
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("4PimS", function(module, exports) {
$parcel$export(module.exports, "ForgeUIExtension", () => $59682774236966e5$export$a61c6459586c5198);

var $iVkr3 = parcelRequire("iVkr3");

var $2QgGz = parcelRequire("2QgGz");
const $59682774236966e5$export$a61c6459586c5198 = (0, $iVkr3.withCommonRenderer)((0, $2QgGz.ForgeUIExtension));

});
parcelRegister("iVkr3", function(module, exports) {
$parcel$export(module.exports, "withCommonRenderer", () => $50297a15ad65186f$export$5d0c37e8180beacd);

var $eJOHy = parcelRequire("eJOHy");

var $f3HRt = parcelRequire("f3HRt");

var $5AOn6 = parcelRequire("5AOn6");
const $50297a15ad65186f$export$5d0c37e8180beacd = (RendererImplementation)=>{
    const RendererWithProps = (props)=>{
        const { contextToken: contextTokenType, localId: localId, ...restProps } = props;
        const extensionDataWithExtras = (0, $eJOHy.useMemo)(()=>({
                ...props.extensionData,
                jira: {
                    ...props.extensionData.jira,
                    isNewNavigation: true
                }
            }), [
            props.extensionData
        ]);
        const extension = (0, $5AOn6.useMemoizedStateObject)(props.extension);
        const extensionData = (0, $5AOn6.useMemoizedStateObject)(extensionDataWithExtras);
        const extensionPayload = (0, $5AOn6.useMemoizedStateObject)(props.extensionPayload);
        const getContextToken = (0, $f3HRt.useGetContextTokenForType)(contextTokenType, extension, extensionData, localId);
        const extraProps = (0, $eJOHy.useMemo)(()=>({
                extension: extension,
                extensionData: extensionData,
                extensionPayload: extensionPayload,
                localId: localId,
                getContextToken: getContextToken
            }), [
            extension,
            extensionData,
            extensionPayload,
            localId,
            getContextToken
        ]);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(RendererImplementation, {
            ...restProps,
            ...extraProps
        });
    };
    const { name: name, displayName: displayName } = RendererImplementation;
    RendererWithProps.displayName = `withCommonRenderer(${name || displayName || 'UNNAMED'})`;
    return RendererWithProps;
};

});
parcelRegister("f3HRt", function(module, exports) {
$parcel$export(module.exports, "useContextToken", () => $30ddd584e2775b6b$export$c86ac7a8f969f554);
$parcel$export(module.exports, "useCmdbContextToken", () => $30ddd584e2775b6b$export$57849d2afc84c515);
$parcel$export(module.exports, "useGetContextTokenForType", () => $30ddd584e2775b6b$export$92242e4f8ad3ceb3);

var $eJOHy = parcelRequire("eJOHy");

var $8XHsn = parcelRequire("8XHsn");

var $dKFdN = parcelRequire("dKFdN");

var $eA7bH = parcelRequire("eA7bH");

var $31hFX = parcelRequire("31hFX");
class $30ddd584e2775b6b$export$b6154a812fa39b91 {
    static getInstance() {
        if (!$30ddd584e2775b6b$export$b6154a812fa39b91.instance) $30ddd584e2775b6b$export$b6154a812fa39b91.instance = new $30ddd584e2775b6b$export$b6154a812fa39b91();
        return $30ddd584e2775b6b$export$b6154a812fa39b91.instance;
    }
    constructor(){
        this.contextTokenCacheMap = new Map();
    }
    setValue(key, value) {
        this.contextTokenCacheMap.set(key, value);
    }
    getValue(key) {
        return this.contextTokenCacheMap.get(key);
    }
    del(key) {
        this.contextTokenCacheMap.delete(key);
    }
}
function $30ddd584e2775b6b$var$fetchContextTokenFromCache(extension, extensionData, localId) {
    const cacheKey = JSON.stringify({
        id: localId || extension.id,
        data: extensionData
    });
    return {
        cachedToken: $30ddd584e2775b6b$export$b6154a812fa39b91.getInstance().getValue(cacheKey),
        cacheKey: cacheKey
    };
}
async function $30ddd584e2775b6b$var$fetchContextTokenFromServer(extension, extensionData, localId, fetchForgeContextTokenFn, cacheKey) {
    const serverResponse = await fetchForgeContextTokenFn({
        extension: extension,
        extensionData: extensionData,
        localId: localId
    });
    const tokenData = {
        ...serverResponse,
        issuedAt: Date.now()
    };
    $30ddd584e2775b6b$export$b6154a812fa39b91.getInstance().setValue(cacheKey, tokenData);
    return tokenData;
}
const $30ddd584e2775b6b$export$40b5d336adc2059c = 0.01; // 10%
async function $30ddd584e2775b6b$var$fetchContextToken(extension, extensionData, localId, opts) {
    const { fetchForgeContextTokenFn: fetchForgeContextTokenFn, useClientRelativeExpirationTime: useClientRelativeExpirationTime } = opts;
    const { cachedToken: cachedToken, cacheKey: cacheKey } = $30ddd584e2775b6b$var$fetchContextTokenFromCache(extension, extensionData, localId);
    if (cachedToken) {
        // 1. Determining token lifetime using client-relative method
        if (useClientRelativeExpirationTime && typeof cachedToken.expiresIn === 'number') {
            if (typeof cachedToken.expiresIn === 'number' && Date.now() - cachedToken.issuedAt + Math.ceil(cachedToken.expiresIn * $30ddd584e2775b6b$export$40b5d336adc2059c) > cachedToken.expiresIn) {
                const tokenData = await $30ddd584e2775b6b$var$fetchContextTokenFromServer(extension, extensionData, localId, fetchForgeContextTokenFn, cacheKey);
                return tokenData.token;
            }
        }
        // 2. Determining token lifetime using server
        // (potentially buggy! see https://gist.github.com/timvisee/fcda9bbdff88d45cc9061606b4b923ca)
        if (typeof cachedToken.expiresAt === 'number' && Date.now() > cachedToken.expiresAt) {
            const tokenData = await $30ddd584e2775b6b$var$fetchContextTokenFromServer(extension, extensionData, localId, fetchForgeContextTokenFn, cacheKey);
            return tokenData.token;
        }
        return cachedToken.token;
    }
    const tokenData = await $30ddd584e2775b6b$var$fetchContextTokenFromServer(extension, extensionData, localId, fetchForgeContextTokenFn, cacheKey);
    return tokenData.token;
}
const $30ddd584e2775b6b$var$USE_COMMON_CONTEXT_TOKEN_OPTS = {
    fetchForgeContextTokenFn: (0, $eA7bH.fetchForgeCommonContextToken),
    useClientRelativeExpirationTime: true
};
const $30ddd584e2775b6b$export$c86ac7a8f969f554 = (extension, extensionData, localId, opts = $30ddd584e2775b6b$var$USE_COMMON_CONTEXT_TOKEN_OPTS)=>{
    const getContextToken = (0, $eJOHy.useCallback)(()=>$30ddd584e2775b6b$var$fetchContextToken(extension, extensionData, localId, opts), [
        extension,
        extensionData,
        localId,
        opts
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            getContextToken: getContextToken
        }), [
        getContextToken
    ]);
};
const $30ddd584e2775b6b$export$1573ce1dbf0e14e8 = (extension, extensionData)=>$30ddd584e2775b6b$export$c86ac7a8f969f554(extension, extensionData, undefined, {
        fetchForgeContextTokenFn: (0, $31hFX.fetchForgeServiceDeskContextToken),
        useClientRelativeExpirationTime: false
    });
const $30ddd584e2775b6b$export$57849d2afc84c515 = (extension, extensionData)=>{
    const { workspaceId: workspaceId } = (0, $8XHsn.useWorkspaceContext)();
    return $30ddd584e2775b6b$export$c86ac7a8f969f554(extension, extensionData, undefined, {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        fetchForgeContextTokenFn: (0, $dKFdN.createFetchForgeCmdbContextToken)(workspaceId),
        useClientRelativeExpirationTime: false
    });
};
const $30ddd584e2775b6b$export$92242e4f8ad3ceb3 = (type, extension, extensionData, localId)=>{
    const jiraContextToken = $30ddd584e2775b6b$export$c86ac7a8f969f554(extension, extensionData, localId);
    const jsmContextToken = $30ddd584e2775b6b$export$1573ce1dbf0e14e8(extension, extensionData);
    const cmdbContextToken = $30ddd584e2775b6b$export$57849d2afc84c515(extension, extensionData);
    if (!type) return undefined;
    switch(type){
        case 'cmdb':
            return cmdbContextToken.getContextToken;
        case 'jsm':
            return jsmContextToken.getContextToken;
        case 'jira':
        default:
            return jiraContextToken.getContextToken;
    }
};

});
parcelRegister("8XHsn", function(module, exports) {
$parcel$export(module.exports, "useWorkspaceContext", () => $5dc043f4942dc6a4$export$827d903316fc333c);
$parcel$export(module.exports, "useInsightVisibility", () => $5dc043f4942dc6a4$export$74ebc9a49f60d38a);

var $eJOHy = parcelRequire("eJOHy");

var $7cSYk = parcelRequire("7cSYk");

var $koAZ4 = parcelRequire("koAZ4");

var $eJrcF = parcelRequire("eJrcF");

var $jopyG = parcelRequire("jopyG");

var $ePaI2 = parcelRequire("ePaI2");
const $5dc043f4942dc6a4$export$a0002067fa97246a = '/rest/servicedesk/cmdb/latest/workspace';
const $5dc043f4942dc6a4$export$122fccf0bbbc9acc = 30000;
const $5dc043f4942dc6a4$export$827d903316fc333c = ()=>{
    const { data: data, loading: loading, error: error, refresh: fetchWorkspaceId } = (0, $eJrcF.useResource)((0, $ePaI2.workspaceResource));
    const workspaceId = data ?? undefined;
    return {
        loading: loading,
        error: // @ts-expect-error - TS2322 - Type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to type 'Error | null | undefined'.
        error,
        workspaceId: workspaceId,
        fetchWorkspaceId: fetchWorkspaceId
    };
};
// https://overreacted.io/making-setinterval-declarative-with-react-hooks/
const $5dc043f4942dc6a4$var$useInterval = (callback, delay)=>{
    const savedCallback = (0, $eJOHy.useRef)(callback);
    // Remember the latest callback.
    (0, $eJOHy.useEffect)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    // Set up the interval.
    (0, $eJOHy.useEffect)(()=>{
        const tick = ()=>{
            savedCallback.current();
        };
        if (delay !== null) {
            const id = setInterval(tick, delay);
            return ()=>clearInterval(id);
        }
        return undefined;
    }, [
        delay
    ]);
};
const $5dc043f4942dc6a4$export$74ebc9a49f60d38a = ()=>{
    const tenantContext = (0, $koAZ4.useTenantContext)();
    const { workspaceId: workspaceId, fetchWorkspaceId: fetchWorkspaceId, loading: loading } = $5dc043f4942dc6a4$export$827d903316fc333c();
    // Optimistically set this true if user is premium and CMDB is enabled in environment - which will prevent a flash for the majority of users
    const [isVisible, setIsVisible] = (0, $eJOHy.useState)((0, $7cSYk.isCMDBEnabledInEnvironment)() && (0, $jopyG.isLicensedPremiumUser)(tenantContext));
    const [shouldPollForWorkspaceId, setShouldPollForWorkspaceId] = (0, $eJOHy.useState)(false);
    const [hasFetchedWorkspaceId, setHasFetchedWorkspaceId] = (0, $eJOHy.useState)(false);
    // Can't test this component without a rerender on each poll — so am just increment a counter with each poll
    const [, setPollCount] = (0, $eJOHy.useState)(0);
    // Run an initial fetch of the workspaceId if the resource wasn't already fetched as
    // part of the route definition (like for the Insight menu in the global nav)
    (0, $eJOHy.useEffect)(()=>{
        if (!hasFetchedWorkspaceId && !workspaceId && (0, $jopyG.isLicensedPremiumUser)(tenantContext) && (0, $7cSYk.isCMDBEnabledInEnvironment)()) {
            fetchWorkspaceId();
            setHasFetchedWorkspaceId(true);
        }
    }, [
        fetchWorkspaceId,
        hasFetchedWorkspaceId,
        tenantContext,
        workspaceId
    ]);
    // Starts/stops the polling of workspaceId
    $5dc043f4942dc6a4$var$useInterval(()=>{
        fetchWorkspaceId();
        setPollCount((a)=>a + 1);
    }, shouldPollForWorkspaceId ? $5dc043f4942dc6a4$export$122fccf0bbbc9acc : null);
    // Main check to see if insight should be visible
    // If user has premium subscription but no workspace ID, we begin polling for the
    // workspace ID as it means their Insight instance hasn’t completed provisioning yet
    (0, $eJOHy.useEffect)(()=>{
        if (hasFetchedWorkspaceId && !loading) {
            if ((0, $jopyG.isLicensedPremiumUser)(tenantContext)) {
                if (workspaceId !== undefined) {
                    setIsVisible(true);
                    setShouldPollForWorkspaceId(false);
                } else {
                    setIsVisible(false);
                    setShouldPollForWorkspaceId(true);
                }
            } else {
                setIsVisible(false);
                setShouldPollForWorkspaceId(false);
            }
        }
    }, [
        tenantContext,
        workspaceId,
        loading,
        hasFetchedWorkspaceId
    ]);
    return isVisible;
};

});

parcelRegister("dKFdN", function(module, exports) {
$parcel$export(module.exports, "createFetchForgeCmdbContextToken", () => $c9006c98a6804d8b$export$33388e733514f842);

var $3ugTQ = parcelRequire("3ugTQ");

var $2x4lT = parcelRequire("2x4lT");
const $c9006c98a6804d8b$export$33388e733514f842 = (workspaceId)=>({ extension: extension, extensionData: extensionData })=>{
        const useWorkspaceAri = true;
        const options = {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify({
                extension: extension,
                extensionData: extensionData,
                useWorkspaceAri: useWorkspaceAri
            })
        };
        return (0, $3ugTQ.performPostRequest)((0, $2x4lT.getCmdbForgeContextTokenUrl)(workspaceId), options);
    };

});
parcelRegister("2x4lT", function(module, exports) {
$parcel$export(module.exports, "getCmdbForgeContextTokenUrl", () => $b41d44702eca5aea$export$f2d03c941c159b04);

var $1qZG3 = parcelRequire("1qZG3");
const $b41d44702eca5aea$export$f2d03c941c159b04 = (workspaceId)=>`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/forge/context-token`;

});
parcelRegister("1qZG3", function(module, exports) {
$parcel$export(module.exports, "getCmdbRestBaseUrl", () => $b2cddbf560b62359$export$28b6c003daedf1c2);
const $b2cddbf560b62359$export$28b6c003daedf1c2 = (workspaceId)=>`/gateway/api/jsm/assets/workspace/${workspaceId}/v1`;

});



parcelRegister("eA7bH", function(module, exports) {
$parcel$export(module.exports, "fetchForgeCommonContextToken", () => $288042f6631fbc9f$export$b3ebe3f24372b35d);

var $4cTDP = parcelRequire("4cTDP");

var $3ugTQ = parcelRequire("3ugTQ");

var $5IiZP = parcelRequire("5IiZP");

var $91rso = parcelRequire("91rso");
const $288042f6631fbc9f$export$b3ebe3f24372b35d = async ({ extension: extension, extensionData: extensionData, localId: localId })=>{
    const tokenResult = (0, $3ugTQ.performPostRequest)('/rest/internal/2/forge/context/token', {
        body: JSON.stringify({
            extension: extension,
            extensionData: extensionData,
            localId: localId,
            useWorkspaceAri: true
        })
    });
    if ((0, $4cTDP.fg)('ditto-track-forge-context-token-fetch')) {
        const EVENT_ID = (0, $5IiZP.toEventId)('fetchForgeCommonContextToken');
        return (0, $91rso.trackPromiseExecution)(tokenResult, EVENT_ID);
    }
    return tokenResult;
};

});
parcelRegister("91rso", function(module, exports) {
$parcel$export(module.exports, "trackPromiseExecution", () => $ade1857e1cd9a40a$export$f360eecfd46489df);

var $1GZq2 = parcelRequire("1GZq2");

var $9gq2c = parcelRequire("9gq2c");
const $ade1857e1cd9a40a$export$f360eecfd46489df = (inputPromise, eventId, enableSampling = true, getSamplingChance = ()=>Math.random() * 100)=>{
    // If sampling is enabled and the random chance exceeds the sampling rate, skip tracking.
    if (enableSampling && getSamplingChance() > (0, $9gq2c.FORGE_SAMPLING_RATE)) return inputPromise;
    (0, $1GZq2.fireOperationalEvent)((0, $9gq2c.OPERATIONAL_ACTIONS).CALLED, {
        id: eventId
    });
    return inputPromise.then((response)=>{
        (0, $1GZq2.fireOperationalEvent)((0, $9gq2c.OPERATIONAL_ACTIONS).SUCCEEDED, {
            id: eventId
        });
        return response;
    }).catch((error)=>{
        (0, $1GZq2.fireOperationalEvent)((0, $9gq2c.OPERATIONAL_ACTIONS).FAILED, {
            id: eventId
        });
        throw error;
    });
};

});


parcelRegister("31hFX", function(module, exports) {
$parcel$export(module.exports, "fetchForgeServiceDeskContextToken", () => $95fa2dd9a789fbfe$export$14d30894e591374b);

var $3ugTQ = parcelRequire("3ugTQ");
const $95fa2dd9a789fbfe$export$14d30894e591374b = ({ extension: extension, extensionData: extensionData })=>{
    const options = {
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        },
        body: JSON.stringify({
            extension: extension,
            extensionData: extensionData
        })
    };
    return (0, $3ugTQ.performPostRequest)('/rest/servicedesk/1/servicedesk-data/forge/context-token', options);
};

});


parcelRegister("5AOn6", function(module, exports) {
$parcel$export(module.exports, "useMemoizedStateObject", () => $1aa834341420cd16$export$cc725e2aa41de44a);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");
const $1aa834341420cd16$export$cc725e2aa41de44a = (data, equalityCheck = (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj))))=>{
    const memoizedData = (0, $eJOHy.useRef)(data);
    return (0, $eJOHy.useMemo)(()=>{
        if (!equalityCheck(data, memoizedData.current)) {
            memoizedData.current = data;
            return data;
        }
        return memoizedData.current;
    }, [
        data,
        equalityCheck
    ]);
};

});


parcelRegister("2QgGz", function(module, exports) {
$parcel$export(module.exports, "ForgeUIExtension", () => $ce7d9edd28b9ae39$export$a61c6459586c5198);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $1WR6N = parcelRequire("1WR6N");

var $4B7rn = parcelRequire("4B7rn");

var $480ZQ = parcelRequire("480ZQ");

var $9QgpA = parcelRequire("9QgpA");

var $6lorv = parcelRequire("6lorv");

var $2c40P = parcelRequire("2c40P");

var $kU13U = parcelRequire("kU13U");

var $cMh2U = parcelRequire("cMh2U");

var $2QZBX = parcelRequire("2QZBX");

var $e6YEs = parcelRequire("e6YEs");

var $f2sjT = parcelRequire("f2sjT");

var $cHtIB = parcelRequire("cHtIB");

var $1M2hR = parcelRequire("1M2hR");

var $4cTDP = parcelRequire("4cTDP");

var $3tDJ4 = parcelRequire("3tDJ4");
var $khGAc = parcelRequire("khGAc");

var $19DFx = parcelRequire("19DFx");

var $j7XAd = parcelRequire("j7XAd");

var $8Yxmm = parcelRequire("8Yxmm");
const $ce7d9edd28b9ae39$export$a61c6459586c5198 = ({ contextIds: contextIds, extension: extension, localId: localId = extension.id, entryPoint: entryPoint, extensionData: extensionData, extensionPayload: extensionPayload, getComponents: getComponents, loadingComponent: loadingComponent, onRender: onRender = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onInitialRender: onInitialRender = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onError: onError = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onLoad: onLoad, onModalExtensionClose: onModalExtensionClose, modalExtension: modalExtension, bridge: bridge, getContextToken: getContextToken, customBridgeMethods: customBridgeMethods, hasModalConsentPrompt: hasModalConsentPrompt, isIframeHidden: isIframeHidden, isIframeResizable: isIframeResizable, onConsentInitialization: onConsentInitialization, onConsentSuccess: onConsentSuccess, consentMessage: consentMessage })=>{
    const accountId = (0, $e6YEs.useAccountId)();
    const activationId = (0, $f2sjT.useActivationId)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const locale = (0, $1M2hR.useLocale)();
    const [isLoadingComponentUnmounted, setIsLoadingComponentUnmounted] = (0, $eJOHy.useState)(false);
    const hasCalledOnInitialRender = (0, $eJOHy.useRef)(false);
    const [forgeDoc, setForgeDoc] = (0, $eJOHy.useState)(undefined);
    const issueKey = (0, $eJOHy.useMemo)(()=>(0, $6lorv.isGenericIssueExtensionData)(extensionData) && extensionData.issue.key ? extensionData.issue.key : (0, $2QZBX.toIssueKey)(''), [
        extensionData
    ]);
    const iframeRef = (0, $eJOHy.useRef)(null);
    const handlerIframeContainer = (0, $eJOHy.useCallback)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (iframeRef.current && document.activeElement === iframeRef.current) iframeRef.current.click();
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $kU13U.isExtensionHidden)(extension)) throw Error("A hidden extension shouldn't be rendered");
    }, [
        extension
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('blur', handlerIframeContainer);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('blur', handlerIframeContainer);
        };
    }, [
        handlerIframeContainer
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (hasCalledOnInitialRender && hasCalledOnInitialRender.current === false) {
            // In case of infrastructure error `forgeDoc` might be empty but we still show an `ErrorPanel`
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
            if (forgeDoc != null) // because loadingComponent unmounts before forgeDoc and error have a value
            // we should call onInitialRender after loadingComponent unmounts
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
            {
                if (isLoadingComponentUnmounted) {
                    // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-live-state-to-parent
                    onInitialRender({
                        forgeDoc: forgeDoc,
                        error: undefined
                    });
                    hasCalledOnInitialRender.current = true;
                }
            }
        }
    }, [
        forgeDoc,
        hasCalledOnInitialRender,
        isLoadingComponentUnmounted,
        onInitialRender
    ]);
    const { showFlag: showFlag, closeFlag: closeFlag } = (0, $9QgpA.useFlagProvider)();
    const bridgeWrapped = (0, $480ZQ.useBridgeWithMetrics)({
        ...bridge,
        showFlag: showFlag,
        closeFlag: closeFlag
    }, extension, entryPoint);
    const customBridgeMethodsWrapped = (0, $480ZQ.useCustomBridgeMethodsWithMetrics)(customBridgeMethods, extension, entryPoint);
    // Components must be memoized here to avoid unnecessary re-renders of ForgeUIRenderer when forgeDoc state is updated above
    const memoizedComponents = (0, $eJOHy.useMemo)(()=>({
            ...getComponents?.({}),
            CommentEditor: $khGAc.CommentEditor,
            ChromelessEditor: $3tDJ4.ChromelessEditor
        }), [
        getComponents
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $ce7d9edd28b9ae39$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $19DFx.ExtensionProvider), {
        localId: localId,
        extension: extension
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1WR6N.ForgeUIRenderer), {
        accountId: accountId || undefined,
        // Since we are using asynchronous functions when bridge expects synchronous functions
        // @ts-expect-error - TS2322 - refresh and submit is incompatible with type '() => Promise<void>'.
        bridge: bridgeWrapped,
        customBridgeMethods: customBridgeMethodsWrapped || undefined,
        client: (0, $2c40P.getApolloClient)(),
        cloudId: cloudId,
        components: (0, $4cTDP.fg)('forge-ui-kit-editor') ? memoizedComponents : getComponents?.({}),
        contextIds: Array.isArray(contextIds) ? contextIds : [
            `ari:cloud:jira:${cloudId}:workspace/${activationId}`
        ],
        entryPoint: entryPoint,
        // @ts-expect-error - TS2322 - Type 'Extension' is not assignable to 'GQLExtension'
        extension: extension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        height: (0, $8Yxmm.calculateHeight)(extension.type, extension.properties.viewportSize),
        hasModalConsentPrompt: hasModalConsentPrompt,
        isIframeHidden: isIframeHidden,
        isIframeResizable: isIframeResizable ?? true,
        locale: locale,
        localId: localId,
        product: "jira",
        mentionProvider: Promise.resolve(new (0, $cMh2U.UserMentionProvider)(issueKey, accountId)),
        getContextToken: getContextToken,
        modalExtension: modalExtension,
        ModalWrapper: (0, $4B7rn.default),
        onError: onError,
        onForgeDocUpdated: (_forgeDoc)=>{
            setForgeDoc(_forgeDoc);
            onRender(_forgeDoc);
        },
        onIframeLoad: onLoad,
        onModalExtensionClose: onModalExtensionClose,
        loadingComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j7XAd.LoadingComponentWithUnmountEvent), {
            loadingComponent: loadingComponent,
            onInitialRender: onInitialRender,
            forgeDoc: forgeDoc,
            onUnmount: ()=>setIsLoadingComponentUnmounted(true)
        }),
        iframeRef: iframeRef,
        onConsentInitialization: onConsentInitialization,
        onConsentSuccess: onConsentSuccess,
        consentMessage: consentMessage
    })));
};
const $ce7d9edd28b9ae39$var$wrapperStyles = (0, $1DXK0.xcss)({
    height: '100%',
    width: '100%'
});

});
parcelRegister("1WR6N", function(module, exports) {
$parcel$export(module.exports, "ForgeUIRenderer", () => $3bbfe6ee62f8c07b$export$b89b612df1c715da);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8LXaq = parcelRequire("8LXaq");

var $2xaVu = parcelRequire("2xaVu");

var $kb5ps = parcelRequire("kb5ps");
var $8jQS9 = parcelRequire("8jQS9");
var $iCkyS = parcelRequire("iCkyS");

var $33gLE = parcelRequire("33gLE");

var $cOLOr = parcelRequire("cOLOr");

var $hByHz = parcelRequire("hByHz");

var $fqHZI = parcelRequire("fqHZI");

var $k5OQG = parcelRequire("k5OQG");
const $3bbfe6ee62f8c07b$export$b89b612df1c715da = (props)=>{
    const { accountId: accountId, bridge: bridge, client: client, components: components, consentMessage: consentMessage, contextIds: contextIds, customBridgeMethods: customBridgeMethods, dialogs: dialogs, entryPoint: entryPoint, extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, extensionViewData: extensionViewData, hasModalConsentPrompt: hasModalConsentPrompt, height: height, width: width, isIframeHidden: isIframeHidden, isIframeResizable: isIframeResizable, getContextToken: getContextToken, loadingComponent: loadingComponent, locale: locale, localId: localId, mentionProvider: mentionProvider, modalExtension: modalExtension, modalStyles: modalStyles, modalProvider: modalProvider, onConsentModalClose: onConsentModalClose, onConsentSuccess: onConsentSuccess, onConsentInitialization: onConsentInitialization, onError: onError, onForgeDocUpdated: onForgeDocUpdated, onIframeLoad: onIframeLoad, onInitialRender: onInitialRender, product: product, timezone: timezone, getModalWidth: getModalWidth, onModalExtensionClose: onModalExtensionClose, onSuccess: onSuccess, onAppError: onAppError, viewportDimensions: viewportDimensions } = props;
    let cloudId;
    let workspaceId;
    if ('cloudId' in props) cloudId = props.cloudId;
    else if ('workspaceId' in props) workspaceId = props.workspaceId;
    const cloudOrWorkspaceId = cloudId ? {
        cloudId: cloudId
    } : {
        workspaceId: workspaceId
    };
    (0, $eJOHy.useEffect)(()=>{
        onInitialRender?.();
    }, [
        onInitialRender
    ]);
    const { id: extensionId, environmentId: environmentId, environmentType: environmentType } = extension;
    const coreData = (0, $eJOHy.useMemo)(()=>({
            workspaceId: workspaceId,
            cloudId: cloudId,
            localId: localId || extensionId,
            environmentId: environmentId,
            environmentType: environmentType
        }), [
        cloudId,
        environmentId,
        environmentType,
        extensionId,
        localId,
        workspaceId
    ]);
    const getThreeLOPrompt = (0, $eJOHy.useCallback)(()=>({
            ThreeLOPrompt: modalExtension || hasModalConsentPrompt ? (0, $8jQS9.makeModalThreeLOPromptForCustomUI)({
                appName: extension.properties.title,
                isBlanketHidden: true,
                onClose: onConsentModalClose
            }) : (0, $iCkyS.makeThreeLOPromptForCustomUI)({
                appName: extension.properties.title,
                onSuccess: onConsentSuccess,
                message: consentMessage,
                onInitialization: onConsentInitialization
            })
        }), [
        extension.properties.title,
        consentMessage,
        hasModalConsentPrompt,
        modalExtension,
        onConsentSuccess,
        onConsentModalClose,
        onConsentInitialization
    ]);
    const customUIProps = {
        accountId: accountId,
        bridge: bridge,
        client: client,
        consentMessage: consentMessage,
        contextIds: contextIds,
        coreData: coreData,
        customBridgeMethods: customBridgeMethods,
        dialogs: dialogs,
        entryPoint: entryPoint,
        extension: extension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionViewData: extensionViewData,
        getContextToken: getContextToken,
        getThreeLOPrompt: getThreeLOPrompt,
        height: height,
        loadingComponent: loadingComponent,
        locale: locale,
        localId: localId,
        mentionProvider: mentionProvider,
        modalExtension: modalExtension,
        modalStyles: modalStyles,
        modalProvider: modalProvider,
        onConsentModalClose: onConsentModalClose,
        onConsentSuccess: onConsentSuccess,
        onError: onError,
        onForgeDocUpdated: onForgeDocUpdated,
        onIframeLoad: onIframeLoad,
        product: product,
        timezone: timezone,
        isIframeHidden: isIframeHidden,
        isIframeResizable: isIframeResizable
    };
    const [viewOnClose, setViewOnClose] = (0, $eJOHy.useState)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $33gLE.ForgeUIExtensionAnalyticsContext), {
        extensionId: props.extension.id,
        localId: props.localId || props.extension.id,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fqHZI.UFOSegmentForgeUnifiedWebRendererRollout), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hByHz.PerformanceAnalyticsProviderRollout), {
                profileKey: `${props.extension.id}-${props.extension.key}-${props.entryPoint}`,
                appType: (0, $cOLOr.isCustomUI)(props.extension, props.entryPoint) ? 'CustomUI' : 'UIKit',
                forgeEnvironment: props.extension.environmentType,
                extensionType: props.extension.type,
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $k5OQG.PerformanceHoldAttributionAnchorRollout), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            hidden: true,
                            id: "forge-ui-renderer"
                        }),
                        !(0, $cOLOr.isCustomUI)(extension, entryPoint) ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2xaVu.UIKitRenderer), {
                            coreData: coreData,
                            getThreeLOPrompt: getThreeLOPrompt,
                            accountId: accountId,
                            client: client,
                            contextIds: contextIds,
                            extension: extension,
                            extensionData: extensionData,
                            extensionViewData: extensionViewData,
                            product: product,
                            bridge: bridge,
                            customBridgeMethods: customBridgeMethods,
                            components: {
                                Frame: (0, $kb5ps.makeFrame)((inputProps)=>{
                                    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8LXaq.CustomUIRenderer), {
                                        ...customUIProps,
                                        extension: {
                                            ...extension,
                                            properties: {
                                                ...extension.properties,
                                                ...inputProps
                                            }
                                        },
                                        // Ensure extensions that are rendered as entryPoints aren't passing through the very same entryPoint to the Frame
                                        entryPoint: undefined,
                                        // Ensures Frame is always resized to the full height of the content
                                        // Required because Jira leaves isIframeResizable as false
                                        isIframeResizable: true
                                    });
                                }),
                                ...components
                            },
                            consentMessage: consentMessage,
                            entryPoint: entryPoint,
                            getContextToken: getContextToken,
                            locale: locale,
                            localId: localId,
                            mentionProvider: mentionProvider,
                            modalExtension: modalExtension,
                            onConsentSuccess: onConsentSuccess,
                            onForgeDocUpdated: onForgeDocUpdated,
                            timezone: timezone,
                            onConsentModalClose: onConsentModalClose,
                            onError: onError,
                            loadingComponent: loadingComponent,
                            extensionPayload: extensionPayload,
                            onSuccess: onSuccess,
                            ...cloudOrWorkspaceId,
                            onAppError: onAppError,
                            viewportDimensions: viewportDimensions
                        }) : modalExtension ? // getModalWidth not applied here since all modal extensions are defaulted to medium width
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8LXaq.ModalCustomUIRenderer), {
                            ...customUIProps,
                            bridge: {
                                onClose: (callback)=>{
                                    setViewOnClose(()=>callback.data);
                                    // stores the callback for when modal is closed
                                    return true;
                                },
                                // spread down here so product can override the default onClose
                                ...customUIProps.bridge
                            },
                            modalOnClose: onModalExtensionClose,
                            closeOnEscape: modalExtension?.shouldCloseOnEscapePress ?? true,
                            closeOnOverlayClick: modalExtension?.shouldCloseOnOverlayClick ?? true,
                            viewOnClose: viewOnClose
                        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8LXaq.CustomUIRenderer), {
                            ...customUIProps,
                            getModalWidth: getModalWidth,
                            width: width
                        })
                    ]
                })
            })
        })
    });
};

});
parcelRegister("8LXaq", function(module, exports) {
$parcel$export(module.exports, "CustomUIRenderer", () => $2578bfa2d8a9f072$export$17d9f1e4832027c9);
$parcel$export(module.exports, "ModalCustomUIRenderer", () => $2578bfa2d8a9f072$export$5d28a207fd7621f6);
/* CustomUIRenderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $860Q6 = parcelRequire("860Q6");
var $8wxIz = parcelRequire("8wxIz");

var $gHHv2 = parcelRequire("gHHv2");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");
var $956it = parcelRequire("956it");

var $b3nvV = parcelRequire("b3nvV");

var $kk5YU = parcelRequire("kk5YU");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");
parcelRequire("1B59H");
var $aJjD9 = parcelRequire("aJjD9");

var $f7YKM = parcelRequire("f7YKM");

var $ej6lz = parcelRequire("ej6lz");

var $aSByt = parcelRequire("aSByt");

var $Ay1uj = parcelRequire("Ay1uj");

var $6J9k6 = parcelRequire("6J9k6");
const $2578bfa2d8a9f072$var$styles = {
    modalDeprecationMessage: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
};
const $2578bfa2d8a9f072$export$17d9f1e4832027c9 = ({ accountId: accountId, bridge: bridge, client: client, contextIds: contextIds, coreData: coreData, customBridgeMethods: customBridgeMethods, dialogs: dialogs, entryPoint: entryPoint, extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, extensionViewData: extensionViewData, getContextToken: getContextToken, getThreeLOPrompt: getThreeLOPrompt, height: height, width: width, isIframeHidden: isIframeHidden, isIframeResizable: isIframeResizable, iframeRef: iframeRef, isInModal: isInModal, loadingComponent: loadingComponent, locale: locale, localId: localId, modalStyles: modalStyles, modalProvider: modalProvider, onIframeLoad: onIframeLoad, onModalCustomUIRendererClose: onModalCustomUIRendererClose, product: product, timezone: timezone, getModalWidth: getModalWidth, setIsLoading: setIsLoading })=>{
    const [error, setError] = (0, $eJOHy.useState)(null);
    // modalOptions is null when no modal is open is non null when opened
    const [modalOptions, setModalOptions] = (0, $eJOHy.useState)(null);
    const [viewOnClose, setViewOnClose] = (0, $eJOHy.useState)();
    const onCloseFromModalClass = modalOptions?.onClose;
    const iframeProps = {
        accountId: accountId,
        apolloClient: client,
        contextIds: contextIds,
        components: getThreeLOPrompt,
        coreData: coreData,
        customBridgeMethods: customBridgeMethods,
        extension: extension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionViewData: extensionViewData,
        getContextToken: getContextToken,
        isHidden: isIframeHidden,
        isResizable: isIframeResizable,
        locale: locale,
        timezone: timezone,
        loadingComponent: loadingComponent
    };
    const extensionInModal = (0, $eJOHy.useMemo)(()=>({
            ...extension,
            // Pass a type that is not included in the dimensions presets so that it falls back to default
            type: `${extension.type}::dynamic-modal`,
            properties: {
                ...extension.properties,
                resource: modalOptions?.resource ?? extension.properties.resource
            }
        }), [
        extension,
        modalOptions?.resource
    ]);
    const onError = (error)=>{
        error && setError(error);
    };
    const extensionDataInModal = (0, $eJOHy.useMemo)(()=>({
            ...extensionData,
            ...modalOptions?.context ? {
                modal: modalOptions?.context
            } : {},
            // This is to handle an incompatibility issue with Compass and JSM where they are incorrectly currently spreading the context object on the top level instead of in the `modal` object.
            // Remove once Compass apps have been updated https://softwareteams.atlassian.net/browse/COMPASS-22051 and a notice to app developers have been sent out
            ...(product === 'compass' || extension.type.startsWith('jiraServiceManagement')) && modalOptions?.context ? {
                ...modalOptions?.context
            } : {}
        }), [
        extension.type,
        extensionData,
        modalOptions?.context,
        product
    ]);
    const handleModalTearDown = (0, $eJOHy.useCallback)(()=>{
        setModalOptions(null);
    }, [
        setModalOptions
    ]);
    const isReducedMotion = (0, $kk5YU.useIsReducedMotion)();
    const handleModalClose = (0, $eJOHy.useCallback)(()=>{
        onCloseFromModalClass?.();
        // if reduced motion is enabled, we need to call handleModalTearDown here as it no longer calls `onCloseComplete` in `ModalCustomUIRenderer`
        if (isReducedMotion) handleModalTearDown();
    }, [
        isReducedMotion,
        onCloseFromModalClass,
        handleModalTearDown
    ]);
    // Confluence specific feature
    // Needed to show Forge modals in live pages. dialogs won't be passed in if the page isn't live.
    (0, $eJOHy.useEffect)(()=>{
        if (product !== 'confluence') return;
        if (dialogs && modalOptions) dialogs.showDialog($2578bfa2d8a9f072$export$5d28a207fd7621f6, {
            extension: extensionInModal,
            extensionData: extensionDataInModal,
            localId: localId,
            onTearDown: handleModalTearDown,
            bridge: bridge,
            size: modalOptions.size,
            closeOnEscape: modalOptions.closeOnEscape,
            closeOnOverlayClick: modalOptions.closeOnOverlayClick
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        modalOptions,
        dialogs
    ]);
    if (error) {
        // Sandbox deprecation error
        if (error === (0, $aSByt.SANDBOX_DEPRECATION_ERROR)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aSByt.ForgeDeprecationMessage), {
            extension: extension,
            client: client,
            error: error
        });
    // Currently no other error types are handled
    }
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8wxIz.Iframe), {
                ...iframeProps,
                entryPoint: entryPoint,
                isResizable: isIframeResizable,
                bridge: {
                    ...bridge,
                    openModal: (opts)=>{
                        setModalOptions(opts.data);
                        return true;
                    },
                    ...onModalCustomUIRendererClose ? {
                        close: (payload)=>{
                            if ((0, $eGOwo.fg)('forge-ui-on-close-bridge-method')) onModalCustomUIRendererClose().then(()=>{
                                bridge?.close?.(payload);
                            }).finally(()=>{
                                return true;
                            });
                            else {
                                // This bridge.close reference is defined below in ModalCustomUIRenderer.
                                onModalCustomUIRendererClose();
                                bridge?.close?.(payload);
                                return true;
                            }
                        }
                    } : {}
                },
                height: height,
                width: width,
                isInModal: isInModal,
                ref: iframeRef,
                onLoad: onIframeLoad,
                setIsLoading: setIsLoading,
                onError: onError
            }),
            modalOptions ? /*#__PURE__*/ (0, $gt9Am.jsx)($2578bfa2d8a9f072$export$5d28a207fd7621f6, {
                ...iframeProps,
                product: product,
                getThreeLOPrompt: getThreeLOPrompt,
                dialogs: dialogs,
                client: client,
                extension: extensionInModal,
                extensionData: extensionDataInModal,
                localId: localId,
                onTearDown: handleModalTearDown,
                bridge: {
                    ...bridge,
                    onClose: (callback)=>{
                        setViewOnClose(()=>callback.data);
                        // stores the callback for when modal is closed
                        return true;
                    },
                    close: (payload)=>{
                        onCloseFromModalClass?.(payload.data);
                        return true;
                    }
                },
                modalOnClose: handleModalClose,
                size: modalOptions.size,
                closeOnEscape: modalOptions.closeOnEscape,
                closeOnOverlayClick: modalOptions.closeOnOverlayClick,
                modalStyles: modalStyles,
                modalProvider: modalProvider,
                getModalWidth: getModalWidth,
                isIframeResizable: isIframeResizable,
                viewOnClose: viewOnClose
            }) : null
        ]
    });
};
const $2578bfa2d8a9f072$export$5d28a207fd7621f6 = ({ accountId: accountId, bridge: bridge, coreData: coreData, client: client, closeOnEscape: closeOnEscape, closeOnOverlayClick: closeOnOverlayClick, consentMessage: consentMessage, contextIds: contextIds, customBridgeMethods: customBridgeMethods, dialogs: dialogs, entryPoint: entryPoint, extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, extensionViewData: extensionViewData, getContextToken: getContextToken, getThreeLOPrompt: getThreeLOPrompt, isIframeHidden: isIframeHidden = false, isIframeResizable: isIframeResizable = false, loadingComponent: loadingComponent, locale: locale, localId: localId, mentionProvider: mentionProvider, modalExtension: modalExtension, modalStyles: modalStyles, modalProvider: ModalProvider, onConsentModalClose: onConsentModalClose, onConsentSuccess: onConsentSuccess, onError: onError, onForgeDocUpdated: onForgeDocUpdated, onIframeLoad: onIframeLoad, onTearDown: onTearDown, product: product, size: size, timezone: timezone, getModalWidth: getModalWidth, modalOnClose: // onClose from `Modal`
modalOnClose, viewOnClose: // onClose from `view`
viewOnClose })=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(true);
    // This is for preventing inline dialog apps from being closed by an esc key press when a
    // modal is open until https://product-fabric.atlassian.net/browse/DSP-3552 is resolved.
    (0, $eJOHy.useEffect)(()=>{
        if (product !== 'confluence' || modalExtension?.type === 'macroConfig' || product === 'confluence' && modalExtension?.type === 'bylineItem') return;
        function dismissEscape(e) {
            if (e.key === 'Escape') {
                e.stopPropagation();
                if (closeOnEscape) {
                    modalOnClose?.();
                    setIsOpen(false);
                }
            }
        }
        if (isOpen) document.addEventListener('keydown', dismissEscape, {
            capture: true
        });
        return ()=>document.removeEventListener('keydown', dismissEscape, {
                capture: true
            });
    }, [
        isOpen,
        closeOnEscape,
        product,
        modalOnClose,
        modalExtension?.type
    ]);
    const modalSize = size ?? extension.properties.viewportSize ?? 'medium';
    const modalWidth = getModalWidth ? getModalWidth(size) : (0, $f7YKM.getAtlasKitModalWidth)(modalSize);
    // If size is defined, iframe modal should not be resizable.
    // In JSM ONLY, iframe modal should ALWAYS be resizable.
    // Iframe should scale to 100% of the modal so that Select drop downs are not cut off
    const isJsmModule = extension.type.startsWith('jiraServiceManagement');
    const isModalResizable = isJsmModule || (size !== undefined ? false : isIframeResizable);
    const shouldShowFCFModalDeprecationMessage = (extension.type === (0, $aJjD9.JiraExtension).CUSTOM_FIELD || extension.type === (0, $aJjD9.JiraExtension).CUSTOM_FIELD_TYPE) && !(0, $eGOwo.fg)('forge_disable_fcf_modal_experience_on_issue_view');
    const renderModal = ()=>{
        const closeProps = {
            onClose: async ()=>{
                if ((0, $eGOwo.fg)('forge-ui-on-close-bridge-method')) try {
                    await viewOnClose?.();
                } finally{
                    modalOnClose?.();
                    setIsOpen(false);
                }
                else {
                    modalOnClose?.();
                    setIsOpen(false);
                }
            },
            onCloseComplete: onTearDown
        };
        const modalContent = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
            children: [
                shouldShowFCFModalDeprecationMessage && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    xcss: $2578bfa2d8a9f072$var$styles.modalDeprecationMessage,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ej6lz.ForgeModalDeprecationMessage), {
                        client: client,
                        extension: extension
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f7YKM.ModalContentWrapper), {
                    size: modalSize,
                    styles: modalStyles,
                    isResizable: isIframeResizable,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)($2578bfa2d8a9f072$export$17d9f1e4832027c9, {
                        product: product,
                        coreData: coreData,
                        getThreeLOPrompt: getThreeLOPrompt,
                        dialogs: dialogs,
                        accountId: accountId,
                        client: client,
                        contextIds: contextIds,
                        extension: extension,
                        extensionData: extensionData,
                        extensionViewData: extensionViewData,
                        bridge: bridge,
                        customBridgeMethods: customBridgeMethods,
                        consentMessage: consentMessage,
                        entryPoint: entryPoint,
                        getContextToken: getContextToken,
                        height: "100%",
                        isIframeHidden: isIframeHidden,
                        isIframeResizable: isModalResizable,
                        locale: locale,
                        localId: localId,
                        mentionProvider: mentionProvider,
                        modalExtension: modalExtension,
                        onConsentSuccess: onConsentSuccess,
                        onForgeDocUpdated: onForgeDocUpdated,
                        timezone: timezone,
                        onConsentModalClose: onConsentModalClose,
                        onError: onError,
                        onIframeLoad: onIframeLoad,
                        loadingComponent: loadingComponent,
                        extensionPayload: extensionPayload,
                        modalStyles: modalStyles,
                        // This is called when `view.close` is called
                        onModalCustomUIRendererClose: async ()=>{
                            if (!(0, $eGOwo.fg)('forge_ui_onclose_fix')) modalOnClose?.();
                            if (viewOnClose && (0, $eGOwo.fg)('forge-ui-on-close-bridge-method')) try {
                                await viewOnClose?.();
                            } finally{
                                setIsOpen(false);
                                // If is a modal extension point, call modalOnClose to reset state from product
                                // This is required to reset the state of the modal in the product when view.close is called
                                if ((0, $eGOwo.fg)('forge_ui_onclose_fix')) modalExtension && modalOnClose?.();
                            }
                            else {
                                setIsOpen(false);
                                // if is a modal extension point, call modalOnClose to reset state from product
                                // This is required to reset the state of the modal in the product when view.close is called
                                if ((0, $eGOwo.fg)('forge_ui_onclose_fix')) modalExtension && modalOnClose?.();
                            }
                        },
                        isInModal: true
                    })
                })
            ]
        });
        if (modalSize === 'fullscreen' && (0, $eGOwo.fg)('platform_add_modal_support_to_bylineitem_extension')) return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $b3nvV.FullScreenModalDialog), {
            ...closeProps,
            testId: "custom-ui-fullscreen-modal-dialog",
            shouldCloseOnEscapePress: closeOnEscape,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $2qG7I.default), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5a9Ro.default), {
                            children: modalExtension?.title
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                            appearance: "subtle",
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6J9k6))),
                            label: "Close Modal",
                            onClick: modalExtension?.closeModalExtension
                        })
                    ]
                }),
                modalContent
            ]
        });
        else {
            const { height: modalHeight } = (0, $860Q6.getModalDimensions)(modalSize ?? 'medium');
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gHHv2.default), {
                ...closeProps,
                width: modalWidth,
                height: modalSize === 'max' ? modalHeight : undefined,
                testId: "custom-ui-modal-dialog",
                shouldCloseOnOverlayClick: closeOnOverlayClick,
                shouldCloseOnEscapePress: closeOnEscape,
                children: modalContent
            });
        }
    };
    if (ModalProvider) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $956it.default), {
        children: isOpen && /*#__PURE__*/ (0, $gt9Am.jsx)(ModalProvider, {
            children: renderModal()
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $956it.default), {
        children: isOpen && renderModal()
    });
};

});
parcelRegister("860Q6", function(module, exports) {
$parcel$export(module.exports, "getModalDimensions", () => $7639abf7ea29e182$export$b3b34c460afe006f);

var $eGOwo = parcelRequire("eGOwo");
const $7639abf7ea29e182$var$ModalSizes = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
    XLARGE: 'xlarge',
    MAX: 'max'
};
const $7639abf7ea29e182$var$modalDimensions = {
    [$7639abf7ea29e182$var$ModalSizes.SMALL]: {
        height: '20vh',
        minHeight: '320px'
    },
    [$7639abf7ea29e182$var$ModalSizes.MEDIUM]: {
        height: '40vh',
        minHeight: '520px'
    },
    [$7639abf7ea29e182$var$ModalSizes.LARGE]: {
        height: '70vh',
        minHeight: '720px'
    },
    [$7639abf7ea29e182$var$ModalSizes.XLARGE]: {
        height: '90vh'
    },
    [$7639abf7ea29e182$var$ModalSizes.MAX]: {
        height: '100%'
    }
};
const $7639abf7ea29e182$export$b3b34c460afe006f = (size)=>{
    if ((0, $eGOwo.fg)('destructure-getmodaldimensions-with-failsafe')) {
        const safeSize = $7639abf7ea29e182$var$modalDimensions[size] ? size : 'medium';
        return $7639abf7ea29e182$var$modalDimensions[safeSize];
    }
    return $7639abf7ea29e182$var$modalDimensions[size];
};

});

parcelRegister("8wxIz", function(module, exports) {
$parcel$export(module.exports, "Iframe", () => $172cef1710df616a$export$5137ec99f248330b);
/* Iframe.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $cZeFf = parcelRequire("cZeFf");
var $58yRG = parcelRequire("58yRG");

var $83IbI = parcelRequire("83IbI");

var $hHgTM = parcelRequire("hHgTM");

var $ezmKu = parcelRequire("ezmKu");
var $13WEh = parcelRequire("13WEh");

var $5OKCR = parcelRequire("5OKCR");

var $kKhkW = parcelRequire("kKhkW");

var $aoswO = parcelRequire("aoswO");
var $chSQm = parcelRequire("chSQm");
var $b3lfX = parcelRequire("b3lfX");
var $cE5ed = parcelRequire("cE5ed");
var $5YSQ9 = parcelRequire("5YSQ9");
var $fJehn = parcelRequire("fJehn");
var $jpNtm = parcelRequire("jpNtm");
var $b2aYp = parcelRequire("b2aYp");

var $dQN6B = parcelRequire("dQN6B");

var $6GbQJ = parcelRequire("6GbQJ");

var $cOZrT = parcelRequire("cOZrT");

var $itxYZ = parcelRequire("itxYZ");

var $eGOwo = parcelRequire("eGOwo");

var $cf43T = parcelRequire("cf43T");

var $3g7o0 = parcelRequire("3g7o0");

var $aoswO = parcelRequire("aoswO");
const $172cef1710df616a$var$styles = {
    hostedResourcesIframeContainer: "_kqswh2mm",
    box: "_1bsb1osq _4t3i1osq"
};
const $172cef1710df616a$var$ReloadOnContextChangeWrapper = ({ context: context, children: children, getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion })=>{
    if (getCurrentForgeReactMajorVersion && (0, $eGOwo.fg)('forge-ui-macro-config-update-improvement')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cf43T.ContextChangeObserverWrapper), {
        context: context,
        getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion,
        children: children
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
        children: children
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5OKCR)))(context));
};
const $172cef1710df616a$export$5137ec99f248330b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ accountId: accountId, extension: extension, contextIds: contextIds, apolloClient: apolloClient, components: components, coreData: coreData, extensionData: extensionData, extensionViewData: extensionViewData, loadingComponent: loadingComponent, onLoad: onLoad, height: height = '100%', width: width = '100%', bridge: bridge, customBridgeMethods: customBridgeMethods, isResizable: isResizable = true, entryPoint: entryPoint, extensionPayload: extensionPayload, getContextToken: getContextToken, timezone: timezone, locale: locale, isHidden: isHidden = false, isInModal: isInModal = false, setShouldShowRenderer: setShouldShowRenderer, setIsLoading: setIsLoading, getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion, onError: onError }, iframeRef)=>{
    const environment = (0, $eJOHy.useContext)((0, $83IbI.EnvironmentContext)); // ARKEN-856: useThemeObserver() is a bit noisy, it returns copies of the same theme which breaks useBridge() dependencies
    // We use useMemoizedStateObject() to properly memoize its output doing a deep-equality check
    const theme = (0, $13WEh.useMemoizedStateObject)((0, $58yRG.default)());
    const iframeWrapperRef = (0, $eJOHy.useRef)(null);
    const [surfaceColor, setSurfaceColor] = (0, $eJOHy.useState)(null);
    const { trackExtensionLoaded: trackExtensionLoaded } = (0, $cOZrT.useForgeUiAnalyticsEvent)();
    (0, $eJOHy.useEffect)(()=>{
        if (!iframeWrapperRef.current) return;
        const nextSurfaceColor = getComputedStyle(iframeWrapperRef.current).getPropertyValue((0, $cZeFf.CURRENT_SURFACE_CSS_VAR));
        setSurfaceColor(nextSurfaceColor);
    }, [
        theme
    ]);
    const { appId: appId, moduleKey: moduleKey } = (0, $ezmKu.parseExtensionId)(extension.id);
    const { environmentId: environmentId, environmentType: environmentType } = extension;
    const extensionEntryPoint = (0, $cE5ed.getExtensionEntryPoint)(extension, entryPoint);
    const urlSafeContext = (0, $eGOwo.fg)('forge-include-hostname-in-url-path') ? (0, $aoswO.urlSafeB64)((0, $3g7o0.getEncodedAppContext)(extension)) : '';
    const defaultSrc = (0, $eJOHy.useMemo)(()=>(0, $aoswO.createSrcFromExtension)(appId, extension, environment, extensionEntryPoint), [
        appId,
        extension,
        environment,
        extensionEntryPoint
    ]);
    const { tunnels: tunnels, loading: isTunnelsLoading } = (0, $hHgTM.useCustomUITunnelsList)({
        client: apolloClient,
        appId: appId,
        environmentId: environmentId,
        environmentType: environmentType
    });
    const isSignedCookieLoading = (0, $b2aYp.useCDNAuthSignedCookie)();
    const loading = isTunnelsLoading || (0, $b2aYp.shouldUseCDNAuth)() && isSignedCookieLoading;
    (0, $eJOHy.useEffect)(()=>{
        const renderType = extension?.properties?.render === 'native' ? 'UIKit' : 'CustomUI';
        const extensionType = (0, $itxYZ.getExtensionType)(extension);
        trackExtensionLoaded({
            forgeEnvironment: extension?.environmentType,
            renderType: renderType,
            extensionType: extensionType
        }); // we only want to track this event once per session per app, hence don't really need to handle dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const [isThreeLOPromptVisible, setIsThreeLOPromptVisible] = (0, $eJOHy.useState)(false);
    const coreDataInner = {
        ...coreData,
        environmentId: environmentId,
        environmentType: environmentType,
        moduleKey: moduleKey,
        siteUrl: window.location.origin
    };
    const resizingEnabled = isResizable && !extension.properties.viewportSize;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
        ref: iframeWrapperRef,
        testId: "hosted-resources-iframe-container",
        xcss: $172cef1710df616a$var$styles.hostedResourcesIframeContainer,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: isThreeLOPromptVisible || isHidden ? undefined : height,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: resizingEnabled || isThreeLOPromptVisible || isHidden ? undefined : height,
            width: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width
        },
        children: [
            loading && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    xcss: $172cef1710df616a$var$styles.box,
                    children: loading && !isHidden && (0, $6GbQJ.getLoadingComponent)(loadingComponent)
                })
            }),
            !loading && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kKhkW.TracingProvider), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)($172cef1710df616a$var$ReloadOnContextChangeWrapper, {
                    getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion,
                    context: (0, $jpNtm.getViewContext)({
                        resolverContext: (0, $5YSQ9.getResolverContext)(coreDataInner, extensionData),
                        accountId: accountId,
                        extension: extension,
                        timezone: timezone ?? (0, $b3lfX.getBrowserTimezone)(),
                        locale: locale ?? (0, $chSQm.getBrowserLocale)(),
                        extensionViewData: extensionViewData,
                        extensionPayload: (0, $eGOwo.fg)('platform_move_dynamic_macro_context') ? extensionPayload : undefined
                    }),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dQN6B.InnerIframe), {
                        accountId: accountId,
                        extension: extension,
                        contextIds: contextIds,
                        apolloClient: apolloClient,
                        components: components,
                        coreData: coreDataInner,
                        extensionData: extensionData,
                        extensionViewData: extensionViewData,
                        loadingComponent: loadingComponent,
                        onLoad: onLoad,
                        height: height,
                        width: width,
                        src: (0, $fJehn.getSrcUrl)(tunnels, extensionEntryPoint, defaultSrc, urlSafeContext),
                        bridge: bridge,
                        customBridgeMethods: customBridgeMethods,
                        isResizable: resizingEnabled,
                        getContextToken: getContextToken,
                        timezone: timezone,
                        locale: locale,
                        setIsThreeLOPromptVisible: setIsThreeLOPromptVisible,
                        setShouldShowRenderer: setShouldShowRenderer,
                        extensionPayload: extensionPayload,
                        isHidden: isHidden,
                        theme: theme,
                        surfaceColor: surfaceColor,
                        appId: appId,
                        ref: iframeRef,
                        isInModal: isInModal,
                        setIsLoading: setIsLoading,
                        onError: onError
                    })
                })
            })
        ]
    });
});

});
parcelRegister("83IbI", function(module, exports) {
$parcel$export(module.exports, "EnvironmentContext", () => $bd1421f16ae5e463$export$6a671bebd9daad64);

var $eJOHy = parcelRequire("eJOHy");
parcelRequire("1B59H");
var $bMVUa = parcelRequire("bMVUa");
const $bd1421f16ae5e463$export$6a671bebd9daad64 = (0, $eJOHy.createContext)((0, $bMVUa.ProductEnvironment).PRODUCTION);

});
parcelRegister("1B59H", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("bMVUa")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("bMVUa")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("aJjD9")).ExtensionEnvironment);
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("d5na4")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("d5na4")).MarkupList);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("aJjD9")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("aJjD9")).JiraExtension);
parcelRequire("cocyy");
var $aJjD9 = parcelRequire("aJjD9");
var $bMVUa = parcelRequire("bMVUa");
var $d5na4 = parcelRequire("d5na4");
parcelRequire("bKXW3");
var $j5jNN = parcelRequire("j5jNN");
var $hFdxU = parcelRequire("hFdxU");
var $5l1cT = parcelRequire("5l1cT");

});
parcelRegister("cocyy", function(module, exports) {
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("d5na4")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("d5na4")).MarkupList);
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("bMVUa")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("bMVUa")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("aJjD9")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("aJjD9")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("aJjD9")).JiraExtension);

var $d5na4 = parcelRequire("d5na4");

var $bMVUa = parcelRequire("bMVUa");

var $1OXOJ = parcelRequire("1OXOJ");

var $aJjD9 = parcelRequire("aJjD9");

});
parcelRegister("d5na4", function(module, exports) {
$parcel$export(module.exports, "MarkupRecursiveList", () => $6547db1b50ae55fe$export$3b98ab6402702476);
$parcel$export(module.exports, "MarkupList", () => $6547db1b50ae55fe$export$3ee8c58bb87b9685);
const $6547db1b50ae55fe$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $6547db1b50ae55fe$export$3ee8c58bb87b9685 = [
    ...$6547db1b50ae55fe$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];

});

parcelRegister("bMVUa", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => $2a85479edecde486$export$2688cec3c24cb60b);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => $2a85479edecde486$export$beaef1891b3e7ca3);
var $2a85479edecde486$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $2a85479edecde486$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});

});

parcelRegister("1OXOJ", function(module, exports) {
const $2c2e5aa3ab9e94c1$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("aJjD9", function(module, exports) {
$parcel$export(module.exports, "ExtensionEnvironment", () => $386a983a4f154d80$export$6e95f5308d9156f9);
$parcel$export(module.exports, "ConfluenceExtension", () => $386a983a4f154d80$export$9a2372818e2520c6);
$parcel$export(module.exports, "JiraExtension", () => $386a983a4f154d80$export$f06ffa3aa6bfec95);
var $386a983a4f154d80$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $386a983a4f154d80$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    TEST_MODULE: 'test:module'
};
const $386a983a4f154d80$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};

});


parcelRegister("bKXW3", function(module, exports) {

var $5l1cT = parcelRequire("5l1cT");

var $hFdxU = parcelRequire("hFdxU");

var $j5jNN = parcelRequire("j5jNN");

});
parcelRegister("5l1cT", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $e56be782cac19c5b$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $e56be782cac19c5b$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $e56be782cac19c5b$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $e56be782cac19c5b$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $e56be782cac19c5b$export$20b9f6acb0888554(effect) {
    return $e56be782cac19c5b$export$7e816460364ed464(effect) || $e56be782cac19c5b$export$eb5bd7f371e458af(effect) || $e56be782cac19c5b$export$f632ad3064955f31(effect);
}

});

parcelRegister("hFdxU", function(module, exports) {
const $4b99458d8b31c0f4$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $4b99458d8b31c0f4$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $4b99458d8b31c0f4$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $4b99458d8b31c0f4$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $4b99458d8b31c0f4$export$caa8cab0db5b0a61(effect) {
    return $4b99458d8b31c0f4$export$65d7078e01574f24(effect) || $4b99458d8b31c0f4$export$709a27a9f80556b8(effect) || $4b99458d8b31c0f4$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("j5jNN", function(module, exports) {
// From forge.ts
const $cf6d8dbb85cf5bab$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $cf6d8dbb85cf5bab$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $cf6d8dbb85cf5bab$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $cf6d8dbb85cf5bab$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $cf6d8dbb85cf5bab$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $cf6d8dbb85cf5bab$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $cf6d8dbb85cf5bab$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $cf6d8dbb85cf5bab$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $cf6d8dbb85cf5bab$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $cf6d8dbb85cf5bab$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $cf6d8dbb85cf5bab$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});




parcelRegister("hHgTM", function(module, exports) {
$parcel$export(module.exports, "useCustomUITunnelsList", () => $ce7337e5b9b863c7$export$ad717e82ff0f4348);

var $eJOHy = parcelRequire("eJOHy");

var $kuAvn = parcelRequire("kuAvn");

var $1fMqv = parcelRequire("1fMqv");

var $cwqPy = parcelRequire("cwqPy");
const $ce7337e5b9b863c7$export$fe748943fdfd6c6b = ()=>{
    const query = `
  query forge_ui_getActiveTunnels($appId: ID!, $environmentId: ID!) {
    appActiveTunnels(appId: $appId, environmentId: $environmentId) {
      customUI {
        resourceKey
        tunnelUrl
      }
    }
  }
  `;
    return (0, $kuAvn.default)`
		${query}
	`;
};
const $ce7337e5b9b863c7$export$6702f78eaa0e936a = (client, appId, environmentId, queryOptions)=>{
    return {
        variables: {
            appId: appId,
            environmentId: environmentId
        },
        ...queryOptions,
        query: $ce7337e5b9b863c7$export$fe748943fdfd6c6b(),
        client: client,
        /**
		 * We don't want to set 'ignore' because that discards errors and we need to inspect
		 * them for SLI reporting. We also need 'all' so we don't discard data on errors:http://go/j/AUX-317
		 * https://www.apollographql.com/docs/react/data/error-handling/
		 */ errorPolicy: 'all',
        context: {
            headers: {
                'atl-attribution': (0, $cwqPy.createAtlAttributionHeader)()
            }
        }
    };
};
const $ce7337e5b9b863c7$export$f31e7455041d7e13 = ({ loading: loading, data: data })=>{
    if (!loading) return data?.appActiveTunnels?.customUI;
    return undefined;
};
const $ce7337e5b9b863c7$export$ad717e82ff0f4348 = (options)=>{
    const { appId: appId, environmentType: environmentType, environmentId: environmentId, client: client, queryOptions: queryOptions } = options;
    const shouldQuery = (0, $eJOHy.useRef)(true);
    if (environmentType !== 'DEVELOPMENT') shouldQuery.current = false;
    const requestOptions = $ce7337e5b9b863c7$export$6702f78eaa0e936a(client, appId, environmentId, queryOptions);
    const { error: error, loading: loading, data: data } = (0, $1fMqv.useQuery)(requestOptions.query || $ce7337e5b9b863c7$export$fe748943fdfd6c6b(), {
        ...requestOptions,
        skip: !shouldQuery.current
    });
    const tunnels = $ce7337e5b9b863c7$export$f31e7455041d7e13({
        loading: loading,
        data: data
    });
    return {
        error: error,
        tunnels: tunnels || [],
        loading: loading
    };
};

});
parcelRegister("kuAvn", function(module, exports) {
$parcel$export(module.exports, "gql", () => $eeb2ed1fa1f7c351$export$72e4926bf8358653);
$parcel$export(module.exports, "default", () => $eeb2ed1fa1f7c351$export$2e2bcd8739ae039);

var $dnskZ = parcelRequire("dnskZ");

var $f6P3g = parcelRequire("f6P3g");
var $eeb2ed1fa1f7c351$var$docCache = new Map();
var $eeb2ed1fa1f7c351$var$fragmentSourceMap = new Map();
var $eeb2ed1fa1f7c351$var$printFragmentWarnings = true;
var $eeb2ed1fa1f7c351$var$experimentalFragmentVariables = false;
function $eeb2ed1fa1f7c351$var$normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function $eeb2ed1fa1f7c351$var$cacheKeyFromLoc(loc) {
    return $eeb2ed1fa1f7c351$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $eeb2ed1fa1f7c351$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $eeb2ed1fa1f7c351$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $eeb2ed1fa1f7c351$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($eeb2ed1fa1f7c351$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $eeb2ed1fa1f7c351$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, ast), {
        definitions: definitions
    });
}
function $eeb2ed1fa1f7c351$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === 'object') workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $eeb2ed1fa1f7c351$var$parseDocument(source) {
    var cacheKey = $eeb2ed1fa1f7c351$var$normalize(source);
    if (!$eeb2ed1fa1f7c351$var$docCache.has(cacheKey)) {
        var parsed = (0, $f6P3g.parse)(source, {
            experimentalFragmentVariables: $eeb2ed1fa1f7c351$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $eeb2ed1fa1f7c351$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') throw new Error('Not a valid GraphQL document.');
        $eeb2ed1fa1f7c351$var$docCache.set(cacheKey, $eeb2ed1fa1f7c351$var$stripLoc($eeb2ed1fa1f7c351$var$processFragments(parsed)));
    }
    return $eeb2ed1fa1f7c351$var$docCache.get(cacheKey);
}
function $eeb2ed1fa1f7c351$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === 'string') literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === 'Document') result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $eeb2ed1fa1f7c351$var$parseDocument(result);
}
function $eeb2ed1fa1f7c351$export$657554ef4dc7ac2d() {
    $eeb2ed1fa1f7c351$var$docCache.clear();
    $eeb2ed1fa1f7c351$var$fragmentSourceMap.clear();
}
function $eeb2ed1fa1f7c351$export$e4294e638636c6ab() {
    $eeb2ed1fa1f7c351$var$printFragmentWarnings = false;
}
function $eeb2ed1fa1f7c351$export$78cf889af350c840() {
    $eeb2ed1fa1f7c351$var$experimentalFragmentVariables = true;
}
function $eeb2ed1fa1f7c351$export$5290df9bbbd3cfa() {
    $eeb2ed1fa1f7c351$var$experimentalFragmentVariables = false;
}
var $eeb2ed1fa1f7c351$var$extras = {
    gql: $eeb2ed1fa1f7c351$export$72e4926bf8358653,
    resetCaches: $eeb2ed1fa1f7c351$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $eeb2ed1fa1f7c351$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $eeb2ed1fa1f7c351$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $eeb2ed1fa1f7c351$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $eeb2ed1fa1f7c351$var$extras.gql, gql_1.resetCaches = $eeb2ed1fa1f7c351$var$extras.resetCaches, gql_1.disableFragmentWarnings = $eeb2ed1fa1f7c351$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $eeb2ed1fa1f7c351$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $eeb2ed1fa1f7c351$var$extras.disableExperimentalFragmentVariables;
})($eeb2ed1fa1f7c351$export$72e4926bf8358653 || ($eeb2ed1fa1f7c351$export$72e4926bf8358653 = {}));
$eeb2ed1fa1f7c351$export$72e4926bf8358653["default"] = $eeb2ed1fa1f7c351$export$72e4926bf8358653;
var $eeb2ed1fa1f7c351$export$2e2bcd8739ae039 = $eeb2ed1fa1f7c351$export$72e4926bf8358653;

});
parcelRegister("f6P3g", function(module, exports) {
$parcel$export(module.exports, "parse", () => $afff0452d66d5631$export$98e6a39c04603d36);

var $iZFMu = parcelRequire("iZFMu");

var $4oHdA = parcelRequire("4oHdA");

var $19BqA = parcelRequire("19BqA");

var $ePiKI = parcelRequire("ePiKI");

var $6dDiC = parcelRequire("6dDiC");

var $4nWzJ = parcelRequire("4nWzJ");

var $6XgSE = parcelRequire("6XgSE");
function $afff0452d66d5631$export$98e6a39c04603d36(source, options) {
    var parser = new $afff0452d66d5631$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $afff0452d66d5631$export$5303528d1070ff6f(source, options) {
    var parser = new $afff0452d66d5631$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $ePiKI.TokenKind).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, $ePiKI.TokenKind).EOF);
    return value;
}
function $afff0452d66d5631$export$28b8f402ccc88182(source, options) {
    var parser = new $afff0452d66d5631$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $ePiKI.TokenKind).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, $ePiKI.TokenKind).EOF);
    return type;
}
var $afff0452d66d5631$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = (0, $6dDiC.isSource)(source) ? source : new (0, $6dDiC.Source)(source);
        this._lexer = new (0, $6XgSE.Lexer)(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, $ePiKI.TokenKind).NAME);
        return {
            kind: (0, $4oHdA.Kind).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
     /**
   * Document : Definition+
   */ ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, $4oHdA.Kind).DOCUMENT,
            definitions: this.many((0, $ePiKI.TokenKind).SOF, this.parseDefinition, (0, $ePiKI.TokenKind).EOF),
            loc: this.loc(start)
        };
    } /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */ ;
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, $ePiKI.TokenKind).NAME)) switch(this._lexer.token.value){
            case 'query':
            case 'mutation':
            case 'subscription':
                return this.parseOperationDefinition();
            case 'fragment':
                return this.parseFragmentDefinition();
            case 'schema':
            case 'scalar':
            case 'type':
            case 'interface':
            case 'union':
            case 'enum':
            case 'input':
            case 'directive':
                return this.parseTypeSystemDefinition();
            case 'extend':
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, $ePiKI.TokenKind).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
     /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, $ePiKI.TokenKind).BRACE_L)) return {
            kind: (0, $4oHdA.Kind).OPERATION_DEFINITION,
            operation: 'query',
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, $ePiKI.TokenKind).NAME)) name = this.parseName();
        return {
            kind: (0, $4oHdA.Kind).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * OperationType : one of query mutation subscription
   */ ;
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, $ePiKI.TokenKind).NAME);
        switch(operationToken.value){
            case 'query':
                return 'query';
            case 'mutation':
                return 'mutation';
            case 'subscription':
                return 'subscription';
        }
        throw this.unexpected(operationToken);
    } /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ ;
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, $ePiKI.TokenKind).PAREN_L, this.parseVariableDefinition, (0, $ePiKI.TokenKind).PAREN_R);
    } /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, $4oHdA.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $ePiKI.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $ePiKI.TokenKind).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    } /**
   * Variable : $ Name
   */ ;
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, $ePiKI.TokenKind).DOLLAR);
        return {
            kind: (0, $4oHdA.Kind).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } /**
   * SelectionSet : { Selection+ }
   */ ;
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, $4oHdA.Kind).SELECTION_SET,
            selections: this.many((0, $ePiKI.TokenKind).BRACE_L, this.parseSelection, (0, $ePiKI.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ ;
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, $ePiKI.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    } /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ ;
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, $ePiKI.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, $4oHdA.Kind).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $ePiKI.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    } /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ ;
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $ePiKI.TokenKind).PAREN_L, item, (0, $ePiKI.TokenKind).PAREN_R);
    } /**
   * Argument[Const] : Name : Value[?Const]
   */ ;
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $ePiKI.TokenKind).COLON);
        return {
            kind: (0, $4oHdA.Kind).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, $4oHdA.Kind).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, $ePiKI.TokenKind).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
     /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, $ePiKI.TokenKind).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $ePiKI.TokenKind).NAME)) return {
            kind: (0, $4oHdA.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, $4oHdA.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ ;
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: (0, $4oHdA.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, $4oHdA.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentName : Name but not `on`
   */ ;
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
     /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, $ePiKI.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, $ePiKI.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, $ePiKI.TokenKind).INT:
                this._lexer.advance();
                return {
                    kind: (0, $4oHdA.Kind).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $ePiKI.TokenKind).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, $4oHdA.Kind).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $ePiKI.TokenKind).STRING:
            case (0, $ePiKI.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $ePiKI.TokenKind).NAME:
                this._lexer.advance();
                switch(token.value){
                    case 'true':
                        return {
                            kind: (0, $4oHdA.Kind).BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case 'false':
                        return {
                            kind: (0, $4oHdA.Kind).BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case 'null':
                        return {
                            kind: (0, $4oHdA.Kind).NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: (0, $4oHdA.Kind).ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case (0, $ePiKI.TokenKind).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, $4oHdA.Kind).STRING,
            value: token.value,
            block: token.kind === (0, $ePiKI.TokenKind).BLOCK_STRING,
            loc: this.loc(token)
        };
    } /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ ;
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, $4oHdA.Kind).LIST,
            values: this.any((0, $ePiKI.TokenKind).BRACKET_L, item, (0, $ePiKI.TokenKind).BRACKET_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */ ;
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, $4oHdA.Kind).OBJECT,
            fields: this.any((0, $ePiKI.TokenKind).BRACE_L, item, (0, $ePiKI.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectField[Const] : Name : Value[?Const]
   */ ;
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $ePiKI.TokenKind).COLON);
        return {
            kind: (0, $4oHdA.Kind).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
     /**
   * Directives[Const] : Directive[?Const]+
   */ ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, $ePiKI.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    } /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */ ;
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, $ePiKI.TokenKind).AT);
        return {
            kind: (0, $4oHdA.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
     /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, $ePiKI.TokenKind).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, $ePiKI.TokenKind).BRACKET_R);
            type = {
                kind: (0, $4oHdA.Kind).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $ePiKI.TokenKind).BANG)) return {
            kind: (0, $4oHdA.Kind).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    } /**
   * NamedType : Name
   */ ;
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, $4oHdA.Kind).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
     /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $ePiKI.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaDefinition();
            case 'scalar':
                return this.parseScalarTypeDefinition();
            case 'type':
                return this.parseObjectTypeDefinition();
            case 'interface':
                return this.parseInterfaceTypeDefinition();
            case 'union':
                return this.parseUnionTypeDefinition();
            case 'enum':
                return this.parseEnumTypeDefinition();
            case 'input':
                return this.parseInputObjectTypeDefinition();
            case 'directive':
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, $ePiKI.TokenKind).STRING) || this.peek((0, $ePiKI.TokenKind).BLOCK_STRING);
    } /**
   * Description : StringValue
   */ ;
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    } /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */ ;
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, $ePiKI.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $ePiKI.TokenKind).BRACE_R);
        return {
            kind: (0, $4oHdA.Kind).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * OperationTypeDefinition : OperationType : NamedType
   */ ;
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, $ePiKI.TokenKind).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, $4oHdA.Kind).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ ;
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $4oHdA.Kind).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $4oHdA.Kind).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ ;
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var _this$_options2;
        if (!this.expectOptionalKeyword('implements')) return [];
        if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
            var types = []; // Optional leading ampersand
            this.expectOptionalToken((0, $ePiKI.TokenKind).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $ePiKI.TokenKind).AMP) || this.peek((0, $ePiKI.TokenKind).NAME));
            return types;
        }
        return this.delimitedMany((0, $ePiKI.TokenKind).AMP, this.parseNamedType);
    } /**
   * FieldsDefinition : { FieldDefinition+ }
   */ ;
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek((0, $ePiKI.TokenKind).BRACE_L) && this._lexer.lookahead().kind === (0, $ePiKI.TokenKind).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, $ePiKI.TokenKind).BRACE_L, this.parseFieldDefinition, (0, $ePiKI.TokenKind).BRACE_R);
    } /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ ;
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, $ePiKI.TokenKind).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $4oHdA.Kind).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ ;
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, $ePiKI.TokenKind).PAREN_L, this.parseInputValueDef, (0, $ePiKI.TokenKind).PAREN_R);
    } /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, $ePiKI.TokenKind).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, $ePiKI.TokenKind).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $4oHdA.Kind).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $4oHdA.Kind).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ ;
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, $4oHdA.Kind).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ ;
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $ePiKI.TokenKind).EQUALS) ? this.delimitedMany((0, $ePiKI.TokenKind).PIPE, this.parseNamedType) : [];
    } /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ ;
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, $4oHdA.Kind).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */ ;
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, $ePiKI.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, $ePiKI.TokenKind).BRACE_R);
    } /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */ ;
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $4oHdA.Kind).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ ;
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, $4oHdA.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */ ;
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, $ePiKI.TokenKind).BRACE_L, this.parseInputValueDef, (0, $ePiKI.TokenKind).BRACE_R);
    } /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $ePiKI.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    } /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */ ;
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, $ePiKI.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $ePiKI.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, $4oHdA.Kind).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ ;
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, $4oHdA.Kind).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ ;
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $4oHdA.Kind).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ ;
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $4oHdA.Kind).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ ;
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, $4oHdA.Kind).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ ;
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, $4oHdA.Kind).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ ;
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $4oHdA.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */ ;
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $ePiKI.TokenKind).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, $4oHdA.Kind).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    } /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ ;
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        return this.delimitedMany((0, $ePiKI.TokenKind).PIPE, this.parseDirectiveLocation);
    } /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ ;
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, $4nWzJ.DirectiveLocation)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
     /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */ ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new (0, $19BqA.Location)(startToken, this._lexer.lastToken, this._lexer.source);
    } /**
   * Determines if the next token is of a given kind
   */ ;
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $iZFMu.syntaxError)(this._lexer.source, token.start, "Expected ".concat($afff0452d66d5631$var$getTokenKindDesc(kind), ", found ").concat($afff0452d66d5631$var$getTokenDesc(token), "."));
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */ ;
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    } /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $ePiKI.TokenKind).NAME && token.value === value) this._lexer.advance();
        else throw (0, $iZFMu.syntaxError)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat($afff0452d66d5631$var$getTokenDesc(token), "."));
    } /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ ;
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $ePiKI.TokenKind).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    } /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ ;
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $iZFMu.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat($afff0452d66d5631$var$getTokenDesc(token), "."));
    } /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    } /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ ;
    _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ function $afff0452d66d5631$var$getTokenDesc(token) {
    var value = token.value;
    return $afff0452d66d5631$var$getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $afff0452d66d5631$var$getTokenKindDesc(kind) {
    return (0, $6XgSE.isPunctuatorTokenKind)(kind) ? "\"".concat(kind, "\"") : kind;
}

});
parcelRegister("iZFMu", function(module, exports) {
$parcel$export(module.exports, "syntaxError", () => $dd3e555a07a61943$export$bbee0c6176c019d4);

var $eXc8C = parcelRequire("eXc8C");
function $dd3e555a07a61943$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $eXc8C.GraphQLError)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}

});
parcelRegister("eXc8C", function(module, exports) {
$parcel$export(module.exports, "GraphQLError", () => $ae2ffdc10628e3fd$export$92d6ed0888e7cb7f);

var $fjX8u = parcelRequire("fjX8u");

var $j38tO = parcelRequire("j38tO");

var $3iKxr = parcelRequire("3iKxr");

var $hD37S = parcelRequire("hD37S");

var $1TwT7 = parcelRequire("1TwT7");
function $ae2ffdc10628e3fd$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ae2ffdc10628e3fd$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $ae2ffdc10628e3fd$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ae2ffdc10628e3fd$var$_typeof(obj);
}
function $ae2ffdc10628e3fd$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ae2ffdc10628e3fd$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ae2ffdc10628e3fd$var$ownKeys(Object(source), true).forEach(function(key) {
            $ae2ffdc10628e3fd$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ae2ffdc10628e3fd$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ae2ffdc10628e3fd$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ae2ffdc10628e3fd$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ae2ffdc10628e3fd$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ae2ffdc10628e3fd$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ae2ffdc10628e3fd$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ae2ffdc10628e3fd$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $ae2ffdc10628e3fd$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $ae2ffdc10628e3fd$var$_setPrototypeOf(subClass, superClass);
}
function $ae2ffdc10628e3fd$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ae2ffdc10628e3fd$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $ae2ffdc10628e3fd$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $ae2ffdc10628e3fd$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $ae2ffdc10628e3fd$var$_possibleConstructorReturn(this, result);
    };
}
function $ae2ffdc10628e3fd$var$_possibleConstructorReturn(self, call) {
    if (call && ($ae2ffdc10628e3fd$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $ae2ffdc10628e3fd$var$_assertThisInitialized(self);
}
function $ae2ffdc10628e3fd$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ae2ffdc10628e3fd$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $ae2ffdc10628e3fd$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$ae2ffdc10628e3fd$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $ae2ffdc10628e3fd$var$_construct(Class, arguments, $ae2ffdc10628e3fd$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $ae2ffdc10628e3fd$var$_setPrototypeOf(Wrapper, Class);
    };
    return $ae2ffdc10628e3fd$var$_wrapNativeSuper(Class);
}
function $ae2ffdc10628e3fd$var$_construct(Parent, args, Class) {
    if ($ae2ffdc10628e3fd$var$_isNativeReflectConstruct()) $ae2ffdc10628e3fd$var$_construct = Reflect.construct;
    else $ae2ffdc10628e3fd$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $ae2ffdc10628e3fd$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $ae2ffdc10628e3fd$var$_construct.apply(null, arguments);
}
function $ae2ffdc10628e3fd$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $ae2ffdc10628e3fd$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $ae2ffdc10628e3fd$var$_setPrototypeOf(o, p) {
    $ae2ffdc10628e3fd$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ae2ffdc10628e3fd$var$_setPrototypeOf(o, p);
}
function $ae2ffdc10628e3fd$var$_getPrototypeOf(o) {
    $ae2ffdc10628e3fd$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ae2ffdc10628e3fd$var$_getPrototypeOf(o);
}
var $ae2ffdc10628e3fd$export$92d6ed0888e7cb7f = /*#__PURE__*/ function(_Error) {
    $ae2ffdc10628e3fd$var$_inherits(GraphQLError, _Error);
    var _super = $ae2ffdc10628e3fd$var$_createSuper(GraphQLError);
    /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _nodeLocations, _nodeLocations2, _nodeLocations3;
        var _this;
        $ae2ffdc10628e3fd$var$_classCallCheck(this, GraphQLError);
        _this = _super.call(this, message);
        _this.name = 'GraphQLError';
        _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        _this.nodes = $ae2ffdc10628e3fd$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        var nodeLocations = [];
        for(var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++){
            var _this$nodes;
            var _ref4 = _ref3[_i2];
            var loc = _ref4.loc;
            if (loc != null) nodeLocations.push(loc);
        }
        nodeLocations = $ae2ffdc10628e3fd$var$undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.
        _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
        _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc) {
            return loc.start;
        });
        _this.locations = positions && source ? positions.map(function(pos) {
            return (0, $hD37S.getLocation)(source, pos);
        }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc) {
            return (0, $hD37S.getLocation)(loc.source, loc.start);
        });
        _this.path = path !== null && path !== void 0 ? path : undefined;
        var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
        if (extensions == null && (0, $j38tO.default)(originalExtensions)) _this.extensions = $ae2ffdc10628e3fd$var$_objectSpread({}, originalExtensions);
        else _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
         // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
        // This ensures that the simplest possible GraphQL service adheres to the spec.
        Object.defineProperties($ae2ffdc10628e3fd$var$_assertThisInitialized(_this), {
            message: {
                enumerable: true
            },
            locations: {
                enumerable: _this.locations != null
            },
            path: {
                enumerable: _this.path != null
            },
            extensions: {
                enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty($ae2ffdc10628e3fd$var$_assertThisInitialized(_this), 'stack', {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return $ae2ffdc10628e3fd$var$_possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace($ae2ffdc10628e3fd$var$_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty($ae2ffdc10628e3fd$var$_assertThisInitialized(_this), 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    $ae2ffdc10628e3fd$var$_createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return $ae2ffdc10628e3fd$export$55ee1551a3f962e6(this);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return $ae2ffdc10628e3fd$export$7b5b869ee98c16ab(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: (0, $3iKxr.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Object';
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ $ae2ffdc10628e3fd$var$_wrapNativeSuper(Error));
function $ae2ffdc10628e3fd$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $ae2ffdc10628e3fd$export$55ee1551a3f962e6(error) {
    var output = error.message;
    if (error.nodes) for(var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++){
        var node = _error$nodes2[_i4];
        if (node.loc) output += '\n\n' + (0, $1TwT7.printLocation)(node.loc);
    }
    else if (error.source && error.locations) for(var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++){
        var location = _error$locations2[_i6];
        output += '\n\n' + (0, $1TwT7.printSourceLocation)(error.source, location);
    }
    return output;
}
function $ae2ffdc10628e3fd$export$7b5b869ee98c16ab(error) {
    var _error$message;
    error || (0, $fjX8u.default)(0, 'Received null or undefined error.');
    var message = (_error$message = error.message) !== null && _error$message !== void 0 ? _error$message : 'An unknown error occurred.';
    var locations = error.locations;
    var path = error.path;
    var extensions = error.extensions;
    return extensions && Object.keys(extensions).length > 0 ? {
        message: message,
        locations: locations,
        path: path,
        extensions: extensions
    } : {
        message: message,
        locations: locations,
        path: path
    };
} /**
 * @see https://github.com/graphql/graphql-spec/blob/master/spec/Section%207%20--%20Response.md#errors
 */ 

});
parcelRegister("fjX8u", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2768086a269b262$export$2e2bcd8739ae039);
function $b2768086a269b262$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("j38tO", function(module, exports) {
$parcel$export(module.exports, "default", () => $dde4e0129ad4f4db$export$2e2bcd8739ae039);
function $dde4e0129ad4f4db$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $dde4e0129ad4f4db$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $dde4e0129ad4f4db$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $dde4e0129ad4f4db$var$_typeof(obj);
}
function $dde4e0129ad4f4db$export$2e2bcd8739ae039(value) {
    return $dde4e0129ad4f4db$var$_typeof(value) == 'object' && value !== null;
}

});

parcelRegister("3iKxr", function(module, exports) {
$parcel$export(module.exports, "SYMBOL_ITERATOR", () => $2677271cc8cb2427$export$f6cdee3c26d6da57);
$parcel$export(module.exports, "SYMBOL_TO_STRING_TAG", () => $2677271cc8cb2427$export$5deadc579ccc7c9c);
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $2677271cc8cb2427$export$f6cdee3c26d6da57 = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var $2677271cc8cb2427$export$8d0083df0471478e = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $2677271cc8cb2427$export$5deadc579ccc7c9c = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';

});

parcelRegister("hD37S", function(module, exports) {
$parcel$export(module.exports, "getLocation", () => $cd5880f6ab51819f$export$e7fd20fad3cf4b5f);
/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $cd5880f6ab51819f$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

});

parcelRegister("1TwT7", function(module, exports) {
$parcel$export(module.exports, "printLocation", () => $1614705cd80bb521$export$96a9681e539deed);
$parcel$export(module.exports, "printSourceLocation", () => $1614705cd80bb521$export$867940333fd9f869);

var $hD37S = parcelRequire("hD37S");
function $1614705cd80bb521$export$96a9681e539deed(location) {
    return $1614705cd80bb521$export$867940333fd9f869(location.source, (0, $hD37S.getLocation)(location.source, location.start));
}
function $1614705cd80bb521$export$867940333fd9f869(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $1614705cd80bb521$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $1614705cd80bb521$var$printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                '',
                subLine
            ];
        }), [
            [
                ' ',
                $1614705cd80bb521$var$whitespace(subLineColumnNum - 1) + '^'
            ],
            [
                '',
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + $1614705cd80bb521$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            '',
            $1614705cd80bb521$var$whitespace(columnNum - 1) + '^'
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $1614705cd80bb521$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $1614705cd80bb521$var$leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
    }).join('\n');
}
function $1614705cd80bb521$var$whitespace(len) {
    return Array(len + 1).join(' ');
}
function $1614705cd80bb521$var$leftPad(len, str) {
    return $1614705cd80bb521$var$whitespace(len - str.length) + str;
}

});



parcelRegister("4oHdA", function(module, exports) {
$parcel$export(module.exports, "Kind", () => $333aed883d7e11f5$export$a84bdc57c5122798);
/**
 * The set of allowed kind values for AST nodes.
 */ var $333aed883d7e11f5$export$a84bdc57c5122798 = Object.freeze({
    // Name
    NAME: 'Name',
    // Document
    DOCUMENT: 'Document',
    OPERATION_DEFINITION: 'OperationDefinition',
    VARIABLE_DEFINITION: 'VariableDefinition',
    SELECTION_SET: 'SelectionSet',
    FIELD: 'Field',
    ARGUMENT: 'Argument',
    // Fragments
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_FRAGMENT: 'InlineFragment',
    FRAGMENT_DEFINITION: 'FragmentDefinition',
    // Values
    VARIABLE: 'Variable',
    INT: 'IntValue',
    FLOAT: 'FloatValue',
    STRING: 'StringValue',
    BOOLEAN: 'BooleanValue',
    NULL: 'NullValue',
    ENUM: 'EnumValue',
    LIST: 'ListValue',
    OBJECT: 'ObjectValue',
    OBJECT_FIELD: 'ObjectField',
    // Directives
    DIRECTIVE: 'Directive',
    // Types
    NAMED_TYPE: 'NamedType',
    LIST_TYPE: 'ListType',
    NON_NULL_TYPE: 'NonNullType',
    // Type System Definitions
    SCHEMA_DEFINITION: 'SchemaDefinition',
    OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
    // Type Definitions
    SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
    OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
    FIELD_DEFINITION: 'FieldDefinition',
    INPUT_VALUE_DEFINITION: 'InputValueDefinition',
    INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
    UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
    ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
    ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
    INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
    // Directive Definitions
    DIRECTIVE_DEFINITION: 'DirectiveDefinition',
    // Type System Extensions
    SCHEMA_EXTENSION: 'SchemaExtension',
    // Type Extensions
    SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
    OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
    INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
    UNION_TYPE_EXTENSION: 'UnionTypeExtension',
    ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
    INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 

});

parcelRegister("19BqA", function(module, exports) {
$parcel$export(module.exports, "Location", () => $0d73aa1a6bd3d4cf$export$18a2be9195644f38);
$parcel$export(module.exports, "Token", () => $0d73aa1a6bd3d4cf$export$50792b0e93539fde);
$parcel$export(module.exports, "isNode", () => $0d73aa1a6bd3d4cf$export$8ee0fc9ee280b4ee);

var $k3Xa1 = parcelRequire("k3Xa1");
var $0d73aa1a6bd3d4cf$export$18a2be9195644f38 = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $k3Xa1.default)($0d73aa1a6bd3d4cf$export$18a2be9195644f38);
var $0d73aa1a6bd3d4cf$export$50792b0e93539fde = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $k3Xa1.default)($0d73aa1a6bd3d4cf$export$50792b0e93539fde);
function $0d73aa1a6bd3d4cf$export$8ee0fc9ee280b4ee(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === 'string';
} /**
 * The list of all possible AST node types.
 */ 

});
parcelRegister("k3Xa1", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9b1fa842852583f$export$2e2bcd8739ae039);

var $8oZnC = parcelRequire("8oZnC");

var $e5Dlp = parcelRequire("e5Dlp");
function $e9b1fa842852583f$export$2e2bcd8739ae039(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === 'function' || (0, $8oZnC.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if (0, $e5Dlp.default) classObject.prototype[0, $e5Dlp.default] = fn;
}

});
parcelRegister("8oZnC", function(module, exports) {
$parcel$export(module.exports, "default", () => $61e02d6059f2aabe$export$2e2bcd8739ae039);
function $61e02d6059f2aabe$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}

});

parcelRegister("e5Dlp", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4200d41543ce842$export$2e2bcd8739ae039);
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $a4200d41543ce842$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $a4200d41543ce842$export$2e2bcd8739ae039 = $a4200d41543ce842$var$nodejsCustomInspectSymbol;

});



parcelRegister("ePiKI", function(module, exports) {
$parcel$export(module.exports, "TokenKind", () => $acb45ff744d0f320$export$8b9d26ab11394711);
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $acb45ff744d0f320$export$8b9d26ab11394711 = Object.freeze({
    SOF: '<SOF>',
    EOF: '<EOF>',
    BANG: '!',
    DOLLAR: '$',
    AMP: '&',
    PAREN_L: '(',
    PAREN_R: ')',
    SPREAD: '...',
    COLON: ':',
    EQUALS: '=',
    AT: '@',
    BRACKET_L: '[',
    BRACKET_R: ']',
    BRACE_L: '{',
    PIPE: '|',
    BRACE_R: '}',
    NAME: 'Name',
    INT: 'Int',
    FLOAT: 'Float',
    STRING: 'String',
    BLOCK_STRING: 'BlockString',
    COMMENT: 'Comment'
}); /**
 * The enum type representing the token kinds values.
 */ 

});

parcelRegister("6dDiC", function(module, exports) {
$parcel$export(module.exports, "Source", () => $487270f96a0f45cd$export$1d2df86270c81ecb);
$parcel$export(module.exports, "isSource", () => $487270f96a0f45cd$export$75135ee9ed6e435b);

var $3iKxr = parcelRequire("3iKxr");

var $4QE9P = parcelRequire("4QE9P");

var $fjX8u = parcelRequire("fjX8u");

var $9kbnx = parcelRequire("9kbnx");
function $487270f96a0f45cd$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $487270f96a0f45cd$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $487270f96a0f45cd$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $487270f96a0f45cd$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $487270f96a0f45cd$export$1d2df86270c81ecb = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        typeof body === 'string' || (0, $fjX8u.default)(0, "Body must be a string. Received: ".concat((0, $4QE9P.default)(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $fjX8u.default)(0, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $fjX8u.default)(0, 'column in locationOffset is 1-indexed and must be positive.');
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    $487270f96a0f45cd$var$_createClass(Source, [
        {
            key: (0, $3iKxr.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Source';
            }
        }
    ]);
    return Source;
}();
function $487270f96a0f45cd$export$75135ee9ed6e435b(source) {
    return (0, $9kbnx.default)(source, $487270f96a0f45cd$export$1d2df86270c81ecb);
}

});
parcelRegister("4QE9P", function(module, exports) {
$parcel$export(module.exports, "default", () => $387b2b38bb5e6d4b$export$2e2bcd8739ae039);

var $e5Dlp = parcelRequire("e5Dlp");
function $387b2b38bb5e6d4b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $387b2b38bb5e6d4b$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $387b2b38bb5e6d4b$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $387b2b38bb5e6d4b$var$_typeof(obj);
}
var $387b2b38bb5e6d4b$var$MAX_ARRAY_LENGTH = 10;
var $387b2b38bb5e6d4b$var$MAX_RECURSIVE_DEPTH = 2;
function $387b2b38bb5e6d4b$export$2e2bcd8739ae039(value) {
    return $387b2b38bb5e6d4b$var$formatValue(value, []);
}
function $387b2b38bb5e6d4b$var$formatValue(value, seenValues) {
    switch($387b2b38bb5e6d4b$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $387b2b38bb5e6d4b$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $387b2b38bb5e6d4b$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $387b2b38bb5e6d4b$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $387b2b38bb5e6d4b$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $387b2b38bb5e6d4b$var$formatArray(value, seenValues);
    return $387b2b38bb5e6d4b$var$formatObject(value, seenValues);
}
function $387b2b38bb5e6d4b$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $387b2b38bb5e6d4b$var$MAX_RECURSIVE_DEPTH) return '[' + $387b2b38bb5e6d4b$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $387b2b38bb5e6d4b$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $387b2b38bb5e6d4b$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $387b2b38bb5e6d4b$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($387b2b38bb5e6d4b$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($387b2b38bb5e6d4b$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $387b2b38bb5e6d4b$var$getCustomFn(object) {
    var customInspectFn = object[String((0, $e5Dlp.default))];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $387b2b38bb5e6d4b$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});

parcelRegister("9kbnx", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c9ecedfbfa67ab7$export$2e2bcd8739ae039);

function $6c9ecedfbfa67ab7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $6c9ecedfbfa67ab7$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $6c9ecedfbfa67ab7$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6c9ecedfbfa67ab7$var$_typeof(obj);
}
var /**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */ // See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
$6c9ecedfbfa67ab7$export$2e2bcd8739ae039 = // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
    return value instanceof constructor;
};

});


parcelRegister("4nWzJ", function(module, exports) {
$parcel$export(module.exports, "DirectiveLocation", () => $3316bf4202cd07db$export$b45ffd2948484c41);
/**
 * The set of allowed directive location values.
 */ var $3316bf4202cd07db$export$b45ffd2948484c41 = Object.freeze({
    // Request Definitions
    QUERY: 'QUERY',
    MUTATION: 'MUTATION',
    SUBSCRIPTION: 'SUBSCRIPTION',
    FIELD: 'FIELD',
    FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
    FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
    INLINE_FRAGMENT: 'INLINE_FRAGMENT',
    VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
    // Type System Definitions
    SCHEMA: 'SCHEMA',
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    FIELD_DEFINITION: 'FIELD_DEFINITION',
    ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    ENUM_VALUE: 'ENUM_VALUE',
    INPUT_OBJECT: 'INPUT_OBJECT',
    INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
}); /**
 * The enum type representing the directive location values.
 */ 

});

parcelRegister("6XgSE", function(module, exports) {
$parcel$export(module.exports, "Lexer", () => $510558e4af143ea3$export$6168dc8908a6c652);
$parcel$export(module.exports, "isPunctuatorTokenKind", () => $510558e4af143ea3$export$59ac0f4da287406a);

var $iZFMu = parcelRequire("iZFMu");

var $19BqA = parcelRequire("19BqA");

var $ePiKI = parcelRequire("ePiKI");

var $l68uS = parcelRequire("l68uS");
var $510558e4af143ea3$export$6168dc8908a6c652 = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new (0, $19BqA.Token)((0, $ePiKI.TokenKind).SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    } /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ ;
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== (0, $ePiKI.TokenKind).EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = $510558e4af143ea3$var$readToken(this, token);
        }while (token.kind === (0, $ePiKI.TokenKind).COMMENT);
        return token;
    };
    return Lexer;
}();
function $510558e4af143ea3$export$59ac0f4da287406a(kind) {
    return kind === (0, $ePiKI.TokenKind).BANG || kind === (0, $ePiKI.TokenKind).DOLLAR || kind === (0, $ePiKI.TokenKind).AMP || kind === (0, $ePiKI.TokenKind).PAREN_L || kind === (0, $ePiKI.TokenKind).PAREN_R || kind === (0, $ePiKI.TokenKind).SPREAD || kind === (0, $ePiKI.TokenKind).COLON || kind === (0, $ePiKI.TokenKind).EQUALS || kind === (0, $ePiKI.TokenKind).AT || kind === (0, $ePiKI.TokenKind).BRACKET_L || kind === (0, $ePiKI.TokenKind).BRACKET_R || kind === (0, $ePiKI.TokenKind).BRACE_L || kind === (0, $ePiKI.TokenKind).PIPE || kind === (0, $ePiKI.TokenKind).BRACE_R;
}
function $510558e4af143ea3$var$printCharCode(code) {
    return isNaN(code) ? (0, $ePiKI.TokenKind).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"");
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $510558e4af143ea3$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = prev.end;
    while(pos < bodyLength){
        var code = body.charCodeAt(pos);
        var _line = lexer.line;
        var _col = 1 + pos - lexer.lineStart; // SourceCharacter
        switch(code){
            case 0xfeff:
            case 9:
            case 32:
            case 44:
                //  ,
                ++pos;
                continue;
            case 10:
                //  \n
                ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 13:
                //  \r
                if (body.charCodeAt(pos + 1) === 10) pos += 2;
                else ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 33:
                //  !
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).BANG, pos, pos + 1, _line, _col, prev);
            case 35:
                //  #
                return $510558e4af143ea3$var$readComment(source, pos, _line, _col, prev);
            case 36:
                //  $
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).DOLLAR, pos, pos + 1, _line, _col, prev);
            case 38:
                //  &
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).AMP, pos, pos + 1, _line, _col, prev);
            case 40:
                //  (
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).PAREN_L, pos, pos + 1, _line, _col, prev);
            case 41:
                //  )
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).PAREN_R, pos, pos + 1, _line, _col, prev);
            case 46:
                //  .
                if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).SPREAD, pos, pos + 3, _line, _col, prev);
                break;
            case 58:
                //  :
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).COLON, pos, pos + 1, _line, _col, prev);
            case 61:
                //  =
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).EQUALS, pos, pos + 1, _line, _col, prev);
            case 64:
                //  @
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).AT, pos, pos + 1, _line, _col, prev);
            case 91:
                //  [
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).BRACKET_L, pos, pos + 1, _line, _col, prev);
            case 93:
                //  ]
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).BRACKET_R, pos, pos + 1, _line, _col, prev);
            case 123:
                // {
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).BRACE_L, pos, pos + 1, _line, _col, prev);
            case 124:
                // |
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).PIPE, pos, pos + 1, _line, _col, prev);
            case 125:
                // }
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).BRACE_R, pos, pos + 1, _line, _col, prev);
            case 34:
                //  "
                if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $510558e4af143ea3$var$readBlockString(source, pos, _line, _col, prev, lexer);
                return $510558e4af143ea3$var$readString(source, pos, _line, _col, prev);
            case 45:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //  9
                return $510558e4af143ea3$var$readNumber(source, pos, code, _line, _col, prev);
            case 65:
            case 66:
            case 67:
            case 68:
            case 69:
            case 70:
            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
            case 76:
            case 77:
            case 78:
            case 79:
            case 80:
            case 81:
            case 82:
            case 83:
            case 84:
            case 85:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 95:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
            case 113:
            case 114:
            case 115:
            case 116:
            case 117:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
                // z
                return $510558e4af143ea3$var$readName(source, pos, _line, _col, prev);
        }
        throw (0, $iZFMu.syntaxError)(source, pos, $510558e4af143ea3$var$unexpectedCharacterMessage(code));
    }
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $510558e4af143ea3$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($510558e4af143ea3$var$printCharCode(code), ".");
    if (code === 39) // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
    return "Cannot parse the unexpected character ".concat($510558e4af143ea3$var$printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $510558e4af143ea3$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $510558e4af143ea3$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $iZFMu.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat($510558e4af143ea3$var$printCharCode(code), "."));
    } else {
        position = $510558e4af143ea3$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $510558e4af143ea3$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $510558e4af143ea3$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || $510558e4af143ea3$var$isNameStart(code)) throw (0, $iZFMu.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($510558e4af143ea3$var$printCharCode(code), "."));
    return new (0, $19BqA.Token)(isFloat ? (0, $ePiKI.TokenKind).FLOAT : (0, $ePiKI.TokenKind).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $510558e4af143ea3$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $iZFMu.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($510558e4af143ea3$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $510558e4af143ea3$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $iZFMu.syntaxError)(source, position, "Invalid character within String: ".concat($510558e4af143ea3$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += '/';
                    break;
                case 92:
                    value += '\\';
                    break;
                case 98:
                    value += '\b';
                    break;
                case 102:
                    value += '\f';
                    break;
                case 110:
                    value += '\n';
                    break;
                case 114:
                    value += '\r';
                    break;
                case 116:
                    value += '\t';
                    break;
                case 117:
                    // uXXXX
                    var charCode = $510558e4af143ea3$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $iZFMu.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $iZFMu.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $iZFMu.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $510558e4af143ea3$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).BLOCK_STRING, start, position + 3, line, col, prev, (0, $l68uS.dedentBlockStringValue)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $iZFMu.syntaxError)(source, position, "Invalid character within String: ".concat($510558e4af143ea3$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $iZFMu.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $510558e4af143ea3$var$uniCharCode(a, b, c, d) {
    return $510558e4af143ea3$var$char2hex(a) << 12 | $510558e4af143ea3$var$char2hex(b) << 8 | $510558e4af143ea3$var$char2hex(c) << 4 | $510558e4af143ea3$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $510558e4af143ea3$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $510558e4af143ea3$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function $510558e4af143ea3$var$isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

});
parcelRegister("l68uS", function(module, exports) {
$parcel$export(module.exports, "dedentBlockStringValue", () => $f5c0bfd4ee7d8292$export$fd88c0b652c46ccc);
$parcel$export(module.exports, "printBlockString", () => $f5c0bfd4ee7d8292$export$adb6ca997eeb1f45);
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $f5c0bfd4ee7d8292$export$fd88c0b652c46ccc(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $f5c0bfd4ee7d8292$export$3c95bfdc680af0c(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $f5c0bfd4ee7d8292$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $f5c0bfd4ee7d8292$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join('\n');
}
function $f5c0bfd4ee7d8292$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== ' ' && str[i] !== '\t') return false;
    }
    return true;
}
function $f5c0bfd4ee7d8292$export$3c95bfdc680af0c(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
function $f5c0bfd4ee7d8292$export$adb6ca997eeb1f45(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === '\\';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

});




parcelRegister("1fMqv", function(module, exports) {
$parcel$export(module.exports, "useQuery", () => $0e9cc1ab166e5529$export$dd0a697e1782aedd);
$parcel$export(module.exports, "useLazyQuery", () => $0e9cc1ab166e5529$export$fd83eea6ecd2d8fa);
$parcel$export(module.exports, "useMutation", () => $0e9cc1ab166e5529$export$609860bf8b0084c);
$parcel$export(module.exports, "useApolloClient", () => $0e9cc1ab166e5529$export$eb9a56e7a29e494);

var $688i3 = parcelRequire("688i3");

var $dnskZ = parcelRequire("dnskZ");

var $eJOHy = parcelRequire("eJOHy");

var $eezJL = parcelRequire("eezJL");

var $hR4hP = parcelRequire("hR4hP");

var $lDEi6 = parcelRequire("lDEi6");
var $0e9cc1ab166e5529$var$OperationData = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $hR4hP.equal)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $lDEi6.invariant)(!!client, 2);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $688i3.parser)(document);
        var requiredOperationName = (0, $688i3.operationName)(type);
        var usedOperationName = (0, $688i3.operationName)(operation.type);
        (0, $lDEi6.invariant)(operation.type === type, 3);
    };
    return OperationData;
}();
var $0e9cc1ab166e5529$var$QueryData = function(_super) {
    (0, $dnskZ.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.currentObservable = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.forceUpdate();
        };
        _this.getExecuteResult = function() {
            var result = _this.getQueryResult();
            _this.startQuerySubscription();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.query.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.query.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.query.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.query.subscribeToMore(options);
        };
        _this.forceUpdate = forceUpdate;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $eezJL.NetworkStatus).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        var obs = this.currentObservable.query;
        var currentResult = obs.getCurrentResult();
        return currentResult.loading ? obs.result() : false;
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _this = this;
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) {
            this.handleErrorOrCompleted();
            setTimeout(function() {
                _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
            });
        }
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable.query;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var treeRenderingInitiated = this.context && this.context.renderPromises;
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = {
            loading: true,
            networkStatus: (0, $eezJL.NetworkStatus).loading,
            called: true,
            data: undefined
        };
        if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
        var result;
        if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $688i3.DocumentType).Query);
        var displayName = options.displayName || 'Query';
        if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
        return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options), {
            displayName: displayName,
            context: options.context,
            metadata: {
                reactComponent: {
                    displayName: displayName
                }
            }
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable.query) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable.query = this.refreshClient().client.watchQuery((0, $dnskZ.__assign)({}, observableQueryOptions));
            if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable.query) {
            this.initializeObservableQuery();
            return;
        }
        var newObservableQueryOptions = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $hR4hP.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function() {
        var _this = this;
        if (this.currentObservable.subscription || this.getOptions().skip) return;
        var obsQuery = this.currentObservable.query;
        this.currentObservable.subscription = obsQuery.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $hR4hP.equal)(previousResult.data, data)) return;
                _this.forceUpdate();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors')) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, $hR4hP.equal)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    _this.forceUpdate();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var lastError = this.currentObservable.query.getLastError();
        var lastResult = this.currentObservable.query.getLastResult();
        this.currentObservable.query.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.currentObservable.query, {
            lastError: lastError,
            lastResult: lastResult
        });
    };
    QueryData.prototype.getQueryResult = function() {
        var result = this.observableQueryFields();
        var options = this.getOptions();
        if (options.skip) result = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, result), {
            data: undefined,
            error: undefined,
            loading: false,
            called: true
        });
        else {
            var currentResult = this.currentObservable.query.getCurrentResult();
            var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error, data = currentResult.data;
            if (errors && errors.length > 0) error = new (0, $eezJL.ApolloError)({
                graphQLErrors: errors
            });
            result = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, result), {
                loading: loading,
                networkStatus: networkStatus,
                error: error,
                called: true
            });
            if (loading) {
                var previousData = this.previousData.result && this.previousData.result.data;
                result.data = previousData && data ? (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, previousData), data) : previousData || data;
            } else if (error) Object.assign(result, {
                data: (this.currentObservable.query.getLastResult() || {}).data
            });
            else {
                var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                var partialRefetch = options.partialRefetch;
                if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                    Object.assign(result, {
                        loading: true,
                        networkStatus: (0, $eezJL.NetworkStatus).loading
                    });
                    result.refetch();
                    return result;
                }
                result.data = data;
            }
        }
        result.client = this.client;
        this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
        this.previousData.result = result;
        return result;
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        var obsQuery = this.currentObservable.query;
        if (!obsQuery) return;
        var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
            if (this.previousOptions && !this.previousData.loading && (0, $hR4hP.equal)(this.previousOptions.query, query) && (0, $hR4hP.equal)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var observable = this.currentObservable.query;
        return {
            variables: observable.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}($0e9cc1ab166e5529$var$OperationData);
function $0e9cc1ab166e5529$var$useDeepMemo(memoFn, key) {
    var ref = (0, $eJOHy.useRef)();
    if (!ref.current || !(0, $hR4hP.equal)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}
function $0e9cc1ab166e5529$var$useBaseQuery(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $eJOHy.useContext)((0, $688i3.getApolloContext)());
    var _a = (0, $eJOHy.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $eJOHy.useRef)();
    if (!queryDataRef.current) queryDataRef.current = new $0e9cc1ab166e5529$var$QueryData({
        options: updatedOptions,
        context: context,
        forceUpdate: forceUpdate
    });
    var queryData = queryDataRef.current;
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    var memo = {
        options: (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = $0e9cc1ab166e5529$var$useDeepMemo(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $eJOHy.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    (0, $eJOHy.useEffect)(function() {
        return function() {
            return queryData.cleanup();
        };
    }, []);
    return result;
}
function $0e9cc1ab166e5529$export$dd0a697e1782aedd(query, options) {
    return $0e9cc1ab166e5529$var$useBaseQuery(query, options, false);
}
function $0e9cc1ab166e5529$export$fd83eea6ecd2d8fa(query, options) {
    return $0e9cc1ab166e5529$var$useBaseQuery(query, options, true);
}
var $0e9cc1ab166e5529$var$MutationData = function(_super) {
    (0, $dnskZ.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $688i3.DocumentType).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $688i3.DocumentType).Mutation);
        result.client = this.refreshClient().client;
        return [
            this.runMutation,
            result
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
        var mutateOptions = (0, $dnskZ.__assign)({}, mutationFunctionOptions);
        var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
        delete mutateOptions.variables;
        return this.refreshClient().client.mutate((0, $dnskZ.__assign)({
            mutation: mutation,
            optimisticResponse: optimisticResponse,
            refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: mutationContext,
            fetchPolicy: fetchPolicy,
            variables: mutateVariables
        }, mutateOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $eezJL.ApolloError)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $hR4hP.equal)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}($0e9cc1ab166e5529$var$OperationData);
function $0e9cc1ab166e5529$export$609860bf8b0084c(mutation, options) {
    var context = (0, $eJOHy.useContext)((0, $688i3.getApolloContext)());
    var _a = (0, $eJOHy.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $eJOHy.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new $0e9cc1ab166e5529$var$MutationData({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $eJOHy.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}
var $0e9cc1ab166e5529$var$SubscriptionData = function(_super) {
    (0, $dnskZ.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $hR4hP.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}($0e9cc1ab166e5529$var$OperationData);
function $0e9cc1ab166e5529$export$368b4214baeb914c(subscription, options) {
    var context = (0, $eJOHy.useContext)((0, $688i3.getApolloContext)());
    var updatedOptions = options ? (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $eJOHy.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $eJOHy.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new $0e9cc1ab166e5529$var$SubscriptionData({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $eJOHy.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $eJOHy.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}
function $0e9cc1ab166e5529$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $688i3.getApolloContext)()).client;
    (0, $lDEi6.invariant)(client, 1);
    return client;
}
function $0e9cc1ab166e5529$var$makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var $0e9cc1ab166e5529$export$260e90e395a79974 = function() {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
    }
    RenderPromises.prototype.registerSSRObservable = function(observable, props) {
        this.lookupQueryInfo(props).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function(props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
        var info = this.lookupQueryInfo(queryInstance.getOptions());
        if (!info.seen) {
            this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                resolve(queryInstance.fetchData());
            }));
            return null;
        }
        return finish();
    };
    RenderPromises.prototype.hasPromises = function() {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function() {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function(promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function(props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || $0e9cc1ab166e5529$var$makeDefaultQueryInfo();
        if (!varMap.has(variablesString)) varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}();

});
parcelRegister("688i3", function(module, exports) {
$parcel$export(module.exports, "getApolloContext", () => $4769ebafec57fcc9$export$a47505d961ee3a1);
$parcel$export(module.exports, "ApolloProvider", () => $4769ebafec57fcc9$export$c16b04c8a9956446);
$parcel$export(module.exports, "DocumentType", () => $4769ebafec57fcc9$export$d1d99cf900472499);
$parcel$export(module.exports, "operationName", () => $4769ebafec57fcc9$export$5db520940cf00715);
$parcel$export(module.exports, "parser", () => $4769ebafec57fcc9$export$8f49e4af10703ce3);

var $eJOHy = parcelRequire("eJOHy");

var $lDEi6 = parcelRequire("lDEi6");
var $4769ebafec57fcc9$var$apolloContext;
function $4769ebafec57fcc9$export$a47505d961ee3a1() {
    if (!$4769ebafec57fcc9$var$apolloContext) $4769ebafec57fcc9$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext({});
    return $4769ebafec57fcc9$var$apolloContext;
}
function $4769ebafec57fcc9$export$c2ee824bcc89ca6a() {
    $4769ebafec57fcc9$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext({});
}
var $4769ebafec57fcc9$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $4769ebafec57fcc9$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $lDEi6.invariant)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $4769ebafec57fcc9$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $4769ebafec57fcc9$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $lDEi6.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $4769ebafec57fcc9$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($4769ebafec57fcc9$export$d1d99cf900472499 || ($4769ebafec57fcc9$export$d1d99cf900472499 = {}));
var $4769ebafec57fcc9$var$cache = new Map();
function $4769ebafec57fcc9$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $4769ebafec57fcc9$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $4769ebafec57fcc9$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $4769ebafec57fcc9$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $4769ebafec57fcc9$export$8f49e4af10703ce3(document) {
    var cached = $4769ebafec57fcc9$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $lDEi6.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $lDEi6.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $lDEi6.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $4769ebafec57fcc9$export$d1d99cf900472499.Query : $4769ebafec57fcc9$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $4769ebafec57fcc9$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $lDEi6.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $4769ebafec57fcc9$var$cache.set(document, payload);
    return payload;
}

});
parcelRegister("lDEi6", function(module, exports) {
$parcel$export(module.exports, "InvariantError", () => $fc0c7e72915b693a$export$cea12affaee22fe8);
$parcel$export(module.exports, "invariant", () => $fc0c7e72915b693a$export$f5708dca728d7177);

var $dnskZ = parcelRequire("dnskZ");

var $igDjg = parcelRequire("igDjg");
var $fc0c7e72915b693a$var$genericMessage = "Invariant Violation";
var $fc0c7e72915b693a$var$_a = Object.setPrototypeOf, $fc0c7e72915b693a$var$setPrototypeOf = $fc0c7e72915b693a$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $fc0c7e72915b693a$var$_a;
var $fc0c7e72915b693a$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $dnskZ.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $fc0c7e72915b693a$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $fc0c7e72915b693a$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $fc0c7e72915b693a$var$genericMessage;
        $fc0c7e72915b693a$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $fc0c7e72915b693a$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $fc0c7e72915b693a$export$cea12affaee22fe8(message);
}
function $fc0c7e72915b693a$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $fc0c7e72915b693a$var$wrapConsoleMethod("warn");
    invariant.error = $fc0c7e72915b693a$var$wrapConsoleMethod("error");
})($fc0c7e72915b693a$export$f5708dca728d7177 || ($fc0c7e72915b693a$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $fc0c7e72915b693a$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $igDjg === "object") $fc0c7e72915b693a$export$e54fe5b0f43758f7 = $igDjg;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($fc0c7e72915b693a$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $fc0c7e72915b693a$var$invariant$1 = $fc0c7e72915b693a$export$f5708dca728d7177;
var $fc0c7e72915b693a$export$2e2bcd8739ae039 = $fc0c7e72915b693a$var$invariant$1;

});


parcelRegister("eezJL", function(module, exports) {
$parcel$export(module.exports, "NetworkStatus", () => $a5ce1825a60c4eb2$export$bd096ddbd246c79c);
$parcel$export(module.exports, "isApolloError", () => $a5ce1825a60c4eb2$export$17f5e6bd290bb15d);
$parcel$export(module.exports, "ApolloError", () => $a5ce1825a60c4eb2$export$26a337512320b8c6);
$parcel$export(module.exports, "ApolloClient", () => $a5ce1825a60c4eb2$export$13f5a5f0f1dbab88);

var $dnskZ = parcelRequire("dnskZ");

var $jFDfc = parcelRequire("jFDfc");
var $hR4hP = parcelRequire("hR4hP");

var $7oe8F = parcelRequire("7oe8F");
var $1ZCcZ = parcelRequire("1ZCcZ");

var $2KZeD = parcelRequire("2KZeD");

var $lDEi6 = parcelRequire("lDEi6");

var $9E3xk = parcelRequire("9E3xk");
var $a5ce1825a60c4eb2$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($a5ce1825a60c4eb2$export$bd096ddbd246c79c || ($a5ce1825a60c4eb2$export$bd096ddbd246c79c = {}));
function $a5ce1825a60c4eb2$var$isNetworkRequestInFlight(networkStatus) {
    return networkStatus < 7;
}
var $a5ce1825a60c4eb2$var$Observable = function(_super) {
    (0, $dnskZ.__extends)(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.prototype[0, $2KZeD.default] = function() {
        return this;
    };
    Observable.prototype['@@observable'] = function() {
        return this;
    };
    return Observable;
}((0, $1ZCcZ.default));
function $a5ce1825a60c4eb2$var$isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
function $a5ce1825a60c4eb2$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var $a5ce1825a60c4eb2$var$generateErrorMessage = function(err) {
    var message = '';
    if ($a5ce1825a60c4eb2$var$isNonEmptyArray(err.graphQLErrors)) err.graphQLErrors.forEach(function(graphQLError) {
        var errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += "GraphQL error: " + errorMessage + "\n";
    });
    if (err.networkError) message += 'Network error: ' + err.networkError.message + '\n';
    message = message.replace(/\n$/, '');
    return message;
};
var $a5ce1825a60c4eb2$export$26a337512320b8c6 = function(_super) {
    (0, $dnskZ.__extends)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        if (!errorMessage) _this.message = $a5ce1825a60c4eb2$var$generateErrorMessage(_this);
        else _this.message = errorMessage;
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);
var $a5ce1825a60c4eb2$export$160bafb6ac1e0641;
(function(FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})($a5ce1825a60c4eb2$export$160bafb6ac1e0641 || ($a5ce1825a60c4eb2$export$160bafb6ac1e0641 = {}));
var $a5ce1825a60c4eb2$var$hasError = function(storeValue, policy) {
    if (policy === void 0) policy = 'none';
    return storeValue && (storeValue.networkError || policy === 'none' && $a5ce1825a60c4eb2$var$isNonEmptyArray(storeValue.graphQLErrors));
};
var $a5ce1825a60c4eb2$export$6c1b56eac59c9584 = function(_super) {
    (0, $dnskZ.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
        var _this = _super.call(this, function(observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.isTornDown = false;
        _this.options = options;
        _this.variables = options.variables || {};
        _this.queryId = queryManager.generateQueryId();
        _this.shouldSubscribe = shouldSubscribe;
        var opDef = (0, $jFDfc.getOperationDefinition)(options.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        _this.queryManager = queryManager;
        return _this;
    }
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var observer = {
                next: function(result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.currentResult = function() {
        var result = this.getCurrentResult();
        if (result.data === undefined) result.data = {};
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function() {
        if (this.isTornDown) {
            var lastResult = this.lastResult;
            return {
                data: !this.lastError && lastResult && lastResult.data || void 0,
                error: this.lastError,
                loading: false,
                networkStatus: $a5ce1825a60c4eb2$export$bd096ddbd246c79c.error
            };
        }
        var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
        var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
        var result;
        var fetchPolicy = this.options.fetchPolicy;
        var isNetworkFetchPolicy = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
        if (queryStoreValue) {
            var networkStatus = queryStoreValue.networkStatus;
            if ($a5ce1825a60c4eb2$var$hasError(queryStoreValue, this.options.errorPolicy)) return {
                data: void 0,
                loading: false,
                networkStatus: networkStatus,
                error: new $a5ce1825a60c4eb2$export$26a337512320b8c6({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError
                })
            };
            if (queryStoreValue.variables) {
                this.options.variables = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.options.variables), queryStoreValue.variables);
                this.variables = this.options.variables;
            }
            result = {
                data: data,
                loading: $a5ce1825a60c4eb2$var$isNetworkRequestInFlight(networkStatus),
                networkStatus: networkStatus
            };
            if (queryStoreValue.graphQLErrors && this.options.errorPolicy === 'all') result.errors = queryStoreValue.graphQLErrors;
        } else {
            var loading = isNetworkFetchPolicy || partial && fetchPolicy !== 'cache-only';
            result = {
                data: data,
                loading: loading,
                networkStatus: loading ? $a5ce1825a60c4eb2$export$bd096ddbd246c79c.loading : $a5ce1825a60c4eb2$export$bd096ddbd246c79c.ready
            };
        }
        if (!partial) this.updateLastResult((0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, result), {
            stale: false
        }));
        return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, result), {
            partial: partial
        });
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult) {
        var snapshot = this.lastResultSnapshot;
        return !(snapshot && newResult && snapshot.networkStatus === newResult.networkStatus && snapshot.stale === newResult.stale && (0, $hR4hP.equal)(snapshot.data, newResult.data));
    };
    ObservableQuery.prototype.getLastResult = function() {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function() {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.lastResult;
        delete this.lastResultSnapshot;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        var queryStore = this.queryManager.queryStore.get(this.queryId);
        if (queryStore) {
            queryStore.networkError = null;
            queryStore.graphQLErrors = [];
        }
    };
    ObservableQuery.prototype.refetch = function(variables) {
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-only') return Promise.reject(new (0, $lDEi6.InvariantError)(1));
        if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'cache-and-network') fetchPolicy = 'network-only';
        if (!(0, $hR4hP.equal)(this.variables, variables)) this.variables = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.variables), variables);
        if (!(0, $hR4hP.equal)(this.options.variables, this.variables)) this.options.variables = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.options.variables), this.variables);
        return this.queryManager.fetchQuery(this.queryId, (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.options), {
            fetchPolicy: fetchPolicy
        }), $a5ce1825a60c4eb2$export$160bafb6ac1e0641.refetch);
    };
    ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        (0, $lDEi6.invariant)(fetchMoreOptions.updateQuery, 2);
        var combinedOptions = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $dnskZ.__assign)((0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.options), fetchMoreOptions), {
            variables: (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.variables), fetchMoreOptions.variables)
        })), {
            fetchPolicy: 'network-only'
        });
        var qid = this.queryManager.generateQueryId();
        return this.queryManager.fetchQuery(qid, combinedOptions, $a5ce1825a60c4eb2$export$160bafb6ac1e0641.normal, this.queryId).then(function(fetchMoreResult) {
            _this.updateQuery(function(previousResult) {
                return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables
                });
            });
            _this.queryManager.stopQuery(qid);
            return fetchMoreResult;
        }, function(error) {
            _this.queryManager.stopQuery(qid);
            throw error;
        });
    };
    ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(opts) {
        var oldFetchPolicy = this.options.fetchPolicy;
        this.options = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.options), opts);
        if (opts.pollInterval) this.startPolling(opts.pollInterval);
        else if (opts.pollInterval === 0) this.stopPolling();
        var fetchPolicy = opts.fetchPolicy;
        return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === 'cache-only' || oldFetchPolicy === 'standby' || fetchPolicy === 'network-only'), opts.fetchResults);
    };
    ObservableQuery.prototype.setVariables = function(variables, tryFetch, fetchResults) {
        if (tryFetch === void 0) tryFetch = false;
        if (fetchResults === void 0) fetchResults = true;
        this.isTornDown = false;
        variables = variables || this.variables;
        if (!tryFetch && (0, $hR4hP.equal)(variables, this.variables)) return this.observers.size && fetchResults ? this.result() : Promise.resolve();
        this.variables = this.options.variables = variables;
        if (!this.observers.size) return Promise.resolve();
        return this.queryManager.fetchQuery(this.queryId, this.options);
    };
    ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var _a = queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
        var newResult = (0, $jFDfc.tryFunctionOrLogError)(function() {
            return mapFn(previousResult, {
                variables: variables
            });
        });
        if (newResult) {
            queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.stopPolling = function() {
        this.queryManager.stopPollingQuery(this.queryId);
        this.options.pollInterval = undefined;
    };
    ObservableQuery.prototype.startPolling = function(pollInterval) {
        $a5ce1825a60c4eb2$var$assertNotCacheFirstOrOnly(this);
        this.options.pollInterval = pollInterval;
        this.queryManager.startPollingQuery(this.options, this.queryId);
    };
    ObservableQuery.prototype.updateLastResult = function(newResult) {
        var previousResult = this.lastResult;
        this.lastResult = newResult;
        this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? newResult : (0, $jFDfc.cloneDeep)(newResult);
        return previousResult;
    };
    ObservableQuery.prototype.onSubscribe = function(observer) {
        var _this = this;
        try {
            var subObserver = observer._subscription._observer;
            if (subObserver && !subObserver.error) subObserver.error = $a5ce1825a60c4eb2$var$defaultSubscriptionObserverErrorCallback;
        } catch (_a) {}
        var first = !this.observers.size;
        this.observers.add(observer);
        if (observer.next && this.lastResult) observer.next(this.lastResult);
        if (observer.error && this.lastError) observer.error(this.lastError);
        if (first) this.setUpQuery();
        return function() {
            if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
        };
    };
    ObservableQuery.prototype.setUpQuery = function() {
        var _this = this;
        var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
        if (this.shouldSubscribe) queryManager.addObservableQuery(queryId, this);
        if (this.options.pollInterval) {
            $a5ce1825a60c4eb2$var$assertNotCacheFirstOrOnly(this);
            queryManager.startPollingQuery(this.options, queryId);
        }
        var onError = function(error) {
            _this.updateLastResult((0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, _this.lastResult), {
                errors: error.graphQLErrors,
                networkStatus: $a5ce1825a60c4eb2$export$bd096ddbd246c79c.error,
                loading: false
            }));
            $a5ce1825a60c4eb2$var$iterateObserversSafely(_this.observers, 'error', _this.lastError = error);
        };
        queryManager.observeQuery(queryId, this.options, {
            next: function(result) {
                if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                    var previousResult_1 = _this.updateLastResult(result);
                    var _a = _this.options, query_1 = _a.query, variables = _a.variables, fetchPolicy_1 = _a.fetchPolicy;
                    if (queryManager.transform(query_1).hasClientExports) queryManager.getLocalState().addExportedVariables(query_1, variables).then(function(variables) {
                        var previousVariables = _this.variables;
                        _this.variables = _this.options.variables = variables;
                        if (!result.loading && previousResult_1 && fetchPolicy_1 !== 'cache-only' && queryManager.transform(query_1).serverQuery && !(0, $hR4hP.equal)(previousVariables, variables)) _this.refetch();
                        else $a5ce1825a60c4eb2$var$iterateObserversSafely(_this.observers, 'next', result);
                    });
                    else $a5ce1825a60c4eb2$var$iterateObserversSafely(_this.observers, 'next', result);
                }
            },
            error: onError
        }).catch(onError);
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        var queryManager = this.queryManager;
        this.isTornDown = true;
        queryManager.stopPollingQuery(this.queryId);
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        queryManager.removeObservableQuery(this.queryId);
        queryManager.stopQuery(this.queryId);
        this.observers.clear();
    };
    return ObservableQuery;
}($a5ce1825a60c4eb2$var$Observable);
function $a5ce1825a60c4eb2$var$defaultSubscriptionObserverErrorCallback(error) {}
function $a5ce1825a60c4eb2$var$iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}
function $a5ce1825a60c4eb2$var$assertNotCacheFirstOrOnly(obsQuery) {
    var fetchPolicy = obsQuery.options.fetchPolicy;
    (0, $lDEi6.invariant)(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 3);
}
var $a5ce1825a60c4eb2$var$MutationStore = function() {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function() {
        return this.store;
    };
    MutationStore.prototype.get = function(mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function(mutationId, mutation, variables) {
        this.store[mutationId] = {
            mutation: mutation,
            variables: variables || {},
            loading: true,
            error: null
        };
    };
    MutationStore.prototype.markMutationError = function(mutationId, error) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = error;
        }
    };
    MutationStore.prototype.markMutationResult = function(mutationId) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = null;
        }
    };
    MutationStore.prototype.reset = function() {
        this.store = {};
    };
    return MutationStore;
}();
var $a5ce1825a60c4eb2$var$QueryStore = function() {
    function QueryStore() {
        this.store = {};
    }
    QueryStore.prototype.getStore = function() {
        return this.store;
    };
    QueryStore.prototype.get = function(queryId) {
        return this.store[queryId];
    };
    QueryStore.prototype.initQuery = function(query) {
        var previousQuery = this.store[query.queryId];
        (0, $lDEi6.invariant)(!previousQuery || previousQuery.document === query.document || (0, $hR4hP.equal)(previousQuery.document, query.document), 19);
        var isSetVariables = false;
        var previousVariables = null;
        if (query.storePreviousVariables && previousQuery && previousQuery.networkStatus !== $a5ce1825a60c4eb2$export$bd096ddbd246c79c.loading) {
            if (!(0, $hR4hP.equal)(previousQuery.variables, query.variables)) {
                isSetVariables = true;
                previousVariables = previousQuery.variables;
            }
        }
        var networkStatus;
        if (isSetVariables) networkStatus = $a5ce1825a60c4eb2$export$bd096ddbd246c79c.setVariables;
        else if (query.isPoll) networkStatus = $a5ce1825a60c4eb2$export$bd096ddbd246c79c.poll;
        else if (query.isRefetch) networkStatus = $a5ce1825a60c4eb2$export$bd096ddbd246c79c.refetch;
        else networkStatus = $a5ce1825a60c4eb2$export$bd096ddbd246c79c.loading;
        var graphQLErrors = [];
        if (previousQuery && previousQuery.graphQLErrors) graphQLErrors = previousQuery.graphQLErrors;
        this.store[query.queryId] = {
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: graphQLErrors,
            networkStatus: networkStatus,
            metadata: query.metadata
        };
        if (typeof query.fetchMoreForQueryId === 'string' && this.store[query.fetchMoreForQueryId]) this.store[query.fetchMoreForQueryId].networkStatus = $a5ce1825a60c4eb2$export$bd096ddbd246c79c.fetchMore;
    };
    QueryStore.prototype.markQueryResult = function(queryId, result, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = null;
        this.store[queryId].graphQLErrors = $a5ce1825a60c4eb2$var$isNonEmptyArray(result.errors) ? result.errors : [];
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = $a5ce1825a60c4eb2$export$bd096ddbd246c79c.ready;
        if (typeof fetchMoreForQueryId === 'string' && this.store[fetchMoreForQueryId]) this.store[fetchMoreForQueryId].networkStatus = $a5ce1825a60c4eb2$export$bd096ddbd246c79c.ready;
    };
    QueryStore.prototype.markQueryError = function(queryId, error, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = error;
        this.store[queryId].networkStatus = $a5ce1825a60c4eb2$export$bd096ddbd246c79c.error;
        if (typeof fetchMoreForQueryId === 'string') this.markQueryResultClient(fetchMoreForQueryId, true);
    };
    QueryStore.prototype.markQueryResultClient = function(queryId, complete) {
        var storeValue = this.store && this.store[queryId];
        if (storeValue) {
            storeValue.networkError = null;
            storeValue.previousVariables = null;
            if (complete) storeValue.networkStatus = $a5ce1825a60c4eb2$export$bd096ddbd246c79c.ready;
        }
    };
    QueryStore.prototype.stopQuery = function(queryId) {
        delete this.store[queryId];
    };
    QueryStore.prototype.reset = function(observableQueryIds) {
        var _this = this;
        Object.keys(this.store).forEach(function(queryId) {
            if (observableQueryIds.indexOf(queryId) < 0) _this.stopQuery(queryId);
            else _this.store[queryId].networkStatus = $a5ce1825a60c4eb2$export$bd096ddbd246c79c.loading;
        });
    };
    return QueryStore;
}();
function $a5ce1825a60c4eb2$var$capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
var $a5ce1825a60c4eb2$var$LocalState = function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $jFDfc.mergeDeep)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $jFDfc.mergeDeep)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function(_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0, $dnskZ.__awaiter)(this, void 0, void 0, function() {
            return (0, $dnskZ.__generator)(this, function(_c) {
                if (document) return [
                    2,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $jFDfc.hasDirectives)([
            'client'
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    LocalState.prototype.serverQuery = function(document) {
        return this.resolvers ? (0, $jFDfc.removeClientSetsFromDocument)(document) : document;
    };
    LocalState.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var cache = this.cache;
        var newContext = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, context), {
            cache: cache,
            getCacheKey: function(obj) {
                if (cache.config) return cache.config.dataIdFromObject(obj);
                else (0, $lDEi6.invariant)(false, 6);
            }
        });
        return newContext;
    };
    LocalState.prototype.addExportedVariables = function(document, variables, context) {
        if (variables === void 0) variables = {};
        if (context === void 0) context = {};
        return (0, $dnskZ.__awaiter)(this, void 0, void 0, function() {
            return (0, $dnskZ.__generator)(this, function(_a) {
                if (document) return [
                    2,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2,
                    (0, $dnskZ.__assign)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $9E3xk.visit)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === 'always' && arg.value.kind === 'BooleanValue' && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $9E3xk.BREAK;
                    }
                }
            }
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $jFDfc.buildQueryFromSelectionSet)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) context = {};
        if (variables === void 0) variables = {};
        if (fragmentMatcher === void 0) fragmentMatcher = function() {
            return true;
        };
        if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
        return (0, $dnskZ.__awaiter)(this, void 0, void 0, function() {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return (0, $dnskZ.__generator)(this, function(_b) {
                mainDefinition = (0, $jFDfc.getMainDefinition)(document);
                fragments = (0, $jFDfc.getFragmentDefinitions)(document);
                fragmentMap = (0, $jFDfc.createFragmentMap)(fragments);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? $a5ce1825a60c4eb2$var$capitalizeFirstLetter(definitionOperation) : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                return [
                    2,
                    this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, rootValue, execContext) {
        return (0, $dnskZ.__awaiter)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $dnskZ.__generator)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $dnskZ.__awaiter)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $dnskZ.__generator)(this, function(_a) {
                            if (!(0, $jFDfc.shouldInclude)(selection, variables)) return [
                                2
                            ];
                            if ((0, $jFDfc.isField)(selection)) return [
                                2,
                                this.resolveField(selection, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') resultsToMerge.push((_a = {}, _a[(0, $jFDfc.resultKeyNameFromField)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $jFDfc.isInlineFragment)(selection)) fragment = selection;
                            else {
                                fragment = fragmentMap[selection.name.value];
                                (0, $lDEi6.invariant)(fragment, 7);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2,
                                    this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2
                            ];
                        });
                    });
                };
                return [
                    2,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $jFDfc.mergeDeepArray)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, rootValue, execContext) {
        return (0, $dnskZ.__awaiter)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $dnskZ.__generator)(this, function(_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $jFDfc.resultKeyNameFromField)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(resolve(rootValue, (0, $jFDfc.argumentsObjectFromField)(field, variables), execContext.context, {
                            field: field,
                            fragmentMap: execContext.fragmentMap
                        }));
                    }
                }
                return [
                    2,
                    resultPromise.then(function(result) {
                        if (result === void 0) result = defaultResult;
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === 'export' && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === 'as' && arg.value.kind === 'StringValue') execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        if (!field.selectionSet) return result;
                        if (result == null) return result;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, result, execContext);
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, item, execContext);
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, item, execContext);
        }));
    };
    return LocalState;
}();
function $a5ce1825a60c4eb2$var$multiplex(inner) {
    var observers = new Set();
    var sub = null;
    return new $a5ce1825a60c4eb2$var$Observable(function(observer) {
        observers.add(observer);
        sub = sub || inner.subscribe({
            next: function(value) {
                observers.forEach(function(obs) {
                    return obs.next && obs.next(value);
                });
            },
            error: function(error) {
                observers.forEach(function(obs) {
                    return obs.error && obs.error(error);
                });
            },
            complete: function() {
                observers.forEach(function(obs) {
                    return obs.complete && obs.complete();
                });
            }
        });
        return function() {
            if (observers.delete(observer) && !observers.size && sub) {
                sub.unsubscribe();
                sub = null;
            }
        };
    });
}
function $a5ce1825a60c4eb2$var$asyncMap(observable, mapFn) {
    return new $a5ce1825a60c4eb2$var$Observable(function(observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeNextCount = 0;
        var completed = false;
        var handler = {
            next: function(value) {
                ++activeNextCount;
                new Promise(function(resolve) {
                    resolve(mapFn(value));
                }).then(function(result) {
                    --activeNextCount;
                    next && next.call(observer, result);
                    completed && handler.complete();
                }, function(e) {
                    --activeNextCount;
                    error && error.call(observer, e);
                });
            },
            error: function(e) {
                error && error.call(observer, e);
            },
            complete: function() {
                completed = true;
                if (!activeNextCount) complete && complete.call(observer);
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}
var $a5ce1825a60c4eb2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $a5ce1825a60c4eb2$var$QueryManager = function() {
    function QueryManager(_a) {
        var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function() {
            return undefined;
        } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.mutationStore = new $a5ce1825a60c4eb2$var$MutationStore();
        this.queryStore = new $a5ce1825a60c4eb2$var$QueryStore();
        this.clientAwareness = {};
        this.idCounter = 1;
        this.queries = new Map();
        this.fetchQueryRejectFns = new Map();
        this.transformCache = new ((0, $jFDfc.canUseWeakMap) ? WeakMap : Map)();
        this.inFlightLinkObservables = new Map();
        this.pollingInfoByQueryId = new Map();
        this.link = link;
        this.queryDeduplication = queryDeduplication;
        this.dataStore = store;
        this.onBroadcast = onBroadcast;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new $a5ce1825a60c4eb2$var$LocalState({
            cache: store.getCache()
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
    }
    QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $lDEi6.InvariantError)(8));
        });
    };
    QueryManager.prototype.mutate = function(_a) {
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        return (0, $dnskZ.__awaiter)(this, void 0, void 0, function() {
            var mutationId, generateUpdateQueriesInfo, self;
            var _this = this;
            return (0, $dnskZ.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        (0, $lDEi6.invariant)(mutation, 9);
                        (0, $lDEi6.invariant)(!fetchPolicy || fetchPolicy === 'no-cache', 10);
                        mutationId = this.generateQueryId();
                        mutation = this.transform(mutation).document;
                        this.setQuery(mutationId, function() {
                            return {
                                document: mutation
                            };
                        });
                        variables = this.getVariables(mutation, variables);
                        if (!this.transform(mutation).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _f.sent();
                        _f.label = 2;
                    case 2:
                        generateUpdateQueriesInfo = function() {
                            var ret = {};
                            if (updateQueriesByName) _this.queries.forEach(function(_a, queryId) {
                                var observableQuery = _a.observableQuery;
                                if (observableQuery) {
                                    var queryName = observableQuery.queryName;
                                    if (queryName && $a5ce1825a60c4eb2$var$hasOwnProperty.call(updateQueriesByName, queryName)) ret[queryId] = {
                                        updater: updateQueriesByName[queryName],
                                        query: _this.queryStore.get(queryId)
                                    };
                                }
                            });
                            return ret;
                        };
                        this.mutationStore.initMutation(mutationId, mutation, variables);
                        this.dataStore.markMutationInit({
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            updateQueries: generateUpdateQueriesInfo(),
                            update: updateWithProxyFn,
                            optimisticResponse: optimisticResponse
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var storeResult;
                                var error;
                                self.getObservableFromLink(mutation, (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, context), {
                                    optimisticResponse: optimisticResponse
                                }), variables, false).subscribe({
                                    next: function(result) {
                                        if ((0, $jFDfc.graphQLResultHasError)(result) && errorPolicy === 'none') {
                                            error = new $a5ce1825a60c4eb2$export$26a337512320b8c6({
                                                graphQLErrors: result.errors
                                            });
                                            return;
                                        }
                                        self.mutationStore.markMutationResult(mutationId);
                                        if (fetchPolicy !== 'no-cache') self.dataStore.markMutationResult({
                                            mutationId: mutationId,
                                            result: result,
                                            document: mutation,
                                            variables: variables,
                                            updateQueries: generateUpdateQueriesInfo(),
                                            update: updateWithProxyFn
                                        });
                                        storeResult = result;
                                    },
                                    error: function(err) {
                                        self.mutationStore.markMutationError(mutationId, err);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        self.setQuery(mutationId, function() {
                                            return {
                                                document: null
                                            };
                                        });
                                        reject(new $a5ce1825a60c4eb2$export$26a337512320b8c6({
                                            networkError: err
                                        }));
                                    },
                                    complete: function() {
                                        if (error) self.mutationStore.markMutationError(mutationId, error);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        if (error) {
                                            reject(error);
                                            return;
                                        }
                                        if (typeof refetchQueries === 'function') refetchQueries = refetchQueries(storeResult);
                                        var refetchQueryPromises = [];
                                        if ($a5ce1825a60c4eb2$var$isNonEmptyArray(refetchQueries)) refetchQueries.forEach(function(refetchQuery) {
                                            if (typeof refetchQuery === 'string') self.queries.forEach(function(_a) {
                                                var observableQuery = _a.observableQuery;
                                                if (observableQuery && observableQuery.queryName === refetchQuery) refetchQueryPromises.push(observableQuery.refetch());
                                            });
                                            else {
                                                var queryOptions = {
                                                    query: refetchQuery.query,
                                                    variables: refetchQuery.variables,
                                                    fetchPolicy: 'network-only'
                                                };
                                                if (refetchQuery.context) queryOptions.context = refetchQuery.context;
                                                refetchQueryPromises.push(self.query(queryOptions));
                                            }
                                        });
                                        Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function() {
                                            self.setQuery(mutationId, function() {
                                                return {
                                                    document: null
                                                };
                                            });
                                            if (errorPolicy === 'ignore' && storeResult && (0, $jFDfc.graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                            resolve(storeResult);
                                        });
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, fetchType, fetchMoreForQueryId) {
        return (0, $dnskZ.__awaiter)(this, void 0, void 0, function() {
            var _a, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result, shouldFetch, requestId, cancel, networkResult;
            var _this = this;
            return (0, $dnskZ.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = options.metadata, metadata = _a === void 0 ? null : _a, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? 'cache-first' : _b, _c = options.context, context = _c === void 0 ? {} : _c;
                        query = this.transform(options.query).document;
                        variables = this.getVariables(query, options.variables);
                        if (!this.transform(query).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(query, variables, context)
                        ];
                    case 1:
                        variables = _e.sent();
                        _e.label = 2;
                    case 2:
                        options = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options), {
                            variables: variables
                        });
                        isNetworkOnly = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
                        needToFetch = isNetworkOnly;
                        if (!isNetworkOnly) {
                            _d = this.dataStore.getCache().diff({
                                query: query,
                                variables: variables,
                                returnPartialData: true,
                                optimistic: false
                            }), complete = _d.complete, result = _d.result;
                            needToFetch = !complete || fetchPolicy === 'cache-and-network';
                            storeResult = result;
                        }
                        shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
                        if ((0, $jFDfc.hasDirectives)([
                            'live'
                        ], query)) shouldFetch = true;
                        requestId = this.idCounter++;
                        cancel = fetchPolicy !== 'no-cache' ? this.updateQueryWatch(queryId, query, options) : undefined;
                        this.setQuery(queryId, function() {
                            return {
                                document: query,
                                lastRequestId: requestId,
                                invalidated: true,
                                cancel: cancel
                            };
                        });
                        this.invalidate(fetchMoreForQueryId);
                        this.queryStore.initQuery({
                            queryId: queryId,
                            document: query,
                            storePreviousVariables: shouldFetch,
                            variables: variables,
                            isPoll: fetchType === $a5ce1825a60c4eb2$export$160bafb6ac1e0641.poll,
                            isRefetch: fetchType === $a5ce1825a60c4eb2$export$160bafb6ac1e0641.refetch,
                            metadata: metadata,
                            fetchMoreForQueryId: fetchMoreForQueryId
                        });
                        this.broadcastQueries();
                        if (shouldFetch) {
                            networkResult = this.fetchRequest({
                                requestId: requestId,
                                queryId: queryId,
                                document: query,
                                options: options,
                                fetchMoreForQueryId: fetchMoreForQueryId
                            }).catch(function(error) {
                                if ($a5ce1825a60c4eb2$export$17f5e6bd290bb15d(error)) throw error;
                                else {
                                    if (requestId >= _this.getQuery(queryId).lastRequestId) {
                                        _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                                        _this.invalidate(queryId);
                                        _this.invalidate(fetchMoreForQueryId);
                                        _this.broadcastQueries();
                                    }
                                    throw new $a5ce1825a60c4eb2$export$26a337512320b8c6({
                                        networkError: error
                                    });
                                }
                            });
                            if (fetchPolicy !== 'cache-and-network') return [
                                2,
                                networkResult
                            ];
                            networkResult.catch(function() {});
                        }
                        this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                        this.invalidate(queryId);
                        this.invalidate(fetchMoreForQueryId);
                        if (this.transform(query).hasForcedResolvers) return [
                            2,
                            this.localState.runResolvers({
                                document: query,
                                remoteResult: {
                                    data: storeResult
                                },
                                context: context,
                                variables: variables,
                                onlyRunForcedResolvers: true
                            }).then(function(result) {
                                _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                                _this.broadcastQueries();
                                return result;
                            })
                        ];
                        this.broadcastQueries();
                        return [
                            2,
                            {
                                data: storeResult
                            }
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markQueryResult = function(queryId, result, _a, fetchMoreForQueryId) {
        var fetchPolicy = _a.fetchPolicy, variables = _a.variables, errorPolicy = _a.errorPolicy;
        if (fetchPolicy === 'no-cache') this.setQuery(queryId, function() {
            return {
                newData: {
                    result: result.data,
                    complete: true
                }
            };
        });
        else this.dataStore.markQueryResult(result, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
    };
    QueryManager.prototype.queryListenerForObserver = function(queryId, options, observer) {
        var _this = this;
        function invoke(method, argument) {
            if (observer[method]) try {
                observer[method](argument);
            } catch (e) {}
            else method;
        }
        return function(queryStoreValue, newData) {
            _this.invalidate(queryId, false);
            if (!queryStoreValue) return;
            var _a = _this.getQuery(queryId), observableQuery = _a.observableQuery, document = _a.document;
            var fetchPolicy = observableQuery ? observableQuery.options.fetchPolicy : options.fetchPolicy;
            if (fetchPolicy === 'standby') return;
            var loading = $a5ce1825a60c4eb2$var$isNetworkRequestInFlight(queryStoreValue.networkStatus);
            var lastResult = observableQuery && observableQuery.getLastResult();
            var networkStatusChanged = !!(lastResult && lastResult.networkStatus !== queryStoreValue.networkStatus);
            var shouldNotifyIfLoading = options.returnPartialData || !newData && queryStoreValue.previousVariables || networkStatusChanged && options.notifyOnNetworkStatusChange || fetchPolicy === 'cache-only' || fetchPolicy === 'cache-and-network';
            if (loading && !shouldNotifyIfLoading) return;
            var hasGraphQLErrors = $a5ce1825a60c4eb2$var$isNonEmptyArray(queryStoreValue.graphQLErrors);
            var errorPolicy = observableQuery && observableQuery.options.errorPolicy || options.errorPolicy || 'none';
            if (errorPolicy === 'none' && hasGraphQLErrors || queryStoreValue.networkError) return invoke('error', new $a5ce1825a60c4eb2$export$26a337512320b8c6({
                graphQLErrors: queryStoreValue.graphQLErrors,
                networkError: queryStoreValue.networkError
            }));
            try {
                var data = void 0;
                var isMissing = void 0;
                if (newData) {
                    if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') _this.setQuery(queryId, function() {
                        return {
                            newData: null
                        };
                    });
                    data = newData.result;
                    isMissing = !newData.complete;
                } else {
                    var lastError = observableQuery && observableQuery.getLastError();
                    var errorStatusChanged = errorPolicy !== 'none' && (lastError && lastError.graphQLErrors) !== queryStoreValue.graphQLErrors;
                    if (lastResult && lastResult.data && !errorStatusChanged) {
                        data = lastResult.data;
                        isMissing = false;
                    } else {
                        var diffResult = _this.dataStore.getCache().diff({
                            query: document,
                            variables: queryStoreValue.previousVariables || queryStoreValue.variables,
                            returnPartialData: true,
                            optimistic: true
                        });
                        data = diffResult.result;
                        isMissing = !diffResult.complete;
                    }
                }
                var stale = isMissing && !(options.returnPartialData || fetchPolicy === 'cache-only');
                var resultFromStore = {
                    data: stale ? lastResult && lastResult.data : data,
                    loading: loading,
                    networkStatus: queryStoreValue.networkStatus,
                    stale: stale
                };
                if (errorPolicy === 'all' && hasGraphQLErrors) resultFromStore.errors = queryStoreValue.graphQLErrors;
                invoke('next', resultFromStore);
            } catch (networkError) {
                invoke('error', new $a5ce1825a60c4eb2$export$26a337512320b8c6({
                    networkError: networkError
                }));
            }
        };
    };
    QueryManager.prototype.transform = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cache = this.dataStore.getCache();
            var transformed = cache.transformDocument(document);
            var forLink = (0, $jFDfc.removeConnectionDirectiveFromDocument)(cache.transformForLink(transformed));
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = this.localState.serverQuery(forLink);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: (0, $jFDfc.hasClientExports)(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: (0, $jFDfc.getDefaultValues)((0, $jFDfc.getOperationDefinition)(transformed))
            };
            var add = function(doc) {
                if (doc && !transformCache.has(doc)) transformCache.set(doc, cacheEntry_1);
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options, shouldSubscribe) {
        if (shouldSubscribe === void 0) shouldSubscribe = true;
        (0, $lDEi6.invariant)(options.fetchPolicy !== 'standby', 11);
        options.variables = this.getVariables(options.query, options.variables);
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') options.notifyOnNetworkStatusChange = false;
        var transformedOptions = (0, $dnskZ.__assign)({}, options);
        return new $a5ce1825a60c4eb2$export$6c1b56eac59c9584({
            queryManager: this,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe
        });
    };
    QueryManager.prototype.query = function(options) {
        var _this = this;
        (0, $lDEi6.invariant)(options.query, 12);
        (0, $lDEi6.invariant)(options.query.kind === 'Document', 13);
        (0, $lDEi6.invariant)(!options.returnPartialData, 14);
        (0, $lDEi6.invariant)(!options.pollInterval, 15);
        return new Promise(function(resolve, reject) {
            var watchedQuery = _this.watchQuery(options, false);
            _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
            watchedQuery.result().then(resolve, reject).then(function() {
                return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
            });
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.idCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        this.stopPollingQuery(queryId);
        this.queryStore.stopQuery(queryId);
        this.invalidate(queryId);
    };
    QueryManager.prototype.addQueryListener = function(queryId, listener) {
        this.setQuery(queryId, function(_a) {
            var listeners = _a.listeners;
            listeners.add(listener);
            return {
                invalidated: false
            };
        });
    };
    QueryManager.prototype.updateQueryWatch = function(queryId, document, options) {
        var _this = this;
        var cancel = this.getQuery(queryId).cancel;
        if (cancel) cancel();
        var previousResult = function() {
            var previousResult = null;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            if (observableQuery) {
                var lastResult = observableQuery.getLastResult();
                if (lastResult) previousResult = lastResult.data;
            }
            return previousResult;
        };
        return this.dataStore.getCache().watch({
            query: document,
            variables: options.variables,
            optimistic: true,
            previousResult: previousResult,
            callback: function(newData) {
                _this.setQuery(queryId, function() {
                    return {
                        invalidated: true,
                        newData: newData
                    };
                });
            }
        });
    };
    QueryManager.prototype.addObservableQuery = function(queryId, observableQuery) {
        this.setQuery(queryId, function() {
            return {
                observableQuery: observableQuery
            };
        });
    };
    QueryManager.prototype.removeObservableQuery = function(queryId) {
        var cancel = this.getQuery(queryId).cancel;
        this.setQuery(queryId, function() {
            return {
                observableQuery: null
            };
        });
        if (cancel) cancel();
    };
    QueryManager.prototype.clearStore = function() {
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $lDEi6.InvariantError)(16));
        });
        var resetIds = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) resetIds.push(queryId);
        });
        this.queryStore.reset(resetIds);
        this.mutationStore.reset();
        return this.dataStore.reset();
    };
    QueryManager.prototype.resetStore = function() {
        var _this = this;
        return this.clearStore().then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) {
                var fetchPolicy = observableQuery.options.fetchPolicy;
                observableQuery.resetLastResults();
                if (fetchPolicy !== 'cache-only' && (includeStandby || fetchPolicy !== 'standby')) observableQueryPromises.push(observableQuery.refetch());
                _this.setQuery(queryId, function() {
                    return {
                        newData: null
                    };
                });
                _this.invalidate(queryId);
            }
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.observeQuery = function(queryId, options, observer) {
        this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
        return this.fetchQuery(queryId, options);
    };
    QueryManager.prototype.startQuery = function(queryId, options, listener) {
        this.addQueryListener(queryId, listener);
        this.fetchQuery(queryId, options).catch(function() {
            return undefined;
        });
        return queryId;
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, variables = _a.variables;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, {}, variables, false).map(function(result) {
                if (!fetchPolicy || fetchPolicy !== 'no-cache') {
                    _this.dataStore.markSubscriptionResult(result, query, variables);
                    _this.broadcastQueries();
                }
                if ((0, $jFDfc.graphQLResultHasError)(result)) throw new $a5ce1825a60c4eb2$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                });
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
            return new $a5ce1825a60c4eb2$var$Observable(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        this.fetchQueryRejectFns.delete("query:" + queryId);
        this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
        this.getQuery(queryId).subscriptions.forEach(function(x) {
            return x.unsubscribe();
        });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.getCurrentQueryResult = function(observableQuery, optimistic) {
        if (optimistic === void 0) optimistic = true;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query, fetchPolicy = _a.fetchPolicy, returnPartialData = _a.returnPartialData;
        var lastResult = observableQuery.getLastResult();
        var newData = this.getQuery(observableQuery.queryId).newData;
        if (newData && newData.complete) return {
            data: newData.result,
            partial: false
        };
        if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') return {
            data: undefined,
            partial: false
        };
        var _b = this.dataStore.getCache().diff({
            query: query,
            variables: variables,
            previousResult: lastResult ? lastResult.data : undefined,
            returnPartialData: true,
            optimistic: optimistic
        }), result = _b.result, complete = _b.complete;
        return {
            data: complete || returnPartialData ? result : void 0,
            partial: !complete
        };
    };
    QueryManager.prototype.getQueryWithPreviousResult = function(queryIdOrObservable) {
        var observableQuery;
        if (typeof queryIdOrObservable === 'string') {
            var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
            (0, $lDEi6.invariant)(foundObserveableQuery, 17);
            observableQuery = foundObserveableQuery;
        } else observableQuery = queryIdOrObservable;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        return {
            previousResult: this.getCurrentQueryResult(observableQuery, false).data,
            variables: variables,
            document: query
        };
    };
    QueryManager.prototype.broadcastQueries = function() {
        var _this = this;
        this.onBroadcast();
        this.queries.forEach(function(info, id) {
            if (info.invalidated) info.listeners.forEach(function(listener) {
                if (listener) listener(_this.queryStore.get(id), info.newData);
            });
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
        var _this = this;
        if (deduplication === void 0) deduplication = this.queryDeduplication;
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _a = this, inFlightLinkObservables_1 = _a.inFlightLinkObservables, link = _a.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $jFDfc.getOperationName)(serverQuery) || void 0,
                context: this.prepareContext((0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = JSON.stringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    byVariables_1.set(varJson_1, observable = $a5ce1825a60c4eb2$var$multiplex((0, $7oe8F.execute)(link, operation)));
                    var cleanup = function() {
                        byVariables_1.delete(varJson_1);
                        if (!byVariables_1.size) inFlightLinkObservables_1.delete(serverQuery);
                        cleanupSub_1.unsubscribe();
                    };
                    var cleanupSub_1 = observable.subscribe({
                        next: cleanup,
                        error: cleanup,
                        complete: cleanup
                    });
                }
            } else observable = $a5ce1825a60c4eb2$var$multiplex((0, $7oe8F.execute)(link, operation));
        } else {
            observable = $a5ce1825a60c4eb2$var$Observable.of({
                data: {}
            });
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) observable = $a5ce1825a60c4eb2$var$asyncMap(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.fetchRequest = function(_a) {
        var _this = this;
        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
        var variables = options.variables, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
        var resultFromStore;
        var errorsFromStore;
        return new Promise(function(resolve, reject) {
            var observable = _this.getObservableFromLink(document, options.context, variables);
            var fqrfId = "fetchRequest:" + queryId;
            _this.fetchQueryRejectFns.set(fqrfId, reject);
            var cleanup = function() {
                _this.fetchQueryRejectFns.delete(fqrfId);
                _this.setQuery(queryId, function(_a) {
                    var subscriptions = _a.subscriptions;
                    subscriptions.delete(subscription);
                });
            };
            var subscription = observable.map(function(result) {
                if (requestId >= _this.getQuery(queryId).lastRequestId) {
                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                    _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                    _this.invalidate(queryId);
                    _this.invalidate(fetchMoreForQueryId);
                    _this.broadcastQueries();
                }
                if (errorPolicy === 'none' && $a5ce1825a60c4eb2$var$isNonEmptyArray(result.errors)) return reject(new $a5ce1825a60c4eb2$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                }));
                if (errorPolicy === 'all') errorsFromStore = result.errors;
                if (fetchMoreForQueryId || fetchPolicy === 'no-cache') resultFromStore = result.data;
                else {
                    var _a = _this.dataStore.getCache().diff({
                        variables: variables,
                        query: document,
                        optimistic: false,
                        returnPartialData: true
                    }), result_1 = _a.result, complete = _a.complete;
                    if (complete || options.returnPartialData) resultFromStore = result_1;
                }
            }).subscribe({
                error: function(error) {
                    cleanup();
                    reject(error);
                },
                complete: function() {
                    cleanup();
                    resolve({
                        data: resultFromStore,
                        errors: errorsFromStore,
                        loading: false,
                        networkStatus: $a5ce1825a60c4eb2$export$bd096ddbd246c79c.ready,
                        stale: false
                    });
                }
            });
            _this.setQuery(queryId, function(_a) {
                var subscriptions = _a.subscriptions;
                subscriptions.add(subscription);
            });
        });
    };
    QueryManager.prototype.getQuery = function(queryId) {
        return this.queries.get(queryId) || {
            listeners: new Set(),
            invalidated: false,
            document: null,
            newData: null,
            lastRequestId: 1,
            observableQuery: null,
            subscriptions: new Set()
        };
    };
    QueryManager.prototype.setQuery = function(queryId, updater) {
        var prev = this.getQuery(queryId);
        var newInfo = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, prev), updater(prev));
        this.queries.set(queryId, newInfo);
    };
    QueryManager.prototype.invalidate = function(queryId, invalidated) {
        if (invalidated === void 0) invalidated = true;
        if (queryId) this.setQuery(queryId, function() {
            return {
                invalidated: invalidated
            };
        });
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    QueryManager.prototype.checkInFlight = function(queryId) {
        var query = this.queryStore.get(queryId);
        return query && query.networkStatus !== $a5ce1825a60c4eb2$export$bd096ddbd246c79c.ready && query.networkStatus !== $a5ce1825a60c4eb2$export$bd096ddbd246c79c.error;
    };
    QueryManager.prototype.startPollingQuery = function(options, queryId, listener) {
        var _this = this;
        var pollInterval = options.pollInterval;
        (0, $lDEi6.invariant)(pollInterval, 18);
        if (!this.ssrMode) {
            var info = this.pollingInfoByQueryId.get(queryId);
            if (!info) this.pollingInfoByQueryId.set(queryId, info = {});
            info.interval = pollInterval;
            info.options = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options), {
                fetchPolicy: 'network-only'
            });
            var maybeFetch_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    if (_this.checkInFlight(queryId)) poll_1();
                    else _this.fetchQuery(queryId, info.options, $a5ce1825a60c4eb2$export$160bafb6ac1e0641.poll).then(poll_1, poll_1);
                }
            };
            var poll_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    clearTimeout(info.timeout);
                    info.timeout = setTimeout(maybeFetch_1, info.interval);
                }
            };
            if (listener) this.addQueryListener(queryId, listener);
            poll_1();
        }
        return queryId;
    };
    QueryManager.prototype.stopPollingQuery = function(queryId) {
        this.pollingInfoByQueryId.delete(queryId);
    };
    return QueryManager;
}();
var $a5ce1825a60c4eb2$var$DataStore = function() {
    function DataStore(initialCache) {
        this.cache = initialCache;
    }
    DataStore.prototype.getCache = function() {
        return this.cache;
    };
    DataStore.prototype.markQueryResult = function(result, document, variables, fetchMoreForQueryId, ignoreErrors) {
        if (ignoreErrors === void 0) ignoreErrors = false;
        var writeWithErrors = !(0, $jFDfc.graphQLResultHasError)(result);
        if (ignoreErrors && (0, $jFDfc.graphQLResultHasError)(result) && result.data) writeWithErrors = true;
        if (!fetchMoreForQueryId && writeWithErrors) this.cache.write({
            result: result.data,
            dataId: 'ROOT_QUERY',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markSubscriptionResult = function(result, document, variables) {
        if (!(0, $jFDfc.graphQLResultHasError)(result)) this.cache.write({
            result: result.data,
            dataId: 'ROOT_SUBSCRIPTION',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markMutationInit = function(mutation) {
        var _this = this;
        if (mutation.optimisticResponse) {
            var optimistic_1;
            if (typeof mutation.optimisticResponse === 'function') optimistic_1 = mutation.optimisticResponse(mutation.variables);
            else optimistic_1 = mutation.optimisticResponse;
            this.cache.recordOptimisticTransaction(function(c) {
                var orig = _this.cache;
                _this.cache = c;
                try {
                    _this.markMutationResult({
                        mutationId: mutation.mutationId,
                        result: {
                            data: optimistic_1
                        },
                        document: mutation.document,
                        variables: mutation.variables,
                        updateQueries: mutation.updateQueries,
                        update: mutation.update
                    });
                } finally{
                    _this.cache = orig;
                }
            }, mutation.mutationId);
        }
    };
    DataStore.prototype.markMutationResult = function(mutation) {
        var _this = this;
        if (!(0, $jFDfc.graphQLResultHasError)(mutation.result)) {
            var cacheWrites_1 = [
                {
                    result: mutation.result.data,
                    dataId: 'ROOT_MUTATION',
                    query: mutation.document,
                    variables: mutation.variables
                }
            ];
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) Object.keys(updateQueries_1).forEach(function(id) {
                var _a = updateQueries_1[id], query = _a.query, updater = _a.updater;
                var _b = _this.cache.diff({
                    query: query.document,
                    variables: query.variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _b.result, complete = _b.complete;
                if (complete) {
                    var nextQueryResult = (0, $jFDfc.tryFunctionOrLogError)(function() {
                        return updater(currentQueryResult, {
                            mutationResult: mutation.result,
                            queryName: (0, $jFDfc.getOperationName)(query.document) || undefined,
                            queryVariables: query.variables
                        });
                    });
                    if (nextQueryResult) cacheWrites_1.push({
                        result: nextQueryResult,
                        dataId: 'ROOT_QUERY',
                        query: query.document,
                        variables: query.variables
                    });
                }
            });
            this.cache.performTransaction(function(c) {
                cacheWrites_1.forEach(function(write) {
                    return c.write(write);
                });
                var update = mutation.update;
                if (update) (0, $jFDfc.tryFunctionOrLogError)(function() {
                    return update(c, mutation.result);
                });
            });
        }
    };
    DataStore.prototype.markMutationComplete = function(_a) {
        var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
        if (optimisticResponse) this.cache.removeOptimistic(mutationId);
    };
    DataStore.prototype.markUpdateQueryResult = function(document, variables, newResult) {
        this.cache.write({
            result: newResult,
            dataId: 'ROOT_QUERY',
            variables: variables,
            query: document
        });
    };
    DataStore.prototype.reset = function() {
        return this.cache.reset();
    };
    return DataStore;
}();
var $a5ce1825a60c4eb2$var$version = "2.6.10";
var $a5ce1825a60c4eb2$var$hasSuggestedDevtools = false;
var $a5ce1825a60c4eb2$export$13f5a5f0f1dbab88 = function() {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link && resolvers) link = (0, $7oe8F.ApolloLink).empty();
        if (!link || !cache) throw new (0, $lDEi6.InvariantError)(4);
        this.link = link;
        this.cache = cache;
        this.store = new $a5ce1825a60c4eb2$var$DataStore(cache);
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || {};
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        var defaultConnectToDevTools = false;
        if (typeof connectToDevTools === 'undefined' ? defaultConnectToDevTools : connectToDevTools && typeof window !== 'undefined') window.__APOLLO_CLIENT__ = this;
        this.version = $a5ce1825a60c4eb2$var$version;
        this.localState = new $a5ce1825a60c4eb2$var$LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new $a5ce1825a60c4eb2$var$QueryManager({
            link: this.link,
            store: this.store,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.queryStore.getStore(),
                        mutations: _this.queryManager.mutationStore.getStore()
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            }
        });
    }
    ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.defaultOptions.watchQuery), options);
        if (this.disableNetworkFetches && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.defaultOptions.query), options);
        (0, $lDEi6.invariant)(options.fetchPolicy !== 'cache-and-network', 5);
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') options = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.defaultOptions.mutate), options);
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function(options) {
        var result = this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeFragment = function(options) {
        var result = this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeData = function(options) {
        var result = this.cache.writeData(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $7oe8F.execute)(this.link, payload);
    };
    ApolloClient.prototype.initQueryManager = function() {
        return this.queryManager;
    };
    ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    return ApolloClient;
}();
var $a5ce1825a60c4eb2$export$2e2bcd8739ae039 = $a5ce1825a60c4eb2$export$13f5a5f0f1dbab88;

});
parcelRegister("jFDfc", function(module, exports) {
$parcel$export(module.exports, "storeKeyNameFromField", () => $e52049bf830e5717$export$54be8689c65f3b56);
$parcel$export(module.exports, "getStoreKeyName", () => $e52049bf830e5717$export$3cdb6c178b88cabe);
$parcel$export(module.exports, "argumentsObjectFromField", () => $e52049bf830e5717$export$3f5a60fb6a781b4f);
$parcel$export(module.exports, "resultKeyNameFromField", () => $e52049bf830e5717$export$7d1ad22471852218);
$parcel$export(module.exports, "isField", () => $e52049bf830e5717$export$fb56ad75dd311c12);
$parcel$export(module.exports, "isInlineFragment", () => $e52049bf830e5717$export$22a1cdafaf27bcff);
$parcel$export(module.exports, "isIdValue", () => $e52049bf830e5717$export$e33b89a9aa87695);
$parcel$export(module.exports, "toIdValue", () => $e52049bf830e5717$export$b124f125e34d720a);
$parcel$export(module.exports, "isJsonValue", () => $e52049bf830e5717$export$226c1c6d1a5b660a);
$parcel$export(module.exports, "getDirectiveInfoFromField", () => $e52049bf830e5717$export$2a7f471142984a91);
$parcel$export(module.exports, "shouldInclude", () => $e52049bf830e5717$export$3dc388a5f013b4a5);
$parcel$export(module.exports, "hasDirectives", () => $e52049bf830e5717$export$2dafb573e282fe8d);
$parcel$export(module.exports, "hasClientExports", () => $e52049bf830e5717$export$8d1e9e5bbfa5d09a);
$parcel$export(module.exports, "getFragmentQueryDocument", () => $e52049bf830e5717$export$abbf37c7cf644e41);
$parcel$export(module.exports, "assign", () => $e52049bf830e5717$export$e6e34fd1f2686227);
$parcel$export(module.exports, "checkDocument", () => $e52049bf830e5717$export$a7d0d8111d2386df);
$parcel$export(module.exports, "getOperationDefinition", () => $e52049bf830e5717$export$7a5b1fa979d2c158);
$parcel$export(module.exports, "getOperationName", () => $e52049bf830e5717$export$41bca9dc6871dd4e);
$parcel$export(module.exports, "getFragmentDefinitions", () => $e52049bf830e5717$export$5320a7ba9466a3df);
$parcel$export(module.exports, "getQueryDefinition", () => $e52049bf830e5717$export$d96b2213c1b9d3a9);
$parcel$export(module.exports, "getMainDefinition", () => $e52049bf830e5717$export$f431198736b7f96d);
$parcel$export(module.exports, "createFragmentMap", () => $e52049bf830e5717$export$193789b4c8246dd4);
$parcel$export(module.exports, "getDefaultValues", () => $e52049bf830e5717$export$84c19026e616569e);
$parcel$export(module.exports, "removeDirectivesFromDocument", () => $e52049bf830e5717$export$e5ae0530da5fe96c);
$parcel$export(module.exports, "addTypenameToDocument", () => $e52049bf830e5717$export$43b332f87950a467);
$parcel$export(module.exports, "removeConnectionDirectiveFromDocument", () => $e52049bf830e5717$export$74985f3324559867);
$parcel$export(module.exports, "buildQueryFromSelectionSet", () => $e52049bf830e5717$export$57c368c23873f32b);
$parcel$export(module.exports, "removeClientSetsFromDocument", () => $e52049bf830e5717$export$8eae69e876ee321e);
$parcel$export(module.exports, "canUseWeakMap", () => $e52049bf830e5717$export$772fbc04a0ad4ce9);
$parcel$export(module.exports, "cloneDeep", () => $e52049bf830e5717$export$629a2bd3f5a49ecc);
$parcel$export(module.exports, "isProduction", () => $e52049bf830e5717$export$f15d00aa73aafac4);
$parcel$export(module.exports, "isTest", () => $e52049bf830e5717$export$410cbc2864fa25b5);
$parcel$export(module.exports, "tryFunctionOrLogError", () => $e52049bf830e5717$export$50a91acae4904909);
$parcel$export(module.exports, "graphQLResultHasError", () => $e52049bf830e5717$export$b4df399e879e53ab);
$parcel$export(module.exports, "mergeDeep", () => $e52049bf830e5717$export$dd702b3c8240390c);
$parcel$export(module.exports, "mergeDeepArray", () => $e52049bf830e5717$export$160070228be94b08);

var $9E3xk = parcelRequire("9E3xk");

var $lDEi6 = parcelRequire("lDEi6");

var $dnskZ = parcelRequire("dnskZ");

var $5OKCR = parcelRequire("5OKCR");

var $hR4hP = parcelRequire("hR4hP");

var $igDjg = parcelRequire("igDjg");
function $e52049bf830e5717$export$dc071f102752d0eb(value) {
    return [
        'StringValue',
        'BooleanValue',
        'EnumValue'
    ].indexOf(value.kind) > -1;
}
function $e52049bf830e5717$export$3ff5e9927c3257c6(value) {
    return [
        'IntValue',
        'FloatValue'
    ].indexOf(value.kind) > -1;
}
function $e52049bf830e5717$var$isStringValue(value) {
    return value.kind === 'StringValue';
}
function $e52049bf830e5717$var$isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function $e52049bf830e5717$var$isIntValue(value) {
    return value.kind === 'IntValue';
}
function $e52049bf830e5717$var$isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function $e52049bf830e5717$var$isVariable(value) {
    return value.kind === 'Variable';
}
function $e52049bf830e5717$var$isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function $e52049bf830e5717$var$isListValue(value) {
    return value.kind === 'ListValue';
}
function $e52049bf830e5717$var$isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function $e52049bf830e5717$var$isNullValue(value) {
    return value.kind === 'NullValue';
}
function $e52049bf830e5717$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($e52049bf830e5717$var$isIntValue(value) || $e52049bf830e5717$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($e52049bf830e5717$var$isBooleanValue(value) || $e52049bf830e5717$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($e52049bf830e5717$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $e52049bf830e5717$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($e52049bf830e5717$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($e52049bf830e5717$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $e52049bf830e5717$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($e52049bf830e5717$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($e52049bf830e5717$var$isNullValue(value)) argObj[name.value] = null;
    else throw new (0, $lDEi6.InvariantError)(17);
}
function $e52049bf830e5717$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $e52049bf830e5717$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $e52049bf830e5717$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $e52049bf830e5717$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $e52049bf830e5717$var$KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export'
];
function $e52049bf830e5717$export$3cdb6c178b88cabe(fieldName, args, directives) {
    if (directives && directives['connection'] && directives['connection']['key']) {
        if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        } else return directives['connection']['key'];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = (0, (/*@__PURE__*/$parcel$interopDefault($5OKCR)))(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($e52049bf830e5717$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
        else completeFieldName += "@" + key;
    });
    return completeFieldName;
}
function $e52049bf830e5717$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $e52049bf830e5717$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $e52049bf830e5717$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $e52049bf830e5717$export$fb56ad75dd311c12(selection) {
    return selection.kind === 'Field';
}
function $e52049bf830e5717$export$22a1cdafaf27bcff(selection) {
    return selection.kind === 'InlineFragment';
}
function $e52049bf830e5717$export$e33b89a9aa87695(idObject) {
    return idObject && idObject.type === 'id' && typeof idObject.generated === 'boolean';
}
function $e52049bf830e5717$export$b124f125e34d720a(idConfig, generated) {
    if (generated === void 0) generated = false;
    return (0, $dnskZ.__assign)({
        type: 'id',
        generated: generated
    }, typeof idConfig === 'string' ? {
        id: idConfig,
        typename: undefined
    } : idConfig);
}
function $e52049bf830e5717$export$226c1c6d1a5b660a(jsonObject) {
    return jsonObject != null && typeof jsonObject === 'object' && jsonObject.type === 'json';
}
function $e52049bf830e5717$var$defaultValueFromVariable(node) {
    throw new (0, $lDEi6.InvariantError)(18);
}
function $e52049bf830e5717$export$b3db129ed867b445(node, onVariable) {
    if (onVariable === void 0) onVariable = $e52049bf830e5717$var$defaultValueFromVariable;
    switch(node.kind){
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value, 10);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function(v) {
                return $e52049bf830e5717$export$b3db129ed867b445(v, onVariable);
            });
        case 'ObjectValue':
            var value = {};
            for(var _i = 0, _a = node.fields; _i < _a.length; _i++){
                var field = _a[_i];
                value[field.name.value] = $e52049bf830e5717$export$b3db129ed867b445(field.value, onVariable);
            }
            return value;
        default:
            return node.value;
    }
}
function $e52049bf830e5717$export$2a7f471142984a91(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function(directive) {
            directiveObj_1[directive.name.value] = $e52049bf830e5717$export$3f5a60fb6a781b4f(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function $e52049bf830e5717$export$3dc388a5f013b4a5(selection, variables) {
    if (variables === void 0) variables = {};
    return $e52049bf830e5717$export$b7bdffb7e6f1ef53(selection.directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables[ifArgument.value.name.value];
            (0, $lDEi6.invariant)(evaledValue !== void 0, 13);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function $e52049bf830e5717$export$1b217de6ce18b9a(doc) {
    var names = [];
    (0, $9E3xk.visit)(doc, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
function $e52049bf830e5717$export$2dafb573e282fe8d(names, doc) {
    return $e52049bf830e5717$export$1b217de6ce18b9a(doc).some(function(name) {
        return names.indexOf(name) > -1;
    });
}
function $e52049bf830e5717$export$8d1e9e5bbfa5d09a(document) {
    return document && $e52049bf830e5717$export$2dafb573e282fe8d([
        'client'
    ], document) && $e52049bf830e5717$export$2dafb573e282fe8d([
        'export'
    ], document);
}
function $e52049bf830e5717$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function $e52049bf830e5717$export$b7bdffb7e6f1ef53(directives) {
    return directives ? directives.filter($e52049bf830e5717$var$isInclusionDirective).map(function(directive) {
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $lDEi6.invariant)(directiveArguments && directiveArguments.length === 1, 14);
        var ifArgument = directiveArguments[0];
        (0, $lDEi6.invariant)(ifArgument.name && ifArgument.name.value === 'if', 15);
        var ifValue = ifArgument.value;
        (0, $lDEi6.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16);
        return {
            directive: directive,
            ifArgument: ifArgument
        };
    }) : [];
}
function $e52049bf830e5717$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === 'OperationDefinition') throw new (0, $lDEi6.InvariantError)(11);
        if (definition.kind === 'FragmentDefinition') fragments.push(definition);
    });
    if (typeof actualFragmentName === 'undefined') {
        (0, $lDEi6.invariant)(fragments.length === 1, 12);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, document), {
        definitions: (0, $dnskZ.__spreadArrays)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions)
    });
    return query;
}
function $e52049bf830e5717$export$e6e34fd1f2686227(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    sources.forEach(function(source) {
        if (typeof source === 'undefined' || source === null) return;
        Object.keys(source).forEach(function(key) {
            target[key] = source[key];
        });
    });
    return target;
}
function $e52049bf830e5717$export$a92e7a440b22bdf0(doc) {
    $e52049bf830e5717$export$a7d0d8111d2386df(doc);
    var mutationDef = doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.operation === 'mutation';
    })[0];
    (0, $lDEi6.invariant)(mutationDef, 1);
    return mutationDef;
}
function $e52049bf830e5717$export$a7d0d8111d2386df(doc) {
    (0, $lDEi6.invariant)(doc && doc.kind === 'Document', 2);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== 'FragmentDefinition';
    }).map(function(definition) {
        if (definition.kind !== 'OperationDefinition') throw new (0, $lDEi6.InvariantError)(3);
        return definition;
    });
    (0, $lDEi6.invariant)(operations.length <= 1, 4);
    return doc;
}
function $e52049bf830e5717$export$7a5b1fa979d2c158(doc) {
    $e52049bf830e5717$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition';
    })[0];
}
function $e52049bf830e5717$export$78a8e95d8d43ad7f(document) {
    var def = $e52049bf830e5717$export$7a5b1fa979d2c158(document);
    (0, $lDEi6.invariant)(def, 5);
    return def;
}
function $e52049bf830e5717$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $e52049bf830e5717$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'FragmentDefinition';
    });
}
function $e52049bf830e5717$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $e52049bf830e5717$export$7a5b1fa979d2c158(doc);
    (0, $lDEi6.invariant)(queryDef && queryDef.operation === 'query', 6);
    return queryDef;
}
function $e52049bf830e5717$export$772111caef41b3f5(doc) {
    (0, $lDEi6.invariant)(doc.kind === 'Document', 7);
    (0, $lDEi6.invariant)(doc.definitions.length <= 1, 8);
    var fragmentDef = doc.definitions[0];
    (0, $lDEi6.invariant)(fragmentDef.kind === 'FragmentDefinition', 9);
    return fragmentDef;
}
function $e52049bf830e5717$export$f431198736b7f96d(queryDoc) {
    $e52049bf830e5717$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' || operation === 'mutation' || operation === 'subscription') return definition;
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw new (0, $lDEi6.InvariantError)(10);
}
function $e52049bf830e5717$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $e52049bf830e5717$export$84c19026e616569e(definition) {
    if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions.filter(function(_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        }).map(function(_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            $e52049bf830e5717$export$a1dab82d368d6525(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return $e52049bf830e5717$export$e6e34fd1f2686227.apply(void 0, (0, $dnskZ.__spreadArrays)([
            {}
        ], defaultValues));
    }
    return {};
}
function $e52049bf830e5717$export$55ead6c9e4eac970(operation) {
    var names = new Set();
    if (operation.variableDefinitions) for(var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++){
        var definition = _a[_i];
        names.add(definition.variable.name.value);
    }
    return names;
}
function $e52049bf830e5717$var$filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function(elem, i) {
        if (test.call(this, elem, i, array)) array[target++] = elem;
    }, context);
    array.length = target;
    return array;
}
var $e52049bf830e5717$var$TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename'
    }
};
function $e52049bf830e5717$var$isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function(selection) {
        return selection.kind === 'FragmentSpread' && $e52049bf830e5717$var$isEmpty(fragments[selection.name.value], fragments);
    });
}
function $e52049bf830e5717$var$nullIfDocIsEmpty(doc) {
    return $e52049bf830e5717$var$isEmpty($e52049bf830e5717$export$7a5b1fa979d2c158(doc) || $e52049bf830e5717$export$772111caef41b3f5(doc), $e52049bf830e5717$export$193789b4c8246dd4($e52049bf830e5717$export$5320a7ba9466a3df(doc))) ? null : doc;
}
function $e52049bf830e5717$var$getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function(dir) {
            return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
        });
    };
}
function $e52049bf830e5717$export$e5ae0530da5fe96c(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = $e52049bf830e5717$var$nullIfDocIsEmpty((0, $9E3xk.visit)(doc, {
        Variable: {
            enter: function(node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') variablesInUse[node.name.value] = true;
            }
        },
        Field: {
            enter: function(node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function(directive) {
                        return directive.remove;
                    });
                    if (shouldRemoveField && node.directives && node.directives.some($e52049bf830e5717$var$getDirectiveMatcher(directives))) {
                        if (node.arguments) node.arguments.forEach(function(arg) {
                            if (arg.value.kind === 'Variable') variablesToRemove.push({
                                name: arg.value.name.value
                            });
                        });
                        if (node.selectionSet) $e52049bf830e5717$var$getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                            fragmentSpreadsToRemove.push({
                                name: frag.name.value
                            });
                        });
                        return null;
                    }
                }
            }
        },
        FragmentSpread: {
            enter: function(node) {
                fragmentSpreadsInUse[node.name.value] = true;
            }
        },
        Directive: {
            enter: function(node) {
                if ($e52049bf830e5717$var$getDirectiveMatcher(directives)(node)) return null;
            }
        }
    }));
    if (modifiedDoc && $e52049bf830e5717$var$filterInPlace(variablesToRemove, function(v) {
        return !variablesInUse[v.name];
    }).length) modifiedDoc = $e52049bf830e5717$export$ecd5bb739c4a8b38(variablesToRemove, modifiedDoc);
    if (modifiedDoc && $e52049bf830e5717$var$filterInPlace(fragmentSpreadsToRemove, function(fs) {
        return !fragmentSpreadsInUse[fs.name];
    }).length) modifiedDoc = $e52049bf830e5717$export$7c9d17c333033c13(fragmentSpreadsToRemove, modifiedDoc);
    return modifiedDoc;
}
function $e52049bf830e5717$export$43b332f87950a467(doc) {
    return (0, $9E3xk.visit)($e52049bf830e5717$export$a7d0d8111d2386df(doc), {
        SelectionSet: {
            enter: function(node, _key, parent) {
                if (parent && parent.kind === 'OperationDefinition') return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return $e52049bf830e5717$export$fb56ad75dd311c12(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if ($e52049bf830e5717$export$fb56ad75dd311c12(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === 'export';
                })) return;
                return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, node), {
                    selections: (0, $dnskZ.__spreadArrays)(selections, [
                        $e52049bf830e5717$var$TYPENAME_FIELD
                    ])
                });
            }
        }
    });
}
var $e52049bf830e5717$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) !directive.arguments || directive.arguments.some(function(arg) {
            return arg.name.value === 'key';
        });
        return willRemove;
    }
};
function $e52049bf830e5717$export$74985f3324559867(doc) {
    return $e52049bf830e5717$export$e5ae0530da5fe96c([
        $e52049bf830e5717$var$connectionRemoveConfig
    ], $e52049bf830e5717$export$a7d0d8111d2386df(doc));
}
function $e52049bf830e5717$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $e52049bf830e5717$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $e52049bf830e5717$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!$e52049bf830e5717$export$fb56ad75dd311c12(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($e52049bf830e5717$var$getDirectiveMatcher(directives)) || nestedCheck && $e52049bf830e5717$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $e52049bf830e5717$export$deed3420cb5d2e1d(directives, doc) {
    $e52049bf830e5717$export$a7d0d8111d2386df(doc);
    var parentPath;
    return $e52049bf830e5717$var$nullIfDocIsEmpty((0, $9E3xk.visit)(doc, {
        SelectionSet: {
            enter: function(node, _key, _parent, path) {
                var currentPath = path.join('-');
                if (!parentPath || currentPath === parentPath || !currentPath.startsWith(parentPath)) {
                    if (node.selections) {
                        var selectionsWithDirectives = node.selections.filter(function(selection) {
                            return $e52049bf830e5717$var$hasDirectivesInSelection(directives, selection);
                        });
                        if ($e52049bf830e5717$var$hasDirectivesInSelectionSet(directives, node, false)) parentPath = currentPath;
                        return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, node), {
                            selections: selectionsWithDirectives
                        });
                    } else return null;
                }
            }
        }
    }));
}
function $e52049bf830e5717$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $e52049bf830e5717$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $e52049bf830e5717$var$getArgumentMatcher(config);
    return $e52049bf830e5717$var$nullIfDocIsEmpty((0, $9E3xk.visit)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, node), {
                    variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    })
                });
            }
        },
        Field: {
            enter: function(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $e52049bf830e5717$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $e52049bf830e5717$var$nullIfDocIsEmpty((0, $9E3xk.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $e52049bf830e5717$var$getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function(selection) {
        if (($e52049bf830e5717$export$fb56ad75dd311c12(selection) || $e52049bf830e5717$export$22a1cdafaf27bcff(selection)) && selection.selectionSet) $e52049bf830e5717$var$getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
            return allFragments.push(frag);
        });
        else if (selection.kind === 'FragmentSpread') allFragments.push(selection);
    });
    return allFragments;
}
function $e52049bf830e5717$export$57c368c23873f32b(document) {
    var definition = $e52049bf830e5717$export$f431198736b7f96d(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') return document;
    var modifiedDoc = (0, $9E3xk.visit)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, node), {
                    operation: 'query'
                });
            }
        }
    });
    return modifiedDoc;
}
function $e52049bf830e5717$export$8eae69e876ee321e(document) {
    $e52049bf830e5717$export$a7d0d8111d2386df(document);
    var modifiedDoc = $e52049bf830e5717$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === 'client';
            },
            remove: true
        }
    ], document);
    if (modifiedDoc) modifiedDoc = (0, $9E3xk.visit)(modifiedDoc, {
        FragmentDefinition: {
            enter: function(node) {
                if (node.selectionSet) {
                    var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                        return $e52049bf830e5717$export$fb56ad75dd311c12(selection) && selection.name.value === '__typename';
                    });
                    if (isTypenameOnly) return null;
                }
            }
        }
    });
    return modifiedDoc;
}
var $e52049bf830e5717$export$772fbc04a0ad4ce9 = typeof WeakMap === 'function' && !(typeof navigator === 'object' && navigator.product === 'ReactNative');
var $e52049bf830e5717$var$toString = Object.prototype.toString;
function $e52049bf830e5717$export$629a2bd3f5a49ecc(value) {
    return $e52049bf830e5717$var$cloneDeepHelper(value, new Map());
}
function $e52049bf830e5717$var$cloneDeepHelper(val, seen) {
    switch($e52049bf830e5717$var$toString.call(val)){
        case "[object Array]":
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $e52049bf830e5717$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $e52049bf830e5717$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}
function $e52049bf830e5717$export$4bd44a2aa29d3d6e() {
    if (typeof $igDjg !== 'undefined' && "production") return "production";
    return 'development';
}
function $e52049bf830e5717$export$f0cb0fda19c18b37(env) {
    return $e52049bf830e5717$export$4bd44a2aa29d3d6e() === env;
}
function $e52049bf830e5717$export$f15d00aa73aafac4() {
    return $e52049bf830e5717$export$f0cb0fda19c18b37('production') === true;
}
function $e52049bf830e5717$export$df77466336fe5355() {
    return $e52049bf830e5717$export$f0cb0fda19c18b37('development') === true;
}
function $e52049bf830e5717$export$410cbc2864fa25b5() {
    return $e52049bf830e5717$export$f0cb0fda19c18b37('test') === true;
}
function $e52049bf830e5717$export$50a91acae4904909(f) {
    try {
        return f();
    } catch (e) {
        if (console.error) console.error(e);
    }
}
function $e52049bf830e5717$export$b4df399e879e53ab(result) {
    return result.errors && result.errors.length;
}
function $e52049bf830e5717$var$deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function(prop) {
        if (o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) $e52049bf830e5717$var$deepFreeze(o[prop]);
    });
    return o;
}
function $e52049bf830e5717$export$7f9c177735b71f18(obj) {
    if ($e52049bf830e5717$export$df77466336fe5355() || $e52049bf830e5717$export$410cbc2864fa25b5()) {
        var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
        if (!symbolIsPolyfilled) return $e52049bf830e5717$var$deepFreeze(obj);
    }
    return obj;
}
var $e52049bf830e5717$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $e52049bf830e5717$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $e52049bf830e5717$export$160070228be94b08(sources);
}
function $e52049bf830e5717$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var pastCopies = [];
        target = $e52049bf830e5717$var$shallowCopyForMerge(target, pastCopies);
        for(var i = 1; i < count; ++i)target = $e52049bf830e5717$var$mergeHelper(target, sources[i], pastCopies);
    }
    return target;
}
function $e52049bf830e5717$var$isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function $e52049bf830e5717$var$mergeHelper(target, source, pastCopies) {
    if ($e52049bf830e5717$var$isObject(source) && $e52049bf830e5717$var$isObject(target)) {
        if (Object.isExtensible && !Object.isExtensible(target)) target = $e52049bf830e5717$var$shallowCopyForMerge(target, pastCopies);
        Object.keys(source).forEach(function(sourceKey) {
            var sourceValue = source[sourceKey];
            if ($e52049bf830e5717$var$hasOwnProperty.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) target[sourceKey] = $e52049bf830e5717$var$mergeHelper($e52049bf830e5717$var$shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
            } else target[sourceKey] = sourceValue;
        });
        return target;
    }
    return source;
}
function $e52049bf830e5717$var$shallowCopyForMerge(value, pastCopies) {
    if (value !== null && typeof value === 'object' && pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) value = value.slice(0);
        else value = (0, $dnskZ.__assign)({
            __proto__: Object.getPrototypeOf(value)
        }, value);
        pastCopies.push(value);
    }
    return value;
}
var $e52049bf830e5717$var$haveWarned = Object.create({});
function $e52049bf830e5717$export$49d47c8e549bfaf9(msg, type) {
    if (type === void 0) type = 'warn';
    if (!$e52049bf830e5717$export$f15d00aa73aafac4() && !$e52049bf830e5717$var$haveWarned[msg]) {
        if (!$e52049bf830e5717$export$410cbc2864fa25b5()) $e52049bf830e5717$var$haveWarned[msg] = true;
        if (type === 'error') console.error(msg);
        else console.warn(msg);
    }
}
function $e52049bf830e5717$export$c54efeba029d4fe8(data) {
    return JSON.parse(JSON.stringify(data));
}

});
parcelRegister("9E3xk", function(module, exports) {
$parcel$export(module.exports, "BREAK", () => $705a97c9b44c8772$export$a89c95c098ac2a58);
$parcel$export(module.exports, "visit", () => $705a97c9b44c8772$export$bf638b60ea8b89b7);
$parcel$export(module.exports, "getVisitFn", () => $705a97c9b44c8772$export$c9c25cca74db6e70);
$parcel$export(module.exports, "visitInParallel", () => $705a97c9b44c8772$export$728beebeea393478);

var $4QE9P = parcelRequire("4QE9P");

var $19BqA = parcelRequire("19BqA");
var $705a97c9b44c8772$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
var $705a97c9b44c8772$export$a89c95c098ac2a58 = Object.freeze({});
function $705a97c9b44c8772$export$bf638b60ea8b89b7(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $705a97c9b44c8772$export$4fcd777a40ccf407;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $19BqA.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, $4QE9P.default)(node), "."));
            var visitFn = $705a97c9b44c8772$export$c9c25cca74db6e70(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $705a97c9b44c8772$export$a89c95c098ac2a58) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $19BqA.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $705a97c9b44c8772$export$728beebeea393478(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $705a97c9b44c8772$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $705a97c9b44c8772$export$a89c95c098ac2a58) skipping[i] = $705a97c9b44c8772$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $705a97c9b44c8772$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $705a97c9b44c8772$export$a89c95c098ac2a58) skipping[i] = $705a97c9b44c8772$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
function $705a97c9b44c8772$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});

parcelRegister("5OKCR", function(module, exports) {
'use strict';
module.exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === 'boolean' ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for(i = 0; i < node.length; i++){
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }
        if (node === null) return 'null';
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    }(data);
};

});

parcelRegister("hR4hP", function(module, exports) {
$parcel$export(module.exports, "equal", () => $cffab61c3f329eee$export$411ce8e5a71e3069);
var $cffab61c3f329eee$var$_a = Object.prototype, $cffab61c3f329eee$var$toString = $cffab61c3f329eee$var$_a.toString, $cffab61c3f329eee$var$hasOwnProperty = $cffab61c3f329eee$var$_a.hasOwnProperty;
var $cffab61c3f329eee$var$previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ function $cffab61c3f329eee$export$411ce8e5a71e3069(a, b) {
    try {
        return $cffab61c3f329eee$var$check(a, b);
    } finally{
        $cffab61c3f329eee$var$previousComparisons.clear();
    }
}
function $cffab61c3f329eee$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = $cffab61c3f329eee$var$toString.call(a);
    var bTag = $cffab61c3f329eee$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            if ($cffab61c3f329eee$var$previouslyCompared(a, b)) return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length) return false;
            // Now make sure they have the same keys.
            for(var k = 0; k < keyCount; ++k){
                if (!$cffab61c3f329eee$var$hasOwnProperty.call(b, aKeys[k])) return false;
            }
            // Finally, check deep equality of all child properties.
            for(var k = 0; k < keyCount; ++k){
                var key = aKeys[k];
                if (!$cffab61c3f329eee$var$check(a[key], b[key])) return false;
            }
            return true;
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]':
            if (a.size !== b.size) return false;
            if ($cffab61c3f329eee$var$previouslyCompared(a, b)) return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while(true){
                var info = aIterator.next();
                if (info.done) break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) return false;
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !$cffab61c3f329eee$var$check(aValue, b.get(aKey))) return false;
            }
            return true;
    }
    // Otherwise the values are not equal.
    return false;
}
function $cffab61c3f329eee$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = $cffab61c3f329eee$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $cffab61c3f329eee$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}
var $cffab61c3f329eee$export$2e2bcd8739ae039 = $cffab61c3f329eee$export$411ce8e5a71e3069;

});


parcelRegister("7oe8F", function(module, exports) {
$parcel$export(module.exports, "fromError", () => fromError);
$parcel$export(module.exports, "ApolloLink", () => ApolloLink);
$parcel$export(module.exports, "from", () => from);
$parcel$export(module.exports, "execute", () => execute);
$parcel$export(module.exports, "Observable", () => (parcelRequire("1ZCcZ")).default);

var $1ZCcZ = parcelRequire("1ZCcZ");

var $lDEi6 = parcelRequire("lDEi6");

var $dnskZ = parcelRequire("dnskZ");

var $jFDfc = parcelRequire("jFDfc");
function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context'
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw new (0, $lDEi6.InvariantError)(2);
    }
    return operation;
}
var LinkError = function(_super) {
    (0, $dnskZ.__extends)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error);
function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function(resolve, reject) {
        observable.subscribe({
            next: function(data) {
                if (completed) ;
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject
        });
    });
}
var makePromise = toPromise;
function fromPromise(promise) {
    return new (0, $1ZCcZ.default)(function(observer) {
        promise.then(function(value) {
            observer.next(value);
            observer.complete();
        }).catch(observer.error.bind(observer));
    });
}
function fromError(errorValue) {
    return new (0, $1ZCcZ.default)(function(observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== 'string' ? (0, $jFDfc.getOperationName)(transformedOperation.query) : '';
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = (0, $dnskZ.__assign)({}, starting);
    var setContext = function(next) {
        if (typeof next === 'function') context = (0, $dnskZ.__assign)({}, context, next(context));
        else context = (0, $dnskZ.__assign)({}, context, next);
    };
    var getContext = function() {
        return (0, $dnskZ.__assign)({}, context);
    };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function() {
            return getKey(operation);
        }
    });
    return operation;
}
function getKey(operation) {
    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
    return JSON.stringify([
        operationName,
        query,
        variables
    ]);
}
function passthrough(op, forward) {
    return forward ? forward(op) : (0, $1ZCcZ.default).of();
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function empty() {
    return new ApolloLink(function() {
        return (0, $1ZCcZ.default).of();
    });
}
function from(links) {
    if (links.length === 0) return empty();
    return links.map(toLink).reduce(function(x, y) {
        return x.concat(y);
    });
}
function split(test, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink(passthrough));
    if (isTerminating(leftLink) && isTerminating(rightLink)) return new ApolloLink(function(operation) {
        return test(operation) ? leftLink.request(operation) || (0, $1ZCcZ.default).of() : rightLink.request(operation) || (0, $1ZCcZ.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return test(operation) ? leftLink.request(operation, forward) || (0, $1ZCcZ.default).of() : rightLink.request(operation, forward) || (0, $1ZCcZ.default).of();
    });
}
var concat = function(first, second) {
    var firstLink = toLink(first);
    if (isTerminating(firstLink)) return firstLink;
    var nextLink = toLink(second);
    if (isTerminating(nextLink)) return new ApolloLink(function(operation) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op) || (0, $1ZCcZ.default).of();
        }) || (0, $1ZCcZ.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op, forward) || (0, $1ZCcZ.default).of();
        }) || (0, $1ZCcZ.default).of();
    });
};
var ApolloLink = function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw new (0, $lDEi6.InvariantError)(1);
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}();
function execute(link, operation) {
    return link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || (0, $1ZCcZ.default).of();
}

});
parcelRegister("1ZCcZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1739205cd9dd2c7e$export$2e2bcd8739ae039);

var $f2glY = parcelRequire("f2glY");
var $1739205cd9dd2c7e$export$77cea355fa80b5f4 = (0, (/*@__PURE__*/$parcel$interopDefault($f2glY)));
var $1739205cd9dd2c7e$export$2e2bcd8739ae039 = $1739205cd9dd2c7e$export$77cea355fa80b5f4;

});
parcelRegister("f2glY", function(module, exports) {

module.exports = (parcelRequire("kWUY2")).Observable;

});
parcelRegister("kWUY2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Observable = void 0;
function $f40569f3cd93f27d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f40569f3cd93f27d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f40569f3cd93f27d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f40569f3cd93f27d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f40569f3cd93f27d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var $f40569f3cd93f27d$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $f40569f3cd93f27d$var$hasSymbol = function(name) {
    return $f40569f3cd93f27d$var$hasSymbols() && Boolean(Symbol[name]);
};
var $f40569f3cd93f27d$var$getSymbol = function(name) {
    return $f40569f3cd93f27d$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($f40569f3cd93f27d$var$hasSymbols() && !$f40569f3cd93f27d$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $f40569f3cd93f27d$var$SymbolIterator = $f40569f3cd93f27d$var$getSymbol('iterator');
var $f40569f3cd93f27d$var$SymbolObservable = $f40569f3cd93f27d$var$getSymbol('observable');
var $f40569f3cd93f27d$var$SymbolSpecies = $f40569f3cd93f27d$var$getSymbol('species'); // === Abstract Operations ===
function $f40569f3cd93f27d$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $f40569f3cd93f27d$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$f40569f3cd93f27d$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $f40569f3cd93f27d$var$Observable;
}
function $f40569f3cd93f27d$var$isObservable(x) {
    return x instanceof $f40569f3cd93f27d$var$Observable; // SPEC: Brand check
}
function $f40569f3cd93f27d$var$hostReportError(e) {
    if ($f40569f3cd93f27d$var$hostReportError.log) $f40569f3cd93f27d$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $f40569f3cd93f27d$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $f40569f3cd93f27d$var$hostReportError(e);
        }
    });
}
function $f40569f3cd93f27d$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $f40569f3cd93f27d$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $f40569f3cd93f27d$var$hostReportError(e);
    }
}
function $f40569f3cd93f27d$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $f40569f3cd93f27d$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $f40569f3cd93f27d$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $f40569f3cd93f27d$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $f40569f3cd93f27d$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $f40569f3cd93f27d$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $f40569f3cd93f27d$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $f40569f3cd93f27d$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $f40569f3cd93f27d$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $f40569f3cd93f27d$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $f40569f3cd93f27d$var$enqueue(function() {
            return $f40569f3cd93f27d$var$flushSubscription(subscription);
        });
        return;
    }
    $f40569f3cd93f27d$var$notifySubscription(subscription, type, value);
}
var $f40569f3cd93f27d$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        $f40569f3cd93f27d$var$_classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $f40569f3cd93f27d$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    $f40569f3cd93f27d$var$_createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== 'closed') {
                    $f40569f3cd93f27d$var$closeSubscription(this);
                    $f40569f3cd93f27d$var$cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $f40569f3cd93f27d$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        $f40569f3cd93f27d$var$_classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    $f40569f3cd93f27d$var$_createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                $f40569f3cd93f27d$var$onNotify(this._subscription, 'next', value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                $f40569f3cd93f27d$var$onNotify(this._subscription, 'error', value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                $f40569f3cd93f27d$var$onNotify(this._subscription, 'complete');
            }
        },
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $f40569f3cd93f27d$var$Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        $f40569f3cd93f27d$var$_classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    $f40569f3cd93f27d$var$_createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new $f40569f3cd93f27d$var$Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== 'function') {
                        reject(new TypeError(fn + ' is not a function'));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $f40569f3cd93f27d$var$getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $f40569f3cd93f27d$var$getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $f40569f3cd93f27d$var$getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = $f40569f3cd93f27d$var$getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function(v) {
                                observer.next(v);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $f40569f3cd93f27d$var$getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function(value) {
                                    observer.next(value);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: $f40569f3cd93f27d$var$SymbolObservable,
            value: function() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === 'function' ? this : Observable;
                if (x == null) throw new TypeError(x + ' is not an object');
                var method = $f40569f3cd93f27d$var$getMethod(x, $f40569f3cd93f27d$var$SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
                    if ($f40569f3cd93f27d$var$isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if ($f40569f3cd93f27d$var$hasSymbol('iterator')) {
                    method = $f40569f3cd93f27d$var$getMethod(x, $f40569f3cd93f27d$var$SymbolIterator);
                    if (method) return new C(function(observer) {
                        $f40569f3cd93f27d$var$enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    $f40569f3cd93f27d$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + ' is not observable');
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === 'function' ? this : Observable;
                return new C(function(observer) {
                    $f40569f3cd93f27d$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: $f40569f3cd93f27d$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
module.exports.Observable = $f40569f3cd93f27d$var$Observable;
if ($f40569f3cd93f27d$var$hasSymbols()) Object.defineProperty($f40569f3cd93f27d$var$Observable, Symbol('extensions'), {
    value: {
        symbol: $f40569f3cd93f27d$var$SymbolObservable,
        hostReportError: $f40569f3cd93f27d$var$hostReportError
    },
    configurable: true
});

});






parcelRegister("cwqPy", function(module, exports) {
$parcel$export(module.exports, "createAtlAttributionHeader", () => $e50aa37d08448e4c$export$14ef296862e3705e);
// our service
const $e50aa37d08448e4c$var$SERVICE = 'forge-ui';
const $e50aa37d08448e4c$export$14ef296862e3705e = (workspaceAri)=>{
    return JSON.stringify({
        atlWorkspaceAri: workspaceAri,
        service: $e50aa37d08448e4c$var$SERVICE
    });
};

});


parcelRegister("ezmKu", function(module, exports) {
$parcel$export(module.exports, "parseExtensionId", () => $e9a4e064bdee1059$export$bae42cbaf7fa3e1b);

var $63yBZ = parcelRequire("63yBZ");
const $e9a4e064bdee1059$export$bae42cbaf7fa3e1b = (extensionId)=>{
    const ari = (0, $63yBZ.parse)(extensionId);
    const [appId, environmentId, groupId, moduleKey] = ari.resourceId.split('/');
    return {
        appId: appId,
        environmentId: environmentId,
        groupId: groupId,
        moduleKey: moduleKey
    };
};

});
parcelRegister("63yBZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dnskZ = parcelRequire("dnskZ");

var $ik6eF = parcelRequire("ik6eF");

$dnskZ.__exportStar((parcelRequire("jWqQq")), module.exports);
/**
 * InvalidAriError - an error thrown if an invalid Ari is constructed
 */ class $468ddf0950beb311$var$InvalidAriError extends Error {
    /**
     * Construct an InvalidAriError given an error message
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {string|undefined} description - The error message
     */ constructor(ariString, description){
        super(`Invalid ari string: ${ariString}${description ? '. ' + description : ''}`);
        this.ariString = ariString;
        // Support correct inheritance in ES5
        Object.setPrototypeOf(this, $468ddf0950beb311$var$InvalidAriError.prototype);
    }
    /**
     * Construct an InvalidAriError given some constraint violations
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {ConstraintViolation<Object>[]} violations - The array of constraint errors
     */ static withConstraintViolations(ariString, violations) {
        return new $468ddf0950beb311$var$InvalidAriError(ariString, violations.map((v)=>v.toString()).join('\n'));
    }
}
module.exports.InvalidAriError = $468ddf0950beb311$var$InvalidAriError;
function $468ddf0950beb311$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
}
// constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
const $468ddf0950beb311$var$basicCharConstraint = $ik6eF.pattern(/^[a-z][a-z.-]*$/);
/**
 * resourceType allows for capitalized letters to support Identity ARIs (`ari:cloud:identity::userGrant/<...>`)
 * It's a violation of the spec, but we still need to support that.
 * See https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0
 */ const $468ddf0950beb311$var$resourceTypeCharConstraints = $ik6eF.pattern(/^[a-z][a-z.-]*$/i);
const $468ddf0950beb311$var$resourceOwnerConstraints = [
    $ik6eF.lengthBetween(3, 255),
    $468ddf0950beb311$var$basicCharConstraint
];
const $468ddf0950beb311$var$resourceTypeConstraints = [
    $ik6eF.lengthBetween(3, 255),
    $468ddf0950beb311$var$resourceTypeCharConstraints
];
const $468ddf0950beb311$var$cloudIdConstraints = [
    $ik6eF.lengthBetween(3, 255)
];
const $468ddf0950beb311$var$siteResourceType = 'site';
const $468ddf0950beb311$var$resourceIdChars = /[\w-._~:@#]/.source;
const $468ddf0950beb311$var$resourceIdConstraints = [
    $ik6eF.pattern(new RegExp(`^${$468ddf0950beb311$var$resourceIdChars}+(/${$468ddf0950beb311$var$resourceIdChars}*)*(;v=${$468ddf0950beb311$var$resourceIdChars}*)*$`))
];
/**
 * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
 * (like those for site wide ARIs) are upgraded to their latest form.
 */ function $468ddf0950beb311$var$upgrade(values) {
    const { resourceId: resourceId, resourceOwner: resourceOwner, cloudId: cloudId } = values;
    // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $468ddf0950beb311$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
class $468ddf0950beb311$var$ResourceIdentifier {
    get cloudId() {
        if (this.resourceType === $468ddf0950beb311$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
        return this.internalCloudId;
    }
    /**
     * Create a new Ari
     *
     * Only the resourceOwner is a required field, any other field can be omitted.
     * Older format types are converted on creation
     *
     * @param {string} values.resourceOwner - the owner of this resource (e.g. hipchat, confluence or jira)
     * @param {string|undefined} values.cloudId - the cloud id for this identifier, defined in AID
     * @param {string|undefined} values.resourceType - the resource type this Ari is associated with (e.g. conversation in hipchat)
     * @param {string|undefined} values.resourceId - a resource identifier, if this is specified the associated resourceType *must* be provided.
     *
     * @throws {InvalidAriError} if the provided segments fail to pass validation
     */ constructor(values){
        const { resourceId: resourceId, resourceOwner: resourceOwner, resourceType: resourceType, cloudId: cloudId } = $468ddf0950beb311$var$upgrade(values);
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
    /**
    * Parse a string as an Ari
    *
    * @param {string} ariString - the string to parse
    * @returns {Ari} the parsed ari
    * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
    */ static parse(ariString) {
        if (!ariString) throw new $468ddf0950beb311$var$InvalidAriError(ariString);
        const match = ariString.match(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/);
        if (!match || match.length !== 5) throw new $468ddf0950beb311$var$InvalidAriError(ariString);
        const terms = match.map((a)=>a && a.length > 0 ? a : undefined);
        const resourceOwner = terms[1];
        if (!resourceOwner) throw new $468ddf0950beb311$var$InvalidAriError(ariString);
        return new $468ddf0950beb311$var$ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    }
    static parseEncoded(encodedAriString) {
        return $468ddf0950beb311$var$parse(decodeURIComponent(encodedAriString));
    }
    /**
     * Converts this Ari to a string.
     */ toString() {
        if (!this.ariString) {
            const resourceId = this.resourceType === $468ddf0950beb311$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            const resourceType = this.resourceType || '';
            const sanitizedCloudId = this.resourceType === $468ddf0950beb311$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = `ari:cloud:${this.resourceOwner}:${sanitizedCloudId}:${resourceType}/${resourceId}`;
        }
        return this.ariString;
    }
    /**
     * Converts this object to its json representation
     */ toJSON() {
        return this.toString();
    }
    /**
     * Checks if this context is the same as another context
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} - true if all segments of both Aris are equal, false otherwise
     */ equals(other) {
        return other instanceof $468ddf0950beb311$var$ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    }
    /**
     * This method checks if the current context contains the other context.
     *
     * Note: it does that by transforming a site context  (e.g. `ari:cloud:<resource owner>:site/<cloud id>`)
     * if required to an "any" resource type context (e.g. `ari:cloud:<resource owner>:<cloud id>:/`)
     *
     * @param {Ari} other
     * @returns {boolean}
     */ contains(other) {
        return this.matches(new $468ddf0950beb311$var$ResourceIdentifier(other));
    }
    /**
     * Checks if this context is the same as or contains the provided context.
     *
     * Undefined segments in this ARI are treated as wildcards for matching purposes, but must exactly
     *  match if they are provided in the `other` Ari - i.e. this method is not commutative.
     *
     * e.g.
     * ```
     * parse('ari:cloud:hipchat::/').contains(parse('ari:cloud:hipchat:cloudid:conversation/blah')) === true
     * parse('ari:cloud:hipchat:cloudid:conversation/blah').contains(parse('ari:cloud:hipchat::/')) === false
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} true if this Ari is the same as the other Ari, or matches the other Ari. False otherwise.
     */ matches(other) {
        return $468ddf0950beb311$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $468ddf0950beb311$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $468ddf0950beb311$var$siteResourceType && !!other.resourceType || $468ddf0950beb311$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $468ddf0950beb311$var$siteResourceType && !!other.resourceType || $468ddf0950beb311$var$matchesSegment(this.resourceId, other.resourceId));
    }
    validateSiteWide() {
        const { resourceType: resourceType, cloudId: cloudId } = this;
        if (resourceType === $468ddf0950beb311$var$siteResourceType && !cloudId) return new $ik6eF.GeneralValidationError('site wide ARIs must have a cloudId');
    }
    validate() {
        const constraintViolations = [
            $ik6eF.validateField(this, 'resourceOwner', $468ddf0950beb311$var$resourceOwnerConstraints),
            $ik6eF.validateField(this, 'resourceType', $468ddf0950beb311$var$resourceTypeConstraints),
            $ik6eF.validateField(this, 'resourceId', $468ddf0950beb311$var$resourceIdConstraints),
            $ik6eF.validateField(this, 'cloudId', $468ddf0950beb311$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $468ddf0950beb311$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $468ddf0950beb311$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    }
    urlEncode() {
        return encodeURIComponent(this.toString());
    }
    urlDecode() {
        return decodeURIComponent(this.toString());
    }
}
module.exports.ResourceIdentifier = $468ddf0950beb311$var$ResourceIdentifier;
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $468ddf0950beb311$var$parse(ariString) {
    return $468ddf0950beb311$var$ResourceIdentifier.parse(ariString);
}
module.exports.parse = $468ddf0950beb311$var$parse;
/**
 * Parse a URL encoded string as an Ari
 *
 * @param {string} encodedAriString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $468ddf0950beb311$var$parseEncoded(encodedAriString) {
    return $468ddf0950beb311$var$ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $468ddf0950beb311$var$parseEncoded;

});
parcelRegister("ik6eF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eDoz3 = parcelRequire("eDoz3");
class $d56eee7d06fcc64a$var$LengthConstraint {
    constructor(min, max){
        this.min = min;
        this.max = max;
    }
    get description() {
        return `length must be between ${this.min} and ${this.max}`;
    }
    isValid(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    }
}
module.exports.LengthConstraint = $d56eee7d06fcc64a$var$LengthConstraint;
class $d56eee7d06fcc64a$var$RegexConstraint {
    constructor(regex){
        this.regex = regex;
    }
    get description() {
        return `value must match regex ${this.regex.source}`;
    }
    isValid(value) {
        return !value || this.regex.test(value);
    }
}
module.exports.RegexConstraint = $d56eee7d06fcc64a$var$RegexConstraint;
class $d56eee7d06fcc64a$var$GeneralValidationError {
    constructor(error){
        this.error = error;
    }
    toString() {
        return this.error;
    }
}
module.exports.GeneralValidationError = $d56eee7d06fcc64a$var$GeneralValidationError;
class $d56eee7d06fcc64a$var$ConstraintViolation {
    constructor(fieldName, value, constraints){
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
    toString() {
        const constraintSummary = this.constraints.map((c)=>`  - ${c.description}`).join('\n');
        return `'${this.value}' is not a valid value for ${this.fieldName} as it violates the following constraints:\n${constraintSummary}`;
    }
}
module.exports.ConstraintViolation = $d56eee7d06fcc64a$var$ConstraintViolation;
function $d56eee7d06fcc64a$var$lengthBetween(min, max) {
    return new $d56eee7d06fcc64a$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $d56eee7d06fcc64a$var$lengthBetween;
function $d56eee7d06fcc64a$var$pattern(regex) {
    return new $d56eee7d06fcc64a$var$RegexConstraint(regex);
}
module.exports.pattern = $d56eee7d06fcc64a$var$pattern;
function $d56eee7d06fcc64a$var$validateField(object, fieldName, constraints) {
    const value = object[fieldName];
    const violatedConstraints = constraints.map((c)=>{
        return c.isValid(value) ? undefined : c;
    }).filter($eDoz3.isDefined);
    return violatedConstraints.length > 0 ? new $d56eee7d06fcc64a$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $d56eee7d06fcc64a$var$validateField;

});
parcelRegister("eDoz3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasValueAtKey = module.exports.hasPresentKey = module.exports.isFilled = module.exports.isDefined = module.exports.isPresent = void 0;
function $aa77c3314e9d9437$var$isPresent(t) {
    return t !== undefined && t !== null;
}
module.exports.isPresent = $aa77c3314e9d9437$var$isPresent;
function $aa77c3314e9d9437$var$isDefined(t) {
    return t !== undefined;
}
module.exports.isDefined = $aa77c3314e9d9437$var$isDefined;
function $aa77c3314e9d9437$var$isFilled(t) {
    return t !== null;
}
module.exports.isFilled = $aa77c3314e9d9437$var$isFilled;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a defined non-null value under the key `k`.
 *
 * @example
 * ```ts
 * const filesWithUrl = files.filter(file => file.url);
 * files[0].url // In this case, TS might still treat this as undefined/null
 *
 * const filesWithUrl = files.filter(hasPresentKey("url"));
 * files[0].url // TS will know that this is present
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $aa77c3314e9d9437$var$hasPresentKey(k) {
    return function(a) {
        return a[k] !== undefined && a[k] !== null;
    };
}
module.exports.hasPresentKey = $aa77c3314e9d9437$var$hasPresentKey;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a specific value V under a key `k`.
 *
 * @example
 * ```ts
 * type File = { type: "image", imageUrl: string } | { type: "pdf", pdfUrl: string };
 * const files: File[] = [];
 *
 * const imageFiles = files.filter(file => file.type === "image");
 * files[0].type // In this case, TS will still treat it  as `"image" | "pdf"`
 *
 * const filesWithUrl = files.filter(hasValueKey("type", "image" as const));
 * files[0].type // TS will now know that this is "image"
 * files[0].imageUrl // TS will know this is present, because already it excluded the other union members.
 *
 * Note: the cast `as const` is necessary, otherwise TS will only know that type is a string.
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $aa77c3314e9d9437$var$hasValueAtKey(k, v) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(a) {
        return a[k] === v;
    };
}
module.exports.hasValueAtKey = $aa77c3314e9d9437$var$hasValueAtKey;

});


parcelRegister("jWqQq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4ZFVe = parcelRequire("4ZFVe");
var $e84841da69f5e74e$var$AppFamilyAri;
(function(AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [
        AppFamilyAri.appResourceType,
        AppFamilyAri.environmentResourceType,
        AppFamilyAri.extensionGroupResourceType,
        AppFamilyAri.extensionResourceType
    ];
})($e84841da69f5e74e$var$AppFamilyAri = module.exports.AppFamilyAri || (module.exports.AppFamilyAri = {}));
class $e84841da69f5e74e$var$AppFamilyAriError extends Error {
    constructor(message, cause){
        super(message);
        this.cause = cause;
    }
}
module.exports.AppFamilyAriError = $e84841da69f5e74e$var$AppFamilyAriError;
class $e84841da69f5e74e$var$NotAppFamilyAriError extends $e84841da69f5e74e$var$AppFamilyAriError {
    constructor(ari, reason){
        super(`ari is not a valid App family ari: ${ari.toString()} as ${reason}`);
        this.reason = reason;
    }
}
module.exports.NotAppFamilyAriError = $e84841da69f5e74e$var$NotAppFamilyAriError;
class $e84841da69f5e74e$var$NotExpectedAppFamilyAriTypeError extends $e84841da69f5e74e$var$AppFamilyAriError {
    constructor(type, ari, cause){
        super(`App family ari (${ari.toString()}) is not of expected type: ${type}`, cause);
        this.cause = cause;
    }
}
module.exports.NotExpectedAppFamilyAriTypeError = $e84841da69f5e74e$var$NotExpectedAppFamilyAriTypeError;
/**
 * throws NotAppFamilyAriError if not a valid app family ari
 */ function $e84841da69f5e74e$var$parseAppAri(ari) {
    return $4ZFVe.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $e84841da69f5e74e$var$parseAppAri;
function $e84841da69f5e74e$var$createAppAri(json) {
    return new $4ZFVe.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $e84841da69f5e74e$var$createAppAri;

});
parcelRegister("4ZFVe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jWqQq = parcelRequire("jWqQq");

var $63yBZ = parcelRequire("63yBZ");

var $ik6eF = parcelRequire("ik6eF");
const $3a2d60ca363a4626$var$versionPrefix = ';v=';
const $3a2d60ca363a4626$var$uuidRegExpString = '[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}';
const $3a2d60ca363a4626$var$uuidConstraints = [
    $ik6eF.pattern(new RegExp(`^${$3a2d60ca363a4626$var$uuidRegExpString}$`, 'i'))
];
const $3a2d60ca363a4626$var$extensionGroupIdConstraints = [
    $ik6eF.pattern(new RegExp(`^(${$3a2d60ca363a4626$var$uuidRegExpString}|static)$`, 'i'))
];
class $3a2d60ca363a4626$var$AppFamilyAriImpl {
    constructor(json){
        this.json = json;
        this.validate();
    }
    get appId() {
        return this.json.appId;
    }
    get environmentId() {
        return this.json.environmentId;
    }
    get version() {
        return this.json.version;
    }
    get extensionGroupId() {
        return this.json.extensionGroupId;
    }
    get extensionKey() {
        return this.json.extensionKey;
    }
    toJSON() {
        return this.json;
    }
    static parse(ari) {
        const { resourceOwner: resourceOwner, resourceType: resourceType, resourceId: resourceId } = ari;
        if (resourceOwner !== $jWqQq.AppFamilyAri.resourceOwner) throw new $jWqQq.NotAppFamilyAriError(ari, `resourceOwner (${resourceOwner}) must be ${$jWqQq.AppFamilyAri.resourceOwner}`);
        if (!resourceType || $jWqQq.AppFamilyAri.appFamilyResourceTypes.indexOf(resourceType) < 0) throw new $jWqQq.NotAppFamilyAriError(ari, `resourceType must be one of ${$jWqQq.AppFamilyAri.appFamilyResourceTypes}`);
        if (!resourceId) throw new $jWqQq.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        const versionIndex = resourceId.indexOf($3a2d60ca363a4626$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($3a2d60ca363a4626$var$versionPrefix) > versionIndex) throw new $jWqQq.NotAppFamilyAriError(ari, 'can only include one version suffix');
        const [mainResourceId, version] = resourceId.split($3a2d60ca363a4626$var$versionPrefix);
        const segments = mainResourceId.split('/').map($3a2d60ca363a4626$var$stripToUndefined);
        if (segments.length > 4) throw new $jWqQq.NotAppFamilyAriError(ari, `no path segments can be added after extensionKey ${segments.slice(4)}`);
        const [appId, environmentId, providedExtensionGroupId, extensionKey] = segments;
        if (!appId) throw new $jWqQq.NotAppFamilyAriError(ari, 'appId must be included');
        const extensionGroupId = providedExtensionGroupId || (resourceType === $jWqQq.AppFamilyAri.extensionGroupResourceType || resourceType === $jWqQq.AppFamilyAri.extensionResourceType ? 'static' : undefined);
        if (resourceType === $jWqQq.AppFamilyAri.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $jWqQq.NotAppFamilyAriError(ari, `environmentId, extensionGroupId, extensionKey must all be provided for resourceType ${$jWqQq.AppFamilyAri.extensionResourceType}`);
        else if (resourceType === $jWqQq.AppFamilyAri.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $jWqQq.NotAppFamilyAriError(ari, `environmentId, extensionGroupId must all be provided for resourceType ${$jWqQq.AppFamilyAri.extensionGroupResourceType}`);
        else if (resourceType === $jWqQq.AppFamilyAri.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $jWqQq.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$jWqQq.AppFamilyAri.environmentResourceType}`);
        else if (resourceType === $jWqQq.AppFamilyAri.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $jWqQq.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$jWqQq.AppFamilyAri.environmentResourceType}`);
        return new $3a2d60ca363a4626$var$AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    }
    asAppAri() {
        return this.returnIf(()=>this.isAppAri(), 'app');
    }
    asAppEnvironmentAri() {
        return this.returnIf(()=>this.isAppEnvironmentAri(), 'environment');
    }
    asExtensionGroupAri() {
        return this.returnIf(()=>this.isExtensionGroupAri(), 'extension-group');
    }
    asExtensionAri() {
        return this.returnIf(()=>this.isExtensionAri(), 'extension');
    }
    isAppAri() {
        return !this.isAtLeastAppEnvironmentAri;
    }
    isAppEnvironmentAri() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    }
    isExtensionGroupAri() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    }
    isExtensionAri() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    }
    returnIf(check, type) {
        if (!check()) throw new $jWqQq.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    }
    get isAtLeastAppEnvironmentAri() {
        return this.environmentId !== undefined;
    }
    get isAtLeastExtensionGroupAri() {
        return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
    }
    validate() {
        const constraintViolations = [
            $ik6eF.validateField(this, 'environmentId', $3a2d60ca363a4626$var$uuidConstraints),
            $ik6eF.validateField(this, 'appId', $3a2d60ca363a4626$var$uuidConstraints),
            $ik6eF.validateField(this, 'extensionGroupId', $3a2d60ca363a4626$var$extensionGroupIdConstraints)
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $63yBZ.InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
    }
    toAri() {
        const resourceOwner = $jWqQq.AppFamilyAri.resourceOwner;
        const { appId: appId, environmentId: environmentId, extensionGroupId: extensionGroupId, extensionKey: extensionKey, version: version } = this.toJSON();
        function withVersion(segments) {
            const path = segments.join('/');
            if (!version) return path;
            else return `${path}${$3a2d60ca363a4626$var$versionPrefix}${version}`;
        }
        if (this.isExtensionAri()) return new $63yBZ.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $jWqQq.AppFamilyAri.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $63yBZ.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $jWqQq.AppFamilyAri.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentAri()) return new $63yBZ.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $jWqQq.AppFamilyAri.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $63yBZ.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $jWqQq.AppFamilyAri.appResourceType,
            resourceId: appId
        });
    }
    toString() {
        return this.toAri().toString();
    }
}
module.exports.AppFamilyAriImpl = $3a2d60ca363a4626$var$AppFamilyAriImpl;
function $3a2d60ca363a4626$var$stripToUndefined(str) {
    if (!str) return undefined;
    const trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}

});




parcelRegister("13WEh", function(module, exports) {
$parcel$export(module.exports, "useMemoizedStateObject", () => $140a45e6d59a5348$export$cc725e2aa41de44a);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");
const $140a45e6d59a5348$export$cc725e2aa41de44a = (data, equalityCheck = (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj))))=>{
    const [memoizedData, setMemoizedData] = (0, $eJOHy.useState)(data);
    (0, $eJOHy.useEffect)(()=>{
        if (!equalityCheck(data, memoizedData)) setMemoizedData(data);
    }, [
        data,
        memoizedData,
        equalityCheck
    ]);
    return memoizedData;
};

});

parcelRegister("kKhkW", function(module, exports) {
$parcel$export(module.exports, "TracingProvider", () => $07c195fec3d4c2b7$export$73f470ced5fdc319);
$parcel$export(module.exports, "useTracingContext", () => $07c195fec3d4c2b7$export$1bd6b93107e60cf1);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $07c195fec3d4c2b7$export$e775b9769343d051 = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $07c195fec3d4c2b7$export$73f470ced5fdc319 = (props)=>{
    const breadCrumbs = (0, $eJOHy.useRef)([]);
    const tracingService = (0, $eJOHy.useRef)({
        getBreadcrumbs: ()=>breadCrumbs.current,
        recordBridgeCall: (description)=>breadCrumbs.current = [
                ...breadCrumbs.current,
                {
                    category: `forge.bridge`,
                    message: description,
                    timestamp: new Date().toISOString()
                }
            ],
        recordGqlCall: (description)=>breadCrumbs.current = [
                ...breadCrumbs.current,
                {
                    type: 'http',
                    category: 'gql',
                    timestamp: new Date().toISOString(),
                    data: {
                        url: description
                    }
                }
            ],
        recordConsentFlow: (description, result)=>breadCrumbs.current = [
                ...breadCrumbs.current,
                {
                    category: `user.consent`,
                    message: description,
                    timestamp: new Date().toISOString(),
                    ...result ? {
                        data: {
                            result: result
                        }
                    } : {}
                }
            ]
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)($07c195fec3d4c2b7$export$e775b9769343d051.Provider, {
        value: tracingService.current,
        children: props.children
    });
};
const $07c195fec3d4c2b7$export$1bd6b93107e60cf1 = ()=>{
    const tracingContext = (0, $eJOHy.useContext)($07c195fec3d4c2b7$export$e775b9769343d051);
    return tracingContext;
};

});

parcelRegister("aoswO", function(module, exports) {
$parcel$export(module.exports, "createSrcFromExtension", () => $7145b95247e15235$export$158d41afab8f2af8);
$parcel$export(module.exports, "urlSafeB64", () => $7145b95247e15235$export$223741b87b7c6af6);

var $lopBx = parcelRequire("lopBx");
var $7pw1V = parcelRequire("7pw1V");
parcelRequire("1B59H");
var $bMVUa = parcelRequire("bMVUa");

var $eGOwo = parcelRequire("eGOwo");

var $aD1DH = parcelRequire("aD1DH");

var $3g7o0 = parcelRequire("3g7o0");
const $7145b95247e15235$export$9b5c32eaf7c2ac3d = {
    [(0, $bMVUa.ProductEnvironment).PRODUCTION]: 'prod',
    [(0, $bMVUa.ProductEnvironment).STAGING]: 'stg',
    [(0, $bMVUa.ProductEnvironment).DEVELOPMENT]: 'stg'
};
const $7145b95247e15235$export$158d41afab8f2af8 = (appId, extension, environment, entryPoint)=>{
    if ((0, $eGOwo.fg)('forge-ui-oasis-enabled')) return (0, $7pw1V.isIsolatedCloud)() ? $7145b95247e15235$export$d68551323b971eed(appId, extension, entryPoint) : $7145b95247e15235$export$b1a4a6ad329e6bd2(appId, extension, environment, entryPoint);
    return $7145b95247e15235$export$b1a4a6ad329e6bd2(appId, extension, environment, entryPoint);
};
const $7145b95247e15235$export$b1a4a6ad329e6bd2 = (appId, extension, environment, entryPoint)=>{
    const cdnEnv = (0, $aD1DH.getCDNEnvironment)(environment);
    // Map the dev environment to staging here for local development. The dev environment is not set up to load Forge apps.
    const urlEnv = cdnEnv === (0, $bMVUa.ForgeCDNEnvironment).DEVELOPMENT ? (0, $bMVUa.ForgeCDNEnvironment).STAGING : cdnEnv;
    const { installationId: installationId, environmentId: environmentId, appVersion: appVersion, properties: properties } = extension;
    const resourceUploadId = properties.resourceUploadId || appVersion;
    const secondLevelDomain = (0, $lopBx.isFedRamp)() ? 'atlassian-dev-us-gov-mod' : 'atlassian-dev';
    const domain = `${$7145b95247e15235$export$d4a94ef9062fefbf(installationId)}--${$7145b95247e15235$export$d4a94ef9062fefbf(appId)}.cdn.${urlEnv}.${secondLevelDomain}.net`;
    /**
	 * Hostname is added here as a URI segment instead of a query string because the JS and CSS scripts inside of the index.html file need to be aware of the hostname as well.
	 * They are using relative paths that will ignore the appended query string here.
	 *
	 * The appId is also included in the subdomain so that it can be compared against the appId in the
	 * resource path. This comparison is performed by the routing Lambda@ Edge to prevent a malicious
	 * developer from appending their malicious app path to a legitimate installation id.
	 */ const encodedAppContext = (0, $3g7o0.getEncodedAppContext)(extension);
    const urlSafeContext = $7145b95247e15235$export$223741b87b7c6af6(encodedAppContext);
    return `https://${domain}/${appId}/${environmentId}/${resourceUploadId}/${entryPoint}/_hostname_${window.location.hostname}/_ctx_${urlSafeContext}/`;
};
const $7145b95247e15235$export$d68551323b971eed = (appId, extension, entryPoint)=>{
    const { installationId: installationId, environmentId: environmentId, appVersion: appVersion, properties: properties } = extension;
    const resourceUploadId = properties.resourceUploadId || appVersion;
    const icDomain = (0, $7pw1V.isolatedCloudDomain)();
    const domain = `${$7145b95247e15235$export$d4a94ef9062fefbf(installationId)}--${$7145b95247e15235$export$d4a94ef9062fefbf(appId)}.forge-cdn.${icDomain}`;
    const encodedAppContext = (0, $3g7o0.getEncodedAppContext)(extension);
    const urlSafeContext = $7145b95247e15235$export$223741b87b7c6af6(encodedAppContext);
    return `https://${domain}/forge-cdn/${appId}/${environmentId}/${resourceUploadId}/${entryPoint}/_hostname_${window.location.hostname}/_ctx_${urlSafeContext}/`;
};
function $7145b95247e15235$export$d4a94ef9062fefbf(uuid) {
    const [a, b, c, d, e] = uuid.split('-');
    const combinedUuid = [
        a,
        `${b}${c}${d}`,
        e
    ];
    return combinedUuid.map((s)=>parseInt(s, 16)).map((s)=>s.toString(36)).join('-');
}
function $7145b95247e15235$export$824f5b1835a75769(shortenedUuid) {
    const [a, b, c] = shortenedUuid.split('-').map((s)=>parseInt(s, 36)).map((s)=>s.toString(16));
    // expands the middle segment into the original UUID
    // ffffffff-abcdabcdabcd-ffffffffffff ===> ffffffff-abcd-abcd-abcd-ffffffffffff
    const middleExpanded = b.match(/.{1,4}/g) || b;
    return [
        a,
        ...middleExpanded,
        c
    ].join('-');
}
function $7145b95247e15235$export$223741b87b7c6af6(str) {
    return str.replace(/\+/g, '-') // Replace '+' with '-'
    .replace(/\//g, '_') // Replace '/' with '_'
    .replace(/=+$/, ''); // Remove padding
}

});
parcelRegister("aD1DH", function(module, exports) {
$parcel$export(module.exports, "getCDNEnvironment", () => $0cbff87d6a3945d0$export$d86e18ec9052db2c);
parcelRequire("1B59H");
var $bMVUa = parcelRequire("bMVUa");

var $lopBx = parcelRequire("lopBx");
const $0cbff87d6a3945d0$export$d86e18ec9052db2c = (productEnvironment)=>{
    if ((0, $lopBx.isFedRamp)()) {
        if (productEnvironment === (0, $bMVUa.ProductEnvironment).STAGING) return (0, $bMVUa.ForgeCDNEnvironment).STAGING;
        else return (0, $bMVUa.ForgeCDNEnvironment).PRODUCTION;
    }
    if (productEnvironment === (0, $bMVUa.ProductEnvironment).DEVELOPMENT) return (0, $bMVUa.ForgeCDNEnvironment).DEVELOPMENT;
    else if (productEnvironment === (0, $bMVUa.ProductEnvironment).STAGING) return (0, $bMVUa.ForgeCDNEnvironment).STAGING;
    else return (0, $bMVUa.ForgeCDNEnvironment).PRODUCTION;
};

});

parcelRegister("3g7o0", function(module, exports) {
$parcel$export(module.exports, "getEncodedAppContext", () => $4a3f9f33def6505a$export$423a62223c29d468);

var $5OKCR = parcelRequire("5OKCR");

var $fXGnA = parcelRequire("fXGnA");
const $4a3f9f33def6505a$export$423a62223c29d468 = (extension)=>{
    const { egress: egress = [], installationConfig: installationConfig = [] } = extension;
    return $4a3f9f33def6505a$var$gzipAndB64Encode({
        egress: egress,
        installationConfig: installationConfig,
        hostname: window.location.hostname
    });
};
const $4a3f9f33def6505a$var$gzipAndB64Encode = (json)=>{
    const jsonString = (0, (/*@__PURE__*/$parcel$interopDefault($5OKCR)))(json); // We use fast-json-stable-stringify to ensure that the JSON is deterministic
    try {
        const zippedData = (0, $fXGnA.gzipSync)(new TextEncoder().encode(jsonString), {
            level: 9,
            mtime: 0
        });
        return btoa(String.fromCharCode(...zippedData));
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err.message);
    }
    return '';
};

});
parcelRegister("fXGnA", function(module, exports) {
$parcel$export(module.exports, "gzipSync", () => $b9ed3d5ec52fbe00$export$3d616c3fb3e15483);
$parcel$export(module.exports, "gunzip", () => $b9ed3d5ec52fbe00$export$b6df3e950734d697);
// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var $b9ed3d5ec52fbe00$var$ch2 = {};
var $b9ed3d5ec52fbe00$var$wk = function(c, id, msg, transfer, cb) {
    var w = new Worker($b9ed3d5ec52fbe00$var$ch2[id] || ($b9ed3d5ec52fbe00$var$ch2[id] = URL.createObjectURL(new Blob([
        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], {
        type: 'text/javascript'
    }))));
    w.onmessage = function(e) {
        var d = e.data, ed = d.$e$;
        if (ed) {
            var err = new Error(ed[0]);
            err['code'] = ed[1];
            err.stack = ed[2];
            cb(err, null);
        } else cb(null, d);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var $b9ed3d5ec52fbe00$var$u8 = Uint8Array, $b9ed3d5ec52fbe00$var$u16 = Uint16Array, $b9ed3d5ec52fbe00$var$i32 = Int32Array;
// fixed length extra bits
var $b9ed3d5ec52fbe00$var$fleb = new $b9ed3d5ec52fbe00$var$u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
var $b9ed3d5ec52fbe00$var$fdeb = new $b9ed3d5ec52fbe00$var$u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var $b9ed3d5ec52fbe00$var$clim = new $b9ed3d5ec52fbe00$var$u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var $b9ed3d5ec52fbe00$var$freb = function(eb, start) {
    var b = new $b9ed3d5ec52fbe00$var$u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new $b9ed3d5ec52fbe00$var$i32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return {
        b: b,
        r: r
    };
};
var $b9ed3d5ec52fbe00$var$_a = $b9ed3d5ec52fbe00$var$freb($b9ed3d5ec52fbe00$var$fleb, 2), $b9ed3d5ec52fbe00$var$fl = $b9ed3d5ec52fbe00$var$_a.b, $b9ed3d5ec52fbe00$var$revfl = $b9ed3d5ec52fbe00$var$_a.r;
// we can ignore the fact that the other numbers are wrong; they never happen anyway
$b9ed3d5ec52fbe00$var$fl[28] = 258, $b9ed3d5ec52fbe00$var$revfl[258] = 28;
var $b9ed3d5ec52fbe00$var$_b = $b9ed3d5ec52fbe00$var$freb($b9ed3d5ec52fbe00$var$fdeb, 0), $b9ed3d5ec52fbe00$var$fd = $b9ed3d5ec52fbe00$var$_b.b, $b9ed3d5ec52fbe00$var$revfd = $b9ed3d5ec52fbe00$var$_b.r;
// map of value to reverse (assuming 16 bits)
var $b9ed3d5ec52fbe00$var$rev = new $b9ed3d5ec52fbe00$var$u16(32768);
for(var $b9ed3d5ec52fbe00$var$i = 0; $b9ed3d5ec52fbe00$var$i < 32768; ++$b9ed3d5ec52fbe00$var$i){
    // reverse table algorithm from SO
    var $b9ed3d5ec52fbe00$var$x = ($b9ed3d5ec52fbe00$var$i & 0xAAAA) >> 1 | ($b9ed3d5ec52fbe00$var$i & 0x5555) << 1;
    $b9ed3d5ec52fbe00$var$x = ($b9ed3d5ec52fbe00$var$x & 0xCCCC) >> 2 | ($b9ed3d5ec52fbe00$var$x & 0x3333) << 2;
    $b9ed3d5ec52fbe00$var$x = ($b9ed3d5ec52fbe00$var$x & 0xF0F0) >> 4 | ($b9ed3d5ec52fbe00$var$x & 0x0F0F) << 4;
    $b9ed3d5ec52fbe00$var$rev[$b9ed3d5ec52fbe00$var$i] = (($b9ed3d5ec52fbe00$var$x & 0xFF00) >> 8 | ($b9ed3d5ec52fbe00$var$x & 0x00FF) << 8) >> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var $b9ed3d5ec52fbe00$var$hMap = function(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new $b9ed3d5ec52fbe00$var$u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)if (cd[i]) ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new $b9ed3d5ec52fbe00$var$u16(mb);
    for(i = 1; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new $b9ed3d5ec52fbe00$var$u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[$b9ed3d5ec52fbe00$var$rev[v] >> rvb] = sv;
        }
    } else {
        co = new $b9ed3d5ec52fbe00$var$u16(s);
        for(i = 0; i < s; ++i)if (cd[i]) co[i] = $b9ed3d5ec52fbe00$var$rev[le[cd[i] - 1]++] >> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var $b9ed3d5ec52fbe00$var$flt = new $b9ed3d5ec52fbe00$var$u8(288);
for(var $b9ed3d5ec52fbe00$var$i = 0; $b9ed3d5ec52fbe00$var$i < 144; ++$b9ed3d5ec52fbe00$var$i)$b9ed3d5ec52fbe00$var$flt[$b9ed3d5ec52fbe00$var$i] = 8;
for(var $b9ed3d5ec52fbe00$var$i = 144; $b9ed3d5ec52fbe00$var$i < 256; ++$b9ed3d5ec52fbe00$var$i)$b9ed3d5ec52fbe00$var$flt[$b9ed3d5ec52fbe00$var$i] = 9;
for(var $b9ed3d5ec52fbe00$var$i = 256; $b9ed3d5ec52fbe00$var$i < 280; ++$b9ed3d5ec52fbe00$var$i)$b9ed3d5ec52fbe00$var$flt[$b9ed3d5ec52fbe00$var$i] = 7;
for(var $b9ed3d5ec52fbe00$var$i = 280; $b9ed3d5ec52fbe00$var$i < 288; ++$b9ed3d5ec52fbe00$var$i)$b9ed3d5ec52fbe00$var$flt[$b9ed3d5ec52fbe00$var$i] = 8;
// fixed distance tree
var $b9ed3d5ec52fbe00$var$fdt = new $b9ed3d5ec52fbe00$var$u8(32);
for(var $b9ed3d5ec52fbe00$var$i = 0; $b9ed3d5ec52fbe00$var$i < 32; ++$b9ed3d5ec52fbe00$var$i)$b9ed3d5ec52fbe00$var$fdt[$b9ed3d5ec52fbe00$var$i] = 5;
// fixed length map
var $b9ed3d5ec52fbe00$var$flm = /*#__PURE__*/ $b9ed3d5ec52fbe00$var$hMap($b9ed3d5ec52fbe00$var$flt, 9, 0), $b9ed3d5ec52fbe00$var$flrm = /*#__PURE__*/ $b9ed3d5ec52fbe00$var$hMap($b9ed3d5ec52fbe00$var$flt, 9, 1);
// fixed distance map
var $b9ed3d5ec52fbe00$var$fdm = /*#__PURE__*/ $b9ed3d5ec52fbe00$var$hMap($b9ed3d5ec52fbe00$var$fdt, 5, 0), $b9ed3d5ec52fbe00$var$fdrm = /*#__PURE__*/ $b9ed3d5ec52fbe00$var$hMap($b9ed3d5ec52fbe00$var$fdt, 5, 1);
// find max of array
var $b9ed3d5ec52fbe00$var$max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var $b9ed3d5ec52fbe00$var$bits = function(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var $b9ed3d5ec52fbe00$var$bits16 = function(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var $b9ed3d5ec52fbe00$var$shft = function(p) {
    return (p + 7) / 8 | 0;
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var $b9ed3d5ec52fbe00$var$slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    return new $b9ed3d5ec52fbe00$var$u8(v.subarray(s, e));
};
var $b9ed3d5ec52fbe00$export$ae5516a5a74c19a8 = {
    UnexpectedEOF: 0,
    InvalidBlockType: 1,
    InvalidLengthLiteral: 2,
    InvalidDistance: 3,
    StreamFinished: 4,
    NoStreamHandler: 5,
    InvalidHeader: 6,
    NoCallback: 7,
    InvalidUTF8: 8,
    ExtraFieldTooLong: 9,
    InvalidDate: 10,
    FilenameTooLong: 11,
    StreamFinishing: 12,
    InvalidZipData: 13,
    UnknownCompressionMethod: 14
};
// error codes
var $b9ed3d5ec52fbe00$var$ec = [
    'unexpected EOF',
    'invalid block type',
    'invalid length/literal',
    'invalid distance',
    'stream finished',
    'no stream handler',
    ,
    'no callback',
    'invalid UTF-8 data',
    'extra field too long',
    'date not in range 1980-2099',
    'filename too long',
    'stream finishing',
    'invalid zip data'
];
var $b9ed3d5ec52fbe00$var$err = function(ind, msg, nt) {
    var e = new Error(msg || $b9ed3d5ec52fbe00$var$ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace) Error.captureStackTrace(e, $b9ed3d5ec52fbe00$var$err);
    if (!nt) throw e;
    return e;
};
// expands raw DEFLATE data
var $b9ed3d5ec52fbe00$var$inflt = function(dat, st, buf, dict) {
    // source length       dict length
    var sl = dat.length, dl = dict ? dict.length : 0;
    if (!sl || st.f && !st.l) return buf || new $b9ed3d5ec52fbe00$var$u8(0);
    var noBuf = !buf;
    // have to estimate size
    var resize = noBuf || st.i != 2;
    // no state
    var noSt = st.i;
    // Assumes roughly 33% compression ratio average
    if (noBuf) buf = new $b9ed3d5ec52fbe00$var$u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new $b9ed3d5ec52fbe00$var$u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            final = $b9ed3d5ec52fbe00$var$bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = $b9ed3d5ec52fbe00$var$bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = $b9ed3d5ec52fbe00$var$shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) $b9ed3d5ec52fbe00$var$err(0);
                    break;
                }
                // ensure size
                if (resize) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                continue;
            } else if (type == 1) lm = $b9ed3d5ec52fbe00$var$flrm, dm = $b9ed3d5ec52fbe00$var$fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = $b9ed3d5ec52fbe00$var$bits(dat, pos, 31) + 257, hcLen = $b9ed3d5ec52fbe00$var$bits(dat, pos + 10, 15) + 4;
                var tl = hLit + $b9ed3d5ec52fbe00$var$bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new $b9ed3d5ec52fbe00$var$u8(tl);
                // code length tree
                var clt = new $b9ed3d5ec52fbe00$var$u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[$b9ed3d5ec52fbe00$var$clim[i]] = $b9ed3d5ec52fbe00$var$bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = $b9ed3d5ec52fbe00$var$max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = $b9ed3d5ec52fbe00$var$hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[$b9ed3d5ec52fbe00$var$bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + $b9ed3d5ec52fbe00$var$bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + $b9ed3d5ec52fbe00$var$bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + $b9ed3d5ec52fbe00$var$bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = $b9ed3d5ec52fbe00$var$max(lt);
                // max dist bits
                dbt = $b9ed3d5ec52fbe00$var$max(dt);
                lm = $b9ed3d5ec52fbe00$var$hMap(lt, lbt, 1);
                dm = $b9ed3d5ec52fbe00$var$hMap(dt, dbt, 1);
            } else $b9ed3d5ec52fbe00$var$err(1);
            if (pos > tbts) {
                if (noSt) $b9ed3d5ec52fbe00$var$err(0);
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17
        if (resize) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            // bits read, code
            var c = lm[$b9ed3d5ec52fbe00$var$bits16(dat, pos) & lms], sym = c >> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) $b9ed3d5ec52fbe00$var$err(0);
                break;
            }
            if (!c) $b9ed3d5ec52fbe00$var$err(2);
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = $b9ed3d5ec52fbe00$var$fleb[i];
                    add = $b9ed3d5ec52fbe00$var$bits(dat, pos, (1 << b) - 1) + $b9ed3d5ec52fbe00$var$fl[i];
                    pos += b;
                }
                // dist
                var d = dm[$b9ed3d5ec52fbe00$var$bits16(dat, pos) & dms], dsym = d >> 4;
                if (!d) $b9ed3d5ec52fbe00$var$err(3);
                pos += d & 15;
                var dt = $b9ed3d5ec52fbe00$var$fd[dsym];
                if (dsym > 3) {
                    var b = $b9ed3d5ec52fbe00$var$fdeb[dsym];
                    dt += $b9ed3d5ec52fbe00$var$bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) $b9ed3d5ec52fbe00$var$err(0);
                    break;
                }
                if (resize) cbuf(bt + 131072);
                var end = bt + add;
                if (bt < dt) {
                    var shift = dl - dt, dend = Math.min(dt, end);
                    if (shift + bt < 0) $b9ed3d5ec52fbe00$var$err(3);
                    for(; bt < dend; ++bt)buf[bt] = dict[shift + bt];
                }
                for(; bt < end; ++bt)buf[bt] = buf[bt - dt];
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    // don't reallocate for streams or user buffers
    return bt != buf.length && noBuf ? $b9ed3d5ec52fbe00$var$slc(buf, 0, bt) : buf.subarray(0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var $b9ed3d5ec52fbe00$var$wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var $b9ed3d5ec52fbe00$var$wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
    d[o + 2] |= v >> 16;
};
// creates code lengths from a frequency table
var $b9ed3d5ec52fbe00$var$hTree = function(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return {
        t: $b9ed3d5ec52fbe00$var$et,
        l: 0
    };
    if (s == 1) {
        var v = new $b9ed3d5ec52fbe00$var$u8(t[0].s + 1);
        v[t[0].s] = 1;
        return {
            t: v,
            l: 1
        };
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new $b9ed3d5ec52fbe00$var$u16(maxSym + 1);
    // max bits in tree
    var mbt = $b9ed3d5ec52fbe00$var$ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return {
        t: new $b9ed3d5ec52fbe00$var$u8(tr),
        l: mbt
    };
};
// get the max length and assign length codes
var $b9ed3d5ec52fbe00$var$ln = function(n, l, d) {
    return n.s == -1 ? Math.max($b9ed3d5ec52fbe00$var$ln(n.l, l, d + 1), $b9ed3d5ec52fbe00$var$ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var $b9ed3d5ec52fbe00$var$lc = function(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new $b9ed3d5ec52fbe00$var$u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return {
        c: cl.subarray(0, cli),
        n: s
    };
};
// calculate the length of output from tree, code lengths
var $b9ed3d5ec52fbe00$var$clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var $b9ed3d5ec52fbe00$var$wfblk = function(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = $b9ed3d5ec52fbe00$var$shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var $b9ed3d5ec52fbe00$var$wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    $b9ed3d5ec52fbe00$var$wbits(out, p++, final);
    ++lf[256];
    var _a = $b9ed3d5ec52fbe00$var$hTree(lf, 15), dlt = _a.t, mlb = _a.l;
    var _b = $b9ed3d5ec52fbe00$var$hTree(df, 15), ddt = _b.t, mdb = _b.l;
    var _c = $b9ed3d5ec52fbe00$var$lc(dlt), lclt = _c.c, nlc = _c.n;
    var _d = $b9ed3d5ec52fbe00$var$lc(ddt), lcdt = _d.c, ndc = _d.n;
    var lcfreq = new $b9ed3d5ec52fbe00$var$u16(19);
    for(var i = 0; i < lclt.length; ++i)++lcfreq[lclt[i] & 31];
    for(var i = 0; i < lcdt.length; ++i)++lcfreq[lcdt[i] & 31];
    var _e = $b9ed3d5ec52fbe00$var$hTree(lcfreq, 7), lct = _e.t, mlcb = _e.l;
    var nlcc = 19;
    for(; nlcc > 4 && !lct[$b9ed3d5ec52fbe00$var$clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = $b9ed3d5ec52fbe00$var$clen(lf, $b9ed3d5ec52fbe00$var$flt) + $b9ed3d5ec52fbe00$var$clen(df, $b9ed3d5ec52fbe00$var$fdt) + eb;
    var dtlen = $b9ed3d5ec52fbe00$var$clen(lf, dlt) + $b9ed3d5ec52fbe00$var$clen(df, ddt) + eb + 14 + 3 * nlcc + $b9ed3d5ec52fbe00$var$clen(lcfreq, lct) + 2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18];
    if (bs >= 0 && flen <= ftlen && flen <= dtlen) return $b9ed3d5ec52fbe00$var$wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    $b9ed3d5ec52fbe00$var$wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = $b9ed3d5ec52fbe00$var$hMap(dlt, mlb, 0), ll = dlt, dm = $b9ed3d5ec52fbe00$var$hMap(ddt, mdb, 0), dl = ddt;
        var llm = $b9ed3d5ec52fbe00$var$hMap(lct, mlcb, 0);
        $b9ed3d5ec52fbe00$var$wbits(out, p, nlc - 257);
        $b9ed3d5ec52fbe00$var$wbits(out, p + 5, ndc - 1);
        $b9ed3d5ec52fbe00$var$wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)$b9ed3d5ec52fbe00$var$wbits(out, p + 3 * i, lct[$b9ed3d5ec52fbe00$var$clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                $b9ed3d5ec52fbe00$var$wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) $b9ed3d5ec52fbe00$var$wbits(out, p, clct[i] >> 5 & 127), p += clct[i] >> 12;
            }
        }
    } else lm = $b9ed3d5ec52fbe00$var$flm, ll = $b9ed3d5ec52fbe00$var$flt, dm = $b9ed3d5ec52fbe00$var$fdm, dl = $b9ed3d5ec52fbe00$var$fdt;
    for(var i = 0; i < li; ++i){
        var sym = syms[i];
        if (sym > 255) {
            var len = sym >> 18 & 31;
            $b9ed3d5ec52fbe00$var$wbits16(out, p, lm[len + 257]), p += ll[len + 257];
            if (len > 7) $b9ed3d5ec52fbe00$var$wbits(out, p, sym >> 23 & 31), p += $b9ed3d5ec52fbe00$var$fleb[len];
            var dst = sym & 31;
            $b9ed3d5ec52fbe00$var$wbits16(out, p, dm[dst]), p += dl[dst];
            if (dst > 3) $b9ed3d5ec52fbe00$var$wbits16(out, p, sym >> 5 & 8191), p += $b9ed3d5ec52fbe00$var$fdeb[dst];
        } else $b9ed3d5ec52fbe00$var$wbits16(out, p, lm[sym]), p += ll[sym];
    }
    $b9ed3d5ec52fbe00$var$wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var $b9ed3d5ec52fbe00$var$deo = /*#__PURE__*/ new $b9ed3d5ec52fbe00$var$i32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var $b9ed3d5ec52fbe00$var$et = /*#__PURE__*/ new $b9ed3d5ec52fbe00$var$u8(0);
// compresses data into a raw DEFLATE buffer
var $b9ed3d5ec52fbe00$var$dflt = function(dat, lvl, plvl, pre, post, st) {
    var s = st.z || dat.length;
    var o = new $b9ed3d5ec52fbe00$var$u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var lst = st.l;
    var pos = (st.r || 0) & 7;
    if (lvl) {
        if (pos) w[0] = st.r >> 3;
        var opt = $b9ed3d5ec52fbe00$var$deo[lvl - 1];
        var n = opt >> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = st.p || new $b9ed3d5ec52fbe00$var$u16(32768), head = st.h || new $b9ed3d5ec52fbe00$var$u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new $b9ed3d5ec52fbe00$var$i32(25000);
        // length/literal freq   distance freq
        var lf = new $b9ed3d5ec52fbe00$var$u16(288), df = new $b9ed3d5ec52fbe00$var$u16(32);
        //  l/lcnt  exbits  index          l/lind  waitdx          blkpos
        var lc_1 = 0, eb = 0, i = st.i || 0, li = 0, wi = st.w || 0, bs = 0;
        for(; i + 2 < s; ++i){
            // hash value
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && (rem > 423 || !lst)) {
                    pos = $b9ed3d5ec52fbe00$var$wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one int32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | $b9ed3d5ec52fbe00$var$revfl[l] << 18 | $b9ed3d5ec52fbe00$var$revfd[d];
                    var lin = $b9ed3d5ec52fbe00$var$revfl[l] & 31, din = $b9ed3d5ec52fbe00$var$revfd[d] & 31;
                    eb += $b9ed3d5ec52fbe00$var$fleb[lin] + $b9ed3d5ec52fbe00$var$fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        for(i = Math.max(i, wi); i < s; ++i){
            syms[li++] = dat[i];
            ++lf[dat[i]];
        }
        pos = $b9ed3d5ec52fbe00$var$wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        if (!lst) {
            st.r = pos & 7 | w[pos / 8 | 0] << 3;
            // shft(pos) now 1 less if pos & 7 != 0
            pos -= 7;
            st.h = head, st.p = prev, st.i = i, st.w = wi;
        }
    } else {
        for(var i = st.w || 0; i < s + lst; i += 65535){
            // end
            var e = i + 65535;
            if (e >= s) {
                // write final block
                w[pos / 8 | 0] = lst;
                e = s;
            }
            pos = $b9ed3d5ec52fbe00$var$wfblk(w, pos + 1, dat.subarray(i, e));
        }
        st.i = s;
    }
    return $b9ed3d5ec52fbe00$var$slc(o, 0, pre + $b9ed3d5ec52fbe00$var$shft(pos) + post);
};
// CRC32 table
var $b9ed3d5ec52fbe00$var$crct = /*#__PURE__*/ function() {
    var t = new Int32Array(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && -306674912) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var $b9ed3d5ec52fbe00$var$crc = function() {
    var c = -1;
    return {
        p: function(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = $b9ed3d5ec52fbe00$var$crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function() {
            return ~c;
        }
    };
};
// Adler32
var $b9ed3d5ec52fbe00$var$adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length | 0;
            for(var i = 0; i != l;){
                var e = Math.min(i + 2655, l);
                for(; i < e; ++i)m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | (a & 0xFF00) << 8 | (b & 255) << 8 | b >> 8;
        }
    };
};
// deflate with opts
var $b9ed3d5ec52fbe00$var$dopt = function(dat, opt, pre, post, st) {
    if (!st) {
        st = {
            l: 1
        };
        if (opt.dictionary) {
            var dict = opt.dictionary.subarray(-32768);
            var newDat = new $b9ed3d5ec52fbe00$var$u8(dict.length + dat.length);
            newDat.set(dict);
            newDat.set(dat, dict.length);
            dat = newDat;
            st.w = dict.length;
        }
    }
    return $b9ed3d5ec52fbe00$var$dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 12 + opt.mem, pre, post, st);
};
// Walmart object spread
var $b9ed3d5ec52fbe00$var$mrg = function(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var $b9ed3d5ec52fbe00$var$wcln = function(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/\s+/g, '').split(',');
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return fnStr;
};
var $b9ed3d5ec52fbe00$var$ch = [];
// clone bufs
var $b9ed3d5ec52fbe00$var$cbfs = function(v) {
    var tl = [];
    for(var k in v)if (v[k].buffer) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var $b9ed3d5ec52fbe00$var$wrkr = function(fns, init, id, cb) {
    if (!$b9ed3d5ec52fbe00$var$ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)fnStr = $b9ed3d5ec52fbe00$var$wcln(fns[i], fnStr, td_1);
        $b9ed3d5ec52fbe00$var$ch[id] = {
            c: $b9ed3d5ec52fbe00$var$wcln(fns[m], fnStr, td_1),
            e: td_1
        };
    }
    var td = $b9ed3d5ec52fbe00$var$mrg({}, $b9ed3d5ec52fbe00$var$ch[id].e);
    return $b9ed3d5ec52fbe00$var$wk($b9ed3d5ec52fbe00$var$ch[id].c + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, $b9ed3d5ec52fbe00$var$cbfs(td), cb);
};
// base async inflate fn
var $b9ed3d5ec52fbe00$var$bInflt = function() {
    return [
        $b9ed3d5ec52fbe00$var$u8,
        $b9ed3d5ec52fbe00$var$u16,
        $b9ed3d5ec52fbe00$var$i32,
        $b9ed3d5ec52fbe00$var$fleb,
        $b9ed3d5ec52fbe00$var$fdeb,
        $b9ed3d5ec52fbe00$var$clim,
        $b9ed3d5ec52fbe00$var$fl,
        $b9ed3d5ec52fbe00$var$fd,
        $b9ed3d5ec52fbe00$var$flrm,
        $b9ed3d5ec52fbe00$var$fdrm,
        $b9ed3d5ec52fbe00$var$rev,
        $b9ed3d5ec52fbe00$var$ec,
        $b9ed3d5ec52fbe00$var$hMap,
        $b9ed3d5ec52fbe00$var$max,
        $b9ed3d5ec52fbe00$var$bits,
        $b9ed3d5ec52fbe00$var$bits16,
        $b9ed3d5ec52fbe00$var$shft,
        $b9ed3d5ec52fbe00$var$slc,
        $b9ed3d5ec52fbe00$var$err,
        $b9ed3d5ec52fbe00$var$inflt,
        $b9ed3d5ec52fbe00$export$90366d8b308ba94a,
        $b9ed3d5ec52fbe00$var$pbf,
        $b9ed3d5ec52fbe00$var$gopt
    ];
};
var $b9ed3d5ec52fbe00$var$bDflt = function() {
    return [
        $b9ed3d5ec52fbe00$var$u8,
        $b9ed3d5ec52fbe00$var$u16,
        $b9ed3d5ec52fbe00$var$i32,
        $b9ed3d5ec52fbe00$var$fleb,
        $b9ed3d5ec52fbe00$var$fdeb,
        $b9ed3d5ec52fbe00$var$clim,
        $b9ed3d5ec52fbe00$var$revfl,
        $b9ed3d5ec52fbe00$var$revfd,
        $b9ed3d5ec52fbe00$var$flm,
        $b9ed3d5ec52fbe00$var$flt,
        $b9ed3d5ec52fbe00$var$fdm,
        $b9ed3d5ec52fbe00$var$fdt,
        $b9ed3d5ec52fbe00$var$rev,
        $b9ed3d5ec52fbe00$var$deo,
        $b9ed3d5ec52fbe00$var$et,
        $b9ed3d5ec52fbe00$var$hMap,
        $b9ed3d5ec52fbe00$var$wbits,
        $b9ed3d5ec52fbe00$var$wbits16,
        $b9ed3d5ec52fbe00$var$hTree,
        $b9ed3d5ec52fbe00$var$ln,
        $b9ed3d5ec52fbe00$var$lc,
        $b9ed3d5ec52fbe00$var$clen,
        $b9ed3d5ec52fbe00$var$wfblk,
        $b9ed3d5ec52fbe00$var$wblk,
        $b9ed3d5ec52fbe00$var$shft,
        $b9ed3d5ec52fbe00$var$slc,
        $b9ed3d5ec52fbe00$var$dflt,
        $b9ed3d5ec52fbe00$var$dopt,
        $b9ed3d5ec52fbe00$export$21533ff51b8a0b4a,
        $b9ed3d5ec52fbe00$var$pbf
    ];
};
// gzip extra
var $b9ed3d5ec52fbe00$var$gze = function() {
    return [
        $b9ed3d5ec52fbe00$var$gzh,
        $b9ed3d5ec52fbe00$var$gzhl,
        $b9ed3d5ec52fbe00$var$wbytes,
        $b9ed3d5ec52fbe00$var$crc,
        $b9ed3d5ec52fbe00$var$crct
    ];
};
// gunzip extra
var $b9ed3d5ec52fbe00$var$guze = function() {
    return [
        $b9ed3d5ec52fbe00$var$gzs,
        $b9ed3d5ec52fbe00$var$gzl
    ];
};
// zlib extra
var $b9ed3d5ec52fbe00$var$zle = function() {
    return [
        $b9ed3d5ec52fbe00$var$zlh,
        $b9ed3d5ec52fbe00$var$wbytes,
        $b9ed3d5ec52fbe00$var$adler
    ];
};
// unzlib extra
var $b9ed3d5ec52fbe00$var$zule = function() {
    return [
        $b9ed3d5ec52fbe00$var$zls
    ];
};
// post buf
var $b9ed3d5ec52fbe00$var$pbf = function(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get opts
var $b9ed3d5ec52fbe00$var$gopt = function(o) {
    return o && {
        out: o.size && new $b9ed3d5ec52fbe00$var$u8(o.size),
        dictionary: o.dictionary
    };
};
// async helper
var $b9ed3d5ec52fbe00$var$cbify = function(dat, opts, fns, init, id, cb) {
    var w = $b9ed3d5ec52fbe00$var$wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([
        dat,
        opts
    ], opts.consume ? [
        dat.buffer
    ] : []);
    return function() {
        w.terminate();
    };
};
// auto stream
var $b9ed3d5ec52fbe00$var$astrm = function(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        return strm.push(ev.data[0], ev.data[1]);
    };
};
// async stream attach
var $b9ed3d5ec52fbe00$var$astrmify = function(fns, strm, opts, init, id, ext) {
    var t;
    var w = $b9ed3d5ec52fbe00$var$wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else if (!Array.isArray(dat)) ext(dat);
        else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.push = function(d, f) {
        if (!strm.ondata) $b9ed3d5ec52fbe00$var$err(5);
        if (t) strm.ondata($b9ed3d5ec52fbe00$var$err(4, 0, 1), null, !!f);
        w.postMessage([
            d,
            t = f
        ], [
            d.buffer
        ]);
    };
    strm.terminate = function() {
        w.terminate();
    };
};
// read 2 bytes
var $b9ed3d5ec52fbe00$var$b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var $b9ed3d5ec52fbe00$var$b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
var $b9ed3d5ec52fbe00$var$b8 = function(d, b) {
    return $b9ed3d5ec52fbe00$var$b4(d, b) + $b9ed3d5ec52fbe00$var$b4(d, b + 4) * 4294967296;
};
// write bytes
var $b9ed3d5ec52fbe00$var$wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var $b9ed3d5ec52fbe00$var$gzh = function(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) $b9ed3d5ec52fbe00$var$wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var $b9ed3d5ec52fbe00$var$gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) $b9ed3d5ec52fbe00$var$err(6, 'invalid gzip data');
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += (d[10] | d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var $b9ed3d5ec52fbe00$var$gzl = function(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var $b9ed3d5ec52fbe00$var$gzhl = function(o) {
    return 10 + (o.filename ? o.filename.length + 1 : 0);
};
// zlib header
var $b9ed3d5ec52fbe00$var$zlh = function(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (o.dictionary && 32);
    c[1] |= 31 - (c[0] << 8 | c[1]) % 31;
    if (o.dictionary) {
        var h = $b9ed3d5ec52fbe00$var$adler();
        h.p(o.dictionary);
        $b9ed3d5ec52fbe00$var$wbytes(c, 2, h.d());
    }
};
// zlib start
var $b9ed3d5ec52fbe00$var$zls = function(d, dict) {
    if ((d[0] & 15) != 8 || d[0] >> 4 > 7 || (d[0] << 8 | d[1]) % 31) $b9ed3d5ec52fbe00$var$err(6, 'invalid zlib data');
    if ((d[1] >> 5 & 1) == +!dict) $b9ed3d5ec52fbe00$var$err(6, 'invalid zlib data: ' + (d[1] & 32 ? 'need' : 'unexpected') + ' dictionary');
    return (d[1] >> 3 & 4) + 2;
};
function $b9ed3d5ec52fbe00$var$StrmOpt(opts, cb) {
    if (typeof opts == 'function') cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
/**
 * Streaming DEFLATE compression
 */ var $b9ed3d5ec52fbe00$export$ae157b6234afe138 = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
        this.s = {
            l: 0,
            i: 32768,
            w: 32768,
            z: 32768
        };
        // Buffer length must always be 0 mod 32768 for index calculations to be correct when modifying head and prev
        // 98304 = 32768 (lookback) + 65536 (common chunk size)
        this.b = new $b9ed3d5ec52fbe00$var$u8(98304);
        if (this.o.dictionary) {
            var dict = this.o.dictionary.subarray(-32768);
            this.b.set(dict, 32768 - dict.length);
            this.s.i = 32768 - dict.length;
        }
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata($b9ed3d5ec52fbe00$var$dopt(c, this.o, 0, 0, this.s), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (!this.ondata) $b9ed3d5ec52fbe00$var$err(5);
        if (this.s.l) $b9ed3d5ec52fbe00$var$err(4);
        var endLen = chunk.length + this.s.z;
        if (endLen > this.b.length) {
            if (endLen > 2 * this.b.length - 32768) {
                var newBuf = new $b9ed3d5ec52fbe00$var$u8(endLen & -32768);
                newBuf.set(this.b.subarray(0, this.s.z));
                this.b = newBuf;
            }
            var split = this.b.length - this.s.z;
            if (split) {
                this.b.set(chunk.subarray(0, split), this.s.z);
                this.s.z = this.b.length;
                this.p(this.b, false);
            }
            this.b.set(this.b.subarray(-32768));
            this.b.set(chunk.subarray(split), 32768);
            this.s.z = chunk.length - split + 32768;
            this.s.i = 32766, this.s.w = 32768;
        } else {
            this.b.set(chunk, this.s.z);
            this.s.z += chunk.length;
        }
        this.s.l = final & 1;
        if (this.s.z > this.s.w + 8191 || final) {
            this.p(this.b, final || false);
            this.s.w = this.s.i, this.s.i -= 2;
        }
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var $b9ed3d5ec52fbe00$export$84e526fabcba03e3 = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        $b9ed3d5ec52fbe00$var$astrmify([
            $b9ed3d5ec52fbe00$var$bDflt,
            function() {
                return [
                    $b9ed3d5ec52fbe00$var$astrm,
                    $b9ed3d5ec52fbe00$export$ae157b6234afe138
                ];
            }
        ], this, $b9ed3d5ec52fbe00$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $b9ed3d5ec52fbe00$export$ae157b6234afe138(ev.data);
            onmessage = $b9ed3d5ec52fbe00$var$astrm(strm);
        }, 6);
    }
    return AsyncDeflate;
}();
function $b9ed3d5ec52fbe00$export$2316623ecd1285ab(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $b9ed3d5ec52fbe00$var$err(7);
    return $b9ed3d5ec52fbe00$var$cbify(data, opts, [
        $b9ed3d5ec52fbe00$var$bDflt
    ], function(ev) {
        return $b9ed3d5ec52fbe00$var$pbf($b9ed3d5ec52fbe00$export$21533ff51b8a0b4a(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function $b9ed3d5ec52fbe00$export$21533ff51b8a0b4a(data, opts) {
    return $b9ed3d5ec52fbe00$var$dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var $b9ed3d5ec52fbe00$export$d1de70a877d6e43c = /*#__PURE__*/ function() {
    function Inflate(opts, cb) {
        // no StrmOpt here to avoid adding to workerizer
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        var dict = opts && opts.dictionary && opts.dictionary.subarray(-32768);
        this.s = {
            i: 0,
            b: dict ? dict.length : 0
        };
        this.o = new $b9ed3d5ec52fbe00$var$u8(32768);
        this.p = new $b9ed3d5ec52fbe00$var$u8(0);
        if (dict) this.o.set(dict);
    }
    Inflate.prototype.e = function(c) {
        if (!this.ondata) $b9ed3d5ec52fbe00$var$err(5);
        if (this.d) $b9ed3d5ec52fbe00$var$err(4);
        if (!this.p.length) this.p = c;
        else if (c.length) {
            var n = new $b9ed3d5ec52fbe00$var$u8(this.p.length + c.length);
            n.set(this.p), n.set(c, this.p.length), this.p = n;
        }
    };
    Inflate.prototype.c = function(final) {
        this.s.i = +(this.d = final || false);
        var bts = this.s.b;
        var dt = $b9ed3d5ec52fbe00$var$inflt(this.p, this.s, this.o);
        this.ondata($b9ed3d5ec52fbe00$var$slc(dt, bts, this.s.b), this.d);
        this.o = $b9ed3d5ec52fbe00$var$slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = $b9ed3d5ec52fbe00$var$slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var $b9ed3d5ec52fbe00$export$fff8358d6dbaa9cc = /*#__PURE__*/ function() {
    function AsyncInflate(opts, cb) {
        $b9ed3d5ec52fbe00$var$astrmify([
            $b9ed3d5ec52fbe00$var$bInflt,
            function() {
                return [
                    $b9ed3d5ec52fbe00$var$astrm,
                    $b9ed3d5ec52fbe00$export$d1de70a877d6e43c
                ];
            }
        ], this, $b9ed3d5ec52fbe00$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $b9ed3d5ec52fbe00$export$d1de70a877d6e43c(ev.data);
            onmessage = $b9ed3d5ec52fbe00$var$astrm(strm);
        }, 7);
    }
    return AsyncInflate;
}();
function $b9ed3d5ec52fbe00$export$cae1ce83fe4a1782(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $b9ed3d5ec52fbe00$var$err(7);
    return $b9ed3d5ec52fbe00$var$cbify(data, opts, [
        $b9ed3d5ec52fbe00$var$bInflt
    ], function(ev) {
        return $b9ed3d5ec52fbe00$var$pbf($b9ed3d5ec52fbe00$export$90366d8b308ba94a(ev.data[0], $b9ed3d5ec52fbe00$var$gopt(ev.data[1])));
    }, 1, cb);
}
function $b9ed3d5ec52fbe00$export$90366d8b308ba94a(data, opts) {
    return $b9ed3d5ec52fbe00$var$inflt(data, {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var $b9ed3d5ec52fbe00$export$8e4b66d280bf8342 = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = $b9ed3d5ec52fbe00$var$crc();
        this.l = 0;
        this.v = 1;
        $b9ed3d5ec52fbe00$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        this.l += chunk.length;
        $b9ed3d5ec52fbe00$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        var raw = $b9ed3d5ec52fbe00$var$dopt(c, this.o, this.v && $b9ed3d5ec52fbe00$var$gzhl(this.o), f && 8, this.s);
        if (this.v) $b9ed3d5ec52fbe00$var$gzh(raw, this.o), this.v = 0;
        if (f) $b9ed3d5ec52fbe00$var$wbytes(raw, raw.length - 8, this.c.d()), $b9ed3d5ec52fbe00$var$wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var $b9ed3d5ec52fbe00$export$b4c75ae96cdf708b = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        $b9ed3d5ec52fbe00$var$astrmify([
            $b9ed3d5ec52fbe00$var$bDflt,
            $b9ed3d5ec52fbe00$var$gze,
            function() {
                return [
                    $b9ed3d5ec52fbe00$var$astrm,
                    $b9ed3d5ec52fbe00$export$ae157b6234afe138,
                    $b9ed3d5ec52fbe00$export$8e4b66d280bf8342
                ];
            }
        ], this, $b9ed3d5ec52fbe00$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $b9ed3d5ec52fbe00$export$8e4b66d280bf8342(ev.data);
            onmessage = $b9ed3d5ec52fbe00$var$astrm(strm);
        }, 8);
    }
    return AsyncGzip;
}();
function $b9ed3d5ec52fbe00$export$69f0ea7cf3a331a8(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $b9ed3d5ec52fbe00$var$err(7);
    return $b9ed3d5ec52fbe00$var$cbify(data, opts, [
        $b9ed3d5ec52fbe00$var$bDflt,
        $b9ed3d5ec52fbe00$var$gze,
        function() {
            return [
                $b9ed3d5ec52fbe00$export$3d616c3fb3e15483
            ];
        }
    ], function(ev) {
        return $b9ed3d5ec52fbe00$var$pbf($b9ed3d5ec52fbe00$export$3d616c3fb3e15483(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function $b9ed3d5ec52fbe00$export$3d616c3fb3e15483(data, opts) {
    if (!opts) opts = {};
    var c = $b9ed3d5ec52fbe00$var$crc(), l = data.length;
    c.p(data);
    var d = $b9ed3d5ec52fbe00$var$dopt(data, opts, $b9ed3d5ec52fbe00$var$gzhl(opts), 8), s = d.length;
    return $b9ed3d5ec52fbe00$var$gzh(d, opts), $b9ed3d5ec52fbe00$var$wbytes(d, s - 8, c.d()), $b9ed3d5ec52fbe00$var$wbytes(d, s - 4, l), d;
}
/**
 * Streaming single or multi-member GZIP decompression
 */ var $b9ed3d5ec52fbe00$export$4cb607de6db70415 = /*#__PURE__*/ function() {
    function Gunzip(opts, cb) {
        this.v = 1;
        this.r = 0;
        $b9ed3d5ec52fbe00$export$d1de70a877d6e43c.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        $b9ed3d5ec52fbe00$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        this.r += chunk.length;
        if (this.v) {
            var p = this.p.subarray(this.v - 1);
            var s = p.length > 3 ? $b9ed3d5ec52fbe00$var$gzs(p) : 4;
            if (s > p.length) {
                if (!final) return;
            } else if (this.v > 1 && this.onmember) this.onmember(this.r - p.length);
            this.p = p.subarray(s), this.v = 0;
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $b9ed3d5ec52fbe00$export$d1de70a877d6e43c.prototype.c.call(this, final);
        // process concatenated GZIP
        if (this.s.f && !this.s.l) {
            this.v = $b9ed3d5ec52fbe00$var$shft(this.s.p) + 9;
            this.s = {
                i: 0
            };
            this.o = new $b9ed3d5ec52fbe00$var$u8(0);
            if (this.p.length) this.push(new $b9ed3d5ec52fbe00$var$u8(0), final);
        }
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming single or multi-member GZIP decompression
 */ var $b9ed3d5ec52fbe00$export$d5adcdd968132151 = /*#__PURE__*/ function() {
    function AsyncGunzip(opts, cb) {
        var _this_1 = this;
        $b9ed3d5ec52fbe00$var$astrmify([
            $b9ed3d5ec52fbe00$var$bInflt,
            $b9ed3d5ec52fbe00$var$guze,
            function() {
                return [
                    $b9ed3d5ec52fbe00$var$astrm,
                    $b9ed3d5ec52fbe00$export$d1de70a877d6e43c,
                    $b9ed3d5ec52fbe00$export$4cb607de6db70415
                ];
            }
        ], this, $b9ed3d5ec52fbe00$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $b9ed3d5ec52fbe00$export$4cb607de6db70415(ev.data);
            strm.onmember = function(offset) {
                return postMessage(offset);
            };
            onmessage = $b9ed3d5ec52fbe00$var$astrm(strm);
        }, 9, function(offset) {
            return _this_1.onmember && _this_1.onmember(offset);
        });
    }
    return AsyncGunzip;
}();
function $b9ed3d5ec52fbe00$export$b6df3e950734d697(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $b9ed3d5ec52fbe00$var$err(7);
    return $b9ed3d5ec52fbe00$var$cbify(data, opts, [
        $b9ed3d5ec52fbe00$var$bInflt,
        $b9ed3d5ec52fbe00$var$guze,
        function() {
            return [
                $b9ed3d5ec52fbe00$export$c80456f7aaba691c
            ];
        }
    ], function(ev) {
        return $b9ed3d5ec52fbe00$var$pbf($b9ed3d5ec52fbe00$export$c80456f7aaba691c(ev.data[0], ev.data[1]));
    }, 3, cb);
}
function $b9ed3d5ec52fbe00$export$c80456f7aaba691c(data, opts) {
    var st = $b9ed3d5ec52fbe00$var$gzs(data);
    if (st + 8 > data.length) $b9ed3d5ec52fbe00$var$err(6, 'invalid gzip data');
    return $b9ed3d5ec52fbe00$var$inflt(data.subarray(st, -8), {
        i: 2
    }, opts && opts.out || new $b9ed3d5ec52fbe00$var$u8($b9ed3d5ec52fbe00$var$gzl(data)), opts && opts.dictionary);
}
/**
 * Streaming Zlib compression
 */ var $b9ed3d5ec52fbe00$export$4187ccf2467013b9 = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = $b9ed3d5ec52fbe00$var$adler();
        this.v = 1;
        $b9ed3d5ec52fbe00$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        $b9ed3d5ec52fbe00$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        var raw = $b9ed3d5ec52fbe00$var$dopt(c, this.o, this.v && (this.o.dictionary ? 6 : 2), f && 4, this.s);
        if (this.v) $b9ed3d5ec52fbe00$var$zlh(raw, this.o), this.v = 0;
        if (f) $b9ed3d5ec52fbe00$var$wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var $b9ed3d5ec52fbe00$export$bedbe3a2c2136490 = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        $b9ed3d5ec52fbe00$var$astrmify([
            $b9ed3d5ec52fbe00$var$bDflt,
            $b9ed3d5ec52fbe00$var$zle,
            function() {
                return [
                    $b9ed3d5ec52fbe00$var$astrm,
                    $b9ed3d5ec52fbe00$export$ae157b6234afe138,
                    $b9ed3d5ec52fbe00$export$4187ccf2467013b9
                ];
            }
        ], this, $b9ed3d5ec52fbe00$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $b9ed3d5ec52fbe00$export$4187ccf2467013b9(ev.data);
            onmessage = $b9ed3d5ec52fbe00$var$astrm(strm);
        }, 10);
    }
    return AsyncZlib;
}();
function $b9ed3d5ec52fbe00$export$925212de7058410b(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $b9ed3d5ec52fbe00$var$err(7);
    return $b9ed3d5ec52fbe00$var$cbify(data, opts, [
        $b9ed3d5ec52fbe00$var$bDflt,
        $b9ed3d5ec52fbe00$var$zle,
        function() {
            return [
                $b9ed3d5ec52fbe00$export$f87121a6d50aff25
            ];
        }
    ], function(ev) {
        return $b9ed3d5ec52fbe00$var$pbf($b9ed3d5ec52fbe00$export$f87121a6d50aff25(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function $b9ed3d5ec52fbe00$export$f87121a6d50aff25(data, opts) {
    if (!opts) opts = {};
    var a = $b9ed3d5ec52fbe00$var$adler();
    a.p(data);
    var d = $b9ed3d5ec52fbe00$var$dopt(data, opts, opts.dictionary ? 6 : 2, 4);
    return $b9ed3d5ec52fbe00$var$zlh(d, opts), $b9ed3d5ec52fbe00$var$wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var $b9ed3d5ec52fbe00$export$af2424f875ff1b17 = /*#__PURE__*/ function() {
    function Unzlib(opts, cb) {
        $b9ed3d5ec52fbe00$export$d1de70a877d6e43c.call(this, opts, cb);
        this.v = opts && opts.dictionary ? 2 : 1;
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        $b9ed3d5ec52fbe00$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 6 && !final) return;
            this.p = this.p.subarray($b9ed3d5ec52fbe00$var$zls(this.p, this.v - 1)), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) $b9ed3d5ec52fbe00$var$err(6, 'invalid zlib data');
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $b9ed3d5ec52fbe00$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var $b9ed3d5ec52fbe00$export$cf6668790220dcad = /*#__PURE__*/ function() {
    function AsyncUnzlib(opts, cb) {
        $b9ed3d5ec52fbe00$var$astrmify([
            $b9ed3d5ec52fbe00$var$bInflt,
            $b9ed3d5ec52fbe00$var$zule,
            function() {
                return [
                    $b9ed3d5ec52fbe00$var$astrm,
                    $b9ed3d5ec52fbe00$export$d1de70a877d6e43c,
                    $b9ed3d5ec52fbe00$export$af2424f875ff1b17
                ];
            }
        ], this, $b9ed3d5ec52fbe00$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $b9ed3d5ec52fbe00$export$af2424f875ff1b17(ev.data);
            onmessage = $b9ed3d5ec52fbe00$var$astrm(strm);
        }, 11);
    }
    return AsyncUnzlib;
}();
function $b9ed3d5ec52fbe00$export$ca7cbb494e731274(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $b9ed3d5ec52fbe00$var$err(7);
    return $b9ed3d5ec52fbe00$var$cbify(data, opts, [
        $b9ed3d5ec52fbe00$var$bInflt,
        $b9ed3d5ec52fbe00$var$zule,
        function() {
            return [
                $b9ed3d5ec52fbe00$export$9ec8134f0f1b9fc6
            ];
        }
    ], function(ev) {
        return $b9ed3d5ec52fbe00$var$pbf($b9ed3d5ec52fbe00$export$9ec8134f0f1b9fc6(ev.data[0], $b9ed3d5ec52fbe00$var$gopt(ev.data[1])));
    }, 5, cb);
}
function $b9ed3d5ec52fbe00$export$9ec8134f0f1b9fc6(data, opts) {
    return $b9ed3d5ec52fbe00$var$inflt(data.subarray($b9ed3d5ec52fbe00$var$zls(data, opts && opts.dictionary), -4), {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $b9ed3d5ec52fbe00$export$578fe199ef655b76 = /*#__PURE__*/ function() {
    function Decompress(opts, cb) {
        this.G = $b9ed3d5ec52fbe00$export$4cb607de6db70415;
        this.I = $b9ed3d5ec52fbe00$export$d1de70a877d6e43c;
        this.Z = $b9ed3d5ec52fbe00$export$af2424f875ff1b17;
        this.o = $b9ed3d5ec52fbe00$var$StrmOpt.call(this, opts, cb) || {};
    }
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) $b9ed3d5ec52fbe00$var$err(5);
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new $b9ed3d5ec52fbe00$var$u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                var _this_2 = this;
                // enables reuse of this method by AsyncDecompress
                var cb = function() {
                    _this_2.ondata.apply(_this_2, arguments);
                };
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(this.o, cb) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(this.o, cb) : new this.Z(this.o, cb);
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $b9ed3d5ec52fbe00$export$ae2c1d81988d4b43 = /*#__PURE__*/ function() {
    function AsyncDecompress(opts, cb) {
        this.G = $b9ed3d5ec52fbe00$export$d5adcdd968132151;
        this.I = $b9ed3d5ec52fbe00$export$fff8358d6dbaa9cc;
        this.Z = $b9ed3d5ec52fbe00$export$cf6668790220dcad;
        $b9ed3d5ec52fbe00$export$578fe199ef655b76.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        $b9ed3d5ec52fbe00$export$578fe199ef655b76.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function $b9ed3d5ec52fbe00$export$678d868aab8fb3c7(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $b9ed3d5ec52fbe00$var$err(7);
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $b9ed3d5ec52fbe00$export$b6df3e950734d697(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $b9ed3d5ec52fbe00$export$cae1ce83fe4a1782(data, opts, cb) : $b9ed3d5ec52fbe00$export$ca7cbb494e731274(data, opts, cb);
}
function $b9ed3d5ec52fbe00$export$c4bdbbbc9a4faabe(data, opts) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $b9ed3d5ec52fbe00$export$c80456f7aaba691c(data, opts) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $b9ed3d5ec52fbe00$export$90366d8b308ba94a(data, opts) : $b9ed3d5ec52fbe00$export$9ec8134f0f1b9fc6(data, opts);
}
// flatten a directory structure
var $b9ed3d5ec52fbe00$var$fltn = function(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k, op = o;
        if (Array.isArray(val)) op = $b9ed3d5ec52fbe00$var$mrg(o, val[1]), val = val[0];
        if (val instanceof $b9ed3d5ec52fbe00$var$u8) t[n] = [
            val,
            op
        ];
        else {
            t[n += '/'] = [
                new $b9ed3d5ec52fbe00$var$u8(0),
                op
            ];
            $b9ed3d5ec52fbe00$var$fltn(val, n, t, o);
        }
    }
};
// text encoder
var $b9ed3d5ec52fbe00$var$te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
// text decoder
var $b9ed3d5ec52fbe00$var$td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var $b9ed3d5ec52fbe00$var$tds = 0;
try {
    $b9ed3d5ec52fbe00$var$td.decode($b9ed3d5ec52fbe00$var$et, {
        stream: true
    });
    $b9ed3d5ec52fbe00$var$tds = 1;
} catch (e) {}
// decode UTF8
var $b9ed3d5ec52fbe00$var$dutf8 = function(d) {
    for(var r = '', i = 0;;){
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return {
            s: r,
            r: $b9ed3d5ec52fbe00$var$slc(d, i - 1)
        };
        if (!eb) r += String.fromCharCode(c);
        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */ var $b9ed3d5ec52fbe00$export$ba46860a31c72e94 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
        this.ondata = cb;
        if ($b9ed3d5ec52fbe00$var$tds) this.t = new TextDecoder();
        else this.p = $b9ed3d5ec52fbe00$var$et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $b9ed3d5ec52fbe00$var$err(5);
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, {
                stream: true
            }), final);
            if (final) {
                if (this.t.decode().length) $b9ed3d5ec52fbe00$var$err(8);
                this.t = null;
            }
            return;
        }
        if (!this.p) $b9ed3d5ec52fbe00$var$err(4);
        var dat = new $b9ed3d5ec52fbe00$var$u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = $b9ed3d5ec52fbe00$var$dutf8(dat), s = _a.s, r = _a.r;
        if (final) {
            if (r.length) $b9ed3d5ec52fbe00$var$err(8);
            this.p = null;
        } else this.p = r;
        this.ondata(s, final);
    };
    return DecodeUTF8;
}();
/**
 * Streaming UTF-8 encoding
 */ var $b9ed3d5ec52fbe00$export$283f13d12b1b210e = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $b9ed3d5ec52fbe00$var$err(5);
        if (this.d) $b9ed3d5ec52fbe00$var$err(4);
        this.ondata($b9ed3d5ec52fbe00$export$366b39a6daa8ed7a(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();
function $b9ed3d5ec52fbe00$export$366b39a6daa8ed7a(str, latin1) {
    if (latin1) {
        var ar_1 = new $b9ed3d5ec52fbe00$var$u8(str.length);
        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if ($b9ed3d5ec52fbe00$var$te) return $b9ed3d5ec52fbe00$var$te.encode(str);
    var l = str.length;
    var ar = new $b9ed3d5ec52fbe00$var$u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new $b9ed3d5ec52fbe00$var$u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return $b9ed3d5ec52fbe00$var$slc(ar, 0, ai);
}
function $b9ed3d5ec52fbe00$export$adb211f8cb999894(dat, latin1) {
    if (latin1) {
        var r = '';
        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    } else if ($b9ed3d5ec52fbe00$var$td) return $b9ed3d5ec52fbe00$var$td.decode(dat);
    else {
        var _a = $b9ed3d5ec52fbe00$var$dutf8(dat), s = _a.s, r = _a.r;
        if (r.length) $b9ed3d5ec52fbe00$var$err(8);
        return s;
    }
}
// deflate bit flag
var $b9ed3d5ec52fbe00$var$dbf = function(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var $b9ed3d5ec52fbe00$var$slzh = function(d, b) {
    return b + 30 + $b9ed3d5ec52fbe00$var$b2(d, b + 26) + $b9ed3d5ec52fbe00$var$b2(d, b + 28);
};
// read zip header
var $b9ed3d5ec52fbe00$var$zh = function(d, b, z) {
    var fnl = $b9ed3d5ec52fbe00$var$b2(d, b + 28), fn = $b9ed3d5ec52fbe00$export$adb211f8cb999894(d.subarray(b + 46, b + 46 + fnl), !($b9ed3d5ec52fbe00$var$b2(d, b + 8) & 2048)), es = b + 46 + fnl, bs = $b9ed3d5ec52fbe00$var$b4(d, b + 20);
    var _a = z && bs == 4294967295 ? $b9ed3d5ec52fbe00$var$z64e(d, es) : [
        bs,
        $b9ed3d5ec52fbe00$var$b4(d, b + 24),
        $b9ed3d5ec52fbe00$var$b4(d, b + 42)
    ], sc = _a[0], su = _a[1], off = _a[2];
    return [
        $b9ed3d5ec52fbe00$var$b2(d, b + 10),
        sc,
        su,
        fn,
        es + $b9ed3d5ec52fbe00$var$b2(d, b + 30) + $b9ed3d5ec52fbe00$var$b2(d, b + 32),
        off
    ];
};
// read zip64 extra field
var $b9ed3d5ec52fbe00$var$z64e = function(d, b) {
    for(; $b9ed3d5ec52fbe00$var$b2(d, b) != 1; b += 4 + $b9ed3d5ec52fbe00$var$b2(d, b + 2));
    return [
        $b9ed3d5ec52fbe00$var$b8(d, b + 12),
        $b9ed3d5ec52fbe00$var$b8(d, b + 4),
        $b9ed3d5ec52fbe00$var$b8(d, b + 20)
    ];
};
// extra field length
var $b9ed3d5ec52fbe00$var$exfl = function(ex) {
    var le = 0;
    if (ex) for(var k in ex){
        var l = ex[k].length;
        if (l > 65535) $b9ed3d5ec52fbe00$var$err(9);
        le += l + 4;
    }
    return le;
};
// write zip header
var $b9ed3d5ec52fbe00$var$wzh = function(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = $b9ed3d5ec52fbe00$var$exfl(ex);
    $b9ed3d5ec52fbe00$var$wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c < 0 && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) $b9ed3d5ec52fbe00$var$err(10);
    $b9ed3d5ec52fbe00$var$wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >> 1), b += 4;
    if (c != -1) {
        $b9ed3d5ec52fbe00$var$wbytes(d, b, f.crc);
        $b9ed3d5ec52fbe00$var$wbytes(d, b + 4, c < 0 ? -c - 2 : c);
        $b9ed3d5ec52fbe00$var$wbytes(d, b + 8, f.size);
    }
    $b9ed3d5ec52fbe00$var$wbytes(d, b + 12, fl);
    $b9ed3d5ec52fbe00$var$wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        $b9ed3d5ec52fbe00$var$wbytes(d, b, col);
        $b9ed3d5ec52fbe00$var$wbytes(d, b + 6, f.attrs);
        $b9ed3d5ec52fbe00$var$wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) for(var k in ex){
        var exf = ex[k], l = exf.length;
        $b9ed3d5ec52fbe00$var$wbytes(d, b, +k);
        $b9ed3d5ec52fbe00$var$wbytes(d, b + 2, l);
        d.set(exf, b + 4), b += 4 + l;
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var $b9ed3d5ec52fbe00$var$wzf = function(o, b, c, d, e) {
    $b9ed3d5ec52fbe00$var$wbytes(o, b, 0x6054B50); // skip disk
    $b9ed3d5ec52fbe00$var$wbytes(o, b + 8, c);
    $b9ed3d5ec52fbe00$var$wbytes(o, b + 10, c);
    $b9ed3d5ec52fbe00$var$wbytes(o, b + 12, d);
    $b9ed3d5ec52fbe00$var$wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var $b9ed3d5ec52fbe00$export$2b25194e1767ea06 = /*#__PURE__*/ function() {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = $b9ed3d5ec52fbe00$var$crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
        if (!this.ondata) $b9ed3d5ec52fbe00$var$err(5);
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();
// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var $b9ed3d5ec52fbe00$export$f7e481ca646388b6 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
        var _this_1 = this;
        if (!opts) opts = {};
        $b9ed3d5ec52fbe00$export$2b25194e1767ea06.call(this, filename);
        this.d = new $b9ed3d5ec52fbe00$export$ae157b6234afe138(opts, function(dat, final) {
            _this_1.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = $b9ed3d5ec52fbe00$var$dbf(opts.level);
    }
    ZipDeflate.prototype.process = function(chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
        $b9ed3d5ec52fbe00$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();
/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var $b9ed3d5ec52fbe00$export$ffb5e59e179924b2 = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
        var _this_1 = this;
        if (!opts) opts = {};
        $b9ed3d5ec52fbe00$export$2b25194e1767ea06.call(this, filename);
        this.d = new $b9ed3d5ec52fbe00$export$84e526fabcba03e3(opts, function(err, dat, final) {
            _this_1.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = $b9ed3d5ec52fbe00$var$dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function(chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
        $b9ed3d5ec52fbe00$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();
// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */ var $b9ed3d5ec52fbe00$export$9a4d4a7c32a75d2f = /*#__PURE__*/ function() {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
        var _this_1 = this;
        if (!this.ondata) $b9ed3d5ec52fbe00$var$err(5);
        // finishing or finished
        if (this.d & 2) this.ondata($b9ed3d5ec52fbe00$var$err(4 + (this.d & 1) * 8, 0, 1), null, false);
        else {
            var f = $b9ed3d5ec52fbe00$export$366b39a6daa8ed7a(file.filename), fl_1 = f.length;
            var com = file.comment, o = com && $b9ed3d5ec52fbe00$export$366b39a6daa8ed7a(com);
            var u = fl_1 != file.filename.length || o && com.length != o.length;
            var hl_1 = fl_1 + $b9ed3d5ec52fbe00$var$exfl(file.extra) + 30;
            if (fl_1 > 65535) this.ondata($b9ed3d5ec52fbe00$var$err(11, 0, 1), null, false);
            var header = new $b9ed3d5ec52fbe00$var$u8(hl_1);
            $b9ed3d5ec52fbe00$var$wzh(header, 0, file, f, u, -1);
            var chks_1 = [
                header
            ];
            var pAll_1 = function() {
                for(var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++){
                    var chk = chks_2[_i];
                    _this_1.ondata(null, chk, false);
                }
                chks_1 = [];
            };
            var tr_1 = this.d;
            this.d = 0;
            var ind_1 = this.u.length;
            var uf_1 = $b9ed3d5ec52fbe00$var$mrg(file, {
                f: f,
                u: u,
                o: o,
                t: function() {
                    if (file.terminate) file.terminate();
                },
                r: function() {
                    pAll_1();
                    if (tr_1) {
                        var nxt = _this_1.u[ind_1 + 1];
                        if (nxt) nxt.r();
                        else _this_1.d = 1;
                    }
                    tr_1 = 1;
                }
            });
            var cl_1 = 0;
            file.ondata = function(err, dat, final) {
                if (err) {
                    _this_1.ondata(err, dat, final);
                    _this_1.terminate();
                } else {
                    cl_1 += dat.length;
                    chks_1.push(dat);
                    if (final) {
                        var dd = new $b9ed3d5ec52fbe00$var$u8(16);
                        $b9ed3d5ec52fbe00$var$wbytes(dd, 0, 0x8074B50);
                        $b9ed3d5ec52fbe00$var$wbytes(dd, 4, file.crc);
                        $b9ed3d5ec52fbe00$var$wbytes(dd, 8, cl_1);
                        $b9ed3d5ec52fbe00$var$wbytes(dd, 12, file.size);
                        chks_1.push(dd);
                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                        if (tr_1) uf_1.r();
                        tr_1 = 1;
                    } else if (tr_1) pAll_1();
                }
            };
            this.u.push(uf_1);
        }
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
        var _this_1 = this;
        if (this.d & 2) {
            this.ondata($b9ed3d5ec52fbe00$var$err(4 + (this.d & 1) * 8, 0, 1), null, true);
            return;
        }
        if (this.d) this.e();
        else this.u.push({
            r: function() {
                if (!(_this_1.d & 1)) return;
                _this_1.u.splice(-1, 1);
                _this_1.e();
            },
            t: function() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function() {
        var bt = 0, l = 0, tl = 0;
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            tl += 46 + f.f.length + $b9ed3d5ec52fbe00$var$exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new $b9ed3d5ec52fbe00$var$u8(tl + 22);
        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
            var f = _c[_b];
            $b9ed3d5ec52fbe00$var$wzh(out, bt, f, f.f, f.u, -f.c - 2, l, f.o);
            bt += 46 + f.f.length + $b9ed3d5ec52fbe00$var$exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        $b9ed3d5ec52fbe00$var$wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();
function $b9ed3d5ec52fbe00$export$8901015135f2fb22(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $b9ed3d5ec52fbe00$var$err(7);
    var r = {};
    $b9ed3d5ec52fbe00$var$fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbd = function(a, b) {
        $b9ed3d5ec52fbe00$var$mt(function() {
            cb(a, b);
        });
    };
    $b9ed3d5ec52fbe00$var$mt(function() {
        cbd = cb;
    });
    var cbf = function() {
        var out = new $b9ed3d5ec52fbe00$var$u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                var l = f.c.length;
                $b9ed3d5ec52fbe00$var$wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + $b9ed3d5ec52fbe00$var$exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                $b9ed3d5ec52fbe00$var$wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cbd(e, null);
            }
        }
        $b9ed3d5ec52fbe00$var$wzf(out, o, files.length, cdl, oe);
        cbd(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = $b9ed3d5ec52fbe00$var$crc(), size = file.length;
        c.p(file);
        var f = $b9ed3d5ec52fbe00$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $b9ed3d5ec52fbe00$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $b9ed3d5ec52fbe00$var$exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cbd(e, null);
            } else {
                var l = d.length;
                files[i] = $b9ed3d5ec52fbe00$var$mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft) cbf();
            }
        };
        if (s > 65535) cbl($b9ed3d5ec52fbe00$var$err(11, 0, 1), null);
        if (!compression) cbl(null, file);
        else if (size < 160000) try {
            cbl(null, $b9ed3d5ec52fbe00$export$21533ff51b8a0b4a(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push($b9ed3d5ec52fbe00$export$2316623ecd1285ab(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function $b9ed3d5ec52fbe00$export$eb1654f146d54eb3(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    $b9ed3d5ec52fbe00$var$fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = $b9ed3d5ec52fbe00$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $b9ed3d5ec52fbe00$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $b9ed3d5ec52fbe00$var$exfl(p.extra);
        if (s > 65535) $b9ed3d5ec52fbe00$var$err(11);
        var d = compression ? $b9ed3d5ec52fbe00$export$21533ff51b8a0b4a(file, p) : file, l = d.length;
        var c = $b9ed3d5ec52fbe00$var$crc();
        c.p(file);
        files.push($b9ed3d5ec52fbe00$var$mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new $b9ed3d5ec52fbe00$var$u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        $b9ed3d5ec52fbe00$var$wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + $b9ed3d5ec52fbe00$var$exfl(f.extra);
        out.set(f.c, f.o + badd);
        $b9ed3d5ec52fbe00$var$wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    $b9ed3d5ec52fbe00$var$wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */ var $b9ed3d5ec52fbe00$export$93f81d5bbbb7c6bf = /*#__PURE__*/ function() {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function(data, final) {
        this.ondata(null, data, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();
/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var $b9ed3d5ec52fbe00$export$eb188945cc39e642 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
        var _this_1 = this;
        this.i = new $b9ed3d5ec52fbe00$export$d1de70a877d6e43c(function(dat, final) {
            _this_1.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function(data, final) {
        try {
            this.i.push(data, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var $b9ed3d5ec52fbe00$export$6235d84645dad4f9 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
        var _this_1 = this;
        if (sz < 320000) this.i = new $b9ed3d5ec52fbe00$export$d1de70a877d6e43c(function(dat, final) {
            _this_1.ondata(null, dat, final);
        });
        else {
            this.i = new $b9ed3d5ec52fbe00$export$fff8358d6dbaa9cc(function(err, dat, final) {
                _this_1.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function(data, final) {
        if (this.i.terminate) data = $b9ed3d5ec52fbe00$var$slc(data, 0);
        this.i.push(data, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();
/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var $b9ed3d5ec52fbe00$export$9b7485f84cbaaa56 = /*#__PURE__*/ function() {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: $b9ed3d5ec52fbe00$export$93f81d5bbbb7c6bf
        };
        this.p = $b9ed3d5ec52fbe00$var$et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
        var _this_1 = this;
        if (!this.onfile) $b9ed3d5ec52fbe00$var$err(5);
        if (!this.p) $b9ed3d5ec52fbe00$var$err(4);
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);
            else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length) buf = chunk;
            else if (!chunk.length) buf = this.p;
            else {
                buf = new $b9ed3d5ec52fbe00$var$u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function() {
                var _a;
                var sig = $b9ed3d5ec52fbe00$var$b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = $b9ed3d5ec52fbe00$var$b2(buf, i + 6), cmp_1 = $b9ed3d5ec52fbe00$var$b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = $b9ed3d5ec52fbe00$var$b2(buf, i + 26), es = $b9ed3d5ec52fbe00$var$b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_3 = [];
                        this_1.k.unshift(chks_3);
                        f = 2;
                        var sc_1 = $b9ed3d5ec52fbe00$var$b4(buf, i + 18), su_1 = $b9ed3d5ec52fbe00$var$b4(buf, i + 22);
                        var fn_1 = $b9ed3d5ec52fbe00$export$adb211f8cb999894(buf.subarray(i + 30, i += 30 + fnl), !u);
                        if (sc_1 == 4294967295) _a = dd ? [
                            -2
                        ] : $b9ed3d5ec52fbe00$var$z64e(buf, i), sc_1 = _a[0], su_1 = _a[1];
                        else if (dd) sc_1 = -1;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function() {
                                if (!file_1.ondata) $b9ed3d5ec52fbe00$var$err(5);
                                if (!sc_1) file_1.ondata(null, $b9ed3d5ec52fbe00$var$et, true);
                                else {
                                    var ctr = _this_1.o[cmp_1];
                                    if (!ctr) file_1.ondata($b9ed3d5ec52fbe00$var$err(14, 'unknown compression type ' + cmp_1, 1), null, false);
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function(err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for(var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++){
                                        var dat = chks_4[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this_1.k[0] == chks_3 && _this_1.c) _this_1.d = d_1;
                                    else d_1.push($b9ed3d5ec52fbe00$var$et, true);
                                }
                            },
                            terminate: function() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for(; i < l - 4; ++i){
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = $b9ed3d5ec52fbe00$var$et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - ($b9ed3d5ec52fbe00$var$b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);
                else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) $b9ed3d5ec52fbe00$var$err(13);
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();
var $b9ed3d5ec52fbe00$var$mt = typeof queueMicrotask == 'function' ? queueMicrotask : typeof setTimeout == 'function' ? setTimeout : function(fn) {
    fn();
};
function $b9ed3d5ec52fbe00$export$23c8d3f8757cab88(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $b9ed3d5ec52fbe00$var$err(7);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var cbd = function(a, b) {
        $b9ed3d5ec52fbe00$var$mt(function() {
            cb(a, b);
        });
    };
    $b9ed3d5ec52fbe00$var$mt(function() {
        cbd = cb;
    });
    var e = data.length - 22;
    for(; $b9ed3d5ec52fbe00$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cbd($b9ed3d5ec52fbe00$var$err(13, 0, 1), null);
        return tAll;
    }
    var lft = $b9ed3d5ec52fbe00$var$b2(data, e + 8);
    if (lft) {
        var c = lft;
        var o = $b9ed3d5ec52fbe00$var$b4(data, e + 16);
        var z = o == 4294967295 || c == 65535;
        if (z) {
            var ze = $b9ed3d5ec52fbe00$var$b4(data, e - 12);
            z = $b9ed3d5ec52fbe00$var$b4(data, ze) == 0x6064B50;
            if (z) {
                c = lft = $b9ed3d5ec52fbe00$var$b4(data, ze + 32);
                o = $b9ed3d5ec52fbe00$var$b4(data, ze + 48);
            }
        }
        var fltr = opts && opts.filter;
        var _loop_3 = function(i) {
            var _a = $b9ed3d5ec52fbe00$var$zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $b9ed3d5ec52fbe00$var$slzh(data, off);
            o = no;
            var cbl = function(e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                } else {
                    if (d) files[fn] = d;
                    if (!--lft) cbd(null, files);
                }
            };
            if (!fltr || fltr({
                name: fn,
                size: sc,
                originalSize: su,
                compression: c_1
            })) {
                if (!c_1) cbl(null, $b9ed3d5ec52fbe00$var$slc(data, b, b + sc));
                else if (c_1 == 8) {
                    var infl = data.subarray(b, b + sc);
                    if (sc < 320000) try {
                        cbl(null, $b9ed3d5ec52fbe00$export$90366d8b308ba94a(infl, {
                            out: new $b9ed3d5ec52fbe00$var$u8(su)
                        }));
                    } catch (e) {
                        cbl(e, null);
                    }
                    else term.push($b9ed3d5ec52fbe00$export$cae1ce83fe4a1782(infl, {
                        size: su
                    }, cbl));
                } else cbl($b9ed3d5ec52fbe00$var$err(14, 'unknown compression type ' + c_1, 1), null);
            } else cbl(null, null);
        };
        for(var i = 0; i < c; ++i)_loop_3(i);
    } else cbd(null, {});
    return tAll;
}
function $b9ed3d5ec52fbe00$export$c757709326bb5901(data, opts) {
    var files = {};
    var e = data.length - 22;
    for(; $b9ed3d5ec52fbe00$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) $b9ed3d5ec52fbe00$var$err(13);
    var c = $b9ed3d5ec52fbe00$var$b2(data, e + 8);
    if (!c) return {};
    var o = $b9ed3d5ec52fbe00$var$b4(data, e + 16);
    var z = o == 4294967295 || c == 65535;
    if (z) {
        var ze = $b9ed3d5ec52fbe00$var$b4(data, e - 12);
        z = $b9ed3d5ec52fbe00$var$b4(data, ze) == 0x6064B50;
        if (z) {
            c = $b9ed3d5ec52fbe00$var$b4(data, ze + 32);
            o = $b9ed3d5ec52fbe00$var$b4(data, ze + 48);
        }
    }
    var fltr = opts && opts.filter;
    for(var i = 0; i < c; ++i){
        var _a = $b9ed3d5ec52fbe00$var$zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $b9ed3d5ec52fbe00$var$slzh(data, off);
        o = no;
        if (!fltr || fltr({
            name: fn,
            size: sc,
            originalSize: su,
            compression: c_2
        })) {
            if (!c_2) files[fn] = $b9ed3d5ec52fbe00$var$slc(data, b, b + sc);
            else if (c_2 == 8) files[fn] = $b9ed3d5ec52fbe00$export$90366d8b308ba94a(data.subarray(b, b + sc), {
                out: new $b9ed3d5ec52fbe00$var$u8(su)
            });
            else $b9ed3d5ec52fbe00$var$err(14, 'unknown compression type ' + c_2);
        }
    }
    return files;
}

});



parcelRegister("chSQm", function(module, exports) {
$parcel$export(module.exports, "getBrowserLocale", () => $47ca9c4cd23c6cee$export$563e375d286a76a7);
const $47ca9c4cd23c6cee$export$563e375d286a76a7 = ()=>{
    if (navigator.languages) return navigator.languages[0];
    return navigator.language;
};

});

parcelRegister("b3lfX", function(module, exports) {
$parcel$export(module.exports, "getBrowserTimezone", () => $12a492df847c8eee$export$9b96caef38763092);

var $aoswO = parcelRequire("aoswO");

var $fJehn = parcelRequire("fJehn");

var $cE5ed = parcelRequire("cE5ed");

var $chSQm = parcelRequire("chSQm");

var $5YSQ9 = parcelRequire("5YSQ9");

var $jpNtm = parcelRequire("jpNtm");

var $1bJUR = parcelRequire("1bJUR");

var $b2aYp = parcelRequire("b2aYp");
const $12a492df847c8eee$export$9b96caef38763092 = ()=>{
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

});
parcelRegister("fJehn", function(module, exports) {
$parcel$export(module.exports, "getSrcUrl", () => $cb47a300031e7790$export$6dd3d030a75d6dba);

var $eGOwo = parcelRequire("eGOwo");

var $1JlIp = parcelRequire("1JlIp");
const $cb47a300031e7790$export$6dd3d030a75d6dba = (tunnels, extensionResource, defaultUrl, urlSafeContext)=>{
    const matchTunnel = tunnels.find((tunnel)=>tunnel.resourceKey === extensionResource);
    const platformFeatureFlags = (0, $1JlIp.getPlatformFeatureFlags)();
    const queryParams = new URLSearchParams({
        ...platformFeatureFlags.length > 0 ? {
            platformFeatureFlags: platformFeatureFlags.join(',')
        } : {},
        // when tunnelling, pass hostname into query param to be passed into CSP
        ...matchTunnel ? {
            hostname: window.location.hostname
        } : {},
        ...matchTunnel && (0, $eGOwo.fg)('forge-include-hostname-in-url-path') ? {
            ctx: urlSafeContext
        } : {}
    }).toString();
    const query = queryParams ? `?${queryParams}` : '';
    if (matchTunnel) return `${matchTunnel.tunnelUrl}${query}`;
    return `${defaultUrl}${query}`;
};

});
parcelRegister("1JlIp", function(module, exports) {
$parcel$export(module.exports, "getPlatformFeatureFlags", () => $ab3225341fc4f696$export$bd17c6970f4d989e);

var $eGOwo = parcelRequire("eGOwo");
const $ab3225341fc4f696$export$bd17c6970f4d989e = ()=>{
    const platformFeatureFlags = [];
    // Each feature flag name is required to be an inline string for static analysis
    if ((0, $eGOwo.fg)('platform-visual-refresh-icons')) platformFeatureFlags.push('platform-visual-refresh-icons');
    if ((0, $eGOwo.fg)('platform-component-visual-refresh')) platformFeatureFlags.push('platform-component-visual-refresh');
    // https://switcheroo.atlassian.com/ui/gates/17cdb9ff-f909-4978-8265-2acd26e02102/key/forge-ui-iframe-analytics
    if ((0, $eGOwo.fg)('forge-ui-performance-analytics-provider') || (0, $eGOwo.fg)('forge-ui-iframe-analytics')) platformFeatureFlags.push('forge-ui-iframe-analytics');
    return platformFeatureFlags;
};

});


parcelRegister("cE5ed", function(module, exports) {
$parcel$export(module.exports, "getExtensionEntryPoint", () => $3a6efc473ac7e3d2$export$5dfdba3e408a8d60);
const $3a6efc473ac7e3d2$export$5dfdba3e408a8d60 = (extension, entryPoint)=>{
    const defaultEntryPoint = extension.properties.resource;
    const alternativeEntryPoint = entryPoint && extension.properties[entryPoint]?.resource;
    return alternativeEntryPoint || defaultEntryPoint;
};

});

parcelRegister("5YSQ9", function(module, exports) {
$parcel$export(module.exports, "getResolverContext", () => $28ff1318a5974dfa$export$c34ac5b863279caa);
const $28ff1318a5974dfa$export$c34ac5b863279caa = (coreData, extensionData)=>({
        ...coreData,
        extension: extensionData
    });

});

parcelRegister("jpNtm", function(module, exports) {
$parcel$export(module.exports, "getViewContext", () => $d8451b3ffba949cf$export$20af16720c0f9c71);

var $eGOwo = parcelRequire("eGOwo");
const $d8451b3ffba949cf$export$68ca3577dbf1f96c = (scopes = [], egress = [])=>{
    // Create a map to store egress data by type then loop through the map to populate the external permissions object
    const egressMap = new Map();
    egress.forEach(({ type: type, addresses: addresses })=>{
        egressMap.set(type, addresses);
    });
    // Construct external permissions from the map
    const externalPermissions = {
        fetch: {
            backend: egressMap.get('FETCH_BACKEND_SIDE') ?? [],
            client: egressMap.get('FETCH_CLIENT_SIDE') ?? []
        },
        fonts: egressMap.get('FONTS') ?? [],
        styles: egressMap.get('STYLES') ?? [],
        frames: egressMap.get('FRAMES') ?? [],
        images: egressMap.get('IMAGES') ?? [],
        media: egressMap.get('MEDIA') ?? [],
        scripts: egressMap.get('SCRIPTS') ?? []
    };
    return {
        scopes: scopes,
        external: externalPermissions
    };
};
const $d8451b3ffba949cf$export$20af16720c0f9c71 = ({ resolverContext: resolverContext, accountId: accountId, extension: extension, timezone: timezone, locale: locale, location: location, extensionPayload: extensionPayload, extensionViewData: extensionViewData, theme: theme, surfaceColor: surfaceColor })=>{
    // Combine the static macro extension data with the dynamic extension view data (macro body) into a single macro object
    const macro = {
        ...resolverContext.extension?.macro,
        ...extensionViewData?.macro,
        ...(0, $eGOwo.fg)('platform_move_dynamic_macro_context') ? extensionPayload?.macro : {}
    };
    /* adding hasAccess separately instead of using userAccess as a whole is to avoid appending __typename in the context */ const userAccess = extension.userAccess ?? {
        enabled: false,
        hasAccess: false
    };
    // Construct permissions object from scopes and egress
    const permissions = $d8451b3ffba949cf$export$68ca3577dbf1f96c(extension?.scopes || [], extension?.egress || []);
    return {
        ...resolverContext,
        extension: {
            ...resolverContext.extension,
            ...extensionViewData,
            ...extensionPayload,
            ...Object.keys(macro).length > 0 ? {
                macro: macro
            } : {},
            location: extension.type === 'jira:globalBackgroundScript' && (0, $eGOwo.fg)('ditto_fcf_jira_globalbackgroundscript') ? '' : location
        },
        accountId: accountId,
        license: extension?.license || null,
        timezone: timezone,
        locale: locale,
        theme: theme,
        surfaceColor: surfaceColor,
        userAccess: userAccess,
        permissions: permissions
    };
};

});

parcelRegister("1bJUR", function(module, exports) {
$parcel$export(module.exports, "selectOptimalInvocationResponse", () => $8f1f0ab19ba804d8$export$782f13e8807e97e6);
/**
 * Utilities for JWT token decoding and comparison logic used in shadow invocation feature
 */ 
var $cOZrT = parcelRequire("cOZrT");
function $8f1f0ab19ba804d8$export$96751ef617237d7e(jwt) {
    if (!jwt) return undefined;
    try {
        const payload = jwt.split('.')[1];
        if (!payload) return undefined;
        const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
        const padded = base64.padEnd(base64.length + (4 - base64.length % 4) % 4, '=');
        return JSON.parse(atob(padded));
    } catch (e) {
        return undefined;
    }
}
/**
 * Checks if a value is a plain object (not array, null, or primitive)
 * @param value - The value to check
 * @returns True if the value is a plain object
 */ function $8f1f0ab19ba804d8$var$isPlainObject(value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
}
/**
 * Recursively compares two objects and returns the differences
 * @param shadow - The shadow object to compare
 * @param regular - The regular object to compare
 * @param path - The current path in the object hierarchy
 * @param result - The result object to accumulate differences
 */ function $8f1f0ab19ba804d8$var$visitObjectDifferences(shadow, regular, path, result) {
    const sObj = $8f1f0ab19ba804d8$var$isPlainObject(shadow) ? shadow : {};
    const rObj = $8f1f0ab19ba804d8$var$isPlainObject(regular) ? regular : {};
    const sKeys = new Set(Object.keys(sObj));
    const rKeys = new Set(Object.keys(rObj));
    // Find keys only in shadow
    sKeys.forEach((k)=>{
        if (!rKeys.has(k)) result.onlyInShadow.push([
            ...path,
            k
        ].join('.'));
    });
    // Find keys only in regular
    rKeys.forEach((k)=>{
        if (!sKeys.has(k)) result.onlyInRegular.push([
            ...path,
            k
        ].join('.'));
    });
    // Compare common keys
    sKeys.forEach((k)=>{
        if (!rKeys.has(k)) return;
        const sv = sObj[k];
        const rv = rObj[k];
        if ($8f1f0ab19ba804d8$var$isPlainObject(sv) && $8f1f0ab19ba804d8$var$isPlainObject(rv)) $8f1f0ab19ba804d8$var$visitObjectDifferences(sv, rv, [
            ...path,
            k
        ], result);
        else if (JSON.stringify(sv) !== JSON.stringify(rv)) result.mismatchedValues.push({
            key: [
                ...path,
                k
            ].join('.'),
            shadow: sv,
            regular: rv
        });
    });
}
function $8f1f0ab19ba804d8$export$c88750430cbf4afc(shadowToken, regularToken) {
    const shadow = shadowToken?.context || {};
    const regular = regularToken?.context || {};
    const result = {
        onlyInShadow: [],
        onlyInRegular: [],
        mismatchedValues: []
    };
    $8f1f0ab19ba804d8$var$visitObjectDifferences(shadow, regular, [], result);
    return result;
}
function $8f1f0ab19ba804d8$export$ad8401ab212af28d(differences) {
    const allDifferingKeys = new Set();
    // Add keys that are only in shadow token
    differences.onlyInShadow.forEach((key)=>allDifferingKeys.add(key));
    // Add keys that are only in regular token
    differences.onlyInRegular.forEach((key)=>allDifferingKeys.add(key));
    // Add keys that have mismatched values
    differences.mismatchedValues.forEach((mismatch)=>allDifferingKeys.add(mismatch.key));
    // Return sorted array for consistent output
    return Array.from(allDifferingKeys).sort();
}
function $8f1f0ab19ba804d8$export$6c4ccde2488ac6b8(differences) {
    const keyValues = {};
    // Keys only in shadow token
    differences.onlyInShadow.forEach((key)=>{
        keyValues[key] = {
            shadow: 'present',
            regular: undefined
        };
    });
    // Keys only in regular token
    differences.onlyInRegular.forEach((key)=>{
        keyValues[key] = {
            regular: 'present',
            shadow: undefined
        };
    });
    // Keys with mismatched values
    differences.mismatchedValues.forEach((mismatch)=>{
        keyValues[mismatch.key] = {
            regular: mismatch.regular,
            shadow: mismatch.shadow
        };
    });
    return keyValues;
}
function $8f1f0ab19ba804d8$export$91cd38f87a379a31(shadowToken, regularToken) {
    const shadow = shadowToken || {};
    const regular = regularToken || {};
    const result = {
        onlyInShadow: [],
        onlyInRegular: [],
        mismatchedValues: []
    };
    $8f1f0ab19ba804d8$var$visitObjectDifferences(shadow, regular, [], result);
    return result;
}
function $8f1f0ab19ba804d8$export$ce683f7fc0bd28b1(differences, regularToken) {
    const mismatchesEmpty = differences.mismatchedValues.length === 0;
    const onlyInRegularOk = differences.onlyInRegular.length <= 1;
    if (!mismatchesEmpty || !onlyInRegularOk) return false;
    if (differences.onlyInRegular.length === 1) {
        const onlyKey = differences.onlyInRegular[0];
        // When using context-only paths, this should be 'extension.content.subtype'
        const regularCtx = regularToken?.context || {};
        const regularSubtype = regularCtx?.extension?.content?.subtype;
        return onlyKey === 'extension.content.subtype' && regularSubtype === null;
    }
    // No differences inside context
    return true;
}
function $8f1f0ab19ba804d8$export$86c16fc1ae19506b(differences, useShadow, regularResponse, shadowResponse) {
    const differingKeys = $8f1f0ab19ba804d8$export$ad8401ab212af28d(differences);
    const differingKeysWithValues = $8f1f0ab19ba804d8$export$6c4ccde2488ac6b8(differences);
    const hasDifferences = differingKeys.length > 0;
    return {
        action: 'contextTokenComparison',
        actionSubject: 'forge.ui.invocation',
        source: 'forge.ui.iframe',
        attributes: {
            comparisonResult: hasDifferences ? 'different' : 'same',
            hasDifferences: hasDifferences,
            differenceCount: differingKeys.length,
            differingKeys: differingKeys,
            differingKeysWithValues: differingKeysWithValues,
            onlyInRegularCount: differences.onlyInRegular.length,
            onlyInShadowCount: differences.onlyInShadow.length,
            mismatchedValuesCount: differences.mismatchedValues.length,
            useShadowResponse: useShadow,
            extensionId: regularResponse.extensionId || shadowResponse.extensionId,
            extensionType: regularResponse.extensionType || shadowResponse.extensionType
        }
    };
}
function $8f1f0ab19ba804d8$export$782f13e8807e97e6(regularResponse, shadowResponse, createAnalyticsEvent) {
    if (!shadowResponse || !regularResponse) return regularResponse;
    const decodedTokens = {
        shadow: $8f1f0ab19ba804d8$export$96751ef617237d7e(shadowResponse.contextToken?.jwt),
        regular: $8f1f0ab19ba804d8$export$96751ef617237d7e(regularResponse.contextToken?.jwt)
    };
    // Use context-only comparison for the decision logic (existing behavior)
    const contextDifferences = $8f1f0ab19ba804d8$export$c88750430cbf4afc(decodedTokens.shadow, decodedTokens.regular);
    const useShadow = $8f1f0ab19ba804d8$export$ce683f7fc0bd28b1(contextDifferences, decodedTokens.regular);
    if (createAnalyticsEvent) {
        // Use full token comparison for comprehensive analytics
        const fullDifferences = $8f1f0ab19ba804d8$export$91cd38f87a379a31(decodedTokens.shadow, decodedTokens.regular);
        const analyticsPayload = $8f1f0ab19ba804d8$export$86c16fc1ae19506b(fullDifferences, useShadow, regularResponse, shadowResponse);
        (0, $cOZrT.fireEvent)(createAnalyticsEvent, analyticsPayload);
    }
    return useShadow ? shadowResponse : regularResponse;
}

});
parcelRegister("cOZrT", function(module, exports) {
$parcel$export(module.exports, "fireEvent", () => $de87f302ea4f427b$export$43835e9acf248a15);
$parcel$export(module.exports, "trackBridgeSucceed", () => $de87f302ea4f427b$export$f4ca3aaa7a36404);
$parcel$export(module.exports, "trackBridgeFailed", () => $de87f302ea4f427b$export$5c425ded9b0e7602);
$parcel$export(module.exports, "trackComponentUsageRendered", () => $de87f302ea4f427b$export$d84d2f0ce1c82c0);
$parcel$export(module.exports, "trackRendererRendered", () => $de87f302ea4f427b$export$7e97f0f47f75f097);
$parcel$export(module.exports, "useForgeUiAnalyticsEvent", () => $de87f302ea4f427b$export$4b165c4db6e19dc5);


var $ftN6c = parcelRequire("ftN6c");

var $6yq62 = parcelRequire("6yq62");

var $dHXR3 = parcelRequire("dHXR3");

var $7pA0u = parcelRequire("7pA0u");

var $eGOwo = parcelRequire("eGOwo");

var $hgc8o = parcelRequire("hgc8o");
const $de87f302ea4f427b$export$43835e9acf248a15 = (createAnalyticsEvent, { action: action, actionSubject: actionSubject, source: source, attributes: attributes }, options)=>{
    const { sampleRate: sampleRate, filter: filter } = options ?? {};
    // If a sample rate is provided, we can use it to determine whether to fire the event
    if (sampleRate) {
        const randomValue = Math.random();
        if (randomValue > sampleRate) return; // Don't fire the event
    }
    const event = createAnalyticsEvent({
        eventType: (0, $d6f34b7bd34f6138$export$12346a674644c156),
        data: {
            action: action,
            actionSubject: actionSubject,
            attributes: attributes,
            source: source,
            tags: [
                'forge'
            ]
        }
    });
    if (filter && !filter(event)) return; // Don't fire the event if it doesn't pass the filter
    event.fire((0, $dHXR3.FORGE_UI_ANALYTICS_CHANNEL));
};
// Ideally this should be removed entirely in the future.
// see: https://hello.atlassian.net/wiki/spaces/ECO/pages/5687458412/Why+is+GASv3+Event+Costs+and+Volumes+Climbing+Cost+Saving+Proposal
const $de87f302ea4f427b$var$legacyTrackBridgeSucceed = (createAnalyticsEvent, { source: source, method: method, additionalAttributes: additionalAttributes, forgeEnvironment: forgeEnvironment })=>$de87f302ea4f427b$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'succeeded',
        actionSubject: 'forge.ui.bridge',
        source: source,
        attributes: {
            ...additionalAttributes ?? {},
            method: method,
            forgeEnvironment: forgeEnvironment
        }
    });
const $de87f302ea4f427b$var$optimisedTrackBridgeSucceed = (createAnalyticsEvent, { source: source, method: method, additionalAttributes: additionalAttributes, forgeEnvironment: forgeEnvironment })=>{
    // currently only `navigate` bridge method is used in the product dashboard
    if (method === 'navigate') // send only 10% of the events as sampled data should sufficient to infer the frequence of feature usage.
    $de87f302ea4f427b$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'succeeded',
        actionSubject: 'forge.ui.bridge',
        source: source,
        attributes: {
            ...additionalAttributes ?? {},
            method: method,
            forgeEnvironment: forgeEnvironment
        }
    }, {
        sampleRate: 0.1
    });
};
const $de87f302ea4f427b$var$trackForgeFeatureFlagEvent = (createAnalyticsEvent, { source: source, appType: appType, baseUrl: baseUrl, appId: appId, flagName: flagName, eventType: eventType, success: success, featureFlagEnv: featureFlagEnv, forgeEnvironment: forgeEnvironment })=>{
    $de87f302ea4f427b$export$43835e9acf248a15(createAnalyticsEvent, {
        action: eventType,
        actionSubject: 'forge.ui.feature_flag',
        source: source,
        attributes: {
            appType: appType,
            baseUrl: baseUrl,
            appId: appId,
            flagName: flagName,
            eventType: eventType,
            success: success,
            featureFlagEnv: featureFlagEnv,
            forgeEnvironment: forgeEnvironment
        }
    });
};
const $de87f302ea4f427b$export$f4ca3aaa7a36404 = (createAnalyticsEvent, payload)=>(0, $eGOwo.fg)('forge-ui-event-cost-optimisation') ? $de87f302ea4f427b$var$optimisedTrackBridgeSucceed(createAnalyticsEvent, payload) : $de87f302ea4f427b$var$legacyTrackBridgeSucceed(createAnalyticsEvent, payload);
const $de87f302ea4f427b$export$5c425ded9b0e7602 = (createAnalyticsEvent, { source: source, errorName: errorName, method: method, forgeEnvironment: forgeEnvironment, additionalAttributes: additionalAttributes })=>$de87f302ea4f427b$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'failed',
        actionSubject: 'forge.ui.bridge',
        source: source,
        attributes: {
            ...additionalAttributes ?? {},
            error: errorName,
            method: method,
            forgeEnvironment: forgeEnvironment
        }
    });
const $de87f302ea4f427b$export$d84d2f0ce1c82c0 = (createAnalyticsEvent, { source: source, isLegacyUiKit: isLegacyUiKit, forgeEnvironment: forgeEnvironment, components: components, forgeReactMajorVersion: forgeReactMajorVersion })=>$de87f302ea4f427b$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'rendered',
        actionSubject: 'forge.ui.analytics.component_usage',
        source: source,
        attributes: {
            appType: `UIKit${isLegacyUiKit ? '1' : ''}`,
            forgeEnvironment: forgeEnvironment,
            components: components,
            forgeReactMajorVersion: forgeReactMajorVersion
        }
    });
const $de87f302ea4f427b$export$7e97f0f47f75f097 = (createAnalyticsEvent, { source: source, target: target })=>$de87f302ea4f427b$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'rendered',
        actionSubject: 'forge.ui.renderer',
        source: source,
        attributes: {
            target: target
        }
    });
const $de87f302ea4f427b$var$extensionLoadedEventFilter = (0, $hgc8o.createSingleEventPerAppFilter)();
const $de87f302ea4f427b$var$trackExtensionLoaded = (createAnalyticsEvent, { source: source, forgeEnvironment: forgeEnvironment, renderType: renderType, extensionType: extensionType, isConfiguring: isConfiguring, isInserting: isInserting })=>{
    const options = (0, $eGOwo.fg)('forge-ui-event-cost-optimisation') ? {
        filter: $de87f302ea4f427b$var$extensionLoadedEventFilter
    } : undefined;
    $de87f302ea4f427b$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'loaded',
        actionSubject: 'forge.ui.extension',
        source: source,
        attributes: {
            forgeEnvironment: forgeEnvironment,
            renderType: renderType,
            extensionType: extensionType,
            isConfiguring: isConfiguring,
            isInserting: isInserting
        }
    }, options);
};
const $de87f302ea4f427b$var$trackExtensionRemounted = (createAnalyticsEvent, { source: source, mountCount: mountCount })=>$de87f302ea4f427b$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'remounted',
        actionSubject: 'forge.ui.extension',
        source: source,
        attributes: {
            mountCount: mountCount
        }
    });
const $de87f302ea4f427b$var$trackExtensionResized = (createAnalyticsEvent, { source: source, resizeTotal: resizeTotal, appType: appType, extensionType: extensionType, navigationTimeStart: navigationTimeStart, resizedValues: resizedValues, forgeEnvironment: forgeEnvironment })=>$de87f302ea4f427b$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'resized',
        actionSubject: 'forge.ui.extension',
        source: source,
        attributes: {
            extensionType: extensionType,
            resizeTotal: resizeTotal,
            appType: appType,
            navigationTimeStart: navigationTimeStart,
            resizedValues: resizedValues,
            forgeEnvironment: forgeEnvironment
        }
    });
const $de87f302ea4f427b$var$trackExtensionClicked = (createAnalyticsEvent, { source: source, appType: appType, extensionType: extensionType, forgeEnvironment: forgeEnvironment, baseUrl: baseUrl, componentName: component })=>$de87f302ea4f427b$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'clicked',
        actionSubject: 'forge.ui.extension',
        source: source,
        attributes: {
            extensionType: extensionType,
            appType: appType,
            forgeEnvironment: forgeEnvironment,
            baseUrl: baseUrl,
            component: component
        }
    });
const $de87f302ea4f427b$var$createForgeUiAnalyticsEventTrackers = ({ createAnalyticsEvent: createAnalyticsEvent, source: source })=>{
    return {
        trackComponentUsageRendered: ({ isLegacyUiKit: isLegacyUiKit, forgeEnvironment: forgeEnvironment, components: components, forgeReactMajorVersion: forgeReactMajorVersion })=>$de87f302ea4f427b$export$d84d2f0ce1c82c0(createAnalyticsEvent, {
                source: source,
                isLegacyUiKit: isLegacyUiKit,
                forgeEnvironment: forgeEnvironment,
                components: components,
                forgeReactMajorVersion: forgeReactMajorVersion
            }),
        trackRendererRendered: ({ target: target })=>$de87f302ea4f427b$export$7e97f0f47f75f097(createAnalyticsEvent, {
                source: source,
                target: target
            }),
        trackExtensionLoaded: ({ forgeEnvironment: forgeEnvironment, renderType: renderType, extensionType: extensionType, isConfiguring: isConfiguring, isInserting: isInserting })=>$de87f302ea4f427b$var$trackExtensionLoaded(createAnalyticsEvent, {
                source: source,
                forgeEnvironment: forgeEnvironment,
                renderType: renderType,
                extensionType: extensionType,
                isConfiguring: isConfiguring,
                isInserting: isInserting
            }),
        trackExtensionRemounted: ({ mountCount: mountCount })=>$de87f302ea4f427b$var$trackExtensionRemounted(createAnalyticsEvent, {
                source: source,
                mountCount: mountCount
            }),
        trackBridgeSucceed: ({ method: method, forgeEnvironment: forgeEnvironment })=>$de87f302ea4f427b$export$f4ca3aaa7a36404(createAnalyticsEvent, {
                source: source,
                method: method,
                forgeEnvironment: forgeEnvironment
            }),
        trackBridgeFailed: ({ method: method, errorName: errorName, forgeEnvironment: forgeEnvironment })=>$de87f302ea4f427b$export$5c425ded9b0e7602(createAnalyticsEvent, {
                source: source,
                errorName: errorName,
                method: method,
                forgeEnvironment: forgeEnvironment
            }),
        trackExtensionResized: ({ navigationTimeStart: navigationTimeStart, resizedValues: resizedValues, resizeTotal: resizeTotal, appType: appType, extensionType: extensionType, forgeEnvironment: forgeEnvironment })=>$de87f302ea4f427b$var$trackExtensionResized(createAnalyticsEvent, {
                source: source,
                navigationTimeStart: navigationTimeStart,
                resizeTotal: resizeTotal,
                resizedValues: resizedValues,
                appType: appType,
                extensionType: extensionType,
                forgeEnvironment: forgeEnvironment
            }),
        trackExtensionClicked: ({ extensionType: extensionType, appType: appType, forgeEnvironment: forgeEnvironment, baseUrl: baseUrl, componentName: componentName })=>$de87f302ea4f427b$var$trackExtensionClicked(createAnalyticsEvent, {
                source: source,
                extensionType: extensionType,
                appType: appType,
                forgeEnvironment: forgeEnvironment,
                baseUrl: baseUrl,
                componentName: componentName
            }),
        trackForgeFeatureFlagEvent: ({ appType: appType, baseUrl: baseUrl, appId: appId, flagName: flagName, eventType: eventType, success: success, featureFlagEnv: featureFlagEnv, forgeEnvironment: forgeEnvironment })=>$de87f302ea4f427b$var$trackForgeFeatureFlagEvent(createAnalyticsEvent, {
                source: source,
                appType: appType,
                baseUrl: baseUrl,
                appId: appId,
                flagName: flagName,
                eventType: eventType,
                success: success,
                featureFlagEnv: featureFlagEnv,
                forgeEnvironment: forgeEnvironment
            })
    };
};
const $de87f302ea4f427b$export$4b165c4db6e19dc5 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { page: source } = (0, $6yq62.useMetricsContext)();
    const cachedTrackers = (0, $7pA0u.useMemoOne)(()=>$de87f302ea4f427b$var$createForgeUiAnalyticsEventTrackers({
            createAnalyticsEvent: createAnalyticsEvent,
            source: source
        }), [
        createAnalyticsEvent,
        source
    ]);
    return (0, $eGOwo.fg)('forge-ui-macro-config-update-improvement') ? cachedTrackers : $de87f302ea4f427b$var$createForgeUiAnalyticsEventTrackers({
        createAnalyticsEvent: createAnalyticsEvent,
        source: source
    });
};

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $d6f34b7bd34f6138$export$a1562d08625f5d7e = 'ui';
const $d6f34b7bd34f6138$export$947dac6c72b26f81 = 'track';
const $d6f34b7bd34f6138$export$f1d537d508d2945a = 'screen';
const $d6f34b7bd34f6138$export$12346a674644c156 = 'operational';
const $d6f34b7bd34f6138$export$b055de0e665cb20c = 'unknown';

parcelRegister("6yq62", function(module, exports) {
$parcel$export(module.exports, "MetricsContext", () => $aa276da3ab34ca5d$export$b438ce9ad9530ae5);
$parcel$export(module.exports, "MetricsContextProvider", () => $aa276da3ab34ca5d$export$163ecee29aa3a8f);
$parcel$export(module.exports, "useMetricsContext", () => $aa276da3ab34ca5d$export$dba2dab0d0f39612);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7pA0u = parcelRequire("7pA0u");

var $83IbI = parcelRequire("83IbI");
const $aa276da3ab34ca5d$export$b438ce9ad9530ae5 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    environment: undefined,
    product: '',
    page: ''
});
const $aa276da3ab34ca5d$export$163ecee29aa3a8f = ({ value: value, children: children })=>{
    const envFromContext = (0, $eJOHy.useContext)((0, $83IbI.EnvironmentContext));
    const { product: product, page: page, environment: environment } = value;
    const memoedValue = (0, $7pA0u.useMemoOne)(()=>{
        return {
            environment: environment ?? envFromContext,
            product: product,
            page: page
        };
    }, [
        page,
        environment,
        envFromContext,
        product
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($aa276da3ab34ca5d$export$b438ce9ad9530ae5.Provider, {
        value: memoedValue,
        children: children
    });
};
const $aa276da3ab34ca5d$export$dba2dab0d0f39612 = ()=>{
    return (0, $eJOHy.useContext)($aa276da3ab34ca5d$export$b438ce9ad9530ae5);
};

});

parcelRegister("dHXR3", function(module, exports) {
$parcel$export(module.exports, "FORGE_UI_ANALYTICS_CHANNEL", () => $a6e038c024d9736c$export$d28801614368e543);
$parcel$export(module.exports, "default", () => $a6e038c024d9736c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8QoO2 = parcelRequire("8QoO2");

const $a6e038c024d9736c$export$d28801614368e543 = 'forge-ui';
const $a6e038c024d9736c$export$7329bcdc3edcd90e = (client)=>(event)=>{
        switch(event.eventType){
            case 0, $d6f34b7bd34f6138$export$a1562d08625f5d7e:
                Promise.resolve(client).then((c)=>c.sendUIEvent(event));
                break;
            case 0, $d6f34b7bd34f6138$export$12346a674644c156:
                Promise.resolve(client).then((c)=>c.sendOperationalEvent(event));
                break;
            case 0, $d6f34b7bd34f6138$export$947dac6c72b26f81:
                Promise.resolve(client).then((c)=>c.sendTrackEvent(event));
                break;
            case 0, $d6f34b7bd34f6138$export$f1d537d508d2945a:
                Promise.resolve(client).then((c)=>c.sendScreenEvent(event));
                break;
        }
    };
/** extract the attributes from event context which should be in the top-level payload */ function $a6e038c024d9736c$var$getPayloadAttributesFromContext(contexts) {
    return (contexts.find((obj)=>obj && obj.forgeUIAnalyticsContext) ?? {}).forgeUIAnalyticsContext ?? {};
}
const $a6e038c024d9736c$var$ForgeUIAnalyticsListener = ({ children: children, client: client, commonAttributes: commonAttributes = {} })=>{
    const listenerHandler = (event)=>{
        const { eventType: eventType, data: data } = event.payload;
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes, tags: tags, source: sourceFromEvent } = data;
        const forgeUIAnalyticsContext = $a6e038c024d9736c$var$getPayloadAttributesFromContext(event.context);
        const source = sourceFromEvent ?? forgeUIAnalyticsContext.source ?? 'unknown';
        const payload = {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            ...forgeUIAnalyticsContext,
            source: source,
            attributes: {
                ...commonAttributes,
                ...event.context.reduce((prev, curr)=>{
                    // Only extract attributes passed as an object via the forgeUIAttributes key
                    const forgeUIAttributes = curr && curr.forgeUIAttributes && typeof curr.forgeUIAttributes === 'object' ? curr.forgeUIAttributes : {};
                    return {
                        ...prev,
                        ...forgeUIAttributes
                    };
                }, {}),
                ...attributes
            },
            tags: tags
        };
        $a6e038c024d9736c$export$7329bcdc3edcd90e(client)({
            eventType: eventType,
            ...payload
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8QoO2.default), {
        onEvent: listenerHandler,
        channel: $a6e038c024d9736c$export$d28801614368e543,
        children: children
    });
};
var $a6e038c024d9736c$export$2e2bcd8739ae039 = $a6e038c024d9736c$var$ForgeUIAnalyticsListener;

});

parcelRegister("hgc8o", function(module, exports) {
$parcel$export(module.exports, "createSingleEventPerAppFilter", () => $7cb77503a03dda11$export$7d41ad2f735979f7);
const $7cb77503a03dda11$var$findAppContextKeyInEvent = (event)=>{
    if (!event.context) return undefined;
    for (const context of event.context){
        const { appId: appId, extensionKey: extensionKey } = context.forgeUIAttributes ?? {};
        if (appId && extensionKey) return `${appId}/${extensionKey}`;
    }
    return undefined;
};
const $7cb77503a03dda11$export$7d41ad2f735979f7 = ()=>{
    const seenAppContextKeys = new Set();
    return (event)=>{
        try {
            const appContextKey = $7cb77503a03dda11$var$findAppContextKeyInEvent(event);
            if (appContextKey) {
                // only reject the event if we have clear evidence that we've seen it before
                if (seenAppContextKeys.has(appContextKey)) return false;
                seenAppContextKeys.add(appContextKey);
            }
        } catch  {
        // in case of any error, we let the event through, so we don't accidentally break analytics
        }
        return true;
    };
};

});



parcelRegister("b2aYp", function(module, exports) {
$parcel$export(module.exports, "useCDNAuthSignedCookie", () => $b526c183c35f15a5$export$98b91f32256d29a8);
$parcel$export(module.exports, "shouldUseCDNAuth", () => $b526c183c35f15a5$export$a6dd2b5c1fe5c76e);

var $eGOwo = parcelRequire("eGOwo");

var $eJOHy = parcelRequire("eJOHy");

var $7pw1V = parcelRequire("7pw1V");
const $b526c183c35f15a5$export$98b91f32256d29a8 = ()=>{
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)($b526c183c35f15a5$export$a6dd2b5c1fe5c76e());
    (0, $eJOHy.useEffect)(()=>{
        if (isLoading) $b526c183c35f15a5$var$loadCDNAuthSignedCookie().catch((err)=>{
            // eslint-disable-next-line no-console
            console.error('Error loading CDN auth signed cookie:', err);
        }).finally(()=>{
            setIsLoading(false);
        });
    }, [
        isLoading
    ]);
    return isLoading;
};
const $b526c183c35f15a5$var$MAX_SIGNED_COOKIE_AGE_MS = 1800000; // 30 minutes
let $b526c183c35f15a5$var$lastSignedCookieFetchTime = 0;
let $b526c183c35f15a5$var$loadingPromise = null;
const $b526c183c35f15a5$var$doLoadCDNAuthSignedCookie = async ()=>{
    const icDomain = (0, $7pw1V.isolatedCloudDomain)();
    const signedCookieUrl = `https://forge.forge-cdn.${icDomain}/forge-cdn/signed-cookies`;
    return await fetch(signedCookieUrl, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    });
};
const $b526c183c35f15a5$var$loadCDNAuthSignedCookie = async ()=>{
    if (Date.now() - $b526c183c35f15a5$var$lastSignedCookieFetchTime < $b526c183c35f15a5$var$MAX_SIGNED_COOKIE_AGE_MS) return;
    // this is to ensure only one loadingPromise is active at a time (to avoid multiple simultaneous requests)
    if ($b526c183c35f15a5$var$loadingPromise) await $b526c183c35f15a5$var$loadingPromise;
    else {
        $b526c183c35f15a5$var$loadingPromise = (async ()=>{
            try {
                const response = await $b526c183c35f15a5$var$doLoadCDNAuthSignedCookie();
                if (!response.ok) throw new Error(`Failed to fetch signed cookies: ${response.statusText}`);
                $b526c183c35f15a5$var$lastSignedCookieFetchTime = Date.now();
            } finally{
                $b526c183c35f15a5$var$loadingPromise = null;
            }
        })();
        await $b526c183c35f15a5$var$loadingPromise;
    }
};
const $b526c183c35f15a5$export$a6dd2b5c1fe5c76e = ()=>{
    return (0, $eGOwo.fg)('forge-ui-cdn-auth') && (0, $7pw1V.isIsolatedCloud)();
};
const $b526c183c35f15a5$export$1b22f04514004ab6 = ()=>{
    $b526c183c35f15a5$var$lastSignedCookieFetchTime = 0;
    $b526c183c35f15a5$var$loadingPromise = null;
};

});


parcelRegister("dQN6B", function(module, exports) {
$parcel$export(module.exports, "InnerIframe", () => $31dc0f44423dd331$export$3c4d31cb85fd39c5);
/* InnerIframe.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8KLBw = parcelRequire("8KLBw");

var $hNwW9 = parcelRequire("hNwW9");

var $8IeH1 = parcelRequire("8IeH1");

var $82KGI = parcelRequire("82KGI");

var $eGOwo = parcelRequire("eGOwo");

var $83IbI = parcelRequire("83IbI");

var $j3eHA = parcelRequire("j3eHA");
var $bVrOy = parcelRequire("bVrOy");
var $6Tf8M = parcelRequire("6Tf8M");

var $iCkyS = parcelRequire("iCkyS");

var $dyHWi = parcelRequire("dyHWi");
var $x6DEi = parcelRequire("x6DEi");
var $f3yFH = parcelRequire("f3yFH");
var $asA27 = parcelRequire("asA27");
var $h2b6l = parcelRequire("h2b6l");

var $kKhkW = parcelRequire("kKhkW");

var $ftN6c = parcelRequire("ftN6c");

var $chSQm = parcelRequire("chSQm");
var $b3lfX = parcelRequire("b3lfX");
var $5YSQ9 = parcelRequire("5YSQ9");
var $jpNtm = parcelRequire("jpNtm");
var $1bJUR = parcelRequire("1bJUR");

var $94uyE = parcelRequire("94uyE");

var $6GbQJ = parcelRequire("6GbQJ");

var $aSByt = parcelRequire("aSByt");

var $2o6iP = parcelRequire("2o6iP");

var $cOLOr = parcelRequire("cOLOr");

var $dRcl3 = parcelRequire("dRcl3");

var $gnBoE = parcelRequire("gnBoE");
const $31dc0f44423dd331$var$styles = {
    threeLOInfo: "_1bsb1osq _4t3i1osq",
    box: "_kqswh2mm"
};
// TODO: no styles defined for resizable modals yet.
// Only Jira enables resizing on modals at the moment.
const $31dc0f44423dd331$var$modalIframeStyles = null;
const $31dc0f44423dd331$var$iframeStyles = null;
const $31dc0f44423dd331$var$hiddenIframeStyles = null;
const $31dc0f44423dd331$var$nonResizeableIframeStyles = null;
const $31dc0f44423dd331$var$defaultComponents = {
    ThreeLOPrompt: (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $iCkyS.default), {
            ...props
        })
};
/**
 * Hook for determining default IFrame React ref, using parent ref when provided
 *
 * @param parentIframeRef parent IFrame React ref
 * @returns default IFrame React ref
 */ function $31dc0f44423dd331$var$useDefaultIframeRef(parentIframeRef) {
    const localIframeRef = (0, $eJOHy.useRef)(null);
    const mergedRef = (0, $82KGI.useMergeRefs)([
        parentIframeRef,
        localIframeRef
    ]);
    return mergedRef;
}
const $31dc0f44423dd331$export$3c4d31cb85fd39c5 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ accountId: accountId, extension: extension, contextIds: contextIds, apolloClient: apolloClient, components: components, coreData: coreData, extensionData: extensionData, extensionViewData: extensionViewData, loadingComponent: loadingComponent, onLoad: onLoad, height: height = '100%', width: width = '100%', src: src, bridge: bridge, customBridgeMethods: customBridgeMethods, isResizable: isResizable, getContextToken: getContextToken, timezone: timezone, locale: locale, setIsThreeLOPromptVisible: setIsThreeLOPromptVisible, setShouldShowRenderer: setShouldShowRenderer, extensionPayload: extensionPayload, isHidden: isHidden, theme: theme, surfaceColor: surfaceColor, appId: appId, isInModal: isInModal, setIsLoading: setIsLoading, onError: onError, entryPoint: entryPoint }, parentIframeRef)=>{
    const { ThreeLOPrompt: ThreeLOPrompt } = components ? components($31dc0f44423dd331$var$defaultComponents) : $31dc0f44423dd331$var$defaultComponents;
    const appIsAuthenticated = (0, $94uyE.isAppConsentedLocally)(appId, accountId);
    const { appVersion: appVersion, consentUrl: consentUrl, currentUserConsent: currentUserConsent, requiresUserConsent: requiresUserConsent, properties: { frameId: frameId } } = extension;
    const [userConsentRequired, setUserConsentRequired] = (0, $eJOHy.useState)(consentUrl && !currentUserConsent && requiresUserConsent && !appIsAuthenticated);
    const productContext = (0, $eJOHy.useMemo)(()=>{
        const resolverContext = (0, $5YSQ9.getResolverContext)({
            ...coreData,
            appVersion: appVersion
        }, extensionData);
        const viewContext = (0, $jpNtm.getViewContext)({
            resolverContext: resolverContext,
            accountId: accountId,
            extension: extension,
            timezone: timezone ?? (0, $b3lfX.getBrowserTimezone)(),
            locale: locale ?? (0, $chSQm.getBrowserLocale)(),
            extensionPayload: extensionPayload,
            extensionViewData: extensionViewData,
            theme: theme,
            surfaceColor: surfaceColor,
            location: window.location.toString()
        });
        return {
            resolverContext: resolverContext,
            viewContext: viewContext
        };
    }, [
        appVersion,
        coreData,
        extensionData,
        extensionViewData,
        accountId,
        extension,
        timezone,
        locale,
        extensionPayload,
        theme,
        surfaceColor
    ]);
    const tracing = (0, $kKhkW.useTracingContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const contextTokenRef = (0, $eJOHy.useRef)(undefined);
    const [threeLOInfo, setThreeLOInfo] = (0, $eJOHy.useState)(null);
    const invokeRetriesRef = (0, $eJOHy.useRef)([]);
    const iframeRef = $31dc0f44423dd331$var$useDefaultIframeRef(parentIframeRef);
    (0, $eJOHy.useEffect)(()=>{
        const clearThreeLOInfo = async ()=>setThreeLOInfo(null);
        if (userConsentRequired) {
            tracing?.recordConsentFlow('consent flow - start');
            setThreeLOInfo({
                authUrl: consentUrl,
                onSuccess: async ()=>{
                    tracing?.recordConsentFlow('consent flow - end', 'success');
                    setUserConsentRequired(false);
                    setIsThreeLOPromptVisible(false);
                    (0, $94uyE.setAppConsentLocal)(appId, accountId);
                    return clearThreeLOInfo();
                },
                onReject: ()=>{
                    tracing?.recordConsentFlow('consent flow - end', 'rejected');
                    return clearThreeLOInfo();
                }
            });
            setIsThreeLOPromptVisible(true);
            setShouldShowRenderer?.(false);
            if (onLoad) onLoad();
        }
    }, [
        onLoad,
        setIsThreeLOPromptVisible,
        setShouldShowRenderer,
        tracing,
        appId,
        accountId,
        consentUrl,
        userConsentRequired
    ]);
    const navigation = (0, $asA27.useNavigation)({
        extension: extension,
        push: bridge?.spaPush
    });
    const invoker = (0, $bVrOy.useInvokeExtension)(contextIds, extension.id, {
        client: apolloClient
    });
    // The hash generated here should match the one created in the Realtime service when it hashes extension.context
    // in the FCT.
    // If this is flaky because of differences between extensionData and the FCT's extension.context, then
    // use the decoded FCT context directly here as well.
    const extensionContext = (()=>{
        try {
            const { modal: modal, ...productExtensionData } = extensionData;
            return (0, (/*@__PURE__*/$parcel$interopDefault($hNwW9)))(productExtensionData || {});
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Product context is not a serializable object.');
            return '';
        }
    })();
    // the realtime hooks below have no side effect (i.e. does not actively trigger any network calls or actively makes any subscription).
    // It is because everything inside this hook is lazily initialized.
    // Importantly:
    // - SubscribeRealtimeChannel is called by the client (i.e. @forge/bridge)
    const subscribeRealtimeChannel = (0, $j3eHA.useSubscribeRealtimeChannel)(extension.installationId, extensionContext);
    const publishRealtimeChannel = (0, $6Tf8M.usePublishRealtimeChannel)(extension.installationId, extensionContext, {
        client: apolloClient
    });
    const environment = (0, $eJOHy.useContext)((0, $83IbI.EnvironmentContext));
    const { cloudId: cloudId, workspaceId: workspaceId } = coreData;
    const rovoChat = (0, $h2b6l.useRovoAgentsChat)(extension.type, extension.environmentType, appId, cloudId, apolloClient);
    const productFetchClient = (0, $x6DEi.useProductFetchClient)({
        appId: appId,
        environment: environment,
        contextIds: contextIds,
        cloudId: cloudId,
        workspaceId: workspaceId,
        extensionId: extension.id,
        options: {
            client: apolloClient
        },
        renderThreeLOPrompt: (retry)=>{
            return new Promise((resolve, reject)=>{
                const authUrl = threeLOInfo?.authUrl || consentUrl;
                if (authUrl) {
                    invokeRetriesRef.current.push(retry);
                    tracing?.recordConsentFlow('consent flow - start');
                    setThreeLOInfo({
                        authUrl: authUrl,
                        onSuccess: ()=>{
                            tracing?.recordConsentFlow('consent flow - end', 'success');
                            resolve();
                            setThreeLOInfo(null);
                            setIsThreeLOPromptVisible(false);
                            setShouldShowRenderer?.(true);
                            return Promise.all(invokeRetriesRef.current.map((retry)=>retry())).then(()=>{
                                invokeRetriesRef.current = [];
                            });
                        },
                        onReject: ()=>{
                            tracing?.recordConsentFlow('consent flow - end', 'rejected');
                            return reject();
                        }
                    });
                    setIsThreeLOPromptVisible(true);
                    setShouldShowRenderer?.(false);
                }
            });
        }
    });
    const { loading: loading, iframeProps: { onLoad: onLoadIframeFromProps } } = (0, $f3yFH.useBridge)({
        cloudId: cloudId,
        theme: theme,
        surfaceColor: surfaceColor,
        origin: new URL(src).origin,
        api: {
            ...(0, $dyHWi.createBridgeApi)(bridge, {
                userConsentRequired: !!userConsentRequired
            }),
            ...(0, $eGOwo.fg)('platform_forge_ui_open_rovo_bridge') ? {
                openRovo: rovoChat.openRovo
            } : {},
            onInvoke: async (payload)=>{
                const newContextToken = getContextToken ? await getContextToken(contextIds) : contextTokenRef.current?.jwt;
                tracing?.recordGqlCall('invokeExtension - start');
                const { data: data } = await invoker({
                    call: payload,
                    context: {
                        ...productContext.resolverContext
                    },
                    extensionPayload: extensionPayload,
                    contextToken: newContextToken
                });
                // Default to using the regular invocation response
                var resp = data?.invokeExtension;
                // If the comparison feature flag is enabled, perform a shadow invocation to compare responses
                if ((0, $eGOwo.fg)('forge_ui_use_get_context_token_compare')) {
                    // Get shadow context token from cached token (when getContextToken is defined, it's already used above)
                    const shadowContextToken = contextTokenRef.current?.jwt;
                    // Perform shadow invocation with the shadow token
                    const { data: shadowData } = await invoker({
                        call: payload,
                        context: {
                            ...productContext.resolverContext
                        },
                        extensionPayload: extensionPayload,
                        contextToken: shadowContextToken
                    });
                    // Compare responses and select the optimal one based on token context differences
                    const selectedResponse = (0, $1bJUR.selectOptimalInvocationResponse)(data?.invokeExtension, shadowData?.invokeExtension, createAnalyticsEvent);
                    if (selectedResponse) resp = selectedResponse;
                }
                if (!resp?.success) {
                    const error = resp?.errors?.[0];
                    if (error?.extensions.errorType === 'USER_CONSENT_REQUIRED') return {
                        type: '3lo',
                        authUrl: error?.extensions.fields?.authInfoUrl
                    };
                    if (error?.extensions.errorType === (0, $aSByt.SANDBOX_DEPRECATION_ERROR) && onError && (0, $eGOwo.fg)('platform_render_sandbox_runtime_error_panel')) onError(error?.extensions.errorType);
                    return {
                        type: 'err',
                        message: error?.message ?? 'An error occurred while trying to invoke.'
                    };
                }
                tracing?.recordGqlCall('invokeExtension - end');
                contextTokenRef.current = resp?.contextToken;
                return {
                    type: 'ok',
                    response: resp?.response?.body
                };
            },
            onInitFeatureFlags: async (data)=>{
                const newContextToken = getContextToken ? await getContextToken() : contextTokenRef.current?.jwt;
                tracing?.recordBridgeCall('getFeatureFlags - start');
                try {
                    const resp = await (0, $gnBoE.getFeatureFlags)(appId, data.user, environment, newContextToken);
                    tracing?.recordBridgeCall('getFeatureFlags - end');
                    return {
                        type: 'ok',
                        response: resp
                    };
                } catch (err) {
                    tracing?.recordBridgeCall('getFeatureFlags - end');
                    // eslint-disable-next-line no-console
                    console.error('There were errors while initialising feature flags client ', err);
                    return {
                        type: 'err',
                        message: 'An error occurred while trying to initialise feature flags client.'
                    };
                }
            },
            onNavigate: navigation.onNavigate,
            onThreeLO: async (authUrl, retry)=>{
                return new Promise((resolve, reject)=>{
                    invokeRetriesRef.current.push(retry);
                    tracing?.recordConsentFlow('consent flow - start');
                    setThreeLOInfo({
                        authUrl: authUrl,
                        onSuccess: ()=>{
                            tracing?.recordConsentFlow('consent flow - end', 'success');
                            resolve();
                            setThreeLOInfo(null);
                            setIsThreeLOPromptVisible(false);
                            setShouldShowRenderer?.(true);
                            return Promise.all(invokeRetriesRef.current.map((retry)=>retry())).then(()=>{
                                invokeRetriesRef.current = [];
                            });
                        },
                        onReject: ()=>{
                            tracing?.recordConsentFlow('consent flow - end', 'rejected');
                            return reject();
                        }
                    });
                    setIsThreeLOPromptVisible(true);
                    setShouldShowRenderer?.(false);
                });
            },
            getContext: async ()=>({
                    ...productContext.viewContext
                }),
            fetchProduct: async ({ restPath: restPath, product: product, fetchRequestInit: fetchRequestInit, isMultipartFormData: isMultipartFormData })=>{
                const response = await productFetchClient(restPath, product, fetchRequestInit, isMultipartFormData);
                const { status: status, statusText: statusText } = response;
                const headers = Object.fromEntries(response.headers.entries());
                const isAttachment = (0, $x6DEi.isBinaryContentType)(response.headers.get('content-type'));
                const body = response.body ? await response.text() : undefined;
                return {
                    headers: headers,
                    status: status,
                    statusText: statusText,
                    body: body,
                    isAttachment: isAttachment
                };
            },
            getFrameId: ()=>frameId ?? null,
            subscribeRealtimeChannel: async (payload)=>{
                if (payload.data.isGlobal && !extension?.scopes?.includes((0, $j3eHA.READ_GLOBAL_CHANNEL_SCOPE)) && (0, $eGOwo.fg)('forge-ui-enforce-realtime-scopes')) {
                    const missingScopeErrorMessage = `${(0, $j3eHA.READ_GLOBAL_CHANNEL_SCOPE)} scope is required to subscribe to Forge Realtime global channels. Please add the scope to the app manifest permissions.`;
                    // eslint-disable-next-line no-console
                    console.error(missingScopeErrorMessage);
                    throw new Error(missingScopeErrorMessage);
                }
                const contextToken = getContextToken ? await getContextToken() : contextTokenRef.current?.jwt;
                return subscribeRealtimeChannel(payload, contextToken);
            },
            publishRealtimeChannel: async (payload)=>{
                const contextToken = getContextToken ? await getContextToken() : contextTokenRef.current?.jwt;
                return publishRealtimeChannel(payload, contextToken);
            }
        },
        customBridgeMethods: customBridgeMethods,
        onLoad: onLoad,
        isResizable: isResizable,
        height: height,
        environment: environment,
        extension: extension,
        iframeRef: iframeRef,
        client: apolloClient,
        contextIds: contextIds
    });
    (0, $eJOHy.useEffect)(()=>{
        setIsLoading?.(loading);
    }, [
        loading,
        setIsLoading
    ]);
    const { containerRef: containerRef } = (0, $2o6iP.useResizeAnalytics)({
        // need to check if the extension is custom UI as well since this component is used in WebRuntime for UI Kit
        isEnabled: (0, $cOLOr.isCustomUI)(extension, entryPoint) && (0, $eGOwo.fg)('forge-ui-performance-analytics-provider')
    });
    const sandboxAttributeRules = [
        'allow-downloads',
        'allow-forms',
        'allow-modals',
        'allow-pointer-lock',
        'allow-same-origin',
        'allow-scripts'
    ];
    try {
        const egressService = (0, $dRcl3.egressPermissionService)('FETCH_CLIENT_SIDE', extension.egress);
        const containsWildCardEgress = egressService.containsWildCardEgress();
        if (containsWildCardEgress) sandboxAttributeRules.push('allow-popups', 'allow-popups-to-escape-sandbox');
    } catch (e) {
    // swallow error
    }
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
        ref: containerRef,
        xcss: $31dc0f44423dd331$var$styles.box,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: isResizable || threeLOInfo ? undefined : height,
            width: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width
        },
        children: [
            navigation.getModalJsx(),
            (loading || threeLOInfo) && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
                xcss: $31dc0f44423dd331$var$styles.threeLOInfo,
                children: [
                    loading && !threeLOInfo && !isHidden && (0, $6GbQJ.getLoadingComponent)(loadingComponent),
                    threeLOInfo && ThreeLOPrompt({
                        authUrl: threeLOInfo.authUrl,
                        onSuccess: threeLOInfo.onSuccess,
                        metadata: {
                            moduleType: extension.type
                        }
                    })
                ]
            }),
            !userConsentRequired && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("iframe", {
                    "data-testid": "hosted-resources-iframe",
                    "data-forge-iframe": true,
                    sandbox: sandboxAttributeRules.join(' '),
                    allow: "camera; clipboard-write; display-capture; fullscreen; microphone",
                    src: src,
                    ref: iframeRef,
                    onLoad: onLoadIframeFromProps,
                    title: `Iframe ${frameId ?? (0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))()} from ${appId}`,
                    className: (0, $hcewu.default)([
                        "_19itglyw _1e0c1ule _1bsb1osq",
                        (loading || threeLOInfo || isHidden) && "_1e0cglyw",
                        isInModal && "_2rkofajl _4t3i1osq",
                        !isResizable && "_4t3i1osq"
                    ])
                })
            })
        ]
    });
});

});
parcelRegister("hNwW9", function(module, exports) {
!function(e) {
    var t;
    module.exports = e();
}(function() {
    return (function r(o, i, u) {
        function s(n, e) {
            if (!i[n]) {
                if (!o[n]) {
                    var t = undefined;
                    if (!e && t) return t(n, !0);
                    if (a) return a(n, !0);
                    throw new Error("Cannot find module '" + n + "'");
                }
                e = i[n] = {
                    exports: {}
                };
                o[n][0].call(e.exports, function(e) {
                    var t = o[n][1][e];
                    return s(t || e);
                }, e, e.exports, r, o, i, u);
            }
            return i[n].exports;
        }
        for(var a = undefined, e = 0; e < u.length; e++)s(u[e]);
        return s;
    })({
        1: [
            function(w, b, m) {
                (function(e, n, s, c, d, h, p, g, y) {
                    "use strict";
                    var r = w("crypto");
                    function t(e, t) {
                        t = u(e, t);
                        var n;
                        return void 0 === (n = "passthrough" !== t.algorithm ? r.createHash(t.algorithm) : new l).write && (n.write = n.update, n.end = n.update), f(t, n).dispatch(e), n.update || n.end(""), n.digest ? n.digest("buffer" === t.encoding ? void 0 : t.encoding) : (e = n.read(), "buffer" !== t.encoding ? e.toString(t.encoding) : e);
                    }
                    (m = b.exports = t).sha1 = function(e) {
                        return t(e);
                    }, m.keys = function(e) {
                        return t(e, {
                            excludeValues: !0,
                            algorithm: "sha1",
                            encoding: "hex"
                        });
                    }, m.MD5 = function(e) {
                        return t(e, {
                            algorithm: "md5",
                            encoding: "hex"
                        });
                    }, m.keysMD5 = function(e) {
                        return t(e, {
                            algorithm: "md5",
                            encoding: "hex",
                            excludeValues: !0
                        });
                    };
                    var o = r.getHashes ? r.getHashes().slice() : [
                        "sha1",
                        "md5"
                    ], i = (o.push("passthrough"), [
                        "buffer",
                        "hex",
                        "binary",
                        "base64"
                    ]);
                    function u(e, t) {
                        var n = {};
                        if (n.algorithm = (t = t || {}).algorithm || "sha1", n.encoding = t.encoding || "hex", n.excludeValues = !!t.excludeValues, n.algorithm = n.algorithm.toLowerCase(), n.encoding = n.encoding.toLowerCase(), n.ignoreUnknown = !0 === t.ignoreUnknown, n.respectType = !1 !== t.respectType, n.respectFunctionNames = !1 !== t.respectFunctionNames, n.respectFunctionProperties = !1 !== t.respectFunctionProperties, n.unorderedArrays = !0 === t.unorderedArrays, n.unorderedSets = !1 !== t.unorderedSets, n.unorderedObjects = !1 !== t.unorderedObjects, n.replacer = t.replacer || void 0, n.excludeKeys = t.excludeKeys || void 0, void 0 === e) throw new Error("Object argument required.");
                        for(var r = 0; r < o.length; ++r)o[r].toLowerCase() === n.algorithm.toLowerCase() && (n.algorithm = o[r]);
                        if (-1 === o.indexOf(n.algorithm)) throw new Error('Algorithm "' + n.algorithm + '"  not supported. supported values: ' + o.join(", "));
                        if (-1 === i.indexOf(n.encoding) && "passthrough" !== n.algorithm) throw new Error('Encoding "' + n.encoding + '"  not supported. supported values: ' + i.join(", "));
                        return n;
                    }
                    function a(e) {
                        if ("function" == typeof e) return null != /^function\s+\w*\s*\(\s*\)\s*{\s+\[native code\]\s+}$/i.exec(Function.prototype.toString.call(e));
                    }
                    function f(o, t, i) {
                        i = i || [];
                        function u(e) {
                            return t.update ? t.update(e, "utf8") : t.write(e, "utf8");
                        }
                        return {
                            dispatch: function(e) {
                                return this["_" + (null === (e = o.replacer ? o.replacer(e) : e) ? "null" : typeof e)](e);
                            },
                            _object: function(t) {
                                var n, e = Object.prototype.toString.call(t), r = /\[object (.*)\]/i.exec(e);
                                r = (r = r ? r[1] : "unknown:[" + e + "]").toLowerCase();
                                if (0 <= (e = i.indexOf(t))) return this.dispatch("[CIRCULAR:" + e + "]");
                                if (i.push(t), void 0 !== s && s.isBuffer && s.isBuffer(t)) return u("buffer:"), u(t);
                                if ("object" === r || "function" === r || "asyncfunction" === r) return e = Object.keys(t), o.unorderedObjects && (e = e.sort()), !1 === o.respectType || a(t) || e.splice(0, 0, "prototype", "__proto__", "constructor"), o.excludeKeys && (e = e.filter(function(e) {
                                    return !o.excludeKeys(e);
                                })), u("object:" + e.length + ":"), n = this, e.forEach(function(e) {
                                    n.dispatch(e), u(":"), o.excludeValues || n.dispatch(t[e]), u(",");
                                });
                                if (!this["_" + r]) {
                                    if (o.ignoreUnknown) return u("[" + r + "]");
                                    throw new Error('Unknown object type "' + r + '"');
                                }
                                this["_" + r](t);
                            },
                            _array: function(e, t) {
                                t = void 0 !== t ? t : !1 !== o.unorderedArrays;
                                var n = this;
                                if (u("array:" + e.length + ":"), !t || e.length <= 1) return e.forEach(function(e) {
                                    return n.dispatch(e);
                                });
                                var r = [], t = e.map(function(e) {
                                    var t = new l, n = i.slice();
                                    return f(o, t, n).dispatch(e), r = r.concat(n.slice(i.length)), t.read().toString();
                                });
                                return i = i.concat(r), t.sort(), this._array(t, !1);
                            },
                            _date: function(e) {
                                return u("date:" + e.toJSON());
                            },
                            _symbol: function(e) {
                                return u("symbol:" + e.toString());
                            },
                            _error: function(e) {
                                return u("error:" + e.toString());
                            },
                            _boolean: function(e) {
                                return u("bool:" + e.toString());
                            },
                            _string: function(e) {
                                u("string:" + e.length + ":"), u(e.toString());
                            },
                            _function: function(e) {
                                u("fn:"), a(e) ? this.dispatch("[native]") : this.dispatch(e.toString()), !1 !== o.respectFunctionNames && this.dispatch("function-name:" + String(e.name)), o.respectFunctionProperties && this._object(e);
                            },
                            _number: function(e) {
                                return u("number:" + e.toString());
                            },
                            _xml: function(e) {
                                return u("xml:" + e.toString());
                            },
                            _null: function() {
                                return u("Null");
                            },
                            _undefined: function() {
                                return u("Undefined");
                            },
                            _regexp: function(e) {
                                return u("regex:" + e.toString());
                            },
                            _uint8array: function(e) {
                                return u("uint8array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _uint8clampedarray: function(e) {
                                return u("uint8clampedarray:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _int8array: function(e) {
                                return u("int8array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _uint16array: function(e) {
                                return u("uint16array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _int16array: function(e) {
                                return u("int16array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _uint32array: function(e) {
                                return u("uint32array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _int32array: function(e) {
                                return u("int32array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _float32array: function(e) {
                                return u("float32array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _float64array: function(e) {
                                return u("float64array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _arraybuffer: function(e) {
                                return u("arraybuffer:"), this.dispatch(new Uint8Array(e));
                            },
                            _url: function(e) {
                                return u("url:" + e.toString());
                            },
                            _map: function(e) {
                                u("map:");
                                e = Array.from(e);
                                return this._array(e, !1 !== o.unorderedSets);
                            },
                            _set: function(e) {
                                u("set:");
                                e = Array.from(e);
                                return this._array(e, !1 !== o.unorderedSets);
                            },
                            _file: function(e) {
                                return u("file:"), this.dispatch([
                                    e.name,
                                    e.size,
                                    e.type,
                                    e.lastModfied
                                ]);
                            },
                            _blob: function() {
                                if (o.ignoreUnknown) return u("[blob]");
                                throw Error('Hashing Blob objects is currently not supported\n(see https://github.com/puleos/object-hash/issues/26)\nUse "options.replacer" or "options.ignoreUnknown"\n');
                            },
                            _domwindow: function() {
                                return u("domwindow");
                            },
                            _bigint: function(e) {
                                return u("bigint:" + e.toString());
                            },
                            _process: function() {
                                return u("process");
                            },
                            _timer: function() {
                                return u("timer");
                            },
                            _pipe: function() {
                                return u("pipe");
                            },
                            _tcp: function() {
                                return u("tcp");
                            },
                            _udp: function() {
                                return u("udp");
                            },
                            _tty: function() {
                                return u("tty");
                            },
                            _statwatcher: function() {
                                return u("statwatcher");
                            },
                            _securecontext: function() {
                                return u("securecontext");
                            },
                            _connection: function() {
                                return u("connection");
                            },
                            _zlib: function() {
                                return u("zlib");
                            },
                            _context: function() {
                                return u("context");
                            },
                            _nodescript: function() {
                                return u("nodescript");
                            },
                            _httpparser: function() {
                                return u("httpparser");
                            },
                            _dataview: function() {
                                return u("dataview");
                            },
                            _signal: function() {
                                return u("signal");
                            },
                            _fsevent: function() {
                                return u("fsevent");
                            },
                            _tlswrap: function() {
                                return u("tlswrap");
                            }
                        };
                    }
                    function l() {
                        return {
                            buf: "",
                            write: function(e) {
                                this.buf += e;
                            },
                            end: function(e) {
                                this.buf += e;
                            },
                            read: function() {
                                return this.buf;
                            }
                        };
                    }
                    m.writeToStream = function(e, t, n) {
                        return void 0 === n && (n = t, t = {}), f(t = u(e, t), n).dispatch(e);
                    };
                }).call(this, w("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, w("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/fake_9a5aa49d.js", "/");
            },
            {
                buffer: 3,
                crypto: 5,
                lYpoI2: 11
            }
        ],
        2: [
            function(e, t, f) {
                (function(e, t, n, r, o, i, u, s, a) {
                    !function(e) {
                        "use strict";
                        var a = "undefined" != typeof Uint8Array ? Uint8Array : Array, t = "+".charCodeAt(0), n = "/".charCodeAt(0), r = "0".charCodeAt(0), o = "a".charCodeAt(0), i = "A".charCodeAt(0), u = "-".charCodeAt(0), s = "_".charCodeAt(0);
                        function f(e) {
                            e = e.charCodeAt(0);
                            return e === t || e === u ? 62 : e === n || e === s ? 63 : e < r ? -1 : e < r + 10 ? e - r + 26 + 26 : e < i + 26 ? e - i : e < o + 26 ? e - o + 26 : void 0;
                        }
                        e.toByteArray = function(e) {
                            var t, n;
                            if (0 < e.length % 4) throw new Error("Invalid string. Length must be a multiple of 4");
                            var r = e.length, r = "=" === e.charAt(r - 2) ? 2 : "=" === e.charAt(r - 1) ? 1 : 0, o = new a(3 * e.length / 4 - r), i = 0 < r ? e.length - 4 : e.length, u = 0;
                            function s(e) {
                                o[u++] = e;
                            }
                            for(t = 0; t < i; t += 4)s((16711680 & (n = f(e.charAt(t)) << 18 | f(e.charAt(t + 1)) << 12 | f(e.charAt(t + 2)) << 6 | f(e.charAt(t + 3)))) >> 16), s((65280 & n) >> 8), s(255 & n);
                            return 2 == r ? s(255 & (n = f(e.charAt(t)) << 2 | f(e.charAt(t + 1)) >> 4)) : 1 == r && (s((n = f(e.charAt(t)) << 10 | f(e.charAt(t + 1)) << 4 | f(e.charAt(t + 2)) >> 2) >> 8 & 255), s(255 & n)), o;
                        }, e.fromByteArray = function(e) {
                            var t, n, r, o, i = e.length % 3, u = "";
                            function s(e) {
                                return "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(e);
                            }
                            for(t = 0, r = e.length - i; t < r; t += 3)n = (e[t] << 16) + (e[t + 1] << 8) + e[t + 2], u += s((o = n) >> 18 & 63) + s(o >> 12 & 63) + s(o >> 6 & 63) + s(63 & o);
                            switch(i){
                                case 1:
                                    u = (u += s((n = e[e.length - 1]) >> 2)) + s(n << 4 & 63) + "==";
                                    break;
                                case 2:
                                    u = (u = (u += s((n = (e[e.length - 2] << 8) + e[e.length - 1]) >> 10)) + s(n >> 4 & 63)) + s(n << 2 & 63) + "=";
                            }
                            return u;
                        };
                    }(void 0 === f ? this.base64js = {} : f);
                }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/base64-js/lib/b64.js", "/node_modules/gulp-browserify/node_modules/base64-js/lib");
            },
            {
                buffer: 3,
                lYpoI2: 11
            }
        ],
        3: [
            function(O, e, H) {
                (function(e, n, f, r, h, p, g, y, w) {
                    var a = O("base64-js"), i = O("ieee754");
                    function f(e, t, n) {
                        if (!(this instanceof f)) return new f(e, t, n);
                        var r, o, i, u, s = typeof e;
                        if ("base64" === t && "string" == s) for(e = (u = e).trim ? u.trim() : u.replace(/^\s+|\s+$/g, ""); e.length % 4 != 0;)e += "=";
                        if ("number" == s) r = j(e);
                        else if ("string" == s) r = f.byteLength(e, t);
                        else {
                            if ("object" != s) throw new Error("First argument needs to be a number, array or string.");
                            r = j(e.length);
                        }
                        if (f._useTypedArrays ? o = f._augment(new Uint8Array(r)) : ((o = this).length = r, o._isBuffer = !0), f._useTypedArrays && "number" == typeof e.byteLength) o._set(e);
                        else if (C(u = e) || f.isBuffer(u) || u && "object" == typeof u && "number" == typeof u.length) for(i = 0; i < r; i++)f.isBuffer(e) ? o[i] = e.readUInt8(i) : o[i] = e[i];
                        else if ("string" == s) o.write(e, 0, t);
                        else if ("number" == s && !f._useTypedArrays && !n) for(i = 0; i < r; i++)o[i] = 0;
                        return o;
                    }
                    function b(e, t, n, r) {
                        return f._charsWritten = c(function(e) {
                            for(var t = [], n = 0; n < e.length; n++)t.push(255 & e.charCodeAt(n));
                            return t;
                        }(t), e, n, r);
                    }
                    function m(e, t, n, r) {
                        return f._charsWritten = c(function(e) {
                            for(var t, n, r = [], o = 0; o < e.length; o++)n = e.charCodeAt(o), t = n >> 8, n = n % 256, r.push(n), r.push(t);
                            return r;
                        }(t), e, n, r);
                    }
                    function v(e, t, n) {
                        var r = "";
                        n = Math.min(e.length, n);
                        for(var o = t; o < n; o++)r += String.fromCharCode(e[o]);
                        return r;
                    }
                    function o(e, t, n, r) {
                        r || (d("boolean" == typeof n, "missing or invalid endian"), d(null != t, "missing offset"), d(t + 1 < e.length, "Trying to read beyond buffer length"));
                        var o, r = e.length;
                        if (!(r <= t)) return n ? (o = e[t], t + 1 < r && (o |= e[t + 1] << 8)) : (o = e[t] << 8, t + 1 < r && (o |= e[t + 1])), o;
                    }
                    function u(e, t, n, r) {
                        r || (d("boolean" == typeof n, "missing or invalid endian"), d(null != t, "missing offset"), d(t + 3 < e.length, "Trying to read beyond buffer length"));
                        var o, r = e.length;
                        if (!(r <= t)) return n ? (t + 2 < r && (o = e[t + 2] << 16), t + 1 < r && (o |= e[t + 1] << 8), o |= e[t], t + 3 < r && (o += e[t + 3] << 24 >>> 0)) : (t + 1 < r && (o = e[t + 1] << 16), t + 2 < r && (o |= e[t + 2] << 8), t + 3 < r && (o |= e[t + 3]), o += e[t] << 24 >>> 0), o;
                    }
                    function _(e, t, n, r) {
                        if (r || (d("boolean" == typeof n, "missing or invalid endian"), d(null != t, "missing offset"), d(t + 1 < e.length, "Trying to read beyond buffer length")), !(e.length <= t)) return r = o(e, t, n, !0), 32768 & r ? -1 * (65535 - r + 1) : r;
                    }
                    function E(e, t, n, r) {
                        if (r || (d("boolean" == typeof n, "missing or invalid endian"), d(null != t, "missing offset"), d(t + 3 < e.length, "Trying to read beyond buffer length")), !(e.length <= t)) return r = u(e, t, n, !0), 2147483648 & r ? -1 * (4294967295 - r + 1) : r;
                    }
                    function I(e, t, n, r) {
                        return r || (d("boolean" == typeof n, "missing or invalid endian"), d(t + 3 < e.length, "Trying to read beyond buffer length")), i.read(e, t, n, 23, 4);
                    }
                    function A(e, t, n, r) {
                        return r || (d("boolean" == typeof n, "missing or invalid endian"), d(t + 7 < e.length, "Trying to read beyond buffer length")), i.read(e, t, n, 52, 8);
                    }
                    function s(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 1 < e.length, "trying to write beyond buffer length"), Y(t, 65535));
                        o = e.length;
                        if (!(o <= n)) for(var i = 0, u = Math.min(o - n, 2); i < u; i++)e[n + i] = (t & 255 << 8 * (r ? i : 1 - i)) >>> 8 * (r ? i : 1 - i);
                    }
                    function l(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 3 < e.length, "trying to write beyond buffer length"), Y(t, 4294967295));
                        o = e.length;
                        if (!(o <= n)) for(var i = 0, u = Math.min(o - n, 4); i < u; i++)e[n + i] = t >>> 8 * (r ? i : 3 - i) & 255;
                    }
                    function B(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 1 < e.length, "Trying to write beyond buffer length"), F(t, 32767, -32768)), e.length <= n || s(e, 0 <= t ? t : 65535 + t + 1, n, r, o);
                    }
                    function L(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 3 < e.length, "Trying to write beyond buffer length"), F(t, 2147483647, -2147483648)), e.length <= n || l(e, 0 <= t ? t : 4294967295 + t + 1, n, r, o);
                    }
                    function U(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 3 < e.length, "Trying to write beyond buffer length"), D(t, 34028234663852886e22, -340282346638528860000000000000000000000)), e.length <= n || i.write(e, t, n, r, 23, 4);
                    }
                    function x(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 7 < e.length, "Trying to write beyond buffer length"), D(t, 17976931348623157e292, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000)), e.length <= n || i.write(e, t, n, r, 52, 8);
                    }
                    H.Buffer = f, H.SlowBuffer = f, H.INSPECT_MAX_BYTES = 50, f.poolSize = 8192, f._useTypedArrays = function() {
                        try {
                            var e = new ArrayBuffer(0), t = new Uint8Array(e);
                            return t.foo = function() {
                                return 42;
                            }, 42 === t.foo() && "function" == typeof t.subarray;
                        } catch (e) {
                            return !1;
                        }
                    }(), f.isEncoding = function(e) {
                        switch(String(e).toLowerCase()){
                            case "hex":
                            case "utf8":
                            case "utf-8":
                            case "ascii":
                            case "binary":
                            case "base64":
                            case "raw":
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                return !0;
                            default:
                                return !1;
                        }
                    }, f.isBuffer = function(e) {
                        return !(null == e || !e._isBuffer);
                    }, f.byteLength = function(e, t) {
                        var n;
                        switch(e += "", t || "utf8"){
                            case "hex":
                                n = e.length / 2;
                                break;
                            case "utf8":
                            case "utf-8":
                                n = T(e).length;
                                break;
                            case "ascii":
                            case "binary":
                            case "raw":
                                n = e.length;
                                break;
                            case "base64":
                                n = M(e).length;
                                break;
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                n = 2 * e.length;
                                break;
                            default:
                                throw new Error("Unknown encoding");
                        }
                        return n;
                    }, f.concat = function(e, t) {
                        if (d(C(e), "Usage: Buffer.concat(list, [totalLength])\nlist should be an Array."), 0 === e.length) return new f(0);
                        if (1 === e.length) return e[0];
                        if ("number" != typeof t) for(o = t = 0; o < e.length; o++)t += e[o].length;
                        for(var n = new f(t), r = 0, o = 0; o < e.length; o++){
                            var i = e[o];
                            i.copy(n, r), r += i.length;
                        }
                        return n;
                    }, f.prototype.write = function(e, t, n, r) {
                        isFinite(t) ? isFinite(n) || (r = n, n = void 0) : (a = r, r = t, t = n, n = a), t = Number(t) || 0;
                        var o, i, u, s, a = this.length - t;
                        switch((!n || a < (n = Number(n))) && (n = a), r = String(r || "utf8").toLowerCase()){
                            case "hex":
                                o = function(e, t, n, r) {
                                    n = Number(n) || 0;
                                    var o = e.length - n;
                                    (!r || o < (r = Number(r))) && (r = o), d((o = t.length) % 2 == 0, "Invalid hex string"), o / 2 < r && (r = o / 2);
                                    for(var i = 0; i < r; i++){
                                        var u = parseInt(t.substr(2 * i, 2), 16);
                                        d(!isNaN(u), "Invalid hex string"), e[n + i] = u;
                                    }
                                    return f._charsWritten = 2 * i, i;
                                }(this, e, t, n);
                                break;
                            case "utf8":
                            case "utf-8":
                                i = this, u = t, s = n, o = f._charsWritten = c(T(e), i, u, s);
                                break;
                            case "ascii":
                            case "binary":
                                o = b(this, e, t, n);
                                break;
                            case "base64":
                                i = this, u = t, s = n, o = f._charsWritten = c(M(e), i, u, s);
                                break;
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                o = m(this, e, t, n);
                                break;
                            default:
                                throw new Error("Unknown encoding");
                        }
                        return o;
                    }, f.prototype.toString = function(e, t, n) {
                        var r, o, i, u, s = this;
                        if (e = String(e || "utf8").toLowerCase(), t = Number(t) || 0, (n = void 0 !== n ? Number(n) : s.length) === t) return "";
                        switch(e){
                            case "hex":
                                r = function(e, t, n) {
                                    var r = e.length;
                                    (!t || t < 0) && (t = 0);
                                    (!n || n < 0 || r < n) && (n = r);
                                    for(var o = "", i = t; i < n; i++)o += k(e[i]);
                                    return o;
                                }(s, t, n);
                                break;
                            case "utf8":
                            case "utf-8":
                                r = function(e, t, n) {
                                    var r = "", o = "";
                                    n = Math.min(e.length, n);
                                    for(var i = t; i < n; i++)e[i] <= 127 ? (r += N(o) + String.fromCharCode(e[i]), o = "") : o += "%" + e[i].toString(16);
                                    return r + N(o);
                                }(s, t, n);
                                break;
                            case "ascii":
                            case "binary":
                                r = v(s, t, n);
                                break;
                            case "base64":
                                o = s, u = n, r = 0 === (i = t) && u === o.length ? a.fromByteArray(o) : a.fromByteArray(o.slice(i, u));
                                break;
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                r = function(e, t, n) {
                                    for(var r = e.slice(t, n), o = "", i = 0; i < r.length; i += 2)o += String.fromCharCode(r[i] + 256 * r[i + 1]);
                                    return o;
                                }(s, t, n);
                                break;
                            default:
                                throw new Error("Unknown encoding");
                        }
                        return r;
                    }, f.prototype.toJSON = function() {
                        return {
                            type: "Buffer",
                            data: Array.prototype.slice.call(this._arr || this, 0)
                        };
                    }, f.prototype.copy = function(e, t, n, r) {
                        if (t = t || 0, (r = r || 0 === r ? r : this.length) !== (n = n || 0) && 0 !== e.length && 0 !== this.length) {
                            d(n <= r, "sourceEnd < sourceStart"), d(0 <= t && t < e.length, "targetStart out of bounds"), d(0 <= n && n < this.length, "sourceStart out of bounds"), d(0 <= r && r <= this.length, "sourceEnd out of bounds"), r > this.length && (r = this.length);
                            var o = (r = e.length - t < r - n ? e.length - t + n : r) - n;
                            if (o < 100 || !f._useTypedArrays) for(var i = 0; i < o; i++)e[i + t] = this[i + n];
                            else e._set(this.subarray(n, n + o), t);
                        }
                    }, f.prototype.slice = function(e, t) {
                        var n = this.length;
                        if (e = S(e, n, 0), t = S(t, n, n), f._useTypedArrays) return f._augment(this.subarray(e, t));
                        for(var r = t - e, o = new f(r, void 0, !0), i = 0; i < r; i++)o[i] = this[i + e];
                        return o;
                    }, f.prototype.get = function(e) {
                        return console.log(".get() is deprecated. Access using array indexes instead."), this.readUInt8(e);
                    }, f.prototype.set = function(e, t) {
                        return console.log(".set() is deprecated. Access using array indexes instead."), this.writeUInt8(e, t);
                    }, f.prototype.readUInt8 = function(e, t) {
                        if (t || (d(null != e, "missing offset"), d(e < this.length, "Trying to read beyond buffer length")), !(e >= this.length)) return this[e];
                    }, f.prototype.readUInt16LE = function(e, t) {
                        return o(this, e, !0, t);
                    }, f.prototype.readUInt16BE = function(e, t) {
                        return o(this, e, !1, t);
                    }, f.prototype.readUInt32LE = function(e, t) {
                        return u(this, e, !0, t);
                    }, f.prototype.readUInt32BE = function(e, t) {
                        return u(this, e, !1, t);
                    }, f.prototype.readInt8 = function(e, t) {
                        if (t || (d(null != e, "missing offset"), d(e < this.length, "Trying to read beyond buffer length")), !(e >= this.length)) return 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
                    }, f.prototype.readInt16LE = function(e, t) {
                        return _(this, e, !0, t);
                    }, f.prototype.readInt16BE = function(e, t) {
                        return _(this, e, !1, t);
                    }, f.prototype.readInt32LE = function(e, t) {
                        return E(this, e, !0, t);
                    }, f.prototype.readInt32BE = function(e, t) {
                        return E(this, e, !1, t);
                    }, f.prototype.readFloatLE = function(e, t) {
                        return I(this, e, !0, t);
                    }, f.prototype.readFloatBE = function(e, t) {
                        return I(this, e, !1, t);
                    }, f.prototype.readDoubleLE = function(e, t) {
                        return A(this, e, !0, t);
                    }, f.prototype.readDoubleBE = function(e, t) {
                        return A(this, e, !1, t);
                    }, f.prototype.writeUInt8 = function(e, t, n) {
                        n || (d(null != e, "missing value"), d(null != t, "missing offset"), d(t < this.length, "trying to write beyond buffer length"), Y(e, 255)), t >= this.length || (this[t] = e);
                    }, f.prototype.writeUInt16LE = function(e, t, n) {
                        s(this, e, t, !0, n);
                    }, f.prototype.writeUInt16BE = function(e, t, n) {
                        s(this, e, t, !1, n);
                    }, f.prototype.writeUInt32LE = function(e, t, n) {
                        l(this, e, t, !0, n);
                    }, f.prototype.writeUInt32BE = function(e, t, n) {
                        l(this, e, t, !1, n);
                    }, f.prototype.writeInt8 = function(e, t, n) {
                        n || (d(null != e, "missing value"), d(null != t, "missing offset"), d(t < this.length, "Trying to write beyond buffer length"), F(e, 127, -128)), t >= this.length || (0 <= e ? this.writeUInt8(e, t, n) : this.writeUInt8(255 + e + 1, t, n));
                    }, f.prototype.writeInt16LE = function(e, t, n) {
                        B(this, e, t, !0, n);
                    }, f.prototype.writeInt16BE = function(e, t, n) {
                        B(this, e, t, !1, n);
                    }, f.prototype.writeInt32LE = function(e, t, n) {
                        L(this, e, t, !0, n);
                    }, f.prototype.writeInt32BE = function(e, t, n) {
                        L(this, e, t, !1, n);
                    }, f.prototype.writeFloatLE = function(e, t, n) {
                        U(this, e, t, !0, n);
                    }, f.prototype.writeFloatBE = function(e, t, n) {
                        U(this, e, t, !1, n);
                    }, f.prototype.writeDoubleLE = function(e, t, n) {
                        x(this, e, t, !0, n);
                    }, f.prototype.writeDoubleBE = function(e, t, n) {
                        x(this, e, t, !1, n);
                    }, f.prototype.fill = function(e, t, n) {
                        if (t = t || 0, n = n || this.length, d("number" == typeof (e = "string" == typeof (e = e || 0) ? e.charCodeAt(0) : e) && !isNaN(e), "value is not a number"), d(t <= n, "end < start"), n !== t && 0 !== this.length) {
                            d(0 <= t && t < this.length, "start out of bounds"), d(0 <= n && n <= this.length, "end out of bounds");
                            for(var r = t; r < n; r++)this[r] = e;
                        }
                    }, f.prototype.inspect = function() {
                        for(var e = [], t = this.length, n = 0; n < t; n++)if (e[n] = k(this[n]), n === H.INSPECT_MAX_BYTES) {
                            e[n + 1] = "...";
                            break;
                        }
                        return "<Buffer " + e.join(" ") + ">";
                    }, f.prototype.toArrayBuffer = function() {
                        if ("undefined" == typeof Uint8Array) throw new Error("Buffer.toArrayBuffer not supported in this browser");
                        if (f._useTypedArrays) return new f(this).buffer;
                        for(var e = new Uint8Array(this.length), t = 0, n = e.length; t < n; t += 1)e[t] = this[t];
                        return e.buffer;
                    };
                    var t = f.prototype;
                    function S(e, t, n) {
                        return "number" != typeof e ? n : t <= (e = ~~e) ? t : 0 <= e || 0 <= (e += t) ? e : 0;
                    }
                    function j(e) {
                        return (e = ~~Math.ceil(+e)) < 0 ? 0 : e;
                    }
                    function C(e) {
                        return (Array.isArray || function(e) {
                            return "[object Array]" === Object.prototype.toString.call(e);
                        })(e);
                    }
                    function k(e) {
                        return e < 16 ? "0" + e.toString(16) : e.toString(16);
                    }
                    function T(e) {
                        for(var t = [], n = 0; n < e.length; n++){
                            var r = e.charCodeAt(n);
                            if (r <= 127) t.push(e.charCodeAt(n));
                            else for(var o = n, i = (55296 <= r && r <= 57343 && n++, encodeURIComponent(e.slice(o, n + 1)).substr(1).split("%")), u = 0; u < i.length; u++)t.push(parseInt(i[u], 16));
                        }
                        return t;
                    }
                    function M(e) {
                        return a.toByteArray(e);
                    }
                    function c(e, t, n, r) {
                        for(var o = 0; o < r && !(o + n >= t.length || o >= e.length); o++)t[o + n] = e[o];
                        return o;
                    }
                    function N(e) {
                        try {
                            return decodeURIComponent(e);
                        } catch (e) {
                            return String.fromCharCode(65533);
                        }
                    }
                    function Y(e, t) {
                        d("number" == typeof e, "cannot write a non-number as a number"), d(0 <= e, "specified a negative value for writing an unsigned value"), d(e <= t, "value is larger than maximum value for type"), d(Math.floor(e) === e, "value has a fractional component");
                    }
                    function F(e, t, n) {
                        d("number" == typeof e, "cannot write a non-number as a number"), d(e <= t, "value larger than maximum allowed value"), d(n <= e, "value smaller than minimum allowed value"), d(Math.floor(e) === e, "value has a fractional component");
                    }
                    function D(e, t, n) {
                        d("number" == typeof e, "cannot write a non-number as a number"), d(e <= t, "value larger than maximum allowed value"), d(n <= e, "value smaller than minimum allowed value");
                    }
                    function d(e, t) {
                        if (!e) throw new Error(t || "Failed assertion");
                    }
                    f._augment = function(e) {
                        return e._isBuffer = !0, e._get = e.get, e._set = e.set, e.get = t.get, e.set = t.set, e.write = t.write, e.toString = t.toString, e.toLocaleString = t.toString, e.toJSON = t.toJSON, e.copy = t.copy, e.slice = t.slice, e.readUInt8 = t.readUInt8, e.readUInt16LE = t.readUInt16LE, e.readUInt16BE = t.readUInt16BE, e.readUInt32LE = t.readUInt32LE, e.readUInt32BE = t.readUInt32BE, e.readInt8 = t.readInt8, e.readInt16LE = t.readInt16LE, e.readInt16BE = t.readInt16BE, e.readInt32LE = t.readInt32LE, e.readInt32BE = t.readInt32BE, e.readFloatLE = t.readFloatLE, e.readFloatBE = t.readFloatBE, e.readDoubleLE = t.readDoubleLE, e.readDoubleBE = t.readDoubleBE, e.writeUInt8 = t.writeUInt8, e.writeUInt16LE = t.writeUInt16LE, e.writeUInt16BE = t.writeUInt16BE, e.writeUInt32LE = t.writeUInt32LE, e.writeUInt32BE = t.writeUInt32BE, e.writeInt8 = t.writeInt8, e.writeInt16LE = t.writeInt16LE, e.writeInt16BE = t.writeInt16BE, e.writeInt32LE = t.writeInt32LE, e.writeInt32BE = t.writeInt32BE, e.writeFloatLE = t.writeFloatLE, e.writeFloatBE = t.writeFloatBE, e.writeDoubleLE = t.writeDoubleLE, e.writeDoubleBE = t.writeDoubleBE, e.fill = t.fill, e.inspect = t.inspect, e.toArrayBuffer = t.toArrayBuffer, e;
                    };
                }).call(this, O("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, O("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/buffer/index.js", "/node_modules/gulp-browserify/node_modules/buffer");
            },
            {
                "base64-js": 2,
                buffer: 3,
                ieee754: 10,
                lYpoI2: 11
            }
        ],
        4: [
            function(c, d, e) {
                (function(e, t, a, n, r, o, i, u, s) {
                    var a = c("buffer").Buffer, f = 4, l = new a(f);
                    l.fill(0);
                    d.exports = {
                        hash: function(e, t, n, r) {
                            for(var o = t(function(e, t) {
                                e.length % f != 0 && (n = e.length + (f - e.length % f), e = a.concat([
                                    e,
                                    l
                                ], n));
                                for(var n, r = [], o = t ? e.readInt32BE : e.readInt32LE, i = 0; i < e.length; i += f)r.push(o.call(e, i));
                                return r;
                            }(e = a.isBuffer(e) ? e : new a(e), r), 8 * e.length), t = r, i = new a(n), u = t ? i.writeInt32BE : i.writeInt32LE, s = 0; s < o.length; s++)u.call(i, o[s], 4 * s, !0);
                            return i;
                        }
                    };
                }).call(this, c("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, c("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/helpers.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                buffer: 3,
                lYpoI2: 11
            }
        ],
        5: [
            function(v, e, _) {
                (function(l, c, u, d, h, p, g, y, w) {
                    var u = v("buffer").Buffer, e = v("./sha"), t = v("./sha256"), n = v("./rng"), b = {
                        sha1: e,
                        sha256: t,
                        md5: v("./md5")
                    }, s = 64, a = new u(s);
                    function r(e, n) {
                        var r = b[e = e || "sha1"], o = [];
                        return r || i("algorithm:", e, "is not yet supported"), {
                            update: function(e) {
                                return u.isBuffer(e) || (e = new u(e)), o.push(e), e.length, this;
                            },
                            digest: function(e) {
                                var t = u.concat(o), t = n ? function(e, t, n) {
                                    u.isBuffer(t) || (t = new u(t)), u.isBuffer(n) || (n = new u(n)), t.length > s ? t = e(t) : t.length < s && (t = u.concat([
                                        t,
                                        a
                                    ], s));
                                    for(var r = new u(s), o = new u(s), i = 0; i < s; i++)r[i] = 54 ^ t[i], o[i] = 92 ^ t[i];
                                    return n = e(u.concat([
                                        r,
                                        n
                                    ])), e(u.concat([
                                        o,
                                        n
                                    ]));
                                }(r, n, t) : r(t);
                                return o = null, e ? t.toString(e) : t;
                            }
                        };
                    }
                    function i() {
                        var e = [].slice.call(arguments).join(" ");
                        throw new Error([
                            e,
                            "we accept pull requests",
                            "http://github.com/dominictarr/crypto-browserify"
                        ].join("\n"));
                    }
                    a.fill(0), _.createHash = function(e) {
                        return r(e);
                    }, _.createHmac = r, _.randomBytes = function(e, t) {
                        if (!t || !t.call) return new u(n(e));
                        try {
                            t.call(this, void 0, new u(n(e)));
                        } catch (e) {
                            t(e);
                        }
                    };
                    var o, f = [
                        "createCredentials",
                        "createCipher",
                        "createCipheriv",
                        "createDecipher",
                        "createDecipheriv",
                        "createSign",
                        "createVerify",
                        "createDiffieHellman",
                        "pbkdf2"
                    ], m = function(e) {
                        _[e] = function() {
                            i("sorry,", e, "is not implemented yet");
                        };
                    };
                    for(o in f)m(f[o], o);
                }).call(this, v("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, v("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/index.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                "./md5": 6,
                "./rng": 7,
                "./sha": 8,
                "./sha256": 9,
                buffer: 3,
                lYpoI2: 11
            }
        ],
        6: [
            function(w, b, e) {
                (function(e, r, o, i, u, a, f, l, y) {
                    var t = w("./helpers");
                    function n(e, t) {
                        e[t >> 5] |= 128 << t % 32, e[14 + (t + 64 >>> 9 << 4)] = t;
                        for(var n = 1732584193, r = -271733879, o = -1732584194, i = 271733878, u = 0; u < e.length; u += 16){
                            var s = n, a = r, f = o, l = i, n = c(n, r, o, i, e[u + 0], 7, -680876936), i = c(i, n, r, o, e[u + 1], 12, -389564586), o = c(o, i, n, r, e[u + 2], 17, 606105819), r = c(r, o, i, n, e[u + 3], 22, -1044525330);
                            n = c(n, r, o, i, e[u + 4], 7, -176418897), i = c(i, n, r, o, e[u + 5], 12, 1200080426), o = c(o, i, n, r, e[u + 6], 17, -1473231341), r = c(r, o, i, n, e[u + 7], 22, -45705983), n = c(n, r, o, i, e[u + 8], 7, 1770035416), i = c(i, n, r, o, e[u + 9], 12, -1958414417), o = c(o, i, n, r, e[u + 10], 17, -42063), r = c(r, o, i, n, e[u + 11], 22, -1990404162), n = c(n, r, o, i, e[u + 12], 7, 1804603682), i = c(i, n, r, o, e[u + 13], 12, -40341101), o = c(o, i, n, r, e[u + 14], 17, -1502002290), n = d(n, r = c(r, o, i, n, e[u + 15], 22, 1236535329), o, i, e[u + 1], 5, -165796510), i = d(i, n, r, o, e[u + 6], 9, -1069501632), o = d(o, i, n, r, e[u + 11], 14, 643717713), r = d(r, o, i, n, e[u + 0], 20, -373897302), n = d(n, r, o, i, e[u + 5], 5, -701558691), i = d(i, n, r, o, e[u + 10], 9, 38016083), o = d(o, i, n, r, e[u + 15], 14, -660478335), r = d(r, o, i, n, e[u + 4], 20, -405537848), n = d(n, r, o, i, e[u + 9], 5, 568446438), i = d(i, n, r, o, e[u + 14], 9, -1019803690), o = d(o, i, n, r, e[u + 3], 14, -187363961), r = d(r, o, i, n, e[u + 8], 20, 1163531501), n = d(n, r, o, i, e[u + 13], 5, -1444681467), i = d(i, n, r, o, e[u + 2], 9, -51403784), o = d(o, i, n, r, e[u + 7], 14, 1735328473), n = h(n, r = d(r, o, i, n, e[u + 12], 20, -1926607734), o, i, e[u + 5], 4, -378558), i = h(i, n, r, o, e[u + 8], 11, -2022574463), o = h(o, i, n, r, e[u + 11], 16, 1839030562), r = h(r, o, i, n, e[u + 14], 23, -35309556), n = h(n, r, o, i, e[u + 1], 4, -1530992060), i = h(i, n, r, o, e[u + 4], 11, 1272893353), o = h(o, i, n, r, e[u + 7], 16, -155497632), r = h(r, o, i, n, e[u + 10], 23, -1094730640), n = h(n, r, o, i, e[u + 13], 4, 681279174), i = h(i, n, r, o, e[u + 0], 11, -358537222), o = h(o, i, n, r, e[u + 3], 16, -722521979), r = h(r, o, i, n, e[u + 6], 23, 76029189), n = h(n, r, o, i, e[u + 9], 4, -640364487), i = h(i, n, r, o, e[u + 12], 11, -421815835), o = h(o, i, n, r, e[u + 15], 16, 530742520), n = p(n, r = h(r, o, i, n, e[u + 2], 23, -995338651), o, i, e[u + 0], 6, -198630844), i = p(i, n, r, o, e[u + 7], 10, 1126891415), o = p(o, i, n, r, e[u + 14], 15, -1416354905), r = p(r, o, i, n, e[u + 5], 21, -57434055), n = p(n, r, o, i, e[u + 12], 6, 1700485571), i = p(i, n, r, o, e[u + 3], 10, -1894986606), o = p(o, i, n, r, e[u + 10], 15, -1051523), r = p(r, o, i, n, e[u + 1], 21, -2054922799), n = p(n, r, o, i, e[u + 8], 6, 1873313359), i = p(i, n, r, o, e[u + 15], 10, -30611744), o = p(o, i, n, r, e[u + 6], 15, -1560198380), r = p(r, o, i, n, e[u + 13], 21, 1309151649), n = p(n, r, o, i, e[u + 4], 6, -145523070), i = p(i, n, r, o, e[u + 11], 10, -1120210379), o = p(o, i, n, r, e[u + 2], 15, 718787259), r = p(r, o, i, n, e[u + 9], 21, -343485551), n = g(n, s), r = g(r, a), o = g(o, f), i = g(i, l);
                        }
                        return Array(n, r, o, i);
                    }
                    function s(e, t, n, r, o, i) {
                        return g((t = g(g(t, e), g(r, i))) << o | t >>> 32 - o, n);
                    }
                    function c(e, t, n, r, o, i, u) {
                        return s(t & n | ~t & r, e, t, o, i, u);
                    }
                    function d(e, t, n, r, o, i, u) {
                        return s(t & r | n & ~r, e, t, o, i, u);
                    }
                    function h(e, t, n, r, o, i, u) {
                        return s(t ^ n ^ r, e, t, o, i, u);
                    }
                    function p(e, t, n, r, o, i, u) {
                        return s(n ^ (t | ~r), e, t, o, i, u);
                    }
                    function g(e, t) {
                        var n = (65535 & e) + (65535 & t);
                        return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
                    }
                    b.exports = function(e) {
                        return t.hash(e, n, 16);
                    };
                }).call(this, w("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, w("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/md5.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                "./helpers": 4,
                buffer: 3,
                lYpoI2: 11
            }
        ],
        7: [
            function(e, l, t) {
                (function(e, t, n, r, o, i, u, s, f) {
                    var a;
                    l.exports = a || function(e) {
                        for(var t, n = new Array(e), r = 0; r < e; r++)0 == (3 & r) && (t = 4294967296 * Math.random()), n[r] = t >>> ((3 & r) << 3) & 255;
                        return n;
                    };
                }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/rng.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                buffer: 3,
                lYpoI2: 11
            }
        ],
        8: [
            function(c, d, e) {
                (function(e, t, n, r, o, s, a, f, l) {
                    var i = c("./helpers");
                    function u(l, c) {
                        l[c >> 5] |= 128 << 24 - c % 32, l[15 + (c + 64 >> 9 << 4)] = c;
                        for(var e, t, n, r = Array(80), o = 1732584193, i = -271733879, u = -1732584194, s = 271733878, d = -1009589776, h = 0; h < l.length; h += 16){
                            for(var p = o, g = i, y = u, w = s, b = d, a = 0; a < 80; a++){
                                r[a] = a < 16 ? l[h + a] : v(r[a - 3] ^ r[a - 8] ^ r[a - 14] ^ r[a - 16], 1);
                                var f = m(m(v(o, 5), (f = i, t = u, n = s, (e = a) < 20 ? f & t | ~f & n : !(e < 40) && e < 60 ? f & t | f & n | t & n : f ^ t ^ n)), m(m(d, r[a]), (e = a) < 20 ? 1518500249 : e < 40 ? 1859775393 : e < 60 ? -1894007588 : -899497514)), d = s, s = u, u = v(i, 30), i = o, o = f;
                            }
                            o = m(o, p), i = m(i, g), u = m(u, y), s = m(s, w), d = m(d, b);
                        }
                        return Array(o, i, u, s, d);
                    }
                    function m(e, t) {
                        var n = (65535 & e) + (65535 & t);
                        return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
                    }
                    function v(e, t) {
                        return e << t | e >>> 32 - t;
                    }
                    d.exports = function(e) {
                        return i.hash(e, u, 20, !0);
                    };
                }).call(this, c("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, c("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                "./helpers": 4,
                buffer: 3,
                lYpoI2: 11
            }
        ],
        9: [
            function(c, d, e) {
                (function(e, t, n, r, u, s, a, f, l) {
                    function b(e, t) {
                        var n = (65535 & e) + (65535 & t);
                        return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
                    }
                    function o(e, l) {
                        var c, d = new Array(1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298), t = new Array(1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225), n = new Array(64);
                        e[l >> 5] |= 128 << 24 - l % 32, e[15 + (l + 64 >> 9 << 4)] = l;
                        for(var r, o, h = 0; h < e.length; h += 16){
                            for(var i = t[0], u = t[1], s = t[2], p = t[3], a = t[4], g = t[5], y = t[6], w = t[7], f = 0; f < 64; f++)n[f] = f < 16 ? e[f + h] : b(b(b((o = n[f - 2], m(o, 17) ^ m(o, 19) ^ v(o, 10)), n[f - 7]), (o = n[f - 15], m(o, 7) ^ m(o, 18) ^ v(o, 3))), n[f - 16]), c = b(b(b(b(w, m(o = a, 6) ^ m(o, 11) ^ m(o, 25)), a & g ^ ~a & y), d[f]), n[f]), r = b(m(r = i, 2) ^ m(r, 13) ^ m(r, 22), i & u ^ i & s ^ u & s), w = y, y = g, g = a, a = b(p, c), p = s, s = u, u = i, i = b(c, r);
                            t[0] = b(i, t[0]), t[1] = b(u, t[1]), t[2] = b(s, t[2]), t[3] = b(p, t[3]), t[4] = b(a, t[4]), t[5] = b(g, t[5]), t[6] = b(y, t[6]), t[7] = b(w, t[7]);
                        }
                        return t;
                    }
                    var i = c("./helpers"), m = function(e, t) {
                        return e >>> t | e << 32 - t;
                    }, v = function(e, t) {
                        return e >>> t;
                    };
                    d.exports = function(e) {
                        return i.hash(e, o, 32, !0);
                    };
                }).call(this, c("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, c("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha256.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                "./helpers": 4,
                buffer: 3,
                lYpoI2: 11
            }
        ],
        10: [
            function(e, t, f) {
                (function(e, t, n, r, o, i, u, s, a) {
                    f.read = function(e, t, n, r, o) {
                        var i, u, l = 8 * o - r - 1, c = (1 << l) - 1, d = c >> 1, s = -7, a = n ? o - 1 : 0, f = n ? -1 : 1, o = e[t + a];
                        for(a += f, i = o & (1 << -s) - 1, o >>= -s, s += l; 0 < s; i = 256 * i + e[t + a], a += f, s -= 8);
                        for(u = i & (1 << -s) - 1, i >>= -s, s += r; 0 < s; u = 256 * u + e[t + a], a += f, s -= 8);
                        if (0 === i) i = 1 - d;
                        else {
                            if (i === c) return u ? NaN : 1 / 0 * (o ? -1 : 1);
                            u += Math.pow(2, r), i -= d;
                        }
                        return (o ? -1 : 1) * u * Math.pow(2, i - r);
                    }, f.write = function(e, t, l, n, r, c) {
                        var o, i, u = 8 * c - r - 1, s = (1 << u) - 1, a = s >> 1, d = 23 === r ? Math.pow(2, -24) - Math.pow(2, -77) : 0, f = n ? 0 : c - 1, h = n ? 1 : -1, c = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
                        for(t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (i = isNaN(t) ? 1 : 0, o = s) : (o = Math.floor(Math.log(t) / Math.LN2), t * (n = Math.pow(2, -o)) < 1 && (o--, n *= 2), 2 <= (t += 1 <= o + a ? d / n : d * Math.pow(2, 1 - a)) * n && (o++, n /= 2), s <= o + a ? (i = 0, o = s) : 1 <= o + a ? (i = (t * n - 1) * Math.pow(2, r), o += a) : (i = t * Math.pow(2, a - 1) * Math.pow(2, r), o = 0)); 8 <= r; e[l + f] = 255 & i, f += h, i /= 256, r -= 8);
                        for(o = o << r | i, u += r; 0 < u; e[l + f] = 255 & o, f += h, o /= 256, u -= 8);
                        e[l + f - h] |= 128 * c;
                    };
                }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/ieee754/index.js", "/node_modules/gulp-browserify/node_modules/ieee754");
            },
            {
                buffer: 3,
                lYpoI2: 11
            }
        ],
        11: [
            function(e, h, t) {
                (function(e, t, n, r, o, f, l, c, d) {
                    var i, u, s;
                    function a() {}
                    (e = h.exports = {}).nextTick = (u = "undefined" != typeof window && window.setImmediate, s = "undefined" != typeof window && window.postMessage && window.addEventListener, u ? function(e) {
                        return window.setImmediate(e);
                    } : s ? (i = [], window.addEventListener("message", function(e) {
                        var t = e.source;
                        t !== window && null !== t || "process-tick" !== e.data || (e.stopPropagation(), 0 < i.length && i.shift()());
                    }, !0), function(e) {
                        i.push(e), window.postMessage("process-tick", "*");
                    }) : function(e) {
                        setTimeout(e, 0);
                    }), e.title = "browser", e.browser = !0, e.env = {}, e.argv = [], e.on = a, e.addListener = a, e.once = a, e.off = a, e.removeListener = a, e.removeAllListeners = a, e.emit = a, e.binding = function(e) {
                        throw new Error("process.binding is not supported");
                    }, e.cwd = function() {
                        return "/";
                    }, e.chdir = function(e) {
                        throw new Error("process.chdir is not supported");
                    };
                }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/process/browser.js", "/node_modules/gulp-browserify/node_modules/process");
            },
            {
                buffer: 3,
                lYpoI2: 11
            }
        ]
    }, {}, [
        1
    ])(1);
});

});

parcelRegister("j3eHA", function(module, exports) {
$parcel$export(module.exports, "READ_GLOBAL_CHANNEL_SCOPE", () => $dab30b9cd36e0954$export$ee06a15cbffa31b);
$parcel$export(module.exports, "useSubscribeRealtimeChannel", () => $dab30b9cd36e0954$export$21407f03011cb801);

var $kuAvn = parcelRequire("kuAvn");

var $6NFTG = parcelRequire("6NFTG");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $3ETQp = parcelRequire("3ETQp");
const $dab30b9cd36e0954$export$ee06a15cbffa31b = 'read:app-global-channel:realtime';
const $dab30b9cd36e0954$var$realtimeChannel = (0, $kuAvn.default)`
	subscription realtimeChannel(
		$installationId: ID!
		$name: String!
		$context: String
		$isGlobal: Boolean
		$token: String
	) {
		ecosystem {
			realtimeChannel(
				installationId: $installationId
				name: $name
				context: $context
				isGlobal: $isGlobal
				token: $token
			) {
				payload
			}
		}
	}
`;
const $dab30b9cd36e0954$var$globalRealtimeChannelQuery = (0, $kuAvn.default)`
	subscription globalRealtimeChannel($installationId: ID!, $name: String!, $token: String) {
		ecosystem {
			globalRealtimeChannel(installationId: $installationId, name: $name, token: $token) {
				payload
			}
		}
	}
`;
const $dab30b9cd36e0954$var$getChannelKey = (context)=>{
    return Object.entries(context).sort((a, b)=>a[0].localeCompare(b[0])).toString();
};
const $dab30b9cd36e0954$export$905d34fe81a9cf60 = ({ isOauthScopedEndpoint: isOauthScopedEndpoint, payload: payload, context: context, installationId: installationId, contextToken: contextToken })=>{
    const query = isOauthScopedEndpoint ? {
        operationName: 'globalRealtimeChannel',
        query: (0, $6NFTG.print)($dab30b9cd36e0954$var$globalRealtimeChannelQuery)
    } : {
        operationName: 'realtimeChannel',
        query: (0, $6NFTG.print)($dab30b9cd36e0954$var$realtimeChannel)
    };
    return {
        ...query,
        variables: {
            installationId: installationId,
            name: payload.data.channelName,
            ...!isOauthScopedEndpoint && {
                context: context,
                isGlobal: payload.data.isGlobal ?? false
            },
            token: payload.data.options?.token
        },
        extensions: {
            'x-forge-context-token': contextToken,
            ...payload.data.options?.replaySeconds && {
                command: {
                    type: 'replay',
                    data: {
                        // Timestamp in seconds of when to replay messages from. Valid for up to 7 days in the past.
                        sequenceNumber: Date.now() / 1000 - payload.data.options.replaySeconds
                    }
                }
            }
        }
    };
};
const $dab30b9cd36e0954$var$unsubscribeAllSubscriptions = (activeSubscriptions)=>{
    activeSubscriptions.forEach((subscription)=>{
        if (!subscription.closed) subscription.unsubscribe();
    });
    activeSubscriptions.clear();
};
const $dab30b9cd36e0954$export$21407f03011cb801 = (installationId, context)=>{
    const activeSubscriptions = (0, $eJOHy.useRef)(new Map());
    (0, $eJOHy.useEffect)(()=>{
        const currentSubscriptions = activeSubscriptions.current;
        return ()=>{
            $dab30b9cd36e0954$var$unsubscribeAllSubscriptions(currentSubscriptions);
        };
    }, []);
    // this is the bridge method that will be called from the extension
    return async (payload, contextToken)=>{
        const { onEvent: onEvent } = payload.data;
        const channelContext = payload.data.options?.contextOverrides ? JSON.stringify({
            context: context,
            contextOverrides: payload.data.options?.contextOverrides
        }) : context;
        const channelKey = $dab30b9cd36e0954$var$getChannelKey({
            channelName: payload.data.channelName,
            isGlobal: payload.data.isGlobal,
            channelContext: channelContext
        });
        const existingSubscription = activeSubscriptions.current.get(channelKey);
        const isGqlCallToOauthScopedEndpoint = (0, $eGOwo.fg)('forge_realtime_uses_new_oauth_scoped_endpoint') && !!payload.data.isGlobal;
        if (existingSubscription) {
            // if subscription already exists
            existingSubscription.addCallback(onEvent);
            onEvent('SUBSCRIPTION_STARTED');
        } else {
            const subscription = (0, $3ETQp.subscribe)($dab30b9cd36e0954$export$905d34fe81a9cf60({
                isOauthScopedEndpoint: isGqlCallToOauthScopedEndpoint,
                payload: payload,
                context: channelContext,
                installationId: installationId,
                contextToken: contextToken
            }), {
                next: (result)=>{
                    subscription.onNext(isGqlCallToOauthScopedEndpoint ? result.data.ecosystem?.globalRealtimeChannel?.payload : result.data.ecosystem?.realtimeChannel?.payload);
                },
                error: (err)=>{
                    subscription.onError(err);
                    activeSubscriptions.current.delete(channelKey);
                },
                complete: ()=>{
                    activeSubscriptions.current.delete(channelKey);
                }
            }, onEvent);
            activeSubscriptions.current.set(channelKey, subscription);
        }
        return {
            unsubscribe: ()=>{
                const subscription = activeSubscriptions.current.get(channelKey);
                if (subscription) {
                    // remove one subscription
                    subscription.removeCallback(onEvent);
                    // if no more subscriptions remove the channelKey and unsubscribe
                    if (subscription.subscriptionCallbacks.length === 0) {
                        activeSubscriptions.current.delete(channelKey);
                        if (!subscription.closed) subscription.unsubscribe();
                    }
                }
            }
        };
    };
};

});
parcelRegister("6NFTG", function(module, exports) {
$parcel$export(module.exports, "print", () => $4f37d191c0ef7631$export$c2d084dc44961371);

var $9E3xk = parcelRequire("9E3xk");

var $l68uS = parcelRequire("l68uS");
function $4f37d191c0ef7631$export$c2d084dc44961371(ast) {
    return (0, $9E3xk.visit)(ast, {
        leave: $4f37d191c0ef7631$var$printDocASTReducer
    });
}
var $4f37d191c0ef7631$var$MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future
var $4f37d191c0ef7631$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return '$' + node.name;
    },
    // Document
    Document: function Document(node) {
        return $4f37d191c0ef7631$var$join(node.definitions, '\n\n') + '\n';
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $4f37d191c0ef7631$var$wrap('(', $4f37d191c0ef7631$var$join(node.variableDefinitions, ', '), ')');
        var directives = $4f37d191c0ef7631$var$join(node.directives, ' ');
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === 'query' ? selectionSet : $4f37d191c0ef7631$var$join([
            op,
            $4f37d191c0ef7631$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], ' ');
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ': ' + type + $4f37d191c0ef7631$var$wrap(' = ', defaultValue) + $4f37d191c0ef7631$var$wrap(' ', $4f37d191c0ef7631$var$join(directives, ' '));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $4f37d191c0ef7631$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        var prefix = $4f37d191c0ef7631$var$wrap('', alias, ': ') + name;
        var argsLine = prefix + $4f37d191c0ef7631$var$wrap('(', $4f37d191c0ef7631$var$join(args, ', '), ')');
        if (argsLine.length > $4f37d191c0ef7631$var$MAX_LINE_LENGTH) argsLine = prefix + $4f37d191c0ef7631$var$wrap('(\n', $4f37d191c0ef7631$var$indent($4f37d191c0ef7631$var$join(args, '\n')), '\n)');
        return $4f37d191c0ef7631$var$join([
            argsLine,
            $4f37d191c0ef7631$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ': ' + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return '...' + name + $4f37d191c0ef7631$var$wrap(' ', $4f37d191c0ef7631$var$join(directives, ' '));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $4f37d191c0ef7631$var$join([
            '...',
            $4f37d191c0ef7631$var$wrap('on ', typeCondition),
            $4f37d191c0ef7631$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($4f37d191c0ef7631$var$wrap('(', $4f37d191c0ef7631$var$join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat($4f37d191c0ef7631$var$wrap('', $4f37d191c0ef7631$var$join(directives, ' '), ' ')) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $l68uS.printBlockString)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? 'true' : 'false';
    },
    NullValue: function NullValue() {
        return 'null';
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return '[' + $4f37d191c0ef7631$var$join(values, ', ') + ']';
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return '{' + $4f37d191c0ef7631$var$join(fields, ', ') + '}';
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ': ' + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return '@' + name + $4f37d191c0ef7631$var$wrap('(', $4f37d191c0ef7631$var$join(args, ', '), ')');
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return '[' + type + ']';
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + '!';
    },
    // Type System Definitions
    SchemaDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $4f37d191c0ef7631$var$join([
            'schema',
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(operationTypes)
        ], ' ');
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ': ' + type;
    },
    ScalarTypeDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $4f37d191c0ef7631$var$join([
            'scalar',
            name,
            $4f37d191c0ef7631$var$join(directives, ' ')
        ], ' ');
    }),
    ObjectTypeDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $4f37d191c0ef7631$var$join([
            'type',
            name,
            $4f37d191c0ef7631$var$wrap('implements ', $4f37d191c0ef7631$var$join(interfaces, ' & ')),
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(fields)
        ], ' ');
    }),
    FieldDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($4f37d191c0ef7631$var$hasMultilineItems(args) ? $4f37d191c0ef7631$var$wrap('(\n', $4f37d191c0ef7631$var$indent($4f37d191c0ef7631$var$join(args, '\n')), '\n)') : $4f37d191c0ef7631$var$wrap('(', $4f37d191c0ef7631$var$join(args, ', '), ')')) + ': ' + type + $4f37d191c0ef7631$var$wrap(' ', $4f37d191c0ef7631$var$join(directives, ' '));
    }),
    InputValueDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $4f37d191c0ef7631$var$join([
            name + ': ' + type,
            $4f37d191c0ef7631$var$wrap('= ', defaultValue),
            $4f37d191c0ef7631$var$join(directives, ' ')
        ], ' ');
    }),
    InterfaceTypeDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return $4f37d191c0ef7631$var$join([
            'interface',
            name,
            $4f37d191c0ef7631$var$wrap('implements ', $4f37d191c0ef7631$var$join(interfaces, ' & ')),
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(fields)
        ], ' ');
    }),
    UnionTypeDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $4f37d191c0ef7631$var$join([
            'union',
            name,
            $4f37d191c0ef7631$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $4f37d191c0ef7631$var$join(types, ' | ') : ''
        ], ' ');
    }),
    EnumTypeDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $4f37d191c0ef7631$var$join([
            'enum',
            name,
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(values)
        ], ' ');
    }),
    EnumValueDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $4f37d191c0ef7631$var$join([
            name,
            $4f37d191c0ef7631$var$join(directives, ' ')
        ], ' ');
    }),
    InputObjectTypeDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $4f37d191c0ef7631$var$join([
            'input',
            name,
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(fields)
        ], ' ');
    }),
    DirectiveDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return 'directive @' + name + ($4f37d191c0ef7631$var$hasMultilineItems(args) ? $4f37d191c0ef7631$var$wrap('(\n', $4f37d191c0ef7631$var$indent($4f37d191c0ef7631$var$join(args, '\n')), '\n)') : $4f37d191c0ef7631$var$wrap('(', $4f37d191c0ef7631$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $4f37d191c0ef7631$var$join(locations, ' | ');
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $4f37d191c0ef7631$var$join([
            'extend schema',
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(operationTypes)
        ], ' ');
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $4f37d191c0ef7631$var$join([
            'extend scalar',
            name,
            $4f37d191c0ef7631$var$join(directives, ' ')
        ], ' ');
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $4f37d191c0ef7631$var$join([
            'extend type',
            name,
            $4f37d191c0ef7631$var$wrap('implements ', $4f37d191c0ef7631$var$join(interfaces, ' & ')),
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(fields)
        ], ' ');
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return $4f37d191c0ef7631$var$join([
            'extend interface',
            name,
            $4f37d191c0ef7631$var$wrap('implements ', $4f37d191c0ef7631$var$join(interfaces, ' & ')),
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(fields)
        ], ' ');
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $4f37d191c0ef7631$var$join([
            'extend union',
            name,
            $4f37d191c0ef7631$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $4f37d191c0ef7631$var$join(types, ' | ') : ''
        ], ' ');
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $4f37d191c0ef7631$var$join([
            'extend enum',
            name,
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(values)
        ], ' ');
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $4f37d191c0ef7631$var$join([
            'extend input',
            name,
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(fields)
        ], ' ');
    }
};
function $4f37d191c0ef7631$var$addDescription(cb) {
    return function(node) {
        return $4f37d191c0ef7631$var$join([
            node.description,
            cb(node)
        ], '\n');
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $4f37d191c0ef7631$var$join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $4f37d191c0ef7631$var$block(array) {
    return $4f37d191c0ef7631$var$wrap('{\n', $4f37d191c0ef7631$var$indent($4f37d191c0ef7631$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $4f37d191c0ef7631$var$wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $4f37d191c0ef7631$var$indent(str) {
    return $4f37d191c0ef7631$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $4f37d191c0ef7631$var$isMultiline(str) {
    return str.indexOf('\n') !== -1;
}
function $4f37d191c0ef7631$var$hasMultilineItems(maybeArray) {
    return maybeArray != null && maybeArray.some($4f37d191c0ef7631$var$isMultiline);
}

});

parcelRegister("3ETQp", function(module, exports) {
$parcel$export(module.exports, "subscribe", () => $1be542ca3cca84df$export$ec068583843480e7);

var $aP5Ku = parcelRequire("aP5Ku");

var $eGOwo = parcelRequire("eGOwo");
const $1be542ca3cca84df$var$getAGGWebsocketURI = ()=>{
    return `wss://${window.location.host}/gateway/api/graphql/subscriptions`;
};
const $1be542ca3cca84df$var$createAGGSubscriptionClient = ()=>{
    return (0, $aP5Ku.createClient)({
        url: $1be542ca3cca84df$var$getAGGWebsocketURI(),
        retryAttempts: 2,
        lazy: true
    });
};
const $1be542ca3cca84df$var$getAGGSubscriptionClient = ()=>{
    let client = window.__FORGE_AGG_SUBSCRIPTION_CLIENT__;
    if (!client) {
        client = $1be542ca3cca84df$var$createAGGSubscriptionClient();
        window.__FORGE_AGG_SUBSCRIPTION_CLIENT__ = client;
    }
    return client;
};
class $1be542ca3cca84df$var$BasicSubscription {
    constructor(baseUnsubscribe, callback){
        this.closed = false;
        this.baseUnsubscribe = baseUnsubscribe;
        this._subscriptionCallbacks = [
            callback
        ];
    }
    get subscriptionCallbacks() {
        return this._subscriptionCallbacks;
    }
    unsubscribe() {
        if (!this.closed) {
            this.baseUnsubscribe();
            this.closed = true;
            this._subscriptionCallbacks = [];
        }
    }
    addCallback(callback) {
        this._subscriptionCallbacks.push(callback);
    }
    removeCallback(callback) {
        const index = this._subscriptionCallbacks.indexOf(callback);
        if (index !== -1) this._subscriptionCallbacks.splice(index, 1);
    }
    onNext(event) {
        const payload = (0, $eGOwo.fg)('forge-ui-allow-realtime-object-payloads') ? this.parsePayload(event) : event;
        this._subscriptionCallbacks.forEach((callback)=>{
            try {
                callback(payload);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('[forge-realtime] Error in subscription callback: ', error);
            }
        });
    }
    onError(error) {
        this._subscriptionCallbacks.forEach((callback)=>{
            try {
                callback(null, error);
            } catch (callbackError) {
                // eslint-disable-next-line no-console
                console.error('[forge-realtime] Error in subscription callback:', callbackError);
            }
        });
    }
    parsePayload(payload) {
        try {
            return JSON.parse(payload);
        // eslint-disable-next-line no-unused-vars
        } catch (err) {
            return payload;
        }
    }
}
const $1be542ca3cca84df$export$ec068583843480e7 = (payload, sink, subscriptionCallback, client)=>{
    if (!client) client = $1be542ca3cca84df$var$getAGGSubscriptionClient();
    const unsubscribe = client.subscribe(payload, sink);
    return new $1be542ca3cca84df$var$BasicSubscription(unsubscribe, subscriptionCallback);
};

});


parcelRegister("bVrOy", function(module, exports) {
$parcel$export(module.exports, "invokeExtensionMutation", () => $0c6ac78555f8e0ae$export$46af696e5313090f);
$parcel$export(module.exports, "useInvokeExtension", () => $0c6ac78555f8e0ae$export$19d283d2f5a7d3c);

var $7pA0u = parcelRequire("7pA0u");

var $kuAvn = parcelRequire("kuAvn");

var $1fMqv = parcelRequire("1fMqv");

var $cwqPy = parcelRequire("cwqPy");
const $0c6ac78555f8e0ae$export$46af696e5313090f = (0, $kuAvn.default)`
	mutation forge_ui_invokeExtension($input: InvokeExtensionInput!) {
		invokeExtension(input: $input) {
			success
			response {
				body
			}
			contextToken {
				jwt
				expiresAt
			}
			errors {
				message
				extensions {
					errorType
					statusCode
					... on InvokeExtensionPayloadErrorExtension {
						fields {
							authInfoUrl
						}
					}
				}
			}
		}
	}
`;
const $0c6ac78555f8e0ae$export$19d283d2f5a7d3c = (contextIds, extensionId, options)=>{
    const [mutationFunction] = (0, $1fMqv.useMutation)($0c6ac78555f8e0ae$export$46af696e5313090f, options);
    return (0, $7pA0u.useCallbackOne)((payload, entryPoint = 'resolver')=>mutationFunction({
            variables: {
                input: {
                    contextIds: contextIds,
                    extensionId: extensionId,
                    payload: payload,
                    entryPoint: entryPoint
                }
            },
            context: {
                headers: {
                    'atl-attribution': (0, $cwqPy.createAtlAttributionHeader)(contextIds.sort().join())
                }
            }
        }), [
        contextIds,
        extensionId,
        mutationFunction
    ]);
};

});

parcelRegister("6Tf8M", function(module, exports) {
$parcel$export(module.exports, "usePublishRealtimeChannel", () => $eac0a8e326349a7b$export$df7d62be1d7f5fc9);

var $kuAvn = parcelRequire("kuAvn");

var $1fMqv = parcelRequire("1fMqv");

var $eGOwo = parcelRequire("eGOwo");

var $cwqPy = parcelRequire("cwqPy");
const $eac0a8e326349a7b$export$50666a6a6eccdc2e = (0, $kuAvn.default)`
	mutation publishRealtimeChannel(
		$installationId: ID!
		$name: String!
		$payload: String!
		$context: String
		$isGlobal: Boolean
		$token: String
	) {
		ecosystem {
			publishRealtimeChannel(
				installationId: $installationId
				name: $name
				payload: $payload
				context: $context
				isGlobal: $isGlobal
				token: $token
			) {
				eventId
				eventTimestamp
			}
		}
	}
`;
const $eac0a8e326349a7b$export$df7d62be1d7f5fc9 = (installationId, context, options)=>{
    const [mutationFunction] = (0, $1fMqv.useMutation)($eac0a8e326349a7b$export$50666a6a6eccdc2e, options);
    return async (payload, contextToken)=>{
        const { channelName: channelName, isGlobal: isGlobal, options: options } = payload.data;
        const { token: token, contextOverrides: contextOverrides } = options || {};
        const eventPayload = (0, $eGOwo.fg)('forge-ui-allow-realtime-object-payloads') ? JSON.stringify(payload.data.eventPayload) : payload.data.eventPayload;
        const channelContext = contextOverrides ? JSON.stringify({
            context: context,
            contextOverrides: contextOverrides
        }) : context;
        const { data: data } = await mutationFunction({
            variables: {
                installationId: installationId,
                name: channelName,
                context: channelContext,
                payload: eventPayload,
                isGlobal: isGlobal ?? false,
                token: token
            },
            context: {
                headers: {
                    'atl-attribution': (0, $cwqPy.createAtlAttributionHeader)(),
                    'x-forge-context-token': contextToken
                }
            }
        });
        if (data?.ecosystem.publishRealtimeChannel) {
            const { eventId: eventId, eventTimestamp: eventTimestamp } = data.ecosystem.publishRealtimeChannel;
            return {
                eventId: eventId,
                eventTimestamp: eventTimestamp
            };
        }
    };
};

});

parcelRegister("iCkyS", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b2d20e1c6840a80$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ThreeLOPromptRenderFn", () => $9b2d20e1c6840a80$export$92dadb4ff2941f34);
$parcel$export(module.exports, "makeThreeLOPrompt", () => $9b2d20e1c6840a80$export$388ff2bd3ce4e348);
$parcel$export(module.exports, "makeThreeLOPromptForCustomUI", () => $9b2d20e1c6840a80$export$7519b5f6e74be543);
/* threeLOPrompt.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7qGN1 = parcelRequire("7qGN1");
var $kDaaB = parcelRequire("kDaaB");

var $dW738 = parcelRequire("dW738");

var $8IeH1 = parcelRequire("8IeH1");

var $iHPvF = parcelRequire("iHPvF");

var $5CSKW = parcelRequire("5CSKW");

var $5AgM9 = parcelRequire("5AgM9");
const $9b2d20e1c6840a80$var$styles = {
    box: "_1h6dtmh3 _1dqonqa1 _189e1dm9"
};
const $9b2d20e1c6840a80$var$ThreeLOPrompt = (props)=>{
    const { loading: loading, startAuth: startAuth, promptMessage: promptMessage, buttonText: buttonText } = (0, $5AgM9.useAuth)(props);
    const { authUrl: authUrl, onInitialization: onInitialization } = props;
    (0, $eJOHy.useEffect)(()=>{
        if (onInitialization) onInitialization();
    }, [
        onInitialization
    ]);
    if (!authUrl || authUrl === '') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iHPvF.default), {
        appearance: "error",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...$9b2d20e1c6840a80$var$messages.noAuthURLErrorMessage
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            onClick: (e)=>e.stopPropagation(),
            padding: "space.250",
            xcss: $9b2d20e1c6840a80$var$styles.box,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dW738.default), {
                alignInline: "start",
                space: "space.250",
                grow: "hug",
                testId: "three-lo-prompt",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                        children: promptMessage
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                        onClick: startAuth,
                        isLoading: loading,
                        children: buttonText
                    })
                ]
            })
        })
    });
};
var $9b2d20e1c6840a80$export$2e2bcd8739ae039 = $9b2d20e1c6840a80$var$ThreeLOPrompt;
const $9b2d20e1c6840a80$export$92dadb4ff2941f34 = ({ forgeDoc: forgeDoc, dispatch: dispatch })=>{
    const { message: message, authUrl: authUrl, promptText: promptText } = forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)($9b2d20e1c6840a80$var$ThreeLOPrompt, {
        message: message,
        authUrl: authUrl,
        promptText: promptText,
        onSuccess: ()=>dispatch({
                type: 'render',
                extensionData: {}
            })
    });
};
const $9b2d20e1c6840a80$export$388ff2bd3ce4e348 = ({ appName: appName, onSuccess: onSuccess })=>{
    return function threeLOPrompt({ forgeDoc: { props: props }, dispatch: dispatch }) {
        const { message: message, authUrl: authUrl, promptText: promptText } = props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)($9b2d20e1c6840a80$var$ThreeLOPrompt, {
            message: message,
            authUrl: authUrl,
            promptText: promptText,
            appName: appName,
            onSuccess: ()=>{
                if (onSuccess) onSuccess();
                return dispatch({
                    type: 'render',
                    extensionData: {}
                });
            }
        });
    };
};
const $9b2d20e1c6840a80$export$7519b5f6e74be543 = ({ appName: appName, onSuccess: onSuccess, message: message, onInitialization: onInitialization })=>{
    return function threeLOPrompt(props) {
        const { authUrl: authUrl, promptText: promptText, onSuccess: onSuccessFromIframeComponent } = props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)($9b2d20e1c6840a80$var$ThreeLOPrompt, {
            message: message,
            authUrl: authUrl,
            promptText: promptText,
            appName: appName,
            onSuccess: ()=>{
                if (onSuccess) onSuccess();
                return Promise.resolve(onSuccessFromIframeComponent);
            },
            onInitialization: onInitialization
        });
    };
};
const $9b2d20e1c6840a80$var$messages = (0, $7qGN1.defineMessages)({
    noAuthURLErrorMessage: {
        id: 'confluence.threeLOPrompt.no.authURL.error-message',
        defaultMessage: 'Consent URL not found. Please refresh the page and try again.',
        description: 'This text is displayed when the URL that gives an app certain permissions is not present.'
    }
});

});
parcelRegister("iHPvF", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c4a865afee94050$export$2e2bcd8739ae039);
/* section-message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $Ay1uj = parcelRequire("Ay1uj");

var $806LH = parcelRequire("806LH");

var $6J9k6 = parcelRequire("6J9k6");

var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");

var $9y5qW = parcelRequire("9y5qW");
const $1c4a865afee94050$var$sectionMessageStyles = {
    container: "_2rko12b0 _1rjcpxbi _18zrpxbi _1nmz1hna",
    iconContainer: "_1mou1i6y _1e0c1txw",
    contentContainer: "_16jlkb7n",
    content: "_11c82smr _syaz1fxt",
    actionsContainer: "_11c82smr",
    dismissButtonContainer: "_1pfh1i6y"
};
const $1c4a865afee94050$var$appearanceStyles = {
    information: "_bfhk33gi",
    warning: "_bfhk1tzq",
    error: "_bfhk1gly",
    success: "_bfhkmv6i",
    discovery: "_bfhk1nvp"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $1c4a865afee94050$var$SectionMessage = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, isDismissible: isDismissible, onDismiss: onDismiss, testId: testId }, ref) {
    const [dismissed, setDismissed] = (0, $eJOHy.useState)(false);
    const handleDismiss = (0, $eJOHy.useCallback)(()=>{
        onDismiss?.();
        setDismissed(true);
    }, [
        onDismiss
    ]);
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $9y5qW.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, $eJOHy.Fragment) ? actions.props.children : actions;
    const actionsArray = (0, $eJOHy.Children).toArray(actionElements);
    return isDismissible && dismissed ? null : /*#__PURE__*/ (0, $gt9Am.jsx)("section", {
        "data-testid": testId,
        ref: ref,
        className: (0, $hcewu.default)([
            $1c4a865afee94050$var$sectionMessageStyles.container,
            $1c4a865afee94050$var$appearanceStyles[appearance]
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            space: "space.200",
            alignBlock: "stretch",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $1c4a865afee94050$var$sectionMessageStyles.iconContainer
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                        size: "medium",
                        primaryColor: primaryColor,
                        secondaryColor: secondaryColor,
                        // props for new icon
                        LEGACY_size: "medium",
                        color: primaryColor,
                        spacing: "spacious"
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                    space: "space.100",
                    testId: testId && `${testId}--content`,
                    xcss: $1c4a865afee94050$var$sectionMessageStyles.contentContainer,
                    children: [
                        !!title && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                            as: "h2",
                            size: "small",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            className: (0, $hcewu.default)([
                                $1c4a865afee94050$var$sectionMessageStyles.content
                            ]),
                            children: children
                        }),
                        actionsArray.length > 0 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                            shouldWrap: true,
                            testId: testId && `${testId}--actions`,
                            separator: "\xb7",
                            space: "space.100",
                            rowSpace: "space.0",
                            // Only use a list role if more than one action is present
                            role: actionsArray.length > 1 ? 'list' : undefined,
                            xcss: $1c4a865afee94050$var$sectionMessageStyles.actionsContainer,
                            children: actionsArray.map((action, id)=>// Only use a listitem role if more than one action is present
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                                    role: actionsArray.length > 1 ? 'listitem' : undefined,
                                    children: action
                                }, id))
                        })
                    ]
                }),
                isDismissible && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $1c4a865afee94050$var$sectionMessageStyles.dismissButtonContainer
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                        testId: testId && `${testId}--dismiss-button`,
                        label: "Dismiss",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6J9k6))),
                        appearance: "subtle",
                        onClick: handleDismiss,
                        spacing: "compact"
                    })
                })
            ]
        })
    });
});
$1c4a865afee94050$var$SectionMessage.displayName = 'SectionMessage';
var $1c4a865afee94050$export$2e2bcd8739ae039 = $1c4a865afee94050$var$SectionMessage;

});
parcelRegister("9y5qW", function(module, exports) {
$parcel$export(module.exports, "getAppearanceIconStyles", () => $1656794cf4e78acc$export$e9b82d2e21ac0c1f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $ejT8C = parcelRequire("ejT8C");

var $1NG86 = parcelRequire("1NG86");

var $i4Iw4 = parcelRequire("i4Iw4");

var $3TFuO = parcelRequire("3TFuO");

var $jkYbX = parcelRequire("jkYbX");

const $1656794cf4e78acc$var$appearanceIconSchema = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $7bb4c1736002a04a$export$226de0355ed012f8)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($i4Iw4))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $7bb4c1736002a04a$export$a6ee3d71bc067634)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $7bb4c1736002a04a$export$8d9596b529bbb9cf)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $7bb4c1736002a04a$export$874739ea9e379ab6)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $7bb4c1736002a04a$export$4b84fd0e2c617bd)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1NG86))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $7bb4c1736002a04a$export$2837b5a1a71d5c02)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $7bb4c1736002a04a$export$8a6341c32b6a3ee6)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3TFuO))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $7bb4c1736002a04a$export$6fa04827ac68a4fb)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $7bb4c1736002a04a$export$363e4475840015bb)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($ejT8C))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $7bb4c1736002a04a$export$147899de772240ec)})`
    }
};
function $1656794cf4e78acc$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $1656794cf4e78acc$var$appearanceIconSchema[appearance] || $1656794cf4e78acc$var$appearanceIconSchema.information;
    const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, $gt9Am.jsx)(appearanceIconStyles.Icon, {
            LEGACY_size: size,
            color: primaryColor,
            spacing: "spacious",
            LEGACY_primaryColor: primaryColor,
            LEGACY_secondaryColor: secondaryColor,
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});
parcelRegister("ejT8C", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5501f2ec2c7fc2907a8ddc6771935d76>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6cd9c4605f2f731$var$_react = $a6cd9c4605f2f731$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a6cd9c4605f2f731$var$_discovery = $a6cd9c4605f2f731$var$_interopRequireDefault((parcelRequire("h4COp")));

var $a6cd9c4605f2f731$var$_note = $a6cd9c4605f2f731$var$_interopRequireDefault((parcelRequire("94404")));
function $a6cd9c4605f2f731$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DiscoveryIcon.
 * This component is DiscoveryIcon, with `UNSAFE_fallbackIcon` set to "EditorNoteIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a6cd9c4605f2f731$var$DiscoveryIcon = (props)=>/*#__PURE__*/ $a6cd9c4605f2f731$var$_react.default.createElement($a6cd9c4605f2f731$var$_discovery.default, Object.assign({
        name: "DiscoveryIcon",
        LEGACY_fallbackIcon: $a6cd9c4605f2f731$var$_note.default
    }, props));
$a6cd9c4605f2f731$var$DiscoveryIcon.displayName = 'DiscoveryIconMigration';
var $a6cd9c4605f2f731$var$_default = module.exports.default = $a6cd9c4605f2f731$var$DiscoveryIcon;

});
parcelRegister("h4COp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84ac540d37aa7b8e7ab349dbbb474c30>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6e0eaad244db33f$var$_react = $c6e0eaad244db33f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c6e0eaad244db33f$var$_baseNew = $c6e0eaad244db33f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c6e0eaad244db33f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Discovery".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c6e0eaad244db33f$var$DiscoveryIcon = (props)=>/*#__PURE__*/ $c6e0eaad244db33f$var$_react.default.createElement($c6e0eaad244db33f$var$_baseNew.default, Object.assign({
        name: "DiscoveryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h6v-4.75C9 9.56 9.56 9 10.25 9H15V3a2 2 0 0 0-2-2M4 5.5h7V4H4zM4 9h3V7.5H4z" clip-rule="evenodd"/><path fill="currentcolor" d="M11.25 10.5a.75.75 0 0 0-.75.75v3.81l4.56-4.56z"/>`
    }, props));
$c6e0eaad244db33f$var$DiscoveryIcon.displayName = 'DiscoveryIcon';
var $c6e0eaad244db33f$var$_default = module.exports.default = $c6e0eaad244db33f$var$DiscoveryIcon;

});

parcelRegister("94404", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6997971b5d08dbe2$var$_react = $6997971b5d08dbe2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $6997971b5d08dbe2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6997971b5d08dbe2$var$EditorNoteIcon = (props)=>/*#__PURE__*/ $6997971b5d08dbe2$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 4h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m1.5 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm0 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props));
$6997971b5d08dbe2$var$EditorNoteIcon.displayName = 'EditorNoteIcon';
var $6997971b5d08dbe2$var$_default = module.exports.default = $6997971b5d08dbe2$var$EditorNoteIcon;

});


var $7bb4c1736002a04a$exports = {};
$parcel$export($7bb4c1736002a04a$exports, "R50", () => $7bb4c1736002a04a$export$4b84fd0e2c617bd);
$parcel$export($7bb4c1736002a04a$exports, "R75", () => $7bb4c1736002a04a$export$b34b069eff244586);
$parcel$export($7bb4c1736002a04a$exports, "R100", () => $7bb4c1736002a04a$export$be802dd0d8b57f35);
$parcel$export($7bb4c1736002a04a$exports, "R200", () => $7bb4c1736002a04a$export$60847d42f9da92a6);
$parcel$export($7bb4c1736002a04a$exports, "R300", () => $7bb4c1736002a04a$export$4a7404f376229999);
$parcel$export($7bb4c1736002a04a$exports, "R400", () => $7bb4c1736002a04a$export$2010d0fb4295b346);
$parcel$export($7bb4c1736002a04a$exports, "R500", () => $7bb4c1736002a04a$export$2837b5a1a71d5c02);
$parcel$export($7bb4c1736002a04a$exports, "Y50", () => $7bb4c1736002a04a$export$8d9596b529bbb9cf);
$parcel$export($7bb4c1736002a04a$exports, "Y75", () => $7bb4c1736002a04a$export$41060a744ab0b7ae);
$parcel$export($7bb4c1736002a04a$exports, "Y100", () => $7bb4c1736002a04a$export$1cc05bbbf340e559);
$parcel$export($7bb4c1736002a04a$exports, "Y200", () => $7bb4c1736002a04a$export$5aae31392d72caaa);
$parcel$export($7bb4c1736002a04a$exports, "Y300", () => $7bb4c1736002a04a$export$c6930421db9fa514);
$parcel$export($7bb4c1736002a04a$exports, "Y400", () => $7bb4c1736002a04a$export$59619663aa6500fb);
$parcel$export($7bb4c1736002a04a$exports, "Y500", () => $7bb4c1736002a04a$export$874739ea9e379ab6);
$parcel$export($7bb4c1736002a04a$exports, "G50", () => $7bb4c1736002a04a$export$8a6341c32b6a3ee6);
$parcel$export($7bb4c1736002a04a$exports, "G75", () => $7bb4c1736002a04a$export$69a3bf21b9686c2b);
$parcel$export($7bb4c1736002a04a$exports, "G100", () => $7bb4c1736002a04a$export$afbce1382ec95f73);
$parcel$export($7bb4c1736002a04a$exports, "G200", () => $7bb4c1736002a04a$export$747d86715d4175de);
$parcel$export($7bb4c1736002a04a$exports, "G300", () => $7bb4c1736002a04a$export$940e1f69e873f202);
$parcel$export($7bb4c1736002a04a$exports, "G400", () => $7bb4c1736002a04a$export$a49394138f7b8e85);
$parcel$export($7bb4c1736002a04a$exports, "G500", () => $7bb4c1736002a04a$export$6fa04827ac68a4fb);
$parcel$export($7bb4c1736002a04a$exports, "B50", () => $7bb4c1736002a04a$export$226de0355ed012f8);
$parcel$export($7bb4c1736002a04a$exports, "B75", () => $7bb4c1736002a04a$export$8c13c2ee36917869);
$parcel$export($7bb4c1736002a04a$exports, "B100", () => $7bb4c1736002a04a$export$ecfc1dff386a3e7a);
$parcel$export($7bb4c1736002a04a$exports, "B200", () => $7bb4c1736002a04a$export$215b7063051591f1);
$parcel$export($7bb4c1736002a04a$exports, "B300", () => $7bb4c1736002a04a$export$e62e8919cca44969);
$parcel$export($7bb4c1736002a04a$exports, "B400", () => $7bb4c1736002a04a$export$b3de0ae08da2ce64);
$parcel$export($7bb4c1736002a04a$exports, "B500", () => $7bb4c1736002a04a$export$a6ee3d71bc067634);
$parcel$export($7bb4c1736002a04a$exports, "B600", () => $7bb4c1736002a04a$export$67f15409e87642a1);
$parcel$export($7bb4c1736002a04a$exports, "B700", () => $7bb4c1736002a04a$export$f0539dbc42dbb067);
$parcel$export($7bb4c1736002a04a$exports, "P50", () => $7bb4c1736002a04a$export$363e4475840015bb);
$parcel$export($7bb4c1736002a04a$exports, "P75", () => $7bb4c1736002a04a$export$4b0a4417ed59760f);
$parcel$export($7bb4c1736002a04a$exports, "P100", () => $7bb4c1736002a04a$export$6011520a64d9a187);
$parcel$export($7bb4c1736002a04a$exports, "P200", () => $7bb4c1736002a04a$export$a7175d4e9206bc80);
$parcel$export($7bb4c1736002a04a$exports, "P300", () => $7bb4c1736002a04a$export$b48405b95304b5a1);
$parcel$export($7bb4c1736002a04a$exports, "P400", () => $7bb4c1736002a04a$export$c71e4279dd54a18d);
$parcel$export($7bb4c1736002a04a$exports, "P500", () => $7bb4c1736002a04a$export$147899de772240ec);
$parcel$export($7bb4c1736002a04a$exports, "T50", () => $7bb4c1736002a04a$export$2cf711fe14c66f06);
$parcel$export($7bb4c1736002a04a$exports, "T75", () => $7bb4c1736002a04a$export$7a8f4d33f6f9772c);
$parcel$export($7bb4c1736002a04a$exports, "T100", () => $7bb4c1736002a04a$export$776c9c497ef08533);
$parcel$export($7bb4c1736002a04a$exports, "T200", () => $7bb4c1736002a04a$export$69cb3ca10c1e330e);
$parcel$export($7bb4c1736002a04a$exports, "T300", () => $7bb4c1736002a04a$export$9dc1ef0f3f48059b);
$parcel$export($7bb4c1736002a04a$exports, "T400", () => $7bb4c1736002a04a$export$7c835c78b6fcdef8);
$parcel$export($7bb4c1736002a04a$exports, "T500", () => $7bb4c1736002a04a$export$6036577f95c3877e);
$parcel$export($7bb4c1736002a04a$exports, "N0", () => $7bb4c1736002a04a$export$29a4f05edc054374);
$parcel$export($7bb4c1736002a04a$exports, "N10", () => $7bb4c1736002a04a$export$e655ef011c4aa1a2);
$parcel$export($7bb4c1736002a04a$exports, "N20", () => $7bb4c1736002a04a$export$9fdfb749e33cdf97);
$parcel$export($7bb4c1736002a04a$exports, "N30", () => $7bb4c1736002a04a$export$3e51e8f1440314ba);
$parcel$export($7bb4c1736002a04a$exports, "N40", () => $7bb4c1736002a04a$export$1ce2d1575d444ceb);
$parcel$export($7bb4c1736002a04a$exports, "N50", () => $7bb4c1736002a04a$export$8754fc7e6d8b3000);
$parcel$export($7bb4c1736002a04a$exports, "N60", () => $7bb4c1736002a04a$export$c2e91cbeada39b8b);
$parcel$export($7bb4c1736002a04a$exports, "N70", () => $7bb4c1736002a04a$export$5f71e19f3a7ad9de);
$parcel$export($7bb4c1736002a04a$exports, "N80", () => $7bb4c1736002a04a$export$eaa8c8a70ac22806);
$parcel$export($7bb4c1736002a04a$exports, "N90", () => $7bb4c1736002a04a$export$7c87d337fb91a97d);
$parcel$export($7bb4c1736002a04a$exports, "N100", () => $7bb4c1736002a04a$export$d6447c357493214f);
$parcel$export($7bb4c1736002a04a$exports, "N200", () => $7bb4c1736002a04a$export$f563ee71e9ee74cd);
$parcel$export($7bb4c1736002a04a$exports, "N300", () => $7bb4c1736002a04a$export$e2ef2124cf4024b1);
$parcel$export($7bb4c1736002a04a$exports, "N400", () => $7bb4c1736002a04a$export$eece5f492e429f08);
$parcel$export($7bb4c1736002a04a$exports, "N500", () => $7bb4c1736002a04a$export$c39c0fe0f26207ae);
$parcel$export($7bb4c1736002a04a$exports, "N600", () => $7bb4c1736002a04a$export$7090862dc3038a9f);
$parcel$export($7bb4c1736002a04a$exports, "N700", () => $7bb4c1736002a04a$export$ad0bacf983b7ddaa);
$parcel$export($7bb4c1736002a04a$exports, "N800", () => $7bb4c1736002a04a$export$7d61b15e0da132af);
$parcel$export($7bb4c1736002a04a$exports, "N900", () => $7bb4c1736002a04a$export$fbda843f0a27fe96);
$parcel$export($7bb4c1736002a04a$exports, "N10A", () => $7bb4c1736002a04a$export$791e57b27ca738ef);
$parcel$export($7bb4c1736002a04a$exports, "N20A", () => $7bb4c1736002a04a$export$8d43898f60b96a82);
$parcel$export($7bb4c1736002a04a$exports, "N30A", () => $7bb4c1736002a04a$export$920c0d5c49070351);
$parcel$export($7bb4c1736002a04a$exports, "N40A", () => $7bb4c1736002a04a$export$46987b49aab6d1a8);
$parcel$export($7bb4c1736002a04a$exports, "N50A", () => $7bb4c1736002a04a$export$7d3359664e8bb0e5);
$parcel$export($7bb4c1736002a04a$exports, "N60A", () => $7bb4c1736002a04a$export$d2d3bedfb276cac0);
$parcel$export($7bb4c1736002a04a$exports, "N70A", () => $7bb4c1736002a04a$export$6e5e7499ff054f6d);
$parcel$export($7bb4c1736002a04a$exports, "N80A", () => $7bb4c1736002a04a$export$59264b346c877fa7);
$parcel$export($7bb4c1736002a04a$exports, "N90A", () => $7bb4c1736002a04a$export$d092757d7c64925c);
$parcel$export($7bb4c1736002a04a$exports, "N100A", () => $7bb4c1736002a04a$export$486ab785e4bac3c6);
$parcel$export($7bb4c1736002a04a$exports, "N200A", () => $7bb4c1736002a04a$export$fba592bbc6419fea);
$parcel$export($7bb4c1736002a04a$exports, "N300A", () => $7bb4c1736002a04a$export$13609db0e6812ab8);
$parcel$export($7bb4c1736002a04a$exports, "N400A", () => $7bb4c1736002a04a$export$fbae4efaa892d883);
$parcel$export($7bb4c1736002a04a$exports, "N500A", () => $7bb4c1736002a04a$export$f13946d26f440ce6);
$parcel$export($7bb4c1736002a04a$exports, "N600A", () => $7bb4c1736002a04a$export$19f58225ac52a306);
$parcel$export($7bb4c1736002a04a$exports, "N700A", () => $7bb4c1736002a04a$export$6384f09da70e7b62);
$parcel$export($7bb4c1736002a04a$exports, "N800A", () => $7bb4c1736002a04a$export$d0dccc730683edc2);
$parcel$export($7bb4c1736002a04a$exports, "DN900", () => $7bb4c1736002a04a$export$2f6319cf7d736c2a);
$parcel$export($7bb4c1736002a04a$exports, "DN800", () => $7bb4c1736002a04a$export$95126bc8884d6634);
$parcel$export($7bb4c1736002a04a$exports, "DN700", () => $7bb4c1736002a04a$export$8338d8c35d44ff1);
$parcel$export($7bb4c1736002a04a$exports, "DN600", () => $7bb4c1736002a04a$export$5368d76ae4fbbda7);
$parcel$export($7bb4c1736002a04a$exports, "DN500", () => $7bb4c1736002a04a$export$9f0a771d16ec8d36);
$parcel$export($7bb4c1736002a04a$exports, "DN400", () => $7bb4c1736002a04a$export$abcf8c38338b4aa5);
$parcel$export($7bb4c1736002a04a$exports, "DN300", () => $7bb4c1736002a04a$export$97e81faa16a182c7);
$parcel$export($7bb4c1736002a04a$exports, "DN200", () => $7bb4c1736002a04a$export$bfe21c59123ecf33);
$parcel$export($7bb4c1736002a04a$exports, "DN100", () => $7bb4c1736002a04a$export$ee82aa2ea6a1558);
$parcel$export($7bb4c1736002a04a$exports, "DN90", () => $7bb4c1736002a04a$export$682927c6ed76be02);
$parcel$export($7bb4c1736002a04a$exports, "DN80", () => $7bb4c1736002a04a$export$91fd9994c5be9757);
$parcel$export($7bb4c1736002a04a$exports, "DN70", () => $7bb4c1736002a04a$export$d281fbfe3cff2df6);
$parcel$export($7bb4c1736002a04a$exports, "DN60", () => $7bb4c1736002a04a$export$3902c91d8b98a753);
$parcel$export($7bb4c1736002a04a$exports, "DN50", () => $7bb4c1736002a04a$export$8e8133c1ba5845b5);
$parcel$export($7bb4c1736002a04a$exports, "DN40", () => $7bb4c1736002a04a$export$33ff357f6620b39);
$parcel$export($7bb4c1736002a04a$exports, "DN30", () => $7bb4c1736002a04a$export$633847cf062b69e0);
$parcel$export($7bb4c1736002a04a$exports, "DN20", () => $7bb4c1736002a04a$export$9776a6e503bdbf76);
$parcel$export($7bb4c1736002a04a$exports, "DN10", () => $7bb4c1736002a04a$export$6c813d5160dff5db);
$parcel$export($7bb4c1736002a04a$exports, "DN0", () => $7bb4c1736002a04a$export$3d4f271a500072a);
$parcel$export($7bb4c1736002a04a$exports, "DN800A", () => $7bb4c1736002a04a$export$fe151285c22759ec);
$parcel$export($7bb4c1736002a04a$exports, "DN700A", () => $7bb4c1736002a04a$export$a101c6190d0da34);
$parcel$export($7bb4c1736002a04a$exports, "DN600A", () => $7bb4c1736002a04a$export$4b16f52932fda51);
$parcel$export($7bb4c1736002a04a$exports, "DN500A", () => $7bb4c1736002a04a$export$a74bcd7b9845b0d8);
$parcel$export($7bb4c1736002a04a$exports, "DN400A", () => $7bb4c1736002a04a$export$9209c179316d1751);
$parcel$export($7bb4c1736002a04a$exports, "DN300A", () => $7bb4c1736002a04a$export$88f55133f636c8dd);
$parcel$export($7bb4c1736002a04a$exports, "DN200A", () => $7bb4c1736002a04a$export$51126f85d1009512);
$parcel$export($7bb4c1736002a04a$exports, "DN100A", () => $7bb4c1736002a04a$export$a069b547bd23af78);
$parcel$export($7bb4c1736002a04a$exports, "DN90A", () => $7bb4c1736002a04a$export$40cce05af3b2600a);
$parcel$export($7bb4c1736002a04a$exports, "DN80A", () => $7bb4c1736002a04a$export$b78942185925a0d);
$parcel$export($7bb4c1736002a04a$exports, "DN70A", () => $7bb4c1736002a04a$export$e058fb44b8eaafca);
$parcel$export($7bb4c1736002a04a$exports, "DN60A", () => $7bb4c1736002a04a$export$92b0b8de26920c18);
$parcel$export($7bb4c1736002a04a$exports, "DN50A", () => $7bb4c1736002a04a$export$67564f7459d3fc9e);
$parcel$export($7bb4c1736002a04a$exports, "DN40A", () => $7bb4c1736002a04a$export$77868e1ca884ffa3);
$parcel$export($7bb4c1736002a04a$exports, "DN30A", () => $7bb4c1736002a04a$export$2afd71d7d3ea2cd5);
$parcel$export($7bb4c1736002a04a$exports, "DN20A", () => $7bb4c1736002a04a$export$f2a0acaab9972c70);
$parcel$export($7bb4c1736002a04a$exports, "DN10A", () => $7bb4c1736002a04a$export$9ab70e67d6475361);
$parcel$export($7bb4c1736002a04a$exports, "T30", () => $7bb4c1736002a04a$export$d2adc5dedf09fced);
$parcel$export($7bb4c1736002a04a$exports, "L50", () => $7bb4c1736002a04a$export$f51762073d2bb381);
$parcel$export($7bb4c1736002a04a$exports, "L75", () => $7bb4c1736002a04a$export$95e26d54def96891);
// Reds
const $7bb4c1736002a04a$export$4b84fd0e2c617bd = '#FFEBE6';
const $7bb4c1736002a04a$export$b34b069eff244586 = '#FFBDAD';
const $7bb4c1736002a04a$export$be802dd0d8b57f35 = '#FF8F73';
const $7bb4c1736002a04a$export$60847d42f9da92a6 = '#FF7452';
const $7bb4c1736002a04a$export$4a7404f376229999 = '#FF5630';
const $7bb4c1736002a04a$export$2010d0fb4295b346 = '#DE350B';
const $7bb4c1736002a04a$export$2837b5a1a71d5c02 = '#BF2600';
const $7bb4c1736002a04a$export$8d9596b529bbb9cf = '#FFFAE6';
const $7bb4c1736002a04a$export$41060a744ab0b7ae = '#FFF0B3';
const $7bb4c1736002a04a$export$1cc05bbbf340e559 = '#FFE380';
const $7bb4c1736002a04a$export$5aae31392d72caaa = '#FFC400';
const $7bb4c1736002a04a$export$c6930421db9fa514 = '#FFAB00';
const $7bb4c1736002a04a$export$59619663aa6500fb = '#FF991F';
const $7bb4c1736002a04a$export$874739ea9e379ab6 = '#FF8B00';
const $7bb4c1736002a04a$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $7bb4c1736002a04a$export$69a3bf21b9686c2b = '#ABF5D1';
const $7bb4c1736002a04a$export$afbce1382ec95f73 = '#79F2C0';
const $7bb4c1736002a04a$export$747d86715d4175de = '#57D9A3';
const $7bb4c1736002a04a$export$940e1f69e873f202 = '#36B37E';
const $7bb4c1736002a04a$export$a49394138f7b8e85 = '#00875A';
const $7bb4c1736002a04a$export$6fa04827ac68a4fb = '#006644';
const $7bb4c1736002a04a$export$226de0355ed012f8 = '#DEEBFF';
const $7bb4c1736002a04a$export$8c13c2ee36917869 = '#B3D4FF';
const $7bb4c1736002a04a$export$ecfc1dff386a3e7a = '#4C9AFF';
const $7bb4c1736002a04a$export$215b7063051591f1 = '#2684FF';
const $7bb4c1736002a04a$export$e62e8919cca44969 = '#0065FF';
const $7bb4c1736002a04a$export$b3de0ae08da2ce64 = '#0052CC';
const $7bb4c1736002a04a$export$a6ee3d71bc067634 = '#0747A6';
const $7bb4c1736002a04a$export$67f15409e87642a1 = '#669DF1';
const $7bb4c1736002a04a$export$f0539dbc42dbb067 = '#8FB8F6';
const $7bb4c1736002a04a$export$363e4475840015bb = '#EAE6FF';
const $7bb4c1736002a04a$export$4b0a4417ed59760f = '#C0B6F2';
const $7bb4c1736002a04a$export$6011520a64d9a187 = '#998DD9';
const $7bb4c1736002a04a$export$a7175d4e9206bc80 = '#8777D9';
const $7bb4c1736002a04a$export$b48405b95304b5a1 = '#6554C0';
const $7bb4c1736002a04a$export$c71e4279dd54a18d = '#5243AA';
const $7bb4c1736002a04a$export$147899de772240ec = '#403294';
const $7bb4c1736002a04a$export$2cf711fe14c66f06 = '#E6FCFF';
const $7bb4c1736002a04a$export$7a8f4d33f6f9772c = '#B3F5FF';
const $7bb4c1736002a04a$export$776c9c497ef08533 = '#79E2F2';
const $7bb4c1736002a04a$export$69cb3ca10c1e330e = '#00C7E6';
const $7bb4c1736002a04a$export$9dc1ef0f3f48059b = '#00B8D9';
const $7bb4c1736002a04a$export$7c835c78b6fcdef8 = '#00A3BF';
const $7bb4c1736002a04a$export$6036577f95c3877e = '#008DA6';
const $7bb4c1736002a04a$export$29a4f05edc054374 = '#FFFFFF';
const $7bb4c1736002a04a$export$e655ef011c4aa1a2 = '#FAFBFC';
const $7bb4c1736002a04a$export$9fdfb749e33cdf97 = '#F4F5F7';
const $7bb4c1736002a04a$export$3e51e8f1440314ba = '#EBECF0';
const $7bb4c1736002a04a$export$1ce2d1575d444ceb = '#DFE1E6';
const $7bb4c1736002a04a$export$8754fc7e6d8b3000 = '#C1C7D0';
const $7bb4c1736002a04a$export$c2e91cbeada39b8b = '#B3BAC5';
const $7bb4c1736002a04a$export$5f71e19f3a7ad9de = '#A5ADBA';
const $7bb4c1736002a04a$export$eaa8c8a70ac22806 = '#97A0AF';
const $7bb4c1736002a04a$export$7c87d337fb91a97d = '#8993A4';
const $7bb4c1736002a04a$export$d6447c357493214f = '#7A869A';
const $7bb4c1736002a04a$export$f563ee71e9ee74cd = '#6B778C';
const $7bb4c1736002a04a$export$e2ef2124cf4024b1 = '#5E6C84';
const $7bb4c1736002a04a$export$eece5f492e429f08 = '#505F79';
const $7bb4c1736002a04a$export$c39c0fe0f26207ae = '#42526E';
const $7bb4c1736002a04a$export$7090862dc3038a9f = '#344563';
const $7bb4c1736002a04a$export$ad0bacf983b7ddaa = '#253858';
const $7bb4c1736002a04a$export$7d61b15e0da132af = '#172B4D';
const $7bb4c1736002a04a$export$fbda843f0a27fe96 = '#091E42';
const $7bb4c1736002a04a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $7bb4c1736002a04a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $7bb4c1736002a04a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $7bb4c1736002a04a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $7bb4c1736002a04a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $7bb4c1736002a04a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $7bb4c1736002a04a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $7bb4c1736002a04a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $7bb4c1736002a04a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $7bb4c1736002a04a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $7bb4c1736002a04a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $7bb4c1736002a04a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $7bb4c1736002a04a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $7bb4c1736002a04a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $7bb4c1736002a04a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $7bb4c1736002a04a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $7bb4c1736002a04a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $7bb4c1736002a04a$export$2f6319cf7d736c2a = '#E6EDFA';
const $7bb4c1736002a04a$export$95126bc8884d6634 = '#DCE5F5';
const $7bb4c1736002a04a$export$8338d8c35d44ff1 = '#CED9EB';
const $7bb4c1736002a04a$export$5368d76ae4fbbda7 = '#B8C7E0';
const $7bb4c1736002a04a$export$9f0a771d16ec8d36 = '#ABBBD6';
const $7bb4c1736002a04a$export$abcf8c38338b4aa5 = '#9FB0CC';
const $7bb4c1736002a04a$export$97e81faa16a182c7 = '#8C9CB8';
const $7bb4c1736002a04a$export$bfe21c59123ecf33 = '#7988A3';
const $7bb4c1736002a04a$export$ee82aa2ea6a1558 = '#67758F';
const $7bb4c1736002a04a$export$682927c6ed76be02 = '#56637A';
const $7bb4c1736002a04a$export$91fd9994c5be9757 = '#455166';
const $7bb4c1736002a04a$export$d281fbfe3cff2df6 = '#3B475C';
const $7bb4c1736002a04a$export$3902c91d8b98a753 = '#313D52';
const $7bb4c1736002a04a$export$8e8133c1ba5845b5 = '#283447';
const $7bb4c1736002a04a$export$33ff357f6620b39 = '#202B3D';
const $7bb4c1736002a04a$export$633847cf062b69e0 = '#1B2638';
const $7bb4c1736002a04a$export$9776a6e503bdbf76 = '#121A29';
const $7bb4c1736002a04a$export$6c813d5160dff5db = '#0E1624';
const $7bb4c1736002a04a$export$3d4f271a500072a = '#0D1424';
const $7bb4c1736002a04a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $7bb4c1736002a04a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $7bb4c1736002a04a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $7bb4c1736002a04a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $7bb4c1736002a04a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $7bb4c1736002a04a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $7bb4c1736002a04a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $7bb4c1736002a04a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $7bb4c1736002a04a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $7bb4c1736002a04a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $7bb4c1736002a04a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $7bb4c1736002a04a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $7bb4c1736002a04a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $7bb4c1736002a04a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $7bb4c1736002a04a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $7bb4c1736002a04a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $7bb4c1736002a04a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $7bb4c1736002a04a$export$d2adc5dedf09fced = '#292A2E';
const $7bb4c1736002a04a$export$f51762073d2bb381 = '#94C748';
const $7bb4c1736002a04a$export$95e26d54def96891 = '#B3DF72';



parcelRegister("5AgM9", function(module, exports) {
$parcel$export(module.exports, "useAuth", () => $7dbfe9eb44cdcd22$export$1d39dc5b47e56ff0);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $chrtv = parcelRequire("chrtv");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");

var $3Wh6p = parcelRequire("3Wh6p");

var $jkYbX = parcelRequire("jkYbX");

var $jGjox = parcelRequire("jGjox");

var $eGOwo = parcelRequire("eGOwo");
// TODO: We should make appName non-optional later: http://go/j/AUX-570
// appName was made optional because it isn't in already inserted apps prior to the change in http://go/j/AUX-411
const $7dbfe9eb44cdcd22$var$defaultPromptMessage = (intl, appName)=>{
    return intl.formatMessage((0, $eGOwo.fg)('product-terminology-refresh') ? $7dbfe9eb44cdcd22$var$messages.defaultPromptMessageAppify : $7dbfe9eb44cdcd22$var$messages.defaultPromptMessage, {
        appString: appName ? appName : intl.formatMessage($7dbfe9eb44cdcd22$var$messages.thisAppLower)
    });
};
const $7dbfe9eb44cdcd22$var$externalAuthPromptMessage = (intl, appName)=>{
    return intl.formatMessage($7dbfe9eb44cdcd22$var$messages.externalAuthPromptMessage, {
        appString: appName ? appName : intl.formatMessage($7dbfe9eb44cdcd22$var$messages.thisAppUpper)
    });
};
const $7dbfe9eb44cdcd22$export$1d39dc5b47e56ff0 = ({ message: message, promptText: promptText, appName: appName, authUrl: authUrl, onSuccess: onSuccess, metadata: metadata })=>{
    const [failedToAuthenticate, setFailedToAuthenticate] = (0, $eJOHy.useState)(false);
    const [authFailureMessage, setAuthFailureMessage] = (0, $eJOHy.useState)(false);
    const [loading, setLoading] = (0, $eJOHy.useState)(false);
    const promptIsForExternalAuth = (0, $chrtv.isExternalAuth)(authUrl);
    const intl = (0, $lRq8t.default)();
    const startAuth = (0, $eJOHy.useCallback)(()=>{
        setLoading(true);
        setAuthFailureMessage(false);
        (0, $chrtv.safeAuth)(authUrl).then(()=>{
            onSuccess().then((callbackAfterConsentFlowHasFinished)=>{
                setLoading(false);
                setFailedToAuthenticate(false);
                if (callbackAfterConsentFlowHasFinished && typeof callbackAfterConsentFlowHasFinished === 'function') callbackAfterConsentFlowHasFinished();
            });
        }, (err)=>{
            setLoading(false);
            setFailedToAuthenticate(true);
            if ((0, $jGjox.isOfTypeAuthError)(err.type)) setAuthFailureMessage(err.message);
        });
    }, [
        authUrl,
        onSuccess,
        setLoading,
        setFailedToAuthenticate,
        setAuthFailureMessage
    ]);
    const promptMessage = failedToAuthenticate ? authFailureMessage || intl.formatMessage($7dbfe9eb44cdcd22$var$messages.defaultFailedToAuthMessage) : message || (promptIsForExternalAuth ? $7dbfe9eb44cdcd22$var$externalAuthPromptMessage(intl, appName) : $7dbfe9eb44cdcd22$var$defaultPromptMessage(intl, appName));
    const content = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3Wh6p.default), {
        alignBlock: "center",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))), {
                label: intl.formatMessage($7dbfe9eb44cdcd22$var$messages.externalAuthWarning),
                color: "var(--ds-icon-warning, #FF8B00)",
                LEGACY_size: "medium",
                spacing: "spacious"
            }),
            promptMessage
        ]
    });
    const externalAuthButtonText = intl.formatMessage($7dbfe9eb44cdcd22$var$messages.configureAccess);
    const buttonText = promptText || (promptIsForExternalAuth ? externalAuthButtonText : intl.formatMessage($7dbfe9eb44cdcd22$var$messages.allowAccess));
    return {
        loading: loading,
        startAuth: startAuth,
        promptMessage: content,
        buttonText: buttonText
    };
};
const $7dbfe9eb44cdcd22$var$messages = (0, $7qGN1.defineMessages)({
    defaultPromptMessage: {
        id: 'confluence.threeLOPrompt.use-auth.default.prompt.message',
        defaultMessage: 'For {appString} to display, you need to allow the app to access Atlassian products on your behalf.',
        description: 'A text prompt that tells a user that an app needs to be given permission before the app can be used.'
    },
    defaultPromptMessageAppify: {
        id: 'confluence.threeLOPrompt.use-auth.default.prompt.message-appify',
        defaultMessage: 'For {appString} to display, you need to grant it access to Atlassian apps on your behalf.',
        description: 'A text prompt that tells a user that an app needs to be given permission before the app can be used.'
    },
    externalAuthPromptMessage: {
        id: 'confluence.threeLOPrompt.use-auth.external.auth.prompt.message',
        defaultMessage: '{appString} requires additional access to your account.',
        description: 'A text prompt indicating that an app requires additional permissions before the app can be used.'
    },
    thisAppUpper: {
        id: 'confluence.threeLOPrompt.use-auth.this.app.upper.message',
        defaultMessage: 'This app',
        description: 'a default message shown to the user when the name of an application is unknown.'
    },
    thisAppLower: {
        id: 'confluence.threeLOPrompt.use-auth.this.app.lower.message',
        defaultMessage: 'this app',
        description: 'a default message shown to the user when the name of an application is unknown.'
    },
    defaultFailedToAuthMessage: {
        id: 'confluence.threeLOPrompt.use-auth.default.failed.to.auth.message',
        defaultMessage: 'Failed to authenticate.',
        description: 'A default text prompt to indicate than an app was unable to authenticate a user.'
    },
    externalAuthWarning: {
        id: 'confluence.threeLOPrompt.use-auth.external.auth.warning.message',
        defaultMessage: 'External Auth Warning',
        description: 'A default text prompt to indicate than an app was unable to authenticate a user.'
    },
    configureAccess: {
        id: 'confluence.threeLOPrompt.use-auth.configure.access.button.text',
        defaultMessage: 'Configure access',
        description: "Label for a button that allows a user to configure the app's access to the user's account"
    },
    allowAccess: {
        id: 'confluence.threeLOPrompt.use-auth.allow.access.button.text',
        defaultMessage: 'Allow access',
        description: 'Label for a button that would allow the user to grant access to some application.'
    }
});

});
parcelRegister("chrtv", function(module, exports) {
$parcel$export(module.exports, "safeAuth", () => $aeb2089e5e1a70d3$export$5a2d35665f488c3c);
$parcel$export(module.exports, "isExternalAuth", () => $aeb2089e5e1a70d3$export$4211976e157c7ad8);

var $ldBiz = parcelRequire("ldBiz");

var $70M97 = parcelRequire("70M97");
const $aeb2089e5e1a70d3$export$6baf9fc1d877ea76 = 'atlassian-token-service-key';
const $aeb2089e5e1a70d3$export$5a2d35665f488c3c = async (startUrl, windowFeatures)=>{
    return (0, $ldBiz.auth)((0, $70M97.sanitizeUrl)(startUrl), windowFeatures);
};
const $aeb2089e5e1a70d3$export$4211976e157c7ad8 = (startUrl)=>{
    const url = new URL(startUrl || '', window.location.href);
    const serviceKey = url.searchParams.get('serviceKey');
    return serviceKey !== $aeb2089e5e1a70d3$export$6baf9fc1d877ea76;
};

});
parcelRegister("ldBiz", function(module, exports) {
$parcel$export(module.exports, "auth", () => $3affdc949abfd5e9$export$73693bad9f5880b0);
$parcel$export(module.exports, "AuthError", () => (parcelRequire("kwM7Y")).AuthError);

var $kwM7Y = parcelRequire("kwM7Y");

var $jGjox = parcelRequire("jGjox");
function $3affdc949abfd5e9$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise((resolve, reject)=>{
        let authWindow = null;
        let authWindowInterval;
        const handleAuthWindowMessage = (event)=>{
            if (event.source !== authWindow) return;
            const { data: data } = event;
            if (typeof data !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    const errorType = data.errorType.toLowerCase();
                    if ((0, $jGjox.isOfTypeAuthError)(errorType)) reject(new (0, $kwM7Y.AuthError)(data.message, errorType));
                    else reject(new (0, $kwM7Y.AuthError)(data.message));
                    break;
            }
        };
        const handleAuthWindowInterval = ()=>{
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $kwM7Y.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        const start = ()=>{
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        const finish = ()=>{
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}

});
parcelRegister("kwM7Y", function(module, exports) {
$parcel$export(module.exports, "AuthError", () => $4f8710bc730ecae5$export$145273558d58e0ac);
class $4f8710bc730ecae5$export$145273558d58e0ac extends Error {
    constructor(message, type){
        super(message), this.message = message, this.type = type;
        this.name = 'AuthError';
        this.type = type;
        this.message = message;
    }
}

});

parcelRegister("jGjox", function(module, exports) {
$parcel$export(module.exports, "isOfTypeAuthError", () => $b4e26c6b0cd1efbb$export$400e64c8451aa84f);
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
const $b4e26c6b0cd1efbb$export$400e64c8451aa84f = (inputString)=>{
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};

});


parcelRegister("70M97", function(module, exports) {
$parcel$export(module.exports, "sanitizeUrl", () => $17b3cd4c61fabe18$export$300bd6d67c49dbfc);
$parcel$export(module.exports, "EmFn", () => $17b3cd4c61fabe18$export$fec26b2d751c6d95);
$parcel$export(module.exports, "LinkFn", () => $17b3cd4c61fabe18$export$7c70dc97eeeaf683);
$parcel$export(module.exports, "StrikeFn", () => $17b3cd4c61fabe18$export$e9e7c187aef6a83a);
$parcel$export(module.exports, "StringFn", () => $17b3cd4c61fabe18$export$11a9c970dcafffc0);
$parcel$export(module.exports, "StrongFn", () => $17b3cd4c61fabe18$export$566c617eb72a5976);

var $gt9Am = parcelRequire("gt9Am");

var $eJ9f5 = parcelRequire("eJ9f5");

var $eGOwo = parcelRequire("eGOwo");

var $eJOHy = parcelRequire("eJOHy");

var $5qJVF = parcelRequire("5qJVF");

var $kpjEk = parcelRequire("kpjEk");

var $kweLG = parcelRequire("kweLG");
const $17b3cd4c61fabe18$var$useDeprecationWarning = (componentName)=>{
    const { forgeEnvironment: forgeEnvironment } = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $kpjEk.RendererContext));
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        if (forgeEnvironment !== 'PRODUCTION') (0, $kweLG.default)(`[@forge/react: ${componentName}] Warning: The "${componentName}" component is deprecated and will be removed on the 28th of August 2025. Please use the "Text" component instead. For more information, visit: https://developer.atlassian.com/platform/forge/ui-kit/components/text/.`);
    }, [
        forgeEnvironment,
        componentName
    ]);
};

const $17b3cd4c61fabe18$var$AkButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("bHnMU")));
// taken from https://hello.atlassian.net/wiki/spaces/PRODSEC/pages/158006558/URI+scheme+Allow+listing
const $17b3cd4c61fabe18$var$PROTOCOL_ALLOWLIST = [
    'http:',
    'https:',
    'ftp:',
    'ftps:',
    'mailto:',
    'skype:',
    'callto:',
    'facetime:',
    'git:',
    'irc:',
    'irc6:',
    'news:',
    'nntp:',
    'feed:',
    'cvs:',
    'svn:',
    'mvn:',
    'ssh:',
    'scp:',
    'sftp:',
    'itms:',
    'notes:',
    'hipchat:',
    'sourcetree:',
    'urn:',
    'tel:',
    'xmpp:',
    'telnet:',
    'vnc:',
    'rdp:',
    'whatsapp:',
    'slack:',
    'sip:',
    'sips:',
    'magnet:',
    'tds:'
];
const $17b3cd4c61fabe18$export$300bd6d67c49dbfc = (urlString)=>{
    const url = new URL(urlString || '', window.location.href);
    if ($17b3cd4c61fabe18$var$PROTOCOL_ALLOWLIST.includes(url.protocol)) return url.toString();
    else return 'about:blank';
};
function $17b3cd4c61fabe18$export$e7bdca014c19fc5c({ children: children }) {
    $17b3cd4c61fabe18$var$useDeprecationWarning('Em');
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
        as: "em",
        children: children
    });
}
function $17b3cd4c61fabe18$export$a6c7ac8248d6e38a({ href: href, children: children, openNewTab: openNewTab, appearance: appearance }) {
    const sanitizedHref = $17b3cd4c61fabe18$export$300bd6d67c49dbfc(href);
    if (appearance === 'primary-button' || appearance === 'button') return /*#__PURE__*/ (0, $gt9Am.jsx)($17b3cd4c61fabe18$var$AkButton, {
        appearance: appearance === 'primary-button' ? 'primary' : 'default',
        href: sanitizedHref,
        rel: "noopener noreferrer",
        target: openNewTab ? '_blank' : undefined,
        children: children
    });
    else return (0, $eGOwo.fg)('dst-a11y__replace-anchor-with-link__forge-ui') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ9f5.default), {
        href: sanitizedHref,
        rel: "noopener noreferrer",
        target: openNewTab ? '_blank' : undefined,
        children: children
    }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
        href: sanitizedHref,
        rel: "noopener noreferrer",
        target: openNewTab ? '_blank' : undefined,
        children: children
    });
}
function $17b3cd4c61fabe18$export$97176b8d51d2058f({ children: children }) {
    $17b3cd4c61fabe18$var$useDeprecationWarning('Strike');
    return /*#__PURE__*/ (0, $gt9Am.jsx)("s", {
        children: children
    });
}
function $17b3cd4c61fabe18$export$89b8e0fa65f6a914({ text: text }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: text
    });
}
function $17b3cd4c61fabe18$export$f301627d437cff88({ children: children }) {
    $17b3cd4c61fabe18$var$useDeprecationWarning('Strong');
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
        as: "strong",
        children: children
    });
}
function $17b3cd4c61fabe18$var$wrap(Component) {
    return function WrappedComponent({ Components: Components, children: children, props: propsAny, render: render, renderChildren: renderChildren, dispatch: dispatch }) {
        const props = propsAny;
        return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
            ...props,
            children: renderChildren({
                Components: Components,
                children: children,
                render: render,
                dispatch: dispatch
            })
        });
    };
}
const $17b3cd4c61fabe18$export$fec26b2d751c6d95 = $17b3cd4c61fabe18$var$wrap($17b3cd4c61fabe18$export$e7bdca014c19fc5c);
const $17b3cd4c61fabe18$export$7c70dc97eeeaf683 = $17b3cd4c61fabe18$var$wrap($17b3cd4c61fabe18$export$a6c7ac8248d6e38a);
const $17b3cd4c61fabe18$export$e9e7c187aef6a83a = $17b3cd4c61fabe18$var$wrap($17b3cd4c61fabe18$export$97176b8d51d2058f);
const $17b3cd4c61fabe18$export$11a9c970dcafffc0 = $17b3cd4c61fabe18$var$wrap($17b3cd4c61fabe18$export$89b8e0fa65f6a914);
const $17b3cd4c61fabe18$export$566c617eb72a5976 = $17b3cd4c61fabe18$var$wrap($17b3cd4c61fabe18$export$f301627d437cff88);

});
parcelRegister("kpjEk", function(module, exports) {
$parcel$export(module.exports, "RendererContext", () => $a3b51b700beb671c$export$1e9ea4edb6d1bfe6);

var $eJOHy = parcelRequire("eJOHy");
const $a3b51b700beb671c$export$1e9ea4edb6d1bfe6 = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext({});

});

parcelRegister("kweLG", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f19b55055b88a2c$export$2e2bcd8739ae039);
// Displays a warning message only once per message to avoid spamming the console with the same message multiple times.
const $2f19b55055b88a2c$var$messages = new Set();
function $2f19b55055b88a2c$export$2e2bcd8739ae039(message) {
    if ($2f19b55055b88a2c$var$messages.has(message)) return;
    $2f19b55055b88a2c$var$messages.add(message);
    if (typeof window !== 'undefined') // eslint-disable-next-line no-console
    console.warn(message);
}

});

parcelRegister("bHnMU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4qZYJ").then(()=>parcelRequire('bfWEp'));

});





parcelRegister("dyHWi", function(module, exports) {
$parcel$export(module.exports, "createBridgeApi", () => $a8dfb39fe0b5d6e1$export$41b5b6d6fbe1e6b6);

var $e2h4B = parcelRequire("e2h4B");
const $a8dfb39fe0b5d6e1$export$41b5b6d6fbe1e6b6 = (bridge, args)=>{
    const { userConsentRequired: userConsentRequired } = args;
    return {
        refresh: $a8dfb39fe0b5d6e1$var$createBridgeMethod(bridge?.refresh),
        submit: $a8dfb39fe0b5d6e1$var$createBridgeMethod(bridge?.submit),
        open: $a8dfb39fe0b5d6e1$var$createBridgeMethod(bridge?.open),
        close: $a8dfb39fe0b5d6e1$var$createBridgeMethod(bridge?.close),
        onClose: $a8dfb39fe0b5d6e1$var$createBridgeMethod(bridge?.onClose),
        openModal: $a8dfb39fe0b5d6e1$var$createBridgeMethod(bridge?.openModal, {
            requiresUserConsent: userConsentRequired
        }),
        showFlag: $a8dfb39fe0b5d6e1$var$createBridgeMethod(bridge?.showFlag),
        closeFlag: $a8dfb39fe0b5d6e1$var$createBridgeMethod(bridge?.closeFlag),
        reconcile: $a8dfb39fe0b5d6e1$var$createBridgeMethod(bridge?.reconcile),
        onError: $a8dfb39fe0b5d6e1$var$createBridgeMethod(bridge?.onError),
        createHistory: ()=>(0, $e2h4B.createHistory)({
                history: bridge?.history,
                extensionBasePath: bridge?.extensionBasePath
            }),
        changeWindowTitle: $a8dfb39fe0b5d6e1$var$createBridgeMethod(bridge?.changeWindowTitle)
    };
};
const $a8dfb39fe0b5d6e1$var$createBridgeMethod = (method, ...args)=>{
    return async (payload)=>{
        if (method) return method(payload, ...args) ?? true;
        return false;
    };
};

});
parcelRegister("e2h4B", function(module, exports) {
$parcel$export(module.exports, "createHistory", () => $4c131d80a3f37f2e$export$4178d7ac16e6cf7c);

var $f3yFH = parcelRequire("f3yFH");
const $4c131d80a3f37f2e$export$21f63b78155c2049 = (extensionBasePath)=>{
    return {
        extensionRouteToFullPath: (extensionRoute)=>`${extensionBasePath}${extensionRoute ?? ''}`,
        fullPathToExtensionRoute: (fullLocation)=>{
            const extensionRoute = fullLocation.split(extensionBasePath).pop();
            return extensionRoute ? extensionRoute : '/';
        }
    };
};
const $4c131d80a3f37f2e$export$4178d7ac16e6cf7c = ({ history: history, extensionBasePath: extensionBasePath })=>{
    if (!history || !extensionBasePath) throw new (0, $f3yFH.BridgeClientError)('History API is not available within this module.');
    const { extensionRouteToFullPath: extensionRouteToFullPath, fullPathToExtensionRoute: fullPathToExtensionRoute } = $4c131d80a3f37f2e$export$21f63b78155c2049(extensionBasePath);
    const parseLocation = (location, parser)=>({
            ...location,
            pathname: parser(location.pathname)
        });
    const setNewHistoryLocation = (type, pathOrLocation, state)=>{
        const setHistory = type === 'push' ? history.push : history.replace;
        if (typeof pathOrLocation === 'string') return setHistory(extensionRouteToFullPath(pathOrLocation), state);
        return setHistory(parseLocation({
            state: state,
            ...pathOrLocation
        }, extensionRouteToFullPath));
    };
    return {
        ...history,
        location: parseLocation(history.location, fullPathToExtensionRoute),
        push (pathOrLocation, state) {
            setNewHistoryLocation('push', pathOrLocation, state);
        },
        replace (pathOrLocation, state) {
            setNewHistoryLocation('replace', pathOrLocation, state);
        },
        listen (listener) {
            const unlisten = history.listen((location, action)=>{
                listener(parseLocation(location, fullPathToExtensionRoute), action);
            });
            return unlisten;
        }
    };
};

});
parcelRegister("f3yFH", function(module, exports) {
$parcel$export(module.exports, "BridgeClientError", () => $fe956540c3e65436$export$d86296fe47e644cc);
$parcel$export(module.exports, "useBridge", () => $fe956540c3e65436$export$23a7a1286dcfa590);

var $eJOHy = parcelRequire("eJOHy");

var $g8IkM = parcelRequire("g8IkM");

var $iaMh6 = parcelRequire("iaMh6");

var $ftN6c = parcelRequire("ftN6c");

var $lopBx = parcelRequire("lopBx");

var $01wZP = parcelRequire("01wZP");

var $aVjJN = parcelRequire("aVjJN");

var $hmwFh = parcelRequire("hmwFh");

var $aGi2o = parcelRequire("aGi2o");

var $1H69i = parcelRequire("1H69i");

var $6SUez = parcelRequire("6SUez");
var $kKhkW = parcelRequire("kKhkW");


var $dHXR3 = parcelRequire("dHXR3");

var $6yq62 = parcelRequire("6yq62");

var $cGlYw = parcelRequire("cGlYw");

var $cOLOr = parcelRequire("cOLOr");
var $ezmKu = parcelRequire("ezmKu");

var $6k0E4 = parcelRequire("6k0E4");

var $eGOwo = parcelRequire("eGOwo");

var $dr03k = parcelRequire("dr03k");

var $aD4zl = parcelRequire("aD4zl");

var $lmoym = parcelRequire("lmoym");

var $cOZrT = parcelRequire("cOZrT");

var $6QUJr = parcelRequire("6QUJr");

var $grXB3 = parcelRequire("grXB3");
let $fe956540c3e65436$var$createIframeBridge = null;

// bridge-core import relies on window object. It is not available in SSR.
if (typeof window !== 'undefined') $fe956540c3e65436$var$createIframeBridge = (parcelRequire("kLtNc")).createIframeBridge;
const $fe956540c3e65436$var$mapCustomBridgeMethods = (customBridgeMethods)=>{
    if (!customBridgeMethods) return {};
    return Object.keys(customBridgeMethods).reduce((acc, key)=>{
        return {
            ...acc,
            [key]: (payload)=>{
                return customBridgeMethods[key](payload?.data);
            }
        };
    }, {});
};
class $fe956540c3e65436$export$d86296fe47e644cc extends Error {
    constructor(cause){
        super(cause);
    }
}
const $fe956540c3e65436$var$MACRO_MODULE_NAME = 'xen:macro';
const $fe956540c3e65436$export$23a7a1286dcfa590 = ({ cloudId: cloudId, theme: theme, surfaceColor: surfaceColor, origin: origin, api: api, customBridgeMethods: customBridgeMethods, onLoad: onLoad, isResizable: isResizable, height: height, environment: environment, extension: extension, iframeRef: iframeRef, client: client, contextIds: contextIds })=>{
    const [loading, setLoading] = (0, $eJOHy.useState)(true);
    const [loadedAt, setLoadedAt] = (0, $eJOHy.useState)(null);
    const { page: page } = (0, $6yq62.useMetricsContext)();
    // This ref avoids the api object ending up in the dep array
    // of the effect that calls createIframeBridge. It means that
    // people can pass anonymous functions as the api without the
    // bridge being re-created every render.
    const apiRef = (0, $eJOHy.useRef)(api);
    (0, $eJOHy.useEffect)(()=>{
        apiRef.current = api;
    }, [
        api
    ]);
    const enableThemingRef = (0, $eJOHy.useRef)();
    const setThemeRef = (0, $eJOHy.useRef)();
    (0, $eJOHy.useEffect)(()=>{
        if (!setThemeRef.current) return;
        setThemeRef.current(theme, surfaceColor, environment);
    }, [
        theme,
        surfaceColor,
        loading,
        environment
    ]);
    // same as above, but for customBridgeMethods
    const customBridgeMethodsRef = (0, $eJOHy.useRef)(customBridgeMethods);
    (0, $eJOHy.useEffect)(()=>{
        customBridgeMethodsRef.current = customBridgeMethods;
    }, [
        customBridgeMethods
    ]);
    const [errorExtensionDetails, setErrorExtensionDetails] = (0, $eJOHy.useState)({
        id: extension.id,
        properties: extension.properties,
        type: extension.type,
        environmentType: extension.environmentType,
        appOwnerAccountId: extension.appOwner?.accountId
    });
    const tracing = (0, $kKhkW.useTracingContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { trackExtensionClicked: trackExtensionClicked, trackForgeFeatureFlagEvent: trackForgeFeatureFlagEvent } = (0, $cOZrT.useForgeUiAnalyticsEvent)();
    (0, $eJOHy.useEffect)(()=>{
        const { type: type, environmentType: environmentType, properties: properties, appOwnerAccountId: appOwnerAccountId, id: id } = errorExtensionDetails;
        if (extension.id !== id || extension.type !== type || extension.environmentType !== environmentType || extension.appOwner?.accountId !== appOwnerAccountId || !(0, (/*@__PURE__*/$parcel$interopDefault($g8IkM)))(extension.properties, properties)) setErrorExtensionDetails({
            id: extension.id,
            properties: extension.properties,
            type: extension.type,
            environmentType: extension.environmentType,
            appOwnerAccountId: extension.appOwner?.accountId
        });
    }, [
        extension,
        errorExtensionDetails
    ]);
    const { id: id, installationId: installationId } = extension;
    // Need to retrieve appId here because extension.appId could be undefined in certain products. For example, Jira extensions do not provide the appId.
    const appId = extension.appId ?? (0, $ezmKu.parseExtensionId)(extension.id).appId;
    const getAppForgeUIExtensions = (0, $6k0E4.useGetAppForgeUIExtensions)({
        client: client,
        appId: appId,
        environmentId: extension.environmentId,
        moduleType: extension.type,
        contextIds: contextIds,
        context: {},
        includeHidden: false,
        cloudId: cloudId,
        bypassNewForgeExtensionListCall: true
    });
    // Query to retrieve the base url of a tenant.
    // The same Atlassian tenant could have a different custom domain for each product.
    // We retrieve the underlying Atlassian domain here to use for URL creation in routing to support cross custom domain routing
    const getBaseUrl = (0, $eJOHy.useCallback)(async ()=>{
        return cloudId ? await (0, $dr03k.getBaseUrl)(client, cloudId) : window.location.origin;
    }, [
        client,
        cloudId
    ]);
    const appType = (0, $eJOHy.useMemo)(()=>(0, $cOLOr.isCustomUI)(extension) ? 'CustomUI' : 'UIKit', [
        extension
    ]);
    const { captureEvent: captureEvent, captureUntrustedEvent: captureUntrustedEvent } = (0, $grXB3.usePerformanceAnalytics)();
    (0, $eJOHy.useEffect)(()=>{
        //this should never happen on client side
        if (!$fe956540c3e65436$var$createIframeBridge) return;
        const iframeEl = iframeRef.current;
        if (iframeEl?.contentWindow && !loading && typeof loadedAt === 'number') {
            const eventCallbacks = [];
            const extensionDetails = {
                id: id.split('/').slice(0, 3).join('/'),
                installationId: installationId
            };
            const sendHandshakeMetric = (page)=>{
                return (success, error)=>{
                    if (success) createAnalyticsEvent({
                        eventType: (0, $d6f34b7bd34f6138$export$12346a674644c156),
                        data: {
                            action: 'succeeded',
                            actionSubject: 'forge.ui.bridge',
                            attributes: {
                                target: 'handshake'
                            },
                            source: page,
                            tags: [
                                'forge'
                            ]
                        }
                    }).fire((0, $dHXR3.FORGE_UI_ANALYTICS_CHANNEL));
                    else {
                        createAnalyticsEvent({
                            eventType: (0, $d6f34b7bd34f6138$export$12346a674644c156),
                            data: {
                                action: 'failed',
                                actionSubject: 'forge.ui.bridge',
                                attributes: {
                                    target: 'handshake',
                                    reason: error instanceof Error ? error.message : 'Unknown error',
                                    isUnrecoverable: (0, $lmoym.isUnrecoverableError)(error)
                                },
                                source: page,
                                tags: [
                                    'forge'
                                ]
                            }
                        }).fire((0, $dHXR3.FORGE_UI_ANALYTICS_CHANNEL));
                        const handshakeError = error instanceof Error ? new Error(`Bridge handshake error: ${error.message}`) : new Error('Unknown bridge handshake error');
                        (0, $6SUez.captureAndReportError)({
                            error: handshakeError,
                            environment: environment,
                            errorExtensionDetails: errorExtensionDetails,
                            page: page,
                            tracing: tracing
                        });
                    }
                };
            };
            const { open: open } = $fe956540c3e65436$var$createIframeBridge({
                theme: theme,
                surfaceColor: surfaceColor,
                withDomain: origin,
                withWindow: iframeEl.contentWindow,
                metadata: {
                    env: environment,
                    module: extension.type,
                    product: extension.type.split(':')[0],
                    isFedRamp: (0, $lopBx.isFedRamp)()
                },
                features: (0, $aVjJN.withMetricsAndAnalytics)({
                    features: {
                        invoke: async ({ data: data })=>{
                            const performanceStart = (0, $6QUJr.getPerformanceMark)();
                            if ((0, $eGOwo.fg)('forge-ui-performance-analytics-provider')) captureEvent({
                                type: 'resolver-invoke-initiated',
                                elapsed: performanceStart
                            });
                            const { onInvoke: onInvoke, onThreeLO: onThreeLO } = apiRef.current;
                            const result = await onInvoke(data);
                            if (result.type === '3lo') return new Promise((resolve, reject)=>{
                                onThreeLO(result.authUrl, ()=>{
                                    const performanceAuthEnd = (0, $6QUJr.getPerformanceMark)();
                                    return onInvoke(data).then((res)=>{
                                        if (res.type === 'ok') resolve(res.response);
                                        if ((0, $eGOwo.fg)('forge-ui-performance-analytics-provider')) {
                                            const performanceEnd = (0, $6QUJr.getPerformanceMark)();
                                            captureEvent({
                                                type: 'resolver-invoked',
                                                duration: performanceEnd - performanceStart,
                                                authDuration: performanceAuthEnd - performanceStart,
                                                elapsed: performanceEnd
                                            });
                                        }
                                        // Unexpected case where 3LO consent requested again after consenting
                                        reject();
                                    }, reject);
                                });
                            });
                            if ((0, $eGOwo.fg)('forge-ui-performance-analytics-provider')) {
                                const performanceEnd = (0, $6QUJr.getPerformanceMark)();
                                captureEvent({
                                    type: 'resolver-invoked',
                                    duration: performanceEnd - performanceStart,
                                    authDuration: 0,
                                    elapsed: performanceEnd
                                });
                            }
                            if (result.type === 'err') throw new Error(result.message);
                            return result.response;
                        },
                        initFeatureFlags: async ({ data: data })=>{
                            if (!(0, $eGOwo.fg)('platform_forge_ff_client_sdk')) return {};
                            const { onInitFeatureFlags: onInitFeatureFlags } = apiRef.current;
                            const result = await onInitFeatureFlags(data);
                            if ((0, $eGOwo.fg)('platform_forge_ff_ui_analytics')) trackForgeFeatureFlagEvent({
                                appType: appType,
                                appId: appId,
                                baseUrl: window.location.origin,
                                eventType: (0, $aGi2o.FeatureFlagEventTypes).INITIALIZATION,
                                success: result.type !== 'err',
                                featureFlagEnv: data.user?.statsigEnvironment?.tier || (0, $aGi2o.FeatureFlagEnv).development,
                                forgeEnvironment: extension.environmentType
                            });
                            if (result.type === 'err') return {};
                            return result.response;
                        },
                        trackFeatureFlagEvent: async ({ data: data })=>{
                            if (!(0, $eGOwo.fg)('platform_forge_ff_ui_analytics')) return;
                            const allowedEventTypes = [
                                (0, $aGi2o.FeatureFlagEventTypes).CHECKFLAG.toUpperCase()
                            ];
                            try {
                                // basic validations
                                if (!data.type || !allowedEventTypes.includes(data.type.toUpperCase())) return;
                                if (data.type.toUpperCase() === (0, $aGi2o.FeatureFlagEventTypes).CHECKFLAG && data.properties.name && (data.properties.name.length < 3 || data.properties.name > 50)) return;
                                if (typeof data.properties.success !== 'boolean') return;
                                if (!(data.properties.environment && data.properties.environment.toLowerCase() in (0, $aGi2o.FeatureFlagEnv))) return;
                                trackForgeFeatureFlagEvent({
                                    appType: appType,
                                    appId: appId,
                                    baseUrl: window.location.origin,
                                    flagName: data.properties.name || '',
                                    eventType: data.type,
                                    success: data.properties.success,
                                    featureFlagEnv: data.properties.environment,
                                    forgeEnvironment: extension.environmentType
                                });
                            } catch (e) {
                            // all errors are ignored
                            }
                            return;
                        },
                        'iframe-analytics': async ({ data: data })=>{
                            if ((0, $eGOwo.fg)('forge-ui-performance-analytics-provider')) captureUntrustedEvent(data);
                            if ((0, $eGOwo.fg)('forge-ui-iframe-analytics')) {
                                if (data.event === 'click') trackExtensionClicked({
                                    extensionType: extension.type,
                                    appType: appType,
                                    forgeEnvironment: extension.environmentType,
                                    baseUrl: window.location.origin
                                });
                            }
                        },
                        getUrl: async ({ data: data })=>{
                            if (data.target && getAppForgeUIExtensions) {
                                const path = await (0, $cGlYw.createNavigateTargetPath)(data, {
                                    getContext: apiRef.current.getContext,
                                    getAppForgeUIExtensions: getAppForgeUIExtensions
                                });
                                if (!path) return null;
                                // If the current domain is a custom domain, we need to request for the base url
                                const baseUrl = (0, $aD4zl.isCustomDomain)(window.location.hostname) ? await getBaseUrl() : window.location.origin;
                                // `getUrl` from `@forge/bridge` will return a URL object.
                                // We are returning a string here as a URL object will serialised into a string when being passed across the bridge
                                return `${baseUrl}${path}`;
                            }
                            return null;
                        },
                        navigate: async ({ data: data })=>{
                            // If a NavigationLocation object was provided:
                            if ('target' in data && data.target && getAppForgeUIExtensions && (0, $eGOwo.fg)('forge-ui-navigation')) {
                                const path = await (0, $cGlYw.createNavigateTargetPath)(data, {
                                    getContext: apiRef.current.getContext,
                                    getAppForgeUIExtensions: getAppForgeUIExtensions
                                });
                                if (!path) {
                                    // eslint-disable-next-line no-console
                                    console.warn('Path was not found for the parameters provided');
                                    return;
                                }
                                // Request for the base url if the current domain is a custom domain
                                if ((0, $aD4zl.isCustomDomain)(window.location.hostname) && (0, $eGOwo.fg)('forge-ui-cross-custom-domain-navigation')) {
                                    const baseUrl = await getBaseUrl();
                                    return apiRef.current.onNavigate({
                                        type: data.type,
                                        url: `${baseUrl}${path}`
                                    });
                                } else return apiRef.current.onNavigate({
                                    type: data.type,
                                    url: path
                                });
                            }
                            return apiRef.current.onNavigate(data);
                        },
                        reconcile: async ({ data: data })=>{
                            return apiRef.current.reconcile(data);
                        },
                        onError: async ({ data: data })=>{
                            return apiRef.current.onError(data);
                        },
                        reload: async ()=>{
                            (0, $hmwFh.reload)();
                        },
                        refresh: async ()=>{
                            return apiRef.current.refresh();
                        },
                        submit: async (payload)=>{
                            return apiRef.current.submit(payload);
                        },
                        open: async ()=>{
                            return apiRef.current.open();
                        },
                        onClose: async (payload)=>{
                            return apiRef.current.onClose(payload);
                        },
                        close: async (payload)=>{
                            return apiRef.current.close(payload);
                        },
                        getContext: ()=>{
                            return apiRef.current.getContext();
                        },
                        openModal: async (payload)=>{
                            return apiRef.current.openModal(payload);
                        },
                        createHistory: async ()=>{
                            return apiRef.current.createHistory();
                        },
                        fetchProduct: async ({ data: data })=>{
                            return apiRef.current.fetchProduct(data);
                        },
                        showFlag: async ({ data: data })=>{
                            const flagActions = data.actions?.map((action)=>{
                                const { onClick: onClick } = action;
                                return {
                                    ...action,
                                    onClick: onClick ? ()=>onClick() : ()=>{}
                                };
                            });
                            return apiRef.current.showFlag({
                                ...data,
                                actions: flagActions
                            });
                        },
                        closeFlag: async ({ data: data })=>{
                            return apiRef.current.closeFlag(data);
                        },
                        on: async (payload)=>{
                            const { event: event, callback: callback } = payload.data;
                            const subscription = (0, $1H69i.on)(event, callback, extensionDetails);
                            eventCallbacks.push(subscription);
                            return {
                                unsubscribe: ()=>{
                                    eventCallbacks.splice(eventCallbacks.indexOf(subscription), 1);
                                    subscription.unsubscribe();
                                }
                            };
                        },
                        emit: async (payload)=>{
                            return (0, $1H69i.emit)(payload.data.event, payload.data.payload, extensionDetails);
                        },
                        enableTheming: async ()=>{
                            await enableThemingRef.current?.();
                            const currentTheme = (0, $01wZP.default)();
                            const surfaceColor = null;
                            setThemeRef.current?.(currentTheme, surfaceColor, environment);
                        },
                        changeWindowTitle: async ({ data: data })=>{
                            apiRef.current.changeWindowTitle(data);
                        },
                        getFrameId: async ()=>{
                            return apiRef.current.getFrameId();
                        },
                        subscribeRealtimeChannel: async (payload)=>{
                            return apiRef.current.subscribeRealtimeChannel?.(payload);
                        },
                        publishRealtimeChannel: async (payload)=>{
                            return apiRef.current.publishRealtimeChannel?.(payload);
                        },
                        openRovo: async ({ data: data })=>{
                            return apiRef.current.openRovo?.(data);
                        },
                        ...$fe956540c3e65436$var$mapCustomBridgeMethods(customBridgeMethodsRef.current)
                    },
                    page: page,
                    environment: environment,
                    forgeEnvironment: extension.environmentType,
                    errorExtensionDetails: errorExtensionDetails,
                    createAnalyticsEvent: createAnalyticsEvent,
                    tracing: tracing
                }),
                sendHandshakeMetric: sendHandshakeMetric(page)
            });
            if (isResizable) (0, $iaMh6.iframeResizer)({
                heightCalculationMethod: 'bodyScroll',
                widthCalculationMethod: 'bodyScroll',
                scrolling: true,
                // @ts-ignore minHeight can be a string
                minHeight: height,
                // sizeWidth is enabled for resizing only for inline macros
                sizeWidth: extension.properties.layout === 'inline' && extension.type === $fe956540c3e65436$var$MACRO_MODULE_NAME,
                initCallback: (iframe)=>{
                    iframe?.iFrameResizer?.resize();
                }
            }, iframeEl);
            const { close: close, enableTheming: enableTheming, setTheme: setTheme } = open();
            setThemeRef.current = setTheme;
            enableThemingRef.current = enableTheming;
            return ()=>{
                close?.(); // close may be undefined here if createIframeBridge call fails
                for (const subscription of eventCallbacks)subscription.unsubscribe();
                iframeEl?.iFrameResizer && iframeEl?.iFrameResizer.removeListeners();
            };
        }
    }, [
        getBaseUrl,
        iframeRef,
        origin,
        loading,
        page,
        isResizable,
        height,
        environment,
        errorExtensionDetails,
        id,
        extension.properties.layout,
        extension.type,
        extension.environmentType,
        installationId,
        tracing,
        theme,
        surfaceColor,
        createAnalyticsEvent,
        loadedAt,
        getAppForgeUIExtensions,
        trackExtensionClicked,
        appType,
        captureEvent,
        captureUntrustedEvent,
        appId,
        trackForgeFeatureFlagEvent
    ]);
    return {
        loading: loading,
        iframeProps: {
            ref: iframeRef,
            onLoad: ()=>{
                onLoad && onLoad();
                setLoading(false);
                setLoadedAt(Date.now());
            }
        }
    };
};

});
parcelRegister("g8IkM", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("iaMh6", function(module, exports) {

module.exports = (parcelRequire("3V2Sl"));

});
parcelRegister("3V2Sl", function(module, exports) {
$parcel$export(module.exports, "iframeResize", () => $2da8ecfa03b8c559$export$e284ab1b3bcdabe6, (v) => $2da8ecfa03b8c559$export$e284ab1b3bcdabe6 = v);
$parcel$export(module.exports, "iframeResizer", () => $2da8ecfa03b8c559$export$b6962bfb5a91d43, (v) => $2da8ecfa03b8c559$export$b6962bfb5a91d43 = v);
$parcel$export(module.exports, "iframeResizerContentWindow", () => $2da8ecfa03b8c559$export$1aafc108bc1f168c, (v) => $2da8ecfa03b8c559$export$1aafc108bc1f168c = v);
var $2da8ecfa03b8c559$export$e284ab1b3bcdabe6;
var $2da8ecfa03b8c559$export$b6962bfb5a91d43// Backwards compatability
;
var $2da8ecfa03b8c559$export$1aafc108bc1f168c;

var $gT7BS = parcelRequire("gT7BS");
$2da8ecfa03b8c559$export$e284ab1b3bcdabe6 = $gT7BS;
$2da8ecfa03b8c559$export$b6962bfb5a91d43 = $gT7BS;

$2da8ecfa03b8c559$export$1aafc108bc1f168c = (parcelRequire("3e4Gk"));

});
parcelRegister("gT7BS", function(module, exports) {
/*
 * File: iframeResizer.js
 * Desc: Force iframes to size to content.
 * Requires: iframeResizer.contentWindow.js to be loaded into the target frame.
 * Doc: https://github.com/davidjbradshaw/iframe-resizer
 * Author: David J. Bradshaw - dave@bradshaw.net
 * Contributor: Jure Mav - jure.mav@gmail.com
 * Contributor: Reed Dadoune - reed@dadoune.com
 */ // eslint-disable-next-line sonarjs/cognitive-complexity, no-shadow-restricted-names
(function(undefined) {
    if (typeof window === 'undefined') return; // don't run for server side render
    var count = 0, logEnabled = false, hiddenCheckEnabled = false, msgHeader = 'message', msgHeaderLen = msgHeader.length, msgId = '[iFrameSizer]', msgIdLen = msgId.length, pagePosition = null, requestAnimationFrame = window.requestAnimationFrame, resetRequiredMethods = {
        max: 1,
        scroll: 1,
        bodyScroll: 1,
        documentElementScroll: 1
    }, settings = {}, timer = null, defaults = {
        autoResize: true,
        bodyBackground: null,
        bodyMargin: null,
        bodyMarginV1: 8,
        bodyPadding: null,
        checkOrigin: true,
        inPageLinks: false,
        enablePublicMethods: true,
        heightCalculationMethod: 'bodyOffset',
        id: 'iFrameResizer',
        interval: 32,
        log: false,
        maxHeight: Infinity,
        maxWidth: Infinity,
        minHeight: 0,
        minWidth: 0,
        mouseEvents: true,
        resizeFrom: 'parent',
        scrolling: false,
        sizeHeight: true,
        sizeWidth: false,
        warningTimeout: 5000,
        tolerance: 0,
        widthCalculationMethod: 'scroll',
        onClose: function() {
            return true;
        },
        onClosed: function() {},
        onInit: function() {},
        onMessage: function() {
            warn('onMessage function not defined');
        },
        onMouseEnter: function() {},
        onMouseLeave: function() {},
        onResized: function() {},
        onScroll: function() {
            return true;
        }
    };
    function getMutationObserver() {
        return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
    }
    function addEventListener(el, evt, func) {
        el.addEventListener(evt, func, false);
    }
    function removeEventListener(el, evt, func) {
        el.removeEventListener(evt, func, false);
    }
    function setupRequestAnimationFrame() {
        var vendors = [
            'moz',
            'webkit',
            'o',
            'ms'
        ];
        var x;
        // Remove vendor prefixing if prefixed and break early if not
        for(x = 0; x < vendors.length && !requestAnimationFrame; x += 1)requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
        if (!requestAnimationFrame) log('setup', 'RequestAnimationFrame not supported');
        else // Firefox extension content-scripts have a globalThis object that is not the same as window.
        // Binding `requestAnimationFrame` to window allows the function to work and prevents errors
        // being thrown when run in that context, and should be a no-op in every other context.
        requestAnimationFrame = requestAnimationFrame.bind(window);
    }
    function getMyID(iframeId) {
        var retStr = 'Host page: ' + iframeId;
        if (window.top !== window.self) retStr = window.parentIFrame && window.parentIFrame.getId ? window.parentIFrame.getId() + ': ' + iframeId : 'Nested host page: ' + iframeId;
        return retStr;
    }
    function formatLogHeader(iframeId) {
        return msgId + '[' + getMyID(iframeId) + ']';
    }
    function isLogEnabled(iframeId) {
        return settings[iframeId] ? settings[iframeId].log : logEnabled;
    }
    function log(iframeId, msg) {
        output('log', iframeId, msg, isLogEnabled(iframeId));
    }
    function info(iframeId, msg) {
        output('info', iframeId, msg, isLogEnabled(iframeId));
    }
    function warn(iframeId, msg) {
        output('warn', iframeId, msg, true);
    }
    function output(type, iframeId, msg, enabled) {
        if (true === enabled && 'object' === typeof window.console) // eslint-disable-next-line no-console
        console[type](formatLogHeader(iframeId), msg);
    }
    function iFrameListener(event) {
        function resizeIFrame() {
            function resize() {
                setSize(messageData);
                setPagePosition(iframeId);
                on('onResized', messageData);
            }
            ensureInRange('Height');
            ensureInRange('Width');
            syncResize(resize, messageData, 'init');
        }
        function processMsg() {
            var data = msg.substr(msgIdLen).split(':');
            var height = data[1] ? parseInt(data[1], 10) : 0;
            var iframe = settings[data[0]] && settings[data[0]].iframe;
            var compStyle = getComputedStyle(iframe);
            return {
                iframe: iframe,
                id: data[0],
                height: height + getPaddingEnds(compStyle) + getBorderEnds(compStyle),
                width: data[2],
                type: data[3]
            };
        }
        function getPaddingEnds(compStyle) {
            if (compStyle.boxSizing !== 'border-box') return 0;
            var top = compStyle.paddingTop ? parseInt(compStyle.paddingTop, 10) : 0;
            var bot = compStyle.paddingBottom ? parseInt(compStyle.paddingBottom, 10) : 0;
            return top + bot;
        }
        function getBorderEnds(compStyle) {
            if (compStyle.boxSizing !== 'border-box') return 0;
            var top = compStyle.borderTopWidth ? parseInt(compStyle.borderTopWidth, 10) : 0;
            var bot = compStyle.borderBottomWidth ? parseInt(compStyle.borderBottomWidth, 10) : 0;
            return top + bot;
        }
        function ensureInRange(Dimension) {
            var max = Number(settings[iframeId]['max' + Dimension]), min = Number(settings[iframeId]['min' + Dimension]), dimension = Dimension.toLowerCase(), size = Number(messageData[dimension]);
            log(iframeId, 'Checking ' + dimension + ' is in range ' + min + '-' + max);
            if (size < min) {
                size = min;
                log(iframeId, 'Set ' + dimension + ' to min value');
            }
            if (size > max) {
                size = max;
                log(iframeId, 'Set ' + dimension + ' to max value');
            }
            messageData[dimension] = '' + size;
        }
        function isMessageFromIFrame() {
            function checkAllowedOrigin() {
                function checkList() {
                    var i = 0, retCode = false;
                    log(iframeId, 'Checking connection is from allowed list of origins: ' + checkOrigin);
                    for(; i < checkOrigin.length; i++)if (checkOrigin[i] === origin) {
                        retCode = true;
                        break;
                    }
                    return retCode;
                }
                function checkSingle() {
                    var remoteHost = settings[iframeId] && settings[iframeId].remoteHost;
                    log(iframeId, 'Checking connection is from: ' + remoteHost);
                    return origin === remoteHost;
                }
                return checkOrigin.constructor === Array ? checkList() : checkSingle();
            }
            var origin = event.origin, checkOrigin = settings[iframeId] && settings[iframeId].checkOrigin;
            if (checkOrigin && '' + origin !== 'null' && !checkAllowedOrigin()) throw new Error('Unexpected message received from: ' + origin + ' for ' + messageData.iframe.id + '. Message was: ' + event.data + '. This error can be disabled by setting the checkOrigin: false option or by providing of array of trusted domains.');
            return true;
        }
        function isMessageForUs() {
            return msgId === ('' + msg).substr(0, msgIdLen) && msg.substr(msgIdLen).split(':')[0] in settings // ''+Protects against non-string msg
            ;
        }
        function isMessageFromMetaParent() {
            // Test if this message is from a parent above us. This is an ugly test, however, updating
            // the message format would break backwards compatibity.
            var retCode = messageData.type in {
                true: 1,
                false: 1,
                undefined: 1
            };
            if (retCode) log(iframeId, 'Ignoring init message from meta parent page');
            return retCode;
        }
        function getMsgBody(offset) {
            return msg.substr(msg.indexOf(':') + msgHeaderLen + offset);
        }
        function forwardMsgFromIFrame(msgBody) {
            log(iframeId, 'onMessage passed: {iframe: ' + messageData.iframe.id + ', message: ' + msgBody + '}');
            on('onMessage', {
                iframe: messageData.iframe,
                message: JSON.parse(msgBody)
            });
            log(iframeId, '--');
        }
        function getPageInfo() {
            var bodyPosition = document.body.getBoundingClientRect(), iFramePosition = messageData.iframe.getBoundingClientRect();
            return JSON.stringify({
                iframeHeight: iFramePosition.height,
                iframeWidth: iFramePosition.width,
                clientHeight: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
                clientWidth: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
                offsetTop: parseInt(iFramePosition.top - bodyPosition.top, 10),
                offsetLeft: parseInt(iFramePosition.left - bodyPosition.left, 10),
                scrollTop: window.pageYOffset,
                scrollLeft: window.pageXOffset,
                documentHeight: document.documentElement.clientHeight,
                documentWidth: document.documentElement.clientWidth,
                windowHeight: window.innerHeight,
                windowWidth: window.innerWidth
            });
        }
        function sendPageInfoToIframe(iframe, iframeId) {
            function debouncedTrigger() {
                trigger('Send Page Info', 'pageInfo:' + getPageInfo(), iframe, iframeId);
            }
            debounceFrameEvents(debouncedTrigger, 32, iframeId);
        }
        function startPageInfoMonitor() {
            function setListener(type, func) {
                function sendPageInfo() {
                    if (settings[id]) sendPageInfoToIframe(settings[id].iframe, id);
                    else stop();
                }
                [
                    'scroll',
                    'resize'
                ].forEach(function(evt) {
                    log(id, type + evt + ' listener for sendPageInfo');
                    func(window, evt, sendPageInfo);
                });
            }
            function stop() {
                setListener('Remove ', removeEventListener);
            }
            function start() {
                setListener('Add ', addEventListener);
            }
            var id = iframeId // Create locally scoped copy of iFrame ID
            ;
            start();
            if (settings[id]) settings[id].stopPageInfo = stop;
        }
        function stopPageInfoMonitor() {
            if (settings[iframeId] && settings[iframeId].stopPageInfo) {
                settings[iframeId].stopPageInfo();
                delete settings[iframeId].stopPageInfo;
            }
        }
        function checkIFrameExists() {
            var retBool = true;
            if (null === messageData.iframe) {
                warn(iframeId, 'IFrame (' + messageData.id + ') not found');
                retBool = false;
            }
            return retBool;
        }
        function getElementPosition(target) {
            var iFramePosition = target.getBoundingClientRect();
            getPagePosition(iframeId);
            return {
                x: Math.floor(Number(iFramePosition.left) + Number(pagePosition.x)),
                y: Math.floor(Number(iFramePosition.top) + Number(pagePosition.y))
            };
        }
        function scrollRequestFromChild(addOffset) {
            /* istanbul ignore next */ // Not testable in Karma
            function reposition() {
                pagePosition = newPosition;
                scrollTo();
                log(iframeId, '--');
            }
            function calcOffset() {
                return {
                    x: Number(messageData.width) + offset.x,
                    y: Number(messageData.height) + offset.y
                };
            }
            function scrollParent() {
                if (window.parentIFrame) window.parentIFrame['scrollTo' + (addOffset ? 'Offset' : '')](newPosition.x, newPosition.y);
                else warn(iframeId, 'Unable to scroll to requested position, window.parentIFrame not found');
            }
            var offset = addOffset ? getElementPosition(messageData.iframe) : {
                x: 0,
                y: 0
            }, newPosition = calcOffset();
            log(iframeId, 'Reposition requested from iFrame (offset x:' + offset.x + ' y:' + offset.y + ')');
            if (window.top !== window.self) scrollParent();
            else reposition();
        }
        function scrollTo() {
            if (false !== on('onScroll', pagePosition)) setPagePosition(iframeId);
            else unsetPagePosition();
        }
        function findTarget(location) {
            function jumpToTarget() {
                var jumpPosition = getElementPosition(target);
                log(iframeId, 'Moving to in page link (#' + hash + ') at x: ' + jumpPosition.x + ' y: ' + jumpPosition.y);
                pagePosition = {
                    x: jumpPosition.x,
                    y: jumpPosition.y
                };
                scrollTo();
                log(iframeId, '--');
            }
            function jumpToParent() {
                if (window.parentIFrame) window.parentIFrame.moveToAnchor(hash);
                else log(iframeId, 'In page link #' + hash + ' not found and window.parentIFrame not found');
            }
            var hash = location.split('#')[1] || '', hashData = decodeURIComponent(hash), target = document.getElementById(hashData) || document.getElementsByName(hashData)[0];
            if (target) jumpToTarget();
            else if (window.top !== window.self) jumpToParent();
            else log(iframeId, 'In page link #' + hash + ' not found');
        }
        function onMouse(event) {
            var mousePos = {};
            if (Number(messageData.width) === 0 && Number(messageData.height) === 0) {
                var data = getMsgBody(9).split(':');
                mousePos = {
                    x: data[1],
                    y: data[0]
                };
            } else mousePos = {
                x: messageData.width,
                y: messageData.height
            };
            on(event, {
                iframe: messageData.iframe,
                screenX: Number(mousePos.x),
                screenY: Number(mousePos.y),
                type: messageData.type
            });
        }
        function on(funcName, val) {
            return chkEvent(iframeId, funcName, val);
        }
        function actionMsg() {
            if (settings[iframeId] && settings[iframeId].firstRun) firstRun();
            switch(messageData.type){
                case 'close':
                    closeIFrame(messageData.iframe);
                    break;
                case 'message':
                    forwardMsgFromIFrame(getMsgBody(6));
                    break;
                case 'mouseenter':
                    onMouse('onMouseEnter');
                    break;
                case 'mouseleave':
                    onMouse('onMouseLeave');
                    break;
                case 'autoResize':
                    settings[iframeId].autoResize = JSON.parse(getMsgBody(9));
                    break;
                case 'scrollTo':
                    scrollRequestFromChild(false);
                    break;
                case 'scrollToOffset':
                    scrollRequestFromChild(true);
                    break;
                case 'pageInfo':
                    sendPageInfoToIframe(settings[iframeId] && settings[iframeId].iframe, iframeId);
                    startPageInfoMonitor();
                    break;
                case 'pageInfoStop':
                    stopPageInfoMonitor();
                    break;
                case 'inPageLink':
                    findTarget(getMsgBody(9));
                    break;
                case 'reset':
                    resetIFrame(messageData);
                    break;
                case 'init':
                    resizeIFrame();
                    on('onInit', messageData.iframe);
                    break;
                default:
                    if (Number(messageData.width) === 0 && Number(messageData.height) === 0) warn('Unsupported message received (' + messageData.type + '), this is likely due to the iframe containing a later ' + 'version of iframe-resizer than the parent page');
                    else resizeIFrame();
            }
        }
        function hasSettings(iframeId) {
            var retBool = true;
            if (!settings[iframeId]) {
                retBool = false;
                warn(messageData.type + ' No settings for ' + iframeId + '. Message was: ' + msg);
            }
            return retBool;
        }
        function iFrameReadyMsgReceived() {
            // eslint-disable-next-line no-restricted-syntax, guard-for-in
            for(var iframeId in settings)trigger('iFrame requested init', createOutgoingMsg(iframeId), settings[iframeId].iframe, iframeId);
        }
        function firstRun() {
            if (settings[iframeId]) settings[iframeId].firstRun = false;
        }
        var msg = event.data, messageData = {}, iframeId = null;
        if ('[iFrameResizerChild]Ready' === msg) iFrameReadyMsgReceived();
        else if (isMessageForUs()) {
            messageData = processMsg();
            iframeId = messageData.id;
            if (settings[iframeId]) settings[iframeId].loaded = true;
            if (!isMessageFromMetaParent() && hasSettings(iframeId)) {
                log(iframeId, 'Received: ' + msg);
                if (checkIFrameExists() && isMessageFromIFrame()) actionMsg();
            }
        } else info(iframeId, 'Ignored: ' + msg);
    }
    function chkEvent(iframeId, funcName, val) {
        var func = null, retVal = null;
        if (settings[iframeId]) {
            func = settings[iframeId][funcName];
            if ('function' === typeof func) retVal = func(val);
            else throw new TypeError(funcName + ' on iFrame[' + iframeId + '] is not a function');
        }
        return retVal;
    }
    function removeIframeListeners(iframe) {
        var iframeId = iframe.id;
        delete settings[iframeId];
    }
    function closeIFrame(iframe) {
        var iframeId = iframe.id;
        if (chkEvent(iframeId, 'onClose', iframeId) === false) {
            log(iframeId, 'Close iframe cancelled by onClose event');
            return;
        }
        log(iframeId, 'Removing iFrame: ' + iframeId);
        try {
            // Catch race condition error with React
            if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
        } catch (error) {
            warn(error);
        }
        chkEvent(iframeId, 'onClosed', iframeId);
        log(iframeId, '--');
        removeIframeListeners(iframe);
    }
    function getPagePosition(iframeId) {
        if (null === pagePosition) {
            pagePosition = {
                x: window.pageXOffset !== undefined ? window.pageXOffset : document.documentElement.scrollLeft,
                y: window.pageYOffset !== undefined ? window.pageYOffset : document.documentElement.scrollTop
            };
            log(iframeId, 'Get page position: ' + pagePosition.x + ',' + pagePosition.y);
        }
    }
    function setPagePosition(iframeId) {
        if (null !== pagePosition) {
            window.scrollTo(pagePosition.x, pagePosition.y);
            log(iframeId, 'Set page position: ' + pagePosition.x + ',' + pagePosition.y);
            unsetPagePosition();
        }
    }
    function unsetPagePosition() {
        pagePosition = null;
    }
    function resetIFrame(messageData) {
        function reset() {
            setSize(messageData);
            trigger('reset', 'reset', messageData.iframe, messageData.id);
        }
        log(messageData.id, 'Size reset requested by ' + ('init' === messageData.type ? 'host page' : 'iFrame'));
        getPagePosition(messageData.id);
        syncResize(reset, messageData, 'reset');
    }
    function setSize(messageData) {
        function setDimension(dimension) {
            if (!messageData.id) {
                log('undefined', 'messageData id not set');
                return;
            }
            messageData.iframe.style[dimension] = messageData[dimension] + 'px';
            log(messageData.id, 'IFrame (' + iframeId + ') ' + dimension + ' set to ' + messageData[dimension] + 'px');
        }
        function chkZero(dimension) {
            // FireFox sets dimension of hidden iFrames to zero.
            // So if we detect that set up an event to check for
            // when iFrame becomes visible.
            /* istanbul ignore next */ // Not testable in PhantomJS
            if (!hiddenCheckEnabled && '0' === messageData[dimension]) {
                hiddenCheckEnabled = true;
                log(iframeId, 'Hidden iFrame detected, creating visibility listener');
                fixHiddenIFrames();
            }
        }
        function processDimension(dimension) {
            setDimension(dimension);
            chkZero(dimension);
        }
        var iframeId = messageData.iframe.id;
        if (settings[iframeId]) {
            if (settings[iframeId].sizeHeight) processDimension('height');
            if (settings[iframeId].sizeWidth) processDimension('width');
        }
    }
    function syncResize(func, messageData, doNotSync) {
        /* istanbul ignore if */ // Not testable in PhantomJS
        if (doNotSync !== messageData.type && requestAnimationFrame && // including check for jasmine because had trouble getting spy to work in unit test using requestAnimationFrame
        !window.jasmine) {
            log(messageData.id, 'Requesting animation frame');
            requestAnimationFrame(func);
        } else func();
    }
    function trigger(calleeMsg, msg, iframe, id, noResponseWarning) {
        function postMessageToIFrame() {
            var target = settings[id] && settings[id].targetOrigin;
            log(id, '[' + calleeMsg + '] Sending msg to iframe[' + id + '] (' + msg + ') targetOrigin: ' + target);
            iframe.contentWindow.postMessage(msgId + msg, target);
        }
        function iFrameNotFound() {
            warn(id, '[' + calleeMsg + '] IFrame(' + id + ') not found');
        }
        function chkAndSend() {
            if (iframe && 'contentWindow' in iframe && null !== iframe.contentWindow) // Null test for PhantomJS
            postMessageToIFrame();
            else iFrameNotFound();
        }
        function warnOnNoResponse() {
            function warning() {
                if (settings[id] && !settings[id].loaded && !errorShown) {
                    errorShown = true;
                    warn(id, 'IFrame has not responded within ' + settings[id].warningTimeout / 1000 + ' seconds. Check iFrameResizer.contentWindow.js has been loaded in iFrame. This message can be ignored if everything is working, or you can set the warningTimeout option to a higher value or zero to suppress this warning.');
                }
            }
            if (!!noResponseWarning && settings[id] && !!settings[id].warningTimeout) settings[id].msgTimeout = setTimeout(warning, settings[id].warningTimeout);
        }
        var errorShown = false;
        id = id || iframe.id;
        if (settings[id]) {
            chkAndSend();
            warnOnNoResponse();
        }
    }
    function createOutgoingMsg(iframeId) {
        return iframeId + ':' + settings[iframeId].bodyMarginV1 + ':' + settings[iframeId].sizeWidth + ':' + settings[iframeId].log + ':' + settings[iframeId].interval + ':' + settings[iframeId].enablePublicMethods + ':' + settings[iframeId].autoResize + ':' + settings[iframeId].bodyMargin + ':' + settings[iframeId].heightCalculationMethod + ':' + settings[iframeId].bodyBackground + ':' + settings[iframeId].bodyPadding + ':' + settings[iframeId].tolerance + ':' + settings[iframeId].inPageLinks + ':' + settings[iframeId].resizeFrom + ':' + settings[iframeId].widthCalculationMethod + ':' + settings[iframeId].mouseEvents;
    }
    function isNumber(value) {
        return typeof value === 'number';
    }
    function setupIFrame(iframe, options) {
        function setLimits() {
            function addStyle(style) {
                var styleValue = settings[iframeId][style];
                if (Infinity !== styleValue && 0 !== styleValue) {
                    iframe.style[style] = isNumber(styleValue) ? styleValue + 'px' : styleValue;
                    log(iframeId, 'Set ' + style + ' = ' + iframe.style[style]);
                }
            }
            function chkMinMax(dimension) {
                if (settings[iframeId]['min' + dimension] > settings[iframeId]['max' + dimension]) throw new Error('Value for min' + dimension + ' can not be greater than max' + dimension);
            }
            chkMinMax('Height');
            chkMinMax('Width');
            addStyle('maxHeight');
            addStyle('minHeight');
            addStyle('maxWidth');
            addStyle('minWidth');
        }
        function newId() {
            var id = options && options.id || defaults.id + count++;
            if (null !== document.getElementById(id)) id += count++;
            return id;
        }
        function ensureHasId(iframeId) {
            if ('' === iframeId) {
                // eslint-disable-next-line no-multi-assign
                iframe.id = iframeId = newId();
                logEnabled = (options || {}).log;
                log(iframeId, 'Added missing iframe ID: ' + iframeId + ' (' + iframe.src + ')');
            }
            return iframeId;
        }
        function setScrolling() {
            log(iframeId, 'IFrame scrolling ' + (settings[iframeId] && settings[iframeId].scrolling ? 'enabled' : 'disabled') + ' for ' + iframeId);
            iframe.style.overflow = false === (settings[iframeId] && settings[iframeId].scrolling) ? 'hidden' : 'auto';
            switch(settings[iframeId] && settings[iframeId].scrolling){
                case 'omit':
                    break;
                case true:
                    iframe.scrolling = 'yes';
                    break;
                case false:
                    iframe.scrolling = 'no';
                    break;
                default:
                    iframe.scrolling = settings[iframeId] ? settings[iframeId].scrolling : 'no';
            }
        }
        // The V1 iFrame script expects an int, where as in V2 expects a CSS
        // string value such as '1px 3em', so if we have an int for V2, set V1=V2
        // and then convert V2 to a string PX value.
        function setupBodyMarginValues() {
            if ('number' === typeof (settings[iframeId] && settings[iframeId].bodyMargin) || '0' === (settings[iframeId] && settings[iframeId].bodyMargin)) {
                settings[iframeId].bodyMarginV1 = settings[iframeId].bodyMargin;
                settings[iframeId].bodyMargin = '' + settings[iframeId].bodyMargin + 'px';
            }
        }
        function checkReset() {
            // Reduce scope of firstRun to function, because IE8's JS execution
            // context stack is borked and this value gets externally
            // changed midway through running this function!!!
            var firstRun = settings[iframeId] && settings[iframeId].firstRun, resetRequertMethod = settings[iframeId] && settings[iframeId].heightCalculationMethod in resetRequiredMethods;
            if (!firstRun && resetRequertMethod) resetIFrame({
                iframe: iframe,
                height: 0,
                width: 0,
                type: 'init'
            });
        }
        function setupIFrameObject() {
            if (settings[iframeId]) settings[iframeId].iframe.iFrameResizer = {
                close: closeIFrame.bind(null, settings[iframeId].iframe),
                removeListeners: removeIframeListeners.bind(null, settings[iframeId].iframe),
                resize: trigger.bind(null, 'Window resize', 'resize', settings[iframeId].iframe),
                moveToAnchor: function(anchor) {
                    trigger('Move to anchor', 'moveToAnchor:' + anchor, settings[iframeId].iframe, iframeId);
                },
                sendMessage: function(message) {
                    message = JSON.stringify(message);
                    trigger('Send Message', 'message:' + message, settings[iframeId].iframe, iframeId);
                }
            };
        }
        // We have to call trigger twice, as we can not be sure if all
        // iframes have completed loading when this code runs. The
        // event listener also catches the page changing in the iFrame.
        function init(msg) {
            function iFrameLoaded() {
                trigger('iFrame.onload', msg, iframe, undefined, true);
                checkReset();
            }
            function createDestroyObserver(MutationObserver) {
                if (!iframe.parentNode) return;
                var destroyObserver = new MutationObserver(function(mutations) {
                    mutations.forEach(function(mutation) {
                        var removedNodes = Array.prototype.slice.call(mutation.removedNodes) // Transform NodeList into an Array
                        ;
                        removedNodes.forEach(function(removedNode) {
                            if (removedNode === iframe) closeIFrame(iframe);
                        });
                    });
                });
                destroyObserver.observe(iframe.parentNode, {
                    childList: true
                });
            }
            var MutationObserver = getMutationObserver();
            if (MutationObserver) createDestroyObserver(MutationObserver);
            addEventListener(iframe, 'load', iFrameLoaded);
            trigger('init', msg, iframe, undefined, true);
        }
        function checkOptions(options) {
            if ('object' !== typeof options) throw new TypeError('Options is not an object');
        }
        function copyOptions(options) {
            // eslint-disable-next-line no-restricted-syntax
            for(var option in defaults)if (Object.prototype.hasOwnProperty.call(defaults, option)) settings[iframeId][option] = Object.prototype.hasOwnProperty.call(options, option) ? options[option] : defaults[option];
        }
        function getTargetOrigin(remoteHost) {
            return '' === remoteHost || null !== remoteHost.match(/^(about:blank|javascript:|file:\/\/)/) ? '*' : remoteHost;
        }
        function depricate(key) {
            var splitName = key.split('Callback');
            if (splitName.length === 2) {
                var name = 'on' + splitName[0].charAt(0).toUpperCase() + splitName[0].slice(1);
                this[name] = this[key];
                delete this[key];
                warn(iframeId, "Deprecated: '" + key + "' has been renamed '" + name + "'. The old method will be removed in the next major version.");
            }
        }
        function processOptions(options) {
            options = options || {};
            settings[iframeId] = {
                firstRun: true,
                iframe: iframe,
                remoteHost: iframe.src && iframe.src.split('/').slice(0, 3).join('/')
            };
            checkOptions(options);
            Object.keys(options).forEach(depricate, options);
            copyOptions(options);
            if (settings[iframeId]) settings[iframeId].targetOrigin = true === settings[iframeId].checkOrigin ? getTargetOrigin(settings[iframeId].remoteHost) : '*';
        }
        function beenHere() {
            return iframeId in settings && 'iFrameResizer' in iframe;
        }
        var iframeId = ensureHasId(iframe.id);
        if (!beenHere()) {
            processOptions(options);
            setScrolling();
            setLimits();
            setupBodyMarginValues();
            init(createOutgoingMsg(iframeId));
            setupIFrameObject();
        } else warn(iframeId, 'Ignored iFrame, already setup.');
    }
    function debouce(fn, time) {
        if (null === timer) timer = setTimeout(function() {
            timer = null;
            fn();
        }, time);
    }
    var frameTimer = {};
    function debounceFrameEvents(fn, time, frameId) {
        if (!frameTimer[frameId]) frameTimer[frameId] = setTimeout(function() {
            frameTimer[frameId] = null;
            fn();
        }, time);
    }
    // Not testable in PhantomJS
    /* istanbul ignore next */ function fixHiddenIFrames() {
        function checkIFrames() {
            function checkIFrame(settingId) {
                function chkDimension(dimension) {
                    return '0px' === (settings[settingId] && settings[settingId].iframe.style[dimension]);
                }
                function isVisible(el) {
                    return null !== el.offsetParent;
                }
                if (settings[settingId] && isVisible(settings[settingId].iframe) && (chkDimension('height') || chkDimension('width'))) trigger('Visibility change', 'resize', settings[settingId].iframe, settingId);
            }
            Object.keys(settings).forEach(function(key) {
                checkIFrame(key);
            });
        }
        function mutationObserved(mutations) {
            log('window', 'Mutation observed: ' + mutations[0].target + ' ' + mutations[0].type);
            debouce(checkIFrames, 16);
        }
        function createMutationObserver() {
            var target = document.querySelector('body'), config = {
                attributes: true,
                attributeOldValue: false,
                characterData: true,
                characterDataOldValue: false,
                childList: true,
                subtree: true
            }, observer = new MutationObserver(mutationObserved);
            observer.observe(target, config);
        }
        var MutationObserver = getMutationObserver();
        if (MutationObserver) createMutationObserver();
    }
    function resizeIFrames(event) {
        function resize() {
            sendTriggerMsg('Window ' + event, 'resize');
        }
        log('window', 'Trigger event: ' + event);
        debouce(resize, 16);
    }
    // Not testable in PhantomJS
    /* istanbul ignore next */ function tabVisible() {
        function resize() {
            sendTriggerMsg('Tab Visable', 'resize');
        }
        if ('hidden' !== document.visibilityState) {
            log('document', 'Trigger event: Visiblity change');
            debouce(resize, 16);
        }
    }
    function sendTriggerMsg(eventName, event) {
        function isIFrameResizeEnabled(iframeId) {
            return settings[iframeId] && 'parent' === settings[iframeId].resizeFrom && settings[iframeId].autoResize && !settings[iframeId].firstRun;
        }
        Object.keys(settings).forEach(function(iframeId) {
            if (isIFrameResizeEnabled(iframeId)) trigger(eventName, event, settings[iframeId].iframe, iframeId);
        });
    }
    function setupEventListeners() {
        addEventListener(window, 'message', iFrameListener);
        addEventListener(window, 'resize', function() {
            resizeIFrames('resize');
        });
        addEventListener(document, 'visibilitychange', tabVisible);
        addEventListener(document, '-webkit-visibilitychange', tabVisible);
    }
    function factory() {
        function init(options, element) {
            function chkType() {
                if (!element.tagName) throw new TypeError('Object is not a valid DOM element');
                else if ('IFRAME' !== element.tagName.toUpperCase()) throw new TypeError('Expected <IFRAME> tag, found <' + element.tagName + '>');
            }
            if (element) {
                chkType();
                setupIFrame(element, options);
                iFrames.push(element);
            }
        }
        function warnDeprecatedOptions(options) {
            if (options && options.enablePublicMethods) warn('enablePublicMethods option has been removed, public methods are now always available in the iFrame');
        }
        var iFrames;
        setupRequestAnimationFrame();
        setupEventListeners();
        return function iFrameResizeF(options, target) {
            iFrames = [] // Only return iFrames past in on this call
            ;
            warnDeprecatedOptions(options);
            switch(typeof target){
                case 'undefined':
                case 'string':
                    Array.prototype.forEach.call(document.querySelectorAll(target || 'iframe'), init.bind(undefined, options));
                    break;
                case 'object':
                    init(options, target);
                    break;
                default:
                    throw new TypeError('Unexpected data type (' + typeof target + ')');
            }
            return iFrames;
        };
    }
    function createJQueryPublicMethod($) {
        if (!$.fn) info('', 'Unable to bind to jQuery, it is not fully loaded.');
        else if (!$.fn.iFrameResize) $.fn.iFrameResize = function $iFrameResizeF(options) {
            function init(index, element) {
                setupIFrame(element, options);
            }
            return this.filter('iframe').each(init).end();
        };
    }
    if (window.jQuery) createJQueryPublicMethod(window.jQuery);
    if (typeof define === 'function' && define.amd) define([], factory);
    else if (typeof module.exports === 'object') // Node for browserfy
    module.exports = factory();
    window.iFrameResize = window.iFrameResize || factory();
})();

});

parcelRegister("3e4Gk", function(module, exports) {
/*
 * File: iframeResizer.contentWindow.js
 * Desc: Include this file in any page being loaded into an iframe
 *       to force the iframe to resize to the content size.
 * Requires: iframeResizer.js on host page.
 * Doc: https://github.com/davidjbradshaw/iframe-resizer
 * Author: David J. Bradshaw - dave@bradshaw.net
 *
 */ // eslint-disable-next-line sonarjs/cognitive-complexity, no-shadow-restricted-names
(function(undefined) {
    if (typeof window === 'undefined') return; // don't run for server side render
    var autoResize = true, base = 10, bodyBackground = '', bodyMargin = 0, bodyMarginStr = '', bodyObserver = null, bodyPadding = '', calculateWidth = false, doubleEventList = {
        resize: 1,
        click: 1
    }, eventCancelTimer = 128, firstRun = true, height = 1, heightCalcModeDefault = 'bodyOffset', heightCalcMode = heightCalcModeDefault, initLock = true, initMsg = '', inPageLinks = {}, interval = 32, intervalTimer = null, logging = false, mouseEvents = false, msgID = '[iFrameSizer]', msgIdLen = msgID.length, myID = '', resetRequiredMethods = {
        max: 1,
        min: 1,
        bodyScroll: 1,
        documentElementScroll: 1
    }, resizeFrom = 'child', sendPermit = true, target = window.parent, targetOriginDefault = '*', tolerance = 0, triggerLocked = false, triggerLockedTimer = null, throttledTimer = 16, width = 1, widthCalcModeDefault = 'scroll', widthCalcMode = widthCalcModeDefault, win = window, onMessage = function() {
        warn('onMessage function not defined');
    }, onReady = function() {}, onPageInfo = function() {}, customCalcMethods = {
        height: function() {
            warn('Custom height calculation function not defined');
            return document.documentElement.offsetHeight;
        },
        width: function() {
            warn('Custom width calculation function not defined');
            return document.body.scrollWidth;
        }
    }, eventHandlersByName = {}, passiveSupported = false;
    function noop() {}
    try {
        var options = Object.create({}, {
            passive: {
                get: function() {
                    passiveSupported = true;
                }
            }
        });
        window.addEventListener('test', noop, options);
        window.removeEventListener('test', noop, options);
    } catch (error) {
    /* */ }
    function addEventListener(el, evt, func, options) {
        el.addEventListener(evt, func, passiveSupported ? options || {} : false);
    }
    function removeEventListener(el, evt, func) {
        el.removeEventListener(evt, func, false);
    }
    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    // Based on underscore.js
    function throttle(func) {
        var context, args, result, timeout = null, previous = 0, later = function() {
            previous = Date.now();
            timeout = null;
            result = func.apply(context, args);
            if (!timeout) // eslint-disable-next-line no-multi-assign
            context = args = null;
        };
        return function() {
            var now = Date.now();
            if (!previous) previous = now;
            var remaining = throttledTimer - (now - previous);
            context = this;
            args = arguments;
            if (remaining <= 0 || remaining > throttledTimer) {
                if (timeout) {
                    clearTimeout(timeout);
                    timeout = null;
                }
                previous = now;
                result = func.apply(context, args);
                if (!timeout) // eslint-disable-next-line no-multi-assign
                context = args = null;
            } else if (!timeout) timeout = setTimeout(later, remaining);
            return result;
        };
    }
    function formatLogMsg(msg) {
        return msgID + '[' + myID + '] ' + msg;
    }
    function log(msg) {
        if (logging && 'object' === typeof window.console) // eslint-disable-next-line no-console
        console.log(formatLogMsg(msg));
    }
    function warn(msg) {
        if ('object' === typeof window.console) // eslint-disable-next-line no-console
        console.warn(formatLogMsg(msg));
    }
    function init() {
        readDataFromParent();
        log('Initialising iFrame (' + window.location.href + ')');
        readDataFromPage();
        setMargin();
        setBodyStyle('background', bodyBackground);
        setBodyStyle('padding', bodyPadding);
        injectClearFixIntoBodyElement();
        checkHeightMode();
        checkWidthMode();
        stopInfiniteResizingOfIFrame();
        setupPublicMethods();
        setupMouseEvents();
        startEventListeners();
        inPageLinks = setupInPageLinks();
        sendSize('init', 'Init message from host page');
        onReady();
    }
    function readDataFromParent() {
        function strBool(str) {
            return 'true' === str;
        }
        var data = initMsg.substr(msgIdLen).split(':');
        myID = data[0];
        bodyMargin = undefined !== data[1] ? Number(data[1]) : bodyMargin // For V1 compatibility
        ;
        calculateWidth = undefined !== data[2] ? strBool(data[2]) : calculateWidth;
        logging = undefined !== data[3] ? strBool(data[3]) : logging;
        interval = undefined !== data[4] ? Number(data[4]) : interval;
        autoResize = undefined !== data[6] ? strBool(data[6]) : autoResize;
        bodyMarginStr = data[7];
        heightCalcMode = undefined !== data[8] ? data[8] : heightCalcMode;
        bodyBackground = data[9];
        bodyPadding = data[10];
        tolerance = undefined !== data[11] ? Number(data[11]) : tolerance;
        inPageLinks.enable = undefined !== data[12] ? strBool(data[12]) : false;
        resizeFrom = undefined !== data[13] ? data[13] : resizeFrom;
        widthCalcMode = undefined !== data[14] ? data[14] : widthCalcMode;
        mouseEvents = undefined !== data[15] ? Boolean(data[15]) : mouseEvents;
    }
    function depricate(key) {
        var splitName = key.split('Callback');
        if (splitName.length === 2) {
            var name = 'on' + splitName[0].charAt(0).toUpperCase() + splitName[0].slice(1);
            this[name] = this[key];
            delete this[key];
            warn("Deprecated: '" + key + "' has been renamed '" + name + "'. The old method will be removed in the next major version.");
        }
    }
    function readDataFromPage() {
        function readData() {
            var data = window.iFrameResizer;
            log('Reading data from page: ' + JSON.stringify(data));
            Object.keys(data).forEach(depricate, data);
            onMessage = 'onMessage' in data ? data.onMessage : onMessage;
            onReady = 'onReady' in data ? data.onReady : onReady;
            targetOriginDefault = 'targetOrigin' in data ? data.targetOrigin : targetOriginDefault;
            heightCalcMode = 'heightCalculationMethod' in data ? data.heightCalculationMethod : heightCalcMode;
            widthCalcMode = 'widthCalculationMethod' in data ? data.widthCalculationMethod : widthCalcMode;
        }
        function setupCustomCalcMethods(calcMode, calcFunc) {
            if ('function' === typeof calcMode) {
                log('Setup custom ' + calcFunc + 'CalcMethod');
                customCalcMethods[calcFunc] = calcMode;
                calcMode = 'custom';
            }
            return calcMode;
        }
        if ('iFrameResizer' in window && Object === window.iFrameResizer.constructor) {
            readData();
            heightCalcMode = setupCustomCalcMethods(heightCalcMode, 'height');
            widthCalcMode = setupCustomCalcMethods(widthCalcMode, 'width');
        }
        log('TargetOrigin for parent set to: ' + targetOriginDefault);
    }
    function chkCSS(attr, value) {
        if (-1 !== value.indexOf('-')) {
            warn('Negative CSS value ignored for ' + attr);
            value = '';
        }
        return value;
    }
    function setBodyStyle(attr, value) {
        if (undefined !== value && '' !== value && 'null' !== value) {
            document.body.style[attr] = value;
            log('Body ' + attr + ' set to "' + value + '"');
        }
    }
    function setMargin() {
        // If called via V1 script, convert bodyMargin from int to str
        if (undefined === bodyMarginStr) bodyMarginStr = bodyMargin + 'px';
        setBodyStyle('margin', chkCSS('margin', bodyMarginStr));
    }
    function stopInfiniteResizingOfIFrame() {
        document.documentElement.style.height = '';
        document.body.style.height = '';
        log('HTML & body height set to "auto"');
    }
    function manageTriggerEvent(options) {
        var listener = {
            add: function(eventName) {
                function handleEvent() {
                    sendSize(options.eventName, options.eventType);
                }
                eventHandlersByName[eventName] = handleEvent;
                addEventListener(window, eventName, handleEvent, {
                    passive: true
                });
            },
            remove: function(eventName) {
                var handleEvent = eventHandlersByName[eventName];
                delete eventHandlersByName[eventName];
                removeEventListener(window, eventName, handleEvent);
            }
        };
        if (options.eventNames && Array.prototype.map) {
            options.eventName = options.eventNames[0];
            options.eventNames.map(listener[options.method]);
        } else listener[options.method](options.eventName);
        log(capitalizeFirstLetter(options.method) + ' event listener: ' + options.eventType);
    }
    function manageEventListeners(method) {
        manageTriggerEvent({
            method: method,
            eventType: 'Animation Start',
            eventNames: [
                'animationstart',
                'webkitAnimationStart'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Animation Iteration',
            eventNames: [
                'animationiteration',
                'webkitAnimationIteration'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Animation End',
            eventNames: [
                'animationend',
                'webkitAnimationEnd'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Input',
            eventName: 'input'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Mouse Up',
            eventName: 'mouseup'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Mouse Down',
            eventName: 'mousedown'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Orientation Change',
            eventName: 'orientationchange'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Print',
            eventName: [
                'afterprint',
                'beforeprint'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Ready State Change',
            eventName: 'readystatechange'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Touch Start',
            eventName: 'touchstart'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Touch End',
            eventName: 'touchend'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Touch Cancel',
            eventName: 'touchcancel'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Transition Start',
            eventNames: [
                'transitionstart',
                'webkitTransitionStart',
                'MSTransitionStart',
                'oTransitionStart',
                'otransitionstart'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Transition Iteration',
            eventNames: [
                'transitioniteration',
                'webkitTransitionIteration',
                'MSTransitionIteration',
                'oTransitionIteration',
                'otransitioniteration'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Transition End',
            eventNames: [
                'transitionend',
                'webkitTransitionEnd',
                'MSTransitionEnd',
                'oTransitionEnd',
                'otransitionend'
            ]
        });
        if ('child' === resizeFrom) manageTriggerEvent({
            method: method,
            eventType: 'IFrame Resized',
            eventName: 'resize'
        });
    }
    function checkCalcMode(calcMode, calcModeDefault, modes, type) {
        if (calcModeDefault !== calcMode) {
            if (!(calcMode in modes)) {
                warn(calcMode + ' is not a valid option for ' + type + 'CalculationMethod.');
                calcMode = calcModeDefault;
            }
            log(type + ' calculation method set to "' + calcMode + '"');
        }
        return calcMode;
    }
    function checkHeightMode() {
        heightCalcMode = checkCalcMode(heightCalcMode, heightCalcModeDefault, getHeight, 'height');
    }
    function checkWidthMode() {
        widthCalcMode = checkCalcMode(widthCalcMode, widthCalcModeDefault, getWidth, 'width');
    }
    function startEventListeners() {
        if (true === autoResize) {
            manageEventListeners('add');
            setupMutationObserver();
        } else log('Auto Resize disabled');
    }
    //   function stopMsgsToParent() {
    //     log('Disable outgoing messages')
    //     sendPermit = false
    //   }
    //   function removeMsgListener() {
    //     log('Remove event listener: Message')
    //     removeEventListener(window, 'message', receiver)
    //   }
    function disconnectMutationObserver() {
        if (null !== bodyObserver) /* istanbul ignore next */ // Not testable in PhantonJS
        bodyObserver.disconnect();
    }
    function stopEventListeners() {
        manageEventListeners('remove');
        disconnectMutationObserver();
        clearInterval(intervalTimer);
    }
    //   function teardown() {
    //     stopMsgsToParent()
    //     removeMsgListener()
    //     if (true === autoResize) stopEventListeners()
    //   }
    function injectClearFixIntoBodyElement() {
        var clearFix = document.createElement('div');
        clearFix.style.clear = 'both';
        // Guard against the following having been globally redefined in CSS.
        clearFix.style.display = 'block';
        clearFix.style.height = '0';
        document.body.appendChild(clearFix);
    }
    function setupInPageLinks() {
        function getPagePosition() {
            return {
                x: window.pageXOffset !== undefined ? window.pageXOffset : document.documentElement.scrollLeft,
                y: window.pageYOffset !== undefined ? window.pageYOffset : document.documentElement.scrollTop
            };
        }
        function getElementPosition(el) {
            var elPosition = el.getBoundingClientRect(), pagePosition = getPagePosition();
            return {
                x: parseInt(elPosition.left, 10) + parseInt(pagePosition.x, 10),
                y: parseInt(elPosition.top, 10) + parseInt(pagePosition.y, 10)
            };
        }
        function findTarget(location) {
            function jumpToTarget(target) {
                var jumpPosition = getElementPosition(target);
                log('Moving to in page link (#' + hash + ') at x: ' + jumpPosition.x + ' y: ' + jumpPosition.y);
                sendMsg(jumpPosition.y, jumpPosition.x, 'scrollToOffset') // X&Y reversed at sendMsg uses height/width
                ;
            }
            var hash = location.split('#')[1] || location, hashData = decodeURIComponent(hash), target = document.getElementById(hashData) || document.getElementsByName(hashData)[0];
            if (undefined !== target) jumpToTarget(target);
            else {
                log('In page link (#' + hash + ') not found in iFrame, so sending to parent');
                sendMsg(0, 0, 'inPageLink', '#' + hash);
            }
        }
        function checkLocationHash() {
            var hash = window.location.hash;
            var href = window.location.href;
            if ('' !== hash && '#' !== hash) findTarget(href);
        }
        function bindAnchors() {
            function setupLink(el) {
                function linkClicked(e) {
                    e.preventDefault();
                    /* jshint validthis:true */ findTarget(this.getAttribute('href'));
                }
                if ('#' !== el.getAttribute('href')) addEventListener(el, 'click', linkClicked);
            }
            Array.prototype.forEach.call(document.querySelectorAll('a[href^="#"]'), setupLink);
        }
        function bindLocationHash() {
            addEventListener(window, 'hashchange', checkLocationHash);
        }
        function initCheck() {
            // Check if page loaded with location hash after init resize
            setTimeout(checkLocationHash, eventCancelTimer);
        }
        function enableInPageLinks() {
            /* istanbul ignore else */ // Not testable in phantonJS
            if (Array.prototype.forEach && document.querySelectorAll) {
                log('Setting up location.hash handlers');
                bindAnchors();
                bindLocationHash();
                initCheck();
            } else warn('In page linking not fully supported in this browser! (See README.md for IE8 workaround)');
        }
        if (inPageLinks.enable) enableInPageLinks();
        else log('In page linking not enabled');
        return {
            findTarget: findTarget
        };
    }
    function setupMouseEvents() {
        if (mouseEvents !== true) return;
        function sendMouse(e) {
            sendMsg(0, 0, e.type, e.screenY + ':' + e.screenX);
        }
        function addMouseListener(evt, name) {
            log('Add event listener: ' + name);
            addEventListener(window.document, evt, sendMouse);
        }
        addMouseListener('mouseenter', 'Mouse Enter');
        addMouseListener('mouseleave', 'Mouse Leave');
    }
    function setupPublicMethods() {
        log('Enable public methods');
        win.parentIFrame = {
            autoResize: function autoResizeF(resize) {
                if (true === resize && false === autoResize) {
                    autoResize = true;
                    startEventListeners();
                } else if (false === resize && true === autoResize) {
                    autoResize = false;
                    stopEventListeners();
                }
                sendMsg(0, 0, 'autoResize', JSON.stringify(autoResize));
                return autoResize;
            },
            close: function closeF() {
                sendMsg(0, 0, 'close');
            // teardown()
            },
            getId: function getIdF() {
                return myID;
            },
            getPageInfo: function getPageInfoF(callback) {
                if ('function' === typeof callback) {
                    onPageInfo = callback;
                    sendMsg(0, 0, 'pageInfo');
                } else {
                    onPageInfo = function() {};
                    sendMsg(0, 0, 'pageInfoStop');
                }
            },
            moveToAnchor: function moveToAnchorF(hash) {
                inPageLinks.findTarget(hash);
            },
            reset: function resetF() {
                resetIFrame('parentIFrame.reset');
            },
            scrollTo: function scrollToF(x, y) {
                sendMsg(y, x, 'scrollTo') // X&Y reversed at sendMsg uses height/width
                ;
            },
            scrollToOffset: function scrollToF(x, y) {
                sendMsg(y, x, 'scrollToOffset') // X&Y reversed at sendMsg uses height/width
                ;
            },
            sendMessage: function sendMessageF(msg, targetOrigin) {
                sendMsg(0, 0, 'message', JSON.stringify(msg), targetOrigin);
            },
            setHeightCalculationMethod: function setHeightCalculationMethodF(heightCalculationMethod) {
                heightCalcMode = heightCalculationMethod;
                checkHeightMode();
            },
            setWidthCalculationMethod: function setWidthCalculationMethodF(widthCalculationMethod) {
                widthCalcMode = widthCalculationMethod;
                checkWidthMode();
            },
            setTargetOrigin: function setTargetOriginF(targetOrigin) {
                log('Set targetOrigin: ' + targetOrigin);
                targetOriginDefault = targetOrigin;
            },
            size: function sizeF(customHeight, customWidth) {
                var valString = '' + (customHeight || '') + (customWidth ? ',' + customWidth : '');
                sendSize('size', 'parentIFrame.size(' + valString + ')', customHeight, customWidth);
            }
        };
    }
    function initInterval() {
        if (0 !== interval) {
            log('setInterval: ' + interval + 'ms');
            intervalTimer = setInterval(function() {
                sendSize('interval', 'setInterval: ' + interval);
            }, Math.abs(interval));
        }
    }
    // Not testable in PhantomJS
    /* istanbul ignore next */ function setupBodyMutationObserver() {
        function addImageLoadListners(mutation) {
            function addImageLoadListener(element) {
                if (false === element.complete) {
                    log('Attach listeners to ' + element.src);
                    element.addEventListener('load', imageLoaded, false);
                    element.addEventListener('error', imageError, false);
                    elements.push(element);
                }
            }
            if (mutation.type === 'attributes' && mutation.attributeName === 'src') addImageLoadListener(mutation.target);
            else if (mutation.type === 'childList') Array.prototype.forEach.call(mutation.target.querySelectorAll('img'), addImageLoadListener);
        }
        function removeFromArray(element) {
            elements.splice(elements.indexOf(element), 1);
        }
        function removeImageLoadListener(element) {
            log('Remove listeners from ' + element.src);
            element.removeEventListener('load', imageLoaded, false);
            element.removeEventListener('error', imageError, false);
            removeFromArray(element);
        }
        function imageEventTriggered(event, type, typeDesc) {
            removeImageLoadListener(event.target);
            sendSize(type, typeDesc + ': ' + event.target.src);
        }
        function imageLoaded(event) {
            imageEventTriggered(event, 'imageLoad', 'Image loaded');
        }
        function imageError(event) {
            imageEventTriggered(event, 'imageLoadFailed', 'Image load failed');
        }
        function mutationObserved(mutations) {
            sendSize('mutationObserver', 'mutationObserver: ' + mutations[0].target + ' ' + mutations[0].type);
            // Deal with WebKit / Blink asyncing image loading when tags are injected into the page
            mutations.forEach(addImageLoadListners);
        }
        function createMutationObserver() {
            var target = document.querySelector('body'), config = {
                attributes: true,
                attributeOldValue: false,
                characterData: true,
                characterDataOldValue: false,
                childList: true,
                subtree: true
            };
            observer = new MutationObserver(mutationObserved);
            log('Create body MutationObserver');
            observer.observe(target, config);
            return observer;
        }
        var elements = [], MutationObserver = window.MutationObserver || window.WebKitMutationObserver, observer = createMutationObserver();
        return {
            disconnect: function() {
                if ('disconnect' in observer) {
                    log('Disconnect body MutationObserver');
                    observer.disconnect();
                    elements.forEach(removeImageLoadListener);
                }
            }
        };
    }
    function setupMutationObserver() {
        var forceIntervalTimer = 0 > interval;
        // Not testable in PhantomJS
        /* istanbul ignore if */ if (window.MutationObserver || window.WebKitMutationObserver) {
            if (forceIntervalTimer) initInterval();
            else bodyObserver = setupBodyMutationObserver();
        } else {
            log('MutationObserver not supported in this browser!');
            initInterval();
        }
    }
    // document.documentElement.offsetHeight is not reliable, so
    // we have to jump through hoops to get a better value.
    function getComputedStyle(prop, el) {
        var retVal = 0;
        el = el || document.body // Not testable in phantonJS
        ;
        retVal = document.defaultView.getComputedStyle(el, null);
        retVal = null !== retVal ? retVal[prop] : 0;
        return parseInt(retVal, base);
    }
    function chkEventThottle(timer) {
        if (timer > throttledTimer / 2) {
            throttledTimer = 2 * timer;
            log('Event throttle increased to ' + throttledTimer + 'ms');
        }
    }
    // Idea from https://github.com/guardian/iframe-messenger
    function getMaxElement(side, elements) {
        var elementsLength = elements.length, elVal = 0, maxVal = 0, Side = capitalizeFirstLetter(side), timer = Date.now();
        for(var i = 0; i < elementsLength; i++){
            elVal = elements[i].getBoundingClientRect()[side] + getComputedStyle('margin' + Side, elements[i]);
            if (elVal > maxVal) maxVal = elVal;
        }
        timer = Date.now() - timer;
        log('Parsed ' + elementsLength + ' HTML elements');
        log('Element position calculated in ' + timer + 'ms');
        chkEventThottle(timer);
        return maxVal;
    }
    function getAllMeasurements(dimensions) {
        return [
            dimensions.bodyOffset(),
            dimensions.bodyScroll(),
            dimensions.documentElementOffset(),
            dimensions.documentElementScroll()
        ];
    }
    function getTaggedElements(side, tag) {
        function noTaggedElementsFound() {
            warn('No tagged elements (' + tag + ') found on page');
            return document.querySelectorAll('body *');
        }
        var elements = document.querySelectorAll('[' + tag + ']');
        if (elements.length === 0) noTaggedElementsFound();
        return getMaxElement(side, elements);
    }
    function getAllElements() {
        return document.querySelectorAll('body *');
    }
    var getHeight = {
        bodyOffset: function getBodyOffsetHeight() {
            return document.body.offsetHeight + getComputedStyle('marginTop') + getComputedStyle('marginBottom');
        },
        offset: function() {
            return getHeight.bodyOffset() // Backwards compatability
            ;
        },
        bodyScroll: function getBodyScrollHeight() {
            return document.body.scrollHeight;
        },
        custom: function getCustomWidth() {
            return customCalcMethods.height();
        },
        documentElementOffset: function getDEOffsetHeight() {
            return document.documentElement.offsetHeight;
        },
        documentElementScroll: function getDEScrollHeight() {
            return document.documentElement.scrollHeight;
        },
        max: function getMaxHeight() {
            return Math.max.apply(null, getAllMeasurements(getHeight));
        },
        min: function getMinHeight() {
            return Math.min.apply(null, getAllMeasurements(getHeight));
        },
        grow: function growHeight() {
            return getHeight.max() // Run max without the forced downsizing
            ;
        },
        lowestElement: function getBestHeight() {
            return Math.max(getHeight.bodyOffset() || getHeight.documentElementOffset(), getMaxElement('bottom', getAllElements()));
        },
        taggedElement: function getTaggedElementsHeight() {
            return getTaggedElements('bottom', 'data-iframe-height');
        }
    }, getWidth = {
        bodyScroll: function getBodyScrollWidth() {
            return document.body.scrollWidth;
        },
        bodyOffset: function getBodyOffsetWidth() {
            return document.body.offsetWidth;
        },
        custom: function getCustomWidth() {
            return customCalcMethods.width();
        },
        documentElementScroll: function getDEScrollWidth() {
            return document.documentElement.scrollWidth;
        },
        documentElementOffset: function getDEOffsetWidth() {
            return document.documentElement.offsetWidth;
        },
        scroll: function getMaxWidth() {
            return Math.max(getWidth.bodyScroll(), getWidth.documentElementScroll());
        },
        max: function getMaxWidth() {
            return Math.max.apply(null, getAllMeasurements(getWidth));
        },
        min: function getMinWidth() {
            return Math.min.apply(null, getAllMeasurements(getWidth));
        },
        rightMostElement: function rightMostElement() {
            return getMaxElement('right', getAllElements());
        },
        taggedElement: function getTaggedElementsWidth() {
            return getTaggedElements('right', 'data-iframe-width');
        }
    };
    function sizeIFrame(triggerEvent, triggerEventDesc, customHeight, customWidth) {
        function resizeIFrame() {
            height = currentHeight;
            width = currentWidth;
            sendMsg(height, width, triggerEvent);
        }
        function isSizeChangeDetected() {
            function checkTolarance(a, b) {
                var retVal = Math.abs(a - b) <= tolerance;
                return !retVal;
            }
            currentHeight = undefined !== customHeight ? customHeight : getHeight[heightCalcMode]();
            currentWidth = undefined !== customWidth ? customWidth : getWidth[widthCalcMode]();
            return checkTolarance(height, currentHeight) || calculateWidth && checkTolarance(width, currentWidth);
        }
        function isForceResizableEvent() {
            return !(triggerEvent in {
                init: 1,
                interval: 1,
                size: 1
            });
        }
        function isForceResizableCalcMode() {
            return heightCalcMode in resetRequiredMethods || calculateWidth && widthCalcMode in resetRequiredMethods;
        }
        function logIgnored() {
            log('No change in size detected');
        }
        function checkDownSizing() {
            if (isForceResizableEvent() && isForceResizableCalcMode()) resetIFrame(triggerEventDesc);
            else if (!(triggerEvent in {
                interval: 1
            })) logIgnored();
        }
        var currentHeight, currentWidth;
        if (isSizeChangeDetected() || 'init' === triggerEvent) {
            lockTrigger();
            resizeIFrame();
        } else checkDownSizing();
    }
    var sizeIFrameThrottled = throttle(sizeIFrame);
    function sendSize(triggerEvent, triggerEventDesc, customHeight, customWidth) {
        function recordTrigger() {
            if (!(triggerEvent in {
                reset: 1,
                resetPage: 1,
                init: 1
            })) log('Trigger event: ' + triggerEventDesc);
        }
        function isDoubleFiredEvent() {
            return triggerLocked && triggerEvent in doubleEventList;
        }
        if (!isDoubleFiredEvent()) {
            recordTrigger();
            if (triggerEvent === 'init') sizeIFrame(triggerEvent, triggerEventDesc, customHeight, customWidth);
            else sizeIFrameThrottled(triggerEvent, triggerEventDesc, customHeight, customWidth);
        } else log('Trigger event cancelled: ' + triggerEvent);
    }
    function lockTrigger() {
        if (!triggerLocked) {
            triggerLocked = true;
            log('Trigger event lock on');
        }
        clearTimeout(triggerLockedTimer);
        triggerLockedTimer = setTimeout(function() {
            triggerLocked = false;
            log('Trigger event lock off');
            log('--');
        }, eventCancelTimer);
    }
    function triggerReset(triggerEvent) {
        height = getHeight[heightCalcMode]();
        width = getWidth[widthCalcMode]();
        sendMsg(height, width, triggerEvent);
    }
    function resetIFrame(triggerEventDesc) {
        var hcm = heightCalcMode;
        heightCalcMode = heightCalcModeDefault;
        log('Reset trigger event: ' + triggerEventDesc);
        lockTrigger();
        triggerReset('reset');
        heightCalcMode = hcm;
    }
    function sendMsg(height, width, triggerEvent, msg, targetOrigin) {
        function setTargetOrigin() {
            if (undefined === targetOrigin) targetOrigin = targetOriginDefault;
            else log('Message targetOrigin: ' + targetOrigin);
        }
        function sendToParent() {
            var size = height + ':' + width, message = myID + ':' + size + ':' + triggerEvent + (undefined !== msg ? ':' + msg : '');
            log('Sending message to host page (' + message + ')');
            target.postMessage(msgID + message, targetOrigin);
        }
        if (true === sendPermit) {
            setTargetOrigin();
            sendToParent();
        }
    }
    function receiver(event) {
        var processRequestFromParent = {
            init: function initFromParent() {
                initMsg = event.data;
                target = event.source;
                init();
                firstRun = false;
                setTimeout(function() {
                    initLock = false;
                }, eventCancelTimer);
            },
            reset: function resetFromParent() {
                if (!initLock) {
                    log('Page size reset by host page');
                    triggerReset('resetPage');
                } else log('Page reset ignored by init');
            },
            resize: function resizeFromParent() {
                sendSize('resizeParent', 'Parent window requested size check');
            },
            moveToAnchor: function moveToAnchorF() {
                inPageLinks.findTarget(getData());
            },
            inPageLink: function inPageLinkF() {
                this.moveToAnchor();
            },
            pageInfo: function pageInfoFromParent() {
                var msgBody = getData();
                log('PageInfoFromParent called from parent: ' + msgBody);
                onPageInfo(JSON.parse(msgBody));
                log(' --');
            },
            message: function messageFromParent() {
                var msgBody = getData();
                log('onMessage called from parent: ' + msgBody);
                // eslint-disable-next-line sonarjs/no-extra-arguments
                onMessage(JSON.parse(msgBody));
                log(' --');
            }
        };
        function isMessageForUs() {
            return msgID === ('' + event.data).substr(0, msgIdLen) // ''+ Protects against non-string messages
            ;
        }
        function getMessageType() {
            return event.data.split(']')[1].split(':')[0];
        }
        function getData() {
            return event.data.substr(event.data.indexOf(':') + 1);
        }
        function isMiddleTier() {
            return !(0, module.exports) && 'iFrameResize' in window || 'jQuery' in window && 'iFrameResize' in window.jQuery.prototype;
        }
        function isInitMsg() {
            // Test if this message is from a child below us. This is an ugly test, however, updating
            // the message format would break backwards compatibity.
            return event.data.split(':')[2] in {
                true: 1,
                false: 1
            };
        }
        function callFromParent() {
            var messageType = getMessageType();
            if (messageType in processRequestFromParent) processRequestFromParent[messageType]();
            else if (!isMiddleTier() && !isInitMsg()) warn('Unexpected message (' + event.data + ')');
        }
        function processMessage() {
            if (false === firstRun) callFromParent();
            else if (isInitMsg()) processRequestFromParent.init();
            else log('Ignored message of type "' + getMessageType() + '". Received before initialization.');
        }
        if (isMessageForUs()) processMessage();
    }
    // Normally the parent kicks things off when it detects the iFrame has loaded.
    // If this script is async-loaded, then tell parent page to retry init.
    function chkLateLoaded() {
        if ('loading' !== document.readyState) window.parent.postMessage('[iFrameResizerChild]Ready', '*');
    }
    addEventListener(window, 'message', receiver);
    addEventListener(window, 'readystatechange', chkLateLoaded);
    chkLateLoaded();
})();

});



parcelRegister("aVjJN", function(module, exports) {
$parcel$export(module.exports, "withMetricsAndAnalytics", () => $53e8d32f7d2ea218$export$68a362b9cb2811d7);


var $6SUez = parcelRequire("6SUez");

var $f3yFH = parcelRequire("f3yFH");

var $k896E = parcelRequire("k896E");

var $dHXR3 = parcelRequire("dHXR3");

var $cOZrT = parcelRequire("cOZrT");

var $eGOwo = parcelRequire("eGOwo");

var $lmoym = parcelRequire("lmoym");
const $53e8d32f7d2ea218$var$prepareBridgeEventAttributes = (bridgeMethod, payload, isSucceed)=>{
    if (bridgeMethod === 'submit' && isSucceed) {
        const payloadFields = Array.from(Object.entries(payload?.data ?? {})).filter(([, value])=>value).map(([key])=>key);
        return {
            payloadFields: payloadFields
        };
    }
    if ((0, $eGOwo.fg)('forge-ui-navigation')) {
        if (bridgeMethod === 'navigate') {
            const { target: target, url: url, type: type } = payload?.data ?? {};
            const navigationContext = {
                target: 'trusted',
                type: type
            };
            if (url && typeof url === 'string') try {
                if ([
                    'https:',
                    'http:'
                ].includes(new URL(url).protocol)) navigationContext.target = 'external';
            } catch (e) {}
            else if (target && typeof target === 'string') navigationContext.target = target;
            return navigationContext;
        }
    }
    if ((0, $eGOwo.fg)('platform_forge_ui_open_rovo_bridge')) {
        if (bridgeMethod === 'openRovo' && isSucceed) {
            const { agentName: agentName, agentKey: agentKey, agentAppId: agentAppId } = payload?.data ?? {};
            const agentDetails = {
                agentName: agentName,
                agentKey: agentKey,
                agentAppId: agentAppId,
                isForgeAgent: false
            };
            if (agentName && agentKey && agentAppId) agentDetails.isForgeAgent = true;
            return agentDetails;
        }
    }
    return {};
};
const $53e8d32f7d2ea218$var$wrapFeatureWithMetricsAndAnalytics = ({ feature: feature, createAnalyticsEvent: createAnalyticsEvent, page: page, bridgeMethod: bridgeMethod, environment: environment, forgeEnvironment: forgeEnvironment, errorExtensionDetails: errorExtensionDetails, tracing: tracing })=>async (payload)=>{
        try {
            tracing?.recordBridgeCall(`${bridgeMethod}() - start`);
            const result = await feature(payload);
            tracing?.recordBridgeCall(`${bridgeMethod}() - end`);
            if (bridgeMethod === 'on') createAnalyticsEvent({
                eventType: (0, $d6f34b7bd34f6138$export$12346a674644c156),
                data: {
                    action: 'subscribed',
                    actionSubject: 'bridgeEvent',
                    attributes: {
                        // TODO: remove the condition (and related test) once Developer UGC spec is ready
                        event: payload.data.event === 'JIRA_ISSUE_CHANGED' ? 'JIRA_ISSUE_CHANGED' : 'other'
                    },
                    source: page,
                    tags: [
                        'forge'
                    ]
                }
            }).fire((0, $dHXR3.FORGE_UI_ANALYTICS_CHANNEL));
            // this replaces the BRIDGE_REQUEST_RECEIVED metal client event
            (0, $cOZrT.trackBridgeSucceed)(createAnalyticsEvent, {
                source: page,
                method: bridgeMethod,
                forgeEnvironment: forgeEnvironment,
                additionalAttributes: $53e8d32f7d2ea218$var$prepareBridgeEventAttributes(bridgeMethod, payload, true)
            });
            return result;
        } catch (err) {
            const error = err instanceof Error ? err : new Error(`Unknown Custom UI Bridge error: ${typeof err}`);
            if (!(error instanceof (0, $f3yFH.BridgeClientError))) {
                if (!(0, $k896E.blocklistedErrorMessagePatterns).some((pattern)=>pattern.test(error.message))) {
                    (0, $cOZrT.trackBridgeFailed)(createAnalyticsEvent, {
                        source: page,
                        errorName: error.name,
                        method: bridgeMethod,
                        forgeEnvironment: forgeEnvironment,
                        additionalAttributes: {
                            ...$53e8d32f7d2ea218$var$prepareBridgeEventAttributes(bridgeMethod, payload, false),
                            reason: error.message,
                            isUnrecoverable: (0, $lmoym.isUnrecoverableError)(error)
                        }
                    });
                    (0, $6SUez.captureAndReportError)({
                        error: error,
                        environment: environment,
                        errorExtensionDetails: errorExtensionDetails,
                        page: page,
                        tracing: tracing
                    });
                }
            }
            throw err;
        }
    };
const $53e8d32f7d2ea218$export$68a362b9cb2811d7 = ({ features: features, createAnalyticsEvent: createAnalyticsEvent, page: page, environment: environment, forgeEnvironment: forgeEnvironment, errorExtensionDetails: errorExtensionDetails, tracing: tracing })=>Object.entries(features).reduce((acc, [key, feature])=>({
            ...acc,
            [key]: $53e8d32f7d2ea218$var$wrapFeatureWithMetricsAndAnalytics({
                feature: feature,
                createAnalyticsEvent: createAnalyticsEvent,
                page: page,
                bridgeMethod: key,
                environment: environment,
                forgeEnvironment: forgeEnvironment,
                errorExtensionDetails: errorExtensionDetails,
                tracing: tracing
            })
        }), {});

});
parcelRegister("6SUez", function(module, exports) {
$parcel$export(module.exports, "captureAndReportError", () => $76144191afe6ce8a$export$faf06bc0661c564c);

var $lopBx = parcelRequire("lopBx");

var $ezmKu = parcelRequire("ezmKu");

var $kKhkW = parcelRequire("kKhkW");
const $76144191afe6ce8a$var$packageVersion = "0.0.0-use.local";
const $76144191afe6ce8a$export$bb9823fd3fb51f9c = 'https://1210cfc4338849588134f2c80b99f75c@o55978.ingest.sentry.io/5988824';
const $76144191afe6ce8a$export$b7f7efe8cd791eed = 'https://a377d38318350e08236b26b7b13c8016@sentry.atlassian-us-gov-mod.com/23';

const $76144191afe6ce8a$export$faf06bc0661c564c = async ({ error: error, environment: environment, errorExtensionDetails: errorExtensionDetails, page: page, errorInfo: errorInfo, tracing: tracing })=>{
    try {
        const module = await (parcelRequire("6RujE"));
        const { BrowserClient: BrowserClient, Hub: Hub } = module;
        // From https://sentry.io/settings/atlassian-2y/projects/forge-ui/keys/ and https://sentry.prod.services.kitt-inf-us-gov-mod.net/settings/sentry/projects/forge-ui/keys
        const dsn = (0, $lopBx.isFedRamp)() ? $76144191afe6ce8a$export$b7f7efe8cd791eed : $76144191afe6ce8a$export$bb9823fd3fb51f9c;
        const client = new BrowserClient({
            environment: environment,
            dsn: dsn,
            release: `forge-ui@${$76144191afe6ce8a$var$packageVersion}`
        });
        const hub = new Hub(client);
        hub.withScope(async (scope)=>{
            if (tracing) {
                const breadcrumbs = tracing.getBreadcrumbs();
                breadcrumbs.forEach((bc)=>scope.addBreadcrumb(bc, 20));
            }
            if (errorInfo) scope.setExtra('componentTrace', {
                errorInfo: errorInfo,
                componentStack: errorInfo?.componentStack?.substring(0, 1000)
            });
            scope.setTag('extensionPoint', page);
            if (errorExtensionDetails) {
                scope.setExtra('extensionProperties', errorExtensionDetails.properties);
                try {
                    const appIdFromId = (0, $ezmKu.parseExtensionId)(errorExtensionDetails.id ?? '').appId;
                    if (appIdFromId) scope.setTag('appId', appIdFromId);
                } catch (e) {
                // parseExtensionId() uses parse() form @atlassian/cs-ari, which throws an error if the ID is not valid
                }
                if (errorExtensionDetails.environmentType) scope.setTag('forgeEnvironment', errorExtensionDetails.environmentType);
                if (errorExtensionDetails.type) scope.setTag('extensionType', errorExtensionDetails.type);
                if (errorExtensionDetails.appOwnerAccountId) scope.setTag('appOwner', errorExtensionDetails.appOwnerAccountId);
            }
            hub.captureException(error);
        });
        return client.close();
    } catch (e) {
    // Error reporting failed, we don't want to cause a unhandledrejection event
    }
};

});
parcelRegister("6RujE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jtFCT").then(()=>parcelRequire('gIc6Q'));

});


parcelRegister("k896E", function(module, exports) {
$parcel$export(module.exports, "blocklistedErrorMessagePatterns", () => $3358de2a7a16d455$export$5458688a52e32026);
const $3358de2a7a16d455$export$5458688a52e32026 = [
    // Error in user code
    /^There was an error invoking the function/,
    // User code returned non-JSON value, so XIS threw an InvalidInvocationPayloadError.
    /^Invalid response body, data must be JSON or undefined$/,
    // Networking errors
    /^Failed to fetch$/,
    /^Network error: Failed to fetch$/,
    /^Network error: Network failure: TypeError: Failed to fetch$/,
    /^NetworkError when attempting to fetch resource.$/,
    /^Network error: Received status 504$/,
    /^GraphQL error: The underlying service call timed out$/,
    // Unauthenticated requests made from public confluence content
    /^GraphQL error: Auth category: UNAUTHENTICATED is not allowed in service xen_invocation_service$/
];

});

parcelRegister("lmoym", function(module, exports) {
$parcel$export(module.exports, "isUnrecoverableError", () => $04205e5916dcd6c3$export$fab3177d2bcbd98a);
const $04205e5916dcd6c3$var$messages = [
    'Window closed for',
    'Window did not load after'
];
const $04205e5916dcd6c3$export$fab3177d2bcbd98a = (error)=>error instanceof Error && $04205e5916dcd6c3$var$messages.some((message)=>error.message.startsWith(message));

});


parcelRegister("hmwFh", function(module, exports) {
$parcel$export(module.exports, "reload", () => $58137924cc255845$export$32da5b5043dcd88c);
function $58137924cc255845$export$32da5b5043dcd88c() {
    window.location.reload();
}

});

parcelRegister("aGi2o", function(module, exports) {
$parcel$export(module.exports, "FeatureFlagEnv", () => $6e413c4749f50a24$export$d0163c7b07301739);
$parcel$export(module.exports, "FeatureFlagEventTypes", () => $6e413c4749f50a24$export$35879154c49e2b67);
var $6e413c4749f50a24$export$d0163c7b07301739 = /*#__PURE__*/ function(FeatureFlagEnv) {
    FeatureFlagEnv["development"] = "development";
    FeatureFlagEnv["staging"] = "staging";
    FeatureFlagEnv["production"] = "production";
    return FeatureFlagEnv;
}({});
var $6e413c4749f50a24$export$35879154c49e2b67 = /*#__PURE__*/ function(FeatureFlagEventTypes) {
    FeatureFlagEventTypes["INITIALIZATION"] = "initialization";
    FeatureFlagEventTypes["CHECKFLAG"] = "checkFlag";
    return FeatureFlagEventTypes;
}({});

});

parcelRegister("1H69i", function(module, exports) {
$parcel$export(module.exports, "on", () => $de6a7ce3e03775c1$export$af631764ddc44097);
$parcel$export(module.exports, "emit", () => $de6a7ce3e03775c1$export$8f35fbd5db0f3634);
// This prefix is also used in ConfigPanelFieldsLoader.tsx in the
// @atlaskit/editor-plugin-extension package. The Editor package is public, so it
// cannot import this constant from @atlassian/forge-ui. Do not update this prefix
// without also doing so in the Editor package.
const $de6a7ce3e03775c1$var$EVENT_PREFIX = 'forge.bridge.';
function $de6a7ce3e03775c1$export$af631764ddc44097(event, callback, extension) {
    const wrappedCallback = (e)=>{
        if (!extension || !e.detail?.extension || extension.id === e.detail?.extension?.id && extension.installationId === e.detail?.extension?.installationId) callback(e.detail?.payload, e.detail?.extension);
    };
    window.document.addEventListener(`${$de6a7ce3e03775c1$var$EVENT_PREFIX}${event}`, wrappedCallback);
    return {
        unsubscribe: ()=>window.document.removeEventListener(`${$de6a7ce3e03775c1$var$EVENT_PREFIX}${event}`, wrappedCallback)
    };
}
function $de6a7ce3e03775c1$export$8f35fbd5db0f3634(event, payload, extension) {
    const newEvent = new CustomEvent(`${$de6a7ce3e03775c1$var$EVENT_PREFIX}${event}`, {
        detail: {
            extension: extension,
            payload: payload
        }
    });
    window.document.dispatchEvent(newEvent);
}

});

parcelRegister("cGlYw", function(module, exports) {
$parcel$export(module.exports, "createNavigateTargetPath", () => $055bb789d359b1dc$export$6aa8556afece32b2);

var $eIlba = parcelRequire("eIlba");

var $i7TgZ = parcelRequire("i7TgZ");

var $aD2uU = parcelRequire("aD2uU");

var $kJ8rV = parcelRequire("kJ8rV");
const $055bb789d359b1dc$var$extensionURLHelpers = {
    ...(0, $eIlba.confluenceExtensionURLHelpers),
    ...(0, $aD2uU.jiraExtensionURLHelpers)
};
const $055bb789d359b1dc$var$navigationTargetHandlers = {
    ...(0, $aD2uU.jiraNavigationTargetHandlers),
    ...(0, $eIlba.confluenceNavigationTargetURLHelpers),
    userProfile: async ({ accountId: accountId })=>(0, $kJ8rV.ensureURLPath)(`/people/${accountId}`),
    module: async ({ moduleKey: moduleKey, ...params }, { getAppForgeUIExtensions: getAppForgeUIExtensions })=>{
        if (!moduleKey) throw (0, $i7TgZ.NavigationError).MissingProperty('moduleKey');
        const module = await (0, $i7TgZ.getModuleByKey)(getAppForgeUIExtensions, moduleKey);
        if (!module || !module.appId || !module.environmentId) throw (0, $i7TgZ.NavigationError).ModuleNotFound(moduleKey);
        const moduleUrlHelper = $055bb789d359b1dc$var$extensionURLHelpers[module.type];
        if (!moduleUrlHelper) throw (0, $i7TgZ.NavigationError).NotSupportedExtensionType(module.type);
        return moduleUrlHelper(module, params);
    }
};
const $055bb789d359b1dc$export$6aa8556afece32b2 = async (targetInfo, utils)=>{
    const { target: target, ...payload } = targetInfo;
    const handler = $055bb789d359b1dc$var$navigationTargetHandlers[target];
    if (!handler) return null;
    try {
        const path = await handler(payload, utils);
        return path;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e.message);
        return null;
    }
};

});
parcelRegister("eIlba", function(module, exports) {
$parcel$export(module.exports, "confluenceExtensionURLHelpers", () => $a26f1e5673eda483$export$68f051c1b56c060f);
$parcel$export(module.exports, "confluenceNavigationTargetURLHelpers", () => $a26f1e5673eda483$export$f91bdc214ca5389d);
parcelRequire("1B59H");
var $aJjD9 = parcelRequire("aJjD9");

var $kJ8rV = parcelRequire("kJ8rV");

var $i7TgZ = parcelRequire("i7TgZ");
const $a26f1e5673eda483$var$makeConfluenceURLPath = (0, $kJ8rV.createMakeProductURLPath)('/wiki');
const $a26f1e5673eda483$var$isCustomContentType = (contentType)=>contentType.startsWith('forge:');
const $a26f1e5673eda483$export$68f051c1b56c060f = {
    [(0, $aJjD9.ConfluenceExtension).GLOBAL_PAGE]: ({ properties: properties, environmentId: environmentId, appId: appId })=>{
        const { route: route } = properties;
        if (appId && environmentId && route) return $a26f1e5673eda483$var$makeConfluenceURLPath(`/apps/${appId}/${environmentId}/${route}`);
        return null;
    },
    [(0, $aJjD9.ConfluenceExtension).GLOBAL_SETTINGS]: ({ id: id })=>$a26f1e5673eda483$var$makeConfluenceURLPath('/admin/forge', {
            id: id
        }),
    [(0, $aJjD9.ConfluenceExtension).SPACE_PAGE]: ({ properties: properties, environmentId: environmentId, appId: appId }, { spaceKey: spaceKey })=>{
        const { route: route } = properties;
        if (route && environmentId && appId) return $a26f1e5673eda483$var$makeConfluenceURLPath(`/spaces/${(0, $i7TgZ.ensurePropertyExists)('spaceKey', spaceKey)}/apps/${appId}/${environmentId}/${route}`);
        return null;
    },
    [(0, $aJjD9.ConfluenceExtension).SPACE_SETTINGS]: ({ properties: properties, appId: appId, environmentId: environmentId }, { spaceKey: spaceKey })=>{
        const { route: route } = properties;
        if (!spaceKey) throw (0, $i7TgZ.NavigationError).MissingProperty('spaceKey');
        if (route && environmentId && appId) return $a26f1e5673eda483$var$makeConfluenceURLPath(`/spaces/${(0, $i7TgZ.ensurePropertyExists)('spaceKey', spaceKey)}/settings/apps/${appId}/${environmentId}/${route}`);
        return null;
    }
};
const $a26f1e5673eda483$export$f91bdc214ca5389d = {
    contentView: async ({ contentId: contentId, version: version })=>{
        if (!contentId) throw (0, $i7TgZ.NavigationError).MissingProperty('contentId');
        let resp = null;
        try {
            resp = await fetch(`/wiki/rest/api/content/${contentId}`);
        } catch (e) {
            throw (0, $i7TgZ.NavigationError).FailedToFetchContentInfo(contentId);
        }
        const { id: id, type: type, _links: { webui: webui } } = await resp.json();
        // if version is provided, we should use it, however, it only works for none-custom content type
        if (version && version >= 0) {
            if ($a26f1e5673eda483$var$isCustomContentType(type)) throw new Error('Version is not supported for custom content type');
            return $a26f1e5673eda483$var$makeConfluenceURLPath('/pages/viewpage.action', {
                pageId: id,
                pageVersion: `${version}`
            });
        } else if (webui) return $a26f1e5673eda483$var$makeConfluenceURLPath(webui);
        throw (0, $i7TgZ.NavigationError).LinkForContentNotFound(contentId);
    },
    contentEdit: async ({ contentId: contentId })=>{
        let resp;
        try {
            resp = await fetch(`/wiki/rest/api/content/${contentId}`);
        } catch (e) {
            throw (0, $i7TgZ.NavigationError).FailedToFetchContentInfo(contentId);
        }
        const { _links: { edituiv2: edituiv2 } } = await resp.json();
        // content with custom content type doesn't have edit link
        if (edituiv2) return $a26f1e5673eda483$var$makeConfluenceURLPath(edituiv2);
        throw (0, $i7TgZ.NavigationError).LinkForContentNotFound(contentId);
    },
    spaceView: async ({ spaceKey: spaceKey })=>{
        return $a26f1e5673eda483$var$makeConfluenceURLPath(`/spaces/${(0, $i7TgZ.ensurePropertyExists)('spaceKey', spaceKey)}`);
    },
    contentList: async (params, { getAppForgeUIExtensions: getAppForgeUIExtensions })=>{
        const { contentType: contentType } = params;
        if (!contentType) throw (0, $i7TgZ.NavigationError).MissingProperty('contentType');
        if (contentType === 'customContent' && params.moduleKey) {
            const { moduleKey: moduleKey } = params;
            const module = await (0, $i7TgZ.getModuleByKey)(getAppForgeUIExtensions, moduleKey);
            if (!module) throw (0, $i7TgZ.NavigationError).ModuleNotFound(moduleKey);
            const { appId: appId, environmentId: environmentId } = module;
            if (appId && environmentId) return $a26f1e5673eda483$var$makeConfluenceURLPath('/search', {
                type: `forge:${appId}:${environmentId}:${moduleKey}`
            });
        } else if (contentType === 'page' && params.spaceKey) return $a26f1e5673eda483$var$makeConfluenceURLPath(`/spaces/${params.spaceKey}/pages`);
        else if (contentType === 'blogpost' && params.spaceKey) return $a26f1e5673eda483$var$makeConfluenceURLPath(`/spaces/${params.spaceKey}/blogs`);
        throw (0, $i7TgZ.NavigationError).InvalidValueForProperty('contentType', contentType);
    }
};

});
parcelRegister("kJ8rV", function(module, exports) {
$parcel$export(module.exports, "ensureURLPath", () => $55c4d88a2c9a0c89$export$26e2379e0018d084);
$parcel$export(module.exports, "createMakeProductURLPath", () => $55c4d88a2c9a0c89$export$ab31bc7dd6e328ce);
// Ensures that the path structured correctly and adds provided parameters to the path
const $55c4d88a2c9a0c89$export$26e2379e0018d084 = (path, parameters)=>{
    let encodedPath = (path ?? '').split('/').map(encodeURIComponent).join('/');
    if (parameters && Object.keys(parameters).length > 0) encodedPath += '?' + new URLSearchParams(parameters).toString();
    return encodedPath;
};
const $55c4d88a2c9a0c89$export$ab31bc7dd6e328ce = (productPathPrefix)=>(path, parameters)=>{
        return $55c4d88a2c9a0c89$export$26e2379e0018d084(path ? productPathPrefix + path : productPathPrefix, parameters);
    };

});

parcelRegister("i7TgZ", function(module, exports) {
$parcel$export(module.exports, "getModuleByKey", () => $73c8fc65cabb01f3$export$c1f2bec49c0b084d);
$parcel$export(module.exports, "NavigationError", () => $73c8fc65cabb01f3$export$c53ed1333d39ada3);
$parcel$export(module.exports, "ensurePropertyExists", () => $73c8fc65cabb01f3$export$ae701e18d3b38cae);
const $73c8fc65cabb01f3$export$c1f2bec49c0b084d = async (getAppForgeUIExtensions, moduleKey)=>{
    const { extensions: extensions } = await getAppForgeUIExtensions({
        expandAppOwner: false
    });
    const module = extensions?.find(({ key: key })=>key === moduleKey);
    return module?.type ? module : null;
};
const $73c8fc65cabb01f3$export$c53ed1333d39ada3 = {
    ModuleNotFound: (moduleKey)=>{
        return new Error(`Navigation failed: Module with moduleKey ${moduleKey} was not found`);
    },
    MissingProperty: (property)=>{
        return new Error(`Navigation failed: ${property} not provided`);
    },
    FailedToFetchContentInfo: (contentId)=>{
        return new Error(`Navigation failed: Failed to fetch content information with id ${contentId}. Please check if the ID provided is correct`);
    },
    NotSupportedExtensionType: (moduleType)=>{
        return new Error(`Navigation failed: Module type ${moduleType} is not supported`);
    },
    InvalidValueForProperty: (property, value)=>{
        return new Error(`Navigation failed: ${value} is not a valid value for ${property}`);
    },
    LinkForContentNotFound: (contentId)=>{
        return new Error(`Navigation failed: Link for content with id ${contentId} was not found`);
    }
};
const $73c8fc65cabb01f3$export$ae701e18d3b38cae = (propertyName, propertyValue)=>{
    if (propertyValue === undefined || propertyValue === null) throw $73c8fc65cabb01f3$export$c53ed1333d39ada3.MissingProperty(propertyName);
    return propertyValue;
};

});


parcelRegister("aD2uU", function(module, exports) {
$parcel$export(module.exports, "jiraExtensionURLHelpers", () => $6e3405fa054394bd$export$47842863b73e9046);
$parcel$export(module.exports, "jiraNavigationTargetHandlers", () => $6e3405fa054394bd$export$ca7043166c283e6d);
parcelRequire("1B59H");
var $aJjD9 = parcelRequire("aJjD9");

var $kJ8rV = parcelRequire("kJ8rV");

var $i7TgZ = parcelRequire("i7TgZ");

var $eGOwo = parcelRequire("eGOwo");
const $6e3405fa054394bd$var$makeJiraURLPath = (0, $kJ8rV.createMakeProductURLPath)('/jira');
const $6e3405fa054394bd$export$47842863b73e9046 = {
    [(0, $aJjD9.JiraExtension).ADMIN_PAGE]: ({ appId: appId, environmentId: environmentId, properties: properties })=>{
        if ((0, $eGOwo.fg)('forge-ui-fix-jira-admin-page-url')) {
            const { useAsGetStarted: useAsGetStarted, useAsConfig: useAsConfig } = properties;
            if (useAsGetStarted) return $6e3405fa054394bd$var$makeJiraURLPath(`/settings/apps/get-started/${appId}/${environmentId}`);
            if (useAsConfig) return $6e3405fa054394bd$var$makeJiraURLPath(`/settings/apps/configure/${appId}/${environmentId}`);
            return $6e3405fa054394bd$var$makeJiraURLPath(`/settings/apps/${appId}/${environmentId}`);
        } else return $6e3405fa054394bd$var$makeJiraURLPath(`/settings/apps/${appId}/${environmentId}`);
    },
    [(0, $aJjD9.JiraExtension).GLOBAL_PAGE]: ({ appId: appId, environmentId: environmentId })=>{
        return $6e3405fa054394bd$var$makeJiraURLPath(`/apps/${appId}/${environmentId}`);
    },
    [(0, $aJjD9.JiraExtension).PERSONAL_SETTINGS_PAGE]: ({ appId: appId, environmentId: environmentId })=>{
        return $6e3405fa054394bd$var$makeJiraURLPath(`/settings/personal/apps/${appId}/${environmentId}`);
    },
    [(0, $aJjD9.JiraExtension).PROJECT_SETTINGS_PAGE]: ({ appId: appId, environmentId: environmentId }, { projectKey: projectKey })=>{
        return $6e3405fa054394bd$var$makeJiraURLPath(`/software/projects/${(0, $i7TgZ.ensurePropertyExists)('projectKey', projectKey).toUpperCase()}/settings/apps/${appId}/${environmentId}`);
    },
    [(0, $aJjD9.JiraExtension).PROJECT_PAGE]: ({ appId: appId, environmentId: environmentId }, { projectKey: projectKey })=>{
        return $6e3405fa054394bd$var$makeJiraURLPath(`/software/projects/${(0, $i7TgZ.ensurePropertyExists)('projectKey', projectKey).toUpperCase()}/apps/${appId}/${environmentId}`);
    }
};
const $6e3405fa054394bd$export$ca7043166c283e6d = {
    dashboard: async ({ dashboardId: dashboardId })=>{
        return $6e3405fa054394bd$var$makeJiraURLPath(`/dashboards/${(0, $i7TgZ.ensurePropertyExists)('dashboardId', dashboardId)}`);
    },
    issue: async ({ issueKey: issueKey })=>{
        return `/browse/${(0, $i7TgZ.ensurePropertyExists)('issueKey', issueKey)}`;
    },
    // equivalent to Connects projectAdminSummary target
    projectSettingsDetails: async ({ projectKey: projectKey })=>{
        return $6e3405fa054394bd$var$makeJiraURLPath(`/software/projects/${(0, $i7TgZ.ensurePropertyExists)('projectKey', projectKey).toUpperCase()}/settings/details`);
    }
};

});


parcelRegister("cOLOr", function(module, exports) {
$parcel$export(module.exports, "isCustomUI", () => $be3b52e7cc63bbf3$export$4c5241daa4566af8);
const $be3b52e7cc63bbf3$export$4c5241daa4566af8 = (extension, entryPoint)=>{
    const { render: render, resource: resource } = extension.properties;
    if (entryPoint && extension.properties[entryPoint]) {
        const { resource: entryPointResource, render: entryPointRender } = extension.properties[entryPoint];
        return entryPointResource != null && entryPointRender !== 'native';
    }
    return resource != null && render !== 'native';
};

});

parcelRegister("6k0E4", function(module, exports) {
$parcel$export(module.exports, "useGetAppForgeUIExtensions", () => $0810cf7d3f4f8458$export$10dcd63d9a8843c4);

var $eJOHy = parcelRequire("eJOHy");

var $1K21P = parcelRequire("1K21P");

var $jxvNC = parcelRequire("jxvNC");

var $cSmYj = parcelRequire("cSmYj");

var $eGOwo = parcelRequire("eGOwo");
const $0810cf7d3f4f8458$var$useCustomCompareMemo = (factory, dependency, isEqual)=>{
    const dependencyRef = (0, $eJOHy.useRef)(dependency);
    const valueRef = (0, $eJOHy.useRef)(factory());
    if (!isEqual(dependency, dependencyRef.current)) {
        dependencyRef.current = dependency;
        valueRef.current = factory();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $eJOHy.useMemo)(()=>valueRef.current, [
        dependencyRef.current
    ]);
};
const $0810cf7d3f4f8458$var$isSameDeps = (a, b)=>{
    if (a === b) return true;
    if (!a || !b) return false;
    const [clientA, appIdA, environmentIdA, contextIdsA] = a;
    const [clientB, appIdB, environmentIdB, contextIdsB] = b;
    return clientA === clientB && appIdA === appIdB && environmentIdA === environmentIdB && (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(contextIdsA.sort(), contextIdsB.sort());
};
const $0810cf7d3f4f8458$export$eafa2a08bf8a8e04 = ({ client: client, appId: appId, environmentId: environmentId, contextIds: contextIds, cloudId: cloudId, includeHidden: includeHidden, moduleType: moduleType, bypassNewForgeExtensionListCall: bypassNewForgeExtensionListCall })=>{
    return $0810cf7d3f4f8458$var$useCustomCompareMemo(()=>{
        return async (params)=>{
            return await (0, $1K21P.getForgeUIExtensionsAsync)({
                client: client,
                contextIds: contextIds,
                extensionsFilter: [
                    {
                        type: (0, $jxvNC.GQLExtensionContextsFilterType).AppIdEnvironmentId,
                        value: `${appId}:${environmentId}`
                    }
                ],
                ...params,
                cloudId: cloudId,
                includeHidden: includeHidden,
                moduleType: moduleType,
                bypassNewForgeExtensionListCall: bypassNewForgeExtensionListCall
            });
        };
    }, [
        client,
        appId,
        environmentId,
        contextIds
    ], $0810cf7d3f4f8458$var$isSameDeps);
};
const $0810cf7d3f4f8458$export$10dcd63d9a8843c4 = (params)=>{
    const getAppForgeUIExtensions = $0810cf7d3f4f8458$export$eafa2a08bf8a8e04(params);
    return (0, $eGOwo.fg)('forge-ui-navigation') ? getAppForgeUIExtensions : null;
};

});
parcelRegister("1K21P", function(module, exports) {
$parcel$export(module.exports, "getForgeUIExtensionsAsync", () => $66ce02e34aa4fb46$export$f276dc1a7d0b17c5);

var $ci6dd = parcelRequire("ci6dd");
var $iUOof = parcelRequire("iUOof");

var $eGOwo = parcelRequire("eGOwo");

var $jPqNm = parcelRequire("jPqNm");
const $66ce02e34aa4fb46$export$f276dc1a7d0b17c5 = async ({ client: client, contextIds: contextIds, moduleType: moduleType, context: context, queryOptions: queryOptions, expandAppOwner: expandAppOwner, extensionsFilter: extensionsFilter, dataClassificationTagIds: dataClassificationTagIds, locale: locale, cloudId: cloudId, includeHidden: includeHidden, bypassNewForgeExtensionListCall: bypassNewForgeExtensionListCall = false })=>{
    if (bypassNewForgeExtensionListCall === false && (0, $eGOwo.fg)('use_new_forge_extension_list_call')) {
        const types = moduleType ? [
            moduleType
        ] : [];
        const requestOptions = (0, $iUOof.createUsePrefilteredExtensionListQueryOptions)(cloudId ?? contextIds[0], context ?? {}, client, types, locale, includeHidden, queryOptions, contextIds);
        const { fetchPolicy: fetchPolicy, ...rest } = requestOptions;
        const { loading: loading, data: data, errors: errors } = await client.query({
            ...rest,
            query: (0, $jPqNm.FetchPreFilteredForgeAppsQuery),
            fetchPolicy: fetchPolicy === 'cache-and-network' ? 'network-only' : fetchPolicy
        });
        const extensions = (0, $iUOof.getPrefilteredExtensionsGQLResult)({
            loading: loading,
            data: data
        });
        return {
            extensions: extensions,
            errors: errors
        };
    } else {
        const requestOptions = (0, $ci6dd.createExtensionListQueryOptions)(client, contextIds, queryOptions, expandAppOwner, extensionsFilter, moduleType, dataClassificationTagIds, locale);
        const queryResult = await client.query(requestOptions);
        return {
            extensions: (0, $ci6dd.getExtensionsFromGQLResult)(queryResult),
            errors: queryResult.errors
        };
    }
};

});
parcelRegister("ci6dd", function(module, exports) {
$parcel$export(module.exports, "createExtensionListQueryOptions", () => $cbf7406d0b8f414f$export$73c0408abd298d1b);
$parcel$export(module.exports, "getExtensionsFromGQLResult", () => $cbf7406d0b8f414f$export$1e6dc3c07340999);
$parcel$export(module.exports, "useExtensionList", () => $cbf7406d0b8f414f$export$cab421e039d23b2);

var $eJOHy = parcelRequire("eJOHy");

var $1fMqv = parcelRequire("1fMqv");

var $jxvNC = parcelRequire("jxvNC");

var $6yq62 = parcelRequire("6yq62");

var $jPqNm = parcelRequire("jPqNm");

var $ftN6c = parcelRequire("ftN6c");


var $dHXR3 = parcelRequire("dHXR3");

var $cwqPy = parcelRequire("cwqPy");
const $cbf7406d0b8f414f$export$73c0408abd298d1b = (client, contextIds, queryOptions, expandAppOwner, filter, extensionType, dataClassificationTagIds, locale, ssr = false)=>{
    const variables = filter ? {
        contextIds: contextIds,
        locale: locale,
        filter: filter
    } : {
        contextIds: contextIds,
        locale: locale,
        type: extensionType
    };
    const query = filter ? (0, $jPqNm.getExtensionListQuery)(expandAppOwner, dataClassificationTagIds) : (0, $jPqNm.getExtensionListQueryOld)(expandAppOwner, undefined, dataClassificationTagIds);
    // In SSR mode render and fetch is one-pass we can't do cache-and-network
    if (ssr && queryOptions?.fetchPolicy === 'cache-and-network') queryOptions.fetchPolicy = 'cache-first';
    return {
        variables: variables,
        ...queryOptions,
        query: query,
        client: client,
        /**
		 * We don't want to set 'ignore' because that discards errors and we need to inspect
		 * them for SLI reporting. We also need 'all' so we don't discard data on errors:http://go/j/AUX-317
		 * https://www.apollographql.com/docs/react/data/error-handling/
		 */ errorPolicy: 'all',
        context: {
            headers: {
                'atl-attribution': (0, $cwqPy.createAtlAttributionHeader)(contextIds.sort().join())
            }
        }
    };
};
const $cbf7406d0b8f414f$export$1e6dc3c07340999 = ({ loading: loading, data: data })=>{
    if (!loading && data && data.extensionContexts && data.extensionContexts[0]) {
        if ('extensions' in data.extensionContexts[0]) return data.extensionContexts[0].extensions ?? null;
        else if ('extensionsByType' in data.extensionContexts[0]) return data.extensionContexts[0].extensionsByType ?? null;
    }
    return null;
};
const $cbf7406d0b8f414f$export$152846a4183c1a10 = async ({ client: client, contextIds: contextIds, type: extensionType, filter: filter, queryOptions: queryOptions, expandAppOwner: expandAppOwner, dataClassificationTagIds: dataClassificationTagIds, locale: locale, queryFn: queryFn })=>{
    if (!queryFn) return null;
    const requestOptions = $cbf7406d0b8f414f$export$73c0408abd298d1b(client, contextIds, queryOptions, expandAppOwner, filter, extensionType, dataClassificationTagIds, locale, true);
    const query = filter ? (0, $jPqNm.getExtensionListQuery)(expandAppOwner) : (0, $jPqNm.getExtensionListQueryOld)(expandAppOwner);
    requestOptions.query = requestOptions.query || query;
    const { data: data } = await queryFn(requestOptions);
    if (!data) return null;
    return $cbf7406d0b8f414f$export$1e6dc3c07340999({
        loading: false,
        data: data
    });
};
const $cbf7406d0b8f414f$export$cab421e039d23b2 = ({ contextIds: contextIds, type: extensionType, filter: filter, client: client, queryOptions: queryOptions, expandAppOwner: expandAppOwner, dataClassificationTagIds: dataClassificationTagIds, locale: locale })=>{
    const requestOptions = $cbf7406d0b8f414f$export$73c0408abd298d1b(client, contextIds, queryOptions, expandAppOwner, filter, extensionType, dataClassificationTagIds, locale);
    const query = filter ? (0, $jPqNm.getExtensionListQuery)(expandAppOwner) : (0, $jPqNm.getExtensionListQueryOld)(expandAppOwner);
    const { error: error, loading: loading, data: data } = (0, $1fMqv.useQuery)(requestOptions.query || query, requestOptions);
    const extensions = $cbf7406d0b8f414f$export$1e6dc3c07340999({
        loading: loading,
        data: data
    });
    const { page: page } = (0, $6yq62.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        if (extensions) createAnalyticsEvent({
            eventType: (0, $d6f34b7bd34f6138$export$12346a674644c156),
            data: {
                action: 'succeeded',
                actionSubject: 'forge.ui.webClient',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'useExtensionList'
                }
            }
        }).fire((0, $dHXR3.FORGE_UI_ANALYTICS_CHANNEL));
    }, [
        extensions,
        page,
        createAnalyticsEvent
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (// if hydration of appOwners (non-critical data) fails but we still have the extensions,
        // we shouldn't count this as a bad event
        !extensions && error && error.graphQLErrors.length > 0) {
            const err = error.graphQLErrors.find((err)=>(0, $jxvNC.isGQLUnderlyingServiceError)(err) || (0, $jxvNC.isGQLGatewayError)(err));
            createAnalyticsEvent({
                eventType: (0, $d6f34b7bd34f6138$export$12346a674644c156),
                data: {
                    action: 'failed',
                    actionSubject: 'forge.ui.webClient',
                    source: page,
                    tags: [
                        'forge'
                    ],
                    attributes: {
                        target: 'useExtensionList',
                        errorName: err ? (0, $jxvNC.isGQLUnderlyingServiceError)(err) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
                    }
                }
            }).fire((0, $dHXR3.FORGE_UI_ANALYTICS_CHANNEL));
        }
    }, [
        extensions,
        error,
        page,
        createAnalyticsEvent
    ]);
    return {
        error: error,
        extensions: extensions || [],
        loading: loading
    };
};

});
parcelRegister("jxvNC", function(module, exports) {
$parcel$export(module.exports, "GQLExtensionContextsFilterType", () => $a7d67d28b482ea36$export$d76ef0f862d061a6);
$parcel$export(module.exports, "isGQLGatewayError", () => $a7d67d28b482ea36$export$8d1c210bc17223c1);
$parcel$export(module.exports, "isGQLUnderlyingServiceError", () => $a7d67d28b482ea36$export$9c0545f564a8227f);
var $a7d67d28b482ea36$export$d76ef0f862d061a6 = /*#__PURE__*/ function(GQLExtensionContextsFilterType) {
    GQLExtensionContextsFilterType["Container"] = "CONTAINER";
    GQLExtensionContextsFilterType["DataClassificationTag"] = "DATA_CLASSIFICATION_TAG";
    GQLExtensionContextsFilterType["ExtensionType"] = "EXTENSION_TYPE";
    GQLExtensionContextsFilterType["PrincipalType"] = "PRINCIPAL_TYPE";
    GQLExtensionContextsFilterType["AppIdEnvironmentId"] = "APP_ID_ENVIRONMENT_ID";
    return GQLExtensionContextsFilterType;
}({});
const $a7d67d28b482ea36$export$8d1c210bc17223c1 = (err)=>err.extensions && err.extensions.errorSource && err.extensions.errorSource === 'GRAPHQL_GATEWAY';
const $a7d67d28b482ea36$export$9c0545f564a8227f = (err)=>err.extensions && err.extensions.errorSource && err.extensions.errorSource === 'UNDERLYING_SERVICE';

});

parcelRegister("jPqNm", function(module, exports) {
$parcel$export(module.exports, "getExtensionListQueryOld", () => $7c89c6abaca32b84$export$b4649e379af92913);
$parcel$export(module.exports, "getExtensionListQuery", () => $7c89c6abaca32b84$export$23f6ad93bea7724);
$parcel$export(module.exports, "FetchPreFilteredForgeAppsQuery", () => $7c89c6abaca32b84$export$54ff27488d768aba);

var $kuAvn = parcelRequire("kuAvn");

var $eGOwo = parcelRequire("eGOwo");
const $7c89c6abaca32b84$var$convertDataClassificationTagsToString = (dataClassificationTagIds)=>{
    return `[
    ${dataClassificationTagIds.map((id)=>`"${id}"`).join(', ')}
  ]`;
};
const $7c89c6abaca32b84$export$b4649e379af92913 = (expandAppOwner, moduleTypes, dataClassificationTagIds)=>{
    const modules = moduleTypes?.map((m)=>`"${m}"`) || [
        '$type'
    ];
    const userAccessField = (0, $eGOwo.fg)('platform-forge-ui-useraccess-in-extension-query') ? `userAccess {
    enabled
    hasAccess
  }` : '';
    const query = `
  query forge_ui_extensionList($contextIds: [ID!]!${moduleTypes ? '' : ', $type: String!'}, $locale: String) {
    extensionContexts(contextIds: $contextIds) {
      id
      ${modules.map((m)=>`
        extensionsByType(type: ${m}, locale: $locale ) {
          id
          appId
          key
          ${expandAppOwner ? `appOwner {
            name
          }` : ''}
          environmentId
          environmentType
          environmentKey
          properties
          license {
            active
            type
            supportEntitlementNumber
            trialEndDate
            subscriptionEndDate
            isEvaluation
            billingPeriod
            ccpEntitlementId
            ccpEntitlementSlug
						capabilitySet
            modes
          }
          ${userAccessField}
          type
          appVersion
          installationId
          migrationKey
					installationConfig {
						key
						value
					}
          egress {
            type
            addresses
						category
						inScopeEUD
          }
					scopes
					consentUrl
					currentUserConsent {
						user {
							aaid
						}
						appEnvironmentVersion {
							id
						}
						consentedAt
					}
					requiresUserConsent
          ${dataClassificationTagIds && dataClassificationTagIds.length > 0 ? `
                dataClassificationPolicyDecision(input: {
                  dataClassificationTags: ${$7c89c6abaca32b84$var$convertDataClassificationTagsToString(dataClassificationTagIds)}
                }) {
                  status
                }
              ` : ''}
        }`).join('')}
    }
  }`;
    return (0, $kuAvn.default)`
		${query}
	`;
};
const $7c89c6abaca32b84$export$23f6ad93bea7724 = (expandAppOwner, dataClassificationTagIds)=>{
    const userAccessField = (0, $eGOwo.fg)('platform-forge-ui-useraccess-in-extension-query') ? `userAccess {
    enabled
    hasAccess
  }` : '';
    const query = `
  query forge_ui_extensionList($contextIds: [ID!]!, $filter: [ExtensionContextsFilter!]!, $locale: String ) {
    extensionContexts(contextIds: $contextIds) {
      id
      extensions(filter: $filter, locale: $locale) @optIn(to: "Access-Narrowing") {
        id
        appId
        key
        ${expandAppOwner ? `appOwner {
          name
        }` : ''}
        environmentId
        environmentType
        environmentKey
        properties
        license {
          active
          type
          supportEntitlementNumber
          trialEndDate
          subscriptionEndDate
          isEvaluation
          billingPeriod
          ccpEntitlementId
          ccpEntitlementSlug
					capabilitySet
          modes
        }
        ${userAccessField}
        type
        appVersion
        installationId
        migrationKey
				installationConfig {
					key
					value
				}
        egress {
          type
          addresses
					category
					inScopeEUD
        }
				scopes
				consentUrl
				currentUserConsent {
					user {
						aaid
					}
					appEnvironmentVersion {
						id
					}
					consentedAt
				}
				requiresUserConsent
        ${dataClassificationTagIds && dataClassificationTagIds.length > 0 ? `
              dataClassificationPolicyDecision(input: {
                dataClassificationTags: ${$7c89c6abaca32b84$var$convertDataClassificationTagsToString(dataClassificationTagIds)}
              }) {
                status
              }
            ` : ''}
      },
    }
  }`;
    return (0, $kuAvn.default)`
		${query}
	`;
};
const $7c89c6abaca32b84$export$54ff27488d768aba = (0, $kuAvn.default)`
	query FetchPreFilteredForgeAppsQuery(
		$cloudId: ID!
		$context: ConfluenceExtensionRenderingContextInput
		$includeHidden: Boolean
		$locale: String
		$types: [String]
	) {
		confluence_forgeExtensionsByType(
			cloudId: $cloudId
			context: $context
			includeHidden: $includeHidden
			locale: $locale
			types: $types
		) {
			id
			appId
			appVersion
			appOwner
			environmentId
			environmentType
			environmentKey
			consentUrl
			migrationKey
			userAccess {
				enabled
				hasAccess
			}
			key
			properties {
				key
				value
			}
			egress {
				addresses
				category
				type
				inScopeEUD
			}
			scopes
			license {
				active
				capabilitySet
				billingPeriod
				ccpEntitlementId
				ccpEntitlementSlug
				isEvaluation
				subscriptionEndDate
				trialEndDate
				type
			}
			type
			installationId
			hiddenBy
		}
	}
`;

});


parcelRegister("iUOof", function(module, exports) {
$parcel$export(module.exports, "createUsePrefilteredExtensionListQueryOptions", () => $a64280056dd08bb0$export$7f11ec46a05c7477);
$parcel$export(module.exports, "getPrefilteredExtensionsGQLResult", () => $a64280056dd08bb0$export$55348c7eb6377fe1);

var $eJOHy = parcelRequire("eJOHy");

var $1fMqv = parcelRequire("1fMqv");

var $jxvNC = parcelRequire("jxvNC");

var $6yq62 = parcelRequire("6yq62");

var $jPqNm = parcelRequire("jPqNm");

var $ftN6c = parcelRequire("ftN6c");


var $dHXR3 = parcelRequire("dHXR3");

var $cwqPy = parcelRequire("cwqPy");

var $cKELx = parcelRequire("cKELx");
const $a64280056dd08bb0$export$7f11ec46a05c7477 = (cloudId, context, client, types, locale, includeHidden, queryOptions, contextIds = [
    cloudId
])=>{
    const variables = {
        cloudId: cloudId,
        context: context,
        includeHidden: includeHidden ?? false,
        types: types,
        locale: locale
    };
    return {
        variables: variables,
        ...queryOptions,
        client: client,
        /**
		 * We don't want to set 'ignore' because that discards errors and we need to inspect
		 * them for SLI reporting. We also need 'all' so we don't discard data on errors:http://go/j/AUX-317
		 * https://www.apollographql.com/docs/react/data/error-handling/
		 */ errorPolicy: 'all',
        context: {
            headers: {
                'atl-attribution': (0, $cwqPy.createAtlAttributionHeader)(contextIds.sort().join())
            }
        }
    };
};
const $a64280056dd08bb0$export$88e0391b02a3c5c9 = ({ cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types, client: client, queryOptions: queryOptions })=>{
    const requestOptions = $a64280056dd08bb0$export$7f11ec46a05c7477(cloudId, context, client, types, locale, includeHidden, queryOptions);
    const { error: error, loading: loading, data: data } = (0, $1fMqv.useQuery)((0, $jPqNm.FetchPreFilteredForgeAppsQuery), requestOptions);
    const extensions = $a64280056dd08bb0$export$55348c7eb6377fe1({
        loading: loading,
        data: data
    });
    const { page: page } = (0, $6yq62.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        if (extensions) createAnalyticsEvent({
            eventType: (0, $d6f34b7bd34f6138$export$12346a674644c156),
            data: {
                action: 'succeeded',
                actionSubject: 'forge.ui.webClient',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'usePrefilteredExtensionList'
                }
            }
        }).fire((0, $dHXR3.FORGE_UI_ANALYTICS_CHANNEL));
    }, [
        extensions,
        page,
        createAnalyticsEvent
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (// if hydration of appOwners (non-critical data) fails but we still have the extensions,
        // we shouldn't count this as a bad event
        !extensions && error && error.graphQLErrors.length > 0) {
            const err = error.graphQLErrors.find((err)=>(0, $jxvNC.isGQLUnderlyingServiceError)(err) || (0, $jxvNC.isGQLGatewayError)(err));
            createAnalyticsEvent({
                eventType: (0, $d6f34b7bd34f6138$export$12346a674644c156),
                data: {
                    action: 'failed',
                    actionSubject: 'forge.ui.webClient',
                    source: page,
                    tags: [
                        'forge'
                    ],
                    attributes: {
                        target: 'usePrefilteredExtensionList',
                        errorName: err ? (0, $jxvNC.isGQLUnderlyingServiceError)(err) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
                    }
                }
            }).fire((0, $dHXR3.FORGE_UI_ANALYTICS_CHANNEL));
        }
    }, [
        extensions,
        error,
        page,
        createAnalyticsEvent
    ]);
    return {
        error: error,
        extensions: extensions || [],
        loading: loading
    };
};
const $a64280056dd08bb0$export$55348c7eb6377fe1 = ({ loading: loading, data: data })=>{
    const extensions = data?.confluence_forgeExtensionsByType || [];
    if (!loading && extensions.length > 0) return (0, $cKELx.transformPreFilteredExtensions)(extensions);
    return null;
};

});
parcelRegister("cKELx", function(module, exports) {
$parcel$export(module.exports, "transformPreFilteredExtensions", () => $63c5fc99bf5bb5b9$export$9ff84ea1b2ab439c);
parcelRequire("1B59H");
var $aJjD9 = parcelRequire("aJjD9");

var $eGOwo = parcelRequire("eGOwo");
const $63c5fc99bf5bb5b9$var$cache = new Map();
const $63c5fc99bf5bb5b9$export$9ff84ea1b2ab439c = (extensions)=>{
    const extensionsIds = (extensions || []).map((ext)=>ext.id).join(',');
    if ((0, $eGOwo.fg)('memoize_prefiltered_extensions')) {
        if ($63c5fc99bf5bb5b9$var$cache.has(extensionsIds)) return $63c5fc99bf5bb5b9$var$cache.get(extensionsIds);
    }
    const result = (extensions || []).flatMap((extension)=>{
        if (!extension) return [];
        if (!extension.environmentKey) return [];
        return [
            {
                id: extension.id,
                appId: extension.appId,
                key: extension.key,
                environmentId: extension.environmentId,
                environmentType: extension.environmentType === (0, $aJjD9.ExtensionEnvironment).DEVELOPMENT || extension.environmentType === (0, $aJjD9.ExtensionEnvironment).STAGING || extension.environmentType === (0, $aJjD9.ExtensionEnvironment).PRODUCTION ? extension.environmentType : (0, $aJjD9.ExtensionEnvironment).DEVELOPMENT,
                environmentKey: extension.environmentKey,
                properties: extension.properties.reduce((acc, property)=>{
                    if (!property.value || !property.key) return acc;
                    try {
                        const jsonValue = JSON.parse(property.value);
                        acc[property.key] = jsonValue;
                    } catch (error) {
                        acc[property.key] = property.value;
                    }
                    return acc;
                }, {}),
                license: extension.license ? {
                    ...extension.license,
                    capabilitySet: $63c5fc99bf5bb5b9$var$mapCapabilitySet(extension.license.capabilitySet)
                } : null,
                userAccess: extension.userAccess ? {
                    hasAccess: extension.userAccess.hasAccess ?? false,
                    enabled: extension.userAccess.enabled ?? false
                } : null,
                type: extension.type,
                installationId: extension.installationId,
                appVersion: extension.appVersion ?? undefined,
                consentUrl: extension.consentUrl ?? undefined,
                migrationKey: extension.migrationKey ?? undefined,
                egress: extension.egress?.flatMap((egress)=>{
                    if (!egress.type || !egress.addresses) return [];
                    return [
                        {
                            type: egress.type,
                            addresses: egress.addresses?.flatMap((address)=>address ?? []),
                            category: egress.category ?? undefined,
                            inScopeEUD: egress.inScopeEUD ?? undefined
                        }
                    ];
                }) ?? undefined,
                scopes: extension.scopes ?? undefined,
                installationConfig: extension.installationConfig?.flatMap((config)=>{
                    if (!config?.key || config.value === null) return [];
                    return [
                        {
                            key: config.key,
                            value: config.value
                        }
                    ];
                }) ?? undefined,
                dataClassificationPolicyDecision: {
                    status: extension.hiddenBy === 'APP_ACCESS_RULES' ? 'BLOCKED' : 'ALLOWED'
                }
            }
        ];
    });
    if ((0, $eGOwo.fg)('memoize_prefiltered_extensions')) $63c5fc99bf5bb5b9$var$cache.set(extensionsIds, result);
    return result;
};
const $63c5fc99bf5bb5b9$var$mapCapabilitySet = (capabilitySet)=>{
    switch(capabilitySet){
        case 'CAPABILITY_ADVANCED':
            return 'capabilityAdvanced';
        default:
            return 'capabilityStandard';
    }
};

});




parcelRegister("dr03k", function(module, exports) {
$parcel$export(module.exports, "getBaseUrl", () => $6d56ec4251f4c428$export$f654b28f82155665);

var $kuAvn = parcelRequire("kuAvn");
const $6d56ec4251f4c428$var$GET_BASE_URL = (0, $kuAvn.default)`
	query tenant_user_query($cloudIds: [ID!]) {
		tenantContexts(cloudIds: $cloudIds) {
			cloudUrl
		}
	}
`;
// Storing baseUrl in memory here so that it can be reused across all extension points for all apps.
// Only called once per session or full page reload
let $6d56ec4251f4c428$var$storedBaseUrl = '';
const $6d56ec4251f4c428$export$f654b28f82155665 = async (client, cloudId)=>{
    if ($6d56ec4251f4c428$var$storedBaseUrl) return $6d56ec4251f4c428$var$storedBaseUrl;
    if (cloudId) {
        const response = await client.query({
            query: $6d56ec4251f4c428$var$GET_BASE_URL,
            variables: {
                cloudIds: cloudId
            }
        });
        const baseUrl = response.data?.tenantContexts?.[0].cloudUrl;
        $6d56ec4251f4c428$var$storedBaseUrl = baseUrl;
        return baseUrl;
    }
    return null;
};

});

parcelRegister("aD4zl", function(module, exports) {
$parcel$export(module.exports, "isCustomDomain", () => $2e2bda927ffc2376$export$97f4c254b641e719);

var $3NLJg = parcelRequire("3NLJg");
const $2e2bda927ffc2376$export$97f4c254b641e719 = (hostname)=>{
    return ![
        ...(0, $3NLJg.TRUSTED_ROOT_DOMAINS),
        'localhost',
        'jira-dev.com'
    ].some((trustedDomain)=>hostname.includes(trustedDomain));
};

});
parcelRegister("3NLJg", function(module, exports) {
$parcel$export(module.exports, "TRUSTED_ROOT_DOMAINS", () => $7e7af448c7258a30$export$bbc6c05835b799fc);
// domains from https://support.atlassian.com/organization-administration/docs/ip-addresses-and-domains-for-atlassian-cloud-products/
const $7e7af448c7258a30$export$bbc6c05835b799fc = [
    'atl-paas.net',
    'atlassian.com',
    'atlassian.net',
    'ss-inf.net',
    'jira.com',
    'bitbucket.org',
    'atlassian-us-gov-mod.com',
    'atlassian-us-gov-mod.net'
];

});


parcelRegister("6QUJr", function(module, exports) {
$parcel$export(module.exports, "getPerformanceMark", () => $82e24fa9d374df40$export$a728e3e4d9df1392);
const $82e24fa9d374df40$export$a728e3e4d9df1392 = ()=>Math.trunc(performance.now());

});

parcelRegister("grXB3", function(module, exports) {
$parcel$export(module.exports, "usePerformanceAnalytics", () => $aad2be7e5795ccaf$export$a8c9835719b09864);

var $eJOHy = parcelRequire("eJOHy");

var $hByHz = parcelRequire("hByHz");

var $8ldUJ = parcelRequire("8ldUJ");

var $eGOwo = parcelRequire("eGOwo");
const $aad2be7e5795ccaf$export$a8c9835719b09864 = ()=>{
    const timelineRef = (0, $eJOHy.useContext)((0, $hByHz.PerformanceAnalyticsContext));
    // Use for out-of-frame capture in platform code.
    const captureEvent = (0, $eJOHy.useCallback)((event)=>{
        if (!(0, $eGOwo.fg)('forge-ui-performance-analytics-provider')) return;
        timelineRef.current.events.push(event);
        timelineRef.current.listeners.forEach((listener)=>listener(event));
    }, [
        timelineRef
    ]);
    // Use for capturing events from untrusted sources (e.g. in-frame via bridge).
    const captureUntrustedEvent = (0, $eJOHy.useCallback)((event)=>{
        if (!(0, $eGOwo.fg)('forge-ui-performance-analytics-provider')) return;
        const result = (0, $8ldUJ.FrameProfilingEventCaptureTransformer).safeParse(event);
        if (!result.success) // TODO: log failed validations to detect contract mismatches/tampering.
        return;
        captureEvent(result.data);
    }, [
        captureEvent
    ]);
    return {
        captureEvent: captureEvent,
        captureUntrustedEvent: captureUntrustedEvent
    };
};

});
parcelRegister("hByHz", function(module, exports) {
$parcel$export(module.exports, "PerformanceAnalyticsContext", () => $870a51df7a7b4b91$export$433ff3d294755246);
$parcel$export(module.exports, "PERFORMANCE_ANALYTICS_INTERVAL", () => $870a51df7a7b4b91$export$e943a7fca26f09e4);
$parcel$export(module.exports, "PerformanceAnalyticsProviderRollout", () => $870a51df7a7b4b91$export$ec3453941beb4064);

var $gt9Am = parcelRequire("gt9Am");

var $ftN6c = parcelRequire("ftN6c");

var $eGOwo = parcelRequire("eGOwo");

var $kioCn = parcelRequire("kioCn");

var $eJOHy = parcelRequire("eJOHy");

var $cOZrT = parcelRequire("cOZrT");

var $6yq62 = parcelRequire("6yq62");

var $6QUJr = parcelRequire("6QUJr");

var $9mFVC = parcelRequire("9mFVC");
const $870a51df7a7b4b91$export$433ff3d294755246 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $870a51df7a7b4b91$export$e943a7fca26f09e4 = 10000;
const $870a51df7a7b4b91$var$offsetElapsedTimestamps = (events, elapsedBaselineMark)=>{
    return events.map((event)=>{
        const evaluatedElapsedTime = event.elapsed - elapsedBaselineMark;
        event.elapsed = evaluatedElapsedTime;
        return event;
    });
};
const $870a51df7a7b4b91$var$isPerformanceAnalyticsEnabled = (extensionType)=>{
    return (0, $9mFVC.getEnabledModulesForPerformanceProfiling)().includes(extensionType) && (0, $eGOwo.fg)('forge-ui-performance-analytics-provider');
};
const $870a51df7a7b4b91$export$9cdba3450d9c6cdc = ({ children: children, appType: appType, forgeEnvironment: forgeEnvironment, profileKey: profileKey, extensionType: extensionType })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { page: source } = (0, $6yq62.useMetricsContext)();
    // Rely on refs to avoid re-rendering all children components when the state changes
    const performanceTimelineRef = (0, $eJOHy.useRef)({
        events: [],
        listeners: new Set()
    });
    const hasSent = (0, $eJOHy.useRef)(false);
    const elapsedBaselineMark = (0, $eJOHy.useRef)(0);
    (0, $eJOHy.useEffect)(()=>{
        hasSent.current = false;
        performanceTimelineRef.current.events = [];
        elapsedBaselineMark.current = (0, $6QUJr.getPerformanceMark)();
    // Use `profileKey` to reset the all state when the extension or entryPoint changes to collect a new set of analytics
    }, [
        profileKey
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (hasSent.current || !$870a51df7a7b4b91$var$isPerformanceAnalyticsEnabled(extensionType || '')) return;
        // Send all collected performance related analytics in a single event
        const timeout = setTimeout(()=>{
            // Clone the eventRef to avoid the possibility of mutating the original object
            const eventsPayload = structuredClone(performanceTimelineRef.current.events);
            if ((0, $eGOwo.fg)('forge-ui-performance-sampling')) (0, $cOZrT.fireEvent)(createAnalyticsEvent, {
                action: 'performance.profiled',
                actionSubject: 'forge.ui.extension',
                attributes: {
                    events: $870a51df7a7b4b91$var$offsetElapsedTimestamps(eventsPayload, elapsedBaselineMark.current),
                    // Time difference since this event was fired and since page loaded
                    navigationTimeStart: elapsedBaselineMark.current,
                    appType: appType,
                    forgeEnvironment: forgeEnvironment
                },
                source: source
            });
            hasSent.current = true;
        }, $870a51df7a7b4b91$export$e943a7fca26f09e4);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        appType,
        createAnalyticsEvent,
        elapsedBaselineMark,
        performanceTimelineRef,
        extensionType,
        forgeEnvironment,
        hasSent,
        source
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($870a51df7a7b4b91$export$433ff3d294755246.Provider, {
        value: performanceTimelineRef,
        children: children
    });
};
const $870a51df7a7b4b91$export$ec3453941beb4064 = (0, $kioCn.componentWithFG)('forge-ui-performance-analytics-provider', $870a51df7a7b4b91$export$9cdba3450d9c6cdc, (0, $eJOHy.Fragment));

});
parcelRegister("kioCn", function(module, exports) {
$parcel$export(module.exports, "componentWithFG", () => $ba8f17f638620588$export$cf56d0f54cfcce4);

var $eGOwo = parcelRequire("eGOwo");

var $AIyOt = parcelRequire("AIyOt");
const $ba8f17f638620588$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $AIyOt.componentWithCondition)(()=>(0, $eGOwo.fg)(featureFlagName), ComponentTrue, ComponentFalse);

});
parcelRegister("AIyOt", function(module, exports) {
$parcel$export(module.exports, "componentWithCondition", () => $12a0a78415ce5192$export$6e8ea24b15199873);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $12a0a78415ce5192$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $gt9Am.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $gt9Am.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}

});


parcelRegister("9mFVC", function(module, exports) {
$parcel$export(module.exports, "getEnabledModulesForPerformanceProfiling", () => $0b552505181a4a5b$export$e6c1c2523bf4461);

var $eGOwo = parcelRequire("eGOwo");
// List of modules that should send performance metrics.
// Add new modules behind feature gate to monitor event volumes.
const $0b552505181a4a5b$var$allowlist = [
    // Jira Modules
    'jira:adminPage',
    'jira:customField',
    'jira:customFieldType',
    'jira:dashboardGadget',
    'jira:globalPage',
    'jira:issueAction',
    'jira:issueActivity',
    'jira:issueContext',
    'jira:issuePanel',
    'jira:projectPage',
    'jira:projectSettingsPage',
    // Confluence Modules
    'confluence:contentAction',
    'confluence:contentBylineItem',
    'confluence:globalPage',
    'confluence:globalSettings',
    'confluence:spacePage',
    'xen:macro'
];
const $0b552505181a4a5b$export$e6c1c2523bf4461 = ()=>{
    // Rolling out UIM in-frame perf capture.
    if ((0, $eGOwo.fg)('forge-ui-uim-perf-profiling-enabled')) return [
        ...$0b552505181a4a5b$var$allowlist,
        'jira:uiModifications'
    ];
    return $0b552505181a4a5b$var$allowlist;
};

});


parcelRegister("8ldUJ", function(module, exports) {
$parcel$export(module.exports, "FrameProfilingEventCaptureTransformer", () => $34aaa6e6df187e75$export$d85e1d6e65aaba29);

var $sSRGq = parcelRequire("sSRGq");

var $6QUJr = parcelRequire("6QUJr");
const $34aaa6e6df187e75$var$ClickedProfilingCapturableEventTransform = (0, $sSRGq.ClickedProfilingEventSchema).transform((_)=>{
    return {
        type: 'user-interacted',
        elapsed: (0, $6QUJr.getPerformanceMark)()
    };
});
const $34aaa6e6df187e75$var$NavigationTimingProfilingCapturableEventTransform = (0, $sSRGq.NavigationTimingProfilingEventSchema).transform((e)=>{
    return {
        type: 'navigation-timing',
        elapsed: (0, $6QUJr.getPerformanceMark)(),
        duration: Math.trunc(e.duration),
        transferSize: e.transferSize
    };
});
const $34aaa6e6df187e75$var$ResourceTimingProfilingCapturableEventTransform = (0, $sSRGq.ResourceTimingProfilingEventSchema).transform((e)=>{
    return {
        type: 'resource-timing',
        elapsed: (0, $6QUJr.getPerformanceMark)(),
        start: Math.trunc(e.start),
        duration: Math.trunc(e.duration),
        transferSize: Math.trunc(e.transferSize),
        initiatorType: e.initiatorType
    };
});
const $34aaa6e6df187e75$var$LayoutShiftProfilingCapturableEventTransform = (0, $sSRGq.LayoutShiftProfilingEventSchema).transform((e)=>{
    return {
        type: 'dcls-score',
        elapsed: (0, $6QUJr.getPerformanceMark)(),
        timestamp: Math.trunc(e.timestamp),
        // Transport 2dp truncated to avoid precision errors.
        score: Math.trunc(e.score * 100),
        inputFlag: e.inputFlag
    };
});
const $34aaa6e6df187e75$var$FCPProfilingCapturableEventTransform = (0, $sSRGq.FCPProfilingEventSchema).transform((e)=>{
    return {
        type: 'fcp-snapshot',
        elapsed: (0, $6QUJr.getPerformanceMark)(),
        start: Math.trunc(e.start)
    };
});
const $34aaa6e6df187e75$var$LCPProfilingCapturableEventTransform = (0, $sSRGq.LCPProfilingEventSchema).transform((e)=>{
    return {
        type: 'lcp-snapshot',
        elapsed: (0, $6QUJr.getPerformanceMark)(),
        start: Math.trunc(e.start),
        size: Math.trunc(e.size)
    };
});
// For each in-frame event type, there should be a transformer to a safely ingestible event.
const $34aaa6e6df187e75$var$transformers = {
    'navigation-timing': $34aaa6e6df187e75$var$NavigationTimingProfilingCapturableEventTransform,
    'resource-timing': $34aaa6e6df187e75$var$ResourceTimingProfilingCapturableEventTransform,
    'dcls-score': $34aaa6e6df187e75$var$LayoutShiftProfilingCapturableEventTransform,
    click: $34aaa6e6df187e75$var$ClickedProfilingCapturableEventTransform,
    'fcp-snapshot': $34aaa6e6df187e75$var$FCPProfilingCapturableEventTransform,
    'lcp-snapshot': $34aaa6e6df187e75$var$LCPProfilingCapturableEventTransform
};
const $34aaa6e6df187e75$export$d85e1d6e65aaba29 = (0, $sSRGq.AppFrameProfilingEventSchema).transform((e)=>$34aaa6e6df187e75$var$transformers[e.event].parse(e));

});
parcelRegister("sSRGq", function(module, exports) {
$parcel$export(module.exports, "ClickedProfilingEventSchema", () => $9144a3b58271b5e7$export$8da39d297b8df514);
$parcel$export(module.exports, "NavigationTimingProfilingEventSchema", () => $9144a3b58271b5e7$export$1226cd123c17e5c1);
$parcel$export(module.exports, "ResourceTimingProfilingEventSchema", () => $9144a3b58271b5e7$export$53d51f558d70545c);
$parcel$export(module.exports, "LayoutShiftProfilingEventSchema", () => $9144a3b58271b5e7$export$dcaedcbfb2a9bf04);
$parcel$export(module.exports, "FCPProfilingEventSchema", () => $9144a3b58271b5e7$export$ea631521a752c0a8);
$parcel$export(module.exports, "LCPProfilingEventSchema", () => $9144a3b58271b5e7$export$23e438485c66108);
$parcel$export(module.exports, "AppFrameProfilingEventSchema", () => $9144a3b58271b5e7$export$d659b0ed364a2533);
parcelRequire("gGDIO");
var $7d3aT = parcelRequire("7d3aT");
const $9144a3b58271b5e7$export$8da39d297b8df514 = (0, $7d3aT).object({
    event: (0, $7d3aT).literal('click')
}).strip();
const $9144a3b58271b5e7$export$1226cd123c17e5c1 = (0, $7d3aT).object({
    event: (0, $7d3aT).literal('navigation-timing'),
    transferSize: (0, $7d3aT).number().nonnegative().finite(),
    duration: (0, $7d3aT).number().nonnegative().finite()
}).strict();
const $9144a3b58271b5e7$var$initiatorTypeValues = (0, $7d3aT).enum([
    'script',
    'fetch',
    'css',
    'link',
    'iframe',
    'img',
    'image',
    'xmlhttprequest',
    'other'
]);
const $9144a3b58271b5e7$export$53d51f558d70545c = (0, $7d3aT).object({
    event: (0, $7d3aT).literal('resource-timing'),
    start: (0, $7d3aT).number().nonnegative().finite(),
    duration: (0, $7d3aT).number().nonnegative().finite(),
    transferSize: (0, $7d3aT).number().nonnegative().finite(),
    initiatorType: (0, $7d3aT).string().pipe($9144a3b58271b5e7$var$initiatorTypeValues.catch($9144a3b58271b5e7$var$initiatorTypeValues.Values.other)).pipe((0, $7d3aT).string())
}).strict();
const $9144a3b58271b5e7$export$dcaedcbfb2a9bf04 = (0, $7d3aT).object({
    event: (0, $7d3aT).literal('dcls-score'),
    score: (0, $7d3aT).number().nonnegative().finite(),
    timestamp: (0, $7d3aT).number().nonnegative().finite(),
    inputFlag: (0, $7d3aT).boolean()
}).strict();
const $9144a3b58271b5e7$export$ea631521a752c0a8 = (0, $7d3aT).object({
    event: (0, $7d3aT).literal('fcp-snapshot'),
    start: (0, $7d3aT).number().nonnegative().finite()
}).strict();
const $9144a3b58271b5e7$export$23e438485c66108 = (0, $7d3aT).object({
    event: (0, $7d3aT).literal('lcp-snapshot'),
    size: (0, $7d3aT).number().nonnegative().finite(),
    start: (0, $7d3aT).number().nonnegative().finite()
}).strict();
const $9144a3b58271b5e7$export$d659b0ed364a2533 = (0, $7d3aT).discriminatedUnion('event', [
    $9144a3b58271b5e7$export$8da39d297b8df514,
    $9144a3b58271b5e7$export$1226cd123c17e5c1,
    $9144a3b58271b5e7$export$53d51f558d70545c,
    $9144a3b58271b5e7$export$dcaedcbfb2a9bf04,
    $9144a3b58271b5e7$export$ea631521a752c0a8,
    $9144a3b58271b5e7$export$23e438485c66108
]);

});
parcelRegister("gGDIO", function(module, exports) {
$parcel$export(module.exports, "z", () => (parcelRequire("7d3aT")));

var $gyLbc = parcelRequire("gyLbc");
var $c25f6184d975a17c$export$2e2bcd8739ae039 = (0, $gyLbc.default);

});
parcelRegister("gyLbc", function(module, exports) {
$parcel$export(module.exports, "default", () => $c0e46b365d289d88$export$2e2bcd8739ae039);
$parcel$export(module.exports, "z", () => (parcelRequire("7d3aT")));

var $7d3aT = parcelRequire("7d3aT");
var $c0e46b365d289d88$export$2e2bcd8739ae039 = $7d3aT;

});
parcelRegister("7d3aT", function(module, exports) {

var $kKULo = parcelRequire("kKULo");

var $eO7MR = parcelRequire("eO7MR");

var $gBJBy = parcelRequire("gBJBy");

var $9LkVA = parcelRequire("9LkVA");

var $dTh4D = parcelRequire("dTh4D");

var $jAWE5 = parcelRequire("jAWE5");
$parcel$exportWildcard(module.exports, $kKULo);
$parcel$exportWildcard(module.exports, $eO7MR);
$parcel$exportWildcard(module.exports, $gBJBy);
$parcel$exportWildcard(module.exports, $9LkVA);
$parcel$exportWildcard(module.exports, $dTh4D);
$parcel$exportWildcard(module.exports, $jAWE5);

});
parcelRegister("kKULo", function(module, exports) {
$parcel$export(module.exports, "setErrorMap", () => $f1c42293ec7901c3$export$1097a8289cfd22d7);
$parcel$export(module.exports, "getErrorMap", () => $f1c42293ec7901c3$export$32f27c719778d4c4);
$parcel$export(module.exports, "defaultErrorMap", () => (parcelRequire("b42gj")).default);

var $b42gj = parcelRequire("b42gj");
let $f1c42293ec7901c3$var$overrideErrorMap = (0, $b42gj.default);
function $f1c42293ec7901c3$export$1097a8289cfd22d7(map) {
    $f1c42293ec7901c3$var$overrideErrorMap = map;
}
function $f1c42293ec7901c3$export$32f27c719778d4c4() {
    return $f1c42293ec7901c3$var$overrideErrorMap;
}

});
parcelRegister("b42gj", function(module, exports) {
$parcel$export(module.exports, "default", () => $80e1d2a94dee7fd6$export$2e2bcd8739ae039);

var $jAWE5 = parcelRequire("jAWE5");

var $9LkVA = parcelRequire("9LkVA");
const $80e1d2a94dee7fd6$var$errorMap = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case (0, $jAWE5.ZodIssueCode).invalid_type:
            if (issue.received === (0, $9LkVA.ZodParsedType).undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case (0, $jAWE5.ZodIssueCode).invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, (0, $9LkVA.util).jsonStringifyReplacer)}`;
            break;
        case (0, $jAWE5.ZodIssueCode).unrecognized_keys:
            message = `Unrecognized key(s) in object: ${(0, $9LkVA.util).joinValues(issue.keys, ", ")}`;
            break;
        case (0, $jAWE5.ZodIssueCode).invalid_union:
            message = `Invalid input`;
            break;
        case (0, $jAWE5.ZodIssueCode).invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${(0, $9LkVA.util).joinValues(issue.options)}`;
            break;
        case (0, $jAWE5.ZodIssueCode).invalid_enum_value:
            message = `Invalid enum value. Expected ${(0, $9LkVA.util).joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case (0, $jAWE5.ZodIssueCode).invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case (0, $jAWE5.ZodIssueCode).invalid_return_type:
            message = `Invalid function return type`;
            break;
        case (0, $jAWE5.ZodIssueCode).invalid_date:
            message = `Invalid date`;
            break;
        case (0, $jAWE5.ZodIssueCode).invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else (0, $9LkVA.util).assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case (0, $jAWE5.ZodIssueCode).too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case (0, $jAWE5.ZodIssueCode).too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case (0, $jAWE5.ZodIssueCode).custom:
            message = `Invalid input`;
            break;
        case (0, $jAWE5.ZodIssueCode).invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case (0, $jAWE5.ZodIssueCode).not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case (0, $jAWE5.ZodIssueCode).not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            (0, $9LkVA.util).assertNever(issue);
    }
    return {
        message: message
    };
};
var $80e1d2a94dee7fd6$export$2e2bcd8739ae039 = $80e1d2a94dee7fd6$var$errorMap;

});
parcelRegister("jAWE5", function(module, exports) {
$parcel$export(module.exports, "ZodIssueCode", () => $e43edeeacb7c357d$export$5ba560653e4a1035);
$parcel$export(module.exports, "quotelessJson", () => $e43edeeacb7c357d$export$913eddeaf297cfea);
$parcel$export(module.exports, "ZodError", () => $e43edeeacb7c357d$export$f98dac4b251ab333);

var $9LkVA = parcelRequire("9LkVA");
const $e43edeeacb7c357d$export$5ba560653e4a1035 = (0, $9LkVA.util).arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $e43edeeacb7c357d$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $e43edeeacb7c357d$export$f98dac4b251ab333 extends Error {
    get errors() {
        return this.issues;
    }
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof $e43edeeacb7c357d$export$f98dac4b251ab333)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, (0, $9LkVA.util).jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$e43edeeacb7c357d$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $e43edeeacb7c357d$export$f98dac4b251ab333(issues);
    return error;
};

});
parcelRegister("9LkVA", function(module, exports) {
$parcel$export(module.exports, "util", () => $71b8bca8f5d2f24e$export$7debb50ef11d5e0b);
$parcel$export(module.exports, "objectUtil", () => $71b8bca8f5d2f24e$export$4aa2142c225fd5c7);
$parcel$export(module.exports, "ZodParsedType", () => $71b8bca8f5d2f24e$export$5716da67bfaa244d);
$parcel$export(module.exports, "getParsedType", () => $71b8bca8f5d2f24e$export$3e9057828ebd5c7a);
var $71b8bca8f5d2f24e$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (_)=>{};
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && Number.isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($71b8bca8f5d2f24e$export$7debb50ef11d5e0b || ($71b8bca8f5d2f24e$export$7debb50ef11d5e0b = {}));
var $71b8bca8f5d2f24e$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($71b8bca8f5d2f24e$export$4aa2142c225fd5c7 || ($71b8bca8f5d2f24e$export$4aa2142c225fd5c7 = {}));
const $71b8bca8f5d2f24e$export$5716da67bfaa244d = $71b8bca8f5d2f24e$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $71b8bca8f5d2f24e$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $71b8bca8f5d2f24e$export$5716da67bfaa244d.undefined;
        case "string":
            return $71b8bca8f5d2f24e$export$5716da67bfaa244d.string;
        case "number":
            return Number.isNaN(data) ? $71b8bca8f5d2f24e$export$5716da67bfaa244d.nan : $71b8bca8f5d2f24e$export$5716da67bfaa244d.number;
        case "boolean":
            return $71b8bca8f5d2f24e$export$5716da67bfaa244d.boolean;
        case "function":
            return $71b8bca8f5d2f24e$export$5716da67bfaa244d.function;
        case "bigint":
            return $71b8bca8f5d2f24e$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $71b8bca8f5d2f24e$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $71b8bca8f5d2f24e$export$5716da67bfaa244d.array;
            if (data === null) return $71b8bca8f5d2f24e$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $71b8bca8f5d2f24e$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $71b8bca8f5d2f24e$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $71b8bca8f5d2f24e$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $71b8bca8f5d2f24e$export$5716da67bfaa244d.date;
            return $71b8bca8f5d2f24e$export$5716da67bfaa244d.object;
        default:
            return $71b8bca8f5d2f24e$export$5716da67bfaa244d.unknown;
    }
};

});




parcelRegister("eO7MR", function(module, exports) {
$parcel$export(module.exports, "makeIssue", () => $ac7bc692f8dbfd6b$export$244a85fde9c419ed);
$parcel$export(module.exports, "EMPTY_PATH", () => $ac7bc692f8dbfd6b$export$1526d2e05f74572);
$parcel$export(module.exports, "addIssueToContext", () => $ac7bc692f8dbfd6b$export$db7caee60e5d514d);
$parcel$export(module.exports, "ParseStatus", () => $ac7bc692f8dbfd6b$export$5b20a5c3d05c1f6f);
$parcel$export(module.exports, "INVALID", () => $ac7bc692f8dbfd6b$export$9a105a556e65c2c0);
$parcel$export(module.exports, "DIRTY", () => $ac7bc692f8dbfd6b$export$325a211da9693fcf);
$parcel$export(module.exports, "OK", () => $ac7bc692f8dbfd6b$export$c6813a8d51f77eaf);
$parcel$export(module.exports, "isAborted", () => $ac7bc692f8dbfd6b$export$afa861e3c5730743);
$parcel$export(module.exports, "isDirty", () => $ac7bc692f8dbfd6b$export$910b6cdd390341b3);
$parcel$export(module.exports, "isValid", () => $ac7bc692f8dbfd6b$export$1ea939691cdc45b8);
$parcel$export(module.exports, "isAsync", () => $ac7bc692f8dbfd6b$export$aefee5ebe1dcfd9e);

var $kKULo = parcelRequire("kKULo");

var $b42gj = parcelRequire("b42gj");
const $ac7bc692f8dbfd6b$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
const $ac7bc692f8dbfd6b$export$1526d2e05f74572 = [];
function $ac7bc692f8dbfd6b$export$db7caee60e5d514d(ctx, issueData) {
    const overrideMap = (0, $kKULo.getErrorMap)();
    const issue = $ac7bc692f8dbfd6b$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === (0, $b42gj.default) ? undefined : (0, $b42gj.default)
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $ac7bc692f8dbfd6b$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $ac7bc692f8dbfd6b$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key: key,
                value: value
            });
        }
        return $ac7bc692f8dbfd6b$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $ac7bc692f8dbfd6b$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $ac7bc692f8dbfd6b$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $ac7bc692f8dbfd6b$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $ac7bc692f8dbfd6b$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $ac7bc692f8dbfd6b$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $ac7bc692f8dbfd6b$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $ac7bc692f8dbfd6b$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $ac7bc692f8dbfd6b$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $ac7bc692f8dbfd6b$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;

});

parcelRegister("gBJBy", function(module, exports) {

});

parcelRegister("dTh4D", function(module, exports) {
$parcel$export(module.exports, "ZodType", () => $a1cda7ed89d79c47$export$2afb8ab49d4b92c0);
$parcel$export(module.exports, "ZodEffects", () => $a1cda7ed89d79c47$export$a60af00cc0ce2582);
$parcel$export(module.exports, "ZodFirstPartyTypeKind", () => $a1cda7ed89d79c47$export$558106ce543bd011);
$parcel$export(module.exports, "ZodOptional", () => $a1cda7ed89d79c47$export$aa56fec1e9d629b8);
$parcel$export(module.exports, "ZodNullable", () => $a1cda7ed89d79c47$export$aaac0b8b429cef5);
$parcel$export(module.exports, "ZodArray", () => $a1cda7ed89d79c47$export$7acfc3e64785411);
$parcel$export(module.exports, "ZodPromise", () => $a1cda7ed89d79c47$export$3f196b0127d6e50a);
$parcel$export(module.exports, "ZodUnion", () => $a1cda7ed89d79c47$export$a8b236cb5070a311);
$parcel$export(module.exports, "ZodIntersection", () => $a1cda7ed89d79c47$export$c02deaf0bb5203d4);
$parcel$export(module.exports, "ZodDefault", () => $a1cda7ed89d79c47$export$bb19b37874861e7e);
$parcel$export(module.exports, "ZodBranded", () => $a1cda7ed89d79c47$export$66b0c798a395271f);
$parcel$export(module.exports, "ZodCatch", () => $a1cda7ed89d79c47$export$75a44ec6249ac76b);
$parcel$export(module.exports, "ZodPipeline", () => $a1cda7ed89d79c47$export$a3c3ef8a0e95c6da);
$parcel$export(module.exports, "ZodReadonly", () => $a1cda7ed89d79c47$export$5d1f7ef05c4e493a);
$parcel$export(module.exports, "datetimeRegex", () => $a1cda7ed89d79c47$export$a4b563879add27a);
$parcel$export(module.exports, "ZodString", () => $a1cda7ed89d79c47$export$1230eb29b8d3b502);
$parcel$export(module.exports, "ZodNumber", () => $a1cda7ed89d79c47$export$5b070a55c0c43e09);
$parcel$export(module.exports, "ZodBigInt", () => $a1cda7ed89d79c47$export$67d741fd70ff98f4);
$parcel$export(module.exports, "ZodBoolean", () => $a1cda7ed89d79c47$export$723d146f80596191);
$parcel$export(module.exports, "ZodDate", () => $a1cda7ed89d79c47$export$e974be33bdc55521);
$parcel$export(module.exports, "ZodSymbol", () => $a1cda7ed89d79c47$export$bcc3b40f6b638044);
$parcel$export(module.exports, "ZodUndefined", () => $a1cda7ed89d79c47$export$4e780e961c30340d);
$parcel$export(module.exports, "ZodNull", () => $a1cda7ed89d79c47$export$a96281f914484f2d);
$parcel$export(module.exports, "ZodAny", () => $a1cda7ed89d79c47$export$b9d1edb536b4e4eb);
$parcel$export(module.exports, "ZodUnknown", () => $a1cda7ed89d79c47$export$ef3b1bb1630977ae);
$parcel$export(module.exports, "ZodNever", () => $a1cda7ed89d79c47$export$1e576a20c3ce9fb5);
$parcel$export(module.exports, "ZodVoid", () => $a1cda7ed89d79c47$export$7d39f5df85f21031);
$parcel$export(module.exports, "ZodObject", () => $a1cda7ed89d79c47$export$736315c5b55efbad);
$parcel$export(module.exports, "ZodTuple", () => $a1cda7ed89d79c47$export$e2a18bb771d8e6a3);
$parcel$export(module.exports, "ZodLazy", () => $a1cda7ed89d79c47$export$378d0cfce37406e6);
$parcel$export(module.exports, "ZodLiteral", () => $a1cda7ed89d79c47$export$7e44096782a165d3);
$parcel$export(module.exports, "ZodEnum", () => $a1cda7ed89d79c47$export$d325d1f0e1c20179);
$parcel$export(module.exports, "ZodNativeEnum", () => $a1cda7ed89d79c47$export$370b2e8d6d6f5c56);
$parcel$export(module.exports, "ZodDiscriminatedUnion", () => $a1cda7ed89d79c47$export$5ef2424805ac76a3);
$parcel$export(module.exports, "ZodRecord", () => $a1cda7ed89d79c47$export$a2acc09968cb4b7f);
$parcel$export(module.exports, "ZodMap", () => $a1cda7ed89d79c47$export$163b6a2b712d9542);
$parcel$export(module.exports, "ZodSet", () => $a1cda7ed89d79c47$export$977057706f816712);
$parcel$export(module.exports, "ZodFunction", () => $a1cda7ed89d79c47$export$d4602ba55673f53c);
$parcel$export(module.exports, "ZodTransformer", () => $a1cda7ed89d79c47$export$a60af00cc0ce2582);
$parcel$export(module.exports, "ZodNaN", () => $a1cda7ed89d79c47$export$26ccfa0145e8511f);
$parcel$export(module.exports, "BRAND", () => $a1cda7ed89d79c47$export$cf2deea74cde46b4);
$parcel$export(module.exports, "custom", () => $a1cda7ed89d79c47$export$4c00f665f0d4b443);
$parcel$export(module.exports, "Schema", () => $a1cda7ed89d79c47$export$2afb8ab49d4b92c0);
$parcel$export(module.exports, "ZodSchema", () => $a1cda7ed89d79c47$export$2afb8ab49d4b92c0);
$parcel$export(module.exports, "late", () => $a1cda7ed89d79c47$export$1ee8ee30835eab8b);
$parcel$export(module.exports, "instanceof", () => $a1cda7ed89d79c47$export$3d916e7c22dbd8b5);
$parcel$export(module.exports, "string", () => $a1cda7ed89d79c47$export$22b082955e083ec3);
$parcel$export(module.exports, "number", () => $a1cda7ed89d79c47$export$98e628dec113755e);
$parcel$export(module.exports, "nan", () => $a1cda7ed89d79c47$export$9e06de0973666692);
$parcel$export(module.exports, "bigint", () => $a1cda7ed89d79c47$export$a0f65b52274bcc00);
$parcel$export(module.exports, "boolean", () => $a1cda7ed89d79c47$export$4a21f16c33752377);
$parcel$export(module.exports, "date", () => $a1cda7ed89d79c47$export$324d90190a8b822a);
$parcel$export(module.exports, "symbol", () => $a1cda7ed89d79c47$export$8f701197936bc2a6);
$parcel$export(module.exports, "undefined", () => $a1cda7ed89d79c47$export$1db45310990710a5);
$parcel$export(module.exports, "null", () => $a1cda7ed89d79c47$export$7b1b591b262c240);
$parcel$export(module.exports, "any", () => $a1cda7ed89d79c47$export$4154a199d7d90455);
$parcel$export(module.exports, "unknown", () => $a1cda7ed89d79c47$export$19282c40b967aec6);
$parcel$export(module.exports, "never", () => $a1cda7ed89d79c47$export$b3e22bcfd64c1022);
$parcel$export(module.exports, "void", () => $a1cda7ed89d79c47$export$490e536ee7389aeb);
$parcel$export(module.exports, "array", () => $a1cda7ed89d79c47$export$2f23118c22fb2630);
$parcel$export(module.exports, "object", () => $a1cda7ed89d79c47$export$be5493f9613cbbe);
$parcel$export(module.exports, "strictObject", () => $a1cda7ed89d79c47$export$8fb0df5f40d0b477);
$parcel$export(module.exports, "union", () => $a1cda7ed89d79c47$export$971dd5b0dfd021b6);
$parcel$export(module.exports, "discriminatedUnion", () => $a1cda7ed89d79c47$export$4b888e40c4ee26dd);
$parcel$export(module.exports, "intersection", () => $a1cda7ed89d79c47$export$bc86dfbf7795668c);
$parcel$export(module.exports, "tuple", () => $a1cda7ed89d79c47$export$65e3907585753458);
$parcel$export(module.exports, "record", () => $a1cda7ed89d79c47$export$e5185e241753e543);
$parcel$export(module.exports, "map", () => $a1cda7ed89d79c47$export$871de8747c9eaa88);
$parcel$export(module.exports, "set", () => $a1cda7ed89d79c47$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "function", () => $a1cda7ed89d79c47$export$44e51c8aac7c2deb);
$parcel$export(module.exports, "lazy", () => $a1cda7ed89d79c47$export$488013bae63b21da);
$parcel$export(module.exports, "literal", () => $a1cda7ed89d79c47$export$c8ec6e1ec9fefcb0);
$parcel$export(module.exports, "enum", () => $a1cda7ed89d79c47$export$78a99c8d44d72635);
$parcel$export(module.exports, "nativeEnum", () => $a1cda7ed89d79c47$export$6fe7eca19ebe5199);
$parcel$export(module.exports, "promise", () => $a1cda7ed89d79c47$export$c957ef27a0ebfd4);
$parcel$export(module.exports, "effect", () => $a1cda7ed89d79c47$export$dc573d8a6576cdb3);
$parcel$export(module.exports, "optional", () => $a1cda7ed89d79c47$export$516e28dec6a4b6d4);
$parcel$export(module.exports, "nullable", () => $a1cda7ed89d79c47$export$133fc36489ac9add);
$parcel$export(module.exports, "preprocess", () => $a1cda7ed89d79c47$export$fc37fe19dfda43ee);
$parcel$export(module.exports, "pipeline", () => $a1cda7ed89d79c47$export$43f28b24e1eb8181);
$parcel$export(module.exports, "ostring", () => $a1cda7ed89d79c47$export$3b3d07727c5b702c);
$parcel$export(module.exports, "onumber", () => $a1cda7ed89d79c47$export$eb150471a61fced6);
$parcel$export(module.exports, "oboolean", () => $a1cda7ed89d79c47$export$269251733cdcbbf1);
$parcel$export(module.exports, "coerce", () => $a1cda7ed89d79c47$export$8c14e57e778d3873);
$parcel$export(module.exports, "transformer", () => $a1cda7ed89d79c47$export$dc573d8a6576cdb3);
$parcel$export(module.exports, "NEVER", () => $a1cda7ed89d79c47$export$96c94437c95d7862);

var $jAWE5 = parcelRequire("jAWE5");
parcelRequire("kKULo");
var $b42gj = parcelRequire("b42gj");
var $kKULo = parcelRequire("kKULo");

var $2NCkc = parcelRequire("2NCkc");

var $eO7MR = parcelRequire("eO7MR");

var $9LkVA = parcelRequire("9LkVA");
class $a1cda7ed89d79c47$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (Array.isArray(this._key)) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $a1cda7ed89d79c47$var$handleResult = (ctx, result)=>{
    if ((0, $eO7MR.isValid)(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new (0, $jAWE5.ZodError)(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $a1cda7ed89d79c47$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        const { message: message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message ?? ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: message ?? required_error ?? ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: message ?? invalid_type_error ?? ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return (0, $9LkVA.getParsedType)(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: (0, $9LkVA.getParsedType)(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new (0, $eO7MR.ParseStatus)(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: (0, $9LkVA.getParsedType)(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ((0, $eO7MR.isAsync)(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        const ctx = {
            common: {
                issues: [],
                async: params?.async ?? false,
                contextualErrorMap: params?.errorMap
            },
            path: params?.path || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: (0, $9LkVA.getParsedType)(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $a1cda7ed89d79c47$var$handleResult(ctx, result);
    }
    "~validate"(data) {
        const ctx = {
            common: {
                issues: [],
                async: !!this["~standard"].async
            },
            path: [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: (0, $9LkVA.getParsedType)(data)
        };
        if (!this["~standard"].async) try {
            const result = this._parseSync({
                data: data,
                path: [],
                parent: ctx
            });
            return (0, $eO7MR.isValid)(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            };
        } catch (err) {
            if (err?.message?.toLowerCase()?.includes("encountered")) this["~standard"].async = true;
            ctx.common = {
                issues: [],
                async: true
            };
        }
        return this._parseAsync({
            data: data,
            path: [],
            parent: ctx
        }).then((result)=>(0, $eO7MR.isValid)(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            });
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params?.errorMap,
                async: true
            },
            path: params?.path || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: (0, $9LkVA.getParsedType)(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ((0, $eO7MR.isAsync)(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $a1cda7ed89d79c47$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: (0, $jAWE5.ZodIssueCode).custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $a1cda7ed89d79c47$export$a60af00cc0ce2582({
            schema: this,
            typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
        this["~standard"] = {
            version: 1,
            vendor: "zod",
            validate: (data)=>this["~validate"](data)
        };
    }
    optional() {
        return $a1cda7ed89d79c47$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $a1cda7ed89d79c47$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $a1cda7ed89d79c47$export$7acfc3e64785411.create(this);
    }
    promise() {
        return $a1cda7ed89d79c47$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $a1cda7ed89d79c47$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $a1cda7ed89d79c47$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $a1cda7ed89d79c47$export$a60af00cc0ce2582({
            ...$a1cda7ed89d79c47$var$processCreateParams(this._def),
            schema: this,
            typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $a1cda7ed89d79c47$export$bb19b37874861e7e({
            ...$a1cda7ed89d79c47$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $a1cda7ed89d79c47$export$66b0c798a395271f({
            typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$a1cda7ed89d79c47$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $a1cda7ed89d79c47$export$75a44ec6249ac76b({
            ...$a1cda7ed89d79c47$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $a1cda7ed89d79c47$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $a1cda7ed89d79c47$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $a1cda7ed89d79c47$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $a1cda7ed89d79c47$var$cuid2Regex = /^[0-9a-z]+$/;
const $a1cda7ed89d79c47$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $a1cda7ed89d79c47$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const $a1cda7ed89d79c47$var$nanoidRegex = /^[a-z0-9_-]{21}$/i;
const $a1cda7ed89d79c47$var$jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
const $a1cda7ed89d79c47$var$durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $a1cda7ed89d79c47$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $a1cda7ed89d79c47$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $a1cda7ed89d79c47$var$emojiRegex;
// faster, simpler, safer
const $a1cda7ed89d79c47$var$ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $a1cda7ed89d79c47$var$ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
// const ipv6Regex =
// /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
const $a1cda7ed89d79c47$var$ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
const $a1cda7ed89d79c47$var$ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const $a1cda7ed89d79c47$var$base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// https://base64.guru/standards/base64url
const $a1cda7ed89d79c47$var$base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const $a1cda7ed89d79c47$var$dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const $a1cda7ed89d79c47$var$dateRegex = new RegExp(`^${$a1cda7ed89d79c47$var$dateRegexSource}$`);
function $a1cda7ed89d79c47$var$timeRegexSource(args) {
    let secondsRegexSource = `[0-5]\\d`;
    if (args.precision) secondsRegexSource = `${secondsRegexSource}\\.\\d{${args.precision}}`;
    else if (args.precision == null) secondsRegexSource = `${secondsRegexSource}(\\.\\d+)?`;
    const secondsQuantifier = args.precision ? "+" : "?"; // require seconds if precision is nonzero
    return `([01]\\d|2[0-3]):[0-5]\\d(:${secondsRegexSource})${secondsQuantifier}`;
}
function $a1cda7ed89d79c47$var$timeRegex(args) {
    return new RegExp(`^${$a1cda7ed89d79c47$var$timeRegexSource(args)}$`);
}
function $a1cda7ed89d79c47$export$a4b563879add27a(args) {
    let regex = `${$a1cda7ed89d79c47$var$dateRegexSource}T${$a1cda7ed89d79c47$var$timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function $a1cda7ed89d79c47$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $a1cda7ed89d79c47$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $a1cda7ed89d79c47$var$ipv6Regex.test(ip)) return true;
    return false;
}
function $a1cda7ed89d79c47$var$isValidJWT(jwt, alg) {
    if (!$a1cda7ed89d79c47$var$jwtRegex.test(jwt)) return false;
    try {
        const [header] = jwt.split(".");
        // Convert base64url to base64
        const base64 = header.replace(/-/g, "+").replace(/_/g, "/").padEnd(header.length + (4 - header.length % 4) % 4, "=");
        const decoded = JSON.parse(atob(base64));
        if (typeof decoded !== "object" || decoded === null) return false;
        if ("typ" in decoded && decoded?.typ !== "JWT") return false;
        if (!decoded.alg) return false;
        if (alg && decoded.alg !== alg) return false;
        return true;
    } catch  {
        return false;
    }
}
function $a1cda7ed89d79c47$var$isValidCidr(ip, version) {
    if ((version === "v4" || !version) && $a1cda7ed89d79c47$var$ipv4CidrRegex.test(ip)) return true;
    if ((version === "v6" || !version) && $a1cda7ed89d79c47$var$ipv6CidrRegex.test(ip)) return true;
    return false;
}
class $a1cda7ed89d79c47$export$1230eb29b8d3b502 extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $9LkVA.ZodParsedType).string) {
            const ctx = this._getOrReturnCtx(input);
            (0, $eO7MR.addIssueToContext)(ctx, {
                code: (0, $jAWE5.ZodIssueCode).invalid_type,
                expected: (0, $9LkVA.ZodParsedType).string,
                received: ctx.parsedType
            });
            return 0, $eO7MR.INVALID;
        }
        const status = new (0, $eO7MR.ParseStatus)();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $eO7MR.addIssueToContext)(ctx, {
                        code: (0, $jAWE5.ZodIssueCode).too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $eO7MR.addIssueToContext)(ctx, {
                        code: (0, $jAWE5.ZodIssueCode).too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) (0, $eO7MR.addIssueToContext)(ctx, {
                        code: (0, $jAWE5.ZodIssueCode).too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) (0, $eO7MR.addIssueToContext)(ctx, {
                        code: (0, $jAWE5.ZodIssueCode).too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$a1cda7ed89d79c47$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $eO7MR.addIssueToContext)(ctx, {
                        validation: "email",
                        code: (0, $jAWE5.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$a1cda7ed89d79c47$var$emojiRegex) $a1cda7ed89d79c47$var$emojiRegex = new RegExp($a1cda7ed89d79c47$var$_emojiRegex, "u");
                if (!$a1cda7ed89d79c47$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $eO7MR.addIssueToContext)(ctx, {
                        validation: "emoji",
                        code: (0, $jAWE5.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$a1cda7ed89d79c47$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $eO7MR.addIssueToContext)(ctx, {
                        validation: "uuid",
                        code: (0, $jAWE5.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!$a1cda7ed89d79c47$var$nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $eO7MR.addIssueToContext)(ctx, {
                        validation: "nanoid",
                        code: (0, $jAWE5.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$a1cda7ed89d79c47$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $eO7MR.addIssueToContext)(ctx, {
                        validation: "cuid",
                        code: (0, $jAWE5.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$a1cda7ed89d79c47$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $eO7MR.addIssueToContext)(ctx, {
                        validation: "cuid2",
                        code: (0, $jAWE5.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$a1cda7ed89d79c47$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $eO7MR.addIssueToContext)(ctx, {
                        validation: "ulid",
                        code: (0, $jAWE5.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch  {
                ctx = this._getOrReturnCtx(input, ctx);
                (0, $eO7MR.addIssueToContext)(ctx, {
                    validation: "url",
                    code: (0, $jAWE5.ZodIssueCode).invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $eO7MR.addIssueToContext)(ctx, {
                        validation: "regex",
                        code: (0, $jAWE5.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $eO7MR.addIssueToContext)(ctx, {
                        code: (0, $jAWE5.ZodIssueCode).invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $eO7MR.addIssueToContext)(ctx, {
                        code: (0, $jAWE5.ZodIssueCode).invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $eO7MR.addIssueToContext)(ctx, {
                        code: (0, $jAWE5.ZodIssueCode).invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $a1cda7ed89d79c47$export$a4b563879add27a(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $eO7MR.addIssueToContext)(ctx, {
                        code: (0, $jAWE5.ZodIssueCode).invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = $a1cda7ed89d79c47$var$dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $eO7MR.addIssueToContext)(ctx, {
                        code: (0, $jAWE5.ZodIssueCode).invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = $a1cda7ed89d79c47$var$timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $eO7MR.addIssueToContext)(ctx, {
                        code: (0, $jAWE5.ZodIssueCode).invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!$a1cda7ed89d79c47$var$durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $eO7MR.addIssueToContext)(ctx, {
                        validation: "duration",
                        code: (0, $jAWE5.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$a1cda7ed89d79c47$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $eO7MR.addIssueToContext)(ctx, {
                        validation: "ip",
                        code: (0, $jAWE5.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "jwt") {
                if (!$a1cda7ed89d79c47$var$isValidJWT(input.data, check.alg)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $eO7MR.addIssueToContext)(ctx, {
                        validation: "jwt",
                        code: (0, $jAWE5.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cidr") {
                if (!$a1cda7ed89d79c47$var$isValidCidr(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $eO7MR.addIssueToContext)(ctx, {
                        validation: "cidr",
                        code: (0, $jAWE5.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!$a1cda7ed89d79c47$var$base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $eO7MR.addIssueToContext)(ctx, {
                        validation: "base64",
                        code: (0, $jAWE5.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64url") {
                if (!$a1cda7ed89d79c47$var$base64urlRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $eO7MR.addIssueToContext)(ctx, {
                        validation: "base64url",
                        code: (0, $jAWE5.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, $9LkVA.util).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: (0, $jAWE5.ZodIssueCode).invalid_string,
            ...(0, $2NCkc.errorUtil).errToObj(message)
        });
    }
    _addCheck(check) {
        return new $a1cda7ed89d79c47$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...(0, $2NCkc.errorUtil).errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...(0, $2NCkc.errorUtil).errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...(0, $2NCkc.errorUtil).errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...(0, $2NCkc.errorUtil).errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...(0, $2NCkc.errorUtil).errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...(0, $2NCkc.errorUtil).errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...(0, $2NCkc.errorUtil).errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...(0, $2NCkc.errorUtil).errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...(0, $2NCkc.errorUtil).errToObj(message)
        });
    }
    base64url(message) {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return this._addCheck({
            kind: "base64url",
            ...(0, $2NCkc.errorUtil).errToObj(message)
        });
    }
    jwt(options) {
        return this._addCheck({
            kind: "jwt",
            ...(0, $2NCkc.errorUtil).errToObj(options)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...(0, $2NCkc.errorUtil).errToObj(options)
        });
    }
    cidr(options) {
        return this._addCheck({
            kind: "cidr",
            ...(0, $2NCkc.errorUtil).errToObj(options)
        });
    }
    datetime(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof options?.precision === "undefined" ? null : options?.precision,
            offset: options?.offset ?? false,
            local: options?.local ?? false,
            ...(0, $2NCkc.errorUtil).errToObj(options?.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message: message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof options?.precision === "undefined" ? null : options?.precision,
            ...(0, $2NCkc.errorUtil).errToObj(options?.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...(0, $2NCkc.errorUtil).errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...(0, $2NCkc.errorUtil).errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options?.position,
            ...(0, $2NCkc.errorUtil).errToObj(options?.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...(0, $2NCkc.errorUtil).errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...(0, $2NCkc.errorUtil).errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...(0, $2NCkc.errorUtil).errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...(0, $2NCkc.errorUtil).errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...(0, $2NCkc.errorUtil).errToObj(message)
        });
    }
    /**
     * Equivalent to `.min(1)`
     */ nonempty(message) {
        return this.min(1, (0, $2NCkc.errorUtil).errToObj(message));
    }
    trim() {
        return new $a1cda7ed89d79c47$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $a1cda7ed89d79c47$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $a1cda7ed89d79c47$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isCIDR() {
        return !!this._def.checks.find((ch)=>ch.kind === "cidr");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get isBase64url() {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return !!this._def.checks.find((ch)=>ch.kind === "base64url");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$a1cda7ed89d79c47$export$1230eb29b8d3b502.create = (params)=>{
    return new $a1cda7ed89d79c47$export$1230eb29b8d3b502({
        checks: [],
        typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodString,
        coerce: params?.coerce ?? false,
        ...$a1cda7ed89d79c47$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $a1cda7ed89d79c47$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = Number.parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = Number.parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / 10 ** decCount;
}
class $a1cda7ed89d79c47$export$5b070a55c0c43e09 extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $9LkVA.ZodParsedType).number) {
            const ctx = this._getOrReturnCtx(input);
            (0, $eO7MR.addIssueToContext)(ctx, {
                code: (0, $jAWE5.ZodIssueCode).invalid_type,
                expected: (0, $9LkVA.ZodParsedType).number,
                received: ctx.parsedType
            });
            return 0, $eO7MR.INVALID;
        }
        let ctx = undefined;
        const status = new (0, $eO7MR.ParseStatus)();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!(0, $9LkVA.util).isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $eO7MR.addIssueToContext)(ctx, {
                        code: (0, $jAWE5.ZodIssueCode).invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $eO7MR.addIssueToContext)(ctx, {
                        code: (0, $jAWE5.ZodIssueCode).too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $eO7MR.addIssueToContext)(ctx, {
                        code: (0, $jAWE5.ZodIssueCode).too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($a1cda7ed89d79c47$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $eO7MR.addIssueToContext)(ctx, {
                        code: (0, $jAWE5.ZodIssueCode).not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $eO7MR.addIssueToContext)(ctx, {
                        code: (0, $jAWE5.ZodIssueCode).not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, $9LkVA.util).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, (0, $2NCkc.errorUtil).toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, (0, $2NCkc.errorUtil).toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, (0, $2NCkc.errorUtil).toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, (0, $2NCkc.errorUtil).toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $a1cda7ed89d79c47$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: (0, $2NCkc.errorUtil).toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $a1cda7ed89d79c47$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: (0, $2NCkc.errorUtil).toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: (0, $2NCkc.errorUtil).toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: (0, $2NCkc.errorUtil).toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: (0, $2NCkc.errorUtil).toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: (0, $2NCkc.errorUtil).toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: (0, $2NCkc.errorUtil).toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: (0, $2NCkc.errorUtil).toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: (0, $2NCkc.errorUtil).toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: (0, $2NCkc.errorUtil).toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && (0, $9LkVA.util).isInteger(ch.value));
    }
    get isFinite() {
        let max = null;
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$a1cda7ed89d79c47$export$5b070a55c0c43e09.create = (params)=>{
    return new $a1cda7ed89d79c47$export$5b070a55c0c43e09({
        checks: [],
        typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodNumber,
        coerce: params?.coerce || false,
        ...$a1cda7ed89d79c47$var$processCreateParams(params)
    });
};
class $a1cda7ed89d79c47$export$67d741fd70ff98f4 extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) try {
            input.data = BigInt(input.data);
        } catch  {
            return this._getInvalidInput(input);
        }
        const parsedType = this._getType(input);
        if (parsedType !== (0, $9LkVA.ZodParsedType).bigint) return this._getInvalidInput(input);
        let ctx = undefined;
        const status = new (0, $eO7MR.ParseStatus)();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $eO7MR.addIssueToContext)(ctx, {
                        code: (0, $jAWE5.ZodIssueCode).too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $eO7MR.addIssueToContext)(ctx, {
                        code: (0, $jAWE5.ZodIssueCode).too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $eO7MR.addIssueToContext)(ctx, {
                        code: (0, $jAWE5.ZodIssueCode).not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, $9LkVA.util).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _getInvalidInput(input) {
        const ctx = this._getOrReturnCtx(input);
        (0, $eO7MR.addIssueToContext)(ctx, {
            code: (0, $jAWE5.ZodIssueCode).invalid_type,
            expected: (0, $9LkVA.ZodParsedType).bigint,
            received: ctx.parsedType
        });
        return 0, $eO7MR.INVALID;
    }
    gte(value, message) {
        return this.setLimit("min", value, true, (0, $2NCkc.errorUtil).toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, (0, $2NCkc.errorUtil).toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, (0, $2NCkc.errorUtil).toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, (0, $2NCkc.errorUtil).toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $a1cda7ed89d79c47$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: (0, $2NCkc.errorUtil).toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $a1cda7ed89d79c47$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: (0, $2NCkc.errorUtil).toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: (0, $2NCkc.errorUtil).toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: (0, $2NCkc.errorUtil).toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: (0, $2NCkc.errorUtil).toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: (0, $2NCkc.errorUtil).toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$a1cda7ed89d79c47$export$67d741fd70ff98f4.create = (params)=>{
    return new $a1cda7ed89d79c47$export$67d741fd70ff98f4({
        checks: [],
        typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodBigInt,
        coerce: params?.coerce ?? false,
        ...$a1cda7ed89d79c47$var$processCreateParams(params)
    });
};
class $a1cda7ed89d79c47$export$723d146f80596191 extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $9LkVA.ZodParsedType).boolean) {
            const ctx = this._getOrReturnCtx(input);
            (0, $eO7MR.addIssueToContext)(ctx, {
                code: (0, $jAWE5.ZodIssueCode).invalid_type,
                expected: (0, $9LkVA.ZodParsedType).boolean,
                received: ctx.parsedType
            });
            return 0, $eO7MR.INVALID;
        }
        return (0, $eO7MR.OK)(input.data);
    }
}
$a1cda7ed89d79c47$export$723d146f80596191.create = (params)=>{
    return new $a1cda7ed89d79c47$export$723d146f80596191({
        typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodBoolean,
        coerce: params?.coerce || false,
        ...$a1cda7ed89d79c47$var$processCreateParams(params)
    });
};
class $a1cda7ed89d79c47$export$e974be33bdc55521 extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $9LkVA.ZodParsedType).date) {
            const ctx = this._getOrReturnCtx(input);
            (0, $eO7MR.addIssueToContext)(ctx, {
                code: (0, $jAWE5.ZodIssueCode).invalid_type,
                expected: (0, $9LkVA.ZodParsedType).date,
                received: ctx.parsedType
            });
            return 0, $eO7MR.INVALID;
        }
        if (Number.isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            (0, $eO7MR.addIssueToContext)(ctx, {
                code: (0, $jAWE5.ZodIssueCode).invalid_date
            });
            return 0, $eO7MR.INVALID;
        }
        const status = new (0, $eO7MR.ParseStatus)();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $eO7MR.addIssueToContext)(ctx, {
                        code: (0, $jAWE5.ZodIssueCode).too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $eO7MR.addIssueToContext)(ctx, {
                        code: (0, $jAWE5.ZodIssueCode).too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else (0, $9LkVA.util).assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $a1cda7ed89d79c47$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: (0, $2NCkc.errorUtil).toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: (0, $2NCkc.errorUtil).toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$a1cda7ed89d79c47$export$e974be33bdc55521.create = (params)=>{
    return new $a1cda7ed89d79c47$export$e974be33bdc55521({
        checks: [],
        coerce: params?.coerce || false,
        typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodDate,
        ...$a1cda7ed89d79c47$var$processCreateParams(params)
    });
};
class $a1cda7ed89d79c47$export$bcc3b40f6b638044 extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $9LkVA.ZodParsedType).symbol) {
            const ctx = this._getOrReturnCtx(input);
            (0, $eO7MR.addIssueToContext)(ctx, {
                code: (0, $jAWE5.ZodIssueCode).invalid_type,
                expected: (0, $9LkVA.ZodParsedType).symbol,
                received: ctx.parsedType
            });
            return 0, $eO7MR.INVALID;
        }
        return (0, $eO7MR.OK)(input.data);
    }
}
$a1cda7ed89d79c47$export$bcc3b40f6b638044.create = (params)=>{
    return new $a1cda7ed89d79c47$export$bcc3b40f6b638044({
        typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodSymbol,
        ...$a1cda7ed89d79c47$var$processCreateParams(params)
    });
};
class $a1cda7ed89d79c47$export$4e780e961c30340d extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $9LkVA.ZodParsedType).undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, $eO7MR.addIssueToContext)(ctx, {
                code: (0, $jAWE5.ZodIssueCode).invalid_type,
                expected: (0, $9LkVA.ZodParsedType).undefined,
                received: ctx.parsedType
            });
            return 0, $eO7MR.INVALID;
        }
        return (0, $eO7MR.OK)(input.data);
    }
}
$a1cda7ed89d79c47$export$4e780e961c30340d.create = (params)=>{
    return new $a1cda7ed89d79c47$export$4e780e961c30340d({
        typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodUndefined,
        ...$a1cda7ed89d79c47$var$processCreateParams(params)
    });
};
class $a1cda7ed89d79c47$export$a96281f914484f2d extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $9LkVA.ZodParsedType).null) {
            const ctx = this._getOrReturnCtx(input);
            (0, $eO7MR.addIssueToContext)(ctx, {
                code: (0, $jAWE5.ZodIssueCode).invalid_type,
                expected: (0, $9LkVA.ZodParsedType).null,
                received: ctx.parsedType
            });
            return 0, $eO7MR.INVALID;
        }
        return (0, $eO7MR.OK)(input.data);
    }
}
$a1cda7ed89d79c47$export$a96281f914484f2d.create = (params)=>{
    return new $a1cda7ed89d79c47$export$a96281f914484f2d({
        typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodNull,
        ...$a1cda7ed89d79c47$var$processCreateParams(params)
    });
};
class $a1cda7ed89d79c47$export$b9d1edb536b4e4eb extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return (0, $eO7MR.OK)(input.data);
    }
}
$a1cda7ed89d79c47$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $a1cda7ed89d79c47$export$b9d1edb536b4e4eb({
        typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodAny,
        ...$a1cda7ed89d79c47$var$processCreateParams(params)
    });
};
class $a1cda7ed89d79c47$export$ef3b1bb1630977ae extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return (0, $eO7MR.OK)(input.data);
    }
}
$a1cda7ed89d79c47$export$ef3b1bb1630977ae.create = (params)=>{
    return new $a1cda7ed89d79c47$export$ef3b1bb1630977ae({
        typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodUnknown,
        ...$a1cda7ed89d79c47$var$processCreateParams(params)
    });
};
class $a1cda7ed89d79c47$export$1e576a20c3ce9fb5 extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        (0, $eO7MR.addIssueToContext)(ctx, {
            code: (0, $jAWE5.ZodIssueCode).invalid_type,
            expected: (0, $9LkVA.ZodParsedType).never,
            received: ctx.parsedType
        });
        return 0, $eO7MR.INVALID;
    }
}
$a1cda7ed89d79c47$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $a1cda7ed89d79c47$export$1e576a20c3ce9fb5({
        typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodNever,
        ...$a1cda7ed89d79c47$var$processCreateParams(params)
    });
};
class $a1cda7ed89d79c47$export$7d39f5df85f21031 extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $9LkVA.ZodParsedType).undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, $eO7MR.addIssueToContext)(ctx, {
                code: (0, $jAWE5.ZodIssueCode).invalid_type,
                expected: (0, $9LkVA.ZodParsedType).void,
                received: ctx.parsedType
            });
            return 0, $eO7MR.INVALID;
        }
        return (0, $eO7MR.OK)(input.data);
    }
}
$a1cda7ed89d79c47$export$7d39f5df85f21031.create = (params)=>{
    return new $a1cda7ed89d79c47$export$7d39f5df85f21031({
        typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodVoid,
        ...$a1cda7ed89d79c47$var$processCreateParams(params)
    });
};
class $a1cda7ed89d79c47$export$7acfc3e64785411 extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== (0, $9LkVA.ZodParsedType).array) {
            (0, $eO7MR.addIssueToContext)(ctx, {
                code: (0, $jAWE5.ZodIssueCode).invalid_type,
                expected: (0, $9LkVA.ZodParsedType).array,
                received: ctx.parsedType
            });
            return 0, $eO7MR.INVALID;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                (0, $eO7MR.addIssueToContext)(ctx, {
                    code: tooBig ? (0, $jAWE5.ZodIssueCode).too_big : (0, $jAWE5.ZodIssueCode).too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                (0, $eO7MR.addIssueToContext)(ctx, {
                    code: (0, $jAWE5.ZodIssueCode).too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                (0, $eO7MR.addIssueToContext)(ctx, {
                    code: (0, $jAWE5.ZodIssueCode).too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $a1cda7ed89d79c47$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return (0, $eO7MR.ParseStatus).mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $a1cda7ed89d79c47$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return (0, $eO7MR.ParseStatus).mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $a1cda7ed89d79c47$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: (0, $2NCkc.errorUtil).toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $a1cda7ed89d79c47$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: (0, $2NCkc.errorUtil).toString(message)
            }
        });
    }
    length(len, message) {
        return new $a1cda7ed89d79c47$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: (0, $2NCkc.errorUtil).toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$a1cda7ed89d79c47$export$7acfc3e64785411.create = (schema, params)=>{
    return new $a1cda7ed89d79c47$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodArray,
        ...$a1cda7ed89d79c47$var$processCreateParams(params)
    });
};
function $a1cda7ed89d79c47$var$deepPartialify(schema) {
    if (schema instanceof $a1cda7ed89d79c47$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $a1cda7ed89d79c47$export$aa56fec1e9d629b8.create($a1cda7ed89d79c47$var$deepPartialify(fieldSchema));
        }
        return new $a1cda7ed89d79c47$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $a1cda7ed89d79c47$export$7acfc3e64785411) return new $a1cda7ed89d79c47$export$7acfc3e64785411({
        ...schema._def,
        type: $a1cda7ed89d79c47$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $a1cda7ed89d79c47$export$aa56fec1e9d629b8) return $a1cda7ed89d79c47$export$aa56fec1e9d629b8.create($a1cda7ed89d79c47$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $a1cda7ed89d79c47$export$aaac0b8b429cef5) return $a1cda7ed89d79c47$export$aaac0b8b429cef5.create($a1cda7ed89d79c47$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $a1cda7ed89d79c47$export$e2a18bb771d8e6a3) return $a1cda7ed89d79c47$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$a1cda7ed89d79c47$var$deepPartialify(item)));
    else return schema;
}
class $a1cda7ed89d79c47$export$736315c5b55efbad extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = (0, $9LkVA.util).objectKeys(shape);
        this._cached = {
            shape: shape,
            keys: keys
        };
        return this._cached;
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $9LkVA.ZodParsedType).object) {
            const ctx = this._getOrReturnCtx(input);
            (0, $eO7MR.addIssueToContext)(ctx, {
                code: (0, $jAWE5.ZodIssueCode).invalid_type,
                expected: (0, $9LkVA.ZodParsedType).object,
                received: ctx.parsedType
            });
            return 0, $eO7MR.INVALID;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $a1cda7ed89d79c47$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $a1cda7ed89d79c47$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $a1cda7ed89d79c47$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    (0, $eO7MR.addIssueToContext)(ctx, {
                        code: (0, $jAWE5.ZodIssueCode).unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $a1cda7ed89d79c47$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key: key,
                    value: value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return (0, $eO7MR.ParseStatus).mergeObjectSync(status, syncPairs);
        });
        else return (0, $eO7MR.ParseStatus).mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        (0, $2NCkc.errorUtil).errToObj;
        return new $a1cda7ed89d79c47$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    const defaultError = this._def.errorMap?.(issue, ctx).message ?? ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (0, $2NCkc.errorUtil).errToObj(message).message ?? defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $a1cda7ed89d79c47$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $a1cda7ed89d79c47$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $a1cda7ed89d79c47$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $a1cda7ed89d79c47$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $a1cda7ed89d79c47$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        for (const key of (0, $9LkVA.util).objectKeys(mask))if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        return new $a1cda7ed89d79c47$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        for (const key of (0, $9LkVA.util).objectKeys(this.shape))if (!mask[key]) shape[key] = this.shape[key];
        return new $a1cda7ed89d79c47$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $a1cda7ed89d79c47$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        for (const key of (0, $9LkVA.util).objectKeys(this.shape)){
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        }
        return new $a1cda7ed89d79c47$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        for (const key of (0, $9LkVA.util).objectKeys(this.shape))if (mask && !mask[key]) newShape[key] = this.shape[key];
        else {
            const fieldSchema = this.shape[key];
            let newField = fieldSchema;
            while(newField instanceof $a1cda7ed89d79c47$export$aa56fec1e9d629b8)newField = newField._def.innerType;
            newShape[key] = newField;
        }
        return new $a1cda7ed89d79c47$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $a1cda7ed89d79c47$var$createZodEnum((0, $9LkVA.util).objectKeys(this.shape));
    }
}
$a1cda7ed89d79c47$export$736315c5b55efbad.create = (shape, params)=>{
    return new $a1cda7ed89d79c47$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $a1cda7ed89d79c47$export$1e576a20c3ce9fb5.create(),
        typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodObject,
        ...$a1cda7ed89d79c47$var$processCreateParams(params)
    });
};
$a1cda7ed89d79c47$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $a1cda7ed89d79c47$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $a1cda7ed89d79c47$export$1e576a20c3ce9fb5.create(),
        typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodObject,
        ...$a1cda7ed89d79c47$var$processCreateParams(params)
    });
};
$a1cda7ed89d79c47$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $a1cda7ed89d79c47$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $a1cda7ed89d79c47$export$1e576a20c3ce9fb5.create(),
        typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodObject,
        ...$a1cda7ed89d79c47$var$processCreateParams(params)
    });
};
class $a1cda7ed89d79c47$export$a8b236cb5070a311 extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new (0, $jAWE5.ZodError)(result.ctx.common.issues));
            (0, $eO7MR.addIssueToContext)(ctx, {
                code: (0, $jAWE5.ZodIssueCode).invalid_union,
                unionErrors: unionErrors
            });
            return 0, $eO7MR.INVALID;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new (0, $jAWE5.ZodError)(issues));
            (0, $eO7MR.addIssueToContext)(ctx, {
                code: (0, $jAWE5.ZodIssueCode).invalid_union,
                unionErrors: unionErrors
            });
            return 0, $eO7MR.INVALID;
        }
    }
    get options() {
        return this._def.options;
    }
}
$a1cda7ed89d79c47$export$a8b236cb5070a311.create = (types, params)=>{
    return new $a1cda7ed89d79c47$export$a8b236cb5070a311({
        options: types,
        typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodUnion,
        ...$a1cda7ed89d79c47$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $a1cda7ed89d79c47$var$getDiscriminator = (type)=>{
    if (type instanceof $a1cda7ed89d79c47$export$378d0cfce37406e6) return $a1cda7ed89d79c47$var$getDiscriminator(type.schema);
    else if (type instanceof $a1cda7ed89d79c47$export$a60af00cc0ce2582) return $a1cda7ed89d79c47$var$getDiscriminator(type.innerType());
    else if (type instanceof $a1cda7ed89d79c47$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $a1cda7ed89d79c47$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $a1cda7ed89d79c47$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return (0, $9LkVA.util).objectValues(type.enum);
    else if (type instanceof $a1cda7ed89d79c47$export$bb19b37874861e7e) return $a1cda7ed89d79c47$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $a1cda7ed89d79c47$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $a1cda7ed89d79c47$export$a96281f914484f2d) return [
        null
    ];
    else if (type instanceof $a1cda7ed89d79c47$export$aa56fec1e9d629b8) return [
        undefined,
        ...$a1cda7ed89d79c47$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $a1cda7ed89d79c47$export$aaac0b8b429cef5) return [
        null,
        ...$a1cda7ed89d79c47$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $a1cda7ed89d79c47$export$66b0c798a395271f) return $a1cda7ed89d79c47$var$getDiscriminator(type.unwrap());
    else if (type instanceof $a1cda7ed89d79c47$export$5d1f7ef05c4e493a) return $a1cda7ed89d79c47$var$getDiscriminator(type.unwrap());
    else if (type instanceof $a1cda7ed89d79c47$export$75a44ec6249ac76b) return $a1cda7ed89d79c47$var$getDiscriminator(type._def.innerType);
    else return [];
};
class $a1cda7ed89d79c47$export$5ef2424805ac76a3 extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $9LkVA.ZodParsedType).object) {
            (0, $eO7MR.addIssueToContext)(ctx, {
                code: (0, $jAWE5.ZodIssueCode).invalid_type,
                expected: (0, $9LkVA.ZodParsedType).object,
                received: ctx.parsedType
            });
            return 0, $eO7MR.INVALID;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            (0, $eO7MR.addIssueToContext)(ctx, {
                code: (0, $jAWE5.ZodIssueCode).invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return 0, $eO7MR.INVALID;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $a1cda7ed89d79c47$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $a1cda7ed89d79c47$export$5ef2424805ac76a3({
            typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$a1cda7ed89d79c47$var$processCreateParams(params)
        });
    }
}
function $a1cda7ed89d79c47$var$mergeValues(a, b) {
    const aType = (0, $9LkVA.getParsedType)(a);
    const bType = (0, $9LkVA.getParsedType)(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === (0, $9LkVA.ZodParsedType).object && bType === (0, $9LkVA.ZodParsedType).object) {
        const bKeys = (0, $9LkVA.util).objectKeys(b);
        const sharedKeys = (0, $9LkVA.util).objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $a1cda7ed89d79c47$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === (0, $9LkVA.ZodParsedType).array && bType === (0, $9LkVA.ZodParsedType).array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $a1cda7ed89d79c47$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === (0, $9LkVA.ZodParsedType).date && bType === (0, $9LkVA.ZodParsedType).date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $a1cda7ed89d79c47$export$c02deaf0bb5203d4 extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ((0, $eO7MR.isAborted)(parsedLeft) || (0, $eO7MR.isAborted)(parsedRight)) return 0, $eO7MR.INVALID;
            const merged = $a1cda7ed89d79c47$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                (0, $eO7MR.addIssueToContext)(ctx, {
                    code: (0, $jAWE5.ZodIssueCode).invalid_intersection_types
                });
                return 0, $eO7MR.INVALID;
            }
            if ((0, $eO7MR.isDirty)(parsedLeft) || (0, $eO7MR.isDirty)(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$a1cda7ed89d79c47$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $a1cda7ed89d79c47$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodIntersection,
        ...$a1cda7ed89d79c47$var$processCreateParams(params)
    });
};
class $a1cda7ed89d79c47$export$e2a18bb771d8e6a3 extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $9LkVA.ZodParsedType).array) {
            (0, $eO7MR.addIssueToContext)(ctx, {
                code: (0, $jAWE5.ZodIssueCode).invalid_type,
                expected: (0, $9LkVA.ZodParsedType).array,
                received: ctx.parsedType
            });
            return 0, $eO7MR.INVALID;
        }
        if (ctx.data.length < this._def.items.length) {
            (0, $eO7MR.addIssueToContext)(ctx, {
                code: (0, $jAWE5.ZodIssueCode).too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return 0, $eO7MR.INVALID;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            (0, $eO7MR.addIssueToContext)(ctx, {
                code: (0, $jAWE5.ZodIssueCode).too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $a1cda7ed89d79c47$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return (0, $eO7MR.ParseStatus).mergeArray(status, results);
        });
        else return (0, $eO7MR.ParseStatus).mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $a1cda7ed89d79c47$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$a1cda7ed89d79c47$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $a1cda7ed89d79c47$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$a1cda7ed89d79c47$var$processCreateParams(params)
    });
};
class $a1cda7ed89d79c47$export$a2acc09968cb4b7f extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $9LkVA.ZodParsedType).object) {
            (0, $eO7MR.addIssueToContext)(ctx, {
                code: (0, $jAWE5.ZodIssueCode).invalid_type,
                expected: (0, $9LkVA.ZodParsedType).object,
                received: ctx.parsedType
            });
            return 0, $eO7MR.INVALID;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $a1cda7ed89d79c47$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $a1cda7ed89d79c47$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return (0, $eO7MR.ParseStatus).mergeObjectAsync(status, pairs);
        else return (0, $eO7MR.ParseStatus).mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $a1cda7ed89d79c47$export$2afb8ab49d4b92c0) return new $a1cda7ed89d79c47$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodRecord,
            ...$a1cda7ed89d79c47$var$processCreateParams(third)
        });
        return new $a1cda7ed89d79c47$export$a2acc09968cb4b7f({
            keyType: $a1cda7ed89d79c47$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodRecord,
            ...$a1cda7ed89d79c47$var$processCreateParams(second)
        });
    }
}
class $a1cda7ed89d79c47$export$163b6a2b712d9542 extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $9LkVA.ZodParsedType).map) {
            (0, $eO7MR.addIssueToContext)(ctx, {
                code: (0, $jAWE5.ZodIssueCode).invalid_type,
                expected: (0, $9LkVA.ZodParsedType).map,
                received: ctx.parsedType
            });
            return 0, $eO7MR.INVALID;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $a1cda7ed89d79c47$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $a1cda7ed89d79c47$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return 0, $eO7MR.INVALID;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return 0, $eO7MR.INVALID;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$a1cda7ed89d79c47$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $a1cda7ed89d79c47$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodMap,
        ...$a1cda7ed89d79c47$var$processCreateParams(params)
    });
};
class $a1cda7ed89d79c47$export$977057706f816712 extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $9LkVA.ZodParsedType).set) {
            (0, $eO7MR.addIssueToContext)(ctx, {
                code: (0, $jAWE5.ZodIssueCode).invalid_type,
                expected: (0, $9LkVA.ZodParsedType).set,
                received: ctx.parsedType
            });
            return 0, $eO7MR.INVALID;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                (0, $eO7MR.addIssueToContext)(ctx, {
                    code: (0, $jAWE5.ZodIssueCode).too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                (0, $eO7MR.addIssueToContext)(ctx, {
                    code: (0, $jAWE5.ZodIssueCode).too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return 0, $eO7MR.INVALID;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $a1cda7ed89d79c47$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $a1cda7ed89d79c47$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: (0, $2NCkc.errorUtil).toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $a1cda7ed89d79c47$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: (0, $2NCkc.errorUtil).toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$a1cda7ed89d79c47$export$977057706f816712.create = (valueType, params)=>{
    return new $a1cda7ed89d79c47$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodSet,
        ...$a1cda7ed89d79c47$var$processCreateParams(params)
    });
};
class $a1cda7ed89d79c47$export$d4602ba55673f53c extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $9LkVA.ZodParsedType).function) {
            (0, $eO7MR.addIssueToContext)(ctx, {
                code: (0, $jAWE5.ZodIssueCode).invalid_type,
                expected: (0, $9LkVA.ZodParsedType).function,
                received: ctx.parsedType
            });
            return 0, $eO7MR.INVALID;
        }
        function makeArgsIssue(args, error) {
            return (0, $eO7MR.makeIssue)({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, $kKULo.getErrorMap)(),
                    (0, $b42gj.default)
                ].filter((x)=>!!x),
                issueData: {
                    code: (0, $jAWE5.ZodIssueCode).invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return (0, $eO7MR.makeIssue)({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, $kKULo.getErrorMap)(),
                    (0, $b42gj.default)
                ].filter((x)=>!!x),
                issueData: {
                    code: (0, $jAWE5.ZodIssueCode).invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $a1cda7ed89d79c47$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, $eO7MR.OK)(async function(...args) {
                const error = new (0, $jAWE5.ZodError)([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, $eO7MR.OK)(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new (0, $jAWE5.ZodError)([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new (0, $jAWE5.ZodError)([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $a1cda7ed89d79c47$export$d4602ba55673f53c({
            ...this._def,
            args: $a1cda7ed89d79c47$export$e2a18bb771d8e6a3.create(items).rest($a1cda7ed89d79c47$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $a1cda7ed89d79c47$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $a1cda7ed89d79c47$export$d4602ba55673f53c({
            args: args ? args : $a1cda7ed89d79c47$export$e2a18bb771d8e6a3.create([]).rest($a1cda7ed89d79c47$export$ef3b1bb1630977ae.create()),
            returns: returns || $a1cda7ed89d79c47$export$ef3b1bb1630977ae.create(),
            typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodFunction,
            ...$a1cda7ed89d79c47$var$processCreateParams(params)
        });
    }
}
class $a1cda7ed89d79c47$export$378d0cfce37406e6 extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$a1cda7ed89d79c47$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $a1cda7ed89d79c47$export$378d0cfce37406e6({
        getter: getter,
        typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodLazy,
        ...$a1cda7ed89d79c47$var$processCreateParams(params)
    });
};
class $a1cda7ed89d79c47$export$7e44096782a165d3 extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            (0, $eO7MR.addIssueToContext)(ctx, {
                received: ctx.data,
                code: (0, $jAWE5.ZodIssueCode).invalid_literal,
                expected: this._def.value
            });
            return 0, $eO7MR.INVALID;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$a1cda7ed89d79c47$export$7e44096782a165d3.create = (value, params)=>{
    return new $a1cda7ed89d79c47$export$7e44096782a165d3({
        value: value,
        typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodLiteral,
        ...$a1cda7ed89d79c47$var$processCreateParams(params)
    });
};
function $a1cda7ed89d79c47$var$createZodEnum(values, params) {
    return new $a1cda7ed89d79c47$export$d325d1f0e1c20179({
        values: values,
        typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodEnum,
        ...$a1cda7ed89d79c47$var$processCreateParams(params)
    });
}
class $a1cda7ed89d79c47$export$d325d1f0e1c20179 extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, $eO7MR.addIssueToContext)(ctx, {
                expected: (0, $9LkVA.util).joinValues(expectedValues),
                received: ctx.parsedType,
                code: (0, $jAWE5.ZodIssueCode).invalid_type
            });
            return 0, $eO7MR.INVALID;
        }
        if (!this._cache) this._cache = new Set(this._def.values);
        if (!this._cache.has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, $eO7MR.addIssueToContext)(ctx, {
                received: ctx.data,
                code: (0, $jAWE5.ZodIssueCode).invalid_enum_value,
                options: expectedValues
            });
            return 0, $eO7MR.INVALID;
        }
        return (0, $eO7MR.OK)(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return $a1cda7ed89d79c47$export$d325d1f0e1c20179.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return $a1cda7ed89d79c47$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
}
$a1cda7ed89d79c47$export$d325d1f0e1c20179.create = $a1cda7ed89d79c47$var$createZodEnum;
class $a1cda7ed89d79c47$export$370b2e8d6d6f5c56 extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const nativeEnumValues = (0, $9LkVA.util).getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== (0, $9LkVA.ZodParsedType).string && ctx.parsedType !== (0, $9LkVA.ZodParsedType).number) {
            const expectedValues = (0, $9LkVA.util).objectValues(nativeEnumValues);
            (0, $eO7MR.addIssueToContext)(ctx, {
                expected: (0, $9LkVA.util).joinValues(expectedValues),
                received: ctx.parsedType,
                code: (0, $jAWE5.ZodIssueCode).invalid_type
            });
            return 0, $eO7MR.INVALID;
        }
        if (!this._cache) this._cache = new Set((0, $9LkVA.util).getValidEnumValues(this._def.values));
        if (!this._cache.has(input.data)) {
            const expectedValues = (0, $9LkVA.util).objectValues(nativeEnumValues);
            (0, $eO7MR.addIssueToContext)(ctx, {
                received: ctx.data,
                code: (0, $jAWE5.ZodIssueCode).invalid_enum_value,
                options: expectedValues
            });
            return 0, $eO7MR.INVALID;
        }
        return (0, $eO7MR.OK)(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$a1cda7ed89d79c47$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $a1cda7ed89d79c47$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodNativeEnum,
        ...$a1cda7ed89d79c47$var$processCreateParams(params)
    });
};
class $a1cda7ed89d79c47$export$3f196b0127d6e50a extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $9LkVA.ZodParsedType).promise && ctx.common.async === false) {
            (0, $eO7MR.addIssueToContext)(ctx, {
                code: (0, $jAWE5.ZodIssueCode).invalid_type,
                expected: (0, $9LkVA.ZodParsedType).promise,
                received: ctx.parsedType
            });
            return 0, $eO7MR.INVALID;
        }
        const promisified = ctx.parsedType === (0, $9LkVA.ZodParsedType).promise ? ctx.data : Promise.resolve(ctx.data);
        return (0, $eO7MR.OK)(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$a1cda7ed89d79c47$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $a1cda7ed89d79c47$export$3f196b0127d6e50a({
        type: schema,
        typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodPromise,
        ...$a1cda7ed89d79c47$var$processCreateParams(params)
    });
};
class $a1cda7ed89d79c47$export$a60af00cc0ce2582 extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $a1cda7ed89d79c47$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                (0, $eO7MR.addIssueToContext)(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return 0, $eO7MR.INVALID;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return 0, $eO7MR.INVALID;
                if (result.status === "dirty") return (0, $eO7MR.DIRTY)(result.value);
                if (status.value === "dirty") return (0, $eO7MR.DIRTY)(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return 0, $eO7MR.INVALID;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return 0, $eO7MR.INVALID;
                if (result.status === "dirty") return (0, $eO7MR.DIRTY)(result.value);
                if (status.value === "dirty") return (0, $eO7MR.DIRTY)(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return 0, $eO7MR.INVALID;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return 0, $eO7MR.INVALID;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!(0, $eO7MR.isValid)(base)) return 0, $eO7MR.INVALID;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!(0, $eO7MR.isValid)(base)) return 0, $eO7MR.INVALID;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        (0, $9LkVA.util).assertNever(effect);
    }
}
$a1cda7ed89d79c47$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $a1cda7ed89d79c47$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$a1cda7ed89d79c47$var$processCreateParams(params)
    });
};
$a1cda7ed89d79c47$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $a1cda7ed89d79c47$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodEffects,
        ...$a1cda7ed89d79c47$var$processCreateParams(params)
    });
};
class $a1cda7ed89d79c47$export$aa56fec1e9d629b8 extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === (0, $9LkVA.ZodParsedType).undefined) return (0, $eO7MR.OK)(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$a1cda7ed89d79c47$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $a1cda7ed89d79c47$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodOptional,
        ...$a1cda7ed89d79c47$var$processCreateParams(params)
    });
};
class $a1cda7ed89d79c47$export$aaac0b8b429cef5 extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === (0, $9LkVA.ZodParsedType).null) return (0, $eO7MR.OK)(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$a1cda7ed89d79c47$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $a1cda7ed89d79c47$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodNullable,
        ...$a1cda7ed89d79c47$var$processCreateParams(params)
    });
};
class $a1cda7ed89d79c47$export$bb19b37874861e7e extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === (0, $9LkVA.ZodParsedType).undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$a1cda7ed89d79c47$export$bb19b37874861e7e.create = (type, params)=>{
    return new $a1cda7ed89d79c47$export$bb19b37874861e7e({
        innerType: type,
        typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$a1cda7ed89d79c47$var$processCreateParams(params)
    });
};
class $a1cda7ed89d79c47$export$75a44ec6249ac76b extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ((0, $eO7MR.isAsync)(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new (0, $jAWE5.ZodError)(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new (0, $jAWE5.ZodError)(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$a1cda7ed89d79c47$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $a1cda7ed89d79c47$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$a1cda7ed89d79c47$var$processCreateParams(params)
    });
};
class $a1cda7ed89d79c47$export$26ccfa0145e8511f extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $9LkVA.ZodParsedType).nan) {
            const ctx = this._getOrReturnCtx(input);
            (0, $eO7MR.addIssueToContext)(ctx, {
                code: (0, $jAWE5.ZodIssueCode).invalid_type,
                expected: (0, $9LkVA.ZodParsedType).nan,
                received: ctx.parsedType
            });
            return 0, $eO7MR.INVALID;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$a1cda7ed89d79c47$export$26ccfa0145e8511f.create = (params)=>{
    return new $a1cda7ed89d79c47$export$26ccfa0145e8511f({
        typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodNaN,
        ...$a1cda7ed89d79c47$var$processCreateParams(params)
    });
};
const $a1cda7ed89d79c47$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $a1cda7ed89d79c47$export$66b0c798a395271f extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $a1cda7ed89d79c47$export$a3c3ef8a0e95c6da extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return 0, $eO7MR.INVALID;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return (0, $eO7MR.DIRTY)(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return 0, $eO7MR.INVALID;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $a1cda7ed89d79c47$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $a1cda7ed89d79c47$export$5d1f7ef05c4e493a extends $a1cda7ed89d79c47$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ((0, $eO7MR.isValid)(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return (0, $eO7MR.isAsync)(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$a1cda7ed89d79c47$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $a1cda7ed89d79c47$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $a1cda7ed89d79c47$export$558106ce543bd011.ZodReadonly,
        ...$a1cda7ed89d79c47$var$processCreateParams(params)
    });
};
////////////////////////////////////////
////////////////////////////////////////
//////////                    //////////
//////////      z.custom      //////////
//////////                    //////////
////////////////////////////////////////
////////////////////////////////////////
function $a1cda7ed89d79c47$var$cleanParams(params, data) {
    const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
        message: params
    } : params;
    const p2 = typeof p === "string" ? {
        message: p
    } : p;
    return p2;
}
function $a1cda7ed89d79c47$export$4c00f665f0d4b443(check, _params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return $a1cda7ed89d79c47$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        const r = check(data);
        if (r instanceof Promise) return r.then((r)=>{
            if (!r) {
                const params = $a1cda7ed89d79c47$var$cleanParams(_params, data);
                const _fatal = params.fatal ?? fatal ?? true;
                ctx.addIssue({
                    code: "custom",
                    ...params,
                    fatal: _fatal
                });
            }
        });
        if (!r) {
            const params = $a1cda7ed89d79c47$var$cleanParams(_params, data);
            const _fatal = params.fatal ?? fatal ?? true;
            ctx.addIssue({
                code: "custom",
                ...params,
                fatal: _fatal
            });
        }
        return;
    });
    return $a1cda7ed89d79c47$export$b9d1edb536b4e4eb.create();
}
const $a1cda7ed89d79c47$export$1ee8ee30835eab8b = {
    object: $a1cda7ed89d79c47$export$736315c5b55efbad.lazycreate
};
var $a1cda7ed89d79c47$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($a1cda7ed89d79c47$export$558106ce543bd011 || ($a1cda7ed89d79c47$export$558106ce543bd011 = {}));
// requires TS 4.4+
class $a1cda7ed89d79c47$var$Class {
    constructor(..._){}
}
const $a1cda7ed89d79c47$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$a1cda7ed89d79c47$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $a1cda7ed89d79c47$export$22b082955e083ec3 = $a1cda7ed89d79c47$export$1230eb29b8d3b502.create;
const $a1cda7ed89d79c47$export$98e628dec113755e = $a1cda7ed89d79c47$export$5b070a55c0c43e09.create;
const $a1cda7ed89d79c47$export$9e06de0973666692 = $a1cda7ed89d79c47$export$26ccfa0145e8511f.create;
const $a1cda7ed89d79c47$export$a0f65b52274bcc00 = $a1cda7ed89d79c47$export$67d741fd70ff98f4.create;
const $a1cda7ed89d79c47$export$4a21f16c33752377 = $a1cda7ed89d79c47$export$723d146f80596191.create;
const $a1cda7ed89d79c47$export$324d90190a8b822a = $a1cda7ed89d79c47$export$e974be33bdc55521.create;
const $a1cda7ed89d79c47$export$8f701197936bc2a6 = $a1cda7ed89d79c47$export$bcc3b40f6b638044.create;
const $a1cda7ed89d79c47$export$1db45310990710a5 = $a1cda7ed89d79c47$export$4e780e961c30340d.create;
const $a1cda7ed89d79c47$export$7b1b591b262c240 = $a1cda7ed89d79c47$export$a96281f914484f2d.create;
const $a1cda7ed89d79c47$export$4154a199d7d90455 = $a1cda7ed89d79c47$export$b9d1edb536b4e4eb.create;
const $a1cda7ed89d79c47$export$19282c40b967aec6 = $a1cda7ed89d79c47$export$ef3b1bb1630977ae.create;
const $a1cda7ed89d79c47$export$b3e22bcfd64c1022 = $a1cda7ed89d79c47$export$1e576a20c3ce9fb5.create;
const $a1cda7ed89d79c47$export$490e536ee7389aeb = $a1cda7ed89d79c47$export$7d39f5df85f21031.create;
const $a1cda7ed89d79c47$export$2f23118c22fb2630 = $a1cda7ed89d79c47$export$7acfc3e64785411.create;
const $a1cda7ed89d79c47$export$be5493f9613cbbe = $a1cda7ed89d79c47$export$736315c5b55efbad.create;
const $a1cda7ed89d79c47$export$8fb0df5f40d0b477 = $a1cda7ed89d79c47$export$736315c5b55efbad.strictCreate;
const $a1cda7ed89d79c47$export$971dd5b0dfd021b6 = $a1cda7ed89d79c47$export$a8b236cb5070a311.create;
const $a1cda7ed89d79c47$export$4b888e40c4ee26dd = $a1cda7ed89d79c47$export$5ef2424805ac76a3.create;
const $a1cda7ed89d79c47$export$bc86dfbf7795668c = $a1cda7ed89d79c47$export$c02deaf0bb5203d4.create;
const $a1cda7ed89d79c47$export$65e3907585753458 = $a1cda7ed89d79c47$export$e2a18bb771d8e6a3.create;
const $a1cda7ed89d79c47$export$e5185e241753e543 = $a1cda7ed89d79c47$export$a2acc09968cb4b7f.create;
const $a1cda7ed89d79c47$export$871de8747c9eaa88 = $a1cda7ed89d79c47$export$163b6a2b712d9542.create;
const $a1cda7ed89d79c47$export$adaa4cf7ef1b65be = $a1cda7ed89d79c47$export$977057706f816712.create;
const $a1cda7ed89d79c47$export$44e51c8aac7c2deb = $a1cda7ed89d79c47$export$d4602ba55673f53c.create;
const $a1cda7ed89d79c47$export$488013bae63b21da = $a1cda7ed89d79c47$export$378d0cfce37406e6.create;
const $a1cda7ed89d79c47$export$c8ec6e1ec9fefcb0 = $a1cda7ed89d79c47$export$7e44096782a165d3.create;
const $a1cda7ed89d79c47$export$78a99c8d44d72635 = $a1cda7ed89d79c47$export$d325d1f0e1c20179.create;
const $a1cda7ed89d79c47$export$6fe7eca19ebe5199 = $a1cda7ed89d79c47$export$370b2e8d6d6f5c56.create;
const $a1cda7ed89d79c47$export$c957ef27a0ebfd4 = $a1cda7ed89d79c47$export$3f196b0127d6e50a.create;
const $a1cda7ed89d79c47$export$dc573d8a6576cdb3 = $a1cda7ed89d79c47$export$a60af00cc0ce2582.create;
const $a1cda7ed89d79c47$export$516e28dec6a4b6d4 = $a1cda7ed89d79c47$export$aa56fec1e9d629b8.create;
const $a1cda7ed89d79c47$export$133fc36489ac9add = $a1cda7ed89d79c47$export$aaac0b8b429cef5.create;
const $a1cda7ed89d79c47$export$fc37fe19dfda43ee = $a1cda7ed89d79c47$export$a60af00cc0ce2582.createWithPreprocess;
const $a1cda7ed89d79c47$export$43f28b24e1eb8181 = $a1cda7ed89d79c47$export$a3c3ef8a0e95c6da.create;
const $a1cda7ed89d79c47$export$3b3d07727c5b702c = ()=>$a1cda7ed89d79c47$export$22b082955e083ec3().optional();
const $a1cda7ed89d79c47$export$eb150471a61fced6 = ()=>$a1cda7ed89d79c47$export$98e628dec113755e().optional();
const $a1cda7ed89d79c47$export$269251733cdcbbf1 = ()=>$a1cda7ed89d79c47$export$4a21f16c33752377().optional();
const $a1cda7ed89d79c47$export$8c14e57e778d3873 = {
    string: (arg)=>$a1cda7ed89d79c47$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$a1cda7ed89d79c47$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$a1cda7ed89d79c47$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$a1cda7ed89d79c47$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$a1cda7ed89d79c47$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $a1cda7ed89d79c47$export$96c94437c95d7862 = (0, $eO7MR.INVALID);

});
parcelRegister("2NCkc", function(module, exports) {
$parcel$export(module.exports, "errorUtil", () => $209de2dbfc54af33$export$b9faa7f0c32cb80d);
var $209de2dbfc54af33$export$b9faa7f0c32cb80d;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    // biome-ignore lint:
    errorUtil.toString = (message)=>typeof message === "string" ? message : message?.message;
})($209de2dbfc54af33$export$b9faa7f0c32cb80d || ($209de2dbfc54af33$export$b9faa7f0c32cb80d = {}));

});








parcelRegister("kLtNc", function(module, exports) {
"use strict";
var $f1df4e97ad8d7707$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f1df4e97ad8d7707$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f1df4e97ad8d7707$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f1df4e97ad8d7707$var$__exportStar((parcelRequire("5V5dT")), module.exports);

});
parcelRegister("5V5dT", function(module, exports) {
"use strict";
var $44f653ce07e4c7dc$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $44f653ce07e4c7dc$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $44f653ce07e4c7dc$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$44f653ce07e4c7dc$var$__exportStar((parcelRequire("bxm6o")), module.exports);

});
parcelRegister("bxm6o", function(module, exports) {
"use strict";
var $8663ebd04e44309f$var$__assign = module.exports && module.exports.__assign || function() {
    $8663ebd04e44309f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8663ebd04e44309f$var$__assign.apply(this, arguments);
};
var $8663ebd04e44309f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8663ebd04e44309f$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createIframeBridge = void 0;

var $1FqvY = parcelRequire("1FqvY");

var $2UTCi = parcelRequire("2UTCi");
var $8663ebd04e44309f$var$setupMessageListeners = function(window, domain, listeners) {
    return Object.entries(listeners).map(function(_a) {
        var eventKey = _a[0], eventHandler = _a[1];
        return (0, $1FqvY.on)(eventKey, {
            window: window,
            domain: domain
        }, function(event) {
            if (eventHandler && event.origin === domain) return eventHandler(event);
        });
    });
};
var $8663ebd04e44309f$var$createIframeBridge = function(options) {
    if (!options.withWindow) throw new Error('Target window to setup the bridge with is not defined');
    var bridge = {
        open: function() {
            var withWindow = options.withWindow, withDomain = options.withDomain, features = options.features, theme = options.theme, surfaceColor = options.surfaceColor, sendHandshakeMetric = options.sendHandshakeMetric, metadata = options.metadata;
            var listeners = $8663ebd04e44309f$var$setupMessageListeners(withWindow, withDomain, features);
            // We only listen for the READY_EVENT fired from the iframe to support hot-reloading via
            // the tunnel. Without this code the hot-reloading would not work. However we do not need
            // to send success / failure analytics as this is only relied upon during development and
            // not in production
            var cancelReadyHandler = (0, $1FqvY.on)($2UTCi.READY_EVENT, {
                window: withWindow,
                domain: withDomain
            }, function() {
                return $8663ebd04e44309f$var$__awaiter(void 0, void 0, void 0, function() {
                    return $8663ebd04e44309f$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            true
                        ];
                    });
                });
            }).cancel;
            // This is the main READY_EVENT that we rely on in production to establish the bridge
            // We send an analytics event to indicate whether this handshake procedure was successful
            // or not and this is how we measure the reliability of the bridge. If an error argument
            // is not sent then the handshake was successful, when we send the caught error it was not
            (0, $1FqvY.send)(withWindow, $2UTCi.READY_EVENT, $8663ebd04e44309f$var$__assign({
                theme: theme,
                surfaceColor: surfaceColor
            }, options.metadata || {}), {
                timeout: $2UTCi.BRIDGE_HANDSHAKE_TIMEOUT_MS
            }).then(function() {
                sendHandshakeMetric(true);
            }).catch(function(error) {
                sendHandshakeMetric(false, error);
                return (0, $2UTCi.handleMissingHandlerError)(error);
            });
            return {
                enableTheming: function() {
                    (0, $1FqvY.send)(withWindow, $2UTCi.THEME_ENABLE_EVENT).catch($2UTCi.handleMissingHandlerError);
                },
                setTheme: function(theme, surfaceColor, env) {
                    (0, $1FqvY.send)(withWindow, $2UTCi.THEME_CHANGE_EVENT, {
                        theme: theme,
                        surfaceColor: surfaceColor,
                        env: env,
                        isFedRamp: metadata.isFedRamp
                    }).catch($2UTCi.handleMissingHandlerError);
                },
                close: function() {
                    cancelReadyHandler();
                    listeners.forEach(function(_a) {
                        var cancel = _a.cancel;
                        return cancel();
                    });
                }
            };
        }
    };
    return bridge;
};
module.exports.createIframeBridge = $8663ebd04e44309f$var$createIframeBridge;

});
parcelRegister("1FqvY", function(module, exports) {
/* @flow */ // $FlowFixMe

module.exports = (parcelRequire("ioYYx")); // eslint-disable-line import/no-commonjs
// $FlowFixMe
module.exports.default = module.exports; // eslint-disable-line import/no-commonjs

});
parcelRegister("ioYYx", function(module, exports) {

var $5Ovjr = parcelRequire("5Ovjr");
var $d659c459e59ff953$require$Buffer = $5Ovjr.Buffer;
!function(root, factory) {
    module.exports = factory();
}("undefined" != typeof self ? self : module.exports, function() {
    return function(modules) {
        var installedModules = {};
        function __webpack_require__(moduleId) {
            if (installedModules[moduleId]) return installedModules[moduleId].exports;
            var module1 = installedModules[moduleId] = {
                i: moduleId,
                l: !1,
                exports: {}
            };
            modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            module1.l = !0;
            return module1.exports;
        }
        __webpack_require__.m = modules;
        __webpack_require__.c = installedModules;
        __webpack_require__.d = function(exports, name, getter) {
            __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
                enumerable: !0,
                get: getter
            });
        };
        __webpack_require__.r = function(exports) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(exports, Symbol.toStringTag, {
                value: "Module"
            });
            Object.defineProperty(exports, "__esModule", {
                value: !0
            });
        };
        __webpack_require__.t = function(value, mode) {
            1 & mode && (value = __webpack_require__(value));
            if (8 & mode) return value;
            if (4 & mode && "object" == typeof value && value && value.__esModule) return value;
            var ns = Object.create(null);
            __webpack_require__.r(ns);
            Object.defineProperty(ns, "default", {
                enumerable: !0,
                value: value
            });
            if (2 & mode && "string" != typeof value) for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            return ns;
        };
        __webpack_require__.n = function(module1) {
            var getter = module1 && module1.__esModule ? function() {
                return module1.default;
            } : function() {
                return module1;
            };
            __webpack_require__.d(getter, "a", getter);
            return getter;
        };
        __webpack_require__.o = function(object, property) {
            return ({}).hasOwnProperty.call(object, property);
        };
        __webpack_require__.p = "";
        return __webpack_require__(__webpack_require__.s = 0);
    }([
        function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "Promise", function() {
                return promise_ZalgoPromise;
            });
            __webpack_require__.d(__webpack_exports__, "TYPES", function() {
                return src_types_TYPES_0;
            });
            __webpack_require__.d(__webpack_exports__, "ProxyWindow", function() {
                return window_ProxyWindow;
            });
            __webpack_require__.d(__webpack_exports__, "setup", function() {
                return setup;
            });
            __webpack_require__.d(__webpack_exports__, "destroy", function() {
                return destroy;
            });
            __webpack_require__.d(__webpack_exports__, "serializeMessage", function() {
                return setup_serializeMessage;
            });
            __webpack_require__.d(__webpack_exports__, "deserializeMessage", function() {
                return setup_deserializeMessage;
            });
            __webpack_require__.d(__webpack_exports__, "createProxyWindow", function() {
                return createProxyWindow;
            });
            __webpack_require__.d(__webpack_exports__, "toProxyWindow", function() {
                return setup_toProxyWindow;
            });
            __webpack_require__.d(__webpack_exports__, "on", function() {
                return on_on;
            });
            __webpack_require__.d(__webpack_exports__, "once", function() {
                return on_once;
            });
            __webpack_require__.d(__webpack_exports__, "send", function() {
                return send_send;
            });
            __webpack_require__.d(__webpack_exports__, "markWindowKnown", function() {
                return markWindowKnown;
            });
            __webpack_require__.d(__webpack_exports__, "cleanUpWindow", function() {
                return cleanUpWindow;
            });
            __webpack_require__.d(__webpack_exports__, "bridge", function() {});
            function isRegex(item) {
                return "[object RegExp]" === ({}).toString.call(item);
            }
            var IE_WIN_ACCESS_ERROR = "Call was rejected by callee.\r\n";
            function isAboutProtocol(win) {
                void 0 === win && (win = window);
                return "about:" === win.location.protocol;
            }
            function getParent(win) {
                void 0 === win && (win = window);
                if (win) try {
                    if (win.parent && win.parent !== win) return win.parent;
                } catch (err) {}
            }
            function getOpener(win) {
                void 0 === win && (win = window);
                if (win && !getParent(win)) try {
                    return win.opener;
                } catch (err) {}
            }
            function canReadFromWindow(win) {
                try {
                    return !0;
                } catch (err) {}
                return !1;
            }
            function getActualDomain(win) {
                void 0 === win && (win = window);
                var location = win.location;
                if (!location) throw new Error("Can not read window location");
                var protocol = location.protocol;
                if (!protocol) throw new Error("Can not read window protocol");
                if ("file:" === protocol) return "file://";
                if ("about:" === protocol) {
                    var parent = getParent(win);
                    return parent && canReadFromWindow() ? getActualDomain(parent) : "about://";
                }
                var host = location.host;
                if (!host) throw new Error("Can not read window host");
                return protocol + "//" + host;
            }
            function getDomain(win) {
                void 0 === win && (win = window);
                var domain = getActualDomain(win);
                return domain && win.mockDomain && 0 === win.mockDomain.indexOf("mock:") ? win.mockDomain : domain;
            }
            function isSameDomain(win) {
                if (!function(win) {
                    try {
                        if (win === window) return !0;
                    } catch (err) {}
                    try {
                        var desc = Object.getOwnPropertyDescriptor(win, "location");
                        if (desc && !1 === desc.enumerable) return !1;
                    } catch (err) {}
                    try {
                        if (isAboutProtocol(win) && canReadFromWindow()) return !0;
                    } catch (err) {}
                    try {
                        if (getActualDomain(win) === getActualDomain(window)) return !0;
                    } catch (err) {}
                    return !1;
                }(win)) return !1;
                try {
                    if (win === window) return !0;
                    if (isAboutProtocol(win) && canReadFromWindow()) return !0;
                    if (getDomain(window) === getDomain(win)) return !0;
                } catch (err) {}
                return !1;
            }
            function assertSameDomain(win) {
                if (!isSameDomain(win)) throw new Error("Expected window to be same domain");
                return win;
            }
            function isAncestorParent(parent, child) {
                if (!parent || !child) return !1;
                var childParent = getParent(child);
                return childParent ? childParent === parent : -1 !== (function(win) {
                    var result = [];
                    try {
                        for(; win.parent !== win;){
                            result.push(win.parent);
                            win = win.parent;
                        }
                    } catch (err) {}
                    return result;
                })(child).indexOf(parent);
            }
            function getFrames(win) {
                var result = [];
                var frames;
                try {
                    frames = win.frames;
                } catch (err) {
                    frames = win;
                }
                var len;
                try {
                    len = frames.length;
                } catch (err) {}
                if (0 === len) return result;
                if (len) {
                    for(var i = 0; i < len; i++){
                        var frame = void 0;
                        try {
                            frame = frames[i];
                        } catch (err) {
                            continue;
                        }
                        result.push(frame);
                    }
                    return result;
                }
                for(var _i = 0; _i < 100; _i++){
                    var _frame = void 0;
                    try {
                        _frame = frames[_i];
                    } catch (err) {
                        return result;
                    }
                    if (!_frame) return result;
                    result.push(_frame);
                }
                return result;
            }
            var iframeWindows = [];
            var iframeFrames = [];
            function isWindowClosed(win, allowMock) {
                void 0 === allowMock && (allowMock = !0);
                try {
                    if (win === window) return !1;
                } catch (err) {
                    return !0;
                }
                try {
                    if (!win) return !0;
                } catch (err) {
                    return !0;
                }
                try {
                    if (win.closed) return !0;
                } catch (err) {
                    return !err || err.message !== IE_WIN_ACCESS_ERROR;
                }
                if (allowMock && isSameDomain(win)) try {
                    if (win.mockclosed) return !0;
                } catch (err) {}
                try {
                    if (!win.parent || !win.top) return !0;
                } catch (err) {}
                var iframeIndex = function(collection, item) {
                    for(var i = 0; i < collection.length; i++)try {
                        if (collection[i] === item) return i;
                    } catch (err) {}
                    return -1;
                }(iframeWindows, win);
                if (-1 !== iframeIndex) {
                    var frame = iframeFrames[iframeIndex];
                    if (frame && function(frame) {
                        if (!frame.contentWindow) return !0;
                        if (!frame.parentNode) return !0;
                        var doc = frame.ownerDocument;
                        if (doc && doc.documentElement && !doc.documentElement.contains(frame)) {
                            var parent = frame;
                            for(; parent.parentNode && parent.parentNode !== parent;)parent = parent.parentNode;
                            if (!parent.host || !doc.documentElement.contains(parent.host)) return !0;
                        }
                        return !1;
                    }(frame)) return !0;
                }
                return !1;
            }
            function getAncestor(win) {
                void 0 === win && (win = window);
                return getOpener(win = win || window) || getParent(win) || void 0;
            }
            function matchDomain(pattern, origin) {
                if ("string" == typeof pattern) {
                    if ("string" == typeof origin) return "*" === pattern || origin === pattern;
                    if (isRegex(origin)) return !1;
                    if (Array.isArray(origin)) return !1;
                }
                return isRegex(pattern) ? isRegex(origin) ? pattern.toString() === origin.toString() : !Array.isArray(origin) && Boolean(origin.match(pattern)) : !!Array.isArray(pattern) && (Array.isArray(origin) ? JSON.stringify(pattern) === JSON.stringify(origin) : !isRegex(origin) && pattern.some(function(subpattern) {
                    return matchDomain(subpattern, origin);
                }));
            }
            function isWindow(obj) {
                try {
                    if (obj === window) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    if ("[object Window]" === ({}).toString.call(obj)) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    if (window.Window && obj instanceof window.Window) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    if (obj && obj.self === obj) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    if (obj && obj.parent === obj) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    if (obj && obj.top === obj) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    if (obj && "__unlikely_value__" === obj.__cross_domain_utils_window_check__) return !1;
                } catch (err) {
                    return !0;
                }
                try {
                    if ("postMessage" in obj && "self" in obj && "location" in obj) return !0;
                } catch (err) {}
                return !1;
            }
            function closeWindow(win) {
                try {
                    win.close();
                } catch (err) {}
            }
            function utils_isPromise(item) {
                try {
                    if (!item) return !1;
                    if ("undefined" != typeof Promise && item instanceof Promise) return !0;
                    if ("undefined" != typeof window && "function" == typeof window.Window && item instanceof window.Window) return !1;
                    if ("undefined" != typeof window && "function" == typeof window.constructor && item instanceof window.constructor) return !1;
                    var _toString = {}.toString;
                    if (_toString) {
                        var name = _toString.call(item);
                        if ("[object Window]" === name || "[object global]" === name || "[object DOMWindow]" === name) return !1;
                    }
                    if ("function" == typeof item.then) return !0;
                } catch (err) {
                    return !1;
                }
                return !1;
            }
            var dispatchedErrors = [];
            var possiblyUnhandledPromiseHandlers = [];
            var activeCount = 0;
            var flushPromise;
            function flushActive() {
                if (!activeCount && flushPromise) {
                    var promise = flushPromise;
                    flushPromise = null;
                    promise.resolve();
                }
            }
            function startActive() {
                activeCount += 1;
            }
            function endActive() {
                activeCount -= 1;
                flushActive();
            }
            var promise_ZalgoPromise = function() {
                function ZalgoPromise(handler) {
                    var _this = this;
                    this.resolved = void 0;
                    this.rejected = void 0;
                    this.errorHandled = void 0;
                    this.value = void 0;
                    this.error = void 0;
                    this.handlers = void 0;
                    this.dispatching = void 0;
                    this.stack = void 0;
                    this.resolved = !1;
                    this.rejected = !1;
                    this.errorHandled = !1;
                    this.handlers = [];
                    if (handler) {
                        var _result;
                        var _error;
                        var resolved = !1;
                        var rejected = !1;
                        var isAsync = !1;
                        startActive();
                        try {
                            handler(function(res) {
                                if (isAsync) _this.resolve(res);
                                else {
                                    resolved = !0;
                                    _result = res;
                                }
                            }, function(err) {
                                if (isAsync) _this.reject(err);
                                else {
                                    rejected = !0;
                                    _error = err;
                                }
                            });
                        } catch (err) {
                            endActive();
                            this.reject(err);
                            return;
                        }
                        endActive();
                        isAsync = !0;
                        resolved ? this.resolve(_result) : rejected && this.reject(_error);
                    }
                }
                var _proto = ZalgoPromise.prototype;
                _proto.resolve = function(result) {
                    if (this.resolved || this.rejected) return this;
                    if (utils_isPromise(result)) throw new Error("Can not resolve promise with another promise");
                    this.resolved = !0;
                    this.value = result;
                    this.dispatch();
                    return this;
                };
                _proto.reject = function(error) {
                    var _this2 = this;
                    if (this.resolved || this.rejected) return this;
                    if (utils_isPromise(error)) throw new Error("Can not reject promise with another promise");
                    if (!error) {
                        var _err = error && "function" == typeof error.toString ? error.toString() : ({}).toString.call(error);
                        error = new Error("Expected reject to be called with Error, got " + _err);
                    }
                    this.rejected = !0;
                    this.error = error;
                    this.errorHandled || setTimeout(function() {
                        _this2.errorHandled || function(err, promise) {
                            if (-1 === dispatchedErrors.indexOf(err)) {
                                dispatchedErrors.push(err);
                                setTimeout(function() {
                                    throw err;
                                }, 1);
                                for(var j = 0; j < possiblyUnhandledPromiseHandlers.length; j++)possiblyUnhandledPromiseHandlers[j](err, promise);
                            }
                        }(error, _this2);
                    }, 1);
                    this.dispatch();
                    return this;
                };
                _proto.asyncReject = function(error) {
                    this.errorHandled = !0;
                    this.reject(error);
                    return this;
                };
                _proto.dispatch = function() {
                    var resolved = this.resolved, rejected = this.rejected, handlers = this.handlers;
                    if (!this.dispatching && (resolved || rejected)) {
                        this.dispatching = !0;
                        startActive();
                        var chain = function(firstPromise, secondPromise) {
                            return firstPromise.then(function(res) {
                                secondPromise.resolve(res);
                            }, function(err) {
                                secondPromise.reject(err);
                            });
                        };
                        for(var i = 0; i < handlers.length; i++){
                            var _handlers$i = handlers[i], onSuccess = _handlers$i.onSuccess, onError = _handlers$i.onError, promise = _handlers$i.promise;
                            var _result2 = void 0;
                            if (resolved) try {
                                _result2 = onSuccess ? onSuccess(this.value) : this.value;
                            } catch (err) {
                                promise.reject(err);
                                continue;
                            }
                            else if (rejected) {
                                if (!onError) {
                                    promise.reject(this.error);
                                    continue;
                                }
                                try {
                                    _result2 = onError(this.error);
                                } catch (err) {
                                    promise.reject(err);
                                    continue;
                                }
                            }
                            if (_result2 instanceof ZalgoPromise && (_result2.resolved || _result2.rejected)) {
                                _result2.resolved ? promise.resolve(_result2.value) : promise.reject(_result2.error);
                                _result2.errorHandled = !0;
                            } else utils_isPromise(_result2) ? _result2 instanceof ZalgoPromise && (_result2.resolved || _result2.rejected) ? _result2.resolved ? promise.resolve(_result2.value) : promise.reject(_result2.error) : chain(_result2, promise) : promise.resolve(_result2);
                        }
                        handlers.length = 0;
                        this.dispatching = !1;
                        endActive();
                    }
                };
                _proto.then = function(onSuccess, onError) {
                    if (onSuccess && "function" != typeof onSuccess && !onSuccess.call) throw new Error("Promise.then expected a function for success handler");
                    if (onError && "function" != typeof onError && !onError.call) throw new Error("Promise.then expected a function for error handler");
                    var promise = new ZalgoPromise;
                    this.handlers.push({
                        promise: promise,
                        onSuccess: onSuccess,
                        onError: onError
                    });
                    this.errorHandled = !0;
                    this.dispatch();
                    return promise;
                };
                _proto.catch = function(onError) {
                    return this.then(void 0, onError);
                };
                _proto.finally = function(onFinally) {
                    if (onFinally && "function" != typeof onFinally && !onFinally.call) throw new Error("Promise.finally expected a function");
                    return this.then(function(result) {
                        return ZalgoPromise.try(onFinally).then(function() {
                            return result;
                        });
                    }, function(err) {
                        return ZalgoPromise.try(onFinally).then(function() {
                            throw err;
                        });
                    });
                };
                _proto.timeout = function(time, err) {
                    var _this3 = this;
                    if (this.resolved || this.rejected) return this;
                    var timeout = setTimeout(function() {
                        _this3.resolved || _this3.rejected || _this3.reject(err || new Error("Promise timed out after " + time + "ms"));
                    }, time);
                    return this.then(function(result) {
                        clearTimeout(timeout);
                        return result;
                    });
                };
                _proto.toPromise = function() {
                    if ("undefined" == typeof Promise) throw new TypeError("Could not find Promise");
                    return Promise.resolve(this);
                };
                ZalgoPromise.resolve = function(value) {
                    return value instanceof ZalgoPromise ? value : utils_isPromise(value) ? new ZalgoPromise(function(resolve, reject) {
                        return value.then(resolve, reject);
                    }) : (new ZalgoPromise).resolve(value);
                };
                ZalgoPromise.reject = function(error) {
                    return (new ZalgoPromise).reject(error);
                };
                ZalgoPromise.asyncReject = function(error) {
                    return (new ZalgoPromise).asyncReject(error);
                };
                ZalgoPromise.all = function(promises) {
                    var promise = new ZalgoPromise;
                    var count = promises.length;
                    var results = [];
                    if (!count) {
                        promise.resolve(results);
                        return promise;
                    }
                    var chain = function(i, firstPromise, secondPromise) {
                        return firstPromise.then(function(res) {
                            results[i] = res;
                            0 == (count -= 1) && promise.resolve(results);
                        }, function(err) {
                            secondPromise.reject(err);
                        });
                    };
                    for(var i = 0; i < promises.length; i++){
                        var prom = promises[i];
                        if (prom instanceof ZalgoPromise) {
                            if (prom.resolved) {
                                results[i] = prom.value;
                                count -= 1;
                                continue;
                            }
                        } else if (!utils_isPromise(prom)) {
                            results[i] = prom;
                            count -= 1;
                            continue;
                        }
                        chain(i, ZalgoPromise.resolve(prom), promise);
                    }
                    0 === count && promise.resolve(results);
                    return promise;
                };
                ZalgoPromise.hash = function(promises) {
                    var result = {};
                    var awaitPromises = [];
                    var _loop = function(key) {
                        if (promises.hasOwnProperty(key)) {
                            var value = promises[key];
                            utils_isPromise(value) ? awaitPromises.push(value.then(function(res) {
                                result[key] = res;
                            })) : result[key] = value;
                        }
                    };
                    for(var key in promises)_loop(key);
                    return ZalgoPromise.all(awaitPromises).then(function() {
                        return result;
                    });
                };
                ZalgoPromise.map = function(items, method) {
                    return ZalgoPromise.all(items.map(method));
                };
                ZalgoPromise.onPossiblyUnhandledException = function(handler) {
                    return function(handler) {
                        possiblyUnhandledPromiseHandlers.push(handler);
                        return {
                            cancel: function() {
                                possiblyUnhandledPromiseHandlers.splice(possiblyUnhandledPromiseHandlers.indexOf(handler), 1);
                            }
                        };
                    }(handler);
                };
                ZalgoPromise.try = function(method, context, args) {
                    if (method && "function" != typeof method && !method.call) throw new Error("Promise.try expected a function");
                    var result;
                    startActive();
                    try {
                        result = method.apply(context, args || []);
                    } catch (err) {
                        endActive();
                        return ZalgoPromise.reject(err);
                    }
                    endActive();
                    return ZalgoPromise.resolve(result);
                };
                ZalgoPromise.delay = function(_delay) {
                    return new ZalgoPromise(function(resolve) {
                        setTimeout(resolve, _delay);
                    });
                };
                ZalgoPromise.isPromise = function(value) {
                    return !!(value && value instanceof ZalgoPromise) || utils_isPromise(value);
                };
                ZalgoPromise.flush = function() {
                    return function(Zalgo) {
                        var promise = flushPromise = flushPromise || new Zalgo;
                        flushActive();
                        return promise;
                    }(ZalgoPromise);
                };
                return ZalgoPromise;
            }();
            function util_safeIndexOf(collection, item) {
                for(var i = 0; i < collection.length; i++)try {
                    if (collection[i] === item) return i;
                } catch (err) {}
                return -1;
            }
            var weakmap_CrossDomainSafeWeakMap = function() {
                function CrossDomainSafeWeakMap() {
                    this.name = void 0;
                    this.weakmap = void 0;
                    this.keys = void 0;
                    this.values = void 0;
                    this.name = "__weakmap_" + (1e9 * Math.random() >>> 0) + "__";
                    if (function() {
                        if ("undefined" == typeof WeakMap) return !1;
                        if (void 0 === Object.freeze) return !1;
                        try {
                            var testWeakMap = new WeakMap;
                            var testKey = {};
                            Object.freeze(testKey);
                            testWeakMap.set(testKey, "__testvalue__");
                            return "__testvalue__" === testWeakMap.get(testKey);
                        } catch (err) {
                            return !1;
                        }
                    }()) try {
                        this.weakmap = new WeakMap;
                    } catch (err) {}
                    this.keys = [];
                    this.values = [];
                }
                var _proto = CrossDomainSafeWeakMap.prototype;
                _proto._cleanupClosedWindows = function() {
                    var weakmap = this.weakmap;
                    var keys = this.keys;
                    for(var i = 0; i < keys.length; i++){
                        var value = keys[i];
                        if (isWindow(value) && isWindowClosed(value)) {
                            if (weakmap) try {
                                weakmap.delete(value);
                            } catch (err) {}
                            keys.splice(i, 1);
                            this.values.splice(i, 1);
                            i -= 1;
                        }
                    }
                };
                _proto.isSafeToReadWrite = function(key) {
                    return !isWindow(key);
                };
                _proto.set = function(key, value) {
                    if (!key) throw new Error("WeakMap expected key");
                    var weakmap = this.weakmap;
                    if (weakmap) try {
                        weakmap.set(key, value);
                    } catch (err) {
                        delete this.weakmap;
                    }
                    if (this.isSafeToReadWrite(key)) try {
                        var name = this.name;
                        var entry = key[name];
                        entry && entry[0] === key ? entry[1] = value : Object.defineProperty(key, name, {
                            value: [
                                key,
                                value
                            ],
                            writable: !0
                        });
                        return;
                    } catch (err) {}
                    this._cleanupClosedWindows();
                    var keys = this.keys;
                    var values = this.values;
                    var index = util_safeIndexOf(keys, key);
                    if (-1 === index) {
                        keys.push(key);
                        values.push(value);
                    } else values[index] = value;
                };
                _proto.get = function(key) {
                    if (!key) throw new Error("WeakMap expected key");
                    var weakmap = this.weakmap;
                    if (weakmap) try {
                        if (weakmap.has(key)) return weakmap.get(key);
                    } catch (err) {
                        delete this.weakmap;
                    }
                    if (this.isSafeToReadWrite(key)) try {
                        var entry = key[this.name];
                        return entry && entry[0] === key ? entry[1] : void 0;
                    } catch (err) {}
                    this._cleanupClosedWindows();
                    var index = util_safeIndexOf(this.keys, key);
                    if (-1 !== index) return this.values[index];
                };
                _proto.delete = function(key) {
                    if (!key) throw new Error("WeakMap expected key");
                    var weakmap = this.weakmap;
                    if (weakmap) try {
                        weakmap.delete(key);
                    } catch (err) {
                        delete this.weakmap;
                    }
                    if (this.isSafeToReadWrite(key)) try {
                        var entry = key[this.name];
                        entry && entry[0] === key && (entry[0] = entry[1] = void 0);
                    } catch (err) {}
                    this._cleanupClosedWindows();
                    var keys = this.keys;
                    var index = util_safeIndexOf(keys, key);
                    if (-1 !== index) {
                        keys.splice(index, 1);
                        this.values.splice(index, 1);
                    }
                };
                _proto.has = function(key) {
                    if (!key) throw new Error("WeakMap expected key");
                    var weakmap = this.weakmap;
                    if (weakmap) try {
                        if (weakmap.has(key)) return !0;
                    } catch (err) {
                        delete this.weakmap;
                    }
                    if (this.isSafeToReadWrite(key)) try {
                        var entry = key[this.name];
                        return !(!entry || entry[0] !== key);
                    } catch (err) {}
                    this._cleanupClosedWindows();
                    return -1 !== util_safeIndexOf(this.keys, key);
                };
                _proto.getOrSet = function(key, getter) {
                    if (this.has(key)) return this.get(key);
                    var value = getter();
                    this.set(key, value);
                    return value;
                };
                return CrossDomainSafeWeakMap;
            }();
            function getFunctionName(fn) {
                return fn.name || fn.__name__ || fn.displayName || "anonymous";
            }
            function setFunctionName(fn, name) {
                try {
                    delete fn.name;
                    fn.name = name;
                } catch (err) {}
                fn.__name__ = fn.displayName = name;
                return fn;
            }
            function uniqueID() {
                var chars = "0123456789abcdef";
                return "xxxxxxxxxx".replace(/./g, function() {
                    return chars.charAt(Math.floor(Math.random() * chars.length));
                }) + "_" + (function(str) {
                    if ("function" == typeof btoa) return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(m, p1) {
                        return String.fromCharCode(parseInt(p1, 16));
                    }));
                    if ("undefined" != typeof $d659c459e59ff953$require$Buffer) return $d659c459e59ff953$require$Buffer.from(str, "utf8").toString("base64");
                    throw new Error("Can not find window.btoa or Buffer");
                })((new Date).toISOString().slice(11, 19).replace("T", ".")).replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
            }
            var objectIDs;
            function serializeArgs(args) {
                try {
                    return JSON.stringify([].slice.call(args), function(subkey, val) {
                        return "function" == typeof val ? "memoize[" + function(obj) {
                            objectIDs = objectIDs || new weakmap_CrossDomainSafeWeakMap;
                            if (null == obj || "object" != typeof obj && "function" != typeof obj) throw new Error("Invalid object");
                            var uid = objectIDs.get(obj);
                            if (!uid) {
                                uid = typeof obj + ":" + uniqueID();
                                objectIDs.set(obj, uid);
                            }
                            return uid;
                        }(val) + "]" : val;
                    });
                } catch (err) {
                    throw new Error("Arguments not serializable -- can not be used to memoize");
                }
            }
            var memoizedFunctions = [];
            function memoize(method, options) {
                var _this = this;
                void 0 === options && (options = {});
                var cacheMap = new weakmap_CrossDomainSafeWeakMap;
                var memoizedFunction = function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var cache = cacheMap.getOrSet(options.thisNamespace ? this : method, function() {
                        return {};
                    });
                    var key = serializeArgs(args);
                    var cacheTime = options.time;
                    cache[key] && cacheTime && Date.now() - cache[key].time < cacheTime && delete cache[key];
                    if (cache[key]) return cache[key].value;
                    var time = Date.now();
                    var value = method.apply(this, arguments);
                    cache[key] = {
                        time: time,
                        value: value
                    };
                    return cache[key].value;
                };
                memoizedFunction.reset = function() {
                    cacheMap.delete(options.thisNamespace ? _this : method);
                };
                memoizedFunctions.push(memoizedFunction);
                return setFunctionName(memoizedFunction, (options.name || getFunctionName(method)) + "::memoized");
            }
            memoize.clear = function() {
                for(var _i2 = 0; _i2 < memoizedFunctions.length; _i2++)memoizedFunctions[_i2].reset();
            };
            function memoizePromise(method) {
                var cache = {};
                function memoizedPromiseFunction() {
                    var _arguments = arguments, _this2 = this;
                    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                    var key = serializeArgs(args);
                    if (cache.hasOwnProperty(key)) return cache[key];
                    cache[key] = promise_ZalgoPromise.try(function() {
                        return method.apply(_this2, _arguments);
                    }).finally(function() {
                        delete cache[key];
                    });
                    return cache[key];
                }
                memoizedPromiseFunction.reset = function() {
                    cache = {};
                };
                return setFunctionName(memoizedPromiseFunction, getFunctionName(method) + "::promiseMemoized");
            }
            function src_util_noop() {}
            function stringifyError(err, level) {
                void 0 === level && (level = 1);
                if (level >= 3) return "stringifyError stack overflow";
                try {
                    if (!err) return "<unknown error: " + ({}).toString.call(err) + ">";
                    if ("string" == typeof err) return err;
                    if (err instanceof Error) {
                        var stack = err && err.stack;
                        var message = err && err.message;
                        if (stack && message) return -1 !== stack.indexOf(message) ? stack : message + "\n" + stack;
                        if (stack) return stack;
                        if (message) return message;
                    }
                    return err && err.toString && "function" == typeof err.toString ? err.toString() : ({}).toString.call(err);
                } catch (newErr) {
                    return "Error while stringifying error: " + stringifyError(newErr, level + 1);
                }
            }
            function stringify(item) {
                return "string" == typeof item ? item : item && item.toString && "function" == typeof item.toString ? item.toString() : ({}).toString.call(item);
            }
            memoize(function(obj) {
                if (Object.values) return Object.values(obj);
                var result = [];
                for(var key in obj)obj.hasOwnProperty(key) && result.push(obj[key]);
                return result;
            });
            function util_isRegex(item) {
                return "[object RegExp]" === ({}).toString.call(item);
            }
            function util_getOrSet(obj, key, getter) {
                if (obj.hasOwnProperty(key)) return obj[key];
                var val = getter();
                obj[key] = val;
                return val;
            }
            Error;
            function isDocumentReady() {
                return Boolean(document.body) && "complete" === document.readyState;
            }
            function isDocumentInteractive() {
                return Boolean(document.body) && "interactive" === document.readyState;
            }
            memoize(function() {
                return new promise_ZalgoPromise(function(resolve) {
                    if (isDocumentReady() || isDocumentInteractive()) return resolve();
                    var interval = setInterval(function() {
                        if (isDocumentReady() || isDocumentInteractive()) {
                            clearInterval(interval);
                            return resolve();
                        }
                    }, 10);
                });
            });
            var currentScript = "undefined" != typeof document ? document.currentScript : null;
            var getCurrentScript = memoize(function() {
                if (currentScript) return currentScript;
                if (currentScript = function() {
                    try {
                        var stack = function() {
                            try {
                                throw new Error("_");
                            } catch (err) {
                                return err.stack || "";
                            }
                        }();
                        var stackDetails = /.*at [^(]*\((.*):(.+):(.+)\)$/gi.exec(stack);
                        var scriptLocation = stackDetails && stackDetails[1];
                        if (!scriptLocation) return;
                        for(var _i20 = 0, _Array$prototype$slic2 = [].slice.call(document.getElementsByTagName("script")).reverse(); _i20 < _Array$prototype$slic2.length; _i20++){
                            var script = _Array$prototype$slic2[_i20];
                            if (script.src && script.src === scriptLocation) return script;
                        }
                    } catch (err) {}
                }()) return currentScript;
                throw new Error("Can not determine current script");
            });
            var currentUID = uniqueID();
            memoize(function() {
                var script;
                try {
                    script = getCurrentScript();
                } catch (err) {
                    return currentUID;
                }
                var uid = script.getAttribute("data-uid");
                if (uid && "string" == typeof uid) return uid;
                uid = uniqueID();
                script.setAttribute("data-uid", uid);
                return uid;
            });
            function global_getGlobal(win) {
                void 0 === win && (win = window);
                var globalKey = "__post_robot_10_0_41__";
                return win !== window ? win[globalKey] : win[globalKey] = win[globalKey] || {};
            }
            var getObj = function() {
                return {};
            };
            function globalStore(key, defStore) {
                void 0 === key && (key = "store");
                void 0 === defStore && (defStore = getObj);
                return util_getOrSet(global_getGlobal(), key, function() {
                    var store = defStore();
                    return {
                        has: function(storeKey) {
                            return store.hasOwnProperty(storeKey);
                        },
                        get: function(storeKey, defVal) {
                            return store.hasOwnProperty(storeKey) ? store[storeKey] : defVal;
                        },
                        set: function(storeKey, val) {
                            store[storeKey] = val;
                            return val;
                        },
                        del: function(storeKey) {
                            delete store[storeKey];
                        },
                        getOrSet: function(storeKey, getter) {
                            return util_getOrSet(store, storeKey, getter);
                        },
                        reset: function() {
                            store = defStore();
                        },
                        keys: function() {
                            return Object.keys(store);
                        }
                    };
                });
            }
            var WildCard = function() {};
            function getWildcard() {
                var global = global_getGlobal();
                global.WINDOW_WILDCARD = global.WINDOW_WILDCARD || new WildCard;
                return global.WINDOW_WILDCARD;
            }
            function windowStore(key, defStore) {
                void 0 === key && (key = "store");
                void 0 === defStore && (defStore = getObj);
                return globalStore("windowStore").getOrSet(key, function() {
                    var winStore = new weakmap_CrossDomainSafeWeakMap;
                    var getStore = function(win) {
                        return winStore.getOrSet(win, defStore);
                    };
                    return {
                        has: function(win) {
                            return getStore(win).hasOwnProperty(key);
                        },
                        get: function(win, defVal) {
                            var store = getStore(win);
                            return store.hasOwnProperty(key) ? store[key] : defVal;
                        },
                        set: function(win, val) {
                            getStore(win)[key] = val;
                            return val;
                        },
                        del: function(win) {
                            delete getStore(win)[key];
                        },
                        getOrSet: function(win, getter) {
                            return util_getOrSet(getStore(win), key, getter);
                        }
                    };
                });
            }
            function getInstanceID() {
                return globalStore("instance").getOrSet("instanceID", uniqueID);
            }
            function resolveHelloPromise(win, _ref) {
                var domain = _ref.domain;
                var helloPromises = windowStore("helloPromises");
                var existingPromise = helloPromises.get(win);
                existingPromise && existingPromise.resolve({
                    domain: domain
                });
                var newPromise = promise_ZalgoPromise.resolve({
                    domain: domain
                });
                helloPromises.set(win, newPromise);
                return newPromise;
            }
            function sayHello(win, _ref4) {
                return (0, _ref4.send)(win, "postrobot_hello", {
                    instanceID: getInstanceID()
                }, {
                    domain: "*",
                    timeout: -1
                }).then(function(_ref5) {
                    var origin = _ref5.origin, instanceID = _ref5.data.instanceID;
                    resolveHelloPromise(win, {
                        domain: origin
                    });
                    return {
                        win: win,
                        domain: origin,
                        instanceID: instanceID
                    };
                });
            }
            function getWindowInstanceID(win, _ref6) {
                var send = _ref6.send;
                return windowStore("windowInstanceIDPromises").getOrSet(win, function() {
                    return sayHello(win, {
                        send: send
                    }).then(function(_ref7) {
                        return _ref7.instanceID;
                    });
                });
            }
            function markWindowKnown(win) {
                windowStore("knownWindows").set(win, !0);
            }
            function isSerializedType(item) {
                return "object" == typeof item && null !== item && "string" == typeof item.__type__;
            }
            function determineType(val) {
                return void 0 === val ? "undefined" : null === val ? "null" : Array.isArray(val) ? "array" : "function" == typeof val ? "function" : "object" == typeof val ? val instanceof Error ? "error" : "function" == typeof val.then ? "promise" : "[object RegExp]" === ({}).toString.call(val) ? "regex" : "[object Date]" === ({}).toString.call(val) ? "date" : "object" : "string" == typeof val ? "string" : "number" == typeof val ? "number" : "boolean" == typeof val ? "boolean" : void 0;
            }
            function serializeType(type, val) {
                return {
                    __type__: type,
                    __val__: val
                };
            }
            var _SERIALIZER;
            var SERIALIZER = ((_SERIALIZER = {}).function = function() {}, _SERIALIZER.error = function(_ref) {
                return serializeType("error", {
                    message: _ref.message,
                    stack: _ref.stack,
                    code: _ref.code,
                    data: _ref.data
                });
            }, _SERIALIZER.promise = function() {}, _SERIALIZER.regex = function(val) {
                return serializeType("regex", val.source);
            }, _SERIALIZER.date = function(val) {
                return serializeType("date", val.toJSON());
            }, _SERIALIZER.array = function(val) {
                return val;
            }, _SERIALIZER.object = function(val) {
                return val;
            }, _SERIALIZER.string = function(val) {
                return val;
            }, _SERIALIZER.number = function(val) {
                return val;
            }, _SERIALIZER.boolean = function(val) {
                return val;
            }, _SERIALIZER.null = function(val) {
                return val;
            }, _SERIALIZER);
            var defaultSerializers = {};
            var _DESERIALIZER;
            var DESERIALIZER = ((_DESERIALIZER = {}).function = function() {
                throw new Error("Function serialization is not implemented; nothing to deserialize");
            }, _DESERIALIZER.error = function(_ref2) {
                var stack = _ref2.stack, code = _ref2.code, data = _ref2.data;
                var error = new Error(_ref2.message);
                error.code = code;
                data && (error.data = data);
                error.stack = stack + "\n\n" + error.stack;
                return error;
            }, _DESERIALIZER.promise = function() {
                throw new Error("Promise serialization is not implemented; nothing to deserialize");
            }, _DESERIALIZER.regex = function(val) {
                return new RegExp(val);
            }, _DESERIALIZER.date = function(val) {
                return new Date(val);
            }, _DESERIALIZER.array = function(val) {
                return val;
            }, _DESERIALIZER.object = function(val) {
                return val;
            }, _DESERIALIZER.string = function(val) {
                return val;
            }, _DESERIALIZER.number = function(val) {
                return val;
            }, _DESERIALIZER.boolean = function(val) {
                return val;
            }, _DESERIALIZER.null = function(val) {
                return val;
            }, _DESERIALIZER);
            var defaultDeserializers = {};
            new promise_ZalgoPromise(function(resolve) {
                if (window.document && window.document.body) return resolve(window.document.body);
                var interval = setInterval(function() {
                    if (window.document && window.document.body) {
                        clearInterval(interval);
                        return resolve(window.document.body);
                    }
                }, 10);
            });
            function cleanupProxyWindows() {
                var idToProxyWindow = globalStore("idToProxyWindow");
                for(var _i2 = 0, _idToProxyWindow$keys2 = idToProxyWindow.keys(); _i2 < _idToProxyWindow$keys2.length; _i2++){
                    var id = _idToProxyWindow$keys2[_i2];
                    idToProxyWindow.get(id).shouldClean() && idToProxyWindow.del(id);
                }
            }
            function getSerializedWindow(winPromise, _ref) {
                var send = _ref.send, _ref$id = _ref.id, id = void 0 === _ref$id ? uniqueID() : _ref$id;
                var windowNamePromise = winPromise.then(function(win) {
                    if (isSameDomain(win)) return assertSameDomain(win).name;
                });
                var windowTypePromise = winPromise.then(function(window1) {
                    if (isWindowClosed(window1)) throw new Error("Window is closed, can not determine type");
                    return getOpener(window1) ? "popup" : "iframe";
                });
                windowNamePromise.catch(src_util_noop);
                windowTypePromise.catch(src_util_noop);
                return {
                    id: id,
                    getType: function() {
                        return windowTypePromise;
                    },
                    getInstanceID: memoizePromise(function() {
                        return winPromise.then(function(win) {
                            return getWindowInstanceID(win, {
                                send: send
                            });
                        });
                    }),
                    close: function() {
                        return winPromise.then(closeWindow);
                    },
                    getName: function() {
                        return winPromise.then(function(win) {
                            if (!isWindowClosed(win)) return isSameDomain(win) ? assertSameDomain(win).name : windowNamePromise;
                        });
                    },
                    focus: function() {
                        return winPromise.then(function(win) {
                            win.focus();
                        });
                    },
                    isClosed: function() {
                        return winPromise.then(function(win) {
                            return isWindowClosed(win);
                        });
                    },
                    setLocation: function(href) {
                        return winPromise.then(function(win) {
                            var domain = window.location.protocol + "//" + window.location.host;
                            if (0 === href.indexOf("/")) href = "" + domain + href;
                            else if (!href.match(/^https?:\/\//) && 0 !== href.indexOf(domain)) throw new Error("Expected url to be http or https url, or absolute path, got " + JSON.stringify(href));
                            if (isSameDomain(win)) try {
                                if (win.location && "function" == typeof win.location.replace) {
                                    win.location.replace(href);
                                    return;
                                }
                            } catch (err) {}
                            win.location = href;
                        });
                    },
                    setName: function(name) {
                        return winPromise.then(function(win) {
                            var sameDomain = isSameDomain(win);
                            var frame = function(win) {
                                if (isSameDomain(win)) return assertSameDomain(win).frameElement;
                                for(var _i21 = 0, _document$querySelect2 = document.querySelectorAll("iframe"); _i21 < _document$querySelect2.length; _i21++){
                                    var frame = _document$querySelect2[_i21];
                                    if (frame && frame.contentWindow && frame.contentWindow === win) return frame;
                                }
                            }(win);
                            if (!sameDomain) throw new Error("Can not set name for cross-domain window: " + name);
                            assertSameDomain(win).name = name;
                            frame && frame.setAttribute("name", name);
                            windowNamePromise = promise_ZalgoPromise.resolve(name);
                        });
                    }
                };
            }
            var window_ProxyWindow = function() {
                function ProxyWindow(_ref2) {
                    var send = _ref2.send, win = _ref2.win, serializedWindow = _ref2.serializedWindow;
                    this.id = void 0;
                    this.isProxyWindow = !0;
                    this.serializedWindow = void 0;
                    this.actualWindow = void 0;
                    this.actualWindowPromise = void 0;
                    this.send = void 0;
                    this.name = void 0;
                    this.actualWindowPromise = new promise_ZalgoPromise;
                    this.serializedWindow = serializedWindow || getSerializedWindow(this.actualWindowPromise, {
                        send: send
                    });
                    globalStore("idToProxyWindow").set(this.getID(), this);
                    win && this.setWindow(win, {
                        send: send
                    });
                }
                var _proto = ProxyWindow.prototype;
                _proto.getID = function() {
                    return this.serializedWindow.id;
                };
                _proto.getType = function() {
                    return this.serializedWindow.getType();
                };
                _proto.isPopup = function() {
                    return this.getType().then(function(type) {
                        return "popup" === type;
                    });
                };
                _proto.setLocation = function(href) {
                    var _this = this;
                    return this.serializedWindow.setLocation(href).then(function() {
                        return _this;
                    });
                };
                _proto.getName = function() {
                    return this.serializedWindow.getName();
                };
                _proto.setName = function(name) {
                    var _this2 = this;
                    return this.serializedWindow.setName(name).then(function() {
                        return _this2;
                    });
                };
                _proto.close = function() {
                    var _this3 = this;
                    return this.serializedWindow.close().then(function() {
                        return _this3;
                    });
                };
                _proto.focus = function() {
                    var _this4 = this;
                    var isPopupPromise = this.isPopup();
                    var getNamePromise = this.getName();
                    var reopenPromise = promise_ZalgoPromise.hash({
                        isPopup: isPopupPromise,
                        name: getNamePromise
                    }).then(function(_ref3) {
                        var name = _ref3.name;
                        _ref3.isPopup && name && window.open("", name);
                    });
                    var focusPromise = this.serializedWindow.focus();
                    return promise_ZalgoPromise.all([
                        reopenPromise,
                        focusPromise
                    ]).then(function() {
                        return _this4;
                    });
                };
                _proto.isClosed = function() {
                    return this.serializedWindow.isClosed();
                };
                _proto.getWindow = function() {
                    return this.actualWindow;
                };
                _proto.setWindow = function(win, _ref4) {
                    var send = _ref4.send;
                    this.actualWindow = win;
                    this.actualWindowPromise.resolve(this.actualWindow);
                    this.serializedWindow = getSerializedWindow(this.actualWindowPromise, {
                        send: send,
                        id: this.getID()
                    });
                    windowStore("winToProxyWindow").set(win, this);
                };
                _proto.awaitWindow = function() {
                    return this.actualWindowPromise;
                };
                _proto.matchWindow = function(win, _ref5) {
                    var _this5 = this;
                    var send = _ref5.send;
                    return promise_ZalgoPromise.try(function() {
                        return _this5.actualWindow ? win === _this5.actualWindow : promise_ZalgoPromise.hash({
                            proxyInstanceID: _this5.getInstanceID(),
                            knownWindowInstanceID: getWindowInstanceID(win, {
                                send: send
                            })
                        }).then(function(_ref6) {
                            var match = _ref6.proxyInstanceID === _ref6.knownWindowInstanceID;
                            match && _this5.setWindow(win, {
                                send: send
                            });
                            return match;
                        });
                    });
                };
                _proto.unwrap = function() {
                    return this.actualWindow || this;
                };
                _proto.getInstanceID = function() {
                    return this.serializedWindow.getInstanceID();
                };
                _proto.shouldClean = function() {
                    return Boolean(this.actualWindow && isWindowClosed(this.actualWindow));
                };
                _proto.serialize = function() {
                    return this.serializedWindow;
                };
                ProxyWindow.unwrap = function(win) {
                    return ProxyWindow.isProxyWindow(win) ? win.unwrap() : win;
                };
                ProxyWindow.serialize = function(win, _ref7) {
                    var send = _ref7.send;
                    cleanupProxyWindows();
                    return ProxyWindow.toProxyWindow(win, {
                        send: send
                    }).serialize();
                };
                ProxyWindow.deserialize = function(serializedWindow, _ref8) {
                    var send = _ref8.send;
                    cleanupProxyWindows();
                    return globalStore("idToProxyWindow").get(serializedWindow.id) || new ProxyWindow({
                        serializedWindow: serializedWindow,
                        send: send
                    });
                };
                ProxyWindow.isProxyWindow = function(obj) {
                    return Boolean(obj && !isWindow(obj) && obj.isProxyWindow);
                };
                ProxyWindow.toProxyWindow = function(win, _ref9) {
                    var send = _ref9.send;
                    cleanupProxyWindows();
                    if (ProxyWindow.isProxyWindow(win)) return win;
                    var actualWindow = win;
                    return windowStore("winToProxyWindow").get(actualWindow) || new ProxyWindow({
                        win: actualWindow,
                        send: send
                    });
                };
                return ProxyWindow;
            }();
            function addMethod(id, val, name, source, domain) {
                var methodStore = windowStore("methodStore");
                var proxyWindowMethods = globalStore("proxyWindowMethods");
                if (window_ProxyWindow.isProxyWindow(source)) proxyWindowMethods.set(id, {
                    val: val,
                    name: name,
                    domain: domain,
                    source: source
                });
                else {
                    proxyWindowMethods.del(id);
                    methodStore.getOrSet(source, function() {
                        return {};
                    })[id] = {
                        domain: domain,
                        name: name,
                        val: val,
                        source: source
                    };
                }
            }
            function lookupMethod(source, id) {
                var methodStore = windowStore("methodStore");
                var proxyWindowMethods = globalStore("proxyWindowMethods");
                return methodStore.getOrSet(source, function() {
                    return {};
                })[id] || proxyWindowMethods.get(id);
            }
            function function_serializeFunction(destination, domain, val, key, _ref3) {
                on = (_ref = {
                    on: _ref3.on,
                    send: _ref3.send
                }).on, send = _ref.send, globalStore("builtinListeners").getOrSet("functionCalls", function() {
                    return on("postrobot_method", {
                        domain: "*"
                    }, function(_ref2) {
                        var source = _ref2.source, origin = _ref2.origin, data = _ref2.data;
                        var id = data.id, name = data.name;
                        var meth = lookupMethod(source, id);
                        if (!meth) throw new Error("Could not find method '" + name + "' with id: " + data.id + " in " + getDomain(window));
                        var methodSource = meth.source, domain = meth.domain, val = meth.val;
                        return promise_ZalgoPromise.try(function() {
                            if (!matchDomain(domain, origin)) throw new Error("Method '" + data.name + "' domain " + JSON.stringify(util_isRegex(meth.domain) ? meth.domain.source : meth.domain) + " does not match origin " + origin + " in " + getDomain(window));
                            if (window_ProxyWindow.isProxyWindow(methodSource)) return methodSource.matchWindow(source, {
                                send: send
                            }).then(function(match) {
                                if (!match) throw new Error("Method call '" + data.name + "' failed - proxy window does not match source in " + getDomain(window));
                            });
                        }).then(function() {
                            return val.apply({
                                source: source,
                                origin: origin
                            }, data.args);
                        }, function(err) {
                            return promise_ZalgoPromise.try(function() {
                                if (val.onError) return val.onError(err);
                            }).then(function() {
                                err.stack && (err.stack = "Remote call to " + name + "(" + function(args) {
                                    void 0 === args && (args = []);
                                    var item;
                                    return (item = args, [].slice.call(item)).map(function(arg) {
                                        return "string" == typeof arg ? "'" + arg + "'" : void 0 === arg ? "undefined" : null === arg ? "null" : "boolean" == typeof arg ? arg.toString() : Array.isArray(arg) ? "[ ... ]" : "object" == typeof arg ? "{ ... }" : "function" == typeof arg ? "() => { ... }" : "<" + typeof arg + ">";
                                    }).join(", ");
                                }(data.args) + ") failed\n\n" + err.stack);
                                throw err;
                            });
                        }).then(function(result) {
                            return {
                                result: result,
                                id: id,
                                name: name
                            };
                        });
                    });
                });
                var _ref, on, send;
                var id = val.__id__ || uniqueID();
                destination = window_ProxyWindow.unwrap(destination);
                var name = val.__name__ || val.name || key;
                "string" == typeof name && "function" == typeof name.indexOf && 0 === name.indexOf("anonymous::") && (name = name.replace("anonymous::", key + "::"));
                if (window_ProxyWindow.isProxyWindow(destination)) {
                    addMethod(id, val, name, destination, domain);
                    destination.awaitWindow().then(function(win) {
                        addMethod(id, val, name, win, domain);
                    });
                } else addMethod(id, val, name, destination, domain);
                return serializeType("cross_domain_function", {
                    id: id,
                    name: name
                });
            }
            function serializeMessage(destination, domain, obj, _ref) {
                var _serialize;
                var on = _ref.on, send = _ref.send;
                return function(obj, serializers) {
                    void 0 === serializers && (serializers = defaultSerializers);
                    var result = JSON.stringify(obj, function(key) {
                        var val = this[key];
                        if (isSerializedType(this)) return val;
                        var type = determineType(val);
                        if (!type) return val;
                        var serializer = serializers[type] || SERIALIZER[type];
                        return serializer ? serializer(val, key) : val;
                    });
                    return void 0 === result ? "undefined" : result;
                }(obj, ((_serialize = {}).promise = function(val, key) {
                    return function(destination, domain, val, key, _ref) {
                        return serializeType("cross_domain_zalgo_promise", {
                            then: function_serializeFunction(destination, domain, function(resolve, reject) {
                                return val.then(resolve, reject);
                            }, key, {
                                on: _ref.on,
                                send: _ref.send
                            })
                        });
                    }(destination, domain, val, key, {
                        on: on,
                        send: send
                    });
                }, _serialize.function = function(val, key) {
                    return function_serializeFunction(destination, domain, val, key, {
                        on: on,
                        send: send
                    });
                }, _serialize.object = function(val) {
                    return isWindow(val) || window_ProxyWindow.isProxyWindow(val) ? serializeType("cross_domain_window", window_ProxyWindow.serialize(val, {
                        send: send
                    })) : val;
                }, _serialize));
            }
            function deserializeMessage(source, origin, message, _ref2) {
                var _deserialize;
                var send = _ref2.send;
                return function(str, deserializers) {
                    void 0 === deserializers && (deserializers = defaultDeserializers);
                    if ("undefined" !== str) return JSON.parse(str, function(key, val) {
                        if (isSerializedType(this)) return val;
                        var type;
                        var value;
                        if (isSerializedType(val)) {
                            type = val.__type__;
                            value = val.__val__;
                        } else {
                            type = determineType(val);
                            value = val;
                        }
                        if (!type) return value;
                        var deserializer = deserializers[type] || DESERIALIZER[type];
                        return deserializer ? deserializer(value, key) : value;
                    });
                }(message, ((_deserialize = {}).cross_domain_zalgo_promise = function(serializedPromise) {
                    return function(source, origin, _ref2) {
                        return new promise_ZalgoPromise(_ref2.then);
                    }(0, 0, serializedPromise);
                }, _deserialize.cross_domain_function = function(serializedFunction) {
                    return function(source, origin, _ref4, _ref5) {
                        var id = _ref4.id, name = _ref4.name;
                        var send = _ref5.send;
                        var getDeserializedFunction = function(opts) {
                            void 0 === opts && (opts = {});
                            function crossDomainFunctionWrapper() {
                                var _arguments = arguments;
                                return window_ProxyWindow.toProxyWindow(source, {
                                    send: send
                                }).awaitWindow().then(function(win) {
                                    var meth = lookupMethod(win, id);
                                    if (meth && meth.val !== crossDomainFunctionWrapper) return meth.val.apply({
                                        source: window,
                                        origin: getDomain()
                                    }, _arguments);
                                    var _args = [].slice.call(_arguments);
                                    return opts.fireAndForget ? send(win, "postrobot_method", {
                                        id: id,
                                        name: name,
                                        args: _args
                                    }, {
                                        domain: origin,
                                        fireAndForget: !0
                                    }) : send(win, "postrobot_method", {
                                        id: id,
                                        name: name,
                                        args: _args
                                    }, {
                                        domain: origin,
                                        fireAndForget: !1
                                    }).then(function(res) {
                                        return res.data.result;
                                    });
                                }).catch(function(err) {
                                    throw err;
                                });
                            }
                            crossDomainFunctionWrapper.__name__ = name;
                            crossDomainFunctionWrapper.__origin__ = origin;
                            crossDomainFunctionWrapper.__source__ = source;
                            crossDomainFunctionWrapper.__id__ = id;
                            crossDomainFunctionWrapper.origin = origin;
                            return crossDomainFunctionWrapper;
                        };
                        var crossDomainFunctionWrapper = getDeserializedFunction();
                        crossDomainFunctionWrapper.fireAndForget = getDeserializedFunction({
                            fireAndForget: !0
                        });
                        return crossDomainFunctionWrapper;
                    }(source, origin, serializedFunction, {
                        send: send
                    });
                }, _deserialize.cross_domain_window = function(serializedWindow) {
                    return window_ProxyWindow.deserialize(serializedWindow, {
                        send: send
                    });
                }, _deserialize));
            }
            var SEND_MESSAGE_STRATEGIES = {};
            SEND_MESSAGE_STRATEGIES.postrobot_post_message = function(win, serializedMessage, domain) {
                0 === domain.indexOf("file:") && (domain = "*");
                win.postMessage(serializedMessage, domain);
            };
            function send_sendMessage(win, domain, message, _ref2) {
                var on = _ref2.on, send = _ref2.send;
                return promise_ZalgoPromise.try(function() {
                    var domainBuffer = windowStore().getOrSet(win, function() {
                        return {};
                    });
                    domainBuffer.buffer = domainBuffer.buffer || [];
                    domainBuffer.buffer.push(message);
                    domainBuffer.flush = domainBuffer.flush || promise_ZalgoPromise.flush().then(function() {
                        if (isWindowClosed(win)) throw new Error("Window is closed");
                        var serializedMessage = serializeMessage(win, domain, ((_ref = {}).__post_robot_10_0_41__ = domainBuffer.buffer || [], _ref), {
                            on: on,
                            send: send
                        });
                        var _ref;
                        delete domainBuffer.buffer;
                        var strategies = Object.keys(SEND_MESSAGE_STRATEGIES);
                        var errors = [];
                        for(var _i2 = 0; _i2 < strategies.length; _i2++){
                            var strategyName = strategies[_i2];
                            try {
                                SEND_MESSAGE_STRATEGIES[strategyName](win, serializedMessage, domain);
                            } catch (err) {
                                errors.push(err);
                            }
                        }
                        if (errors.length === strategies.length) throw new Error("All post-robot messaging strategies failed:\n\n" + errors.map(function(err, i) {
                            return i + ". " + stringifyError(err);
                        }).join("\n\n"));
                    });
                    return domainBuffer.flush.then(function() {
                        delete domainBuffer.flush;
                    });
                }).then(src_util_noop);
            }
            function getResponseListener(hash) {
                return globalStore("responseListeners").get(hash);
            }
            function deleteResponseListener(hash) {
                globalStore("responseListeners").del(hash);
            }
            function isResponseListenerErrored(hash) {
                return globalStore("erroredResponseListeners").has(hash);
            }
            function getRequestListener(_ref) {
                var name = _ref.name, win = _ref.win, domain = _ref.domain;
                var requestListeners = windowStore("requestListeners");
                "*" === win && (win = null);
                "*" === domain && (domain = null);
                if (!name) throw new Error("Name required to get request listener");
                for(var _i4 = 0, _ref3 = [
                    win,
                    getWildcard()
                ]; _i4 < _ref3.length; _i4++){
                    var winQualifier = _ref3[_i4];
                    if (winQualifier) {
                        var nameListeners = requestListeners.get(winQualifier);
                        if (nameListeners) {
                            var domainListeners = nameListeners[name];
                            if (domainListeners) {
                                if (domain && "string" == typeof domain) {
                                    if (domainListeners[domain]) return domainListeners[domain];
                                    if (domainListeners.__domain_regex__) for(var _i6 = 0, _domainListeners$__DO2 = domainListeners.__domain_regex__; _i6 < _domainListeners$__DO2.length; _i6++){
                                        var _domainListeners$__DO3 = _domainListeners$__DO2[_i6], listener = _domainListeners$__DO3.listener;
                                        if (matchDomain(_domainListeners$__DO3.regex, domain)) return listener;
                                    }
                                }
                                if (domainListeners["*"]) return domainListeners["*"];
                            }
                        }
                    }
                }
            }
            function handleRequest(source, origin, message, _ref) {
                var on = _ref.on, send = _ref.send;
                var options = getRequestListener({
                    name: message.name,
                    win: source,
                    domain: origin
                });
                var logName = "postrobot_method" === message.name && message.data && "string" == typeof message.data.name ? message.data.name + "()" : message.name;
                function sendResponse(ack, data, error) {
                    return promise_ZalgoPromise.flush().then(function() {
                        if (!message.fireAndForget && !isWindowClosed(source)) try {
                            return send_sendMessage(source, origin, {
                                id: uniqueID(),
                                origin: getDomain(window),
                                type: "postrobot_message_response",
                                hash: message.hash,
                                name: message.name,
                                ack: ack,
                                data: data,
                                error: error
                            }, {
                                on: on,
                                send: send
                            });
                        } catch (err) {
                            throw new Error("Send response message failed for " + logName + " in " + getDomain() + "\n\n" + stringifyError(err));
                        }
                    });
                }
                return promise_ZalgoPromise.all([
                    promise_ZalgoPromise.flush().then(function() {
                        if (!message.fireAndForget && !isWindowClosed(source)) try {
                            return send_sendMessage(source, origin, {
                                id: uniqueID(),
                                origin: getDomain(window),
                                type: "postrobot_message_ack",
                                hash: message.hash,
                                name: message.name
                            }, {
                                on: on,
                                send: send
                            });
                        } catch (err) {
                            throw new Error("Send ack message failed for " + logName + " in " + getDomain() + "\n\n" + stringifyError(err));
                        }
                    }),
                    promise_ZalgoPromise.try(function() {
                        if (!options) throw new Error("No handler found for post message: " + message.name + " from " + origin + " in " + window.location.protocol + "//" + window.location.host + window.location.pathname);
                        if (!matchDomain(options.domain, origin)) throw new Error("Request origin " + origin + " does not match domain " + options.domain.toString());
                        return options.handler({
                            source: source,
                            origin: origin,
                            data: message.data
                        });
                    }).then(function(data) {
                        return sendResponse("success", data);
                    }, function(error) {
                        return sendResponse("error", null, error);
                    })
                ]).then(src_util_noop).catch(function(err) {
                    if (options && options.handleError) return options.handleError(err);
                    throw err;
                });
            }
            function handleAck(source, origin, message) {
                if (!isResponseListenerErrored(message.hash)) {
                    var options = getResponseListener(message.hash);
                    if (!options) throw new Error("No handler found for post message ack for message: " + message.name + " from " + origin + " in " + window.location.protocol + "//" + window.location.host + window.location.pathname);
                    try {
                        if (!matchDomain(options.domain, origin)) throw new Error("Ack origin " + origin + " does not match domain " + options.domain.toString());
                        if (source !== options.win) throw new Error("Ack source does not match registered window");
                    } catch (err) {
                        options.promise.reject(err);
                    }
                    options.ack = !0;
                }
            }
            function handleResponse(source, origin, message) {
                if (!isResponseListenerErrored(message.hash)) {
                    var options = getResponseListener(message.hash);
                    if (!options) throw new Error("No handler found for post message response for message: " + message.name + " from " + origin + " in " + window.location.protocol + "//" + window.location.host + window.location.pathname);
                    if (!matchDomain(options.domain, origin)) throw new Error("Response origin " + origin + " does not match domain " + (pattern = options.domain, Array.isArray(pattern) ? "(" + pattern.join(" | ") + ")" : isRegex(pattern) ? "RegExp(" + pattern.toString() : pattern.toString()));
                    var pattern;
                    if (source !== options.win) throw new Error("Response source does not match registered window");
                    deleteResponseListener(message.hash);
                    "error" === message.ack ? options.promise.reject(message.error) : "success" === message.ack && options.promise.resolve({
                        source: source,
                        origin: origin,
                        data: message.data
                    });
                }
            }
            function receive_receiveMessage(event, _ref2) {
                var on = _ref2.on, send = _ref2.send;
                var receivedMessages = globalStore("receivedMessages");
                try {
                    if (!window || window.closed || !event.source) return;
                } catch (err) {
                    return;
                }
                var source = event.source, origin = event.origin;
                var messages = function(message, source, origin, _ref) {
                    var on = _ref.on, send = _ref.send;
                    var parsedMessage;
                    try {
                        parsedMessage = deserializeMessage(source, origin, message, {
                            on: on,
                            send: send
                        });
                    } catch (err) {
                        return;
                    }
                    if (parsedMessage && "object" == typeof parsedMessage && null !== parsedMessage) {
                        var parseMessages = parsedMessage.__post_robot_10_0_41__;
                        if (Array.isArray(parseMessages)) return parseMessages;
                    }
                }(event.data, source, origin, {
                    on: on,
                    send: send
                });
                if (messages) {
                    markWindowKnown(source);
                    for(var _i2 = 0; _i2 < messages.length; _i2++){
                        var message = messages[_i2];
                        if (receivedMessages.has(message.id)) return;
                        receivedMessages.set(message.id, !0);
                        if (isWindowClosed(source) && !message.fireAndForget) return;
                        0 === message.origin.indexOf("file:") && (origin = "file://");
                        try {
                            "postrobot_message_request" === message.type ? handleRequest(source, origin, message, {
                                on: on,
                                send: send
                            }) : "postrobot_message_response" === message.type ? handleResponse(source, origin, message) : "postrobot_message_ack" === message.type && handleAck(source, origin, message);
                        } catch (err) {
                            setTimeout(function() {
                                throw err;
                            }, 0);
                        }
                    }
                }
            }
            function on_on(name, options, handler) {
                if (!name) throw new Error("Expected name");
                if ("function" == typeof (options = options || {})) {
                    handler = options;
                    options = {};
                }
                if (!handler) throw new Error("Expected handler");
                (options = options || {}).name = name;
                options.handler = handler || options.handler;
                var win = options.window;
                var domain = options.domain;
                var requestListener = function addRequestListener(_ref4, listener) {
                    var name = _ref4.name, win = _ref4.win, domain = _ref4.domain;
                    var requestListeners = windowStore("requestListeners");
                    if (!name || "string" != typeof name) throw new Error("Name required to add request listener");
                    if (Array.isArray(win)) {
                        var listenersCollection = [];
                        for(var _i8 = 0, _win2 = win; _i8 < _win2.length; _i8++)listenersCollection.push(addRequestListener({
                            name: name,
                            domain: domain,
                            win: _win2[_i8]
                        }, listener));
                        return {
                            cancel: function() {
                                for(var _i10 = 0; _i10 < listenersCollection.length; _i10++)listenersCollection[_i10].cancel();
                            }
                        };
                    }
                    if (Array.isArray(domain)) {
                        var _listenersCollection = [];
                        for(var _i12 = 0, _domain2 = domain; _i12 < _domain2.length; _i12++)_listenersCollection.push(addRequestListener({
                            name: name,
                            win: win,
                            domain: _domain2[_i12]
                        }, listener));
                        return {
                            cancel: function() {
                                for(var _i14 = 0; _i14 < _listenersCollection.length; _i14++)_listenersCollection[_i14].cancel();
                            }
                        };
                    }
                    var existingListener = getRequestListener({
                        name: name,
                        win: win,
                        domain: domain
                    });
                    win && "*" !== win || (win = getWildcard());
                    domain = domain || "*";
                    if (existingListener) throw win && domain ? new Error("Request listener already exists for " + name + " on domain " + domain.toString() + " for " + (win === getWildcard() ? "wildcard" : "specified") + " window") : win ? new Error("Request listener already exists for " + name + " for " + (win === getWildcard() ? "wildcard" : "specified") + " window") : domain ? new Error("Request listener already exists for " + name + " on domain " + domain.toString()) : new Error("Request listener already exists for " + name);
                    var nameListeners = requestListeners.getOrSet(win, function() {
                        return {};
                    });
                    var domainListeners = util_getOrSet(nameListeners, name, function() {
                        return {};
                    });
                    var strDomain = domain.toString();
                    var regexListeners;
                    var regexListener;
                    util_isRegex(domain) ? (regexListeners = util_getOrSet(domainListeners, "__domain_regex__", function() {
                        return [];
                    })).push(regexListener = {
                        regex: domain,
                        listener: listener
                    }) : domainListeners[strDomain] = listener;
                    return {
                        cancel: function() {
                            delete domainListeners[strDomain];
                            if (regexListener) {
                                regexListeners.splice(regexListeners.indexOf(regexListener, 1));
                                regexListeners.length || delete domainListeners.__domain_regex__;
                            }
                            Object.keys(domainListeners).length || delete nameListeners[name];
                            win && !Object.keys(nameListeners).length && requestListeners.del(win);
                        }
                    };
                }({
                    name: name,
                    win: win,
                    domain: domain
                }, {
                    handler: options.handler,
                    handleError: options.errorHandler || function(err) {
                        throw err;
                    },
                    window: win,
                    domain: domain || "*",
                    name: name
                });
                return {
                    cancel: function() {
                        requestListener.cancel();
                    }
                };
            }
            function on_once(name, options, handler) {
                if ("function" == typeof (options = options || {})) {
                    handler = options;
                    options = {};
                }
                var promise = new promise_ZalgoPromise;
                var listener;
                options.errorHandler = function(err) {
                    listener.cancel();
                    promise.reject(err);
                };
                listener = on_on(name, options, function(event) {
                    listener.cancel();
                    promise.resolve(event);
                    if (handler) return handler(event);
                });
                promise.cancel = listener.cancel;
                return promise;
            }
            var send_send = function send(win, name, data, options) {
                var domainMatcher = (options = options || {}).domain || "*";
                var responseTimeout = options.timeout || -1;
                var childTimeout = options.timeout || 5e3;
                var fireAndForget = options.fireAndForget || !1;
                return promise_ZalgoPromise.try(function() {
                    !function(name, win, domain) {
                        if (!name) throw new Error("Expected name");
                        if (domain && "string" != typeof domain && !Array.isArray(domain) && !util_isRegex(domain)) throw new TypeError("Can not send " + name + ". Expected domain " + JSON.stringify(domain) + " to be a string, array, or regex");
                        if (isWindowClosed(win)) throw new Error("Can not send " + name + ". Target window is closed");
                    }(name, win, domainMatcher);
                    if (function(parent, child) {
                        var actualParent = getAncestor(child);
                        if (actualParent) return actualParent === parent;
                        if (child === parent) return !1;
                        if (function(win) {
                            void 0 === win && (win = window);
                            try {
                                if (win.top) return win.top;
                            } catch (err) {}
                            if (getParent(win) === win) return win;
                            try {
                                if (isAncestorParent(window, win) && window.top) return window.top;
                            } catch (err) {}
                            try {
                                if (isAncestorParent(win, window) && window.top) return window.top;
                            } catch (err) {}
                            for(var _i7 = 0, _getAllChildFrames4 = function getAllChildFrames(win) {
                                var result = [];
                                for(var _i3 = 0, _getFrames2 = getFrames(win); _i3 < _getFrames2.length; _i3++){
                                    var frame = _getFrames2[_i3];
                                    result.push(frame);
                                    for(var _i5 = 0, _getAllChildFrames2 = getAllChildFrames(frame); _i5 < _getAllChildFrames2.length; _i5++)result.push(_getAllChildFrames2[_i5]);
                                }
                                return result;
                            }(win); _i7 < _getAllChildFrames4.length; _i7++){
                                var frame = _getAllChildFrames4[_i7];
                                try {
                                    if (frame.top) return frame.top;
                                } catch (err) {}
                                if (getParent(frame) === frame) return frame;
                            }
                        }(child) === child) return !1;
                        for(var _i15 = 0, _getFrames8 = getFrames(parent); _i15 < _getFrames8.length; _i15++)if (_getFrames8[_i15] === child) return !0;
                        return !1;
                    }(window, win)) return function(win, timeout, name) {
                        void 0 === timeout && (timeout = 5e3);
                        void 0 === name && (name = "Window");
                        var promise = function(win) {
                            return windowStore("helloPromises").getOrSet(win, function() {
                                return new promise_ZalgoPromise;
                            });
                        }(win);
                        -1 !== timeout && (promise = promise.timeout(timeout, new Error(name + " did not load after " + timeout + "ms")));
                        return promise;
                    }(win, childTimeout);
                }).then(function(_temp) {
                    return function(win, targetDomain, actualDomain, _ref) {
                        var send = _ref.send;
                        return promise_ZalgoPromise.try(function() {
                            return "string" == typeof targetDomain ? targetDomain : promise_ZalgoPromise.try(function() {
                                return actualDomain || sayHello(win, {
                                    send: send
                                }).then(function(_ref2) {
                                    return _ref2.domain;
                                });
                            }).then(function(normalizedDomain) {
                                if (!matchDomain(targetDomain, targetDomain)) throw new Error("Domain " + stringify(targetDomain) + " does not match " + stringify(targetDomain));
                                return normalizedDomain;
                            });
                        });
                    }(win, domainMatcher, (void 0 === _temp ? {} : _temp).domain, {
                        send: send
                    });
                }).then(function(targetDomain) {
                    var domain = targetDomain;
                    var logName = "postrobot_method" === name && data && "string" == typeof data.name ? data.name + "()" : name;
                    var promise = new promise_ZalgoPromise;
                    var hash = name + "_" + uniqueID();
                    if (!fireAndForget) {
                        var responseListener = {
                            name: name,
                            win: win,
                            domain: domain,
                            promise: promise
                        };
                        !function(hash, listener) {
                            globalStore("responseListeners").set(hash, listener);
                        }(hash, responseListener);
                        var reqPromises = windowStore("requestPromises").getOrSet(win, function() {
                            return [];
                        });
                        reqPromises.push(promise);
                        promise.catch(function() {
                            !function(hash) {
                                globalStore("erroredResponseListeners").set(hash, !0);
                            }(hash);
                            deleteResponseListener(hash);
                        });
                        var totalAckTimeout = function(win) {
                            return windowStore("knownWindows").get(win, !1);
                        }(win) ? 1e4 : 2e3;
                        var totalResTimeout = responseTimeout;
                        var ackTimeout = totalAckTimeout;
                        var resTimeout = totalResTimeout;
                        var interval = function(method, time) {
                            var timeout;
                            !function loop() {
                                timeout = setTimeout(function() {
                                    !function() {
                                        if (isWindowClosed(win)) return promise.reject(new Error("Window closed for " + name + " before " + (responseListener.ack ? "response" : "ack")));
                                        if (responseListener.cancelled) return promise.reject(new Error("Response listener was cancelled for " + name));
                                        ackTimeout = Math.max(ackTimeout - 500, 0);
                                        -1 !== resTimeout && (resTimeout = Math.max(resTimeout - 500, 0));
                                        responseListener.ack || 0 !== ackTimeout ? 0 === resTimeout && promise.reject(new Error("No response for postMessage " + logName + " in " + getDomain() + " in " + totalResTimeout + "ms")) : promise.reject(new Error("No ack for postMessage " + logName + " in " + getDomain() + " in " + totalAckTimeout + "ms"));
                                    }();
                                    loop();
                                }, 500);
                            }();
                            return {
                                cancel: function() {
                                    clearTimeout(timeout);
                                }
                            };
                        }();
                        promise.finally(function() {
                            interval.cancel();
                            reqPromises.splice(reqPromises.indexOf(promise, 1));
                        }).catch(src_util_noop);
                    }
                    return send_sendMessage(win, domain, {
                        id: uniqueID(),
                        origin: getDomain(window),
                        type: "postrobot_message_request",
                        hash: hash,
                        name: name,
                        data: data,
                        fireAndForget: fireAndForget
                    }, {
                        on: on_on,
                        send: send
                    }).then(function() {
                        return fireAndForget ? promise.resolve() : promise;
                    }, function(err) {
                        throw new Error("Send request message failed for " + logName + " in " + getDomain() + "\n\n" + stringifyError(err));
                    });
                });
            };
            function setup_serializeMessage(destination, domain, obj) {
                return serializeMessage(destination, domain, obj, {
                    on: on_on,
                    send: send_send
                });
            }
            function setup_deserializeMessage(source, origin, message) {
                return deserializeMessage(source, origin, message, {
                    on: on_on,
                    send: send_send
                });
            }
            function createProxyWindow(win) {
                return new window_ProxyWindow({
                    send: send_send,
                    win: win
                });
            }
            function setup_toProxyWindow(win) {
                return window_ProxyWindow.toProxyWindow(win, {
                    send: send_send
                });
            }
            function setup() {
                if (!global_getGlobal().initialized) {
                    global_getGlobal().initialized = !0;
                    on = (_ref3 = {
                        on: on_on,
                        send: send_send
                    }).on, send = _ref3.send, (global = global_getGlobal()).receiveMessage = global.receiveMessage || function(message) {
                        return receive_receiveMessage(message, {
                            on: on,
                            send: send
                        });
                    };
                    !function(_ref5) {
                        var on = _ref5.on, send = _ref5.send;
                        globalStore().getOrSet("postMessageListener", function() {
                            return function(obj, event, handler) {
                                obj.addEventListener("message", handler);
                                return {
                                    cancel: function() {
                                        obj.removeEventListener("message", handler);
                                    }
                                };
                            }(window, 0, function(event) {
                                !function(event, _ref4) {
                                    var on = _ref4.on, send = _ref4.send;
                                    promise_ZalgoPromise.try(function() {
                                        var source = event.source || event.sourceElement;
                                        var origin = event.origin || event.originalEvent && event.originalEvent.origin;
                                        var data = event.data;
                                        "null" === origin && (origin = "file://");
                                        if (source) {
                                            if (!origin) throw new Error("Post message did not have origin domain");
                                            receive_receiveMessage({
                                                source: source,
                                                origin: origin,
                                                data: data
                                            }, {
                                                on: on,
                                                send: send
                                            });
                                        }
                                    });
                                }(event, {
                                    on: on,
                                    send: send
                                });
                            });
                        });
                    }({
                        on: on_on,
                        send: send_send
                    });
                    !function(_ref8) {
                        var on = _ref8.on, send = _ref8.send;
                        globalStore("builtinListeners").getOrSet("helloListener", function() {
                            var listener = on("postrobot_hello", {
                                domain: "*"
                            }, function(_ref3) {
                                resolveHelloPromise(_ref3.source, {
                                    domain: _ref3.origin
                                });
                                return {
                                    instanceID: getInstanceID()
                                };
                            });
                            var parent = getAncestor();
                            parent && sayHello(parent, {
                                send: send
                            }).catch(function(err) {});
                            return listener;
                        });
                    }({
                        on: on_on,
                        send: send_send
                    });
                }
                var _ref3, on, send, global;
            }
            function destroy() {
                !function() {
                    var responseListeners = globalStore("responseListeners");
                    for(var _i2 = 0, _responseListeners$ke2 = responseListeners.keys(); _i2 < _responseListeners$ke2.length; _i2++){
                        var hash = _responseListeners$ke2[_i2];
                        var listener = responseListeners.get(hash);
                        listener && (listener.cancelled = !0);
                        responseListeners.del(hash);
                    }
                }();
                (listener = globalStore().get("postMessageListener")) && listener.cancel();
                var listener;
                delete window.__post_robot_10_0_41__;
            }
            var src_types_TYPES_0 = !0;
            function cleanUpWindow(win) {
                for(var _i2 = 0, _requestPromises$get2 = windowStore("requestPromises").get(win, []); _i2 < _requestPromises$get2.length; _i2++)_requestPromises$get2[_i2].reject(new Error("Window " + (isWindowClosed(win) ? "closed" : "cleaned up") + " before response")).catch(src_util_noop);
            }
            setup();
        }
    ]);
});

});


parcelRegister("2UTCi", function(module, exports) {
"use strict";
var $21fbf40a931df5ba$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $21fbf40a931df5ba$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BRIDGE_HANDSHAKE_TIMEOUT_MS = module.exports.THEME_CHANGE_EVENT = module.exports.THEME_ENABLE_EVENT = module.exports.READY_EVENT = module.exports.handleMissingHandlerError = module.exports.firstToResolve = void 0;
var $21fbf40a931df5ba$var$invertPromise = function(p) {
    return new Promise(function(resolve, reject) {
        return p.then(reject, resolve);
    });
};
var $21fbf40a931df5ba$var$firstToResolve = function(promises) {
    return $21fbf40a931df5ba$var$__awaiter(void 0, void 0, void 0, function() {
        var err_1;
        return $21fbf40a931df5ba$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    _a.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4 /*yield*/ ,
                        $21fbf40a931df5ba$var$invertPromise(Promise.all(promises.map($21fbf40a931df5ba$var$invertPromise)))
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
                case 2:
                    err_1 = _a.sent();
                    throw err_1[0];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
module.exports.firstToResolve = $21fbf40a931df5ba$var$firstToResolve;
var $21fbf40a931df5ba$var$handleMissingHandlerError = function(error) {
    if (error === null || error === void 0 ? void 0 : error.message.startsWith('No handler found for post message:')) return Promise.resolve();
    else return Promise.reject("Error while sending bridge message: ".concat(error === null || error === void 0 ? void 0 : error.message));
};
module.exports.handleMissingHandlerError = $21fbf40a931df5ba$var$handleMissingHandlerError;
module.exports.READY_EVENT = '__ready';
module.exports.THEME_ENABLE_EVENT = '__theme_enable';
module.exports.THEME_CHANGE_EVENT = '__theme_change';
module.exports.BRIDGE_HANDSHAKE_TIMEOUT_MS = 20000;

});







parcelRegister("x6DEi", function(module, exports) {
$parcel$export(module.exports, "isBinaryContentType", () => $4aafef57fff08661$export$da8d8c42bfb20907);
$parcel$export(module.exports, "useProductFetchClient", () => $4aafef57fff08661$export$2f041121bdb61a5);

var $1fMqv = parcelRequire("1fMqv");

var $kuAvn = parcelRequire("kuAvn");

var $eJOHy = parcelRequire("eJOHy");

var $lopBx = parcelRequire("lopBx");
var $7pw1V = parcelRequire("7pw1V");

var $kKhkW = parcelRequire("kKhkW");

var $bKKF4 = parcelRequire("bKKF4");
var $cwqPy = parcelRequire("cwqPy");
var $aD1DH = parcelRequire("aD1DH");

var $eGOwo = parcelRequire("eGOwo");

var $63yBZ = parcelRequire("63yBZ");

var $6QUJr = parcelRequire("6QUJr");

var $grXB3 = parcelRequire("grXB3");
const $4aafef57fff08661$export$ed8186c9e5e5ba23 = (0, $kuAvn.default)`
	mutation forge_ui_userAuthTokenForExtension($input: UserAuthTokenForExtensionInput!) {
		userAuthTokenForExtension(input: $input) {
			success
			errors {
				message
			}
			authToken {
				token
				ttl
			}
		}
	}
`;
const $4aafef57fff08661$var$validProducts = [
    'confluence',
    'jira',
    'bitbucket'
];
const $4aafef57fff08661$var$apiGatewayUrlMap = {
    dev: 'api.stg.atlassian.com',
    stg: 'api.stg.atlassian.com',
    prod: 'api.atlassian.com'
};
const $4aafef57fff08661$var$getApiGatewayUrl = (environment)=>{
    const apiBase = $4aafef57fff08661$var$apiGatewayUrlMap[environment];
    const url = (0, $lopBx.isFedRamp)() ? apiBase.replace('atlassian.com', 'atlassian-us-gov-mod.com') : apiBase;
    if (!url) throw new Error(`Invalid environment: ${environment}`);
    return url;
};
const $4aafef57fff08661$var$getBaseUrlForIsolatedCloud = (product, cloudId)=>{
    if (product === 'bitbucket') throw new Error('product not supported in Isolated Cloud yet.');
    const apiBase = `api.${(0, $7pw1V.isolatedCloudDomain)()}`;
    return `https://${apiBase}/ex/${product}/${cloudId}`;
};
function $4aafef57fff08661$var$getBaseUrlForCommercialAndFedRamp(environment, product, cloudId) {
    if (product === 'bitbucket') return environment === 'prod' ? 'https://api.bitbucket.org' : 'https://api.integration.bb-inf.net';
    const apiBase = $4aafef57fff08661$var$getApiGatewayUrl(environment);
    return `https://${apiBase}/ex/${product}/${cloudId}`;
}
function $4aafef57fff08661$var$getBaseUrl(environment, product, cloudId) {
    if ((0, $eGOwo.fg)('forge-ui-oasis-enabled')) return (0, $7pw1V.isIsolatedCloud)() ? $4aafef57fff08661$var$getBaseUrlForIsolatedCloud(product, cloudId) : $4aafef57fff08661$var$getBaseUrlForCommercialAndFedRamp(environment, product, cloudId);
    return $4aafef57fff08661$var$getBaseUrlForCommercialAndFedRamp(environment, product, cloudId);
}
function $4aafef57fff08661$var$createProductUrl(environment, product, restPath, cloudId) {
    const baseUrl = $4aafef57fff08661$var$getBaseUrl(environment, product, cloudId);
    const fullUrl = // bitbucket requests could be made with absolute URLs
    // e.g. when following href links in API responses
    product === 'bitbucket' && restPath.startsWith(`${baseUrl}/`) ? restPath : `${baseUrl}${restPath}`;
    const productUrl = new URL(fullUrl).toString();
    if (!productUrl.startsWith(`${baseUrl}/`)) throw new Error('Invalid product URL');
    return productUrl;
}
function $4aafef57fff08661$var$isTokenValid(token) {
    return !!(token && token.expiry > Date.now());
}
function $4aafef57fff08661$var$isProduct(product) {
    return $4aafef57fff08661$var$validProducts.includes(product);
}
function $4aafef57fff08661$export$da8d8c42bfb20907(contentType) {
    return Boolean(contentType && !contentType.includes('application/json') && contentType.search(/text\//) === -1);
}
function $4aafef57fff08661$var$parseFormData(formLike) {
    const form = new FormData();
    for (const [key, value] of Object.entries(formLike))if (key === 'file') {
        const fileName = formLike['__fileName'];
        const mimeType = formLike['__fileType'];
        // convert back from base64 to File (Blob)
        const blob = (0, $bKKF4.base64ToBlob)(value, mimeType);
        const file = new File([
            blob
        ], fileName, {
            type: mimeType
        });
        form.append('file', file);
    } else form.append(key, value);
    // remove request metadata properties
    form.delete('__fileName');
    form.delete('__fileType');
    return form;
}
const $4aafef57fff08661$var$MILLIS_IN_SECOND = 1000;
const $4aafef57fff08661$var$requestProduct = async (url, init)=>{
    const response = await fetch(url, init);
    const isAttachment = $4aafef57fff08661$export$da8d8c42bfb20907(response.headers.get('content-type'));
    if (response.ok && response.body !== null && response.status !== 204 && isAttachment) {
        const b64Content = await (0, $bKKF4.blobToBase64)(await response.blob());
        return new Response(b64Content, {
            status: response.status,
            statusText: response.statusText,
            headers: response.headers
        });
    }
    return response;
};
function $4aafef57fff08661$export$2f041121bdb61a5({ appId: appId, extensionId: extensionId, accountType: accountType, environment: environment, cloudId: cloudId, workspaceId: workspaceId, renderThreeLOPrompt: renderThreeLOPrompt, options: options, contextIds: contextIds = [] }) {
    const { captureEvent: captureEvent } = (0, $grXB3.usePerformanceAnalytics)();
    const [mutationFunction] = (0, $1fMqv.useMutation)($4aafef57fff08661$export$ed8186c9e5e5ba23, options);
    const authTokenRef = (0, $eJOHy.useRef)(undefined);
    const tracing = (0, $kKhkW.useTracingContext)();
    /**
	 * Workspace based products like Trello and Bitbucket will not pass in cloudId,
	 * they will pass in workspaceId instead.
	 */ if (!cloudId && !workspaceId) return async ()=>{
        throw new Error('Product APIs are not available in this module. Remove requestConfluence, requestJira or requestBitbucket from your code.');
    };
    const fetchOAuthToken = async (extensionId, contextIds)=>{
        tracing?.recordGqlCall('userAuthTokenForExtension - start');
        const { data: data } = await mutationFunction({
            variables: {
                input: {
                    extensionId: extensionId,
                    contextIds: contextIds
                }
            },
            context: {
                headers: {
                    'atl-attribution': (0, $cwqPy.createAtlAttributionHeader)(contextIds.sort().join())
                }
            }
        });
        if (data?.userAuthTokenForExtension) {
            const { success: success, authToken: authToken, errors: errors } = data.userAuthTokenForExtension;
            tracing?.recordGqlCall('userAuthTokenForExtension - end');
            if (!success && errors && errors[0].message.includes('No Atlassian OAuth token found for this user and extension')) return new Promise((resolve)=>{
                renderThreeLOPrompt(async ()=>{
                    const token = await fetchOAuthToken(extensionId, contextIds);
                    resolve(token);
                });
            });
            if (success && authToken) {
                const { token: token, ttl: ttl } = authToken;
                return {
                    token: token,
                    expiry: Date.now() + ttl * $4aafef57fff08661$var$MILLIS_IN_SECOND
                };
            }
        }
        throw new Error('An unexpected error occurred when fetching an auth token');
    };
    const cdnEnvironment = (0, $aD1DH.getCDNEnvironment)(environment);
    return async (restPath, product, init, isMultipartFormData)=>{
        if (!$4aafef57fff08661$var$isProduct(product)) throw new Error(`Invalid product: ${product}`);
        const requestAuthStartMark = (0, $6QUJr.getPerformanceMark)();
        if ((0, $eGOwo.fg)('forge-ui-performance-analytics-provider')) captureEvent?.({
            type: 'product-api-request-initiated',
            elapsed: requestAuthStartMark
        });
        const atlassianAccount = !accountType || accountType === 'atlassian';
        if (!$4aafef57fff08661$var$isTokenValid(authTokenRef.current) && atlassianAccount) authTokenRef.current = await fetchOAuthToken(extensionId, contextIds);
        const headers = new Headers(init.headers);
        headers.set('Authorization', `Bearer ${authTokenRef?.current?.token}`);
        if ((0, $eGOwo.fg)('forge-ui-add-x-ecosystem-user-agent-header')) {
            // this header is used to identify requests made by Forge, based on:
            // https://hello.atlassian.net/wiki/x/O5jUIwE?atlOrigin=eyJpIjoiM2NhNjU1MDUxOWJkNDcxNThiNzJjNWU1NzE5Y2FmZTMiLCJwIjoiYyJ9
            const appAri = (0, $63yBZ.createAppAri)({
                appId: appId
            }).toString();
            headers.set('x-ecosystem-user-agent', `forge ${appAri}`);
        }
        const body = isMultipartFormData ? $4aafef57fff08661$var$parseFormData(JSON.parse(init.body)) : init.body;
        if (isMultipartFormData) // let the fetch api correctly set the multipart/form-data content-type
        // https://github.com/github/fetch/issues/505#issuecomment-293064470
        headers.delete('content-type');
        const requestAuthEndMark = (0, $6QUJr.getPerformanceMark)();
        const request = $4aafef57fff08661$var$requestProduct($4aafef57fff08661$var$createProductUrl(cdnEnvironment, product, restPath, cloudId), {
            ...init,
            body: body,
            headers: headers
        });
        if ((0, $eGOwo.fg)('forge-ui-performance-analytics-provider')) request.then((_)=>{
            const requestEndMark = (0, $6QUJr.getPerformanceMark)();
            captureEvent?.({
                type: 'product-api-requested',
                duration: requestEndMark - requestAuthStartMark,
                authDuration: requestAuthEndMark - requestAuthStartMark,
                elapsed: requestEndMark
            });
        });
        return request;
    };
}

});
parcelRegister("bKKF4", function(module, exports) {
$parcel$export(module.exports, "base64ToBlob", () => $9d74bfc107667d68$export$b3fb17ae4345ac8f);
$parcel$export(module.exports, "blobToBase64", () => $9d74bfc107667d68$export$47a328b4cabd57cc);
const $9d74bfc107667d68$export$b3fb17ae4345ac8f = (b64string, mimeType)=>{
    const base64Data = b64string.split(',')[1];
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for(let i = 0; i < byteCharacters.length; i++)byteNumbers[i] = byteCharacters.charCodeAt(i);
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([
        byteArray
    ], {
        type: mimeType
    });
};
const $9d74bfc107667d68$export$47a328b4cabd57cc = (blob)=>{
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onloadend = ()=>{
            resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
};

});


parcelRegister("asA27", function(module, exports) {
$parcel$export(module.exports, "useNavigation", () => $e87503a545d75caa$export$d0fd4b7106de2769);
/* useNavigation.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $ftN6c = parcelRequire("ftN6c");


var $goZPP = parcelRequire("goZPP");

var $5qJVF = parcelRequire("5qJVF");

var $gHHv2 = parcelRequire("gHHv2");
var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");
var $956it = parcelRequire("956it");

var $dHXR3 = parcelRequire("dHXR3");

var $f3yFH = parcelRequire("f3yFH");

var $hXtQI = parcelRequire("hXtQI");

var $gQw4t = parcelRequire("gQw4t");

var $dRcl3 = parcelRequire("dRcl3");

var $2lpkv = parcelRequire("2lpkv");

var $3NLJg = parcelRequire("3NLJg");
const $e87503a545d75caa$var$cssActionItem = null;
function $e87503a545d75caa$export$d0fd4b7106de2769({ extension: extension, push: push }) {
    const [modalState, setModalState] = (0, $eJOHy.useState)({
        state: 'closed'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const egressService = (0, $dRcl3.useEgressPermissionService)('FETCH_CLIENT_SIDE', extension.egress);
    return {
        onNavigate: async ({ type: type, url: urlString })=>{
            const url = (0, $2lpkv.makeUrl)(urlString);
            const linkType = $e87503a545d75caa$export$8071740a02e53ce2(url, egressService);
            if (linkType === 'invalid' || !url) throw new (0, $f3yFH.BridgeClientError)(`link is invalid: ${urlString}`);
            if (linkType === 'trusted') {
                (0, $hXtQI.navigate)(url.href, type, push);
                return;
            }
            const analyticsAttributes = $e87503a545d75caa$export$e748b6351ba5f204(url);
            return new Promise((resolve, reject)=>{
                // TODO: remove this event once we have switched over to the new event schema
                // https://ecosystem-platform.atlassian.net/browse/EXT-2196
                createAnalyticsEvent({
                    eventType: (0, $d6f34b7bd34f6138$export$a1562d08625f5d7e),
                    data: {
                        action: 'viewed',
                        actionSubject: 'externalLinkModal',
                        attributes: analyticsAttributes
                    }
                }).fire((0, $dHXR3.FORGE_UI_ANALYTICS_CHANNEL));
                setModalState({
                    state: 'open',
                    url: url,
                    onConfirm: ()=>{
                        (0, $hXtQI.navigate)(url.href, type, push);
                        // TODO: remove this event once we have switched over to the new event schema
                        // https://ecosystem-platform.atlassian.net/browse/EXT-2196
                        createAnalyticsEvent({
                            eventType: (0, $d6f34b7bd34f6138$export$a1562d08625f5d7e),
                            data: {
                                action: 'approved',
                                actionSubject: 'externalLinkModal',
                                attributes: analyticsAttributes
                            }
                        }).fire((0, $dHXR3.FORGE_UI_ANALYTICS_CHANNEL));
                        resolve();
                    },
                    onCancel: ()=>{
                        // TODO: remove this event once we have switched over to the new event schema
                        // https://ecosystem-platform.atlassian.net/browse/EXT-2196
                        createAnalyticsEvent({
                            eventType: (0, $d6f34b7bd34f6138$export$a1562d08625f5d7e),
                            data: {
                                action: 'cancelled',
                                actionSubject: 'externalLinkModal',
                                attributes: analyticsAttributes
                            }
                        }).fire((0, $dHXR3.FORGE_UI_ANALYTICS_CHANNEL));
                        reject(new (0, $f3yFH.BridgeClientError)('cancelled'));
                    }
                });
            });
        },
        getModalJsx: ()=>{
            if (modalState.state === 'closed') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $956it.default), {});
            const ModalFooter = ()=>{
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kseeK.default), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- to avoid import of css module from @compiled/react
                        className: (0, $hcewu.default)([
                            "_1e0c1txw _1bah1yb4 _1bsb1osq"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
                                href: "https://go.atlassian.com/forge-help-app-security",
                                appearance: "subtle-link",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                className: (0, $hcewu.default)([
                                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf"
                                ]),
                                children: "Learn more about app security"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                className: (0, $hcewu.default)([
                                    "_1e0c116y _19pkidpf _2hwxr5cr _otyridpf _18u0r5cr"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                                        className: (0, $hcewu.default)([
                                            "_16jlkb7n _1o9zidpf _i0dl1wug _19pkidpf _2hwx1b66 _otyridpf _18u01b66"
                                        ]),
                                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
                                            appearance: "subtle",
                                            onClick: ()=>{
                                                setModalState({
                                                    state: 'closed'
                                                });
                                                modalState.onCancel();
                                            },
                                            children: "Cancel"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                                        className: (0, $hcewu.default)([
                                            "_16jlkb7n _1o9zidpf _i0dl1wug _19pkidpf _2hwx1b66 _otyridpf _18u01b66"
                                        ]),
                                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
                                            appearance: "warning",
                                            onClick: ()=>{
                                                modalState.onConfirm();
                                                setModalState({
                                                    state: 'closed'
                                                });
                                            },
                                            children: "Continue"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                });
            };
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $956it.default), {
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gHHv2.default), {
                    onClose: ()=>{
                        setModalState({
                            state: 'closed'
                        });
                        modalState.onCancel();
                    },
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2qG7I.default), {
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5a9Ro.default), {
                                appearance: "warning",
                                children: `Opening external page on ${modalState.url.hostname}`
                            })
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $ik0CA.default), {
                            children: [
                                extension.properties?.title ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $5qJVF.default), {
                                    as: "p",
                                    children: [
                                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                                            as: "strong",
                                            children: extension.properties.title
                                        }),
                                        " is sending you to an external page. Ensure you trust that page before you continue."
                                    ]
                                }) : /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $5qJVF.default), {
                                    as: "p",
                                    children: [
                                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                                            as: "strong",
                                            children: "This app"
                                        }),
                                        " is sending you to an external page. Ensure you trust that page before you continue."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                                    as: "p",
                                    maxLines: 1,
                                    children: modalState.url.href
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)(ModalFooter, {})
                    ]
                })
            });
        }
    };
}
const $e87503a545d75caa$var$getRootDomain = (url)=>{
    const hostnameParts = url.hostname.split('.');
    // Root domain consists of the last two parts of the hostname
    if (hostnameParts.length > 1) return hostnameParts.slice(-2).join('.');
    else // If there's only one part, return it (e.g., 'localhost')
    return url.hostname;
};
function $e87503a545d75caa$export$8071740a02e53ce2(url, egressService) {
    if (!url) return 'invalid';
    if (url.protocol === 'mailto:') return 'trusted';
    if (url.protocol === 'tel:') return 'trusted';
    try {
        // URL is listed under permissions in manifest
        if (egressService.isValidUrl(url.href)) return 'trusted';
        // URL is from same origin
        if (url.origin === (0, $gQw4t.getOrigin)()) return 'trusted';
        // URL is under a trusted atlassian domain
        const rootDomain = $e87503a545d75caa$var$getRootDomain(url);
        if ((0, $3NLJg.TRUSTED_ROOT_DOMAINS).includes(rootDomain)) return 'trusted';
        if ([
            'https:',
            'http:'
        ].includes(url.protocol)) return 'external';
    } catch  {}
    return 'invalid';
}
function $e87503a545d75caa$export$e748b6351ba5f204(url) {
    // Don't count the initial `?` in the query string length.
    const queryStringSize = url.search.length > 1 ? url.search.length - 1 : 0;
    return {
        url: url.href,
        queryStringSize: queryStringSize
    };
}

});
parcelRegister("hXtQI", function(module, exports) {
$parcel$export(module.exports, "navigate", () => $08f7807726110f36$export$ff7962acd6052c28);
function $08f7807726110f36$export$ff7962acd6052c28(url, type, push) {
    switch(type){
        case 'new-tab':
            window.open(url, '_blank', 'noopener noreferrer');
            break;
        case 'same-tab':
            if (push) push(url);
            else window.location.href = url;
            break;
    }
}

});

parcelRegister("gQw4t", function(module, exports) {
$parcel$export(module.exports, "getOrigin", () => $2f57b175fd8c2c8a$export$5a759dc7a1cfb72a);
const $2f57b175fd8c2c8a$export$5a759dc7a1cfb72a = ()=>{
    return window.location.origin;
};

});

parcelRegister("dRcl3", function(module, exports) {
$parcel$export(module.exports, "egressPermissionService", () => $0d2c9f74e9c7cc40$export$440f6339165c68d2);
$parcel$export(module.exports, "useEgressPermissionService", () => $0d2c9f74e9c7cc40$export$8a0b6b45ac3015d5);

var $eJOHy = parcelRequire("eJOHy");

var $hxydL = parcelRequire("hxydL");
const $0d2c9f74e9c7cc40$export$440f6339165c68d2 = (permissionType, egress)=>{
    const egressUrls = (egress || []).find((permission)=>permission.type === permissionType);
    const allowedUrls = egressUrls ? egressUrls.addresses : [];
    return new (0, $hxydL.EgressFilteringService)(allowedUrls);
};
const $0d2c9f74e9c7cc40$export$8a0b6b45ac3015d5 = (permissionType, egress)=>{
    return (0, $eJOHy.useMemo)(()=>{
        return $0d2c9f74e9c7cc40$export$440f6339165c68d2(permissionType, egress);
    }, [
        permissionType,
        egress
    ]);
};

});
parcelRegister("hxydL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dnskZ = parcelRequire("dnskZ");

$dnskZ.__exportStar((parcelRequire("e7ZqU")), module.exports);

});
parcelRegister("e7ZqU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dnskZ = parcelRequire("dnskZ");

$dnskZ.__exportStar((parcelRequire("9N6SQ")), module.exports);

$dnskZ.__exportStar((parcelRequire("heUAo")), module.exports);

});
parcelRegister("9N6SQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EgressFilteringService = void 0;

var $aN3lj = parcelRequire("aN3lj");

var $7WJ1X = parcelRequire("7WJ1X");
class $720e079d17dbae9d$var$EgressFilteringService {
    URLs;
    wildcardDomains;
    allowsEverything;
    constructor(allowList){
        this.URLs = allowList.filter((domainOrURL)=>!domainOrURL.startsWith('*')).map((url)=>this.parseUrl(url));
        this.wildcardDomains = allowList.filter((domainOrURL)=>domainOrURL !== '*').map((url)=>this.parseUrl(url)).filter((url)=>decodeURIComponent(url.hostname).startsWith('*'));
        this.allowsEverything = allowList.includes('*');
    }
    parseUrl(url) {
        return (0, $7WJ1X.parseUrl)(url);
    }
    containsWildCardEgress() {
        return this.allowsEverything;
    }
    isValidUrl(url) {
        if (this.allowsEverything) return true;
        const parsedUrl = this.parseUrl(url);
        return this.allowedDomain(parsedUrl, this.URLs) || this.allowedDomain(parsedUrl, this.wildcardDomains);
    }
    allowedDomain(domain, allowList) {
        return allowList.filter((allowed)=>allowed.protocol === domain.protocol).some((url)=>(0, $aN3lj.minimatch)(domain.hostname, decodeURIComponent(url.hostname)));
    }
}
module.exports.EgressFilteringService = $720e079d17dbae9d$var$EgressFilteringService;

});
parcelRegister("aN3lj", function(module, exports) {

var $igDjg = parcelRequire("igDjg");
"use strict";
var $7db112c51fdf9eb6$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.unescape = module.exports.escape = module.exports.AST = module.exports.Minimatch = module.exports.match = module.exports.makeRe = module.exports.braceExpand = module.exports.defaults = module.exports.filter = module.exports.GLOBSTAR = module.exports.sep = module.exports.minimatch = void 0;

const $7db112c51fdf9eb6$var$brace_expansion_1 = $7db112c51fdf9eb6$var$__importDefault((parcelRequire("fapoe")));

var $1rST3 = parcelRequire("1rST3");

var $bhGjx = parcelRequire("bhGjx");

var $eMqju = parcelRequire("eMqju");

var $86rUr = parcelRequire("86rUr");
const $7db112c51fdf9eb6$var$minimatch = (p, pattern, options = {})=>{
    (0, $1rST3.assertValidPattern)(pattern);
    // shortcut: comments match nothing.
    if (!options.nocomment && pattern.charAt(0) === '#') return false;
    return new $7db112c51fdf9eb6$var$Minimatch(pattern, options).match(p);
};
module.exports.minimatch = $7db112c51fdf9eb6$var$minimatch;
// Optimized checking for the most common glob patterns.
const $7db112c51fdf9eb6$var$starDotExtRE = /^\*+([^+@!?\*\[\(]*)$/;
const $7db112c51fdf9eb6$var$starDotExtTest = (ext)=>(f)=>!f.startsWith('.') && f.endsWith(ext);
const $7db112c51fdf9eb6$var$starDotExtTestDot = (ext)=>(f)=>f.endsWith(ext);
const $7db112c51fdf9eb6$var$starDotExtTestNocase = (ext)=>{
    ext = ext.toLowerCase();
    return (f)=>!f.startsWith('.') && f.toLowerCase().endsWith(ext);
};
const $7db112c51fdf9eb6$var$starDotExtTestNocaseDot = (ext)=>{
    ext = ext.toLowerCase();
    return (f)=>f.toLowerCase().endsWith(ext);
};
const $7db112c51fdf9eb6$var$starDotStarRE = /^\*+\.\*+$/;
const $7db112c51fdf9eb6$var$starDotStarTest = (f)=>!f.startsWith('.') && f.includes('.');
const $7db112c51fdf9eb6$var$starDotStarTestDot = (f)=>f !== '.' && f !== '..' && f.includes('.');
const $7db112c51fdf9eb6$var$dotStarRE = /^\.\*+$/;
const $7db112c51fdf9eb6$var$dotStarTest = (f)=>f !== '.' && f !== '..' && f.startsWith('.');
const $7db112c51fdf9eb6$var$starRE = /^\*+$/;
const $7db112c51fdf9eb6$var$starTest = (f)=>f.length !== 0 && !f.startsWith('.');
const $7db112c51fdf9eb6$var$starTestDot = (f)=>f.length !== 0 && f !== '.' && f !== '..';
const $7db112c51fdf9eb6$var$qmarksRE = /^\?+([^+@!?\*\[\(]*)?$/;
const $7db112c51fdf9eb6$var$qmarksTestNocase = ([$0, ext = ''])=>{
    const noext = $7db112c51fdf9eb6$var$qmarksTestNoExt([
        $0
    ]);
    if (!ext) return noext;
    ext = ext.toLowerCase();
    return (f)=>noext(f) && f.toLowerCase().endsWith(ext);
};
const $7db112c51fdf9eb6$var$qmarksTestNocaseDot = ([$0, ext = ''])=>{
    const noext = $7db112c51fdf9eb6$var$qmarksTestNoExtDot([
        $0
    ]);
    if (!ext) return noext;
    ext = ext.toLowerCase();
    return (f)=>noext(f) && f.toLowerCase().endsWith(ext);
};
const $7db112c51fdf9eb6$var$qmarksTestDot = ([$0, ext = ''])=>{
    const noext = $7db112c51fdf9eb6$var$qmarksTestNoExtDot([
        $0
    ]);
    return !ext ? noext : (f)=>noext(f) && f.endsWith(ext);
};
const $7db112c51fdf9eb6$var$qmarksTest = ([$0, ext = ''])=>{
    const noext = $7db112c51fdf9eb6$var$qmarksTestNoExt([
        $0
    ]);
    return !ext ? noext : (f)=>noext(f) && f.endsWith(ext);
};
const $7db112c51fdf9eb6$var$qmarksTestNoExt = ([$0])=>{
    const len = $0.length;
    return (f)=>f.length === len && !f.startsWith('.');
};
const $7db112c51fdf9eb6$var$qmarksTestNoExtDot = ([$0])=>{
    const len = $0.length;
    return (f)=>f.length === len && f !== '.' && f !== '..';
};
/* c8 ignore start */ const $7db112c51fdf9eb6$var$defaultPlatform = typeof $igDjg === 'object' && $igDjg ? (typeof $igDjg.env === 'object' && $igDjg.env && undefined, $igDjg.platform) : 'posix';
const $7db112c51fdf9eb6$var$path = {
    win32: {
        sep: '\\'
    },
    posix: {
        sep: '/'
    }
};
/* c8 ignore stop */ module.exports.sep = $7db112c51fdf9eb6$var$defaultPlatform === 'win32' ? $7db112c51fdf9eb6$var$path.win32.sep : $7db112c51fdf9eb6$var$path.posix.sep;
module.exports.minimatch.sep = module.exports.sep;
module.exports.GLOBSTAR = Symbol('globstar **');
module.exports.minimatch.GLOBSTAR = module.exports.GLOBSTAR;
// any single thing other than /
// don't need to escape / when using new RegExp()
const $7db112c51fdf9eb6$var$qmark = '[^/]';
// * => any number of characters
const $7db112c51fdf9eb6$var$star = $7db112c51fdf9eb6$var$qmark + '*?';
// ** when dots are allowed.  Anything goes, except .. and .
// not (^ or / followed by one or two dots followed by $ or /),
// followed by anything, any number of times.
const $7db112c51fdf9eb6$var$twoStarDot = '(?:(?!(?:\\/|^)(?:\\.{1,2})($|\\/)).)*?';
// not a ^ or / followed by a dot,
// followed by anything, any number of times.
const $7db112c51fdf9eb6$var$twoStarNoDot = '(?:(?!(?:\\/|^)\\.).)*?';
const $7db112c51fdf9eb6$var$filter = (pattern, options = {})=>(p)=>(0, module.exports.minimatch)(p, pattern, options);
module.exports.filter = $7db112c51fdf9eb6$var$filter;
module.exports.minimatch.filter = module.exports.filter;
const $7db112c51fdf9eb6$var$ext = (a, b = {})=>Object.assign({}, a, b);
const $7db112c51fdf9eb6$var$defaults = (def)=>{
    if (!def || typeof def !== 'object' || !Object.keys(def).length) return module.exports.minimatch;
    const orig = module.exports.minimatch;
    const m = (p, pattern, options = {})=>orig(p, pattern, $7db112c51fdf9eb6$var$ext(def, options));
    return Object.assign(m, {
        Minimatch: class Minimatch extends orig.Minimatch {
            constructor(pattern, options = {}){
                super(pattern, $7db112c51fdf9eb6$var$ext(def, options));
            }
            static defaults(options) {
                return orig.defaults($7db112c51fdf9eb6$var$ext(def, options)).Minimatch;
            }
        },
        AST: class AST extends orig.AST {
            /* c8 ignore start */ constructor(type, parent, options = {}){
                super(type, parent, $7db112c51fdf9eb6$var$ext(def, options));
            }
            /* c8 ignore stop */ static fromGlob(pattern, options = {}) {
                return orig.AST.fromGlob(pattern, $7db112c51fdf9eb6$var$ext(def, options));
            }
        },
        unescape: (s, options = {})=>orig.unescape(s, $7db112c51fdf9eb6$var$ext(def, options)),
        escape: (s, options = {})=>orig.escape(s, $7db112c51fdf9eb6$var$ext(def, options)),
        filter: (pattern, options = {})=>orig.filter(pattern, $7db112c51fdf9eb6$var$ext(def, options)),
        defaults: (options)=>orig.defaults($7db112c51fdf9eb6$var$ext(def, options)),
        makeRe: (pattern, options = {})=>orig.makeRe(pattern, $7db112c51fdf9eb6$var$ext(def, options)),
        braceExpand: (pattern, options = {})=>orig.braceExpand(pattern, $7db112c51fdf9eb6$var$ext(def, options)),
        match: (list, pattern, options = {})=>orig.match(list, pattern, $7db112c51fdf9eb6$var$ext(def, options)),
        sep: orig.sep,
        GLOBSTAR: module.exports.GLOBSTAR
    });
};
module.exports.defaults = $7db112c51fdf9eb6$var$defaults;
module.exports.minimatch.defaults = module.exports.defaults;
// Brace expansion:
// a{b,c}d -> abd acd
// a{b,}c -> abc ac
// a{0..3}d -> a0d a1d a2d a3d
// a{b,c{d,e}f}g -> abg acdfg acefg
// a{b,c}d{e,f}g -> abdeg acdeg abdeg abdfg
//
// Invalid sets are not expanded.
// a{2..}b -> a{2..}b
// a{b}c -> a{b}c
const $7db112c51fdf9eb6$var$braceExpand = (pattern, options = {})=>{
    (0, $1rST3.assertValidPattern)(pattern);
    // Thanks to Yeting Li <https://github.com/yetingli> for
    // improving this regexp to avoid a ReDOS vulnerability.
    if (options.nobrace || !/\{(?:(?!\{).)*\}/.test(pattern)) // shortcut. no need to expand.
    return [
        pattern
    ];
    return (0, $7db112c51fdf9eb6$var$brace_expansion_1.default)(pattern);
};
module.exports.braceExpand = $7db112c51fdf9eb6$var$braceExpand;
module.exports.minimatch.braceExpand = module.exports.braceExpand;
// parse a component of the expanded set.
// At this point, no pattern may contain "/" in it
// so we're going to return a 2d array, where each entry is the full
// pattern, split on '/', and then turned into a regular expression.
// A regexp is made at the end which joins each array with an
// escaped /, and another full one which joins each regexp with |.
//
// Following the lead of Bash 4.1, note that "**" only has special meaning
// when it is the *only* thing in a path portion.  Otherwise, any series
// of * is equivalent to a single *.  Globstar behavior is enabled by
// default, and can be disabled by setting options.noglobstar.
const $7db112c51fdf9eb6$var$makeRe = (pattern, options = {})=>new $7db112c51fdf9eb6$var$Minimatch(pattern, options).makeRe();
module.exports.makeRe = $7db112c51fdf9eb6$var$makeRe;
module.exports.minimatch.makeRe = module.exports.makeRe;
const $7db112c51fdf9eb6$var$match = (list, pattern, options = {})=>{
    const mm = new $7db112c51fdf9eb6$var$Minimatch(pattern, options);
    list = list.filter((f)=>mm.match(f));
    if (mm.options.nonull && !list.length) list.push(pattern);
    return list;
};
module.exports.match = $7db112c51fdf9eb6$var$match;
module.exports.minimatch.match = module.exports.match;
// replace stuff like \* with *
const $7db112c51fdf9eb6$var$globMagic = /[?*]|[+@!]\(.*?\)|\[|\]/;
const $7db112c51fdf9eb6$var$regExpEscape = (s)=>s.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
class $7db112c51fdf9eb6$var$Minimatch {
    options;
    set;
    pattern;
    windowsPathsNoEscape;
    nonegate;
    negate;
    comment;
    empty;
    preserveMultipleSlashes;
    partial;
    globSet;
    globParts;
    nocase;
    isWindows;
    platform;
    windowsNoMagicRoot;
    regexp;
    constructor(pattern, options = {}){
        (0, $1rST3.assertValidPattern)(pattern);
        options = options || {};
        this.options = options;
        this.pattern = pattern;
        this.platform = options.platform || $7db112c51fdf9eb6$var$defaultPlatform;
        this.isWindows = this.platform === 'win32';
        this.windowsPathsNoEscape = !!options.windowsPathsNoEscape || options.allowWindowsEscape === false;
        if (this.windowsPathsNoEscape) this.pattern = this.pattern.replace(/\\/g, '/');
        this.preserveMultipleSlashes = !!options.preserveMultipleSlashes;
        this.regexp = null;
        this.negate = false;
        this.nonegate = !!options.nonegate;
        this.comment = false;
        this.empty = false;
        this.partial = !!options.partial;
        this.nocase = !!this.options.nocase;
        this.windowsNoMagicRoot = options.windowsNoMagicRoot !== undefined ? options.windowsNoMagicRoot : !!(this.isWindows && this.nocase);
        this.globSet = [];
        this.globParts = [];
        this.set = [];
        // make the set of regexps etc.
        this.make();
    }
    hasMagic() {
        if (this.options.magicalBraces && this.set.length > 1) return true;
        for (const pattern of this.set)for (const part of pattern){
            if (typeof part !== 'string') return true;
        }
        return false;
    }
    debug(..._) {}
    make() {
        const pattern = this.pattern;
        const options = this.options;
        // empty patterns and comments match nothing.
        if (!options.nocomment && pattern.charAt(0) === '#') {
            this.comment = true;
            return;
        }
        if (!pattern) {
            this.empty = true;
            return;
        }
        // step 1: figure out negation, etc.
        this.parseNegate();
        // step 2: expand braces
        this.globSet = [
            ...new Set(this.braceExpand())
        ];
        if (options.debug) this.debug = (...args)=>console.error(...args);
        this.debug(this.pattern, this.globSet);
        // step 3: now we have a set, so turn each one into a series of
        // path-portion matching patterns.
        // These will be regexps, except in the case of "**", which is
        // set to the GLOBSTAR object for globstar behavior,
        // and will not contain any / characters
        //
        // First, we preprocess to make the glob pattern sets a bit simpler
        // and deduped.  There are some perf-killing patterns that can cause
        // problems with a glob walk, but we can simplify them down a bit.
        const rawGlobParts = this.globSet.map((s)=>this.slashSplit(s));
        this.globParts = this.preprocess(rawGlobParts);
        this.debug(this.pattern, this.globParts);
        // glob --> regexps
        let set = this.globParts.map((s, _, __)=>{
            if (this.isWindows && this.windowsNoMagicRoot) {
                // check if it's a drive or unc path.
                const isUNC = s[0] === '' && s[1] === '' && (s[2] === '?' || !$7db112c51fdf9eb6$var$globMagic.test(s[2])) && !$7db112c51fdf9eb6$var$globMagic.test(s[3]);
                const isDrive = /^[a-z]:/i.test(s[0]);
                if (isUNC) return [
                    ...s.slice(0, 4),
                    ...s.slice(4).map((ss)=>this.parse(ss))
                ];
                else if (isDrive) return [
                    s[0],
                    ...s.slice(1).map((ss)=>this.parse(ss))
                ];
            }
            return s.map((ss)=>this.parse(ss));
        });
        this.debug(this.pattern, set);
        // filter out everything that didn't compile properly.
        this.set = set.filter((s)=>s.indexOf(false) === -1);
        // do not treat the ? in UNC paths as magic
        if (this.isWindows) for(let i = 0; i < this.set.length; i++){
            const p = this.set[i];
            if (p[0] === '' && p[1] === '' && this.globParts[i][2] === '?' && typeof p[3] === 'string' && /^[a-z]:$/i.test(p[3])) p[2] = '?';
        }
        this.debug(this.pattern, this.set);
    }
    // various transforms to equivalent pattern sets that are
    // faster to process in a filesystem walk.  The goal is to
    // eliminate what we can, and push all ** patterns as far
    // to the right as possible, even if it increases the number
    // of patterns that we have to process.
    preprocess(globParts) {
        // if we're not in globstar mode, then turn all ** into *
        if (this.options.noglobstar) for(let i = 0; i < globParts.length; i++){
            for(let j = 0; j < globParts[i].length; j++)if (globParts[i][j] === '**') globParts[i][j] = '*';
        }
        const { optimizationLevel: optimizationLevel = 1 } = this.options;
        if (optimizationLevel >= 2) {
            // aggressive optimization for the purpose of fs walking
            globParts = this.firstPhasePreProcess(globParts);
            globParts = this.secondPhasePreProcess(globParts);
        } else if (optimizationLevel >= 1) // just basic optimizations to remove some .. parts
        globParts = this.levelOneOptimize(globParts);
        else // just collapse multiple ** portions into one
        globParts = this.adjascentGlobstarOptimize(globParts);
        return globParts;
    }
    // just get rid of adjascent ** portions
    adjascentGlobstarOptimize(globParts) {
        return globParts.map((parts)=>{
            let gs = -1;
            while(-1 !== (gs = parts.indexOf('**', gs + 1))){
                let i = gs;
                while(parts[i + 1] === '**')i++;
                if (i !== gs) parts.splice(gs, i - gs);
            }
            return parts;
        });
    }
    // get rid of adjascent ** and resolve .. portions
    levelOneOptimize(globParts) {
        return globParts.map((parts)=>{
            parts = parts.reduce((set, part)=>{
                const prev = set[set.length - 1];
                if (part === '**' && prev === '**') return set;
                if (part === '..') {
                    if (prev && prev !== '..' && prev !== '.' && prev !== '**') {
                        set.pop();
                        return set;
                    }
                }
                set.push(part);
                return set;
            }, []);
            return parts.length === 0 ? [
                ''
            ] : parts;
        });
    }
    levelTwoFileOptimize(parts) {
        if (!Array.isArray(parts)) parts = this.slashSplit(parts);
        let didSomething = false;
        do {
            didSomething = false;
            // <pre>/<e>/<rest> -> <pre>/<rest>
            if (!this.preserveMultipleSlashes) {
                for(let i = 1; i < parts.length - 1; i++){
                    const p = parts[i];
                    // don't squeeze out UNC patterns
                    if (i === 1 && p === '' && parts[0] === '') continue;
                    if (p === '.' || p === '') {
                        didSomething = true;
                        parts.splice(i, 1);
                        i--;
                    }
                }
                if (parts[0] === '.' && parts.length === 2 && (parts[1] === '.' || parts[1] === '')) {
                    didSomething = true;
                    parts.pop();
                }
            }
            // <pre>/<p>/../<rest> -> <pre>/<rest>
            let dd = 0;
            while(-1 !== (dd = parts.indexOf('..', dd + 1))){
                const p = parts[dd - 1];
                if (p && p !== '.' && p !== '..' && p !== '**') {
                    didSomething = true;
                    parts.splice(dd - 1, 2);
                    dd -= 2;
                }
            }
        }while (didSomething);
        return parts.length === 0 ? [
            ''
        ] : parts;
    }
    // First phase: single-pattern processing
    // <pre> is 1 or more portions
    // <rest> is 1 or more portions
    // <p> is any portion other than ., .., '', or **
    // <e> is . or ''
    //
    // **/.. is *brutal* for filesystem walking performance, because
    // it effectively resets the recursive walk each time it occurs,
    // and ** cannot be reduced out by a .. pattern part like a regexp
    // or most strings (other than .., ., and '') can be.
    //
    // <pre>/**/../<p>/<p>/<rest> -> {<pre>/../<p>/<p>/<rest>,<pre>/**/<p>/<p>/<rest>}
    // <pre>/<e>/<rest> -> <pre>/<rest>
    // <pre>/<p>/../<rest> -> <pre>/<rest>
    // **/**/<rest> -> **/<rest>
    //
    // **/*/<rest> -> */**/<rest> <== not valid because ** doesn't follow
    // this WOULD be allowed if ** did follow symlinks, or * didn't
    firstPhasePreProcess(globParts) {
        let didSomething = false;
        do {
            didSomething = false;
            // <pre>/**/../<p>/<p>/<rest> -> {<pre>/../<p>/<p>/<rest>,<pre>/**/<p>/<p>/<rest>}
            for (let parts of globParts){
                let gs = -1;
                while(-1 !== (gs = parts.indexOf('**', gs + 1))){
                    let gss = gs;
                    while(parts[gss + 1] === '**')// <pre>/**/**/<rest> -> <pre>/**/<rest>
                    gss++;
                    // eg, if gs is 2 and gss is 4, that means we have 3 **
                    // parts, and can remove 2 of them.
                    if (gss > gs) parts.splice(gs + 1, gss - gs);
                    let next = parts[gs + 1];
                    const p = parts[gs + 2];
                    const p2 = parts[gs + 3];
                    if (next !== '..') continue;
                    if (!p || p === '.' || p === '..' || !p2 || p2 === '.' || p2 === '..') continue;
                    didSomething = true;
                    // edit parts in place, and push the new one
                    parts.splice(gs, 1);
                    const other = parts.slice(0);
                    other[gs] = '**';
                    globParts.push(other);
                    gs--;
                }
                // <pre>/<e>/<rest> -> <pre>/<rest>
                if (!this.preserveMultipleSlashes) {
                    for(let i = 1; i < parts.length - 1; i++){
                        const p = parts[i];
                        // don't squeeze out UNC patterns
                        if (i === 1 && p === '' && parts[0] === '') continue;
                        if (p === '.' || p === '') {
                            didSomething = true;
                            parts.splice(i, 1);
                            i--;
                        }
                    }
                    if (parts[0] === '.' && parts.length === 2 && (parts[1] === '.' || parts[1] === '')) {
                        didSomething = true;
                        parts.pop();
                    }
                }
                // <pre>/<p>/../<rest> -> <pre>/<rest>
                let dd = 0;
                while(-1 !== (dd = parts.indexOf('..', dd + 1))){
                    const p = parts[dd - 1];
                    if (p && p !== '.' && p !== '..' && p !== '**') {
                        didSomething = true;
                        const needDot = dd === 1 && parts[dd + 1] === '**';
                        const splin = needDot ? [
                            '.'
                        ] : [];
                        parts.splice(dd - 1, 2, ...splin);
                        if (parts.length === 0) parts.push('');
                        dd -= 2;
                    }
                }
            }
        }while (didSomething);
        return globParts;
    }
    // second phase: multi-pattern dedupes
    // {<pre>/*/<rest>,<pre>/<p>/<rest>} -> <pre>/*/<rest>
    // {<pre>/<rest>,<pre>/<rest>} -> <pre>/<rest>
    // {<pre>/**/<rest>,<pre>/<rest>} -> <pre>/**/<rest>
    //
    // {<pre>/**/<rest>,<pre>/**/<p>/<rest>} -> <pre>/**/<rest>
    // ^-- not valid because ** doens't follow symlinks
    secondPhasePreProcess(globParts) {
        for(let i = 0; i < globParts.length - 1; i++)for(let j = i + 1; j < globParts.length; j++){
            const matched = this.partsMatch(globParts[i], globParts[j], !this.preserveMultipleSlashes);
            if (matched) {
                globParts[i] = [];
                globParts[j] = matched;
                break;
            }
        }
        return globParts.filter((gs)=>gs.length);
    }
    partsMatch(a, b, emptyGSMatch = false) {
        let ai = 0;
        let bi = 0;
        let result = [];
        let which = '';
        while(ai < a.length && bi < b.length){
            if (a[ai] === b[bi]) {
                result.push(which === 'b' ? b[bi] : a[ai]);
                ai++;
                bi++;
            } else if (emptyGSMatch && a[ai] === '**' && b[bi] === a[ai + 1]) {
                result.push(a[ai]);
                ai++;
            } else if (emptyGSMatch && b[bi] === '**' && a[ai] === b[bi + 1]) {
                result.push(b[bi]);
                bi++;
            } else if (a[ai] === '*' && b[bi] && (this.options.dot || !b[bi].startsWith('.')) && b[bi] !== '**') {
                if (which === 'b') return false;
                which = 'a';
                result.push(a[ai]);
                ai++;
                bi++;
            } else if (b[bi] === '*' && a[ai] && (this.options.dot || !a[ai].startsWith('.')) && a[ai] !== '**') {
                if (which === 'a') return false;
                which = 'b';
                result.push(b[bi]);
                ai++;
                bi++;
            } else return false;
        }
        // if we fall out of the loop, it means they two are identical
        // as long as their lengths match
        return a.length === b.length && result;
    }
    parseNegate() {
        if (this.nonegate) return;
        const pattern = this.pattern;
        let negate = false;
        let negateOffset = 0;
        for(let i = 0; i < pattern.length && pattern.charAt(i) === '!'; i++){
            negate = !negate;
            negateOffset++;
        }
        if (negateOffset) this.pattern = pattern.slice(negateOffset);
        this.negate = negate;
    }
    // set partial to true to test if, for example,
    // "/a/b" matches the start of "/*/b/*/d"
    // Partial means, if you run out of file before you run
    // out of pattern, then that's fine, as long as all
    // the parts match.
    matchOne(file, pattern, partial = false) {
        const options = this.options;
        // UNC paths like //?/X:/... can match X:/... and vice versa
        // Drive letters in absolute drive or unc paths are always compared
        // case-insensitively.
        if (this.isWindows) {
            const fileDrive = typeof file[0] === 'string' && /^[a-z]:$/i.test(file[0]);
            const fileUNC = !fileDrive && file[0] === '' && file[1] === '' && file[2] === '?' && /^[a-z]:$/i.test(file[3]);
            const patternDrive = typeof pattern[0] === 'string' && /^[a-z]:$/i.test(pattern[0]);
            const patternUNC = !patternDrive && pattern[0] === '' && pattern[1] === '' && pattern[2] === '?' && typeof pattern[3] === 'string' && /^[a-z]:$/i.test(pattern[3]);
            const fdi = fileUNC ? 3 : fileDrive ? 0 : undefined;
            const pdi = patternUNC ? 3 : patternDrive ? 0 : undefined;
            if (typeof fdi === 'number' && typeof pdi === 'number') {
                const [fd, pd] = [
                    file[fdi],
                    pattern[pdi]
                ];
                if (fd.toLowerCase() === pd.toLowerCase()) {
                    pattern[pdi] = fd;
                    if (pdi > fdi) pattern = pattern.slice(pdi);
                    else if (fdi > pdi) file = file.slice(fdi);
                }
            }
        }
        // resolve and reduce . and .. portions in the file as well.
        // dont' need to do the second phase, because it's only one string[]
        const { optimizationLevel: optimizationLevel = 1 } = this.options;
        if (optimizationLevel >= 2) file = this.levelTwoFileOptimize(file);
        this.debug('matchOne', this, {
            file: file,
            pattern: pattern
        });
        this.debug('matchOne', file.length, pattern.length);
        for(var fi = 0, pi = 0, fl = file.length, pl = pattern.length; fi < fl && pi < pl; fi++, pi++){
            this.debug('matchOne loop');
            var p = pattern[pi];
            var f = file[fi];
            this.debug(pattern, p, f);
            // should be impossible.
            // some invalid regexp stuff in the set.
            /* c8 ignore start */ if (p === false) return false;
            /* c8 ignore stop */ if (p === module.exports.GLOBSTAR) {
                this.debug('GLOBSTAR', [
                    pattern,
                    p,
                    f
                ]);
                // "**"
                // a/**/b/**/c would match the following:
                // a/b/x/y/z/c
                // a/x/y/z/b/c
                // a/b/x/b/x/c
                // a/b/c
                // To do this, take the rest of the pattern after
                // the **, and see if it would match the file remainder.
                // If so, return success.
                // If not, the ** "swallows" a segment, and try again.
                // This is recursively awful.
                //
                // a/**/b/**/c matching a/b/x/y/z/c
                // - a matches a
                // - doublestar
                //   - matchOne(b/x/y/z/c, b/**/c)
                //     - b matches b
                //     - doublestar
                //       - matchOne(x/y/z/c, c) -> no
                //       - matchOne(y/z/c, c) -> no
                //       - matchOne(z/c, c) -> no
                //       - matchOne(c, c) yes, hit
                var fr = fi;
                var pr = pi + 1;
                if (pr === pl) {
                    this.debug('** at the end');
                    // a ** at the end will just swallow the rest.
                    // We have found a match.
                    // however, it will not swallow /.x, unless
                    // options.dot is set.
                    // . and .. are *never* matched by **, for explosively
                    // exponential reasons.
                    for(; fi < fl; fi++){
                        if (file[fi] === '.' || file[fi] === '..' || !options.dot && file[fi].charAt(0) === '.') return false;
                    }
                    return true;
                }
                // ok, let's see if we can swallow whatever we can.
                while(fr < fl){
                    var swallowee = file[fr];
                    this.debug('\nglobstar while', file, fr, pattern, pr, swallowee);
                    // XXX remove this slice.  Just pass the start index.
                    if (this.matchOne(file.slice(fr), pattern.slice(pr), partial)) {
                        this.debug('globstar found match!', fr, fl, swallowee);
                        // found a match.
                        return true;
                    } else {
                        // can't swallow "." or ".." ever.
                        // can only swallow ".foo" when explicitly asked.
                        if (swallowee === '.' || swallowee === '..' || !options.dot && swallowee.charAt(0) === '.') {
                            this.debug('dot detected!', file, fr, pattern, pr);
                            break;
                        }
                        // ** swallows a segment, and continue.
                        this.debug('globstar swallow a segment, and continue');
                        fr++;
                    }
                }
                // no match was found.
                // However, in partial mode, we can't say this is necessarily over.
                /* c8 ignore start */ if (partial) {
                    // ran out of file
                    this.debug('\n>>> no match, partial?', file, fr, pattern, pr);
                    if (fr === fl) return true;
                }
                /* c8 ignore stop */ return false;
            }
            // something other than **
            // non-magic patterns just have to match exactly
            // patterns with magic have been turned into regexps.
            let hit;
            if (typeof p === 'string') {
                hit = f === p;
                this.debug('string match', p, f, hit);
            } else {
                hit = p.test(f);
                this.debug('pattern match', p, f, hit);
            }
            if (!hit) return false;
        }
        // Note: ending in / means that we'll get a final ""
        // at the end of the pattern.  This can only match a
        // corresponding "" at the end of the file.
        // If the file ends in /, then it can only match a
        // a pattern that ends in /, unless the pattern just
        // doesn't have any more for it. But, a/b/ should *not*
        // match "a/b/*", even though "" matches against the
        // [^/]*? pattern, except in partial mode, where it might
        // simply not be reached yet.
        // However, a/b/ should still satisfy a/*
        // now either we fell off the end of the pattern, or we're done.
        if (fi === fl && pi === pl) // ran out of pattern and filename at the same time.
        // an exact hit!
        return true;
        else if (fi === fl) // ran out of file, but still had pattern left.
        // this is ok if we're doing the match as part of
        // a glob fs traversal.
        return partial;
        else if (pi === pl) // ran out of pattern, still have file left.
        // this is only acceptable if we're on the very last
        // empty segment of a file with a trailing slash.
        // a/* should match a/b/
        return fi === fl - 1 && file[fi] === '';
        else // should be unreachable.
        throw new Error('wtf?');
    /* c8 ignore stop */ }
    braceExpand() {
        return (0, module.exports.braceExpand)(this.pattern, this.options);
    }
    parse(pattern) {
        (0, $1rST3.assertValidPattern)(pattern);
        const options = this.options;
        // shortcuts
        if (pattern === '**') return module.exports.GLOBSTAR;
        if (pattern === '') return '';
        // far and away, the most common glob pattern parts are
        // *, *.*, and *.<ext>  Add a fast check method for those.
        let m;
        let fastTest = null;
        if (m = pattern.match($7db112c51fdf9eb6$var$starRE)) fastTest = options.dot ? $7db112c51fdf9eb6$var$starTestDot : $7db112c51fdf9eb6$var$starTest;
        else if (m = pattern.match($7db112c51fdf9eb6$var$starDotExtRE)) fastTest = (options.nocase ? options.dot ? $7db112c51fdf9eb6$var$starDotExtTestNocaseDot : $7db112c51fdf9eb6$var$starDotExtTestNocase : options.dot ? $7db112c51fdf9eb6$var$starDotExtTestDot : $7db112c51fdf9eb6$var$starDotExtTest)(m[1]);
        else if (m = pattern.match($7db112c51fdf9eb6$var$qmarksRE)) fastTest = (options.nocase ? options.dot ? $7db112c51fdf9eb6$var$qmarksTestNocaseDot : $7db112c51fdf9eb6$var$qmarksTestNocase : options.dot ? $7db112c51fdf9eb6$var$qmarksTestDot : $7db112c51fdf9eb6$var$qmarksTest)(m);
        else if (m = pattern.match($7db112c51fdf9eb6$var$starDotStarRE)) fastTest = options.dot ? $7db112c51fdf9eb6$var$starDotStarTestDot : $7db112c51fdf9eb6$var$starDotStarTest;
        else if (m = pattern.match($7db112c51fdf9eb6$var$dotStarRE)) fastTest = $7db112c51fdf9eb6$var$dotStarTest;
        const re = $bhGjx.AST.fromGlob(pattern, this.options).toMMPattern();
        if (fastTest && typeof re === 'object') // Avoids overriding in frozen environments
        Reflect.defineProperty(re, 'test', {
            value: fastTest
        });
        return re;
    }
    makeRe() {
        if (this.regexp || this.regexp === false) return this.regexp;
        // at this point, this.set is a 2d array of partial
        // pattern strings, or "**".
        //
        // It's better to use .match().  This function shouldn't
        // be used, really, but it's pretty convenient sometimes,
        // when you just want to work with a regex.
        const set = this.set;
        if (!set.length) {
            this.regexp = false;
            return this.regexp;
        }
        const options = this.options;
        const twoStar = options.noglobstar ? $7db112c51fdf9eb6$var$star : options.dot ? $7db112c51fdf9eb6$var$twoStarDot : $7db112c51fdf9eb6$var$twoStarNoDot;
        const flags = new Set(options.nocase ? [
            'i'
        ] : []);
        // regexpify non-globstar patterns
        // if ** is only item, then we just do one twoStar
        // if ** is first, and there are more, prepend (\/|twoStar\/)? to next
        // if ** is last, append (\/twoStar|) to previous
        // if ** is in the middle, append (\/|\/twoStar\/) to previous
        // then filter out GLOBSTAR symbols
        let re = set.map((pattern)=>{
            const pp = pattern.map((p)=>{
                if (p instanceof RegExp) for (const f of p.flags.split(''))flags.add(f);
                return typeof p === 'string' ? $7db112c51fdf9eb6$var$regExpEscape(p) : p === module.exports.GLOBSTAR ? module.exports.GLOBSTAR : p._src;
            });
            pp.forEach((p, i)=>{
                const next = pp[i + 1];
                const prev = pp[i - 1];
                if (p !== module.exports.GLOBSTAR || prev === module.exports.GLOBSTAR) return;
                if (prev === undefined) {
                    if (next !== undefined && next !== module.exports.GLOBSTAR) pp[i + 1] = '(?:\\/|' + twoStar + '\\/)?' + next;
                    else pp[i] = twoStar;
                } else if (next === undefined) pp[i - 1] = prev + '(?:\\/|' + twoStar + ')?';
                else if (next !== module.exports.GLOBSTAR) {
                    pp[i - 1] = prev + '(?:\\/|\\/' + twoStar + '\\/)' + next;
                    pp[i + 1] = module.exports.GLOBSTAR;
                }
            });
            return pp.filter((p)=>p !== module.exports.GLOBSTAR).join('/');
        }).join('|');
        // need to wrap in parens if we had more than one thing with |,
        // otherwise only the first will be anchored to ^ and the last to $
        const [open, close] = set.length > 1 ? [
            '(?:',
            ')'
        ] : [
            '',
            ''
        ];
        // must match entire pattern
        // ending in a * or ** will make it less strict.
        re = '^' + open + re + close + '$';
        // can match anything, as long as it's not this.
        if (this.negate) re = '^(?!' + re + ').+$';
        try {
            this.regexp = new RegExp(re, [
                ...flags
            ].join(''));
        /* c8 ignore start */ } catch (ex) {
            // should be impossible
            this.regexp = false;
        }
        /* c8 ignore stop */ return this.regexp;
    }
    slashSplit(p) {
        // if p starts with // on windows, we preserve that
        // so that UNC paths aren't broken.  Otherwise, any number of
        // / characters are coalesced into one, unless
        // preserveMultipleSlashes is set to true.
        if (this.preserveMultipleSlashes) return p.split('/');
        else if (this.isWindows && /^\/\/[^\/]+/.test(p)) // add an extra '' for the one we lose
        return [
            '',
            ...p.split(/\/+/)
        ];
        else return p.split(/\/+/);
    }
    match(f, partial = this.partial) {
        this.debug('match', f, this.pattern);
        // short-circuit in the case of busted things.
        // comments, etc.
        if (this.comment) return false;
        if (this.empty) return f === '';
        if (f === '/' && partial) return true;
        const options = this.options;
        // windows: need to use /, not \
        if (this.isWindows) f = f.split('\\').join('/');
        // treat the test path as a set of pathparts.
        const ff = this.slashSplit(f);
        this.debug(this.pattern, 'split', ff);
        // just ONE of the pattern sets in this.set needs to match
        // in order for it to be valid.  If negating, then just one
        // match means that we have failed.
        // Either way, return on the first hit.
        const set = this.set;
        this.debug(this.pattern, 'set', set);
        // Find the basename of the path by looking for the last non-empty segment
        let filename = ff[ff.length - 1];
        if (!filename) for(let i = ff.length - 2; !filename && i >= 0; i--)filename = ff[i];
        for(let i = 0; i < set.length; i++){
            const pattern = set[i];
            let file = ff;
            if (options.matchBase && pattern.length === 1) file = [
                filename
            ];
            const hit = this.matchOne(file, pattern, partial);
            if (hit) {
                if (options.flipNegate) return true;
                return !this.negate;
            }
        }
        // didn't get any hits.  this is success if it's a negative
        // pattern, failure otherwise.
        if (options.flipNegate) return false;
        return this.negate;
    }
    static defaults(def) {
        return module.exports.minimatch.defaults(def).Minimatch;
    }
}
module.exports.Minimatch = $7db112c51fdf9eb6$var$Minimatch;

var $bhGjx = parcelRequire("bhGjx");
Object.defineProperty(module.exports, "AST", {
    enumerable: true,
    get: function() {
        return $bhGjx.AST;
    }
});

var $eMqju = parcelRequire("eMqju");
Object.defineProperty(module.exports, "escape", {
    enumerable: true,
    get: function() {
        return $eMqju.escape;
    }
});

var $86rUr = parcelRequire("86rUr");
Object.defineProperty(module.exports, "unescape", {
    enumerable: true,
    get: function() {
        return $86rUr.unescape;
    }
});
/* c8 ignore stop */ module.exports.minimatch.AST = $bhGjx.AST;
module.exports.minimatch.Minimatch = $7db112c51fdf9eb6$var$Minimatch;
module.exports.minimatch.escape = $eMqju.escape;
module.exports.minimatch.unescape = $86rUr.unescape;

});
parcelRegister("fapoe", function(module, exports) {

var $9MN6c = parcelRequire("9MN6c");
module.exports = $b0ab7c142cf78d2d$var$expandTop;
var $b0ab7c142cf78d2d$var$escSlash = '\0SLASH' + Math.random() + '\0';
var $b0ab7c142cf78d2d$var$escOpen = '\0OPEN' + Math.random() + '\0';
var $b0ab7c142cf78d2d$var$escClose = '\0CLOSE' + Math.random() + '\0';
var $b0ab7c142cf78d2d$var$escComma = '\0COMMA' + Math.random() + '\0';
var $b0ab7c142cf78d2d$var$escPeriod = '\0PERIOD' + Math.random() + '\0';
function $b0ab7c142cf78d2d$var$numeric(str) {
    return parseInt(str, 10) == str ? parseInt(str, 10) : str.charCodeAt(0);
}
function $b0ab7c142cf78d2d$var$escapeBraces(str) {
    return str.split('\\\\').join($b0ab7c142cf78d2d$var$escSlash).split('\\{').join($b0ab7c142cf78d2d$var$escOpen).split('\\}').join($b0ab7c142cf78d2d$var$escClose).split('\\,').join($b0ab7c142cf78d2d$var$escComma).split('\\.').join($b0ab7c142cf78d2d$var$escPeriod);
}
function $b0ab7c142cf78d2d$var$unescapeBraces(str) {
    return str.split($b0ab7c142cf78d2d$var$escSlash).join('\\').split($b0ab7c142cf78d2d$var$escOpen).join('{').split($b0ab7c142cf78d2d$var$escClose).join('}').split($b0ab7c142cf78d2d$var$escComma).join(',').split($b0ab7c142cf78d2d$var$escPeriod).join('.');
}
// Basically just str.split(","), but handling cases
// where we have nested braced sections, which should be
// treated as individual members, like {a,{b,c},d}
function $b0ab7c142cf78d2d$var$parseCommaParts(str) {
    if (!str) return [
        ''
    ];
    var parts = [];
    var m = $9MN6c('{', '}', str);
    if (!m) return str.split(',');
    var pre = m.pre;
    var body = m.body;
    var post = m.post;
    var p = pre.split(',');
    p[p.length - 1] += '{' + body + '}';
    var postParts = $b0ab7c142cf78d2d$var$parseCommaParts(post);
    if (post.length) {
        p[p.length - 1] += postParts.shift();
        p.push.apply(p, postParts);
    }
    parts.push.apply(parts, p);
    return parts;
}
function $b0ab7c142cf78d2d$var$expandTop(str) {
    if (!str) return [];
    // I don't know why Bash 4.3 does this, but it does.
    // Anything starting with {} will have the first two bytes preserved
    // but *only* at the top level, so {},a}b will not expand to anything,
    // but a{},b}c will be expanded to [a}c,abc].
    // One could argue that this is a bug in Bash, but since the goal of
    // this module is to match Bash's rules, we escape a leading {}
    if (str.substr(0, 2) === '{}') str = '\\{\\}' + str.substr(2);
    return $b0ab7c142cf78d2d$var$expand($b0ab7c142cf78d2d$var$escapeBraces(str), true).map($b0ab7c142cf78d2d$var$unescapeBraces);
}
function $b0ab7c142cf78d2d$var$embrace(str) {
    return '{' + str + '}';
}
function $b0ab7c142cf78d2d$var$isPadded(el) {
    return /^-?0\d/.test(el);
}
function $b0ab7c142cf78d2d$var$lte(i, y) {
    return i <= y;
}
function $b0ab7c142cf78d2d$var$gte(i, y) {
    return i >= y;
}
function $b0ab7c142cf78d2d$var$expand(str, isTop) {
    var expansions = [];
    var m = $9MN6c('{', '}', str);
    if (!m) return [
        str
    ];
    // no need to expand pre, since it is guaranteed to be free of brace-sets
    var pre = m.pre;
    var post = m.post.length ? $b0ab7c142cf78d2d$var$expand(m.post, false) : [
        ''
    ];
    if (/\$$/.test(m.pre)) for(var k = 0; k < post.length; k++){
        var expansion = pre + '{' + m.body + '}' + post[k];
        expansions.push(expansion);
    }
    else {
        var isNumericSequence = /^-?\d+\.\.-?\d+(?:\.\.-?\d+)?$/.test(m.body);
        var isAlphaSequence = /^[a-zA-Z]\.\.[a-zA-Z](?:\.\.-?\d+)?$/.test(m.body);
        var isSequence = isNumericSequence || isAlphaSequence;
        var isOptions = m.body.indexOf(',') >= 0;
        if (!isSequence && !isOptions) {
            // {a},b}
            if (m.post.match(/,.*\}/)) {
                str = m.pre + '{' + m.body + $b0ab7c142cf78d2d$var$escClose + m.post;
                return $b0ab7c142cf78d2d$var$expand(str);
            }
            return [
                str
            ];
        }
        var n;
        if (isSequence) n = m.body.split(/\.\./);
        else {
            n = $b0ab7c142cf78d2d$var$parseCommaParts(m.body);
            if (n.length === 1) {
                // x{{a,b}}y ==> x{a}y x{b}y
                n = $b0ab7c142cf78d2d$var$expand(n[0], false).map($b0ab7c142cf78d2d$var$embrace);
                if (n.length === 1) return post.map(function(p) {
                    return m.pre + n[0] + p;
                });
            }
        }
        // at this point, n is the parts, and we know it's not a comma set
        // with a single entry.
        var N;
        if (isSequence) {
            var x = $b0ab7c142cf78d2d$var$numeric(n[0]);
            var y = $b0ab7c142cf78d2d$var$numeric(n[1]);
            var width = Math.max(n[0].length, n[1].length);
            var incr = n.length == 3 ? Math.abs($b0ab7c142cf78d2d$var$numeric(n[2])) : 1;
            var test = $b0ab7c142cf78d2d$var$lte;
            var reverse = y < x;
            if (reverse) {
                incr *= -1;
                test = $b0ab7c142cf78d2d$var$gte;
            }
            var pad = n.some($b0ab7c142cf78d2d$var$isPadded);
            N = [];
            for(var i = x; test(i, y); i += incr){
                var c;
                if (isAlphaSequence) {
                    c = String.fromCharCode(i);
                    if (c === '\\') c = '';
                } else {
                    c = String(i);
                    if (pad) {
                        var need = width - c.length;
                        if (need > 0) {
                            var z = new Array(need + 1).join('0');
                            if (i < 0) c = '-' + z + c.slice(1);
                            else c = z + c;
                        }
                    }
                }
                N.push(c);
            }
        } else {
            N = [];
            for(var j = 0; j < n.length; j++)N.push.apply(N, $b0ab7c142cf78d2d$var$expand(n[j], false));
        }
        for(var j = 0; j < N.length; j++)for(var k = 0; k < post.length; k++){
            var expansion = pre + N[j] + post[k];
            if (!isTop || isSequence || expansion) expansions.push(expansion);
        }
    }
    return expansions;
}

});
parcelRegister("9MN6c", function(module, exports) {
'use strict';
module.exports = $71feaecea50aa733$var$balanced;
function $71feaecea50aa733$var$balanced(a, b, str) {
    if (a instanceof RegExp) a = $71feaecea50aa733$var$maybeMatch(a, str);
    if (b instanceof RegExp) b = $71feaecea50aa733$var$maybeMatch(b, str);
    var r = $71feaecea50aa733$var$range(a, b, str);
    return r && {
        start: r[0],
        end: r[1],
        pre: str.slice(0, r[0]),
        body: str.slice(r[0] + a.length, r[1]),
        post: str.slice(r[1] + b.length)
    };
}
function $71feaecea50aa733$var$maybeMatch(reg, str) {
    var m = str.match(reg);
    return m ? m[0] : null;
}
$71feaecea50aa733$var$balanced.range = $71feaecea50aa733$var$range;
function $71feaecea50aa733$var$range(a, b, str) {
    var begs, beg, left, right, result;
    var ai = str.indexOf(a);
    var bi = str.indexOf(b, ai + 1);
    var i = ai;
    if (ai >= 0 && bi > 0) {
        begs = [];
        left = str.length;
        while(i >= 0 && !result){
            if (i == ai) {
                begs.push(i);
                ai = str.indexOf(a, i + 1);
            } else if (begs.length == 1) result = [
                begs.pop(),
                bi
            ];
            else {
                beg = begs.pop();
                if (beg < left) {
                    left = beg;
                    right = bi;
                }
                bi = str.indexOf(b, i + 1);
            }
            i = ai < bi && ai >= 0 ? ai : bi;
        }
        if (begs.length) result = [
            left,
            right
        ];
    }
    return result;
}

});


parcelRegister("1rST3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertValidPattern = void 0;
const $10e2e378d270e196$var$MAX_PATTERN_LENGTH = 65536;
const $10e2e378d270e196$var$assertValidPattern = (pattern)=>{
    if (typeof pattern !== 'string') throw new TypeError('invalid pattern');
    if (pattern.length > $10e2e378d270e196$var$MAX_PATTERN_LENGTH) throw new TypeError('pattern is too long');
};
module.exports.assertValidPattern = $10e2e378d270e196$var$assertValidPattern;

});

parcelRegister("bhGjx", function(module, exports) {
"use strict";
// parse a single path portion
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AST = void 0;

var $jQeq5 = parcelRequire("jQeq5");

var $86rUr = parcelRequire("86rUr");
const $83721aed6dc1e49f$var$types = new Set([
    '!',
    '?',
    '+',
    '*',
    '@'
]);
const $83721aed6dc1e49f$var$isExtglobType = (c)=>$83721aed6dc1e49f$var$types.has(c);
// Patterns that get prepended to bind to the start of either the
// entire string, or just a single path portion, to prevent dots
// and/or traversal patterns, when needed.
// Exts don't need the ^ or / bit, because the root binds that already.
const $83721aed6dc1e49f$var$startNoTraversal = '(?!(?:^|/)\\.\\.?(?:$|/))';
const $83721aed6dc1e49f$var$startNoDot = '(?!\\.)';
// characters that indicate a start of pattern needs the "no dots" bit,
// because a dot *might* be matched. ( is not in the list, because in
// the case of a child extglob, it will handle the prevention itself.
const $83721aed6dc1e49f$var$addPatternStart = new Set([
    '[',
    '.'
]);
// cases where traversal is A-OK, no dot prevention needed
const $83721aed6dc1e49f$var$justDots = new Set([
    '..',
    '.'
]);
const $83721aed6dc1e49f$var$reSpecials = new Set('().*{}+?[]^$\\!');
const $83721aed6dc1e49f$var$regExpEscape = (s)=>s.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
// any single thing other than /
const $83721aed6dc1e49f$var$qmark = '[^/]';
// * => any number of characters
const $83721aed6dc1e49f$var$star = $83721aed6dc1e49f$var$qmark + '*?';
// use + when we need to ensure that *something* matches, because the * is
// the only thing in the path portion.
const $83721aed6dc1e49f$var$starNoEmpty = $83721aed6dc1e49f$var$qmark + '+?';
// remove the \ chars that we added if we end up doing a nonmagic compare
// const deslash = (s: string) => s.replace(/\\(.)/g, '$1')
class $83721aed6dc1e49f$var$AST {
    type;
    #root;
    #hasMagic;
    #uflag = false;
    #parts = [];
    #parent;
    #parentIndex;
    #negs;
    #filledNegs = false;
    #options;
    #toString;
    // set to true if it's an extglob with no children
    // (which really means one child of '')
    #emptyExt = false;
    constructor(type, parent, options = {}){
        this.type = type;
        // extglobs are inherently magical
        if (type) this.#hasMagic = true;
        this.#parent = parent;
        this.#root = this.#parent ? this.#parent.#root : this;
        this.#options = this.#root === this ? options : this.#root.#options;
        this.#negs = this.#root === this ? [] : this.#root.#negs;
        if (type === '!' && !this.#root.#filledNegs) this.#negs.push(this);
        this.#parentIndex = this.#parent ? this.#parent.#parts.length : 0;
    }
    get hasMagic() {
        /* c8 ignore start */ if (this.#hasMagic !== undefined) return this.#hasMagic;
        /* c8 ignore stop */ for (const p of this.#parts){
            if (typeof p === 'string') continue;
            if (p.type || p.hasMagic) return this.#hasMagic = true;
        }
        // note: will be undefined until we generate the regexp src and find out
        return this.#hasMagic;
    }
    // reconstructs the pattern
    toString() {
        if (this.#toString !== undefined) return this.#toString;
        if (!this.type) return this.#toString = this.#parts.map((p)=>String(p)).join('');
        else return this.#toString = this.type + '(' + this.#parts.map((p)=>String(p)).join('|') + ')';
    }
    #fillNegs() {
        /* c8 ignore start */ if (this !== this.#root) throw new Error('should only call on root');
        if (this.#filledNegs) return this;
        /* c8 ignore stop */ // call toString() once to fill this out
        this.toString();
        this.#filledNegs = true;
        let n;
        while(n = this.#negs.pop()){
            if (n.type !== '!') continue;
            // walk up the tree, appending everthing that comes AFTER parentIndex
            let p = n;
            let pp = p.#parent;
            while(pp){
                for(let i = p.#parentIndex + 1; !pp.type && i < pp.#parts.length; i++)for (const part of n.#parts){
                    /* c8 ignore start */ if (typeof part === 'string') throw new Error('string part in extglob AST??');
                    /* c8 ignore stop */ part.copyIn(pp.#parts[i]);
                }
                p = pp;
                pp = p.#parent;
            }
        }
        return this;
    }
    push(...parts) {
        for (const p of parts){
            if (p === '') continue;
            /* c8 ignore start */ if (typeof p !== 'string' && !(p instanceof $83721aed6dc1e49f$var$AST && p.#parent === this)) throw new Error('invalid part: ' + p);
            /* c8 ignore stop */ this.#parts.push(p);
        }
    }
    toJSON() {
        const ret = this.type === null ? this.#parts.slice().map((p)=>typeof p === 'string' ? p : p.toJSON()) : [
            this.type,
            ...this.#parts.map((p)=>p.toJSON())
        ];
        if (this.isStart() && !this.type) ret.unshift([]);
        if (this.isEnd() && (this === this.#root || this.#root.#filledNegs && this.#parent?.type === '!')) ret.push({});
        return ret;
    }
    isStart() {
        if (this.#root === this) return true;
        // if (this.type) return !!this.#parent?.isStart()
        if (!this.#parent?.isStart()) return false;
        if (this.#parentIndex === 0) return true;
        // if everything AHEAD of this is a negation, then it's still the "start"
        const p = this.#parent;
        for(let i = 0; i < this.#parentIndex; i++){
            const pp = p.#parts[i];
            if (!(pp instanceof $83721aed6dc1e49f$var$AST && pp.type === '!')) return false;
        }
        return true;
    }
    isEnd() {
        if (this.#root === this) return true;
        if (this.#parent?.type === '!') return true;
        if (!this.#parent?.isEnd()) return false;
        if (!this.type) return this.#parent?.isEnd();
        // if not root, it'll always have a parent
        /* c8 ignore start */ const pl = this.#parent ? this.#parent.#parts.length : 0;
        /* c8 ignore stop */ return this.#parentIndex === pl - 1;
    }
    copyIn(part) {
        if (typeof part === 'string') this.push(part);
        else this.push(part.clone(this));
    }
    clone(parent) {
        const c = new $83721aed6dc1e49f$var$AST(this.type, parent);
        for (const p of this.#parts)c.copyIn(p);
        return c;
    }
    static #parseAST(str, ast, pos, opt) {
        let escaping = false;
        let inBrace = false;
        let braceStart = -1;
        let braceNeg = false;
        if (ast.type === null) {
            // outside of a extglob, append until we find a start
            let i = pos;
            let acc = '';
            while(i < str.length){
                const c = str.charAt(i++);
                // still accumulate escapes at this point, but we do ignore
                // starts that are escaped
                if (escaping || c === '\\') {
                    escaping = !escaping;
                    acc += c;
                    continue;
                }
                if (inBrace) {
                    if (i === braceStart + 1) {
                        if (c === '^' || c === '!') braceNeg = true;
                    } else if (c === ']' && !(i === braceStart + 2 && braceNeg)) inBrace = false;
                    acc += c;
                    continue;
                } else if (c === '[') {
                    inBrace = true;
                    braceStart = i;
                    braceNeg = false;
                    acc += c;
                    continue;
                }
                if (!opt.noext && $83721aed6dc1e49f$var$isExtglobType(c) && str.charAt(i) === '(') {
                    ast.push(acc);
                    acc = '';
                    const ext = new $83721aed6dc1e49f$var$AST(c, ast);
                    i = $83721aed6dc1e49f$var$AST.#parseAST(str, ext, i, opt);
                    ast.push(ext);
                    continue;
                }
                acc += c;
            }
            ast.push(acc);
            return i;
        }
        // some kind of extglob, pos is at the (
        // find the next | or )
        let i = pos + 1;
        let part = new $83721aed6dc1e49f$var$AST(null, ast);
        const parts = [];
        let acc = '';
        while(i < str.length){
            const c = str.charAt(i++);
            // still accumulate escapes at this point, but we do ignore
            // starts that are escaped
            if (escaping || c === '\\') {
                escaping = !escaping;
                acc += c;
                continue;
            }
            if (inBrace) {
                if (i === braceStart + 1) {
                    if (c === '^' || c === '!') braceNeg = true;
                } else if (c === ']' && !(i === braceStart + 2 && braceNeg)) inBrace = false;
                acc += c;
                continue;
            } else if (c === '[') {
                inBrace = true;
                braceStart = i;
                braceNeg = false;
                acc += c;
                continue;
            }
            if ($83721aed6dc1e49f$var$isExtglobType(c) && str.charAt(i) === '(') {
                part.push(acc);
                acc = '';
                const ext = new $83721aed6dc1e49f$var$AST(c, part);
                part.push(ext);
                i = $83721aed6dc1e49f$var$AST.#parseAST(str, ext, i, opt);
                continue;
            }
            if (c === '|') {
                part.push(acc);
                acc = '';
                parts.push(part);
                part = new $83721aed6dc1e49f$var$AST(null, ast);
                continue;
            }
            if (c === ')') {
                if (acc === '' && ast.#parts.length === 0) ast.#emptyExt = true;
                part.push(acc);
                acc = '';
                ast.push(...parts, part);
                return i;
            }
            acc += c;
        }
        // unfinished extglob
        // if we got here, it was a malformed extglob! not an extglob, but
        // maybe something else in there.
        ast.type = null;
        ast.#hasMagic = undefined;
        ast.#parts = [
            str.substring(pos - 1)
        ];
        return i;
    }
    static fromGlob(pattern, options = {}) {
        const ast = new $83721aed6dc1e49f$var$AST(null, undefined, options);
        $83721aed6dc1e49f$var$AST.#parseAST(pattern, ast, 0, options);
        return ast;
    }
    // returns the regular expression if there's magic, or the unescaped
    // string if not.
    toMMPattern() {
        // should only be called on root
        /* c8 ignore start */ if (this !== this.#root) return this.#root.toMMPattern();
        /* c8 ignore stop */ const glob = this.toString();
        const [re, body, hasMagic, uflag] = this.toRegExpSource();
        // if we're in nocase mode, and not nocaseMagicOnly, then we do
        // still need a regular expression if we have to case-insensitively
        // match capital/lowercase characters.
        const anyMagic = hasMagic || this.#hasMagic || this.#options.nocase && !this.#options.nocaseMagicOnly && glob.toUpperCase() !== glob.toLowerCase();
        if (!anyMagic) return body;
        const flags = (this.#options.nocase ? 'i' : '') + (uflag ? 'u' : '');
        return Object.assign(new RegExp(`^${re}$`, flags), {
            _src: re,
            _glob: glob
        });
    }
    get options() {
        return this.#options;
    }
    // returns the string match, the regexp source, whether there's magic
    // in the regexp (so a regular expression is required) and whether or
    // not the uflag is needed for the regular expression (for posix classes)
    // TODO: instead of injecting the start/end at this point, just return
    // the BODY of the regexp, along with the start/end portions suitable
    // for binding the start/end in either a joined full-path makeRe context
    // (where we bind to (^|/), or a standalone matchPart context (where
    // we bind to ^, and not /).  Otherwise slashes get duped!
    //
    // In part-matching mode, the start is:
    // - if not isStart: nothing
    // - if traversal possible, but not allowed: ^(?!\.\.?$)
    // - if dots allowed or not possible: ^
    // - if dots possible and not allowed: ^(?!\.)
    // end is:
    // - if not isEnd(): nothing
    // - else: $
    //
    // In full-path matching mode, we put the slash at the START of the
    // pattern, so start is:
    // - if first pattern: same as part-matching mode
    // - if not isStart(): nothing
    // - if traversal possible, but not allowed: /(?!\.\.?(?:$|/))
    // - if dots allowed or not possible: /
    // - if dots possible and not allowed: /(?!\.)
    // end is:
    // - if last pattern, same as part-matching mode
    // - else nothing
    //
    // Always put the (?:$|/) on negated tails, though, because that has to be
    // there to bind the end of the negated pattern portion, and it's easier to
    // just stick it in now rather than try to inject it later in the middle of
    // the pattern.
    //
    // We can just always return the same end, and leave it up to the caller
    // to know whether it's going to be used joined or in parts.
    // And, if the start is adjusted slightly, can do the same there:
    // - if not isStart: nothing
    // - if traversal possible, but not allowed: (?:/|^)(?!\.\.?$)
    // - if dots allowed or not possible: (?:/|^)
    // - if dots possible and not allowed: (?:/|^)(?!\.)
    //
    // But it's better to have a simpler binding without a conditional, for
    // performance, so probably better to return both start options.
    //
    // Then the caller just ignores the end if it's not the first pattern,
    // and the start always gets applied.
    //
    // But that's always going to be $ if it's the ending pattern, or nothing,
    // so the caller can just attach $ at the end of the pattern when building.
    //
    // So the todo is:
    // - better detect what kind of start is needed
    // - return both flavors of starting pattern
    // - attach $ at the end of the pattern when creating the actual RegExp
    //
    // Ah, but wait, no, that all only applies to the root when the first pattern
    // is not an extglob. If the first pattern IS an extglob, then we need all
    // that dot prevention biz to live in the extglob portions, because eg
    // +(*|.x*) can match .xy but not .yx.
    //
    // So, return the two flavors if it's #root and the first child is not an
    // AST, otherwise leave it to the child AST to handle it, and there,
    // use the (?:^|/) style of start binding.
    //
    // Even simplified further:
    // - Since the start for a join is eg /(?!\.) and the start for a part
    // is ^(?!\.), we can just prepend (?!\.) to the pattern (either root
    // or start or whatever) and prepend ^ or / at the Regexp construction.
    toRegExpSource(allowDot) {
        const dot = allowDot ?? !!this.#options.dot;
        if (this.#root === this) this.#fillNegs();
        if (!this.type) {
            const noEmpty = this.isStart() && this.isEnd();
            const src = this.#parts.map((p)=>{
                const [re, _, hasMagic, uflag] = typeof p === 'string' ? $83721aed6dc1e49f$var$AST.#parseGlob(p, this.#hasMagic, noEmpty) : p.toRegExpSource(allowDot);
                this.#hasMagic = this.#hasMagic || hasMagic;
                this.#uflag = this.#uflag || uflag;
                return re;
            }).join('');
            let start = '';
            if (this.isStart()) {
                if (typeof this.#parts[0] === 'string') {
                    // this is the string that will match the start of the pattern,
                    // so we need to protect against dots and such.
                    // '.' and '..' cannot match unless the pattern is that exactly,
                    // even if it starts with . or dot:true is set.
                    const dotTravAllowed = this.#parts.length === 1 && $83721aed6dc1e49f$var$justDots.has(this.#parts[0]);
                    if (!dotTravAllowed) {
                        const aps = $83721aed6dc1e49f$var$addPatternStart;
                        // check if we have a possibility of matching . or ..,
                        // and prevent that.
                        const needNoTrav = // dots are allowed, and the pattern starts with [ or .
                        dot && aps.has(src.charAt(0)) || // the pattern starts with \., and then [ or .
                        src.startsWith('\\.') && aps.has(src.charAt(2)) || // the pattern starts with \.\., and then [ or .
                        src.startsWith('\\.\\.') && aps.has(src.charAt(4));
                        // no need to prevent dots if it can't match a dot, or if a
                        // sub-pattern will be preventing it anyway.
                        const needNoDot = !dot && !allowDot && aps.has(src.charAt(0));
                        start = needNoTrav ? $83721aed6dc1e49f$var$startNoTraversal : needNoDot ? $83721aed6dc1e49f$var$startNoDot : '';
                    }
                }
            }
            // append the "end of path portion" pattern to negation tails
            let end = '';
            if (this.isEnd() && this.#root.#filledNegs && this.#parent?.type === '!') end = '(?:$|\\/)';
            const final = start + src + end;
            return [
                final,
                (0, $86rUr.unescape)(src),
                this.#hasMagic = !!this.#hasMagic,
                this.#uflag
            ];
        }
        // We need to calculate the body *twice* if it's a repeat pattern
        // at the start, once in nodot mode, then again in dot mode, so a
        // pattern like *(?) can match 'x.y'
        const repeated = this.type === '*' || this.type === '+';
        // some kind of extglob
        const start = this.type === '!' ? '(?:(?!(?:' : '(?:';
        let body = this.#partsToRegExp(dot);
        if (this.isStart() && this.isEnd() && !body && this.type !== '!') {
            // invalid extglob, has to at least be *something* present, if it's
            // the entire path portion.
            const s = this.toString();
            this.#parts = [
                s
            ];
            this.type = null;
            this.#hasMagic = undefined;
            return [
                s,
                (0, $86rUr.unescape)(this.toString()),
                false,
                false
            ];
        }
        // XXX abstract out this map method
        let bodyDotAllowed = !repeated || allowDot || dot || !$83721aed6dc1e49f$var$startNoDot ? '' : this.#partsToRegExp(true);
        if (bodyDotAllowed === body) bodyDotAllowed = '';
        if (bodyDotAllowed) body = `(?:${body})(?:${bodyDotAllowed})*?`;
        // an empty !() is exactly equivalent to a starNoEmpty
        let final = '';
        if (this.type === '!' && this.#emptyExt) final = (this.isStart() && !dot ? $83721aed6dc1e49f$var$startNoDot : '') + $83721aed6dc1e49f$var$starNoEmpty;
        else {
            const close = this.type === '!' ? '))' + (this.isStart() && !dot && !allowDot ? $83721aed6dc1e49f$var$startNoDot : '') + $83721aed6dc1e49f$var$star + ')' : this.type === '@' ? ')' : this.type === '?' ? ')?' : this.type === '+' && bodyDotAllowed ? ')' : this.type === '*' && bodyDotAllowed ? `)?` : `)${this.type}`;
            final = start + body + close;
        }
        return [
            final,
            (0, $86rUr.unescape)(body),
            this.#hasMagic = !!this.#hasMagic,
            this.#uflag
        ];
    }
    #partsToRegExp(dot) {
        return this.#parts.map((p)=>{
            // extglob ASTs should only contain parent ASTs
            /* c8 ignore start */ if (typeof p === 'string') throw new Error('string type in extglob ast??');
            /* c8 ignore stop */ // can ignore hasMagic, because extglobs are already always magic
            const [re, _, _hasMagic, uflag] = p.toRegExpSource(dot);
            this.#uflag = this.#uflag || uflag;
            return re;
        }).filter((p)=>!(this.isStart() && this.isEnd()) || !!p).join('|');
    }
    static #parseGlob(glob, hasMagic, noEmpty = false) {
        let escaping = false;
        let re = '';
        let uflag = false;
        for(let i = 0; i < glob.length; i++){
            const c = glob.charAt(i);
            if (escaping) {
                escaping = false;
                re += ($83721aed6dc1e49f$var$reSpecials.has(c) ? '\\' : '') + c;
                continue;
            }
            if (c === '\\') {
                if (i === glob.length - 1) re += '\\\\';
                else escaping = true;
                continue;
            }
            if (c === '[') {
                const [src, needUflag, consumed, magic] = (0, $jQeq5.parseClass)(glob, i);
                if (consumed) {
                    re += src;
                    uflag = uflag || needUflag;
                    i += consumed - 1;
                    hasMagic = hasMagic || magic;
                    continue;
                }
            }
            if (c === '*') {
                if (noEmpty && glob === '*') re += $83721aed6dc1e49f$var$starNoEmpty;
                else re += $83721aed6dc1e49f$var$star;
                hasMagic = true;
                continue;
            }
            if (c === '?') {
                re += $83721aed6dc1e49f$var$qmark;
                hasMagic = true;
                continue;
            }
            re += $83721aed6dc1e49f$var$regExpEscape(c);
        }
        return [
            re,
            (0, $86rUr.unescape)(glob),
            !!hasMagic,
            uflag
        ];
    }
}
module.exports.AST = $83721aed6dc1e49f$var$AST;

});
parcelRegister("jQeq5", function(module, exports) {
"use strict";
// translate the various posix character classes into unicode properties
// this works across all unicode locales
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseClass = void 0;
// { <posix class>: [<translation>, /u flag required, negated]
const $e71e0f219ac65195$var$posixClasses = {
    '[:alnum:]': [
        '\\p{L}\\p{Nl}\\p{Nd}',
        true
    ],
    '[:alpha:]': [
        '\\p{L}\\p{Nl}',
        true
    ],
    '[:ascii:]': [
        "\\x00-\\x7f",
        false
    ],
    '[:blank:]': [
        '\\p{Zs}\\t',
        true
    ],
    '[:cntrl:]': [
        '\\p{Cc}',
        true
    ],
    '[:digit:]': [
        '\\p{Nd}',
        true
    ],
    '[:graph:]': [
        '\\p{Z}\\p{C}',
        true,
        true
    ],
    '[:lower:]': [
        '\\p{Ll}',
        true
    ],
    '[:print:]': [
        '\\p{C}',
        true
    ],
    '[:punct:]': [
        '\\p{P}',
        true
    ],
    '[:space:]': [
        '\\p{Z}\\t\\r\\n\\v\\f',
        true
    ],
    '[:upper:]': [
        '\\p{Lu}',
        true
    ],
    '[:word:]': [
        '\\p{L}\\p{Nl}\\p{Nd}\\p{Pc}',
        true
    ],
    '[:xdigit:]': [
        'A-Fa-f0-9',
        false
    ]
};
// only need to escape a few things inside of brace expressions
// escapes: [ \ ] -
const $e71e0f219ac65195$var$braceEscape = (s)=>s.replace(/[[\]\\-]/g, '\\$&');
// escape all regexp magic characters
const $e71e0f219ac65195$var$regexpEscape = (s)=>s.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
// everything has already been escaped, we just have to join
const $e71e0f219ac65195$var$rangesToString = (ranges)=>ranges.join('');
// takes a glob string at a posix brace expression, and returns
// an equivalent regular expression source, and boolean indicating
// whether the /u flag needs to be applied, and the number of chars
// consumed to parse the character class.
// This also removes out of order ranges, and returns ($.) if the
// entire class just no good.
const $e71e0f219ac65195$var$parseClass = (glob, position)=>{
    const pos = position;
    /* c8 ignore start */ if (glob.charAt(pos) !== '[') throw new Error('not in a brace expression');
    /* c8 ignore stop */ const ranges = [];
    const negs = [];
    let i = pos + 1;
    let sawStart = false;
    let uflag = false;
    let escaping = false;
    let negate = false;
    let endPos = pos;
    let rangeStart = '';
    WHILE: while(i < glob.length){
        const c = glob.charAt(i);
        if ((c === '!' || c === '^') && i === pos + 1) {
            negate = true;
            i++;
            continue;
        }
        if (c === ']' && sawStart && !escaping) {
            endPos = i + 1;
            break;
        }
        sawStart = true;
        if (c === '\\') {
            if (!escaping) {
                escaping = true;
                i++;
                continue;
            }
        }
        if (c === '[' && !escaping) {
            // either a posix class, a collation equivalent, or just a [
            for (const [cls, [unip, u, neg]] of Object.entries($e71e0f219ac65195$var$posixClasses))if (glob.startsWith(cls, i)) {
                // invalid, [a-[] is fine, but not [a-[:alpha]]
                if (rangeStart) return [
                    '$.',
                    false,
                    glob.length - pos,
                    true
                ];
                i += cls.length;
                if (neg) negs.push(unip);
                else ranges.push(unip);
                uflag = uflag || u;
                continue WHILE;
            }
        }
        // now it's just a normal character, effectively
        escaping = false;
        if (rangeStart) {
            // throw this range away if it's not valid, but others
            // can still match.
            if (c > rangeStart) ranges.push($e71e0f219ac65195$var$braceEscape(rangeStart) + '-' + $e71e0f219ac65195$var$braceEscape(c));
            else if (c === rangeStart) ranges.push($e71e0f219ac65195$var$braceEscape(c));
            rangeStart = '';
            i++;
            continue;
        }
        // now might be the start of a range.
        // can be either c-d or c-] or c<more...>] or c] at this point
        if (glob.startsWith('-]', i + 1)) {
            ranges.push($e71e0f219ac65195$var$braceEscape(c + '-'));
            i += 2;
            continue;
        }
        if (glob.startsWith('-', i + 1)) {
            rangeStart = c;
            i += 2;
            continue;
        }
        // not the start of a range, just a single character
        ranges.push($e71e0f219ac65195$var$braceEscape(c));
        i++;
    }
    if (endPos < i) // didn't see the end of the class, not a valid class,
    // but might still be valid as a literal match.
    return [
        '',
        false,
        0,
        false
    ];
    // if we got no ranges and no negates, then we have a range that
    // cannot possibly match anything, and that poisons the whole glob
    if (!ranges.length && !negs.length) return [
        '$.',
        false,
        glob.length - pos,
        true
    ];
    // if we got one positive range, and it's a single character, then that's
    // not actually a magic pattern, it's just that one literal character.
    // we should not treat that as "magic", we should just return the literal
    // character. [_] is a perfectly valid way to escape glob magic chars.
    if (negs.length === 0 && ranges.length === 1 && /^\\?.$/.test(ranges[0]) && !negate) {
        const r = ranges[0].length === 2 ? ranges[0].slice(-1) : ranges[0];
        return [
            $e71e0f219ac65195$var$regexpEscape(r),
            false,
            endPos - pos,
            false
        ];
    }
    const sranges = '[' + (negate ? '^' : '') + $e71e0f219ac65195$var$rangesToString(ranges) + ']';
    const snegs = '[' + (negate ? '' : '^') + $e71e0f219ac65195$var$rangesToString(negs) + ']';
    const comb = ranges.length && negs.length ? '(' + sranges + '|' + snegs + ')' : ranges.length ? sranges : snegs;
    return [
        comb,
        uflag,
        endPos - pos,
        true
    ];
};
module.exports.parseClass = $e71e0f219ac65195$var$parseClass;

});

parcelRegister("86rUr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.unescape = void 0;
/**
 * Un-escape a string that has been escaped with {@link escape}.
 *
 * If the {@link windowsPathsNoEscape} option is used, then square-brace
 * escapes are removed, but not backslash escapes.  For example, it will turn
 * the string `'[*]'` into `*`, but it will not turn `'\\*'` into `'*'`,
 * becuase `\` is a path separator in `windowsPathsNoEscape` mode.
 *
 * When `windowsPathsNoEscape` is not set, then both brace escapes and
 * backslash escapes are removed.
 *
 * Slashes (and backslashes in `windowsPathsNoEscape` mode) cannot be escaped
 * or unescaped.
 */ const $5e64887a12a9c251$var$unescape = (s, { windowsPathsNoEscape: windowsPathsNoEscape = false } = {})=>{
    return windowsPathsNoEscape ? s.replace(/\[([^\/\\])\]/g, '$1') : s.replace(/((?!\\).|^)\[([^\/\\])\]/g, '$1$2').replace(/\\([^\/])/g, '$1');
};
module.exports.unescape = $5e64887a12a9c251$var$unescape;

});


parcelRegister("eMqju", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.escape = void 0;
/**
 * Escape all magic characters in a glob pattern.
 *
 * If the {@link windowsPathsNoEscape | GlobOptions.windowsPathsNoEscape}
 * option is used, then characters are escaped by wrapping in `[]`, because
 * a magic character wrapped in a character class can only be satisfied by
 * that exact character.  In this mode, `\` is _not_ escaped, because it is
 * not interpreted as a magic character, but instead as a path separator.
 */ const $ac29f5aa61cc4f4d$var$escape = (s, { windowsPathsNoEscape: windowsPathsNoEscape = false } = {})=>{
    // don't need to escape +@! because we escape the parens
    // that make those magic, and escaping ! as [!] isn't valid,
    // because [!]] is a valid glob class meaning not ']'.
    return windowsPathsNoEscape ? s.replace(/[?*()[\]]/g, '[$&]') : s.replace(/[?*()[\]\\]/g, '\\$&');
};
module.exports.escape = $ac29f5aa61cc4f4d$var$escape;

});


parcelRegister("7WJ1X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseUrl = void 0;
function $5c90e151fff28538$var$parseUrl(url) {
    const protocol = url.match(/^(.*?:)/)?.[0] ?? 'https:';
    const hostname = url.replace(protocol, '').replace(/^\/*/, '').replace(/^\\*/, '').split(/[\?\/]/)[0];
    return {
        protocol: protocol,
        hostname: hostname
    };
}
module.exports.parseUrl = $5c90e151fff28538$var$parseUrl;

});


parcelRegister("heUAo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getEgressesBasedOnToggles = module.exports.sortAndGroupEgressPermissionsByDomain = module.exports.EgressCategory = module.exports.EgressType = void 0;

var $aN3lj = parcelRequire("aN3lj");

var $7WJ1X = parcelRequire("7WJ1X");
const $c8cfa346e95a2167$var$sortAndGroupEgressPermissionsByDomain = (egressAddresses)=>{
    if (egressAddresses?.length === 0) return [];
    const protocolRegex = /^(.*?:\/\/)/;
    const domains = new Set();
    const wildcardDomains = [];
    egressAddresses.forEach((item)=>{
        const itemWithProtocol = protocolRegex.test(item) ? item : `https://${item}`;
        const url = (0, $7WJ1X.parseUrl)(itemWithProtocol);
        if (url.hostname.startsWith('*')) {
            domains.add(url.hostname.substring(2));
            wildcardDomains.push(new $aN3lj.Minimatch(url.hostname));
        } else domains.add(url.hostname);
    });
    return [
        ...domains
    ].sort().reduce((grouped, domain)=>{
        if (!wildcardDomains.some((wcd)=>wcd.match(domain))) grouped.push(domain);
        return grouped;
    }, []);
};
module.exports.sortAndGroupEgressPermissionsByDomain = $c8cfa346e95a2167$var$sortAndGroupEgressPermissionsByDomain;
var $c8cfa346e95a2167$var$EgressType;
(function(EgressType) {
    EgressType["FetchBackendSide"] = "FETCH_BACKEND_SIDE";
    EgressType["FetchClientSide"] = "FETCH_CLIENT_SIDE";
    EgressType["Fonts"] = "FONTS";
    EgressType["Frames"] = "FRAMES";
    EgressType["Images"] = "IMAGES";
    EgressType["Media"] = "MEDIA";
    EgressType["Navigation"] = "NAVIGATION";
    EgressType["Scripts"] = "SCRIPTS";
    EgressType["Styles"] = "STYLES";
})($c8cfa346e95a2167$var$EgressType = module.exports.EgressType || (module.exports.EgressType = {}));
var $c8cfa346e95a2167$var$EgressCategory;
(function(EgressCategory) {
    EgressCategory["ANALYTICS"] = "ANALYTICS";
})($c8cfa346e95a2167$var$EgressCategory = module.exports.EgressCategory || (module.exports.EgressCategory = {}));
const $c8cfa346e95a2167$var$getEgressesBasedOnToggles = (input)=>{
    const filteredEgresses = input.egress.filter((egress)=>{
        if (egress.category?.toUpperCase() === $c8cfa346e95a2167$var$EgressCategory.ANALYTICS) {
            if (input.installationConfig) {
                const analyticsConfig = input.installationConfig.find((config)=>config.key.toUpperCase() === 'ALLOW_EGRESS_ANALYTICS');
                return analyticsConfig?.value !== false;
            } else return input.overrides.ALLOW_EGRESS_ANALYTICS !== false;
        }
        return true;
    });
    const egressByType = new Map();
    for (const egress of filteredEgresses){
        if (!egressByType.has(egress.type)) egressByType.set(egress.type, egress.addresses);
        egressByType.set(egress.type, [
            ...egressByType.get(egress.type),
            ...egress.addresses
        ]);
    }
    return [
        ...egressByType.entries()
    ].map(([type, egresses])=>({
            type: type,
            addresses: [
                ...new Set(egresses)
            ]
        }));
};
module.exports.getEgressesBasedOnToggles = $c8cfa346e95a2167$var$getEgressesBasedOnToggles;

});




parcelRegister("2lpkv", function(module, exports) {
$parcel$export(module.exports, "makeUrl", () => $04f835d373bf273f$export$e98ca45c96b2aafe);

var $gQw4t = parcelRequire("gQw4t");
const $04f835d373bf273f$var$emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// Filters out all parameters that may be used for malicious purposes such as attaching local files or adding bcc recipients
// Only subject and body are allowed
const $04f835d373bf273f$var$filterMailtoParams = (mailtoLink)=>{
    try {
        const url = new URL(mailtoLink);
        const params = url.searchParams;
        const email = url.pathname;
        let newParams = '';
        if (!$04f835d373bf273f$var$emailRegex.test(email)) // throw empty error for makeUrl to catch
        throw new Error();
        if (params.has('subject')) newParams += 'subject=' + encodeURIComponent(params.get('subject') || '');
        if (params.has('body')) {
            newParams += newParams ? '&body=' : 'body=';
            newParams += encodeURIComponent(params.get('body') || '');
        }
        return `${url.protocol}${email}` + (newParams ? '?' + newParams : '');
    } catch (error) {
        // throw empty error for makeUrl to catch
        throw new Error();
    }
};
function $04f835d373bf273f$export$e98ca45c96b2aafe(urlString) {
    try {
        if (urlString.startsWith('mailto:')) return new URL($04f835d373bf273f$var$filterMailtoParams(urlString));
        if (urlString.startsWith('tel:')) // For telephone links, we just return the URL as is
        return new URL(urlString);
        // Check if URL starts with a custom URL scheme (e.g., forge:\\, spotify:, etc.)
        const customURLSchemeRegex = /^[a-zA-Z]+:(\\\\)?/;
        if (customURLSchemeRegex.test(urlString)) return new URL(urlString);
        // We decode the URL string to handle cases where a malicious app might pass in a URL with encoded characters to bypass our egress checks
        const decodedUrlString = decodeURIComponent(urlString);
        const fullUrl = decodedUrlString.startsWith('/') ? `${(0, $gQw4t.getOrigin)()}${urlString}` : urlString;
        // Checks if `fullUrl` has a protocol(eg. http://, https://, etc), if not, add the `https://` protocol
        const protocolRegex = /^(.*?:\/\/)/;
        const urlWithProtocol = protocolRegex.test(fullUrl) ? fullUrl : `https://${fullUrl}`;
        // We use the URL constructor to validate the URL
        const url = new URL(urlWithProtocol);
        return url;
    } catch  {
        return undefined;
    }
}

});


parcelRegister("h2b6l", function(module, exports) {
$parcel$export(module.exports, "useRovoAgentsChat", () => $7b37bc4ab643055b$export$1b9e058b7e689de);

var $leNtV = parcelRequire("leNtV");
parcelRequire("1B59H");
var $aJjD9 = parcelRequire("aJjD9");

var $9D7Fh = parcelRequire("9D7Fh");

var $dhyRR = parcelRequire("dhyRR");
const $7b37bc4ab643055b$var$ROVO_TOPIC = 'ai-mate';
const $7b37bc4ab643055b$var$FORGE_SOURCE = 'forge-bridge-open-rovo';
const $7b37bc4ab643055b$var$ROVO_EVENT_TYPE = 'chat-new';
const $7b37bc4ab643055b$var$isRestrictedAppEnvironment = (environmentType, appId)=>{
    const ALLOWED_INTERNAL_APP_IDS = [
        '41dcbde8-321e-4e36-8b17-6f7697794ea6'
    ];
    return environmentType === (0, $aJjD9.ExtensionEnvironment).PRODUCTION && !ALLOWED_INTERNAL_APP_IDS.includes(appId);
};
function $7b37bc4ab643055b$export$1b9e058b7e689de(extensionType, environmentType, appId, cloudId, apolloClient) {
    const publish = (0, $leNtV.usePublish)($7b37bc4ab643055b$var$ROVO_TOPIC);
    return {
        openRovo: async ({ agentKey: agentKey, agentName: agentName, agentAppId: agentAppId, prompt: prompt })=>{
            // TODO: Remove this check once the feature is not in EAP
            if ($7b37bc4ab643055b$var$isRestrictedAppEnvironment(environmentType, appId)) {
                /* eslint-disable no-console */ console.error('Forge rovo open usage is restricted to Forge apps in a non-production environment. Please see https://developer.atlassian.com/platform/forge/cli-reference/environments/ for reference on Forge app environments.');
                /* eslint-disable no-console */ return;
            }
            const product = (0, $9D7Fh.getRovoProductFromExtensionType)(extensionType);
            if (!cloudId || !product) return false;
            // If agent name is not provided use default rovo chat agent
            const agentId = agentName ? await (0, $dhyRR.getRovoAgentId)({
                client: apolloClient,
                cloudId: cloudId,
                input: {
                    name: agentName
                },
                product: product,
                agentKey: agentKey,
                agentAppId: agentAppId
            }) : (0, $dhyRR.DEFAULT_AGENT_REFERENCE);
            publish({
                type: $7b37bc4ab643055b$var$ROVO_EVENT_TYPE,
                product: product,
                data: {
                    dialogues: [],
                    agentId: agentId,
                    ...prompt ? {
                        prompt: prompt
                    } : {}
                },
                source: $7b37bc4ab643055b$var$FORGE_SOURCE
            });
        }
    };
}

});
parcelRegister("9D7Fh", function(module, exports) {
$parcel$export(module.exports, "getRovoProductFromExtensionType", () => $ca01b283fb2cc851$export$eb5f18ff99769aac);
const $ca01b283fb2cc851$export$eb5f18ff99769aac = (extensionType)=>{
    const [product, moduleName] = extensionType.split(':');
    const SUPPORTED_PRODUCTS = [
        'jira',
        'confluence'
    ];
    // For xen:macro
    if (product === 'xen') return 'confluence';
    // Resolve non-portal JSM modules to Jira
    if (product === 'jiraServiceManagement') {
        if (moduleName && !moduleName.includes('portal')) return 'jira';
    }
    if (!SUPPORTED_PRODUCTS.includes(product)) return null;
    return product;
};

});

parcelRegister("dhyRR", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_AGENT_REFERENCE", () => $71f9cddeac1c9c35$export$6e6c2af98f57fa9d);
$parcel$export(module.exports, "getRovoAgentId", () => $71f9cddeac1c9c35$export$de10b7621d6ba909);

var $kuAvn = parcelRequire("kuAvn");
const $71f9cddeac1c9c35$export$6e6c2af98f57fa9d = 'ai_mate_agent';
const $71f9cddeac1c9c35$export$b573cc53e8beacd0 = (0, $kuAvn.default)`
	query agentStudioGetAgents(
		$cloudId: String!
		$input: AgentStudioAgentQueryInput
		$product: String
	) {
		agentStudio_getAgents(cloudId: $cloudId, input: $input, product: $product)
			@optIn(to: "AgentStudio") {
			edges {
				node {
					id
					name
					externalConfigReference
				}
			}
		}
	}
`;
// From https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/06c1faa9feb39485f12c6528f9baf9bb1c653451/platform/packages/ai-mate/conversation-assistant-agent/src/services/paginated-agents/utils.tsx
const $71f9cddeac1c9c35$var$getAgentIdFromAri = (ari)=>{
    // Pattern: ari:cloud:rovo::agent/activation/{uuid}/{uuid}
    const ariPattern = /^ari:cloud:rovo::agent\/activation\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/([^/]+)$/;
    const match = ari.match(ariPattern);
    if (!match) return null;
    // Return the second UUID (agent ID)
    return match[1];
};
const $71f9cddeac1c9c35$var$getIdFromAgent = (agent)=>{
    const id = agent?.node?.id;
    if (!id) return null;
    return $71f9cddeac1c9c35$var$getAgentIdFromAri(agent?.node?.id);
};
const $71f9cddeac1c9c35$var$getAgentIdFromResponse = (agentsList, agentKey, agentAppId)=>{
    // No agents found from given name so fallback to default agent
    if (agentsList.length === 0) return null;
    // OOTB agents can't have the same name,
    // but it can have the same name as a custom agent or a forge agent
    if (!agentKey || !agentAppId) {
        // Custom agents don't have externalConfigReference
        const agent = agentsList.find((agent)=>agent?.node?.externalConfigReference != null && !agent?.node?.externalConfigReference.includes('ari:cloud:ecosystem::extension'));
        return $71f9cddeac1c9c35$var$getIdFromAgent(agent);
    }
    // Forge agents can have the same name so we have to filter further by key and appId
    // Their external config reference follows the pattern:
    // `${installationId}_ari:cloud:ecosystem::extension/${appId}/${environmentId}/static/${moduleKey}`;
    const forgeAgentRegex = new RegExp(`${agentAppId}/[^/]+/static/${agentKey}`);
    const agent = agentsList.find((agent)=>agent?.node?.externalConfigReference && forgeAgentRegex.test(agent?.node?.externalConfigReference));
    return $71f9cddeac1c9c35$var$getIdFromAgent(agent);
};
const $71f9cddeac1c9c35$export$de10b7621d6ba909 = async ({ client: client, cloudId: cloudId, product: product, input: input, agentKey: agentKey, agentAppId: agentAppId })=>{
    const variables = {
        cloudId: cloudId,
        product: product,
        input: input
    };
    try {
        const response = await client.query({
            query: $71f9cddeac1c9c35$export$b573cc53e8beacd0,
            variables: variables,
            fetchPolicy: 'cache-first'
        });
        const agentsList = response.data?.agentStudio_getAgents?.edges ?? [];
        const agentId = $71f9cddeac1c9c35$var$getAgentIdFromResponse(agentsList, agentKey, agentAppId) ?? $71f9cddeac1c9c35$export$6e6c2af98f57fa9d;
        return agentId;
    } catch (err) {
        return $71f9cddeac1c9c35$export$6e6c2af98f57fa9d;
    }
};

});


parcelRegister("94uyE", function(module, exports) {
$parcel$export(module.exports, "isAppConsentedLocally", () => $869b129ccbdd9497$export$c58c2ef6cd7b14a1);
$parcel$export(module.exports, "setAppConsentLocal", () => $869b129ccbdd9497$export$8d4e05c53de89926);
const $869b129ccbdd9497$export$c58c2ef6cd7b14a1 = (appId, accountId)=>!!window['__consentedApps']?.[`${appId}:${accountId}`];
const $869b129ccbdd9497$export$8d4e05c53de89926 = (appId, accountId)=>{
    window.__consentedApps = window.__consentedApps || {};
    window.__consentedApps[`${appId}:${accountId}`] = true;
};

});

parcelRegister("6GbQJ", function(module, exports) {
$parcel$export(module.exports, "getLoadingComponent", () => $67565d1f34d66cec$export$aee5524fcec014ce);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $luIVK = parcelRequire("luIVK");
const $67565d1f34d66cec$export$aee5524fcec014ce = (loadingComponent)=>{
    if (loadingComponent) return typeof loadingComponent === 'function' ? loadingComponent() : loadingComponent;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $luIVK.Loader), {});
};

});
parcelRegister("luIVK", function(module, exports) {
$parcel$export(module.exports, "Loader", () => $b0f03019ee76bbf8$export$3b0d6d7590275603);
/* loader.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7ep4S = parcelRequire("7ep4S");
const $b0f03019ee76bbf8$export$3b0d6d7590275603 = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _y3gn1h6o _ca0qutpp _n3tdutpp _1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
            testId: "forge-app-loading-spinner",
            size: "large"
        })
    });
};

});


parcelRegister("aSByt", function(module, exports) {
$parcel$export(module.exports, "SANDBOX_DEPRECATION_ERROR", () => $97af29d32e1cef7b$export$22d69806bfc9e8c1);
$parcel$export(module.exports, "ForgeDeprecationMessage", () => $97af29d32e1cef7b$export$e812f4e5298c004d);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $iHPvF = parcelRequire("iHPvF");

var $kQDMm = parcelRequire("kQDMm");

var $cwqPy = parcelRequire("cwqPy");
const $97af29d32e1cef7b$export$22d69806bfc9e8c1 = 'INVALID_INVOCATION_RUNTIME_ERROR';
const $97af29d32e1cef7b$var$buildMessage = (title, error)=>{
    if (error === $97af29d32e1cef7b$export$22d69806bfc9e8c1) return `Your app ${title} is no longer working as it uses a deprecated platform feature. Please check if an update for this app is available through Atlassian Administration, or ask the app developer to upgrade the app.\nIf the app is listed on the marketplace, contact the developer using the Support tab.`;
    return `${title} version is outdated due to a deprecated platform component.\nThe app developer needs to update it to a compatible version.\nPlease ask your admin to check for updates or contact the app developer.`;
};
const $97af29d32e1cef7b$export$e812f4e5298c004d = (props)=>{
    const { client: client, extension: extension, error: error } = props;
    const [appName, setAppName] = (0, $eJOHy.useState)(undefined);
    (0, $eJOHy.useEffect)(()=>{
        if (client) {
            const response = client.query({
                query: (0, $kQDMm.GET_APP_NAME),
                variables: {
                    id: extension.id
                },
                context: {
                    headers: {
                        'atl-attribution': (0, $cwqPy.createAtlAttributionHeader)()
                    }
                }
            });
            response.then((data)=>{
                const appName = data.data?.app.name;
                setAppName(appName);
            });
        }
    }, [
        client,
        extension.id
    ]);
    const title = appName ? appName : extension.properties.title;
    const message = $97af29d32e1cef7b$var$buildMessage(title, error);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iHPvF.default), {
        title: "App update required",
        appearance: "error",
        children: message
    });
};

});
parcelRegister("kQDMm", function(module, exports) {
$parcel$export(module.exports, "GET_APP_NAME", () => $1ef8d21e4b587f7a$export$d55d1cb9c5e0f267);

var $kuAvn = parcelRequire("kuAvn");
const $1ef8d21e4b587f7a$export$d55d1cb9c5e0f267 = (0, $kuAvn.default)`
	query app($id: ID!) {
		app(id: $id) {
			name
		}
	}
`;

});


parcelRegister("2o6iP", function(module, exports) {
$parcel$export(module.exports, "useResizeAnalytics", () => $91899e38d87c6f2c$export$1b708c663f12db29);

var $eJOHy = parcelRequire("eJOHy");

var $6QUJr = parcelRequire("6QUJr");

var $aftb3 = parcelRequire("aftb3");

var $grXB3 = parcelRequire("grXB3");

var $hByHz = parcelRequire("hByHz");
const $91899e38d87c6f2c$export$1b708c663f12db29 = ({ isEnabled: isEnabled, viewportDimensions: viewportDimensions })=>{
    const { captureEvent: captureEvent } = (0, $grXB3.usePerformanceAnalytics)();
    const { containerRef: containerRef, height: height } = (0, $aftb3.useHeightObserver)();
    const isTracking = (0, $eJOHy.useRef)(true);
    (0, $eJOHy.useEffect)(()=>{
        // Stop tracking after 10 seconds
        const timeoutId = setTimeout(()=>{
            isTracking.current = false;
        }, (0, $hByHz.PERFORMANCE_ANALYTICS_INTERVAL));
        return ()=>clearTimeout(timeoutId);
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        if (height !== null && isEnabled && isTracking.current) {
            isTracking.current = true;
            captureEvent({
                type: 'resized',
                height: height,
                measuredHeight: viewportDimensions?.measuredHeight,
                viewportHeight: viewportDimensions?.viewportHeight,
                elapsed: (0, $6QUJr.getPerformanceMark)()
            });
        }
    }, [
        height,
        isEnabled,
        captureEvent,
        viewportDimensions
    ]);
    return {
        containerRef: containerRef
    };
};

});
parcelRegister("aftb3", function(module, exports) {
$parcel$export(module.exports, "useHeightObserver", () => $c7b378de28e521bc$export$9de303ca9515c607);

var $eJOHy = parcelRequire("eJOHy");
const $c7b378de28e521bc$var$LIMIT_UNIQUE_RESIZE_OBSERVATIONS = 15;
const $c7b378de28e521bc$export$9de303ca9515c607 = ()=>{
    const containerRef = (0, $eJOHy.useRef)(null);
    const [height, setHeight] = (0, $eJOHy.useState)(null);
    const [observationInvalidatedReason, setObservationInvalidatedReason] = (0, $eJOHy.useState)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (!containerRef.current) return;
        let uniqueSizeObservations = 0;
        // Also handles initial height in case ref->element attachment is delayed.
        const observer = new ResizeObserver(([entry])=>{
            setHeight((prevHeight)=>{
                const height = Math.trunc(entry.contentRect.height);
                if (prevHeight !== height) uniqueSizeObservations++;
                return height;
            });
            // Break after too many unique changes.
            if (uniqueSizeObservations >= $c7b378de28e521bc$var$LIMIT_UNIQUE_RESIZE_OBSERVATIONS) {
                observer.disconnect();
                setObservationInvalidatedReason(`Stopped counting after ${$c7b378de28e521bc$var$LIMIT_UNIQUE_RESIZE_OBSERVATIONS} unique resize events`);
            }
        });
        observer.observe(containerRef.current);
        return ()=>observer.disconnect();
    }, []);
    return {
        containerRef: containerRef,
        height: height,
        observationInvalidatedReason: observationInvalidatedReason
    };
};

});


parcelRegister("gnBoE", function(module, exports) {
$parcel$export(module.exports, "getFeatureFlags", () => $b6677f557d988e94$export$e02fc95a45760598);

var $cwqPy = parcelRequire("cwqPy");
var $aD1DH = parcelRequire("aD1DH");
const $b6677f557d988e94$var$globalEdgeUrlMap = {
    dev: 'dev.services.atlassian.com',
    stg: 'stg.services.atlassian.com',
    prod: 'services.atlassian.com'
};
const $b6677f557d988e94$var$getBaseUrl = (environment)=>{
    const baseUrl = $b6677f557d988e94$var$globalEdgeUrlMap[environment];
    if (!baseUrl) throw new Error(`Invalid environment: ${environment}`);
    const service = 'forge-outbound-proxy';
    const url = `https://${service}.${baseUrl}`;
    return url;
};
const $b6677f557d988e94$export$e02fc95a45760598 = async (appId, user, environment, contextToken)=>{
    const init = {
        method: 'POST',
        headers: {
            'atl-attribution': (0, $cwqPy.createAtlAttributionHeader)(),
            'Content-Type': 'application/json',
            Authentication: `Bearer ${contextToken}`
        },
        body: JSON.stringify({
            user: user,
            appId: appId
        })
    };
    const url = $b6677f557d988e94$var$getBaseUrl((0, $aD1DH.getCDNEnvironment)(environment)) + '/client/feature-flags';
    const response = await fetch(url, init);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return response.json();
};

});


parcelRegister("itxYZ", function(module, exports) {
$parcel$export(module.exports, "getExtensionType", () => $54bb88709be6c513$export$45b306f42e1402e5);
const $54bb88709be6c513$export$45b306f42e1402e5 = (extension)=>{
    const { properties: properties } = extension;
    if (properties?.layout === 'bodied') return 'bodiedExtension';
    else if (properties?.layout === 'inline') return 'inlineExtension';
    return 'extension';
};

});

parcelRegister("cf43T", function(module, exports) {
$parcel$export(module.exports, "ContextChangeObserverWrapper", () => $6057603bc28b6f20$export$5585193a0b9bb43d);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $1H69i = parcelRequire("1H69i");

var $5OKCR = parcelRequire("5OKCR");

var $7pA0u = parcelRequire("7pA0u");

var $cOZrT = parcelRequire("cOZrT");
const $6057603bc28b6f20$export$5585193a0b9bb43d = ({ context: context, children: children, getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion })=>{
    const forgeReactMajorVersion = (0, $eJOHy.useRef)(null);
    const initialConfigKey = (0, $eJOHy.useRef)(null);
    const { config: config, ...extensionWithoutConfig } = context.extension ?? {};
    const currentConfigKey = (0, (/*@__PURE__*/$parcel$interopDefault($5OKCR)))(config);
    const baseContextKey = (0, (/*@__PURE__*/$parcel$interopDefault($5OKCR)))({
        ...context,
        extension: extensionWithoutConfig
    });
    const trackWrappedComponentMounted = $6057603bc28b6f20$var$useWrappedComponentMountTracker();
    (0, $eJOHy.useEffect)(()=>{
        (0, $1H69i.emit)('FORGE_CORE_MACRO_CONFIG_CHANGED', {
            config: config
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentConfigKey
    ]);
    if (forgeReactMajorVersion.current === null) forgeReactMajorVersion.current = getCurrentForgeReactMajorVersion();
    if (initialConfigKey.current === null) initialConfigKey.current = currentConfigKey;
    // for existing apps we need to ensure backwards compatibility
    const shouldContextKeyChangeOnConfigChange = forgeReactMajorVersion.current === null || forgeReactMajorVersion.current < 11;
    // if the app is using the new version of Forge react, we always uses the initial config key
    const key = baseContextKey + (shouldContextKeyChangeOnConfigChange ? currentConfigKey : initialConfigKey.current);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($6057603bc28b6f20$var$WrappedComponent, {
        onMounted: trackWrappedComponentMounted,
        children: children
    }, key);
};
const $6057603bc28b6f20$var$useWrappedComponentMountTracker = ()=>{
    const { trackExtensionRemounted: trackExtensionRemounted } = (0, $cOZrT.useForgeUiAnalyticsEvent)();
    const mountedCount = (0, $eJOHy.useRef)(0);
    const trackWrappedComponentMounted = (0, $7pA0u.useCallbackOne)(()=>{
        mountedCount.current += 1;
        if (mountedCount.current > 1) trackExtensionRemounted({
            mountCount: mountedCount.current
        });
    }, [
        mountedCount,
        trackExtensionRemounted
    ]);
    return trackWrappedComponentMounted;
};
const $6057603bc28b6f20$var$WrappedComponent = ({ children: children, onMounted: onMounted })=>{
    (0, $eJOHy.useEffect)(()=>{
        onMounted();
    }, [
        onMounted
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
};

});


parcelRegister("b3nvV", function(module, exports) {
$parcel$export(module.exports, "FullScreenModalDialog", () => $58638ceafd87926a$export$103e9686fdc354e8);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lybQZ = parcelRequire("lybQZ");

var $956it = parcelRequire("956it");

var $2qG7I = parcelRequire("2qG7I");

var $5a9Ro = parcelRequire("5a9Ro");

var $ik0CA = parcelRequire("ik0CA");

var $kseeK = parcelRequire("kseeK");
function $58638ceafd87926a$export$103e9686fdc354e8(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lybQZ.default), {
        ...props,
        /**
			 * Making this an internal-only prop and exposing it through a facade
			 * component so that we can keep public types simple.
			 *
			 * Otherwise we need complex conditional types that are harder to
			 * understand / maintain and aren't actually any better for consumers.
			 */ isFullScreen: true,
        /**
			 * Setting width and height to 100% because the `isFullScreen` prop just
			 * removes the spacing around the modal. We still need to set the size to
			 * be 100%.
			 *
			 * Intentionally reusing the existing internals as much as possible to
			 * keep complexity low and avoid duplication. It also makes the fullscreen
			 * changes easier to remove.
			 */ width: "100%",
        height: "100%",
        /**
			 * Full screen modals only support body scrolling, so that the header
			 * and close button will always stay visible.
			 */ shouldScrollInViewport: false,
        /**
			 * This prop is a noop for fullscreen modals, so we aren't exposing it to consumers.
			 * Using `false` internally to avoid potential bugs.
			 */ shouldCloseOnOverlayClick: false,
        /**
			 * The blanket is only briefly visible for fullscreen modals when fading in,
			 * but provides a bit more of a visual cue that it has appeared on top.
			 *
			 * We don't want consumers to disable it.
			 */ isBlanketHidden: false
    });
}

});

parcelRegister("f7YKM", function(module, exports) {
$parcel$export(module.exports, "ModalContentWrapper", () => $a379e6f5f2bdcacb$export$a6d6b74199964ee4);
$parcel$export(module.exports, "getAtlasKitModalWidth", () => $a379e6f5f2bdcacb$export$ca177c112881662a);
/* custom-ui-modal-utils.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $ik0CA = parcelRequire("ik0CA");
const $a379e6f5f2bdcacb$var$smallModalStyles = null;
const $a379e6f5f2bdcacb$var$mediumModalStyles = null;
const $a379e6f5f2bdcacb$var$largeModalStyles = null;
const $a379e6f5f2bdcacb$var$xlargeModalStyles = null;
const $a379e6f5f2bdcacb$var$maxModalStyles = null;
const $a379e6f5f2bdcacb$var$resizableModalStyles = null;
const $a379e6f5f2bdcacb$export$a6d6b74199964ee4 = ({ children: children, size: size, styles: styles, isResizable: isResizable })=>{
    switch(size){
        case 'small':
            return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                style: styles,
                className: (0, $hcewu.default)([
                    "_2rkofajl _4t3i1tmh _1tkenklw _bfhk1bhr",
                    isResizable && "_1reo1wug _18m91wug _4t3i1wug"
                ]),
                children: children
            });
        case 'medium':
            return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                style: styles,
                className: (0, $hcewu.default)([
                    "_2rkofajl _4t3ivzbd _1tke1lk4 _bfhk1bhr",
                    isResizable && "_1reo1wug _18m91wug _4t3i1wug"
                ]),
                children: children
            });
        case 'large':
            return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                style: styles,
                className: (0, $hcewu.default)([
                    "_2rkofajl _4t3i1rxh _1tke1yw0 _bfhk1bhr",
                    isResizable && "_1reo1wug _18m91wug _4t3i1wug"
                ]),
                children: children
            });
        case 'xlarge':
            return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                style: styles,
                className: (0, $hcewu.default)([
                    "_2rkofajl _4t3i10fc _1tkezwhf _bfhk1bhr",
                    isResizable && "_1reo1wug _18m91wug _4t3i1wug"
                ]),
                children: children
            });
        case 'max':
            return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                style: styles,
                className: (0, $hcewu.default)([
                    "_2rkofajl _4t3i1osq _bfhk1bhr"
                ]),
                children: children
            });
        default:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ik0CA.default), {
                children: children
            });
    }
};
const $a379e6f5f2bdcacb$export$ca177c112881662a = (modalSize)=>{
    if (modalSize === 'xlarge') return 'x-large';
    if (modalSize === 'max') return '100%';
    return modalSize;
};

});

parcelRegister("ej6lz", function(module, exports) {
$parcel$export(module.exports, "ForgeModalDeprecationMessage", () => $83edf3b996a18275$export$5b67d59ebd4f147c);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $iHPvF = parcelRequire("iHPvF");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");

var $kQDMm = parcelRequire("kQDMm");

var $cwqPy = parcelRequire("cwqPy");
function $83edf3b996a18275$export$5b67d59ebd4f147c(props) {
    const { client: client, extension: extension } = props;
    const [appName, setAppName] = (0, $eJOHy.useState)(undefined);
    (0, $eJOHy.useEffect)(()=>{
        if (client && extension) {
            const response = client.query({
                query: (0, $kQDMm.GET_APP_NAME),
                variables: {
                    id: extension.id
                },
                context: {
                    headers: {
                        'atl-attribution': (0, $cwqPy.createAtlAttributionHeader)()
                    }
                }
            });
            response.then((data)=>{
                const appName = data.data?.app.name;
                setAppName(appName);
            });
        }
    }, [
        client,
        extension
    ]);
    const intl = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iHPvF.default), {
        title: intl.formatMessage($83edf3b996a18275$var$messages.title),
        appearance: "error",
        children: intl.formatMessage($83edf3b996a18275$var$messages.message, {
            appName: appName
        })
    });
}
const $83edf3b996a18275$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        id: 'forge.modal.deprecation.title',
        defaultMessage: 'Update your app',
        description: 'A section title that informs the user that the app needs to be updated.'
    },
    message: {
        id: 'forge.modal.deprecation.message',
        defaultMessage: 'Your app {appName} uses the deprecated modal editing experience for custom fields, which is being phased out. Please have your system admin update the app to use inline editing instead. If issues remain, contact the app developer.',
        description: 'A section message that informs the user that the app needs to be updated as it is using a deprecated platform feature and will soon stop working.'
    }
});

});


parcelRegister("2xaVu", function(module, exports) {
$parcel$export(module.exports, "UIKitRenderer", () => $e95377b2361405ba$export$9ca39743052e068e);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $ls6Yq = parcelRequire("ls6Yq");

var $c05dT = parcelRequire("c05dT");
var $6siRN = parcelRequire("6siRN");
var $3k3Gm = parcelRequire("3k3Gm");

var $8iFcj = parcelRequire("8iFcj");

var $h5IVr = parcelRequire("h5IVr");

var $2o6iP = parcelRequire("2o6iP");
const $e95377b2361405ba$var$HeightAnalyticsWrapper = ({ children: children, viewportDimensions: viewportDimensions })=>{
    const isEnabled = (0, $eGOwo.fg)('forge-ui-performance-analytics-provider');
    const { containerRef: containerRef } = (0, $2o6iP.useResizeAnalytics)({
        isEnabled: isEnabled,
        viewportDimensions: viewportDimensions
    });
    if (isEnabled) return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: containerRef,
        id: "forge-ui-height-observer-wrapper",
        children: children
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
};
const $e95377b2361405ba$export$9ca39743052e068e = (props)=>{
    const { accountId: accountId, bridge: bridge, client: client, components: components, coreData: coreData, contextIds: contextIds, entryPoint: entryPoint, extension: extension, extensionData: extensionData, extensionViewData: extensionViewData, getContextToken: getContextToken, mentionProvider: mentionProvider, product: product, locale: locale, modalExtension: modalExtension, onForgeDocUpdated: onForgeDocUpdated, getThreeLOPrompt: getThreeLOPrompt, customBridgeMethods: customBridgeMethods, loadingComponent: loadingComponent, onError: onError, extensionPayload: extensionPayload, onSuccess: onSuccess, onAppError: onAppError, viewportDimensions: viewportDimensions } = props;
    const { cloudId: cloudId, workspaceId: workspaceId } = coreData;
    const [forgeDoc, setForgeDoc] = (0, $eJOHy.useState)(undefined);
    const [error, setError] = (0, $eJOHy.useState)(undefined);
    const [shouldShowRenderer, setShouldShowRenderer] = (0, $eJOHy.useState)(true);
    const isMacro = extension.type === 'xen:macro';
    const injectedComponentsWithKey = (0, $eJOHy.useMemo)(()=>{
        return components ? Object.keys(components).reduce((acc, key)=>{
            const Component = components[key];
            return {
                ...acc,
                // A key is required to ensure React creates new component instances when forgeDoc.key changes.
                // Without this key, React reuses the same component instance across different forgeDoc updates,
                // causing hook call order violations when the component structure changes between renders.
                [key]: (args)=>/*#__PURE__*/ (0, $eJOHy.createElement)(Component, {
                        ...args,
                        key: args.forgeDoc.key
                    })
            };
        }, {}) : {};
    }, [
        components
    ]);
    const wiredComponents = (0, $eJOHy.useMemo)(()=>({
            Avatar: (0, $c05dT.makeUser)({
                client: client
            }),
            AvatarStack: (0, $6siRN.makeUserGroup)({
                client: client
            }),
            UserPicker: (0, $3k3Gm.makeNativeUserPicker)({
                client: client,
                mentionProvider: mentionProvider,
                accountId: accountId,
                ...workspaceId ? {
                    cloudId: 'bitbucket'
                } : {
                    cloudId: cloudId
                },
                productAttributes: workspaceId ? {
                    workspaceIds: [
                        (0, $h5IVr.uncurlyUuid)(workspaceId)
                    ]
                } : undefined,
                productKey: product
            })
        }), [
        accountId,
        client,
        cloudId,
        mentionProvider,
        product,
        workspaceId
    ]);
    const getComponents = (0, $eJOHy.useCallback)((defaults)=>({
            ...defaults,
            ...wiredComponents,
            ...(0, $eGOwo.fg)('forge-ui-kit-editor') ? injectedComponentsWithKey : components
        }), [
        components,
        injectedComponentsWithKey,
        wiredComponents
    ]);
    const handleError = (0, $eJOHy.useCallback)((error)=>{
        if (onError) onError(error.message);
        if (onAppError) onAppError(error.message);
    }, [
        onError,
        onAppError
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (onError && error) onError(error.message);
        if (onAppError && error) onAppError(error.message);
    }, [
        error,
        onError,
        onAppError
    ]);
    const isUiKit1 = !(extension.properties.resource || entryPoint && extension.properties[entryPoint].resource);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)($e95377b2361405ba$var$HeightAnalyticsWrapper, {
        viewportDimensions: isMacro ? viewportDimensions : undefined,
        children: [
            shouldShowRenderer && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ls6Yq.default), {
                isNative: !isUiKit1,
                forgeDoc: forgeDoc,
                extension: extension,
                error: error?.message,
                components: getComponents,
                modalExtension: modalExtension,
                extensionData: extensionData,
                extensionPayload: extensionPayload,
                extensionType: extensionData.type,
                loading: true,
                loadingComponent: loadingComponent,
                onError: handleError,
                client: client,
                onSuccess: onSuccess
            }),
            isUiKit1 ? null : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8iFcj.WebRuntime), {
                accountId: accountId,
                setForgeDoc: (forgeDoc)=>{
                    if (forgeDoc.type !== 'MacroConfig') setForgeDoc(forgeDoc);
                    onForgeDocUpdated?.(forgeDoc);
                },
                setError: setError,
                apolloClient: client,
                components: getThreeLOPrompt,
                contextIds: contextIds,
                extension: extension,
                coreData: coreData,
                extensionData: extensionData,
                extensionPayload: extensionPayload,
                extensionViewData: extensionViewData,
                locale: locale,
                bridge: bridge,
                getContextToken: getContextToken,
                entryPoint: entryPoint,
                customBridgeMethods: customBridgeMethods,
                setShouldShowRenderer: setShouldShowRenderer
            })
        ]
    });
};

});
parcelRegister("ls6Yq", function(module, exports) {
$parcel$export(module.exports, "default", () => $4121b6534991fc61$export$2e2bcd8739ae039);
/* eslint-disable import/dynamic-import-chunkname */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4nehu = parcelRequire("4nehu");

var $eGOwo = parcelRequire("eGOwo");

var $7k9lH = parcelRequire("7k9lH");
var $8vTrP = parcelRequire("8vTrP");
var $4D7K2 = parcelRequire("4D7K2");

var $hmQK4 = parcelRequire("hmQK4");

var $83IbI = parcelRequire("83IbI");
var $kpjEk = parcelRequire("kpjEk");
var $kdiX2 = parcelRequire("kdiX2");

var $luIVK = parcelRequire("luIVK");

var $hx0Wt = parcelRequire("hx0Wt");

var $kNbkK = parcelRequire("kNbkK");

var $j1aXw = parcelRequire("j1aXw");

var $ezmKu = parcelRequire("ezmKu");

var $aoswO = parcelRequire("aoswO");

var $aSByt = parcelRequire("aSByt");

var $j05LD = parcelRequire("j05LD");

var $6FaCM = parcelRequire("6FaCM");
const $4121b6534991fc61$var$getLoadingComponent = (loadingComponent)=>{
    if (loadingComponent) // Wrapping loadingComponent in a valid react element (fragment)
    // ReactNode type is not necessarily a valid React element, unable to change this type as different extension points pass in various loadingComponent types
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: loadingComponent
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $luIVK.Loader), {});
};
const $4121b6534991fc61$var$getAppDomainName = (extension, environment)=>{
    const parsedExtension = extension && extension?.id ? (0, $ezmKu.parseExtensionId)(extension.id) : undefined;
    if (parsedExtension) {
        const iframeSrc = (0, $aoswO.createSrcFromExtension)(parsedExtension.appId, extension, environment, '');
        const iframeUrl = new URL(iframeSrc);
        return iframeUrl.host;
    }
    return;
};

const $4121b6534991fc61$var$RendererNextLatest = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>/* webpackChunkName: "forge-ui-renderer-with-components" */ Promise.resolve((parcelRequire("kNbkK"))).then((module)=>({
            default: module.RendererNextLatest
        })));
const $4121b6534991fc61$var$shouldRenderDeprecationErrorMessage = (appId, isNative, forgeReactMajorVersion, error)=>{
    if (error === (0, $aSByt.SANDBOX_DEPRECATION_ERROR)) return true;
    // Currently supported - UI Kit 2 and @forge/react >=10
    if (isNative && forgeReactMajorVersion) return false;
    // Deprecated - UI Kit 2 @forge/react < 10.
    if (isNative && !forgeReactMajorVersion) return true;
    // Deprecated - UI Kit 1
    if (!(0, $eGOwo.fg)('platform_disable_ui_kit_1')) return false;
    // Non excluded UI Kit 1 apps
    return true;
};
// This extra component exists so errors from the "render" function are caught in the an error boundary
// Also the error boundary requires a suspense fallback
const $4121b6534991fc61$var$RendererNextWithProviders = (props)=>{
    const { extension: extension, forgeDoc: forgeDoc, dispatch: dispatch, locale: locale, client: client, error: error } = props;
    const defaultDispatch = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(async ()=>{}, []);
    const forgeReactMajorVersion = forgeDoc?.forgeReactMajorVersion;
    const environment = (0, $eJOHy.useContext)((0, $83IbI.EnvironmentContext));
    const domainName = $4121b6534991fc61$var$getAppDomainName(extension, environment);
    // true while fetching initial forgeDoc
    if (props.loading && props.isNative && !forgeDoc) return $4121b6534991fc61$var$getLoadingComponent(props.loadingComponent);
    if ($4121b6534991fc61$var$shouldRenderDeprecationErrorMessage(extension.appId, props.isNative, forgeReactMajorVersion, error)) return props.modalExtension ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6FaCM.ForgeExtensionPointModal), {
        modalExtension: props.modalExtension,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aSByt.ForgeDeprecationMessage), {
            client: client,
            extension: extension,
            error: error
        })
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aSByt.ForgeDeprecationMessage), {
        client: client,
        extension: extension,
        error: error
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
        fallback: $4121b6534991fc61$var$getLoadingComponent(props.loadingComponent),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8vTrP.default), {
            dispatch: dispatch,
            extension: extension,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7k9lH.default), {
                dispatch: dispatch,
                extension: extension,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hx0Wt.default), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4D7K2.default), {
                        onError: props.onError,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kdiX2.WidthProvider), {
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
                                locale: locale ?? 'en',
                                defaultLocale: "en",
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hmQK4.PortalProvider), {
                                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kpjEk.RendererContext).Provider, {
                                        value: {
                                            egress: extension?.egress,
                                            properties: extension?.properties,
                                            forgeEnvironment: extension?.environmentType,
                                            forgeReactMajorVersion: forgeReactMajorVersion,
                                            appDomainName: domainName,
                                            extensionType: extension?.type
                                        },
                                        children: props.isNative && forgeReactMajorVersion && forgeReactMajorVersion >= 10 ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j1aXw.default), {
                                            children: /*#__PURE__*/ (0, $gt9Am.jsx)($4121b6534991fc61$var$RenderTrackingWrapper, {
                                                children: /*#__PURE__*/ (0, $gt9Am.jsx)($4121b6534991fc61$var$RendererNextLatest, {
                                                    ...props,
                                                    dispatch: dispatch ?? defaultDispatch
                                                })
                                            })
                                        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kNbkK.RendererNextLegacy), {
                                            ...props,
                                            dispatch: dispatch ?? defaultDispatch
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};
const $4121b6534991fc61$var$RenderTrackingWrapper = ({ children: children })=>{
    if ((0, $eGOwo.fg)('forge-ui-track-ui-kit-renderer-rendered-event')) return /*#__PURE__*/ (0, $gt9Am.jsx)($4121b6534991fc61$var$RenderTrackingWrapperActual, {
        children: children
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
};
const $4121b6534991fc61$var$RenderTrackingWrapperActual = ({ children: children })=>{
    (0, $j05LD.useSendRendererRenderedAnalytics)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
};
var $4121b6534991fc61$export$2e2bcd8739ae039 = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($4121b6534991fc61$var$RendererNextWithProviders, {
        ...props
    });
};

});
parcelRegister("7k9lH", function(module, exports) {
$parcel$export(module.exports, "ComponentError", () => $52ab7455d018b509$export$925737f92c0570a1);
$parcel$export(module.exports, "default", () => $52ab7455d018b509$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
parcelRequire("1B59H");
var $bMVUa = parcelRequire("bMVUa");

var $ehEUE = parcelRequire("ehEUE");

var $6SUez = parcelRequire("6SUez");

var $ftN6c = parcelRequire("ftN6c");


var $dHXR3 = parcelRequire("dHXR3");

var $6yq62 = parcelRequire("6yq62");
class $52ab7455d018b509$export$925737f92c0570a1 extends Error {
    constructor(message, component){
        super(message);
        this.component = component;
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $52ab7455d018b509$export$925737f92c0570a1.prototype);
    }
}
class $52ab7455d018b509$var$ComponentErrorBoundaryWithCreateAnalyticsEvent extends (0, $eJOHy.Component) {
    static{
        this.contextType = (0, $6yq62.MetricsContext);
    }
    componentDidCatch(error, errorInfo) {
        // Filters out reporting errors for components that are not valid e.g. <Buton/>
        if (!(error instanceof $52ab7455d018b509$export$925737f92c0570a1)) throw error;
        const { extension: extension } = this.props;
        const { page: page, environment: environment } = this.context;
        (0, $6SUez.captureAndReportError)({
            error: error,
            errorInfo: errorInfo,
            page: page,
            environment: environment ?? (0, $bMVUa.ProductEnvironment).DEVELOPMENT,
            errorExtensionDetails: extension ? {
                type: extension.type,
                environmentType: extension.environmentType,
                appOwnerAccountId: extension.appOwner?.accountId,
                properties: extension.properties,
                id: extension?.id
            } : undefined
        });
        this.props.createAnalyticsEvent({
            eventType: (0, $d6f34b7bd34f6138$export$12346a674644c156),
            data: {
                action: 'failed',
                actionSubject: 'forge.ui.renderer',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'errorBoundary',
                    errorName: 'componentError',
                    component: error.component
                }
            }
        }).fire((0, $dHXR3.FORGE_UI_ANALYTICS_CHANNEL));
        this.setState({
            thrownError: {
                error: error,
                errorInfo: errorInfo
            }
        });
    }
    render() {
        const { thrownError: thrownError } = this.state;
        if (!thrownError) return this.props.children;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ehEUE.default), {
            error: thrownError.error,
            dispatch: this.props.dispatch
        });
    }
    constructor(...args){
        super(...args), this.state = {
            thrownError: undefined
        };
    }
}
const $52ab7455d018b509$var$ComponentErrorBoundary = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)($52ab7455d018b509$var$ComponentErrorBoundaryWithCreateAnalyticsEvent, {
        ...props,
        createAnalyticsEvent: createAnalyticsEvent
    });
};
var $52ab7455d018b509$export$2e2bcd8739ae039 = $52ab7455d018b509$var$ComponentErrorBoundary;

});
parcelRegister("ehEUE", function(module, exports) {
$parcel$export(module.exports, "default", () => $76c9333a34bc6a61$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ErrorPanelRenderFn", () => $76c9333a34bc6a61$export$1fe699079d0f690f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");

var $luIVK = parcelRequire("luIVK");
function $76c9333a34bc6a61$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

const $76c9333a34bc6a61$var$AKSectionMessage = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3O8m5")));

const $76c9333a34bc6a61$var$SectionMessageAction = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("86YhR")));
const $76c9333a34bc6a61$var$textWrapCss = {
    name: "1089mxj",
    styles: "white-space:pre-wrap"
};
var $76c9333a34bc6a61$var$_ref = {
    name: "1axjbqe",
    styles: "width:100%;ul{padding-left:0;}"
};
const $76c9333a34bc6a61$var$ErrorPanel = ({ error: error, dispatch: dispatch, isReloadPage: isReloadPage })=>{
    const { message: message, errorDetails: errorDetails, errorMessage: errorMessage } = error;
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const intl = (0, $lRq8t.default)();
    const reinitializeApp = async ()=>{
        if (isReloadPage) window.location.reload();
        setIsLoading(true);
        try {
            if (dispatch) await dispatch({
                type: 'render',
                extensionData: {}
            });
        } finally{
            setIsLoading(false);
        }
    };
    if (isLoading) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $luIVK.Loader), null);
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: $76c9333a34bc6a61$var$_ref
    }, /*#__PURE__*/ (0, $1NIU8.jsx)($76c9333a34bc6a61$var$AKSectionMessage, {
        appearance: "error",
        title: message,
        actions: [
            {
                key: 'refresh',
                text: intl.formatMessage(isReloadPage ? $76c9333a34bc6a61$var$messages.reloadPage : $76c9333a34bc6a61$var$messages.refreshApp),
                onClick: reinitializeApp
            }
        ].map(({ text: text, key: key, onClick: onClick })=>/*#__PURE__*/ (0, $1NIU8.jsx)($76c9333a34bc6a61$var$SectionMessageAction, {
                key: key,
                onClick: onClick
            }, text))
    }, errorMessage && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8nu6j.default), {
        xcss: $76c9333a34bc6a61$var$textWrapCss
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $5qJVF.default), {
        as: "p"
    }, errorMessage)), errorDetails && /*#__PURE__*/ (0, $1NIU8.jsx)("pre", {
        css: $76c9333a34bc6a61$var$textWrapCss
    }, errorDetails)));
};
var $76c9333a34bc6a61$export$2e2bcd8739ae039 = $76c9333a34bc6a61$var$ErrorPanel;
const $76c9333a34bc6a61$export$1fe699079d0f690f = ({ forgeDoc: forgeDoc, dispatch: dispatch })=>{
    const { error: error } = forgeDoc.props;
    return /*#__PURE__*/ (0, $1NIU8.jsx)($76c9333a34bc6a61$var$ErrorPanel, {
        key: "error",
        error: error,
        dispatch: dispatch
    });
};
const $76c9333a34bc6a61$var$messages = (0, $7qGN1.defineMessages)({
    refreshApp: {
        id: 'confluence.error.panel.refresh.app',
        defaultMessage: 'Refresh app',
        description: 'This text is displayed on a button that lets the user refresh the app.'
    },
    reloadPage: {
        id: 'confluence.error.panel.reload.page',
        defaultMessage: 'Reload page',
        description: 'This text is displayed on a button that lets the user reload the page'
    }
});

});
parcelRegister("3O8m5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6Hnuo").then(()=>parcelRequire('bSHsR'));

});

parcelRegister("86YhR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6C1sr").then(()=>parcelRequire('fjObP'));

});



parcelRegister("8vTrP", function(module, exports) {
$parcel$export(module.exports, "default", () => $54944709d568a8a7$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
parcelRequire("1B59H");
var $bMVUa = parcelRequire("bMVUa");

var $ehEUE = parcelRequire("ehEUE");

var $6yq62 = parcelRequire("6yq62");

var $6SUez = parcelRequire("6SUez");

var $ftN6c = parcelRequire("ftN6c");


var $dHXR3 = parcelRequire("dHXR3");
class $54944709d568a8a7$export$a707936a384f62f9 extends Error {
    constructor(error){
        super(error.logMessage);
        this.errorTitle = error.errorTitle;
        this.logMessage = error.logMessage;
        this.errorBody = error.errorBody;
    }
}
class $54944709d568a8a7$var$GenericErrorBoundaryWithCreateAnalyticsEvent extends (0, $eJOHy.Component) {
    static{
        this.contextType = (0, $6yq62.MetricsContext);
    }
    componentDidCatch(error, errorInfo) {
        const { page: page, environment: environment } = this.context;
        const { createAnalyticsEvent: createAnalyticsEvent, extension: extension } = this.props;
        (0, $6SUez.captureAndReportError)({
            error: error,
            errorInfo: errorInfo,
            page: page,
            environment: environment || (0, $bMVUa.ProductEnvironment).DEVELOPMENT,
            errorExtensionDetails: extension ? {
                type: extension.type,
                environmentType: extension.environmentType,
                appOwnerAccountId: extension.appOwner?.accountId,
                properties: extension.properties,
                id: extension?.id
            } : undefined
        });
        createAnalyticsEvent({
            eventType: (0, $d6f34b7bd34f6138$export$12346a674644c156),
            data: {
                action: 'failed',
                actionSubject: 'forge.ui.renderer',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'errorBoundary',
                    errorName: error.name
                }
            }
        }).fire((0, $dHXR3.FORGE_UI_ANALYTICS_CHANNEL));
        if (error instanceof $54944709d568a8a7$export$a707936a384f62f9) this.setState({
            thrownError: {
                error: {
                    name: 'error',
                    message: error.errorTitle,
                    errorMessage: error.errorBody
                },
                errorInfo: errorInfo
            }
        });
        else this.setState({
            thrownError: {
                error: error,
                errorInfo: errorInfo
            }
        });
    }
    render() {
        const { thrownError: thrownError } = this.state;
        if (!thrownError) return this.props.children;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ehEUE.default), {
            error: thrownError.error,
            dispatch: this.props.dispatch
        });
    }
    constructor(...args){
        super(...args), this.state = {
            thrownError: undefined
        };
    }
}
const $54944709d568a8a7$var$GenericErrorBoundary = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)($54944709d568a8a7$var$GenericErrorBoundaryWithCreateAnalyticsEvent, {
        ...props,
        createAnalyticsEvent: createAnalyticsEvent
    });
};
var $54944709d568a8a7$export$2e2bcd8739ae039 = $54944709d568a8a7$var$GenericErrorBoundary;

});

parcelRegister("4D7K2", function(module, exports) {
$parcel$export(module.exports, "default", () => $d25e369e234bf1fe$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
class $d25e369e234bf1fe$var$IntegrationErrorHandlerBoundary extends (0, $eJOHy.Component) {
    componentDidCatch(error) {
        if (this.props.onError) this.props.onError(error);
        throw error;
    }
    render() {
        return this.props.children;
    }
}
var $d25e369e234bf1fe$export$2e2bcd8739ae039 = $d25e369e234bf1fe$var$IntegrationErrorHandlerBoundary;

});

parcelRegister("hmQK4", function(module, exports) {
$parcel$export(module.exports, "PortalConsumer", () => $5ac71cfea9ac5fc9$export$7d41556b227a95c9);
$parcel$export(module.exports, "PortalProvider", () => $5ac71cfea9ac5fc9$export$6df4068a17305b10);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $67YQP = parcelRequire("67YQP");

var $IW7jS = parcelRequire("IW7jS");
const { Provider: $5ac71cfea9ac5fc9$var$Provider, Consumer: $5ac71cfea9ac5fc9$export$7d41556b227a95c9 } = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(undefined);
const $5ac71cfea9ac5fc9$export$6df4068a17305b10 = ({ children: children })=>{
    const [portal, setPortal] = (0, $eJOHy.useState)();
    const [isPortalReady, setIsPortalReady] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (portal !== null) setIsPortalReady(true);
    }, [
        portal
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            isPortalReady && /*#__PURE__*/ (0, $gt9Am.jsx)($5ac71cfea9ac5fc9$var$Provider, {
                value: portal,
                children: children
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $67YQP.default), {
                zIndex: (0, $IW7jS.layers).modal() + 1,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    "data-testid": "forge-ui-portal",
                    ref: setPortal
                })
            })
        ]
    });
};

});

parcelRegister("kdiX2", function(module, exports) {
$parcel$export(module.exports, "WidthContext", () => $c7969a2921a89709$export$27e39f636459b9f);
$parcel$export(module.exports, "WidthProvider", () => $c7969a2921a89709$export$7921e18173e8c666);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $gMRLG = parcelRequire("gMRLG");
const $c7969a2921a89709$export$27e39f636459b9f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(0);
const $c7969a2921a89709$var$SCROLLBAR_WIDTH = 30;
const $c7969a2921a89709$export$7921e18173e8c666 = ({ children: children })=>{
    const [width, setWidth] = (0, $eJOHy.useState)(0);
    const handleWidthChange = (newWidth)=>{
        // Ignore changes that are less than SCROLLBAR_WIDTH, otherwise it can cause infinite re-scaling
        if (!newWidth || Math.abs(width - newWidth) < $c7969a2921a89709$var$SCROLLBAR_WIDTH) return;
        setWidth(newWidth);
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gMRLG.WidthObserver), {
                setWidth: handleWidthChange
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)($c7969a2921a89709$export$27e39f636459b9f.Provider, {
                value: width,
                children: children
            })
        ]
    });
};
const $c7969a2921a89709$export$5d8538aa831b6ebb = $c7969a2921a89709$export$27e39f636459b9f.Consumer;

});
parcelRegister("gMRLG", function(module, exports) {
$parcel$export(module.exports, "WidthObserver", () => $fc07c79ce5b93db8$export$b2ad68b9bc407b80);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ghv3t = parcelRequire("ghv3t");
const $fc07c79ce5b93db8$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo((props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ghv3t.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $fc07c79ce5b93db8$export$2e2bcd8739ae039 = $fc07c79ce5b93db8$export$b2ad68b9bc407b80;

});
parcelRegister("ghv3t", function(module, exports) {
$parcel$export(module.exports, "WidthDetectorObserver", () => $8fd70c84fe96dcaa$export$ff983d2a2b6112ea);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $fecNP = parcelRequire("fecNP");
const $8fd70c84fe96dcaa$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $fecNP.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});

});
parcelRegister("fecNP", function(module, exports) {
$parcel$export(module.exports, "useInView", () => $838e57da8fce74d2$export$2f62ee6831462844);

var $eJOHy = parcelRequire("eJOHy");
function $838e57da8fce74d2$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
	 * Unsubscribe IntersectionObserver before unmounting a component.
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}

});




parcelRegister("hx0Wt", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab073aaa79f6597c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ehEUE = parcelRequire("ehEUE");
class $ab073aaa79f6597c$export$51ac3312edef55d7 extends Error {
    get issue() {
        return this._issue;
    }
    get property() {
        return this._property;
    }
    set property(value) {
        this._property = value;
    }
    constructor({ issue: issue, message: message }){
        super(message);
        this._issue = issue;
        this._property = '';
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $ab073aaa79f6597c$export$51ac3312edef55d7.prototype);
    }
}
class $ab073aaa79f6597c$var$StyleErrorBoundary extends (0, $eJOHy.Component) {
    componentDidCatch(error) {
        if (!(error instanceof $ab073aaa79f6597c$export$51ac3312edef55d7)) throw error;
        this.setState({
            error: error
        });
    }
    render() {
        const { error: error } = this.state;
        if (!error) return this.props.children;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ehEUE.default), {
            error: {
                name: 'style-error',
                message: `Error was thrown on style property: ${error.property}`,
                errorMessage: `${error.issue}\n${error.message}`
            },
            isReloadPage: true
        });
    }
    constructor(...args){
        super(...args), this.state = {
            error: null
        };
    }
}
var $ab073aaa79f6597c$export$2e2bcd8739ae039 = $ab073aaa79f6597c$var$StyleErrorBoundary;

});

parcelRegister("kNbkK", function(module, exports) {
$parcel$export(module.exports, "RendererNextLatest", () => $ec6089d09e90d400$export$593275278a807c58);
$parcel$export(module.exports, "RendererNextLegacy", () => $ec6089d09e90d400$export$6d81a7348fccd2a2);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $9REJS = parcelRequire("9REJS");

var $cagBP = parcelRequire("cagBP");

var $1QT2I = parcelRequire("1QT2I");

var $4ZfiI = parcelRequire("4ZfiI");

var $lfx7V = parcelRequire("lfx7V");

var $iCkyS = parcelRequire("iCkyS");

var $7k9lH = parcelRequire("7k9lH");

var $pec4g = parcelRequire("pec4g");
const $ec6089d09e90d400$export$a200b9d079640a1 = new Set([
    'Badge',
    'Box',
    'Button',
    'ButtonGroup',
    'Calendar',
    'Checkbox',
    'CheckboxGroup',
    'Code',
    'CodeBlock',
    'Comment',
    'DatePicker',
    'DynamicTable',
    'EmptyState',
    'ErrorMessage',
    'Flex',
    'FileCard',
    'Form',
    'FormFooter',
    'FormHeader',
    'FormSection',
    'Grid',
    'Heading',
    'HelperMessage',
    'Icon',
    'Inline',
    'InlineEdit',
    'Label',
    'LinkButton',
    'List',
    'ListItem',
    'LoadingButton',
    'Lozenge',
    'Modal',
    'ModalBody',
    'ModalFooter',
    'ModalHeader',
    'ModalTitle',
    'ModalTransition',
    'Popup',
    'Pressable',
    'ProgressBar',
    'ProgressTracker',
    'Radio',
    'RadioGroup',
    'Range',
    'RequiredAsterisk',
    'SectionMessage',
    'SectionMessageAction',
    'Select',
    'Spinner',
    'Stack',
    'Tab',
    'TabList',
    'TabPanel',
    'Tabs',
    'Tag',
    'TagGroup',
    'TextArea',
    'Textfield',
    'TimePicker',
    'Toggle',
    'Tooltip',
    'ValidMessage',
    'AdfRenderer',
    'Image',
    'Link',
    'Text',
    'Strong',
    'BarChart',
    'StackBarChart',
    'HorizontalStackBarChart',
    'HorizontalBarChart',
    'LineChart',
    'PieChart',
    'DonutChart',
    'String',
    'Em',
    'Strike',
    'Root',
    'Fragment',
    'ThreeLOPrompt',
    'User',
    'UserGroup',
    'UserPicker',
    'Frame',
    'ContentWrapper',
    'ValidationMessage',
    'ButtonSet',
    'DateLozenge',
    'ErrorPanel',
    'FormCondition',
    'InlineDialog',
    'ModalDialog',
    'StatusLozenge',
    'Table',
    'TextField',
    'View',
    'FilePicker'
]);
const $ec6089d09e90d400$var$rendererNextComponents = {
    ThreeLOPrompt: (0, $iCkyS.ThreeLOPromptRenderFn)
};
// This was extracted from RendererNext Component due to UnknownComponent Error being
// incompatible with running in a server-side context.
const $ec6089d09e90d400$var$customRenderErrorFn = (forgeDocType)=>{
    // Buckets errors into two kinds, ComponentError - component errors we want to report on e.g. <Button/> vs ones we don't e.g. <Buton/> which will only show up in the users console
    if ($ec6089d09e90d400$export$a200b9d079640a1.has(forgeDocType)) throw new (0, $7k9lH.ComponentError)(`Error rendering app - component ${forgeDocType}.`, forgeDocType);
    else throw new Error(`Error rendering app - encountered unknown component ${forgeDocType}.`);
};
const $ec6089d09e90d400$export$593275278a807c58 = (props)=>{
    const uiKitComponents = Object.keys((0, $4ZfiI.importMapMemo)).reduce((acc, key)=>{
        const Component = (0, $4ZfiI.importMapMemo)[key];
        return {
            ...acc,
            [key]: (args)=>/*#__PURE__*/ (0, $eJOHy.createElement)(Component, {
                    ...args,
                    key: args.forgeDoc.key
                })
        };
    }, {});
    const uiKitChartsComponents = Object.keys((0, $lfx7V.importMapChartsMemo)).reduce((acc, key)=>{
        const Component = (0, $lfx7V.importMapChartsMemo)[key];
        return {
            ...acc,
            [key]: (args)=>/*#__PURE__*/ (0, $eJOHy.createElement)(Component, {
                    ...args,
                    key: args.forgeDoc.key
                })
        };
    }, {});
    const components = {
        ...uiKitComponents,
        ...uiKitChartsComponents,
        String: (0, $9REJS.uiKit1Components).String,
        Em: (0, $9REJS.uiKit1Components).Em,
        Strong: (0, $pec4g.Strong),
        Strike: (0, $9REJS.uiKit1Components).Strike,
        Root: $cagBP.Root,
        Fragment: $cagBP.Fragment
    };
    const combinedComponents = {
        ...components,
        ...$ec6089d09e90d400$var$rendererNextComponents
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1QT2I.RendererNext), {
        ...props,
        components: props.components ? props.components(combinedComponents) : combinedComponents,
        customRenderErrorFn: $ec6089d09e90d400$var$customRenderErrorFn
    });
};
const $ec6089d09e90d400$export$6d81a7348fccd2a2 = (props)=>{
    const combinedComponents = {
        ...(0, $9REJS.uiKit1Components),
        ...$ec6089d09e90d400$var$rendererNextComponents
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1QT2I.RendererNext), {
        ...props,
        components: props.components ? props.components(combinedComponents) : combinedComponents,
        customRenderErrorFn: $ec6089d09e90d400$var$customRenderErrorFn
    });
};

});
parcelRegister("9REJS", function(module, exports) {
$parcel$export(module.exports, "uiKit1Components", () => $fbb4592b1c6166ff$export$65fce8c2f2babb3e);

var $eJOHy = parcelRequire("eJOHy");

var $bAiL9 = parcelRequire("bAiL9");

var $3fQFh = parcelRequire("3fQFh");

var $eUUeL = parcelRequire("eUUeL");

var $hkc7c = parcelRequire("hkc7c");

var $fAt8s = parcelRequire("fAt8s");

var $1DNCg = parcelRequire("1DNCg");

var $gD6OG = parcelRequire("gD6OG");

var $ehEUE = parcelRequire("ehEUE");

var $i3v3M = parcelRequire("i3v3M");

var $2SqlQ = parcelRequire("2SqlQ");

var $ljqGl = parcelRequire("ljqGl");

var $9HjWS = parcelRequire("9HjWS");

var $fR0ol = parcelRequire("fR0ol");

var $eIxIr = parcelRequire("eIxIr");

var $fjtyX = parcelRequire("fjtyX");

var $24ML5 = parcelRequire("24ML5");

var $gmTz7 = parcelRequire("gmTz7");

var $k3iHm = parcelRequire("k3iHm");

var $dYUjm = parcelRequire("dYUjm");

var $axYyc = parcelRequire("axYyc");

var $8eNFp = parcelRequire("8eNFp");
var $flRHQ = parcelRequire("flRHQ");

var $hadI0 = parcelRequire("hadI0");

var $8DDbc = parcelRequire("8DDbc");

var $bMMfu = parcelRequire("bMMfu");

var $cUeS9 = parcelRequire("cUeS9");

var $htPkC = parcelRequire("htPkC");

var $lEA2o = parcelRequire("lEA2o");

var $nQCZy = parcelRequire("nQCZy");

var $70M97 = parcelRequire("70M97");

var $4Puwt = parcelRequire("4Puwt");
const $fbb4592b1c6166ff$export$65fce8c2f2babb3e = {
    Badge: (0, $4Puwt.upgradeComponent)((0, $bAiL9.BadgeFn)),
    Button: (args)=>/*#__PURE__*/ (0, $eJOHy.createElement)((0, $3fQFh.Button), {
            ...args,
            key: args.forgeDoc.key
        }),
    ButtonSet: (0, $4Puwt.upgradeComponent)((0, $eUUeL.ButtonSetFn)),
    CheckboxGroup: (0, $4Puwt.upgradeComponent)((0, $hkc7c.CheckboxGroupFn)),
    Code: (0, $4Puwt.upgradeComponent)((0, $fAt8s.CodeFn)),
    DateLozenge: (0, $4Puwt.upgradeComponent)((0, $1DNCg.DateLozengeFn)),
    DatePicker: (0, $4Puwt.upgradeComponent)((0, $gD6OG.DatePickerFn)),
    Em: (0, $4Puwt.upgradeComponent)((0, $70M97.EmFn)),
    ErrorPanel: (0, $ehEUE.ErrorPanelRenderFn),
    Form: (args)=>/*#__PURE__*/ (0, $eJOHy.createElement)((0, $i3v3M.Form), {
            ...args,
            key: args.forgeDoc.key
        }),
    FormCondition: (0, $4Puwt.upgradeComponent)((0, $2SqlQ.FormConditionFn)),
    Heading: (0, $4Puwt.upgradeComponent)((0, $nQCZy.HeadingFn)),
    Image: (0, $4Puwt.upgradeComponent)((0, $ljqGl.ImageFn)),
    InlineDialog: (args)=>/*#__PURE__*/ (0, $eJOHy.createElement)((0, $9HjWS.InlineDialog), {
            ...args,
            key: args.forgeDoc.key
        }),
    Link: (0, $4Puwt.upgradeComponent)((0, $70M97.LinkFn)),
    ModalDialog: (args)=>/*#__PURE__*/ (0, $eJOHy.createElement)((0, $fR0ol.ModalDialog), {
            ...args,
            key: args.forgeDoc.key
        }),
    RadioGroup: (0, $4Puwt.upgradeComponent)((0, $eIxIr.RadioGroupFn)),
    Range: (0, $4Puwt.upgradeComponent)((0, $fjtyX.RangeFn)),
    SectionMessage: (0, $4Puwt.upgradeComponent)((0, $24ML5.SectionMessageFn)),
    Select: (0, $4Puwt.upgradeComponent)((0, $gmTz7.SelectFn)),
    StatusLozenge: (0, $4Puwt.upgradeComponent)((0, $k3iHm.StatusLozengeFn)),
    Strike: (0, $4Puwt.upgradeComponent)((0, $70M97.StrikeFn)),
    String: (0, $4Puwt.upgradeComponent)((0, $70M97.StringFn)),
    Strong: (0, $4Puwt.upgradeComponent)((0, $70M97.StrongFn)),
    Table: (0, $4Puwt.upgradeComponent)((0, $axYyc.TableFn)),
    Tabs: (0, $4Puwt.upgradeComponent)((0, $dYUjm.TabsFn)),
    Tag: (0, $4Puwt.upgradeComponent)((0, $8eNFp.TagFn)),
    TagGroup: (0, $4Puwt.upgradeComponent)((0, $flRHQ.TagGroupFn)),
    Text: (0, $4Puwt.upgradeComponent)((0, $hadI0.TextFn)),
    TextArea: (0, $4Puwt.upgradeComponent)((0, $8DDbc.TextAreaFn)),
    TextField: (0, $4Puwt.upgradeComponent)((0, $bMMfu.TextFieldFn)),
    Toggle: (0, $4Puwt.upgradeComponent)((0, $cUeS9.ToggleFn)),
    Tooltip: (0, $4Puwt.upgradeComponent)((0, $htPkC.TooltipFn)),
    View: (0, $4Puwt.upgradeComponent)((0, $lEA2o.ViewFn))
};

});
parcelRegister("bAiL9", function(module, exports) {
$parcel$export(module.exports, "BadgeFn", () => $4241ad9f2200c0b3$export$c07d87ab1594bff4);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

const $4241ad9f2200c0b3$var$AKBadge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("dW7Vf")));
function $4241ad9f2200c0b3$var$Badge({ appearance: appearance = 'default', text: text }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)($4241ad9f2200c0b3$var$AKBadge, {
        appearance: appearance,
        children: text
    });
}
var $4241ad9f2200c0b3$export$2e2bcd8739ae039 = $4241ad9f2200c0b3$var$Badge;
function $4241ad9f2200c0b3$export$c07d87ab1594bff4({ props: props }) {
    const { appearance: appearance, text: text } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)($4241ad9f2200c0b3$var$Badge, {
        appearance: appearance,
        text: text
    });
}

});
parcelRegister("dW7Vf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("btvHm").then(()=>parcelRequire('hgsJA'));

});


parcelRegister("3fQFh", function(module, exports) {
$parcel$export(module.exports, "AkButton", () => $9183044c2b69de95$export$8471a7693ebd6f54);
$parcel$export(module.exports, "useButton", () => $9183044c2b69de95$export$ea18c227d4417cc3);
$parcel$export(module.exports, "Button", () => $9183044c2b69de95$export$353f5b6fc5456de1);
$parcel$export(module.exports, "useActionButtons", () => $9183044c2b69de95$export$fdac0c774aedd7f7);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $1p0Y0 = parcelRequire("1p0Y0");

var $kdiX2 = parcelRequire("kdiX2");

var $btUKm = parcelRequire("btUKm");

const $9183044c2b69de95$export$8471a7693ebd6f54 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("bdwGa")));
function $9183044c2b69de95$export$ea18c227d4417cc3({ forgeDoc: forgeDoc, dispatch: dispatch }) {
    const { props: { appearance: appearance = 'default', text: text, disabled: disabled, onClick: onClick, icon: icon, iconPosition: iconPosition = 'before' } = {} } = forgeDoc;
    const [loading, setLoading] = (0, $eJOHy.useState)(false);
    const handleClick = async ()=>{
        setLoading(true);
        try {
            await dispatch({
                type: 'event',
                handler: onClick,
                args: [],
                extensionData: {}
            });
        } finally{
            setLoading(false);
        }
    };
    let iconDom;
    if (icon) iconDom = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $btUKm.default), {
        size: "medium",
        glyph: icon
    });
    const iconBefore = iconPosition === 'before' ? iconDom : undefined;
    const iconAfter = iconPosition === 'after' ? iconDom : undefined;
    const width = (0, $eJOHy.useContext)((0, $kdiX2.WidthContext));
    let shouldFitContainer = (0, $1p0Y0.buttonShouldFitContainer)(width);
    return {
        akButtonProps: {
            shouldFitContainer: shouldFitContainer,
            iconBefore: iconBefore,
            iconAfter: iconAfter,
            isLoading: loading,
            isDisabled: disabled,
            appearance: appearance,
            onClick: handleClick,
            children: text
        }
    };
}
function $9183044c2b69de95$export$353f5b6fc5456de1(props) {
    const { akButtonProps: akButtonProps } = $9183044c2b69de95$export$ea18c227d4417cc3(props);
    const { shouldFitContainer: shouldFitContainer, iconBefore: iconBefore, iconAfter: iconAfter, isLoading: isLoading, isDisabled: isDisabled, appearance: appearance, onClick: onClick, children: children } = akButtonProps;
    return /*#__PURE__*/ (0, $gt9Am.jsx)($9183044c2b69de95$export$8471a7693ebd6f54, {
        shouldFitContainer: shouldFitContainer,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isLoading: isLoading,
        isDisabled: isDisabled,
        appearance: appearance,
        onClick: onClick,
        children: children
    });
}
function $9183044c2b69de95$export$fdac0c774aedd7f7({ forgeDoc: forgeDoc, dispatch: dispatch }) {
    const [loading, setLoading] = (0, $eJOHy.useState)(forgeDoc.map(()=>false));
    const width = (0, $eJOHy.useContext)((0, $kdiX2.WidthContext));
    const shouldFitContainer = (0, $1p0Y0.buttonShouldFitContainer)(width);
    const actionButtons = forgeDoc.map((actionButtonForgeDoc, index)=>{
        const { props: { appearance: appearance = 'subtle', text: text, disabled: disabled, onClick: onClick, icon: icon, iconPosition: iconPosition = 'before' } = {} } = actionButtonForgeDoc;
        const handleClick = async ()=>{
            setLoading(loading.map((l, i)=>{
                if (i === index) return true;
                return l;
            }));
            try {
                await dispatch({
                    type: 'event',
                    handler: onClick,
                    args: [],
                    extensionData: {}
                });
            } finally{
                setLoading(loading.map((l, i)=>{
                    if (i === index) return false;
                    return l;
                }));
            }
        };
        let iconDom;
        if (icon) iconDom = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $btUKm.default), {
            size: "medium",
            glyph: icon
        });
        const iconBefore = iconPosition === 'before' ? iconDom : undefined;
        const iconAfter = iconPosition === 'after' ? iconDom : undefined;
        return {
            shouldFitContainer: shouldFitContainer,
            iconBefore: iconBefore,
            iconAfter: iconAfter,
            isLoading: loading[index],
            isDisabled: disabled,
            appearance: appearance,
            onClick: handleClick,
            children: text
        };
    });
    return {
        akActionButtonProps: actionButtons
    };
}

});
parcelRegister("1p0Y0", function(module, exports) {
$parcel$export(module.exports, "buttonShouldFitContainer", () => $ac34178e4f5bb3cd$export$37ca8ef0f54b556e);
const $ac34178e4f5bb3cd$var$FULL_WIDTH_BUTTONS_BREAKPOINT_PX = 360;
const $ac34178e4f5bb3cd$export$37ca8ef0f54b556e = (width)=>width > 0 && width < $ac34178e4f5bb3cd$var$FULL_WIDTH_BUTTONS_BREAKPOINT_PX;

});

parcelRegister("btUKm", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e3723e260cdbc13$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $bHgsi = parcelRequire("bHgsi");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");
const $5e3723e260cdbc13$var$Icon = ({ size: size = 'medium', glyph: glyph })=>{
    const Component = (0, $bHgsi.IconPaths)[glyph];
    const intl = (0, $lRq8t.default)();
    if (!Component) return null;
     // do nothing
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
        fallback: null,
        children: // @ts-ignore Jira only - TS2322: Type '{ label: string; size: "small" | "medium" | "large"; }' is not assignable to type 'IntrinsicAttributes'.
        /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
            label: intl.formatMessage($5e3723e260cdbc13$var$messages.icon),
            size: size
        })
    });
};
var $5e3723e260cdbc13$export$2e2bcd8739ae039 = $5e3723e260cdbc13$var$Icon;
function $5e3723e260cdbc13$export$af44fe23e87e9bd7({ props: props }) {
    const { glyph: glyph, size: size } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)($5e3723e260cdbc13$var$Icon, {
        glyph: glyph,
        size: size
    });
}
const $5e3723e260cdbc13$var$messages = (0, $7qGN1.defineMessages)({
    icon: {
        id: 'confluence.icon.label',
        defaultMessage: 'Icon',
        description: 'A label identifying this component as an icon.'
    }
});

});
parcelRegister("bHgsi", function(module, exports) {
$parcel$export(module.exports, "IconPaths", () => $69012a1bfc9de736$export$6409a24d2c5a7539);
// *** GENERATED FILE - DO NOT EDIT ***
// WARNING: import needs to be statically analysable to not be problematic [at runtime]

var $eJOHy = parcelRequire("eJOHy");





































































































































































































































































































































































const $69012a1bfc9de736$export$6409a24d2c5a7539 = {
    activity: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("axsCd"))),
    add: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("9Fm1W"))),
    'add-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lNFQy"))),
    'add-item': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hRePn"))),
    addon: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("9PqOo"))),
    'app-access': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4wmSQ"))),
    'app-switcher': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7gWbN"))),
    archive: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5mXw6"))),
    'arrow-down': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jUg0H"))),
    'arrow-down-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hgwWm"))),
    'arrow-left': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("h0mAD")))),
    'arrow-left-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3WBvT"))),
    'arrow-right': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fNCbK"))),
    'arrow-right-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("qavM1"))),
    'arrow-up': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hHXHT"))),
    'arrow-up-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aAtO9"))),
    attachment: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5fhJg"))),
    audio: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bsi2e"))),
    'audio-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hafIS"))),
    backlog: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("iZiYj"))),
    billing: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("izYoX"))),
    'billing-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4wQqY"))),
    'bitbucket-branches': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1YNKq"))),
    'bitbucket-builds': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4mV01"))),
    'bitbucket-clone': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4URYH"))),
    'bitbucket-commits': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7qTXR"))),
    'bitbucket-compare': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fm6q0"))),
    'bitbucket-forks': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6bk5T"))),
    'bitbucket-output': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5kHcX"))),
    'bitbucket-pipelines': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("11xtF"))),
    'bitbucket-pullrequests': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("GIowT"))),
    'bitbucket-repos': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eh8xN"))),
    'bitbucket-snippets': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6xXUa"))),
    'bitbucket-source': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eQkYx"))),
    board: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("ibFjc"))),
    book: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1pP3X"))),
    'bullet-list': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fLWi7"))),
    calendar: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("76JV8")))),
    'calendar-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("96Apc"))),
    camera: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dDfhe"))),
    'camera-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("zbjhX"))),
    'camera-rotate': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dprUg"))),
    'camera-take-picture': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("c6c6w"))),
    canvas: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("g12PG"))),
    check: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("2kdvq")))),
    'check-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("jhvt8")))),
    'check-circle-outline': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dmBba"))),
    checkbox: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aMG9i"))),
    'checkbox-indeterminate': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4leDg"))),
    'chevron-down': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("1UIWS")))),
    'chevron-down-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kmdPb"))),
    'chevron-left': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bKbFx"))),
    'chevron-left-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3e3gt"))),
    'chevron-left-large': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("k9ooi")))),
    'chevron-right': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("fRBiY")))),
    'chevron-right-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("kYD0I")))),
    'chevron-right-large': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("czcci")))),
    'chevron-up': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cLNFy"))),
    'chevron-up-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gWjQ0"))),
    'child-issues': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6HxVA"))),
    code: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jaaKd"))),
    comment: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("e50Bu"))),
    component: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bpWPz"))),
    copy: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("hZKKB")))),
    creditcard: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("h9t5B"))),
    'creditcard-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("646d9")))),
    cross: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("laG04")))),
    'cross-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("jZF1f")))),
    dashboard: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("a2dzl"))),
    decision: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lUNrH"))),
    department: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("iJZrp"))),
    'detail-view': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eAUE9"))),
    discover: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("50tGD"))),
    'discover-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("ccTZm"))),
    document: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("05bpU"))),
    'document-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1zWcV"))),
    documents: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2Lfta"))),
    download: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7XZaJ"))),
    'drag-handler': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bqrYs"))),
    dropbox: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fDz61"))),
    edit: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gIq8f"))),
    'edit-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2h2se"))),
    'editor-add': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("bKq60")))),
    'editor-addon': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4UPtj"))),
    'editor-advanced': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eg9mT"))),
    'editor-align-center': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("197JG"))),
    'editor-align-image-center': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8qapV"))),
    'editor-align-image-left': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dEt0o"))),
    'editor-align-image-right': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2h37v"))),
    'editor-align-left': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("a8jAd"))),
    'editor-align-right': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2pHPx"))),
    'editor-attachment': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bBmjU"))),
    'editor-background-color': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("Cs8TW"))),
    'editor-bold': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("b4zTI")))),
    'editor-bullet-list': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("hhyv8")))),
    'editor-close': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("6OLN4")))),
    'editor-code': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("Uzddr")))),
    'editor-collapse': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1Nb7L"))),
    'editor-date': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("cyebN")))),
    'editor-decision': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("fvh9f")))),
    'editor-divider': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gO5rE"))),
    'editor-done': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("37Ug4")))),
    'editor-edit': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3N9KL"))),
    'editor-emoji': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("gF0HQ")))),
    'editor-error': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kAbU2"))),
    'editor-expand': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("0Yz5o"))),
    'editor-feedback': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8HRPj"))),
    'editor-file': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("l3xZw"))),
    'editor-file-preview': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3sc9L"))),
    'editor-help': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bWcHV"))),
    'editor-hint': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gAhAq"))),
    'editor-horizontal-rule': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("k5n7B")))),
    'editor-image': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("3h9bV")))),
    'editor-image-border': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("57zOb"))),
    'editor-image-resize': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4k7ht"))),
    'editor-indent': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("eiUei")))),
    'editor-info': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("eAsyt")))),
    'editor-italic': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("lasBY")))),
    'editor-layout-single': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8EsJw"))),
    'editor-layout-three-equal': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lnadk"))),
    'editor-layout-three-with-sidebars': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3DkPn"))),
    'editor-layout-two-equal': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("kHKYy")))),
    'editor-layout-two-left-sidebar': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gLdes"))),
    'editor-layout-two-right-sidebar': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3iI0u"))),
    'editor-link': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("frcEo")))),
    'editor-media-center': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cwgo1"))),
    'editor-media-full-width': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("clXui"))),
    'editor-media-wide': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3Ih6p"))),
    'editor-media-wrap-left': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gPpf9"))),
    'editor-media-wrap-right': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fyq9U"))),
    'editor-mention': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("6cJsV")))),
    'editor-more': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("fES0B")))),
    'editor-note': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("94404")))),
    'editor-number-list': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("hM9Fu")))),
    'editor-open': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("llG54"))),
    'editor-outdent': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("8hxcF")))),
    'editor-panel': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("b676u"))),
    'editor-photo': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("coNMY"))),
    'editor-quote': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("95phr"))),
    'editor-recent': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("a3Vzm"))),
    'editor-redo': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8TXBT"))),
    'editor-remove': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("f7oSr")))),
    'editor-remove-emoji': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lE8hi"))),
    'editor-search': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("dPkHp")))),
    'editor-settings': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("ibxUD"))),
    'editor-strikethrough': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("qO03x"))),
    'editor-success': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("6BeTe")))),
    'editor-table': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("XRjx0")))),
    'editor-table-display-options': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aE1uf"))),
    'editor-task': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("a9Y5z")))),
    'editor-text-color': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3ob62"))),
    'editor-text-style': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("exniU")))),
    'editor-underline': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hxvM5"))),
    'editor-undo': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2ZVB1"))),
    'editor-unlink': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("bnsEu")))),
    'editor-warning': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("k89QS"))),
    email: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("4ZN93")))),
    emoji: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("acJe8"))),
    'emoji-add': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hOysi"))),
    'emoji-activity': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lyZCv"))),
    'emoji-atlassian': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gFyU6"))),
    'emoji-custom': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jOedN"))),
    'emoji-emoji': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("d88Xn"))),
    'emoji-flags': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eeAFc"))),
    'emoji-food': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8EbyJ"))),
    'emoji-frequent': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("pgD1c"))),
    'emoji-keyboard': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2xtKF"))),
    'emoji-nature': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fADd3"))),
    'emoji-objects': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bpyTT"))),
    'emoji-people': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("f3J6m"))),
    'emoji-productivity': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4x7zS"))),
    'emoji-symbols': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("j9jS8"))),
    'emoji-travel': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("CcgmX"))),
    error: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("duLdC")))),
    export: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7ibBx"))),
    feedback: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2fuGi"))),
    file: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1DK2N"))),
    filter: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("46rU4"))),
    'flag-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kpHER"))),
    folder: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7XKr3"))),
    'folder-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lnYob"))),
    followers: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gr7DB"))),
    following: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cPNom"))),
    googledrive: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("9cdOY"))),
    'graph-bar': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1jMXj"))),
    'graph-line': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jXtYG"))),
    gsuite: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aIPLP"))),
    highlights: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("k6gch"))),
    'hipchat-audio-only': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5WsrD"))),
    'hipchat-chevron-double-down': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eV9E5"))),
    'hipchat-chevron-double-up': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("90eO2"))),
    'hipchat-chevron-down': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("lD65a")))),
    'hipchat-chevron-up': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("bIwqN")))),
    'hipchat-dial-out': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bcLSQ"))),
    'hipchat-lobby': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7PZNM"))),
    'hipchat-media-attachment-count': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cPCOJ"))),
    'hipchat-outgoing-sound': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3Uvbk"))),
    'hipchat-sd-video': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5AsjY"))),
    home: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("g66wC"))),
    'home-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bIlY9"))),
    image: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3eKdM"))),
    'image-border': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("k6iyf"))),
    'image-resize': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fX1Pk"))),
    info: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("cDDv2")))),
    'invite-team': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gQDdL"))),
    issue: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("88tEs"))),
    'issue-raise': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cyQXM"))),
    issues: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6ZIkL"))),
    'jira-capture': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fH8G5"))),
    'jira-failed-build-status': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cn8Wc"))),
    'jira-labs': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1wbDv"))),
    'jira-test-session': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("j0QvP"))),
    label: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lnXk0"))),
    lightbulb: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eAmma"))),
    'lightbulb-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("i2Uod")))),
    like: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("e0B6y"))),
    link: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("a2o1i")))),
    'link-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jt0vj"))),
    list: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1Royr"))),
    location: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hpfLU"))),
    lock: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("djnBL"))),
    'lock-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("djJr9"))),
    'lock-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("kKPzl")))),
    marketplace: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jheAx"))),
    'media-services-actual-size': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("etSq4"))),
    'media-services-add-comment': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4Kxo1"))),
    'media-services-annotate': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eiXxm"))),
    'media-services-arrow': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("a6D1j"))),
    'media-services-audio': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gBCxG"))),
    'media-services-blur': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eAstp"))),
    'media-services-brush': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5ZdZX"))),
    'media-services-button-option': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("ewvjF"))),
    'media-services-code': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1SbDw"))),
    'media-services-document': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6mo8x"))),
    'media-services-filter': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("Yf1Va"))),
    'media-services-fit-to-page': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lRyIz"))),
    'media-services-full-screen': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8xKDw"))),
    'media-services-grid': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3UlY1"))),
    'media-services-image': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bHFww"))),
    'media-services-line': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8PTHr"))),
    'media-services-line-thickness': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("daEBz"))),
    'media-services-no-image': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jJw6o"))),
    'media-services-open-mediaviewer': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kIrJp"))),
    'media-services-oval': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("c0SXP"))),
    'media-services-pdf': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kj27R"))),
    'media-services-preselected': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kK7t8"))),
    'media-services-presentation': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3a68c"))),
    'media-services-rectangle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("iRHgf"))),
    'media-services-scale-large': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6SIxB"))),
    'media-services-scale-small': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dwvQx"))),
    'media-services-spreadsheet': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5I8wl"))),
    'media-services-text': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("52PFA")))),
    'media-services-unknown': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eWCJI"))),
    'media-services-video': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8kzpV"))),
    'media-services-zip': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4mG9s"))),
    'media-services-zoom-in': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3fqM3"))),
    'media-services-zoom-out': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("9nbqs"))),
    mention: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("l7iAz"))),
    menu: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hvE4Q"))),
    'menu-expand': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1rcrH"))),
    mobile: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fLlzt"))),
    more: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aQ0Lk"))),
    'more-vertical': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2seYZ"))),
    notification: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("l5GY2"))),
    'notification-all': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("akUEx"))),
    'notification-direct': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gKJE9"))),
    'office-building': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4O6SD"))),
    'office-building-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lOr5M"))),
    open: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6Wjaq"))),
    overview: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kQTTx"))),
    page: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6kENQ"))),
    'page-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7HTlr"))),
    pdf: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dBMVf"))),
    people: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("9HVF4")))),
    'people-group': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aYmcy"))),
    person: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("6NCZy")))),
    'person-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jrMtG"))),
    'person-with-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1sjLr"))),
    'person-with-cross': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("iUwam"))),
    'person-with-tick': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bQ7iR"))),
    portfolio: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fboOn"))),
    preferences: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5VPJY"))),
    premium: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4EjXL"))),
    'presence-active': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8JCLK"))),
    'presence-busy': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("M8Rxj"))),
    'presence-unavailable': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hABlI"))),
    question: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("iEJ32"))),
    'question-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("53vxQ")))),
    questions: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5EdbP"))),
    queues: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hbrEb"))),
    quote: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("8KCrB")))),
    radio: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("572Y0"))),
    recent: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kjuUp"))),
    redo: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("exckD"))),
    refresh: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lEfaF"))),
    retry: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1gz3S"))),
    roadmap: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kn3qg"))),
    'room-menu': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7qVFS"))),
    schedule: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5e7uw"))),
    'schedule-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hGeWn"))),
    screen: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3biwk"))),
    search: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("i1DfW")))),
    'select-clear': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("3VlSK")))),
    send: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6TZpS"))),
    settings: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("cytXm")))),
    share: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4jdxN"))),
    ship: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("01opv")))),
    shortcut: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("lhaOC")))),
    'sign-in': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("6qSYw")))),
    'sign-out': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kiVwN"))),
    sprint: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gBjOL"))),
    star: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("82lov"))),
    'star-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aCmtX"))),
    'star-large': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fRyUd"))),
    status: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("eta4I")))),
    stopwatch: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fowLT"))),
    subtask: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hr6tQ"))),
    suitcase: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3hTpc"))),
    switcher: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8oAwh"))),
    table: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bWIu4"))),
    task: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2QLpH"))),
    teams: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hVSj9"))),
    trash: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3miRP"))),
    tray: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7WWbR"))),
    undo: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fjcOC"))),
    unlink: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("g4fkL"))),
    unlock: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2iqiy"))),
    'unlock-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("j9AZ9"))),
    'unlock-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jDQyJ"))),
    upload: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2gF6z"))),
    'user-avatar-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("g4Zdb")))),
    'vid-audio-muted': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("apcuj"))),
    'vid-audio-on': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aWY6T"))),
    'vid-backward': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aPSWW"))),
    'vid-camera-off': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("ld6vq"))),
    'vid-camera-on': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1zMU1"))),
    'vid-connection-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4qGO3"))),
    'vid-forward': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("af22p"))),
    'vid-full-screen-off': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cbUsA"))),
    'vid-full-screen-on': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("29nSC"))),
    'vid-hang-up': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8HTiE"))),
    'vid-hd-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aakLu"))),
    'vid-pause': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8LnSq"))),
    'vid-play': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("9NEyp"))),
    'vid-raised-hand': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bzWAP"))),
    'vid-share-screen': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2OxZe"))),
    'vid-speaking-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4AQBL"))),
    'vid-volume-full': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("04WeJ"))),
    'vid-volume-half': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("iUvxg"))),
    'vid-volume-muted': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6Dv6q"))),
    'video-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1uhII"))),
    'video-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1lulf"))),
    warning: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("60rxg")))),
    watch: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("krDxS"))),
    'watch-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8Sc2L"))),
    world: /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("HAIsX"))),
    'world-small': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2X60A")))
};

});
parcelRegister("axsCd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8PW9S").then(()=>parcelRequire('975wj'));

});

parcelRegister("9Fm1W", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cBkmk").then(()=>parcelRequire('lnnie'));

});

parcelRegister("lNFQy", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5kdxD").then(()=>parcelRequire('XNSav'));

});

parcelRegister("hRePn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("c6h2T").then(()=>parcelRequire('4wUVQ'));

});

parcelRegister("9PqOo", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("JqUf8").then(()=>parcelRequire('8cQww'));

});

parcelRegister("4wmSQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jAiVN").then(()=>parcelRequire('cHJgY'));

});

parcelRegister("7gWbN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("i2MEP").then(()=>parcelRequire('17tab'));

});

parcelRegister("5mXw6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lOBVk").then(()=>parcelRequire('gQLCs'));

});

parcelRegister("jUg0H", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9SP4M").then(()=>parcelRequire('56U2f'));

});

parcelRegister("hgwWm", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("95wwu").then(()=>parcelRequire('iTwYh'));

});

parcelRegister("3WBvT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3Yxkh").then(()=>parcelRequire('ebhGv'));

});

parcelRegister("fNCbK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3X8iz").then(()=>parcelRequire('WCqcH'));

});

parcelRegister("qavM1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jhhKM").then(()=>parcelRequire('9YAbA'));

});

parcelRegister("hHXHT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("67Fw9").then(()=>parcelRequire('iK3VB'));

});

parcelRegister("aAtO9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7ppCQ").then(()=>parcelRequire('3BuQC'));

});

parcelRegister("5fhJg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bJrAA").then(()=>parcelRequire('m7bQa'));

});

parcelRegister("bsi2e", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lh1G0").then(()=>parcelRequire('9TRud'));

});

parcelRegister("hafIS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bffjE").then(()=>parcelRequire('2LTTf'));

});

parcelRegister("iZiYj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("b0Aes").then(()=>parcelRequire('eKycu'));

});

parcelRegister("izYoX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gB2Tu").then(()=>parcelRequire('dDf59'));

});

parcelRegister("4wQqY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5KlPN").then(()=>parcelRequire('5pnqQ'));

});

parcelRegister("1YNKq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("b8unI").then(()=>parcelRequire('1H8nC'));

});

parcelRegister("4mV01", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lrEVZ").then(()=>parcelRequire('af8GT'));

});

parcelRegister("4URYH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hLWkv").then(()=>parcelRequire('ey6lq'));

});

parcelRegister("7qTXR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("g19B6").then(()=>parcelRequire('bAoP2'));

});

parcelRegister("fm6q0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("23EvE").then(()=>parcelRequire('eylG6'));

});

parcelRegister("6bk5T", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8RgYl").then(()=>parcelRequire('bis1j'));

});

parcelRegister("5kHcX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("h3DZN").then(()=>parcelRequire('4017U'));

});

parcelRegister("11xtF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("clNzN").then(()=>parcelRequire('kXViC'));

});

parcelRegister("GIowT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("HOIkg").then(()=>parcelRequire('goMQ6'));

});

parcelRegister("eh8xN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2eEVY").then(()=>parcelRequire('12dl7'));

});

parcelRegister("6xXUa", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4lWB4").then(()=>parcelRequire('ae24m'));

});

parcelRegister("eQkYx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jkuie").then(()=>parcelRequire('iKnZb'));

});

parcelRegister("ibFjc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gK4kH").then(()=>parcelRequire('g3o8b'));

});

parcelRegister("1pP3X", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7ljrx").then(()=>parcelRequire('kEs7r'));

});

parcelRegister("fLWi7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("39Gfh").then(()=>parcelRequire('aDHzd'));

});

parcelRegister("76JV8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $52ccb6d3a2735d8d$var$_react = $52ccb6d3a2735d8d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $52ccb6d3a2735d8d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $52ccb6d3a2735d8d$var$CalendarIcon = (props)=>/*#__PURE__*/ $52ccb6d3a2735d8d$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props));
$52ccb6d3a2735d8d$var$CalendarIcon.displayName = 'CalendarIcon';
var $52ccb6d3a2735d8d$var$_default = module.exports.default = $52ccb6d3a2735d8d$var$CalendarIcon;

});

parcelRegister("96Apc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9hgjX").then(()=>parcelRequire('f19h5'));

});

parcelRegister("dDfhe", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ed2mE").then(()=>parcelRequire('4Bew3'));

});

parcelRegister("zbjhX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9NysB").then(()=>parcelRequire('8jWFf'));

});

parcelRegister("dprUg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("awMlP").then(()=>parcelRequire('WO5HT'));

});

parcelRegister("c6c6w", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8iD1s").then(()=>parcelRequire('7uPJZ'));

});

parcelRegister("g12PG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gumMy").then(()=>parcelRequire('4j6Gh'));

});

parcelRegister("2kdvq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1b17ecff78f4ff04$var$_react = $1b17ecff78f4ff04$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $1b17ecff78f4ff04$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1b17ecff78f4ff04$var$CheckIcon = (props)=>/*#__PURE__*/ $1b17ecff78f4ff04$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props));
$1b17ecff78f4ff04$var$CheckIcon.displayName = 'CheckIcon';
var $1b17ecff78f4ff04$var$_default = module.exports.default = $1b17ecff78f4ff04$var$CheckIcon;

});

parcelRegister("dmBba", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hSLye").then(()=>parcelRequire('aYKMq'));

});

parcelRegister("aMG9i", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("atgUY").then(()=>parcelRequire('dwm7g'));

});

parcelRegister("4leDg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("l8iYW").then(()=>parcelRequire('i0lOb'));

});

parcelRegister("kmdPb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5x3QX").then(()=>parcelRequire('2trcY'));

});

parcelRegister("bKbFx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7A8wH").then(()=>parcelRequire('6teG9'));

});

parcelRegister("3e3gt", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1GWUI").then(()=>parcelRequire('12kIx'));

});

parcelRegister("k9ooi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eab7917427604e36$var$_react = $eab7917427604e36$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $eab7917427604e36$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $eab7917427604e36$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $eab7917427604e36$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props));
$eab7917427604e36$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $eab7917427604e36$var$_default = module.exports.default = $eab7917427604e36$var$ChevronLeftLargeIcon;

});

parcelRegister("czcci", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9262370c29d80ea9$var$_react = $9262370c29d80ea9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $9262370c29d80ea9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9262370c29d80ea9$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $9262370c29d80ea9$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props));
$9262370c29d80ea9$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $9262370c29d80ea9$var$_default = module.exports.default = $9262370c29d80ea9$var$ChevronRightLargeIcon;

});

parcelRegister("cLNFy", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kh9kE").then(()=>parcelRequire('5Qxpc'));

});

parcelRegister("gWjQ0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dfLQO").then(()=>parcelRequire('3I0V3'));

});

parcelRegister("6HxVA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fw2TG").then(()=>parcelRequire('8NFT3'));

});

parcelRegister("jaaKd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2fcuy").then(()=>parcelRequire('8VBAo'));

});

parcelRegister("e50Bu", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hgifA").then(()=>parcelRequire('04OD1'));

});

parcelRegister("bpWPz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4SJXV").then(()=>parcelRequire('fW86E'));

});

parcelRegister("hZKKB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d19c65e3fa3f02f9$var$_react = $d19c65e3fa3f02f9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $d19c65e3fa3f02f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d19c65e3fa3f02f9$var$CopyIcon = (props)=>/*#__PURE__*/ $d19c65e3fa3f02f9$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
    }, props));
$d19c65e3fa3f02f9$var$CopyIcon.displayName = 'CopyIcon';
var $d19c65e3fa3f02f9$var$_default = module.exports.default = $d19c65e3fa3f02f9$var$CopyIcon;

});

parcelRegister("h9t5B", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dSwYG").then(()=>parcelRequire('2oHRg'));

});

parcelRegister("a2dzl", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("isLXN").then(()=>parcelRequire('ciHbV'));

});

parcelRegister("lUNrH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("h1t7D").then(()=>parcelRequire('aK7PB'));

});

parcelRegister("iJZrp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7BI7e").then(()=>parcelRequire('hFG4c'));

});

parcelRegister("eAUE9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dy9a9").then(()=>parcelRequire('H5mkF'));

});

parcelRegister("50tGD", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lfMoa").then(()=>parcelRequire('jJ1lg'));

});

parcelRegister("ccTZm", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("e56oM").then(()=>parcelRequire('f4OSv'));

});

parcelRegister("05bpU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dHjW1").then(()=>parcelRequire('2Bbby'));

});

parcelRegister("1zWcV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gz4XT").then(()=>parcelRequire('ePbAf'));

});

parcelRegister("2Lfta", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("yFU5h").then(()=>parcelRequire('cisEQ'));

});

parcelRegister("7XZaJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jsJXH").then(()=>parcelRequire('bRp3T'));

});

parcelRegister("bqrYs", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jQZ1Q").then(()=>parcelRequire('aCd44'));

});

parcelRegister("fDz61", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("i564Y").then(()=>parcelRequire('h5Ce7'));

});

parcelRegister("gIq8f", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8fEsa").then(()=>parcelRequire('dUYQ5'));

});

parcelRegister("2h2se", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ba1Fd").then(()=>parcelRequire('5InvN'));

});

parcelRegister("bKq60", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $88d83ba8c9217cfe$var$_react = $88d83ba8c9217cfe$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $88d83ba8c9217cfe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $88d83ba8c9217cfe$var$EditorAddIcon = (props)=>/*#__PURE__*/ $88d83ba8c9217cfe$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V7a1 1 0 0 0-2 0v4H7a1 1 0 0 0 0 2h4v4a1 1 0 0 0 2 0v-4h4a1 1 0 0 0 0-2z"/></svg>`
    }, props));
$88d83ba8c9217cfe$var$EditorAddIcon.displayName = 'EditorAddIcon';
var $88d83ba8c9217cfe$var$_default = module.exports.default = $88d83ba8c9217cfe$var$EditorAddIcon;

});

parcelRegister("4UPtj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2w0Qi").then(()=>parcelRequire('aUqM7'));

});

parcelRegister("eg9mT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aYP9q").then(()=>parcelRequire('5hZy0'));

});

parcelRegister("197JG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("90sCJ").then(()=>parcelRequire('itJvv'));

});

parcelRegister("8qapV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aSCoB").then(()=>parcelRequire('4Mccv'));

});

parcelRegister("dEt0o", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dqckE").then(()=>parcelRequire('8gvqu'));

});

parcelRegister("2h37v", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hqZFk").then(()=>parcelRequire('1sHch'));

});

parcelRegister("a8jAd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7dkq2").then(()=>parcelRequire('vUe0y'));

});

parcelRegister("2pHPx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9qc0L").then(()=>parcelRequire('67pUS'));

});

parcelRegister("bBmjU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fWxRi").then(()=>parcelRequire('9nmea'));

});

parcelRegister("Cs8TW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("wtjfs").then(()=>parcelRequire('8kJOj'));

});

parcelRegister("6OLN4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f6c7bc606f2d15e$var$_react = $4f6c7bc606f2d15e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $4f6c7bc606f2d15e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4f6c7bc606f2d15e$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $4f6c7bc606f2d15e$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props));
$4f6c7bc606f2d15e$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $4f6c7bc606f2d15e$var$_default = module.exports.default = $4f6c7bc606f2d15e$var$EditorCloseIcon;

});

parcelRegister("1Nb7L", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jVjxu").then(()=>parcelRequire('ddWy7'));

});

parcelRegister("gO5rE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hzrP3").then(()=>parcelRequire('k87gZ'));

});

parcelRegister("37Ug4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $246daa468c067835$var$_react = $246daa468c067835$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $246daa468c067835$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $246daa468c067835$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $246daa468c067835$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props));
$246daa468c067835$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $246daa468c067835$var$_default = module.exports.default = $246daa468c067835$var$EditorDoneIcon;

});

parcelRegister("3N9KL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("a4qNu").then(()=>parcelRequire('6x7wA'));

});

parcelRegister("kAbU2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7UChg").then(()=>parcelRequire('awf0r'));

});

parcelRegister("0Yz5o", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("glSHX").then(()=>parcelRequire('62Ipf'));

});

parcelRegister("8HRPj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9NcCG").then(()=>parcelRequire('976s5'));

});

parcelRegister("l3xZw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hF3Lf").then(()=>parcelRequire('LCM7i'));

});

parcelRegister("3sc9L", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jAOus").then(()=>parcelRequire('aBLo2'));

});

parcelRegister("bWcHV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kkylz").then(()=>parcelRequire('jnYmb'));

});

parcelRegister("gAhAq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aGy68").then(()=>parcelRequire('bqzz1'));

});

parcelRegister("57zOb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5houT").then(()=>parcelRequire('alwqL'));

});

parcelRegister("4k7ht", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("421Eq").then(()=>parcelRequire('8XVSm'));

});

parcelRegister("8EsJw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1JiyL").then(()=>parcelRequire('kA5Ep'));

});

parcelRegister("lnadk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("g5ovv").then(()=>parcelRequire('k4eLp'));

});

parcelRegister("3DkPn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9xAGT").then(()=>parcelRequire('afglw'));

});

parcelRegister("gLdes", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("g9oxW").then(()=>parcelRequire('EgBsF'));

});

parcelRegister("3iI0u", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hhp6l").then(()=>parcelRequire('9SSs2'));

});

parcelRegister("cwgo1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bvZPH").then(()=>parcelRequire('2jUeN'));

});

parcelRegister("clXui", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5nmY1").then(()=>parcelRequire('cR50m'));

});

parcelRegister("3Ih6p", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6aFSl").then(()=>parcelRequire('2dRbb'));

});

parcelRegister("gPpf9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fHoIY").then(()=>parcelRequire('8xVOG'));

});

parcelRegister("fyq9U", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7eAVc").then(()=>parcelRequire('kWoux'));

});

parcelRegister("llG54", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5W8n7").then(()=>parcelRequire('5TRYB'));

});

parcelRegister("b676u", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9xOM6").then(()=>parcelRequire('1Sm4w'));

});

parcelRegister("coNMY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4E4zv").then(()=>parcelRequire('bhy5u'));

});

parcelRegister("95phr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7BdRT").then(()=>parcelRequire('cLAxe'));

});

parcelRegister("a3Vzm", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("i4UPb").then(()=>parcelRequire('7sS8E'));

});

parcelRegister("8TXBT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7er38").then(()=>parcelRequire('vvebX'));

});

parcelRegister("f7oSr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b01ace88b278d48a$var$_react = $b01ace88b278d48a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $b01ace88b278d48a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b01ace88b278d48a$var$EditorRemoveIcon = (props)=>/*#__PURE__*/ $b01ace88b278d48a$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 7h10a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2m2.78 11a1 1 0 0 1-.97-.757L7.156 10.62A.5.5 0 0 1 7.64 10h8.72a.5.5 0 0 1 .485.621l-1.656 6.622a1 1 0 0 1-.97.757zM11 6h2a1 1 0 0 1 1 1h-4a1 1 0 0 1 1-1"/></svg>`
    }, props));
$b01ace88b278d48a$var$EditorRemoveIcon.displayName = 'EditorRemoveIcon';
var $b01ace88b278d48a$var$_default = module.exports.default = $b01ace88b278d48a$var$EditorRemoveIcon;

});

parcelRegister("lE8hi", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4Dpbh").then(()=>parcelRequire('4r46I'));

});

parcelRegister("dPkHp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a110182f06b4ad6b$var$_react = $a110182f06b4ad6b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $a110182f06b4ad6b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a110182f06b4ad6b$var$EditorSearchIcon = (props)=>/*#__PURE__*/ $a110182f06b4ad6b$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
    }, props));
$a110182f06b4ad6b$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
var $a110182f06b4ad6b$var$_default = module.exports.default = $a110182f06b4ad6b$var$EditorSearchIcon;

});

parcelRegister("ibxUD", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8PrU4").then(()=>parcelRequire('55Bec'));

});

parcelRegister("qO03x", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fMaAd").then(()=>parcelRequire('978Kz'));

});

parcelRegister("aE1uf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dLvDd").then(()=>parcelRequire('bFIyM'));

});

parcelRegister("3ob62", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("czbxW").then(()=>parcelRequire('8zghZ'));

});

parcelRegister("hxvM5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4VV25").then(()=>parcelRequire('hhX4N'));

});

parcelRegister("2ZVB1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6ks1u").then(()=>parcelRequire('8zM2d'));

});

parcelRegister("k89QS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7PGCU").then(()=>parcelRequire('78Hx3'));

});

parcelRegister("4ZN93", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a32fb20eb7dd93a$var$_react = $3a32fb20eb7dd93a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $3a32fb20eb7dd93a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3a32fb20eb7dd93a$var$EmailIcon = (props)=>/*#__PURE__*/ $3a32fb20eb7dd93a$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 7v10h14V7zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2z"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 0 0 4.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.12 1.12 0 0 1-1.583 0z"/></g></svg>`
    }, props));
$3a32fb20eb7dd93a$var$EmailIcon.displayName = 'EmailIcon';
var $3a32fb20eb7dd93a$var$_default = module.exports.default = $3a32fb20eb7dd93a$var$EmailIcon;

});

parcelRegister("acJe8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jJyiN").then(()=>parcelRequire('gBuYk'));

});

parcelRegister("hOysi", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5AHuk").then(()=>parcelRequire('fPVZ9'));

});

parcelRegister("lyZCv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("l2uIb").then(()=>parcelRequire('9bvq1'));

});

parcelRegister("gFyU6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("71TFb").then(()=>parcelRequire('av1JP'));

});

parcelRegister("jOedN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hhCVh").then(()=>parcelRequire('eJrv9'));

});

parcelRegister("d88Xn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("glsNq").then(()=>parcelRequire('bJeeF'));

});

parcelRegister("eeAFc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5MoOU").then(()=>parcelRequire('5HjYw'));

});

parcelRegister("8EbyJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dF9x9").then(()=>parcelRequire('d68Yw'));

});

parcelRegister("pgD1c", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ekl6p").then(()=>parcelRequire('gTfIE'));

});

parcelRegister("2xtKF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("k49zw").then(()=>parcelRequire('2TUNQ'));

});

parcelRegister("fADd3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6HpCe").then(()=>parcelRequire('hBeZB'));

});

parcelRegister("bpyTT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("Aklpg").then(()=>parcelRequire('6PIBc'));

});

parcelRegister("f3J6m", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8Jr41").then(()=>parcelRequire('kmWFq'));

});

parcelRegister("4x7zS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8te3e").then(()=>parcelRequire('d5yYM'));

});

parcelRegister("j9jS8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4Znfo").then(()=>parcelRequire('88aCw'));

});

parcelRegister("CcgmX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ibIy0").then(()=>parcelRequire('bJwMY'));

});

parcelRegister("7ibBx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("k3S9d").then(()=>parcelRequire('lS60U'));

});

parcelRegister("2fuGi", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4Rpg4").then(()=>parcelRequire('9ryJx'));

});

parcelRegister("1DK2N", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8tzTI").then(()=>parcelRequire('1mgPR'));

});

parcelRegister("46rU4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fr8OK").then(()=>parcelRequire('55Xut'));

});

parcelRegister("kpHER", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1nxiB").then(()=>parcelRequire('QZnoq'));

});

parcelRegister("7XKr3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lkNn0").then(()=>parcelRequire('17hUm'));

});

parcelRegister("lnYob", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("e1Ceu").then(()=>parcelRequire('fsQEt'));

});

parcelRegister("gr7DB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("k3wBC").then(()=>parcelRequire('jPcmr'));

});

parcelRegister("cPNom", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dF2kg").then(()=>parcelRequire('aNw41'));

});

parcelRegister("9cdOY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kelo3").then(()=>parcelRequire('dP9Iy'));

});

parcelRegister("1jMXj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2EFah").then(()=>parcelRequire('78kLE'));

});

parcelRegister("jXtYG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4ko5y").then(()=>parcelRequire('5loX9'));

});

parcelRegister("aIPLP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3bCpl").then(()=>parcelRequire('7mPBC'));

});

parcelRegister("k6gch", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9cjn0").then(()=>parcelRequire('lP4VJ'));

});

parcelRegister("5WsrD", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8xZDN").then(()=>parcelRequire('kRQuv'));

});

parcelRegister("eV9E5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eEmWq").then(()=>parcelRequire('hVV5E'));

});

parcelRegister("90eO2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kmEjD").then(()=>parcelRequire('FyGHt'));

});

parcelRegister("bcLSQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("j5BI7").then(()=>parcelRequire('94MwS'));

});

parcelRegister("7PZNM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("a11r2").then(()=>parcelRequire('bDEAQ'));

});

parcelRegister("cPCOJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kNyWt").then(()=>parcelRequire('77KIU'));

});

parcelRegister("3Uvbk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("71Xc8").then(()=>parcelRequire('lFYEk'));

});

parcelRegister("5AsjY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9pHFU").then(()=>parcelRequire('aGxmN'));

});

parcelRegister("g66wC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jDbBU").then(()=>parcelRequire('lPGku'));

});

parcelRegister("bIlY9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iI1rx").then(()=>parcelRequire('7Xamg'));

});

parcelRegister("3eKdM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jNuSK").then(()=>parcelRequire('9Dsnq'));

});

parcelRegister("k6iyf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fPvem").then(()=>parcelRequire('1qE6O'));

});

parcelRegister("fX1Pk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2JTvY").then(()=>parcelRequire('lhDHA'));

});

parcelRegister("gQDdL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("168y5").then(()=>parcelRequire('xh7on'));

});

parcelRegister("88tEs", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7VNjW").then(()=>parcelRequire('7eZoy'));

});

parcelRegister("cyQXM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lyamL").then(()=>parcelRequire('4idZl'));

});

parcelRegister("6ZIkL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("CwkI6").then(()=>parcelRequire('b5mgb'));

});

parcelRegister("fH8G5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kv290").then(()=>parcelRequire('gOAbs'));

});

parcelRegister("cn8Wc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4h9Ss").then(()=>parcelRequire('9D9o8'));

});

parcelRegister("1wbDv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lfyv0").then(()=>parcelRequire('jWelK'));

});

parcelRegister("j0QvP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("a5MOw").then(()=>parcelRequire('fdbBG'));

});

parcelRegister("lnXk0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("i7B1x").then(()=>parcelRequire('bBHDr'));

});

parcelRegister("eAmma", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kvImD").then(()=>parcelRequire('ijSaI'));

});

parcelRegister("e0B6y", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("g1Xnf").then(()=>parcelRequire('1Pa7M'));

});

parcelRegister("a2o1i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $74ecb925586ee899$var$_react = $74ecb925586ee899$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $74ecb925586ee899$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $74ecb925586ee899$var$LinkIcon = (props)=>/*#__PURE__*/ $74ecb925586ee899$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props));
$74ecb925586ee899$var$LinkIcon.displayName = 'LinkIcon';
var $74ecb925586ee899$var$_default = module.exports.default = $74ecb925586ee899$var$LinkIcon;

});

parcelRegister("jt0vj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("17IHh").then(()=>parcelRequire('bZR3b'));

});

parcelRegister("1Royr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fdSEM").then(()=>parcelRequire('aceGa'));

});

parcelRegister("hpfLU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("d6xir").then(()=>parcelRequire('7wMyK'));

});

parcelRegister("djnBL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("967wm").then(()=>parcelRequire('jFH1h'));

});

parcelRegister("djJr9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ge5BM").then(()=>parcelRequire('2qR2u'));

});

parcelRegister("kKPzl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1c01b17c1604b90$var$_react = $f1c01b17c1604b90$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $f1c01b17c1604b90$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f1c01b17c1604b90$var$LockFilledIcon = (props)=>/*#__PURE__*/ $f1c01b17c1604b90$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 10V8.002A4.004 4.004 0 0 1 12 4a4 4 0 0 1 4 4.002V10a2 2 0 0 1 2 2v6c0 1.105-.902 2-2.009 2H8.01A2 2 0 0 1 6 18v-6c0-1.102.897-1.995 2-2m2 0h4V8.002A2 2 0 0 0 12 6c-1.102 0-2 .898-2 2.002zm2 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`
    }, props));
$f1c01b17c1604b90$var$LockFilledIcon.displayName = 'LockFilledIcon';
var $f1c01b17c1604b90$var$_default = module.exports.default = $f1c01b17c1604b90$var$LockFilledIcon;

});

parcelRegister("jheAx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cmc5o").then(()=>parcelRequire('64a9y'));

});

parcelRegister("etSq4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cdIZr").then(()=>parcelRequire('2F5b6'));

});

parcelRegister("4Kxo1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("25Ymu").then(()=>parcelRequire('CwC9E'));

});

parcelRegister("eiXxm", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1eWDI").then(()=>parcelRequire('8CnfC'));

});

parcelRegister("a6D1j", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eLoti").then(()=>parcelRequire('5n11j'));

});

parcelRegister("gBCxG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3xh1Y").then(()=>parcelRequire('4oGzS'));

});

parcelRegister("eAstp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7UMfo").then(()=>parcelRequire('5mo7T'));

});

parcelRegister("5ZdZX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kuHvv").then(()=>parcelRequire('8Jkrp'));

});

parcelRegister("ewvjF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hYaAe").then(()=>parcelRequire('dIbk1'));

});

parcelRegister("1SbDw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9qj4A").then(()=>parcelRequire('jGoOG'));

});

parcelRegister("6mo8x", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1DGap").then(()=>parcelRequire('dpuyx'));

});

parcelRegister("Yf1Va", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5W6c9").then(()=>parcelRequire('dlAc5'));

});

parcelRegister("lRyIz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kUiUR").then(()=>parcelRequire('8lWE8'));

});

parcelRegister("8xKDw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fkVsa").then(()=>parcelRequire('BjOSK'));

});

parcelRegister("3UlY1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bhIY6").then(()=>parcelRequire('8MeK7'));

});

parcelRegister("bHFww", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5GYyU").then(()=>parcelRequire('cCn8A'));

});

parcelRegister("8PTHr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6QB1T").then(()=>parcelRequire('dJc8G'));

});

parcelRegister("daEBz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fU8qX").then(()=>parcelRequire('95O0U'));

});

parcelRegister("jJw6o", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1zCTk").then(()=>parcelRequire('jHLFs'));

});

parcelRegister("kIrJp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("b8zCh").then(()=>parcelRequire('ijUCF'));

});

parcelRegister("c0SXP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9vwdH").then(()=>parcelRequire('dy3yk'));

});

parcelRegister("kj27R", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6nJtj").then(()=>parcelRequire('naEVr'));

});

parcelRegister("kK7t8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2XbC1").then(()=>parcelRequire('eAmxO'));

});

parcelRegister("3a68c", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("k6Fy0").then(()=>parcelRequire('83EtJ'));

});

parcelRegister("iRHgf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hzRYS").then(()=>parcelRequire('rKLCF'));

});

parcelRegister("6SIxB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6eTQ0").then(()=>parcelRequire('haqIx'));

});

parcelRegister("dwvQx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("22HLg").then(()=>parcelRequire('5dZBJ'));

});

parcelRegister("5I8wl", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3u49T").then(()=>parcelRequire('b6so3'));

});

parcelRegister("eWCJI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bqaSW").then(()=>parcelRequire('jysme'));

});

parcelRegister("8kzpV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5rwjP").then(()=>parcelRequire('52jDP'));

});

parcelRegister("4mG9s", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6VGr2").then(()=>parcelRequire('kwQYh'));

});

parcelRegister("3fqM3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2Sswr").then(()=>parcelRequire('funwk'));

});

parcelRegister("9nbqs", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fYgDU").then(()=>parcelRequire('djL4Z'));

});

parcelRegister("l7iAz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hs6oN").then(()=>parcelRequire('agyc8'));

});

parcelRegister("hvE4Q", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4emIQ").then(()=>parcelRequire('gJmwe'));

});

parcelRegister("1rcrH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dB9J6").then(()=>parcelRequire('7OgRC'));

});

parcelRegister("fLlzt", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7KTTm").then(()=>parcelRequire('gE8ze'));

});

parcelRegister("aQ0Lk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cbFgx").then(()=>parcelRequire('31yN3'));

});

parcelRegister("2seYZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iLlJF").then(()=>parcelRequire('4w7Cf'));

});

parcelRegister("l5GY2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lRweH").then(()=>parcelRequire('9TNDT'));

});

parcelRegister("akUEx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("b8RiO").then(()=>parcelRequire('exldq'));

});

parcelRegister("gKJE9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("l1UOm").then(()=>parcelRequire('aYffm'));

});

parcelRegister("4O6SD", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("a2C9b").then(()=>parcelRequire('if7fN'));

});

parcelRegister("lOr5M", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("esVy5").then(()=>parcelRequire('bjFeZ'));

});

parcelRegister("6Wjaq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7A7U0").then(()=>parcelRequire('63Q5r'));

});

parcelRegister("kQTTx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4Jr6P").then(()=>parcelRequire('i53Hg'));

});

parcelRegister("6kENQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8RnVw").then(()=>parcelRequire('ho2si'));

});

parcelRegister("7HTlr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7Ndc2").then(()=>parcelRequire('ha22e'));

});

parcelRegister("dBMVf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ajic1").then(()=>parcelRequire('fEtUg'));

});

parcelRegister("9HVF4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7114db95708449c8$var$_react = $7114db95708449c8$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $7114db95708449c8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7114db95708449c8$var$PeopleIcon = (props)=>/*#__PURE__*/ $7114db95708449c8$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><path d="M13 12a1.997 1.997 0 0 0-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3 3 0 0 1 12.997 12z"/></g></svg>`
    }, props));
$7114db95708449c8$var$PeopleIcon.displayName = 'PeopleIcon';
var $7114db95708449c8$var$_default = module.exports.default = $7114db95708449c8$var$PeopleIcon;

});

parcelRegister("aYmcy", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iw8Ph").then(()=>parcelRequire('hh8BY'));

});

parcelRegister("6NCZy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f3590a7e2e97d7f$var$_react = $4f3590a7e2e97d7f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $4f3590a7e2e97d7f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4f3590a7e2e97d7f$var$PersonIcon = (props)=>/*#__PURE__*/ $4f3590a7e2e97d7f$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="12" cy="7" r="4"/></g></svg>`
    }, props));
$4f3590a7e2e97d7f$var$PersonIcon.displayName = 'PersonIcon';
var $4f3590a7e2e97d7f$var$_default = module.exports.default = $4f3590a7e2e97d7f$var$PersonIcon;

});

parcelRegister("jrMtG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iucz1").then(()=>parcelRequire('e5XXZ'));

});

parcelRegister("1sjLr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6wZgZ").then(()=>parcelRequire('di1sw'));

});

parcelRegister("iUwam", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bGizp").then(()=>parcelRequire('6nxda'));

});

parcelRegister("bQ7iR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("78c8n").then(()=>parcelRequire('85yTx'));

});

parcelRegister("fboOn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4gYcM").then(()=>parcelRequire('hg3w4'));

});

parcelRegister("5VPJY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("382Q7").then(()=>parcelRequire('c8Sc8'));

});

parcelRegister("4EjXL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1FABL").then(()=>parcelRequire('ko7mk'));

});

parcelRegister("8JCLK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hyhWi").then(()=>parcelRequire('ieVy8'));

});

parcelRegister("M8Rxj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("elmfm").then(()=>parcelRequire('44Pd8'));

});

parcelRegister("hABlI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jCwJz").then(()=>parcelRequire('8QWdM'));

});

parcelRegister("iEJ32", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("e6NbN").then(()=>parcelRequire('1UNF9'));

});

parcelRegister("53vxQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3ae5b3b3da919dbc$var$_react = $3ae5b3b3da919dbc$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $3ae5b3b3da919dbc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3ae5b3b3da919dbc$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $3ae5b3b3da919dbc$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><circle cx="12" cy="18" r="1" fill="inherit"/><path fill="inherit" d="M15.89 9.05a3.98 3.98 0 0 0-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.99.99 0 0 0 .982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 0 1 4.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 0 0-1 .987v2.014a1.001 1.001 0 0 0 2.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0 0 15.89 9.05"/></g></svg>`
    }, props));
$3ae5b3b3da919dbc$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $3ae5b3b3da919dbc$var$_default = module.exports.default = $3ae5b3b3da919dbc$var$QuestionCircleIcon;

});

parcelRegister("5EdbP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iyv15").then(()=>parcelRequire('8OgoK'));

});

parcelRegister("hbrEb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dtqns").then(()=>parcelRequire('e2T7h'));

});

parcelRegister("572Y0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("i5XfU").then(()=>parcelRequire('279SN'));

});

parcelRegister("kjuUp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fpXfq").then(()=>parcelRequire('3YzE3'));

});

parcelRegister("exckD", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("35355").then(()=>parcelRequire('f87hJ'));

});

parcelRegister("lEfaF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gVfRD").then(()=>parcelRequire('96otq'));

});

parcelRegister("1gz3S", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7igsj").then(()=>parcelRequire('a8nB2'));

});

parcelRegister("kn3qg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iTnhJ").then(()=>parcelRequire('jzOmA'));

});

parcelRegister("7qVFS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8aUUY").then(()=>parcelRequire('4kIKR'));

});

parcelRegister("5e7uw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5dNkA").then(()=>parcelRequire('azuEZ'));

});

parcelRegister("hGeWn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("14NIX").then(()=>parcelRequire('argEv'));

});

parcelRegister("3biwk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("k3XCC").then(()=>parcelRequire('03p3V'));

});

parcelRegister("6TZpS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gfl86").then(()=>parcelRequire('d4bbl'));

});

parcelRegister("4jdxN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hJZ31").then(()=>parcelRequire('4jCd5'));

});

parcelRegister("01opv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $004307881908012c$var$_react = $004307881908012c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $004307881908012c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $004307881908012c$var$ShipIcon = (props)=>/*#__PURE__*/ $004307881908012c$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 12h8v-2H6zM4 8.99C4 8.445 4.456 8 5.002 8h9.996C15.55 8 16 8.451 16 8.99V14H4z"/><path d="M6 7.005C6 5.898 6.898 5 7.998 5h2.004C11.106 5 12 5.894 12 7.005V10H6zm4 0V7H7.999c.005 0 .002.003.002.005V8h2z"/><path fill-rule="nonzero" d="M4.5 17h13.994l1.002-3H4.14zm-2.495-4.012A.862.862 0 0 1 2.883 12h18.393c.55 0 .857.417.681.944l-1.707 5.112c-.174.521-.758.944-1.315.944H3.725a1.15 1.15 0 0 1-1.118-.988z"/></g></svg>`
    }, props));
$004307881908012c$var$ShipIcon.displayName = 'ShipIcon';
var $004307881908012c$var$_default = module.exports.default = $004307881908012c$var$ShipIcon;

});

parcelRegister("kiVwN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kWHNc").then(()=>parcelRequire('bv5Vu'));

});

parcelRegister("gBjOL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("98YiA").then(()=>parcelRequire('1L428'));

});

parcelRegister("82lov", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cQBAR").then(()=>parcelRequire('2Cx9n'));

});

parcelRegister("aCmtX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("glQWR").then(()=>parcelRequire('91hUW'));

});

parcelRegister("fRyUd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9fb63").then(()=>parcelRequire('dhNEi'));

});

parcelRegister("fowLT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6TpaP").then(()=>parcelRequire('5NWMp'));

});

parcelRegister("hr6tQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dmjTp").then(()=>parcelRequire('2V4fk'));

});

parcelRegister("3hTpc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eF8g9").then(()=>parcelRequire('cW9vr'));

});

parcelRegister("8oAwh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cjkeb").then(()=>parcelRequire('3jp5k'));

});

parcelRegister("bWIu4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dIzxh").then(()=>parcelRequire('l3PcV'));

});

parcelRegister("2QLpH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kONGf").then(()=>parcelRequire('jgKZU'));

});

parcelRegister("hVSj9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("247gI").then(()=>parcelRequire('lTJ4V'));

});

parcelRegister("3miRP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("j6NA8").then(()=>parcelRequire('4jyPp'));

});

parcelRegister("7WWbR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5OUiu").then(()=>parcelRequire('cBLI1'));

});

parcelRegister("fjcOC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cqSzt").then(()=>parcelRequire('2YhMX'));

});

parcelRegister("g4fkL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bIiQl").then(()=>parcelRequire('21h9s'));

});

parcelRegister("2iqiy", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iw7mH").then(()=>parcelRequire('3gW4g'));

});

parcelRegister("j9AZ9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("idy9a").then(()=>parcelRequire('fz788'));

});

parcelRegister("jDQyJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8ZNno").then(()=>parcelRequire('g7Yw9'));

});

parcelRegister("2gF6z", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dBEdI").then(()=>parcelRequire('lmcPJ'));

});

parcelRegister("apcuj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fUYfP").then(()=>parcelRequire('jfdC8'));

});

parcelRegister("aWY6T", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7x8iZ").then(()=>parcelRequire('1l2tN'));

});

parcelRegister("aPSWW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ituVa").then(()=>parcelRequire('6RGeE'));

});

parcelRegister("ld6vq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iG1Cs").then(()=>parcelRequire('gU4j4'));

});

parcelRegister("1zMU1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("19lKy").then(()=>parcelRequire('il93n'));

});

parcelRegister("4qGO3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("is2fC").then(()=>parcelRequire('h88zC'));

});

parcelRegister("af22p", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2uUTw").then(()=>parcelRequire('hN51X'));

});

parcelRegister("cbUsA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dQNjw").then(()=>parcelRequire('9mwnp'));

});

parcelRegister("29nSC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iLfpK").then(()=>parcelRequire('fYdPe'));

});

parcelRegister("8HTiE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8D6c1").then(()=>parcelRequire('h7eGp'));

});

parcelRegister("aakLu", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ePp1D").then(()=>parcelRequire('eRdPG'));

});

parcelRegister("8LnSq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("51CzE").then(()=>parcelRequire('lQpoo'));

});

parcelRegister("9NEyp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kJuAQ").then(()=>parcelRequire('7elOh'));

});

parcelRegister("bzWAP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("f6nmi").then(()=>parcelRequire('cj15I'));

});

parcelRegister("2OxZe", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1RIcp").then(()=>parcelRequire('k3xlK'));

});

parcelRegister("4AQBL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dWOwD").then(()=>parcelRequire('dMJRY'));

});

parcelRegister("04WeJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bfEtT").then(()=>parcelRequire('hk6N7'));

});

parcelRegister("iUvxg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ghRDy").then(()=>parcelRequire('377EB'));

});

parcelRegister("6Dv6q", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7titD").then(()=>parcelRequire('ioc4u'));

});

parcelRegister("1uhII", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1T5xx").then(()=>parcelRequire('5l5CZ'));

});

parcelRegister("1lulf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ay3sK").then(()=>parcelRequire('fLfZY'));

});

parcelRegister("krDxS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gcNl8").then(()=>parcelRequire('ckYfT'));

});

parcelRegister("8Sc2L", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("i8qCQ").then(()=>parcelRequire('jefpy'));

});

parcelRegister("HAIsX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4zRxf").then(()=>parcelRequire('d9Hm3'));

});

parcelRegister("2X60A", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hJs6U").then(()=>parcelRequire('22YUK'));

});



parcelRegister("bdwGa", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eSsym").then(()=>parcelRequire('hvoP7'));

});


parcelRegister("eUUeL", function(module, exports) {
$parcel$export(module.exports, "ButtonSet", () => $56416921eaf7c3af$export$87e672a75327e04b);
$parcel$export(module.exports, "ButtonSetFn", () => $56416921eaf7c3af$export$1ff560ec9540c1a9);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");
parcelRequire("eJOHy");
function $56416921eaf7c3af$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $56416921eaf7c3af$var$_ref = {
    name: "o9i2zm",
    styles: "display:flex;flex-wrap:wrap;> *{margin-top:var(--ds-space-100, 8px);margin-right:var(--ds-space-100, 8px);}margin-top:var(--ds-space-negative-100, -8px);margin-right:var(--ds-space-negative-100, -8px)"
};
const $56416921eaf7c3af$export$87e672a75327e04b = ({ children: children })=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: $56416921eaf7c3af$var$_ref
    }, children);
const $56416921eaf7c3af$export$1ff560ec9540c1a9 = ({ children: children, dispatch: dispatch, Components: Components, render: render, renderChildren: renderChildren })=>/*#__PURE__*/ (0, $1NIU8.jsx)($56416921eaf7c3af$export$87e672a75327e04b, null, renderChildren({
        children: children,
        dispatch: dispatch,
        Components: Components,
        render: render
    }));

});

parcelRegister("hkc7c", function(module, exports) {
$parcel$export(module.exports, "CheckboxGroupFn", () => $ca5f0a3d10fd7bff$export$b78851756f45833b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eJOHy = parcelRequire("eJOHy");

var $i3v3M = parcelRequire("i3v3M");
function $ca5f0a3d10fd7bff$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ca5f0a3d10fd7bff$var$styles = {
    name: "1l4ndn6",
    styles: "line-height:20px"
};

const $ca5f0a3d10fd7bff$var$AKCheckbox = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("jytLP")).then((module)=>({
            default: module.Checkbox
        })));

const $ca5f0a3d10fd7bff$var$AKCheckboxField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("de5df")).then((module)=>({
            default: module.CheckboxField
        })));

const $ca5f0a3d10fd7bff$var$Fieldset = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("de5df")).then((module)=>({
            default: module.Fieldset
        })));

const $ca5f0a3d10fd7bff$var$AKHelperMessage = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("de5df")).then((module)=>({
            default: module.HelperMessage
        })));
const $ca5f0a3d10fd7bff$export$4aa08d5625cb8ead = ({ options: options, label: label, name: name, description: description })=>{
    const defaultValues = [];
    options.forEach((option)=>{
        if (option.defaultChecked) defaultValues.push(option.value);
    });
    const [checkboxFieldValues, setCheckboxFieldValues] = (0, $eJOHy.useState)(defaultValues);
    return /*#__PURE__*/ (0, $1NIU8.jsx)($ca5f0a3d10fd7bff$var$Fieldset, {
        legend: label
    }, description && /*#__PURE__*/ (0, $1NIU8.jsx)($ca5f0a3d10fd7bff$var$AKHelperMessage, null, description), options.map((option)=>{
        const { key: key, label: label, value: value, defaultChecked: defaultChecked, isRequired: isRequired } = option;
        return /*#__PURE__*/ (0, $1NIU8.jsx)($ca5f0a3d10fd7bff$var$AKCheckboxField, {
            key: key,
            value: value,
            defaultIsChecked: defaultChecked,
            name: name
        }, ({ fieldProps: fieldProps })=>{
            const { id: id, isDisabled: isDisabled, isInvalid: isInvalid, onChange: onChange, onBlur: onBlur, onFocus: onFocus, value: value, name: name, 'aria-invalid': ariaInvalid, 'aria-labelledby': ariaLabelledBy, isChecked: isChecked } = fieldProps;
            return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
                css: $ca5f0a3d10fd7bff$var$styles
            }, /*#__PURE__*/ (0, $1NIU8.jsx)($ca5f0a3d10fd7bff$var$AKCheckbox, {
                id: id,
                isChecked: isChecked,
                isDisabled: isDisabled,
                isInvalid: isInvalid,
                isRequired: isRequired,
                onBlur: onBlur,
                onFocus: onFocus,
                value: value,
                name: name,
                label: label,
                onChange: (e)=>{
                    if (e.target.checked) setCheckboxFieldValues((prevState)=>[
                            ...prevState,
                            value
                        ]);
                    else setCheckboxFieldValues(checkboxFieldValues.filter((e)=>e !== value));
                    return onChange(e);
                },
                "aria-invalid": ariaInvalid,
                "aria-labelledby": ariaLabelledBy
            }));
        });
    }), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $i3v3M.FormStateChangeNotifier), {
        name: name,
        value: checkboxFieldValues
    }));
};
const $ca5f0a3d10fd7bff$export$b78851756f45833b = ({ props: propsAny, children: children })=>{
    const { name: name, description: description } = propsAny;
    const props = propsAny;
    // NOTE: legend is deprecated
    const label = 'legend' in props ? props.legend : props.label;
    const options = children.filter(({ type: type })=>type === 'Checkbox').map((child)=>{
        const { key: key, props: props } = child;
        const { label: label, value: value, defaultChecked: defaultChecked, isRequired: isRequired } = props;
        return {
            key: key,
            label: label,
            value: value,
            defaultChecked: defaultChecked,
            isRequired: isRequired
        };
    });
    return /*#__PURE__*/ (0, $1NIU8.jsx)($ca5f0a3d10fd7bff$export$4aa08d5625cb8ead, {
        label: label,
        name: name,
        options: options,
        description: description
    });
};

});
parcelRegister("i3v3M", function(module, exports) {
$parcel$export(module.exports, "AkForm", () => $220a9ff2417f42c4$export$117438e17b246db9);
$parcel$export(module.exports, "AkFormFooter", () => $220a9ff2417f42c4$export$bbe730ec239dd31a);
$parcel$export(module.exports, "isActionButton", () => $220a9ff2417f42c4$export$2127b0e8511224d0);
$parcel$export(module.exports, "useForm", () => $220a9ff2417f42c4$export$87c0cf8eb5a167e0);
$parcel$export(module.exports, "FormContext", () => $220a9ff2417f42c4$export$c24727297075ec6a);
$parcel$export(module.exports, "FormStateChangeNotifier", () => $220a9ff2417f42c4$export$56c425463976216f);
$parcel$export(module.exports, "Form", () => $220a9ff2417f42c4$export$a7fed597f4b8afd8);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");

var $3fQFh = parcelRequire("3fQFh");
var $eUUeL = parcelRequire("eUUeL");

var $h3mfa = parcelRequire("h3mfa");

var $iWhr8 = parcelRequire("iWhr8");

const $220a9ff2417f42c4$export$117438e17b246db9 = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("de5df")).then((module)=>({
            default: module.default
        })));

const $220a9ff2417f42c4$export$bbe730ec239dd31a = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("de5df")).then((module)=>({
            default: module.FormFooter
        })));

const $220a9ff2417f42c4$export$c0511946385c3887 = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("de5df")).then((module)=>({
            default: module.Field
        })));
const $220a9ff2417f42c4$export$2127b0e8511224d0 = (auxElement)=>auxElement.key && auxElement.key.startsWith('actionButton');
function $220a9ff2417f42c4$export$87c0cf8eb5a167e0({ forgeDoc: forgeDoc, dispatch: dispatch, render: render }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { props: { submitButtonText: submitButtonText = formatMessage($220a9ff2417f42c4$export$defe85febe8b728c.forgeFormSubmitButtonText), onSubmit: onSubmit, submitButtonAppearance: submitButtonAppearance = 'default' } = {} } = forgeDoc;
    const [loading, setLoading] = (0, $eJOHy.useState)(false);
    /**
   * Toggle the Form's React key to remount the component for clearing fields
   * Using the formProps' reset() would trigger our custom form validation for isRequired on some fields
   */ const [formKey, setFormKey] = (0, $eJOHy.useState)(0);
    const onSubmitHandler = async (formData)=>{
        setLoading(true);
        try {
            await dispatch({
                type: 'event',
                extensionData: {},
                handler: onSubmit,
                args: [
                    (0, $h3mfa.transformFormData)(formData)
                ]
            });
            setFormKey(Number(!formKey));
        } finally{
            setLoading(false);
        }
    };
    const akSubmitButtonProps = {
        ...(0, $3fQFh.useButton)({
            forgeDoc: {
                type: 'Button',
                props: {
                    text: submitButtonText,
                    appearance: submitButtonAppearance
                },
                children: []
            },
            dispatch: dispatch,
            render: render
        }).akButtonProps,
        onClick: undefined,
        type: 'submit',
        isLoading: loading
    };
    const children = forgeDoc.children.filter((x)=>!$220a9ff2417f42c4$export$2127b0e8511224d0(x));
    const actions = forgeDoc.children.filter($220a9ff2417f42c4$export$2127b0e8511224d0).map((actionButton)=>({
            ...actionButton,
            props: {
                ...actionButton.props,
                appearance: 'subtle'
            }
        }));
    return {
        akFormProps: {
            key: formKey,
            onSubmit: onSubmitHandler,
            children: ()=>{
                throw Error('@atlassian/forge-ui: Invalid composition of UI Kit useForm and Atlaskit Form');
            }
        },
        akSubmitButtonProps: akSubmitButtonProps,
        htmlFormProps: {
            // @ts-ignore
            'data-testid': 'form',
            className: (0, $iWhr8.emotionInstance).css`
        width: 100%;
        margin-top: 0;
        > *:not(footer) {
          margin-top: 0;
        }
        > *:not(:last-child) {
          margin-bottom: ${"var(--ds-space-100, 8px)"};
        }
        ${children.length === 0 ? `
            > footer {
              margin-top: 0;
            }
            ` : ''}
      `
        },
        akFormFooterProps: {
            align: 'start'
        },
        children: children.map(render),
        actions: actions.length > 0 ? actions.map(render) : null
    };
}
const $220a9ff2417f42c4$export$c24727297075ec6a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(null);
const $220a9ff2417f42c4$export$56c425463976216f = ({ name: name, value: value })=>{
    const formContext = (0, $eJOHy.useContext)($220a9ff2417f42c4$export$c24727297075ec6a);
    (0, $eJOHy.useEffect)(()=>{
        formContext?.setFormValue(name, value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        name,
        Array.isArray(value) ? value.join() : value
    ]);
    return null;
};
function $220a9ff2417f42c4$export$a7fed597f4b8afd8(props) {
    const { actions: actions, akFormFooterProps: akFormFooterProps, akFormProps: akFormProps, akSubmitButtonProps: akSubmitButtonProps, children: children, htmlFormProps: htmlFormProps } = $220a9ff2417f42c4$export$87c0cf8eb5a167e0(props);
    const { shouldFitContainer: shouldFitContainer, iconBefore: iconBefore, iconAfter: iconAfter, isLoading: loading, isDisabled: disabled, appearance: appearance, onClick: onClick, type: type, children: buttonChildren } = akSubmitButtonProps;
    const { align: align } = akFormFooterProps;
    const { key: key, onSubmit: onSubmit } = akFormProps;
    // @ts-ignore Ignoring the fact that "data-testid" is not part of the declared type
    const { className: className, 'data-testid': dataTestId } = htmlFormProps;
    const [formValues, setFormValues] = (0, $eJOHy.useState)({});
    const setFormValue = (name, value)=>{
        setFormValues((prevState)=>({
                ...prevState,
                [name]: value
            }));
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)($220a9ff2417f42c4$export$117438e17b246db9, {
        onSubmit: onSubmit,
        children: ({ formProps: formProps })=>{
            const { onSubmit: onSubmit, onKeyDown: onKeyDown, ref: ref } = formProps;
            return(// eslint-disable-next-line @atlassian/a11y/no-noninteractive-element-interactions
            /*#__PURE__*/ (0, $gt9Am.jsxs)("form", {
                onSubmit: onSubmit,
                onKeyDown: onKeyDown,
                ref: ref,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                "data-testid": dataTestId,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)($220a9ff2417f42c4$export$c24727297075ec6a.Provider, {
                        value: {
                            formValues: formValues,
                            setFormValue: setFormValue
                        },
                        children: children
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)($220a9ff2417f42c4$export$bbe730ec239dd31a, {
                        align: align,
                        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eUUeL.ButtonSet), {
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3fQFh.AkButton), {
                                    shouldFitContainer: shouldFitContainer,
                                    iconBefore: iconBefore,
                                    iconAfter: iconAfter,
                                    isLoading: loading,
                                    isDisabled: disabled,
                                    appearance: appearance,
                                    onClick: onClick,
                                    type: type,
                                    children: buttonChildren
                                }),
                                actions
                            ]
                        })
                    })
                ]
            }));
        }
    }, key);
}
const $220a9ff2417f42c4$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    forgeFormSubmitButtonText: {
        id: 'forge-ui.form.submit-button.text',
        defaultMessage: 'Submit',
        description: 'Text for a button for a user to submit their form input.'
    }
});

});
parcelRegister("h3mfa", function(module, exports) {
$parcel$export(module.exports, "transformFormValue", () => $90d8c27f50d8bd97$export$1a3c135ac4585aa9);
$parcel$export(module.exports, "transformFormData", () => $90d8c27f50d8bd97$export$d1360584b6d92fb7);
const $90d8c27f50d8bd97$var$isOptionData = (value)=>typeof value === 'object' && value.hasOwnProperty('value');
const $90d8c27f50d8bd97$var$isUserData = (value)=>typeof value === 'object' && value.hasOwnProperty('id') && value.hasOwnProperty('name') && value.hasOwnProperty('avatarUrl');
const $90d8c27f50d8bd97$export$1a3c135ac4585aa9 = (value)=>{
    if ($90d8c27f50d8bd97$var$isOptionData(value)) return value.value;
    else if ($90d8c27f50d8bd97$var$isUserData(value) && value.type === 'user') return value.id;
    return value;
};
const $90d8c27f50d8bd97$export$d1360584b6d92fb7 = (formData)=>Object.entries(formData).reduce((transformedData, [key, value])=>{
        return {
            ...transformedData,
            [key]: Array.isArray(value) ? value.map($90d8c27f50d8bd97$export$1a3c135ac4585aa9) : $90d8c27f50d8bd97$export$1a3c135ac4585aa9(value)
        };
    }, {});

});

parcelRegister("iWhr8", function(module, exports) {
$parcel$export(module.exports, "emotionInstance", () => $b0a5e279cfc566c2$export$6a54433420868a45);

var $cSkmB = parcelRequire("cSkmB");
const $b0a5e279cfc566c2$export$6a54433420868a45 = (0, $cSkmB.default)({
    key: 'ui-kit-css'
});

});
parcelRegister("cSkmB", function(module, exports) {
$parcel$export(module.exports, "default", () => $95fa52fa0531775a$export$2e2bcd8739ae039);

var $4Z5dY = parcelRequire("4Z5dY");

var $915ra = parcelRequire("915ra");

var $l5tKr = parcelRequire("l5tKr");
function $95fa52fa0531775a$var$insertWithoutScoping(cache, serialized) {
    if (cache.inserted[serialized.name] === undefined) return cache.insert('', serialized, cache.sheet, true);
}
function $95fa52fa0531775a$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $l5tKr.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $95fa52fa0531775a$var$createEmotion = function createEmotion(options) {
    var cache = (0, $4Z5dY.default)(options); // $FlowFixMe
    cache.sheet.speedy = function(value) {
        this.isSpeedy = value;
    };
    cache.compat = true;
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $915ra.serializeStyles)(args, cache.registered, undefined);
        (0, $l5tKr.insertStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var keyframes = function keyframes() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var serialized = (0, $915ra.serializeStyles)(args, cache.registered);
        var animation = "animation-" + serialized.name;
        $95fa52fa0531775a$var$insertWithoutScoping(cache, {
            name: serialized.name,
            styles: "@keyframes " + animation + "{" + serialized.styles + "}"
        });
        return animation;
    };
    var injectGlobal = function injectGlobal() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        var serialized = (0, $915ra.serializeStyles)(args, cache.registered);
        $95fa52fa0531775a$var$insertWithoutScoping(cache, serialized);
    };
    var cx = function cx() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return $95fa52fa0531775a$var$merge(cache.registered, css, $95fa52fa0531775a$var$classnames(args));
    };
    return {
        css: css,
        cx: cx,
        injectGlobal: injectGlobal,
        keyframes: keyframes,
        hydrate: function hydrate(ids) {
            ids.forEach(function(key) {
                cache.inserted[key] = true;
            });
        },
        flush: function flush() {
            cache.registered = {};
            cache.inserted = {};
            cache.sheet.flush();
        },
        // $FlowFixMe
        sheet: cache.sheet,
        cache: cache,
        getRegisteredStyles: (0, $l5tKr.getRegisteredStyles).bind(null, cache.registered),
        merge: $95fa52fa0531775a$var$merge.bind(null, cache.registered, css)
    };
};
var $95fa52fa0531775a$var$classnames = function classnames(args) {
    var cls = '';
    for(var i = 0; i < args.length; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
var $95fa52fa0531775a$export$2e2bcd8739ae039 = $95fa52fa0531775a$var$createEmotion;

});


parcelRegister("de5df", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("b9iN1").then(()=>parcelRequire('jdENA'));

});


parcelRegister("jytLP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("11LfB").then(()=>parcelRequire('8xiBH'));

});


parcelRegister("fAt8s", function(module, exports) {
$parcel$export(module.exports, "CodeFn", () => $01a55dc8611d9556$export$9f067e9ed3ed058);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eJOHy = parcelRequire("eJOHy");

var $7rgPd = parcelRequire("7rgPd");
function $01a55dc8611d9556$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $01a55dc8611d9556$var$styles = {
    name: "h0cvw5",
    styles: "width:'100%'"
};

const $01a55dc8611d9556$var$AKCodeBlock = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("Phpsi")).then((module)=>({
            AkCode: module.Code,
            AkCodeBlock: module.CodeBlock
        })).then((module)=>({
            default: module.AkCodeBlock
        })));

const $01a55dc8611d9556$var$AKCodeInline = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("Phpsi")).then((module)=>({
            AkCode: module.Code,
            AkCodeBlock: module.CodeBlock
        })).then((module)=>({
            default: module.AkCode
        })));
const $01a55dc8611d9556$var$Code = ({ text: text, language: language = 'text', showLineNumbers: showLineNumbers = true })=>{
    const { inline: inline } = (0, $7rgPd.useInlineContext)();
    return inline ? /*#__PURE__*/ (0, $1NIU8.jsx)($01a55dc8611d9556$var$AKCodeInline, null, text) : /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $01a55dc8611d9556$var$styles
    }, /*#__PURE__*/ (0, $1NIU8.jsx)($01a55dc8611d9556$var$AKCodeBlock, {
        text: text,
        language: language,
        showLineNumbers: showLineNumbers
    }));
};
var $01a55dc8611d9556$export$2e2bcd8739ae039 = $01a55dc8611d9556$var$Code;
const $01a55dc8611d9556$export$9f067e9ed3ed058 = ({ props: props })=>{
    const { text: text, language: language, showLineNumbers: showLineNumbers } = props;
    return /*#__PURE__*/ (0, $1NIU8.jsx)($01a55dc8611d9556$var$Code, {
        text: text,
        language: language,
        showLineNumbers: showLineNumbers
    });
};

});
parcelRegister("7rgPd", function(module, exports) {
$parcel$export(module.exports, "InlineContext", () => $c2e18797ba87c087$export$75ab56226e2d3efd);
$parcel$export(module.exports, "useInlineContext", () => $c2e18797ba87c087$export$3828d4e780bd54a);

var $eJOHy = parcelRequire("eJOHy");
const $c2e18797ba87c087$export$75ab56226e2d3efd = /*#__PURE__*/ (0, $eJOHy.createContext)({
    inline: false
});
const $c2e18797ba87c087$export$3828d4e780bd54a = ()=>(0, $eJOHy.useContext)($c2e18797ba87c087$export$75ab56226e2d3efd);

});

parcelRegister("Phpsi", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iAsK1").then(()=>parcelRequire('2acNi'));

});


parcelRegister("1DNCg", function(module, exports) {
$parcel$export(module.exports, "DateLozengeFn", () => $c47104143f668e90$export$607d2293d1fe73f9);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

const $c47104143f668e90$var$AkDateLozenge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("kXzGu")).then((module)=>({
            default: module.Date
        })));
const $c47104143f668e90$var$DateLozenge = ({ value: value })=>/*#__PURE__*/ (0, $gt9Am.jsx)($c47104143f668e90$var$AkDateLozenge, {
        value: value
    });
var $c47104143f668e90$export$2e2bcd8739ae039 = $c47104143f668e90$var$DateLozenge;
const $c47104143f668e90$export$607d2293d1fe73f9 = ({ props: props })=>{
    const { value: value } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)($c47104143f668e90$var$DateLozenge, {
        value: value
    });
};

});
parcelRegister("kXzGu", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cfi6w").then(()=>parcelRequire('cUJcf'));

});


parcelRegister("gD6OG", function(module, exports) {
$parcel$export(module.exports, "DatePickerFn", () => $8093bd526dc264b5$export$946840bece97c37);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eJOHy = parcelRequire("eJOHy");

var $i3v3M = parcelRequire("i3v3M");

var $8rPev = parcelRequire("8rPev");

const $8093bd526dc264b5$var$AKDatePicker = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("4sBQU")).then((module)=>({
            default: module.DatePicker
        })));

const $8093bd526dc264b5$var$AKField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("de5df")).then((module)=>({
            default: module.Field
        })));

const $8093bd526dc264b5$var$AKHelperMessage = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("de5df")).then((module)=>({
            default: module.HelperMessage
        })));

const $8093bd526dc264b5$var$AKErrorMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("de5df")).then((module)=>({
            default: module.ErrorMessage
        })));
const $8093bd526dc264b5$var$validate = (value)=>!value ? 'EMPTY' : undefined;
const $8093bd526dc264b5$export$fa96065c64444af6 = (locale)=>{
    const formatObj = new Intl.DateTimeFormat(locale).formatToParts(new Date());
    return formatObj.map((obj)=>{
        switch(obj.type){
            case 'day':
                return 'DD';
            case 'month':
                return 'MM';
            case 'year':
                return 'YYYY';
            default:
                return obj.value;
        }
    }).join('');
};
const $8093bd526dc264b5$var$DatePicker = ({ name: name, label: label, description: description, placeholder: placeholder, defaultValue: defaultValue, isRequired: isRequired })=>{
    const [locale, setLocale] = (0, $eJOHy.useState)('en-US');
    (0, $eJOHy.useEffect)(()=>{
        if (window.navigator.languages && locale !== window.navigator.languages[0]) setLocale(window.navigator.languages[0]);
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8rPev.FieldContainer), null, /*#__PURE__*/ (0, $1NIU8.jsx)($8093bd526dc264b5$var$AKField, {
        name: name,
        label: label,
        defaultValue: defaultValue,
        isRequired: isRequired,
        validate: isRequired ? $8093bd526dc264b5$var$validate : undefined
    }, ({ fieldProps: fieldProps, error: error })=>{
        const { id: id, isDisabled: isDisabled, isInvalid: isInvalid, onBlur: onBlur, onChange: onChange, onFocus: onFocus, 'aria-invalid': ariaInvalid, 'aria-labelledby': ariaLabelledBy } = fieldProps;
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $i3v3M.FormStateChangeNotifier), {
            name: name,
            value: fieldProps.value
        }), /*#__PURE__*/ (0, $1NIU8.jsx)($8093bd526dc264b5$var$AKDatePicker, {
            id: id,
            isDisabled: isDisabled,
            onBlur: onBlur,
            onFocus: onFocus,
            onChange: onChange,
            value: fieldProps.value || '',
            placeholder: placeholder,
            dateFormat: $8093bd526dc264b5$export$fa96065c64444af6(locale),
            isInvalid: isInvalid || Boolean(error),
            "aria-invalid": ariaInvalid,
            "aria-labelledby": ariaLabelledBy
        }), error === 'EMPTY' && /*#__PURE__*/ (0, $1NIU8.jsx)($8093bd526dc264b5$var$AKErrorMessage, null, "This field is required."), description && /*#__PURE__*/ (0, $1NIU8.jsx)($8093bd526dc264b5$var$AKHelperMessage, null, description));
    }));
};
var $8093bd526dc264b5$export$2e2bcd8739ae039 = $8093bd526dc264b5$var$DatePicker;
const $8093bd526dc264b5$export$946840bece97c37 = ({ props: props })=>{
    const { name: name, label: label, defaultValue: defaultValue, description: description, placeholder: placeholder, isRequired: isRequired } = props;
    return /*#__PURE__*/ (0, $1NIU8.jsx)($8093bd526dc264b5$var$DatePicker, {
        name: name,
        label: label,
        defaultValue: defaultValue,
        description: description,
        placeholder: placeholder,
        isRequired: isRequired
    });
};

});
parcelRegister("8rPev", function(module, exports) {
$parcel$export(module.exports, "FieldContainer", () => $719fa3b4cdf5bd6b$export$b5c4b0e7cd7f148b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $719fa3b4cdf5bd6b$var$boxStyles = (0, $1DXK0.xcss)({
    maxWidth: '100%',
    width: '320px'
});
const $719fa3b4cdf5bd6b$export$b5c4b0e7cd7f148b = (props)=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8nu6j.default), {
        xcss: $719fa3b4cdf5bd6b$var$boxStyles
    }, props.children);
};

});

parcelRegister("4sBQU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4LWHc").then(()=>parcelRequire('3oO6V'));

});


parcelRegister("2SqlQ", function(module, exports) {
$parcel$export(module.exports, "FormConditionFn", () => $4386cbd4270b6e27$export$5063d3d804b7f0da);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $h3mfa = parcelRequire("h3mfa");

var $i3v3M = parcelRequire("i3v3M");
const $4386cbd4270b6e27$var$isEqual = (first, second)=>{
    if (first === second) return true;
    if (Array.isArray(first) && Array.isArray(second)) return first.sort().toString() === second.sort().toString();
    return false;
};
const $4386cbd4270b6e27$var$FormCondition = ({ when: when, is: is, areChildrenPersisted: areChildrenPersisted = false, children: children })=>{
    const formContext = (0, $eJOHy.useContext)((0, $i3v3M.FormContext));
    const shouldShowChildren = $4386cbd4270b6e27$var$isEqual((0, $h3mfa.transformFormValue)(formContext?.formValues[when]), is);
    if (areChildrenPersisted) return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $1NIU8.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: shouldShowChildren ? 'block' : 'none'
        })
    }, children);
    else return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, shouldShowChildren ? children : null);
};
var $4386cbd4270b6e27$export$2e2bcd8739ae039 = $4386cbd4270b6e27$var$FormCondition;
const $4386cbd4270b6e27$export$5063d3d804b7f0da = ({ props: props, children: children, Components: Components, dispatch: dispatch, render: render, renderChildren: renderChildren })=>{
    const { when: when, is: is, areChildrenPersisted: areChildrenPersisted } = props;
    return /*#__PURE__*/ (0, $1NIU8.jsx)($4386cbd4270b6e27$var$FormCondition, {
        when: when,
        is: is,
        areChildrenPersisted: areChildrenPersisted
    }, renderChildren({
        children: children,
        render: render,
        dispatch: dispatch,
        Components: Components
    }));
};

});

parcelRegister("ljqGl", function(module, exports) {
$parcel$export(module.exports, "ImageFn", () => $4598d134f4cccca2$export$f62f254e0954ca34);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $MyJAf = parcelRequire("MyJAf");

var $1gAFw = parcelRequire("1gAFw");
const $4598d134f4cccca2$export$baab7c95ad93ac5a = {
    xsmall: '25%',
    small: '37.5%',
    medium: '50%',
    large: '75%',
    xlarge: '100%'
};
function $4598d134f4cccca2$export$2e2bcd8739ae039({ src: src, alt: alt, size: size = 'xlarge' }) {
    const maxWidth = $4598d134f4cccca2$export$baab7c95ad93ac5a[size] || '100%';
    return /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 'auto',
            maxWidth: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            maxWidth,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            textAlign: 'center'
        },
        src: src,
        alt: alt
    });
}
const $4598d134f4cccca2$export$f62f254e0954ca34 = ({ props: props })=>{
    const { src: src, alt: alt, size: size } = props;
    const isValidUrl = (0, $1gAFw.useIsValidImageUrl)(src);
    if (isValidUrl) return /*#__PURE__*/ (0, $gt9Am.jsx)($4598d134f4cccca2$export$2e2bcd8739ae039, {
        src: src,
        alt: alt,
        size: size
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $MyJAf.EgressErrorMessage), {
        url: src
    });
};

});
parcelRegister("MyJAf", function(module, exports) {
$parcel$export(module.exports, "EgressErrorMessage", () => $71e250628e5248ab$export$5cfbc54f19d7d1a4);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kpjEk = parcelRequire("kpjEk");

var $5qJVF = parcelRequire("5qJVF");

var $iHPvF = parcelRequire("iHPvF");

var $eJ9f5 = parcelRequire("eJ9f5");
const $71e250628e5248ab$export$5cfbc54f19d7d1a4 = ({ url: url })=>{
    const { forgeEnvironment: forgeEnvironment } = (0, $eJOHy.useContext)((0, $kpjEk.RendererContext));
    const dataUriRegex = /^data/;
    const isDataUri = dataUriRegex.test(url);
    if (forgeEnvironment === 'DEVELOPMENT') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iHPvF.default), {
        appearance: "error",
        testId: "egress-error-message",
        children: isDataUri ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $5qJVF.default), {
            children: [
                "Please use the ",
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                    as: "strong",
                    children: "data:image"
                }),
                " scheme for an image source."
            ]
        }) : /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $5qJVF.default), {
            children: [
                "Egress permissions for",
                ' ',
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ9f5.default), {
                    href: url,
                    target: "_blank",
                    children: url
                }),
                ' ',
                "missing in the manifest. For more information",
                ' ',
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ9f5.default), {
                    href: "https://developer.atlassian.com/platform/forge/manifest-reference/permissions/#images",
                    target: "_blank",
                    children: "see reference docs"
                }),
                "."
            ]
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iHPvF.default), {
        appearance: "error",
        children: "Unable to display due to an image link issue."
    });
};

});

parcelRegister("1gAFw", function(module, exports) {
$parcel$export(module.exports, "useIsValidImageUrl", () => $5b60ba36ea4be0ca$export$3a08b61b3ed9a4da);
$parcel$export(module.exports, "isValidImageUrl", () => $5b60ba36ea4be0ca$export$6e0a24fd7459483a);

var $eJOHy = parcelRequire("eJOHy");

var $lopBx = parcelRequire("lopBx");
var $7pw1V = parcelRequire("7pw1V");
parcelRequire("1B59H");
var $bMVUa = parcelRequire("bMVUa");

var $dRcl3 = parcelRequire("dRcl3");

var $83IbI = parcelRequire("83IbI");
var $kpjEk = parcelRequire("kpjEk");

var $aD1DH = parcelRequire("aD1DH");

var $eGOwo = parcelRequire("eGOwo");

var $14k9p = parcelRequire("14k9p");
// --------------------------------------------------------------------------------------------------------------------
//
// NOTE: any changes to these hosts MUST BE applied to the Forge Monorepo -- and vice versa.
// See packages/forge-csp/src/csp/csp-injection-service.ts for the original source code.
//
// --------------------------------------------------------------------------------------------------------------------
/**
 * Media API is used to store product attachments.
 * URLs are defined here: https://developer.atlassian.com/platform/media/support/faq/#which-environment-should-i-use-
 */ const $5b60ba36ea4be0ca$var$ATLASSIAN_API_GATEWAY_HOST = {
    dev: 'https://api.dev.atlassian.com',
    stg: 'https://api.stg.atlassian.com',
    prod: 'https://api.atlassian.com',
    'fedramp-stg': 'https://api.stg.atlassian-us-gov-mod.com',
    'fedramp-prod': 'https://api.atlassian-us-gov-mod.com'
};
const $5b60ba36ea4be0ca$var$ATLASSIAN_MEDIA_GATEWAY_HOST = {
    dev: 'https://media.dev.atl-paas.net',
    stg: 'https://media.staging.atl-paas.net',
    prod: 'https://api.media.atlassian.com',
    'fedramp-stg': 'https://api-media.stg.atlassian-us-gov-mod.com',
    'fedramp-prod': 'https://api-media.atlassian-us-gov-mod.com'
};
const $5b60ba36ea4be0ca$var$ATLASSIAN_AVATAR_HOST = {
    dev: 'avatar-management--avatars.us-west-2.staging.public.atl-paas.net',
    stg: 'avatar-management--avatars.us-west-2.staging.public.atl-paas.net',
    prod: 'avatar-management--avatars.us-west-2.prod.public.atl-paas.net',
    'fedramp-stg': 'avatar-management--avatars.us-east-1.staging.cdn.atlassian-us-gov-mod.com',
    'fedramp-prod': 'avatar-management--avatars.us-east-1.prod.cdn.atlassian-us-gov-mod.com'
};
const $5b60ba36ea4be0ca$var$ATLASSIAN_EMOJIS_HOST = {
    dev: 'https://pf-emoji-service--cdn.ap-southeast-2.dev.public.atl-paas.net',
    stg: 'https://pf-emoji-service--cdn.us-east-1.staging.public.atl-paas.net',
    prod: 'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net',
    'fedramp-stg': 'https://pf-emoji-service--cdn.us-east-1.staging.cdn.atlassian-us-gov-mod.com',
    'fedramp-prod': 'https://pf-emoji-service--cdn.us-east-1.prod.cdn.atlassian-us-gov-mod.com'
};
const $5b60ba36ea4be0ca$var$ATLASSIAN_TEAM_HEADER_HOST = {
    dev: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/gradients/',
    stg: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/gradients/',
    prod: 'https://teams-directory-frontend.prod-east.frontend.public.atl-paas.net/assets/gradients/',
    'fedramp-stg': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/',
    'fedramp-prod': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/'
};
const $5b60ba36ea4be0ca$var$ATLASSIAN_TEAM_AVATAR_HOST = {
    dev: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/',
    stg: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/',
    prod: 'https://teams-directory-frontend.prod-east.frontend.public.atl-paas.net/assets/',
    'fedramp-stg': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/',
    'fedramp-prod': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/'
};
const $5b60ba36ea4be0ca$var$ATLASSIAN_FOS_HOST = {
    dev: 'https://tdp-os.dev.services.atlassian.com',
    stg: 'https://tdp-os.stg.services.atlassian.com',
    prod: 'https://tdp-os.services.atlassian.com',
    'fedramp-stg': 'https://tdp-os.stg.services.atlassian-us-gov-mod.com',
    'fedramp-prod': 'https://tdp-os.services.atlassian-us-gov-mod.com'
};
const $5b60ba36ea4be0ca$var$getFOSHosts = (env)=>[
        `${$5b60ba36ea4be0ca$var$ATLASSIAN_FOS_HOST[env]}/fos-eap/download/*`,
        `${$5b60ba36ea4be0ca$var$ATLASSIAN_FOS_HOST[env]}/fop/app/download/*`,
        `${$5b60ba36ea4be0ca$var$ATLASSIAN_FOS_HOST[env]}/fop/cdn/download/*`
    ];
/**
 * Atlassian products use Wordpress as a proxy to serve avatar images in certain conditions.
 * Not allowing them by default forces developers to add the `*.wp.com` domain to the CSP image policy.
 * See: https://hello.atlassian.net/wiki/x/XJpuCgE
 */ const $5b60ba36ea4be0ca$var$ATLASSIAN_IMAGES_HOSTS = {
    dev: [
        `https://${$5b60ba36ea4be0ca$var$ATLASSIAN_AVATAR_HOST['dev']}`,
        `https://*.wp.com/${$5b60ba36ea4be0ca$var$ATLASSIAN_AVATAR_HOST['dev']}/`,
        $5b60ba36ea4be0ca$var$ATLASSIAN_API_GATEWAY_HOST['dev'],
        $5b60ba36ea4be0ca$var$ATLASSIAN_MEDIA_GATEWAY_HOST['dev'],
        $5b60ba36ea4be0ca$var$ATLASSIAN_EMOJIS_HOST['dev'],
        $5b60ba36ea4be0ca$var$ATLASSIAN_TEAM_AVATAR_HOST['dev'],
        $5b60ba36ea4be0ca$var$ATLASSIAN_TEAM_HEADER_HOST['dev']
    ],
    stg: [
        `https://${$5b60ba36ea4be0ca$var$ATLASSIAN_AVATAR_HOST['stg']}`,
        `https://*.wp.com/${$5b60ba36ea4be0ca$var$ATLASSIAN_AVATAR_HOST['stg']}/`,
        $5b60ba36ea4be0ca$var$ATLASSIAN_API_GATEWAY_HOST['stg'],
        $5b60ba36ea4be0ca$var$ATLASSIAN_MEDIA_GATEWAY_HOST['stg'],
        $5b60ba36ea4be0ca$var$ATLASSIAN_EMOJIS_HOST['stg'],
        $5b60ba36ea4be0ca$var$ATLASSIAN_TEAM_AVATAR_HOST['stg'],
        $5b60ba36ea4be0ca$var$ATLASSIAN_TEAM_HEADER_HOST['stg']
    ],
    prod: [
        `https://${$5b60ba36ea4be0ca$var$ATLASSIAN_AVATAR_HOST['prod']}`,
        `https://*.wp.com/${$5b60ba36ea4be0ca$var$ATLASSIAN_AVATAR_HOST['prod']}/`,
        $5b60ba36ea4be0ca$var$ATLASSIAN_API_GATEWAY_HOST['prod'],
        $5b60ba36ea4be0ca$var$ATLASSIAN_MEDIA_GATEWAY_HOST['prod'],
        $5b60ba36ea4be0ca$var$ATLASSIAN_EMOJIS_HOST['prod'],
        $5b60ba36ea4be0ca$var$ATLASSIAN_TEAM_AVATAR_HOST['prod'],
        $5b60ba36ea4be0ca$var$ATLASSIAN_TEAM_HEADER_HOST['prod']
    ],
    'fedramp-stg': [
        `https://${$5b60ba36ea4be0ca$var$ATLASSIAN_AVATAR_HOST['fedramp-stg']}`,
        `https://*.wp.com/${$5b60ba36ea4be0ca$var$ATLASSIAN_AVATAR_HOST['fedramp-stg']}/`,
        $5b60ba36ea4be0ca$var$ATLASSIAN_API_GATEWAY_HOST['fedramp-stg'],
        $5b60ba36ea4be0ca$var$ATLASSIAN_MEDIA_GATEWAY_HOST['fedramp-stg'],
        $5b60ba36ea4be0ca$var$ATLASSIAN_EMOJIS_HOST['fedramp-stg'],
        $5b60ba36ea4be0ca$var$ATLASSIAN_TEAM_AVATAR_HOST['fedramp-stg'],
        $5b60ba36ea4be0ca$var$ATLASSIAN_TEAM_HEADER_HOST['fedramp-stg']
    ],
    'fedramp-prod': [
        `https://${$5b60ba36ea4be0ca$var$ATLASSIAN_AVATAR_HOST['fedramp-prod']}`,
        `https://*.wp.com/${$5b60ba36ea4be0ca$var$ATLASSIAN_AVATAR_HOST['fedramp-prod']}/`,
        $5b60ba36ea4be0ca$var$ATLASSIAN_API_GATEWAY_HOST['fedramp-prod'],
        $5b60ba36ea4be0ca$var$ATLASSIAN_MEDIA_GATEWAY_HOST['fedramp-prod'],
        $5b60ba36ea4be0ca$var$ATLASSIAN_EMOJIS_HOST['fedramp-prod'],
        $5b60ba36ea4be0ca$var$ATLASSIAN_TEAM_AVATAR_HOST['fedramp-prod'],
        $5b60ba36ea4be0ca$var$ATLASSIAN_TEAM_HEADER_HOST['fedramp-prod']
    ]
};
// --------------------------------------------------------------------------------------------------------------------
/**
 * Gravatar is still used internally to serve legacy Atlassian avatars.
 * Unsplash is integrated by default in Confluence to the header image picker functionality.
 */ const $5b60ba36ea4be0ca$var$EXTERNAL_ALLOW_LISTED_IMAGES_HOSTS = [
    'https://secure.gravatar.com',
    'https://images.unsplash.com'
];
const $5b60ba36ea4be0ca$export$189ea7794c50ff15 = (url, iframeDomainName)=>{
    if (!iframeDomainName) return false;
    let imageSrcUrl;
    try {
        imageSrcUrl = new URL(url);
        // Image is valid if it comes from the same domain as the iframe OR if it's being served from localhost (when using forge tunnel)
        return iframeDomainName === imageSrcUrl.host || imageSrcUrl.hostname === 'localhost';
    } catch (e) {
        return false;
    }
};
const $5b60ba36ea4be0ca$var$getImageHostsEnvironment = (environment)=>{
    if ((0, $lopBx.isFedRamp)()) {
        if (environment === (0, $bMVUa.ProductEnvironment).STAGING) return 'fedramp-stg';
        return 'fedramp-prod';
    }
    return (0, $aD1DH.getCDNEnvironment)(environment);
};
const $5b60ba36ea4be0ca$var$getImageHostsEnvironmentForIC = (environment)=>{
    return environment === (0, $bMVUa.ProductEnvironment).PRODUCTION ? 'ic-prod' : 'ic-stg';
};
const $5b60ba36ea4be0ca$var$getAtlassianImageHosts = (environment)=>{
    if ((0, $eGOwo.fg)('forge-ui-oasis-enabled')) {
        if ((0, $7pw1V.isIsolatedCloud)()) {
            const icImageHostsEnvironment = $5b60ba36ea4be0ca$var$getImageHostsEnvironmentForIC(environment);
            return (0, $14k9p.getAtlassianImageHost)(icImageHostsEnvironment, {
                getICDomain: ()=>(0, $7pw1V.isolatedCloudDomain)()
            });
        }
        const imageHostsEnvironment = $5b60ba36ea4be0ca$var$getImageHostsEnvironment(environment);
        return (0, $14k9p.getAtlassianImageHost)(imageHostsEnvironment);
    }
    return $5b60ba36ea4be0ca$var$getAtlassianImageHostsForCommercialAndFedRamp(environment);
};
const $5b60ba36ea4be0ca$var$getAtlassianImageHostsForCommercialAndFedRamp = (environment)=>{
    const imageHostsEnvironment = $5b60ba36ea4be0ca$var$getImageHostsEnvironment(environment);
    return [
        ...$5b60ba36ea4be0ca$var$ATLASSIAN_IMAGES_HOSTS[imageHostsEnvironment],
        ...(0, $eGOwo.fg)('add-fos-hosts-to-valid-image-urls') ? $5b60ba36ea4be0ca$var$getFOSHosts(imageHostsEnvironment) : []
    ];
};
const $5b60ba36ea4be0ca$export$3a08b61b3ed9a4da = (url)=>{
    const { egress: egress, appDomainName: appDomainName } = (0, $eJOHy.useContext)((0, $kpjEk.RendererContext));
    const environment = (0, $eJOHy.useContext)((0, $83IbI.EnvironmentContext));
    const allowListedImageHosts = [
        window.location.hostname,
        ...$5b60ba36ea4be0ca$var$getAtlassianImageHosts(environment),
        ...$5b60ba36ea4be0ca$var$EXTERNAL_ALLOW_LISTED_IMAGES_HOSTS
    ];
    const egressService = (0, $dRcl3.useEgressPermissionService)('IMAGES', [
        ...egress || [],
        {
            type: 'IMAGES',
            addresses: allowListedImageHosts
        }
    ]);
    return $5b60ba36ea4be0ca$export$6e0a24fd7459483a(url, egressService, appDomainName);
};
const $5b60ba36ea4be0ca$export$6e0a24fd7459483a = (url, egressService, appDomainName)=>{
    const dataImageUrlRegex = /^data:image/;
    try {
        const isValidUrl = $5b60ba36ea4be0ca$export$189ea7794c50ff15(url, appDomainName) || dataImageUrlRegex.test(url) || egressService.isValidUrl(url);
        return isValidUrl;
    } catch (e) {
        return false;
    }
};

});
parcelRegister("14k9p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dnskZ = parcelRequire("dnskZ");

$dnskZ.__exportStar((parcelRequire("fvzJk")), module.exports);

$dnskZ.__exportStar((parcelRequire("iwjLL")), module.exports);

});
parcelRegister("fvzJk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dnskZ = parcelRequire("dnskZ");

$dnskZ.__exportStar((parcelRequire("dsMvo")), module.exports);

$dnskZ.__exportStar((parcelRequire("anNhY")), module.exports);

});
parcelRegister("dsMvo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CSPInjectionService = module.exports.EXTERNAL_ALLOW_LISTED_IMAGES_HOSTS = module.exports.getAtlassianImageHost = void 0;

var $iwjLL = parcelRequire("iwjLL");
const $9cd384078b5f912f$var$isICEnvKey = (env)=>env === 'ic-prod' || env === 'ic-stg';
const $9cd384078b5f912f$var$makeICDomain = (env, icLabel)=>`${icLabel}.${env === 'ic-prod' ? 'atlassian-isolated.net' : 'oasis-stg.com'}`;
const $9cd384078b5f912f$var$getICDomain = (env, icOptions)=>{
    if ('getICDomain' in icOptions) return icOptions.getICDomain();
    return $9cd384078b5f912f$var$makeICDomain(env, icOptions.icLabel);
};
const $9cd384078b5f912f$var$makeICHosts = (targetHostFunction)=>{
    return {
        'ic-stg': (icOptions)=>targetHostFunction('ic-stg', icOptions),
        'ic-prod': (icOptions)=>targetHostFunction('ic-prod', icOptions)
    };
};
const $9cd384078b5f912f$var$ATLASSIAN_HOST = {
    ATLASSIAN_API_GATEWAY_HOST: {
        dev: 'https://api.dev.atlassian.com',
        stg: 'https://api.stg.atlassian.com',
        prod: 'https://api.atlassian.com',
        'fedramp-stg': 'https://api.stg.atlassian-us-gov-mod.com',
        'fedramp-prod': 'https://api.atlassian-us-gov-mod.com',
        ...$9cd384078b5f912f$var$makeICHosts((env, icOptions)=>`https://api.${$9cd384078b5f912f$var$getICDomain(env, icOptions)}`)
    },
    ATLASSIAN_MEDIA_GATEWAY_HOST: {
        dev: 'https://media.dev.atl-paas.net',
        stg: 'https://media.staging.atl-paas.net',
        prod: 'https://api.media.atlassian.com',
        'fedramp-stg': 'https://api-media.stg.atlassian-us-gov-mod.com',
        'fedramp-prod': 'https://api-media.atlassian-us-gov-mod.com',
        ...$9cd384078b5f912f$var$makeICHosts((env, icOptions)=>`https://media-api.${$9cd384078b5f912f$var$getICDomain(env, icOptions)}`)
    },
    ATLASSIAN_AVATAR_HOST: {
        dev: 'avatar-management--avatars.us-west-2.staging.public.atl-paas.net',
        stg: 'avatar-management--avatars.us-west-2.staging.public.atl-paas.net',
        prod: 'avatar-management--avatars.us-west-2.prod.public.atl-paas.net',
        'fedramp-stg': 'avatar-management--avatars.us-east-1.staging.cdn.atlassian-us-gov-mod.com',
        'fedramp-prod': 'avatar-management--avatars.us-east-1.prod.cdn.atlassian-us-gov-mod.com',
        'ic-stg': (_icOptions)=>'avatar-management--avatars.us-west-2.staging.public.atl-paas.net',
        'ic-prod': (_icOptions)=>'avatar-management--avatars.us-west-2.prod.public.atl-paas.net'
    },
    ATLASSIAN_TEAM_HEADER_HOST: {
        dev: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/gradients/',
        stg: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/gradients/',
        prod: 'https://teams-directory-frontend.prod-east.frontend.public.atl-paas.net/assets/gradients/',
        'fedramp-stg': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/',
        'fedramp-prod': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/',
        ...$9cd384078b5f912f$var$makeICHosts((env, icOptions)=>`https://teams-directory-frontend.services.${$9cd384078b5f912f$var$getICDomain(env, icOptions)}/bfa/`)
    },
    ATLASSIAN_TEAM_AVATAR_HOST: {
        dev: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/',
        stg: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/',
        prod: 'https://teams-directory-frontend.prod-east.frontend.public.atl-paas.net/assets/',
        'fedramp-stg': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/',
        'fedramp-prod': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/',
        ...$9cd384078b5f912f$var$makeICHosts((env, icOptions)=>`https://teams-directory-frontend.services.${$9cd384078b5f912f$var$getICDomain(env, icOptions)}/bfa/`)
    },
    ATLASSIAN_EMOJIS_HOST: {
        dev: 'https://pf-emoji-service--cdn.ap-southeast-2.dev.public.atl-paas.net',
        stg: 'https://pf-emoji-service--cdn.us-east-1.staging.public.atl-paas.net',
        prod: 'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net',
        'fedramp-stg': 'https://pf-emoji-service--cdn.us-east-1.staging.cdn.atlassian-us-gov-mod.com',
        'fedramp-prod': 'https://pf-emoji-service--cdn.us-east-1.prod.cdn.atlassian-us-gov-mod.com',
        ...$9cd384078b5f912f$var$makeICHosts((env, icOptions)=>`https://pf-emoji-service.${$9cd384078b5f912f$var$getICDomain(env, icOptions)}`)
    }
};
const $9cd384078b5f912f$var$getAtlassianHost = (hostType, microsEnv, icOptions)=>{
    const hostMap = $9cd384078b5f912f$var$ATLASSIAN_HOST[hostType];
    if ($9cd384078b5f912f$var$isICEnvKey(microsEnv)) {
        if (!icOptions) throw new Error('Missing IC label');
        return hostMap[microsEnv](icOptions);
    }
    return hostMap[microsEnv];
};
const $9cd384078b5f912f$var$getAtlassianImageHost = (microsEnv, icOptions)=>{
    return [
        `https://${$9cd384078b5f912f$var$getAtlassianHost('ATLASSIAN_AVATAR_HOST', microsEnv, icOptions)}`,
        `https://*.wp.com/${$9cd384078b5f912f$var$getAtlassianHost('ATLASSIAN_AVATAR_HOST', microsEnv, icOptions)}/`,
        $9cd384078b5f912f$var$getAtlassianHost('ATLASSIAN_API_GATEWAY_HOST', microsEnv, icOptions),
        $9cd384078b5f912f$var$getAtlassianHost('ATLASSIAN_MEDIA_GATEWAY_HOST', microsEnv, icOptions),
        $9cd384078b5f912f$var$getAtlassianHost('ATLASSIAN_EMOJIS_HOST', microsEnv, icOptions),
        $9cd384078b5f912f$var$getAtlassianHost('ATLASSIAN_TEAM_AVATAR_HOST', microsEnv, icOptions),
        $9cd384078b5f912f$var$getAtlassianHost('ATLASSIAN_TEAM_HEADER_HOST', microsEnv, icOptions)
    ];
};
module.exports.getAtlassianImageHost = $9cd384078b5f912f$var$getAtlassianImageHost;
module.exports.EXTERNAL_ALLOW_LISTED_IMAGES_HOSTS = [
    'https://secure.gravatar.com',
    'https://images.unsplash.com'
];
class $9cd384078b5f912f$var$CSPInjectionService {
    constructor(){
        this.getInjectableCSP = ({ existingCSPDetails: existingCSPDetails, microsEnv: microsEnv, tunnelCSPReporterUri: tunnelCSPReporterUri, hostname: hostname, isFedRAMP: isFedRAMP, icOptions: icOptions })=>{
            const reportUri = tunnelCSPReporterUri || this.getCSPReportUri(microsEnv, icOptions);
            const defaultSrc = `'self'`;
            const frameAncestors = [
                "'self'",
                ...this.getFrameAncestors(microsEnv, hostname, icOptions)
            ].join(' ');
            const frameSrc = [
                "'self'",
                hostname,
                ...this.getExistingCSPDetails($iwjLL.ExternalCspType.FRAME_SRC, existingCSPDetails)
            ].filter((a)=>a).join(' ');
            const fontSrc = [
                "'self'",
                ...this.getExistingCSPDetails($iwjLL.ExternalCspType.FONT_SRC, existingCSPDetails)
            ].join(' ');
            const imgSrc = [
                "'self'",
                'data:',
                'blob:',
                hostname,
                ...module.exports.EXTERNAL_ALLOW_LISTED_IMAGES_HOSTS,
                ...(0, module.exports.getAtlassianImageHost)(microsEnv, icOptions),
                ...this.getExistingCSPDetails($iwjLL.ExternalCspType.IMG_SRC, existingCSPDetails)
            ].filter((a)=>a).join(' ');
            const mediaSrc = [
                "'self'",
                'data:',
                'blob:',
                hostname,
                $9cd384078b5f912f$var$getAtlassianHost('ATLASSIAN_MEDIA_GATEWAY_HOST', microsEnv, icOptions),
                ...this.getExistingCSPDetails($iwjLL.ExternalCspType.MEDIA_SRC, existingCSPDetails)
            ].filter((a)=>a).join(' ');
            const connectSrc = [
                "'self'",
                ...this.getConnectSrc(microsEnv, !!tunnelCSPReporterUri, icOptions),
                ...this.getExistingCSPDetails($iwjLL.ExternalCspType.CONNECT_SRC, existingCSPDetails)
            ].join(' ');
            const scriptSrc = [
                "'self'",
                this.getForgeGlobalCSP(microsEnv, isFedRAMP, icOptions),
                ...this.getExistingCSPDetails($iwjLL.ExternalCspType.SCRIPT_SRC, existingCSPDetails)
            ].join(' ');
            const styleSrc = [
                "'self'",
                this.getForgeGlobalCSP(microsEnv, isFedRAMP, icOptions),
                ...this.getExistingCSPDetails($iwjLL.ExternalCspType.STYLE_SRC, existingCSPDetails)
            ].join(' ');
            return [
                `default-src ${defaultSrc}`,
                `frame-ancestors ${frameAncestors}`,
                `frame-src ${frameSrc}`,
                `font-src ${fontSrc}`,
                `img-src ${imgSrc}`,
                `media-src ${mediaSrc}`,
                `connect-src ${connectSrc}`,
                `script-src ${scriptSrc}`,
                `style-src ${styleSrc}`,
                `form-action 'self'`,
                `sandbox allow-popups allow-popups-to-escape-sandbox allow-downloads allow-forms allow-modals allow-pointer-lock allow-same-origin allow-scripts`,
                `report-uri ${reportUri}`
            ];
        };
    }
    getCSPReportUri(microsEnv, icOptions) {
        const serviceName = $9cd384078b5f912f$var$isICEnvKey(microsEnv) && icOptions ? icOptions.serviceName : 'forge-cdn';
        if (microsEnv === 'dev' || microsEnv === 'stg') return `https://web-security-reports.stg.services.atlassian.com/csp-report/${serviceName}`;
        return `https://web-security-reports.services.atlassian.com/csp-report/${serviceName}`;
    }
    getForgeGlobalCSP(microsEnv, isFedRAMP = false, icOptions) {
        if ($9cd384078b5f912f$var$isICEnvKey(microsEnv) && icOptions) return `https://forge.forge-cdn.${$9cd384078b5f912f$var$getICDomain(microsEnv, icOptions)}`;
        return isFedRAMP ? `https://forge.cdn.${microsEnv.split('-')[1]}.atlassian-dev-us-gov-mod.net` : `https://forge.cdn.${microsEnv}.atlassian-dev.net`;
    }
    getMetalClientCSP(microsEnv, icOptions) {
        if ($9cd384078b5f912f$var$isICEnvKey(microsEnv) && icOptions) return `https://api.${$9cd384078b5f912f$var$getICDomain(microsEnv, icOptions)}/metal/ingest`;
        return `https://api.${microsEnv === 'prod' ? '' : 'stg.'}atlassian.com/metal/ingest`;
    }
    getExistingCSPDetails(cspType, cspDetails) {
        var _a;
        return (_a = cspDetails[cspType]) !== null && _a !== void 0 ? _a : [];
    }
    getConnectSrc(microsEnv, isTunnelling, icOptions) {
        const allowed = [];
        if (isTunnelling) allowed.push(...[
            'ws://localhost:*',
            'http://localhost:*'
        ]);
        const metalClientCSP = this.getMetalClientCSP(microsEnv, icOptions);
        allowed.push(metalClientCSP);
        allowed.push(`${$9cd384078b5f912f$var$getAtlassianHost('ATLASSIAN_API_GATEWAY_HOST', microsEnv, icOptions)}/gateway/api/emoji/`);
        allowed.push($9cd384078b5f912f$var$getAtlassianHost('ATLASSIAN_MEDIA_GATEWAY_HOST', microsEnv, icOptions));
        return allowed;
    }
    getFrameAncestors(microsEnv, hostname, icOptions) {
        let frameAncestors = [];
        switch(microsEnv){
            case 'dev':
            case 'stg':
                frameAncestors = [
                    '*.jira-dev.com',
                    'http://localhost:*',
                    'http://devbucket.localhost',
                    'https://integration.bb-inf.net',
                    '*.atl-paas.net',
                    '*.stg.atlassian.com'
                ];
                break;
            case 'fedramp-stg':
                frameAncestors = [
                    '*.atlassian-stg-fedm.net'
                ];
                break;
            case 'fedramp-prod':
                frameAncestors = [
                    '*.atlassian-us-gov-mod.net'
                ];
                break;
            case 'ic-stg':
            case 'ic-prod':
                if (icOptions) frameAncestors = [
                    `*.${$9cd384078b5f912f$var$getICDomain(microsEnv, icOptions)}`
                ];
                break;
            case 'prod':
            default:
                frameAncestors = [
                    '*.atlassian.net',
                    'bitbucket.org',
                    '*.jira.com',
                    '*.atlassian.com',
                    '*.frontend.public.atl-paas.net'
                ];
                break;
        }
        if (hostname) frameAncestors.push(hostname);
        return frameAncestors;
    }
}
module.exports.CSPInjectionService = $9cd384078b5f912f$var$CSPInjectionService;

});
parcelRegister("iwjLL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExternalCspType = void 0;
var $d7ba8cee7c35b677$var$ExternalCspType;
(function(ExternalCspType) {
    ExternalCspType["IMG_SRC"] = "img-src";
    ExternalCspType["MEDIA_SRC"] = "media-src";
    ExternalCspType["SCRIPT_SRC"] = "script-src";
    ExternalCspType["STYLE_SRC"] = "style-src";
    ExternalCspType["CONNECT_SRC"] = "connect-src";
    ExternalCspType["FONT_SRC"] = "font-src";
    ExternalCspType["FRAME_SRC"] = "frame-src";
})($d7ba8cee7c35b677$var$ExternalCspType = module.exports.ExternalCspType || (module.exports.ExternalCspType = {}));

});


parcelRegister("anNhY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CSPProcessingService = module.exports.InvalidConnectSrc = void 0;

var $dnskZ = parcelRequire("dnskZ");

const $78f24920d43abf57$var$content_security_policy_parser_1 = $dnskZ.__importDefault((parcelRequire("73QxA")));

const $78f24920d43abf57$var$crypto_1 = $dnskZ.__importDefault((parcelRequire("cdGvs")));
class $78f24920d43abf57$var$InvalidConnectSrc extends Error {
    constructor(){
        super('fetch.client should be an array of strings');
    }
}
module.exports.InvalidConnectSrc = $78f24920d43abf57$var$InvalidConnectSrc;
class $78f24920d43abf57$var$CSPProcessingService {
    constructor(logger, cheerioLoader){
        this.logger = logger;
        this.cheerioLoader = cheerioLoader;
        this.STYLE_SRC_ALLOWLIST = [
            `'unsafe-inline'`
        ];
        this.QUOTED_SCRIPT_SRC_ALLOWLIST = [
            'unsafe-inline',
            'unsafe-eval',
            'unsafe-hashes'
        ];
        this.UNQUOTED_SCRIPT_SRC_ALLOWLIST = [
            'blob:'
        ];
        this.SCRIPT_SRC_ALLOWLIST = [
            ...this.QUOTED_SCRIPT_SRC_ALLOWLIST,
            ...this.UNQUOTED_SCRIPT_SRC_ALLOWLIST
        ];
        this.BASE_64_HASH_PATTERNS = [
            /^sha256-[a-zA-Z0-9=+/]{44}$/,
            /^sha384-[a-zA-Z0-9=+/]{64}$/,
            /^sha512-[a-zA-Z0-9=+/]{88}$/
        ];
    }
    getCspDetails(body, permissions) {
        var _a, _b;
        const { scripts: scripts, styles: styles } = (_a = permissions === null || permissions === void 0 ? void 0 : permissions.content) !== null && _a !== void 0 ? _a : {
            scripts: [],
            styles: []
        };
        const external = (_b = permissions === null || permissions === void 0 ? void 0 : permissions.external) !== null && _b !== void 0 ? _b : {};
        const $ = this.cheerioLoader(body, {
            xml: {
                xmlMode: false
            }
        });
        const { 'script-src': scriptSrc, 'style-src': styleSrc, ...mappedExternalCsp } = this.mapExternalPermissionsToCsp(external);
        return {
            'style-src': [
                ...this.getStyleSrc($, styles),
                ...styleSrc
            ],
            'script-src': [
                ...this.getScriptSrc($, scripts),
                ...scriptSrc
            ],
            ...mappedExternalCsp
        };
    }
    getInvalidCspPermissions(contentPermissions) {
        var _a, _b;
        const { styles: styles, scripts: scripts } = contentPermissions;
        const invalidStyles = (_a = styles === null || styles === void 0 ? void 0 : styles.filter((styleSrc)=>!this.isValidUserStyleSrc(`'${styleSrc}'`))) !== null && _a !== void 0 ? _a : [];
        const invalidScripts = (_b = scripts === null || scripts === void 0 ? void 0 : scripts.filter((scriptSrc)=>!this.isValidUserScriptSrc(scriptSrc))) !== null && _b !== void 0 ? _b : [];
        return [
            ...invalidStyles,
            ...invalidScripts
        ];
    }
    assertValidFetchClient(fetch) {
        if (fetch === null || fetch === void 0 ? void 0 : fetch.client) for (const client of fetch === null || fetch === void 0 ? void 0 : fetch.client){
            if (typeof client !== 'string') throw new $78f24920d43abf57$var$InvalidConnectSrc();
        }
    }
    egressesToStringMap(externalPermissions) {
        return externalPermissions === null || externalPermissions === void 0 ? void 0 : externalPermissions.map((egress)=>typeof egress === 'object' ? egress.address : egress);
    }
    mapExternalPermissionsToCsp(externalPermissions) {
        var _a, _b, _c, _d, _e, _f, _g;
        const { images: images, media: media, scripts: scripts, fetch: fetch, styles: styles, fonts: fonts, frames: frames } = externalPermissions;
        this.assertValidFetchClient(fetch);
        return {
            'img-src': (_a = this.egressesToStringMap(images)) !== null && _a !== void 0 ? _a : [],
            'media-src': (_b = this.egressesToStringMap(media)) !== null && _b !== void 0 ? _b : [],
            'script-src': (_c = this.egressesToStringMap(scripts)) !== null && _c !== void 0 ? _c : [],
            'style-src': (_d = this.egressesToStringMap(styles)) !== null && _d !== void 0 ? _d : [],
            'connect-src': (_e = fetch === null || fetch === void 0 ? void 0 : fetch.client) !== null && _e !== void 0 ? _e : [],
            'font-src': (_f = this.egressesToStringMap(fonts)) !== null && _f !== void 0 ? _f : [],
            'frame-src': (_g = this.egressesToStringMap(frames)) !== null && _g !== void 0 ? _g : []
        };
    }
    getStyleSrc($, userStyleSrc) {
        var _a, _b;
        const quotedUserStyleSrc = (_a = userStyleSrc === null || userStyleSrc === void 0 ? void 0 : userStyleSrc.map((x)=>`'${x}'`)) !== null && _a !== void 0 ? _a : [];
        const deprecatedUserStyleSrc = (_b = this.getDeprecatedUserCsp($)['style-src']) !== null && _b !== void 0 ? _b : [];
        const uniqueStyleSrc = [
            ...new Set([
                ...deprecatedUserStyleSrc,
                ...quotedUserStyleSrc
            ])
        ];
        return uniqueStyleSrc.filter((x)=>this.isValidUserStyleSrc(x));
    }
    getScriptSrc($, userScriptSrc) {
        var _a;
        const validUserScriptSrc = (_a = userScriptSrc === null || userScriptSrc === void 0 ? void 0 : userScriptSrc.filter((x)=>this.isValidUserScriptSrc(x))) !== null && _a !== void 0 ? _a : [];
        const generatedScriptHashes = validUserScriptSrc.includes('unsafe-inline') ? [] : this.getInlineScriptHashes($);
        const { scriptSrc: scriptSrc, userScriptHashes: userScriptHashes } = this.extractUniqueHashes(validUserScriptSrc, generatedScriptHashes);
        return [
            ...scriptSrc,
            ...generatedScriptHashes,
            ...userScriptHashes
        ].map((x)=>this.formatScriptSrc(x));
    }
    extractUniqueHashes(userScriptSrc, existingScriptHashes) {
        var _a;
        const userScriptHashes = [];
        const scriptSrc = (_a = userScriptSrc === null || userScriptSrc === void 0 ? void 0 : userScriptSrc.filter((scriptSrc)=>{
            const isValidHash = this.isValidHash(scriptSrc);
            if (isValidHash && !existingScriptHashes.includes(scriptSrc)) userScriptHashes.push(scriptSrc);
            return !isValidHash;
        })) !== null && _a !== void 0 ? _a : [];
        return {
            scriptSrc: scriptSrc,
            userScriptHashes: userScriptHashes
        };
    }
    getInlineScriptHashes($) {
        return $('script:not([src])').map((_index, script)=>{
            const html = $(script).html();
            return html && `sha256-${this.hashScript(html)}`;
        }).get();
    }
    hashScript(content) {
        const sha256 = $78f24920d43abf57$var$crypto_1.default.createHash('sha256');
        return sha256.update(content).digest('base64');
    }
    formatScriptSrc(scriptSrc) {
        if (this.UNQUOTED_SCRIPT_SRC_ALLOWLIST.includes(scriptSrc)) return scriptSrc;
        return `'${scriptSrc}'`;
    }
    isValidUserScriptSrc(scriptSrc) {
        if (!this.isSafeCsp(scriptSrc)) return false;
        return this.isValidHash(scriptSrc) || this.SCRIPT_SRC_ALLOWLIST.includes(scriptSrc);
    }
    isValidUserStyleSrc(styleSrc) {
        if (!this.isSafeCsp(styleSrc)) {
            this.logger.info('discarding potentially-malicious CSP');
            return false;
        }
        return this.STYLE_SRC_ALLOWLIST.includes(styleSrc);
    }
    isSafeCsp(cspString) {
        return /^([a-zA-Z0-9='"+\/ -]|blob:)*$/.test(cspString);
    }
    isValidHash(cspString) {
        return this.BASE_64_HASH_PATTERNS.some((pattern)=>pattern.test(cspString));
    }
    getDeprecatedUserCsp($) {
        const cspContent = $('meta[http-equiv="Content-Security-Policy"]').attr('content');
        if (!cspContent) return {};
        if (!this.isSafeCsp(cspContent)) {
            this.logger.info('discarding potentially-malicious CSP');
            return {};
        }
        return (0, $78f24920d43abf57$var$content_security_policy_parser_1.default)(cspContent);
    }
}
module.exports.CSPProcessingService = $78f24920d43abf57$var$CSPProcessingService;

});
parcelRegister("73QxA", function(module, exports) {
"use strict";
module.exports = (policy)=>{
    const result = {};
    policy.split(";").forEach((directive)=>{
        const [directiveKey, ...directiveValue] = directive.trim().split(/\s+/g);
        if (directiveKey && !Object.prototype.hasOwnProperty.call(result, directiveKey)) {
            if (directiveKey === "__proto__") Object.defineProperty(result, directiveKey, {
                configurable: true,
                enumerable: true,
                writable: true,
                value: directiveValue
            });
            else result[directiveKey] = directiveValue;
        }
    });
    return result;
};

});

parcelRegister("cdGvs", function(module, exports) {
$parcel$export(module.exports, "randomBytes", () => $8e57abd681b11d1c$export$5f828d93ff035aa8, (v) => $8e57abd681b11d1c$export$5f828d93ff035aa8 = v);
$parcel$export(module.exports, "rng", () => $8e57abd681b11d1c$export$cd94982b18c6332c, (v) => $8e57abd681b11d1c$export$cd94982b18c6332c = v);
$parcel$export(module.exports, "pseudoRandomBytes", () => $8e57abd681b11d1c$export$1d518568e4f529b0, (v) => $8e57abd681b11d1c$export$1d518568e4f529b0 = v);
$parcel$export(module.exports, "prng", () => $8e57abd681b11d1c$export$5285b6d41c912b41, (v) => $8e57abd681b11d1c$export$5285b6d41c912b41 = v);
$parcel$export(module.exports, "createHash", () => $8e57abd681b11d1c$export$2fb37efbf6ae0c0e, (v) => $8e57abd681b11d1c$export$2fb37efbf6ae0c0e = v);
$parcel$export(module.exports, "Hash", () => $8e57abd681b11d1c$export$ab85ecd77ce6a5cd, (v) => $8e57abd681b11d1c$export$ab85ecd77ce6a5cd = v);
$parcel$export(module.exports, "createHmac", () => $8e57abd681b11d1c$export$da39cf97e1eb7c91, (v) => $8e57abd681b11d1c$export$da39cf97e1eb7c91 = v);
$parcel$export(module.exports, "Hmac", () => $8e57abd681b11d1c$export$52a9039d7177394f, (v) => $8e57abd681b11d1c$export$52a9039d7177394f = v);
$parcel$export(module.exports, "getHashes", () => $8e57abd681b11d1c$export$f7201db400317331, (v) => $8e57abd681b11d1c$export$f7201db400317331 = v);
$parcel$export(module.exports, "pbkdf2", () => $8e57abd681b11d1c$export$448fa22aedc9dbca, (v) => $8e57abd681b11d1c$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $8e57abd681b11d1c$export$b80c7ba289c8fa56, (v) => $8e57abd681b11d1c$export$b80c7ba289c8fa56 = v);
$parcel$export(module.exports, "Cipher", () => $8e57abd681b11d1c$export$26e5786e8ac8e530, (v) => $8e57abd681b11d1c$export$26e5786e8ac8e530 = v);
$parcel$export(module.exports, "createCipher", () => $8e57abd681b11d1c$export$bdd223f16383713e, (v) => $8e57abd681b11d1c$export$bdd223f16383713e = v);
$parcel$export(module.exports, "Cipheriv", () => $8e57abd681b11d1c$export$20533d26f07f1ee0, (v) => $8e57abd681b11d1c$export$20533d26f07f1ee0 = v);
$parcel$export(module.exports, "createCipheriv", () => $8e57abd681b11d1c$export$2f64596b8cbf08b4, (v) => $8e57abd681b11d1c$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "Decipher", () => $8e57abd681b11d1c$export$2ce6d8d0e8b04e1a, (v) => $8e57abd681b11d1c$export$2ce6d8d0e8b04e1a = v);
$parcel$export(module.exports, "createDecipher", () => $8e57abd681b11d1c$export$12ada9414fbc594c, (v) => $8e57abd681b11d1c$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "Decipheriv", () => $8e57abd681b11d1c$export$f5e7e39d57cd9700, (v) => $8e57abd681b11d1c$export$f5e7e39d57cd9700 = v);
$parcel$export(module.exports, "createDecipheriv", () => $8e57abd681b11d1c$export$36b6d6ef312eab39, (v) => $8e57abd681b11d1c$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $8e57abd681b11d1c$export$58a258485f1e49f6, (v) => $8e57abd681b11d1c$export$58a258485f1e49f6 = v);
$parcel$export(module.exports, "listCiphers", () => $8e57abd681b11d1c$export$dedd8dc3dc62b370, (v) => $8e57abd681b11d1c$export$dedd8dc3dc62b370 = v);
$parcel$export(module.exports, "DiffieHellmanGroup", () => $8e57abd681b11d1c$export$971862a2fcb1bb40, (v) => $8e57abd681b11d1c$export$971862a2fcb1bb40 = v);
$parcel$export(module.exports, "createDiffieHellmanGroup", () => $8e57abd681b11d1c$export$c6ff6a88acbeaf40, (v) => $8e57abd681b11d1c$export$c6ff6a88acbeaf40 = v);
$parcel$export(module.exports, "getDiffieHellman", () => $8e57abd681b11d1c$export$fdc27893e98845cc, (v) => $8e57abd681b11d1c$export$fdc27893e98845cc = v);
$parcel$export(module.exports, "createDiffieHellman", () => $8e57abd681b11d1c$export$6671fb9a1323bed, (v) => $8e57abd681b11d1c$export$6671fb9a1323bed = v);
$parcel$export(module.exports, "DiffieHellman", () => $8e57abd681b11d1c$export$d74daf141a551db, (v) => $8e57abd681b11d1c$export$d74daf141a551db = v);
$parcel$export(module.exports, "createSign", () => $8e57abd681b11d1c$export$45df7cae684751af, (v) => $8e57abd681b11d1c$export$45df7cae684751af = v);
$parcel$export(module.exports, "Sign", () => $8e57abd681b11d1c$export$1db683ad541682f6, (v) => $8e57abd681b11d1c$export$1db683ad541682f6 = v);
$parcel$export(module.exports, "createVerify", () => $8e57abd681b11d1c$export$6f65485f87568e37, (v) => $8e57abd681b11d1c$export$6f65485f87568e37 = v);
$parcel$export(module.exports, "Verify", () => $8e57abd681b11d1c$export$91a8e56769aeb334, (v) => $8e57abd681b11d1c$export$91a8e56769aeb334 = v);
$parcel$export(module.exports, "createECDH", () => $8e57abd681b11d1c$export$2d4117e99c2179e4, (v) => $8e57abd681b11d1c$export$2d4117e99c2179e4 = v);
$parcel$export(module.exports, "publicEncrypt", () => $8e57abd681b11d1c$export$512823e338ddb1b7, (v) => $8e57abd681b11d1c$export$512823e338ddb1b7 = v);
$parcel$export(module.exports, "privateEncrypt", () => $8e57abd681b11d1c$export$9d0e0c0c4a8d30f3, (v) => $8e57abd681b11d1c$export$9d0e0c0c4a8d30f3 = v);
$parcel$export(module.exports, "publicDecrypt", () => $8e57abd681b11d1c$export$b9d55ff329113abd, (v) => $8e57abd681b11d1c$export$b9d55ff329113abd = v);
$parcel$export(module.exports, "privateDecrypt", () => $8e57abd681b11d1c$export$7efb24e2fddf99b9, (v) => $8e57abd681b11d1c$export$7efb24e2fddf99b9 = v);
$parcel$export(module.exports, "randomFill", () => $8e57abd681b11d1c$export$bb1abf2ce84fc7e8, (v) => $8e57abd681b11d1c$export$bb1abf2ce84fc7e8 = v);
$parcel$export(module.exports, "randomFillSync", () => $8e57abd681b11d1c$export$2f7171e78e524d5e, (v) => $8e57abd681b11d1c$export$2f7171e78e524d5e = v);
$parcel$export(module.exports, "createCredentials", () => $8e57abd681b11d1c$export$e1d879b482f37d98, (v) => $8e57abd681b11d1c$export$e1d879b482f37d98 = v);
$parcel$export(module.exports, "constants", () => $8e57abd681b11d1c$export$1a988e7317c65621, (v) => $8e57abd681b11d1c$export$1a988e7317c65621 = v);
// eslint-disable-next-line no-multi-assign
var $8e57abd681b11d1c$export$5f828d93ff035aa8;
var $8e57abd681b11d1c$export$cd94982b18c6332c;
var $8e57abd681b11d1c$export$1d518568e4f529b0;
var $8e57abd681b11d1c$export$5285b6d41c912b41;
// eslint-disable-next-line no-multi-assign
var $8e57abd681b11d1c$export$2fb37efbf6ae0c0e;
var $8e57abd681b11d1c$export$ab85ecd77ce6a5cd;
// eslint-disable-next-line no-multi-assign
var $8e57abd681b11d1c$export$da39cf97e1eb7c91;
var $8e57abd681b11d1c$export$52a9039d7177394f;
var $8e57abd681b11d1c$export$f7201db400317331;
var $8e57abd681b11d1c$export$448fa22aedc9dbca;
var $8e57abd681b11d1c$export$b80c7ba289c8fa56;
var $8e57abd681b11d1c$export$26e5786e8ac8e530;
var $8e57abd681b11d1c$export$bdd223f16383713e;
var $8e57abd681b11d1c$export$20533d26f07f1ee0;
var $8e57abd681b11d1c$export$2f64596b8cbf08b4;
var $8e57abd681b11d1c$export$2ce6d8d0e8b04e1a;
var $8e57abd681b11d1c$export$12ada9414fbc594c;
var $8e57abd681b11d1c$export$f5e7e39d57cd9700;
var $8e57abd681b11d1c$export$36b6d6ef312eab39;
var $8e57abd681b11d1c$export$58a258485f1e49f6;
var $8e57abd681b11d1c$export$dedd8dc3dc62b370;
var $8e57abd681b11d1c$export$971862a2fcb1bb40;
var $8e57abd681b11d1c$export$c6ff6a88acbeaf40;
var $8e57abd681b11d1c$export$fdc27893e98845cc;
var $8e57abd681b11d1c$export$6671fb9a1323bed;
var $8e57abd681b11d1c$export$d74daf141a551db;
var $8e57abd681b11d1c$export$45df7cae684751af;
var $8e57abd681b11d1c$export$1db683ad541682f6;
var $8e57abd681b11d1c$export$6f65485f87568e37;
var $8e57abd681b11d1c$export$91a8e56769aeb334;
var $8e57abd681b11d1c$export$2d4117e99c2179e4;
var $8e57abd681b11d1c$export$512823e338ddb1b7;
var $8e57abd681b11d1c$export$9d0e0c0c4a8d30f3;
var $8e57abd681b11d1c$export$b9d55ff329113abd;
var $8e57abd681b11d1c$export$7efb24e2fddf99b9;
var $8e57abd681b11d1c$export$bb1abf2ce84fc7e8;
var $8e57abd681b11d1c$export$2f7171e78e524d5e;
var $8e57abd681b11d1c$export$e1d879b482f37d98;
var $8e57abd681b11d1c$export$1a988e7317c65621;
'use strict';

$8e57abd681b11d1c$export$5f828d93ff035aa8 = $8e57abd681b11d1c$export$cd94982b18c6332c = $8e57abd681b11d1c$export$1d518568e4f529b0 = $8e57abd681b11d1c$export$5285b6d41c912b41 = (parcelRequire("49lWG"));

$8e57abd681b11d1c$export$2fb37efbf6ae0c0e = $8e57abd681b11d1c$export$ab85ecd77ce6a5cd = (parcelRequire("lKbOi"));

$8e57abd681b11d1c$export$da39cf97e1eb7c91 = $8e57abd681b11d1c$export$52a9039d7177394f = (parcelRequire("6Gm8U"));

var $5zKpg = parcelRequire("5zKpg");
var $8e57abd681b11d1c$var$algoKeys = Object.keys($5zKpg);
var $8e57abd681b11d1c$var$hashes = [
    'sha1',
    'sha224',
    'sha256',
    'sha384',
    'sha512',
    'md5',
    'rmd160'
].concat($8e57abd681b11d1c$var$algoKeys);
$8e57abd681b11d1c$export$f7201db400317331 = function() {
    return $8e57abd681b11d1c$var$hashes;
};

var $ljyV3 = parcelRequire("ljyV3");
$8e57abd681b11d1c$export$448fa22aedc9dbca = $ljyV3.pbkdf2;
$8e57abd681b11d1c$export$b80c7ba289c8fa56 = $ljyV3.pbkdf2Sync;

var $gx4cO = parcelRequire("gx4cO");
$8e57abd681b11d1c$export$26e5786e8ac8e530 = $gx4cO.Cipher;
$8e57abd681b11d1c$export$bdd223f16383713e = $gx4cO.createCipher;
$8e57abd681b11d1c$export$20533d26f07f1ee0 = $gx4cO.Cipheriv;
$8e57abd681b11d1c$export$2f64596b8cbf08b4 = $gx4cO.createCipheriv;
$8e57abd681b11d1c$export$2ce6d8d0e8b04e1a = $gx4cO.Decipher;
$8e57abd681b11d1c$export$12ada9414fbc594c = $gx4cO.createDecipher;
$8e57abd681b11d1c$export$f5e7e39d57cd9700 = $gx4cO.Decipheriv;
$8e57abd681b11d1c$export$36b6d6ef312eab39 = $gx4cO.createDecipheriv;
$8e57abd681b11d1c$export$58a258485f1e49f6 = $gx4cO.getCiphers;
$8e57abd681b11d1c$export$dedd8dc3dc62b370 = $gx4cO.listCiphers;

var $1QxKQ = parcelRequire("1QxKQ");
$8e57abd681b11d1c$export$971862a2fcb1bb40 = $1QxKQ.DiffieHellmanGroup;
$8e57abd681b11d1c$export$c6ff6a88acbeaf40 = $1QxKQ.createDiffieHellmanGroup;
$8e57abd681b11d1c$export$fdc27893e98845cc = $1QxKQ.getDiffieHellman;
$8e57abd681b11d1c$export$6671fb9a1323bed = $1QxKQ.createDiffieHellman;
$8e57abd681b11d1c$export$d74daf141a551db = $1QxKQ.DiffieHellman;

var $8I2P7 = parcelRequire("8I2P7");
$8e57abd681b11d1c$export$45df7cae684751af = $8I2P7.createSign;
$8e57abd681b11d1c$export$1db683ad541682f6 = $8I2P7.Sign;
$8e57abd681b11d1c$export$6f65485f87568e37 = $8I2P7.createVerify;
$8e57abd681b11d1c$export$91a8e56769aeb334 = $8I2P7.Verify;

$8e57abd681b11d1c$export$2d4117e99c2179e4 = (parcelRequire("7nDDR"));

var $33QHh = parcelRequire("33QHh");
$8e57abd681b11d1c$export$512823e338ddb1b7 = $33QHh.publicEncrypt;
$8e57abd681b11d1c$export$9d0e0c0c4a8d30f3 = $33QHh.privateEncrypt;
$8e57abd681b11d1c$export$b9d55ff329113abd = $33QHh.publicDecrypt;
$8e57abd681b11d1c$export$7efb24e2fddf99b9 = $33QHh.privateDecrypt;

var $fa9Fb = parcelRequire("fa9Fb");
$8e57abd681b11d1c$export$bb1abf2ce84fc7e8 = $fa9Fb.randomFill;
$8e57abd681b11d1c$export$2f7171e78e524d5e = $fa9Fb.randomFillSync;
$8e57abd681b11d1c$export$e1d879b482f37d98 = function() {
    throw new Error('sorry, createCredentials is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
};
$8e57abd681b11d1c$export$1a988e7317c65621 = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
};

});
parcelRegister("49lWG", function(module, exports) {

var $igDjg = parcelRequire("igDjg");
'use strict';
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $305906a0d6965edf$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $305906a0d6965edf$var$MAX_UINT32 = 4294967295;
function $305906a0d6965edf$var$oldBrowser() {
    throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11');
}

var $bc1ju = parcelRequire("bc1ju");
var $305906a0d6965edf$require$Buffer = $bc1ju.Buffer;
var $305906a0d6965edf$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($305906a0d6965edf$var$crypto && $305906a0d6965edf$var$crypto.getRandomValues) module.exports = $305906a0d6965edf$var$randomBytes;
else module.exports = $305906a0d6965edf$var$oldBrowser;
function $305906a0d6965edf$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $305906a0d6965edf$var$MAX_UINT32) throw new RangeError('requested too many random bytes');
    var bytes = $305906a0d6965edf$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $305906a0d6965edf$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $305906a0d6965edf$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $305906a0d6965edf$var$crypto.getRandomValues(bytes.slice(generated, generated + $305906a0d6965edf$var$MAX_BYTES));
        else $305906a0d6965edf$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === 'function') return $igDjg.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});
parcelRegister("bc1ju", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $5Ovjr = parcelRequire("5Ovjr");
var $8261d57ccd32d7d3$var$Buffer = $5Ovjr.Buffer;
// alternative to using Object.keys for old browsers
function $8261d57ccd32d7d3$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($8261d57ccd32d7d3$var$Buffer.from && $8261d57ccd32d7d3$var$Buffer.alloc && $8261d57ccd32d7d3$var$Buffer.allocUnsafe && $8261d57ccd32d7d3$var$Buffer.allocUnsafeSlow) module.exports = $5Ovjr;
else {
    // Copy properties from require('buffer')
    $8261d57ccd32d7d3$var$copyProps($5Ovjr, module.exports);
    module.exports.Buffer = $8261d57ccd32d7d3$var$SafeBuffer;
}
function $8261d57ccd32d7d3$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $8261d57ccd32d7d3$var$Buffer(arg, encodingOrOffset, length);
}
$8261d57ccd32d7d3$var$SafeBuffer.prototype = Object.create($8261d57ccd32d7d3$var$Buffer.prototype);
// Copy static methods from Buffer
$8261d57ccd32d7d3$var$copyProps($8261d57ccd32d7d3$var$Buffer, $8261d57ccd32d7d3$var$SafeBuffer);
$8261d57ccd32d7d3$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $8261d57ccd32d7d3$var$Buffer(arg, encodingOrOffset, length);
};
$8261d57ccd32d7d3$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $8261d57ccd32d7d3$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$8261d57ccd32d7d3$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $8261d57ccd32d7d3$var$Buffer(size);
};
$8261d57ccd32d7d3$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $5Ovjr.SlowBuffer(size);
};

});


parcelRegister("lKbOi", function(module, exports) {
'use strict';

var $lpcNn = parcelRequire("lpcNn");

var $a8EwA = parcelRequire("a8EwA");

var $aABar = parcelRequire("aABar");

var $laOeJ = parcelRequire("laOeJ");

var $3T1AC = parcelRequire("3T1AC");
function $fd470e23c8bf4afc$var$Hash(hash) {
    $3T1AC.call(this, 'digest');
    this._hash = hash;
}
$lpcNn($fd470e23c8bf4afc$var$Hash, $3T1AC);
$fd470e23c8bf4afc$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$fd470e23c8bf4afc$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === 'md5') return new $a8EwA();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $aABar();
    return new $fd470e23c8bf4afc$var$Hash($laOeJ(alg));
};

});
parcelRegister("lpcNn", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("a8EwA", function(module, exports) {

var $5Ovjr = parcelRequire("5Ovjr");
var $761a1612341ad4b9$require$Buffer = $5Ovjr.Buffer;
'use strict';

var $lpcNn = parcelRequire("lpcNn");

var $6VzRH = parcelRequire("6VzRH");
var $761a1612341ad4b9$var$ARRAY16 = new Array(16);
function $761a1612341ad4b9$var$MD5() {
    $6VzRH.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$lpcNn($761a1612341ad4b9$var$MD5, $6VzRH);
$761a1612341ad4b9$var$MD5.prototype._update = function() {
    var M = $761a1612341ad4b9$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $761a1612341ad4b9$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $761a1612341ad4b9$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $761a1612341ad4b9$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $761a1612341ad4b9$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $761a1612341ad4b9$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $761a1612341ad4b9$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $761a1612341ad4b9$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $761a1612341ad4b9$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $761a1612341ad4b9$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $761a1612341ad4b9$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $761a1612341ad4b9$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $761a1612341ad4b9$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $761a1612341ad4b9$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $761a1612341ad4b9$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $761a1612341ad4b9$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $761a1612341ad4b9$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $761a1612341ad4b9$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $761a1612341ad4b9$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $761a1612341ad4b9$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $761a1612341ad4b9$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $761a1612341ad4b9$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $761a1612341ad4b9$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $761a1612341ad4b9$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $761a1612341ad4b9$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $761a1612341ad4b9$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $761a1612341ad4b9$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $761a1612341ad4b9$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $761a1612341ad4b9$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $761a1612341ad4b9$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $761a1612341ad4b9$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $761a1612341ad4b9$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $761a1612341ad4b9$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $761a1612341ad4b9$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $761a1612341ad4b9$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $761a1612341ad4b9$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $761a1612341ad4b9$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $761a1612341ad4b9$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $761a1612341ad4b9$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $761a1612341ad4b9$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $761a1612341ad4b9$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $761a1612341ad4b9$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $761a1612341ad4b9$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $761a1612341ad4b9$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $761a1612341ad4b9$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $761a1612341ad4b9$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $761a1612341ad4b9$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $761a1612341ad4b9$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $761a1612341ad4b9$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $761a1612341ad4b9$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $761a1612341ad4b9$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $761a1612341ad4b9$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $761a1612341ad4b9$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $761a1612341ad4b9$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $761a1612341ad4b9$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $761a1612341ad4b9$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $761a1612341ad4b9$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $761a1612341ad4b9$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $761a1612341ad4b9$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $761a1612341ad4b9$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $761a1612341ad4b9$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $761a1612341ad4b9$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $761a1612341ad4b9$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $761a1612341ad4b9$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $761a1612341ad4b9$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$761a1612341ad4b9$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = new $761a1612341ad4b9$require$Buffer(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $761a1612341ad4b9$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $761a1612341ad4b9$var$fnF(a, b, c, d, m, k, s) {
    return $761a1612341ad4b9$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $761a1612341ad4b9$var$fnG(a, b, c, d, m, k, s) {
    return $761a1612341ad4b9$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $761a1612341ad4b9$var$fnH(a, b, c, d, m, k, s) {
    return $761a1612341ad4b9$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $761a1612341ad4b9$var$fnI(a, b, c, d, m, k, s) {
    return $761a1612341ad4b9$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $761a1612341ad4b9$var$MD5;

});
parcelRegister("6VzRH", function(module, exports) {
'use strict';

var $bc1ju = parcelRequire("bc1ju");
var $50b3e2fd6e44353a$require$Buffer = $bc1ju.Buffer;

var $flUTc = parcelRequire("flUTc");
var $50b3e2fd6e44353a$require$Transform = $flUTc.Transform;

var $lpcNn = parcelRequire("lpcNn");
function $50b3e2fd6e44353a$var$throwIfNotStringOrBuffer(val, prefix) {
    if (!$50b3e2fd6e44353a$require$Buffer.isBuffer(val) && typeof val !== 'string') throw new TypeError(prefix + ' must be a string or a buffer');
}
function $50b3e2fd6e44353a$var$HashBase(blockSize) {
    $50b3e2fd6e44353a$require$Transform.call(this);
    this._block = $50b3e2fd6e44353a$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$lpcNn($50b3e2fd6e44353a$var$HashBase, $50b3e2fd6e44353a$require$Transform);
$50b3e2fd6e44353a$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$50b3e2fd6e44353a$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$50b3e2fd6e44353a$var$HashBase.prototype.update = function(data, encoding) {
    $50b3e2fd6e44353a$var$throwIfNotStringOrBuffer(data, 'Data');
    if (this._finalized) throw new Error('Digest already called');
    if (!$50b3e2fd6e44353a$require$Buffer.isBuffer(data)) data = $50b3e2fd6e44353a$require$Buffer.from(data, encoding);
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$50b3e2fd6e44353a$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$50b3e2fd6e44353a$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$50b3e2fd6e44353a$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $50b3e2fd6e44353a$var$HashBase;

});
parcelRegister("flUTc", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $b2d4f2334e7a0de0$var$Stream;

var $7OU8o = parcelRequire("7OU8o");
var $b2d4f2334e7a0de0$require$EE = $7OU8o.EventEmitter;

var $lpcNn = parcelRequire("lpcNn");
$lpcNn($b2d4f2334e7a0de0$var$Stream, $b2d4f2334e7a0de0$require$EE);

$b2d4f2334e7a0de0$var$Stream.Readable = (parcelRequire("4YxZ8"));

$b2d4f2334e7a0de0$var$Stream.Writable = (parcelRequire("358BL"));

$b2d4f2334e7a0de0$var$Stream.Duplex = (parcelRequire("gXjNe"));

$b2d4f2334e7a0de0$var$Stream.Transform = (parcelRequire("lBsbr"));

$b2d4f2334e7a0de0$var$Stream.PassThrough = (parcelRequire("1y443"));

$b2d4f2334e7a0de0$var$Stream.finished = (parcelRequire("hplrP"));

$b2d4f2334e7a0de0$var$Stream.pipeline = (parcelRequire("6s7ke"));
// Backwards-compat with node 0.4.x
$b2d4f2334e7a0de0$var$Stream.Stream = $b2d4f2334e7a0de0$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $b2d4f2334e7a0de0$var$Stream() {
    $b2d4f2334e7a0de0$require$EE.call(this);
}
$b2d4f2334e7a0de0$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($b2d4f2334e7a0de0$require$EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("7OU8o", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $5b18bf0c82fb1188$var$R = typeof Reflect === 'object' ? Reflect : null;
var $5b18bf0c82fb1188$var$ReflectApply = $5b18bf0c82fb1188$var$R && typeof $5b18bf0c82fb1188$var$R.apply === 'function' ? $5b18bf0c82fb1188$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5b18bf0c82fb1188$var$ReflectOwnKeys;
if ($5b18bf0c82fb1188$var$R && typeof $5b18bf0c82fb1188$var$R.ownKeys === 'function') $5b18bf0c82fb1188$var$ReflectOwnKeys = $5b18bf0c82fb1188$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5b18bf0c82fb1188$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5b18bf0c82fb1188$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5b18bf0c82fb1188$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5b18bf0c82fb1188$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5b18bf0c82fb1188$var$EventEmitter() {
    $5b18bf0c82fb1188$var$EventEmitter.init.call(this);
}
module.exports = $5b18bf0c82fb1188$var$EventEmitter;
module.exports.once = $5b18bf0c82fb1188$var$once;
// Backwards-compat with node 0.10.x
$5b18bf0c82fb1188$var$EventEmitter.EventEmitter = $5b18bf0c82fb1188$var$EventEmitter;
$5b18bf0c82fb1188$var$EventEmitter.prototype._events = undefined;
$5b18bf0c82fb1188$var$EventEmitter.prototype._eventsCount = 0;
$5b18bf0c82fb1188$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5b18bf0c82fb1188$var$defaultMaxListeners = 10;
function $5b18bf0c82fb1188$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5b18bf0c82fb1188$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $5b18bf0c82fb1188$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $5b18bf0c82fb1188$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $5b18bf0c82fb1188$var$defaultMaxListeners = arg;
    }
});
$5b18bf0c82fb1188$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5b18bf0c82fb1188$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $5b18bf0c82fb1188$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $5b18bf0c82fb1188$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5b18bf0c82fb1188$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5b18bf0c82fb1188$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5b18bf0c82fb1188$var$_getMaxListeners(this);
};
$5b18bf0c82fb1188$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $5b18bf0c82fb1188$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5b18bf0c82fb1188$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5b18bf0c82fb1188$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5b18bf0c82fb1188$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5b18bf0c82fb1188$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5b18bf0c82fb1188$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5b18bf0c82fb1188$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5b18bf0c82fb1188$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5b18bf0c82fb1188$var$_addListener(this, type, listener, false);
};
$5b18bf0c82fb1188$var$EventEmitter.prototype.on = $5b18bf0c82fb1188$var$EventEmitter.prototype.addListener;
$5b18bf0c82fb1188$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5b18bf0c82fb1188$var$_addListener(this, type, listener, true);
};
function $5b18bf0c82fb1188$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5b18bf0c82fb1188$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5b18bf0c82fb1188$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5b18bf0c82fb1188$var$EventEmitter.prototype.once = function once(type, listener) {
    $5b18bf0c82fb1188$var$checkListener(listener);
    this.on(type, $5b18bf0c82fb1188$var$_onceWrap(this, type, listener));
    return this;
};
$5b18bf0c82fb1188$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5b18bf0c82fb1188$var$checkListener(listener);
    this.prependListener(type, $5b18bf0c82fb1188$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5b18bf0c82fb1188$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5b18bf0c82fb1188$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5b18bf0c82fb1188$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$5b18bf0c82fb1188$var$EventEmitter.prototype.off = $5b18bf0c82fb1188$var$EventEmitter.prototype.removeListener;
$5b18bf0c82fb1188$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5b18bf0c82fb1188$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5b18bf0c82fb1188$var$unwrapListeners(evlistener) : $5b18bf0c82fb1188$var$arrayClone(evlistener, evlistener.length);
}
$5b18bf0c82fb1188$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5b18bf0c82fb1188$var$_listeners(this, type, true);
};
$5b18bf0c82fb1188$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5b18bf0c82fb1188$var$_listeners(this, type, false);
};
$5b18bf0c82fb1188$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $5b18bf0c82fb1188$var$listenerCount.call(emitter, type);
};
$5b18bf0c82fb1188$var$EventEmitter.prototype.listenerCount = $5b18bf0c82fb1188$var$listenerCount;
function $5b18bf0c82fb1188$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5b18bf0c82fb1188$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5b18bf0c82fb1188$var$ReflectOwnKeys(this._events) : [];
};
function $5b18bf0c82fb1188$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5b18bf0c82fb1188$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5b18bf0c82fb1188$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5b18bf0c82fb1188$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $5b18bf0c82fb1188$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $5b18bf0c82fb1188$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5b18bf0c82fb1188$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $5b18bf0c82fb1188$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $5b18bf0c82fb1188$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("4YxZ8", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $igDjg = parcelRequire("igDjg");
'use strict';
module.exports = $39f720b7c6e5b098$var$Readable;
/*<replacement>*/ var $39f720b7c6e5b098$var$Duplex;
/*</replacement>*/ $39f720b7c6e5b098$var$Readable.ReadableState = $39f720b7c6e5b098$var$ReadableState;

var $7OU8o = parcelRequire("7OU8o");
var $39f720b7c6e5b098$require$EE = $7OU8o.EventEmitter;
var $39f720b7c6e5b098$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $duXG6 = parcelRequire("duXG6");

var $5Ovjr = parcelRequire("5Ovjr");
var $39f720b7c6e5b098$require$Buffer = $5Ovjr.Buffer;
var $39f720b7c6e5b098$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $39f720b7c6e5b098$var$_uint8ArrayToBuffer(chunk) {
    return $39f720b7c6e5b098$require$Buffer.from(chunk);
}
function $39f720b7c6e5b098$var$_isUint8Array(obj) {
    return $39f720b7c6e5b098$require$Buffer.isBuffer(obj) || obj instanceof $39f720b7c6e5b098$var$OurUint8Array;
}

var $lOA8N = parcelRequire("lOA8N");
var $39f720b7c6e5b098$var$debug;
if ($lOA8N && $lOA8N.debuglog) $39f720b7c6e5b098$var$debug = $lOA8N.debuglog('stream');
else $39f720b7c6e5b098$var$debug = function debug() {};

var $4bmRn = parcelRequire("4bmRn");

var $dxOnz = parcelRequire("dxOnz");

var $5epc0 = parcelRequire("5epc0");
var $39f720b7c6e5b098$var$getHighWaterMark = $5epc0.getHighWaterMark;

var $5AwkU = parcelRequire("5AwkU");
var $39f720b7c6e5b098$require$_require$codes = $5AwkU.codes;
var $39f720b7c6e5b098$var$ERR_INVALID_ARG_TYPE = $39f720b7c6e5b098$require$_require$codes.ERR_INVALID_ARG_TYPE, $39f720b7c6e5b098$var$ERR_STREAM_PUSH_AFTER_EOF = $39f720b7c6e5b098$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $39f720b7c6e5b098$var$ERR_METHOD_NOT_IMPLEMENTED = $39f720b7c6e5b098$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $39f720b7c6e5b098$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $39f720b7c6e5b098$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $39f720b7c6e5b098$var$StringDecoder;
var $39f720b7c6e5b098$var$createReadableStreamAsyncIterator;
var $39f720b7c6e5b098$var$from;

(parcelRequire("lpcNn"))($39f720b7c6e5b098$var$Readable, $duXG6);
var $39f720b7c6e5b098$var$errorOrDestroy = $dxOnz.errorOrDestroy;
var $39f720b7c6e5b098$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $39f720b7c6e5b098$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $39f720b7c6e5b098$var$ReadableState(options, stream, isDuplex) {
    $39f720b7c6e5b098$var$Duplex = $39f720b7c6e5b098$var$Duplex || (parcelRequire("gXjNe"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $39f720b7c6e5b098$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $39f720b7c6e5b098$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $4bmRn();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$39f720b7c6e5b098$var$StringDecoder) $39f720b7c6e5b098$var$StringDecoder = (parcelRequire("2Sdak")).StringDecoder;
        this.decoder = new $39f720b7c6e5b098$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $39f720b7c6e5b098$var$Readable(options) {
    $39f720b7c6e5b098$var$Duplex = $39f720b7c6e5b098$var$Duplex || (parcelRequire("gXjNe"));
    if (!(this instanceof $39f720b7c6e5b098$var$Readable)) return new $39f720b7c6e5b098$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $39f720b7c6e5b098$var$Duplex;
    this._readableState = new $39f720b7c6e5b098$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $duXG6.call(this);
}
Object.defineProperty($39f720b7c6e5b098$var$Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$39f720b7c6e5b098$var$Readable.prototype.destroy = $dxOnz.destroy;
$39f720b7c6e5b098$var$Readable.prototype._undestroy = $dxOnz.undestroy;
$39f720b7c6e5b098$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$39f720b7c6e5b098$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $39f720b7c6e5b098$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $39f720b7c6e5b098$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$39f720b7c6e5b098$var$Readable.prototype.unshift = function(chunk) {
    return $39f720b7c6e5b098$var$readableAddChunk(this, chunk, null, true, false);
};
function $39f720b7c6e5b098$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $39f720b7c6e5b098$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $39f720b7c6e5b098$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $39f720b7c6e5b098$var$chunkInvalid(state, chunk);
        if (er) $39f720b7c6e5b098$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $39f720b7c6e5b098$require$Buffer.prototype) chunk = $39f720b7c6e5b098$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $39f720b7c6e5b098$var$errorOrDestroy(stream, new $39f720b7c6e5b098$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $39f720b7c6e5b098$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $39f720b7c6e5b098$var$errorOrDestroy(stream, new $39f720b7c6e5b098$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $39f720b7c6e5b098$var$addChunk(stream, state, chunk, false);
                    else $39f720b7c6e5b098$var$maybeReadMore(stream, state);
                } else $39f720b7c6e5b098$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $39f720b7c6e5b098$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $39f720b7c6e5b098$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $39f720b7c6e5b098$var$emitReadable(stream);
    }
    $39f720b7c6e5b098$var$maybeReadMore(stream, state);
}
function $39f720b7c6e5b098$var$chunkInvalid(state, chunk) {
    var er;
    if (!$39f720b7c6e5b098$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $39f720b7c6e5b098$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
$39f720b7c6e5b098$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$39f720b7c6e5b098$var$Readable.prototype.setEncoding = function(enc) {
    if (!$39f720b7c6e5b098$var$StringDecoder) $39f720b7c6e5b098$var$StringDecoder = (parcelRequire("2Sdak")).StringDecoder;
    var decoder = new $39f720b7c6e5b098$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $39f720b7c6e5b098$var$MAX_HWM = 0x40000000;
function $39f720b7c6e5b098$var$computeNewHighWaterMark(n) {
    if (n >= $39f720b7c6e5b098$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $39f720b7c6e5b098$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $39f720b7c6e5b098$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $39f720b7c6e5b098$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$39f720b7c6e5b098$var$Readable.prototype.read = function(n) {
    $39f720b7c6e5b098$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $39f720b7c6e5b098$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $39f720b7c6e5b098$var$endReadable(this);
        else $39f720b7c6e5b098$var$emitReadable(this);
        return null;
    }
    n = $39f720b7c6e5b098$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $39f720b7c6e5b098$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $39f720b7c6e5b098$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $39f720b7c6e5b098$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $39f720b7c6e5b098$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $39f720b7c6e5b098$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $39f720b7c6e5b098$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $39f720b7c6e5b098$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $39f720b7c6e5b098$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $39f720b7c6e5b098$var$onEofChunk(stream, state) {
    $39f720b7c6e5b098$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $39f720b7c6e5b098$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $39f720b7c6e5b098$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $39f720b7c6e5b098$var$emitReadable(stream) {
    var state = stream._readableState;
    $39f720b7c6e5b098$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $39f720b7c6e5b098$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $igDjg.nextTick($39f720b7c6e5b098$var$emitReadable_, stream);
    }
}
function $39f720b7c6e5b098$var$emitReadable_(stream) {
    var state = stream._readableState;
    $39f720b7c6e5b098$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $39f720b7c6e5b098$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $39f720b7c6e5b098$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $igDjg.nextTick($39f720b7c6e5b098$var$maybeReadMore_, stream, state);
    }
}
function $39f720b7c6e5b098$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $39f720b7c6e5b098$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$39f720b7c6e5b098$var$Readable.prototype._read = function(n) {
    $39f720b7c6e5b098$var$errorOrDestroy(this, new $39f720b7c6e5b098$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
$39f720b7c6e5b098$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $39f720b7c6e5b098$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $igDjg.stdout && dest !== $igDjg.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $igDjg.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $39f720b7c6e5b098$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $39f720b7c6e5b098$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $39f720b7c6e5b098$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $39f720b7c6e5b098$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $39f720b7c6e5b098$var$debug('ondata');
        var ret = dest.write(chunk);
        $39f720b7c6e5b098$var$debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $39f720b7c6e5b098$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $39f720b7c6e5b098$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $39f720b7c6e5b098$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($39f720b7c6e5b098$var$EElistenerCount(dest, 'error') === 0) $39f720b7c6e5b098$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $39f720b7c6e5b098$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $39f720b7c6e5b098$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $39f720b7c6e5b098$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $39f720b7c6e5b098$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $39f720b7c6e5b098$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $39f720b7c6e5b098$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $39f720b7c6e5b098$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $39f720b7c6e5b098$var$flow(src);
        }
    };
}
$39f720b7c6e5b098$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $39f720b7c6e5b098$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$39f720b7c6e5b098$var$Readable.prototype.on = function(ev, fn) {
    var res = $duXG6.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $39f720b7c6e5b098$var$debug('on readable', state.length, state.reading);
            if (state.length) $39f720b7c6e5b098$var$emitReadable(this);
            else if (!state.reading) $igDjg.nextTick($39f720b7c6e5b098$var$nReadingNextTick, this);
        }
    }
    return res;
};
$39f720b7c6e5b098$var$Readable.prototype.addListener = $39f720b7c6e5b098$var$Readable.prototype.on;
$39f720b7c6e5b098$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $duXG6.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $igDjg.nextTick($39f720b7c6e5b098$var$updateReadableListening, this);
    return res;
};
$39f720b7c6e5b098$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $duXG6.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $igDjg.nextTick($39f720b7c6e5b098$var$updateReadableListening, this);
    return res;
};
function $39f720b7c6e5b098$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function $39f720b7c6e5b098$var$nReadingNextTick(self1) {
    $39f720b7c6e5b098$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$39f720b7c6e5b098$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $39f720b7c6e5b098$var$debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $39f720b7c6e5b098$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $39f720b7c6e5b098$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $igDjg.nextTick($39f720b7c6e5b098$var$resume_, stream, state);
    }
}
function $39f720b7c6e5b098$var$resume_(stream, state) {
    $39f720b7c6e5b098$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $39f720b7c6e5b098$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$39f720b7c6e5b098$var$Readable.prototype.pause = function() {
    $39f720b7c6e5b098$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $39f720b7c6e5b098$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function $39f720b7c6e5b098$var$flow(stream) {
    var state = stream._readableState;
    $39f720b7c6e5b098$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$39f720b7c6e5b098$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $39f720b7c6e5b098$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $39f720b7c6e5b098$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $39f720b7c6e5b098$var$kProxyEvents.length; n++)stream.on($39f720b7c6e5b098$var$kProxyEvents[n], this.emit.bind(this, $39f720b7c6e5b098$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $39f720b7c6e5b098$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === 'function') $39f720b7c6e5b098$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($39f720b7c6e5b098$var$createReadableStreamAsyncIterator === undefined) $39f720b7c6e5b098$var$createReadableStreamAsyncIterator = (parcelRequire("iPsLK"));
    return $39f720b7c6e5b098$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($39f720b7c6e5b098$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($39f720b7c6e5b098$var$Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($39f720b7c6e5b098$var$Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$39f720b7c6e5b098$var$Readable._fromList = $39f720b7c6e5b098$var$fromList;
Object.defineProperty($39f720b7c6e5b098$var$Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $39f720b7c6e5b098$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $39f720b7c6e5b098$var$endReadable(stream) {
    var state = stream._readableState;
    $39f720b7c6e5b098$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $igDjg.nextTick($39f720b7c6e5b098$var$endReadableNT, state, stream);
    }
}
function $39f720b7c6e5b098$var$endReadableNT(state, stream) {
    $39f720b7c6e5b098$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === 'function') $39f720b7c6e5b098$var$Readable.from = function(iterable, opts) {
    if ($39f720b7c6e5b098$var$from === undefined) $39f720b7c6e5b098$var$from = (parcelRequire("fkKSr"));
    return $39f720b7c6e5b098$var$from($39f720b7c6e5b098$var$Readable, iterable, opts);
};
function $39f720b7c6e5b098$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("duXG6", function(module, exports) {

module.exports = (parcelRequire("7OU8o")).EventEmitter;

});

parcelRegister("4bmRn", function(module, exports) {
'use strict';
function $30b9ec017e732106$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $30b9ec017e732106$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $30b9ec017e732106$var$ownKeys(Object(source), !0).forEach(function(key) {
            $30b9ec017e732106$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $30b9ec017e732106$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $30b9ec017e732106$var$_defineProperty(obj, key, value) {
    key = $30b9ec017e732106$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $30b9ec017e732106$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $30b9ec017e732106$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $30b9ec017e732106$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $30b9ec017e732106$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $30b9ec017e732106$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $30b9ec017e732106$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $30b9ec017e732106$var$_toPropertyKey(arg) {
    var key = $30b9ec017e732106$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $30b9ec017e732106$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $5Ovjr = parcelRequire("5Ovjr");
var $30b9ec017e732106$var$Buffer = $5Ovjr.Buffer;

var $lOA8N = parcelRequire("lOA8N");
var $30b9ec017e732106$var$inspect = $lOA8N.inspect;
var $30b9ec017e732106$var$custom = $30b9ec017e732106$var$inspect && $30b9ec017e732106$var$inspect.custom || 'inspect';
function $30b9ec017e732106$var$copyBuffer(src, target, offset) {
    $30b9ec017e732106$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $30b9ec017e732106$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $30b9ec017e732106$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $30b9ec017e732106$var$Buffer.alloc(0);
                var ret = $30b9ec017e732106$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $30b9ec017e732106$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $30b9ec017e732106$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $30b9ec017e732106$var$custom,
            value: function value(_, options) {
                return $30b9ec017e732106$var$inspect(this, $30b9ec017e732106$var$_objectSpread($30b9ec017e732106$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("dxOnz", function(module, exports) {

var $igDjg = parcelRequire("igDjg");
'use strict';
// undocumented cb() API, needed for core, not for public API
function $9dc56fab3b95b272$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $igDjg.nextTick($9dc56fab3b95b272$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $igDjg.nextTick($9dc56fab3b95b272$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $igDjg.nextTick($9dc56fab3b95b272$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $igDjg.nextTick($9dc56fab3b95b272$var$emitErrorAndCloseNT, _this, err);
            } else $igDjg.nextTick($9dc56fab3b95b272$var$emitCloseNT, _this);
        } else if (cb) {
            $igDjg.nextTick($9dc56fab3b95b272$var$emitCloseNT, _this);
            cb(err);
        } else $igDjg.nextTick($9dc56fab3b95b272$var$emitCloseNT, _this);
    });
    return this;
}
function $9dc56fab3b95b272$var$emitErrorAndCloseNT(self, err) {
    $9dc56fab3b95b272$var$emitErrorNT(self, err);
    $9dc56fab3b95b272$var$emitCloseNT(self);
}
function $9dc56fab3b95b272$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function $9dc56fab3b95b272$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $9dc56fab3b95b272$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
function $9dc56fab3b95b272$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: $9dc56fab3b95b272$var$destroy,
    undestroy: $9dc56fab3b95b272$var$undestroy,
    errorOrDestroy: $9dc56fab3b95b272$var$errorOrDestroy
};

});

parcelRegister("5epc0", function(module, exports) {
'use strict';

var $3cf1cd4d43cc2d30$var$ERR_INVALID_OPT_VALUE = (parcelRequire("5AwkU")).codes.ERR_INVALID_OPT_VALUE;
function $3cf1cd4d43cc2d30$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $3cf1cd4d43cc2d30$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $3cf1cd4d43cc2d30$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new $3cf1cd4d43cc2d30$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $3cf1cd4d43cc2d30$var$getHighWaterMark
};

});
parcelRegister("5AwkU", function(module, exports) {
$parcel$export(module.exports, "codes", () => $411965d667e880b8$export$e45cb6485273080e, (v) => $411965d667e880b8$export$e45cb6485273080e = v);
var $411965d667e880b8$export$e45cb6485273080e;
'use strict';
function $411965d667e880b8$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $411965d667e880b8$var$codes = {};
function $411965d667e880b8$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $411965d667e880b8$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $411965d667e880b8$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $411965d667e880b8$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $411965d667e880b8$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $411965d667e880b8$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $411965d667e880b8$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$411965d667e880b8$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$411965d667e880b8$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $411965d667e880b8$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($411965d667e880b8$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($411965d667e880b8$var$oneOf(expected, 'type'));
    else {
        var type = $411965d667e880b8$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($411965d667e880b8$var$oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$411965d667e880b8$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
$411965d667e880b8$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
$411965d667e880b8$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
$411965d667e880b8$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
$411965d667e880b8$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
$411965d667e880b8$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
$411965d667e880b8$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
$411965d667e880b8$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$411965d667e880b8$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
$411965d667e880b8$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
$411965d667e880b8$export$e45cb6485273080e = $411965d667e880b8$var$codes;

});


parcelRegister("gXjNe", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $igDjg = parcelRequire("igDjg");
'use strict';
/*<replacement>*/ var $c581827edb509720$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $c581827edb509720$var$Duplex;

var $4YxZ8 = parcelRequire("4YxZ8");

var $358BL = parcelRequire("358BL");

(parcelRequire("lpcNn"))($c581827edb509720$var$Duplex, $4YxZ8);
// Allow the keys array to be GC'ed.
var $c581827edb509720$var$keys = $c581827edb509720$var$objectKeys($358BL.prototype);
for(var $c581827edb509720$var$v = 0; $c581827edb509720$var$v < $c581827edb509720$var$keys.length; $c581827edb509720$var$v++){
    var $c581827edb509720$var$method = $c581827edb509720$var$keys[$c581827edb509720$var$v];
    if (!$c581827edb509720$var$Duplex.prototype[$c581827edb509720$var$method]) $c581827edb509720$var$Duplex.prototype[$c581827edb509720$var$method] = $358BL.prototype[$c581827edb509720$var$method];
}
function $c581827edb509720$var$Duplex(options) {
    if (!(this instanceof $c581827edb509720$var$Duplex)) return new $c581827edb509720$var$Duplex(options);
    $4YxZ8.call(this, options);
    $358BL.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', $c581827edb509720$var$onend);
        }
    }
}
Object.defineProperty($c581827edb509720$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($c581827edb509720$var$Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($c581827edb509720$var$Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $c581827edb509720$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $igDjg.nextTick($c581827edb509720$var$onEndNT, this);
}
function $c581827edb509720$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($c581827edb509720$var$Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("358BL", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $igDjg = parcelRequire("igDjg");
'use strict';
module.exports = $23e8841c62ca9eaf$var$Writable;
/* <replacement> */ function $23e8841c62ca9eaf$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $23e8841c62ca9eaf$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $23e8841c62ca9eaf$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $23e8841c62ca9eaf$var$Duplex;
/*</replacement>*/ $23e8841c62ca9eaf$var$Writable.WritableState = $23e8841c62ca9eaf$var$WritableState;

/*<replacement>*/ var $23e8841c62ca9eaf$var$internalUtil = {
    deprecate: (parcelRequire("aULhc"))
};

var $duXG6 = parcelRequire("duXG6");

var $5Ovjr = parcelRequire("5Ovjr");
var $23e8841c62ca9eaf$require$Buffer = $5Ovjr.Buffer;
var $23e8841c62ca9eaf$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $23e8841c62ca9eaf$var$_uint8ArrayToBuffer(chunk) {
    return $23e8841c62ca9eaf$require$Buffer.from(chunk);
}
function $23e8841c62ca9eaf$var$_isUint8Array(obj) {
    return $23e8841c62ca9eaf$require$Buffer.isBuffer(obj) || obj instanceof $23e8841c62ca9eaf$var$OurUint8Array;
}

var $dxOnz = parcelRequire("dxOnz");

var $5epc0 = parcelRequire("5epc0");
var $23e8841c62ca9eaf$var$getHighWaterMark = $5epc0.getHighWaterMark;

var $5AwkU = parcelRequire("5AwkU");
var $23e8841c62ca9eaf$require$_require$codes = $5AwkU.codes;
var $23e8841c62ca9eaf$var$ERR_INVALID_ARG_TYPE = $23e8841c62ca9eaf$require$_require$codes.ERR_INVALID_ARG_TYPE, $23e8841c62ca9eaf$var$ERR_METHOD_NOT_IMPLEMENTED = $23e8841c62ca9eaf$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $23e8841c62ca9eaf$var$ERR_MULTIPLE_CALLBACK = $23e8841c62ca9eaf$require$_require$codes.ERR_MULTIPLE_CALLBACK, $23e8841c62ca9eaf$var$ERR_STREAM_CANNOT_PIPE = $23e8841c62ca9eaf$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $23e8841c62ca9eaf$var$ERR_STREAM_DESTROYED = $23e8841c62ca9eaf$require$_require$codes.ERR_STREAM_DESTROYED, $23e8841c62ca9eaf$var$ERR_STREAM_NULL_VALUES = $23e8841c62ca9eaf$require$_require$codes.ERR_STREAM_NULL_VALUES, $23e8841c62ca9eaf$var$ERR_STREAM_WRITE_AFTER_END = $23e8841c62ca9eaf$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $23e8841c62ca9eaf$var$ERR_UNKNOWN_ENCODING = $23e8841c62ca9eaf$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $23e8841c62ca9eaf$var$errorOrDestroy = $dxOnz.errorOrDestroy;

(parcelRequire("lpcNn"))($23e8841c62ca9eaf$var$Writable, $duXG6);
function $23e8841c62ca9eaf$var$nop() {}

function $23e8841c62ca9eaf$var$WritableState(options, stream, isDuplex) {
    $23e8841c62ca9eaf$var$Duplex = $23e8841c62ca9eaf$var$Duplex || (parcelRequire("gXjNe"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $23e8841c62ca9eaf$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $23e8841c62ca9eaf$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $23e8841c62ca9eaf$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $23e8841c62ca9eaf$var$CorkedRequest(this);
}
$23e8841c62ca9eaf$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($23e8841c62ca9eaf$var$WritableState.prototype, 'buffer', {
            get: $23e8841c62ca9eaf$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $23e8841c62ca9eaf$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $23e8841c62ca9eaf$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($23e8841c62ca9eaf$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($23e8841c62ca9eaf$var$realHasInstance.call(this, object)) return true;
            if (this !== $23e8841c62ca9eaf$var$Writable) return false;
            return object && object._writableState instanceof $23e8841c62ca9eaf$var$WritableState;
        }
    });
} else $23e8841c62ca9eaf$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $23e8841c62ca9eaf$var$Writable(options) {
    $23e8841c62ca9eaf$var$Duplex = $23e8841c62ca9eaf$var$Duplex || (parcelRequire("gXjNe"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $23e8841c62ca9eaf$var$Duplex;
    if (!isDuplex && !$23e8841c62ca9eaf$var$realHasInstance.call($23e8841c62ca9eaf$var$Writable, this)) return new $23e8841c62ca9eaf$var$Writable(options);
    this._writableState = new $23e8841c62ca9eaf$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $duXG6.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$23e8841c62ca9eaf$var$Writable.prototype.pipe = function() {
    $23e8841c62ca9eaf$var$errorOrDestroy(this, new $23e8841c62ca9eaf$var$ERR_STREAM_CANNOT_PIPE());
};
function $23e8841c62ca9eaf$var$writeAfterEnd(stream, cb) {
    var er = new $23e8841c62ca9eaf$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $23e8841c62ca9eaf$var$errorOrDestroy(stream, er);
    $igDjg.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $23e8841c62ca9eaf$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $23e8841c62ca9eaf$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new $23e8841c62ca9eaf$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        $23e8841c62ca9eaf$var$errorOrDestroy(stream, er);
        $igDjg.nextTick(cb, er);
        return false;
    }
    return true;
}
$23e8841c62ca9eaf$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $23e8841c62ca9eaf$var$_isUint8Array(chunk);
    if (isBuf && !$23e8841c62ca9eaf$require$Buffer.isBuffer(chunk)) chunk = $23e8841c62ca9eaf$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $23e8841c62ca9eaf$var$nop;
    if (state.ending) $23e8841c62ca9eaf$var$writeAfterEnd(this, cb);
    else if (isBuf || $23e8841c62ca9eaf$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $23e8841c62ca9eaf$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$23e8841c62ca9eaf$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$23e8841c62ca9eaf$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $23e8841c62ca9eaf$var$clearBuffer(this, state);
    }
};
$23e8841c62ca9eaf$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $23e8841c62ca9eaf$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($23e8841c62ca9eaf$var$Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $23e8841c62ca9eaf$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $23e8841c62ca9eaf$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($23e8841c62ca9eaf$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $23e8841c62ca9eaf$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $23e8841c62ca9eaf$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $23e8841c62ca9eaf$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $23e8841c62ca9eaf$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $23e8841c62ca9eaf$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $23e8841c62ca9eaf$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $igDjg.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $igDjg.nextTick($23e8841c62ca9eaf$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $23e8841c62ca9eaf$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $23e8841c62ca9eaf$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $23e8841c62ca9eaf$var$finishMaybe(stream, state);
    }
}
function $23e8841c62ca9eaf$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $23e8841c62ca9eaf$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new $23e8841c62ca9eaf$var$ERR_MULTIPLE_CALLBACK();
    $23e8841c62ca9eaf$var$onwriteStateUpdate(state);
    if (er) $23e8841c62ca9eaf$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $23e8841c62ca9eaf$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $23e8841c62ca9eaf$var$clearBuffer(stream, state);
        if (sync) $igDjg.nextTick($23e8841c62ca9eaf$var$afterWrite, stream, state, finished, cb);
        else $23e8841c62ca9eaf$var$afterWrite(stream, state, finished, cb);
    }
}
function $23e8841c62ca9eaf$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $23e8841c62ca9eaf$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $23e8841c62ca9eaf$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $23e8841c62ca9eaf$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $23e8841c62ca9eaf$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $23e8841c62ca9eaf$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $23e8841c62ca9eaf$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $23e8841c62ca9eaf$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$23e8841c62ca9eaf$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $23e8841c62ca9eaf$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
$23e8841c62ca9eaf$var$Writable.prototype._writev = null;
$23e8841c62ca9eaf$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $23e8841c62ca9eaf$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($23e8841c62ca9eaf$var$Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $23e8841c62ca9eaf$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $23e8841c62ca9eaf$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $23e8841c62ca9eaf$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        $23e8841c62ca9eaf$var$finishMaybe(stream, state);
    });
}
function $23e8841c62ca9eaf$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $igDjg.nextTick($23e8841c62ca9eaf$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $23e8841c62ca9eaf$var$finishMaybe(stream, state) {
    var need = $23e8841c62ca9eaf$var$needFinish(state);
    if (need) {
        $23e8841c62ca9eaf$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $23e8841c62ca9eaf$var$endWritable(stream, state, cb) {
    state.ending = true;
    $23e8841c62ca9eaf$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $igDjg.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $23e8841c62ca9eaf$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($23e8841c62ca9eaf$var$Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$23e8841c62ca9eaf$var$Writable.prototype.destroy = $dxOnz.destroy;
$23e8841c62ca9eaf$var$Writable.prototype._undestroy = $dxOnz.undestroy;
$23e8841c62ca9eaf$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("aULhc", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $7f23ce73abc7e948$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $7f23ce73abc7e948$var$deprecate(fn, msg) {
    if ($7f23ce73abc7e948$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($7f23ce73abc7e948$var$config('throwDeprecation')) throw new Error(msg);
            else if ($7f23ce73abc7e948$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $7f23ce73abc7e948$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});



parcelRegister("2Sdak", function(module, exports) {
$parcel$export(module.exports, "StringDecoder", () => $217ad655d15aa455$export$63a7aa211a91ed69, (v) => $217ad655d15aa455$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $217ad655d15aa455$export$63a7aa211a91ed69;
'use strict';

var $bc1ju = parcelRequire("bc1ju");
var $217ad655d15aa455$require$Buffer = $bc1ju.Buffer;
/*</replacement>*/ var $217ad655d15aa455$var$isEncoding = $217ad655d15aa455$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $217ad655d15aa455$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $217ad655d15aa455$var$normalizeEncoding(enc) {
    var nenc = $217ad655d15aa455$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($217ad655d15aa455$require$Buffer.isEncoding === $217ad655d15aa455$var$isEncoding || !$217ad655d15aa455$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$217ad655d15aa455$export$63a7aa211a91ed69 = $217ad655d15aa455$var$StringDecoder;
function $217ad655d15aa455$var$StringDecoder(encoding) {
    this.encoding = $217ad655d15aa455$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $217ad655d15aa455$var$utf16Text;
            this.end = $217ad655d15aa455$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $217ad655d15aa455$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $217ad655d15aa455$var$base64Text;
            this.end = $217ad655d15aa455$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $217ad655d15aa455$var$simpleWrite;
            this.end = $217ad655d15aa455$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $217ad655d15aa455$require$Buffer.allocUnsafe(nb);
}
$217ad655d15aa455$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$217ad655d15aa455$var$StringDecoder.prototype.end = $217ad655d15aa455$var$utf8End;
// Returns only complete characters in a Buffer
$217ad655d15aa455$var$StringDecoder.prototype.text = $217ad655d15aa455$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$217ad655d15aa455$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $217ad655d15aa455$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $217ad655d15aa455$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $217ad655d15aa455$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $217ad655d15aa455$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $217ad655d15aa455$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $217ad655d15aa455$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $217ad655d15aa455$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $217ad655d15aa455$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $217ad655d15aa455$var$utf8Text(buf, i) {
    var total = $217ad655d15aa455$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $217ad655d15aa455$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $217ad655d15aa455$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $217ad655d15aa455$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $217ad655d15aa455$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $217ad655d15aa455$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $217ad655d15aa455$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $217ad655d15aa455$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});

parcelRegister("iPsLK", function(module, exports) {

var $igDjg = parcelRequire("igDjg");
'use strict';
var $db534e60299c11c5$var$_Object$setPrototypeO;
function $db534e60299c11c5$var$_defineProperty(obj, key, value) {
    key = $db534e60299c11c5$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $db534e60299c11c5$var$_toPropertyKey(arg) {
    var key = $db534e60299c11c5$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $db534e60299c11c5$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $hplrP = parcelRequire("hplrP");
var $db534e60299c11c5$var$kLastResolve = Symbol('lastResolve');
var $db534e60299c11c5$var$kLastReject = Symbol('lastReject');
var $db534e60299c11c5$var$kError = Symbol('error');
var $db534e60299c11c5$var$kEnded = Symbol('ended');
var $db534e60299c11c5$var$kLastPromise = Symbol('lastPromise');
var $db534e60299c11c5$var$kHandlePromise = Symbol('handlePromise');
var $db534e60299c11c5$var$kStream = Symbol('stream');
function $db534e60299c11c5$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $db534e60299c11c5$var$readAndResolve(iter) {
    var resolve = iter[$db534e60299c11c5$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$db534e60299c11c5$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$db534e60299c11c5$var$kLastPromise] = null;
            iter[$db534e60299c11c5$var$kLastResolve] = null;
            iter[$db534e60299c11c5$var$kLastReject] = null;
            resolve($db534e60299c11c5$var$createIterResult(data, false));
        }
    }
}
function $db534e60299c11c5$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $igDjg.nextTick($db534e60299c11c5$var$readAndResolve, iter);
}
function $db534e60299c11c5$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$db534e60299c11c5$var$kEnded]) {
                resolve($db534e60299c11c5$var$createIterResult(undefined, true));
                return;
            }
            iter[$db534e60299c11c5$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $db534e60299c11c5$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $db534e60299c11c5$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($db534e60299c11c5$var$_Object$setPrototypeO = {
    get stream () {
        return this[$db534e60299c11c5$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$db534e60299c11c5$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$db534e60299c11c5$var$kEnded]) return Promise.resolve($db534e60299c11c5$var$createIterResult(undefined, true));
        if (this[$db534e60299c11c5$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $igDjg.nextTick(function() {
                if (_this[$db534e60299c11c5$var$kError]) reject(_this[$db534e60299c11c5$var$kError]);
                else resolve($db534e60299c11c5$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$db534e60299c11c5$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($db534e60299c11c5$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$db534e60299c11c5$var$kStream].read();
            if (data !== null) return Promise.resolve($db534e60299c11c5$var$createIterResult(data, false));
            promise = new Promise(this[$db534e60299c11c5$var$kHandlePromise]);
        }
        this[$db534e60299c11c5$var$kLastPromise] = promise;
        return promise;
    }
}, $db534e60299c11c5$var$_defineProperty($db534e60299c11c5$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $db534e60299c11c5$var$_defineProperty($db534e60299c11c5$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$db534e60299c11c5$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($db534e60299c11c5$var$createIterResult(undefined, true));
        });
    });
}), $db534e60299c11c5$var$_Object$setPrototypeO), $db534e60299c11c5$var$AsyncIteratorPrototype);
var $db534e60299c11c5$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($db534e60299c11c5$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $db534e60299c11c5$var$_defineProperty(_Object$create, $db534e60299c11c5$var$kStream, {
        value: stream,
        writable: true
    }), $db534e60299c11c5$var$_defineProperty(_Object$create, $db534e60299c11c5$var$kLastResolve, {
        value: null,
        writable: true
    }), $db534e60299c11c5$var$_defineProperty(_Object$create, $db534e60299c11c5$var$kLastReject, {
        value: null,
        writable: true
    }), $db534e60299c11c5$var$_defineProperty(_Object$create, $db534e60299c11c5$var$kError, {
        value: null,
        writable: true
    }), $db534e60299c11c5$var$_defineProperty(_Object$create, $db534e60299c11c5$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $db534e60299c11c5$var$_defineProperty(_Object$create, $db534e60299c11c5$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$db534e60299c11c5$var$kStream].read();
            if (data) {
                iterator[$db534e60299c11c5$var$kLastPromise] = null;
                iterator[$db534e60299c11c5$var$kLastResolve] = null;
                iterator[$db534e60299c11c5$var$kLastReject] = null;
                resolve($db534e60299c11c5$var$createIterResult(data, false));
            } else {
                iterator[$db534e60299c11c5$var$kLastResolve] = resolve;
                iterator[$db534e60299c11c5$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$db534e60299c11c5$var$kLastPromise] = null;
    $hplrP(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[$db534e60299c11c5$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$db534e60299c11c5$var$kLastPromise] = null;
                iterator[$db534e60299c11c5$var$kLastResolve] = null;
                iterator[$db534e60299c11c5$var$kLastReject] = null;
                reject(err);
            }
            iterator[$db534e60299c11c5$var$kError] = err;
            return;
        }
        var resolve = iterator[$db534e60299c11c5$var$kLastResolve];
        if (resolve !== null) {
            iterator[$db534e60299c11c5$var$kLastPromise] = null;
            iterator[$db534e60299c11c5$var$kLastResolve] = null;
            iterator[$db534e60299c11c5$var$kLastReject] = null;
            resolve($db534e60299c11c5$var$createIterResult(undefined, true));
        }
        iterator[$db534e60299c11c5$var$kEnded] = true;
    });
    stream.on('readable', $db534e60299c11c5$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $db534e60299c11c5$var$createReadableStreamAsyncIterator;

});
parcelRegister("hplrP", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $cac5688b31ef9b0b$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("5AwkU")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $cac5688b31ef9b0b$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $cac5688b31ef9b0b$var$noop() {}
function $cac5688b31ef9b0b$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function $cac5688b31ef9b0b$var$eos(stream, opts, callback) {
    if (typeof opts === 'function') return $cac5688b31ef9b0b$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $cac5688b31ef9b0b$var$once(callback || $cac5688b31ef9b0b$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $cac5688b31ef9b0b$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $cac5688b31ef9b0b$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if ($cac5688b31ef9b0b$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = $cac5688b31ef9b0b$var$eos;

});


parcelRegister("fkKSr", function(module, exports) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

});


parcelRegister("lBsbr", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $fba2ea5a88d03f91$var$Transform;

var $5AwkU = parcelRequire("5AwkU");
var $fba2ea5a88d03f91$require$_require$codes = $5AwkU.codes;
var $fba2ea5a88d03f91$var$ERR_METHOD_NOT_IMPLEMENTED = $fba2ea5a88d03f91$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $fba2ea5a88d03f91$var$ERR_MULTIPLE_CALLBACK = $fba2ea5a88d03f91$require$_require$codes.ERR_MULTIPLE_CALLBACK, $fba2ea5a88d03f91$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $fba2ea5a88d03f91$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $fba2ea5a88d03f91$var$ERR_TRANSFORM_WITH_LENGTH_0 = $fba2ea5a88d03f91$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $gXjNe = parcelRequire("gXjNe");

(parcelRequire("lpcNn"))($fba2ea5a88d03f91$var$Transform, $gXjNe);
function $fba2ea5a88d03f91$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new $fba2ea5a88d03f91$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $fba2ea5a88d03f91$var$Transform(options) {
    if (!(this instanceof $fba2ea5a88d03f91$var$Transform)) return new $fba2ea5a88d03f91$var$Transform(options);
    $gXjNe.call(this, options);
    this._transformState = {
        afterTransform: $fba2ea5a88d03f91$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $fba2ea5a88d03f91$var$prefinish);
}
function $fba2ea5a88d03f91$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        $fba2ea5a88d03f91$var$done(_this, er, data);
    });
    else $fba2ea5a88d03f91$var$done(this, null, null);
}
$fba2ea5a88d03f91$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $gXjNe.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$fba2ea5a88d03f91$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $fba2ea5a88d03f91$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
$fba2ea5a88d03f91$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$fba2ea5a88d03f91$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$fba2ea5a88d03f91$var$Transform.prototype._destroy = function(err, cb) {
    $gXjNe.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $fba2ea5a88d03f91$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $fba2ea5a88d03f91$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $fba2ea5a88d03f91$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("1y443", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $120c1e7ff45aa35c$var$PassThrough;

var $lBsbr = parcelRequire("lBsbr");

(parcelRequire("lpcNn"))($120c1e7ff45aa35c$var$PassThrough, $lBsbr);
function $120c1e7ff45aa35c$var$PassThrough(options) {
    if (!(this instanceof $120c1e7ff45aa35c$var$PassThrough)) return new $120c1e7ff45aa35c$var$PassThrough(options);
    $lBsbr.call(this, options);
}
$120c1e7ff45aa35c$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("6s7ke", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var $4b2b0a4381c8ffa9$var$eos;
function $4b2b0a4381c8ffa9$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $5AwkU = parcelRequire("5AwkU");
var $4b2b0a4381c8ffa9$require$_require$codes = $5AwkU.codes;
var $4b2b0a4381c8ffa9$var$ERR_MISSING_ARGS = $4b2b0a4381c8ffa9$require$_require$codes.ERR_MISSING_ARGS, $4b2b0a4381c8ffa9$var$ERR_STREAM_DESTROYED = $4b2b0a4381c8ffa9$require$_require$codes.ERR_STREAM_DESTROYED;
function $4b2b0a4381c8ffa9$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $4b2b0a4381c8ffa9$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}

function $4b2b0a4381c8ffa9$var$destroyer(stream, reading, writing, callback) {
    callback = $4b2b0a4381c8ffa9$var$once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if ($4b2b0a4381c8ffa9$var$eos === undefined) $4b2b0a4381c8ffa9$var$eos = (parcelRequire("hplrP"));
    $4b2b0a4381c8ffa9$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($4b2b0a4381c8ffa9$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new $4b2b0a4381c8ffa9$var$ERR_STREAM_DESTROYED('pipe'));
    };
}
function $4b2b0a4381c8ffa9$var$call(fn) {
    fn();
}
function $4b2b0a4381c8ffa9$var$pipe(from, to) {
    return from.pipe(to);
}
function $4b2b0a4381c8ffa9$var$popCallback(streams) {
    if (!streams.length) return $4b2b0a4381c8ffa9$var$noop;
    if (typeof streams[streams.length - 1] !== 'function') return $4b2b0a4381c8ffa9$var$noop;
    return streams.pop();
}
function $4b2b0a4381c8ffa9$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $4b2b0a4381c8ffa9$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $4b2b0a4381c8ffa9$var$ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $4b2b0a4381c8ffa9$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($4b2b0a4381c8ffa9$var$call);
            if (reading) return;
            destroys.forEach($4b2b0a4381c8ffa9$var$call);
            callback(error);
        });
    });
    return streams.reduce($4b2b0a4381c8ffa9$var$pipe);
}
module.exports = $4b2b0a4381c8ffa9$var$pipeline;

});




parcelRegister("aABar", function(module, exports) {
'use strict';

var $5Ovjr = parcelRequire("5Ovjr");
var $7b5a18dcf6db70d6$require$Buffer = $5Ovjr.Buffer;

var $lpcNn = parcelRequire("lpcNn");

var $6VzRH = parcelRequire("6VzRH");
var $7b5a18dcf6db70d6$var$ARRAY16 = new Array(16);
var $7b5a18dcf6db70d6$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $7b5a18dcf6db70d6$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $7b5a18dcf6db70d6$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $7b5a18dcf6db70d6$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $7b5a18dcf6db70d6$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $7b5a18dcf6db70d6$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $7b5a18dcf6db70d6$var$RIPEMD160() {
    $6VzRH.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$lpcNn($7b5a18dcf6db70d6$var$RIPEMD160, $6VzRH);
$7b5a18dcf6db70d6$var$RIPEMD160.prototype._update = function() {
    var words = $7b5a18dcf6db70d6$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $7b5a18dcf6db70d6$var$fn1(al, bl, cl, dl, el, words[$7b5a18dcf6db70d6$var$zl[i]], $7b5a18dcf6db70d6$var$hl[0], $7b5a18dcf6db70d6$var$sl[i]);
            tr = $7b5a18dcf6db70d6$var$fn5(ar, br, cr, dr, er, words[$7b5a18dcf6db70d6$var$zr[i]], $7b5a18dcf6db70d6$var$hr[0], $7b5a18dcf6db70d6$var$sr[i]);
        } else if (i < 32) {
            tl = $7b5a18dcf6db70d6$var$fn2(al, bl, cl, dl, el, words[$7b5a18dcf6db70d6$var$zl[i]], $7b5a18dcf6db70d6$var$hl[1], $7b5a18dcf6db70d6$var$sl[i]);
            tr = $7b5a18dcf6db70d6$var$fn4(ar, br, cr, dr, er, words[$7b5a18dcf6db70d6$var$zr[i]], $7b5a18dcf6db70d6$var$hr[1], $7b5a18dcf6db70d6$var$sr[i]);
        } else if (i < 48) {
            tl = $7b5a18dcf6db70d6$var$fn3(al, bl, cl, dl, el, words[$7b5a18dcf6db70d6$var$zl[i]], $7b5a18dcf6db70d6$var$hl[2], $7b5a18dcf6db70d6$var$sl[i]);
            tr = $7b5a18dcf6db70d6$var$fn3(ar, br, cr, dr, er, words[$7b5a18dcf6db70d6$var$zr[i]], $7b5a18dcf6db70d6$var$hr[2], $7b5a18dcf6db70d6$var$sr[i]);
        } else if (i < 64) {
            tl = $7b5a18dcf6db70d6$var$fn4(al, bl, cl, dl, el, words[$7b5a18dcf6db70d6$var$zl[i]], $7b5a18dcf6db70d6$var$hl[3], $7b5a18dcf6db70d6$var$sl[i]);
            tr = $7b5a18dcf6db70d6$var$fn2(ar, br, cr, dr, er, words[$7b5a18dcf6db70d6$var$zr[i]], $7b5a18dcf6db70d6$var$hr[3], $7b5a18dcf6db70d6$var$sr[i]);
        } else {
            tl = $7b5a18dcf6db70d6$var$fn5(al, bl, cl, dl, el, words[$7b5a18dcf6db70d6$var$zl[i]], $7b5a18dcf6db70d6$var$hl[4], $7b5a18dcf6db70d6$var$sl[i]);
            tr = $7b5a18dcf6db70d6$var$fn1(ar, br, cr, dr, er, words[$7b5a18dcf6db70d6$var$zr[i]], $7b5a18dcf6db70d6$var$hr[4], $7b5a18dcf6db70d6$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $7b5a18dcf6db70d6$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $7b5a18dcf6db70d6$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$7b5a18dcf6db70d6$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $7b5a18dcf6db70d6$require$Buffer.alloc ? $7b5a18dcf6db70d6$require$Buffer.alloc(20) : new $7b5a18dcf6db70d6$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $7b5a18dcf6db70d6$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $7b5a18dcf6db70d6$var$fn1(a, b, c, d, e, m, k, s) {
    return $7b5a18dcf6db70d6$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $7b5a18dcf6db70d6$var$fn2(a, b, c, d, e, m, k, s) {
    return $7b5a18dcf6db70d6$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $7b5a18dcf6db70d6$var$fn3(a, b, c, d, e, m, k, s) {
    return $7b5a18dcf6db70d6$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $7b5a18dcf6db70d6$var$fn4(a, b, c, d, e, m, k, s) {
    return $7b5a18dcf6db70d6$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $7b5a18dcf6db70d6$var$fn5(a, b, c, d, e, m, k, s) {
    return $7b5a18dcf6db70d6$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $7b5a18dcf6db70d6$var$RIPEMD160;

});

parcelRegister("laOeJ", function(module, exports) {
var $f6a1801cc6915192$var$exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = $f6a1801cc6915192$var$exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)');
    return new Algorithm();
};

$f6a1801cc6915192$var$exports.sha = (parcelRequire("lsWBJ"));

$f6a1801cc6915192$var$exports.sha1 = (parcelRequire("LJk59"));

$f6a1801cc6915192$var$exports.sha224 = (parcelRequire("6nGAA"));

$f6a1801cc6915192$var$exports.sha256 = (parcelRequire("lisQE"));

$f6a1801cc6915192$var$exports.sha384 = (parcelRequire("9fz4y"));

$f6a1801cc6915192$var$exports.sha512 = (parcelRequire("lD3cd"));

});
parcelRegister("lsWBJ", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ 
var $lpcNn = parcelRequire("lpcNn");

var $hAJqV = parcelRequire("hAJqV");

var $bc1ju = parcelRequire("bc1ju");
var $fa09acc3e2e4f447$require$Buffer = $bc1ju.Buffer;
var $fa09acc3e2e4f447$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $fa09acc3e2e4f447$var$W = new Array(80);
function $fa09acc3e2e4f447$var$Sha() {
    this.init();
    this._w = $fa09acc3e2e4f447$var$W;
    $hAJqV.call(this, 64, 56);
}
$lpcNn($fa09acc3e2e4f447$var$Sha, $hAJqV);
$fa09acc3e2e4f447$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $fa09acc3e2e4f447$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $fa09acc3e2e4f447$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $fa09acc3e2e4f447$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$fa09acc3e2e4f447$var$Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $fa09acc3e2e4f447$var$rotl5(a) + $fa09acc3e2e4f447$var$ft(s, b, c, d) + e + W[j] + $fa09acc3e2e4f447$var$K[s] | 0;
        e = d;
        d = c;
        c = $fa09acc3e2e4f447$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$fa09acc3e2e4f447$var$Sha.prototype._hash = function() {
    var H = $fa09acc3e2e4f447$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $fa09acc3e2e4f447$var$Sha;

});
parcelRegister("hAJqV", function(module, exports) {

var $bc1ju = parcelRequire("bc1ju");
var $cce90a93e6eb59d3$require$Buffer = $bc1ju.Buffer;
// prototype class for hash functions
function $cce90a93e6eb59d3$var$Hash(blockSize, finalSize) {
    this._block = $cce90a93e6eb59d3$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$cce90a93e6eb59d3$var$Hash.prototype.update = function(data, enc) {
    if (typeof data === 'string') {
        enc = enc || 'utf8';
        data = $cce90a93e6eb59d3$require$Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$cce90a93e6eb59d3$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$cce90a93e6eb59d3$var$Hash.prototype._update = function() {
    throw new Error('_update must be implemented by subclass');
};
module.exports = $cce90a93e6eb59d3$var$Hash;

});


parcelRegister("LJk59", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ 
var $lpcNn = parcelRequire("lpcNn");

var $hAJqV = parcelRequire("hAJqV");

var $bc1ju = parcelRequire("bc1ju");
var $08f78c15f3f7ce83$require$Buffer = $bc1ju.Buffer;
var $08f78c15f3f7ce83$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $08f78c15f3f7ce83$var$W = new Array(80);
function $08f78c15f3f7ce83$var$Sha1() {
    this.init();
    this._w = $08f78c15f3f7ce83$var$W;
    $hAJqV.call(this, 64, 56);
}
$lpcNn($08f78c15f3f7ce83$var$Sha1, $hAJqV);
$08f78c15f3f7ce83$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $08f78c15f3f7ce83$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $08f78c15f3f7ce83$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $08f78c15f3f7ce83$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $08f78c15f3f7ce83$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$08f78c15f3f7ce83$var$Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = $08f78c15f3f7ce83$var$rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $08f78c15f3f7ce83$var$rotl5(a) + $08f78c15f3f7ce83$var$ft(s, b, c, d) + e + W[j] + $08f78c15f3f7ce83$var$K[s] | 0;
        e = d;
        d = c;
        c = $08f78c15f3f7ce83$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$08f78c15f3f7ce83$var$Sha1.prototype._hash = function() {
    var H = $08f78c15f3f7ce83$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $08f78c15f3f7ce83$var$Sha1;

});

parcelRegister("6nGAA", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $lpcNn = parcelRequire("lpcNn");

var $lisQE = parcelRequire("lisQE");

var $hAJqV = parcelRequire("hAJqV");

var $bc1ju = parcelRequire("bc1ju");
var $4a55ed5ce6dce9cf$require$Buffer = $bc1ju.Buffer;
var $4a55ed5ce6dce9cf$var$W = new Array(64);
function $4a55ed5ce6dce9cf$var$Sha224() {
    this.init();
    this._w = $4a55ed5ce6dce9cf$var$W // new Array(64)
    ;
    $hAJqV.call(this, 64, 56);
}
$lpcNn($4a55ed5ce6dce9cf$var$Sha224, $lisQE);
$4a55ed5ce6dce9cf$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$4a55ed5ce6dce9cf$var$Sha224.prototype._hash = function() {
    var H = $4a55ed5ce6dce9cf$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $4a55ed5ce6dce9cf$var$Sha224;

});
parcelRegister("lisQE", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $lpcNn = parcelRequire("lpcNn");

var $hAJqV = parcelRequire("hAJqV");

var $bc1ju = parcelRequire("bc1ju");
var $f811a811486da313$require$Buffer = $bc1ju.Buffer;
var $f811a811486da313$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $f811a811486da313$var$W = new Array(64);
function $f811a811486da313$var$Sha256() {
    this.init();
    this._w = $f811a811486da313$var$W // new Array(64)
    ;
    $hAJqV.call(this, 64, 56);
}
$lpcNn($f811a811486da313$var$Sha256, $hAJqV);
$f811a811486da313$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $f811a811486da313$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $f811a811486da313$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $f811a811486da313$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $f811a811486da313$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $f811a811486da313$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $f811a811486da313$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$f811a811486da313$var$Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = $f811a811486da313$var$gamma1(W[i - 2]) + W[i - 7] + $f811a811486da313$var$gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $f811a811486da313$var$sigma1(e) + $f811a811486da313$var$ch(e, f, g) + $f811a811486da313$var$K[j] + W[j] | 0;
        var T2 = $f811a811486da313$var$sigma0(a) + $f811a811486da313$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$f811a811486da313$var$Sha256.prototype._hash = function() {
    var H = $f811a811486da313$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $f811a811486da313$var$Sha256;

});


parcelRegister("9fz4y", function(module, exports) {

var $lpcNn = parcelRequire("lpcNn");

var $lD3cd = parcelRequire("lD3cd");

var $hAJqV = parcelRequire("hAJqV");

var $bc1ju = parcelRequire("bc1ju");
var $6bc0b8695d89d025$require$Buffer = $bc1ju.Buffer;
var $6bc0b8695d89d025$var$W = new Array(160);
function $6bc0b8695d89d025$var$Sha384() {
    this.init();
    this._w = $6bc0b8695d89d025$var$W;
    $hAJqV.call(this, 128, 112);
}
$lpcNn($6bc0b8695d89d025$var$Sha384, $lD3cd);
$6bc0b8695d89d025$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$6bc0b8695d89d025$var$Sha384.prototype._hash = function() {
    var H = $6bc0b8695d89d025$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $6bc0b8695d89d025$var$Sha384;

});
parcelRegister("lD3cd", function(module, exports) {

var $lpcNn = parcelRequire("lpcNn");

var $hAJqV = parcelRequire("hAJqV");

var $bc1ju = parcelRequire("bc1ju");
var $fbefb826edd0b9f6$require$Buffer = $bc1ju.Buffer;
var $fbefb826edd0b9f6$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $fbefb826edd0b9f6$var$W = new Array(160);
function $fbefb826edd0b9f6$var$Sha512() {
    this.init();
    this._w = $fbefb826edd0b9f6$var$W;
    $hAJqV.call(this, 128, 112);
}
$lpcNn($fbefb826edd0b9f6$var$Sha512, $hAJqV);
$fbefb826edd0b9f6$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $fbefb826edd0b9f6$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $fbefb826edd0b9f6$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $fbefb826edd0b9f6$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $fbefb826edd0b9f6$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $fbefb826edd0b9f6$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $fbefb826edd0b9f6$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $fbefb826edd0b9f6$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $fbefb826edd0b9f6$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $fbefb826edd0b9f6$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$fbefb826edd0b9f6$var$Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = $fbefb826edd0b9f6$var$Gamma0(xh, xl);
        var gamma0l = $fbefb826edd0b9f6$var$Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = $fbefb826edd0b9f6$var$Gamma1(xh, xl);
        var gamma1l = $fbefb826edd0b9f6$var$Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $fbefb826edd0b9f6$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $fbefb826edd0b9f6$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $fbefb826edd0b9f6$var$getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = $fbefb826edd0b9f6$var$maj(ah, bh, ch);
        var majl = $fbefb826edd0b9f6$var$maj(al, bl, cl);
        var sigma0h = $fbefb826edd0b9f6$var$sigma0(ah, al);
        var sigma0l = $fbefb826edd0b9f6$var$sigma0(al, ah);
        var sigma1h = $fbefb826edd0b9f6$var$sigma1(eh, el);
        var sigma1l = $fbefb826edd0b9f6$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = $fbefb826edd0b9f6$var$K[j];
        var Kil = $fbefb826edd0b9f6$var$K[j + 1];
        var chh = $fbefb826edd0b9f6$var$Ch(eh, fh, gh);
        var chl = $fbefb826edd0b9f6$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $fbefb826edd0b9f6$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $fbefb826edd0b9f6$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $fbefb826edd0b9f6$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $fbefb826edd0b9f6$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $fbefb826edd0b9f6$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $fbefb826edd0b9f6$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $fbefb826edd0b9f6$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $fbefb826edd0b9f6$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $fbefb826edd0b9f6$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $fbefb826edd0b9f6$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $fbefb826edd0b9f6$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $fbefb826edd0b9f6$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $fbefb826edd0b9f6$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $fbefb826edd0b9f6$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $fbefb826edd0b9f6$var$getCarry(this._hl, hl) | 0;
};
$fbefb826edd0b9f6$var$Sha512.prototype._hash = function() {
    var H = $fbefb826edd0b9f6$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $fbefb826edd0b9f6$var$Sha512;

});



parcelRegister("3T1AC", function(module, exports) {

var $bc1ju = parcelRequire("bc1ju");
var $2d47bdd2b4b2a104$require$Buffer = $bc1ju.Buffer;

var $flUTc = parcelRequire("flUTc");
var $2d47bdd2b4b2a104$require$Transform = $flUTc.Transform;

var $2Sdak = parcelRequire("2Sdak");
var $2d47bdd2b4b2a104$require$StringDecoder = $2Sdak.StringDecoder;

var $lpcNn = parcelRequire("lpcNn");
function $2d47bdd2b4b2a104$var$CipherBase(hashMode) {
    $2d47bdd2b4b2a104$require$Transform.call(this);
    this.hashMode = typeof hashMode === 'string';
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this.final = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$lpcNn($2d47bdd2b4b2a104$var$CipherBase, $2d47bdd2b4b2a104$require$Transform);
$2d47bdd2b4b2a104$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    if (typeof data === 'string') data = $2d47bdd2b4b2a104$require$Buffer.from(data, inputEnc);
    var outData = this._update(data);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$2d47bdd2b4b2a104$var$CipherBase.prototype.setAutoPadding = function() {};
$2d47bdd2b4b2a104$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error('trying to get auth tag in unsupported state');
};
$2d47bdd2b4b2a104$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error('trying to set auth tag in unsupported state');
};
$2d47bdd2b4b2a104$var$CipherBase.prototype.setAAD = function() {
    throw new Error('trying to set aad in unsupported state');
};
$2d47bdd2b4b2a104$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$2d47bdd2b4b2a104$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$2d47bdd2b4b2a104$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $2d47bdd2b4b2a104$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$2d47bdd2b4b2a104$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $2d47bdd2b4b2a104$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error('can\'t switch encodings');
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $2d47bdd2b4b2a104$var$CipherBase;

});


parcelRegister("6Gm8U", function(module, exports) {
'use strict';

var $lpcNn = parcelRequire("lpcNn");

var $iHYaE = parcelRequire("iHYaE");

var $3T1AC = parcelRequire("3T1AC");

var $bc1ju = parcelRequire("bc1ju");
var $4dd7d7679702d307$require$Buffer = $bc1ju.Buffer;

var $bfiBY = parcelRequire("bfiBY");

var $aABar = parcelRequire("aABar");

var $laOeJ = parcelRequire("laOeJ");
var $4dd7d7679702d307$var$ZEROS = $4dd7d7679702d307$require$Buffer.alloc(128);
function $4dd7d7679702d307$var$Hmac(alg, key) {
    $3T1AC.call(this, 'digest');
    if (typeof key === 'string') key = $4dd7d7679702d307$require$Buffer.from(key);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === 'rmd160' ? new $aABar() : $laOeJ(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $4dd7d7679702d307$require$Buffer.concat([
        key,
        $4dd7d7679702d307$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $4dd7d7679702d307$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $4dd7d7679702d307$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === 'rmd160' ? new $aABar() : $laOeJ(alg);
    this._hash.update(ipad);
}
$lpcNn($4dd7d7679702d307$var$Hmac, $3T1AC);
$4dd7d7679702d307$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$4dd7d7679702d307$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === 'rmd160' ? new $aABar() : $laOeJ(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $4dd7d7679702d307$var$Hmac('rmd160', key);
    if (alg === 'md5') return new $iHYaE($bfiBY, key);
    return new $4dd7d7679702d307$var$Hmac(alg, key);
};

});
parcelRegister("iHYaE", function(module, exports) {
'use strict';

var $lpcNn = parcelRequire("lpcNn");

var $bc1ju = parcelRequire("bc1ju");
var $d9eaeacf75841ecf$require$Buffer = $bc1ju.Buffer;

var $3T1AC = parcelRequire("3T1AC");
var $d9eaeacf75841ecf$var$ZEROS = $d9eaeacf75841ecf$require$Buffer.alloc(128);
var $d9eaeacf75841ecf$var$blocksize = 64;
function $d9eaeacf75841ecf$var$Hmac(alg, key) {
    $3T1AC.call(this, 'digest');
    if (typeof key === 'string') key = $d9eaeacf75841ecf$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $d9eaeacf75841ecf$var$blocksize) key = alg(key);
    else if (key.length < $d9eaeacf75841ecf$var$blocksize) key = $d9eaeacf75841ecf$require$Buffer.concat([
        key,
        $d9eaeacf75841ecf$var$ZEROS
    ], $d9eaeacf75841ecf$var$blocksize);
    var ipad = this._ipad = $d9eaeacf75841ecf$require$Buffer.allocUnsafe($d9eaeacf75841ecf$var$blocksize);
    var opad = this._opad = $d9eaeacf75841ecf$require$Buffer.allocUnsafe($d9eaeacf75841ecf$var$blocksize);
    for(var i = 0; i < $d9eaeacf75841ecf$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$lpcNn($d9eaeacf75841ecf$var$Hmac, $3T1AC);
$d9eaeacf75841ecf$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$d9eaeacf75841ecf$var$Hmac.prototype._final = function() {
    var h = this._alg($d9eaeacf75841ecf$require$Buffer.concat(this._hash));
    return this._alg($d9eaeacf75841ecf$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $d9eaeacf75841ecf$var$Hmac;

});

parcelRegister("bfiBY", function(module, exports) {

var $a8EwA = parcelRequire("a8EwA");
module.exports = function(buffer) {
    return new $a8EwA().update(buffer).digest();
};

});


parcelRegister("5zKpg", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3XBoT"));

});
parcelRegister("3XBoT", function(module, exports) {
module.exports = JSON.parse("{\"sha224WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"RSA-SHA224\":{\"sign\":\"ecdsa\\/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha256WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"RSA-SHA256\":{\"sign\":\"ecdsa\\/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha384WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"RSA-SHA384\":{\"sign\":\"ecdsa\\/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA512\":{\"sign\":\"ecdsa\\/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA1\":{\"sign\":\"rsa\",\"hash\":\"sha1\",\"id\":\"3021300906052b0e03021a05000414\"},\"ecdsa-with-SHA1\":{\"sign\":\"ecdsa\",\"hash\":\"sha1\",\"id\":\"\"},\"sha256\":{\"sign\":\"ecdsa\",\"hash\":\"sha256\",\"id\":\"\"},\"sha224\":{\"sign\":\"ecdsa\",\"hash\":\"sha224\",\"id\":\"\"},\"sha384\":{\"sign\":\"ecdsa\",\"hash\":\"sha384\",\"id\":\"\"},\"sha512\":{\"sign\":\"ecdsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-SHA1\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-WITH-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-WITH-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-WITH-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-WITH-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-RIPEMD160\":{\"sign\":\"dsa\",\"hash\":\"rmd160\",\"id\":\"\"},\"ripemd160WithRSA\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"RSA-RIPEMD160\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"md5WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"},\"RSA-MD5\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"}}");

});


parcelRegister("ljyV3", function(module, exports) {
$parcel$export(module.exports, "pbkdf2", () => $f84675938e3c28bb$export$448fa22aedc9dbca, (v) => $f84675938e3c28bb$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $f84675938e3c28bb$export$b80c7ba289c8fa56, (v) => $f84675938e3c28bb$export$b80c7ba289c8fa56 = v);
var $f84675938e3c28bb$export$448fa22aedc9dbca;
var $f84675938e3c28bb$export$b80c7ba289c8fa56;

$f84675938e3c28bb$export$448fa22aedc9dbca = (parcelRequire("iRzD9"));

$f84675938e3c28bb$export$b80c7ba289c8fa56 = (parcelRequire("lfi0j"));

});
parcelRegister("iRzD9", function(module, exports) {

var $bc1ju = parcelRequire("bc1ju");
var $dbb8d0aeb8f26630$require$Buffer = $bc1ju.Buffer;

var $cqTB9 = parcelRequire("cqTB9");

var $4N6ib = parcelRequire("4N6ib");

var $lfi0j = parcelRequire("lfi0j");

var $9CqDT = parcelRequire("9CqDT");
var $dbb8d0aeb8f26630$var$ZERO_BUF;
var $dbb8d0aeb8f26630$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $dbb8d0aeb8f26630$var$toBrowser = {
    sha: 'SHA-1',
    'sha-1': 'SHA-1',
    sha1: 'SHA-1',
    sha256: 'SHA-256',
    'sha-256': 'SHA-256',
    sha384: 'SHA-384',
    'sha-384': 'SHA-384',
    'sha-512': 'SHA-512',
    sha512: 'SHA-512'
};
var $dbb8d0aeb8f26630$var$checks = [];
function $dbb8d0aeb8f26630$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$dbb8d0aeb8f26630$var$subtle || !$dbb8d0aeb8f26630$var$subtle.importKey || !$dbb8d0aeb8f26630$var$subtle.deriveBits) return Promise.resolve(false);
    if ($dbb8d0aeb8f26630$var$checks[algo] !== undefined) return $dbb8d0aeb8f26630$var$checks[algo];
    $dbb8d0aeb8f26630$var$ZERO_BUF = $dbb8d0aeb8f26630$var$ZERO_BUF || $dbb8d0aeb8f26630$require$Buffer.alloc(8);
    var prom = $dbb8d0aeb8f26630$var$browserPbkdf2($dbb8d0aeb8f26630$var$ZERO_BUF, $dbb8d0aeb8f26630$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }).catch(function() {
        return false;
    });
    $dbb8d0aeb8f26630$var$checks[algo] = prom;
    return prom;
}
var $dbb8d0aeb8f26630$var$nextTick;
function $dbb8d0aeb8f26630$var$getNextTick() {
    if ($dbb8d0aeb8f26630$var$nextTick) return $dbb8d0aeb8f26630$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $dbb8d0aeb8f26630$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $dbb8d0aeb8f26630$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $dbb8d0aeb8f26630$var$nextTick = $parcel$global.setImmediate;
    else $dbb8d0aeb8f26630$var$nextTick = $parcel$global.setTimeout;
    return $dbb8d0aeb8f26630$var$nextTick;
}
function $dbb8d0aeb8f26630$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $dbb8d0aeb8f26630$var$subtle.importKey('raw', password, {
        name: 'PBKDF2'
    }, false, [
        'deriveBits'
    ]).then(function(key) {
        return $dbb8d0aeb8f26630$var$subtle.deriveBits({
            name: 'PBKDF2',
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $dbb8d0aeb8f26630$require$Buffer.from(res);
    });
}
function $dbb8d0aeb8f26630$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $dbb8d0aeb8f26630$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $dbb8d0aeb8f26630$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === 'function') {
        callback = digest;
        digest = undefined;
    }
    digest = digest || 'sha1';
    var algo = $dbb8d0aeb8f26630$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== 'function') {
        $dbb8d0aeb8f26630$var$getNextTick()(function() {
            var out;
            try {
                out = $lfi0j(password, salt, iterations, keylen, digest);
            } catch (e) {
                return callback(e);
            }
            callback(null, out);
        });
        return;
    }
    $cqTB9(iterations, keylen);
    password = $9CqDT(password, $4N6ib, 'Password');
    salt = $9CqDT(salt, $4N6ib, 'Salt');
    if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2');
    $dbb8d0aeb8f26630$var$resolvePromise($dbb8d0aeb8f26630$var$checkNative(algo).then(function(resp) {
        if (resp) return $dbb8d0aeb8f26630$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $lfi0j(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("cqTB9", function(module, exports) {
var $90d30a66ac5f6e5c$var$MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs
;
module.exports = function(iterations, keylen) {
    if (typeof iterations !== 'number') throw new TypeError('Iterations not a number');
    if (iterations < 0) throw new TypeError('Bad iterations');
    if (typeof keylen !== 'number') throw new TypeError('Key length not a number');
    if (keylen < 0 || keylen > $90d30a66ac5f6e5c$var$MAX_ALLOC || keylen !== keylen) throw new TypeError('Bad key length');
};

});

parcelRegister("4N6ib", function(module, exports) {

var $igDjg = parcelRequire("igDjg");
var $37d09e8c8445e985$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $37d09e8c8445e985$var$defaultEncoding = 'utf-8';
else if ($parcel$global.process && $parcel$global.process.version) {
    var $37d09e8c8445e985$var$pVersionMajor = parseInt($igDjg.version.split('.')[0].slice(1), 10);
    $37d09e8c8445e985$var$defaultEncoding = $37d09e8c8445e985$var$pVersionMajor >= 6 ? 'utf-8' : 'binary';
} else $37d09e8c8445e985$var$defaultEncoding = 'utf-8';
module.exports = $37d09e8c8445e985$var$defaultEncoding;

});

parcelRegister("lfi0j", function(module, exports) {

var $bfiBY = parcelRequire("bfiBY");

var $aABar = parcelRequire("aABar");

var $laOeJ = parcelRequire("laOeJ");

var $bc1ju = parcelRequire("bc1ju");
var $f778f6ebcca4ec09$require$Buffer = $bc1ju.Buffer;

var $cqTB9 = parcelRequire("cqTB9");

var $4N6ib = parcelRequire("4N6ib");

var $9CqDT = parcelRequire("9CqDT");
var $f778f6ebcca4ec09$var$ZEROS = $f778f6ebcca4ec09$require$Buffer.alloc(128);
var $f778f6ebcca4ec09$var$sizes = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
};
function $f778f6ebcca4ec09$var$Hmac(alg, key, saltLen) {
    var hash = $f778f6ebcca4ec09$var$getDigest(alg);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $f778f6ebcca4ec09$require$Buffer.concat([
        key,
        $f778f6ebcca4ec09$var$ZEROS
    ], blocksize);
    var ipad = $f778f6ebcca4ec09$require$Buffer.allocUnsafe(blocksize + $f778f6ebcca4ec09$var$sizes[alg]);
    var opad = $f778f6ebcca4ec09$require$Buffer.allocUnsafe(blocksize + $f778f6ebcca4ec09$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $f778f6ebcca4ec09$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $f778f6ebcca4ec09$var$sizes[alg];
}
$f778f6ebcca4ec09$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $f778f6ebcca4ec09$var$getDigest(alg) {
    function shaFunc(data) {
        return $laOeJ(alg).update(data).digest();
    }
    function rmd160Func(data) {
        return new $aABar().update(data).digest();
    }
    if (alg === 'rmd160' || alg === 'ripemd160') return rmd160Func;
    if (alg === 'md5') return $bfiBY;
    return shaFunc;
}
function $f778f6ebcca4ec09$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $cqTB9(iterations, keylen);
    password = $9CqDT(password, $4N6ib, 'Password');
    salt = $9CqDT(salt, $4N6ib, 'Salt');
    digest = digest || 'sha1';
    var hmac = new $f778f6ebcca4ec09$var$Hmac(digest, password, salt.length);
    var DK = $f778f6ebcca4ec09$require$Buffer.allocUnsafe(keylen);
    var block1 = $f778f6ebcca4ec09$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = $f778f6ebcca4ec09$var$sizes[digest];
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $f778f6ebcca4ec09$var$pbkdf2;

});
parcelRegister("9CqDT", function(module, exports) {

var $bc1ju = parcelRequire("bc1ju");
var $700c544caafb586d$require$Buffer = $bc1ju.Buffer;
module.exports = function(thing, encoding, name) {
    if ($700c544caafb586d$require$Buffer.isBuffer(thing)) return thing;
    else if (typeof thing === 'string') return $700c544caafb586d$require$Buffer.from(thing, encoding);
    else if (ArrayBuffer.isView(thing)) return $700c544caafb586d$require$Buffer.from(thing.buffer);
    else throw new TypeError(name + ' must be a string, a Buffer, a typed array or a DataView');
};

});




parcelRegister("gx4cO", function(module, exports) {
$parcel$export(module.exports, "createCipher", () => $c092fd8c67dea9e2$export$bdd223f16383713e, (v) => $c092fd8c67dea9e2$export$bdd223f16383713e = v);
$parcel$export(module.exports, "Cipher", () => $c092fd8c67dea9e2$export$26e5786e8ac8e530, (v) => $c092fd8c67dea9e2$export$26e5786e8ac8e530 = v);
$parcel$export(module.exports, "createCipheriv", () => $c092fd8c67dea9e2$export$2f64596b8cbf08b4, (v) => $c092fd8c67dea9e2$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "Cipheriv", () => $c092fd8c67dea9e2$export$20533d26f07f1ee0, (v) => $c092fd8c67dea9e2$export$20533d26f07f1ee0 = v);
$parcel$export(module.exports, "createDecipher", () => $c092fd8c67dea9e2$export$12ada9414fbc594c, (v) => $c092fd8c67dea9e2$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "Decipher", () => $c092fd8c67dea9e2$export$2ce6d8d0e8b04e1a, (v) => $c092fd8c67dea9e2$export$2ce6d8d0e8b04e1a = v);
$parcel$export(module.exports, "createDecipheriv", () => $c092fd8c67dea9e2$export$36b6d6ef312eab39, (v) => $c092fd8c67dea9e2$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "Decipheriv", () => $c092fd8c67dea9e2$export$f5e7e39d57cd9700, (v) => $c092fd8c67dea9e2$export$f5e7e39d57cd9700 = v);
$parcel$export(module.exports, "listCiphers", () => $c092fd8c67dea9e2$export$dedd8dc3dc62b370, (v) => $c092fd8c67dea9e2$export$dedd8dc3dc62b370 = v);
$parcel$export(module.exports, "getCiphers", () => $c092fd8c67dea9e2$export$58a258485f1e49f6, (v) => $c092fd8c67dea9e2$export$58a258485f1e49f6 = v);
var $c092fd8c67dea9e2$export$bdd223f16383713e;
var $c092fd8c67dea9e2$export$26e5786e8ac8e530;
var $c092fd8c67dea9e2$export$2f64596b8cbf08b4;
var $c092fd8c67dea9e2$export$20533d26f07f1ee0;
var $c092fd8c67dea9e2$export$12ada9414fbc594c;
var $c092fd8c67dea9e2$export$2ce6d8d0e8b04e1a;
var $c092fd8c67dea9e2$export$36b6d6ef312eab39;
var $c092fd8c67dea9e2$export$f5e7e39d57cd9700;
var $c092fd8c67dea9e2$export$dedd8dc3dc62b370;
var $c092fd8c67dea9e2$export$58a258485f1e49f6;

var $lZY5o = parcelRequire("lZY5o");

var $7uhwq = parcelRequire("7uhwq");

var $jNEhs = parcelRequire("jNEhs");

var $hmMcl = parcelRequire("hmMcl");

var $cXjgY = parcelRequire("cXjgY");
function $c092fd8c67dea9e2$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($jNEhs[suite]) {
        keyLen = $jNEhs[suite].key;
        ivLen = $jNEhs[suite].iv;
    } else if ($hmMcl[suite]) {
        keyLen = $hmMcl[suite].key * 8;
        ivLen = $hmMcl[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $cXjgY(password, false, keyLen, ivLen);
    return $c092fd8c67dea9e2$var$createCipheriv(suite, keys.key, keys.iv);
}
function $c092fd8c67dea9e2$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($jNEhs[suite]) {
        keyLen = $jNEhs[suite].key;
        ivLen = $jNEhs[suite].iv;
    } else if ($hmMcl[suite]) {
        keyLen = $hmMcl[suite].key * 8;
        ivLen = $hmMcl[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $cXjgY(password, false, keyLen, ivLen);
    return $c092fd8c67dea9e2$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $c092fd8c67dea9e2$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($jNEhs[suite]) return $7uhwq.createCipheriv(suite, key, iv);
    if ($hmMcl[suite]) return new $lZY5o({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError('invalid suite type');
}
function $c092fd8c67dea9e2$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($jNEhs[suite]) return $7uhwq.createDecipheriv(suite, key, iv);
    if ($hmMcl[suite]) return new $lZY5o({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError('invalid suite type');
}
function $c092fd8c67dea9e2$var$getCiphers() {
    return Object.keys($hmMcl).concat($7uhwq.getCiphers());
}
$c092fd8c67dea9e2$export$bdd223f16383713e = $c092fd8c67dea9e2$export$26e5786e8ac8e530 = $c092fd8c67dea9e2$var$createCipher;
$c092fd8c67dea9e2$export$2f64596b8cbf08b4 = $c092fd8c67dea9e2$export$20533d26f07f1ee0 = $c092fd8c67dea9e2$var$createCipheriv;
$c092fd8c67dea9e2$export$12ada9414fbc594c = $c092fd8c67dea9e2$export$2ce6d8d0e8b04e1a = $c092fd8c67dea9e2$var$createDecipher;
$c092fd8c67dea9e2$export$36b6d6ef312eab39 = $c092fd8c67dea9e2$export$f5e7e39d57cd9700 = $c092fd8c67dea9e2$var$createDecipheriv;
$c092fd8c67dea9e2$export$dedd8dc3dc62b370 = $c092fd8c67dea9e2$export$58a258485f1e49f6 = $c092fd8c67dea9e2$var$getCiphers;

});
parcelRegister("lZY5o", function(module, exports) {

var $5Ovjr = parcelRequire("5Ovjr");
var $042207dc02edaa79$require$Buffer = $5Ovjr.Buffer;

var $3T1AC = parcelRequire("3T1AC");

var $lFDWJ = parcelRequire("lFDWJ");

var $lpcNn = parcelRequire("lpcNn");
var $042207dc02edaa79$var$modes = {
    'des-ede3-cbc': $lFDWJ.CBC.instantiate($lFDWJ.EDE),
    'des-ede3': $lFDWJ.EDE,
    'des-ede-cbc': $lFDWJ.CBC.instantiate($lFDWJ.EDE),
    'des-ede': $lFDWJ.EDE,
    'des-cbc': $lFDWJ.CBC.instantiate($lFDWJ.DES),
    'des-ecb': $lFDWJ.DES
};
$042207dc02edaa79$var$modes.des = $042207dc02edaa79$var$modes['des-cbc'];
$042207dc02edaa79$var$modes.des3 = $042207dc02edaa79$var$modes['des-ede3-cbc'];
module.exports = $042207dc02edaa79$var$DES;
$lpcNn($042207dc02edaa79$var$DES, $3T1AC);
function $042207dc02edaa79$var$DES(opts) {
    $3T1AC.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $042207dc02edaa79$var$modes[modeName];
    var type;
    if (opts.decrypt) type = 'decrypt';
    else type = 'encrypt';
    var key = opts.key;
    if (modeName === 'des-ede' || modeName === 'des-ede-cbc') key = $042207dc02edaa79$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$042207dc02edaa79$var$DES.prototype._update = function(data) {
    return new $042207dc02edaa79$require$Buffer(this._des.update(data));
};
$042207dc02edaa79$var$DES.prototype._final = function() {
    return new $042207dc02edaa79$require$Buffer(this._des.final());
};

});
parcelRegister("lFDWJ", function(module, exports) {
$parcel$export(module.exports, "DES", () => $fc6c69c9a2ebf664$export$cc8859615686b300, (v) => $fc6c69c9a2ebf664$export$cc8859615686b300 = v);
$parcel$export(module.exports, "CBC", () => $fc6c69c9a2ebf664$export$8ad3f227af08fcc5, (v) => $fc6c69c9a2ebf664$export$8ad3f227af08fcc5 = v);
$parcel$export(module.exports, "EDE", () => $fc6c69c9a2ebf664$export$947646e34766044f, (v) => $fc6c69c9a2ebf664$export$947646e34766044f = v);
var $fc6c69c9a2ebf664$export$eab97d15b1788b8d;
var $fc6c69c9a2ebf664$export$26e5786e8ac8e530;
var $fc6c69c9a2ebf664$export$cc8859615686b300;
var $fc6c69c9a2ebf664$export$8ad3f227af08fcc5;
var $fc6c69c9a2ebf664$export$947646e34766044f;
'use strict';

$fc6c69c9a2ebf664$export$eab97d15b1788b8d = (parcelRequire("j2YqV"));

$fc6c69c9a2ebf664$export$26e5786e8ac8e530 = (parcelRequire("fDjLG"));

$fc6c69c9a2ebf664$export$cc8859615686b300 = (parcelRequire("jv9BL"));

$fc6c69c9a2ebf664$export$8ad3f227af08fcc5 = (parcelRequire("aAWtO"));

$fc6c69c9a2ebf664$export$947646e34766044f = (parcelRequire("d77cK"));

});
parcelRegister("j2YqV", function(module, exports) {
$parcel$export(module.exports, "readUInt32BE", () => $dddd1504a8b7c7a7$export$cfaef8ed399428b0, (v) => $dddd1504a8b7c7a7$export$cfaef8ed399428b0 = v);
$parcel$export(module.exports, "writeUInt32BE", () => $dddd1504a8b7c7a7$export$a80c7deaea7cbd80, (v) => $dddd1504a8b7c7a7$export$a80c7deaea7cbd80 = v);
$parcel$export(module.exports, "ip", () => $dddd1504a8b7c7a7$export$ed7577ae6e1cd0ef, (v) => $dddd1504a8b7c7a7$export$ed7577ae6e1cd0ef = v);
$parcel$export(module.exports, "rip", () => $dddd1504a8b7c7a7$export$5dcbef3aa594f567, (v) => $dddd1504a8b7c7a7$export$5dcbef3aa594f567 = v);
$parcel$export(module.exports, "pc1", () => $dddd1504a8b7c7a7$export$5bc8001ca71ed9c5, (v) => $dddd1504a8b7c7a7$export$5bc8001ca71ed9c5 = v);
$parcel$export(module.exports, "r28shl", () => $dddd1504a8b7c7a7$export$3e714e2c5d5d8cb2, (v) => $dddd1504a8b7c7a7$export$3e714e2c5d5d8cb2 = v);
$parcel$export(module.exports, "pc2", () => $dddd1504a8b7c7a7$export$94c3e544fd062b7f, (v) => $dddd1504a8b7c7a7$export$94c3e544fd062b7f = v);
$parcel$export(module.exports, "expand", () => $dddd1504a8b7c7a7$export$9f77e0932fb78f72, (v) => $dddd1504a8b7c7a7$export$9f77e0932fb78f72 = v);
$parcel$export(module.exports, "substitute", () => $dddd1504a8b7c7a7$export$d865ce2836f5927f, (v) => $dddd1504a8b7c7a7$export$d865ce2836f5927f = v);
$parcel$export(module.exports, "permute", () => $dddd1504a8b7c7a7$export$95e62ad65da8b7d2, (v) => $dddd1504a8b7c7a7$export$95e62ad65da8b7d2 = v);
$parcel$export(module.exports, "padSplit", () => $dddd1504a8b7c7a7$export$209139ff098c441a, (v) => $dddd1504a8b7c7a7$export$209139ff098c441a = v);
var $dddd1504a8b7c7a7$export$cfaef8ed399428b0;
var $dddd1504a8b7c7a7$export$a80c7deaea7cbd80;
var $dddd1504a8b7c7a7$export$ed7577ae6e1cd0ef;
var $dddd1504a8b7c7a7$export$5dcbef3aa594f567;
var $dddd1504a8b7c7a7$export$5bc8001ca71ed9c5;
var $dddd1504a8b7c7a7$export$3e714e2c5d5d8cb2;
var $dddd1504a8b7c7a7$export$94c3e544fd062b7f;
var $dddd1504a8b7c7a7$export$9f77e0932fb78f72;
var $dddd1504a8b7c7a7$export$d865ce2836f5927f;
var $dddd1504a8b7c7a7$export$95e62ad65da8b7d2;
var $dddd1504a8b7c7a7$export$209139ff098c441a;
'use strict';
$dddd1504a8b7c7a7$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$dddd1504a8b7c7a7$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$dddd1504a8b7c7a7$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$dddd1504a8b7c7a7$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$dddd1504a8b7c7a7$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$dddd1504a8b7c7a7$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $dddd1504a8b7c7a7$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$dddd1504a8b7c7a7$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $dddd1504a8b7c7a7$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $dddd1504a8b7c7a7$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $dddd1504a8b7c7a7$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $dddd1504a8b7c7a7$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$dddd1504a8b7c7a7$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $dddd1504a8b7c7a7$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$dddd1504a8b7c7a7$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $dddd1504a8b7c7a7$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $dddd1504a8b7c7a7$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $dddd1504a8b7c7a7$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$dddd1504a8b7c7a7$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $dddd1504a8b7c7a7$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $dddd1504a8b7c7a7$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$dddd1504a8b7c7a7$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = '0' + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(' ');
};

});

parcelRegister("fDjLG", function(module, exports) {
'use strict';

var $fvn5w = parcelRequire("fvn5w");
function $b619d5135b516063$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $b619d5135b516063$var$Cipher;
$b619d5135b516063$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$b619d5135b516063$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === 'decrypt') return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$b619d5135b516063$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$b619d5135b516063$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$b619d5135b516063$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$b619d5135b516063$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$b619d5135b516063$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === 'encrypt') last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$b619d5135b516063$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$b619d5135b516063$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$b619d5135b516063$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$b619d5135b516063$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $fvn5w.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRegister("fvn5w", function(module, exports) {
module.exports = $b49ba914e53af871$var$assert;
function $b49ba914e53af871$var$assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
}
$b49ba914e53af871$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
};

});


parcelRegister("jv9BL", function(module, exports) {
'use strict';

var $fvn5w = parcelRequire("fvn5w");

var $lpcNn = parcelRequire("lpcNn");

var $j2YqV = parcelRequire("j2YqV");

var $fDjLG = parcelRequire("fDjLG");
function $e3285d88571bbf72$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $e3285d88571bbf72$var$DES(options) {
    $fDjLG.call(this, options);
    var state = new $e3285d88571bbf72$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$lpcNn($e3285d88571bbf72$var$DES, $fDjLG);
module.exports = $e3285d88571bbf72$var$DES;
$e3285d88571bbf72$var$DES.create = function create(options) {
    return new $e3285d88571bbf72$var$DES(options);
};
var $e3285d88571bbf72$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$e3285d88571bbf72$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $fvn5w.equal(key.length, this.blockSize, 'Invalid key length');
    var kL = $j2YqV.readUInt32BE(key, 0);
    var kR = $j2YqV.readUInt32BE(key, 4);
    $j2YqV.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $e3285d88571bbf72$var$shiftTable[i >>> 1];
        kL = $j2YqV.r28shl(kL, shift);
        kR = $j2YqV.r28shl(kR, shift);
        $j2YqV.pc2(kL, kR, state.keys, i);
    }
};
$e3285d88571bbf72$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $j2YqV.readUInt32BE(inp, inOff);
    var r = $j2YqV.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $j2YqV.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === 'encrypt') this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $j2YqV.writeUInt32BE(out, l, outOff);
    $j2YqV.writeUInt32BE(out, r, outOff + 4);
};
$e3285d88571bbf72$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$e3285d88571bbf72$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$fvn5w.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$e3285d88571bbf72$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $j2YqV.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $j2YqV.substitute(keyL, keyR);
        var f = $j2YqV.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $j2YqV.rip(r, l, out, off);
};
$e3285d88571bbf72$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $j2YqV.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $j2YqV.substitute(keyL, keyR);
        var f = $j2YqV.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $j2YqV.rip(l, r, out, off);
};

});

parcelRegister("aAWtO", function(module, exports) {
$parcel$export(module.exports, "instantiate", () => $7b6aa1144e163c66$export$f9bb8d20ccc7477a, (v) => $7b6aa1144e163c66$export$f9bb8d20ccc7477a = v);
var $7b6aa1144e163c66$export$f9bb8d20ccc7477a;
'use strict';

var $fvn5w = parcelRequire("fvn5w");

var $lpcNn = parcelRequire("lpcNn");
var $7b6aa1144e163c66$var$proto = {};
function $7b6aa1144e163c66$var$CBCState(iv) {
    $fvn5w.equal(iv.length, 8, 'Invalid IV length');
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $7b6aa1144e163c66$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $lpcNn(CBC, Base);
    var keys = Object.keys($7b6aa1144e163c66$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $7b6aa1144e163c66$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$7b6aa1144e163c66$export$f9bb8d20ccc7477a = $7b6aa1144e163c66$var$instantiate;
$7b6aa1144e163c66$var$proto._cbcInit = function _cbcInit() {
    var state = new $7b6aa1144e163c66$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$7b6aa1144e163c66$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === 'encrypt') {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("d77cK", function(module, exports) {
'use strict';

var $fvn5w = parcelRequire("fvn5w");

var $lpcNn = parcelRequire("lpcNn");

var $fDjLG = parcelRequire("fDjLG");

var $jv9BL = parcelRequire("jv9BL");
function $98c1847bef2c94bf$var$EDEState(type, key) {
    $fvn5w.equal(key.length, 24, 'Invalid key length');
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === 'encrypt') this.ciphers = [
        $jv9BL.create({
            type: 'encrypt',
            key: k1
        }),
        $jv9BL.create({
            type: 'decrypt',
            key: k2
        }),
        $jv9BL.create({
            type: 'encrypt',
            key: k3
        })
    ];
    else this.ciphers = [
        $jv9BL.create({
            type: 'decrypt',
            key: k3
        }),
        $jv9BL.create({
            type: 'encrypt',
            key: k2
        }),
        $jv9BL.create({
            type: 'decrypt',
            key: k1
        })
    ];
}
function $98c1847bef2c94bf$var$EDE(options) {
    $fDjLG.call(this, options);
    var state = new $98c1847bef2c94bf$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$lpcNn($98c1847bef2c94bf$var$EDE, $fDjLG);
module.exports = $98c1847bef2c94bf$var$EDE;
$98c1847bef2c94bf$var$EDE.create = function create(options) {
    return new $98c1847bef2c94bf$var$EDE(options);
};
$98c1847bef2c94bf$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$98c1847bef2c94bf$var$EDE.prototype._pad = $jv9BL.prototype._pad;
$98c1847bef2c94bf$var$EDE.prototype._unpad = $jv9BL.prototype._unpad;

});



parcelRegister("7uhwq", function(module, exports) {
$parcel$export(module.exports, "createCipheriv", () => $5738ed401b2fe5c5$export$2f64596b8cbf08b4, (v) => $5738ed401b2fe5c5$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createDecipheriv", () => $5738ed401b2fe5c5$export$36b6d6ef312eab39, (v) => $5738ed401b2fe5c5$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $5738ed401b2fe5c5$export$58a258485f1e49f6, (v) => $5738ed401b2fe5c5$export$58a258485f1e49f6 = v);
var $5738ed401b2fe5c5$export$bdd223f16383713e;
var $5738ed401b2fe5c5$export$26e5786e8ac8e530;
var $5738ed401b2fe5c5$export$2f64596b8cbf08b4;
var $5738ed401b2fe5c5$export$20533d26f07f1ee0;
var $5738ed401b2fe5c5$export$12ada9414fbc594c;
var $5738ed401b2fe5c5$export$2ce6d8d0e8b04e1a;
var $5738ed401b2fe5c5$export$36b6d6ef312eab39;
var $5738ed401b2fe5c5$export$f5e7e39d57cd9700;
var $5738ed401b2fe5c5$export$dedd8dc3dc62b370;
var $5738ed401b2fe5c5$export$58a258485f1e49f6;

var $3qdkQ = parcelRequire("3qdkQ");

var $1sSVk = parcelRequire("1sSVk");

var $jqBek = parcelRequire("jqBek");
function $5738ed401b2fe5c5$var$getCiphers() {
    return Object.keys($jqBek);
}
$5738ed401b2fe5c5$export$bdd223f16383713e = $5738ed401b2fe5c5$export$26e5786e8ac8e530 = $3qdkQ.createCipher;
$5738ed401b2fe5c5$export$2f64596b8cbf08b4 = $5738ed401b2fe5c5$export$20533d26f07f1ee0 = $3qdkQ.createCipheriv;
$5738ed401b2fe5c5$export$12ada9414fbc594c = $5738ed401b2fe5c5$export$2ce6d8d0e8b04e1a = $1sSVk.createDecipher;
$5738ed401b2fe5c5$export$36b6d6ef312eab39 = $5738ed401b2fe5c5$export$f5e7e39d57cd9700 = $1sSVk.createDecipheriv;
$5738ed401b2fe5c5$export$dedd8dc3dc62b370 = $5738ed401b2fe5c5$export$58a258485f1e49f6 = $5738ed401b2fe5c5$var$getCiphers;

});
parcelRegister("3qdkQ", function(module, exports) {
$parcel$export(module.exports, "createCipheriv", () => $27de24e5da9acb35$export$2f64596b8cbf08b4, (v) => $27de24e5da9acb35$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createCipher", () => $27de24e5da9acb35$export$bdd223f16383713e, (v) => $27de24e5da9acb35$export$bdd223f16383713e = v);
var $27de24e5da9acb35$export$2f64596b8cbf08b4;
var $27de24e5da9acb35$export$bdd223f16383713e;

var $jNEhs = parcelRequire("jNEhs");

var $fB8Uc = parcelRequire("fB8Uc");

var $bc1ju = parcelRequire("bc1ju");
var $27de24e5da9acb35$require$Buffer = $bc1ju.Buffer;

var $c2KNb = parcelRequire("c2KNb");

var $3T1AC = parcelRequire("3T1AC");

var $2RWrR = parcelRequire("2RWrR");

var $cXjgY = parcelRequire("cXjgY");

var $lpcNn = parcelRequire("lpcNn");
function $27de24e5da9acb35$var$Cipher(mode, key, iv) {
    $3T1AC.call(this);
    this._cache = new $27de24e5da9acb35$var$Splitter();
    this._cipher = new $2RWrR.AES(key);
    this._prev = $27de24e5da9acb35$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$lpcNn($27de24e5da9acb35$var$Cipher, $3T1AC);
$27de24e5da9acb35$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $27de24e5da9acb35$require$Buffer.concat(out);
};
var $27de24e5da9acb35$var$PADDING = $27de24e5da9acb35$require$Buffer.alloc(16, 0x10);
$27de24e5da9acb35$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($27de24e5da9acb35$var$PADDING)) {
        this._cipher.scrub();
        throw new Error('data not multiple of block length');
    }
};
$27de24e5da9acb35$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $27de24e5da9acb35$var$Splitter() {
    this.cache = $27de24e5da9acb35$require$Buffer.allocUnsafe(0);
}
$27de24e5da9acb35$var$Splitter.prototype.add = function(data) {
    this.cache = $27de24e5da9acb35$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$27de24e5da9acb35$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$27de24e5da9acb35$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $27de24e5da9acb35$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $27de24e5da9acb35$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $27de24e5da9acb35$var$createCipheriv(suite, password, iv) {
    var config = $jNEhs[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof password === 'string') password = $27de24e5da9acb35$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (typeof iv === 'string') iv = $27de24e5da9acb35$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (config.type === 'stream') return new $c2KNb(config.module, password, iv);
    else if (config.type === 'auth') return new $fB8Uc(config.module, password, iv);
    return new $27de24e5da9acb35$var$Cipher(config.module, password, iv);
}
function $27de24e5da9acb35$var$createCipher(suite, password) {
    var config = $jNEhs[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $cXjgY(password, false, config.key, config.iv);
    return $27de24e5da9acb35$var$createCipheriv(suite, keys.key, keys.iv);
}
$27de24e5da9acb35$export$2f64596b8cbf08b4 = $27de24e5da9acb35$var$createCipheriv;
$27de24e5da9acb35$export$bdd223f16383713e = $27de24e5da9acb35$var$createCipher;

});
parcelRegister("jNEhs", function(module, exports) {








var $e6a1d6ccf49c6782$var$modeModules = {
    ECB: (parcelRequire("eMkVO")),
    CBC: (parcelRequire("5eoOg")),
    CFB: (parcelRequire("a0JrK")),
    CFB8: (parcelRequire("eDIgW")),
    CFB1: (parcelRequire("5CwtA")),
    OFB: (parcelRequire("2TlmV")),
    CTR: (parcelRequire("I28gq")),
    GCM: (parcelRequire("I28gq"))
};

var $jqBek = parcelRequire("jqBek");
for(var $e6a1d6ccf49c6782$var$key in $jqBek)$jqBek[$e6a1d6ccf49c6782$var$key].module = $e6a1d6ccf49c6782$var$modeModules[$jqBek[$e6a1d6ccf49c6782$var$key].mode];
module.exports = $jqBek;

});
parcelRegister("eMkVO", function(module, exports) {
$parcel$export(module.exports, "encrypt", () => $ac25c8ebcb0f72fb$export$5b0f6292f11d1d18, (v) => $ac25c8ebcb0f72fb$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $ac25c8ebcb0f72fb$export$e85a0c9a1067c5d3, (v) => $ac25c8ebcb0f72fb$export$e85a0c9a1067c5d3 = v);
var $ac25c8ebcb0f72fb$export$5b0f6292f11d1d18;
var $ac25c8ebcb0f72fb$export$e85a0c9a1067c5d3;
$ac25c8ebcb0f72fb$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$ac25c8ebcb0f72fb$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("5eoOg", function(module, exports) {
$parcel$export(module.exports, "encrypt", () => $3cf1813dc12d210b$export$5b0f6292f11d1d18, (v) => $3cf1813dc12d210b$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $3cf1813dc12d210b$export$e85a0c9a1067c5d3, (v) => $3cf1813dc12d210b$export$e85a0c9a1067c5d3 = v);
var $3cf1813dc12d210b$export$5b0f6292f11d1d18;
var $3cf1813dc12d210b$export$e85a0c9a1067c5d3;

var $6gx1o = parcelRequire("6gx1o");
$3cf1813dc12d210b$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $6gx1o(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$3cf1813dc12d210b$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $6gx1o(out, pad);
};

});
parcelRegister("6gx1o", function(module, exports) {

var $5Ovjr = parcelRequire("5Ovjr");
var $48fdda19aeab7d36$require$Buffer = $5Ovjr.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $48fdda19aeab7d36$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("a0JrK", function(module, exports) {
$parcel$export(module.exports, "encrypt", () => $749d2834be54ffe5$export$5b0f6292f11d1d18, (v) => $749d2834be54ffe5$export$5b0f6292f11d1d18 = v);
var $749d2834be54ffe5$export$5b0f6292f11d1d18;

var $bc1ju = parcelRequire("bc1ju");
var $749d2834be54ffe5$require$Buffer = $bc1ju.Buffer;

var $6gx1o = parcelRequire("6gx1o");
function $749d2834be54ffe5$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $6gx1o(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $749d2834be54ffe5$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$749d2834be54ffe5$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $749d2834be54ffe5$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $749d2834be54ffe5$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $749d2834be54ffe5$require$Buffer.concat([
                out,
                $749d2834be54ffe5$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $749d2834be54ffe5$require$Buffer.concat([
                out,
                $749d2834be54ffe5$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("eDIgW", function(module, exports) {
$parcel$export(module.exports, "encrypt", () => $aa870cbeabca2265$export$5b0f6292f11d1d18, (v) => $aa870cbeabca2265$export$5b0f6292f11d1d18 = v);
var $aa870cbeabca2265$export$5b0f6292f11d1d18;

var $bc1ju = parcelRequire("bc1ju");
var $aa870cbeabca2265$require$Buffer = $bc1ju.Buffer;
function $aa870cbeabca2265$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $aa870cbeabca2265$require$Buffer.concat([
        self._prev.slice(1),
        $aa870cbeabca2265$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$aa870cbeabca2265$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $aa870cbeabca2265$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $aa870cbeabca2265$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("5CwtA", function(module, exports) {
$parcel$export(module.exports, "encrypt", () => $4179b178de23b0f4$export$5b0f6292f11d1d18, (v) => $4179b178de23b0f4$export$5b0f6292f11d1d18 = v);
var $4179b178de23b0f4$export$5b0f6292f11d1d18;

var $bc1ju = parcelRequire("bc1ju");
var $4179b178de23b0f4$require$Buffer = $bc1ju.Buffer;
function $4179b178de23b0f4$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $4179b178de23b0f4$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $4179b178de23b0f4$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $4179b178de23b0f4$require$Buffer.allocUnsafe(buffer.length);
    buffer = $4179b178de23b0f4$require$Buffer.concat([
        buffer,
        $4179b178de23b0f4$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$4179b178de23b0f4$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $4179b178de23b0f4$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $4179b178de23b0f4$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("2TlmV", function(module, exports) {
$parcel$export(module.exports, "encrypt", () => $21b14b3314bd8dd2$export$5b0f6292f11d1d18, (v) => $21b14b3314bd8dd2$export$5b0f6292f11d1d18 = v);
var $21b14b3314bd8dd2$export$5b0f6292f11d1d18;

var $5Ovjr = parcelRequire("5Ovjr");
var $21b14b3314bd8dd2$require$Buffer = $5Ovjr.Buffer;

var $6gx1o = parcelRequire("6gx1o");
function $21b14b3314bd8dd2$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$21b14b3314bd8dd2$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $21b14b3314bd8dd2$require$Buffer.concat([
        self._cache,
        $21b14b3314bd8dd2$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $6gx1o(chunk, pad);
};

});

parcelRegister("I28gq", function(module, exports) {
$parcel$export(module.exports, "encrypt", () => $0845c39a8ff8404a$export$5b0f6292f11d1d18, (v) => $0845c39a8ff8404a$export$5b0f6292f11d1d18 = v);
var $0845c39a8ff8404a$export$5b0f6292f11d1d18;

var $6gx1o = parcelRequire("6gx1o");

var $bc1ju = parcelRequire("bc1ju");
var $0845c39a8ff8404a$require$Buffer = $bc1ju.Buffer;

var $c6spo = parcelRequire("c6spo");
function $0845c39a8ff8404a$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $c6spo(self._prev);
    return out;
}
var $0845c39a8ff8404a$var$blockSize = 16;
$0845c39a8ff8404a$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $0845c39a8ff8404a$var$blockSize);
    var start = self._cache.length;
    self._cache = $0845c39a8ff8404a$require$Buffer.concat([
        self._cache,
        $0845c39a8ff8404a$require$Buffer.allocUnsafe(chunkNum * $0845c39a8ff8404a$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $0845c39a8ff8404a$var$getBlock(self);
        var offset = start + i * $0845c39a8ff8404a$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $6gx1o(chunk, pad);
};

});
parcelRegister("c6spo", function(module, exports) {
function $8cfc14eda12118df$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $8cfc14eda12118df$var$incr32;

});


parcelRegister("jqBek", function(module, exports) {
module.exports = JSON.parse("{\"aes-128-ecb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-192-ecb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-256-ecb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-128-cbc\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-192-cbc\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-256-cbc\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes128\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes192\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes256\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-128-cfb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-192-cfb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-256-cfb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-128-cfb8\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-192-cfb8\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-256-cfb8\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-128-cfb1\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-192-cfb1\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-256-cfb1\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-128-ofb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-192-ofb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-256-ofb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-128-ctr\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-192-ctr\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-256-ctr\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-128-gcm\":{\"cipher\":\"AES\",\"key\":128,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-192-gcm\":{\"cipher\":\"AES\",\"key\":192,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-256-gcm\":{\"cipher\":\"AES\",\"key\":256,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"}}");

});


parcelRegister("fB8Uc", function(module, exports) {

var $2RWrR = parcelRequire("2RWrR");

var $bc1ju = parcelRequire("bc1ju");
var $b5b1382c42b6399c$require$Buffer = $bc1ju.Buffer;

var $3T1AC = parcelRequire("3T1AC");

var $lpcNn = parcelRequire("lpcNn");

var $8TrlQ = parcelRequire("8TrlQ");

var $6gx1o = parcelRequire("6gx1o");

var $c6spo = parcelRequire("c6spo");
function $b5b1382c42b6399c$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $b5b1382c42b6399c$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $b5b1382c42b6399c$require$Buffer.concat([
            iv,
            $b5b1382c42b6399c$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $b5b1382c42b6399c$require$Buffer.concat([
            iv,
            $b5b1382c42b6399c$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $8TrlQ(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($b5b1382c42b6399c$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($b5b1382c42b6399c$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $b5b1382c42b6399c$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $b5b1382c42b6399c$require$Buffer.from(self._finID);
    $c6spo(out);
    return out;
}
function $b5b1382c42b6399c$var$StreamCipher(mode, key, iv, decrypt) {
    $3T1AC.call(this);
    var h = $b5b1382c42b6399c$require$Buffer.alloc(4, 0);
    this._cipher = new $2RWrR.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $8TrlQ(ck);
    iv = $b5b1382c42b6399c$var$calcIv(this, iv, ck);
    this._prev = $b5b1382c42b6399c$require$Buffer.from(iv);
    this._cache = $b5b1382c42b6399c$require$Buffer.allocUnsafe(0);
    this._secCache = $b5b1382c42b6399c$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$lpcNn($b5b1382c42b6399c$var$StreamCipher, $3T1AC);
$b5b1382c42b6399c$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $b5b1382c42b6399c$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$b5b1382c42b6399c$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data');
    var tag = $6gx1o(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $b5b1382c42b6399c$var$xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data');
    this._authTag = tag;
    this._cipher.scrub();
};
$b5b1382c42b6399c$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$b5b1382c42b6399c$require$Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state');
    return this._authTag;
};
$b5b1382c42b6399c$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state');
    this._authTag = tag;
};
$b5b1382c42b6399c$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error('Attempting to set AAD in unsupported state');
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $b5b1382c42b6399c$var$StreamCipher;

});
parcelRegister("2RWrR", function(module, exports) {
$parcel$export(module.exports, "AES", () => $216ddea8fb999898$export$b80fbe1c3a2b92b5, (v) => $216ddea8fb999898$export$b80fbe1c3a2b92b5 = v);
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $216ddea8fb999898$export$b80fbe1c3a2b92b5;

var $bc1ju = parcelRequire("bc1ju");
var $216ddea8fb999898$require$Buffer = $bc1ju.Buffer;
function $216ddea8fb999898$var$asUInt32Array(buf) {
    if (!$216ddea8fb999898$require$Buffer.isBuffer(buf)) buf = $216ddea8fb999898$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $216ddea8fb999898$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $216ddea8fb999898$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $216ddea8fb999898$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $216ddea8fb999898$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $216ddea8fb999898$var$AES(key) {
    this._key = $216ddea8fb999898$var$asUInt32Array(key);
    this._reset();
}
$216ddea8fb999898$var$AES.blockSize = 16;
$216ddea8fb999898$var$AES.keySize = 32;
$216ddea8fb999898$var$AES.prototype.blockSize = $216ddea8fb999898$var$AES.blockSize;
$216ddea8fb999898$var$AES.prototype.keySize = $216ddea8fb999898$var$AES.keySize;
$216ddea8fb999898$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $216ddea8fb999898$var$G.SBOX[t >>> 24] << 24 | $216ddea8fb999898$var$G.SBOX[t >>> 16 & 0xff] << 16 | $216ddea8fb999898$var$G.SBOX[t >>> 8 & 0xff] << 8 | $216ddea8fb999898$var$G.SBOX[t & 0xff];
            t ^= $216ddea8fb999898$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $216ddea8fb999898$var$G.SBOX[t >>> 24] << 24 | $216ddea8fb999898$var$G.SBOX[t >>> 16 & 0xff] << 16 | $216ddea8fb999898$var$G.SBOX[t >>> 8 & 0xff] << 8 | $216ddea8fb999898$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $216ddea8fb999898$var$G.INV_SUB_MIX[0][$216ddea8fb999898$var$G.SBOX[tt >>> 24]] ^ $216ddea8fb999898$var$G.INV_SUB_MIX[1][$216ddea8fb999898$var$G.SBOX[tt >>> 16 & 0xff]] ^ $216ddea8fb999898$var$G.INV_SUB_MIX[2][$216ddea8fb999898$var$G.SBOX[tt >>> 8 & 0xff]] ^ $216ddea8fb999898$var$G.INV_SUB_MIX[3][$216ddea8fb999898$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$216ddea8fb999898$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $216ddea8fb999898$var$asUInt32Array(M);
    return $216ddea8fb999898$var$cryptBlock(M, this._keySchedule, $216ddea8fb999898$var$G.SUB_MIX, $216ddea8fb999898$var$G.SBOX, this._nRounds);
};
$216ddea8fb999898$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $216ddea8fb999898$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$216ddea8fb999898$var$AES.prototype.decryptBlock = function(M) {
    M = $216ddea8fb999898$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $216ddea8fb999898$var$cryptBlock(M, this._invKeySchedule, $216ddea8fb999898$var$G.INV_SUB_MIX, $216ddea8fb999898$var$G.INV_SBOX, this._nRounds);
    var buf = $216ddea8fb999898$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$216ddea8fb999898$var$AES.prototype.scrub = function() {
    $216ddea8fb999898$var$scrubVec(this._keySchedule);
    $216ddea8fb999898$var$scrubVec(this._invKeySchedule);
    $216ddea8fb999898$var$scrubVec(this._key);
};
$216ddea8fb999898$export$b80fbe1c3a2b92b5 = $216ddea8fb999898$var$AES;

});

parcelRegister("8TrlQ", function(module, exports) {

var $bc1ju = parcelRequire("bc1ju");
var $6798ad2ef75d6c5a$require$Buffer = $bc1ju.Buffer;
var $6798ad2ef75d6c5a$var$ZEROES = $6798ad2ef75d6c5a$require$Buffer.alloc(16, 0);
function $6798ad2ef75d6c5a$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $6798ad2ef75d6c5a$var$fromArray(out) {
    var buf = $6798ad2ef75d6c5a$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $6798ad2ef75d6c5a$var$GHASH(key) {
    this.h = key;
    this.state = $6798ad2ef75d6c5a$require$Buffer.alloc(16, 0);
    this.cache = $6798ad2ef75d6c5a$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$6798ad2ef75d6c5a$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$6798ad2ef75d6c5a$var$GHASH.prototype._multiply = function() {
    var Vi = $6798ad2ef75d6c5a$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $6798ad2ef75d6c5a$var$fromArray(Zi);
};
$6798ad2ef75d6c5a$var$GHASH.prototype.update = function(buf) {
    this.cache = $6798ad2ef75d6c5a$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$6798ad2ef75d6c5a$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($6798ad2ef75d6c5a$require$Buffer.concat([
        this.cache,
        $6798ad2ef75d6c5a$var$ZEROES
    ], 16));
    this.ghash($6798ad2ef75d6c5a$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $6798ad2ef75d6c5a$var$GHASH;

});


parcelRegister("c2KNb", function(module, exports) {

var $2RWrR = parcelRequire("2RWrR");

var $bc1ju = parcelRequire("bc1ju");
var $8c49f7ede3e06a4d$require$Buffer = $bc1ju.Buffer;

var $3T1AC = parcelRequire("3T1AC");

var $lpcNn = parcelRequire("lpcNn");
function $8c49f7ede3e06a4d$var$StreamCipher(mode, key, iv, decrypt) {
    $3T1AC.call(this);
    this._cipher = new $2RWrR.AES(key);
    this._prev = $8c49f7ede3e06a4d$require$Buffer.from(iv);
    this._cache = $8c49f7ede3e06a4d$require$Buffer.allocUnsafe(0);
    this._secCache = $8c49f7ede3e06a4d$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$lpcNn($8c49f7ede3e06a4d$var$StreamCipher, $3T1AC);
$8c49f7ede3e06a4d$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$8c49f7ede3e06a4d$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $8c49f7ede3e06a4d$var$StreamCipher;

});

parcelRegister("cXjgY", function(module, exports) {

var $bc1ju = parcelRequire("bc1ju");
var $96e9f1e21de38486$require$Buffer = $bc1ju.Buffer;

var $a8EwA = parcelRequire("a8EwA");
/* eslint-disable camelcase */ function $96e9f1e21de38486$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$96e9f1e21de38486$require$Buffer.isBuffer(password)) password = $96e9f1e21de38486$require$Buffer.from(password, 'binary');
    if (salt) {
        if (!$96e9f1e21de38486$require$Buffer.isBuffer(salt)) salt = $96e9f1e21de38486$require$Buffer.from(salt, 'binary');
        if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length');
    }
    var keyLen = keyBits / 8;
    var key = $96e9f1e21de38486$require$Buffer.alloc(keyLen);
    var iv = $96e9f1e21de38486$require$Buffer.alloc(ivLen || 0);
    var tmp = $96e9f1e21de38486$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $a8EwA();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $96e9f1e21de38486$var$EVP_BytesToKey;

});


parcelRegister("1sSVk", function(module, exports) {
$parcel$export(module.exports, "createDecipher", () => $111302a4fa3c38f9$export$12ada9414fbc594c, (v) => $111302a4fa3c38f9$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "createDecipheriv", () => $111302a4fa3c38f9$export$36b6d6ef312eab39, (v) => $111302a4fa3c38f9$export$36b6d6ef312eab39 = v);
var $111302a4fa3c38f9$export$12ada9414fbc594c;
var $111302a4fa3c38f9$export$36b6d6ef312eab39;

var $fB8Uc = parcelRequire("fB8Uc");

var $bc1ju = parcelRequire("bc1ju");
var $111302a4fa3c38f9$require$Buffer = $bc1ju.Buffer;

var $jNEhs = parcelRequire("jNEhs");

var $c2KNb = parcelRequire("c2KNb");

var $3T1AC = parcelRequire("3T1AC");

var $2RWrR = parcelRequire("2RWrR");

var $cXjgY = parcelRequire("cXjgY");

var $lpcNn = parcelRequire("lpcNn");
function $111302a4fa3c38f9$var$Decipher(mode, key, iv) {
    $3T1AC.call(this);
    this._cache = new $111302a4fa3c38f9$var$Splitter();
    this._last = void 0;
    this._cipher = new $2RWrR.AES(key);
    this._prev = $111302a4fa3c38f9$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$lpcNn($111302a4fa3c38f9$var$Decipher, $3T1AC);
$111302a4fa3c38f9$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $111302a4fa3c38f9$require$Buffer.concat(out);
};
$111302a4fa3c38f9$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $111302a4fa3c38f9$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error('data not multiple of block length');
};
$111302a4fa3c38f9$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $111302a4fa3c38f9$var$Splitter() {
    this.cache = $111302a4fa3c38f9$require$Buffer.allocUnsafe(0);
}
$111302a4fa3c38f9$var$Splitter.prototype.add = function(data) {
    this.cache = $111302a4fa3c38f9$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$111302a4fa3c38f9$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$111302a4fa3c38f9$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $111302a4fa3c38f9$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error('unable to decrypt data');
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error('unable to decrypt data');
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $111302a4fa3c38f9$var$createDecipheriv(suite, password, iv) {
    var config = $jNEhs[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof iv === 'string') iv = $111302a4fa3c38f9$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (typeof password === 'string') password = $111302a4fa3c38f9$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (config.type === 'stream') return new $c2KNb(config.module, password, iv, true);
    else if (config.type === 'auth') return new $fB8Uc(config.module, password, iv, true);
    return new $111302a4fa3c38f9$var$Decipher(config.module, password, iv);
}
function $111302a4fa3c38f9$var$createDecipher(suite, password) {
    var config = $jNEhs[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $cXjgY(password, false, config.key, config.iv);
    return $111302a4fa3c38f9$var$createDecipheriv(suite, keys.key, keys.iv);
}
$111302a4fa3c38f9$export$12ada9414fbc594c = $111302a4fa3c38f9$var$createDecipher;
$111302a4fa3c38f9$export$36b6d6ef312eab39 = $111302a4fa3c38f9$var$createDecipheriv;

});


parcelRegister("hmMcl", function(module, exports) {
$parcel$export(module.exports, "des-ecb", () => $ca49e0e67710abc2$export$116f8a5cee447347, (v) => $ca49e0e67710abc2$export$116f8a5cee447347 = v);
$parcel$export(module.exports, "des-cbc", () => $ca49e0e67710abc2$export$7483c4066bfb7ae9, (v) => $ca49e0e67710abc2$export$7483c4066bfb7ae9 = v);
$parcel$export(module.exports, "des", () => $ca49e0e67710abc2$export$e7a565d2e588bb06, (v) => $ca49e0e67710abc2$export$e7a565d2e588bb06 = v);
$parcel$export(module.exports, "des-ede3-cbc", () => $ca49e0e67710abc2$export$aaa2f54a426f3eb8, (v) => $ca49e0e67710abc2$export$aaa2f54a426f3eb8 = v);
$parcel$export(module.exports, "des3", () => $ca49e0e67710abc2$export$eba20568dde4ada, (v) => $ca49e0e67710abc2$export$eba20568dde4ada = v);
$parcel$export(module.exports, "des-ede3", () => $ca49e0e67710abc2$export$d3b5e5996938f5ae, (v) => $ca49e0e67710abc2$export$d3b5e5996938f5ae = v);
$parcel$export(module.exports, "des-ede-cbc", () => $ca49e0e67710abc2$export$57c08356130bc99b, (v) => $ca49e0e67710abc2$export$57c08356130bc99b = v);
$parcel$export(module.exports, "des-ede", () => $ca49e0e67710abc2$export$c7169791d5c1e65d, (v) => $ca49e0e67710abc2$export$c7169791d5c1e65d = v);
var $ca49e0e67710abc2$export$116f8a5cee447347;
var $ca49e0e67710abc2$export$7483c4066bfb7ae9;
var $ca49e0e67710abc2$export$e7a565d2e588bb06;
var $ca49e0e67710abc2$export$aaa2f54a426f3eb8;
var $ca49e0e67710abc2$export$eba20568dde4ada;
var $ca49e0e67710abc2$export$d3b5e5996938f5ae;
var $ca49e0e67710abc2$export$57c08356130bc99b;
var $ca49e0e67710abc2$export$c7169791d5c1e65d;
$ca49e0e67710abc2$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$ca49e0e67710abc2$export$7483c4066bfb7ae9 = $ca49e0e67710abc2$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$ca49e0e67710abc2$export$aaa2f54a426f3eb8 = $ca49e0e67710abc2$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$ca49e0e67710abc2$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$ca49e0e67710abc2$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$ca49e0e67710abc2$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};

});


parcelRegister("1QxKQ", function(module, exports) {
$parcel$export(module.exports, "DiffieHellmanGroup", () => $1584d4b9d2f94b14$export$971862a2fcb1bb40, (v) => $1584d4b9d2f94b14$export$971862a2fcb1bb40 = v);
$parcel$export(module.exports, "createDiffieHellmanGroup", () => $1584d4b9d2f94b14$export$c6ff6a88acbeaf40, (v) => $1584d4b9d2f94b14$export$c6ff6a88acbeaf40 = v);
$parcel$export(module.exports, "getDiffieHellman", () => $1584d4b9d2f94b14$export$fdc27893e98845cc, (v) => $1584d4b9d2f94b14$export$fdc27893e98845cc = v);
$parcel$export(module.exports, "createDiffieHellman", () => $1584d4b9d2f94b14$export$6671fb9a1323bed, (v) => $1584d4b9d2f94b14$export$6671fb9a1323bed = v);
$parcel$export(module.exports, "DiffieHellman", () => $1584d4b9d2f94b14$export$d74daf141a551db, (v) => $1584d4b9d2f94b14$export$d74daf141a551db = v);
var $1584d4b9d2f94b14$export$971862a2fcb1bb40;
var $1584d4b9d2f94b14$export$c6ff6a88acbeaf40;
var $1584d4b9d2f94b14$export$fdc27893e98845cc;
var $1584d4b9d2f94b14$export$6671fb9a1323bed;
var $1584d4b9d2f94b14$export$d74daf141a551db;

var $5Ovjr = parcelRequire("5Ovjr");
var $1584d4b9d2f94b14$require$Buffer = $5Ovjr.Buffer;

var $aamuv = parcelRequire("aamuv");

var $iCn9k = parcelRequire("iCn9k");

var $2QIm3 = parcelRequire("2QIm3");
function $1584d4b9d2f94b14$var$getDiffieHellman(mod) {
    var prime = new $1584d4b9d2f94b14$require$Buffer($iCn9k[mod].prime, 'hex');
    var gen = new $1584d4b9d2f94b14$require$Buffer($iCn9k[mod].gen, 'hex');
    return new $2QIm3(prime, gen);
}
var $1584d4b9d2f94b14$var$ENCODINGS = {
    'binary': true,
    'hex': true,
    'base64': true
};
function $1584d4b9d2f94b14$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($1584d4b9d2f94b14$require$Buffer.isBuffer(enc) || $1584d4b9d2f94b14$var$ENCODINGS[enc] === undefined) return $1584d4b9d2f94b14$var$createDiffieHellman(prime, 'binary', enc, generator);
    enc = enc || 'binary';
    genc = genc || 'binary';
    generator = generator || new $1584d4b9d2f94b14$require$Buffer([
        2
    ]);
    if (!$1584d4b9d2f94b14$require$Buffer.isBuffer(generator)) generator = new $1584d4b9d2f94b14$require$Buffer(generator, genc);
    if (typeof prime === 'number') return new $2QIm3($aamuv(prime, generator), generator, true);
    if (!$1584d4b9d2f94b14$require$Buffer.isBuffer(prime)) prime = new $1584d4b9d2f94b14$require$Buffer(prime, enc);
    return new $2QIm3(prime, generator, true);
}
$1584d4b9d2f94b14$export$971862a2fcb1bb40 = $1584d4b9d2f94b14$export$c6ff6a88acbeaf40 = $1584d4b9d2f94b14$export$fdc27893e98845cc = $1584d4b9d2f94b14$var$getDiffieHellman;
$1584d4b9d2f94b14$export$6671fb9a1323bed = $1584d4b9d2f94b14$export$d74daf141a551db = $1584d4b9d2f94b14$var$createDiffieHellman;

});
parcelRegister("aamuv", function(module, exports) {

var $49lWG = parcelRequire("49lWG");
module.exports = $766c48d45d1b9a06$var$findPrime;
$766c48d45d1b9a06$var$findPrime.simpleSieve = $766c48d45d1b9a06$var$simpleSieve;
$766c48d45d1b9a06$var$findPrime.fermatTest = $766c48d45d1b9a06$var$fermatTest;

var $2DhqK = parcelRequire("2DhqK");
var $766c48d45d1b9a06$var$TWENTYFOUR = new $2DhqK(24);

var $i7JTy = parcelRequire("i7JTy");
var $766c48d45d1b9a06$var$millerRabin = new $i7JTy();
var $766c48d45d1b9a06$var$ONE = new $2DhqK(1);
var $766c48d45d1b9a06$var$TWO = new $2DhqK(2);
var $766c48d45d1b9a06$var$FIVE = new $2DhqK(5);
var $766c48d45d1b9a06$var$SIXTEEN = new $2DhqK(16);
var $766c48d45d1b9a06$var$EIGHT = new $2DhqK(8);
var $766c48d45d1b9a06$var$TEN = new $2DhqK(10);
var $766c48d45d1b9a06$var$THREE = new $2DhqK(3);
var $766c48d45d1b9a06$var$SEVEN = new $2DhqK(7);
var $766c48d45d1b9a06$var$ELEVEN = new $2DhqK(11);
var $766c48d45d1b9a06$var$FOUR = new $2DhqK(4);
var $766c48d45d1b9a06$var$TWELVE = new $2DhqK(12);
var $766c48d45d1b9a06$var$primes = null;
function $766c48d45d1b9a06$var$_getPrimes() {
    if ($766c48d45d1b9a06$var$primes !== null) return $766c48d45d1b9a06$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $766c48d45d1b9a06$var$primes = res;
    return res;
}
function $766c48d45d1b9a06$var$simpleSieve(p) {
    var primes = $766c48d45d1b9a06$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $766c48d45d1b9a06$var$fermatTest(p) {
    var red = $2DhqK.mont(p);
    return $766c48d45d1b9a06$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $766c48d45d1b9a06$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $2DhqK([
            0x8c,
            0x7b
        ]);
        else return new $2DhqK([
            0x8c,
            0x27
        ]);
    }
    gen = new $2DhqK(gen);
    var num, n2;
    while(true){
        num = new $2DhqK($49lWG(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($766c48d45d1b9a06$var$ONE);
        if (!num.testn(1)) num.iadd($766c48d45d1b9a06$var$TWO);
        if (!gen.cmp($766c48d45d1b9a06$var$TWO)) while(num.mod($766c48d45d1b9a06$var$TWENTYFOUR).cmp($766c48d45d1b9a06$var$ELEVEN))num.iadd($766c48d45d1b9a06$var$FOUR);
        else if (!gen.cmp($766c48d45d1b9a06$var$FIVE)) while(num.mod($766c48d45d1b9a06$var$TEN).cmp($766c48d45d1b9a06$var$THREE))num.iadd($766c48d45d1b9a06$var$FOUR);
        n2 = num.shrn(1);
        if ($766c48d45d1b9a06$var$simpleSieve(n2) && $766c48d45d1b9a06$var$simpleSieve(num) && $766c48d45d1b9a06$var$fermatTest(n2) && $766c48d45d1b9a06$var$fermatTest(num) && $766c48d45d1b9a06$var$millerRabin.test(n2) && $766c48d45d1b9a06$var$millerRabin.test(num)) return num;
    }
}

});
parcelRegister("2DhqK", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("lOA8N")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("i7JTy", function(module, exports) {

var $2DhqK = parcelRequire("2DhqK");

var $6WjTK = parcelRequire("6WjTK");
function $d31c7b3bce1e5240$var$MillerRabin(rand) {
    this.rand = rand || new $6WjTK.Rand();
}
module.exports = $d31c7b3bce1e5240$var$MillerRabin;
$d31c7b3bce1e5240$var$MillerRabin.create = function create(rand) {
    return new $d31c7b3bce1e5240$var$MillerRabin(rand);
};
$d31c7b3bce1e5240$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $2DhqK(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$d31c7b3bce1e5240$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$d31c7b3bce1e5240$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $2DhqK.mont(n);
    var rone = new $2DhqK(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $2DhqK(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$d31c7b3bce1e5240$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $2DhqK.mont(n);
    var rone = new $2DhqK(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $2DhqK(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};

});
parcelRegister("6WjTK", function(module, exports) {
var $50d7983b3bbaea29$var$r;
module.exports = function rand(len) {
    if (!$50d7983b3bbaea29$var$r) $50d7983b3bbaea29$var$r = new $50d7983b3bbaea29$var$Rand(null);
    return $50d7983b3bbaea29$var$r.generate(len);
};
function $50d7983b3bbaea29$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $50d7983b3bbaea29$var$Rand;
$50d7983b3bbaea29$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$50d7983b3bbaea29$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === 'object') {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $50d7983b3bbaea29$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $50d7983b3bbaea29$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === 'object') // Old junk
    $50d7983b3bbaea29$var$Rand.prototype._rand = function() {
        throw new Error('Not implemented yet');
    };
} else // Node.js or Web worker with no crypto support
try {
    var $50d7983b3bbaea29$var$crypto = (parcelRequire("lOA8N"));
    if (typeof $50d7983b3bbaea29$var$crypto.randomBytes !== 'function') throw new Error('Not supported');
    $50d7983b3bbaea29$var$Rand.prototype._rand = function _rand(n) {
        return $50d7983b3bbaea29$var$crypto.randomBytes(n);
    };
} catch (e) {}

});



parcelRegister("iCn9k", function(module, exports) {
module.exports = JSON.parse("{\"modp1\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff\"},\"modp2\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff\"},\"modp5\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff\"},\"modp14\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff\"},\"modp15\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff\"},\"modp16\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff\"},\"modp17\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff\"},\"modp18\":{\"gen\":\"02\",\"prime\":\"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\"}}");

});

parcelRegister("2QIm3", function(module, exports) {

var $5Ovjr = parcelRequire("5Ovjr");
var $2132d80329461c85$require$Buffer = $5Ovjr.Buffer;

var $2DhqK = parcelRequire("2DhqK");

var $i7JTy = parcelRequire("i7JTy");
var $2132d80329461c85$var$millerRabin = new $i7JTy();
var $2132d80329461c85$var$TWENTYFOUR = new $2DhqK(24);
var $2132d80329461c85$var$ELEVEN = new $2DhqK(11);
var $2132d80329461c85$var$TEN = new $2DhqK(10);
var $2132d80329461c85$var$THREE = new $2DhqK(3);
var $2132d80329461c85$var$SEVEN = new $2DhqK(7);

var $aamuv = parcelRequire("aamuv");

var $49lWG = parcelRequire("49lWG");
module.exports = $2132d80329461c85$var$DH;
function $2132d80329461c85$var$setPublicKey(pub, enc) {
    enc = enc || 'utf8';
    if (!$2132d80329461c85$require$Buffer.isBuffer(pub)) pub = new $2132d80329461c85$require$Buffer(pub, enc);
    this._pub = new $2DhqK(pub);
    return this;
}
function $2132d80329461c85$var$setPrivateKey(priv, enc) {
    enc = enc || 'utf8';
    if (!$2132d80329461c85$require$Buffer.isBuffer(priv)) priv = new $2132d80329461c85$require$Buffer(priv, enc);
    this._priv = new $2DhqK(priv);
    return this;
}
var $2132d80329461c85$var$primeCache = {};
function $2132d80329461c85$var$checkPrime(prime, generator) {
    var gen = generator.toString('hex');
    var hex = [
        gen,
        prime.toString(16)
    ].join('_');
    if (hex in $2132d80329461c85$var$primeCache) return $2132d80329461c85$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$aamuv.simpleSieve || !$aamuv.fermatTest(prime) || !$2132d80329461c85$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === '02' || gen === '05') // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $2132d80329461c85$var$primeCache[hex] = error;
        return error;
    }
    if (!$2132d80329461c85$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case '02':
            if (prime.mod($2132d80329461c85$var$TWENTYFOUR).cmp($2132d80329461c85$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case '05':
            rem = prime.mod($2132d80329461c85$var$TEN);
            if (rem.cmp($2132d80329461c85$var$THREE) && rem.cmp($2132d80329461c85$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $2132d80329461c85$var$primeCache[hex] = error;
    return error;
}
function $2132d80329461c85$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $2DhqK(prime);
    this._prime = $2DhqK.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $2132d80329461c85$var$setPublicKey;
        this.setPrivateKey = $2132d80329461c85$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($2132d80329461c85$var$DH.prototype, 'verifyError', {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== 'number') this._primeCode = $2132d80329461c85$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$2132d80329461c85$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $2DhqK($49lWG(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$2132d80329461c85$var$DH.prototype.computeSecret = function(other) {
    other = new $2DhqK(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $2132d80329461c85$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $2132d80329461c85$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $2132d80329461c85$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$2132d80329461c85$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $2132d80329461c85$var$formatReturnValue(this._pub, enc);
};
$2132d80329461c85$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $2132d80329461c85$var$formatReturnValue(this._priv, enc);
};
$2132d80329461c85$var$DH.prototype.getPrime = function(enc) {
    return $2132d80329461c85$var$formatReturnValue(this.__prime, enc);
};
$2132d80329461c85$var$DH.prototype.getGenerator = function(enc) {
    return $2132d80329461c85$var$formatReturnValue(this._gen, enc);
};
$2132d80329461c85$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || 'utf8';
    if (!$2132d80329461c85$require$Buffer.isBuffer(gen)) gen = new $2132d80329461c85$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $2DhqK(gen);
    return this;
};
function $2132d80329461c85$var$formatReturnValue(bn, enc) {
    var buf = new $2132d80329461c85$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}

});


parcelRegister("8I2P7", function(module, exports) {
'use strict';

var $bc1ju = parcelRequire("bc1ju");
var $65749f75075eae97$require$Buffer = $bc1ju.Buffer;

var $lKbOi = parcelRequire("lKbOi");

var $6Wmtq = parcelRequire("6Wmtq");

var $lpcNn = parcelRequire("lpcNn");

var $3HcYt = parcelRequire("3HcYt");

var $hCU6x = parcelRequire("hCU6x");

var $3XBoT = parcelRequire("3XBoT");
Object.keys($3XBoT).forEach(function(key) {
    $3XBoT[key].id = $65749f75075eae97$require$Buffer.from($3XBoT[key].id, 'hex');
    $3XBoT[key.toLowerCase()] = $3XBoT[key];
});
function $65749f75075eae97$var$Sign(algorithm) {
    $6Wmtq.Writable.call(this);
    var data = $3XBoT[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hashType = data.hash;
    this._hash = $lKbOi(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$lpcNn($65749f75075eae97$var$Sign, $6Wmtq.Writable);
$65749f75075eae97$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$65749f75075eae97$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $65749f75075eae97$require$Buffer.from(data, enc) : data);
    return this;
};
$65749f75075eae97$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $3HcYt(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $65749f75075eae97$var$Verify(algorithm) {
    $6Wmtq.Writable.call(this);
    var data = $3XBoT[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hash = $lKbOi(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$lpcNn($65749f75075eae97$var$Verify, $6Wmtq.Writable);
$65749f75075eae97$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$65749f75075eae97$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $65749f75075eae97$require$Buffer.from(data, enc) : data);
    return this;
};
$65749f75075eae97$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === 'string' ? $65749f75075eae97$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $hCU6x(sigBuffer, hash, key, this._signType, this._tag);
};
function $65749f75075eae97$var$createSign(algorithm) {
    return new $65749f75075eae97$var$Sign(algorithm);
}
function $65749f75075eae97$var$createVerify(algorithm) {
    return new $65749f75075eae97$var$Verify(algorithm);
}
module.exports = {
    Sign: $65749f75075eae97$var$createSign,
    Verify: $65749f75075eae97$var$createVerify,
    createSign: $65749f75075eae97$var$createSign,
    createVerify: $65749f75075eae97$var$createVerify
};

});
parcelRegister("6Wmtq", function(module, exports) {

exports = module.exports = (parcelRequire("gCjFU"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("7Y1rN"));

exports.Duplex = (parcelRequire("aSTZL"));

exports.Transform = (parcelRequire("5FKU5"));

exports.PassThrough = (parcelRequire("7czWT"));

});
parcelRegister("gCjFU", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $igDjg = parcelRequire("igDjg");
'use strict';

var $ldmaM = parcelRequire("ldmaM");
/*</replacement>*/ module.exports = $c18f74feef889a0b$var$Readable;

var $4YWcW = parcelRequire("4YWcW");
/*</replacement>*/ /*<replacement>*/ var $c18f74feef889a0b$var$Duplex;
/*</replacement>*/ $c18f74feef889a0b$var$Readable.ReadableState = $c18f74feef889a0b$var$ReadableState;

var $7OU8o = parcelRequire("7OU8o");
var $c18f74feef889a0b$require$EE = $7OU8o.EventEmitter;
var $c18f74feef889a0b$var$EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};

var $5OdY0 = parcelRequire("5OdY0");

var $hkgLp = parcelRequire("hkgLp");
var $c18f74feef889a0b$require$Buffer = $hkgLp.Buffer;
var $c18f74feef889a0b$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $c18f74feef889a0b$var$_uint8ArrayToBuffer(chunk) {
    return $c18f74feef889a0b$require$Buffer.from(chunk);
}
function $c18f74feef889a0b$var$_isUint8Array(obj) {
    return $c18f74feef889a0b$require$Buffer.isBuffer(obj) || obj instanceof $c18f74feef889a0b$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $c18f74feef889a0b$var$util = Object.create((parcelRequire("4YQ7N")));

$c18f74feef889a0b$var$util.inherits = (parcelRequire("lpcNn"));

var $lOA8N = parcelRequire("lOA8N");
var $c18f74feef889a0b$var$debug = void 0;
if ($lOA8N && $lOA8N.debuglog) $c18f74feef889a0b$var$debug = $lOA8N.debuglog('stream');
else $c18f74feef889a0b$var$debug = function() {};

var $7Mled = parcelRequire("7Mled");

var $3wmK5 = parcelRequire("3wmK5");
var $c18f74feef889a0b$var$StringDecoder;
$c18f74feef889a0b$var$util.inherits($c18f74feef889a0b$var$Readable, $5OdY0);
var $c18f74feef889a0b$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $c18f74feef889a0b$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($4YWcW(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $c18f74feef889a0b$var$ReadableState(options, stream) {
    $c18f74feef889a0b$var$Duplex = $c18f74feef889a0b$var$Duplex || (parcelRequire("aSTZL"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $c18f74feef889a0b$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $7Mled();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$c18f74feef889a0b$var$StringDecoder) $c18f74feef889a0b$var$StringDecoder = (parcelRequire("ca1y8")).StringDecoder;
        this.decoder = new $c18f74feef889a0b$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $c18f74feef889a0b$var$Readable(options) {
    $c18f74feef889a0b$var$Duplex = $c18f74feef889a0b$var$Duplex || (parcelRequire("aSTZL"));
    if (!(this instanceof $c18f74feef889a0b$var$Readable)) return new $c18f74feef889a0b$var$Readable(options);
    this._readableState = new $c18f74feef889a0b$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $5OdY0.call(this);
}
Object.defineProperty($c18f74feef889a0b$var$Readable.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$c18f74feef889a0b$var$Readable.prototype.destroy = $3wmK5.destroy;
$c18f74feef889a0b$var$Readable.prototype._undestroy = $3wmK5.undestroy;
$c18f74feef889a0b$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$c18f74feef889a0b$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $c18f74feef889a0b$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $c18f74feef889a0b$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$c18f74feef889a0b$var$Readable.prototype.unshift = function(chunk) {
    return $c18f74feef889a0b$var$readableAddChunk(this, chunk, null, true, false);
};
function $c18f74feef889a0b$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $c18f74feef889a0b$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $c18f74feef889a0b$var$chunkInvalid(state, chunk);
        if (er) stream.emit('error', er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $c18f74feef889a0b$require$Buffer.prototype) chunk = $c18f74feef889a0b$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));
                else $c18f74feef889a0b$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit('error', new Error('stream.push() after EOF'));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $c18f74feef889a0b$var$addChunk(stream, state, chunk, false);
                    else $c18f74feef889a0b$var$maybeReadMore(stream, state);
                } else $c18f74feef889a0b$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $c18f74feef889a0b$var$needMoreData(state);
}
function $c18f74feef889a0b$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit('data', chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $c18f74feef889a0b$var$emitReadable(stream);
    }
    $c18f74feef889a0b$var$maybeReadMore(stream, state);
}
function $c18f74feef889a0b$var$chunkInvalid(state, chunk) {
    var er;
    if (!$c18f74feef889a0b$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $c18f74feef889a0b$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$c18f74feef889a0b$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$c18f74feef889a0b$var$Readable.prototype.setEncoding = function(enc) {
    if (!$c18f74feef889a0b$var$StringDecoder) $c18f74feef889a0b$var$StringDecoder = (parcelRequire("ca1y8")).StringDecoder;
    this._readableState.decoder = new $c18f74feef889a0b$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $c18f74feef889a0b$var$MAX_HWM = 0x800000;
function $c18f74feef889a0b$var$computeNewHighWaterMark(n) {
    if (n >= $c18f74feef889a0b$var$MAX_HWM) n = $c18f74feef889a0b$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $c18f74feef889a0b$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $c18f74feef889a0b$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$c18f74feef889a0b$var$Readable.prototype.read = function(n) {
    $c18f74feef889a0b$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $c18f74feef889a0b$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $c18f74feef889a0b$var$endReadable(this);
        else $c18f74feef889a0b$var$emitReadable(this);
        return null;
    }
    n = $c18f74feef889a0b$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $c18f74feef889a0b$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $c18f74feef889a0b$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $c18f74feef889a0b$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $c18f74feef889a0b$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $c18f74feef889a0b$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $c18f74feef889a0b$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $c18f74feef889a0b$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $c18f74feef889a0b$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $c18f74feef889a0b$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $c18f74feef889a0b$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $c18f74feef889a0b$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $c18f74feef889a0b$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) $ldmaM.nextTick($c18f74feef889a0b$var$emitReadable_, stream);
        else $c18f74feef889a0b$var$emitReadable_(stream);
    }
}
function $c18f74feef889a0b$var$emitReadable_(stream) {
    $c18f74feef889a0b$var$debug('emit readable');
    stream.emit('readable');
    $c18f74feef889a0b$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $c18f74feef889a0b$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $ldmaM.nextTick($c18f74feef889a0b$var$maybeReadMore_, stream, state);
    }
}
function $c18f74feef889a0b$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $c18f74feef889a0b$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$c18f74feef889a0b$var$Readable.prototype._read = function(n) {
    this.emit('error', new Error('_read() is not implemented'));
};
$c18f74feef889a0b$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $c18f74feef889a0b$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $igDjg.stdout && dest !== $igDjg.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $ldmaM.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $c18f74feef889a0b$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $c18f74feef889a0b$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $c18f74feef889a0b$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $c18f74feef889a0b$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on('data', ondata);
    function ondata(chunk) {
        $c18f74feef889a0b$var$debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $c18f74feef889a0b$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $c18f74feef889a0b$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $c18f74feef889a0b$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($c18f74feef889a0b$var$EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
    }
    // Make sure our error handler is attached before userland ones.
    $c18f74feef889a0b$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $c18f74feef889a0b$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $c18f74feef889a0b$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $c18f74feef889a0b$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $c18f74feef889a0b$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $c18f74feef889a0b$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $c18f74feef889a0b$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $c18f74feef889a0b$var$flow(src);
        }
    };
}
$c18f74feef889a0b$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $c18f74feef889a0b$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$c18f74feef889a0b$var$Readable.prototype.on = function(ev, fn) {
    var res = $5OdY0.prototype.on.call(this, ev, fn);
    if (ev === 'data') // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $ldmaM.nextTick($c18f74feef889a0b$var$nReadingNextTick, this);
            else if (state.length) $c18f74feef889a0b$var$emitReadable(this);
        }
    }
    return res;
};
$c18f74feef889a0b$var$Readable.prototype.addListener = $c18f74feef889a0b$var$Readable.prototype.on;
function $c18f74feef889a0b$var$nReadingNextTick(self1) {
    $c18f74feef889a0b$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$c18f74feef889a0b$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $c18f74feef889a0b$var$debug('resume');
        state.flowing = true;
        $c18f74feef889a0b$var$resume(this, state);
    }
    return this;
};
function $c18f74feef889a0b$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $ldmaM.nextTick($c18f74feef889a0b$var$resume_, stream, state);
    }
}
function $c18f74feef889a0b$var$resume_(stream, state) {
    if (!state.reading) {
        $c18f74feef889a0b$var$debug('resume read 0');
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    $c18f74feef889a0b$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$c18f74feef889a0b$var$Readable.prototype.pause = function() {
    $c18f74feef889a0b$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $c18f74feef889a0b$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    return this;
};
function $c18f74feef889a0b$var$flow(stream) {
    var state = stream._readableState;
    $c18f74feef889a0b$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$c18f74feef889a0b$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $c18f74feef889a0b$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $c18f74feef889a0b$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $c18f74feef889a0b$var$kProxyEvents.length; n++)stream.on($c18f74feef889a0b$var$kProxyEvents[n], this.emit.bind(this, $c18f74feef889a0b$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $c18f74feef889a0b$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($c18f74feef889a0b$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$c18f74feef889a0b$var$Readable._fromList = $c18f74feef889a0b$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $c18f74feef889a0b$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $c18f74feef889a0b$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $c18f74feef889a0b$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $c18f74feef889a0b$var$copyFromBufferString(n, list) : $c18f74feef889a0b$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $c18f74feef889a0b$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $c18f74feef889a0b$var$copyFromBuffer(n, list) {
    var ret = $c18f74feef889a0b$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $c18f74feef889a0b$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $ldmaM.nextTick($c18f74feef889a0b$var$endReadableNT, state, stream);
    }
}
function $c18f74feef889a0b$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
    }
}
function $c18f74feef889a0b$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("ldmaM", function(module, exports) {

var $igDjg = parcelRequire("igDjg");
'use strict';
if (typeof $igDjg === 'undefined' || !$igDjg.version || $igDjg.version.indexOf('v0.') === 0 || $igDjg.version.indexOf('v1.') === 0 && $igDjg.version.indexOf('v1.8.') !== 0) module.exports = {
    nextTick: $f71c02f0c6a52960$var$nextTick
};
else module.exports = $igDjg;
function $f71c02f0c6a52960$var$nextTick(fn, arg1, arg2, arg3) {
    if (typeof fn !== 'function') throw new TypeError('"callback" argument must be a function');
    var len = arguments.length;
    var args, i;
    switch(len){
        case 0:
        case 1:
            return $igDjg.nextTick(fn);
        case 2:
            return $igDjg.nextTick(function afterTickOne() {
                fn.call(null, arg1);
            });
        case 3:
            return $igDjg.nextTick(function afterTickTwo() {
                fn.call(null, arg1, arg2);
            });
        case 4:
            return $igDjg.nextTick(function afterTickThree() {
                fn.call(null, arg1, arg2, arg3);
            });
        default:
            args = new Array(len - 1);
            i = 0;
            while(i < args.length)args[i++] = arguments[i];
            return $igDjg.nextTick(function afterTick() {
                fn.apply(null, args);
            });
    }
}

});

parcelRegister("4YWcW", function(module, exports) {
var $3a09ead716c65ea2$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $3a09ead716c65ea2$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("5OdY0", function(module, exports) {

module.exports = (parcelRequire("7OU8o")).EventEmitter;

});

parcelRegister("hkgLp", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $5Ovjr = parcelRequire("5Ovjr");
var $c9d14eda548076c8$var$Buffer = $5Ovjr.Buffer;
// alternative to using Object.keys for old browsers
function $c9d14eda548076c8$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($c9d14eda548076c8$var$Buffer.from && $c9d14eda548076c8$var$Buffer.alloc && $c9d14eda548076c8$var$Buffer.allocUnsafe && $c9d14eda548076c8$var$Buffer.allocUnsafeSlow) module.exports = $5Ovjr;
else {
    // Copy properties from require('buffer')
    $c9d14eda548076c8$var$copyProps($5Ovjr, module.exports);
    module.exports.Buffer = $c9d14eda548076c8$var$SafeBuffer;
}
function $c9d14eda548076c8$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $c9d14eda548076c8$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$c9d14eda548076c8$var$copyProps($c9d14eda548076c8$var$Buffer, $c9d14eda548076c8$var$SafeBuffer);
$c9d14eda548076c8$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $c9d14eda548076c8$var$Buffer(arg, encodingOrOffset, length);
};
$c9d14eda548076c8$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $c9d14eda548076c8$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$c9d14eda548076c8$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $c9d14eda548076c8$var$Buffer(size);
};
$c9d14eda548076c8$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $5Ovjr.SlowBuffer(size);
};

});

parcelRegister("4YQ7N", function(module, exports) {
$parcel$export(module.exports, "isArray", () => $3a0532ea6d9537b3$export$43bee75e5e14138e, (v) => $3a0532ea6d9537b3$export$43bee75e5e14138e = v);
$parcel$export(module.exports, "isBoolean", () => $3a0532ea6d9537b3$export$f9ce7b637dfbe238, (v) => $3a0532ea6d9537b3$export$f9ce7b637dfbe238 = v);
$parcel$export(module.exports, "isNull", () => $3a0532ea6d9537b3$export$630801d484da15df, (v) => $3a0532ea6d9537b3$export$630801d484da15df = v);
$parcel$export(module.exports, "isNullOrUndefined", () => $3a0532ea6d9537b3$export$bedb7023a7733221, (v) => $3a0532ea6d9537b3$export$bedb7023a7733221 = v);
$parcel$export(module.exports, "isNumber", () => $3a0532ea6d9537b3$export$7e4aa119212bc614, (v) => $3a0532ea6d9537b3$export$7e4aa119212bc614 = v);
$parcel$export(module.exports, "isString", () => $3a0532ea6d9537b3$export$844ec244b1367d54, (v) => $3a0532ea6d9537b3$export$844ec244b1367d54 = v);
$parcel$export(module.exports, "isSymbol", () => $3a0532ea6d9537b3$export$a244864fd9645c7f, (v) => $3a0532ea6d9537b3$export$a244864fd9645c7f = v);
$parcel$export(module.exports, "isUndefined", () => $3a0532ea6d9537b3$export$fce6876652108ab, (v) => $3a0532ea6d9537b3$export$fce6876652108ab = v);
$parcel$export(module.exports, "isRegExp", () => $3a0532ea6d9537b3$export$49841c62b9eff15, (v) => $3a0532ea6d9537b3$export$49841c62b9eff15 = v);
$parcel$export(module.exports, "isObject", () => $3a0532ea6d9537b3$export$a6cdc56e425d0d0a, (v) => $3a0532ea6d9537b3$export$a6cdc56e425d0d0a = v);
$parcel$export(module.exports, "isDate", () => $3a0532ea6d9537b3$export$871608497c498473, (v) => $3a0532ea6d9537b3$export$871608497c498473 = v);
$parcel$export(module.exports, "isError", () => $3a0532ea6d9537b3$export$e6127cc7fe7395c3, (v) => $3a0532ea6d9537b3$export$e6127cc7fe7395c3 = v);
$parcel$export(module.exports, "isFunction", () => $3a0532ea6d9537b3$export$f6e2535fb5126e54, (v) => $3a0532ea6d9537b3$export$f6e2535fb5126e54 = v);
$parcel$export(module.exports, "isPrimitive", () => $3a0532ea6d9537b3$export$c3825b437cbdea5c, (v) => $3a0532ea6d9537b3$export$c3825b437cbdea5c = v);
$parcel$export(module.exports, "isBuffer", () => $3a0532ea6d9537b3$export$a7884ebc965f8f54, (v) => $3a0532ea6d9537b3$export$a7884ebc965f8f54 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
var $3a0532ea6d9537b3$export$43bee75e5e14138e;
var $3a0532ea6d9537b3$export$f9ce7b637dfbe238;
var $3a0532ea6d9537b3$export$630801d484da15df;
var $3a0532ea6d9537b3$export$bedb7023a7733221;
var $3a0532ea6d9537b3$export$7e4aa119212bc614;
var $3a0532ea6d9537b3$export$844ec244b1367d54;
var $3a0532ea6d9537b3$export$a244864fd9645c7f;
var $3a0532ea6d9537b3$export$fce6876652108ab;
var $3a0532ea6d9537b3$export$49841c62b9eff15;
var $3a0532ea6d9537b3$export$a6cdc56e425d0d0a;
var $3a0532ea6d9537b3$export$871608497c498473;
var $3a0532ea6d9537b3$export$e6127cc7fe7395c3;
var $3a0532ea6d9537b3$export$f6e2535fb5126e54;
var $3a0532ea6d9537b3$export$c3825b437cbdea5c;
var $3a0532ea6d9537b3$export$a7884ebc965f8f54;
function $3a0532ea6d9537b3$var$isArray(arg) {
    if (Array.isArray) return Array.isArray(arg);
    return $3a0532ea6d9537b3$var$objectToString(arg) === '[object Array]';
}
$3a0532ea6d9537b3$export$43bee75e5e14138e = $3a0532ea6d9537b3$var$isArray;
function $3a0532ea6d9537b3$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
$3a0532ea6d9537b3$export$f9ce7b637dfbe238 = $3a0532ea6d9537b3$var$isBoolean;
function $3a0532ea6d9537b3$var$isNull(arg) {
    return arg === null;
}
$3a0532ea6d9537b3$export$630801d484da15df = $3a0532ea6d9537b3$var$isNull;
function $3a0532ea6d9537b3$var$isNullOrUndefined(arg) {
    return arg == null;
}
$3a0532ea6d9537b3$export$bedb7023a7733221 = $3a0532ea6d9537b3$var$isNullOrUndefined;
function $3a0532ea6d9537b3$var$isNumber(arg) {
    return typeof arg === 'number';
}
$3a0532ea6d9537b3$export$7e4aa119212bc614 = $3a0532ea6d9537b3$var$isNumber;
function $3a0532ea6d9537b3$var$isString(arg) {
    return typeof arg === 'string';
}
$3a0532ea6d9537b3$export$844ec244b1367d54 = $3a0532ea6d9537b3$var$isString;
function $3a0532ea6d9537b3$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
$3a0532ea6d9537b3$export$a244864fd9645c7f = $3a0532ea6d9537b3$var$isSymbol;
function $3a0532ea6d9537b3$var$isUndefined(arg) {
    return arg === void 0;
}
$3a0532ea6d9537b3$export$fce6876652108ab = $3a0532ea6d9537b3$var$isUndefined;
function $3a0532ea6d9537b3$var$isRegExp(re) {
    return $3a0532ea6d9537b3$var$objectToString(re) === '[object RegExp]';
}
$3a0532ea6d9537b3$export$49841c62b9eff15 = $3a0532ea6d9537b3$var$isRegExp;
function $3a0532ea6d9537b3$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
$3a0532ea6d9537b3$export$a6cdc56e425d0d0a = $3a0532ea6d9537b3$var$isObject;
function $3a0532ea6d9537b3$var$isDate(d) {
    return $3a0532ea6d9537b3$var$objectToString(d) === '[object Date]';
}
$3a0532ea6d9537b3$export$871608497c498473 = $3a0532ea6d9537b3$var$isDate;
function $3a0532ea6d9537b3$var$isError(e) {
    return $3a0532ea6d9537b3$var$objectToString(e) === '[object Error]' || e instanceof Error;
}
$3a0532ea6d9537b3$export$e6127cc7fe7395c3 = $3a0532ea6d9537b3$var$isError;
function $3a0532ea6d9537b3$var$isFunction(arg) {
    return typeof arg === 'function';
}
$3a0532ea6d9537b3$export$f6e2535fb5126e54 = $3a0532ea6d9537b3$var$isFunction;
function $3a0532ea6d9537b3$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
$3a0532ea6d9537b3$export$c3825b437cbdea5c = $3a0532ea6d9537b3$var$isPrimitive;

$3a0532ea6d9537b3$export$a7884ebc965f8f54 = (parcelRequire("5Ovjr")).Buffer.isBuffer;
function $3a0532ea6d9537b3$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}

});

parcelRegister("7Mled", function(module, exports) {
'use strict';
function $5a9d7b9a333b8ae5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $hkgLp = parcelRequire("hkgLp");
var $5a9d7b9a333b8ae5$require$Buffer = $hkgLp.Buffer;

var $lOA8N = parcelRequire("lOA8N");
function $5a9d7b9a333b8ae5$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $5a9d7b9a333b8ae5$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return '';
        var p = this.head;
        var ret = '' + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $5a9d7b9a333b8ae5$require$Buffer.alloc(0);
        var ret = $5a9d7b9a333b8ae5$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $5a9d7b9a333b8ae5$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($lOA8N && $lOA8N.inspect && $lOA8N.inspect.custom) module.exports.prototype[$lOA8N.inspect.custom] = function() {
    var obj = $lOA8N.inspect({
        length: this.length
    });
    return this.constructor.name + ' ' + obj;
};

});

parcelRegister("3wmK5", function(module, exports) {
'use strict';

var $ldmaM = parcelRequire("ldmaM");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $29060068f7c131cc$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $ldmaM.nextTick($29060068f7c131cc$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $ldmaM.nextTick($29060068f7c131cc$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $ldmaM.nextTick($29060068f7c131cc$var$emitErrorNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $ldmaM.nextTick($29060068f7c131cc$var$emitErrorNT, _this, err);
            }
        } else if (cb) cb(err);
    });
    return this;
}
function $29060068f7c131cc$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $29060068f7c131cc$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
module.exports = {
    destroy: $29060068f7c131cc$var$destroy,
    undestroy: $29060068f7c131cc$var$undestroy
};

});

parcelRegister("aSTZL", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
'use strict';

var $ldmaM = parcelRequire("ldmaM");
/*</replacement>*/ /*<replacement>*/ var $7eca62071f55f6a8$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $7eca62071f55f6a8$var$Duplex;

/*<replacement>*/ var $7eca62071f55f6a8$var$util = Object.create((parcelRequire("4YQ7N")));

$7eca62071f55f6a8$var$util.inherits = (parcelRequire("lpcNn"));

var $gCjFU = parcelRequire("gCjFU");

var $7Y1rN = parcelRequire("7Y1rN");
$7eca62071f55f6a8$var$util.inherits($7eca62071f55f6a8$var$Duplex, $gCjFU);
// avoid scope creep, the keys array can then be collected
var $7eca62071f55f6a8$var$keys = $7eca62071f55f6a8$var$objectKeys($7Y1rN.prototype);
for(var $7eca62071f55f6a8$var$v = 0; $7eca62071f55f6a8$var$v < $7eca62071f55f6a8$var$keys.length; $7eca62071f55f6a8$var$v++){
    var $7eca62071f55f6a8$var$method = $7eca62071f55f6a8$var$keys[$7eca62071f55f6a8$var$v];
    if (!$7eca62071f55f6a8$var$Duplex.prototype[$7eca62071f55f6a8$var$method]) $7eca62071f55f6a8$var$Duplex.prototype[$7eca62071f55f6a8$var$method] = $7Y1rN.prototype[$7eca62071f55f6a8$var$method];
}
function $7eca62071f55f6a8$var$Duplex(options) {
    if (!(this instanceof $7eca62071f55f6a8$var$Duplex)) return new $7eca62071f55f6a8$var$Duplex(options);
    $gCjFU.call(this, options);
    $7Y1rN.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', $7eca62071f55f6a8$var$onend);
}
Object.defineProperty($7eca62071f55f6a8$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $7eca62071f55f6a8$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $ldmaM.nextTick($7eca62071f55f6a8$var$onEndNT, this);
}
function $7eca62071f55f6a8$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($7eca62071f55f6a8$var$Duplex.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$7eca62071f55f6a8$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $ldmaM.nextTick(cb, err);
};

});
parcelRegister("7Y1rN", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $ldmaM = parcelRequire("ldmaM");
/*</replacement>*/ module.exports = $5ccf426d877afb1d$var$Writable;
/* <replacement> */ function $5ccf426d877afb1d$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $5ccf426d877afb1d$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $5ccf426d877afb1d$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $5ccf426d877afb1d$var$asyncWrite = (0, $ldmaM.nextTick);
/*</replacement>*/ /*<replacement>*/ var $5ccf426d877afb1d$var$Duplex;
/*</replacement>*/ $5ccf426d877afb1d$var$Writable.WritableState = $5ccf426d877afb1d$var$WritableState;

/*<replacement>*/ var $5ccf426d877afb1d$var$util = Object.create((parcelRequire("4YQ7N")));

$5ccf426d877afb1d$var$util.inherits = (parcelRequire("lpcNn"));

/*</replacement>*/ /*<replacement>*/ var $5ccf426d877afb1d$var$internalUtil = {
    deprecate: (parcelRequire("aULhc"))
};

var $5OdY0 = parcelRequire("5OdY0");

var $hkgLp = parcelRequire("hkgLp");
var $5ccf426d877afb1d$require$Buffer = $hkgLp.Buffer;
var $5ccf426d877afb1d$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $5ccf426d877afb1d$var$_uint8ArrayToBuffer(chunk) {
    return $5ccf426d877afb1d$require$Buffer.from(chunk);
}
function $5ccf426d877afb1d$var$_isUint8Array(obj) {
    return $5ccf426d877afb1d$require$Buffer.isBuffer(obj) || obj instanceof $5ccf426d877afb1d$var$OurUint8Array;
}

var $3wmK5 = parcelRequire("3wmK5");
$5ccf426d877afb1d$var$util.inherits($5ccf426d877afb1d$var$Writable, $5OdY0);
function $5ccf426d877afb1d$var$nop() {}

function $5ccf426d877afb1d$var$WritableState(options, stream) {
    $5ccf426d877afb1d$var$Duplex = $5ccf426d877afb1d$var$Duplex || (parcelRequire("aSTZL"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $5ccf426d877afb1d$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $5ccf426d877afb1d$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $5ccf426d877afb1d$var$CorkedRequest(this);
}
$5ccf426d877afb1d$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($5ccf426d877afb1d$var$WritableState.prototype, 'buffer', {
            get: $5ccf426d877afb1d$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $5ccf426d877afb1d$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $5ccf426d877afb1d$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($5ccf426d877afb1d$var$Writable, Symbol.hasInstance, {
        value: function(object) {
            if ($5ccf426d877afb1d$var$realHasInstance.call(this, object)) return true;
            if (this !== $5ccf426d877afb1d$var$Writable) return false;
            return object && object._writableState instanceof $5ccf426d877afb1d$var$WritableState;
        }
    });
} else $5ccf426d877afb1d$var$realHasInstance = function(object) {
    return object instanceof this;
};

function $5ccf426d877afb1d$var$Writable(options) {
    $5ccf426d877afb1d$var$Duplex = $5ccf426d877afb1d$var$Duplex || (parcelRequire("aSTZL"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$5ccf426d877afb1d$var$realHasInstance.call($5ccf426d877afb1d$var$Writable, this) && !(this instanceof $5ccf426d877afb1d$var$Duplex)) return new $5ccf426d877afb1d$var$Writable(options);
    this._writableState = new $5ccf426d877afb1d$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $5OdY0.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$5ccf426d877afb1d$var$Writable.prototype.pipe = function() {
    this.emit('error', new Error('Cannot pipe, not readable'));
};
function $5ccf426d877afb1d$var$writeAfterEnd(stream, cb) {
    var er = new Error('write after end');
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit('error', er);
    $ldmaM.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $5ccf426d877afb1d$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError('May not write null values to stream');
    else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    if (er) {
        stream.emit('error', er);
        $ldmaM.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$5ccf426d877afb1d$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $5ccf426d877afb1d$var$_isUint8Array(chunk);
    if (isBuf && !$5ccf426d877afb1d$require$Buffer.isBuffer(chunk)) chunk = $5ccf426d877afb1d$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $5ccf426d877afb1d$var$nop;
    if (state.ended) $5ccf426d877afb1d$var$writeAfterEnd(this, cb);
    else if (isBuf || $5ccf426d877afb1d$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $5ccf426d877afb1d$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$5ccf426d877afb1d$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$5ccf426d877afb1d$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $5ccf426d877afb1d$var$clearBuffer(this, state);
    }
};
$5ccf426d877afb1d$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $5ccf426d877afb1d$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $5ccf426d877afb1d$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($5ccf426d877afb1d$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $5ccf426d877afb1d$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $5ccf426d877afb1d$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $5ccf426d877afb1d$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $5ccf426d877afb1d$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $5ccf426d877afb1d$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $ldmaM.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $ldmaM.nextTick($5ccf426d877afb1d$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
        // this can emit finish, but finish must
        // always follow error
        $5ccf426d877afb1d$var$finishMaybe(stream, state);
    }
}
function $5ccf426d877afb1d$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $5ccf426d877afb1d$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $5ccf426d877afb1d$var$onwriteStateUpdate(state);
    if (er) $5ccf426d877afb1d$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $5ccf426d877afb1d$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $5ccf426d877afb1d$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $5ccf426d877afb1d$var$asyncWrite($5ccf426d877afb1d$var$afterWrite, stream, state, finished, cb);
        else $5ccf426d877afb1d$var$afterWrite(stream, state, finished, cb);
    }
}
function $5ccf426d877afb1d$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $5ccf426d877afb1d$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $5ccf426d877afb1d$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $5ccf426d877afb1d$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $5ccf426d877afb1d$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $5ccf426d877afb1d$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $5ccf426d877afb1d$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $5ccf426d877afb1d$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$5ccf426d877afb1d$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error('_write() is not implemented'));
};
$5ccf426d877afb1d$var$Writable.prototype._writev = null;
$5ccf426d877afb1d$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $5ccf426d877afb1d$var$endWritable(this, state, cb);
};
function $5ccf426d877afb1d$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $5ccf426d877afb1d$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit('error', err);
        state.prefinished = true;
        stream.emit('prefinish');
        $5ccf426d877afb1d$var$finishMaybe(stream, state);
    });
}
function $5ccf426d877afb1d$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function') {
            state.pendingcb++;
            state.finalCalled = true;
            $ldmaM.nextTick($5ccf426d877afb1d$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $5ccf426d877afb1d$var$finishMaybe(stream, state) {
    var need = $5ccf426d877afb1d$var$needFinish(state);
    if (need) {
        $5ccf426d877afb1d$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
        }
    }
    return need;
}
function $5ccf426d877afb1d$var$endWritable(stream, state, cb) {
    state.ending = true;
    $5ccf426d877afb1d$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $ldmaM.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $5ccf426d877afb1d$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($5ccf426d877afb1d$var$Writable.prototype, 'destroyed', {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$5ccf426d877afb1d$var$Writable.prototype.destroy = $3wmK5.destroy;
$5ccf426d877afb1d$var$Writable.prototype._undestroy = $3wmK5.undestroy;
$5ccf426d877afb1d$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});


parcelRegister("ca1y8", function(module, exports) {
$parcel$export(module.exports, "StringDecoder", () => $8da79ee6aeaa085e$export$63a7aa211a91ed69, (v) => $8da79ee6aeaa085e$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $8da79ee6aeaa085e$export$63a7aa211a91ed69;
'use strict';

var $hkgLp = parcelRequire("hkgLp");
var $8da79ee6aeaa085e$require$Buffer = $hkgLp.Buffer;
/*</replacement>*/ var $8da79ee6aeaa085e$var$isEncoding = $8da79ee6aeaa085e$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $8da79ee6aeaa085e$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $8da79ee6aeaa085e$var$normalizeEncoding(enc) {
    var nenc = $8da79ee6aeaa085e$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($8da79ee6aeaa085e$require$Buffer.isEncoding === $8da79ee6aeaa085e$var$isEncoding || !$8da79ee6aeaa085e$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$8da79ee6aeaa085e$export$63a7aa211a91ed69 = $8da79ee6aeaa085e$var$StringDecoder;
function $8da79ee6aeaa085e$var$StringDecoder(encoding) {
    this.encoding = $8da79ee6aeaa085e$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $8da79ee6aeaa085e$var$utf16Text;
            this.end = $8da79ee6aeaa085e$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $8da79ee6aeaa085e$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $8da79ee6aeaa085e$var$base64Text;
            this.end = $8da79ee6aeaa085e$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $8da79ee6aeaa085e$var$simpleWrite;
            this.end = $8da79ee6aeaa085e$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $8da79ee6aeaa085e$require$Buffer.allocUnsafe(nb);
}
$8da79ee6aeaa085e$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$8da79ee6aeaa085e$var$StringDecoder.prototype.end = $8da79ee6aeaa085e$var$utf8End;
// Returns only complete characters in a Buffer
$8da79ee6aeaa085e$var$StringDecoder.prototype.text = $8da79ee6aeaa085e$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$8da79ee6aeaa085e$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $8da79ee6aeaa085e$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $8da79ee6aeaa085e$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $8da79ee6aeaa085e$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $8da79ee6aeaa085e$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $8da79ee6aeaa085e$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $8da79ee6aeaa085e$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $8da79ee6aeaa085e$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $8da79ee6aeaa085e$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $8da79ee6aeaa085e$var$utf8Text(buf, i) {
    var total = $8da79ee6aeaa085e$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $8da79ee6aeaa085e$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $8da79ee6aeaa085e$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $8da79ee6aeaa085e$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $8da79ee6aeaa085e$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $8da79ee6aeaa085e$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $8da79ee6aeaa085e$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $8da79ee6aeaa085e$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});


parcelRegister("5FKU5", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $42152a2652bdd5bf$var$Transform;

var $aSTZL = parcelRequire("aSTZL");

/*<replacement>*/ var $42152a2652bdd5bf$var$util = Object.create((parcelRequire("4YQ7N")));

$42152a2652bdd5bf$var$util.inherits = (parcelRequire("lpcNn"));
/*</replacement>*/ $42152a2652bdd5bf$var$util.inherits($42152a2652bdd5bf$var$Transform, $aSTZL);
function $42152a2652bdd5bf$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit('error', new Error('write callback called multiple times'));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $42152a2652bdd5bf$var$Transform(options) {
    if (!(this instanceof $42152a2652bdd5bf$var$Transform)) return new $42152a2652bdd5bf$var$Transform(options);
    $aSTZL.call(this, options);
    this._transformState = {
        afterTransform: $42152a2652bdd5bf$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $42152a2652bdd5bf$var$prefinish);
}
function $42152a2652bdd5bf$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function') this._flush(function(er, data) {
        $42152a2652bdd5bf$var$done(_this, er, data);
    });
    else $42152a2652bdd5bf$var$done(this, null, null);
}
$42152a2652bdd5bf$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $aSTZL.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$42152a2652bdd5bf$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error('_transform() is not implemented');
};
$42152a2652bdd5bf$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$42152a2652bdd5bf$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$42152a2652bdd5bf$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $aSTZL.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit('close');
    });
};
function $42152a2652bdd5bf$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
    if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
}

});

parcelRegister("7czWT", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $53e58a1240f81b5f$var$PassThrough;

var $5FKU5 = parcelRequire("5FKU5");

/*<replacement>*/ var $53e58a1240f81b5f$var$util = Object.create((parcelRequire("4YQ7N")));

$53e58a1240f81b5f$var$util.inherits = (parcelRequire("lpcNn"));
/*</replacement>*/ $53e58a1240f81b5f$var$util.inherits($53e58a1240f81b5f$var$PassThrough, $5FKU5);
function $53e58a1240f81b5f$var$PassThrough(options) {
    if (!(this instanceof $53e58a1240f81b5f$var$PassThrough)) return new $53e58a1240f81b5f$var$PassThrough(options);
    $5FKU5.call(this, options);
}
$53e58a1240f81b5f$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});


parcelRegister("3HcYt", function(module, exports) {
'use strict';

var $bc1ju = parcelRequire("bc1ju");
var $2b0f73b3e5a7a0ae$require$Buffer = $bc1ju.Buffer;

var $6Gm8U = parcelRequire("6Gm8U");

var $9lS7E = parcelRequire("9lS7E");

var $i8FXa = parcelRequire("i8FXa");
var $2b0f73b3e5a7a0ae$require$EC = $i8FXa.ec;

var $fFAQR = parcelRequire("fFAQR");

var $3ot7a = parcelRequire("3ot7a");

var $eoUcT = parcelRequire("eoUcT");
var $2b0f73b3e5a7a0ae$var$RSA_PKCS1_PADDING = 1;
function $2b0f73b3e5a7a0ae$var$sign(hash, key, hashType, signType, tag) {
    var priv = $3ot7a(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
        return $2b0f73b3e5a7a0ae$var$ecSign(hash, priv);
    } else if (priv.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong private key type');
        return $2b0f73b3e5a7a0ae$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
    if (key.padding !== undefined && key.padding !== $2b0f73b3e5a7a0ae$var$RSA_PKCS1_PADDING) throw new Error('illegal or unsupported padding mode');
    hash = $2b0f73b3e5a7a0ae$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $9lS7E(pad, priv);
    return out;
}
function $2b0f73b3e5a7a0ae$var$ecSign(hash, priv) {
    var curveId = $eoUcT[priv.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'));
    var curve = new $2b0f73b3e5a7a0ae$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $2b0f73b3e5a7a0ae$require$Buffer.from(out.toDER());
}
function $2b0f73b3e5a7a0ae$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $fFAQR(0);
    var k;
    var H = $2b0f73b3e5a7a0ae$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $2b0f73b3e5a7a0ae$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $2b0f73b3e5a7a0ae$var$makeKey(q, kv, algo);
        r = $2b0f73b3e5a7a0ae$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $fFAQR(0);
        }
    }
    return $2b0f73b3e5a7a0ae$var$toDER(r, s);
}
function $2b0f73b3e5a7a0ae$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $2b0f73b3e5a7a0ae$require$Buffer.from(res);
}
function $2b0f73b3e5a7a0ae$var$getKey(x, q, hash, algo) {
    x = $2b0f73b3e5a7a0ae$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $2b0f73b3e5a7a0ae$require$Buffer.alloc(q.byteLength() - x.length);
        x = $2b0f73b3e5a7a0ae$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $2b0f73b3e5a7a0ae$var$bits2octets(hash, q);
    var v = $2b0f73b3e5a7a0ae$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $2b0f73b3e5a7a0ae$require$Buffer.alloc(hlen);
    k = $6Gm8U(algo, k).update(v).update($2b0f73b3e5a7a0ae$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $6Gm8U(algo, k).update(v).digest();
    k = $6Gm8U(algo, k).update(v).update($2b0f73b3e5a7a0ae$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $6Gm8U(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $2b0f73b3e5a7a0ae$var$bits2int(obits, q) {
    var bits = new $fFAQR(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $2b0f73b3e5a7a0ae$var$bits2octets(bits, q) {
    bits = $2b0f73b3e5a7a0ae$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $2b0f73b3e5a7a0ae$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $2b0f73b3e5a7a0ae$require$Buffer.alloc(q.byteLength() - out.length);
        out = $2b0f73b3e5a7a0ae$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $2b0f73b3e5a7a0ae$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $2b0f73b3e5a7a0ae$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $6Gm8U(algo, kv.k).update(kv.v).digest();
            t = $2b0f73b3e5a7a0ae$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $2b0f73b3e5a7a0ae$var$bits2int(t, q);
        kv.k = $6Gm8U(algo, kv.k).update(kv.v).update($2b0f73b3e5a7a0ae$require$Buffer.from([
            0
        ])).digest();
        kv.v = $6Gm8U(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $2b0f73b3e5a7a0ae$var$makeR(g, k, p, q) {
    return g.toRed($fFAQR.mont(p)).redPow(k).fromRed().mod(q);
}
module.exports = $2b0f73b3e5a7a0ae$var$sign;
module.exports.getKey = $2b0f73b3e5a7a0ae$var$getKey;
module.exports.makeKey = $2b0f73b3e5a7a0ae$var$makeKey;

});
parcelRegister("9lS7E", function(module, exports) {
'use strict';

var $fFAQR = parcelRequire("fFAQR");

var $49lWG = parcelRequire("49lWG");

var $bc1ju = parcelRequire("bc1ju");
var $6cf00ecd60d55341$require$Buffer = $bc1ju.Buffer;
function $6cf00ecd60d55341$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $fFAQR($49lWG(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $6cf00ecd60d55341$var$blind(priv) {
    var r = $6cf00ecd60d55341$var$getr(priv);
    var blinder = r.toRed($fFAQR.mont(priv.modulus)).redPow(new $fFAQR(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $6cf00ecd60d55341$var$crt(msg, priv) {
    var blinds = $6cf00ecd60d55341$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $fFAQR(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($fFAQR.mont(priv.prime1));
    var c2 = blinded.toRed($fFAQR.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($6cf00ecd60d55341$require$Buffer, 'be', len);
}
$6cf00ecd60d55341$var$crt.getr = $6cf00ecd60d55341$var$getr;
module.exports = $6cf00ecd60d55341$var$crt;

});
parcelRegister("fFAQR", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("lOA8N")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
        BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("i8FXa", function(module, exports) {
'use strict';
var $d349846d24ea0b2b$var$elliptic = module.exports;

$d349846d24ea0b2b$var$elliptic.version = (parcelRequire("5o7QR")).version;

$d349846d24ea0b2b$var$elliptic.utils = (parcelRequire("adpkR"));

$d349846d24ea0b2b$var$elliptic.rand = (parcelRequire("6WjTK"));

$d349846d24ea0b2b$var$elliptic.curve = (parcelRequire("jZNQh"));

$d349846d24ea0b2b$var$elliptic.curves = (parcelRequire("dc9yW"));

// Protocols
$d349846d24ea0b2b$var$elliptic.ec = (parcelRequire("2gaKR"));

$d349846d24ea0b2b$var$elliptic.eddsa = (parcelRequire("lcOlN"));

});
parcelRegister("5o7QR", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"elliptic\",\"version\":\"6.6.1\",\"description\":\"EC cryptography\",\"main\":\"lib\\/elliptic.js\",\"files\":[\"lib\"],\"scripts\":{\"lint\":\"eslint lib test\",\"lint:fix\":\"npm run lint -- --fix\",\"unit\":\"istanbul test _mocha --reporter=spec test\\/index.js\",\"test\":\"npm run lint && npm run unit\",\"version\":\"grunt dist && git add dist\\/\"},\"repository\":{\"type\":\"git\",\"url\":\"git@github.com:indutny\\/elliptic\"},\"keywords\":[\"EC\",\"Elliptic\",\"curve\",\"Cryptography\"],\"author\":\"Fedor Indutny <fedor@indutny.com>\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https:\\/\\/github.com\\/indutny\\/elliptic\\/issues\"},\"homepage\":\"https:\\/\\/github.com\\/indutny\\/elliptic\",\"devDependencies\":{\"brfs\":\"^2.0.2\",\"coveralls\":\"^3.1.0\",\"eslint\":\"^7.6.0\",\"grunt\":\"^1.2.1\",\"grunt-browserify\":\"^5.3.0\",\"grunt-cli\":\"^1.3.2\",\"grunt-contrib-connect\":\"^3.0.0\",\"grunt-contrib-copy\":\"^1.0.0\",\"grunt-contrib-uglify\":\"^5.0.0\",\"grunt-mocha-istanbul\":\"^5.0.2\",\"grunt-saucelabs\":\"^9.0.1\",\"istanbul\":\"^0.4.5\",\"mocha\":\"^8.0.1\"},\"dependencies\":{\"bn.js\":\"^4.11.9\",\"brorand\":\"^1.1.0\",\"hash.js\":\"^1.0.0\",\"hmac-drbg\":\"^1.0.1\",\"inherits\":\"^2.0.4\",\"minimalistic-assert\":\"^1.0.1\",\"minimalistic-crypto-utils\":\"^1.0.1\"}}");

});

parcelRegister("adpkR", function(module, exports) {
'use strict';
var $76fec561c2707b9d$var$utils = module.exports;

var $2DhqK = parcelRequire("2DhqK");

var $fvn5w = parcelRequire("fvn5w");

var $fZjlU = parcelRequire("fZjlU");
$76fec561c2707b9d$var$utils.assert = $fvn5w;
$76fec561c2707b9d$var$utils.toArray = $fZjlU.toArray;
$76fec561c2707b9d$var$utils.zero2 = $fZjlU.zero2;
$76fec561c2707b9d$var$utils.toHex = $fZjlU.toHex;
$76fec561c2707b9d$var$utils.encode = $fZjlU.encode;
// Represent num in a w-NAF form
function $76fec561c2707b9d$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$76fec561c2707b9d$var$utils.getNAF = $76fec561c2707b9d$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $76fec561c2707b9d$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$76fec561c2707b9d$var$utils.getJSF = $76fec561c2707b9d$var$getJSF;
function $76fec561c2707b9d$var$cachedProperty(obj, name, computer) {
    var key = '_' + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$76fec561c2707b9d$var$utils.cachedProperty = $76fec561c2707b9d$var$cachedProperty;
function $76fec561c2707b9d$var$parseBytes(bytes) {
    return typeof bytes === 'string' ? $76fec561c2707b9d$var$utils.toArray(bytes, 'hex') : bytes;
}
$76fec561c2707b9d$var$utils.parseBytes = $76fec561c2707b9d$var$parseBytes;
function $76fec561c2707b9d$var$intFromLE(bytes) {
    return new $2DhqK(bytes, 'hex', 'le');
}
$76fec561c2707b9d$var$utils.intFromLE = $76fec561c2707b9d$var$intFromLE;

});
parcelRegister("fZjlU", function(module, exports) {
'use strict';
var $ba3b907a172242eb$var$utils = module.exports;
function $ba3b907a172242eb$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== 'string') {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === 'hex') {
        msg = msg.replace(/[^a-z0-9]+/ig, '');
        if (msg.length % 2 !== 0) msg = '0' + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$ba3b907a172242eb$var$utils.toArray = $ba3b907a172242eb$var$toArray;
function $ba3b907a172242eb$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$ba3b907a172242eb$var$utils.zero2 = $ba3b907a172242eb$var$zero2;
function $ba3b907a172242eb$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $ba3b907a172242eb$var$zero2(msg[i].toString(16));
    return res;
}
$ba3b907a172242eb$var$utils.toHex = $ba3b907a172242eb$var$toHex;
$ba3b907a172242eb$var$utils.encode = function encode(arr, enc) {
    if (enc === 'hex') return $ba3b907a172242eb$var$toHex(arr);
    else return arr;
};

});


parcelRegister("jZNQh", function(module, exports) {
'use strict';
var $e8ea6078385370d6$var$curve = module.exports;

$e8ea6078385370d6$var$curve.base = (parcelRequire("lSqYL"));

$e8ea6078385370d6$var$curve.short = (parcelRequire("dqXxw"));

$e8ea6078385370d6$var$curve.mont = (parcelRequire("lNS7a"));

$e8ea6078385370d6$var$curve.edwards = (parcelRequire("iyIfL"));

});
parcelRegister("lSqYL", function(module, exports) {
'use strict';

var $2DhqK = parcelRequire("2DhqK");

var $adpkR = parcelRequire("adpkR");
var $fed39195ba64a5cf$var$getNAF = $adpkR.getNAF;
var $fed39195ba64a5cf$var$getJSF = $adpkR.getJSF;
var $fed39195ba64a5cf$var$assert = $adpkR.assert;
function $fed39195ba64a5cf$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $2DhqK(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $2DhqK.red(conf.prime) : $2DhqK.mont(this.p);
    // Useful for many curves
    this.zero = new $2DhqK(0).toRed(this.red);
    this.one = new $2DhqK(1).toRed(this.red);
    this.two = new $2DhqK(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $2DhqK(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $fed39195ba64a5cf$var$BaseCurve;
$fed39195ba64a5cf$var$BaseCurve.prototype.point = function point() {
    throw new Error('Not implemented');
};
$fed39195ba64a5cf$var$BaseCurve.prototype.validate = function validate() {
    throw new Error('Not implemented');
};
$fed39195ba64a5cf$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $fed39195ba64a5cf$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $fed39195ba64a5cf$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$fed39195ba64a5cf$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $fed39195ba64a5cf$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $fed39195ba64a5cf$var$assert(z !== 0);
        if (p.type === 'affine') {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === 'affine' ? acc.toP() : acc;
};
$fed39195ba64a5cf$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $fed39195ba64a5cf$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $fed39195ba64a5cf$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $fed39195ba64a5cf$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === 'affine') acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $fed39195ba64a5cf$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$fed39195ba64a5cf$var$BaseCurve.BasePoint = $fed39195ba64a5cf$var$BasePoint;
$fed39195ba64a5cf$var$BasePoint.prototype.eq = function eq() {
    throw new Error('Not implemented');
};
$fed39195ba64a5cf$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$fed39195ba64a5cf$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $adpkR.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $fed39195ba64a5cf$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $fed39195ba64a5cf$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error('Unknown point format');
};
$fed39195ba64a5cf$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$fed39195ba64a5cf$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray('be', len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray('be', len));
};
$fed39195ba64a5cf$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $adpkR.encode(this._encode(compact), enc);
};
$fed39195ba64a5cf$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$fed39195ba64a5cf$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$fed39195ba64a5cf$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$fed39195ba64a5cf$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$fed39195ba64a5cf$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$fed39195ba64a5cf$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("dqXxw", function(module, exports) {
'use strict';

var $adpkR = parcelRequire("adpkR");

var $2DhqK = parcelRequire("2DhqK");

var $lpcNn = parcelRequire("lpcNn");

var $lSqYL = parcelRequire("lSqYL");
var $9c7be366fd8b45ed$var$assert = $adpkR.assert;
function $9c7be366fd8b45ed$var$ShortCurve(conf) {
    $lSqYL.call(this, 'short', conf);
    this.a = new $2DhqK(conf.a, 16).toRed(this.red);
    this.b = new $2DhqK(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$lpcNn($9c7be366fd8b45ed$var$ShortCurve, $lSqYL);
module.exports = $9c7be366fd8b45ed$var$ShortCurve;
$9c7be366fd8b45ed$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $2DhqK(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $2DhqK(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $9c7be366fd8b45ed$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $2DhqK(vec.a, 16),
            b: new $2DhqK(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$9c7be366fd8b45ed$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $2DhqK.mont(num);
    var tinv = new $2DhqK(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $2DhqK(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$9c7be366fd8b45ed$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $2DhqK(1);
    var y1 = new $2DhqK(0);
    var x2 = new $2DhqK(0);
    var y2 = new $2DhqK(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$9c7be366fd8b45ed$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$9c7be366fd8b45ed$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $2DhqK(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$9c7be366fd8b45ed$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$9c7be366fd8b45ed$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $9c7be366fd8b45ed$var$Point(curve, x, y, isRed) {
    $lSqYL.BasePoint.call(this, curve, 'affine');
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $2DhqK(x, 16);
        this.y = new $2DhqK(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$lpcNn($9c7be366fd8b45ed$var$Point, $lSqYL.BasePoint);
$9c7be366fd8b45ed$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $9c7be366fd8b45ed$var$Point(this, x, y, isRed);
};
$9c7be366fd8b45ed$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $9c7be366fd8b45ed$var$Point.fromJSON(this, obj, red);
};
$9c7be366fd8b45ed$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$9c7be366fd8b45ed$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$9c7be366fd8b45ed$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === 'string') obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$9c7be366fd8b45ed$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};
$9c7be366fd8b45ed$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$9c7be366fd8b45ed$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$9c7be366fd8b45ed$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$9c7be366fd8b45ed$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$9c7be366fd8b45ed$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$9c7be366fd8b45ed$var$Point.prototype.mul = function mul(k) {
    k = new $2DhqK(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$9c7be366fd8b45ed$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$9c7be366fd8b45ed$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$9c7be366fd8b45ed$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$9c7be366fd8b45ed$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$9c7be366fd8b45ed$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $9c7be366fd8b45ed$var$JPoint(curve, x, y, z) {
    $lSqYL.BasePoint.call(this, curve, 'jacobian');
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $2DhqK(0);
    } else {
        this.x = new $2DhqK(x, 16);
        this.y = new $2DhqK(y, 16);
        this.z = new $2DhqK(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$lpcNn($9c7be366fd8b45ed$var$JPoint, $lSqYL.BasePoint);
$9c7be366fd8b45ed$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $9c7be366fd8b45ed$var$JPoint(this, x, y, z);
};
$9c7be366fd8b45ed$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$9c7be366fd8b45ed$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$9c7be366fd8b45ed$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$9c7be366fd8b45ed$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$9c7be366fd8b45ed$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$9c7be366fd8b45ed$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$9c7be366fd8b45ed$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$9c7be366fd8b45ed$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$9c7be366fd8b45ed$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$9c7be366fd8b45ed$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$9c7be366fd8b45ed$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $2DhqK(k, kbase);
    return this.curve._wnafMul(this, k);
};
$9c7be366fd8b45ed$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === 'affine') return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$9c7be366fd8b45ed$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$9c7be366fd8b45ed$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC JPoint Infinity>';
    return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
};
$9c7be366fd8b45ed$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("lNS7a", function(module, exports) {
'use strict';

var $2DhqK = parcelRequire("2DhqK");

var $lpcNn = parcelRequire("lpcNn");

var $lSqYL = parcelRequire("lSqYL");

var $adpkR = parcelRequire("adpkR");
function $fdf826a291c15931$var$MontCurve(conf) {
    $lSqYL.call(this, 'mont', conf);
    this.a = new $2DhqK(conf.a, 16).toRed(this.red);
    this.b = new $2DhqK(conf.b, 16).toRed(this.red);
    this.i4 = new $2DhqK(4).toRed(this.red).redInvm();
    this.two = new $2DhqK(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$lpcNn($fdf826a291c15931$var$MontCurve, $lSqYL);
module.exports = $fdf826a291c15931$var$MontCurve;
$fdf826a291c15931$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $fdf826a291c15931$var$Point(curve, x, z) {
    $lSqYL.BasePoint.call(this, curve, 'projective');
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $2DhqK(x, 16);
        this.z = new $2DhqK(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$lpcNn($fdf826a291c15931$var$Point, $lSqYL.BasePoint);
$fdf826a291c15931$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($adpkR.toArray(bytes, enc), 1);
};
$fdf826a291c15931$var$MontCurve.prototype.point = function point(x, z) {
    return new $fdf826a291c15931$var$Point(this, x, z);
};
$fdf826a291c15931$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $fdf826a291c15931$var$Point.fromJSON(this, obj);
};
$fdf826a291c15931$var$Point.prototype.precompute = function precompute() {
// No-op
};
$fdf826a291c15931$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray('be', this.curve.p.byteLength());
};
$fdf826a291c15931$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $fdf826a291c15931$var$Point(curve, obj[0], obj[1] || curve.one);
};
$fdf826a291c15931$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$fdf826a291c15931$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$fdf826a291c15931$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$fdf826a291c15931$var$Point.prototype.add = function add() {
    throw new Error('Not supported on Montgomery curve');
};
$fdf826a291c15931$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$fdf826a291c15931$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$fdf826a291c15931$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$fdf826a291c15931$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$fdf826a291c15931$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$fdf826a291c15931$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$fdf826a291c15931$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("iyIfL", function(module, exports) {
'use strict';

var $adpkR = parcelRequire("adpkR");

var $2DhqK = parcelRequire("2DhqK");

var $lpcNn = parcelRequire("lpcNn");

var $lSqYL = parcelRequire("lSqYL");
var $d82dbabfdabf9acb$var$assert = $adpkR.assert;
function $d82dbabfdabf9acb$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $lSqYL.call(this, 'edwards', conf);
    this.a = new $2DhqK(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $2DhqK(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $2DhqK(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $d82dbabfdabf9acb$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$lpcNn($d82dbabfdabf9acb$var$EdwardsCurve, $lSqYL);
module.exports = $d82dbabfdabf9acb$var$EdwardsCurve;
$d82dbabfdabf9acb$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$d82dbabfdabf9acb$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$d82dbabfdabf9acb$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$d82dbabfdabf9acb$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $2DhqK(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$d82dbabfdabf9acb$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $2DhqK(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error('invalid point');
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error('invalid point');
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$d82dbabfdabf9acb$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $d82dbabfdabf9acb$var$Point(curve, x, y, z, t) {
    $lSqYL.BasePoint.call(this, curve, 'projective');
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $2DhqK(x, 16);
        this.y = new $2DhqK(y, 16);
        this.z = z ? new $2DhqK(z, 16) : this.curve.one;
        this.t = t && new $2DhqK(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$lpcNn($d82dbabfdabf9acb$var$Point, $lSqYL.BasePoint);
$d82dbabfdabf9acb$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $d82dbabfdabf9acb$var$Point.fromJSON(this, obj);
};
$d82dbabfdabf9acb$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $d82dbabfdabf9acb$var$Point(this, x, y, z, t);
};
$d82dbabfdabf9acb$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $d82dbabfdabf9acb$var$Point(curve, obj[0], obj[1], obj[2]);
};
$d82dbabfdabf9acb$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$d82dbabfdabf9acb$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$d82dbabfdabf9acb$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$d82dbabfdabf9acb$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$d82dbabfdabf9acb$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$d82dbabfdabf9acb$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$d82dbabfdabf9acb$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$d82dbabfdabf9acb$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$d82dbabfdabf9acb$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$d82dbabfdabf9acb$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$d82dbabfdabf9acb$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$d82dbabfdabf9acb$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$d82dbabfdabf9acb$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$d82dbabfdabf9acb$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$d82dbabfdabf9acb$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$d82dbabfdabf9acb$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$d82dbabfdabf9acb$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$d82dbabfdabf9acb$var$Point.prototype.toP = $d82dbabfdabf9acb$var$Point.prototype.normalize;
$d82dbabfdabf9acb$var$Point.prototype.mixedAdd = $d82dbabfdabf9acb$var$Point.prototype.add;

});


parcelRegister("dc9yW", function(module, exports) {
'use strict';
var $027aa464509ff0b8$var$curves = module.exports;

var $ge2JM = parcelRequire("ge2JM");

var $jZNQh = parcelRequire("jZNQh");

var $adpkR = parcelRequire("adpkR");
var $027aa464509ff0b8$var$assert = $adpkR.assert;
function $027aa464509ff0b8$var$PresetCurve(options) {
    if (options.type === 'short') this.curve = new $jZNQh.short(options);
    else if (options.type === 'edwards') this.curve = new $jZNQh.edwards(options);
    else this.curve = new $jZNQh.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $027aa464509ff0b8$var$assert(this.g.validate(), 'Invalid curve');
    $027aa464509ff0b8$var$assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
$027aa464509ff0b8$var$curves.PresetCurve = $027aa464509ff0b8$var$PresetCurve;
function $027aa464509ff0b8$var$defineCurve(name, options) {
    Object.defineProperty($027aa464509ff0b8$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $027aa464509ff0b8$var$PresetCurve(options);
            Object.defineProperty($027aa464509ff0b8$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$027aa464509ff0b8$var$defineCurve('p192', {
    type: 'short',
    prime: 'p192',
    p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
    b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
    n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
    hash: $ge2JM.sha256,
    gRed: false,
    g: [
        '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
        '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
    ]
});
$027aa464509ff0b8$var$defineCurve('p224', {
    type: 'short',
    prime: 'p224',
    p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
    b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
    n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
    hash: $ge2JM.sha256,
    gRed: false,
    g: [
        'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
        'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
    ]
});
$027aa464509ff0b8$var$defineCurve('p256', {
    type: 'short',
    prime: null,
    p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
    a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
    b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
    n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
    hash: $ge2JM.sha256,
    gRed: false,
    g: [
        '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
        '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
    ]
});
$027aa464509ff0b8$var$defineCurve('p384', {
    type: 'short',
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $ge2JM.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$027aa464509ff0b8$var$defineCurve('p521', {
    type: 'short',
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $ge2JM.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$027aa464509ff0b8$var$defineCurve('curve25519', {
    type: 'mont',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '76d06',
    b: '1',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $ge2JM.sha256,
    gRed: false,
    g: [
        '9'
    ]
});
$027aa464509ff0b8$var$defineCurve('ed25519', {
    type: 'edwards',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '-1',
    c: '1',
    // -121665 * (121666^(-1)) (mod P)
    d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $ge2JM.sha256,
    gRed: false,
    g: [
        '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
        // 4/5
        '6666666666666666666666666666666666666666666666666666666666666658'
    ]
});
var $027aa464509ff0b8$var$pre;

try {
    $027aa464509ff0b8$var$pre = (parcelRequire("lf5Ev"));
} catch (e) {
    $027aa464509ff0b8$var$pre = undefined;
}
$027aa464509ff0b8$var$defineCurve('secp256k1', {
    type: 'short',
    prime: 'k256',
    p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
    a: '0',
    b: '7',
    n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
    h: '1',
    hash: $ge2JM.sha256,
    // Precomputed endomorphism
    beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
    lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
    basis: [
        {
            a: '3086d221a7d46bcde86c90e49284eb15',
            b: '-e4437ed6010e88286f547fa90abfe4c3'
        },
        {
            a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
            b: '3086d221a7d46bcde86c90e49284eb15'
        }
    ],
    gRed: false,
    g: [
        '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
        '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
        $027aa464509ff0b8$var$pre
    ]
});

});
parcelRegister("ge2JM", function(module, exports) {
var $bd0013b730754267$var$hash = module.exports;

$bd0013b730754267$var$hash.utils = (parcelRequire("kI0hI"));

$bd0013b730754267$var$hash.common = (parcelRequire("jItOG"));

$bd0013b730754267$var$hash.sha = (parcelRequire("7NoMR"));

$bd0013b730754267$var$hash.ripemd = (parcelRequire("dBa6q"));

$bd0013b730754267$var$hash.hmac = (parcelRequire("bgWqu"));
// Proxy hash functions to the main object
$bd0013b730754267$var$hash.sha1 = $bd0013b730754267$var$hash.sha.sha1;
$bd0013b730754267$var$hash.sha256 = $bd0013b730754267$var$hash.sha.sha256;
$bd0013b730754267$var$hash.sha224 = $bd0013b730754267$var$hash.sha.sha224;
$bd0013b730754267$var$hash.sha384 = $bd0013b730754267$var$hash.sha.sha384;
$bd0013b730754267$var$hash.sha512 = $bd0013b730754267$var$hash.sha.sha512;
$bd0013b730754267$var$hash.ripemd160 = $bd0013b730754267$var$hash.ripemd.ripemd160;

});
parcelRegister("kI0hI", function(module, exports) {
$parcel$export(module.exports, "inherits", () => $f138234050ce5547$export$69f1b2dcda23c5f8, (v) => $f138234050ce5547$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "toArray", () => $f138234050ce5547$export$45b10814cc054894, (v) => $f138234050ce5547$export$45b10814cc054894 = v);
$parcel$export(module.exports, "toHex", () => $f138234050ce5547$export$7ea66e3774a60b67, (v) => $f138234050ce5547$export$7ea66e3774a60b67 = v);
$parcel$export(module.exports, "htonl", () => $f138234050ce5547$export$34a52f00f601f6f1, (v) => $f138234050ce5547$export$34a52f00f601f6f1 = v);
$parcel$export(module.exports, "toHex32", () => $f138234050ce5547$export$812b0cbd5e8a72ab, (v) => $f138234050ce5547$export$812b0cbd5e8a72ab = v);
$parcel$export(module.exports, "zero2", () => $f138234050ce5547$export$f24f9e11d63bb314, (v) => $f138234050ce5547$export$f24f9e11d63bb314 = v);
$parcel$export(module.exports, "zero8", () => $f138234050ce5547$export$b71357c7e07ca1f1, (v) => $f138234050ce5547$export$b71357c7e07ca1f1 = v);
$parcel$export(module.exports, "join32", () => $f138234050ce5547$export$2e58a4b541fdcbe8, (v) => $f138234050ce5547$export$2e58a4b541fdcbe8 = v);
$parcel$export(module.exports, "split32", () => $f138234050ce5547$export$183b950bde9faab8, (v) => $f138234050ce5547$export$183b950bde9faab8 = v);
$parcel$export(module.exports, "rotr32", () => $f138234050ce5547$export$4785c77169fea59e, (v) => $f138234050ce5547$export$4785c77169fea59e = v);
$parcel$export(module.exports, "rotl32", () => $f138234050ce5547$export$242a185dfcffac5b, (v) => $f138234050ce5547$export$242a185dfcffac5b = v);
$parcel$export(module.exports, "sum32", () => $f138234050ce5547$export$58c04ae0ae31877d, (v) => $f138234050ce5547$export$58c04ae0ae31877d = v);
$parcel$export(module.exports, "sum32_3", () => $f138234050ce5547$export$d058ca695f8c6f11, (v) => $f138234050ce5547$export$d058ca695f8c6f11 = v);
$parcel$export(module.exports, "sum32_4", () => $f138234050ce5547$export$a1efd7fc3e986367, (v) => $f138234050ce5547$export$a1efd7fc3e986367 = v);
$parcel$export(module.exports, "sum32_5", () => $f138234050ce5547$export$bbfea4a2b5abaab4, (v) => $f138234050ce5547$export$bbfea4a2b5abaab4 = v);
$parcel$export(module.exports, "sum64", () => $f138234050ce5547$export$97ad4afc7de86152, (v) => $f138234050ce5547$export$97ad4afc7de86152 = v);
$parcel$export(module.exports, "sum64_hi", () => $f138234050ce5547$export$ce4673d9a79f6a4b, (v) => $f138234050ce5547$export$ce4673d9a79f6a4b = v);
$parcel$export(module.exports, "sum64_lo", () => $f138234050ce5547$export$786cc99fc6eedc0b, (v) => $f138234050ce5547$export$786cc99fc6eedc0b = v);
$parcel$export(module.exports, "sum64_4_hi", () => $f138234050ce5547$export$45c59b9a1848dd0, (v) => $f138234050ce5547$export$45c59b9a1848dd0 = v);
$parcel$export(module.exports, "sum64_4_lo", () => $f138234050ce5547$export$50d8f613e76d3034, (v) => $f138234050ce5547$export$50d8f613e76d3034 = v);
$parcel$export(module.exports, "sum64_5_hi", () => $f138234050ce5547$export$b8e83683c60ee162, (v) => $f138234050ce5547$export$b8e83683c60ee162 = v);
$parcel$export(module.exports, "sum64_5_lo", () => $f138234050ce5547$export$aeeb51790d1bcc4a, (v) => $f138234050ce5547$export$aeeb51790d1bcc4a = v);
$parcel$export(module.exports, "rotr64_hi", () => $f138234050ce5547$export$bb7c616f719ad9c, (v) => $f138234050ce5547$export$bb7c616f719ad9c = v);
$parcel$export(module.exports, "rotr64_lo", () => $f138234050ce5547$export$4d63290824f9d7df, (v) => $f138234050ce5547$export$4d63290824f9d7df = v);
$parcel$export(module.exports, "shr64_hi", () => $f138234050ce5547$export$2f64ceb90ef28ea1, (v) => $f138234050ce5547$export$2f64ceb90ef28ea1 = v);
$parcel$export(module.exports, "shr64_lo", () => $f138234050ce5547$export$8d2089d465f6d10d, (v) => $f138234050ce5547$export$8d2089d465f6d10d = v);
var $f138234050ce5547$export$69f1b2dcda23c5f8;
var $f138234050ce5547$export$45b10814cc054894;
var $f138234050ce5547$export$7ea66e3774a60b67;
var $f138234050ce5547$export$34a52f00f601f6f1;
var $f138234050ce5547$export$812b0cbd5e8a72ab;
var $f138234050ce5547$export$f24f9e11d63bb314;
var $f138234050ce5547$export$b71357c7e07ca1f1;
var $f138234050ce5547$export$2e58a4b541fdcbe8;
var $f138234050ce5547$export$183b950bde9faab8;
var $f138234050ce5547$export$4785c77169fea59e;
var $f138234050ce5547$export$242a185dfcffac5b;
var $f138234050ce5547$export$58c04ae0ae31877d;
var $f138234050ce5547$export$d058ca695f8c6f11;
var $f138234050ce5547$export$a1efd7fc3e986367;
var $f138234050ce5547$export$bbfea4a2b5abaab4;
var $f138234050ce5547$export$97ad4afc7de86152;
var $f138234050ce5547$export$ce4673d9a79f6a4b;
var $f138234050ce5547$export$786cc99fc6eedc0b;
var $f138234050ce5547$export$45c59b9a1848dd0;
var $f138234050ce5547$export$50d8f613e76d3034;
var $f138234050ce5547$export$b8e83683c60ee162;
var $f138234050ce5547$export$aeeb51790d1bcc4a;
var $f138234050ce5547$export$bb7c616f719ad9c;
var $f138234050ce5547$export$4d63290824f9d7df;
var $f138234050ce5547$export$2f64ceb90ef28ea1;
var $f138234050ce5547$export$8d2089d465f6d10d;
'use strict';

var $fvn5w = parcelRequire("fvn5w");

var $lpcNn = parcelRequire("lpcNn");
$f138234050ce5547$export$69f1b2dcda23c5f8 = $lpcNn;
function $f138234050ce5547$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === 'string') {
        if (!enc) for(var i = 0; i < msg.length; i++){
            var c = msg.charCodeAt(i);
            var hi = c >> 8;
            var lo = c & 0xff;
            if (hi) res.push(hi, lo);
            else res.push(lo);
        }
        else if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0) msg = '0' + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$f138234050ce5547$export$45b10814cc054894 = $f138234050ce5547$var$toArray;
function $f138234050ce5547$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $f138234050ce5547$var$zero2(msg[i].toString(16));
    return res;
}
$f138234050ce5547$export$7ea66e3774a60b67 = $f138234050ce5547$var$toHex;
function $f138234050ce5547$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$f138234050ce5547$export$34a52f00f601f6f1 = $f138234050ce5547$var$htonl;
function $f138234050ce5547$var$toHex32(msg, endian) {
    var res = '';
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === 'little') w = $f138234050ce5547$var$htonl(w);
        res += $f138234050ce5547$var$zero8(w.toString(16));
    }
    return res;
}
$f138234050ce5547$export$812b0cbd5e8a72ab = $f138234050ce5547$var$toHex32;
function $f138234050ce5547$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$f138234050ce5547$export$f24f9e11d63bb314 = $f138234050ce5547$var$zero2;
function $f138234050ce5547$var$zero8(word) {
    if (word.length === 7) return '0' + word;
    else if (word.length === 6) return '00' + word;
    else if (word.length === 5) return '000' + word;
    else if (word.length === 4) return '0000' + word;
    else if (word.length === 3) return '00000' + word;
    else if (word.length === 2) return '000000' + word;
    else if (word.length === 1) return '0000000' + word;
    else return word;
}
$f138234050ce5547$export$b71357c7e07ca1f1 = $f138234050ce5547$var$zero8;
function $f138234050ce5547$var$join32(msg, start, end, endian) {
    var len = end - start;
    $fvn5w(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$f138234050ce5547$export$2e58a4b541fdcbe8 = $f138234050ce5547$var$join32;
function $f138234050ce5547$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === 'big') {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$f138234050ce5547$export$183b950bde9faab8 = $f138234050ce5547$var$split32;
function $f138234050ce5547$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$f138234050ce5547$export$4785c77169fea59e = $f138234050ce5547$var$rotr32;
function $f138234050ce5547$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$f138234050ce5547$export$242a185dfcffac5b = $f138234050ce5547$var$rotl32;
function $f138234050ce5547$var$sum32(a, b) {
    return a + b >>> 0;
}
$f138234050ce5547$export$58c04ae0ae31877d = $f138234050ce5547$var$sum32;
function $f138234050ce5547$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$f138234050ce5547$export$d058ca695f8c6f11 = $f138234050ce5547$var$sum32_3;
function $f138234050ce5547$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$f138234050ce5547$export$a1efd7fc3e986367 = $f138234050ce5547$var$sum32_4;
function $f138234050ce5547$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$f138234050ce5547$export$bbfea4a2b5abaab4 = $f138234050ce5547$var$sum32_5;
function $f138234050ce5547$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$f138234050ce5547$export$97ad4afc7de86152 = $f138234050ce5547$var$sum64;
function $f138234050ce5547$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$f138234050ce5547$export$ce4673d9a79f6a4b = $f138234050ce5547$var$sum64_hi;
function $f138234050ce5547$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$f138234050ce5547$export$786cc99fc6eedc0b = $f138234050ce5547$var$sum64_lo;
function $f138234050ce5547$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$f138234050ce5547$export$45c59b9a1848dd0 = $f138234050ce5547$var$sum64_4_hi;
function $f138234050ce5547$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$f138234050ce5547$export$50d8f613e76d3034 = $f138234050ce5547$var$sum64_4_lo;
function $f138234050ce5547$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$f138234050ce5547$export$b8e83683c60ee162 = $f138234050ce5547$var$sum64_5_hi;
function $f138234050ce5547$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$f138234050ce5547$export$aeeb51790d1bcc4a = $f138234050ce5547$var$sum64_5_lo;
function $f138234050ce5547$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$f138234050ce5547$export$bb7c616f719ad9c = $f138234050ce5547$var$rotr64_hi;
function $f138234050ce5547$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$f138234050ce5547$export$4d63290824f9d7df = $f138234050ce5547$var$rotr64_lo;
function $f138234050ce5547$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$f138234050ce5547$export$2f64ceb90ef28ea1 = $f138234050ce5547$var$shr64_hi;
function $f138234050ce5547$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$f138234050ce5547$export$8d2089d465f6d10d = $f138234050ce5547$var$shr64_lo;

});

parcelRegister("jItOG", function(module, exports) {
$parcel$export(module.exports, "BlockHash", () => $e5a941497347c42d$export$8687658379b577e6, (v) => $e5a941497347c42d$export$8687658379b577e6 = v);
var $e5a941497347c42d$export$8687658379b577e6;
'use strict';

var $kI0hI = parcelRequire("kI0hI");

var $fvn5w = parcelRequire("fvn5w");
function $e5a941497347c42d$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = 'big';
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$e5a941497347c42d$export$8687658379b577e6 = $e5a941497347c42d$var$BlockHash;
$e5a941497347c42d$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $kI0hI.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $kI0hI.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$e5a941497347c42d$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $fvn5w(this.pending === null);
    return this._digest(enc);
};
$e5a941497347c42d$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === 'big') {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("7NoMR", function(module, exports) {
$parcel$export(module.exports, "sha1", () => $5ad0563a5e5bd52b$export$5091bdda49ba90f5, (v) => $5ad0563a5e5bd52b$export$5091bdda49ba90f5 = v);
$parcel$export(module.exports, "sha224", () => $5ad0563a5e5bd52b$export$97b70509d4e397ea, (v) => $5ad0563a5e5bd52b$export$97b70509d4e397ea = v);
$parcel$export(module.exports, "sha256", () => $5ad0563a5e5bd52b$export$bced8d2aada2d1c9, (v) => $5ad0563a5e5bd52b$export$bced8d2aada2d1c9 = v);
$parcel$export(module.exports, "sha384", () => $5ad0563a5e5bd52b$export$612d47d55dedde45, (v) => $5ad0563a5e5bd52b$export$612d47d55dedde45 = v);
$parcel$export(module.exports, "sha512", () => $5ad0563a5e5bd52b$export$a888d2532e6dc7bb, (v) => $5ad0563a5e5bd52b$export$a888d2532e6dc7bb = v);
var $5ad0563a5e5bd52b$export$5091bdda49ba90f5;
var $5ad0563a5e5bd52b$export$97b70509d4e397ea;
var $5ad0563a5e5bd52b$export$bced8d2aada2d1c9;
var $5ad0563a5e5bd52b$export$612d47d55dedde45;
var $5ad0563a5e5bd52b$export$a888d2532e6dc7bb;
'use strict';

$5ad0563a5e5bd52b$export$5091bdda49ba90f5 = (parcelRequire("8K2jK"));

$5ad0563a5e5bd52b$export$97b70509d4e397ea = (parcelRequire("cOufm"));

$5ad0563a5e5bd52b$export$bced8d2aada2d1c9 = (parcelRequire("7rUho"));

$5ad0563a5e5bd52b$export$612d47d55dedde45 = (parcelRequire("8hRnG"));

$5ad0563a5e5bd52b$export$a888d2532e6dc7bb = (parcelRequire("d48d2"));

});
parcelRegister("8K2jK", function(module, exports) {
'use strict';

var $kI0hI = parcelRequire("kI0hI");

var $jItOG = parcelRequire("jItOG");

var $d3QOG = parcelRequire("d3QOG");
var $65d46ad7da76ac5f$var$rotl32 = $kI0hI.rotl32;
var $65d46ad7da76ac5f$var$sum32 = $kI0hI.sum32;
var $65d46ad7da76ac5f$var$sum32_5 = $kI0hI.sum32_5;
var $65d46ad7da76ac5f$var$ft_1 = $d3QOG.ft_1;
var $65d46ad7da76ac5f$var$BlockHash = $jItOG.BlockHash;
var $65d46ad7da76ac5f$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $65d46ad7da76ac5f$var$SHA1() {
    if (!(this instanceof $65d46ad7da76ac5f$var$SHA1)) return new $65d46ad7da76ac5f$var$SHA1();
    $65d46ad7da76ac5f$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$kI0hI.inherits($65d46ad7da76ac5f$var$SHA1, $65d46ad7da76ac5f$var$BlockHash);
module.exports = $65d46ad7da76ac5f$var$SHA1;
$65d46ad7da76ac5f$var$SHA1.blockSize = 512;
$65d46ad7da76ac5f$var$SHA1.outSize = 160;
$65d46ad7da76ac5f$var$SHA1.hmacStrength = 80;
$65d46ad7da76ac5f$var$SHA1.padLength = 64;
$65d46ad7da76ac5f$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $65d46ad7da76ac5f$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $65d46ad7da76ac5f$var$sum32_5($65d46ad7da76ac5f$var$rotl32(a, 5), $65d46ad7da76ac5f$var$ft_1(s, b, c, d), e, W[i], $65d46ad7da76ac5f$var$sha1_K[s]);
        e = d;
        d = c;
        c = $65d46ad7da76ac5f$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $65d46ad7da76ac5f$var$sum32(this.h[0], a);
    this.h[1] = $65d46ad7da76ac5f$var$sum32(this.h[1], b);
    this.h[2] = $65d46ad7da76ac5f$var$sum32(this.h[2], c);
    this.h[3] = $65d46ad7da76ac5f$var$sum32(this.h[3], d);
    this.h[4] = $65d46ad7da76ac5f$var$sum32(this.h[4], e);
};
$65d46ad7da76ac5f$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $kI0hI.toHex32(this.h, 'big');
    else return $kI0hI.split32(this.h, 'big');
};

});
parcelRegister("d3QOG", function(module, exports) {
$parcel$export(module.exports, "ft_1", () => $9824866f6da513fd$export$5a92649d7ddb9f63, (v) => $9824866f6da513fd$export$5a92649d7ddb9f63 = v);
$parcel$export(module.exports, "ch32", () => $9824866f6da513fd$export$c6d0d020c3a6269, (v) => $9824866f6da513fd$export$c6d0d020c3a6269 = v);
$parcel$export(module.exports, "maj32", () => $9824866f6da513fd$export$eb90c27fca05f956, (v) => $9824866f6da513fd$export$eb90c27fca05f956 = v);
$parcel$export(module.exports, "s0_256", () => $9824866f6da513fd$export$14a4a98e063b1999, (v) => $9824866f6da513fd$export$14a4a98e063b1999 = v);
$parcel$export(module.exports, "s1_256", () => $9824866f6da513fd$export$d20cecfa1564c686, (v) => $9824866f6da513fd$export$d20cecfa1564c686 = v);
$parcel$export(module.exports, "g0_256", () => $9824866f6da513fd$export$44fd472a12fc6db, (v) => $9824866f6da513fd$export$44fd472a12fc6db = v);
$parcel$export(module.exports, "g1_256", () => $9824866f6da513fd$export$1ed238bb6ea1dd47, (v) => $9824866f6da513fd$export$1ed238bb6ea1dd47 = v);
var $9824866f6da513fd$export$5a92649d7ddb9f63;
var $9824866f6da513fd$export$c6d0d020c3a6269;
var $9824866f6da513fd$export$eb90c27fca05f956;
var $9824866f6da513fd$export$cc992891a14496a1;
var $9824866f6da513fd$export$14a4a98e063b1999;
var $9824866f6da513fd$export$d20cecfa1564c686;
var $9824866f6da513fd$export$44fd472a12fc6db;
var $9824866f6da513fd$export$1ed238bb6ea1dd47;
'use strict';

var $kI0hI = parcelRequire("kI0hI");
var $9824866f6da513fd$var$rotr32 = $kI0hI.rotr32;
function $9824866f6da513fd$var$ft_1(s, x, y, z) {
    if (s === 0) return $9824866f6da513fd$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $9824866f6da513fd$var$p32(x, y, z);
    if (s === 2) return $9824866f6da513fd$var$maj32(x, y, z);
}
$9824866f6da513fd$export$5a92649d7ddb9f63 = $9824866f6da513fd$var$ft_1;
function $9824866f6da513fd$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$9824866f6da513fd$export$c6d0d020c3a6269 = $9824866f6da513fd$var$ch32;
function $9824866f6da513fd$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$9824866f6da513fd$export$eb90c27fca05f956 = $9824866f6da513fd$var$maj32;
function $9824866f6da513fd$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$9824866f6da513fd$export$cc992891a14496a1 = $9824866f6da513fd$var$p32;
function $9824866f6da513fd$var$s0_256(x) {
    return $9824866f6da513fd$var$rotr32(x, 2) ^ $9824866f6da513fd$var$rotr32(x, 13) ^ $9824866f6da513fd$var$rotr32(x, 22);
}
$9824866f6da513fd$export$14a4a98e063b1999 = $9824866f6da513fd$var$s0_256;
function $9824866f6da513fd$var$s1_256(x) {
    return $9824866f6da513fd$var$rotr32(x, 6) ^ $9824866f6da513fd$var$rotr32(x, 11) ^ $9824866f6da513fd$var$rotr32(x, 25);
}
$9824866f6da513fd$export$d20cecfa1564c686 = $9824866f6da513fd$var$s1_256;
function $9824866f6da513fd$var$g0_256(x) {
    return $9824866f6da513fd$var$rotr32(x, 7) ^ $9824866f6da513fd$var$rotr32(x, 18) ^ x >>> 3;
}
$9824866f6da513fd$export$44fd472a12fc6db = $9824866f6da513fd$var$g0_256;
function $9824866f6da513fd$var$g1_256(x) {
    return $9824866f6da513fd$var$rotr32(x, 17) ^ $9824866f6da513fd$var$rotr32(x, 19) ^ x >>> 10;
}
$9824866f6da513fd$export$1ed238bb6ea1dd47 = $9824866f6da513fd$var$g1_256;

});


parcelRegister("cOufm", function(module, exports) {
'use strict';

var $kI0hI = parcelRequire("kI0hI");

var $7rUho = parcelRequire("7rUho");
function $95419de83e247735$var$SHA224() {
    if (!(this instanceof $95419de83e247735$var$SHA224)) return new $95419de83e247735$var$SHA224();
    $7rUho.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$kI0hI.inherits($95419de83e247735$var$SHA224, $7rUho);
module.exports = $95419de83e247735$var$SHA224;
$95419de83e247735$var$SHA224.blockSize = 512;
$95419de83e247735$var$SHA224.outSize = 224;
$95419de83e247735$var$SHA224.hmacStrength = 192;
$95419de83e247735$var$SHA224.padLength = 64;
$95419de83e247735$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === 'hex') return $kI0hI.toHex32(this.h.slice(0, 7), 'big');
    else return $kI0hI.split32(this.h.slice(0, 7), 'big');
};

});
parcelRegister("7rUho", function(module, exports) {
'use strict';

var $kI0hI = parcelRequire("kI0hI");

var $jItOG = parcelRequire("jItOG");

var $d3QOG = parcelRequire("d3QOG");

var $fvn5w = parcelRequire("fvn5w");
var $56c6b5f0e8035dce$var$sum32 = $kI0hI.sum32;
var $56c6b5f0e8035dce$var$sum32_4 = $kI0hI.sum32_4;
var $56c6b5f0e8035dce$var$sum32_5 = $kI0hI.sum32_5;
var $56c6b5f0e8035dce$var$ch32 = $d3QOG.ch32;
var $56c6b5f0e8035dce$var$maj32 = $d3QOG.maj32;
var $56c6b5f0e8035dce$var$s0_256 = $d3QOG.s0_256;
var $56c6b5f0e8035dce$var$s1_256 = $d3QOG.s1_256;
var $56c6b5f0e8035dce$var$g0_256 = $d3QOG.g0_256;
var $56c6b5f0e8035dce$var$g1_256 = $d3QOG.g1_256;
var $56c6b5f0e8035dce$var$BlockHash = $jItOG.BlockHash;
var $56c6b5f0e8035dce$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $56c6b5f0e8035dce$var$SHA256() {
    if (!(this instanceof $56c6b5f0e8035dce$var$SHA256)) return new $56c6b5f0e8035dce$var$SHA256();
    $56c6b5f0e8035dce$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $56c6b5f0e8035dce$var$sha256_K;
    this.W = new Array(64);
}
$kI0hI.inherits($56c6b5f0e8035dce$var$SHA256, $56c6b5f0e8035dce$var$BlockHash);
module.exports = $56c6b5f0e8035dce$var$SHA256;
$56c6b5f0e8035dce$var$SHA256.blockSize = 512;
$56c6b5f0e8035dce$var$SHA256.outSize = 256;
$56c6b5f0e8035dce$var$SHA256.hmacStrength = 192;
$56c6b5f0e8035dce$var$SHA256.padLength = 64;
$56c6b5f0e8035dce$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $56c6b5f0e8035dce$var$sum32_4($56c6b5f0e8035dce$var$g1_256(W[i - 2]), W[i - 7], $56c6b5f0e8035dce$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $fvn5w(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $56c6b5f0e8035dce$var$sum32_5(h, $56c6b5f0e8035dce$var$s1_256(e), $56c6b5f0e8035dce$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $56c6b5f0e8035dce$var$sum32($56c6b5f0e8035dce$var$s0_256(a), $56c6b5f0e8035dce$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $56c6b5f0e8035dce$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $56c6b5f0e8035dce$var$sum32(T1, T2);
    }
    this.h[0] = $56c6b5f0e8035dce$var$sum32(this.h[0], a);
    this.h[1] = $56c6b5f0e8035dce$var$sum32(this.h[1], b);
    this.h[2] = $56c6b5f0e8035dce$var$sum32(this.h[2], c);
    this.h[3] = $56c6b5f0e8035dce$var$sum32(this.h[3], d);
    this.h[4] = $56c6b5f0e8035dce$var$sum32(this.h[4], e);
    this.h[5] = $56c6b5f0e8035dce$var$sum32(this.h[5], f);
    this.h[6] = $56c6b5f0e8035dce$var$sum32(this.h[6], g);
    this.h[7] = $56c6b5f0e8035dce$var$sum32(this.h[7], h);
};
$56c6b5f0e8035dce$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $kI0hI.toHex32(this.h, 'big');
    else return $kI0hI.split32(this.h, 'big');
};

});


parcelRegister("8hRnG", function(module, exports) {
'use strict';

var $kI0hI = parcelRequire("kI0hI");

var $d48d2 = parcelRequire("d48d2");
function $6089519c9c4d386d$var$SHA384() {
    if (!(this instanceof $6089519c9c4d386d$var$SHA384)) return new $6089519c9c4d386d$var$SHA384();
    $d48d2.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$kI0hI.inherits($6089519c9c4d386d$var$SHA384, $d48d2);
module.exports = $6089519c9c4d386d$var$SHA384;
$6089519c9c4d386d$var$SHA384.blockSize = 1024;
$6089519c9c4d386d$var$SHA384.outSize = 384;
$6089519c9c4d386d$var$SHA384.hmacStrength = 192;
$6089519c9c4d386d$var$SHA384.padLength = 128;
$6089519c9c4d386d$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $kI0hI.toHex32(this.h.slice(0, 12), 'big');
    else return $kI0hI.split32(this.h.slice(0, 12), 'big');
};

});
parcelRegister("d48d2", function(module, exports) {
'use strict';

var $kI0hI = parcelRequire("kI0hI");

var $jItOG = parcelRequire("jItOG");

var $fvn5w = parcelRequire("fvn5w");
var $9832044388241bc6$var$rotr64_hi = $kI0hI.rotr64_hi;
var $9832044388241bc6$var$rotr64_lo = $kI0hI.rotr64_lo;
var $9832044388241bc6$var$shr64_hi = $kI0hI.shr64_hi;
var $9832044388241bc6$var$shr64_lo = $kI0hI.shr64_lo;
var $9832044388241bc6$var$sum64 = $kI0hI.sum64;
var $9832044388241bc6$var$sum64_hi = $kI0hI.sum64_hi;
var $9832044388241bc6$var$sum64_lo = $kI0hI.sum64_lo;
var $9832044388241bc6$var$sum64_4_hi = $kI0hI.sum64_4_hi;
var $9832044388241bc6$var$sum64_4_lo = $kI0hI.sum64_4_lo;
var $9832044388241bc6$var$sum64_5_hi = $kI0hI.sum64_5_hi;
var $9832044388241bc6$var$sum64_5_lo = $kI0hI.sum64_5_lo;
var $9832044388241bc6$var$BlockHash = $jItOG.BlockHash;
var $9832044388241bc6$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $9832044388241bc6$var$SHA512() {
    if (!(this instanceof $9832044388241bc6$var$SHA512)) return new $9832044388241bc6$var$SHA512();
    $9832044388241bc6$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $9832044388241bc6$var$sha512_K;
    this.W = new Array(160);
}
$kI0hI.inherits($9832044388241bc6$var$SHA512, $9832044388241bc6$var$BlockHash);
module.exports = $9832044388241bc6$var$SHA512;
$9832044388241bc6$var$SHA512.blockSize = 1024;
$9832044388241bc6$var$SHA512.outSize = 512;
$9832044388241bc6$var$SHA512.hmacStrength = 192;
$9832044388241bc6$var$SHA512.padLength = 128;
$9832044388241bc6$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $9832044388241bc6$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $9832044388241bc6$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $9832044388241bc6$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $9832044388241bc6$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $9832044388241bc6$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $9832044388241bc6$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$9832044388241bc6$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $fvn5w(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $9832044388241bc6$var$s1_512_hi(eh, el);
        var c1_lo = $9832044388241bc6$var$s1_512_lo(eh, el);
        var c2_hi = $9832044388241bc6$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $9832044388241bc6$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $9832044388241bc6$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $9832044388241bc6$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $9832044388241bc6$var$s0_512_hi(ah, al);
        c0_lo = $9832044388241bc6$var$s0_512_lo(ah, al);
        c1_hi = $9832044388241bc6$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $9832044388241bc6$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $9832044388241bc6$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $9832044388241bc6$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $9832044388241bc6$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $9832044388241bc6$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $9832044388241bc6$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $9832044388241bc6$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $9832044388241bc6$var$sum64(this.h, 0, ah, al);
    $9832044388241bc6$var$sum64(this.h, 2, bh, bl);
    $9832044388241bc6$var$sum64(this.h, 4, ch, cl);
    $9832044388241bc6$var$sum64(this.h, 6, dh, dl);
    $9832044388241bc6$var$sum64(this.h, 8, eh, el);
    $9832044388241bc6$var$sum64(this.h, 10, fh, fl);
    $9832044388241bc6$var$sum64(this.h, 12, gh, gl);
    $9832044388241bc6$var$sum64(this.h, 14, hh, hl);
};
$9832044388241bc6$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $kI0hI.toHex32(this.h, 'big');
    else return $kI0hI.split32(this.h, 'big');
};
function $9832044388241bc6$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9832044388241bc6$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9832044388241bc6$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9832044388241bc6$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9832044388241bc6$var$s0_512_hi(xh, xl) {
    var c0_hi = $9832044388241bc6$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $9832044388241bc6$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $9832044388241bc6$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9832044388241bc6$var$s0_512_lo(xh, xl) {
    var c0_lo = $9832044388241bc6$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $9832044388241bc6$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $9832044388241bc6$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9832044388241bc6$var$s1_512_hi(xh, xl) {
    var c0_hi = $9832044388241bc6$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $9832044388241bc6$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $9832044388241bc6$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9832044388241bc6$var$s1_512_lo(xh, xl) {
    var c0_lo = $9832044388241bc6$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $9832044388241bc6$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $9832044388241bc6$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9832044388241bc6$var$g0_512_hi(xh, xl) {
    var c0_hi = $9832044388241bc6$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $9832044388241bc6$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $9832044388241bc6$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9832044388241bc6$var$g0_512_lo(xh, xl) {
    var c0_lo = $9832044388241bc6$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $9832044388241bc6$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $9832044388241bc6$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9832044388241bc6$var$g1_512_hi(xh, xl) {
    var c0_hi = $9832044388241bc6$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $9832044388241bc6$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $9832044388241bc6$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9832044388241bc6$var$g1_512_lo(xh, xl) {
    var c0_lo = $9832044388241bc6$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $9832044388241bc6$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $9832044388241bc6$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("dBa6q", function(module, exports) {
$parcel$export(module.exports, "ripemd160", () => $9e66913e3d3ef246$export$d1cea0ee4e3f0d3e, (v) => $9e66913e3d3ef246$export$d1cea0ee4e3f0d3e = v);
var $9e66913e3d3ef246$export$d1cea0ee4e3f0d3e;
'use strict';

var $kI0hI = parcelRequire("kI0hI");

var $jItOG = parcelRequire("jItOG");
var $9e66913e3d3ef246$var$rotl32 = $kI0hI.rotl32;
var $9e66913e3d3ef246$var$sum32 = $kI0hI.sum32;
var $9e66913e3d3ef246$var$sum32_3 = $kI0hI.sum32_3;
var $9e66913e3d3ef246$var$sum32_4 = $kI0hI.sum32_4;
var $9e66913e3d3ef246$var$BlockHash = $jItOG.BlockHash;
function $9e66913e3d3ef246$var$RIPEMD160() {
    if (!(this instanceof $9e66913e3d3ef246$var$RIPEMD160)) return new $9e66913e3d3ef246$var$RIPEMD160();
    $9e66913e3d3ef246$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = 'little';
}
$kI0hI.inherits($9e66913e3d3ef246$var$RIPEMD160, $9e66913e3d3ef246$var$BlockHash);
$9e66913e3d3ef246$export$d1cea0ee4e3f0d3e = $9e66913e3d3ef246$var$RIPEMD160;
$9e66913e3d3ef246$var$RIPEMD160.blockSize = 512;
$9e66913e3d3ef246$var$RIPEMD160.outSize = 160;
$9e66913e3d3ef246$var$RIPEMD160.hmacStrength = 192;
$9e66913e3d3ef246$var$RIPEMD160.padLength = 64;
$9e66913e3d3ef246$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $9e66913e3d3ef246$var$sum32($9e66913e3d3ef246$var$rotl32($9e66913e3d3ef246$var$sum32_4(A, $9e66913e3d3ef246$var$f(j, B, C, D), msg[$9e66913e3d3ef246$var$r[j] + start], $9e66913e3d3ef246$var$K(j)), $9e66913e3d3ef246$var$s[j]), E);
        A = E;
        E = D;
        D = $9e66913e3d3ef246$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $9e66913e3d3ef246$var$sum32($9e66913e3d3ef246$var$rotl32($9e66913e3d3ef246$var$sum32_4(Ah, $9e66913e3d3ef246$var$f(79 - j, Bh, Ch, Dh), msg[$9e66913e3d3ef246$var$rh[j] + start], $9e66913e3d3ef246$var$Kh(j)), $9e66913e3d3ef246$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $9e66913e3d3ef246$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $9e66913e3d3ef246$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $9e66913e3d3ef246$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $9e66913e3d3ef246$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $9e66913e3d3ef246$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $9e66913e3d3ef246$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$9e66913e3d3ef246$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $kI0hI.toHex32(this.h, 'little');
    else return $kI0hI.split32(this.h, 'little');
};
function $9e66913e3d3ef246$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $9e66913e3d3ef246$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $9e66913e3d3ef246$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $9e66913e3d3ef246$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $9e66913e3d3ef246$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $9e66913e3d3ef246$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $9e66913e3d3ef246$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("bgWqu", function(module, exports) {
'use strict';

var $kI0hI = parcelRequire("kI0hI");

var $fvn5w = parcelRequire("fvn5w");
function $021e2b656e199d3d$var$Hmac(hash, key, enc) {
    if (!(this instanceof $021e2b656e199d3d$var$Hmac)) return new $021e2b656e199d3d$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($kI0hI.toArray(key, enc));
}
module.exports = $021e2b656e199d3d$var$Hmac;
$021e2b656e199d3d$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $fvn5w(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$021e2b656e199d3d$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$021e2b656e199d3d$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("lf5Ev", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
                'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
            ],
            [
                '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
                '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
            ],
            [
                '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
                'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
            ],
            [
                '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
                '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
            ],
            [
                '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
                '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
            ],
            [
                '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
                '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
            ],
            [
                'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
                '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
            ],
            [
                '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
                'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
            ],
            [
                'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
                '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
            ],
            [
                'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
                'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
            ],
            [
                'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
                '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
            ],
            [
                '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
                '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
            ],
            [
                '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
                '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
            ],
            [
                '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
                '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
            ],
            [
                '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
                '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
            ],
            [
                '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
                '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
            ],
            [
                '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
                '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
            ],
            [
                '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
                '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
            ],
            [
                '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
                'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
            ],
            [
                'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
                '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
            ],
            [
                'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
                '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
            ],
            [
                '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
                '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
            ],
            [
                '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
                '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
            ],
            [
                'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
                '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
            ],
            [
                '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
                'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
            ],
            [
                'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
                '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
            ],
            [
                'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
                'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
            ],
            [
                'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
                '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
            ],
            [
                'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
                'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
            ],
            [
                'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
                '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
            ],
            [
                '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
                'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
            ],
            [
                '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
                '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
            ],
            [
                'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
                '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
            ],
            [
                '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
                'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
            ],
            [
                'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
                '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
            ],
            [
                'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
                '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
            ],
            [
                'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
                'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
            ],
            [
                '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
                '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
            ],
            [
                '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
                '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
            ],
            [
                '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
                'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
            ],
            [
                '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
                '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
            ],
            [
                'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
                '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
            ],
            [
                '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
                '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
            ],
            [
                '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
                'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
            ],
            [
                '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
                '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
            ],
            [
                'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
                '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
            ],
            [
                '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
                'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
            ],
            [
                'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
                'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
            ],
            [
                'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
                '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
            ],
            [
                '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
                'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
            ],
            [
                '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
                'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
            ],
            [
                'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
                '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
            ],
            [
                'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
                '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
            ],
            [
                'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
                '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
            ],
            [
                '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
                'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
            ],
            [
                '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
                '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
            ],
            [
                'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
                'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
            ],
            [
                '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
                'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
            ],
            [
                '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
                '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
            ],
            [
                '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
                '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
            ],
            [
                'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
                'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
            ],
            [
                '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
                '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
            ],
            [
                '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
                '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
            ],
            [
                'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
                '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
            ],
            [
                'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
                'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
                '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
            ],
            [
                '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
                'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
            ],
            [
                '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
                '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
            ],
            [
                'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
                'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
            ],
            [
                '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
                'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
            ],
            [
                'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
                'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
            ],
            [
                'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
                '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
            ],
            [
                'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
                '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
            ],
            [
                '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
                '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
            ],
            [
                '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
                '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
            ],
            [
                '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
                '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
            ],
            [
                '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
                '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
            ],
            [
                'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
                'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
            ],
            [
                'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
                '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
            ],
            [
                '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
                'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
            ],
            [
                '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
                'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
            ],
            [
                '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
                '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
            ],
            [
                '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
                '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
            ],
            [
                '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
                '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
            ],
            [
                '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
                'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
            ],
            [
                'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
                'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
            ],
            [
                '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
                '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
            ],
            [
                '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
                '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
            ],
            [
                'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
                'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
            ],
            [
                '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
                '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
            ],
            [
                'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
                'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
            ],
            [
                'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
                'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
            ],
            [
                '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
                '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
            ],
            [
                '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
                '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
            ],
            [
                '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
                '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
            ],
            [
                'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
                '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
            ],
            [
                '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
                '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
            ],
            [
                'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
                '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
            ],
            [
                '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
                'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
            ],
            [
                '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
                'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
            ],
            [
                'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
                'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
            ],
            [
                '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
                '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
            ],
            [
                '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
                'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
            ],
            [
                'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
                'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
            ],
            [
                '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
                '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
            ],
            [
                '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
                'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
            ],
            [
                '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
                '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
            ],
            [
                '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
                'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
            ],
            [
                'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
                '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
            ],
            [
                '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
                '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
            ],
            [
                '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
                'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
            ],
            [
                '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
                'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
            ],
            [
                'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
                'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
            ],
            [
                'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
                'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
            ],
            [
                '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
                '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
            ],
            [
                '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
                '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
            ],
            [
                'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
                '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
            ],
            [
                'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
                'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
            ],
            [
                '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
                '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
            ],
            [
                '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
                '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
            ],
            [
                'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
                '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
            ],
            [
                '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
                '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
            ],
            [
                'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
                'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
            ],
            [
                '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
                'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
            ],
            [
                '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
                '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
            ],
            [
                'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
                '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
            ],
            [
                'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
                '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
            ],
            [
                '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
                '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
            ],
            [
                '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
                '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
            ],
            [
                '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
                'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
            ],
            [
                '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
                'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
            ],
            [
                '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
                '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
            ],
            [
                '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
                '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
            ],
            [
                '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
                '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
            ],
            [
                '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
                'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
            ],
            [
                'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
                'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
            ],
            [
                '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
                'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
            ],
            [
                'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
                '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
            ],
            [
                'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
                '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
            ],
            [
                'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
                '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
            ],
            [
                'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
                '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
            ],
            [
                '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
                'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
            ],
            [
                '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
                '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
            ],
            [
                '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
                'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
            ],
            [
                'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
                'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
            ],
            [
                'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
                '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
            ],
            [
                'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
                'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
            ],
            [
                'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
                '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
            ],
            [
                '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
                '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
            ],
            [
                'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
                '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
            ],
            [
                'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
                '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
            ],
            [
                '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
                '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
            ],
            [
                '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
                'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
            ],
            [
                'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
                '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
            ],
            [
                'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
                '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
            ],
            [
                'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
                '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
            ],
            [
                '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
                '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
            ],
            [
                'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
                'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
            ],
            [
                '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
                'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
            ],
            [
                'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
                'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
            ],
            [
                'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
                '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
            ],
            [
                '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
                'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
            ],
            [
                'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
                '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
            ],
            [
                'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
                '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
            ],
            [
                'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
                '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
            ],
            [
                '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
                'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
            ],
            [
                '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
                'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
            ],
            [
                'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
                '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
            ],
            [
                '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
                'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
            ],
            [
                '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
                '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
            ],
            [
                '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
                'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
            ],
            [
                'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
                'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
            ],
            [
                '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
                'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
            ],
            [
                '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
                '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
            ],
            [
                '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
                'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
            ],
            [
                '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
                '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
            ],
            [
                'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
                'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
            ],
            [
                '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
                '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
            ],
            [
                'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
                '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
            ],
            [
                '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
                '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
            ],
            [
                'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
                'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
            ],
            [
                'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
                '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
            ],
            [
                'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
                'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
            ],
            [
                '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
                'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
            ],
            [
                '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
                '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
            ],
            [
                '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
                'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
            ],
            [
                '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
                '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
            ],
            [
                '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
                '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
            ],
            [
                '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
                'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
            ],
            [
                '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
                '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
            ],
            [
                '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
                '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
            ],
            [
                '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
                '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
            ]
        ]
    }
};

});


parcelRegister("2gaKR", function(module, exports) {
'use strict';

var $2DhqK = parcelRequire("2DhqK");

var $avgQL = parcelRequire("avgQL");

var $adpkR = parcelRequire("adpkR");

var $dc9yW = parcelRequire("dc9yW");

var $6WjTK = parcelRequire("6WjTK");
var $1a556b18d782c5ab$var$assert = $adpkR.assert;

var $7W3Is = parcelRequire("7W3Is");

var $N9Rr3 = parcelRequire("N9Rr3");
function $1a556b18d782c5ab$var$EC(options) {
    if (!(this instanceof $1a556b18d782c5ab$var$EC)) return new $1a556b18d782c5ab$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === 'string') {
        $1a556b18d782c5ab$var$assert(Object.prototype.hasOwnProperty.call($dc9yW, options), 'Unknown curve ' + options);
        options = $dc9yW[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $dc9yW.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $1a556b18d782c5ab$var$EC;
$1a556b18d782c5ab$var$EC.prototype.keyPair = function keyPair(options) {
    return new $7W3Is(this, options);
};
$1a556b18d782c5ab$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $7W3Is.fromPrivate(this, priv, enc);
};
$1a556b18d782c5ab$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $7W3Is.fromPublic(this, pub, enc);
};
$1a556b18d782c5ab$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $avgQL({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8',
        entropy: options.entropy || $6WjTK(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || 'utf8',
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $2DhqK(2));
    for(;;){
        var priv = new $2DhqK(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$1a556b18d782c5ab$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly, bitLength) {
    var byteLength;
    if ($2DhqK.isBN(msg) || typeof msg === 'number') {
        msg = new $2DhqK(msg, 16);
        byteLength = msg.byteLength();
    } else if (typeof msg === 'object') {
        // BN assumes an array-like input and asserts length
        byteLength = msg.length;
        msg = new $2DhqK(msg, 16);
    } else {
        // BN converts the value to string
        var str = msg.toString();
        // HEX encoding
        byteLength = str.length + 1 >>> 1;
        msg = new $2DhqK(str, 16);
    }
    // Allow overriding
    if (typeof bitLength !== 'number') bitLength = byteLength * 8;
    var delta = bitLength - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$1a556b18d782c5ab$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === 'object') {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    if (typeof msg !== 'string' && typeof msg !== 'number' && !$2DhqK.isBN(msg)) {
        $1a556b18d782c5ab$var$assert(typeof msg === 'object' && msg && typeof msg.length === 'number', 'Expected message to be an array-like, a hex string, or a BN instance');
        $1a556b18d782c5ab$var$assert(msg.length >>> 0 === msg.length); // non-negative 32-bit integer
        for(var i = 0; i < msg.length; i++)$1a556b18d782c5ab$var$assert((msg[i] & 255) === msg[i]);
    }
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(msg, false, options.msgBitLength);
    // Would fail further checks, but let's make the error message clear
    $1a556b18d782c5ab$var$assert(!msg.isNeg(), 'Can not sign a negative message');
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray('be', bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray('be', bytes);
    // Recheck nonce to be bijective to msg
    $1a556b18d782c5ab$var$assert(new $2DhqK(nonce).eq(msg), 'Can not sign message');
    // Instantiate Hmac_DRBG
    var drbg = new $avgQL({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8'
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $2DhqK(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $2DhqK(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $N9Rr3({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$1a556b18d782c5ab$var$EC.prototype.verify = function verify(msg, signature, key, enc, options) {
    if (!options) options = {};
    msg = this._truncateToN(msg, false, options.msgBitLength);
    key = this.keyFromPublic(key, enc);
    signature = new $N9Rr3(signature, 'hex');
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$1a556b18d782c5ab$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $1a556b18d782c5ab$var$assert((3 & j) === j, 'The recovery param is more than two bits');
    signature = new $N9Rr3(signature, enc);
    var n = this.n;
    var e = new $2DhqK(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$1a556b18d782c5ab$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $N9Rr3(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error('Unable to find valid recovery factor');
};

});
parcelRegister("avgQL", function(module, exports) {
'use strict';

var $ge2JM = parcelRequire("ge2JM");

var $fZjlU = parcelRequire("fZjlU");

var $fvn5w = parcelRequire("fvn5w");
function $7a59deb648a5f399$var$HmacDRBG(options) {
    if (!(this instanceof $7a59deb648a5f399$var$HmacDRBG)) return new $7a59deb648a5f399$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $fZjlU.toArray(options.entropy, options.entropyEnc || 'hex');
    var nonce = $fZjlU.toArray(options.nonce, options.nonceEnc || 'hex');
    var pers = $fZjlU.toArray(options.pers, options.persEnc || 'hex');
    $fvn5w(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._init(entropy, nonce, pers);
}
module.exports = $7a59deb648a5f399$var$HmacDRBG;
$7a59deb648a5f399$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$7a59deb648a5f399$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $ge2JM.hmac(this.hash, this.K);
};
$7a59deb648a5f399$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$7a59deb648a5f399$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== 'string') {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $fZjlU.toArray(entropy, entropyEnc);
    add = $fZjlU.toArray(add, addEnc);
    $fvn5w(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$7a59deb648a5f399$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');
    // Optional encoding
    if (typeof enc !== 'string') {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $fZjlU.toArray(add, addEnc || 'hex');
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $fZjlU.encode(res, enc);
};

});

parcelRegister("7W3Is", function(module, exports) {
'use strict';

var $2DhqK = parcelRequire("2DhqK");

var $adpkR = parcelRequire("adpkR");
var $5c70d51e4fdb4ff9$var$assert = $adpkR.assert;
function $5c70d51e4fdb4ff9$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $5c70d51e4fdb4ff9$var$KeyPair;
$5c70d51e4fdb4ff9$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $5c70d51e4fdb4ff9$var$KeyPair) return pub;
    return new $5c70d51e4fdb4ff9$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$5c70d51e4fdb4ff9$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $5c70d51e4fdb4ff9$var$KeyPair) return priv;
    return new $5c70d51e4fdb4ff9$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$5c70d51e4fdb4ff9$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: 'Invalid public key'
    };
    if (!pub.validate()) return {
        result: false,
        reason: 'Public key is not a point'
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: 'Public key * N != O'
    };
    return {
        result: true,
        reason: null
    };
};
$5c70d51e4fdb4ff9$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === 'string') {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$5c70d51e4fdb4ff9$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === 'hex') return this.priv.toString(16, 2);
    else return this.priv;
};
$5c70d51e4fdb4ff9$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $2DhqK(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$5c70d51e4fdb4ff9$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === 'mont') $5c70d51e4fdb4ff9$var$assert(key.x, 'Need x coordinate');
        else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') $5c70d51e4fdb4ff9$var$assert(key.x && key.y, 'Need both x and y coordinate');
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$5c70d51e4fdb4ff9$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $5c70d51e4fdb4ff9$var$assert(pub.validate(), 'public point not validated');
    return pub.mul(this.priv).getX();
};
// ECDSA
$5c70d51e4fdb4ff9$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$5c70d51e4fdb4ff9$var$KeyPair.prototype.verify = function verify(msg, signature, options) {
    return this.ec.verify(msg, signature, this, undefined, options);
};
$5c70d51e4fdb4ff9$var$KeyPair.prototype.inspect = function inspect() {
    return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

});

parcelRegister("N9Rr3", function(module, exports) {
'use strict';

var $2DhqK = parcelRequire("2DhqK");

var $adpkR = parcelRequire("adpkR");
var $093c39e11fdc0cef$var$assert = $adpkR.assert;
function $093c39e11fdc0cef$var$Signature(options, enc) {
    if (options instanceof $093c39e11fdc0cef$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $093c39e11fdc0cef$var$assert(options.r && options.s, 'Signature without r or s');
    this.r = new $2DhqK(options.r, 16);
    this.s = new $2DhqK(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $093c39e11fdc0cef$var$Signature;
function $093c39e11fdc0cef$var$Position() {
    this.place = 0;
}
function $093c39e11fdc0cef$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    if (buf[p.place] === 0x00) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $093c39e11fdc0cef$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$093c39e11fdc0cef$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $adpkR.toArray(data, enc);
    var p = new $093c39e11fdc0cef$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $093c39e11fdc0cef$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $093c39e11fdc0cef$var$getLength(data, p);
    if (rlen === false) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $093c39e11fdc0cef$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $2DhqK(r);
    this.s = new $2DhqK(s);
    this.recoveryParam = null;
    return true;
};
function $093c39e11fdc0cef$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$093c39e11fdc0cef$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $093c39e11fdc0cef$var$rmPadding(r);
    s = $093c39e11fdc0cef$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $093c39e11fdc0cef$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $093c39e11fdc0cef$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $093c39e11fdc0cef$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $adpkR.encode(res, enc);
};

});


parcelRegister("lcOlN", function(module, exports) {
'use strict';

var $ge2JM = parcelRequire("ge2JM");

var $dc9yW = parcelRequire("dc9yW");

var $adpkR = parcelRequire("adpkR");
var $f701c68eaaa1d2e7$var$assert = $adpkR.assert;
var $f701c68eaaa1d2e7$var$parseBytes = $adpkR.parseBytes;

var $iSuHd = parcelRequire("iSuHd");

var $dNIDP = parcelRequire("dNIDP");
function $f701c68eaaa1d2e7$var$EDDSA(curve) {
    $f701c68eaaa1d2e7$var$assert(curve === 'ed25519', 'only tested with ed25519 so far');
    if (!(this instanceof $f701c68eaaa1d2e7$var$EDDSA)) return new $f701c68eaaa1d2e7$var$EDDSA(curve);
    curve = $dc9yW[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $ge2JM.sha512;
}
module.exports = $f701c68eaaa1d2e7$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $f701c68eaaa1d2e7$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $f701c68eaaa1d2e7$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $f701c68eaaa1d2e7$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $f701c68eaaa1d2e7$var$parseBytes(message);
    sig = this.makeSignature(sig);
    if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) return false;
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$f701c68eaaa1d2e7$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $adpkR.intFromLE(hash.digest()).umod(this.curve.n);
};
$f701c68eaaa1d2e7$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $iSuHd.fromPublic(this, pub);
};
$f701c68eaaa1d2e7$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $iSuHd.fromSecret(this, secret);
};
$f701c68eaaa1d2e7$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $dNIDP) return sig;
    return new $dNIDP(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $f701c68eaaa1d2e7$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray('le', this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$f701c68eaaa1d2e7$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $adpkR.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $adpkR.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$f701c68eaaa1d2e7$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray('le', this.encodingLength);
};
$f701c68eaaa1d2e7$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $adpkR.intFromLE(bytes);
};
$f701c68eaaa1d2e7$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("iSuHd", function(module, exports) {
'use strict';

var $adpkR = parcelRequire("adpkR");
var $dbe514babaddcb81$var$assert = $adpkR.assert;
var $dbe514babaddcb81$var$parseBytes = $adpkR.parseBytes;
var $dbe514babaddcb81$var$cachedProperty = $adpkR.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $dbe514babaddcb81$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $dbe514babaddcb81$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $dbe514babaddcb81$var$parseBytes(params.pub);
}
$dbe514babaddcb81$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $dbe514babaddcb81$var$KeyPair) return pub;
    return new $dbe514babaddcb81$var$KeyPair(eddsa, {
        pub: pub
    });
};
$dbe514babaddcb81$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $dbe514babaddcb81$var$KeyPair) return secret;
    return new $dbe514babaddcb81$var$KeyPair(eddsa, {
        secret: secret
    });
};
$dbe514babaddcb81$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$dbe514babaddcb81$var$cachedProperty($dbe514babaddcb81$var$KeyPair, 'pubBytes', function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$dbe514babaddcb81$var$cachedProperty($dbe514babaddcb81$var$KeyPair, 'pub', function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$dbe514babaddcb81$var$cachedProperty($dbe514babaddcb81$var$KeyPair, 'privBytes', function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$dbe514babaddcb81$var$cachedProperty($dbe514babaddcb81$var$KeyPair, 'priv', function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$dbe514babaddcb81$var$cachedProperty($dbe514babaddcb81$var$KeyPair, 'hash', function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$dbe514babaddcb81$var$cachedProperty($dbe514babaddcb81$var$KeyPair, 'messagePrefix', function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$dbe514babaddcb81$var$KeyPair.prototype.sign = function sign(message) {
    $dbe514babaddcb81$var$assert(this._secret, 'KeyPair can only verify');
    return this.eddsa.sign(message, this);
};
$dbe514babaddcb81$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$dbe514babaddcb81$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $dbe514babaddcb81$var$assert(this._secret, 'KeyPair is public only');
    return $adpkR.encode(this.secret(), enc);
};
$dbe514babaddcb81$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $adpkR.encode(this.pubBytes(), enc);
};
module.exports = $dbe514babaddcb81$var$KeyPair;

});

parcelRegister("dNIDP", function(module, exports) {
'use strict';

var $2DhqK = parcelRequire("2DhqK");

var $adpkR = parcelRequire("adpkR");
var $a0c27acd2a091cd9$var$assert = $adpkR.assert;
var $a0c27acd2a091cd9$var$cachedProperty = $adpkR.cachedProperty;
var $a0c27acd2a091cd9$var$parseBytes = $adpkR.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $a0c27acd2a091cd9$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== 'object') sig = $a0c27acd2a091cd9$var$parseBytes(sig);
    if (Array.isArray(sig)) {
        $a0c27acd2a091cd9$var$assert(sig.length === eddsa.encodingLength * 2, 'Signature has invalid size');
        sig = {
            R: sig.slice(0, eddsa.encodingLength),
            S: sig.slice(eddsa.encodingLength)
        };
    }
    $a0c27acd2a091cd9$var$assert(sig.R && sig.S, 'Signature without R or S');
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $2DhqK) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$a0c27acd2a091cd9$var$cachedProperty($a0c27acd2a091cd9$var$Signature, 'S', function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$a0c27acd2a091cd9$var$cachedProperty($a0c27acd2a091cd9$var$Signature, 'R', function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$a0c27acd2a091cd9$var$cachedProperty($a0c27acd2a091cd9$var$Signature, 'Rencoded', function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$a0c27acd2a091cd9$var$cachedProperty($a0c27acd2a091cd9$var$Signature, 'Sencoded', function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$a0c27acd2a091cd9$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$a0c27acd2a091cd9$var$Signature.prototype.toHex = function toHex() {
    return $adpkR.encode(this.toBytes(), 'hex').toUpperCase();
};
module.exports = $a0c27acd2a091cd9$var$Signature;

});



parcelRegister("3ot7a", function(module, exports) {
'use strict';

var $eZ5uz = parcelRequire("eZ5uz");

var $2jqRh = parcelRequire("2jqRh");

var $arqMV = parcelRequire("arqMV");

var $7uhwq = parcelRequire("7uhwq");

var $ljyV3 = parcelRequire("ljyV3");

var $bc1ju = parcelRequire("bc1ju");
var $278a328be25154d0$require$Buffer = $bc1ju.Buffer;
function $278a328be25154d0$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $2jqRh[data.algorithm.decrypt.cipher.algo.join('.')];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split('-')[1], 10) / 8;
    var key = $ljyV3.pbkdf2Sync(password, salt, iters, keylen, 'sha1');
    var cipher = $7uhwq.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher['final']());
    return $278a328be25154d0$require$Buffer.concat(out);
}
function $278a328be25154d0$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === 'object' && !$278a328be25154d0$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === 'string') buffer = $278a328be25154d0$require$Buffer.from(buffer);
    var stripped = $arqMV(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case 'CERTIFICATE':
            ndata = $eZ5uz.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case 'PUBLIC KEY':
            if (!ndata) ndata = $eZ5uz.PublicKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $eZ5uz.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
                case '1.2.840.10045.2.1':
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: 'ec',
                        data: ndata
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.pub_key = $eZ5uz.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
                    return {
                        type: 'dsa',
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'ENCRYPTED PRIVATE KEY':
            data = $eZ5uz.EncryptedPrivateKey.decode(data, 'der');
            data = $278a328be25154d0$var$decrypt(data, password);
        // falls through
        case 'PRIVATE KEY':
            ndata = $eZ5uz.PrivateKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $eZ5uz.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
                case '1.2.840.10045.2.1':
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $eZ5uz.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.priv_key = $eZ5uz.DSAparam.decode(ndata.subjectPrivateKey, 'der');
                    return {
                        type: 'dsa',
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'RSA PUBLIC KEY':
            return $eZ5uz.RSAPublicKey.decode(data, 'der');
        case 'RSA PRIVATE KEY':
            return $eZ5uz.RSAPrivateKey.decode(data, 'der');
        case 'DSA PRIVATE KEY':
            return {
                type: 'dsa',
                params: $eZ5uz.DSAPrivateKey.decode(data, 'der')
            };
        case 'EC PRIVATE KEY':
            data = $eZ5uz.ECPrivateKey.decode(data, 'der');
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error('unknown key type ' + type);
    }
}
$278a328be25154d0$var$parseKeys.signature = $eZ5uz.signature;
module.exports = $278a328be25154d0$var$parseKeys;

});
parcelRegister("eZ5uz", function(module, exports) {
$parcel$export(module.exports, "certificate", () => $ae8b05cad5a38d00$export$c98397a6eb8d0678, (v) => $ae8b05cad5a38d00$export$c98397a6eb8d0678 = v);
$parcel$export(module.exports, "RSAPrivateKey", () => $ae8b05cad5a38d00$export$f4aab6816f64fa6b, (v) => $ae8b05cad5a38d00$export$f4aab6816f64fa6b = v);
$parcel$export(module.exports, "RSAPublicKey", () => $ae8b05cad5a38d00$export$4471f5c65d097c11, (v) => $ae8b05cad5a38d00$export$4471f5c65d097c11 = v);
$parcel$export(module.exports, "PublicKey", () => $ae8b05cad5a38d00$export$ca8b6604d6ce14de, (v) => $ae8b05cad5a38d00$export$ca8b6604d6ce14de = v);
$parcel$export(module.exports, "PrivateKey", () => $ae8b05cad5a38d00$export$8f54525b330fd87b, (v) => $ae8b05cad5a38d00$export$8f54525b330fd87b = v);
$parcel$export(module.exports, "EncryptedPrivateKey", () => $ae8b05cad5a38d00$export$23cd2842b44ca3e7, (v) => $ae8b05cad5a38d00$export$23cd2842b44ca3e7 = v);
$parcel$export(module.exports, "DSAPrivateKey", () => $ae8b05cad5a38d00$export$245c9aaa9f5ce4ce, (v) => $ae8b05cad5a38d00$export$245c9aaa9f5ce4ce = v);
$parcel$export(module.exports, "DSAparam", () => $ae8b05cad5a38d00$export$8ad762e3e6399afe, (v) => $ae8b05cad5a38d00$export$8ad762e3e6399afe = v);
$parcel$export(module.exports, "ECPrivateKey", () => $ae8b05cad5a38d00$export$32ef6f92e22c6ab0, (v) => $ae8b05cad5a38d00$export$32ef6f92e22c6ab0 = v);
$parcel$export(module.exports, "signature", () => $ae8b05cad5a38d00$export$c9cd164b539ebb63, (v) => $ae8b05cad5a38d00$export$c9cd164b539ebb63 = v);
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $ae8b05cad5a38d00$export$c98397a6eb8d0678;
var $ae8b05cad5a38d00$export$f4aab6816f64fa6b;
var $ae8b05cad5a38d00$export$4471f5c65d097c11;
var $ae8b05cad5a38d00$export$ca8b6604d6ce14de;
var $ae8b05cad5a38d00$export$8f54525b330fd87b;
var $ae8b05cad5a38d00$export$23cd2842b44ca3e7;
var $ae8b05cad5a38d00$export$245c9aaa9f5ce4ce;
var $ae8b05cad5a38d00$export$8ad762e3e6399afe;
var $ae8b05cad5a38d00$export$32ef6f92e22c6ab0;
var $ae8b05cad5a38d00$export$c9cd164b539ebb63;
'use strict';

var $cYka3 = parcelRequire("cYka3");

$ae8b05cad5a38d00$export$c98397a6eb8d0678 = (parcelRequire("hF7AY"));
var $ae8b05cad5a38d00$var$RSAPrivateKey = $cYka3.define('RSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('modulus')['int'](), this.key('publicExponent')['int'](), this.key('privateExponent')['int'](), this.key('prime1')['int'](), this.key('prime2')['int'](), this.key('exponent1')['int'](), this.key('exponent2')['int'](), this.key('coefficient')['int']());
});
$ae8b05cad5a38d00$export$f4aab6816f64fa6b = $ae8b05cad5a38d00$var$RSAPrivateKey;
var $ae8b05cad5a38d00$var$RSAPublicKey = $cYka3.define('RSAPublicKey', function() {
    this.seq().obj(this.key('modulus')['int'](), this.key('publicExponent')['int']());
});
$ae8b05cad5a38d00$export$4471f5c65d097c11 = $ae8b05cad5a38d00$var$RSAPublicKey;
var $ae8b05cad5a38d00$var$AlgorithmIdentifier = $cYka3.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('none').null_().optional(), this.key('curve').objid().optional(), this.key('params').seq().obj(this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int']()).optional());
});
var $ae8b05cad5a38d00$var$PublicKey = $cYka3.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($ae8b05cad5a38d00$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
$ae8b05cad5a38d00$export$ca8b6604d6ce14de = $ae8b05cad5a38d00$var$PublicKey;
var $ae8b05cad5a38d00$var$PrivateKeyInfo = $cYka3.define('PrivateKeyInfo', function() {
    this.seq().obj(this.key('version')['int'](), this.key('algorithm').use($ae8b05cad5a38d00$var$AlgorithmIdentifier), this.key('subjectPrivateKey').octstr());
});
$ae8b05cad5a38d00$export$8f54525b330fd87b = $ae8b05cad5a38d00$var$PrivateKeyInfo;
var $ae8b05cad5a38d00$var$EncryptedPrivateKeyInfo = $cYka3.define('EncryptedPrivateKeyInfo', function() {
    this.seq().obj(this.key('algorithm').seq().obj(this.key('id').objid(), this.key('decrypt').seq().obj(this.key('kde').seq().obj(this.key('id').objid(), this.key('kdeparams').seq().obj(this.key('salt').octstr(), this.key('iters')['int']())), this.key('cipher').seq().obj(this.key('algo').objid(), this.key('iv').octstr()))), this.key('subjectPrivateKey').octstr());
});
$ae8b05cad5a38d00$export$23cd2842b44ca3e7 = $ae8b05cad5a38d00$var$EncryptedPrivateKeyInfo;
var $ae8b05cad5a38d00$var$DSAPrivateKey = $cYka3.define('DSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int'](), this.key('pub_key')['int'](), this.key('priv_key')['int']());
});
$ae8b05cad5a38d00$export$245c9aaa9f5ce4ce = $ae8b05cad5a38d00$var$DSAPrivateKey;
$ae8b05cad5a38d00$export$8ad762e3e6399afe = $cYka3.define('DSAparam', function() {
    this['int']();
});
var $ae8b05cad5a38d00$var$ECParameters = $cYka3.define('ECParameters', function() {
    this.choice({
        namedCurve: this.objid()
    });
});
var $ae8b05cad5a38d00$var$ECPrivateKey = $cYka3.define('ECPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('privateKey').octstr(), this.key('parameters').optional().explicit(0).use($ae8b05cad5a38d00$var$ECParameters), this.key('publicKey').optional().explicit(1).bitstr());
});
$ae8b05cad5a38d00$export$32ef6f92e22c6ab0 = $ae8b05cad5a38d00$var$ECPrivateKey;
$ae8b05cad5a38d00$export$c9cd164b539ebb63 = $cYka3.define('signature', function() {
    this.seq().obj(this.key('r')['int'](), this.key('s')['int']());
});

});
parcelRegister("cYka3", function(module, exports) {
var $971aba389bb92486$var$asn1 = module.exports;

$971aba389bb92486$var$asn1.bignum = (parcelRequire("2DhqK"));

$971aba389bb92486$var$asn1.define = (parcelRequire("3on7m")).define;

$971aba389bb92486$var$asn1.base = (parcelRequire("eLXXP"));

$971aba389bb92486$var$asn1.constants = (parcelRequire("eHw67"));

$971aba389bb92486$var$asn1.decoders = (parcelRequire("f2ZIt"));

$971aba389bb92486$var$asn1.encoders = (parcelRequire("2n5Kp"));

});
parcelRegister("3on7m", function(module, exports) {

var $cYka3 = parcelRequire("cYka3");

var $lpcNn = parcelRequire("lpcNn");
var $27858ba9e9ebdce4$var$api = module.exports;
$27858ba9e9ebdce4$var$api.define = function define(name, body) {
    return new $27858ba9e9ebdce4$var$Entity(name, body);
};
function $27858ba9e9ebdce4$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}

$27858ba9e9ebdce4$var$Entity.prototype._createNamed = function createNamed(base) {
    var named;
    try {
        named = (parcelRequire("3g2tj")).runInThisContext('(function ' + this.name + '(entity) {\n' + '  this._initNamed(entity);\n' + '})');
    } catch (e) {
        named = function(entity) {
            this._initNamed(entity);
        };
    }
    $lpcNn(named, base);
    named.prototype._initNamed = function initnamed(entity) {
        base.call(this, entity);
    };
    return new named(this);
};
$27858ba9e9ebdce4$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || 'der';
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($cYka3.decoders[enc]);
    return this.decoders[enc];
};
$27858ba9e9ebdce4$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$27858ba9e9ebdce4$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || 'der';
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($cYka3.encoders[enc]);
    return this.encoders[enc];
};
$27858ba9e9ebdce4$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("3g2tj", function(module, exports) {
var indexOf = function(xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for(var i = 0; i < xs.length; i++){
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function(obj) {
    if (Object.keys) return Object.keys(obj);
    else {
        var res = [];
        for(var key in obj)res.push(key);
        return res;
    }
};
var forEach = function(xs, fn) {
    if (xs.forEach) return xs.forEach(fn);
    else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
};
var defineProp = function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            });
        };
    } catch (e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}();
var globals = [
    'Array',
    'Boolean',
    'Date',
    'Error',
    'EvalError',
    'Function',
    'Infinity',
    'JSON',
    'Math',
    'NaN',
    'Number',
    'Object',
    'RangeError',
    'ReferenceError',
    'RegExp',
    'String',
    'SyntaxError',
    'TypeError',
    'URIError',
    'decodeURI',
    'decodeURIComponent',
    'encodeURI',
    'encodeURIComponent',
    'escape',
    'eval',
    'isFinite',
    'isNaN',
    'parseFloat',
    'parseInt',
    'undefined',
    'unescape'
];
function Context() {}
Context.prototype = {};
var Script = exports.Script = function NodeScript(code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};
Script.prototype.runInContext = function(context) {
    if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;
    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    forEach(Object_keys(context), function(key) {
        win[key] = context[key];
    });
    forEach(globals, function(key) {
        if (context[key]) win[key] = context[key];
    });
    var winKeys = Object_keys(win);
    var res = wEval.call(win, this.code);
    forEach(Object_keys(win), function(key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
    });
    forEach(globals, function(key) {
        if (!(key in context)) defineProp(context, key, win[key]);
    });
    document.body.removeChild(iframe);
    return res;
};
Script.prototype.runInThisContext = function() {
    return eval(this.code); // maybe...
};
Script.prototype.runInNewContext = function(context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);
    if (context) forEach(Object_keys(ctx), function(key) {
        context[key] = ctx[key];
    });
    return res;
};
forEach(Object_keys(Script.prototype), function(name) {
    exports[name] = Script[name] = function(code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});
exports.isContext = function(context) {
    return context instanceof Context;
};
exports.createScript = function(code) {
    return exports.Script(code);
};
exports.createContext = Script.createContext = function(context) {
    var copy = new Context();
    if (typeof context === 'object') forEach(Object_keys(context), function(key) {
        copy[key] = context[key];
    });
    return copy;
};

});


parcelRegister("eLXXP", function(module, exports) {
var $ac13f80c5474f128$var$base = module.exports;

$ac13f80c5474f128$var$base.Reporter = (parcelRequire("bCIdS")).Reporter;

$ac13f80c5474f128$var$base.DecoderBuffer = (parcelRequire("f3yiX")).DecoderBuffer;

$ac13f80c5474f128$var$base.EncoderBuffer = (parcelRequire("f3yiX")).EncoderBuffer;

$ac13f80c5474f128$var$base.Node = (parcelRequire("kujLU"));

});
parcelRegister("bCIdS", function(module, exports) {
$parcel$export(module.exports, "Reporter", () => $87658c10a229fbc2$export$957313a2f485e5ed, (v) => $87658c10a229fbc2$export$957313a2f485e5ed = v);
var $87658c10a229fbc2$export$957313a2f485e5ed;

var $lpcNn = parcelRequire("lpcNn");
function $87658c10a229fbc2$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$87658c10a229fbc2$export$957313a2f485e5ed = $87658c10a229fbc2$var$Reporter;
$87658c10a229fbc2$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $87658c10a229fbc2$var$ReporterError;
};
$87658c10a229fbc2$var$Reporter.prototype.save = function save() {
    var state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$87658c10a229fbc2$var$Reporter.prototype.restore = function restore(data) {
    var state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$87658c10a229fbc2$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$87658c10a229fbc2$var$Reporter.prototype.exitKey = function exitKey(index) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$87658c10a229fbc2$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    var state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$87658c10a229fbc2$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join('/');
};
$87658c10a229fbc2$var$Reporter.prototype.enterObject = function enterObject() {
    var state = this._reporterState;
    var prev = state.obj;
    state.obj = {};
    return prev;
};
$87658c10a229fbc2$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    var state = this._reporterState;
    var now = state.obj;
    state.obj = prev;
    return now;
};
$87658c10a229fbc2$var$Reporter.prototype.error = function error(msg) {
    var err;
    var state = this._reporterState;
    var inherited = msg instanceof $87658c10a229fbc2$var$ReporterError;
    if (inherited) err = msg;
    else err = new $87658c10a229fbc2$var$ReporterError(state.path.map(function(elem) {
        return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$87658c10a229fbc2$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    var state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $87658c10a229fbc2$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$lpcNn($87658c10a229fbc2$var$ReporterError, Error);
$87658c10a229fbc2$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + ' at: ' + (this.path || '(shallow)');
    if (Error.captureStackTrace) Error.captureStackTrace(this, $87658c10a229fbc2$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("f3yiX", function(module, exports) {
$parcel$export(module.exports, "DecoderBuffer", () => $af61bf0d561ad37e$export$bf9f79cdc4a49163, (v) => $af61bf0d561ad37e$export$bf9f79cdc4a49163 = v);
$parcel$export(module.exports, "EncoderBuffer", () => $af61bf0d561ad37e$export$8ff24f7760c7a78e, (v) => $af61bf0d561ad37e$export$8ff24f7760c7a78e = v);
var $af61bf0d561ad37e$export$bf9f79cdc4a49163;
var $af61bf0d561ad37e$export$8ff24f7760c7a78e;

var $lpcNn = parcelRequire("lpcNn");

var $eLXXP = parcelRequire("eLXXP");
var $af61bf0d561ad37e$require$Reporter = $eLXXP.Reporter;

var $5Ovjr = parcelRequire("5Ovjr");
var $af61bf0d561ad37e$require$Buffer = $5Ovjr.Buffer;
function $af61bf0d561ad37e$var$DecoderBuffer(base, options) {
    $af61bf0d561ad37e$require$Reporter.call(this, options);
    if (!$af61bf0d561ad37e$require$Buffer.isBuffer(base)) {
        this.error('Input not Buffer');
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$lpcNn($af61bf0d561ad37e$var$DecoderBuffer, $af61bf0d561ad37e$require$Reporter);
$af61bf0d561ad37e$export$bf9f79cdc4a49163 = $af61bf0d561ad37e$var$DecoderBuffer;
$af61bf0d561ad37e$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $af61bf0d561ad37e$require$Reporter.prototype.save.call(this)
    };
};
$af61bf0d561ad37e$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    var res = new $af61bf0d561ad37e$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $af61bf0d561ad37e$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$af61bf0d561ad37e$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$af61bf0d561ad37e$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || 'DecoderBuffer overrun');
};
$af61bf0d561ad37e$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || 'DecoderBuffer overrun');
    var res = new $af61bf0d561ad37e$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$af61bf0d561ad37e$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $af61bf0d561ad37e$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!(item instanceof $af61bf0d561ad37e$var$EncoderBuffer)) item = new $af61bf0d561ad37e$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === 'number') {
        if (!(0 <= value && value <= 0xff)) return reporter.error('non-byte EncoderBuffer value');
        this.value = value;
        this.length = 1;
    } else if (typeof value === 'string') {
        this.value = value;
        this.length = $af61bf0d561ad37e$require$Buffer.byteLength(value);
    } else if ($af61bf0d561ad37e$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error('Unsupported type: ' + typeof value);
}
$af61bf0d561ad37e$export$8ff24f7760c7a78e = $af61bf0d561ad37e$var$EncoderBuffer;
$af61bf0d561ad37e$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = new $af61bf0d561ad37e$require$Buffer(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === 'number') out[offset] = this.value;
        else if (typeof this.value === 'string') out.write(this.value, offset);
        else if ($af61bf0d561ad37e$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});

parcelRegister("kujLU", function(module, exports) {

var $eLXXP = parcelRequire("eLXXP");
var $eea5f243271b039d$require$Reporter = $eLXXP.Reporter;

var $eLXXP = parcelRequire("eLXXP");
var $eea5f243271b039d$require$EncoderBuffer = $eLXXP.EncoderBuffer;

var $eLXXP = parcelRequire("eLXXP");
var $eea5f243271b039d$require$DecoderBuffer = $eLXXP.DecoderBuffer;

var $fvn5w = parcelRequire("fvn5w");
// Supported tags
var $eea5f243271b039d$var$tags = [
    'seq',
    'seqof',
    'set',
    'setof',
    'objid',
    'bool',
    'gentime',
    'utctime',
    'null_',
    'enum',
    'int',
    'objDesc',
    'bitstr',
    'bmpstr',
    'charstr',
    'genstr',
    'graphstr',
    'ia5str',
    'iso646str',
    'numstr',
    'octstr',
    'printstr',
    't61str',
    'unistr',
    'utf8str',
    'videostr'
];
// Public methods list
var $eea5f243271b039d$var$methods = [
    'key',
    'obj',
    'use',
    'optional',
    'explicit',
    'implicit',
    'def',
    'choice',
    'any',
    'contains'
].concat($eea5f243271b039d$var$tags);
// Overrided methods list
var $eea5f243271b039d$var$overrided = [
    '_peekTag',
    '_decodeTag',
    '_use',
    '_decodeStr',
    '_decodeObjid',
    '_decodeTime',
    '_decodeNull',
    '_decodeInt',
    '_decodeBool',
    '_decodeList',
    '_encodeComposite',
    '_encodeStr',
    '_encodeObjid',
    '_encodeTime',
    '_encodeNull',
    '_encodeInt',
    '_encodeBool'
];
function $eea5f243271b039d$var$Node(enc, parent) {
    var state = {};
    this._baseState = state;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state['default'] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $eea5f243271b039d$var$Node;
var $eea5f243271b039d$var$stateProps = [
    'enc',
    'parent',
    'children',
    'tag',
    'args',
    'reverseArgs',
    'choice',
    'optional',
    'any',
    'obj',
    'use',
    'alteredUse',
    'key',
    'default',
    'explicit',
    'implicit',
    'contains'
];
$eea5f243271b039d$var$Node.prototype.clone = function clone() {
    var state = this._baseState;
    var cstate = {};
    $eea5f243271b039d$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$eea5f243271b039d$var$Node.prototype._wrap = function wrap() {
    var state = this._baseState;
    $eea5f243271b039d$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            var clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$eea5f243271b039d$var$Node.prototype._init = function init(body) {
    var state = this._baseState;
    $fvn5w(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $fvn5w.equal(state.children.length, 1, 'Root node can have only one child');
};
$eea5f243271b039d$var$Node.prototype._useArgs = function useArgs(args) {
    var state = this._baseState;
    // Filter children and args
    var children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $fvn5w(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $fvn5w(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== 'object' || arg.constructor !== Object) return arg;
            var res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                var value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$eea5f243271b039d$var$overrided.forEach(function(method) {
    $eea5f243271b039d$var$Node.prototype[method] = function _overrided() {
        var state = this._baseState;
        throw new Error(method + ' not implemented for encoding: ' + state.enc);
    };
});
//
// Public methods
//
$eea5f243271b039d$var$tags.forEach(function(tag) {
    $eea5f243271b039d$var$Node.prototype[tag] = function _tagMethod() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        $fvn5w(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$eea5f243271b039d$var$Node.prototype.use = function use(item) {
    $fvn5w(item);
    var state = this._baseState;
    $fvn5w(state.use === null);
    state.use = item;
    return this;
};
$eea5f243271b039d$var$Node.prototype.optional = function optional() {
    var state = this._baseState;
    state.optional = true;
    return this;
};
$eea5f243271b039d$var$Node.prototype.def = function def(val) {
    var state = this._baseState;
    $fvn5w(state['default'] === null);
    state['default'] = val;
    state.optional = true;
    return this;
};
$eea5f243271b039d$var$Node.prototype.explicit = function explicit(num) {
    var state = this._baseState;
    $fvn5w(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$eea5f243271b039d$var$Node.prototype.implicit = function implicit(num) {
    var state = this._baseState;
    $fvn5w(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$eea5f243271b039d$var$Node.prototype.obj = function obj() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$eea5f243271b039d$var$Node.prototype.key = function key(newKey) {
    var state = this._baseState;
    $fvn5w(state.key === null);
    state.key = newKey;
    return this;
};
$eea5f243271b039d$var$Node.prototype.any = function any() {
    var state = this._baseState;
    state.any = true;
    return this;
};
$eea5f243271b039d$var$Node.prototype.choice = function choice(obj) {
    var state = this._baseState;
    $fvn5w(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$eea5f243271b039d$var$Node.prototype.contains = function contains(item) {
    var state = this._baseState;
    $fvn5w(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$eea5f243271b039d$var$Node.prototype._decode = function decode(input, options) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state['default'];
    var present = true;
    var prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        var tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            var save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    var prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            var explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        var start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            if (state.any) var save = input.save();
            var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, 'tagged');
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, 'content');
        // Select proper method for tag
        if (state.any) result;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
            var data = new $eea5f243271b039d$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$eea5f243271b039d$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    var state = this._baseState;
    if (tag === 'seq' || tag === 'set') return null;
    if (tag === 'seqof' || tag === 'setof') return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === 'objid' && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === 'objid') return this._decodeObjid(input, null, null, options);
    else if (tag === 'gentime' || tag === 'utctime') return this._decodeTime(input, tag, options);
    else if (tag === 'null_') return this._decodeNull(input, options);
    else if (tag === 'bool') return this._decodeBool(input, options);
    else if (tag === 'objDesc') return this._decodeStr(input, tag, options);
    else if (tag === 'int' || tag === 'enum') return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error('unknown tag: ' + tag);
};
$eea5f243271b039d$var$Node.prototype._getUse = function _getUse(entity, obj) {
    var state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $fvn5w(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$eea5f243271b039d$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    var state = this._baseState;
    var result = null;
    var match = false;
    Object.keys(state.choice).some(function(key) {
        var save = input.save();
        var node = state.choice[key];
        try {
            var value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error('Choice not matched');
    return result;
};
//
// Encoding
//
$eea5f243271b039d$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $eea5f243271b039d$require$EncoderBuffer(data, this.reporter);
};
$eea5f243271b039d$var$Node.prototype._encode = function encode(data, reporter, parent) {
    var state = this._baseState;
    if (state['default'] !== null && state['default'] === data) return;
    var result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$eea5f243271b039d$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $eea5f243271b039d$require$Reporter());
    var result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state['default'] !== null) data = state['default'];
        else return;
    }
    // Encode children first
    var content = null;
    var primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === 'null_') return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error('Child should have a key');
            var prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== 'object') return reporter.error('Child expected, but input is not object');
            var res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === 'seqof' || state.tag === 'setof') {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error('Too many args for : ' + state.tag);
            if (!Array.isArray(data)) return reporter.error('seqof/setof, but data is not Array');
            var child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                var state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    var result;
    if (!state.any && state.choice === null) {
        var tag = state.implicit !== null ? state.implicit : state.tag;
        var cls = state.implicit === null ? 'universal' : 'context';
        if (tag === null) {
            if (state.use === null) reporter.error('Tag could be omitted only for .use()');
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, 'context', result);
    return result;
};
$eea5f243271b039d$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    var state = this._baseState;
    var node = state.choice[data.type];
    if (!node) $fvn5w(false, data.type + ' not found in ' + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$eea5f243271b039d$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === 'objid' && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === 'objid') return this._encodeObjid(data, null, null);
    else if (tag === 'gentime' || tag === 'utctime') return this._encodeTime(data, tag);
    else if (tag === 'null_') return this._encodeNull();
    else if (tag === 'int' || tag === 'enum') return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === 'bool') return this._encodeBool(data);
    else if (tag === 'objDesc') return this._encodeStr(data, tag);
    else throw new Error('Unsupported tag: ' + tag);
};
$eea5f243271b039d$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$eea5f243271b039d$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

});


parcelRegister("eHw67", function(module, exports) {
var $ab3dfac8857aa936$var$constants = module.exports;
// Helper
$ab3dfac8857aa936$var$constants._reverse = function reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
};

$ab3dfac8857aa936$var$constants.der = (parcelRequire("aSaPf"));

});
parcelRegister("aSaPf", function(module, exports) {
$parcel$export(module.exports, "tagClass", () => $7ea758400413e7b5$export$3584c46ed60baee8, (v) => $7ea758400413e7b5$export$3584c46ed60baee8 = v);
$parcel$export(module.exports, "tagClassByName", () => $7ea758400413e7b5$export$f18596ef8d632e49, (v) => $7ea758400413e7b5$export$f18596ef8d632e49 = v);
$parcel$export(module.exports, "tag", () => $7ea758400413e7b5$export$2b067c6666111485, (v) => $7ea758400413e7b5$export$2b067c6666111485 = v);
$parcel$export(module.exports, "tagByName", () => $7ea758400413e7b5$export$f17df38a421ab9e3, (v) => $7ea758400413e7b5$export$f17df38a421ab9e3 = v);
var $7ea758400413e7b5$export$3584c46ed60baee8;
var $7ea758400413e7b5$export$f18596ef8d632e49;
var $7ea758400413e7b5$export$2b067c6666111485;
var $7ea758400413e7b5$export$f17df38a421ab9e3;

var $eHw67 = parcelRequire("eHw67");
$7ea758400413e7b5$export$3584c46ed60baee8 = {
    0: 'universal',
    1: 'application',
    2: 'context',
    3: 'private'
};
$7ea758400413e7b5$export$f18596ef8d632e49 = $eHw67._reverse($7ea758400413e7b5$export$3584c46ed60baee8);
$7ea758400413e7b5$export$2b067c6666111485 = {
    0x00: 'end',
    0x01: 'bool',
    0x02: 'int',
    0x03: 'bitstr',
    0x04: 'octstr',
    0x05: 'null_',
    0x06: 'objid',
    0x07: 'objDesc',
    0x08: 'external',
    0x09: 'real',
    0x0a: 'enum',
    0x0b: 'embed',
    0x0c: 'utf8str',
    0x0d: 'relativeOid',
    0x10: 'seq',
    0x11: 'set',
    0x12: 'numstr',
    0x13: 'printstr',
    0x14: 't61str',
    0x15: 'videostr',
    0x16: 'ia5str',
    0x17: 'utctime',
    0x18: 'gentime',
    0x19: 'graphstr',
    0x1a: 'iso646str',
    0x1b: 'genstr',
    0x1c: 'unistr',
    0x1d: 'charstr',
    0x1e: 'bmpstr'
};
$7ea758400413e7b5$export$f17df38a421ab9e3 = $eHw67._reverse($7ea758400413e7b5$export$2b067c6666111485);

});


parcelRegister("f2ZIt", function(module, exports) {
var $af46ea788213e55a$var$decoders = module.exports;

$af46ea788213e55a$var$decoders.der = (parcelRequire("jT156"));

$af46ea788213e55a$var$decoders.pem = (parcelRequire("XBc5H"));

});
parcelRegister("jT156", function(module, exports) {

var $lpcNn = parcelRequire("lpcNn");

var $cYka3 = parcelRequire("cYka3");
var $e7a3fe18eaeef0d2$var$base = $cYka3.base;
var $e7a3fe18eaeef0d2$var$bignum = $cYka3.bignum;
// Import DER constants
var $e7a3fe18eaeef0d2$var$der = $cYka3.constants.der;
function $e7a3fe18eaeef0d2$var$DERDecoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $e7a3fe18eaeef0d2$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $e7a3fe18eaeef0d2$var$DERDecoder;
$e7a3fe18eaeef0d2$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!(data instanceof $e7a3fe18eaeef0d2$var$base.DecoderBuffer)) data = new $e7a3fe18eaeef0d2$var$base.DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $e7a3fe18eaeef0d2$var$DERNode(parent) {
    $e7a3fe18eaeef0d2$var$base.Node.call(this, 'der', parent);
}
$lpcNn($e7a3fe18eaeef0d2$var$DERNode, $e7a3fe18eaeef0d2$var$base.Node);
$e7a3fe18eaeef0d2$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    var state = buffer.save();
    var decodedTag = $e7a3fe18eaeef0d2$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + 'of' === tag || any;
};
$e7a3fe18eaeef0d2$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    var decodedTag = $e7a3fe18eaeef0d2$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    var len = $e7a3fe18eaeef0d2$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + 'of' !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    var state = buffer.save();
    var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$e7a3fe18eaeef0d2$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    while(true){
        var tag = $e7a3fe18eaeef0d2$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        var len = $e7a3fe18eaeef0d2$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        var res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === 'end') break;
    }
};
$e7a3fe18eaeef0d2$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    var result = [];
    while(!buffer.isEmpty()){
        var possibleEnd = this._peekTag(buffer, 'end');
        if (buffer.isError(possibleEnd)) return possibleEnd;
        var res = decoder.decode(buffer, 'der', options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$e7a3fe18eaeef0d2$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === 'bitstr') {
        var unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === 'bmpstr') {
        var raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error('Decoding of string type: bmpstr length mismatch');
        var str = '';
        for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === 'numstr') {
        var numstr = buffer.raw().toString('ascii');
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === 'octstr') return buffer.raw();
    else if (tag === 'objDesc') return buffer.raw();
    else if (tag === 'printstr') {
        var printstr = buffer.raw().toString('ascii');
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error('Decoding of string type: ' + tag + ' unsupported');
};
$e7a3fe18eaeef0d2$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    var result;
    var identifiers = [];
    var ident = 0;
    while(!buffer.isEmpty()){
        var subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    var first = identifiers[0] / 40 | 0;
    var second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        var tmp = values[result.join(' ')];
        if (tmp === undefined) tmp = values[result.join('.')];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$e7a3fe18eaeef0d2$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    var str = buffer.raw().toString();
    if (tag === 'gentime') {
        var year = str.slice(0, 4) | 0;
        var mon = str.slice(4, 6) | 0;
        var day = str.slice(6, 8) | 0;
        var hour = str.slice(8, 10) | 0;
        var min = str.slice(10, 12) | 0;
        var sec = str.slice(12, 14) | 0;
    } else if (tag === 'utctime') {
        var year = str.slice(0, 2) | 0;
        var mon = str.slice(2, 4) | 0;
        var day = str.slice(4, 6) | 0;
        var hour = str.slice(6, 8) | 0;
        var min = str.slice(8, 10) | 0;
        var sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error('Decoding ' + tag + ' time is not supported yet');
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$e7a3fe18eaeef0d2$var$DERNode.prototype._decodeNull = function decodeNull(buffer) {
    return null;
};
$e7a3fe18eaeef0d2$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    var res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$e7a3fe18eaeef0d2$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    var raw = buffer.raw();
    var res = new $e7a3fe18eaeef0d2$var$bignum(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$e7a3fe18eaeef0d2$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getDecoder('der').tree;
};
// Utility methods
function $e7a3fe18eaeef0d2$var$derDecodeTag(buf, fail) {
    var tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    var cls = $e7a3fe18eaeef0d2$var$der.tagClass[tag >> 6];
    var primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        var oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    var tagStr = $e7a3fe18eaeef0d2$var$der.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $e7a3fe18eaeef0d2$var$derDecodeLen(buf, primitive, fail) {
    var len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    var num = len & 0x7f;
    if (num > 4) return buf.error('length octect is too long');
    len = 0;
    for(var i = 0; i < num; i++){
        len <<= 8;
        var j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("XBc5H", function(module, exports) {

var $lpcNn = parcelRequire("lpcNn");

var $5Ovjr = parcelRequire("5Ovjr");
var $0b325cc272043f8b$require$Buffer = $5Ovjr.Buffer;

var $jT156 = parcelRequire("jT156");
function $0b325cc272043f8b$var$PEMDecoder(entity) {
    $jT156.call(this, entity);
    this.enc = 'pem';
}
$lpcNn($0b325cc272043f8b$var$PEMDecoder, $jT156);
module.exports = $0b325cc272043f8b$var$PEMDecoder;
$0b325cc272043f8b$var$PEMDecoder.prototype.decode = function decode(data, options) {
    var lines = data.toString().split(/[\r\n]+/g);
    var label = options.label.toUpperCase();
    var re = /^-----(BEGIN|END) ([^-]+)-----$/;
    var start = -1;
    var end = -1;
    for(var i = 0; i < lines.length; i++){
        var match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== 'BEGIN') break;
            start = i;
        } else {
            if (match[1] !== 'END') break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error('PEM section not found for: ' + label);
    var base64 = lines.slice(start + 1, end).join('');
    // Remove excessive symbols
    base64.replace(/[^a-z0-9\+\/=]+/gi, '');
    var input = new $0b325cc272043f8b$require$Buffer(base64, 'base64');
    return $jT156.prototype.decode.call(this, input, options);
};

});


parcelRegister("2n5Kp", function(module, exports) {
var $1ba2301bd63a272a$var$encoders = module.exports;

$1ba2301bd63a272a$var$encoders.der = (parcelRequire("011cL"));

$1ba2301bd63a272a$var$encoders.pem = (parcelRequire("cjLq2"));

});
parcelRegister("011cL", function(module, exports) {

var $lpcNn = parcelRequire("lpcNn");

var $5Ovjr = parcelRequire("5Ovjr");
var $00310759f1741782$require$Buffer = $5Ovjr.Buffer;

var $cYka3 = parcelRequire("cYka3");
var $00310759f1741782$var$base = $cYka3.base;
// Import DER constants
var $00310759f1741782$var$der = $cYka3.constants.der;
function $00310759f1741782$var$DEREncoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $00310759f1741782$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $00310759f1741782$var$DEREncoder;
$00310759f1741782$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $00310759f1741782$var$DERNode(parent) {
    $00310759f1741782$var$base.Node.call(this, 'der', parent);
}
$lpcNn($00310759f1741782$var$DERNode, $00310759f1741782$var$base.Node);
$00310759f1741782$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    var encodedTag = $00310759f1741782$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        var header = new $00310759f1741782$require$Buffer(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    var lenOctets = 1;
    for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    var header = new $00310759f1741782$require$Buffer(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$00310759f1741782$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === 'bitstr') return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === 'bmpstr') {
        var buf = new $00310759f1741782$require$Buffer(str.length * 2);
        for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === 'numstr') {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === 'printstr') {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === 'objDesc') return this._createEncoderBuffer(str);
    else return this.reporter.error('Encoding of string type: ' + tag + ' unsupported');
};
$00310759f1741782$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === 'string') {
        if (!values) return this.reporter.error('string objid given, but no values map found');
        if (!values.hasOwnProperty(id)) return this.reporter.error('objid not found in values map');
        id = values[id].split(/[\s\.]+/g);
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error('Second objid identifier OOB');
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    var size = 0;
    for(var i = 0; i < id.length; i++){
        var ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    var objid = new $00310759f1741782$require$Buffer(size);
    var offset = objid.length - 1;
    for(var i = id.length - 1; i >= 0; i--){
        var ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $00310759f1741782$var$two(num) {
    if (num < 10) return '0' + num;
    else return num;
}
$00310759f1741782$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    var str;
    var date = new Date(time);
    if (tag === 'gentime') str = [
        $00310759f1741782$var$two(date.getFullYear()),
        $00310759f1741782$var$two(date.getUTCMonth() + 1),
        $00310759f1741782$var$two(date.getUTCDate()),
        $00310759f1741782$var$two(date.getUTCHours()),
        $00310759f1741782$var$two(date.getUTCMinutes()),
        $00310759f1741782$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else if (tag === 'utctime') str = [
        $00310759f1741782$var$two(date.getFullYear() % 100),
        $00310759f1741782$var$two(date.getUTCMonth() + 1),
        $00310759f1741782$var$two(date.getUTCDate()),
        $00310759f1741782$var$two(date.getUTCHours()),
        $00310759f1741782$var$two(date.getUTCMinutes()),
        $00310759f1741782$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else this.reporter.error('Encoding ' + tag + ' time is not supported yet');
    return this._encodeStr(str, 'octstr');
};
$00310759f1741782$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer('');
};
$00310759f1741782$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === 'string') {
        if (!values) return this.reporter.error('String int or enum given, but no values map');
        if (!values.hasOwnProperty(num)) return this.reporter.error('Values map doesn\'t contain: ' + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== 'number' && !$00310759f1741782$require$Buffer.isBuffer(num)) {
        var numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = new $00310759f1741782$require$Buffer(numArray);
    }
    if ($00310759f1741782$require$Buffer.isBuffer(num)) {
        var size = num.length;
        if (num.length === 0) size++;
        var out = new $00310759f1741782$require$Buffer(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    var size = 1;
    for(var i = num; i >= 0x100; i >>= 8)size++;
    var out = new Array(size);
    for(var i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer(new $00310759f1741782$require$Buffer(out));
};
$00310759f1741782$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$00310759f1741782$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getEncoder('der').tree;
};
$00310759f1741782$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    var state = this._baseState;
    var i;
    if (state['default'] === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $00310759f1741782$var$encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === 'seqof') tag = 'seq';
    else if (tag === 'setof') tag = 'set';
    if ($00310759f1741782$var$der.tagByName.hasOwnProperty(tag)) res = $00310759f1741782$var$der.tagByName[tag];
    else if (typeof tag === 'number' && (tag | 0) === tag) res = tag;
    else return reporter.error('Unknown tag: ' + tag);
    if (res >= 0x1f) return reporter.error('Multi-octet tag encoding unsupported');
    if (!primitive) res |= 0x20;
    res |= $00310759f1741782$var$der.tagClassByName[cls || 'universal'] << 6;
    return res;
}

});

parcelRegister("cjLq2", function(module, exports) {

var $lpcNn = parcelRequire("lpcNn");

var $011cL = parcelRequire("011cL");
function $8f7c0ad01e0dceb6$var$PEMEncoder(entity) {
    $011cL.call(this, entity);
    this.enc = 'pem';
}
$lpcNn($8f7c0ad01e0dceb6$var$PEMEncoder, $011cL);
module.exports = $8f7c0ad01e0dceb6$var$PEMEncoder;
$8f7c0ad01e0dceb6$var$PEMEncoder.prototype.encode = function encode(data, options) {
    var buf = $011cL.prototype.encode.call(this, data);
    var p = buf.toString('base64');
    var out = [
        '-----BEGIN ' + options.label + '-----'
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push('-----END ' + options.label + '-----');
    return out.join('\n');
};

});



parcelRegister("hF7AY", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
'use strict';

var $cYka3 = parcelRequire("cYka3");
var $cdbc2844673a6ba7$var$Time = $cYka3.define('Time', function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $cdbc2844673a6ba7$var$AttributeTypeValue = $cYka3.define('AttributeTypeValue', function() {
    this.seq().obj(this.key('type').objid(), this.key('value').any());
});
var $cdbc2844673a6ba7$var$AlgorithmIdentifier = $cYka3.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('parameters').optional(), this.key('curve').objid().optional());
});
var $cdbc2844673a6ba7$var$SubjectPublicKeyInfo = $cYka3.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($cdbc2844673a6ba7$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
var $cdbc2844673a6ba7$var$RelativeDistinguishedName = $cYka3.define('RelativeDistinguishedName', function() {
    this.setof($cdbc2844673a6ba7$var$AttributeTypeValue);
});
var $cdbc2844673a6ba7$var$RDNSequence = $cYka3.define('RDNSequence', function() {
    this.seqof($cdbc2844673a6ba7$var$RelativeDistinguishedName);
});
var $cdbc2844673a6ba7$var$Name = $cYka3.define('Name', function() {
    this.choice({
        rdnSequence: this.use($cdbc2844673a6ba7$var$RDNSequence)
    });
});
var $cdbc2844673a6ba7$var$Validity = $cYka3.define('Validity', function() {
    this.seq().obj(this.key('notBefore').use($cdbc2844673a6ba7$var$Time), this.key('notAfter').use($cdbc2844673a6ba7$var$Time));
});
var $cdbc2844673a6ba7$var$Extension = $cYka3.define('Extension', function() {
    this.seq().obj(this.key('extnID').objid(), this.key('critical').bool().def(false), this.key('extnValue').octstr());
});
var $cdbc2844673a6ba7$var$TBSCertificate = $cYka3.define('TBSCertificate', function() {
    this.seq().obj(this.key('version').explicit(0)['int']().optional(), this.key('serialNumber')['int'](), this.key('signature').use($cdbc2844673a6ba7$var$AlgorithmIdentifier), this.key('issuer').use($cdbc2844673a6ba7$var$Name), this.key('validity').use($cdbc2844673a6ba7$var$Validity), this.key('subject').use($cdbc2844673a6ba7$var$Name), this.key('subjectPublicKeyInfo').use($cdbc2844673a6ba7$var$SubjectPublicKeyInfo), this.key('issuerUniqueID').implicit(1).bitstr().optional(), this.key('subjectUniqueID').implicit(2).bitstr().optional(), this.key('extensions').explicit(3).seqof($cdbc2844673a6ba7$var$Extension).optional());
});
var $cdbc2844673a6ba7$var$X509Certificate = $cYka3.define('X509Certificate', function() {
    this.seq().obj(this.key('tbsCertificate').use($cdbc2844673a6ba7$var$TBSCertificate), this.key('signatureAlgorithm').use($cdbc2844673a6ba7$var$AlgorithmIdentifier), this.key('signatureValue').bitstr());
});
module.exports = $cdbc2844673a6ba7$var$X509Certificate;

});


parcelRegister("2jqRh", function(module, exports) {
module.exports = JSON.parse("{\"2.16.840.1.101.3.4.1.1\":\"aes-128-ecb\",\"2.16.840.1.101.3.4.1.2\":\"aes-128-cbc\",\"2.16.840.1.101.3.4.1.3\":\"aes-128-ofb\",\"2.16.840.1.101.3.4.1.4\":\"aes-128-cfb\",\"2.16.840.1.101.3.4.1.21\":\"aes-192-ecb\",\"2.16.840.1.101.3.4.1.22\":\"aes-192-cbc\",\"2.16.840.1.101.3.4.1.23\":\"aes-192-ofb\",\"2.16.840.1.101.3.4.1.24\":\"aes-192-cfb\",\"2.16.840.1.101.3.4.1.41\":\"aes-256-ecb\",\"2.16.840.1.101.3.4.1.42\":\"aes-256-cbc\",\"2.16.840.1.101.3.4.1.43\":\"aes-256-ofb\",\"2.16.840.1.101.3.4.1.44\":\"aes-256-cfb\"}");

});

parcelRegister("arqMV", function(module, exports) {
'use strict';
// adapted from https://github.com/apatil/pemstrip
var $79a1348999d050f8$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $79a1348999d050f8$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $79a1348999d050f8$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $cXjgY = parcelRequire("cXjgY");

var $7uhwq = parcelRequire("7uhwq");

var $bc1ju = parcelRequire("bc1ju");
var $79a1348999d050f8$require$Buffer = $bc1ju.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($79a1348999d050f8$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($79a1348999d050f8$var$fullRegex);
        decrypted = $79a1348999d050f8$require$Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64');
    } else {
        var suite = 'aes' + match[1];
        var iv = $79a1348999d050f8$require$Buffer.from(match[2], 'hex');
        var cipherText = $79a1348999d050f8$require$Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64');
        var cipherKey = $cXjgY(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $7uhwq.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher['final']());
        decrypted = $79a1348999d050f8$require$Buffer.concat(out);
    }
    var tag = key.match($79a1348999d050f8$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});


parcelRegister("eoUcT", function(module, exports) {
module.exports = JSON.parse("{\"1.3.132.0.10\":\"secp256k1\",\"1.3.132.0.33\":\"p224\",\"1.2.840.10045.3.1.1\":\"p192\",\"1.2.840.10045.3.1.7\":\"p256\",\"1.3.132.0.34\":\"p384\",\"1.3.132.0.35\":\"p521\"}");

});


parcelRegister("hCU6x", function(module, exports) {
'use strict';

var $bc1ju = parcelRequire("bc1ju");
var $cd51817695b22a95$require$Buffer = $bc1ju.Buffer;

var $fFAQR = parcelRequire("fFAQR");

var $i8FXa = parcelRequire("i8FXa");
var $cd51817695b22a95$require$EC = $i8FXa.ec;

var $3ot7a = parcelRequire("3ot7a");

var $eoUcT = parcelRequire("eoUcT");
function $cd51817695b22a95$var$verify(sig, hash, key, signType, tag) {
    var pub = $3ot7a(key);
    if (pub.type === 'ec') {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
        return $cd51817695b22a95$var$ecVerify(sig, hash, pub);
    } else if (pub.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong public key type');
        return $cd51817695b22a95$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
    hash = $cd51817695b22a95$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $cd51817695b22a95$require$Buffer.from(pad);
    var red = $fFAQR.mont(pub.modulus);
    sig = new $fFAQR(sig).toRed(red);
    sig = sig.redPow(new $fFAQR(pub.publicExponent));
    sig = $cd51817695b22a95$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $cd51817695b22a95$var$ecVerify(sig, hash, pub) {
    var curveId = $eoUcT[pub.data.algorithm.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'));
    var curve = new $cd51817695b22a95$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $cd51817695b22a95$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $3ot7a.signature.decode(sig, 'der');
    var s = unpacked.s;
    var r = unpacked.r;
    $cd51817695b22a95$var$checkValue(s, q);
    $cd51817695b22a95$var$checkValue(r, q);
    var montp = $fFAQR.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $fFAQR(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $cd51817695b22a95$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error('invalid sig');
    if (b.cmp(q) >= 0) throw new Error('invalid sig');
}
module.exports = $cd51817695b22a95$var$verify;

});


parcelRegister("7nDDR", function(module, exports) {

var $5Ovjr = parcelRequire("5Ovjr");
var $55f96e734ed9e5f4$require$Buffer = $5Ovjr.Buffer;

var $i8FXa = parcelRequire("i8FXa");

var $2DhqK = parcelRequire("2DhqK");
module.exports = function createECDH(curve) {
    return new $55f96e734ed9e5f4$var$ECDH(curve);
};
var $55f96e734ed9e5f4$var$aliases = {
    secp256k1: {
        name: 'secp256k1',
        byteLength: 32
    },
    secp224r1: {
        name: 'p224',
        byteLength: 28
    },
    prime256v1: {
        name: 'p256',
        byteLength: 32
    },
    prime192v1: {
        name: 'p192',
        byteLength: 24
    },
    ed25519: {
        name: 'ed25519',
        byteLength: 32
    },
    secp384r1: {
        name: 'p384',
        byteLength: 48
    },
    secp521r1: {
        name: 'p521',
        byteLength: 66
    }
};
$55f96e734ed9e5f4$var$aliases.p224 = $55f96e734ed9e5f4$var$aliases.secp224r1;
$55f96e734ed9e5f4$var$aliases.p256 = $55f96e734ed9e5f4$var$aliases.secp256r1 = $55f96e734ed9e5f4$var$aliases.prime256v1;
$55f96e734ed9e5f4$var$aliases.p192 = $55f96e734ed9e5f4$var$aliases.secp192r1 = $55f96e734ed9e5f4$var$aliases.prime192v1;
$55f96e734ed9e5f4$var$aliases.p384 = $55f96e734ed9e5f4$var$aliases.secp384r1;
$55f96e734ed9e5f4$var$aliases.p521 = $55f96e734ed9e5f4$var$aliases.secp521r1;
function $55f96e734ed9e5f4$var$ECDH(curve) {
    this.curveType = $55f96e734ed9e5f4$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $i8FXa.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$55f96e734ed9e5f4$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$55f96e734ed9e5f4$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || 'utf8';
    if (!$55f96e734ed9e5f4$require$Buffer.isBuffer(other)) other = new $55f96e734ed9e5f4$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $55f96e734ed9e5f4$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$55f96e734ed9e5f4$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === 'compressed', true);
    if (format === 'hybrid') {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $55f96e734ed9e5f4$var$formatReturnValue(key, enc);
};
$55f96e734ed9e5f4$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $55f96e734ed9e5f4$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$55f96e734ed9e5f4$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || 'utf8';
    if (!$55f96e734ed9e5f4$require$Buffer.isBuffer(pub)) pub = new $55f96e734ed9e5f4$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$55f96e734ed9e5f4$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || 'utf8';
    if (!$55f96e734ed9e5f4$require$Buffer.isBuffer(priv)) priv = new $55f96e734ed9e5f4$require$Buffer(priv, enc);
    var _priv = new $2DhqK(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $55f96e734ed9e5f4$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $55f96e734ed9e5f4$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $55f96e734ed9e5f4$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $55f96e734ed9e5f4$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});

parcelRegister("33QHh", function(module, exports) {
$parcel$export(module.exports, "publicEncrypt", () => $23aa8779c04a9cc7$export$512823e338ddb1b7, (v) => $23aa8779c04a9cc7$export$512823e338ddb1b7 = v);
$parcel$export(module.exports, "privateDecrypt", () => $23aa8779c04a9cc7$export$7efb24e2fddf99b9, (v) => $23aa8779c04a9cc7$export$7efb24e2fddf99b9 = v);
$parcel$export(module.exports, "privateEncrypt", () => $23aa8779c04a9cc7$export$9d0e0c0c4a8d30f3, (v) => $23aa8779c04a9cc7$export$9d0e0c0c4a8d30f3 = v);
$parcel$export(module.exports, "publicDecrypt", () => $23aa8779c04a9cc7$export$b9d55ff329113abd, (v) => $23aa8779c04a9cc7$export$b9d55ff329113abd = v);
var $23aa8779c04a9cc7$export$512823e338ddb1b7;
var $23aa8779c04a9cc7$export$7efb24e2fddf99b9;
var $23aa8779c04a9cc7$export$9d0e0c0c4a8d30f3;
var $23aa8779c04a9cc7$export$b9d55ff329113abd;

$23aa8779c04a9cc7$export$512823e338ddb1b7 = (parcelRequire("9aLMz"));

$23aa8779c04a9cc7$export$7efb24e2fddf99b9 = (parcelRequire("ePQLV"));
$23aa8779c04a9cc7$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $23aa8779c04a9cc7$export$512823e338ddb1b7(key, buf, true);
};
$23aa8779c04a9cc7$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $23aa8779c04a9cc7$export$7efb24e2fddf99b9(key, buf, true);
};

});
parcelRegister("9aLMz", function(module, exports) {

var $3ot7a = parcelRequire("3ot7a");

var $49lWG = parcelRequire("49lWG");

var $lKbOi = parcelRequire("lKbOi");

var $j6uee = parcelRequire("j6uee");

var $f7HPr = parcelRequire("f7HPr");

var $2DhqK = parcelRequire("2DhqK");

var $cBwDd = parcelRequire("cBwDd");

var $9lS7E = parcelRequire("9lS7E");

var $bc1ju = parcelRequire("bc1ju");
var $6ada1cd508a29d36$require$Buffer = $bc1ju.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $3ot7a(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $6ada1cd508a29d36$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $6ada1cd508a29d36$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $2DhqK(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error('data too long for modulus');
    } else throw new Error('unknown padding');
    if (reverse) return $9lS7E(paddedMsg, key);
    else return $cBwDd(paddedMsg, key);
};
function $6ada1cd508a29d36$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $lKbOi('sha1').update($6ada1cd508a29d36$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error('message too long');
    var ps = $6ada1cd508a29d36$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $49lWG(hLen);
    var maskedDb = $f7HPr($6ada1cd508a29d36$require$Buffer.concat([
        iHash,
        ps,
        $6ada1cd508a29d36$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $j6uee(seed, dblen));
    var maskedSeed = $f7HPr(seed, $j6uee(maskedDb, hLen));
    return new $2DhqK($6ada1cd508a29d36$require$Buffer.concat([
        $6ada1cd508a29d36$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $6ada1cd508a29d36$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error('message too long');
    var ps;
    if (reverse) ps = $6ada1cd508a29d36$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $6ada1cd508a29d36$var$nonZero(k - mLen - 3);
    return new $2DhqK($6ada1cd508a29d36$require$Buffer.concat([
        $6ada1cd508a29d36$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $6ada1cd508a29d36$require$Buffer.alloc(1),
        msg
    ], k));
}
function $6ada1cd508a29d36$var$nonZero(len) {
    var out = $6ada1cd508a29d36$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $49lWG(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $49lWG(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("j6uee", function(module, exports) {

var $lKbOi = parcelRequire("lKbOi");

var $bc1ju = parcelRequire("bc1ju");
var $de8606a116ec4d61$require$Buffer = $bc1ju.Buffer;
module.exports = function(seed, len) {
    var t = $de8606a116ec4d61$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $de8606a116ec4d61$var$i2ops(i++);
        t = $de8606a116ec4d61$require$Buffer.concat([
            t,
            $lKbOi('sha1').update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $de8606a116ec4d61$var$i2ops(c) {
    var out = $de8606a116ec4d61$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("f7HPr", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("cBwDd", function(module, exports) {

var $2DhqK = parcelRequire("2DhqK");

var $bc1ju = parcelRequire("bc1ju");
var $92d240adbc4addfe$require$Buffer = $bc1ju.Buffer;
function $92d240adbc4addfe$var$withPublic(paddedMsg, key) {
    return $92d240adbc4addfe$require$Buffer.from(paddedMsg.toRed($2DhqK.mont(key.modulus)).redPow(new $2DhqK(key.publicExponent)).fromRed().toArray());
}
module.exports = $92d240adbc4addfe$var$withPublic;

});


parcelRegister("ePQLV", function(module, exports) {

var $3ot7a = parcelRequire("3ot7a");

var $j6uee = parcelRequire("j6uee");

var $f7HPr = parcelRequire("f7HPr");

var $2DhqK = parcelRequire("2DhqK");

var $9lS7E = parcelRequire("9lS7E");

var $lKbOi = parcelRequire("lKbOi");

var $cBwDd = parcelRequire("cBwDd");

var $bc1ju = parcelRequire("bc1ju");
var $accec388d65ad127$require$Buffer = $bc1ju.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $3ot7a(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $2DhqK(enc).cmp(key.modulus) >= 0) throw new Error('decryption error');
    var msg;
    if (reverse) msg = $cBwDd(new $2DhqK(enc), key);
    else msg = $9lS7E(enc, key);
    var zBuffer = $accec388d65ad127$require$Buffer.alloc(k - msg.length);
    msg = $accec388d65ad127$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $accec388d65ad127$var$oaep(key, msg);
    else if (padding === 1) return $accec388d65ad127$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error('unknown padding');
};
function $accec388d65ad127$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $lKbOi('sha1').update($accec388d65ad127$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error('decryption error');
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $f7HPr(maskedSeed, $j6uee(maskedDb, hLen));
    var db = $f7HPr(maskedDb, $j6uee(seed, k - hLen - 1));
    if ($accec388d65ad127$var$compare(iHash, db.slice(0, hLen))) throw new Error('decryption error');
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error('decryption error');
    return db.slice(i);
}
function $accec388d65ad127$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString('hex') !== '0002' && !reverse || p1.toString('hex') !== '0001' && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error('decryption error');
    return msg.slice(i);
}
function $accec388d65ad127$var$compare(a, b) {
    a = $accec388d65ad127$require$Buffer.from(a);
    b = $accec388d65ad127$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});


parcelRegister("fa9Fb", function(module, exports) {
$parcel$export(module.exports, "randomFill", () => $b09f491cbdd4266f$export$bb1abf2ce84fc7e8, (v) => $b09f491cbdd4266f$export$bb1abf2ce84fc7e8 = v);
$parcel$export(module.exports, "randomFillSync", () => $b09f491cbdd4266f$export$2f7171e78e524d5e, (v) => $b09f491cbdd4266f$export$2f7171e78e524d5e = v);
var $b09f491cbdd4266f$export$bb1abf2ce84fc7e8;
var $b09f491cbdd4266f$export$2f7171e78e524d5e;

var $igDjg = parcelRequire("igDjg");
'use strict';
function $b09f491cbdd4266f$var$oldBrowser() {
    throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11');
}

var $bc1ju = parcelRequire("bc1ju");

var $49lWG = parcelRequire("49lWG");
var $b09f491cbdd4266f$var$Buffer = $bc1ju.Buffer;
var $b09f491cbdd4266f$var$kBufferMaxLength = $bc1ju.kMaxLength;
var $b09f491cbdd4266f$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $b09f491cbdd4266f$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $b09f491cbdd4266f$var$assertOffset(offset, length) {
    if (typeof offset !== 'number' || offset !== offset) throw new TypeError('offset must be a number');
    if (offset > $b09f491cbdd4266f$var$kMaxUint32 || offset < 0) throw new TypeError('offset must be a uint32');
    if (offset > $b09f491cbdd4266f$var$kBufferMaxLength || offset > length) throw new RangeError('offset out of range');
}
function $b09f491cbdd4266f$var$assertSize(size, offset, length) {
    if (typeof size !== 'number' || size !== size) throw new TypeError('size must be a number');
    if (size > $b09f491cbdd4266f$var$kMaxUint32 || size < 0) throw new TypeError('size must be a uint32');
    if (size + offset > length || size > $b09f491cbdd4266f$var$kBufferMaxLength) throw new RangeError('buffer too small');
}
if ($b09f491cbdd4266f$var$crypto && $b09f491cbdd4266f$var$crypto.getRandomValues || false) {
    $b09f491cbdd4266f$export$bb1abf2ce84fc7e8 = $b09f491cbdd4266f$var$randomFill;
    $b09f491cbdd4266f$export$2f7171e78e524d5e = $b09f491cbdd4266f$var$randomFillSync;
} else {
    $b09f491cbdd4266f$export$bb1abf2ce84fc7e8 = $b09f491cbdd4266f$var$oldBrowser;
    $b09f491cbdd4266f$export$2f7171e78e524d5e = $b09f491cbdd4266f$var$oldBrowser;
}
function $b09f491cbdd4266f$var$randomFill(buf, offset, size, cb) {
    if (!$b09f491cbdd4266f$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === 'function') {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === 'function') {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== 'function') throw new TypeError('"cb" argument must be a function');
    $b09f491cbdd4266f$var$assertOffset(offset, buf.length);
    $b09f491cbdd4266f$var$assertSize(size, offset, buf.length);
    return $b09f491cbdd4266f$var$actualFill(buf, offset, size, cb);
}
function $b09f491cbdd4266f$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $b09f491cbdd4266f$var$crypto.getRandomValues(uint);
    if (cb) {
        $igDjg.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $49lWG(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $49lWG(size);
    bytes.copy(buf, offset);
    return buf;
}
function $b09f491cbdd4266f$var$randomFillSync(buf, offset, size) {
    if (typeof offset === 'undefined') offset = 0;
    if (!$b09f491cbdd4266f$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $b09f491cbdd4266f$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $b09f491cbdd4266f$var$assertSize(size, offset, buf.length);
    return $b09f491cbdd4266f$var$actualFill(buf, offset, size);
}

});







parcelRegister("9HjWS", function(module, exports) {
$parcel$export(module.exports, "InlineDialog", () => $cc439fd71242afb9$export$c7313f750e9cbc9d);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $i3v3M = parcelRequire("i3v3M");

var $3fQFh = parcelRequire("3fQFh");
var $eUUeL = parcelRequire("eUUeL");
function $cc439fd71242afb9$var$Form(props) {
    const { actions: actions, akFormProps: akFormProps, akSubmitButtonProps: akSubmitButtonProps, children: children, htmlFormProps: htmlFormProps } = (0, $i3v3M.useForm)(props);
    const { key: key, onSubmit: onSubmit } = akFormProps;
    const { children: submitButtonChildren, shouldFitContainer: shouldFitContainer, iconBefore: iconBefore, iconAfter: iconAfter, isLoading: loading, isDisabled: disabled, onClick: onClick, type: type } = akSubmitButtonProps;
    // @ts-ignore Ignoring the fact that "data-testid" is not part of the declared type
    const { className: className, 'data-testid': dataTestId } = htmlFormProps;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i3v3M.AkForm), {
        onSubmit: onSubmit,
        children: ({ formProps: formProps })=>{
            const { onSubmit: onSubmit, onKeyDown: onKeyDown, ref: ref } = formProps;
            return(// eslint-disable-next-line @atlassian/a11y/no-noninteractive-element-interactions
            /*#__PURE__*/ (0, $gt9Am.jsxs)("form", {
                onSubmit: onSubmit,
                onKeyDown: onKeyDown,
                ref: ref,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                "data-testid": dataTestId,
                children: [
                    children,
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i3v3M.AkFormFooter), {
                        align: "end",
                        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eUUeL.ButtonSet), {
                            children: [
                                actions,
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3fQFh.AkButton), {
                                    shouldFitContainer: shouldFitContainer,
                                    iconBefore: iconBefore,
                                    iconAfter: iconAfter,
                                    isLoading: loading,
                                    isDisabled: disabled,
                                    onClick: onClick,
                                    type: type,
                                    appearance: "primary",
                                    children: submitButtonChildren
                                })
                            ]
                        })
                    })
                ]
            }));
        }
    }, key);
}
function $cc439fd71242afb9$export$a06b1ef8e65f6918({ forgeDoc: forgeDoc, dispatch: dispatch, render: render }) {
    if (forgeDoc.children.length === 0) return {
        children: []
    };
    return {
        children: forgeDoc.children[0].type === 'Form' ? /*#__PURE__*/ (0, $gt9Am.jsx)($cc439fd71242afb9$var$Form, {
            forgeDoc: forgeDoc.children[0],
            dispatch: dispatch,
            render: render
        }) : forgeDoc.children.map(render)
    };
}
const $cc439fd71242afb9$export$c7313f750e9cbc9d = (props)=>{
    const { children: children } = $cc439fd71242afb9$export$a06b1ef8e65f6918(props);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
        children: children
    });
};

});

parcelRegister("fR0ol", function(module, exports) {
$parcel$export(module.exports, "ModalDialog", () => $f0dc4a4635c01aea$export$1fa217be60c2f188);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eJOHy = parcelRequire("eJOHy");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");

var $i3v3M = parcelRequire("i3v3M");

var $3fQFh = parcelRequire("3fQFh");

const $f0dc4a4635c01aea$export$d84e15b05040c98 = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("j5ZQQ")));

const $f0dc4a4635c01aea$var$AKModalHeader = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("2qG7I"))));

const $f0dc4a4635c01aea$var$AKModalTitle = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("5a9Ro"))));

const $f0dc4a4635c01aea$var$AKModalBody = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("ik0CA"))));

const $f0dc4a4635c01aea$var$AKModalFooter = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("kseeK"))));

const $f0dc4a4635c01aea$var$AKButton = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bdwGa")));
const $f0dc4a4635c01aea$var$COMPONENT_TOP_MARGIN = "var(--ds-space-150, 12px)";
function $f0dc4a4635c01aea$var$applyTopMargin(element) {
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $1NIU8.css)({
            marginTop: $f0dc4a4635c01aea$var$COMPONENT_TOP_MARGIN
        })
    }, element);
}
function $f0dc4a4635c01aea$export$1e9ab8114847a87d({ forgeDoc: forgeDoc, dispatch: dispatch, render: render }) {
    const intl = (0, $lRq8t.default)();
    const { appearance: appearance, header: header, onClose: onClose, closeButtonText: closeButtonText = intl.formatMessage($f0dc4a4635c01aea$var$messages.closeModalButton), width: width = 'medium' } = forgeDoc.props || {};
    const formForgeDoc = forgeDoc.children.length === 1 && forgeDoc.children[0]?.type === 'Form' ? forgeDoc.children[0] : undefined;
    const [isSubmitting, setIsSubmitting] = (0, $eJOHy.useState)(false);
    const [isClosing, setIsClosing] = (0, $eJOHy.useState)(false);
    const [formValues, setFormValues] = (0, $eJOHy.useState)({});
    const setFormValue = (name, value)=>{
        setFormValues((prevState)=>({
                ...prevState,
                [name]: value
            }));
    };
    const { children: children, akFormProps: akFormProps, htmlFormProps: htmlFormProps, akSubmitButtonProps: akFormSubmitButtonProps } = (0, $i3v3M.useForm)({
        // This is awkward because we only use values if formForgeDoc exists
        // I want to conditionally call this hook but I can't
        forgeDoc: formForgeDoc || {
            type: 'Form',
            children: []
        },
        dispatch: dispatch,
        render: render
    });
    const akFormPropsWithOnSubmit = {
        ...akFormProps,
        onSubmit: async (...args)=>{
            setIsSubmitting(true);
            try {
                await akFormProps.onSubmit(...args);
            } finally{
                setIsSubmitting(false);
            }
        }
    };
    const formId = (0, $eJOHy.useRef)(`modal-form-id-${Date.now()}`);
    const akSubmitButtonProps = {
        ...akFormSubmitButtonProps,
        appearance: appearance || 'primary',
        isLoading: isSubmitting,
        form: formId.current
    };
    const handleClose = async ()=>{
        setIsClosing(true);
        try {
            await dispatch({
                type: 'event',
                handler: onClose,
                args: [],
                extensionData: {}
            });
        } finally{
            setIsClosing(false);
        }
    };
    const actions = formForgeDoc ? formForgeDoc.children.filter((0, $i3v3M.isActionButton)) : [];
    const { akActionButtonProps: akActionButtonProps } = (0, $3fQFh.useActionButtons)({
        forgeDoc: actions,
        dispatch: dispatch,
        render: render
    });
    const { akButtonProps: closeButtonProps } = (0, $3fQFh.useButton)({
        forgeDoc: {
            type: 'Button',
            props: {
                appearance: 'subtle',
                text: closeButtonText,
                onClick: onClose
            },
            children: []
        },
        dispatch: dispatch,
        render: render
    });
    const akCloseButtonProps = {
        ...closeButtonProps,
        isLoading: isClosing || closeButtonProps.isLoading
    };
    return {
        akModalDialogProps: {
            onClose: handleClose,
            width: width
        },
        akModalTitleProps: {
            appearance: appearance,
            children: header
        },
        akModalBodyProps: {
            children: formForgeDoc ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $i3v3M.AkForm), akFormPropsWithOnSubmit, ({ formProps: formProps })=>/*#__PURE__*/ (0, $1NIU8.jsx)("form", {
                    ...formProps,
                    ...htmlFormProps,
                    id: formId.current
                }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $i3v3M.FormContext).Provider, {
                    value: {
                        formValues: formValues,
                        setFormValue: setFormValue
                    }
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (child, index)=>index === 0 ? child : $f0dc4a4635c01aea$var$applyTopMargin(child))))) : (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(forgeDoc.children.map(render), (child, index)=>index === 0 ? child : $f0dc4a4635c01aea$var$applyTopMargin(child))
        },
        actions: formForgeDoc ? [
            ...akActionButtonProps,
            akCloseButtonProps,
            akSubmitButtonProps
        ] : [
            akCloseButtonProps
        ]
    };
}
function $f0dc4a4635c01aea$export$1fa217be60c2f188(props) {
    const { akModalDialogProps: akModalDialogProps, akModalTitleProps: akModalTitleProps, akModalBodyProps: akModalBodyProps, actions: actions } = $f0dc4a4635c01aea$export$1e9ab8114847a87d(props);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, $1NIU8.jsx)($f0dc4a4635c01aea$export$d84e15b05040c98, akModalDialogProps, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, $1NIU8.jsx)($f0dc4a4635c01aea$var$AKModalHeader, null, /*#__PURE__*/ (0, $1NIU8.jsx)($f0dc4a4635c01aea$var$AKModalTitle, akModalTitleProps)), /*#__PURE__*/ (0, $1NIU8.jsx)($f0dc4a4635c01aea$var$AKModalBody, akModalBodyProps), /*#__PURE__*/ (0, $1NIU8.jsx)($f0dc4a4635c01aea$var$AKModalFooter, null, actions.map((akButtonProps, index)=>/*#__PURE__*/ (0, $1NIU8.jsx)($f0dc4a4635c01aea$var$AKButton, {
            ...akButtonProps,
            key: index
        }))))));
}
const $f0dc4a4635c01aea$var$messages = (0, $7qGN1.defineMessages)({
    closeModalButton: {
        id: 'confluence.modal.dialog.close.modal.button',
        defaultMessage: 'Cancel',
        description: 'The text inside of the button that will cancel the modal operation.'
    }
});

});
parcelRegister("j5ZQQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1Nd4C").then(()=>parcelRequire('fdZLV'));

});


parcelRegister("eIxIr", function(module, exports) {
$parcel$export(module.exports, "RadioGroupFn", () => $cd461e766f458873$export$306cd3e63a0f2f51);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eJOHy = parcelRequire("eJOHy");

var $i3v3M = parcelRequire("i3v3M");
function $cd461e766f458873$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $cd461e766f458873$var$styles = {
    name: "1l4ndn6",
    styles: "line-height:20px"
};

const $cd461e766f458873$var$Field = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("de5df")).then((module)=>({
            default: module.Field
        })));

const $cd461e766f458873$var$AkRadioGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>Promise.resolve((parcelRequire("a6tuu"))));

const $cd461e766f458873$var$AKHelperMessage = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("de5df")).then((module)=>({
            default: module.HelperMessage
        })));
const $cd461e766f458873$export$a98f0dcb43a68a25 = ({ options: options, defaultValue: defaultValue, isRequired: isRequired, label: label, description: description, name: name })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)($cd461e766f458873$var$Field, {
        defaultValue: defaultValue,
        isRequired: isRequired,
        label: label,
        name: name
    }, ({ fieldProps: fieldProps })=>{
        const { id: id, isRequired: isRequired, isDisabled: isDisabled, isInvalid: isInvalid, onChange: onChange, value: value, 'aria-labelledby': ariaLabelledBy } = fieldProps;
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $i3v3M.FormStateChangeNotifier), {
            name: name,
            value: fieldProps.value
        }), description && /*#__PURE__*/ (0, $1NIU8.jsx)($cd461e766f458873$var$AKHelperMessage, null, description), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $cd461e766f458873$var$styles
        }, /*#__PURE__*/ (0, $1NIU8.jsx)($cd461e766f458873$var$AkRadioGroup, {
            "test-id": id,
            isRequired: isRequired,
            isDisabled: isDisabled,
            isInvalid: isInvalid,
            onChange: onChange,
            value: value,
            "aria-labelledby": ariaLabelledBy,
            options: options
        })));
    });
};
const $cd461e766f458873$export$306cd3e63a0f2f51 = ({ props: props, children: children })=>{
    const { label: label, name: name, isRequired: isRequired, description: description } = props;
    let defaultValue;
    const options = children.map((child)=>{
        const { props: props, type: type } = child;
        if (type === 'Radio') {
            const { label: label, value: value, defaultChecked: defaultChecked } = props;
            if (defaultChecked) defaultValue = value;
            return {
                name: name,
                label: label,
                value: value
            };
        }
    }).filter((option)=>typeof option !== 'undefined');
    return /*#__PURE__*/ (0, $1NIU8.jsx)($cd461e766f458873$export$a98f0dcb43a68a25, {
        label: label,
        name: name,
        options: options,
        defaultValue: defaultValue,
        description: description,
        isRequired: isRequired
    });
};

});
parcelRegister("a6tuu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $de7bef9bf1f92e14$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3Vuhz = parcelRequire("3Vuhz");

var $gl2vi = parcelRequire("gl2vi");

var $gPG64 = parcelRequire("gPG64");
const $de7bef9bf1f92e14$var$noOptions = [];
function $de7bef9bf1f92e14$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, options: options = $de7bef9bf1f92e14$var$noOptions, value: propValue, defaultValue: defaultValue, id: id, isDisabled: isDisabled, isRequired: isRequired, isInvalid: isInvalid, labelId: labelId, onInvalid: onInvalid = (0, $3Vuhz.default), name: name, analyticsContext: analyticsContext, ['aria-labelledby']: ariaLabelledBy, testId: testId } = props;
    const uid = (0, $gl2vi.useId)();
    const [selectedValue, setSelectedValue] = (0, $eJOHy.useState)(propValue !== undefined ? propValue : defaultValue);
    const onRadioChange = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        setSelectedValue(e.currentTarget.value);
        if (onChange) onChange(e, analyticsEvent);
    }, [
        onChange
    ]);
    // If propValue is provided than act as a controlled component
    // If not then act as an uncontrolled component using the value from state
    const value = typeof propValue !== 'undefined' ? propValue : selectedValue;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        role: "radiogroup",
        // TODO: Make `aria-labelledby` a `never` in TS. See https://product-fabric.atlassian.net/browse/DSP-23009
        "aria-labelledby": labelId || ariaLabelledBy,
        "data-testid": testId,
        "aria-describedby": isInvalid ? `${id || uid}-error` : undefined,
        id: id || uid,
        children: options.map(({ ...optionProps }, index)=>{
            if (typeof isDisabled !== 'undefined') optionProps.isDisabled = isDisabled;
            const isChecked = value !== null && optionProps.value === value;
            return /*#__PURE__*/ (0, $eJOHy.createElement)((0, $gPG64.default), {
                ...optionProps,
                name: name || optionProps.name,
                key: index,
                onChange: onRadioChange,
                onInvalid: onInvalid,
                isInvalid: isChecked && isInvalid,
                isChecked: isChecked,
                testId: optionProps.testId || testId,
                isRequired: isRequired,
                analyticsContext: analyticsContext
            });
        })
    });
}

});


parcelRegister("fjtyX", function(module, exports) {
$parcel$export(module.exports, "RangeFn", () => $8bb9f349ed7c48d6$export$da0b73f16fbcfd59);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $i3v3M = parcelRequire("i3v3M");

var $8rPev = parcelRequire("8rPev");

const $8bb9f349ed7c48d6$var$AKRange = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("dKpDm")));

const $8bb9f349ed7c48d6$var$AKField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("de5df")).then((module)=>({
            default: module.Field
        })));
const $8bb9f349ed7c48d6$var$Range = ({ defaultValue: defaultValue, min: min = 0, max: max = 100, step: step = 1, label: label, name: name, testId: testId })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8rPev.FieldContainer), null, /*#__PURE__*/ (0, $1NIU8.jsx)($8bb9f349ed7c48d6$var$AKField, {
        name: name,
        label: label,
        defaultValue: defaultValue || min
    }, ({ fieldProps: fieldProps })=>{
        const { isDisabled: isDisabled, onChange: onChange, onBlur: onBlur, onFocus: onFocus, value: value, 'aria-labelledby': ariaLabelledBy } = fieldProps;
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $i3v3M.FormStateChangeNotifier), {
            name: name,
            value: fieldProps.value
        }), /*#__PURE__*/ (0, $1NIU8.jsx)($8bb9f349ed7c48d6$var$AKRange, {
            min: min,
            max: max,
            step: step,
            testId: testId,
            isDisabled: isDisabled,
            value: value,
            onChange: onChange,
            onBlur: onBlur,
            onFocus: onFocus,
            "aria-labelledby": ariaLabelledBy
        }));
    }));
};
var $8bb9f349ed7c48d6$export$2e2bcd8739ae039 = $8bb9f349ed7c48d6$var$Range;
const $8bb9f349ed7c48d6$export$da0b73f16fbcfd59 = ({ props: props })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)($8bb9f349ed7c48d6$var$Range, props);
};

});
parcelRegister("dKpDm", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lFEXu").then(()=>parcelRequire('Uhlgd'));

});


parcelRegister("24ML5", function(module, exports) {
$parcel$export(module.exports, "SectionMessageFn", () => $cf319340e437c150$export$8376ed98c8f93829);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

const $cf319340e437c150$var$AKSectionMessage = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3O8m5")));
const $cf319340e437c150$export$e06a8392284a8d09 = {
    info: 'information',
    confirmation: 'success',
    change: 'discovery',
    warning: 'warning',
    error: 'error'
};
const $cf319340e437c150$var$SectionMessage = ({ title: title, appearance: appearance = 'info', children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($cf319340e437c150$var$AKSectionMessage, {
        title: title,
        //TODO: Remove this mapping once the forge-ui package is updated to accomodate section-message appearance changes
        appearance: $cf319340e437c150$export$e06a8392284a8d09[appearance],
        children: children
    });
};
var $cf319340e437c150$export$2e2bcd8739ae039 = $cf319340e437c150$var$SectionMessage;
const $cf319340e437c150$export$8376ed98c8f93829 = ({ props: props, children: children, Components: Components, render: render, renderChildren: renderChildren, dispatch: dispatch })=>{
    const { title: title, appearance: appearance } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)($cf319340e437c150$var$SectionMessage, {
        title: title,
        appearance: appearance,
        children: renderChildren({
            Components: Components,
            children: children,
            render: render,
            dispatch: dispatch
        })
    });
};

});

parcelRegister("gmTz7", function(module, exports) {
$parcel$export(module.exports, "SelectFn", () => $fbe1c418fc4b40fb$export$747c8c62a73d26b4);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eJOHy = parcelRequire("eJOHy");

var $7qGN1 = parcelRequire("7qGN1");
var $kDaaB = parcelRequire("kDaaB");

var $8rPev = parcelRequire("8rPev");

var $hmQK4 = parcelRequire("hmQK4");

var $i3v3M = parcelRequire("i3v3M");

const $fbe1c418fc4b40fb$var$AKFormField = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aakjp")));

const $fbe1c418fc4b40fb$var$AKSelect = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8OCo2")));

const $fbe1c418fc4b40fb$var$AKErrorMessage = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("de5df")).then((module)=>({
            default: module.ErrorMessage
        })));

const $fbe1c418fc4b40fb$var$AKHelperMessage = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("de5df")).then((module)=>({
            default: module.HelperMessage
        })));
const $fbe1c418fc4b40fb$var$validate = (value)=>!value ? 'EMPTY' : undefined;
const $fbe1c418fc4b40fb$export$ef9b1a59e592288f = ({ options: options, isMulti: isMulti, defaultValue: defaultValue, label: label, name: name, description: description, isRequired: isRequired, placeholder: placeholder })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $hmQK4.PortalConsumer), null, (portal)=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, $8rPev.FieldContainer), null, /*#__PURE__*/ (0, $1NIU8.jsx)($fbe1c418fc4b40fb$var$AKFormField, {
            defaultValue: defaultValue,
            label: label,
            name: name,
            isRequired: isRequired,
            validate: isRequired ? $fbe1c418fc4b40fb$var$validate : undefined
        }, ({ fieldProps: fieldProps, error: error })=>{
            const { id: id, isRequired: isRequired, isDisabled: isDisabled, isInvalid: isInvalid, onChange: onChange, onBlur: onBlur, onFocus: onFocus, value: value, 'aria-labelledby': ariaLabelledBy } = fieldProps;
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $i3v3M.FormStateChangeNotifier), {
                name: name,
                value: fieldProps.value
            }), /*#__PURE__*/ (0, $1NIU8.jsx)($fbe1c418fc4b40fb$var$AKSelect, {
                id: id,
                isRequired: isRequired,
                isDisabled: isDisabled,
                isInvalid: isInvalid,
                onChange: onChange,
                onBlur: onBlur,
                onFocus: onFocus,
                value: value,
                "aria-labelledby": ariaLabelledBy,
                isMulti: isMulti,
                menuPortalTarget: portal,
                options: options,
                placeholder: placeholder,
                validationState: error ? 'error' : 'default'
            }), error === 'EMPTY' && /*#__PURE__*/ (0, $1NIU8.jsx)($fbe1c418fc4b40fb$var$AKErrorMessage, null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $kDaaB.default), $fbe1c418fc4b40fb$var$messages.requiredFieldMessage)), description && /*#__PURE__*/ (0, $1NIU8.jsx)($fbe1c418fc4b40fb$var$AKHelperMessage, null, description));
        })));
};
const $fbe1c418fc4b40fb$export$747c8c62a73d26b4 = ({ props: props, children: children })=>{
    const { description: description, label: label, name: name, isMulti: isMulti, placeholder: placeholder, isRequired: isRequired } = props;
    let defaultValue = [];
    const options = children.map((child)=>{
        const { props: props, type: type } = child;
        if (type === 'Option') {
            const { defaultSelected: defaultSelected, label: label, value: value } = props;
            const option = {
                label: label,
                value: value
            };
            if (defaultSelected) {
                if (isMulti) defaultValue.push(option);
                else defaultValue = [
                    option
                ];
            }
            return option;
        }
    }).filter((option)=>typeof option !== 'undefined');
    const formattedDefaultValue = isMulti ? defaultValue : defaultValue[0];
    return /*#__PURE__*/ (0, $1NIU8.jsx)($fbe1c418fc4b40fb$export$ef9b1a59e592288f, {
        label: label,
        name: name,
        options: options,
        isMulti: isMulti,
        isRequired: isRequired,
        defaultValue: formattedDefaultValue,
        description: description,
        placeholder: placeholder
    });
};
const $fbe1c418fc4b40fb$var$messages = (0, $7qGN1.defineMessages)({
    requiredFieldMessage: {
        id: 'confluence.select.required.field.message',
        defaultMessage: 'This field is required.',
        description: 'This message alerts the user that a field is required.'
    }
});

});
parcelRegister("aakjp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1sTS1").then(()=>parcelRequire('ev1gN'));

});

parcelRegister("8OCo2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hOb79").then(()=>parcelRequire('gCWwJ'));

});


parcelRegister("k3iHm", function(module, exports) {
$parcel$export(module.exports, "StatusLozengeFn", () => $da13ebed249ea43d$export$3cc3ebecc7f239e9);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

const $da13ebed249ea43d$var$AkStatusLozenge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("dxy0F")));
const $da13ebed249ea43d$var$StatusLozenge = ({ appearance: appearance, text: text })=>/*#__PURE__*/ (0, $gt9Am.jsx)($da13ebed249ea43d$var$AkStatusLozenge, {
        appearance: appearance,
        children: text
    });
var $da13ebed249ea43d$export$2e2bcd8739ae039 = $da13ebed249ea43d$var$StatusLozenge;
const $da13ebed249ea43d$export$3cc3ebecc7f239e9 = ({ props: props })=>{
    const { appearance: appearance, text: text } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)($da13ebed249ea43d$var$StatusLozenge, {
        appearance: appearance,
        text: text
    });
};

});
parcelRegister("dxy0F", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("e6o61").then(()=>parcelRequire('9bBMV'));

});


parcelRegister("dYUjm", function(module, exports) {
$parcel$export(module.exports, "TabsFn", () => $4c0c0b93a09e1580$export$79714c2052a995e9);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $lEA2o = parcelRequire("lEA2o");

var $1NIU8 = parcelRequire("1NIU8");

var $o0Fzr = parcelRequire("o0Fzr");

const $4c0c0b93a09e1580$var$AKTabs = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("i7CMz")).then((module)=>({
            default: module.default
        })));

const $4c0c0b93a09e1580$var$AKTab = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("i7CMz")).then((module)=>({
            default: module.Tab
        })));

const $4c0c0b93a09e1580$var$AKTabList = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("i7CMz")).then((module)=>({
            default: module.TabList
        })));

const $4c0c0b93a09e1580$var$AKTabPanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("i7CMz")).then((module)=>({
            default: module.TabPanel
        })));
// Tabs must be stateful so we don't reset to the first tab on re-renders
const $4c0c0b93a09e1580$var$Tabs = ({ tabs: tabs })=>{
    const [selectedIndex, setSelectedIndex] = (0, $eJOHy.useState)(0);
    const id = (0, $eJOHy.useRef)((0, $o0Fzr.useUID)());
    return /*#__PURE__*/ (0, $1NIU8.jsx)($4c0c0b93a09e1580$var$AKTabs, {
        selected: selectedIndex,
        onChange: setSelectedIndex,
        id: id.current,
        shouldUnmountTabPanelOnChange: true
    }, /*#__PURE__*/ (0, $1NIU8.jsx)($4c0c0b93a09e1580$var$AKTabList, null, tabs.map((tab, index)=>/*#__PURE__*/ (0, $1NIU8.jsx)($4c0c0b93a09e1580$var$AKTab, {
            key: index
        }, tab.label))), tabs.map((tab, index)=>/*#__PURE__*/ (0, $1NIU8.jsx)($4c0c0b93a09e1580$var$AKTabPanel, {
            key: index
        }, tab.content)));
};
var $4c0c0b93a09e1580$export$2e2bcd8739ae039 = $4c0c0b93a09e1580$var$Tabs;
const $4c0c0b93a09e1580$export$79714c2052a995e9 = ({ children: children, dispatch: dispatch, Components: Components, render: render, renderChildren: renderChildren })=>{
    const tabData = children.map((child)=>{
        const { props: props, type: type } = child;
        if (type === 'Tab') return {
            label: props?.label,
            content: /*#__PURE__*/ (0, $1NIU8.jsx)((0, $lEA2o.default), {
                nonVisibleChildren: null
            }, renderChildren({
                children: child.children,
                dispatch: dispatch,
                Components: Components,
                render: render
            }))
        };
    }).filter((child)=>child != null);
    return /*#__PURE__*/ (0, $1NIU8.jsx)($4c0c0b93a09e1580$var$Tabs, {
        tabs: tabData
    });
};

});
parcelRegister("lEA2o", function(module, exports) {
$parcel$export(module.exports, "default", () => $e3c004fb06f3bc83$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ViewFn", () => $e3c004fb06f3bc83$export$9dd2b28001e5a44e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eJOHy = parcelRequire("eJOHy");
function $e3c004fb06f3bc83$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e3c004fb06f3bc83$var$styles = {
    name: "6n1ert",
    styles: "width:inherit"
};
const $e3c004fb06f3bc83$var$COMPONENT_TOP_MARGIN = "var(--ds-space-150, 12px)";
function $e3c004fb06f3bc83$var$applyTopMargin(element) {
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $1NIU8.css)({
            marginTop: $e3c004fb06f3bc83$var$COMPONENT_TOP_MARGIN,
            width: 'inherit'
        })
    }, element);
}
var $e3c004fb06f3bc83$var$_ref = {
    name: "13i2jrr",
    styles: "display:flex;background:transparent;flex-direction:column;padding:0;position:relative;overflow:hidden;align-items:flex-start;width:100%;> *{margin-bottom:0;}"
};
const $e3c004fb06f3bc83$var$View = ({ children: children, nonVisibleChildren: nonVisibleChildren })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: $e3c004fb06f3bc83$var$_ref
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (child, index)=>index ? $e3c004fb06f3bc83$var$applyTopMargin(child) : /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $e3c004fb06f3bc83$var$styles
        }, child)), nonVisibleChildren);
};
var $e3c004fb06f3bc83$export$2e2bcd8739ae039 = $e3c004fb06f3bc83$var$View;
const $e3c004fb06f3bc83$export$9dd2b28001e5a44e = ({ children: children, dispatch: dispatch, Components: Components, render: render, renderChildren: renderChildren })=>{
    const isChildVisible = (type)=>![
            'ModalDialog'
        ].includes(type);
    const nonVisibleChildren = children.filter(({ type: type })=>!isChildVisible(type));
    const visibleChildren = children.filter(({ type: type })=>isChildVisible(type));
    return /*#__PURE__*/ (0, $1NIU8.jsx)($e3c004fb06f3bc83$var$View, {
        nonVisibleChildren: renderChildren({
            children: nonVisibleChildren,
            dispatch: dispatch,
            Components: Components,
            render: render
        })
    }, renderChildren({
        children: visibleChildren,
        dispatch: dispatch,
        Components: Components,
        render: render
    }));
};

});

parcelRegister("i7CMz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8BT92").then(()=>parcelRequire('39EXX'));

});


parcelRegister("axYyc", function(module, exports) {
$parcel$export(module.exports, "TableFn", () => $c3a7f5a6a5c806ef$export$d1aa90943bebe2eb);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eJOHy = parcelRequire("eJOHy");

var $1Q4AG = parcelRequire("1Q4AG");
function $c3a7f5a6a5c806ef$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c3a7f5a6a5c806ef$var$styles = {
    name: "a5j0nx",
    styles: "align-self:normal;margin-bottom:0px;word-break:initial"
};
const $c3a7f5a6a5c806ef$export$54ec01a60f47d33d = ({ head: head, rows: rows, rowsPerPage: rowsPerPage = 15 })=>{
    const [currentPage, setCurrentPage] = (0, $eJOHy.useState)(1);
    // rowsPerPage of 0 is a sentinel value for a fixed size Table
    const isFixedSize = rowsPerPage === 0 || rows.length <= rowsPerPage;
    rowsPerPage = isFixedSize ? Infinity : rowsPerPage;
    function onChange(i) {
        setCurrentPage(i);
    }
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $c3a7f5a6a5c806ef$var$styles
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $1Q4AG.default), {
        isFixedSize: isFixedSize,
        rowsPerPage: rowsPerPage,
        page: currentPage,
        onSetPage: onChange,
        head: head,
        rows: rows
    }));
};
const $c3a7f5a6a5c806ef$export$d1aa90943bebe2eb = ({ props: props, children: children, dispatch: dispatch, render: render, Components: Components })=>{
    const { rowsPerPage: rowsPerPage } = props;
    const convertRow = (row)=>{
        const cells = row.children.filter((child)=>child.type === 'Cell').map((cell)=>{
            const content = cell.children.map((child)=>{
                return render({
                    aux: child,
                    dispatch: dispatch,
                    Components: Components
                });
            });
            return {
                content: content
            };
        });
        return {
            cells: cells
        };
    };
    const head = children.filter((child)=>child.type === 'Head');
    const headData = head.length > 0 ? convertRow(head[0]) : {
        cells: []
    };
    const rows = children.filter((child)=>child.type === 'Row').map((row)=>convertRow(row));
    return /*#__PURE__*/ (0, $1NIU8.jsx)($c3a7f5a6a5c806ef$export$54ec01a60f47d33d, {
        head: headData,
        rows: rows,
        rowsPerPage: rowsPerPage
    });
};

});
parcelRegister("1Q4AG", function(module, exports) {
$parcel$export(module.exports, "default", () => $f314ce04b399bf69$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

const $f314ce04b399bf69$var$AKDynamicTable = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("amrTh")).then((module)=>({
            default: module.DynamicTableStateless
        })));
class $f314ce04b399bf69$export$e6dfd72ab29f8598 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    /**
	 * There's a bug with Suspense and findDOMNode https://github.com/facebook/react/issues/14188
	 * We've opted to catch and ignore the error temporarily while we address the issue in Atlaskit
	 * See http:/go/j/FUI-870
	 */ componentDidCatch(error) {
        if (error && error.message && (error.message === 'Unable to find node on an unmounted component.' || error.message.startsWith('Minified React error #188;')) && !this.state.retried) this.setState({
            retried: true
        }, ()=>this.setState({
                retried: false
            }));
        else throw error;
    }
    render() {
        const { Component: Component, head: head, isFixedSize: isFixedSize, onSetPage: onSetPage, page: page, rows: rows, rowsPerPage: rowsPerPage } = this.props;
        if (Component) return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
            head: head,
            isFixedSize: isFixedSize,
            onSetPage: onSetPage,
            page: page,
            rows: rows,
            rowsPerPage: rowsPerPage
        });
        else return null;
    }
    constructor(...args){
        super(...args), this.state = {
            retried: false
        };
    }
}
const $f314ce04b399bf69$var$LazyLoadedTable = (props)=>{
    const { head: head, isFixedSize: isFixedSize, onSetPage: onSetPage, page: page, rows: rows, rowsPerPage: rowsPerPage } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)($f314ce04b399bf69$export$e6dfd72ab29f8598, {
        Component: $f314ce04b399bf69$var$AKDynamicTable,
        head: head,
        isFixedSize: isFixedSize,
        onSetPage: onSetPage,
        page: page,
        rows: rows,
        rowsPerPage: rowsPerPage
    });
};
var $f314ce04b399bf69$export$2e2bcd8739ae039 = $f314ce04b399bf69$var$LazyLoadedTable;

});
parcelRegister("amrTh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dOb3j").then(()=>parcelRequire('1Jhrl'));

});



parcelRegister("8eNFp", function(module, exports) {
$parcel$export(module.exports, "TagFn", () => $477b9a1a8bee20ba$export$3ee92cd923c64da4);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

const $477b9a1a8bee20ba$var$AKTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("g07US")).then((module)=>({
            default: module.SimpleTag
        })));
const $477b9a1a8bee20ba$var$colorDict = {
    default: 'standard',
    green: 'green',
    blue: 'blue',
    red: 'red',
    purple: 'purple',
    grey: 'grey',
    teal: 'teal',
    yellow: 'yellow',
    'green-light': 'greenLight',
    'blue-light': 'blueLight',
    'red-light': 'redLight',
    'purple-light': 'purpleLight',
    'grey-light': 'greyLight',
    'teal-light': 'tealLight',
    'yellow-light': 'yellowLight'
};
const $477b9a1a8bee20ba$var$mapColorToAK = (color)=>{
    return $477b9a1a8bee20ba$var$colorDict[color];
};
const $477b9a1a8bee20ba$var$Tag = ({ color: color = 'default', text: text })=>{
    const akColor = $477b9a1a8bee20ba$var$mapColorToAK(color);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($477b9a1a8bee20ba$var$AKTag, {
        color: akColor,
        text: text
    });
};
const $477b9a1a8bee20ba$export$3ee92cd923c64da4 = ({ props: props })=>{
    const { color: color, text: text } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)($477b9a1a8bee20ba$var$Tag, {
        color: color,
        text: text
    });
};
var $477b9a1a8bee20ba$export$2e2bcd8739ae039 = $477b9a1a8bee20ba$var$Tag;

});
parcelRegister("g07US", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kNFvF"),
    $ewTvA("76j7Q")
]).then(()=>parcelRequire('7D8HD'));

});


parcelRegister("flRHQ", function(module, exports) {
$parcel$export(module.exports, "TagGroupFn", () => $88d896b13a9fd387$export$95fa80966968aa57);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

const $88d896b13a9fd387$var$AKTagGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("lwddQ")));
const $88d896b13a9fd387$var$TagGroup = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($88d896b13a9fd387$var$AKTagGroup, {
        children: children
    });
};
var $88d896b13a9fd387$export$2e2bcd8739ae039 = $88d896b13a9fd387$var$TagGroup;
const $88d896b13a9fd387$export$95fa80966968aa57 = ({ children: children, dispatch: dispatch, Components: Components, render: render, renderChildren: renderChildren })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($88d896b13a9fd387$var$TagGroup, {
        children: renderChildren({
            children: children,
            dispatch: dispatch,
            Components: Components,
            render: render
        })
    });
};

});
parcelRegister("lwddQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5OJft").then(()=>parcelRequire('6NdgQ'));

});


parcelRegister("hadI0", function(module, exports) {
$parcel$export(module.exports, "TextFn", () => $f7ffa8b57d691946$export$c703e634d6a416c6);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1NIU8 = parcelRequire("1NIU8");
parcelRequire("1B59H");
var $d5na4 = parcelRequire("d5na4");

var $7rgPd = parcelRequire("7rgPd");

var $5qJVF = parcelRequire("5qJVF");
function $f7ffa8b57d691946$export$e56c262d45d65d3f(text) {
    return text.split(/\s*\n\s*\n[\n\s]*/).filter((str)=>str.length > 0);
}
function $f7ffa8b57d691946$export$cc54e21c3860db3d({ content: content }) {
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", null, $f7ffa8b57d691946$export$e56c262d45d65d3f(content).map((paragraph, i)=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, $5qJVF.default), {
            as: "p",
            key: i
        }, paragraph)));
}
const $f7ffa8b57d691946$var$ALIGN_ALLOWLIST = [
    'start',
    'center',
    'end'
];
const $f7ffa8b57d691946$var$isTextAlign = (align)=>{
    return $f7ffa8b57d691946$var$ALIGN_ALLOWLIST.includes(align);
};
function $f7ffa8b57d691946$export$8af001e2d8bdb181(align) {
    if ($f7ffa8b57d691946$var$isTextAlign(align)) return align;
    else return 'start';
}
function $f7ffa8b57d691946$export$a4f87e7f51175d99({ children: children, align: align }) {
    const sanitizedAlign = $f7ffa8b57d691946$export$8af001e2d8bdb181(align);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $7rgPd.InlineContext).Provider, {
        value: {
            inline: true
        }
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $1NIU8.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            textAlign: sanitizedAlign
        })
    }, children));
}
function $f7ffa8b57d691946$var$filterMarkup(children, nested) {
    const isNestable = (child)=>(0, $d5na4.MarkupRecursiveList).some((x)=>child.type === x);
    const isInline = (child)=>(0, $d5na4.MarkupList).some((x)=>child.type === x);
    return children.map((child)=>{
        if (nested) {
            if (!isNestable(child)) return null;
        } else {
            if (!isInline(child)) return null;
        }
        return {
            ...child,
            children: $f7ffa8b57d691946$var$filterMarkup(child.children, true)
        };
    }).filter((x)=>x !== null);
}
function $f7ffa8b57d691946$export$e64c089f4186fe76({ Components: Components, children: children, align: align, dispatch: dispatch, render: render, renderChildren: renderChildren }) {
    // filter non Markup components
    children = $f7ffa8b57d691946$var$filterMarkup(children, false);
    return /*#__PURE__*/ (0, $1NIU8.jsx)($f7ffa8b57d691946$export$a4f87e7f51175d99, {
        align: align
    }, renderChildren({
        Components: Components,
        children: children,
        render: render,
        dispatch: dispatch
    }));
}
function $f7ffa8b57d691946$export$c703e634d6a416c6({ props: props, children: children, type: type, dispatch: dispatch, render: render, renderChildren: renderChildren, Components: Components }) {
    const { content: content, format: format } = props;
    if (typeof content === 'string') return /*#__PURE__*/ (0, $1NIU8.jsx)($f7ffa8b57d691946$export$cc54e21c3860db3d, {
        content: content
    });
    if (format === 'markup') {
        const { align: align } = props;
        return $f7ffa8b57d691946$export$e64c089f4186fe76({
            children: children,
            align: align,
            type: type,
            dispatch: dispatch,
            render: render,
            renderChildren: renderChildren,
            Components: Components
        });
    }
    // otherwise, do nothing
    return null;
}

});

parcelRegister("8DDbc", function(module, exports) {
$parcel$export(module.exports, "TextAreaFn", () => $484df23bb9dbfe48$export$7c39c70ba43929a0);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eJOHy = parcelRequire("eJOHy");

var $7qGN1 = parcelRequire("7qGN1");
var $kDaaB = parcelRequire("kDaaB");

var $8rPev = parcelRequire("8rPev");

var $i3v3M = parcelRequire("i3v3M");

const $484df23bb9dbfe48$var$AkFormField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("de5df")).then((module)=>({
            default: module.Field
        })));

const $484df23bb9dbfe48$var$AKTextArea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("g6iR0")));

const $484df23bb9dbfe48$var$AKErrorMessage = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("de5df")).then((module)=>({
            default: module.ErrorMessage
        })));

const $484df23bb9dbfe48$var$AKHelperMessage = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("de5df")).then((module)=>({
            default: module.HelperMessage
        })));
const $484df23bb9dbfe48$var$validate = (value)=>!value ? 'EMPTY' : undefined;
const $484df23bb9dbfe48$var$TextArea = (props)=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, $8rPev.FieldContainer), null, /*#__PURE__*/ (0, $1NIU8.jsx)($484df23bb9dbfe48$var$AkFormField, {
        name: props.name,
        label: props.label,
        defaultValue: props.defaultValue,
        isRequired: props.isRequired,
        validate: props.isRequired ? $484df23bb9dbfe48$var$validate : undefined
    }, ({ fieldProps: fieldProps, error: error })=>{
        const { id: id, isRequired: isRequired, isDisabled: isDisabled, isInvalid: isInvalid, onChange: onChange, onBlur: onBlur, onFocus: onFocus, value: value, 'aria-labelledby': ariaLabelledBy } = fieldProps;
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $i3v3M.FormStateChangeNotifier), {
            name: props.name,
            value: fieldProps.value
        }), /*#__PURE__*/ (0, $1NIU8.jsx)($484df23bb9dbfe48$var$AKTextArea, {
            id: id,
            isRequired: isRequired,
            isDisabled: isDisabled,
            isInvalid: isInvalid,
            onChange: onChange,
            onBlur: onBlur,
            onFocus: onFocus,
            value: value,
            "aria-labelledby": ariaLabelledBy,
            appearance: "standard",
            resize: "smart",
            minimumRows: 2,
            isMonospaced: props.isMonospaced,
            placeholder: props.placeholder,
            spellCheck: props.spellCheck
        }), error === 'EMPTY' && /*#__PURE__*/ (0, $1NIU8.jsx)($484df23bb9dbfe48$var$AKErrorMessage, null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $kDaaB.default), $484df23bb9dbfe48$var$messages.requiredFieldMessage)), props.description && /*#__PURE__*/ (0, $1NIU8.jsx)($484df23bb9dbfe48$var$AKHelperMessage, null, props.description));
    }));
var $484df23bb9dbfe48$export$2e2bcd8739ae039 = $484df23bb9dbfe48$var$TextArea;
const $484df23bb9dbfe48$export$7c39c70ba43929a0 = ({ props: props })=>{
    const { name: name, label: label, defaultValue: defaultValue, isMonospaced: isMonospaced, isRequired: isRequired, description: description, placeholder: placeholder, spellCheck: spellCheck } = props;
    return /*#__PURE__*/ (0, $1NIU8.jsx)($484df23bb9dbfe48$var$TextArea, {
        name: name,
        label: label,
        defaultValue: defaultValue,
        isMonospaced: isMonospaced,
        isRequired: isRequired,
        placeholder: placeholder,
        description: description,
        spellCheck: spellCheck
    });
};
const $484df23bb9dbfe48$var$messages = (0, $7qGN1.defineMessages)({
    requiredFieldMessage: {
        id: 'confluence.text.area.required.field.message',
        defaultMessage: 'This field is required.',
        description: 'This message alerts the user that a field is required.'
    }
});

});
parcelRegister("g6iR0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kT1bF").then(()=>parcelRequire('5vfS0'));

});


parcelRegister("bMMfu", function(module, exports) {
$parcel$export(module.exports, "TextFieldFn", () => $40f694608da3970e$export$13e56753353ca8c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eJOHy = parcelRequire("eJOHy");

var $dOz1q = parcelRequire("dOz1q");

var $i3v3M = parcelRequire("i3v3M");

var $8rPev = parcelRequire("8rPev");

const $40f694608da3970e$var$AKTextField = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4y2Yc")));

const $40f694608da3970e$var$AKErrorMessage = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("de5df")).then((module)=>({
            default: module.ErrorMessage
        })));

const $40f694608da3970e$var$AKField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("de5df")).then((module)=>({
            default: module.Field
        })));

const $40f694608da3970e$var$AKHelperMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("de5df")).then((module)=>({
            default: module.HelperMessage
        })));
const $40f694608da3970e$var$isValidType = (type)=>{
    return [
        'text',
        'number',
        'email',
        'tel',
        'password'
    ].includes(type);
};
function $40f694608da3970e$var$TextField({ type: type = 'text', name: name, label: label, description: description, placeholder: // description about the field
placeholder, isRequired: isRequired = false, defaultValue: defaultValue = '', testId: testId, autoComplete: autoComplete }) {
    const validate = (0, $dOz1q.makeValidate)(isRequired, type);
    // WARNING: for <input type=number> and React, native validation is strange, use type text
    const fieldType = !$40f694608da3970e$var$isValidType(type) || type === 'number' ? 'text' : type;
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8rPev.FieldContainer), null, /*#__PURE__*/ (0, $1NIU8.jsx)($40f694608da3970e$var$AKField, {
        name: name,
        label: label,
        defaultValue: defaultValue,
        isRequired: isRequired,
        validate: validate
    }, ({ fieldProps: fieldProps })=>{
        const { id: id, isDisabled: isDisabled, isInvalid: isInvalid, onBlur: onBlur, onFocus: onFocus, value: value, onChange: onChange, 'aria-labelledby': ariaLabelledBy } = fieldProps;
        const error = isInvalid ? validate(value) : null;
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $i3v3M.FormStateChangeNotifier), {
            name: name,
            value: value
        }), /*#__PURE__*/ (0, $1NIU8.jsx)($40f694608da3970e$var$AKTextField, {
            type: fieldType,
            testId: testId,
            placeholder: placeholder,
            autoComplete: autoComplete,
            onFocus: onFocus,
            onBlur: onBlur,
            isDisabled: isDisabled,
            id: id,
            isInvalid: isInvalid,
            "aria-labelledby": ariaLabelledBy,
            defaultValue: defaultValue,
            onChange: onChange
        }), error ? /*#__PURE__*/ (0, $1NIU8.jsx)($40f694608da3970e$var$AKErrorMessage, null, error) : null, description ? /*#__PURE__*/ (0, $1NIU8.jsx)($40f694608da3970e$var$AKHelperMessage, null, description) : null);
    }));
}
var $40f694608da3970e$export$2e2bcd8739ae039 = $40f694608da3970e$var$TextField;
const $40f694608da3970e$export$13e56753353ca8c = ({ props: props })=>{
    const { name: name, label: label, type: type, description: description, defaultValue: defaultValue, isRequired: isRequired, placeholder: placeholder, autoComplete: autoComplete } = props;
    return /*#__PURE__*/ (0, $1NIU8.jsx)($40f694608da3970e$var$TextField, {
        type: type,
        name: name,
        label: label,
        defaultValue: defaultValue,
        isRequired: isRequired,
        description: description,
        placeholder: placeholder,
        autoComplete: autoComplete
    });
};

});
parcelRegister("dOz1q", function(module, exports) {
$parcel$export(module.exports, "makeValidate", () => $9690b4deb93b327f$export$175ffc4a72fd9f6d);
// eslint-disable-next-line import/no-extraneous-dependencies

var $hantM = parcelRequire("hantM");

var $4nehu = parcelRequire("4nehu");
var $99KvW = parcelRequire("99KvW");
var $7qGN1 = parcelRequire("7qGN1");
const $9690b4deb93b327f$var$cache = (0, $99KvW.createIntlCache)();
const $9690b4deb93b327f$var$defaultIntl = (0, $4nehu.createIntl)({
    locale: 'en'
}, $9690b4deb93b327f$var$cache);
function $9690b4deb93b327f$export$7e4aa119212bc614(value, propIntl) {
    const intl = propIntl ? propIntl : $9690b4deb93b327f$var$defaultIntl;
    const { formatMessage: formatMessage } = intl;
    return (0, (/*@__PURE__*/$parcel$interopDefault($hantM)))(value) ? undefined : formatMessage($9690b4deb93b327f$var$messages.validNumber);
}
function $9690b4deb93b327f$export$7fbbfbca30081d0(value, propIntl) {
    const intl = propIntl ? propIntl : $9690b4deb93b327f$var$defaultIntl;
    const { formatMessage: formatMessage } = intl;
    if (typeof value === 'string' && /@/.test(value)) return;
    // return 'Enter a valid email.';
    return formatMessage($9690b4deb93b327f$var$messages.validEmail);
}
function $9690b4deb93b327f$export$d7aad9be675cc63d(value, propIntl) {
    const intl = propIntl ? propIntl : $9690b4deb93b327f$var$defaultIntl;
    const { formatMessage: formatMessage } = intl;
    if (typeof value === 'string' && /[0-9]/.test(value)) return;
    // return 'Enter a valid telephone.';
    return formatMessage($9690b4deb93b327f$var$messages.validTelephone);
}
const $9690b4deb93b327f$var$Validators = {
    email: $9690b4deb93b327f$export$7fbbfbca30081d0,
    number: $9690b4deb93b327f$export$7e4aa119212bc614,
    tel: $9690b4deb93b327f$export$d7aad9be675cc63d
};
function $9690b4deb93b327f$export$175ffc4a72fd9f6d(isRequired, type, propIntl) {
    return function Validate(value) {
        const intl = propIntl ? propIntl : $9690b4deb93b327f$var$defaultIntl;
        const { formatMessage: formatMessage } = intl;
        const isEmpty = typeof value === 'string' && value.length === 0;
        if (isRequired && isEmpty) // return 'This field is required.';
        return formatMessage($9690b4deb93b327f$var$messages.requiredFieldMessage);
        if (isEmpty) return;
        const isType = type in $9690b4deb93b327f$var$Validators ? $9690b4deb93b327f$var$Validators[type] : undefined;
        return isType ? isType(value, propIntl) : undefined;
    };
}
const $9690b4deb93b327f$var$messages = (0, $7qGN1.defineMessages)({
    validNumber: {
        id: 'confluence.textfield.validator.number',
        defaultMessage: 'Enter a valid number',
        description: 'Message prompting the user to enter a number in the proper format.'
    },
    validEmail: {
        id: 'confluence.textfield.validator.email',
        defaultMessage: 'Enter a valid email.',
        description: 'Message prompting the user to enter an email address in the proper format.'
    },
    validTelephone: {
        id: 'confluence.textfield.validator.telephone',
        defaultMessage: 'Enter a valid telephone.',
        description: 'Message prompting the user to enter a phone number in the proper format.'
    },
    requiredFieldMessage: {
        id: 'confluence.textfield.validator.required.field.message',
        defaultMessage: 'This field is required.',
        description: 'This message alerts the user that a field is required.'
    }
});

});
parcelRegister("hantM", function(module, exports) {
/*!
 * is-number <https://github.com/jonschlinkert/is-number>
 *
 * Copyright (c) 2014-present, Jon Schlinkert.
 * Released under the MIT License.
 */ 'use strict';
module.exports = function(num) {
    if (typeof num === 'number') return num - num === 0;
    if (typeof num === 'string' && num.trim() !== '') return Number.isFinite ? Number.isFinite(+num) : isFinite(+num);
    return false;
};

});


parcelRegister("4y2Yc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("i8Bdx").then(()=>parcelRequire('fMfeg'));

});


parcelRegister("cUeS9", function(module, exports) {
$parcel$export(module.exports, "ToggleFn", () => $4448fc50bd281031$export$65f25b46bc78faae);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $i3v3M = parcelRequire("i3v3M");
function $4448fc50bd281031$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

const $4448fc50bd281031$var$AKToggle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("jRv7X")).then((module)=>({
            default: module.default
        })));

const $4448fc50bd281031$var$AKField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("de5df")).then((module)=>({
            default: module.Field
        })));
const $4448fc50bd281031$var$wrapperStyles = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
const $4448fc50bd281031$var$labelStyles = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $4448fc50bd281031$var$Toggle = ({ name: name, defaultChecked: defaultChecked, testId: testId, label: label })=>/*#__PURE__*/ (0, $1NIU8.jsx)($4448fc50bd281031$var$AKField, {
        defaultValue: defaultChecked,
        name: name
    }, ({ fieldProps: fieldProps })=>{
        const { onChange: onChange, value: value, id: id, isDisabled: isDisabled, onBlur: onBlur, onFocus: onFocus, name: toggleName } = fieldProps;
        return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $4448fc50bd281031$var$wrapperStyles
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $i3v3M.FormStateChangeNotifier), {
            name: name,
            value: value
        }), /*#__PURE__*/ (0, $1NIU8.jsx)($4448fc50bd281031$var$AKToggle, {
            onChange: onChange,
            isChecked: value,
            size: "large",
            label: label,
            testId: testId,
            id: id,
            isDisabled: isDisabled,
            onBlur: onBlur,
            onFocus: onFocus,
            name: toggleName
        }), /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            css: $4448fc50bd281031$var$labelStyles,
            onClick: ()=>onChange(!value)
        }, label));
    });
var $4448fc50bd281031$export$2e2bcd8739ae039 = $4448fc50bd281031$var$Toggle;
const $4448fc50bd281031$export$65f25b46bc78faae = ({ props: props })=>{
    const { name: name, label: label, defaultChecked: defaultChecked } = props;
    return /*#__PURE__*/ (0, $1NIU8.jsx)($4448fc50bd281031$var$Toggle, {
        name: name,
        label: label,
        defaultChecked: defaultChecked
    });
};

});
parcelRegister("jRv7X", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gAB0r").then(()=>parcelRequire('iavkQ'));

});


parcelRegister("htPkC", function(module, exports) {
$parcel$export(module.exports, "TooltipFn", () => $762dad596637a69c$export$243693318987dcde);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

const $762dad596637a69c$var$AKTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("kMzLg")));
const $762dad596637a69c$var$Tooltip = ({ text: text, children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)($762dad596637a69c$var$AKTooltip, {
        content: text,
        children: children
    });
var $762dad596637a69c$export$2e2bcd8739ae039 = $762dad596637a69c$var$Tooltip;
const $762dad596637a69c$export$243693318987dcde = ({ props: props, children: children, Components: Components, render: render, renderChildren: renderChildren, dispatch: dispatch })=>{
    const { text: text } = props;
    const renderedChildren = renderChildren({
        Components: Components,
        children: children,
        render: render,
        dispatch: dispatch
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)($762dad596637a69c$var$Tooltip, {
        text: text,
        children: Array.isArray(renderedChildren) ? renderedChildren[0] : renderedChildren
    });
};

});
parcelRegister("kMzLg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1sNWi").then(()=>parcelRequire('jJiSi'));

});


parcelRegister("nQCZy", function(module, exports) {
$parcel$export(module.exports, "HeadingFn", () => $60cdbf8747de2e97$export$fad8cd1e3bc5cd8a);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $806LH = parcelRequire("806LH");
function $60cdbf8747de2e97$export$a8a3e93435678ff9({ size: size = 'medium', children: children }) {
    if (size === 'large') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
        size: "xlarge",
        children: children
    });
    if (size === 'small') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
        size: "xsmall",
        children: children
    });
    // size === 'medium'
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
        size: "medium",
        children: children
    });
}
var $60cdbf8747de2e97$export$2e2bcd8739ae039 = $60cdbf8747de2e97$export$a8a3e93435678ff9;
function $60cdbf8747de2e97$export$fad8cd1e3bc5cd8a({ Components: Components, props: props, children: children, renderChildren: renderChildren, dispatch: dispatch, render: render }) {
    const { size: size } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)($60cdbf8747de2e97$export$a8a3e93435678ff9, {
        size: size,
        children: renderChildren({
            Components: Components,
            children: children,
            render: render,
            dispatch: dispatch
        })
    });
}

});

parcelRegister("4Puwt", function(module, exports) {
$parcel$export(module.exports, "upgradeComponent", () => $34b6e9244aa4eeec$export$d3f7e791718dec1c);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $LFmXM = parcelRequire("LFmXM");
const $34b6e9244aa4eeec$export$56cc4e6ad1676196 = (0, $LFmXM.default)((dispatch)=>(legacyEffects)=>{
        return Promise.all((Array.isArray(legacyEffects) ? legacyEffects : [
            legacyEffects
        ]).map((legacyEffect)=>{
            switch(legacyEffect.type){
                case 'initialize':
                    return dispatch({
                        type: 'render',
                        extensionData: {}
                    });
                case 'event':
                    return dispatch({
                        type: 'event',
                        handler: legacyEffect.handler,
                        args: legacyEffect.args,
                        extensionData: {}
                    });
                default:
                    throw Error(`Cannot dispatch "${legacyEffect.type}" effect`);
            }
        })).then(()=>{});
    });
const $34b6e9244aa4eeec$export$d3f7e791718dec1c = (Comp)=>({ forgeDoc: forgeDoc, render: render, dispatch: dispatch })=>{
        const { children: children, key: key, props: props, type: type } = forgeDoc;
        return /*#__PURE__*/ (0, $gt9Am.jsx)(Comp, {
            type: type,
            props: props,
            dispatch: $34b6e9244aa4eeec$export$56cc4e6ad1676196(dispatch),
            children: children,
            Components: {} /* no components actually use this component map */ ,
            render: (props)=>render(props.aux),
            renderChildren: (props)=>props.children.map(render)
        }, key);
    };

});


parcelRegister("cagBP", function(module, exports) {
$parcel$export(module.exports, "Fragment", () => $3eacbd9d290babcc$export$ffb0004e005737fa);
$parcel$export(module.exports, "Root", () => $3eacbd9d290babcc$export$be92b6f5f03c0fe9);
/* internalComponents.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
const $3eacbd9d290babcc$export$ffb0004e005737fa = ({ forgeDoc: forgeDoc, render: render })=>/*#__PURE__*/ (0, $gt9Am.jsx)($eJOHy.Fragment, {
        children: forgeDoc.children.map(render)
    });
const $3eacbd9d290babcc$export$be92b6f5f03c0fe9 = ({ forgeDoc: forgeDoc, render: render })=>{
    const { children: children } = forgeDoc;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_1qhqze3t _1jzaze3t _1bgsze3t _9b1aze3t _cog4ze3t _1gbhze3t"
        ]),
        children: children.map(render)
    });
};

});

parcelRegister("1QT2I", function(module, exports) {
$parcel$export(module.exports, "RendererNext", () => $cca6b9ea9f7d48ab$export$c18f98553e983d72);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
parcelRequire("1B59H");
var $aJjD9 = parcelRequire("aJjD9");

var $fqICx = parcelRequire("fqICx");

var $eGOwo = parcelRequire("eGOwo");

var $5qJVF = parcelRequire("5qJVF");

var $dcekp = parcelRequire("dcekp");

var $fkH7A = parcelRequire("fkH7A");

var $kpjEk = parcelRequire("kpjEk");

var $iHPvF = parcelRequire("iHPvF");

var $kweLG = parcelRequire("kweLG");

var $6FaCM = parcelRequire("6FaCM");
const $cca6b9ea9f7d48ab$export$7a0a827f8287b06d = (componentType, forgeEnvironment)=>{
    if (forgeEnvironment === 'PRODUCTION') return;
    if (componentType === 'Heading') (0, $kweLG.default)(`[@forge/react: Heading] Warning: The functionality of the "as" prop is being updated and should no longer be used to determine heading sizes. To avoid breaking changes, migrate to using the "size" prop. For more details, visit: https://atlassian.design/components/heading`);
};
const $cca6b9ea9f7d48ab$export$21a8719ce41a1de2 = (componentMap, componentType)=>{
    if (componentType === 'User' || componentType === 'Avatar') return componentMap['User'] || componentMap['Avatar'];
    if (componentType === 'UserGroup' || componentType === 'AvatarStack') return componentMap['UserGroup'] || componentMap['AvatarStack'];
    return componentMap[componentType];
};
const $cca6b9ea9f7d48ab$var$isAlignFormButtonsEnd = (extensionType, forgeDoc)=>{
    // Confluence Byline and ContextMenu Forge apps with a Form component as
    // there only child shifts the form buttons to the end in the footer
    return (extensionType === (0, $aJjD9.ConfluenceExtension).BYLINE || extensionType === (0, $aJjD9.ConfluenceExtension).CONTEXT_MENU) && forgeDoc.children[0]?.type === 'Form';
};
const $cca6b9ea9f7d48ab$var$forgeDocWithModalComponent = (forgeDoc, modalExtension)=>{
    const { closeModalExtension: closeModalExtension, title: title, modalWidth: modalWidth, onSubmitSuccess: onSubmitSuccess } = modalExtension;
    // ModalDialog component sets the default width to `medium`
    const akModalWidth = modalWidth ? (0, $dcekp.getADSModalWidth)(modalWidth) : undefined;
    const forgeDocWithModal = {
        ...forgeDoc,
        children: [
            {
                type: 'ModalDialog',
                props: {
                    onClose: closeModalExtension,
                    header: title,
                    width: akModalWidth,
                    onSubmitSuccess: onSubmitSuccess
                },
                children: forgeDoc.children
            }
        ]
    };
    return forgeDocWithModal;
};
const $cca6b9ea9f7d48ab$var$forgeDocWithFormEndButtons = (forgeDoc)=>{
    if (forgeDoc.children.length === 0) return forgeDoc;
    return {
        ...forgeDoc,
        children: [
            {
                ...forgeDoc.children[0],
                props: {
                    ...forgeDoc.children[0].props,
                    alignFooterButtons: 'end'
                }
            }
        ]
    };
};
const $cca6b9ea9f7d48ab$export$c18f98553e983d72 = ({ forgeDoc: forgeDoc, loading: loading = false, error: error, customRenderErrorFn: customRenderErrorFn, components: components, dispatch: dispatch, modalExtension: modalExtension, extensionType: extensionType, isNative: isNative, onSuccess: onSuccess, client: client, extension: extension })=>{
    const { forgeEnvironment: forgeEnvironment } = (0, $eJOHy.useContext)((0, $kpjEk.RendererContext));
    (0, $fkH7A.useSendNodeCountAnalytics)({
        forgeDoc: forgeDoc,
        forgeEnvironment: forgeEnvironment ?? 'DEVELOPMENT',
        UIKitVersion: isNative ? '2' : '1'
    });
    const render = (forgeDoc)=>{
        $cca6b9ea9f7d48ab$export$7a0a827f8287b06d(forgeDoc.type, forgeEnvironment ?? 'DEVELOPMENT');
        const renderFn = $cca6b9ea9f7d48ab$export$21a8719ce41a1de2(components, forgeDoc.type);
        if (!renderFn) {
            if (customRenderErrorFn) customRenderErrorFn(forgeDoc.type);
            else throw new Error(`Error rendering app - encountered unknown component ${forgeDoc.type}.`);
        }
        onSuccess && onSuccess();
        return renderFn({
            forgeDoc: forgeDoc,
            dispatch: dispatch,
            render: render
        });
    };
    if (error) return modalExtension ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6FaCM.ForgeExtensionPointModal), {
        modalExtension: modalExtension,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iHPvF.default), {
            title: "Something went wrong",
            appearance: "error",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                children: error
            })
        })
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iHPvF.default), {
        title: "Something went wrong",
        appearance: "error",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
            children: error
        })
    });
    if (!forgeDoc) return null;
    // Extensions rendered in a modal for version 10 and onwards are handled here.
    // This is the default behavior for handles model extensions across product modules.
    // When the modelExtension prop is present, and the forgeReactMajorVersion is 10 or higher,
    // the provided foreDoc is rendered within a Modal component with the provided modalExtension props.
    // This setup is to ensure that the modal extension is rendered correctly across all product modules,
    // and is the resolution for the HOT described in: https://ops.internal.atlassian.com/jira/browse/HOT-108146
    if (forgeDoc.forgeReactMajorVersion && forgeDoc.forgeReactMajorVersion >= 10 && modalExtension) {
        const isFirstChildAForm = forgeDoc.children[0]?.type === 'Form';
        const { onSubmitSuccess: onSubmitSuccess } = modalExtension;
        // injects onSubmitSuccess to into the Form component submit handler
        if (isFirstChildAForm) {
            // doing a deep clone here to make a copy of onSubmit
            const formPropsCopy = (0, (/*@__PURE__*/$parcel$interopDefault($fqICx)))(forgeDoc.children[0].props);
            forgeDoc.children[0].props = {
                ...formPropsCopy,
                onSubmit: async ()=>{
                    const isSuccess = await formPropsCopy.onSubmit();
                    if (onSubmitSuccess && (isSuccess === true || isSuccess === undefined)) onSubmitSuccess();
                }
            };
        }
        const shouldShowFCFModalDeprecationMessage = (extensionType === (0, $aJjD9.JiraExtension).CUSTOM_FIELD || extensionType === (0, $aJjD9.JiraExtension).CUSTOM_FIELD_TYPE) && !(0, $eGOwo.fg)('forge_disable_fcf_modal_experience_on_issue_view');
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6FaCM.ForgeExtensionPointModal), {
            modalExtension: modalExtension,
            shouldShowFCFModalDeprecationMessage: shouldShowFCFModalDeprecationMessage,
            client: client,
            extension: extension,
            children: render(forgeDoc)
        });
    }
    const newForgeDoc = extensionType && $cca6b9ea9f7d48ab$var$isAlignFormButtonsEnd(extensionType, forgeDoc) ? $cca6b9ea9f7d48ab$var$forgeDocWithFormEndButtons(forgeDoc) : forgeDoc;
    const extensionForgeDoc = modalExtension ? $cca6b9ea9f7d48ab$var$forgeDocWithModalComponent(newForgeDoc, modalExtension) : newForgeDoc;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: render(extensionForgeDoc)
    });
};

});
parcelRegister("dcekp", function(module, exports) {
$parcel$export(module.exports, "getADSModalWidth", () => $fe889bd11edeb456$export$2d5db5bd91fc0e);
const $fe889bd11edeb456$export$2d5db5bd91fc0e = (modalSize)=>{
    switch(modalSize){
        case 'xlarge':
            return 'x-large';
        case 'max':
            return '100%';
        default:
            return modalSize;
    }
};

});

parcelRegister("fkH7A", function(module, exports) {
$parcel$export(module.exports, "useSendNodeCountAnalytics", () => $d5cbdd0ce0455e50$export$a0feef3ec4af33b4);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $cOZrT = parcelRequire("cOZrT");

var $6yq62 = parcelRequire("6yq62");
const $d5cbdd0ce0455e50$export$5f39eab89195003c = (doc, componentCountMap)=>{
    if (!doc.props) return;
    Object.keys(doc.props).forEach((propName)=>{
        if (propName === 'children') return;
        const componentName = doc.type;
        if (componentCountMap[componentName].propCount[propName] !== undefined) componentCountMap[componentName].propCount[propName] += 1;
        else componentCountMap[componentName].propCount[propName] = 1;
    });
};
const $d5cbdd0ce0455e50$var$getIconInformation = (doc, componentCountMap)=>{
    if (doc.type !== 'Icon' || !doc.props) return;
    const { glyph: glyph, primaryColor: primaryColor, secondaryColor: secondaryColor } = doc.props;
    if (!componentCountMap.Icon.uniqueGlyphs) componentCountMap.Icon.uniqueGlyphs = new Set();
    if (glyph) componentCountMap.Icon.uniqueGlyphs.add(glyph);
    // TODO: Stop tracking these props once they have been removed from the code base
    // https://ecosystem-platform.atlassian.net/browse/EXT-3350
    if (!componentCountMap.Icon.deprecatedPropsList) componentCountMap.Icon.deprecatedPropsList = new Set();
    if (primaryColor) componentCountMap.Icon.deprecatedPropsList.add('primaryColor');
    if (secondaryColor) componentCountMap.Icon.deprecatedPropsList.add('secondaryColor');
};
// Recursive function to get the total number of components and total number of props on a component
const $d5cbdd0ce0455e50$var$getCountAnalytics = (forgeDoc, componentCountMap = {}, visitors = [])=>{
    const componentName = forgeDoc.type;
    // Type String is not a component
    if (componentName === 'String') return componentCountMap;
    // Don't send Root count as it's always one
    if (componentName !== 'Root') {
        const hasComponentEncountered = componentCountMap[componentName] !== undefined;
        if (hasComponentEncountered) componentCountMap[componentName].componentCount += 1;
        else componentCountMap[componentName] = {
            componentCount: 1,
            propCount: {}
        };
        // Call all visitor functions
        visitors.forEach((visitor)=>{
            visitor(forgeDoc, componentCountMap);
        });
    }
    forgeDoc.children.forEach((forgeDocChild)=>{
        $d5cbdd0ce0455e50$var$getCountAnalytics(forgeDocChild, componentCountMap, visitors);
    });
    return componentCountMap;
};
const $d5cbdd0ce0455e50$var$createKey = (countMap)=>{
    let key = '';
    Object.keys(countMap).sort().forEach((componentName)=>{
        key += `${componentName}${countMap[componentName].componentCount}`;
    });
    return key;
};
const $d5cbdd0ce0455e50$export$a0feef3ec4af33b4 = ({ forgeDoc: forgeDoc, forgeEnvironment: forgeEnvironment, UIKitVersion: UIKitVersion })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { page: source } = (0, $6yq62.useMetricsContext)();
    const prevCountMap = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef({});
    if (forgeDoc === undefined) return;
    const componentCount = $d5cbdd0ce0455e50$var$getCountAnalytics(forgeDoc, {}, [
        $d5cbdd0ce0455e50$export$5f39eab89195003c,
        $d5cbdd0ce0455e50$var$getIconInformation
    ]);
    const componentCountAsKey = $d5cbdd0ce0455e50$var$createKey(componentCount);
    // converting to a string here as a safety measure against mutations to the original forgeDoc object
    const forgeReactMajorVersion = forgeDoc.forgeReactMajorVersion?.toString() ?? null;
    // compare if a previous count has already been sent for analytics
    if (!prevCountMap.current.hasOwnProperty(componentCountAsKey)) {
        prevCountMap.current = {
            ...prevCountMap.current,
            [componentCountAsKey]: true
        };
        // NOTE: createAnalyticsEvent has a side effect of potentially mutating objects that are passed into it
        // Any objects passed in should not be reused or must be deep cloned first
        const components = {};
        for(let componentName in componentCount)if (componentName === 'Icon') components[componentName] = {
            count: componentCount[componentName].componentCount,
            propCount: componentCount[componentName].propCount,
            uniqueGlyphs: Array.from(componentCount[componentName].uniqueGlyphs ?? []),
            deprecatedPropsList: Array.from(componentCount[componentName].deprecatedPropsList ?? [])
        };
        else components[componentName] = {
            count: componentCount[componentName].componentCount,
            propCount: componentCount[componentName].propCount
        };
        (0, $cOZrT.trackComponentUsageRendered)(createAnalyticsEvent, {
            source: source,
            isLegacyUiKit: UIKitVersion === '1',
            forgeEnvironment: forgeEnvironment,
            components: components,
            forgeReactMajorVersion: forgeReactMajorVersion
        });
    }
};

});

parcelRegister("6FaCM", function(module, exports) {
$parcel$export(module.exports, "ForgeExtensionPointModal", () => $e297d6f23f391591$export$bf4fcca1fb0dca1e);
/* ForgeExtensionPointModal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $6J9k6 = parcelRequire("6J9k6");

var $gHHv2 = parcelRequire("gHHv2");
var $ik0CA = parcelRequire("ik0CA");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $b3nvV = parcelRequire("b3nvV");

var $8IeH1 = parcelRequire("8IeH1");
var $78OnL = parcelRequire("78OnL");

var $ej6lz = parcelRequire("ej6lz");

var $dcekp = parcelRequire("dcekp");

var $eGOwo = parcelRequire("eGOwo");
const $e297d6f23f391591$var$styles = {
    modalWrapper: "_n3td1ejb"
};
const $e297d6f23f391591$var$ModalWrapper = (props)=>{
    const { closeModalExtension: closeModalExtension, width: width, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress } = props;
    if (width === 'fullscreen' && (0, $eGOwo.fg)('platform_add_modal_support_to_bylineitem_extension')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b3nvV.FullScreenModalDialog), {
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        onClose: closeModalExtension,
        children: props.children
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gHHv2.default), {
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        onClose: closeModalExtension,
        width: width,
        children: props.children
    });
};
const $e297d6f23f391591$export$bf4fcca1fb0dca1e = ({ children: children, modalExtension: modalExtension, shouldShowFCFModalDeprecationMessage: shouldShowFCFModalDeprecationMessage, client: client, extension: extension })=>{
    const { closeModalExtension: closeModalExtension, title: title, modalWidth: modalWidth, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress } = modalExtension;
    const ADSModalWidth = modalWidth ? (0, $dcekp.getADSModalWidth)(modalWidth) : undefined;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)($e297d6f23f391591$var$ModalWrapper, {
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        closeModalExtension: closeModalExtension,
        width: ADSModalWidth,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $2qG7I.default), {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5a9Ro.default), {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                        appearance: "subtle",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6J9k6))),
                        label: "Close Modal",
                        onClick: closeModalExtension
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ik0CA.default), {
                children: shouldShowFCFModalDeprecationMessage && extension && client ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                    space: "space.200",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ej6lz.ForgeModalDeprecationMessage), {
                            client: client,
                            extension: extension
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                            xcss: $e297d6f23f391591$var$styles.modalWrapper,
                            children: children
                        })
                    ]
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    xcss: $e297d6f23f391591$var$styles.modalWrapper,
                    children: children
                })
            })
        ]
    });
};

});


parcelRegister("4ZfiI", function(module, exports) {
$parcel$export(module.exports, "importMapMemo", () => $66f4817a489ad69c$export$954661e84fee40f6);

var $eJOHy = parcelRequire("eJOHy");

var $iQWV3 = parcelRequire("iQWV3");
var $gHU71 = parcelRequire("gHU71");
var $eM6RF = parcelRequire("eM6RF");
var $554by = parcelRequire("554by");
var $8fgfE = parcelRequire("8fgfE");
var $jcnYX = parcelRequire("jcnYX");
var $2NKTO = parcelRequire("2NKTO");
var $dDkXW = parcelRequire("dDkXW");
var $ahoNd = parcelRequire("ahoNd");
var $43wzl = parcelRequire("43wzl");
var $9lJqz = parcelRequire("9lJqz");
var $bYyH2 = parcelRequire("bYyH2");
var $7aicR = parcelRequire("7aicR");
var $jjGAp = parcelRequire("jjGAp");
var $2EmTa = parcelRequire("2EmTa");
var $1vOwE = parcelRequire("1vOwE");
var $1JS9A = parcelRequire("1JS9A");
var $lfmiP = parcelRequire("lfmiP");
var $6boT6 = parcelRequire("6boT6");
var $2VICx = parcelRequire("2VICx");
var $i14JQ = parcelRequire("i14JQ");
var $expKe = parcelRequire("expKe");
var $ewtb5 = parcelRequire("ewtb5");
var $ef4Xa = parcelRequire("ef4Xa");
var $cD3pl = parcelRequire("cD3pl");
var $iRtff = parcelRequire("iRtff");
var $1jJ11 = parcelRequire("1jJ11");
var $96r6J = parcelRequire("96r6J");
var $3iGWx = parcelRequire("3iGWx");
var $gzuLh = parcelRequire("gzuLh");
var $jePLG = parcelRequire("jePLG");
var $4N3qz = parcelRequire("4N3qz");
var $ejoUA = parcelRequire("ejoUA");
var $8i2Q3 = parcelRequire("8i2Q3");
var $lejfd = parcelRequire("lejfd");
var $d5oRz = parcelRequire("d5oRz");
var $lArQs = parcelRequire("lArQs");
var $c9GiM = parcelRequire("c9GiM");
var $bTGrp = parcelRequire("bTGrp");
var $kAv0k = parcelRequire("kAv0k");
var $adx0N = parcelRequire("adx0N");
var $97FvP = parcelRequire("97FvP");
var $ir6Lo = parcelRequire("ir6Lo");
var $9p7FN = parcelRequire("9p7FN");
var $a71Pf = parcelRequire("a71Pf");
var $f1JOx = parcelRequire("f1JOx");
var $6w9NU = parcelRequire("6w9NU");
var $befiz = parcelRequire("befiz");
var $7urwA = parcelRequire("7urwA");
var $3lTFF = parcelRequire("3lTFF");
var $9NmWB = parcelRequire("9NmWB");
var $50DNI = parcelRequire("50DNI");
var $3KcxV = parcelRequire("3KcxV");
var $1YFAh = parcelRequire("1YFAh");
var $68m2D = parcelRequire("68m2D");
var $pec4g = parcelRequire("pec4g");
var $4hJhN = parcelRequire("4hJhN");
var $6NjIV = parcelRequire("6NjIV");
var $5O40n = parcelRequire("5O40n");
var $h2oYB = parcelRequire("h2oYB");
var $cefYx = parcelRequire("cefYx");
var $3FS7N = parcelRequire("3FS7N");
var $3oQzb = parcelRequire("3oQzb");
var $4xqqE = parcelRequire("4xqqE");
var $2FRLC = parcelRequire("2FRLC");
var $eqXEa = parcelRequire("eqXEa");
var $1Mlgx = parcelRequire("1Mlgx");
var $1pn5e = parcelRequire("1pn5e");
var $1amvD = parcelRequire("1amvD");

var $bEvoj = parcelRequire("bEvoj");
const $66f4817a489ad69c$export$7cbf6225478f6479 = {
    Badge: $gHU71.Badge,
    Box: $eM6RF.Box,
    Button: $554by.Button,
    ButtonGroup: $8fgfE.ButtonGroup,
    Calendar: $jcnYX.Calendar,
    Checkbox: $2NKTO.Checkbox,
    CheckboxGroup: $dDkXW.CheckboxGroup,
    Code: $ahoNd.Code,
    CodeBlock: $43wzl.CodeBlock,
    Comment: $9lJqz.Comment,
    DatePicker: $bYyH2.DatePicker,
    DynamicTable: $7aicR.DynamicTable,
    EmptyState: $jjGAp.EmptyState,
    ErrorMessage: $2EmTa.ErrorMessage,
    Flex: $lfmiP.Flex,
    FileCard: $1vOwE.FileCard,
    Form: $6boT6.Form,
    FormFooter: $2VICx.FormFooter,
    FormHeader: $i14JQ.FormHeader,
    FormSection: $expKe.FormSection,
    Grid: $ewtb5.Grid,
    Heading: $ef4Xa.Heading,
    HelperMessage: $cD3pl.HelperMessage,
    Icon: $iRtff.Icon,
    Inline: $96r6J.Inline,
    InlineEdit: $3iGWx.InlineEdit,
    Label: $gzuLh.Label,
    LinkButton: $4N3qz.LinkButton,
    List: $ejoUA.List,
    ListItem: $8i2Q3.ListItem,
    LoadingButton: $lejfd.LoadingButton,
    Lozenge: $d5oRz.Lozenge,
    Modal: $lArQs.Modal,
    ModalBody: $c9GiM.ModalBody,
    ModalFooter: $bTGrp.ModalFooter,
    ModalHeader: $kAv0k.ModalHeader,
    ModalTitle: $adx0N.ModalTitle,
    ModalTransition: $97FvP.ModalTransition,
    Popup: $ir6Lo.Popup,
    Pressable: $9p7FN.Pressable,
    ProgressBar: $a71Pf.ProgressBar,
    ProgressTracker: $f1JOx.ProgressTracker,
    Radio: $6w9NU.Radio,
    RadioGroup: $befiz.RadioGroup,
    Range: $7urwA.Range,
    RequiredAsterisk: $3lTFF.RequiredAsterisk,
    SectionMessage: $9NmWB.SectionMessage,
    SectionMessageAction: $50DNI.SectionMessageAction,
    Select: $3KcxV.Select,
    Spinner: $1YFAh.Spinner,
    Stack: $68m2D.Stack,
    Tab: $4hJhN.Tab,
    TabList: $6NjIV.TabList,
    TabPanel: $5O40n.TabPanel,
    Tabs: $h2oYB.Tabs,
    Tag: $cefYx.SimpleTag,
    TagGroup: $3FS7N.TagGroup,
    TextArea: $4xqqE.TextArea,
    Textfield: $2FRLC.Textfield,
    TimePicker: $eqXEa.TimePicker,
    Toggle: $1Mlgx.Toggle,
    Tooltip: $1pn5e.Tooltip,
    ValidMessage: $1amvD.ValidMessage,
    AdfRenderer: $iQWV3.AdfRenderer,
    Image: $1jJ11.Image,
    Link: $jePLG.Link,
    Text: $3oQzb.PatchedText,
    Strong: $pec4g.Strong,
    FilePicker: $1JS9A.FilePicker
};
const $66f4817a489ad69c$export$954661e84fee40f6 = Object.entries($66f4817a489ad69c$export$7cbf6225478f6479).reduce((agg, [key, Component])=>{
    agg[key] = (0, $eJOHy.memo)(Component, (0, $bEvoj.forgePropsAreEqual));
    return agg;
}, {});

});
parcelRegister("iQWV3", function(module, exports) {
$parcel$export(module.exports, "AdfRenderer", () => $64a8c7207f9db1b1$export$c334f442ba514f7d);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ix0Ab = parcelRequire("ix0Ab");

var $0mclG = parcelRequire("0mclG");

var $4Z9bh = parcelRequire("4Z9bh");

var $3cc2J = parcelRequire("3cc2J");

var $MyJAf = parcelRequire("MyJAf");

var $kpjEk = parcelRequire("kpjEk");

var $dRcl3 = parcelRequire("dRcl3");

var $1gAFw = parcelRequire("1gAFw");

var $asA27 = parcelRequire("asA27");

var $aWpPf = parcelRequire("aWpPf");
const $64a8c7207f9db1b1$var$filterInvalidMediaUrls = (appDomainName, egressServices, document)=>{
    const invalidUrls = new Set();
    const visitors = {
        media: (node)=>{
            const url = node?.attrs?.url;
            if (url && !egressServices.some((service)=>(0, $1gAFw.isValidImageUrl)(url, service, appDomainName))) {
                invalidUrls.add(url);
                return {
                    ...node,
                    attrs: {
                        ...node.attrs,
                        // Remove the URL so it fails to load
                        // We use a space because an empty string causes an infinite loading spinner
                        url: ' '
                    }
                };
            }
        }
    };
    const filteredDocument = (0, $0mclG.traverse)(document, visitors);
    return {
        filteredDocument: filteredDocument ? filteredDocument : document,
        invalidUrls: Array.from(invalidUrls)
    };
};
const $64a8c7207f9db1b1$var$useSupportsMedia = ()=>{
    try {
        (0, $3cc2J.useMediaClient)();
        return true;
    } catch (e) {
        // Throws if no MediaClientProvider is found
        return false;
    }
};
const $64a8c7207f9db1b1$export$c334f442ba514f7d = (props)=>{
    const supportsMedia = $64a8c7207f9db1b1$var$useSupportsMedia();
    const { egress: egress, properties: properties, appDomainName: appDomainName, forgeEnvironment: forgeEnvironment } = (0, $eJOHy.useContext)((0, $kpjEk.RendererContext));
    const imagesEgressService = (0, $dRcl3.useEgressPermissionService)('IMAGES', egress);
    const mediaEgressService = (0, $dRcl3.useEgressPermissionService)('MEDIA', egress);
    const egressServices = [
        imagesEgressService,
        mediaEgressService
    ];
    const { onNavigate: onNavigate, getModalJsx: getModalJsx } = (0, $asA27.useNavigation)({
        extension: {
            egress: egress,
            properties: properties
        }
    });
    const { document: document, documentWithoutMedia: documentWithoutMedia, ...adfRendererProps } = props.forgeDoc.props;
    // The client provides both the document with media and without media, as it doesn't know whether the MediaClientProvider is present
    // Then, in the parent product, we can decide whether to render the document with media or without media
    const doc = !supportsMedia && documentWithoutMedia ? documentWithoutMedia : document;
    const { filteredDocument: filteredDocument, invalidUrls: invalidUrls } = $64a8c7207f9db1b1$var$filterInvalidMediaUrls(appDomainName, egressServices, doc);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            forgeEnvironment === 'DEVELOPMENT' && invalidUrls.map((url)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $MyJAf.EgressErrorMessage), {
                    url: url
                }, url)),
            getModalJsx(),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Z9bh.RendererActionsContext), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ix0Ab.default), {
                    ...adfRendererProps,
                    eventHandlers: {
                        link: {
                            onClick: (e)=>{
                                e.preventDefault();
                                adfRendererProps?.eventHandlers?.link?.onClick?.(e, e.currentTarget.href);
                                onNavigate({
                                    type: 'same-tab',
                                    url: (0, $aWpPf.sanitizeUrl)(e.currentTarget.href)
                                });
                            }
                        }
                    },
                    document: filteredDocument
                })
            })
        ]
    });
};

});
parcelRegister("ix0Ab", function(module, exports) {
$parcel$export(module.exports, "default", () => $7653122e837526a6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8DB98 = parcelRequire("8DB98");

var $1RDZV = parcelRequire("1RDZV");
var $6Ramj = parcelRequire("6Ramj");

var $iZVrE = parcelRequire("iZVrE");
var $jjlK8 = parcelRequire("jjlK8");
var $93FVZ = parcelRequire("93FVZ");
var $2bEPZ = parcelRequire("2bEPZ");
var $lilfD = parcelRequire("lilfD");

var $92xoS = parcelRequire("92xoS");

var $1NIU8 = parcelRequire("1NIU8");

var $7EdFW = parcelRequire("7EdFW");

var $hvjqZ = parcelRequire("hvjqZ");

var $65rqJ = parcelRequire("65rqJ");

var $Sk9g1 = parcelRequire("Sk9g1");

var $dyNYh = parcelRequire("dyNYh");
var $LjYWw = parcelRequire("LjYWw");

var $eGOwo = parcelRequire("eGOwo");

var $bgewf = parcelRequire("bgewf");

var $eUaD0 = parcelRequire("eUaD0");

var $bMFKb = parcelRequire("bMFKb");

var $jgFE8 = parcelRequire("jgFE8");

var $8KLBw = parcelRequire("8KLBw");

var $aYybS = parcelRequire("aYybS");
var $fjfmN = parcelRequire("fjfmN");

var $bdjbf = parcelRequire("bdjbf");

var $7ueoK = parcelRequire("7ueoK");

var $4SRvD = parcelRequire("4SRvD");

var $iOvh6 = parcelRequire("iOvh6");

var $RTnFt = parcelRequire("RTnFt");

var $g9wjI = parcelRequire("g9wjI");

var $4Z9bh = parcelRequire("4Z9bh");

var $dZ1mQ = parcelRequire("dZ1mQ");

var $jzI2h = parcelRequire("jzI2h");

var $csUn2 = parcelRequire("csUn2");

var $7DXmb = parcelRequire("7DXmb");

var $khi07 = parcelRequire("khi07");

var $hQy2y = parcelRequire("hQy2y");

var $86V7W = parcelRequire("86V7W");


var $fC4S5 = parcelRequire("fC4S5");

var $2uPUs = parcelRequire("2uPUs");

var $bVKVd = parcelRequire("bVKVd");

var $c3ajv = parcelRequire("c3ajv");

var $goISJ = parcelRequire("goISJ");

var $8AF0U = parcelRequire("8AF0U");

var $jWNZR = parcelRequire("jWNZR");

var $9Letn = parcelRequire("9Letn");

var $cbSL1 = parcelRequire("cbSL1");

var $53NHC = parcelRequire("53NHC");
function $7653122e837526a6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7653122e837526a6$export$47b2879ca9bbf67a = 2000;
const $7653122e837526a6$export$1b622068be977101 = 3000;
// we want to calculate all the table widths (which causes reflows) after the renderer has finished loading to mitigate performance impact
const $7653122e837526a6$var$TABLE_WIDTH_INFO_TIMEOUT = 10000;
const $7653122e837526a6$var$packageName = "platform-pkg";
const $7653122e837526a6$var$packageVersion = "0.0.0-use.local";
const $7653122e837526a6$var$setAsQueryContainerStyles = {
    name: "3qfej8",
    styles: "container-name:ak-renderer-wrapper;container-type:inline-size"
};
const $7653122e837526a6$var$handleMouseTripleClickInTables = (event)=>{
    const browser = (0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $7EdFW.getBrowserInfo)() : (0, $7EdFW.browser);
    if (browser.ios || browser.android) return;
    const badBrowser = browser.chrome || browser.safari;
    const tripleClick = event.detail >= 3;
    if (!(badBrowser && tripleClick)) return;
    const selection = window.getSelection();
    if (!selection) return;
    const { type: type, anchorNode: anchorNode, focusNode: focusNode } = selection;
    const rangeSelection = Boolean(type === 'Range' && anchorNode && focusNode);
    if (!rangeSelection) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const target = event.target;
    const tableCell = target.closest('td,th');
    const clickedInCell = Boolean(tableCell);
    if (!clickedInCell) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const anchorInCell = tableCell.contains(anchorNode);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const focusInCell = tableCell.contains(focusNode);
    const selectionStartsOrEndsOutsideClickedCell = !(anchorInCell && focusInCell);
    if (!selectionStartsOrEndsOutsideClickedCell) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    const elementToSelect = anchorInCell ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    anchorNode.parentElement?.closest('div,p') : focusInCell ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    focusNode.parentElement?.closest('div,p') : tableCell;
    if (elementToSelect) selection.selectAllChildren(elementToSelect);
};
/**
 * Handle clicks inside renderer. If the click isn't on media, in the media picker, or on a
 * link, call the onUnhandledClick eventHandler (which in Jira for example, may switch the
 * renderer out for the editor).
 * @param event Click event anywhere inside renderer
 * @param props
 * @param mouseDownSelection
 * @example
 */ const $7653122e837526a6$var$handleWrapperOnClick = (event, props, mouseDownSelection)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const targetElement = event.target;
    $7653122e837526a6$var$handleMouseTripleClickInTables(event);
    // ED-14862: When a user triple clicks to select a line of content inside a
    // a table cell, but the browser incorrectly moves the selection start or end into
    // a different table cell, we manually set the selection back to within the original
    // table cell the user intended to target
    if (!props.eventHandlers?.onUnhandledClick) return;
    if (!(targetElement instanceof window.Element)) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const rendererWrapper = event.currentTarget;
    const isInteractiveElementInTree = (0, $g9wjI.findInTree)(targetElement, rendererWrapper, (0, $hQy2y.isInteractiveElement));
    if (isInteractiveElementInTree) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    const windowSelection = window.getSelection();
    const selection = windowSelection !== null ? windowSelection.toString() : undefined;
    const hasSelection = selection && selection.length !== 0;
    const hasSelectionMouseDown = mouseDownSelection.current && mouseDownSelection.current.length !== 0;
    const allowEditBasedOnSelection = !hasSelection && !hasSelectionMouseDown;
    if (allowEditBasedOnSelection) props.eventHandlers.onUnhandledClick(event);
};
const $7653122e837526a6$export$c49fe2316038f3c2 = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = props;
    const mouseDownSelection = (0, $eJOHy.useRef)(undefined);
    const providerFactory = (0, $eJOHy.useMemo)(()=>props.dataProviders || new (0, $1RDZV.default)(), [
        props.dataProviders
    ]);
    const { contentMode: parentContextContentMode } = (0, $RTnFt.useRendererContext)();
    const createRendererContext = (0, $eJOHy.useMemo)(()=>(featureFlags, isTopLevelRenderer, contentMode)=>{
            const normalizedFeatureFlags = (0, $jgFE8.normalizeFeatureFlags)(featureFlags);
            return {
                featureFlags: normalizedFeatureFlags,
                isTopLevelRenderer: isTopLevelRenderer === undefined,
                ...(0, $eGOwo.fg)('platform_editor_content_mode_render_context') && {
                    contentMode: contentMode || parentContextContentMode
                }
            };
        }, [
        parentContextContentMode
    ]);
    const fireAnalyticsEventOld = (0, $eJOHy.useCallback)((event)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = props;
        if (createAnalyticsEvent) {
            const channel = (0, $bgewf.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }, [
        props
    ]);
    const fireAnalyticsEventNew = (0, $eJOHy.useCallback)((event)=>{
        if (createAnalyticsEvent) {
            const channel = (0, $bgewf.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }, [
        createAnalyticsEvent
    ]);
    const fireAnalyticsEvent = (0, $92xoS.editorExperiment)('platform_renderer_fix_analytics_memo_callback', true, {
        exposure: true
    }) ? fireAnalyticsEventNew : fireAnalyticsEventOld;
    const deriveSerializerProps = (0, $eJOHy.useCallback)((props)=>{
        const stickyHeaders = props.stickyHeaders ? props.stickyHeaders === true ? {} : props.stickyHeaders : undefined;
        const { annotationProvider: annotationProvider } = props;
        const allowAnnotationsDraftMode = Boolean(annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.allowDraftMode);
        const { featureFlags: featureFlags } = createRendererContext(props.featureFlags, props.isTopLevelRenderer, props.contentMode);
        return {
            startPos: props.startPos ?? 0,
            providers: providerFactory,
            eventHandlers: props.eventHandlers,
            extensionHandlers: props.extensionHandlers,
            portal: props.portal,
            objectContext: {
                adDoc: props.shouldRemoveEmptySpaceAroundContent ? (0, $goISJ.removeEmptySpaceAroundContent)(props.document) : props.document,
                schema: props.schema,
                ...props.rendererContext
            },
            appearance: props.appearance,
            contentMode: props.contentMode,
            disableHeadingIDs: props.disableHeadingIDs,
            disableActions: props.disableActions,
            allowHeadingAnchorLinks: props.allowHeadingAnchorLinks,
            allowColumnSorting: props.allowColumnSorting,
            fireAnalyticsEvent: fireAnalyticsEvent,
            shouldOpenMediaViewer: props.shouldOpenMediaViewer,
            allowAltTextOnImages: props.allowAltTextOnImages,
            stickyHeaders: stickyHeaders,
            allowMediaLinking: props.media && props.media.allowLinking,
            surroundTextNodesWithTextWrapper: allowAnnotationsDraftMode,
            media: props.media,
            emojiResourceConfig: props.emojiResourceConfig,
            smartLinks: props.smartLinks,
            extensionViewportSizes: props.extensionViewportSizes,
            getExtensionHeight: props.getExtensionHeight,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowAnnotations: props.allowAnnotations,
            allowSelectAllTrap: props.allowSelectAllTrap,
            allowPlaceholderText: props.allowPlaceholderText,
            nodeComponents: props.nodeComponents,
            allowWindowedCodeBlock: featureFlags?.allowWindowedCodeBlock,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            isPresentational: props.UNSTABLE_isPresentational,
            textHighlighter: props.textHighlighter || props.UNSTABLE_textHighlighter,
            allowTableAlignment: props.UNSTABLE_allowTableAlignment,
            allowTableResizing: props.UNSTABLE_allowTableResizing,
            disableTableOverflowShadow: props.disableTableOverflowShadow
        };
    }, [
        createRendererContext,
        providerFactory,
        fireAnalyticsEvent
    ]);
    const serializer = (0, $8AF0U.useMemoFromPropsDerivative)((serializerProps)=>props.createSerializer?.(serializerProps) ?? new (0, $aYybS.default)(serializerProps), deriveSerializerProps, props);
    const localRef = (0, $eJOHy.useRef)(null);
    const editorRef = props.innerRef || localRef;
    const id = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))(), []);
    const renderedMeasurementDistortedDurationMonitor = (0, $eJOHy.useMemo)(()=>(0, $65rqJ.getDistortedDurationMonitor)(), []);
    // we are doing this to ensure it runs as
    // early as possible in the React lifecycle
    // to avoid any other side effects
    const measureStarted = (0, $eJOHy.useRef)(false);
    const startAnalyticsMeasure = ()=>{
        (0, $hvjqZ.startMeasure)(`Renderer Render Time: ${id}`);
    };
    if (!measureStarted.current) {
        startAnalyticsMeasure();
        measureStarted.current = true;
    }
    const anchorLinkAnalytics = (0, $eJOHy.useCallback)(()=>{
        const hash = window.location.hash && decodeURIComponent(window.location.hash.slice(1));
        const disableHeadingIDs = props.disableHeadingIDs;
        if (!disableHeadingIDs && hash && editorRef && editorRef.current instanceof HTMLElement) {
            const anchorLinkElement = document.getElementById(hash);
            if (anchorLinkElement && editorRef.current.contains(anchorLinkElement)) fireAnalyticsEvent({
                action: (0, $bMFKb.ACTION).VIEWED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).ANCHOR_LINK,
                attributes: {
                    platform: (0, $7ueoK.PLATFORM).WEB,
                    mode: (0, $7ueoK.MODE).RENDERER
                },
                eventType: (0, $bMFKb.EVENT_TYPE).UI
            });
        }
    }, [
        props.disableHeadingIDs,
        editorRef,
        fireAnalyticsEvent
    ]);
    const getSchema = (0, $eJOHy.useMemo)(()=>{
        return (schema, adfStage)=>{
            if (schema) return schema;
            return (0, $8DB98.getSchemaBasedOnStage)(adfStage);
        };
    }, []);
    const onMouseDownEditView = ()=>{
        const windowSelection = window.getSelection();
        mouseDownSelection.current = windowSelection !== null ? windowSelection.toString() : undefined;
    };
    const { dataProviders: dataProviders, analyticsEventSeverityTracking: analyticsEventSeverityTracking } = props;
    (0, $eJOHy.useEffect)(()=>{
        let rafID;
        let widthAnalyticsSetTimeoutID;
        let widthAnalyticsRicID;
        let widthAnalyticsRafID;
        const handleAnalytics = ()=>{
            fireAnalyticsEvent({
                action: (0, $bMFKb.ACTION).STARTED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).RENDERER,
                attributes: {
                    platform: (0, $7ueoK.PLATFORM).WEB
                },
                eventType: (0, $bMFKb.EVENT_TYPE).UI
            });
            rafID = requestAnimationFrame(()=>{
                (0, $hvjqZ.stopMeasure)(`Renderer Render Time: ${id}`, (duration)=>{
                    const forceSeverityTracking = typeof analyticsEventSeverityTracking === 'undefined' && (0, $LjYWw.shouldForceTracking)();
                    const severity = !!forceSeverityTracking || analyticsEventSeverityTracking?.enabled ? (0, $dyNYh.getAnalyticsEventSeverity)(duration, analyticsEventSeverityTracking?.severityNormalThreshold ?? $7653122e837526a6$export$47b2879ca9bbf67a, analyticsEventSeverityTracking?.severityDegradedThreshold ?? $7653122e837526a6$export$1b622068be977101) : undefined;
                    const isTTRTrackingExplicitlyDisabled = analyticsEventSeverityTracking?.enabled === false;
                    if (!isTTRTrackingExplicitlyDisabled) fireAnalyticsEvent({
                        action: (0, $bMFKb.ACTION).RENDERED,
                        actionSubject: (0, $bMFKb.ACTION_SUBJECT).RENDERER,
                        attributes: {
                            platform: (0, $7ueoK.PLATFORM).WEB,
                            duration: duration,
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            distortedDuration: renderedMeasurementDistortedDurationMonitor.distortedDuration,
                            ttfb: (0, $Sk9g1.getResponseEndTime)(),
                            nodes: (0, $86V7W.countNodes)(props.document),
                            severity: severity
                        },
                        eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
                    });
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    renderedMeasurementDistortedDurationMonitor.cleanup();
                });
                anchorLinkAnalytics();
            });
            if ((0, $cbSL1.expValEquals)('platform_editor_editor_width_analytics', 'isEnabled', true)) // send statistics about the widths of the tables on the page for alerting
            widthAnalyticsSetTimeoutID = setTimeout(()=>{
                const requestIdleCallbackFn = ()=>{
                    const renderer = props.innerRef?.current?.querySelector('.ak-renderer-document');
                    if (renderer) {
                        const payload = (0, $53NHC.getWidthInfoPayload)(renderer);
                        if (payload) fireAnalyticsEvent(payload);
                    }
                };
                if (window && typeof window.requestIdleCallback === 'function') widthAnalyticsRicID = window.requestIdleCallback(requestIdleCallbackFn);
                else if (window && typeof window.requestAnimationFrame === 'function') // requestIdleCallback is not supported in safari, fallback to requestAnimationFrame
                widthAnalyticsRafID = window.requestAnimationFrame(requestIdleCallbackFn);
            }, $7653122e837526a6$var$TABLE_WIDTH_INFO_TIMEOUT);
        };
        handleAnalytics();
        return ()=>{
            if (rafID) window.cancelAnimationFrame(rafID);
            if (widthAnalyticsSetTimeoutID) window.clearTimeout(widthAnalyticsSetTimeoutID);
            if (widthAnalyticsRafID) window.cancelAnimationFrame(widthAnalyticsRafID);
            if (widthAnalyticsRicID) window.cancelIdleCallback(widthAnalyticsRicID);
            // if this is the ProviderFactory which was created in constructor
            // it's safe to destroy it on Renderer unmount
            // updated to match existing class component
            if (!dataProviders) providerFactory.destroy();
        };
    // we are going to ignore this because I'm doing this on purpose
    // having a dependency array means we run stopMeasure twice per render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const rendererContext = (0, $eJOHy.useMemo)(()=>createRendererContext(props.featureFlags, props.isTopLevelRenderer, props.contentMode), [
        props.featureFlags,
        props.isTopLevelRenderer,
        createRendererContext,
        props.contentMode
    ]);
    try {
        const schema = getSchema(props.schema, props.adfStage);
        const { result: result, stat: stat, pmDoc: pmDoc } = (0, $fjfmN.renderDocument)(props.shouldRemoveEmptySpaceAroundContent ? (0, $goISJ.removeEmptySpaceAroundContent)(props.document) : props.document, serializer, schema, props.adfStage, props.useSpecBasedValidator, id, fireAnalyticsEvent, props.unsupportedContentLevelsTracking, props.appearance, props.includeNodesCountInStats, props.skipValidation, props.validationOverrides);
        if (props.onComplete) props.onComplete(stat);
        const rendererOutput = /*#__PURE__*/ (0, $1NIU8.jsx)((0, $RTnFt.RendererContextProvider), {
            value: rendererContext
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jzI2h.ActiveHeaderIdProvider), {
            value: (0, $iOvh6.getActiveHeadingId)(props.allowHeadingAnchorLinks)
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $bdjbf.default).Provider, {
            value: {
                fireAnalyticsEvent: (event)=>fireAnalyticsEvent(event)
            }
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $dZ1mQ.Provider), null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $6Ramj.ProviderFactoryProvider), {
            value: providerFactory
        }, /*#__PURE__*/ (0, $1NIU8.jsx)($7653122e837526a6$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            contentMode: (0, $eGOwo.fg)('platform_editor_content_mode_render_context') ? props.contentMode || rendererContext.contentMode || 'standard' : props.contentMode || 'standard',
            allowNestedHeaderLinks: (0, $iOvh6.isNestedHeaderLinksEnabled)(props.allowHeadingAnchorLinks),
            allowColumnSorting: props.allowColumnSorting,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowPlaceholderText: props.allowPlaceholderText,
            useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
            addTelepointer: props.addTelepointer,
            innerRef: editorRef,
            onClick: (event)=>$7653122e837526a6$var$handleWrapperOnClick(event, props, mouseDownSelection),
            onMouseDown: onMouseDownEditView,
            ssr: props.media?.ssr,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            isTopLevelRenderer: rendererContext.isTopLevelRenderer,
            shouldRemoveEmptySpaceAroundContent: props.shouldRemoveEmptySpaceAroundContent,
            allowRendererContainerStyles: props.allowRendererContainerStyles
        }, props.enableSsrInlineScripts || props.noOpSSRInlineScript ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $khi07.BreakoutSSRInlineScript), {
            noOpSSRInlineScript: Boolean(props.noOpSSRInlineScript)
        }) : null, /*#__PURE__*/ (0, $1NIU8.jsx)($7653122e837526a6$var$RendererActionsInternalUpdater, {
            doc: pmDoc,
            schema: schema,
            onAnalyticsEvent: fireAnalyticsEvent
        }, result)))))));
        const rendererResult = props.truncated ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $fC4S5.TruncatedWrapper), {
            height: props.maxHeight,
            fadeHeight: props.fadeOutHeight
        }, rendererOutput) : rendererOutput;
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, rendererResult);
    } catch (e) {
        if (props.onError) props.onError(e);
        return /*#__PURE__*/ (0, $1NIU8.jsx)($7653122e837526a6$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            contentMode: (0, $eGOwo.fg)('platform_editor_content_mode_render_context') ? props.contentMode || rendererContext.contentMode || 'standard' : props.contentMode || 'standard',
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowPlaceholderText: props.allowPlaceholderText,
            allowColumnSorting: props.allowColumnSorting,
            allowNestedHeaderLinks: (0, $iOvh6.isNestedHeaderLinksEnabled)(props.allowHeadingAnchorLinks),
            useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
            addTelepointer: props.addTelepointer,
            onClick: (event)=>$7653122e837526a6$var$handleWrapperOnClick(event, props, mouseDownSelection),
            isTopLevelRenderer: rendererContext.isTopLevelRenderer,
            allowRendererContainerStyles: props.allowRendererContainerStyles
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $93FVZ.default), null));
    }
};
const $7653122e837526a6$var$RendererFunctionalComponentMemoized = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo($7653122e837526a6$export$c49fe2316038f3c2);
const $7653122e837526a6$var$RendererFunctionalComponentWithPortalContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo((props)=>{
    // If nodeComponents are provided, we don't remove portal from props and use context instead,
    // because we can't guarantee compatibility with existing Atlaskit Renderer consumers.
    if (props.nodeComponents) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7653122e837526a6$var$RendererFunctionalComponentMemoized, props);
    const { portal: portal, ...propsWithoutPortal } = props;
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jWNZR.PortalContext).Provider, {
        value: portal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7653122e837526a6$export$c49fe2316038f3c2, propsWithoutPortal));
});
function $7653122e837526a6$export$88530751e3977073(props) {
    const { startPos: startPos } = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $csUn2.AnnotationsPositionContext));
    const { isTopLevelRenderer: isTopLevelRenderer } = (0, $RTnFt.useRendererContext)();
    const { skipValidation: skipValidation, allowNestedTables: allowNestedTables } = (0, $eJOHy.useContext)((0, $2uPUs.ValidationContext)) || {};
    const validationOverrides = (0, $eJOHy.useMemo)(()=>({
            allowNestedTables: allowNestedTables
        }), [
        allowNestedTables
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)($7653122e837526a6$var$RendererFunctionalComponentWithPortalContext, {
        ...props,
        startPos: startPos,
        isTopLevelRenderer: props.isTopLevelRenderer ?? isTopLevelRenderer,
        skipValidation: skipValidation,
        validationOverrides: validationOverrides
    });
}
const $7653122e837526a6$export$af81ffb59b6ef0dd = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo((props)=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, $eUaD0.FabricEditorAnalyticsContext), {
        data: {
            appearance: (0, $dyNYh.getAnalyticsAppearance)(props.appearance),
            packageName: $7653122e837526a6$var$packageName,
            packageVersion: $7653122e837526a6$var$packageVersion,
            componentName: 'renderer',
            editorSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))()
        }
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $lilfD.WithCreateAnalyticsEvent), {
        render: (createAnalyticsEvent)=>{
            // `IntlErrorBoundary` only captures Internationalisation errors, leaving others for `ErrorBoundary`.
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $7DXmb.ErrorBoundary), {
                component: (0, $bMFKb.ACTION_SUBJECT).RENDERER,
                rethrowError: true,
                fallbackComponent: null,
                createAnalyticsEvent: createAnalyticsEvent
            }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jjlK8.IntlErrorBoundary), null, /*#__PURE__*/ (0, $1NIU8.jsx)($7653122e837526a6$export$88530751e3977073, {
                ...props,
                createAnalyticsEvent: createAnalyticsEvent
            })));
        }
    })));
const $7653122e837526a6$var$RendererWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo((props)=>{
    const { allowColumnSorting: allowColumnSorting, allowNestedHeaderLinks: allowNestedHeaderLinks, innerRef: innerRef, appearance: appearance, contentMode: contentMode, children: children, onClick: onClick, onMouseDown: onMouseDown, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, addTelepointer: addTelepointer, ssr: ssr, isInsideOfInlineExtension: isInsideOfInlineExtension, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer, allowRendererContainerStyles: allowRendererContainerStyles } = props;
    const createTelepointer = ()=>{
        const telepointer = document.createElement('span');
        telepointer.textContent = '\u200b';
        telepointer.id = (0, $9a762f515f769003$export$74b525449cc7cbd1);
        return telepointer;
    };
    const initialUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(true);
    (0, $eJOHy.useEffect)(()=>{
        // We must check if window is defined, if it isn't we are in a SSR environment
        // and we don't want to add the telepointer
        if (typeof window !== 'undefined' && addTelepointer && innerRef?.current) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const renderer = innerRef.current.querySelector('.ak-renderer-document');
            if (initialUpdate.current) {
                const lastChild = renderer.lastChild;
                lastChild && lastChild.appendChild(createTelepointer());
            }
            const mutateTelepointer = (mutations)=>{
                mutations.forEach((mutation, index)=>{
                    if (initialUpdate.current) {
                        const oldTelepointer = renderer.querySelector(`#${(0, $9a762f515f769003$export$74b525449cc7cbd1)}`);
                        if (oldTelepointer) oldTelepointer.remove();
                        const lastChild = renderer.lastChild;
                        lastChild && lastChild.appendChild(createTelepointer());
                        initialUpdate.current = false;
                    }
                    if (mutation.type === 'characterData') {
                        const parentNode = mutation.target.parentElement;
                        if (parentNode) {
                            const oldTelepointer = renderer.querySelector(`#${(0, $9a762f515f769003$export$74b525449cc7cbd1)}`);
                            if (oldTelepointer) oldTelepointer.remove();
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            parentNode.appendChild(createTelepointer());
                        }
                    }
                    /**
           * When streaming ADF content, we may receive mutations where nodes get
           * replaced, rather than have characterData updated.
           *
           * Telepointer changes will also cause a childList mutation, so we manually ignore it.
           * Telepointer changes are always a singular node-adds or node-removes.
           */ const isAdfStreamingEnabled = (0, $9Letn.expValEqualsNoExposure)('platform_editor_ai_iw_adf_streaming', 'cohort', 'adf_gpt41mini') || (0, $9Letn.expValEqualsNoExposure)('platform_editor_ai_iw_adf_streaming', 'cohort', 'adf_gemini25flash') || (0, $9Letn.expValEqualsNoExposure)('platform_editor_ai_ct_sg_adf_streaming', 'isEnabled', true) || (0, $9Letn.expValEqualsNoExposure)('platform_editor_ai_non_iw_adf_streaming', 'cohort', 'adf_gpt41mini') || (0, $9Letn.expValEqualsNoExposure)('platform_editor_ai_non_iw_adf_streaming', 'cohort', 'adf_gemini25flash');
                    if (isAdfStreamingEnabled && mutation.type === 'childList' && !(mutation.addedNodes.length === 1 && mutation.addedNodes[0]?.id === (0, $9a762f515f769003$export$74b525449cc7cbd1) || mutation.removedNodes.length === 1 && mutation.removedNodes[0]?.id === (0, $9a762f515f769003$export$74b525449cc7cbd1))) {
                        const lastChild = renderer.lastChild;
                        if (lastChild) {
                            /**
               * We want to place telepointer inside content (which has data-renderer-start-pos) and
               * inside lines in codeblocks (which have data-ds--code--row).
               */ const contentElements = lastChild.querySelectorAll('[data-renderer-start-pos],[data-ds--code--row]');
                            const lastElement = contentElements[contentElements.length - 1];
                            const oldTelepointer = renderer.querySelector(`#${(0, $9a762f515f769003$export$74b525449cc7cbd1)}`);
                            if (lastElement) {
                                oldTelepointer?.remove();
                                lastElement?.appendChild(createTelepointer());
                            } else {
                                oldTelepointer?.remove();
                                lastChild?.appendChild(createTelepointer());
                            }
                        }
                    }
                });
            };
            const observer = new MutationObserver(mutateTelepointer);
            observer.observe(innerRef.current, {
                characterData: true,
                attributes: false,
                childList: true,
                subtree: true
            });
            return ()=>observer.disconnect();
        }
    }, [
        innerRef,
        addTelepointer
    ]);
    const renderer = /*#__PURE__*/ (0, $1NIU8.jsx)((0, $2bEPZ.WidthProvider), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `ak-renderer-wrapper is-${appearance}`,
        "data-appearance": appearance,
        shouldCheckExistingValue: isInsideOfInlineExtension
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $iZVrE.BaseTheme), {
        baseFontSize: (0, $c3ajv.getBaseFontSize)(appearance, contentMode)
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $4SRvD.EditorMediaClientProvider), {
        ssr: ssr
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $bVKVd.RendererStyleContainer), {
        innerRef: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        appearance: appearance,
        contentMode: contentMode,
        allowNestedHeaderLinks: allowNestedHeaderLinks,
        allowColumnSorting: !!allowColumnSorting,
        useBlockRenderForCodeBlock: useBlockRenderForCodeBlock,
        allowAnnotations: props.allowAnnotations,
        allowTableResizing: allowTableResizing,
        allowRendererContainerStyles: allowRendererContainerStyles
    }, children))));
    // We can only make the wrapper div query container when we have a known width.
    // This is also required for SSR to work correctly. As WidthProvider/WithConsumer will not have the correct width during SSR.
    //
    // allowRendererContainerStyles is not needed for comment container styling as container should always be set for comments
    if (appearance === 'comment' && isTopLevelRenderer && (0, $eGOwo.fg)('platform-ssr-table-resize')) return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $7653122e837526a6$var$setAsQueryContainerStyles
    }, renderer);
    // We are setting this wrapper div as query container conditionally.
    // Only apply container-type = inline-size when having a known width in full-page/full-width/comment mode.
    // Otherwise when appearance is unspecified the renderer size is decided by the content.
    // In this case we can't set the container-type = inline-size as it will collapse width to 0.
    return (appearance === 'full-page' || appearance === 'full-width') && // In case of having excerpt-include on page there are multiple renderers nested.
    // Make sure only the root renderer is set to be query container.
    isTopLevelRenderer && allowRendererContainerStyles && (0, $eGOwo.fg)('platform-ssr-table-resize') ? /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $7653122e837526a6$var$setAsQueryContainerStyles
    }, renderer) : renderer;
});
const $7653122e837526a6$var$RootRendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(null);
function $7653122e837526a6$var$RendererActionsInternalUpdater({ children: children, doc: doc, schema: schema, onAnalyticsEvent: onAnalyticsEvent }) {
    const rootRendererContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext($7653122e837526a6$var$RootRendererContext);
    const actions = (0, $eJOHy.useContext)((0, $4Z9bh.RendererContext));
    const rendererRef = (0, $eJOHy.useRef)(null);
    // This doc is used by the renderer actions when applying comments to the document.
    // (via hand crafted steps based on non prosemirror based position calculations)
    // It is set to the root renderer's doc as otherwise the resulting document will
    // be incorrect (nested renderers use a fake document which represents a subset
    // of the actual document).
    let _doc;
    if ((0, $92xoS.editorExperiment)('comment_on_bodied_extensions', true) && rootRendererContextValue) // If rootRendererContextValue is set -- we are inside a nested renderer
    // and should always use the doc from the root renderer
    _doc = rootRendererContextValue.doc;
    else // If rootRendererContextValue is not set -- we are in the root renderer
    // and set the doc to the current doc.
    _doc = doc;
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (_doc) actions._privateRegisterRenderer(rendererRef, _doc, schema, onAnalyticsEvent);
        else actions._privateUnregisterRenderer();
        return ()=>actions._privateUnregisterRenderer();
    }, [
        actions,
        schema,
        _doc,
        onAnalyticsEvent
    ]);
    if ((0, $92xoS.editorExperiment)('comment_on_bodied_extensions', true)) return /*#__PURE__*/ (0, $1NIU8.jsx)($7653122e837526a6$var$RootRendererContext.Provider, {
        value: {
            doc: _doc
        }
    }, children);
    return children;
}
// Usage notes:
// Used by Confluence for nested renderers
// For the View page renderer - see RendererWithAnalytics
const $7653122e837526a6$var$RendererWithAnnotationSelection = (props)=>{
    const { allowAnnotations: allowAnnotations, document: adfDocument } = props;
    const localRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const innerRef = props.innerRef || localRef;
    if (!allowAnnotations) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $1NIU8.jsx)($7653122e837526a6$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props
    });
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $4Z9bh.RendererActionsContext), null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $csUn2.AnnotationsWrapper), {
        rendererRef: innerRef,
        adfDocument: adfDocument,
        annotationProvider: props.annotationProvider,
        isNestedRender: true
    }, /*#__PURE__*/ (0, $1NIU8.jsx)($7653122e837526a6$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props,
        featureFlags: props.featureFlags
    })));
};
var // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/* @deprecated using this version of the renderer causes the RendererActions to inaccessible from any consumers */ $7653122e837526a6$export$2e2bcd8739ae039 = $7653122e837526a6$var$RendererWithAnnotationSelection;

});
parcelRegister("8DB98", function(module, exports) {
$parcel$export(module.exports, "defaultSchemaConfig", () => $649ec7bd1a149376$export$e4e3ac1fa64862db);
$parcel$export(module.exports, "getSchemaBasedOnStage", () => $649ec7bd1a149376$export$fd147e7d448dea03);
$parcel$export(module.exports, "defaultSchema", () => $649ec7bd1a149376$export$1db618b7b2275ea1);

var $LFmXM = parcelRequire("LFmXM");

var $dMcxi = parcelRequire("dMcxi");
var $eSKW9 = parcelRequire("eSKW9");
var $6C9Qx = parcelRequire("6C9Qx");
var $jSvxD = parcelRequire("jSvxD");
var $gkLMH = parcelRequire("gkLMH");
var $hn1YX = parcelRequire("hn1YX");
var $e6HpD = parcelRequire("e6HpD");

var $g7Jv8 = parcelRequire("g7Jv8");
const $649ec7bd1a149376$var$getDefaultSchemaConfig = ()=>{
    const defaultSchemaConfig = {
        nodes: [
            'doc',
            'paragraph',
            'text',
            'bulletList',
            'orderedList',
            'listItem',
            'heading',
            'blockquote',
            'codeBlock',
            'panel',
            'rule',
            'image',
            'caption',
            'mention',
            'media',
            'mediaGroup',
            'mediaSingle',
            'mediaInline',
            'confluenceUnsupportedBlock',
            'confluenceUnsupportedInline',
            'confluenceJiraIssue',
            'expand',
            'nestedExpand',
            'extension',
            'inlineExtension',
            'bodiedExtension',
            'hardBreak',
            'emoji',
            'table',
            'tableCell',
            'tableHeader',
            'tableRow',
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem',
            'blockTaskItem',
            'unknownBlock',
            'date',
            'status',
            'placeholder',
            'layoutSection',
            'layoutColumn',
            'inlineCard',
            'blockCard',
            'embedCard',
            'unsupportedBlock',
            'unsupportedInline'
        ],
        marks: [
            'link',
            'em',
            'strong',
            'strike',
            'subsup',
            'underline',
            'code',
            'textColor',
            'backgroundColor',
            'confluenceInlineComment',
            'breakout',
            'alignment',
            'indentation',
            'annotation',
            'dataConsumer',
            'border',
            'unsupportedMark',
            'unsupportedNodeAttribute',
            'typeAheadQuery',
            // https://product-fabric.atlassian.net/browse/ED-10214,
            'fragment'
        ]
    };
    return defaultSchemaConfig;
};
const $649ec7bd1a149376$export$e4e3ac1fa64862db = $649ec7bd1a149376$var$getDefaultSchemaConfig();
const $649ec7bd1a149376$export$fd147e7d448dea03 = (0, $LFmXM.default)((stage = 'final')=>{
    const defaultSchemaConfig = $649ec7bd1a149376$var$getDefaultSchemaConfig();
    if (stage === 'stage0') defaultSchemaConfig.customNodeSpecs = {
        layoutSection: (0, $jSvxD.layoutSectionWithSingleColumn),
        multiBodiedExtension: (0, $6C9Qx.multiBodiedExtension),
        extensionFrame: (0, $6C9Qx.extensionFrame),
        expand: (0, $eSKW9.expandWithNestedExpand),
        listItem: (0, $gkLMH.listItemWithDecisionStage0),
        table: (0, $e6HpD.tableWithNestedTable),
        tableRow: (0, $e6HpD.tableRowWithNestedTable),
        tableCell: (0, $e6HpD.tableCellWithNestedTable),
        tableHeader: (0, $e6HpD.tableHeaderWithNestedTable),
        syncBlock: $hn1YX.syncBlock,
        bodiedSyncBlock: $dMcxi.bodiedSyncBlock
    };
    return (0, $g7Jv8.createSchema)(defaultSchemaConfig);
});
const $649ec7bd1a149376$export$1db618b7b2275ea1 = $649ec7bd1a149376$export$fd147e7d448dea03();

});
parcelRegister("dMcxi", function(module, exports) {
$parcel$export(module.exports, "bodiedSyncBlock", () => $a0797b6e9c92db22$export$e92c7e4302dd4371);

var $nJVLW = parcelRequire("nJVLW");

var $2OrIX = parcelRequire("2OrIX");
const $a0797b6e9c92db22$export$e92c7e4302dd4371 = (0, $nJVLW.bodiedSyncBlockStage0)({
    parseDOM: [
        {
            tag: 'div[data-bodied-sync-block]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || (0, $2OrIX.uuid).generate(),
                    resourceId: dom.getAttribute('data-resource-id') || ''
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId, resourceId: resourceId } = node.attrs;
        const name = 'div';
        const attrs = {
            'data-bodied-sync-block': '',
            'data-local-id': localId,
            'data-resource-id': resourceId
        };
        return [
            name,
            attrs,
            0
        ];
    }
});

});
parcelRegister("nJVLW", function(module, exports) {
$parcel$export(module.exports, "blockCard", () => $0475c6ffc1ba526d$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $0475c6ffc1ba526d$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockquoteLegacy", () => $0475c6ffc1ba526d$export$199922e5af8e9a6);
$parcel$export(module.exports, "blockTaskItem", () => $0475c6ffc1ba526d$export$16018c61064a18df);
$parcel$export(module.exports, "bodiedExtension", () => $0475c6ffc1ba526d$export$27903d543b563e39);
$parcel$export(module.exports, "bodiedSyncBlockStage0", () => $0475c6ffc1ba526d$export$d48e1571b7a35aec);
$parcel$export(module.exports, "bulletList", () => $0475c6ffc1ba526d$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $0475c6ffc1ba526d$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "codeBlock", () => $0475c6ffc1ba526d$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "confluenceJiraIssue", () => $0475c6ffc1ba526d$export$daf889beb5092f95);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $0475c6ffc1ba526d$export$e6e4878f43c27cab);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => $0475c6ffc1ba526d$export$3e6d667072febc87);
$parcel$export(module.exports, "date", () => $0475c6ffc1ba526d$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $0475c6ffc1ba526d$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $0475c6ffc1ba526d$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $0475c6ffc1ba526d$export$2a111da947c407d2);
$parcel$export(module.exports, "embedCard", () => $0475c6ffc1ba526d$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $0475c6ffc1ba526d$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $0475c6ffc1ba526d$export$9f77e0932fb78f72);
$parcel$export(module.exports, "extension", () => $0475c6ffc1ba526d$export$1b45514b112dd749);
$parcel$export(module.exports, "extensionFrameStage0", () => $0475c6ffc1ba526d$export$b555be60c7703afb);
$parcel$export(module.exports, "hardBreak", () => $0475c6ffc1ba526d$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $0475c6ffc1ba526d$export$46e4a324ac90507f);
$parcel$export(module.exports, "image", () => $0475c6ffc1ba526d$export$5c452ff88e35e47d);
$parcel$export(module.exports, "inlineCard", () => $0475c6ffc1ba526d$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtensionWithMarks", () => $0475c6ffc1ba526d$export$b3b1e36c2105006d);
$parcel$export(module.exports, "layoutColumn", () => $0475c6ffc1ba526d$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $0475c6ffc1ba526d$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionFull", () => $0475c6ffc1ba526d$export$cdae19acb0a520fd);
$parcel$export(module.exports, "layoutSectionWithSingleColumnStage0", () => $0475c6ffc1ba526d$export$206007566ca0aca5);
$parcel$export(module.exports, "listItem", () => $0475c6ffc1ba526d$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemWithNestedDecisionStage0", () => $0475c6ffc1ba526d$export$df876f0305235056);
$parcel$export(module.exports, "media", () => $0475c6ffc1ba526d$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $0475c6ffc1ba526d$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $0475c6ffc1ba526d$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $0475c6ffc1ba526d$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleCaption", () => $0475c6ffc1ba526d$export$8d067f22dc2d1254);
$parcel$export(module.exports, "mediaSingleFull", () => $0475c6ffc1ba526d$export$7e767666f2ce108a);
$parcel$export(module.exports, "mediaSingleWidthType", () => $0475c6ffc1ba526d$export$4bd9a38995f6bf50);
$parcel$export(module.exports, "mention", () => $0475c6ffc1ba526d$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtensionStage0", () => $0475c6ffc1ba526d$export$750e45819f66d9d0);
$parcel$export(module.exports, "nestedExpand", () => $0475c6ffc1ba526d$export$63cadbf5f4296627);
$parcel$export(module.exports, "orderedList", () => $0475c6ffc1ba526d$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $0475c6ffc1ba526d$export$21f42ab9b6679f44);
$parcel$export(module.exports, "paragraph", () => $0475c6ffc1ba526d$export$9c206ddddb32a9b);
$parcel$export(module.exports, "placeholder", () => $0475c6ffc1ba526d$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $0475c6ffc1ba526d$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "status", () => $0475c6ffc1ba526d$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "syncBlockStage0", () => $0475c6ffc1ba526d$export$3782866d5d058412);
$parcel$export(module.exports, "table", () => $0475c6ffc1ba526d$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithNestedTable", () => $0475c6ffc1ba526d$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableCell", () => $0475c6ffc1ba526d$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $0475c6ffc1ba526d$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeader", () => $0475c6ffc1ba526d$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $0475c6ffc1ba526d$export$2a5a518232fa1a97);
$parcel$export(module.exports, "tableRow", () => $0475c6ffc1ba526d$export$ce666bf02318c957);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $0475c6ffc1ba526d$export$7d657479499397);
$parcel$export(module.exports, "taskItem", () => $0475c6ffc1ba526d$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $0475c6ffc1ba526d$export$375b6afcc5f4d291);
$parcel$export(module.exports, "text", () => $0475c6ffc1ba526d$export$6f093cfa640b7166);
$parcel$export(module.exports, "unsupportedBlock", () => $0475c6ffc1ba526d$export$44b79b0979d0f0f7);
$parcel$export(module.exports, "unsupportedInline", () => $0475c6ffc1ba526d$export$310ebe0d80122e9b);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $1zhCF = parcelRequire("1zhCF");
const $0475c6ffc1ba526d$export$c4c2f833baaebdb8 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        },
        url: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $0475c6ffc1ba526d$export$67dc04e652a298ca = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
const $0475c6ffc1ba526d$export$199922e5af8e9a6 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
const $0475c6ffc1ba526d$export$16018c61064a18df = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | extension) (paragraph | extension)*',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
const $0475c6ffc1ba526d$export$27903d543b563e39 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $0475c6ffc1ba526d$export$e7320d153c538837 = (0, $1zhCF.createPMNodeSpecFactory)({
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $0475c6ffc1ba526d$export$d48e1571b7a35aec = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | blockCard | blockquote | bulletList | codeBlock | confluenceUnsupportedBlock | decisionList | embedCard | expand | heading | layoutSection | mediaGroup | mediaSingle | orderedList | panel | rule | table | taskList | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation breakout link fragment',
    attrs: {
        resourceId: {
            default: ''
        },
        localId: {
            default: ''
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$a140c94e5ea26bee = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $0475c6ffc1ba526d$export$8e3c2dfdc4f0453d = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*',
    marks: '_',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
const $0475c6ffc1ba526d$export$7bb0d5c671655cc4 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        }
    },
    code: true,
    defining: true
});
const $0475c6ffc1ba526d$export$e4f1c66d84049f8b = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        }
    },
    code: true,
    defining: true
});
const $0475c6ffc1ba526d$export$daf889beb5092f95 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ''
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    }
});
const $0475c6ffc1ba526d$export$e6e4878f43c27cab = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $0475c6ffc1ba526d$export$3e6d667072febc87 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $0475c6ffc1ba526d$export$324d90190a8b822a = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$47988d68fe575725 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$6959e16eeff859b4 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'DECIDED'
        }
    },
    defining: true
});
const $0475c6ffc1ba526d$export$62d45a65fb43d95e = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(decisionItem | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $0475c6ffc1ba526d$export$2a111da947c407d2 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(block | codeBlock | layoutSection | blockRootOnly | expand | syncBlock | bodiedSyncBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment breakout'
});
const $0475c6ffc1ba526d$export$be4283d9a1cb1ff6 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: ''
        },
        layout: {
            default: 'center'
        },
        width: {
            default: 100
        },
        originalHeight: {
            default: null
        },
        originalWidth: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$a19185d1233fc4b2 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$f5574b5d45fc2112 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$9f77e0932fb78f72 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $0475c6ffc1ba526d$export$7e3788972005cc72 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $0475c6ffc1ba526d$export$1b45514b112dd749 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$a8baf338431a691 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$b555be60c7703afb = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {},
    selectable: false,
    definingAsContext: false,
    definingForContent: true,
    isolating: true
});
const $0475c6ffc1ba526d$export$371da9dd35aba193 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: '\n'
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    linebreakReplacement: true
});
const $0475c6ffc1ba526d$export$46e4a324ac90507f = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $0475c6ffc1ba526d$export$1b0c1557b234fa00 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $0475c6ffc1ba526d$export$85461f751c457cc2 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $0475c6ffc1ba526d$export$2b380a0f7e250af1 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $0475c6ffc1ba526d$export$5c452ff88e35e47d = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        src: {
            default: ''
        },
        alt: {
            default: ''
        },
        title: {
            default: null
        }
    },
    draggable: true
});
const $0475c6ffc1ba526d$export$cbf8224b64e0d942 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $0475c6ffc1ba526d$export$2f4e72b9459914ad = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $0475c6ffc1ba526d$export$16b353b2649bd8d9 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$b3b1e36c2105006d = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$ab76e7c03cd6f650 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(block | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment',
    attrs: {
        width: {
            default: undefined
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
const $0475c6ffc1ba526d$export$b3b6a70a7fa4a5be = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
const $0475c6ffc1ba526d$export$cdae19acb0a520fd = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){2,3}',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
const $0475c6ffc1ba526d$export$206007566ca0aca5 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,5} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        columnRuleStyle: {
            default: null
        },
        localId: {
            default: null
        }
    },
    isolating: true
});
const $0475c6ffc1ba526d$export$76c7e83ecc9cdf05 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | extension)*',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $0475c6ffc1ba526d$export$df876f0305235056 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension)*',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $0475c6ffc1ba526d$export$987d49ffe1b0900f = (0, $1zhCF.createPMNodeSpecFactory)({
    attrs: {
        type: {
            default: 'file'
        },
        localId: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        height: {
            default: null
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        __contextId: {
            default: null
        },
        __displayType: {
            default: null
        },
        __external: {
            default: false
        },
        __fileMimeType: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        url: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$2855e964765eac9 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(media | unsupportedBlock)+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {},
    selectable: false
});
const $0475c6ffc1ba526d$export$38bab695e3f720f1 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        type: {
            default: 'file'
        },
        localId: {
            default: null
        },
        url: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        height: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __fileMimeType: {
            default: null
        },
        __displayType: {
            default: null
        },
        __contextId: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        __external: {
            default: false
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$969fe3781ca15058 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true,
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'annotation border link unsupportedMark unsupportedNodeAttribute'
});
const $0475c6ffc1ba526d$export$8d067f22dc2d1254 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$7e767666f2ce108a = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$4bd9a38995f6bf50 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: true,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$db83999c14438df4 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$46f790bd65f760d0 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$750e45819f66d9d0 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'extensionFrame+',
    marks: 'unsupportedNodeAttribute unsupportedMark',
    group: 'blockRootOnly',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
const $0475c6ffc1ba526d$export$63cadbf5f4296627 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $0475c6ffc1ba526d$export$f03786aa6312d1e4 = (0, $1zhCF.createPMNodeSpecFactory)({
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $0475c6ffc1ba526d$export$a5dc81035676e7a = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        order: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
const $0475c6ffc1ba526d$export$21f42ab9b6679f44 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$9c206ddddb32a9b = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $0475c6ffc1ba526d$export$4f98472e6dc14293 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $0475c6ffc1ba526d$export$ea332b61641b0588 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $0475c6ffc1ba526d$export$a1f41dc4901771f8 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $0475c6ffc1ba526d$export$c7187bbd1a7a9244 = (0, $1zhCF.createPMNodeSpecFactory)({
    marks: '',
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
const $0475c6ffc1ba526d$export$fbeb3a3956e8a3c7 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    }
});
const $0475c6ffc1ba526d$export$471f7ae5c4103ae1 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$b6ce52be8d7a261 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$3782866d5d058412 = (0, $1zhCF.createPMNodeSpecFactory)({
    attrs: {
        resourceId: {
            default: ''
        },
        localId: {
            default: ''
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$9852986a3ec5f6a0 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $0475c6ffc1ba526d$export$ce086a560a1d05f5 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $0475c6ffc1ba526d$export$e1e720e5f4603e6a = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $0475c6ffc1ba526d$export$abf39ca178940ff3 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $0475c6ffc1ba526d$export$48884d2a5190dc73 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $0475c6ffc1ba526d$export$2a5a518232fa1a97 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $0475c6ffc1ba526d$export$ce666bf02318c957 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: 'row'
});
const $0475c6ffc1ba526d$export$7d657479499397 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: 'row'
});
const $0475c6ffc1ba526d$export$6d8b0ef52e2e6390 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
const $0475c6ffc1ba526d$export$375b6afcc5f4d291 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(taskItem | unsupportedBlock | blockTaskItem)+ (taskItem | taskList | unsupportedBlock | blockTaskItem)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $0475c6ffc1ba526d$export$6f093cfa640b7166 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline'
});
const $0475c6ffc1ba526d$export$5ea06bc686c59dc2 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline'
});
const $0475c6ffc1ba526d$export$93256a4c17b33a82 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline'
});
const $0475c6ffc1ba526d$export$a12828d0f14a2762 = (0, $1zhCF.createPMNodeSpecFactory)({});
const $0475c6ffc1ba526d$export$44b79b0979d0f0f7 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$310ebe0d80122e9b = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});

});
parcelRegister("1zhCF", function(module, exports) {
$parcel$export(module.exports, "createPMNodeSpecFactory", () => $1246bacc7b1ceffa$export$bf0a80f00e2b8ff6);
$parcel$export(module.exports, "createPMMarkSpecFactory", () => $1246bacc7b1ceffa$export$cf5823ed4e9f4c6f);
/**
 * Factory method to attach custom parseDOM and/or toDOM for nodeSpec
 *
 * @example
 * createPMNodeSpecFactory<SomeNode>(node)({parseDOM: {}, toDOM: (node) => {} });
 *
 * @param nodeSpec - NodeSpec without toDom and parseDom
 * @returns A function for a node which allows the consumer to define toDom and parseDom
 */ const $1246bacc7b1ceffa$export$bf0a80f00e2b8ff6 = (nodeSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        return {
            ...nodeSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };
const $1246bacc7b1ceffa$export$cf5823ed4e9f4c6f = (markSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        return {
            ...markSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };

});


parcelRegister("2OrIX", function(module, exports) {
$parcel$export(module.exports, "generateUuid", () => $20c5c1b68bce331d$export$1c3aefb711c3a4cc);
$parcel$export(module.exports, "uuid", () => $20c5c1b68bce331d$export$31b40729666a4ae0);
/* eslint-disable no-bitwise */ const $20c5c1b68bce331d$export$1c3aefb711c3a4cc = ()=>'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
/* eslint-enable no-bitwise */ let $20c5c1b68bce331d$var$staticValue = false;
const $20c5c1b68bce331d$export$31b40729666a4ae0 = {
    setStatic (value) {
        $20c5c1b68bce331d$var$staticValue = value;
    },
    generate () {
        return $20c5c1b68bce331d$var$staticValue || $20c5c1b68bce331d$export$1c3aefb711c3a4cc();
    }
};

});


parcelRegister("eSKW9", function(module, exports) {
$parcel$export(module.exports, "expandWithNestedExpand", () => $ad5a848656ebe869$export$7b80cba28d10b2c1);
$parcel$export(module.exports, "expandWithNestedExpandLocalId", () => $ad5a848656ebe869$export$2ae5e7565ff9ffa6);
$parcel$export(module.exports, "toJSON", () => $ad5a848656ebe869$export$54fd2c36b5cc6731);

var $nJVLW = parcelRequire("nJVLW");

var $2OrIX = parcelRequire("2OrIX");
/**
 * @name expand_node
 */ /**
 * @name expand_with_no_mark_node
 */ /**
 * @name expand_root_only_node
 */ function $ad5a848656ebe869$var$getExpandAttrs(domNode) {
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
const $ad5a848656ebe869$var$nodeSpecOptions = {
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: $ad5a848656ebe869$var$getExpandAttrs
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $ad5a848656ebe869$var$getExpandAttrs
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $ad5a848656ebe869$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $ad5a848656ebe869$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $ad5a848656ebe869$export$7b80cba28d10b2c1 = (0, $nJVLW.expand)($ad5a848656ebe869$var$nodeSpecOptions);
const $ad5a848656ebe869$export$2ae5e7565ff9ffa6 = (0, $nJVLW.expand)({
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $ad5a848656ebe869$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $2OrIX.uuid).generate()
                };
            }
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $ad5a848656ebe869$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $2OrIX.uuid).generate()
                };
            }
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $ad5a848656ebe869$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $2OrIX.uuid).generate()
                };
            }
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $ad5a848656ebe869$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $2OrIX.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $ad5a848656ebe869$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>!key.startsWith('__')).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});

parcelRegister("6C9Qx", function(module, exports) {
$parcel$export(module.exports, "extensionFrame", () => $4d0dedfce6d8a509$export$4fdcae991fd743e7);
$parcel$export(module.exports, "multiBodiedExtension", () => $4d0dedfce6d8a509$export$c3c04d555a8b9013);

var $fPSlo = parcelRequire("fPSlo");

var $nJVLW = parcelRequire("nJVLW");
const $4d0dedfce6d8a509$export$4fdcae991fd743e7 = (0, $nJVLW.extensionFrameStage0)({
    parseDOM: [
        {
            context: 'extensionFrame//',
            tag: 'div[data-extension-frame]',
            skip: true
        },
        {
            tag: 'div[data-extension-frame]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-extension-frame': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $4d0dedfce6d8a509$export$c3c04d555a8b9013 = (0, $nJVLW.multiBodiedExtensionStage0)({
    parseDOM: [
        {
            context: 'multiBodiedExtension//',
            tag: '[data-node-type="multi-bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="multi-bodied-extension"]',
            getAttrs: (domNode)=>(0, $fPSlo.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'multi-bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});
parcelRegister("fPSlo", function(module, exports) {
$parcel$export(module.exports, "getExtensionAttrs", () => $b875c609076dd72b$export$1765e2758fc47004);
const $b875c609076dd72b$export$d5f21755dc782a4a = (name)=>{
    return !!name && [
        'default',
        'wide',
        'full-width'
    ].includes(name);
};
const $b875c609076dd72b$export$1765e2758fc47004 = (dom, isInline = false)=>{
    const extensionType = dom.getAttribute('data-extension-type');
    const extensionKey = dom.getAttribute('data-extension-key');
    if (!extensionType || !extensionKey) return false;
    const attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute('data-text') || undefined,
        parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
        localId: dom.getAttribute('data-local-id') || undefined
    };
    if (!isInline) {
        const rawLayout = dom.getAttribute('data-layout');
        attrs.layout = $b875c609076dd72b$export$d5f21755dc782a4a(rawLayout) ? rawLayout : 'default';
    }
    return attrs;
};

});


parcelRegister("jSvxD", function(module, exports) {
$parcel$export(module.exports, "layoutSection", () => $e78b86f811605f22$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => $e78b86f811605f22$export$4f9d8f623ff17117);
$parcel$export(module.exports, "layoutSectionWithLocalId", () => $e78b86f811605f22$export$d9d3c69a64270b13);
$parcel$export(module.exports, "layoutSectionWithSingleColumnLocalId", () => $e78b86f811605f22$export$64facded20dfd85c);

var $nJVLW = parcelRequire("nJVLW");

var $2OrIX = parcelRequire("2OrIX");
const $e78b86f811605f22$export$b3b6a70a7fa4a5be = (0, $nJVLW.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $e78b86f811605f22$export$cdae19acb0a520fd = (0, $nJVLW.layoutSectionFull)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $e78b86f811605f22$export$4f9d8f623ff17117 = (0, $nJVLW.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: (dom)=>{
                const columnRuleStyle = dom.getAttribute('data-column-rule-style');
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle
                } : {};
            }
        }
    ],
    toDOM (node) {
        const { columnRuleStyle: columnRuleStyle } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $e78b86f811605f22$export$d9d3c69a64270b13 = (0, $nJVLW.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: ()=>{
                const localId = (0, $2OrIX.uuid).generate();
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-local-id': localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $e78b86f811605f22$export$64facded20dfd85c = (0, $nJVLW.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: (dom)=>{
                const columnRuleStyle = dom.getAttribute('data-column-rule-style');
                const localId = (0, $2OrIX.uuid).generate();
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle,
                    localId: localId
                } : {
                    localId: localId
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { columnRuleStyle: columnRuleStyle } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("gkLMH", function(module, exports) {
$parcel$export(module.exports, "listItem", () => $be43949bca9723a7$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemWithLocalId", () => $be43949bca9723a7$export$483d52f09158e61c);
$parcel$export(module.exports, "listItemWithDecisionStage0", () => $be43949bca9723a7$export$b2cd54d5ce935ddb);

var $2OrIX = parcelRequire("2OrIX");

var $nJVLW = parcelRequire("nJVLW");
const $be43949bca9723a7$export$76c7e83ecc9cdf05 = (0, $nJVLW.listItem)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});
const $be43949bca9723a7$export$483d52f09158e61c = (0, $nJVLW.listItem)({
    parseDOM: [
        {
            tag: 'li',
            getAttrs: ()=>({
                    localId: (0, $2OrIX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        return [
            'li',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            },
            0
        ];
    }
});
const $be43949bca9723a7$export$b2cd54d5ce935ddb = (0, $nJVLW.listItemWithNestedDecisionStage0)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});
const $be43949bca9723a7$export$394466eb252d967a = (0, $nJVLW.listItemWithNestedDecisionStage0)({
    parseDOM: [
        {
            tag: 'li',
            getAttrs: ()=>({
                    localId: (0, $2OrIX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs2;
        return [
            'li',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
            },
            0
        ];
    }
});

});

parcelRegister("hn1YX", function(module, exports) {
$parcel$export(module.exports, "syncBlock", () => $ca561f464c8d9900$export$faab0ca9701d7048);

var $nJVLW = parcelRequire("nJVLW");

var $2OrIX = parcelRequire("2OrIX");
const $ca561f464c8d9900$export$faab0ca9701d7048 = (0, $nJVLW.syncBlockStage0)({
    parseDOM: [
        {
            tag: 'div[data-sync-block]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || (0, $2OrIX.uuid).generate(),
                    resourceId: dom.getAttribute('data-resource-id') || ''
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId, resourceId: resourceId } = node.attrs;
        const name = 'div';
        const attrs = {
            'data-sync-block': '',
            'data-local-id': localId,
            'data-resource-id': resourceId
        };
        return [
            name,
            attrs
        ];
    }
});

});

parcelRegister("e6HpD", function(module, exports) {
$parcel$export(module.exports, "tablePrefixSelector", () => $a4534d0d8902e0f9$export$9cfceb893b24742a);
$parcel$export(module.exports, "tableCellSelector", () => $a4534d0d8902e0f9$export$69cb4c3f80383763);
$parcel$export(module.exports, "tableHeaderSelector", () => $a4534d0d8902e0f9$export$7b07d37d879c957f);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => $a4534d0d8902e0f9$export$8dd42a84cd52da07);
$parcel$export(module.exports, "tableCellContentDomSelector", () => $a4534d0d8902e0f9$export$5e26a5c19f0865d8);
$parcel$export(module.exports, "getCellAttrs", () => $a4534d0d8902e0f9$export$43977bde391e007);
$parcel$export(module.exports, "getCellDomAttrs", () => $a4534d0d8902e0f9$export$363c8dda799bfe9c);
$parcel$export(module.exports, "tableBackgroundColorNames", () => $a4534d0d8902e0f9$export$8cc2833b5b349a1e);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => $a4534d0d8902e0f9$export$219b7f492ad209f8);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => $a4534d0d8902e0f9$export$95e9c925fbf01d1c);
$parcel$export(module.exports, "table", () => $a4534d0d8902e0f9$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithCustomWidth", () => $a4534d0d8902e0f9$export$90e634fbace1f0c4);
$parcel$export(module.exports, "tableStage0", () => $a4534d0d8902e0f9$export$3862de5c8c9098cf);
$parcel$export(module.exports, "tableToJSON", () => $a4534d0d8902e0f9$export$1f92a2f429e06fa8);
$parcel$export(module.exports, "tableRow", () => $a4534d0d8902e0f9$export$ce666bf02318c957);
$parcel$export(module.exports, "tableCell", () => $a4534d0d8902e0f9$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "toJSONTableCell", () => $a4534d0d8902e0f9$export$2ac34c099660f1a8);
$parcel$export(module.exports, "tableHeader", () => $a4534d0d8902e0f9$export$48884d2a5190dc73);
$parcel$export(module.exports, "toJSONTableHeader", () => $a4534d0d8902e0f9$export$2af48797a1010bb1);
$parcel$export(module.exports, "tableWithNestedTable", () => $a4534d0d8902e0f9$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $a4534d0d8902e0f9$export$7d657479499397);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $a4534d0d8902e0f9$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $a4534d0d8902e0f9$export$2a5a518232fa1a97);
$parcel$export(module.exports, "tableRowWithLocalId", () => $a4534d0d8902e0f9$export$c8f0853ac97552c9);
$parcel$export(module.exports, "tableCellWithLocalId", () => $a4534d0d8902e0f9$export$db76cfd28a574029);
$parcel$export(module.exports, "tableHeaderWithLocalId", () => $a4534d0d8902e0f9$export$b82d2b1d8824143d);
$parcel$export(module.exports, "tableRowWithNestedTableWithLocalId", () => $a4534d0d8902e0f9$export$27926e30c8a74147);
$parcel$export(module.exports, "tableCellWithNestedTableWithLocalId", () => $a4534d0d8902e0f9$export$e9fd700fafee293a);
$parcel$export(module.exports, "tableHeaderWithNestedTableWithLocalId", () => $a4534d0d8902e0f9$export$7928c3aeb4cd2213);

var $dyyJM = parcelRequire("dyyJM");

var $51dYk = parcelRequire("51dYk");

var $2OrIX = parcelRequire("2OrIX");

var $4PpDP = parcelRequire("4PpDP");

var $nJVLW = parcelRequire("nJVLW");
const $a4534d0d8902e0f9$export$9cfceb893b24742a = 'pm-table';
const $a4534d0d8902e0f9$export$69cb4c3f80383763 = `${$a4534d0d8902e0f9$export$9cfceb893b24742a}-cell-content-wrap`;
const $a4534d0d8902e0f9$export$7b07d37d879c957f = `${$a4534d0d8902e0f9$export$9cfceb893b24742a}-header-content-wrap`;
const $a4534d0d8902e0f9$export$8dd42a84cd52da07 = `${$a4534d0d8902e0f9$export$9cfceb893b24742a}-cell-nodeview-wrapper`;
const $a4534d0d8902e0f9$export$5e26a5c19f0865d8 = `${$a4534d0d8902e0f9$export$9cfceb893b24742a}-cell-nodeview-content-dom`;
const $a4534d0d8902e0f9$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $51dYk.N20).toLocaleLowerCase();
const $a4534d0d8902e0f9$export$43977bde391e007 = (dom, defaultValues = {})=>{
    const widthAttr = dom.getAttribute('data-colwidth');
    const width = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(',').map((str)=>Number(str)) : null;
    const colspan = Number(dom.getAttribute('colspan') || 1);
    let { backgroundColor: backgroundColor } = dom.style;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ const dataCellBackground = dom.getAttribute('data-cell-background');
    const dataCellBackgroundHexCode = dataCellBackground && (0, $51dYk.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes('--ds-background-neutral')) backgroundColor = '';
    else if (backgroundColor && (0, $51dYk.isRgb)(backgroundColor)) {
        const result = (0, $51dYk.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    const backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues['background'] ? backgroundColor : null);
    const localId = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.localId;
    return {
        colspan: colspan,
        rowspan: Number(dom.getAttribute('rowspan') || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode,
        ...localId && {
            localId: localId
        }
    };
};
// these are for test only
let $a4534d0d8902e0f9$var$testGlobalTheme;
const $a4534d0d8902e0f9$export$fd7e0dd2b74807f7 = (theme)=>{
    $a4534d0d8902e0f9$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
const $a4534d0d8902e0f9$var$getGlobalTheme = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($a4534d0d8902e0f9$var$testGlobalTheme) return {
        colorMode: $a4534d0d8902e0f9$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $a4534d0d8902e0f9$var$cssVariablePattern = /^var\(--.*\)$/;
const $a4534d0d8902e0f9$export$363c8dda799bfe9c = (node)=>{
    var _node$attrs;
    const attrs = {};
    const nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
    if (node.attrs.background) {
        const { background: background } = node.attrs;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        const ignored = nodeType === 'tableHeader' && background === $a4534d0d8902e0f9$export$8cc2833b5b349a1e.get('light gray') || nodeType === 'tableCell' && background === $a4534d0d8902e0f9$export$8cc2833b5b349a1e.get('white') || nodeType === 'tableHeader' && background.includes('--ds-background-neutral');
        if (ignored) attrs.style = '';
        else {
            const color = (0, $51dYk.isRgb)(background) && (0, $51dYk.rgbToHex)(background) ? (0, $51dYk.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ const tokenColor = (0, $dyyJM.hexToEditorBackgroundPaletteRawValue)(color);
            if (tokenColor) attrs.style = `background-color: ${tokenColor};`;
            else if (/**
       * There was previously a bug in dark mode where we would attempt to invert
       * a design token in `getDarkModeLCHColor` causing issues.
       * If it's a design token we should return it as is.
       */ $a4534d0d8902e0f9$var$cssVariablePattern.test(color)) attrs.style = `background-color: ${color};`;
            else // if we have a custom color, we need to check if we are in dark mode
            if ($a4534d0d8902e0f9$var$getGlobalTheme().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
            attrs.style = `background-color: ${(0, $4PpDP.getDarkModeLCHColor)(color)};`;
            else // if we are in light mode, we can just set the color
            attrs.style = `background-color: ${background};`;
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs['data-cell-background'] = color;
            if (typeof color === 'string') attrs.colorname = $a4534d0d8902e0f9$export$219b7f492ad209f8.get(color.toLowerCase());
        }
    }
    if (nodeType === 'tableHeader') attrs.class = $a4534d0d8902e0f9$export$7b07d37d879c957f;
    else attrs.class = $a4534d0d8902e0f9$export$69cb4c3f80383763;
    if (node !== null && node !== void 0 && (_node$attrs = node.attrs) !== null && _node$attrs !== void 0 && _node$attrs.localId) attrs['data-local-id'] = node.attrs.localId;
    return attrs;
};
const $a4534d0d8902e0f9$export$219b7f492ad209f8 = new Map();
const $a4534d0d8902e0f9$export$95e9c925fbf01d1c = (0, $51dYk.hexToRgba)((0, $51dYk.N800), 0.12) || (0, $51dYk.N0);
const $a4534d0d8902e0f9$export$8cc2833b5b349a1e = new Map();
[
    [
        (0, $51dYk.N0),
        'White'
    ],
    [
        (0, $51dYk.B50),
        'Light blue'
    ],
    [
        (0, $51dYk.T50),
        'Light teal'
    ],
    [
        (0, $51dYk.G50),
        'Light green'
    ],
    [
        (0, $51dYk.Y50),
        'Light yellow'
    ],
    [
        (0, $51dYk.R50),
        'Light red'
    ],
    [
        (0, $51dYk.P50),
        'Light purple'
    ],
    [
        (0, $51dYk.N20),
        'Light gray'
    ],
    [
        (0, $51dYk.B75),
        'Blue'
    ],
    [
        (0, $51dYk.T75),
        'Teal'
    ],
    [
        (0, $51dYk.G75),
        'Green'
    ],
    [
        (0, $51dYk.Y75),
        'Yellow'
    ],
    [
        (0, $51dYk.R75),
        'Red'
    ],
    [
        (0, $51dYk.P75),
        'Purple'
    ],
    [
        (0, $51dYk.N60),
        'Gray'
    ],
    [
        (0, $51dYk.B100),
        'Dark blue'
    ],
    [
        (0, $51dYk.T100),
        'Dark teal'
    ],
    [
        (0, $51dYk.G200),
        'Dark green'
    ],
    [
        (0, $51dYk.Y200),
        'Dark yellow'
    ],
    [
        (0, $51dYk.R100),
        'Dark red'
    ],
    [
        (0, $51dYk.P100),
        'Dark purple'
    ]
].forEach(([colorValue, colorName])=>{
    $a4534d0d8902e0f9$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $a4534d0d8902e0f9$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
});
/**
 * @name table_node
 */ /**
 * @name table_row_node
 */ /**
 * @name table_cell_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name table_cell_node
 */ /**
 * @name table_header_node
 */ // table nodes with nested tables support
const $a4534d0d8902e0f9$var$tableNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'table',
            getAttrs: (node)=>{
                var _dom$parentElement;
                const dom = node;
                const breakoutWrapper = (_dom$parentElement = dom.parentElement) === null || _dom$parentElement === void 0 ? void 0 : _dom$parentElement.parentElement;
                return {
                    isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true',
                    layout: // copying from editor
                    dom.getAttribute('data-layout') || (breakoutWrapper === null || breakoutWrapper === void 0 ? void 0 : breakoutWrapper.getAttribute('data-layout')) || 'default',
                    __autoSize: dom.getAttribute('data-autosize') === 'true',
                    localId: dom.getAttribute('data-table-local-id') || (0, $2OrIX.uuid).generate(),
                    width: Number(dom.getAttribute('data-table-width')) || null,
                    displayMode: dom.getAttribute('data-table-display-mode') || null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-number-column': node.attrs.isNumberColumnEnabled,
            'data-layout': node.attrs.layout,
            'data-autosize': node.attrs.__autoSize,
            'data-table-local-id': node.attrs.localId,
            'data-table-width': node.attrs.width,
            'data-table-display-mode': node.attrs.displayMode
        };
        return [
            'table',
            attrs,
            [
                'tbody',
                0
            ]
        ];
    }
};
// TODO: Fix any, potential issue. ED-5048
const $a4534d0d8902e0f9$var$createTableSpec = ()=>(0, $nJVLW.table)($a4534d0d8902e0f9$var$tableNodeSpecOptions);
const $a4534d0d8902e0f9$export$9852986a3ec5f6a0 = $a4534d0d8902e0f9$var$createTableSpec();
const $a4534d0d8902e0f9$export$90e634fbace1f0c4 = $a4534d0d8902e0f9$var$createTableSpec();
const $a4534d0d8902e0f9$export$3862de5c8c9098cf = $a4534d0d8902e0f9$var$createTableSpec();
const $a4534d0d8902e0f9$var$shouldIncludeAttribute = (key, value)=>!key.startsWith('__') && (key !== 'localId' || !!value);
const $a4534d0d8902e0f9$export$1f92a2f429e06fa8 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>$a4534d0d8902e0f9$var$shouldIncludeAttribute(key, node.attrs[key])).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });
const $a4534d0d8902e0f9$var$tableRowNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'tr'
        }
    ],
    toDOM () {
        return [
            'tr',
            0
        ];
    }
};
const $a4534d0d8902e0f9$export$ce666bf02318c957 = (0, $nJVLW.tableRow)($a4534d0d8902e0f9$var$tableRowNodeSpecOptions);
const $a4534d0d8902e0f9$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    },
    localId: {
        default: null,
        optional: true
    }
};
const $a4534d0d8902e0f9$var$tableCellNodeSpecOptions = {
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: '.ak-renderer-table-number-column',
            ignore: true
        },
        {
            tag: 'td',
            getAttrs: (dom)=>$a4534d0d8902e0f9$export$43977bde391e007(dom)
        }
    ],
    toDOM: (node)=>[
            'td',
            $a4534d0d8902e0f9$export$363c8dda799bfe9c(node),
            0
        ]
};
const $a4534d0d8902e0f9$export$e1e720e5f4603e6a = (0, $nJVLW.tableCell)($a4534d0d8902e0f9$var$tableCellNodeSpecOptions);
const $a4534d0d8902e0f9$export$2ac34c099660f1a8 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            // Only process keys that are defined in cellAttrs
            if ($a4534d0d8902e0f9$var$cellAttrs[key] && $a4534d0d8902e0f9$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });
const $a4534d0d8902e0f9$var$tableHeaderNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: (dom)=>$a4534d0d8902e0f9$export$43977bde391e007(dom, {
                    background: $a4534d0d8902e0f9$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                })
        }
    ],
    toDOM: (node)=>[
            'th',
            $a4534d0d8902e0f9$export$363c8dda799bfe9c(node),
            0
        ]
};
const $a4534d0d8902e0f9$export$48884d2a5190dc73 = (0, $nJVLW.tableHeader)($a4534d0d8902e0f9$var$tableHeaderNodeSpecOptions);
const $a4534d0d8902e0f9$export$2af48797a1010bb1 = $a4534d0d8902e0f9$export$2ac34c099660f1a8;
const $a4534d0d8902e0f9$export$ce086a560a1d05f5 = (0, $nJVLW.tableWithNestedTable)($a4534d0d8902e0f9$var$tableNodeSpecOptions);
const $a4534d0d8902e0f9$export$7d657479499397 = (0, $nJVLW.tableRowWithNestedTable)($a4534d0d8902e0f9$var$tableRowNodeSpecOptions);
const $a4534d0d8902e0f9$export$abf39ca178940ff3 = (0, $nJVLW.tableCellWithNestedTable)($a4534d0d8902e0f9$var$tableCellNodeSpecOptions);
const $a4534d0d8902e0f9$export$2a5a518232fa1a97 = (0, $nJVLW.tableHeaderWithNestedTable)($a4534d0d8902e0f9$var$tableHeaderNodeSpecOptions);
// table nodes with localId support
const $a4534d0d8902e0f9$var$tableRowNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'tr',
            getAttrs: ()=>({
                    localId: (0, $2OrIX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs2;
        return [
            'tr',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
            },
            0
        ];
    }
};
const $a4534d0d8902e0f9$export$c8f0853ac97552c9 = (0, $nJVLW.tableRow)($a4534d0d8902e0f9$var$tableRowNodeSpecOptionsWithLocalId);
const $a4534d0d8902e0f9$var$tableCellNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'td',
            getAttrs: (dom)=>$a4534d0d8902e0f9$export$43977bde391e007(dom, {
                    localId: (0, $2OrIX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        return [
            'td',
            $a4534d0d8902e0f9$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
const $a4534d0d8902e0f9$export$db76cfd28a574029 = (0, $nJVLW.tableCell)($a4534d0d8902e0f9$var$tableCellNodeSpecOptionsWithLocalId);
const $a4534d0d8902e0f9$var$tableHeaderNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: (dom)=>$a4534d0d8902e0f9$export$43977bde391e007(dom, {
                    background: $a4534d0d8902e0f9$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND,
                    localId: (0, $2OrIX.uuid).generate()
                })
        }
    ],
    toDOM: (node)=>[
            'th',
            $a4534d0d8902e0f9$export$363c8dda799bfe9c(node),
            0
        ]
};
const $a4534d0d8902e0f9$export$b82d2b1d8824143d = (0, $nJVLW.tableHeader)($a4534d0d8902e0f9$var$tableHeaderNodeSpecOptionsWithLocalId);
const $a4534d0d8902e0f9$export$27926e30c8a74147 = (0, $nJVLW.tableRowWithNestedTable)($a4534d0d8902e0f9$var$tableRowNodeSpecOptionsWithLocalId);
const $a4534d0d8902e0f9$export$e9fd700fafee293a = (0, $nJVLW.tableCellWithNestedTable)($a4534d0d8902e0f9$var$tableCellNodeSpecOptionsWithLocalId);
const $a4534d0d8902e0f9$export$7928c3aeb4cd2213 = (0, $nJVLW.tableHeaderWithNestedTable)($a4534d0d8902e0f9$var$tableHeaderNodeSpecOptionsWithLocalId);

});
parcelRegister("dyyJM", function(module, exports) {
$parcel$export(module.exports, "hexToEditorBorderPaletteColor", () => $028c05c3f3022d58$export$bad3c41dd33cb4bc);
$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $028c05c3f3022d58$export$9c2f408d391feb93);
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $028c05c3f3022d58$export$8b58ff1b36bb75e0);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $028c05c3f3022d58$export$a270511a0e7fd61a);

var $59rsN = parcelRequire("59rsN");
function $028c05c3f3022d58$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $028c05c3f3022d58$export$aa000893c5e2b9c2[hexColor.toUpperCase()] : undefined;
}
const $028c05c3f3022d58$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ '#091E4224': 'var(--ds-border, #091E4224)',
    /** gray */ '#758195': 'var(--ds-border-bold, #758195)',
    /** gray - bold */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $028c05c3f3022d58$export$9c2f408d391feb93(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $028c05c3f3022d58$export$57fa5089caad992[hexColor.toUpperCase()] : undefined;
}
const $028c05c3f3022d58$export$57fa5089caad992 = {
    /** blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** blue - medium */ '#4C9AFF': 'var(--ds-icon-accent-blue, #4C9AFF)',
    /** blue - strong */ '#0747A6': 'var(--ds-text-accent-blue, #0747A6)',
    /** teal - light */ '#B3F5FF': 'var(--ds-background-accent-teal-subtler, #B3F5FF)',
    /** teal - medium */ '#00B8D9': 'var(--ds-icon-accent-teal, #00B8D9)',
    /** teal - strong */ '#008DA6': 'var(--ds-text-accent-teal, #008DA6)',
    /** green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)',
    /** green - medium */ '#36B37E': 'var(--ds-icon-accent-green, #36B37E)',
    /** green - strong */ '#006644': 'var(--ds-text-accent-green, #006644)',
    /** yellowOrange - light */ '#FFF0B3': 'var(--ds-background-accent-yellow-subtler, #FFF0B3)',
    /** yellowOrange - medium */ '#FFC400': 'var(--ds-background-accent-orange-subtle, #FFC400)',
    /** yellowOrange - strong */ '#FF991F': 'var(--ds-icon-accent-orange, #FF991F)',
    /** red - light */ '#FFBDAD': 'var(--ds-background-accent-red-subtler, #FFBDAD)',
    /** red - medium */ '#FF5630': 'var(--ds-icon-accent-red, #FF5630)',
    /** red - strong */ '#BF2600': 'var(--ds-text-accent-red, #BF2600)',
    /** purple - light */ '#EAE6FF': 'var(--ds-background-accent-purple-subtler, #EAE6FF)',
    /** purple - medium */ '#6554C0': 'var(--ds-icon-accent-purple, #6554C0)',
    /** purple - strong */ '#403294': 'var(--ds-text-accent-purple, #403294)',
    /** whiteGray - light */ '#FFFFFF': 'var(--ds-text-inverse, #FFFFFF)',
    /** whiteGray - medium */ '#97A0AF': 'var(--ds-icon-accent-gray, #97A0AF)',
    /** whiteGray - strong */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $028c05c3f3022d58$export$8b58ff1b36bb75e0(hexColor) {
    if ((0, $59rsN.default).getExperimentValue('platform_editor_add_orange_highlight_color', 'cohort', 'control') !== 'test') $028c05c3f3022d58$export$12a518ff137dd389['#FEDEC8'] = 'var(--ds-background-accent-yellow-subtler, #F8E6A0)';
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    return hexColor ? $028c05c3f3022d58$export$12a518ff137dd389[hexColor.toUpperCase()] : undefined;
}
const $028c05c3f3022d58$export$12a518ff137dd389 = {
    /** Gray - light */ '#DCDFE4': 'var(--ds-background-accent-gray-subtler, #DCDFE4)',
    /** Teal - light */ '#C6EDFB': 'var(--ds-background-accent-teal-subtler, #C6EDFB)',
    /** Lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** Yellow - light */ '#F8E6A0': 'var(--ds-background-accent-yellow-subtler, #F8E6A0)',
    /** Orange - light */ '#FEDEC8': 'var(--ds-background-accent-orange-subtler, #FEDEC8)',
    /** Magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** Purple - light */ '#DFD8FD': 'var(--ds-background-accent-purple-subtler, #DFD8FD)'
};
function $028c05c3f3022d58$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    const tokenData = hexColor ? $028c05c3f3022d58$export$2462741d70e6a62f[hexColor.toUpperCase()] : undefined;
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $028c05c3f3022d58$export$2462741d70e6a62f = {
    /** blue - light */ '#DEEBFF': {
        getValue: ()=>'#DEEBFF',
        token: 'var(--ds-background-accent-blue-subtlest, #DEEBFF)'
    },
    /** blue - medium */ '#B3D4FF': {
        getValue: ()=>'#B3D4FF',
        token: 'var(--ds-background-accent-blue-subtler, #B3D4FF)'
    },
    /** blue - strong */ '#4C9AFF': {
        getValue: ()=>'#4C9AFF',
        token: 'var(--ds-background-accent-blue-subtle, #4C9AFF)'
    },
    /** teal - light */ '#E6FCFF': {
        getValue: ()=>'#E6FCFF',
        token: 'var(--ds-background-accent-teal-subtlest, #E6FCFF)'
    },
    /** teal - medium */ '#B3F5FF': {
        getValue: ()=>'#B3F5FF',
        token: 'var(--ds-background-accent-teal-subtler, #B3F5FF)'
    },
    /** teal - strong */ '#79E2F2': {
        getValue: ()=>'#79E2F2',
        token: 'var(--ds-background-accent-teal-subtle, #79E2F2)'
    },
    /** green - light */ '#E3FCEF': {
        getValue: ()=>'#E3FCEF',
        token: 'var(--ds-background-accent-green-subtlest, #E3FCEF)'
    },
    /** green - medium */ '#ABF5D1': {
        getValue: ()=>'#ABF5D1',
        token: 'var(--ds-background-accent-green-subtler, #ABF5D1)'
    },
    /** green - strong */ '#57D9A3': {
        getValue: ()=>'#57D9A3',
        token: 'var(--ds-background-accent-green-subtle, #57D9A3)'
    },
    /** yellowOrange - light */ '#FFFAE6': {
        getValue: ()=>'#FFFAE6',
        token: 'var(--ds-background-accent-yellow-subtlest, #FFFAE6)'
    },
    /** yellowOrange - medium */ '#FFF0B3': {
        getValue: ()=>'#FFF0B3',
        token: 'var(--ds-background-accent-yellow-subtler, #FFF0B3)'
    },
    /** yellowOrange - strong */ '#FFC400': {
        getValue: ()=>'#FFC400',
        token: 'var(--ds-background-accent-orange-subtle, #FFC400)'
    },
    /** red - light */ '#FFEBE6': {
        getValue: ()=>'#FFEBE6',
        token: 'var(--ds-background-accent-red-subtlest, #FFEBE6)'
    },
    /** red - medium */ '#FFBDAD': {
        getValue: ()=>'#FFBDAD',
        token: 'var(--ds-background-accent-red-subtler, #FFBDAD)'
    },
    /** red - strong */ '#FF8F73': {
        getValue: ()=>'#FF8F73',
        token: 'var(--ds-background-accent-red-subtle, #FF8F73)'
    },
    /** purple - light */ '#EAE6FF': {
        getValue: ()=>'#EAE6FF',
        token: 'var(--ds-background-accent-purple-subtlest, #EAE6FF)'
    },
    /** purple - medium */ '#C0B6F2': {
        getValue: ()=>'#C0B6F2',
        token: 'var(--ds-background-accent-purple-subtler, #C0B6F2)'
    },
    /** purple - strong */ '#998DD9': {
        getValue: ()=>'#998DD9',
        token: 'var(--ds-background-accent-purple-subtle, #998DD9)'
    },
    /** whiteGray - light */ '#FFFFFF': {
        getValue: ()=>'#FFFFFF',
        token: 'var(--ds-surface, #FFFFFF)'
    },
    /** whiteGray - medium */ '#F4F5F7': {
        getValue: ()=>'#F4F5F7',
        token: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
    },
    /** whiteGray - strong */ '#B3BAC5': {
        getValue: ()=>'#B3BAC5',
        token: 'var(--ds-background-accent-gray-subtle, #B3BAC5)'
    }
};

});

parcelRegister("51dYk", function(module, exports) {
$parcel$export(module.exports, "R50", () => $3a77e248cfc93706$export$4b84fd0e2c617bd);
$parcel$export(module.exports, "R75", () => $3a77e248cfc93706$export$b34b069eff244586);
$parcel$export(module.exports, "R100", () => $3a77e248cfc93706$export$be802dd0d8b57f35);
$parcel$export(module.exports, "R300", () => $3a77e248cfc93706$export$4a7404f376229999);
$parcel$export(module.exports, "R500", () => $3a77e248cfc93706$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y50", () => $3a77e248cfc93706$export$8d9596b529bbb9cf);
$parcel$export(module.exports, "Y75", () => $3a77e248cfc93706$export$41060a744ab0b7ae);
$parcel$export(module.exports, "Y200", () => $3a77e248cfc93706$export$5aae31392d72caaa);
$parcel$export(module.exports, "Yellow200", () => $3a77e248cfc93706$export$fc857b6f8771648a);
$parcel$export(module.exports, "Y400", () => $3a77e248cfc93706$export$59619663aa6500fb);
$parcel$export(module.exports, "G50", () => $3a77e248cfc93706$export$8a6341c32b6a3ee6);
$parcel$export(module.exports, "G75", () => $3a77e248cfc93706$export$69a3bf21b9686c2b);
$parcel$export(module.exports, "G200", () => $3a77e248cfc93706$export$747d86715d4175de);
$parcel$export(module.exports, "G300", () => $3a77e248cfc93706$export$940e1f69e873f202);
$parcel$export(module.exports, "G500", () => $3a77e248cfc93706$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "B50", () => $3a77e248cfc93706$export$226de0355ed012f8);
$parcel$export(module.exports, "B75", () => $3a77e248cfc93706$export$8c13c2ee36917869);
$parcel$export(module.exports, "B100", () => $3a77e248cfc93706$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "B400", () => $3a77e248cfc93706$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $3a77e248cfc93706$export$a6ee3d71bc067634);
$parcel$export(module.exports, "L200", () => $3a77e248cfc93706$export$f72948ef771f6f15);
$parcel$export(module.exports, "N0", () => $3a77e248cfc93706$export$29a4f05edc054374);
$parcel$export(module.exports, "N20", () => $3a77e248cfc93706$export$9fdfb749e33cdf97);
$parcel$export(module.exports, "N30", () => $3a77e248cfc93706$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N40", () => $3a77e248cfc93706$export$1ce2d1575d444ceb);
$parcel$export(module.exports, "N50", () => $3a77e248cfc93706$export$8754fc7e6d8b3000);
$parcel$export(module.exports, "N60", () => $3a77e248cfc93706$export$c2e91cbeada39b8b);
$parcel$export(module.exports, "N80", () => $3a77e248cfc93706$export$eaa8c8a70ac22806);
$parcel$export(module.exports, "N200", () => $3a77e248cfc93706$export$f563ee71e9ee74cd);
$parcel$export(module.exports, "N300", () => $3a77e248cfc93706$export$e2ef2124cf4024b1);
$parcel$export(module.exports, "Neutral300", () => $3a77e248cfc93706$export$1ae1cebe22dcedb4);
$parcel$export(module.exports, "N300A", () => $3a77e248cfc93706$export$13609db0e6812ab8);
$parcel$export(module.exports, "N500", () => $3a77e248cfc93706$export$c39c0fe0f26207ae);
$parcel$export(module.exports, "N600", () => $3a77e248cfc93706$export$7090862dc3038a9f);
$parcel$export(module.exports, "N800", () => $3a77e248cfc93706$export$7d61b15e0da132af);
$parcel$export(module.exports, "N1000", () => $3a77e248cfc93706$export$f78789c8b01753cd);
$parcel$export(module.exports, "M200", () => $3a77e248cfc93706$export$a19f0c33186f7767);
$parcel$export(module.exports, "O200", () => $3a77e248cfc93706$export$51716a84e62e022c);
$parcel$export(module.exports, "P50", () => $3a77e248cfc93706$export$363e4475840015bb);
$parcel$export(module.exports, "P75", () => $3a77e248cfc93706$export$4b0a4417ed59760f);
$parcel$export(module.exports, "P100", () => $3a77e248cfc93706$export$6011520a64d9a187);
$parcel$export(module.exports, "P200", () => $3a77e248cfc93706$export$a7175d4e9206bc80);
$parcel$export(module.exports, "P300", () => $3a77e248cfc93706$export$b48405b95304b5a1);
$parcel$export(module.exports, "P500", () => $3a77e248cfc93706$export$147899de772240ec);
$parcel$export(module.exports, "T50", () => $3a77e248cfc93706$export$2cf711fe14c66f06);
$parcel$export(module.exports, "T75", () => $3a77e248cfc93706$export$7a8f4d33f6f9772c);
$parcel$export(module.exports, "T100", () => $3a77e248cfc93706$export$776c9c497ef08533);
$parcel$export(module.exports, "T200", () => $3a77e248cfc93706$export$69cb3ca10c1e330e);
$parcel$export(module.exports, "T300", () => $3a77e248cfc93706$export$9dc1ef0f3f48059b);
$parcel$export(module.exports, "T500", () => $3a77e248cfc93706$export$6036577f95c3877e);
$parcel$export(module.exports, "normalizeHexColor", () => $3a77e248cfc93706$export$b61655071712e690);
$parcel$export(module.exports, "isHex", () => $3a77e248cfc93706$export$8a9b6341a7c96bc);
$parcel$export(module.exports, "isRgb", () => $3a77e248cfc93706$export$e698776ec826343);
$parcel$export(module.exports, "rgbToHex", () => $3a77e248cfc93706$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgb", () => $3a77e248cfc93706$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToRgba", () => $3a77e248cfc93706$export$9665a07d9187b414);

var $k9rAg = parcelRequire("k9rAg");
const $3a77e248cfc93706$export$4b84fd0e2c617bd = '#FFEBE6';
const $3a77e248cfc93706$export$b34b069eff244586 = '#FFBDAD';
const $3a77e248cfc93706$export$be802dd0d8b57f35 = '#FF8F73';
const $3a77e248cfc93706$export$4a7404f376229999 = '#FF5630';
const $3a77e248cfc93706$export$2010d0fb4295b346 = '#DE350B';
const $3a77e248cfc93706$export$2837b5a1a71d5c02 = '#BF2600';
const $3a77e248cfc93706$export$8d9596b529bbb9cf = '#FFFAE6';
const $3a77e248cfc93706$export$41060a744ab0b7ae = '#FFF0B3';
const $3a77e248cfc93706$export$5aae31392d72caaa = '#FFC400';
const $3a77e248cfc93706$export$fc857b6f8771648a = '#F8E6A0';
const $3a77e248cfc93706$export$59619663aa6500fb = '#FF991F';
const $3a77e248cfc93706$export$874739ea9e379ab6 = '#FF8B00';
const $3a77e248cfc93706$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $3a77e248cfc93706$export$69a3bf21b9686c2b = '#ABF5D1';
const $3a77e248cfc93706$export$747d86715d4175de = '#57D9A3';
const $3a77e248cfc93706$export$940e1f69e873f202 = '#36B37E';
const $3a77e248cfc93706$export$a49394138f7b8e85 = '#00875A';
const $3a77e248cfc93706$export$6fa04827ac68a4fb = '#006644';
const $3a77e248cfc93706$export$226de0355ed012f8 = '#DEEBFF';
const $3a77e248cfc93706$export$8c13c2ee36917869 = '#B3D4FF';
const $3a77e248cfc93706$export$ecfc1dff386a3e7a = '#4C9AFF';
const $3a77e248cfc93706$export$b3de0ae08da2ce64 = '#0052CC';
const $3a77e248cfc93706$export$a6ee3d71bc067634 = '#0747A6';
const $3a77e248cfc93706$export$f72948ef771f6f15 = '#D3F1A7';
const $3a77e248cfc93706$export$29a4f05edc054374 = '#FFFFFF';
const $3a77e248cfc93706$export$9fdfb749e33cdf97 = '#F4F5F7';
const $3a77e248cfc93706$export$3e51e8f1440314ba = '#EBECF0';
const $3a77e248cfc93706$export$1ce2d1575d444ceb = '#DFE1E6';
const $3a77e248cfc93706$export$8754fc7e6d8b3000 = '#C1C7D0';
const $3a77e248cfc93706$export$c2e91cbeada39b8b = '#B3BAC5';
const $3a77e248cfc93706$export$eaa8c8a70ac22806 = '#97A0AF';
const $3a77e248cfc93706$export$7c87d337fb91a97d = '#8993A4';
const $3a77e248cfc93706$export$f563ee71e9ee74cd = '#6B778C';
const $3a77e248cfc93706$export$e2ef2124cf4024b1 = '#5E6C84';
const $3a77e248cfc93706$export$1ae1cebe22dcedb4 = '#DCDFE4';
const $3a77e248cfc93706$export$13609db0e6812ab8 = '#091E4224';
const $3a77e248cfc93706$export$c39c0fe0f26207ae = '#42526E';
const $3a77e248cfc93706$export$7090862dc3038a9f = '#758195';
const $3a77e248cfc93706$export$7d61b15e0da132af = '#172B4D';
const $3a77e248cfc93706$export$f78789c8b01753cd = '#172B4D';
const $3a77e248cfc93706$export$a19f0c33186f7767 = '#FDD0EC';
const $3a77e248cfc93706$export$51716a84e62e022c = '#FEDEC8';
const $3a77e248cfc93706$export$363e4475840015bb = '#EAE6FF';
const $3a77e248cfc93706$export$4b0a4417ed59760f = '#C0B6F2';
const $3a77e248cfc93706$export$6011520a64d9a187 = '#998DD9';
const $3a77e248cfc93706$export$a7175d4e9206bc80 = '#DFD8FD';
const $3a77e248cfc93706$export$b48405b95304b5a1 = '#6554C0';
const $3a77e248cfc93706$export$c71e4279dd54a18d = '#5243AA';
const $3a77e248cfc93706$export$147899de772240ec = '#403294';
const $3a77e248cfc93706$export$2cf711fe14c66f06 = '#E6FCFF';
const $3a77e248cfc93706$export$7a8f4d33f6f9772c = '#B3F5FF';
const $3a77e248cfc93706$export$776c9c497ef08533 = '#79E2F2';
const $3a77e248cfc93706$export$69cb3ca10c1e330e = '#C6EDFB';
const $3a77e248cfc93706$export$9dc1ef0f3f48059b = '#00B8D9';
const $3a77e248cfc93706$export$6036577f95c3877e = '#008DA6';
function $3a77e248cfc93706$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ($3a77e248cfc93706$export$8a9b6341a7c96bc(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split('').map((c)=>c === '#' ? '#' : `${c}${c}`).join('');
    } else if ($3a77e248cfc93706$export$e698776ec826343(color)) return $3a77e248cfc93706$export$34d09c4a771c46ef(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === 'default') return null;
        else if ($k9rAg.default && $k9rAg.default[color]) color = $k9rAg.default[color];
        else if ($k9rAg && $k9rAg[color]) color = $k9rAg[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}
function $3a77e248cfc93706$export$5a544e13ad4e1fa5(color) {
    if (!$3a77e248cfc93706$export$8a9b6341a7c96bc(color)) return null;
    let colorBits = color.substring(1).split('');
    if (colorBits.length === 3) colorBits = [
        colorBits[0],
        colorBits[0],
        colorBits[1],
        colorBits[1],
        colorBits[2],
        colorBits[2]
    ];
    const rgb = Number(`0x${colorBits.join('')}`);
    // eslint-disable-next-line no-bitwise
    return `rgb(${rgb >> 16 & 255},${rgb >> 8 & 255},${rgb & 255})`;
}
function $3a77e248cfc93706$export$9665a07d9187b414(rawColor, alpha) {
    const color = $3a77e248cfc93706$export$b61655071712e690(rawColor);
    if (!color) return null;
    const hex2rgb = (color)=>color.match(/[a-z0-9]{2}/gi).map((hex)=>parseInt(hex, 16));
    return `rgba(${hex2rgb(color).concat(alpha).join(',')})`;
}
function $3a77e248cfc93706$export$34d09c4a771c46ef(value) {
    const matches = value.match(/(0?\.?\d{1,3})%?\b/g);
    if (matches && matches.length >= 3) {
        const [red, green, blue] = matches.map(Number);
        return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1) // eslint-disable-line no-bitwise
        ;
    }
    return null;
}
function $3a77e248cfc93706$export$e698776ec826343(color) {
    return /rgba?\(/.test(color);
}
function $3a77e248cfc93706$export$8a9b6341a7c96bc(color) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
}

});
parcelRegister("k9rAg", function(module, exports) {
module.exports = JSON.parse("{\"aliceblue\":\"#f0f8ff\",\"antiquewhite\":\"#faebd7\",\"aqua\":\"#00ffff\",\"aquamarine\":\"#7fffd4\",\"azure\":\"#f0ffff\",\"beige\":\"#f5f5dc\",\"bisque\":\"#ffe4c4\",\"black\":\"#000000\",\"blanchedalmond\":\"#ffebcd\",\"blue\":\"#0000ff\",\"blueviolet\":\"#8a2be2\",\"brown\":\"#a52a2a\",\"burlywood\":\"#deb887\",\"cadetblue\":\"#5f9ea0\",\"chartreuse\":\"#7fff00\",\"chocolate\":\"#d2691e\",\"coral\":\"#ff7f50\",\"cornflowerblue\":\"#6495ed\",\"cornsilk\":\"#fff8dc\",\"crimson\":\"#dc143c\",\"cyan\":\"#00ffff\",\"darkblue\":\"#00008b\",\"darkcyan\":\"#008b8b\",\"darkgoldenrod\":\"#b8860b\",\"darkgray\":\"#a9a9a9\",\"darkgreen\":\"#006400\",\"darkgrey\":\"#a9a9a9\",\"darkkhaki\":\"#bdb76b\",\"darkmagenta\":\"#8b008b\",\"darkolivegreen\":\"#556b2f\",\"darkorange\":\"#ff8c00\",\"darkorchid\":\"#9932cc\",\"darkred\":\"#8b0000\",\"darksalmon\":\"#e9967a\",\"darkseagreen\":\"#8fbc8f\",\"darkslateblue\":\"#483d8b\",\"darkslategray\":\"#2f4f4f\",\"darkslategrey\":\"#2f4f4f\",\"darkturquoise\":\"#00ced1\",\"darkviolet\":\"#9400d3\",\"deeppink\":\"#ff1493\",\"deepskyblue\":\"#00bfff\",\"dimgray\":\"#696969\",\"dimgrey\":\"#696969\",\"dodgerblue\":\"#1e90ff\",\"firebrick\":\"#b22222\",\"floralwhite\":\"#fffaf0\",\"forestgreen\":\"#228b22\",\"fuchsia\":\"#ff00ff\",\"gainsboro\":\"#dcdcdc\",\"ghostwhite\":\"#f8f8ff\",\"gold\":\"#ffd700\",\"goldenrod\":\"#daa520\",\"gray\":\"#808080\",\"green\":\"#008000\",\"greenyellow\":\"#adff2f\",\"grey\":\"#808080\",\"honeydew\":\"#f0fff0\",\"hotpink\":\"#ff69b4\",\"indianred\":\"#cd5c5c\",\"indigo\":\"#4b0082\",\"ivory\":\"#fffff0\",\"khaki\":\"#f0e68c\",\"lavender\":\"#e6e6fa\",\"lavenderblush\":\"#fff0f5\",\"lawngreen\":\"#7cfc00\",\"lemonchiffon\":\"#fffacd\",\"lightblue\":\"#add8e6\",\"lightcoral\":\"#f08080\",\"lightcyan\":\"#e0ffff\",\"lightgoldenrodyellow\":\"#fafad2\",\"lightgray\":\"#d3d3d3\",\"lightgreen\":\"#90ee90\",\"lightgrey\":\"#d3d3d3\",\"lightpink\":\"#ffb6c1\",\"lightsalmon\":\"#ffa07a\",\"lightseagreen\":\"#20b2aa\",\"lightskyblue\":\"#87cefa\",\"lightslategray\":\"#778899\",\"lightslategrey\":\"#778899\",\"lightsteelblue\":\"#b0c4de\",\"lightyellow\":\"#ffffe0\",\"lime\":\"#00ff00\",\"limegreen\":\"#32cd32\",\"linen\":\"#faf0e6\",\"magenta\":\"#ff00ff\",\"maroon\":\"#800000\",\"mediumaquamarine\":\"#66cdaa\",\"mediumblue\":\"#0000cd\",\"mediumorchid\":\"#ba55d3\",\"mediumpurple\":\"#9370db\",\"mediumseagreen\":\"#3cb371\",\"mediumslateblue\":\"#7b68ee\",\"mediumspringgreen\":\"#00fa9a\",\"mediumturquoise\":\"#48d1cc\",\"mediumvioletred\":\"#c71585\",\"midnightblue\":\"#191970\",\"mintcream\":\"#f5fffa\",\"mistyrose\":\"#ffe4e1\",\"moccasin\":\"#ffe4b5\",\"navajowhite\":\"#ffdead\",\"navy\":\"#000080\",\"oldlace\":\"#fdf5e6\",\"olive\":\"#808000\",\"olivedrab\":\"#6b8e23\",\"orange\":\"#ffa500\",\"orangered\":\"#ff4500\",\"orchid\":\"#da70d6\",\"palegoldenrod\":\"#eee8aa\",\"palegreen\":\"#98fb98\",\"paleturquoise\":\"#afeeee\",\"palevioletred\":\"#db7093\",\"papayawhip\":\"#ffefd5\",\"peachpuff\":\"#ffdab9\",\"peru\":\"#cd853f\",\"pink\":\"#ffc0cb\",\"plum\":\"#dda0dd\",\"powderblue\":\"#b0e0e6\",\"purple\":\"#800080\",\"rebeccapurple\":\"#663399\",\"red\":\"#ff0000\",\"rosybrown\":\"#bc8f8f\",\"royalblue\":\"#4169e1\",\"saddlebrown\":\"#8b4513\",\"salmon\":\"#fa8072\",\"sandybrown\":\"#f4a460\",\"seagreen\":\"#2e8b57\",\"seashell\":\"#fff5ee\",\"sienna\":\"#a0522d\",\"silver\":\"#c0c0c0\",\"skyblue\":\"#87ceeb\",\"slateblue\":\"#6a5acd\",\"slategray\":\"#708090\",\"slategrey\":\"#708090\",\"snow\":\"#fffafa\",\"springgreen\":\"#00ff7f\",\"steelblue\":\"#4682b4\",\"tan\":\"#d2b48c\",\"teal\":\"#008080\",\"thistle\":\"#d8bfd8\",\"tomato\":\"#ff6347\",\"turquoise\":\"#40e0d0\",\"violet\":\"#ee82ee\",\"wheat\":\"#f5deb3\",\"white\":\"#ffffff\",\"whitesmoke\":\"#f5f5f5\",\"yellow\":\"#ffff00\",\"yellowgreen\":\"#9acd32\"}");

});


parcelRegister("4PpDP", function(module, exports) {
$parcel$export(module.exports, "getDarkModeLCHColor", () => $383fd0b1d61f7ae7$export$a5065c3b8aacaf99);
// https://en.wikipedia.org/wiki/HCL_color_space
// https://en.wikipedia.org/wiki/CIE_1931_color_space#CIE_xy_chromaticity_diagram_and_the_CIE_xyY_color_space
// https://en.wikipedia.org/wiki/CIELAB_color_space
const $383fd0b1d61f7ae7$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $383fd0b1d61f7ae7$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b)=>r + r + g + g + b + b);
const $383fd0b1d61f7ae7$var$rgbFromHex = (input)=>{
    const fullHex = $383fd0b1d61f7ae7$var$expandShorthandHex(input);
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
const $383fd0b1d61f7ae7$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $383fd0b1d61f7ae7$var$rgbToXyz = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
const $383fd0b1d61f7ae7$var$xyzToLab = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });
const $383fd0b1d61f7ae7$var$labToLch = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
const $383fd0b1d61f7ae7$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $383fd0b1d61f7ae7$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $383fd0b1d61f7ae7$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $383fd0b1d61f7ae7$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $383fd0b1d61f7ae7$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $383fd0b1d61f7ae7$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $383fd0b1d61f7ae7$var$rgbToLch = (rgb)=>$383fd0b1d61f7ae7$var$labToLch($383fd0b1d61f7ae7$var$xyzToLab($383fd0b1d61f7ae7$var$rgbToXyz(rgb)));
const $383fd0b1d61f7ae7$var$lchToRgb = (lch)=>$383fd0b1d61f7ae7$var$xyzToRgb($383fd0b1d61f7ae7$var$labToXyz($383fd0b1d61f7ae7$var$lchToLab(lch)));
const $383fd0b1d61f7ae7$export$313b8a8fcb34c3b8 = (color, newPercent)=>{
    const rgb = $383fd0b1d61f7ae7$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $383fd0b1d61f7ae7$var$rgbToLch(rgb);
    lch.l = $383fd0b1d61f7ae7$var$clamp(newPercent, 0, 100);
    return $383fd0b1d61f7ae7$var$rgbToHex($383fd0b1d61f7ae7$var$lchToRgb(lch));
};
const $383fd0b1d61f7ae7$var$getLightness = (color)=>{
    const rgb = $383fd0b1d61f7ae7$var$rgbFromHex(color);
    if (rgb === null) return 0;
    const lch = $383fd0b1d61f7ae7$var$rgbToLch(rgb);
    return lch.l;
};
const $383fd0b1d61f7ae7$export$a5065c3b8aacaf99 = (currentBackgroundColor)=>{
    const lightness = $383fd0b1d61f7ae7$var$getLightness(currentBackgroundColor);
    const newLightness = Math.abs(100 - lightness);
    return $383fd0b1d61f7ae7$export$313b8a8fcb34c3b8(currentBackgroundColor, newLightness).toUpperCase();
};

});


parcelRegister("g7Jv8", function(module, exports) {
$parcel$export(module.exports, "createSchema", () => $bbd098624269520c$export$5f4ce795563f4211);

var $3xw6l = parcelRequire("3xw6l");


var $mYA6R = parcelRequire("mYA6R");

var $fRfD8 = parcelRequire("fRfD8");
var $jxPcD = parcelRequire("jxPcD");
var $7i9jz = parcelRequire("7i9jz");
var $3Pxk9 = parcelRequire("3Pxk9");
var $7uhRT = parcelRequire("7uhRT");
var $eA6GD = parcelRequire("eA6GD");
var $04SjV = parcelRequire("04SjV");
var $dHJym = parcelRequire("dHJym");
var $eonww = parcelRequire("eonww");
var $6Ymtk = parcelRequire("6Ymtk");
var $7GG3N = parcelRequire("7GG3N");
var $h9kgv = parcelRequire("h9kgv");
var $f4V9T = parcelRequire("f4V9T");
var $YKDO7 = parcelRequire("YKDO7");
var $hI6rl = parcelRequire("hI6rl");
var $abZsg = parcelRequire("abZsg");
var $anaPs = parcelRequire("anaPs");
var $b7o0x = parcelRequire("b7o0x");
var $kdb0W = parcelRequire("kdb0W");
var $3pgGD = parcelRequire("3pgGD");

var $5sqgz = parcelRequire("5sqgz");
var $5iuEY = parcelRequire("5iuEY");
var $kuVVV = parcelRequire("kuVVV");
var $dMcxi = parcelRequire("dMcxi");
var $7T1su = parcelRequire("7T1su");
var $l2o3P = parcelRequire("l2o3P");
var $02BNy = parcelRequire("02BNy");
var $itOTx = parcelRequire("itOTx");
var $99RFR = parcelRequire("99RFR");
var $4LGm1 = parcelRequire("4LGm1");
var $s7CHM = parcelRequire("s7CHM");
var $eblOZ = parcelRequire("eblOZ");
var $9FkNK = parcelRequire("9FkNK");
var $gjQyF = parcelRequire("gjQyF");
var $YIci7 = parcelRequire("YIci7");
var $foHUC = parcelRequire("foHUC");
var $eSKW9 = parcelRequire("eSKW9");
var $iBSvH = parcelRequire("iBSvH");
var $ePdnq = parcelRequire("ePdnq");
var $6r1B4 = parcelRequire("6r1B4");
var $6C9Qx = parcelRequire("6C9Qx");
var $ewUmv = parcelRequire("ewUmv");
var $8FGKL = parcelRequire("8FGKL");
var $lM0g9 = parcelRequire("lM0g9");
var $3MHOZ = parcelRequire("3MHOZ");
var $5Ufvu = parcelRequire("5Ufvu");
var $gNk91 = parcelRequire("gNk91");
var $jSvxD = parcelRequire("jSvxD");
var $gkLMH = parcelRequire("gkLMH");
var $bTlUc = parcelRequire("bTlUc");
var $goVGV = parcelRequire("goVGV");
var $5RVMs = parcelRequire("5RVMs");
var $8Mfla = parcelRequire("8Mfla");
var $7axvl = parcelRequire("7axvl");
var $6UEeD = parcelRequire("6UEeD");
var $a4ifE = parcelRequire("a4ifE");
var $bK3tx = parcelRequire("bK3tx");
var $hbObi = parcelRequire("hbObi");
var $jC4KP = parcelRequire("jC4KP");
var $c2Gqu = parcelRequire("c2Gqu");
var $hn1YX = parcelRequire("hn1YX");
var $e6HpD = parcelRequire("e6HpD");
var $6Yq90 = parcelRequire("6Yq90");
var $53i5t = parcelRequire("53i5t");
var $bffKB = parcelRequire("bffKB");
var $e1kFZ = parcelRequire("e1kFZ");
var $5blh0 = parcelRequire("5blh0");
function $bbd098624269520c$var$addItems(builtInItems, config, customSpecs = {}) {
    if (!config) return {};
    /**
   * Add built-in Node / Mark specs
   */ const items = builtInItems.reduce((items, { name: name, spec: spec })=>{
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
   * Add Custom Node / Mark specs
   */ return Object.keys(customSpecs).reduce((items, name)=>{
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}
// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
//
// To avoid the problem, we include items that serve to "declare" the groups in the schema. This
// approach unfortunately leaves unused items in the schema, but has the benefit of avoiding the
// need to manipulate `exclude` or content expression values for potentially every schema item.
function $bbd098624269520c$var$groupDeclaration(name) {
    return {
        name: `__${name}GroupDeclaration`,
        spec: {
            group: name
        }
    };
}
const $bbd098624269520c$var$markGroupDeclarations = [
    $bbd098624269520c$var$groupDeclaration((0, $212f88bb056bb83b$export$9b982809044276a6)),
    $bbd098624269520c$var$groupDeclaration((0, $212f88bb056bb83b$export$4498a6080fed604c)),
    $bbd098624269520c$var$groupDeclaration((0, $212f88bb056bb83b$export$f8e8a5f34f6ea725)),
    $bbd098624269520c$var$groupDeclaration((0, $212f88bb056bb83b$export$b395009ca7f092c7))
];
const $bbd098624269520c$var$markGroupDeclarationsNames = $bbd098624269520c$var$markGroupDeclarations.map((groupMark)=>groupMark.name);
const $bbd098624269520c$var$nodesInOrder = [
    {
        name: 'doc',
        spec: (0, $gjQyF.doc)
    },
    {
        name: 'paragraph',
        spec: (0, $bK3tx.paragraph)
    },
    {
        name: 'text',
        spec: (0, $53i5t.text)
    },
    {
        name: 'bulletList',
        spec: (0, $7T1su.bulletList)
    },
    {
        name: 'orderedList',
        spec: (0, $a4ifE.orderedListWithOrder)
    },
    {
        name: 'listItem',
        spec: (0, $gkLMH.listItem)
    },
    {
        name: 'heading',
        spec: (0, $8FGKL.heading)
    },
    {
        name: 'blockquote',
        spec: (0, $iBSvH.extendedBlockquote)
    },
    {
        name: 'codeBlock',
        spec: (0, $02BNy.codeBlock)
    },
    {
        name: 'panel',
        spec: (0, $ePdnq.extendedPanel)(true)
    },
    {
        name: 'rule',
        spec: (0, $jC4KP.rule)
    },
    {
        name: 'image',
        spec: (0, $lM0g9.image)
    },
    {
        name: 'mention',
        spec: (0, $7axvl.mention)
    },
    {
        name: 'caption',
        spec: (0, $l2o3P.caption)
    },
    {
        name: 'media',
        spec: (0, $bTlUc.media)
    },
    {
        name: 'mediaGroup',
        spec: (0, $goVGV.mediaGroup)
    },
    {
        name: 'mediaSingle',
        spec: (0, $8Mfla.mediaSingleFull)
    },
    {
        name: 'mediaInline',
        spec: (0, $5RVMs.mediaInline)
    },
    {
        name: 'placeholder',
        spec: (0, $hbObi.placeholder)
    },
    {
        name: 'layoutSection',
        spec: (0, $jSvxD.layoutSection)
    },
    {
        name: 'layoutColumn',
        spec: (0, $gNk91.layoutColumn)
    },
    {
        name: 'hardBreak',
        spec: (0, $ewUmv.hardBreak)
    },
    {
        name: 'emoji',
        spec: (0, $foHUC.emoji)
    },
    {
        name: 'table',
        spec: (0, $e6HpD.table)
    },
    {
        name: 'tableCell',
        spec: (0, $e6HpD.tableCell)
    },
    {
        name: 'tableRow',
        spec: (0, $e6HpD.tableRow)
    },
    {
        name: 'tableHeader',
        spec: (0, $e6HpD.tableHeader)
    },
    {
        name: 'confluenceJiraIssue',
        spec: (0, $itOTx.confluenceJiraIssue)
    },
    {
        name: 'confluenceUnsupportedInline',
        spec: (0, $4LGm1.confluenceUnsupportedInline)
    },
    {
        name: 'confluenceUnsupportedBlock',
        spec: (0, $99RFR.confluenceUnsupportedBlock)
    },
    {
        name: 'decisionList',
        spec: (0, $9FkNK.decisionList)
    },
    {
        name: 'decisionItem',
        spec: (0, $eblOZ.decisionItem)
    },
    {
        name: 'taskList',
        spec: (0, $6Yq90.taskList)
    },
    {
        name: 'taskItem',
        spec: (0, $5iuEY.taskItem)
    },
    {
        name: 'blockTaskItem',
        spec: (0, $5iuEY.blockTaskItem)
    },
    {
        name: 'date',
        spec: (0, $s7CHM.date)
    },
    {
        name: 'status',
        spec: (0, $c2Gqu.status)
    },
    {
        name: 'expand',
        spec: (0, $eSKW9.expandWithNestedExpand)
    },
    {
        name: 'nestedExpand',
        spec: (0, $6UEeD.nestedExpand)
    },
    {
        name: 'extension',
        spec: (0, $6r1B4.extension)
    },
    {
        name: 'inlineExtension',
        spec: (0, $5Ufvu.inlineExtension)
    },
    {
        name: 'bodiedExtension',
        spec: (0, $kuVVV.bodiedExtension)
    },
    {
        name: 'multiBodiedExtension',
        spec: (0, $6C9Qx.multiBodiedExtension)
    },
    {
        name: 'extensionFrame',
        spec: (0, $6C9Qx.extensionFrame)
    },
    {
        name: 'inlineCard',
        spec: (0, $3MHOZ.inlineCard)
    },
    {
        name: 'blockCard',
        spec: (0, $5sqgz.blockCard)
    },
    {
        name: 'embedCard',
        spec: (0, $YIci7.embedCard)
    },
    {
        name: 'syncBlock',
        spec: (0, $hn1YX.syncBlock)
    },
    {
        name: 'bodiedSyncBlock',
        spec: (0, $dMcxi.bodiedSyncBlock)
    },
    {
        name: 'unknownBlock',
        spec: (0, $bffKB.default)
    },
    {
        name: 'unsupportedBlock',
        spec: (0, $e1kFZ.unsupportedBlock)
    },
    {
        name: 'unsupportedInline',
        spec: (0, $5blh0.unsupportedInline)
    }
];
const $bbd098624269520c$var$marksInOrder = [
    {
        name: 'link',
        spec: (0, $h9kgv.link)
    },
    {
        name: 'em',
        spec: (0, $eonww.em)
    },
    {
        name: 'strong',
        spec: (0, $YKDO7.strong)
    },
    {
        name: 'textColor',
        spec: (0, $abZsg.textColor)
    },
    {
        name: 'backgroundColor',
        spec: (0, $7i9jz.backgroundColor)
    },
    {
        name: 'strike',
        spec: (0, $f4V9T.strike)
    },
    {
        name: 'subsup',
        spec: (0, $hI6rl.subsup)
    },
    {
        name: 'underline',
        spec: (0, $b7o0x.underline)
    },
    {
        name: 'code',
        spec: (0, $eA6GD.code)
    },
    {
        name: 'typeAheadQuery',
        spec: (0, $anaPs.typeAheadQuery)
    },
    {
        name: 'alignment',
        spec: (0, $fRfD8.alignment)
    },
    {
        name: 'annotation',
        spec: (0, $jxPcD.annotation)
    },
    {
        name: 'confluenceInlineComment',
        spec: (0, $04SjV.confluenceInlineComment)
    },
    ...$bbd098624269520c$var$markGroupDeclarations,
    {
        name: 'breakout',
        spec: (0, $7uhRT.breakout)
    },
    {
        name: 'dataConsumer',
        spec: (0, $dHJym.dataConsumer)
    },
    {
        name: 'fragment',
        spec: (0, $6Ymtk.fragment)
    },
    {
        name: 'indentation',
        spec: (0, $7GG3N.indentation)
    },
    {
        name: 'border',
        spec: (0, $3Pxk9.border)
    },
    {
        name: 'unsupportedMark',
        spec: (0, $kdb0W.unsupportedMark)
    },
    {
        name: 'unsupportedNodeAttribute',
        spec: (0, $3pgGD.unsupportedNodeAttribute)
    }
];
function $bbd098624269520c$export$2d0c32a809131488() {
    const nodes = $bbd098624269520c$var$nodesInOrder.reduce((acc, { name: name, spec: spec })=>{
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    const marks = $bbd098624269520c$var$marksInOrder.reduce((acc, { name: name, spec: spec })=>{
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    return {
        nodes: nodes,
        marks: marks
    };
}
function $bbd098624269520c$export$5f4ce795563f4211(config) {
    const { customNodeSpecs: customNodeSpecs, customMarkSpecs: customMarkSpecs } = config;
    const nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    const marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat($bbd098624269520c$var$markGroupDeclarationsNames);
    let nodes = $bbd098624269520c$var$addItems($bbd098624269520c$var$nodesInOrder, nodesConfig, customNodeSpecs);
    const marks = $bbd098624269520c$var$addItems($bbd098624269520c$var$marksInOrder, marksConfig, customMarkSpecs);
    nodes = (0, $mYA6R.sanitizeNodes)(nodes, marks);
    return new (0, $3xw6l.Schema)({
        nodes: nodes,
        marks: marks
    });
}
const $bbd098624269520c$export$c77b6d30da5276a1 = true;

});
parcelRegister("3xw6l", function(module, exports) {
$parcel$export(module.exports, "Fragment", () => $293d5acde922b5fe$export$ffb0004e005737fa);
$parcel$export(module.exports, "Mark", () => $293d5acde922b5fe$export$c9d15bcfc6d42044);
$parcel$export(module.exports, "ReplaceError", () => $293d5acde922b5fe$export$6de0e778727af3f2);
$parcel$export(module.exports, "Slice", () => $293d5acde922b5fe$export$b3f2e2de3a8baa1e);
$parcel$export(module.exports, "ResolvedPos", () => $293d5acde922b5fe$export$b2a42f82e59e4b19);
$parcel$export(module.exports, "NodeRange", () => $293d5acde922b5fe$export$7bc461ceb770fb16);
$parcel$export(module.exports, "Node", () => $293d5acde922b5fe$export$85c928794f8d04d4);
$parcel$export(module.exports, "MarkType", () => $293d5acde922b5fe$export$b6a78689043c6521);
$parcel$export(module.exports, "Schema", () => $293d5acde922b5fe$export$19342e026b58ebb7);
$parcel$export(module.exports, "DOMParser", () => $293d5acde922b5fe$export$1059c6e7d2ce5669);
$parcel$export(module.exports, "DOMSerializer", () => $293d5acde922b5fe$export$3476b78f8f5a8b72);

var $b22x6 = parcelRequire("b22x6");
function $293d5acde922b5fe$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $293d5acde922b5fe$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $293d5acde922b5fe$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $293d5acde922b5fe$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $293d5acde922b5fe$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $293d5acde922b5fe$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $293d5acde922b5fe$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $293d5acde922b5fe$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $293d5acde922b5fe$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $293d5acde922b5fe$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $293d5acde922b5fe$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $293d5acde922b5fe$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $293d5acde922b5fe$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $293d5acde922b5fe$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $293d5acde922b5fe$var$retIndex(0, pos);
        if (pos == this.size) return $293d5acde922b5fe$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $293d5acde922b5fe$var$retIndex(i + 1, end);
                return $293d5acde922b5fe$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $293d5acde922b5fe$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $293d5acde922b5fe$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $293d5acde922b5fe$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $293d5acde922b5fe$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $293d5acde922b5fe$export$ffb0004e005737fa.empty;
        if (nodes instanceof $293d5acde922b5fe$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $293d5acde922b5fe$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $293d5acde922b5fe$export$ffb0004e005737fa.empty = new $293d5acde922b5fe$export$ffb0004e005737fa([], 0);
const $293d5acde922b5fe$var$found = {
    index: 0,
    offset: 0
};
function $293d5acde922b5fe$var$retIndex(index, offset) {
    $293d5acde922b5fe$var$found.index = index;
    $293d5acde922b5fe$var$found.offset = offset;
    return $293d5acde922b5fe$var$found;
}
function $293d5acde922b5fe$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$293d5acde922b5fe$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$293d5acde922b5fe$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $293d5acde922b5fe$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $293d5acde922b5fe$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $293d5acde922b5fe$export$c9d15bcfc6d42044.none;
        if (marks instanceof $293d5acde922b5fe$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $293d5acde922b5fe$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $293d5acde922b5fe$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $293d5acde922b5fe$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $293d5acde922b5fe$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $293d5acde922b5fe$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $293d5acde922b5fe$export$b3f2e2de3a8baa1e($293d5acde922b5fe$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $293d5acde922b5fe$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $293d5acde922b5fe$export$b3f2e2de3a8baa1e($293d5acde922b5fe$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $293d5acde922b5fe$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $293d5acde922b5fe$export$b3f2e2de3a8baa1e.empty = new $293d5acde922b5fe$export$b3f2e2de3a8baa1e($293d5acde922b5fe$export$ffb0004e005737fa.empty, 0, 0);
function $293d5acde922b5fe$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($293d5acde922b5fe$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $293d5acde922b5fe$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $293d5acde922b5fe$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $293d5acde922b5fe$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $293d5acde922b5fe$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $293d5acde922b5fe$export$6de0e778727af3f2("Inconsistent open depths");
    return $293d5acde922b5fe$var$replaceOuter($from, $to, slice, 0);
}
function $293d5acde922b5fe$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $293d5acde922b5fe$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $293d5acde922b5fe$var$close(node, $293d5acde922b5fe$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $293d5acde922b5fe$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $293d5acde922b5fe$var$prepareSliceForReplace(slice, $from);
        return $293d5acde922b5fe$var$close(node, $293d5acde922b5fe$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $293d5acde922b5fe$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $293d5acde922b5fe$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $293d5acde922b5fe$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $293d5acde922b5fe$var$checkJoin(node, $after.node(depth));
    return node;
}
function $293d5acde922b5fe$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $293d5acde922b5fe$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $293d5acde922b5fe$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$293d5acde922b5fe$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $293d5acde922b5fe$var$addNode($end.nodeBefore, target);
}
function $293d5acde922b5fe$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $293d5acde922b5fe$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $293d5acde922b5fe$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $293d5acde922b5fe$var$joinable($end, $to, depth + 1);
    let content = [];
    $293d5acde922b5fe$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $293d5acde922b5fe$var$checkJoin(openStart, openEnd);
        $293d5acde922b5fe$var$addNode($293d5acde922b5fe$var$close(openStart, $293d5acde922b5fe$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $293d5acde922b5fe$var$addNode($293d5acde922b5fe$var$close(openStart, $293d5acde922b5fe$var$replaceTwoWay($from, $start, depth + 1)), content);
        $293d5acde922b5fe$var$addRange($start, $end, depth, content);
        if (openEnd) $293d5acde922b5fe$var$addNode($293d5acde922b5fe$var$close(openEnd, $293d5acde922b5fe$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $293d5acde922b5fe$var$addRange($to, null, depth, content);
    return new $293d5acde922b5fe$export$ffb0004e005737fa(content);
}
function $293d5acde922b5fe$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $293d5acde922b5fe$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $293d5acde922b5fe$var$joinable($from, $to, depth + 1);
        $293d5acde922b5fe$var$addNode($293d5acde922b5fe$var$close(type, $293d5acde922b5fe$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $293d5acde922b5fe$var$addRange($to, null, depth, content);
    return new $293d5acde922b5fe$export$ffb0004e005737fa(content);
}
function $293d5acde922b5fe$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($293d5acde922b5fe$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $293d5acde922b5fe$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $293d5acde922b5fe$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $293d5acde922b5fe$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $293d5acde922b5fe$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $293d5acde922b5fe$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $293d5acde922b5fe$var$resolveCache.set(doc, cache = new $293d5acde922b5fe$var$ResolveCache);
        let result = cache.elts[cache.i] = $293d5acde922b5fe$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $293d5acde922b5fe$var$resolveCacheSize;
        return result;
    }
}
class $293d5acde922b5fe$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $293d5acde922b5fe$var$resolveCacheSize = 12, $293d5acde922b5fe$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $293d5acde922b5fe$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $293d5acde922b5fe$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $293d5acde922b5fe$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $293d5acde922b5fe$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $293d5acde922b5fe$export$ffb0004e005737fa.empty;
    }
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $293d5acde922b5fe$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $293d5acde922b5fe$var$emptyAttrs) && $293d5acde922b5fe$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $293d5acde922b5fe$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $293d5acde922b5fe$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $293d5acde922b5fe$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $293d5acde922b5fe$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $293d5acde922b5fe$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $293d5acde922b5fe$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $293d5acde922b5fe$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $293d5acde922b5fe$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $293d5acde922b5fe$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $293d5acde922b5fe$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $293d5acde922b5fe$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$293d5acde922b5fe$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $293d5acde922b5fe$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$293d5acde922b5fe$export$85c928794f8d04d4.prototype.text = undefined;
class $293d5acde922b5fe$var$TextNode extends $293d5acde922b5fe$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $293d5acde922b5fe$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $293d5acde922b5fe$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $293d5acde922b5fe$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $293d5acde922b5fe$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $293d5acde922b5fe$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $293d5acde922b5fe$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $293d5acde922b5fe$export$364ed450558d7ec4.empty;
        let expr = $293d5acde922b5fe$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $293d5acde922b5fe$var$dfa($293d5acde922b5fe$var$nfa(expr));
        $293d5acde922b5fe$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $293d5acde922b5fe$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $293d5acde922b5fe$export$364ed450558d7ec4.empty = new $293d5acde922b5fe$export$364ed450558d7ec4(true);
class $293d5acde922b5fe$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $293d5acde922b5fe$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($293d5acde922b5fe$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $293d5acde922b5fe$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($293d5acde922b5fe$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $293d5acde922b5fe$var$parseExprSubscript(stream) {
    let expr = $293d5acde922b5fe$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $293d5acde922b5fe$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $293d5acde922b5fe$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $293d5acde922b5fe$var$parseExprRange(stream, expr) {
    let min = $293d5acde922b5fe$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $293d5acde922b5fe$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $293d5acde922b5fe$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $293d5acde922b5fe$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $293d5acde922b5fe$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $293d5acde922b5fe$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $293d5acde922b5fe$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $293d5acde922b5fe$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $293d5acde922b5fe$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($293d5acde922b5fe$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $293d5acde922b5fe$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($293d5acde922b5fe$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $293d5acde922b5fe$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $293d5acde922b5fe$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($293d5acde922b5fe$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $293d5acde922b5fe$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $293d5acde922b5fe$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $293d5acde922b5fe$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $293d5acde922b5fe$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $293d5acde922b5fe$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $293d5acde922b5fe$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $293d5acde922b5fe$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $293d5acde922b5fe$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $293d5acde922b5fe$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $293d5acde922b5fe$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $293d5acde922b5fe$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $293d5acde922b5fe$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $293d5acde922b5fe$export$ffb0004e005737fa.from(content), $293d5acde922b5fe$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $293d5acde922b5fe$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $293d5acde922b5fe$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $293d5acde922b5fe$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $293d5acde922b5fe$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($293d5acde922b5fe$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $293d5acde922b5fe$export$85c928794f8d04d4(this, attrs, content.append(after), $293d5acde922b5fe$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $293d5acde922b5fe$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $293d5acde922b5fe$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $293d5acde922b5fe$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $293d5acde922b5fe$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $293d5acde922b5fe$var$Attribute {
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $293d5acde922b5fe$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $293d5acde922b5fe$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $293d5acde922b5fe$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $293d5acde922b5fe$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $293d5acde922b5fe$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $293d5acde922b5fe$export$c9d15bcfc6d42044(this, $293d5acde922b5fe$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $293d5acde922b5fe$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $293d5acde922b5fe$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $293d5acde922b5fe$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $b22x6.default).from(spec.nodes), instanceSpec.marks = (0, $b22x6.default).from(spec.marks || {}), this.nodes = $293d5acde922b5fe$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $293d5acde922b5fe$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $293d5acde922b5fe$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $293d5acde922b5fe$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $293d5acde922b5fe$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $293d5acde922b5fe$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $293d5acde922b5fe$var$TextNode(type, type.defaultAttrs, text, $293d5acde922b5fe$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $293d5acde922b5fe$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $293d5acde922b5fe$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $293d5acde922b5fe$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $293d5acde922b5fe$var$isTagRule(rule) {
    return rule.tag != null;
}
function $293d5acde922b5fe$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $293d5acde922b5fe$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($293d5acde922b5fe$var$isTagRule(rule)) this.tags.push(rule);
            else if ($293d5acde922b5fe$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $293d5acde922b5fe$var$ParseContext(this, options, false);
        context.addAll(dom, $293d5acde922b5fe$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $293d5acde922b5fe$var$ParseContext(this, options, true);
        context.addAll(dom, $293d5acde922b5fe$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $293d5acde922b5fe$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($293d5acde922b5fe$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $293d5acde922b5fe$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $293d5acde922b5fe$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $293d5acde922b5fe$export$1059c6e7d2ce5669(schema, $293d5acde922b5fe$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $293d5acde922b5fe$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $293d5acde922b5fe$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $293d5acde922b5fe$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $293d5acde922b5fe$var$OPT_PRESERVE_WS = 1, $293d5acde922b5fe$var$OPT_PRESERVE_WS_FULL = 2, $293d5acde922b5fe$var$OPT_OPEN_LEFT = 4;
function $293d5acde922b5fe$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $293d5acde922b5fe$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $293d5acde922b5fe$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $293d5acde922b5fe$var$OPT_PRESERVE_WS | $293d5acde922b5fe$var$OPT_PRESERVE_WS_FULL : base & ~$293d5acde922b5fe$var$OPT_OPEN_LEFT;
}
class $293d5acde922b5fe$var$NodeContext {
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $293d5acde922b5fe$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $293d5acde922b5fe$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($293d5acde922b5fe$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $293d5acde922b5fe$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $293d5acde922b5fe$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($293d5acde922b5fe$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$293d5acde922b5fe$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $293d5acde922b5fe$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $293d5acde922b5fe$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $293d5acde922b5fe$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $293d5acde922b5fe$var$NodeContext(topNode.type, topNode.attrs, $293d5acde922b5fe$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $293d5acde922b5fe$var$NodeContext(null, null, $293d5acde922b5fe$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $293d5acde922b5fe$var$NodeContext(parser.schema.topNodeType, null, $293d5acde922b5fe$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $293d5acde922b5fe$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $293d5acde922b5fe$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($293d5acde922b5fe$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $293d5acde922b5fe$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $293d5acde922b5fe$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($293d5acde922b5fe$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $293d5acde922b5fe$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $293d5acde922b5fe$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $293d5acde922b5fe$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $293d5acde922b5fe$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $293d5acde922b5fe$var$OPT_OPEN_LEFT;
        let applyMarks = $293d5acde922b5fe$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $293d5acde922b5fe$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $293d5acde922b5fe$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $293d5acde922b5fe$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $293d5acde922b5fe$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $293d5acde922b5fe$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $293d5acde922b5fe$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $293d5acde922b5fe$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $293d5acde922b5fe$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $293d5acde922b5fe$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $293d5acde922b5fe$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $293d5acde922b5fe$var$renderSpec($293d5acde922b5fe$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $293d5acde922b5fe$var$renderSpec($293d5acde922b5fe$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $293d5acde922b5fe$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $293d5acde922b5fe$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $293d5acde922b5fe$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $293d5acde922b5fe$var$gatherToDOM(schema.marks);
    }
}
function $293d5acde922b5fe$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $293d5acde922b5fe$var$doc(options) {
    return options.document || window.document;
}
const $293d5acde922b5fe$var$suspiciousAttributeCache = new WeakMap();
function $293d5acde922b5fe$var$suspiciousAttributes(attrs) {
    let value = $293d5acde922b5fe$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $293d5acde922b5fe$var$suspiciousAttributeCache.set(attrs, value = $293d5acde922b5fe$var$suspiciousAttributesInner(attrs));
    return value;
}
function $293d5acde922b5fe$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $293d5acde922b5fe$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $293d5acde922b5fe$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $293d5acde922b5fe$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});
parcelRegister("b22x6", function(module, exports) {
$parcel$export(module.exports, "default", () => $8081d8961ff8b83a$export$2e2bcd8739ae039);
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $8081d8961ff8b83a$var$OrderedMap(content) {
    this.content = content;
}
$8081d8961ff8b83a$var$OrderedMap.prototype = {
    constructor: $8081d8961ff8b83a$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $8081d8961ff8b83a$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $8081d8961ff8b83a$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $8081d8961ff8b83a$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $8081d8961ff8b83a$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $8081d8961ff8b83a$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $8081d8961ff8b83a$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $8081d8961ff8b83a$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $8081d8961ff8b83a$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $8081d8961ff8b83a$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $8081d8961ff8b83a$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$8081d8961ff8b83a$var$OrderedMap.from = function(value) {
    if (value instanceof $8081d8961ff8b83a$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $8081d8961ff8b83a$var$OrderedMap(content);
};
var $8081d8961ff8b83a$export$2e2bcd8739ae039 = $8081d8961ff8b83a$var$OrderedMap;

});


// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
const $212f88bb056bb83b$export$4498a6080fed604c = 'fontStyle';
const $212f88bb056bb83b$export$f8e8a5f34f6ea725 = 'searchQuery';
const $212f88bb056bb83b$export$b395009ca7f092c7 = 'link';
const $212f88bb056bb83b$export$9b982809044276a6 = 'color';
const $212f88bb056bb83b$export$470d0905851e47a1 = 'alignment';
const $212f88bb056bb83b$export$bacb7f4b06a06b22 = 'indentation';

parcelRegister("mYA6R", function(module, exports) {
$parcel$export(module.exports, "sanitizeNodes", () => $04510c65475a01e5$export$daf54fed04c8fb77);
function $04510c65475a01e5$export$daf54fed04c8fb77(nodes, supportedMarks) {
    const nodeNames = Object.keys(nodes);
    nodeNames.forEach((nodeKey)=>{
        const nodeSpec = {
            ...nodes[nodeKey]
        };
        if (nodeSpec.marks && nodeSpec.marks !== '_') nodeSpec.marks = nodeSpec.marks.split(' ').filter((mark)=>!!supportedMarks[mark]).join(' ');
        if (nodeSpec.content) nodeSpec.content = $04510c65475a01e5$var$sanitizeNodeSpecContent(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $04510c65475a01e5$var$sanitizeNodeSpecContent(nodes, rawContent) {
    const content = rawContent.replace(/\W/g, ' ');
    const contentKeys = content.split(' ');
    const unsupportedContentKeys = contentKeys.filter((contentKey)=>!$04510c65475a01e5$var$isContentSupported(nodes, contentKey));
    return unsupportedContentKeys.reduce((newContent, nodeName)=>$04510c65475a01e5$var$sanitizedContent(newContent, nodeName), rawContent);
}
function $04510c65475a01e5$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || '';
    if (!content || !content.match(/\w/)) return '';
    const pattern = `(${invalidContent}((\\s)*\\|)+)|((\\|(\\s)*)+${invalidContent}(\\+|\\*)?)|(${invalidContent}$)|(${invalidContent}(\\+|\\*))`;
    return content.replace(new RegExp(pattern, 'g'), '').replace('  ', ' ').trim();
}
function $04510c65475a01e5$var$isContentSupported(nodes, contentKey) {
    const nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(const supportedKey in nodes){
        const nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}

});

parcelRegister("fRfD8", function(module, exports) {
$parcel$export(module.exports, "alignmentPositionMap", () => $b8b7ee14906d8946$export$be9cf49015769bbd);
$parcel$export(module.exports, "alignment", () => $b8b7ee14906d8946$export$8e53000a4ec837);

var $dpWhK = parcelRequire("dpWhK");
const $b8b7ee14906d8946$export$be9cf49015769bbd = {
    end: 'right',
    right: 'end',
    center: 'center'
};
const $b8b7ee14906d8946$export$8e53000a4ec837 = (0, $dpWhK.alignment)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-block-mark',
            getAttrs: (dom)=>{
                const align = dom.getAttribute('data-align');
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: `fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-${mark.attrs.align}`,
                'data-align': mark.attrs.align
            },
            0
        ];
    }
});

});
parcelRegister("dpWhK", function(module, exports) {
$parcel$export(module.exports, "alignment", () => $9c4ad26098e14d16$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $9c4ad26098e14d16$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $9c4ad26098e14d16$export$8c5a050822fd698c);
$parcel$export(module.exports, "border", () => $9c4ad26098e14d16$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $9c4ad26098e14d16$export$89015c65f1c75e3f);
$parcel$export(module.exports, "code", () => $9c4ad26098e14d16$export$6565f9f03506010b);
$parcel$export(module.exports, "confluenceInlineComment", () => $9c4ad26098e14d16$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $9c4ad26098e14d16$export$3024f02c495408d6);
$parcel$export(module.exports, "em", () => $9c4ad26098e14d16$export$c63c6f932822f543);
$parcel$export(module.exports, "fragment", () => $9c4ad26098e14d16$export$f00aeb236b6f05af);
$parcel$export(module.exports, "indentation", () => $9c4ad26098e14d16$export$480c699bd4ec0d86);
$parcel$export(module.exports, "link", () => $9c4ad26098e14d16$export$9c30223ca0a664fb);
$parcel$export(module.exports, "strike", () => $9c4ad26098e14d16$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $9c4ad26098e14d16$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $9c4ad26098e14d16$export$b3401ee80eb31041);
$parcel$export(module.exports, "textColor", () => $9c4ad26098e14d16$export$32f78bffcd82ff28);
$parcel$export(module.exports, "typeAheadQuery", () => $9c4ad26098e14d16$export$20af3dabbb5538df);
$parcel$export(module.exports, "underline", () => $9c4ad26098e14d16$export$425327af25286e5e);
$parcel$export(module.exports, "unsupportedMark", () => $9c4ad26098e14d16$export$30d78d5eb6719bb8);
$parcel$export(module.exports, "unsupportedNodeAttribute", () => $9c4ad26098e14d16$export$a316dc07ff5182a2);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $1zhCF = parcelRequire("1zhCF");
const $9c4ad26098e14d16$export$8e53000a4ec837 = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        align: {}
    },
    excludes: 'alignment indentation',
    group: 'alignment'
});
const $9c4ad26098e14d16$export$8512c9afa7b24c3b = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        id: {
            default: ''
        },
        annotationType: {
            default: 'inlineComment'
        }
    },
    inclusive: true,
    excludes: '',
    group: 'annotation'
});
const $9c4ad26098e14d16$export$8c5a050822fd698c = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    excludes: 'color',
    group: 'color'
});
const $9c4ad26098e14d16$export$1edee58a52776cd9 = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        size: {},
        color: {}
    },
    inclusive: false
});
const $9c4ad26098e14d16$export$89015c65f1c75e3f = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        mode: {
            default: 'wide'
        },
        width: {
            default: null
        }
    },
    inclusive: false,
    spanning: false
});
const $9c4ad26098e14d16$export$6565f9f03506010b = (0, $1zhCF.createPMMarkSpecFactory)({
    inclusive: true,
    excludes: 'fontStyle link searchQuery color'
});
const $9c4ad26098e14d16$export$f3b72f8fc4684ecd = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        reference: {
            default: ''
        }
    },
    inclusive: false,
    excludes: ''
});
const $9c4ad26098e14d16$export$3024f02c495408d6 = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        sources: {
            default: []
        }
    }
});
const $9c4ad26098e14d16$export$c63c6f932822f543 = (0, $1zhCF.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $9c4ad26098e14d16$export$f00aeb236b6f05af = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        localId: {
            default: ''
        },
        name: {
            default: null
        }
    },
    inclusive: false,
    excludes: ''
});
const $9c4ad26098e14d16$export$480c699bd4ec0d86 = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        level: {}
    },
    excludes: 'indentation alignment',
    group: 'indentation'
});
const $9c4ad26098e14d16$export$9c30223ca0a664fb = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null
        }
    },
    inclusive: false,
    excludes: 'link',
    group: 'link'
});
const $9c4ad26098e14d16$export$4899a95d70ec5056 = (0, $1zhCF.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $9c4ad26098e14d16$export$59ae2c325a998f89 = (0, $1zhCF.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $9c4ad26098e14d16$export$b3401ee80eb31041 = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        type: {
            default: 'sub'
        }
    },
    inclusive: true,
    group: 'fontStyle'
});
const $9c4ad26098e14d16$export$32f78bffcd82ff28 = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
const $9c4ad26098e14d16$export$20af3dabbb5538df = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        trigger: {
            default: ''
        }
    },
    inclusive: true,
    group: 'searchQuery'
});
const $9c4ad26098e14d16$export$425327af25286e5e = (0, $1zhCF.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $9c4ad26098e14d16$export$30d78d5eb6719bb8 = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        originalValue: {}
    },
    excludes: ''
});
const $9c4ad26098e14d16$export$a316dc07ff5182a2 = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        unsupported: {},
        type: {}
    }
});

});


parcelRegister("jxPcD", function(module, exports) {
$parcel$export(module.exports, "AnnotationTypes", () => $e3a8d12fb24e7751$export$94aa2fc69ad33d19);
$parcel$export(module.exports, "AnnotationMarkStates", () => $e3a8d12fb24e7751$export$4bab14797673da9f);
$parcel$export(module.exports, "buildDataAttributes", () => $e3a8d12fb24e7751$export$93a98caa8bc6cb07);
$parcel$export(module.exports, "annotation", () => $e3a8d12fb24e7751$export$8512c9afa7b24c3b);

var $dpWhK = parcelRequire("dpWhK");
let $e3a8d12fb24e7751$export$94aa2fc69ad33d19 = /*#__PURE__*/ function(AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
    return AnnotationTypes;
}({});
let $e3a8d12fb24e7751$export$4bab14797673da9f = /*#__PURE__*/ function(AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
    return AnnotationMarkStates;
}({});
function $e3a8d12fb24e7751$export$93a98caa8bc6cb07({ id: id, annotationType: annotationType, state: state }) {
    const data = {
        'data-mark-type': 'annotation',
        'data-mark-annotation-type': annotationType,
        'data-id': id
    };
    if (state) return {
        ...data,
        'data-mark-annotation-state': state
    };
    return data;
}
const $e3a8d12fb24e7751$export$8512c9afa7b24c3b = (0, $dpWhK.annotation)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            mark: 'annotation',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-id'),
                    annotationType: dom.getAttribute('data-mark-annotation-type')
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        /*
      Data attributes on the DOM node are a temporary means of
      incrementally switching over to the Annotation mark. Once renderer
      provides native support for inline comments the data attributes on the
      DOM nodes will be removed.
    */ return [
            'span',
            {
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                'class': 'fabric-editor-annotation',
                ...$e3a8d12fb24e7751$export$93a98caa8bc6cb07({
                    id: node.attrs.id,
                    annotationType: node.attrs.annotationType
                })
            },
            0
        ];
    }
});

});

parcelRegister("7i9jz", function(module, exports) {
$parcel$export(module.exports, "backgroundColorPalette", () => $54f1708b23d22a73$export$14ec3f21a268e497);
$parcel$export(module.exports, "backgroundColorPaletteNext", () => $54f1708b23d22a73$export$7ab6fa38cecaeee2);
$parcel$export(module.exports, "backgroundColor", () => $54f1708b23d22a73$export$8c5a050822fd698c);

var $dpWhK = parcelRequire("dpWhK");

var $dyyJM = parcelRequire("dyyJM");

var $51dYk = parcelRequire("51dYk");

var $abZsg = parcelRequire("abZsg");

var $4PpDP = parcelRequire("4PpDP");
/**
 * @name backgroundColor_mark
 */ // Remove this when cleaning up platform_editor_add_orange_highlight_color
const $54f1708b23d22a73$var$colorArrayPalette = [
    [
        (0, $51dYk.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $51dYk.T200),
        'Teal'
    ],
    // token: color.background.accent.teal.subtler
    [
        (0, $51dYk.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $51dYk.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $51dYk.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $51dYk.P200),
        'Purple'
    ] // token: color.background.accent.purple.subtler
];
const $54f1708b23d22a73$var$colorArrayPaletteNext = [
    [
        (0, $51dYk.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $51dYk.P200),
        'Purple'
    ],
    // token: color.background.accent.purple.subtler
    [
        (0, $51dYk.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $51dYk.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $51dYk.Yellow200),
        'Yellow'
    ],
    // token: color.background.accent.yellow.subtler
    [
        (0, $51dYk.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $51dYk.T200),
        'Teal'
    ] // token: color.background.accent.teal.subtler
];
const $54f1708b23d22a73$export$14ec3f21a268e497 = new Map();
$54f1708b23d22a73$var$colorArrayPalette.forEach(([color, label])=>$54f1708b23d22a73$export$14ec3f21a268e497.set(color.toLowerCase(), label));
const $54f1708b23d22a73$export$7ab6fa38cecaeee2 = new Map();
$54f1708b23d22a73$var$colorArrayPaletteNext.forEach(([color, label])=>$54f1708b23d22a73$export$7ab6fa38cecaeee2.set(color.toLowerCase(), label));
const $54f1708b23d22a73$export$8c5a050822fd698c = (0, $dpWhK.backgroundColor)({
    parseDOM: [
        {
            style: 'background-color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $51dYk.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $54f1708b23d22a73$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: '.fabric-background-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $54f1708b23d22a73$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        /**
     * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * separate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $dyyJM.hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $abZsg.getGlobalTheme)().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $4PpDP.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-background-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-background-custom-color']: mark.attrs.color
            }
        ];
    }
});

});
parcelRegister("abZsg", function(module, exports) {
$parcel$export(module.exports, "colorPalette", () => $76ba9a217de88ec9$export$569885e57444f84a);
$parcel$export(module.exports, "getGlobalTheme", () => $76ba9a217de88ec9$export$813ecdf77207a053);
$parcel$export(module.exports, "textColor", () => $76ba9a217de88ec9$export$32f78bffcd82ff28);

var $dpWhK = parcelRequire("dpWhK");

var $dyyJM = parcelRequire("dyyJM");

var $51dYk = parcelRequire("51dYk");

var $4PpDP = parcelRequire("4PpDP");
/**
 * @name textColor_mark
 */ // used for extended palette in text color picker
const $76ba9a217de88ec9$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $51dYk.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $51dYk.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $51dYk.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $51dYk.Y400),
        'Orange'
    ],
    // Cheezy blasters
    [
        (0, $51dYk.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $51dYk.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $51dYk.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $51dYk.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $51dYk.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $51dYk.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $51dYk.Y200),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $51dYk.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $51dYk.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $51dYk.N0),
        'White'
    ],
    [
        (0, $51dYk.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $51dYk.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $51dYk.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $51dYk.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $51dYk.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $51dYk.P50),
        'Light purple'
    ] // Lavender secret
];
const $76ba9a217de88ec9$export$569885e57444f84a = new Map();
const $76ba9a217de88ec9$export$81e5ed9e84fe2e28 = $76ba9a217de88ec9$export$569885e57444f84a;
$76ba9a217de88ec9$var$colorArrayPalette.forEach(([color, label])=>$76ba9a217de88ec9$export$569885e57444f84a.set(color.toLowerCase(), label));
// these are for test only
let $76ba9a217de88ec9$var$testGlobalTheme;
const $76ba9a217de88ec9$export$fd7e0dd2b74807f7 = (theme)=>{
    $76ba9a217de88ec9$var$testGlobalTheme = theme;
};
const $76ba9a217de88ec9$export$813ecdf77207a053 = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($76ba9a217de88ec9$var$testGlobalTheme) return {
        colorMode: $76ba9a217de88ec9$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $76ba9a217de88ec9$export$32f78bffcd82ff28 = (0, $dpWhK.textColor)({
    parseDOM: [
        {
            style: 'color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $51dYk.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $76ba9a217de88ec9$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: '.fabric-text-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $76ba9a217de88ec9$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $dyyJM.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($76ba9a217de88ec9$export$813ecdf77207a053().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $4PpDP.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-text-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-text-custom-color']: mark.attrs.color
            }
        ];
    }
});

});


parcelRegister("3Pxk9", function(module, exports) {
$parcel$export(module.exports, "borderColorPalette", () => $2c9ffbf60e7d1542$export$e4e044c989c86ca7);
$parcel$export(module.exports, "border", () => $2c9ffbf60e7d1542$export$1edee58a52776cd9);

var $dpWhK = parcelRequire("dpWhK");

var $dyyJM = parcelRequire("dyyJM");

var $51dYk = parcelRequire("51dYk");
/**
 * @name border_mark
 * @description This mark adds decoration to an element, and any element decorated with it will also have a border style.
 */ const $2c9ffbf60e7d1542$var$borderColorArrayPalette = [
    [
        (0, $51dYk.N300A),
        'Subtle gray'
    ],
    [
        (0, $51dYk.N600),
        'Gray'
    ],
    [
        (0, $51dYk.N1000),
        'Bold gray'
    ]
];
const $2c9ffbf60e7d1542$export$e4e044c989c86ca7 = new Map();
$2c9ffbf60e7d1542$var$borderColorArrayPalette.forEach(([color, label])=>$2c9ffbf60e7d1542$export$e4e044c989c86ca7.set(color.toLowerCase(), label));
const $2c9ffbf60e7d1542$export$1edee58a52776cd9 = (0, $dpWhK.border)({
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: (domNode)=>{
                var _dom$getAttribute, _dom$getAttribute2;
                const dom = domNode;
                const color = ((_dom$getAttribute = dom.getAttribute('data-color')) !== null && _dom$getAttribute !== void 0 ? _dom$getAttribute : '').toLowerCase();
                const size = +((_dom$getAttribute2 = dom.getAttribute('data-size')) !== null && _dom$getAttribute2 !== void 0 ? _dom$getAttribute2 : '0');
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $2c9ffbf60e7d1542$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    toDOM (mark, isInline) {
        const wrapperStyle = isInline ? 'span' : 'div';
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        const paletteColorValue = (0, $dyyJM.hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                'data-mark-type': 'border',
                'data-color': mark.attrs.color,
                'data-size': mark.attrs.size,
                style: `--custom-palette-color: ${paletteColorValue}`
            }
        ];
    }
});

});

parcelRegister("7uhRT", function(module, exports) {
$parcel$export(module.exports, "breakout", () => $573931fdaecc07f5$export$89015c65f1c75e3f);

var $dpWhK = parcelRequire("dpWhK");
const $573931fdaecc07f5$var$allowedTypes = [
    'wide',
    'full-width'
];
const $573931fdaecc07f5$export$89015c65f1c75e3f = (0, $dpWhK.breakout)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-breakout-mark',
            getAttrs (dom) {
                const mode = dom.getAttribute('data-mode');
                const width = dom.getAttribute('data-width');
                return {
                    mode: $573931fdaecc07f5$var$allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode,
                    width: width ? parseInt(width) : null
                };
            }
        }
    ],
    toDOM (mark) {
        var _mark$attrs;
        return [
            'div',
            {
                class: 'fabric-editor-breakout-mark',
                'data-mode': mark.attrs.mode,
                'data-width': (_mark$attrs = mark.attrs) === null || _mark$attrs === void 0 ? void 0 : _mark$attrs.width
            },
            0
        ];
    }
});

});

parcelRegister("eA6GD", function(module, exports) {
$parcel$export(module.exports, "code", () => $a9d99d50afe8568a$export$6565f9f03506010b);

var $dpWhK = parcelRequire("dpWhK");
const $a9d99d50afe8568a$export$6565f9f03506010b = (0, $dpWhK.code)({
    parseDOM: [
        {
            tag: 'span.code',
            preserveWhitespace: true
        },
        {
            tag: 'code',
            preserveWhitespace: true
        },
        {
            tag: 'tt',
            preserveWhitespace: true
        },
        {
            tag: 'span',
            preserveWhitespace: true,
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre') return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) return {};
                return false;
            }
        }
    ],
    toDOM () {
        return [
            'span',
            {
                class: 'code',
                spellcheck: 'false'
            }
        ];
    }
});

});

parcelRegister("04SjV", function(module, exports) {
$parcel$export(module.exports, "confluenceInlineComment", () => $00ea82b899b17721$export$f3b72f8fc4684ecd);

var $dpWhK = parcelRequire("dpWhK");
const $00ea82b899b17721$export$f3b72f8fc4684ecd = (0, $dpWhK.confluenceInlineComment)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-mark-type': 'confluenceInlineComment',
                'data-reference': node.attrs.reference
            }
        ];
    }
});

});

parcelRegister("dHJym", function(module, exports) {
$parcel$export(module.exports, "dataConsumer", () => $9fa2a06e539a28ed$export$3024f02c495408d6);
$parcel$export(module.exports, "toJSON", () => $9fa2a06e539a28ed$export$54fd2c36b5cc6731);

var $dpWhK = parcelRequire("dpWhK");

var $j783N = parcelRequire("j783N");
/**
 * This annotation is purely for reference, & does _nothing_ given annotating
 * `minLength` on an array of strings is not supported with our schema+spec
 * generator.
 *
 * We're keeping it to signal that data consumer `sources` shouldn't be empty
 * strings
 *
 * // @minLength 1
 */ /**
 * @name dataConsumer_mark
 * @description This mark is used for metadata surrounding a node consuming data
 * from a given source node
 */ const $9fa2a06e539a28ed$var$parseDataConsumer = (maybeValue)=>{
    const sources = (0, $j783N.isDOMElement)(maybeValue) && maybeValue.getAttribute('data-sources');
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch  {
        return false;
    }
};
const $9fa2a06e539a28ed$export$3024f02c495408d6 = (0, $dpWhK.dataConsumer)({
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: (maybeValue)=>$9fa2a06e539a28ed$var$parseDataConsumer(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'dataConsumer',
                'data-sources': JSON.stringify(mark.attrs.sources)
            }
        ];
    }
});
const $9fa2a06e539a28ed$export$54fd2c36b5cc6731 = (mark)=>{
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter((key)=>key === 'sources' && mark.attrs[key].length > 0 && mark.attrs[key] !== null).reduce((acc, key)=>{
            return {
                ...acc,
                [key]: mark.attrs[key]
            };
        }, {})
    };
};

});
parcelRegister("j783N", function(module, exports) {
$parcel$export(module.exports, "isDOMElement", () => $dea4ec58c68501e8$export$c296e2d4365c37a5);
const $dea4ec58c68501e8$export$c296e2d4365c37a5 = (maybeNode)=>maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;

});


parcelRegister("eonww", function(module, exports) {
$parcel$export(module.exports, "em", () => $a7a58ddd4fa9ccdc$export$c63c6f932822f543);

var $dpWhK = parcelRequire("dpWhK");
/**
 * @name em_mark
 */ const $a7a58ddd4fa9ccdc$var$emDOM = [
    'em'
];
const $a7a58ddd4fa9ccdc$export$c63c6f932822f543 = (0, $dpWhK.em)({
    parseDOM: [
        {
            tag: 'i'
        },
        {
            tag: 'em'
        },
        {
            style: 'font-style=italic'
        }
    ],
    toDOM () {
        return $a7a58ddd4fa9ccdc$var$emDOM;
    }
});

});

parcelRegister("6Ymtk", function(module, exports) {
$parcel$export(module.exports, "fragment", () => $5139c72ca03c3689$export$f00aeb236b6f05af);
$parcel$export(module.exports, "toJSON", () => $5139c72ca03c3689$export$54fd2c36b5cc6731);

var $dpWhK = parcelRequire("dpWhK");

var $j783N = parcelRequire("j783N");
/**
 * @name fragment_mark
 * @description Indicates that the elements decorated with this mark belong to a "fragment" entity, which represents a collection of ADF nodes.
 * This entity can be referred to later by its `localId` attribute.
 */ const $5139c72ca03c3689$var$parseFragment = (maybeValue)=>{
    var _maybeValue$getAttrib;
    if (!(0, $j783N.isDOMElement)(maybeValue)) return false;
    const name = (_maybeValue$getAttrib = maybeValue.getAttribute('data-name')) !== null && _maybeValue$getAttrib !== void 0 ? _maybeValue$getAttrib : undefined;
    const localId = maybeValue.getAttribute('data-localId');
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
const $5139c72ca03c3689$export$f00aeb236b6f05af = (0, $dpWhK.fragment)({
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: (maybeValue)=>$5139c72ca03c3689$var$parseFragment(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'fragment',
                'data-name': mark.attrs.name,
                'data-localId': mark.attrs.localId
            }
        ];
    }
});
const $5139c72ca03c3689$export$54fd2c36b5cc6731 = (mark)=>{
    return {
        type: mark.type.name,
        attrs: {
            localId: mark.attrs.localId,
            ...mark.attrs.name ? {
                name: mark.attrs.name
            } : {}
        }
    };
};

});

parcelRegister("7GG3N", function(module, exports) {
$parcel$export(module.exports, "indentation", () => $598d14eba71ad958$export$480c699bd4ec0d86);

var $dpWhK = parcelRequire("dpWhK");
const $598d14eba71ad958$export$480c699bd4ec0d86 = (0, $dpWhK.indentation)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-indentation-mark',
            getAttrs (dom) {
                const level = +(dom.getAttribute('data-level') || '0');
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                'data-level': mark.attrs.level
            },
            0
        ];
    }
});

});

parcelRegister("h9kgv", function(module, exports) {
$parcel$export(module.exports, "link", () => $c7c2ff29c44bed75$export$9c30223ca0a664fb);
$parcel$export(module.exports, "toJSON", () => $c7c2ff29c44bed75$export$54fd2c36b5cc6731);

var $dpWhK = parcelRequire("dpWhK");

var $iKozC = parcelRequire("iKozC");
const $c7c2ff29c44bed75$export$b5f67017585d1431 = (attribute)=>(domNode)=>{
        const dom = domNode;
        const href = dom.getAttribute(attribute) || '';
        const attrs = {
            __confluenceMetadata: dom.hasAttribute('__confluenceMetadata') ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '') : undefined
        };
        if (!(0, $iKozC.isSafeUrl)(href)) return false;
        if ((0, $iKozC.isRootRelative)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $iKozC.normalizeUrl)(href);
        return attrs;
    };
const $c7c2ff29c44bed75$export$9c30223ca0a664fb = (0, $dpWhK.link)({
    parseDOM: [
        {
            tag: '[data-block-link]',
            getAttrs: $c7c2ff29c44bed75$export$b5f67017585d1431('data-block-link'),
            contentElement: (node)=>{
                const clone = node.cloneNode(true);
                clone.removeAttribute('data-block-link');
                clone.setAttribute('data-skip-paste', 'true');
                const wrapper = document.createElement('div');
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: 'a[href]',
            getAttrs: $c7c2ff29c44bed75$export$b5f67017585d1431('href')
        }
    ],
    toDOM (node, isInline) {
        const attrs = Object.keys(node.attrs).reduce((attrs, key)=>{
            if (key === '__confluenceMetadata') {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === 'href') attrs[key] = (0, $iKozC.isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
            else attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            'a',
            attrs
        ];
        return [
            'a',
            {
                ...attrs,
                ['data-block-link']: 'true',
                class: 'blockLink'
            },
            0
        ];
    }
});
const $c7c2ff29c44bed75$var$OPTIONAL_ATTRS = [
    'title',
    'id',
    'collection',
    'occurrenceKey',
    '__confluenceMetadata'
];
const $c7c2ff29c44bed75$export$54fd2c36b5cc6731 = (mark)=>({
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).reduce((attrs, key)=>{
            if ($c7c2ff29c44bed75$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
            return attrs;
        }, {})
    });

});
parcelRegister("iKozC", function(module, exports) {
$parcel$export(module.exports, "isSafeUrl", () => $da5f95a938306985$export$c9f92f5469372e0f);
$parcel$export(module.exports, "linkify", () => $da5f95a938306985$export$8ccbde94d5c7f8e7);
$parcel$export(module.exports, "linkifyMatch", () => $da5f95a938306985$export$6f7d7761b97f967);
$parcel$export(module.exports, "getLinkMatch", () => $da5f95a938306985$export$ce9ae45aed3e4ec);
$parcel$export(module.exports, "normalizeUrl", () => $da5f95a938306985$export$6535eb414fa2c8b6);
$parcel$export(module.exports, "isRootRelative", () => $da5f95a938306985$export$23579274a7a24f7b);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $agOHY = parcelRequire("agOHY");
const $da5f95a938306985$var$whitelistedURLPatterns = [
    /^https?:\/\//im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/im,
    /^sourcetree:\/\//im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^#/im
];
const $da5f95a938306985$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    if (urlTrimmed.length === 0) return true;
    return $da5f95a938306985$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
const $da5f95a938306985$export$8ccbde94d5c7f8e7 = (0, (/*@__PURE__*/$parcel$interopDefault($agOHY)))();
$da5f95a938306985$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$da5f95a938306985$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
const $da5f95a938306985$var$urlWithoutSpacesValidator = {
    validate: /[^\s]+/
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$da5f95a938306985$export$8ccbde94d5c7f8e7.add('tel:', $da5f95a938306985$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$da5f95a938306985$export$8ccbde94d5c7f8e7.add('file:', $da5f95a938306985$var$urlWithoutSpacesValidator);
$da5f95a938306985$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
const $da5f95a938306985$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $da5f95a938306985$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$da5f95a938306985$var$tlds.push($da5f95a938306985$var$tlds2Char);
$da5f95a938306985$export$8ccbde94d5c7f8e7.tlds($da5f95a938306985$var$tlds, false);
const $da5f95a938306985$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $da5f95a938306985$export$6f7d7761b97f967 = (text)=>{
    if (!$da5f95a938306985$export$746d02eae03c72e1.test(text)) return [];
    const matches = [];
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($da5f95a938306985$export$746d02eae03c72e1) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($da5f95a938306985$export$746d02eae03c72e1);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
function $da5f95a938306985$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    let match = $da5f95a938306985$export$6f7d7761b97f967(str);
    if (!match.length) match = $da5f95a938306985$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $da5f95a938306985$export$6535eb414fa2c8b6(url) {
    const match = $da5f95a938306985$export$ce9ae45aed3e4ec(url);
    return match && match.url || '';
}
function $da5f95a938306985$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith('/') || url === '#top' || url === '#';
}

});
parcelRegister("agOHY", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $77a2bb99974301ae$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $77a2bb99974301ae$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $77a2bb99974301ae$var$isString(obj) {
    return $77a2bb99974301ae$var$_class(obj) === '[object String]';
}
function $77a2bb99974301ae$var$isObject(obj) {
    return $77a2bb99974301ae$var$_class(obj) === '[object Object]';
}
function $77a2bb99974301ae$var$isRegExp(obj) {
    return $77a2bb99974301ae$var$_class(obj) === '[object RegExp]';
}
function $77a2bb99974301ae$var$isFunction(obj) {
    return $77a2bb99974301ae$var$_class(obj) === '[object Function]';
}
function $77a2bb99974301ae$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $77a2bb99974301ae$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $77a2bb99974301ae$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $77a2bb99974301ae$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $77a2bb99974301ae$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $77a2bb99974301ae$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $77a2bb99974301ae$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $77a2bb99974301ae$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $77a2bb99974301ae$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $77a2bb99974301ae$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $77a2bb99974301ae$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("dZNb9"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($77a2bb99974301ae$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($77a2bb99974301ae$var$isObject(val)) {
            if ($77a2bb99974301ae$var$isRegExp(val.validate)) compiled.validate = $77a2bb99974301ae$var$createValidator(val.validate);
            else if ($77a2bb99974301ae$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($77a2bb99974301ae$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $77a2bb99974301ae$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($77a2bb99974301ae$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $77a2bb99974301ae$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($77a2bb99974301ae$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|' + '(' + self.re.host_fuzzy_test.source + ')|' + '@', 'i');
    //
    // Cleanup
    //
    $77a2bb99974301ae$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $77a2bb99974301ae$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $77a2bb99974301ae$var$createMatch(self, shift) {
    var match = new $77a2bb99974301ae$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $77a2bb99974301ae$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $77a2bb99974301ae$var$LinkifyIt)) return new $77a2bb99974301ae$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($77a2bb99974301ae$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $77a2bb99974301ae$var$assign({}, $77a2bb99974301ae$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $77a2bb99974301ae$var$assign({}, $77a2bb99974301ae$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $77a2bb99974301ae$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $77a2bb99974301ae$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $77a2bb99974301ae$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $77a2bb99974301ae$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $77a2bb99974301ae$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $77a2bb99974301ae$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $77a2bb99974301ae$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $77a2bb99974301ae$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $77a2bb99974301ae$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $77a2bb99974301ae$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($77a2bb99974301ae$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($77a2bb99974301ae$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $77a2bb99974301ae$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $77a2bb99974301ae$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $77a2bb99974301ae$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $77a2bb99974301ae$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $77a2bb99974301ae$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $77a2bb99974301ae$var$LinkifyIt;

});
parcelRegister("dZNb9", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("hZcCd")).source;
    re.src_Cc = (parcelRequire("iNnZB")).source;
    re.src_Z = (parcelRequire("23KJ1")).source;
    re.src_P = (parcelRequire("dDBFM")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,3}[a-zA-Z0-9%/]|' + // github has ... in commit range links. Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + '\\,(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    '\\!(?!' + re.src_ZCc + '|[!]).|' + '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    re.src_email_name = '[\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]+';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + // don't allow `--` in domain names, because:
    // - that can conflict with markdown &mdash; / &ndash;
    // - nobody use those anyway
    '(?:' + re.src_pseudo_letter + '(?:-(?!-)|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|\\(|' + re.src_ZCc + ')(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});
parcelRegister("hZcCd", function(module, exports) {
module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("iNnZB", function(module, exports) {
module.exports = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("23KJ1", function(module, exports) {
module.exports = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;

});

parcelRegister("dDBFM", function(module, exports) {
module.exports = /[!-#%-\*,-/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E49\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});





parcelRegister("f4V9T", function(module, exports) {
$parcel$export(module.exports, "strike", () => $afa39141d5f07f7e$export$4899a95d70ec5056);

var $dpWhK = parcelRequire("dpWhK");
const $afa39141d5f07f7e$export$4899a95d70ec5056 = (0, $dpWhK.strike)({
    parseDOM: [
        {
            tag: 'strike'
        },
        {
            tag: 's'
        },
        {
            tag: 'del'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'line-through' && null
        }
    ],
    toDOM () {
        return [
            's'
        ];
    }
});

});

parcelRegister("YKDO7", function(module, exports) {
$parcel$export(module.exports, "strong", () => $0b69c8a71c20472c$export$59ae2c325a998f89);

var $dpWhK = parcelRequire("dpWhK");
/**
 * @name strong_mark
 */ const $0b69c8a71c20472c$var$strongDOM = [
    'strong'
];
const $0b69c8a71c20472c$export$59ae2c325a998f89 = (0, $dpWhK.strong)({
    parseDOM: [
        {
            tag: 'strong'
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: 'b',
            getAttrs (node) {
                const element = node;
                return element.style.fontWeight !== 'normal' && null;
            }
        },
        {
            tag: 'span',
            getAttrs (node) {
                const element = node;
                const { fontWeight: fontWeight } = element.style;
                return typeof fontWeight === 'string' && (fontWeight === 'bold' || fontWeight === 'bolder' || /^(bold(er)?|[5-9]\d{2,})$/.test(fontWeight)) && null;
            }
        }
    ],
    toDOM () {
        return $0b69c8a71c20472c$var$strongDOM;
    }
});

});

parcelRegister("hI6rl", function(module, exports) {
$parcel$export(module.exports, "subsup", () => $ce4b8a96280c3122$export$b3401ee80eb31041);

var $dpWhK = parcelRequire("dpWhK");
/**
 * @name subsup_mark
 */ function $ce4b8a96280c3122$var$getAttrFromVerticalAlign(node) {
    if (node === 'sub') return {
        type: 'sub'
    };
    if (node === 'super') return {
        type: 'sup'
    };
    return false;
}
const $ce4b8a96280c3122$export$b3401ee80eb31041 = (0, $dpWhK.subsup)({
    parseDOM: [
        {
            tag: 'sub',
            attrs: {
                type: 'sub'
            }
        },
        {
            tag: 'sup',
            attrs: {
                type: 'sup'
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            style: 'vertical-align=super',
            getAttrs: (node)=>$ce4b8a96280c3122$var$getAttrFromVerticalAlign(node)
        },
        {
            style: 'vertical-align=sub',
            getAttrs: (node)=>$ce4b8a96280c3122$var$getAttrFromVerticalAlign(node)
        }
    ],
    toDOM (mark) {
        return [
            mark.attrs.type
        ];
    }
});

});

parcelRegister("anaPs", function(module, exports) {
$parcel$export(module.exports, "typeAheadQuery", () => $78d473cb65f0df79$export$20af3dabbb5538df);

var $dpWhK = parcelRequire("dpWhK");

var $51dYk = parcelRequire("51dYk");
const $78d473cb65f0df79$export$20af3dabbb5538df = (0, $dpWhK.typeAheadQuery)({
    parseDOM: [
        {
            tag: 'span[data-type-ahead-query]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-type-ahead-query': 'true',
                'data-trigger': node.attrs.trigger,
                style: `color: ${(0, $51dYk.B400)}`
            }
        ];
    }
});

});

parcelRegister("b7o0x", function(module, exports) {
$parcel$export(module.exports, "underline", () => $8182f89abb2f8453$export$425327af25286e5e);

var $dpWhK = parcelRequire("dpWhK");
const $8182f89abb2f8453$export$425327af25286e5e = (0, $dpWhK.underline)({
    parseDOM: [
        {
            tag: 'u'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'underline' && null
        }
    ],
    toDOM () {
        return [
            'u'
        ];
    }
});

});

parcelRegister("kdb0W", function(module, exports) {
$parcel$export(module.exports, "unsupportedMark", () => $eb6d90b5414d615f$export$30d78d5eb6719bb8);

var $dpWhK = parcelRequire("dpWhK");
const $eb6d90b5414d615f$export$30d78d5eb6719bb8 = (0, $dpWhK.unsupportedMark)({
    toDOM () {
        return [
            'span'
        ];
    }
});

});

parcelRegister("3pgGD", function(module, exports) {
$parcel$export(module.exports, "unsupportedNodeAttribute", () => $27b0a68621bb260d$export$a316dc07ff5182a2);

var $dpWhK = parcelRequire("dpWhK");
const $27b0a68621bb260d$export$a316dc07ff5182a2 = (0, $dpWhK.unsupportedNodeAttribute)({
    toDOM () {
        return [
            'span'
        ];
    }
});

});

parcelRegister("5sqgz", function(module, exports) {
$parcel$export(module.exports, "blockCard", () => $3f93f1394abd8f36$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockCardWithLocalId", () => $3f93f1394abd8f36$export$9894f24949f094e5);

var $nJVLW = parcelRequire("nJVLW");

var $2OrIX = parcelRequire("2OrIX");
/**
 * @name blockCard_node
 */ const $3f93f1394abd8f36$var$getCommonAttributesFromDom = (dom)=>{
    const anchor = dom;
    const data = anchor.getAttribute('data-card-data');
    const datasource = anchor.getAttribute('data-datasource');
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? dom.getAttribute('data-layout') || undefined : undefined,
        width: Number(dom.getAttribute('data-width')) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
const $3f93f1394abd8f36$export$c4c2f833baaebdb8 = (0, $nJVLW.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('href') || undefined,
                    ...$3f93f1394abd8f36$var$getCommonAttributesFromDom(dom)
                };
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('data-card-url') || undefined,
                    ...$3f93f1394abd8f36$var$getCommonAttributesFromDom(dom)
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { url: url } = node.attrs;
        const { data: data } = node.attrs;
        const { layout: layout, width: width, datasource: datasource } = node.attrs;
        const attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': `${width}`
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || ' '
        ];
    }
});
const $3f93f1394abd8f36$export$9894f24949f094e5 = (0, $nJVLW.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('href') || undefined,
                    ...$3f93f1394abd8f36$var$getCommonAttributesFromDom(dom),
                    localId: (0, $2OrIX.uuid).generate()
                };
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('data-card-url') || undefined,
                    ...$3f93f1394abd8f36$var$getCommonAttributesFromDom(dom),
                    localId: (0, $2OrIX.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs2, _node$attrs3;
        const { url: url } = node.attrs;
        const { data: data } = node.attrs;
        const { layout: layout, width: width, datasource: datasource } = node.attrs;
        const attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': `${width}`,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.url) || ' '
        ];
    }
});

});

parcelRegister("5iuEY", function(module, exports) {
$parcel$export(module.exports, "taskItem", () => $3db66a9f0ad7bab5$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "blockTaskItem", () => $3db66a9f0ad7bab5$export$16018c61064a18df);

var $2OrIX = parcelRequire("2OrIX");

var $nJVLW = parcelRequire("nJVLW");
const $3db66a9f0ad7bab5$export$6d8b0ef52e2e6390 = (0, $nJVLW.taskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $2OrIX.uuid).generate(),
                    state: dom.getAttribute('data-task-state') || 'TODO'
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $3db66a9f0ad7bab5$export$16018c61064a18df = (0, $nJVLW.blockTaskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-is-block]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $2OrIX.uuid).generate(),
                    state: dom.getAttribute('data-task-state') || 'TODO'
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO',
            'data-task-is-block': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("kuVVV", function(module, exports) {
$parcel$export(module.exports, "bodiedExtension", () => $eec38c5829cd5cfe$export$27903d543b563e39);

var $fPSlo = parcelRequire("fPSlo");

var $nJVLW = parcelRequire("nJVLW");
const $eec38c5829cd5cfe$export$27903d543b563e39 = (0, $nJVLW.bodiedExtension)({
    parseDOM: [
        {
            context: 'bodiedExtension//',
            tag: '[data-node-type="bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="bodied-extension"]',
            getAttrs: (domNode)=>(0, $fPSlo.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("7T1su", function(module, exports) {
$parcel$export(module.exports, "bulletListSelector", () => $5bdecd1b7c926ffc$export$5f25a39efab3b58b);
$parcel$export(module.exports, "bulletList", () => $5bdecd1b7c926ffc$export$a140c94e5ea26bee);
$parcel$export(module.exports, "bulletListWithLocalId", () => $5bdecd1b7c926ffc$export$dfd406053b2bab40);

var $2OrIX = parcelRequire("2OrIX");

var $nJVLW = parcelRequire("nJVLW");
const $5bdecd1b7c926ffc$export$5f25a39efab3b58b = '.ak-ul';
const $5bdecd1b7c926ffc$export$a140c94e5ea26bee = (0, $nJVLW.bulletList)({
    parseDOM: [
        {
            tag: 'ul'
        }
    ],
    toDOM () {
        const attrs = {
            class: $5bdecd1b7c926ffc$export$5f25a39efab3b58b.substr(1)
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});
const $5bdecd1b7c926ffc$export$dfd406053b2bab40 = (0, $nJVLW.bulletList)({
    parseDOM: [
        {
            tag: 'ul',
            getAttrs: ()=>{
                return {
                    localId: (0, $2OrIX.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            class: $5bdecd1b7c926ffc$export$5f25a39efab3b58b.substr(1),
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});

});

parcelRegister("l2o3P", function(module, exports) {
$parcel$export(module.exports, "caption", () => $f50c72db8a29084b$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "captionWithLocalId", () => $f50c72db8a29084b$export$b5d01ee303c467aa);

var $nJVLW = parcelRequire("nJVLW");

var $2OrIX = parcelRequire("2OrIX");
const $f50c72db8a29084b$export$8e3c2dfdc4f0453d = (0, $nJVLW.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-caption': 'true'
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});
const $f50c72db8a29084b$export$b5d01ee303c467aa = (0, $nJVLW.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]',
            getAttrs: ()=>{
                return {
                    localId: (0, $2OrIX.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            'data-caption': 'true',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});

});

parcelRegister("02BNy", function(module, exports) {
$parcel$export(module.exports, "codeBlock", () => $007d81fc2959166a$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "toJSON", () => $007d81fc2959166a$export$54fd2c36b5cc6731);
$parcel$export(module.exports, "codeBlockWithLocalId", () => $007d81fc2959166a$export$3f75de798a0b5356);

var $3xw6l = parcelRequire("3xw6l");

var $nJVLW = parcelRequire("nJVLW");

var $2OrIX = parcelRequire("2OrIX");
/**
 * @name codeBlock_with_no_marks_node
 */ /**
 * @name codeBlock_node
 */ const $007d81fc2959166a$var$getLanguageFromEditorStyle = (dom)=>{
    return dom.getAttribute('data-language') || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
const $007d81fc2959166a$var$getLanguageFromBitbucketStyle = (dom)=>{
    if (dom && dom.classList.contains('codehilite')) // code block html from Bitbucket always contains an extra new line
    return $007d81fc2959166a$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
const $007d81fc2959166a$var$getLanguageFromCode = (dom)=>{
    const firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === 'CODE') return firstChild.getAttribute('data-language') || undefined;
};
const $007d81fc2959166a$var$extractLanguageFromClass = (className)=>{
    const languageRegex = /(?:^|\s)language-([^\s]+)/;
    const result = languageRegex.exec(className);
    if (result && result[1]) return result[1];
    return;
};
const $007d81fc2959166a$var$removeLastNewLine = (dom)=>{
    const parent = dom && dom.parentElement;
    if (parent && parent.classList.contains('codehilite')) dom.textContent = dom.textContent.replace(/\n$/, '');
    return dom;
};
function $007d81fc2959166a$var$parseCodeFromHtml(node) {
    let code = '';
    node.childNodes.forEach((child)=>{
        if (child.nodeType === Node.TEXT_NODE) // append text
        code += child.nodeValue;
        else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
            const tagName = child.tagName.toLowerCase();
            if (tagName === 'div' || tagName === 'p') // add a newline before its content, unless it's the first child to avoid leading newlines
            {
                if (child.previousElementSibling !== null) code += '\n';
            }
            if (tagName === 'br') code += '\n';
            else code += $007d81fc2959166a$var$parseCodeFromHtml(child);
        }
    });
    return code;
}
const $007d81fc2959166a$export$7bb0d5c671655cc4 = (0, $nJVLW.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                let dom = domNode;
                const language = $007d81fc2959166a$var$getLanguageFromBitbucketStyle(dom.parentElement) || $007d81fc2959166a$var$getLanguageFromEditorStyle(dom.parentElement) || $007d81fc2959166a$var$getLanguageFromCode(dom) || dom.getAttribute('data-language');
                dom = $007d81fc2959166a$var$removeLastNewLine(dom);
                return {
                    language: language
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: (domNode, schema)=>{
                const code = $007d81fc2959166a$var$parseCodeFromHtml(domNode);
                return code ? (0, $3xw6l.Fragment).from(schema.text(code)) : (0, $3xw6l.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: (dom)=>{
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                const dom = domNode;
                // TODO: ED-5604 Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach((line)=>line.remove());
                return {};
            }
        }
    ],
    toDOM (node) {
        return [
            'pre',
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});
const $007d81fc2959166a$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((memo, key)=>{
            if (key === 'uniqueId') return memo;
            if (key === 'language' && node.attrs.language === null) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    });
const $007d81fc2959166a$export$3f75de798a0b5356 = (0, $nJVLW.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                let dom = domNode;
                const language = $007d81fc2959166a$var$getLanguageFromBitbucketStyle(dom.parentElement) || $007d81fc2959166a$var$getLanguageFromEditorStyle(dom.parentElement) || $007d81fc2959166a$var$getLanguageFromCode(dom) || dom.getAttribute('data-language');
                dom = $007d81fc2959166a$var$removeLastNewLine(dom);
                return {
                    language: language,
                    localId: (0, $2OrIX.uuid).generate()
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: (domNode, schema)=>{
                const code = $007d81fc2959166a$var$parseCodeFromHtml(domNode);
                return code ? (0, $3xw6l.Fragment).from(schema.text(code)) : (0, $3xw6l.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: (dom)=>{
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                const dom = domNode;
                // TODO: ED-5604 Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach((line)=>line.remove());
                return {};
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'pre',
            attrs,
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});

});

parcelRegister("itOTx", function(module, exports) {
$parcel$export(module.exports, "confluenceJiraIssue", () => $d7426a112a1f91a3$export$daf889beb5092f95);

var $nJVLW = parcelRequire("nJVLW");
const $d7426a112a1f91a3$var$name = 'confluenceJiraIssue';
const $d7426a112a1f91a3$export$daf889beb5092f95 = (0, $nJVLW.confluenceJiraIssue)({
    parseDOM: [
        {
            tag: `span[data-node-type="${$d7426a112a1f91a3$var$name}"]`,
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': $d7426a112a1f91a3$var$name,
            'data-macro-id': node.attrs.macroId,
            'data-schema-version': node.attrs.schemaVersion,
            'data-server': node.attrs.server,
            'data-server-id': node.attrs.serverId,
            'data-jira-issue': node.attrs.issueKey
        };
        return [
            'span',
            attrs,
            node.attrs.issueKey
        ];
    }
});

});

parcelRegister("99RFR", function(module, exports) {
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $01b87e4e18733712$export$e6e4878f43c27cab);

var $nJVLW = parcelRequire("nJVLW");
const $01b87e4e18733712$var$name = 'confluenceUnsupportedBlock';
const $01b87e4e18733712$export$e6e4878f43c27cab = (0, $nJVLW.confluenceUnsupportedBlock)({
    toDOM (node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        const attrs = {
            'data-node-type': $01b87e4e18733712$var$name,
            'data-confluence-unsupported': 'block',
            'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$01b87e4e18733712$var$name}"]`,
            getAttrs (dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("4LGm1", function(module, exports) {
$parcel$export(module.exports, "confluenceUnsupportedInline", () => $378c67d877621958$export$3e6d667072febc87);

var $nJVLW = parcelRequire("nJVLW");
const $378c67d877621958$var$name = 'confluenceUnsupportedInline';
const $378c67d877621958$export$3e6d667072febc87 = (0, $nJVLW.confluenceUnsupportedInline)({
    toDOM (node) {
        const attrs = {
            'data-node-type': $378c67d877621958$var$name,
            'data-confluence-unsupported': 'inline',
            'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$378c67d877621958$var$name}"]`,
            getAttrs (dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("s7CHM", function(module, exports) {
$parcel$export(module.exports, "date", () => $0548877699ee10bf$export$324d90190a8b822a);
$parcel$export(module.exports, "dateWithLocalId", () => $0548877699ee10bf$export$a6a035390e3921b2);

var $nJVLW = parcelRequire("nJVLW");

var $2OrIX = parcelRequire("2OrIX");
const $0548877699ee10bf$export$324d90190a8b822a = (0, $nJVLW.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: (dom)=>({
                    timestamp: dom.getAttribute('data-timestamp')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp
        };
        return [
            'span',
            attrs
        ];
    }
});
const $0548877699ee10bf$export$a6a035390e3921b2 = (0, $nJVLW.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: (dom)=>({
                    timestamp: dom.getAttribute('data-timestamp'),
                    localId: (0, $2OrIX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("eblOZ", function(module, exports) {
$parcel$export(module.exports, "decisionItem", () => $a533050aace96451$export$6959e16eeff859b4);

var $2OrIX = parcelRequire("2OrIX");

var $nJVLW = parcelRequire("nJVLW");
const $a533050aace96451$export$6959e16eeff859b4 = (0, $nJVLW.decisionItem)({
    parseDOM: [
        {
            tag: 'li[data-decision-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $2OrIX.uuid).generate(),
                    state: dom.getAttribute('data-decision-state')
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-decision-local-id': localId || 'local-decision',
            'data-decision-state': state
        };
        return [
            'li',
            attrs,
            0
        ];
    }
});

});

parcelRegister("9FkNK", function(module, exports) {
$parcel$export(module.exports, "decisionListSelector", () => $70981417a2cd0f7b$export$a5393ce68c2ff601);
$parcel$export(module.exports, "decisionList", () => $70981417a2cd0f7b$export$62d45a65fb43d95e);

var $2OrIX = parcelRequire("2OrIX");

var $nJVLW = parcelRequire("nJVLW");
/**
 * @name decisionList_node
 */ const $70981417a2cd0f7b$var$name = 'decisionList';
const $70981417a2cd0f7b$export$a5393ce68c2ff601 = `[data-node-type="${$70981417a2cd0f7b$var$name}"]`;
const $70981417a2cd0f7b$export$62d45a65fb43d95e = (0, $nJVLW.decisionList)({
    parseDOM: [
        {
            tag: `ol${$70981417a2cd0f7b$export$a5393ce68c2ff601}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $2OrIX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $70981417a2cd0f7b$var$name,
            'data-decision-list-local-id': localId || 'local-decision-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("gjQyF", function(module, exports) {
$parcel$export(module.exports, "doc", () => $be1730a7caadbb4e$export$2a111da947c407d2);

var $nJVLW = parcelRequire("nJVLW");
const $be1730a7caadbb4e$export$2a111da947c407d2 = (0, $nJVLW.doc)({});

});

parcelRegister("YIci7", function(module, exports) {
$parcel$export(module.exports, "embedCard", () => $0b67e35d143af9e6$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "embedCardWithLocalId", () => $0b67e35d143af9e6$export$36734475a7f6fd3e);

var $nJVLW = parcelRequire("nJVLW");

var $2OrIX = parcelRequire("2OrIX");
const $0b67e35d143af9e6$export$be4283d9a1cb1ff6 = (0, $nJVLW.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: (dom)=>({
                    url: dom.getAttribute('data-card-url'),
                    layout: dom.getAttribute('data-layout') || 'center',
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(dom.getAttribute('data-card-original-height')) || null
                })
        }
    ],
    toDOM (node) {
        const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
        const attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight
        };
        return [
            'div',
            attrs
        ];
    }
});
const $0b67e35d143af9e6$export$36734475a7f6fd3e = (0, $nJVLW.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: (dom)=>({
                    url: dom.getAttribute('data-card-url'),
                    layout: dom.getAttribute('data-layout') || 'center',
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(dom.getAttribute('data-card-original-height')) || null,
                    localId: (0, $2OrIX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
        const attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("foHUC", function(module, exports) {
$parcel$export(module.exports, "emoji", () => $b35b28eecd7e0f91$export$a19185d1233fc4b2);
$parcel$export(module.exports, "emojiWithLocalId", () => $b35b28eecd7e0f91$export$ebb3b3c7a0ac9936);

var $4Dhy7 = parcelRequire("4Dhy7");

var $nJVLW = parcelRequire("nJVLW");

var $2OrIX = parcelRequire("2OrIX");
const $b35b28eecd7e0f91$export$a19185d1233fc4b2 = (0, $nJVLW.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $b35b28eecd7e0f91$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $b35b28eecd7e0f91$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $b35b28eecd7e0f91$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: (dom)=>(0, $4Dhy7.acNameToEmoji)(dom.getAttribute('data-emoticon-name'))
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: (dom)=>(0, $4Dhy7.acShortcutToEmoji)(dom.getAttribute('data-hipchat-emoticon'))
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $b35b28eecd7e0f91$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $b35b28eecd7e0f91$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $b35b28eecd7e0f91$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        }
    ],
    toDOM (node) {
        const { shortName: shortName, id: id, text: text } = node.attrs;
        const attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $b35b28eecd7e0f91$export$ebb3b3c7a0ac9936 = (0, $nJVLW.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $b35b28eecd7e0f91$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $b35b28eecd7e0f91$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $b35b28eecd7e0f91$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $2OrIX.uuid).generate()
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: (dom)=>{
                const attrs = (0, $4Dhy7.acNameToEmoji)(dom.getAttribute('data-emoticon-name'));
                return {
                    ...attrs,
                    localId: (0, $2OrIX.uuid).generate()
                };
            }
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: (dom)=>{
                const attrs = (0, $4Dhy7.acShortcutToEmoji)(dom.getAttribute('data-hipchat-emoticon'));
                return {
                    ...attrs,
                    localId: (0, $2OrIX.uuid).generate()
                };
            }
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $b35b28eecd7e0f91$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $b35b28eecd7e0f91$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $b35b28eecd7e0f91$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $2OrIX.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { shortName: shortName, id: id, text: text } = node.attrs;
        const attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});
parcelRegister("4Dhy7", function(module, exports) {
$parcel$export(module.exports, "acNameToEmoji", () => $35f86add2efe8d16$export$f61e93bda2a8b420);
$parcel$export(module.exports, "acShortcutToEmoji", () => $35f86add2efe8d16$export$441f8b58f5790a68);
$parcel$export(module.exports, "getEmojiAcName", () => $35f86add2efe8d16$export$880a2465992fbbe);
// Default emoji id for Confluence glyphs that has no match to Fabric Emoji
const $35f86add2efe8d16$var$DEFAULT_EMOJI_ID = '2b50';
// Default ac:name for emoticons as a fallback is `blue-star`
const $35f86add2efe8d16$var$DEFAULT_EMOJI_ACNAME = 'blue-star';
// ac:hipchat-emoticon prefix when converting to Emoji ID
const $35f86add2efe8d16$var$HC_EMOTICON_PREFIX = 'atlassian-';
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */ const $35f86add2efe8d16$var$acNameToEmojiMap = {
    smile: [
        '1f642',
        ':slight_smile:',
        '\uD83D\uDE42'
    ],
    sad: [
        '1f641',
        ':slight_frown:',
        '\uD83D\uDE41'
    ],
    cheeky: [
        '1f61b',
        ':stuck_out_tongue:',
        '\uD83D\uDE1B'
    ],
    laugh: [
        '1f600',
        ':grinning:',
        '\uD83D\uDE00'
    ],
    wink: [
        '1f609',
        ':wink:',
        '\uD83D\uDE09'
    ],
    information: [
        '2139',
        ':information_source:',
        '\u2139'
    ],
    tick: [
        '2705',
        ':white_check_mark:',
        '\u2705'
    ],
    cross: [
        '274c',
        ':x:',
        '\u274C'
    ],
    warning: [
        '26a0',
        ':warning:',
        '\u26A0'
    ],
    plus: [
        '2795',
        ':heavy_plus_sign:',
        '\u2795'
    ],
    minus: [
        '2796',
        ':heavy_minus_sign:',
        '\u2796'
    ],
    question: [
        '2753',
        ':question:',
        '\u003F'
    ],
    'thumbs-up': [
        '1f44d',
        ':thumbsup:',
        '\uD83D\uDC4D'
    ],
    'thumbs-down': [
        '1f44e',
        ':thumbsdown:',
        '\uD83D\uDC4E'
    ],
    'light-on': [
        '1f4a1',
        ':bulb:',
        '\uD83D\uDCA1'
    ],
    'yellow-star': [
        '2b50',
        ':star:',
        '\uD83D\uDC9B'
    ],
    'light-off': [
        '1f6ab',
        ':no_entry_sign:',
        '\uD83D\uDEAB'
    ],
    'red-star': [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'green-star': [
        '1f49a',
        ':green_heart:',
        '\uD83D\uDC9A'
    ],
    'blue-star': [
        '1f499',
        ':blue_heart:',
        '\uD83D\uDC99'
    ],
    heart: [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'broken-heart': [
        '1f494',
        ':broken_heart:',
        '\uD83D\uDC94'
    ]
};
function $35f86add2efe8d16$export$f61e93bda2a8b420(acName) {
    const emojiData = $35f86add2efe8d16$var$acNameToEmojiMap[acName];
    return emojiData ? {
        id: emojiData[0],
        shortName: emojiData[1],
        text: emojiData[2]
    } : {
        id: $35f86add2efe8d16$var$DEFAULT_EMOJI_ID,
        shortName: `:${acName}:`,
        text: ''
    };
}
function $35f86add2efe8d16$export$bc94e44ec0e7bd82(emojiId) {
    const filterEmojis = (acName)=>$35f86add2efe8d16$var$acNameToEmojiMap[acName] ? $35f86add2efe8d16$var$acNameToEmojiMap[acName][0] === emojiId : false;
    return Object.keys($35f86add2efe8d16$var$acNameToEmojiMap).filter(filterEmojis)[0];
}
function $35f86add2efe8d16$export$441f8b58f5790a68(hipchatEmoticonShortName) {
    return {
        id: `${$35f86add2efe8d16$var$HC_EMOTICON_PREFIX}${hipchatEmoticonShortName}`,
        shortName: `:${hipchatEmoticonShortName}:`,
        text: ''
    };
}
function $35f86add2efe8d16$var$getAcNameFromShortName(shortName) {
    return shortName.slice(shortName[0] === ':' ? 1 : 0, shortName[shortName.length - 1] === ':' ? -1 : shortName.length);
}
function $35f86add2efe8d16$export$880a2465992fbbe({ id: id, shortName: shortName }) {
    if ($35f86add2efe8d16$var$DEFAULT_EMOJI_ID === id) {
        const possibleName = $35f86add2efe8d16$var$getAcNameFromShortName(shortName);
        if (possibleName in $35f86add2efe8d16$var$acNameToEmojiMap) return possibleName;
    }
    return $35f86add2efe8d16$export$bc94e44ec0e7bd82(id) || $35f86add2efe8d16$var$DEFAULT_EMOJI_ACNAME;
}

});


parcelRegister("iBSvH", function(module, exports) {
$parcel$export(module.exports, "blockquote", () => $d8c5f74ef3d86bcc$export$67dc04e652a298ca);
$parcel$export(module.exports, "extendedBlockquote", () => $d8c5f74ef3d86bcc$export$70a64939da3e8455);
$parcel$export(module.exports, "extendedBlockquoteWithLocalId", () => $d8c5f74ef3d86bcc$export$950ebf43f3364a0f);

var $nJVLW = parcelRequire("nJVLW");

var $2OrIX = parcelRequire("2OrIX");
/**
 * @name blockquote_node
 */ const $d8c5f74ef3d86bcc$var$nodeSpecOptions = {
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM () {
        return [
            'blockquote',
            0
        ];
    }
};
const $d8c5f74ef3d86bcc$export$67dc04e652a298ca = (0, $nJVLW.blockquoteLegacy)($d8c5f74ef3d86bcc$var$nodeSpecOptions);
const $d8c5f74ef3d86bcc$export$70a64939da3e8455 = (0, $nJVLW.blockquote)($d8c5f74ef3d86bcc$var$nodeSpecOptions);
const $d8c5f74ef3d86bcc$var$nodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'blockquote',
            getAttrs: ()=>{
                return {
                    localId: (0, $2OrIX.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        return [
            'blockquote',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            },
            0
        ];
    }
};
const $d8c5f74ef3d86bcc$export$950ebf43f3364a0f = (0, $nJVLW.blockquote)($d8c5f74ef3d86bcc$var$nodeSpecOptionsWithLocalId);

});

parcelRegister("ePdnq", function(module, exports) {
$parcel$export(module.exports, "PanelType", () => $acb0347d33162113$export$969277cf61e5a7aa);
$parcel$export(module.exports, "extendedPanel", () => $acb0347d33162113$export$ce20b13564211141);
$parcel$export(module.exports, "extendedPanelWithLocalId", () => $acb0347d33162113$export$855c3c67c9c9ebaf);

var $nJVLW = parcelRequire("nJVLW");

var $2OrIX = parcelRequire("2OrIX");
let $acb0347d33162113$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});
/**
 * @name panel_node
 */ const $acb0347d33162113$var$getDomAttrs = (nodeAttrs)=>{
    const attrs = {
        'data-panel-type': nodeAttrs.panelType,
        'data-panel-icon': nodeAttrs.panelIcon,
        'data-panel-icon-id': nodeAttrs.panelIconId,
        'data-panel-icon-text': nodeAttrs.panelIconText,
        'data-panel-color': nodeAttrs.panelColor,
        'data-local-id': (nodeAttrs === null || nodeAttrs === void 0 ? void 0 : nodeAttrs.localId) || undefined
    };
    return attrs;
};
const $acb0347d33162113$var$getParseDOMAttrs = (allowCustomPanel, dom, generateLocalId)=>{
    let parseDOMAttrs = {
        panelType: dom.getAttribute('data-panel-type')
    };
    if (generateLocalId) parseDOMAttrs.localId = (0, $2OrIX.uuid).generate();
    if (allowCustomPanel) parseDOMAttrs = {
        ...parseDOMAttrs,
        panelIcon: dom.getAttribute('data-panel-icon'),
        panelIconId: dom.getAttribute('data-panel-icon-id'),
        panelIconText: dom.getAttribute('data-panel-icon-text'),
        panelColor: dom.getAttribute('data-panel-color')
    };
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === $acb0347d33162113$export$969277cf61e5a7aa.CUSTOM ? $acb0347d33162113$export$969277cf61e5a7aa.INFO : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};
const $acb0347d33162113$var$createPanelNodeSpecOptions = (allowCustomPanel, generateLocalId)=>({
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: (dom)=>$acb0347d33162113$var$getParseDOMAttrs(allowCustomPanel, dom, generateLocalId)
            }
        ],
        toDOM (node) {
            const attrs = $acb0347d33162113$var$getDomAttrs(node.attrs);
            const contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    });
const $acb0347d33162113$export$ce20b13564211141 = (allowCustomPanel)=>(0, $nJVLW.panel)($acb0347d33162113$var$createPanelNodeSpecOptions(allowCustomPanel));
const $acb0347d33162113$export$855c3c67c9c9ebaf = (allowCustomPanel)=>(0, $nJVLW.panel)($acb0347d33162113$var$createPanelNodeSpecOptions(allowCustomPanel, true));

});

parcelRegister("6r1B4", function(module, exports) {
$parcel$export(module.exports, "extension", () => $01358634d8baf68a$export$1b45514b112dd749);

var $fPSlo = parcelRequire("fPSlo");

var $nJVLW = parcelRequire("nJVLW");
const $01358634d8baf68a$export$1b45514b112dd749 = (0, $nJVLW.extension)({
    parseDOM: [
        {
            tag: '[data-node-type="extension"]',
            getAttrs: (domNode)=>(0, $fPSlo.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("ewUmv", function(module, exports) {
$parcel$export(module.exports, "hardBreak", () => $a93fc62957e42117$export$371da9dd35aba193);

var $nJVLW = parcelRequire("nJVLW");
const $a93fc62957e42117$export$371da9dd35aba193 = (0, $nJVLW.hardBreak)({
    parseDOM: [
        {
            tag: 'br'
        }
    ],
    toDOM () {
        return [
            'br'
        ];
    }
});

});

parcelRegister("8FGKL", function(module, exports) {
$parcel$export(module.exports, "heading", () => $650350f97a125578$export$46e4a324ac90507f);

var $nJVLW = parcelRequire("nJVLW");
/**
 * @name heading_node
 */ /**
 * @name heading_with_no_marks_node
 */ // Check `paragraph` node for why we are doing things like this
/**
 * @name heading_with_alignment_node
 */ /**
 * @name heading_with_indentation_node
 */ const $650350f97a125578$var$getAttrs = (level)=>(domNode)=>{
        var _heading$attrs, _heading$attrs$localI;
        return {
            level: level,
            localId: domNode.getAttribute('data-local-id') || ((_heading$attrs = $650350f97a125578$export$46e4a324ac90507f.attrs) === null || _heading$attrs === void 0 ? void 0 : (_heading$attrs$localI = _heading$attrs.localId) === null || _heading$attrs$localI === void 0 ? void 0 : _heading$attrs$localI.default)
        };
    };
const $650350f97a125578$export$46e4a324ac90507f = (0, $nJVLW.heading)({
    parseDOM: [
        {
            tag: 'h1',
            getAttrs: $650350f97a125578$var$getAttrs(1)
        },
        {
            tag: 'h2',
            getAttrs: $650350f97a125578$var$getAttrs(2)
        },
        {
            tag: 'h3',
            getAttrs: $650350f97a125578$var$getAttrs(3)
        },
        {
            tag: 'h4',
            getAttrs: $650350f97a125578$var$getAttrs(4)
        },
        {
            tag: 'h5',
            getAttrs: $650350f97a125578$var$getAttrs(5)
        },
        {
            tag: 'h6',
            getAttrs: $650350f97a125578$var$getAttrs(6)
        }
    ],
    toDOM (node) {
        const { level: level, localId: localId } = node.attrs;
        const name = 'h' + level;
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});

});

parcelRegister("lM0g9", function(module, exports) {
$parcel$export(module.exports, "image", () => $fd9e48320ef47dab$export$5c452ff88e35e47d);

var $nJVLW = parcelRequire("nJVLW");
const $fd9e48320ef47dab$export$5c452ff88e35e47d = (0, $nJVLW.image)({
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: 'img[src]',
            getAttrs (domNode) {
                const dom = domNode;
                return {
                    src: dom.getAttribute('src'),
                    alt: dom.getAttribute('alt'),
                    title: dom.getAttribute('title')
                };
            }
        }
    ],
    toDOM (node) {
        return [
            'img',
            node.attrs
        ];
    }
});

});

parcelRegister("3MHOZ", function(module, exports) {
$parcel$export(module.exports, "inlineCard", () => $2c17d8cd4306fb03$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineCardWithLocalId", () => $2c17d8cd4306fb03$export$7ed775fc743eadd1);

var $nJVLW = parcelRequire("nJVLW");

var $2OrIX = parcelRequire("2OrIX");
const $2c17d8cd4306fb03$export$cbf8224b64e0d942 = (0, $nJVLW.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : ''
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});
const $2c17d8cd4306fb03$export$7ed775fc743eadd1 = (0, $nJVLW.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $2OrIX.uuid).generate()
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $2OrIX.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : '',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});

});

parcelRegister("5Ufvu", function(module, exports) {
$parcel$export(module.exports, "inlineExtension", () => $44ce3609d5dda29d$export$16b353b2649bd8d9);

var $fPSlo = parcelRequire("fPSlo");

var $nJVLW = parcelRequire("nJVLW");
const $44ce3609d5dda29d$export$16b353b2649bd8d9 = (0, $nJVLW.inlineExtensionWithMarks)({
    parseDOM: [
        {
            tag: 'span[data-extension-type]',
            getAttrs: (domNode)=>(0, $fPSlo.getExtensionAttrs)(domNode, true)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-local-id:': node.attrs.localId,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("gNk91", function(module, exports) {
$parcel$export(module.exports, "layoutColumn", () => $c3a0d938bf65ffc4$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutColumnWithLocalId", () => $c3a0d938bf65ffc4$export$b2e27d292505bac2);

var $nJVLW = parcelRequire("nJVLW");

var $2OrIX = parcelRequire("2OrIX");
const $c3a0d938bf65ffc4$export$ab76e7c03cd6f650 = (0, $nJVLW.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-layout-column': 'true'
        };
        const { width: width } = node.attrs;
        if (width) {
            attrs['style'] = `flex-basis: ${width}%`;
            attrs['data-column-width'] = `${width}`;
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        const contentAttrs = {
            'data-layout-content': 'true'
        };
        return [
            'div',
            attrs,
            [
                'div',
                contentAttrs,
                0
            ]
        ];
    }
});
const $c3a0d938bf65ffc4$export$b2e27d292505bac2 = (0, $nJVLW.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined,
                    localId: (0, $2OrIX.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            'data-layout-column': 'true',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        const { width: width } = node.attrs;
        if (width) {
            attrs['style'] = `flex-basis: ${width}%`;
            attrs['data-column-width'] = `${width}`;
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        const contentAttrs = {
            'data-layout-content': 'true'
        };
        return [
            'div',
            attrs,
            [
                'div',
                contentAttrs,
                0
            ]
        ];
    }
});

});

parcelRegister("bTlUc", function(module, exports) {
$parcel$export(module.exports, "createMediaSpec", () => $8a85d2bbd938d1a8$export$35bdbf5bc8caa677);
$parcel$export(module.exports, "copyPrivateAttributes", () => $8a85d2bbd938d1a8$export$111130fa8968d741);
$parcel$export(module.exports, "media", () => $8a85d2bbd938d1a8$export$987d49ffe1b0900f);
$parcel$export(module.exports, "toJSON", () => $8a85d2bbd938d1a8$export$54fd2c36b5cc6731);

var $51dYk = parcelRequire("51dYk");

var $nJVLW = parcelRequire("nJVLW");

var $2OrIX = parcelRequire("2OrIX");
const $8a85d2bbd938d1a8$export$bb3fe706be61f640 = (0, $nJVLW.media)({}).attrs;
const $8a85d2bbd938d1a8$export$35bdbf5bc8caa677 = (attributes, inline = false, generateLocalId = false)=>{
    const domNodeType = inline ? 'span' : 'div';
    const nodeName = inline ? 'mediaInline' : 'media';
    const parseDOM = [
        {
            tag: `${domNodeType}[data-node-type="${nodeName}"]`,
            getAttrs: (dom)=>{
                const attrs = {};
                if (attributes) Object.keys(attributes).forEach((k)=>{
                    const key = $8a85d2bbd938d1a8$export$f84fdfb973c05bd8(k).replace(/^__/, '');
                    const value = dom.getAttribute(`data-${key}`) || '';
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                const width = Number(attrs.width);
                if (typeof width !== 'undefined' && !isNaN(width)) attrs.width = width;
                const height = Number(attrs.height);
                if (typeof height !== 'undefined' && !isNaN(height)) attrs.height = height;
                if (generateLocalId) attrs.localId = (0, $2OrIX.uuid).generate();
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    const toDOM = (node)=>{
        const attrs = {
            'data-id': node.attrs.id,
            'data-node-type': `${nodeName}`,
            'data-type': node.attrs.type,
            'data-collection': node.attrs.collection,
            'data-occurrence-key': node.attrs.occurrenceKey,
            'data-width': node.attrs.width,
            'data-height': node.attrs.height,
            'data-url': node.attrs.url,
            'data-alt': node.attrs.alt,
            'data-local-id': node.attrs.localId || undefined,
            // toDOM is used for static rendering as well as editor rendering. This comes into play for
            // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
            // node view being used for editing).
            title: 'Attachment',
            // Manually kept in sync with the style of media cards. The goal is to render a plain gray
            // rectangle that provides an affordance for media.
            style: `display: inline-block; border-radius: 3px; background: ${(0, $51dYk.N30)}; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);`
        };
        $8a85d2bbd938d1a8$export$111130fa8968d741(node.attrs, attrs, (key)=>`data-${$8a85d2bbd938d1a8$export$f84fdfb973c05bd8(key.slice(2))}`);
        return [
            `${domNodeType}`,
            attrs
        ];
    };
    if (inline) return (0, $nJVLW.mediaInline)({
        parseDOM: parseDOM,
        toDOM: toDOM
    });
    return (0, $nJVLW.media)({
        parseDOM: [
            ...parseDOM,
            {
                // media-inline.ts uses this same function to generate the nodespec
                // this ensures that we don't make a media inline out of a copied image
                // https://product-fabric.atlassian.net/browse/EDM-2996
                tag: 'img:not(.smart-link-icon)',
                getAttrs: (dom)=>{
                    const attrs = {
                        type: 'external',
                        url: dom.getAttribute('src') || '',
                        alt: dom.getAttribute('alt') || ''
                    };
                    if (generateLocalId) attrs.localId = (0, $2OrIX.uuid).generate();
                    return attrs;
                }
            }
        ],
        toDOM: toDOM
    });
};
const $8a85d2bbd938d1a8$export$987d49ffe1b0900f = $8a85d2bbd938d1a8$export$35bdbf5bc8caa677($8a85d2bbd938d1a8$export$bb3fe706be61f640, false, false);
const $8a85d2bbd938d1a8$export$8446e47a4c7fd000 = $8a85d2bbd938d1a8$export$35bdbf5bc8caa677({
    ...$8a85d2bbd938d1a8$export$bb3fe706be61f640,
    localId: {
        default: (0, $2OrIX.uuid).generate()
    }
}, false, true);
const $8a85d2bbd938d1a8$export$f84fdfb973c05bd8 = (str)=>str.replace(/([^A-Z]+)([A-Z])/g, (_, x, y)=>`${x}-${y.toLowerCase()}`);
const $8a85d2bbd938d1a8$export$111130fa8968d741 = (from, to, map)=>{
    if ($8a85d2bbd938d1a8$export$987d49ffe1b0900f.attrs) Object.keys($8a85d2bbd938d1a8$export$987d49ffe1b0900f.attrs).forEach((key)=>{
        if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
    });
};
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */ const $8a85d2bbd938d1a8$var$optionalAttributes = [
    'occurrenceKey',
    'width',
    'height',
    'url',
    'alt',
    'localId'
];
const $8a85d2bbd938d1a8$var$externalOnlyAttributes = [
    'type',
    'url',
    'width',
    'height',
    'alt',
    'localId'
];
const $8a85d2bbd938d1a8$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs)// Strip private attributes e.g. __fileName, __fileSize, __fileMimeType, etc.
        .filter((key)=>!(key[0] === '_' && key[1] === '_')).reduce((obj, key)=>{
            if (node.attrs.type === 'external' && $8a85d2bbd938d1a8$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
            if ($8a85d2bbd938d1a8$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === '')) return obj;
            if ([
                'width',
                'height'
            ].indexOf(key) !== -1) {
                obj[key] = Number(node.attrs[key]);
                return obj;
            }
            obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});

parcelRegister("goVGV", function(module, exports) {
$parcel$export(module.exports, "mediaGroup", () => $bf0ba381e6b14c0b$export$2855e964765eac9);

var $nJVLW = parcelRequire("nJVLW");
const $bf0ba381e6b14c0b$export$2855e964765eac9 = (0, $nJVLW.mediaGroup)({
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM () {
        return [
            'div',
            {
                'data-node-type': 'mediaGroup'
            },
            0
        ];
    }
});

});

parcelRegister("5RVMs", function(module, exports) {
$parcel$export(module.exports, "mediaInline", () => $445eb905c73a8551$export$38bab695e3f720f1);

var $bTlUc = parcelRequire("bTlUc");

var $2OrIX = parcelRequire("2OrIX");

var $nJVLW = parcelRequire("nJVLW");
const $445eb905c73a8551$export$38bab695e3f720f1 = (0, $bTlUc.createMediaSpec)((0, $nJVLW.mediaInline)({}).attrs, true);
const $445eb905c73a8551$export$aea8e9c496505c61 = (0, $bTlUc.createMediaSpec)({
    ...(0, $nJVLW.mediaInline)({}).attrs,
    localId: {
        default: (0, $2OrIX.uuid).generate()
    }
}, true, true);

});

parcelRegister("8Mfla", function(module, exports) {
$parcel$export(module.exports, "mediaSingleSpec", () => $663eb4b9329f7335$export$5a1e124099b60c6b);
$parcel$export(module.exports, "mediaSingle", () => $663eb4b9329f7335$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleWithCaption", () => $663eb4b9329f7335$export$d35e6c006d4abdfb);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => $663eb4b9329f7335$export$9c58e19811ce4cf5);
$parcel$export(module.exports, "mediaSingleFull", () => $663eb4b9329f7335$export$7e767666f2ce108a);
$parcel$export(module.exports, "mediaSingleFullWithLocalId", () => $663eb4b9329f7335$export$75376a385837c942);
$parcel$export(module.exports, "toJSON", () => $663eb4b9329f7335$export$54fd2c36b5cc6731);

var $QD9UD = parcelRequire("QD9UD");

var $j783N = parcelRequire("j783N");

var $nJVLW = parcelRequire("nJVLW");

var $2OrIX = parcelRequire("2OrIX");
const $663eb4b9329f7335$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    // null makes small images to have original size by default
    layout: {
        default: 'center'
    }
};
const $663eb4b9329f7335$export$5a1e124099b60c6b = ({ withCaption: withCaption = false, withExtendedWidthTypes: withExtendedWidthTypes = false, generateLocalId: generateLocalId = false })=>{
    const getAttrs = (dom)=>{
        if (!(0, $j783N.isDOMElement)(dom)) // this should never happen
        return {
            layout: 'center'
        };
        const layout = dom.getAttribute('data-layout') || 'center';
        const width = Number(dom.getAttribute('data-width')) || null;
        const widthType = dom.getAttribute('data-width-type');
        if (generateLocalId) return {
            layout: layout,
            width: width,
            widthType: widthType,
            localId: (0, $2OrIX.uuid).generate()
        };
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $QD9UD.WidthType).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    const getAttrsFromNode = (node)=>{
        const { layout: layout, width: width } = node.attrs;
        const attrs = {
            'data-node-type': 'mediaSingle',
            'data-layout': layout,
            'data-width': ''
        };
        if (generateLocalId) {
            var _node$attrs;
            attrs['data-local-id'] = (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined;
        }
        if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            const { widthType: widthType } = node.attrs;
            return {
                ...attrs,
                'data-width-type': widthType || (0, $QD9UD.WidthType).PERCENTAGE
            };
        }
        return attrs;
    };
    if (withExtendedWidthTypes && withCaption) return (0, $nJVLW.mediaSingleFull)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (withExtendedWidthTypes && !withCaption) return (0, $nJVLW.mediaSingleWidthType)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (!withExtendedWidthTypes && withCaption) return (0, $nJVLW.mediaSingleCaption)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    return (0, $nJVLW.mediaSingle)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
};
const $663eb4b9329f7335$export$969fe3781ca15058 = $663eb4b9329f7335$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: false
});
const $663eb4b9329f7335$export$d35e6c006d4abdfb = $663eb4b9329f7335$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: false
});
const $663eb4b9329f7335$export$9c58e19811ce4cf5 = $663eb4b9329f7335$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: true
});
const $663eb4b9329f7335$export$7e767666f2ce108a = $663eb4b9329f7335$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true
});
const $663eb4b9329f7335$export$75376a385837c942 = $663eb4b9329f7335$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true,
    generateLocalId: true
});
const $663eb4b9329f7335$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if (node.attrs[key] !== null) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});
parcelRegister("QD9UD", function(module, exports) {
$parcel$export(module.exports, "WidthType", () => $09e33b94b508f894$export$4d41558722ac7eed);
/**
 * @description The widthType attribute is used to support fixed with media single
 */ let $09e33b94b508f894$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({});

});


parcelRegister("7axvl", function(module, exports) {
$parcel$export(module.exports, "mention", () => $538374e55dff7f13$export$db83999c14438df4);
$parcel$export(module.exports, "toJSON", () => $538374e55dff7f13$export$54fd2c36b5cc6731);

var $2OrIX = parcelRequire("2OrIX");

var $nJVLW = parcelRequire("nJVLW");
let $538374e55dff7f13$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
const $538374e55dff7f13$export$db83999c14438df4 = (0, $nJVLW.mention)({
    parseDOM: [
        {
            tag: 'span[data-mention-id]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-mention-id') || $538374e55dff7f13$export$db83999c14438df4.attrs.id.default,
                    text: dom.textContent || $538374e55dff7f13$export$db83999c14438df4.attrs.text.default,
                    accessLevel: dom.getAttribute('data-access-level') || $538374e55dff7f13$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: (0, $2OrIX.uuid).generate()
                };
                const userType = dom.getAttribute('data-user-type');
                if ($538374e55dff7f13$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { id: id, accessLevel: accessLevel, text: text, userType: userType, localId: localId } = node.attrs;
        const attrs = {
            'data-mention-id': id,
            'data-access-level': accessLevel,
            contenteditable: 'false'
        };
        if (localId) attrs['data-local-id'] = localId;
        if (userType) attrs['data-user-type'] = userType;
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $538374e55dff7f13$var$isOptional = (key)=>{
    return [
        'userType',
        'localId'
    ].indexOf(key) > -1;
};
const $538374e55dff7f13$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($538374e55dff7f13$var$isOptional(key) && !node.attrs[key]) return obj;
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});

parcelRegister("6UEeD", function(module, exports) {
$parcel$export(module.exports, "nestedExpand", () => $50872edefbef1f48$export$63cadbf5f4296627);
$parcel$export(module.exports, "nestedExpandWithLocalId", () => $50872edefbef1f48$export$b854197485aa1fa0);

var $nJVLW = parcelRequire("nJVLW");

var $2OrIX = parcelRequire("2OrIX");
/**
 * @name nestedExpand_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name nestedExpand_node
 */ /**
 * @name nestedExpand_with_no_marks_node
 */ function $50872edefbef1f48$var$getExpandAttrs(domNode, generateLocalId) {
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true,
        localId: generateLocalId ? (0, $2OrIX.uuid).generate() : undefined
    };
}
const $50872edefbef1f48$var$nestedExpandFactoryOptions = {
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$50872edefbef1f48$var$getExpandAttrs(domNode, false)
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$50872edefbef1f48$var$getExpandAttrs(domNode, false)
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $50872edefbef1f48$export$63cadbf5f4296627 = (0, $nJVLW.nestedExpand)($50872edefbef1f48$var$nestedExpandFactoryOptions);
const $50872edefbef1f48$export$b854197485aa1fa0 = (0, $nJVLW.nestedExpand)({
    ...$50872edefbef1f48$var$nestedExpandFactoryOptions,
    parseDOM: [
        ...$50872edefbef1f48$var$nestedExpandFactoryOptions.parseDOM,
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$50872edefbef1f48$var$getExpandAttrs(domNode, true)
        },
        {
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$50872edefbef1f48$var$getExpandAttrs(domNode, true)
        }
    ]
});

});

parcelRegister("a4ifE", function(module, exports) {
$parcel$export(module.exports, "orderedListSelector", () => $75486f772c8c4cf6$export$4e7125c7ff595be5);
$parcel$export(module.exports, "orderedList", () => $75486f772c8c4cf6$export$a5dc81035676e7a);
$parcel$export(module.exports, "orderedListWithLocalId", () => $75486f772c8c4cf6$export$8157adc5747ec436);
$parcel$export(module.exports, "orderedListWithOrder", () => $75486f772c8c4cf6$export$b9ab759e8298198f);
$parcel$export(module.exports, "orderedListWithOrderAndLocalId", () => $75486f772c8c4cf6$export$2ea3505d41d7525d);

var $2OrIX = parcelRequire("2OrIX");

var $nJVLW = parcelRequire("nJVLW");
const $75486f772c8c4cf6$export$4e7125c7ff595be5 = '.ak-ol';
const $75486f772c8c4cf6$export$a5dc81035676e7a = (0, $nJVLW.orderedList)({
    parseDOM: [
        {
            tag: 'ol'
        }
    ],
    toDOM () {
        const attrs = {
            class: $75486f772c8c4cf6$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
const $75486f772c8c4cf6$export$8157adc5747ec436 = (0, $nJVLW.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: ()=>({
                    localId: (0, $2OrIX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            class: $75486f772c8c4cf6$export$4e7125c7ff595be5.substr(1),
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
const $75486f772c8c4cf6$var$resolveStart = (start)=>{
    const num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $75486f772c8c4cf6$export$b9ab759e8298198f = (0, $nJVLW.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const startDOMAttr = dom.getAttribute('start');
                if (startDOMAttr) {
                    const start = $75486f772c8c4cf6$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM (node) {
        var _node$attrs2;
        const start = $75486f772c8c4cf6$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.order);
        const attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $75486f772c8c4cf6$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
const $75486f772c8c4cf6$export$2ea3505d41d7525d = (0, $nJVLW.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const startDOMAttr = dom.getAttribute('start');
                const localId = (0, $2OrIX.uuid).generate();
                if (startDOMAttr) {
                    const start = $75486f772c8c4cf6$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start,
                        localId: localId
                    };
                }
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs3, _node$attrs4;
        const start = $75486f772c8c4cf6$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.order);
        const attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $75486f772c8c4cf6$export$4e7125c7ff595be5.substr(1),
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs4 = node.attrs) === null || _node$attrs4 === void 0 ? void 0 : _node$attrs4.localId) || undefined
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("bK3tx", function(module, exports) {
$parcel$export(module.exports, "paragraph", () => $88c6afc1badc0455$export$9c206ddddb32a9b);

var $nJVLW = parcelRequire("nJVLW");
const $88c6afc1badc0455$export$9c206ddddb32a9b = (0, $nJVLW.paragraph)({
    parseDOM: [
        {
            tag: 'p',
            getAttrs: (domNode)=>{
                var _paragraph$attrs, _paragraph$attrs$loca;
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || ((_paragraph$attrs = $88c6afc1badc0455$export$9c206ddddb32a9b.attrs) === null || _paragraph$attrs === void 0 ? void 0 : (_paragraph$attrs$loca = _paragraph$attrs.localId) === null || _paragraph$attrs$loca === void 0 ? void 0 : _paragraph$attrs$loca.default)
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const name = 'p';
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});

});

parcelRegister("hbObi", function(module, exports) {
$parcel$export(module.exports, "placeholder", () => $c83a63aa944f66a1$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "placeholderWithLocalId", () => $c83a63aa944f66a1$export$6205248609a8f7a0);

var $nJVLW = parcelRequire("nJVLW");

var $2OrIX = parcelRequire("2OrIX");
const $c83a63aa944f66a1$export$c7187bbd1a7a9244 = (0, $nJVLW.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: (dom)=>({
                    text: dom.getAttribute('data-placeholder') || $c83a63aa944f66a1$export$c7187bbd1a7a9244.attrs.text.default
                })
        }
    ],
    toDOM (node) {
        const { text: text } = node.attrs;
        const attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $c83a63aa944f66a1$export$6205248609a8f7a0 = (0, $nJVLW.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: (dom)=>({
                    text: dom.getAttribute('data-placeholder') || $c83a63aa944f66a1$export$c7187bbd1a7a9244.attrs.text.default,
                    localId: (0, $2OrIX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { text: text } = node.attrs;
        const attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("jC4KP", function(module, exports) {
$parcel$export(module.exports, "rule", () => $e475410b583b636d$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "ruleWithLocalId", () => $e475410b583b636d$export$bf3ef6fb6ad90e7);

var $nJVLW = parcelRequire("nJVLW");

var $2OrIX = parcelRequire("2OrIX");
/**
 * @name rule_node
 */ const $e475410b583b636d$var$hrDOM = [
    'hr'
];
const $e475410b583b636d$export$fbeb3a3956e8a3c7 = (0, $nJVLW.rule)({
    parseDOM: [
        {
            tag: 'hr'
        }
    ],
    toDOM () {
        return $e475410b583b636d$var$hrDOM;
    }
});
const $e475410b583b636d$export$bf3ef6fb6ad90e7 = (0, $nJVLW.rule)({
    parseDOM: [
        {
            tag: 'hr',
            getAttrs: ()=>({
                    localId: (0, $2OrIX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        return [
            'hr',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            }
        ];
    }
});

});

parcelRegister("c2Gqu", function(module, exports) {
$parcel$export(module.exports, "status", () => $8c4694e34f16e8bc$export$471f7ae5c4103ae1);

var $2OrIX = parcelRequire("2OrIX");

var $nJVLW = parcelRequire("nJVLW");
const $8c4694e34f16e8bc$export$471f7ae5c4103ae1 = (0, $nJVLW.status)({
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    text: dom.textContent.replace(/\n/, '').trim(),
                    color: dom.getAttribute('data-color'),
                    localId: (0, $2OrIX.uuid).generate(),
                    style: dom.getAttribute('data-style')
                };
            }
        }
    ],
    toDOM (node) {
        const { text: text, color: color, localId: localId, style: style } = node.attrs;
        const attrs = {
            'data-node-type': 'status',
            'data-color': color,
            'data-local-id': localId,
            'data-style': style,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("6Yq90", function(module, exports) {
$parcel$export(module.exports, "taskListSelector", () => $014f6df118f8d370$export$c0ec71adb7a18fb2);
$parcel$export(module.exports, "taskList", () => $014f6df118f8d370$export$375b6afcc5f4d291);

var $2OrIX = parcelRequire("2OrIX");

var $nJVLW = parcelRequire("nJVLW");
/**
 * @name taskList_node
 */ const $014f6df118f8d370$var$name = 'actionList';
const $014f6df118f8d370$export$c0ec71adb7a18fb2 = `[data-node-type="${$014f6df118f8d370$var$name}"]`;
const $014f6df118f8d370$export$375b6afcc5f4d291 = (0, $nJVLW.taskList)({
    parseDOM: [
        {
            tag: `div${$014f6df118f8d370$export$c0ec71adb7a18fb2}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $2OrIX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $014f6df118f8d370$var$name,
            'data-task-list-local-id': localId || 'local-task-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("53i5t", function(module, exports) {
$parcel$export(module.exports, "text", () => $3adb434dc421ab11$export$6f093cfa640b7166);

var $nJVLW = parcelRequire("nJVLW");
const $3adb434dc421ab11$export$6f093cfa640b7166 = (0, $nJVLW.text)({
    toDebugString: ()=>'text_node'
});

});

parcelRegister("bffKB", function(module, exports) {
$parcel$export(module.exports, "default", () => $82fd5027b66be343$export$2e2bcd8739ae039);
const $82fd5027b66be343$var$name = 'unknownBlock';
var $82fd5027b66be343$export$2e2bcd8739ae039 = {
    group: 'block',
    content: 'inline+',
    marks: '_',
    toDOM () {
        return [
            'div',
            {
                'data-node-type': $82fd5027b66be343$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$82fd5027b66be343$var$name}"]`
        }
    ]
};

});

parcelRegister("e1kFZ", function(module, exports) {
$parcel$export(module.exports, "unsupportedBlock", () => $a3513293b95ecc1d$export$44b79b0979d0f0f7);

var $nJVLW = parcelRequire("nJVLW");
const $a3513293b95ecc1d$export$44b79b0979d0f0f7 = (0, $nJVLW.unsupportedBlock)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedBlock',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    }
});

});

parcelRegister("5blh0", function(module, exports) {
$parcel$export(module.exports, "unsupportedInline", () => $3c5e7b4352f31e0d$export$310ebe0d80122e9b);

var $nJVLW = parcelRequire("nJVLW");
const $3c5e7b4352f31e0d$export$310ebe0d80122e9b = (0, $nJVLW.unsupportedInline)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedInline',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'span',
            attrs,
            'Unsupported content'
        ];
    }
});

});



parcelRegister("1RDZV", function(module, exports) {
$parcel$export(module.exports, "default", () => $d0fcdaf71392d1b2$export$2e2bcd8739ae039);
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d0fcdaf71392d1b2$var$isUndefined(x) {
    return x === undefined;
}
class $d0fcdaf71392d1b2$export$2e2bcd8739ae039 {
    static create(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    providers) {
        const providerFactory = new $d0fcdaf71392d1b2$export$2e2bcd8739ae039();
        const keys = Object.keys(providers);
        keys.forEach((name)=>{
            providerFactory.setProvider(name, providers[name]);
        });
        return providerFactory;
    }
    destroy() {
        this.providers.clear();
        this.subscribers.clear();
    }
    isEmpty() {
        return !this.providers.size && !this.subscribers.size;
    }
    setProvider(name, provider) {
        // Do not trigger notifyUpdate if provider is the same.
        if (this.providers.get(name) === provider) return;
        if (!$d0fcdaf71392d1b2$var$isUndefined(provider)) this.providers.set(name, provider);
        else this.providers.delete(name);
        this.notifyUpdated(name, provider);
    }
    removeProvider(name) {
        this.providers.delete(name);
        this.notifyUpdated(name);
    }
    subscribe(name, handler) {
        const handlers = this.subscribers.get(name) || [];
        handlers.push(handler);
        this.subscribers.set(name, handlers);
        const provider = this.providers.get(name);
        if (provider) handler(name, provider);
        return provider;
    }
    unsubscribe(name, handler) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        const index = handlers.indexOf(handler);
        if (index !== -1) handlers.splice(index, 1);
        if (handlers.length === 0) this.subscribers.delete(name);
        else this.subscribers.set(name, handlers);
    }
    unsubscribeAll(name) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        this.subscribers.delete(name);
    }
    hasProvider(name) {
        return this.providers.has(name);
    }
    notifyUpdated(name, provider) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        handlers.forEach((handler)=>{
            handler(name, provider);
        });
    }
    constructor(){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.providers = new Map();
        this.subscribers = new Map();
    }
}

});

parcelRegister("6Ramj", function(module, exports) {
$parcel$export(module.exports, "ProviderFactoryProvider", () => $7ba0a7c04681d272$export$617c134b25cc4265);
$parcel$export(module.exports, "useProvider", () => $7ba0a7c04681d272$export$693cdb10cec23617);
$parcel$export(module.exports, "useProviderLayout", () => $7ba0a7c04681d272$export$6fde1d0d81db98e1);

var $eJOHy = parcelRequire("eJOHy");

var $1RDZV = parcelRequire("1RDZV");
const $7ba0a7c04681d272$var$ProviderFactoryContext = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(new (0, $1RDZV.default)());
const $7ba0a7c04681d272$export$617c134b25cc4265 = $7ba0a7c04681d272$var$ProviderFactoryContext.Provider;
const $7ba0a7c04681d272$export$a3af4b6980aa23b5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext($7ba0a7c04681d272$var$ProviderFactoryContext);
const $7ba0a7c04681d272$export$693cdb10cec23617 = (name)=>{
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState();
    const providerFactory = $7ba0a7c04681d272$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        const providerHandler = (_, provider)=>{
            setProvider(provider);
        };
        providerFactory.subscribe(name, providerHandler);
        return ()=>{
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};
const $7ba0a7c04681d272$export$6fde1d0d81db98e1 = (name)=>{
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState();
    const providerFactory = $7ba0a7c04681d272$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useLayoutEffect(()=>{
        const providerHandler = (_, provider)=>{
            setProvider(provider);
        };
        providerFactory.subscribe(name, providerHandler);
        return ()=>{
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};

});

parcelRegister("iZVrE", function(module, exports) {
$parcel$export(module.exports, "mapBreakpointToLayoutMaxWidth", () => $697937b55cdec847$export$b5ccf4d25d2c5af1);
$parcel$export(module.exports, "BaseTheme", () => $697937b55cdec847$export$a1a213d350ca51ca);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $loabE = parcelRequire("loabE");

var $7yBx7 = parcelRequire("7yBx7");

var $2bEPZ = parcelRequire("2bEPZ");
function $697937b55cdec847$export$b5ccf4d25d2c5af1(breakpoint) {
    switch(breakpoint){
        case 'M':
        case 'L':
            return 760;
        default:
            return 680;
    }
}
function $697937b55cdec847$export$3de34996b814f0f0({ baseFontSize: baseFontSize, children: children }) {
    const memoizedTheme = (0, $eJOHy.useMemo)(()=>({
            baseFontSize: baseFontSize || 14,
            layoutMaxWidth: (0, $7yBx7.akEditorDefaultLayoutWidth)
        }), [
        baseFontSize
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $loabE.a), {
        theme: memoizedTheme,
        children: children
    });
}
function $697937b55cdec847$export$a1a213d350ca51ca({ children: children, baseFontSize: baseFontSize }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2bEPZ.WidthConsumer), {
        children: ({ breakpoint: breakpoint })=>/*#__PURE__*/ (0, $gt9Am.jsx)($697937b55cdec847$export$3de34996b814f0f0, {
                breakpoint: breakpoint,
                baseFontSize: baseFontSize,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
                    children: children
                })
            })
    });
}

});
parcelRegister("7yBx7", function(module, exports) {
$parcel$export(module.exports, "akEditorFullPageDefaultFontSize", () => $12e0df67293c076b$export$fe6b0b821a0e9067);
$parcel$export(module.exports, "akEditorFullPageDenseFontSize", () => $12e0df67293c076b$export$24495b314f307191);
$parcel$export(module.exports, "akEditorSubtleAccent", () => $12e0df67293c076b$export$1d762aef048d30f9);
$parcel$export(module.exports, "akEditorBlockquoteBorderColor", () => $12e0df67293c076b$export$a7a75e50ae62d0a8);
$parcel$export(module.exports, "akEditorDeleteBorder", () => $12e0df67293c076b$export$3c108a6bc41bb5f2);
$parcel$export(module.exports, "akEditorDeleteIconColor", () => $12e0df67293c076b$export$bf3aaa2106c119fd);
$parcel$export(module.exports, "akEditorCustomIconSize", () => $12e0df67293c076b$export$d2715266dd4a1fd1);
$parcel$export(module.exports, "akEditorSelectedBorderColor", () => $12e0df67293c076b$export$cf524c1b49838a49);
$parcel$export(module.exports, "akEditorSelectedBorderSize", () => $12e0df67293c076b$export$8dac549e32469ac4);
$parcel$export(module.exports, "akEditorSelectedBorderBoldSize", () => $12e0df67293c076b$export$befaaae517e3d864);
$parcel$export(module.exports, "akEditorSelectedBorder", () => $12e0df67293c076b$export$6e1e1996c4e8cc51);
$parcel$export(module.exports, "akEditorSelectedBoxShadow", () => $12e0df67293c076b$export$b6a59ac3a19b6343);
$parcel$export(module.exports, "akEditorUnitZIndex", () => $12e0df67293c076b$export$f35cc48f3398ab79);
$parcel$export(module.exports, "akEditorShadowZIndex", () => $12e0df67293c076b$export$b46cda584c619451);
$parcel$export(module.exports, "akEditorStickyHeaderZIndex", () => $12e0df67293c076b$export$6bed85de54b5de42);
$parcel$export(module.exports, "akEditorSmallZIndex", () => $12e0df67293c076b$export$321ddd2f049dd12);
$parcel$export(module.exports, "akEditorGridLineZIndex", () => $12e0df67293c076b$export$daeac9b8422ac3c2);
$parcel$export(module.exports, "akEditorMenuZIndex", () => $12e0df67293c076b$export$501d46e11ed5bf73);
$parcel$export(module.exports, "akEditorFloatingPanelZIndex", () => $12e0df67293c076b$export$6817b4b6a5ef78f1);
$parcel$export(module.exports, "akEditorFloatingDialogZIndex", () => $12e0df67293c076b$export$93768eb72dec48ce);
$parcel$export(module.exports, "akEditorTableCellOnStickyHeaderZIndex", () => $12e0df67293c076b$export$c0aec4e0896849a0);
$parcel$export(module.exports, "akEditorFloatingOverlapPanelZIndex", () => $12e0df67293c076b$export$5886f057e4f21fe4);
$parcel$export(module.exports, "akEditorTableToolbarSize", () => $12e0df67293c076b$export$6e85faa46d537a3f);
$parcel$export(module.exports, "akEditorTableBorder", () => $12e0df67293c076b$export$36ba77fba4a62d5f);
$parcel$export(module.exports, "akEditorTableToolbar", () => $12e0df67293c076b$export$640eef769748f78f);
$parcel$export(module.exports, "akEditorTableHeaderCellBackground", () => $12e0df67293c076b$export$4c6f61fb4b9ae93);
$parcel$export(module.exports, "akEditorTableBorderSelected", () => $12e0df67293c076b$export$f7bbcec54ff5bc47);
$parcel$export(module.exports, "akEditorFullPageMaxWidth", () => $12e0df67293c076b$export$fad19f16d3f953a3);
$parcel$export(module.exports, "akEditorDefaultLayoutWidth", () => $12e0df67293c076b$export$9db045950eedb49f);
$parcel$export(module.exports, "akEditorWideLayoutWidth", () => $12e0df67293c076b$export$74c442132af16a);
$parcel$export(module.exports, "akEditorFullWidthLayoutWidth", () => $12e0df67293c076b$export$f580e3d28d0986de);
$parcel$export(module.exports, "akEditorTableNumberColumnWidth", () => $12e0df67293c076b$export$37df10057d36a0e5);
$parcel$export(module.exports, "akEditorBreakoutPadding", () => $12e0df67293c076b$export$437293c5e9fc2703);
$parcel$export(module.exports, "akEditorGutterPadding", () => $12e0df67293c076b$export$6e0f4d52efd3d2d);
$parcel$export(module.exports, "akEditorGutterPaddingDynamic", () => $12e0df67293c076b$export$f222e0c7a2dc5324);
$parcel$export(module.exports, "akEditorGutterPaddingReduced", () => $12e0df67293c076b$export$aae87d25ced827bb);
$parcel$export(module.exports, "akEditorFullPageNarrowBreakout", () => $12e0df67293c076b$export$cccda66937c91e4c);
$parcel$export(module.exports, "akEditorMobileBreakoutPoint", () => $12e0df67293c076b$export$efe8561bbd3f74d2);
$parcel$export(module.exports, "akEditorTableCellMinWidth", () => $12e0df67293c076b$export$e4d39a9e8607c1d3);
$parcel$export(module.exports, "akEditorTableLegacyCellMinWidth", () => $12e0df67293c076b$export$43946f2400ab6f1f);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPaddingWide", () => $12e0df67293c076b$export$558438ae7fd4b8ce);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPadding", () => $12e0df67293c076b$export$6beb98d32d4ca149);
$parcel$export(module.exports, "akEditorSwoopCubicBezier", () => $12e0df67293c076b$export$3b24948cd5dbb087);
$parcel$export(module.exports, "gridMediumMaxWidth", () => $12e0df67293c076b$export$5edb4f38c3eacb1a);
$parcel$export(module.exports, "breakoutWideScaleRatio", () => $12e0df67293c076b$export$e60820063058ed59);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidthSmallViewport", () => $12e0df67293c076b$export$60da500206e2ceec);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidth", () => $12e0df67293c076b$export$c0e6648ae1bb2fac);
$parcel$export(module.exports, "akRichMediaResizeZIndex", () => $12e0df67293c076b$export$fb15fade89f67217);
$parcel$export(module.exports, "akLayoutGutterOffset", () => $12e0df67293c076b$export$847030921e9d5a40);
$parcel$export(module.exports, "akEditorLineHeight", () => $12e0df67293c076b$export$40eb41ab799f0329);
$parcel$export(module.exports, "akEditorContextPanelWidth", () => $12e0df67293c076b$export$688a6dc01e760755);
$parcel$export(module.exports, "akEditorTableCellBlanketSelected", () => $12e0df67293c076b$export$e736f2caf3b39eb3);
$parcel$export(module.exports, "akEditorTableCellBlanketDeleted", () => $12e0df67293c076b$export$de3cef07cda55645);
$parcel$export(module.exports, "akEditorWrappedNodeZIndex", () => $12e0df67293c076b$export$e88f6c898960b391);
$parcel$export(module.exports, "blockNodesVerticalMargin", () => $12e0df67293c076b$export$1d0d506416d457f1);
$parcel$export(module.exports, "scaledBlockNodesVerticalMargin", () => $12e0df67293c076b$export$53030af820b542f5);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_WIDTH", () => $12e0df67293c076b$export$e683ef42725d1713);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_HEIGHT", () => $12e0df67293c076b$export$226c784ba04bd04b);
$parcel$export(module.exports, "MAX_BROWSER_SCROLLBAR_HEIGHT", () => $12e0df67293c076b$export$214ff00e5618d86c);
$parcel$export(module.exports, "FULL_PAGE_EDITOR_TOOLBAR_HEIGHT", () => $12e0df67293c076b$export$d7726a000ae2d7c);
$parcel$export(module.exports, "akEditorSelectedNodeClassName", () => $12e0df67293c076b$export$a02a3f1515c2e21a);
$parcel$export(module.exports, "editorFontSize", () => $12e0df67293c076b$export$58a725ff69bda73a);
$parcel$export(module.exports, "relativeFontSizeToBase16", () => $12e0df67293c076b$export$59733a9f61449b25);
$parcel$export(module.exports, "relativeSizeToBaseFontSize", () => $12e0df67293c076b$export$46715ac1fbd9e64e);
$parcel$export(module.exports, "VIEWPORT_SIZES", () => $12e0df67293c076b$export$96b72b7f243fa693);
$parcel$export(module.exports, "akEditorMobileMaxWidth", () => $12e0df67293c076b$export$9369fd010fa0ddd6);
$parcel$export(module.exports, "participantColors", () => $12e0df67293c076b$export$42608c013398a830);

var $eGOwo = parcelRequire("eGOwo");

var $cbSL1 = parcelRequire("cbSL1");

var $92xoS = parcelRequire("92xoS");
const $12e0df67293c076b$export$fe6b0b821a0e9067 = 16;
const $12e0df67293c076b$export$24495b314f307191 = 13;
const $12e0df67293c076b$export$9a7c520c39e1f0aa = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
const $12e0df67293c076b$export$1d762aef048d30f9 = "var(--ds-background-accent-gray-subtler, #DCDFE4)";
const $12e0df67293c076b$export$a7a75e50ae62d0a8 = "var(--ds-border, #091E4224)";
const $12e0df67293c076b$export$b9864494c2608629 = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
const $12e0df67293c076b$export$f0e953d95429ca1 = '12px';
const $12e0df67293c076b$export$a309dbdeca0adb1a = '2px 4px';
const $12e0df67293c076b$export$ef95eb6ef0fd0a4a = "var(--ds-background-danger, #FFECEB)";
const $12e0df67293c076b$export$8f7d2d784079e274 = 'rgba(255, 189, 173, 0.5)'; // R75 with 50% opacity
const $12e0df67293c076b$export$3c108a6bc41bb5f2 = "var(--ds-border-danger, #E2483D)";
const $12e0df67293c076b$export$bf3aaa2106c119fd = "var(--ds-icon-danger, #C9372C)";
const $12e0df67293c076b$export$d2715266dd4a1fd1 = 20;
const $12e0df67293c076b$export$cf524c1b49838a49 = "var(--ds-border-selected, #0C66E4)";
const $12e0df67293c076b$export$8dac549e32469ac4 = 1;
const $12e0df67293c076b$export$befaaae517e3d864 = 2;
const $12e0df67293c076b$export$6e1e1996c4e8cc51 = `${$12e0df67293c076b$export$8dac549e32469ac4}px solid ${"var(--ds-border-selected, #0C66E4)"}`;
const $12e0df67293c076b$export$b6a59ac3a19b6343 = `0 0 0 ${$12e0df67293c076b$export$8dac549e32469ac4}px ${"var(--ds-border-selected, #0C66E4)"}`;
const $12e0df67293c076b$export$37e178ca41c198ca = `0 0 0 ${$12e0df67293c076b$export$befaaae517e3d864}px ${"var(--ds-border-selected, #0C66E4)"}`;
const $12e0df67293c076b$export$4a007c22e25e31f6 = 0.3;
const $12e0df67293c076b$export$f35cc48f3398ab79 = 1;
const $12e0df67293c076b$export$b46cda584c619451 = 2;
const $12e0df67293c076b$export$6bed85de54b5de42 = 11; // filmstrip uses 10 for its shadow
const $12e0df67293c076b$export$321ddd2f049dd12 = $12e0df67293c076b$export$6bed85de54b5de42 + 1;
const $12e0df67293c076b$export$daeac9b8422ac3c2 = 2;
const $12e0df67293c076b$export$501d46e11ed5bf73 = 500;
const $12e0df67293c076b$export$6817b4b6a5ef78f1 = 400;
const $12e0df67293c076b$export$93768eb72dec48ce = $12e0df67293c076b$export$501d46e11ed5bf73 + 10;
const $12e0df67293c076b$export$c0aec4e0896849a0 = $12e0df67293c076b$export$93768eb72dec48ce - 5;
const $12e0df67293c076b$export$5886f057e4f21fe4 = $12e0df67293c076b$export$6817b4b6a5ef78f1 + 5;
const $12e0df67293c076b$export$6e85faa46d537a3f = 11;
const $12e0df67293c076b$export$36ba77fba4a62d5f = "var(--ds-background-accent-gray-subtler, #DCDFE4)";
const $12e0df67293c076b$export$640eef769748f78f = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
const $12e0df67293c076b$export$4c6f61fb4b9ae93 = '#F1F2F4';
const $12e0df67293c076b$export$95e9a0285b97474d = '#2C333A';
const $12e0df67293c076b$export$f7bbcec54ff5bc47 = "var(--ds-border-focused, #388BFF)";
const $12e0df67293c076b$export$76b5e653883e5290 = '3px';
const $12e0df67293c076b$export$6d85fe8177a50c0c = 0.5;
const $12e0df67293c076b$export$fad19f16d3f953a3 = 680;
const $12e0df67293c076b$export$9db045950eedb49f = 760;
const $12e0df67293c076b$export$74c442132af16a = 960; // This value is used for tables with breakouts and is used to calculate `breakoutWidthPx`
const $12e0df67293c076b$export$f580e3d28d0986de = 1800;
const $12e0df67293c076b$export$9d5488b5afad62bf = 1792;
const $12e0df67293c076b$export$37df10057d36a0e5 = 42;
const $12e0df67293c076b$export$437293c5e9fc2703 = 96;
const $12e0df67293c076b$export$6e0f4d52efd3d2d = 32;
const $12e0df67293c076b$export$f222e0c7a2dc5324 = ()=>// eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $eGOwo.fg)('platform_editor_controls_increase_full_page_gutter') && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? 72 : 52;
const $12e0df67293c076b$export$aae87d25ced827bb = 24;
const $12e0df67293c076b$export$cccda66937c91e4c = 600;
const $12e0df67293c076b$export$efe8561bbd3f74d2 = 720;
const $12e0df67293c076b$export$e4d39a9e8607c1d3 = 48;
const $12e0df67293c076b$export$43946f2400ab6f1f = 128;
const $12e0df67293c076b$export$558438ae7fd4b8ce = 12;
const $12e0df67293c076b$export$6beb98d32d4ca149 = 4;
const $12e0df67293c076b$export$3b24948cd5dbb087 = `cubic-bezier(0.15, 1, 0.3, 1)`;
const $12e0df67293c076b$export$5edb4f38c3eacb1a = 1024;
const $12e0df67293c076b$export$e60820063058ed59 = 1.33;
const $12e0df67293c076b$export$60da500206e2ceec = 905; // from breakoutConsts.calcWideWidth, layoutMaxWidth * breakoutConsts.wideScaleRatio = 904.8 ~ 905 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is <= 1266px.
const $12e0df67293c076b$export$c0e6648ae1bb2fac = 1011; // = akEditorDefaultLayoutWidth * breakoutWideScaleRatio = 1010.8 ~ 1011 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is > 1329px.
const $12e0df67293c076b$export$fb15fade89f67217 = $12e0df67293c076b$export$f35cc48f3398ab79 * 99;
const $12e0df67293c076b$export$847030921e9d5a40 = 12;
const $12e0df67293c076b$export$40eb41ab799f0329 = 1.714;
const $12e0df67293c076b$export$e271312fc7124aec = '1px';
const $12e0df67293c076b$export$d29cb2c31fcbb7c5 = 2;
const $12e0df67293c076b$export$688a6dc01e760755 = 320;
const $12e0df67293c076b$export$e736f2caf3b39eb3 = 'rgba(179, 212, 255, 0.3)';
const $12e0df67293c076b$export$de3cef07cda55645 = 'rgba(255, 235, 230, 0.3)';
const $12e0df67293c076b$export$e88f6c898960b391 = $12e0df67293c076b$export$f35cc48f3398ab79 * 2; //prevent paragraph nodes from rendering above wrapped nodes
const $12e0df67293c076b$export$e5c605f2b2a12b00 = {
    SMALL: 550,
    MEDIUM: 760
};
const $12e0df67293c076b$export$1d0d506416d457f1 = '0.75rem';
const $12e0df67293c076b$export$53030af820b542f5 = '0.75em';
const $12e0df67293c076b$export$e683ef42725d1713 = 680;
const $12e0df67293c076b$export$226c784ba04bd04b = 480;
const $12e0df67293c076b$export$214ff00e5618d86c = 20;
const $12e0df67293c076b$export$c82675fa56f2eefd = '56px';
const $12e0df67293c076b$var$DEFAULT_FONT_SIZE = 14;
const $12e0df67293c076b$export$d7726a000ae2d7c = (isToolbarAIFCEnabled)=>{
    if (// if value is undefined assume this is being called outside of editor where the experiment can be checked
    isToolbarAIFCEnabled === undefined ? ((0, $92xoS.editorExperiment)('platform_editor_toolbar_aifc', true) || (0, $eGOwo.fg)('aifc_create_enabled')) && (0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_patch_3', 'isEnabled', true) : isToolbarAIFCEnabled && (0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_patch_3', 'isEnabled', true)) return '44px';
    if ((0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) return "var(--ds-space-500, 40px)";
    return "var(--ds-space-500, 40px)";
};
const $12e0df67293c076b$export$d1343597f3b52d83 = 40;
const $12e0df67293c076b$export$a02a3f1515c2e21a = 'ak-editor-selected-node';
const $12e0df67293c076b$export$58a725ff69bda73a = ({ theme: theme })=>theme && theme.baseFontSize ? theme.baseFontSize : $12e0df67293c076b$var$DEFAULT_FONT_SIZE;
const $12e0df67293c076b$export$945a9e125632354d = (multiplier)=>({ theme: theme })=>$12e0df67293c076b$export$58a725ff69bda73a({
            theme: theme
        }) * multiplier;
const $12e0df67293c076b$export$59733a9f61449b25 = (px)=>{
    if (typeof px === 'string') px = parseInt(px);
    if (isNaN(px)) throw new Error(`Invalid font size: '${px}'`);
    return `${px / 16}rem`;
};
const $12e0df67293c076b$export$46715ac1fbd9e64e = (value)=>{
    return `calc(${value} * var(--ak-editor-base-font-size) / ${$12e0df67293c076b$export$fe6b0b821a0e9067})`;
};
const $12e0df67293c076b$export$96b72b7f243fa693 = {
    laptopHiDPI: {
        width: 1440,
        height: 900
    },
    laptopMDPI: {
        width: 1280,
        height: 800
    },
    tabletL: {
        width: 1024,
        height: 1366
    },
    tabletS: {
        width: 768,
        height: 1024
    },
    mobileM: {
        width: 414,
        height: 736
    },
    mobileS: {
        width: 375,
        height: 667
    },
    mobileXS: {
        width: 320,
        height: 568
    }
};
const $12e0df67293c076b$export$9369fd010fa0ddd6 = 0;
const $12e0df67293c076b$export$846a716e9e69a8df = [
    [
        'White',
        '#000000'
    ],
    [
        'Light blue',
        '#0C294F'
    ],
    [
        'Light teal',
        '#0C343B'
    ],
    [
        'Light green',
        '#052E21'
    ],
    [
        'Light yellow',
        '#484123'
    ],
    [
        'Light red',
        '#441C13'
    ],
    [
        'Light purple',
        '#282249'
    ],
    [
        'Light gray',
        '#202328'
    ],
    [
        'Blue',
        '#0B3165'
    ],
    [
        'Teal',
        '#044853'
    ],
    [
        'Green',
        '#053927'
    ],
    [
        'Yellow',
        '#6F5C25'
    ],
    [
        'Red',
        '#582013'
    ],
    [
        'Purple',
        '#3E327B'
    ],
    [
        'Gray',
        '#475262'
    ],
    [
        'Dark blue',
        '#003884'
    ],
    [
        'Dark teal',
        '#055866'
    ],
    [
        'Dark green',
        '#044932'
    ],
    [
        'Dark yellow',
        '#82641C'
    ],
    [
        'Dark red',
        '#6B2A19'
    ],
    [
        'Dark purple',
        '#4D38B2'
    ]
].map(([colorName, colorValue])=>$12e0df67293c076b$export$5f2dade43b841301(colorName, colorValue)).join('\n');
function $12e0df67293c076b$export$5f2dade43b841301(colorName, colorValue) {
    return `
  &[colorname="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
  }
  `;
}
const $12e0df67293c076b$export$312e1e71424c4aa1 = [
    "var(--ds-icon-accent-red, #C9372C)",
    "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    "var(--ds-icon-accent-magenta, #CD519D)",
    "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "var(--ds-icon-accent-orange, #E56910)",
    "var(--ds-background-accent-orange-bolder-hovered, #A54800)",
    "var(--ds-icon-accent-green, #22A06B)",
    "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    "var(--ds-icon-accent-blue, #1D7AFC)",
    "var(--ds-background-accent-blue-bolder-hovered, #0055CC)",
    "var(--ds-icon-accent-teal, #2898BD)",
    "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    "var(--ds-icon-accent-lime, #6A9A23)",
    "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    "var(--ds-icon-accent-purple, #8270DB)",
    "var(--ds-background-accent-purple-bolder-hovered, #5E4DB2)",
    "var(--ds-icon-accent-gray, #758195)",
    "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
    "var(--ds-icon-accent-yellow, #B38600)",
    "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    "var(--ds-background-accent-yellow-bolder-pressed, #533F04)"
];
const $12e0df67293c076b$export$42608c013398a830 = [
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)",
        svgBackgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-blue-bolder, #0C66E4)",
        svgBackgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
        svgBackgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-yellow-bolder, #946F00)",
        svgBackgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
        svgBackgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-magenta-bolder, #AE4787)",
        svgBackgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-teal-bolder, #227D9B)",
        svgBackgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-orange-bolder, #C25100)",
        svgBackgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-lime-bolder, #5B7F24)",
        svgBackgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-gray-bolder, #626F86)",
        svgBackgroundColor: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-blue-subtle, #579DFF)",
        svgBackgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FF)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
        svgBackgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-orange-subtle, #FEA362)",
        svgBackgroundColor: "var(--ds-background-accent-orange-subtlest, #FFF3EB)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
        svgBackgroundColor: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
        svgBackgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        svgBackgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
        svgBackgroundColor: "var(--ds-background-accent-purple-subtlest, #F3F0FF)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-magenta-subtle, #E774BB)",
        svgBackgroundColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)"
    }
];

});
parcelRegister("cbSL1", function(module, exports) {
$parcel$export(module.exports, "expValEquals", () => $80111f8cfb287dae$export$45abdb3f977b5b14);

var $803eB = parcelRequire("803eB");
function $80111f8cfb287dae$export$45abdb3f977b5b14(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue = null) {
    return (0, $803eB.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, true);
}

});
parcelRegister("803eB", function(module, exports) {
$parcel$export(module.exports, "expValEqualsInternal", () => $1a1aa4dcd65a9a0e$export$58e581060588c6bb);

var $59rsN = parcelRequire("59rsN");

var $4iJGP = parcelRequire("4iJGP");

var $bfW07 = parcelRequire("bfW07");
function $1a1aa4dcd65a9a0e$export$58e581060588c6bb(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, experimentExposure) {
    // @ts-ignore need to loosen the type here to allow for any experiment name
    if ((0, $bfW07._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    // @ts-ignore need to loosen the type here to allow for any experiment name
    return (0, $bfW07._overrides)[experimentName] === experimentExpectedValue;
    // If client is not initialized, we compare with the default value
    if (!(0, $59rsN.default).initializeCompleted()) return experimentDefaultValue === experimentExpectedValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $59rsN.default).getExperimentValue(experimentName, experimentParam, experimentDefaultValue, {
        fireExperimentExposure: experimentExposure
    });
    if (// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $59rsN.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting', 'isEnabled', false)) // Duplicated from /confluence/next/packages/feature-experiments/src/index.ts
    (0, $4iJGP.addFeatureFlagAccessed)(`${experimentName}:${experimentParam}`, experimentValue);
    return experimentValue === experimentExpectedValue;
}

});
parcelRegister("bfW07", function(module, exports) {
$parcel$export(module.exports, "_overrides", () => $98b68f42908704b3$export$e5d73bf4f8e2ae96);
$parcel$export(module.exports, "_paramOverrides", () => $98b68f42908704b3$export$4e849416bb5c5b52);
$parcel$export(module.exports, "_product", () => $98b68f42908704b3$export$cf7305fc65acbf0d);
$parcel$export(module.exports, "setupEditorExperiments", () => $98b68f42908704b3$export$1c2b6dbf79eb3560);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $dpRNR = parcelRequire("dpRNR");

var $iR7nX = parcelRequire("iR7nX");
let $98b68f42908704b3$export$e5d73bf4f8e2ae96 = {};
let $98b68f42908704b3$export$4e849416bb5c5b52 = {};
let $98b68f42908704b3$export$cf7305fc65acbf0d;
function $98b68f42908704b3$export$1c2b6dbf79eb3560(product, /**
	 * Overrides are used to set the group of an experiment for testing purposes.
	 * This is useful when you want to test a specific experiment group.
	 */ groupOverrides, /**
	 * Param overrides are used to set the experiment parameters for testing purposes.
	 * This is useful when you want to tweak the experiment parameters for testing.
	 */ paramOverrides, options) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        // @ts-ignore
        groupOverrides = Object.entries(groupOverrides).reduce((acc, [key, value])=>{
            const config = (0, $dpRNR.editorExperimentsConfig)[key];
            if (config) acc = {
                ...acc,
                [key]: config.typeGuard(value) ? value : config.defaultValue
            };
            return acc;
        }, {});
        $98b68f42908704b3$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    if (product === 'test' && !options?.disableTestOverrides) {
        // Enforce expectation - file overrides, then global overrides, then default to true for boolean
        // experiments, then last result use the default value
        const testOverrides = Object.fromEntries(Object.entries((0, $dpRNR.editorExperimentsConfig)).map(([key, value])=>{
            const defaultValue = typeof value.defaultValue === 'boolean' ? true : value.defaultValue;
            return [
                key,
                groupOverrides?.[key] ?? (0, $iR7nX.testMultivariateOverrides)[key] ?? (0, $iR7nX.testBooleanOverrides)[key] ?? defaultValue
            ];
        }));
        $98b68f42908704b3$export$e5d73bf4f8e2ae96 = testOverrides;
    }
    $98b68f42908704b3$export$cf7305fc65acbf0d = product;
    $98b68f42908704b3$export$4e849416bb5c5b52 = paramOverrides || {};
}

});
parcelRegister("dpRNR", function(module, exports) {
$parcel$export(module.exports, "editorExperimentsConfig", () => $91e9175ec4c776be$export$6cbb856f286b07ef);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $9M2Eg = parcelRequire("9M2Eg");
const $91e9175ec4c776be$export$6cbb856f286b07ef = {
    // new format to avoid collisions with other users when updating the file
    // Editor Platform experiments
    // lwoollard experiments
    // Added 03-09-2025
    cc_editor_limited_mode_include_lcm: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_limited_mode_include_lcm'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 03-09-2025
    cc_editor_interactivity_monitoring: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_interactivity_monitoring'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    cc_editor_insm_doc_size_stats: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_insm_doc_size_stats'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-30
    cc_editor_insm_outlier_events: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_insm_outlier_events'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-09-30
    // variant 1: remove table overflow shadows completely, no table border shown when scrolling.
    // variant 2: remove table overflow shadows, show table border when scrolling.
    // variant 3: replace table overflow shadows with CSS-only solution.
    platform_editor_disable_table_overflow_shadows: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_disable_table_overflow_shadows'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1',
            'variant2',
            'variant3'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-05-27
    platform_editor_reduce_noisy_steps_ncs: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_reduce_noisy_steps_ncs'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-24
    editor_prevent_numbered_column_too_big_jira_1: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            jira: 'editor_prevent_numbered_column_too_big_jira_1'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-02
    platform_editor_block_control_optimise_render: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_control_optimise_render'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-boolean': (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-multivariate': (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        values: [
            'one',
            'two',
            'three'
        ],
        defaultValue: 'one'
    }),
    // Added 2024-08-08
    'test-new-experiments-package': (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_drag_handle_hover: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_drag_handle_hover',
            jira: 'platform_editor_table_drag_handle_hover'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-05
    support_table_in_comment: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_support_table_in_comment_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-07
    platform_editor_exp_lazy_node_views: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_exp_lazy_node_views'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_editor_experience_tracking: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_experience_tracking'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-26
    platform_editor_prevent_toolbar_layout_shifts: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_prevent_toolbar_layout_shifts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-01
    comment_on_bodied_extensions: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_comment_on_bodied_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_advanced_layouts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-3-15
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_single_column_layout/setup
    single_column_layouts: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_column_layout'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-08
    support_table_in_comment_jira: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_support_table_in_comment_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    'platform_editor_ai-prompts-placeholder': (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai-prompts-placeholder'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // added 2024-11-06
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_nested_tables/setup
    'nested-tables-in-tables': (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nested_tables'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_unsplash_page_header'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-12-05
    platform_editor_blockquote_in_text_formatting_menu: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blockquote_in_text_formatting_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-13
    platform_editor_element_drag_and_drop_multiselect: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_element_drag_and_drop_multiselect'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_edit_response_in_preview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-02-10
    platform_editor_controls: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-08-01
    platform_editor_controls_block_controls_state_fix: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls_block_controls_state_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 28-02-2025
    platform_editor_insertion: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_insertion'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-09-03
    platform_editor_hydratable_ui: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_hydratable_ui'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-14
    platform_editor_resizer_cls_fix: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_resizer_cls_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-03-28
    platform_editor_ai_proactive_ai_nudge_parameters: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_proactive_ai_nudge_parameters'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-04-14
    // https://switcheroo.atlassian.com/ui/gates/b159b45a-86d9-4f4b-b482-f9aca5b615d6/key/platform_editor_offline_editing_web
    platform_editor_offline_editing_web: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_offline_editing_web'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-14
    editor_ai_inline_suggestion_date_v2: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'editor_ai_inline_suggestion_date_v2'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-31
    platform_editor_lovability_suppress_toolbar_event: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_suppress_toolbar_event',
            jira: 'platform_editor_lovability_suppress_toolbar_event'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_drag_and_drop: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_drag_and_drop'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_table_selector: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_table_selector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_editor_usesharedpluginstateselector: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_usesharedpluginstateselector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_renderer_fix_analytics_memo_callback: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_fix_analytics_memo_callback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-26
    platform_editor_stop_width_reflows: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_stop_width_reflows'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-10
    platform_editor_no_cursor_on_edit_page_init: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_no_cursor_on_edit_page_init'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_debounce_portal_provider: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_debounce_portal_provider'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-15
    platform_editor_no_ssr: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_no_ssr'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-14
    platform_editor_jira_advanced_code_blocks: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_jira_advanced_code_blocks'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-08 - Jira work sync description comment summary
    'jira-work-sync-desc-comment-summary': (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            jira: 'jira-work-sync-desc-comment-summary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-15
    platform_editor_breakout_resizing: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-07
    platform_editor_ai_quickstart_command: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_quickstart_command'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-05
    platform_editor_block_controls_perf_optimization: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_controls_perf_optimization'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-16
    platform_editor_enable_single_player_step_merging: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_enable_single_player_step_merging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-02
    platform_editor_code_block_fold_gutter: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_code_block_fold_gutter'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-18
    platform_editor_ai_iw_adf_streaming: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_iw_adf_streaming'
        },
        param: 'cohort',
        values: [
            'control',
            'adf_gemini25flash',
            'adf_gpt41mini'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-06-18
    platform_editor_ai_ct_sg_adf_streaming: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_ct_sg_adf_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-20
    platform_editor_ai_non_iw_adf_streaming: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_non_iw_adf_streaming'
        },
        param: 'cohort',
        values: [
            'control',
            'adf_gemini25flash',
            'adf_gpt41mini'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-07-07
    platform_editor_ai_remove_trivial_prompts_cc: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_remove_trivial_prompts_cc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    //Added 2025-07-25
    platform_editor_extension_styles: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_extension_styles'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-20
    confluence_whiteboards_quick_insert_aa: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert_aa'
        },
        param: 'cohort',
        values: [
            'control',
            'test_blank',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-06-24
    platform_editor_find_and_replace_improvements: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_find_and_replace_improvements'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-24
    confluence_whiteboards_quick_insert: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert'
        },
        param: 'cohort',
        values: [
            'control',
            'test_blank',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-06-26
    platform_editor_feedback_mandatory_rating: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_feedback_mandatory_rating'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_drag_handle_aria_label: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_drag_handle_aria_label'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-07
    platform_editor_toggle_expand_on_match_found: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toggle_expand_on_match_found'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_smart_card_otp: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_smart_card_otp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-15
    platform_editor_preview_panel_responsiveness: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_preview_panels_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_preview_panel_linking_exp: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_preview_panel_linking_exp_conf',
            jira: 'platform_editor_preview_panel_linking_exp_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_editor_hoverlink_ui_fixes_exp: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_hoverlink_ui_fixes_exp'
        },
        param: 'cohort',
        values: [
            'control',
            'css_changes_only',
            'css_js_changes'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-08-17
    platform_hover_card_preview_panel: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_hover_card_preview_panel',
            jira: 'platform_hover_card_preview_panel'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-09-17
    platform_hover_card_preview_panel_modal: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_hover_card_preview_panel_modal',
            jira: 'platform_hover_card_preview_panel_modal'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025--8-05
    platform_editor_block_menu: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025--9-17
    platform_editor_block_menu_empty_line: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_menu_empty_line'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    platform_editor_emoji_otp: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_emoji_otp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-23
    platform_editor_renderer_breakout_fix: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_renderer_breakout_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-24
    editor_enghealth_hyperlink_toolbar_aria_values: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_enghealth_hyperlink_toolbar_aria_values'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_add_orange_highlight_color: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_add_orange_highlight_color'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    //Added 2025-07-16
    platform_editor_toolbar_aifc: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_toolbar_aifc_jira',
            confluence: 'platform_editor_toolbar_aifc_confluence'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-04
    editor_refactor_backspace_task_and_decisions: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_refactor_backspace_task_and_decisions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    //Added 2025-07-16
    platform_editor_toolbar_aifc_patch_3: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_toolbar_aifc_patch_3',
            confluence: 'platform_editor_toolbar_aifc_patch_3'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    //Added 2025-09-09
    platform_editor_toolbar_aifc_patch_4: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_toolbar_aifc_patch_4',
            confluence: 'platform_editor_toolbar_aifc_patch_4'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-29
    platform_editor_toolbar_aifc_selection_extension: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_selection_extension',
            jira: 'platform_editor_toolbar_aifc_selection_extension'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-04
    platform_editor_floating_toolbar_button_aria_label: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_floating_toolbar_button_aria_label'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-24
    platform_editor_enghealth_table_plugin_lable_rule: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_enghealth_table_plugin_lable_rule'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-31
    platform_editor_breakout_interaction_rerender: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_interaction_rerender'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-27
    platform_editor_toolbar_aifc_responsive: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_responsive',
            jira: 'platform_editor_toolbar_aifc_responsive'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_pasting_nested_table_fix: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_pasting_nested_table_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 20205-07-28
    platform_editor_fix_quick_insert_consistency_exp: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_quick_insert_consistency_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-31
    platform_editor_fix_a11y_aria_posinset_0: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_a11y_aria_posinset_0'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_blocktaskitem_node_tenantid: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_node_tenantid'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-08
    platform_editor_blocktaskitem_patch_1: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_patch_1'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-06
    cc_editor_limited_mode: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_limited_mode'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_native_anchor_support: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_native_anchor_support'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-28
    editor_enable_image_alignment_in_expand: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_enable_image_alignment_in_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_august_a11y: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_august_a11y'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-10
    platform_synced_block: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_synced_block'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    cc_improve_writing_on_paste_v2: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_improve_writing_on_paste_v2'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_locale_datepicker: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_locale_datepicker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_find_replace_a11y_fixes: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_find_replace_a11y_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-19
    platform_editor_breakout_resizing_vc90_fix: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing_vc90_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-27
    platform_editor_toolbar_support_custom_components: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_support_custom_components'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-21
    platform_editor_paste_rich_text_bugfix: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_paste_rich_text_bugfix',
            jira: 'platform_editor_paste_rich_text_bugfix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-25
    platform_editor_toolbar_aifc_template_editor: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_template_editor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-26
    platform_editor_toolbar_migrate_loom: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_migrate_loom',
            jira: 'platform_editor_toolbar_migrate_loom'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    platform_editor_prevent_taskitem_remount: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_prevent_taskitem_remount'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-01
    cc_editor_ai_content_mode: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_ai_content_mode'
        },
        param: 'variant',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-09-08
    platform_editor_editor_width_analytics: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_editor_width_analytics',
            jira: 'platform_editor_editor_width_analytics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-10
    platform_editor_fix_button_name_violation_in_table: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_button_name_violation_in_table'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-11
    platform_editor_quick_insert_image_wrap_right_fix: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_quick_insert_image_wrap_right_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-11
    platform_editor_block_menu_layout_format: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_menu_layout_format'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-11
    platform_editor_block_menu_expand_format: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_menu_expand_format'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-17
    platform_editor_block_menu_keyboard_navigation: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_menu_keyboard_navigation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-11
    platform_editor_add_aria_checked_to_inline_img_btn: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_add_aria_checked_to_inline_image_btn'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    platform_editor_nested_table_refresh_width_fix: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nested_table_refresh_width_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-15
    platform_editor_toolbar_aifc_patch_5: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_patch_5'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-18
    platform_editor_toolbar_aifc_renderer_selection: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_renderer_selection'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_use_llm_space_recommendations: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_use_llm_space_recommendations'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-15
    platform_editor_text_highlight_padding: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_text_highlight_padding'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-24
    platform_editor_lovability_user_intent: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_user_intent'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-17
    cc_complexit_fe_emoji_stability: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_complexit_fe_emoji_stability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-23
    cc_editor_ttvc_release_bundle_one: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_ttvc_release_bundle_one'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-07
    platform_editor_plain_text_support: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_plain_text_support',
            confluence: 'platform_editor_plain_text_support'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-26
    platform_editor_toolbar_aifc_patch_6: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_patch_6'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-17
    confluence_content_mode_replace_dense_with_compact: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_content_mode_replace_dense_with_compact'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-01
    platform_inline_smartcard_connect_button_exp: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_inline_smartcard_connect_button_exp',
            jira: 'platform_inline_smartcard_connect_button_exp'
        },
        param: 'cohort',
        values: [
            'control',
            'test1',
            'test2'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-10
    platform_editor_new_list_decorations_logic: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_new_list_decorations_logic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-13
    platform_editor_media_error_analytics: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_error_analytics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-15
    platform_editor_new_mentions_detection_logic: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_new_mentions_detection_logic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-20
    confluence_whiteboards_quick_insert_localised: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert_localised'
        },
        param: 'cohort',
        values: [
            'control',
            'test_blank',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-28
    confluence_whiteboards_quick_insert_localised_aa: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert_localised_aa'
        },
        param: 'cohort',
        values: [
            'control',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-22
    platform_editor_remove_bidi_char_warning: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_bidi_char_warning'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-24
    platform_editor_fix_clone_nesting_exp: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_clone_nesting_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-27
    platform_editor_table_sticky_header_improvements: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_improvements'
        },
        param: 'cohort',
        values: [
            'control',
            'test_with_overflow',
            'test_without_overflow'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-11-04
    platform_editor_disable_lazy_load_media: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_disable_lazy_load_media'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-29
    platform_editor_lovability_inline_code: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_inline_code'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-05
    platform_editor_lovability_emoji_scaling: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_emoji_scaling'
        },
        param: 'isEnabled',
        defaultValue: false
    })
};

});
parcelRegister("9M2Eg", function(module, exports) {
$parcel$export(module.exports, "createBooleanExperiment", () => $99d69a3554c71d9e$export$456f1587c9c92021);
$parcel$export(module.exports, "createMultivariateExperiment", () => $99d69a3554c71d9e$export$fb89e8a786694d1);

var $cFacD = parcelRequire("cFacD");
function $99d69a3554c71d9e$export$456f1587c9c92021(config) {
    return {
        ...config,
        typeGuard: (0, $cFacD.isBoolean),
        defaultValue: config.defaultValue
    };
}
function $99d69a3554c71d9e$export$fb89e8a786694d1(config) {
    const { values: values } = config;
    return {
        ...config,
        values: [
            ...values
        ],
        typeGuard: (0, $cFacD.oneOf)(config.values),
        defaultValue: config.defaultValue
    };
}

});
parcelRegister("cFacD", function(module, exports) {
$parcel$export(module.exports, "isBoolean", () => $ae50fe7194104c61$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "oneOf", () => $ae50fe7194104c61$export$a9a18ae5ba42aeab);
function $ae50fe7194104c61$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}
function $ae50fe7194104c61$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
	 * This is used by test utils to get the variants when running describe.each
	 */ if ($ae50fe7194104c61$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}
const $ae50fe7194104c61$var$IS_TESTING_ENV = false;

});



parcelRegister("iR7nX", function(module, exports) {
$parcel$export(module.exports, "testMultivariateOverrides", () => $88e4e44d8ad6406b$export$7e849a84a00ffd1c);
$parcel$export(module.exports, "testBooleanOverrides", () => $88e4e44d8ad6406b$export$54960937bb713f97);
const $88e4e44d8ad6406b$export$7e849a84a00ffd1c = {
    'example-multivariate': 'one',
    'platform_editor_ai-prompts-placeholder': 'control',
    platform_editor_ai_proactive_ai_nudge_parameters: 'control',
    platform_editor_controls: 'control',
    confluence_whiteboards_quick_insert_aa: 'control',
    confluence_whiteboards_quick_insert: 'control',
    confluence_whiteboards_quick_insert_localised: 'control',
    confluence_whiteboards_quick_insert_localised_aa: 'control',
    platform_editor_insertion: 'control',
    editor_ai_inline_suggestion_date_v2: 'control',
    cc_editor_ai_content_mode: 'control',
    platform_editor_add_orange_highlight_color: 'control',
    platform_editor_ai_iw_adf_streaming: 'control',
    platform_editor_ai_non_iw_adf_streaming: 'control',
    platform_hover_card_preview_panel: 'control',
    platform_hover_card_preview_panel_modal: 'control',
    platform_inline_smartcard_connect_button_exp: 'control',
    confluence_content_mode_replace_dense_with_compact: 'control',
    cc_editor_insm_outlier_events: 'test',
    platform_editor_disable_table_overflow_shadows: 'control',
    platform_editor_hoverlink_ui_fixes_exp: 'control',
    platform_editor_table_sticky_header_improvements: 'control'
};
const $88e4e44d8ad6406b$export$54960937bb713f97 = {
    platform_editor_feedback_mandatory_rating: false,
    platform_editor_preview_panel_responsiveness: false,
    platform_editor_renderer_breakout_fix: false,
    platform_editor_toolbar_aifc: false,
    platform_editor_block_control_optimise_render: false,
    'test-new-experiments-package': false,
    support_table_in_comment: false,
    platform_editor_exp_lazy_node_views: false,
    platform_renderer_table_sticky_scrollbar: false,
    platform_editor_prevent_toolbar_layout_shifts: false,
    comment_on_bodied_extensions: false,
    advanced_layouts: false,
    single_column_layouts: false,
    support_table_in_comment_jira: false,
    'nested-tables-in-tables': false,
    platform_editor_ai_unsplash_page_header: false,
    platform_editor_blockquote_in_text_formatting_menu: false,
    platform_editor_element_drag_and_drop_multiselect: false,
    platform_editor_ai_edit_response_in_preview: false,
    platform_editor_offline_editing_web: false,
    platform_editor_tables_drag_and_drop: false,
    platform_editor_tables_table_selector: false,
    platform_renderer_fix_analytics_memo_callback: false,
    platform_editor_stop_width_reflows: false,
    platform_editor_no_cursor_on_edit_page_init: false,
    'jira-work-sync-desc-comment-summary': false,
    platform_editor_breakout_resizing: false,
    platform_editor_ai_quickstart_command: false,
    platform_editor_block_controls_perf_optimization: false,
    platform_editor_enable_single_player_step_merging: false,
    platform_editor_ai_remove_trivial_prompts_cc: false,
    platform_editor_find_and_replace_improvements: false,
    platform_editor_toggle_expand_on_match_found: false,
    platform_editor_reduce_noisy_steps_ncs: false,
    cc_improve_writing_on_paste_v2: false,
    platform_editor_text_highlight_padding: false
};

});




parcelRegister("92xoS", function(module, exports) {
$parcel$export(module.exports, "editorExperiment", () => $19fb77b8a89e4410$export$9b7cf3b74f250027);
$parcel$export(module.exports, "unstable_editorExperimentParam", () => $19fb77b8a89e4410$export$92316ae898e357eb);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $59rsN = parcelRequire("59rsN");

var $4iJGP = parcelRequire("4iJGP");

var $dpRNR = parcelRequire("dpRNR");

var $bfW07 = parcelRequire("bfW07");
function $19fb77b8a89e4410$export$9b7cf3b74f250027(experimentName, expectedExperimentValue, options = {
    exposure: false
}) {
    const experimentConfig = (0, $dpRNR.editorExperimentsConfig)[experimentName];
    if ((0, $bfW07._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $bfW07._overrides)[experimentName] === expectedExperimentValue;
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error(`Editor experiment configuration is not defined ${experimentName}. Likely the experiment does not exist or editor package versions are misaligned`);
    if (!(0, $bfW07._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return experimentConfig.defaultValue === expectedExperimentValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const experimentKey = experimentConfig?.productKeys?.[0, $bfW07._product];
    if (!experimentKey) // This will be hit in the case of an experiment not being set up for the product
    return (0, $dpRNR.editorExperimentsConfig)[experimentName]?.defaultValue === expectedExperimentValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $59rsN.default).getExperimentValue(// @ts-ignore
    experimentKey, experimentConfig.param, experimentConfig.defaultValue, {
        typeGuard: experimentConfig.typeGuard,
        fireExperimentExposure: options.exposure
    });
    if (// When cleaning this gate up -- `calling where the experiments have the product key set`
    // in __tests__/experiments should be updated (as it's had the count bumped to include these).
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $59rsN.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting', 'isEnabled', false)) (0, $4iJGP.addFeatureFlagAccessed)(`${experimentName}:${experimentConfig.param}`, experimentValue);
    return expectedExperimentValue === experimentValue;
}
function $19fb77b8a89e4410$export$92316ae898e357eb(experimentName, paramName, options) {
    if ((0, $bfW07._paramOverrides)[experimentName]?.[paramName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $bfW07._paramOverrides)[experimentName][paramName];
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $59rsN.default).getExperimentValue(experimentName, paramName, options.defaultValue, {
        typeGuard: options.typeGuard,
        fireExperimentExposure: options.exposure ?? false
    });
    return experimentValue;
}

});


parcelRegister("2bEPZ", function(module, exports) {
$parcel$export(module.exports, "getBreakpoint", () => $7765fd643b71afb3$export$1eb095b00b926404);
$parcel$export(module.exports, "createWidthContext", () => $7765fd643b71afb3$export$31a4966bffb9ac98);
$parcel$export(module.exports, "WidthContext", () => $7765fd643b71afb3$export$27e39f636459b9f);
$parcel$export(module.exports, "WidthConsumer", () => $7765fd643b71afb3$export$5d8538aa831b6ebb);
$parcel$export(module.exports, "WidthProvider", () => $7765fd643b71afb3$export$7921e18173e8c666);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $LFmXM = parcelRequire("LFmXM");

var $bRPNB = parcelRequire("bRPNB");

var $gMRLG = parcelRequire("gMRLG");

var $fNh22 = parcelRequire("fNh22");
function $7765fd643b71afb3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7765fd643b71afb3$var$styles = {
    name: "pw7jst",
    styles: "position:relative;width:100%"
};
const $7765fd643b71afb3$var$SCROLLBAR_WIDTH = 30;
function $7765fd643b71afb3$export$1eb095b00b926404(width = 0) {
    const MAX_S = 1266;
    const MAX_M = 2146;
    if (width >= MAX_S && width < MAX_M) return 'M';
    else if (width >= MAX_M) return 'L';
    return 'S';
}
function $7765fd643b71afb3$export$31a4966bffb9ac98(width = 0) {
    return {
        width: width,
        breakpoint: $7765fd643b71afb3$export$1eb095b00b926404(width)
    };
}
const $7765fd643b71afb3$export$27e39f636459b9f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext($7765fd643b71afb3$export$31a4966bffb9ac98());
const { Provider: $7765fd643b71afb3$var$Provider, Consumer: $7765fd643b71afb3$export$5d8538aa831b6ebb } = $7765fd643b71afb3$export$27e39f636459b9f;
const $7765fd643b71afb3$export$df154c49e93b2ac2 = (0, $LFmXM.default)(()=>{
    return (0, $fNh22.isSSR)() ? 0 : document.body?.offsetWidth ?? 0;
});
const $7765fd643b71afb3$export$7921e18173e8c666 = ({ className: className, shouldCheckExistingValue: shouldCheckExistingValue, children: children })=>{
    const existingContextValue = (0, $eJOHy.useContext)($7765fd643b71afb3$export$27e39f636459b9f);
    const [width, setWidth] = (0, $eJOHy.useState)($7765fd643b71afb3$export$df154c49e93b2ac2);
    const widthRef = (0, $eJOHy.useRef)(width);
    const isMountedRef = (0, $eJOHy.useRef)(true);
    const providerValue = (0, $eJOHy.useMemo)(()=>$7765fd643b71afb3$export$31a4966bffb9ac98(width), [
        width
    ]);
    const updateWidth = (0, $eJOHy.useMemo)(()=>{
        return (0, $bRPNB.default)((nextWidth)=>{
            const currentWidth = widthRef.current || 0;
            // Ignore changes that are less than SCROLLBAR_WIDTH, otherwise it can cause infinite re-scaling
            if (Math.abs(currentWidth - nextWidth) < $7765fd643b71afb3$var$SCROLLBAR_WIDTH) return;
            // Avoid React memory leak by checking if the component is still mounted
            if (!isMountedRef.current) return;
            widthRef.current = nextWidth;
            setWidth(nextWidth);
        });
    }, []);
    const skipWidthDetection = shouldCheckExistingValue && existingContextValue.width > 0;
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useLayoutEffect(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $7765fd643b71afb3$var$styles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, !skipWidthDetection && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $gMRLG.WidthObserver), {
        setWidth: updateWidth,
        offscreen: true
    }), /*#__PURE__*/ (0, $1NIU8.jsx)($7765fd643b71afb3$var$Provider, {
        value: providerValue
    }, children)), skipWidthDetection && children);
};

});
parcelRegister("fNh22", function(module, exports) {
$parcel$export(module.exports, "isSSR", () => $8d37e6f7c6dd916d$export$48d7c418edadb60c);

var $igDjg = parcelRequire("igDjg");
function $8d37e6f7c6dd916d$export$48d7c418edadb60c() {
    try {
        return Boolean(// In most places there is no document when running on server-side
        typeof document === 'undefined' || // When SSRing editor with full cycle mode we define the document
        // Check Confluence specific environment variable
        typeof $igDjg !== 'undefined' && undefined);
    } catch (e) {
        // Catch possible error that might occur and just return false
        return false;
    }
}

});



parcelRegister("jjlK8", function(module, exports) {
$parcel$export(module.exports, "IntlErrorBoundary", () => $e2aede23e89d0b7e$export$7df0749115d18d19);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4nehu = parcelRequire("4nehu");
const $e2aede23e89d0b7e$export$c7ef921528e1d279 = '<IntlProvider> needs to exist in the component ancestry';
const $e2aede23e89d0b7e$var$isMissingIntlProviderInAncestryError = (err)=>err?.toString()?.includes('<IntlProvider> needs to exist in the component ancestry');
class $e2aede23e89d0b7e$export$7df0749115d18d19 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidCatch(error, errorInfo) {
        // if missing IntlProvider in ancestry, we setup a fallback IntlProvider ourselves
        if ($e2aede23e89d0b7e$var$isMissingIntlProviderInAncestryError(error)) this.setState({
            missingIntlProviderInAncestry: true
        });
        else // else we re-propagate the non-react-intl-next error
        throw error;
    }
    render() {
        if (this.state.missingIntlProviderInAncestry) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
            locale: "en",
            children: this.props.children
        });
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            missingIntlProviderInAncestry: false
        };
    }
}

});

parcelRegister("93FVZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $6999eed130dec5d2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");

var $7yBx7 = parcelRequire("7yBx7");

var $k9Gmz = parcelRequire("k9Gmz");

var $k71qx = parcelRequire("k71qx");

var $bMFKb = parcelRequire("bMFKb");

var $gPpAv = parcelRequire("gPpAv");

var $3mTkR = parcelRequire("3mTkR");

var $z9Bay = parcelRequire("z9Bay");
const $6999eed130dec5d2$var$blockNodeStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    background: "var(--ds-background-disabled, #091E4208)",
    border: `${"var(--ds-border-width, 1px)"} dashed ${"var(--ds-border-disabled, #091E420F)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-radius-small, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $7yBx7.relativeFontSizeToBase16)(14),
    margin: `${"var(--ds-space-100, 8px)"} 0`,
    minHeight: '24px',
    padding: "var(--ds-space-150, 12px)",
    textAlign: 'center',
    verticalAlign: 'text-bottom',
    minWidth: '120px',
    alignItems: 'center',
    justifyContent: 'center'
});
const $6999eed130dec5d2$var$UnsupportedBlockNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $z9Bay.getUnsupportedContent)((0, $gPpAv.unsupportedContentMessages).unsupportedBlockContent, (0, $gPpAv.unsupportedContentMessages).unsupportedBlockContent.defaultMessage + ':', node, intl);
    const tooltipContent = intl.formatMessage((0, $gPpAv.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $eJOHy.useRef)({
        padding: '4px'
    });
    const originalNodeType = node?.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $eJOHy.useCallback)(()=>dispatchAnalyticsEvent && (0, $3mTkR.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $bMFKb.ACTION_SUBJECT_ID).ON_UNSUPPORTED_BLOCK, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $6999eed130dec5d2$var$blockNodeStyle,
        className: "unsupported"
    }, message, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k71qx.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k9Gmz))), {
        label: "?",
        LEGACY_size: "small"
    })))));
};
var $6999eed130dec5d2$export$2e2bcd8739ae039 = (0, $6YFG2.default)($6999eed130dec5d2$var$UnsupportedBlockNode);

});
parcelRegister("k9Gmz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::62c47233d9edbba3b204e8a396289dde>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eac5825a371ccc4d$var$_react = $eac5825a371ccc4d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $eac5825a371ccc4d$var$_questionCircle = $eac5825a371ccc4d$var$_interopRequireDefault((parcelRequire("8mxGC")));

var $eac5825a371ccc4d$var$_questionCircle2 = $eac5825a371ccc4d$var$_interopRequireDefault((parcelRequire("53vxQ")));
function $eac5825a371ccc4d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for QuestionCircleIcon.
 * This component is QuestionCircleIcon, with `UNSAFE_fallbackIcon` set to "QuestionCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eac5825a371ccc4d$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $eac5825a371ccc4d$var$_react.default.createElement($eac5825a371ccc4d$var$_questionCircle.default, Object.assign({
        name: "QuestionCircleIcon",
        LEGACY_fallbackIcon: $eac5825a371ccc4d$var$_questionCircle2.default
    }, props));
$eac5825a371ccc4d$var$QuestionCircleIcon.displayName = 'QuestionCircleIconMigration';
var $eac5825a371ccc4d$var$_default = module.exports.default = $eac5825a371ccc4d$var$QuestionCircleIcon;

});

parcelRegister("bMFKb", function(module, exports) {
$parcel$export(module.exports, "EVENT_TYPE", () => $17b833dfd922470c$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $17b833dfd922470c$export$9523889e0a5da4ba);
$parcel$export(module.exports, "INPUT_METHOD", () => $17b833dfd922470c$export$85f107b1fcc9d96f);
$parcel$export(module.exports, "INSERT_MEDIA_VIA", () => $17b833dfd922470c$export$9b31fa32ae3f8051);
$parcel$export(module.exports, "TRIGGER_METHOD", () => $17b833dfd922470c$export$81a8b7dba1aa8f75);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $17b833dfd922470c$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $17b833dfd922470c$export$9957974f8b4d8f74);
$parcel$export(module.exports, "CONTENT_COMPONENT", () => $17b833dfd922470c$export$9f0b2adf3cfd71b7);
var $17b833dfd922470c$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $17b833dfd922470c$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["ACTIONED"] = "actioned";
    ACTION["ACTIVATED"] = "activated";
    ACTION["ADDED"] = "added";
    ACTION["API_ERROR"] = "apiError";
    ACTION["API_RECEIVED"] = "apiReceived";
    ACTION["API_PURGED"] = "apiPurged";
    ACTION["BROWSER_FREEZE"] = "browserFreeze";
    ACTION["CANCELLED"] = "cancelled";
    ACTION["CAUGHT_DOM_ERROR"] = "caughtDomError";
    ACTION["CHANGED_BACKGROUND_COLOR"] = "changedBackgroundColor";
    ACTION["CHANGED_ICON"] = "changedIcon";
    ACTION["CHANGED_FULL_WIDTH_MODE"] = "changedFullWidthMode";
    ACTION["CHANGED_LAYOUT"] = "changedLayout";
    ACTION["CHANGED_BREAKOUT_MODE"] = "changedBreakoutMode";
    ACTION["CHANGED_REPLACEMENT_TEXT"] = "changedReplacementText";
    ACTION["CHANGED_TYPE"] = "changedType";
    ACTION["CHANGED_URL"] = "changedUrl";
    ACTION["CLEARED"] = "cleared";
    ACTION["CLICK"] = "click";
    ACTION["CLICKED"] = "clicked";
    ACTION["CLOSED"] = "closed";
    ACTION["COMMITTED"] = "committed";
    /** used in @atlassian/editor-referentiality */ ACTION["CONNECTED_NODES"] = "connectedNodes";
    ACTION["CONVERTED"] = "converted";
    ACTION["COPIED"] = "copied";
    ACTION["CUT"] = "cut";
    ACTION["DEACTIVATED"] = "deactivated";
    ACTION["DECREMENTED"] = "decremented";
    ACTION["DELETED"] = "deleted";
    ACTION["DISCARDED_INVALID_STEPS_FROM_TRANSACTION"] = "discardedInvalidStepsFromTransaction";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_SOURCE"] = "disconnectedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_TARGET"] = "disconnectedTarget";
    ACTION["DISMISSED"] = "dismissed";
    ACTION["DISPATCHED_INVALID_TRANSACTION"] = "dispatchedInvalidTransaction";
    ACTION["DISPATCHED_VALID_TRANSACTION"] = "dispatchedValidTransaction";
    ACTION["DOUBLE_CLICKED"] = "doubleClicked";
    ACTION["DRAGGED"] = "dragged";
    ACTION["EDITED"] = "edited";
    ACTION["EDITOR_CRASHED"] = "unhandledErrorCaught";
    ACTION["EDITOR_CRASHED_ADDITIONAL_INFORMATION"] = "unhandledErrorCaughtAdditionalInfov2";
    ACTION["EDITOR_MOUNTED"] = "mounted";
    ACTION["EDITOR_CONTENT_RETRIEVAL_PERFORMED"] = "contentRetrievalPerformed";
    ACTION["RE_RENDERED"] = "reRendered";
    ACTION["ENDED"] = "ended";
    ACTION["ENTERED"] = "entered";
    ACTION["ERROR"] = "error";
    ACTION["ERRORED"] = "errored";
    ACTION["EXPOSED"] = "exposed";
    ACTION["FAILED_TO_UNMOUNT"] = "failedToUnmount";
    ACTION["FAILED_TO_INSERT"] = "failedToInsert";
    ACTION["FIND_NEXT_PERFORMED"] = "findNextPerformed";
    ACTION["FIND_PERFORMED"] = "findPerformed";
    ACTION["FIND_PREV_PERFORMED"] = "findPrevPerformed";
    ACTION["UNDO_PERFORMED"] = "undo";
    ACTION["REDO_PERFORMED"] = "redo";
    ACTION["FORMATTED"] = "formatted";
    ACTION["HELP_OPENED"] = "helpOpened";
    ACTION["HIGHLIGHTED"] = "highlighted";
    ACTION["INCREMENTED"] = "incremented";
    ACTION["INDENTED"] = "indented";
    ACTION["INITIALISED"] = "initialised";
    ACTION["INITIATED"] = "initiated";
    /** used in @atlassian/editor-referentiality */ ACTION["INITIALISED_FRAGMENT_MARK"] = "initialisedFragmentMark";
    ACTION["INPUT_PERF_SAMPLING"] = "inputPerfSampling";
    ACTION["INPUT_PERF_SAMPLING_AVG"] = "inputPerfSamplingAvg";
    ACTION["INSERTED"] = "inserted";
    ACTION["INVALID_DOCUMENT_ENCOUNTERED"] = "invalidDocumentEncountered";
    ACTION["INVOKED"] = "invoked";
    /** used in @atlassian/editor-referentiality */ ACTION["GOT_CONNECTIONS"] = "gotConnections";
    ACTION["LANGUAGE_SELECTED"] = "languageSelected";
    ACTION["LIST_ITEM_JOINED"] = "listItemJoined";
    ACTION["MATCHED"] = "matched";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["NODE_CONTENT_SANITIZED"] = "nodeContentSanitized";
    ACTION["OFFLINE_STORAGE_TOO_MANY_RETRIES_ERROR"] = "offlineStorageTooManyRetriesError";
    ACTION["OFFLINE_STORAGE_FAILED_STEPS"] = "offlineStorageFailedSteps";
    ACTION["OFFLINE_STORAGE_STEPS_DATABASE_ERROR"] = "offlineStorageStepsDatabaseError";
    ACTION["OFFLINE_STORAGE_RESYNC_ONLINE"] = "offlineStorageResyncOnline";
    ACTION["OFFLINE_STORAGE_BROADCAST_CHANNEL_FIRST_UPDATE"] = "offlineStorageBroadcastChannelFirstUpdate";
    ACTION["OFFLINE_STORAGE_RESTORE_STEPS_INITIATED"] = "offlineStorageRestoreStepsInitiated";
    ACTION["OPENED"] = "opened";
    ACTION["OUTDENTED"] = "outdented";
    ACTION["PASTED"] = "pasted";
    ACTION["PASTED_AS_PLAIN"] = "pastedAsPlain";
    ACTION["PASTED_TIMED"] = "pastedTimed";
    ACTION["PRESSED"] = "pressed";
    ACTION["PROSEMIRROR_RENDERED"] = "proseMirrorRendered";
    ACTION["REACT_NODEVIEW_RENDERED"] = "reactNodeViewRendered";
    ACTION["REPLACED_ALL"] = "replacedAll";
    ACTION["REPLACED_ONE"] = "replacedOne";
    ACTION["RESOLVED"] = "resolved";
    ACTION["REQUEST_TO_EDIT"] = "requestToEdit";
    ACTION["SELECTED"] = "selected";
    ACTION["SHOWN"] = "shown";
    ACTION["SLOW_INPUT"] = "slowInput";
    ACTION["STARTED"] = "started";
    ACTION["STOPPED"] = "stopped";
    ACTION["SUBMITTED"] = "submitted";
    ACTION["SUBSTITUTED"] = "autoSubstituted";
    ACTION["SYNCHRONY_DISCONNECTED"] = "synchronyDisconnected";
    ACTION["SYNCHRONY_ENTITY_ERROR"] = "synchronyEntityError";
    ACTION["SYNCHRONY_ERROR"] = "synchronyError";
    ACTION["TEXT_LINK_MARK_TRANSFORMED"] = "textLinkMarkTransformed";
    ACTION["TOGGLED"] = "toggled";
    ACTION["DEDUPE_MARKS_TRANSFORMED_V2"] = "dedupeMarksTransformedV2";
    ACTION["NODES_MISSING_CONTENT_TRANSFORMED"] = "nodesMissingContentTransformed";
    ACTION["INDENTATION_MARKS_TRANSFORMED"] = "indentationMarksTransformed";
    ACTION["INVALID_MEDIA_CONTENT_TRANSFORMED"] = "invalidMediaContentTransformed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["TRANSACTION_MUTATED_AFTER_DISPATCH"] = "transactionMutatedAfterDispatched";
    ACTION["TYPING_FINISHED"] = "typingFinished";
    ACTION["TYPING_STARTED"] = "typingStarted";
    ACTION["UNHANDLED_ERROR_CAUGHT"] = "unhandledErrorCaught";
    ACTION["UNLINK"] = "unlinked";
    ACTION["UNSUPPORTED_CONTENT_ENCOUNTERED"] = "unsupportedContentEncounteredV2";
    ACTION["UPDATED"] = "updated";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_FRAGMENT_MARK_NAME"] = "updatedFragmentMarkName";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_SOURCE"] = "updatedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_TARGET"] = "updatedTarget";
    ACTION["UPLOAD_EXTERNAL_FAIL"] = "uploadExternalFailed";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["WITH_PLUGIN_STATE_CALLED"] = "withPluginStateCalled";
    ACTION["RENDERED"] = "rendered";
    ACTION["ON_EDITOR_READY_CALLBACK"] = "onEditorReadyCallback";
    /**
	 * @private
	 * @deprecated
	 *
	 * This is no longer used and can be removed at a later date
	 */ ACTION["ON_CHANGE_CALLBACK"] = "onChangeCalled";
    ACTION["NESTED_TABLE_TRANSFORMED"] = "nestedTableTransformed";
    ACTION["NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS"] = "newCollabSyncUpErrorNoSteps";
    ACTION["REMOVE_ICON"] = "removedIcon";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["DOCUMENT_PROCESSING_ERROR"] = "documentProcessingErrorV2";
    ACTION["CRASHED"] = "unhandledErrorCaughtV2";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["NCS_SESSION_STEP_METRICS"] = "ncsSessionStepMetrics";
    ACTION["STEPS_TRACKED"] = "stepsTracked";
    ACTION["STEPS_FILTERED"] = "stepsFiltered";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["UNSUPPORTED_TOOLTIP_VIEWED"] = "viewed";
    ACTION["RECORD_VIDEO"] = "recordVideo";
    ACTION["INSERT_VIDEO"] = "insertVideo";
    ACTION["RECORD_VIDEO_FAILED"] = "recordVideoFailed";
    ACTION["ADD_CHILD"] = "addChild";
    ACTION["CHANGE_ACTIVE"] = "changeActive";
    ACTION["REMOVE_CHILD"] = "removeChild";
    ACTION["UPDATE_PARAMETERS"] = "updateParameters";
    ACTION["GET_CHILDREN"] = "getChildren";
    ACTION["GET_CHILDREN_CONTAINER"] = "getChildrenContainer";
    ACTION["MOVED"] = "moved";
    ACTION["UPLOAD_COMMENCED"] = "uploadCommenced";
    ACTION["UPLOAD_SUCCEEDED"] = "uploadSucceeded";
    ACTION["UPLOAD_FAILED"] = "uploadFailed";
    ACTION["TOGGLE_CODE_BLOCK_WRAP"] = "toggleCodeBlockWrap";
    ACTION["RESIZED"] = "resized";
    ACTION["RESIZED_PERF_SAMPLING"] = "resizedPerfSampling";
    ACTION["BLOCKS_DRAG_INIT"] = "blocksDragInit";
    ACTION["SINGLE_COL_LAYOUT_DETECTED"] = "singleColumLayoutDetected";
    ACTION["VIEW_MORE"] = "viewMore";
    ACTION["LOCAL_ID_NOT_FOUND"] = "localIdNotFound";
    ACTION["NO_DOC_CHANGE_FOUND"] = "noDocChangeFound";
    ACTION["INVALID_COMMAND_FOUND"] = "invalidCommandFound";
    /**
	 * used in Editor AI inline suggestion for a track event when a suggestion is inserted
	 * previously tracked events being used by Editor AI proactive suggestion
	 *
	 */ ACTION["SUGGESTION_INSERTED"] = "suggestionInserted";
    ACTION["SUGGESTION_DISMISSED"] = "suggestionDismissed";
    ACTION["SUGGESTION_VIEWED"] = "suggestionViewed";
    ACTION["TABLE_WIDTH_INFO"] = "tableWidthInformation";
    ACTION["SUPPRESSED"] = "suppressed";
    return ACTION;
}({});
var $17b833dfd922470c$export$85f107b1fcc9d96f = /*#__PURE__*/ function(INPUT_METHOD) {
    INPUT_METHOD["ASCII"] = "ascii";
    INPUT_METHOD["AUTO"] = "auto";
    INPUT_METHOD["AUTO_DETECT"] = "autoDetect";
    INPUT_METHOD["BUTTON"] = "button";
    INPUT_METHOD["BLUR"] = "blur";
    INPUT_METHOD["CARD"] = "card";
    INPUT_METHOD["CLIPBOARD"] = "clipboard";
    INPUT_METHOD["CONFIG_PANEL"] = "configPanel";
    INPUT_METHOD["CONTEXT_MENU"] = "contextMenu";
    INPUT_METHOD["DRAG_AND_DROP"] = "dragAndDrop";
    INPUT_METHOD["DRAG"] = "drag";
    INPUT_METHOD["EXTERNAL"] = "external";
    INPUT_METHOD["EXTENSION_API"] = "extensionApi";
    INPUT_METHOD["FLOATING_TB"] = "floatingToolbar";
    INPUT_METHOD["FORMATTING"] = "autoformatting";
    INPUT_METHOD["INSERT_MENU"] = "insertMenu";
    INPUT_METHOD["INSERT_MENU_RIGHT_RAIL"] = "insertMenuRightRail";
    INPUT_METHOD["KEYBOARD"] = "keyboard";
    INPUT_METHOD["MEDIA_PICKER"] = "mediaPicker";
    INPUT_METHOD["MACRO_BROWSER"] = "macroBrowser";
    INPUT_METHOD["MANUAL"] = "manual";
    INPUT_METHOD["PICKER"] = "picker";
    INPUT_METHOD["PICKER_CLOUD"] = "cloudPicker";
    INPUT_METHOD["PREFILL"] = "prefill";
    INPUT_METHOD["QUICK_INSERT"] = "quickInsert";
    INPUT_METHOD["SHORTCUT"] = "shortcut";
    INPUT_METHOD["TOOLBAR"] = "toolbar";
    INPUT_METHOD["TYPEAHEAD"] = "typeAhead";
    INPUT_METHOD["DATASOURCE"] = "datasource_config";
    INPUT_METHOD["TABLE_CONTEXT_MENU"] = "tableContextMenu";
    INPUT_METHOD["MOUSE"] = "mouse";
    INPUT_METHOD["BROWSER"] = "browser";
    INPUT_METHOD["DOUBLE_CLICK"] = "doubleClick";
    INPUT_METHOD["META_CLICK"] = "metaClick";
    INPUT_METHOD["INLINE_SUGGESTION_FLOATING_TB"] = "inlineSuggestionFloatingToolbar";
    INPUT_METHOD["BLOCK_MENU"] = "blockMenu";
    INPUT_METHOD["SMART_LINK"] = "smartLink";
    return INPUT_METHOD;
}({});
var $17b833dfd922470c$export$9b31fa32ae3f8051 = /*#__PURE__*/ function(INSERT_MEDIA_VIA) {
    INSERT_MEDIA_VIA["LOCAL_UPLOAD"] = "localUpload";
    INSERT_MEDIA_VIA["EXTERNAL_URL"] = "externalUrl";
    INSERT_MEDIA_VIA["EXTERNAL_UPLOAD"] = "externalUpload";
    return INSERT_MEDIA_VIA;
}({});
var $17b833dfd922470c$export$81a8b7dba1aa8f75 = /*#__PURE__*/ function(TRIGGER_METHOD) {
    TRIGGER_METHOD["BUTTON"] = "button";
    TRIGGER_METHOD["KEYBOARD"] = "keyboard";
    TRIGGER_METHOD["SHORTCUT"] = "shortcut";
    TRIGGER_METHOD["TOOLBAR"] = "toolbar";
    TRIGGER_METHOD["EXTERNAL"] = "external";
    return TRIGGER_METHOD;
}({});
var $17b833dfd922470c$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["AI_INTERACTION"] = "aiInteraction";
    ACTION_SUBJECT["AI_RESULT"] = "aiResult";
    ACTION_SUBJECT["AI_FEEDBACK"] = "aiFeedback";
    ACTION_SUBJECT["AI_STREAMING"] = "aiStreaming";
    ACTION_SUBJECT["COLLAB"] = "collab";
    ACTION_SUBJECT["TOOLBAR_BUTTON"] = "toolbarButton";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["CONFIG_PANEL"] = "configPanel";
    ACTION_SUBJECT["CONTENT_COMPONENT"] = "contentComponent";
    ACTION_SUBJECT["DATE"] = "date";
    ACTION_SUBJECT["DATE_SEGMENT"] = "dateSegment";
    ACTION_SUBJECT["DOCUMENT"] = "document";
    ACTION_SUBJECT["EDITOR"] = "editor";
    ACTION_SUBJECT["ACTIVITY_SESSION"] = "activitySession";
    ACTION_SUBJECT["ELEMENT_BROWSER"] = "elementBrowser";
    ACTION_SUBJECT["EMBEDS"] = "embeds";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["EXTENSION"] = "extension";
    ACTION_SUBJECT["FEATURE"] = "feature";
    ACTION_SUBJECT["FEEDBACK_DIALOG"] = "feedbackDialog";
    ACTION_SUBJECT["FIND_REPLACE_DIALOG"] = "findReplaceDialog";
    ACTION_SUBJECT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    ACTION_SUBJECT["FLOATING_TOOLBAR_PLUGIN"] = "floatingToolbarPlugin";
    ACTION_SUBJECT["HELP"] = "help";
    ACTION_SUBJECT["INVITE_ITEM"] = "inviteItem";
    ACTION_SUBJECT["LAYOUT"] = "layout";
    ACTION_SUBJECT["LIST"] = "list";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["MENTION"] = "mention";
    ACTION_SUBJECT["MENTION_TYPEAHEAD"] = "mentionTypeahead";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["PANEL"] = "panel";
    ACTION_SUBJECT["PICKER"] = "picker";
    ACTION_SUBJECT["PLUS_MENU"] = "plusMenu";
    ACTION_SUBJECT["PLUGIN_SLOT"] = "pluginSlot";
    ACTION_SUBJECT["REQUEST_TO_EDIT_POP_UP"] = "requestToEditPopUp";
    ACTION_SUBJECT["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT["SELECTION"] = "selection";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["TABLES_PLUGIN"] = "tablesPlugin";
    ACTION_SUBJECT["TEAM_MENTION_TYPEAHEAD"] = "teamMentionTypeahead";
    ACTION_SUBJECT["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT["TEXT"] = "text";
    ACTION_SUBJECT["TOOLBAR"] = "toolbar";
    ACTION_SUBJECT["TYPEAHEAD"] = "typeAhead";
    ACTION_SUBJECT["TYPEAHEAD_ITEM"] = "typeAheadItem";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["SEARCH_RESULT"] = "searchResult";
    ACTION_SUBJECT["CREATE_LINK_INLINE_DIALOG"] = "createLinkInlineDialog";
    ACTION_SUBJECT["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT["REACT_EDITOR_VIEW"] = "reactEditorView";
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["TOOLTIP"] = "tooltip";
    ACTION_SUBJECT["LOOM"] = "loom";
    ACTION_SUBJECT["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT["BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT["DROP_TARGET"] = "dropTarget";
    ACTION_SUBJECT["DRAG"] = "drag";
    ACTION_SUBJECT["ELEMENT"] = "element";
    ACTION_SUBJECT["INLINE_DIALOG"] = "inlineDialog";
    ACTION_SUBJECT["ENGAGEMENT_PLATFORM"] = "engagementPlatform";
    ACTION_SUBJECT["MEDIA_VIEWER"] = "mediaViewer";
    ACTION_SUBJECT["DECORATION"] = "decoration";
    ACTION_SUBJECT["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT["EDITOR_PLUGIN_SELECTION_EXTENSION"] = "editorPluginSelectionExtension";
    ACTION_SUBJECT["AI_DEFINITIONS"] = "aiDefinitions";
    ACTION_SUBJECT["USER_PREFERENCES"] = "userPreferences";
    ACTION_SUBJECT["ALIGNMENT"] = "alignment";
    ACTION_SUBJECT["OFFLINE_EDITING"] = "offlineEditing";
    ACTION_SUBJECT["TOOLBAR_DROPDOWN_MENU"] = "toolbarDropdownMenu";
    ACTION_SUBJECT["TOOLBAR_DROPDOWN_MENU_ITEM"] = "toolbarDropdownMenuItem";
    ACTION_SUBJECT["BLOCK_MENU"] = "blockMenu";
    ACTION_SUBJECT["BLOCK_MENU_ITEM"] = "blockMenuItem";
    ACTION_SUBJECT["SYNCED_BLOCK"] = "syncedBlock";
    return ACTION_SUBJECT;
}({});
var $17b833dfd922470c$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["ACTION"] = "action";
    ACTION_SUBJECT_ID["ACTIVITY"] = "activity";
    ACTION_SUBJECT_ID["AI_CHANGES_ACCEPT_BUTTON"] = "aiChangesAcceptButton";
    ACTION_SUBJECT_ID["AI_CHANGES_REJECT_BUTTON"] = "aiChangesRejectButton";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_DEFINE_BUTTON"] = "aiDefinitionsDefineButton";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_AUTO_HIGHLIGHT"] = "aiDefinitionsAutoHighlight";
    ACTION_SUBJECT_ID["AI_INLINE_SUGGESTION"] = "aiInlineSuggestion";
    ACTION_SUBJECT_ID["AI_PANELS_BODIED_EXTENSION"] = "aiPanelsBodiedExtension";
    ACTION_SUBJECT_ID["AI_PROMPT_LINK_PICKER_BUTTON"] = "aiPromptLinkPickerButton";
    ACTION_SUBJECT_ID["AI_PROMPT_MENTION_BUTTON"] = "aiPromptMentionButton";
    ACTION_SUBJECT_ID["AI_PROACTIVE_FEEDBACK_DIALOG"] = "aiProactiveFeedbackDialog";
    ACTION_SUBJECT_ID["AI_ASK_ROVO_BUTTON"] = "aiAskRovoButton";
    ACTION_SUBJECT_ID["AI_HERO_PROMPT_BUTTON"] = "aiHeroPromptButton";
    ACTION_SUBJECT_ID["AI_MORE_ROVO_OPTIONS"] = "aiMoreRovoOptions";
    ACTION_SUBJECT_ID["AI_TRANSLATE"] = "aiTranslate";
    ACTION_SUBJECT_ID["AI_CHANGE_TONE"] = "aiChangeTone";
    ACTION_SUBJECT_ID["ALL"] = "all";
    ACTION_SUBJECT_ID["ALT_TEXT"] = "altText";
    ACTION_SUBJECT_ID["ANNOTATE_BUTTON"] = "annotateButton";
    ACTION_SUBJECT_ID["AVATAR_GROUP_PLUGIN"] = "AvatarGroupInPlugin";
    ACTION_SUBJECT_ID["BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["BORDER"] = "border";
    ACTION_SUBJECT_ID["BUTTON_CATEGORY"] = "categoryButton";
    ACTION_SUBJECT_ID["BUTTON_FEEDBACK"] = "feedbackButton";
    ACTION_SUBJECT_ID["BUTTON_HELP"] = "helpButton";
    ACTION_SUBJECT_ID["CANCEL"] = "cancel";
    ACTION_SUBJECT_ID["CAPTION"] = "caption";
    ACTION_SUBJECT_ID["CARD_BLOCK"] = "blockCard";
    ACTION_SUBJECT_ID["CARD_INLINE"] = "inlineCard";
    ACTION_SUBJECT_ID["CELL"] = "cell";
    ACTION_SUBJECT_ID["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    ACTION_SUBJECT_ID["COPY_BUTTON"] = "copyButton";
    ACTION_SUBJECT_ID["COPY_LINK_TO_ANCHOR"] = "copyLinkToAnchor";
    ACTION_SUBJECT_ID["COPY_BLOCK"] = "copyBlock";
    ACTION_SUBJECT_ID["COPY_LINK_TO_BLOCK"] = "copyLinkToBlock";
    ACTION_SUBJECT_ID["DELETE_BLOCK"] = "deleteBlock";
    ACTION_SUBJECT_ID["MOVE_UP_BLOCK"] = "moveUpBlock";
    ACTION_SUBJECT_ID["MOVE_DOWN_BLOCK"] = "moveDownBlock";
    ACTION_SUBJECT_ID["FORMAT_MENU"] = "formatMenu";
    ACTION_SUBJECT_ID["CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU"] = "createInlineCommentFromHighlightActionsMenu";
    ACTION_SUBJECT_ID["DATE"] = "date";
    ACTION_SUBJECT_ID["DATE_DAY"] = "day";
    ACTION_SUBJECT_ID["DATE_MONTH"] = "month";
    ACTION_SUBJECT_ID["DATE_YEAR"] = "year";
    ACTION_SUBJECT_ID["DECISION"] = "decision";
    ACTION_SUBJECT_ID["DISCARD_STREAM"] = "discardStream";
    ACTION_SUBJECT_ID["DIVIDER"] = "divider";
    ACTION_SUBJECT_ID["EDIT_LINK"] = "editLink";
    ACTION_SUBJECT_ID["EDIT_DATASOURCE"] = "editDatasource";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT_ID["ELEMENT_DRAG_HANDLE"] = "elementDragHandle";
    ACTION_SUBJECT_ID["ELEMENT_DROP_TARGET"] = "elementDropTarget";
    ACTION_SUBJECT_ID["EMBEDS"] = "embeds";
    ACTION_SUBJECT_ID["EMOJI"] = "emoji";
    ACTION_SUBJECT_ID["EXPAND"] = "expand";
    ACTION_SUBJECT_ID["EXPERIENCE_APPLICATION"] = "experienceApplication";
    ACTION_SUBJECT_ID["EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_API"] = "extensionApi";
    ACTION_SUBJECT_ID["EXTENSION_BLOCK"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_BODIED"] = "bodiedExtension";
    ACTION_SUBJECT_ID["EXTENSION_INLINE"] = "inlineExtension";
    ACTION_SUBJECT_ID["FLOATING_TOOLBAR_OVERFLOW"] = "floatingToolbarOverflow";
    ACTION_SUBJECT_ID["FLOATING_TOOLBAR"] = "floatingToolbar";
    ACTION_SUBJECT_ID["FORMAT_BACKGROUND_COLOR"] = "backgroundColor";
    ACTION_SUBJECT_ID["FORMAT_BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["FORMAT_CLEAR"] = "clearFormatting";
    ACTION_SUBJECT_ID["FORMAT_CODE"] = "code";
    ACTION_SUBJECT_ID["FORMAT_COLOR"] = "color";
    ACTION_SUBJECT_ID["FORMAT_HEADING"] = "heading";
    ACTION_SUBJECT_ID["FORMAT_INDENT"] = "indentation";
    ACTION_SUBJECT_ID["FORMAT_ITALIC"] = "italic";
    ACTION_SUBJECT_ID["FORMAT_LIST_BULLET"] = "bulletedList";
    ACTION_SUBJECT_ID["FORMAT_LIST_NUMBER"] = "numberedList";
    ACTION_SUBJECT_ID["FORMAT_STRIKE"] = "strike";
    ACTION_SUBJECT_ID["FORMAT_STRONG"] = "strong";
    ACTION_SUBJECT_ID["FORMAT_SUB"] = "subscript";
    ACTION_SUBJECT_ID["FORMAT_SUPER"] = "superscript";
    ACTION_SUBJECT_ID["FORMAT_UNDERLINE"] = "underline";
    ACTION_SUBJECT_ID["FRAGMENT_MARK"] = "fragmentMark";
    ACTION_SUBJECT_ID["GOTO_SMART_LINK_SETTINGS"] = "goToSmartLinkSettings";
    ACTION_SUBJECT_ID["HELP_QUICK_INSERT"] = "helpQuickInsert";
    ACTION_SUBJECT_ID["HOVER_LABEL"] = "hoverLabel";
    ACTION_SUBJECT_ID["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["LAYOUT"] = "layout";
    ACTION_SUBJECT_ID["LINE_BREAK"] = "lineBreak";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["LINK_PREVIEW"] = "linkPreview";
    ACTION_SUBJECT_ID["LINK_SEARCH_INPUT"] = "linkSearchInput";
    ACTION_SUBJECT_ID["MEDIA"] = "media";
    ACTION_SUBJECT_ID["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT_ID["MEDIA_INLINE_IMAGE"] = "mediaInlineImage";
    ACTION_SUBJECT_ID["MEDIA_LINK"] = "mediaLink";
    ACTION_SUBJECT_ID["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["MENTION"] = "mention";
    ACTION_SUBJECT_ID["MENTION_PROVIDER"] = "mentionProvider";
    ACTION_SUBJECT_ID["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["NODE"] = "node";
    ACTION_SUBJECT_ID["OPEN_LINK"] = "openLink";
    ACTION_SUBJECT_ID["OFFLINE_EDITING"] = "offlineEditing";
    ACTION_SUBJECT_ID["PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_BLOCK_CARD"] = "blockCard";
    ACTION_SUBJECT_ID["PASTE_BLOCKQUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["PASTE_BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT_ID["PASTE_BULLET_LIST"] = "bulletList";
    ACTION_SUBJECT_ID["PASTE_CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["PASTE_DECISION_LIST"] = "decisionList";
    ACTION_SUBJECT_ID["PASTE_EXPAND"] = "expand";
    ACTION_SUBJECT_ID["PASTE_EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["PASTE_HEADING"] = "heading";
    ACTION_SUBJECT_ID["PASTE_MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["PASTE_MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["PASTE_NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["PASTE_ORDERED_LIST"] = "orderedList";
    ACTION_SUBJECT_ID["PASTE_PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_PARAGRAPH"] = "paragraph";
    ACTION_SUBJECT_ID["PASTE_RULE"] = "rule";
    ACTION_SUBJECT_ID["PASTE_TABLE"] = "table";
    ACTION_SUBJECT_ID["PASTE_TABLE_CELL"] = "tableCell";
    ACTION_SUBJECT_ID["PASTE_TABLE_HEADER"] = "tableHeader";
    ACTION_SUBJECT_ID["PASTE_TABLE_ROW"] = "tableRow";
    ACTION_SUBJECT_ID["PASTE_TASK_LIST"] = "taskList";
    ACTION_SUBJECT_ID["PICKER_CLOUD"] = "cloudPicker";
    ACTION_SUBJECT_ID["PICKER_MEDIA"] = "mediaPicker";
    ACTION_SUBJECT_ID["PICKER_COLOR"] = "colorPicker";
    ACTION_SUBJECT_ID["PICKER_EMOJI"] = "emojiPicker";
    ACTION_SUBJECT_ID["PICKER_TABLE_SIZE"] = "tableSizePicker";
    ACTION_SUBJECT_ID["DOCKED_PRIMARY_TOOLBAR"] = "dockedPrimaryToolbar";
    ACTION_SUBJECT_ID["PLACEHOLDER_TEXT"] = "placeholderText";
    ACTION_SUBJECT_ID["POST_QUERY_SEARCH_RESULTS"] = "postQuerySearchResults";
    ACTION_SUBJECT_ID["PRE_QUERY_SEARCH_RESULTS"] = "preQuerySearchResults";
    ACTION_SUBJECT_ID["PROACTIVE_SUGGESTION"] = "proactiveSuggestion";
    ACTION_SUBJECT_ID["PRODUCT_NAME"] = "productName";
    ACTION_SUBJECT_ID["PUNC"] = "punctuation";
    ACTION_SUBJECT_ID["QUICK_SEARCH"] = "quickSearch";
    ACTION_SUBJECT_ID["RANGE"] = "range";
    ACTION_SUBJECT_ID["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT_ID["RECENT_ACTIVITIES"] = "recentActivities";
    ACTION_SUBJECT_ID["RESIZED"] = "resized";
    ACTION_SUBJECT_ID["RESPONSE_FEEDBACK_BUTTON"] = "responseFeedbackButton";
    ACTION_SUBJECT_ID["RICH_MEDIA_LAYOUT"] = "richMediaLayout";
    ACTION_SUBJECT_ID["SAVE"] = "save";
    ACTION_SUBJECT_ID["SECTION"] = "section";
    ACTION_SUBJECT_ID["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT_ID["SMART_LINK_TOOLBAR"] = "smartLinkToolbar";
    ACTION_SUBJECT_ID["STATUS"] = "status";
    ACTION_SUBJECT_ID["SYMBOL"] = "symbol";
    ACTION_SUBJECT_ID["TABLE"] = "table";
    ACTION_SUBJECT_ID["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT_ID["TEXT"] = "text";
    ACTION_SUBJECT_ID["TYPEAHEAD_EMOJI"] = "emojiTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_LINK"] = "linkTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_MENTION"] = "mentionTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_QUICK_INSERT"] = "quickInsertTypeAhead";
    ACTION_SUBJECT_ID["TOOLBAR_PREVIEW"] = "previewFromToolbar";
    ACTION_SUBJECT_ID["UNKNOWN_NODE"] = "unknownNode";
    ACTION_SUBJECT_ID["UNLINK"] = "unlink";
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["UNSUPPORTED_ERROR"] = "unsupportedUnhandled";
    ACTION_SUBJECT_ID["UNSUPPORTED_NODE_ATTRIBUTE"] = "unsupportedNodeAttribute";
    ACTION_SUBJECT_ID["UNSUPPORTED_BLOCK"] = "unsupportedBlock";
    ACTION_SUBJECT_ID["UNSUPPORTED_INLINE"] = "unsupportedInline";
    ACTION_SUBJECT_ID["UNSUPPORTED_MARK"] = "unsupportedMark";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_INLINE"] = "onUnsupportedInline";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_BLOCK"] = "onUnsupportedBlock";
    ACTION_SUBJECT_ID["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT_ID["UPDATE_STREAM"] = "updateStream";
    ACTION_SUBJECT_ID["UPLOAD_MEDIA"] = "uploadMedia";
    ACTION_SUBJECT_ID["SELECTION_TOOLBAR_PREFERENCES"] = "selectionToolbarPreferences";
    ACTION_SUBJECT_ID["SELECTION_TOOLBAR"] = "selectionToolbar";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_DROPDOWN"] = "editorPluginSelectionExtensionDropdown";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_ITEM"] = "editorPluginSelectionExtensionItem";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_COMPONENT"] = "editorPluginSelectionExtensionComponent";
    ACTION_SUBJECT_ID["TRANSFORM"] = "transform";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_SOURCE_URL"] = "syncedBlockSourceUrl";
    return ACTION_SUBJECT_ID;
}({});
var $17b833dfd922470c$export$75ef928acd21e35b = /*#__PURE__*/ function(FLOATING_CONTROLS_TITLE) {
    FLOATING_CONTROLS_TITLE["CODE_BLOCK"] = "codeBlockFloatingControls";
    FLOATING_CONTROLS_TITLE["EXTENSION"] = "extensionFloatingControls";
    FLOATING_CONTROLS_TITLE["HYPERLINK"] = "hyperlinkFloatingControls";
    FLOATING_CONTROLS_TITLE["MEDIA"] = "mediaFloatingControls";
    FLOATING_CONTROLS_TITLE["PANEL"] = "panelFloatingControls";
    FLOATING_CONTROLS_TITLE["TABLE"] = "tableFloatingControls";
    FLOATING_CONTROLS_TITLE["EXPAND"] = "expandToolbar";
    return FLOATING_CONTROLS_TITLE;
}({});
var $17b833dfd922470c$export$9f0b2adf3cfd71b7 = /*#__PURE__*/ function(CONTENT_COMPONENT) {
    CONTENT_COMPONENT["INLINE_COMMENT"] = "inlineComment";
    CONTENT_COMPONENT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    CONTENT_COMPONENT["FLOATING_INSERT_BUTTON"] = "floatingInsertButton";
    CONTENT_COMPONENT["FLOATING_TOOLBAR"] = "floatingToolbar";
    CONTENT_COMPONENT["SELECTION_TOOLBAR"] = "selectionToolbar";
    return CONTENT_COMPONENT;
}({});

});

parcelRegister("gPpAv", function(module, exports) {
$parcel$export(module.exports, "unsupportedContentMessages", () => $240a9a996e10d4f5$export$32ec96484dd3ba39);

var $7qGN1 = parcelRequire("7qGN1");
const $240a9a996e10d4f5$export$32ec96484dd3ba39 = (0, $7qGN1.defineMessages)({
    unsupportedInlineContent: {
        id: 'fabric.editor.unsupportedInlineContent',
        defaultMessage: 'Unsupported content',
        description: 'Unsupported content'
    },
    unsupportedBlockContent: {
        id: 'fabric.editor.unsupportedBlockContent',
        defaultMessage: 'This editor does not support displaying this content',
        description: 'This editor does not support displaying this content'
    },
    unsupportedContentTooltip: {
        id: 'fabric.editor.unsupportedContentTooltip',
        defaultMessage: 'Content is not available in this editor, this will be preserved when you edit and save',
        description: 'Content is not available in this editor, this will be preserved when you edit and save'
    }
});

});

parcelRegister("3mTkR", function(module, exports) {
$parcel$export(module.exports, "findAndTrackUnsupportedContentNodes", () => $66b6d13af08c068e$export$d343369b8f25914);
$parcel$export(module.exports, "fireUnsupportedEvent", () => $66b6d13af08c068e$export$e1051b410945e4d4);
$parcel$export(module.exports, "trackUnsupportedContentTooltipDisplayedFor", () => $66b6d13af08c068e$export$3a34598135e7219b);

var $bMFKb = parcelRequire("bMFKb");
const $66b6d13af08c068e$var$whitelistedAttributes = [
    'align',
    'annotationType',
    'extensionKey',
    'extensionType',
    'layout',
    'type',
    'localId',
    'mode',
    'language',
    'timestamp',
    'state',
    'originalWidth',
    'originalHeight',
    'height',
    'width',
    'shortName',
    'level',
    'userType',
    'order',
    'panelType',
    'color',
    'style',
    'isNumberColumnEnabled',
    'colspan',
    'rowspan',
    'colwidth',
    'background'
];
function $66b6d13af08c068e$var$concatAncestorHierarchy(node, ancestoryHierarchy) {
    const { name: name } = node.type;
    // Space concatenator used to reduce analytics payload size
    return ancestoryHierarchy ? `${ancestoryHierarchy} ${name}` : name;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $66b6d13af08c068e$var$sanitizeMarks = (marks = [])=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedMarks = [];
    marks.forEach((mark)=>{
        if (mark.attrs) {
            const attrs = $66b6d13af08c068e$var$sanitizeAttributes(mark.attrs);
            sanitizedMarks.push({
                ...mark,
                attrs: attrs
            });
        } else sanitizedMarks.push({
            ...mark
        });
    });
    return sanitizedMarks;
};
const $66b6d13af08c068e$var$sanitizeAttributes = (attrs = {})=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedAttrs = Object.assign({}, attrs);
    Object.keys(attrs).filter((key)=>!$66b6d13af08c068e$var$whitelistedAttributes.includes(key)).forEach((key)=>{
        sanitizedAttrs[key] !== null ? sanitizedAttrs[key] = '' : sanitizedAttrs[key] = 'null';
    });
    return sanitizedAttrs;
};
const $66b6d13af08c068e$var$trackUnsupportedContentTooltipActionFor = (action, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    dispatchAnalyticsEvent({
        action: action,
        actionSubjectId: unsupportedContentType,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).TOOLTIP,
        eventType: (0, $bMFKb.EVENT_TYPE).UI,
        attributes: {
            unsupportedNodeType: originalNodeType
        }
    });
};
const $66b6d13af08c068e$export$d343369b8f25914 = (node, schema, dispatchAnalyticsEvent, ancestorHierarchy = '')=>{
    const { type: nodeType, marks: nodeMarks } = node;
    const { unsupportedMark: unsupportedMark, unsupportedNodeAttribute: unsupportedNodeAttribute } = schema.marks;
    const { unsupportedInline: unsupportedInline, unsupportedBlock: unsupportedBlock } = schema.nodes;
    const parentType = ancestorHierarchy.split(' ').pop() || '';
    if (nodeMarks.length) nodeMarks.forEach((mark)=>{
        if (mark.type === unsupportedMark) {
            const { originalValue: originalValue } = mark.attrs || {};
            const { type: type } = originalValue || {};
            const unsupportedNode = {
                type: type || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: originalValue.attrs || {}
            };
            $66b6d13af08c068e$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $bMFKb.ACTION_SUBJECT_ID).UNSUPPORTED_MARK, unsupportedNode);
        } else if (mark.type === unsupportedNodeAttribute) {
            const { unsupported: unsupported } = mark.attrs || {};
            const unsupportedNodeAttribute = {
                type: nodeType.name || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: unsupported || {}
            };
            $66b6d13af08c068e$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $bMFKb.ACTION_SUBJECT_ID).UNSUPPORTED_NODE_ATTRIBUTE, unsupportedNodeAttribute);
        }
    });
    if (nodeType === unsupportedInline || nodeType === unsupportedBlock) {
        const { originalValue: originalValue } = node.attrs || {};
        const { marks: marks } = originalValue || [];
        const { attrs: attrs } = originalValue || {};
        const { type: type } = originalValue || {};
        const unsupportedNode = {
            type: type || '',
            ancestry: ancestorHierarchy,
            parentType: parentType,
            marks: marks || [],
            attrs: attrs || {}
        };
        const actionSubjectId = nodeType === unsupportedInline ? (0, $bMFKb.ACTION_SUBJECT_ID).UNSUPPORTED_INLINE : (0, $bMFKb.ACTION_SUBJECT_ID).UNSUPPORTED_BLOCK;
        $66b6d13af08c068e$export$e1051b410945e4d4(dispatchAnalyticsEvent, actionSubjectId, unsupportedNode);
    } else // Recursive check for nested content
    node.content.forEach((childNode)=>$66b6d13af08c068e$export$d343369b8f25914(childNode, schema, dispatchAnalyticsEvent, $66b6d13af08c068e$var$concatAncestorHierarchy(node, ancestorHierarchy)));
};
const $66b6d13af08c068e$export$e1051b410945e4d4 = (dispatchAnalyticsEvent, actionSubjectId, unsupportedNode, errorCode)=>{
    const sanitizedAttrs = $66b6d13af08c068e$var$sanitizeAttributes(unsupportedNode.attrs);
    const sanitizedMarks = $66b6d13af08c068e$var$sanitizeMarks(unsupportedNode.marks);
    const sanitizedUnsupportedNode = {
        type: unsupportedNode.type,
        ancestry: unsupportedNode.ancestry,
        parentType: unsupportedNode.parentType,
        attrs: sanitizedAttrs,
        marks: sanitizedMarks
    };
    const payload = {
        action: (0, $bMFKb.ACTION).UNSUPPORTED_CONTENT_ENCOUNTERED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        attributes: {
            unsupportedNode: sanitizedUnsupportedNode,
            ...!!errorCode && {
                errorCode: errorCode
            }
        },
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK
    };
    dispatchAnalyticsEvent(payload);
};
const $66b6d13af08c068e$export$3a34598135e7219b = (dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    $66b6d13af08c068e$var$trackUnsupportedContentTooltipActionFor((0, $bMFKb.ACTION).UNSUPPORTED_TOOLTIP_VIEWED, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType);
};

});

parcelRegister("z9Bay", function(module, exports) {
$parcel$export(module.exports, "getUnsupportedContent", () => $bea0a1ed5ad48e2f$export$d4ded51d0f0bd2df);
function $bea0a1ed5ad48e2f$export$d4ded51d0f0bd2df(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
message, prefix, node, intl) {
    const defaultLocale = 'en';
    let canTranslateToLocale = true;
    const locale = intl ? intl.locale : defaultLocale;
    let finalMessage = message.defaultMessage;
    if (node && locale.startsWith(defaultLocale)) {
        const { originalValue: originalValue } = node.attrs;
        if (originalValue.text || originalValue.attrs && originalValue.attrs.text) {
            finalMessage = originalValue.text ? originalValue.text : originalValue.attrs.text;
            canTranslateToLocale = false;
        } else if (originalValue.type) {
            finalMessage = `${prefix} ${originalValue.type}`;
            canTranslateToLocale = false;
        }
    }
    if (intl && canTranslateToLocale) return intl.formatMessage(message);
    return finalMessage;
}

});


parcelRegister("lilfD", function(module, exports) {
$parcel$export(module.exports, "WithCreateAnalyticsEvent", () => $7560959cd315952a$export$9ac3d19711324187);

var $eJOHy = parcelRequire("eJOHy");

var $4J0ad = parcelRequire("4J0ad");
const $7560959cd315952a$export$9ac3d19711324187 = (0, $4J0ad.default)()(class WithCreateAnalyticsEvent extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { render: render, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        return render(createAnalyticsEvent);
    }
});

});

parcelRegister("7EdFW", function(module, exports) {
$parcel$export(module.exports, "browser", () => $4f85d3430881614f$export$3f2684e5d7cb1006);
$parcel$export(module.exports, "getBrowserInfo", () => $4f85d3430881614f$export$6c724a6ffa2dc3e1);

var $LFmXM = parcelRequire("LFmXM");
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required
/**
 * @deprecated
 * This file is deprecated and will be removed in the next major release.
 * Please use `getBrowserInfo` function to get the browser info on demand.
 * Static `browser` info is no longer supported.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4f85d3430881614f$export$3f2684e5d7cb1006 = {
    mac: false,
    windows: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    gecko_version: 0,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    safari_version: 0,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const ieEdge = /(?:Edge|Edg)\/(\d+)/.exec(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $4f85d3430881614f$export$3f2684e5d7cb1006.mac = /Mac/.test(navigator.platform);
    $4f85d3430881614f$export$3f2684e5d7cb1006.windows = // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    navigator.userAgentData?.platform === 'Windows' || // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /Windows|Win\d+/i.test(navigator.userAgent);
    const ie = $4f85d3430881614f$export$3f2684e5d7cb1006.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $4f85d3430881614f$export$3f2684e5d7cb1006.ie_version = ieUpTo10 ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $4f85d3430881614f$export$3f2684e5d7cb1006.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $4f85d3430881614f$export$3f2684e5d7cb1006.gecko_version = parseInt((navigator.userAgent.match(/Firefox\/(\d+)/) || [])[1], 10);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $4f85d3430881614f$export$3f2684e5d7cb1006.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $4f85d3430881614f$export$3f2684e5d7cb1006.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $4f85d3430881614f$export$3f2684e5d7cb1006.android = /Android \d/.test(navigator.userAgent);
    $4f85d3430881614f$export$3f2684e5d7cb1006.ios = // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $4f85d3430881614f$export$3f2684e5d7cb1006.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $4f85d3430881614f$export$3f2684e5d7cb1006.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $4f85d3430881614f$export$3f2684e5d7cb1006.safari_version = parseInt(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    (navigator.userAgent.match(/Version\/([0-9\._]+).*Safari/) || [])[1], 10);
    $4f85d3430881614f$export$3f2684e5d7cb1006.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $4f85d3430881614f$export$3f2684e5d7cb1006.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
const $4f85d3430881614f$var$getFirstMatch = (regexp, ua)=>{
    const match = ua.match(regexp);
    return match && match.length > 0 && match[1] || '';
};
const $4f85d3430881614f$var$getSecondMatch = (regexp, ua)=>{
    const match = ua.match(regexp);
    return match && match.length > 0 && match[2] || '';
};
// Helper functions to safely access browser properties
const $4f85d3430881614f$var$getSafeUserAgent = ()=>{
    if (typeof window === 'undefined') return undefined;
    // Fallback to navigator.userAgent with proper null checking
    return window.navigator?.userAgent;
};
const $4f85d3430881614f$var$getSafePlatform = ()=>{
    if (typeof window === 'undefined') return undefined;
    return window.navigator?.platform;
};
const $4f85d3430881614f$var$hasIntersectionObserver = ()=>{
    return typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    'intersectionRatio' in window.IntersectionObserverEntry.prototype;
};
const $4f85d3430881614f$var$hasResizeObserver = ()=>{
    return typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
};
const $4f85d3430881614f$export$6c724a6ffa2dc3e1 = (0, $LFmXM.default)(()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {
        mac: false,
        windows: false,
        ie: false,
        ie_version: 0,
        gecko: false,
        gecko_version: 0,
        chrome: false,
        chrome_version: 0,
        android: false,
        ios: false,
        webkit: false,
        safari: false,
        safari_version: 0,
        supportsIntersectionObserver: false,
        supportsResizeObserver: false
    };
    const userAgent = $4f85d3430881614f$var$getSafeUserAgent();
    const platform = $4f85d3430881614f$var$getSafePlatform();
    if (userAgent) {
        // inspired from https://github.com/bowser-js/bowser/blob/master/src/parser-browsers.js
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const ieEdge = /\sedg\//i.test(userAgent);
        // eslint-disable-next-line require-unicode-regexp
        const ieEdge2 = /edg([ea]|ios)/i.test(userAgent);
        // eslint-disable-next-line require-unicode-regexp
        const internetExplorer = /msie|trident/i.test(userAgent);
        // Ideally we should use userAgent instead of platform, but we have lots of keymap tests failure when we change it
        // So leave it as is for now.
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        result.mac = platform && /Mac/.test(platform);
        // Previously relied on navigator.userAgentData?.platform and userAgent, now used only userAgent
        result.windows = // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        /Windows|Win\d+/i.test(userAgent);
        // used userAgent rather than relying on documentMode
        const ie = ieEdge || ieEdge2 || internetExplorer;
        result.ie = ie;
        // inspired from https://github.com/bowser-js/bowser/blob/master/src/parser-browsers.js
        result.ie_version = ieEdge ? parseInt($4f85d3430881614f$var$getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, userAgent), 10) : ieEdge2 ? parseInt($4f85d3430881614f$var$getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, userAgent), 10) : parseInt($4f85d3430881614f$var$getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, userAgent), 10);
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        result.gecko = !ie && /gecko\/\d/i.test(userAgent);
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        result.gecko_version = parseInt((userAgent.match(/Firefox\/(\d+)/) || [])[1], 10);
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        result.chrome = !ie && /Chrome\//.test(userAgent);
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        result.chrome_version = parseInt((userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        result.android = /Android \d/.test(userAgent);
        result.ios = // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        !ie && /AppleWebKit/.test(userAgent) && /Mobile\/\w+/.test(userAgent);
        // Previously relied on navigator.vendor, now used userAgent
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        result.safari = /safari|applewebkit/i.test(userAgent);
        result.safari_version = parseInt(// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        (userAgent.match(/Version\/([0-9\._]+).*Safari/) || [])[1], 10);
        // Previously we relied on documentElement.style.WebkitAppearance, now changed to userAgent
        // eslint-disable-next-line require-unicode-regexp
        result.webkit = /(apple)?webkit/i.test(userAgent);
        result.supportsIntersectionObserver = $4f85d3430881614f$var$hasIntersectionObserver();
        result.supportsResizeObserver = $4f85d3430881614f$var$hasResizeObserver();
    }
    return result;
});

});

parcelRegister("hvjqZ", function(module, exports) {
$parcel$export(module.exports, "startMeasure", () => $7524b3b31c9b447b$export$b62aa2130c86b59b);
$parcel$export(module.exports, "stopMeasure", () => $7524b3b31c9b447b$export$37c25be427bec097);
$parcel$export(module.exports, "clearMeasure", () => $7524b3b31c9b447b$export$6f766653554dac02);

var $8LHnV = parcelRequire("8LHnV");
const $7524b3b31c9b447b$var$measureMap = new Map();
function $7524b3b31c9b447b$export$b62aa2130c86b59b(measureName) {
    if (!(0, $8LHnV.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::start`);
    $7524b3b31c9b447b$var$measureMap.set(measureName, performance.now());
}
function $7524b3b31c9b447b$export$37c25be427bec097(measureName, onMeasureComplete) {
    if (!(0, $8LHnV.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::end`);
    const start = onMeasureComplete ? $7524b3b31c9b447b$var$measureMap.get(measureName) : undefined;
    try {
        performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
    } catch (error) {} finally{
        if (onMeasureComplete) {
            const entry = performance.getEntriesByName(measureName).pop();
            if (entry) onMeasureComplete(entry.duration, entry.startTime);
            else if (start) onMeasureComplete(performance.now() - start, start);
        }
        $7524b3b31c9b447b$export$6f766653554dac02(measureName);
    }
}
function $7524b3b31c9b447b$export$6f766653554dac02(measureName) {
    if (!(0, $8LHnV.isPerformanceAPIAvailable)()) return;
    $7524b3b31c9b447b$var$measureMap.delete(measureName);
    performance.clearMarks(`${measureName}::start`);
    performance.clearMarks(`${measureName}::end`);
    performance.clearMeasures(measureName);
}
function $7524b3b31c9b447b$export$b0a51f9f0047ea32(measureName) {
    if (!(0, $8LHnV.isPerformanceAPIAvailable)()) return false;
    return $7524b3b31c9b447b$var$measureMap.get(measureName) !== undefined;
}

});
parcelRegister("8LHnV", function(module, exports) {
$parcel$export(module.exports, "isPerformanceAPIAvailable", () => $25dcd805afa5e07f$export$b5717a625dd4a3eb);
$parcel$export(module.exports, "isPerformanceObserverAvailable", () => $25dcd805afa5e07f$export$48995af1e77d8643);
let $25dcd805afa5e07f$var$hasRequiredPerformanceAPIs;
function $25dcd805afa5e07f$export$b5717a625dd4a3eb() {
    if ($25dcd805afa5e07f$var$hasRequiredPerformanceAPIs === undefined) $25dcd805afa5e07f$var$hasRequiredPerformanceAPIs = typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType',
        'now'
    ].every((api)=>!!performance[api]);
    return $25dcd805afa5e07f$var$hasRequiredPerformanceAPIs;
}
function $25dcd805afa5e07f$export$48995af1e77d8643() {
    return !!(typeof window !== 'undefined' && 'PerformanceObserver' in window);
}
function $25dcd805afa5e07f$export$4370ec0f52022f66() {
    return $25dcd805afa5e07f$export$48995af1e77d8643() && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('longtask');
}

});


parcelRegister("65rqJ", function(module, exports) {
$parcel$export(module.exports, "getDistortedDurationMonitor", () => $bca630d6f152961c$export$70f7d127254a90c);
$parcel$export(module.exports, "measureRender", () => $bca630d6f152961c$export$267ed650a5d21ae6);

var $8LHnV = parcelRequire("8LHnV");
const $bca630d6f152961c$export$70f7d127254a90c = ()=>{
    if (typeof document === 'undefined') return {
        distortedDuration: false,
        cleanup () {}
    };
    // If an editor is rendered when the document is not visible -- the callback passed to
    // requestAnimationFrame will not fire until the document becomes visible again.
    //
    // For the purposes of using performance measurement -- this behaviour means the events
    // which have been fired in the background are not useful -- and lead to other events
    // being hard to draw conclusions from.
    //
    // To mitigate this -- we detect this state -- and fire a separate callback when the
    // measurement has occurred when the render was in the background
    let distortedDuration = document.visibilityState !== 'visible';
    function handleVisibilityChange() {
        if (document.visibilityState !== 'visible') distortedDuration = true;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return {
        distortedDuration: distortedDuration,
        /**
		 * Cleans up the document visibility event listener
		 */ cleanup () {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        }
    };
};
function $bca630d6f152961c$export$267ed650a5d21ae6(/**
	 * Unique name for the measurement
	 *
	 * Important: if multiple measureRender events are fired at the same time
	 * with the same measure name -- the result will not be correct.
	 */ measureName, /**
	 * Call back fired when the measurement completes.
	 *
	 * Note: when this function is called when the Document.visibilityState is not
	 * visible -- the duration is likely to be misleading/inaccurate. This is due
	 * to the measurements use of the `requestAnimationFrame` api which only fires
	 * when the Document.visibilityState is visible.
	 */ onMeasureComplete) {
    if (!(0, $8LHnV.isPerformanceAPIAvailable)()) return;
    const startMark = `[START]: ${measureName}`;
    const endMark = `[END]: ${measureName}`;
    const startTime = performance.now();
    performance.mark(startMark);
    const distortedDurationMonitor = $bca630d6f152961c$export$70f7d127254a90c();
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            performance.mark(endMark);
            distortedDurationMonitor.cleanup();
            const duration = performance.now() - startTime;
            try {
                performance.measure(measureName, startMark, endMark);
                const entry = performance.getEntriesByName(measureName).pop();
                if (!entry) onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
                else onMeasureComplete({
                    duration: entry.duration,
                    startTime: entry.startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            } catch (e) {
                onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            }
            performance.clearMeasures(measureName);
            performance.clearMarks(startMark);
            performance.clearMarks(endMark);
        });
    });
}

});

parcelRegister("Sk9g1", function(module, exports) {
$parcel$export(module.exports, "getResponseEndTime", () => $ac2e032b774c2f79$export$92d097a1155bbe27);

var $8LHnV = parcelRequire("8LHnV");
function $ac2e032b774c2f79$export$92d097a1155bbe27() {
    if (!(0, $8LHnV.isPerformanceAPIAvailable)()) return;
    const nav = performance.getEntriesByType('navigation')[0];
    if (nav) return nav.responseEnd;
    return;
}

});

parcelRegister("dyNYh", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsAppearance", () => $6098e217e78ad5fc$export$be87849653b93e6b);
$parcel$export(module.exports, "getAnalyticsEditorAppearance", () => $6098e217e78ad5fc$export$31ae53e002edded0);
$parcel$export(module.exports, "getAnalyticsEventSeverity", () => $6098e217e78ad5fc$export$f8edd689e8b20f3a);
$parcel$export(module.exports, "findInsertLocation", () => $6098e217e78ad5fc$export$d770b562ead089d8);
$parcel$export(module.exports, "analyticsEventKey", () => $6098e217e78ad5fc$export$288273ee3e3b6132);
$parcel$export(module.exports, "getBreakpointKey", () => $6098e217e78ad5fc$export$afdcbbd112676ca8);

var $457Jo = parcelRequire("457Jo");

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");

var $cwzAY = parcelRequire("cwzAY");
const $6098e217e78ad5fc$export$be87849653b93e6b = (appearance)=>{
    switch(appearance){
        case 'full-page':
            return (0, $457Jo.EDITOR_APPEARANCE_CONTEXT).FIXED_WIDTH;
        case 'full-width':
            return (0, $457Jo.EDITOR_APPEARANCE_CONTEXT).FULL_WIDTH;
        case 'comment':
            return (0, $457Jo.EDITOR_APPEARANCE_CONTEXT).COMMENT;
        case 'chromeless':
            return (0, $457Jo.EDITOR_APPEARANCE_CONTEXT).CHROMELESS;
        case 'mobile':
            return (0, $457Jo.EDITOR_APPEARANCE_CONTEXT).MOBILE;
    }
};
const $6098e217e78ad5fc$export$31ae53e002edded0 = (editorAppearance)=>editorAppearance ? `editor_${$6098e217e78ad5fc$export$be87849653b93e6b(editorAppearance)}` : '_unknown';
const $6098e217e78ad5fc$export$f8edd689e8b20f3a = (duration, normalThreshold, degradedThreshold)=>{
    if (duration > normalThreshold && duration <= degradedThreshold) return "degraded";
    if (duration > degradedThreshold) return "blocking";
    return "normal";
};
function $6098e217e78ad5fc$export$d770b562ead089d8(selection) {
    const { schema: schema, name: name } = selection.$from.doc.type;
    if (selection instanceof (0, $3lIcL.NodeSelection)) return selection.node.type.name;
    if (selection instanceof (0, $cwzAY.CellSelection)) return schema.nodes.table.name;
    // Text selection
    const parentNodeInfo = (0, $BmspC.findParentNode)((node)=>node.type !== schema.nodes.paragraph)(selection);
    return parentNodeInfo ? parentNodeInfo.node.type.name : name;
}
var $6098e217e78ad5fc$export$6a6bef12562cd865 = /*#__PURE__*/ function(SEVERITY) {
    SEVERITY["NORMAL"] = "normal";
    SEVERITY["DEGRADED"] = "degraded";
    SEVERITY["BLOCKING"] = "blocking";
    return SEVERITY;
}({});
const $6098e217e78ad5fc$export$288273ee3e3b6132 = 'EDITOR_ANALYTICS_EVENT';
const $6098e217e78ad5fc$var$EDITOR_BREAKPOINT_WIDTH = {
    S: 760,
    M: 1600,
    L: Infinity
};
const $6098e217e78ad5fc$var$TABLE_BREAKPOINT_KEYS = Object.keys($6098e217e78ad5fc$var$EDITOR_BREAKPOINT_WIDTH);
const $6098e217e78ad5fc$export$afdcbbd112676ca8 = (width)=>{
    return $6098e217e78ad5fc$var$TABLE_BREAKPOINT_KEYS.find((key)=>width <= $6098e217e78ad5fc$var$EDITOR_BREAKPOINT_WIDTH[key]) || 'L';
};

});
parcelRegister("3lIcL", function(module, exports) {
$parcel$export(module.exports, "Selection", () => $27059f7464a1d1f5$export$52baac22726c72bf);
$parcel$export(module.exports, "SelectionRange", () => $27059f7464a1d1f5$export$7bd1839c3c5d5bd4);
$parcel$export(module.exports, "TextSelection", () => $27059f7464a1d1f5$export$c2b25f346d19bcbb);
$parcel$export(module.exports, "AllSelection", () => $27059f7464a1d1f5$export$c15d9ba76bdbcd95);
$parcel$export(module.exports, "NodeSelection", () => $27059f7464a1d1f5$export$e2940151ac854c0b);
$parcel$export(module.exports, "Transaction", () => $27059f7464a1d1f5$export$febc5573c75cefb0);
$parcel$export(module.exports, "EditorState", () => $27059f7464a1d1f5$export$afa855cbfaff27f2);
$parcel$export(module.exports, "Plugin", () => $27059f7464a1d1f5$export$901cf72dabf2112a);
$parcel$export(module.exports, "PluginKey", () => $27059f7464a1d1f5$export$1692d8b0e89cecc3);

var $3xw6l = parcelRequire("3xw6l");

var $lzEKq = parcelRequire("lzEKq");
const $27059f7464a1d1f5$var$classesById = Object.create(null);
/**
Superclass for editor selections. Every selection type should
extend this. Should not be instantiated directly.
*/ class $27059f7464a1d1f5$export$52baac22726c72bf {
    /**
    Initialize a selection with the head and anchor and ranges. If no
    ranges are given, constructs a single range across `$anchor` and
    `$head`.
    */ constructor(/**
    The resolved anchor of the selection (the side that stays in
    place when the selection is modified).
    */ $anchor, /**
    The resolved head of the selection (the side that moves when
    the selection is modified).
    */ $head, ranges){
        this.$anchor = $anchor;
        this.$head = $head;
        this.ranges = ranges || [
            new $27059f7464a1d1f5$export$7bd1839c3c5d5bd4($anchor.min($head), $anchor.max($head))
        ];
    }
    /**
    The selection's anchor, as an unresolved position.
    */ get anchor() {
        return this.$anchor.pos;
    }
    /**
    The selection's head.
    */ get head() {
        return this.$head.pos;
    }
    /**
    The lower bound of the selection's main range.
    */ get from() {
        return this.$from.pos;
    }
    /**
    The upper bound of the selection's main range.
    */ get to() {
        return this.$to.pos;
    }
    /**
    The resolved lower  bound of the selection's main range.
    */ get $from() {
        return this.ranges[0].$from;
    }
    /**
    The resolved upper bound of the selection's main range.
    */ get $to() {
        return this.ranges[0].$to;
    }
    /**
    Indicates whether the selection contains any content.
    */ get empty() {
        let ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++)if (ranges[i].$from.pos != ranges[i].$to.pos) return false;
        return true;
    }
    /**
    Get the content of this selection as a slice.
    */ content() {
        return this.$from.doc.slice(this.from, this.to, true);
    }
    /**
    Replace the selection with a slice or, if no slice is given,
    delete the selection. Will append to the given transaction.
    */ replace(tr, content = (0, $3xw6l.Slice).empty) {
        // Put the new selection at the position after the inserted
        // content. When that ended in an inline node, search backwards,
        // to get the position after that node. If not, search forward.
        let lastNode = content.content.lastChild, lastParent = null;
        for(let i = 0; i < content.openEnd; i++){
            lastParent = lastNode;
            lastNode = lastNode.lastChild;
        }
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $3xw6l.Slice).empty : content);
            if (i == 0) $27059f7464a1d1f5$var$selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
        }
    }
    /**
    Replace the selection with the given node, appending the changes
    to the given transaction.
    */ replaceWith(tr, node) {
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            let from = mapping.map($from.pos), to = mapping.map($to.pos);
            if (i) tr.deleteRange(from, to);
            else {
                tr.replaceRangeWith(from, to, node);
                $27059f7464a1d1f5$var$selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
            }
        }
    }
    /**
    Find a valid cursor or leaf node selection starting at the given
    position and searching back if `dir` is negative, and forward if
    positive. When `textOnly` is true, only consider cursor
    selections. Will return null when no valid selection position is
    found.
    */ static findFrom($pos, dir, textOnly = false) {
        let inner = $pos.parent.inlineContent ? new $27059f7464a1d1f5$export$c2b25f346d19bcbb($pos) : $27059f7464a1d1f5$var$findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
        if (inner) return inner;
        for(let depth = $pos.depth - 1; depth >= 0; depth--){
            let found = dir < 0 ? $27059f7464a1d1f5$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : $27059f7464a1d1f5$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
            if (found) return found;
        }
        return null;
    }
    /**
    Find a valid cursor or leaf node selection near the given
    position. Searches forward first by default, but if `bias` is
    negative, it will search backwards first.
    */ static near($pos, bias = 1) {
        return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new $27059f7464a1d1f5$export$c15d9ba76bdbcd95($pos.node(0));
    }
    /**
    Find the cursor or leaf node selection closest to the start of
    the given document. Will return an
    [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
    exists.
    */ static atStart(doc) {
        return $27059f7464a1d1f5$var$findSelectionIn(doc, doc, 0, 0, 1) || new $27059f7464a1d1f5$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Find the cursor or leaf node selection closest to the end of the
    given document.
    */ static atEnd(doc) {
        return $27059f7464a1d1f5$var$findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new $27059f7464a1d1f5$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Deserialize the JSON representation of a selection. Must be
    implemented for custom classes (as a static class method).
    */ static fromJSON(doc, json) {
        if (!json || !json.type) throw new RangeError("Invalid input for Selection.fromJSON");
        let cls = $27059f7464a1d1f5$var$classesById[json.type];
        if (!cls) throw new RangeError(`No selection type ${json.type} defined`);
        return cls.fromJSON(doc, json);
    }
    /**
    To be able to deserialize selections from JSON, custom selection
    classes must register themselves with an ID string, so that they
    can be disambiguated. Try to pick something that's unlikely to
    clash with classes from other modules.
    */ static jsonID(id, selectionClass) {
        if (id in $27059f7464a1d1f5$var$classesById) throw new RangeError("Duplicate use of selection JSON ID " + id);
        $27059f7464a1d1f5$var$classesById[id] = selectionClass;
        selectionClass.prototype.jsonID = id;
        return selectionClass;
    }
    /**
    Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
    which is a value that can be mapped without having access to a
    current document, and later resolved to a real selection for a
    given document again. (This is used mostly by the history to
    track and restore old selections.) The default implementation of
    this method just converts the selection to a text selection and
    returns the bookmark for that.
    */ getBookmark() {
        return $27059f7464a1d1f5$export$c2b25f346d19bcbb.between(this.$anchor, this.$head).getBookmark();
    }
}
$27059f7464a1d1f5$export$52baac22726c72bf.prototype.visible = true;
/**
Represents a selected range in a document.
*/ class $27059f7464a1d1f5$export$7bd1839c3c5d5bd4 {
    /**
    Create a range.
    */ constructor(/**
    The lower bound of the range.
    */ $from, /**
    The upper bound of the range.
    */ $to){
        this.$from = $from;
        this.$to = $to;
    }
}
let $27059f7464a1d1f5$var$warnedAboutTextSelection = false;
function $27059f7464a1d1f5$var$checkTextSelection($pos) {
    if (!$27059f7464a1d1f5$var$warnedAboutTextSelection && !$pos.parent.inlineContent) {
        $27059f7464a1d1f5$var$warnedAboutTextSelection = true;
        console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
    }
}
/**
A text selection represents a classical editor selection, with a
head (the moving side) and anchor (immobile side), both of which
point into textblock nodes. It can be empty (a regular cursor
position).
*/ class $27059f7464a1d1f5$export$c2b25f346d19bcbb extends $27059f7464a1d1f5$export$52baac22726c72bf {
    /**
    Construct a text selection between the given points.
    */ constructor($anchor, $head = $anchor){
        $27059f7464a1d1f5$var$checkTextSelection($anchor);
        $27059f7464a1d1f5$var$checkTextSelection($head);
        super($anchor, $head);
    }
    /**
    Returns a resolved position if this is a cursor selection (an
    empty text selection), and null otherwise.
    */ get $cursor() {
        return this.$anchor.pos == this.$head.pos ? this.$head : null;
    }
    map(doc, mapping) {
        let $head = doc.resolve(mapping.map(this.head));
        if (!$head.parent.inlineContent) return $27059f7464a1d1f5$export$52baac22726c72bf.near($head);
        let $anchor = doc.resolve(mapping.map(this.anchor));
        return new $27059f7464a1d1f5$export$c2b25f346d19bcbb($anchor.parent.inlineContent ? $anchor : $head, $head);
    }
    replace(tr, content = (0, $3xw6l.Slice).empty) {
        super.replace(tr, content);
        if (content == (0, $3xw6l.Slice).empty) {
            let marks = this.$from.marksAcross(this.$to);
            if (marks) tr.ensureMarks(marks);
        }
    }
    eq(other) {
        return other instanceof $27059f7464a1d1f5$export$c2b25f346d19bcbb && other.anchor == this.anchor && other.head == this.head;
    }
    getBookmark() {
        return new $27059f7464a1d1f5$var$TextBookmark(this.anchor, this.head);
    }
    toJSON() {
        return {
            type: "text",
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid input for TextSelection.fromJSON");
        return new $27059f7464a1d1f5$export$c2b25f346d19bcbb(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    /**
    Create a text selection from non-resolved positions.
    */ static create(doc, anchor, head = anchor) {
        let $anchor = doc.resolve(anchor);
        return new this($anchor, head == anchor ? $anchor : doc.resolve(head));
    }
    /**
    Return a text selection that spans the given positions or, if
    they aren't text positions, find a text selection near them.
    `bias` determines whether the method searches forward (default)
    or backwards (negative number) first. Will fall back to calling
    [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
    doesn't contain a valid text position.
    */ static between($anchor, $head, bias) {
        let dPos = $anchor.pos - $head.pos;
        if (!bias || dPos) bias = dPos >= 0 ? 1 : -1;
        if (!$head.parent.inlineContent) {
            let found = $27059f7464a1d1f5$export$52baac22726c72bf.findFrom($head, bias, true) || $27059f7464a1d1f5$export$52baac22726c72bf.findFrom($head, -bias, true);
            if (found) $head = found.$head;
            else return $27059f7464a1d1f5$export$52baac22726c72bf.near($head, bias);
        }
        if (!$anchor.parent.inlineContent) {
            if (dPos == 0) $anchor = $head;
            else {
                $anchor = ($27059f7464a1d1f5$export$52baac22726c72bf.findFrom($anchor, -bias, true) || $27059f7464a1d1f5$export$52baac22726c72bf.findFrom($anchor, bias, true)).$anchor;
                if ($anchor.pos < $head.pos != dPos < 0) $anchor = $head;
            }
        }
        return new $27059f7464a1d1f5$export$c2b25f346d19bcbb($anchor, $head);
    }
}
$27059f7464a1d1f5$export$52baac22726c72bf.jsonID("text", $27059f7464a1d1f5$export$c2b25f346d19bcbb);
class $27059f7464a1d1f5$var$TextBookmark {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $27059f7464a1d1f5$var$TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        return $27059f7464a1d1f5$export$c2b25f346d19bcbb.between(doc.resolve(this.anchor), doc.resolve(this.head));
    }
}
/**
A node selection is a selection that points at a single node. All
nodes marked [selectable](https://prosemirror.net/docs/ref/#model.NodeSpec.selectable) can be the
target of a node selection. In such a selection, `from` and `to`
point directly before and after the selected node, `anchor` equals
`from`, and `head` equals `to`..
*/ class $27059f7464a1d1f5$export$e2940151ac854c0b extends $27059f7464a1d1f5$export$52baac22726c72bf {
    /**
    Create a node selection. Does not verify the validity of its
    argument.
    */ constructor($pos){
        let node = $pos.nodeAfter;
        let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
        super($pos, $end);
        this.node = node;
    }
    map(doc, mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        let $pos = doc.resolve(pos);
        if (deleted) return $27059f7464a1d1f5$export$52baac22726c72bf.near($pos);
        return new $27059f7464a1d1f5$export$e2940151ac854c0b($pos);
    }
    content() {
        return new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(this.node), 0, 0);
    }
    eq(other) {
        return other instanceof $27059f7464a1d1f5$export$e2940151ac854c0b && other.anchor == this.anchor;
    }
    toJSON() {
        return {
            type: "node",
            anchor: this.anchor
        };
    }
    getBookmark() {
        return new $27059f7464a1d1f5$var$NodeBookmark(this.anchor);
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number") throw new RangeError("Invalid input for NodeSelection.fromJSON");
        return new $27059f7464a1d1f5$export$e2940151ac854c0b(doc.resolve(json.anchor));
    }
    /**
    Create a node selection from non-resolved positions.
    */ static create(doc, from) {
        return new $27059f7464a1d1f5$export$e2940151ac854c0b(doc.resolve(from));
    }
    /**
    Determines whether the given node may be selected as a node
    selection.
    */ static isSelectable(node) {
        return !node.isText && node.type.spec.selectable !== false;
    }
}
$27059f7464a1d1f5$export$e2940151ac854c0b.prototype.visible = false;
$27059f7464a1d1f5$export$52baac22726c72bf.jsonID("node", $27059f7464a1d1f5$export$e2940151ac854c0b);
class $27059f7464a1d1f5$var$NodeBookmark {
    constructor(anchor){
        this.anchor = anchor;
    }
    map(mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        return deleted ? new $27059f7464a1d1f5$var$TextBookmark(pos, pos) : new $27059f7464a1d1f5$var$NodeBookmark(pos);
    }
    resolve(doc) {
        let $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
        if (node && $27059f7464a1d1f5$export$e2940151ac854c0b.isSelectable(node)) return new $27059f7464a1d1f5$export$e2940151ac854c0b($pos);
        return $27059f7464a1d1f5$export$52baac22726c72bf.near($pos);
    }
}
/**
A selection type that represents selecting the whole document
(which can not necessarily be expressed with a text selection, when
there are for example leaf block nodes at the start or end of the
document).
*/ class $27059f7464a1d1f5$export$c15d9ba76bdbcd95 extends $27059f7464a1d1f5$export$52baac22726c72bf {
    /**
    Create an all-selection over the given document.
    */ constructor(doc){
        super(doc.resolve(0), doc.resolve(doc.content.size));
    }
    replace(tr, content = (0, $3xw6l.Slice).empty) {
        if (content == (0, $3xw6l.Slice).empty) {
            tr.delete(0, tr.doc.content.size);
            let sel = $27059f7464a1d1f5$export$52baac22726c72bf.atStart(tr.doc);
            if (!sel.eq(tr.selection)) tr.setSelection(sel);
        } else super.replace(tr, content);
    }
    toJSON() {
        return {
            type: "all"
        };
    }
    /**
    @internal
    */ static fromJSON(doc) {
        return new $27059f7464a1d1f5$export$c15d9ba76bdbcd95(doc);
    }
    map(doc) {
        return new $27059f7464a1d1f5$export$c15d9ba76bdbcd95(doc);
    }
    eq(other) {
        return other instanceof $27059f7464a1d1f5$export$c15d9ba76bdbcd95;
    }
    getBookmark() {
        return $27059f7464a1d1f5$var$AllBookmark;
    }
}
$27059f7464a1d1f5$export$52baac22726c72bf.jsonID("all", $27059f7464a1d1f5$export$c15d9ba76bdbcd95);
const $27059f7464a1d1f5$var$AllBookmark = {
    map () {
        return this;
    },
    resolve (doc) {
        return new $27059f7464a1d1f5$export$c15d9ba76bdbcd95(doc);
    }
};
// FIXME we'll need some awareness of text direction when scanning for selections
// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function $27059f7464a1d1f5$var$findSelectionIn(doc, node, pos, index, dir, text = false) {
    if (node.inlineContent) return $27059f7464a1d1f5$export$c2b25f346d19bcbb.create(doc, pos);
    for(let i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir){
        let child = node.child(i);
        if (!child.isAtom) {
            let inner = $27059f7464a1d1f5$var$findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
            if (inner) return inner;
        } else if (!text && $27059f7464a1d1f5$export$e2940151ac854c0b.isSelectable(child)) return $27059f7464a1d1f5$export$e2940151ac854c0b.create(doc, pos - (dir < 0 ? child.nodeSize : 0));
        pos += child.nodeSize * dir;
    }
    return null;
}
function $27059f7464a1d1f5$var$selectionToInsertionEnd(tr, startLen, bias) {
    let last = tr.steps.length - 1;
    if (last < startLen) return;
    let step = tr.steps[last];
    if (!(step instanceof (0, $lzEKq.ReplaceStep) || step instanceof (0, $lzEKq.ReplaceAroundStep))) return;
    let map = tr.mapping.maps[last], end;
    map.forEach((_from, _to, _newFrom, newTo)=>{
        if (end == null) end = newTo;
    });
    tr.setSelection($27059f7464a1d1f5$export$52baac22726c72bf.near(tr.doc.resolve(end), bias));
}
const $27059f7464a1d1f5$var$UPDATED_SEL = 1, $27059f7464a1d1f5$var$UPDATED_MARKS = 2, $27059f7464a1d1f5$var$UPDATED_SCROLL = 4;
/**
An editor state transaction, which can be applied to a state to
create an updated state. Use
[`EditorState.tr`](https://prosemirror.net/docs/ref/#state.EditorState.tr) to create an instance.

Transactions track changes to the document (they are a subclass of
[`Transform`](https://prosemirror.net/docs/ref/#transform.Transform)), but also other state changes,
like selection updates and adjustments of the set of [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks). In addition, you can store
metadata properties in a transaction, which are extra pieces of
information that client code or plugins can use to describe what a
transaction represents, so that they can update their [own
state](https://prosemirror.net/docs/ref/#state.StateField) accordingly.

The [editor view](https://prosemirror.net/docs/ref/#view.EditorView) uses a few metadata
properties: it will attach a property `"pointer"` with the value
`true` to selection transactions directly caused by mouse or touch
input, a `"composition"` property holding an ID identifying the
composition that caused it to transactions caused by composed DOM
input, and a `"uiEvent"` property of that may be `"paste"`,
`"cut"`, or `"drop"`.
*/ class $27059f7464a1d1f5$export$febc5573c75cefb0 extends (0, $lzEKq.Transform) {
    /**
    @internal
    */ constructor(state){
        super(state.doc);
        // The step count for which the current selection is valid.
        this.curSelectionFor = 0;
        // Bitfield to track which aspects of the state were updated by
        // this transaction.
        this.updated = 0;
        // Object used to store metadata properties for the transaction.
        this.meta = Object.create(null);
        this.time = Date.now();
        this.curSelection = state.selection;
        this.storedMarks = state.storedMarks;
    }
    /**
    The transaction's current selection. This defaults to the editor
    selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
    transaction, but can be overwritten with
    [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
    */ get selection() {
        if (this.curSelectionFor < this.steps.length) {
            this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
            this.curSelectionFor = this.steps.length;
        }
        return this.curSelection;
    }
    /**
    Update the transaction's current selection. Will determine the
    selection that the editor gets when the transaction is applied.
    */ setSelection(selection) {
        if (selection.$from.doc != this.doc) throw new RangeError("Selection passed to setSelection must point at the current document");
        this.curSelection = selection;
        this.curSelectionFor = this.steps.length;
        this.updated = (this.updated | $27059f7464a1d1f5$var$UPDATED_SEL) & ~$27059f7464a1d1f5$var$UPDATED_MARKS;
        this.storedMarks = null;
        return this;
    }
    /**
    Whether the selection was explicitly updated by this transaction.
    */ get selectionSet() {
        return (this.updated & $27059f7464a1d1f5$var$UPDATED_SEL) > 0;
    }
    /**
    Set the current stored marks.
    */ setStoredMarks(marks) {
        this.storedMarks = marks;
        this.updated |= $27059f7464a1d1f5$var$UPDATED_MARKS;
        return this;
    }
    /**
    Make sure the current stored marks or, if that is null, the marks
    at the selection, match the given set of marks. Does nothing if
    this is already the case.
    */ ensureMarks(marks) {
        if (!(0, $3xw6l.Mark).sameSet(this.storedMarks || this.selection.$from.marks(), marks)) this.setStoredMarks(marks);
        return this;
    }
    /**
    Add a mark to the set of stored marks.
    */ addStoredMark(mark) {
        return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Remove a mark or mark type from the set of stored marks.
    */ removeStoredMark(mark) {
        return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Whether the stored marks were explicitly set for this transaction.
    */ get storedMarksSet() {
        return (this.updated & $27059f7464a1d1f5$var$UPDATED_MARKS) > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        super.addStep(step, doc);
        this.updated = this.updated & ~$27059f7464a1d1f5$var$UPDATED_MARKS;
        this.storedMarks = null;
    }
    /**
    Update the timestamp for the transaction.
    */ setTime(time) {
        this.time = time;
        return this;
    }
    /**
    Replace the current selection with the given slice.
    */ replaceSelection(slice) {
        this.selection.replace(this, slice);
        return this;
    }
    /**
    Replace the selection with the given node. When `inheritMarks` is
    true and the content is inline, it inherits the marks from the
    place where it is inserted.
    */ replaceSelectionWith(node, inheritMarks = true) {
        let selection = this.selection;
        if (inheritMarks) node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || (0, $3xw6l.Mark).none));
        selection.replaceWith(this, node);
        return this;
    }
    /**
    Delete the selection.
    */ deleteSelection() {
        this.selection.replace(this);
        return this;
    }
    /**
    Replace the given range, or the selection if no range is given,
    with a text node containing the given string.
    */ insertText(text, from, to) {
        let schema = this.doc.type.schema;
        if (from == null) {
            if (!text) return this.deleteSelection();
            return this.replaceSelectionWith(schema.text(text), true);
        } else {
            if (to == null) to = from;
            to = to == null ? from : to;
            if (!text) return this.deleteRange(from, to);
            let marks = this.storedMarks;
            if (!marks) {
                let $from = this.doc.resolve(from);
                marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
            }
            this.replaceRangeWith(from, to, schema.text(text, marks));
            if (!this.selection.empty) this.setSelection($27059f7464a1d1f5$export$52baac22726c72bf.near(this.selection.$to));
            return this;
        }
    }
    /**
    Store a metadata property in this transaction, keyed either by
    name or by plugin.
    */ setMeta(key, value) {
        this.meta[typeof key == "string" ? key : key.key] = value;
        return this;
    }
    /**
    Retrieve a metadata property for a given name or plugin.
    */ getMeta(key) {
        return this.meta[typeof key == "string" ? key : key.key];
    }
    /**
    Returns true if this transaction doesn't contain any metadata,
    and can thus safely be extended.
    */ get isGeneric() {
        for(let _ in this.meta)return false;
        return true;
    }
    /**
    Indicate that the editor should scroll the selection into view
    when updated to the state produced by this transaction.
    */ scrollIntoView() {
        this.updated |= $27059f7464a1d1f5$var$UPDATED_SCROLL;
        return this;
    }
    /**
    True when this transaction has had `scrollIntoView` called on it.
    */ get scrolledIntoView() {
        return (this.updated & $27059f7464a1d1f5$var$UPDATED_SCROLL) > 0;
    }
}
function $27059f7464a1d1f5$var$bind(f, self) {
    return !self || !f ? f : f.bind(self);
}
class $27059f7464a1d1f5$var$FieldDesc {
    constructor(name, desc, self){
        this.name = name;
        this.init = $27059f7464a1d1f5$var$bind(desc.init, self);
        this.apply = $27059f7464a1d1f5$var$bind(desc.apply, self);
    }
}
const $27059f7464a1d1f5$var$baseFields = [
    new $27059f7464a1d1f5$var$FieldDesc("doc", {
        init (config) {
            return config.doc || config.schema.topNodeType.createAndFill();
        },
        apply (tr) {
            return tr.doc;
        }
    }),
    new $27059f7464a1d1f5$var$FieldDesc("selection", {
        init (config, instance) {
            return config.selection || $27059f7464a1d1f5$export$52baac22726c72bf.atStart(instance.doc);
        },
        apply (tr) {
            return tr.selection;
        }
    }),
    new $27059f7464a1d1f5$var$FieldDesc("storedMarks", {
        init (config) {
            return config.storedMarks || null;
        },
        apply (tr, _marks, _old, state) {
            return state.selection.$cursor ? tr.storedMarks : null;
        }
    }),
    new $27059f7464a1d1f5$var$FieldDesc("scrollToSelection", {
        init () {
            return 0;
        },
        apply (tr, prev) {
            return tr.scrolledIntoView ? prev + 1 : prev;
        }
    })
];
// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
class $27059f7464a1d1f5$var$Configuration {
    constructor(schema, plugins){
        this.schema = schema;
        this.plugins = [];
        this.pluginsByKey = Object.create(null);
        this.fields = $27059f7464a1d1f5$var$baseFields.slice();
        if (plugins) plugins.forEach((plugin)=>{
            if (this.pluginsByKey[plugin.key]) throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
            this.plugins.push(plugin);
            this.pluginsByKey[plugin.key] = plugin;
            if (plugin.spec.state) this.fields.push(new $27059f7464a1d1f5$var$FieldDesc(plugin.key, plugin.spec.state, plugin));
        });
    }
}
/**
The state of a ProseMirror editor is represented by an object of
this type. A state is a persistent data structure—it isn't
updated, but rather a new state value is computed from an old one
using the [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) method.

A state holds a number of built-in fields, and plugins can
[define](https://prosemirror.net/docs/ref/#state.PluginSpec.state) additional fields.
*/ class $27059f7464a1d1f5$export$afa855cbfaff27f2 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ config){
        this.config = config;
    }
    /**
    The schema of the state's document.
    */ get schema() {
        return this.config.schema;
    }
    /**
    The plugins that are active in this state.
    */ get plugins() {
        return this.config.plugins;
    }
    /**
    Apply the given transaction to produce a new state.
    */ apply(tr) {
        return this.applyTransaction(tr).state;
    }
    /**
    @internal
    */ filterTransaction(tr, ignore = -1) {
        for(let i = 0; i < this.config.plugins.length; i++)if (i != ignore) {
            let plugin = this.config.plugins[i];
            if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this)) return false;
        }
        return true;
    }
    /**
    Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
    returns the precise transactions that were applied (which might
    be influenced by the [transaction
    hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
    plugins) along with the new state.
    */ applyTransaction(rootTr) {
        if (!this.filterTransaction(rootTr)) return {
            state: this,
            transactions: []
        };
        let trs = [
            rootTr
        ], newState = this.applyInner(rootTr), seen = null;
        // This loop repeatedly gives plugins a chance to respond to
        // transactions as new transactions are added, making sure to only
        // pass the transactions the plugin did not see before.
        for(;;){
            let haveNew = false;
            for(let i = 0; i < this.config.plugins.length; i++){
                let plugin = this.config.plugins[i];
                if (plugin.spec.appendTransaction) {
                    let n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
                    let tr = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
                    if (tr && newState.filterTransaction(tr, i)) {
                        tr.setMeta("appendedTransaction", rootTr);
                        if (!seen) {
                            seen = [];
                            for(let j = 0; j < this.config.plugins.length; j++)seen.push(j < i ? {
                                state: newState,
                                n: trs.length
                            } : {
                                state: this,
                                n: 0
                            });
                        }
                        trs.push(tr);
                        newState = newState.applyInner(tr);
                        haveNew = true;
                    }
                    if (seen) seen[i] = {
                        state: newState,
                        n: trs.length
                    };
                }
            }
            if (!haveNew) return {
                state: newState,
                transactions: trs
            };
        }
    }
    /**
    @internal
    */ applyInner(tr) {
        if (!tr.before.eq(this.doc)) throw new RangeError("Applying a mismatched transaction");
        let newInstance = new $27059f7464a1d1f5$export$afa855cbfaff27f2(this.config), fields = this.config.fields;
        for(let i = 0; i < fields.length; i++){
            let field = fields[i];
            newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
        }
        return newInstance;
    }
    /**
    Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
    */ get tr() {
        return new $27059f7464a1d1f5$export$febc5573c75cefb0(this);
    }
    /**
    Create a new state.
    */ static create(config) {
        let $config = new $27059f7464a1d1f5$var$Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
        let instance = new $27059f7464a1d1f5$export$afa855cbfaff27f2($config);
        for(let i = 0; i < $config.fields.length; i++)instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
        return instance;
    }
    /**
    Create a new state based on this one, but with an adjusted set
    of active plugins. State fields that exist in both sets of
    plugins are kept unchanged. Those that no longer exist are
    dropped, and those that are new are initialized using their
    [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
    configuration object..
    */ reconfigure(config) {
        let $config = new $27059f7464a1d1f5$var$Configuration(this.schema, config.plugins);
        let fields = $config.fields, instance = new $27059f7464a1d1f5$export$afa855cbfaff27f2($config);
        for(let i = 0; i < fields.length; i++){
            let name = fields[i].name;
            instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
        }
        return instance;
    }
    /**
    Serialize this state to JSON. If you want to serialize the state
    of plugins, pass an object mapping property names to use in the
    resulting JSON object to plugin objects. The argument may also be
    a string or number, in which case it is ignored, to support the
    way `JSON.stringify` calls `toString` methods.
    */ toJSON(pluginFields) {
        let result = {
            doc: this.doc.toJSON(),
            selection: this.selection.toJSON()
        };
        if (this.storedMarks) result.storedMarks = this.storedMarks.map((m)=>m.toJSON());
        if (pluginFields && typeof pluginFields == 'object') for(let prop in pluginFields){
            if (prop == "doc" || prop == "selection") throw new RangeError("The JSON fields `doc` and `selection` are reserved");
            let plugin = pluginFields[prop], state = plugin.spec.state;
            if (state && state.toJSON) result[prop] = state.toJSON.call(plugin, this[plugin.key]);
        }
        return result;
    }
    /**
    Deserialize a JSON representation of a state. `config` should
    have at least a `schema` field, and should contain array of
    plugins to initialize the state with. `pluginFields` can be used
    to deserialize the state of plugins, by associating plugin
    instances with the property names they use in the JSON object.
    */ static fromJSON(config, json, pluginFields) {
        if (!json) throw new RangeError("Invalid input for EditorState.fromJSON");
        if (!config.schema) throw new RangeError("Required config field 'schema' missing");
        let $config = new $27059f7464a1d1f5$var$Configuration(config.schema, config.plugins);
        let instance = new $27059f7464a1d1f5$export$afa855cbfaff27f2($config);
        $config.fields.forEach((field)=>{
            if (field.name == "doc") instance.doc = (0, $3xw6l.Node).fromJSON(config.schema, json.doc);
            else if (field.name == "selection") instance.selection = $27059f7464a1d1f5$export$52baac22726c72bf.fromJSON(instance.doc, json.selection);
            else if (field.name == "storedMarks") {
                if (json.storedMarks) instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
            } else {
                if (pluginFields) for(let prop in pluginFields){
                    let plugin = pluginFields[prop], state = plugin.spec.state;
                    if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
                        instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
                        return;
                    }
                }
                instance[field.name] = field.init(config, instance);
            }
        });
        return instance;
    }
}
function $27059f7464a1d1f5$var$bindProps(obj, self, target) {
    for(let prop in obj){
        let val = obj[prop];
        if (val instanceof Function) val = val.bind(self);
        else if (prop == "handleDOMEvents") val = $27059f7464a1d1f5$var$bindProps(val, self, {});
        target[prop] = val;
    }
    return target;
}
/**
Plugins bundle functionality that can be added to an editor.
They are part of the [editor state](https://prosemirror.net/docs/ref/#state.EditorState) and
may influence that state and the view that contains it.
*/ class $27059f7464a1d1f5$export$901cf72dabf2112a {
    /**
    Create a plugin.
    */ constructor(/**
    The plugin's [spec object](https://prosemirror.net/docs/ref/#state.PluginSpec).
    */ spec){
        this.spec = spec;
        /**
        The [props](https://prosemirror.net/docs/ref/#view.EditorProps) exported by this plugin.
        */ this.props = {};
        if (spec.props) $27059f7464a1d1f5$var$bindProps(spec.props, this, this.props);
        this.key = spec.key ? spec.key.key : $27059f7464a1d1f5$var$createKey("plugin");
    }
    /**
    Extract the plugin's state field from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}
const $27059f7464a1d1f5$var$keys = Object.create(null);
function $27059f7464a1d1f5$var$createKey(name) {
    if (name in $27059f7464a1d1f5$var$keys) return name + "$" + ++$27059f7464a1d1f5$var$keys[name];
    $27059f7464a1d1f5$var$keys[name] = 0;
    return name + "$";
}
/**
A key is used to [tag](https://prosemirror.net/docs/ref/#state.PluginSpec.key) plugins in a way
that makes it possible to find them, given an editor state.
Assigning a key does mean only one plugin of that type can be
active in a state.
*/ class $27059f7464a1d1f5$export$1692d8b0e89cecc3 {
    /**
    Create a plugin key.
    */ constructor(name = "key"){
        this.key = $27059f7464a1d1f5$var$createKey(name);
    }
    /**
    Get the active plugin with this key, if any, from an editor
    state.
    */ get(state) {
        return state.config.pluginsByKey[this.key];
    }
    /**
    Get the plugin's state from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}

});
parcelRegister("lzEKq", function(module, exports) {
$parcel$export(module.exports, "StepMap", () => $040d9edd1880ca83$export$c53d01c3ab9721b3);
$parcel$export(module.exports, "Mapping", () => $040d9edd1880ca83$export$f5f785078011b62);
$parcel$export(module.exports, "Step", () => $040d9edd1880ca83$export$fd55ce593607084a);
$parcel$export(module.exports, "StepResult", () => $040d9edd1880ca83$export$8ebf1578a4199c09);
$parcel$export(module.exports, "AddMarkStep", () => $040d9edd1880ca83$export$d24ba56b0e3464a9);
$parcel$export(module.exports, "RemoveMarkStep", () => $040d9edd1880ca83$export$94150db1311f67a9);
$parcel$export(module.exports, "AddNodeMarkStep", () => $040d9edd1880ca83$export$adefd16c402fee4e);
$parcel$export(module.exports, "RemoveNodeMarkStep", () => $040d9edd1880ca83$export$fdf7d1dc10724da2);
$parcel$export(module.exports, "ReplaceStep", () => $040d9edd1880ca83$export$5c860b2e74034756);
$parcel$export(module.exports, "ReplaceAroundStep", () => $040d9edd1880ca83$export$444ba800d6024a98);
$parcel$export(module.exports, "liftTarget", () => $040d9edd1880ca83$export$f1508b72cc76a09e);
$parcel$export(module.exports, "findWrapping", () => $040d9edd1880ca83$export$118cb9a83e81ba37);
$parcel$export(module.exports, "canSplit", () => $040d9edd1880ca83$export$5aaf008897aef029);
$parcel$export(module.exports, "canJoin", () => $040d9edd1880ca83$export$f15f89fd9d8cc98a);
$parcel$export(module.exports, "joinPoint", () => $040d9edd1880ca83$export$41b1d4cb5ceb3147);
$parcel$export(module.exports, "insertPoint", () => $040d9edd1880ca83$export$64cb316d02de1dd1);
$parcel$export(module.exports, "dropPoint", () => $040d9edd1880ca83$export$2819d598d048fc9c);
$parcel$export(module.exports, "replaceStep", () => $040d9edd1880ca83$export$ed6ac67359824afd);
$parcel$export(module.exports, "AttrStep", () => $040d9edd1880ca83$export$626399c38172f669);
$parcel$export(module.exports, "DocAttrStep", () => $040d9edd1880ca83$export$f50707b396300ac9);
$parcel$export(module.exports, "Transform", () => $040d9edd1880ca83$export$563a914cafbdc389);

var $3xw6l = parcelRequire("3xw6l");
// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.
const $040d9edd1880ca83$var$lower16 = 0xffff;
const $040d9edd1880ca83$var$factor16 = Math.pow(2, 16);
function $040d9edd1880ca83$var$makeRecover(index, offset) {
    return index + offset * $040d9edd1880ca83$var$factor16;
}
function $040d9edd1880ca83$var$recoverIndex(value) {
    return value & $040d9edd1880ca83$var$lower16;
}
function $040d9edd1880ca83$var$recoverOffset(value) {
    return (value - (value & $040d9edd1880ca83$var$lower16)) / $040d9edd1880ca83$var$factor16;
}
const $040d9edd1880ca83$var$DEL_BEFORE = 1, $040d9edd1880ca83$var$DEL_AFTER = 2, $040d9edd1880ca83$var$DEL_ACROSS = 4, $040d9edd1880ca83$var$DEL_SIDE = 8;
/**
An object representing a mapped position with extra
information.
*/ class $040d9edd1880ca83$export$c77c9be41668e9b4 {
    /**
    @internal
    */ constructor(/**
    The mapped version of the position.
    */ pos, /**
    @internal
    */ delInfo, /**
    @internal
    */ recover){
        this.pos = pos;
        this.delInfo = delInfo;
        this.recover = recover;
    }
    /**
    Tells you whether the position was deleted, that is, whether the
    step removed the token on the side queried (via the `assoc`)
    argument from the document.
    */ get deleted() {
        return (this.delInfo & $040d9edd1880ca83$var$DEL_SIDE) > 0;
    }
    /**
    Tells you whether the token before the mapped position was deleted.
    */ get deletedBefore() {
        return (this.delInfo & ($040d9edd1880ca83$var$DEL_BEFORE | $040d9edd1880ca83$var$DEL_ACROSS)) > 0;
    }
    /**
    True when the token after the mapped position was deleted.
    */ get deletedAfter() {
        return (this.delInfo & ($040d9edd1880ca83$var$DEL_AFTER | $040d9edd1880ca83$var$DEL_ACROSS)) > 0;
    }
    /**
    Tells whether any of the steps mapped through deletes across the
    position (including both the token before and after the
    position).
    */ get deletedAcross() {
        return (this.delInfo & $040d9edd1880ca83$var$DEL_ACROSS) > 0;
    }
}
/**
A map describing the deletions and insertions made by a step, which
can be used to find the correspondence between positions in the
pre-step version of a document and the same position in the
post-step version.
*/ class $040d9edd1880ca83$export$c53d01c3ab9721b3 {
    /**
    Create a position map. The modifications to the document are
    represented as an array of numbers, in which each group of three
    represents a modified chunk as `[start, oldSize, newSize]`.
    */ constructor(/**
    @internal
    */ ranges, /**
    @internal
    */ inverted = false){
        this.ranges = ranges;
        this.inverted = inverted;
        if (!ranges.length && $040d9edd1880ca83$export$c53d01c3ab9721b3.empty) return $040d9edd1880ca83$export$c53d01c3ab9721b3.empty;
    }
    /**
    @internal
    */ recover(value) {
        let diff = 0, index = $040d9edd1880ca83$var$recoverIndex(value);
        if (!this.inverted) for(let i = 0; i < index; i++)diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
        return this.ranges[index * 3] + diff + $040d9edd1880ca83$var$recoverOffset(value);
    }
    mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    map(pos, assoc = 1) {
        return this._map(pos, assoc, true);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
            if (pos <= end) {
                let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
                let result = start + diff + (side < 0 ? 0 : newSize);
                if (simple) return result;
                let recover = pos == (assoc < 0 ? start : end) ? null : $040d9edd1880ca83$var$makeRecover(i / 3, pos - start);
                let del = pos == start ? $040d9edd1880ca83$var$DEL_AFTER : pos == end ? $040d9edd1880ca83$var$DEL_BEFORE : $040d9edd1880ca83$var$DEL_ACROSS;
                if (assoc < 0 ? pos != start : pos != end) del |= $040d9edd1880ca83$var$DEL_SIDE;
                return new $040d9edd1880ca83$export$c77c9be41668e9b4(result, del, recover);
            }
            diff += newSize - oldSize;
        }
        return simple ? pos + diff : new $040d9edd1880ca83$export$c77c9be41668e9b4(pos + diff, 0, null);
    }
    /**
    @internal
    */ touches(pos, recover) {
        let diff = 0, index = $040d9edd1880ca83$var$recoverIndex(recover);
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], end = start + oldSize;
            if (pos <= end && i == index * 3) return true;
            diff += this.ranges[i + newIndex] - oldSize;
        }
        return false;
    }
    /**
    Calls the given function on each of the changed ranges included in
    this map.
    */ forEach(f) {
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0, diff = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
            f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
            diff += newSize - oldSize;
        }
    }
    /**
    Create an inverted version of this map. The result can be used to
    map positions in the post-step document to the pre-step document.
    */ invert() {
        return new $040d9edd1880ca83$export$c53d01c3ab9721b3(this.ranges, !this.inverted);
    }
    /**
    @internal
    */ toString() {
        return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
    }
    /**
    Create a map that moves all positions by offset `n` (which may be
    negative). This can be useful when applying steps meant for a
    sub-document to a larger document, or vice-versa.
    */ static offset(n) {
        return n == 0 ? $040d9edd1880ca83$export$c53d01c3ab9721b3.empty : new $040d9edd1880ca83$export$c53d01c3ab9721b3(n < 0 ? [
            0,
            -n,
            0
        ] : [
            0,
            0,
            n
        ]);
    }
}
/**
A StepMap that contains no changed ranges.
*/ $040d9edd1880ca83$export$c53d01c3ab9721b3.empty = new $040d9edd1880ca83$export$c53d01c3ab9721b3([]);
/**
A mapping represents a pipeline of zero or more [step
maps](https://prosemirror.net/docs/ref/#transform.StepMap). It has special provisions for losslessly
handling mapping positions through a series of steps in which some
steps are inverted versions of earlier steps. (This comes up when
‘[rebasing](/docs/guide/#transform.rebasing)’ steps for
collaboration or history management.)
*/ class $040d9edd1880ca83$export$f5f785078011b62 {
    /**
    Create a new mapping with the given position maps.
    */ constructor(/**
    The step maps in this mapping.
    */ maps = [], /**
    @internal
    */ mirror, /**
    The starting position in the `maps` array, used when `map` or
    `mapResult` is called.
    */ from = 0, /**
    The end position in the `maps` array.
    */ to = maps.length){
        this.maps = maps;
        this.mirror = mirror;
        this.from = from;
        this.to = to;
    }
    /**
    Create a mapping that maps only through a part of this one.
    */ slice(from = 0, to = this.maps.length) {
        return new $040d9edd1880ca83$export$f5f785078011b62(this.maps, this.mirror, from, to);
    }
    /**
    @internal
    */ copy() {
        return new $040d9edd1880ca83$export$f5f785078011b62(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
    }
    /**
    Add a step map to the end of this mapping. If `mirrors` is
    given, it should be the index of the step map that is the mirror
    image of this one.
    */ appendMap(map, mirrors) {
        this.to = this.maps.push(map);
        if (mirrors != null) this.setMirror(this.maps.length - 1, mirrors);
    }
    /**
    Add all the step maps in a given mapping to this one (preserving
    mirroring information).
    */ appendMapping(mapping) {
        for(let i = 0, startSize = this.maps.length; i < mapping.maps.length; i++){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
        }
    }
    /**
    Finds the offset of the step map that mirrors the map at the
    given offset, in this mapping (as per the second argument to
    `appendMap`).
    */ getMirror(n) {
        if (this.mirror) {
            for(let i = 0; i < this.mirror.length; i++)if (this.mirror[i] == n) return this.mirror[i + (i % 2 ? -1 : 1)];
        }
    }
    /**
    @internal
    */ setMirror(n, m) {
        if (!this.mirror) this.mirror = [];
        this.mirror.push(n, m);
    }
    /**
    Append the inverse of the given mapping to this one.
    */ appendMappingInverted(mapping) {
        for(let i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
        }
    }
    /**
    Create an inverted version of this mapping.
    */ invert() {
        let inverse = new $040d9edd1880ca83$export$f5f785078011b62;
        inverse.appendMappingInverted(this);
        return inverse;
    }
    /**
    Map a position through this mapping.
    */ map(pos, assoc = 1) {
        if (this.mirror) return this._map(pos, assoc, true);
        for(let i = this.from; i < this.to; i++)pos = this.maps[i].map(pos, assoc);
        return pos;
    }
    /**
    Map a position through this mapping, returning a mapping
    result.
    */ mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let delInfo = 0;
        for(let i = this.from; i < this.to; i++){
            let map = this.maps[i], result = map.mapResult(pos, assoc);
            if (result.recover != null) {
                let corr = this.getMirror(i);
                if (corr != null && corr > i && corr < this.to) {
                    i = corr;
                    pos = this.maps[corr].recover(result.recover);
                    continue;
                }
            }
            delInfo |= result.delInfo;
            pos = result.pos;
        }
        return simple ? pos : new $040d9edd1880ca83$export$c77c9be41668e9b4(pos, delInfo, null);
    }
}
const $040d9edd1880ca83$var$stepsByID = Object.create(null);
/**
A step object represents an atomic change. It generally applies
only to the document it was created for, since the positions
stored in it will only make sense for that document.

New steps are defined by creating classes that extend `Step`,
overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
methods, and registering your class with a unique
JSON-serialization identifier using
[`Step.jsonID`](https://prosemirror.net/docs/ref/#transform.Step^jsonID).
*/ class $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Get the step map that represents the changes made by this step,
    and which can be used to transform between positions in the old
    and the new document.
    */ getMap() {
        return $040d9edd1880ca83$export$c53d01c3ab9721b3.empty;
    }
    /**
    Try to merge this step with another one, to be applied directly
    after it. Returns the merged step when possible, null if the
    steps can't be merged.
    */ merge(other) {
        return null;
    }
    /**
    Deserialize a step from its JSON representation. Will call
    through to the step class' own implementation of this method.
    */ static fromJSON(schema, json) {
        if (!json || !json.stepType) throw new RangeError("Invalid input for Step.fromJSON");
        let type = $040d9edd1880ca83$var$stepsByID[json.stepType];
        if (!type) throw new RangeError(`No step type ${json.stepType} defined`);
        return type.fromJSON(schema, json);
    }
    /**
    To be able to serialize steps to JSON, each step needs a string
    ID to attach to its JSON representation. Use this method to
    register an ID for your step classes. Try to pick something
    that's unlikely to clash with steps from other modules.
    */ static jsonID(id, stepClass) {
        if (id in $040d9edd1880ca83$var$stepsByID) throw new RangeError("Duplicate use of step JSON ID " + id);
        $040d9edd1880ca83$var$stepsByID[id] = stepClass;
        stepClass.prototype.jsonID = id;
        return stepClass;
    }
}
/**
The result of [applying](https://prosemirror.net/docs/ref/#transform.Step.apply) a step. Contains either a
new document or a failure value.
*/ class $040d9edd1880ca83$export$8ebf1578a4199c09 {
    /**
    @internal
    */ constructor(/**
    The transformed document, if successful.
    */ doc, /**
    The failure message, if unsuccessful.
    */ failed){
        this.doc = doc;
        this.failed = failed;
    }
    /**
    Create a successful step result.
    */ static ok(doc) {
        return new $040d9edd1880ca83$export$8ebf1578a4199c09(doc, null);
    }
    /**
    Create a failed step result.
    */ static fail(message) {
        return new $040d9edd1880ca83$export$8ebf1578a4199c09(null, message);
    }
    /**
    Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
    arguments. Create a successful result if it succeeds, and a
    failed one if it throws a `ReplaceError`.
    */ static fromReplace(doc, from, to, slice) {
        try {
            return $040d9edd1880ca83$export$8ebf1578a4199c09.ok(doc.replace(from, to, slice));
        } catch (e) {
            if (e instanceof (0, $3xw6l.ReplaceError)) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail(e.message);
            throw e;
        }
    }
}
function $040d9edd1880ca83$var$mapFragment(fragment, f, parent) {
    let mapped = [];
    for(let i = 0; i < fragment.childCount; i++){
        let child = fragment.child(i);
        if (child.content.size) child = child.copy($040d9edd1880ca83$var$mapFragment(child.content, f, child));
        if (child.isInline) child = f(child, parent, i);
        mapped.push(child);
    }
    return (0, $3xw6l.Fragment).fromArray(mapped);
}
/**
Add a mark to all inline content between two positions.
*/ class $040d9edd1880ca83$export$d24ba56b0e3464a9 extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Create a mark step.
    */ constructor(/**
    The start of the marked range.
    */ from, /**
    The end of the marked range.
    */ to, /**
    The mark to add.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
        let parent = $from.node($from.sharedDepth(this.to));
        let slice = new (0, $3xw6l.Slice)($040d9edd1880ca83$var$mapFragment(oldSlice.content, (node, parent)=>{
            if (!node.isAtom || !parent.type.allowsMarkType(this.mark.type)) return node;
            return node.mark(this.mark.addToSet(node.marks));
        }, parent), oldSlice.openStart, oldSlice.openEnd);
        return $040d9edd1880ca83$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $040d9edd1880ca83$export$94150db1311f67a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $040d9edd1880ca83$export$d24ba56b0e3464a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $040d9edd1880ca83$export$d24ba56b0e3464a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $040d9edd1880ca83$export$d24ba56b0e3464a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "addMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for AddMarkStep.fromJSON");
        return new $040d9edd1880ca83$export$d24ba56b0e3464a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("addMark", $040d9edd1880ca83$export$d24ba56b0e3464a9);
/**
Remove a mark from all inline content between two positions.
*/ class $040d9edd1880ca83$export$94150db1311f67a9 extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The start of the unmarked range.
    */ from, /**
    The end of the unmarked range.
    */ to, /**
    The mark to remove.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to);
        let slice = new (0, $3xw6l.Slice)($040d9edd1880ca83$var$mapFragment(oldSlice.content, (node)=>{
            return node.mark(this.mark.removeFromSet(node.marks));
        }, doc), oldSlice.openStart, oldSlice.openEnd);
        return $040d9edd1880ca83$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $040d9edd1880ca83$export$d24ba56b0e3464a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $040d9edd1880ca83$export$94150db1311f67a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $040d9edd1880ca83$export$94150db1311f67a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $040d9edd1880ca83$export$94150db1311f67a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "removeMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
        return new $040d9edd1880ca83$export$94150db1311f67a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("removeMark", $040d9edd1880ca83$export$94150db1311f67a9);
/**
Add a mark to a specific node.
*/ class $040d9edd1880ca83$export$adefd16c402fee4e extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Create a node mark step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to add.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
        return $040d9edd1880ca83$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (node) {
            let newSet = this.mark.addToSet(node.marks);
            if (newSet.length == node.marks.length) {
                for(let i = 0; i < node.marks.length; i++)if (!node.marks[i].isInSet(newSet)) return new $040d9edd1880ca83$export$adefd16c402fee4e(this.pos, node.marks[i]);
                return new $040d9edd1880ca83$export$adefd16c402fee4e(this.pos, this.mark);
            }
        }
        return new $040d9edd1880ca83$export$fdf7d1dc10724da2(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $040d9edd1880ca83$export$adefd16c402fee4e(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "addNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
        return new $040d9edd1880ca83$export$adefd16c402fee4e(json.pos, schema.markFromJSON(json.mark));
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("addNodeMark", $040d9edd1880ca83$export$adefd16c402fee4e);
/**
Remove a mark from a specific node.
*/ class $040d9edd1880ca83$export$fdf7d1dc10724da2 extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to remove.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
        return $040d9edd1880ca83$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node || !this.mark.isInSet(node.marks)) return this;
        return new $040d9edd1880ca83$export$adefd16c402fee4e(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $040d9edd1880ca83$export$fdf7d1dc10724da2(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "removeNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
        return new $040d9edd1880ca83$export$fdf7d1dc10724da2(json.pos, schema.markFromJSON(json.mark));
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("removeNodeMark", $040d9edd1880ca83$export$fdf7d1dc10724da2);
/**
Replace a part of the document with a slice of new content.
*/ class $040d9edd1880ca83$export$5c860b2e74034756 extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    The given `slice` should fit the 'gap' between `from` and
    `to`—the depths must line up, and the surrounding nodes must be
    able to be joined with the open sides of the slice. When
    `structure` is true, the step will fail if the content between
    from and to is not just a sequence of closing and then opening
    tokens (this is to guard against rebased replace steps
    overwriting something they weren't supposed to).
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The slice to insert.
    */ slice, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.slice = slice;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && $040d9edd1880ca83$var$contentBetween(doc, this.from, this.to)) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail("Structure replace would overwrite content");
        return $040d9edd1880ca83$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, this.slice);
    }
    getMap() {
        return new $040d9edd1880ca83$export$c53d01c3ab9721b3([
            this.from,
            this.to - this.from,
            this.slice.size
        ]);
    }
    invert(doc) {
        return new $040d9edd1880ca83$export$5c860b2e74034756(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deletedAcross && to.deletedAcross) return null;
        return new $040d9edd1880ca83$export$5c860b2e74034756(from.pos, Math.max(from.pos, to.pos), this.slice);
    }
    merge(other) {
        if (!(other instanceof $040d9edd1880ca83$export$5c860b2e74034756) || other.structure || this.structure) return null;
        if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $3xw6l.Slice).empty : new (0, $3xw6l.Slice)(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
            return new $040d9edd1880ca83$export$5c860b2e74034756(this.from, this.to + (other.to - other.from), slice, this.structure);
        } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $3xw6l.Slice).empty : new (0, $3xw6l.Slice)(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
            return new $040d9edd1880ca83$export$5c860b2e74034756(other.from, this.to, slice, this.structure);
        } else return null;
    }
    toJSON() {
        let json = {
            stepType: "replace",
            from: this.from,
            to: this.to
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for ReplaceStep.fromJSON");
        return new $040d9edd1880ca83$export$5c860b2e74034756(json.from, json.to, (0, $3xw6l.Slice).fromJSON(schema, json.slice), !!json.structure);
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("replace", $040d9edd1880ca83$export$5c860b2e74034756);
/**
Replace a part of the document with a slice of content, but
preserve a range of the replaced content by moving it into the
slice.
*/ class $040d9edd1880ca83$export$444ba800d6024a98 extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Create a replace-around step with the given range and gap.
    `insert` should be the point in the slice into which the content
    of the gap should be moved. `structure` has the same meaning as
    it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The start of preserved range.
    */ gapFrom, /**
    The end of preserved range.
    */ gapTo, /**
    The slice to insert.
    */ slice, /**
    The position in the slice where the preserved range should be
    inserted.
    */ insert, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.gapFrom = gapFrom;
        this.gapTo = gapTo;
        this.slice = slice;
        this.insert = insert;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && ($040d9edd1880ca83$var$contentBetween(doc, this.from, this.gapFrom) || $040d9edd1880ca83$var$contentBetween(doc, this.gapTo, this.to))) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail("Structure gap-replace would overwrite content");
        let gap = doc.slice(this.gapFrom, this.gapTo);
        if (gap.openStart || gap.openEnd) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail("Gap is not a flat range");
        let inserted = this.slice.insertAt(this.insert, gap.content);
        if (!inserted) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail("Content does not fit in gap");
        return $040d9edd1880ca83$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, inserted);
    }
    getMap() {
        return new $040d9edd1880ca83$export$c53d01c3ab9721b3([
            this.from,
            this.gapFrom - this.from,
            this.insert,
            this.gapTo,
            this.to - this.gapTo,
            this.slice.size - this.insert
        ]);
    }
    invert(doc) {
        let gap = this.gapTo - this.gapFrom;
        return new $040d9edd1880ca83$export$444ba800d6024a98(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        let gapFrom = this.from == this.gapFrom ? from.pos : mapping.map(this.gapFrom, -1);
        let gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
        if (from.deletedAcross && to.deletedAcross || gapFrom < from.pos || gapTo > to.pos) return null;
        return new $040d9edd1880ca83$export$444ba800d6024a98(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
    }
    toJSON() {
        let json = {
            stepType: "replaceAround",
            from: this.from,
            to: this.to,
            gapFrom: this.gapFrom,
            gapTo: this.gapTo,
            insert: this.insert
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
        return new $040d9edd1880ca83$export$444ba800d6024a98(json.from, json.to, json.gapFrom, json.gapTo, (0, $3xw6l.Slice).fromJSON(schema, json.slice), json.insert, !!json.structure);
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("replaceAround", $040d9edd1880ca83$export$444ba800d6024a98);
function $040d9edd1880ca83$var$contentBetween(doc, from, to) {
    let $from = doc.resolve(from), dist = to - from, depth = $from.depth;
    while(dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount){
        depth--;
        dist--;
    }
    if (dist > 0) {
        let next = $from.node(depth).maybeChild($from.indexAfter(depth));
        while(dist > 0){
            if (!next || next.isLeaf) return true;
            next = next.firstChild;
            dist--;
        }
    }
    return false;
}
function $040d9edd1880ca83$var$addMark(tr, from, to, mark) {
    let removed = [], added = [];
    let removing, adding;
    tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (!node.isInline) return;
        let marks = node.marks;
        if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
            let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
            let newSet = mark.addToSet(marks);
            for(let i = 0; i < marks.length; i++)if (!marks[i].isInSet(newSet)) {
                if (removing && removing.to == start && removing.mark.eq(marks[i])) removing.to = end;
                else removed.push(removing = new $040d9edd1880ca83$export$94150db1311f67a9(start, end, marks[i]));
            }
            if (adding && adding.to == start) adding.to = end;
            else added.push(adding = new $040d9edd1880ca83$export$d24ba56b0e3464a9(start, end, mark));
        }
    });
    removed.forEach((s)=>tr.step(s));
    added.forEach((s)=>tr.step(s));
}
function $040d9edd1880ca83$var$removeMark(tr, from, to, mark) {
    let matched = [], step = 0;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isInline) return;
        step++;
        let toRemove = null;
        if (mark instanceof (0, $3xw6l.MarkType)) {
            let set = node.marks, found;
            while(found = mark.isInSet(set)){
                (toRemove || (toRemove = [])).push(found);
                set = found.removeFromSet(set);
            }
        } else if (mark) {
            if (mark.isInSet(node.marks)) toRemove = [
                mark
            ];
        } else toRemove = node.marks;
        if (toRemove && toRemove.length) {
            let end = Math.min(pos + node.nodeSize, to);
            for(let i = 0; i < toRemove.length; i++){
                let style = toRemove[i], found;
                for(let j = 0; j < matched.length; j++){
                    let m = matched[j];
                    if (m.step == step - 1 && style.eq(matched[j].style)) found = m;
                }
                if (found) {
                    found.to = end;
                    found.step = step;
                } else matched.push({
                    style: style,
                    from: Math.max(pos, from),
                    to: end,
                    step: step
                });
            }
        }
    });
    matched.forEach((m)=>tr.step(new $040d9edd1880ca83$export$94150db1311f67a9(m.from, m.to, m.style)));
}
function $040d9edd1880ca83$var$clearIncompatible(tr, pos, parentType, match = parentType.contentMatch, clearNewlines = true) {
    let node = tr.doc.nodeAt(pos);
    let replSteps = [], cur = pos + 1;
    for(let i = 0; i < node.childCount; i++){
        let child = node.child(i), end = cur + child.nodeSize;
        let allowed = match.matchType(child.type);
        if (!allowed) replSteps.push(new $040d9edd1880ca83$export$5c860b2e74034756(cur, end, (0, $3xw6l.Slice).empty));
        else {
            match = allowed;
            for(let j = 0; j < child.marks.length; j++)if (!parentType.allowsMarkType(child.marks[j].type)) tr.step(new $040d9edd1880ca83$export$94150db1311f67a9(cur, end, child.marks[j]));
            if (clearNewlines && child.isText && parentType.whitespace != "pre") {
                let m, newline = /\r?\n|\r/g, slice;
                while(m = newline.exec(child.text)){
                    if (!slice) slice = new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
                    replSteps.push(new $040d9edd1880ca83$export$5c860b2e74034756(cur + m.index, cur + m.index + m[0].length, slice));
                }
            }
        }
        cur = end;
    }
    if (!match.validEnd) {
        let fill = match.fillBefore((0, $3xw6l.Fragment).empty, true);
        tr.replace(cur, cur, new (0, $3xw6l.Slice)(fill, 0, 0));
    }
    for(let i = replSteps.length - 1; i >= 0; i--)tr.step(replSteps[i]);
}
function $040d9edd1880ca83$var$canCut(node, start, end) {
    return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
}
/**
Try to find a target depth to which the content in the given range
can be lifted. Will not go across
[isolating](https://prosemirror.net/docs/ref/#model.NodeSpec.isolating) parent nodes.
*/ function $040d9edd1880ca83$export$f1508b72cc76a09e(range) {
    let parent = range.parent;
    let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
    for(let depth = range.depth;; --depth){
        let node = range.$from.node(depth);
        let index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
        if (depth < range.depth && node.canReplace(index, endIndex, content)) return depth;
        if (depth == 0 || node.type.spec.isolating || !$040d9edd1880ca83$var$canCut(node, index, endIndex)) break;
    }
    return null;
}
function $040d9edd1880ca83$var$lift(tr, range, target) {
    let { $from: $from, $to: $to, depth: depth } = range;
    let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
    let start = gapStart, end = gapEnd;
    let before = (0, $3xw6l.Fragment).empty, openStart = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $from.index(d) > 0) {
        splitting = true;
        before = (0, $3xw6l.Fragment).from($from.node(d).copy(before));
        openStart++;
    } else start--;
    let after = (0, $3xw6l.Fragment).empty, openEnd = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $to.after(d + 1) < $to.end(d)) {
        splitting = true;
        after = (0, $3xw6l.Fragment).from($to.node(d).copy(after));
        openEnd++;
    } else end++;
    tr.step(new $040d9edd1880ca83$export$444ba800d6024a98(start, end, gapStart, gapEnd, new (0, $3xw6l.Slice)(before.append(after), openStart, openEnd), before.size - openStart, true));
}
/**
Try to find a valid way to wrap the content in the given range in a
node of the given type. May introduce extra nodes around and inside
the wrapper node, if necessary. Returns null if no valid wrapping
could be found. When `innerRange` is given, that range's content is
used as the content to fit into the wrapping, instead of the
content of `range`.
*/ function $040d9edd1880ca83$export$118cb9a83e81ba37(range, nodeType, attrs = null, innerRange = range) {
    let around = $040d9edd1880ca83$var$findWrappingOutside(range, nodeType);
    let inner = around && $040d9edd1880ca83$var$findWrappingInside(innerRange, nodeType);
    if (!inner) return null;
    return around.map($040d9edd1880ca83$var$withAttrs).concat({
        type: nodeType,
        attrs: attrs
    }).concat(inner.map($040d9edd1880ca83$var$withAttrs));
}
function $040d9edd1880ca83$var$withAttrs(type) {
    return {
        type: type,
        attrs: null
    };
}
function $040d9edd1880ca83$var$findWrappingOutside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let around = parent.contentMatchAt(startIndex).findWrapping(type);
    if (!around) return null;
    let outer = around.length ? around[0] : type;
    return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
}
function $040d9edd1880ca83$var$findWrappingInside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let inner = parent.child(startIndex);
    let inside = type.contentMatch.findWrapping(inner.type);
    if (!inside) return null;
    let lastType = inside.length ? inside[inside.length - 1] : type;
    let innerMatch = lastType.contentMatch;
    for(let i = startIndex; innerMatch && i < endIndex; i++)innerMatch = innerMatch.matchType(parent.child(i).type);
    if (!innerMatch || !innerMatch.validEnd) return null;
    return inside;
}
function $040d9edd1880ca83$var$wrap(tr, range, wrappers) {
    let content = (0, $3xw6l.Fragment).empty;
    for(let i = wrappers.length - 1; i >= 0; i--){
        if (content.size) {
            let match = wrappers[i].type.contentMatch.matchFragment(content);
            if (!match || !match.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
        }
        content = (0, $3xw6l.Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
    }
    let start = range.start, end = range.end;
    tr.step(new $040d9edd1880ca83$export$444ba800d6024a98(start, end, start, end, new (0, $3xw6l.Slice)(content, 0, 0), wrappers.length, true));
}
function $040d9edd1880ca83$var$setBlockType(tr, from, to, type, attrs) {
    if (!type.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
    let mapFrom = tr.steps.length;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        let attrsHere = typeof attrs == "function" ? attrs(node) : attrs;
        if (node.isTextblock && !node.hasMarkup(type, attrsHere) && $040d9edd1880ca83$var$canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
            let convertNewlines = null;
            if (type.schema.linebreakReplacement) {
                let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
                if (pre && !supportLinebreak) convertNewlines = false;
                else if (!pre && supportLinebreak) convertNewlines = true;
            }
            // Ensure all markup that isn't allowed in the new node type is cleared
            if (convertNewlines === false) $040d9edd1880ca83$var$replaceLinebreaks(tr, node, pos, mapFrom);
            $040d9edd1880ca83$var$clearIncompatible(tr, tr.mapping.slice(mapFrom).map(pos, 1), type, undefined, convertNewlines === null);
            let mapping = tr.mapping.slice(mapFrom);
            let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
            tr.step(new $040d9edd1880ca83$export$444ba800d6024a98(startM, endM, startM + 1, endM - 1, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(type.create(attrsHere, null, node.marks)), 0, 0), 1, true));
            if (convertNewlines === true) $040d9edd1880ca83$var$replaceNewlines(tr, node, pos, mapFrom);
            return false;
        }
    });
}
function $040d9edd1880ca83$var$replaceNewlines(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.isText) {
            let m, newline = /\r?\n|\r/g;
            while(m = newline.exec(child.text)){
                let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index);
                tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement.create());
            }
        }
    });
}
function $040d9edd1880ca83$var$replaceLinebreaks(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.type == child.type.schema.linebreakReplacement) {
            let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset);
            tr.replaceWith(start, start + 1, node.type.schema.text("\n"));
        }
    });
}
function $040d9edd1880ca83$var$canChangeType(doc, pos, type) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $pos.parent.canReplaceWith(index, index + 1, type);
}
/**
Change the type, attributes, and/or marks of the node at `pos`.
When `type` isn't given, the existing node type is preserved,
*/ function $040d9edd1880ca83$var$setNodeMarkup(tr, pos, type, attrs, marks) {
    let node = tr.doc.nodeAt(pos);
    if (!node) throw new RangeError("No node at given position");
    if (!type) type = node.type;
    let newNode = type.create(attrs, null, marks || node.marks);
    if (node.isLeaf) return tr.replaceWith(pos, pos + node.nodeSize, newNode);
    if (!type.validContent(node.content)) throw new RangeError("Invalid content for node type " + type.name);
    tr.step(new $040d9edd1880ca83$export$444ba800d6024a98(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(newNode), 0, 0), 1, true));
}
/**
Check whether splitting at the given position is allowed.
*/ function $040d9edd1880ca83$export$5aaf008897aef029(doc, pos, depth = 1, typesAfter) {
    let $pos = doc.resolve(pos), base = $pos.depth - depth;
    let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
    if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;
    for(let d = $pos.depth - 1, i = depth - 2; d > base; d--, i--){
        let node = $pos.node(d), index = $pos.index(d);
        if (node.type.spec.isolating) return false;
        let rest = node.content.cutByIndex(index, node.childCount);
        let overrideChild = typesAfter && typesAfter[i + 1];
        if (overrideChild) rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
        let after = typesAfter && typesAfter[i] || node;
        if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest)) return false;
    }
    let index = $pos.indexAfter(base);
    let baseType = typesAfter && typesAfter[0];
    return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
}
function $040d9edd1880ca83$var$split(tr, pos, depth = 1, typesAfter) {
    let $pos = tr.doc.resolve(pos), before = (0, $3xw6l.Fragment).empty, after = (0, $3xw6l.Fragment).empty;
    for(let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--){
        before = (0, $3xw6l.Fragment).from($pos.node(d).copy(before));
        let typeAfter = typesAfter && typesAfter[i];
        after = (0, $3xw6l.Fragment).from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
    }
    tr.step(new $040d9edd1880ca83$export$5c860b2e74034756(pos, pos, new (0, $3xw6l.Slice)(before.append(after), depth, depth), true));
}
/**
Test whether the blocks before and after a given position can be
joined.
*/ function $040d9edd1880ca83$export$f15f89fd9d8cc98a(doc, pos) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $040d9edd1880ca83$var$joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
}
function $040d9edd1880ca83$var$canAppendWithSubstitutedLinebreaks(a, b) {
    if (!b.content.size) a.type.compatibleContent(b.type);
    let match = a.contentMatchAt(a.childCount);
    let { linebreakReplacement: linebreakReplacement } = a.type.schema;
    for(let i = 0; i < b.childCount; i++){
        let child = b.child(i);
        let type = child.type == linebreakReplacement ? a.type.schema.nodes.text : child.type;
        match = match.matchType(type);
        if (!match) return false;
        if (!a.type.allowsMarks(child.marks)) return false;
    }
    return match.validEnd;
}
function $040d9edd1880ca83$var$joinable(a, b) {
    return !!(a && b && !a.isLeaf && $040d9edd1880ca83$var$canAppendWithSubstitutedLinebreaks(a, b));
}
/**
Find an ancestor of the given position that can be joined to the
block before (or after if `dir` is positive). Returns the joinable
point, if any.
*/ function $040d9edd1880ca83$export$41b1d4cb5ceb3147(doc, pos, dir = -1) {
    let $pos = doc.resolve(pos);
    for(let d = $pos.depth;; d--){
        let before, after, index = $pos.index(d);
        if (d == $pos.depth) {
            before = $pos.nodeBefore;
            after = $pos.nodeAfter;
        } else if (dir > 0) {
            before = $pos.node(d + 1);
            index++;
            after = $pos.node(d).maybeChild(index);
        } else {
            before = $pos.node(d).maybeChild(index - 1);
            after = $pos.node(d + 1);
        }
        if (before && !before.isTextblock && $040d9edd1880ca83$var$joinable(before, after) && $pos.node(d).canReplace(index, index + 1)) return pos;
        if (d == 0) break;
        pos = dir < 0 ? $pos.before(d) : $pos.after(d);
    }
}
function $040d9edd1880ca83$var$join(tr, pos, depth) {
    let convertNewlines = null;
    let { linebreakReplacement: linebreakReplacement } = tr.doc.type.schema;
    let $before = tr.doc.resolve(pos - depth), beforeType = $before.node().type;
    if (linebreakReplacement && beforeType.inlineContent) {
        let pre = beforeType.whitespace == "pre";
        let supportLinebreak = !!beforeType.contentMatch.matchType(linebreakReplacement);
        if (pre && !supportLinebreak) convertNewlines = false;
        else if (!pre && supportLinebreak) convertNewlines = true;
    }
    let mapFrom = tr.steps.length;
    if (convertNewlines === false) {
        let $after = tr.doc.resolve(pos + depth);
        $040d9edd1880ca83$var$replaceLinebreaks(tr, $after.node(), $after.before(), mapFrom);
    }
    if (beforeType.inlineContent) $040d9edd1880ca83$var$clearIncompatible(tr, pos + depth - 1, beforeType, $before.node().contentMatchAt($before.index()), convertNewlines == null);
    let mapping = tr.mapping.slice(mapFrom), start = mapping.map(pos - depth);
    tr.step(new $040d9edd1880ca83$export$5c860b2e74034756(start, mapping.map(pos + depth, -1), (0, $3xw6l.Slice).empty, true));
    if (convertNewlines === true) {
        let $full = tr.doc.resolve(start);
        $040d9edd1880ca83$var$replaceNewlines(tr, $full.node(), $full.before(), tr.steps.length);
    }
    return tr;
}
/**
Try to find a point where a node of the given type can be inserted
near `pos`, by searching up the node hierarchy when `pos` itself
isn't a valid place but is at the start or end of a node. Return
null if no position was found.
*/ function $040d9edd1880ca83$export$64cb316d02de1dd1(doc, pos, nodeType) {
    let $pos = doc.resolve(pos);
    if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) return pos;
    if ($pos.parentOffset == 0) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.index(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.before(d + 1);
        if (index > 0) return null;
    }
    if ($pos.parentOffset == $pos.parent.content.size) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.indexAfter(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.after(d + 1);
        if (index < $pos.node(d).childCount) return null;
    }
    return null;
}
/**
Finds a position at or around the given position where the given
slice can be inserted. Will look at parent nodes' nearest boundary
and try there, even if the original position wasn't directly at the
start or end of that node. Returns null when no position was found.
*/ function $040d9edd1880ca83$export$2819d598d048fc9c(doc, pos, slice) {
    let $pos = doc.resolve(pos);
    if (!slice.content.size) return pos;
    let content = slice.content;
    for(let i = 0; i < slice.openStart; i++)content = content.firstChild.content;
    for(let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++)for(let d = $pos.depth; d >= 0; d--){
        let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
        let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
        let parent = $pos.node(d), fits = false;
        if (pass == 1) fits = parent.canReplace(insertPos, insertPos, content);
        else {
            let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
            fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
        }
        if (fits) return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
    }
    return null;
}
/**
‘Fit’ a slice into a given position in the document, producing a
[step](https://prosemirror.net/docs/ref/#transform.Step) that inserts it. Will return null if
there's no meaningful way to insert the slice here, or inserting it
would be a no-op (an empty slice over an empty range).
*/ function $040d9edd1880ca83$export$ed6ac67359824afd(doc, from, to = from, slice = (0, $3xw6l.Slice).empty) {
    if (from == to && !slice.size) return null;
    let $from = doc.resolve(from), $to = doc.resolve(to);
    // Optimization -- avoid work if it's obvious that it's not needed.
    if ($040d9edd1880ca83$var$fitsTrivially($from, $to, slice)) return new $040d9edd1880ca83$export$5c860b2e74034756(from, to, slice);
    return new $040d9edd1880ca83$var$Fitter($from, $to, slice).fit();
}
function $040d9edd1880ca83$var$fitsTrivially($from, $to, slice) {
    return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
}
// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// This class tracks the state of the placement progress in the
// following properties:
//
//  - `frontier` holds a stack of `{type, match}` objects that
//    represent the open side of the replacement. It starts at
//    `$from`, then moves forward as content is placed, and is finally
//    reconciled with `$to`.
//
//  - `unplaced` is a slice that represents the content that hasn't
//    been placed yet.
//
//  - `placed` is a fragment of placed content. Its open-start value
//    is implicit in `$from`, and its open-end value in `frontier`.
class $040d9edd1880ca83$var$Fitter {
    constructor($from, $to, unplaced){
        this.$from = $from;
        this.$to = $to;
        this.unplaced = unplaced;
        this.frontier = [];
        this.placed = (0, $3xw6l.Fragment).empty;
        for(let i = 0; i <= $from.depth; i++){
            let node = $from.node(i);
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt($from.indexAfter(i))
            });
        }
        for(let i = $from.depth; i > 0; i--)this.placed = (0, $3xw6l.Fragment).from($from.node(i).copy(this.placed));
    }
    get depth() {
        return this.frontier.length - 1;
    }
    fit() {
        // As long as there's unplaced content, try to place some of it.
        // If that fails, either increase the open score of the unplaced
        // slice, or drop nodes from it, and then try again.
        while(this.unplaced.size){
            let fit = this.findFittable();
            if (fit) this.placeNodes(fit);
            else this.openMore() || this.dropNode();
        }
        // When there's inline content directly after the frontier _and_
        // directly after `this.$to`, we must generate a `ReplaceAround`
        // step that pulls that content into the node after the frontier.
        // That means the fitting must be done to the end of the textblock
        // node after `this.$to`, not `this.$to` itself.
        let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
        let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
        if (!$to) return null;
        // If closing to `$to` succeeded, create a step
        let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
        while(openStart && openEnd && content.childCount == 1){
            content = content.firstChild.content;
            openStart--;
            openEnd--;
        }
        let slice = new (0, $3xw6l.Slice)(content, openStart, openEnd);
        if (moveInline > -1) return new $040d9edd1880ca83$export$444ba800d6024a98($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
        if (slice.size || $from.pos != this.$to.pos) return new $040d9edd1880ca83$export$5c860b2e74034756($from.pos, $to.pos, slice);
        return null;
    }
    // Find a position on the start spine of `this.unplaced` that has
    // content that can be moved somewhere on the frontier. Returns two
    // depths, one for the slice and one for the frontier.
    findFittable() {
        let startDepth = this.unplaced.openStart;
        for(let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++){
            let node = cur.firstChild;
            if (cur.childCount > 1) openEnd = 0;
            if (node.type.spec.isolating && openEnd <= d) {
                startDepth = d;
                break;
            }
            cur = node.content;
        }
        // Only try wrapping nodes (pass 2) after finding a place without
        // wrapping failed.
        for(let pass = 1; pass <= 2; pass++)for(let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--){
            let fragment, parent = null;
            if (sliceDepth) {
                parent = $040d9edd1880ca83$var$contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
                fragment = parent.content;
            } else fragment = this.unplaced.content;
            let first = fragment.firstChild;
            for(let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--){
                let { type: type, match: match } = this.frontier[frontierDepth], wrap, inject = null;
                // In pass 1, if the next node matches, or there is no next
                // node but the parents look compatible, we've found a
                // place.
                if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore((0, $3xw6l.Fragment).from(first), false)) : parent && type.compatibleContent(parent.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    inject: inject
                };
                else if (pass == 2 && first && (wrap = match.findWrapping(first.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    wrap: wrap
                };
                // Don't continue looking further up if the parent node
                // would fit here.
                if (parent && match.matchType(parent.type)) break;
            }
        }
    }
    openMore() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $040d9edd1880ca83$var$contentAt(content, openStart);
        if (!inner.childCount || inner.firstChild.isLeaf) return false;
        this.unplaced = new (0, $3xw6l.Slice)(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
        return true;
    }
    dropNode() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $040d9edd1880ca83$var$contentAt(content, openStart);
        if (inner.childCount <= 1 && openStart > 0) {
            let openAtEnd = content.size - openStart <= openStart + inner.size;
            this.unplaced = new (0, $3xw6l.Slice)($040d9edd1880ca83$var$dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
        } else this.unplaced = new (0, $3xw6l.Slice)($040d9edd1880ca83$var$dropFromFragment(content, openStart, 1), openStart, openEnd);
    }
    // Move content from the unplaced slice at `sliceDepth` to the
    // frontier node at `frontierDepth`. Close that frontier node when
    // applicable.
    placeNodes({ sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, inject: inject, wrap: wrap }) {
        while(this.depth > frontierDepth)this.closeFrontierNode();
        if (wrap) for(let i = 0; i < wrap.length; i++)this.openFrontierNode(wrap[i]);
        let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
        let openStart = slice.openStart - sliceDepth;
        let taken = 0, add = [];
        let { match: match, type: type } = this.frontier[frontierDepth];
        if (inject) {
            for(let i = 0; i < inject.childCount; i++)add.push(inject.child(i));
            match = match.matchFragment(inject);
        }
        // Computes the amount of (end) open nodes at the end of the
        // fragment. When 0, the parent is open, but no more. When
        // negative, nothing is open.
        let openEndCount = fragment.size + sliceDepth - (slice.content.size - slice.openEnd);
        // Scan over the fragment, fitting as many child nodes as
        // possible.
        while(taken < fragment.childCount){
            let next = fragment.child(taken), matches = match.matchType(next.type);
            if (!matches) break;
            taken++;
            if (taken > 1 || openStart == 0 || next.content.size) {
                match = matches;
                add.push($040d9edd1880ca83$var$closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
            }
        }
        let toEnd = taken == fragment.childCount;
        if (!toEnd) openEndCount = -1;
        this.placed = $040d9edd1880ca83$var$addToFragment(this.placed, frontierDepth, (0, $3xw6l.Fragment).from(add));
        this.frontier[frontierDepth].match = match;
        // If the parent types match, and the entire node was moved, and
        // it's not open, close this frontier node right away.
        if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) this.closeFrontierNode();
        // Add new frontier nodes for any open nodes at the end.
        for(let i = 0, cur = fragment; i < openEndCount; i++){
            let node = cur.lastChild;
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt(node.childCount)
            });
            cur = node.content;
        }
        // Update `this.unplaced`. Drop the entire node from which we
        // placed it we got to its end, otherwise just drop the placed
        // nodes.
        this.unplaced = !toEnd ? new (0, $3xw6l.Slice)($040d9edd1880ca83$var$dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd) : sliceDepth == 0 ? (0, $3xw6l.Slice).empty : new (0, $3xw6l.Slice)($040d9edd1880ca83$var$dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
    }
    mustMoveInline() {
        if (!this.$to.parent.isTextblock) return -1;
        let top = this.frontier[this.depth], level;
        if (!top.type.isTextblock || !$040d9edd1880ca83$var$contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) return -1;
        let { depth: depth } = this.$to, after = this.$to.after(depth);
        while(depth > 1 && after == this.$to.end(--depth))++after;
        return after;
    }
    findCloseLevel($to) {
        scan: for(let i = Math.min(this.depth, $to.depth); i >= 0; i--){
            let { match: match, type: type } = this.frontier[i];
            let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
            let fit = $040d9edd1880ca83$var$contentAfterFits($to, i, type, match, dropInner);
            if (!fit) continue;
            for(let d = i - 1; d >= 0; d--){
                let { match: match, type: type } = this.frontier[d];
                let matches = $040d9edd1880ca83$var$contentAfterFits($to, d, type, match, true);
                if (!matches || matches.childCount) continue scan;
            }
            return {
                depth: i,
                fit: fit,
                move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to
            };
        }
    }
    close($to) {
        let close = this.findCloseLevel($to);
        if (!close) return null;
        while(this.depth > close.depth)this.closeFrontierNode();
        if (close.fit.childCount) this.placed = $040d9edd1880ca83$var$addToFragment(this.placed, close.depth, close.fit);
        $to = close.move;
        for(let d = close.depth + 1; d <= $to.depth; d++){
            let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
            this.openFrontierNode(node.type, node.attrs, add);
        }
        return $to;
    }
    openFrontierNode(type, attrs = null, content) {
        let top = this.frontier[this.depth];
        top.match = top.match.matchType(type);
        this.placed = $040d9edd1880ca83$var$addToFragment(this.placed, this.depth, (0, $3xw6l.Fragment).from(type.create(attrs, content)));
        this.frontier.push({
            type: type,
            match: type.contentMatch
        });
    }
    closeFrontierNode() {
        let open = this.frontier.pop();
        let add = open.match.fillBefore((0, $3xw6l.Fragment).empty, true);
        if (add.childCount) this.placed = $040d9edd1880ca83$var$addToFragment(this.placed, this.frontier.length, add);
    }
}
function $040d9edd1880ca83$var$dropFromFragment(fragment, depth, count) {
    if (depth == 0) return fragment.cutByIndex(count, fragment.childCount);
    return fragment.replaceChild(0, fragment.firstChild.copy($040d9edd1880ca83$var$dropFromFragment(fragment.firstChild.content, depth - 1, count)));
}
function $040d9edd1880ca83$var$addToFragment(fragment, depth, content) {
    if (depth == 0) return fragment.append(content);
    return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy($040d9edd1880ca83$var$addToFragment(fragment.lastChild.content, depth - 1, content)));
}
function $040d9edd1880ca83$var$contentAt(fragment, depth) {
    for(let i = 0; i < depth; i++)fragment = fragment.firstChild.content;
    return fragment;
}
function $040d9edd1880ca83$var$closeNodeStart(node, openStart, openEnd) {
    if (openStart <= 0) return node;
    let frag = node.content;
    if (openStart > 1) frag = frag.replaceChild(0, $040d9edd1880ca83$var$closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
    if (openStart > 0) {
        frag = node.type.contentMatch.fillBefore(frag).append(frag);
        if (openEnd <= 0) frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore((0, $3xw6l.Fragment).empty, true));
    }
    return node.copy(frag);
}
function $040d9edd1880ca83$var$contentAfterFits($to, depth, type, match, open) {
    let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
    if (index == node.childCount && !type.compatibleContent(node.type)) return null;
    let fit = match.fillBefore(node.content, true, index);
    return fit && !$040d9edd1880ca83$var$invalidMarks(type, node.content, index) ? fit : null;
}
function $040d9edd1880ca83$var$invalidMarks(type, fragment, start) {
    for(let i = start; i < fragment.childCount; i++)if (!type.allowsMarks(fragment.child(i).marks)) return true;
    return false;
}
function $040d9edd1880ca83$var$definesContent(type) {
    return type.spec.defining || type.spec.definingForContent;
}
function $040d9edd1880ca83$var$replaceRange(tr, from, to, slice) {
    if (!slice.size) return tr.deleteRange(from, to);
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    if ($040d9edd1880ca83$var$fitsTrivially($from, $to, slice)) return tr.step(new $040d9edd1880ca83$export$5c860b2e74034756(from, to, slice));
    let targetDepths = $040d9edd1880ca83$var$coveredDepths($from, tr.doc.resolve(to));
    // Can't replace the whole document, so remove 0 if it's present
    if (targetDepths[targetDepths.length - 1] == 0) targetDepths.pop();
    // Negative numbers represent not expansion over the whole node at
    // that depth, but replacing from $from.before(-D) to $to.pos.
    let preferredTarget = -($from.depth + 1);
    targetDepths.unshift(preferredTarget);
    // This loop picks a preferred target depth, if one of the covering
    // depths is not outside of a defining node, and adds negative
    // depths for any depth that has $from at its start and does not
    // cross a defining node.
    for(let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--){
        let spec = $from.node(d).type.spec;
        if (spec.defining || spec.definingAsContext || spec.isolating) break;
        if (targetDepths.indexOf(d) > -1) preferredTarget = d;
        else if ($from.before(d) == pos) targetDepths.splice(1, 0, -d);
    }
    // Try to fit each possible depth of the slice into each possible
    // target depth, starting with the preferred depths.
    let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
    let leftNodes = [], preferredDepth = slice.openStart;
    for(let content = slice.content, i = 0;; i++){
        let node = content.firstChild;
        leftNodes.push(node);
        if (i == slice.openStart) break;
        content = node.content;
    }
    // Back up preferredDepth to cover defining textblocks directly
    // above it, possibly skipping a non-defining textblock.
    for(let d = preferredDepth - 1; d >= 0; d--){
        let leftNode = leftNodes[d], def = $040d9edd1880ca83$var$definesContent(leftNode.type);
        if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1))) preferredDepth = d;
        else if (def || !leftNode.type.isTextblock) break;
    }
    for(let j = slice.openStart; j >= 0; j--){
        let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
        let insert = leftNodes[openDepth];
        if (!insert) continue;
        for(let i = 0; i < targetDepths.length; i++){
            // Loop over possible expansion levels, starting with the
            // preferred one
            let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
            if (targetDepth < 0) {
                expand = false;
                targetDepth = -targetDepth;
            }
            let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
            if (parent.canReplaceWith(index, index, insert.type, insert.marks)) return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new (0, $3xw6l.Slice)($040d9edd1880ca83$var$closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
        }
    }
    let startSteps = tr.steps.length;
    for(let i = targetDepths.length - 1; i >= 0; i--){
        tr.replace(from, to, slice);
        if (tr.steps.length > startSteps) break;
        let depth = targetDepths[i];
        if (depth < 0) continue;
        from = $from.before(depth);
        to = $to.after(depth);
    }
}
function $040d9edd1880ca83$var$closeFragment(fragment, depth, oldOpen, newOpen, parent) {
    if (depth < oldOpen) {
        let first = fragment.firstChild;
        fragment = fragment.replaceChild(0, first.copy($040d9edd1880ca83$var$closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
    }
    if (depth > newOpen) {
        let match = parent.contentMatchAt(0);
        let start = match.fillBefore(fragment).append(fragment);
        fragment = start.append(match.matchFragment(start).fillBefore((0, $3xw6l.Fragment).empty, true));
    }
    return fragment;
}
function $040d9edd1880ca83$var$replaceRangeWith(tr, from, to, node) {
    if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
        let point = $040d9edd1880ca83$export$64cb316d02de1dd1(tr.doc, from, node.type);
        if (point != null) from = to = point;
    }
    tr.replaceRange(from, to, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(node), 0, 0));
}
function $040d9edd1880ca83$var$deleteRange(tr, from, to) {
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    let covered = $040d9edd1880ca83$var$coveredDepths($from, $to);
    for(let i = 0; i < covered.length; i++){
        let depth = covered[i], last = i == covered.length - 1;
        if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) return tr.delete($from.start(depth), $to.end(depth));
        if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) return tr.delete($from.before(depth), $to.after(depth));
    }
    for(let d = 1; d <= $from.depth && d <= $to.depth; d++){
        if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d && $from.start(d - 1) == $to.start(d - 1) && $from.node(d - 1).canReplace($from.index(d - 1), $to.index(d - 1))) return tr.delete($from.before(d), to);
    }
    tr.delete(from, to);
}
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function $040d9edd1880ca83$var$coveredDepths($from, $to) {
    let result = [], minDepth = Math.min($from.depth, $to.depth);
    for(let d = minDepth; d >= 0; d--){
        let start = $from.start(d);
        if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) break;
        if (start == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start - 1) result.push(d);
    }
    return result;
}
/**
Update an attribute in a specific node.
*/ class $040d9edd1880ca83$export$626399c38172f669 extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.pos = pos;
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail("No node at attribute step's position");
        let attrs = Object.create(null);
        for(let name in node.attrs)attrs[name] = node.attrs[name];
        attrs[this.attr] = this.value;
        let updated = node.type.create(attrs, null, node.marks);
        return $040d9edd1880ca83$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    getMap() {
        return $040d9edd1880ca83$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $040d9edd1880ca83$export$626399c38172f669(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $040d9edd1880ca83$export$626399c38172f669(pos.pos, this.attr, this.value);
    }
    toJSON() {
        return {
            stepType: "attr",
            pos: this.pos,
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.pos != "number" || typeof json.attr != "string") throw new RangeError("Invalid input for AttrStep.fromJSON");
        return new $040d9edd1880ca83$export$626399c38172f669(json.pos, json.attr, json.value);
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("attr", $040d9edd1880ca83$export$626399c38172f669);
/**
Update an attribute in the doc node.
*/ class $040d9edd1880ca83$export$f50707b396300ac9 extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let attrs = Object.create(null);
        for(let name in doc.attrs)attrs[name] = doc.attrs[name];
        attrs[this.attr] = this.value;
        let updated = doc.type.create(attrs, doc.content, doc.marks);
        return $040d9edd1880ca83$export$8ebf1578a4199c09.ok(updated);
    }
    getMap() {
        return $040d9edd1880ca83$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $040d9edd1880ca83$export$f50707b396300ac9(this.attr, doc.attrs[this.attr]);
    }
    map(mapping) {
        return this;
    }
    toJSON() {
        return {
            stepType: "docAttr",
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.attr != "string") throw new RangeError("Invalid input for DocAttrStep.fromJSON");
        return new $040d9edd1880ca83$export$f50707b396300ac9(json.attr, json.value);
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("docAttr", $040d9edd1880ca83$export$f50707b396300ac9);
/**
@internal
*/ let $040d9edd1880ca83$export$88cc3a1dfce48dd3 = class extends Error {
};
$040d9edd1880ca83$export$88cc3a1dfce48dd3 = function TransformError(message) {
    let err = Error.call(this, message);
    err.__proto__ = TransformError.prototype;
    return err;
};
$040d9edd1880ca83$export$88cc3a1dfce48dd3.prototype = Object.create(Error.prototype);
$040d9edd1880ca83$export$88cc3a1dfce48dd3.prototype.constructor = $040d9edd1880ca83$export$88cc3a1dfce48dd3;
$040d9edd1880ca83$export$88cc3a1dfce48dd3.prototype.name = "TransformError";
/**
Abstraction to build up and track an array of
[steps](https://prosemirror.net/docs/ref/#transform.Step) representing a document transformation.

Most transforming methods return the `Transform` object itself, so
that they can be chained.
*/ class $040d9edd1880ca83$export$563a914cafbdc389 {
    /**
    Create a transform that starts with the given document.
    */ constructor(/**
    The current document (the result of applying the steps in the
    transform).
    */ doc){
        this.doc = doc;
        /**
        The steps in this transform.
        */ this.steps = [];
        /**
        The documents before each of the steps.
        */ this.docs = [];
        /**
        A mapping with the maps for each of the steps in this transform.
        */ this.mapping = new $040d9edd1880ca83$export$f5f785078011b62;
    }
    /**
    The starting document.
    */ get before() {
        return this.docs.length ? this.docs[0] : this.doc;
    }
    /**
    Apply a new step in this transform, saving the result. Throws an
    error when the step fails.
    */ step(step) {
        let result = this.maybeStep(step);
        if (result.failed) throw new $040d9edd1880ca83$export$88cc3a1dfce48dd3(result.failed);
        return this;
    }
    /**
    Try to apply a step in this transformation, ignoring it if it
    fails. Returns the step result.
    */ maybeStep(step) {
        let result = step.apply(this.doc);
        if (!result.failed) this.addStep(step, result.doc);
        return result;
    }
    /**
    True when the document has been changed (when there are any
    steps).
    */ get docChanged() {
        return this.steps.length > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        this.docs.push(this.doc);
        this.steps.push(step);
        this.mapping.appendMap(step.getMap());
        this.doc = doc;
    }
    /**
    Replace the part of the document between `from` and `to` with the
    given `slice`.
    */ replace(from, to = from, slice = (0, $3xw6l.Slice).empty) {
        let step = $040d9edd1880ca83$export$ed6ac67359824afd(this.doc, from, to, slice);
        if (step) this.step(step);
        return this;
    }
    /**
    Replace the given range with the given content, which may be a
    fragment, node, or array of nodes.
    */ replaceWith(from, to, content) {
        return this.replace(from, to, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(content), 0, 0));
    }
    /**
    Delete the content between the given positions.
    */ delete(from, to) {
        return this.replace(from, to, (0, $3xw6l.Slice).empty);
    }
    /**
    Insert the given content at the given position.
    */ insert(pos, content) {
        return this.replaceWith(pos, pos, content);
    }
    /**
    Replace a range of the document with a given slice, using
    `from`, `to`, and the slice's
    [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
    than fixed start and end points. This method may grow the
    replaced area or close open nodes in the slice in order to get a
    fit that is more in line with WYSIWYG expectations, by dropping
    fully covered parent nodes of the replaced region when they are
    marked [non-defining as
    context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
    open parent node from the slice that _is_ marked as [defining
    its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
    
    This is the method, for example, to handle paste. The similar
    [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
    primitive tool which will _not_ move the start and end of its given
    range, and is useful in situations where you need more precise
    control over what happens.
    */ replaceRange(from, to, slice) {
        $040d9edd1880ca83$var$replaceRange(this, from, to, slice);
        return this;
    }
    /**
    Replace the given range with a node, but use `from` and `to` as
    hints, rather than precise positions. When from and to are the same
    and are at the start or end of a parent node in which the given
    node doesn't fit, this method may _move_ them out towards a parent
    that does allow the given node to be placed. When the given range
    completely covers a parent node, this method may completely replace
    that parent node.
    */ replaceRangeWith(from, to, node) {
        $040d9edd1880ca83$var$replaceRangeWith(this, from, to, node);
        return this;
    }
    /**
    Delete the given range, expanding it to cover fully covered
    parent nodes until a valid replace is found.
    */ deleteRange(from, to) {
        $040d9edd1880ca83$var$deleteRange(this, from, to);
        return this;
    }
    /**
    Split the content in the given range off from its parent, if there
    is sibling content before or after it, and move it up the tree to
    the depth specified by `target`. You'll probably want to use
    [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
    sure the lift is valid.
    */ lift(range, target) {
        $040d9edd1880ca83$var$lift(this, range, target);
        return this;
    }
    /**
    Join the blocks around the given position. If depth is 2, their
    last and first siblings are also joined, and so on.
    */ join(pos, depth = 1) {
        $040d9edd1880ca83$var$join(this, pos, depth);
        return this;
    }
    /**
    Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
    The wrappers are assumed to be valid in this position, and should
    probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
    */ wrap(range, wrappers) {
        $040d9edd1880ca83$var$wrap(this, range, wrappers);
        return this;
    }
    /**
    Set the type of all textblocks (partly) between `from` and `to` to
    the given node type with the given attributes.
    */ setBlockType(from, to = from, type, attrs = null) {
        $040d9edd1880ca83$var$setBlockType(this, from, to, type, attrs);
        return this;
    }
    /**
    Change the type, attributes, and/or marks of the node at `pos`.
    When `type` isn't given, the existing node type is preserved,
    */ setNodeMarkup(pos, type, attrs = null, marks) {
        $040d9edd1880ca83$var$setNodeMarkup(this, pos, type, attrs, marks);
        return this;
    }
    /**
    Set a single attribute on a given node to a new value.
    The `pos` addresses the document content. Use `setDocAttribute`
    to set attributes on the document itself.
    */ setNodeAttribute(pos, attr, value) {
        this.step(new $040d9edd1880ca83$export$626399c38172f669(pos, attr, value));
        return this;
    }
    /**
    Set a single attribute on the document to a new value.
    */ setDocAttribute(attr, value) {
        this.step(new $040d9edd1880ca83$export$f50707b396300ac9(attr, value));
        return this;
    }
    /**
    Add a mark to the node at position `pos`.
    */ addNodeMark(pos, mark) {
        this.step(new $040d9edd1880ca83$export$adefd16c402fee4e(pos, mark));
        return this;
    }
    /**
    Remove a mark (or a mark of the given type) from the node at
    position `pos`.
    */ removeNodeMark(pos, mark) {
        if (!(mark instanceof (0, $3xw6l.Mark))) {
            let node = this.doc.nodeAt(pos);
            if (!node) throw new RangeError("No node at position " + pos);
            mark = mark.isInSet(node.marks);
            if (!mark) return this;
        }
        this.step(new $040d9edd1880ca83$export$fdf7d1dc10724da2(pos, mark));
        return this;
    }
    /**
    Split the node at the given position, and optionally, if `depth` is
    greater than one, any number of nodes above that. By default, the
    parts split off will inherit the node type of the original node.
    This can be changed by passing an array of types and attributes to
    use after the split.
    */ split(pos, depth = 1, typesAfter) {
        $040d9edd1880ca83$var$split(this, pos, depth, typesAfter);
        return this;
    }
    /**
    Add the given mark to the inline content between `from` and `to`.
    */ addMark(from, to, mark) {
        $040d9edd1880ca83$var$addMark(this, from, to, mark);
        return this;
    }
    /**
    Remove marks from inline nodes between `from` and `to`. When
    `mark` is a single mark, remove precisely that mark. When it is
    a mark type, remove all marks of that type. When it is null,
    remove all marks of any type.
    */ removeMark(from, to, mark) {
        $040d9edd1880ca83$var$removeMark(this, from, to, mark);
        return this;
    }
    /**
    Removes all marks and nodes from the content of the node at
    `pos` that don't match the given new parent node type. Accepts
    an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
    third argument.
    */ clearIncompatible(pos, parentType, match) {
        $040d9edd1880ca83$var$clearIncompatible(this, pos, parentType, match);
        return this;
    }
}

});


parcelRegister("BmspC", function(module, exports) {
$parcel$export(module.exports, "removeParentNodeOfType", () => $0704e05c57d80c1d$export$5dd18664fe8bcbde);
$parcel$export(module.exports, "findParentNodeOfType", () => $0704e05c57d80c1d$export$1a3a74094b9968e);
$parcel$export(module.exports, "replaceParentNodeOfType", () => $0704e05c57d80c1d$export$b72cc612b642c071);
$parcel$export(module.exports, "removeSelectedNode", () => $0704e05c57d80c1d$export$7d6e4e6663186878);
$parcel$export(module.exports, "isNodeSelection", () => $0704e05c57d80c1d$export$a8c1d2c13abf8822);
$parcel$export(module.exports, "replaceSelectedNode", () => $0704e05c57d80c1d$export$39874bca494f9ba3);
$parcel$export(module.exports, "setTextSelection", () => $0704e05c57d80c1d$export$1df6d14df6b0b758);
$parcel$export(module.exports, "safeInsert", () => $0704e05c57d80c1d$export$5fe92db78385e37c);
$parcel$export(module.exports, "canInsert", () => $0704e05c57d80c1d$export$b4d1262a40ad21d4);
$parcel$export(module.exports, "removeNodeBefore", () => $0704e05c57d80c1d$export$ffb1550ab6c3d03c);
$parcel$export(module.exports, "findPositionOfNodeBefore", () => $0704e05c57d80c1d$export$f8088819b1e2c2dc);
$parcel$export(module.exports, "findParentNode", () => $0704e05c57d80c1d$export$dc159056ffdb4c76);
$parcel$export(module.exports, "findParentNodeClosestToPos", () => $0704e05c57d80c1d$export$fe09644e3bc6166b);
$parcel$export(module.exports, "findDomRefAtPos", () => $0704e05c57d80c1d$export$666ce65defe9ad6e);
$parcel$export(module.exports, "hasParentNode", () => $0704e05c57d80c1d$export$178ecaf80f45fdb6);
$parcel$export(module.exports, "findParentNodeOfTypeClosestToPos", () => $0704e05c57d80c1d$export$8bf0d019bde85d18);
$parcel$export(module.exports, "hasParentNodeOfType", () => $0704e05c57d80c1d$export$14f438bb7227ce63);
$parcel$export(module.exports, "findParentDomRefOfType", () => $0704e05c57d80c1d$export$faeafc1151740116);
$parcel$export(module.exports, "findSelectedNodeOfType", () => $0704e05c57d80c1d$export$924aa2dd4d9a67fa);
$parcel$export(module.exports, "flatten", () => $0704e05c57d80c1d$export$bffa455ba8c619a6);
$parcel$export(module.exports, "findChildren", () => $0704e05c57d80c1d$export$f94ca194e830789c);
$parcel$export(module.exports, "findChildrenByType", () => $0704e05c57d80c1d$export$96bb9476c7c69f39);
$parcel$export(module.exports, "contains", () => $0704e05c57d80c1d$export$2344b14b097df817);
// src/selection.ts

var $3lIcL = parcelRequire("3lIcL");

var $3xw6l = parcelRequire("3xw6l");
var $0704e05c57d80c1d$export$5dd18664fe8bcbde = (nodeType)=>(tr)=>{
        const parent = $0704e05c57d80c1d$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $0704e05c57d80c1d$var$removeNodeAtPos(parent.pos)(tr);
        return tr;
    };
var $0704e05c57d80c1d$export$b72cc612b642c071 = (nodeType, content)=>(tr)=>{
        if (!Array.isArray(nodeType)) nodeType = [
            nodeType
        ];
        for(let i = 0, count = nodeType.length; i < count; i++){
            const parent = $0704e05c57d80c1d$export$1a3a74094b9968e(nodeType[i])(tr.selection);
            if (parent) {
                const newTr = $0704e05c57d80c1d$var$replaceNodeAtPos(parent.pos, content)(tr);
                if (newTr !== tr) return newTr;
            }
        }
        return tr;
    };
var $0704e05c57d80c1d$export$7d6e4e6663186878 = (tr)=>{
    if ($0704e05c57d80c1d$export$a8c1d2c13abf8822(tr.selection)) {
        const from = tr.selection.$from.pos;
        const to = tr.selection.$to.pos;
        return $0704e05c57d80c1d$var$cloneTr(tr.delete(from, to));
    }
    return tr;
};
var $0704e05c57d80c1d$export$39874bca494f9ba3 = (content)=>(tr)=>{
        if ($0704e05c57d80c1d$export$a8c1d2c13abf8822(tr.selection)) {
            const { $from: $from, $to: $to } = tr.selection;
            if (content instanceof (0, $3xw6l.Fragment) && $from.parent.canReplace($from.index(), $from.indexAfter(), content) || content instanceof (0, $3xw6l.Node) && $from.parent.canReplaceWith($from.index(), $from.indexAfter(), content.type)) return $0704e05c57d80c1d$var$cloneTr(tr.replaceWith($from.pos, $to.pos, content).setSelection(new (0, $3lIcL.NodeSelection)(tr.doc.resolve($from.pos))));
        }
        return tr;
    };
var $0704e05c57d80c1d$export$1df6d14df6b0b758 = (position, dir = 1)=>(tr)=>{
        const nextSelection = (0, $3lIcL.Selection).findFrom(tr.doc.resolve(position), dir, true);
        if (nextSelection) return tr.setSelection(nextSelection);
        return tr;
    };
var $0704e05c57d80c1d$var$isSelectableNode = (node)=>Boolean(node instanceof (0, $3xw6l.Node) && node.type && node.type.spec.selectable);
var $0704e05c57d80c1d$var$shouldSelectNode = (node)=>$0704e05c57d80c1d$var$isSelectableNode(node) && node.type.isLeaf;
var $0704e05c57d80c1d$var$setSelection = (node, pos, tr)=>{
    if ($0704e05c57d80c1d$var$shouldSelectNode(node)) return tr.setSelection(new (0, $3lIcL.NodeSelection)(tr.doc.resolve(pos)));
    return $0704e05c57d80c1d$export$1df6d14df6b0b758(pos)(tr);
};
var $0704e05c57d80c1d$export$5fe92db78385e37c = (content, position, tryToReplace)=>(tr)=>{
        const hasPosition = typeof position === "number";
        const { $from: $from } = tr.selection;
        const $insertPos = hasPosition ? tr.doc.resolve(position) : $0704e05c57d80c1d$export$a8c1d2c13abf8822(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
        const { parent: parent } = $insertPos;
        if ($0704e05c57d80c1d$export$a8c1d2c13abf8822(tr.selection) && tryToReplace) {
            const oldTr = tr;
            tr = $0704e05c57d80c1d$export$39874bca494f9ba3(content)(tr);
            if (oldTr !== tr) return tr;
        }
        if ($0704e05c57d80c1d$var$isEmptyParagraph(parent)) {
            const oldTr = tr;
            tr = $0704e05c57d80c1d$export$b72cc612b642c071(parent.type, content)(tr);
            if (oldTr !== tr) {
                const pos = $0704e05c57d80c1d$var$isSelectableNode(content) ? // for selectable node, selection position would be the position of the replaced parent
                $insertPos.before($insertPos.depth) : $insertPos.pos;
                return $0704e05c57d80c1d$var$setSelection(content, pos, tr);
            }
        }
        if ($0704e05c57d80c1d$export$b4d1262a40ad21d4($insertPos, content)) {
            tr.insert($insertPos.pos, content);
            const pos = hasPosition ? $insertPos.pos : $0704e05c57d80c1d$var$isSelectableNode(content) ? // for atom nodes selection position after insertion is the previous pos
            tr.selection.$anchor.pos - 1 : tr.selection.$anchor.pos;
            return $0704e05c57d80c1d$var$cloneTr($0704e05c57d80c1d$var$setSelection(content, pos, tr));
        }
        for(let i = $insertPos.depth; i > 0; i--){
            const pos = $insertPos.after(i);
            const $pos = tr.doc.resolve(pos);
            if ($0704e05c57d80c1d$export$b4d1262a40ad21d4($pos, content)) {
                tr.insert(pos, content);
                return $0704e05c57d80c1d$var$cloneTr($0704e05c57d80c1d$var$setSelection(content, pos, tr));
            }
        }
        return tr;
    };
var $0704e05c57d80c1d$export$36491a9ea218d882 = (nodeType, type, attrs, marks)=>(tr)=>{
        const parent = $0704e05c57d80c1d$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $0704e05c57d80c1d$var$cloneTr(tr.setNodeMarkup(parent.pos, type, Object.assign({}, parent.node.attrs, attrs), marks));
        return tr;
    };
var $0704e05c57d80c1d$export$7f11cc48adfe3aed = (nodeType)=>(tr)=>{
        if (!$0704e05c57d80c1d$export$a8c1d2c13abf8822(tr.selection)) {
            const parent = $0704e05c57d80c1d$export$1a3a74094b9968e(nodeType)(tr.selection);
            if (parent) return $0704e05c57d80c1d$var$cloneTr(tr.setSelection((0, $3lIcL.NodeSelection).create(tr.doc, parent.pos)));
        }
        return tr;
    };
var $0704e05c57d80c1d$export$ffb1550ab6c3d03c = (tr)=>{
    const position = $0704e05c57d80c1d$export$f8088819b1e2c2dc(tr.selection);
    if (typeof position === "number") return $0704e05c57d80c1d$var$removeNodeAtPos(position)(tr);
    return tr;
};
// src/helpers.ts
var $0704e05c57d80c1d$export$a8c1d2c13abf8822 = (selection)=>{
    return selection instanceof (0, $3lIcL.NodeSelection);
};
var $0704e05c57d80c1d$var$equalNodeType = (nodeType, node)=>{
    return Array.isArray(nodeType) && nodeType.indexOf(node.type) > -1 || node.type === nodeType;
};
var $0704e05c57d80c1d$var$cloneTr = (tr)=>{
    return Object.assign(Object.create(tr), tr).setTime(Date.now());
};
var $0704e05c57d80c1d$var$replaceNodeAtPos = (position, content)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        const $pos = tr.doc.resolve(position);
        if (!node) return tr;
        if ($0704e05c57d80c1d$var$canReplace($pos, content)) {
            tr = tr.replaceWith(position, position + node.nodeSize, content);
            const start = tr.selection.$from.pos - 1;
            tr = $0704e05c57d80c1d$export$1df6d14df6b0b758(Math.max(start, 0), -1)(tr);
            tr = $0704e05c57d80c1d$export$1df6d14df6b0b758(tr.selection.$from.start())(tr);
            return $0704e05c57d80c1d$var$cloneTr(tr);
        }
        return tr;
    };
var $0704e05c57d80c1d$var$canReplace = ($pos, content)=>{
    const node = $pos.node($pos.depth);
    return node && node.type.validContent(content instanceof (0, $3xw6l.Fragment) ? content : (0, $3xw6l.Fragment).from(content));
};
var $0704e05c57d80c1d$var$removeNodeAtPos = (position)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        if (!node) return tr;
        return $0704e05c57d80c1d$var$cloneTr(tr.delete(position, position + node.nodeSize));
    };
var $0704e05c57d80c1d$export$b4d1262a40ad21d4 = ($pos, content)=>{
    const index = $pos.index();
    if (content instanceof (0, $3xw6l.Fragment)) return $pos.parent.canReplace(index, index, content);
    else if (content instanceof (0, $3xw6l.Node)) return $pos.parent.canReplaceWith(index, index, content.type);
    return false;
};
var $0704e05c57d80c1d$var$isEmptyParagraph = (node)=>{
    return !node || node.type.name === "paragraph" && node.nodeSize === 2;
};
// src/selection.ts
var $0704e05c57d80c1d$export$dc159056ffdb4c76 = (predicate)=>({ $from: $from, $to: $to }, validateSameParent = false)=>{
        if (validateSameParent && !$from.sameParent($to)) {
            let depth = Math.min($from.depth, $to.depth);
            while(depth >= 0){
                const fromNode = $from.node(depth);
                const toNode = $to.node(depth);
                if (toNode === fromNode) {
                    if (predicate(fromNode)) return {
                        // Return the resolved pos
                        pos: depth > 0 ? $from.before(depth) : 0,
                        start: $from.start(depth),
                        depth: depth,
                        node: fromNode
                    };
                }
                depth = depth - 1;
            }
            return;
        }
        return $0704e05c57d80c1d$export$fe09644e3bc6166b($from, predicate);
    };
var $0704e05c57d80c1d$export$fe09644e3bc6166b = ($pos, predicate)=>{
    for(let i = $pos.depth; i > 0; i--){
        const node = $pos.node(i);
        if (predicate(node)) return {
            pos: i > 0 ? $pos.before(i) : 0,
            start: $pos.start(i),
            depth: i,
            node: node
        };
    }
};
var $0704e05c57d80c1d$export$8556d79fa8189214 = (predicate, domAtPos)=>(selection)=>{
        const parent = $0704e05c57d80c1d$export$dc159056ffdb4c76(predicate)(selection);
        if (parent) return $0704e05c57d80c1d$export$666ce65defe9ad6e(parent.pos, domAtPos);
    };
var $0704e05c57d80c1d$export$178ecaf80f45fdb6 = (predicate)=>(selection)=>{
        return !!$0704e05c57d80c1d$export$dc159056ffdb4c76(predicate)(selection);
    };
var $0704e05c57d80c1d$export$1a3a74094b9968e = (nodeType)=>(selection)=>{
        return $0704e05c57d80c1d$export$dc159056ffdb4c76((node)=>$0704e05c57d80c1d$var$equalNodeType(nodeType, node))(selection);
    };
var $0704e05c57d80c1d$export$8bf0d019bde85d18 = ($pos, nodeType)=>{
    return $0704e05c57d80c1d$export$fe09644e3bc6166b($pos, (node)=>$0704e05c57d80c1d$var$equalNodeType(nodeType, node));
};
var $0704e05c57d80c1d$export$14f438bb7227ce63 = (nodeType)=>(selection)=>{
        return $0704e05c57d80c1d$export$178ecaf80f45fdb6((node)=>$0704e05c57d80c1d$var$equalNodeType(nodeType, node))(selection);
    };
var $0704e05c57d80c1d$export$faeafc1151740116 = (nodeType, domAtPos)=>(selection)=>{
        return $0704e05c57d80c1d$export$8556d79fa8189214((node)=>$0704e05c57d80c1d$var$equalNodeType(nodeType, node), domAtPos)(selection);
    };
var $0704e05c57d80c1d$export$924aa2dd4d9a67fa = (nodeType)=>(selection)=>{
        if ($0704e05c57d80c1d$export$a8c1d2c13abf8822(selection)) {
            const { node: node, $from: $from } = selection;
            if ($0704e05c57d80c1d$var$equalNodeType(nodeType, node)) return {
                node: node,
                start: $from.start(),
                pos: $from.pos,
                depth: $from.depth
            };
        }
    };
var $0704e05c57d80c1d$export$f8088819b1e2c2dc = (selection)=>{
    const { nodeBefore: nodeBefore } = selection.$from;
    const maybeSelection = (0, $3lIcL.Selection).findFrom(selection.$from, -1);
    if (maybeSelection && nodeBefore) {
        const parent = $0704e05c57d80c1d$export$1a3a74094b9968e(nodeBefore.type)(maybeSelection);
        if (parent) return parent.pos;
        return maybeSelection.$from.pos;
    }
};
var $0704e05c57d80c1d$export$666ce65defe9ad6e = (position, domAtPos)=>{
    const dom = domAtPos(position);
    const node = dom.node.childNodes[dom.offset];
    if (dom.node.nodeType === Node.TEXT_NODE && dom.node.parentNode) return dom.node.parentNode;
    if (!node || node.nodeType === Node.TEXT_NODE) return dom.node;
    return node;
};
// src/node.ts
var $0704e05c57d80c1d$export$bffa455ba8c619a6 = (node, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    const result = [];
    node.descendants((child, pos)=>{
        result.push({
            node: child,
            pos: pos
        });
        if (!descend) return false;
    });
    return result;
};
var $0704e05c57d80c1d$export$f94ca194e830789c = (node, predicate, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    else if (!predicate) throw new Error('Invalid "predicate" parameter');
    return $0704e05c57d80c1d$export$bffa455ba8c619a6(node, descend).filter((child)=>predicate(child.node));
};
var $0704e05c57d80c1d$export$53418710fbc2d8cc = (node, descend = true)=>{
    return $0704e05c57d80c1d$export$f94ca194e830789c(node, (child)=>child.isText, descend);
};
var $0704e05c57d80c1d$export$ddc1620722e25671 = (node, descend = true)=>{
    return $0704e05c57d80c1d$export$f94ca194e830789c(node, (child)=>child.isInline, descend);
};
var $0704e05c57d80c1d$export$cae8d7f259e5bbe9 = (node, descend = true)=>{
    return $0704e05c57d80c1d$export$f94ca194e830789c(node, (child)=>child.isBlock, descend);
};
var $0704e05c57d80c1d$export$a836476a7f9de5b4 = (node, predicate, descend = true)=>{
    return $0704e05c57d80c1d$export$f94ca194e830789c(node, (child)=>!!predicate(child.attrs), descend);
};
var $0704e05c57d80c1d$export$96bb9476c7c69f39 = (node, nodeType, descend = true)=>{
    return $0704e05c57d80c1d$export$f94ca194e830789c(node, (child)=>child.type === nodeType, descend);
};
var $0704e05c57d80c1d$export$c01a9e7ec615e821 = (node, markType, descend = true)=>{
    return $0704e05c57d80c1d$export$f94ca194e830789c(node, (child)=>Boolean(markType.isInSet(child.marks)), descend);
};
var $0704e05c57d80c1d$export$2344b14b097df817 = (node, nodeType)=>{
    return !!$0704e05c57d80c1d$export$96bb9476c7c69f39(node, nodeType).length;
};

});

parcelRegister("cwzAY", function(module, exports) {
$parcel$export(module.exports, "CellSelection", () => $d2163c16df8aab18$export$831cc7e2a83afa94);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
// Was copied from https://github.com/ProseMirror/prosemirror-tables/blob/master/src/cellselection.js
// This file defines a ProseMirror selection subclass that models
// table cell selections. The table plugin needs to be active to wire
// in the user interaction part of table selections (so that you
// actually get such selections when you select across cells).

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $9sdKa = parcelRequire("9sdKa");

var $2vA54 = parcelRequire("2vA54");

var $cSPHa = parcelRequire("cSPHa");

var $9K0SW = parcelRequire("9K0SW");

var $7VjxU = parcelRequire("7VjxU");

var $7lSnz = parcelRequire("7lSnz");
class $d2163c16df8aab18$export$831cc7e2a83afa94 extends (0, $3lIcL.Selection) {
    constructor($anchorCell, $headCell = $anchorCell){
        const ranges = (0, $7VjxU.getCellSelectionRanges)($anchorCell, $headCell);
        super(ranges[0].$from, ranges[0].$to, ranges);
        // :: ResolvedPos
        // A resolved position pointing _in front of_ the anchor cell (the one
        // that doesn't move when extending the selection).
        this.$anchorCell = $anchorCell;
        // :: ResolvedPos
        // A resolved position pointing in front of the head cell (the one
        // moves when extending the selection).
        this.$headCell = $headCell;
        this.visible = false;
    }
    map(doc, mapping) {
        const $anchorCell = doc.resolve(mapping.map(this.$anchorCell.pos));
        const $headCell = doc.resolve(mapping.map(this.$headCell.pos));
        if ((0, $cSPHa.pointsAtCell)($anchorCell) && (0, $cSPHa.pointsAtCell)($headCell) && (0, $7lSnz.inSameTable)($anchorCell, $headCell)) {
            const tableChanged = this.$anchorCell.node(-1) !== $anchorCell.node(-1);
            if (tableChanged && this.isRowSelection()) return $d2163c16df8aab18$export$831cc7e2a83afa94.rowSelection($anchorCell, $headCell);
            if (tableChanged && this.isColSelection()) return $d2163c16df8aab18$export$831cc7e2a83afa94.colSelection($anchorCell, $headCell);
            return new $d2163c16df8aab18$export$831cc7e2a83afa94($anchorCell, $headCell);
        }
        return (0, $3lIcL.TextSelection).between($anchorCell, $headCell);
    }
    // :: () → Slice
    // Returns a rectangular slice of table rows containing the selected
    // cells.
    content() {
        const table = this.$anchorCell.node(-1);
        const map = (0, $2vA54.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const rect = map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start);
        const seen = {};
        const rows = [];
        for(let row = rect.top; row < rect.bottom; row++){
            const rowContent = [];
            for(let index = row * map.width + rect.left, col = rect.left; col < rect.right; col++, index++){
                const pos = map.map[index];
                if (!seen[pos]) {
                    seen[pos] = true;
                    const cellRect = map.findCell(pos);
                    let cell = table.nodeAt(pos);
                    if (cell === null || cell === undefined) throw new Error(`No cell at position ${pos}`);
                    const extraLeft = rect.left - cellRect.left;
                    const extraRight = cellRect.right - rect.right;
                    if (extraLeft > 0 || extraRight > 0) {
                        let { attrs: attrs } = cell;
                        if (!attrs) throw new Error(`No cell at position ${pos}`);
                        if (extraLeft > 0) attrs = (0, $9K0SW.removeColSpan)(attrs, 0, extraLeft);
                        if (extraRight > 0) // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        attrs = (0, $9K0SW.removeColSpan)(attrs, attrs.colspan - extraRight, extraRight);
                        if (cellRect.left < rect.left) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position after create/createAndFill`);
                    if (cellRect.top < rect.top || cellRect.bottom > rect.bottom) {
                        const attrs = {
                            ...cell.attrs,
                            rowspan: Math.min(cellRect.bottom, rect.bottom) - Math.max(cellRect.top, rect.top)
                        };
                        if (cellRect.top < rect.top) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position before rowContent.push`);
                    rowContent.push(cell);
                }
            }
            rows.push(table.child(row).copy((0, $3xw6l.Fragment).from(rowContent)));
        }
        const fragment = this.isColSelection() && this.isRowSelection() ? table : rows;
        return new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(fragment), 1, 1);
    }
    replace(tr, content = (0, $3xw6l.Slice).empty) {
        const mapFrom = tr.steps.length;
        const { ranges: ranges } = this;
        for(let i = 0; i < ranges.length; i++){
            const { $from: $from, $to: $to } = ranges[i];
            const mapping = tr.mapping.slice(mapFrom);
            tr.replace(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $3xw6l.Slice).empty : content);
        }
        const sel = (0, $3lIcL.Selection).findFrom(tr.doc.resolve(tr.mapping.slice(mapFrom).map(this.to)), -1);
        if (sel) tr.setSelection(sel);
    }
    replaceWith(tr, node) {
        this.replace(tr, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(node), 0, 0));
    }
    forEachCell(f) {
        const table = this.$anchorCell.node(-1);
        const map = (0, $2vA54.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const cells = map.cellsInRect(map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start));
        for(let i = 0; i < cells.length; i++){
            const cell = table.nodeAt(cells[i]);
            if (cell === null || cell === undefined) throw new Error(`undefined cell at pos ${cells[i]}`);
            f(cell, start + cells[i]);
        }
    }
    // :: () → bool
    // True if this selection goes all the way from the top to the
    // bottom of the table.
    isColSelection() {
        if (!this.$anchorCell || !this.$headCell) throw new Error('invalid $anchorCell or $headCell');
        const anchorTop = this.$anchorCell.index(-1);
        const headTop = this.$headCell.index(-1);
        if (Math.min(anchorTop, headTop) > 0) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const anchorBot = anchorTop + this.$anchorCell.nodeAfter.attrs.rowspan;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const headBot = headTop + this.$headCell.nodeAfter.attrs.rowspan;
        return Math.max(anchorBot, headBot) === this.$headCell.node(-1).childCount;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest column selection that covers the given anchor
    // and head cell.
    static colSelection($anchorCell, $headCell = $anchorCell) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $2vA54.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.top <= headRect.top) {
            if (anchorRect.top > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.left]);
            if (headRect.bottom < map.height) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (map.height - 1) + headRect.right - 1]);
        } else {
            if (headRect.top > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.left]);
            if (anchorRect.bottom < map.height) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (map.height - 1) + anchorRect.right - 1]);
        }
        return new $d2163c16df8aab18$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    // :: () → bool
    // True if this selection goes all the way from the left to the
    // right of the table.
    isRowSelection() {
        if (!this.$anchorCell || !this.$headCell) return false;
        const start = this.$anchorCell.start(-1);
        const map = (0, $2vA54.TableMap).get(this.$anchorCell.node(-1));
        const rowAtAnchorCell = map.rowCount(this.$anchorCell.pos - start);
        const rowAtHeadCell = map.rowCount(this.$headCell.pos - start);
        const isSelectionSameRow = rowAtAnchorCell === rowAtHeadCell;
        // if anchor and head in the same line, counting how many cells
        // should be in the row except merged cell
        const maxColumnInSelectedRow = map.getMaxColInRow(this.$anchorCell);
        // if selected cells less than table max column amount, and
        // the anchor/head not in a merged cell
        // it should be select maxColumnInSelectedRow to be TRUE
        if (isSelectionSameRow && this.ranges.length <= map.width && !map.isPosMerged(this.$anchorCell.pos - start) && !map.isPosMerged(this.$headCell.pos - start)) return this.ranges.length === maxColumnInSelectedRow;
        // If anchor and head in different row, it should be always in first and
        // last column to select the whole row.
        const anchorLeft = map.colCount(this.$anchorCell.pos - start);
        const headLeft = map.colCount(this.$headCell.pos - start);
        if (Math.min(anchorLeft, headLeft) > 0) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const anchorRight = anchorLeft + this.$anchorCell.nodeAfter.attrs.colspan;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const headRight = headLeft + this.$headCell.nodeAfter.attrs.colspan;
        return Math.max(anchorRight, headRight) === map.width;
    }
    eq(other) {
        return other instanceof $d2163c16df8aab18$export$831cc7e2a83afa94 && other.$anchorCell.pos === this.$anchorCell.pos && other.$headCell.pos === this.$headCell.pos;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest row selection that covers the given anchor
    // and head cell.
    static rowSelection($anchorCell, $headCell = $anchorCell, reverse = false) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $2vA54.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.left <= headRect.left) {
            if (anchorRect.left > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.top * map.width]);
            if (headRect.right < map.width) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (headRect.top + 1) - 1]);
        } else {
            if (headRect.left > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.top * map.width]);
            if (anchorRect.right < map.width) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (anchorRect.top + 1) - 1]);
        }
        return reverse ? new $d2163c16df8aab18$export$831cc7e2a83afa94($calculatedHeadCell, $calculatedAnchorCell) : new $d2163c16df8aab18$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    toJSON() {
        return {
            type: 'cell',
            anchor: this.$anchorCell.pos,
            head: this.$headCell.pos
        };
    }
    static fromJSON(doc, json) {
        return new $d2163c16df8aab18$export$831cc7e2a83afa94(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    // :: (Node, number, ?number) → CellSelection
    static create(doc, anchorCell, headCell = anchorCell) {
        return new $d2163c16df8aab18$export$831cc7e2a83afa94(doc.resolve(anchorCell), doc.resolve(headCell));
    }
    getBookmark() {
        return new (0, $9sdKa.CellBookmark)(this.$anchorCell.pos, this.$headCell.pos);
    }
}
(0, $3lIcL.Selection).jsonID('cell', $d2163c16df8aab18$export$831cc7e2a83afa94);

});
parcelRegister("9sdKa", function(module, exports) {
$parcel$export(module.exports, "CellBookmark", () => $261b53ebec41e3a8$export$ca751a6394ad160e);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $3lIcL = parcelRequire("3lIcL");

var $7lSnz = parcelRequire("7lSnz");
class $261b53ebec41e3a8$export$ca751a6394ad160e {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $261b53ebec41e3a8$export$ca751a6394ad160e(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        const $anchorCell = doc.resolve(this.anchor);
        const $headCell = doc.resolve(this.head);
        if ($anchorCell.parent.type.spec.tableRole === 'row' && $headCell.parent.type.spec.tableRole === 'row' && $anchorCell.index() < $anchorCell.parent.childCount && $headCell.index() < $headCell.parent.childCount && (0, $7lSnz.inSameTable)($anchorCell, $headCell)) {
            const data = {
                type: 'cell',
                anchor: $anchorCell.pos,
                head: $headCell.pos
            };
            return (0, $3lIcL.Selection).fromJSON(doc, data);
        }
        return (0, $3lIcL.Selection).near($headCell, 1);
    }
}

});
parcelRegister("7lSnz", function(module, exports) {
$parcel$export(module.exports, "isInTable", () => $03a54050b67a9b6d$export$217a88ad224d1b11);
$parcel$export(module.exports, "inSameTable", () => $03a54050b67a9b6d$export$debd62b44eb7e281);
function $03a54050b67a9b6d$export$217a88ad224d1b11(state) {
    const { $head: $head } = state.selection;
    for(let d = $head.depth; d > 0; d--){
        if ($head.node(d).type.spec.tableRole === 'row') return true;
    }
    return false;
}
function $03a54050b67a9b6d$export$debd62b44eb7e281($a, $b) {
    return $a.depth === $b.depth && $a.pos >= $b.start(-1) && $a.pos <= $b.end(-1);
}

});


parcelRegister("2vA54", function(module, exports) {
$parcel$export(module.exports, "Rect", () => $92f17257f5177c44$export$c79fc6492f3af13d);
$parcel$export(module.exports, "TableProblemTypes", () => $92f17257f5177c44$export$d8cd393a71edca79);
$parcel$export(module.exports, "TableMap", () => $92f17257f5177c44$export$493da463fed0a57a);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
// Because working with row and column-spanning cells is not quite
// trivial, this code builds up a descriptive structure for a given
// table node. The structures are cached with the (persistent) table
// nodes as key, so that they only have to be recomputed when the
// content of the table changes.
//
// This does mean that they have to store table-relative, not
// document-relative positions. So code that uses them will typically
// compute the start position of the table and offset positions passed
// to or gotten from this structure by that amount.
let $92f17257f5177c44$var$readFromCache, $92f17257f5177c44$var$addToCache;
// Prefer using a weak map to cache table maps. Fall back on a
// fixed-size cache if that's not supported.
if (typeof WeakMap !== 'undefined') {
    const cache = new WeakMap();
    $92f17257f5177c44$var$readFromCache = (key)=>cache.get(key);
    $92f17257f5177c44$var$addToCache = (key, value)=>{
        cache.set(key, value);
        return value;
    };
} else {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cache = [];
    const cacheSize = 10;
    let cachePos = 0;
    $92f17257f5177c44$var$readFromCache = (key)=>{
        for(let i = 0; i < cache.length; i += 2){
            if (cache[i] === key) return cache[i + 1];
        }
    };
    $92f17257f5177c44$var$addToCache = (key, value)=>{
        if (cachePos === cacheSize) cachePos = 0;
        cache[cachePos++] = key;
        return cache[cachePos++] = value;
    };
}
class $92f17257f5177c44$export$c79fc6492f3af13d {
    constructor(left, top, right, bottom){
        this.left = left;
        this.top = top;
        this.right = right;
        this.bottom = bottom;
    }
}
var $92f17257f5177c44$export$d8cd393a71edca79 = /*#__PURE__*/ function(TableProblemTypes) {
    TableProblemTypes["COLLISION"] = "collision";
    TableProblemTypes["OVERLONG_ROWSPAN"] = "overlong_rowspan";
    TableProblemTypes["MISSING"] = "missing";
    TableProblemTypes["COLWIDTH_MISMATCH"] = "colwidth mismatch";
    return TableProblemTypes;
}({});
const $92f17257f5177c44$export$c60fae4049791eae = 140;
class $92f17257f5177c44$export$493da463fed0a57a {
    constructor(width, height, map, problems, mapByColumn, mapByRow){
        this.mapByColumn = [];
        this.mapByRow = [];
        this.width = width;
        this.height = height;
        this.mapByColumn = mapByColumn || [];
        this.mapByRow = mapByRow || [];
        // :: [number] A width * height array with the start position of
        // the cell covering that part of the table in each slot
        this.map = map;
        // An optional array of problems (cell overlap or non-rectangular
        // shape) for the table, used by the table normalizer.
        this.problems = problems;
    }
    // :: (number) → Rect
    // Find the dimensions of the cell at the given position.
    findCell(pos) {
        for(let i = 0; i < this.map.length; i++){
            const curPos = this.map[i];
            if (curPos !== pos) continue;
            const left = i % this.width;
            const top = i / this.width | 0;
            let right = left + 1;
            let bottom = top + 1;
            for(let j = 1; right < this.width && this.map[i + j] === curPos; j++)right++;
            for(let j = 1; bottom < this.height && this.map[i + this.width * j] === curPos; j++)bottom++;
            return new $92f17257f5177c44$export$c79fc6492f3af13d(left, top, right, bottom);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the left side of the cell at the given position.
    colCount(pos) {
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return i % this.width;
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the top side of the cell at the given position.
    rowCount(pos) {
        if (this.width <= 0) throw new RangeError('Wrong table width found');
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return Math.floor(i / this.width);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    isPosMerged(pos) {
        return this.map.includes(pos, this.map.indexOf(pos) + 1);
    }
    isCellMerged(row, col) {
        return this.isCellMergedTopLeft(row, col) || this.isCellMergedBottomRight(row, col);
    }
    isCellMergedTopLeft(row, col) {
        const pos = this.map[row * this.width + col];
        return(// top
        row > 0 && pos === this.map[(row - 1) * this.width + col] || // left
        col > 0 && pos === this.map[row * this.width + (col - 1)]);
    }
    isCellMergedBottomRight(row, col) {
        const pos = this.map[row * this.width + col];
        return(// bottom
        row < this.height - 1 && pos === this.map[(row + 1) * this.width + col] || // right
        col < this.width - 1 && pos === this.map[row * this.width + (col + 1)]);
    }
    // :: (number, string, number) → ?number
    // Find the next cell in the given direction, starting from the cell
    // at `pos`, if any.
    nextCell(pos, axis, dir) {
        const { left: left, right: right, top: top, bottom: bottom } = this.findCell(pos);
        if (axis === 'horiz') {
            if (dir < 0 ? left === 0 : right === this.width) return null;
            return this.map[top * this.width + (dir < 0 ? left - 1 : right)];
        } else {
            if (dir < 0 ? top === 0 : bottom === this.height) return null;
            return this.map[left + this.width * (dir < 0 ? top - 1 : bottom)];
        }
    }
    // :: (number, number) → Rect
    // Get the rectangle spanning the two given cells.
    rectBetween(a, b) {
        const { left: leftA, right: rightA, top: topA, bottom: bottomA } = this.findCell(a);
        const { left: leftB, right: rightB, top: topB, bottom: bottomB } = this.findCell(b);
        return new $92f17257f5177c44$export$c79fc6492f3af13d(Math.min(leftA, leftB), Math.min(topA, topB), Math.max(rightA, rightB), Math.max(bottomA, bottomB));
    }
    // :: (Rect) → [number]
    // Return the position of all cells that have the top left corner in
    // the given rectangle.
    cellsInRect(rect) {
        const result = [];
        const seen = {};
        for(let row = rect.top; row < rect.bottom; row++)for(let col = rect.left; col < rect.right; col++){
            const index = row * this.width + col;
            const pos = this.map[index];
            if (seen[pos]) continue;
            seen[pos] = true;
            if ((col !== rect.left || !col || this.map[index - 1] !== pos) && (row !== rect.top || !row || this.map[index - this.width] !== pos)) result.push(pos);
        }
        return result;
    }
    // :: (number, number, Node) → number
    // Return the position at which the cell at the given row and column
    // starts, or would start, if a cell started there.
    positionAt(row, col, table) {
        for(let i = 0, rowStart = 0;; i++){
            const rowEnd = rowStart + table.child(i).nodeSize;
            if (i === row) {
                let index = col + row * this.width;
                const rowEndIndex = (row + 1) * this.width;
                // Skip past cells from previous rows (via rowspan)
                while(index < rowEndIndex && this.map[index] < rowStart)index++;
                return index === rowEndIndex ? rowEnd - 1 : this.map[index];
            }
            rowStart = rowEnd;
        }
    }
    getMaxColInRow(pos) {
        const parentRowNode = pos.parent;
        if (parentRowNode.type.name === 'tableRow') return parentRowNode.childCount;
    }
    hasMergedCells() {
        const uniquePositions = new Set(this.map);
        return uniquePositions.size !== this.map.length;
    }
    // :: (Node) → TableMap
    // Find the table map for the given table node.
    static get(table) {
        return $92f17257f5177c44$var$readFromCache(table) || $92f17257f5177c44$var$addToCache(table, $92f17257f5177c44$var$computeMap(table));
    }
}
// Compute a table map.
function $92f17257f5177c44$var$computeMap(table) {
    if (table.type.spec.tableRole !== 'table') throw new RangeError('Not a table node: ' + table.type.name);
    const width = $92f17257f5177c44$var$findWidth(table);
    const height = table.childCount;
    const map = [];
    const colWidths = [];
    let mapPos = 0, problems = null;
    for(let i = 0, e = width * height; i < e; i++)map[i] = 0;
    for(let row = 0, pos = 0; row < height; row++){
        const rowNode = table.child(row);
        pos++;
        for(let i = 0;; i++){
            while(mapPos < map.length && map[mapPos] !== 0)mapPos++;
            if (i === rowNode.childCount) break;
            const cellNode = rowNode.child(i), { colspan: colspan, rowspan: rowspan, colwidth: colwidth } = cellNode.attrs;
            for(let h = 0; h < rowspan; h++){
                if (h + row >= height) {
                    (problems || (problems = [])).push({
                        type: "overlong_rowspan",
                        pos: pos,
                        n: rowspan - h
                    });
                    break;
                }
                const start = mapPos + h * width;
                for(let w = 0; w < colspan; w++){
                    if (map[start + w] === 0) map[start + w] = pos;
                    else (problems || (problems = [])).push({
                        type: "collision",
                        row: row,
                        pos: pos,
                        n: colspan - w
                    });
                    const colW = colwidth && colwidth[w];
                    if (colW) {
                        const widthIndex = (start + w) % width * 2, prev = colWidths[widthIndex];
                        if (prev == null || prev !== colW && colWidths[widthIndex + 1] === 1) {
                            colWidths[widthIndex] = colW;
                            colWidths[widthIndex + 1] = 1;
                        } else if (prev === colW) colWidths[widthIndex + 1]++;
                    }
                }
            }
            mapPos += colspan;
            pos += cellNode.nodeSize;
        }
        const expectedPos = (row + 1) * width;
        let missing = 0;
        while(mapPos < expectedPos)if (map[mapPos++] === 0) missing++;
        if (missing) (problems || (problems = [])).push({
            type: "missing",
            row: row,
            n: missing
        });
        pos++;
    }
    const mapByRow = Array(height);
    const mapByColumn = Array(width);
    for(let i = 0; i < map.length; i++){
        const columnIndex = i % width;
        mapByColumn[columnIndex] = mapByColumn[columnIndex] ?? [];
        mapByColumn[columnIndex].push(map[i]);
        const rowIndex = Math.trunc(i / width);
        mapByRow[rowIndex] = mapByRow[rowIndex] ?? [];
        mapByRow[rowIndex].push(map[i]);
    }
    const tableMap = new $92f17257f5177c44$export$493da463fed0a57a(width, height, map, problems, mapByColumn, mapByRow);
    let badWidths = false;
    // For columns that have defined widths, but whose widths disagree
    // between rows, fix up the cells whose width doesn't match the
    // computed one.
    for(let i = 0; !badWidths && i < colWidths.length; i += 2)if (colWidths[i] != null && colWidths[i + 1] < height) badWidths = true;
    // colWidths is an array of numbers, it can look like this
    // const colWidths = [255, 3, 125, 3, 150, 2, 130, 1];
    // 255 is a colWidth and 3 is a number of cells with this colwidth.
    // This check exists to make sure that the table has been resized,
    // which means there will be elements in the colWidths array.
    if (colWidths.length > 0 && colWidths.length !== width * 2) {
        for(let i = 0; i < width * 2 - colWidths.length; i++)colWidths.push($92f17257f5177c44$export$c60fae4049791eae, 0);
        badWidths = true;
    }
    if (badWidths) $92f17257f5177c44$var$findBadColWidths(tableMap, colWidths, table);
    return tableMap;
}
function $92f17257f5177c44$var$findWidth(table) {
    let width = -1;
    let hasRowSpan = false;
    for(let row = 0; row < table.childCount; row++){
        const rowNode = table.child(row);
        let rowWidth = 0;
        if (hasRowSpan) for(let j = 0; j < row; j++){
            const prevRow = table.child(j);
            for(let i = 0; i < prevRow.childCount; i++){
                const cell = prevRow.child(i);
                if (j + cell.attrs.rowspan > row) rowWidth += cell.attrs.colspan;
            }
        }
        for(let i = 0; i < rowNode.childCount; i++){
            const cell = rowNode.child(i);
            rowWidth += cell.attrs.colspan;
            if (cell.attrs.rowspan > 1) hasRowSpan = true;
        }
        if (width === -1) width = rowWidth;
        else if (width !== rowWidth) width = Math.max(width, rowWidth);
    }
    return width;
}
function $92f17257f5177c44$var$findBadColWidths(map, colWidths, table) {
    if (!map.problems) map.problems = [];
    const seen = {};
    for(let i = 0; i < map.map.length; i++){
        const pos = map.map[i];
        if (seen[pos]) continue;
        seen[pos] = true;
        const node = table.nodeAt(pos);
        let updated = null;
        for(let j = 0; j < node.attrs.colspan; j++){
            const col = (i + j) % map.width, colWidth = colWidths[col * 2];
            if (colWidth != null && (!node.attrs.colwidth || node.attrs.colwidth[j] !== colWidth)) (updated || (updated = $92f17257f5177c44$var$freshColWidth(node.attrs)))[j] = colWidth;
        }
        if (updated) map.problems.unshift({
            type: "colwidth mismatch",
            pos: pos,
            colwidth: updated
        });
    }
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $92f17257f5177c44$var$freshColWidth(attrs) {
    if (attrs.colwidth) return attrs.colwidth.slice();
    const result = [];
    for(let i = 0; i < attrs.colspan; i++)result.push(0);
    return result;
}

});

parcelRegister("cSPHa", function(module, exports) {
$parcel$export(module.exports, "pointsAtCell", () => $2dfed9e7e05b2316$export$3c89e45c7dff9619);
$parcel$export(module.exports, "cellNear", () => $2dfed9e7e05b2316$export$7a283ef453dbae9e);
$parcel$export(module.exports, "cellAround", () => $2dfed9e7e05b2316$export$1f482d92c57578ce);
$parcel$export(module.exports, "nextCell", () => $2dfed9e7e05b2316$export$172699367bb25225);

var $2vA54 = parcelRequire("2vA54");
function $2dfed9e7e05b2316$export$3c89e45c7dff9619($pos) {
    return $pos.parent.type.spec.tableRole === 'row' && $pos.nodeAfter;
}
function $2dfed9e7e05b2316$export$7a283ef453dbae9e($pos) {
    for(let after = $pos.nodeAfter, { pos: pos } = $pos; after; after = after.firstChild, pos++){
        const role = after.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos);
    }
    for(let before = $pos.nodeBefore, { pos: pos } = $pos; before; before = before.lastChild, pos--){
        const role = before.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos - before.nodeSize);
    }
    return null;
}
function $2dfed9e7e05b2316$export$1f482d92c57578ce($pos) {
    for(let d = $pos.depth - 1; d > 0; d--){
        if ($pos.node(d).type.spec.tableRole === 'row') return $pos.node(0).resolve($pos.before(d + 1));
    }
    return null;
}
function $2dfed9e7e05b2316$export$172699367bb25225($pos, axis, dir) {
    const start = $pos.start(-1);
    const map = (0, $2vA54.TableMap).get($pos.node(-1));
    const moved = map.nextCell($pos.pos - start, axis, dir);
    return moved == null ? null : $pos.node(0).resolve(start + moved);
}

});

parcelRegister("9K0SW", function(module, exports) {
$parcel$export(module.exports, "removeColSpan", () => $786bf010e3609b18$export$b24d9c3cc95412e0);
$parcel$export(module.exports, "assertColspan", () => $786bf010e3609b18$export$6fccdf7cee1b5201);
$parcel$export(module.exports, "addColSpan", () => $786bf010e3609b18$export$147ee78a1321ac36);
function $786bf010e3609b18$export$b24d9c3cc95412e0(attrs, pos, n = 1) {
    if (!attrs.colspan) throw new Error('removeColSpan(): attrs.colspan not defined');
    const result = {
        ...attrs,
        colspan: attrs.colspan - n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        result.colwidth.splice(pos, n);
        if (!result.colwidth.some((w)=>w > 0)) result.colwidth = undefined;
    }
    return result;
}
function $786bf010e3609b18$export$6fccdf7cee1b5201(attrs) {
    if (typeof attrs.colspan === 'undefined') throw new Error('addColSpan: attrs.colspan is not defined');
    if (typeof attrs.colspan !== 'number' || Number.isNaN(attrs.colspan) || attrs.colspan < 1) throw new Error(`addColSpan: attrs.colspan must be number >= 1, received: ${attrs.colspan}`);
}
function $786bf010e3609b18$export$147ee78a1321ac36(attrs, pos, n = 1) {
    $786bf010e3609b18$export$6fccdf7cee1b5201(attrs);
    const result = {
        ...attrs,
        colspan: attrs.colspan + n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        for(let i = 0; i < n; i++)result.colwidth.splice(pos, 0, 0);
    }
    return result;
}

});

parcelRegister("7VjxU", function(module, exports) {
$parcel$export(module.exports, "getCellSelectionRanges", () => $c774abe147af6cb9$export$a60a444208fd5099);

var $3lIcL = parcelRequire("3lIcL");

var $2vA54 = parcelRequire("2vA54");
function $c774abe147af6cb9$export$a60a444208fd5099($anchorCell, $headCell) {
    const table = $anchorCell.node(-1);
    const map = (0, $2vA54.TableMap).get(table);
    const start = $anchorCell.start(-1);
    const rect = map.rectBetween($anchorCell.pos - start, $headCell.pos - start);
    const doc = $anchorCell.node(0);
    const cells = map.cellsInRect(rect).filter((p)=>p !== $headCell.pos - start);
    // Make the head cell the first range, so that it counts as the
    // primary part of the selection
    cells.unshift($headCell.pos - start);
    return cells.map((pos)=>{
        const cell = table.nodeAt(pos);
        if (cell === null) throw new Error(`No cell at position ${pos}`);
        const from = pos + start + 1;
        return new (0, $3lIcL.SelectionRange)(doc.resolve(from), doc.resolve(from + cell.content.size));
    });
}

});



parcelRegister("LjYWw", function(module, exports) {
$parcel$export(module.exports, "shouldForceTracking", () => $c2e457fcbc1453ce$export$5b59d3e9e22dbdc6);
// START: temporary code https://product-fabric.atlassian.net/browse/ED-10260
const $c2e457fcbc1453ce$export$5b59d3e9e22dbdc6 = ()=>{
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const { FRONTEND_VERSION: FRONTEND_VERSION = '' } = window.__buildInfo || {};
        return window.location.hostname === 'product-fabric.atlassian.net' && FRONTEND_VERSION.includes('branch-deploy');
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err);
        return false;
    }
}; // END:  temporary code  https://product-fabric.atlassian.net/browse/ED-10260

});

parcelRegister("jgFE8", function(module, exports) {
$parcel$export(module.exports, "normalizeFeatureFlags", () => $36675c30e06e1565$export$f1485fc4974593c0);
$parcel$export(module.exports, "getEnabledFeatureFlagKeys", () => $36675c30e06e1565$export$6d018dd0f6cbebcb);

var $7mF43 = parcelRequire("7mF43");

var $4CEkC = parcelRequire("4CEkC");
const $36675c30e06e1565$var$EMPTY = {};
function $36675c30e06e1565$var$isObjectFlagKey(key, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
value, objectFlagKeys) {
    return Boolean(typeof value === 'string' && objectFlagKeys?.includes(key));
}
function $36675c30e06e1565$var$isValidJSONObject(value) {
    try {
        const result = JSON.parse(value);
        if (typeof result === 'object' && result !== null) return true;
        return false;
    } catch (err) {
        return false;
    }
}
function $36675c30e06e1565$export$f1485fc4974593c0(rawFeatureFlags, options) {
    if (!rawFeatureFlags) return $36675c30e06e1565$var$EMPTY;
    return Object.entries(rawFeatureFlags).filter((e)=>{
        if (typeof e[1] === 'boolean') return true;
        if ($36675c30e06e1565$var$isObjectFlagKey((0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))(e[0]), e[1], options?.objectFlagKeys) && $36675c30e06e1565$var$isValidJSONObject(e[1])) return true;
        return false;
    }).filter(([key])=>(0, (/*@__PURE__*/$parcel$interopDefault($4CEkC)))(key) === key).map(([key, value])=>[
            (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))(key),
            value
        ]).reduce((flags, [key, value])=>{
        if ($36675c30e06e1565$var$isObjectFlagKey(key, value, options?.objectFlagKeys)) flags[key] = JSON.parse(value);
        if (typeof value === 'boolean') flags[key] = value;
        return flags;
    }, {});
}
function $36675c30e06e1565$export$6d018dd0f6cbebcb(featureFlags) {
    return Object.keys(featureFlags).filter((key)=>featureFlags[key] === true);
}

});

parcelRegister("aYybS", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e23e48a41f0e258$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $3xw6l = parcelRequire("3xw6l");

var $cbSL1 = parcelRequire("cbSL1");

var $92xoS = parcelRequire("92xoS");
parcelRequire("lOeyo");
var $lbGwd = parcelRequire("lbGwd");
var $lOeyo = parcelRequire("lOeyo");

var $fB6mC = parcelRequire("fB6mC");

var $iOvh6 = parcelRequire("iOvh6");

var $bTpHi = parcelRequire("bTpHi");

var $cRsRn = parcelRequire("cRsRn");

var $BmspC = parcelRequire("BmspC");

var $eGOwo = parcelRequire("eGOwo");

var $g9wjI = parcelRequire("g9wjI");

var $fpMtm = parcelRequire("fpMtm");
var $QAAiN = parcelRequire("QAAiN");

var $37UKp = parcelRequire("37UKp");

var $fftJQ = parcelRequire("fftJQ");

var $7Uu7t = parcelRequire("7Uu7t");

var $bRAXN = parcelRequire("bRAXN");

var $7htLd = parcelRequire("7htLd");
function $2e23e48a41f0e258$var$mergeMarks(marksAndNodes) {
    return marksAndNodes.reduce((acc, markOrNode)=>{
        const prev = acc.length && acc[acc.length - 1] || null;
        if (markOrNode.type instanceof (0, $3xw6l.MarkType) && prev && prev.type instanceof (0, $3xw6l.MarkType) && Array.isArray(prev.content) && (0, $cRsRn.isSameMark)(prev, markOrNode)) prev.content = $2e23e48a41f0e258$var$mergeMarks(prev.content.concat(markOrNode.content));
        else acc.push(markOrNode);
        return acc;
    }, []);
}
class $2e23e48a41f0e258$export$2e2bcd8739ae039 {
    constructor(init){
        this.headingIds = [];
        /**
	 * The reason we have this extra array here is because we need to generate the same unique
	 * heading id for 2 different nodes: headers and expands (check the implementation of
	 * `getUniqueHeadingId` for more info).
	 *
	 * We will eventually need to refactor the current approach to generate unique ids
	 * for headers under this ticket -> https://product-fabric.atlassian.net/browse/ED-9668
	 */ this.expandHeadingIds = [];
        this.allowCopyToClipboard = false;
        this.allowWrapCodeBlock = false;
        this.allowPlaceholderText = true;
        this.allowCustomPanels = false;
        this.surroundTextNodesWithTextWrapper = false;
        this.allowAnnotations = false;
        this.standaloneBackgroundColorMarks = [];
        this.serializeFragmentChild = (node, { index: index, parentInfo: parentInfo })=>{
            const pos = this.startPos;
            const currentPath = parentInfo && parentInfo.path || [];
            const parentIsIncompleteTask = (node.type.name === 'taskItem' || node.type.name === 'blockTaskItem' && (0, $cbSL1.expValEquals)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true)) && node.attrs.state !== 'DONE' || // If blockTaskItem is in the schema, check if the parent of the current node
            // is an incomplete task item, because blockTaskItems can have nested nodes
            node.type.schema.nodes.blockTaskItem && parentInfo?.parentIsIncompleteTask === true && (0, $cbSL1.expValEquals)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true);
            const nodeKey = `${node.type.name}__${this.startPos}`;
            const serializedContent = this.serializeFragment(node.content, this.getNodeProps(node, parentInfo), (0, $lOeyo.toReact)(node, {
                allowSelectAllTrap: this.allowSelectAllTrap,
                allowWindowedCodeBlock: this.allowWindowedCodeBlock
            }, this.nodeComponents), nodeKey, {
                parentIsIncompleteTask: parentIsIncompleteTask,
                path: [
                    ...currentPath,
                    node
                ],
                pos: this.startPos
            });
            this.startPos = pos + node.nodeSize;
            const marks = node.marks ? [
                ...node.marks
            ] : [];
            const isMedia = node.type.name === 'media';
            const shouldSkipBorderMark = (mark)=>currentPath.some((n)=>n.type?.name !== 'mediaSingle') && isMedia && mark.type.name === 'border';
            const shouldSkipLinkMark = (mark)=>this.allowMediaLinking !== true && isMedia && mark.type.name === 'link';
            return marks.reduceRight((content, mark)=>{
                if (shouldSkipLinkMark(mark) || shouldSkipBorderMark(mark)) return content;
                return this.renderMark((0, $QAAiN.toReact)(mark), this.withMediaMarkProps(node, mark, this.getMarkProps(mark, [], node)), `${mark.type.name}-${index}`, content);
            }, serializedContent);
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.withMediaMarkProps = (node, mark, defaultProps)=>{
            if (mark.type.name === 'link' && node.type.name === 'media') return {
                ...defaultProps,
                isMediaLink: true
            };
            if (node.type.name === 'mediaInline' && mark.type.name === 'annotation') return {
                ...defaultProps,
                isMediaInline: true
            };
            return defaultProps;
        };
        this.getUnsupportedContentProps = (node)=>{
            return {
                node: node,
                dispatchAnalyticsEvent: this.fireAnalyticsEvent
            };
        };
        this.getAnnotationMarkProps = (mark, marksParentPath)=>{
            const annotationParentIds = (marksParentPath || []).reduce((acc, parent)=>{
                if ((0, $fpMtm.isAnnotationMark)(parent)) return [
                    ...acc,
                    parent.attrs.id
                ];
                return acc;
            }, []);
            return {
                id: mark.attrs.id,
                annotationType: mark.attrs.annotationType,
                annotationParentIds: annotationParentIds,
                allowAnnotations: this.allowAnnotations,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
        };
        this.getMarkProps = (mark, marksParentPath, node)=>{
            if ((0, $fpMtm.isAnnotationMark)(mark)) return this.getAnnotationMarkProps(mark, marksParentPath);
            const { key: key, ...otherAttrs } = mark.attrs;
            const extraProps = {
                isInline: node?.isInline
            };
            // currently the only mark which has custom props is the code mark
            const markSpecificProps = (0, $37UKp.isCodeMark)(mark) ? {
                // The appearance being mobile indicates we are in an renderer being
                // rendered by mobile bridge in a web view.
                // The tooltip is likely to have unexpected behaviour there, with being cut
                // off, so we disable it. This is also to keep the behaviour consistent with
                // the rendering in the mobile Native Renderer.
                codeBidiWarningTooltipEnabled: false
            } : {};
            const props = {
                eventHandlers: this.eventHandlers,
                fireAnalyticsEvent: this.fireAnalyticsEvent,
                markKey: key,
                ...otherAttrs,
                ...extraProps,
                ...markSpecificProps,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
            return props;
        };
        if ((0, $92xoS.editorExperiment)('comment_on_bodied_extensions', true)) {
            this.initStartPos = init.startPos || 1;
            this.startPos = init.startPos || 1;
        } else {
            this.initStartPos = 1;
            this.startPos = 1;
        }
        this.providers = init.providers;
        this.eventHandlers = init.eventHandlers;
        this.extensionHandlers = init.extensionHandlers;
        this.portal = init.portal;
        this.rendererContext = init.objectContext;
        this.appearance = init.appearance;
        this.contentMode = init.contentMode;
        this.disableHeadingIDs = init.disableHeadingIDs;
        this.disableActions = init.disableActions;
        this.allowHeadingAnchorLinks = init.allowHeadingAnchorLinks;
        this.allowCopyToClipboard = init.allowCopyToClipboard;
        this.allowWrapCodeBlock = init.allowWrapCodeBlock;
        this.allowPlaceholderText = init.allowPlaceholderText;
        this.allowCustomPanels = init.allowCustomPanels;
        this.allowColumnSorting = init.allowColumnSorting;
        this.fireAnalyticsEvent = init.fireAnalyticsEvent;
        this.shouldOpenMediaViewer = init.shouldOpenMediaViewer;
        this.allowAltTextOnImages = init.allowAltTextOnImages;
        this.stickyHeaders = init.stickyHeaders;
        this.allowMediaLinking = init.allowMediaLinking;
        this.allowAnnotations = Boolean(init.allowAnnotations);
        this.surroundTextNodesWithTextWrapper = Boolean(init.surroundTextNodesWithTextWrapper);
        this.media = init.media;
        this.emojiResourceConfig = init.emojiResourceConfig;
        this.smartLinks = init.smartLinks;
        this.extensionViewportSizes = init.extensionViewportSizes;
        this.getExtensionHeight = init.getExtensionHeight;
        this.allowSelectAllTrap = init.allowSelectAllTrap;
        this.nodeComponents = init.nodeComponents;
        this.allowWindowedCodeBlock = init.allowWindowedCodeBlock;
        this.isInsideOfInlineExtension = init.isInsideOfInlineExtension;
        this.textHighlighter = init.textHighlighter;
        this.allowTableAlignment = init.allowTableAlignment;
        this.allowTableResizing = init.allowTableResizing;
        this.isPresentational = init.isPresentational;
        this.disableTableOverflowShadow = init.disableTableOverflowShadow;
    }
    resetState() {
        this.headingIds = [];
        this.expandHeadingIds = [];
        this.startPos = this.initStartPos;
    }
    getNodeProps(node, parentInfo) {
        const path = parentInfo ? parentInfo.path : undefined;
        switch(node.type.name){
            case 'date':
                return this.getDateProps(node, parentInfo, path);
            case 'hardBreak':
                return this.getHardBreakProps(node, path);
            case 'heading':
                return this.getHeadingProps(node, path);
            case 'media':
                return this.getMediaProps(node, path);
            case 'emoji':
                return this.getEmojiProps(node, path);
            case 'extension':
            case 'bodiedExtension':
                return this.getExtensionProps(node, path);
            case 'mediaGroup':
                return this.getMediaGroupProps(node);
            case 'mediaInline':
                return this.getMediaInlineProps(node);
            case 'mediaSingle':
                return this.getMediaSingleProps(node, path);
            case 'table':
                return this.getTableProps(node, path);
            case 'tableHeader':
            case 'tableRow':
                return this.getTableChildrenProps(node);
            case 'taskItem':
                return this.getTaskItemProps(node, path);
            case 'embedCard':
                return this.getEmbedCardProps(node, path);
            case 'blockCard':
                return this.getBlockCardProps(node, path);
            case 'expand':
                return this.getExpandProps(node, path);
            case 'unsupportedBlock':
            case 'unsupportedInline':
                return this.getUnsupportedContentProps(node);
            case 'codeBlock':
                return this.getCodeBlockProps(node);
            case 'panel':
                return this.getPanelProps(node);
            default:
                return this.getProps(node, path);
        }
    }
    serializeFragment(fragment, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props = {}, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    target = this.allowSelectAllTrap ? (0, $lbGwd.DocWithSelectAllTrap) : (0, $lbGwd.default), key = 'root-0', parentInfo) {
        // This makes sure that we reset internal state on re-render.
        if (key === 'root-0') this.resetState();
        return this.renderNode(target, props, key, $2e23e48a41f0e258$export$2e2bcd8739ae039.getChildNodes(fragment).map((node, index)=>{
            if ((0, $lOeyo.isTextWrapper)(node)) return this.serializeTextWrapper(node.content, {
                index: index,
                parentInfo: parentInfo
            });
            return this.serializeFragmentChild(node, {
                index: index,
                parentInfo: parentInfo
            });
        }));
    }
    serializeTextWrapper(content, { index: index, parentInfo: parentInfo }) {
        const currentPath = parentInfo && parentInfo.path || [];
        const nodePosition = parentInfo && parentInfo.pos || 1;
        if ((0, $cbSL1.expValEquals)('platform_editor_text_highlight_padding', 'isEnabled', true)) this.standaloneBackgroundColorMarks.push(...(0, $7htLd.getStandaloneBackgroundColorMarks)(content));
        return $2e23e48a41f0e258$export$2e2bcd8739ae039.buildMarkStructure(content).map((mark, index)=>{
            return this.serializeMark({
                mark: mark,
                parentNode: {
                    path: currentPath,
                    pos: nodePosition
                },
                parentMark: {
                    path: [
                        mark
                    ]
                }
            });
        });
    }
    serializeMark({ mark: mark, parentNode: parentNode, parentMark: parentMark }) {
        if (!(0, $lOeyo.isTextNode)(mark)) {
            const serializeContent = (childMark, index)=>this.serializeMark({
                    mark: childMark,
                    parentNode: parentNode,
                    parentMark: {
                        path: [
                            ...parentMark.path,
                            childMark
                        ]
                    }
                });
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const content = (mark.content || []).map(serializeContent);
            const markKey = `${mark.type.name}-component__${this.startPos}__${parentMark.path.length}`;
            const isStandalone = (0, $cbSL1.expValEquals)('platform_editor_text_highlight_padding', 'isEnabled', true) && this.standaloneBackgroundColorMarks.some((m)=>mark.eq(m));
            return this.renderMark((0, $QAAiN.toReact)(mark), {
                ...this.getMarkProps(mark, parentMark.path),
                isStandalone: isStandalone
            }, markKey, content);
        }
        const startPos = this.startPos;
        const endPos = startPos + mark.nodeSize;
        this.startPos = endPos;
        const textKey = `text-wrapper_${this.startPos}`;
        if (this.surroundTextNodesWithTextWrapper) {
            const parentDepth = Math.max(parentNode.path.length - 1, 0);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fB6mC.default), {
                startPos: startPos + parentDepth,
                endPos: endPos + parentDepth,
                textHighlighter: this.textHighlighter,
                marks: mark.marks,
                children: mark.text
            }, textKey);
        }
        const segments = (0, $bRAXN.segmentText)(mark.text, this.textHighlighter);
        return (0, $7Uu7t.renderTextSegments)(segments, this.textHighlighter, mark.marks, startPos);
    }
    renderNode(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    NodeComponent, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props, key, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    content) {
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $gt9Am.jsx)(NodeComponent, {
            ...props,
            children: content
        }, key));
    }
    renderMark(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    MarkComponent, props, key, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    content) {
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $gt9Am.jsx)(MarkComponent, {
            ...props,
            children: content
        }, key));
    }
    getTableChildrenProps(node) {
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting
        };
    }
    getTableProps(node, path = []) {
        const isInsideOfBlockNode = (0, $fftJQ.insideBlockNode)(path, node.type.schema);
        const isInsideMultiBodiedExtension = (0, $fftJQ.insideMultiBodiedExtension)(path, node.type.schema);
        const isInsideOfTable = (0, $fftJQ.insideTable)(path, node.type.schema);
        // TODO: CEMS-1048 - Support sticky headers inside breakout + layout
        const stickyHeaders = !isInsideOfTable && !(0, $fftJQ.insideBreakoutLayout)(path) ? this.stickyHeaders : undefined;
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting,
            columnWidths: (0, $bTpHi.getColumnWidths)(node),
            tableNode: node,
            stickyHeaders: stickyHeaders,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isInsideOfTable: isInsideOfTable,
            isInsideMultiBodiedExtension: isInsideMultiBodiedExtension,
            allowTableAlignment: this.allowTableAlignment,
            allowTableResizing: this.allowTableResizing,
            isPresentational: (0, $eGOwo.fg)('platform_renderer_isPresentational') ? this.isPresentational : false,
            disableTableOverflowShadow: this.disableTableOverflowShadow
        };
    }
    getDateProps(node, parentInfo, path = []) {
        return {
            timestamp: node.attrs && node.attrs.timestamp,
            parentIsIncompleteTask: parentInfo && parentInfo.parentIsIncompleteTask,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': this.startPos + path.length
            }
        };
    }
    getMediaSingleProps(node, path = []) {
        const { marks: { link: link } } = node.type.schema;
        const isInsideOfBlockNode = (0, $fftJQ.insideBlockNode)(path, node.type.schema);
        const isLinkMark = (mark)=>mark.type === link;
        const childHasLink = node.firstChild && node.firstChild.marks.filter((m)=>isLinkMark(m) || this.allowMediaLinking === true).length;
        return {
            ...this.getProps(node, path),
            isInsideOfBlockNode: isInsideOfBlockNode,
            childHasLink: childHasLink,
            allowCaptions: this.media && this.media.allowCaptions,
            featureFlags: this.media && this.media.featureFlags
        };
    }
    getMediaProps(node, path = []) {
        const { marks: { annotation: annotation, link: link, border: border } } = node.type.schema;
        const isChildOfMediaSingle = path.some((n)=>n.type?.name === 'mediaSingle');
        const isAnnotationMark = (mark)=>mark.type === annotation;
        const isLinkMark = (mark)=>mark.type === link;
        const isBorderMark = (mark)=>isChildOfMediaSingle && mark.type === border;
        return {
            ...this.getProps(node, path),
            marks: node.marks.filter((m)=>!isLinkMark(m) || this.allowMediaLinking === true),
            isLinkMark: isLinkMark,
            isBorderMark: isBorderMark,
            isAnnotationMark: isAnnotationMark,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            ssr: this.media?.ssr,
            // surroundTextNodesWithTextWrapper checks inlineComment.allowDraftMode
            allowAnnotationsDraftMode: this.surroundTextNodesWithTextWrapper,
            enableSyncMediaCard: this.media?.enableSyncMediaCard
        };
    }
    getExtensionProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            extensionViewportSizes: this.extensionViewportSizes,
            nodeHeight: this.getExtensionHeight?.(node)
        };
    }
    getEmojiProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            resourceConfig: this.emojiResourceConfig
        };
    }
    getEmbedCardProps(node, path = []) {
        const isInsideOfBlockNode = (0, $fftJQ.insideBlockNode)(path, node.type.schema);
        return {
            ...this.getProps(node),
            isInsideOfBlockNode: isInsideOfBlockNode
        };
    }
    getBlockCardProps(node, path = []) {
        return {
            ...this.getProps(node),
            isNodeNested: path.length > 0
        };
    }
    getMediaGroupProps(node) {
        return {
            ...this.getProps(node),
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            enableDownloadButton: this.media?.enableDownloadButton,
            ssr: this.media?.ssr
        };
    }
    getMediaInlineProps(node) {
        return {
            ...this.getProps(node),
            ssr: this.media?.ssr
        };
    }
    getTaskItemProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            disabled: this.disableActions
        };
    }
    getHardBreakProps(node, path = []) {
        let forceNewLine = false;
        const parentNode = path.length > 0 ? path[path.length - 1] : null;
        if (parentNode && parentNode.lastChild === node) forceNewLine = true;
        return {
            ...this.getProps(node),
            forceNewLine: forceNewLine
        };
    }
    getCodeBlockProps(node) {
        // The appearance being mobile indicates we are in an renderer being
        // rendered by mobile bridge in a web view.
        // The tooltip is likely to have unexpected behaviour there, with being cut
        // off, so we disable it. This is also to keep the behaviour consistent with
        // the rendering in the mobile Native Renderer.
        const codeBidiWarningTooltipEnabled = false;
        return {
            ...this.getProps(node),
            text: node.textContent,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
        };
    }
    getPanelProps(node) {
        return {
            ...this.getProps(node),
            allowCustomPanels: this.allowCustomPanels
        };
    }
    getProps(node, path = []) {
        const startPos = this.startPos + path.length;
        return {
            text: node.text,
            providers: this.providers,
            eventHandlers: this.eventHandlers,
            extensionHandlers: this.extensionHandlers,
            portal: this.portal,
            rendererContext: this.rendererContext,
            serializer: this,
            content: node.content ? node.content.toJSON() : undefined,
            allowHeadingAnchorLinks: this.allowHeadingAnchorLinks,
            allowCopyToClipboard: this.allowCopyToClipboard,
            allowWrapCodeBlock: this.allowWrapCodeBlock,
            allowPlaceholderText: this.allowPlaceholderText,
            rendererAppearance: this.appearance,
            rendererContentMode: this.contentMode,
            fireAnalyticsEvent: this.fireAnalyticsEvent,
            nodeType: node.type.name,
            marks: node.marks,
            smartLinks: this.smartLinks,
            isInsideOfInlineExtension: this.isInsideOfInlineExtension,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': startPos
            },
            startPos: startPos,
            path: path,
            ...node.attrs
        };
    }
    headingAnchorSupported(path = []) {
        const isImmediateParent = (path, nodeName)=>{
            return path.length > 0 && path[path.length - 1].type.name === nodeName;
        };
        return (0, $iOvh6.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks) || path.length === 0 || isImmediateParent(path, 'layoutColumn');
    }
    getHeadingProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            content: node.content ? node.content.toJSON() : undefined,
            headingId: this.getHeadingId(node, this.headingIds),
            showAnchorLink: this.appearance !== 'comment' && this.allowHeadingAnchorLinks && !this.disableHeadingIDs && this.headingAnchorSupported(path)
        };
    }
    getExpandProps(node, path = []) {
        if (!(0, $iOvh6.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks)) return this.getProps(node);
        const nestedHeaderIds = (0, $BmspC.findChildrenByType)(node, node.type.schema.nodes.heading).map(({ node: node })=>this.getHeadingId(node, this.expandHeadingIds));
        return {
            ...this.getProps(node),
            nestedHeaderIds: nestedHeaderIds
        };
    }
    // The return value of this function is NOT url encoded,
    // In HTML5 standard, id can contain any characters, encoding is no necessary.
    // Plus we trying to avoid double encoding, therefore we leave the value as is.
    // Remember to use encodeURIComponent when generating url from the id value.
    getHeadingId(node, headingIds) {
        if (this.disableHeadingIDs || !node.content.size) return;
        // We are not use node.textContent here, because we would like to handle cases where
        // headings only contain inline blocks like emoji, status and date.
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const nodeContent = node.content.toJSON()// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((acc, node)=>acc.concat((0, $g9wjI.getText)(node) || ''), '').trim()// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/\s/g, '-');
        if (!nodeContent) return;
        return this.getUniqueHeadingId(nodeContent, headingIds);
    }
    getUniqueHeadingId(baseId, headingIds, counter = 0) {
        if (counter === 0 && headingIds.indexOf(baseId) === -1) {
            headingIds.push(baseId);
            return baseId;
        } else if (counter !== 0) {
            const headingId = `${baseId}.${counter}`;
            if (headingIds.indexOf(headingId) === -1) {
                headingIds.push(headingId);
                return headingId;
            }
        }
        return this.getUniqueHeadingId(baseId, headingIds, ++counter);
    }
    static getChildNodes(fragment) {
        const children = [];
        fragment.forEach((node)=>{
            children.push(node);
        });
        return (0, $lOeyo.mergeTextNodes)(children);
    }
    static getMarks(node) {
        if (!node.marks || node.marks.length === 0) return [];
        return (0, $cRsRn.getMarksByOrder)(node.marks);
    }
    static buildMarkStructure(content) {
        return $2e23e48a41f0e258$var$mergeMarks(content.map((node)=>{
            const nodeMarks = this.getMarks(node);
            if (nodeMarks.length === 0) return node;
            return nodeMarks.reverse().reduce((acc, mark)=>{
                const { eq: eq } = mark;
                return {
                    ...mark,
                    eq: eq,
                    content: [
                        acc
                    ]
                };
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            }, node);
        }));
    }
    // TODO: ED-9004 - Remove unused ReactSerializer.fromSchema in renderer
    // https://sourcegraph-frontend.internal.shared-prod.us-west-2.kitt-inf.net/search?q=ReactSerializer.fromSchema&patternType=literal
    static fromSchema(_, init) {
        return new $2e23e48a41f0e258$export$2e2bcd8739ae039(init);
    }
}

});
parcelRegister("lOeyo", function(module, exports) {
$parcel$export(module.exports, "InlineCard", () => $c1924200614751bb$export$aff6291803939b05);
$parcel$export(module.exports, "nodeToReact", () => $c1924200614751bb$export$3931063f6a5f290e);
$parcel$export(module.exports, "toReact", () => $c1924200614751bb$export$d4334b129116aad7);
$parcel$export(module.exports, "mergeTextNodes", () => $c1924200614751bb$export$8045509d14b5046f);
$parcel$export(module.exports, "isTextWrapper", () => $c1924200614751bb$export$d4ebd3557ee7fac1);
$parcel$export(module.exports, "isTextNode", () => $c1924200614751bb$export$ccbedd67ef6e9417);
$parcel$export(module.exports, "Doc", () => (parcelRequire("lbGwd")).default);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => (parcelRequire("lbGwd")).DocWithSelectAllTrap);
/* eslint-disable @atlaskit/editor/no-re-export */ // Mapping file

var $joSn0 = parcelRequire("joSn0");

var $93FVZ = parcelRequire("93FVZ");
var $dfCRV = parcelRequire("dfCRV");

var $eGOwo = parcelRequire("eGOwo");

var $jduyI = parcelRequire("jduyI");

var $fNF2S = parcelRequire("fNF2S");

var $bDynL = parcelRequire("bDynL");

var $9DR0p = parcelRequire("9DR0p");

var $gzcAo = parcelRequire("gzcAo");

var $53tmQ = parcelRequire("53tmQ");

var $lbGwd = parcelRequire("lbGwd");

var $fsEil = parcelRequire("fsEil");

var $3OwO2 = parcelRequire("3OwO2");

var $5v0qs = parcelRequire("5v0qs");

var $dnybp = parcelRequire("dnybp");

var $j3a3j = parcelRequire("j3a3j");

var $5YAb6 = parcelRequire("5YAb6");

var $lLYaS = parcelRequire("lLYaS");

var $9WY2n = parcelRequire("9WY2n");

var $fF9eS = parcelRequire("fF9eS");

var $lwXex = parcelRequire("lwXex");

var $gtUUa = parcelRequire("gtUUa");

var $aYUex = parcelRequire("aYUex");

var $idsFq = parcelRequire("idsFq");

var $lzf9g = parcelRequire("lzf9g");

var $eACId = parcelRequire("eACId");

var $eoMJq = parcelRequire("eoMJq");

const $c1924200614751bb$export$a22ee8f907eecb5f = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("gF78o")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$6c415d1fdae3dfdb = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("fpfZq")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$771a55a10b0a40ae = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("jv2lN")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$27c4189b8be1bf93 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("bk0oz")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$b458dfa720128865 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("5xqvU")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$b6f73a2b0b0de599 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("glfsH")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$6341f9a885713487 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("flFZe")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$96e9906d6d93a972 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("46r9p")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$56cc48506ff790a = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("2tsHJ")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$2ddb90ad54e5f587 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("h9546")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$6789d7ecdc77631b = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("lKCDC")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$aff6291803939b05 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("3Sn3X")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$d18ccd25c0d2c6b0 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("73bGp")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$7fc53215244aec38 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("glKdb")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$d7858be3df00d59 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("joUSr")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$462ea7c2a1c4cb1f = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("kPjsx")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$888d74bc001c3a5d = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("1paLD")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$e891316fea657d90 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("dcoh7")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$49bd1dfb0ad29c40 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("82LRg")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$var$SyncBlockLoader = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("1UWR4")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$var$BodiedSyncBlock = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("edBEs")).then((mod)=>mod.default),
    loading: ()=>null
});
const $c1924200614751bb$export$3931063f6a5f290e = {
    blockquote: (0, $jduyI.default),
    bulletList: (0, $53tmQ.default),
    blockCard: $c1924200614751bb$export$d18ccd25c0d2c6b0,
    caption: (0, $9WY2n.default),
    date: $c1924200614751bb$export$6341f9a885713487,
    decisionItem: $c1924200614751bb$export$b6f73a2b0b0de599,
    decisionList: $c1924200614751bb$export$b458dfa720128865,
    doc: (0, $lbGwd.default),
    emoji: $c1924200614751bb$export$56cc48506ff790a,
    extension: (0, $fsEil.default),
    bodiedExtension: (0, $fNF2S.default),
    multiBodiedExtension: (0, $9DR0p.default),
    extensionFrame: (0, $gzcAo.default),
    hardBreak: (0, $3OwO2.default),
    heading: (0, $5v0qs.default),
    inlineCard: $c1924200614751bb$export$aff6291803939b05,
    inlineExtension: (0, $dnybp.default),
    layoutSection: (0, $j3a3j.default),
    layoutColumn: (0, $5YAb6.default),
    listItem: (0, $lLYaS.default),
    media: $c1924200614751bb$export$7fc53215244aec38,
    mediaGroup: $c1924200614751bb$export$d7858be3df00d59,
    mediaInline: $c1924200614751bb$export$462ea7c2a1c4cb1f,
    mediaSingle: $c1924200614751bb$export$888d74bc001c3a5d,
    mention: $c1924200614751bb$export$e891316fea657d90,
    orderedList: (0, $fF9eS.default),
    panel: $c1924200614751bb$export$2ddb90ad54e5f587,
    paragraph: (0, $lwXex.default),
    placeholder: (0, $gtUUa.default),
    rule: (0, $aYUex.default),
    status: $c1924200614751bb$export$96e9906d6d93a972,
    taskItem: $c1924200614751bb$export$27c4189b8be1bf93,
    taskList: $c1924200614751bb$export$771a55a10b0a40ae,
    table: (0, $idsFq.default),
    tableCell: (0, $lzf9g.TableCell),
    tableHeader: (0, $lzf9g.TableHeader),
    tableRow: (0, $eACId.default),
    unknownBlock: (0, $eoMJq.default),
    unsupportedBlock: (0, $93FVZ.default),
    unsupportedInline: (0, $dfCRV.default),
    expand: $c1924200614751bb$export$49bd1dfb0ad29c40,
    syncBlock: $c1924200614751bb$var$SyncBlockLoader,
    bodiedSyncBlock: $c1924200614751bb$var$BodiedSyncBlock,
    nestedExpand: $c1924200614751bb$export$49bd1dfb0ad29c40,
    embedCard: $c1924200614751bb$export$6789d7ecdc77631b,
    blockTaskItem: $c1924200614751bb$export$27c4189b8be1bf93
};
const $c1924200614751bb$export$d4334b129116aad7 = (node, flags, nodeComponents)=>{
    if (node.type.name === 'doc' && flags?.allowSelectAllTrap === true) return 0, $lbGwd.DocWithSelectAllTrap;
    if (node.type.name === 'codeBlock') {
        if (flags?.allowWindowedCodeBlock === true) return $c1924200614751bb$export$a22ee8f907eecb5f;
        return $c1924200614751bb$export$6c415d1fdae3dfdb;
    }
    // Allowing custom components to override those provided in nodeToReact
    const nodes = {
        ...$c1924200614751bb$export$3931063f6a5f290e,
        ...nodeComponents
    };
    nodes['multiBodiedExtension'] = (0, $eGOwo.fg)('platform_editor_multi_body_extension_extensibility') ? (0, $9DR0p.default) : (0, $bDynL.default);
    return nodes[node.type.name];
};
const $c1924200614751bb$export$8045509d14b5046f = (nodes)=>{
    return nodes.reduce((acc, current)=>{
        if (!$c1924200614751bb$export$1879817ac5c922b7(current.type.name)) {
            acc.push(current);
            return acc;
        }
        // Append node to previous node, if it was a text wrapper
        if (acc.length > 0 && $c1924200614751bb$export$d4ebd3557ee7fac1(acc[acc.length - 1])) {
            const textWrapper = acc[acc.length - 1];
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            textWrapper.content.push(current);
            textWrapper.nodeSize += current.nodeSize;
        } else acc.push({
            type: {
                name: 'textWrapper'
            },
            content: [
                current
            ],
            nodeSize: current.nodeSize
        });
        return acc;
    }, []);
};
const $c1924200614751bb$export$1879817ac5c922b7 = (type)=>{
    return type === 'text';
};
const $c1924200614751bb$export$d4ebd3557ee7fac1 = (node)=>{
    return node.type.name === 'textWrapper';
};
function $c1924200614751bb$export$ccbedd67ef6e9417(node) {
    return node.type.name === 'text';
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $c1924200614751bb$var$whitespaceRegex = /^\s*$/;
const $c1924200614751bb$export$dd0c7365db1f79a5 = (doc)=>{
    if (doc.childCount !== 1) return false;
    const parentNodes = [];
    doc.forEach((child)=>parentNodes.push(child));
    const node = parentNodes[0];
    return node.type.name === 'paragraph' && $c1924200614751bb$var$isEmojiBlock(node.content);
};
const $c1924200614751bb$var$isEmojiBlock = (pnode)=>{
    const content = [];
    // Optimisation for long documents - worst case block will be space-emoji-space
    if (pnode.childCount > 7) return false;
    pnode.forEach((child)=>content.push(child));
    let emojiCount = 0;
    for(let i = 0; i < content.length; ++i){
        const node = content[i];
        switch(node.type.name){
            case 'text':
                if (node.text && !node.text.match($c1924200614751bb$var$whitespaceRegex)) return false;
                continue;
            case 'emoji':
                if (++emojiCount > 3) return false;
                continue;
            default:
                // Only text and emoji nodes are allowed
                return false;
        }
    }
    return emojiCount > 0;
};

});
parcelRegister("dfCRV", function(module, exports) {
$parcel$export(module.exports, "default", () => $e072a79986bfd933$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");

var $7yBx7 = parcelRequire("7yBx7");

var $k9Gmz = parcelRequire("k9Gmz");

var $k71qx = parcelRequire("k71qx");

var $bMFKb = parcelRequire("bMFKb");

var $gPpAv = parcelRequire("gPpAv");

var $3mTkR = parcelRequire("3mTkR");

var $z9Bay = parcelRequire("z9Bay");
const $e072a79986bfd933$var$inlineNodeStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    alignItems: 'center',
    background: "var(--ds-background-disabled, #091E4208)",
    border: `${"var(--ds-border-width, 1px)"} dashed ${"var(--ds-border-disabled, #091E420F)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-radius-small, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'inline-flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $7yBx7.relativeFontSizeToBase16)(14),
    margin: `0 ${"var(--ds-space-025, 2px)"}`,
    minHeight: '24px',
    padding: `0 ${"var(--ds-space-100, 8px)"}`,
    verticalAlign: 'middle',
    whiteSpace: 'nowrap'
});
const $e072a79986bfd933$var$UnsupportedInlineNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $z9Bay.getUnsupportedContent)((0, $gPpAv.unsupportedContentMessages).unsupportedInlineContent, 'Unsupported', node, intl);
    const tooltipContent = intl.formatMessage((0, $gPpAv.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $eJOHy.useRef)({
        padding: '4px'
    });
    const originalNodeType = node?.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $eJOHy.useCallback)(()=>dispatchAnalyticsEvent && (0, $3mTkR.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $bMFKb.ACTION_SUBJECT_ID).ON_UNSUPPORTED_INLINE, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $e072a79986bfd933$var$inlineNodeStyle
    }, message, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k71qx.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k9Gmz))), {
        label: "?",
        LEGACY_size: "small"
    }))));
};
var $e072a79986bfd933$export$2e2bcd8739ae039 = (0, $6YFG2.default)($e072a79986bfd933$var$UnsupportedInlineNode);

});

parcelRegister("jduyI", function(module, exports) {
$parcel$export(module.exports, "default", () => $74062e18b3abf97d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
function $74062e18b3abf97d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("blockquote", {
        "data-local-id": props.localId,
        children: props.children
    });
}

});

parcelRegister("fNF2S", function(module, exports) {
$parcel$export(module.exports, "default", () => $4efcd8b6a9f6e056$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $fsEil = parcelRequire("fsEil");

var $7DXmb = parcelRequire("7DXmb");

var $cZRB0 = parcelRequire("cZRB0");

var $ex5uO = parcelRequire("ex5uO");

var $bMFKb = parcelRequire("bMFKb");

var $csUn2 = parcelRequire("csUn2");

var $2uPUs = parcelRequire("2uPUs");

var $eGOwo = parcelRequire("eGOwo");
const $4efcd8b6a9f6e056$var$ValidationContextWrapper = ({ children: children })=>{
    // We override validation of nested tables in nested renderers as invalid ADF (but valid Prosemirror)
    // may have been introduced in the parent renderer's render and subsequent transformations.
    // For example - nested tables which are transformed from an extension node in ADF
    // to native Prosemirror nested table nodes in and this is invalid ADF.
    const validationContextValue = (0, $eJOHy.useMemo)(()=>({
            allowNestedTables: true
        }), []);
    if (!(0, $eGOwo.fg)('platform_editor_nested_table_extension_comment_fix')) return children;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2uPUs.ValidationContextProvider), {
        value: validationContextValue,
        children: children
    });
};
const $4efcd8b6a9f6e056$var$BodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [], extensionKey: extensionKey, extensionType: extensionType, parameters: parameters, extensionViewportSizes: extensionViewportSizes, localId: localId } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const removeOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children)// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7DXmb.ErrorBoundary), {
        component: (0, $ex5uO.ACTION_SUBJECT).RENDERER,
        componentId: (0, $bMFKb.ACTION_SUBJECT_ID).EXTENSION_BODIED,
        createAnalyticsEvent: createAnalyticsEvent,
        additionalInfo: `${extensionType}: ${extensionKey} `,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $csUn2.AnnotationsPositionContext).Provider, {
            value: {
                startPos: props.startPos + 1
            },
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($4efcd8b6a9f6e056$var$ValidationContextWrapper, {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cZRB0.default), {
                    ...props,
                    type: "bodiedExtension",
                    children: ({ result: result })=>{
                        try {
                            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(result)) // Return the content directly if it's a valid JSX.Element
                            return (0, $fsEil.renderExtension)(result, layout, {
                                isTopLevel: path.length < 1
                            }, removeOverflow, parameters?.extensionId, extensionViewportSizes, undefined, localId);
                        } catch (e) {
                        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
                        // Always return default content if anything goes wrong
                        return (0, $fsEil.renderExtension)(children, layout, {
                            isTopLevel: path.length < 1
                        }, removeOverflow, parameters?.extensionId, extensionViewportSizes, undefined, localId);
                    }
                })
            })
        })
    });
};
var $4efcd8b6a9f6e056$export$2e2bcd8739ae039 = $4efcd8b6a9f6e056$var$BodiedExtension;

});
parcelRegister("fsEil", function(module, exports) {
$parcel$export(module.exports, "renderExtension", () => $ad9414b9d01e2717$export$b7482bdc8aff85e4);
$parcel$export(module.exports, "default", () => $ad9414b9d01e2717$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $cZRB0 = parcelRequire("cZRB0");

var $k6yTf = parcelRequire("k6yTf");
var $2bEPZ = parcelRequire("2bEPZ");

var $bnh3n = parcelRequire("bnh3n");

var $iRC0e = parcelRequire("iRC0e");
const $ad9414b9d01e2717$var$viewportSizes = [
    'small',
    'medium',
    'default',
    'large',
    'xlarge'
];
// Mirrors sizes from https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/platform/packages/forge/xen-editor-provider/src/render/renderers/ForgeUIExtension.tsx
const $ad9414b9d01e2717$var$macroHeights = {
    small: '112px',
    medium: '262px',
    default: '262px',
    large: '524px',
    xlarge: '1048px'
};
const $ad9414b9d01e2717$var$getViewportSize = (extensionId, extensionViewportSizes)=>{
    if (!Array.isArray(extensionViewportSizes) || !extensionId) return;
    const extension = extensionViewportSizes.find((extension)=>extension.extensionId === extensionId);
    if (extension) {
        const viewportSize = extension.viewportSize && $ad9414b9d01e2717$var$viewportSizes.includes(extension.viewportSize) ? extension.viewportSize : 'default';
        return $ad9414b9d01e2717$var$macroHeights[viewportSize];
    }
};
const $ad9414b9d01e2717$export$b7482bdc8aff85e4 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
content, layout, options = {}, removeOverflow, extensionId, extensionViewportSizes, nodeHeight, localId)=>{
    const overflowContainerClass = !removeOverflow ? (0, $iRC0e.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
    // by default, we assume the extension is at top level, (direct child of doc node)
    const { isTopLevel: isTopLevel = true } = options || {};
    const centerAlignClass = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) ? (0, $iRC0e.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    /**
	 * To reduce cumulative layout shift, we check installed manifest values (viewportSize) for Forge and extension node parameters
	 * for Connect (legacy). As Connect is being phased out, we want Forge to also start to store its expected height
	 * in node parameters, especially for dynamic content macros. LegacyMacroStyledElements implements logic similar to here
	 * as the extension handler in CFE for legacy macros and Connect.
	 */ const viewportSize = $ad9414b9d01e2717$var$getViewportSize(extensionId, extensionViewportSizes);
    const extensionHeight = nodeHeight || viewportSize;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2bEPZ.WidthConsumer), {
        children: ({ width: width })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                ref: options.handleRef,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `${(0, $iRC0e.RendererCssClassName).EXTENSION} ${options.shadowClassNames} ${centerAlignClass}`,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    width: isTopLevel ? (0, $bnh3n.calcBreakoutWidth)(layout, width) : '100%',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    minHeight: `${extensionHeight}px`
                },
                "data-layout": layout,
                "data-local-id": localId,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: overflowContainerClass,
                    children: content
                })
            })
    });
};
const $ad9414b9d01e2717$var$Extension = (props)=>{
    const { text: text, layout: layout = 'default', handleRef: handleRef, shadowClassNames: shadowClassNames, path: path = [], extensionViewportSizes: extensionViewportSizes, parameters: parameters, nodeHeight: nodeHeight, localId: localId } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cZRB0.default), {
        ...props,
        type: "extension",
        children: ({ result: result })=>{
            try {
                // Return the result directly if it's a valid JSX.Element
                if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(result)) return $ad9414b9d01e2717$export$b7482bdc8aff85e4(result, layout, {
                    isTopLevel: path.length < 1,
                    handleRef: handleRef,
                    shadowClassNames: shadowClassNames
                }, undefined, parameters?.extensionId, extensionViewportSizes, nodeHeight, localId);
            } catch (e) {
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
            // Always return default content if anything goes wrong
            return $ad9414b9d01e2717$export$b7482bdc8aff85e4(text || 'extension', layout, {
                isTopLevel: path.length < 1,
                handleRef: handleRef,
                shadowClassNames: shadowClassNames
            }, undefined, parameters?.extensionId, extensionViewportSizes, nodeHeight, localId);
        }
    });
};
var $ad9414b9d01e2717$export$2e2bcd8739ae039 = (0, $k6yTf.default)($ad9414b9d01e2717$var$Extension, {
    overflowSelector: `.${(0, $iRC0e.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
});

});
parcelRegister("cZRB0", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e283c99cb64abbd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eJOHy = parcelRequire("eJOHy");

var $LFmXM = parcelRequire("LFmXM");

var $fvGDQ = parcelRequire("fvGDQ");

var $4sxxB = parcelRequire("4sxxB");

var $3AGQm = parcelRequire("3AGQm");

var $eGOwo = parcelRequire("eGOwo");
function $6e283c99cb64abbd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6e283c99cb64abbd$var$inlineExtensionStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'inline-block',
    maxWidth: '100%',
    verticalAlign: 'middle',
    // 0px margin top is important here.
    // When running on server-side emotion will generate style tags before elements.
    // This caused packages/editor/editor-common/src/styles/shared/block-marks.ts to override the margin-top.
    // However as soon as the styles are extracted to <head> it adds back the margin.
    // The timing is tricky as it happens to be when UFO collects the dimension for the placeholder for TTVC calculation.
    // This resulted 1px mismatch on the image. Further cause everything on page to shift by 1px.
    // es-lint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    margin: `0px 1px ${"var(--ds-space-050, 4px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& .rich-media-item': {
        maxWidth: '100%'
    }
});
const $6e283c99cb64abbd$var$plainTextMacroStyle = {
    name: "1b7osz4",
    styles: "display:inline;vertical-align:baseline;[data-macro-body]{display:inline;}"
};
function $6e283c99cb64abbd$export$2e2bcd8739ae039(props) {
    const { extensionHandlers: extensionHandlers, rendererContext: rendererContext, extensionType: extensionType, extensionKey: extensionKey, parameters: parameters, content: content, text: text, type: type, localId: localId, marks: marks, actions: actions, children: children } = props;
    const isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(true);
    const localGetNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>(0, $LFmXM.default)((0, $fvGDQ.getNodeRenderer)), []);
    const [extensionProvider, setExtensionProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(null);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleProvider = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((name, providerPromise)=>{
        providerPromise && providerPromise.then((provider)=>{
            if (isMounted.current) setExtensionProvider(provider);
        });
    }, []);
    const renderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((extensionProvider)=>{
        const fragmentLocalId = marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
        const node = {
            type: type,
            extensionKey: extensionKey,
            extensionType: extensionType,
            parameters: parameters,
            content: content || text,
            localId: localId,
            fragmentLocalId: fragmentLocalId
        };
        const isPlainTextMacro = Boolean(node?.parameters?.macroParams?.__bodyContent);
        let result = null;
        try {
            if (extensionHandlers && extensionHandlers[extensionType]) {
                const render = (0, $3AGQm.getExtensionRenderer)(extensionHandlers[extensionType]);
                result = render(node, rendererContext.adDoc);
            }
            if (!result && extensionProvider) {
                const NodeRenderer = localGetNodeRenderer(extensionProvider, extensionType, extensionKey);
                if (node.type === 'multiBodiedExtension') result = /*#__PURE__*/ (0, $1NIU8.jsx)(NodeRenderer, {
                    node: node,
                    actions: actions
                });
                else if (node.type === 'inlineExtension') {
                    if ((0, $eGOwo.fg)('platform_editor_renderer_inline_extension_improve')) result = /*#__PURE__*/ (0, $1NIU8.jsx)($6e283c99cb64abbd$export$f41ccc3bd3324832, {
                        isPlainTextMacro: isPlainTextMacro
                    }, /*#__PURE__*/ (0, $1NIU8.jsx)(NodeRenderer, {
                        node: node
                    }));
                    else result = /*#__PURE__*/ (0, $1NIU8.jsx)($6e283c99cb64abbd$export$f41ccc3bd3324832, null, /*#__PURE__*/ (0, $1NIU8.jsx)(NodeRenderer, {
                        node: node
                    }));
                } else result = /*#__PURE__*/ (0, $1NIU8.jsx)(NodeRenderer, {
                    node: node
                });
            }
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        return children({
            result: result
        });
    }, [
        actions,
        children,
        content,
        extensionHandlers,
        extensionKey,
        extensionType,
        localGetNodeRenderer,
        localId,
        marks,
        parameters,
        rendererContext?.adDoc,
        text,
        type
    ]);
    const setupAndRenderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((providers)=>{
        if (!extensionProvider && providers.extensionProvider) handleProvider('extensionProvider', providers.extensionProvider);
        return renderExtensionNode(extensionProvider);
    }, [
        extensionProvider,
        handleProvider,
        renderExtensionNode
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    if (!props.providers) return setupAndRenderExtensionNode({});
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $4sxxB.WithProviders), {
        providers: [
            'extensionProvider'
        ],
        providerFactory: props.providers,
        renderNode: setupAndRenderExtensionNode
    });
}
const $6e283c99cb64abbd$export$f41ccc3bd3324832 = ({ children: children, isPlainTextMacro: isPlainTextMacro, ssrPlaceholder: ssrPlaceholder, ssrPlaceholderReplace: ssrPlaceholderReplace })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `inline-extension-renderer ${isPlainTextMacro ? 'plain-text-macro' : ''}`,
        css: [
            $6e283c99cb64abbd$var$inlineExtensionStyle,
            isPlainTextMacro && $6e283c99cb64abbd$var$plainTextMacroStyle
        ],
        "data-ssr-placeholder": ssrPlaceholder,
        "data-ssr-placeholder-replace": ssrPlaceholderReplace
    }, children);
};

});
parcelRegister("fvGDQ", function(module, exports) {
$parcel$export(module.exports, "getExtensionModuleNode", () => $9bf604c19126813a$export$82dd45c2db936caf);
$parcel$export(module.exports, "getExtensionModuleNodePrivateProps", () => $9bf604c19126813a$export$426f8efd8690d8aa);
$parcel$export(module.exports, "getNodeRenderer", () => $9bf604c19126813a$export$67a7d49db68d30a0);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $joSn0 = parcelRequire("joSn0");

var $l3kPA = parcelRequire("l3kPA");
function $9bf604c19126813a$var$getNodeFromManifest(// eslint-disable-next-line @typescript-eslint/no-explicit-any
manifest, extKey, nodeKey, extensionType, extensionKey) {
    if (!manifest) throw new Error(`Extension with key "${extKey}" and type "${extensionType}" not found!`);
    if (!manifest.modules.nodes) throw new Error(`Couldn't find any node for extension type "${extensionType}" and key "${extensionKey}"!`);
    const node = manifest.modules.nodes[nodeKey];
    if (!node) throw new Error(`Node with key "${extensionKey}" not found on manifest for extension type "${extensionType}" and key "${extensionKey}"!`);
    return node;
}
async function $9bf604c19126813a$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey) {
    const [extKey, nodeKey] = (0, $l3kPA.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const manifest = await extensionProvider.getExtension(extensionType, extKey);
    return $9bf604c19126813a$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey);
}
function $9bf604c19126813a$export$903681ffb5af37a7(extensionProvider, extensionType, extensionKey) {
    const [extKey, nodeKey] = (0, $l3kPA.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const manifest = extensionProvider?.getPreloadedExtension?.(extensionType, extKey);
    if (manifest) return $9bf604c19126813a$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey);
    else return extensionProvider.getExtension(extensionType, extKey).then((manifest)=>$9bf604c19126813a$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey));
}
async function $9bf604c19126813a$export$426f8efd8690d8aa(extensionProvider, extensionType, extensionKey) {
    const moduleNode = await $9bf604c19126813a$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey);
    return Object.keys(moduleNode).filter((key)=>key.startsWith('__')).reduce((acc, key)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        acc[key] = moduleNode[key];
        return acc;
    }, {});
}
function $9bf604c19126813a$var$ExtensionLoading(props) {
    if (props.error || props.timedOut) {
        // eslint-disable-next-line no-console
        console.error('Error rendering extension', props.error);
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            children: "Error loading the extension!"
        });
    } else return null;
}
function $9bf604c19126813a$export$67a7d49db68d30a0(extensionProvider, extensionType, extensionKey) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
        loader: ()=>{
            const maybePromise = $9bf604c19126813a$export$903681ffb5af37a7(extensionProvider, extensionType, extensionKey);
            if (maybePromise instanceof Promise) return maybePromise.then((node)=>(0, $l3kPA.resolveImport)(node.render()));
            else {
                const preloaded = maybePromise?.renderSync?.();
                // Only product implemented preloading will return sync result
                // However the out-of-box won't handle this. Confluence uses a custom implementation
                return preloaded ? (0, $l3kPA.resolveImportSync)(preloaded) : (0, $l3kPA.resolveImport)(maybePromise.render());
            }
        },
        loading: $9bf604c19126813a$var$ExtensionLoading
    });
}

});
parcelRegister("l3kPA", function(module, exports) {
$parcel$export(module.exports, "getExtensionKeyAndNodeKey", () => $258d69c4789a7f77$export$8a49818572e1d105);
$parcel$export(module.exports, "buildAction", () => $258d69c4789a7f77$export$bb33bcdd9a10a608);
$parcel$export(module.exports, "resolveImportSync", () => $258d69c4789a7f77$export$dca2026e63034304);
$parcel$export(module.exports, "resolveImport", () => $258d69c4789a7f77$export$d69c9b451c47653b);
const $258d69c4789a7f77$export$a7d04c836550045a = 'com.atlassian.ecosystem';
const $258d69c4789a7f77$export$8a49818572e1d105 = (extensionKey, extensionType)=>{
    // Forge macro extensionKey has a user generated string, so splitting on
    // a colon is unstable for their particular use case. They only have one
    // node in the relevant manifest so we can hardcode nodeKey to 'default'.
    if (extensionType === $258d69c4789a7f77$export$a7d04c836550045a) return [
        extensionKey,
        'default'
    ];
    const [extKey, nodeKey = 'default'] = extensionKey.split(':');
    return [
        extKey,
        nodeKey
    ];
};
const $258d69c4789a7f77$export$5f3eb042babacbbd = (extensionKey, nodeKey)=>{
    if (!nodeKey || nodeKey === 'default') return extensionKey;
    return `${extensionKey}:${nodeKey}`;
};
function $258d69c4789a7f77$export$bb33bcdd9a10a608(action, manifest) {
    if (typeof action === 'function') return action;
    if (action.type === 'node' && manifest.modules.nodes) return $258d69c4789a7f77$export$33863d887d6f4bfd(action, manifest);
}
const $258d69c4789a7f77$export$dca2026e63034304 = (importedModule)=>{
    return importedModule && importedModule.__esModule ? importedModule.default : importedModule;
};
const $258d69c4789a7f77$export$d69c9b451c47653b = async (importPromise)=>{
    return $258d69c4789a7f77$export$dca2026e63034304(await importPromise);
};
function $258d69c4789a7f77$export$33863d887d6f4bfd(action, manifest) {
    if (!manifest.modules.nodes) return;
    const node = manifest.modules.nodes[action.key];
    const extensionKey = $258d69c4789a7f77$export$5f3eb042babacbbd(manifest.key, action.key);
    const extension = {
        type: node.type,
        attrs: {
            extensionType: manifest.type,
            extensionKey: extensionKey,
            parameters: action.parameters
        }
    };
    if (node.type === 'bodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    };
    else if (node.type === 'multiBodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'extensionFrame',
                content: [
                    {
                        type: 'paragraph',
                        content: []
                    }
                ]
            }
        ]
    };
    return extension;
}

});


parcelRegister("4sxxB", function(module, exports) {
$parcel$export(module.exports, "WithProviders", () => $b2c1f4a7501c3351$export$d498ee8be33e096f);
/* eslint-disable @repo/internal/react/no-class-components */ 
var $eJOHy = parcelRequire("eJOHy");
class $b2c1f4a7501c3351$export$d498ee8be33e096f extends (0, $eJOHy.PureComponent) {
    static{
        this.displayName = 'WithProviders';
    }
    constructor(props){
        super(props), this.mounted = false, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleProviderIfMounted = (name, provider)=>{
            if (!this.mounted) return;
            this.handleProvider(name, provider);
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleProvider = (name, provider)=>{
            this.setState(({ providers: providers })=>{
                return {
                    providers: {
                        ...providers,
                        [name]: provider
                    }
                };
            });
        };
        this.mounted = false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const providers = {};
        this.props.providers.forEach((name)=>{
            const providerPromise = props.providerFactory.subscribe(name, this.handleProviderIfMounted);
            providers[name] = providerPromise;
        });
        this.state = {
            providers: providers
        };
    }
    componentDidMount() {
        this.mounted = true;
    }
    componentWillUnmount() {
        const { providers: providers, providerFactory: providerFactory } = this.props;
        providers.forEach((name)=>{
            providerFactory.unsubscribe(name, this.handleProviderIfMounted);
        });
    }
    render() {
        const { state: state, props: props } = this;
        const { renderNode: renderNode } = props;
        return renderNode(state.providers);
    }
}

});

parcelRegister("3AGQm", function(module, exports) {
$parcel$export(module.exports, "getExtensionRenderer", () => $4754977c03885da7$export$9214452ef07eda7);
function $4754977c03885da7$export$9214452ef07eda7(extensionHandler) {
    if (typeof extensionHandler === 'object') return extensionHandler.render;
    else return extensionHandler;
}

});


parcelRegister("k6yTf", function(module, exports) {
$parcel$export(module.exports, "shadowClassNames", () => $da606684968a05e6$export$4735dd2b0fa88aa5);
$parcel$export(module.exports, "default", () => $da606684968a05e6$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3gw29 = parcelRequire("3gw29");
const $da606684968a05e6$export$4735dd2b0fa88aa5 = {
    RIGHT_SHADOW: 'right-shadow',
    LEFT_SHADOW: 'left-shadow'
};
function $da606684968a05e6$export$2e2bcd8739ae039(Component, options) {
    return class OverflowShadow extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
        componentWillUnmount() {
            if (options.useShadowObserver) return this.shadowObserver && this.shadowObserver.dispose();
            if (this.overflowContainer) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowContainer.removeEventListener('scroll', this.handleScroll);
            this.updateShadows();
        }
        componentDidUpdate() {
            if (!options.useShadowObserver) this.updateShadows();
        }
        initShadowObserver() {
            if (this.shadowObserver || !this.overflowContainer) return;
            this.shadowObserver = new (0, $3gw29.ShadowObserver)({
                scrollContainer: this.overflowContainer,
                onUpdateShadows: (shadowStates)=>{
                    this.setState((prevState)=>{
                        const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = shadowStates;
                        if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== prevState.showRightShadow) return {
                            showLeftShadow: showLeftShadow,
                            showRightShadow: showRightShadow
                        };
                        return null;
                    });
                }
            });
        }
        render() {
            const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = this.state;
            const classNames = [
                !this.props?.disableTableOverflowShadow && showRightShadow && $da606684968a05e6$export$4735dd2b0fa88aa5.RIGHT_SHADOW,
                !this.props?.disableTableOverflowShadow && showLeftShadow && $da606684968a05e6$export$4735dd2b0fa88aa5.LEFT_SHADOW,
                options.useShadowObserver && (0, $3gw29.shadowObserverClassNames).SHADOW_CONTAINER
            ].filter(Boolean).join(' ');
            return(// Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                handleRef: this.handleContainer,
                shadowClassNames: classNames,
                ...this.props
            }));
        }
        constructor(...args){
            super(...args), this.overflowContainerWidth = 0, this.state = {
                showLeftShadow: false,
                showRightShadow: false
            }, this.handleScroll = (event)=>{
                if (!this.overflowContainer || event.target !== this.overflowContainer || options.useShadowObserver) return;
                this.updateShadows();
            }, this.updateShadows = ()=>{
                if (options.useShadowObserver) return;
                this.setState((prevState)=>{
                    if (!this.overflowContainer) return;
                    const diff = this.calcOverflowDiff();
                    const showRightShadow = diff > 0 && diff > this.overflowContainer.scrollLeft;
                    const showLeftShadow = this.showLeftShadow(this.overflowContainer);
                    if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== this.state.showRightShadow) return {
                        showLeftShadow: showLeftShadow,
                        showRightShadow: showRightShadow
                    };
                    return null;
                });
            }, this.showLeftShadow = (overflowContainer)=>{
                return !!overflowContainer && overflowContainer.scrollLeft > 0;
            }, this.calcOverflowDiff = ()=>{
                if (!this.overflowContainer) return 0;
                this.diff = this.calcScrollableWidth();
                return this.diff - this.overflowContainer.offsetWidth;
            }, this.calcScrollableWidth = ()=>{
                if (!this.scrollable && this.overflowContainer) return this.overflowContainer.scrollWidth;
                if (!this.scrollable) return 0;
                let width = 0;
                for(let i = 0; i < this.scrollable.length; i++){
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const scrollableElement = this.scrollable[i];
                    width += scrollableElement.scrollWidth;
                }
                return width;
            }, this.handleContainer = (container)=>{
                if (!container || this.container) return;
                this.container = container;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                this.overflowContainer = container.querySelector(options.overflowSelector);
                if (!this.overflowContainer) this.overflowContainer = container;
                if (options.useShadowObserver) {
                    this.initShadowObserver();
                    return;
                }
                this.updateShadows();
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.overflowContainer.addEventListener('scroll', this.handleScroll);
            };
        }
    };
}

});
parcelRegister("3gw29", function(module, exports) {
$parcel$export(module.exports, "shadowObserverClassNames", () => $035d40e16bddbfa4$export$1cbe0bb16052178d);
$parcel$export(module.exports, "ShadowObserver", () => $035d40e16bddbfa4$export$51a5b28e4fb2dba2);
var $035d40e16bddbfa4$export$ebeea2fe2e93862e = /*#__PURE__*/ function(ShadowKeys) {
    ShadowKeys["SHOW_LEFT_SHADOW"] = "showLeftShadow";
    ShadowKeys["SHOW_RIGHT_SHADOW"] = "showRightShadow";
    return ShadowKeys;
}({});
const $035d40e16bddbfa4$export$1cbe0bb16052178d = {
    SENTINEL_LEFT: 'sentinel-left',
    SENTINEL_RIGHT: 'sentinel-right',
    SHADOW_CONTAINER: 'with-shadow-observer'
};
const $035d40e16bddbfa4$var$requestIdleCallback = (fn)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.requestIdleCallback ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn) : window.requestAnimationFrame(fn);
};
const $035d40e16bddbfa4$var$cancelIdleCallback = (id)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.cancelIdleCallback ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.cancelIdleCallback(id) : window.cancelAnimationFrame(id);
};
class $035d40e16bddbfa4$export$51a5b28e4fb2dba2 {
    constructor({ scrollContainer: scrollContainer, onUpdateShadows: onUpdateShadows }){
        this.sentinels = {};
        this.shadowStates = {
            ["showLeftShadow"]: false,
            ["showRightShadow"]: false
        };
        this.init = ()=>{
            if (!this.scrollContainer || this.intersectionObserver) return;
            this.sentinels.right = document.createElement('div');
            this.sentinels.right.classList.add($035d40e16bddbfa4$export$1cbe0bb16052178d.SENTINEL_RIGHT);
            this.scrollContainer.appendChild(this.sentinels.right);
            this.sentinels.left = document.createElement('div');
            this.sentinels.left.classList.add($035d40e16bddbfa4$export$1cbe0bb16052178d.SENTINEL_LEFT);
            this.scrollContainer.prepend(this.sentinels.left);
            this.intersectionObserver = new IntersectionObserver((entries, _)=>{
                entries.forEach(this.onIntersect);
            }, {
                root: this.scrollContainer,
                rootMargin: '1px'
            });
            this.intersectionObserver.observe(this.sentinels.left);
            this.intersectionObserver.observe(this.sentinels.right);
        };
        this.onIntersect = (entry)=>{
            this.requestCallbackId = $035d40e16bddbfa4$var$requestIdleCallback(()=>{
                if (entry.target.classList.contains($035d40e16bddbfa4$export$1cbe0bb16052178d.SENTINEL_LEFT)) this.shadowStates["showLeftShadow"] = !entry.isIntersecting;
                if (entry.target.classList.contains($035d40e16bddbfa4$export$1cbe0bb16052178d.SENTINEL_RIGHT)) this.shadowStates["showRightShadow"] = !entry.isIntersecting;
                this.onUpdateShadows(this.shadowStates);
            });
        };
        this.scrollContainer = scrollContainer;
        this.onUpdateShadows = onUpdateShadows;
        this.init();
    }
    dispose() {
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            this.intersectionObserver = undefined;
            this.requestCallbackId && $035d40e16bddbfa4$var$cancelIdleCallback(this.requestCallbackId);
        }
    }
}

});


parcelRegister("bnh3n", function(module, exports) {
$parcel$export(module.exports, "breakoutConsts", () => $a68a669b79a16fde$export$ead1fecec2ecf57c);
$parcel$export(module.exports, "absoluteBreakoutWidth", () => $a68a669b79a16fde$export$b34ea040d1533a3);
$parcel$export(module.exports, "calcWideWidth", () => $a68a669b79a16fde$export$86325001fe8f3adc);
$parcel$export(module.exports, "calcBreakoutWidth", () => $a68a669b79a16fde$export$5f4502874a28dfce);
$parcel$export(module.exports, "calculateBreakoutStyles", () => $a68a669b79a16fde$export$c377853ecdd53e5b);
$parcel$export(module.exports, "getNextBreakoutMode", () => $a68a669b79a16fde$export$7eb758567e6644fd);
$parcel$export(module.exports, "getTitle", () => $a68a669b79a16fde$export$70d1bf7729efff40);

var $7yBx7 = parcelRequire("7yBx7");

var $h2yqz = parcelRequire("h2yqz");

var $iZVrE = parcelRequire("iZVrE");

var $2bEPZ = parcelRequire("2bEPZ");

var $7SIsS = parcelRequire("7SIsS");
const $a68a669b79a16fde$export$ead1fecec2ecf57c = {
    padding: (0, $7yBx7.akEditorBreakoutPadding),
    defaultLayoutWidth: (0, $7yBx7.akEditorDefaultLayoutWidth),
    wideScaleRatio: (0, $7yBx7.breakoutWideScaleRatio),
    fullWidthLayoutWidth: (0, $7yBx7.akEditorFullWidthLayoutWidth),
    wideLayoutWidth: (0, $7yBx7.akEditorWideLayoutWidth),
    mapBreakpointToLayoutMaxWidth: $iZVrE.mapBreakpointToLayoutMaxWidth,
    getBreakpoint: $2bEPZ.getBreakpoint,
    /**
	 * This function can return percentage value or px value depending upon the inputs
	 */ calcBreakoutWidth: (breakoutConsts)=>(layout, containerWidth, padding)=>{
            const effectiveFullWidth = containerWidth - (padding ?? breakoutConsts.padding);
            switch(layout){
                case 'full-width':
                    return `${Math.min(effectiveFullWidth, breakoutConsts.fullWidthLayoutWidth)}px`;
                case 'wide':
                    if (effectiveFullWidth <= 0) return '100%';
                    const wideWidth = breakoutConsts.calcWideWidth(breakoutConsts)(containerWidth, undefined, undefined, padding);
                    if (wideWidth.endsWith('%')) return `${Math.min(effectiveFullWidth, breakoutConsts.fullWidthLayoutWidth)}px`;
                    return wideWidth;
                default:
                    return '100%';
            }
        },
    calcBreakoutWithCustomWidth: (breakoutConsts)=>(mode, width, editorContainerWidth)=>{
            if (width !== null && width > 0) {
                const effectiveFullWidth = editorContainerWidth - breakoutConsts.padding;
                // if below 0 then expect we're rendering in SSR
                return `${Math.min(width, effectiveFullWidth)}px`;
            }
            return breakoutConsts.calcBreakoutWidth(breakoutConsts)(mode, editorContainerWidth);
        },
    calcLineLength: (breakoutConsts)=>()=>breakoutConsts.defaultLayoutWidth,
    calcWideWidth: (breakoutConsts)=>(containerWidth = breakoutConsts.defaultLayoutWidth, maxWidth = Infinity, fallback = '100%', padding)=>{
            const effectiveFullWidth = containerWidth - (padding ?? breakoutConsts.padding);
            const layoutMaxWidth = breakoutConsts.mapBreakpointToLayoutMaxWidth(breakoutConsts.getBreakpoint(containerWidth));
            const wideWidth = Math.min(Math.ceil(layoutMaxWidth * breakoutConsts.wideScaleRatio), effectiveFullWidth);
            return layoutMaxWidth > wideWidth ? fallback : `${Math.min(maxWidth, wideWidth)}px`;
        }
};
const $a68a669b79a16fde$export$b34ea040d1533a3 = (layout, containerWidth)=>{
    const breakoutWidth = $a68a669b79a16fde$export$ead1fecec2ecf57c.calcBreakoutWidth($a68a669b79a16fde$export$ead1fecec2ecf57c)(layout, containerWidth);
    // If it's percent, map to max layout size
    if (breakoutWidth.endsWith('%')) switch(layout){
        case 'full-width':
            return 0, $7yBx7.akEditorFullWidthLayoutWidth;
        case 'wide':
            return 0, $7yBx7.akEditorWideLayoutWidth;
        default:
            return $a68a669b79a16fde$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($a68a669b79a16fde$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
    }
    return parseInt(breakoutWidth, 10);
};
const $a68a669b79a16fde$export$86325001fe8f3adc = $a68a669b79a16fde$export$ead1fecec2ecf57c.calcWideWidth($a68a669b79a16fde$export$ead1fecec2ecf57c);
const $a68a669b79a16fde$export$5f4502874a28dfce = $a68a669b79a16fde$export$ead1fecec2ecf57c.calcBreakoutWidth($a68a669b79a16fde$export$ead1fecec2ecf57c);
const $a68a669b79a16fde$export$ccc0a02edddeed39 = $a68a669b79a16fde$export$ead1fecec2ecf57c.calcBreakoutWithCustomWidth($a68a669b79a16fde$export$ead1fecec2ecf57c);
function $a68a669b79a16fde$export$c377853ecdd53e5b({ mode: mode, widthStateLineLength: widthStateLineLength, widthStateWidth: widthStateWidth }) {
    const breakoutWidth = $a68a669b79a16fde$export$5f4502874a28dfce(mode, widthStateWidth);
    const breakoutWidthPx = (0, $7SIsS.parsePx)(breakoutWidth);
    if (!widthStateLineLength) // lineLength is not normally undefined when this is run for,
    // consumers but can be in SSR, initial render or test (jsdom)
    // environments.
    //
    // this approach doesn't work well with position: fixed, so
    // it breaks things like sticky headers.
    //
    // It can also cause bluriness for some child content (such as iframes)
    return {
        type: 'line-length-unknown',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        display: 'flex',
        justifyContent: 'center',
        transform: 'none',
        transition: `min-width 0.5s ${0, $7yBx7.akEditorSwoopCubicBezier}`
    };
    // NOTE
    // At time of writing -- when toggling between full-width and
    // full-page appearance modes. There is a slight delay before
    // the widthState is updated.
    // During this period -- the marginLeftPx will be incorrect.
    // const marginLeftPx = -(breakoutWidthPx - widthStateLineLength) / 2;
    return {
        type: 'line-length-known',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        transition: `min-width 0.5s ${0, $7yBx7.akEditorSwoopCubicBezier}`,
        transform: `translateX(-50%)`,
        marginLeft: `50%`
    };
}
function $a68a669b79a16fde$export$586300c53bd298dd(mode, widthStateWidth, padding) {
    return (0, $7SIsS.parsePx)($a68a669b79a16fde$export$5f4502874a28dfce(mode, widthStateWidth, padding));
}
const $a68a669b79a16fde$export$7eb758567e6644fd = (currentMode)=>{
    if (currentMode === 'full-width') return 'center';
    else if (currentMode === 'wide') return 'full-width';
    return 'wide';
};
const $a68a669b79a16fde$export$70d1bf7729efff40 = (layout)=>{
    switch(layout){
        case 'full-width':
            return (0, $h2yqz.default).layoutFixedWidth;
        case 'wide':
            return (0, $h2yqz.default).layoutFullWidth;
        default:
            return (0, $h2yqz.default).layoutWide;
    }
};

});
parcelRegister("h2yqz", function(module, exports) {
$parcel$export(module.exports, "default", () => $a862382972fced25$export$2e2bcd8739ae039);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $7qGN1 = parcelRequire("7qGN1");

var $7Lz9d = parcelRequire("7Lz9d");

var $80t1d = parcelRequire("80t1d");

var $j0yUU = parcelRequire("j0yUU");

var $garJk = parcelRequire("garJk");

var $TgnAJ = parcelRequire("TgnAJ");

var $brgNx = parcelRequire("brgNx");


var $53A9i = parcelRequire("53A9i");

var $4AqYB = parcelRequire("4AqYB");


var $ehejR = parcelRequire("ehejR");

var $46A2h = parcelRequire("46A2h");

var $jSSd5 = parcelRequire("jSSd5");

var $6dRXt = parcelRequire("6dRXt");

var $1LIK6 = parcelRequire("1LIK6");

var $1D5wE = parcelRequire("1D5wE");

var $fJeGS = parcelRequire("fJeGS");

var $eCOhn = parcelRequire("eCOhn");

var $iW8Cl = parcelRequire("iW8Cl");

var $2EHqK = parcelRequire("2EHqK");

var $cINgv = parcelRequire("cINgv");

var $iRGZx = parcelRequire("iRGZx");

var $7g31l = parcelRequire("7g31l");

var $cfB8F = parcelRequire("cfB8F");

var $cDtOg = parcelRequire("cDtOg");

var $4DFTL = parcelRequire("4DFTL");

var $DGjKK = parcelRequire("DGjKK");

var $fbDBV = parcelRequire("fbDBV");

var $dfJR8 = parcelRequire("dfJR8");

var $dH8bz = parcelRequire("dH8bz");

var $gjx6N = parcelRequire("gjx6N");

var $h6V7a = parcelRequire("h6V7a");

var $gYWwp = parcelRequire("gYWwp");

var $lVkxz = parcelRequire("lVkxz");


var $jlbSP = parcelRequire("jlbSP");


var $ee8QX = parcelRequire("ee8QX");

var $dTBhg = parcelRequire("dTBhg");

var $mo6o5 = parcelRequire("mo6o5");

var $6TnyW = parcelRequire("6TnyW");

var $a862382972fced25$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    layoutFixedWidth: {
        id: 'fabric.editor.layoutFixedWidth',
        defaultMessage: 'Back to center',
        description: 'Display your element (image, table, extension, etc) as standard width'
    },
    layoutStateFixedWidth: {
        id: 'fabric.editor.layoutStateFixedWidth',
        defaultMessage: 'Centered',
        description: 'Displaying your element (image, table, extension, etc) as standard width'
    },
    layoutWide: {
        id: 'fabric.editor.layoutWide',
        defaultMessage: 'Go wide',
        description: 'Display your element (image, table, extension, etc) wider than normal'
    },
    layoutStateWide: {
        id: 'fabric.editor.layoutStateWide',
        defaultMessage: 'Wide',
        description: 'Displaying your element (image, table, extension, etc) wider than normal'
    },
    layoutFullWidth: {
        id: 'fabric.editor.layoutFullWidth',
        defaultMessage: 'Go full width',
        description: 'Display your element (image, table, extension, etc) as full width'
    },
    layoutStateFullWidth: {
        id: 'fabric.editor.layoutStateFullWidth',
        defaultMessage: 'Full width',
        description: 'Displaying your element (image, table, extension, etc) as full width'
    },
    alignImageRight: {
        id: 'fabric.editor.alignImageRight',
        defaultMessage: 'Align right',
        description: 'Aligns image to the right'
    },
    alignImageCenter: {
        id: 'fabric.editor.alignImageCenter',
        defaultMessage: 'Align center',
        description: 'Aligns image to the center'
    },
    alignImageLeft: {
        id: 'fabric.editor.alignImageLeft',
        defaultMessage: 'Align left',
        description: 'Aligns image to the left'
    },
    delete: {
        id: 'fabric.editor.delete',
        defaultMessage: 'Delete',
        description: 'Delete the element (image, panel, table, etc.) from your document'
    },
    remove: {
        id: 'fabric.editor.remove',
        defaultMessage: 'Remove',
        description: 'Delete the element (image, panel, table, etc.) from your document'
    },
    removeEmoji: {
        id: 'fabric.editor.removeEmoji',
        defaultMessage: 'Remove emoji',
        description: 'Remove the emoji panel icon from custom panel'
    },
    visit: {
        id: 'fabric.editor.visit',
        defaultMessage: 'Open link in a new window',
        description: 'Open the link in a new window'
    },
    inviteToEditButtonTitle: {
        id: 'fabric.editor.editMode.inviteToEditButton.title',
        defaultMessage: 'Invite to edit',
        description: 'Invite another user to edit the current document'
    },
    saveButton: {
        id: 'fabric.editor.saveButton',
        defaultMessage: 'Save',
        description: 'Submit and save a comment or document'
    },
    cancelButton: {
        id: 'fabric.editor.cancelButton',
        defaultMessage: 'Cancel',
        description: 'Discard the current comment or document'
    },
    taskList: {
        id: 'fabric.editor.tooltip.taskList',
        defaultMessage: 'an action item',
        description: 'an action item in the Editor'
    },
    bulletList: {
        id: 'fabric.editor.tooltip.bulletList',
        defaultMessage: 'a list',
        description: 'a list item in the Editor'
    },
    nestedExpand: {
        id: 'fabric.editor.tooltip.nestedExpand',
        defaultMessage: 'a nested expand',
        description: 'expand node which is nested'
    },
    decisionList: {
        id: 'fabric.editor.tooltip.decisionList',
        defaultMessage: 'a decision list',
        description: 'a list of decisions'
    },
    defaultBlockNode: {
        id: 'fabric.editor.tooltip.defaultBlockNode',
        defaultMessage: 'a block node',
        description: 'a block node element'
    },
    panel: {
        id: 'fabric.editor.tooltip.blockPanel',
        defaultMessage: 'a panel',
        description: 'Panel node in the Editor'
    },
    blockquote: {
        id: 'fabric.editor.blockquote',
        defaultMessage: 'a quote',
        description: 'a quote node'
    },
    timeUpdated: {
        id: 'fabric.editor.time.updated',
        defaultMessage: 'Updated',
        description: 'Time last updated'
    },
    timeViewed: {
        id: 'fabric.editor.time.viewed',
        defaultMessage: 'Viewed',
        description: 'Time last viewed'
    },
    timeAgo: {
        id: 'fabric.editor.time.ago',
        defaultMessage: 'ago',
        description: 'Some time ago'
    },
    copyToClipboard: {
        id: 'fabric.editor.copyToClipboard',
        defaultMessage: 'Copy',
        description: 'Copy the whole content of the element to your clipboard'
    },
    copiedToClipboard: {
        id: 'fabric.editor.copiedToClipboard',
        defaultMessage: 'Copied!',
        description: 'Copied the whole content of the element to clipboard'
    },
    viewMore: {
        id: 'fabric.editor.overflowMenuViewMore',
        defaultMessage: 'View more',
        description: 'View more options in toolbar'
    }
});

});
parcelRegister("7Lz9d", function(module, exports) {
$parcel$export(module.exports, "alignmentMessages", () => $dc92283c73543884$export$5229ffea355cfdf6);

var $7qGN1 = parcelRequire("7qGN1");
const $dc92283c73543884$export$5229ffea355cfdf6 = (0, $7qGN1.defineMessages)({
    alignment: {
        id: 'fabric.editor.alignment',
        defaultMessage: 'Text alignment',
        description: 'Opens drop down menu of options to configure text alignment'
    },
    alignLeft: {
        id: 'fabric.editor.alignLeft',
        defaultMessage: 'Align left',
        description: 'label stating that text is aligned left'
    },
    alignCenter: {
        id: 'fabric.editor.alignCenter',
        defaultMessage: 'Align center',
        description: 'label stating that text is aligned center'
    },
    alignRight: {
        id: 'fabric.editor.alignRight',
        defaultMessage: 'Align right',
        description: 'label stating that text is aligned right'
    }
});

});

parcelRegister("80t1d", function(module, exports) {
$parcel$export(module.exports, "annotationMessages", () => $21f2c1c46f6d0e21$export$ff612ca71703201d);

var $7qGN1 = parcelRequire("7qGN1");
const $21f2c1c46f6d0e21$export$ff612ca71703201d = (0, $7qGN1.defineMessages)({
    createComment: {
        id: 'fabric.editor.createComment',
        defaultMessage: 'Comment',
        description: 'Create/add an inline comment based on the users selection'
    },
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Remove this message when the editor_inline_comments_on_inline_nodes FF is removed
    createCommentInvalid: {
        id: 'fabric.editor.createCommentInvalid',
        defaultMessage: 'You can only comment on text and headings',
        description: 'Error message to communicate to the user they can only do the current action in certain contexts'
    },
    createCommentDisabled: {
        id: 'fabric.editor.createCommentDisabled',
        defaultMessage: 'You can only comment on text, headings, emojis, dates, mentions, links, and statuses.',
        description: 'Error message to communicate to the user they can only do the current action in certain contexts'
    },
    // Duplicated by Confluence's
    // highlight-actions.inline-comments.comment.no.permission
    noPermissionToAddComment: {
        id: 'fabric.editor.noPermissionToAddComment',
        defaultMessage: '{contentType, select, blogpost {You do not have permission to add comments to this blogpost} page {You do not have permission to add comments to this page} other {You do not have permission to add comments to this page}}',
        description: 'Tooltip for when the user does not have permission to add inline comments'
    },
    toolbar: {
        id: 'fabric.editor.annotationToolbar',
        defaultMessage: 'Annotation toolbar',
        description: 'A label for a toolbar (UI element) that creates annotations/comments in the document'
    }
});

});

parcelRegister("j0yUU", function(module, exports) {
$parcel$export(module.exports, "messages", () => $b492bc7e7de477dd$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $b492bc7e7de477dd$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    fullWidthLabel: {
        id: 'fabric.editor.breakoutFullWidthLabel',
        defaultMessage: 'Full-width',
        description: 'Resize current element to full-width mode'
    },
    wideWidthLabel: {
        id: 'fabric.editor.breakoutWideWidthLabel',
        defaultMessage: 'Wide',
        description: 'Resize current element to wide mode'
    },
    resizeHandle: {
        id: 'fabric.editor.resizeHandle',
        defaultMessage: 'Resize handle',
        description: 'Resize handle'
    },
    resizeExpand: {
        id: 'fabric.editor.breakout.resizeExpand',
        defaultMessage: 'Resize expand',
        description: 'Tooltip displayed on custom expand width resize handle'
    },
    resizeCodeBlock: {
        id: 'fabric.editor.breakout.resizeCodeBlock',
        defaultMessage: 'Resize code snippet',
        description: 'Tooltip displayed on custom code block width resize handle'
    },
    resizeLayout: {
        id: 'fabric.editor.breakout.resizeLayout',
        defaultMessage: 'Resize layout',
        description: 'Tooltip displayed on custom layout width resize handle'
    },
    resizeElement: {
        id: 'fabric.editor.breakout.resizeElement',
        defaultMessage: 'Resize element',
        description: 'Tooltip displayed on custom element (node) width resize handle'
    }
});

});

parcelRegister("garJk", function(module, exports) {
$parcel$export(module.exports, "messages", () => $e72c8b1673a400ef$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $e72c8b1673a400ef$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    copyBlock: {
        id: 'fabric.editor.block.menu.copy.block',
        defaultMessage: 'Copy block',
        description: 'Copy the selected block to the clipboard'
    },
    copyContent: {
        id: 'fabric.editor.block.menu.copy.content',
        defaultMessage: 'Copy content',
        description: 'Copy the selected content to the clipboard'
    },
    moveUpBlock: {
        id: 'fabric.editor.block.menu.move.up',
        defaultMessage: 'Move up',
        description: 'Move the selected block up'
    },
    moveDownBlock: {
        id: 'fabric.editor.block.menu.move.down',
        defaultMessage: 'Move down',
        description: 'Move the selected block down'
    },
    copyLink: {
        id: 'fabric.editor.block.menu.copy.link',
        defaultMessage: 'Copy link',
        description: 'Copy link to the selected block'
    },
    copyLinkToBlock: {
        id: 'fabric.editor.block.menu.copy.link.to.block',
        defaultMessage: 'Copy link to block',
        description: 'Copy link to the selected block'
    },
    paragraph: {
        id: 'fabric.editor.block.menu.paragraph',
        defaultMessage: 'Paragraph',
        description: 'Change the selected block to a paragraph'
    },
    codeBlock: {
        id: 'fabric.editor.block.menu.codeblock',
        defaultMessage: 'Code block',
        description: 'Convert to a code block'
    },
    layout: {
        id: 'fabric.editor.block.menu.layout',
        defaultMessage: 'Layout',
        description: 'Convert to a layout node'
    },
    deleteBlock: {
        id: 'fabric.editor.block.menu.delete.block',
        defaultMessage: 'Delete',
        description: 'Delete the selected block'
    },
    turnInto: {
        id: 'fabric.editor.block.menu.turn.into',
        defaultMessage: 'Turn into',
        description: 'Turn the selected block into another type'
    },
    createSyncedBlock: {
        id: 'fabric.editor.block.menu.create.synced.block',
        defaultMessage: 'Create synced block',
        description: 'Create a synced block at this empty line'
    },
    convertToSyncedBlock: {
        id: 'fabric.editor.block.menu.convert.to.synced.block',
        defaultMessage: 'Convert to synced block',
        description: 'Convert the selection to a synced block by putting all of the content inside a new synced block'
    },
    newLozenge: {
        id: 'fabric.editor.block.menu.new.lozenge',
        defaultMessage: 'New',
        description: 'Text in lozenge which appears next to newly added menu items'
    }
});

});

parcelRegister("TgnAJ", function(module, exports) {
$parcel$export(module.exports, "messages", () => $3e5e298fb8fde602$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $3e5e298fb8fde602$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    normal: {
        id: 'fabric.editor.normal',
        defaultMessage: 'Normal text',
        description: 'This is the default text style'
    },
    heading1: {
        id: 'fabric.editor.heading1',
        defaultMessage: 'Heading 1',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading1Description: {
        id: 'fabric.editor.heading1Description',
        defaultMessage: 'Use this for a top level heading',
        description: 'Description of the main heading, heading 1'
    },
    heading2: {
        id: 'fabric.editor.heading2',
        defaultMessage: 'Heading 2',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading2Description: {
        id: 'fabric.editor.heading2Description',
        defaultMessage: 'Use this for key sections',
        description: 'Description of a subtitle heading or secondary heading'
    },
    heading3: {
        id: 'fabric.editor.heading3',
        defaultMessage: 'Heading 3',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading3Description: {
        id: 'fabric.editor.heading3Description',
        defaultMessage: 'Use this for sub sections and group headings',
        description: ''
    },
    heading4: {
        id: 'fabric.editor.heading4',
        defaultMessage: 'Heading 4',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading4Description: {
        id: 'fabric.editor.heading4Description',
        defaultMessage: 'Use this for deep headings',
        description: ''
    },
    heading5: {
        id: 'fabric.editor.heading5',
        defaultMessage: 'Heading 5',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading5Description: {
        id: 'fabric.editor.heading5Description',
        defaultMessage: 'Use this for grouping list items',
        description: ''
    },
    heading6: {
        id: 'fabric.editor.heading6',
        defaultMessage: 'Heading 6',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading6Description: {
        id: 'fabric.editor.heading6Description',
        defaultMessage: 'Use this for low level headings',
        description: ''
    },
    blockquote: {
        id: 'fabric.editor.blockquote2',
        defaultMessage: 'Quote',
        description: 'Quote some text'
    },
    blockquoteDescription: {
        id: 'fabric.editor.blockquote.description',
        defaultMessage: 'Insert a quote or citation',
        description: 'Quote some text'
    },
    codeblock: {
        id: 'fabric.editor.codeblock',
        defaultMessage: 'Code snippet',
        description: 'Insert a snippet/segment of code (code block)'
    },
    codeblockDescription: {
        id: 'fabric.editor.codeblock.description',
        defaultMessage: 'Display code with syntax highlighting',
        description: 'Insert a snippet/segment of code (code block)'
    },
    infoPanel: {
        id: 'fabric.editor.infoPanel',
        defaultMessage: 'Info panel',
        description: 'Visually distinguishes your text by adding a background colour (blue, purple, yellow, green, red)'
    },
    infoPanelDescription: {
        id: 'fabric.editor.infoPanel.description',
        defaultMessage: 'Highlight information in a colored panel',
        description: 'Visually distinguishes your text by adding a background colour (blue, purple, yellow, green, red)'
    },
    notePanel: {
        id: 'fabric.editor.notePanel',
        defaultMessage: 'Note panel',
        description: 'Visually distinguishes your text by adding a note panel'
    },
    notePanelDescription: {
        id: 'fabric.editor.notePanel.description',
        defaultMessage: 'Add a note in a colored panel',
        description: 'Visually distinguishes your text by adding a note panel'
    },
    successPanel: {
        id: 'fabric.editor.successPanel',
        defaultMessage: 'Success panel',
        description: 'Visually distinguishes your text by adding a success panel'
    },
    successPanelDescription: {
        id: 'fabric.editor.successPanel.description',
        defaultMessage: 'Add tips in a colored panel',
        description: 'Visually distinguishes your text by adding a success panel'
    },
    warningPanel: {
        id: 'fabric.editor.warningPanel',
        defaultMessage: 'Warning panel',
        description: 'Visually distinguishes your text by adding a warning panel'
    },
    warningPanelDescription: {
        id: 'fabric.editor.warningPanel.description',
        defaultMessage: 'Add a note of caution in a colored panel',
        description: 'Visually distinguishes your text by adding a warning panel'
    },
    errorPanel: {
        id: 'fabric.editor.errorPanel',
        defaultMessage: 'Error panel',
        description: 'Visually distinguishes your text by adding a error panel'
    },
    errorPanelDescription: {
        id: 'fabric.editor.errorPanel.description',
        defaultMessage: 'Call out errors in a colored panel',
        description: 'Visually distinguishes your text by adding a error panel'
    },
    customPanel: {
        id: 'fabric.editor.customPanel',
        defaultMessage: 'Custom panel',
        description: 'Visually distinguishes your panel by adding a emoji icon and background color'
    },
    customPanelDescription: {
        id: 'fabric.editor.customPanel.description',
        defaultMessage: 'Add a note with an emoji and colored background',
        description: 'Visually distinguishes your panel by adding a emoji icon and background color '
    },
    syncedBlock: {
        id: 'fabric.editor.syncedBlock',
        defaultMessage: 'Create synced block',
        description: 'Inserts a synced block that auto-updates content across Atlassian apps'
    },
    syncedBlockDescription: {
        id: 'fabric.editor.syncedBlock.description',
        defaultMessage: 'Sync content across multiple locations',
        description: 'Description of the synced block that auto-updates content across Atlassian apps'
    },
    panel: {
        id: 'fabric.editor.panel',
        defaultMessage: 'Panel',
        description: 'Visually distinguishes your text by adding a panel'
    },
    other: {
        id: 'fabric.editor.other',
        defaultMessage: 'Others...',
        description: 'Other text formatting'
    }
});

});

parcelRegister("brgNx", function(module, exports) {
$parcel$export(module.exports, "codeBidiWarningMessages", () => $7ab4004aea737315$export$42bb270d1224182);

var $7qGN1 = parcelRequire("7qGN1");
const $7ab4004aea737315$export$42bb270d1224182 = (0, $7qGN1.defineMessages)({
    /**
	 * Message taken from
	 * https://hello.atlassian.net/wiki/spaces/~tswan/pages/1366555782/PSHELP-2943+Investigate+Trojan+Source+Attack+Vulnerability+design
	 */ label: {
        id: 'fabric.editor.codeBidiWarningLabel',
        defaultMessage: 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.',
        description: 'Tooltip message to present to users when a bidirectional character is encountered in code.'
    }
});

});

parcelRegister("53A9i", function(module, exports) {
$parcel$export(module.exports, "linkMessages", () => $fc6681fa190cc7ad$export$4ce3884394d6d9);

var $7qGN1 = parcelRequire("7qGN1");
const $fc6681fa190cc7ad$export$4ce3884394d6d9 = (0, $7qGN1.defineMessages)({
    openLink: {
        id: 'fabric.editor.openLink',
        defaultMessage: 'Open link in a new tab',
        description: 'Opens the link in a new tab'
    },
    openPreviewPanel: {
        id: 'fabric.editor.openPreviewPanel',
        defaultMessage: 'Open preview panel',
        description: 'Opens preview panel and loads the page inside it'
    }
});

});

parcelRegister("4AqYB", function(module, exports) {
$parcel$export(module.exports, "linkToolbarMessages", () => $e531378f6ee78f93$export$2d7676d841c8ae9);

var $7qGN1 = parcelRequire("7qGN1");
const $e531378f6ee78f93$export$2d7676d841c8ae9 = (0, $7qGN1.defineMessages)({
    addLink: {
        id: 'fabric.editor.mediaAddLink',
        defaultMessage: 'Add link',
        description: 'Add link'
    },
    unableToOpenLink: {
        id: 'fabric.editor.unableToOpenLink',
        defaultMessage: 'Unable to open this link',
        description: 'Unable to open this link'
    },
    unlink: {
        id: 'fabric.editor.unlink',
        defaultMessage: 'Unlink',
        description: 'Removes the hyperlink but keeps your text.'
    },
    editDatasourceStandalone: {
        id: 'fabric.editor.editDatasourceStandalone',
        defaultMessage: 'Edit',
        description: 'A standalone edit button to edit the datasource via a config modal'
    },
    editDatasourceStandaloneTooltip: {
        id: 'fabric.editor.editDatasourceStandaloneTooltip',
        defaultMessage: 'Edit search query',
        description: 'A standalone edit button tooltip to hint at editing the datasource via a config modal'
    },
    editLink: {
        id: 'fabric.editor.editLink',
        defaultMessage: 'Edit link',
        description: 'Edit the link, update display text'
    },
    placeholder: {
        id: 'fabric.editor.hyperlinkToolbarPlaceholder',
        defaultMessage: 'Paste or search for link',
        description: 'Paste or search for link'
    },
    linkPlaceholder: {
        id: 'fabric.editor.linkPlaceholder',
        defaultMessage: 'Paste link',
        description: 'Create a new link by pasting a URL.'
    },
    linkAddress: {
        id: 'fabric.editor.linkAddress',
        defaultMessage: 'Link address',
        description: 'Insert the address of the link'
    },
    invalidLink: {
        id: 'fabric.editor.invalidLink',
        defaultMessage: 'Please enter a valid link.',
        description: 'Please enter a valid link.'
    },
    emptyLink: {
        id: 'fabric.editor.emptyLink',
        defaultMessage: 'Please enter a link.',
        description: 'Please enter a link.'
    },
    settingsLink: {
        id: 'fabric.editor.settingsLinks',
        defaultMessage: 'Go to Link Preferences',
        description: 'Go to Link Preferences'
    },
    preferencesLink: {
        id: 'fabric.editor.preferencesLink',
        defaultMessage: 'Link preferences',
        description: 'Go to link preferences'
    },
    editDatasource: {
        id: 'fabric.editor.edit.datasource',
        defaultMessage: 'Edit search query',
        description: 'Datasource toolbar edit button'
    },
    searchInput: {
        id: 'fabric.editor.edit.searchInput',
        defaultMessage: 'Add a link',
        description: 'Label for the search media input'
    }
});

});

parcelRegister("ehejR", function(module, exports) {
$parcel$export(module.exports, "codeBlockButtonMessages", () => $3a5f51fb91bec33b$export$74e304339778e94d);

var $7qGN1 = parcelRequire("7qGN1");
const $3a5f51fb91bec33b$export$74e304339778e94d = (0, $7qGN1.defineMessages)({
    copyCodeToClipboard: {
        id: 'fabric.editor.codeBlockCopyButton.copyToClipboard',
        defaultMessage: 'Copy as text',
        description: 'Copy the content of the code block as text to your clipboard'
    },
    copiedCodeToClipboard: {
        id: 'fabric.editor.codeBlockCopyButton.copiedToClipboard',
        defaultMessage: 'Copied!',
        description: 'Copied the content of the code block as text to clipboard'
    },
    wrapCode: {
        id: 'fabric.editor.codeBlockWrapButton.wrapCodeBlock',
        defaultMessage: 'Turn on wrap',
        description: 'Wrap the content of the code block'
    },
    unwrapCode: {
        id: 'fabric.editor.codeBlockWrapButton.unwrapCodeBlock',
        defaultMessage: 'Turn off wrap',
        description: 'Wrap the content of the code block'
    },
    selectLanguage: {
        id: 'fabric.editor.selectLanguage',
        defaultMessage: 'Select language',
        description: 'Code blocks display software code. A prompt to select the software language the code is written in.'
    }
});

});

parcelRegister("46A2h", function(module, exports) {
$parcel$export(module.exports, "toolbarInsertBlockMessages", () => $33ecf47745d659ba$export$70c8a7203d95247);

var $7qGN1 = parcelRequire("7qGN1");
const $33ecf47745d659ba$export$70c8a7203d95247 = (0, $7qGN1.defineMessages)({
    action: {
        id: 'fabric.editor.action',
        defaultMessage: 'Action item',
        description: "Also known as a \u201Ctask\u201D, \u201Cto do item\u201D, or a checklist"
    },
    actionDescription: {
        id: 'fabric.editor.action.description',
        defaultMessage: 'Create and assign action items',
        description: ''
    },
    closeInsertRightRail: {
        id: 'fabric.editor.insertRightRail.close',
        defaultMessage: 'Close',
        description: 'Close button label'
    },
    link: {
        id: 'fabric.editor.link',
        defaultMessage: 'Link',
        description: 'Insert a hyperlink'
    },
    linkDescription: {
        id: 'fabric.editor.link.description',
        defaultMessage: 'Insert a link',
        description: 'Insert a hyperlink'
    },
    mediaFiles: {
        id: 'fabric.editor.mediaFiles',
        defaultMessage: 'Image, video, or file',
        description: 'Insert one or more files, videos or images'
    },
    addMediaFiles: {
        id: 'fabric.editor.addMediaFiles',
        defaultMessage: 'Add image, video, or file',
        description: 'Insert one or more files, videos or images'
    },
    insertRightRailTitle: {
        id: 'fabric.editor.insertRightRail.title',
        defaultMessage: 'Insert',
        description: 'Insert a node into the document'
    },
    mediaFilesDescription: {
        id: 'fabric.editor.mediaFiles.description',
        defaultMessage: 'Add images and other files to your page',
        description: 'Insert one or more files or images'
    },
    image: {
        id: 'fabric.editor.image',
        defaultMessage: 'Image',
        description: 'Insert an image.'
    },
    mention: {
        id: 'fabric.editor.mention',
        defaultMessage: 'Mention',
        description: 'Reference another person in your document'
    },
    mentionDescription: {
        id: 'fabric.editor.mention.description',
        defaultMessage: 'Mention someone to send them a notification',
        description: 'Reference another person in your document'
    },
    emoji: {
        id: 'fabric.editor.emoji',
        defaultMessage: 'Emoji',
        description: 'Insert an emoticon or smiley :-)'
    },
    emojiDescription: {
        id: 'fabric.editor.emoji.description',
        defaultMessage: "Use emojis to express ideas \uD83C\uDF89 and emotions \uD83D\uDE04",
        description: 'Insert an emoticon or smiley :-)'
    },
    table: {
        id: 'fabric.editor.table',
        defaultMessage: 'Table',
        description: 'Inserts a table in the document'
    },
    tableDescription: {
        id: 'fabric.editor.table.description',
        defaultMessage: 'Insert a table',
        description: 'Inserts a table in the document'
    },
    tableSelector: {
        id: 'fabric.editor.tableSelector',
        defaultMessage: 'Table size',
        description: 'Opens a table selector that lets you insert a table of custom size'
    },
    tableSelectorDescription: {
        id: 'fabric.editor.tableSelector.description',
        defaultMessage: 'Add a table using popup to select a custom size',
        description: 'Opens a table selector that lets you insert a table of a custom size'
    },
    tableSizeSelectorButton: {
        id: 'fabric.editor.tableSizeSelectorButton',
        defaultMessage: '{numberOfColumns} by {numberOfRows}',
        description: 'Creates a table of custom size'
    },
    tableSizeSelectorPopup: {
        id: 'fabric.editor.tableSizeSelectorPopup',
        defaultMessage: 'Table size selector',
        description: 'Table selector popup to create table of custom size'
    },
    expand: {
        id: 'fabric.editor.expand',
        defaultMessage: 'Expand',
        description: 'Inserts an expand in the document'
    },
    expandDescription: {
        id: 'fabric.editor.expand.description',
        defaultMessage: 'Insert an expand',
        description: 'Inserts an expand in the document'
    },
    decision: {
        id: 'fabric.editor.decision',
        defaultMessage: 'Decision',
        description: "Capture a decision you\u2019ve made"
    },
    decisionDescription: {
        id: 'fabric.editor.decision.description',
        defaultMessage: "Capture decisions so they\u2019re easy to track",
        description: "Capture a decision you\u2019ve made"
    },
    feedbackDialog: {
        id: 'fabric.editor.feedbackDialog',
        defaultMessage: 'Give feedback',
        description: 'Open the feedback dialog from editor'
    },
    feedbackDialogDescription: {
        id: 'fabric.editor.feedbackDialog.description',
        defaultMessage: 'Tell us about your experience using the cloud editor',
        description: 'Description for feedback option under quick insert dropdown'
    },
    horizontalRule: {
        id: 'fabric.editor.horizontalRule',
        defaultMessage: 'Divider',
        description: 'A horizontal rule or divider'
    },
    horizontalRuleDescription: {
        id: 'fabric.editor.horizontalRule.description',
        defaultMessage: 'Separate content with a horizontal line',
        description: 'A horizontal rule or divider'
    },
    date: {
        id: 'fabric.editor.date',
        defaultMessage: 'Date',
        description: 'Opens a date picker that lets you select a date'
    },
    dateDescription: {
        id: 'fabric.editor.date.description',
        defaultMessage: 'Add a date using a calendar',
        description: 'Opens a date picker that lets you select a date'
    },
    placeholderText: {
        id: 'fabric.editor.placeholderText',
        defaultMessage: 'Placeholder text',
        description: 'Inserts a text placeholder into the page'
    },
    placeholderTextDescription: {
        id: 'fabric.editor.placeholderText.description',
        defaultMessage: 'Insert a text placeholder into the page',
        description: 'Inserts a text placeholder into the page'
    },
    columns: {
        id: 'fabric.editor.columns',
        defaultMessage: 'Layouts',
        description: 'Create a multi column section or layout'
    },
    columnsDescription: {
        id: 'fabric.editor.columns.description',
        defaultMessage: 'Structure your page using sections',
        description: 'Create a multi column section or layout'
    },
    columnsDescriptionAdvancedLayout: {
        id: 'fabric.editor.columns.advanced.layout.description',
        defaultMessage: 'Insert {numberOfColumns} equal {numberOfColumns, plural, one {column} other {columns}}',
        description: 'Create a multi column section or layout'
    },
    singleColumnsDescriptionAdvancedLayout: {
        id: 'fabric.editor.columns.advanced.layout.single.description',
        defaultMessage: 'Insert a single column layout',
        description: 'Create a multi column section or layout'
    },
    status: {
        id: 'fabric.editor.status',
        defaultMessage: 'Status',
        description: 'Inserts an item representing the status of an activity to task.'
    },
    statusDescription: {
        id: 'fabric.editor.status.description',
        defaultMessage: 'Add a custom status label',
        description: 'Inserts an item representing the status of an activity to task.'
    },
    viewMore: {
        id: 'fabric.editor.viewMore',
        defaultMessage: 'View more',
        description: 'View more elements that can be inserted'
    },
    viewMoreAriaLabel: {
        id: 'fabric.editor.viewMoreAriaLabel',
        defaultMessage: 'View all elements',
        description: 'A more descriptive aria label describing that users can view all the elements to be inserted.'
    },
    insertMenu: {
        id: 'fabric.editor.insertMenu',
        defaultMessage: 'Insert elements',
        description: 'Opens a menu of additional items that can be inserted into your document.'
    },
    help: {
        id: 'fabric.editor.help',
        defaultMessage: 'Help',
        description: 'Opens up the help dialog'
    },
    helpDescription: {
        id: 'fabric.editor.help.description',
        defaultMessage: 'Browse all the keyboard shortcuts and markdown options',
        description: 'Browse all the keyboard shortcuts and markdown options'
    },
    recordVideo: {
        id: 'fabric.editor.recordVideo',
        defaultMessage: 'Record a Loom video',
        description: 'Record a Loom video'
    },
    addLoomVideo: {
        id: 'fabric.editor.addLoomVideo',
        defaultMessage: 'Record a Loom video',
        description: 'Record a Loom video'
    },
    addLoomVideoComment: {
        id: 'fabric.editor.addLoomVideoComment',
        defaultMessage: 'Record a Loom video comment',
        description: 'Record a Loom video comment'
    },
    recordVideoDescription: {
        id: 'fabric.editor.recordVideo.description',
        defaultMessage: 'Record and share your screen and thoughts',
        description: 'Record and share your screen and thoughts'
    },
    recordLoomShortTitle: {
        id: 'fabric.editor.recordLoomShortTitle',
        defaultMessage: 'Record',
        description: 'Record'
    },
    turnInto: {
        id: 'fabric.editor.turnInto',
        defaultMessage: 'Turn into',
        description: 'Turn selected texts into another element containing those texts'
    }
});

});

parcelRegister("jSSd5", function(module, exports) {
$parcel$export(module.exports, "toolbarMessages", () => $ee2b3acd8c035b8b$export$81b075fd34c2f0bb);

var $7qGN1 = parcelRequire("7qGN1");
const $ee2b3acd8c035b8b$export$81b075fd34c2f0bb = (0, $7qGN1.defineMessages)({
    wrapLeft: {
        id: 'fabric.editor.wrapLeft',
        defaultMessage: 'Wrap left',
        description: 'Aligns your image to the left and wraps text around it.'
    },
    wrapRight: {
        id: 'fabric.editor.wrapRight',
        defaultMessage: 'Wrap right',
        description: 'Aligns your image to the right and wraps text around it.'
    },
    changeToMediaSingle: {
        id: 'fabric.editor.media_change_mediasingle',
        defaultMessage: 'Original size',
        description: 'In the context of a media inline image, it allows the user to convert it to media single'
    },
    changeToMediaInlineImage: {
        id: 'fabric.editor.media_change_mediainline_default',
        defaultMessage: 'Inline',
        description: 'In the context of media single contains media node, it allows the user to convert media single to media inline image'
    },
    changeToMediaInlineImageCaptionWarning: {
        id: 'fabric.editor.media_change_mediainline_caption_warn',
        defaultMessage: 'Inline (caption will be removed)',
        description: 'In the context of media single contains media node, it allows the user to convert media single to media inline image and warn user about caption being removed'
    }
});

});

parcelRegister("6dRXt", function(module, exports) {
$parcel$export(module.exports, "messages", () => $c19b855dc4027d63$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $c19b855dc4027d63$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    url: {
        id: 'fabric.editor.url',
        defaultMessage: 'Display URL',
        description: 'Convert the card to become a regular text-based hyperlink.'
    },
    block: {
        id: 'fabric.editor.displayBlock',
        defaultMessage: 'Display card',
        description: 'Display link as a card with a rich preview similar to in a Facebook feed with page title, description, and potentially an image.'
    },
    inline: {
        id: 'fabric.editor.displayInline',
        defaultMessage: 'Display inline',
        description: 'Display link with the title only.'
    },
    embed: {
        id: 'fabric.editor.displayEmbed',
        defaultMessage: 'Display embed',
        description: 'Display link as an embedded object'
    },
    link: {
        id: 'fabric.editor.displayLink',
        defaultMessage: 'Display as text',
        description: 'Convert the card to become a regular text-based hyperlink.'
    },
    card: {
        id: 'fabric.editor.cardFloatingControls',
        defaultMessage: 'Card options',
        description: 'Options to change card type'
    },
    blockCardUnavailable: {
        id: 'fabric.editor.blockCardUnavailable',
        defaultMessage: 'The inline link is inside {node} and cannot have its view changed',
        description: 'Warning message to show the user that this node cannot change its view'
    },
    displayOptionUnavailableInParentNode: {
        id: 'fabric.editor.displayOptionUnavailableInParentNode',
        defaultMessage: "This display option isn't available inside {node}",
        description: 'Warning message to show the user that this node option is not available inside a parent node type'
    },
    urlTitle: {
        id: 'fabric.editor.urlTitle',
        defaultMessage: 'URL',
        description: 'Title for option to convert the card to become a regular text-based hyperlink.'
    },
    blockTitle: {
        id: 'fabric.editor.blockTitle',
        defaultMessage: 'Card',
        description: 'Title for option to display link in the card view.'
    },
    inlineTitle: {
        id: 'fabric.editor.inlineTitle',
        defaultMessage: 'Inline',
        description: 'Title for option to display link in the inline view.'
    },
    openButtonTitle: {
        id: 'fabric.editor.openButtonTitle',
        defaultMessage: 'Open',
        description: 'Title for a button that opens a link when clicked.'
    },
    panelButtonTitle: {
        id: 'fabric.editor.panelButtonTitle',
        defaultMessage: 'Panel',
        description: 'Title for a button that opens side panel when clicked.'
    },
    previewButtonTitle: {
        id: 'fabric.editor.previewButtonTitle',
        defaultMessage: 'Preview',
        description: 'Title for a button that when clicked opens a preview modal or a preview panel.'
    },
    embedTitle: {
        id: 'fabric.editor.embedTitle',
        defaultMessage: 'Embed',
        description: 'Title for option to display link as an embedded object.'
    },
    urlDescription: {
        id: 'fabric.editor.urlDescription',
        defaultMessage: 'Display link as URL',
        description: 'Description for option to convert the card to become a regular text-based hyperlink.'
    },
    blockDescription: {
        id: 'fabric.editor.blockDescription',
        defaultMessage: 'Display more information about a link, including a summary and actions',
        description: 'Description for option to display link in the card view.'
    },
    inlineDescription: {
        id: 'fabric.editor.inlineDescription',
        defaultMessage: 'Display link as inline text',
        description: 'Description for option to display link in the inline view.'
    },
    embedDescription: {
        id: 'fabric.editor.ecombedDescription',
        defaultMessage: 'Display an interactive preview of a link',
        description: 'Description for option to display link as an embedded object.'
    },
    embedToBlockCardWarning: {
        id: 'fabric.editor.embedToBlockCardWarning',
        defaultMessage: 'Displays as a card on small screens',
        description: 'Warning message to show the user that embed card will be displayed as a block card on small screens.'
    },
    editDropdownExpandIconLabel: {
        id: 'fabric.editor.editDropdownExpandIconLabel',
        defaultMessage: 'Expand dropdown menu',
        description: 'Text of an icon to expand the dropdown'
    },
    editDropdownTriggerTitle: {
        id: 'fabric.editor.editDropdownTriggerTitle',
        defaultMessage: 'Edit',
        description: 'Text of a button to trigger opening an edit dropdown'
    },
    editDropdownEditLinkTitle: {
        id: 'fabric.editor.editDropdownEditLinkTitle',
        defaultMessage: 'Edit link',
        description: 'Edit dropdown edit link button text'
    },
    editDropdownEditDatasourceTitle: {
        id: 'fabric.editor.editDropdownEditDatasourceTitle',
        defaultMessage: 'Edit search query',
        description: 'Edit dropdown edit datasource button text'
    },
    datasourceTitle: {
        id: 'fabric.editor.datasourceTitle',
        defaultMessage: 'Edit search query',
        description: 'Tooltip of button to edit a card into a datasource'
    },
    datasourceAppearanceTitle: {
        id: 'fabric.editor.datasourceAppearanceTitle',
        defaultMessage: 'List',
        description: 'Tooltip of button to change to datasource appearance'
    },
    datasourceJiraIssue: {
        id: 'fabric.editor.datasource.jiraIssue',
        defaultMessage: 'Jira Issues',
        description: 'Insert a jira datasource table'
    },
    datasourceJiraIssueDescription: {
        id: 'fabric.editor.datasource.jiraIssue.description',
        defaultMessage: 'Insert Jira issues from Jira Cloud with enhanced search, filtering, and configuration.',
        description: 'Insert a jira datasource table'
    },
    datasourceAssetsObjectsGeneralAvailability: {
        id: 'fabric.editor.datasource.assetsObjectsGeneralAvailability',
        defaultMessage: 'Assets',
        description: 'Text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects.'
    },
    datasourceAssetsObjectsDescription: {
        id: 'fabric.editor.datasource.assetsObjects.description',
        defaultMessage: 'Insert objects from Assets in Jira Service Management with search and filtering',
        description: 'Description text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects'
    },
    inlineOverlay: {
        id: 'fabric.editor.inlineOverlay',
        defaultMessage: 'Configure',
        description: 'An overlay shown when hover over inline smart link to inform user that they can click the link to edit the links appearance.'
    },
    inlineConfigureLink: {
        id: 'fabric.editor.inlineConfigureLink',
        defaultMessage: 'Configure link',
        description: 'An icon shown when hovering over inline smart link to inform user they can click the icon to configure the links appearance.'
    },
    inlineGoToLink: {
        id: 'fabric.editor.inlineGoToLink',
        defaultMessage: 'Go to link',
        description: 'An option in the configure link dropdown that informs the user they can click the option to open the link'
    },
    datasourceConfluenceSearch: {
        id: 'fabric.editor.datasource.confluenceSearch',
        defaultMessage: 'Insert Confluence list',
        description: 'Title shown for Confluence Search datasource on QuickInsert options'
    },
    datasourceConfluenceSearchDescription: {
        id: 'fabric.editor.datasource.confluenceSearch.description',
        defaultMessage: 'Insert list of search results from Confluence with enhanced search, filtering, and configuration.',
        description: 'Description text displayed when selecting the type of data to include onto the page, in this case: Confluence Search objects'
    },
    datasourceJiraIssueIssueTermRefresh: {
        id: 'fabric.editor.datasource.jiraIssue.issue-term-refresh',
        defaultMessage: 'Jira Work Items',
        description: 'Insert a jira datasource table (Issue Terminology Refresh)'
    },
    datasourceJiraIssueDescriptionIssueTermRefresh: {
        id: 'fabric.editor.datasource.jiraIssue.description.issue-term-refresh',
        defaultMessage: 'Insert Jira work items from Jira Cloud with enhanced search, filtering, and configuration.',
        description: 'Insert a jira datasource table (Issue Terminology Refresh)'
    }
});

});

parcelRegister("1LIK6", function(module, exports) {
$parcel$export(module.exports, "messages", () => $b60a8f86e9d01be8$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $b60a8f86e9d01be8$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    toolbarLabel: {
        id: 'fabric.editor.toolbarLabel',
        defaultMessage: 'Editor',
        description: 'Label for the ARIA region landmark'
    },
    pageActionsLabel: {
        id: 'fabric.editor.pageActionsLabel',
        defaultMessage: 'Page actions',
        description: 'Label for the ARIA region landmark'
    },
    editableContentLabel: {
        id: 'fabric.editor.editableContentLabel',
        defaultMessage: 'Editable content',
        description: 'Label for the ARIA region landmark'
    }
});

});

parcelRegister("1D5wE", function(module, exports) {
$parcel$export(module.exports, "toolbarMessages", () => $ce22d229c4242f60$export$81b075fd34c2f0bb);

var $7qGN1 = parcelRequire("7qGN1");
const $ce22d229c4242f60$export$81b075fd34c2f0bb = (0, $7qGN1.defineMessages)({
    underline: {
        id: 'fabric.editor.underline',
        defaultMessage: 'Underline',
        description: 'Whether the text selection has underlined text'
    },
    strike: {
        id: 'fabric.editor.strike',
        defaultMessage: 'Strikethrough',
        description: 'Whether the text selection has crossed out text'
    },
    code: {
        id: 'fabric.editor.code',
        defaultMessage: 'Code',
        description: 'Whether the text selection has monospaced/code font'
    },
    codeOn: {
        id: 'fabric.editor.code.on',
        defaultMessage: '{textFormattingOff}, Code On',
        description: 'Reports that code formatting has been turned on'
    },
    subscript: {
        id: 'fabric.editor.subscript',
        defaultMessage: 'Subscript',
        description: 'Whether the text selection is written below the line in a slightly smaller size'
    },
    subscriptOffSuperscriptOn: {
        id: 'fabric.editor.subscript.off.superscript.on',
        defaultMessage: 'Subscript Off, Superscript On',
        description: 'Reports text formatting in case when subscript off and superscript on'
    },
    superscript: {
        id: 'fabric.editor.superscript',
        defaultMessage: 'Superscript',
        description: 'Whether the text selection is written above the line in a slightly smaller size'
    },
    superscriptOffSubscriptOn: {
        id: 'fabric.editor.superscript.off.subscript.on',
        defaultMessage: 'Superscript Off, Subscript On',
        description: 'Describe text formatting in case when Superscript Off and Subscript on'
    },
    clearFormatting: {
        id: 'fabric.editor.clearFormatting',
        defaultMessage: 'Clear formatting',
        description: 'Remove all rich text formatting from the selected text'
    },
    moreFormatting: {
        id: 'fabric.editor.moreFormatting',
        defaultMessage: 'More formatting',
        description: 'Clicking this will show a menu with additional formatting options'
    },
    textFormatting: {
        id: 'fabric.editor.textFormatting',
        defaultMessage: 'Text formatting',
        description: 'Aria label for the wrapper of text format buttons'
    },
    textFormat: {
        id: 'fabric.editor.textFormat',
        defaultMessage: 'Format text',
        description: 'Aria label for the wrapper of text format buttons'
    },
    bold: {
        id: 'fabric.editor.bold',
        defaultMessage: 'Bold',
        description: "This refers to bold or \u201Cstrong\u201D formatting, indicates that its contents have strong importance, seriousness, or urgency."
    },
    italic: {
        id: 'fabric.editor.italic',
        defaultMessage: 'Italic',
        description: 'This refers to italics or emphasized formatting.'
    },
    on: {
        id: 'fabric.editor.on',
        defaultMessage: '{formattingType} On',
        description: 'Reports that text formatting has been turned on'
    },
    off: {
        id: 'fabric.editor.off',
        defaultMessage: '{formattingType} Off',
        description: 'Reports that text formatting has been turned off'
    },
    textStyles: {
        id: 'fabric.editor.textStyles',
        defaultMessage: '{blockTypeName} Text styles',
        description: 'Menu label that provides access to various heading styles or normal text. For example: normal text styles, heading 1 text styles.'
    },
    textStylesTooltip: {
        id: 'fabric.editor.textStylesTooltip',
        defaultMessage: 'Text styles',
        description: 'Tooltip text for menu that provides access to various heading styles or normal text.'
    },
    textFormattingOff: {
        id: 'fabric.editor.text.formatting.off',
        defaultMessage: 'Text formatting Off',
        description: 'Reports that text formatting has been turned off'
    },
    navigateToEditorToolbar: {
        id: 'fabric.editor.navigate.toolbar.editor',
        defaultMessage: 'Navigate to editor toolbar',
        description: 'Navigate to the main editor toolbar.'
    },
    navigateToFloatingToolbar: {
        id: 'fabric.editor.navigate.toolbar.floating',
        defaultMessage: 'Navigate to floating toolbar',
        description: 'Navigate to a floating toolbar for relevant nodes (e.g. tables or panels).'
    },
    askAI: {
        id: 'fabric.editor.navigate.toolbar.askAI',
        defaultMessage: 'Ask AI',
        description: 'Open the AI panel to ask a question or generate content.'
    },
    selectionToolbarOverflowMenuTooltip: {
        id: 'fabric.editor.selectionToolbarOverflowMenuTooltip',
        defaultMessage: 'More options',
        description: 'Tooltip for the overflow menu in the selection toolbar'
    }
});

});

parcelRegister("fJeGS", function(module, exports) {
$parcel$export(module.exports, "messages", () => $d71b619850badb35$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $d71b619850badb35$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    tableScrollRegion: {
        id: 'fabric.editor.tableScrollRegion',
        defaultMessage: 'Table scroll region',
        description: 'Label for the scrollable region of a table, used for accessibility purposes.'
    },
    tableOptions: {
        id: 'fabric.editor.tableOptions',
        defaultMessage: 'Table options',
        description: 'Opens a menu with additional table options'
    },
    tableSizeIncreaseScreenReaderInformation: {
        id: 'fabric.editor.tableResizeIncreaseScreenReaderInformation',
        defaultMessage: 'Table width increased to {newWidth, plural, one {# pixel} other {# pixels}}.',
        description: 'Information for screen reader users about increasing the table size by a certain number of pixels.'
    },
    tableSizeDecreaseScreenReaderInformation: {
        id: 'fabric.editor.tableResizeDecreaseScreenReaderInformation',
        defaultMessage: 'Table width decreased to {newWidth, plural, one {# pixel} other {# pixels}}.',
        description: 'Information for screen reader users about decreasing the table size by a certain number of pixels.'
    },
    headerRow: {
        id: 'fabric.editor.headerRow',
        defaultMessage: 'Header row',
        description: 'Marks the first table row as a header row'
    },
    headerColumn: {
        id: 'fabric.editor.headerColumn',
        defaultMessage: 'Header column',
        description: 'Marks the first table column as a header row'
    },
    numberedColumn: {
        id: 'fabric.editor.numberedColumn',
        defaultMessage: 'Numbered column',
        description: 'Adds an auto-numbering column to your table'
    },
    collapseTable: {
        id: 'fabric.editor.collapseTable',
        defaultMessage: 'Collapse table',
        description: 'Wraps table in an expand'
    },
    resizeTable: {
        id: 'fabric.editor.tables.resizeTable',
        defaultMessage: 'Resize table',
        description: 'Tooltip displayed on custom table width resize hande'
    },
    insertColumn: {
        id: 'fabric.editor.insertColumn',
        defaultMessage: 'Insert column right',
        description: 'Inserts a new column to the right of selected column.'
    },
    addColumnLeft: {
        id: 'fabric.editor.addColumnLeft',
        defaultMessage: 'Add column left',
        description: 'Adds a new column to the left of selected column.'
    },
    addColumnRight: {
        id: 'fabric.editor.addColumnRight',
        defaultMessage: 'Add column right',
        description: 'Adds a new column to the right of selected column.'
    },
    insertColumnDrag: {
        id: 'fabric.editor.insertColumnDrag',
        defaultMessage: 'Insert column',
        description: 'Inserts a new column to the right of selected column.'
    },
    removeColumns: {
        id: 'fabric.editor.removeColumns',
        defaultMessage: 'Delete {0, plural, one {column} other {columns}}',
        description: 'Deletes a table column.'
    },
    insertRow: {
        id: 'fabric.editor.insertRow',
        defaultMessage: 'Insert row below',
        description: 'Inserts a new row below the selected row.'
    },
    addRowAbove: {
        id: 'fabric.editor.addRowAbove',
        defaultMessage: 'Add row above',
        description: 'Adds a new row above the selected row.'
    },
    addRowBelow: {
        id: 'fabric.editor.addRowBelow',
        defaultMessage: 'Add row below',
        description: 'Adds a new row below the selected row.'
    },
    moveColumnLeft: {
        id: 'fabric.editor.moveColumnLeft',
        defaultMessage: 'Move {0, plural, one {column} other {columns}} left',
        description: 'Moves a column or columns to the left.'
    },
    moveColumnRight: {
        id: 'fabric.editor.moveColumnRight',
        defaultMessage: 'Move {0, plural, one {column} other {columns}} right',
        description: 'Moves a column or columns to the right.'
    },
    moveRowUp: {
        id: 'fabric.editor.moveRowUp',
        defaultMessage: 'Move {0, plural, one {row} other {rows}} up',
        description: 'Moves a row or selected rows up.'
    },
    moveRowDown: {
        id: 'fabric.editor.moveDownDown',
        defaultMessage: 'Move {0, plural, one {row} other {rows}} down',
        description: 'Moves a row or selected rows down.'
    },
    insertRowDrag: {
        id: 'fabric.editor.insertRowDrag',
        defaultMessage: 'Insert row',
        description: 'Inserts a new row below the selected row.'
    },
    removeRows: {
        id: 'fabric.editor.removeRows',
        defaultMessage: 'Delete {0, plural, one {row} other {rows}}',
        description: 'Deletes a table row.'
    },
    rowNumbers: {
        id: 'fabrid.editor.rowNumbers',
        defaultMessage: 'Row numbers',
        desciption: 'Adds a number to each row except header row'
    },
    rowsAreInserted: {
        id: 'fabric.editor.rowsAreInserted',
        defaultMessage: '{count, plural, one {A row has been} other {{count} rows have been}} inserted',
        description: 'Assistive message following the insertion of row(s)'
    },
    rowsAreRemoved: {
        id: 'fabric.editor.rowsAreRemoved',
        defaultMessage: '{count, plural, one {The row has been} other {{count} rows have been}} removed',
        description: 'Assistive message following the removal of row(s)'
    },
    rowSelected: {
        id: 'fabric.editor.rowSelected',
        defaultMessage: 'Row {index} of {total} selected',
        description: 'Assistive message following the selection of a row'
    },
    rowMovedUp: {
        id: 'fabric.editor.rowMovedUp',
        defaultMessage: 'Row moved up to {index} of {total}',
        description: 'Assistive message following the upward movement of a row'
    },
    rowMovedDown: {
        id: 'fabric.editor.rowMovedDown',
        defaultMessage: 'Row moved down to {index} of {total}',
        description: 'Assistive message following the downward movement of a row'
    },
    columnsAreInserted: {
        id: 'fabric.editor.columnsAreInserted',
        defaultMessage: '{count, plural, one {A column has been} other {{count} columns have been}} inserted',
        description: 'Assistive message following the insertion of column(s)'
    },
    columnsAreRemoved: {
        id: 'fabric.editor.columnsAreRemoved',
        defaultMessage: '{count, plural, one {The column has been} other {{count} columns have been}} removed',
        description: 'Assistive message following the removal of column(s)'
    },
    columnSelected: {
        id: 'fabric.editor.columnSelected',
        defaultMessage: 'Column {index} of {total} selected',
        description: 'Assistive message following the selection of a column'
    },
    columnMovedLeft: {
        id: 'fabric.editor.columnMovedLeft',
        defaultMessage: 'Column moved left to {index} of {total}',
        description: 'Assistive message following the left movement of a column'
    },
    columnMovedRight: {
        id: 'fabric.editor.columnMovedRight',
        defaultMessage: 'Column moved right to {index} of {total}',
        description: 'Assistive message following the right movement of a column'
    },
    cellOptions: {
        id: 'fabric.editor.cellOptions',
        defaultMessage: 'Cell options',
        description: 'Opens a menu with options for the current table cell.'
    },
    confirmDeleteLinkedModalOKButton: {
        id: 'fabric.editor.tables.confirmDeleteLinkedModalOKButton',
        defaultMessage: 'Delete',
        description: 'Action button label for confirm modal when deleting a table linked to an extension.'
    },
    confirmDeleteLinkedModalMessage: {
        id: 'fabric.editor.tables.confirmDeleteLinkedModalMessage',
        defaultMessage: 'Deleting {nodeName} will break anything connected to it.',
        description: 'Message for confirm modal when deleting a table linked to an extension.'
    },
    confirmDeleteLinkedModalMessagePrefix: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix',
        defaultMessage: 'Deleting',
        description: 'prefix for confirmation dialog text'
    },
    confirmModalCheckboxLabel: {
        id: 'fabric.editor.floatingToolbar.confirmModalCheckboxLabel',
        defaultMessage: 'Also delete connected elements',
        description: 'checkbox label text'
    },
    deleteElementTitle: {
        id: 'fabric.editor.extension.deleteElementTitle',
        defaultMessage: 'Delete element',
        description: 'Title text for confirm modal when deleting an extension linked to a data consumer.'
    },
    unnamedSource: {
        id: 'fabric.editor.extension.sourceNoTitledName',
        defaultMessage: 'this element',
        description: 'The current element without preset name been selected'
    },
    adjustColumns: {
        id: 'fabric.editor.tables.adjustColumn',
        defaultMessage: 'Adjust column',
        description: 'Tooltip displayed on table column resize handle'
    },
    cornerControl: {
        id: 'fabric.editor.cornerControl',
        defaultMessage: 'Highlight table',
        description: 'A button on the upper left corner of the table that shows up when the table is in focus. Clicking on it will select the entire table.'
    },
    cellBackground: {
        id: 'fabric.editor.cellBackground',
        defaultMessage: 'Cell background',
        description: 'Change the background color of a table cell.'
    },
    backgroundColor: {
        id: 'fabric.editor.backgroundColor',
        defaultMessage: 'Background color',
        description: 'Change the background color of a table cell.'
    },
    mergeCells: {
        id: 'fabric.editor.mergeCells',
        defaultMessage: 'Merge cells',
        description: 'Merge tables cells together.'
    },
    splitCell: {
        id: 'fabric.editor.splitCell',
        defaultMessage: 'Split cell',
        description: 'Split a merged table cell.'
    },
    clearCells: {
        id: 'fabric.editor.clearCells',
        defaultMessage: 'Clear {0, plural, one {cell} other {cells}}',
        description: 'Clears the contents of the selected cells (this does not delete the cells themselves).'
    },
    sortColumnASC: {
        id: 'fabric.editor.sortColumnASC',
        defaultMessage: "Sort column A \u2192 Z",
        description: 'Sort column in ascending order'
    },
    sortColumnDESC: {
        id: 'fabric.editor.sortColumnDESC',
        defaultMessage: "Sort column Z \u2192 A",
        description: 'Sort column in descending order'
    },
    sortColumnIncreasing: {
        id: 'fabric.editor.sortColumnIncreasing',
        defaultMessage: 'Sort increasing',
        description: 'Sort column in ascending order'
    },
    sortColumnDecreasing: {
        id: 'fabric.editor.sortColumnDecreasing',
        defaultMessage: 'Sort decreasing',
        description: 'Sort column in descending order'
    },
    canNotSortTable: {
        id: 'fabric.editor.canNotSortTable',
        defaultMessage: `\u{26A0}\u{FE0F} You can't sort a table with merged cells`,
        description: `Split your cells to enable this feature`
    },
    distributeColumns: {
        id: 'fabric.editor.distributeColumns',
        defaultMessage: `Distribute columns`,
        description: `Distribute widths between selected columns`
    },
    lockColumnWidths: {
        id: 'fabric.editor.lockColumns',
        defaultMessage: 'Fixed column widths',
        description: 'Toggle button to enable fixed column widths'
    },
    rowControl: {
        id: 'fabric.editor.rowControl',
        defaultMessage: 'Highlight row',
        description: 'A button on the left of each row that shows up when the table is in focus. Clicking on it will select the entire row.'
    },
    rowDragHandle: {
        id: 'fabric.editor.rowDragHandle',
        defaultMessage: 'Row options',
        description: 'The row drag handle to move the row within the table. Click to open a menu for more row options.'
    },
    dragHandleZone: {
        id: 'fabric.editor.dragHandleZone',
        defaultMessage: 'Activate drag handle zone',
        description: 'The drag handle zone to trigger the drag handle to move the row/column within the table.'
    },
    columnDragHandle: {
        id: 'fabric.editor.columnDragHandle',
        defaultMessage: 'Column options',
        description: 'The column drag handle to move the column within the table. Click to open a menu for more column options.'
    },
    fullWidthLabel: {
        id: 'fabric.editor.tableFullWidthLabel',
        defaultMessage: 'Full-width',
        description: 'Trigger table width to full-width mode'
    },
    startedColumnResize: {
        id: 'fabric.editor.tables.startedColumnResize',
        defaultMessage: 'Started column resize',
        description: 'Screen Reader announces when the user engages the column resizer'
    },
    focusedOtherResize: {
        id: 'fabric.editor.tables.otherResize',
        defaultMessage: '{direction, select, left {Switched to the left column resize} right {Switched to the right column resize} other {}}',
        description: 'Screen Reader announces when the user switches to the left or right column resizer'
    },
    changedColumnWidth: {
        id: 'fabric.editor.tables.columnWidth',
        defaultMessage: '{width, plural, one {Column width was changed to {width} pixel} other {Column width was changed to {width} pixels}}',
        description: 'Screen Reader announces when the user modifies the column width'
    },
    columnResizeStop: {
        id: 'fabric.editor.tables.resizeStop',
        defaultMessage: 'Stopped resize',
        description: 'Screen Reader announces when the user discontinues the resizing operation'
    },
    columnResizeOverflow: {
        id: 'fabric.editor.tables.columnResizeOverflow',
        defaultMessage: 'You can only resize this column while the table has a scroll bar.',
        description: 'Screen Reader announces when the user attempts to resize the last column without the table being in overflow state'
    },
    columnResizeLast: {
        id: 'fabric.editor.tables.columnResizeLast',
        defaultMessage: 'You can only resize this column to the left.',
        description: 'Screen Reader announces when the user attempts to resize the last column when only the previous one is available for resizing'
    },
    tableAlignmentOptions: {
        id: 'fabric.editor.tableAlignmentOptions',
        defaultMessage: 'Alignment options',
        description: 'Opens a menu with additional table alignment options'
    },
    alignTableCenter: {
        id: 'fabric.editor.alignTableCenter',
        defaultMessage: 'Align center',
        description: 'Aligns table to the center'
    },
    alignTableLeft: {
        id: 'fabric.editor.alignTableLeft',
        defaultMessage: 'Align left',
        description: 'Aligns table to the left'
    }
});

});

parcelRegister("eCOhn", function(module, exports) {
$parcel$export(module.exports, "messages", () => $45c2fe7a1b237ebb$export$defe85febe8b728c);
// Common Translations will live here

var $7qGN1 = parcelRequire("7qGN1");
const $45c2fe7a1b237ebb$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    unorderedList: {
        id: 'fabric.editor.unorderedList',
        defaultMessage: 'Bullet list',
        description: "A list with bullets. Also known as an \u201Cunordered\u201D list"
    },
    unorderedListDescription: {
        id: 'fabric.editor.unorderedList.description',
        defaultMessage: 'Create an unordered list',
        description: ''
    },
    bulletedList: {
        id: 'fabric.editor.bulletedList',
        defaultMessage: 'Bulleted list',
        description: "A list with bullets. Also known as an \u201Cunordered\u201D list"
    },
    orderedList: {
        id: 'fabric.editor.orderedList',
        defaultMessage: 'Numbered list',
        description: "A list with ordered items 1\u2026 2\u2026 3\u2026"
    },
    orderedListDescription: {
        id: 'fabric.editor.orderedList.description',
        defaultMessage: 'Create an ordered list',
        description: ''
    },
    lists: {
        id: 'fabric.editor.lists',
        defaultMessage: 'Lists',
        description: 'Menu shows ordered/bullet list and unordered/numbered lists'
    },
    listsFormat: {
        id: 'fabric.editor.listsFormat',
        defaultMessage: 'List formatting',
        description: 'Aria label for the wrapper of list buttons'
    }
});

});

parcelRegister("iW8Cl", function(module, exports) {
$parcel$export(module.exports, "messages", () => $8bb64a7e24bfadd9$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $8bb64a7e24bfadd9$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    undo: {
        id: 'fabric.editor.undo',
        defaultMessage: 'Undo',
        description: 'Undo the previously performed action.'
    },
    redo: {
        id: 'fabric.editor.redo',
        defaultMessage: 'Redo',
        description: 'Redo the previously undone action.'
    }
});

});

parcelRegister("2EHqK", function(module, exports) {
$parcel$export(module.exports, "messages", () => $fd160dd2be67857e$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $fd160dd2be67857e$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    statusEditorLabel: {
        id: 'fabric.editor.statusEditorLabel',
        defaultMessage: 'Status editor',
        description: 'Label for the status element editor'
    },
    placeholder: {
        id: 'fabric.editor.statusPlaceholder',
        defaultMessage: 'Set a status',
        description: 'Placeholder description for an empty (new) status item in the editor'
    },
    editText: {
        id: 'fabric.editor.editStatusText',
        defaultMessage: 'Edit Status',
        description: 'Title for the input that changes the status text'
    },
    editColor: {
        id: 'fabric.editor.editStatusColor',
        defaultMessage: 'Edit Status Color',
        description: 'Title for the color picker that changes the status color'
    },
    statusPickerOpenedAlert: {
        id: 'fabric.editor.statusPickerOpenedAlert',
        defaultMessage: 'Status editor popup opened, press Tab to access popup',
        description: 'Screen reader alert when the status picker is opened, letting the user know they can press the Tab button to access the status picker'
    }
});

});

parcelRegister("cINgv", function(module, exports) {
$parcel$export(module.exports, "messages", () => $1eca0ac9b99404a8$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $1eca0ac9b99404a8$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    editText: {
        id: 'fabric.editor.editDateText',
        defaultMessage: 'Edit Date',
        description: 'Title for the input that changes the date'
    },
    invalidDateError: {
        id: 'fabric.editor.invalidDateError',
        defaultMessage: 'Enter a valid date',
        description: 'Error message when the date typed in is invalid, requesting they inputs a new date'
    },
    onKeyUpDownText: {
        id: 'fabric.editor.upDown',
        defaultMessage: 'On the use of up and down arrow keys into the following input field, the date will update below',
        description: 'The text for the date input informs the user that using the arrow keys (up and down) will update the date picker below'
    },
    datePickerOpenedAlert: {
        id: 'fabric.editor.datePickerOpenedAlert',
        defaultMessage: 'Date editor popup opened, press Tab to access popup',
        description: 'Screen reader alert when the date picker is opened, letting the user know they can press the Tab button to access the date picker'
    }
});

});

parcelRegister("iRGZx", function(module, exports) {
$parcel$export(module.exports, "toolbarMessages", () => $4c7e049146e1f690$export$81b075fd34c2f0bb);

var $7qGN1 = parcelRequire("7qGN1");
const $4c7e049146e1f690$export$81b075fd34c2f0bb = (0, $7qGN1.defineMessages)({
    singleColumn: {
        id: 'fabric.editor.single',
        defaultMessage: 'Single column layout',
        description: 'Layout with one single column'
    },
    twoColumns: {
        id: 'fabric.editor.twoColumns',
        defaultMessage: 'Two columns layout',
        description: 'Layout with two columns of equal width'
    },
    singleColumnAdvancedLayout: {
        id: 'fabric.editor.singleColumns',
        defaultMessage: '1 Column layout',
        description: 'Layout with one column of equal width'
    },
    twoColumnsAdvancedLayout: {
        id: 'fabric.editor.twoColumns',
        defaultMessage: '2 Column layout',
        description: 'Layout with two columns of equal width'
    },
    threeColumns: {
        id: 'fabric.editor.threeColumns',
        defaultMessage: 'Three columns layout',
        description: 'Layout with three columns of equal width'
    },
    threeColumnsAdvancedLayout: {
        id: 'fabric.editor.threeColumns',
        defaultMessage: '3 Column layout',
        description: 'Layout with three columns of equal width'
    },
    fourColumns: {
        id: 'fabric.editor.fourColumns',
        defaultMessage: '4 Column layout',
        description: 'Layout with four columns of equal width'
    },
    fiveColumns: {
        id: 'fabric.editor.fiveColumns',
        defaultMessage: '5 Column layout',
        description: 'Layout with five columns of equal width'
    },
    rightSidebar: {
        id: 'fabric.editor.rightSidebar',
        defaultMessage: 'Right sidebar layout',
        description: 'Layout with two columns, left column is 2/3 and right is 1/3 of page'
    },
    leftSidebar: {
        id: 'fabric.editor.leftSidebar',
        defaultMessage: 'Left sidebar layout',
        description: 'Layout with two columns, left column is 1/3 and right is 2/3 of page'
    },
    threeColumnsWithSidebars: {
        id: 'fabric.editor.threeColumnsWithSidebars',
        defaultMessage: 'Three columns with sidebars layout',
        description: 'Layout with 3 columns laid out as 25% - 50% - 25%'
    },
    threeColumnsWithLeftSidebars: {
        id: 'fabric.editor.threeColumnsWithLeftSidebars',
        defaultMessage: 'Three columns with left sidebar layout',
        description: 'Layout with 3 columns laid out as 25% - 25% - 50%'
    },
    threeColumnsWithRightSidebars: {
        id: 'fabric.editor.threeColumnsWithRightSidebars',
        defaultMessage: 'Three columns with right sidebar layout',
        description: 'Layout with 3 columns laid out as 50% - 25% - 25%'
    },
    floatingToolbarRadioGroupAriaLabel: {
        id: 'fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel',
        defaultMessage: 'Layout options',
        description: "a floating toolbar radiogroup's aria label"
    },
    layoutPlaceholder: {
        id: 'fabric.editor.layout.placeholder',
        defaultMessage: 'Add content',
        description: 'Add placeholder text for empty layout'
    },
    controlslayoutPlaceholder: {
        id: 'fabric.editor.layout.controls.placeholder',
        defaultMessage: '/ to insert',
        description: 'Add placeholder text for empty layout'
    },
    columnOption: {
        id: 'fabric.editor.layout.columnOption',
        defaultMessage: '{count, plural, one {{count} Column} other {{count} Columns}}',
        description: 'column option text for layout'
    },
    resizeLayout: {
        id: 'fabric.editor.layout.resizeLayout',
        defaultMessage: 'Resize layout',
        description: 'resize layout'
    }
});

});

parcelRegister("7g31l", function(module, exports) {
$parcel$export(module.exports, "messages", () => $7bbed4c82e53e478$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $7bbed4c82e53e478$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    indent: {
        id: 'fabric.editor.indent',
        defaultMessage: 'Indent',
        description: 'Indent a list item, paragraph or heading'
    },
    outdent: {
        id: 'fabric.editor.outdent',
        defaultMessage: 'Outdent',
        description: 'Outdent a list item, paragraph or heading'
    }
});

});

parcelRegister("cfB8F", function(module, exports) {
$parcel$export(module.exports, "avatarGroupMessages", () => $a6cec650fc40f0ef$export$8a0e7c3f8f5b8868);

var $7qGN1 = parcelRequire("7qGN1");
const $a6cec650fc40f0ef$export$8a0e7c3f8f5b8868 = (0, $7qGN1.defineMessages)({
    editors: {
        id: 'fabric.editor.editors',
        defaultMessage: 'Editors',
        description: 'classifying the people that are currently editing the document'
    }
});

});

parcelRegister("cDtOg", function(module, exports) {
$parcel$export(module.exports, "findReplaceMessages", () => $a66c45e29fd21165$export$b46a930e1a386b2e);

var $7qGN1 = parcelRequire("7qGN1");
const $a66c45e29fd21165$export$b46a930e1a386b2e = (0, $7qGN1.defineMessages)({
    find: {
        id: 'fabric.editor.find',
        defaultMessage: 'Find',
        description: 'The word or phrase to search for on the document'
    },
    matchCase: {
        id: 'fabric.editor.matchCase',
        defaultMessage: 'Match case',
        description: 'Toggle whether should also match case when searching for text'
    },
    findNext: {
        id: 'fabric.editor.findNext',
        defaultMessage: 'Find next',
        description: 'Locate the next occurrence of the word or phrase that was searched for'
    },
    findPrevious: {
        id: 'fabric.editor.findPrevious',
        defaultMessage: 'Find previous',
        description: 'Locate the previous occurrence of the word or phrase that was searched for'
    },
    closeFindReplaceDialog: {
        id: 'fabric.editor.closeFindReplaceDialog',
        defaultMessage: 'Close',
        description: 'Cancel search and close the "Find and Replace" dialog'
    },
    noResultsFound: {
        id: 'fabric.editor.noResultsFound',
        defaultMessage: 'No results',
        description: 'No matches were found for the word or phrase that was searched for'
    },
    resultsCount: {
        id: 'fabric.editor.resultsCount',
        description: 'Text for selected search match position and total results count',
        defaultMessage: '{selectedMatchPosition} of {totalResultsCount}'
    },
    findReplaceToolbarButton: {
        id: 'fabric.editor.findReplaceToolbarButton',
        defaultMessage: 'Find and replace',
        description: '"Find" highlights all instances of a word or phrase on the document, and "Replace" changes one or all of those instances to something else'
    },
    replaceWith: {
        id: 'fabric.editor.replaceWith',
        defaultMessage: 'Replace with',
        description: 'The value that will replace the word or phrase that was searched for'
    },
    replace: {
        id: 'fabric.editor.replace',
        defaultMessage: 'Replace',
        description: 'Replace only the currently selected instance of the word or phrase'
    },
    replaceAll: {
        id: 'fabric.editor.replaceAll',
        defaultMessage: 'Replace all',
        description: 'Replace all instances of the word or phrase throughout the entire document'
    },
    replaceSuccess: {
        id: 'fabric.editor.replaceSuccess',
        defaultMessage: '{numberOfMatches, plural, one {# match replaced} other {# matches replaced}}',
        description: 'Text when replacement succesfully done'
    }
});

});

parcelRegister("4DFTL", function(module, exports) {
$parcel$export(module.exports, "elementInsertSidePanel", () => $d008cf8ca1405ef2$export$276a218f93338b76);

var $7qGN1 = parcelRequire("7qGN1");
const $d008cf8ca1405ef2$export$276a218f93338b76 = (0, $7qGN1.defineMessages)({
    title: {
        id: 'fabric.editor.elementInsertSidePanel.title',
        defaultMessage: 'Insert',
        description: 'Title of a panel that opens on the side'
    }
});

});

parcelRegister("DGjKK", function(module, exports) {
$parcel$export(module.exports, "textColorMessages", () => $d285b988275b721e$export$effb4ee8b6f74abe);

var $7qGN1 = parcelRequire("7qGN1");
const $d285b988275b721e$export$effb4ee8b6f74abe = (0, $7qGN1.defineMessages)({
    textColor: {
        id: 'fabric.editor.textColor',
        defaultMessage: '{selectedColorName} Text color',
        description: 'Label of menu that provides access to various colors of text. For example: green Text color, dark blue Text color'
    },
    textColorTooltip: {
        id: 'fabric.editor.textColorTooltip',
        defaultMessage: 'Text color',
        description: 'Toolip of menu that provides access to various colors of text.'
    },
    textColorHighlightTooltip: {
        id: 'fabric.editor.textColorHighlightTooltip',
        defaultMessage: 'Text and Highlight color',
        description: 'Tooltip of menu that provides access to various colors of highlight.'
    }
});

});

parcelRegister("fbDBV", function(module, exports) {
$parcel$export(module.exports, "tasksAndDecisionsMessages", () => $7a785933fd3c87cb$export$273d864e9e6d0b1f);

var $7qGN1 = parcelRequire("7qGN1");
const $7a785933fd3c87cb$export$273d864e9e6d0b1f = (0, $7qGN1.defineMessages)({
    taskPlaceholder: {
        id: 'fabric.editor.taskPlaceholder',
        defaultMessage: "Type your action, use '@' to assign to someone.",
        description: 'Placeholder description for an empty action/task in the editor'
    },
    decisionPlaceholder: {
        id: 'fabric.editor.decisionPlaceholder',
        defaultMessage: "Add a decision\u2026",
        description: 'Placeholder description for an empty decision in the editor'
    },
    editAccessTitle: {
        id: 'fabric.editor.editAccessTitle',
        defaultMessage: 'You need edit access',
        description: 'Title in the popup when we click on action item checkbox without edit permission'
    },
    requestToEditDescription: {
        id: 'fabric.editor.requestToEditDescription',
        defaultMessage: 'When you request access, the page owner will receive a notification.',
        description: 'Description in the popup when we click on action item checkbox without edit permission'
    },
    requestToEdit: {
        id: 'fabric.editor.requestToEdit',
        defaultMessage: 'Request to edit',
        description: 'Button in the popup when we click on action item checkbox without edit permission'
    },
    dismiss: {
        id: 'fabric.editor.requestToEditDismiss',
        defaultMessage: 'Dismiss',
        description: 'Button in the popup when we click on dismiss without edit permission'
    },
    markTaskAsCompleted: {
        id: 'fabric.editor.taskDecision.markTaskAsCompleted',
        defaultMessage: 'Mark task as completed',
        description: 'Button to mark a task as complete in the editor'
    },
    markTaskAsNotCompleted: {
        id: 'fabric.editor.taskDecision.markTaskAsNotCompleted',
        defaultMessage: 'Mark task as not completed',
        description: 'Button to mark a task as not complete in the editor'
    },
    taskList: {
        id: 'fabric.editor.taskList',
        defaultMessage: 'Task list',
        description: 'Label for the task list in the editor'
    }
});

});

parcelRegister("dfJR8", function(module, exports) {
$parcel$export(module.exports, "placeholderTextMessages", () => $61bb10fca263c45e$export$ee8ab8a034b5a8bd);

var $7qGN1 = parcelRequire("7qGN1");
const $61bb10fca263c45e$export$ee8ab8a034b5a8bd = (0, $7qGN1.defineMessages)({
    placeholderTextPlaceholder: {
        id: 'fabric.editor.placeholderTextPlaceholder',
        defaultMessage: 'Add placeholder text',
        description: ''
    },
    shortEmptyNodePlaceholderText: {
        id: 'fabric.editor.shortEmptyNodePlaceholderText',
        defaultMessage: '/ to insert',
        description: 'Short placeholder text for empty nodes'
    },
    longEmptyNodePlaceholderText: {
        id: 'fabric.editor.longEmptyNodePlaceholderText',
        defaultMessage: 'Type / to insert elements',
        description: 'Long placeholder text for empty nodes'
    },
    syncBlockPlaceholderText: {
        id: 'fabric.editor.syncBlockPlaceholderText',
        defaultMessage: 'Add content then copy this synced block to access it across spaces',
        description: 'Placeholder text for sync block'
    }
});

});

parcelRegister("dH8bz", function(module, exports) {
$parcel$export(module.exports, "pasteOptionsToolbarMessages", () => $403965a26c78acdb$export$703e803e9cb0cea4);

var $7qGN1 = parcelRequire("7qGN1");
const $403965a26c78acdb$export$703e803e9cb0cea4 = (0, $7qGN1.defineMessages)({
    pasteOptions: {
        id: 'fabric.editor.pasteOptions',
        defaultMessage: 'Paste options',
        description: 'Opens a menu with additional paste options'
    },
    plainText: {
        id: 'fabric.editor.plainText',
        defaultMessage: 'Use plain text',
        description: 'Converts pasted text into plain text'
    },
    markdown: {
        id: 'fabric.editor.useMarkdown',
        defaultMessage: 'Use Markdown',
        description: 'Converts pasted text into Markdown'
    },
    richText: {
        id: 'fabric.editor.richText',
        defaultMessage: 'Use rich text',
        description: 'Converts pasted text into Rich text'
    }
});

});

parcelRegister("gjx6N", function(module, exports) {
$parcel$export(module.exports, "panelMessages", () => $972b12a409cadd14$export$7bb18eb6f9170174);

var $7qGN1 = parcelRequire("7qGN1");
const $972b12a409cadd14$export$7bb18eb6f9170174 = (0, $7qGN1.defineMessages)({
    info: {
        id: 'fabric.editor.info',
        defaultMessage: 'Info',
        description: 'Panels provide a way to highlight text. The info panel has a blue background.'
    },
    note: {
        id: 'fabric.editor.note',
        defaultMessage: 'Note',
        description: 'Panels provide a way to highlight text. The note panel has a purple background.'
    },
    success: {
        id: 'fabric.editor.success',
        defaultMessage: 'Success',
        description: 'Panels provide a way to highlight text. The success panel has a green background.'
    },
    warning: {
        id: 'fabric.editor.warning',
        defaultMessage: 'Warning',
        description: 'Panels provide a way to highlight text. The warning panel has a yellow background.'
    },
    error: {
        id: 'fabric.editor.error',
        defaultMessage: 'Error',
        description: 'Panels provide a way to highlight text. The error panel has a red background.'
    },
    emoji: {
        id: 'fabric.editor.panel.emoji',
        defaultMessage: 'Add emoji',
        description: 'Select the panel icon'
    },
    custom: {
        id: 'fabric.editor.panel.custom',
        defaultMessage: 'Custom',
        description: 'Custom panels where user has selected custom emoji and background color'
    },
    backgroundColor: {
        id: 'fabric.editor.panel.backgroundColor',
        defaultMessage: 'Background color',
        description: 'Select the panel background color.'
    },
    panelsGroup: {
        id: 'fabric.editor.panel.panelsGroup',
        defaultMessage: 'Panel Types',
        description: 'aria-label for group of panels the floating toolbar'
    }
});

});

parcelRegister("h6V7a", function(module, exports) {
$parcel$export(module.exports, "mentionMessages", () => $2c98be67879905c5$export$33aafd5ccbbbd00a);

var $7qGN1 = parcelRequire("7qGN1");
const $2c98be67879905c5$export$33aafd5ccbbbd00a = (0, $7qGN1.defineMessages)({
    inviteItemTitle: {
        id: 'fabric.editor.inviteItem.title',
        defaultMessage: '{userRole, select, admin {Invite} trusted {Invite} other {Add}} teammate to {productName}',
        description: 'Title of the invite teammate item in typeahead plugin'
    },
    mentionsAddLabel: {
        id: 'fabric.editor.mentionsAddLabel',
        defaultMessage: 'add-icon',
        description: 'icon label to describe adding a new mention'
    },
    mentionsIconLabel: {
        id: 'fabric.editor.mentionsIconLabel',
        defaultMessage: 'Mention',
        description: 'icon label to describe the mention icon'
    },
    mentionsNodeLabel: {
        id: 'fabric.editor.mentionNode.label',
        defaultMessage: 'Tagged user',
        description: 'Label to indicate mention node to Screen reader users, that preceeds with user name ex: "Tagged user @XXX'
    },
    unknownLabel: {
        id: 'fabric.editor.unknown.label',
        defaultMessage: 'Unknown',
        description: 'Label to indicate unknown mention node'
    }
});

});

parcelRegister("gYWwp", function(module, exports) {
$parcel$export(module.exports, "helpDialogMessages", () => $899ee4221ade9631$export$83c85447c71428ba);

var $7qGN1 = parcelRequire("7qGN1");
const $899ee4221ade9631$export$83c85447c71428ba = (0, $7qGN1.defineMessages)({
    editorHelp: {
        id: 'fabric.editor.editorHelp',
        defaultMessage: 'Editor help',
        description: 'Title of editor help dialog.'
    },
    helpDialogTips: {
        id: 'fabric.editor.helpDialogTips',
        defaultMessage: 'Press {keyMap} to quickly open this dialog at any time',
        description: 'Hint about how to open a dialog quickly using a shortcut.'
    },
    keyboardShortcuts: {
        id: 'fabric.editor.keyboardShortcuts',
        defaultMessage: 'Keyboard shortcuts',
        description: ''
    },
    markdown: {
        id: 'fabric.editor.markdown',
        defaultMessage: 'Markdown',
        description: 'It is a name of popular markup language.'
    },
    pastePlainText: {
        id: 'fabric.editor.pastePlainText',
        defaultMessage: 'Paste plain text',
        description: ''
    },
    CheckUncheckActionItem: {
        id: 'fabric.editor.checkUncheckActionItem',
        defaultMessage: 'Toggle action item',
        description: 'For Check/Uncheck Action item use shortcut'
    },
    InsertTableColumn: {
        id: 'fabric.editor.insertTableColumn',
        defaultMessage: 'Insert table column',
        description: 'For insert table column'
    },
    InsertTableRow: {
        id: 'fabric.editor.insertTableRow',
        defaultMessage: 'Insert table row',
        description: 'For insert table row'
    },
    altText: {
        id: 'fabric.editor.altText',
        defaultMessage: 'Alt text',
        description: 'Alternative text for image.'
    },
    selectTableRow: {
        id: 'fabric.editor.selectTableRow',
        defaultMessage: 'Select table row',
        description: 'Hint for selecting a table row using a shortcut'
    },
    selectTableColumn: {
        id: 'fabric.editor.selectTableColumn',
        defaultMessage: 'Select table column',
        description: 'Hint for selecting a table column using a shortcut'
    },
    selectColumnResize: {
        id: 'fabric.editor.selectColumnResize',
        defaultMessage: 'Select column resize',
        description: 'Hint for selecting a column resize a shortcut'
    },
    increaseSize: {
        id: 'fabric.editor.increaseSize',
        defaultMessage: 'Increase table or media size',
        description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to increase the width of the selected element. Optimal characters less than 21.'
    },
    increaseElementSize: {
        id: 'fabric.editor.increaseElementSize',
        defaultMessage: 'Increase element size',
        description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to increase the width of the selected element. Optimal characters less than 21.'
    },
    decreaseSize: {
        id: 'fabric.editor.decreaseSize',
        defaultMessage: 'Decrease table or media size',
        description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to decrease the width of the selected element. Optimal characters less than 21.'
    },
    decreaseElementSize: {
        id: 'fabric.editor.decreaseElementSize',
        defaultMessage: 'Decrease element size',
        description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to decrease the width of the selected element. Optimal characters less than 21.'
    },
    openCellOptions: {
        id: 'fabric.editor.openCellOptions',
        defaultMessage: 'Open cell options',
        description: 'Keyboard shortcut to open cell options.'
    },
    focusTableResizeHandle: {
        id: 'fabric.editor.focusTableResizeHandle',
        defaultMessage: 'Focus table resize handle',
        description: 'Focus table resize handle'
    },
    closeHelpDialog: {
        id: 'fabric.editor.closeHelpDialog',
        defaultMessage: 'Close help dialog',
        description: ''
    },
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Move it inside quick insert plugin
    quickInsert: {
        id: 'fabric.editor.quickInsert',
        defaultMessage: 'Quick insert',
        description: 'Name of a feature, which let you insert items quickly.'
    },
    highlightColor: {
        id: 'fabric.editor.highlightColor',
        defaultMessage: 'Toggle highlight color palette',
        description: 'Keyboard shortcut to toggle highlight color palette.'
    }
});

});

parcelRegister("lVkxz", function(module, exports) {
$parcel$export(module.exports, "highlightMessages", () => $92b384d8a449c9ca$export$456100c8374b6011);

var $7qGN1 = parcelRequire("7qGN1");
const $92b384d8a449c9ca$export$456100c8374b6011 = (0, $7qGN1.defineMessages)({
    highlight: {
        id: 'fabric.editor.highlight',
        defaultMessage: 'Highlight color',
        description: 'Label for the highlight color menu option in the primary editor toolbar. Opens up the color palette for the highlight colors.'
    },
    highlightFloatingToolbar: {
        id: 'fabric.editor.highlightFloatingToolbar',
        defaultMessage: 'Highlight',
        description: 'Button content for the highlight color menu option in the editor floating toolbar. Opens up the color palette for the highlight colors.'
    },
    removeColor: {
        id: 'fabric.editor.highlight.removeColor',
        defaultMessage: 'Remove color',
        description: 'Button content for the combined text highlight and color menu, removes either the applied text color or highlight color.'
    }
});

});

parcelRegister("jlbSP", function(module, exports) {
$parcel$export(module.exports, "mediaInsertMessages", () => $0b0f92edf766e88d$export$7eb9dc59242bbc45);

var $7qGN1 = parcelRequire("7qGN1");
const $0b0f92edf766e88d$export$7eb9dc59242bbc45 = (0, $7qGN1.defineMessages)({
    loadPreview: {
        id: 'fabric.editor.media.insert.loadPreview',
        defaultMessage: 'Load preview',
        description: 'Text on a button that loads a preview of a media file that has been linked to from a URL'
    },
    insert: {
        id: 'fabric.editor.media.insert.insert',
        defaultMessage: 'Insert',
        description: 'Text on the modal action button that inserts the linked media file into the editor document'
    },
    pasteLinkToUpload: {
        id: 'fabric.editor.media.insert.pasteLinkToUpload',
        defaultMessage: 'Paste link to upload',
        description: 'Placeholder text for the input field where a user can paste (as in copy-paste) a URL to upload a media file'
    },
    cancel: {
        id: 'fabric.editor.media.insert.cancel',
        defaultMessage: 'Cancel',
        description: 'Text on the modal action button that cancels the media file insertion and closes the modal'
    },
    fromUrlErrorMessage: {
        id: 'fabric.editor.media.insert.fromUrlErrorMessage',
        defaultMessage: "Unfortunately, we can\u2019t add this image link. Download the image, then drag and drop onto the page.",
        description: 'Error message displayed when a user tries to insert an image from a URL that cannot be loaded. This may be because the URL is invalid, there is a network error or any other reason the preview upload does not succeed. When this occurs the suggestion is to attempt downloading the linked file manually and using a local upload instead.'
    },
    fromUrlWarning: {
        id: 'fabric.editor.media.insert.fromUrlWarning',
        defaultMessage: 'This image might not be visible to others due to source restrictions. Consider uploading the file instead.',
        description: 'Warning message displayed when a user tries to insert an image from a URL that may not be visible to others due to source restrictions such as not having permissions/authentication to load the image. The suggestion is to upload the file instead.'
    },
    localFileNetworkErrorMessage: {
        id: 'fabric.editor.media.insert.localFileNetworkErrorMessage',
        defaultMessage: 'File upload error. Check file path or network.',
        description: 'Error message displayed when a network error occurs during file upload'
    },
    localFileErrorMessage: {
        id: 'fabric.editor.media.insert.localFileErrorMessage',
        defaultMessage: "This file couldn\u2019t be uploaded.",
        description: 'Generic catch-all error message displayed when file upload fails'
    },
    mediaAlt: {
        id: 'fabric.editor.media.insert.mediaAlt',
        defaultMessage: 'Preview for uploaded image or video file',
        description: 'Alt text describing a preview of an image uploaded.'
    },
    upload: {
        id: 'fabric.editor.media.insert.upload',
        defaultMessage: 'Upload',
        description: 'Text on a button that opens a file picker dialog to upload a media file'
    },
    linkTabTitle: {
        id: 'fabric.editor.media.insert.linkTabTitle',
        defaultMessage: 'Link',
        description: 'Title of the navigation tab that allows users to insert media from a URL or link'
    },
    fileTabTitle: {
        id: 'fabric.editor.media.insert.fileTabTitle',
        defaultMessage: 'File',
        description: 'Title of the navigation tab that allows users to upload local media files'
    },
    mediaPickerPopupAriaLabel: {
        id: 'fabric.editor.media.insert.mediaPickerPopupAriaLabel',
        defaultMessage: 'Media picker',
        description: 'Accessibility label for the media picker popup'
    },
    invalidUrlErrorMessage: {
        id: 'fabric.editor.media.insert.invalidUrlErrorMessage',
        defaultMessage: 'Invalid link',
        description: 'Error message displayed when a user tries to insert media from an invalid URL'
    }
});

});

parcelRegister("ee8QX", function(module, exports) {
$parcel$export(module.exports, "selectionToolbarMessages", () => $e86aaeaae7fd5cd3$export$b0226831bf5c0d3e);

var $7qGN1 = parcelRequire("7qGN1");
const $e86aaeaae7fd5cd3$export$b0226831bf5c0d3e = (0, $7qGN1.defineMessages)({
    toolbarAppears: {
        id: 'fabric.editor.toolbarAppears',
        defaultMessage: 'Toolbar appears',
        description: 'Label for toolbar position options'
    },
    toolbarPositionInline: {
        id: 'fabric.editor.toolbarPositionInline',
        defaultMessage: 'In-line with text',
        description: 'Label for in-line toolbar position option'
    },
    toolbarPositionFixedAtTop: {
        id: 'fabric.editor.toolbarPositionFixedAtTop',
        defaultMessage: 'Fixed at top',
        description: 'Label for fixed at top toolbar position option'
    },
    toolbarPositionUnpined: {
        id: 'fabric.editor.toolbarPositionUnpined',
        defaultMessage: 'Pin the toolbar at the top',
        description: 'Label for in-line toolbar position option'
    },
    toolbarPositionPinedAtTop: {
        id: 'fabric.editor.toolbarPositionPinedAtTop',
        defaultMessage: 'Unpin the toolbar',
        description: 'Label for fixed at top toolbar position option'
    },
    toolbarPositionUnpinnedConcise: {
        id: 'fabric.editor.toolbarPositionUnpinnedConcise',
        defaultMessage: 'Pin toolbar to top',
        description: 'Label for menu item to pin the toolbar to the top of the page'
    }
});

});

parcelRegister("dTBhg", function(module, exports) {
$parcel$export(module.exports, "contextPanelMessages", () => $392c7c9da540e229$export$8ea7f7e979b71fa5);

var $7qGN1 = parcelRequire("7qGN1");
const $392c7c9da540e229$export$8ea7f7e979b71fa5 = (0, $7qGN1.defineMessages)({
    panelLabel: {
        id: 'fabric.editor.contextPanel.panelLabel',
        defaultMessage: 'Context panel',
        description: 'Label for the context panel'
    }
});

});

parcelRegister("mo6o5", function(module, exports) {
$parcel$export(module.exports, "trackChangesMessages", () => $45b94eed1df02b58$export$8448461a71ae48a1);

var $7qGN1 = parcelRequire("7qGN1");
const $45b94eed1df02b58$export$8448461a71ae48a1 = (0, $7qGN1.defineMessages)({
    toolbarIconLabel: {
        id: 'editor.trackChanges.toolbarIconLabel',
        defaultMessage: 'Track Changes',
        description: 'Label for the track changes toolbar icon'
    },
    removed: {
        id: 'editor.trackChanges.removed',
        defaultMessage: 'Removed',
        description: 'Label for content that has been removed in track changes'
    }
});

});

parcelRegister("6TnyW", function(module, exports) {
$parcel$export(module.exports, "syncBlockMessages", () => $e9fcd42a782c1ddc$export$254768729b492c8b);

var $7qGN1 = parcelRequire("7qGN1");
const $e9fcd42a782c1ddc$export$254768729b492c8b = (0, $7qGN1.defineMessages)({
    copySyncBlockLabel: {
        id: 'fabric.editor.copySyncBlock',
        defaultMessage: 'Copy',
        description: 'Button label for copying the reference of sync block element to your clipboard'
    },
    copySyncBlockTooltip: {
        id: 'fabric.editor.copySyncBlockTooltip',
        defaultMessage: 'Copy reference to clipboard',
        description: 'Tooltip for the button to copy the reference of sync block element to your clipboard'
    },
    editSourceLabel: {
        id: 'fabric.editor.editSourceLabel',
        defaultMessage: 'Edit source',
        description: 'Button label for editing the source of sync block element'
    },
    editSourceTooltip: {
        id: 'fabric.editor.editSourceTooltip',
        defaultMessage: 'Navigate to source page of the sync block',
        description: 'Tooltip for the button to navigate to the source page of the sync block element'
    },
    editSourceTooltipDisabled: {
        id: 'fabric.editor.editSourceTooltipDisabled',
        defaultMessage: 'Source link is not currently available',
        description: 'Tooltip for the button to navigate to the source page, when URL is not available'
    },
    syncBlockGroup: {
        id: 'fabric.editor.syncBlockGroup',
        defaultMessage: 'Sync Block Types',
        description: 'aria-label for group of sync block the floating toolbar'
    },
    syncedBlockLabel: {
        id: 'fabric.editor.syncedBlock',
        defaultMessage: 'Synced block',
        description: 'Label which appears above the synced block when it is selected'
    },
    permissionDeniedHeading: {
        id: 'fabric.editor.syncedBlockPermissionDeniedHeading',
        defaultMessage: "You don't have permission to view this synced block",
        description: 'Heading for error state where the user does not have permission to view the synced block'
    },
    permissionDeniedDescription: {
        id: 'fabric.editor.syncedBlockPermissionDeniedDescription',
        defaultMessage: "The source of this synced block is a content item you don't have access to.",
        description: 'Description for error state where the user does not have permission to view the synced block'
    },
    permissionDeniedAltText: {
        id: 'fabric.editor.syncedBlockPermissionDeniedIconAltText',
        defaultMessage: 'Permission denied.',
        description: 'Alt text for icon on error state where the user does not have permission to view the synced block'
    },
    requestAccessButton: {
        id: 'fabric.editor.requestAccessToSyncedBlock',
        defaultMessage: 'Request access',
        description: 'Label for button which requests access to view the source page of the sync block'
    },
    accessRequested: {
        id: 'fabric.editor.accessToSyncedBlockRequested',
        defaultMessage: 'Access requested',
        description: 'Text which displays after the request to view the source page of the sync block has been sent and is still pending'
    },
    requestAccessError: {
        id: 'fabric.editor.requestAccessToSyncedBlockError',
        defaultMessage: 'Something went wrong. Click to try again',
        description: 'Text which displays next to the request access button after something went wrong after clicking the button.'
    },
    sourceSyncBlockTooltip: {
        id: 'fabric.editor.sourceSyncBlockTooltip',
        defaultMessage: 'When you edit this source block it will update across synced locations.',
        description: 'Description in tooltip which appears when you hover over the synced block label'
    },
    defaultSyncBlockTooltip: {
        id: 'fabric.editor.sourceSyncBlockTooltip',
        defaultMessage: 'Synced block',
        description: "Description in tooltip which appears when we haven't been able to fetch other information about the sync block"
    },
    referenceSyncBlockTooltip: {
        id: 'fabric.editor.referenceSyncBlockTooltip',
        defaultMessage: 'Synced from: {title}',
        description: 'Tooltip that shows the source page title of the synced block'
    },
    deleteConfirmationModalTitle: {
        id: 'fabric.editor.deleteConfirmationModalTitle',
        defaultMessage: "You're about to delete synced content",
        description: 'Title of delete confirmation modal that appears when user tries to delete source synced block'
    },
    deleteConfirmationModalCancelButton: {
        id: 'fabric.editor.deleteConfirmationModalCancelButton',
        defaultMessage: "Cancel",
        description: 'Text on button which cancels deleting when user was trying to delete source synced block'
    },
    deleteConfirmationModalDeleteButton: {
        id: 'fabric.editor.deleteConfirmationModalDeleteButton',
        defaultMessage: "Delete",
        description: 'Text on button which confirms deleting the sync block when user was trying to delete source synced block'
    },
    deleteConfirmationModalDescription: {
        id: 'fabric.editor.deleteConfirmationModalDescriptionSingle',
        defaultMessage: 'Deleting this content will also remove {syncBlockCount, plural, one {a synced block. References to this block} other {# synced blocks. References to these blocks}} in other locations will show an error. Continue with deletion?',
        description: 'Description of delete confirmation modal that appears when user tries to delete source synced block'
    }
});

});


parcelRegister("7SIsS", function(module, exports) {
$parcel$export(module.exports, "walkUpTreeUntil", () => $303e888fda8630d4$export$df14aaf7a527ab0c);
$parcel$export(module.exports, "unwrap", () => $303e888fda8630d4$export$debb760848ca95a);
$parcel$export(module.exports, "removeNestedEmptyEls", () => $303e888fda8630d4$export$5b66dc78851adb5e);
$parcel$export(module.exports, "containsClassName", () => $303e888fda8630d4$export$c8913a477cc44663);
$parcel$export(module.exports, "closest", () => $303e888fda8630d4$export$ff7f7c97cdce86e);
$parcel$export(module.exports, "closestElement", () => $303e888fda8630d4$export$d508bcfb7f019487);
$parcel$export(module.exports, "parsePx", () => $303e888fda8630d4$export$b0eef8cd00b29d5c);
$parcel$export(module.exports, "maphElem", () => $303e888fda8630d4$export$5b6ab01a6efa50e2);
/**
 * Walks a DOM tree up to the provided `stopElement`, or if falsy before.
 * @param element
 * @param stopElement
 */ function $303e888fda8630d4$export$df14aaf7a527ab0c(element, shouldStop) {
    let rootElement = element;
    while(rootElement && rootElement.parentElement && !shouldStop(rootElement))rootElement = rootElement.parentElement;
    return rootElement;
}
function $303e888fda8630d4$export$debb760848ca95a(parent, wrapped) {
    const docsFragment = document.createDocumentFragment();
    Array.from(wrapped.children).forEach((child)=>{
        docsFragment.appendChild(child);
    });
    parent.replaceChild(docsFragment, wrapped);
}
function $303e888fda8630d4$export$5b66dc78851adb5e(el) {
    while(el.parentElement && el.childElementCount === 0 && el.textContent === ''){
        const parentEl = el.parentElement;
        parentEl.removeChild(el);
        el = parentEl;
    }
}
const $303e888fda8630d4$export$c8913a477cc44663 = (node, className)=>{
    if (!node) return false;
    if (node.classList && node.classList.contains) return node.classList.contains(className);
    if (!node.className) return false;
    const classNames = typeof node.className.baseVal === 'string' ? node.className.baseVal : node.className;
    return classNames.split(' ').indexOf(className) !== -1;
};
function $303e888fda8630d4$export$ff7f7c97cdce86e(node, s) {
    if (!node) return null;
    let el = node;
    if (!document.documentElement || !document.documentElement.contains(el)) return null;
    if (el.closest) return el.closest(s);
    do {
        const matchfn = el.matches ? el.matches : el.msMatchesSelector;
        if (matchfn && matchfn.call(el, s)) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        return el;
        el = el.parentElement || el.parentNode;
    }while (el !== null && el.nodeType === 1);
    return null;
}
function $303e888fda8630d4$export$d508bcfb7f019487(node, s) {
    return $303e888fda8630d4$export$ff7f7c97cdce86e(node, s);
}
function $303e888fda8630d4$export$b0eef8cd00b29d5c(pxStr) {
    if (!pxStr.endsWith('px')) return undefined;
    const maybeNumber = parseInt(pxStr, 10);
    return !Number.isNaN(maybeNumber) ? maybeNumber : undefined;
}
function $303e888fda8630d4$export$b2d5d4f1aeebddf1(elem, callback) {
    const array = [];
    for(let i = 0; i < elem.childElementCount; i++)array.push(callback(elem.children[i], i, elem));
    return array;
}
function $303e888fda8630d4$export$5b6ab01a6efa50e2(elem, callback) {
    return $303e888fda8630d4$export$b2d5d4f1aeebddf1(elem, callback);
}

});


parcelRegister("iRC0e", function(module, exports) {
$parcel$export(module.exports, "RendererCssClassName", () => $8260bd4d0a5990ae$export$91f3bbbf974496e2);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
const $8260bd4d0a5990ae$var$clPrefix = 'ak-renderer-';
const $8260bd4d0a5990ae$export$91f3bbbf974496e2 = {
    DOCUMENT: `${$8260bd4d0a5990ae$var$clPrefix}document`,
    EXTENSION: `${$8260bd4d0a5990ae$var$clPrefix}extension`,
    EXTENSION_CENTER_ALIGN: `${$8260bd4d0a5990ae$var$clPrefix}extension-center-align`,
    EXTENSION_OVERFLOW_CONTAINER: `${$8260bd4d0a5990ae$var$clPrefix}extension-overflow-container`,
    NUMBER_COLUMN: `${$8260bd4d0a5990ae$var$clPrefix}table-number-column`,
    SORTABLE_COLUMN_WRAPPER: `${$8260bd4d0a5990ae$var$clPrefix}tableHeader-sortable-column__wrapper`,
    SORTABLE_COLUMN: `${$8260bd4d0a5990ae$var$clPrefix}tableHeader-sortable-column`,
    SORTABLE_COLUMN_ICON_WRAPPER: `${$8260bd4d0a5990ae$var$clPrefix}tableHeader-sorting-icon__wrapper`,
    SORTABLE_COLUMN_NO_ORDER: `${$8260bd4d0a5990ae$var$clPrefix}tableHeader-sorting-icon__no-order`
};

});


parcelRegister("7DXmb", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $857f9b714f712b51$export$e926676385687eaf);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $bMFKb = parcelRequire("bMFKb");

var $bgewf = parcelRequire("bgewf");

var $djRdf = parcelRequire("djRdf");

var $7ueoK = parcelRequire("7ueoK");

var $aXKmr = parcelRequire("aXKmr");
class $857f9b714f712b51$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    fireAnalyticsEvent(event) {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        if (createAnalyticsEvent) {
            const channel = (0, $bgewf.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        const additionalInfo = this.props.additionalInfo ?? '';
        this.fireAnalyticsEvent({
            action: (0, $bMFKb.ACTION).CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $7ueoK.PLATFORM).WEB,
                errorMessage: `${additionalInfo}${error?.message}`,
                componentStack: errorInfo?.componentStack || undefined,
                errorRethrown: Boolean(this.props.rethrowError)
            }
        });
        (0, $djRdf.logException)(error, {
            location: 'renderer'
        });
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const pattern = /Failed to execute.*on 'Node'.*/;
        const matchesPattern = pattern.test(error.message);
        if (matchesPattern) {
            this.fireAnalyticsEvent({
                action: (0, $bMFKb.ACTION).CAUGHT_DOM_ERROR,
                actionSubject: this.props.component,
                actionSubjectId: this.props.componentId,
                eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    platform: (0, $7ueoK.PLATFORM).WEB,
                    errorMessage: `${additionalInfo}${error?.message}`
                }
            });
            this.setState(()=>({
                    domError: true
                }));
        }
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        }, ()=>{
            if (this.props.rethrowError) throw error;
        });
    }
    render() {
        if (this.state.domError) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
            children: this.props.children
        }, (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))());
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            errorCaptured: false,
            domError: false
        };
    }
}

});
parcelRegister("djRdf", function(module, exports) {
$parcel$export(module.exports, "logException", () => $163b5c5391cb930a$export$f86b2a1a2ce291b3);

var $ggBOG = parcelRequire("ggBOG");
const $163b5c5391cb930a$var$SENTRY_DSN = 'https://0b10c8e02fb44d8796c047b102c9bee8@o55978.ingest.sentry.io/4505129224110080';
const $163b5c5391cb930a$var$packageName = 'editor-common'; // Sentry doesn't accept '/' in its releases https://docs.sentry.io/platforms/javascript/configuration/releases/
const $163b5c5391cb930a$var$packageVersion = "0.0.0-use.local";
const $163b5c5391cb930a$var$sanitiseSentryEvents = (data, _hint)=>{
    // Remove URL as it has UGC
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Sanitise the URL instead of just removing it
    if (data.request) delete data.request.url;
    return data;
};


const $163b5c5391cb930a$export$f86b2a1a2ce291b3 = async (error, tags)=>{
    try {
        const { BrowserClient: BrowserClient, defaultIntegrations: defaultIntegrations, getCurrentHub: getCurrentHub } = await (parcelRequire("7rjAT"));
        const { ExtraErrorData: ExtraErrorData } = await (parcelRequire("5JtgR"));
        const sentryOptions = {
            dsn: (0, $ggBOG.isFedRamp)() ? undefined : $163b5c5391cb930a$var$SENTRY_DSN,
            release: `${$163b5c5391cb930a$var$packageName}@${$163b5c5391cb930a$var$packageVersion}`,
            environment: undefined ?? 'unknown',
            ignoreErrors: [
                // Network issues
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                /^network error/i,
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                /^network failure/i,
                'TypeError: Failed to fetch',
                // A benign error, see https://stackoverflow.com/a/50387233/2645305
                'ResizeObserver loop limit exceeded',
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                /ResizeObserver loop completed with undelivered notifications/
            ],
            autoSessionTracking: false,
            integrations: (_integrations)=>[
                    // Remove the Breadcrumbs integration from the default as it's too likely to log UGC/PII
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/default/
                    ...defaultIntegrations.filter(({ name: name })=>name !== 'Breadcrumbs'),
                    // Extracts all non-native attributes from the error object and attaches them to the event as the extra data
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/plugin/?original_referrer=https%3A%2F%2Fduckduckgo.com%2F#extraerrordata
                    new ExtraErrorData()
                ],
            beforeSend: $163b5c5391cb930a$var$sanitiseSentryEvents
        };
        // Use a client to avoid picking up the errors from parent applications
        const client = new BrowserClient(sentryOptions);
        const hub = getCurrentHub();
        // @ts-ignore - TypeScript 5.9.2 upgrade
        hub.bindClient(client);
        hub.withScope((scope)=>{
            scope.setTags({
                // Jira environment variables
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-bundler': window.BUNDLER_VERSION,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-variant': window.BUILD_VARIANT,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-release': window.BUILD_KEY,
                // Confluence environment variables
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'confluence-frontend-version': window.__buildInfo?.FRONTEND_VERSION,
                ...tags
            });
            // Explicitly remove the breadcrumbs as it's too likely to log UGC/PII to side-step the hub integrations not being respected
            scope.clearBreadcrumbs();
            hub.captureException(error);
        });
        // @ts-ignore - TypeScript 5.9.2 upgrade
        return client.close();
    } catch (_error) {
    // Error reporting failed, we don't want this to generate more errors
    }
};

});
parcelRegister("ggBOG", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", () => $a0cf5f3254b84053$export$64d6499adf9b2e51);
const $a0cf5f3254b84053$var$FEDRAMP_MODERATE = 'fedramp-moderate';
function $a0cf5f3254b84053$export$64d6499adf9b2e51() {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === $a0cf5f3254b84053$var$FEDRAMP_MODERATE;
    const matches = global.location?.hostname?.match(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});

parcelRegister("7rjAT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6dgQT").then(()=>parcelRequire('fVZ2Y'));

});

parcelRegister("5JtgR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("f5ExK").then(()=>parcelRequire('lysGq'));

});


parcelRegister("7ueoK", function(module, exports) {
$parcel$export(module.exports, "PLATFORM", () => $0b4fec753ef144f9$export$88c4881e092abcaf);
$parcel$export(module.exports, "MODE", () => $0b4fec753ef144f9$export$e48589d9e4824227);
var $0b4fec753ef144f9$export$88c4881e092abcaf = /*#__PURE__*/ function(PLATFORM) {
    PLATFORM["NATIVE"] = "mobileNative";
    PLATFORM["HYBRID"] = "mobileHybrid";
    PLATFORM["WEB"] = "web";
    return PLATFORM;
}({});
var $0b4fec753ef144f9$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
var $0b4fec753ef144f9$var$RESOLVE_METHOD = /*#__PURE__*/ function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
    return RESOLVE_METHOD;
}($0b4fec753ef144f9$var$RESOLVE_METHOD || {});

});


parcelRegister("ex5uO", function(module, exports) {
$parcel$export(module.exports, "EVENT_TYPE", () => $d667e8c98ffb1fe9$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $d667e8c98ffb1fe9$export$9523889e0a5da4ba);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $d667e8c98ffb1fe9$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $d667e8c98ffb1fe9$export$9957974f8b4d8f74);
var $d667e8c98ffb1fe9$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $d667e8c98ffb1fe9$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["STARTED"] = "started";
    ACTION["RENDERED"] = "rendered";
    ACTION["CRASHED"] = "unhandledErrorCaught";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["CLICKED"] = "clicked";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["INSERTED"] = "inserted";
    ACTION["OPENED"] = "opened";
    ACTION["CLOSED"] = "closed";
    ACTION["DELETED"] = "deleted";
    ACTION["EDITED"] = "edited";
    ACTION["RESOLVED"] = "resolved";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["TABLE_WIDTH_INFO"] = "tableWidthInfo";
    return ACTION;
}({});
var $d667e8c98ffb1fe9$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    return ACTION_SUBJECT;
}({});
var $d667e8c98ffb1fe9$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["HOVER_LABEL"] = "hoverLabel";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    return ACTION_SUBJECT_ID;
}({});

});

parcelRegister("csUn2", function(module, exports) {
$parcel$export(module.exports, "AnnotationsPositionContext", () => $cb5aba900900238c$export$8c8c3e12db6c0591);
$parcel$export(module.exports, "AnnotationsWrapper", () => $cb5aba900900238c$export$cef0157dd42cbb3f);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jxPcD = parcelRequire("jxPcD");

var $kfxeF = parcelRequire("kfxeF");

var $2MYsB = parcelRequire("2MYsB");

var $eFHDV = parcelRequire("eFHDV");

var $1YS5j = parcelRequire("1YS5j");

var $iNoZC = parcelRequire("iNoZC");

var $ftN6c = parcelRequire("ftN6c");

var $e2m7L = parcelRequire("e2m7L");

var $8dxEE = parcelRequire("8dxEE");

var $3OjM0 = parcelRequire("3OjM0");
const $cb5aba900900238c$var$LoadAnnotations = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
    (0, $1YS5j.useLoadAnnotations)({
        adfDocument: adfDocument,
        isNestedRender: isNestedRender,
        onLoadComplete: onLoadComplete
    });
    return null;
});
const $cb5aba900900238c$export$8c8c3e12db6c0591 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext({
    startPos: 1
});
const $cb5aba900900238c$export$7121915072388536 = (props)=>{
    const { children: children, rendererRef: rendererRef, adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete } = props;
    const providers = (0, $eJOHy.useContext)((0, $eFHDV.ProvidersContext));
    const updateSubscriber = providers && providers.inlineComment && providers.inlineComment.updateSubscriber;
    const inlineCommentAnnotationsState = (0, $iNoZC.useAnnotationStateByTypeEvent)({
        type: (0, $jxPcD.AnnotationTypes).INLINE_COMMENT,
        updateSubscriber: updateSubscriber || null
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eFHDV.InlineCommentsStateContext).Provider, {
        value: inlineCommentAnnotationsState,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2m7L.AnnotationRangeProvider), {
            allowCommentsOnMedia: providers?.inlineComment?.allowCommentsOnMedia ?? false,
            isNestedRender: isNestedRender,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8dxEE.AnnotationHoverContext), {
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $2MYsB.AnnotationsContextWrapper), {
                    createAnalyticsEvent: createAnalyticsEvent,
                    rendererRef: rendererRef,
                    isNestedRender: isNestedRender,
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)($cb5aba900900238c$var$LoadAnnotations, {
                            adfDocument: adfDocument,
                            isNestedRender: isNestedRender,
                            onLoadComplete: onLoadComplete
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kfxeF.AnnotationView), {
                            isNestedRender: isNestedRender,
                            createAnalyticsEvent: createAnalyticsEvent
                        }),
                        children
                    ]
                })
            })
        })
    });
};
const $cb5aba900900238c$export$cef0157dd42cbb3f = (props)=>{
    const { children: children, annotationProvider: annotationProvider, rendererRef: rendererRef, adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete } = props;
    if (!isNestedRender && annotationProvider?.annotationManager) // We need to ensure there is a single instance of the annotation manager for the whole document
    // and that it is the same instance for all annotations.
    // This is because the annotation manager is responsible for managing the state of ALL annotations.
    // This includes annotations inside extensions.
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eFHDV.ProvidersContext).Provider, {
        value: annotationProvider,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3OjM0.AnnotationManagerProvider), {
            annotationManager: annotationProvider.annotationManager,
            updateSubscriber: annotationProvider?.inlineComment?.updateSubscriber ?? undefined,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($cb5aba900900238c$export$7121915072388536, {
                rendererRef: rendererRef,
                adfDocument: adfDocument,
                isNestedRender: isNestedRender,
                onLoadComplete: onLoadComplete,
                children: children
            })
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eFHDV.ProvidersContext).Provider, {
        value: annotationProvider,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($cb5aba900900238c$export$7121915072388536, {
            rendererRef: rendererRef,
            adfDocument: adfDocument,
            isNestedRender: isNestedRender,
            onLoadComplete: onLoadComplete,
            children: children
        })
    });
};

});
parcelRegister("kfxeF", function(module, exports) {
$parcel$export(module.exports, "AnnotationView", () => $f1a4c1b074cd6009$export$41cd4a02859c2806);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eFHDV = parcelRequire("eFHDV");

var $iNoZC = parcelRequire("iNoZC");

var $4Z9bh = parcelRequire("4Z9bh");
const $f1a4c1b074cd6009$export$41cd4a02859c2806 = (props)=>{
    const providers = (0, $eJOHy.useContext)((0, $eFHDV.ProvidersContext));
    const actionContext = (0, $eJOHy.useContext)((0, $4Z9bh.RendererContext));
    const inlineCommentProvider = providers && providers.inlineComment;
    const updateSubscriber = inlineCommentProvider && inlineCommentProvider.updateSubscriber || null;
    const viewComponentProps = (0, $iNoZC.useAnnotationClickEvent)({
        updateSubscriber: updateSubscriber,
        createAnalyticsEvent: props.createAnalyticsEvent,
        isNestedRender: props.isNestedRender
    });
    const ViewComponent = inlineCommentProvider && inlineCommentProvider.viewComponent;
    const deleteAnnotation = (0, $eJOHy.useMemo)(()=>(annotationInfo)=>actionContext.deleteAnnotation(annotationInfo.id, annotationInfo.type), [
        actionContext
    ]);
    // For view mode, the finding of inline node types is a bit more complex,
    // that's why we will not provide it as a `inlineNodeTypes` props to the view component,
    // to speed up the rendering process.
    const getInlineNodeTypes = (0, $eJOHy.useCallback)((annotationId)=>actionContext.getInlineNodeTypes(annotationId), [
        actionContext
    ]);
    if (ViewComponent && viewComponentProps) {
        const { annotations: annotations, clickElementTarget: clickElementTarget } = viewComponentProps;
        return /*#__PURE__*/ (0, $gt9Am.jsx)(ViewComponent, {
            annotations: annotations,
            clickElementTarget: clickElementTarget,
            deleteAnnotation: deleteAnnotation,
            getInlineNodeTypes: getInlineNodeTypes
        });
    }
    return null;
};

});
parcelRegister("eFHDV", function(module, exports) {
$parcel$export(module.exports, "ProvidersContext", () => $1b6da805fd7eb803$export$6a26b015ac619737);
$parcel$export(module.exports, "InlineCommentsStateContext", () => $1b6da805fd7eb803$export$aafe46a36ef535ba);

var $eJOHy = parcelRequire("eJOHy");
const $1b6da805fd7eb803$export$6a26b015ac619737 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $1b6da805fd7eb803$export$aafe46a36ef535ba = /*#__PURE__*/ (0, $eJOHy.createContext)({});

});

parcelRegister("iNoZC", function(module, exports) {
$parcel$export(module.exports, "useAnnotationStateByTypeEvent", () => $a748c376ed70405d$export$95f9f9045e92d283);
$parcel$export(module.exports, "useHasFocusEvent", () => $a748c376ed70405d$export$48f5d7f6702be07c);
$parcel$export(module.exports, "useAnnotationClickEvent", () => $a748c376ed70405d$export$26cf539704e444c1);

var $eJOHy = parcelRequire("eJOHy");

var $4Fc33 = parcelRequire("4Fc33");

var $jxPcD = parcelRequire("jxPcD");

var $bMFKb = parcelRequire("bMFKb");

var $bgewf = parcelRequire("bgewf");

var $3OjM0 = parcelRequire("3OjM0");
const $a748c376ed70405d$export$95f9f9045e92d283 = ({ type: type, updateSubscriber: updateSubscriber })=>{
    const [states, setStates] = (0, $eJOHy.useState)({});
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $3OjM0.useAnnotationManagerDispatch)();
    const { annotations: annotations } = (0, $3OjM0.useAnnotationManagerState)();
    const isAnnotationManagerEnabled = !!annotationManager;
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            if (!payload) return;
            const nextStates = Object.values(payload).reduce((acc, curr)=>{
                if (curr.id && curr.annotationType === type) {
                    // Check for empty state to prevent additional renders
                    const isEmpty = curr.state === null || curr.state === undefined;
                    return {
                        ...acc,
                        [curr.id]: !isEmpty ? curr.state : states[curr.id]
                    };
                }
                return acc;
            }, {});
            setStates({
                ...states,
                ...nextStates
            });
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $4Fc33.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            return ()=>{
                updateSubscriber.off((0, $4Fc33.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            };
        }
    }, [
        states,
        type,
        updateSubscriber,
        dispatch,
        isAnnotationManagerEnabled
    ]);
    const annotationMarkStates = (0, $eJOHy.useMemo)(()=>{
        return Object.values(annotations).reduce((acc, curr)=>{
            return {
                ...acc,
                [curr.id]: curr.markState
            };
        }, {});
    }, [
        annotations
    ]);
    if (isAnnotationManagerEnabled) return annotationMarkStates;
    else return states;
};
const $a748c376ed70405d$export$48f5d7f6702be07c = ({ id: id, updateSubscriber: updateSubscriber })=>{
    const [hasFocus, setHasFocus] = (0, $eJOHy.useState)(false);
    const [isHovered, setIsHovered] = (0, $eJOHy.useState)(false);
    const { currentSelectedAnnotationId: currentSelectedAnnotationId, currentHoveredAnnotationId: currentHoveredAnnotationId } = (0, $3OjM0.useAnnotationManagerState)();
    const { annotationManager: annotationManager } = (0, $3OjM0.useAnnotationManagerDispatch)();
    const isAnnotationManagerEnabled = !!annotationManager;
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            setHasFocus(payload && payload.annotationId === id);
        };
        const callbackForHoveredAnnotation = (payload)=>{
            setIsHovered(payload && payload.annotationId === id);
        };
        const removeFocus = ()=>{
            setHasFocus(false);
        };
        const removeHoverEffect = ()=>{
            setIsHovered(false);
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $4Fc33.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
            updateSubscriber.on((0, $4Fc33.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
            updateSubscriber.on((0, $4Fc33.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
            updateSubscriber.on((0, $4Fc33.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, removeHoverEffect);
            return ()=>{
                updateSubscriber.off((0, $4Fc33.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
                updateSubscriber.off((0, $4Fc33.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
                updateSubscriber.off((0, $4Fc33.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
                updateSubscriber.off((0, $4Fc33.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, removeHoverEffect);
            };
        }
    }, [
        id,
        updateSubscriber,
        isAnnotationManagerEnabled
    ]);
    if (isAnnotationManagerEnabled) return {
        hasFocus: currentSelectedAnnotationId === id,
        isHovered: currentHoveredAnnotationId === id
    };
    else return {
        hasFocus: hasFocus,
        isHovered: isHovered
    };
};
const $a748c376ed70405d$var$NO_ANNOTATION_SELECTED = {
    annotations: [],
    clickElementTarget: undefined
};
const $a748c376ed70405d$export$26cf539704e444c1 = (props)=>{
    const [annotationClickEvent, setAnnotationClickEvent] = (0, $eJOHy.useState)(null);
    const { updateSubscriber: updateSubscriber, createAnalyticsEvent: createAnalyticsEvent, isNestedRender: isNestedRender } = props;
    const { annotationManager: annotationManager } = (0, $3OjM0.useAnnotationManagerDispatch)();
    const isAnnotationManagerEnabled = !!annotationManager;
    const { currentSelectedAnnotationId: currentSelectedAnnotationId, currentSelectedMarkRef: currentSelectedMarkRef } = (0, $3OjM0.useAnnotationManagerState)();
    const selectedAnnotation = (0, $eJOHy.useMemo)(()=>{
        return currentSelectedAnnotationId && currentSelectedMarkRef && currentSelectedMarkRef.id === currentSelectedAnnotationId ? {
            annotations: [
                {
                    id: currentSelectedAnnotationId,
                    type: (0, $jxPcD.AnnotationTypes).INLINE_COMMENT
                }
            ],
            clickElementTarget: currentSelectedMarkRef
        } : // When creating a new annotation, currentSelectedAnnotationId and currentSelectedMarkRef will be set one after another,
        // if this isn't a const, it will cause useMemo to return two different "empty" objects and causes infinite re-renders.
        $a748c376ed70405d$var$NO_ANNOTATION_SELECTED;
    }, [
        currentSelectedAnnotationId,
        currentSelectedMarkRef
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!updateSubscriber || isNestedRender) return;
        const clickCb = ({ annotationIds: annotationIds, eventTarget: eventTarget, eventTargetType: eventTargetType, viewMethod: viewMethod })=>{
            const annotationsByType = annotationIds.filter((id)=>!!id).map((id)=>({
                    id: id,
                    type: (0, $jxPcD.AnnotationTypes).INLINE_COMMENT
                }));
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $bMFKb.ACTION).VIEWED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: annotationsByType.length || 0,
                    targetNodeType: eventTargetType,
                    method: viewMethod
                }
            }).fire((0, $bgewf.FabricChannel).editor);
            setAnnotationClickEvent({
                annotations: annotationsByType,
                clickElementTarget: eventTarget
            });
        };
        const deselectCb = ()=>{
            setAnnotationClickEvent({
                annotations: [],
                clickElementTarget: undefined
            });
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $4Fc33.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
            updateSubscriber.on((0, $4Fc33.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            return ()=>{
                updateSubscriber.off((0, $4Fc33.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
                updateSubscriber.off((0, $4Fc33.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            };
        }
    }, [
        updateSubscriber,
        createAnalyticsEvent,
        isNestedRender,
        isAnnotationManagerEnabled
    ]);
    if (isAnnotationManagerEnabled) return isNestedRender ? null : selectedAnnotation;
    else return annotationClickEvent;
};

});
parcelRegister("4Fc33", function(module, exports) {
$parcel$export(module.exports, "AnnotationUpdateEvent", () => $d1a8723ca29ef28b$export$c1c4b33b4e7b1c70);

var $7OU8o = parcelRequire("7OU8o");
var $d1a8723ca29ef28b$export$c1c4b33b4e7b1c70 = /*#__PURE__*/ function(AnnotationUpdateEvent) {
    AnnotationUpdateEvent["SET_ANNOTATION_FOCUS"] = "SET_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["SET_ANNOTATION_HOVERED"] = "SET_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["SET_ANNOTATION_STATE"] = "SET_ANNOTATION_STATE";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_FOCUS"] = "REMOVE_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_HOVERED"] = "REMOVE_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["ON_ANNOTATION_CLICK"] = "ON_ANNOTATION_CLICK";
    AnnotationUpdateEvent["DESELECT_ANNOTATIONS"] = "DESELECT_ANNOTATIONS";
    return AnnotationUpdateEvent;
}({});
class $d1a8723ca29ef28b$export$7cc60aa9ef845515 {
    emit(event, params) {
        if (typeof params === 'undefined') return this.emitter.emit(event);
        return this.emitter.emit(event, params);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    on(event, listener) {
        return this.emitter.on(event, listener);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    off(event, listener) {
        return this.emitter.removeListener(event, listener);
    }
    listeners(event) {
        return this.emitter.listeners(event);
    }
    constructor(){
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($7OU8o)))();
    }
}

});

parcelRegister("3OjM0", function(module, exports) {
$parcel$export(module.exports, "AnnotationManagerProvider", () => $145edea21db52b9d$export$f21fb05766361bb3);
$parcel$export(module.exports, "useAnnotationManagerState", () => $145edea21db52b9d$export$654a1fb45487f838);
$parcel$export(module.exports, "useAnnotationManagerDispatch", () => $145edea21db52b9d$export$12cbbb89fb7702d0);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jxPcD = parcelRequire("jxPcD");

var $4Fc33 = parcelRequire("4Fc33");

var $4Z9bh = parcelRequire("4Z9bh");
const $145edea21db52b9d$var$initState = {
    isDrafting: false,
    draftId: undefined,
    draftMarkRef: undefined,
    draftActionResult: undefined,
    annotations: {},
    currentSelectedAnnotationId: undefined,
    currentSelectedMarkRef: undefined,
    currentHoveredAnnotationId: undefined
};
const $145edea21db52b9d$var$AnnotationManagerStateContext = /*#__PURE__*/ (0, $eJOHy.createContext)($145edea21db52b9d$var$initState);
const $145edea21db52b9d$var$AnnotationManagerDispatchContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    annotationManager: undefined,
    dispatch: ()=>{}
});
function $145edea21db52b9d$var$reducer(state, action) {
    switch(action.type){
        case 'reset':
            return {
                ...state,
                ...$145edea21db52b9d$var$initState
            };
        case 'loadAnnotation':
            {
                const currentIds = Object.keys(state.annotations);
                const uids = Array.from(new Set(currentIds.concat(action.data.map((a)=>a.id))));
                const updates = [];
                for (const id of uids){
                    const loadedAnnotation = action.data.find((a)=>a.id === id);
                    if (!loadedAnnotation && state.annotations[id]?.markState === (0, $jxPcD.AnnotationMarkStates).ACTIVE) {
                        // If the annotation is not in the loaded data, we need to remove it from the state. However,
                        // rather then removing it, we will set the mark state to resolved. This is to align it better with
                        // how the editor works.
                        updates.push({
                            id: id,
                            markState: (0, $jxPcD.AnnotationMarkStates).RESOLVED
                        });
                        continue;
                    }
                    if (!!loadedAnnotation?.markState && state.annotations[id]?.markState !== loadedAnnotation.markState) {
                        updates.push({
                            id: id,
                            markState: loadedAnnotation.markState
                        });
                        continue;
                    }
                }
                if (updates.length > 0) return {
                    ...state,
                    annotations: updates.reduce((nextAnnotations, update)=>{
                        return {
                            ...nextAnnotations,
                            [update.id]: {
                                ...nextAnnotations[update.id],
                                ...update
                            }
                        };
                    }, state.annotations)
                };
                return state;
            }
        case 'updateAnnotation':
            {
                const current = state.annotations[action.data.id];
                const { id: id, selected: selected, hovered: hovered, markState: markState = current?.markState } = action.data;
                const updates = [];
                // If the annotation is not currently in the state, we need to add it to the state.
                if (!current) updates.push({
                    id: id,
                    markState: markState ?? (0, $jxPcD.AnnotationMarkStates).ACTIVE
                });
                // The goal of the following is to enforce a single selection and a single hover state across all annotations.
                let nextSelectedId = state.currentSelectedAnnotationId;
                if (selected && nextSelectedId !== id) nextSelectedId = id;
                // If the annotation is currently selected and it's being unselected, we need to remove it from the
                // current selected annotation id.
                if (selected === false && nextSelectedId === id) nextSelectedId = undefined;
                let nextHoveredId = state.currentHoveredAnnotationId;
                if (hovered && nextHoveredId !== id) nextHoveredId = id;
                // If the annotation is currently hovered and it's being unhovered, we need to remove it from the
                // current hovered annotation id.
                if (hovered === false && nextHoveredId === id) nextHoveredId = undefined;
                // If the annotations mark state is not the same as the current mark state, we need to update it.
                if (current?.markState !== markState) {
                    updates.push({
                        id: id,
                        markState: markState ?? (0, $jxPcD.AnnotationMarkStates).ACTIVE
                    });
                    // If the annotation is currently selected and it's being resolved, then we need to remove it from the
                    // current selected annotation id also.
                    if (markState === (0, $jxPcD.AnnotationMarkStates).RESOLVED && nextSelectedId === id) nextSelectedId = undefined;
                }
                if (updates.length > 0 || nextSelectedId !== state.currentSelectedAnnotationId || nextHoveredId !== state.currentHoveredAnnotationId) return {
                    ...state,
                    currentSelectedAnnotationId: nextSelectedId,
                    currentHoveredAnnotationId: nextHoveredId,
                    annotations: updates.reduce((nextAnnotations, update)=>{
                        return {
                            ...nextAnnotations,
                            [update.id]: {
                                ...nextAnnotations[update.id],
                                ...update
                            }
                        };
                    }, state.annotations)
                };
                return state;
            }
        case 'resetSelectedAnnotation':
            if (state.currentSelectedAnnotationId !== undefined) return {
                ...state,
                currentSelectedAnnotationId: undefined,
                currentSelectedMarkRef: undefined
            };
            return state;
        case 'resetHoveredAnnotation':
            if (state.currentHoveredAnnotationId !== undefined) return {
                ...state,
                currentHoveredAnnotationId: undefined
            };
            return state;
        case 'setDrafting':
            if (state.isDrafting !== action.data.isDrafting || state.draftId !== action.data.draftId || state.draftActionResult !== action.data.draftActionResult) // XXX: When a draft is open the current selected annotation should no longer be selected. We need
            // to decide what is better UX,
            // 1 - do we want to deselct the selected annotation on draft open, if so then when draft is closed the s
            // selected annotation will not come back
            // 2 - do we want to still allow the selected annotation to be selected when draft is open, however the underlying
            // mark style just shows the annotation as not selected when a draft is active. Then when a draft closes
            // we can reopen the previous selected annotation.
            return {
                ...state,
                isDrafting: action.data.isDrafting,
                draftId: action.data.draftId,
                draftActionResult: action.data.draftActionResult
            };
            return state;
        case 'setDraftMarkRef':
            if (state.draftMarkRef !== action.data.draftMarkRef) return {
                ...state,
                draftMarkRef: action.data.draftMarkRef
            };
            return state;
        case 'setSelectedMarkRef':
            if (state.currentSelectedMarkRef !== action.data.markRef) return {
                ...state,
                currentSelectedMarkRef: action.data.markRef
            };
            return state;
    }
}
const $145edea21db52b9d$export$f21fb05766361bb3 = ({ children: children, annotationManager: annotationManager, updateSubscriber: updateSubscriber })=>{
    const [state, dispatch] = (0, $eJOHy.useReducer)($145edea21db52b9d$var$reducer, $145edea21db52b9d$var$initState);
    const actionContext = (0, $eJOHy.useContext)((0, $4Z9bh.RendererContext));
    (0, $eJOHy.useEffect)(()=>{
        const getDraft = ()=>{
            if (!state.isDrafting || !state.draftActionResult || !state.draftMarkRef || !state.draftId) return {
                success: false,
                reason: 'draft-not-started'
            };
            return {
                success: true,
                inlineNodeTypes: state.draftActionResult.inlineNodeTypes ?? [],
                targetElement: state.draftMarkRef,
                actionResult: {
                    step: state.draftActionResult.step,
                    doc: state.draftActionResult.doc,
                    inlineNodeTypes: state.draftActionResult.inlineNodeTypes,
                    targetNodeType: state.draftActionResult.targetNodeType,
                    originalSelection: state.draftActionResult.originalSelection,
                    numMatches: state.draftActionResult.numMatches,
                    matchIndex: state.draftActionResult.matchIndex,
                    pos: state.draftActionResult.pos
                }
            };
        };
        annotationManager?.hook('getDraft', getDraft);
        return ()=>{
            annotationManager?.unhook('getDraft', getDraft);
        };
    }, [
        annotationManager,
        state.draftId,
        state.isDrafting,
        state.draftMarkRef,
        state.draftActionResult
    ]);
    // We need to watch for the draft mark element to exist, so we can inform any listeners that the draft has been started
    // and give them a reference to the element
    (0, $eJOHy.useEffect)(()=>{
        if (state.isDrafting && state.draftId && state.draftMarkRef && state.draftActionResult) annotationManager?.emit({
            name: 'draftAnnotationStarted',
            data: {
                inlineNodeTypes: state.draftActionResult.inlineNodeTypes ?? [],
                targetElement: state.draftMarkRef,
                actionResult: {
                    step: state.draftActionResult.step,
                    doc: state.draftActionResult.doc,
                    inlineNodeTypes: state.draftActionResult.inlineNodeTypes,
                    targetNodeType: state.draftActionResult.targetNodeType,
                    originalSelection: state.draftActionResult.originalSelection,
                    numMatches: state.draftActionResult.numMatches,
                    matchIndex: state.draftActionResult.matchIndex,
                    pos: state.draftActionResult.pos
                }
            }
        });
    }, [
        annotationManager,
        state.draftId,
        state.isDrafting,
        state.draftMarkRef,
        state.draftActionResult
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const setIsAnnotationSelected = (id, isSelected)=>{
            if (state.isDrafting) return {
                success: false,
                reason: 'draft-in-progress'
            };
            if (!state.annotations?.[id]) return {
                success: false,
                reason: 'id-not-valid'
            };
            // the annotation is currently not selected and is being selected
            if (id !== state.currentSelectedAnnotationId && isSelected) {
                dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: id,
                        selected: true
                    }
                });
                dispatch({
                    type: 'setSelectedMarkRef',
                    data: {
                        markRef: document.getElementById(id) || undefined
                    }
                });
            } else if (id === state.currentSelectedAnnotationId && !isSelected) dispatch({
                type: 'resetSelectedAnnotation'
            });
            return {
                success: true,
                isSelected: isSelected
            };
        };
        annotationManager?.hook('setIsAnnotationSelected', setIsAnnotationSelected);
        return ()=>{
            annotationManager?.unhook('setIsAnnotationSelected', setIsAnnotationSelected);
        };
    }, [
        annotationManager,
        state.isDrafting,
        state.annotations,
        state.currentSelectedAnnotationId,
        state.currentSelectedMarkRef
    ]);
    const prevSelectedAnnotationId = (0, $eJOHy.useRef)(undefined);
    (0, $eJOHy.useEffect)(()=>{
        if (prevSelectedAnnotationId.current) annotationManager?.emit({
            name: 'annotationSelectionChanged',
            data: {
                annotationId: prevSelectedAnnotationId.current,
                isSelected: false,
                inlineNodeTypes: []
            }
        });
        prevSelectedAnnotationId.current = state.currentSelectedAnnotationId;
    }, [
        state.currentSelectedAnnotationId,
        annotationManager
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (state.currentSelectedAnnotationId && state.currentSelectedMarkRef && state.currentSelectedMarkRef.id === state.currentSelectedAnnotationId) annotationManager?.emit({
            name: 'annotationSelectionChanged',
            data: {
                annotationId: state.currentSelectedAnnotationId,
                isSelected: true,
                inlineNodeTypes: []
            }
        });
    }, [
        annotationManager,
        state.currentSelectedAnnotationId,
        state.currentSelectedMarkRef
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const setIsAnnotationHovered = (id, isHovered)=>{
            if (!state.annotations?.[id]) return {
                success: false,
                reason: 'id-not-valid'
            };
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: id,
                    hovered: isHovered
                }
            });
            return {
                success: true,
                isHovered: isHovered
            };
        };
        annotationManager?.hook('setIsAnnotationHovered', setIsAnnotationHovered);
        return ()=>{
            annotationManager?.unhook('setIsAnnotationHovered', setIsAnnotationHovered);
        };
    }, [
        annotationManager,
        state.annotations
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const clearAnnotation = (id)=>{
            if (!state.annotations?.[id]) return {
                success: false,
                reason: 'id-not-valid'
            };
            const result = actionContext.deleteAnnotation(id, (0, $jxPcD.AnnotationTypes).INLINE_COMMENT);
            if (!result) return {
                success: false,
                reason: 'clear-failed'
            };
            const { step: step, doc: doc } = result;
            return {
                success: true,
                actionResult: {
                    step: step,
                    doc: doc
                }
            };
        };
        annotationManager?.hook('clearAnnotation', clearAnnotation);
        return ()=>{
            annotationManager?.unhook('clearAnnotation', clearAnnotation);
        };
    }, [
        annotationManager,
        state.annotations,
        actionContext
    ]);
    /**
	 * This is a temporary solution to ensure that the annotation manager state is in sync with the
	 * old updateSubscriber. The updateSubscriber will eventually be deprecated and the state will be managed
	 * by the annotation manager itself.
	 */ (0, $eJOHy.useEffect)(()=>{
        const onSetAnnotationState = (payload)=>{
            if (!payload) return;
            Object.values(payload).forEach((annotation)=>{
                if (annotation.id && annotation.annotationType === (0, $jxPcD.AnnotationTypes).INLINE_COMMENT) dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: annotation.id,
                        markState: annotation.state ?? undefined
                    }
                });
            });
        };
        const onAnnotationSelected = (payload)=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: payload.annotationId,
                    selected: true
                }
            });
        };
        const onAnnotationHovered = (payload)=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: payload.annotationId,
                    hovered: true
                }
            });
        };
        const onAnnotationSelectedRemoved = ()=>{
            dispatch({
                type: 'resetSelectedAnnotation'
            });
        };
        const onAnnotationHoveredRemoved = ()=>{
            dispatch({
                type: 'resetHoveredAnnotation'
            });
        };
        const onAnnotationClick = ({ annotationIds: annotationIds, eventTarget: eventTarget, eventTargetType: eventTargetType, viewMethod: viewMethod })=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: annotationIds[0],
                    selected: true
                }
            });
            dispatch({
                type: 'setSelectedMarkRef',
                data: {
                    markRef: eventTarget
                }
            });
        };
        const onAnnotationDeselect = ()=>{
            dispatch({
                type: 'resetSelectedAnnotation'
            });
        };
        updateSubscriber?.on((0, $4Fc33.AnnotationUpdateEvent).SET_ANNOTATION_STATE, onSetAnnotationState);
        updateSubscriber?.on((0, $4Fc33.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, onAnnotationSelected);
        updateSubscriber?.on((0, $4Fc33.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, onAnnotationHovered);
        updateSubscriber?.on((0, $4Fc33.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, onAnnotationSelectedRemoved);
        updateSubscriber?.on((0, $4Fc33.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, onAnnotationHoveredRemoved);
        updateSubscriber?.on((0, $4Fc33.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, onAnnotationClick);
        updateSubscriber?.on((0, $4Fc33.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, onAnnotationDeselect);
        return ()=>{
            updateSubscriber?.off((0, $4Fc33.AnnotationUpdateEvent).SET_ANNOTATION_STATE, onSetAnnotationState);
            updateSubscriber?.off((0, $4Fc33.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, onAnnotationSelected);
            updateSubscriber?.off((0, $4Fc33.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, onAnnotationHovered);
            updateSubscriber?.off((0, $4Fc33.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, onAnnotationSelectedRemoved);
            updateSubscriber?.off((0, $4Fc33.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, onAnnotationHoveredRemoved);
            updateSubscriber?.off((0, $4Fc33.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, onAnnotationClick);
            updateSubscriber?.off((0, $4Fc33.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, onAnnotationDeselect);
        };
    }, [
        updateSubscriber
    ]);
    const dispatchData = (0, $eJOHy.useMemo)(()=>({
            annotationManager: annotationManager,
            dispatch: dispatch
        }), [
        annotationManager,
        dispatch
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($145edea21db52b9d$var$AnnotationManagerStateContext.Provider, {
        value: state,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($145edea21db52b9d$var$AnnotationManagerDispatchContext.Provider, {
            value: dispatchData,
            children: children
        })
    });
};
const $145edea21db52b9d$export$654a1fb45487f838 = ()=>{
    return (0, $eJOHy.useContext)($145edea21db52b9d$var$AnnotationManagerStateContext);
};
const $145edea21db52b9d$export$12cbbb89fb7702d0 = ()=>{
    return (0, $eJOHy.useContext)($145edea21db52b9d$var$AnnotationManagerDispatchContext);
};

});
parcelRegister("4Z9bh", function(module, exports) {
$parcel$export(module.exports, "RendererContext", () => $23eeb1bb2885a66b$export$1e9ea4edb6d1bfe6);
$parcel$export(module.exports, "RendererActionsContext", () => $23eeb1bb2885a66b$export$66feffbad722f9d4);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $ftN6c = parcelRequire("ftN6c");

var $3VCQy = parcelRequire("3VCQy");

var $bMFKb = parcelRequire("bMFKb");

var $e6uVp = parcelRequire("e6uVp");
const $23eeb1bb2885a66b$export$1e9ea4edb6d1bfe6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(new (0, $e6uVp.default)());
function $23eeb1bb2885a66b$export$66feffbad722f9d4({ children: children, context: context }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const actions = (0, $eJOHy.useMemo)(()=>new (0, $e6uVp.default)(true), []);
    // Remove this eventually when root cause is assessed
    if ((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.count(children) > 1 && (0, $eGOwo.fg)('confluence_frontend_fix_view_page_slo')) // Send event when we get more than 1 child
    try {
        throw new Error('Too many children');
    } catch (e) {
        const { stack: stack } = e;
        createAnalyticsEvent({
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
            action: 'rendered',
            actionSubject: 'multipleChildren',
            actionSubjectId: 'rendererActionsContext',
            attributes: {
                numChildren: (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.count(children),
                stackTrace: stack
            }
        }).fire((0, $3VCQy.FabricChannel).editor);
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)($23eeb1bb2885a66b$export$1e9ea4edb6d1bfe6.Provider, {
        value: context || actions,
        children: (0, $eGOwo.fg)('confluence_frontend_fix_view_page_slo') ? (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.only(children) : children
    });
}
const $23eeb1bb2885a66b$export$d5fcf151601331bc = $23eeb1bb2885a66b$export$1e9ea4edb6d1bfe6.Consumer;

});
parcelRegister("e6uVp", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ae78d55dc28f79f$export$2e2bcd8739ae039);

var $jxPcD = parcelRequire("jxPcD");

var $7TRmB = parcelRequire("7TRmB");

var $lovmf = parcelRequire("lovmf");

var $3lIcL = parcelRequire("3lIcL");

var $bMFKb = parcelRequire("bMFKb");

var $lzEKq = parcelRequire("lzEKq");

var $eGOwo = parcelRequire("eGOwo");

var $2mfh2 = parcelRequire("2mfh2");

var $jidPs = parcelRequire("jidPs");

var $gKium = parcelRequire("gKium");
class $8ae78d55dc28f79f$export$2e2bcd8739ae039 {
    constructor(initFromContext = false){
        // This is our psuedo feature flag for now
        // This module can only be used when wrapped with
        // the <RendererContext> component for now.
        this.initFromContext = false;
        this.initFromContext = initFromContext;
        this.transformer = new (0, $lovmf.JSONTransformer)();
    }
    //#region private
    _privateRegisterRenderer(ref, doc, schema, onAnalyticsEvent) {
        if (!this.initFromContext) return;
        else if (!this.ref) this.ref = ref;
        else if (this.ref !== ref) throw new Error("Renderer has already been registered! It's not allowed to re-register with another new Renderer instance.");
        this.doc = doc;
        this.schema = schema;
        this.onAnalyticsEvent = onAnalyticsEvent;
    }
    _privateUnregisterRenderer() {
        this.doc = undefined;
        this.ref = undefined;
        this.schema = undefined;
    }
    /**
	 * Validate whether we can create an annotation between two positions
	 */ _privateValidatePositionsForAnnotation(from, to) {
        if (!this.doc || !this.schema) return false;
        const currentSelection = (0, $3lIcL.TextSelection).create(this.doc, from, to);
        if ((0, $7TRmB.isEmptyTextSelectionRenderer)(currentSelection, this.schema)) return false;
        const result = (0, $7TRmB.canApplyAnnotationOnRange)({
            from: from,
            to: to
        }, this.doc, this.schema);
        return result;
    }
    //#endregion
    deleteAnnotation(annotationId, annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const mark = this.schema.marks.annotation.create({
            id: annotationId,
            annotationType: annotationType
        });
        let from;
        let to;
        let nodePos;
        let step;
        this.doc.descendants((node, pos)=>{
            const found = mark.isInSet(node.marks);
            if (found && node.type.name === 'media') nodePos = pos;
            if (found && !from) {
                // Set both here incase it only spans one node.
                from = pos;
                to = pos + node.nodeSize;
            } else if (found && from) // If the mark spans multiple nodes,
            // we'll keep setting the end until no longer found.
            to = pos + node.nodeSize;
            return true;
        });
        if (nodePos !== undefined) step = new (0, $lzEKq.RemoveNodeMarkStep)(nodePos, mark);
        else {
            if (from === undefined || to === undefined) return false;
            step = new (0, $lzEKq.RemoveMarkStep)(from, to, mark);
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (this.onAnalyticsEvent) {
            const payload = {
                action: (0, $bMFKb.ACTION).DELETED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                attributes: {
                    inlineNodeNames: step instanceof (0, $lzEKq.RemoveMarkStep) ? (0, $jidPs.getRendererRangeInlineNodeNames)({
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        pos: {
                            from: from,
                            to: to
                        },
                        actions: this
                    }) : undefined
                }
            };
            this.onAnalyticsEvent(payload);
        }
        if (!failed && doc) return {
            step: step,
            doc: this.transformer.encode(doc)
        };
        return false;
    }
    annotate(range, annotationId, annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const pos = (0, $2mfh2.getPosFromRange)(range);
        if (!pos) return false;
        const { from: from, to: to } = pos;
        const validPositions = this._privateValidatePositionsForAnnotation(from, to);
        if (!validPositions) return false;
        return this.applyAnnotation(pos, {
            annotationId: annotationId,
            annotationType: (0, $jxPcD.AnnotationTypes).INLINE_COMMENT
        });
    }
    isValidAnnotationRange(range) {
        if (!range) return false;
        if ((0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes')) {
            if (this.isRendererWithinRange(range)) return false;
        }
        const pos = (0, $2mfh2.getPosFromRange)(range);
        if (!pos || !this.doc) return false;
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    isRangeAnnotatable(range) {
        try {
            if (!range) return false;
            const { startContainer: startContainer, endContainer: endContainer } = range;
            if (startContainer.parentElement?.closest('.ak-renderer-extension') || endContainer.parentElement?.closest('.ak-renderer-extension')) return false;
            return this.isValidAnnotationRange(range);
        } catch  {
            // isValidAnnotationRange can fail when called inside nested renderers.
            // while isRendererWithinRange guards against this to some degree -- the classnames
            // are controlled by product -- and we don't have platform guarantees on them.
            //
            // Currently there is a mix of logic across the platform and confluence on determining
            // positions that are annotatable. This is a defensive check to ensure we don't throw an error
            // in cases where the range is not valid.
            return false;
        }
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
	 * This is replaced by `isRangeAnnotatable`.
	 *
	 * @deprecated
	 **/ isRendererWithinRange(range) {
        const { startContainer: startContainer, endContainer: endContainer } = range;
        if (startContainer.parentElement && startContainer.parentElement.closest('.ak-renderer-extension') || endContainer.parentElement && endContainer.parentElement.closest('.ak-renderer-extension')) return true;
        return false;
    }
    isValidAnnotationPosition(pos) {
        if (!pos || !this.doc) return false;
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    /**
	 * Note: False indicates that the selection not able to be calculated.
	 */ getPositionFromRange(range) {
        if (!this.doc || !this.schema || !range) return false;
        return (0, $2mfh2.getPosFromRange)(range);
    }
    getAnnotationMarks() {
        const { schema: schema, doc: doc } = this;
        if (!schema || !doc) return [];
        const { marks: { annotation: annotationMarkType } } = schema;
        if (!annotationMarkType) return [];
        const marks = [];
        doc.descendants((node)=>{
            const annotationsMark = node.marks.filter((m)=>m.type === annotationMarkType);
            if (!annotationsMark || !annotationsMark.length) return true;
            marks.push(...annotationsMark);
            return false;
        });
        const uniqueMarks = new Map();
        marks.forEach((m)=>{
            uniqueMarks.set(m.attrs.id, m);
        });
        return Array.from(uniqueMarks.values());
    }
    getAnnotationsByPosition(range) {
        if (!this.doc || !this.schema) return [];
        const pos = (0, $2mfh2.getPosFromRange)(range);
        if (!pos || !this.doc) return [];
        return (0, $7TRmB.getAnnotationIdsFromRange)(pos, this.doc, this.schema);
    }
    applyAnnotation(pos, annotation) {
        if (!this.doc || !pos || !this.schema) return false;
        const { from: from, to: to } = pos;
        const { annotationId: annotationId, annotationType: annotationType } = annotation;
        let step;
        let targetNodeType;
        // As part of fix for RAP, `from` points to the position right before media node
        // hence, -1 is not needed
        const beforeNodePos = from;
        const possibleNode = this.doc.nodeAt(beforeNodePos);
        if (possibleNode?.type.name === 'media') {
            targetNodeType = 'media';
            step = new (0, $lzEKq.AddNodeMarkStep)(beforeNodePos, this.schema.marks.annotation.create({
                id: annotationId,
                type: annotationType
            }));
        } else {
            const resolvedNode = this.doc.resolve(from).node();
            // annotation is technically on text, but the context is caption
            targetNodeType = resolvedNode.type.name === 'caption' ? 'caption' : 'text';
            step = (0, $2mfh2.createAnnotationStep)(from, to, {
                annotationId: annotationId,
                annotationType: annotationType,
                schema: this.schema
            });
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (failed || !doc) return false;
        const originalSelection = doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $gKium.getIndexMatch)(this.doc, this.schema, originalSelection, from);
        return {
            step: step,
            doc: this.transformer.encode(doc),
            inlineNodeTypes: (0, $jidPs.getRendererRangeInlineNodeNames)({
                actions: this,
                pos: {
                    from: from,
                    to: to
                }
            }),
            ancestorNodeTypes: (0, $jidPs.getRendererRangeAncestorNodeNames)({
                actions: this,
                pos: {
                    from: from,
                    to: to
                }
            }),
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos,
            targetNodeType: targetNodeType
        };
    }
    generateAnnotationIndexMatch(pos) {
        if (!this.doc || !pos || !this.schema) return false;
        const { from: from, to: to } = pos;
        const originalSelection = this.doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $gKium.getIndexMatch)(this.doc, this.schema, originalSelection, from);
        return {
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos
        };
    }
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Do not forget to remove `undefined` when the `editor_inline_comments_on_inline_nodes` is removed.
    getInlineNodeTypes(annotationId) {
        if (!this.doc || !this.schema) return [];
        return (0, $7TRmB.getAnnotationInlineNodeTypes)({
            doc: this.doc,
            schema: this.schema
        }, annotationId);
    }
}

});
parcelRegister("7TRmB", function(module, exports) {
$parcel$export(module.exports, "canApplyAnnotationOnRange", () => $1a8b7be3131e0019$export$77ddf8216f9eb904);
$parcel$export(module.exports, "getAnnotationIdsFromRange", () => $1a8b7be3131e0019$export$badbcc229c848aec);
$parcel$export(module.exports, "hasAnnotationMark", () => $1a8b7be3131e0019$export$5fe1412b20386053);
$parcel$export(module.exports, "containsAnyAnnotations", () => $1a8b7be3131e0019$export$1976770b876b2728);
$parcel$export(module.exports, "getRangeInlineNodeNames", () => $1a8b7be3131e0019$export$35054451202ed5d9);
$parcel$export(module.exports, "getRangeAncestorNodeNames", () => $1a8b7be3131e0019$export$2a160f09551a3adc);
$parcel$export(module.exports, "getAnnotationInlineNodeTypes", () => $1a8b7be3131e0019$export$8261bc1f662f3f6e);
$parcel$export(module.exports, "getAnnotationMarksForPos", () => $1a8b7be3131e0019$export$bb1945a828f2864b);
$parcel$export(module.exports, "isEmptyTextSelection", () => $1a8b7be3131e0019$export$2efbc6d84ea0fbec);
$parcel$export(module.exports, "isEmptyTextSelectionRenderer", () => $1a8b7be3131e0019$export$a35880e7ecdcf47b);

var $jxPcD = parcelRequire("jxPcD");

var $eGOwo = parcelRequire("eGOwo");
const $1a8b7be3131e0019$export$77ddf8216f9eb904 = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    if (isNaN(from + to) || to - from <= 0 || to < 0 || from < 0) return false;
    let foundInvalid = false;
    doc.nodesBetween(rangeSelection.from, rangeSelection.to, (node, _pos, parent)=>{
        // Special exception for hardBreak nodes
        if (schema.nodes.hardBreak === node.type) return false;
        // For block elements or text nodes, we want to check
        // if annotations are allowed inside this tree
        // or if we're leaf and not text
        if ((0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes')) {
            const isAllowedInlineNode = [
                'emoji',
                'status',
                'date',
                'mention',
                'inlineCard'
            ].includes(node.type.name);
            if (node.isInline && !node.isText && !isAllowedInlineNode || node.isLeaf && !node.isText && !isAllowedInlineNode || node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
                foundInvalid = true;
                return false;
            }
        } else if (node.isInline && !node.isText || node.isLeaf && !node.isText || node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
            foundInvalid = true;
            return false;
        }
        return true;
    });
    return !foundInvalid;
};
const $1a8b7be3131e0019$export$badbcc229c848aec = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    const annotations = new Set();
    doc.nodesBetween(from, to, (node)=>{
        if (!node.marks) return true;
        node.marks.forEach((mark)=>{
            if (mark.type === schema.marks.annotation && mark.attrs) annotations.add(mark.attrs.id);
        });
        return true;
    });
    return Array.from(annotations);
};
function $1a8b7be3131e0019$export$5fe1412b20386053(node, state) {
    const { schema: { marks: { annotation: annotationMark } } } = state;
    return !!(annotationMark && node && node.marks.length && annotationMark.isInSet(node.marks));
}
function $1a8b7be3131e0019$export$1976770b876b2728(slice, state) {
    if (!slice.content.size) return false;
    let hasAnnotation = false;
    slice.content.forEach((node)=>{
        hasAnnotation = hasAnnotation || $1a8b7be3131e0019$export$5fe1412b20386053(node, state);
        // return early if annotation found already
        if (hasAnnotation) return true;
        // check annotations in descendants
        node.descendants((node)=>{
            if ($1a8b7be3131e0019$export$5fe1412b20386053(node, state)) {
                hasAnnotation = true;
                return false;
            }
            return true;
        });
    });
    return hasAnnotation;
}
function $1a8b7be3131e0019$export$35054451202ed5d9({ doc: doc, pos: pos }) {
    if (!(0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const nodeNames = new Set();
    try {
        doc.nodesBetween(pos.from, pos.to, (node)=>{
            if (node.isInline) nodeNames.add(node.type.name);
        });
        // We sort the list alphabetically to make human consumption of the list easier (in tools like the analytics extension)
        const sortedNames = [
            ...nodeNames
        ].sort();
        return sortedNames;
    } catch  {
        // Some callers have existing gaps where the positions are not valid,
        // and so when called in the current document can throw an error if out of range.
        //
        // This is a defensive check to ensure we don't throw an error in those cases.
        return undefined;
    }
}
function $1a8b7be3131e0019$export$2a160f09551a3adc({ doc: doc, pos: pos }) {
    if (!(0, $eGOwo.fg)('cc_comments_log_draft_annotation_ancestor_nodes')) return undefined;
    const nodeNames = new Set();
    try {
        // For a range, we can get ancestors at both from and to positions
        // or just use the from position if you want ancestors at the start
        const resolvedFromPos = doc.resolve(pos.from);
        const resolvedToPos = doc.resolve(pos.to);
        // Collect ancestors at the 'from' position
        for(let depth = resolvedFromPos.depth; depth > 0; depth--){
            const ancestorNode = resolvedFromPos.node(depth);
            nodeNames.add(ancestorNode.type.name);
        }
        // Use nodesBetween to collect parent types without additional resolve() calls
        // This isn't as precise as calling resolve() on each parent, but it's a lot faster
        // and should hopefully provide a good approximation of the ancestor nodes
        const seenParents = new Set();
        doc.nodesBetween(pos.from, pos.to, (node, nodePos, parent)=>{
            // Collect parent chain using the parent parameter
            const currentParent = parent;
            if (!!currentParent && !seenParents.has(currentParent)) {
                seenParents.add(currentParent);
                nodeNames.add(currentParent.type.name);
            // Note: We can't easily get the parent's parent from this context
            // without additional resolve calls, so this approach has limitations
            }
            return true;
        });
        // Optionally collect ancestors at the 'to' position if different
        // This ensures we capture all ancestor contexts across the range
        if (pos.from !== pos.to) for(let depth = resolvedToPos.depth; depth > 0; depth--){
            const ancestorNode = resolvedToPos.node(depth);
            nodeNames.add(ancestorNode.type.name);
        }
        return [
            ...nodeNames
        ];
    } catch  {
        // Some callers have existing gaps where the positions are not valid,
        // and so when called in the current document can throw an error if out of range.
        //
        // This is a defensive check to ensure we don't throw an error in those cases.
        return undefined;
    }
}
function $1a8b7be3131e0019$export$8261bc1f662f3f6e(state, annotationId) {
    if (!(0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const mark = state.schema.marks.annotation.create({
        id: annotationId,
        annotationType: (0, $jxPcD.AnnotationTypes).INLINE_COMMENT
    });
    const inlineNodeNames = new Set();
    state.doc.descendants((node, pos)=>{
        if (mark.isInSet(node.marks)) inlineNodeNames.add(node.type.name);
        return true;
    });
    // This sorting is done to make human consumption easier (ie. in dev tools, test snapshots, analytics events, ...)
    return [
        ...inlineNodeNames
    ].sort();
}
function $1a8b7be3131e0019$export$bb1945a828f2864b(pos) {
    if (!(0, $eGOwo.fg)('editor_inline_comments_paste_insert_nodes')) return undefined;
    const annotationMarks = pos.marks().filter((mark)=>mark.type === pos.doc.type.schema.marks.annotation);
    return annotationMarks;
}
function $1a8b7be3131e0019$export$2efbc6d84ea0fbec(selection, schema) {
    const { text: text, paragraph: paragraph } = schema.nodes;
    let hasContent = false;
    selection.content().content.descendants((node)=>{
        // for empty paragraph - consider empty (nothing to comment on)
        if (node.type === paragraph && !node.content.size) return false;
        // for not a text or nonempty text - consider nonempty (can comment if the node is supported for annotations)
        if (node.type !== text || !node.textContent) hasContent = true;
        return !hasContent;
    });
    return !hasContent;
}
function $1a8b7be3131e0019$export$a35880e7ecdcf47b(selection, schema) {
    const { text: text, paragraph: paragraph } = schema.nodes;
    let hasContent = false;
    selection.content().content.descendants((node)=>{
        // for empty paragraph - consider empty (nothing to comment on)
        if (node.type === paragraph && !node.content.size) return false;
        // for inline elements - consider nonempty
        if (node.type !== text && node.type.isInline) hasContent = true;
        // for nonempty text - consider nonempty (can comment if the node is supported for annotations)
        if (node.type === text && !!node.textContent) hasContent = true;
        // for other non-text nodes - continue descending
        return !hasContent;
    });
    return !hasContent;
}

});

parcelRegister("lovmf", function(module, exports) {
$parcel$export(module.exports, "SchemaStage", () => $452aa29341178512$export$933e6445c497ffd5);
$parcel$export(module.exports, "nodeToJSON", () => $452aa29341178512$export$3a858d3babd60825);
$parcel$export(module.exports, "JSONTransformer", () => $452aa29341178512$export$98cb1d9308d0944d);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $cSmYj = parcelRequire("cSmYj");

var $02BNy = parcelRequire("02BNy");
var $dHJym = parcelRequire("dHJym");
var $eSKW9 = parcelRequire("eSKW9");
var $6Ymtk = parcelRequire("6Ymtk");
var $h9kgv = parcelRequire("h9kgv");
var $8Mfla = parcelRequire("8Mfla");
var $bTlUc = parcelRequire("bTlUc");
var $7axvl = parcelRequire("7axvl");
var $e6HpD = parcelRequire("e6HpD");

var $8DB98 = parcelRequire("8DB98");

var $5RXjG = parcelRequire("5RXjG");

var $lGx2C = parcelRequire("lGx2C");
var $452aa29341178512$export$933e6445c497ffd5 = /*#__PURE__*/ function(SchemaStage) {
    SchemaStage["FINAL"] = "final";
    SchemaStage["STAGE_0"] = "stage0";
    return SchemaStage;
}({});
const $452aa29341178512$var$isType = (type)=>(node)=>node.type.name === type;
// Create a Set of node types that should have empty attrs removed
const $452aa29341178512$var$NODES_WITH_EMPTY_ATTRS_REMOVAL = new Set([
    'paragraph',
    'layoutSection',
    'blockquote',
    'nestedExpand',
    'bulletList',
    'listItem',
    'orderedList',
    'rule',
    'caption',
    'tableRow',
    'media',
    'mediaSingle',
    'mediaInline'
]);
const $452aa29341178512$var$isCodeBlock = $452aa29341178512$var$isType('codeBlock');
const $452aa29341178512$var$isMediaNode = $452aa29341178512$var$isType('media');
const $452aa29341178512$var$isMediaInline = $452aa29341178512$var$isType('mediaInline');
const $452aa29341178512$var$isMediaSingleNode = $452aa29341178512$var$isType('mediaSingle');
const $452aa29341178512$var$isMentionNode = $452aa29341178512$var$isType('mention');
const $452aa29341178512$var$isParagraph = $452aa29341178512$var$isType('paragraph');
const $452aa29341178512$var$isHeading = $452aa29341178512$var$isType('heading');
const $452aa29341178512$var$isTable = $452aa29341178512$var$isType('table');
const $452aa29341178512$var$isTableCell = $452aa29341178512$var$isType('tableCell');
const $452aa29341178512$var$isTableHeader = $452aa29341178512$var$isType('tableHeader');
const $452aa29341178512$var$isLinkMark = $452aa29341178512$var$isType('link');
const $452aa29341178512$var$isUnsupportedMark = $452aa29341178512$var$isType('unsupportedMark');
const $452aa29341178512$var$isUnsupportedNodeAttributeMark = $452aa29341178512$var$isType('unsupportedNodeAttribute');
const $452aa29341178512$var$isExpand = $452aa29341178512$var$isType('expand');
const $452aa29341178512$var$isNestedExpand = $452aa29341178512$var$isType('nestedExpand');
const $452aa29341178512$var$isUnsupportedNode = (node)=>$452aa29341178512$var$isType('unsupportedBlock')(node) || $452aa29341178512$var$isType('unsupportedInline')(node);
const $452aa29341178512$var$isDataConsumer = $452aa29341178512$var$isType('dataConsumer');
const $452aa29341178512$var$isFragmentMark = $452aa29341178512$var$isType('fragment');
const $452aa29341178512$var$isHardBreak = $452aa29341178512$var$isType('hardBreak');
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $452aa29341178512$var$filterNull = (subject)=>{
    let output = {
        ...subject
    };
    // eslint-disable-next-line guard-for-in
    for(const key in output){
        const current = output[key];
        if (current === null) {
            const { [key]: unusedKey, ...filteredObj } = output;
            output = filteredObj;
        } else if (typeof current === 'object' && !Array.isArray(current)) output[key] = $452aa29341178512$var$filterNull(current);
    }
    return output;
};
const $452aa29341178512$var$createDocFromContent = (content)=>{
    return {
        version: 1,
        type: 'doc',
        content: content || []
    };
};
const $452aa29341178512$var$emptyDoc = $452aa29341178512$var$createDocFromContent([
    {
        type: 'paragraph',
        content: []
    }
]);
/**
 * Transforms a Prosemirror node into a JSON representation. Compared with
 * native Prosemirror JSON, this representation ensures we have valid ADF attrs.
 *
 * @param node The Prosemirror node to transform.
 * @param mentionMap A map of mention IDs to their display names.
 * @returns The JSON representation of the node.
 */ const $452aa29341178512$export$3a858d3babd60825 = (node, mentionMap)=>{
    const obj = {
        type: node.type.name
    };
    if ($452aa29341178512$var$isUnsupportedNode(node)) return node.attrs.originalValue;
    else if ($452aa29341178512$var$isMediaNode(node)) obj.attrs = (0, $bTlUc.toJSON)(node).attrs;
    else if ($452aa29341178512$var$isMediaSingleNode(node)) obj.attrs = (0, $8Mfla.toJSON)(node).attrs;
    else if ($452aa29341178512$var$isMediaInline(node)) obj.attrs = (0, $bTlUc.toJSON)(node).attrs;
    else if ($452aa29341178512$var$isMentionNode(node)) obj.attrs = (0, $7axvl.toJSON)(node).attrs;
    else if ($452aa29341178512$var$isCodeBlock(node)) obj.attrs = (0, $02BNy.toJSON)(node).attrs;
    else if ($452aa29341178512$var$isTable(node)) obj.attrs = (0, $e6HpD.tableToJSON)(node).attrs;
    else if ($452aa29341178512$var$isTableCell(node)) obj.attrs = (0, $e6HpD.toJSONTableCell)(node).attrs;
    else if ($452aa29341178512$var$isTableHeader(node)) obj.attrs = (0, $e6HpD.toJSONTableHeader)(node).attrs;
    else if ($452aa29341178512$var$isExpand(node) || $452aa29341178512$var$isNestedExpand(node)) obj.attrs = (0, $eSKW9.toJSON)(node).attrs;
    else if (node.attrs && Object.keys(node.attrs).length) obj.attrs = node.attrs;
    if (obj.attrs) obj.attrs = $452aa29341178512$var$filterNull(obj.attrs);
    if ($452aa29341178512$var$isMentionNode(node) && mentionMap) {
        // If the mentionMap exists and has a name defined then we should use it and prepend @ to the begining of it.
        const name = !!mentionMap?.[node.attrs.id] ? `@${mentionMap[node.attrs.id]}` : '';
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const text = obj.attrs?.text ?? '';
        obj.attrs = {
            ...obj.attrs,
            // If an explicit text value is set on the mention then that should take priority over the mentionMap value.
            text: !!text ? text : name
        };
    }
    if ($452aa29341178512$var$NODES_WITH_EMPTY_ATTRS_REMOVAL.has(node.type.name) && obj.attrs && !Object.keys(obj.attrs).length || $452aa29341178512$var$isHardBreak(node)) delete obj.attrs;
    if (node.isText) obj.text = node.textContent;
    else node.content.forEach((child)=>{
        obj.content = obj.content || [];
        obj.content.push($452aa29341178512$export$3a858d3babd60825(child, mentionMap));
    });
    if ($452aa29341178512$var$isParagraph(node) || $452aa29341178512$var$isHeading(node)) obj.content = obj.content || [];
    if (node.marks.length) {
        // Run any custom mark serialisers
        const parsedMarks = node.marks.map((mark)=>{
            if ($452aa29341178512$var$isUnsupportedMark(mark)) return $452aa29341178512$var$canOverrideMark(mark, node.marks) ? null : mark.attrs.originalValue;
            else if ($452aa29341178512$var$isUnsupportedNodeAttributeMark(mark)) return null;
            else if ($452aa29341178512$var$isLinkMark(mark)) return (0, $h9kgv.toJSON)(mark);
            else if ($452aa29341178512$var$isDataConsumer(mark)) {
                const serialised = (0, $dHJym.toJSON)(mark);
                return !serialised.attrs.sources || serialised.attrs.sources?.length === 0 ? null : serialised;
            } else if ($452aa29341178512$var$isFragmentMark(mark)) {
                const fragmentMark = (0, $6Ymtk.toJSON)(mark);
                if (!fragmentMark.attrs.localId) return null;
                return fragmentMark;
            } else return mark.toJSON();
        }).filter((maybeMark)=>maybeMark !== null);
        // Only set if we have a non-empty array, otherwise explicitly undefine it (as we only run this path if `node.marks.length`)
        obj.marks = parsedMarks?.length > 0 ? parsedMarks : undefined;
        const nodeAttributeMark = node.marks.find($452aa29341178512$var$isUnsupportedNodeAttributeMark);
        if (nodeAttributeMark && nodeAttributeMark.attrs.type.nodeType === obj.type) obj.attrs = {
            ...$452aa29341178512$var$getUnwrappedNodeAttributes(node, nodeAttributeMark, obj)
        };
    }
    return obj;
};
const $452aa29341178512$var$canOverrideMark = (mark, existingMarks)=>{
    if (existingMarks.some((e)=>mark.attrs.originalValue.type === e.type.name)) return (0, $5RXjG.markOverrideRuleFor)(mark.attrs.originalValue.type).canOverrideUnsupportedMark();
    return false;
};
const $452aa29341178512$var$getUnwrappedNodeAttributes = (node, mark, obj)=>{
    const nodeAttributes = node.type.spec.attrs;
    const attributes = {
        ...mark.attrs.unsupported,
        ...obj.attrs
    };
    // Ignored via go/ees005
    // eslint-disable-next-line no-var
    for(var key in obj.attrs)if (obj.attrs.hasOwnProperty(key)) {
        const attribute = nodeAttributes ? nodeAttributes[key] : null;
        if (attribute) {
            if (attribute.default === node.attrs[key] && mark.attrs.unsupported[key]) return {
                ...attributes,
                [key]: mark.attrs.unsupported[key]
            };
        }
    }
    return attributes;
};
class $452aa29341178512$export$98cb1d9308d0944d {
    /**
	 * @param schema The current editor schema
	 * @param mentionMap An optional mapping of user IDs to mention names. This is used by the encoder to substitute empty
	 * mention node.attr.text values with mapped names.
	 */ constructor(schema = (0, $8DB98.defaultSchema), mentionMap){
        this.schema = schema;
        this.mentionMap = mentionMap;
    }
    encode(node, options = {}) {
        const content = [];
        node.content.forEach((child)=>{
            content.push((0, $lGx2C.sanitizeNode)($452aa29341178512$export$3a858d3babd60825(child, this.mentionMap), options));
        });
        if (!content || (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(content, $452aa29341178512$var$emptyDoc.content)) return $452aa29341178512$var$createDocFromContent([]);
        return $452aa29341178512$var$createDocFromContent(content);
    }
    internalParse(content, schema) {
        const doc = schema.nodeFromJSON(content);
        doc.check();
        return doc;
    }
    parse(content, stage) {
        if (content.type !== 'doc') throw new Error('Expected content format to be ADF');
        const schema = !!stage ? (0, $8DB98.getSchemaBasedOnStage)(stage) : this.schema;
        if (!content.content || content.content.length === 0) return this.internalParse($452aa29341178512$var$emptyDoc, schema);
        return this.internalParse(content, schema);
    }
    /**
	 * This method is used to encode a single node
	 */ encodeNode(node) {
        return (0, $lGx2C.sanitizeNode)($452aa29341178512$export$3a858d3babd60825(node, this.mentionMap));
    }
}

});
parcelRegister("5RXjG", function(module, exports) {
$parcel$export(module.exports, "markOverrideRuleFor", () => $dde2fa0263905fa8$export$28e4e3c024cce988);
const $dde2fa0263905fa8$var$defaultAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return true;
    }
};
const $dde2fa0263905fa8$var$defaultDoNotAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return false;
    }
};
const $dde2fa0263905fa8$export$28e4e3c024cce988 = (type)=>{
    switch(type){
        case 'link':
        case 'em':
        case 'strong':
        case 'strike':
        case 'subsup':
        case 'underline':
        case 'code':
        case 'textColor':
        case 'backgroundColor':
        case 'confluenceInlineComment':
        case 'breakout':
        case 'alignment':
        case 'indentation':
        case 'border':
            return $dde2fa0263905fa8$var$defaultAllowOverrideBehaviour;
        default:
            return $dde2fa0263905fa8$var$defaultDoNotAllowOverrideBehaviour;
    }
};

});

parcelRegister("lGx2C", function(module, exports) {
$parcel$export(module.exports, "sanitizeNode", () => $6129054bcfac353f$export$48b382180baf8e88);

var $jF4Mi = parcelRequire("jF4Mi");

var $0mclG = parcelRequire("0mclG");

var $jME2s = parcelRequire("jME2s");
const $6129054bcfac353f$var$hasNestedTable = (tableCellNode)=>tableCellNode.content?.some((node)=>node?.type === 'table');
function $6129054bcfac353f$export$48b382180baf8e88(json, options = {}) {
    const { keepNestedTables: keepNestedTables = false } = options;
    const sanitizedJSON = (0, $0mclG.traverse)(json, {
        text: (node)=>{
            if (!node || !Array.isArray(node.marks)) return node;
            return {
                ...node,
                marks: node.marks.filter((mark)=>mark.type !== 'typeAheadQuery')
            };
        },
        status: (node)=>{
            if (node.attrs && !!node.attrs.text) return (0, $jME2s.removeNonAnnotationMarks)(node);
            return false; // empty status
        },
        caption: (node)=>{
            if (node.content) return node;
            return false; // empty caption
        },
        tableCell: (node)=>{
            if ($6129054bcfac353f$var$hasNestedTable(node)) return keepNestedTables ? node : (0, $jF4Mi.transformNestedTableNodeOutgoingDocument)(node);
            return;
        },
        tableHeader: (node)=>{
            if ($6129054bcfac353f$var$hasNestedTable(node)) return keepNestedTables ? node : (0, $jF4Mi.transformNestedTableNodeOutgoingDocument)(node);
            return;
        },
        emoji: (0, $jME2s.removeNonAnnotationMarks),
        mention: (0, $jME2s.removeNonAnnotationMarks),
        date: (0, $jME2s.removeNonAnnotationMarks),
        hardBreak: (0, $jME2s.removeMarks),
        inlineCard: (0, $jME2s.removeNonAnnotationMarks)
    });
    return sanitizedJSON;
}

});
parcelRegister("jF4Mi", function(module, exports) {
$parcel$export(module.exports, "transformNestedTablesIncomingDocument", () => $7043dab3dcfeb1cc$export$18544d0b5f43e4a1);
$parcel$export(module.exports, "transformNestedTableNodeOutgoingDocument", () => $7043dab3dcfeb1cc$export$8a334a7d9fe120ec);

var $0mclG = parcelRequire("0mclG");

var $8zW2f = parcelRequire("8zW2f");

var $lmGkG = parcelRequire("lmGkG");
const $7043dab3dcfeb1cc$var$NESTED_TABLE_EXTENSION_TYPE = 'com.atlassian.confluence.migration', $7043dab3dcfeb1cc$var$NESTED_TABLE_EXTENSION_KEY = 'nested-table';
const $7043dab3dcfeb1cc$export$f45e7335ec874bfe = (extensionNode)=>extensionNode.attrs?.extensionType === $7043dab3dcfeb1cc$var$NESTED_TABLE_EXTENSION_TYPE && extensionNode.attrs?.extensionKey === $7043dab3dcfeb1cc$var$NESTED_TABLE_EXTENSION_KEY;
const $7043dab3dcfeb1cc$var$transformNestedTableExtension = (nestedTableExtension)=>{
    // No content - drop the extension node
    if (!nestedTableExtension.attrs?.parameters?.adf) return false;
    try {
        const adf = JSON.parse(nestedTableExtension.attrs?.parameters?.adf);
        if (!adf.content || adf.content.length === 0) return false;
        return adf.content[0];
    } catch (e) {
        throw new (0, $lmGkG.NodeNestingTransformError)('Failed to parse nested table content');
    }
};
// TODO: EDITOR-806 - Remove when cleaning feature gate platform_editor_nested_table_extension_comment_fix
function $7043dab3dcfeb1cc$var$isInsideBodiedExtension(parent) {
    if (parent.node === undefined) return false;
    if (parent.node.type === 'bodiedExtension') return true;
    if (parent?.parent?.node) return $7043dab3dcfeb1cc$var$isInsideBodiedExtension(parent.parent);
    return false;
}
const $7043dab3dcfeb1cc$export$18544d0b5f43e4a1 = (adf, // TODO: EDITOR-806 - Remove options when cleaning feature gate platform_editor_nested_table_extension_comment_fix as no longer needed
options = {})=>{
    let isTransformed = false;
    const transformedAdf = (0, $0mclG.traverse)(adf, {
        extension: (node, parent)=>{
            if ($7043dab3dcfeb1cc$export$f45e7335ec874bfe(node)) {
                // TODO: EDITOR-806 - Remove this block when cleaning feature gate platform_editor_nested_table_extension_comment_fix
                // Bodied extensions in renderer use their own nested renderer to render the content.
                // This results in the document being validated/transformed twice, once with untransformed content and again with transformed content.
                // Since the untransformed content is valid ADF (table as extension in table) but the transformed content is not valid ADF, (table in table)
                // we need to skip transforming nested tables inside bodied extensions in renderer on the first pass or else it will fail validation and render an unsupported block.
                if (options.environment === 'renderer' && $7043dab3dcfeb1cc$var$isInsideBodiedExtension(parent) && !options.disableNestedRendererTreatment) return undefined;
                isTransformed = true;
                return $7043dab3dcfeb1cc$var$transformNestedTableExtension(node);
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};
const $7043dab3dcfeb1cc$export$8a334a7d9fe120ec = (tableCellNode)=>{
    try {
        return {
            ...tableCellNode,
            content: tableCellNode.content?.map((childNode)=>{
                // wrap nested table in an extension node
                if (childNode?.type === 'table') return (0, $8zW2f.extension)({
                    extensionType: $7043dab3dcfeb1cc$var$NESTED_TABLE_EXTENSION_TYPE,
                    extensionKey: $7043dab3dcfeb1cc$var$NESTED_TABLE_EXTENSION_KEY,
                    parameters: {
                        adf: JSON.stringify({
                            type: 'doc',
                            version: 1,
                            content: [
                                childNode
                            ]
                        })
                    }
                });
                return childNode;
            })
        };
    } catch (e) {
        throw new (0, $lmGkG.NodeNestingTransformError)('Failed to encode nested table node');
    }
};

});
parcelRegister("0mclG", function(module, exports) {
$parcel$export(module.exports, "traverse", () => $9495d7eb76b80944$export$df3f009e3d155b20);
function $9495d7eb76b80944$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $9495d7eb76b80944$export$df3f009e3d155b20(adf, visitors) {
    if (!$9495d7eb76b80944$export$735cfea22ce30f58(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
    return $9495d7eb76b80944$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $9495d7eb76b80944$var$traverseNode(adfNode, parent, visitors, index, depth) {
    const visitor = visitors[adfNode.type] || visitors['any'];
    let newNode = {
        ...adfNode
    };
    if (visitor) {
        const processedNode = visitor({
            ...newNode
        }, parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
        if (!node) return acc;
        const processedNode = $9495d7eb76b80944$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});

parcelRegister("8zW2f", function(module, exports) {
$parcel$export(module.exports, "extension", () => $5a200accbce47c41$export$1b45514b112dd749);
const $5a200accbce47c41$export$1b45514b112dd749 = (attrs)=>({
        type: 'extension',
        attrs: attrs
    });

});

parcelRegister("lmGkG", function(module, exports) {
$parcel$export(module.exports, "NodeNestingTransformError", () => $e75bb52268bda547$export$3d8e8d2182f13924);
/** NodeNestingTransformError  */ class $e75bb52268bda547$export$3d8e8d2182f13924 extends Error {
    /**
	 * @param message - Error message - Do not use any UGC in this message
	 */ constructor(message){
        super(message);
        this.name = 'NodeNestingTransformError';
    }
}

});


parcelRegister("jME2s", function(module, exports) {
$parcel$export(module.exports, "removeMarks", () => $7ddfde3dbc93f214$export$9bf001d8ef76e497);
$parcel$export(module.exports, "removeNonAnnotationMarks", () => $7ddfde3dbc93f214$export$8cae9126fc577085);
function $7ddfde3dbc93f214$export$9bf001d8ef76e497(node) {
    const newNode = {
        ...node
    };
    delete newNode.marks;
    return newNode;
}
function $7ddfde3dbc93f214$export$8cae9126fc577085(node) {
    const newNode = {
        ...node
    };
    if (node.marks) newNode.marks = node.marks.filter((mark)=>mark.type === 'annotation');
    return newNode;
}

});



parcelRegister("2mfh2", function(module, exports) {
$parcel$export(module.exports, "getPosFromRange", () => $03329e2d8fa98a74$export$243cdddc5b21d8c1);
$parcel$export(module.exports, "createAnnotationStep", () => $03329e2d8fa98a74$export$74899f7e5acb5cd3);

var $eGOwo = parcelRequire("eGOwo");

var $lzEKq = parcelRequire("lzEKq");
function $03329e2d8fa98a74$var$getStartPos(element) {
    return parseInt(element.dataset.rendererStartPos || '-1', 10);
}
const $03329e2d8fa98a74$var$getNodeType = (element)=>element.dataset.nodeType;
function $03329e2d8fa98a74$var$isPositionPointer(element) {
    return $03329e2d8fa98a74$var$getStartPos(element) > -1;
}
function $03329e2d8fa98a74$var$findParent(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $03329e2d8fa98a74$export$e3140dc7d0c35e48(parentElement)) return null;
    if ($03329e2d8fa98a74$var$isPositionPointer(parentElement)) return parentElement;
    return $03329e2d8fa98a74$var$findParent(parentElement);
}
function $03329e2d8fa98a74$var$findMediaParent(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $03329e2d8fa98a74$export$e3140dc7d0c35e48(parentElement)) return null;
    if (parentElement.dataset.nodeType === 'mediaSingle') return parentElement;
    return $03329e2d8fa98a74$var$findMediaParent(parentElement);
}
function $03329e2d8fa98a74$var$findParentBeforePointer(element) {
    const { parentElement: parentElement } = element;
    if ($03329e2d8fa98a74$export$e3140dc7d0c35e48(parentElement) || !parentElement) return null;
    if ($03329e2d8fa98a74$var$isPositionPointer(parentElement)) return element;
    return $03329e2d8fa98a74$var$findParentBeforePointer(parentElement);
}
function $03329e2d8fa98a74$var$isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function $03329e2d8fa98a74$var$isTextNode(node) {
    return node.nodeType === Node.TEXT_NODE;
}
function $03329e2d8fa98a74$var$isHighlightTextNode(node) {
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    return !!node?.dataset?.highlighted;
}
function $03329e2d8fa98a74$var$isNodeInlineMark(node) {
    return $03329e2d8fa98a74$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
}
function $03329e2d8fa98a74$var$isElementInlineMark(element) {
    return !!element && Boolean(element.dataset.rendererMark);
}
function $03329e2d8fa98a74$var$isNodeInlineTextMark(node) {
    if (node === null) return false;
    const isInlineMark = $03329e2d8fa98a74$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
    if (!isInlineMark) return false;
    /**
	 * This checks if the element has any descendents with the data-inline-card
	 * attribute set to 'true'. If it does, we should not consider it as an
	 * inline text mark.
	 **/ if ($03329e2d8fa98a74$var$hasInlineNodeDescendant(node)) return false;
    return true;
}
/**
 * This checks all the descendents of a node and returns true if it reaches
 * a descendant with the data-inline-card attribute set to 'true'.
 */ function $03329e2d8fa98a74$var$hasInlineNodeDescendant(node) {
    if ($03329e2d8fa98a74$var$isElementNode(node)) {
        if ((0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes')) {
            if (node.dataset.annotationInlineNode === 'true') return true;
        } else {
            if (node.dataset.inlineCard === 'true') return true;
        }
        return Array.from(node.childNodes).some($03329e2d8fa98a74$var$hasInlineNodeDescendant);
    }
    return false;
}
function $03329e2d8fa98a74$var$resolveNodePos(node) {
    let resolvedPos = 0;
    let prev = node.previousSibling;
    while(prev){
        if (prev.nodeType === Node.COMMENT_NODE) {
            // Comment nodes should not result in the position being
            // incremented, so we skip them.
            prev = prev.previousSibling;
            continue;
        }
        if (prev && ($03329e2d8fa98a74$var$isTextNode(prev) || $03329e2d8fa98a74$var$isHighlightTextNode(prev))) resolvedPos += (prev.textContent || '').length;
        else if (prev) {
            if ((0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes')) {
                if ($03329e2d8fa98a74$var$isNodeInlineTextMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
                else resolvedPos += 1;
            } else if ($03329e2d8fa98a74$var$isNodeInlineMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
            else resolvedPos += 1;
        }
        prev = prev.previousSibling;
    }
    return resolvedPos;
}
function $03329e2d8fa98a74$export$e3140dc7d0c35e48(element) {
    return !!element && element.classList.contains('ak-renderer-document');
}
function $03329e2d8fa98a74$export$5db587db55468da7(node, offset, findEnd = false) {
    // If the passed node doesn't exist, we should abort
    if (!node) return false;
    if ((0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes')) {
        const startPosAncestor = node.parentElement?.closest('[data-renderer-start-pos');
        const potentialParent = (0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes') ? 'data-annotation-mark' : 'data-inline-card';
        if (startPosAncestor?.hasAttribute(potentialParent)) {
            if (findEnd) return parseInt(startPosAncestor?.getAttribute('data-renderer-start-pos') || '-1', 10) + 1;
            else return parseInt(startPosAncestor?.getAttribute('data-renderer-start-pos') || '-1', 10);
        }
    }
    /**
	 * If anchor node is an element (e.g. after a triple click) the anchorOffset
	 * is the number of child nodes preceding the anchor.
	 * https://developer.mozilla.org/en-US/docs/Web/API/Selection/anchorOffset
	 *
	 * For end pos we calculate the number of characters by stepping through
	 * each of the node's children.
	 */ if (node instanceof HTMLElement && $03329e2d8fa98a74$var$isPositionPointer(node)) {
        if (findEnd) {
            let count = $03329e2d8fa98a74$var$getStartPos(node);
            const children = node.childNodes;
            for(let i = 0; i < offset; i++)count += children[i]?.textContent?.length || 1;
            return count;
        }
        return $03329e2d8fa98a74$var$getStartPos(node) + offset;
    }
    const parent = $03329e2d8fa98a74$var$findParent(node);
    // Similar to above, if we cant find a parent position pointer
    // we should not proceed.
    if (!parent) return false;
    let resolvedPos = $03329e2d8fa98a74$var$getStartPos(parent);
    let current = node;
    if (current.parentElement && current.parentElement !== parent) {
        // Find the parent element that is a direct child of the position pointer
        // the outer most element from our text position.
        const preParentPointer = $03329e2d8fa98a74$var$findParentBeforePointer(current.parentElement);
        // If our range is inside an inline node
        // We need to move our pointers to parent element
        // since we don't want to count text inside inline nodes at all
        if ((0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes')) {
            if (!($03329e2d8fa98a74$var$isNodeInlineTextMark(preParentPointer) || $03329e2d8fa98a74$var$isHighlightTextNode(preParentPointer))) {
                current = current.parentElement;
                offset = 0;
            }
        } else if (!($03329e2d8fa98a74$var$isElementInlineMark(preParentPointer) || $03329e2d8fa98a74$var$isHighlightTextNode(preParentPointer))) {
            current = current.parentElement;
            offset = 0;
        }
        resolvedPos += $03329e2d8fa98a74$var$resolveNodePos(current);
        while(current && current.parentElement !== parent){
            current = current.parentNode;
            if (current) {
                const nodePos = $03329e2d8fa98a74$var$resolveNodePos(current);
                resolvedPos += nodePos;
            }
        }
    } else resolvedPos += $03329e2d8fa98a74$var$resolveNodePos(current);
    return resolvedPos + offset;
}
function $03329e2d8fa98a74$export$243cdddc5b21d8c1(range) {
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
    const possibleMediaOrMediaSingleElement = $03329e2d8fa98a74$var$findParent(startContainer);
    // Video hover targets return media single, not media, thus, the extra check in condition.
    const isMediaOrMediaSingle = possibleMediaOrMediaSingleElement && // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /media|mediaSingle/.test($03329e2d8fa98a74$var$getNodeType(possibleMediaOrMediaSingleElement) || '');
    if (isMediaOrMediaSingle) {
        let pos;
        const mediaSingleElement = $03329e2d8fa98a74$var$getNodeType(possibleMediaOrMediaSingleElement) === 'mediaSingle' ? possibleMediaOrMediaSingleElement : $03329e2d8fa98a74$var$findMediaParent(possibleMediaOrMediaSingleElement);
        if (mediaSingleElement) pos = $03329e2d8fa98a74$var$getStartPos(mediaSingleElement);
        if (pos !== undefined) return {
            from: pos,
            to: pos
        };
    }
    const from = $03329e2d8fa98a74$export$5db587db55468da7(startContainer, startOffset);
    const findEnd = true;
    const to = $03329e2d8fa98a74$export$5db587db55468da7(endContainer, endOffset, findEnd);
    if (from === false || to === false) return false;
    return {
        from: from,
        to: to
    };
}
function $03329e2d8fa98a74$export$74899f7e5acb5cd3(from, to, opts) {
    return new (0, $lzEKq.AddMarkStep)(Math.min(from, to), Math.max(from, to), opts.schema.marks.annotation.create({
        id: opts.annotationId,
        annotationType: opts.annotationType
    }));
}

});

parcelRegister("jidPs", function(module, exports) {
$parcel$export(module.exports, "getRendererRangeInlineNodeNames", () => $87925fa32df8c0bb$export$b0ea72d31617ccea);
$parcel$export(module.exports, "getRendererRangeAncestorNodeNames", () => $87925fa32df8c0bb$export$1726c23d64498b6);

var $7TRmB = parcelRequire("7TRmB");

var $eGOwo = parcelRequire("eGOwo");
function $87925fa32df8c0bb$export$b0ea72d31617ccea({ actions: actions, pos: pos }) {
    if (!(0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const { doc: doc } = actions;
    if (!pos || !doc) return undefined;
    const inlineNodeNames = (0, $7TRmB.getRangeInlineNodeNames)({
        doc: doc,
        pos: pos
    });
    return inlineNodeNames;
}
function $87925fa32df8c0bb$export$1726c23d64498b6({ actions: actions, pos: pos }) {
    if (!(0, $eGOwo.fg)('cc_comments_log_draft_annotation_ancestor_nodes')) return undefined;
    const { doc: doc } = actions;
    if (!pos || !doc) return undefined;
    const ancestorNodeNames = (0, $7TRmB.getRangeAncestorNodeNames)({
        doc: doc,
        pos: pos
    });
    return ancestorNodeNames;
}

});

parcelRegister("gKium", function(module, exports) {
$parcel$export(module.exports, "getIndexMatch", () => $55cdc9eaf22a5d55$export$fb7dab895a0d310e);
function $55cdc9eaf22a5d55$export$fb7dab895a0d310e(doc, schema, selectedText, startIndex) {
    let textContent = '';
    let matchIndex = 0;
    let numMatches = 0;
    let blockNodePos;
    doc.descendants((node, pos)=>{
        const nodeType = node.type;
        const { media: media } = schema.nodes;
        // Mirrors Confluence backend and doesn't construct textContent if it doesn't allow annotations
        // Don't skip media node so that block node can be defined its startIndex in within [nodeStart, nodeEnd]
        if ((node.isText || !nodeType.allowsMarkType(schema.marks.annotation)) && nodeType !== media) // Note: `return true` as a parent disallowing annotations does not mean a child disallows annotations.
        // Eg: panel (invalid) > p (valid)
        return true;
        const nodeStart = pos;
        const nodeEnd = nodeStart + node.nodeSize;
        if (startIndex >= nodeStart && startIndex <= nodeEnd) {
            // if it's a node block, set position to pos to indicate to the backend
            // that it's an annotation on a block node
            if (nodeType === media) blockNodePos = pos;
            // If the start of the annotation selection is within the current node, we scan the document for previous occurrences
            // Find the index by counting all previous instances of the selectedText in the partial textContent
            // Need to scan from start, up to `startIndex` (which includes partial of the current node)
            textContent += doc.textBetween(nodeStart, startIndex - 1);
            matchIndex = $55cdc9eaf22a5d55$export$3c2359e76fc742da(textContent, selectedText);
            // Complete appending of the node
            textContent += doc.textBetween(startIndex, nodeEnd);
        } else textContent += node.textContent;
        return true;
    });
    // Count total number of matches in final text
    numMatches = $55cdc9eaf22a5d55$export$3c2359e76fc742da(textContent, selectedText);
    return {
        numMatches: numMatches,
        matchIndex: matchIndex,
        textContent: textContent,
        blockNodePos: blockNodePos
    };
}
function $55cdc9eaf22a5d55$export$3c2359e76fc742da(searchString, query) {
    if (searchString === '' || query === '') return 0;
    // Escape characters that would trigger as syntax in a regex query before converting to the query
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const reg = new RegExp(query.replace(/(?=[.\\+*?[^\]$(){}\|])/g, '\\'), 'g');
    return (searchString.match(reg) || []).length;
}

});






parcelRegister("2MYsB", function(module, exports) {
$parcel$export(module.exports, "AnnotationsContextWrapper", () => $3225c5b8d7284970$export$787af8a111ff3c03);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eFHDV = parcelRequire("eFHDV");

var $iYQKl = parcelRequire("iYQKl");

var $4jhSu = parcelRequire("4jhSu");
const $3225c5b8d7284970$export$787af8a111ff3c03 = (props)=>{
    const providers = (0, $eJOHy.useContext)((0, $eFHDV.ProvidersContext));
    const { rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent, children: children } = props;
    const inlineCommentProvider = providers && providers.inlineComment;
    const selectionComponent = inlineCommentProvider && inlineCommentProvider.selectionComponent;
    const hoverComponent = inlineCommentProvider && inlineCommentProvider.hoverComponent;
    if (!selectionComponent && !hoverComponent) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            children,
            !!hoverComponent && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iYQKl.RangeValidator), {
                createAnalyticsEvent: createAnalyticsEvent,
                rendererRef: rendererRef,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                component: hoverComponent
            }),
            !!selectionComponent && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4jhSu.SelectionRangeValidator), {
                createAnalyticsEvent: createAnalyticsEvent,
                rendererRef: rendererRef,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                selectionComponent: selectionComponent
            })
        ]
    });
};

});
parcelRegister("iYQKl", function(module, exports) {
$parcel$export(module.exports, "RangeValidator", () => $66f06c5e6ba01ad8$export$6d8376a902cb8aa7);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eCe47 = parcelRequire("eCe47");

var $4Z9bh = parcelRequire("4Z9bh");

var $e2m7L = parcelRequire("e2m7L");

var $8dxEE = parcelRequire("8dxEE");
const $66f06c5e6ba01ad8$export$6d8376a902cb8aa7 = (props)=>{
    const { component: component, rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $eJOHy.useContext)((0, $4Z9bh.RendererContext));
    const { clearHoverRange: clearHoverRange } = (0, $e2m7L.useAnnotationRangeDispatch)();
    const { range: range, type: type } = (0, $e2m7L.useAnnotationRangeState)();
    const { isWithinRange: isWithinRange } = (0, $8dxEE.useAnnotationHoverContext)();
    if (!range || type !== 'hover') return null;
    const documentPosition = actions.getPositionFromRange(range);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eCe47.Mounter), {
        isWithinRange: isWithinRange,
        range: range,
        wrapperDOM: rendererRef,
        component: component,
        onClose: clearHoverRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: true,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        createAnalyticsEvent: createAnalyticsEvent
    });
};
$66f06c5e6ba01ad8$export$6d8376a902cb8aa7.displayName = 'HoverRangeValidator';

});
parcelRegister("eCe47", function(module, exports) {
$parcel$export(module.exports, "Mounter", () => $1f52d6c5534efa56$export$2109cd350bcf6eda);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jxPcD = parcelRequire("jxPcD");

var $fH5Zn = parcelRequire("fH5Zn");

var $bgewf = parcelRequire("bgewf");

var $bMFKb = parcelRequire("bMFKb");

var $4Z9bh = parcelRequire("4Z9bh");

var $e2m7L = parcelRequire("e2m7L");
const $1f52d6c5534efa56$export$2109cd350bcf6eda = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo((props)=>{
    const { component: Component, range: range, isWithinRange: isWithinRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const { promoteHoverToDraft: promoteHoverToDraft, clearHoverDraft: clearHoverDraft } = (0, $e2m7L.useAnnotationRangeDispatch)();
    const { hoverDraftDocumentPosition: hoverDraftDocumentPosition } = (0, $e2m7L.useAnnotationRangeState)();
    const actions = (0, $eJOHy.useContext)((0, $4Z9bh.RendererContext));
    const onCreateCallback = (0, $eJOHy.useCallback)((annotationId)=>{
        const positionToAnnotate = hoverDraftDocumentPosition || documentPosition;
        if (!isAnnotationAllowed || !positionToAnnotate || !applyAnnotation) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $jxPcD.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $bMFKb.ACTION).INSERTED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {},
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK
        }).fire((0, $bgewf.FabricChannel).editor);
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        isAnnotationAllowed,
        documentPosition,
        applyAnnotation,
        createAnalyticsEvent,
        hoverDraftDocumentPosition
    ]);
    const createIndexCallback = (0, $eJOHy.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $eJOHy.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $bMFKb.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    documentPosition: documentPosition,
                    isAnnotationAllowed: isAnnotationAllowed
                },
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK
            }).fire((0, $bgewf.FabricChannel).editor);
            return false;
        }
        promoteHoverToDraft(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = actions.getAnnotationsByPosition(range);
            createAnalyticsEvent({
                action: (0, $bMFKb.ACTION).OPENED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length
                }
            }).fire((0, $bgewf.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $fH5Zn.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        const positionToAnnotate = hoverDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $bMFKb.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    positionToAnnotate: positionToAnnotate,
                    applyAnnotationMissing: !applyAnnotation,
                    annotationId: options.annotationId
                },
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK
            }).fire((0, $bgewf.FabricChannel).editor);
            return false;
        }
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $jxPcD.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        isAnnotationAllowed,
        createAnalyticsEvent,
        applyAnnotation,
        actions,
        range,
        promoteHoverToDraft,
        hoverDraftDocumentPosition
    ]);
    const removeDraftModeCallback = (0, $eJOHy.useCallback)(()=>{
        clearHoverDraft();
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearHoverDraft
    ]);
    const onCloseCallback = (0, $eJOHy.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $bMFKb.ACTION).CLOSED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
            attributes: {}
        }).fire((0, $bgewf.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        range: range,
        isWithinRange: isWithinRange,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: onCloseCallback,
        onCreate: onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: applyDraftModeCallback,
        removeDraftMode: removeDraftModeCallback
    });
});

});
parcelRegister("fH5Zn", function(module, exports) {
$parcel$export(module.exports, "dataAttributes", () => $2de571c1e1a9c251$export$15d6ddc168d35719);
$parcel$export(module.exports, "updateWindowSelectionAroundDraft", () => $2de571c1e1a9c251$export$e14699d956e87e73);
const $2de571c1e1a9c251$export$15d6ddc168d35719 = ({ from: from, to: to })=>{
    return {
        ['data-annotation-draft-mark']: true,
        ['data-draft-start-at']: from,
        ['data-draft-end-at']: to
    };
};
const $2de571c1e1a9c251$var$buildDataAttributesQuery = (pos)=>{
    const a = $2de571c1e1a9c251$export$15d6ddc168d35719(pos);
    return Object.entries(a).map(([k, v])=>`[${k}="${v}"]`).join('');
};
const $2de571c1e1a9c251$export$e14699d956e87e73 = (pos)=>{
    const sel = window.getSelection();
    if (!sel) return false;
    const draftNodes = document.querySelectorAll($2de571c1e1a9c251$var$buildDataAttributesQuery(pos));
    if (!draftNodes || draftNodes.length === 0) return false;
    sel.removeAllRanges();
    const range = document.createRange();
    range.setStart(draftNodes[0], 0);
    range.setEndAfter(draftNodes[draftNodes.length - 1]);
    sel.addRange(range);
    return true;
};

});

parcelRegister("e2m7L", function(module, exports) {
$parcel$export(module.exports, "AnnotationRangeProvider", () => $cf414537940f7a80$export$30384a6aedd19fee);
$parcel$export(module.exports, "useAnnotationRangeState", () => $cf414537940f7a80$export$e07ee6d6cc95d9a0);
$parcel$export(module.exports, "useAnnotationRangeDispatch", () => $cf414537940f7a80$export$708fc397e2b6f08d);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $cf414537940f7a80$var$initialState = {
    type: null,
    selectionRange: null,
    hoverRange: null,
    selectionDraftRange: null,
    hoverDraftRange: null,
    selectionDraftDocumentPosition: null,
    hoverDraftDocumentPosition: null
};
function $cf414537940f7a80$var$reducer(state, action) {
    switch(action.type){
        case 'clearSelection':
            if (state.selectionRange !== null) return {
                ...state,
                selectionRange: null,
                type: state.type === 'selection' ? null : state.type
            };
            return state;
        case 'clearHover':
            if (state.hoverRange !== null) return {
                ...state,
                hoverRange: null,
                type: state.type === 'hover' ? null : state.type
            };
            return state;
        case 'setSelection':
            if (state.selectionRange !== action.range) return {
                ...state,
                selectionRange: action.range,
                type: 'selection'
            };
            return state;
        case 'setHover':
            if (state.hoverRange !== action.range) return {
                ...state,
                hoverRange: action.range,
                type: 'hover'
            };
            return state;
        case 'promoteSelectionToDraft':
            // we should only promote the range to a draft if the current range type is a selection
            // we should also store the promotion type, so that a clear will not accidently clear the draft of a
            // different type
            if (state.selectionDraftRange !== state.selectionRange) return {
                ...state,
                selectionRange: null,
                type: state.type === 'selection' ? null : state.type,
                selectionDraftRange: state.selectionRange,
                selectionDraftDocumentPosition: action.position
            };
            return state;
        case 'promoteHoverToDraft':
            if (state.hoverDraftRange !== state.hoverRange) return {
                ...state,
                hoverRange: null,
                type: state.type === 'hover' ? null : state.type,
                hoverDraftRange: state.hoverRange,
                hoverDraftDocumentPosition: action.position
            };
            return state;
        case 'clearSelectionDraft':
            if (state.selectionDraftRange !== null) return {
                ...state,
                selectionDraftRange: null,
                selectionDraftDocumentPosition: null
            };
            return state;
        case 'clearHoverDraft':
            if (state.hoverDraftRange !== null) return {
                ...state,
                hoverDraftRange: null,
                hoverDraftDocumentPosition: null
            };
            return state;
    }
}
const $cf414537940f7a80$export$145b9bb655c3d220 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    range: null,
    type: null,
    selectionDraftRange: null,
    hoverDraftRange: null,
    selectionDraftDocumentPosition: null,
    hoverDraftDocumentPosition: null
});
const $cf414537940f7a80$export$efb0d1c8cbaac647 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    clearSelectionRange: ()=>{},
    clearHoverRange: ()=>{},
    setSelectionRange: ()=>{},
    promoteSelectionToDraft: ()=>{},
    promoteHoverToDraft: ()=>{},
    clearSelectionDraft: ()=>{},
    clearHoverDraft: ()=>{}
});
const $cf414537940f7a80$export$7cf774ce920e4bbd = ({ children: children, allowCommentsOnMedia: allowCommentsOnMedia })=>{
    const [{ selectionRange: selectionRange, hoverRange: hoverRange, type: type, selectionDraftRange: selectionDraftRange, selectionDraftDocumentPosition: selectionDraftDocumentPosition, hoverDraftRange: hoverDraftRange, hoverDraftDocumentPosition: hoverDraftDocumentPosition }, dispatch] = (0, $eJOHy.useReducer)($cf414537940f7a80$var$reducer, $cf414537940f7a80$var$initialState);
    const clearSelectionRange = (0, $eJOHy.useCallback)(()=>dispatch({
            type: 'clearSelection'
        }), []);
    const clearHoverRange = (0, $eJOHy.useCallback)(()=>dispatch({
            type: 'clearHover'
        }), []);
    const setSelectionRange = (0, $eJOHy.useCallback)((range)=>dispatch({
            type: 'setSelection',
            range: range
        }), []);
    const setHoverTarget = (0, $eJOHy.useCallback)((target)=>{
        // the HoverComponent expects an element deeply nested inside media, these classes work with the current implementation
        const mediaNode = target.querySelector('.media-card-inline-player, .media-file-card-view');
        if (!mediaNode) return;
        const range = document.createRange();
        range.setStartBefore(mediaNode);
        range.setEndAfter(mediaNode);
        dispatch({
            type: 'setHover',
            range: range
        });
    }, []);
    const promoteSelectionToDraft = (0, $eJOHy.useCallback)((position)=>{
        dispatch({
            type: 'promoteSelectionToDraft',
            position: position
        });
    }, []);
    const clearSelectionDraft = (0, $eJOHy.useCallback)(()=>{
        dispatch({
            type: 'clearSelectionDraft'
        });
    }, []);
    const promoteHoverToDraft = (0, $eJOHy.useCallback)((position)=>{
        dispatch({
            type: 'promoteHoverToDraft',
            position: position
        });
    }, []);
    const clearHoverDraft = (0, $eJOHy.useCallback)(()=>{
        dispatch({
            type: 'clearHoverDraft'
        });
    }, []);
    const stateData = (0, $eJOHy.useMemo)(()=>{
        return {
            // We techinically have two ranges, however we only want to expose one of them at a time, because only one draft
            // can be active at a time. The type of range is used to determine which range is active.
            range: type === 'selection' ? selectionRange : hoverRange,
            type: type,
            selectionDraftRange: selectionDraftRange,
            hoverDraftRange: hoverDraftRange,
            selectionDraftDocumentPosition: selectionDraftDocumentPosition,
            hoverDraftDocumentPosition: hoverDraftDocumentPosition
        };
    }, [
        selectionRange,
        hoverRange,
        type,
        selectionDraftRange,
        selectionDraftDocumentPosition,
        hoverDraftRange,
        hoverDraftDocumentPosition
    ]);
    const dispatchData = (0, $eJOHy.useMemo)(()=>({
            clearSelectionRange: clearSelectionRange,
            clearHoverRange: clearHoverRange,
            setSelectionRange: setSelectionRange,
            setHoverTarget: !!allowCommentsOnMedia ? setHoverTarget : undefined,
            promoteSelectionToDraft: promoteSelectionToDraft,
            promoteHoverToDraft: promoteHoverToDraft,
            clearSelectionDraft: clearSelectionDraft,
            clearHoverDraft: clearHoverDraft
        }), [
        allowCommentsOnMedia,
        clearSelectionRange,
        clearHoverRange,
        setSelectionRange,
        setHoverTarget,
        promoteSelectionToDraft,
        promoteHoverToDraft,
        clearSelectionDraft,
        clearHoverDraft
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($cf414537940f7a80$export$145b9bb655c3d220.Provider, {
        value: stateData,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($cf414537940f7a80$export$efb0d1c8cbaac647.Provider, {
            value: dispatchData,
            children: children
        })
    });
};
const $cf414537940f7a80$export$30384a6aedd19fee = ({ children: children, allowCommentsOnMedia: allowCommentsOnMedia, isNestedRender: isNestedRender })=>{
    /*
	 * If this is a nested render, we do not provide the context
	 * because it has already been provided higher up the component tree
	 * and we need the original context to create annotations on extensions.
	 */ return isNestedRender ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)($cf414537940f7a80$export$7cf774ce920e4bbd, {
        allowCommentsOnMedia: allowCommentsOnMedia,
        children: children
    });
};
const $cf414537940f7a80$export$e07ee6d6cc95d9a0 = ()=>{
    return (0, $eJOHy.useContext)($cf414537940f7a80$export$145b9bb655c3d220);
};
const $cf414537940f7a80$export$708fc397e2b6f08d = ()=>{
    return (0, $eJOHy.useContext)($cf414537940f7a80$export$efb0d1c8cbaac647);
};

});


parcelRegister("8dxEE", function(module, exports) {
$parcel$export(module.exports, "AnnotationHoverContext", () => $eff383fadc0ede10$export$b3db0feb20552fc3);
$parcel$export(module.exports, "useAnnotationHoverContext", () => $eff383fadc0ede10$export$a02bfcbbbf920306);
$parcel$export(module.exports, "useAnnotationHoverDispatch", () => $eff383fadc0ede10$export$c288883964405c82);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $eff383fadc0ede10$var$AnnotationHoverStateContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    isWithinRange: false
});
const $eff383fadc0ede10$var$AnnotationHoverDispatchContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    cancelTimeout: ()=>{},
    initiateTimeout: ()=>{},
    setIsWithinRange: ()=>{}
});
const $eff383fadc0ede10$export$b3db0feb20552fc3 = ({ children: children })=>{
    const [isWithinRange, setIsWithinRange] = (0, $eJOHy.useState)(false);
    const timeoutHandler = (0, $eJOHy.useRef)();
    const cancelTimeout = (0, $eJOHy.useCallback)(()=>{
        if (timeoutHandler) clearTimeout(timeoutHandler.current);
    }, [
        timeoutHandler
    ]);
    const initiateTimeout = (0, $eJOHy.useCallback)(()=>{
        if (isWithinRange) timeoutHandler.current = setTimeout(()=>{
            setIsWithinRange(false);
        }, 500);
    }, [
        isWithinRange
    ]);
    const stateData = (0, $eJOHy.useMemo)(()=>({
            isWithinRange: isWithinRange
        }), [
        isWithinRange
    ]);
    const dispatchData = (0, $eJOHy.useMemo)(()=>({
            cancelTimeout: cancelTimeout,
            initiateTimeout: initiateTimeout,
            setIsWithinRange: setIsWithinRange
        }), [
        cancelTimeout,
        initiateTimeout,
        setIsWithinRange
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($eff383fadc0ede10$var$AnnotationHoverStateContext.Provider, {
        value: stateData,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($eff383fadc0ede10$var$AnnotationHoverDispatchContext.Provider, {
            value: dispatchData,
            children: children
        })
    });
};
const $eff383fadc0ede10$export$a02bfcbbbf920306 = ()=>{
    return (0, $eJOHy.useContext)($eff383fadc0ede10$var$AnnotationHoverStateContext);
};
const $eff383fadc0ede10$export$c288883964405c82 = ()=>{
    return (0, $eJOHy.useContext)($eff383fadc0ede10$var$AnnotationHoverDispatchContext);
};

});


parcelRegister("4jhSu", function(module, exports) {
$parcel$export(module.exports, "SelectionRangeValidator", () => $d15d2217dff1b0e8$export$74435b85e23b84d9);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8Saoj = parcelRequire("8Saoj");

var $bggde = parcelRequire("bggde");

var $4Z9bh = parcelRequire("4Z9bh");
const $d15d2217dff1b0e8$export$74435b85e23b84d9 = (props)=>{
    const { selectionComponent: selectionComponent, rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $eJOHy.useContext)((0, $4Z9bh.RendererContext));
    const [type, range, draftRange, clearRange] = (0, $8Saoj.useUserSelectionRange)({
        rendererRef: rendererRef
    });
    const selectionRange = type === 'selection' ? range : null;
    // !!! the draft range will become invalid after the mark DOM is inserted
    if (!selectionRange && !draftRange) return null;
    const documentPosition = actions.getPositionFromRange(range);
    // This property is drilled down to consumers when a new range is selected to test it's validity
    let isAnnotationAllowedOnRange = false;
    try {
        isAnnotationAllowedOnRange = documentPosition && actions.isValidAnnotationPosition(documentPosition);
    } catch  {
        isAnnotationAllowedOnRange = false;
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bggde.SelectionInlineCommentMounter), {
        range: selectionRange,
        draftRange: draftRange,
        wrapperDOM: rendererRef,
        component: selectionComponent,
        onClose: clearRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: isAnnotationAllowedOnRange,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        createAnalyticsEvent: createAnalyticsEvent
    });
};
$d15d2217dff1b0e8$export$74435b85e23b84d9.displayName = 'SelectionRangeValidator';

});
parcelRegister("8Saoj", function(module, exports) {
$parcel$export(module.exports, "useUserSelectionRange", () => $11095f38adeb145c$export$47201332e612f5a4);

var $eJOHy = parcelRequire("eJOHy");

var $e2m7L = parcelRequire("e2m7L");

var $hgjUT = parcelRequire("hgjUT");

var $3OjM0 = parcelRequire("3OjM0");
const $11095f38adeb145c$export$47201332e612f5a4 = (props)=>{
    const { rendererRef: { current: rendererDOM } } = props;
    const selectionTimeoutRef = (0, $eJOHy.useRef)();
    const { clearSelectionRange: clearSelectionRange, setSelectionRange: setSelectionRange } = (0, $e2m7L.useAnnotationRangeDispatch)();
    const { range: range, type: type, selectionDraftRange: selectionDraftRange } = (0, $e2m7L.useAnnotationRangeState)();
    const { annotationManager: annotationManager } = (0, $3OjM0.useAnnotationManagerDispatch)();
    const lastRangeRef = (0, $eJOHy.useRef)(null);
    const isAnnotationManagerEnabled = !!annotationManager;
    const onSelectionChange = (0, $eJOHy.useCallback)((event)=>{
        if (selectionTimeoutRef.current) clearTimeout(selectionTimeoutRef.current);
        selectionTimeoutRef.current = setTimeout(()=>{
            const sel = document.getSelection();
            if (!sel || sel.type !== 'Range' || sel.rangeCount !== 1) {
                lastRangeRef.current = null; // Clear last range if selection is invalid
                if (isAnnotationManagerEnabled) clearSelectionRange();
                return;
            }
            let _range = sel.getRangeAt(0);
            // Skip if the selection hasn't changed
            if (lastRangeRef.current && _range.compareBoundaryPoints(Range.START_TO_START, lastRangeRef.current) === 0 && _range.compareBoundaryPoints(Range.END_TO_END, lastRangeRef.current) === 0) return;
            if (rendererDOM && (0, $hgjUT.isRangeInsideOfRendererContainer)(rendererDOM, _range)) {
                const { startContainer: startContainer, endContainer: endContainer } = _range;
                const isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
                if (isTripleClick) {
                    let p = startContainer;
                    while(p && p.nodeName !== 'P' && p !== rendererDOM)p = p.parentNode;
                    if (p && p.nodeName === 'P' && p instanceof Element) {
                        const range = document.createRange();
                        range.selectNodeContents(p);
                        sel.removeAllRanges();
                        sel.addRange(range);
                        _range = sel.getRangeAt(0);
                    }
                }
                setSelectionRange(_range.cloneRange());
                lastRangeRef.current = _range;
            }
        }, 100);
    }, [
        rendererDOM,
        setSelectionRange,
        clearSelectionRange,
        isAnnotationManagerEnabled
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!document || !rendererDOM) return;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('selectionchange', onSelectionChange);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('selectionchange', onSelectionChange);
            clearSelectionRange();
        };
    }, [
        rendererDOM,
        onSelectionChange,
        clearSelectionRange
    ]);
    return [
        type,
        range,
        selectionDraftRange,
        clearSelectionRange
    ];
};

});
parcelRegister("hgjUT", function(module, exports) {
$parcel$export(module.exports, "isRangeInsideOfRendererContainer", () => $f03d2274a274d42b$export$90ee8f2d9317f430);
/** Exists in its own module to allow mocking in unit tests */ const $f03d2274a274d42b$export$90ee8f2d9317f430 = (rendererDOM, range)=>{
    const sourceRange = document.createRange();
    sourceRange.selectNode(rendererDOM);
    const isSelectionStartsAfterRenderer = range.compareBoundaryPoints(Range.START_TO_START, sourceRange) === 1;
    const isSelectionStartsBeforeRenderer = range.compareBoundaryPoints(Range.START_TO_END, sourceRange) === 1;
    const isSelectionEndsAfterRenderer = range.compareBoundaryPoints(Range.END_TO_END, sourceRange) === 1;
    return isSelectionStartsAfterRenderer && isSelectionStartsBeforeRenderer && !isSelectionEndsAfterRenderer;
};

});


parcelRegister("bggde", function(module, exports) {
$parcel$export(module.exports, "SelectionInlineCommentMounter", () => $b0e110fc86dabdf8$export$ca7741472ed8ba00);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8KLBw = parcelRequire("8KLBw");

var $jxPcD = parcelRequire("jxPcD");

var $eGOwo = parcelRequire("eGOwo");

var $fH5Zn = parcelRequire("fH5Zn");

var $bgewf = parcelRequire("bgewf");

var $bMFKb = parcelRequire("bMFKb");

var $jidPs = parcelRequire("jidPs");

var $4Z9bh = parcelRequire("4Z9bh");

var $3OjM0 = parcelRequire("3OjM0");

var $e2m7L = parcelRequire("e2m7L");
const $b0e110fc86dabdf8$export$ca7741472ed8ba00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo((props)=>{
    const { component: Component, range: range, draftRange: draftRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const { promoteSelectionToDraft: promoteSelectionToDraft, clearSelectionDraft: clearSelectionDraft } = (0, $e2m7L.useAnnotationRangeDispatch)();
    const { selectionDraftDocumentPosition: selectionDraftDocumentPosition } = (0, $e2m7L.useAnnotationRangeState)();
    const actions = (0, $eJOHy.useContext)((0, $4Z9bh.RendererContext));
    const { isDrafting: isDrafting, draftId: draftId } = (0, $3OjM0.useAnnotationManagerState)();
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $3OjM0.useAnnotationManagerDispatch)();
    const inlineNodeTypes = (0, $eJOHy.useMemo)(()=>{
        if (!actions.isRangeAnnotatable(range)) return undefined;
        return (0, $jidPs.getRendererRangeInlineNodeNames)({
            pos: documentPosition,
            actions: actions
        });
    }, [
        documentPosition,
        actions,
        range
    ]);
    const onCreateCallback = (0, $eJOHy.useCallback)((annotationId)=>{
        // We want to support creation on a documentPosition if the user is only using ranges
        // but we want to prioritize draft positions if they are being used by consumers
        // !!! at this point, the documentPosition can be the wrong position if the user select something else
        const positionToAnnotate = selectionDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation) return false;
        // Evaluate position validity when the user commits the position to be annotated
        const isCreateAllowedOnPosition = actions.isValidAnnotationPosition(positionToAnnotate);
        if (!isCreateAllowedOnPosition) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $jxPcD.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $bMFKb.ACTION).INSERTED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            },
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK
        }).fire((0, $bgewf.FabricChannel).editor);
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        actions,
        documentPosition,
        applyAnnotation,
        createAnalyticsEvent,
        inlineNodeTypes,
        selectionDraftDocumentPosition
    ]);
    const createIndexCallback = (0, $eJOHy.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $eJOHy.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $bMFKb.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    inlineNodeNames: inlineNodeTypes,
                    documentPosition: documentPosition,
                    isAnnotationAllowed: isAnnotationAllowed
                },
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK
            }).fire((0, $bgewf.FabricChannel).editor);
            return false;
        }
        promoteSelectionToDraft(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = range ? actions.getAnnotationsByPosition(range) : [];
            createAnalyticsEvent({
                action: (0, $bMFKb.ACTION).OPENED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length,
                    inlineNodeNames: inlineNodeTypes
                }
            }).fire((0, $bgewf.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $fH5Zn.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        // at this point, the documentPosition is the position that the user has selected,
        // not the selectionDraftDocumentPosition
        // because the documentPosition is not promoted to selectionDraftDocumentPosition yet
        // use platform_editor_comments_api_manager here so we can clear the code path when the flag is removed
        const positionToAnnotate = (0, $eGOwo.fg)('platform_editor_comments_api_manager') ? documentPosition : selectionDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $bMFKb.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    positionToAnnotate: positionToAnnotate,
                    applyAnnotationMissing: !applyAnnotation,
                    annotationId: options.annotationId
                },
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK
            }).fire((0, $bgewf.FabricChannel).editor);
            return false;
        }
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $jxPcD.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        isAnnotationAllowed,
        createAnalyticsEvent,
        applyAnnotation,
        actions,
        range,
        inlineNodeTypes,
        promoteSelectionToDraft,
        selectionDraftDocumentPosition
    ]);
    const removeDraftModeCallback = (0, $eJOHy.useCallback)(()=>{
        clearSelectionDraft();
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearSelectionDraft
    ]);
    const onCloseCallback = (0, $eJOHy.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $bMFKb.ACTION).CLOSED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            }
        }).fire((0, $bgewf.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent,
        inlineNodeTypes
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (annotationManager) {
            const allowAnnotation = ()=>{
                if (isDrafting) return false;
                return isAnnotationAllowed;
            };
            annotationManager.hook('allowAnnotation', allowAnnotation);
            return ()=>{
                annotationManager.unhook('allowAnnotation', allowAnnotation);
            };
        }
    }, [
        annotationManager,
        isAnnotationAllowed,
        isDrafting
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (annotationManager) {
            const startDraft = ()=>{
                // if there is a draft in progress, we ignore it and start a new draft
                // this is because clearing the draft will remove the mark node from the DOM, which will cause the selection range to be invalid
                const id = (0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))();
                const result = applyDraftModeCallback({
                    annotationId: id,
                    keepNativeSelection: false
                });
                if (!result) return {
                    success: false,
                    reason: 'invalid-range'
                };
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: true,
                        draftId: id,
                        draftActionResult: result
                    }
                });
                dispatch({
                    type: 'resetSelectedAnnotation'
                });
                return {
                    success: true,
                    // We cannot get a ref to the target element here
                    // because the draft is not yet applied to the DOM
                    targetElement: undefined,
                    inlineNodeTypes: result.inlineNodeTypes ?? [],
                    actionResult: {
                        step: result.step,
                        doc: result.doc,
                        inlineNodeTypes: result.inlineNodeTypes,
                        targetNodeType: result.targetNodeType,
                        originalSelection: result.originalSelection,
                        numMatches: result.numMatches,
                        matchIndex: result.matchIndex,
                        pos: result.pos
                    }
                };
            };
            annotationManager.hook('startDraft', startDraft);
            return ()=>{
                annotationManager.unhook('startDraft', startDraft);
            };
        }
    }, [
        annotationManager,
        isDrafting,
        applyDraftModeCallback,
        actions,
        range,
        dispatch
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (annotationManager) {
            const clearDraft = ()=>{
                if (!isDrafting) return {
                    success: false,
                    reason: 'draft-not-started'
                };
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: false,
                        draftId: undefined,
                        draftActionResult: undefined
                    }
                });
                onCloseCallback();
                return {
                    success: true
                };
            };
            annotationManager.hook('clearDraft', clearDraft);
            return ()=>{
                annotationManager.unhook('clearDraft', clearDraft);
            };
        }
    }, [
        annotationManager,
        onCloseCallback,
        isDrafting,
        dispatch
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (annotationManager) {
            const applyDraft = (id)=>{
                if (!isDrafting || !draftId) return {
                    success: false,
                    reason: 'draft-not-started'
                };
                const result = onCreateCallback(id);
                if (!result) return {
                    success: false,
                    reason: 'range-no-longer-exists'
                };
                onCloseCallback();
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: false,
                        draftId: undefined,
                        draftActionResult: undefined
                    }
                });
                dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: id,
                        selected: true,
                        markState: (0, $jxPcD.AnnotationMarkStates).ACTIVE
                    }
                });
                return {
                    success: true,
                    targetElement: undefined,
                    actionResult: id !== draftId ? {
                        step: result.step,
                        doc: result.doc,
                        inlineNodeTypes: result.inlineNodeTypes,
                        targetNodeType: result.targetNodeType,
                        originalSelection: result.originalSelection,
                        numMatches: result.numMatches,
                        matchIndex: result.matchIndex,
                        pos: result.pos
                    } : undefined
                };
            };
            annotationManager.hook('applyDraft', applyDraft);
            return ()=>{
                annotationManager.unhook('applyDraft', applyDraft);
            };
        }
    }, [
        annotationManager,
        onCreateCallback,
        onCloseCallback,
        isDrafting,
        draftId,
        dispatch
    ]);
    // Please remove this NOP function when the flag platform_editor_comments_api_manager is removed.
    const nop = (0, $eJOHy.useMemo)(()=>()=>false, []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        range: range,
        draftRange: draftRange,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: annotationManager ? nop : onCloseCallback,
        onCreate: annotationManager ? nop : onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: annotationManager ? nop : applyDraftModeCallback,
        removeDraftMode: annotationManager ? nop : removeDraftModeCallback,
        inlineNodeTypes: inlineNodeTypes
    });
});

});



parcelRegister("1YS5j", function(module, exports) {
$parcel$export(module.exports, "useLoadAnnotations", () => $34c81e7572b846dd$export$39f7c1a861a0d41c);

var $eJOHy = parcelRequire("eJOHy");

var $4Fc33 = parcelRequire("4Fc33");

var $eFHDV = parcelRequire("eFHDV");

var $4Z9bh = parcelRequire("4Z9bh");

var $3OjM0 = parcelRequire("3OjM0");
const $34c81e7572b846dd$export$39f7c1a861a0d41c = ({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
    const actions = (0, $eJOHy.useContext)((0, $4Z9bh.RendererContext));
    const providers = (0, $eJOHy.useContext)((0, $eFHDV.ProvidersContext));
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $3OjM0.useAnnotationManagerDispatch)();
    const isAnnotationManagerEnabled = !!annotationManager;
    (0, $eJOHy.useEffect)(()=>{
        if (!providers) return;
        const { inlineComment: { getState: inlineCommentGetState, updateSubscriber: updateSubscriberInlineComment } } = providers;
        const annotations = actions.getAnnotationMarks();
        // we don't want to request integrators for state with an empty list of ids.
        if (!annotations.length) {
            if (!isNestedRender) // inlineCommentGetState handles empty lists gracefully. It has a side-effect of clearing state, which is why this call is needed
            inlineCommentGetState([], isNestedRender);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: 0
            });
            return;
        }
        const ids = annotations.map((mark)=>mark.attrs.id);
        const cb = (data)=>{
            if (!updateSubscriberInlineComment) return;
            const payload = data.reduce((acc, value)=>({
                    ...acc,
                    [value.id]: value
                }), {});
            if (isAnnotationManagerEnabled) dispatch({
                type: 'loadAnnotation',
                data: Object.keys(payload).map((id)=>({
                        id: id,
                        markState: payload[id].state ?? undefined
                    }))
            });
            else updateSubscriberInlineComment.emit((0, $4Fc33.AnnotationUpdateEvent).SET_ANNOTATION_STATE, payload);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: data.filter((data)=>data.state === 'active').length
            });
        };
        inlineCommentGetState(ids, isNestedRender).then(cb);
    }, [
        actions,
        providers,
        adfDocument,
        isNestedRender,
        onLoadComplete,
        dispatch,
        isAnnotationManagerEnabled
    ]);
};

});


parcelRegister("2uPUs", function(module, exports) {
$parcel$export(module.exports, "ValidationContext", () => $637c2da842893e64$export$d452675449e81987);
$parcel$export(module.exports, "ValidationContextProvider", () => $637c2da842893e64$export$5b655fe45447a548);

var $eJOHy = parcelRequire("eJOHy");
const $637c2da842893e64$export$d452675449e81987 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $637c2da842893e64$export$5b655fe45447a548 = $637c2da842893e64$export$d452675449e81987.Provider;

});


parcelRegister("bDynL", function(module, exports) {
$parcel$export(module.exports, "default", () => $9db481286d0d47db$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/prefer-primitives, @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");


var $eJOHy = parcelRequire("eJOHy");

var $fsEil = parcelRequire("fsEil");

var $cZRB0 = parcelRequire("cZRB0");

var $gpsHJ = parcelRequire("gpsHJ");
var $2bEPZ = parcelRequire("2bEPZ");

var $iRC0e = parcelRequire("iRC0e");

var $bnh3n = parcelRequire("bnh3n");
const $9db481286d0d47db$var$useMultiBodiedExtensionActions = ({ updateActiveChild: updateActiveChild, children: children })=>{
    const actions = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>{
        return {
            changeActive (index) {
                return updateActiveChild(index);
            },
            addChild () {
                return false;
            },
            getChildrenCount () {
                return children ? children?.length : 0;
            },
            removeChild (index) {
                return false;
            },
            updateParameters (parameters) {
                return false;
            },
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getChildren () {
                return [];
            },
            getChildrenContainer () {
                return null;
            }
        };
    }, [
        updateActiveChild,
        children
    ]);
    return actions;
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $9db481286d0d47db$var$navigationCssExtended = /*#__PURE__*/ (0, $1NIU8.css)((0, $gpsHJ.sharedMultiBodiedExtensionStyles).mbeNavigation, ";margin-left:0!important;margin-right:0!important;.mbe-add-tab-button,.mbe-remove-tab{display:none;}");
const $9db481286d0d47db$var$MultiBodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [] } = props;
    const [activeChildIndex, setActiveChildIndex] = (0, $eJOHy.useState)(0);
    const removeOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children)// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
    const overflowContainerClass = !removeOverflow ? (0, $iRC0e.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
    const updateActiveChild = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((index)=>{
        if (typeof index !== 'number') {
            // Ignored via go/ees007
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO: Make sure we log this somewhere if this happens
            setActiveChildIndex(0);
            return false;
        }
        setActiveChildIndex(index);
        return true;
    }, [
        setActiveChildIndex
    ]);
    const actions = $9db481286d0d47db$var$useMultiBodiedExtensionActions({
        updateActiveChild: updateActiveChild,
        children: children
    });
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    const containerCssExtended = /*#__PURE__*/ (0, $1NIU8.css)((0, $gpsHJ.sharedMultiBodiedExtensionStyles).mbeExtensionContainer, ";.ak-renderer-extension{margin-top:0!important;}[data-layout='full-width'],[data-layout='wide']{.multiBodiedExtension-navigation{border-right:3px solid ", `var(--ds-border, ${(0, $7bb4c1736002a04a$export$1ce2d1575d444ceb)})`, "!important;}}.multiBodiedExtension--frames>[data-extension-frame='true']:nth-of-type(", activeChildIndex + 1, "){", (0, $gpsHJ.sharedMultiBodiedExtensionStyles).extensionFrameContent, " margin-left:0;margin-right:0;}");
    const isTopLevel = path.length < 1;
    const centerAlignClass = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) ? (0, $iRC0e.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    function renderMbeContent(width) {
        return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $iRC0e.RendererCssClassName).EXTENSION} ${centerAlignClass} ${overflowContainerClass}`,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                width: isTopLevel ? (0, $bnh3n.calcBreakoutWidth)(layout, width) : '100%'
            },
            "data-layout": layout
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("nav", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "multiBodiedExtension-navigation",
            css: $9db481286d0d47db$var$navigationCssExtended,
            "data-testid": "multiBodiedExtension-navigation"
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $cZRB0.default), {
            ...props,
            actions: actions,
            type: "multiBodiedExtension"
        }, ({ result: result })=>{
            try {
                if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(result)) // Return the content directly if it's a valid JSX.Element
                return (0, $fsEil.renderExtension)(result, layout, {
                    isTopLevel: path.length < 1
                });
            } catch (e) {
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
            // Always return default content if anything goes wrong
            return (0, $fsEil.renderExtension)(children, layout, {
                isTopLevel: path.length < 1
            });
        })), /*#__PURE__*/ (0, $1NIU8.jsx)("article", {
            "data-testid": "multiBodiedExtension--frames",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `multiBodiedExtension--frames`
        }, children));
    }
    return /*#__PURE__*/ (0, $1NIU8.jsx)("section", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "multiBodiedExtension--container",
        css: containerCssExtended,
        "data-testid": "multiBodiedExtension--container",
        "data-active-child-index": activeChildIndex,
        "data-layout": layout
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $2bEPZ.WidthConsumer), null, ({ width: width })=>renderMbeContent(width)));
};
var $9db481286d0d47db$export$2e2bcd8739ae039 = $9db481286d0d47db$var$MultiBodiedExtension;

});
parcelRegister("gpsHJ", function(module, exports) {
$parcel$export(module.exports, "removeMarginsAndBorder", () => $4cef5c2bc10730e6$export$8df0393dc2d5d656);
$parcel$export(module.exports, "sharedMultiBodiedExtensionStyles", () => $4cef5c2bc10730e6$export$9c7196ca47f67390);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");
function $4cef5c2bc10730e6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Wraps the navigation bar and extensionFrames
const $4cef5c2bc10730e6$var$mbeExtensionContainer = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    background: 'transparent !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'padding:': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        left: `${"var(--ds-space-100, 8px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        right: `${"var(--ds-space-100, 8px)"} !important`
    },
    paddingBottom: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-padding': {
        paddingBottom: 0
    },
    position: 'relative',
    verticalAlign: 'middle',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-handler-result': {
        marginLeft: "var(--ds-space-100, 8px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".multiBodiedExtension-content-dom-wrapper > [data-extension-frame='true'], .multiBodiedExtension--frames > [data-extension-frame='true']": {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-content-dom-wrapper, .multiBodiedExtension--frames': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[data-extension-frame='true'] > :not(style):first-child, [data-extension-frame='true'] > style:first-child + *": {
            marginTop: 0
        }
    }
});
const $4cef5c2bc10730e6$var$mbeNavigation = {
    name: "4tty3q",
    styles: "border-top-left-radius:var(--ds-radius-small, 3px);border-top-right-radius:var(--ds-radius-small, 3px);user-select:none;-webkit-user-modify:read-only;border-bottom:none !important;background:var(--ds-surface, white);margin-left:var(--ds-space-100, 8px);margin-right:var(--ds-space-100, 8px);&.remove-margins{margin:var(--ds-space-negative-100, -8px);}&.remove-border{border:none;}"
};
const $4cef5c2bc10730e6$var$extensionFrameContent = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    padding: `${"var(--ds-space-100, 8px)"} !important`,
    display: 'block',
    minHeight: '100px',
    background: 'transparent',
    borderBottomLeftRadius: "var(--ds-radius-small, 3px)",
    borderBottomRightRadius: "var(--ds-radius-small, 3px)",
    marginLeft: "var(--ds-space-100, 8px)",
    marginRight: "var(--ds-space-100, 8px)",
    cursor: 'initial',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.pm-table-with-controls': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: `${"var(--ds-space-150, 12px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingRight: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.bodiedExtensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-100, 8px)"} !important`
    }
});
const $4cef5c2bc10730e6$export$8df0393dc2d5d656 = {
    name: "c620zi",
    styles: "margin-left:0;margin-right:0;border:none"
};
const $4cef5c2bc10730e6$export$9c7196ca47f67390 = {
    mbeExtensionContainer: $4cef5c2bc10730e6$var$mbeExtensionContainer,
    mbeNavigation: $4cef5c2bc10730e6$var$mbeNavigation,
    extensionFrameContent: $4cef5c2bc10730e6$var$extensionFrameContent
};

});


parcelRegister("9DR0p", function(module, exports) {
$parcel$export(module.exports, "default", () => $19255d557a43e493$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/prefer-primitives, @atlaskit/design-system/consistent-css-prop-usage */ /**
                                                                                                                   * @jsxRuntime classic
                                                                                                                   * @jsx jsx
                                                                                                                   * @jsxFrag
                                                                                                                   */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eJOHy = parcelRequire("eJOHy");

var $2bEPZ = parcelRequire("2bEPZ");

var $iRC0e = parcelRequire("iRC0e");

var $bnh3n = parcelRequire("bnh3n");

var $enT6M = parcelRequire("enT6M");

var $7Oflg = parcelRequire("7Oflg");
function $19255d557a43e493$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $19255d557a43e493$var$containerStyles = {
    name: "utcqjk",
    styles: "&:first-child > .ak-renderer-extension{margin-top:0;}"
};
const $19255d557a43e493$var$MultiBodiedExtensionChildrenContainer = ({ children: children })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("article", {
        "data-testid": "multiBodiedExtension--frames"
    }, children);
};
const $19255d557a43e493$var$MultiBodiedExtensionNavigation = ({ children: children })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("nav", {
        "data-testid": "multiBodiedExtension-navigation"
    }, children);
};
const $19255d557a43e493$var$MultiBodiedExtensionWrapper = ({ width: width, path: path, layout: layout, children: children })=>{
    const isTopLevel = path.length < 1;
    const centerAlignClass = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) ? (0, $iRC0e.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    // This hierarchy is copied from regular extension (see extension.tsx)
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $iRC0e.RendererCssClassName).EXTENSION} ${centerAlignClass}`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: isTopLevel ? (0, $bnh3n.calcBreakoutWidth)(layout, width) : '100%'
        },
        "data-layout": layout,
        "data-testid": "multiBodiedExtension--wrapper"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: `${(0, $iRC0e.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
    }, children));
};
const $19255d557a43e493$var$MultiBodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [], parameters: parameters, extensionType: extensionType, extensionKey: extensionKey, content: content, marks: marks, localId: localId } = props;
    const [activeChildIndex, setActiveChildIndex] = (0, $eJOHy.useState)(0);
    const { loading: loading, extensionContext: extensionContext } = (0, $7Oflg.useMultiBodiedExtensionContext)({
        extensionType: extensionType,
        extensionKey: extensionKey
    });
    const actions = (0, $enT6M.useMultiBodiedExtensionActions)({
        updateActiveChild: setActiveChildIndex,
        children: children,
        childrenContainer: /*#__PURE__*/ (0, $1NIU8.jsx)($19255d557a43e493$var$MultiBodiedExtensionChildrenContainer, null, children),
        allowBodiedOverride: extensionContext?.privateProps?.__allowBodiedOverride
    });
    const renderContent = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        if (loading || !extensionContext) return null;
        const { NodeRenderer: NodeRenderer, privateProps: privateProps } = extensionContext;
        const fragmentLocalId = marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
        const node = {
            type: 'multiBodiedExtension',
            extensionKey: extensionKey,
            extensionType: extensionType,
            parameters: parameters,
            content: content,
            localId: localId,
            fragmentLocalId: fragmentLocalId
        };
        if (privateProps.__allowBodiedOverride) return /*#__PURE__*/ (0, $1NIU8.jsx)(NodeRenderer, {
            node: node,
            actions: actions
        });
        else return /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, $1NIU8.jsx)($19255d557a43e493$var$MultiBodiedExtensionNavigation, null, /*#__PURE__*/ (0, $1NIU8.jsx)(NodeRenderer, {
            node: node,
            actions: actions
        })), /*#__PURE__*/ (0, $1NIU8.jsx)($19255d557a43e493$var$MultiBodiedExtensionChildrenContainer, null, children));
    }, [
        loading,
        extensionContext,
        marks,
        extensionKey,
        extensionType,
        parameters,
        content,
        localId,
        actions,
        children
    ]);
    // make the frame visible
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    const containerActiveFrameStyles = /*#__PURE__*/ (0, $1NIU8.css)("& [data-extension-frame='true']:nth-of-type(", activeChildIndex + 1, "){display:block;}");
    return /*#__PURE__*/ (0, $1NIU8.jsx)("section", {
        css: [
            $19255d557a43e493$var$containerStyles,
            containerActiveFrameStyles
        ],
        "data-testid": "multiBodiedExtension--container",
        "data-multiBodiedExtension-container": true,
        "data-active-child-index": activeChildIndex,
        "data-layout": layout,
        "data-local-id": localId
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $2bEPZ.WidthConsumer), null, ({ width: width })=>/*#__PURE__*/ (0, $1NIU8.jsx)($19255d557a43e493$var$MultiBodiedExtensionWrapper, {
            layout: layout,
            width: width,
            path: path
        }, renderContent())));
};
var $19255d557a43e493$export$2e2bcd8739ae039 = $19255d557a43e493$var$MultiBodiedExtension;

});
parcelRegister("enT6M", function(module, exports) {
$parcel$export(module.exports, "useMultiBodiedExtensionActions", () => $c4dcfa71779e05f0$export$3c7139d93ecb4f1f);

var $eJOHy = parcelRequire("eJOHy");
const $c4dcfa71779e05f0$export$3c7139d93ecb4f1f = ({ updateActiveChild: updateActiveChild, children: children, allowBodiedOverride: allowBodiedOverride, childrenContainer: childrenContainer })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>{
        return {
            changeActive (index) {
                if (!Number.isInteger(index)) return false;
                updateActiveChild(index);
                return true;
            },
            addChild () {
                return false;
            },
            getChildrenCount () {
                return children && Array.isArray(children) ? children.length : 0;
            },
            removeChild (_index) {
                return false;
            },
            updateParameters (_parameters) {
                return false;
            },
            getChildren () {
                return [];
            },
            getChildrenContainer () {
                return allowBodiedOverride ? childrenContainer : null;
            }
        };
    }, [
        updateActiveChild,
        children,
        allowBodiedOverride,
        childrenContainer
    ]);
};

});

parcelRegister("7Oflg", function(module, exports) {
$parcel$export(module.exports, "useMultiBodiedExtensionContext", () => $f24dd63e8512ec71$export$e55394818db35473);

var $eJOHy = parcelRequire("eJOHy");

var $LFmXM = parcelRequire("LFmXM");

var $fvGDQ = parcelRequire("fvGDQ");

var $6Ramj = parcelRequire("6Ramj");
const $f24dd63e8512ec71$export$e55394818db35473 = ({ extensionType: extensionType, extensionKey: extensionKey })=>{
    const isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(true);
    const localGetNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>(0, $LFmXM.default)((0, $fvGDQ.getNodeRenderer)), []);
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [privateProps, setPrivateProps] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState();
    const providerPromise = (0, $6Ramj.useProvider)('extensionProvider');
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        if (providerPromise) providerPromise.then((p)=>{
            if (isMounted.current) setProvider(p);
            return (0, $fvGDQ.getExtensionModuleNodePrivateProps)(p, extensionType, extensionKey);
        }).then((pr)=>{
            if (isMounted.current) setPrivateProps(pr);
        });
    }, [
        providerPromise,
        extensionType,
        extensionKey
    ]);
    const NodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>{
        if (!provider) return null;
        return localGetNodeRenderer(provider, extensionType, extensionKey);
    }, [
        provider,
        extensionType,
        extensionKey,
        localGetNodeRenderer
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>{
        if (!provider || !NodeRenderer || !privateProps) return {
            extensionContext: null,
            loading: true
        };
        return {
            extensionContext: {
                NodeRenderer: NodeRenderer,
                privateProps: privateProps
            },
            loading: false
        };
    }, [
        provider,
        NodeRenderer,
        privateProps
    ]);
};

});


parcelRegister("gzcAo", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ce4d6773e8cb55f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eGOwo = parcelRequire("eGOwo");
function $8ce4d6773e8cb55f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8ce4d6773e8cb55f$var$containerCSSOld = {
    name: "1e1nv5z",
    styles: "min-height:100px;flex-basis:100%"
};
const $8ce4d6773e8cb55f$var$containerCSSNew = /*#__PURE__*/ (0, $1NIU8.css)({
    padding: `${"var(--ds-space-100, 8px)"}`,
    minHeight: '100px',
    // by default all frames are hidden, this style is overridden in multiBodiedExtensions for active frame
    display: 'none'
});
const $8ce4d6773e8cb55f$var$ExtensionFrame = (props)=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            (0, $eGOwo.fg)('platform_editor_multi_body_extension_extensibility') ? $8ce4d6773e8cb55f$var$containerCSSNew : $8ce4d6773e8cb55f$var$containerCSSOld
        ],
        "data-extension-frame": "true"
    }, props.children);
};
var $8ce4d6773e8cb55f$export$2e2bcd8739ae039 = $8ce4d6773e8cb55f$var$ExtensionFrame;

});

parcelRegister("53tmQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e35c62ab9ad9b570$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $7T1su = parcelRequire("7T1su");

var $iCTcU = parcelRequire("iCTcU");
function $e35c62ab9ad9b570$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("ul", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7T1su.bulletListSelector).substr(1),
        "data-local-id": props.localId,
        "data-indent-level": props.path ? (0, $iCTcU.getListIndentLevel)(props.path) : 1,
        children: props.children
    });
}

});
parcelRegister("iCTcU", function(module, exports) {
$parcel$export(module.exports, "getListIndentLevel", () => $a2d656820b3db7d4$export$75aa84e85754623e);
function $a2d656820b3db7d4$export$75aa84e85754623e(path) {
    let count = 1;
    path.forEach((node)=>{
        if (node.type.name === 'bulletList' || node.type.name === 'orderedList') count++;
    });
    return count;
}

});


parcelRegister("lbGwd", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4d94d1c513db838$export$2e2bcd8739ae039);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => $b4d94d1c513db838$export$41121a410ca2f650);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $iRC0e = parcelRequire("iRC0e");

var $2v2KH = parcelRequire("2v2KH");
function $b4d94d1c513db838$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $iRC0e.RendererCssClassName).DOCUMENT,
        children: props.children
    });
}
function $b4d94d1c513db838$export$41121a410ca2f650(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: (0, $2v2KH.useSelectAllTrap)(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $iRC0e.RendererCssClassName).DOCUMENT,
        children: props.children
    });
}

});
parcelRegister("2v2KH", function(module, exports) {
$parcel$export(module.exports, "useSelectAllTrap", () => $5478bcf2c5a2bb88$export$98871b245ee25215);

var $bMFKb = parcelRequire("bMFKb");

var $eJOHy = parcelRequire("eJOHy");

var $bdjbf = parcelRequire("bdjbf");

var $glugJ = parcelRequire("glugJ");
const $5478bcf2c5a2bb88$export$98871b245ee25215 = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $bdjbf.default));
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const clicked = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(false);
    const caught = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef();
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const mac = typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;
    const onKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((e)=>{
        const el = ref.current;
        if (!el) return;
        const modKey = mac ? e.metaKey : e.ctrlKey;
        if (!modKey || e.code !== 'KeyA' || e.shiftKey) return;
        const elementSelection = (0, $glugJ.ElementSelection).fromWindow();
        const isInput = e.target?.matches?.('input');
        if (elementSelection.eq(caught.current) || isInput) {
            fireAnalyticsEvent({
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                action: (0, $bMFKb.ACTION).SELECT_ALL_ESCAPED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).RENDERER
            });
            return;
        }
        if (elementSelection.inside(el) || elementSelection.type === 'None' && clicked.current) {
            fireAnalyticsEvent({
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                action: (0, $bMFKb.ACTION).SELECT_ALL_CAUGHT,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).RENDERER
            });
            e.preventDefault();
            caught.current = elementSelection.select(el);
        }
    }, [
        mac,
        ref,
        fireAnalyticsEvent,
        clicked,
        caught
    ]);
    const onClick = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((e)=>{
        clicked.current = ref.current?.contains(e.target) ?? false;
    }, [
        ref,
        clicked
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('keydown', onKeyDown);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('click', onClick);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('keydown', onKeyDown);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('click', onClick);
        };
    }, [
        onKeyDown,
        onClick
    ]);
    return ref;
};

});
parcelRegister("bdjbf", function(module, exports) {
$parcel$export(module.exports, "default", () => $6bb290c2d9dd1319$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $6bb290c2d9dd1319$var$AnalyticsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext({
    fireAnalyticsEvent: (_event)=>null
});
var $6bb290c2d9dd1319$export$2e2bcd8739ae039 = $6bb290c2d9dd1319$var$AnalyticsContext;

});

parcelRegister("glugJ", function(module, exports) {
$parcel$export(module.exports, "ElementSelection", () => $7062a901fb1935c9$export$6e6724d89f27411);
class $7062a901fb1935c9$export$6e6724d89f27411 {
    constructor(selection){
        this.type = selection ? selection.type : 'None';
        if (selection && this.type !== 'None') this.range = selection.getRangeAt(0);
    }
    eq(selection) {
        if (!selection) return false;
        if (this.range && selection.range) {
            const startMatches = this.range?.compareBoundaryPoints(Range.START_TO_START, selection.range) === 0;
            const endMatches = this.range?.compareBoundaryPoints(Range.END_TO_END, selection.range) === 0;
            return startMatches && endMatches;
        }
        return this.type === 'None' && selection.type === 'None';
    }
    inside(el) {
        return el.contains(this.range?.commonAncestorContainer ?? null);
    }
    select(el) {
        const range = document.createRange();
        range.selectNodeContents(el);
        const selection = window.getSelection();
        if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
        }
        return $7062a901fb1935c9$export$6e6724d89f27411.fromWindow();
    }
    static fromWindow(win = window) {
        return new $7062a901fb1935c9$export$6e6724d89f27411(win.getSelection());
    }
}

});



parcelRegister("3OwO2", function(module, exports) {
$parcel$export(module.exports, "default", () => $79b328dc1583078f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $79b328dc1583078f$var$HardBreak = ({ forceNewLine: forceNewLine = false })=>{
    // To display an empty line using Shift+Enter, ProseMirror inserts a
    // double <br>. The second <br> is not part of the document, it's just
    // there to make browsers behave properly. The forceNewLine prop in this
    // component replicates this behaviour. If the last child node is a
    // hardBreak, it will also insert a double <br>.
    if (forceNewLine) return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("br", {}),
            /*#__PURE__*/ (0, $gt9Am.jsx)("br", {})
        ]
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("br", {});
};
var $79b328dc1583078f$export$2e2bcd8739ae039 = $79b328dc1583078f$var$HardBreak;

});

parcelRegister("5v0qs", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e0bf67c244646d3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6fs4r = parcelRequire("6fs4r");

var $2QO3b = parcelRequire("2QO3b");

var $bMFKb = parcelRequire("bMFKb");

var $bdjbf = parcelRequire("bdjbf");

var $hhRpb = parcelRequire("hhRpb");

var $a6S67 = parcelRequire("a6S67");
const $9e0bf67c244646d3$var$getCurrentUrlWithHash = (hash = '')=>{
    const url = new URL(window.location.href);
    url.search = ''; // clear any query params so that the page will correctly scroll to the anchor
    url.hash = encodeURIComponent(hash);
    return url.href;
};
function $9e0bf67c244646d3$var$hasRightAlignmentMark(marks) {
    if (!marks || !marks.length) return false;
    return marks.some((mark)=>mark.type.name === 'alignment' && mark.attrs.align === 'end');
}
function $9e0bf67c244646d3$var$WrappedHeadingAnchor({ enableNestedHeaderLinks: enableNestedHeaderLinks, level: level, headingId: headingId, hideFromScreenReader: hideFromScreenReader }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bdjbf.default).Consumer, {
        children: ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $a6S67.default), {
                enableNestedHeaderLinks: enableNestedHeaderLinks,
                level: level,
                onCopyText: ()=>{
                    fireAnalyticsEvent({
                        action: (0, $bMFKb.ACTION).CLICKED,
                        actionSubject: (0, $bMFKb.ACTION_SUBJECT).BUTTON,
                        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).HEADING_ANCHOR_LINK,
                        eventType: (0, $bMFKb.EVENT_TYPE).UI
                    });
                    return (0, $hhRpb.copyTextToClipboard)($9e0bf67c244646d3$var$getCurrentUrlWithHash(headingId));
                },
                hideFromScreenReader: hideFromScreenReader,
                headingId: headingId
            })
    });
}
function $9e0bf67c244646d3$var$Heading(props) {
    const { headingId: headingId, dataAttributes: dataAttributes, allowHeadingAnchorLinks: allowHeadingAnchorLinks, marks: marks, invisible: invisible, localId: localId } = props;
    const HX = `h${props.level}`;
    const mouseEntered = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(false);
    const showAnchorLink = !!props.showAnchorLink;
    const isRightAligned = $9e0bf67c244646d3$var$hasRightAlignmentMark(marks);
    const enableNestedHeaderLinks = allowHeadingAnchorLinks && allowHeadingAnchorLinks.allowNestedHeaderLinks;
    const headingIdToUse = invisible ? undefined : headingId;
    const mouseEnterHandler = ()=>{
        if (showAnchorLink && !mouseEntered.current) {
            // Abort TTVC calculation when the mouse hovers over heading. Hovering over
            // heading render heading anchor and inline comment buttons. These user-induced
            // DOM changes are valid reasons to abort the TTVC calculation.
            (0, $2QO3b.abortAll)('new_interaction');
            mouseEntered.current = true;
        }
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)(HX, {
                id: headingIdToUse,
                "data-local-id": localId,
                "data-renderer-start-pos": dataAttributes['data-renderer-start-pos'],
                onMouseEnter: mouseEnterHandler,
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                    children: [
                        showAnchorLink && headingId && isRightAligned && /*#__PURE__*/ (0, $gt9Am.jsx)($9e0bf67c244646d3$var$WrappedHeadingAnchor, {
                            level: props.level,
                            enableNestedHeaderLinks: enableNestedHeaderLinks,
                            headingId: headingId,
                            hideFromScreenReader: true
                        }),
                        props.children,
                        showAnchorLink && headingId && !isRightAligned && /*#__PURE__*/ (0, $gt9Am.jsx)($9e0bf67c244646d3$var$WrappedHeadingAnchor, {
                            level: props.level,
                            enableNestedHeaderLinks: enableNestedHeaderLinks,
                            headingId: headingId,
                            hideFromScreenReader: true
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6fs4r.default), {
                testId: "visually-hidden-heading-anchor",
                children: showAnchorLink && headingId && /*#__PURE__*/ (0, $gt9Am.jsx)($9e0bf67c244646d3$var$WrappedHeadingAnchor, {
                    level: props.level,
                    enableNestedHeaderLinks: enableNestedHeaderLinks,
                    headingId: headingId
                })
            })
        ]
    });
}
var $9e0bf67c244646d3$export$2e2bcd8739ae039 = $9e0bf67c244646d3$var$Heading;

});
parcelRegister("hhRpb", function(module, exports) {
$parcel$export(module.exports, "copyTextToClipboard", () => $da1385cd7c8ce6e7$export$f980440e1ab4537d);
const $da1385cd7c8ce6e7$export$f980440e1ab4537d = (text)=>new Promise((resolve, reject)=>{
        const isApiSupported = !!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
        if (isApiSupported) navigator.clipboard.writeText(text).then(()=>resolve(), (e)=>reject(e));
        else reject('Clipboard API is not supported');
    });

});

parcelRegister("a6S67", function(module, exports) {
$parcel$export(module.exports, "HeadingAnchorWrapperClassName", () => $b1e1c8f0f51f3fcd$export$3c9cedc52604835d);
$parcel$export(module.exports, "default", () => $b1e1c8f0f51f3fcd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");

var $av9Of = parcelRequire("av9Of");

var $k71qx = parcelRequire("k71qx");

var $4Iw1X = parcelRequire("4Iw1X");
function $b1e1c8f0f51f3fcd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b1e1c8f0f51f3fcd$export$3c9cedc52604835d = 'heading-anchor-wrapper';
const $b1e1c8f0f51f3fcd$var$CopyAnchorWrapperWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $b1e1c8f0f51f3fcd$export$3c9cedc52604835d,
        ref: ref
    }, children);
});
const $b1e1c8f0f51f3fcd$var$copyAnchorButtonStyles = {
    name: "vhh4ux",
    styles: "display:inline;outline:none;background-color:transparent;border:none;color:var(--ds-icon, #44546F);cursor:pointer;right:0"
};
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $b1e1c8f0f51f3fcd$var$HeadingAnchor extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    componentDidMount() {
        this.resetMessage();
    }
    render() {
        const { tooltipMessage: tooltipMessage } = this.state;
        if (tooltipMessage) // We set the key to the message to ensure it remounts when the message
        // changes, so that it correctly repositions.
        // @see https://ecosystem.atlassian.net/projects/AK/queues/issue/AK-6548
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k71qx.default), {
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            tag: $b1e1c8f0f51f3fcd$var$CopyAnchorWrapperWithRef,
            content: tooltipMessage,
            position: "top",
            delay: 0,
            key: tooltipMessage
        }, this.renderAnchorButton());
        return this.renderAnchorButton();
    }
    constructor(...args){
        super(...args), this.state = {
            tooltipMessage: '',
            isClicked: false
        }, this.setTooltipState = (message, isClicked = false)=>{
            this.setState({
                // TODO: ED-14403 - investigate why this does not translate
                tooltipMessage: this.props.intl.formatMessage(message),
                isClicked: isClicked
            });
        }, this.getCopyAriaLabel = ()=>{
            const { copyAriaLabel: copyAriaLabel } = (0, $4Iw1X.headingAnchorLinkMessages);
            return this.props.intl.formatMessage(copyAriaLabel);
        }, this.copyToClipboard = async (event)=>{
            const { copiedHeadingLinkToClipboard: copiedHeadingLinkToClipboard, failedToCopyHeadingLink: failedToCopyHeadingLink } = (0, $4Iw1X.headingAnchorLinkMessages);
            event.stopPropagation();
            try {
                await this.props.onCopyText();
                this.setTooltipState(copiedHeadingLinkToClipboard, true);
            } catch (e) {
                this.setTooltipState(failedToCopyHeadingLink);
            }
        }, this.resetMessage = ()=>{
            this.setTooltipState((0, $4Iw1X.headingAnchorLinkMessages).copyHeadingLinkToClipboard);
        }, this.renderAnchorButton = ()=>{
            const { hideFromScreenReader: hideFromScreenReader = false, headingId: headingId } = this.props;
            return /*#__PURE__*/ (0, $1NIU8.jsx)("button", {
                "data-testid": "anchor-button",
                css: $b1e1c8f0f51f3fcd$var$copyAnchorButtonStyles,
                // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
                onMouseLeave: this.resetMessage,
                onClick: this.copyToClipboard,
                "aria-hidden": hideFromScreenReader,
                tabIndex: hideFromScreenReader ? undefined : -1,
                "aria-label": hideFromScreenReader ? undefined : this.state.tooltipMessage,
                "aria-labelledby": hideFromScreenReader ? undefined : headingId,
                type: "button"
            }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
                label: this.getCopyAriaLabel(),
                LEGACY_size: this.props.level > 3 ? 'small' : 'medium',
                color: this.state.isClicked ? "var(--ds-icon-selected, #0C66E4)" : "var(--ds-icon-subtle, #626F86)"
            }));
        };
    }
}
var $b1e1c8f0f51f3fcd$export$2e2bcd8739ae039 = (0, $6YFG2.default)($b1e1c8f0f51f3fcd$var$HeadingAnchor);

});
parcelRegister("av9Of", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c7207a1a192d06bb66aba669d57a8645>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7a54689236011148$var$_react = $7a54689236011148$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7a54689236011148$var$_link = $7a54689236011148$var$_interopRequireDefault((parcelRequire("cV8sz")));

var $7a54689236011148$var$_link2 = $7a54689236011148$var$_interopRequireDefault((parcelRequire("a2o1i")));
function $7a54689236011148$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "LinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7a54689236011148$var$LinkIcon = (props)=>/*#__PURE__*/ $7a54689236011148$var$_react.default.createElement($7a54689236011148$var$_link.default, Object.assign({
        name: "LinkIcon",
        LEGACY_fallbackIcon: $7a54689236011148$var$_link2.default
    }, props));
$7a54689236011148$var$LinkIcon.displayName = 'LinkIconMigration';
var $7a54689236011148$var$_default = module.exports.default = $7a54689236011148$var$LinkIcon;

});
parcelRegister("cV8sz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f51e3026bdf0966f56fca36d1a42e0f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $96815ed7645c21ae$var$_react = $96815ed7645c21ae$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $96815ed7645c21ae$var$_baseNew = $96815ed7645c21ae$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $96815ed7645c21ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $96815ed7645c21ae$var$LinkIcon = (props)=>/*#__PURE__*/ $96815ed7645c21ae$var$_react.default.createElement($96815ed7645c21ae$var$_baseNew.default, Object.assign({
        name: "LinkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$96815ed7645c21ae$var$LinkIcon.displayName = 'LinkIcon';
var $96815ed7645c21ae$var$_default = module.exports.default = $96815ed7645c21ae$var$LinkIcon;

});


parcelRegister("4Iw1X", function(module, exports) {
$parcel$export(module.exports, "headingAnchorLinkMessages", () => $552b6cd9c26dd6f0$export$74bada844422036d);
$parcel$export(module.exports, "tableCellMessages", () => $552b6cd9c26dd6f0$export$c79ebc36348824d1);
$parcel$export(module.exports, "inlineCommentMessages", () => $552b6cd9c26dd6f0$export$9f52c375a6ef34fc);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $7qGN1 = parcelRequire("7qGN1");
const $552b6cd9c26dd6f0$export$74bada844422036d = (0, $7qGN1.defineMessages)({
    copyHeadingLinkToClipboard: {
        id: 'fabric.editor.headingLink.copyAnchorLink',
        defaultMessage: 'Copy link to heading',
        description: 'Copy heading link to clipboard'
    },
    copiedHeadingLinkToClipboard: {
        id: 'fabric.editor.headingLink.copied',
        defaultMessage: 'Copied!',
        description: 'Copied heading link to clipboard'
    },
    failedToCopyHeadingLink: {
        id: 'fabric.editor.headingLink.failedToCopy',
        defaultMessage: 'Copy failed',
        description: 'failed to copy heading link to clipboard'
    },
    copyAriaLabel: {
        id: 'fabric.editor.headingLink.copyAriaLabel',
        defaultMessage: 'Copy',
        description: 'copy aria label for link icon'
    }
});
const $552b6cd9c26dd6f0$export$c79ebc36348824d1 = (0, $7qGN1.defineMessages)({
    noneSortingLabel: {
        id: 'fabric.editor.headingLink.noneSortingLabel',
        defaultMessage: 'none',
        description: 'this table column is not sorted'
    },
    ascSortingLabel: {
        id: 'fabric.editor.headingLink.ascSortingLabel',
        defaultMessage: 'ascending',
        description: 'this table column is sorted in ascending order'
    },
    descSortingLabel: {
        id: 'fabric.editor.headingLink.descSortingLabel',
        defaultMessage: 'descending',
        description: 'this table column is sorted in descending order'
    }
});
const $552b6cd9c26dd6f0$export$9f52c375a6ef34fc = (0, $7qGN1.defineMessages)({
    contentRendererInlineCommentMarkerStart: {
        id: 'fabric.editor.inlineComment.marker.start',
        defaultMessage: 'inline comment start',
        description: 'Starting marker to indicate that text is highlighted with an inline comment by a screen reader.'
    },
    contentRendererInlineCommentMarkerEnd: {
        id: 'fabric.editor.inlineComment.marker.end',
        defaultMessage: 'inline comment end',
        description: 'Ending marker to indicate that text was highlighted with an inline comment by a screen reader.'
    }
});

});



parcelRegister("dnybp", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5d377e74d822dd2$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $cZRB0 = parcelRequire("cZRB0");
const $f5d377e74d822dd2$var$InlineExtension = (props)=>{
    const { text: text } = props;
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cZRB0.default), {
        ...props,
        type: "inlineExtension",
        children: ({ result: result })=>{
            try {
                // Return the result directly if it's a valid JSX.Element
                if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(result)) return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                    children: result
                });
            } catch (e) {
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
            // Always return default content if anything goes wrong
            return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                children: text || 'inlineExtension'
            });
        }
    }));
};
var $f5d377e74d822dd2$export$2e2bcd8739ae039 = $f5d377e74d822dd2$var$InlineExtension;

});

parcelRegister("j3a3j", function(module, exports) {
$parcel$export(module.exports, "default", () => $667d38b36abe6e31$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $92xoS = parcelRequire("92xoS");
function $667d38b36abe6e31$export$2e2bcd8739ae039(props) {
    return (0, $92xoS.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: "layout-section-container",
        "data-local-id": props.localId,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-layout-section": true,
            "data-layout-columns": props?.content?.length,
            children: props.children
        })
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-layout-section": true,
        "data-local-id": props.localId,
        children: props.children
    });
}

});

parcelRegister("5YAb6", function(module, exports) {
$parcel$export(module.exports, "default", () => $1aad786176e81e67$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $2bEPZ = parcelRequire("2bEPZ");

var $eGOwo = parcelRequire("eGOwo");
function $1aad786176e81e67$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// localized styles, was from clearNextSiblingMarginTopStyle in @atlaskit/editor-common/ui
const $1aad786176e81e67$var$clearNextSiblingMarginTopStyle = {
    name: "1f3w791",
    styles: "& + *{margin-top:0 !important;}"
};
const $1aad786176e81e67$var$multipleWrappedImagesStyle = {
    name: "y2yz5o",
    styles: "& [class*=\"image-wrap-\"] + [class*=\"image-wrap-\"], & [class*=\"image-wrap-\"]:has( + [class*=\"image-wrap-\"]){margin-top:0;}"
};
// localized styles, was from clearNextSiblingBlockMarkMarginTopStyle in @atlaskit/editor-common/ui
const $1aad786176e81e67$var$clearNextSiblingBlockMarkMarginTopStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`+ .fabric-editor-block-mark > p,
	  + .fabric-editor-block-mark > h1,
	  + .fabric-editor-block-mark > h2,
	  + .fabric-editor-block-mark > h3,
	  + .fabric-editor-block-mark > h4,
	  + .fabric-editor-block-mark > h5,
	  + .fabric-editor-block-mark > h6
	`]: {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: '0 !important'
    }
});
function $1aad786176e81e67$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        "data-layout-column": true,
        "data-column-width": props.width,
        style: {
            flexBasis: `${props.width}%`
        },
        css: (0, $eGOwo.fg)('platform_editor_fix_media_in_renderer') && $1aad786176e81e67$var$multipleWrappedImagesStyle
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $2bEPZ.WidthProvider), null, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            $1aad786176e81e67$var$clearNextSiblingMarginTopStyle,
            $1aad786176e81e67$var$clearNextSiblingBlockMarkMarginTopStyle
        ]
    }), props.children));
}

});

parcelRegister("lLYaS", function(module, exports) {
$parcel$export(module.exports, "default", () => $681d17e16eed1ca4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
function $681d17e16eed1ca4$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("li", {
        children: props.children
    });
}

});

parcelRegister("9WY2n", function(module, exports) {
$parcel$export(module.exports, "default", () => $e1daed5b0ad27c08$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $dKDe7 = parcelRequire("dKDe7");
const $e1daed5b0ad27c08$var$RenderCaption = ({ children: children, dataAttributes: dataAttributes })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dKDe7.default), {
        hasContent: true,
        dataAttributes: dataAttributes,
        children: children
    });
};
var $e1daed5b0ad27c08$export$2e2bcd8739ae039 = $e1daed5b0ad27c08$var$RenderCaption;

});
parcelRegister("dKDe7", function(module, exports) {
$parcel$export(module.exports, "default", () => $d97783cd2ad3e478$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $hr4HX = parcelRequire("hr4HX");
function $d97783cd2ad3e478$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d97783cd2ad3e478$var$captionWrapperStyle = {
    name: "1f0iwez",
    styles: "margin-top:var(--ds-space-100, 8px);text-align:center;position:relative;color:var(--ds-text-subtle, #44546F)"
};
const $d97783cd2ad3e478$var$placeholderStyle = (0, $1DXK0.xcss)({
    color: 'color.text.subtlest',
    position: 'absolute',
    top: 'space.0',
    width: '100%'
});
class $d97783cd2ad3e478$export$f7feb87190a94c76 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { selected: selected, hasContent: hasContent, children: children, dataAttributes: dataAttributes, intl: { formatMessage: formatMessage } } = this.props;
        const showPlaceholder = !selected && !hasContent;
        return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            "data-media-caption": true,
            "data-testid": "media-caption",
            ...dataAttributes,
            css: $d97783cd2ad3e478$var$captionWrapperStyle
        }, showPlaceholder ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8nu6j.default), {
            xcss: $d97783cd2ad3e478$var$placeholderStyle
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $5qJVF.default), null, formatMessage((0, $hr4HX.messages).placeholder))) : null, children);
    }
}
var $d97783cd2ad3e478$export$2e2bcd8739ae039 = (0, $6YFG2.default)($d97783cd2ad3e478$export$f7feb87190a94c76);

});
parcelRegister("hr4HX", function(module, exports) {
$parcel$export(module.exports, "messages", () => $9bc70266f7559b7d$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $9bc70266f7559b7d$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    placeholder: {
        id: 'fabric.editor.captionPlaceholder',
        defaultMessage: 'Add a caption',
        description: 'Placeholder description for an empty (new) caption in the editor'
    }
});

});



parcelRegister("fF9eS", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a507d0ec54be88c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $a4ifE = parcelRequire("a4ifE");

var $kvnqO = parcelRequire("kvnqO");

var $fCXIH = parcelRequire("fCXIH");

var $iCTcU = parcelRequire("iCTcU");
function $2a507d0ec54be88c$export$2e2bcd8739ae039(props) {
    const extraProps = {};
    const itemCounterDigitsSize = (0, $fCXIH.getItemCounterDigitsSize)({
        order: props.order,
        itemsCount: props?.content?.length
    });
    if (itemCounterDigitsSize && itemCounterDigitsSize > 1) extraProps.style = (0, $kvnqO.getOrderedListInlineStyles)(itemCounterDigitsSize, 'object');
    if (props.order !== undefined) extraProps.start = (0, $fCXIH.resolveOrder)(props.order);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("ol", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $a4ifE.orderedListSelector).substr(1),
        "data-local-id": props.localId,
        "data-indent-level": props.path ? (0, $iCTcU.getListIndentLevel)(props.path) : 1,
        start: props.start,
        ...extraProps,
        children: props.children
    });
}

});
parcelRegister("kvnqO", function(module, exports) {
$parcel$export(module.exports, "listItemCounterPadding", () => $042d28d65fee5e06$export$bafd6beec0797f87);
$parcel$export(module.exports, "getOrderedListInlineStyles", () => $042d28d65fee5e06$export$6d31fdb1d74cee3e);
const $042d28d65fee5e06$export$bafd6beec0797f87 = 24;
var $042d28d65fee5e06$var$CSS_VAR_NAMES = /*#__PURE__*/ function(CSS_VAR_NAMES) {
    CSS_VAR_NAMES["ITEM_COUNTER_PADDING"] = "--ed--list--item-counter--padding";
    return CSS_VAR_NAMES;
}($042d28d65fee5e06$var$CSS_VAR_NAMES || {});
const $042d28d65fee5e06$var$getItemCounterLeftPadding = (itemCounterDigitsSize)=>{
    // Previous padding-left was approximately 24px. We approximate that
    // same value using "ch" units (which represent the width of a "0" digit
    // character). We use "ch" so that this computed padding can now grow if
    //  the font-size ever enlarges.
    let paddingLeft = `2.385ch`;
    if (itemCounterDigitsSize >= 2) {
        // When there are 2 or more digits, we use a combination of "ch" units and
        // pixel values so that while the computed padding grows if font-size ever
        // enlarges, it doesn't over-scale with each digit (because of the fixed pixel
        // portion of the computed value). This way, very large item counters will not
        // become overly left-padded.
        const fixedBasePx = 2;
        paddingLeft = `calc(${itemCounterDigitsSize + 1}ch - ${fixedBasePx}px)`;
    }
    return paddingLeft;
};
const $042d28d65fee5e06$var$stringifyStyle = (style)=>Object.entries(style).reduce((str, [key, value])=>`${str}${key}:${value};`, ``);
function $042d28d65fee5e06$export$6d31fdb1d74cee3e(itemCounterDigitsSize, styleFormat) {
    const style = {
        ["--ed--list--item-counter--padding"]: $042d28d65fee5e06$var$getItemCounterLeftPadding(itemCounterDigitsSize)
    };
    if (styleFormat === 'string') return $042d28d65fee5e06$var$stringifyStyle(style);
    return style;
}

});

parcelRegister("fCXIH", function(module, exports) {
$parcel$export(module.exports, "resolveOrder", () => $8408b0ba796dc38c$export$d445360e2a3c026b);
$parcel$export(module.exports, "getOrderFromOrderedListNode", () => $8408b0ba796dc38c$export$cbefb5b89ef0719f);
$parcel$export(module.exports, "getItemCounterDigitsSize", () => $8408b0ba796dc38c$export$320582fc14ba1e0f);
$parcel$export(module.exports, "isListNode", () => $8408b0ba796dc38c$export$a7d7d2b9ba4d4dbb);
$parcel$export(module.exports, "isParagraphNode", () => $8408b0ba796dc38c$export$35f600abfe6f0127);
$parcel$export(module.exports, "isListItemNode", () => $8408b0ba796dc38c$export$2ddb0a75547407f6);
$parcel$export(module.exports, "isBulletList", () => $8408b0ba796dc38c$export$35b2f400604e700);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/prosemirror-transformer/utils/list.ts
// If changes are made to this file, please make the same update in the linked file.
const $8408b0ba796dc38c$export$8ef94ae42a3729bd = 1;
const $8408b0ba796dc38c$export$d445360e2a3c026b = (order)=>{
    const num = Number(order);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $8408b0ba796dc38c$export$cbefb5b89ef0719f = (orderedListNode)=>{
    const order = orderedListNode?.attrs?.order;
    return $8408b0ba796dc38c$export$d445360e2a3c026b(order) ?? $8408b0ba796dc38c$export$8ef94ae42a3729bd;
};
const $8408b0ba796dc38c$export$320582fc14ba1e0f = (options)=>{
    const order = $8408b0ba796dc38c$export$d445360e2a3c026b(options.order) ?? $8408b0ba796dc38c$export$8ef94ae42a3729bd;
    const itemsCount = typeof options.itemsCount === 'number' ? options.itemsCount : 0;
    const largestCounter = order + (itemsCount - 1);
    return String(largestCounter)?.split('.')?.[0]?.length;
};
function $8408b0ba796dc38c$export$a7d7d2b9ba4d4dbb(node) {
    return Boolean(node && node.type && [
        'orderedList',
        'bulletList'
    ].includes(node.type.name));
}
function $8408b0ba796dc38c$export$35f600abfe6f0127(node) {
    return Boolean(node && node.type && 'paragraph' === node.type.name);
}
function $8408b0ba796dc38c$export$2ddb0a75547407f6(node) {
    return Boolean(node && node.type && 'listItem' === node.type.name);
}
function $8408b0ba796dc38c$export$35b2f400604e700(node) {
    return Boolean(node && node.type && 'bulletList' === node.type.name);
}

});


parcelRegister("lwXex", function(module, exports) {
$parcel$export(module.exports, "default", () => $c8bd68a40fee5900$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $22Lfi = parcelRequire("22Lfi");
function $c8bd68a40fee5900$export$2e2bcd8739ae039({ children: children, dataAttributes: dataAttributes, localId: localId }) {
    return(// ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, $gt9Am.jsx)("p", {
        ...dataAttributes,
        "data-local-id": localId,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $22Lfi.default), {
            children: children
        })
    }));
}

});
parcelRegister("22Lfi", function(module, exports) {
$parcel$export(module.exports, "default", () => $412e5af08bbe0159$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $412e5af08bbe0159$export$2e2bcd8739ae039(props) {
    const { children: children } = props;
    const childCount = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children).length;
    if (!childCount) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: "\xa0"
    });
    return children;
}

});


parcelRegister("gtUUa", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ab3bdba2518f19c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
function $3ab3bdba2518f19c$export$2e2bcd8739ae039(props) {
    if (props.allowPlaceholderText) return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-placeholder": `${props.text}`,
        children: props.text
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {});
}

});

parcelRegister("aYUex", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ce23554b9f83dab$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
function $8ce23554b9f83dab$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("hr", {
        role: "presentation"
    });
}

});

parcelRegister("idsFq", function(module, exports) {
$parcel$export(module.exports, "isTableResizingEnabled", () => $4ae183b0f220a464$export$eec82c0a93aa66d9);
$parcel$export(module.exports, "isStickyScrollbarEnabled", () => $4ae183b0f220a464$export$bdb2dadcb04aad50);
$parcel$export(module.exports, "default", () => $4ae183b0f220a464$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $cjLtO = parcelRequire("cjLtO");

var $fJeGS = parcelRequire("fJeGS");

var $k6yTf = parcelRequire("k6yTf");
var $2bEPZ = parcelRequire("2bEPZ");

var $eGOwo = parcelRequire("eGOwo");

var $d3BBj = parcelRequire("d3BBj");
var $bTpHi = parcelRequire("bTpHi");
var $gikGJ = parcelRequire("gikGJ");

var $hh2CV = parcelRequire("hh2CV");

var $7yBx7 = parcelRequire("7yBx7");

var $68RqK = parcelRequire("68RqK");

var $92xoS = parcelRequire("92xoS");


var $lzf9g = parcelRequire("lzf9g");

var $dZ1mQ = parcelRequire("dZ1mQ");

var $177xQ = parcelRequire("177xQ");

var $hpXI5 = parcelRequire("hpXI5");

var $3xZmi = parcelRequire("3xZmi");

var $hxOCd = parcelRequire("hxOCd");

var $eOVsb = parcelRequire("eOVsb");
const $4ae183b0f220a464$export$eec82c0a93aa66d9 = (appearance)=>(0, $3xZmi.isFullWidthOrFullPageAppearance)(appearance) || (0, $3xZmi.isCommentAppearance)(appearance) && (0, $92xoS.editorExperiment)('support_table_in_comment', true, {
        exposure: true
    });
const $4ae183b0f220a464$export$bdb2dadcb04aad50 = (appearance)=>(0, $3xZmi.isFullWidthOrFullPageAppearance)(appearance) && (0, $92xoS.editorExperiment)('platform_renderer_table_sticky_scrollbar', true, {
        exposure: true
    });
const $4ae183b0f220a464$export$334894231c46c1a5 = (children, tableNode, smartCardStorage, tableOrderStatus)=>{
    if (!tableOrderStatus || tableOrderStatus.order === (0, $hh2CV.SortOrder).NO_ORDER) return children;
    const { order: order, columnIndex: columnIndex } = tableOrderStatus;
    const compareNodesInOrder = (0, $gikGJ.createCompareNodes)({
        getInlineCardTextFromStore (attrs) {
            const { url: url } = attrs;
            if (!url) return null;
            return smartCardStorage.get(url) || null;
        }
    }, order);
    const tableArray = (0, $bTpHi.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    const tableArrayWithChildren = tableArray.map((rowNodes, index)=>({
            rowNodes: rowNodes,
            rowReact: children[index]
        }));
    const headerRow = tableArrayWithChildren.shift();
    const sortedTable = tableArrayWithChildren.sort((rowA, rowB)=>compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]));
    if (headerRow) sortedTable.unshift(headerRow);
    return sortedTable.map((elem)=>elem.rowReact);
};
const $4ae183b0f220a464$export$42f5658c8e0092da = (row)=>{
    let hasRowspan = false;
    row.forEach((cell)=>hasRowspan = hasRowspan || cell.attrs.rowspan > 1);
    return hasRowspan;
};
const $4ae183b0f220a464$export$f422245984b0eda7 = (refElement)=>{
    return Math.round(refElement.getBoundingClientRect().top);
};
const $4ae183b0f220a464$export$7c141112f3c89f11 = (scrollTop, tableTop, tableBottom, rowHeight)=>tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
const $4ae183b0f220a464$export$89f3188e1adc30d5 = (scrollTop, tableBottom, rowHeight)=>tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
const $4ae183b0f220a464$export$100baa0f10804e6e = (rows, tableOrderStatus, onSorting)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(rows, (row, index)=>{
        if (index === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.only(row), {
            tableOrderStatus: tableOrderStatus,
            onSorting: onSorting
        });
        return row;
    });
};
const $4ae183b0f220a464$export$28daf78feed5098c = (rows)=>{
    if (!rows.length) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { children: children } = rows[0].props;
    if (!children.length) return false;
    if (children.length === 1) return children[0].type === (0, $lzf9g.TableHeader);
    return children.every((node)=>node.type === (0, $lzf9g.TableHeader));
};
/**
 * This TableWrapper component was created to make sure that the aria-label can be
 * internationalized without needing to add `intl` to the TableContainer.
 *
 * @param {TableWrapperProps} root0 - The props object.
 * @param {React.ReactNode} root0.children - The table content to render inside the wrapper.
 * @param {React.RefObject<HTMLDivElement>} root0.wrapperRef - Ref to the wrapper div element.
 * @param {(() => void) | undefined} root0.onScroll - Optional scroll event handler.
 * @param {StickyHeaderConfig | undefined} root0.stickyHeaders - Optional sticky header configuration.
 * @returns The rendered table wrapper component.
 * @example
 * <TableWrapper wrapperRef={ref} onScroll={handleScroll} stickyHeaders={config}>
 *   <Table>...</Table>
 * </TableWrapper>
 */ const $4ae183b0f220a464$var$TableWrapper = ({ children: children, wrapperRef: wrapperRef, onScroll: onScroll, stickyHeaders: stickyHeaders })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $cjLtO.TableSharedCssClassName).TABLE_NODE_WRAPPER,
        ref: wrapperRef,
        onScroll: stickyHeaders ? onScroll : undefined,
        // Adding tabIndex here because this is a scrollable container and it needs to be focusable so keyboard users can scroll it.
        // eslint-disable-next-line @atlassian/a11y/no-noninteractive-tabindex
        tabIndex: 0,
        role: "region",
        "aria-label": formatMessage((0, $fJeGS.messages).tableScrollRegion),
        children: children
    });
};
const $4ae183b0f220a464$export$940095e914312886 = (node, children)=>{
    return $4ae183b0f220a464$export$28daf78feed5098c(children) && node && node.firstChild && !$4ae183b0f220a464$export$42f5658c8e0092da(node.firstChild);
};
class $4ae183b0f220a464$export$f2c3aea42b2a048f extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    /**
   *
   * @example
   */ componentDidMount() {
        this.resizeObserver = new ResizeObserver(this.applyResizerChange);
        if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
        if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
        if (this.props.stickyHeaders) {
            this.overflowParent = (0, $177xQ.OverflowParent).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.addEventListener('scroll', this.onScroll);
        }
        if (this.wrapperRef.current && $4ae183b0f220a464$export$bdb2dadcb04aad50(this.props.rendererAppearance)) this.stickyScrollbar = new (0, $hxOCd.TableStickyScrollbar)(this.wrapperRef.current);
    }
    /**
   *
   * @param prevProps
   * @param prevState
   * @example
   */ componentDidUpdate(prevProps, prevState) {
        // toggling sticky headers visiblity
        if (this.props.stickyHeaders && !this.overflowParent) this.overflowParent = (0, $177xQ.OverflowParent).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
        else if (!this.props.stickyHeaders && this.overflowParent) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            this.overflowParent = null;
        }
        // offsetTop might have changed, re-position sticky header
        if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
        // sync horizontal scroll in floating div when toggling modes
        if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
    }
    /**
   *
   */ get pinTop() {
        if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
        return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, $cjLtO.tableMarginTop) - (0, $177xQ.tableStickyPadding);
    }
    /**
   *
   */ get shouldAddOverflowParentOffsetTop_DO_NOT_USE() {
        // IF the StickyHeaderConfig specifies that the default scroll root offsetTop should be added
        // AND the StickyHeaderConfig specifies a default scroll root id
        // AND the OverflowParent is the corresponding element
        // THEN we should add the OverflowParent offset top (RETURN TRUE)
        return this.props.stickyHeaders && !!this.props.stickyHeaders.shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE && !!this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE && this.overflowParent && this.overflowParent.id === this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE;
    }
    /**
   *
   */ get stickyTop() {
        switch(this.state.stickyMode){
            case 'pin-bottom':
                return this.pinTop;
            case 'stick':
                const offsetTop = this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
                if (typeof offsetTop === 'number' && this.shouldAddOverflowParentOffsetTop_DO_NOT_USE) {
                    const overflowParentOffsetTop = this.overflowParent ? this.overflowParent.top : 0;
                    return offsetTop + overflowParentOffsetTop;
                } else return offsetTop;
            default:
                return undefined;
        }
    }
    /**
   *
   * @example
   */ render() {
        const { isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, renderWidth: renderWidth, columnWidths: columnWidths, stickyHeaders: stickyHeaders, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing, isPresentational: isPresentational } = this.props;
        const { stickyMode: stickyMode } = this.state;
        const lineLengthFixedWidth = (0, $7yBx7.akEditorDefaultLayoutWidth);
        let left;
        let updatedLayout;
        // The tableWidth and left offset logic below must stay aligned with the `breakout-ssr.tsx` logic
        // Please consider changes below carefully to not negatively impact SSR
        // `renderWidth` cannot be depended on during SSR
        const isRenderWidthValid = !!renderWidth && renderWidth > 0;
        const fullPageRendererWidthCSS = (0, $92xoS.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
            exposure: true
        }) ? 'calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)' : `100cqw - ${0, $9a762f515f769003$export$12fd658e5eef0d79}px * 2`;
        const renderWidthCSS = rendererAppearance === 'full-page' ? fullPageRendererWidthCSS : `100cqw`;
        const calcDefaultLayoutWidthByAppearance = (rendererAppearance, tableNode)=>{
            if (rendererAppearance === 'full-width' && !tableNode?.attrs.width) return [
                isRenderWidthValid ? Math.min((0, $7yBx7.akEditorFullWidthLayoutWidth), renderWidth) : (0, $7yBx7.akEditorFullWidthLayoutWidth),
                `min(${(0, $7yBx7.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`
            ];
            else if (rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width) {
                const tableContainerWidth = (0, $68RqK.getTableContainerWidth)(tableNode);
                return [
                    isRenderWidthValid ? renderWidth : tableContainerWidth,
                    renderWidthCSS
                ];
            } else {
                // custom width, or width mapped to breakpoint
                const tableContainerWidth = (0, $68RqK.getTableContainerWidth)(tableNode);
                return [
                    isRenderWidthValid ? Math.min(tableContainerWidth, renderWidth) : tableContainerWidth,
                    `min(${tableContainerWidth}px, ${renderWidthCSS})`
                ];
            }
        };
        const [tableWidth, tableWidthCSS] = calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode);
        // Logic for table alignment in renderer
        const isTableAlignStart = tableNode && tableNode.attrs && tableNode.attrs.layout === 'align-start' && allowTableAlignment;
        const fullWidthLineLength = isRenderWidthValid ? Math.min((0, $7yBx7.akEditorFullWidthLayoutWidth), renderWidth) : (0, $7yBx7.akEditorFullWidthLayoutWidth);
        const fullWidthLineLengthCSS = `min(${(0, $7yBx7.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const commentLineLength = isRenderWidthValid ? renderWidth : lineLengthFixedWidth;
        const isCommentAppearanceAndTableAlignmentEnabled = (0, $3xZmi.isCommentAppearance)(rendererAppearance) && allowTableAlignment;
        const lineLength = (0, $3xZmi.isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLength : isCommentAppearanceAndTableAlignmentEnabled ? commentLineLength : lineLengthFixedWidth;
        const lineLengthCSS = (0, $3xZmi.isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLengthCSS : isCommentAppearanceAndTableAlignmentEnabled ? renderWidthCSS : `${lineLengthFixedWidth}px`;
        // Setting fixTableSSRResizing to false while FG logic is true in tableNew
        const fixTableSSRResizing = false;
        const tableWidthNew = fixTableSSRResizing ? (0, $68RqK.getTableContainerWidth)(tableNode) : tableWidth;
        const shouldCalculateLeftForAlignment = !isInsideOfBlockNode && !isInsideOfTable && isTableAlignStart && ((0, $3xZmi.isFullPageAppearance)(rendererAppearance) && tableWidthNew <= lineLengthFixedWidth || (0, $3xZmi.isFullWidthAppearance)(rendererAppearance) || isCommentAppearanceAndTableAlignmentEnabled);
        let leftCSS;
        if (shouldCalculateLeftForAlignment) {
            left = (tableWidth - lineLength) / 2;
            leftCSS = `(${tableWidthCSS} - ${lineLengthCSS}) / 2`;
        }
        if (fixTableSSRResizing) {
            if (!shouldCalculateLeftForAlignment && (0, $3xZmi.isFullPageAppearance)(rendererAppearance)) // Note tableWidthCSS here is the renderer width
            // When the screen is super wide we want table to break out.
            // However if screen is smaller than 760px. We want table align to left.
            leftCSS = `min(0px, ${lineLengthCSS} - ${tableWidthCSS}) / 2`;
        } else if (!shouldCalculateLeftForAlignment && (0, $3xZmi.isFullPageAppearance)(rendererAppearance) && tableWidthNew > lineLengthFixedWidth) left = lineLengthFixedWidth / 2 - tableWidth / 2;
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(this.props.children);
        // Historically, tables in the full-width renderer had their layout set to 'default' which is deceiving.
        // This check caters for those tables and helps with SSR logic
        const isFullWidth = !tableNode?.attrs.width && rendererAppearance === 'full-width' && layout !== 'full-width';
        if (isFullWidth) updatedLayout = 'full-width';
        else if (tableNode?.attrs.width) updatedLayout = 'custom';
        else updatedLayout = layout;
        let finalTableContainerWidth = allowTableResizing ? tableWidthNew : 'inherit';
        // We can only use CSS to determine the width when we have a known width in container.
        // When appearance is full-page, full-width or comment we use CSS based width calculation.
        // Otherwise it's fixed table width (customized width) or inherit.
        if ((rendererAppearance === 'full-page' || rendererAppearance === 'full-width') && fixTableSSRResizing) finalTableContainerWidth = allowTableResizing ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && !allowTableAlignment) // If table alignment is disabled and table width is akEditorDefaultLayoutWidth = 760,
        // it is most likely a table created before "Support Table in Comments" FF was enabled
        // and we would see a bug ED-24795. A table created before "Support Table in Comments",
        // should inhirit the width of the renderer container.
        // !NOTE: it a table resized to 760 is copied from 'full-page' editor and pasted in comment editor
        // where (allowTableResizing && !allowTableAlignment), the table will loose 760px width.
        finalTableContainerWidth = tableNode?.attrs.width && tableNode?.attrs.width !== (0, $7yBx7.akEditorDefaultLayoutWidth) ? fixTableSSRResizing ? `calc(${tableWidthCSS})` : tableWidth : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && allowTableAlignment) // If table alignment is enabled and layout is not 'align-start' or 'center', we are loading a table that was
        // created before "Support Table in Comments" FF was enabled. So the table should have the same width as renderer container
        // instead of 760 that was set on tableNode when the table had been published.
        finalTableContainerWidth = (tableNode?.attrs.layout === 'align-start' || tableNode?.attrs.layout === 'center') && tableNode?.attrs.width ? fixTableSSRResizing ? `calc(${tableWidthCSS})` : tableWidth : 'inherit';
        let style;
        if (fixTableSSRResizing) style = {
            width: finalTableContainerWidth,
            left: leftCSS ? `calc(${leftCSS})` : undefined,
            marginLeft: shouldCalculateLeftForAlignment && leftCSS !== undefined ? `calc(-1 * (${leftCSS}))` : undefined
        };
        else style = {
            width: finalTableContainerWidth,
            left: left,
            marginLeft: shouldCalculateLeftForAlignment && left !== undefined ? -left : undefined
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER} ${this.props.shadowClassNames || ''}`,
                "data-layout": updatedLayout,
                ref: this.props.handleRef,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                children: [
                    $4ae183b0f220a464$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
                        "data-testid": "sticky-scrollbar-sentinel-top"
                    }),
                    stickyHeaders && $4ae183b0f220a464$export$940095e914312886(tableNode, children) && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $177xQ.StickyTable), {
                        isNumberColumnEnabled: isNumberColumnEnabled,
                        tableWidth: tableWidth,
                        layout: layout,
                        renderWidth: renderWidth,
                        handleRef: this.props.handleRef,
                        shadowClassNames: this.props.shadowClassNames,
                        top: this.stickyTop,
                        mode: stickyMode,
                        innerRef: this.stickyWrapperRef,
                        wrapperWidth: this.state.wrapperWidth,
                        columnWidths: columnWidths,
                        rowHeight: this.state.headerRowHeight,
                        tableNode: tableNode,
                        rendererAppearance: rendererAppearance,
                        allowTableResizing: allowTableResizing,
                        children: [
                            children && children[0]
                        ]
                    }),
                    (0, $eGOwo.fg)('editor_enghealth_focusable_scrollable_tables') ? /*#__PURE__*/ (0, $gt9Am.jsx)($4ae183b0f220a464$var$TableWrapper, {
                        wrapperRef: this.wrapperRef,
                        onScroll: this.props.stickyHeaders ? this.onWrapperScrolled : undefined,
                        stickyHeaders: stickyHeaders,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hpXI5.Table), {
                            innerRef: this.tableRef,
                            columnWidths: columnWidths,
                            layout: layout,
                            isNumberColumnEnabled: isNumberColumnEnabled,
                            renderWidth: renderWidth,
                            tableNode: tableNode,
                            rendererAppearance: rendererAppearance,
                            isInsideOfBlockNode: isInsideOfBlockNode,
                            isInsideOfTable: isInsideOfTable,
                            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                            allowTableResizing: allowTableResizing,
                            isPresentational: isPresentational,
                            children: this.grabFirstRowRef(children)
                        })
                    }) : /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $cjLtO.TableSharedCssClassName).TABLE_NODE_WRAPPER,
                        ref: this.wrapperRef,
                        onScroll: this.props.stickyHeaders && this.onWrapperScrolled,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hpXI5.Table), {
                            innerRef: this.tableRef,
                            columnWidths: columnWidths,
                            layout: layout,
                            isNumberColumnEnabled: isNumberColumnEnabled,
                            renderWidth: renderWidth,
                            tableNode: tableNode,
                            rendererAppearance: rendererAppearance,
                            isInsideOfBlockNode: isInsideOfBlockNode,
                            isInsideOfTable: isInsideOfTable,
                            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                            allowTableResizing: allowTableResizing,
                            isPresentational: isPresentational,
                            children: this.grabFirstRowRef(children)
                        })
                    }),
                    $4ae183b0f220a464$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER,
                        ref: this.stickyScrollbarRef,
                        style: {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            height: "var(--ds-space-250, 20px)",
                            // MAX_BROWSER_SCROLLBAR_HEIGHT
                            // Follow editor to hide by default so it does not show empty gap in SSR
                            // https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/platform/packages/editor/editor-plugin-table/src/nodeviews/TableComponent.tsx#957
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            display: fixTableSSRResizing ? 'none' : 'block',
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                            width: '100%'
                        },
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            style: {
                                width: this.tableRef.current?.clientWidth,
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                height: '100%'
                            }
                        })
                    }),
                    $4ae183b0f220a464$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
                        "data-testid": "sticky-scrollbar-sentinel-bottom"
                    })
                ]
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            stickyMode: 'none',
            wrapperWidth: 0,
            headerRowHeight: 0
        }, this.tableRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.stickyHeaderRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.stickyScrollbarRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), // used for sync scroll + copying wrapper width to sticky header
        this.stickyWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.overflowParent = null, this.resizeObserver = null, this.applyResizerChange = (entries)=>{
            let wrapperWidth = this.state.wrapperWidth;
            let headerRowHeight = this.state.headerRowHeight;
            for (const entry of entries){
                if (entry.target === this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                else if (entry.target === this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
            }
            if (headerRowHeight !== this.state.headerRowHeight || wrapperWidth !== this.state.wrapperWidth) this.setState({
                wrapperWidth: wrapperWidth,
                headerRowHeight: headerRowHeight
            });
        }, this.componentWillUnmount = ()=>{
            if (this.overflowParent) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            if (this.nextFrame) cancelAnimationFrame(this.nextFrame);
            if (this.resizeObserver) this.resizeObserver.disconnect();
            if (this.stickyScrollbar) this.stickyScrollbar.dispose();
        }, this.getScrollTop = ()=>{
            const { stickyHeaders: stickyHeaders } = this.props;
            const offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
            return (this.overflowParent ? this.overflowParent.top : 0) + offsetTop;
        }, this.updateSticky = ()=>{
            const tableElem = this.tableRef.current;
            const refElem = this.stickyHeaderRef.current;
            if (!tableElem || !refElem) return;
            const scrollTop = this.getScrollTop() + (0, $177xQ.tableStickyPadding);
            const tableTop = $4ae183b0f220a464$export$f422245984b0eda7(tableElem);
            const tableBottom = tableTop + tableElem.clientHeight;
            const shouldSticky = $4ae183b0f220a464$export$7c141112f3c89f11(scrollTop, tableTop, tableBottom, refElem.clientHeight);
            const shouldPin = $4ae183b0f220a464$export$89f3188e1adc30d5(scrollTop, tableBottom, refElem.clientHeight);
            let stickyMode = 'none';
            if (shouldPin) stickyMode = 'pin-bottom';
            else if (shouldSticky) stickyMode = 'stick';
            if (this.state.stickyMode !== stickyMode) this.setState({
                stickyMode: stickyMode
            });
            this.nextFrame = undefined;
        }, this.onScroll = ()=>{
            if (!this.nextFrame) this.nextFrame = requestAnimationFrame(this.updateSticky);
        }, this.onWrapperScrolled = ()=>{
            if (!this.wrapperRef.current || !this.stickyWrapperRef.current) return;
            this.stickyWrapperRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
            if (this.stickyScrollbarRef.current) this.stickyScrollbarRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
        }, this.grabFirstRowRef = (children)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children || false, (child, idx)=>{
                if (idx === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(child, {
                    innerRef: this.stickyHeaderRef
                });
                return child;
            });
        };
    }
}
class $4ae183b0f220a464$export$91e0997fd3f75d56 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    /**
   *
   * @example
   */ render() {
        const { children: children } = this.props;
        if (!children) return null;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children);
        const orderedChildren = (0, $d3BBj.compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenArray);
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $gt9Am.jsx)($4ae183b0f220a464$export$f2c3aea42b2a048f, {
            ...this.props,
            children: orderedChildren
        });
    }
    constructor(...args){
        super(...args), this.state = {
            tableOrderStatus: undefined
        }, // adds sortable + re-orders children
        this.addSortableColumn = (childrenArray)=>{
            const { tableNode: tableNode, allowColumnSorting: allowColumnSorting, smartCardStorage: smartCardStorage } = this.props;
            const { tableOrderStatus: tableOrderStatus } = this.state;
            if (allowColumnSorting && $4ae183b0f220a464$export$28daf78feed5098c(childrenArray) && tableNode && !(0, $bTpHi.hasMergedCell)(tableNode)) return $4ae183b0f220a464$export$100baa0f10804e6e($4ae183b0f220a464$export$334894231c46c1a5(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, this.changeSortOrder);
            return childrenArray;
        }, this.changeSortOrder = (columnIndex, sortOrder)=>{
            this.setState({
                tableOrderStatus: {
                    columnIndex: columnIndex,
                    order: sortOrder
                }
            });
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.addNumberColumnIndexes = (rows)=>{
            const { isNumberColumnEnabled: isNumberColumnEnabled } = this.props;
            const headerRowEnabled = $4ae183b0f220a464$export$28daf78feed5098c(rows);
            return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(rows, (row, index)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.only(row), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    index: headerRowEnabled ? index === 0 ? '' : index : index + 1
                });
            });
        };
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4ae183b0f220a464$var$TableWithShadowsAndContainerStyles = (0, $k6yTf.default)((0, $eOVsb.TableProcessorWithContainerStyles), {
    /**
   * The :scope is in reference to table container and we are selecting only
   * direct children that match the table node wrapper selector, not their
   * descendants.
   */ overflowSelector: `:scope > .${(0, $cjLtO.TableSharedCssClassName).TABLE_NODE_WRAPPER}`,
    useShadowObserver: true
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4ae183b0f220a464$var$TableWithShadows = (0, $k6yTf.default)($4ae183b0f220a464$export$91e0997fd3f75d56, {
    /**
   * The :scope is in reference to table container and we are selecting only
   * direct children that match the table node wrapper selector, not their
   * descendants.
   */ overflowSelector: `:scope > .${(0, $cjLtO.TableSharedCssClassName).TABLE_NODE_WRAPPER}`,
    useShadowObserver: true
});
const $4ae183b0f220a464$var$TableWithWidth = (props)=>{
    if ((0, $eGOwo.fg)('platform-ssr-table-resize')) {
        const colWidthsSum = props.columnWidths?.reduce((total, val)=>total + val, 0) || 0;
        if (colWidthsSum || props.allowTableResizing) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $gt9Am.jsx)($4ae183b0f220a464$var$TableWithShadowsAndContainerStyles, {
            ...props
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eOVsb.TableProcessorWithContainerStyles), {
            ...props
        });
    } else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2bEPZ.WidthConsumer), {
        children: ({ width: width })=>{
            const renderWidth = props.rendererAppearance === 'full-page' ? width - (0, $9a762f515f769003$export$12fd658e5eef0d79) * 2 : width;
            const colWidthsSum = props.columnWidths?.reduce((total, val)=>total + val, 0) || 0;
            if (colWidthsSum || props.allowTableResizing) // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, $gt9Am.jsx)($4ae183b0f220a464$var$TableWithShadows, {
                renderWidth: renderWidth,
                ...props
            });
            // there should not be a case when colWidthsSum is 0 and table is in overflow state - so no need to render shadows in this case
            return /*#__PURE__*/ (0, $gt9Am.jsx)($4ae183b0f220a464$export$91e0997fd3f75d56, {
                renderWidth: renderWidth,
                ...props
            });
        }
    });
};
var $4ae183b0f220a464$export$2e2bcd8739ae039 = (0, $dZ1mQ.withSmartCardStorage)($4ae183b0f220a464$var$TableWithWidth);

});
parcelRegister("cjLtO", function(module, exports) {
$parcel$export(module.exports, "tableMarginTop", () => $00ec34b4d6cfa8a7$export$808015ab1dd6897a);
$parcel$export(module.exports, "tableMarginTopWithControl", () => $00ec34b4d6cfa8a7$export$910bf0d22c3d10f2);
$parcel$export(module.exports, "tableMarginSides", () => $00ec34b4d6cfa8a7$export$a43e30915fab3ccf);
$parcel$export(module.exports, "tableCellMinWidth", () => $00ec34b4d6cfa8a7$export$531f77930bf508de);
$parcel$export(module.exports, "tableNewColumnMinWidth", () => $00ec34b4d6cfa8a7$export$c60fae4049791eae);
$parcel$export(module.exports, "tableCellBorderWidth", () => $00ec34b4d6cfa8a7$export$72aad729077aa0fb);
$parcel$export(module.exports, "tableCellPadding", () => $00ec34b4d6cfa8a7$export$e56b8ca552b280f6);
$parcel$export(module.exports, "TableSharedCssClassName", () => $00ec34b4d6cfa8a7$export$c096bca5477eb7ad);
$parcel$export(module.exports, "tableSharedStyle", () => $00ec34b4d6cfa8a7$export$c2bf8eea75aa9302);
$parcel$export(module.exports, "calcTableWidth", () => $00ec34b4d6cfa8a7$export$d7ece4d8beb06815);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $e6HpD = parcelRequire("e6HpD");

var $7yBx7 = parcelRequire("7yBx7");
var $1rXAK = parcelRequire("1rXAK");

var $eGOwo = parcelRequire("eGOwo");

var $cbSL1 = parcelRequire("cbSL1");

var $7EdFW = parcelRequire("7EdFW");

var $gBkUB = parcelRequire("gBkUB");

var $63wVg = parcelRequire("63wVg");
function $00ec34b4d6cfa8a7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $00ec34b4d6cfa8a7$export$808015ab1dd6897a = 24;
const $00ec34b4d6cfa8a7$export$afe1899c3eea9823 = 16;
const $00ec34b4d6cfa8a7$export$910bf0d22c3d10f2 = 14;
const $00ec34b4d6cfa8a7$export$a43e30915fab3ccf = 8;
const $00ec34b4d6cfa8a7$export$531f77930bf508de = 48;
const $00ec34b4d6cfa8a7$export$c60fae4049791eae = 140;
const $00ec34b4d6cfa8a7$export$72aad729077aa0fb = 1;
const $00ec34b4d6cfa8a7$export$e56b8ca552b280f6 = 8;
const $00ec34b4d6cfa8a7$export$bba39e724bc39451 = 6;
const $00ec34b4d6cfa8a7$export$e5ff276883773ffd = 8;
const $00ec34b4d6cfa8a7$export$880976487022eb5 = $00ec34b4d6cfa8a7$export$808015ab1dd6897a + $00ec34b4d6cfa8a7$export$e5ff276883773ffd - $00ec34b4d6cfa8a7$export$72aad729077aa0fb;
const $00ec34b4d6cfa8a7$export$c096bca5477eb7ad = {
    TABLE_CONTAINER: `${(0, $e6HpD.tablePrefixSelector)}-container`,
    TABLE_NODE_WRAPPER: `${(0, $e6HpD.tablePrefixSelector)}-wrapper`,
    TABLE_SCROLL_INLINE_SHADOW: `${(0, $e6HpD.tablePrefixSelector)}-scroll-inline-shadow`,
    TABLE_RIGHT_BORDER: `${(0, $e6HpD.tablePrefixSelector)}-right-border`,
    TABLE_LEFT_BORDER: `${(0, $e6HpD.tablePrefixSelector)}-left-border`,
    TABLE_LEFT_SHADOW: `${(0, $e6HpD.tablePrefixSelector)}-with-left-shadow`,
    TABLE_RIGHT_SHADOW: `${(0, $e6HpD.tablePrefixSelector)}-with-right-shadow`,
    TABLE_STICKY_SHADOW: `${(0, $e6HpD.tablePrefixSelector)}-sticky-shadow`,
    TABLE_STICKY_WRAPPER: `${(0, $e6HpD.tablePrefixSelector)}-sticky-wrapper`,
    TABLE_STICKY_SCROLLBAR_CONTAINER: `${(0, $e6HpD.tablePrefixSelector)}-sticky-scrollbar-container`,
    TABLE_STICKY_SENTINEL_TOP: `${(0, $e6HpD.tablePrefixSelector)}-sticky-sentinel-top`,
    TABLE_STICKY_SENTINEL_BOTTOM: `${(0, $e6HpD.tablePrefixSelector)}-sticky-sentinel-bottom`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_TOP: `${(0, $e6HpD.tablePrefixSelector)}-sticky-scrollbar-sentinel-top`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM: `${(0, $e6HpD.tablePrefixSelector)}-sticky-scrollbar-sentinel-bottom`,
    TABLE_SHADOW_SENTINEL_LEFT: `${(0, $e6HpD.tablePrefixSelector)}-shadow-sentinel-left`,
    TABLE_SHADOW_SENTINEL_RIGHT: `${(0, $e6HpD.tablePrefixSelector)}-shadow-sentinel-right`,
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_NODEVIEW_CONTENT_DOM: (0, $e6HpD.tableCellContentDomSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_WRAPPER: (0, $e6HpD.tableCellSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_HEADER_CELL_WRAPPER: (0, $e6HpD.tableHeaderSelector),
    TABLE_ROW_CONTROLS_WRAPPER: `${(0, $e6HpD.tablePrefixSelector)}-row-controls-wrapper`,
    TABLE_COLUMN_CONTROLS_DECORATIONS: `${(0, $e6HpD.tablePrefixSelector)}-column-controls-decoration`,
    TABLE_RESIZER_CONTAINER: `${(0, $e6HpD.tablePrefixSelector)}-resizer-container`
};
/* first block node has 0 top margin */ var $00ec34b4d6cfa8a7$var$_ref = {
    name: "qubt66",
    styles: ">:first-child:not(style),>style:first-child+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+*,>style:first-child+.ProseMirror-gapcursor+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+*,>style:first-child+.ProseMirror-gapcursor+span+*{margin-top:0;}"
};
var $00ec34b4d6cfa8a7$var$_ref2 = {
    name: "1fct7qz",
    styles: ">:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}"
};
const $00ec34b4d6cfa8a7$var$firstNodeWithNotMarginTop = ()=>(0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') ? $00ec34b4d6cfa8a7$var$_ref2 : $00ec34b4d6cfa8a7$var$_ref;
const $00ec34b4d6cfa8a7$export$c2bf8eea75aa9302 = ()=>{
    const browser = (0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $7EdFW.getBrowserInfo)() : (0, $7EdFW.browser);
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Appears safe to auto-fix, but leaving it up to the team to remediate as the readability only gets worse with autofixing
    return /*#__PURE__*/ (0, $1NIU8.css)((0, $63wVg.tableCellBackgroundStyleOverride)(), " .", $00ec34b4d6cfa8a7$export$c096bca5477eb7ad.TABLE_CONTAINER, "{position:relative;margin:0 auto var(--ds-space-200, 16px);box-sizing:border-box;", (0, $cbSL1.expValEquals)('platform_editor_disable_table_overflow_shadows', 'cohort', 'variant2') && `.${$00ec34b4d6cfa8a7$export$c096bca5477eb7ad.TABLE_RIGHT_BORDER}, .${$00ec34b4d6cfa8a7$export$c096bca5477eb7ad.TABLE_LEFT_BORDER} {
				display: block;
				width: 1px;
				height: calc(100% - ${"var(--ds-space-300, 24px)"});
				background: ${`var(--ds-background-accent-gray-subtler, ${0, $7yBx7.akEditorTableBorder})`};
				position: absolute;
				top: ${"var(--ds-space-300, 24px)"};
			}
			.${$00ec34b4d6cfa8a7$export$c096bca5477eb7ad.TABLE_RIGHT_BORDER} {
				right: 0;
			}
			.${$00ec34b4d6cfa8a7$export$c096bca5477eb7ad.TABLE_LEFT_BORDER} {
				left: 0;
			}
			`, ";.decisionItemView-content-wrap:first-of-type>div{margin-top:0;}}.", $00ec34b4d6cfa8a7$export$c096bca5477eb7ad.TABLE_CONTAINER, "[data-number-column='true']{padding-left:", (0, $7yBx7.akEditorTableNumberColumnWidth) - 1, "px;clear:both;}.", $00ec34b4d6cfa8a7$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, "{will-change:width,margin-left;}.", $00ec34b4d6cfa8a7$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, " table{will-change:width;}.", $00ec34b4d6cfa8a7$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, ">table{margin:var(--ds-space-300, 24px) 0 0 0;}.", $00ec34b4d6cfa8a7$export$c096bca5477eb7ad.TABLE_CONTAINER, ">table,.", $00ec34b4d6cfa8a7$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, ">table{margin:var(--ds-space-300, 24px) var(--ds-space-100, 8px) 0 0;}", (0, $eGOwo.fg)('platform_editor_bordered_panel_nested_in_table') ? `.${$00ec34b4d6cfa8a7$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER} .ak-editor-panel {
			border: ${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #d9dbea)"};
		}` : '', ".", $00ec34b4d6cfa8a7$export$c096bca5477eb7ad.TABLE_CONTAINER, ">table,.", $00ec34b4d6cfa8a7$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, ">table,.", $00ec34b4d6cfa8a7$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, ">table{border-collapse:collapse;border:", $00ec34b4d6cfa8a7$export$72aad729077aa0fb, "px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $7yBx7.akEditorTableBorder)})`, ";", (0, $cbSL1.expValEquals)('platform_editor_disable_table_overflow_shadows', 'cohort', 'variant2') && `
				border-left-color: transparent;
				border-right-color: transparent;
			`, " table-layout:fixed;font-size:1em;width:100%;&[data-autosize='true']{table-layout:auto;}&{*{box-sizing:border-box;}hr{box-sizing:content-box;}tbody{border-bottom:none;}th td{background-color:var(--ds-background-neutral-subtle, white);}>tbody>tr>th,>tbody>tr>td{min-width:", $00ec34b4d6cfa8a7$export$531f77930bf508de, "px;font-weight:var(--ds-font-weight-regular, 400);vertical-align:top;border:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $7yBx7.akEditorTableBorder)})`, ";border-right-width:0;border-bottom-width:0;padding:var(--ds-space-100, 8px);", browser.gecko || browser.ie || browser.mac && browser.chrome ? 'background-clip: padding-box;' : '', " ", $00ec34b4d6cfa8a7$var$firstNodeWithNotMarginTop(), " th p:not(:first-of-type),td p:not(:first-of-type){margin-top:var(--ds-space-150, 12px);}}>tbody>tr>td{background-color:var(--ds-surface, #FFFFFF);}th{background-color:", `var(--ds-background-accent-gray-subtlest, ${(0, $7yBx7.akEditorTableToolbar)})`, ";text-align:left;", (0, $cbSL1.expValEquals)('platform_editor_native_anchor_support', 'isEnabled', true) ? '&:not(.danger)' : '&:not([style]):not(.danger)', "{.", (0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, ":not(.danger){background-color:var(--ds-surface-raised, rgb(235, 237, 240));:not(.", (0, $7yBx7.akEditorSelectedNodeClassName), "){box-shadow:0px 0px 0px 1px var(--ds-border, transparent);}.", (0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER, "{background-image:", (0, $1rXAK.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), ";background-color:var(--ds-background-neutral, rgb(235, 237, 240));}.", (0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-neutral, rgb(226, 229, 233));}>[data-ds--code--code-block]{background-image:", (0, $1rXAK.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), "!important;background-color:var(--ds-background-neutral, rgb(235, 237, 240))!important;/* selector lives inside @atlaskit/code */--ds--code--line-number-bg-color:var(--ds-background-neutral, rgb(226, 229, 233));}}}}}}");
};
const $00ec34b4d6cfa8a7$export$d7ece4d8beb06815 = (layout, containerWidth, addControllerPadding = true)=>{
    switch(layout){
        case 'full-width':
            return containerWidth ? Math.min(containerWidth - (addControllerPadding ? (0, $7yBx7.akEditorBreakoutPadding) : 0), (0, $7yBx7.akEditorFullWidthLayoutWidth)) : (0, $7yBx7.akEditorFullWidthLayoutWidth);
        case 'wide':
            if (containerWidth) return Math.min(containerWidth - (addControllerPadding ? (0, $7yBx7.akEditorBreakoutPadding) : 0), (0, $7yBx7.akEditorWideLayoutWidth));
            return 0, $7yBx7.akEditorWideLayoutWidth;
        default:
            return 'inherit';
    }
};

});
parcelRegister("1rXAK", function(module, exports) {
$parcel$export(module.exports, "overflowShadow", () => $46a467cbc6a60acf$export$c5c1e4f4640336fb);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");
const $46a467cbc6a60acf$export$c5c1e4f4640336fb = ({ leftCoverWidth: leftCoverWidth, rightCoverWidth: rightCoverWidth })=>{
    const width = "var(--ds-space-100, 8px)";
    const leftCoverWidthResolved = leftCoverWidth || width;
    const rightCoverWidthResolved = rightCoverWidth || width;
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $1NIU8.css)();
};

});

parcelRegister("gBkUB", function(module, exports) {
$parcel$export(module.exports, "CodeBlockSharedCssClassName", () => $560191ff43d42495$export$42659c26f026f6ea);
const $560191ff43d42495$export$42659c26f026f6ea = {
    CODEBLOCK_CONTAINER: 'code-block',
    CODEBLOCK_START: 'code-block--start',
    CODEBLOCK_END: 'code-block--end',
    CODEBLOCK_CONTENT_WRAPPER: 'code-block-content-wrapper',
    CODEBLOCK_LINE_NUMBER_GUTTER: 'line-number-gutter',
    CODEBLOCK_CONTENT: 'code-content',
    DS_CODEBLOCK: '[data-ds--code--code-block]',
    CODEBLOCK_CONTENT_WRAPPED: 'code-content--wrapped',
    CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET: 'code-content__line-number--wrapped'
};

});

parcelRegister("63wVg", function(module, exports) {
$parcel$export(module.exports, "tableCellBackgroundStyleOverride", () => $79d10202613a72be$export$677e93f0f5f9623a);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $e6HpD = parcelRequire("e6HpD");

var $kZPQ0 = parcelRequire("kZPQ0");
// This is used in order to support usage of DS tokens. Table cell background-color
// is set inline in '@atlaskit/adf-schema' and the color value is stored in ADF so
// it is not possible to use tokens there without polluting ADF.
// As table cell backgrounds are set inline, this should not break mobile as
// hexToEditorBackgroundPaletteColor() outputs a css variable with fallback hex.
const $79d10202613a72be$var$mapBackgroundColors = ()=>{
    let cssString = '';
    (0, $e6HpD.tableBackgroundColorNames).forEach((value, key)=>{
        const paletteColorValue = (0, $kZPQ0.hexToEditorBackgroundPaletteColor)(value);
        if (paletteColorValue) cssString += `
        td[colorname='${key}' i],
        th[colorname='${key}' i] {
          background-color: ${paletteColorValue} !important;
        }
      `;
    });
    return cssString;
};
const $79d10202613a72be$export$677e93f0f5f9623a = ()=>/*#__PURE__*/ (0, $1NIU8.css)($79d10202613a72be$var$mapBackgroundColors());

});
parcelRegister("kZPQ0", function(module, exports) {
$parcel$export(module.exports, "hexToEditorBackgroundPaletteColor", () => $d7ddc44a74c35e5a$export$5f6a44a42a4b38c2);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $d7ddc44a74c35e5a$export$a270511a0e7fd61a);
// This import will be stripped on build

var $2On2D = parcelRequire("2On2D");
function $d7ddc44a74c35e5a$export$5f6a44a42a4b38c2(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $d7ddc44a74c35e5a$export$2462741d70e6a62f[hexColor.toUpperCase()];
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return tokenData ? tokenData.token : undefined;
}
function $d7ddc44a74c35e5a$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $d7ddc44a74c35e5a$export$2462741d70e6a62f[hexColor.toUpperCase()];
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $d7ddc44a74c35e5a$export$2462741d70e6a62f = {
    // blue
    /** blue - light */ ['#DEEBFF']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.blue.subtlest', fallback),
        token: "var(--ds-background-accent-blue-subtlest, #DEEBFF)"
    },
    // source for hex code was legacy token B50
    /** blue - medium */ ['#B3D4FF']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.blue.subtler', fallback),
        token: "var(--ds-background-accent-blue-subtler, #B3D4FF)"
    },
    // source for hex code was legacy token B75
    /** blue - strong */ ['#4C9AFF']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.blue.subtle', fallback),
        token: "var(--ds-background-accent-blue-subtle, #4C9AFF)"
    },
    // source for hex code was legacy token B100
    // teal
    /** teal - light */ ['#E6FCFF']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.teal.subtlest', fallback),
        token: "var(--ds-background-accent-teal-subtlest, #E6FCFF)" // source for hex code was legacy token T50,
    },
    /** teal - medium */ ['#B3F5FF']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.teal.subtler', fallback),
        token: "var(--ds-background-accent-teal-subtler, #B3F5FF)" // source for hex code was legacy token T75,
    },
    /** teal - strong */ ['#79E2F2']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.teal.subtle', fallback),
        token: "var(--ds-background-accent-teal-subtle, #79E2F2)" // source for hex code was legacy token T100,
    },
    // green
    /** green - light */ ['#E3FCEF']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.green.subtlest', fallback),
        token: "var(--ds-background-accent-green-subtlest, #E3FCEF)" // source for hex code was legacy token G50,
    },
    /** green - medium */ ['#ABF5D1']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.green.subtler', fallback),
        token: "var(--ds-background-accent-green-subtler, #ABF5D1)" // source for hex code was legacy token G75,
    },
    /** green - strong */ ['#57D9A3']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.green.subtle', fallback),
        token: "var(--ds-background-accent-green-subtle, #57D9A3)" // source for hex code was legacy token G200,
    },
    // yellowOrange
    /** yellowOrange - light */ ['#FFFAE6']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.yellow.subtlest', fallback),
        token: "var(--ds-background-accent-yellow-subtlest, #FFFAE6)" // source for hex code was legacy token Y50,
    },
    /** yellowOrange - medium */ ['#FFF0B3']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.yellow.subtler', fallback),
        token: "var(--ds-background-accent-yellow-subtler, #FFF0B3)" // source for hex code was legacy token Y75,
    },
    /** yellowOrange - strong */ ['#FFC400']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.orange.subtle', fallback),
        token: "var(--ds-background-accent-orange-subtle, #FFC400)" // source for hex code was legacy token Y200,
    },
    // red
    /** red - light */ ['#FFEBE6']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.red.subtlest', fallback),
        token: "var(--ds-background-accent-red-subtlest, #FFEBE6)" // source for hex code was legacy token R50,
    },
    /** red - medium */ ['#FFBDAD']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.red.subtler', fallback),
        token: "var(--ds-background-accent-red-subtler, #FFBDAD)" // source for hex code was legacy token R75,
    },
    /** red - strong */ ['#FF8F73']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.red.subtle', fallback),
        token: "var(--ds-background-accent-red-subtle, #FF8F73)" // source for hex code was legacy token R100,
    },
    // purple
    /** purple - light */ ['#EAE6FF']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.purple.subtlest', fallback),
        token: "var(--ds-background-accent-purple-subtlest, #EAE6FF)" // source for hex code was legacy token P50,
    },
    /** purple - medium */ ['#C0B6F2']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.purple.subtler', fallback),
        token: "var(--ds-background-accent-purple-subtler, #C0B6F2)" // source for hex code was legacy token P75,
    },
    /** purple - strong */ ['#998DD9']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.purple.subtle', fallback),
        token: "var(--ds-background-accent-purple-subtle, #998DD9)" // source for hex code was legacy token P100,
    },
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: {
        getValue: (fallback)=>(0, $2On2D.default)('elevation.surface', fallback),
        token: "var(--ds-surface, #FFFFFF)" // source for hex code was legacy token N0,
    },
    /** whiteGray - medium */ ['#F4F5F7']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.gray.subtlest', fallback),
        token: "var(--ds-background-accent-gray-subtlest, #F4F5F7)" // source for hex code was legacy token N20,
    },
    /** whiteGray - strong */ ['#B3BAC5']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.gray.subtle', fallback),
        token: "var(--ds-background-accent-gray-subtle, #B3BAC5)" // source for hex code was legacy token N60,
    }
};

});



parcelRegister("d3BBj", function(module, exports) {
$parcel$export(module.exports, "compose", () => $cebdc4ee82f37b00$export$f672e0b6f7222cd7);
/** Helper type for single arg function */ function $cebdc4ee82f37b00$export$f672e0b6f7222cd7(func, ...funcs) {
    const allFuncs = [
        func,
        ...funcs
    ];
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function composed(raw) {
        return allFuncs.reduceRight((memo, func)=>func(memo), raw);
    };
}

});

parcelRegister("bTpHi", function(module, exports) {
$parcel$export(module.exports, "getColumnWidths", () => $6086fc23ae8f0d14$export$e54c9225ca52acc);
$parcel$export(module.exports, "calcTableColumnWidths", () => $6086fc23ae8f0d14$export$98951d3cdcfd364b);
$parcel$export(module.exports, "hasMergedCell", () => $6086fc23ae8f0d14$export$f9d610bfbb78949b);
$parcel$export(module.exports, "convertProsemirrorTableNodeToArrayOfRows", () => $6086fc23ae8f0d14$export$69fbfaf01f2fd534);
$parcel$export(module.exports, "isPositionNearTableRow", () => $6086fc23ae8f0d14$export$889a8e446452be16);
function $6086fc23ae8f0d14$export$e54c9225ca52acc(node) {
    let tableColumnWidths = [];
    node.forEach((row)=>{
        const currentTableWidth = [];
        row.forEach((cell)=>{
            const { colspan: colspan, colwidth: colwidth } = cell.attrs;
            // column has been resized, colWidth will be an array, can safely take values even if cell is merged
            if (Array.isArray(colwidth)) currentTableWidth.push(...colwidth);
            else if (colspan !== undefined && colspan > 1) currentTableWidth.push(...Array(colspan).fill(0));
            else currentTableWidth.push(0);
        });
        if (currentTableWidth.length > tableColumnWidths.length) tableColumnWidths = currentTableWidth;
    });
    return tableColumnWidths;
}
function $6086fc23ae8f0d14$export$98951d3cdcfd364b(node) {
    const firstRow = node.firstChild;
    const tableColumnWidths = [];
    if (firstRow) firstRow.forEach((cell)=>{
        const { colspan: colspan, colwidth: colwidth } = cell.attrs;
        // column has been resized, colWidth will be an array, can safely take values even if cell is merged
        if (Array.isArray(colwidth)) tableColumnWidths.push(...colwidth);
        else if (colspan > 1) tableColumnWidths.push(...Array(colspan).fill(0));
        else tableColumnWidths.push(0);
    });
    return tableColumnWidths;
}
function $6086fc23ae8f0d14$export$f9d610bfbb78949b(tableNode) {
    let hasSpan = false;
    tableNode.descendants((node)=>{
        if (node.type.name === 'tableRow') return true;
        const { colspan: colspan, rowspan: rowspan } = node.attrs;
        if (colspan > 1 || rowspan > 1) hasSpan = true;
        return false;
    });
    return hasSpan;
}
function $6086fc23ae8f0d14$export$69fbfaf01f2fd534(tableNode) {
    const result = [];
    tableNode.forEach((rowNode)=>{
        if (rowNode.type.name === 'tableRow') {
            const row = [];
            rowNode.forEach((n)=>row.push(n));
            result.push(row);
        }
    });
    return result;
}
function $6086fc23ae8f0d14$export$889a8e446452be16(pos, schema, direction) {
    if (!schema.nodes.tableRow) return false;
    const doc = pos.doc;
    let resolved = pos;
    const sibling = direction === 'before' ? 'nodeBefore' : 'nodeAfter';
    while(resolved.depth > 0){
        const siblingType = resolved[sibling]?.type;
        if (siblingType === schema.nodes.tableRow) return true;
        resolved = doc.resolve(resolved[direction]());
    }
    return false;
}

});

parcelRegister("gikGJ", function(module, exports) {
$parcel$export(module.exports, "createCompareNodes", () => $2cd578ee4d14df78$export$49215374a8bec29c);

var $eGOwo = parcelRequire("eGOwo");

var $hh2CV = parcelRequire("hh2CV");
var $2cd578ee4d14df78$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType[ContentType["NUMBER"] = 0] = "NUMBER";
    ContentType[ContentType["TEXT"] = 5] = "TEXT";
    ContentType[ContentType["MENTION"] = 10] = "MENTION";
    ContentType[ContentType["DATE"] = 15] = "DATE";
    ContentType[ContentType["STATUS"] = 20] = "STATUS";
    ContentType[ContentType["LINK"] = 25] = "LINK";
    return ContentType;
}({});
function $2cd578ee4d14df78$var$getLinkMark(node) {
    const [linkMark] = node.marks.filter((mark)=>mark.type.name === 'link');
    return linkMark || null;
}
function $2cd578ee4d14df78$var$parseLocaleNumber(stringNumber, groupPattern, fractionPattern) {
    if (!stringNumber.trim().length) return null;
    const maybeANumber = Number.parseFloat(stringNumber.replace(groupPattern, '').replace(fractionPattern, '.'));
    if (Number.isNaN(maybeANumber)) return null;
    return maybeANumber;
}
function $2cd578ee4d14df78$export$8ebf986086b1866f() {
    // Source: https://stackoverflow.com/questions/12004808/does-javascript-take-local-decimal-separators-into-account
    const locale = window.navigator.language;
    const thousandSeparator = Intl.NumberFormat(locale).format(11111)// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .replace(/\p{Number}/gu, '');
    const decimalSeparator = Intl.NumberFormat(locale).format(1.1)// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .replace(/\p{Number}/gu, '');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const numericPattern = new RegExp(`(\\d+(?:[${thousandSeparator}${decimalSeparator}]?\\d+)*)`, 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const thousandSeparatorPattern = new RegExp('\\' + thousandSeparator, 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const decimalSeparatorPattern = new RegExp('\\' + decimalSeparator);
    return (text)=>{
        if (!text.trim().length) return null;
        // This will break the text apart at the locations of the formatted numbers
        const result = text.split(numericPattern);
        // We then put the text back together but with all the formatted numbers converted back to plain numerals,
        // for example a sentence like "What is 1,000.01% of 10,000.01" would be normalized and sorted as
        // if it's saying "What is 1000.01% of 10000.01". This way the Intl.Collator can use the numeric setting to sort
        // numeral values within string correctly.
        const tokens = result.reduce((acc, stringNumber)=>{
            if (!stringNumber?.length) return acc;
            const maybeANumber = $2cd578ee4d14df78$var$parseLocaleNumber(stringNumber, thousandSeparatorPattern, decimalSeparatorPattern);
            // NOTE: We know there can only be a single decimal separator. So we can assume that if the first found separator
            // is not at the same position as the last found one, then we can assume the locale used to format the number
            // is different to our locale. This will result in the value being treated as a string.
            if (maybeANumber !== null && stringNumber.indexOf(decimalSeparator) === stringNumber.lastIndexOf(decimalSeparator)) acc.push(maybeANumber);
            else acc.push(stringNumber);
            return acc;
        }, []);
        if (tokens.length === 1) return tokens[0];
        return tokens.join('');
    };
}
function $2cd578ee4d14df78$export$7cc053f549ed70b8(textNode, normalizeTextParser) {
    // treat as a link if contain a link
    const linkMark = $2cd578ee4d14df78$var$getLinkMark(textNode);
    if (linkMark) {
        const value = textNode.text || '';
        return {
            type: 25,
            value: value
        };
    }
    const text = textNode.text || '';
    const normalizedText = normalizeTextParser(text);
    if (typeof normalizedText === 'number') return {
        type: 0,
        value: normalizedText
    };
    return {
        type: 5,
        value: normalizedText ?? text
    };
}
function $2cd578ee4d14df78$var$getMetaFromNode(node, options, normalizeTextParser) {
    if (!node) return null;
    const firstChild = node.firstChild;
    if (!firstChild) return null;
    switch(firstChild.type.name){
        // Text case
        /*
      Get Meta value from the first child if the cell is of type
        * Heading (Any cell where the text is set to a heading type)
        * Paragraph (Normal text)
     */ case 'heading':
        case 'paragraph':
            return $2cd578ee4d14df78$var$getMetaFromNode(firstChild, options, normalizeTextParser);
        case 'inlineCard':
            {
                const attrs = firstChild.attrs;
                const maybeTitle = options.getInlineCardTextFromStore(attrs);
                if (maybeTitle) return {
                    type: 25,
                    value: maybeTitle
                };
                const url = attrs.url;
                return {
                    type: 25,
                    value: url ? url : ''
                };
            }
        case 'text':
            return $2cd578ee4d14df78$export$7cc053f549ed70b8(firstChild, normalizeTextParser);
        case 'status':
            {
                const text = firstChild.attrs.text;
                return {
                    type: 20,
                    value: text
                };
            }
        case 'date':
            {
                const timestamp = Number.parseInt(firstChild.attrs.timestamp, 20);
                return {
                    type: 15,
                    value: timestamp
                };
            }
        case 'mention':
            {
                const text = firstChild.attrs.text || '';
                return {
                    type: 10,
                    value: text.toLowerCase()
                };
            }
        default:
            return null;
    }
}
function $2cd578ee4d14df78$var$compareValue(valueA, valueB) {
    if (valueA === valueB) return 0;
    if (typeof valueA === 'string' && typeof valueB === 'string') return valueA.localeCompare(valueB, window.navigator.language, {
        caseFirst: 'upper',
        numeric: true
    });
    return valueA > valueB ? 1 : -1;
}
const $2cd578ee4d14df78$export$49215374a8bec29c = (options, order = (0, $hh2CV.SortOrder).ASC)=>{
    const normalizeTextParser = $2cd578ee4d14df78$export$8ebf986086b1866f();
    return (nodeA, nodeB)=>{
        const metaNodeA = $2cd578ee4d14df78$var$getMetaFromNode(nodeA, options, normalizeTextParser);
        const metaNodeB = $2cd578ee4d14df78$var$getMetaFromNode(nodeB, options, normalizeTextParser);
        /*
      Donot switch the order (Asec or Desc) if either node is null.
      This will ensure that empty cells are always at the bottom during sorting.
    */ if (metaNodeA === null || metaNodeB === null) return $2cd578ee4d14df78$var$compareMetaFromNode(metaNodeA, metaNodeB);
        return (order === (0, $hh2CV.SortOrder).DESC ? -1 : 1) * $2cd578ee4d14df78$var$compareMetaFromNode(metaNodeA, metaNodeB);
    };
};
function $2cd578ee4d14df78$var$compareMetaFromNode(metaNodeA, metaNodeB) {
    if (metaNodeA === metaNodeB) return 0;
    if (metaNodeA === null || metaNodeB === null) return metaNodeB === null ? -1 : 1;
    if ((0, $eGOwo.fg)('platform_editor_fix_mixed_types_column_sort')) {
        if (metaNodeA.type === 5 && metaNodeB.type === 0 || metaNodeA.type === 0 && metaNodeB.type === 5) return $2cd578ee4d14df78$var$compareValue(String(metaNodeA.value), String(metaNodeB.value));
    }
    if (metaNodeA.type !== metaNodeB.type) return metaNodeA.type > metaNodeB.type ? 1 : -1;
    return $2cd578ee4d14df78$var$compareValue(metaNodeA.value, metaNodeB.value);
}

});
parcelRegister("hh2CV", function(module, exports) {
$parcel$export(module.exports, "SortOrder", () => $026f7cd52e6b22e7$export$7ae723045d45777a);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $4Fc33 = parcelRequire("4Fc33");

var $aBsWC = parcelRequire("aBsWC");

var $026f7cd52e6b22e7$export$7ae723045d45777a = /*#__PURE__*/ function(SortOrder) {
    SortOrder["ASC"] = "asc";
    SortOrder["DESC"] = "desc";
    SortOrder["NO_ORDER"] = "no_order";
    return SortOrder;
}({});

});
parcelRegister("aBsWC", function(module, exports) {
$parcel$export(module.exports, "ToolbarSize", () => $639c7867308be22b$export$ed55211407a9423);
$parcel$export(module.exports, "ToolbarWidths", () => $639c7867308be22b$export$423b5e8c92d477b9);
$parcel$export(module.exports, "ToolbarWidthsNext", () => $639c7867308be22b$export$3f050002d3df641b);
$parcel$export(module.exports, "ToolbarWidthsFullPage", () => $639c7867308be22b$export$63ca43752be70b90);
$parcel$export(module.exports, "ToolbarWidthsFullPageNext", () => $639c7867308be22b$export$501a79d885598191);
var $639c7867308be22b$export$ed55211407a9423 = /*#__PURE__*/ function(ToolbarSize) {
    ToolbarSize[ToolbarSize["XXL"] = 6] = "XXL";
    ToolbarSize[ToolbarSize["XL"] = 5] = "XL";
    ToolbarSize[ToolbarSize["L"] = 4] = "L";
    ToolbarSize[ToolbarSize["M"] = 3] = "M";
    ToolbarSize[ToolbarSize["S"] = 2] = "S";
    ToolbarSize[ToolbarSize["XXXS"] = 1] = "XXXS";
    return ToolbarSize;
}({});
var $639c7867308be22b$export$423b5e8c92d477b9 = /*#__PURE__*/ function(ToolbarWidths) {
    ToolbarWidths[ToolbarWidths["XXL"] = 610] = "XXL";
    ToolbarWidths[ToolbarWidths["XL"] = 540] = "XL";
    ToolbarWidths[ToolbarWidths["L"] = 460] = "L";
    ToolbarWidths[ToolbarWidths["M"] = 450] = "M";
    ToolbarWidths[ToolbarWidths["S"] = 410] = "S";
    return ToolbarWidths;
}({});
var $639c7867308be22b$export$3f050002d3df641b = /*#__PURE__*/ function(ToolbarWidthsNext) {
    ToolbarWidthsNext[ToolbarWidthsNext["XXL"] = 768] = "XXL";
    ToolbarWidthsNext[ToolbarWidthsNext["XL"] = 576] = "XL";
    ToolbarWidthsNext[ToolbarWidthsNext["L"] = 460] = "L";
    ToolbarWidthsNext[ToolbarWidthsNext["M"] = 450] = "M";
    ToolbarWidthsNext[ToolbarWidthsNext["S"] = 410] = "S";
    return ToolbarWidthsNext;
}({});
var $639c7867308be22b$export$63ca43752be70b90 = /*#__PURE__*/ function(ToolbarWidthsFullPage) {
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XXL"] = 650] = "XXL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XL"] = 580] = "XL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["L"] = 540] = "L";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["M"] = 490] = "M";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["S"] = 410] = "S";
    return ToolbarWidthsFullPage;
}({});
var $639c7867308be22b$export$501a79d885598191 = /*#__PURE__*/ function(ToolbarWidthsFullPageNext) {
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XXL"] = 1200] = "XXL";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XL"] = 992] = "XL";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["L"] = 768] = "L";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["M"] = 576] = "M";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["S"] = 410] = "S";
    return ToolbarWidthsFullPageNext;
}({});

});



parcelRegister("68RqK", function(module, exports) {
$parcel$export(module.exports, "layoutToWidth", () => $0996654c31bce5a9$export$9b77d38feba5446);
$parcel$export(module.exports, "getParentNodeWidth", () => $0996654c31bce5a9$export$d76cc081ce1449a8);
$parcel$export(module.exports, "getTableContainerWidth", () => $0996654c31bce5a9$export$3930799be057b305);

var $BmspC = parcelRequire("BmspC");

var $7yBx7 = parcelRequire("7yBx7");

var $eGOwo = parcelRequire("eGOwo");

var $cbSL1 = parcelRequire("cbSL1");

var $2smsR = parcelRequire("2smsR");

var $2onoM = parcelRequire("2onoM");

var $cjLtO = parcelRequire("cjLtO");

var $bnh3n = parcelRequire("bnh3n");
const $0996654c31bce5a9$var$GRID_SIZE = 8;
const $0996654c31bce5a9$var$NESTED_DND_GUTTER_OFFSET = 8;
const $0996654c31bce5a9$var$NESTED_DND_MARGIN_OFFSET = 12;
const $0996654c31bce5a9$export$9b77d38feba5446 = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    default: (0, $7yBx7.akEditorDefaultLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    wide: (0, $7yBx7.akEditorWideLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    'full-width': (0, $7yBx7.akEditorFullWidthLayoutWidth)
};
const $0996654c31bce5a9$export$d76cc081ce1449a8 = (pos, state, containerWidth, isFullWidthModeEnabled)=>{
    if (!pos) return;
    const node = $0996654c31bce5a9$var$getNestedParentNode(pos, state);
    if (!node) return;
    let layout = node.attrs.layout || 'default';
    const { schema: schema } = state;
    const breakoutMark = schema.marks.breakout && schema.marks.breakout.isInSet(node.marks);
    if (breakoutMark && breakoutMark.attrs.mode) layout = breakoutMark.attrs.mode;
    const breakoutWidth = breakoutMark ? breakoutMark.attrs.width : undefined;
    let parentWidth = $0996654c31bce5a9$var$calcBreakoutNodeWidth(layout, containerWidth, isFullWidthModeEnabled, breakoutWidth);
    // Please, do not copy or use this kind of code below
    // @ts-ignore
    const contextPanelPluginKey = {
        key: 'contextPanelPluginKey$',
        getState: (state)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return state['contextPanelPluginKey$'];
        }
    };
    switch(node.type){
        case schema.nodes.layoutSection:
            // the extra width of the layout does not add to the width of the area the table can be inside
            if (!(0, $cbSL1.expValEquals)('platform_editor_nested_table_refresh_width_fix', 'isEnabled', true)) parentWidth += (0, $7yBx7.akLayoutGutterOffset) * 2; // extra width that gets added to layout
            // Calculate width of parent layout column when
            // Parallel layout with viewport greater than 1024px
            // OR side panel of an extension is open and change the node width to smaller than containerWidth
            if (containerWidth.width > (0, $7yBx7.gridMediumMaxWidth) || contextPanelPluginKey.getState(state)?.contents.length > 0 && contextPanelPluginKey.getState(state)?.contents[0] !== undefined) {
                // margin between sections
                parentWidth -= (0, $cbSL1.expValEquals)('platform_editor_nested_table_refresh_width_fix', 'isEnabled', true) && (0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') ? ((0, $2onoM.LAYOUT_SECTION_MARGIN) + $0996654c31bce5a9$var$NESTED_DND_MARGIN_OFFSET + 2) * (node.childCount - 1) : ((0, $2onoM.LAYOUT_SECTION_MARGIN) + 2) * (node.childCount - 1);
                const $pos = state.doc.resolve(pos);
                const column = (0, $BmspC.findParentNodeOfTypeClosestToPos)($pos, [
                    state.schema.nodes.layoutColumn
                ]);
                if (column && column.node && !isNaN(column.node.attrs.width)) // get exact width of parent layout column using node attrs
                parentWidth = Math.round(parentWidth * column.node.attrs.width * 0.01);
            }
            // account for the padding of the parent node
            parentWidth -= (0, $cbSL1.expValEquals)('platform_editor_nested_table_refresh_width_fix', 'isEnabled', true) && (0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') ? ((0, $2onoM.LAYOUT_COLUMN_PADDING) + $0996654c31bce5a9$var$NESTED_DND_GUTTER_OFFSET) * 2 : (0, $2onoM.LAYOUT_COLUMN_PADDING) * 2;
            break;
        case schema.nodes.bodiedExtension:
            parentWidth -= (0, $2smsR.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.extensionFrame:
            parentWidth -= (0, $2smsR.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.expand:
            // padding
            parentWidth -= $0996654c31bce5a9$var$GRID_SIZE * 2;
            // gutter offset
            parentWidth += $0996654c31bce5a9$var$GRID_SIZE * 3;
            // padding right
            parentWidth -= $0996654c31bce5a9$var$GRID_SIZE;
            // padding left
            parentWidth -= $0996654c31bce5a9$var$GRID_SIZE * 4 - $0996654c31bce5a9$var$GRID_SIZE / 2;
            break;
        case schema.nodes.tableCell:
        case schema.nodes.tableHeader:
            // Calculate the available column width
            if (Array.isArray(node.attrs.colwidth)) parentWidth = node.attrs.colwidth.slice(0, node.attrs.colspan).reduce((sum, width)=>sum + width, 0);
            // Compensate for padding
            parentWidth -= (0, $cjLtO.tableCellPadding) * 2;
            break;
    }
    parentWidth -= 2; // border
    return parentWidth;
};
const $0996654c31bce5a9$var$getNestedParentNode = (tablePos, state)=>{
    if (tablePos === undefined) return null;
    const $pos = state.doc.resolve(tablePos);
    const parent = (0, $BmspC.findParentNodeOfTypeClosestToPos)($pos, [
        state.schema.nodes.bodiedExtension,
        state.schema.nodes.extensionFrame,
        state.schema.nodes.layoutSection,
        state.schema.nodes.expand,
        state.schema.nodes.tableCell,
        state.schema.nodes.tableHeader
    ]);
    return parent ? parent.node : null;
};
const $0996654c31bce5a9$var$calcBreakoutNodeWidth = (layout, containerWidth, isFullWidthModeEnabled, breakoutWidth)=>{
    if (breakoutWidth && (0, $cbSL1.expValEquals)('platform_editor_nested_table_refresh_width_fix', 'isEnabled', true)) return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, breakoutWidth) : // --ak-editor--breakout-full-page-guttering-padding = (--ak-editor--large-gutter-padding * 2) + --ak-editor--default-gutter-padding
    Math.min(containerWidth.width - ((0, $7yBx7.akEditorGutterPaddingDynamic)() * 2 + (0, $7yBx7.akEditorGutterPadding)), breakoutWidth);
    return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, (0, $7yBx7.akEditorFullWidthLayoutWidth)) : (0, $bnh3n.absoluteBreakoutWidth)(layout, containerWidth.width);
};
const $0996654c31bce5a9$export$3930799be057b305 = (node)=>{
    if (node?.attrs.width) return node.attrs.width;
    return $0996654c31bce5a9$export$9b77d38feba5446[node?.attrs.layout] || (0, $7yBx7.akEditorDefaultLayoutWidth);
};
const $0996654c31bce5a9$export$9724081a0d43786a = (node, offset)=>{
    const isNumberColumnEnabled = node.attrs.isNumberColumnEnabled;
    if (isNumberColumnEnabled && offset > 0) return $0996654c31bce5a9$export$3930799be057b305(node) - offset;
    return $0996654c31bce5a9$export$3930799be057b305(node);
};

});
parcelRegister("2smsR", function(module, exports) {
$parcel$export(module.exports, "BODIED_EXT_PADDING", () => $811b7408671269e7$export$5ac5087fe1217160);
$parcel$export(module.exports, "BODIED_EXT_MBE_MARGIN_TOP", () => $811b7408671269e7$export$91624ec52c59c24c);
const $811b7408671269e7$export$f5ecdce4c60ff98b = 8;
const $811b7408671269e7$export$5ac5087fe1217160 = $811b7408671269e7$export$f5ecdce4c60ff98b * 2;
const $811b7408671269e7$export$91624ec52c59c24c = 12;

});

parcelRegister("2onoM", function(module, exports) {
$parcel$export(module.exports, "LAYOUT_SECTION_MARGIN", () => $916997c92af17d95$export$cd04f19842abff0);
$parcel$export(module.exports, "LAYOUT_COLUMN_PADDING", () => $916997c92af17d95$export$a1bb91aa2d5fcce8);
const $916997c92af17d95$export$cd04f19842abff0 = 8;
const $916997c92af17d95$export$a1bb91aa2d5fcce8 = $916997c92af17d95$export$cd04f19842abff0 * 1.5;
const $916997c92af17d95$export$e5ee675b2c7e739b = 50;

});


const $9a762f515f769003$export$12fd658e5eef0d79 = 32;
const $9a762f515f769003$export$74b525449cc7cbd1 = 'ai-streaming-telepointer';

parcelRegister("lzf9g", function(module, exports) {
$parcel$export(module.exports, "TableHeader", () => $63cf8e5030b59364$export$f850895b287ef28e);
$parcel$export(module.exports, "TableCell", () => $63cf8e5030b59364$export$1e4baea7053fc0e3);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4PpDP = parcelRequire("4PpDP");
var $e6HpD = parcelRequire("e6HpD");

var $58yRG = parcelRequire("58yRG");

var $hh2CV = parcelRequire("hh2CV");

var $kZPQ0 = parcelRequire("kZPQ0");

var $169DZ = parcelRequire("169DZ");

var $7ueoK = parcelRequire("7ueoK");

var $bMFKb = parcelRequire("bMFKb");

var $iRC0e = parcelRequire("iRC0e");

var $lRq8t = parcelRequire("lRq8t");

var $4Iw1X = parcelRequire("4Iw1X");
const $63cf8e5030b59364$var$IgnoreSorting = [
    'LABEL',
    'INPUT'
];
const $63cf8e5030b59364$var$nextStatusOrder = (currentSortOrder)=>{
    switch(currentSortOrder){
        case (0, $hh2CV.SortOrder).NO_ORDER:
            return (0, $hh2CV.SortOrder).ASC;
        case (0, $hh2CV.SortOrder).ASC:
            return (0, $hh2CV.SortOrder).DESC;
        case (0, $hh2CV.SortOrder).DESC:
            return (0, $hh2CV.SortOrder).NO_ORDER;
    }
    return (0, $hh2CV.SortOrder).NO_ORDER;
};
const $63cf8e5030b59364$var$getSortOrderLabel = (intl, currentSortOrder)=>{
    const { noneSortingLabel: noneSortingLabel, ascSortingLabel: ascSortingLabel, descSortingLabel: descSortingLabel } = (0, $4Iw1X.tableCellMessages);
    switch(currentSortOrder){
        case (0, $hh2CV.SortOrder).NO_ORDER:
            return intl.formatMessage(noneSortingLabel);
        case (0, $hh2CV.SortOrder).ASC:
            return intl.formatMessage(ascSortingLabel);
        case (0, $hh2CV.SortOrder).DESC:
            return intl.formatMessage(descSortingLabel);
        default:
            return intl.formatMessage(noneSortingLabel);
    }
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $63cf8e5030b59364$var$getDataAttributes = (colwidth, background)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const attrs = {};
    if (colwidth) attrs['data-colwidth'] = colwidth.join(',');
    /**
   * Storing hex code in data-cell-background because
   *  we want to have DST token (css variable) or
   *  DST token value (value (hex code) of css variable) in
   *  inline style to correct render table cell background
   *  based on selected theme.
   * Currently we rely on background color hex code stored in
   *  inline style.
   * Because of that when we copy and paste table, we end up
   *  having DST token or DST token value in ADF instead of
   *  original hex code which we map to DST token.
   * So, introducing data-cell-background.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ if (background) attrs['data-cell-background'] = background;
    return attrs;
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $63cf8e5030b59364$var$cssVariablePattern = /^var\(--.*\)$/;
const $63cf8e5030b59364$var$getStyle = ({ background: background, colGroupWidth: colGroupWidth, offsetTop: offsetTop, colorMode: colorMode })=>{
    const style = {};
    if (background && // ignore setting inline styles if ds neutral token is detected
    !background.includes('--ds-background-neutral')) {
        /**
     * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
     * backgrounds persisted.
     *
     * This feature predates the introduction of dark mode.
     *
     * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-cell-background), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $kZPQ0.hexToEditorBackgroundPaletteRawValue)(background);
        if (tokenColor) style.backgroundColor = tokenColor;
        else if (/**
     * There was previously a bug in dark mode where we would attempt to invert
     * a design token in `getDarkModeLCHColor` causing issues.
     * If it's a design token we should return it as is.
     */ $63cf8e5030b59364$var$cssVariablePattern.test(background)) style.backgroundColor = background;
        else // if we have a custom color, we need to check if we are in dark mode
        if (colorMode === 'dark') // if we are in dark mode, we need to invert the color
        style.backgroundColor = (0, $4PpDP.getDarkModeLCHColor)(background);
        else // if we are in light mode, we can just set the color
        style.backgroundColor = background;
    }
    if (colGroupWidth) {
        style.width = colGroupWidth;
        style.minWidth = colGroupWidth;
    }
    if (offsetTop !== undefined) style.top = offsetTop;
    return style;
};
const $63cf8e5030b59364$var$getWithCellProps = (WrapperComponent)=>{
    return function WithCellProps(props) {
        const { colorMode: colorMode } = (0, $58yRG.default)();
        const { children: children, className: className, onClick: onClick, colwidth: colwidth, colGroupWidth: colGroupWidth, rowspan: rowspan, colspan: colspan, background: background, offsetTop: offsetTop, ariaSort: ariaSort } = props;
        // This is used to set the background color of the cell
        // to a dark mode color in mobile dark mode
        const colorName = background ? (0, $e6HpD.tableBackgroundColorPalette).get(background) : '';
        return /*#__PURE__*/ (0, $gt9Am.jsx)(WrapperComponent, {
            rowSpan: rowspan,
            colSpan: colspan,
            // Note: When content from a renderer is pasted into an editor
            // the background color is not taken from the inline style.
            // Instead it is taken from the data-cell-background attribute
            // (added via getDataAttributes below).
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $63cf8e5030b59364$var$getStyle({
                background: background,
                colGroupWidth: colGroupWidth,
                offsetTop: offsetTop,
                colorMode: colorMode
            }),
            colorname: colorName,
            onClick: onClick,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ...$63cf8e5030b59364$var$getDataAttributes(colwidth, background),
            "aria-sort": ariaSort,
            children: children
        });
    };
};
const $63cf8e5030b59364$var$TH = $63cf8e5030b59364$var$getWithCellProps('th');
const $63cf8e5030b59364$export$cfca40ca5c56a38e = (WrapperComponent)=>{
    return function THWithSortableColumn(props) {
        const intl = (0, $lRq8t.default)();
        const { allowColumnSorting: allowColumnSorting, onSorting: onSorting, children: children, sortOrdered: sortOrdered, isHeaderRow: isHeaderRow } = props;
        const sortOrderedClassName = sortOrdered === (0, $hh2CV.SortOrder).NO_ORDER ? (0, $iRC0e.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER : '';
        if (!allowColumnSorting || !isHeaderRow) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $gt9Am.jsx)(WrapperComponent, {
            ...props
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)(WrapperComponent, {
            ...props,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $iRC0e.RendererCssClassName).SORTABLE_COLUMN_WRAPPER,
            ariaSort: $63cf8e5030b59364$var$getSortOrderLabel(intl, sortOrdered),
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                className: (0, $iRC0e.RendererCssClassName).SORTABLE_COLUMN,
                children: [
                    children,
                    /*#__PURE__*/ (0, $gt9Am.jsx)("figure", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: `${(0, $iRC0e.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER} ${sortOrderedClassName}`,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $169DZ.default), {
                            isSortingAllowed: !!onSorting,
                            sortOrdered: sortOrdered,
                            onClick: sort,
                            onKeyDown: onKeyPress
                        })
                    })
                ]
            })
        });
        function onKeyPress(event) {
            const keys = [
                ' ',
                'Enter',
                'Spacebar'
            ];
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const { tagName: tagName } = event.target;
            // trigger sorting if space or enter are clicked but not when in an input field (template variables)
            if (keys.includes(event.key) && !$63cf8e5030b59364$var$IgnoreSorting.includes(tagName)) {
                event.preventDefault();
                sort();
            }
        }
        function sort() {
            const { fireAnalyticsEvent: fireAnalyticsEvent, onSorting: onSorting, columnIndex: columnIndex, sortOrdered: sortOrdered } = props;
            if (onSorting && columnIndex != null) {
                const sortOrder = $63cf8e5030b59364$var$nextStatusOrder(sortOrdered);
                onSorting(columnIndex, sortOrder);
                fireAnalyticsEvent && fireAnalyticsEvent({
                    action: (0, $bMFKb.ACTION).SORT_COLUMN,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).TABLE,
                    attributes: {
                        platform: (0, $7ueoK.PLATFORM).WEB,
                        mode: (0, $7ueoK.MODE).RENDERER,
                        columnIndex: columnIndex,
                        sortOrder: sortOrder
                    },
                    eventType: (0, $bMFKb.EVENT_TYPE).TRACK
                });
            } else fireAnalyticsEvent && fireAnalyticsEvent({
                action: (0, $bMFKb.ACTION).SORT_COLUMN_NOT_ALLOWED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).TABLE,
                attributes: {
                    platform: (0, $7ueoK.PLATFORM).WEB,
                    mode: (0, $7ueoK.MODE).RENDERER
                },
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK
            });
        }
    };
};
const $63cf8e5030b59364$export$f850895b287ef28e = $63cf8e5030b59364$export$cfca40ca5c56a38e($63cf8e5030b59364$var$TH);
const $63cf8e5030b59364$var$TD = $63cf8e5030b59364$var$getWithCellProps('td');
const $63cf8e5030b59364$export$1e4baea7053fc0e3 = $63cf8e5030b59364$var$TD;

});
parcelRegister("169DZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $7d4b1c665a79444b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");

var $k71qx = parcelRequire("k71qx");

var $hh2CV = parcelRequire("hh2CV");


var $lLPRx = parcelRequire("lLPRx");
function $7d4b1c665a79444b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $7d4b1c665a79444b$export$c3618f310f725028 = /*#__PURE__*/ function(StatusClassNames) {
    StatusClassNames["ASC"] = "sorting-icon-svg__asc";
    StatusClassNames["DESC"] = "sorting-icon-svg__desc";
    StatusClassNames["NO_ORDER"] = "sorting-icon-svg__no_order";
    StatusClassNames["SORTING_NOT_ALLOWED"] = "sorting-icon-svg__not-allowed";
    return StatusClassNames;
}({});
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $7d4b1c665a79444b$var$buttonStyles = /*#__PURE__*/ (0, $1NIU8.css)("position:absolute;display:flex;height:28px;width:28px;margin:var(--ds-space-075, 6px);right:0;top:0;border:var(--ds-border-width-selected, 2px) solid var(--ds-border, #fff);border-radius:var(--ds-radius-small, 4px);background-color:var(--ds-surface-overlay, #FFFFFF);justify-content:center;align-items:center;cursor:pointer;&:hover{background-color:var(--ds-surface-overlay-hovered, #F1F2F4);}&:active{background-color:var(--ds-surface-overlay-pressed, rgba(179, 212, 255, 0.6));}&.", (0, $438179c68884651b$export$bd4f24d8b1e86b23), "__not-allowed{cursor:not-allowed;}");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $7d4b1c665a79444b$var$iconWrapperStyles = /*#__PURE__*/ (0, $1NIU8.css)("width:8px;height:12px;transition:transform 0.3s cubic-bezier(0.15, 1, 0.3, 1);transform-origin:50% 50%;display:flex;justify-content:center;&.", "sorting-icon-svg__desc", "{transform:rotate(-180deg);}&.", (0, $438179c68884651b$export$bd4f24d8b1e86b23), "-inactive{opacity:0.7;}");
// The icon is created with CSS due to the following Firefox issue: https://product-fabric.atlassian.net/browse/ED-8001
// The TL;DR is that svg's in tables mess up how HTML is copied in Firefox. Using a styled div instead solves the problem.
// For this reason, svg's should be avoided in tables until this issue is fixed: https://bugzilla.mozilla.org/show_bug.cgi?id=1664350
const $7d4b1c665a79444b$var$iconStyles = {
    name: "1fasfp6",
    styles: "height:100%;width:2px;border-radius:var(--ds-radius-full, 9999px);background:var(--ds-icon, #42526E);user-select:none;&::before, &::after{background:var(--ds-icon, #42526E);content:'';height:2px;width:6px;position:absolute;border-radius:var(--ds-radius-full, 9999px);}&::before{transform:rotate(45deg) translate(3.4px, 8.5px);}&::after{transform:rotate(-45deg) translate(-6.3px, 5.7px);}"
};
const $7d4b1c665a79444b$var$getIconClassName = (isSortingAllowed, sortOrdered)=>{
    const activated = sortOrdered !== (0, $hh2CV.SortOrder).NO_ORDER;
    const activeStatusClass = `${(0, $438179c68884651b$export$bd4f24d8b1e86b23)}-${activated ? 'active' : 'inactive'}`;
    if (!isSortingAllowed) return `${"sorting-icon-svg__not-allowed"} ${activeStatusClass}`;
    switch(sortOrdered){
        case (0, $hh2CV.SortOrder).ASC:
            return `${"sorting-icon-svg__asc"} ${activeStatusClass}`;
        case (0, $hh2CV.SortOrder).DESC:
            return `${"sorting-icon-svg__desc"} ${activeStatusClass}`;
        default:
            return `${"sorting-icon-svg__no_order"} ${activeStatusClass}`;
    }
};
const $7d4b1c665a79444b$var$getTooltipTitle = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel } = (0, $lLPRx.sortingIconMessages);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $hh2CV.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $hh2CV.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $hh2CV.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return '';
};
const $7d4b1c665a79444b$var$getAriaLabel = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel, defaultLabel: defaultLabel } = (0, $lLPRx.sortingAriaLabelMessages);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $hh2CV.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $hh2CV.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $hh2CV.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return intl.formatMessage(defaultLabel);
};
const $7d4b1c665a79444b$var$SortingIcon = ({ isSortingAllowed: isSortingAllowed, sortOrdered: sortOrdered, intl: intl, onClick: onClick, onKeyDown: onKeyDown })=>{
    const buttonClassName = `${(0, $438179c68884651b$export$bd4f24d8b1e86b23)} ${sortOrdered !== (0, $hh2CV.SortOrder).NO_ORDER ? 'is-active' : ''}${isSortingAllowed ? '' : ` ${0, $438179c68884651b$export$bd4f24d8b1e86b23}__not-allowed `}`;
    const content = $7d4b1c665a79444b$var$getTooltipTitle(intl, isSortingAllowed, sortOrdered);
    const ariaLabel = $7d4b1c665a79444b$var$getAriaLabel(intl, isSortingAllowed, sortOrdered);
    const handleClick = ()=>{
        if (isSortingAllowed) onClick();
    };
    const handleKeyDown = (event)=>{
        if (isSortingAllowed) onKeyDown(event);
    };
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k71qx.default), {
        delay: 0,
        content: content,
        position: "top"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $7d4b1c665a79444b$var$buttonStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: buttonClassName,
        role: "button",
        tabIndex: isSortingAllowed ? 0 : -1,
        "aria-label": ariaLabel,
        "aria-disabled": !isSortingAllowed,
        "aria-hidden": !isSortingAllowed,
        onClick: handleClick,
        onKeyDown: handleKeyDown
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $7d4b1c665a79444b$var$iconWrapperStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $7d4b1c665a79444b$var$getIconClassName(isSortingAllowed, sortOrdered)
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            $7d4b1c665a79444b$var$iconStyles
        ]
    }))));
};
var $7d4b1c665a79444b$export$2e2bcd8739ae039 = (0, $6YFG2.default)($7d4b1c665a79444b$var$SortingIcon);

});
const $438179c68884651b$export$bd4f24d8b1e86b23 = `ak-renderer-tableHeader-sorting-icon`;

parcelRegister("lLPRx", function(module, exports) {
$parcel$export(module.exports, "sortingIconMessages", () => $f5c57691b59ca4ae$export$458c50917513cd1a);
$parcel$export(module.exports, "sortingAriaLabelMessages", () => $f5c57691b59ca4ae$export$f142573f51a67577);

var $7qGN1 = parcelRequire("7qGN1");
const $f5c57691b59ca4ae$export$458c50917513cd1a = (0, $7qGN1.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.headingLink.noOrderLabel',
        defaultMessage: 'Sort column A to Z',
        description: 'Sort the column in ascending order'
    },
    ascOrderLabel: {
        id: 'fabric.editor.headingLink.ascOrderLabel',
        defaultMessage: 'Sort column Z to A',
        description: 'Sort the column in descending order'
    },
    descOrderLabel: {
        id: 'fabric.editor.headingLink.descOrderLabel',
        defaultMessage: 'Clear sorting',
        description: 'clear the sorting from this column'
    },
    invalidLabel: {
        id: 'fabric.editor.headingLink.invalidLabel',
        defaultMessage: `\u{26A0}\u{FE0F}  You can't sort a table with merged cells`,
        description: 'this sort is invalid for merged cells'
    }
});
const $f5c57691b59ca4ae$export$f142573f51a67577 = (0, $7qGN1.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.no',
        defaultMessage: 'No sort applied to the column',
        description: 'Aria-label for Sort column button when sorting was not applied or the sorting has been cleared'
    },
    ascOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.asc',
        defaultMessage: 'Ascending sort applied',
        description: 'Aria-label for Sort column button when ascending sorting was applied'
    },
    descOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.desc',
        defaultMessage: 'Descending sort applied',
        description: 'Aria-label for Sort column button when descending sorting was applied'
    },
    invalidLabel: {
        id: 'fabric.editor.tableHeader.sorting.invalid',
        defaultMessage: `You can't sort a table with merged cells`,
        description: 'Aria-label for Sort column button when sorting is not possible'
    },
    defaultLabel: {
        id: 'fabric.editor.tableHeader.sorting.default',
        defaultMessage: 'Sort the column',
        description: 'Default aria-label for Sort column button'
    }
});

});



parcelRegister("dZ1mQ", function(module, exports) {
$parcel$export(module.exports, "Provider", () => $74c87a508e26c9e0$export$2881499e37b75b9a);
$parcel$export(module.exports, "withSmartCardStorage", () => $74c87a508e26c9e0$export$65e2d5a272a382b0);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $74c87a508e26c9e0$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(new Map());
const $74c87a508e26c9e0$export$2881499e37b75b9a = function({ children: children }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)($74c87a508e26c9e0$export$841858b892ce1f4c.Provider, {
        value: new Map(),
        children: children
    });
};
const $74c87a508e26c9e0$export$65e2d5a272a382b0 = (WrappedComponent)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/prefer-stateless-function
    return class extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
        render() {
            return /*#__PURE__*/ (0, $gt9Am.jsx)($74c87a508e26c9e0$export$841858b892ce1f4c.Consumer, {
                children: (storage)=>/*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
                        ...this.props,
                        smartCardStorage: storage
                    })
            });
        }
    };
};

});

parcelRegister("177xQ", function(module, exports) {
$parcel$export(module.exports, "tableStickyPadding", () => $428fa281f6d943ea$export$3de6413b528017ca);
$parcel$export(module.exports, "StickyTable", () => $428fa281f6d943ea$export$fd9654fc359d55a3);
$parcel$export(module.exports, "OverflowParent", () => $428fa281f6d943ea$export$e97bc6692974bd0b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $cjLtO = parcelRequire("cjLtO");

var $7yBx7 = parcelRequire("7yBx7");


var $hpXI5 = parcelRequire("hpXI5");

var $daWoF = parcelRequire("daWoF");
function $428fa281f6d943ea$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $428fa281f6d943ea$export$3de6413b528017ca = 8;
const $428fa281f6d943ea$var$modeSpecficStyles = {
    none: {
        name: "eivff4",
        styles: "display:none"
    },
    stick: {
        name: "duudsh",
        styles: "position:fixed"
    },
    'pin-bottom': {
        name: "a4hmbt",
        styles: "position:absolute"
    }
};
// refactored based on fixedTableDivStaticStyles
// TODO: DSP-4123 - Quality ticket
const $428fa281f6d943ea$var$fixedTableDivStaticStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    zIndex: 'var(--ak-renderer-sticky-header-zindex)',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER}, & .${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        marginTop: 0,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        tr: {
            background: "var(--ds-surface, white)"
        }
    },
    borderTop: `${$428fa281f6d943ea$export$3de6413b528017ca}px solid ${"var(--ds-surface, white)"}`,
    background: "var(--ds-surface-overlay, white)",
    boxShadow: `0 6px 4px -4px ${`var(--ds-shadow-overflow-perimeter, ${(0, $7bb4c1736002a04a$export$46987b49aab6d1a8)})`}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "div[data-expanded='false'] &": {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.right-shadow::after, & .${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.left-shadow::before`]: {
        top: '0px',
        height: '100%'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "&.fixed-table-div-custom-table-resizing[mode='stick']": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: 'var(--ak-renderer-sticky-header-zindex)'
    }
});
const $428fa281f6d943ea$var$FixedTableDiv = (props)=>{
    const { top: top, wrapperWidth: wrapperWidth, mode: mode, allowTableResizing: allowTableResizing } = props;
    let stickyHeaderZIndex;
    if (allowTableResizing) stickyHeaderZIndex = 13;
    else stickyHeaderZIndex = (0, $7yBx7.akEditorStickyHeaderZIndex);
    const attrs = {
        mode: mode
    };
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        ...attrs,
        "data-testid": "sticky-table-fixed",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: allowTableResizing ? 'fixed-table-div-custom-table-resizing' : '',
        css: [
            $428fa281f6d943ea$var$fixedTableDivStaticStyles,
            $428fa281f6d943ea$var$modeSpecficStyles?.[mode]
        ],
        style: {
            '--ak-renderer-sticky-header-zindex': stickyHeaderZIndex,
            width: `${wrapperWidth}px`,
            top: typeof top === 'number' ? `${top}px` : undefined
        }
    }, props.children);
};
const $428fa281f6d943ea$export$fd9654fc359d55a3 = ({ top: top, left: left, mode: mode, shadowClassNames: shadowClassNames, innerRef: innerRef, wrapperWidth: wrapperWidth, tableWidth: tableWidth, isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, children: children, columnWidths: columnWidths, renderWidth: renderWidth, rowHeight: rowHeight, tableNode: tableNode, rendererAppearance: rendererAppearance, allowTableResizing: allowTableResizing, fixTableSSRResizing: fixTableSSRResizing = false })=>{
    let styles;
    /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ if (allowTableResizing) styles = /*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'absolute'
    });
    else styles = /*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        left: left && left < 0 ? left : undefined,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'relative'
    });
    /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: styles
    }, /*#__PURE__*/ (0, $1NIU8.jsx)($428fa281f6d943ea$var$FixedTableDiv, {
        top: mode === 'stick' ? top : undefined,
        mode: rowHeight > 300 ? 'none' : mode,
        wrapperWidth: wrapperWidth,
        allowTableResizing: allowTableResizing
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER} is-sticky ${shadowClassNames || ''}`,
        "data-layout": layout,
        style: {
            width: tableWidth,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginBottom: fixTableSSRResizing ? 0 : ''
        }
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_WRAPPER}`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $hpXI5.Table), {
        columnWidths: columnWidths,
        layout: layout,
        isNumberColumnEnabled: isNumberColumnEnabled,
        renderWidth: renderWidth,
        tableNode: tableNode,
        rendererAppearance: rendererAppearance,
        fixTableSSRResizing: fixTableSSRResizing
    }, /**
               * @see https://product-fabric.atlassian.net/browse/ED-10235
               * We pass prop 'invisible' to our table's children nodes meaning
               * they exist inside of the 'invisible' duplicated table component that
               * enables sticky headers.
               */ (0, $daWoF.recursivelyInjectProps)(children, {
        invisible: true
    })))))));
};
/**
 * Traverse DOM Tree upwards looking for table parents with "overflow: scroll".
 * @param table
 * @param defaultScrollRootId
 * @example
 */ function $428fa281f6d943ea$var$findHorizontalOverflowScrollParent(table, defaultScrollRootId) {
    let parent = table;
    if (!parent) return null;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while(parent = parent.parentElement){
        // IE11 on Window 8 doesn't show styles from CSS when accessing through element.style property.
        const style = window.getComputedStyle(parent);
        if (style.overflow === 'scroll' || style.overflowY === 'scroll') return parent;
        if (!!defaultScrollRootId && parent.id === defaultScrollRootId) // If a defaultScrollRootId was specified and we reached the element with this id without finding a closer
        // scroll parent, use this element as the scroll parent
        return parent;
    }
    return null;
}
class $428fa281f6d943ea$export$e97bc6692974bd0b {
    constructor(ref){
        this.ref = ref;
        this.ref = ref;
    }
    /**
   *
   * @param el
   * @param defaultScrollRootId
   * @example
   */ static fromElement(el, defaultScrollRootId) {
        return new $428fa281f6d943ea$export$e97bc6692974bd0b($428fa281f6d943ea$var$findHorizontalOverflowScrollParent(el, defaultScrollRootId) || window);
    }
    /**
   *
   */ get isElement() {
        return this.ref instanceof HTMLElement;
    }
    /**
   *
   */ get id() {
        if (this.ref instanceof HTMLElement) return this.ref.id;
        return '';
    }
    /**
   *
   */ get top() {
        if (this.ref instanceof HTMLElement) return this.ref.getBoundingClientRect().top;
        return 0;
    }
    /**
   *
   * @param type
   * @param cb
   * @param {...any} args
   * @example
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    addEventListener(type, cb, ...args) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.ref.addEventListener(type, cb, ...args);
    }
    /**
   *
   * @param type
   * @param cb
   * @param {...any} args
   * @example
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    removeEventListener(type, cb, ...args) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.ref.removeEventListener(type, cb, ...args);
    }
}

});
parcelRegister("hpXI5", function(module, exports) {
$parcel$export(module.exports, "Table", () => $73248f20006ee04a$export$54ec01a60f47d33d);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5X2BQ = parcelRequire("5X2BQ");

var $68RqK = parcelRequire("68RqK");

var $7yBx7 = parcelRequire("7yBx7");

var $eGOwo = parcelRequire("eGOwo");
const $73248f20006ee04a$export$54ec01a60f47d33d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ innerRef: innerRef, isNumberColumnEnabled: isNumberColumnEnabled, columnWidths: columnWidths, layout: layout, renderWidth: renderWidth, children: children, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableResizing: allowTableResizing, isPresentational: isPresentational, fixTableSSRResizing: fixTableSSRResizing = false })=>{
    let tableWidth = tableNode ? (0, $68RqK.getTableContainerWidth)(tableNode) : (0, $7yBx7.akEditorDefaultLayoutWidth);
    let tableColumnWidths = columnWidths;
    if (rendererAppearance === 'comment' && allowTableResizing && tableNode && !tableNode.attrs?.width) tableWidth = 'inherit';
    if (rendererAppearance === 'comment' && !allowTableResizing) // in the case we have css container stylings,
    // we don't need to calculate width here as this
    // is done via css
    {
        if (!(0, $eGOwo.fg)('platform-ssr-table-resize')) tableWidth = renderWidth;
    }
    // for columns that are evenly distributed, do not return `colgroup` since existing table containerQuery
    // scales up the columns width. This ensures columns always have 42px.
    if (rendererAppearance === 'comment') // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    {
        if ((0, $eGOwo.fg)('platform-ssr-table-resize') && (0, $eGOwo.fg)('platform_table_number_column')) tableColumnWidths = columnWidths && (0, $5X2BQ.colWidthSum)(columnWidths) ? columnWidths : undefined;
    }
    const tableLayout = tableNode?.attrs.layout;
    const tableDisplayMode = tableNode?.attrs.displayMode;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("table", {
        ...(0, $eGOwo.fg)('platform_renderer_isPresentational') && {
            role: isPresentational ? 'presentation' : undefined
        },
        "data-testid": "renderer-table",
        "data-number-column": isNumberColumnEnabled,
        "data-table-width": tableWidth,
        "data-layout": tableLayout,
        "data-table-display-mode": tableDisplayMode,
        ref: innerRef,
        style: {
            marginTop: fixTableSSRResizing ? '0px' : ''
        },
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5X2BQ.Colgroup), {
                columnWidths: tableColumnWidths,
                layout: layout,
                isNumberColumnEnabled: isNumberColumnEnabled,
                renderWidth: renderWidth,
                tableNode: tableNode,
                rendererAppearance: rendererAppearance,
                isInsideOfBlockNode: isInsideOfBlockNode,
                isInsideOfTable: isInsideOfTable,
                isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                allowTableResizing: allowTableResizing
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("tbody", {
                children: children
            })
        ]
    });
});

});
parcelRegister("5X2BQ", function(module, exports) {
$parcel$export(module.exports, "colWidthSum", () => $f206524cd9dc600c$export$2d9bdaa5b8cd99f0);
$parcel$export(module.exports, "Colgroup", () => $f206524cd9dc600c$export$89efc2d0ceeaa030);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $cjLtO = parcelRequire("cjLtO");

var $7yBx7 = parcelRequire("7yBx7");

var $92xoS = parcelRequire("92xoS");

var $68RqK = parcelRequire("68RqK");

var $bMc4v = parcelRequire("bMc4v");

var $RTnFt = parcelRequire("RTnFt");

var $eGOwo = parcelRequire("eGOwo");

var $cbSL1 = parcelRequire("cbSL1");
// we allow scaling down column widths by no more than 30%
// this intends to reduce unwanted scrolling in the Renderer in these scenarios:
// User A creates a table with column widths → User B views it on a smaller screen
// User A creates a table with column widths → User A views it with reduced viewport space (eg. Confluence sidebar is open)
const $f206524cd9dc600c$var$MAX_SCALING_PERCENT = 0.3;
const $f206524cd9dc600c$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION = 0.4;
const $f206524cd9dc600c$var$isTableColumnResized = (columnWidths)=>{
    const filteredWidths = columnWidths.filter((width)=>width !== 0);
    return !!filteredWidths.length;
};
const $f206524cd9dc600c$var$fixColumnWidth = ({ columnWidth: columnWidth, zeroWidthColumnsCount: zeroWidthColumnsCount, scaleDownPercent: scaleDownPercent })=>{
    if (columnWidth === 0) return columnWidth;
    // If the tables total width (including no zero widths col or cols without width) is less than the current layout
    // We scale up the columns to meet the minimum of the table layout.
    if (zeroWidthColumnsCount === 0 && scaleDownPercent) return Math.max(Math.floor((1 - scaleDownPercent) * columnWidth), (0, $cjLtO.tableCellMinWidth));
    return Math.max(// We need to take tableCellBorderWidth, to avoid unnecessary overflow.
    columnWidth - (0, $cjLtO.tableCellBorderWidth), zeroWidthColumnsCount ? (0, $7yBx7.akEditorTableLegacyCellMinWidth) : (0, $cjLtO.tableCellMinWidth));
};
const $f206524cd9dc600c$var$calcScalePercent = ({ renderWidth: renderWidth, tableWidth: tableWidth, maxScale: maxScale, isNumberColumnEnabled: isNumberColumnEnabled })=>{
    const noNumColumnScalePercent = renderWidth / tableWidth;
    // when numbered column is enabled, we need to calculate the scale percent without the akEditorTableNumberColumnWidth
    // As numbered column width is not scaled down
    const numColumnScalePercent = (renderWidth - (0, $7yBx7.akEditorTableNumberColumnWidth)) / (tableWidth - (0, $7yBx7.akEditorTableNumberColumnWidth));
    const diffPercent = 1 - noNumColumnScalePercent;
    return diffPercent < maxScale ? isNumberColumnEnabled ? 1 - numColumnScalePercent : diffPercent : maxScale;
};
const $f206524cd9dc600c$export$2d9bdaa5b8cd99f0 = (columnWidths)=>columnWidths.reduce((prev, curr)=>curr + prev, 0);
const $f206524cd9dc600c$var$renderScaleDownColgroup = (props)=>{
    const { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled, renderWidth: renderWidth, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, isTableScalingEnabled: isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer } = props;
    if (!columnWidths || columnWidths.every((width)=>width === 0) && (0, $eGOwo.fg)('platform_editor_numbered_column_in_include')) return [];
    const tableColumnResized = $f206524cd9dc600c$var$isTableColumnResized(columnWidths);
    const noOfColumns = columnWidths.length;
    let targetWidths;
    // This is a fix for ED-23259
    // Some extensions (for ex: Page Properties or Excerpt) do not renderer tables directly inside themselves. They use ReactRenderer.
    // So if we add a check like isInsideExtension (similar to exising isInsideBlockNode), it will fail, and to the only way to learn
    // if the table is rendered inside another node, is to check if the Renderer itself is nested.
    const isRendererNested = isTopLevelRenderer === false;
    // appearance == comment && allowTableResizing && !tableNode?.attrs.width, means it is a comment
    // appearance == comment && !allowTableResizing && !tableNode?.attrs.width, means it is a inline comment
    // When comment and inline comment table width inherits from the parent container, we want tableContainerWidth === renderWidth
    // Tables with numbered columns inside of extensions cannot use the renderWidth when it is 0. In this case, it should
    // explicitly use the width coming from the table node as the final table container width.
    const tableContainerWidth = rendererAppearance === 'comment' && !tableNode?.attrs.width || isRendererNested && (!(0, $eGOwo.fg)('platform_fix_nested_num_column_scaling') || !isNumberColumnEnabled) ? renderWidth : (0, $68RqK.getTableContainerWidth)(tableNode);
    if (allowTableResizing && !isInsideOfBlockNode && !isInsideOfTable && !isinsideMultiBodiedExtension && !tableColumnResized) {
        // when no columns are resized, each column should have equal width, equals to tableWidth / noOfColumns
        const tableWidth = (isNumberColumnEnabled ? tableContainerWidth - (0, $7yBx7.akEditorTableNumberColumnWidth) : tableContainerWidth) - 1;
        const defaultColumnWidth = tableWidth / noOfColumns;
        targetWidths = new Array(noOfColumns).fill(defaultColumnWidth);
    } else if (!tableColumnResized) return null;
    const sumOfColumns = $f206524cd9dc600c$export$2d9bdaa5b8cd99f0(columnWidths);
    // tables in the wild may be smaller than table container width (col resizing bugs, created before custom widths etc.)
    // this causes issues with num column scaling as we add a new table column in renderer
    const isTableSmallerThanContainer = sumOfColumns < tableContainerWidth - 1;
    const forceScaleForNumColumn = isTableScalingEnabled && isNumberColumnEnabled && tableColumnResized;
    // when table resized and number column is enabled, we need to scale down the table in render
    if (forceScaleForNumColumn) {
        const calculatedTableContainerWidth = rendererAppearance === 'comment' ? sumOfColumns : tableContainerWidth;
        const scalePercentage = +((calculatedTableContainerWidth - (0, $7yBx7.akEditorTableNumberColumnWidth)) / calculatedTableContainerWidth);
        const targetMaxWidth = calculatedTableContainerWidth - (0, $7yBx7.akEditorTableNumberColumnWidth);
        let totalWidthAfterScale = 0;
        const newScaledTargetWidths = columnWidths.map((width)=>{
            // we need to scale each column UP, to ensure total width of table matches table container
            const patchedWidth = isTableSmallerThanContainer ? width / sumOfColumns * (calculatedTableContainerWidth - 1) : width;
            const newWidth = Math.floor(patchedWidth * scalePercentage);
            totalWidthAfterScale += newWidth;
            return newWidth;
        });
        const diff = targetMaxWidth - totalWidthAfterScale;
        targetWidths = newScaledTargetWidths;
        if (diff > 0 || diff < 0 && Math.abs(diff) < (0, $cjLtO.tableCellMinWidth)) {
            let updated = false;
            targetWidths = targetWidths.map((width)=>{
                if (!updated && width + diff > (0, $cjLtO.tableCellMinWidth)) {
                    updated = true;
                    width += diff;
                }
                return width;
            });
        }
    }
    targetWidths = targetWidths || columnWidths;
    // @see ED-6056
    const maxTableWidth = renderWidth < tableContainerWidth ? renderWidth : tableContainerWidth;
    let tableWidth = isNumberColumnEnabled ? (0, $7yBx7.akEditorTableNumberColumnWidth) : 0;
    let minTableWidth = tableWidth;
    let zeroWidthColumnsCount = 0;
    targetWidths.forEach((width)=>{
        if (width) tableWidth += Math.ceil(width);
        else zeroWidthColumnsCount += 1;
        minTableWidth += Math.ceil(width) || (0, $7yBx7.akEditorTableLegacyCellMinWidth);
    });
    let cellMinWidth = 0;
    let scaleDownPercent = 0;
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
    const isTableWidthFixed = isTableScalingWithFixedColumnWidthsOptionEnabled && props.tableNode?.attrs.displayMode === 'fixed';
    const maxScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && rendererAppearance === 'comment' ? $f206524cd9dc600c$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION : $f206524cd9dc600c$var$MAX_SCALING_PERCENT;
    // fixes migration tables with zero-width columns
    if (zeroWidthColumnsCount > 0) {
        if (minTableWidth > maxTableWidth) {
            const minWidth = Math.ceil((maxTableWidth - tableWidth) / zeroWidthColumnsCount);
            cellMinWidth = minWidth < (0, $7yBx7.akEditorTableLegacyCellMinWidth) ? (0, $7yBx7.akEditorTableLegacyCellMinWidth) : minWidth;
        }
    } else if (renderWidth < tableWidth && !isTableWidthFixed) {
        const shouldTable100ScaleDown = rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width;
        scaleDownPercent = $f206524cd9dc600c$var$calcScalePercent({
            renderWidth: renderWidth,
            tableWidth: tableWidth,
            maxScale: (0, $eGOwo.fg)('platform-ssr-table-resize') ? maxScalingPercent : shouldTable100ScaleDown ? 1 : maxScalingPercent,
            isNumberColumnEnabled: isNumberColumnEnabled
        });
    }
    if (isNumberColumnEnabled && (tableWidth < maxTableWidth || maxTableWidth === 0) && (0, $cbSL1.expValEquals)('editor_prevent_numbered_column_too_big_jira_1', 'isEnabled', true)) {
        const fixedColWidths = targetWidths.map((width)=>$f206524cd9dc600c$var$fixColumnWidth({
                columnWidth: width,
                zeroWidthColumnsCount: zeroWidthColumnsCount,
                scaleDownPercent: scaleDownPercent
            }) || cellMinWidth);
        const sumFixedColumnWidths = $f206524cd9dc600c$export$2d9bdaa5b8cd99f0(fixedColWidths);
        return fixedColWidths.map((colWidth)=>{
            const width = Math.max(colWidth, cellMinWidth);
            if (colWidth > (0, $7yBx7.akEditorTableCellMinWidth)) // To make sure the numbered column isn't scaled, use
            // percentages for the other columns.
            // Calculate the percentage based on the sum of the fixed column widths
            return {
                width: `${width / sumFixedColumnWidths * 100}%`
            };
            else {
                // If the column is equal to or less than the minimum cell width, we need to return a fixed pixel width.
                // This is to prevent columns being scaled below the minimum cell width.
                const style = width ? {
                    width: `${width}px`
                } : {};
                return style;
            }
        });
    }
    /**
	 * When cleaning up editor_prevent_numbered_column_too_big_jira_1 experiment,
	 * resuse the fixedColWidths const to avoid code duplication.
	 */ return targetWidths.map((colWidth)=>{
        const width = $f206524cd9dc600c$var$fixColumnWidth({
            columnWidth: colWidth,
            zeroWidthColumnsCount: zeroWidthColumnsCount,
            scaleDownPercent: scaleDownPercent
        }) || cellMinWidth;
        const style = width ? {
            width: `${width}px`
        } : {};
        return style;
    });
};
const $f206524cd9dc600c$export$89efc2d0ceeaa030 = (props)=>{
    const { isTopLevelRenderer: isTopLevelRenderer } = (0, $RTnFt.useRendererContext)();
    const { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled } = props;
    const flags = (0, $bMc4v.useFeatureFlags)();
    if (!columnWidths) return null;
    const colStyles = $f206524cd9dc600c$var$renderScaleDownColgroup({
        ...props,
        isTopLevelRenderer: isTopLevelRenderer,
        isTableScalingEnabled: props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width' || props.rendererAppearance === 'comment' && (0, $92xoS.editorExperiment)('support_table_in_comment', true, {
            exposure: true
        }) || props.rendererAppearance === 'comment' && (0, $92xoS.editorExperiment)('support_table_in_comment_jira', true, {
            exposure: true
        }),
        isTableFixedColumnWidthsOptionEnabled: !!(flags && 'tableWithFixedColumnWidthsOption' in flags && flags.tableWithFixedColumnWidthsOption) && (props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width')
    });
    if (!colStyles) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("colgroup", {
        children: [
            isNumberColumnEnabled && /*#__PURE__*/ (0, $gt9Am.jsx)("col", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                style: {
                    width: (0, $7yBx7.akEditorTableNumberColumnWidth)
                },
                "data-test-id": 'num'
            }),
            colStyles.map((style, idx)=>// Ignored via go/ees005
                // eslint-disable-next-line react/no-array-index-key, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $gt9Am.jsx)("col", {
                    style: style
                }, idx))
        ]
    });
};

});
parcelRegister("bMc4v", function(module, exports) {
$parcel$export(module.exports, "useFeatureFlags", () => $cd26d1764c39db20$export$90335b3ff08f335);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $RTnFt = parcelRequire("RTnFt");
const $cd26d1764c39db20$export$90335b3ff08f335 = ()=>(0, $RTnFt.useRendererContext)()?.featureFlags;

});
parcelRegister("RTnFt", function(module, exports) {
$parcel$export(module.exports, "useRendererContext", () => $168a8c218e1e34ec$export$a906432540ed7ed8);
$parcel$export(module.exports, "RendererContextProvider", () => $168a8c218e1e34ec$export$ca5df47902194781);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $eJOHy = parcelRequire("eJOHy");
const $168a8c218e1e34ec$var$RendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext({});
const $168a8c218e1e34ec$export$a906432540ed7ed8 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext($168a8c218e1e34ec$var$RendererContext);
const $168a8c218e1e34ec$export$ca5df47902194781 = $168a8c218e1e34ec$var$RendererContext.Provider;

});




parcelRegister("daWoF", function(module, exports) {
$parcel$export(module.exports, "recursivelyInjectProps", () => $f4a7ec86790d5a0e$export$40e12ce8e0a76b0c);

var $eJOHy = parcelRequire("eJOHy");
function $f4a7ec86790d5a0e$export$40e12ce8e0a76b0c(children, propsToInject) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children).map((child)=>{
        // Cannot add a prop to an invalid element, so just return the child
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) return child;
        // Recursive call if child has nested children
        if (child.props.children) child = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(child, {
            children: $f4a7ec86790d5a0e$export$40e12ce8e0a76b0c(child.props.children, propsToInject)
        });
        // Add props to react child node
        return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(child, propsToInject);
    });
}

});


parcelRegister("3xZmi", function(module, exports) {
$parcel$export(module.exports, "isFullWidthAppearance", () => $94795b49a3b496cd$export$c0112b8340d4924b);
$parcel$export(module.exports, "isFullPageAppearance", () => $94795b49a3b496cd$export$a64737a81cde10b4);
$parcel$export(module.exports, "isCommentAppearance", () => $94795b49a3b496cd$export$f77d2ff45b2c53ed);
$parcel$export(module.exports, "isFullWidthOrFullPageAppearance", () => $94795b49a3b496cd$export$33331a99fac775a1);
const $94795b49a3b496cd$export$c0112b8340d4924b = (appearance)=>appearance === 'full-width';
const $94795b49a3b496cd$export$a64737a81cde10b4 = (appearance)=>appearance === 'full-page';
const $94795b49a3b496cd$export$f77d2ff45b2c53ed = (appearance)=>appearance === 'comment';
const $94795b49a3b496cd$export$33331a99fac775a1 = (appearance)=>$94795b49a3b496cd$export$a64737a81cde10b4(appearance) || $94795b49a3b496cd$export$c0112b8340d4924b(appearance);

});

parcelRegister("hxOCd", function(module, exports) {
$parcel$export(module.exports, "TableStickyScrollbar", () => $aaed5ba788d3113a$export$8c072780619cfc83);

var $cjLtO = parcelRequire("cjLtO");

var $eGOwo = parcelRequire("eGOwo");
class $aaed5ba788d3113a$export$8c072780619cfc83 {
    constructor(wrapper){
        this.sentinels = {};
        this.handleScroll = (event)=>{
            if (!this.stickyScrollbarContainerElement || !this.wrapper || event.target !== this.stickyScrollbarContainerElement) return;
            this.wrapper.scrollLeft = this.stickyScrollbarContainerElement.scrollLeft;
        };
        this.wrapper = wrapper;
        this.init();
    }
    dispose() {
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.removeEventListener('scroll', this.handleScroll);
        this.deleteIntersectionObserver();
    }
    scrollLeft(left) {
        if (this.stickyScrollbarContainerElement) this.stickyScrollbarContainerElement.scrollLeft = left;
    }
    init() {
        if (!this.wrapper) return;
        const scrollbarContainers = this.wrapper.parentElement?.querySelectorAll(`.${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.stickyScrollbarContainerElement = (0, $eGOwo.fg)('platform_editor_querySelector_fix_table_renderer') ? scrollbarContainers?.item(scrollbarContainers.length - 1) : this.wrapper.parentElement?.querySelector(`.${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.addEventListener('scroll', this.handleScroll, {
            passive: true
        });
        this.createIntersectionObserver();
    }
    createIntersectionObserver() {
        this.rendererScrollableElement = window.document;
        if (!this.rendererScrollableElement || !this.wrapper) return;
        this.intersectionObserver = new IntersectionObserver((entries, _)=>{
            if (!this.stickyScrollbarContainerElement) return;
            entries.forEach((entry)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const target = entry.target;
                if (target.classList.contains((0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)) this.sentinelBottomCallback(entry);
                if (target.classList.contains((0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) this.sentinelTopCallback(entry);
            });
        }, {
            root: this.rendererScrollableElement
        });
        const bottomSentinels = this.wrapper?.parentElement?.getElementsByClassName((0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM);
        this.sentinels.bottom = (0, $eGOwo.fg)('platform_editor_querySelector_fix_table_renderer') ? bottomSentinels?.item(bottomSentinels.length - 1) : this.wrapper?.parentElement?.getElementsByClassName((0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)?.item(0);
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.sentinels.top = this.wrapper?.parentElement?.getElementsByClassName((0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)?.item(0);
        [
            this.sentinels.bottom,
            this.sentinels.top
        ].forEach((el)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.intersectionObserver.observe(el));
    }
    deleteIntersectionObserver() {
        if (this.intersectionObserver) {
            if (this.sentinels.bottom) this.intersectionObserver.unobserve(this.sentinels.bottom);
            this.intersectionObserver.disconnect();
        }
    }
    sentinelBottomCallback(entry) {
        const sentinelIsAboveScrollArea = entry.boundingClientRect.top < (entry.rootBounds?.top || 0);
        this.bottomSentinelState = sentinelIsAboveScrollArea ? 'above' : entry.isIntersecting ? 'visible' : 'below';
        this.toggle();
    }
    sentinelTopCallback(entry) {
        const sentinelIsBelowScrollArea = (entry.rootBounds?.bottom || 0) < entry.boundingClientRect.top;
        this.topSentinelState = sentinelIsBelowScrollArea ? 'below' : entry.isIntersecting ? 'visible' : 'above';
        this.toggle();
    }
    toggle() {
        if ((this.topSentinelState === 'visible' || this.topSentinelState === 'above') && this.bottomSentinelState === 'below') this.show();
        else this.hide();
    }
    hide() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'hidden') this.stickyScrollbarContainerElement.style.visibility = 'hidden';
    }
    show() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'visible') this.stickyScrollbarContainerElement.style.visibility = 'visible';
    }
}

});

parcelRegister("eOVsb", function(module, exports) {
$parcel$export(module.exports, "TableProcessorWithContainerStyles", () => $4bc4db8903ecca42$export$827f89182557f335);
/* eslint-disable @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/enforce-style-prop, @repo/internal/react/no-class-components */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $cjLtO = parcelRequire("cjLtO");

var $68RqK = parcelRequire("68RqK");


var $eGOwo = parcelRequire("eGOwo");

var $d3BBj = parcelRequire("d3BBj");
var $bTpHi = parcelRequire("bTpHi");
var $gikGJ = parcelRequire("gikGJ");

var $hh2CV = parcelRequire("hh2CV");

var $7yBx7 = parcelRequire("7yBx7");

var $92xoS = parcelRequire("92xoS");

var $lzf9g = parcelRequire("lzf9g");

var $177xQ = parcelRequire("177xQ");

var $hpXI5 = parcelRequire("hpXI5");

var $3xZmi = parcelRequire("3xZmi");

var $hxOCd = parcelRequire("hxOCd");
const $4bc4db8903ecca42$var$stickyContainerBaseStyles = {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    height: "var(--ds-space-250, 20px)",
    // MAX_BROWSER_SCROLLBAR_HEIGHT
    // Follow editor to hide by default so it does not show empty gap in SSR
    // https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/platform/packages/editor/editor-plugin-table/src/nodeviews/TableComponent.tsx#957
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    display: 'block',
    width: '100%'
};
const $4bc4db8903ecca42$var$stickyContainerAdditionalStyles = {
    visibility: 'hidden',
    overflowX: 'auto',
    position: 'sticky',
    bottom: "var(--ds-space-0, 0px)",
    zIndex: 1
};
const $4bc4db8903ecca42$export$eec82c0a93aa66d9 = (appearance)=>(0, $3xZmi.isFullWidthOrFullPageAppearance)(appearance) || (0, $3xZmi.isCommentAppearance)(appearance) && (0, $92xoS.editorExperiment)('support_table_in_comment', true, {
        exposure: true
    });
const $4bc4db8903ecca42$export$bdb2dadcb04aad50 = (appearance)=>(0, $3xZmi.isFullWidthOrFullPageAppearance)(appearance) && (0, $92xoS.editorExperiment)('platform_renderer_table_sticky_scrollbar', true, {
        exposure: true
    });
const $4bc4db8903ecca42$export$334894231c46c1a5 = (children, tableNode, smartCardStorage, tableOrderStatus)=>{
    if (!tableOrderStatus || tableOrderStatus.order === (0, $hh2CV.SortOrder).NO_ORDER) return children;
    const { order: order, columnIndex: columnIndex } = tableOrderStatus;
    const compareNodesInOrder = (0, $gikGJ.createCompareNodes)({
        getInlineCardTextFromStore (attrs) {
            const { url: url } = attrs;
            if (!url) return null;
            return smartCardStorage.get(url) || null;
        }
    }, order);
    const tableArray = (0, $bTpHi.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    const tableArrayWithChildren = tableArray.map((rowNodes, index)=>({
            rowNodes: rowNodes,
            rowReact: children[index]
        }));
    const headerRow = tableArrayWithChildren.shift();
    const sortedTable = tableArrayWithChildren.sort((rowA, rowB)=>compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]));
    if (headerRow) sortedTable.unshift(headerRow);
    return sortedTable.map((elem)=>elem.rowReact);
};
const $4bc4db8903ecca42$export$42f5658c8e0092da = (row)=>{
    let hasRowspan = false;
    row.forEach((cell)=>hasRowspan = hasRowspan || cell.attrs.rowspan > 1);
    return hasRowspan;
};
const $4bc4db8903ecca42$export$f422245984b0eda7 = (refElement)=>{
    return Math.round(refElement.getBoundingClientRect().top);
};
const $4bc4db8903ecca42$export$7c141112f3c89f11 = (scrollTop, tableTop, tableBottom, rowHeight)=>tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
const $4bc4db8903ecca42$export$89f3188e1adc30d5 = (scrollTop, tableBottom, rowHeight)=>tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
const $4bc4db8903ecca42$export$100baa0f10804e6e = (rows, tableOrderStatus, onSorting)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(rows, (row, index)=>{
        if (index === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.only(row), {
            tableOrderStatus: tableOrderStatus,
            onSorting: onSorting
        });
        return row;
    });
};
const $4bc4db8903ecca42$export$28daf78feed5098c = (rows)=>{
    if (!rows.length) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { children: children } = rows[0].props;
    if (!children.length) return false;
    if (children.length === 1) return children[0].type === (0, $lzf9g.TableHeader);
    return children.every((node)=>node.type === (0, $lzf9g.TableHeader));
};
const $4bc4db8903ecca42$export$940095e914312886 = (node, children)=>{
    return $4bc4db8903ecca42$export$28daf78feed5098c(children) && node && node.firstChild && !$4bc4db8903ecca42$export$42f5658c8e0092da(node.firstChild);
};
class $4bc4db8903ecca42$export$f2c3aea42b2a048f extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    /**
   *
   * @example
   */ componentDidMount() {
        this.resizeObserver = new ResizeObserver(this.applyResizerChange);
        if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
        if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
        if (this.props.stickyHeaders) {
            this.overflowParent = (0, $177xQ.OverflowParent).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.addEventListener('scroll', this.onScroll);
        }
        if (this.wrapperRef.current && $4bc4db8903ecca42$export$bdb2dadcb04aad50(this.props.rendererAppearance)) this.stickyScrollbar = new (0, $hxOCd.TableStickyScrollbar)(this.wrapperRef.current);
    }
    /**
   *
   * @param prevProps
   * @param prevState
   * @example
   */ componentDidUpdate(prevProps, prevState) {
        // toggling sticky headers visiblity
        if (this.props.stickyHeaders && !this.overflowParent) this.overflowParent = (0, $177xQ.OverflowParent).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
        else if (!this.props.stickyHeaders && this.overflowParent) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            this.overflowParent = null;
        }
        // offsetTop might have changed, re-position sticky header
        if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
        // sync horizontal scroll in floating div when toggling modes
        if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
    }
    /**
   *
   */ get pinTop() {
        if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
        return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, $cjLtO.tableMarginTop) - (0, $177xQ.tableStickyPadding);
    }
    /**
   *
   */ get shouldAddOverflowParentOffsetTop_DO_NOT_USE() {
        // IF the StickyHeaderConfig specifies that the default scroll root offsetTop should be added
        // AND the StickyHeaderConfig specifies a default scroll root id
        // AND the OverflowParent is the corresponding element
        // THEN we should add the OverflowParent offset top (RETURN TRUE)
        return this.props.stickyHeaders && !!this.props.stickyHeaders.shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE && !!this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE && this.overflowParent && this.overflowParent.id === this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE;
    }
    /**
   *
   */ get stickyTop() {
        switch(this.state.stickyMode){
            case 'pin-bottom':
                return this.pinTop;
            case 'stick':
                const offsetTop = this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
                if (typeof offsetTop === 'number' && this.shouldAddOverflowParentOffsetTop_DO_NOT_USE) {
                    const overflowParentOffsetTop = this.overflowParent ? this.overflowParent.top : 0;
                    return offsetTop + overflowParentOffsetTop;
                } else return offsetTop;
            default:
                return undefined;
        }
    }
    /**
   *
   * @example
   */ render() {
        const { isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, columnWidths: columnWidths, stickyHeaders: stickyHeaders, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing, isPresentational: isPresentational } = this.props;
        const { stickyMode: stickyMode } = this.state;
        const lineLengthFixedWidth = (0, $7yBx7.akEditorDefaultLayoutWidth);
        let updatedLayout;
        const fullPageRendererWidthCSS = (0, $92xoS.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
            exposure: true
        }) ? 'calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)' : `100cqw - ${0, $9a762f515f769003$export$12fd658e5eef0d79}px * 2`;
        const renderWidthCSS = rendererAppearance === 'full-page' ? fullPageRendererWidthCSS : `100cqw`;
        const calcDefaultLayoutWidthByAppearance = (rendererAppearance, tableNode)=>{
            if (rendererAppearance === 'full-width' && !tableNode?.attrs.width) return `min(${0, $7yBx7.akEditorFullWidthLayoutWidth}px, ${renderWidthCSS})`;
            else if (rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width) return renderWidthCSS;
            else {
                // custom width, or width mapped to breakpoint
                const tableContainerWidth = (0, $68RqK.getTableContainerWidth)(tableNode);
                return `min(${tableContainerWidth}px, ${renderWidthCSS})`;
            }
        };
        const tableWidthCSS = calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode);
        // Logic for table alignment in renderer
        const isTableAlignStart = tableNode && tableNode.attrs && tableNode.attrs.layout === 'align-start' && allowTableAlignment;
        const fullWidthLineLengthCSS = `min(${(0, $7yBx7.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const isCommentAppearanceAndTableAlignmentEnabled = (0, $3xZmi.isCommentAppearance)(rendererAppearance) && allowTableAlignment;
        const lineLengthCSS = (0, $3xZmi.isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLengthCSS : isCommentAppearanceAndTableAlignmentEnabled ? renderWidthCSS : `${lineLengthFixedWidth}px`;
        const tableWidthNew = (0, $68RqK.getTableContainerWidth)(tableNode);
        const shouldCalculateLeftForAlignment = !isInsideOfBlockNode && !isInsideOfTable && isTableAlignStart && ((0, $3xZmi.isFullPageAppearance)(rendererAppearance) && tableWidthNew <= lineLengthFixedWidth || (0, $3xZmi.isFullWidthAppearance)(rendererAppearance) || isCommentAppearanceAndTableAlignmentEnabled);
        let leftCSS;
        if (shouldCalculateLeftForAlignment) leftCSS = `(${tableWidthCSS} - ${lineLengthCSS}) / 2`;
        if (!shouldCalculateLeftForAlignment && (0, $3xZmi.isFullPageAppearance)(rendererAppearance)) // Note tableWidthCSS here is the renderer width
        // When the screen is super wide we want table to break out.
        // However if screen is smaller than 760px. We want table align to left.
        leftCSS = `min(0px, ${lineLengthCSS} - ${tableWidthCSS}) / 2`;
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(this.props.children);
        // Historically, tables in the full-width renderer had their layout set to 'default' which is deceiving.
        // This check caters for those tables and helps with SSR logic
        const isFullWidth = !tableNode?.attrs.width && rendererAppearance === 'full-width' && layout !== 'full-width';
        if (isFullWidth) updatedLayout = 'full-width';
        else if (tableNode?.attrs.width) updatedLayout = 'custom';
        else updatedLayout = layout;
        let finalTableContainerWidth = allowTableResizing ? tableWidthNew : 'inherit';
        // We can only use CSS to determine the width when we have a known width in container.
        // When appearance is full-page, full-width or comment we use CSS based width calculation.
        // Otherwise it's fixed table width (customized width) or inherit.
        if (rendererAppearance === 'full-page' || rendererAppearance === 'full-width') finalTableContainerWidth = allowTableResizing ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && !allowTableAlignment) // If table alignment is disabled and table width is akEditorDefaultLayoutWidth = 760,
        // it is most likely a table created before "Support Table in Comments" FF was enabled
        // and we would see a bug ED-24795. A table created before "Support Table in Comments",
        // should inhirit the width of the renderer container.
        // !NOTE: it a table resized to 760 is copied from 'full-page' editor and pasted in comment editor
        // where (allowTableResizing && !allowTableAlignment), the table will loose 760px width.
        finalTableContainerWidth = tableNode?.attrs.width && tableNode?.attrs.width !== (0, $7yBx7.akEditorDefaultLayoutWidth) ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && allowTableAlignment) // If table alignment is enabled and layout is not 'align-start' or 'center', we are loading a table that was
        // created before "Support Table in Comments" FF was enabled. So the table should have the same width as renderer container
        // instead of 760 that was set on tableNode when the table had been published.
        finalTableContainerWidth = (tableNode?.attrs.layout === 'align-start' || tableNode?.attrs.layout === 'center') && tableNode?.attrs.width ? `calc(${tableWidthCSS})` : 'inherit';
        const style = {
            width: finalTableContainerWidth,
            left: leftCSS ? `calc(${leftCSS})` : undefined,
            marginLeft: shouldCalculateLeftForAlignment && leftCSS !== undefined ? `calc(-1 * (${leftCSS}))` : undefined
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER} ${this.props.shadowClassNames || ''}`,
                "data-layout": updatedLayout,
                "data-testid": "table-container",
                ref: this.props.handleRef,
                style: style,
                children: [
                    $4bc4db8903ecca42$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
                        "data-testid": "sticky-scrollbar-sentinel-top"
                    }),
                    stickyHeaders && tableNode && $4bc4db8903ecca42$export$940095e914312886(tableNode, children) && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $177xQ.StickyTable), {
                        isNumberColumnEnabled: isNumberColumnEnabled,
                        tableWidth: "inherit",
                        renderWidth: 0,
                        layout: layout,
                        handleRef: this.props.handleRef,
                        shadowClassNames: this.props.shadowClassNames,
                        top: this.stickyTop,
                        mode: stickyMode,
                        innerRef: this.stickyWrapperRef,
                        wrapperWidth: this.state.wrapperWidth,
                        columnWidths: columnWidths,
                        rowHeight: this.state.headerRowHeight,
                        tableNode: tableNode,
                        rendererAppearance: rendererAppearance,
                        allowTableResizing: allowTableResizing,
                        fixTableSSRResizing: true,
                        children: [
                            children && children[0]
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $cjLtO.TableSharedCssClassName).TABLE_NODE_WRAPPER,
                        ref: this.wrapperRef,
                        "data-number-column": tableNode?.attrs.isNumberColumnEnabled,
                        "data-layout": tableNode?.attrs.layout,
                        "data-autosize": tableNode?.attrs.__autoSize,
                        "data-table-local-id": tableNode?.attrs.localId,
                        "data-table-width": tableNode?.attrs.width,
                        "data-vc": "table-node-wrapper",
                        onScroll: this.props.stickyHeaders && this.onWrapperScrolled,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hpXI5.Table), {
                            innerRef: this.tableRef,
                            columnWidths: columnWidths,
                            layout: layout,
                            renderWidth: 0,
                            isNumberColumnEnabled: isNumberColumnEnabled,
                            tableNode: tableNode,
                            rendererAppearance: rendererAppearance,
                            isInsideOfBlockNode: isInsideOfBlockNode,
                            isInsideOfTable: isInsideOfTable,
                            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                            allowTableResizing: allowTableResizing,
                            isPresentational: isPresentational,
                            children: this.grabFirstRowRef(children)
                        })
                    }),
                    $4bc4db8903ecca42$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: `${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}${(0, $eGOwo.fg)('confluence_frontend_table_scrollbar_ttvc_fix') ? '-view-page' : ''}`,
                        ref: this.stickyScrollbarRef,
                        "data-vc": "table-sticky-scrollbar-container",
                        style: (0, $eGOwo.fg)('confluence_frontend_table_scrollbar_ttvc_fix') ? {
                            ...$4bc4db8903ecca42$var$stickyContainerBaseStyles,
                            ...$4bc4db8903ecca42$var$stickyContainerAdditionalStyles
                        } : $4bc4db8903ecca42$var$stickyContainerBaseStyles,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            style: {
                                width: (0, $eGOwo.fg)('confluence_frontend_table_scrollbar_ttvc_fix') ? '100%' : this.tableRef.current?.clientWidth,
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                height: '100%'
                            }
                        })
                    }),
                    $4bc4db8903ecca42$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
                        "data-testid": "sticky-scrollbar-sentinel-bottom"
                    })
                ]
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            stickyMode: 'none',
            wrapperWidth: 0,
            headerRowHeight: 0
        }, this.tableRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.stickyHeaderRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.stickyScrollbarRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), // used for sync scroll + copying wrapper width to sticky header
        this.stickyWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.overflowParent = null, this.updatedLayout = 'custom', this.resizeObserver = null, this.applyResizerChange = (entries)=>{
            let wrapperWidth = this.state.wrapperWidth;
            let headerRowHeight = this.state.headerRowHeight;
            for (const entry of entries){
                if (entry.target === this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                else if (entry.target === this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
            }
            if (headerRowHeight !== this.state.headerRowHeight || wrapperWidth !== this.state.wrapperWidth) this.setState({
                wrapperWidth: wrapperWidth,
                headerRowHeight: headerRowHeight
            });
        }, this.componentWillUnmount = ()=>{
            if (this.overflowParent) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            if (this.nextFrame) cancelAnimationFrame(this.nextFrame);
            if (this.resizeObserver) this.resizeObserver.disconnect();
            if (this.stickyScrollbar) this.stickyScrollbar.dispose();
        }, this.getScrollTop = ()=>{
            const { stickyHeaders: stickyHeaders } = this.props;
            const offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
            return (this.overflowParent ? this.overflowParent.top : 0) + offsetTop;
        }, this.updateSticky = ()=>{
            const tableElem = this.tableRef.current;
            const refElem = this.stickyHeaderRef.current;
            if (!tableElem || !refElem) return;
            const scrollTop = this.getScrollTop() + (0, $177xQ.tableStickyPadding);
            const tableTop = $4bc4db8903ecca42$export$f422245984b0eda7(tableElem);
            const tableBottom = tableTop + tableElem.clientHeight;
            const shouldSticky = $4bc4db8903ecca42$export$7c141112f3c89f11(scrollTop, tableTop, tableBottom, refElem.clientHeight);
            const shouldPin = $4bc4db8903ecca42$export$89f3188e1adc30d5(scrollTop, tableBottom, refElem.clientHeight);
            let stickyMode = 'none';
            if (shouldPin) stickyMode = 'pin-bottom';
            else if (shouldSticky) stickyMode = 'stick';
            if (this.state.stickyMode !== stickyMode) this.setState({
                stickyMode: stickyMode
            });
            this.nextFrame = undefined;
        }, this.onScroll = ()=>{
            if (!this.nextFrame) this.nextFrame = requestAnimationFrame(this.updateSticky);
        }, this.onWrapperScrolled = ()=>{
            if (!this.wrapperRef.current || !this.stickyWrapperRef.current) return;
            this.stickyWrapperRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
            if (this.stickyScrollbarRef.current) this.stickyScrollbarRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
        }, this.grabFirstRowRef = (children)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children || false, (child, idx)=>{
                if (idx === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(child, {
                    innerRef: this.stickyHeaderRef
                });
                return child;
            });
        };
    }
}
class $4bc4db8903ecca42$export$827f89182557f335 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    /**
   *
   * @example
   */ render() {
        const { children: children } = this.props;
        if (!children) return null;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children);
        const orderedChildren = (0, $d3BBj.compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenArray);
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $gt9Am.jsx)($4bc4db8903ecca42$export$f2c3aea42b2a048f, {
            ...this.props,
            children: orderedChildren
        });
    }
    constructor(...args){
        super(...args), this.state = {
            tableOrderStatus: undefined
        }, // adds sortable + re-orders children
        this.addSortableColumn = (childrenArray)=>{
            const { tableNode: tableNode, allowColumnSorting: allowColumnSorting, smartCardStorage: smartCardStorage } = this.props;
            const { tableOrderStatus: tableOrderStatus } = this.state;
            if (allowColumnSorting && $4bc4db8903ecca42$export$28daf78feed5098c(childrenArray) && tableNode && !(0, $bTpHi.hasMergedCell)(tableNode)) return $4bc4db8903ecca42$export$100baa0f10804e6e($4bc4db8903ecca42$export$334894231c46c1a5(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, this.changeSortOrder);
            return childrenArray;
        }, this.changeSortOrder = (columnIndex, sortOrder)=>{
            this.setState({
                tableOrderStatus: {
                    columnIndex: columnIndex,
                    order: sortOrder
                }
            });
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.addNumberColumnIndexes = (rows)=>{
            const { isNumberColumnEnabled: isNumberColumnEnabled } = this.props;
            const headerRowEnabled = $4bc4db8903ecca42$export$28daf78feed5098c(rows);
            return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(rows, (row, index)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.only(row), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    index: headerRowEnabled ? index === 0 ? '' : index : index + 1
                });
            });
        };
    }
}

});


parcelRegister("eACId", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a8fa33519ffce33$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $d3BBj = parcelRequire("d3BBj");

var $hh2CV = parcelRequire("hh2CV");

var $iRC0e = parcelRequire("iRC0e");
class $0a8fa33519ffce33$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { children: children, innerRef: innerRef } = this.props;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children);
        return /*#__PURE__*/ (0, $gt9Am.jsxs)("tr", {
            ref: innerRef,
            children: [
                this.props.isNumberColumnEnabled && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $gt9Am.jsx)("td", {
                    className: (0, $iRC0e.RendererCssClassName).NUMBER_COLUMN,
                    children: this.props.index
                }),
                (0, $d3BBj.compose)(this.addSortableColumn, this.addColGroupWidth)(childrenArray)
            ]
        });
    }
    constructor(...args){
        super(...args), this.state = {
            colGroupWidths: []
        }, this.addSortableColumn = (childrenArray)=>{
            const { allowColumnSorting: allowColumnSorting, index: rowIndex } = this.props;
            const isHeaderRow = !rowIndex;
            if (allowColumnSorting && isHeaderRow) childrenArray = childrenArray.map((child, index)=>{
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) {
                    const { tableOrderStatus: tableOrderStatus } = this.props;
                    let sortOrdered = (0, $hh2CV.SortOrder).NO_ORDER;
                    if (tableOrderStatus) sortOrdered = index === tableOrderStatus.columnIndex ? tableOrderStatus.order : (0, $hh2CV.SortOrder).NO_ORDER;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(child, {
                        columnIndex: index,
                        onSorting: this.props.onSorting,
                        sortOrdered: sortOrdered,
                        isHeaderRow: isHeaderRow
                    });
                }
            });
            return childrenArray;
        }, this.addColGroupWidth = (childrenArray)=>{
            if (this.state.colGroupWidths?.length) childrenArray = childrenArray.map((child, index)=>{
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(child, {
                    colGroupWidth: this.state.colGroupWidths[index]
                });
            });
            return childrenArray;
        };
    }
}

});

parcelRegister("eoMJq", function(module, exports) {
$parcel$export(module.exports, "default", () => $b5f6b4c882c0f359$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
function $b5f6b4c882c0f359$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: "UnknownBlock",
        children: props.children
    });
}

});

parcelRegister("gF78o", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8736I").then(()=>parcelRequire('gp0ta'));

});

parcelRegister("fpfZq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6aYtx").then(()=>parcelRequire('ioMWp'));

});

parcelRegister("jv2lN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kyc3X").then(()=>parcelRequire('lu3aG'));

});

parcelRegister("bk0oz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8A35j").then(()=>parcelRequire('MUFrj'));

});

parcelRegister("5xqvU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9ClHX").then(()=>parcelRequire('8nyI6'));

});

parcelRegister("glfsH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("i5I3w").then(()=>parcelRequire('2XJ8t'));

});

parcelRegister("flFZe", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ipFBo").then(()=>parcelRequire('aEpcu'));

});

parcelRegister("46r9p", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iFaWe").then(()=>parcelRequire('LiaMl'));

});

parcelRegister("2tsHJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("ldGmJ")
]).then(()=>parcelRequire('6L7mA'));

});

parcelRegister("h9546", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("dMn8Q")
]).then(()=>parcelRequire('7naaD'));

});

parcelRegister("lKCDC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kNFvF"),
    $ewTvA("fliVL"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("2RTKs")
]).then(()=>parcelRequire('1C1WZ'));

});

parcelRegister("3Sn3X", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kNFvF"),
    $ewTvA("fliVL"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("7ePgM")
]).then(()=>parcelRequire('hGXwD'));

});

parcelRegister("73bGp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kNFvF"),
    $ewTvA("fliVL"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("3JEjo")
]).then(()=>parcelRequire('9ug1Y'));

});

parcelRegister("glKdb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("7w8Lg")
]).then(()=>parcelRequire('6Tw9l'));

});

parcelRegister("joUSr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("kDya6")
]).then(()=>parcelRequire('2FwjZ'));

});

parcelRegister("kPjsx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("71t3O")
]).then(()=>parcelRequire('dHHKP'));

});

parcelRegister("1paLD", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kCxTP").then(()=>parcelRequire('5KYHN'));

});

parcelRegister("dcoh7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("6tXwk")
]).then(()=>parcelRequire('glEdp'));

});

parcelRegister("82LRg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("6F0xO")
]).then(()=>parcelRequire('dF4iL'));

});

parcelRegister("1UWR4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("k3dCC").then(()=>parcelRequire('dmfaU'));

});

parcelRegister("edBEs", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1rHns").then(()=>parcelRequire('2h9yT'));

});


parcelRegister("fB6mC", function(module, exports) {
$parcel$export(module.exports, "default", () => $f3c66b95e4e31148$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5P88b = parcelRequire("5P88b");
const $f3c66b95e4e31148$var$TextWrapper = (props)=>{
    const { startPos: startPos, endPos: endPos } = props;
    const { children: children } = props;
    if (!children) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5P88b.TextWithAnnotationDraft), {
        startPos: startPos,
        endPos: endPos,
        textHighlighter: props.textHighlighter,
        marks: props.marks,
        children: children
    });
};
var $f3c66b95e4e31148$export$2e2bcd8739ae039 = $f3c66b95e4e31148$var$TextWrapper;

});
parcelRegister("5P88b", function(module, exports) {
$parcel$export(module.exports, "TextWithAnnotationDraft", () => $f285203f0973bda4$export$69a4e0ac39aaf9b7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $dAxMl = parcelRequire("dAxMl");

var $9Go2F = parcelRequire("9Go2F");

var $lr7KE = parcelRequire("lr7KE");

var $fH5Zn = parcelRequire("fH5Zn");

var $bRAXN = parcelRequire("bRAXN");

var $7Uu7t = parcelRequire("7Uu7t");

var $3OjM0 = parcelRequire("3OjM0");

var $e2m7L = parcelRequire("e2m7L");
// Localized AnnotationSharedCSSByState().common and AnnotationSharedCSSByState().focus
const $f285203f0973bda4$var$markStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    color: 'inherit',
    backgroundColor: 'unset',
    WebkitTapHighlightColor: 'transparent',
    borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid transparent`,
    cursor: 'pointer',
    padding: '1px 0 2px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has(.card), &:has([data-inline-card])': {
        padding: '5px 0 3px 0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has(.date-lozenger-container)': {
        paddingTop: "var(--ds-space-025, 2px)"
    },
    background: "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)",
    borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
    boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"
});
const $f285203f0973bda4$export$8062d68eccdfa39c = ({ draftPosition: draftPosition, children: children })=>{
    const { dispatch: dispatch } = (0, $3OjM0.useAnnotationManagerDispatch)();
    const markRef = (0, $eJOHy.useCallback)((node)=>{
        dispatch({
            type: 'setDraftMarkRef',
            data: {
                draftMarkRef: node ?? undefined
            }
        });
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)("mark", {
        "data-renderer-mark": true,
        ...(0, $fH5Zn.dataAttributes)(draftPosition),
        css: $f285203f0973bda4$var$markStyles,
        ref: markRef
    }, children);
};
const $f285203f0973bda4$export$846ef6158669db08 = (annotationPosition, fragmentCount)=>{
    if (annotationPosition === (0, $dAxMl.InsertDraftPosition).START) return 0;
    if (annotationPosition === (0, $dAxMl.InsertDraftPosition).END) return fragmentCount - 1;
    if (annotationPosition === (0, $dAxMl.InsertDraftPosition).INSIDE && fragmentCount === 3) return 1;
    return -1;
};
const $f285203f0973bda4$export$b756d37afc321d72 = ({ texts: texts, shouldApplyAnnotationAt: shouldApplyAnnotationAt, draftPosition: draftPosition, textHighlighter: textHighlighter, marks: marks })=>{
    const annotateIndex = $f285203f0973bda4$export$846ef6158669db08(shouldApplyAnnotationAt, texts.length);
    return texts.map((value, index)=>{
        const segments = (0, $bRAXN.segmentText)(value, textHighlighter);
        if (annotateIndex === index) return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $1NIU8.jsx)($f285203f0973bda4$export$8062d68eccdfa39c, {
            key: index,
            draftPosition: draftPosition
        }, (0, $7Uu7t.renderTextSegments)(segments, textHighlighter, marks || [], draftPosition.from)));
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
            key: index
        }, (0, $7Uu7t.renderTextSegments)(segments, textHighlighter, marks || [], draftPosition.from)));
    });
};
const $f285203f0973bda4$export$69a4e0ac39aaf9b7 = ({ startPos: startPos, endPos: endPos, children: children, textHighlighter: textHighlighter, marks: marks })=>{
    const textPosition = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>({
            start: startPos,
            end: endPos
        }), [
        endPos,
        startPos
    ]);
    const { selectionDraftDocumentPosition: nextDraftPosition } = (0, $e2m7L.useAnnotationRangeState)();
    const shouldApplyAnnotationAt = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>{
        if (!nextDraftPosition) return false;
        return (0, $lr7KE.calcInsertDraftPositionOnText)(textPosition, nextDraftPosition);
    }, [
        nextDraftPosition,
        textPosition
    ]);
    const textString = (0, $9Go2F.findTextString)(children);
    if (!textString) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, children);
    if (shouldApplyAnnotationAt === false || !nextDraftPosition) {
        const segments = (0, $bRAXN.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, (0, $7Uu7t.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    if (shouldApplyAnnotationAt === (0, $dAxMl.InsertDraftPosition).AROUND_TEXT) {
        const segments = (0, $bRAXN.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $1NIU8.jsx)($f285203f0973bda4$export$8062d68eccdfa39c, {
            key: 0,
            draftPosition: nextDraftPosition
        }, (0, $7Uu7t.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    const offsets = (0, $9Go2F.calcTextSplitOffset)(nextDraftPosition, textPosition, textString);
    const texts = (0, $9Go2F.splitText)(textString, offsets);
    if (!texts) {
        const segments = (0, $bRAXN.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, (0, $7Uu7t.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    const components = $f285203f0973bda4$export$b756d37afc321d72({
        texts: texts,
        shouldApplyAnnotationAt: shouldApplyAnnotationAt,
        draftPosition: nextDraftPosition,
        textHighlighter: textHighlighter,
        marks: marks
    });
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, components);
};

});
parcelRegister("dAxMl", function(module, exports) {
$parcel$export(module.exports, "InsertDraftPosition", () => $75c06ae1a0de2c65$export$c1bd4813440b4505);
var $75c06ae1a0de2c65$export$c1bd4813440b4505 = /*#__PURE__*/ function(InsertDraftPosition) {
    InsertDraftPosition["AROUND_TEXT"] = "AROUND_TEXT";
    InsertDraftPosition["START"] = "START";
    InsertDraftPosition["END"] = "END";
    InsertDraftPosition["INSIDE"] = "INSIDE";
    return InsertDraftPosition;
}({});

});

parcelRegister("9Go2F", function(module, exports) {
$parcel$export(module.exports, "findTextString", () => $d3e611b0662150a6$export$a9795c84b22a1f06);
$parcel$export(module.exports, "splitText", () => $d3e611b0662150a6$export$2878cc467c8be8fe);
$parcel$export(module.exports, "calcTextSplitOffset", () => $d3e611b0662150a6$export$1059bfc467f4f55d);

var $eJOHy = parcelRequire("eJOHy");
const $d3e611b0662150a6$export$a9795c84b22a1f06 = (reactNode)=>{
    let result = null;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(reactNode);
    for (const childNode of children){
        if (result) break;
        else if (typeof childNode === 'string') result = childNode;
        else if ($d3e611b0662150a6$var$isReactElement(childNode) && childNode.props.children) result = $d3e611b0662150a6$export$a9795c84b22a1f06(childNode.props.children);
    }
    return result;
};
function $d3e611b0662150a6$var$isReactElement(child) {
    return !!child.type;
}
const $d3e611b0662150a6$export$2878cc467c8be8fe = (text, { startOffset: startOffset, endOffset: endOffset })=>{
    if (endOffset > text.length || endOffset - startOffset <= 0) return null;
    return [
        text.slice(0, startOffset),
        text.slice(startOffset, endOffset),
        text.slice(endOffset)
    ].filter(Boolean);
};
const $d3e611b0662150a6$export$1059bfc467f4f55d = (position, textPosition, text)=>{
    const { start: start, end: end } = textPosition;
    const startOffset = Math.max(position.from - start, 0);
    const endOffset = Math.min(Math.abs(end - position.to - text.length), text.length);
    return {
        startOffset: startOffset,
        endOffset: endOffset
    };
};

});

parcelRegister("lr7KE", function(module, exports) {
$parcel$export(module.exports, "calcInsertDraftPositionOnText", () => $289f20261f120a5e$export$b1baddbd5f289877);

var $dAxMl = parcelRequire("dAxMl");
const $289f20261f120a5e$export$b1baddbd5f289877 = ({ start: startTextPosition, end: endTextPosition }, position)=>{
    const isRangePositionAroundText = position.from <= startTextPosition && position.to >= endTextPosition;
    if (isRangePositionAroundText) return (0, $dAxMl.InsertDraftPosition).AROUND_TEXT;
    const isRangePositionInsideText = position.from > startTextPosition && position.from < endTextPosition && position.to < endTextPosition && position.to > startTextPosition;
    if (isRangePositionInsideText) return (0, $dAxMl.InsertDraftPosition).INSIDE;
    const isRangePositionStartingAtText = position.from >= startTextPosition && position.from <= endTextPosition && position.to >= endTextPosition;
    if (isRangePositionStartingAtText) return (0, $dAxMl.InsertDraftPosition).END;
    const isRangePositionEndingAtText = position.from <= startTextPosition && position.to >= startTextPosition && position.to <= endTextPosition;
    if (isRangePositionEndingAtText) return (0, $dAxMl.InsertDraftPosition).START;
    return false;
};

});

parcelRegister("bRAXN", function(module, exports) {
$parcel$export(module.exports, "segmentText", () => $9bd02ef7824cc2a4$export$93301b6f1ff0b0c3);
function $9bd02ef7824cc2a4$export$93301b6f1ff0b0c3(text, highlighter) {
    if (!highlighter || !text) return [
        {
            type: 'plain',
            text: text ?? ''
        }
    ];
    const segments = [];
    let pos = 0;
    try {
        const markTextSegmentMatches = text.matchAll(highlighter.pattern);
        for (const markTextMatch of markTextSegmentMatches){
            if (markTextMatch.index !== 0) segments.push({
                type: 'plain',
                text: text.substring(pos, markTextMatch.index)
            });
            segments.push({
                type: 'match',
                text: markTextMatch[0],
                groups: markTextMatch.groups && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                Object.keys(markTextMatch.groups).filter((key)=>markTextMatch.groups[key])
            });
            pos = markTextMatch.index + markTextMatch[0].length;
        }
        if (pos < text.length) segments.push({
            type: 'plain',
            text: text.substring(pos)
        });
        return segments;
    } catch (_e) {}
    return [
        {
            type: 'plain',
            text: text
        }
    ];
}

});

parcelRegister("7Uu7t", function(module, exports) {
$parcel$export(module.exports, "renderTextSegments", () => $ee7ad9044e65fe28$export$8a20fd0614851c5f);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $ee7ad9044e65fe28$export$8a20fd0614851c5f(segments, textHighlighter, marksList, startPos) {
    const Component = textHighlighter?.component;
    const marks = new Set(marksList.map((m)=>m.type.name));
    function renderSegment(segment, idx = 0) {
        if (segment.type === 'plain' || !Component) return segment.text;
        return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            "data-highlighted": true,
            "data-vc": "highlighted-text",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                match: segment.text,
                groups: segment.groups,
                marks: marks,
                startPos: startPos + idx,
                children: segment.text
            }, `${segment.text}_${startPos}_${idx}`)
        });
    }
    if (segments.length === 1) return renderSegment(segments[0]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
        children: segments.map(renderSegment)
    }, `text-wrapper_${startPos}`);
}

});



parcelRegister("iOvh6", function(module, exports) {
$parcel$export(module.exports, "isNestedHeaderLinksEnabled", () => $8e65b6dd74371a42$export$7aa7587d1ce9583c);
$parcel$export(module.exports, "getActiveHeadingId", () => $8e65b6dd74371a42$export$acb253d79d72af92);
function $8e65b6dd74371a42$export$7aa7587d1ce9583c(allowHeadingAnchorLinks) {
    // If it's a boolean or undefined, then we don't support nesting.
    if (!allowHeadingAnchorLinks || typeof allowHeadingAnchorLinks === 'boolean') return false;
    const { allowNestedHeaderLinks: allowNestedHeaderLinks } = allowHeadingAnchorLinks;
    // Explicit cast to a boolean to cover scenario where it's undefined.
    return !!allowNestedHeaderLinks;
}
function $8e65b6dd74371a42$export$acb253d79d72af92(allowHeadingAnchorLinks) {
    if (!$8e65b6dd74371a42$export$7aa7587d1ce9583c(allowHeadingAnchorLinks)) return undefined;
    return allowHeadingAnchorLinks.activeHeadingId;
}

});

parcelRegister("cRsRn", function(module, exports) {
$parcel$export(module.exports, "getMarksByOrder", () => $0190d1906f5ad323$export$99a33ed044c278ae);
$parcel$export(module.exports, "isSameMark", () => $0190d1906f5ad323$export$b1304404bdc42b7a);
$parcel$export(module.exports, "getValidDocument", () => $0190d1906f5ad323$export$fb80336a7e408cb3);
$parcel$export(module.exports, "getValidNode", () => $0190d1906f5ad323$export$81b20b6c83a56bd);

var $2OrIX = parcelRequire("2OrIX");
var $fAF2Y = parcelRequire("fAF2Y");
var $iKozC = parcelRequire("iKozC");
var $ePdnq = parcelRequire("ePdnq");

var $8DB98 = parcelRequire("8DB98");

var $eGOwo = parcelRequire("eGOwo");

var $cbSL1 = parcelRequire("cbSL1");
const $0190d1906f5ad323$export$3b94ef2190b2d585 = {
    FINAL: 'final',
    STAGE_0: 'stage0'
};
const $0190d1906f5ad323$export$62d5811a2955c1d8 = [
    'fragment',
    'link',
    'em',
    'strong',
    'textColor',
    'backgroundColor',
    'strike',
    'subsup',
    'underline',
    'code',
    'confluenceInlineComment',
    'annotation',
    'dataConsumer'
];
const $0190d1906f5ad323$export$30f8aa4cc1f8c1cb = (type)=>{
    return type === 'sub' || type === 'sup';
};
const $0190d1906f5ad323$export$99a33ed044c278ae = (marks)=>{
    return [
        ...marks
    ].sort((a, b)=>$0190d1906f5ad323$export$62d5811a2955c1d8.indexOf(a.type.name) - $0190d1906f5ad323$export$62d5811a2955c1d8.indexOf(b.type.name));
};
const $0190d1906f5ad323$export$b1304404bdc42b7a = (mark, otherMark)=>{
    if (!mark || !otherMark) return false;
    return mark.eq(otherMark);
};
const $0190d1906f5ad323$export$fb80336a7e408cb3 = (doc, schema = (0, $8DB98.defaultSchema), adfStage = 'final')=>{
    const node = $0190d1906f5ad323$export$81b20b6c83a56bd(doc, schema, adfStage);
    if (node.type === 'doc') {
        node.content = $0190d1906f5ad323$var$wrapInlineNodes(node.content);
        return node;
    }
    return null;
};
const $0190d1906f5ad323$var$wrapInlineNodes = (nodes = [])=>{
    return nodes.map((node)=>(0, $fAF2Y.inlineNodes).has(node.type) ? {
            type: 'paragraph',
            content: [
                node
            ]
        } : node);
};
const $0190d1906f5ad323$export$fafd4f799ee68da0 = (content, schema = (0, $8DB98.defaultSchema), adfStage = 'final')=>{
    return content.map((node)=>$0190d1906f5ad323$export$81b20b6c83a56bd(node, schema, adfStage));
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $0190d1906f5ad323$var$TEXT_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $0190d1906f5ad323$var$RELATIVE_LINK = /^\//;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $0190d1906f5ad323$var$ANCHOR_LINK = /^#/;
const $0190d1906f5ad323$var$flattenUnknownBlockTree = (node, schema = (0, $8DB98.defaultSchema), adfStage = 'final')=>{
    const output = [];
    let isPrevLeafNode = false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    for(let i = 0; i < node.content.length; i++){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const childNode = node.content[i];
        const isLeafNode = !(childNode.content && childNode.content.length);
        if (i > 0) {
            if (isPrevLeafNode) output.push({
                type: 'text',
                text: ' '
            });
            else output.push({
                type: 'hardBreak'
            });
        }
        if (isLeafNode) output.push($0190d1906f5ad323$export$81b20b6c83a56bd(childNode, schema, adfStage));
        else output.push(...$0190d1906f5ad323$var$flattenUnknownBlockTree(childNode, schema, adfStage));
        isPrevLeafNode = isLeafNode;
    }
    return output;
};
const $0190d1906f5ad323$export$b9908ef75cad1e0e = (node)=>{
    const { attrs: attrs = {}, content: content, text: text, type: type } = node;
    if (!content || !content.length) {
        const unknownInlineNode = {
            type: 'text',
            text: text || attrs.text || `[${type}]`
        };
        const { textUrl: textUrl } = attrs;
        if (textUrl && (0, $iKozC.isSafeUrl)(textUrl)) unknownInlineNode.marks = [
            {
                type: 'link',
                attrs: {
                    href: textUrl
                }
            }
        ];
        return unknownInlineNode;
    }
    /*
	 * Find leaf nodes and join them. If leaf nodes' parent node is the same node
	 * join with a blank space, otherwise they are children of different branches, i.e.
	 * we need to join them with a hardBreak node
	 */ return {
        type: 'unknownBlock',
        content: $0190d1906f5ad323$var$flattenUnknownBlockTree(node)
    };
};
const $0190d1906f5ad323$var$getValidMarks = (marks, adfStage = 'final')=>{
    if (marks && marks.length > 0) return marks.reduce((acc, mark)=>{
        const validMark = $0190d1906f5ad323$export$87c6d4a6ebb7d9e9(mark, adfStage);
        if (validMark) acc.push(validMark);
        return acc;
    }, []);
    return marks;
};
const $0190d1906f5ad323$export$81b20b6c83a56bd = (originalNode, schema = (0, $8DB98.defaultSchema), adfStage = 'final')=>{
    const { attrs: attrs, marks: marks, text: text, type: type } = originalNode;
    let { content: content } = originalNode;
    const node = {
        attrs: attrs,
        marks: marks,
        text: text,
        type: type
    };
    if (content) node.content = content = $0190d1906f5ad323$export$fafd4f799ee68da0(content, schema, adfStage);
    // If node type doesn't exist in schema, make it an unknown node
    if (!schema.nodes[type]) return $0190d1906f5ad323$export$b9908ef75cad1e0e(node);
    if (type) switch(type){
        case 'doc':
            {
                const { version: version } = originalNode;
                if (version && content && content.length) return {
                    type: type,
                    content: content
                };
                break;
            }
        case 'codeBlock':
            if (content) content = content.reduce((acc, val)=>{
                if (val.type === 'text') acc.push({
                    type: val.type,
                    text: val.text
                });
                return acc;
            }, []);
            if (attrs && attrs.language) return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
            return {
                type: type,
                content: content,
                marks: marks
            };
        case 'date':
            if (attrs && attrs.timestamp) return {
                type: type,
                attrs: attrs,
                ...(0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'status':
            if (attrs && attrs.text && attrs.color) return {
                type: type,
                attrs: attrs,
                ...(0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'emoji':
            if (attrs && attrs.shortName) return {
                type: type,
                attrs: attrs,
                ...(0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'inlineExtension':
        case 'extension':
            if (attrs && attrs.extensionType && attrs.extensionKey) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'inlineCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $iKozC.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $iKozC.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs,
                ...(0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'blockCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $iKozC.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $iKozC.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'embedCard':
            if (attrs && (attrs.url && (0, $iKozC.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $iKozC.isSafeUrl)(attrs.data.url)) && attrs.layout) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'bodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'multiBodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'extensionFrame':
            if (content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'hardBreak':
            return {
                type: type
            };
        case 'caption':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'mediaInline':
            {
                let mediaId = '';
                let mediaCollection = [];
                if (attrs) {
                    const { id: id, collection: collection } = attrs;
                    mediaId = id;
                    mediaCollection = collection;
                }
                if (mediaId && mediaCollection) return {
                    type: type,
                    attrs: attrs,
                    marks: marks
                };
                break;
            }
        case 'media':
            {
                let mediaId = '';
                let mediaType = '';
                let mediaCollection = [];
                let mediaUrl = '';
                if (attrs) {
                    const { id: id, collection: collection, type: type, url: url } = attrs;
                    mediaId = id;
                    mediaType = type;
                    mediaCollection = collection;
                    mediaUrl = url;
                }
                if (mediaType === 'external' && !!mediaUrl) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        url: mediaUrl,
                        width: attrs.width,
                        height: attrs.height
                    };
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $0190d1906f5ad323$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                } else if (mediaId && mediaType) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        id: mediaId,
                        collection: mediaCollection
                    };
                    if (attrs.width) mediaAttrs.width = attrs.width;
                    if (attrs.height) mediaAttrs.height = attrs.height;
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $0190d1906f5ad323$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                }
                break;
            }
        case 'mediaGroup':
            if (Array.isArray(content) && !content.some((e)=>e.type !== 'media')) return {
                type: type,
                content: content
            };
            break;
        case 'mediaSingle':
            {
                const containsJustMedia = Array.isArray(content) && content.length === 1 && content[0].type === 'media';
                const containsMediaAndCaption = Array.isArray(content) && content.length === 2 && content[0].type === 'media' && content[1].type === 'caption';
                if (containsJustMedia || containsMediaAndCaption) return {
                    type: type,
                    attrs: attrs,
                    content: content,
                    marks: $0190d1906f5ad323$var$getValidMarks(marks, adfStage)
                };
                break;
            }
        case 'mention':
            {
                let mentionText = '';
                let mentionId;
                let mentionAccess;
                if (attrs) {
                    const { text: text, displayName: displayName, id: id, accessLevel: accessLevel } = attrs;
                    mentionText = text || displayName;
                    mentionId = id;
                    mentionAccess = accessLevel;
                }
                if (!mentionText) mentionText = text || '@unknown';
                if (mentionText && mentionId) {
                    const mentionNode = {
                        type: type,
                        attrs: {
                            id: mentionId,
                            text: mentionText,
                            accessLevel: ''
                        },
                        ...(0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes') ? {
                            marks: marks
                        } : {}
                    };
                    if (mentionAccess) mentionNode.attrs.accessLevel = mentionAccess;
                    return mentionNode;
                }
                break;
            }
        case 'paragraph':
            if (adfStage === 'stage0') {
                const paragraphNode = {
                    type: type,
                    content: content || []
                };
                if (attrs && attrs.localId) paragraphNode.attrs = {
                    localId: attrs.localId
                };
                if (marks) paragraphNode.marks = [
                    ...marks
                ];
                return paragraphNode;
            }
            return marks ? {
                type: type,
                content: content || [],
                marks: marks
            } : {
                type: type,
                content: content || []
            };
        case 'rule':
            return {
                type: type
            };
        case 'text':
            {
                const { marks: marks } = node;
                if (text) return marks ? {
                    type: type,
                    text: text,
                    marks: $0190d1906f5ad323$var$getValidMarks(marks, adfStage)
                } : {
                    type: type,
                    text: text
                };
                break;
            }
        case 'heading':
            if (attrs) {
                const { level: level } = attrs;
                const between = (x, a, b)=>x >= a && x <= b;
                if (level && between(level, 1, 6)) {
                    if (adfStage === 'stage0') {
                        const headingNode = {
                            type: type,
                            content: content,
                            attrs: {
                                level: level
                            }
                        };
                        if (attrs.localId) headingNode.attrs.localId = attrs.localId;
                        if (marks) headingNode.marks = [
                            ...marks
                        ];
                        return headingNode;
                    }
                    return marks ? {
                        type: type,
                        content: content,
                        marks: marks,
                        attrs: {
                            level: level
                        }
                    } : {
                        type: type,
                        content: content,
                        attrs: {
                            level: level
                        }
                    };
                }
            }
            break;
        case 'bulletList':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'orderedList':
            if (content) return {
                type: type,
                content: content,
                attrs: {
                    order: attrs && attrs.order
                }
            };
            break;
        case 'listItem':
            if (content) return {
                type: type,
                content: $0190d1906f5ad323$var$wrapInlineNodes(content)
            };
            break;
        case 'blockquote':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'panel':
            if (attrs && content) {
                const { panelType: panelType } = attrs;
                if (Object.values((0, $ePdnq.PanelType)).includes(panelType)) return {
                    type: type,
                    attrs: attrs,
                    content: content
                };
            }
            break;
        case 'layoutSection':
            if (content) return {
                type: type,
                marks: marks,
                content: content
            };
            break;
        case 'layoutColumn':
            if (attrs && content) {
                if (attrs.width > 0 && attrs.width <= 100) return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'decisionList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $2OrIX.generateUuid)()
                }
            };
        case 'decisionItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $2OrIX.generateUuid)(),
                    state: attrs && attrs.state || 'DECIDED'
                }
            };
        case 'taskList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $2OrIX.generateUuid)()
                }
            };
        case 'taskItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $2OrIX.generateUuid)(),
                    state: attrs && attrs.state || 'TODO'
                }
            };
        case 'blockTaskItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $2OrIX.generateUuid)(),
                    state: attrs && attrs.state || 'TODO'
                }
            };
        case 'table':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableRow')) {
                if (adfStage === 'stage0') return {
                    type: type,
                    content: content,
                    attrs: {
                        ...attrs,
                        localId: attrs?.localId || (0, $2OrIX.generateUuid)(),
                        width: attrs?.width || null
                    }
                };
                return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'tableRow':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableCell' && e.type !== 'tableHeader')) return {
                type: type,
                content: content
            };
            break;
        case 'tableCell':
        case 'tableHeader':
            if (content) {
                const cellAttrs = {};
                if (attrs) {
                    if (attrs.colspan && attrs.colspan > 1) cellAttrs.colspan = attrs.colspan;
                    if (attrs.rowspan && attrs.rowspan > 1) cellAttrs.rowspan = attrs.rowspan;
                    if (attrs.background) cellAttrs.background = attrs.background;
                    if (attrs.colwidth && Array.isArray(attrs.colwidth)) cellAttrs.colwidth = attrs.colwidth;
                }
                return {
                    type: type,
                    content: $0190d1906f5ad323$var$wrapInlineNodes(content),
                    attrs: attrs ? cellAttrs : undefined
                };
            }
            break;
        case 'image':
            if (attrs && attrs.src) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'placeholder':
            if (attrs && typeof attrs.text !== 'undefined') return {
                type: type,
                attrs: attrs
            };
            break;
        case 'expand':
        case 'nestedExpand':
            return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
        case 'syncBlock':
            if (adfStage === 'stage0' && (0, $cbSL1.expValEquals)('platform_synced_block', 'isEnabled', true)) return {
                type: type,
                attrs: attrs,
                marks: marks
            };
            else return $0190d1906f5ad323$export$b9908ef75cad1e0e(node);
        case 'bodiedSyncBlock':
            if (adfStage === 'stage0' && attrs && Array.isArray(content) && content.length > 0 && (0, $cbSL1.expValEquals)('platform_synced_block', 'isEnabled', true)) return {
                type: type,
                attrs: attrs,
                marks: marks,
                content: content
            };
            else return $0190d1906f5ad323$export$b9908ef75cad1e0e(node);
    }
    return $0190d1906f5ad323$export$b9908ef75cad1e0e(node);
};
const $0190d1906f5ad323$export$87c6d4a6ebb7d9e9 = (mark, adfStage = 'final')=>{
    const { attrs: attrs, type: type } = mark;
    if (type) switch(type){
        case 'code':
            return {
                type: type
            };
        case 'em':
            return {
                type: type
            };
        case 'link':
            if (attrs) {
                const { href: href, url: url, __confluenceMetadata: __confluenceMetadata } = attrs;
                let linkHref = href || url;
                if (linkHref && linkHref.indexOf(':') === -1 && !$0190d1906f5ad323$var$RELATIVE_LINK.test(linkHref) && !$0190d1906f5ad323$var$ANCHOR_LINK.test(linkHref)) linkHref = `http://${linkHref}`;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const linkAttrs = {
                    href: linkHref
                };
                if (__confluenceMetadata) linkAttrs.__confluenceMetadata = __confluenceMetadata;
                if (linkHref && (0, $iKozC.isSafeUrl)(linkHref)) return {
                    type: type,
                    attrs: linkAttrs
                };
            }
            break;
        case 'strike':
            return {
                type: type
            };
        case 'strong':
            return {
                type: type
            };
        case 'subsup':
            if (attrs && attrs['type']) {
                const subSupType = attrs['type'];
                if ($0190d1906f5ad323$export$30f8aa4cc1f8c1cb(subSupType)) return {
                    type: type,
                    attrs: {
                        type: subSupType
                    }
                };
            }
            break;
        case 'textColor':
            if (attrs && $0190d1906f5ad323$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'underline':
            return {
                type: type
            };
        case 'annotation':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
        case 'backgroundColor':
            if (attrs && $0190d1906f5ad323$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
    }
    if (adfStage === 'stage0') switch(type){
        case 'confluenceInlineComment':
            return {
                type: type,
                attrs: attrs
            };
        case 'dataConsumer':
            return {
                type: type,
                attrs: attrs
            };
        case 'fragment':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
    }
    return null;
};

});
parcelRegister("fAF2Y", function(module, exports) {
$parcel$export(module.exports, "inlineNodes", () => $b59a0ee18888e473$export$b1f729c6af6f2a6e);

var $jd35j = parcelRequire("jd35j");
const $b59a0ee18888e473$var$typedNodes = $jd35j;
const $b59a0ee18888e473$export$b1f729c6af6f2a6e = new Set(Object.keys($b59a0ee18888e473$var$typedNodes).filter((key)=>$b59a0ee18888e473$var$typedNodes[key] && $b59a0ee18888e473$var$typedNodes[key].group === 'inline'));

});
parcelRegister("jd35j", function(module, exports) {
$parcel$export(module.exports, "expandWithNestedExpand", () => (parcelRequire("eSKW9")).expandWithNestedExpand);
$parcel$export(module.exports, "expandWithNestedExpandLocalId", () => (parcelRequire("eSKW9")).expandWithNestedExpandLocalId);
$parcel$export(module.exports, "expandToJSON", () => (parcelRequire("eSKW9")).toJSON);
$parcel$export(module.exports, "confluenceJiraIssue", () => (parcelRequire("itOTx")).confluenceJiraIssue);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => (parcelRequire("99RFR")).confluenceUnsupportedBlock);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => (parcelRequire("4LGm1")).confluenceUnsupportedInline);
$parcel$export(module.exports, "doc", () => (parcelRequire("gjQyF")).doc);
$parcel$export(module.exports, "blockquote", () => (parcelRequire("iBSvH")).blockquote);
$parcel$export(module.exports, "extendedBlockquote", () => (parcelRequire("iBSvH")).extendedBlockquote);
$parcel$export(module.exports, "extendedBlockquoteWithLocalId", () => (parcelRequire("iBSvH")).extendedBlockquoteWithLocalId);
$parcel$export(module.exports, "bulletList", () => (parcelRequire("7T1su")).bulletList);
$parcel$export(module.exports, "bulletListSelector", () => (parcelRequire("7T1su")).bulletListSelector);
$parcel$export(module.exports, "bulletListWithLocalId", () => (parcelRequire("7T1su")).bulletListWithLocalId);
$parcel$export(module.exports, "codeBlock", () => (parcelRequire("02BNy")).codeBlock);
$parcel$export(module.exports, "codeBlockWithLocalId", () => (parcelRequire("02BNy")).codeBlockWithLocalId);
$parcel$export(module.exports, "codeBlockToJSON", () => (parcelRequire("02BNy")).toJSON);
$parcel$export(module.exports, "hardBreak", () => (parcelRequire("ewUmv")).hardBreak);
$parcel$export(module.exports, "heading", () => (parcelRequire("8FGKL")).heading);
$parcel$export(module.exports, "rule", () => (parcelRequire("jC4KP")).rule);
$parcel$export(module.exports, "ruleWithLocalId", () => (parcelRequire("jC4KP")).ruleWithLocalId);
$parcel$export(module.exports, "orderedList", () => (parcelRequire("a4ifE")).orderedList);
$parcel$export(module.exports, "orderedListSelector", () => (parcelRequire("a4ifE")).orderedListSelector);
$parcel$export(module.exports, "orderedListWithLocalId", () => (parcelRequire("a4ifE")).orderedListWithLocalId);
$parcel$export(module.exports, "orderedListWithOrder", () => (parcelRequire("a4ifE")).orderedListWithOrder);
$parcel$export(module.exports, "orderedListWithOrderAndLocalId", () => (parcelRequire("a4ifE")).orderedListWithOrderAndLocalId);
$parcel$export(module.exports, "paragraph", () => (parcelRequire("bK3tx")).paragraph);
$parcel$export(module.exports, "emoji", () => (parcelRequire("foHUC")).emoji);
$parcel$export(module.exports, "emojiWithLocalId", () => (parcelRequire("foHUC")).emojiWithLocalId);
$parcel$export(module.exports, "image", () => (parcelRequire("lM0g9")).image);
$parcel$export(module.exports, "mention", () => (parcelRequire("7axvl")).mention);
$parcel$export(module.exports, "mentionToJSON", () => (parcelRequire("7axvl")).toJSON);
$parcel$export(module.exports, "listItem", () => (parcelRequire("gkLMH")).listItem);
$parcel$export(module.exports, "listItemWithDecisionStage0", () => (parcelRequire("gkLMH")).listItemWithDecisionStage0);
$parcel$export(module.exports, "listItemWithLocalId", () => (parcelRequire("gkLMH")).listItemWithLocalId);
$parcel$export(module.exports, "extendedPanel", () => (parcelRequire("ePdnq")).extendedPanel);
$parcel$export(module.exports, "extendedPanelWithLocalId", () => (parcelRequire("ePdnq")).extendedPanelWithLocalId);
$parcel$export(module.exports, "PanelType", () => (parcelRequire("ePdnq")).PanelType);
$parcel$export(module.exports, "text", () => (parcelRequire("53i5t")).text);
$parcel$export(module.exports, "unknownBlock", () => (parcelRequire("bffKB")).default);
$parcel$export(module.exports, "caption", () => (parcelRequire("l2o3P")).caption);
$parcel$export(module.exports, "captionWithLocalId", () => (parcelRequire("l2o3P")).captionWithLocalId);
$parcel$export(module.exports, "media", () => (parcelRequire("bTlUc")).media);
$parcel$export(module.exports, "copyPrivateMediaAttributes", () => (parcelRequire("bTlUc")).copyPrivateAttributes);
$parcel$export(module.exports, "mediaToJSON", () => (parcelRequire("bTlUc")).toJSON);
$parcel$export(module.exports, "mediaGroup", () => (parcelRequire("goVGV")).mediaGroup);
$parcel$export(module.exports, "mediaInline", () => (parcelRequire("5RVMs")).mediaInline);
$parcel$export(module.exports, "mediaSingle", () => (parcelRequire("8Mfla")).mediaSingle);
$parcel$export(module.exports, "mediaSingleSpec", () => (parcelRequire("8Mfla")).mediaSingleSpec);
$parcel$export(module.exports, "mediaSingleWithCaption", () => (parcelRequire("8Mfla")).mediaSingleWithCaption);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => (parcelRequire("8Mfla")).mediaSingleWithWidthType);
$parcel$export(module.exports, "mediaSingleFull", () => (parcelRequire("8Mfla")).mediaSingleFull);
$parcel$export(module.exports, "mediaSingleFullWithLocalId", () => (parcelRequire("8Mfla")).mediaSingleFullWithLocalId);
$parcel$export(module.exports, "mediaSingleToJSON", () => (parcelRequire("8Mfla")).toJSON);
$parcel$export(module.exports, "table", () => (parcelRequire("e6HpD")).table);
$parcel$export(module.exports, "tableWithNestedTable", () => (parcelRequire("e6HpD")).tableWithNestedTable);
$parcel$export(module.exports, "tableRowWithNestedTable", () => (parcelRequire("e6HpD")).tableRowWithNestedTable);
$parcel$export(module.exports, "tableCellWithNestedTable", () => (parcelRequire("e6HpD")).tableCellWithNestedTable);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => (parcelRequire("e6HpD")).tableHeaderWithNestedTable);
$parcel$export(module.exports, "tableRowWithLocalId", () => (parcelRequire("e6HpD")).tableRowWithLocalId);
$parcel$export(module.exports, "tableCellWithLocalId", () => (parcelRequire("e6HpD")).tableCellWithLocalId);
$parcel$export(module.exports, "tableHeaderWithLocalId", () => (parcelRequire("e6HpD")).tableHeaderWithLocalId);
$parcel$export(module.exports, "tableRowWithNestedTableWithLocalId", () => (parcelRequire("e6HpD")).tableRowWithNestedTableWithLocalId);
$parcel$export(module.exports, "tableCellWithNestedTableWithLocalId", () => (parcelRequire("e6HpD")).tableCellWithNestedTableWithLocalId);
$parcel$export(module.exports, "tableHeaderWithNestedTableWithLocalId", () => (parcelRequire("e6HpD")).tableHeaderWithNestedTableWithLocalId);
$parcel$export(module.exports, "tableStage0", () => (parcelRequire("e6HpD")).tableStage0);
$parcel$export(module.exports, "tableWithCustomWidth", () => (parcelRequire("e6HpD")).tableWithCustomWidth);
$parcel$export(module.exports, "tableToJSON", () => (parcelRequire("e6HpD")).tableToJSON);
$parcel$export(module.exports, "tableCell", () => (parcelRequire("e6HpD")).tableCell);
$parcel$export(module.exports, "toJSONTableCell", () => (parcelRequire("e6HpD")).toJSONTableCell);
$parcel$export(module.exports, "tableHeader", () => (parcelRequire("e6HpD")).tableHeader);
$parcel$export(module.exports, "toJSONTableHeader", () => (parcelRequire("e6HpD")).toJSONTableHeader);
$parcel$export(module.exports, "tableRow", () => (parcelRequire("e6HpD")).tableRow);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => (parcelRequire("e6HpD")).tableBackgroundColorPalette);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => (parcelRequire("e6HpD")).tableBackgroundBorderColor);
$parcel$export(module.exports, "tableBackgroundColorNames", () => (parcelRequire("e6HpD")).tableBackgroundColorNames);
$parcel$export(module.exports, "getCellAttrs", () => (parcelRequire("e6HpD")).getCellAttrs);
$parcel$export(module.exports, "getCellDomAttrs", () => (parcelRequire("e6HpD")).getCellDomAttrs);
$parcel$export(module.exports, "tablePrefixSelector", () => (parcelRequire("e6HpD")).tablePrefixSelector);
$parcel$export(module.exports, "tableCellSelector", () => (parcelRequire("e6HpD")).tableCellSelector);
$parcel$export(module.exports, "tableHeaderSelector", () => (parcelRequire("e6HpD")).tableHeaderSelector);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => (parcelRequire("e6HpD")).tableCellContentWrapperSelector);
$parcel$export(module.exports, "tableCellContentDomSelector", () => (parcelRequire("e6HpD")).tableCellContentDomSelector);
$parcel$export(module.exports, "decisionList", () => (parcelRequire("9FkNK")).decisionList);
$parcel$export(module.exports, "decisionListSelector", () => (parcelRequire("9FkNK")).decisionListSelector);
$parcel$export(module.exports, "decisionItem", () => (parcelRequire("eblOZ")).decisionItem);
$parcel$export(module.exports, "taskList", () => (parcelRequire("6Yq90")).taskList);
$parcel$export(module.exports, "taskListSelector", () => (parcelRequire("6Yq90")).taskListSelector);
$parcel$export(module.exports, "taskItem", () => (parcelRequire("5iuEY")).taskItem);
$parcel$export(module.exports, "blockTaskItem", () => (parcelRequire("5iuEY")).blockTaskItem);
$parcel$export(module.exports, "date", () => (parcelRequire("s7CHM")).date);
$parcel$export(module.exports, "dateWithLocalId", () => (parcelRequire("s7CHM")).dateWithLocalId);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("hbObi")).placeholder);
$parcel$export(module.exports, "placeholderWithLocalId", () => (parcelRequire("hbObi")).placeholderWithLocalId);
$parcel$export(module.exports, "layoutSection", () => (parcelRequire("jSvxD")).layoutSection);
$parcel$export(module.exports, "layoutSectionWithLocalId", () => (parcelRequire("jSvxD")).layoutSectionWithLocalId);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => (parcelRequire("jSvxD")).layoutSectionWithSingleColumn);
$parcel$export(module.exports, "layoutSectionWithSingleColumnLocalId", () => (parcelRequire("jSvxD")).layoutSectionWithSingleColumnLocalId);
$parcel$export(module.exports, "layoutColumn", () => (parcelRequire("gNk91")).layoutColumn);
$parcel$export(module.exports, "layoutColumnWithLocalId", () => (parcelRequire("gNk91")).layoutColumnWithLocalId);
$parcel$export(module.exports, "inlineCard", () => (parcelRequire("3MHOZ")).inlineCard);
$parcel$export(module.exports, "inlineCardWithLocalId", () => (parcelRequire("3MHOZ")).inlineCardWithLocalId);
$parcel$export(module.exports, "blockCard", () => (parcelRequire("5sqgz")).blockCard);
$parcel$export(module.exports, "blockCardWithLocalId", () => (parcelRequire("5sqgz")).blockCardWithLocalId);
$parcel$export(module.exports, "unsupportedBlock", () => (parcelRequire("e1kFZ")).unsupportedBlock);
$parcel$export(module.exports, "unsupportedInline", () => (parcelRequire("5blh0")).unsupportedInline);
$parcel$export(module.exports, "status", () => (parcelRequire("c2Gqu")).status);
$parcel$export(module.exports, "nestedExpand", () => (parcelRequire("6UEeD")).nestedExpand);
$parcel$export(module.exports, "nestedExpandWithLocalId", () => (parcelRequire("6UEeD")).nestedExpandWithLocalId);
$parcel$export(module.exports, "embedCard", () => (parcelRequire("YIci7")).embedCard);
$parcel$export(module.exports, "embedCardWithLocalId", () => (parcelRequire("YIci7")).embedCardWithLocalId);
$parcel$export(module.exports, "extension", () => (parcelRequire("6r1B4")).extension);
$parcel$export(module.exports, "inlineExtension", () => (parcelRequire("5Ufvu")).inlineExtension);
$parcel$export(module.exports, "bodiedExtension", () => (parcelRequire("kuVVV")).bodiedExtension);
$parcel$export(module.exports, "extensionFrame", () => (parcelRequire("6C9Qx")).extensionFrame);
$parcel$export(module.exports, "multiBodiedExtension", () => (parcelRequire("6C9Qx")).multiBodiedExtension);
$parcel$export(module.exports, "syncBlock", () => (parcelRequire("hn1YX")).syncBlock);
$parcel$export(module.exports, "bodiedSyncBlock", () => (parcelRequire("dMcxi")).bodiedSyncBlock);

var $eSKW9 = parcelRequire("eSKW9");

var $itOTx = parcelRequire("itOTx");

var $99RFR = parcelRequire("99RFR");

var $4LGm1 = parcelRequire("4LGm1");

var $gjQyF = parcelRequire("gjQyF");

var $iBSvH = parcelRequire("iBSvH");

var $7T1su = parcelRequire("7T1su");

var $02BNy = parcelRequire("02BNy");

var $ewUmv = parcelRequire("ewUmv");

var $8FGKL = parcelRequire("8FGKL");

var $jC4KP = parcelRequire("jC4KP");

var $a4ifE = parcelRequire("a4ifE");

var $bK3tx = parcelRequire("bK3tx");

var $foHUC = parcelRequire("foHUC");

var $lM0g9 = parcelRequire("lM0g9");

var $7axvl = parcelRequire("7axvl");

var $gkLMH = parcelRequire("gkLMH");

var $ePdnq = parcelRequire("ePdnq");

var $53i5t = parcelRequire("53i5t");

var $bffKB = parcelRequire("bffKB");

var $l2o3P = parcelRequire("l2o3P");

var $bTlUc = parcelRequire("bTlUc");

var $goVGV = parcelRequire("goVGV");

var $5RVMs = parcelRequire("5RVMs");

var $8Mfla = parcelRequire("8Mfla");

var $e6HpD = parcelRequire("e6HpD");

var $9FkNK = parcelRequire("9FkNK");

var $eblOZ = parcelRequire("eblOZ");

var $6Yq90 = parcelRequire("6Yq90");

var $5iuEY = parcelRequire("5iuEY");

var $s7CHM = parcelRequire("s7CHM");

var $hbObi = parcelRequire("hbObi");

var $jSvxD = parcelRequire("jSvxD");

var $gNk91 = parcelRequire("gNk91");

var $3MHOZ = parcelRequire("3MHOZ");

var $5sqgz = parcelRequire("5sqgz");

var $e1kFZ = parcelRequire("e1kFZ");

var $5blh0 = parcelRequire("5blh0");

var $c2Gqu = parcelRequire("c2Gqu");

var $6UEeD = parcelRequire("6UEeD");

var $YIci7 = parcelRequire("YIci7");

var $6r1B4 = parcelRequire("6r1B4");

var $5Ufvu = parcelRequire("5Ufvu");

var $kuVVV = parcelRequire("kuVVV");

var $6C9Qx = parcelRequire("6C9Qx");

var $hn1YX = parcelRequire("hn1YX");

var $dMcxi = parcelRequire("dMcxi");

});



parcelRegister("g9wjI", function(module, exports) {
$parcel$export(module.exports, "ADFEncoder", () => $cd37434dd3346d1d$export$bcf771b83128eae7);
$parcel$export(module.exports, "getText", () => $cd37434dd3346d1d$export$c72d34660a162238);
$parcel$export(module.exports, "getEventHandler", () => $cd37434dd3346d1d$export$eee20638634729b3);
$parcel$export(module.exports, "findInTree", () => $cd37434dd3346d1d$export$38b61ebf4950cd39);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $8DB98 = parcelRequire("8DB98");

var $lovmf = parcelRequire("lovmf");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $cd37434dd3346d1d$var$createEncoder(parser, encoder) {
    return (value)=>encoder.encode(parser.parse(value));
}
class $cd37434dd3346d1d$export$bcf771b83128eae7 {
    constructor(createTransformerWithSchema){
        const transformer = createTransformerWithSchema((0, $8DB98.defaultSchema));
        this.encode = $cd37434dd3346d1d$var$createEncoder(transformer, new (0, $lovmf.JSONTransformer)());
    }
}
const $cd37434dd3346d1d$export$c72d34660a162238 = (node)=>{
    return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || `[${typeof node.type === 'string' ? node.type : node.type.name}]`;
};
const $cd37434dd3346d1d$export$eee20638634729b3 = (eventHandlers, type, eventName = 'onClick')=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return eventHandlers && type && eventHandlers[type] && eventHandlers[type][eventName];
};
function $cd37434dd3346d1d$export$38b61ebf4950cd39(element, topElement, evaluate) {
    if (element === topElement) return false;
    if (evaluate(element)) return true;
    if (!element.parentElement) return false;
    return $cd37434dd3346d1d$export$38b61ebf4950cd39(element.parentElement, topElement, evaluate);
}

});

parcelRegister("fpMtm", function(module, exports) {
$parcel$export(module.exports, "isAnnotationMark", () => $8e95121bd58c9778$export$855795c145f03402);
$parcel$export(module.exports, "default", () => $8e95121bd58c9778$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $jxPcD = parcelRequire("jxPcD");

var $jAnZ0 = parcelRequire("jAnZ0");
const $8e95121bd58c9778$export$855795c145f03402 = (mark)=>{
    return mark && mark.type && mark.type.name === 'annotation';
};
const $8e95121bd58c9778$var$AnnotationComponent = ({ id: id, annotationType: annotationType, children: children, dataAttributes: dataAttributes, annotationParentIds: annotationParentIds = [], allowAnnotations: allowAnnotations, useBlockLevel: useBlockLevel, isMediaInline: isMediaInline })=>{
    const data = {
        ...dataAttributes,
        ...(0, $jxPcD.buildDataAttributes)({
            id: id,
            annotationType: annotationType
        })
    };
    if (allowAnnotations) return isMediaInline ? // Inline comment on mediaInline is not supported as part of comments on media project,
    // hence skip any styling/event handling for annotations on mediaInline.
    // `id` is still needed so that comment view component can be correct positioned
    // when using comment navigation to access comments on mediaInline
    /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        id: id,
        children: children
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jAnZ0.MarkElement), {
        id: id,
        dataAttributes: data,
        annotationParentIds: annotationParentIds,
        annotationType: annotationType,
        useBlockLevel: useBlockLevel,
        children: children
    });
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        id: id,
        ...data,
        children: children
    }));
};
var $8e95121bd58c9778$export$2e2bcd8739ae039 = $8e95121bd58c9778$var$AnnotationComponent;

});
parcelRegister("jAnZ0", function(module, exports) {
$parcel$export(module.exports, "MarkElement", () => $79e3bb2207ad1bdc$export$f3069f755c1eba0b);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jxPcD = parcelRequire("jxPcD");

var $4Fc33 = parcelRequire("4Fc33");

var $kyRoR = parcelRequire("kyRoR");

var $8QIFO = parcelRequire("8QIFO");

var $eq5No = parcelRequire("eq5No");

var $iNoZC = parcelRequire("iNoZC");

var $eFHDV = parcelRequire("eFHDV");

var $3OjM0 = parcelRequire("3OjM0");
const $79e3bb2207ad1bdc$export$f3069f755c1eba0b = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, useBlockLevel: useBlockLevel })=>{
    const updateSubscriber = (0, $eq5No.useInlineCommentSubscriberContext)();
    const states = (0, $eJOHy.useContext)((0, $eFHDV.InlineCommentsStateContext));
    const { hasFocus: hasFocus, isHovered: isHovered } = (0, $iNoZC.useHasFocusEvent)({
        id: id,
        updateSubscriber: updateSubscriber
    });
    const dataAttributesMemorized = (0, $eJOHy.useMemo)(()=>dataAttributes, [
        dataAttributes
    ]);
    const { dispatch: dispatch, annotationManager: annotationManager } = (0, $3OjM0.useAnnotationManagerDispatch)();
    const onClick = (0, $eJOHy.useCallback)((props)=>{
        if (!updateSubscriber) return;
        if (useBlockLevel) return;
        const { eventTarget: eventTarget, annotationIds: annotationIds } = props;
        if (annotationManager) {
            if (hasFocus) {
                dispatch({
                    type: 'resetSelectedAnnotation'
                });
                return;
            }
            annotationManager.checkPreemptiveGate().then((canSelect)=>{
                if (canSelect) {
                    // if there is a draft, clear it first
                    annotationManager?.clearDraft();
                    // use setIsAnnotationSelected won't work here if there is a draft in progress
                    // so we need to use dispatch to update the state directly
                    dispatch({
                        type: 'updateAnnotation',
                        data: {
                            id: annotationIds[0],
                            selected: true
                        }
                    });
                    dispatch({
                        type: 'setSelectedMarkRef',
                        data: {
                            markRef: eventTarget
                        }
                    });
                }
            }).catch((error)=>{
            // TODO: EDITOR-595 - An error occurred while checking the preemptive gate. We should report this error.
            });
        } else updateSubscriber.emit((0, $4Fc33.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: annotationIds,
            eventTarget: eventTarget
        });
    }, [
        updateSubscriber,
        useBlockLevel,
        dispatch,
        annotationManager,
        hasFocus
    ]);
    const activeParentIds = (0, $8QIFO.useInlineCommentsFilter)({
        annotationIds: annotationParentIds,
        filter: {
            state: (0, $jxPcD.AnnotationMarkStates).ACTIVE
        }
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kyRoR.MarkComponent), {
        id: id,
        dataAttributes: dataAttributesMemorized,
        annotationParentIds: activeParentIds,
        onClick: onClick,
        hasFocus: hasFocus,
        isHovered: isHovered,
        state: states[id],
        useBlockLevel: useBlockLevel,
        children: children
    });
};

});
parcelRegister("kyRoR", function(module, exports) {
$parcel$export(module.exports, "MarkComponent", () => $77ee966c5ae21f53$export$4f5a51511304fdd0);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $jxPcD = parcelRequire("jxPcD");

var $eGOwo = parcelRequire("eGOwo");

var $lRq8t = parcelRequire("lRq8t");

var $4Iw1X = parcelRequire("4Iw1X");

var $3OjM0 = parcelRequire("3OjM0");
const $77ee966c5ae21f53$var$markStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    color: 'inherit',
    backgroundColor: 'unset',
    WebkitTapHighlightColor: 'transparent',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $jxPcD.AnnotationMarkStates).ACTIVE}']`]: {
        // was from blur in AnnotationSharedCSSByState().blur
        background: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
            borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            // TODO: DSP-4147 - Annotation shadow
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)",
            cursor: 'pointer'
        }
    }
});
const $77ee966c5ae21f53$var$markStylesLayeringFix = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $jxPcD.AnnotationMarkStates).ACTIVE}']`]: {
        // Only apply transparency to nested marks when parent is focused
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"] mark': {
            backgroundColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.fabric-background-color-mark &[data-has-focus="true"], &[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"
        }
    }
});
const $77ee966c5ae21f53$var$markStylesWithUpdatedShadow = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $jxPcD.AnnotationMarkStates).ACTIVE}']`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"
        }
    }
});
const $77ee966c5ae21f53$var$markStylesWithInlineComments = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $jxPcD.AnnotationMarkStates).ACTIVE}']`]: {
        // was from common in AnnotationSharedCSSByState().common
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid transparent`,
        cursor: 'pointer',
        padding: `1px 0 ${"var(--ds-space-025, 2px)"}`,
        // it was under fg(annotations_align_editor_and_renderer_styles) from AnnotationSharedCSSByState().common, assume it's on as already rolled out
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.card), &:has([data-inline-card])': {
            padding: '5px 0 3px 0'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.date-lozenger-container)': {
            paddingTop: "var(--ds-space-025, 2px)"
        },
        // was from blur in AnnotationSharedCSSByState().blur
        background: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
        borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"
        }
    }
});
const $77ee966c5ae21f53$var$markStylesWithCommentsPanel = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $jxPcD.AnnotationMarkStates).ACTIVE}']`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&[data-is-hovered="true"]:not([data-has-focus="true"])': {
            background: "var(--ds-background-accent-yellow-subtlest-hovered, #F8E6A0)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"
        }
    }
});
const $77ee966c5ae21f53$var$isMobile = ()=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
const $77ee966c5ae21f53$var$accessibilityStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    '&::before, &::after': {
        clipPath: 'inset(100%)',
        clip: 'rect(1px, 1px, 1px, 1px)',
        height: '1px',
        overflow: 'hidden',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
    },
    '&::before': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: `' [var(--ak-renderer-annotation-startmarker)] '`
    },
    '&::after': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: `' [var(--ak-renderer-annotation-endmarker)] '`
    }
});
const $77ee966c5ae21f53$export$4f5a51511304fdd0 = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, state: state, hasFocus: hasFocus, isHovered: isHovered, onClick: onClick, useBlockLevel: useBlockLevel })=>{
    const intl = (0, $lRq8t.default)();
    const annotationIds = (0, $eJOHy.useMemo)(()=>[
            ...new Set([
                ...annotationParentIds,
                id
            ])
        ], [
        id,
        annotationParentIds
    ]);
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $3OjM0.useAnnotationManagerDispatch)();
    const { currentSelectedAnnotationId: currentSelectedAnnotationId } = (0, $3OjM0.useAnnotationManagerState)();
    const isAnnotationManagerEnabled = !!annotationManager;
    // after creating a new annotation, we need to set the markRef to the new mark
    const markRef = (0, $eJOHy.useCallback)((node)=>{
        if (id === currentSelectedAnnotationId && node) dispatch({
            type: 'setSelectedMarkRef',
            data: {
                markRef: node
            }
        });
    }, [
        dispatch,
        id,
        currentSelectedAnnotationId
    ]);
    const onMarkClick = (0, $eJOHy.useCallback)((event)=>{
        // prevent inline mark logic for media block marks
        if (event.currentTarget instanceof HTMLElement && event.currentTarget.getAttribute('data-block-mark')) return;
        // prevents multiple callback on overlapping annotations
        if (event.defaultPrevented || state !== (0, $jxPcD.AnnotationMarkStates).ACTIVE) return;
        if ((0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes')) // We only want to interfere with click events if the click is on some ui inside the renderer document
        // This is to prevent the click events from portaled content (such as link previews and mention profiles)
        {
            if (event.target instanceof HTMLElement && event.target.closest('.ak-renderer-document')) {
                if (event.target.closest('[data-mention-id]')) ;
                else {
                    // prevents from opening link URL inside webView in Safari
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        } else // prevents from opening link URL inside webView in Safari
        event.preventDefault();
        if (isAnnotationManagerEnabled) // currentTarget is the right element if there are multiple overlapping annotations
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        onClick({
            eventTarget: event.currentTarget,
            annotationIds: annotationIds
        });
        else // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        onClick({
            eventTarget: event.target,
            annotationIds: annotationIds
        });
    }, [
        annotationIds,
        onClick,
        state,
        isAnnotationManagerEnabled
    ]);
    const onMarkEnter = (evt)=>{
        const focusedElementTag = document.activeElement?.tagName;
        if (focusedElementTag === 'MARK' && evt.key === 'Enter') onMarkClick(evt);
    };
    const overriddenData = !state ? dataAttributes : {
        ...dataAttributes,
        'data-mark-annotation-state': state,
        'data-has-focus': hasFocus,
        'data-is-hovered': isHovered
    };
    const desktopAccessibilityAttributes = $77ee966c5ae21f53$var$isMobile() ? {} : {
        role: 'button',
        tabIndex: 0,
        onKeyDown: onMarkEnter,
        'aria-expanded': hasFocus
    };
    const accessibility = state !== (0, $jxPcD.AnnotationMarkStates).ACTIVE ? {
        'aria-disabled': true
    } : {
        'aria-details': annotationIds.join(', '),
        ...desktopAccessibilityAttributes
    };
    return (0, $1NIU8.jsx)(useBlockLevel ? 'div' : 'mark', {
        ref: id === currentSelectedAnnotationId ? markRef : undefined,
        id: id,
        [(0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes') ? 'onClickCapture' : 'onClick']: onMarkClick,
        ...accessibility,
        ...overriddenData,
        ...!useBlockLevel && {
            css: [
                $77ee966c5ae21f53$var$markStyles,
                $77ee966c5ae21f53$var$markStylesLayeringFix,
                (0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes') && $77ee966c5ae21f53$var$markStylesWithInlineComments,
                (0, $eGOwo.fg)('confluence-frontend-comments-panel') && $77ee966c5ae21f53$var$markStylesWithCommentsPanel,
                !$77ee966c5ae21f53$var$isMobile() && $77ee966c5ae21f53$var$accessibilityStyles,
                $77ee966c5ae21f53$var$markStylesWithUpdatedShadow
            ],
            style: {
                '--ak-renderer-annotation-startmarker': intl.formatMessage((0, $4Iw1X.inlineCommentMessages).contentRendererInlineCommentMarkerStart),
                '--ak-renderer-annotation-endmarker': intl.formatMessage((0, $4Iw1X.inlineCommentMessages).contentRendererInlineCommentMarkerEnd)
            }
        }
    }, children);
};

});

parcelRegister("8QIFO", function(module, exports) {
$parcel$export(module.exports, "useInlineCommentsFilter", () => $fc07fd7dc625d9d7$export$8e7d47f9e38ad4f1);

var $eJOHy = parcelRequire("eJOHy");

var $eFHDV = parcelRequire("eFHDV");
const $fc07fd7dc625d9d7$export$8e7d47f9e38ad4f1 = ({ annotationIds: annotationIds, filter: { state: stateFilter } })=>{
    const states = (0, $eJOHy.useContext)((0, $eFHDV.InlineCommentsStateContext));
    return (0, $eJOHy.useMemo)(()=>{
        return annotationIds.reduce((acc, id)=>{
            if (states && states[id] === stateFilter) return [
                ...acc,
                id
            ];
            return acc;
        }, []);
    }, [
        annotationIds,
        states,
        stateFilter
    ]);
};

});

parcelRegister("eq5No", function(module, exports) {
$parcel$export(module.exports, "useInlineCommentSubscriberContext", () => $5e4da24e72f18355$export$b46737175cffd396);

var $eJOHy = parcelRequire("eJOHy");

var $eFHDV = parcelRequire("eFHDV");
const $5e4da24e72f18355$export$b46737175cffd396 = ()=>{
    const providers = (0, $eJOHy.useContext)((0, $eFHDV.ProvidersContext));
    if (!providers) return null;
    const { inlineComment: { updateSubscriber: updateSubscriber } } = providers;
    return updateSubscriber || null;
};

});



parcelRegister("QAAiN", function(module, exports) {
$parcel$export(module.exports, "toReact", () => $e606d7f5429e1a94$export$d4334b129116aad7);
/* eslint-disable @atlaskit/editor/no-re-export */ // Mapping file

var $37UKp = parcelRequire("37UKp");

var $bIYcL = parcelRequire("bIYcL");

var $edt1J = parcelRequire("edt1J");

var $7B5Pg = parcelRequire("7B5Pg");

var $9PRAt = parcelRequire("9PRAt");

var $lFm6v = parcelRequire("lFm6v");

var $4U2Ut = parcelRequire("4U2Ut");

var $clQ8A = parcelRequire("clQ8A");

var $105lA = parcelRequire("105lA");

var $kh0nj = parcelRequire("kh0nj");

var $agnfA = parcelRequire("agnfA");

var $36uir = parcelRequire("36uir");

var $1JSxg = parcelRequire("1JSxg");

var $1lKH5 = parcelRequire("1lKH5");

var $jLqyg = parcelRequire("jLqyg");

var $5lVub = parcelRequire("5lVub");

var $fpMtm = parcelRequire("fpMtm");

var $79gvV = parcelRequire("79gvV");

var $6Iogh = parcelRequire("6Iogh");
const $e606d7f5429e1a94$export$c00d967a0f56fdb7 = {
    code: (0, $37UKp.default),
    em: (0, $bIYcL.default),
    link: (0, $edt1J.default),
    strike: (0, $7B5Pg.default),
    strong: (0, $9PRAt.default),
    subsup: (0, $lFm6v.default),
    textColor: (0, $4U2Ut.default),
    backgroundColor: (0, $clQ8A.default),
    underline: (0, $105lA.default),
    annotation: (0, $fpMtm.default),
    border: (0, $79gvV.default),
    // Stage0
    confluenceInlineComment: (0, $6Iogh.default),
    breakout: (0, $kh0nj.default),
    alignment: (0, $agnfA.default),
    indentation: (0, $36uir.default),
    unsupportedMark: (0, $1JSxg.default),
    unsupportedNodeAttribute: (0, $1lKH5.default),
    dataConsumer: (0, $jLqyg.default),
    fragment: (0, $5lVub.default)
};
const $e606d7f5429e1a94$export$d4334b129116aad7 = (mark)=>{
    return $e606d7f5429e1a94$export$c00d967a0f56fdb7[mark.type.name];
};

});
parcelRegister("37UKp", function(module, exports) {
$parcel$export(module.exports, "isCodeMark", () => $6bff173c6c794ed6$export$86390c02c110ec2f);
$parcel$export(module.exports, "default", () => $6bff173c6c794ed6$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6YFG2 = parcelRequire("6YFG2");

var $esi81 = parcelRequire("esi81");

var $brgNx = parcelRequire("brgNx");
const $6bff173c6c794ed6$export$86390c02c110ec2f = (mark)=>{
    return mark && mark.type && mark.type.name === 'code';
};
function $6bff173c6c794ed6$export$7cea6ffa7022e85f(props) {
    const codeBidiWarningLabel = props.intl.formatMessage((0, $brgNx.codeBidiWarningMessages).label);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $esi81.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "code",
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: props.codeBidiWarningTooltipEnabled,
        ...props.dataAttributes,
        children: props.children
    });
}
var $6bff173c6c794ed6$export$2e2bcd8739ae039 = (0, $6YFG2.default)($6bff173c6c794ed6$export$7cea6ffa7022e85f);

});
parcelRegister("esi81", function(module, exports) {
$parcel$export(module.exports, "default", () => $a412e6cbdd328664$export$2e2bcd8739ae039);
/* code.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hDNIq = parcelRequire("hDNIq");

var $2E9Su = parcelRequire("2E9Su");
const $a412e6cbdd328664$var$styles = {
    base: "_ca0qyh40 _u5f3m5ip _n3tdyh40 _19bvm5ip _2rkofajl _11c81u0j _1reo1wug _18m91wug _1dqoglyw _1e0c1nu9 _bfhktkvp _16d9qvcn _syaz1fxt _vwz41kw7 _1i4q1hna _o5721jtm"
};
/**
 * __Code__
 *
 * Code highlights short strings of code snippets inline with body text.
 *
 * - [Examples](https://atlassian.design/components/code/examples)
 * - [Code](https://atlassian.design/components/code/code)
 * - [Usage](https://atlassian.design/components/code/usage)
 */ const $a412e6cbdd328664$var$Code = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function Code({ testId: testId, ...props }, ref) {
    const { children: children, codeBidiWarnings: codeBidiWarnings = true, hasBidiWarnings: hasBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, isBidiWarningTooltipEnabled: isBidiWarningTooltipEnabled, ...otherProps } = props;
    // Use new props if provided, otherwise fall back to deprecated props
    const shouldShowBidiWarnings = hasBidiWarnings !== undefined ? hasBidiWarnings : codeBidiWarnings;
    const shouldEnableTooltip = isBidiWarningTooltipEnabled !== undefined ? isBidiWarningTooltipEnabled : codeBidiWarningTooltipEnabled;
    const decoratedChildren = shouldShowBidiWarnings ? /*#__PURE__*/ (0, $gt9Am.jsx)($a412e6cbdd328664$var$RenderCodeChildrenWithBidiWarnings, {
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: shouldEnableTooltip,
        children: children
    }) : children;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("code", {
        ref: ref,
        "data-testid": testId,
        ...otherProps,
        className: (0, $hcewu.default)([
            $a412e6cbdd328664$var$styles.base
        ]),
        children: decoratedChildren
    });
}));
function $a412e6cbdd328664$var$RenderCodeChildrenWithBidiWarnings({ children: children, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled }) {
    const replacedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (childNode)=>{
        if (typeof childNode === 'string') {
            const decorated = (0, $2E9Su.default)(childNode, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hDNIq.default), {
                    bidiCharacter: bidiCharacter,
                    label: codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningTooltipEnabled
                }, index));
            return decorated;
        }
        if ($a412e6cbdd328664$var$isReactElement(childNode) && childNode.props.children) {
            // eslint-disable-next-line @repo/internal/react/no-clone-element
            const newChildNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(childNode, {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)($a412e6cbdd328664$var$RenderCodeChildrenWithBidiWarnings, {
                    codeBidiWarningLabel: codeBidiWarningLabel,
                    codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
                    children: childNode.props.children
                })
            });
            return newChildNode;
        }
        return childNode;
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
        children: replacedChildren
    });
}
function $a412e6cbdd328664$var$isReactElement(child) {
    return !!child.type;
}
$a412e6cbdd328664$var$Code.displayName = 'Code';
var $a412e6cbdd328664$export$2e2bcd8739ae039 = $a412e6cbdd328664$var$Code;

});
parcelRegister("hDNIq", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ef15aa1302d4294$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $6JdWh = parcelRequire("6JdWh");
function $9ef15aa1302d4294$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, shouldSkipChildren: shouldSkipChildren, tooltipEnabled: tooltipEnabled, isTooltipEnabled: isTooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    // Use new props if provided, otherwise fall back to deprecated props
    const shouldEnableTooltip = isTooltipEnabled !== undefined ? isTooltipEnabled : tooltipEnabled;
    const shouldSkip = shouldSkipChildren !== undefined ? shouldSkipChildren : skipChildren;
    if (shouldEnableTooltip) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: label,
        tag: $9ef15aa1302d4294$var$CustomizedTagWithRef,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6JdWh.Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter,
            children: shouldSkip ? null : bidiCharacter
        })
    }));
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6JdWh.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter,
        children: shouldSkip ? null : bidiCharacter
    });
}
const $9ef15aa1302d4294$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...rest,
        ref: ref,
        children: children
    });
});

});
parcelRegister("6JdWh", function(module, exports) {
$parcel$export(module.exports, "Decorator", () => $773f36c924fc369d$export$a592b67c93d52467);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6fs4r = parcelRequire("6fs4r");
const $773f36c924fc369d$var$decoration = {
    root: "_kqswh2mm _szpl2smr _dsq41wug _1xyt1b66 _123w1b66 _15nnze3t _rxygze3t _1a354jg8 _1j6r1odn _1uakf6fq _1kt9y7el _is06wx40 _1rus1tzq _1cfcvrvc _24gj1h6o _19o61h6o _cfu1116y _1rbawx40 _1xqc1rd4"
};
function $773f36c924fc369d$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $773f36c924fc369d$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                "data-testid": testId,
                "data-bidi-character-code": bidiCharacterCode,
                // This is set to true so that the content is not read out by
                // screen readers as the content includes angle brackets for
                // visual decoration purposes.
                // We use a visually hidden `mark` element below for screen readers
                "aria-hidden": "true",
                className: (0, $hcewu.default)([
                    $773f36c924fc369d$var$decoration.root
                ]),
                children: children
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6fs4r.default), {
                testId: testId && `${testId}--visually-hidden`,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("mark", {
                    children: bidiCharacterCode
                })
            })
        ]
    });
}
function $773f36c924fc369d$var$getBidiCharacterCode(bidiCharacter) {
    const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
    return `U+${bidiCharacterCode}`;
}

});


parcelRegister("2E9Su", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb505789c157e144$export$2e2bcd8739ae039);
const $fb505789c157e144$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
function $fb505789c157e144$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll($fb505789c157e144$export$ecb256e6a1f5ee7e)
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});



parcelRegister("bIYcL", function(module, exports) {
$parcel$export(module.exports, "default", () => $8786347b58360674$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
function $8786347b58360674$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, $gt9Am.jsx)("em", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("edt1J", function(module, exports) {
$parcel$export(module.exports, "default", () => $6876389d600286d8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");


var $g9wjI = parcelRequire("g9wjI");

var $7ueoK = parcelRequire("7ueoK");

var $bMFKb = parcelRequire("bMFKb");

var $l5jZM = parcelRequire("l5jZM");

var $e2B2h = parcelRequire("e2B2h");
const $6876389d600286d8$var$anchorStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    color: `var(--ds-link, ${(0, $7bb4c1736002a04a$export$b3de0ae08da2ce64)})`,
    '&:hover': {
        color: `var(--ds-link, ${(0, $7bb4c1736002a04a$export$e62e8919cca44969)})`,
        textDecoration: 'underline'
    },
    '&:active': {
        color: `var(--ds-link-pressed, ${(0, $7bb4c1736002a04a$export$a6ee3d71bc067634)})`
    }
});
function $6876389d600286d8$export$2e2bcd8739ae039(props) {
    const { href: href, target: target, eventHandlers: eventHandlers, fireAnalyticsEvent: fireAnalyticsEvent, isMediaLink: isMediaLink, dataAttributes: dataAttributes } = props;
    const anchorProps = {
        href: href,
        target: target,
        title: href
    };
    if (target === '_blank') anchorProps.rel = 'noreferrer noopener';
    const handler = (0, $g9wjI.getEventHandler)(eventHandlers, 'link');
    if (isMediaLink) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, props.children);
    const analyticsData = {
        attributes: {
            location: 'renderer'
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: 'renderer'
    };
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $e2B2h.default), {
        data: analyticsData
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $l5jZM.default), {
        css: $6876389d600286d8$var$anchorStyles,
        onClick: (e)=>{
            if (fireAnalyticsEvent) fireAnalyticsEvent({
                action: (0, $bMFKb.ACTION).VISITED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).LINK,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                attributes: {
                    platform: (0, $7ueoK.PLATFORM).WEB,
                    mode: (0, $7ueoK.MODE).RENDERER
                }
            });
            if (handler) handler(e, href);
        },
        ...anchorProps,
        ...dataAttributes,
        isLinkComponent: true,
        enableResolve: true
    }, props.children));
}

});
parcelRegister("l5jZM", function(module, exports) {
$parcel$export(module.exports, "default", () => $1beed08016469a9f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $dUaMU = parcelRequire("dUaMU");

var $59rsN = parcelRequire("59rsN");

var $eJ9f5 = parcelRequire("eJ9f5");

var $liquj = parcelRequire("liquj");

var $1gQOQ = parcelRequire("1gQOQ");

var $60qVn = parcelRequire("60qVn");

var $l9SGA = parcelRequire("l9SGA");

var $zJfva = parcelRequire("zJfva");

var $jBltW = parcelRequire("jBltW");
const $1beed08016469a9f$var$PACKAGE_DATA = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: 'linkUrl'
};
const $1beed08016469a9f$var$Anchor = (0, $liquj.withLinkClickedEvent)('a');
const $1beed08016469a9f$export$8c0773eab230d49e = (0, $liquj.withLinkClickedEvent)((0, $eJ9f5.default));
const $1beed08016469a9f$var$LinkUrl = ({ href: href, children: children, checkSafety: checkSafety = true, onClick: onClick, testId: testId = 'link-with-safety', isLinkComponent: isLinkComponent = false, enableResolve: enableResolve = false, ...props })=>{
    (0, $gRw8I.di)($1beed08016469a9f$export$8c0773eab230d49e, (0, $jBltW.useLinkWarningModal));
    const { isLinkSafe: isLinkSafe, showSafetyWarningModal: showSafetyWarningModal, ...linkWarningModalProps } = (0, $jBltW.useLinkWarningModal)();
    const resolveHyperlinkFG = (0, $59rsN.default).checkGate('platform_editor_resolve_hyperlinks_killswitch');
    if (resolveHyperlinkFG) {
        const Link = enableResolve ? (0, $l9SGA.HyperlinkWithSmartLinkResolver) : (0, $60qVn.default);
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1gQOQ.LinkAnalyticsContext), {
                    url: href,
                    display: "url",
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)(Link, {
                        href: href,
                        isLinkComponent: isLinkComponent,
                        onClick: (e)=>{
                            if (!checkSafety) {
                                onClick && onClick(e);
                                return;
                            }
                            // Only call the onClick if the link is safe
                            if (isLinkSafe(e, href)) onClick && onClick(e);
                            else showSafetyWarningModal(e, href);
                        },
                        ...props,
                        children: children
                    })
                }),
                checkSafety && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $zJfva.default), {
                    ...linkWarningModalProps
                })
            ]
        });
    }
    const Link = isLinkComponent ? $1beed08016469a9f$export$8c0773eab230d49e : $1beed08016469a9f$var$Anchor;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1gQOQ.LinkAnalyticsContext), {
                url: href,
                display: "url",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(Link, {
                    ...isLinkComponent ? {
                        testId: testId
                    } : {
                        'data-testid': testId
                    },
                    href: href || '',
                    onClick: (e)=>{
                        if (!checkSafety) {
                            onClick && onClick(e);
                            return;
                        }
                        // Only call the onClick if the link is safe
                        if (isLinkSafe(e, href)) onClick && onClick(e);
                        else showSafetyWarningModal(e, href);
                    },
                    ...props,
                    children: children
                })
            }),
            checkSafety && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $zJfva.default), {
                ...linkWarningModalProps
            })
        ]
    });
};
var $1beed08016469a9f$export$2e2bcd8739ae039 = (0, $dUaMU.default)($1beed08016469a9f$var$PACKAGE_DATA)($1beed08016469a9f$var$LinkUrl);

});
parcelRegister("liquj", function(module, exports) {
$parcel$export(module.exports, "fireLinkClickedEvent", () => $9bb097c912a9f010$export$7987de3055fbdcb0);
$parcel$export(module.exports, "withLinkClickedEvent", () => $9bb097c912a9f010$export$263352d59c0c5966);

var $eJOHy = parcelRequire("eJOHy");

var $8GnsF = parcelRequire("8GnsF");

var $e3qu2 = parcelRequire("e3qu2");

var $b43DQ = parcelRequire("b43DQ");
const $9bb097c912a9f010$export$cfb45d54e1604f6c = new Map([
    [
        undefined,
        'none'
    ],
    [
        0,
        'left'
    ],
    [
        1,
        'middle'
    ],
    [
        2,
        'right'
    ]
]);
const $9bb097c912a9f010$export$74743eda5dda3ccf = (e)=>{
    return [
        'alt',
        'ctrl',
        'meta',
        'shift'
    ].filter((key)=>e[`${key}Key`] === true);
};
const $9bb097c912a9f010$var$isContentEditable = (el)=>{
    return el instanceof HTMLElement && el.isContentEditable;
};
function $9bb097c912a9f010$export$d2a83e3b34be812b(e, clickType) {
    const { mac: mac, safari: safari } = (0, $8GnsF.browser)();
    /**
	 * If the link/parent is content editable then left click won't have typical effect
	 */ if ($9bb097c912a9f010$var$isContentEditable(e.currentTarget) && [
        'left',
        'middle'
    ].includes(clickType)) return 'contentEditable';
    switch(clickType){
        case 'left':
        case 'keyboard':
            {
                // Meta key = Cmd for macOS, Windows key sometimes for Windows (otherwise false)
                // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
                if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                if (e.shiftKey) {
                    // Alt/option click in safari typically adds the link to bookmarks
                    if (safari) return 'alt';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.ctrlKey) {
                    // Ctrl+Left on macOS defaults to triggering a right click instead (so won't trigger onClick)
                    // but if this behaviour is disabled, likely outcome is clickThrough
                    if (mac) return 'clickThrough';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.altKey) return 'alt';
                const target = e.currentTarget.getAttribute('target');
                if (target === '_blank') return 'clickThroughNewTabOrWindow';
                return 'clickThrough';
            }
        case 'middle':
            return 'clickThroughNewTabOrWindow';
        case 'right':
            return 'contextMenu';
    }
    return 'unknown';
}
const $9bb097c912a9f010$var$linkClickedEvent = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        }
    });
const $9bb097c912a9f010$export$7fedc699766c16de = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $9bb097c912a9f010$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $9bb097c912a9f010$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $9bb097c912a9f010$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    const linkClickedEventResult = $9bb097c912a9f010$var$linkClickedEvent({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented
    });
    // if the current target is an anchor tag, we can get the href from it and use that as the url being navigated too.
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        return {
            ...linkClickedEventResult,
            nonPrivacySafeAttributes: {
                url: url
            }
        };
    } else // We can't get the href from the event target, so dont include the url or any non privacy safe attributes
    return linkClickedEventResult;
};
const $9bb097c912a9f010$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
        const payload = $9bb097c912a9f010$export$7fedc699766c16de(event);
        if (payload) createAnalyticsEvent({
            ...payload,
            ...overrides,
            attributes: {
                ...payload.attributes,
                ...overrides?.attributes
            },
            nonPrivacySafeAttributes: {
                ...payload.nonPrivacySafeAttributes,
                ...overrides?.nonPrivacySafeAttributes
            }
        }).fire((0, $b43DQ.ANALYTICS_CHANNEL));
    };
const $9bb097c912a9f010$var$getDisplayName = (WrappedComponent)=>{
    if (typeof WrappedComponent === 'string') return WrappedComponent;
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
function $9bb097c912a9f010$export$263352d59c0c5966(WrappedComponent) {
    const Component = (props)=>{
        const onClick = (0, $e3qu2.useLinkClicked)(props.onClick);
        const onMouseDown = (0, $e3qu2.useMouseDownEvent)(props.onMouseDown);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, {
            ...props,
            onClick: onClick,
            onMouseDown: onMouseDown
        });
    };
    Component.displayName = `withLinkClickedEvent(${$9bb097c912a9f010$var$getDisplayName(WrappedComponent)})`;
    return Component;
}

});
parcelRegister("8GnsF", function(module, exports) {
$parcel$export(module.exports, "browser", () => $9001dc59012896ed$export$3f2684e5d7cb1006);
const $9001dc59012896ed$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $9001dc59012896ed$var$result.mac = /Mac/.test(navigator.platform);
    let ie = $9001dc59012896ed$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $9001dc59012896ed$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $9001dc59012896ed$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $9001dc59012896ed$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $9001dc59012896ed$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $9001dc59012896ed$var$result.android = /Android \d/.test(navigator.userAgent);
    $9001dc59012896ed$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $9001dc59012896ed$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $9001dc59012896ed$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $9001dc59012896ed$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $9001dc59012896ed$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
function $9001dc59012896ed$export$3f2684e5d7cb1006() {
    return $9001dc59012896ed$var$result;
}

});

parcelRegister("e3qu2", function(module, exports) {
$parcel$export(module.exports, "useLinkClicked", () => $3d45ba8ff999246a$export$5993d3ca6c85f774);
$parcel$export(module.exports, "useMouseDownEvent", () => $3d45ba8ff999246a$export$df67f318ded0283c);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $liquj = parcelRequire("liquj");
var $3d45ba8ff999246a$export$81a5b494baf0f17c = /*#__PURE__*/ function(ClickButton) {
    ClickButton[ClickButton["Left"] = 0] = "Left";
    ClickButton[ClickButton["Middle"] = 1] = "Middle";
    ClickButton[ClickButton["Right"] = 2] = "Right";
    return ClickButton;
}({});
const $3d45ba8ff999246a$export$5993d3ca6c85f774 = (/**
	 * Handler to
	 */ handler, /**
	 * Filter which mouse events should trigger the link clicked event
	 */ predicate)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return (0, $eJOHy.useCallback)((...args)=>{
        const [event] = args;
        handler?.apply(null, args);
        if (!predicate || predicate?.(event)) (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        handler,
        predicate,
        createAnalyticsEvent
    ]);
};
const $3d45ba8ff999246a$var$isNotLeftClick = (event)=>event.button !== 0;
const $3d45ba8ff999246a$export$df67f318ded0283c = (onMouseDown)=>{
    return $3d45ba8ff999246a$export$5993d3ca6c85f774(onMouseDown, $3d45ba8ff999246a$var$isNotLeftClick);
};

});

parcelRegister("b43DQ", function(module, exports) {
$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $3132e66a6b380708$export$85183a312807388d);
$parcel$export(module.exports, "context", () => $3132e66a6b380708$export$a078c61943f9dbbe);
$parcel$export(module.exports, "TrackQuickActionType", () => $3132e66a6b380708$export$72af824fa910c33e);
$parcel$export(module.exports, "TrackQuickActionFailureReason", () => $3132e66a6b380708$export$c89e475f7f7174c2);
$parcel$export(module.exports, "SmartLinkEvents", () => $3132e66a6b380708$export$b91e0203b928470c);
const $3132e66a6b380708$export$85183a312807388d = 'media';
const $3132e66a6b380708$export$a078c61943f9dbbe = {
    componentName: 'smart-cards',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
var $3132e66a6b380708$export$72af824fa910c33e = /*#__PURE__*/ function(TrackQuickActionType) {
    TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
    return TrackQuickActionType;
}({});
var $3132e66a6b380708$export$c89e475f7f7174c2 = /*#__PURE__*/ function(TrackQuickActionFailureReason) {
    TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
    TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
    TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
    return TrackQuickActionFailureReason;
}({});
class $3132e66a6b380708$export$b91e0203b928470c {
    insertSmartLink(url, type, createAnalyticsEvent) {
        $3132e66a6b380708$export$2a123f7ee48a122c({
            action: 'inserted',
            actionSubject: 'smartLink',
            eventType: 'track',
            attributes: {
                type: type
            },
            nonPrivacySafeAttributes: {
                domainName: url
            }
        }, createAnalyticsEvent);
    }
}
const $3132e66a6b380708$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($3132e66a6b380708$export$85183a312807388d);
};

});


parcelRegister("1gQOQ", function(module, exports) {
$parcel$export(module.exports, "LinkAnalyticsContext", () => $fe116df880bf8f77$export$9458cdec663b9ff1);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $e2B2h = parcelRequire("e2B2h");
const $fe116df880bf8f77$export$9458cdec663b9ff1 = ({ display: display, id: id, children: children, source: source })=>{
    const displayCategory = display === 'url' ? 'link' : undefined;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
        data: {
            source: source,
            attributes: {
                displayCategory: displayCategory,
                display: display,
                id: id
            }
        },
        children: children
    });
};

});

parcelRegister("60qVn", function(module, exports) {
$parcel$export(module.exports, "default", () => $74cba8ab54cad65b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eJ9f5 = parcelRequire("eJ9f5");

var $liquj = parcelRequire("liquj");
const $74cba8ab54cad65b$var$Anchor = (0, $liquj.withLinkClickedEvent)('a');
const $74cba8ab54cad65b$export$8c0773eab230d49e = (0, $liquj.withLinkClickedEvent)((0, $eJ9f5.default));
const $74cba8ab54cad65b$var$Hyperlink = ({ href: href, children: children, testId: testId, isLinkComponent: isLinkComponent = false, ...props })=>{
    const Link = isLinkComponent ? $74cba8ab54cad65b$export$8c0773eab230d49e : $74cba8ab54cad65b$var$Anchor;
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Link, {
        ...isLinkComponent ? {
            testId: testId
        } : {
            'data-testid': testId
        },
        href: href || '',
        ...props,
        children: children
    });
};
var $74cba8ab54cad65b$export$2e2bcd8739ae039 = $74cba8ab54cad65b$var$Hyperlink;

});

parcelRegister("l9SGA", function(module, exports) {
$parcel$export(module.exports, "HyperlinkWithSmartLinkResolver", () => $a65a192ed5eb10a7$export$1fdb4f77fe528a52);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $6YFG2 = parcelRequire("6YFG2");

var $59rsN = parcelRequire("59rsN");

var $hy9OT = parcelRequire("hy9OT");

var $eGOwo = parcelRequire("eGOwo");

var $03JM4 = parcelRequire("03JM4");

var $cIlQC = parcelRequire("cIlQC");

var $4SSxN = parcelRequire("4SSxN");

var $44bDi = parcelRequire("44bDi");

var $e9k8p = parcelRequire("e9k8p");

var $ettNQ = parcelRequire("ettNQ");

var $60qVn = parcelRequire("60qVn");

var $9rEhV = parcelRequire("9rEhV");
const $a65a192ed5eb10a7$var$HyperlinkFallbackComponent = ()=>null;
const $a65a192ed5eb10a7$var$withValidator = (Component, DefaultComponent)=>(props)=>{
        const shouldResolveHyperlink = (0, $4SSxN.default)(props?.href);
        return shouldResolveHyperlink && props.href ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $44bDi.SmartLinkAnalyticsContext), {
            url: props.href,
            display: "url",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                ...props
            })
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)(DefaultComponent, {
            ...props
        });
    };
const $a65a192ed5eb10a7$var$HyperlinkWithSmartLinkResolverInner = ({ onClick: onClickCallback, ...props })=>{
    const { actions: actions, state: state } = (0, $cIlQC.default)({
        href: props.href || ''
    });
    const services = (0, $03JM4.getServices)(state?.details);
    const thirdPartyARI = (0, $03JM4.getThirdPartyARI)(state?.details);
    const firstPartyIdentifier = (0, $03JM4.getFirstPartyIdentifier)();
    const fire3PClickEvent = (0, $eGOwo.fg)('platform_smartlink_3pclick_analytics') ? (0, $ettNQ.useFire3PWorkflowsClickEvent)(firstPartyIdentifier, thirdPartyARI) : undefined;
    const onClick = (0, $eJOHy.useCallback)((e)=>{
        // Only fire the event if the feature flag is on and other conditions are met
        if (state?.status === 'resolved' && e?.button === 0 && fire3PClickEvent && (0, $eGOwo.fg)('platform_smartlink_3pclick_analytics')) // 0 taken from button state representation -
        // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
        fire3PClickEvent();
        onClickCallback?.(e);
    }, [
        onClickCallback,
        fire3PClickEvent,
        state?.status
    ]);
    const onAuthorize = (0, $eJOHy.useCallback)(()=>actions.authorize('url'), [
        actions
    ]);
    const shouldRenderConnectBtn = ()=>{
        if (!props.children || !Array.isArray(props.children) || props.children.length === 0) return false;
        const firstChild = props.children[0];
        try {
            // Check if first child has a string matching href
            if (typeof firstChild === 'string') return props.href === firstChild;
            // Check if first child has another child object containing matching href. This aligns with the behavior of the TextWrapper component used by editor to render link nodes
            if (firstChild?.props?.children && typeof firstChild.props.children === 'string') return props.href === firstChild.props.children;
        } catch (_) {
            return false;
        }
    };
    if (state?.status === 'unauthorized' && shouldRenderConnectBtn() && ((0, $59rsN.default).getExperimentValue('platform_linking_bluelink_connect_confluence', 'isEnabled', false) || (0, $59rsN.default).getExperimentValue('platform_linking_bluelink_connect_jira', 'isEnabled', false))) {
        const provider = (0, $hy9OT.extractSmartLinkProvider)(state?.details);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9rEhV.default), {
            ...props,
            onAuthorize: services?.length ? onAuthorize : undefined,
            onClick: onClick,
            showConnectBtn: services?.length > 0,
            provider: provider
        });
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $60qVn.default), {
        ...props,
        onClick: onClick
    });
};
const $a65a192ed5eb10a7$export$1fdb4f77fe528a52 = (0, $axOsj.withErrorBoundary)($a65a192ed5eb10a7$var$withValidator((0, $6YFG2.default)((0, $e9k8p.default)($a65a192ed5eb10a7$var$HyperlinkWithSmartLinkResolverInner), {
    enforceContext: false
}), (0, $60qVn.default)), {
    FallbackComponent: $a65a192ed5eb10a7$var$HyperlinkFallbackComponent
});

});
parcelRegister("hy9OT", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkTitle", () => $27694d81d2f2dfcb$export$3eda18658b66108);
$parcel$export(module.exports, "extractSmartLinkUrl", () => $27694d81d2f2dfcb$export$7ba9b12c6a1b73de);
$parcel$export(module.exports, "extractSmartLinkAri", () => $27694d81d2f2dfcb$export$16b02be3e2bb31ad);
$parcel$export(module.exports, "extractSmartLinkEmbed", () => $27694d81d2f2dfcb$export$864b719baf5d744d);
$parcel$export(module.exports, "extractSmartLinkProvider", () => $27694d81d2f2dfcb$export$ff753ed519e96e9e);
$parcel$export(module.exports, "extractSmartLinkCreatedOn", () => $27694d81d2f2dfcb$export$7a685df468cbf38f);
$parcel$export(module.exports, "extractSmartLinkModifiedOn", () => $27694d81d2f2dfcb$export$75047940e157fd1f);
$parcel$export(module.exports, "extractSmartLinkCreatedBy", () => $27694d81d2f2dfcb$export$242875b46118beb2);
$parcel$export(module.exports, "extractSmartLinkAuthorGroup", () => $27694d81d2f2dfcb$export$41fc716e1bc2dc90);
$parcel$export(module.exports, "extractSmartLinkModifiedBy", () => $27694d81d2f2dfcb$export$7f099a839071a190);
$parcel$export(module.exports, "extractSmartLinkDownloadUrl", () => $27694d81d2f2dfcb$export$96ed4c1b14ac210a);

var $9R3Jd = parcelRequire("9R3Jd");
var $1IwHM = parcelRequire("1IwHM");
var $9T6dQ = parcelRequire("9T6dQ");
var $3seWH = parcelRequire("3seWH");
var $aHgka = parcelRequire("aHgka");
var $hdxEk = parcelRequire("hdxEk");
var $9Thyx = parcelRequire("9Thyx");
var $8T839 = parcelRequire("8T839");

var $6OR2o = parcelRequire("6OR2o");

var $3jSKi = parcelRequire("3jSKi");
const $27694d81d2f2dfcb$export$3eda18658b66108 = (response, removeTextHighlightingFromTitle)=>{
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.displayName;
    return (0, $8T839.extractTitle)(response?.data, removeTextHighlightingFromTitle);
};
const $27694d81d2f2dfcb$export$7ba9b12c6a1b73de = (response)=>{
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.url;
    return (0, $3seWH.extractLink)(response?.data);
};
const $27694d81d2f2dfcb$export$16b02be3e2bb31ad = (response)=>{
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.ari || (0, $3jSKi.extractEntity)(response)?.thirdPartyAri;
    const data = response?.data;
    return (0, $9R3Jd.extractAri)(data);
};
const $27694d81d2f2dfcb$export$864b719baf5d744d = (response, iframeUrlType)=>{
    if ((0, $3jSKi.isEntityPresent)(response)) {
        // TODO: Missing iframeUrlType
        const embedUrl = (0, $3jSKi.extractEntityEmbedUrl)(response);
        return embedUrl ? {
            src: embedUrl
        } : undefined;
    }
    return (0, $6OR2o.extractPreview)(response?.data, 'web', iframeUrlType);
};
const $27694d81d2f2dfcb$export$ff753ed519e96e9e = (response)=>{
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntityProvider)(response);
    return response?.data && (0, $9Thyx.extractProvider)(response?.data);
};
const $27694d81d2f2dfcb$export$7a685df468cbf38f = (response)=>{
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.createdAt;
    return response?.data && (0, $1IwHM.extractDateCreated)(response.data);
};
const $27694d81d2f2dfcb$export$75047940e157fd1f = (response)=>{
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.lastUpdatedAt;
    return response?.data && (0, $9T6dQ.extractDateUpdated)(response.data);
};
const $27694d81d2f2dfcb$export$242875b46118beb2 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.createdBy?.displayName;
    const persons = (0, $aHgka.extractPersonCreatedBy)(response.data);
    return !!persons?.length ? persons[0].name : undefined;
};
const $27694d81d2f2dfcb$export$41fc716e1bc2dc90 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) {
        const entity = (0, $3jSKi.extractEntity)(response);
        const owners = entity?.owners;
        if (owners) return owners.map((owner)=>({
                name: owner.displayName,
                src: owner.picture
            })).filter((item)=>!!item);
    }
    return (0, $aHgka.extractPersonCreatedBy)(response.data);
};
const $27694d81d2f2dfcb$export$7f099a839071a190 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.lastUpdatedBy?.displayName;
    const person = (0, $hdxEk.extractPersonUpdatedBy)(response.data);
    return person ? person.name : undefined;
};
const $27694d81d2f2dfcb$export$96ed4c1b14ac210a = (response)=>{
    if ((0, $3jSKi.isEntityPresent)(response)) {
        const entity = (0, $3jSKi.extractEntity)(response);
        return entity && 'exportLinks' in entity && Array.isArray(entity.exportLinks) && entity.exportLinks.length > 0 ? entity?.exportLinks?.[0].url : undefined;
    }
    return response?.data?.['atlassian:downloadUrl'];
};

});
parcelRegister("9R3Jd", function(module, exports) {
$parcel$export(module.exports, "extractAri", () => $8b174f4749aef8f6$export$be18a6294fd426ec);
const $8b174f4749aef8f6$export$be18a6294fd426ec = (jsonLd)=>{
    if (jsonLd['atlassian:ari']) return jsonLd['atlassian:ari'];
    return undefined;
};

});

parcelRegister("1IwHM", function(module, exports) {
$parcel$export(module.exports, "extractDateCreated", () => $9bce2094467d007a$export$e1226a5e0bbbf862);
const $9bce2094467d007a$export$e1226a5e0bbbf862 = (jsonLd)=>{
    if (jsonLd['schema:dateCreated']) return jsonLd['schema:dateCreated'];
    return undefined;
};

});

parcelRegister("9T6dQ", function(module, exports) {
$parcel$export(module.exports, "extractDateUpdated", () => $ab4b85685fa6a4de$export$7fc2f5e6f9d22ae7);
const $ab4b85685fa6a4de$export$7fc2f5e6f9d22ae7 = (jsonLd)=>{
    if (jsonLd.updated) return jsonLd.updated;
    return undefined;
};

});

parcelRegister("3seWH", function(module, exports) {
$parcel$export(module.exports, "extractLink", () => $6f5194fe1d549fab$export$63f54cf4c5883620);

var $jo2Je = parcelRequire("jo2Je");
const $6f5194fe1d549fab$export$63f54cf4c5883620 = (jsonLd)=>{
    const url = jsonLd?.url;
    if (url) {
        if (typeof url === 'string') return url;
        else return (0, $jo2Je.extractUrlFromLinkJsonLd)(url);
    }
    return undefined;
};

});
parcelRegister("jo2Je", function(module, exports) {
$parcel$export(module.exports, "extractUrlFromLinkJsonLd", () => $9fd708127ba15a99$export$396ba4ef2e37dc65);
const $9fd708127ba15a99$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $9fd708127ba15a99$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
    return undefined;
};

});


parcelRegister("aHgka", function(module, exports) {
$parcel$export(module.exports, "extractPersonCreatedBy", () => $537f0d3ea3fbcfb9$export$a66235cba0c9d11a);

var $9JeZK = parcelRequire("9JeZK");
const $537f0d3ea3fbcfb9$export$a66235cba0c9d11a = (jsonLd)=>{
    const attributedTo = jsonLd.attributedTo;
    if (attributedTo) {
        if (Array.isArray(attributedTo)) return attributedTo.map((0, $9JeZK.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $9JeZK.extractPersonFromJsonLd)(attributedTo);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};

});
parcelRegister("9JeZK", function(module, exports) {
$parcel$export(module.exports, "extractPersonFromJsonLd", () => $a634170ae128bef4$export$c471ae5fddcf1392);

var $4moW4 = parcelRequire("4moW4");
const $a634170ae128bef4$export$c471ae5fddcf1392 = (person)=>{
    if (typeof person === 'string') throw Error('Link.person needs to be an object.');
    else if (person['@type'] === 'Link') {
        if (person.name) return {
            name: person.name
        };
    } else {
        if (person.name) return {
            name: person.name,
            src: person.icon && (0, $4moW4.extractUrlFromIconJsonLd)(person.icon)
        };
    }
    return undefined;
};

});
parcelRegister("4moW4", function(module, exports) {
$parcel$export(module.exports, "extractUrlFromIconJsonLd", () => $74d023e64fe83956$export$67f3d92c824fd850);

var $jo2Je = parcelRequire("jo2Je");
const $74d023e64fe83956$export$67f3d92c824fd850 = (icon)=>{
    if (typeof icon === 'string') return icon;
    else if (icon['@type'] === 'Link') return (0, $jo2Je.extractUrlFromLinkJsonLd)(icon);
    else {
        if (icon.url) return (0, $jo2Je.extractUrlFromLinkJsonLd)(icon.url);
    }
    return undefined;
};

});



parcelRegister("hdxEk", function(module, exports) {
$parcel$export(module.exports, "extractPersonUpdatedBy", () => $9b8725aa10ec9f20$export$8a2d1ed7e6f336f0);

var $9JeZK = parcelRequire("9JeZK");
const $9b8725aa10ec9f20$export$8a2d1ed7e6f336f0 = (jsonLd)=>{
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) return (0, $9JeZK.extractPersonFromJsonLd)(updatedBy);
    return undefined;
};

});

parcelRegister("9Thyx", function(module, exports) {
$parcel$export(module.exports, "extractProvider", () => $af479a3c34473181$export$a832871718466647);
$parcel$export(module.exports, "extractProviderIcon", () => $af479a3c34473181$export$6fb636a2ac885215);
$parcel$export(module.exports, "isConfluenceGenerator", () => $af479a3c34473181$export$38df542ff03a4183);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lgMTT = parcelRequire("lgMTT");

var $lgMTT = parcelRequire("lgMTT");

var $eGOwo = parcelRequire("eGOwo");


var $4moW4 = parcelRequire("4moW4");
var $jo2Je = parcelRequire("jo2Je");
const $af479a3c34473181$export$a832871718466647 = (jsonLd)=>{
    const generator = jsonLd.generator;
    if (generator) {
        if (typeof generator === 'string') throw Error('Link.generator requires a name and icon.');
        else if (generator['@type'] === 'Link') {
            if (generator.name) return {
                text: generator.name
            };
        } else if (generator.name) {
            const id = generator['@id'];
            return {
                text: generator.name,
                icon: $af479a3c34473181$export$6fb636a2ac885215(generator.icon, id),
                id: id,
                image: $af479a3c34473181$var$extractProviderImage(generator.image)
            };
        }
    }
    return undefined;
};
const $af479a3c34473181$export$6fb636a2ac885215 = (icon, id)=>{
    if (id) {
        if (id === (0, $9f5235d88a87be7c$export$cee224b5de4d6d66)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.ConfluenceIcon), {
            appearance: "brand",
            size: "xxsmall",
            ...(0, $eGOwo.fg)('navx-1895-new-logo-design') ? {
                shouldUseNewLogoDesign: true
            } : undefined
        });
        else if (id === (0, $9f5235d88a87be7c$export$f654d825189934a7)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.JiraIcon), {
            appearance: "brand",
            size: "xxsmall",
            ...(0, $eGOwo.fg)('navx-1895-new-logo-design') ? {
                shouldUseNewLogoDesign: true
            } : undefined
        });
    }
    if (icon) return (0, $4moW4.extractUrlFromIconJsonLd)(icon);
    return undefined;
};
const $af479a3c34473181$var$extractProviderImage = (image)=>{
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $jo2Je.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $jo2Je.extractUrlFromLinkJsonLd)(image.url);
        }
    }
    return undefined;
};
const $af479a3c34473181$export$38df542ff03a4183 = (id)=>{
    return id === (0, $9f5235d88a87be7c$export$cee224b5de4d6d66);
};

});
const $9f5235d88a87be7c$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $9f5235d88a87be7c$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $9f5235d88a87be7c$export$84a73a0383f58180 = 'JiraTask';
const $9f5235d88a87be7c$export$c6c83963a9378a67 = 'JiraSubTask';
const $9f5235d88a87be7c$export$58af3c426c111a6d = 'JiraStory';
const $9f5235d88a87be7c$export$ac9898a63417219e = 'JiraBug';
const $9f5235d88a87be7c$export$54db5e3fb12e39cd = 'JiraEpic';
const $9f5235d88a87be7c$export$2f54a5a217202c85 = 'JiraIncident';
const $9f5235d88a87be7c$export$d097371052bfc411 = 'JiraServiceRequest';
const $9f5235d88a87be7c$export$efd9452ad16c6676 = 'JiraChange';
const $9f5235d88a87be7c$export$2e7e70abb5d81f67 = 'JiraProblem';
const $9f5235d88a87be7c$export$ce25cfc40b280dbc = 'JiraCustomTaskType';


parcelRegister("8T839", function(module, exports) {
$parcel$export(module.exports, "extractTitle", () => $8cab052601305f86$export$b05803156e5015b6);

var $inXgt = parcelRequire("inXgt");

var $dpM2S = parcelRequire("dpM2S");
const $8cab052601305f86$export$b05803156e5015b6 = (jsonLd, removeTextHighlightingFromTitle)=>{
    if (!jsonLd) return undefined;
    const name = jsonLd.name?.replace(/[\r\n]+/g, '');
    const id = jsonLd['@id'] || '';
    // Check if this is a reference to something _inside_ a Repository.
    // We format these titles to represent more metadata.
    const context = (0, $inXgt.extractContext)(jsonLd);
    const type = (0, $dpM2S.extractType)(jsonLd);
    const hasContextType = context && context.type;
    const hasContextRepo = hasContextType && context.type.includes('atlassian:SourceCodeRepository');
    if (hasContextRepo && type) {
        const contextName = context.name && `${context.name}: ` || '';
        // COMMIT: `repo-name: abf137c title of commit message`
        if (type.includes('atlassian:SourceCodeCommit')) {
            const [, hashContent] = id.split(':');
            const hash = hashContent && `${hashContent.substring(0, 8)} `;
            return contextName + (hash || '') + name;
        }
        // PR: `repo-name: #42 title of pull request`
        if (type.includes('atlassian:SourceCodePullRequest')) {
            const pullRequest = jsonLd;
            const internalId = pullRequest['atlassian:internalId'];
            const internalIdRef = internalId && `#${internalId} `;
            return contextName + (internalIdRef || '') + name;
        }
        // BRANCH: `repo-name/branch-name`
        if (type.includes('atlassian:SourceCodeReference')) return contextName + name;
        // FILE: `repo-name: filepath`
        if (type.includes('schema:DigitalDocument')) return contextName + name;
    }
    if (removeTextHighlightingFromTitle) {
        const textFragmentRegex = new RegExp(' \\| :~:text=.*', 'g');
        const truncated = name?.replace(textFragmentRegex, '');
        return truncated;
    }
    return name;
};

});
parcelRegister("inXgt", function(module, exports) {
$parcel$export(module.exports, "extractContext", () => $1424377282a92e98$export$efdbd45f3e77a161);

var $dpM2S = parcelRequire("dpM2S");

var $4moW4 = parcelRequire("4moW4");
const $1424377282a92e98$export$efdbd45f3e77a161 = (jsonLd)=>{
    const context = jsonLd.context;
    if (context) {
        if (typeof context === 'string') return {
            name: context
        };
        else if (context['@type'] === 'Link') {
            if (context.name) return {
                name: context.name
            };
        } else {
            if (context.name) return {
                name: context.name,
                icon: context.icon && (0, $4moW4.extractUrlFromIconJsonLd)(context.icon),
                type: (0, $dpM2S.extractType)(context)
            };
        }
    }
    return undefined;
};

});
parcelRegister("dpM2S", function(module, exports) {
$parcel$export(module.exports, "extractType", () => $f106af885ce6cc9e$export$2e9ae379995d99e3);
const $f106af885ce6cc9e$export$2e9ae379995d99e3 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (type) {
        if (Array.isArray(jsonLd['@type'])) return type;
        else return [
            type
        ];
    }
    return undefined;
};

});



parcelRegister("6OR2o", function(module, exports) {
$parcel$export(module.exports, "extractPreview", () => $b7d97bd8e95d8e87$export$4b0d98b1b7f6d115);

var $dToaf = parcelRequire("dToaf");

var $jo2Je = parcelRequire("jo2Je");
const $b7d97bd8e95d8e87$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd?.preview;
    const isSupported = (0, $dToaf.extractPlatformIsSupported)(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: (0, $jo2Je.extractUrlFromLinkJsonLd)(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: (0, $jo2Je.extractUrlFromLinkJsonLd)(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
    return undefined;
};

});
parcelRegister("dToaf", function(module, exports) {
$parcel$export(module.exports, "extractPlatformIsSupported", () => $74d23019aa5430ff$export$3e8ad908070b68b2);
const $74d23019aa5430ff$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};

});


parcelRegister("3jSKi", function(module, exports) {
$parcel$export(module.exports, "extractEntity", () => $315a3a5639bc1399$export$8beff7405d020ddf);
$parcel$export(module.exports, "isEntityPresent", () => $315a3a5639bc1399$export$c7168210b81d9383);
$parcel$export(module.exports, "extractEntityEmbedUrl", () => $315a3a5639bc1399$export$f97663ee76ac5b24);
$parcel$export(module.exports, "extractEntityProvider", () => $315a3a5639bc1399$export$ad879f2c9d5100a0);
$parcel$export(module.exports, "extractEntityIcon", () => $315a3a5639bc1399$export$19346520e937a99f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lgMTT = parcelRequire("lgMTT");

var $lgMTT = parcelRequire("lgMTT");

var $eGOwo = parcelRequire("eGOwo");

const $315a3a5639bc1399$export$8beff7405d020ddf = (response)=>response?.entityData;
const $315a3a5639bc1399$export$c7168210b81d9383 = (response)=>Boolean($315a3a5639bc1399$export$8beff7405d020ddf(response));
const $315a3a5639bc1399$export$f97663ee76ac5b24 = (response)=>{
    const entity = $315a3a5639bc1399$export$8beff7405d020ddf(response);
    return entity && 'liveEmbedUrl' in entity && typeof entity?.liveEmbedUrl === 'string' ? entity?.liveEmbedUrl : undefined;
};
const $315a3a5639bc1399$export$ad879f2c9d5100a0 = (response)=>{
    if (!response?.meta?.generator) return undefined;
    const { icon: icon, id: id, image: image, name: name } = response.meta.generator;
    if (!name || !icon) throw Error('Link.generator requires a name and icon.');
    let providerIcon;
    switch(id){
        case 0, $9f5235d88a87be7c$export$cee224b5de4d6d66:
            providerIcon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.ConfluenceIcon), {
                appearance: "brand",
                ...(0, $eGOwo.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined,
                size: "xxsmall"
            });
            break;
        case 0, $9f5235d88a87be7c$export$f654d825189934a7:
            providerIcon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.JiraIcon), {
                appearance: "brand",
                ...(0, $eGOwo.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined,
                size: "xxsmall"
            });
            break;
        default:
            providerIcon = icon.url;
    }
    return {
        text: name,
        icon: providerIcon,
        id: id,
        image: image ? image : icon.url
    };
};
const $315a3a5639bc1399$export$19346520e937a99f = (response)=>{
    const entity = $315a3a5639bc1399$export$8beff7405d020ddf(response);
    let url;
    if (entity) url = 'iconUrl' in entity && typeof entity?.iconUrl === 'string' ? entity.iconUrl : response?.meta.generator?.icon?.url;
    return {
        url: url,
        label: entity?.displayName
    };
};

});


parcelRegister("03JM4", function(module, exports) {
$parcel$export(module.exports, "getByDefinitionId", () => $a9130c46b8c7e440$export$f75b0b690ab4dfb9);
$parcel$export(module.exports, "getClickUrl", () => $a9130c46b8c7e440$export$cf3c5acf9e9d0f02);
$parcel$export(module.exports, "getDefinitionId", () => $a9130c46b8c7e440$export$46fa3e7718c82e41);
$parcel$export(module.exports, "getExtensionKey", () => $a9130c46b8c7e440$export$218d96312e385949);
$parcel$export(module.exports, "getObjectAri", () => $a9130c46b8c7e440$export$81164c1570bcd038);
$parcel$export(module.exports, "getThirdPartyARI", () => $a9130c46b8c7e440$export$e029950864672b4);
$parcel$export(module.exports, "getFirstPartyIdentifier", () => $a9130c46b8c7e440$export$48b4e58cdb8031ba);
$parcel$export(module.exports, "getObjectName", () => $a9130c46b8c7e440$export$5615361d76a8be5);
$parcel$export(module.exports, "getObjectIconUrl", () => $a9130c46b8c7e440$export$bcf275804417edda);
$parcel$export(module.exports, "getResourceType", () => $a9130c46b8c7e440$export$16c0ebb0de9b767b);
$parcel$export(module.exports, "getServices", () => $a9130c46b8c7e440$export$a009e3a1163d46fb);
$parcel$export(module.exports, "isFinalState", () => $a9130c46b8c7e440$export$d590d08942abc17a);
$parcel$export(module.exports, "hasAuthScopeOverrides", () => $a9130c46b8c7e440$export$3f9446bb21b945a0);

var $eGOwo = parcelRequire("eGOwo");

var $70skx = parcelRequire("70skx");
const $a9130c46b8c7e440$export$f75b0b690ab4dfb9 = (definitionId, store)=>{
    const urls = Object.keys(store);
    return urls.filter((url)=>{
        const { details: details } = store[url];
        return details && details.meta.definitionId === definitionId;
    });
};
const $a9130c46b8c7e440$export$cf3c5acf9e9d0f02 = (url, jsonLd)=>{
    if (jsonLd && jsonLd.data) {
        const visitUrl = (0, $70skx.extractVisitUrl)(jsonLd.data);
        if (visitUrl) return visitUrl;
    }
    return url;
};
const $a9130c46b8c7e440$export$46fa3e7718c82e41 = (details)=>details?.meta?.definitionId;
const $a9130c46b8c7e440$export$218d96312e385949 = (details)=>details?.meta?.key;
const $a9130c46b8c7e440$export$81164c1570bcd038 = (details)=>details?.data && 'atlassian:ari' in details.data && details.data['atlassian:ari'] || undefined;
const $a9130c46b8c7e440$export$e029950864672b4 = (details)=>{
    if ((0, $eGOwo.fg)('platform_smartlink_3pclick_analytics')) {
        if (details?.entityData && 'thirdPartyAri' in details.entityData && details.entityData.thirdPartyAri) return details.entityData.thirdPartyAri;
        if (details?.data && 'atlassian:ari' in details.data && typeof details.data['atlassian:ari'] === 'string') {
            const ari = details.data['atlassian:ari'];
            if (ari.includes('ari:third-party')) return ari;
        }
    }
    return undefined;
};
const $a9130c46b8c7e440$export$48b4e58cdb8031ba = ()=>{
    if (!(0, $eGOwo.fg)('platform_smartlink_3pclick_analytics')) return undefined;
    const product = $a9130c46b8c7e440$var$getProductFromWindowURL();
    const currentURL = window.location.href;
    if (product === 'confluence') {
        if (currentURL.includes('content.id')) {
            const contentId = $a9130c46b8c7e440$var$extractContentIdFromURL(currentURL);
            if (contentId) return `ConfluenceContentId:${contentId}`;
        }
        const pageId = $a9130c46b8c7e440$var$extractPageIdFromURL(currentURL);
        if (pageId) return `ConfluencePageId:${pageId}`;
    } else if (product === 'jira') {
        const issueKey = $a9130c46b8c7e440$var$extractJiraIssueIdFromURL(currentURL);
        if (issueKey) return `JiraIssueKey:${issueKey}`;
    }
    return undefined;
};
const $a9130c46b8c7e440$export$5615361d76a8be5 = (details)=>details?.data && 'name' in details.data && details.data.name || undefined;
const $a9130c46b8c7e440$export$bcf275804417edda = (details)=>{
    if (details?.data && 'icon' in details.data && details.data.icon) {
        if (typeof details.data.icon === 'object' && 'url' in details.data.icon && details.data.icon.url && typeof details.data.icon.url === 'string') return details.data.icon.url;
    }
    return undefined;
};
const $a9130c46b8c7e440$export$16c0ebb0de9b767b = (details)=>details?.meta?.resourceType;
const $a9130c46b8c7e440$export$e2005c9600188ac7 = (details)=>details?.meta?.product;
const $a9130c46b8c7e440$export$f8fdefc70357968e = (details)=>details?.meta?.subproduct;
const $a9130c46b8c7e440$export$a009e3a1163d46fb = (details)=>details && details.meta.auth || [];
const $a9130c46b8c7e440$export$ac5d414b1ebfab5a = (details)=>details && $a9130c46b8c7e440$export$cd41ae544cfc2a65(details) && $a9130c46b8c7e440$export$795910f5f15a9633(details);
const $a9130c46b8c7e440$export$cd41ae544cfc2a65 = ({ meta: { access: access } })=>access === 'granted';
const $a9130c46b8c7e440$export$795910f5f15a9633 = ({ meta: { visibility: visibility } })=>visibility === 'restricted' || visibility === 'public';
const $a9130c46b8c7e440$export$a752a116d184ffbd = (details)=>{
    return details?.meta?.requestAccess?.accessType;
};
const $a9130c46b8c7e440$export$d590d08942abc17a = (status)=>{
    return [
        'unauthorized',
        'forbidden',
        'errored',
        'resolved',
        'not_found'
    ].indexOf(status) > -1;
};
const $a9130c46b8c7e440$export$66805b16d2a1da7c = (details)=>details?.datasources;
const $a9130c46b8c7e440$export$ba6d13ab7b87c55c = (details)=>{
    const datasources = $a9130c46b8c7e440$export$66805b16d2a1da7c(details);
    return !!datasources && datasources.length > 0;
};
const $a9130c46b8c7e440$export$3f9446bb21b945a0 = (details)=>!!details?.meta.hasScopeOverrides;
// Helper function to extract page ID from standard Confluence page URLs
const $a9130c46b8c7e440$var$extractPageIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Following this pattern for confluence URL -> /wiki/spaces/{space}/pages/{pageId}/{title}
        const pagesMatch = urlObj.pathname.match(/\/wiki\/spaces\/[^\/]+\/pages\/(\d+)(?:\/|$)/);
        if (pagesMatch && pagesMatch[1]) return pagesMatch[1];
        // Following this pattern for confluence URL -> /wiki/pages/viewpage.action?pageId={pageId}
        const pageIdParam = urlObj.searchParams.get('pageId');
        if (pageIdParam) return pageIdParam;
        // Following this pattern for confluence URL -> /wiki/display/{space}/{pageId}
        const displayMatch = urlObj.pathname.match(/\/wiki\/display\/[^\/]+\/(\d+)/);
        if (displayMatch && displayMatch[1]) return displayMatch[1];
    } catch  {
        return undefined;
    }
    return undefined;
};
const $a9130c46b8c7e440$var$extractContentIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Pattern: ?content.id={contentId} (for app connector URLs and plugin servlet URLs)
        const contentId = urlObj.searchParams.get('content.id');
        if (contentId) return contentId;
        // Also support URLs where content.id is in the query string but not parsed by URL (edge case)
        // e.g., /wiki/plugins/servlet/ac/com.atlassian.perspectiveretros/perspective-retros?content.id=5662725850
        const match = url.match(/[?&]content\.id=(\d+)/);
        if (match && match[1]) return match[1];
    } catch  {
        return undefined;
    }
    return undefined;
};
const $a9130c46b8c7e440$var$extractJiraIssueIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Support any case for Jira keys (e.g., AI3W-864, ai3w-864, Ai3W-864)
        const browseMatch = urlObj.pathname.match(/\/browse\/([A-Za-z0-9]+-\d+)/);
        if (browseMatch && browseMatch[1]) return browseMatch[1];
        // /jira/browse/{issueKey}
        const jiraBrowseMatch = urlObj.pathname.match(/\/jira\/browse\/([A-Za-z0-9]+-\d+)/);
        if (jiraBrowseMatch && jiraBrowseMatch[1]) return jiraBrowseMatch[1];
        // Query parameter ?selectedIssue={issueKey}
        const selectedIssue = urlObj.searchParams.get('selectedIssue');
        if (selectedIssue && /^[A-Za-z0-9]+-\d+$/.test(selectedIssue)) return selectedIssue;
        // Query parameter ?issueKey={issueKey}
        const issueKeyParam = urlObj.searchParams.get('issueKey');
        if (issueKeyParam && /^[A-Za-z0-9]+-\d+$/.test(issueKeyParam)) return issueKeyParam;
    } catch  {
        return undefined;
    }
    return undefined;
};
const $a9130c46b8c7e440$var$getProductFromWindowURL = ()=>{
    try {
        const currentUrl = window.location.href;
        const urlObj = new URL(currentUrl);
        const hostname = urlObj.hostname.toLowerCase();
        const pathname = urlObj.pathname.toLowerCase();
        // Check for Confluence patterns
        if (hostname.includes('confluence') || pathname.includes('/wiki/') || pathname.includes('/display/') || pathname.includes('/spaces/')) return 'confluence';
        // Check for Jira patterns
        if (hostname.includes('jira') || pathname.includes('/browse/') || pathname.includes('/projects/') || pathname.includes('/secure/')) return 'jira';
    } catch  {
        return undefined;
    }
    return undefined;
};

});
parcelRegister("70skx", function(module, exports) {
$parcel$export(module.exports, "extractVisitUrl", () => $23c7211e82610c9c$export$c81497d3681f24f4);
const $23c7211e82610c9c$export$c81497d3681f24f4 = (jsonLd)=>{
    return jsonLd['atlassian:visitUrl'];
};

});


parcelRegister("cIlQC", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc619ccde41b15c4$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $bmWcp = parcelRequire("bmWcp");

var $2QXr6 = parcelRequire("2QXr6");

var $bde0S = parcelRequire("bde0S");

var $03JM4 = parcelRequire("03JM4");

var $5TXKo = parcelRequire("5TXKo");

var $454gh = parcelRequire("454gh");
const $cc619ccde41b15c4$var$useResolveHyperlink = ({ href: href })=>{
    const [id] = (0, $eJOHy.useState)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))());
    const state = (0, $5TXKo.useSmartCardState)(href);
    const definitionId = (0, $03JM4.getDefinitionId)(state.details);
    const extensionKey = (0, $03JM4.getExtensionKey)(state.details);
    const resourceType = (0, $03JM4.getResourceType)(state.details);
    const actions = (0, $bde0S.useSmartCardActions)(id, href);
    const scheduledRegister = (0, $454gh.useScheduledRegister)(href, actions.register);
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        scheduledRegister().catch((error)=>{
            throw error;
        });
    }, [
        scheduledRegister
    ]);
    (0, $eJOHy.useEffect)(()=>{
        $2QXr6.mark(id, state.status);
        if (state.status !== 'pending' && state.status !== 'resolving') {
            $2QXr6.create(id, state.status);
            if (state.status === 'resolved') fireEvent('operational.hyperlink.resolved', {
                definitionId: definitionId ?? null,
                extensionKey: extensionKey ?? null,
                resourceType: resourceType ?? null,
                duration: $2QXr6.getMeasure(id, state.status)?.duration ?? null
            });
            else if (state.error?.type !== 'ResolveUnsupportedError' && state.error?.type !== 'UnsupportedError') fireEvent('operational.hyperlink.unresolved', {
                definitionId: definitionId ?? null,
                extensionKey: extensionKey ?? null,
                resourceType: resourceType ?? null,
                reason: state.status,
                error: state.error === undefined ? null : {
                    name: state.error.name,
                    kind: state.error.kind,
                    type: state.error.type
                }
            });
        }
    }, [
        id,
        state.status,
        state.error,
        definitionId,
        extensionKey,
        resourceType,
        fireEvent
    ]);
    return {
        state: state,
        actions: actions
    };
};
var $cc619ccde41b15c4$export$2e2bcd8739ae039 = $cc619ccde41b15c4$var$useResolveHyperlink;

});
parcelRegister("bmWcp", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $b236f5372ffdd3ba$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::676f76a2e45920437adc8c35a9af8b37>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");


var $928jS = parcelRequire("928jS");
const $b236f5372ffdd3ba$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireEvent = (0, $eJOHy.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $928jS.default)(...params));
        event.fire((0, $6462ef276ac974ec$export$3f072f06b90c3985));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
const $6462ef276ac974ec$export$3f072f06b90c3985 = 'media';

parcelRegister("928jS", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ac9e1681ec36717$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::f914fb83fac56e7154ef460866628f7d>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ const $5ac9e1681ec36717$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $5ac9e1681ec36717$export$2e2bcd8739ae039 = $5ac9e1681ec36717$var$createEventPayload;

});


parcelRegister("2QXr6", function(module, exports) {
$parcel$export(module.exports, "clearMarks", () => $a922bc214c753b7c$export$1a717feb4df1a945);
$parcel$export(module.exports, "clearMeasures", () => $a922bc214c753b7c$export$de42547d395c8271);
$parcel$export(module.exports, "getMeasure", () => $a922bc214c753b7c$export$d6e97a903ae9a3aa);
$parcel$export(module.exports, "mark", () => $a922bc214c753b7c$export$bf7f2fce5c1cf636);
$parcel$export(module.exports, "create", () => $a922bc214c753b7c$export$185802fd694ee1f5);
const $a922bc214c753b7c$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $a922bc214c753b7c$var$hasPerformanceAPIAvailable = $a922bc214c753b7c$var$isPerformanceAPIAvailable();
const $a922bc214c753b7c$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;
const $a922bc214c753b7c$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;
const $a922bc214c753b7c$export$1a717feb4df1a945 = (id)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
        marks.forEach((mark)=>performance.clearMarks(mark.name));
    }
};
const $a922bc214c753b7c$export$de42547d395c8271 = (id)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
        measures.forEach((measure)=>performance.clearMeasures(measure.name));
    }
};
const $a922bc214c753b7c$var$getMark = (id, status)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const name = $a922bc214c753b7c$export$fcff3185c7ce7f2b(id, status);
        const marks = performance.getEntriesByName(name);
        if (marks.length > 0) return marks[0];
        return undefined;
    }
};
const $a922bc214c753b7c$export$d6e97a903ae9a3aa = (id, status)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const name = $a922bc214c753b7c$export$984df7f61dd7928f(id, status);
        const measures = performance.getEntriesByName(name);
        if (measures.length > 0) return measures[0];
        return undefined;
    }
};
const $a922bc214c753b7c$export$bf7f2fce5c1cf636 = (id, status)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const name = $a922bc214c753b7c$export$fcff3185c7ce7f2b(id, status);
        performance.mark(name);
    }
};
const $a922bc214c753b7c$export$185802fd694ee1f5 = (id, status)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const name = $a922bc214c753b7c$export$984df7f61dd7928f(id, status);
        const measure = $a922bc214c753b7c$export$d6e97a903ae9a3aa(id, status);
        if (!measure) {
            const startMark = $a922bc214c753b7c$var$getMark(id, 'pending');
            const endMark = $a922bc214c753b7c$var$getMark(id, status);
            if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
        }
    }
};

});

parcelRegister("bde0S", function(module, exports) {
$parcel$export(module.exports, "useSmartCardActions", () => $0b92ec45d8e4fb8b$export$f7c340395f31e832);

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");

var $ggoTr = parcelRequire("ggoTr");

var $ldBiz = parcelRequire("ldBiz");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $1mLfK = parcelRequire("1mLfK");

var $03JM4 = parcelRequire("03JM4");

var $7xssH = parcelRequire("7xssH");

var $kbv8x = parcelRequire("kbv8x");
const $0b92ec45d8e4fb8b$export$f7c340395f31e832 = (id, url)=>{
    const resolveUrl = (0, $kbv8x.default)();
    const invokeClientAction = (0, $7xssH.default)({});
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const { store: store } = (0, $9kfy2.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const getSmartLinkState = (0, $eJOHy.useCallback)(()=>{
        const { details: details, status: status, metadataStatus: metadataStatus } = getState()[url] ?? {
            status: (0, $5NtHI.SmartLinkStatus).Pending
        };
        return {
            details: details,
            status: status,
            metadataStatus: metadataStatus
        };
    }, [
        getState,
        url
    ]);
    const setMetadataStatus = (0, $eJOHy.useCallback)((metadataStatus)=>{
        dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch,
        url
    ]);
    const resolve = (0, $eJOHy.useCallback)(async (resourceUrl = url, isReloading = false, isMetadataRequest = false)=>resolveUrl(resourceUrl, isReloading, isMetadataRequest, id), [
        id,
        resolveUrl,
        url
    ]);
    const register = (0, $eJOHy.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        if (!details) {
            dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_RESOLVING), {
                url: url
            }));
            setMetadataStatus('pending');
        }
        return resolve();
    }, [
        getSmartLinkState,
        resolve,
        dispatch,
        url,
        setMetadataStatus
    ]);
    const reload = (0, $eJOHy.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        const definitionId = (0, $03JM4.getDefinitionId)(details);
        if (definitionId) (0, $03JM4.getByDefinitionId)(definitionId, getState()).map((url)=>resolve(url, true));
        else resolve(url, true);
    }, [
        getSmartLinkState,
        url,
        getState,
        resolve
    ]);
    const loadMetadata = (0, $eJOHy.useCallback)(()=>{
        const { metadataStatus: metadataStatus } = getSmartLinkState();
        //metadataStatus will be undefined for SSR links only
        if (metadataStatus === undefined) {
            setMetadataStatus('pending');
            return resolve(url, false, true);
        }
    }, [
        getSmartLinkState,
        resolve,
        setMetadataStatus,
        url
    ]);
    const authorize = (0, $eJOHy.useCallback)((appearance)=>{
        const { details: details, status: status } = getSmartLinkState();
        const definitionId = (0, $03JM4.getDefinitionId)(details);
        const extensionKey = (0, $03JM4.getExtensionKey)(details);
        const services = (0, $03JM4.getServices)(details);
        // When authentication is triggered, let GAS know!
        if (status === 'unauthorized') fireEvent('ui.button.clicked.connectAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (status === 'forbidden') fireEvent('ui.smartLink.clicked.tryAnotherAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (services.length > 0) {
            fireEvent('screen.consentModal.viewed', {
                definitionId: definitionId ?? null
            });
            (0, $ldBiz.auth)(services[0].url).then(()=>{
                fireEvent('track.applicationAccount.connected', {
                    definitionId: definitionId ?? null
                });
                (0, $1mLfK.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: 'success'
                });
                fireEvent('operational.smartLink.connectSucceeded', {
                    definitionId: definitionId ?? null
                });
                reload();
            }, (err)=>{
                (0, $1mLfK.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: err.type
                });
                fireEvent('operational.smartLink.connectFailed', {
                    definitionId: definitionId ?? null,
                    reason: err.type ?? null
                });
                if (err.type === 'auth_window_closed') fireEvent('ui.consentModal.closed', {
                    display: appearance,
                    definitionId: definitionId ?? null
                });
                reload();
            });
        }
    }, [
        getSmartLinkState,
        id,
        reload,
        fireEvent
    ]);
    const invoke = (0, $eJOHy.useCallback)(async (opts, appearance)=>{
        const { key: key, action: action } = opts;
        const source = opts.source || appearance;
        if (opts.type === 'client') return await invokeClientAction({
            actionFn: opts.action.promise,
            actionType: action.type,
            display: source,
            extensionKey: key
        });
    }, [
        invokeClientAction
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            register: register,
            reload: reload,
            authorize: authorize,
            invoke: invoke,
            loadMetadata: loadMetadata
        }), [
        register,
        reload,
        authorize,
        invoke,
        loadMetadata
    ]);
};

});
parcelRegister("9kfy2", function(module, exports) {
$parcel$export(module.exports, "SmartCardContext", () => $fc76586a45127857$export$156b523e63b4f63a);
$parcel$export(module.exports, "useSmartLinkContext", () => $fc76586a45127857$export$e1d190b530cf0ee9);
$parcel$export(module.exports, "useSmartCardContext", () => $fc76586a45127857$export$10e9cca30e50f657);
$parcel$export(module.exports, "EditorSmartCardProviderValueGuard", () => $fc76586a45127857$export$797e3658f090919c);
$parcel$export(module.exports, "EditorSmartCardProvider", () => $fc76586a45127857$export$2a29ca11e08dc129);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

const $fc76586a45127857$export$156b523e63b4f63a = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
function $fc76586a45127857$export$e1d190b530cf0ee9() {
    const context = (0, $eJOHy.useContext)($fc76586a45127857$export$156b523e63b4f63a);
    if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
    return context;
}
const $fc76586a45127857$export$10e9cca30e50f657 = ()=>$fc76586a45127857$var$useContextMemoized($fc76586a45127857$export$156b523e63b4f63a);
const $fc76586a45127857$export$797e3658f090919c = ({ children: children })=>{
    const cardContext = $fc76586a45127857$export$10e9cca30e50f657();
    if (!cardContext?.value) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
};
function $fc76586a45127857$var$useContextMemoized(reactContext) {
    const value = (0, $eJOHy.useContext)(reactContext);
    const context = (0, $eJOHy.useMemo)(()=>({
            Provider: reactContext.Provider,
            Consumer: reactContext.Consumer,
            value: value
        }), [
        value,
        reactContext
    ]);
    return context;
}
const $fc76586a45127857$export$2a29ca11e08dc129 = ({ children: children })=>{
    const cardContext = $fc76586a45127857$export$10e9cca30e50f657();
    const Provider = cardContext.Provider;
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Provider, {
        value: cardContext.value,
        children: children
    });
};
var $fc76586a45127857$export$2e2bcd8739ae039 = $fc76586a45127857$export$156b523e63b4f63a;

});

parcelRegister("ggoTr", function(module, exports) {
$parcel$export(module.exports, "ACTION_PENDING", () => $614f754b0a09058a$export$6e470aad5ba8952e);
$parcel$export(module.exports, "ACTION_RESOLVING", () => $614f754b0a09058a$export$9a6a932a0a39498e);
$parcel$export(module.exports, "ACTION_RESOLVED", () => $614f754b0a09058a$export$63ec8bc7a8a75482);
$parcel$export(module.exports, "ACTION_RELOADING", () => $614f754b0a09058a$export$b8cfaa842c9ab487);
$parcel$export(module.exports, "ACTION_ERROR", () => $614f754b0a09058a$export$6d8ed3f9433dd372);
$parcel$export(module.exports, "ACTION_ERROR_FALLBACK", () => $614f754b0a09058a$export$cfbbb7126bc8a0c6);
$parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", () => $614f754b0a09058a$export$2c5edb971b673330);
$parcel$export(module.exports, "cardAction", () => $614f754b0a09058a$export$a884a52152489cc3);
// TODO: eventually move this file to @atlaskit/link-actions
const $614f754b0a09058a$export$6e470aad5ba8952e = 'pending';
const $614f754b0a09058a$export$9a6a932a0a39498e = 'resolving';
const $614f754b0a09058a$export$63ec8bc7a8a75482 = 'resolved';
const $614f754b0a09058a$export$b8cfaa842c9ab487 = 'reloading';
const $614f754b0a09058a$export$6d8ed3f9433dd372 = 'errored';
const $614f754b0a09058a$export$cfbbb7126bc8a0c6 = 'fallback';
const $614f754b0a09058a$export$76b5c1aca20759c6 = 'preload';
const $614f754b0a09058a$export$2c5edb971b673330 = 'metadata';
const $614f754b0a09058a$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
        type: type,
        url: url,
        payload: payload,
        error: error,
        metadataStatus: metadataStatus,
        ignoreStatusCheck: ignoreStatusCheck
    });

});

parcelRegister("5NtHI", function(module, exports) {
$parcel$export(module.exports, "CONTENT_URL_SECURITY_AND_PERMISSIONS", () => $fc2e49eaf9e6df05$export$5c881701926acbef);
$parcel$export(module.exports, "CONTENT_URL_3P_ACCOUNT_AUTH", () => $fc2e49eaf9e6df05$export$93d67ab022d9f8d2);
$parcel$export(module.exports, "CONTENT_URL_AI", () => $fc2e49eaf9e6df05$export$70d24f0465ae60f8);
$parcel$export(module.exports, "CONTENT_URL_AI_TROUBLESHOOTING", () => $fc2e49eaf9e6df05$export$a3ed5c4e9d9599b7);
$parcel$export(module.exports, "CONTENT_URL_ACCEPTABLE_USE_POLICY", () => $fc2e49eaf9e6df05$export$73b198e73554a323);
$parcel$export(module.exports, "SmartLinkAlignment", () => $fc2e49eaf9e6df05$export$8910bf86027fe6be);
$parcel$export(module.exports, "SmartLinkDirection", () => $fc2e49eaf9e6df05$export$60831686b0574c86);
$parcel$export(module.exports, "SmartLinkPosition", () => $fc2e49eaf9e6df05$export$d58e6377644d1dcf);
$parcel$export(module.exports, "SmartLinkSize", () => $fc2e49eaf9e6df05$export$51f13ced115cbdae);
$parcel$export(module.exports, "SmartLinkStatus", () => $fc2e49eaf9e6df05$export$61cff06be26816f);
$parcel$export(module.exports, "SmartLinkTheme", () => $fc2e49eaf9e6df05$export$aed0f1e801ad691f);
$parcel$export(module.exports, "SmartLinkInternalTheme", () => $fc2e49eaf9e6df05$export$9aafec380d7005da);
$parcel$export(module.exports, "SmartLinkWidth", () => $fc2e49eaf9e6df05$export$19c60054ee783de6);
$parcel$export(module.exports, "ElementName", () => $fc2e49eaf9e6df05$export$d65b168331104a46);
$parcel$export(module.exports, "ActionName", () => $fc2e49eaf9e6df05$export$9c95d6e1614bad84);
$parcel$export(module.exports, "InternalActionName", () => $fc2e49eaf9e6df05$export$4871a84b35cf8eb9);
$parcel$export(module.exports, "IconType", () => $fc2e49eaf9e6df05$export$13ff1290a9e22e77);
$parcel$export(module.exports, "MediaType", () => $fc2e49eaf9e6df05$export$483c11740a902fcd);
$parcel$export(module.exports, "MediaPlacement", () => $fc2e49eaf9e6df05$export$f9f4737e25ab90fa);
$parcel$export(module.exports, "CardDisplay", () => $fc2e49eaf9e6df05$export$6ca4ef8b3dc2c804);
const $fc2e49eaf9e6df05$export$5c881701926acbef = 'https://support.atlassian.com/confluence-cloud/docs/insert-links-and-anchors/#Smart-links';
const $fc2e49eaf9e6df05$export$93d67ab022d9f8d2 = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link/';
const $fc2e49eaf9e6df05$export$70d24f0465ae60f8 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $fc2e49eaf9e6df05$export$a3ed5c4e9d9599b7 = 'https://status.atlassian.com/';
const $fc2e49eaf9e6df05$export$73b198e73554a323 = 'https://www.atlassian.com/legal/acceptable-use-policy';
var $fc2e49eaf9e6df05$export$8910bf86027fe6be = /*#__PURE__*/ function(SmartLinkAlignment) {
    SmartLinkAlignment["Left"] = "left";
    SmartLinkAlignment["Right"] = "right";
    return SmartLinkAlignment;
}({});
var $fc2e49eaf9e6df05$export$60831686b0574c86 = /*#__PURE__*/ function(SmartLinkDirection) {
    SmartLinkDirection["Horizontal"] = "horizontal";
    SmartLinkDirection["Vertical"] = "vertical";
    return SmartLinkDirection;
}({});
var $fc2e49eaf9e6df05$export$d58e6377644d1dcf = /*#__PURE__*/ function(SmartLinkPosition) {
    SmartLinkPosition["Top"] = "top";
    SmartLinkPosition["Center"] = "center";
    return SmartLinkPosition;
}({});
var $fc2e49eaf9e6df05$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $fc2e49eaf9e6df05$export$61cff06be26816f = /*#__PURE__*/ function(SmartLinkStatus) {
    SmartLinkStatus["Pending"] = "pending";
    SmartLinkStatus["Resolving"] = "resolving";
    SmartLinkStatus["Resolved"] = "resolved";
    SmartLinkStatus["Forbidden"] = "forbidden";
    SmartLinkStatus["Errored"] = "errored";
    SmartLinkStatus["NotFound"] = "not_found";
    SmartLinkStatus["Unauthorized"] = "unauthorized";
    SmartLinkStatus["Fallback"] = "fallback";
    return SmartLinkStatus;
}({});
var $fc2e49eaf9e6df05$export$aed0f1e801ad691f = /*#__PURE__*/ function(SmartLinkTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkTheme["Black"] = "black";
    SmartLinkTheme["Link"] = "link";
    return SmartLinkTheme;
}({});
var $fc2e49eaf9e6df05$export$9aafec380d7005da = /*#__PURE__*/ function(SmartLinkInternalTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkInternalTheme["Grey"] = "grey";
    return SmartLinkInternalTheme;
}({});
var $fc2e49eaf9e6df05$export$19c60054ee783de6 = /*#__PURE__*/ function(SmartLinkWidth) {
    SmartLinkWidth["FitToContent"] = "fit-to-content";
    SmartLinkWidth["Flexible"] = "flexible";
    return SmartLinkWidth;
}({});
var $fc2e49eaf9e6df05$export$d65b168331104a46 = /*#__PURE__*/ function(ElementName) {
    ElementName["AppliedToComponentsCount"] = "AppliedToComponentsCount";
    ElementName["AssignedTo"] = "AssignedTo";
    ElementName["AssignedToGroup"] = "AssignedToGroup";
    ElementName["AttachmentCount"] = "AttachmentCount";
    ElementName["AuthorGroup"] = "AuthorGroup";
    ElementName["ChecklistProgress"] = "ChecklistProgress";
    ElementName["CollaboratorGroup"] = "CollaboratorGroup";
    ElementName["CommentCount"] = "CommentCount";
    ElementName["CreatedBy"] = "CreatedBy";
    ElementName["CreatedOn"] = "CreatedOn";
    ElementName["DueOn"] = "DueOn";
    ElementName["LatestCommit"] = "LatestCommit";
    ElementName["LinkIcon"] = "LinkIcon";
    ElementName["Location"] = "Location";
    ElementName["ModifiedBy"] = "ModifiedBy";
    ElementName["ModifiedOn"] = "ModifiedOn";
    ElementName["OwnedBy"] = "OwnedBy";
    ElementName["OwnedByGroup"] = "OwnedByGroup";
    ElementName["Preview"] = "Preview";
    ElementName["Priority"] = "Priority";
    ElementName["ProgrammingLanguage"] = "ProgrammingLanguage";
    ElementName["Provider"] = "Provider";
    ElementName["ReactCount"] = "ReactCount";
    ElementName["ReadTime"] = "ReadTime";
    ElementName["Snippet"] = "Snippet";
    ElementName["SourceBranch"] = "SourceBranch";
    ElementName["State"] = "State";
    ElementName["SubscriberCount"] = "SubscriberCount";
    ElementName["SubTasksProgress"] = "SubTasksProgress";
    ElementName["StoryPoints"] = "StoryPoints";
    ElementName["TargetBranch"] = "TargetBranch";
    ElementName["TeamMemberCount"] = "TeamMemberCount";
    ElementName["Title"] = "Title";
    ElementName["UserAttributes"] = "UserAttributes";
    ElementName["ViewCount"] = "ViewCount";
    ElementName["VoteCount"] = "VoteCount";
    ElementName["SentOn"] = "SentOn";
    return ElementName;
}({});
var $fc2e49eaf9e6df05$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["CopyLinkAction"] = "CopyLinkAction";
    ActionName["DeleteAction"] = "DeleteAction";
    ActionName["EditAction"] = "EditAction";
    ActionName["FollowAction"] = "FollowAction";
    ActionName["PreviewAction"] = "PreviewAction";
    ActionName["AutomationAction"] = "AutomationAction";
    ActionName["DownloadAction"] = "DownloadAction";
    ActionName["CustomAction"] = "CustomAction";
    return ActionName;
}({});
var $fc2e49eaf9e6df05$export$4871a84b35cf8eb9 = /*#__PURE__*/ function(InternalActionName) {
    InternalActionName["AISummaryAction"] = "AISummaryAction";
    InternalActionName["UnresolvedAction"] = "UnresolvedAction";
    InternalActionName["ViewRelatedLinksAction"] = "ViewRelatedLinksAction";
    return InternalActionName;
}({});
var $fc2e49eaf9e6df05$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Blog"] = "FileType:Blog";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Template"] = "FileType:Template";
    IconType["Video"] = "FileType:Video";
    // BitBucket?
    IconType["Branch"] = "BitBucket:Branch";
    IconType["Commit"] = "BitBucket:Commit";
    IconType["Project"] = "BitBucket:Project";
    IconType["PullRequest"] = "BitBucket:PullRequest";
    IconType["Repo"] = "BitBucket:Repo";
    // Jira?
    IconType["Bug"] = "Jira:Bug";
    IconType["Change"] = "Jira:Change";
    IconType["Epic"] = "Jira:Epic";
    IconType["Incident"] = "Jira:Incident";
    IconType["Problem"] = "Jira:Problem";
    IconType["ServiceRequest"] = "Jira:ServiceRequest";
    IconType["Story"] = "Jira:Story";
    IconType["SubTask"] = "Jira:SubTask";
    IconType["Task"] = "Jira:Task";
    // Confluence
    IconType["LiveDocument"] = "Confluence:LiveDocument";
    // Provider
    IconType["Confluence"] = "Provider:Confluence";
    IconType["Jira"] = "Provider:Jira";
    // Fallback
    IconType["Default"] = "Default";
    IconType["Error"] = "Default:Error";
    IconType["Forbidden"] = "Default:Forbidden";
    // Badge
    IconType["Attachment"] = "Badge:Attachment";
    IconType["CheckItem"] = "Badge:Task";
    IconType["Comment"] = "Badge:Comment";
    IconType["Component"] = "Badge:Component";
    IconType["View"] = "Badge:View";
    IconType["React"] = "Badge:React";
    IconType["Vote"] = "Badge:Vote";
    IconType["PriorityBlocker"] = "Badge:PriorityBlocker";
    IconType["PriorityCritical"] = "Badge:PriorityCritical";
    IconType["PriorityHigh"] = "Badge:PriorityHigh";
    IconType["PriorityHighest"] = "Badge:PriorityHighest";
    IconType["PriorityLow"] = "Badge:PriorityLow";
    IconType["PriorityLowest"] = "Badge:PriorityLowest";
    IconType["PriorityMajor"] = "Badge:PriorityMajor";
    IconType["PriorityMedium"] = "Badge:PriorityMedium";
    IconType["PriorityMinor"] = "Badge:PriorityMinor";
    IconType["PriorityTrivial"] = "Badge:PriorityTrivial";
    IconType["PriorityUndefined"] = "Badge:PriorityUndefined";
    IconType["ProgrammingLanguage"] = "Badge:ProgrammingLanguage";
    IconType["Subscriber"] = "Badge:Subscriber";
    IconType["SubTasksProgress"] = "Badge:SubTask";
    return IconType;
}({});
var $fc2e49eaf9e6df05$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["Image"] = "image";
    return MediaType;
}({});
var $fc2e49eaf9e6df05$export$f9f4737e25ab90fa = /*#__PURE__*/ function(MediaPlacement) {
    MediaPlacement["Left"] = "left";
    MediaPlacement["Right"] = "right";
    return MediaPlacement;
}({});
var $fc2e49eaf9e6df05$export$6ca4ef8b3dc2c804 = /*#__PURE__*/ function(CardDisplay) {
    CardDisplay["Inline"] = "inline";
    CardDisplay["Block"] = "block";
    CardDisplay["Embed"] = "embed";
    CardDisplay["EmbedPreview"] = "embedPreview";
    CardDisplay["Flexible"] = "flexible";
    CardDisplay["HoverCardPreview"] = "hoverCardPreview";
    return CardDisplay;
}({});

});

parcelRegister("1mLfK", function(module, exports) {
$parcel$export(module.exports, "startUfoExperience", () => $e01fd61e15160d33$export$5e9287b6a10f8075);
$parcel$export(module.exports, "succeedUfoExperience", () => $e01fd61e15160d33$export$c5a5cf072c836c0e);
$parcel$export(module.exports, "failUfoExperience", () => $e01fd61e15160d33$export$8dda83bafca11b77);
$parcel$export(module.exports, "addMetadataToExperience", () => $e01fd61e15160d33$export$4084c0df4a03a6af);

var $9iIu4 = parcelRequire("9iIu4");
var $aRnO1 = parcelRequire("aRnO1");
const $e01fd61e15160d33$var$inlineExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $aRnO1.ExperienceTypes).Experience,
    performanceType: (0, $aRnO1.ExperiencePerformanceTypes).InlineResult
};
const $e01fd61e15160d33$var$renderExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $aRnO1.ExperienceTypes).Load,
    performanceType: (0, $aRnO1.ExperiencePerformanceTypes).PageSegmentLoad
};
const $e01fd61e15160d33$var$aiExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $aRnO1.ExperienceTypes).Experience,
    performanceType: (0, $aRnO1.ExperiencePerformanceTypes).InlineResult
};
const $e01fd61e15160d33$var$ufoExperiences = {
    'smart-link-rendered': new (0, $9iIu4.ConcurrentExperience)('smart-link-rendered', $e01fd61e15160d33$var$renderExperience),
    'smart-link-authenticated': new (0, $9iIu4.ConcurrentExperience)('smart-link-authenticated', $e01fd61e15160d33$var$inlineExperience),
    'smart-link-action-invocation': new (0, $9iIu4.ConcurrentExperience)('smart-link-action-invocation', $e01fd61e15160d33$var$inlineExperience),
    'smart-link-ai-summary': new (0, $9iIu4.ConcurrentExperience)('smart-link-ai-summary', $e01fd61e15160d33$var$aiExperience)
};
const $e01fd61e15160d33$export$5e9287b6a10f8075 = (experienceName, id, properties)=>{
    const experience = $e01fd61e15160d33$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (properties) experience.addMetadata(properties);
};
const $e01fd61e15160d33$export$c5a5cf072c836c0e = (experienceName, id, properties)=>{
    const experience = $e01fd61e15160d33$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: properties
    });
};
const $e01fd61e15160d33$export$8dda83bafca11b77 = (experienceName, id, properties)=>{
    const experience = $e01fd61e15160d33$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: properties
    });
};
const $e01fd61e15160d33$export$4084c0df4a03a6af = (experienceName, id, properties)=>{
    $e01fd61e15160d33$var$ufoExperiences[experienceName].getInstance(id).addMetadata(properties);
};

});
parcelRegister("9iIu4", function(module, exports) {
$parcel$export(module.exports, "ConcurrentExperience", () => $a5bd41df052e3fc6$export$ac1cddfee07ba6ac);

var $jJiQE = parcelRequire("jJiQE");

var $2pMzV = parcelRequire("2pMzV");
class $a5bd41df052e3fc6$export$ac1cddfee07ba6ac {
    constructor(experienceId, config){
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $2pMzV.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $jJiQE.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
}

});
parcelRegister("jJiQE", function(module, exports) {
$parcel$export(module.exports, "ufolog", () => $3c943c12e74b5b78$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $3c943c12e74b5b78$export$d53d07b6034c4560);
class $3c943c12e74b5b78$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($3c943c12e74b5b78$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($3c943c12e74b5b78$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $3c943c12e74b5b78$export$4ab84f6f04f6566d = new $3c943c12e74b5b78$var$UFOLogger();
const $3c943c12e74b5b78$export$b4958caff08a0960 = (...args)=>{
    $3c943c12e74b5b78$export$4ab84f6f04f6566d.log(...args);
};
const $3c943c12e74b5b78$export$d53d07b6034c4560 = (...args)=>{
    $3c943c12e74b5b78$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("2pMzV", function(module, exports) {
$parcel$export(module.exports, "UFOExperience", () => $eb40b99b73192801$export$c00d22927c60484a);

var $aSYAD = parcelRequire("aSYAD");
class $eb40b99b73192801$export$c00d22927c60484a extends (0, $aSYAD.UFOAbstractExperience) {
}

});
parcelRegister("aSYAD", function(module, exports) {
$parcel$export(module.exports, "UFOAbstractExperience", () => $fb5df3e7e01c2259$export$d31c89db257648c);

var $aXKmr = parcelRequire("aXKmr");


var $6uX6b = parcelRequire("6uX6b");

var $jJiQE = parcelRequire("jJiQE");

var $5hbWe = parcelRequire("5hbWe");

var $ccWvh = parcelRequire("ccWvh");

var $aP4V0 = parcelRequire("aP4V0");

var $2Ilzg = parcelRequire("2Ilzg");

var $g0oDq = parcelRequire("g0oDq");

var $8OSL8 = parcelRequire("8OSL8");

var $aRnO1 = parcelRequire("aRnO1");
const $fb5df3e7e01c2259$var$getPageVisibleState = ()=>{
    return !(0, $2Ilzg.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $ccWvh.PageVisibleState).VISIBLE : (0, $ccWvh.PageVisibleState).HIDDEN;
};
const $fb5df3e7e01c2259$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $aP4V0.roundPerfNow)();
};
class $fb5df3e7e01c2259$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $g0oDq.UFOExperienceState).NOT_STARTED;
        this.instanceId = null // for concurrent
        ;
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $ccWvh.PageVisibleState).MIXED;
            (0, $5hbWe.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $fb5df3e7e01c2259$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $aRnO1.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $aRnO1.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $jJiQE.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $8OSL8.canTransition)(this.state, newState)) {
            (0, $jJiQE.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $g0oDq.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $fb5df3e7e01c2259$export$c753e8669d30c8ad(timestamp);
                this.uuid = (0, $aXKmr.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $fb5df3e7e01c2259$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $6uX6b.getGlobalEventStream)().push((0, $6uX6b.unsubscribeEvent)((0, $ccWvh.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $jJiQE.ufolog)('this.parent', this.parent);
                (0, $6uX6b.getGlobalEventStream)().push((0, $6uX6b.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $jJiQE.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $jJiQE.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $g0oDq.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $fb5df3e7e01c2259$var$getPageVisibleState();
            (0, $5hbWe.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $jJiQE.ufolog)('subscribed', this.id);
                (0, $6uX6b.getGlobalEventStream)().push((0, $6uX6b.subscribeEvent)((0, $ccWvh.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $ccWvh.FMP_MARK) && name !== (0, $ccWvh.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $jJiQE.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $fb5df3e7e01c2259$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $g0oDq.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $ccWvh.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $ccWvh.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $jJiQE.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $5hbWe.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $g0oDq.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $g0oDq.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $g0oDq.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $jJiQE.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $4e1f4772088a5f3c$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
// temp solution until we can get it automated
const $4e1f4772088a5f3c$export$2295b861f318254a = '0.1.5';

parcelRegister("6uX6b", function(module, exports) {
$parcel$export(module.exports, "getGlobalEventStream", () => $aa71c8960fce0a9f$export$6123a44dc2384540);
$parcel$export(module.exports, "subscribeEvent", () => $aa71c8960fce0a9f$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $aa71c8960fce0a9f$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $aa71c8960fce0a9f$export$7c957416596ca127);

var $jJiQE = parcelRequire("jJiQE");

var $ccWvh = parcelRequire("ccWvh");
const $aa71c8960fce0a9f$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $aa71c8960fce0a9f$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $aa71c8960fce0a9f$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $aa71c8960fce0a9f$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $jJiQE.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $aa71c8960fce0a9f$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $ccWvh.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $aa71c8960fce0a9f$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $ccWvh.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $aa71c8960fce0a9f$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $ccWvh.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("ccWvh", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $eeff76e3a75af2a8$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $eeff76e3a75af2a8$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $eeff76e3a75af2a8$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $eeff76e3a75af2a8$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $eeff76e3a75af2a8$export$837e0f79a8056912);
var $eeff76e3a75af2a8$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $eeff76e3a75af2a8$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $eeff76e3a75af2a8$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $eeff76e3a75af2a8$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $eeff76e3a75af2a8$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $eeff76e3a75af2a8$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $eeff76e3a75af2a8$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $eeff76e3a75af2a8$export$9f2bf58999404c75 = 'fmp';
const $eeff76e3a75af2a8$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("5hbWe", function(module, exports) {
$parcel$export(module.exports, "visibilityChangeObserver", () => $d460cc96d513760c$export$13e680397ec8f3eb);

var $2Ilzg = parcelRequire("2Ilzg");
class $d460cc96d513760c$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, $2Ilzg.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $d460cc96d513760c$export$13e680397ec8f3eb = new $d460cc96d513760c$var$VisibilityChangeObserver();

});
parcelRegister("2Ilzg", function(module, exports) {
$parcel$export(module.exports, "isWindowObjectAvailable", () => $5b8b2c70c6400f35$export$15e172712955e18f);
const $5b8b2c70c6400f35$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("aP4V0", function(module, exports) {
$parcel$export(module.exports, "roundPerfNow", () => $53acaf7fbb090f6e$export$5f490af6b2b115cf);
const $53acaf7fbb090f6e$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("g0oDq", function(module, exports) {
$parcel$export(module.exports, "UFOExperienceState", () => $7c8f0df3a7880bc0$export$81b70111112841a0);
const $7c8f0df3a7880bc0$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("8OSL8", function(module, exports) {
$parcel$export(module.exports, "canTransition", () => $ac48b2b50e1c5998$export$178881f329fdb81f);

var $g0oDq = parcelRequire("g0oDq");
const $ac48b2b50e1c5998$var$UFOStateAvailableTransitions = {
    [(0, $g0oDq.UFOExperienceState).NOT_STARTED.id]: [
        (0, $g0oDq.UFOExperienceState).STARTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).STARTED.id]: [
        (0, $g0oDq.UFOExperienceState).IN_PROGRESS.id,
        (0, $g0oDq.UFOExperienceState).BLOCKED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $g0oDq.UFOExperienceState).FAILED.id,
        (0, $g0oDq.UFOExperienceState).ABORTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $g0oDq.UFOExperienceState).BLOCKED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $g0oDq.UFOExperienceState).FAILED.id,
        (0, $g0oDq.UFOExperienceState).ABORTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).BLOCKED.id]: [
        (0, $g0oDq.UFOExperienceState).RECOVERED.id,
        (0, $g0oDq.UFOExperienceState).ABORTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).RECOVERED.id]: [
        (0, $g0oDq.UFOExperienceState).STARTED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $g0oDq.UFOExperienceState).FAILED.id,
        (0, $g0oDq.UFOExperienceState).ABORTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).SUCCEEDED.id]: [
        (0, $g0oDq.UFOExperienceState).STARTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $g0oDq.UFOExperienceState).SUCCEEDED.id,
        (0, $g0oDq.UFOExperienceState).FAILED.id,
        (0, $g0oDq.UFOExperienceState).ABORTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).FAILED.id]: [
        (0, $g0oDq.UFOExperienceState).STARTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).ABORTED.id]: [
        (0, $g0oDq.UFOExperienceState).STARTED.id
    ]
};
const $ac48b2b50e1c5998$export$178881f329fdb81f = (state1, state2)=>{
    return $ac48b2b50e1c5998$var$UFOStateAvailableTransitions[state1.id] && $ac48b2b50e1c5998$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});

parcelRegister("aRnO1", function(module, exports) {
$parcel$export(module.exports, "ExperienceTypes", () => $a0f874ab7df0b90c$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $a0f874ab7df0b90c$export$cc26007c03242fff);
var $a0f874ab7df0b90c$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $a0f874ab7df0b90c$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});





parcelRegister("7xssH", function(module, exports) {
$parcel$export(module.exports, "default", () => $28096ecb360b0e22$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $bmWcp = parcelRequire("bmWcp");

var $2QXr6 = parcelRequire("2QXr6");

var $1mLfK = parcelRequire("1mLfK");
const $28096ecb360b0e22$var$ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';
/**
 * Invoke client action such as preview, download and open link
 */ const $28096ecb360b0e22$var$useInvokeClientAction = ({ fireEvent: fireEventProp })=>{
    const { fireEvent: defaultFireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const fireEvent = fireEventProp ?? defaultFireEvent;
    return (0, $eJOHy.useCallback)(async ({ actionSubjectId: actionSubjectId, actionType: actionType, actionFn: actionFn, definitionId: definitionId = null, extensionKey: extensionKey, display: display, id: id, resourceType: resourceType = null })=>{
        const experienceId = (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))();
        // Begin performance instrumentation.
        const markName = `${experienceId}-${actionType}`;
        $2QXr6.mark(markName, 'pending');
        try {
            // Begin UFO experience
            (0, $1mLfK.startUfoExperience)($28096ecb360b0e22$var$ACTION_EXPERIENCE_NAME, experienceId, {
                actionType: actionType,
                display: display,
                extensionKey: extensionKey,
                invokeType: 'client'
            });
            // Begin analytics instrumentation.
            if (actionSubjectId !== undefined) fireEvent(`ui.button.clicked.${actionSubjectId}`, {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            // Invoke action
            const result = await actionFn();
            $2QXr6.mark(markName, 'resolved');
            (0, $1mLfK.succeedUfoExperience)($28096ecb360b0e22$var$ACTION_EXPERIENCE_NAME, experienceId);
            fireEvent('operational.smartLinkAction.resolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $2QXr6.getMeasure(markName, 'resolved')?.duration ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            return result;
        } catch (err) {
            $2QXr6.mark(markName, 'errored');
            (0, $1mLfK.failUfoExperience)($28096ecb360b0e22$var$ACTION_EXPERIENCE_NAME, experienceId);
            const reason = typeof err === 'string' ? err : err?.message;
            fireEvent('operational.smartLinkAction.unresolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $2QXr6.getMeasure(markName, 'errored')?.duration ?? null,
                id: id ?? experienceId,
                reason: reason,
                resourceType: resourceType
            });
        }
    }, [
        fireEvent
    ]);
};
var $28096ecb360b0e22$export$2e2bcd8739ae039 = $28096ecb360b0e22$var$useInvokeClientAction;

});

parcelRegister("kbv8x", function(module, exports) {
$parcel$export(module.exports, "default", () => $b139b7122b26d76a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3jSKi = parcelRequire("3jSKi");

var $9kfy2 = parcelRequire("9kfy2");

var $5NtHI = parcelRequire("5NtHI");

var $1mLfK = parcelRequire("1mLfK");

var $99QxN = parcelRequire("99QxN");
const $b139b7122b26d76a$var$useResolve = ()=>{
    // Request JSON-LD data for the card from ORS, if it has extended
    // its cache lifespan OR there is no data for it currently. Once the data
    // has come back asynchronously, call the useResponse callback to
    // dispatch the resolved action for the card.
    const { store: store, connections: connections } = (0, $9kfy2.useSmartLinkContext)();
    const { getState: getState } = store;
    const { handleResolvedLinkResponse: handleResolvedLinkResponse, handleResolvedLinkError: handleResolvedLinkError } = (0, $99QxN.default)();
    return (0, $eJOHy.useCallback)(async (url, isReloading = false, isMetadataRequest = false, id = '')=>{
        const { details: details } = getState()[url] || {
            status: (0, $5NtHI.SmartLinkStatus).Pending,
            details: undefined
        };
        const hasData = !!(details && details.data || (0, $3jSKi.isEntityPresent)(details));
        if (isReloading || !hasData || isMetadataRequest) return connections.client.fetchData(url, isReloading).then((response)=>handleResolvedLinkResponse(url, response, isReloading, isMetadataRequest)).catch((error)=>handleResolvedLinkError(url, error, undefined, isMetadataRequest));
        else (0, $1mLfK.addMetadataToExperience)('smart-link-rendered', id, {
            cached: true
        });
    }, [
        connections.client,
        getState,
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $b139b7122b26d76a$export$2e2bcd8739ae039 = $b139b7122b26d76a$var$useResolve;

});
parcelRegister("99QxN", function(module, exports) {
$parcel$export(module.exports, "default", () => $69b217076914baa8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $9kfy2 = parcelRequire("9kfy2");

var $ggoTr = parcelRequire("ggoTr");
var $4pUJe = parcelRequire("4pUJe");
var $4g7cp = parcelRequire("4g7cp");

var $5NtHI = parcelRequire("5NtHI");

var $gA511 = parcelRequire("gA511");

const $69b217076914baa8$var$useResponse = ()=>{
    // Takes in the JSON-LD response and dispatch the resolved action for the card.
    // It will dispatch a successful or error action
    const { store: store, config: config } = (0, $9kfy2.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const hasAuthFlowSupported = config.authFlow !== 'disabled';
    const setMetadataStatus = (0, $eJOHy.useCallback)((url, metadataStatus)=>{
        dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch
    ]);
    const handleResolvedLinkError = (0, $eJOHy.useCallback)((url, error, response, isMetadataRequest)=>{
        const newState = {
            status: (0, $5NtHI.SmartLinkStatus).Pending,
            details: undefined
        };
        const { details: details } = getState()[url] || newState;
        const hasData = !!(details && details.data);
        // If metadata request then set metadata status, return and do not alter link status
        if (isMetadataRequest) {
            setMetadataStatus(url, 'errored');
            return;
        }
        if (error.kind === 'fatal') {
            // If we already have resolved data for this URL in the store, then
            // simply fallback to the previous data.
            if (hasData) dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_RESOLVED), {
                url: url
            }, details));
            else {
                dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_ERROR), {
                    url: url
                }, details, error));
                throw error;
            }
        } else if (error.kind === 'auth') dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_RESOLVED), {
            url: url
        }, (0, $gA511.getUnauthorizedJsonLd)()));
        else if (error.kind === 'fallback') // Fallback to blue link with smart link formatting. Not part of reliability.
        dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_ERROR_FALLBACK), {
            url: url
        }, response, error));
        else // Fallback to blue link with smart link formatting. Part of reliability.
        dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_ERROR), {
            url: url
        }, undefined, error));
    }, [
        getState,
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkSuccess = (0, $eJOHy.useCallback)((resourceUrl, response, isReloading, isMetadataRequest)=>{
        //if a link resolves normally, metadata will also always be resolved
        setMetadataStatus(resourceUrl, 'resolved');
        // Dispatch Analytics and resolved card action - including unauthorized states.
        if (isReloading) dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_RELOADING), {
            url: resourceUrl
        }, response));
        else dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_RESOLVED), {
            url: resourceUrl
        }, response, undefined, undefined, isMetadataRequest));
    }, [
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkResponse = (0, $eJOHy.useCallback)((resourceUrl, response, isReloading = false, isMetadataRequest)=>{
        const hostname = new URL(resourceUrl).hostname;
        const nextStatus = response ? (0, $4g7cp.getStatus)(response) : 'fatal';
        // If we require authorization & do not have an authFlow available,
        // throw an error and render as a normal blue link.
        if ((nextStatus === 'unauthorized' || nextStatus === 'forbidden') && !hasAuthFlowSupported) {
            handleResolvedLinkError(resourceUrl, new (0, $4pUJe.APIError)('fallback', hostname, (0, $9121cfe34e6487d9$export$3e81ce851ffda0ad)), response, isMetadataRequest);
            return;
        }
        // Handle any other errors
        if (!response || nextStatus === 'fatal') {
            handleResolvedLinkError(resourceUrl, new (0, $4pUJe.APIError)('fatal', hostname, (0, $9121cfe34e6487d9$export$45e7dda0d43d7f55)), undefined, isMetadataRequest);
            return;
        }
        // Handle errors of any other kind in the metadata request response
        if (isMetadataRequest && nextStatus !== 'resolved') {
            handleResolvedLinkError(resourceUrl, new (0, $4pUJe.APIError)('error', hostname, (0, $9121cfe34e6487d9$export$338f7d9ccca1975d)), response, isMetadataRequest);
            return;
        }
        /**
			 * Using unstable_batchedUpdates because this store update happens async and triggers a rerender
			 * more info:
			 * https://github.com/facebook/react/blob/v18.2.0/packages/use-sync-external-store/src/useSyncExternalStoreShimClient.js#L113
			 * https://react-redux.js.org/api/batch
			 */ (0, $aQK2r.unstable_batchedUpdates)(()=>{
            handleResolvedLinkSuccess(resourceUrl, response, isReloading, isMetadataRequest);
        });
    }, [
        handleResolvedLinkError,
        handleResolvedLinkSuccess,
        hasAuthFlowSupported
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            handleResolvedLinkError: handleResolvedLinkError,
            handleResolvedLinkResponse: handleResolvedLinkResponse
        }), [
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $69b217076914baa8$export$2e2bcd8739ae039 = $69b217076914baa8$var$useResponse;

});
parcelRegister("4pUJe", function(module, exports) {
$parcel$export(module.exports, "APIError", () => $d6704a2e786f0169$export$3e5b797e39668f84);
class $d6704a2e786f0169$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`), this.kind = kind, this.hostname = hostname, this.message = message, this.type = type, this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}

});

parcelRegister("4g7cp", function(module, exports) {
$parcel$export(module.exports, "getStatus", () => $09aa029e7109943c$export$b70265791d2079d4);
const $09aa029e7109943c$var$getStatusForNotFoundVisibility = (meta)=>{
    const accessType = meta.requestAccess?.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $09aa029e7109943c$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $09aa029e7109943c$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};

});

parcelRegister("gA511", function(module, exports) {
$parcel$export(module.exports, "getEmptyJsonLd", () => $af7c5b7c4494ebd5$export$2796a804c6e44f63);
$parcel$export(module.exports, "getUnauthorizedJsonLd", () => $af7c5b7c4494ebd5$export$b9482e0f6d365cc7);
$parcel$export(module.exports, "getForbiddenJsonLd", () => $af7c5b7c4494ebd5$export$e32193033a594efb);
const $af7c5b7c4494ebd5$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $af7c5b7c4494ebd5$export$2796a804c6e44f63 = ()=>$af7c5b7c4494ebd5$var$emptyData;
const $af7c5b7c4494ebd5$export$b9482e0f6d365cc7 = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'unauthorized',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$af7c5b7c4494ebd5$var$emptyData
        }
    });
const $af7c5b7c4494ebd5$export$e32193033a594efb = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'forbidden',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$af7c5b7c4494ebd5$var$emptyData
        }
    });

});

const $9121cfe34e6487d9$export$297c39c8b9bfca0 = 'resolving';
const $9121cfe34e6487d9$export$b64a888338c24e0e = 'errored';
const $9121cfe34e6487d9$export$677b6edfa0002c70 = 'fallback';
const $9121cfe34e6487d9$export$3e81ce851ffda0ad = 'Provider.authFlow is not set to OAuth2.';
const $9121cfe34e6487d9$export$45e7dda0d43d7f55 = 'Fatal error resolving URL';
const $9121cfe34e6487d9$export$338f7d9ccca1975d = 'Error resolving metadata.';




parcelRegister("5TXKo", function(module, exports) {
$parcel$export(module.exports, "useSmartCardState", () => $644fcc1916cdb207$export$b0444d00ba7313c6);

var $iHcr1 = parcelRequire("iHcr1");

var $9kfy2 = parcelRequire("9kfy2");
const $644fcc1916cdb207$var$PENDING_STATE = {
    status: 'pending'
};
function $644fcc1916cdb207$export$b0444d00ba7313c6(url) {
    const { store: store } = (0, $9kfy2.useSmartLinkContext)();
    const cardState = (0, $iHcr1.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, store.getState, (state)=>state[url]);
    return cardState ?? $644fcc1916cdb207$var$PENDING_STATE;
}

});

parcelRegister("454gh", function(module, exports) {
$parcel$export(module.exports, "useScheduledRegister", () => $7a3c469b230357a6$export$db80d61271e4d5af);
/**
 * This is a scheduled batched register mechanism for resolving blue hyperlinks while the page is idle.
 * i.e. SharePoint tenants with the same hostname will be grouped together before the register is made.
 */ 
var $eJOHy = parcelRequire("eJOHy");
const $7a3c469b230357a6$var$batchQueue = new Map();
const $7a3c469b230357a6$var$batchTimeouts = new Map();
const $7a3c469b230357a6$var$BATCH_DELAY = 250;
const $7a3c469b230357a6$var$executeBatch = (hostname)=>{
    const items = $7a3c469b230357a6$var$batchQueue.get(hostname) || [];
    if (items.length === 0) return;
    $7a3c469b230357a6$var$batchQueue.delete(hostname);
    $7a3c469b230357a6$var$batchTimeouts.delete(hostname);
    items.forEach(({ register: register, resolve: resolve, reject: reject })=>{
        register().then(resolve).catch(reject);
    });
};
const $7a3c469b230357a6$var$addToBatch = (hostname, item)=>{
    if (!$7a3c469b230357a6$var$batchQueue.has(hostname)) $7a3c469b230357a6$var$batchQueue.set(hostname, []);
    $7a3c469b230357a6$var$batchQueue.get(hostname).push(item);
    if ($7a3c469b230357a6$var$batchTimeouts.has(hostname)) clearTimeout($7a3c469b230357a6$var$batchTimeouts.get(hostname));
    $7a3c469b230357a6$var$batchTimeouts.set(hostname, setTimeout(()=>{
        $7a3c469b230357a6$var$executeBatch(hostname);
    }, $7a3c469b230357a6$var$BATCH_DELAY));
};
const $7a3c469b230357a6$export$db80d61271e4d5af = (href, register)=>{
    const isScheduled = (0, $eJOHy.useRef)(false);
    const scheduledRegister = (0, $eJOHy.useCallback)(()=>{
        if (!href || !register || isScheduled.current) return Promise.resolve();
        isScheduled.current = true;
        return new Promise((resolve, reject)=>{
            const scheduleRegister = ()=>{
                try {
                    const hostname = new URL(href).hostname;
                    $7a3c469b230357a6$var$addToBatch(hostname, {
                        href: href,
                        register: register,
                        resolve: (value)=>{
                            isScheduled.current = false;
                            resolve(value);
                        },
                        reject: (error)=>{
                            isScheduled.current = false;
                            reject(error);
                        }
                    });
                } catch (error) {
                    isScheduled.current = false;
                    register().then(resolve).catch(reject);
                }
            };
            if (typeof window !== 'undefined') {
                if ('requestIdleCallback' in window) window.requestIdleCallback(scheduleRegister);
                else setTimeout(scheduleRegister, 0);
            } else scheduleRegister();
        });
    }, [
        href,
        register
    ]);
    return scheduledRegister;
};

});


parcelRegister("4SSxN", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d6d94d7bc990063$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");
const $2d6d94d7bc990063$var$allowedHostnames = [
    'sharepoint.com',
    'onedrive.live.com',
    'docs.google.com',
    'drive.google.com'
];
const $2d6d94d7bc990063$export$aa45d36a96427452 = (href)=>{
    try {
        const hostname = new URL(href).hostname.toLowerCase();
        return $2d6d94d7bc990063$var$allowedHostnames.some((allowedHostname)=>hostname.includes(allowedHostname));
    } catch  {
        return false;
    }
};
const $2d6d94d7bc990063$var$useResolveHyperlinkValidator = (href = '')=>{
    const hasSmartCardProvider = !!(0, $eJOHy.useContext)((0, $9kfy2.SmartCardContext));
    return hasSmartCardProvider && $2d6d94d7bc990063$export$aa45d36a96427452(href);
};
var $2d6d94d7bc990063$export$2e2bcd8739ae039 = $2d6d94d7bc990063$var$useResolveHyperlinkValidator;

});

parcelRegister("44bDi", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkAnalyticsContext", () => $5c3f03a637d1ec7f$export$ac28ada90c4970b7);
$parcel$export(module.exports, "SmartLinkAnalyticsContext", () => $5c3f03a637d1ec7f$export$eaff10f7ec59c455);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $e2B2h = parcelRequire("e2B2h");

var $59rsN = parcelRequire("59rsN");

var $wq6W1 = parcelRequire("wq6W1");

var $9kfy2 = parcelRequire("9kfy2");

var $9NiLY = parcelRequire("9NiLY");

var $eGOwo = parcelRequire("eGOwo");

var $5TXKo = parcelRequire("5TXKo");

var $b43DQ = parcelRequire("b43DQ");
const $5c3f03a637d1ec7f$var$getExtendedResolvedAttributes = (linkDetails, details, linkStatus, error)=>({
        definitionId: details?.meta?.definitionId ?? null,
        resourceType: details?.meta?.resourceType ?? null,
        ...(0, $wq6W1.getResolvedAttributes)(linkDetails, details, linkStatus, error)
    });
const $5c3f03a637d1ec7f$var$getSmartLinkAnalyticsContext = ({ display: display, id: id, response: response, source: source, status: status, url: url, error: error })=>{
    const isHyperlinkConnectExperimentEnabled = (0, $59rsN.default).getExperimentValue('platform_linking_bluelink_connect_confluence', 'isEnabled', false) || (0, $59rsN.default).getExperimentValue('platform_linking_bluelink_connect_jira', 'isEnabled', false);
    const resolvedAttributes = isHyperlinkConnectExperimentEnabled ? $5c3f03a637d1ec7f$var$getExtendedResolvedAttributes({
        url: url,
        displayCategory: display === 'url' ? 'link' : 'smartLink'
    }, response, status, error) : $5c3f03a637d1ec7f$var$getExtendedResolvedAttributes({
        url: url
    }, response, status, error);
    return {
        source: source,
        attributes: {
            ...(0, $b43DQ.context),
            display: display,
            id: id,
            ...resolvedAttributes
        }
    };
};
const $5c3f03a637d1ec7f$export$ac28ada90c4970b7 = ({ display: display, id: id, source: source, url: url })=>{
    const { store: store } = (0, $9kfy2.useSmartLinkContext)();
    const state = store ? (0, $9NiLY.getUrl)(store, url) : undefined;
    return (0, $eJOHy.useMemo)(()=>{
        return $5c3f03a637d1ec7f$var$getSmartLinkAnalyticsContext({
            display: display,
            id: id,
            response: state?.details,
            source: source,
            status: state?.status,
            url: url,
            error: state?.error
        });
    }, [
        display,
        id,
        source,
        state?.details,
        state?.status,
        url,
        state?.error
    ]);
};
const $5c3f03a637d1ec7f$export$eaff10f7ec59c455 = ({ children: children, display: display, id: id, source: source, url: url })=>{
    const { details: details, status: status, error: error } = (0, $5TXKo.useSmartCardState)(url);
    const data = $5c3f03a637d1ec7f$var$getSmartLinkAnalyticsContext({
        display: display,
        id: id,
        response: details,
        source: source,
        status: status,
        url: url,
        error: (0, $eGOwo.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? error : undefined
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
        data: data,
        children: children
    });
};

});
parcelRegister("wq6W1", function(module, exports) {
$parcel$export(module.exports, "getResolvedAttributes", () => $05ccd9b6e0c82253$export$7243431f5325a7b);

var $4g7cp = parcelRequire("4g7cp");

var $6jgT3 = parcelRequire("6jgT3");

var $eGOwo = parcelRequire("eGOwo");
const $05ccd9b6e0c82253$export$7243431f5325a7b = (linkDetails, details, linkStatus, error)=>{
    const status = linkStatus ?? (details && (0, $4g7cp.getStatus)(details));
    const displayCategory = linkDetails.displayCategory === 'link' ? 'link' : (0, $6jgT3.getDisplayCategory)(status);
    return {
        status: status ?? null,
        statusDetails: details?.meta?.requestAccess?.accessType ?? null,
        displayCategory: displayCategory,
        extensionKey: (0, $eGOwo.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? details?.meta?.key ?? error?.extensionKey ?? null : details?.meta?.key ?? null,
        destinationTenantId: details?.meta?.tenantId ?? null,
        destinationActivationId: details?.meta?.activationId ?? null,
        destinationContainerId: details?.meta?.containerId ?? null,
        destinationCategory: details?.meta?.category ?? null,
        destinationProduct: details?.meta?.product ?? null,
        destinationSubproduct: details?.meta?.subproduct ?? null,
        destinationObjectId: details?.meta?.objectId ?? null,
        destinationObjectType: details?.meta?.resourceType ?? null,
        canBeDatasource: (details?.datasources || []).length > 0
    };
};

});
parcelRegister("6jgT3", function(module, exports) {
$parcel$export(module.exports, "getDisplayCategory", () => $e94b2157750adb74$export$28ddbae335bd80b5);
const $e94b2157750adb74$export$28ddbae335bd80b5 = (status)=>{
    return !status || status !== 'not_found' ? 'smartLink' : 'link';
};

});


parcelRegister("9NiLY", function(module, exports) {
$parcel$export(module.exports, "getUrl", () => $ab3ef581aa51838e$export$94df0e59ebebf4a7);
const $ab3ef581aa51838e$export$94df0e59ebebf4a7 = (store, url)=>{
    return store.getState()[url] || {
        status: 'pending'
    };
};

});


parcelRegister("e9k8p", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd51ffa982f0ea36$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4nehu = parcelRequire("4nehu");
/**
 * HOC to wrap component with IntlProvider if not available
 */ const $dd51ffa982f0ea36$var$withIntlProvider = (Component)=>(props)=>{
        const content = /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
            ...props
        });
        return props?.intl ? content : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
            locale: "en",
            children: content
        });
    };
var $dd51ffa982f0ea36$export$2e2bcd8739ae039 = $dd51ffa982f0ea36$var$withIntlProvider;

});

parcelRegister("ettNQ", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkEvents", () => $6b9d8190953f47e0$export$ed70996d478e16d3);
$parcel$export(module.exports, "useFire3PWorkflowsClickEvent", () => $6b9d8190953f47e0$export$e682245dc886cff2);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $b43DQ = parcelRequire("b43DQ");
function $6b9d8190953f47e0$export$ed70996d478e16d3() {
    /**
	 * this utility maybe extended in the future to include
	 * more contextual info about SLs
	 */ const events = (0, $eJOHy.useMemo)(()=>new (0, $b43DQ.SmartLinkEvents)(), []);
    return events;
}
function $6b9d8190953f47e0$export$e682245dc886cff2(firstPartyIdentifier, thirdPartyARI) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return ()=>{
        const smartlinkClickAnalyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'smartLink',
            actionSubjectId: 'smartlinkClickAnalyticsWorkflows',
            eventType: 'ui',
            attributes: {
                eventName: 'smartLinkClickAnalyticsThirdPartyWorkflows',
                firstPartyIdentifier: firstPartyIdentifier
            },
            nonPrivacySafeAttributes: {
                thirdPartyARI: thirdPartyARI
            }
        });
        smartlinkClickAnalyticsEvent.fire('media');
    };
}

});

parcelRegister("9rEhV", function(module, exports) {
$parcel$export(module.exports, "default", () => $71473b112e1a2743$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $19nmp = parcelRequire("19nmp");

var $4Rp6r = parcelRequire("4Rp6r");

var $60qVn = parcelRequire("60qVn");
const $71473b112e1a2743$var$HyperlinkUnauthorizedView = ({ onAuthorize: onAuthorize, provider: provider, showConnectBtn: showConnectBtn, ...props })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $60qVn.default), {
                ...props
            }),
            showConnectBtn && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                children: [
                    ' ',
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Rp6r.ActionButton), {
                        onClick: onAuthorize,
                        testId: "button-connect-account",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                            ...(0, $19nmp.messages).connect_link_account_card_name,
                            values: {
                                context: provider?.text
                            }
                        })
                    })
                ]
            })
        ]
    });
};
var $71473b112e1a2743$export$2e2bcd8739ae039 = $71473b112e1a2743$var$HyperlinkUnauthorizedView;

});
parcelRegister("19nmp", function(module, exports) {
$parcel$export(module.exports, "messages", () => $d6bf071ed8fc5324$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $d6bf071ed8fc5324$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    actions: {
        id: 'fabric.linking.actions',
        defaultMessage: 'Actions',
        description: ''
    },
    add_account: {
        id: 'fabric.linking.add_account',
        defaultMessage: 'Add account',
        description: 'Allows to add a new account'
    },
    ai_summarize: {
        id: 'fabric.linking.ai_summarize',
        defaultMessage: 'Summarize',
        description: 'Action to summarize link resource content with AI'
    },
    ai_summarized: {
        id: 'fabric.linking.ai_summarized',
        defaultMessage: 'Summarized by Atlassian Intelligence',
        description: 'Shown with the content summarised by AI.'
    },
    ai_summarized_abbreviation: {
        id: 'fabric.linking.ai_summarized_abbreviation',
        defaultMessage: 'Summarized by AI',
        description: 'Shown with the content summarised by AI. AI is in abbreviation form to reduce space.'
    },
    ai_summarized_info: {
        id: 'fabric.linking.ai_summarized_info',
        defaultMessage: 'Information quality may vary. <a>Learn more</a>',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarized_info_short: {
        id: 'fabric.linking.ai_summarized_info_short',
        defaultMessage: 'Content quality may vary',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarizing: {
        id: 'fabric.linking.ai_summarizing',
        defaultMessage: 'Atlassian Intelligence is working...',
        description: 'Shown when AI summary is summarising the link resource content.'
    },
    ai_summary_error_generic: {
        id: 'fabric.linking.ai_summary_error_generic',
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
        description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
    },
    ai_summary_error_acceptable_use_violation: {
        id: 'fabric.linking.ai_summary_error_acceptable_use_violation',
        defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
        description: 'Shown when AI summary is summarising the link resource content and the content violates atlassians acceptable use policy.'
    },
    ai_summary_error_hipaa_content_detected: {
        id: 'fabric.linking.ai_summary_error_hipaa_content_detected',
        defaultMessage: 'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
        description: 'Shown when the AI summary is summarising the link resource content and the content contains HIPAA restricted content.'
    },
    ai_summary_error_exceeding_context_length_error: {
        id: 'fabric.linking.ai_summary_error_exceeding_context_length_error',
        defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize.",
        description: 'Shown when the AI summary is summarising the link resource content and the content is too large to summarize.'
    },
    assigned_to: {
        id: 'fabric.linking.assigned_to',
        defaultMessage: 'Assigned to {context}',
        description: 'Indicates the person or entity that the resource is assigned to.'
    },
    automation_action_title: {
        id: 'fabric.linking.automation-action.title',
        defaultMessage: 'View automation rules',
        description: 'The title of the button in a hover card to open an automation menu for a given SmartLink.'
    },
    automation_action_icon_label: {
        id: 'fabric.linking.automation-action.icon.label',
        defaultMessage: 'Automation icon',
        description: 'The label for the automation icon inside of the button opening the automation menu.'
    },
    automation_action_tooltip: {
        id: 'fabric.linking.automation-action.tooltip',
        defaultMessage: 'Select an automation rule to run',
        description: 'The tooltip for the automation action indicating that a button will open an automation modal.'
    },
    automation_action_confluence_page_modal_title: {
        id: 'fabric.linking.automation-action.confluence.page.modal.title',
        defaultMessage: 'Page automations',
        description: 'The title of the automation modal when the SmartLink is a Confluence page'
    },
    automation_action_confluence_page_modal_description: {
        id: 'fabric.linking.automation-action.confluence.page.modal.description',
        defaultMessage: 'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
        description: 'The description in the automation modal when the SmartLink is a Confluence page. Indicating which page the automation will apply to, and who controls the available automations.'
    },
    cancel: {
        id: 'fabric.linking.cancel',
        defaultMessage: 'Cancel',
        description: 'cancel'
    },
    beta: {
        id: 'fabric.linking.beta',
        defaultMessage: 'Beta',
        description: 'Indicates a beta phase of the feature.'
    },
    cannot_connect: {
        id: 'fabric.linking.cannot_connect',
        defaultMessage: "Can't connect, try again",
        description: 'Error for when a provided link is not found.'
    },
    cannot_find_link: {
        id: 'fabric.linking.cannot_find_link',
        defaultMessage: "Can't find link",
        description: 'Error for when a provided link is not found.'
    },
    click_to_join: {
        id: 'fabric.linking.click_to_join',
        defaultMessage: 'Join {context}',
        description: 'Allows the user join the product or service immediately'
    },
    click_to_join_description: {
        id: 'fabric.linking.click_to_join_description',
        defaultMessage: "You've been approved, so you can join {context} right away.",
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    close: {
        id: 'fabric.linking.close',
        defaultMessage: 'Close',
        description: ''
    },
    check_this_link: {
        id: 'fabric.linking.check_this_link',
        defaultMessage: 'Check this link',
        description: 'Link safety warning modal header'
    },
    compass_applied_components_count: {
        id: 'compass.applied_components_count.non-final',
        defaultMessage: 'Applied to {numberOfComponents, plural, one {{numberOfComponents, number} component}  other {{numberOfComponents, number} components}}'
    },
    connect_to: {
        id: 'fabric.linking.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services'
    },
    connect_account_description: {
        id: 'fabric.linking.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account'
    },
    connect_link_account: {
        id: 'fabric.linking.connect_link_account',
        defaultMessage: 'Connect to preview',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
    },
    connect_link_account_card: {
        id: 'fabric.linking.connect_link_account_card_view',
        defaultMessage: 'Connect',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_link_account_card_name: {
        id: 'fabric.linking.connect_link_account_card_view_name',
        defaultMessage: 'Connect your {context} account',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    connect_link_account_card_description: {
        id: 'fabric.linking.connect_link_account_card_view_description',
        defaultMessage: 'To show a preview of this link, connect your {context} account.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
    },
    connect_unauthorised_account_action: {
        id: 'fabric.linking.connect_unauthorised_account_action',
        defaultMessage: 'Connect to {context}',
        description: 'Shown on a button to connect user external account to their Atlassian account.'
    },
    connect_unauthorised_account_description: {
        id: 'fabric.linking.connect_unauthorised_account_description',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    experiment_connect_unauthorised_account_action: {
        id: 'fabric.linking.experiment_connect_unauthorised_account_action.non-final',
        defaultMessage: 'Connect {context}',
        description: 'Shown on a button to connect user external account to their Atlassian account.'
    },
    experiment_connect_link_account_card_name_title: {
        id: 'fabric.linking.experiment_connect_link_account_card_name.non-final',
        defaultMessage: 'Get more out of {context}',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    experiment_connect_hovercard_description_1: {
        id: 'fabric.linking.experiment_connect_hovercard_description_1.non-final',
        defaultMessage: 'Connect your {context} account to turn simple URLs into rich, interactive previews, making it easier to collaborate and stay in context.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. (experiment test 1)'
    },
    experiment_connect_hovercard_description_2: {
        id: 'fabric.linking.experiment_connect_hovercard_description_2.non-final',
        defaultMessage: 'Connect your {context} account to turn simple URLs into rich, interactive previews and unlock more AI experiences, making it easier to collaborate and stay in context.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. (experiment test 2)'
    },
    experiment_connect_hovercard_description_3: {
        id: 'fabric.linking.experiment_connect_hovercard_description_3.non-final',
        defaultMessage: 'Transform ordinary URLs into rich, interactive previews of your {context} content, and unlock enhanced AI-powered features within your Atlassian apps.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. (experiment test 3)'
    },
    continue: {
        id: 'fabric.linking.continue',
        defaultMessage: 'Continue',
        description: 'continue'
    },
    copy_url_to_clipboard: {
        id: 'fabric.linking.copy_url_to_clipboard',
        defaultMessage: 'Copy link',
        description: ''
    },
    copied_url_to_clipboard: {
        id: 'fabric.linking.copied_url_to_clipboard',
        defaultMessage: 'Copied!',
        description: 'Url has been copied to the clipboard'
    },
    could_not_load_link: {
        id: 'fabric.linking.couldnt_load_link',
        defaultMessage: "We couldn't load this link for an unknown reason.",
        description: 'Error case for card view - link could not be loaded.'
    },
    created_by: {
        id: 'fabric.linking.created_by',
        defaultMessage: 'Created by {context}',
        description: 'Indicates the person or entity that created the resource.'
    },
    created_on_relative: {
        id: 'fabric.linking.create_on_relative',
        defaultMessage: 'Created {context}',
        description: 'Indicated when entity was created (relative form)'
    },
    created_on_absolute: {
        id: 'fabric.linking.create_on_absolute',
        defaultMessage: 'Created on {context}',
        description: 'Indicated when entity was created (absolute form)'
    },
    delete: {
        id: 'fabric.linking.delete',
        defaultMessage: 'Delete',
        description: 'Allow a user to delete a link'
    },
    download: {
        id: 'fabric.linking.download',
        defaultMessage: 'Download',
        description: ''
    },
    download_description: {
        id: 'fabric.linking.download_description',
        defaultMessage: 'Download this file into your local storage',
        description: 'Description on what Download does'
    },
    download_file: {
        id: 'fabric.linking.download_file',
        defaultMessage: 'Download file',
        description: 'Allow a user to download a file'
    },
    ai_summary_action: {
        id: 'fabric.linking.ai_summary_action',
        defaultMessage: 'Summarize with AI',
        description: 'Allow a user to summarize a link'
    },
    ai_summary_action_description: {
        id: 'fabric.linking.ai_summary_action_description',
        defaultMessage: 'Summarize the content of this link using Atlassian Intelligence.',
        description: 'Description of what the summarize link with AI action does'
    },
    copy_summary_action: {
        id: 'fabric.linking.copy_summary_action',
        defaultMessage: 'Copy summary',
        description: 'Allow a user to copy a generated summary'
    },
    copy_summary_action_description: {
        id: 'fabric.linking.copy_summary_action_description',
        defaultMessage: 'Copy summary',
        description: 'Description of what the copy summary AI action does'
    },
    copied_summary_action_description: {
        id: 'fabric.linking.copied_summary_action_description',
        defaultMessage: 'Copied summary to clipboard',
        description: 'Confirmation to the user that the summry has been copied'
    },
    edit: {
        id: 'fabric.linking.edit',
        defaultMessage: 'Edit',
        description: 'Allow a user to edit a link'
    },
    follow: {
        id: 'fabric.linking.follow',
        defaultMessage: 'Follow',
        description: 'Click to follow a project.'
    },
    follow_project_description: {
        id: 'fabric.linking.follow_project_description',
        defaultMessage: 'Follow to get notifications on this project',
        description: 'Description on what Follow does'
    },
    follow_project: {
        id: 'fabric.linking.follow_project',
        defaultMessage: 'Follow project',
        description: 'Click to follow a project.'
    },
    follow_project_error: {
        id: 'fabric.linking.follow_project_error',
        defaultMessage: 'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    follow_goal_description: {
        id: 'fabric.linking.follow_goal_description',
        defaultMessage: 'Follow this goal to get notifications on updates',
        description: 'Description on what Follow does'
    },
    follow_goal: {
        id: 'fabric.linking.follow_goal',
        defaultMessage: 'Follow goal',
        description: 'Click to follow a project.'
    },
    follow_goal_error: {
        id: 'fabric.linking.follow_goal_error',
        defaultMessage: 'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas goal'
    },
    go_back: {
        id: 'fabric.linking.go_back',
        defaultMessage: 'Go back',
        description: 'go back'
    },
    invalid_permissions: {
        id: 'fabric.linking.invalid_permissions',
        defaultMessage: 'Restricted content',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    invalid_permissions_description: {
        id: 'fabric.linking.invalid_permissions_description',
        defaultMessage: "You'll need to request access or try a different account to view this preview.",
        description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
    },
    join_to_view: {
        id: 'fabric.linking.join_to_view',
        defaultMessage: 'Join {context} to view this issue',
        description: 'Allows the user join the product or service immediately'
    },
    learn_more_about_smart_links: {
        id: 'fabric.linking.learn_more_about_smart_links',
        defaultMessage: 'Learn more about Smart Links.',
        description: 'An anchor link to redirect user to a page about Smart Links.'
    },
    experiment_learn_more_about_smart_links: {
        id: 'fabric.linking.experiment_learn_more_about_smart_links.non-final',
        defaultMessage: 'Learn more about smart link security and permissions.',
        description: 'An anchor link to redirect user to a page about Smart Links.'
    },
    learn_more_about_connecting_account: {
        id: 'fabric.linking.learn_more_about_connecting_account',
        defaultMessage: 'Learn more about connecting your account to Atlassian products.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    loading: {
        id: 'fabric.linking.loading',
        defaultMessage: 'Loading...',
        description: 'Indicates an element on a page is loading.'
    },
    modified_by: {
        id: 'fabric.linking.updated_by',
        defaultMessage: 'Modified by {context}',
        description: 'Indicates the person or entity that modified the resource.'
    },
    modified_on_relative: {
        id: 'fabric.linking.modified_on_relative',
        defaultMessage: 'Updated {context}',
        description: 'Indicated when entity was modified (relative form)'
    },
    modified_on_absolute: {
        id: 'fabric.linking.modified_on_absolute',
        defaultMessage: 'Updated on {context}',
        description: 'Indicated when entity was modified (absolute form)'
    },
    more_actions: {
        id: 'fabric.linking.more_actions',
        defaultMessage: 'More actions',
        description: 'Allows the users to see more link actions'
    },
    open_issue_in_jira: {
        id: 'fabric.linking.open_issue_in_jira',
        defaultMessage: 'Open issue in Jira',
        description: 'Click to open link in Jira'
    },
    open_link_in_a_new_tab: {
        id: 'fabric.linking.open_link_in_a_new_tab',
        defaultMessage: 'Open link in a new tab',
        description: 'Click to open link in a new tab'
    },
    owned_by: {
        id: 'fabric.linking.owned_by',
        defaultMessage: 'Owned by {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    owned_by_override: {
        id: 'fabric.linking.owned_by_override',
        defaultMessage: 'By {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    preview_description: {
        id: 'fabric.linking.preview_description',
        defaultMessage: 'Open a full screen preview of this link',
        description: 'Description on what Preview does'
    },
    preview_improved: {
        id: 'fabric.linking.preview_improved',
        defaultMessage: 'Open preview',
        description: 'Click to view a richer view of your content, without needing to navigate to it.'
    },
    preview_modal: {
        id: 'fabric.linking.preview_modal',
        defaultMessage: 'Open preview modal',
        description: 'Button used to view a modal view of your content without needing to navigate to it.'
    },
    preview_panel: {
        id: 'fabric.linking.preview_panel',
        defaultMessage: 'Open preview panel',
        description: 'Button used to view a side panel view of your content without needing to navigate to it.'
    },
    preview_close: {
        id: 'fabric.linking.preview_close',
        defaultMessage: 'Close preview',
        description: 'Click to close embed preview modal.'
    },
    preview_max_size: {
        id: 'fabric.linking.preview_max_size',
        defaultMessage: 'View full screen',
        description: 'Click to increase embed preview modal size to a maximum viewing size.'
    },
    preview_min_size: {
        id: 'fabric.linking.preview_min_size',
        defaultMessage: 'Close full screen',
        description: 'Click to decrease embed preview modal size to a minimum viewing size.'
    },
    priority_blocker: {
        id: 'fabric.linking.priority_blocker',
        defaultMessage: 'Blocker',
        description: 'Indicated priority as blocker'
    },
    priority_critical: {
        id: 'fabric.linking.priority_critical',
        defaultMessage: 'Critical',
        description: 'Indicated priority as critical'
    },
    priority_high: {
        id: 'fabric.linking.priority_high',
        defaultMessage: 'High',
        description: 'Indicated priority as high'
    },
    priority_highest: {
        id: 'fabric.linking.priority_highest',
        defaultMessage: 'Highest',
        description: 'Indicated priority as highest'
    },
    priority_low: {
        id: 'fabric.linking.priority_low',
        defaultMessage: 'Low',
        description: 'Indicated priority as low'
    },
    priority_lowest: {
        id: 'fabric.linking.priority_lowest',
        defaultMessage: 'Lowest',
        description: 'Indicated priority as lowest'
    },
    priority_major: {
        id: 'fabric.linking.priority_major',
        defaultMessage: 'Major',
        description: 'Indicated priority as major'
    },
    priority_medium: {
        id: 'fabric.linking.priority_medium',
        defaultMessage: 'Medium',
        description: 'Indicated priority as medium'
    },
    priority_minor: {
        id: 'fabric.linking.priority_minor',
        defaultMessage: 'Minor',
        description: 'Indicated priority as minor'
    },
    priority_trivial: {
        id: 'fabric.linking.priority_trivial',
        defaultMessage: 'Trivial',
        description: 'Indicated priority as trivial'
    },
    priority_undefined: {
        id: 'fabric.linking.priority_undefined',
        defaultMessage: 'Undefined',
        description: 'Indicated priority as unknown'
    },
    forbidden_access: {
        id: 'fabric.linking.forbidden_access',
        defaultMessage: 'Your access is forbidden',
        description: 'Shown when a user does not have access to a resource behind the link.'
    },
    pending_request: {
        id: 'fabric.linking.pending_request',
        defaultMessage: 'Your access request is pending',
        description: 'Shown when a user has requested an access but status is pending.'
    },
    read_time: {
        id: 'fabric.linking.read_time',
        defaultMessage: '{context} min read',
        description: 'Estimated time to read this resource'
    },
    restricted_link: {
        id: 'fabric.linking.restricted_link',
        defaultMessage: 'Restricted link, try another account',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    request_access_to_view: {
        id: 'fabric.linking.request_access_to_view',
        defaultMessage: 'Request access to {context} to view this issue',
        description: 'Allows the user to request access to a product or service'
    },
    request_denied: {
        id: 'fabric.linking.request_denied',
        defaultMessage: 'Your access request was denied',
        description: 'The user had request access but the request was denied by a product or service'
    },
    retry: {
        id: 'fabric.linking.retry',
        defaultMessage: 'Retry',
        description: 'Allows user to perform an action again'
    },
    save: {
        id: 'fabric.linking.save',
        defaultMessage: 'Save',
        description: 'Just the "save" word'
    },
    sent_on_relative: {
        id: 'fabric.linking.sent_on_relative',
        defaultMessage: 'Sent {context}',
        description: 'Indicated when entity was sent (relative form)'
    },
    sent_on_absolute: {
        id: 'fabric.linking.sent_on_absolute',
        defaultMessage: 'Sent on {context}',
        description: 'Indicated when entity was sent (absolute form)'
    },
    status_change_load_error: {
        id: 'fabric.linking.status_change_load_error',
        defaultMessage: "We couldn\u2019t load the statuses and transitions",
        description: 'Informs the user that the loading of status transitions failed'
    },
    status_change_permission_error: {
        id: 'fabric.linking.status_change_permission_error',
        defaultMessage: "You don\u2019t have permission to transition this issue. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    status_change_update_error: {
        id: 'fabric.linking.status_change_update_error',
        defaultMessage: "We couldn\u2019t update the status",
        description: "Occurs when a user tries to update an issue's status but fails to do so"
    },
    try_again: {
        id: 'fabric.linking.try_again',
        defaultMessage: 'Try again',
        description: 'Allow the user to try an action again'
    },
    try_another_account: {
        id: 'fabric.linking.try_another_account',
        defaultMessage: 'Try another account',
        description: 'Allows the user to try an action again with a different account'
    },
    link_safety_warning_message: {
        id: 'fabric.linking.link_safety_warning_message',
        defaultMessage: 'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
        description: 'Link safety check warning message'
    },
    unauthorised_account_description: {
        id: 'fabric.linking.unauthorised_account_description',
        defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_description_no_provider: {
        id: 'fabric.linking.unauthorised_account_description_no_provider',
        defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_name: {
        id: 'fabric.linking.unauthorised_account_name',
        defaultMessage: "We can't display private pages from {context}",
        description: 'Shown when a user does not have access to a link.'
    },
    unauthorised_account_name_no_provider: {
        id: 'fabric.linking.unauthorised_account_name_no_provider',
        defaultMessage: "We can't display private pages",
        description: 'Shown when a user does not have access to a link.'
    },
    unassigned: {
        id: 'fabric.linking.unassigned',
        defaultMessage: 'Unassigned',
        description: 'Shown as a tooltip text for a default unassigned fallback avatar'
    },
    unfollow: {
        id: 'fabric.linking.unfollow',
        defaultMessage: 'Unfollow',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_description: {
        id: 'fabric.linking.unfollow_project_description',
        defaultMessage: 'Unfollow to stop receiving project notifications',
        description: 'Description on what Unfollow does'
    },
    unfollow_project: {
        id: 'fabric.linking.unfollow_project',
        defaultMessage: 'Unfollow project',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_error: {
        id: 'fabric.linking.unfollow_project_error',
        defaultMessage: 'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    unfollow_goal_description: {
        id: 'fabric.linking.unfollow_goal_description',
        defaultMessage: 'Unfollow to stop receiving notifications for this goal',
        description: 'Description on what Unfollow does'
    },
    unfollow_goal: {
        id: 'fabric.linking.unfollow_goal',
        defaultMessage: 'Unfollow goal',
        description: 'Click to unfollow a project.'
    },
    unfollow_goal_error: {
        id: 'fabric.linking.unfollow_goal_error',
        defaultMessage: 'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas goal'
    },
    unlink_account: {
        id: 'fabric.linking.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user'
    },
    view: {
        id: 'fabric.linking.view',
        defaultMessage: 'View',
        description: 'Go through to a piece of content to view it in its original context.'
    },
    viewIn: {
        id: 'fabric.linking.srclink',
        defaultMessage: 'View in',
        description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
    },
    viewOriginal: {
        id: 'fabric.linking.srclinkunknown',
        defaultMessage: 'View Original',
        description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
    },
    default_no_access_title: {
        id: 'fabric.linking.no_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they dont have access to certain content'
    },
    direct_access_title: {
        id: 'fabric.linking.direct_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access_description: {
        id: 'fabric.linking.direct_access_description',
        defaultMessage: 'Your team uses {product} to collaborate and you can start using it right away!',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access: {
        id: 'fabric.linking.direct_access',
        defaultMessage: 'Join now',
        description: 'Allows the user join the product or service immediately'
    },
    request_access_description: {
        id: 'fabric.linking.request_access_description',
        defaultMessage: 'Your team uses {product} to collaborate. Send your admin a request for access.',
        description: 'Informs the user to request access to a product by talking to the website administrator'
    },
    request_access: {
        id: 'fabric.linking.request_access',
        defaultMessage: 'Request access',
        description: 'Allows the user to request access to a product or service'
    },
    request_access_pending_title: {
        id: 'fabric.linking.request_access_pending_title',
        defaultMessage: 'Access to {product} is pending',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_access_pending_description: {
        id: 'fabric.linking.request_access_pending_description',
        defaultMessage: 'Your request to access {hostname} is awaiting admin approval.',
        description: 'Informs the user that their request to view this content is pending website administrator approval'
    },
    request_access_pending: {
        id: 'fabric.linking.request_access_pending',
        defaultMessage: 'Pending approval',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_denied_description: {
        id: 'fabric.linking.request_denied_description',
        defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}.",
        description: 'Informs the user that their request to view this content was denied'
    },
    access_exists_description: {
        id: 'fabric.linking.access_exists_description',
        defaultMessage: 'Request access to view this content from {hostname}.',
        description: 'Informs the user to contact the website administrator to request access to a product'
    },
    not_found_description: {
        id: 'fabric.linking.not_found_description',
        defaultMessage: "The page doesn't exist or it may have changed after this link was added.",
        description: 'Error case for when a provided item is not found within the list of items'
    },
    not_found_title: {
        id: 'fabric.linking.not_found_title',
        defaultMessage: "We can't show you this {product} page",
        description: 'Error case for when a provided link is not found'
    },
    forbidden_title: {
        id: 'fabric.linking.forbidden_title',
        defaultMessage: "You don't have access to this content",
        description: 'Informs the user that they do not have access to the linked content.'
    },
    forbidden_description: {
        id: 'fabric.linking.forbidden_description',
        defaultMessage: 'Contact your admin to request access to {hostname}.',
        description: 'Informs the user that they must contact the site administrator for access.'
    },
    related: {
        id: 'fabric.linking.related',
        defaultMessage: 'Related',
        description: 'Informs the user about related resources'
    },
    generic_error_message: {
        id: 'fabric.linking.generic_error_message',
        defaultMessage: 'An error occurred',
        description: 'A generic error message to the user'
    },
    related_links_modal_title: {
        id: 'fabric.linking.related_links_modal_title',
        defaultMessage: 'Related links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_view_related_urls: {
        id: 'fabric.linking.related_links_view_related_urls',
        defaultMessage: 'View recent links',
        description: 'Action to view related links to the given resource'
    },
    related_links_view_related_links: {
        id: 'fabric.linking.related_links_view_related_links',
        defaultMessage: 'View related links',
        description: 'Action to view related links to the given resource'
    },
    related_links_found_in: {
        id: 'fabric.linking.related_links_found_in',
        defaultMessage: 'Found in',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_not_found: {
        id: 'fabric.linking.related_links_not_found',
        defaultMessage: "We didn't find any links to show here.",
        description: 'Informs the user that there are no related resources for the given url'
    },
    related_links_includes_links_to: {
        id: 'fabric.linking.related_links_includes_links_to',
        defaultMessage: 'Includes links to',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_modal_error_title: {
        id: 'fabric.linking.related_links_modal_error_title',
        defaultMessage: `We're having trouble loading related links`,
        description: 'Title for related links error'
    },
    related_links_modal_unavailable_title: {
        id: 'fabric.linking.related_links_modal_unavailable_title',
        defaultMessage: `We couldn't find any related links`,
        description: 'Title for related links error'
    },
    related_links_modal_error_description: {
        id: 'fabric.linking.related_links_modal_error_description',
        defaultMessage: 'Check your connection or refresh the page to try again',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_description: {
        id: 'fabric.linking.related_links_modal_unavailable_description',
        defaultMessage: 'We continuously review and add related links for updated pages or other content types',
        description: 'Informs the user that there was a problem loading related links'
    },
    join_to_viewIssueTermRefresh: {
        id: 'fabric.linking.join_to_view-issue-term-refresh',
        defaultMessage: 'Join {context} to view this work item',
        description: 'Allows the user join the product or service immediately'
    },
    open_issue_in_jiraIssueTermRefresh: {
        id: 'fabric.linking.open_issue_in_jira-issue-term-refresh',
        defaultMessage: 'Open work item in Jira',
        description: 'Click to open link in Jira'
    },
    request_access_to_viewIssueTermRefresh: {
        id: 'fabric.linking.request_access_to_view-issue-term-refresh',
        defaultMessage: 'Request access to {context} to view this work item',
        description: 'Allows the user to request access to a product or service'
    },
    status_change_permission_errorIssueTermRefresh: {
        id: 'fabric.linking.status_change_permission_error-issue-term-refresh',
        defaultMessage: "You don\u2019t have permission to transition this work item. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    team_members_count: {
        id: 'fabric.linking.team_members_count',
        defaultMessage: '{context} members',
        description: 'Indicates the count of team member'
    },
    user_attributes: {
        id: 'fabric.linking.user_attributes',
        defaultMessage: '{context}',
        description: 'Displays user attributes like role, department, location, and pronouns'
    },
    follow_project_descriptionGalaxia: {
        id: 'fabric.linking.follow_project_description-galaxia',
        defaultMessage: 'Follow to get notifications on this space',
        description: 'Description on what Follow does'
    },
    follow_project_errorGalaxia: {
        id: 'fabric.linking.follow_project_error-galaxia',
        defaultMessage: 'We encountered an error while trying to follow the space. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    unfollow_project_descriptionGalaxia: {
        id: 'fabric.linking.unfollow_project_description-galaxia',
        defaultMessage: 'Unfollow to stop receiving space notifications',
        description: 'Description on what Unfollow does'
    },
    unfollow_project_errorGalaxia: {
        id: 'fabric.linking.unfollow_project_error-galaxia',
        defaultMessage: 'We encountered an error while trying to unfollow the space. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    connect_unauthorised_account_description_appify: {
        id: 'fabric.linking.connect_unauthorised_account_description-appify',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian apps.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider_appify: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider-appify',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian apps.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    learn_more_about_connecting_account_appify: {
        id: 'fabric.linking.learn_more_about_connecting_account-appify',
        defaultMessage: 'Learn more about connecting your account to Atlassian apps.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    }
});

});

parcelRegister("4Rp6r", function(module, exports) {
$parcel$export(module.exports, "ActionButton", () => $36fa193905cb5ef0$export$cfc7921d29ef7b80);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $46R8N = parcelRequire("46R8N");

var $g6YpQ = parcelRequire("g6YpQ");
const $36fa193905cb5ef0$var$styles = {
    button: "_1e0c1bgi",
    innerContainer: "_1e0c1nu9 _1y1m1u8q _16d9qvcn _k48p1wq8 _19bv12x7 _ca0qv77o _n3tdv77o _u5f312x7 _y3gn18uv _o5721btx _1nmz9jpi",
    enabled: "_syaz1fxt _80omtlke _bfhkm7j4 _irr315ej _1di6ip91",
    disabled: "_syaz1lh4 _80om13gf _bfhksyzs"
};
const $36fa193905cb5ef0$var$experimentEnabledStyles = {
    control: "_syaz1fxt _80omtlke _bfhkm7j4 _irr315ej _1di6ip91",
    test1: "_syaz15cr _80omtlke _bfhk1fvw _qrwqlb4i _1o0zlb4i _irr318hz _1di6gr1v",
    test2: "_syaz15cr _80omtlke _bfhk1t1b _qrwqlb4i _1o0zlb4i _irr3e4nv _1di682ra"
};
const $36fa193905cb5ef0$export$cfc7921d29ef7b80 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, isDisabled: isDisabled, viewType: viewType = 'default', ...props }, ref)=>{
    const experimentValue = viewType === 'unauthorised' ? (0, $g6YpQ.expVal)('platform_inline_smartcard_connect_button_exp', 'cohort', 'control') : 'control';
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        ...props,
        isDisabled: isDisabled,
        ref: ref,
        // We need to reset Pressable fixed font size to allow inline card to inherit the font size
        // from parent component such as paragraph and heading
        style: {
            font: `inherit`
        },
        xcss: $36fa193905cb5ef0$var$styles.button,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            tabIndex: isDisabled ? undefined : 0,
            className: (0, $hcewu.default)([
                $36fa193905cb5ef0$var$styles.innerContainer,
                isDisabled ? $36fa193905cb5ef0$var$styles.disabled : experimentValue !== 'control' ? $36fa193905cb5ef0$var$experimentEnabledStyles[experimentValue] : $36fa193905cb5ef0$var$styles.enabled
            ]),
            children: children
        })
    });
});

});
parcelRegister("g6YpQ", function(module, exports) {
$parcel$export(module.exports, "expVal", () => $f1d9f52443f254ec$export$9db1624a8af791a4);
$parcel$export(module.exports, "expValNoExposure", () => $f1d9f52443f254ec$export$94f132839aec533f);

var $59rsN = parcelRequire("59rsN");

var $dpRNR = parcelRequire("dpRNR");

var $bfW07 = parcelRequire("bfW07");
function $f1d9f52443f254ec$var$expValInternal({ experimentName: experimentName, experimentParam: experimentParam, defaultValue: defaultValue, fireExperimentExposure: fireExperimentExposure }) {
    const experimentConfig = (0, $dpRNR.editorExperimentsConfig)[experimentName];
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error(`Editor experiment configuration is not defined ${experimentName}. Likely the experiment does not exist or editor package versions are misaligned`);
    // @ts-ignore need to loosen the type here to allow for any experiment name
    if ((0, $bfW07._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    // @ts-ignore need to loosen the type here to allow for any experiment name
    return (0, $bfW07._overrides)[experimentName];
    // Check for parameter overrides
    const paramOverride = (0, $bfW07._paramOverrides)[experimentName]?.[experimentParam];
    if (paramOverride !== undefined) return paramOverride;
    // If client is not initialized, we return the default value
    if (!(0, $59rsN.default).initializeCompleted()) return defaultValue;
    if (!(0, $bfW07._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return defaultValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const experimentKey = experimentConfig?.productKeys?.[0, $bfW07._product];
    if (!experimentKey) // This will be hit in the case of an experiment not being set up for the product
    return defaultValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $59rsN.default).getExperimentValue(experimentName, experimentParam, defaultValue, {
        fireExperimentExposure: fireExperimentExposure
    });
    return experimentValue;
}
function $f1d9f52443f254ec$export$9db1624a8af791a4(experimentName, experimentParam, defaultValue) {
    return $f1d9f52443f254ec$var$expValInternal({
        experimentName: experimentName,
        experimentParam: experimentParam,
        defaultValue: defaultValue,
        fireExperimentExposure: true
    });
}
function $f1d9f52443f254ec$export$94f132839aec533f(experimentName, experimentParam, defaultValue) {
    return $f1d9f52443f254ec$var$expValInternal({
        experimentName: experimentName,
        experimentParam: experimentParam,
        defaultValue: defaultValue,
        fireExperimentExposure: false
    });
}

});




parcelRegister("zJfva", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b3c49071625adc0$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kDaaB = parcelRequire("kDaaB");
var $6YFG2 = parcelRequire("6YFG2");
var $4nehu = parcelRequire("4nehu");

var $goZPP = parcelRequire("goZPP");

var $eJ9f5 = parcelRequire("eJ9f5");

var $gHHv2 = parcelRequire("gHHv2");
var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");
var $956it = parcelRequire("956it");

var $19nmp = parcelRequire("19nmp");
const $7b3c49071625adc0$var$breakWordsCss = null;
const $7b3c49071625adc0$var$WarningModal = (props)=>{
    const { isOpen: isOpen, unsafeLinkText: unsafeLinkText, url: url, onClose: onClose, onContinue: onContinue, intl: intl } = props;
    const content = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $956it.default), {
        children: isOpen && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gHHv2.default), {
            onClose: onClose,
            testId: "link-with-safety-warning",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2qG7I.default), {
                    hasCloseButton: true,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5a9Ro.default), {
                        appearance: "warning",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                            ...(0, $19nmp.messages).check_this_link
                        })
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ik0CA.default), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            "_o5726vc6 _1nmz9jpi"
                        ]),
                        children: url && unsafeLinkText && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                            ...(0, $19nmp.messages).link_safety_warning_message,
                            values: {
                                unsafeLinkText: unsafeLinkText,
                                a: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ9f5.default), {
                                        href: url,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: url
                                    })
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $kseeK.default), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
                            appearance: "subtle",
                            onClick: onClose,
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                ...(0, $19nmp.messages).go_back
                            })
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
                            appearance: "warning",
                            onClick: onContinue,
                            autoFocus: true,
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                ...(0, $19nmp.messages).continue
                            })
                        })
                    ]
                })
            ]
        })
    });
    return intl ? content : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        locale: "en",
        children: content
    });
};
var $7b3c49071625adc0$export$2e2bcd8739ae039 = (0, $6YFG2.default)($7b3c49071625adc0$var$WarningModal, {
    enforceContext: false
});

});

parcelRegister("jBltW", function(module, exports) {
$parcel$export(module.exports, "useLinkWarningModal", () => $fb1c524ee3dbf684$export$32b76c003683c2ec);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $lGxtk = parcelRequire("lGxtk");

var $b43DQ = parcelRequire("b43DQ");
const $fb1c524ee3dbf684$var$toUrl = (url, base)=>{
    try {
        return new URL(url, base);
    } catch  {
        return undefined;
    }
};
const $fb1c524ee3dbf684$export$32b76c003683c2ec = ()=>{
    const [unsafeLinkText, setUnsafeLinkText] = (0, $eJOHy.useState)(null);
    const [url, setUrl] = (0, $eJOHy.useState)(null);
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const sendWarningModalViewedEvent = ()=>{
        createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'linkSafetyWarningModal',
            eventType: 'screen',
            name: 'linkSafetyWarningModal'
        }).fire((0, $b43DQ.ANALYTICS_CHANNEL));
    };
    const sendContinueClickedEvent = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'linkSafetyWarningModalContinue',
            eventType: 'ui',
            screen: 'linkSafetyWarningModal'
        }).fire((0, $b43DQ.ANALYTICS_CHANNEL));
    };
    /**
	 * It checks and warns if a link text is a URL and different from an actual link destination
	 */ const isLinkSafe = (event, href)=>{
        if (!href) return true;
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        const normalisedUrlFromLinkText = (0, $lGxtk.normalizeUrl)(linkText);
        if (!normalisedUrlFromLinkText) return true;
        const anchorLinkRegex = new RegExp(/^#/im);
        const isLinkTextAnchorLink = anchorLinkRegex.test(linkText);
        const isAnchorLink = anchorLinkRegex.test(href);
        if (isAnchorLink || isLinkTextAnchorLink) return true;
        const relativeLinkRegex = new RegExp(/^\//im);
        const isRelativeHrefLink = relativeLinkRegex.test(href);
        if (isRelativeHrefLink) return true;
        const hrefUrl = $fb1c524ee3dbf684$var$toUrl(href, window.location.origin);
        const linkTextUrl = $fb1c524ee3dbf684$var$toUrl(normalisedUrlFromLinkText, hrefUrl?.origin);
        if (!hrefUrl || !linkTextUrl) return true;
        const currentAtlassianProductOrigin = window.location.origin;
        const isSafeToIgnoreNonOriginDifferences = hrefUrl?.origin === currentAtlassianProductOrigin && linkTextUrl?.origin === currentAtlassianProductOrigin;
        if (isSafeToIgnoreNonOriginDifferences) return true;
        const httpProtocols = [
            'http:',
            'https:'
        ];
        let areProtocolsEquivalent;
        if (httpProtocols.includes(linkTextUrl.protocol) && httpProtocols.includes(hrefUrl.protocol)) {
            const noUserNameAndPassword = !linkTextUrl.username && !linkTextUrl.password && !hrefUrl.username && !hrefUrl.password;
            areProtocolsEquivalent = noUserNameAndPassword;
        } else areProtocolsEquivalent = linkTextUrl.protocol === hrefUrl.protocol;
        const areEquivalentLinks = linkTextUrl.hostname === hrefUrl.hostname && linkTextUrl.pathname === hrefUrl.pathname && linkTextUrl.search === hrefUrl.search && linkTextUrl.username === hrefUrl.username && linkTextUrl.password === hrefUrl.password && areProtocolsEquivalent;
        if (!areEquivalentLinks) return false;
        return true;
    };
    const showSafetyWarningModal = (event, href)=>{
        event.preventDefault();
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        setUnsafeLinkText(linkText);
        href && setUrl(href);
        setIsOpen(true);
        sendWarningModalViewedEvent();
    };
    const onClose = ()=>{
        setIsOpen(false);
        setUnsafeLinkText(null);
        setUrl(null);
    };
    const onContinue = ()=>{
        onClose();
        sendContinueClickedEvent();
        url && window.open(url, '_blank', 'noopener noreferrer');
    };
    return {
        isLinkSafe: isLinkSafe,
        isOpen: isOpen,
        onClose: onClose,
        onContinue: onContinue,
        showSafetyWarningModal: showSafetyWarningModal,
        unsafeLinkText: unsafeLinkText,
        url: url
    };
};

});
parcelRegister("lGxtk", function(module, exports) {
$parcel$export(module.exports, "isSafeUrl", () => $e793a9958f7445ee$export$c9f92f5469372e0f);
$parcel$export(module.exports, "normalizeUrl", () => $e793a9958f7445ee$export$6535eb414fa2c8b6);
/**
 * This file has been partially duplicated in packages/editor/adf-schema/src/utils/url.ts
 * Any changes made here should be mirrored there until the duplicate behaviour is resolved
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $ap5nJ = parcelRequire("ap5nJ");
const $e793a9958f7445ee$var$linkify = (0, (/*@__PURE__*/$parcel$interopDefault($ap5nJ)))();
$e793a9958f7445ee$var$linkify.add('sourcetree:', 'http:');
$e793a9958f7445ee$var$linkify.add('jamfselfservice:', 'http:');
$e793a9958f7445ee$var$linkify.add('notes:', 'http:');
const $e793a9958f7445ee$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $e793a9958f7445ee$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$e793a9958f7445ee$var$tlds.push($e793a9958f7445ee$var$tlds2Char);
$e793a9958f7445ee$var$linkify.tlds($e793a9958f7445ee$var$tlds, false);
const $e793a9958f7445ee$var$whitelistedURLPatterns = [
    /^https?:\/\/[^\s]*$/im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\/[^\s]*$/im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:[^\s]*$/im,
    /^facetime:[^\s]*$/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    /^sourcetree:/im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^foo:/im,
    /^#/im
];
const $e793a9958f7445ee$var$normaliseLinkHref = (url)=>{
    const match = $e793a9958f7445ee$var$getLinkMatch(url);
    return match && match.url || null;
};
const $e793a9958f7445ee$var$getLinkMatch = (str)=>{
    if (!str) return null;
    let match = $e793a9958f7445ee$var$linkifyMatch(str);
    if (!match.length) match = $e793a9958f7445ee$var$linkify.match(str);
    return match && match.length > 0 && match[0].index === 0 && match[0].lastIndex === str.trim().length ? match[0] : null;
};
const $e793a9958f7445ee$var$LINK_REGEXP = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $e793a9958f7445ee$var$linkifyMatch = (text)=>{
    const matches = [];
    if (!$e793a9958f7445ee$var$LINK_REGEXP.test(text)) return matches;
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($e793a9958f7445ee$var$LINK_REGEXP) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($e793a9958f7445ee$var$LINK_REGEXP);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
const $e793a9958f7445ee$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    return $e793a9958f7445ee$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
function $e793a9958f7445ee$export$6535eb414fa2c8b6(url) {
    if (!url) return '';
    const urlWithoutNewlines = url.replace(/[\r\n]+/g, '');
    if ($e793a9958f7445ee$export$c9f92f5469372e0f(urlWithoutNewlines)) return urlWithoutNewlines.trim();
    return $e793a9958f7445ee$var$normaliseLinkHref(urlWithoutNewlines);
}

});
parcelRegister("ap5nJ", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $793069e9e15f92f4$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $793069e9e15f92f4$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $793069e9e15f92f4$var$isString(obj) {
    return $793069e9e15f92f4$var$_class(obj) === '[object String]';
}
function $793069e9e15f92f4$var$isObject(obj) {
    return $793069e9e15f92f4$var$_class(obj) === '[object Object]';
}
function $793069e9e15f92f4$var$isRegExp(obj) {
    return $793069e9e15f92f4$var$_class(obj) === '[object RegExp]';
}
function $793069e9e15f92f4$var$isFunction(obj) {
    return $793069e9e15f92f4$var$_class(obj) === '[object Function]';
}
function $793069e9e15f92f4$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $793069e9e15f92f4$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $793069e9e15f92f4$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $793069e9e15f92f4$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $793069e9e15f92f4$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $793069e9e15f92f4$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $793069e9e15f92f4$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $793069e9e15f92f4$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $793069e9e15f92f4$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $793069e9e15f92f4$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $793069e9e15f92f4$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("jgL8p"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($793069e9e15f92f4$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($793069e9e15f92f4$var$isObject(val)) {
            if ($793069e9e15f92f4$var$isRegExp(val.validate)) compiled.validate = $793069e9e15f92f4$var$createValidator(val.validate);
            else if ($793069e9e15f92f4$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($793069e9e15f92f4$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $793069e9e15f92f4$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($793069e9e15f92f4$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $793069e9e15f92f4$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($793069e9e15f92f4$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $793069e9e15f92f4$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $793069e9e15f92f4$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $793069e9e15f92f4$var$createMatch(self, shift) {
    var match = new $793069e9e15f92f4$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $793069e9e15f92f4$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $793069e9e15f92f4$var$LinkifyIt)) return new $793069e9e15f92f4$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($793069e9e15f92f4$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $793069e9e15f92f4$var$assign({}, $793069e9e15f92f4$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $793069e9e15f92f4$var$assign({}, $793069e9e15f92f4$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $793069e9e15f92f4$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $793069e9e15f92f4$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $793069e9e15f92f4$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $793069e9e15f92f4$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $793069e9e15f92f4$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $793069e9e15f92f4$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $793069e9e15f92f4$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $793069e9e15f92f4$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $793069e9e15f92f4$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $793069e9e15f92f4$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($793069e9e15f92f4$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($793069e9e15f92f4$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $793069e9e15f92f4$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $793069e9e15f92f4$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $793069e9e15f92f4$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $793069e9e15f92f4$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $793069e9e15f92f4$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $793069e9e15f92f4$var$LinkifyIt;

});
parcelRegister("jgL8p", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("hZcCd")).source;
    re.src_Cc = (parcelRequire("iNnZB")).source;
    re.src_Z = (parcelRequire("23KJ1")).source;
    re.src_P = (parcelRequire("dDBFM")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,}[a-zA-Z0-9%/&]|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + ',(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    ';(?!' + re.src_ZCc + ').|' + // allow `;` if not followed by space-like char
    '\\!+(?!' + re.src_ZCc + '|[!]).|' + // allow `!!!` in paths, but not at the end
    '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});






parcelRegister("7B5Pg", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b3c96b2f2803b80$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
function $3b3c96b2f2803b80$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props.dataAttributes,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            textDecoration: 'line-through'
        },
        children: props.children
    });
}

});

parcelRegister("9PRAt", function(module, exports) {
$parcel$export(module.exports, "default", () => $bce450ecfa4821ab$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
function $bce450ecfa4821ab$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, $gt9Am.jsx)("strong", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("lFm6v", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d4e88ced3f0d8ea$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $4d4e88ced3f0d8ea$var$isSub = (type)=>{
    return type === 'sub';
};
function $4d4e88ced3f0d8ea$export$2e2bcd8739ae039(props) {
    if ($4d4e88ced3f0d8ea$var$isSub(props.type)) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)("sub", {
        ...props.dataAttributes,
        children: props.children
    });
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)("sup", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("4U2Ut", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc4a5b898726e218$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4PpDP = parcelRequire("4PpDP");

var $9NsIT = parcelRequire("9NsIT");

var $58yRG = parcelRequire("58yRG");
function $cc4a5b898726e218$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $58yRG.default)();
    // Note -- while there is no way to create custom colors using default tooling
    // the editor does supported ad hoc color values -- and there may be content
    // which has been migrated or created via apis which use such values.
    let paletteColorValue;
    /**
   * The Editor persists custom text colors when content has been migrated from the old editor, or created via
   * apis.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text colors copied from external editor sources. Where we load the background color from a
   * seperate attribute (data-text-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $9NsIT.hexToEditorTextPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = (0, $9NsIT.hexToEditorTextPaletteColor)(props.color) || props.color;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $4PpDP.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $eJOHy.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props.dataAttributes,
        "data-text-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-text-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: props.children
    });
}

});
parcelRegister("9NsIT", function(module, exports) {
$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $cf1cfab83fe39928$export$9c2f408d391feb93);
// This import will be stripped on build
/**
 * This takes an adf hex color and returns a matching text palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToTextPaletteColor('#0747A6');
 * //     ^? const cssValue: string
 * <span style={{textColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $cf1cfab83fe39928$export$9c2f408d391feb93(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return $cf1cfab83fe39928$export$57fa5089caad992[hexColor.toUpperCase()];
}
const $cf1cfab83fe39928$export$57fa5089caad992 = {
    // blue
    /** blue - light */ ['#B3D4FF']: "var(--ds-background-accent-blue-subtler, #B3D4FF)",
    // source for hex code was legacy token B75
    /** blue - medium */ ['#4C9AFF']: "var(--ds-icon-accent-blue, #4C9AFF)",
    // source for hex code was legacy token B100
    /** blue - strong */ ['#0747A6']: "var(--ds-text-accent-blue, #0747A6)",
    // source for hex code was legacy token B500
    // teal
    /** teal - light */ ['#B3F5FF']: "var(--ds-background-accent-teal-subtler, #B3F5FF)",
    // source for hex code was legacy token T75
    /** teal - medium */ ['#00B8D9']: "var(--ds-icon-accent-teal, #00B8D9)",
    // source for hex code was legacy token T300
    /** teal - strong */ ['#008DA6']: "var(--ds-text-accent-teal, #008DA6)",
    // source for hex code was legacy token T500
    // green
    /** green - light */ ['#ABF5D1']: "var(--ds-background-accent-green-subtler, #ABF5D1)",
    // source for hex code was legacy token G75
    /** green - medium */ ['#36B37E']: "var(--ds-icon-accent-green, #36B37E)",
    // source for hex code was legacy token G300
    /** green - strong */ ['#006644']: "var(--ds-text-accent-green, #006644)",
    // source for hex code was legacy token G500
    // yellowOrange
    /** yellowOrange - light */ ['#FFF0B3']: "var(--ds-background-accent-yellow-subtler, #FFF0B3)",
    // source for hex code was legacy token Y75
    /** yellowOrange - medium */ ['#FFC400']: "var(--ds-background-accent-orange-subtle, #FFC400)",
    // source for hex code was legacy token Y200
    /** yellowOrange - strong */ ['#FF991F']: "var(--ds-icon-accent-orange, #FF991F)",
    // source for hex code was legacy token Y400
    // red
    /** red - light */ ['#FFBDAD']: "var(--ds-background-accent-red-subtler, #FFBDAD)",
    // source for hex code was legacy token R75
    /** red - medium */ ['#FF5630']: "var(--ds-icon-accent-red, #FF5630)",
    // source for hex code was legacy token R300
    /** red - strong */ ['#BF2600']: "var(--ds-text-accent-red, #BF2600)",
    // source for hex code was legacy token R500
    // purple
    /** purple - light */ ['#EAE6FF']: "var(--ds-background-accent-purple-subtler, #EAE6FF)",
    // source for hex code was legacy token P50
    /** purple - medium */ ['#6554C0']: "var(--ds-icon-accent-purple, #6554C0)",
    // source for hex code was legacy token P300
    /** purple - strong */ ['#403294']: "var(--ds-text-accent-purple, #403294)",
    // source for hex code was legacy token P500
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: "var(--ds-text-inverse, #FFFFFF)",
    // source for hex code was legacy token N0
    /** whiteGray - medium */ ['#97A0AF']: "var(--ds-icon-accent-gray, #97A0AF)",
    // source for hex code was legacy token N80
    /** whiteGray - strong */ ['#172B4D']: "var(--ds-text, #172B4D)" // source for hex code was legacy token N800
};

});


parcelRegister("clQ8A", function(module, exports) {
$parcel$export(module.exports, "default", () => $1546906879e66b96$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4PpDP = parcelRequire("4PpDP");

var $drB0U = parcelRequire("drB0U");

var $58yRG = parcelRequire("58yRG");

var $cbSL1 = parcelRequire("cbSL1");
function $1546906879e66b96$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $58yRG.default)();
    let paletteColorValue;
    /**
   * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text background colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text background colors copied from external editor sources. Where we load the background color from a
   * separate attribute (data-background-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $drB0U.hexToEditorTextBackgroundPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = tokenColor;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $4PpDP.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $eJOHy.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    if (props.isStandalone && (0, $cbSL1.expValEquals)('platform_editor_text_highlight_padding', 'isEnabled', true)) return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-block-mark": props.dataAttributes['data-block-mark'],
        "data-renderer-mark": props.dataAttributes['data-renderer-mark'],
        "data-background-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-background-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "background-color-padding-left background-color-padding-right",
            children: props.children
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props.dataAttributes,
        "data-background-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-background-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: props.children
    });
}

});
parcelRegister("drB0U", function(module, exports) {
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $5768ec9dd457945c$export$8b58ff1b36bb75e0);

var $cbSL1 = parcelRequire("cbSL1");
const $5768ec9dd457945c$export$12a518ff137dd389 = {
    /** Gray - light */ ['#DCDFE4']: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
    /** Teal - light */ ['#C6EDFB']: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    /** Lime - light */ ['#D3F1A7']: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    /** Yellow - light */ ['#F8E6A0']: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
    /** Orange - light */ ['#FEDEC8']: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    /** Magenta - light */ ['#FDD0EC']: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    /** Purple - light */ ['#DFD8FD']: "var(--ds-background-accent-purple-subtler, #DFD8FD)"
};
function $5768ec9dd457945c$export$8b58ff1b36bb75e0(hexColor) {
    if (!(0, $cbSL1.expValEquals)('platform_editor_add_orange_highlight_color', 'cohort', 'test')) // @ts-expect-error Expect type error. Will modify production type
    // if experiment proceeds post-results.
    $5768ec9dd457945c$export$12a518ff137dd389['#FEDEC8'] = "var(--ds-background-accent-yellow-subtler, #F8E6A0)";
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    // @ts-ignore
    return $5768ec9dd457945c$export$12a518ff137dd389[hexColor.toUpperCase()];
}

});


parcelRegister("105lA", function(module, exports) {
$parcel$export(module.exports, "default", () => $fbcdb99a38cb4c35$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
function $fbcdb99a38cb4c35$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)("u", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("kh0nj", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd2a7aa9e7dc459d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");

var $92xoS = parcelRequire("92xoS");

var $cbSL1 = parcelRequire("cbSL1");
const $fd2a7aa9e7dc459d$var$wrapperStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `${(0, $7yBx7.blockNodesVerticalMargin)} 0`,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginLeft: '50%',
    transform: 'translateX(-50%)'
});
const $fd2a7aa9e7dc459d$var$getWidth = (width, mode)=>{
    if ((0, $92xoS.editorExperiment)('advanced_layouts', true) && width) return `min(${width}px, var(--ak-editor--breakout-container-without-gutter-width))`;
    else {
        if (mode === 'full-width') {
            if ((0, $cbSL1.expValEquals)('platform_editor_renderer_breakout_fix', 'isEnabled', true)) return `min(${0, $7yBx7.akEditorFullWidthLayoutWidth}px, var(--ak-editor--breakout-container-without-gutter-width))`;
            return `max(${0, $7yBx7.akEditorDefaultLayoutWidth}px, min(${0, $7yBx7.akEditorFullWidthLayoutWidth}px, var(--ak-editor--breakout-container-without-gutter-width)))`;
        }
        if (mode === 'wide') return `min(var(--ak-editor--breakout-wide-layout-width), var(--ak-editor--breakout-container-without-gutter-width))`;
    }
};
function $fd2a7aa9e7dc459d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $fd2a7aa9e7dc459d$var$wrapperStyles,
        "data-mode": props.mode,
        ...(0, $92xoS.editorExperiment)('advanced_layouts', true) && {
            'data-has-width': !!props.width,
            'data-width': props.width
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            width: $fd2a7aa9e7dc459d$var$getWidth('width' in props ? props.width : null, props.mode)
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-breakout-mark fabric-editor-block-mark"
    }, props.children);
}

});

parcelRegister("agnfA", function(module, exports) {
$parcel$export(module.exports, "default", () => $776c00fdd448ca26$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $fRfD8 = parcelRequire("fRfD8");
const $776c00fdd448ca26$var$MarkWrapper = (props)=>{
    const dataAlign = props['data-align'] ? (0, $fRfD8.alignmentPositionMap)[props['data-align']] : undefined;
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        style: {
            textAlign: dataAlign
        },
        ...props
    }, props.children);
};
function $776c00fdd448ca26$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $1NIU8.jsx)($776c00fdd448ca26$var$MarkWrapper, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-alignment",
        "data-align": props.align
    }, props.children);
}

});

parcelRegister("36uir", function(module, exports) {
$parcel$export(module.exports, "default", () => $4adf8cdc302fb563$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
function $4adf8cdc302fb563$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-indentation-mark",
        "data-level": props.level,
        children: props.children
    });
}

});

parcelRegister("1JSxg", function(module, exports) {
$parcel$export(module.exports, "default", () => $56a2d33572f5581d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
function $56a2d33572f5581d$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("1lKH5", function(module, exports) {
$parcel$export(module.exports, "default", () => $b0ef138c69d3df93$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
function $b0ef138c69d3df93$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("jLqyg", function(module, exports) {
$parcel$export(module.exports, "default", () => $a728379652509c5a$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
function $a728379652509c5a$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, $gt9Am.jsx)(WrapperElement, {
        "data-source": props.sources ? JSON.stringify(props.sources) : undefined,
        "data-mark-type": "dataConsumer",
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("5lVub", function(module, exports) {
$parcel$export(module.exports, "default", () => $72bc8ea88846b0a8$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
function $72bc8ea88846b0a8$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, $gt9Am.jsx)(WrapperElement, {
        "data-localId": props.localId,
        "data-name": props.name,
        "data-mark-type": "fragment",
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("79gvV", function(module, exports) {
$parcel$export(module.exports, "default", () => $7877f25ac91f8c5c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");
function $7877f25ac91f8c5c$export$2e2bcd8739ae039(props) {
    const borderColor = props.color ?? '';
    const borderSize = props.size ?? 0;
    return /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        "data-color": borderColor,
        "data-size": borderSize,
        "data-mark-type": "border"
    }, props.children);
}

});

parcelRegister("6Iogh", function(module, exports) {
$parcel$export(module.exports, "default", () => $990911999fff5606$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
class $990911999fff5606$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    render() {
        const { reference: reference, children: children } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            "data-mark-type": "confluenceInlineComment",
            "data-reference": reference,
            children: children
        });
    }
}

});


parcelRegister("fftJQ", function(module, exports) {
$parcel$export(module.exports, "insideBreakoutLayout", () => $8a7b49658fbd7dfc$export$d7bc71cca336a3b);
$parcel$export(module.exports, "insideBlockNode", () => $8a7b49658fbd7dfc$export$42ddc573eb5a7b43);
$parcel$export(module.exports, "insideMultiBodiedExtension", () => $8a7b49658fbd7dfc$export$9f1e9347b0411934);
$parcel$export(module.exports, "insideTable", () => $8a7b49658fbd7dfc$export$244bf4b32387ef62);
const $8a7b49658fbd7dfc$var$isLayoutNode = (node)=>node.type.name === 'layoutSection';
const $8a7b49658fbd7dfc$var$hasBreakOutMark = (node)=>node.marks.some((m)=>m.type.name === 'breakout');
const $8a7b49658fbd7dfc$export$d7bc71cca336a3b = (path)=>path.some((item)=>$8a7b49658fbd7dfc$var$isLayoutNode(item) && $8a7b49658fbd7dfc$var$hasBreakOutMark(item));
const $8a7b49658fbd7dfc$export$42ddc573eb5a7b43 = (path, schema)=>{
    const { nodes: { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } } = schema;
    const blockNodeNames = [
        expand,
        nestedExpand,
        layoutColumn
    ].filter((node)=>Boolean(node)).map((node)=>node.name);
    return path && path.some((n)=>n.type && blockNodeNames.indexOf(n.type.name) > -1);
};
const $8a7b49658fbd7dfc$export$9f1e9347b0411934 = (path, schema)=>{
    const { nodes: { multiBodiedExtension: multiBodiedExtension } } = schema;
    return path.some((n)=>n.type === multiBodiedExtension);
};
const $8a7b49658fbd7dfc$export$244bf4b32387ef62 = (path, schema)=>{
    const { nodes: { table: table } } = schema;
    return path.some((n)=>n.type === table);
};

});

parcelRegister("7htLd", function(module, exports) {
$parcel$export(module.exports, "getStandaloneBackgroundColorMarks", () => $dd1b5416310e55f3$export$eeb66772b38d7581);

var $aYybS = parcelRequire("aYybS");
const $dd1b5416310e55f3$export$eeb66772b38d7581 = (content)=>{
    const standaloneMarks = [];
    // keep track of the previous node's state
    let prev = {
        selfSpaceOnTheRight: true
    };
    let prevNode = null;
    // Iterates through each node in the content array.
    // Tracks if the previous node had a backgroundColor mark and if it ended with a space.
    // If a backgroundColor mark is followed by a text node that starts with a space,
    // and the previous node ended with a space, the previous backgroundColor mark is considered standalone.
    // At the end, flushes any remaining node that meets the standalone criteria.
    for(let i = 0; i < content.length; i++){
        const node = content[i];
        const nodeMarks = (0, $aYybS.default).getMarks(node);
        const isBackgroundColor = nodeMarks.some((m)=>m.type.name === 'backgroundColor');
        let selfSpaceOnTheLeft = false;
        let selfSpaceOnTheRight = false;
        if (node.text) {
            selfSpaceOnTheLeft = node.text.startsWith(' ');
            selfSpaceOnTheRight = node.text.endsWith(' ');
        }
        if (isBackgroundColor) {
            prevNode = node;
            prev = {
                selfSpaceOnTheRight: false,
                hasBackgroundColor: true,
                spaceToTheLeft: prev !== null && prev.selfSpaceOnTheRight
            };
        } else {
            // If prev exists, check for standalone logic
            if (prev && prev.hasBackgroundColor && prevNode) // If prev had space on the left and current is a TextNode and has space on the left
            {
                if (prev.spaceToTheLeft && selfSpaceOnTheLeft) {
                    const mark = (0, $aYybS.default).getMarks(prevNode).find((m)=>m.type.name === 'backgroundColor');
                    if (mark) standaloneMarks.push(mark);
                }
            }
            prevNode = null;
            prev = {
                selfSpaceOnTheRight: selfSpaceOnTheRight,
                hasBackgroundColor: false
            };
        }
    }
    if (prevNode) {
        if (prev && prev.hasBackgroundColor && prev.spaceToTheLeft) {
            const mark = (0, $aYybS.default).getMarks(prevNode).find((m)=>m.type.name === 'backgroundColor');
            if (mark) standaloneMarks.push(mark);
        }
    }
    return standaloneMarks;
};

});


parcelRegister("fjfmN", function(module, exports) {
$parcel$export(module.exports, "renderDocument", () => $7a1052b2a1567e8a$export$59a54f98b9753d5c);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $8DB98 = parcelRequire("8DB98");

var $djAo6 = parcelRequire("djAo6");
var $jF4Mi = parcelRequire("jF4Mi");

var $bMFKb = parcelRequire("bMFKb");

var $3mTkR = parcelRequire("3mTkR");
var $3Ussg = parcelRequire("3Ussg");

var $cRsRn = parcelRequire("cRsRn");

var $eGOwo = parcelRequire("eGOwo");

var $LFmXM = parcelRequire("LFmXM");

var $7ueoK = parcelRequire("7ueoK");

var $lE3K0 = parcelRequire("lE3K0");

var $86V7W = parcelRequire("86V7W");
const $7a1052b2a1567e8a$var$SUPPORTS_HIRES_TIMER_API = !!(typeof window !== 'undefined' && window.performance && performance.now);
const $7a1052b2a1567e8a$var$withStopwatch = (cb)=>{
    const startTime = $7a1052b2a1567e8a$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const output = cb();
    const endTime = $7a1052b2a1567e8a$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const time = endTime - startTime;
    return {
        output: output,
        time: time
    };
};
const $7a1052b2a1567e8a$var$_validation = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent, skipValidation, validationOverrides)=>{
    let result;
    if (useSpecBasedValidator) {
        // link mark on mediaSingle is deprecated, need to move link mark to child media node
        // https://product-fabric.atlassian.net/browse/ED-14043
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $djAo6.transformMediaLinkMarks)(doc);
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).MEDIA_LINK_TRANSFORMED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).RENDERER,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
        });
        result = skipValidation ? transformedAdf || doc : (0, $3Ussg.validateADFEntity)(schema, transformedAdf || doc, dispatchAnalyticsEvent, validationOverrides);
    } else result = (0, $cRsRn.getValidDocument)(doc, schema, adfStage);
    if (!result) return result;
    // ProseMirror always require a child under doc
    if (result.type === 'doc' && useSpecBasedValidator) {
        if (Array.isArray(result.content) && result.content.length === 0) result.content.push({
            type: 'paragraph',
            content: []
        });
        // Just making sure doc is always valid
        if (!result.version) result.version = 1;
    }
    // Convert nested-table extensions into nested tables
    try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $jF4Mi.transformNestedTablesIncomingDocument)(result, {
            environment: 'renderer',
            disableNestedRendererTreatment: (0, $eGOwo.fg)('platform_editor_nested_table_extension_comment_fix')
        });
        if (isTransformed) {
            dispatchAnalyticsEvent?.({
                action: (0, $bMFKb.ACTION).NESTED_TABLE_TRANSFORMED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).RENDERER,
                eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
            });
            result = transformedAdf;
        }
    } catch (e) {
        dispatchAnalyticsEvent?.({
            action: (0, $bMFKb.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).RENDERER,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $7ueoK.PLATFORM).WEB,
                errorStack: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to encode one or more nested tables' : undefined}`
            }
        });
    }
    return result;
};
const $7a1052b2a1567e8a$var$memoValidation = (0, $LFmXM.default)($7a1052b2a1567e8a$var$_validation, (newArgs, lastArgs)=>{
    const [newDoc, newSchema, newADFStage, newUseSpecValidator, , /* ignoring dispatchAnalyticsEvent */ newSkipValidation, newValidationOverrides] = newArgs;
    const [oldDoc, oldSchema, oldADFStage, oldUseSpecValidator, , /* ignoring dispatchAnalyticsEvent */ oldSkipValidation, oldValidationOverrides] = lastArgs;
    return $7a1052b2a1567e8a$var$areDocsEqual(newDoc, oldDoc) && newSchema === oldSchema && newADFStage === oldADFStage && newUseSpecValidator === oldUseSpecValidator && newSkipValidation === oldSkipValidation && newValidationOverrides === oldValidationOverrides;
});
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7a1052b2a1567e8a$var$areDocsEqual = (docA, docB)=>{
    if (docA === docB) return true;
    if (typeof docA === 'string' && typeof docB === 'string') return docA === docB;
    // PMNode
    if (docA.type && docA.toJSON && docB.type && docB.toJSON) return JSON.stringify(docA.toJSON()) === JSON.stringify(docB.toJSON());
    // Object
    return JSON.stringify(docA) === JSON.stringify(docB);
};
const $7a1052b2a1567e8a$var$_serializeFragment = (serializer, doc)=>{
    return serializer.serializeFragment(doc.content);
};
const $7a1052b2a1567e8a$var$memoSerializeFragment = (0, $LFmXM.default)($7a1052b2a1567e8a$var$_serializeFragment, (newArgs, lastArgs)=>{
    const [newSerializer, newDoc] = newArgs;
    const [oldSerializer, oldDoc] = lastArgs;
    return newSerializer === oldSerializer && $7a1052b2a1567e8a$var$areDocsEqual(newDoc, oldDoc);
});
const $7a1052b2a1567e8a$var$_createNodeAndCheck = (schema, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, dispatchAnalyticsEvent)=>{
    const pmNode = schema.nodeFromJSON(doc);
    try {
        pmNode.check();
    } catch (err) {
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $7ueoK.PLATFORM).WEB,
                errorStack: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
        });
    }
    return pmNode;
};
const $7a1052b2a1567e8a$var$memoCreateNodeAndCheck = (0, $LFmXM.default)($7a1052b2a1567e8a$var$_createNodeAndCheck, (newArgs, lastArgs)=>{
    // ignore dispatchAnalyticsEvent
    const [newSchema, newDoc] = newArgs;
    const [oldSchema, oldDoc] = lastArgs;
    return newSchema === oldSchema && $7a1052b2a1567e8a$var$areDocsEqual(newDoc, oldDoc);
});
const $7a1052b2a1567e8a$export$59a54f98b9753d5c = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, serializer, schema = (0, $8DB98.defaultSchema), adfStage = 'final', useSpecBasedValidator = false, rendererId = 'noid', dispatchAnalyticsEvent, unsupportedContentLevelsTracking, appearance, includeNodesCountInStats, skipValidation, validationOverrides)=>{
    const stat = {
        sanitizeTime: 0
    };
    if ((0, $eGOwo.fg)('platform_editor_renderer_rm_usespecbasedvalidator')) useSpecBasedValidator = true;
    const { output: validDoc, time: sanitizeTime } = $7a1052b2a1567e8a$var$withStopwatch(()=>{
        return $7a1052b2a1567e8a$var$memoValidation(doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent, skipValidation, validationOverrides);
    });
    // save sanitize time to stats
    stat.sanitizeTime = sanitizeTime;
    if (!validDoc) return {
        stat: stat,
        result: null
    };
    const { output: node, time: buildTreeTime } = $7a1052b2a1567e8a$var$withStopwatch(()=>{
        return $7a1052b2a1567e8a$var$memoCreateNodeAndCheck(schema, validDoc, dispatchAnalyticsEvent);
    });
    // save build tree time to stats
    stat.buildTreeTime = buildTreeTime;
    const { output: result, time: serializeTime } = $7a1052b2a1567e8a$var$withStopwatch(()=>{
        return $7a1052b2a1567e8a$var$memoSerializeFragment(serializer, node);
    });
    // save serialize tree time to stats
    stat.serializeTime = serializeTime;
    if (dispatchAnalyticsEvent && useSpecBasedValidator) {
        (0, $3mTkR.findAndTrackUnsupportedContentNodes)(node, schema, dispatchAnalyticsEvent);
        if (unsupportedContentLevelsTracking?.enabled) {
            const documentData = {
                doc: validDoc,
                appearance: appearance,
                rendererId: rendererId
            };
            (0, $lE3K0.trackUnsupportedContentLevels)(documentData, unsupportedContentLevelsTracking, dispatchAnalyticsEvent);
        }
    }
    if (includeNodesCountInStats) stat.nodesCount = (0, $86V7W.countNodes)(doc);
    return {
        result: result,
        stat: stat,
        pmDoc: node
    };
};

});
parcelRegister("djAo6", function(module, exports) {
$parcel$export(module.exports, "transformMediaLinkMarks", () => $b2a4642f722aa8d8$export$6528700f3fa2fe2a);

var $0mclG = parcelRequire("0mclG");
const $b2a4642f722aa8d8$export$6528700f3fa2fe2a = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $0mclG.traverse)(adf, {
        mediaSingle: (node)=>{
            if (!node.marks || !node.content || node.content[0]?.type !== 'media') return node;
            let linkMark = null;
            node.marks.forEach((mark, i)=>{
                if (mark.type === 'link') {
                    linkMark = mark;
                    node.marks?.splice(i, 1);
                    isTransformed = true;
                }
            });
            if (node.marks.length === 0) delete node.marks;
            if (linkMark) {
                const mediaNode = node.content[0];
                // only add link mark if media node doesnt already have one
                if (mediaNode.marks?.every((mark)=>mark.type !== 'link')) mediaNode.marks.push(linkMark);
                else if (!mediaNode.marks) mediaNode.marks = [
                    linkMark
                ];
            }
            return node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("3Ussg", function(module, exports) {
$parcel$export(module.exports, "validateADFEntity", () => $263400656bb608dd$export$884cfad20dece33e);

var $2MkAG = parcelRequire("2MkAG");

var $bMFKb = parcelRequire("bMFKb");

var $3mTkR = parcelRequire("3mTkR");
const $263400656bb608dd$export$8e7fd962b4d3895d = 'unsupportedNodeAttribute';
const $263400656bb608dd$var$errorCallbackFor = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
marks, validate, dispatchAnalyticsEvent, validationOverrides)=>{
    return (entity, error, options)=>{
        return $263400656bb608dd$export$468b008419c9a974(entity, error, {
            ...options,
            allowNestedTables: validationOverrides?.allowNestedTables
        }, marks, validate, dispatchAnalyticsEvent);
    };
};
const $263400656bb608dd$export$468b008419c9a974 = (entity, error, options, marks, validate, dispatchAnalyticsEvent)=>{
    if (entity && entity.type === $263400656bb608dd$export$8e7fd962b4d3895d) return entity;
    if (options.isMark) return $263400656bb608dd$export$87b732fa69cdf16e(error.meta, 'mark');
    if (options.isNodeAttribute) {
        const entityType = entity && entity.type ? entity.type : undefined;
        return {
            type: $263400656bb608dd$export$8e7fd962b4d3895d,
            attrs: {
                type: {
                    nodeType: entityType
                },
                unsupported: error.meta
            }
        };
    }
    if (entity && marks.indexOf(entity.type) > -1) return;
    /**
	 * There's a inconsistency between ProseMirror and ADF.
	 * `content` is actually optional in ProseMirror.
	 * And, also empty `text` node is not valid.
	 */ if (error.code === 'MISSING_PROPERTIES' && entity.type === 'paragraph') return {
        type: 'paragraph',
        content: []
    };
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: We can repair missing content like `panel` without a `paragraph`.
    if (error.code === 'INVALID_CONTENT_LENGTH') {
        if (error.meta && options.allowUnsupportedBlock && entity.content) return $263400656bb608dd$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent);
        else // Can't fix it by wrapping
        if (dispatchAnalyticsEvent) $263400656bb608dd$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    }
    // Nested tables don't actually exist in ADF. In ADF they are stored as an `extension` node with the nested table content serialized in a property of that extension.
    // Usually when we validate ADF we are validating this `extension` and then later transforming it into nested tables for usage by ProseMirror.
    // Under certain circumstances however, ADF validation is performed on this already transformed extension and since nested tables aren't allowed by ADF this
    // produces an error. For example, nested renderers in Confluence `bodiedExtension`'s. The nested renderer receives the already transformed nested tables that originated from the
    // `extension` node and validates it. This is invalid ADF so an error is thrown.
    // This override allows an exception to be made for nested tables in the validator in this circumstance.
    if (options.allowNestedTables) {
        const meta = error.meta;
        if (options.allowNestedTables && meta?.parentType && [
            'tableCell',
            'tableHeader'
        ].includes(meta?.parentType) && error.code === 'INVALID_CONTENT' && entity.type === 'table') return entity;
    }
    if (options.allowUnsupportedBlock) return $263400656bb608dd$export$87b732fa69cdf16e(entity);
    if (options.allowUnsupportedInline) return $263400656bb608dd$export$87b732fa69cdf16e(entity, 'inline');
    if (dispatchAnalyticsEvent) $263400656bb608dd$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    return entity;
};
function $263400656bb608dd$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent) {
    const meta = error.meta;
    if (meta.type === 'maximum') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    entity.content = entity.content.filter((x)=>!!x).map((child, index)=>{
        return index >= meta.requiredLength && child.type !== 'unsupportedBlock' ? $263400656bb608dd$export$87b732fa69cdf16e(child) : validate(child, $263400656bb608dd$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent)).entity;
    });
    if (meta.type === 'minimum') {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (entity.content.length === 0) return $263400656bb608dd$export$87b732fa69cdf16e(entity);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        entity.content = entity.content.filter((x)=>!!x).map((child)=>{
            return child.type !== 'unsupportedBlock' ? $263400656bb608dd$export$87b732fa69cdf16e(child) : child;
        });
    }
    return entity;
}
function $263400656bb608dd$var$trackValidationError(dispatchAnalyticsEvent, error, entity) {
    if (!dispatchAnalyticsEvent) return;
    (0, $3mTkR.fireUnsupportedEvent)(dispatchAnalyticsEvent, (0, $bMFKb.ACTION_SUBJECT_ID).UNSUPPORTED_ERROR, {
        type: entity.type || '',
        ancestry: entity.ancestorHierarchy || '',
        parentType: entity.parentType || '',
        marks: entity.marks || [],
        attrs: entity.attrs || {}
    }, error.code);
}
const $263400656bb608dd$export$884cfad20dece33e = (schema, node, dispatchAnalyticsEvent, validationOverrides)=>{
    const nodes = Object.keys(schema.nodes);
    const marks = Object.keys(schema.marks);
    const validate = (0, $2MkAG.validator)(nodes, marks, {
        allowPrivateAttributes: true
    });
    const emptyDoc = {
        type: 'doc',
        content: []
    };
    const { entity: entity = emptyDoc } = validate(node, $263400656bb608dd$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent, validationOverrides));
    return entity;
};
function $263400656bb608dd$export$87b732fa69cdf16e(originalValue, type = 'block') {
    let unsupportedNodeType;
    switch(type){
        case 'inline':
            unsupportedNodeType = 'unsupportedInline';
            break;
        case 'mark':
            unsupportedNodeType = 'unsupportedMark';
            break;
        default:
            unsupportedNodeType = 'unsupportedBlock';
    }
    return {
        type: unsupportedNodeType,
        attrs: {
            originalValue: originalValue
        }
    };
}

});
parcelRegister("2MkAG", function(module, exports) {
$parcel$export(module.exports, "validator", () => $96effbef339de82e$export$956325f45c5d174a);
// Ignored via go/ees005
// eslint-disable-next-line import/no-namespace

var $l7cdi = parcelRequire("l7cdi");

var $kfOTy = parcelRequire("kfOTy");

var $eZqxv = parcelRequire("eZqxv");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $96effbef339de82e$var$mapMarksItems(spec, fn = (x)=>x) {
    if (spec.props && spec.props.marks) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items, ...rest } = spec.props.marks;
        return {
            ...spec,
            props: {
                ...spec.props,
                marks: {
                    ...rest,
                    /**
					 * `Text & MarksObject<Mark-1>` produces `items: ['mark-1']`
					 * `Text & MarksObject<Mark-1 | Mark-2>` produces `items: [['mark-1', 'mark-2']]`
					 */ items: items.length ? Array.isArray(items[0]) ? items.map(fn) : [
                        fn(items)
                    ] : [
                        []
                    ]
                }
            }
        };
    } else return spec;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $96effbef339de82e$var$partitionObject = (obj, predicate)=>Object.keys(obj).reduce((acc, key)=>{
        const result = predicate(key, obj[key], obj);
        acc[result ? 0 : 1].push(key);
        return acc;
    }, [
        [],
        []
    ]);
/**
 * Normalizes the structure of files imported from './specs'.
 * We denormalised the spec to save bundle size.
 */ function $96effbef339de82e$var$createSpec(nodes, marks) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys($l7cdi).reduce((newSpecs, k)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const spec = {
            ...$l7cdi[k]
        };
        if (spec.props) {
            spec.props = {
                ...spec.props
            };
            if (spec.props.content) {
                // 'tableCell_content' => { type: 'array', items: [ ... ] }
                if ((0, $kfOTy.isString)(spec.props.content)) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                spec.props.content = $l7cdi[spec.props.content];
                // ['inline', 'emoji']
                if (Array.isArray(spec.props.content)) /**
					 * Flatten
					 *
					 * Input:
					 * [ { type: 'array', items: [ 'tableHeader' ] }, { type: 'array', items: [ 'tableCell' ] } ]
					 *
					 * Output:
					 * { type: 'array', items: [ [ 'tableHeader' ], [ 'tableCell' ] ] }
					 */ spec.props.content = {
                    type: 'array',
                    items: (spec.props.content || []).map((arr)=>arr.items)
                };
                else spec.props.content = {
                    ...spec.props.content
                };
                spec.props.content.items = spec.props.content.items// ['inline'] => [['emoji', 'hr', ...]]
                // ['media'] => [['media']]
                .map((item)=>(0, $kfOTy.isString)(item) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Array.isArray($l7cdi[item]) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    $l7cdi[item] : [
                        item
                    ] : item)// [['emoji', 'hr', 'inline_code']] => [['emoji', 'hr', ['text', { marks: {} }]]]
                .map((item)=>item.map((subItem)=>// Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        Array.isArray($l7cdi[subItem]) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        $l7cdi[subItem] : (0, $kfOTy.isString)(subItem) ? subItem : [
                            'text',
                            subItem
                        ])// Remove unsupported nodes & marks
                    // Filter nodes
                    .filter((subItem)=>{
                        if (nodes) {
                            // Node with overrides
                            // ['mediaSingle', { props: { content: { items: [ 'media', 'caption' ] } }}]
                            if (Array.isArray(subItem)) {
                                const isMainNodeSupported = nodes.indexOf(subItem[0]) > -1;
                                if (isMainNodeSupported && subItem[1]?.props?.content?.items) return subItem[1].props.content.items.every((item)=>nodes.indexOf(item) > -1);
                                return isMainNodeSupported;
                            }
                            return nodes.indexOf(subItem) > -1;
                        }
                        return true;
                    })// Filter marks
                    .map((subItem)=>Array.isArray(subItem) && marks ? /**
										 * TODO: Probably try something like immer, but it's 3.3kb gzipped.
										 * Not worth it just for this.
										 */ [
                            subItem[0],
                            $96effbef339de82e$var$mapMarksItems(subItem[1])
                        ] : subItem));
            }
        }
        newSpecs[k] = spec;
        return newSpecs;
    }, {});
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $96effbef339de82e$var$getOptionsForType(type, list) {
    if (!list) return {};
    for(let i = 0, len = list.length; i < len; i++){
        const spec = list[i];
        let name = spec;
        let options = {};
        if (Array.isArray(spec)) [name, options] = spec;
        if (name === type) return options;
    }
    return false;
}
const $96effbef339de82e$var$isValidatorSpecAttrs = (spec)=>{
    return !!spec.props;
};
function $96effbef339de82e$export$66c739158ef99a42(spec, value) {
    if (!(0, $kfOTy.isDefined)(value)) return !!spec.optional;
    if ($96effbef339de82e$var$isValidatorSpecAttrs(spec)) {
        // If spec has ".props" it is ValidatorSpecAttrs and need to pipe back in recursively
        const [_, invalidKeys] = $96effbef339de82e$var$partitionObject(spec.props, (key, subSpec)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            $96effbef339de82e$export$66c739158ef99a42(subSpec, value[key]));
        return invalidKeys.length === 0;
    }
    // extension_node parameters has no type
    if (!(0, $kfOTy.isDefined)(spec.type)) return !!spec.optional;
    switch(spec.type){
        case 'boolean':
            return (0, $kfOTy.isBoolean)(value);
        case 'number':
            return (0, $kfOTy.isNumber)(value) && ((0, $kfOTy.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $kfOTy.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'integer':
            return (0, $kfOTy.isInteger)(value) && ((0, $kfOTy.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $kfOTy.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'string':
            const validatorFnPassed = (rule)=>typeof value === 'string' && (0, $kfOTy.isDefined)((0, $eZqxv.validatorFnMap)[rule]) && (0, $eZqxv.validatorFnMap)[rule](value);
            return (0, $kfOTy.isString)(value) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            ((0, $kfOTy.isDefined)(spec.minLength) ? spec.minLength <= value.length : true) && ((0, $kfOTy.isDefined)(spec.validatorFn) ? validatorFnPassed(spec.validatorFn) : true) && // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            (spec.pattern ? new RegExp(spec.pattern).test(value) : true);
        case 'object':
            return (0, $kfOTy.isPlainObject)(value);
        case 'array':
            if (Array.isArray(value)) {
                const isTuple = !!spec.isTupleLike;
                const { minItems: minItems, maxItems: maxItems } = spec;
                if (minItems !== undefined && value.length < minItems || maxItems !== undefined && value.length > maxItems) return false;
                if (isTuple) {
                    // If value has fewer items than tuple has specs - we are fine with that.
                    const numberOfItemsToCheck = Math.min(spec.items.length, value.length);
                    return Array(numberOfItemsToCheck).fill(null).every((_, i)=>$96effbef339de82e$export$66c739158ef99a42(spec.items[i], value[i]));
                } else return value.every((valueItem)=>// We check that at least one of the specs in the list (spec.items) matches each value from
                    spec.items.some((itemSpec)=>$96effbef339de82e$export$66c739158ef99a42(itemSpec, valueItem)));
            }
            return false;
        case 'enum':
            return (0, $kfOTy.isString)(value) && spec.values.indexOf(value) > -1;
    }
}
const $96effbef339de82e$var$errorMessageFor = (type, message)=>`${type}: ${message}.`;
const $96effbef339de82e$var$getUnsupportedOptions = (spec)=>{
    if (spec && spec.props && spec.props.content) {
        const { allowUnsupportedBlock: allowUnsupportedBlock, allowUnsupportedInline: allowUnsupportedInline } = spec.props.content;
        return {
            allowUnsupportedBlock: allowUnsupportedBlock,
            allowUnsupportedInline: allowUnsupportedInline
        };
    }
    return {};
};
const $96effbef339de82e$var$invalidChildContent = (child, errorCallback, parentSpec)=>{
    const message = $96effbef339de82e$var$errorMessageFor(child.type, 'invalid content');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...child
    }, {
        code: 'INVALID_CONTENT',
        message: message,
        meta: {
            parentType: parentSpec?.props?.type?.values[0]
        }
    }, $96effbef339de82e$var$getUnsupportedOptions(parentSpec));
};
const $96effbef339de82e$var$unsupportedMarkContent = (errorCode, mark, errorCallback, errorMessage)=>{
    const message = errorMessage || $96effbef339de82e$var$errorMessageFor(mark.type, 'unsupported mark');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...mark
    }, {
        code: errorCode,
        message: message,
        meta: mark
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: true
    });
};
const $96effbef339de82e$var$unsupportedNodeAttributesContent = (entity, errorCode, invalidAttributes, message, errorCallback)=>{
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        type: entity.type
    }, {
        code: errorCode,
        message: message,
        meta: invalidAttributes
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: false,
        isNodeAttribute: true
    });
};
function $96effbef339de82e$export$956325f45c5d174a(nodes, marks, options) {
    const validatorSpecs = $96effbef339de82e$var$createSpec(nodes, marks);
    const { mode: mode = 'strict', allowPrivateAttributes: allowPrivateAttributes = false } = options || {};
    const validate = (entity, errorCallback, allowed, parentSpec)=>{
        const validationResult = validateNode(entity, errorCallback, allowed, parentSpec);
        return {
            entity: validationResult.entity,
            valid: validationResult.valid
        };
    };
    const validateNode = (entity, errorCallback, allowed, parentSpec, isMark = false)=>{
        const { type: type } = entity;
        const newEntity = {
            ...entity
        };
        const err = (code, msg, meta)=>{
            const message = $96effbef339de82e$var$errorMessageFor(type, msg);
            if (errorCallback) return {
                valid: false,
                entity: errorCallback(newEntity, {
                    code: code,
                    message: message,
                    meta: meta
                }, $96effbef339de82e$var$getUnsupportedOptions(parentSpec))
            };
            else throw new Error(message);
        };
        if (type) {
            const typeOptions = $96effbef339de82e$var$getOptionsForType(type, allowed);
            if (typeOptions === false) return isMark ? {
                valid: false
            } : err('INVALID_TYPE', 'type not allowed here');
            const spec = validatorSpecs[type];
            if (!spec) return err('INVALID_TYPE', `${type}: No validation spec found for type!`);
            const specBasedValidationResult = specBasedValidationFor(spec, typeOptions, entity, err, newEntity, type, errorCallback, isMark);
            if (specBasedValidationResult.hasValidated && specBasedValidationResult.result) return specBasedValidationResult.result;
        } else return err('INVALID_TYPE', 'ProseMirror Node/Mark should contain a `type`');
        return {
            valid: true,
            entity: newEntity
        };
    };
    return validate;
    function marksValidationFor(validator, entity, errorCallback, newEntity, err) {
        let validationResult;
        if (validator.props && validator.props.marks) {
            const marksSet = allowedMarksFor(validator);
            const marksValidationResult = marksAfterValidation(entity, errorCallback, marksSet, validator);
            validationResult = {
                valid: true,
                entity: newEntity,
                marksValidationOutput: marksValidationResult
            };
        } else validationResult = marksForEntitySpecNotSupportingMarks(entity, newEntity, errorCallback, err);
        return validationResult;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function validatorFor(spec, typeOptions) {
        return {
            ...spec,
            ...typeOptions,
            // options with props can override props of spec
            ...spec.props ? {
                props: {
                    ...spec.props,
                    ...typeOptions['props'] || {}
                }
            } : {}
        };
    }
    function marksAfterValidation(entity, errorCallback, marksSet, validator) {
        return entity.marks ? entity.marks.map((mark)=>{
            const isAKnownMark = marks ? marks.indexOf(mark.type) > -1 : true;
            if (mode === 'strict' && isAKnownMark) {
                const finalResult = validateNode(mark, errorCallback, marksSet, validator, true);
                const finalMark = finalResult.entity;
                if (finalMark) return {
                    valid: true,
                    originalMark: mark,
                    newMark: finalMark
                };
                else if (finalResult.marksValidationOutput && finalResult.marksValidationOutput.length) return {
                    valid: false,
                    originalMark: mark,
                    errorCode: finalResult.marksValidationOutput[0].errorCode,
                    message: finalResult.marksValidationOutput[0].message
                };
                else return {
                    valid: false,
                    originalMark: mark,
                    errorCode: 'INVALID_TYPE'
                };
            } else return {
                valid: false,
                originalMark: mark,
                errorCode: 'INVALID_CONTENT'
            };
        }) : [];
    }
    function allowedMarksFor(validator) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items } = validator.props.marks;
        const marksSet = items.length ? Array.isArray(items[0]) ? items[0] : items : [];
        return marksSet;
    }
    function marksForEntitySpecNotSupportingMarks(prevEntity, newEntity, errorCallback, err) {
        const errorCode = 'REDUNDANT_MARKS';
        const currentMarks = prevEntity.marks || [];
        const newMarks = currentMarks.map((mark)=>{
            const isUnsupportedNodeAttributeMark = mark.type === 'unsupportedNodeAttribute';
            if (isUnsupportedNodeAttributeMark) return mark;
            return $96effbef339de82e$var$unsupportedMarkContent(errorCode, mark, errorCallback);
        });
        if (newMarks.length) {
            newEntity.marks = newMarks;
            return {
                valid: true,
                entity: newEntity
            };
        } else return err('REDUNDANT_MARKS', 'redundant marks', {
            marks: Object.keys(currentMarks)
        });
    }
    function requiredPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        if (validatorSpec.required) {
            if (!validatorSpec.required.every((prop)=>(0, $kfOTy.isDefined)(prevEntity[prop]))) result = err('MISSING_PROPERTIES', 'required prop missing');
        }
        return result;
    }
    function textPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.text) {
            if ((0, $kfOTy.isDefined)(prevEntity.text) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            !$96effbef339de82e$export$66c739158ef99a42(validatorSpec.props.text, prevEntity.text)) result = err('INVALID_TEXT', `'text' validation failed`);
        }
        return result;
    }
    function contentLengthValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.content && prevEntity.content) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const { minItems: minItems, maxItems: maxItems } = validatorSpec.props.content;
            const length = prevEntity.content.length;
            if ((0, $kfOTy.isDefined)(minItems) && minItems > length) result = err('INVALID_CONTENT_LENGTH', `'content' should have more than ${minItems} child`, {
                length: length,
                requiredLength: minItems,
                type: 'minimum'
            });
            else if ((0, $kfOTy.isDefined)(maxItems) && maxItems < length) result = err('INVALID_CONTENT_LENGTH', `'content' should have less than ${maxItems} child`, {
                length: length,
                requiredLength: maxItems,
                type: 'maximum'
            });
        }
        return result;
    }
    function invalidAttributesFor(validatorSpec, prevEntity) {
        let invalidAttrs = [];
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let validatorAttrs = {};
        if (validatorSpec.props && validatorSpec.props.attrs) {
            const attrOptions = (0, $kfOTy.makeArray)(validatorSpec.props.attrs);
            /**
			 * Attrs can be union type so try each path
			 * attrs: [{ props: { url: { type: 'string' } } }, { props: { data: {} } }],
			 * Gotcha: It will always report the last failure.
			 */ for(let i = 0, length = attrOptions.length; i < length; ++i){
                const attrOption = attrOptions[i];
                if (attrOption && attrOption.props) [, invalidAttrs] = $96effbef339de82e$var$partitionObject(attrOption.props, (key, spec)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const valueToValidate = prevEntity.attrs[key];
                    return $96effbef339de82e$export$66c739158ef99a42(spec, valueToValidate);
                });
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                validatorAttrs = attrOption;
                if (!invalidAttrs.length) break;
            }
        }
        return {
            invalidAttrs: invalidAttrs,
            validatorAttrs: validatorAttrs
        };
    }
    function attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback) {
        const validatorSpecAllowsAttributes = validatorSpec.props && validatorSpec.props.attrs;
        if (prevEntity.attrs) {
            if (!validatorSpecAllowsAttributes) {
                if (isMark) return handleNoAttibutesAllowedInSpecForMark(prevEntity, prevEntity.attrs);
                const attrs = Object.keys(prevEntity.attrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, [], attrs, errorCallback);
            }
            const { hasUnsupportedAttrs: hasUnsupportedAttrs, redundantAttrs: redundantAttrs, invalidAttrs: invalidAttrs } = validateAttributes(validatorSpec, prevEntity, prevEntity.attrs);
            if (hasUnsupportedAttrs) {
                if (isMark) return handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback);
            }
        }
        return {
            valid: true,
            entity: prevEntity
        };
    }
    function validateAttributes(validatorSpec, prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const invalidAttributesResult = invalidAttributesFor(validatorSpec, prevEntity);
        const { invalidAttrs: invalidAttrs } = invalidAttributesResult;
        const validatorAttrs = invalidAttributesResult.validatorAttrs;
        const attrs = Object.keys(attributes).filter((k)=>!(allowPrivateAttributes && k.startsWith('__')));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const redundantAttrs = attrs.filter((a)=>!validatorAttrs.props[a]);
        const hasRedundantAttrs = redundantAttrs.length > 0;
        const hasUnsupportedAttrs = invalidAttrs.length || hasRedundantAttrs;
        return {
            hasUnsupportedAttrs: hasUnsupportedAttrs,
            invalidAttrs: invalidAttrs,
            redundantAttrs: redundantAttrs
        };
    }
    function handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback) {
        const attr = invalidAttrs.concat(redundantAttrs);
        let result = {
            valid: true,
            entity: prevEntity
        };
        const message = $96effbef339de82e$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const errorCode = 'UNSUPPORTED_ATTRIBUTES';
        newEntity.marks = wrapUnSupportedNodeAttributes(prevEntity, newEntity, attr, errorCode, message, errorCallback);
        result = {
            valid: true,
            entity: newEntity
        };
        return result;
    }
    function handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs) {
        let errorCode = 'INVALID_ATTRIBUTES';
        let message = $96effbef339de82e$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const hasRedundantAttrs = redundantAttrs.length;
        const hasBothInvalidAndRedundantAttrs = hasRedundantAttrs && invalidAttrs.length;
        if (!hasBothInvalidAndRedundantAttrs && hasRedundantAttrs) {
            errorCode = 'REDUNDANT_ATTRIBUTES';
            message = $96effbef339de82e$var$errorMessageFor('redundant attributes found', redundantAttrs.join(', '));
        }
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function handleNoAttibutesAllowedInSpecForMark(prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const message = $96effbef339de82e$var$errorMessageFor('redundant attributes found', Object.keys(attributes).join(', '));
        const errorCode = 'REDUNDANT_ATTRIBUTES';
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function wrapUnSupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, errorCode, message, errorCallback) {
        const invalidValues = {};
        // eslint-disable-next-line guard-for-in
        for(const invalidAttr in invalidAttrs){
            invalidValues[invalidAttrs[invalidAttr]] = prevEntity.attrs && prevEntity.attrs[invalidAttrs[invalidAttr]];
            if (newEntity.attrs) delete newEntity.attrs[invalidAttrs[invalidAttr]];
        }
        const unsupportedNodeAttributeValues = $96effbef339de82e$var$unsupportedNodeAttributesContent(prevEntity, errorCode, invalidValues, message, errorCallback);
        const finalEntity = {
            ...newEntity
        };
        if (finalEntity.marks) {
            if (!unsupportedNodeAttributeValues) return finalEntity.marks;
            // If there is an existing unsupported node attribute mark, overwrite it to avoid duplicate marks
            const existingMark = finalEntity.marks.find((mark)=>mark.type === unsupportedNodeAttributeValues.type);
            if (existingMark) existingMark.attrs = unsupportedNodeAttributeValues.attrs;
            else finalEntity.marks.push(unsupportedNodeAttributeValues);
            return finalEntity.marks;
        } else return [
            unsupportedNodeAttributeValues
        ];
    }
    function extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type) {
        const result = {
            valid: true,
            entity: prevEntity
        };
        const [requiredProps, redundantProps] = $96effbef339de82e$var$partitionObject(prevEntity, (k)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $kfOTy.isDefined)(validatorSpec.props[k]));
        if (redundantProps.length) {
            if (mode === 'loose') {
                newEntity = {
                    type: type
                };
                requiredProps.reduce((acc, p)=>(0, $kfOTy.copy)(prevEntity, acc, p), newEntity);
            } else {
                if (!((redundantProps.indexOf('marks') > -1 || redundantProps.indexOf('attrs') > -1) && redundantProps.length === 1)) return err('REDUNDANT_PROPERTIES', `redundant props found: ${redundantProps.join(', ')}`, {
                    props: redundantProps
                });
            }
        }
        return result;
    }
    function specBasedValidationFor(spec, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    typeOptions, prevEntity, err, newEntity, type, errorCallback, isMark) {
        const specBasedValidationResult = {
            hasValidated: false
        };
        const validatorSpec = validatorFor(spec, typeOptions);
        if (!validatorSpec) return specBasedValidationResult;
        // Required Props
        // For array format where `required` is an array
        const requiredPropertyValidatonResult = requiredPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!requiredPropertyValidatonResult.valid) return {
            hasValidated: true,
            result: requiredPropertyValidatonResult
        };
        if (!validatorSpec.props) {
            const props = Object.keys(prevEntity);
            // If there's no validator.props then there shouldn't be any key except `type`
            if (props.length > 1) return {
                hasValidated: true,
                result: err('REDUNDANT_PROPERTIES', `redundant props found: ${Object.keys(prevEntity).join(', ')}`, {
                    props: props
                })
            };
            return specBasedValidationResult;
        }
        // Check text
        const textPropertyValidationResult = textPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!textPropertyValidationResult.valid) return {
            hasValidated: true,
            result: textPropertyValidationResult
        };
        // Content Length
        const contentLengthValidationResult = contentLengthValidationFor(validatorSpec, prevEntity, err);
        if (!contentLengthValidationResult.valid) return {
            hasValidated: true,
            result: contentLengthValidationResult
        };
        // Required Props
        // For object format based on `optional` property
        const [, missingProps] = $96effbef339de82e$var$partitionObject(validatorSpec.props, (k, v)=>{
            // if the validator is an array, then check
            // if the `required` field contains the key.
            const isOptional = Array.isArray(v) ? !validatorSpec.required?.includes(k) : typeof v === 'object' && v !== null && 'optional' in v ? v.optional : false;
            return isOptional || (0, $kfOTy.isDefined)(prevEntity[k]);
        });
        if (missingProps.length) return {
            hasValidated: true,
            result: err('MISSING_PROPERTIES', 'required prop missing', {
                props: missingProps
            })
        };
        const attributesValidationResult = attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback);
        if (!attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        if (isMark && attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        const extraPropsValidationResult = extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type);
        if (!extraPropsValidationResult.valid) return {
            hasValidated: true,
            result: extraPropsValidationResult
        };
        // Children
        if (validatorSpec.props.content) {
            const contentValidatorSpec = validatorSpec.props.content;
            if (prevEntity.content) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const validateChildNode = (child, index)=>{
                    if (child === undefined) return child;
                    const validateChildMarks = (childEntity, marksValidationOutput, errorCallback, isLastValidationSpec, isParentTupleLike = false)=>{
                        let marksAreValid = true;
                        if (childEntity && childEntity.marks && marksValidationOutput) {
                            const validMarks = marksValidationOutput.filter((mark)=>mark.valid);
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            const finalMarks = marksValidationOutput.map((mr)=>{
                                if (mr.valid) return mr.newMark;
                                else {
                                    if (validMarks.length || isLastValidationSpec || isParentTupleLike || mr.errorCode === 'INVALID_TYPE' || mr.errorCode === 'INVALID_CONTENT' || mr.errorCode === 'REDUNDANT_ATTRIBUTES' || mr.errorCode === 'INVALID_ATTRIBUTES') return $96effbef339de82e$var$unsupportedMarkContent(// Ignored via go/ees005
                                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                    mr.errorCode, mr.originalMark, errorCallback, mr.message);
                                    return;
                                }
                            }).filter(Boolean);
                            if (finalMarks.length) childEntity.marks = finalMarks;
                            else {
                                delete childEntity.marks;
                                marksAreValid = false;
                            }
                        }
                        return {
                            valid: marksAreValid,
                            entity: childEntity
                        };
                    };
                    const hasMultipleCombinationOfContentAllowed = !!contentValidatorSpec.isTupleLike;
                    if (hasMultipleCombinationOfContentAllowed) {
                        const { entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, (0, $kfOTy.makeArray)(contentValidatorSpec.items[index] || contentValidatorSpec.items[contentValidatorSpec.items.length - 1]), validatorSpec);
                        const { entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, false, true);
                        return entity;
                    }
                    // Only go inside valid branch
                    const allowedSpecsForEntity = contentValidatorSpec.items.filter((item)=>Array.isArray(item) ? item.some(// [p, hr, ...] or [p, [text, {}], ...]
                        (spec)=>(Array.isArray(spec) ? spec[0] : spec) === child.type) : true);
                    if (allowedSpecsForEntity.length) {
                        if (allowedSpecsForEntity.length > 1) throw new Error('Consider using Tuple instead!');
                        const maybeArray = (0, $kfOTy.makeArray)(allowedSpecsForEntity[0]);
                        const allowedSpecsForChild = maybeArray.filter((item)=>(Array.isArray(item) ? item[0] : item) === child.type);
                        if (allowedSpecsForChild.length === 0) return $96effbef339de82e$var$invalidChildContent(child, errorCallback, validatorSpec);
                        /**
						 * When there's multiple possible branches try all of them.
						 * If all of them fails, throw the first one.
						 * e.g.- [['text', { marks: ['a'] }], ['text', { marks: ['b'] }]]
						 */ let firstError;
                        let firstChild;
                        for(let i = 0, len = allowedSpecsForChild.length; i < len; i++)try {
                            const allowedValueForCurrentSpec = [
                                allowedSpecsForChild[i]
                            ];
                            const { valid: valid, entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, allowedValueForCurrentSpec, validatorSpec);
                            if (valid) {
                                const isLastValidationSpec = i === allowedSpecsForChild.length - 1;
                                const { valid: marksAreValid, entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, isLastValidationSpec);
                                const unsupportedMarks = entity && entity.marks && entity.marks.filter((mark)=>mark.type === 'unsupportedMark') || [];
                                if (marksAreValid && !unsupportedMarks.length) return entity;
                                else firstChild = firstChild || newChildEntity;
                            } else firstChild = firstChild || newChildEntity;
                        } catch (error) {
                            firstError = firstError || error;
                        }
                        if (!errorCallback) throw firstError;
                        else return firstChild;
                    } else return $96effbef339de82e$var$invalidChildContent(child, errorCallback, validatorSpec);
                };
                newEntity.content = prevEntity.content.map(validateChildNode).filter(Boolean);
            } else if (!contentValidatorSpec.optional) return {
                hasValidated: true,
                result: err('MISSING_PROPERTIES', 'missing `content` prop')
            };
        }
        // Marks
        if (prevEntity.marks) return {
            hasValidated: true,
            result: marksValidationFor(validatorSpec, prevEntity, errorCallback, newEntity, err)
        };
        return specBasedValidationResult;
    }
}

});
parcelRegister("l7cdi", function(module, exports) {
$parcel$export(module.exports, "alignment", () => (parcelRequire("aio1x")).alignment);
$parcel$export(module.exports, "annotation", () => (parcelRequire("aio1x")).annotation);
$parcel$export(module.exports, "backgroundColor", () => (parcelRequire("aio1x")).backgroundColor);
$parcel$export(module.exports, "blockCard", () => (parcelRequire("aio1x")).blockCard);
$parcel$export(module.exports, "block_content", () => (parcelRequire("aio1x")).block_content);
$parcel$export(module.exports, "blockRootOnly", () => (parcelRequire("aio1x")).blockRootOnly);
$parcel$export(module.exports, "blockquote", () => (parcelRequire("aio1x")).blockquote);
$parcel$export(module.exports, "blockTaskItem", () => (parcelRequire("aio1x")).blockTaskItem);
$parcel$export(module.exports, "bodiedExtension", () => (parcelRequire("aio1x")).bodiedExtension);
$parcel$export(module.exports, "bodiedExtension_with_marks", () => (parcelRequire("aio1x")).bodiedExtension_with_marks);
$parcel$export(module.exports, "border", () => (parcelRequire("aio1x")).border);
$parcel$export(module.exports, "breakout", () => (parcelRequire("aio1x")).breakout);
$parcel$export(module.exports, "bulletList", () => (parcelRequire("aio1x")).bulletList);
$parcel$export(module.exports, "caption", () => (parcelRequire("aio1x")).caption);
$parcel$export(module.exports, "code", () => (parcelRequire("aio1x")).code);
$parcel$export(module.exports, "codeBlock", () => (parcelRequire("aio1x")).codeBlock);
$parcel$export(module.exports, "codeBlock_root_only", () => (parcelRequire("aio1x")).codeBlock_root_only);
$parcel$export(module.exports, "text_with_no_marks", () => (parcelRequire("aio1x")).text_with_no_marks);
$parcel$export(module.exports, "confluenceInlineComment", () => (parcelRequire("aio1x")).confluenceInlineComment);
$parcel$export(module.exports, "dataConsumer", () => (parcelRequire("aio1x")).dataConsumer);
$parcel$export(module.exports, "date", () => (parcelRequire("aio1x")).date);
$parcel$export(module.exports, "decisionItem", () => (parcelRequire("aio1x")).decisionItem);
$parcel$export(module.exports, "decisionList", () => (parcelRequire("aio1x")).decisionList);
$parcel$export(module.exports, "doc", () => (parcelRequire("aio1x")).doc);
$parcel$export(module.exports, "em", () => (parcelRequire("aio1x")).em);
$parcel$export(module.exports, "embedCard", () => (parcelRequire("aio1x")).embedCard);
$parcel$export(module.exports, "emoji", () => (parcelRequire("aio1x")).emoji);
$parcel$export(module.exports, "expand", () => (parcelRequire("aio1x")).expand);
$parcel$export(module.exports, "expand_root_only", () => (parcelRequire("aio1x")).expand_root_only);
$parcel$export(module.exports, "extension", () => (parcelRequire("aio1x")).extension);
$parcel$export(module.exports, "extensionFrame", () => (parcelRequire("aio1x")).extensionFrame);
$parcel$export(module.exports, "extension_with_marks", () => (parcelRequire("aio1x")).extension_with_marks);
$parcel$export(module.exports, "fragment", () => (parcelRequire("aio1x")).fragment);
$parcel$export(module.exports, "hardBreak", () => (parcelRequire("aio1x")).hardBreak);
$parcel$export(module.exports, "heading", () => (parcelRequire("aio1x")).heading);
$parcel$export(module.exports, "heading_with_alignment", () => (parcelRequire("aio1x")).heading_with_alignment);
$parcel$export(module.exports, "heading_with_indentation", () => (parcelRequire("aio1x")).heading_with_indentation);
$parcel$export(module.exports, "heading_with_no_marks", () => (parcelRequire("aio1x")).heading_with_no_marks);
$parcel$export(module.exports, "indentation", () => (parcelRequire("aio1x")).indentation);
$parcel$export(module.exports, "inlineCard", () => (parcelRequire("aio1x")).inlineCard);
$parcel$export(module.exports, "inlineExtension", () => (parcelRequire("aio1x")).inlineExtension);
$parcel$export(module.exports, "inlineExtension_with_marks", () => (parcelRequire("aio1x")).inlineExtension_with_marks);
$parcel$export(module.exports, "inline_content", () => (parcelRequire("aio1x")).inline_content);
$parcel$export(module.exports, "layoutColumn", () => (parcelRequire("aio1x")).layoutColumn);
$parcel$export(module.exports, "layoutSection", () => (parcelRequire("aio1x")).layoutSection);
$parcel$export(module.exports, "layoutSection_full", () => (parcelRequire("aio1x")).layoutSection_full);
$parcel$export(module.exports, "layoutSection_with_single_column", () => (parcelRequire("aio1x")).layoutSection_with_single_column);
$parcel$export(module.exports, "link", () => (parcelRequire("aio1x")).link);
$parcel$export(module.exports, "listItem", () => (parcelRequire("aio1x")).listItem);
$parcel$export(module.exports, "media", () => (parcelRequire("aio1x")).media);
$parcel$export(module.exports, "mediaGroup", () => (parcelRequire("aio1x")).mediaGroup);
$parcel$export(module.exports, "mediaInline", () => (parcelRequire("aio1x")).mediaInline);
$parcel$export(module.exports, "mediaSingle", () => (parcelRequire("aio1x")).mediaSingle);
$parcel$export(module.exports, "mediaSingle_caption", () => (parcelRequire("aio1x")).mediaSingle_caption);
$parcel$export(module.exports, "mediaSingle_full", () => (parcelRequire("aio1x")).mediaSingle_full);
$parcel$export(module.exports, "mention", () => (parcelRequire("aio1x")).mention);
$parcel$export(module.exports, "multiBodiedExtension", () => (parcelRequire("aio1x")).multiBodiedExtension);
$parcel$export(module.exports, "nestedExpand", () => (parcelRequire("aio1x")).nestedExpand);
$parcel$export(module.exports, "nestedExpand_content", () => (parcelRequire("aio1x")).nestedExpand_content);
$parcel$export(module.exports, "nestedExpand_with_no_marks", () => (parcelRequire("aio1x")).nestedExpand_with_no_marks);
$parcel$export(module.exports, "non_nestable_block_content", () => (parcelRequire("aio1x")).non_nestable_block_content);
$parcel$export(module.exports, "orderedList", () => (parcelRequire("aio1x")).orderedList);
$parcel$export(module.exports, "panel", () => (parcelRequire("aio1x")).panel);
$parcel$export(module.exports, "paragraph", () => (parcelRequire("aio1x")).paragraph);
$parcel$export(module.exports, "paragraph_with_alignment", () => (parcelRequire("aio1x")).paragraph_with_alignment);
$parcel$export(module.exports, "paragraph_with_indentation", () => (parcelRequire("aio1x")).paragraph_with_indentation);
$parcel$export(module.exports, "paragraph_with_no_marks", () => (parcelRequire("aio1x")).paragraph_with_no_marks);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("aio1x")).placeholder);
$parcel$export(module.exports, "rule", () => (parcelRequire("aio1x")).rule);
$parcel$export(module.exports, "status", () => (parcelRequire("aio1x")).status);
$parcel$export(module.exports, "strike", () => (parcelRequire("aio1x")).strike);
$parcel$export(module.exports, "strong", () => (parcelRequire("aio1x")).strong);
$parcel$export(module.exports, "subsup", () => (parcelRequire("aio1x")).subsup);
$parcel$export(module.exports, "table", () => (parcelRequire("aio1x")).table);
$parcel$export(module.exports, "tableCell", () => (parcelRequire("aio1x")).tableCell);
$parcel$export(module.exports, "tableHeader", () => (parcelRequire("aio1x")).tableHeader);
$parcel$export(module.exports, "tableRow", () => (parcelRequire("aio1x")).tableRow);
$parcel$export(module.exports, "taskItem", () => (parcelRequire("aio1x")).taskItem);
$parcel$export(module.exports, "taskList", () => (parcelRequire("aio1x")).taskList);
$parcel$export(module.exports, "text", () => (parcelRequire("aio1x")).text);
$parcel$export(module.exports, "textColor", () => (parcelRequire("aio1x")).textColor);
$parcel$export(module.exports, "text_code_inline", () => (parcelRequire("aio1x")).text_code_inline);
$parcel$export(module.exports, "text_formatted", () => (parcelRequire("aio1x")).text_formatted);
$parcel$export(module.exports, "text_link_inline", () => (parcelRequire("aio1x")).text_link_inline);
$parcel$export(module.exports, "underline", () => (parcelRequire("aio1x")).underline);
$parcel$export(module.exports, "syncBlock", () => (parcelRequire("aio1x")).syncBlock);
$parcel$export(module.exports, "bodiedSyncBlock", () => (parcelRequire("aio1x")).bodiedSyncBlock);
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $aio1x = parcelRequire("aio1x");

});
parcelRegister("aio1x", function(module, exports) {
$parcel$export(module.exports, "alignment", () => $77ee386e3e14f4e0$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $77ee386e3e14f4e0$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $77ee386e3e14f4e0$export$8c5a050822fd698c);
$parcel$export(module.exports, "block_content", () => $77ee386e3e14f4e0$export$a31afb40076fa18b);
$parcel$export(module.exports, "blockCard", () => $77ee386e3e14f4e0$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $77ee386e3e14f4e0$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockRootOnly", () => $77ee386e3e14f4e0$export$ebb5393736e9ba23);
$parcel$export(module.exports, "blockTaskItem", () => $77ee386e3e14f4e0$export$16018c61064a18df);
$parcel$export(module.exports, "bodiedExtension", () => $77ee386e3e14f4e0$export$27903d543b563e39);
$parcel$export(module.exports, "bodiedExtension_with_marks", () => $77ee386e3e14f4e0$export$ee052cc5b2356e83);
$parcel$export(module.exports, "bodiedSyncBlock", () => $77ee386e3e14f4e0$export$e92c7e4302dd4371);
$parcel$export(module.exports, "border", () => $77ee386e3e14f4e0$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $77ee386e3e14f4e0$export$89015c65f1c75e3f);
$parcel$export(module.exports, "bulletList", () => $77ee386e3e14f4e0$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $77ee386e3e14f4e0$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "code", () => $77ee386e3e14f4e0$export$6565f9f03506010b);
$parcel$export(module.exports, "codeBlock", () => $77ee386e3e14f4e0$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "codeBlock_root_only", () => $77ee386e3e14f4e0$export$38d90d1aac6883a3);
$parcel$export(module.exports, "confluenceInlineComment", () => $77ee386e3e14f4e0$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $77ee386e3e14f4e0$export$3024f02c495408d6);
$parcel$export(module.exports, "date", () => $77ee386e3e14f4e0$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $77ee386e3e14f4e0$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $77ee386e3e14f4e0$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $77ee386e3e14f4e0$export$2a111da947c407d2);
$parcel$export(module.exports, "em", () => $77ee386e3e14f4e0$export$c63c6f932822f543);
$parcel$export(module.exports, "embedCard", () => $77ee386e3e14f4e0$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $77ee386e3e14f4e0$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $77ee386e3e14f4e0$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expand_root_only", () => $77ee386e3e14f4e0$export$b2817c6954dd6d2c);
$parcel$export(module.exports, "extension", () => $77ee386e3e14f4e0$export$1b45514b112dd749);
$parcel$export(module.exports, "extension_with_marks", () => $77ee386e3e14f4e0$export$15be7c145cec614a);
$parcel$export(module.exports, "extensionFrame", () => $77ee386e3e14f4e0$export$4fdcae991fd743e7);
$parcel$export(module.exports, "fragment", () => $77ee386e3e14f4e0$export$f00aeb236b6f05af);
$parcel$export(module.exports, "hardBreak", () => $77ee386e3e14f4e0$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $77ee386e3e14f4e0$export$46e4a324ac90507f);
$parcel$export(module.exports, "heading_with_alignment", () => $77ee386e3e14f4e0$export$c17edf9af655deaf);
$parcel$export(module.exports, "heading_with_indentation", () => $77ee386e3e14f4e0$export$1902f9737466a0dc);
$parcel$export(module.exports, "heading_with_no_marks", () => $77ee386e3e14f4e0$export$7b491e75f1be9278);
$parcel$export(module.exports, "indentation", () => $77ee386e3e14f4e0$export$480c699bd4ec0d86);
$parcel$export(module.exports, "inline_content", () => $77ee386e3e14f4e0$export$e23e6162adaa368d);
$parcel$export(module.exports, "inlineCard", () => $77ee386e3e14f4e0$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtension", () => $77ee386e3e14f4e0$export$16b353b2649bd8d9);
$parcel$export(module.exports, "inlineExtension_with_marks", () => $77ee386e3e14f4e0$export$e37f10815f36843d);
$parcel$export(module.exports, "layoutColumn", () => $77ee386e3e14f4e0$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $77ee386e3e14f4e0$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSection_full", () => $77ee386e3e14f4e0$export$941b63fbd931e449);
$parcel$export(module.exports, "layoutSection_with_single_column", () => $77ee386e3e14f4e0$export$e0e9834198e8601d);
$parcel$export(module.exports, "link", () => $77ee386e3e14f4e0$export$9c30223ca0a664fb);
$parcel$export(module.exports, "listItem", () => $77ee386e3e14f4e0$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "media", () => $77ee386e3e14f4e0$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $77ee386e3e14f4e0$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $77ee386e3e14f4e0$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $77ee386e3e14f4e0$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingle_caption", () => $77ee386e3e14f4e0$export$68b0ead306f9670f);
$parcel$export(module.exports, "mediaSingle_full", () => $77ee386e3e14f4e0$export$f7fd577406abd5f8);
$parcel$export(module.exports, "mention", () => $77ee386e3e14f4e0$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtension", () => $77ee386e3e14f4e0$export$c3c04d555a8b9013);
$parcel$export(module.exports, "nestedExpand", () => $77ee386e3e14f4e0$export$63cadbf5f4296627);
$parcel$export(module.exports, "nestedExpand_content", () => $77ee386e3e14f4e0$export$9584f52f3ebd5d7e);
$parcel$export(module.exports, "nestedExpand_with_no_marks", () => $77ee386e3e14f4e0$export$b756fc994eb0bc4f);
$parcel$export(module.exports, "non_nestable_block_content", () => $77ee386e3e14f4e0$export$ed866000601e7fa5);
$parcel$export(module.exports, "orderedList", () => $77ee386e3e14f4e0$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $77ee386e3e14f4e0$export$21f42ab9b6679f44);
$parcel$export(module.exports, "paragraph", () => $77ee386e3e14f4e0$export$9c206ddddb32a9b);
$parcel$export(module.exports, "paragraph_with_alignment", () => $77ee386e3e14f4e0$export$9ca11c06877e5c64);
$parcel$export(module.exports, "paragraph_with_indentation", () => $77ee386e3e14f4e0$export$a3bd66932996fb7d);
$parcel$export(module.exports, "paragraph_with_no_marks", () => $77ee386e3e14f4e0$export$f06f75eb1e56b0c5);
$parcel$export(module.exports, "placeholder", () => $77ee386e3e14f4e0$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $77ee386e3e14f4e0$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "status", () => $77ee386e3e14f4e0$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "strike", () => $77ee386e3e14f4e0$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $77ee386e3e14f4e0$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $77ee386e3e14f4e0$export$b3401ee80eb31041);
$parcel$export(module.exports, "syncBlock", () => $77ee386e3e14f4e0$export$faab0ca9701d7048);
$parcel$export(module.exports, "table", () => $77ee386e3e14f4e0$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableCell", () => $77ee386e3e14f4e0$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableHeader", () => $77ee386e3e14f4e0$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableRow", () => $77ee386e3e14f4e0$export$ce666bf02318c957);
$parcel$export(module.exports, "taskItem", () => $77ee386e3e14f4e0$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $77ee386e3e14f4e0$export$375b6afcc5f4d291);
$parcel$export(module.exports, "text", () => $77ee386e3e14f4e0$export$6f093cfa640b7166);
$parcel$export(module.exports, "text_code_inline", () => $77ee386e3e14f4e0$export$5008c13f04d544f6);
$parcel$export(module.exports, "text_formatted", () => $77ee386e3e14f4e0$export$d24a7becb4e0da7c);
$parcel$export(module.exports, "text_link_inline", () => $77ee386e3e14f4e0$export$2a9d18d5b3064e6c);
$parcel$export(module.exports, "text_with_no_marks", () => $77ee386e3e14f4e0$export$437a3d96346717e0);
$parcel$export(module.exports, "textColor", () => $77ee386e3e14f4e0$export$32f78bffcd82ff28);
$parcel$export(module.exports, "underline", () => $77ee386e3e14f4e0$export$425327af25286e5e);
const $77ee386e3e14f4e0$export$8e53000a4ec837 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'alignment'
            ]
        },
        attrs: {
            props: {
                align: {
                    type: 'enum',
                    values: [
                        'center',
                        'end'
                    ]
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$8512c9afa7b24c3b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'annotation'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                annotationType: {
                    type: 'enum',
                    values: [
                        'inlineComment'
                    ]
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$8c5a050822fd698c = {
    props: {
        type: {
            type: 'enum',
            values: [
                'backgroundColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$a31afb40076fa18b = [
    'blockCard',
    'paragraph_with_no_marks',
    'paragraph_with_alignment',
    'paragraph_with_indentation',
    'mediaSingle_caption',
    'mediaSingle_full',
    'codeBlock',
    'taskList',
    'bulletList',
    'orderedList',
    'heading_with_no_marks',
    'heading_with_alignment',
    'heading_with_indentation',
    'mediaGroup',
    'decisionList',
    'rule',
    'panel',
    'blockquote',
    'extension_with_marks',
    'embedCard',
    'table',
    'expand',
    'bodiedExtension_with_marks'
];
const $77ee386e3e14f4e0$export$c4c2f833baaebdb8 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockCard'
            ]
        },
        attrs: [
            {
                props: {
                    localId: {
                        type: 'string',
                        optional: true
                    },
                    url: {
                        type: 'string',
                        optional: true,
                        validatorFn: 'safeUrl'
                    },
                    datasource: {
                        props: {
                            id: {
                                type: 'string'
                            },
                            parameters: {
                                type: 'object'
                            },
                            views: {
                                items: [
                                    {
                                        props: {
                                            properties: {
                                                optional: true,
                                                type: 'object'
                                            },
                                            type: {
                                                type: 'string'
                                            }
                                        }
                                    }
                                ],
                                minItems: 1,
                                type: 'array'
                            }
                        }
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    }
                }
            }
        ]
    },
    required: [
        'attrs'
    ]
};
const $77ee386e3e14f4e0$export$67dc04e652a298ca = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockquote'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'orderedList',
                    'bulletList',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $77ee386e3e14f4e0$export$ebb5393736e9ba23 = [
    'multiBodiedExtension'
];
const $77ee386e3e14f4e0$export$16018c61064a18df = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockTaskItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'extension_with_marks'
                ],
                [
                    'paragraph_with_no_marks',
                    'extension_with_marks'
                ]
            ],
            minItems: 1
        }
    }
};
const $77ee386e3e14f4e0$export$27903d543b563e39 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'non_nestable_block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $77ee386e3e14f4e0$export$ee052cc5b2356e83 = [
    'bodiedExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$e92c7e4302dd4371 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bodiedSyncBlock'
            ]
        },
        attrs: {
            props: {
                resourceId: {
                    type: 'string'
                },
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'paragraph_with_no_marks',
                    'blockCard',
                    'blockquote',
                    'bulletList',
                    'codeBlock',
                    'decisionList',
                    'embedCard',
                    'expand',
                    'heading',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'heading_with_no_marks',
                    'layoutSection',
                    'mediaGroup',
                    'mediaSingle',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaSingle_width_type',
                    'orderedList',
                    'panel',
                    'rule',
                    'table',
                    'taskList'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'breakout'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$1edee58a52776cd9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'border'
            ]
        },
        attrs: {
            props: {
                size: {
                    type: 'number',
                    minimum: 1,
                    maximum: 3
                },
                color: {
                    pattern: '^#[0-9a-fA-F]{8}$|^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$89015c65f1c75e3f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'breakout'
            ]
        },
        attrs: {
            props: {
                mode: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width'
                    ]
                },
                width: {
                    type: 'number',
                    optional: true
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$a140c94e5ea26bee = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bulletList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'listItem',
                    'listItem_with_nested_decision'
                ]
            ],
            minItems: 1
        }
    }
};
const $77ee386e3e14f4e0$export$8e3c2dfdc4f0453d = {
    props: {
        type: {
            type: 'enum',
            values: [
                'caption'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'hardBreak',
                    'mention',
                    'emoji',
                    'date',
                    'placeholder',
                    'inlineCard',
                    'status',
                    'text_formatted',
                    'text_code_inline'
                ]
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $77ee386e3e14f4e0$export$6565f9f03506010b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'code'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$7bb0d5c671655cc4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'codeBlock'
            ]
        },
        attrs: {
            props: {
                language: {
                    type: 'string',
                    optional: true
                },
                uniqueId: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'text_with_no_marks'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $77ee386e3e14f4e0$export$38d90d1aac6883a3 = [
    'codeBlock',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$f3b72f8fc4684ecd = {
    props: {
        type: {
            type: 'enum',
            values: [
                'confluenceInlineComment'
            ]
        },
        attrs: {
            props: {
                reference: {
                    type: 'string'
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$3024f02c495408d6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'dataConsumer'
            ]
        },
        attrs: {
            props: {
                sources: {
                    type: 'array',
                    items: [
                        {
                            type: 'string'
                        }
                    ],
                    minItems: 1
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$324d90190a8b822a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'date'
            ]
        },
        attrs: {
            props: {
                timestamp: {
                    minLength: 1,
                    type: 'string'
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$6959e16eeff859b4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $77ee386e3e14f4e0$export$62d45a65fb43d95e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'decisionItem'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $77ee386e3e14f4e0$export$2a111da947c407d2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'doc'
            ]
        },
        version: {
            type: 'enum',
            values: [
                1
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'blockCard',
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'bulletList',
                    'orderedList',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'mediaGroup',
                    'decisionList',
                    'rule',
                    'panel',
                    'blockquote',
                    'extension_with_marks',
                    'embedCard',
                    'table',
                    'expand',
                    'bodiedExtension_with_marks',
                    'codeBlock_root_only',
                    'layoutSection_with_single_column',
                    'layoutSection_full',
                    'multiBodiedExtension',
                    'expand_root_only',
                    'syncBlock',
                    'bodiedSyncBlock'
                ]
            ],
            allowUnsupportedBlock: true
        }
    }
};
const $77ee386e3e14f4e0$export$c63c6f932822f543 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'em'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$be4283d9a1cb1ff6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'embedCard'
            ]
        },
        attrs: {
            props: {
                url: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'wrap-right',
                        'wrap-left',
                        'align-end',
                        'align-start'
                    ]
                },
                width: {
                    type: 'number',
                    maximum: 100,
                    minimum: 0,
                    optional: true
                },
                originalHeight: {
                    type: 'number',
                    optional: true
                },
                originalWidth: {
                    type: 'number',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$a19185d1233fc4b2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'emoji'
            ]
        },
        attrs: {
            props: {
                shortName: {
                    type: 'string'
                },
                id: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$9f77e0932fb78f72 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'expand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'decisionList',
                    'taskList',
                    'table',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $77ee386e3e14f4e0$export$b2817c6954dd6d2c = [
    'expand',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$1b45514b112dd749 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $77ee386e3e14f4e0$export$15be7c145cec614a = [
    'extension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$4fdcae991fd743e7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extensionFrame'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_full',
                    'mediaSingle_caption',
                    'decisionList',
                    'taskList',
                    'table',
                    'extension_with_marks',
                    'bodiedExtension_with_marks',
                    'blockCard',
                    'embedCard'
                ]
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'dataConsumer',
                    'fragment'
                ]
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$f00aeb236b6f05af = {
    props: {
        type: {
            type: 'enum',
            values: [
                'fragment'
            ]
        },
        attrs: {
            props: {
                localId: {
                    minLength: 1,
                    type: 'string'
                },
                name: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$371da9dd35aba193 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'hardBreak'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'enum',
                    values: [
                        '\n'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        }
    }
};
const $77ee386e3e14f4e0$export$46e4a324ac90507f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'heading'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $77ee386e3e14f4e0$export$c17edf9af655deaf = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$1902f9737466a0dc = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$7b491e75f1be9278 = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $77ee386e3e14f4e0$export$480c699bd4ec0d86 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'indentation'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$e23e6162adaa368d = [
    'text_formatted',
    'text_code_inline',
    'date',
    'emoji',
    'hardBreak',
    'inlineCard',
    'mention',
    'placeholder',
    'status',
    'inlineExtension_with_marks',
    'mediaInline'
];
const $77ee386e3e14f4e0$export$cbf8224b64e0d942 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineCard'
            ]
        },
        attrs: [
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $77ee386e3e14f4e0$export$16b353b2649bd8d9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $77ee386e3e14f4e0$export$e37f10815f36843d = [
    'inlineExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$ab76e7c03cd6f650 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutColumn'
            ]
        },
        attrs: {
            props: {
                width: {
                    type: 'number',
                    minimum: 0,
                    maximum: 100
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $77ee386e3e14f4e0$export$b3b6a70a7fa4a5be = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutSection'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'layoutColumn'
            ],
            minItems: 1,
            maxItems: 3,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'breakout'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$941b63fbd931e449 = [
    'layoutSection',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 2,
                maxItems: 3,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$e0e9834198e8601d = [
    'layoutSection',
    {
        props: {
            attrs: {
                props: {
                    columnRuleStyle: {
                        type: 'enum',
                        values: [
                            'solid'
                        ],
                        optional: true
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    }
                },
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 1,
                maxItems: 5,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$9c30223ca0a664fb = {
    props: {
        type: {
            type: 'enum',
            values: [
                'link'
            ]
        },
        attrs: {
            props: {
                href: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                title: {
                    type: 'string',
                    optional: true
                },
                id: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string',
                    optional: true
                },
                occurrenceKey: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$76c7e83ecc9cdf05 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'listItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'extension_with_marks'
                ],
                [
                    'paragraph_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'taskList',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $77ee386e3e14f4e0$export$2b82905b9aebbab0 = [
    'listItem',
    {
        props: {
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    [
                        'paragraph_with_no_marks',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'decisionList',
                        'extension_with_marks'
                    ],
                    [
                        'paragraph_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'taskList',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'decisionList',
                        'extension_with_marks'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $77ee386e3e14f4e0$export$987d49ffe1b0900f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'media'
            ]
        },
        attrs: [
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'link',
                            'file'
                        ]
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    },
                    id: {
                        minLength: 1,
                        type: 'string'
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    collection: {
                        type: 'string'
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    occurrenceKey: {
                        minLength: 1,
                        type: 'string',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    }
                }
            },
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'external'
                        ]
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    url: {
                        type: 'string'
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $77ee386e3e14f4e0$export$2855e964765eac9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaGroup'
            ]
        },
        content: {
            type: 'array',
            items: [
                'media'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $77ee386e3e14f4e0$export$38bab695e3f720f1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaInline'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'link',
                        'file',
                        'image'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                url: {
                    type: 'string',
                    optional: true
                },
                id: {
                    minLength: 1,
                    type: 'string'
                },
                alt: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string'
                },
                occurrenceKey: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                },
                height: {
                    type: 'number',
                    optional: true
                },
                data: {
                    type: 'object',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$969fe3781ca15058 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaSingle'
            ]
        },
        attrs: [
            {
                props: {
                    localId: {
                        type: 'string',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        minimum: 0,
                        maximum: 100,
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'percentage'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    localId: {
                        type: 'string',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        minimum: 0
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'pixel'
                        ]
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                'link'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$68b0ead306f9670f = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    'media',
                    'caption'
                ],
                minItems: 1,
                maxItems: 2,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $77ee386e3e14f4e0$export$f7fd577406abd5f8 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $77ee386e3e14f4e0$export$af10954ff7b86f88 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $77ee386e3e14f4e0$export$db83999c14438df4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mention'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                accessLevel: {
                    type: 'string',
                    optional: true
                },
                userType: {
                    type: 'enum',
                    values: [
                        'DEFAULT',
                        'SPECIAL',
                        'APP'
                    ],
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$c3c04d555a8b9013 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'multiBodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    type: 'string',
                    minLength: 1
                },
                extensionType: {
                    type: 'string',
                    minLength: 1
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'default',
                        'wide',
                        'full-width'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true,
                    minLength: 1
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'extensionFrame'
            ]
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $77ee386e3e14f4e0$export$63cadbf5f4296627 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'nestedExpand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: 'nestedExpand_content'
    },
    required: [
        'content'
    ]
};
const $77ee386e3e14f4e0$export$9584f52f3ebd5d7e = {
    type: 'array',
    items: [
        [
            'paragraph_with_no_marks',
            'heading_with_no_marks',
            'mediaSingle_caption',
            'mediaSingle_full',
            'mediaGroup',
            'codeBlock',
            'bulletList',
            'orderedList',
            'taskList',
            'decisionList',
            'rule',
            'panel',
            'blockquote',
            'extension_with_marks'
        ]
    ],
    minItems: 1,
    allowUnsupportedBlock: true
};
const $77ee386e3e14f4e0$export$b756fc994eb0bc4f = [
    'nestedExpand',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $77ee386e3e14f4e0$export$ed866000601e7fa5 = [
    'paragraph_with_no_marks',
    'panel',
    'blockquote',
    'orderedList',
    'bulletList',
    'rule',
    'heading_with_no_marks',
    'codeBlock',
    'mediaGroup',
    'mediaSingle_caption',
    'mediaSingle_full',
    'decisionList',
    'taskList',
    'table',
    'blockCard',
    'embedCard',
    'extension_with_marks'
];
const $77ee386e3e14f4e0$export$a5dc81035676e7a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'orderedList'
            ]
        },
        attrs: {
            props: {
                order: {
                    type: 'number',
                    minimum: 0,
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'listItem',
                    'listItem_with_nested_decision'
                ]
            ],
            minItems: 1
        }
    }
};
const $77ee386e3e14f4e0$export$21f42ab9b6679f44 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'panel'
            ]
        },
        attrs: {
            props: {
                panelType: {
                    type: 'enum',
                    values: [
                        'info',
                        'note',
                        'tip',
                        'warning',
                        'error',
                        'success',
                        'custom'
                    ]
                },
                panelIcon: {
                    type: 'string',
                    optional: true
                },
                panelIconId: {
                    type: 'string',
                    optional: true
                },
                panelIconText: {
                    type: 'string',
                    optional: true
                },
                panelColor: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'heading_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'blockCard',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'rule',
                    'decisionList',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $77ee386e3e14f4e0$export$9c206ddddb32a9b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'paragraph'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $77ee386e3e14f4e0$export$9ca11c06877e5c64 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$a3bd66932996fb7d = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$f06f75eb1e56b0c5 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $77ee386e3e14f4e0$export$c7187bbd1a7a9244 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'placeholder'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'string'
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$fbeb3a3956e8a3c7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'rule'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        }
    }
};
const $77ee386e3e14f4e0$export$471f7ae5c4103ae1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'status'
            ]
        },
        attrs: {
            props: {
                text: {
                    minLength: 1,
                    type: 'string'
                },
                color: {
                    type: 'enum',
                    values: [
                        'neutral',
                        'purple',
                        'blue',
                        'red',
                        'yellow',
                        'green'
                    ]
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                style: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$4899a95d70ec5056 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strike'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$59ae2c325a998f89 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strong'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$b3401ee80eb31041 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'subsup'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'sub',
                        'sup'
                    ]
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$faab0ca9701d7048 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'syncBlock'
            ]
        },
        attrs: {
            props: {
                resourceId: {
                    type: 'string'
                },
                localId: {
                    type: 'string'
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'breakout'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$9852986a3ec5f6a0 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'table'
            ]
        },
        attrs: {
            props: {
                displayMode: {
                    type: 'enum',
                    values: [
                        'default',
                        'fixed'
                    ],
                    optional: true
                },
                isNumberColumnEnabled: {
                    type: 'boolean',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'align-end',
                        'align-start',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    minLength: 1,
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'tableRow'
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'fragment'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$e1e720e5f4603e6a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableCell'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    },
    required: [
        'content'
    ]
};
const $77ee386e3e14f4e0$export$48884d2a5190dc73 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableHeader'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks',
                    'nestedExpand'
                ]
            ],
            minItems: 1
        }
    },
    required: [
        'content'
    ]
};
const $77ee386e3e14f4e0$export$ce666bf02318c957 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableRow'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'tableCell',
                    'tableHeader'
                ]
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$6d8b0ef52e2e6390 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $77ee386e3e14f4e0$export$375b6afcc5f4d291 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                [
                    'taskItem',
                    'blockTaskItem'
                ],
                [
                    'taskItem',
                    'taskList',
                    'blockTaskItem'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $77ee386e3e14f4e0$export$6f093cfa640b7166 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'text'
            ]
        },
        text: {
            type: 'string',
            minLength: 1
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $77ee386e3e14f4e0$export$5008c13f04d544f6 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'code',
                        'link',
                        'annotation'
                    ]
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$d24a7becb4e0da7c = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'link',
                        'em',
                        'strong',
                        'strike',
                        'subsup',
                        'underline',
                        'textColor',
                        'annotation',
                        'backgroundColor',
                        null
                    ]
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$2a9d18d5b3064e6c = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'link'
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$437a3d96346717e0 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $77ee386e3e14f4e0$export$32f78bffcd82ff28 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'textColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    type: 'string',
                    pattern: '^#[0-9a-fA-F]{6}$'
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$425327af25286e5e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'underline'
            ]
        }
    }
};

});


parcelRegister("kfOTy", function(module, exports) {
$parcel$export(module.exports, "isDefined", () => $e5985938f1ee69ed$export$4e62c701997796c1);
$parcel$export(module.exports, "isNumber", () => $e5985938f1ee69ed$export$7e4aa119212bc614);
$parcel$export(module.exports, "isInteger", () => $e5985938f1ee69ed$export$a287f47fed4544b8);
$parcel$export(module.exports, "isBoolean", () => $e5985938f1ee69ed$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "isString", () => $e5985938f1ee69ed$export$844ec244b1367d54);
$parcel$export(module.exports, "isPlainObject", () => $e5985938f1ee69ed$export$53b83ca8eaab0383);
$parcel$export(module.exports, "copy", () => $e5985938f1ee69ed$export$784d13d8ee351f07);
$parcel$export(module.exports, "makeArray", () => $e5985938f1ee69ed$export$7b85fd78dd236198);
const $e5985938f1ee69ed$export$4e62c701997796c1 = (x)=>x != null;
const $e5985938f1ee69ed$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);
const $e5985938f1ee69ed$export$a287f47fed4544b8 = (x)=>typeof x === 'number' && isFinite(x) && Math.floor(x) === x;
const $e5985938f1ee69ed$export$f9ce7b637dfbe238 = (x)=>x === true || x === false || toString.call(x) === '[object Boolean]';
const $e5985938f1ee69ed$export$844ec244b1367d54 = (s)=>typeof s === 'string' || s instanceof String;
const $e5985938f1ee69ed$export$53b83ca8eaab0383 = (x)=>typeof x === 'object' && x !== null && !Array.isArray(x);
const $e5985938f1ee69ed$export$784d13d8ee351f07 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
source, dest, key)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dest[key] = source[key];
    return dest;
};
const $e5985938f1ee69ed$export$7b85fd78dd236198 = (maybeArray)=>Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];

});

parcelRegister("eZqxv", function(module, exports) {
$parcel$export(module.exports, "validatorFnMap", () => $804f031b1e946960$export$d1b377ca77ac267d);

var $iKozC = parcelRequire("iKozC");
const $804f031b1e946960$export$d1b377ca77ac267d = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    safeUrl: (0, $iKozC.isSafeUrl)
};

});



parcelRegister("lE3K0", function(module, exports) {
$parcel$export(module.exports, "trackUnsupportedContentLevels", () => $16664e34104af16b$export$a43de96edd8d0a0);

var $dyNYh = parcelRequire("dyNYh");
var $33XK0 = parcelRequire("33XK0");

var $bMFKb = parcelRequire("bMFKb");

var $7ueoK = parcelRequire("7ueoK");
const $16664e34104af16b$var$rendersMap = {};
const $16664e34104af16b$var$processLevelsAndTrack = (item, thresholds, dispatchAnalyticsEvent)=>{
    try {
        const { severity: severity, percentage: percentage, counts: { supportedNodes: supportedNodes, unsupportedNodes: unsupportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } } = (0, $33XK0.getUnsupportedContentLevelData)(item.doc, thresholds);
        dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).RENDERER,
            attributes: {
                appearance: (0, $dyNYh.getAnalyticsAppearance)(item.appearance),
                platform: (0, $7ueoK.PLATFORM).WEB,
                unsupportedContentLevelSeverity: severity,
                unsupportedContentLevelPercentage: percentage,
                unsupportedNodesCount: unsupportedNodes,
                supportedNodesCount: supportedNodes,
                unsupportedNodeTypeCount: unsupportedNodeTypeCount
            },
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
        });
    } catch (err) {
        dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $7ueoK.PLATFORM).WEB,
                error: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
        });
    }
};
const $16664e34104af16b$var$schedule = (fn)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (typeof window.requestIdleCallback === 'function') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn);
    else setTimeout(fn, 0);
};
const $16664e34104af16b$var$DEFAULT_SAMPLING_RATE = 100;
const $16664e34104af16b$export$a43de96edd8d0a0 = (item, trackingOptions, dispatchAnalyticsEvent)=>{
    const { thresholds: thresholds, samplingRates: samplingRates } = trackingOptions;
    const appearance = item.appearance ?? 'unknown';
    if (!$16664e34104af16b$var$rendersMap[appearance]) $16664e34104af16b$var$rendersMap[appearance] = new Set();
    // bail out if already processed a render from a given renderer instance
    const didProcessRenderer = $16664e34104af16b$var$rendersMap[appearance].has(item.rendererId);
    if (didProcessRenderer) return;
    // otherwise track the render
    $16664e34104af16b$var$rendersMap[appearance].add(item.rendererId);
    const sampleRate = samplingRates && samplingRates[appearance] || $16664e34104af16b$var$DEFAULT_SAMPLING_RATE;
    // sample from the first available tracked render
    if ($16664e34104af16b$var$rendersMap[appearance].size === 1) $16664e34104af16b$var$schedule(()=>$16664e34104af16b$var$processLevelsAndTrack(item, thresholds, dispatchAnalyticsEvent));
    // cleanup/refresh tracked renders at the sampling rate
    if ($16664e34104af16b$var$rendersMap[appearance].size % sampleRate === 0) $16664e34104af16b$var$rendersMap[appearance] = new Set();
};

});
parcelRegister("33XK0", function(module, exports) {
$parcel$export(module.exports, "getUnsupportedContentLevelData", () => $5e806909aed268e6$export$484b83e0462998d);

var $0mclG = parcelRequire("0mclG");
var $5e806909aed268e6$export$6632e71a22d31bf1 = /*#__PURE__*/ function(UNSUPPORTED_CONTENT_LEVEL_SEVERITY) {
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["NORMAL"] = "normal";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["DEGRADED"] = "degraded";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["BLOCKING"] = "blocking";
    return UNSUPPORTED_CONTENT_LEVEL_SEVERITY;
}({});
const $5e806909aed268e6$export$f9f8a29778652c3e = {
    DEGRADED: 10,
    BLOCKING: 25
};
const $5e806909aed268e6$var$buildUnsupportedContentLevelThresholds = (customThresholds)=>{
    return {
        degraded: customThresholds?.degraded || $5e806909aed268e6$export$f9f8a29778652c3e.DEGRADED,
        blocking: customThresholds?.blocking || $5e806909aed268e6$export$f9f8a29778652c3e.BLOCKING
    };
};
const $5e806909aed268e6$var$countSupportedUnsupportedNodes = (validDocument)=>{
    let unsupportedNodes = 0;
    let supportedNodes = 0;
    const unsupportedNodeTypeCount = {};
    const unsupportedNodeTypes = [
        'unsupportedInline',
        'unsupportedBlock',
        'confluenceUnsupportedInline',
        'confluenceUnsupportedBlock'
    ];
    (0, $0mclG.traverse)(validDocument, {
        any: (node)=>{
            if (unsupportedNodeTypes.includes(node.type)) {
                const originalNode = node.attrs?.originalValue;
                if (originalNode) // start an independent traversal for the purpose of counting
                // unsupported content nodes (with nested children contributing towards
                // that count)
                (0, $0mclG.traverse)(originalNode, {
                    any: (unsupportedNode, parent)=>{
                        unsupportedNodes++;
                        // Count the types of unsupported nodes
                        const parentType = parent.parent?.node?.type ?? 'unknown';
                        const type = `${parentType}/${unsupportedNode?.type ?? 'unknown'}`;
                        unsupportedNodeTypeCount[type] = (unsupportedNodeTypeCount?.[type] ?? 0) + 1;
                    }
                });
                // force the parent traversal (which is counting supported content nodes)
                // to skip traversal/counting of nested children of the unsupported nodes
                return false;
            } else supportedNodes++;
        }
    });
    return {
        unsupportedNodes: unsupportedNodes,
        supportedNodes: supportedNodes,
        unsupportedNodeTypeCount: unsupportedNodeTypeCount
    };
};
const $5e806909aed268e6$var$mapUnsupportedContentLevelToSeverity = (unsupportedContentLevelPercent, thresholds)=>{
    if (thresholds.degraded <= unsupportedContentLevelPercent && unsupportedContentLevelPercent < thresholds.blocking) return "degraded";
    if (thresholds.blocking <= unsupportedContentLevelPercent) return "blocking";
    return "normal";
};
const $5e806909aed268e6$export$484b83e0462998d = (validDocument, customThresholds)=>{
    const { unsupportedNodes: unsupportedNodes, supportedNodes: supportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } = $5e806909aed268e6$var$countSupportedUnsupportedNodes(validDocument);
    const thresholds = $5e806909aed268e6$var$buildUnsupportedContentLevelThresholds(customThresholds);
    const percentage = Math.round(unsupportedNodes / (unsupportedNodes + supportedNodes) * 100);
    const severity = $5e806909aed268e6$var$mapUnsupportedContentLevelToSeverity(percentage, thresholds);
    return {
        severity: severity,
        percentage: percentage,
        counts: {
            supportedNodes: supportedNodes,
            unsupportedNodes: unsupportedNodes,
            unsupportedNodeTypeCount: unsupportedNodeTypeCount
        }
    };
};

});


parcelRegister("86V7W", function(module, exports) {
$parcel$export(module.exports, "countNodes", () => $11211b02bfd44def$export$1daf15cbaf649dad);

var $7Tt7Y = parcelRequire("7Tt7Y");
function $11211b02bfd44def$export$1daf15cbaf649dad(adfDocument) {
    return (0, $7Tt7Y.reduce)(adfDocument, (acc, node)=>{
        acc[node.type] = (acc[node.type] || 0) + 1;
        return acc;
    }, {});
}

});
parcelRegister("7Tt7Y", function(module, exports) {
$parcel$export(module.exports, "reduce", () => $a7e2059b80756531$export$533b26079ad0b4b);

var $0mclG = parcelRequire("0mclG");
function $a7e2059b80756531$export$533b26079ad0b4b(adf, callback, initial) {
    let result = initial;
    (0, $0mclG.traverse)(adf, {
        any: (node)=>{
            result = callback(result, node);
        }
    });
    return result;
}

});



parcelRegister("4SRvD", function(module, exports) {
$parcel$export(module.exports, "EditorMediaClientProvider", () => $178829c31cb74d12$export$77218b6ff680865f);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aRuva = parcelRequire("aRuva");
var $93R6D = parcelRequire("93R6D");

var $6Ramj = parcelRequire("6Ramj");
const $178829c31cb74d12$export$77218b6ff680865f = ({ children: children, ssr: ssr })=>{
    const [mediaClientConfig, setMediaClientConfig] = (0, $eJOHy.useState)();
    const mediaProvider = (0, $6Ramj.useProviderLayout)('mediaProvider');
    /**
	 * If a mediaClientConfig is provided then we will force
	 * skip the mediaClient from context
	 */ const shouldSkipContext = Boolean(ssr?.config || mediaProvider);
    const contextMediaClient = (0, $eJOHy.useContext)((0, $93R6D.MediaClientContext));
    // MediaClientProvider currently requires a mediaClientConfig
    // And inserting the MediaClientProvider will cause a re-render
    // We should use MediaClientProvider once it no longer requires a config
    const mediaClient = (0, $eJOHy.useMemo)(()=>mediaClientConfig ? (0, $aRuva.getMediaClient)(mediaClientConfig) : undefined, [
        mediaClientConfig
    ]);
    // Consumers can override the mediaClient for renderer,
    // by not providing both SSR config and mediaProvider,
    // and provide a top level mediaClient context
    // This is useful for testing and creating examples.
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (ssr?.config) setMediaClientConfig(ssr.config);
        else if (mediaProvider) mediaProvider.then((provider)=>{
            setMediaClientConfig(provider.viewMediaClientConfig);
        });
    }, [
        mediaProvider,
        ssr
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $93R6D.MediaClientContext).Provider, {
        value: shouldSkipContext ? mediaClient : contextMediaClient,
        children: children
    });
};

});
parcelRegister("aRuva", function(module, exports) {
$parcel$export(module.exports, "getMediaClient", () => $3430d7925e0b0890$export$c9ecbc1b719fd417);

var $e33YM = parcelRequire("e33YM");
const $3430d7925e0b0890$export$f92e83e86b03c398 = new Map();
const $3430d7925e0b0890$export$c9ecbc1b719fd417 = (mediaClientConfig)=>{
    // The Provider defines mediaClientConfig as required,
    // but integrators may skip it when using Media Card to display external images
    // i.e. a Media Client is not needed.
    // An empty mediaClientConfig object `{}` won't fall into this case,
    // but that case is handled internally by Media Client.
    if (!mediaClientConfig) return new (0, $e33YM.MediaClient)({
        authProvider: ()=>Promise.resolve({
                clientId: '',
                token: '',
                baseUrl: ''
            })
    });
    let mediaClient = $3430d7925e0b0890$export$f92e83e86b03c398.get(mediaClientConfig);
    if (!mediaClient) {
        mediaClient = new (0, $e33YM.MediaClient)(mediaClientConfig);
        $3430d7925e0b0890$export$f92e83e86b03c398.set(mediaClientConfig, mediaClient);
    }
    return mediaClient;
};

});
parcelRegister("e33YM", function(module, exports) {
$parcel$export(module.exports, "MediaClient", () => $4ee615cd17ba35c7$export$fba8b4ca6d386aec);

var $adK77 = parcelRequire("adK77");
parcelRequire("1jG9B");
var $9t1Mu = parcelRequire("9t1Mu");

var $jkwTu = parcelRequire("jkwTu");

var $iPHIU = parcelRequire("iPHIU");

var $gWavf = parcelRequire("gWavf");
parcelRequire("48hWz");
var $1ZNSP = parcelRequire("1ZNSP");

class $4ee615cd17ba35c7$export$fba8b4ca6d386aec {
    constructor(mediaClientConfig, store = (0, $1ZNSP.mediaStore), mediaApi){
        this.mediaClientConfig = mediaClientConfig;
        this.store = store;
        this.mediaStore = mediaApi ?? new (0, $jkwTu.MediaStore)({
            authProvider: mediaClientConfig.authProvider,
            initialAuth: mediaClientConfig.initialAuth,
            chunkHashAlgorithm: (0, $9t1Mu.ChunkHashAlgorithm).Sha256,
            authProviderTimeout: mediaClientConfig.authProviderTimeoutMs
        });
        this.config = mediaClientConfig;
        this.file = new (0, $iPHIU.FileFetcherImpl)(this.mediaStore, this.store);
        this.eventEmitter = new (0, $adK77.EventEmitter2)();
        this.stargate = new (0, $gWavf.StargateClient)(mediaClientConfig.stargateBaseUrl);
    }
    /**
	 * @internal
	 */ __DO_NOT_USE__getMediaStore() {
        return this.store;
    }
    getImage(id, params, controller, fetchMaxRes, traceContext) {
        return this.mediaStore.getImage(id, params, controller, fetchMaxRes, traceContext);
    }
    getImageUrl(id, params) {
        return this.mediaStore.getFileImageURL(id, params);
    }
    getImageUrlSync(id, params) {
        return this.mediaStore.getFileImageURLSync(id, params);
    }
    async getImageMetadata(id, params) {
        return (await this.mediaStore.getImageMetadata(id, params)).metadata;
    }
    async mobileUploadPromise() {
        if (this.mobileUpload) return this.mobileUpload;
        const module = await (parcelRequire("921Bq"));
        this.mobileUpload = new module.MobileUploadImpl(this.mediaStore, this.store);
        return this.mobileUpload;
    }
    async removeFileFromCollection(id, collectionName, occurrenceKey, traceContext) {
        await this.mediaStore.removeCollectionFile(id, collectionName, occurrenceKey, traceContext);
    }
    on(event, listener) {
        this.eventEmitter.on(event, listener);
    }
    off(event, listener) {
        this.eventEmitter.off(event, listener);
    }
    emit(event, payload) {
        return this.eventEmitter.emit(event, payload);
    }
}

});
parcelRegister("adK77", function(module, exports) {

var $igDjg = parcelRequire("igDjg");
!function(undefined) {
    var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    var defaultMaxListeners = 10;
    function init() {
        this._events = {};
        if (this._conf) configure.call(this, this._conf);
    }
    function configure(conf) {
        if (conf) {
            this._conf = conf;
            conf.delimiter && (this.delimiter = conf.delimiter);
            this._maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
            conf.wildcard && (this.wildcard = conf.wildcard);
            conf.newListener && (this.newListener = conf.newListener);
            conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
            if (this.wildcard) this.listenerTree = {};
        } else this._maxListeners = defaultMaxListeners;
    }
    function logPossibleMemoryLeak(count, eventName) {
        var errorMsg = "(node) warning: possible EventEmitter memory leak detected. " + count + ' listeners added. ' + 'Use emitter.setMaxListeners() to increase limit.';
        if (this.verboseMemoryLeak) errorMsg += ' Event name: ' + eventName + '.';
        if (typeof $igDjg !== 'undefined' && $igDjg.emitWarning) {
            var e = new Error(errorMsg);
            e.name = 'MaxListenersExceededWarning';
            e.emitter = this;
            e.count = count;
            $igDjg.emitWarning(e);
        } else {
            console.error(errorMsg);
            if (console.trace) console.trace();
        }
    }
    function EventEmitter(conf) {
        this._events = {};
        this.newListener = false;
        this.verboseMemoryLeak = false;
        configure.call(this, conf);
    }
    EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
    //
    // Attention, function return type now is array, always !
    // It has zero elements if no any matches found and one or more
    // elements (leafs) if there are matches
    //
    function searchListenerTree(handlers, type, tree, i) {
        if (!tree) return [];
        var listeners = [], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached, typeLength = type.length, currentType = type[i], nextType = type[i + 1];
        if (i === typeLength && tree._listeners) {
            //
            // If at the end of the event(s) list and the tree has listeners
            // invoke those listeners.
            //
            if (typeof tree._listeners === 'function') {
                handlers && handlers.push(tree._listeners);
                return [
                    tree
                ];
            } else {
                for(leaf = 0, len = tree._listeners.length; leaf < len; leaf++)handlers && handlers.push(tree._listeners[leaf]);
                return [
                    tree
                ];
            }
        }
        if (currentType === '*' || currentType === '**' || tree[currentType]) {
            //
            // If the event emitted is '*' at this part
            // or there is a concrete match at this patch
            //
            if (currentType === '*') {
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 1));
                return listeners;
            } else if (currentType === '**') {
                endReached = i + 1 === typeLength || i + 2 === typeLength && nextType === '*';
                if (endReached && tree._listeners) // The next element has a _listeners, add it to the handlers.
                listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
                    if (branch === '*' || branch === '**') {
                        if (tree[branch]._listeners && !endReached) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                        listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                    } else if (branch === nextType) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 2));
                    else // No match on this one, shift into the tree but not in the type array.
                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                }
                return listeners;
            }
            listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i + 1));
        }
        xTree = tree['*'];
        if (xTree) //
        // If the listener tree will allow any match for this part,
        // then recursively explore all branches of the tree
        //
        searchListenerTree(handlers, type, xTree, i + 1);
        xxTree = tree['**'];
        if (xxTree) {
            if (i < typeLength) {
                if (xxTree._listeners) // If we have a listener on a '**', it will catch all, so add its handler.
                searchListenerTree(handlers, type, xxTree, typeLength);
                // Build arrays of matching next branches and others.
                for(branch in xxTree)if (branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
                    if (branch === nextType) // We know the next element will match, so jump twice.
                    searchListenerTree(handlers, type, xxTree[branch], i + 2);
                    else if (branch === currentType) // Current node matches, move into the tree.
                    searchListenerTree(handlers, type, xxTree[branch], i + 1);
                    else {
                        isolatedBranch = {};
                        isolatedBranch[branch] = xxTree[branch];
                        searchListenerTree(handlers, type, {
                            '**': isolatedBranch
                        }, i + 1);
                    }
                }
            } else if (xxTree._listeners) // We have reached the end and still on a '**'
            searchListenerTree(handlers, type, xxTree, typeLength);
            else if (xxTree['*'] && xxTree['*']._listeners) searchListenerTree(handlers, type, xxTree['*'], typeLength);
        }
        return listeners;
    }
    function growListenerTree(type, listener) {
        type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
        //
        // Looks for two consecutive '**', if so, don't add the event at all.
        //
        for(var i = 0, len = type.length; i + 1 < len; i++){
            if (type[i] === '**' && type[i + 1] === '**') return;
        }
        var tree = this.listenerTree;
        var name = type.shift();
        while(name !== undefined){
            if (!tree[name]) tree[name] = {};
            tree = tree[name];
            if (type.length === 0) {
                if (!tree._listeners) tree._listeners = listener;
                else {
                    if (typeof tree._listeners === 'function') tree._listeners = [
                        tree._listeners
                    ];
                    tree._listeners.push(listener);
                    if (!tree._listeners.warned && this._maxListeners > 0 && tree._listeners.length > this._maxListeners) {
                        tree._listeners.warned = true;
                        logPossibleMemoryLeak.call(this, tree._listeners.length, name);
                    }
                }
                return true;
            }
            name = type.shift();
        }
        return true;
    }
    // By default EventEmitters will print a warning if more than
    // 10 listeners are added to it. This is a useful default which
    // helps finding memory leaks.
    //
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.delimiter = '.';
    EventEmitter.prototype.setMaxListeners = function(n) {
        if (n !== undefined) {
            this._maxListeners = n;
            if (!this._conf) this._conf = {};
            this._conf.maxListeners = n;
        }
    };
    EventEmitter.prototype.event = '';
    EventEmitter.prototype.once = function(event, fn) {
        return this._once(event, fn, false);
    };
    EventEmitter.prototype.prependOnceListener = function(event, fn) {
        return this._once(event, fn, true);
    };
    EventEmitter.prototype._once = function(event, fn, prepend) {
        this._many(event, 1, fn, prepend);
        return this;
    };
    EventEmitter.prototype.many = function(event, ttl, fn) {
        return this._many(event, ttl, fn, false);
    };
    EventEmitter.prototype.prependMany = function(event, ttl, fn) {
        return this._many(event, ttl, fn, true);
    };
    EventEmitter.prototype._many = function(event, ttl, fn, prepend) {
        var self = this;
        if (typeof fn !== 'function') throw new Error('many only accepts instances of Function');
        function listener() {
            if (--ttl === 0) self.off(event, listener);
            return fn.apply(this, arguments);
        }
        listener._origin = fn;
        this._on(event, listener, prepend);
        return self;
    };
    EventEmitter.prototype.emit = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return false;
        }
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all && this._all.length) {
            handler = this._all.slice();
            if (al > 3) {
                args = new Array(al);
                for(j = 0; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this, type);
                        break;
                    case 2:
                        handler[i].call(this, type, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, type, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else {
            handler = this._events[type];
            if (typeof handler === 'function') {
                this.event = type;
                switch(al){
                    case 1:
                        handler.call(this);
                        break;
                    case 2:
                        handler.call(this, arguments[1]);
                        break;
                    case 3:
                        handler.call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        args = new Array(al - 1);
                        for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                        handler.apply(this, args);
                }
                return true;
            } else if (handler) // need to make copy of handlers because list can change in the middle
            // of emit call
            handler = handler.slice();
        }
        if (handler && handler.length) {
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this);
                        break;
                    case 2:
                        handler[i].call(this, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
            return true;
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) throw arguments[1]; // Unhandled 'error' event
            else throw new Error("Uncaught, unspecified 'error' event.");
            return false;
        }
        return !!this._all;
    };
    EventEmitter.prototype.emitAsync = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return Promise.resolve([
                false
            ]);
        }
        var promises = [];
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all) {
            if (al > 3) {
                args = new Array(al);
                for(j = 1; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = this._all.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(this._all[i].call(this, type));
                        break;
                    case 2:
                        promises.push(this._all[i].call(this, type, arguments[1]));
                        break;
                    case 3:
                        promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(this._all[i].apply(this, args));
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else handler = this._events[type];
        if (typeof handler === 'function') {
            this.event = type;
            switch(al){
                case 1:
                    promises.push(handler.call(this));
                    break;
                case 2:
                    promises.push(handler.call(this, arguments[1]));
                    break;
                case 3:
                    promises.push(handler.call(this, arguments[1], arguments[2]));
                    break;
                default:
                    args = new Array(al - 1);
                    for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                    promises.push(handler.apply(this, args));
            }
        } else if (handler && handler.length) {
            handler = handler.slice();
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(handler[i].call(this));
                        break;
                    case 2:
                        promises.push(handler[i].call(this, arguments[1]));
                        break;
                    case 3:
                        promises.push(handler[i].call(this, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(handler[i].apply(this, args));
                }
            }
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) return Promise.reject(arguments[1]); // Unhandled 'error' event
            else return Promise.reject("Uncaught, unspecified 'error' event.");
        }
        return Promise.all(promises);
    };
    EventEmitter.prototype.on = function(type, listener) {
        return this._on(type, listener, false);
    };
    EventEmitter.prototype.prependListener = function(type, listener) {
        return this._on(type, listener, true);
    };
    EventEmitter.prototype.onAny = function(fn) {
        return this._onAny(fn, false);
    };
    EventEmitter.prototype.prependAny = function(fn) {
        return this._onAny(fn, true);
    };
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    EventEmitter.prototype._onAny = function(fn, prepend) {
        if (typeof fn !== 'function') throw new Error('onAny only accepts instances of Function');
        if (!this._all) this._all = [];
        // Add the function to the event listener collection.
        if (prepend) this._all.unshift(fn);
        else this._all.push(fn);
        return this;
    };
    EventEmitter.prototype._on = function(type, listener, prepend) {
        if (typeof type === 'function') {
            this._onAny(type, listener);
            return this;
        }
        if (typeof listener !== 'function') throw new Error('on only accepts instances of Function');
        this._events || init.call(this);
        // To avoid recursion in the case that type == "newListeners"! Before
        // adding it to the listeners, first emit "newListeners".
        this.emit('newListener', type, listener);
        if (this.wildcard) {
            growListenerTree.call(this, type, listener);
            return this;
        }
        if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
        this._events[type] = listener;
        else {
            if (typeof this._events[type] === 'function') // Change to array.
            this._events[type] = [
                this._events[type]
            ];
            // If we've already got an array, just add
            if (prepend) this._events[type].unshift(listener);
            else this._events[type].push(listener);
            // Check for listener leak
            if (!this._events[type].warned && this._maxListeners > 0 && this._events[type].length > this._maxListeners) {
                this._events[type].warned = true;
                logPossibleMemoryLeak.call(this, this._events[type].length, type);
            }
        }
        return this;
    };
    EventEmitter.prototype.off = function(type, listener) {
        if (typeof listener !== 'function') throw new Error('removeListener only takes instances of Function');
        var handlers, leafs = [];
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
        } else {
            // does not use listeners(), so no side effect of creating _events[type]
            if (!this._events[type]) return this;
            handlers = this._events[type];
            leafs.push({
                _listeners: handlers
            });
        }
        for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
            var leaf = leafs[iLeaf];
            handlers = leaf._listeners;
            if (isArray(handlers)) {
                var position = -1;
                for(var i = 0, length = handlers.length; i < length; i++)if (handlers[i] === listener || handlers[i].listener && handlers[i].listener === listener || handlers[i]._origin && handlers[i]._origin === listener) {
                    position = i;
                    break;
                }
                if (position < 0) continue;
                if (this.wildcard) leaf._listeners.splice(position, 1);
                else this._events[type].splice(position, 1);
                if (handlers.length === 0) {
                    if (this.wildcard) delete leaf._listeners;
                    else delete this._events[type];
                }
                this.emit("removeListener", type, listener);
                return this;
            } else if (handlers === listener || handlers.listener && handlers.listener === listener || handlers._origin && handlers._origin === listener) {
                if (this.wildcard) delete leaf._listeners;
                else delete this._events[type];
                this.emit("removeListener", type, listener);
            }
        }
        function recursivelyGarbageCollect(root) {
            if (root === undefined) return;
            var keys = Object.keys(root);
            for(var i in keys){
                var key = keys[i];
                var obj = root[key];
                if (obj instanceof Function || typeof obj !== "object" || obj === null) continue;
                if (Object.keys(obj).length > 0) recursivelyGarbageCollect(root[key]);
                if (Object.keys(obj).length === 0) delete root[key];
            }
        }
        recursivelyGarbageCollect(this.listenerTree);
        return this;
    };
    EventEmitter.prototype.offAny = function(fn) {
        var i = 0, l = 0, fns;
        if (fn && this._all && this._all.length > 0) {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)if (fn === fns[i]) {
                fns.splice(i, 1);
                this.emit("removeListenerAny", fn);
                return this;
            }
        } else {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)this.emit("removeListenerAny", fns[i]);
            this._all = [];
        }
        return this;
    };
    EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
    EventEmitter.prototype.removeAllListeners = function(type) {
        if (arguments.length === 0) {
            !this._events || init.call(this);
            return this;
        }
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
            for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
                var leaf = leafs[iLeaf];
                leaf._listeners = null;
            }
        } else if (this._events) this._events[type] = null;
        return this;
    };
    EventEmitter.prototype.listeners = function(type) {
        if (this.wildcard) {
            var handlers = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
            return handlers;
        }
        this._events || init.call(this);
        if (!this._events[type]) this._events[type] = [];
        if (!isArray(this._events[type])) this._events[type] = [
            this._events[type]
        ];
        return this._events[type];
    };
    EventEmitter.prototype.eventNames = function() {
        return Object.keys(this._events);
    };
    EventEmitter.prototype.listenerCount = function(type) {
        return this.listeners(type).length;
    };
    EventEmitter.prototype.listenersAny = function() {
        if (this._all) return this._all;
        else return [];
    };
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define(function() {
        return EventEmitter;
    });
    else // CommonJS
    module.exports = EventEmitter;
}();

});

parcelRegister("1jG9B", function(module, exports) {
$parcel$export(module.exports, "mediaState", () => (parcelRequire("bLPxw")).mediaState);
$parcel$export(module.exports, "isClientBasedAuth", () => (parcelRequire("7mZlN")).isClientBasedAuth);
$parcel$export(module.exports, "authToOwner", () => (parcelRequire("7mZlN")).authToOwner);
$parcel$export(module.exports, "ChunkHashAlgorithm", () => (parcelRequire("9t1Mu")).ChunkHashAlgorithm);
// WARNING! DO NOTE MOVE THIS EXPORT!
// mediaState should be exported BEFORE StreamsCache import later because
// StreamsCache will try to import mediaState from here.

var $bLPxw = parcelRequire("bLPxw");

var $7mZlN = parcelRequire("7mZlN");

var $9t1Mu = parcelRequire("9t1Mu");

});
parcelRegister("bLPxw", function(module, exports) {
$parcel$export(module.exports, "mediaState", () => $b0497af2bbf706c4$export$8cef61637918b288);

var $adK77 = parcelRequire("adK77");

var $7xkt0 = parcelRequire("7xkt0");
const $b0497af2bbf706c4$export$8cef61637918b288 = {
    streams: new (0, $7xkt0.LRUMap)(1000),
    stateDeferreds: new Map(),
    eventEmitter: new (0, $adK77.EventEmitter2)()
};

});
parcelRegister("7xkt0", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});


parcelRegister("7mZlN", function(module, exports) {
$parcel$export(module.exports, "isClientBasedAuth", () => $8faf84af4f6865cd$export$6ba49fcac9c46e54);
$parcel$export(module.exports, "authToOwner", () => $8faf84af4f6865cd$export$17f6055767a8d96a);
function $8faf84af4f6865cd$export$6ba49fcac9c46e54(auth) {
    return !!auth.clientId;
}
function $8faf84af4f6865cd$export$af1ab14f2246ef72(auth) {
    return !!auth.asapIssuer;
}
const $8faf84af4f6865cd$export$17f6055767a8d96a = (auth)=>{
    if ($8faf84af4f6865cd$export$af1ab14f2246ef72(auth)) return auth;
    const clientAuth = {
        id: auth.clientId,
        baseUrl: auth.baseUrl,
        token: auth.token
    };
    return clientAuth;
};

});

parcelRegister("9t1Mu", function(module, exports) {
$parcel$export(module.exports, "ChunkHashAlgorithm", () => $7f634a1b182817d3$export$d3e73a50cc549c2e);
var $7f634a1b182817d3$export$d3e73a50cc549c2e = /*#__PURE__*/ function(ChunkHashAlgorithm) {
    ChunkHashAlgorithm["Sha256"] = "sha256";
    return ChunkHashAlgorithm;
}({});

});


parcelRegister("jkwTu", function(module, exports) {
$parcel$export(module.exports, "MediaStore", () => $6c83a790055aaff5$export$572b8a2a9fd7cbba);
$parcel$export(module.exports, "getMediaEnvironment", () => $6c83a790055aaff5$export$c8b741e18397852a);
$parcel$export(module.exports, "getMediaRegion", () => $6c83a790055aaff5$export$20f9315304dd6726);
parcelRequire("1jG9B");
var $9t1Mu = parcelRequire("9t1Mu");
var $7mZlN = parcelRequire("7mZlN");

var $6PCIn = parcelRequire("6PCIn");

var $1xw3A = parcelRequire("1xw3A");

var $h3W10 = parcelRequire("h3W10");
var $8RCh7 = parcelRequire("8RCh7");

var $2Cdf9 = parcelRequire("2Cdf9");

var $2dJnj = parcelRequire("2dJnj");

var $hsEvX = parcelRequire("hsEvX");

var $fEnUE = parcelRequire("fEnUE");
const $6c83a790055aaff5$var$MEDIA_API_REGION = 'media-api-region';
const $6c83a790055aaff5$var$MEDIA_API_ENVIRONMENT = 'media-api-environment';
const $6c83a790055aaff5$var$extendImageParams = (params, fetchMaxRes = false)=>{
    return {
        ...params,
        'max-age': params?.['max-age'] ?? (0, $6PCIn.FILE_CACHE_MAX_AGE),
        allowAnimated: params?.allowAnimated ?? true,
        mode: params?.mode ?? 'crop',
        ...fetchMaxRes ? {
            width: (0, $6PCIn.MAX_RESOLUTION),
            height: (0, $6PCIn.MAX_RESOLUTION)
        } : {}
    };
};
const $6c83a790055aaff5$var$jsonHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};
const $6c83a790055aaff5$var$cdnFeatureFlag = (endpoint)=>{
    let result = endpoint;
    if ((0, $2dJnj.isCDNEnabled)()) result += '/cdn';
    return result;
};
class $6c83a790055aaff5$export$572b8a2a9fd7cbba {
    constructor(config){
        this.config = config;
        this.getArtifactBinary = async (artifacts, artifactName, { collectionName: collectionName, abortController: abortController, maxAge: maxAge = (0, $6PCIn.FILE_CACHE_MAX_AGE), traceContext: traceContext })=>{
            const metadata = {
                method: 'GET',
                endpoint: `artifact-cdn-url`
            };
            const extendedTraceContext = (0, $2Cdf9.extendTraceContext)(traceContext);
            const options = {
                ...metadata,
                traceContext: extendedTraceContext
            };
            const artifactUrl = await this.getArtifactURL(artifacts, artifactName, collectionName, maxAge);
            return (0, $8RCh7.request)(artifactUrl, options, abortController).then((0, $2Cdf9.createMapResponseToBlob)(metadata));
        };
        this.uploadArtifact = async (id, file, params, collectionName, traceContext)=>{
            const metadata = {
                method: 'POST',
                endpoint: '/file/{fileId}/artifact/binary'
            };
            const headers = {
                Accept: 'application/json',
                'Content-Type': file.type
            };
            const extendedParams = {
                ...params,
                name: file.name,
                collection: collectionName
            };
            const authContext = {
                collectionName: collectionName,
                access: [
                    {
                        type: 'file',
                        id: id,
                        actions: [
                            'update'
                        ]
                    }
                ]
            };
            const options = {
                ...metadata,
                authContext: authContext,
                headers: headers,
                params: extendedParams,
                body: file,
                traceContext: traceContext
            };
            return this.request(`/file/${id}/artifact/binary`, options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
        };
        this.deleteArtifact = async (id, artifactName, collectionName, traceContext)=>{
            const metadata = {
                method: 'DELETE',
                endpoint: '/file/{fileId}/artifact/{artifactName}'
            };
            const authContext = {
                collectionName: collectionName,
                access: [
                    {
                        type: 'file',
                        id: id,
                        actions: [
                            'update'
                        ]
                    }
                ]
            };
            const options = {
                ...metadata,
                authContext: authContext,
                traceContext: traceContext,
                params: {
                    collection: collectionName
                }
            };
            await this.request(`/file/${id}/artifact/${artifactName}`, options);
        };
        this.resolveAuth = (authContext)=>(0, $hsEvX.resolveAuth)(this.config.authProvider, authContext, this.config.authProviderTimeout);
        this.resolveInitialAuth = ()=>(0, $hsEvX.resolveInitialAuth)(this.config.initialAuth);
        this._chunkHashAlgorithm = config.chunkHashAlgorithm || (0, $9t1Mu.ChunkHashAlgorithm).Sha256;
    }
    async removeCollectionFile(id, collectionName, occurrenceKey, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/collection/{collectionName}'
        };
        const body = {
            actions: [
                {
                    action: 'remove',
                    item: {
                        type: 'file',
                        id: id,
                        occurrenceKey: occurrenceKey
                    }
                }
            ]
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/collection/${collectionName}`, options);
    }
    createUpload(createUpTo = 1, collectionName, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            params: {
                createUpTo: createUpTo,
                hashAlgorithm: this._chunkHashAlgorithm
            },
            headers: {
                Accept: 'application/json'
            },
            traceContext: traceContext
        };
        return this.request(`/upload`, options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    async uploadChunk(etag, blob, uploadId, partNumber, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/chunk/{etag}'
        };
        const options = {
            ...metadata,
            params: {
                uploadId: uploadId,
                partNumber: partNumber
            },
            authContext: {
                collectionName: collectionName
            },
            body: blob,
            traceContext: traceContext
        };
        await this.request(`/chunk/${etag}`, options);
    }
    createFileFromUpload(body, params = {}, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $6c83a790055aaff5$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/upload', options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    getRejectedResponseFromDescriptor(descriptor, limit) {
        return {
            fileId: descriptor.fileId,
            error: {
                code: 'ExceedMaxFileSizeLimit',
                title: 'The expected file size exceeded the maximum size limit.',
                href: 'https://dt-api-filestore--app.ap-southeast-2.dev.atl-paas.net/api.html#BadRequest',
                limit: limit,
                size: descriptor.size
            }
        };
    }
    async touchFiles(body, params = {}, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload/createWithFiles'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            headers: $6c83a790055aaff5$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext,
            params: {
                hashAlgorithm: this._chunkHashAlgorithm
            }
        };
        return this.request('/upload/createWithFiles', options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    getFile(fileId, params = {}, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${fileId}`, options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    async getFileImageURL(id, params) {
        const { collection: collectionName } = params || {};
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        return this.createFileImageURL(id, auth, params);
    }
    // TODO Create ticket in case Trace Id can be supported through query params
    getFileImageURLSync(id, params) {
        const auth = this.resolveInitialAuth();
        return this.createFileImageURL(id, auth, params);
    }
    createFileImageURL(id, auth, params) {
        const options = {
            params: $6c83a790055aaff5$var$extendImageParams(params),
            auth: auth
        };
        const imageEndpoint = $6c83a790055aaff5$var$cdnFeatureFlag('image');
        if ((0, $fEnUE.isPathBasedEnabled)()) return (0, $fEnUE.mapToPathBasedUrl)((0, $2Cdf9.createUrl)(`${auth.baseUrl}/file/${id}/${imageEndpoint}`, options));
        return (0, $2dJnj.mapToMediaCdnUrl)((0, $2Cdf9.createUrl)(`${auth.baseUrl}/file/${id}/${imageEndpoint}`, options), auth.token);
    }
    async getFileBinary(id, collectionName, abortController, maxAge = (0, $6PCIn.FILE_CACHE_MAX_AGE)) {
        const headers = {};
        const binaryEndpoint = $6c83a790055aaff5$var$cdnFeatureFlag('binary');
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${binaryEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: headers,
            params: {
                collection: collectionName,
                'max-age': `${maxAge}`
            }
        };
        return this.request(`/file/${id}/${binaryEndpoint}`, options, abortController, true).then((0, $2Cdf9.createMapResponseToBlob)(metadata));
    }
    async getFileBinaryURL(id, collectionName, maxAge = (0, $6PCIn.FILE_CACHE_MAX_AGE)) {
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                dl: true,
                collection: collectionName,
                'max-age': maxAge
            },
            auth: auth
        };
        const binaryEndpoint = $6c83a790055aaff5$var$cdnFeatureFlag('binary');
        if ((0, $fEnUE.isPathBasedEnabled)()) return (0, $fEnUE.mapToPathBasedUrl)((0, $2Cdf9.createUrl)(`${auth.baseUrl}/file/${id}/${binaryEndpoint}`, options));
        return (0, $2dJnj.mapToMediaCdnUrl)((0, $2Cdf9.createUrl)(`${auth.baseUrl}/file/${id}/${binaryEndpoint}`, options), auth.token);
    }
    async getArtifactURL(artifacts, artifactName, collectionName, maxAge = (0, $6PCIn.FILE_CACHE_MAX_AGE)) {
        // ----- WARNING ----------
        // DO NOT USE!!!!!
        // artifact.cdnUrl fails in Jira.
        // ----------------------------------
        // getArtifactURL returns a constructed url PATH, not the full Media/CDN Url.
        // We use the provided cdnUrl from metadata first.
        /* if (isCommercial() && fg('platform_media_cdn_delivery')) {
			const cdnUrl = artifacts[artifactName]?.cdnUrl;
			if (cdnUrl) {
				return cdnUrl;
			}
		} */ const artifactUrl = (0, $1xw3A.getArtifactUrl)(artifacts, artifactName);
        if (!artifactUrl) throw new Error(`artifact ${artifactName} not found`);
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                collection: collectionName,
                'max-age': maxAge
            },
            auth: auth
        };
        const url = (0, $2Cdf9.createUrl)((0, $2dJnj.mapToMediaCdnUrl)(artifactUrl, auth.token), options);
        if ((0, $fEnUE.isPathBasedEnabled)()) return (0, $fEnUE.mapToPathBasedUrl)(url);
        return url;
    }
    async getImage(id, params, controller, fetchMaxRes, traceContext) {
        // TODO add checkWebpSupport() back https://product-fabric.atlassian.net/browse/MPT-584
        const isWebpSupported = false;
        const headers = {};
        if (isWebpSupported) headers.accept = 'image/webp,image/*,*/*;q=0.8';
        const imageEndpoint = $6c83a790055aaff5$var$cdnFeatureFlag('image');
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${imageEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: $6c83a790055aaff5$var$extendImageParams(params, fetchMaxRes),
            headers: headers,
            traceContext: traceContext,
            addMediaClientParam: true
        };
        return this.request(`/file/${id}/${imageEndpoint}`, options, controller, true).then((0, $2Cdf9.createMapResponseToBlob)(metadata));
    }
    async getItems(ids, collectionName, traceContext, includeHashForDuplicateFiles) {
        const descriptors = ids.map((id)=>({
                type: 'file',
                id: id,
                collection: collectionName
            }));
        const metadata = {
            method: 'POST',
            endpoint: '/items'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $6c83a790055aaff5$var$jsonHeaders,
            body: JSON.stringify({
                descriptors: descriptors,
                includeHashForDuplicateFiles: includeHashForDuplicateFiles
            }),
            traceContext: traceContext
        };
        return this.request('/items', options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    async getImageMetadata(id, params, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}/image/metadata'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${id}/image/metadata`, options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    async getDocumentContent(id, options, traceContext) {
        // when requesting for password protected document don't use CDN as it won't forward headers
        // this is deliberate to avoid caching Password protected files
        // Note: this should be removed once endpoint implements server side Cache-Control headers
        const shouldCache = !options.password;
        const endpoint = shouldCache ? $6c83a790055aaff5$var$cdnFeatureFlag('contents') : 'contents';
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/document/${endpoint}`
        };
        const headers = options.password ? {
            'x-document-authorization': `Basic ${options.password}`
        } : {};
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: options.collectionName
            },
            headers: headers,
            params: {
                collection: options.collectionName,
                pageStart: options.pageStart,
                pageEnd: options.pageEnd,
                'max-age': shouldCache ? (0, $6PCIn.FILE_CACHE_MAX_AGE) : 0
            },
            traceContext: traceContext
        };
        return this.request(`/file/${id}/document/${endpoint}`, requestOptions).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    async getDocumentPageImage(id, options, traceContext) {
        // when requesting for password protected document don't use CDN as it won't forward headers
        // this is deliberate to avoid caching Password protected files
        // Note: this should be removed once endpoint implements server side Cache-Control headers
        const shouldCache = !options.password;
        const endpoint = shouldCache ? $6c83a790055aaff5$var$cdnFeatureFlag('page') : 'page';
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/document/${endpoint}`
        };
        const headers = options.password ? {
            'x-document-authorization': `Basic ${options.password}`
        } : {};
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: options.collectionName
            },
            headers: headers,
            params: {
                collection: options.collectionName,
                page: options.page,
                zoom: options.zoom,
                'max-age': shouldCache ? (0, $6PCIn.FILE_CACHE_MAX_AGE) : 0
            },
            traceContext: traceContext
        };
        return this.request(`/file/${id}/document/${endpoint}`, requestOptions).then((0, $2Cdf9.createMapResponseToBlob)(metadata));
    }
    async appendChunksToUpload(uploadId, body, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/upload/{uploadId}/chunks'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $6c83a790055aaff5$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/upload/${uploadId}/chunks`, options);
    }
    copyFileWithToken(body, params, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/withToken'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $6c83a790055aaff5$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/copy/withToken', options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    copyFile(id, params, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/v2/file/copy'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $6c83a790055aaff5$var$jsonHeaders,
            body: JSON.stringify({
                id: id
            }),
            traceContext: traceContext,
            clientOptions: {
                retryOptions: {
                    shouldRetryError: (err)=>(0, $2Cdf9.defaultShouldRetryError)(err) || (0, $h3W10.isRequestError)(err) && err?.metadata?.statusCode === 401
                }
            }
        };
        return this.request('/v2/file/copy', options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    async registerCopyIntents(files, traceContext, resolvedAuth) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/intents'
        };
        const options = {
            ...metadata,
            headers: $6c83a790055aaff5$var$jsonHeaders,
            body: JSON.stringify({
                files: files
            }),
            traceContext: traceContext,
            resolvedAuth: resolvedAuth
        };
        await this.request('/file/copy/intents', options);
    }
    async request(path, options = {
        method: 'GET',
        endpoint: undefined,
        authContext: {}
    }, controller, useMediaCdn) {
        const { method: method, endpoint: endpoint, authContext: authContext, params: params, headers: headers, body: body, clientOptions: clientOptions, traceContext: traceContext, addMediaClientParam: addMediaClientParam, resolvedAuth: resolvedAuth } = options;
        const auth = resolvedAuth ?? await this.resolveAuth(authContext);
        const clientId = (0, $7mZlN.isClientBasedAuth)(auth) ? auth.clientId : undefined;
        const extendedTraceContext = (0, $2Cdf9.extendTraceContext)(traceContext);
        const extendedParams = addMediaClientParam ? {
            ...params,
            clientId: clientId
        } : params;
        let url = `${auth.baseUrl}${path}`;
        if (useMediaCdn) url = (0, $2dJnj.mapToMediaCdnUrl)(url, auth.token);
        if ((0, $fEnUE.isPathBasedEnabled)()) url = (0, $fEnUE.mapToPathBasedUrl)(url);
        const response = await (0, $8RCh7.request)(url, {
            method: method,
            endpoint: endpoint,
            auth: auth,
            params: extendedParams,
            headers: headers,
            body: body,
            clientOptions: clientOptions,
            traceContext: extendedTraceContext
        }, controller);
        $6c83a790055aaff5$var$setKeyValueInSessionStorage($6c83a790055aaff5$var$MEDIA_API_REGION, response.headers.get('x-media-region'));
        $6c83a790055aaff5$var$setKeyValueInSessionStorage($6c83a790055aaff5$var$MEDIA_API_ENVIRONMENT, response.headers.get('x-media-env'));
        return response;
    }
    async testUrl(url, options = {}) {
        const { traceContext: traceContext } = options;
        await (0, $8RCh7.request)(url, {
            method: 'HEAD',
            traceContext: (0, $2Cdf9.extendTraceContext)(traceContext),
            clientOptions: {
                retryOptions: {
                    maxAttempts: 1
                }
            }
        });
    }
    get chunkHashAlgorithm() {
        return this._chunkHashAlgorithm;
    }
}
const $6c83a790055aaff5$var$getValueFromSessionStorage = (key)=>{
    return window && window.sessionStorage && window.sessionStorage.getItem(key) || undefined;
};
const $6c83a790055aaff5$var$setKeyValueInSessionStorage = (key, value)=>{
    if (!value || !(window && window.sessionStorage)) return;
    const currentValue = window.sessionStorage.getItem(key);
    if (currentValue !== value) window.sessionStorage.setItem(key, value);
};
const $6c83a790055aaff5$export$c8b741e18397852a = ()=>{
    return $6c83a790055aaff5$var$getValueFromSessionStorage($6c83a790055aaff5$var$MEDIA_API_ENVIRONMENT);
};
const $6c83a790055aaff5$export$20f9315304dd6726 = ()=>{
    return $6c83a790055aaff5$var$getValueFromSessionStorage($6c83a790055aaff5$var$MEDIA_API_REGION);
};

});
parcelRegister("6PCIn", function(module, exports) {
$parcel$export(module.exports, "RECENTS_COLLECTION", () => $b90d9cdebe03397b$export$860a16125e30000b);
$parcel$export(module.exports, "FILE_CACHE_MAX_AGE", () => $b90d9cdebe03397b$export$bd6e8fe09a90927b);
$parcel$export(module.exports, "MAX_RESOLUTION", () => $b90d9cdebe03397b$export$6e70f30e392bc53f);
$parcel$export(module.exports, "CHUNK_SIZE", () => $b90d9cdebe03397b$export$c1abb8bab1e615cd);
$parcel$export(module.exports, "PROCESSING_BATCH_SIZE", () => $b90d9cdebe03397b$export$3d5157f0def70e54);
$parcel$export(module.exports, "MAX_UPLOAD_FILE_SIZE", () => $b90d9cdebe03397b$export$f14f521f3d306044);

var $jmTJ7 = parcelRequire("jmTJ7");
const $b90d9cdebe03397b$export$860a16125e30000b = 'recents';
const $b90d9cdebe03397b$export$bd6e8fe09a90927b = 2592000; // Retain for 30 days
const $b90d9cdebe03397b$export$6e70f30e392bc53f = 4096;
const $b90d9cdebe03397b$export$c1abb8bab1e615cd = 5 * (0, $jmTJ7.DATA_UNIT).MB;
const $b90d9cdebe03397b$export$3d5157f0def70e54 = 1000;
const $b90d9cdebe03397b$export$f14f521f3d306044 = 2 * (0, $jmTJ7.DATA_UNIT).TB;

});
parcelRegister("jmTJ7", function(module, exports) {
$parcel$export(module.exports, "isNotFoundMediaItemDetails", () => $29f3d51eb645d15a$export$fd27d7abbc4a746d);
$parcel$export(module.exports, "DATA_UNIT", () => $29f3d51eb645d15a$export$76cfea4c354af843);
const $29f3d51eb645d15a$export$350ede7b7a6acf99 = (type)=>{
    const defaultPreviewableTypes = [
        'audio',
        'video',
        'image',
        'doc'
    ];
    return defaultPreviewableTypes.indexOf(type) > -1;
};
const $29f3d51eb645d15a$export$fd27d7abbc4a746d = (itemDetails)=>{
    return 'type' in itemDetails && itemDetails.type === 'not-found';
};
var $29f3d51eb645d15a$export$76cfea4c354af843 = /*#__PURE__*/ function(DATA_UNIT) {
    DATA_UNIT[DATA_UNIT["MB"] = 1048576] = "MB";
    DATA_UNIT[DATA_UNIT["GB"] = 1073741824] = "GB";
    DATA_UNIT[DATA_UNIT["TB"] = 1099511627776] = "TB";
    return DATA_UNIT;
}({});

});


parcelRegister("1xw3A", function(module, exports) {
$parcel$export(module.exports, "getArtifactUrl", () => $91442ef87cdc4338$export$1cc24defa44e7f84);

var $2dJnj = parcelRequire("2dJnj");
const $91442ef87cdc4338$export$1cc24defa44e7f84 = (artifacts, prop)=>{
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if ((0, $2dJnj.isCDNEnabled)() && artifacts[prop]?.url) return `${artifacts[prop]?.url}/cdn`;
    return artifacts[prop]?.url;
};

});
parcelRegister("2dJnj", function(module, exports) {
$parcel$export(module.exports, "isCDNEnabled", () => $bf5b522ee1224e39$export$3e47d0e609e44278);
$parcel$export(module.exports, "mapToMediaCdnUrl", () => $bf5b522ee1224e39$export$fb88a576cf28364d);

var $eGOwo = parcelRequire("eGOwo");

var $3NmFr = parcelRequire("3NmFr");

var $7pw1V = parcelRequire("7pw1V");

var $fEnUE = parcelRequire("fEnUE");
const $bf5b522ee1224e39$export$8a9b6ab3569a543a = {
    'api.media.atlassian.com': 'media-cdn.atlassian.com',
    'media.staging.atl-paas.net': 'media-cdn.stg.atlassian.com'
};
// Cloudfront has a hard limit of 8,192 bytes
// https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/cloudfront-limits.html
// Assuming other parts of the URL make up a max of ~1000 (in reality it's lower), the token can be ~7000
const $bf5b522ee1224e39$var$MEDIA_TOKEN_LENGTH_LIMIT = 7000;
function $bf5b522ee1224e39$export$3e47d0e609e44278() {
    return (0, $3NmFr.isCommercial)() && !(0, $7pw1V.isIsolatedCloud)() && (0, $eGOwo.fg)('platform_media_cdn_delivery') && !(0, $fEnUE.isPathBasedEnabled)();
}
function $bf5b522ee1224e39$export$fb88a576cf28364d(url, token) {
    const tokenLength = token?.length ?? 0;
    if (!$bf5b522ee1224e39$export$3e47d0e609e44278() || tokenLength > $bf5b522ee1224e39$var$MEDIA_TOKEN_LENGTH_LIMIT) return url;
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if ((0, $eGOwo.fg)('platform_media_cdn_delivery') && (0, $eGOwo.fg)('platform_media_cdn_single_host')) try {
        const parsedUrl = new URL(url);
        const cdnHost = $bf5b522ee1224e39$export$8a9b6ab3569a543a[parsedUrl.host];
        // If no mapping is found, return the original URL
        if (!cdnHost) return url;
        // Replace the host with the CDN host in the original URL
        parsedUrl.host = cdnHost;
        return parsedUrl.toString();
    } catch (error) {
        return url;
    }
    return url;
}

});
parcelRegister("3NmFr", function(module, exports) {
$parcel$export(module.exports, "isCommercial", () => $130542adabbe691e$export$df69ff6733e73e50);
function $130542adabbe691e$export$df69ff6733e73e50() {
    const global = globalThis;
    const perimeter = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (perimeter) // Note: reference to MICROS_PERIMETER can be found in: https://hello.atlassian.net/wiki/spaces/MICROS/pages/167212650/Runtime+configuration+environment+variables+and+adding+secrets#Micros-provided-variables
    return perimeter === 'commercial';
    // Return true if the current hostname does NOT match any of the forbidden patterns.
    return !global.location?.hostname?.match(/(atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net))/);
}

});

parcelRegister("fEnUE", function(module, exports) {
$parcel$export(module.exports, "isPathBasedEnabled", () => $e4d3865d0c2bde9e$export$6de3392754e98e65);
$parcel$export(module.exports, "mapToPathBasedUrl", () => $e4d3865d0c2bde9e$export$774e2add1fbe26aa);
$parcel$export(module.exports, "mapRetryUrlToPathBasedUrl", () => $e4d3865d0c2bde9e$export$e71b0af0000b3cfa);

var $eGOwo = parcelRequire("eGOwo");

var $9Wv0b = parcelRequire("9Wv0b");
function $e4d3865d0c2bde9e$var$getRelativeUrl(absoluteUrl) {
    const url = new URL(absoluteUrl);
    return `${url.pathname}${url.search}${url.hash}`;
}
function $e4d3865d0c2bde9e$export$6de3392754e98e65() {
    const isLocalhost = (0, $9Wv0b.default)()?.location?.hostname === 'localhost';
    return (0, $eGOwo.fg)('platform_media_path_based_route') && !isLocalhost;
}
function $e4d3865d0c2bde9e$export$774e2add1fbe26aa(url) {
    if ($e4d3865d0c2bde9e$export$6de3392754e98e65()) {
        const parsedUrl = new URL(url);
        parsedUrl.pathname = `/media-api${parsedUrl.pathname}`;
        const location = (0, $9Wv0b.default)()?.location;
        // in this case we are most likely in SSR / a non browser environment so just return a relative URL
        if (!location) return $e4d3865d0c2bde9e$var$getRelativeUrl(parsedUrl.toString());
        parsedUrl.host = location.host;
        return parsedUrl.toString();
    }
    return url;
}
function $e4d3865d0c2bde9e$export$e71b0af0000b3cfa(url) {
    const parsedUrl = new URL(url);
    parsedUrl.host = (0, $9Wv0b.default)()?.location.host ?? '';
    // remove CDN from the URL for retry if it exists
    const pathname = parsedUrl.pathname;
    if (pathname.endsWith('/cdn')) parsedUrl.pathname = pathname.replace('/cdn', '');
    parsedUrl.pathname = `/media-api${parsedUrl.pathname}`;
    return parsedUrl;
}

});
parcelRegister("9Wv0b", function(module, exports) {
$parcel$export(module.exports, "default", () => $bea1ee745dc0e3b5$export$2e2bcd8739ae039);
var $bea1ee745dc0e3b5$export$2e2bcd8739ae039 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};

});




parcelRegister("h3W10", function(module, exports) {
$parcel$export(module.exports, "RequestError", () => $360d238df22c07b8$export$43ee7d0e4f429743);
$parcel$export(module.exports, "isRequestError", () => $360d238df22c07b8$export$3717b1ffef4428ea);

var $4rKJa = parcelRequire("4rKJa");
class $360d238df22c07b8$export$43ee7d0e4f429743 extends (0, $4rKJa.BaseMediaClientError) {
    constructor(reason, metadata, innerError){
        super(reason, metadata, innerError);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { method: method, endpoint: endpoint, mediaRegion: mediaRegion, mediaEnv: mediaEnv, attempts: attempts, clientExhaustedRetries: clientExhaustedRetries, statusCode: statusCode, traceContext: traceContext } = {}, innerError: innerError } = this;
        return {
            reason: reason,
            method: method,
            endpoint: endpoint,
            mediaRegion: mediaRegion,
            mediaEnv: mediaEnv,
            attempts: attempts,
            clientExhaustedRetries: clientExhaustedRetries,
            statusCode: statusCode,
            metadata: {
                traceContext: traceContext
            },
            innerError: innerError
        };
    }
}
function $360d238df22c07b8$export$3717b1ffef4428ea(err) {
    return err instanceof $360d238df22c07b8$export$43ee7d0e4f429743;
}

});
parcelRegister("4rKJa", function(module, exports) {
$parcel$export(module.exports, "BaseMediaClientError", () => $e9c543355e5204ca$export$2b0aca14d61c3190);
$parcel$export(module.exports, "CommonMediaClientError", () => $e9c543355e5204ca$export$e574d1724215079f);
$parcel$export(module.exports, "isCommonMediaClientError", () => $e9c543355e5204ca$export$881f0f9bc813e1f3);
$parcel$export(module.exports, "toCommonMediaClientError", () => $e9c543355e5204ca$export$a5db89cfc88eff9);
$parcel$export(module.exports, "fromCommonMediaClientError", () => $e9c543355e5204ca$export$c2b89b9a32286816);

var $eBofv = parcelRequire("eBofv");
class $e9c543355e5204ca$export$2b0aca14d61c3190 extends Error {
    constructor(reason, metadata, innerError){
        super(reason), this.reason = reason, this.metadata = metadata, this.innerError = innerError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $e9c543355e5204ca$export$e574d1724215079f extends $e9c543355e5204ca$export$2b0aca14d61c3190 {
    constructor(reason, metadata, innerError){
        super(reason, metadata, innerError);
    }
    get attributes() {
        return {
            reason: this.reason
        };
    }
}
function $e9c543355e5204ca$export$881f0f9bc813e1f3(error) {
    if (!error) return false;
    // Check if the error is an instance of Error
    if (error instanceof $e9c543355e5204ca$export$e574d1724215079f) return true;
    return typeof error.reason === 'string' && ('metadata' in error || error.metadata === undefined) && ('innerError' in error || error.innerError === undefined);
}
const $e9c543355e5204ca$export$a5db89cfc88eff9 = (errorFileState)=>{
    const error = errorFileState.details?.error;
    return new $e9c543355e5204ca$export$e574d1724215079f(error?.reason || 'unknown-reason', error?.metadata, error?.innerError);
};
const $e9c543355e5204ca$export$c2b89b9a32286816 = (id, occurrenceKey, error)=>{
    return {
        status: 'error',
        id: id,
        occurrenceKey: occurrenceKey,
        reason: error.reason,
        details: {
            /** Use this attr to translate back into CommonMediaClientError (toCommonMediaClientError) */ error: {
                reason: error?.reason,
                metadata: error?.metadata,
                innerError: error?.innerError
            },
            // Legacy details
            ...error?.attributes
        },
        message: error?.message
    };
};

});
parcelRegister("eBofv", function(module, exports) {
$parcel$export(module.exports, "getMediaClientErrorReason", () => $508e04f54b9269ab$export$c15d72765ee2baa4);
function $508e04f54b9269ab$export$2491e0bbdb59256e(error) {
    return error instanceof Object && 'attributes' in error && error.attributes instanceof Object && 'reason' in error.attributes && error instanceof Error;
}
function $508e04f54b9269ab$export$c15d72765ee2baa4(err) {
    return $508e04f54b9269ab$export$2491e0bbdb59256e(err) ? err.attributes.reason : 'unknown';
}

});



parcelRegister("8RCh7", function(module, exports) {
$parcel$export(module.exports, "request", () => $16d1dca60bf2e497$export$b5fe3f66a567bec0);

var $h3W10 = parcelRequire("h3W10");

var $2Cdf9 = parcelRequire("2Cdf9");

var $eGOwo = parcelRequire("eGOwo");

var $fEnUE = parcelRequire("fEnUE");

var $vcOMX = parcelRequire("vcOMX");
async function $16d1dca60bf2e497$export$b5fe3f66a567bec0(url, options = {}, controller) {
    const { method: method = 'GET', endpoint: endpoint, auth: auth, params: params, headers: headers, body: body, clientOptions: clientOptions = {}, traceContext: traceContext } = options;
    const { retryOptions: retryOptions } = clientOptions;
    const metadata = {
        method: method,
        endpoint: endpoint,
        traceContext: traceContext
    };
    // TODO BMPT-918: add client timeout feature behing a FF (using clientOptions.clientTimeout + Promise.race)
    const doFetch = ()=>fetch((0, $2Cdf9.createUrl)(url, {
            params: params
        }), {
            method: method,
            body: body,
            headers: (0, $2Cdf9.extendHeaders)(headers, auth, traceContext),
            signal: controller && controller.signal
        }).then((0, $2Cdf9.createProcessFetchResponse)(metadata));
    if ((0, $eGOwo.fg)('platform_media_retry_edge_error')) {
        const shouldRetryError = (err)=>{
            if ((0, $2Cdf9.isFetchNetworkError)(err) && (0, $vcOMX.default)()?.userAgent.includes('Edg/')) return false;
            return (0, $2Cdf9.defaultShouldRetryError)(err);
        };
        try {
            return await (0, $2Cdf9.fetchRetry)(doFetch, metadata, {
                ...retryOptions,
                shouldRetryError: shouldRetryError
            });
        } catch (error) {
            if ((0, $2Cdf9.isFetchNetworkError)(error) && (0, $vcOMX.default)()?.userAgent.includes('Edg/')) {
                const doFetchWithPathBasedUrl = ()=>fetch((0, $2Cdf9.createUrl)((0, $fEnUE.mapRetryUrlToPathBasedUrl)(url).toString(), {
                        params: params
                    }), {
                        method: method,
                        body: body,
                        headers: (0, $2Cdf9.extendHeaders)(headers, auth, traceContext),
                        signal: controller && controller.signal
                    }).then((0, $2Cdf9.createProcessFetchResponse)(metadata));
                return (0, $2Cdf9.fetchRetry)(doFetchWithPathBasedUrl, metadata, retryOptions);
            }
            throw error;
        }
    }
    return (0, $2Cdf9.fetchRetry)(doFetch, metadata, retryOptions);
}

});
parcelRegister("2Cdf9", function(module, exports) {
$parcel$export(module.exports, "isFetchNetworkError", () => $8e2ee04a8e27c7ba$export$ad8c5cf7dd4c3caf);
$parcel$export(module.exports, "extendTraceContext", () => $8e2ee04a8e27c7ba$export$ee24a95986dfd173);
$parcel$export(module.exports, "createUrl", () => $8e2ee04a8e27c7ba$export$7138c24907de3954);
$parcel$export(module.exports, "extendHeaders", () => $8e2ee04a8e27c7ba$export$18cfbabc415d771c);
$parcel$export(module.exports, "createMapResponseToJson", () => $8e2ee04a8e27c7ba$export$e0519b126b73efa6);
$parcel$export(module.exports, "createMapResponseToBlob", () => $8e2ee04a8e27c7ba$export$5cc7b0795397da86);
$parcel$export(module.exports, "defaultShouldRetryError", () => $8e2ee04a8e27c7ba$export$fee2242cbb339663);
$parcel$export(module.exports, "fetchRetry", () => $8e2ee04a8e27c7ba$export$782df2acbe10b22c);
$parcel$export(module.exports, "createRequestErrorReason", () => $8e2ee04a8e27c7ba$export$6397609af718d008);
$parcel$export(module.exports, "createProcessFetchResponse", () => $8e2ee04a8e27c7ba$export$6e2e477edb7d6032);
parcelRequire("1jG9B");
var $7mZlN = parcelRequire("7mZlN");

var $3xaEP = parcelRequire("3xaEP");

var $9WNJB = parcelRequire("9WNJB");

var $h3W10 = parcelRequire("h3W10");
const $8e2ee04a8e27c7ba$var$getStatusCode = (error)=>(0, $h3W10.isRequestError)(error) && error.metadata?.statusCode && error.metadata.statusCode;
function $8e2ee04a8e27c7ba$export$80c51ea1e89203dd(timeout) {
    return new Promise((resolve)=>setTimeout(resolve, timeout));
}
function $8e2ee04a8e27c7ba$export$de0b576cf7ce4a53(err) {
    return err instanceof Error && err.message === 'request_cancelled' || !!err && err.name === 'AbortError';
}
function $8e2ee04a8e27c7ba$export$ad8c5cf7dd4c3caf(err) {
    return err instanceof TypeError;
}
function $8e2ee04a8e27c7ba$export$bc96a6a479480590(error) {
    const statusCode = error && $8e2ee04a8e27c7ba$var$getStatusCode(error);
    return statusCode === 429 || !!error && !!error.message && error.message.includes('429');
}
const $8e2ee04a8e27c7ba$export$ee24a95986dfd173 = (traceContext)=>traceContext ? {
        ...traceContext,
        spanId: traceContext?.spanId || (0, $3xaEP.getRandomTelemetryId)()
    } : undefined;
const $8e2ee04a8e27c7ba$export$922566b90d0535ce = {
    traceId: 'x-b3-traceid',
    spanId: 'x-b3-spanid',
    parentSpanId: 'x-b3-parentspanid',
    sampled: 'x-b3-sampled',
    flags: 'x-b3-flags'
};
const $8e2ee04a8e27c7ba$var$mapTraceIdToRequestHeaders = (traceContext)=>{
    return traceContext ? {
        [$8e2ee04a8e27c7ba$export$922566b90d0535ce.traceId]: traceContext.traceId,
        [$8e2ee04a8e27c7ba$export$922566b90d0535ce.spanId]: traceContext.spanId
    } : {};
};
function $8e2ee04a8e27c7ba$export$eaf4479116d2f925(auth) {
    if (!auth) return {};
    if ((0, $7mZlN.isClientBasedAuth)(auth)) return {
        'X-Client-Id': auth.clientId,
        Authorization: `Bearer ${auth.token}`
    };
    return {
        'X-Issuer': auth.asapIssuer,
        Authorization: `Bearer ${auth.token}`
    };
}
function $8e2ee04a8e27c7ba$export$7138c24907de3954(url, { params: params, auth: auth }) {
    const parsedUrl = new URL(url, auth?.baseUrl);
    const authParams = auth && (0, $9WNJB.mapAuthToQueryParameters)(auth) || {};
    const paramsToAppend = {
        ...params,
        ...authParams
    };
    Object.entries(paramsToAppend).filter(([_, value])=>value != null).forEach((pair)=>{
        parsedUrl.searchParams.set(...pair);
    });
    parsedUrl.searchParams.sort();
    return parsedUrl.toString();
}
function $8e2ee04a8e27c7ba$export$18cfbabc415d771c(headers, auth, traceContext) {
    if (!auth && !traceContext && !headers) return undefined;
    return {
        ...headers ?? {},
        ...$8e2ee04a8e27c7ba$export$eaf4479116d2f925(auth),
        ...$8e2ee04a8e27c7ba$var$mapTraceIdToRequestHeaders(traceContext)
    };
}
function $8e2ee04a8e27c7ba$export$e0519b126b73efa6(metadata) {
    return async (response)=>{
        try {
            return await response.json();
        } catch (err) {
            throw new (0, $h3W10.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$8e2ee04a8e27c7ba$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
function $8e2ee04a8e27c7ba$export$5cc7b0795397da86(metadata) {
    return async (response)=>{
        try {
            return await response.blob();
        } catch (err) {
            throw new (0, $h3W10.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$8e2ee04a8e27c7ba$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
const $8e2ee04a8e27c7ba$export$fee2242cbb339663 = (err)=>{
    const statusCode = $8e2ee04a8e27c7ba$var$getStatusCode(err);
    return $8e2ee04a8e27c7ba$export$ad8c5cf7dd4c3caf(err) || (statusCode ? statusCode >= 500 : false);
};
const $8e2ee04a8e27c7ba$export$c65cfa70960d8fe5 = {
    startTimeoutInMs: 1000,
    maxAttempts: 5,
    factor: 2
};
function $8e2ee04a8e27c7ba$export$359f19ca51f9eba1(error, extraMetadata) {
    const { reason: reason, metadata: metadata, innerError: innerError } = error;
    return new (0, $h3W10.RequestError)(reason, {
        ...metadata,
        ...extraMetadata
    }, innerError);
}
async function $8e2ee04a8e27c7ba$export$782df2acbe10b22c(functionToRetry, metadata, overwriteOptions = {}) {
    const options = {
        ...$8e2ee04a8e27c7ba$export$c65cfa70960d8fe5,
        ...overwriteOptions
    };
    const { startTimeoutInMs: startTimeoutInMs, maxAttempts: maxAttempts, factor: factor, shouldRetryError: shouldRetryError = $8e2ee04a8e27c7ba$export$fee2242cbb339663 } = options;
    let attempts = 0;
    let timeoutInMs = startTimeoutInMs;
    let lastError;
    const waitAndBumpTimeout = async ()=>{
        await $8e2ee04a8e27c7ba$export$80c51ea1e89203dd(timeoutInMs);
        timeoutInMs *= factor;
        attempts += 1;
    };
    while(attempts < maxAttempts)try {
        return await functionToRetry();
    } catch (err) {
        lastError = err;
        // don't retry if request was aborted by user
        if ($8e2ee04a8e27c7ba$export$de0b576cf7ce4a53(err)) throw new (0, $h3W10.RequestError)('clientAbortedRequest', metadata, err);
        if (!shouldRetryError(err)) throw err;
        await waitAndBumpTimeout();
    }
    if ((0, $h3W10.isRequestError)(lastError)) throw $8e2ee04a8e27c7ba$export$359f19ca51f9eba1(lastError, {
        attempts: attempts,
        clientExhaustedRetries: true
    });
    throw new (0, $h3W10.RequestError)('serverUnexpectedError', {
        ...metadata,
        attempts: attempts,
        clientExhaustedRetries: true
    }, lastError);
}
function $8e2ee04a8e27c7ba$export$6397609af718d008(statusCode) {
    switch(statusCode){
        case 400:
            return 'serverBadRequest';
        case 401:
            return 'serverUnauthorized';
        case 403:
            return 'serverForbidden';
        case 404:
            return 'serverNotFound';
        case 422:
            return 'serverUnprocessableEntity';
        case 423:
            return 'serverEntityLocked';
        case 429:
            return 'serverRateLimited';
        case 500:
            return 'serverInternalError';
        case 502:
            return 'serverBadGateway';
        default:
            return 'serverUnexpectedError';
    }
}
function $8e2ee04a8e27c7ba$export$d171f49f6b4ddc33(metadata, response) {
    const { status: statusCode } = response;
    const reason = $8e2ee04a8e27c7ba$export$6397609af718d008(statusCode);
    return new (0, $h3W10.RequestError)(reason, {
        ...metadata,
        ...$8e2ee04a8e27c7ba$export$ea175c0c5497224(response),
        statusCode: statusCode
    });
}
function $8e2ee04a8e27c7ba$export$6e2e477edb7d6032(metadata) {
    return (response)=>{
        if (response.ok || response.status < 400) return response;
        const requestError = $8e2ee04a8e27c7ba$export$d171f49f6b4ddc33(metadata, response);
        throw requestError;
    };
}
function $8e2ee04a8e27c7ba$export$ea175c0c5497224(response) {
    const { headers: headers } = response;
    const mediaRegion = headers.get('x-media-region') || 'unknown';
    const mediaEnv = headers.get('x-media-env') || 'unknown';
    return {
        mediaRegion: mediaRegion,
        mediaEnv: mediaEnv
    };
}

});
parcelRegister("3xaEP", function(module, exports) {
$parcel$export(module.exports, "isUndefined", () => $af4102ec3e3c11b2$export$fce6876652108ab);
$parcel$export(module.exports, "omitBy", () => $af4102ec3e3c11b2$export$d7a617dda645b4e3);
$parcel$export(module.exports, "getRandomHex", () => $af4102ec3e3c11b2$export$456b25e3a9b4a843);
$parcel$export(module.exports, "getRandomTelemetryId", () => $af4102ec3e3c11b2$export$2e36de8639bad0ad);
const $af4102ec3e3c11b2$export$fce6876652108ab = (value)=>value === undefined;
const $af4102ec3e3c11b2$export$357523c63a2253b9 = (obj, keys = [])=>{
    if (obj === undefined) return {};
    return Object.fromEntries(Object.entries(obj).filter(([k])=>keys.includes(k)));
};
const $af4102ec3e3c11b2$export$d7a617dda645b4e3 = (obj, predicate)=>Object.fromEntries(Object.entries(obj).filter(([, v])=>!predicate(v)));
const $af4102ec3e3c11b2$export$61fc7d43ac8f84b0 = (func, wait)=>{
    let timeout;
    return (...args)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>func(...args), wait);
    };
};
const $af4102ec3e3c11b2$export$de994efd351b291c = (srcObj)=>{
    return (obj)=>{
        let key;
        for(key in srcObj){
            if (obj[key] === undefined || obj[key] !== srcObj[key]) return false;
        }
        return true;
    };
};
function $af4102ec3e3c11b2$var$getRandomHexValues(byte) {
    return [
        ...Array(byte * 2)
    ].map(()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $af4102ec3e3c11b2$export$456b25e3a9b4a843(byte) {
    let randomHex;
    if (window?.crypto) try {
        randomHex = Array.from(window.crypto.getRandomValues(new Uint8Array(byte))).map((b)=>b.toString(16).padStart(2, '0')).join('');
    } catch (e) {
        randomHex = $af4102ec3e3c11b2$var$getRandomHexValues(byte);
    }
    else randomHex = $af4102ec3e3c11b2$var$getRandomHexValues(byte);
    return randomHex;
}
function $af4102ec3e3c11b2$export$2e36de8639bad0ad() {
    return $af4102ec3e3c11b2$export$456b25e3a9b4a843(8);
}

});

parcelRegister("9WNJB", function(module, exports) {
$parcel$export(module.exports, "mapAuthToQueryParameters", () => $47d6feb819b26718$export$6833b130611df767);
parcelRequire("1jG9B");
var $7mZlN = parcelRequire("7mZlN");
function $47d6feb819b26718$export$6833b130611df767(auth) {
    if ((0, $7mZlN.isClientBasedAuth)(auth)) return {
        client: auth.clientId,
        token: auth.token
    };
    else return {
        issuer: auth.asapIssuer,
        token: auth.token
    };
}

});


parcelRegister("vcOMX", function(module, exports) {
$parcel$export(module.exports, "default", () => $50d40fcfaddb9f61$export$2e2bcd8739ae039);
var $50d40fcfaddb9f61$export$2e2bcd8739ae039 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.navigator === 'undefined') return;
    return window.navigator;
};

});


parcelRegister("hsEvX", function(module, exports) {
$parcel$export(module.exports, "resolveAuth", () => $6d143f49360dbe76$export$4b4cec3dcdfce972);
$parcel$export(module.exports, "resolveInitialAuth", () => $6d143f49360dbe76$export$5211e1371264aec3);

var $3Y4Hn = parcelRequire("3Y4Hn");

var $3nErQ = parcelRequire("3nErQ");
const $6d143f49360dbe76$export$560085fe411c0660 = 10000;
const $6d143f49360dbe76$export$4b4cec3dcdfce972 = async (authProvider, authContext, authProviderTimeout = $6d143f49360dbe76$export$560085fe411c0660)=>{
    let auth;
    try {
        auth = await Promise.race([
            authProvider(authContext),
            (0, $3nErQ.rejectTimeout)(authProviderTimeout, new (0, $3Y4Hn.MediaStoreError)('authProviderTimedOut'))
        ]);
    } catch (err) {
        if (err instanceof (0, $3Y4Hn.MediaStoreError)) throw err;
        throw new (0, $3Y4Hn.MediaStoreError)('failedAuthProvider', err instanceof Error ? err : undefined);
    }
    if (!auth) throw new (0, $3Y4Hn.MediaStoreError)('emptyAuth');
    /*
    We added a token expiration check here in the past, and then we had to revert due to edge cases in the client that we can't control.
    Token expiration check in the frontend is a bad idea. Don't do it!
    More info:
    https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/13080
    https://gist.github.com/timvisee/fcda9bbdff88d45cc9061606b4b923ca
  */ return auth;
};
const $6d143f49360dbe76$export$5211e1371264aec3 = (auth)=>{
    if (!auth) throw new (0, $3Y4Hn.MediaStoreError)('missingInitialAuth');
    return auth;
};

});
parcelRegister("3Y4Hn", function(module, exports) {
$parcel$export(module.exports, "MediaStoreError", () => $d19f60583c5ce4e8$export$b78480bd311630bc);

var $4rKJa = parcelRequire("4rKJa");
class $d19f60583c5ce4e8$export$b78480bd311630bc extends (0, $4rKJa.BaseMediaClientError) {
    constructor(reason, innerError){
        super(reason, undefined, innerError);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, innerError: innerError } = this;
        return {
            reason: reason,
            innerError: innerError
        };
    }
}
function $d19f60583c5ce4e8$export$8d2a9b675b2ce37a(err) {
    return err instanceof $d19f60583c5ce4e8$export$b78480bd311630bc;
}

});

parcelRegister("3nErQ", function(module, exports) {
$parcel$export(module.exports, "rejectTimeout", () => $bdd7813d02cb717f$export$cf2d2a1124beacb2);
const $bdd7813d02cb717f$export$c30e7cea8bbec3c0 = (timeout, resolveWith)=>new Promise((resolve, _reject)=>{
        setTimeout(resolve, timeout, resolveWith);
    });
const $bdd7813d02cb717f$export$cf2d2a1124beacb2 = (timeout, rejectWith)=>new Promise((_resolve, reject)=>{
        setTimeout(reject, timeout, rejectWith);
    });

});



parcelRegister("iPHIU", function(module, exports) {
$parcel$export(module.exports, "FileFetcherImpl", () => $09c82e56436a3d4e$export$fe17eabf77aabacb);
$parcel$export(module.exports, "FileFetcherError", () => (parcelRequire("1GWfm")).FileFetcherError);

var $2PBDa = parcelRequire("2PBDa");

var $3PmNk = parcelRequire("3PmNk");

var $8KLBw = parcelRequire("8KLBw");
parcelRequire("1jG9B");
var $7mZlN = parcelRequire("7mZlN");

var $g1OQu = parcelRequire("g1OQu");

var $jkwTu = parcelRequire("jkwTu");

var $bbNl0 = parcelRequire("bbNl0");

var $jmTJ7 = parcelRequire("jmTJ7");

var $1GWfm = parcelRequire("1GWfm");

var $2mMyO = parcelRequire("2mMyO");

var $abkQS = parcelRequire("abkQS");

var $lRBVi = parcelRequire("lRBVi");

var $6PCIn = parcelRequire("6PCIn");

var $eaj78 = parcelRequire("eaj78");

var $hRxrn = parcelRequire("hRxrn");

var $atDjN = parcelRequire("atDjN");

var $053B3 = parcelRequire("053B3");

var $iDYg8 = parcelRequire("iDYg8");

var $jFXx8 = parcelRequire("jFXx8");
var $kFG4u = parcelRequire("kFG4u");

var $ea8A0 = parcelRequire("ea8A0");

var $jkEmk = parcelRequire("jkEmk");

var $5JVfG = parcelRequire("5JVfG");

var $8UZz3 = parcelRequire("8UZz3");

var $393Zn = parcelRequire("393Zn");

var $iX2Cl = parcelRequire("iX2Cl");
parcelRequire("48hWz");
var $1ZNSP = parcelRequire("1ZNSP");

var $bksvR = parcelRequire("bksvR");

var $2Cdf9 = parcelRequire("2Cdf9");

var $4rKJa = parcelRequire("4rKJa");
const $09c82e56436a3d4e$var$isCopySourceFileWithToken = (token)=>!!token.authProvider;
const $09c82e56436a3d4e$var$isCopyDestinationWithToken = (token)=>!!token.authProvider;
class $09c82e56436a3d4e$export$fe17eabf77aabacb {
    constructor(mediaApi, store = (0, $1ZNSP.mediaStore)){
        this.mediaApi = mediaApi;
        this.store = store;
        this.getErrorFileState = (error, id, occurrenceKey)=>{
            if ((0, $4rKJa.isCommonMediaClientError)(error)) return (0, $4rKJa.fromCommonMediaClientError)(id, occurrenceKey, error);
            // ________________________________________________
            // Legacy serializers
            // We need to revisit all the incoming error types and ensure all the "reason" values are known
            // We need to change the input error: any for a known type.
            if (typeof error === 'string') {
                const err = new (0, $4rKJa.CommonMediaClientError)(error);
                return (0, $4rKJa.fromCommonMediaClientError)(id, occurrenceKey, err);
            } else {
                const err = new (0, $4rKJa.CommonMediaClientError)(error?.reason || 'unknown', error?.metadata, error?.innerError);
                return (0, $4rKJa.fromCommonMediaClientError)(id, occurrenceKey, err);
            }
        };
        this.setFileState = (id, fileState)=>{
            this.store.setState((state)=>{
                state.files[id] = fileState;
            });
        };
        this.createDownloadFileStream = (id, collectionName, occurrenceKey, includeHashForDuplicateFiles, forceRefresh)=>{
            const subject = (0, $jkEmk.createMediaSubject)();
            const poll = new (0, $393Zn.PollingFunction)();
            // ensure subject errors if polling exceeds max iterations or uncaught exception in executor
            poll.onError = (error)=>subject.error(error);
            poll.execute(async ()=>{
                if (forceRefresh) this.dataloader.clear({
                    id: id,
                    collectionName: collectionName,
                    includeHashForDuplicateFiles: includeHashForDuplicateFiles
                });
                const response = await this.dataloader.load({
                    id: id,
                    collectionName: collectionName,
                    includeHashForDuplicateFiles: includeHashForDuplicateFiles
                });
                if ((0, $jmTJ7.isNotFoundMediaItemDetails)(response)) throw new (0, $1GWfm.FileFetcherError)('emptyItems', {
                    id: id,
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey,
                    traceContext: response.metadataTraceContext
                });
                if ((0, $iX2Cl.isEmptyFile)(response)) throw new (0, $1GWfm.FileFetcherError)('zeroVersionFile', {
                    id: id,
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey,
                    traceContext: response.metadataTraceContext
                });
                const fileState = (0, $bbNl0.mapMediaItemToFileState)(id, response);
                subject.next(fileState);
                switch(fileState.status){
                    case 'processing':
                        // the only case for continuing polling, otherwise this function is run once only
                        poll.next();
                        break;
                    case 'processed':
                        subject.complete();
                        break;
                }
            });
            return subject;
        };
        this.getUploadingFileStateBase = (file, upfrontId)=>{
            // TODO: DO not modify the input parameter 'content' attribute
            if (typeof file.content === 'string') file.content = (0, $iDYg8.convertBase64ToBlob)(file.content);
            const { content: content, name: name = '' } = file;
            const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
            let preview;
            // TODO [MSW-796]: get file size for base64
            let size = 0;
            let mimeType = '';
            if (content instanceof Blob) {
                size = content.size;
                mimeType = content.type;
                preview = {
                    value: content,
                    origin: 'local'
                };
            }
            const mediaType = (0, $atDjN.getMediaTypeFromUploadableFile)(file);
            return {
                id: id,
                occurrenceKey: occurrenceKey,
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: mimeType,
                preview: preview
            };
        };
        this.uploadArtifact = async (id, file, params, collectionName, traceContext)=>{
            const { data: data } = await this.mediaApi.uploadArtifact(id, file, params, collectionName, traceContext);
            /* TEMPORARYLY PULLING NEW METADATA till the endpoint is fixed */ const { data: altData } = await this.mediaApi.getItems([
                id
            ], collectionName, traceContext);
            const itemDetails = altData.items[0].details;
            // ------------------------------------------------------------
            this.setFileState(id, (0, $bbNl0.mapMediaItemToFileState)(id, itemDetails));
            return data;
        };
        this.deleteArtifact = async (id, artifactName, collectionName, traceContext)=>{
            await this.mediaApi.deleteArtifact(id, artifactName, collectionName, traceContext);
            // Manually remove the artifact from file state instead of re-requesting the entire payload.
            const file = this.store.getState().files[id];
            if (file && file.status === 'processed' && file.artifacts) {
                const updatedArtifacts = {
                    ...file.artifacts
                };
                delete updatedArtifacts[artifactName];
                const updatedFileState = {
                    ...file,
                    artifacts: updatedArtifacts
                };
                this.setFileState(id, updatedFileState);
            }
        };
        this.getOrFetchFileState = async (id, collectionName)=>{
            let fileState = this.store.getState().files[id];
            return fileState ?? await this.getCurrentState(id, {
                collectionName: collectionName
            });
        };
        this.getDurationOfVideo = async (id, collectionName)=>{
            const fileState = await this.getOrFetchFileState(id, collectionName);
            if (fileState.status !== 'processed' || fileState.mediaType !== 'video' || !fileState.artifacts['video.mp4']) throw new Error('File is not a video');
            if (fileState.mediaMetadata?.duration) return fileState.mediaMetadata.duration;
            // If the duration is not present, we need to fetch it from the artifact
            const artifactUrlString = await this.getArtifactURL(fileState.artifacts, 'video.mp4', collectionName);
            const artifactUrl = new URL(artifactUrlString);
            const artifactPath = `${artifactUrl.pathname}${artifactUrl.search}`;
            const res = await this.mediaApi.request(artifactPath, {
                headers: {
                    Range: 'bytes=0-199'
                }
            });
            // Get the response as ArrayBuffer
            const arrayBuffer = await res.arrayBuffer();
            const uint8Array = new Uint8Array(arrayBuffer);
            const mvhdBytes = new Uint8Array([
                109,
                118,
                104,
                100
            ]); // "mvhd" in ASCII
            let mvhdIndex = -1;
            for(let i = 0; i <= uint8Array.length - mvhdBytes.length; i++){
                mvhdIndex = i;
                for(let j = 0; j < mvhdBytes.length; j++)if (uint8Array[i + j] !== mvhdBytes[j]) {
                    mvhdIndex = -1;
                    break;
                }
                if (mvhdIndex !== -1) break;
            }
            if (mvhdIndex === -1) throw new Error('Unable to find mvhd bytes');
            // Create DataView for reading big-endian integers
            const dataView = new DataView(arrayBuffer);
            const start = mvhdIndex + 16; // Skip atom header and version/flags
            // Check if we have enough bytes to read timescale and duration
            if (start + 8 > arrayBuffer.byteLength) return 0;
            // flase as second parameter indicates big-endian 32-bit integers
            const timeScale = dataView.getUint32(start, false);
            const duration = dataView.getUint32(start + 4, false);
            if (timeScale === 0) throw new Error('Timescale is invalid');
            // get the video length in seconds
            const videoLength = Math.floor(duration / timeScale);
            return videoLength;
        };
        this.getVideoDurations = async (files)=>{
            // get all the duration promises
            const promises = files.map(async ({ id: id, collectionName: collectionName })=>{
                try {
                    return await this.getDurationOfVideo(id, collectionName);
                } catch (_err) {
                    return -1;
                }
            });
            const durations = await Promise.all(promises);
            // only return the durations that are present;
            return durations.reduce((acc, curr, i)=>{
                if (curr !== -1) {
                    const id = files[i].id;
                    acc[id] = curr;
                }
                return acc;
            }, {});
        };
        this.dataloader = (0, $hRxrn.createFileDataloader)(mediaApi);
        this.copyIntentRegisterationBatcher = (0, $bksvR.createCopyIntentRegisterationBatcher)(mediaApi);
    }
    getFileState(id, options = {}) {
        const { collectionName: collectionName, occurrenceKey: occurrenceKey, includeHashForDuplicateFiles: includeHashForDuplicateFiles, forceRefresh: forceRefresh } = options;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($eaj78)))(id)) {
            const subject = (0, $jkEmk.createMediaSubject)();
            const err = new (0, $1GWfm.FileFetcherError)('invalidFileId', {
                id: id,
                collectionName: collectionName,
                occurrenceKey: occurrenceKey
            });
            const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
            subject.error(err);
            this.setFileState(id, errorFileState);
            return (0, $jFXx8.fromObservable)(subject);
        }
        if (forceRefresh) (0, $abkQS.getFileStreamsCache)().remove(id);
        return (0, $jFXx8.fromObservable)((0, $abkQS.getFileStreamsCache)().getOrInsert(id, ()=>{
            const subject = this.createDownloadFileStream(id, collectionName, undefined, includeHashForDuplicateFiles, forceRefresh);
            subject.subscribe({
                next: (fileState)=>{
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    this.setFileState(id, errorFileState);
                }
            });
            return subject;
        }));
    }
    getCurrentState(id, options) {
        return (0, $kFG4u.toPromise)(this.getFileState(id, options));
    }
    getArtifactURL(artifacts, artifactName, collectionName) {
        return this.mediaApi.getArtifactURL(artifacts, artifactName, collectionName);
    }
    getFileBinaryURL(id, collectionName, maxAge) {
        return this.mediaApi.getFileBinaryURL(id, collectionName, maxAge);
    }
    touchFiles(descriptors, collection, traceContext) {
        return this.mediaApi.touchFiles({
            descriptors: descriptors
        }, {
            collection: collection
        }, traceContext).then(({ data: data })=>data);
    }
    generateUploadableFileUpfrontIds(collection, traceContext) {
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))();
        const occurrenceKey = (0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))();
        const touchFileDescriptor = {
            fileId: id,
            occurrenceKey: occurrenceKey,
            collection: collection
        };
        const deferredUploadId = this.touchFiles([
            touchFileDescriptor
        ], collection, traceContext).then((touchedFiles)=>touchedFiles.created[0].uploadId);
        return {
            id: id,
            occurrenceKey: occurrenceKey,
            deferredUploadId: deferredUploadId
        };
    }
    async uploadExternal(url, collection, traceContext) {
        const uploadableFileUpfrontIds = this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
        const subject = (0, $jkEmk.createMediaSubject)();
        const deferredBlob = fetch(url).then((response)=>response.blob()).catch(()=>undefined);
        const preview = new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) reject('Could not fetch the blob');
            resolve({
                value: blob,
                origin: 'remote'
            });
        });
        const name = url.split('/').pop() || '';
        // we create a initial fileState with the minimum info that we have at this point
        const fileState = {
            status: 'processing',
            name: name,
            size: 0,
            mediaType: 'unknown',
            mimeType: '',
            id: id,
            occurrenceKey: occurrenceKey,
            preview: preview
        };
        subject.next(fileState);
        // we save it into the cache as soon as possible, in case someone subscribes
        (0, $abkQS.getFileStreamsCache)().set(id, subject);
        this.setFileState(id, fileState);
        return new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) return reject('Could not download remote file');
            const { type: type, size: size } = blob;
            const file = {
                content: blob,
                mimeType: type,
                collection: collection,
                name: name,
                size: size
            };
            const mediaType = (0, $5JVfG.getMediaTypeFromMimeType)(type);
            // we emit a richer state after the blob is fetched
            subject.next({
                status: 'processing',
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: type,
                id: id,
                occurrenceKey: occurrenceKey,
                preview: preview
            });
            // we don't want to wait for the file to be upload
            this.upload(file, undefined, uploadableFileUpfrontIds, traceContext);
            let dimensions;
            try {
                dimensions = await (0, $ea8A0.getDimensionsFromBlob)(mediaType, blob);
            } catch (error) {
                reject(error);
                return;
            }
            resolve({
                dimensions: dimensions,
                mimeType: type,
                uploadableFileUpfrontIds: uploadableFileUpfrontIds
            });
        });
    }
    upload(file, controller, uploadableFileUpfrontIds, traceContext) {
        const { collection: collection } = file;
        const upfrontId = uploadableFileUpfrontIds || this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
        const stateBase = this.getUploadingFileStateBase(file, upfrontId);
        const subject = (0, $jkEmk.createMediaSubject)();
        (0, $abkQS.getFileStreamsCache)().set(id, subject);
        const onProgress = (progress)=>{
            const fileState = {
                status: 'uploading',
                ...stateBase,
                progress: progress
            };
            subject.next(fileState);
            this.setFileState(id, fileState);
        };
        let processingSubscription = new (0, $2PBDa.Subscription)();
        const onUploadFinish = (error)=>{
            if (error) {
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(id, errorFileState);
                return subject.error(error);
            }
            processingSubscription = this.createDownloadFileStream(id, collection, occurrenceKey).pipe((0, $3PmNk.map)((remoteFileState)=>({
                    // merges base state with remote state
                    ...stateBase,
                    ...remoteFileState,
                    ...(0, $053B3.overrideMediaTypeIfUnknown)(remoteFileState, stateBase.mediaType)
                }))).subscribe({
                next: (fileState)=>{
                    subject.next(fileState);
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    subject.error(err);
                    this.setFileState(id, errorFileState);
                },
                complete: subject.complete
            });
        };
        const { cancel: cancel } = (0, $2mMyO.uploadFile)(file, this.mediaApi, upfrontId, {
            onUploadFinish: onUploadFinish,
            onProgress: onProgress
        }, traceContext);
        controller?.setAbort(()=>{
            cancel();
            // TODO: filestate should turn to "Aborted" or something.
            // Consider canceling an upload that is already finished
            processingSubscription.unsubscribe();
        });
        // We should report progress asynchronously, since this is what consumer expects
        // (otherwise in newUploadService file-converting event will be emitted before files-added)
        setTimeout(onProgress, 0, 0);
        return (0, $jFXx8.fromObservable)(subject);
    }
    async downloadBinary(id, name = 'download', collectionName, traceContext) {
        const url = await this.mediaApi.getFileBinaryURL(id, collectionName);
        (0, $g1OQu.downloadUrl)(url, {
            name: name
        });
        (0, $lRBVi.globalMediaEventEmitter).emit('media-viewed', {
            fileId: id,
            isUserCollection: collectionName === (0, $6PCIn.RECENTS_COLLECTION),
            viewingLevel: 'download'
        });
        // Test the download after initiated the Browser process to catch any potential errors.
        await this.mediaApi.testUrl(url, {
            traceContext: traceContext
        });
    }
    async registerCopyIntent(id, collectionName) {
        // pre-resolving auth to add it to the key
        const auth = await this.mediaApi.resolveAuth({
            collectionName: collectionName
        });
        const key = {
            id: id,
            collectionName: collectionName,
            resolvedAuth: auth
        };
        const error = await this.copyIntentRegisterationBatcher.load(key);
        if (error) {
            // if the error is retryable then it should not be cached
            if ((0, $2Cdf9.defaultShouldRetryError)(error)) this.copyIntentRegisterationBatcher.clear(key);
            throw error;
        }
    }
    async copyFileWithToken(source, destination, traceContext) {
        const { authProvider: authProvider, collection: sourceCollection, id: id } = source;
        const { authProvider: destinationAuthProvider, collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
        const mediaStore = destination.mediaStore || new (0, $jkwTu.MediaStore)({
            authProvider: destinationAuthProvider
        });
        const owner = (0, $7mZlN.authToOwner)(await authProvider({
            collectionName: sourceCollection
        }));
        const body = {
            sourceFile: {
                id: id,
                collection: sourceCollection,
                owner: owner
            }
        };
        const params = {
            collection: destinationCollectionName,
            replaceFileId: replaceFileId,
            occurrenceKey: occurrenceKey
        };
        const { data: data } = await mediaStore.copyFileWithToken(body, params, traceContext);
        return data;
    }
    async copyFileWithIntent(source, destination, traceContext) {
        const res = await this.mediaApi.copyFile(source.id, {
            sourceCollection: source.collection,
            collection: destination.collection,
            replaceFileId: destination.replaceFileId
        }, traceContext);
        const { data: data } = res;
        return data;
    }
    async copyFile(source, destination, options = {}, traceContext) {
        const { id: id } = source;
        const { collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
        const { preview: preview, mimeType: mimeType } = options;
        const cache = (0, $abkQS.getFileStreamsCache)();
        let processingSubscription;
        try {
            let copiedFile;
            if ($09c82e56436a3d4e$var$isCopySourceFileWithToken(source) && $09c82e56436a3d4e$var$isCopyDestinationWithToken(destination)) copiedFile = await this.copyFileWithToken(source, destination, traceContext);
            else copiedFile = await this.copyFileWithIntent(source, destination, traceContext);
            // if we were passed a "mimeType", we propagate it into copiedFileWithMimeType
            const copiedFileWithMimeType = {
                ...copiedFile,
                ...mimeType ? {
                    mimeType: mimeType
                } : undefined
            };
            const { id: copiedId, mimeType: copiedMimeType } = copiedFileWithMimeType;
            // backend may return an "unknown" mediaType just after the copy
            // it's better to deduce it from "copiedMimeType" using getMediaTypeFromMimeType()
            const mediaType = copiedMimeType ? (0, $5JVfG.getMediaTypeFromMimeType)(copiedMimeType) : 'unknown';
            const copiedFileState = (0, $bbNl0.mapMediaFileToFileState)({
                data: copiedFileWithMimeType
            });
            const fileCache = cache.get(copiedId);
            const subject = fileCache || (0, $jkEmk.createMediaSubject)();
            // if we were passed a "preview", we propagate it into the copiedFileState
            const previewOverride = !(0, $bbNl0.isErrorFileState)(copiedFileState) && !!preview ? {
                preview: preview
            } : {};
            if (!(0, $bbNl0.isFinalFileState)(copiedFileState) && // mimeType should always be returned by "copyFileWithToken"
            // but in case it's not, we don't want to penalize "copyFile"
            copiedMimeType && await (0, $8UZz3.shouldFetchRemoteFileStates)(mediaType, copiedMimeType, preview)) {
                const fileState = {
                    ...copiedFileState,
                    ...(0, $053B3.overrideMediaTypeIfUnknown)(copiedFileState, mediaType),
                    ...previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
                processingSubscription = this.createDownloadFileStream(copiedId, destinationCollectionName, occurrenceKey).subscribe({
                    next: (remoteFileState)=>{
                        const fileState = {
                            ...remoteFileState,
                            ...(0, $053B3.overrideMediaTypeIfUnknown)(remoteFileState, mediaType),
                            ...!(0, $bbNl0.isErrorFileState)(remoteFileState) && previewOverride
                        };
                        this.setFileState(copiedId, fileState);
                        return subject.next(fileState);
                    },
                    error: (err)=>{
                        const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                        this.setFileState(copiedId, errorFileState);
                        return subject.error(err);
                    },
                    complete: ()=>subject.complete()
                });
            } else if (!(0, $bbNl0.isProcessingFileState)(copiedFileState)) {
                const fileState = {
                    ...copiedFileState,
                    ...!(0, $bbNl0.isErrorFileState)(copiedFileState) && previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
            }
            if (!cache.has(copiedId)) (0, $abkQS.getFileStreamsCache)().set(copiedId, subject);
            return copiedFile;
        } catch (error) {
            if (processingSubscription) processingSubscription.unsubscribe();
            if (replaceFileId) {
                const fileCache = cache.get(replaceFileId);
                const replaceFileState = this.store.getState().files[replaceFileId];
                if (fileCache) fileCache.error(error);
                else // Create a new subject with the error state for new subscriptions
                cache.set(id, (0, $jkEmk.createMediaSubject)(error));
                const key = replaceFileState ? replaceFileId : id;
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(key, errorFileState);
            }
            throw error;
        }
    }
}

});
parcelRegister("g1OQu", function(module, exports) {
$parcel$export(module.exports, "downloadUrl", () => $c1f893c1652c9963$export$8a96edb1c96563f4);
const $c1f893c1652c9963$export$8a96edb1c96563f4 = (url, options)=>{
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    if (options && options.name) link.download = options.name;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

});

parcelRegister("bbNl0", function(module, exports) {
$parcel$export(module.exports, "isUploadingFileState", () => $071e98cd60064284$export$70eb3481b487c668);
$parcel$export(module.exports, "isProcessingFileState", () => $071e98cd60064284$export$5c30e6dd75278e66);
$parcel$export(module.exports, "isProcessedFileState", () => $071e98cd60064284$export$1d17291aafa5f231);
$parcel$export(module.exports, "isErrorFileState", () => $071e98cd60064284$export$f863e1e09c8a926);
$parcel$export(module.exports, "isPreviewableFileState", () => $071e98cd60064284$export$92dd692b31e42e64);
$parcel$export(module.exports, "isFinalFileState", () => $071e98cd60064284$export$270b3fc27120edd0);
$parcel$export(module.exports, "isNonErrorFinalFileState", () => $071e98cd60064284$export$8f33148a37b0c72f);
$parcel$export(module.exports, "hasArtifacts", () => $071e98cd60064284$export$ecdf3dee1d148302);
$parcel$export(module.exports, "isImageRepresentationReady", () => $071e98cd60064284$export$4e33ccde53b4f0bf);
$parcel$export(module.exports, "mapMediaFileToFileState", () => $071e98cd60064284$export$ddfd67d20657322f);
$parcel$export(module.exports, "mapMediaItemToFileState", () => $071e98cd60064284$export$ea3730792e8bebfb);
const $071e98cd60064284$export$70eb3481b487c668 = (fileState)=>fileState.status === 'uploading';
const $071e98cd60064284$export$5c30e6dd75278e66 = (fileState)=>fileState.status === 'processing';
const $071e98cd60064284$export$1d17291aafa5f231 = (fileState)=>fileState.status === 'processed';
const $071e98cd60064284$export$f863e1e09c8a926 = (fileState)=>fileState.status === 'error';
const $071e98cd60064284$export$92dd692b31e42e64 = (fileState)=>!$071e98cd60064284$export$f863e1e09c8a926(fileState) && !!fileState.preview;
const $071e98cd60064284$export$270b3fc27120edd0 = (fileState)=>[
        'processed',
        'failed-processing',
        'error'
    ].includes(fileState.status);
const $071e98cd60064284$export$8f33148a37b0c72f = (fileState)=>[
        'processed',
        'failed-processing'
    ].includes(fileState.status);
const $071e98cd60064284$export$ecdf3dee1d148302 = (fileState)=>'artifacts' in fileState && fileState.artifacts !== undefined;
const $071e98cd60064284$export$4e33ccde53b4f0bf = (fileState)=>{
    switch(fileState.status){
        case 'processing':
        case 'processed':
        case 'failed-processing':
            return !!(fileState.representations && fileState.representations.image);
        default:
            return false;
    }
};
const $071e98cd60064284$export$ddfd67d20657322f = (mediaFile)=>{
    const { id: id, name: name, size: size, processingStatus: processingStatus, artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, representations: representations, createdAt: createdAt, metadataTraceContext: metadataTraceContext, hash: hash, abuseClassification: abuseClassification, mediaMetadata: mediaMetadata } = mediaFile.data;
    const baseState = {
        id: id,
        name: name,
        size: size,
        mediaType: mediaType,
        mimeType: mimeType,
        artifacts: artifacts,
        representations: representations,
        createdAt: createdAt,
        hash: hash,
        metadataTraceContext: metadataTraceContext,
        abuseClassification: abuseClassification,
        mediaMetadata: mediaMetadata
    };
    switch(processingStatus){
        case 'pending':
        case undefined:
            return {
                ...baseState,
                status: 'processing'
            };
        case 'succeeded':
            return {
                ...baseState,
                status: 'processed'
            };
        case 'failed':
            return {
                ...baseState,
                status: 'failed-processing'
            };
    }
};
const $071e98cd60064284$export$ea3730792e8bebfb = (id, item)=>{
    return $071e98cd60064284$export$ddfd67d20657322f({
        data: {
            id: id,
            ...item
        }
    });
};

});

parcelRegister("1GWfm", function(module, exports) {
$parcel$export(module.exports, "FileFetcherError", () => $a248c46a7558c626$export$e3e60f0dab8641de);

var $4rKJa = parcelRequire("4rKJa");
class $a248c46a7558c626$export$e3e60f0dab8641de extends (0, $4rKJa.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
        this.id = metadata.id;
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { id: id, collectionName: collectionName, occurrenceKey: occurrenceKey, traceContext: traceContext } } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            ...traceContext && {
                metadata: {
                    traceContext: traceContext
                }
            }
        };
    }
}
function $a248c46a7558c626$export$5c3435f75ce0ce70(err) {
    return err instanceof $a248c46a7558c626$export$e3e60f0dab8641de;
}

});

parcelRegister("2mMyO", function(module, exports) {
$parcel$export(module.exports, "uploadFile", () => $d0f3b9835713140d$export$a5575dbeeffdad98);

var $irjb3 = parcelRequire("irjb3");

var $2opa2 = parcelRequire("2opa2");

var $4pIMA = parcelRequire("4pIMA");

var $keN2a = parcelRequire("keN2a");

var $bpbRw = parcelRequire("bpbRw");

var $6PCIn = parcelRequire("6PCIn");

var $jZL78 = parcelRequire("jZL78");
const $d0f3b9835713140d$var$hashingFunction = async (blob, hashAlgorithm)=>{
    const hasher = await (0, $keN2a.createHasher)(hashAlgorithm);
    return hasher.hash(blob);
};
const $d0f3b9835713140d$var$createUploadingFunction = (store, deferredUploadId, collectionName, traceContext)=>async (chunk)=>{
        return await store.uploadChunk(chunk.hash, chunk.blob, await deferredUploadId, chunk.partNumber, collectionName, traceContext);
    };
const $d0f3b9835713140d$var$createProcessingFunction = (store, deferredUploadId, collection, traceContext)=>{
    let offset = 0;
    return async (chunks)=>{
        await store.appendChunksToUpload(await deferredUploadId, {
            chunks: $d0f3b9835713140d$var$hashedChunks(chunks),
            offset: offset
        }, collection, traceContext);
        offset += chunks.length;
    };
};
const $d0f3b9835713140d$var$createFileFromUpload = async (file, store, uploadableFileUpfrontIds, uploadId, traceContext)=>{
    const { collection: collection, name: name, mimeType: mimeType } = file;
    const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    const body = file.size ? {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType,
        conditions: {
            size: file.size
        }
    } : {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType
    };
    return store.createFileFromUpload(body, {
        occurrenceKey: occurrenceKey,
        collection: collection,
        replaceFileId: id
    }, traceContext);
};
const $d0f3b9835713140d$export$a5575dbeeffdad98 = (file, store, uploadableFileUpfrontIds, callbacks, traceContext)=>{
    const { content: content, collection: collection } = file;
    const { deferredUploadId: deferredUploadId, id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    let chunkSize = (0, $6PCIn.CHUNK_SIZE);
    try {
        if (content instanceof Blob) chunkSize = (0, $jZL78.calculateChunkSize)(content.size);
    } catch (err) {
        if (err instanceof Error && err.message === (0, $jZL78.fileSizeError)) callbacks?.onUploadFinish(new (0, $bpbRw.UploaderError)(err.message, {
            id: id,
            collectionName: collection,
            occurrenceKey: occurrenceKey
        }));
        return {
            cancel: ()=>{
                callbacks?.onUploadFinish('canceled');
            }
        };
    }
    const chunkinatorObservable = (0, $irjb3.chunkinator)(content, {
        hashingFunction: (blob)=>$d0f3b9835713140d$var$hashingFunction(blob, store.chunkHashAlgorithm),
        hashingConcurrency: 5,
        chunkSize: chunkSize,
        uploadingConcurrency: 3,
        uploadingFunction: $d0f3b9835713140d$var$createUploadingFunction(store, deferredUploadId, collection, traceContext),
        processingBatchSize: (0, $6PCIn.PROCESSING_BATCH_SIZE),
        processingFunction: $d0f3b9835713140d$var$createProcessingFunction(store, deferredUploadId, collection, traceContext)
    }, {
        onProgress (progress) {
            if (callbacks) callbacks.onProgress(progress);
        }
    });
    const onUploadFinish = callbacks && callbacks.onUploadFinish || (()=>{});
    const subscription = (0, $2opa2.from)(deferredUploadId).pipe((0, $4pIMA.concatMap)((uploadId)=>chunkinatorObservable.pipe((0, $4pIMA.concatMap)(()=>(0, $2opa2.from)($d0f3b9835713140d$var$createFileFromUpload(file, store, uploadableFileUpfrontIds, uploadId, traceContext)))))).subscribe({
        error: (err)=>onUploadFinish(err),
        complete: ()=>onUploadFinish()
    });
    return {
        cancel: ()=>{
            subscription.unsubscribe();
            onUploadFinish('canceled');
        }
    };
};
const $d0f3b9835713140d$var$hashedChunks = (chunks)=>chunks.map((chunk)=>chunk.hash);

});
parcelRegister("irjb3", function(module, exports) {
$parcel$export(module.exports, "chunkinator", () => $d61183fbf8357e07$export$9ab6bef3838698f8);

var $jgII5 = parcelRequire("jgII5");

var $4pIMA = parcelRequire("4pIMA");

var $aoje7 = parcelRequire("aoje7");

var $9cPse = parcelRequire("9cPse");

var $fjIB7 = parcelRequire("fjIB7");

var $iyZWI = parcelRequire("iyZWI");

var $htAnC = parcelRequire("htAnC");

var $h9RjH = parcelRequire("h9RjH");

var $aN4rI = parcelRequire("aN4rI");

var $2opa2 = parcelRequire("2opa2");
const $d61183fbf8357e07$export$88e80b3a0bb31f63 = (file, options, callbacks)=>(0, $9cPse.fromPromise)((0, $aN4rI.fetchBlob)(file)).pipe((0, $4pIMA.concatMap)((blob)=>{
        const { chunkSize: chunkSize } = options;
        const { onProgress: onProgress } = callbacks;
        const totalChunks = Math.ceil(blob.size / chunkSize);
        const slicenatedBlobs = (0, $fjIB7.slicenator)(blob, {
            size: chunkSize
        });
        const hashinatedBlobs = (0, $iyZWI.hashinator)(slicenatedBlobs, {
            concurrency: options.hashingConcurrency,
            hasher: options.hashingFunction
        });
        let uploadedChunks = 0;
        let uploadedBlobs = (0, $htAnC.uploadinator)(hashinatedBlobs, {
            concurrency: options.uploadingConcurrency,
            uploader: options.uploadingFunction
        });
        if (onProgress) uploadedBlobs = uploadedBlobs.pipe((0, $jgII5.tap)(()=>{
            uploadedChunks += 1;
            onProgress(uploadedChunks / totalChunks);
        }));
        return (0, $h9RjH.processinator)(uploadedBlobs, {
            batchSize: options.processingBatchSize,
            processor: options.processingFunction
        }).pipe((0, $4pIMA.concatMap)((batchedChunks)=>{
            return (0, $2opa2.from)(batchedChunks);
        }), (0, $aoje7.bufferCount)(totalChunks));
    }));
const $d61183fbf8357e07$export$9ab6bef3838698f8 = (file, options, callbacks)=>{
    return $d61183fbf8357e07$export$88e80b3a0bb31f63(file, options, callbacks);
};

});
parcelRegister("fjIB7", function(module, exports) {
$parcel$export(module.exports, "slicenator", () => $0dec34349839a009$export$5b92d769f2f57509);

var $4NFCE = parcelRequire("4NFCE");

var $3PmNk = parcelRequire("3PmNk");
const $0dec34349839a009$export$5b92d769f2f57509 = (blob, { size: chunkSize })=>{
    const totalChunks = Math.ceil(blob.size / chunkSize);
    return (0, $4NFCE.range)(0, totalChunks).pipe((0, $3PmNk.map)((index)=>{
        return {
            partNumber: index + 1,
            blob: blob.slice(index * chunkSize, (index + 1) * chunkSize)
        };
    }));
};

});

parcelRegister("iyZWI", function(module, exports) {
$parcel$export(module.exports, "hashinator", () => $946c6df5bbe7edda$export$d5f5a550a38ec367);

var $aN4rI = parcelRequire("aN4rI");
const $946c6df5bbe7edda$export$28a452a485721473 = (hasher)=>(slicedBlob)=>hasher(slicedBlob.blob).then((hash)=>({
                blob: slicedBlob.blob,
                hash: `${hash}-${slicedBlob.blob.size}`,
                partNumber: slicedBlob.partNumber
            }));
const $946c6df5bbe7edda$export$d5f5a550a38ec367 = (blobs$, { hasher: hasher, concurrency: concurrency })=>(0, $aN4rI.asyncMap)($946c6df5bbe7edda$export$28a452a485721473(hasher), concurrency)(blobs$);

});
parcelRegister("aN4rI", function(module, exports) {
$parcel$export(module.exports, "fetchBlob", () => $6bb2bbe9f31d7b02$export$14e9cfd4a872cc1e);
$parcel$export(module.exports, "asyncMap", () => $6bb2bbe9f31d7b02$export$707ee4c4c95d39e3);

var $7kixv = parcelRequire("7kixv");

var $eynBz = parcelRequire("eynBz");
async function $6bb2bbe9f31d7b02$export$14e9cfd4a872cc1e(file) {
    if (typeof file === 'string') return await fetch(file).then((response)=>response.blob());
    else return file;
}
const $6bb2bbe9f31d7b02$var$notify = (promise, observer, onReady)=>{
    const notifier = {
        notifyIfReady: ()=>false
    };
    promise.then((value)=>{
        notifier.notifyIfReady = ()=>{
            observer.next(value);
            observer.complete();
            return true;
        };
        onReady(notifier);
    }, (reason)=>{
        notifier.notifyIfReady = ()=>{
            observer.error(reason);
            return true;
        };
        onReady(notifier);
    });
    return notifier;
};
const $6bb2bbe9f31d7b02$var$mapper = (project)=>{
    const notifiers = new Array();
    const onReady = ()=>{
        // find the first non-ready notifier in the queue,
        // while invoking all ready notifiers that we encounter along the way
        const notReadyIdx = notifiers.findIndex((notifier)=>!notifier.notifyIfReady());
        if (notReadyIdx > 0) // remove all the notifiers we invoked
        notifiers.splice(0, notReadyIdx);
    };
    return (value)=>new (0, $7kixv.Observable)((sub)=>{
            notifiers.push($6bb2bbe9f31d7b02$var$notify(project(value), sub, onReady));
        });
};
const $6bb2bbe9f31d7b02$export$707ee4c4c95d39e3 = (project, concurrent)=>(0, $eynBz.mergeMap)($6bb2bbe9f31d7b02$var$mapper(project), concurrent);

});


parcelRegister("htAnC", function(module, exports) {
$parcel$export(module.exports, "uploadinator", () => $376f95738497d04c$export$94ce0f3fcf999415);

var $aN4rI = parcelRequire("aN4rI");
const $376f95738497d04c$export$94ce0f3fcf999415 = (blobs$, options)=>{
    const upload = (blob)=>{
        return options.uploader(blob).then(()=>blob);
    };
    return blobs$.pipe((0, $aN4rI.asyncMap)(upload, options.concurrency));
};

});

parcelRegister("h9RjH", function(module, exports) {
$parcel$export(module.exports, "processinator", () => $cfa6e3d7bb356500$export$2f21790600302ed);

var $aoje7 = parcelRequire("aoje7");

var $4pIMA = parcelRequire("4pIMA");
const $cfa6e3d7bb356500$export$2f21790600302ed = (blobs$, options)=>{
    const process = (blobs)=>{
        if (options.processor) return options.processor(blobs).then(()=>blobs);
        else return Promise.resolve(blobs);
    };
    return blobs$.pipe((0, $aoje7.bufferCount)(options.batchSize)).pipe((0, $4pIMA.concatMap)(process));
};

});


parcelRegister("keN2a", function(module, exports) {
$parcel$export(module.exports, "createHasher", () => $a41e44f7241fbce8$export$14b114effbc08b6b);
parcelRequire("1jG9B");
var $9t1Mu = parcelRequire("9t1Mu");
let $a41e44f7241fbce8$var$hasher = null;
let $a41e44f7241fbce8$var$sha256Hasher = null;
const $a41e44f7241fbce8$export$d9c9d11cd648a505 = ()=>{
    $a41e44f7241fbce8$var$hasher = null;
    $a41e44f7241fbce8$var$sha256Hasher = null;
};


const $a41e44f7241fbce8$export$14b114effbc08b6b = async (algorithm)=>{
    try {
        if (algorithm === (0, $9t1Mu.ChunkHashAlgorithm).Sha256) {
            if (!$a41e44f7241fbce8$var$sha256Hasher) {
                // TODO this needs to support worker sha256 hasher as well
                const { SimpleHasher: SimpleHasher } = await (parcelRequire("2D0dL"));
                $a41e44f7241fbce8$var$sha256Hasher = new SimpleHasher();
            }
            return $a41e44f7241fbce8$var$sha256Hasher;
        }
    } catch (error) {}
    const { SimpleHasher: SimpleHasher } = await (parcelRequire("got4H"));
    $a41e44f7241fbce8$var$hasher = new SimpleHasher();
    return $a41e44f7241fbce8$var$hasher;
};

});
parcelRegister("2D0dL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kxQbf").then(()=>parcelRequire('g8wZ9'));

});

parcelRegister("got4H", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("6rET6")
]).then(()=>parcelRequire('cPCGi'));

});


parcelRegister("bpbRw", function(module, exports) {
$parcel$export(module.exports, "UploaderError", () => $85ab3781ae20a637$export$515240c3f059c807);

var $4rKJa = parcelRequire("4rKJa");
class $85ab3781ae20a637$export$515240c3f059c807 extends (0, $4rKJa.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
        this.id = metadata.id;
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { id: id, collectionName: collectionName, occurrenceKey: occurrenceKey } } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey
        };
    }
}
function $85ab3781ae20a637$export$80ee180172bc336(err) {
    return err instanceof $85ab3781ae20a637$export$515240c3f059c807;
}

});

parcelRegister("jZL78", function(module, exports) {
$parcel$export(module.exports, "fileSizeError", () => $b71a6cbe9ec1a24a$export$b36239e4c33c2902);
$parcel$export(module.exports, "calculateChunkSize", () => $b71a6cbe9ec1a24a$export$71f452e02035c1e2);

var $jmTJ7 = parcelRequire("jmTJ7");

var $6PCIn = parcelRequire("6PCIn");
const $b71a6cbe9ec1a24a$export$b36239e4c33c2902 = 'fileSizeExceedsLimit';
const $b71a6cbe9ec1a24a$export$71f452e02035c1e2 = (fileSize)=>{
    if (fileSize > (0, $6PCIn.MAX_UPLOAD_FILE_SIZE)) throw new Error($b71a6cbe9ec1a24a$export$b36239e4c33c2902);
    if (fileSize <= 5 * (0, $jmTJ7.DATA_UNIT).GB) return 5 * (0, $jmTJ7.DATA_UNIT).MB;
    if (fileSize > 5 * (0, $jmTJ7.DATA_UNIT).GB && fileSize <= 50 * (0, $jmTJ7.DATA_UNIT).GB) return 50 * (0, $jmTJ7.DATA_UNIT).MB;
    if (fileSize > 50 * (0, $jmTJ7.DATA_UNIT).GB && fileSize <= 0.95 * (0, $jmTJ7.DATA_UNIT).TB) return 100 * (0, $jmTJ7.DATA_UNIT).MB;
    return 210 * (0, $jmTJ7.DATA_UNIT).MB;
};

});


parcelRegister("abkQS", function(module, exports) {
$parcel$export(module.exports, "getFileStreamsCache", () => $20fb1b7a81082f5e$export$f2f061938c1e6810);
class $20fb1b7a81082f5e$export$4293896e79732236 {
    constructor(streams){
        this.streams = streams;
    }
    has(id) {
        return !!this.streams.find(id);
    }
    set(id, stream) {
        this.streams.set(id, stream);
    }
    get(id) {
        return this.streams.get(id);
    }
    getOrInsert(id, callback) {
        if (!this.has(id)) this.set(id, callback());
        return this.get(id);
    }
    removeAll() {
        this.streams.clear();
    }
    remove(id) {
        this.streams.delete(id);
    }
    get size() {
        return this.streams.size;
    }
}
let $20fb1b7a81082f5e$var$streamCache;

const $20fb1b7a81082f5e$export$f2f061938c1e6810 = ()=>{
    if (!$20fb1b7a81082f5e$var$streamCache) {
        // TODO: we can move this into a static import like
        // import {mediaState} from '@atlaskit/media-core'
        const mediaState = (parcelRequire("bLPxw")).mediaState;
        $20fb1b7a81082f5e$var$streamCache = new $20fb1b7a81082f5e$export$4293896e79732236(mediaState.streams);
    }
    return $20fb1b7a81082f5e$var$streamCache;
};

});

parcelRegister("lRBVi", function(module, exports) {
$parcel$export(module.exports, "globalMediaEventEmitter", () => $175af825576b091d$export$68d003d3105952ad);
parcelRequire("1jG9B");
var $bLPxw = parcelRequire("bLPxw");
const $175af825576b091d$export$68d003d3105952ad = {
    on (event, listener) {
        if ((0, $bLPxw.mediaState).eventEmitter) (0, $bLPxw.mediaState).eventEmitter.on(event, listener);
    },
    off (event, listener) {
        if ((0, $bLPxw.mediaState).eventEmitter) (0, $bLPxw.mediaState).eventEmitter.off(event, listener);
    },
    emit (event, payload) {
        if ((0, $bLPxw.mediaState).eventEmitter) return (0, $bLPxw.mediaState).eventEmitter.emit(event, payload);
        return undefined;
    }
};

});

parcelRegister("eaj78", function(module, exports) {
// Regular expression used for basic parsing of the uuid.

var $5Ovjr = parcelRequire("5Ovjr");
var $a500d3812b6eabd3$require$Buffer = $5Ovjr.Buffer;
var $a500d3812b6eabd3$var$pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/**
 * Unparses a UUID buffer to a string. From node-uuid:
 * https://github.com/defunctzombie/node-uuid/blob/master/uuid.js
 *
 * Copyright (c) 2010-2012 Robert Kieffer
 * MIT License - http://opensource.org/licenses/mit-license.php
 *
 * @param  {Buffer} buf
 * @param  {Number=0} offset
 * @return {String}
 */ var $a500d3812b6eabd3$var$_byteToHex = [];
for(var $a500d3812b6eabd3$var$i = 0; $a500d3812b6eabd3$var$i < 256; $a500d3812b6eabd3$var$i++)$a500d3812b6eabd3$var$_byteToHex[$a500d3812b6eabd3$var$i] = ($a500d3812b6eabd3$var$i + 0x100).toString(16).substr(1);
function $a500d3812b6eabd3$var$unparse(buf, offset) {
    var i = offset || 0, bth = $a500d3812b6eabd3$var$_byteToHex;
    return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
}
/**
 * Determines whether the uuid is valid, converting
 * it from a buffer if necessary.
 *
 * @param  {String|Buffer}  uuid
 * @param  {Number=}  version
 * @return {Boolean}
 */ module.exports = function(uuid, version) {
    var parsedUuid;
    // If the uuid is a biffer, parse it...
    if ($a500d3812b6eabd3$require$Buffer.isBuffer(uuid)) parsedUuid = $a500d3812b6eabd3$var$unparse(uuid);
    else if (Object.prototype.toString.call(uuid) === '[object String]') parsedUuid = uuid;
    else return false;
    parsedUuid = parsedUuid.toLowerCase();
    // All UUIDs fit a basic schema. Match that.
    if (!$a500d3812b6eabd3$var$pattern.test(parsedUuid)) return false;
    // Now extract the version...
    if (version === undefined) version = $a500d3812b6eabd3$var$extractVersion(parsedUuid);
    else if ($a500d3812b6eabd3$var$extractVersion(parsedUuid) !== version) return false;
    switch(version){
        // For certain versions, the checks we did up to this point are fine.
        case 1:
        case 2:
            return true;
        // For versions 3 and 4, they must specify a variant.
        case 3:
        case 4:
        case 5:
            return [
                '8',
                '9',
                'a',
                'b'
            ].indexOf(parsedUuid.charAt(19)) !== -1;
        default:
            // We should only be able to reach this if the consumer explicitly
            // provided an invalid version. Prior to extractVersion we check
            // that it's 1-4 in the regex.
            throw new Error('Invalid version provided.');
    }
};
/**
 * Extracts the version from the UUID, which is (by definition) the M in
 * xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx
 *
 * @param  {String} uuid
 * @return {Number}
 */ var $a500d3812b6eabd3$var$extractVersion = module.exports.version = function(uuid) {
    return uuid.charAt(14) | 0;
};

});

parcelRegister("hRxrn", function(module, exports) {
$parcel$export(module.exports, "createFileDataloader", () => $611f84914cb6f1a5$export$ae188fee39529b82);

var $79KwK = parcelRequire("79KwK");

var $3xaEP = parcelRequire("3xaEP");
const $611f84914cb6f1a5$export$b79d95ee17a87a = 100;
const $611f84914cb6f1a5$var$isBatchLoadingErrorResult = (result)=>{
    return result.error instanceof Error;
};
const $611f84914cb6f1a5$var$isResponseFileItem = (fileItem)=>{
    return 'details' in fileItem;
};
const $611f84914cb6f1a5$var$makeCacheKey = (id, collection)=>collection ? `${id}-${collection}` : id;
const $611f84914cb6f1a5$export$71cd2e8f8162d47b = (dataloaderKeys, fileItems)=>{
    const itemsByKey = fileItems.reduce((prev, fileItem)=>{
        const { id: id, collection: collection } = fileItem;
        const key = $611f84914cb6f1a5$var$makeCacheKey(id, collection);
        if ($611f84914cb6f1a5$var$isBatchLoadingErrorResult(fileItem)) prev[key] = fileItem.error;
        else if ($611f84914cb6f1a5$var$isResponseFileItem(fileItem)) prev[key] = {
            ...fileItem.details,
            metadataTraceContext: fileItem.metadataTraceContext
        };
        else prev[key] = {
            id: id,
            collection: collection,
            type: 'not-found',
            metadataTraceContext: fileItem.metadataTraceContext
        };
        return prev;
    }, {});
    return dataloaderKeys.map((dataloaderKey)=>{
        const { id: id, collectionName: collectionName } = dataloaderKey;
        const key = $611f84914cb6f1a5$var$makeCacheKey(id, collectionName);
        return itemsByKey[key] || {
            id: id,
            type: 'not-found'
        };
    });
};
function $611f84914cb6f1a5$export$4a53beb129e8c49a(mediaStore) {
    return async (keys)=>{
        const nonCollectionName = '__media-single-file-collection__';
        const includeHashByCollection = keys.reduce((acc, key)=>{
            const collectionName = key.collectionName || nonCollectionName;
            if (key.includeHashForDuplicateFiles) acc[collectionName] = key.includeHashForDuplicateFiles;
            return acc;
        }, {});
        const fileIdsByCollection = keys.reduce((acc, key)=>{
            const collectionName = key.collectionName || nonCollectionName;
            const fileIds = acc[collectionName] || [];
            // de-duplicate ids in collection
            if (fileIds.indexOf(key.id) === -1) fileIds.push(key.id);
            acc[collectionName] = fileIds;
            return acc;
        }, {});
        const items = [];
        await Promise.all(Object.keys(fileIdsByCollection).map(async (collectionNameKey)=>{
            const metadataTraceContext = {
                traceId: (0, $3xaEP.getRandomTelemetryId)(),
                spanId: (0, $3xaEP.getRandomTelemetryId)()
            };
            const fileIds = fileIdsByCollection[collectionNameKey];
            const includeHashForDuplicateFiles = includeHashByCollection[collectionNameKey];
            const collectionName = collectionNameKey === nonCollectionName ? undefined : collectionNameKey;
            try {
                const response = await mediaStore.getItems(fileIds, collectionName, metadataTraceContext, includeHashForDuplicateFiles);
                const itemsWithMetadataTraceContext = response.data.items.map((item)=>({
                        ...item,
                        metadataTraceContext: metadataTraceContext
                    }));
                items.push(...itemsWithMetadataTraceContext);
                // add EmptyResponseFileItem for each file ID not included in /items response
                const itemsIds = itemsWithMetadataTraceContext.map((item)=>item.id);
                const fileIdsNotFound = fileIds.filter((id)=>!itemsIds.includes(id));
                fileIdsNotFound.forEach((fileId)=>{
                    items.push({
                        id: fileId,
                        collection: collectionName,
                        type: 'not-found',
                        metadataTraceContext: metadataTraceContext
                    });
                });
            } catch (error) {
                fileIds.forEach((fileId)=>{
                    items.push({
                        id: fileId,
                        collection: collectionName,
                        error: error
                    });
                });
            }
        }));
        return $611f84914cb6f1a5$export$71cd2e8f8162d47b(keys, items);
    };
}
function $611f84914cb6f1a5$export$ae188fee39529b82(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($79KwK)))($611f84914cb6f1a5$export$4a53beb129e8c49a(mediaStore), {
        maxBatchSize: $611f84914cb6f1a5$export$b79d95ee17a87a
    });
}

});
parcelRegister("79KwK", function(module, exports) {

var $igDjg = parcelRequire("igDjg");
"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $535d76fea738a4fd$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $535d76fea738a4fd$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $535d76fea738a4fd$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $535d76fea738a4fd$var$getValidCacheKeyFn(options);
        this._cacheMap = $535d76fea738a4fd$var$getValidCacheMap(options);
        this._batch = null;
        this.name = $535d76fea738a4fd$var$getValidName(options);
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
        var batch = $535d76fea738a4fd$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey = this._cacheKeyFn(key); // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    } /**
   * Loads multiple keys, promising an array of values:
   *
   *     var [ a, b ] = await myLoader.loadMany([ 'a', 'b' ]);
   *
   * This is similar to the more verbose:
   *
   *     var [ a, b ] = await Promise.all([
   *       myLoader.load('a'),
   *       myLoader.load('b')
   *     ]);
   *
   * However it is different in the case where any load fails. Where
   * Promise.all() would reject, loadMany() always resolves, however each result
   * is either a value or an Error instance.
   *
   *     var [ a, b, c ] = await myLoader.loadMany([ 'a', 'b', 'badkey' ]);
   *     // c instanceof Error
   *
   */ ;
    _proto.loadMany = function loadMany(keys) {
        if (!$535d76fea738a4fd$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    } /**
   * Clears the value at `key` from the cache, if it exists. Returns itself for
   * method chaining.
   */ ;
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    } /**
   * Clears the entire cache. To be used when some event results in unknown
   * invalidations across this particular `DataLoader`. Returns itself for
   * method chaining.
   */ ;
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    } /**
   * Adds the provided key and value to the cache. If the key already
   * exists, no change is made. Returns itself for method chaining.
   *
   * To prime the cache with an error at a key, provide an Error instance.
   */ ;
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    } /**
   * The name given to this `DataLoader` instance. Useful for APM tools.
   *
   * Is `null` if not set in the constructor.
   */ ;
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $535d76fea738a4fd$var$enqueuePostPromiseJob = typeof $igDjg === 'object' && typeof $igDjg.nextTick === 'function' ? function(fn) {
    if (!$535d76fea738a4fd$var$resolvedPromise) $535d76fea738a4fd$var$resolvedPromise = Promise.resolve();
    $535d76fea738a4fd$var$resolvedPromise.then(function() {
        $igDjg.nextTick(fn);
    });
} : typeof setImmediate === 'function' ? function(fn) {
    setImmediate(fn);
} : function(fn) {
    setTimeout(fn);
}; // Private: cached resolved Promise instance
var $535d76fea738a4fd$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $535d76fea738a4fd$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        $535d76fea738a4fd$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $535d76fea738a4fd$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $535d76fea738a4fd$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise;
    try {
        batchPromise = loader._batchLoadFn(batch.keys);
    } catch (e) {
        return $535d76fea738a4fd$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
    } // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $535d76fea738a4fd$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$535d76fea738a4fd$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $535d76fea738a4fd$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var value = values[i];
            if (value instanceof Error) batch.callbacks[i].reject(value);
            else batch.callbacks[i].resolve(value);
        }
    })["catch"](function(error) {
        $535d76fea738a4fd$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $535d76fea738a4fd$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $535d76fea738a4fd$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $535d76fea738a4fd$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $535d76fea738a4fd$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $535d76fea738a4fd$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $535d76fea738a4fd$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $535d76fea738a4fd$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $535d76fea738a4fd$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
}
function $535d76fea738a4fd$var$getValidName(options) {
    if (options && options.name) return options.name;
    return null;
} // Private
function $535d76fea738a4fd$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $535d76fea738a4fd$var$DataLoader;

});


parcelRegister("atDjN", function(module, exports) {
$parcel$export(module.exports, "getMediaTypeFromUploadableFile", () => $4c3ee7170cb316c1$export$ac3214931ffd82af);

var $5JVfG = parcelRequire("5JVfG");
const $4c3ee7170cb316c1$export$ac3214931ffd82af = (file)=>{
    if (file.content instanceof Blob) {
        const type = file.content.type;
        return (0, $5JVfG.getMediaTypeFromMimeType)(type);
    } else return 'unknown';
};

});
parcelRegister("5JVfG", function(module, exports) {
$parcel$export(module.exports, "getMediaTypeFromMimeType", () => $2a0d3eeca821ff8d$export$79e1dc0d1801e8ef);
$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => (parcelRequire("fK3MF")).isImageMimeTypeSupportedByBrowser);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => (parcelRequire("fK3MF")).isVideoMimeTypeSupportedByBrowser);

var $5hd6w = parcelRequire("5hd6w");

var $fK3MF = parcelRequire("fK3MF");

var $i9yw1 = parcelRequire("i9yw1");
const $2a0d3eeca821ff8d$export$79e1dc0d1801e8ef = (mimeType)=>{
    if ((0, $5hd6w.isArchive)(mimeType)) return 'archive';
    if ((0, $fK3MF.isImageMimeTypeSupportedByBrowser)(mimeType) || (0, $i9yw1.isImageMimeTypeSupportedByServer)(mimeType)) return 'image';
    if ((0, $fK3MF.isDocumentMimeTypeSupportedByBrowser)(mimeType) || (0, $i9yw1.isDocumentMimeTypeSupportedByServer)(mimeType)) return 'doc';
    if ((0, $fK3MF.isAudioMimeTypeSupportedByBrowser)(mimeType) || (0, $i9yw1.isAudioMimeTypeSupportedByServer)(mimeType)) return 'audio';
    if ((0, $fK3MF.isVideoMimeTypeSupportedByBrowser)(mimeType) || (0, $i9yw1.isVideoMimeTypeSupportedByServer)(mimeType)) return 'video';
    return 'unknown';
};

});
parcelRegister("5hd6w", function(module, exports) {
$parcel$export(module.exports, "isArchive", () => $d95d3f124d05d5e2$export$f47f3fe506e20fe6);
// Based on https://en.wikipedia.org/wiki/List_of_archive_formats
const $d95d3f124d05d5e2$export$f47f3fe506e20fe6 = (mimeType)=>[
        'application/x-archive',
        'application/x-cpio',
        'application/x-shar',
        'application/x-iso9660-image',
        'application/x-sbx',
        'application/x-tar',
        'application/x-bzip2',
        'application/gzip',
        'application/x-gzip',
        'application/x-lzip',
        'application/x-lzma',
        'application/x-lzop',
        'application/x-snappy-framed',
        'application/x-xz',
        'application/x-compress',
        'application/zstd',
        'application/x-7z-compressed',
        'application/x-ace-compressed',
        'application/x-astrotite-afa',
        'application/x-alz-compressed',
        'application/vnd.android.package-archive',
        'application/x-freearc',
        'application/x-arj',
        'application/x-b1',
        'application/vnd.ms-cab-compressed',
        'application/x-cfs-compressed',
        'application/x-dar',
        'application/x-dgc-compressed',
        'application/x-apple-diskimage',
        'application/x-gca-compressed',
        'application/java-archive',
        'application/x-lzh',
        'application/x-lzx',
        'application/x-rar-compressed',
        'application/x-stuffit',
        'application/x-stuffitx',
        'application/x-gtar',
        'application/x-ms-wim',
        'application/x-xar',
        'application/zip',
        'application/x-zoo',
        'application/x-par2'
    ].indexOf(mimeType.toLowerCase()) > -1;

});

parcelRegister("fK3MF", function(module, exports) {
$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => $14d0a1fe72c887af$export$c021f2623a75015f);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByBrowser", () => $14d0a1fe72c887af$export$74325e3c843a9555);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByBrowser", () => $14d0a1fe72c887af$export$ff36075ea755a717);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => $14d0a1fe72c887af$export$87bf945cf31ec2d9);
$parcel$export(module.exports, "isMimeTypeSupportedByBrowser", () => $14d0a1fe72c887af$export$55ca6cdaf6093034);
// Based on https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types
const $14d0a1fe72c887af$export$c021f2623a75015f = (mimeType)=>[
        'image/apng',
        'image/bmp',
        'image/gif',
        'image/x-icon',
        'image/jpeg',
        'image/png',
        'image/webp'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $14d0a1fe72c887af$export$74325e3c843a9555 = (mimeType)=>mimeType.toLowerCase() === 'application/pdf';
const $14d0a1fe72c887af$export$ff36075ea755a717 = (mimeType)=>[
        'audio/aac',
        'audio/flac',
        'audio/mp4',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/wav',
        'audio/x-wav'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $14d0a1fe72c887af$export$87bf945cf31ec2d9 = (mimeType)=>[
        'video/mp4',
        'video/quicktime'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $14d0a1fe72c887af$export$55ca6cdaf6093034 = (mimeType)=>$14d0a1fe72c887af$export$74325e3c843a9555(mimeType) || $14d0a1fe72c887af$export$c021f2623a75015f(mimeType) || $14d0a1fe72c887af$export$ff36075ea755a717(mimeType) || $14d0a1fe72c887af$export$87bf945cf31ec2d9(mimeType);

});

parcelRegister("i9yw1", function(module, exports) {
$parcel$export(module.exports, "isImageMimeTypeSupportedByServer", () => $b92ae6a0fa1244e6$export$e9a065a80f76311e);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByServer", () => $b92ae6a0fa1244e6$export$86baad7a89d908e9);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByServer", () => $b92ae6a0fa1244e6$export$8cba23825d020bbb);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByServer", () => $b92ae6a0fa1244e6$export$9c2b4de5fdca2ce3);
$parcel$export(module.exports, "isMimeTypeSupportedByServer", () => $b92ae6a0fa1244e6$export$548d9148a80556a3);
// Based on https://developer.atlassian.com/platform/media/learning/file-previews/
const $b92ae6a0fa1244e6$export$e9a065a80f76311e = (mimeType)=>[
        'image/bmp',
        'image/x-windows-bmp',
        'application/dicom',
        'image/gif',
        'image/jpeg',
        'image/jpg',
        'image/jp_',
        'application/jpg',
        'application/x-jpg',
        'image/png',
        'application/png',
        'application/x-png',
        'application/vnd.adobe.photoshop',
        'image/vnd.adobe.photoshop',
        'image/photoshop',
        'image/x-photoshop',
        'image/psd',
        'application/photoshop',
        'application/psd',
        'zz-application/zz-winassoc-psd',
        'image/tiff',
        'image/x-tif',
        'image/x-tiff',
        'application/tif',
        'application/x-tif',
        'application/tiff',
        'application/x-tiff',
        'image/svg+xml',
        'image/heif',
        'image/heif-sequence',
        'image/heic',
        'image/heic-sequence'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $b92ae6a0fa1244e6$export$86baad7a89d908e9 = (mimeType)=>[
        // Adobe PDF
        'application/pdf',
        'application/x-pdf',
        'application/acrobat',
        'applications/vnd.pdf',
        'text/pdf',
        'text/x-pdf',
        // Adobe Illustrator
        'application/vnd.adobe.illustrator',
        // Microsoft Office
        'application/vnd.ms-office',
        // Microsoft Word
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
        'application/vnd.ms-word.document.macroenabled.12',
        'application/vnd.ms-word.template.macroenabled.12',
        // Microsoft Excel
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
        'application/vnd.ms-excel.sheet.macroenabled.12',
        'application/vnd.ms-excel.template.macroenabled.12',
        'application/vnd.ms-excel.addin.macroenabled.12',
        'application/vnd.ms-excel.sheet.macroenabled',
        'application/vnd.ms-excel.template.macroenabled',
        'application/vnd.ms-excel.addin.macroenabled',
        // Microsoft Powerpoint
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.openxmlformats-officedocument.presentationml.template',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
        'application/vnd.ms-powerpoint.presentation.macroenabled.12',
        'application/vnd.ms-powerpoint.template.macroenabled.12',
        'application/vnd.ms-powerpoint.slideshow.macroenabled.12',
        // OpenOffice
        'application/vnd.sun.xml.writer',
        'application/vnd.sun.xml.writer.template',
        // OpenDocument
        'application/vnd.sun.xml.draw',
        'application/vnd.sun.xml.draw.template',
        'application/vnd.oasis.opendocument.graphics',
        'application/vnd.oasis.opendocument.presentation',
        'application/x-vnd.oasis.opendocument.presentation',
        'application/vnd.sun.xml.calc',
        'application/vnd.sun.xml.calc.template',
        'application/vnd.oasis.opendocument.spreadsheet',
        'application/x-vnd.oasis.opendocument.spreadsheet',
        'application/vnd.oasis.opendocument.spreadsheet-template',
        'application/vnd.oasis.opendocument.text',
        'application/vnd.oasis.opendocument.text-template',
        'application/vnd.oasis.opendocument.text-master',
        'application/x-vnd.oasis.opendocument.text',
        'application/x-vnd.oasis.opendocument.text-template',
        'application/x-vnd.oasis.opendocument.text-master',
        // WordPerfect
        'application/vnd.wordperfect',
        // Text files
        'text/csv',
        'text/x-diff',
        'text/x-perl',
        'text/x-python',
        'text/x-ruby',
        'text/rtf',
        'text/richtext',
        'text/plain',
        'application/txt',
        // Rich text
        'application/rtf',
        'application/x-rtf',
        // PostScript
        'application/postscript'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $b92ae6a0fa1244e6$export$8cba23825d020bbb = (mimeType)=>[
        'audio/aac',
        'audio/x-hx-aac-adts',
        'audio/vnd.dolby.dd-raw',
        'audio/aiff',
        'audio/x-aiff',
        'audio/x-monkeys-audio',
        'audio/x-ape',
        'audio/basic',
        'audio/flac',
        'audio/mp4',
        'audio/midi',
        'audio/x-matroska',
        'audio/x-mod',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/x-pn-realaudio',
        'audio/wav',
        'audio/x-wav',
        'audio/x-ms-wma'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $b92ae6a0fa1244e6$export$9c2b4de5fdca2ce3 = (mimeType)=>[
        'video/3gpp',
        'video/3gpp2',
        'video/x-ms-asf',
        'video/avi',
        'video/msvideo',
        'video/x-msvideo',
        'video/x-dv',
        'video/x-flv',
        'video/m2ts',
        'video/x-m4v',
        'video/x-matroska',
        'video/quicktime',
        'video/mp4',
        'video/mpeg',
        'video/ogg',
        'video/x-ogg',
        'video/webm',
        'video/x-ms-wmv'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $b92ae6a0fa1244e6$export$94e1479e01d2af53 = (mimeType)=>[
        'binary/octet-stream'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $b92ae6a0fa1244e6$export$548d9148a80556a3 = (mimeType)=>$b92ae6a0fa1244e6$export$e9a065a80f76311e(mimeType) || $b92ae6a0fa1244e6$export$86baad7a89d908e9(mimeType) || $b92ae6a0fa1244e6$export$8cba23825d020bbb(mimeType) || $b92ae6a0fa1244e6$export$9c2b4de5fdca2ce3(mimeType) || $b92ae6a0fa1244e6$export$94e1479e01d2af53(mimeType);

});



parcelRegister("053B3", function(module, exports) {
$parcel$export(module.exports, "overrideMediaTypeIfUnknown", () => $492d4a64b2b2425c$export$89097c0ec1e0dee1);

var $bbNl0 = parcelRequire("bbNl0");
const $492d4a64b2b2425c$export$89097c0ec1e0dee1 = (fileState, mediaType)=>{
    if (!(0, $bbNl0.isErrorFileState)(fileState) && fileState.mediaType === 'unknown') return {
        mediaType: mediaType
    };
    return {};
};

});

parcelRegister("iDYg8", function(module, exports) {
$parcel$export(module.exports, "convertBase64ToBlob", () => $87b4c423efa40e5c$export$ed17558b11b88056);
const $87b4c423efa40e5c$export$ed17558b11b88056 = (base64)=>{
    const sliceSize = 512;
    const base64Data = base64.split(',')[1];
    const byteCharacters = atob(base64Data);
    const byteArrays = [];
    for(let offset = 0; offset < byteCharacters.length; offset += sliceSize){
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = slice.split('').map((_, i)=>slice.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
    return new Blob(byteArrays, {
        type: 'image/jpeg'
    });
};

});

parcelRegister("jFXx8", function(module, exports) {
$parcel$export(module.exports, "fromObservable", () => $a6ac257ab8a71611$export$4b2432e2d8723823);

var $jkEmk = parcelRequire("jkEmk");
function $a6ac257ab8a71611$export$4b2432e2d8723823(observable) {
    return {
        subscribe: (observer)=>{
            const subscription = // This is needed to handle "subscribe" function overload.
            // It allows accepting a single "next" callback function as an argument.
            observer instanceof Function ? observable.subscribe(observer) : observable.subscribe(observer);
            return {
                unsubscribe: ()=>{
                    subscription.unsubscribe();
                }
            };
        }
    };
}
function $a6ac257ab8a71611$export$8659d1f07d151381(item) {
    return $a6ac257ab8a71611$export$4b2432e2d8723823((0, $jkEmk.createMediaSubject)(item));
}

});
parcelRegister("jkEmk", function(module, exports) {
$parcel$export(module.exports, "createMediaSubject", () => $5f3a872941d2eff3$export$bc76d51553fa5e35);

var $86Sof = parcelRequire("86Sof");
function $5f3a872941d2eff3$export$bc76d51553fa5e35(initialState) {
    const subject = new (0, $86Sof.ReplaySubject)(1);
    if (initialState instanceof Error) subject.error(initialState);
    else if (initialState) subject.next(initialState);
    return subject;
}

});


parcelRegister("kFG4u", function(module, exports) {
$parcel$export(module.exports, "toPromise", () => $74eb9133065f0126$export$4dbaaf6c79705e6c);

var $2PBDa = parcelRequire("2PBDa");
const $74eb9133065f0126$export$4dbaaf6c79705e6c = (mediaSubscribable, subscription = new (0, $2PBDa.Subscription)())=>new Promise((resolve, reject)=>subscription.add(mediaSubscribable.subscribe({
            next: (state)=>{
                resolve(state);
                subscription.unsubscribe();
            },
            error: (error)=>{
                reject(error);
                subscription.unsubscribe();
            }
        })));

});

parcelRegister("ea8A0", function(module, exports) {
$parcel$export(module.exports, "getDimensionsFromBlob", () => $2f9cb480159d13ae$export$71797c284d89a3e1);

var $hthqT = parcelRequire("hthqT");

var $gOskN = parcelRequire("gOskN");
const $2f9cb480159d13ae$export$71797c284d89a3e1 = async (mediaType, blob)=>{
    switch(mediaType){
        case 'image':
            {
                const url = URL.createObjectURL(blob);
                try {
                    return await (0, $hthqT.getImageDimensionsFromBlob)(url);
                } finally{
                    URL.revokeObjectURL(url);
                }
            }
        case 'video':
            return (0, $gOskN.getVideoDimensionsFromBlob)(blob);
        default:
            throw new Error(`Can't extract dimensions from ${mediaType}`);
    }
};

});
parcelRegister("hthqT", function(module, exports) {
$parcel$export(module.exports, "getImageDimensionsFromBlob", () => $d7d48590d371ba3a$export$a1c3205f28a20414);
const $d7d48590d371ba3a$export$a1c3205f28a20414 = (url)=>new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = url;
        img.onload = ()=>resolve({
                width: img.width,
                height: img.height
            });
        img.onerror = reject;
    });

});

parcelRegister("gOskN", function(module, exports) {
$parcel$export(module.exports, "getVideoDimensionsFromBlob", () => $4a8128b4320ca47f$export$62aabd5ff85d0451);
const $4a8128b4320ca47f$export$62aabd5ff85d0451 = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        // loadedmetadata, loadeddata, play, playing
        video.addEventListener('loadedmetadata', function timeupdateHandler() {
            video.removeEventListener('loadedmetadata', timeupdateHandler);
            resolve({
                width: video.videoWidth,
                height: video.videoHeight
            });
            URL.revokeObjectURL(url);
        });
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});


parcelRegister("8UZz3", function(module, exports) {
$parcel$export(module.exports, "shouldFetchRemoteFileStates", () => $d7014b773fe3cff6$export$2ccdd6f9a9eba6a);

var $fK3MF = parcelRequire("fK3MF");
var $i9yw1 = parcelRequire("i9yw1");

var $gOskN = parcelRequire("gOskN");
async function $d7014b773fe3cff6$export$2ccdd6f9a9eba6a(mediaType, mimeType, preview) {
    if ((mediaType === 'doc' || !(0, $fK3MF.isMimeTypeSupportedByBrowser)(mimeType) || !preview) && (0, $i9yw1.isMimeTypeSupportedByServer)(mimeType)) return true;
    if (mediaType === 'video' && !!preview) {
        const content = (await preview).value;
        if (!(content instanceof Blob)) return false;
        try {
            const { width: width, height: height } = await (0, $gOskN.getVideoDimensionsFromBlob)(content);
            return !width && !height;
        } catch (e) {
            // any exception from getVideoDimensionsFromBlob() may imply that local video isn't playable
            // hence we'll need remote fileStates to grab a "processed" video
            return true;
        }
    }
    return false;
}

});

parcelRegister("393Zn", function(module, exports) {
$parcel$export(module.exports, "PollingFunction", () => $10b695ec33f62c2d$export$4c54d536f8e37dc2);

var $8iexj = parcelRequire("8iexj");
const $10b695ec33f62c2d$export$9f15a162d6785fc9 = {
    poll_intervalMs: 3000,
    poll_maxAttempts: 30,
    poll_backoffFactor: 1.25,
    poll_maxIntervalMs: 200000
};
class $10b695ec33f62c2d$export$4c54d536f8e37dc2 {
    constructor(options){
        this.poll_intervalMs = 0;
        this.attempt = 1;
        this.shouldIterate = true;
        this.timeoutId = 0;
        this.options = {
            ...$10b695ec33f62c2d$export$9f15a162d6785fc9,
            ...options
        };
        this.poll_intervalMs = this.options.poll_intervalMs;
    }
    async execute(executor) {
        const { poll_maxAttempts: poll_maxAttempts } = this.options;
        if (poll_maxAttempts === 0) // hard kill, polling disabled
        return this.fail(new (0, $8iexj.PollingError)('pollingMaxAttemptsExceeded', {
            attempts: this.attempt
        }));
        try {
            // executor must explicitly call this.next() for triggering next iteration (pull)
            this.shouldIterate = false;
            await executor();
            if (!this.shouldIterate) return;
            if (this.attempt >= poll_maxAttempts) // max iterations exceeded, let the consumer know
            return this.fail(new (0, $8iexj.PollingError)('pollingMaxAttemptsExceeded', {
                attempts: this.attempt
            }));
            this.poll_intervalMs = this.getIntervalMsForIteration(this.attempt);
            this.attempt++;
            this.timeoutId = window.setTimeout(()=>this.execute(executor), this.poll_intervalMs);
        } catch (error) {
            this.fail(error);
        }
    }
    fail(error) {
        const { onError: onError } = this;
        this.cancel();
        onError && onError(error);
    }
    getIntervalMsForIteration(iteration) {
        let poll_intervalMs = this.options.poll_intervalMs;
        if (iteration === 1) return poll_intervalMs;
        for(let i = 2; i <= iteration; i++)poll_intervalMs = poll_intervalMs * this.options.poll_backoffFactor;
        return Math.min(Math.round(poll_intervalMs), this.options.poll_maxIntervalMs);
    }
    next() {
        this.shouldIterate = true;
    }
    cancel() {
        window.clearTimeout(this.timeoutId);
        this.timeoutId = 0;
    }
}

});
parcelRegister("8iexj", function(module, exports) {
$parcel$export(module.exports, "PollingError", () => $76319a6a54892893$export$c3748c310e92340a);

var $4rKJa = parcelRequire("4rKJa");
class $76319a6a54892893$export$c3748c310e92340a extends (0, $4rKJa.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { attempts: attempts } } = this;
        return {
            reason: reason,
            attempts: attempts
        };
    }
}
function $76319a6a54892893$export$541e3e52eea6fece(err) {
    return err instanceof $76319a6a54892893$export$c3748c310e92340a;
}

});


parcelRegister("iX2Cl", function(module, exports) {
$parcel$export(module.exports, "isEmptyFile", () => $0723e6aaf9777481$export$728192ce8dd94659);
const $0723e6aaf9777481$export$d32fc52697b2ec92 = 43200000; /* 12 hours */ 
function $0723e6aaf9777481$export$728192ce8dd94659(fileDetails, now = Date.now()) {
    const { artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, name: name, processingStatus: processingStatus, representations: representations, size: size, createdAt: createdAt } = fileDetails;
    if (!artifacts && !mediaType && !mimeType && !name && !processingStatus && !representations && !size && typeof createdAt === 'number') {
        const msSinceFileCreation = now - createdAt;
        if (msSinceFileCreation > $0723e6aaf9777481$export$d32fc52697b2ec92) return true;
    }
    return false;
}

});

parcelRegister("48hWz", function(module, exports) {
$parcel$export(module.exports, "mediaStore", () => (parcelRequire("1ZNSP")).mediaStore);

var $1ZNSP = parcelRequire("1ZNSP");

});
parcelRegister("1ZNSP", function(module, exports) {
$parcel$export(module.exports, "mediaStore", () => $8cb4e2ad5e722a42$export$5785580dea19518d);

var $7LOiC = parcelRequire("7LOiC");

var $1pZVO = parcelRequire("1pZVO");

var $96y8R = parcelRequire("96y8R");
const $8cb4e2ad5e722a42$var$mediaStoreWithoutDevtools = (0, $96y8R.createStore)()((0, $7LOiC.subscribeWithSelector)((0, $1pZVO.immer)(()=>({
        files: {}
    }))));
const $8cb4e2ad5e722a42$var$mediaStoreWithDevtools = (0, $96y8R.createStore)()((0, $7LOiC.devtools)((0, $7LOiC.subscribeWithSelector)((0, $1pZVO.immer)(()=>({
        files: {}
    })))));
const $8cb4e2ad5e722a42$export$5785580dea19518d = $8cb4e2ad5e722a42$var$mediaStoreWithoutDevtools;
const $8cb4e2ad5e722a42$export$503459913a0dc356 = (initialStore)=>{
    return (0, $96y8R.createStore)()((0, $7LOiC.subscribeWithSelector)((0, $1pZVO.immer)(()=>({
            files: {},
            ...initialStore
        }))));
};

});
parcelRegister("7LOiC", function(module, exports) {
$parcel$export(module.exports, "devtools", () => $5a83f092dca5fc3e$export$6922d3b3a607469e);
$parcel$export(module.exports, "subscribeWithSelector", () => $5a83f092dca5fc3e$export$5c593627aef9f076);
var $5a83f092dca5fc3e$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/middleware.mjs"
});
const $5a83f092dca5fc3e$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...a)=>api.dispatch(...a),
            ...initial
        };
    };
const $5a83f092dca5fc3e$export$4feba8a1bc8e9afd = $5a83f092dca5fc3e$var$reduxImpl;
const $5a83f092dca5fc3e$var$trackedConnections = /* @__PURE__ */ new Map();
const $5a83f092dca5fc3e$var$getTrackedConnectionState = (name)=>{
    const api = $5a83f092dca5fc3e$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const $5a83f092dca5fc3e$var$extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === void 0) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = $5a83f092dca5fc3e$var$trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store: store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $5a83f092dca5fc3e$var$trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store: store,
        ...newConnection
    };
};
const $5a83f092dca5fc3e$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : ($5a83f092dca5fc3e$import_meta.env ? $5a83f092dca5fc3e$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (_e) {}
        if (!extensionConnector) {
            if (($5a83f092dca5fc3e$import_meta.env ? $5a83f092dca5fc3e$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[zustand devtools middleware] Please install/enable Redux devtools extension");
            return fn(set, get, api);
        }
        const { connection: connection, ...connectionInformation } = $5a83f092dca5fc3e$var$extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === void 0 ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === void 0) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...$5a83f092dca5fc3e$var$getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...a)=>{
                if (($5a83f092dca5fc3e$import_meta.env ? $5a83f092dca5fc3e$import_meta.env.MODE : void 0) !== "production" && a[0].type === "__setState" && !didWarnAboutReservedActionType) {
                    console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                    didWarnAboutReservedActionType = true;
                }
                originalDispatch(...a);
            };
        }
        connection.subscribe((message)=>{
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $5a83f092dca5fc3e$var$parseJsonThen(message.payload, (action)=>{
                        if (action.type === "__setState") {
                            if (store === void 0) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format. 
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($5a83f092dca5fc3e$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === void 0) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($5a83f092dca5fc3e$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $5a83f092dca5fc3e$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($5a83f092dca5fc3e$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $5a83f092dca5fc3e$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState: nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                if (!lastComputedState) return;
                                if (store === void 0) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null || connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const $5a83f092dca5fc3e$export$6922d3b3a607469e = $5a83f092dca5fc3e$var$devtoolsImpl;
const $5a83f092dca5fc3e$var$parseJsonThen = (stringified, f)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== void 0) f(parsed);
};
const $5a83f092dca5fc3e$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const $5a83f092dca5fc3e$export$5c593627aef9f076 = $5a83f092dca5fc3e$var$subscribeWithSelectorImpl;
const $5a83f092dca5fc3e$export$1be1fc439b849fdf = (initialState, create)=>(...a)=>Object.assign({}, initialState, create(...a));
function $5a83f092dca5fc3e$export$95a3b7b12ab518f9(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (_e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? void 0 : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const $5a83f092dca5fc3e$var$toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return $5a83f092dca5fc3e$var$toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return $5a83f092dca5fc3e$var$toThenable(onRejected)(e);
                }
            };
        }
    };
const $5a83f092dca5fc3e$var$oldImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            getStorage: ()=>localStorage,
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage;
        try {
            storage = options.getStorage();
        } catch (_e) {}
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const thenableSerialize = $5a83f092dca5fc3e$var$toThenable(options.serialize);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            let errorInSync;
            const thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then((serializedValue)=>storage.setItem(options.name, serializedValue)).catch((e)=>{
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        let stateFromStorage;
        const hydrate = ()=>{
            var _a;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>cb(get()));
            const postRehydrationCallback = ((_a = options.onRehydrateStorage) == null ? void 0 : _a.call(options, get())) || void 0;
            return $5a83f092dca5fc3e$var$toThenable(storage.getItem.bind(storage))(options.name).then((storageValue)=>{
                if (storageValue) return options.deserialize(storageValue);
            }).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
const $5a83f092dca5fc3e$var$newImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: $5a83f092dca5fc3e$export$95a3b7b12ab518f9(()=>localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        api.getInitialState = ()=>configResult;
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
            return $5a83f092dca5fc3e$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return [
                            true,
                            options.migrate(deserializedStorageValue.state, deserializedStorageValue.version)
                        ];
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return [
                        false,
                        deserializedStorageValue.state
                    ];
                }
                return [
                    false,
                    void 0
                ];
            }).then((migrationResult)=>{
                var _a2;
                const [migrated, migratedState] = migrationResult;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                if (migrated) return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const $5a83f092dca5fc3e$var$persistImpl = (config, baseOptions)=>{
    if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) {
        if (($5a83f092dca5fc3e$import_meta.env ? $5a83f092dca5fc3e$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead.");
        return $5a83f092dca5fc3e$var$oldImpl(config, baseOptions);
    }
    return $5a83f092dca5fc3e$var$newImpl(config, baseOptions);
};
const $5a83f092dca5fc3e$export$9a6132153fba2e0 = $5a83f092dca5fc3e$var$persistImpl;

});

parcelRegister("1pZVO", function(module, exports) {
$parcel$export(module.exports, "immer", () => $10882a850d9663b5$export$428de7ec69ac95c);

var $K2rwM = parcelRequire("K2rwM");
const $10882a850d9663b5$var$immerImpl = (initializer)=>(set, get, store)=>{
        store.setState = (updater, replace, ...a)=>{
            const nextState = typeof updater === "function" ? (0, $K2rwM.produce)(updater) : updater;
            return set(nextState, replace, ...a);
        };
        return initializer(store.setState, get, store);
    };
const $10882a850d9663b5$export$428de7ec69ac95c = $10882a850d9663b5$var$immerImpl;

});
parcelRegister("K2rwM", function(module, exports) {
$parcel$export(module.exports, "isDraft", () => r);
$parcel$export(module.exports, "isDraftable", () => t);
$parcel$export(module.exports, "immerable", () => L);
$parcel$export(module.exports, "original", () => e);
$parcel$export(module.exports, "freeze", () => d);
$parcel$export(module.exports, "nothing", () => H);
$parcel$export(module.exports, "current", () => R);
$parcel$export(module.exports, "enableES5", () => F);
$parcel$export(module.exports, "enablePatches", () => T);
$parcel$export(module.exports, "enableMapSet", () => C);
$parcel$export(module.exports, "enableAllPlugins", () => J);
$parcel$export(module.exports, "castDraft", () => K);
$parcel$export(module.exports, "castImmutable", () => $);
$parcel$export(module.exports, "Immer", () => un);
$parcel$export(module.exports, "produce", () => fn);
$parcel$export(module.exports, "produceWithPatches", () => cn);
$parcel$export(module.exports, "setAutoFreeze", () => sn);
$parcel$export(module.exports, "setUseProxies", () => vn);
$parcel$export(module.exports, "applyPatches", () => pn);
$parcel$export(module.exports, "createDraft", () => ln);
$parcel$export(module.exports, "finishDraft", () => dn);
$parcel$export(module.exports, "default", () => $08a6311ec7f77a2c$export$2e2bcd8739ae039);
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $08a6311ec7f77a2c$export$2e2bcd8739ae039 = fn;

});


parcelRegister("96y8R", function(module, exports) {
$parcel$export(module.exports, "createStore", () => $6a0f287ca3f709ed$export$f51a9068ac82ea43);
var $6a0f287ca3f709ed$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/vanilla.mjs"
});
const $6a0f287ca3f709ed$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const destroy = ()=>{
        if (($6a0f287ca3f709ed$import_meta.env ? $6a0f287ca3f709ed$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.");
        listeners.clear();
    };
    const api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const $6a0f287ca3f709ed$export$f51a9068ac82ea43 = (createState)=>createState ? $6a0f287ca3f709ed$var$createStoreImpl(createState) : $6a0f287ca3f709ed$var$createStoreImpl;
var $6a0f287ca3f709ed$export$2e2bcd8739ae039 = (createState)=>{
    if (($6a0f287ca3f709ed$import_meta.env ? $6a0f287ca3f709ed$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'.");
    return $6a0f287ca3f709ed$export$f51a9068ac82ea43(createState);
};

});



parcelRegister("bksvR", function(module, exports) {
$parcel$export(module.exports, "createCopyIntentRegisterationBatcher", () => $6bed172d1e1e47c4$export$57945b6819e39246);

var $79KwK = parcelRequire("79KwK");

var $3xaEP = parcelRequire("3xaEP");
const $6bed172d1e1e47c4$export$b79d95ee17a87a = 100;
/**
 * Returns a function that, given Array<DataloaderKey>, resolves to an array of same length containing either DataloaderResult or Error.
 * Such contract is formalised by Dataloader 1.0, @see https://github.com/graphql/dataloader
 *
 * If an Error is resolved in the results, it must be at same position then their corresponding key:
 * - Dataloader will re-throw that Error when accessing/loading that particular key
 *
 * @param mediaStore instance of MediaStore
 */ function $6bed172d1e1e47c4$var$createBatchCopyIntentRegisterationFunc(mediaStore) {
    return async (keys)=>{
        const keysByToken = keys.reduce((acc, key)=>{
            const token = key.resolvedAuth.token;
            acc[token] = acc[token] || [];
            // de-duplicate ids in collection
            const hasDuplicates = acc[token].some(({ id: id, collectionName: collectionName })=>key.id === id && collectionName === key.collectionName);
            if (!hasDuplicates) acc[token].push(key);
            return acc;
        }, {});
        const items = [];
        await Promise.all(Object.keys(keysByToken).map(async (batchKey)=>{
            const metadataTraceContext = {
                traceId: (0, $3xaEP.getRandomTelemetryId)(),
                spanId: (0, $3xaEP.getRandomTelemetryId)()
            };
            const files = keysByToken[batchKey].map((key)=>({
                    id: key.id,
                    collection: key.collectionName
                }));
            // given these are batched by the token the assumption is that they have the same details.
            const resolvedAuth = keysByToken[batchKey][0].resolvedAuth;
            try {
                await mediaStore.registerCopyIntents(files, metadataTraceContext, resolvedAuth);
            } catch (error) {
                files.forEach(({ id: id, collection: collection })=>{
                    items.push({
                        id: id,
                        collection: collection,
                        error: error
                    });
                });
            }
        }));
        return keys.map(({ id: id, collectionName: collectionName })=>{
            return items.find((item)=>item.id === id && item.collection === collectionName)?.error;
        });
    };
}
function $6bed172d1e1e47c4$export$57945b6819e39246(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($79KwK)))($6bed172d1e1e47c4$var$createBatchCopyIntentRegisterationFunc(mediaStore), {
        maxBatchSize: $6bed172d1e1e47c4$export$b79d95ee17a87a,
        cacheKeyFn: ({ id: id, collectionName: collectionName = 'default', resolvedAuth: resolvedAuth })=>`${id}-${collectionName}-${resolvedAuth.token}`
    });
}

});


parcelRegister("gWavf", function(module, exports) {
$parcel$export(module.exports, "StargateClient", () => $60a1ef1a71feccaf$export$c66ca190f89caaac);
class $60a1ef1a71feccaf$export$c66ca190f89caaac {
    constructor(baseUrl){
        this.baseUrl = baseUrl || '/gateway/api';
    }
    async fetchToken(clientId) {
        return (await fetch(`${this.baseUrl}/media/auth/smartedge`, {
            credentials: 'include',
            headers: {
                'x-client-id': clientId
            }
        })).json();
    }
    isTokenExpired(token) {
        const currentTimeInSeconds = new Date().getTime() / 1000;
        return token.data.iat + token.data.expiresIn - currentTimeInSeconds < 0;
    }
}

});

parcelRegister("921Bq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lPk9Z").then(()=>parcelRequire('h77Xn'));

});



parcelRegister("93R6D", function(module, exports) {
$parcel$export(module.exports, "MediaClientContext", () => $c470ce77068e97aa$export$ba5d7212f2b4619f);
$parcel$export(module.exports, "MediaClientProvider", () => $c470ce77068e97aa$export$5bff351c86f56d97);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aRuva = parcelRequire("aRuva");
const $c470ce77068e97aa$export$ba5d7212f2b4619f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(undefined);
const $c470ce77068e97aa$export$5bff351c86f56d97 = ({ children: children, clientConfig: clientConfig })=>{
    const mediaClient = (0, $eJOHy.useMemo)(()=>(0, $aRuva.getMediaClient)(clientConfig), [
        clientConfig
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($c470ce77068e97aa$export$ba5d7212f2b4619f.Provider, {
        value: mediaClient,
        children: children
    });
};

});


parcelRegister("jzI2h", function(module, exports) {
$parcel$export(module.exports, "ActiveHeaderIdProvider", () => $49f30dc8867dd336$export$20439b49fdd0d26c);
$parcel$export(module.exports, "ActiveHeaderIdConsumer", () => $49f30dc8867dd336$export$cddc3c6ebe2d2cec);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const { Provider: $49f30dc8867dd336$export$20439b49fdd0d26c, Consumer: $49f30dc8867dd336$var$Consumer } = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(undefined);
/**
 * We need to expose this abstraction on top of the native Consumer in order to control when
 * The consumer will get notified when a match has happened. If we use the Consumer directly in
 * Expand components without this inner state, everytime a new prop comes in, and the `newActiveHeaderId`
 * is the same as before, we will set the expand to true forever, until the active header id changes.
 * Thus, the user won't be able to collapse the expand.
 *
 * By exposing `onNestedHeaderIdMatch` here we can control when will consumers be notified:
 * only when a `newActiveHeaderId` comes in from the Provider and the list of header ids includes it.
 */ const $49f30dc8867dd336$export$cddc3c6ebe2d2cec = ({ nestedHeaderIds: nestedHeaderIds, onNestedHeaderIdMatch: onNestedHeaderIdMatch })=>{
    const [activeHeaderId, setActiveHeaderId] = (0, $eJOHy.useState)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)($49f30dc8867dd336$var$Consumer, {
        children: (newActiveHeaderId)=>{
            if (!newActiveHeaderId || !nestedHeaderIds.includes(newActiveHeaderId)) setActiveHeaderId(undefined);
            else if (newActiveHeaderId !== activeHeaderId && nestedHeaderIds.includes(newActiveHeaderId)) {
                setActiveHeaderId(newActiveHeaderId);
                onNestedHeaderIdMatch();
            }
            return null;
        }
    });
};

});

parcelRegister("khi07", function(module, exports) {
$parcel$export(module.exports, "BreakoutSSRInlineScript", () => $28fde8499608f589$export$cfc1361be0de4203);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $bnh3n = parcelRequire("bnh3n");

var $eGOwo = parcelRequire("eGOwo");

function $28fde8499608f589$export$cfc1361be0de4203({ noOpSSRInlineScript: noOpSSRInlineScript }) {
    /**
	 * Should only inline this script while SSR,
	 * not needed on the client side.
	 */ // For hydrateRoot there is a mismatch on client for this script.
    // So we want to add the script on client side but guard it with check to
    // not execute logic
    if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) {
        if (!noOpSSRInlineScript) return null;
        else window.__RENDERER_BYPASS_BREAKOUT_SSR__ = true;
    }
    const id = Math.floor(Math.random() * 9999990001) + 9999;
    const shouldSkipScript = {
        table: (0, $eGOwo.fg)('platform-ssr-table-resize')
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)("script", {
        "data-breakout-script-id": id,
        // To investigate if we can replace this.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: $28fde8499608f589$export$92859d13f30c883e(id, shouldSkipScript)
        },
        "data-testid": "breakout-ssr-inline-script"
    });
}
function $28fde8499608f589$export$92859d13f30c883e(id, shouldSkipScript) {
    const flags = {
        platform_editor_fix_media_in_renderer: (0, $eGOwo.fg)('platform_editor_fix_media_in_renderer')
    };
    return `(function(window){
if(typeof window !== 'undefined' && window.__RENDERER_BYPASS_BREAKOUT_SSR__) { return; }
${$28fde8499608f589$export$47813c4121c8b4b3};
(${$28fde8499608f589$var$applyBreakoutAfterSSR.toString()})("${id}", breakoutConsts, ${JSON.stringify(shouldSkipScript)}, ${JSON.stringify(flags)});
})(window);
`;
}
const $28fde8499608f589$export$47813c4121c8b4b3 = `
  var breakoutConsts = ${JSON.stringify((0, $bnh3n.breakoutConsts))};
  breakoutConsts.mapBreakpointToLayoutMaxWidth = ${(0, $bnh3n.breakoutConsts).mapBreakpointToLayoutMaxWidth.toString()};
  breakoutConsts.getBreakpoint = ${(0, $bnh3n.breakoutConsts).getBreakpoint.toString()};
  breakoutConsts.calcBreakoutWidth = ${(0, $bnh3n.breakoutConsts).calcBreakoutWidth.toString()};
  breakoutConsts.calcLineLength = ${(0, $bnh3n.breakoutConsts).calcLineLength.toString()};
  breakoutConsts.calcWideWidth = ${(0, $bnh3n.breakoutConsts).calcWideWidth.toString()};
  breakoutConsts.FullPagePadding = ${(0, $9a762f515f769003$export$12fd658e5eef0d79).toString()};
`;
/**
 * WARNING: NO EXTERNAL FUNCTION CALL IN THIS FUNCTION
 * This function will be put to DOM as an inline script.
 * It can not have any external function dependency.
 * All required data must be passed in as serializable parameters.
 */ // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $28fde8499608f589$var$applyBreakoutAfterSSR(id, breakoutConsts, shouldSkipBreakoutScript, flags) {
    const MEDIA_NODE_TYPE = 'mediaSingle';
    const WIDE_LAYOUT_MODES = [
        'full-width',
        'wide',
        'custom'
    ];
    function findUp(element, condition) {
        if (!element) return;
        while(element.parentElement){
            if (condition(element)) return element.parentElement;
            element = element.parentElement;
        }
    }
    const renderer = findUp(document.querySelector(`[data-breakout-script-id="${id}"]`), (elem)=>!!elem.parentElement?.classList.contains('ak-renderer-wrapper'));
    if (!renderer) return;
    const observer = new MutationObserver((mutationsList)=>{
        mutationsList.forEach((item)=>{
            if (item.target.nodeType !== Node.ELEMENT_NODE) return;
            // Remove with feature gate 'platform-ssr-table-resize'
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            if (item.target.classList.contains('ak-renderer-document')) item.addedNodes.forEach((maybeNode)=>{
                // maybeNode may contain comments which doesn't have a dataset property
                if (maybeNode.nodeType !== Node.ELEMENT_NODE) return;
                let width;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const node = maybeNode;
                const mode = node.dataset.mode || node.dataset.layout || '';
                const nodeType = node.dataset.nodeType;
                const widthType = node.dataset.widthType;
                const isMediaSingleWithPixelWidth = nodeType === 'mediaSingle' && widthType === 'pixel';
                if (!mode || !WIDE_LAYOUT_MODES.includes(mode) || // skip apply width styling to mediaSingle node with pixel width to avoid image size changing
                // eslint-disable-next-line @atlaskit/platform/no-preconditioning
                isMediaSingleWithPixelWidth && flags['platform_editor_fix_media_in_renderer']) return;
                // When flag is on we are using CSS to calculate the table width thus don't need logic below to set the width and left.
                if (shouldSkipBreakoutScript.table && node.classList.contains('pm-table-container')) return;
                if (node.classList.contains('fabric-editor-breakout-mark')) return;
                // use breakout script for all other types of nodes
                if (node.classList.contains('pm-table-container') && mode === 'custom') {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const rendererWidth = renderer.offsetWidth;
                    const effectiveWidth = rendererWidth - breakoutConsts.padding;
                    width = `${Math.min(parseInt(node.style.width), effectiveWidth)}px`;
                } else // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                width = breakoutConsts.calcBreakoutWidth(breakoutConsts)(mode, renderer.offsetWidth);
                if (node.style.width === width) return;
                node.style.width = width;
                // Tables require some special logic, as they are not using common css transform approach,
                // because it breaks with sticky headers. This logic is copied from a table node:
                // https://bitbucket.org/atlassian/atlassian-frontend/src/77938aee0c140d02ff99b98a03849be1236865b4/packages/editor/renderer/src/react/nodes/table.tsx#table.tsx-235:245
                if (node.classList.contains('pm-table-container') && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                !renderer.classList.contains('is-full-width')) {
                    const lineLength = breakoutConsts.calcLineLength(breakoutConsts)();
                    const left = lineLength / 2 - parseInt(width) / 2;
                    if (left < 0 && parseInt(width) > lineLength) node.style.left = left + 'px';
                    else node.style.left = '';
                }
            });
            else if (/**
				 * The mutation observer is only called once per added node.
				 * The above condition only deals with direct children of <div class="ak-renderer-document" />
				 * When it is initially called on the direct children, not all the sub children have loaded.
				 * So nested media elements which are not immediately loaded as sub children are not available in the above conditional.
				 * Thus adding this conditional to deal with all media elements directly.
				 */ // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            item.target.dataset.nodeType === MEDIA_NODE_TYPE) // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            applyMediaBreakout(item.target);
        });
    });
    const applyMediaBreakout = (card)=>{
        // width was already set by another breakout script
        if (card.style.width) return;
        const tableParent = findUp(card, (elem)=>elem instanceof HTMLTableCellElement);
        // only apply the breakout to media elements not nested inside table
        // table sizing is not based on percentage width
        if (tableParent) return;
        const mode = card.dataset.mode || card.dataset.layout || '';
        const width = card.dataset.width;
        const isPixelBasedResizing = card.dataset.widthType === 'pixel';
        if (WIDE_LAYOUT_MODES.includes(mode)) card.style.width = '100%';
        else if (width && !isPixelBasedResizing) // Pixel based resizing has width set in pixels based on its width attribute
        // Thus, no need to override for non-wide layouts
        card.style.width = `${width}%`;
    };
    observer.observe(renderer, {
        childList: true,
        subtree: true
    });
    /**
	 * Using window load event to unsubscribe from mutation observer, as at this stage document is fully rendered.
	 * Experiment with DOMContentLoaded showed that some of the blocks were not processed at all.
	 * That's why window load is necessary.
	 *
	 * More info:
	 * – https://html.spec.whatwg.org/multipage/parsing.html#the-end
	 * – https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
	 * – https://developer.mozilla.org/en-US/docs/Web/API/Document/DOMContentLoaded_event
	 */ const disconnect = ()=>{
        observer.disconnect();
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('load', disconnect);
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('load', disconnect);
}
const $28fde8499608f589$export$2a0b3eeee3f2ea40 = (0, $bnh3n.breakoutConsts).calcLineLength((0, $bnh3n.breakoutConsts));

});

parcelRegister("hQy2y", function(module, exports) {
$parcel$export(module.exports, "isInteractiveElement", () => $829ac6fce69e52f7$export$3dee5e4542c672d9);


function $829ac6fce69e52f7$export$3dee5e4542c672d9(element) {
    if ('href' in element && element.href != null) return true;
    if (element.classList.contains((0, $2f9f53af5a1aaefa$export$42c8d07e41ed1e74))) return true;
    if (element.classList.contains((0, $87b212d64266f221$export$7a6526d4be3b7eb3))) return true;
    return false;
}

});
const $87b212d64266f221$export$7a6526d4be3b7eb3 = 'media-file-card-view';
const $87b212d64266f221$export$1b2a6cb6a124ba37 = 'media-file-card-view-selected';

/**
 * Classname for the media viewer popup that appears adjacent to the editor div. Use this to check
 * if the media viewer has appeared.
 */ const $2f9f53af5a1aaefa$export$42c8d07e41ed1e74 = 'media-viewer-popup';


parcelRegister("fC4S5", function(module, exports) {
$parcel$export(module.exports, "TruncatedWrapper", () => $95f9782da3cce186$export$79ad592494094f07);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eJOHy = parcelRequire("eJOHy");
const $95f9782da3cce186$var$fadeOutStyles = (maxHeight, top, backgroundColor)=>/*#__PURE__*/ (0, $1NIU8.css)({
        position: 'relative',
        overflowY: 'hidden',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxHeight: `${maxHeight}px`,
        '&::after': {
            content: "''",
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            top: `${top}px`,
            bottom: 0,
            left: 0,
            right: 0,
            backgroundImage: `linear-gradient( ${"var(--ds-background-neutral-subtle, rgba(255, 255, 255, 0))"}, ${backgroundColor} )`
        }
    });
const $95f9782da3cce186$var$FadeOut = (props)=>{
    const { children: children, backgroundColor: backgroundColor, fadeHeight: fadeHeight, height: height } = props;
    const top = height - fadeHeight;
    const styles = $95f9782da3cce186$var$fadeOutStyles(height, top, backgroundColor);
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: styles
    }, children);
};
class $95f9782da3cce186$export$79ad592494094f07 extends (0, $eJOHy.Component) {
    constructor(props){
        super(props);
    }
    // TODO: DSP-4123 - Quality ticket as elevation.surface will be issue when sits top of modal.
    render() {
        const { height: height = 95, fadeHeight: fadeHeight = 24, backgroundColor: backgroundColor = "var(--ds-surface, white)", children: children } = this.props;
        return /*#__PURE__*/ (0, $1NIU8.jsx)($95f9782da3cce186$var$FadeOut, {
            height: height,
            fadeHeight: fadeHeight,
            backgroundColor: backgroundColor
        }, children);
    }
}

});

parcelRegister("bVKVd", function(module, exports) {
$parcel$export(module.exports, "RendererStyleContainer", () => $28bec4b928772749$export$8f0929e72efe521f);
/* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values */ /**
                                                                                                                                                                                                                                                                           * @jsxRuntime classic
                                                                                                                                                                                                                                                                           * @jsx jsx
                                                                                                                                                                                                                                                                           */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");

var $ePRGY = parcelRequire("ePRGY");



var $eGOwo = parcelRequire("eGOwo");

var $9Letn = parcelRequire("9Letn");

var $iRC0e = parcelRequire("iRC0e");

var $7yBx7 = parcelRequire("7yBx7");

var $dA9km = parcelRequire("dA9km");

var $a6S67 = parcelRequire("a6S67");

var $gBkUB = parcelRequire("gBkUB");
var $fDsDd = parcelRequire("fDsDd");
var $kvnqO = parcelRequire("kvnqO");
var $laqWo = parcelRequire("laqWo");
var $e2Ny4 = parcelRequire("e2Ny4");
var $cjLtO = parcelRequire("cjLtO");
var $gZAVf = parcelRequire("gZAVf");

var $7T1su = parcelRequire("7T1su");
var $a4ifE = parcelRequire("a4ifE");

var $k6yTf = parcelRequire("k6yTf");
var $3gw29 = parcelRequire("3gw29");

var $7EdFW = parcelRequire("7EdFW");

var $92xoS = parcelRequire("92xoS");

var $idsFq = parcelRequire("idsFq");


var $ka8WB = parcelRequire("ka8WB");

var $Vv4zU = parcelRequire("Vv4zU");

var $c3ajv = parcelRequire("c3ajv");

var $8iUeU = parcelRequire("8iUeU");
var $dXRfX = parcelRequire("dXRfX");

var $cbSL1 = parcelRequire("cbSL1");
function $28bec4b928772749$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $28bec4b928772749$var$wrappedMediaBreakoutPoint = 410;
const $28bec4b928772749$var$TELEPOINTER_ID = 'ai-streaming-telepointer';
const $28bec4b928772749$var$tableShadowWidth = 32;
const $28bec4b928772749$var$LAYOUT_BREAKPOINT_RENDERER = 629;
// originally defined from packages/editor/editor-plugin-table/src/ui/common-styles.ts
// Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO: tableRowHeight can be moved into `@atlaskit/editor-common/table`
const $28bec4b928772749$var$tableRowHeight = 44;
const $28bec4b928772749$var$isBackgroundClipBrowserFixNeeded = ()=>{
    const browser = (0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $7EdFW.getBrowserInfo)() : (0, $7EdFW.browser);
    return browser.isGecko || browser.isIE || browser.isMac && browser.isChrome;
};
// styles are copied from ./style.tsx
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage
const $28bec4b928772749$var$baseStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 'var(--ak-renderer-base-font-size)',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '1.5rem',
    color: `var(--ds-text, ${(0, $7bb4c1736002a04a$export$7d61b15e0da132af)})`,
    [`.${(0, $iRC0e.RendererCssClassName).DOCUMENT}::after`]: {
        // we add a clearfix after ak-renderer-document in order to
        // contain internal floats (such as media images that are "wrap-left")
        // to just the renderer (and not spill outside of it)
        content: '""',
        visibility: 'hidden',
        display: 'block',
        height: 0,
        clear: 'both'
    },
    [`.${(0, $iRC0e.RendererCssClassName).DOCUMENT}`]: {
        // p, h3, and action items
        [`.${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
            height: '22px',
            transform: `translateY(-2px)`
        },
        h1: {
            [`> .mediaInlineView-content-wrap > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '36px',
                transform: `translateY(-3px)`
            }
        },
        h2: {
            [`> .mediaInlineView-content-wrap > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '31px',
                transform: `translateY(-3px)`
            }
        },
        h3: {
            [`> .mediaInlineView-content-wrap > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '25px',
                transform: `translateY(-2px)`
            }
        },
        h4: {
            [`> .mediaInlineView-content-wrap > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '23px',
                transform: `translateY(-2px)`
            }
        },
        h5: {
            [`> .mediaInlineView-content-wrap > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '20px',
                transform: `translateY(-2px)`
            }
        },
        h6: {
            [`> .mediaInlineView-content-wrap > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '18px',
                transform: `translateY(-2px)`
            }
        }
    },
    '& h1, & h2, & h3, & h4, & h5, & h6': {
        [`.${0, $a6S67.HeadingAnchorWrapperClassName}`]: {
            position: 'absolute',
            marginLeft: "var(--ds-space-075, 6px)",
            button: {
                paddingLeft: 0,
                paddingRight: 0
            },
            /**
       * Adds the visibility of the button when in focus through keyboard navigation.
       */ 'button:focus': {
                opacity: 1,
                transform: 'none !important'
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $a6S67.HeadingAnchorWrapperClassName}`]: {
                '> button': {
                    opacity: 0,
                    transform: `translate(-8px, 0px)`,
                    transition: `opacity 0.2s ease 0s, transform 0.2s ease 0s`
                }
            },
            '&:hover': {
                [`.${0, $a6S67.HeadingAnchorWrapperClassName} > button`]: {
                    opacity: 1,
                    transform: 'none !important'
                }
            }
        }
    },
    '& h1': {
        [`.${0, $a6S67.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${28 / 24}em`
        }
    },
    '& h2': {
        [`.${0, $a6S67.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.2}em`
        }
    },
    '& h3': {
        [`.${0, $a6S67.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.25}em`
        }
    },
    '& h4': {
        [`.${0, $a6S67.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 14}em`
        }
    },
    '& h5': {
        [`.${0, $a6S67.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 12}em`
        }
    },
    '& h6': {
        [`.${0, $a6S67.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 11}em`
        }
    },
    [`& span.akActionMark`]: {
        color: `var(--ds-link, ${(0, $7bb4c1736002a04a$export$b3de0ae08da2ce64)})`,
        textDecoration: 'none',
        cursor: 'pointer',
        '&:hover': {
            color: `var(--ds-link, ${(0, $7bb4c1736002a04a$export$e62e8919cca44969)})`,
            textDecoration: 'underline'
        },
        '&:active': {
            color: `var(--ds-link-pressed, ${(0, $7bb4c1736002a04a$export$a6ee3d71bc067634)})`
        }
    },
    '& span[data-placeholder]': {
        color: `var(--ds-text-subtlest, ${(0, $7bb4c1736002a04a$export$f563ee71e9ee74cd)})`
    }
});
const $28bec4b928772749$var$akEditorBreakpointForSmallDevice = '1266px';
const $28bec4b928772749$var$responsiveBreakoutWidth = /*#__PURE__*/ (0, $1NIU8.css)({
    '--ak-editor--breakout-container-without-gutter-width': `calc(100cqw - ${(0, $7yBx7.akEditorGutterPadding)}px * 2)`,
    // Corresponds to the legacyContentStyles from `@atlaskit/editor-core` meant to introduce responsive breakout width.
    '--ak-editor--breakout-wide-layout-width': `${(0, $7yBx7.akEditorCalculatedWideLayoutWidthSmallViewport)}px`,
    [`@media (min-width: ${$28bec4b928772749$var$akEditorBreakpointForSmallDevice})`]: {
        '--ak-editor--breakout-wide-layout-width': `${(0, $7yBx7.akEditorCalculatedWideLayoutWidth)}px`
    }
});
const $28bec4b928772749$var$responsiveBreakoutWidthFullWidth = /*#__PURE__*/ (0, $1NIU8.css)({
    '--ak-editor--breakout-container-without-gutter-width': '100cqw',
    // Corresponds to the legacyContentStyles from `@atlaskit/editor-core` meant to introduce responsive breakout width.
    '--ak-editor--breakout-wide-layout-width': `${(0, $7yBx7.akEditorCalculatedWideLayoutWidthSmallViewport)}px`,
    [`@media (min-width: ${$28bec4b928772749$var$akEditorBreakpointForSmallDevice})`]: {
        '--ak-editor--breakout-wide-layout-width': `${(0, $7yBx7.akEditorCalculatedWideLayoutWidth)}px`
    }
});
const $28bec4b928772749$var$responsiveBreakoutWidthWithReducedPadding = /*#__PURE__*/ (0, $1NIU8.css)({
    '--ak-editor--breakout-container-without-gutter-width': `calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)`,
    // Corresponds to the legacyContentStyles from `@atlaskit/editor-core` meant to introduce responsive breakout width.
    '--ak-editor--breakout-wide-layout-width': `${(0, $7yBx7.akEditorCalculatedWideLayoutWidthSmallViewport)}px`,
    [`@media (min-width: ${$28bec4b928772749$var$akEditorBreakpointForSmallDevice})`]: {
        '--ak-editor--breakout-wide-layout-width': `${(0, $7yBx7.akEditorCalculatedWideLayoutWidth)}px`
    },
    [`@media (max-width: ${0, $7yBx7.akEditorFullPageNarrowBreakout}px)`]: {
        '--ak-editor--breakout-container-without-gutter-width': `calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)`
    }
});
const $28bec4b928772749$var$hideHeadingCopyLinkWrapperStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    '& h1, & h2, & h3, & h4, & h5, & h6': {
        [`.${0, $a6S67.HeadingAnchorWrapperClassName}`]: {
            '&:focus-within': {
                opacity: 1
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $a6S67.HeadingAnchorWrapperClassName}`]: {
                opacity: 0,
                transition: `opacity 0.2s ease 0s`
            },
            '&:hover': {
                [`.${0, $a6S67.HeadingAnchorWrapperClassName}`]: {
                    opacity: 1
                }
            }
        }
    }
});
const $28bec4b928772749$var$rendererFullPageStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $7yBx7.akEditorDefaultLayoutWidth)}px`,
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    padding: `0 ${(0, $9a762f515f769003$export$12fd658e5eef0d79)}px`
});
const $28bec4b928772749$var$rendererFullPageStylesWithReducedPadding = /*#__PURE__*/ (0, $1NIU8.css)({
    '--ak-renderer--full-page-gutter': `${(0, $9a762f515f769003$export$12fd658e5eef0d79)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $7yBx7.akEditorDefaultLayoutWidth)}px`,
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    padding: `0 var(--ak-renderer--full-page-gutter)`,
    [`@media (max-width: ${0, $7yBx7.akEditorFullPageNarrowBreakout}px)`]: {
        '--ak-renderer--full-page-gutter': `${(0, $7yBx7.akEditorGutterPaddingReduced)}px`
    }
});
const $28bec4b928772749$var$rendererFullWidthStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $7yBx7.akEditorFullWidthLayoutWidth)}px`,
    margin: `0 auto`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"]), .ak-renderer-extension': {
        width: '100% !important'
    }
});
const $28bec4b928772749$var$rendererFullWidthStylesForTableResizing = {
    name: "b6n1sl",
    styles: ".pm-table-container{width:100% !important;}"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $28bec4b928772749$var$telepointerStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    [`#${$28bec4b928772749$var$TELEPOINTER_ID}`]: {
        display: 'inline-block',
        position: 'relative',
        width: '1.5px',
        height: '25px',
        backgroundColor: "var(--ds-background-brand-bold, #0C66E4)",
        marginLeft: "var(--ds-space-025, 2px)",
        '&::after': {
            content: '"AI"',
            position: 'absolute',
            display: 'block',
            top: 0,
            left: 0,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: '10px',
            fontWeight: "var(--ds-font-weight-bold, 700)",
            width: '12.5px',
            height: '13px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            paddingTop: '1px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            paddingLeft: '1.5px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'initial',
            borderRadius: `0px ${"var(--ds-radius-xsmall, 2px)"} ${"var(--ds-radius-xsmall, 2px)"} 0px`,
            color: "var(--ds-text-inverse, white)",
            backgroundColor: "var(--ds-background-brand-bold, #0C66E4)"
        }
    }
});
const $28bec4b928772749$var$rovoTelepointerStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    [`#${$28bec4b928772749$var$TELEPOINTER_ID}`]: {
        display: 'inline-block',
        position: 'relative',
        width: '1.5px',
        height: '24px',
        backgroundColor: "var(--ds-background-brand-bold, #0C66E4)",
        marginLeft: "var(--ds-space-025, 2px)",
        '&::after': {
            content: '""',
            position: 'absolute',
            display: 'block',
            top: 0,
            left: 0,
            width: '31.5px',
            height: '15.5px',
            borderRadius: `0px ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"} 0px`,
            background: // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography, @atlaskit/design-system/ensure-design-token-usage
            'linear-gradient(to right, #1868db 0px, #1868db 1.5px, transparent 1.5px) 0 0 / 100% 100% no-repeat, conic-gradient(from 270deg at 50% 50%, #1868db 0deg, #1868db 115deg, #fca700 115deg, #fca700 180deg, #bf63f3 180deg, #bf63f3 310deg, #82b536 310deg, #82b536 359.96deg, #1868db 360deg)'
        },
        '&::before': {
            content: '"Rovo"',
            position: 'absolute',
            fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            color: "var(--ds-text-inverse, white)",
            background: "var(--ds-text, #172B4D)",
            top: 1,
            left: 1,
            borderRadius: `0px ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"} 0px`,
            zIndex: 1,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: '10px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            padding: '0.5px 2.5px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'initial'
        }
    }
});
const $28bec4b928772749$var$whitespaceSharedStyles = {
    name: "1s8ykn2",
    styles: "word-wrap:break-word;white-space:pre-wrap"
};
const $28bec4b928772749$var$blockquoteSharedStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& blockquote': {
        boxSizing: 'border-box',
        color: 'inherit',
        width: '100%',
        display: 'inline-block',
        paddingLeft: "var(--ds-space-200, 16px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderLeft: `${"var(--ds-border-width-selected, 2px)"} solid ${`var(--ds-border, ${(0, $7yBx7.akEditorBlockquoteBorderColor)})`}`,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $7yBx7.blockNodesVerticalMargin)} 0 0 0`,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[dir='rtl'] &": {
            paddingLeft: 0,
            paddingRight: "var(--ds-space-200, 16px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: 0
        },
        '&::before': {
            content: "''"
        },
        '&::after': {
            content: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& table, & table:last-child': {
            display: 'inline-table'
        },
        // Workaround for overriding the inline-block display on last child of a blockquote set in CSS reset.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> .extensionView-content-wrap:last-child': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: 'block'
        }
    }
});
const $28bec4b928772749$var$headingsSharedStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    '& h1': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${24 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 28 / 24,
        color: "var(--ds-text, #172B4D)",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: `-0.01em`,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.667em'
    },
    '& h2': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${20 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.2,
        color: "var(--ds-text, #172B4D)",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: `-0.008em`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.8em',
        marginBottom: 0
    },
    '& h3': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${16 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.25,
        color: "var(--ds-text, #172B4D)",
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: `-0.006em`,
        marginTop: "var(--ds-space-400, 2em)",
        marginBottom: 0
    },
    '& h4': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${1}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 16 / 14,
        color: "var(--ds-text, #172B4D)",
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: `-0.003em`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.357em'
    },
    '& h5': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${12 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 16 / 12,
        color: "var(--ds-text, #172B4D)",
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.667em',
        textTransform: 'none'
    },
    '& h6': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${11 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 16 / 11,
        color: "var(--ds-text-subtlest, #626F86)",
        fontWeight: "var(--ds-font-weight-bold, 700)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.455em',
        textTransform: 'none'
    }
});
const $28bec4b928772749$var$headingsSharedStylesWithEditorUGC = /*#__PURE__*/ (0, $1NIU8.css)({
    '& h1': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h1)`,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        },
        '&::before': {}
    },
    '& h2': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h2)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.4em',
        marginBottom: 0,
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    },
    '& h3': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h3)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.31249em',
        marginBottom: 0,
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    },
    '& h4': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h4)`,
        marginTop: "var(--ds-space-250, 1.25em)",
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    },
    '& h5': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h5)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em',
        textTransform: 'none',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    },
    '& h6': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h6)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.59091em',
        textTransform: 'none',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    }
});
const $28bec4b928772749$var$headingWithAlignmentStyles = {
    name: "sd2n24",
    styles: ".fabric-editor-block-mark.fabric-editor-alignment:not(:first-child){> h1:first-child{margin-top:1.667em;} > h2:first-child{margin-top:1.8em;}> h3:first-child{margin-top:2em;}> h4:first-child{margin-top:1.357em;}> h5:first-child{margin-top:1.667em;}> h6:first-child{margin-top:1.455em;}}.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment{> :is(h1, h2, h3, h4, h5, h6):first-child{margin-top:0;}}"
};
const $28bec4b928772749$var$ruleSharedStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    '& hr': {
        border: 'none',
        backgroundColor: "var(--ds-border, #091E4224)",
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $7yBx7.akEditorLineHeight)}em 0`,
        height: '2px',
        borderRadius: "var(--ds-radius-full, 9999px)"
    }
});
// When cleaning up `platform_editor_content_mode_button_mvp` simplify the name/ use the other paragraph style name
const $28bec4b928772749$var$paragraphSharedStylesWithEditorUGC = /*#__PURE__*/ (0, $1NIU8.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-normal-text)`,
        marginTop: (0, $7yBx7.blockNodesVerticalMargin),
        marginBottom: 0
    }
});
const $28bec4b928772749$var$paragraphStylesUGCScaledMargin = /*#__PURE__*/ (0, $1NIU8.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-normal-text)`,
        marginTop: (0, $7yBx7.scaledBlockNodesVerticalMargin),
        marginBottom: 0
    }
});
const $28bec4b928772749$var$paragraphSharedStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: (0, $7yBx7.akEditorLineHeight),
        fontWeight: "var(--ds-font-weight-regular, 400)",
        marginTop: (0, $7yBx7.blockNodesVerticalMargin),
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: '-0.005em'
    }
});
// When cleaning up `platform_editor_content_mode_button_mvp` simplify the name/ use the other paragraph style name
const $28bec4b928772749$var$paragraphSharedStyleScaledMargin = /*#__PURE__*/ (0, $1NIU8.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: (0, $7yBx7.akEditorLineHeight),
        fontWeight: "var(--ds-font-weight-regular, 400)",
        marginTop: (0, $7yBx7.scaledBlockNodesVerticalMargin),
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: '-0.005em'
    }
});
const $28bec4b928772749$var$listsSharedStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    /* =============== INDENTATION SPACING ========= */ 'ul, ol': {
        boxSizing: 'border-box',
        paddingLeft: `var(--ed--list--item-counter--padding, ${(0, $kvnqO.listItemCounterPadding)}px)`
    },
    [`${0, $a4ifE.orderedListSelector}, ${0, $7T1su.bulletListSelector}`]: {
        /*
     Ensures list item content adheres to the list's margin instead
     of filling the entire block row. This is important to allow
     clicking interactive elements which are floated next to a list.
      For some history and context on this block, see PRs related to tickets.:
     @see ED-6551 - original issue.
     @see ED-7015 - follow up issue.
     @see ED-7447 - flow-root change.
      used to have display: 'table' in tag template style but not supported in object styles
     removed display: 'table' as 'flow-root' is supported in latest browsers
      @see https://css-tricks.com/display-flow-root/
    */ display: 'flow-root'
    },
    /* =============== INDENTATION AESTHETICS ========= */ /**
  	We support nested lists up to six levels deep.
  **/ /* LEGACY LISTS */ 'ul, ul ul ul ul': {
        listStyleType: 'disc'
    },
    'ul ul, ul ul ul ul ul': {
        listStyleType: 'circle'
    },
    'ul ul ul, ul ul ul ul ul ul': {
        listStyleType: 'square'
    },
    'ol, ol ol ol ol': {
        listStyleType: 'decimal'
    },
    'ol ol, ol ol ol ol ol': {
        listStyleType: 'lower-alpha'
    },
    'ol ol ol, ol ol ol ol ol ol': {
        listStyleType: 'lower-roman'
    },
    /* PREDICTABLE LISTS */ 'ol[data-indent-level="1"], ol[data-indent-level="4"]': {
        listStyleType: 'decimal'
    },
    'ol[data-indent-level="2"], ol[data-indent-level="5"]': {
        listStyleType: 'lower-alpha'
    },
    'ol[data-indent-level="3"], ol[data-indent-level="6"]': {
        listStyleType: 'lower-roman'
    },
    'ul[data-indent-level="1"], ul[data-indent-level="4"]': {
        listStyleType: 'disc'
    },
    'ul[data-indent-level="2"], ul[data-indent-level="5"]': {
        listStyleType: 'circle'
    },
    'ul[data-indent-level="3"], ul[data-indent-level="6"]': {
        listStyleType: 'square'
    }
});
/*
	Firefox does not handle empty block element inside li tag.
	If there is not block element inside li tag,
	then firefox sets inherited height to li
	However, if there is any block element and if it's empty
	(or has empty inline element) then
	firefox sets li tag height to zero.
	More details at
	https://product-fabric.atlassian.net/wiki/spaces/~455502413/pages/3149365890/ED-14110+Investigation
*/ const $28bec4b928772749$var$listsSharedStylesForGekko = {
    name: "jlg15n",
    styles: "ul, ol{li p:empty, li p > span:empty{display:inline-block;}}"
};
const $28bec4b928772749$var$indentationSharedStyles = {
    name: "1bgz9nd",
    styles: ".fabric-editor-indentation-mark{&[data-level='1']{margin-left:30px;}&[data-level='2']{margin-left:60px;}&[data-level='3']{margin-left:90px;}&[data-level='4']{margin-left:120px;}&[data-level='5']{margin-left:150px;}&[data-level='6']{margin-left:180px;}}"
};
const $28bec4b928772749$var$indentationSharedStylesWithMarginFix = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.fabric-editor-indentation-mark': {
        // Prevent marginTop of p:first-child overrode by batch.css
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        'p:first-child': {
            marginTop: (0, $7yBx7.blockNodesVerticalMargin)
        }
    }
});
const $28bec4b928772749$var$blockMarksSharedStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    /**
   * We need to remove margin-top from first item
   * inside doc, tableCell, tableHeader, blockquote, etc.
   */ [`*:not(.fabric-editor-block-mark) >,
  	*:not(.fabric-editor-block-mark) >
    div.fabric-editor-block-mark:first-of-type
	:not(.fabric-editor-indentation-mark)
	:not(.fabric-editor-alignment),
  	.fabric-editor-alignment:first-of-type:first-child,
  	.ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child`]: {
        'p, h1, h2, h3, h4, h5, h6, .heading-wrapper': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            ':first-child:not(style), style:first-child + *': {
                marginTop: 0
            }
        }
    }
});
const $28bec4b928772749$var$codeMarkSharedStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.code': {
        '--ds--code--bg-color': "var(--ds-background-neutral, #091E420F)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        fontWeight: "var(--ds-font-weight-regular, 400)",
        backgroundColor: `var(--ds--code--bg-color,${`var(--ds-background-neutral, ${(0, $7bb4c1736002a04a$export$9fdfb749e33cdf97)})`})`,
        color: `var(--ds-text, ${(0, $7bb4c1736002a04a$export$7d61b15e0da132af)})`,
        borderStyle: 'none',
        borderRadius: "var(--ds-radius-small, 3px)",
        display: 'inline',
        padding: '2px 0.5ch',
        boxDecorationBreak: 'clone',
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    }
});
const $28bec4b928772749$var$extensionStyle = {
    name: "188isfx",
    styles: ".ak-renderer-extension :not(.ak-renderer-extension .ak-renderer-document *, .aui-lozenge, .status-lozenge-span *), .ak-renderer-extension .ak-renderer-document .ak-renderer-extension:not(:has(.ak-renderer-document)) :not(.aui-lozenge, .status-lozenge-span *){font-size:var(--ak-renderer-base-font-size);}"
};
const $28bec4b928772749$var$shadowSharedStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $k6yTf.shadowClassNames).RIGHT_SHADOW}::before, .${(0, $k6yTf.shadowClassNames).RIGHT_SHADOW}::after, .${(0, $k6yTf.shadowClassNames).LEFT_SHADOW}::before, .${(0, $k6yTf.shadowClassNames).LEFT_SHADOW}::after`]: {
        display: 'none',
        position: 'absolute',
        pointerEvents: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $7yBx7.akEditorShadowZIndex),
        width: '8px',
        content: "''",
        height: 'calc(100%)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $k6yTf.shadowClassNames).RIGHT_SHADOW}, .${(0, $k6yTf.shadowClassNames).LEFT_SHADOW}`]: {
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $k6yTf.shadowClassNames).LEFT_SHADOW}::before`]: {
        background: `linear-gradient( to left, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to right, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
        top: '0px',
        left: 0,
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $k6yTf.shadowClassNames).RIGHT_SHADOW}::after`]: {
        background: `linear-gradient( to right, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to left, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
        right: '0px',
        top: '0px',
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $3gw29.shadowObserverClassNames).SENTINEL_LEFT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $3gw29.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    }
});
const $28bec4b928772749$var$dateSharedStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${(0, $fDsDd.DateSharedCssClassName).DATE_WRAPPER} span`]: {
        whiteSpace: 'unset'
    }
});
const $28bec4b928772749$var$textColorStyles = {
    name: "1nlqh0j",
    styles: ".fabric-text-color-mark{color:var(--custom-palette-color, inherit);}a .fabric-text-color-mark{color:unset;}"
};
const $28bec4b928772749$var$backgroundColorStyles = {
    name: "yf96ao",
    styles: ".fabric-background-color-mark{background-color:var(--custom-palette-color, inherit);border-radius:var(--ds-radius-xsmall, 2px);padding-top:1px;padding-bottom:2px;box-decoration-break:clone;}a .fabric-background-color-mark{background-color:unset;}.fabric-background-color-mark .ak-editor-annotation{background-color:unset;}"
};
const $28bec4b928772749$export$a365082c2a191514 = {
    name: "nf8qu5",
    styles: ".fabric-background-color-mark:has(.background-color-padding-left){padding-left:var(--ds-space-025, 2px);margin-left:var(--ds-space-negative-025, -2px);}.fabric-background-color-mark:has(.background-color-padding-right){padding-right:var(--ds-space-025, 2px);margin-right:var(--ds-space-negative-025, -2px);}"
};
const $28bec4b928772749$var$tasksAndDecisionsStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    '.ProseMirror': {
        [`.taskItemView-content-wrap,
		.${(0, $gZAVf.TaskDecisionSharedCssClassName).DECISION_CONTAINER}`]: {
            position: 'relative',
            minWidth: `${(0, $7yBx7.akEditorTableCellMinWidth)}px`
        },
        [`.${(0, $gZAVf.TaskDecisionSharedCssClassName).DECISION_CONTAINER}`]: {
            marginTop: 0
        },
        [`.${(0, $gZAVf.TaskDecisionSharedCssClassName).TASK_CONTAINER}`]: {
            'span[contenteditable="false"]': {
                height: `${(0, $7yBx7.akEditorLineHeight)}em`
            }
        },
        [`.${(0, $gZAVf.TaskDecisionSharedCssClassName).TASK_ITEM}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $7yBx7.akEditorLineHeight)
        }
    },
    'div[data-task-local-id]': {
        'span[contenteditable="false"]': {
            height: `${(0, $7yBx7.akEditorLineHeight)}em`
        },
        'span[contenteditable="false"] + div': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${(0, $7yBx7.akEditorLineHeight)}em`
        }
    },
    'div[data-task-list-local-id]': {
        margin: `${"var(--ds-space-150, 12px)"} 0 0 0`,
        // If task item is not first in the list then set margin top to 4px.
        'div + div': {
            marginTop: "var(--ds-space-050, 4px)"
        }
    },
    // If task list is not first in the document then set margin top to 4px.
    'div[data-task-list-local-id] div[data-task-list-local-id]': {
        marginTop: "var(--ds-space-050, 4px)",
        marginLeft: "var(--ds-space-300, 24px)"
    },
    /* When action list is inside panel */ '.ak-editor-panel__content': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div[data-task-list-local-id]:first-child': {
            margin: '0 0 0 0 !important'
        }
    }
});
const $28bec4b928772749$var$smartCardStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    [`.${(0, $e2Ny4.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}`]: {
        display: 'block',
        margin: `${(0, $7yBx7.blockNodesVerticalMargin)} 0 0`,
        maxWidth: `${760}px`
    }
});
const $28bec4b928772749$var$smartCardStylesAvatarFix = /*#__PURE__*/ (0, $1NIU8.css)({
    [`.${(0, $e2Ny4.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}:not(.${(0, $e2Ny4.SmartCardSharedCssClassName).DATASOURCE_CONTAINER})`]: {
        /* EDM-11991: Fix list plugin adding padding to ADS AvatarGroup start */ 'ul, ol': {
            paddingLeft: 'inherit'
        }
    }
});
const $28bec4b928772749$var$smartCardStylesAvatarMarginFix = /*#__PURE__*/ (0, $1NIU8.css)({
    [`.${(0, $e2Ny4.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}:not(.${(0, $e2Ny4.SmartCardSharedCssClassName).DATASOURCE_CONTAINER})`]: {
        'ul, ol': {
            marginRight: 'inherit'
        }
    }
});
const $28bec4b928772749$var$smartCardStylesAvatarListZeroMarginTop = /*#__PURE__*/ (0, $1NIU8.css)({
    [`.${(0, $e2Ny4.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}:not(.${(0, $e2Ny4.SmartCardSharedCssClassName).DATASOURCE_CONTAINER})`]: {
        'ul, ol': {
            marginTop: 0
        }
    }
});
// In Renderer in Jira there is no SmartCardSharedCssClassName.INLINE_CARD_CONTAINER, so using data-inline-cart="true"
const $28bec4b928772749$var$headerSmartCardStyles = {
    name: "qwtpmh",
    styles: "[data-inline-card=\"true\"]{[data-inlinecard-button-overlay=\"icon-wrapper-line-height\"] span{line-height:0;}}"
};
const $28bec4b928772749$var$baseOtherStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    '& .UnknownBlock': {
        fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${0.875}rem`,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word'
    },
    '& span.date-node': {
        background: `var(--ds-background-neutral, ${(0, $7bb4c1736002a04a$export$920c0d5c49070351)})`,
        borderRadius: "var(--ds-radius-small, 3px)",
        color: `var(--ds-text, ${(0, $7bb4c1736002a04a$export$7d61b15e0da132af)})`,
        padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
        margin: `0 1px`,
        transition: `background 0.3s`
    },
    '& span.date-node-highlighted': {
        background: `var(--ds-background-danger, ${(0, $7bb4c1736002a04a$export$4b84fd0e2c617bd)})`,
        color: `var(--ds-text-danger, ${(0, $7bb4c1736002a04a$export$2837b5a1a71d5c02)})`
    },
    '& .renderer-image': {
        maxWidth: '100%',
        display: 'block',
        margin: `${"var(--ds-space-300, 24px)"} 0`
    },
    [`.${0, $laqWo.richMediaClassName}.rich-media-wrapped + .${0, $laqWo.richMediaClassName}:not(.rich-media-wrapped)`]: {
        clear: 'both'
    },
    [`& .code-block,
	& blockquote,
	& hr,
	& > div > div:not(.rich-media-wrapped),
	.${0, $laqWo.richMediaClassName}.rich-media-wrapped + .rich-media-wrapped + *:not(.rich-media-wrapped),
	.${0, $laqWo.richMediaClassName}.rich-media-wrapped + div:not(.rich-media-wrapped),
	.${0, $laqWo.richMediaClassName}.image-align-start,
		.${0, $laqWo.richMediaClassName}.image-center,
		.${0, $laqWo.richMediaClassName}.image-align-end`]: {
        clear: 'both'
    },
    '& .rich-media-wrapped': {
        '& + h1, & + h2, & + h3, & + h4, & + h5, & + h6': {
            marginTop: "var(--ds-space-100, 8px)"
        }
    },
    // originally copied the block after mediaSharedStyle
    'div[class^="image-wrap-"] + div[class^="image-wrap-"]': {
        marginLeft: 0,
        marginRight: 0
    },
    /* Breakout for tables and extensions */ [`.${(0, $iRC0e.RendererCssClassName).DOCUMENT} >`]: {
        [`*:not([data-mark-type='fragment']) .${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`[data-mark-type='fragment'] * .${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`* .${(0, $iRC0e.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
            overflowX: 'auto'
        },
        [`& .${(0, $iRC0e.RendererCssClassName).EXTENSION}:first-child`]: {
            marginTop: 0
        }
    },
    [`.${(0, $iRC0e.RendererCssClassName).DOCUMENT}`]: {
        [`.${(0, $iRC0e.RendererCssClassName).EXTENSION}`]: {
            marginTop: `${(0, $7yBx7.blockNodesVerticalMargin)}`
        },
        [`.${(0, $iRC0e.RendererCssClassName).EXTENSION_CENTER_ALIGN}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: '50%',
            transform: 'translateX(-50%)'
        },
        [`.${(0, $cjLtO.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            overflowX: 'auto'
        },
        [`.${(0, $3gw29.shadowObserverClassNames).SHADOW_CONTAINER} .${(0, $cjLtO.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            display: 'flex'
        }
    }
});
const $28bec4b928772749$var$alignedHeadingAnchorStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO Delete this comment after verifying space token -> previous value `margin: 6px`
    '.fabric-editor-block-mark[data-align] >': {
        'h1, h2, h3, h4, h5, h6': {
            position: 'relative'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-block-mark:not([data-align="center"])[data-align]': {
        [`.${0, $a6S67.HeadingAnchorWrapperClassName}`]: {
            margin: `0 ${"var(--ds-space-075, 6px)"} 0 0`,
            // If the anchor is right aligned then the left side of the heading
            // is aligned with the left side of the anchor.
            // In order to align as expected we transform it the width of the element (plus our expected 6px)
            // to the left
            transform: `translateX(calc(-100% - ${"var(--ds-space-075, 6px)"}))`
        },
        '@media (hover: hover) and (pointer: fine)': {
            [`.${0, $a6S67.HeadingAnchorWrapperClassName} > button`]: {
                transform: `translate(8px, 0px)`
            }
        }
    }
});
const $28bec4b928772749$var$firstWrappedMediaStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // Remove gap between first wrapped mediaSingle and its fellow wrapped mediaSingle
    [`.${0, $laqWo.richMediaClassName}[class*="image-wrap-"]:has(+ .${0, $laqWo.richMediaClassName}[class*="image-wrap-"])`]: {
        marginRight: 0,
        marginLeft: 0
    }
});
// Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO: emotion refactor - there's a mediaSingleSharedNewStyle, but not originally used in the renderer.
const $28bec4b928772749$var$mediaSingleSharedStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${0, $laqWo.richMediaClassName}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${0, $laqWo.richMediaClassName}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${0, $laqWo.richMediaClassName}.image-wrap-right + .${0, $laqWo.richMediaClassName}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${0, $laqWo.richMediaClassName}.image-wrap-left + .${0, $laqWo.richMediaClassName}.image-wrap-right, .${0, $laqWo.richMediaClassName}.image-wrap-right + .${0, $laqWo.richMediaClassName}.image-wrap-left, .${0, $laqWo.richMediaClassName}.image-wrap-left + .${0, $laqWo.richMediaClassName}.image-wrap-left, .${0, $laqWo.richMediaClassName}.image-wrap-right + .${0, $laqWo.richMediaClassName}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$28bec4b928772749$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});
// was shared between editor-core and renderer
const $28bec4b928772749$var$tableSharedStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    // originally from packages/editor/editor-common/src/styles/shared/tableCell.ts
    // Hardcoding the background color for the table cells to avoid the use of inline styles
    'td[colorname="white" i], th[colorname="white" i]': {
        backgroundColor: `${"var(--ds-surface, #FFFFFF)"} !important`
    },
    'td[colorname="light blue" i], th[colorname="light blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtlest, #DEEBFF)"} !important`
    },
    'td[colorname="light teal" i], th[colorname="light teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtlest, #E6FCFF)"} !important`
    },
    'td[colorname="light green" i], th[colorname="light green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtlest, #E3FCEF)"} !important`
    },
    'td[colorname="light yellow" i], th[colorname="light yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-yellow-subtlest, #FFFAE6)"} !important`
    },
    'td[colorname="light red" i], th[colorname="light red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtlest, #FFEBE6)"} !important`
    },
    'td[colorname="light purple" i], th[colorname="light purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtlest, #EAE6FF)"} !important`
    },
    'td[colorname="light gray" i], th[colorname="light gray" i]': {
        backgroundColor: `${"var(--ds-background-accent-gray-subtlest, #F4F5F7)"} !important`
    },
    'td[colorname="blue" i], th[colorname="blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtler, #B3D4FF)"} !important`
    },
    'td[colorname="teal" i], th[colorname="teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtler, #B3F5FF)"} !important`
    },
    'td[colorname="green" i], th[colorname="green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtler, #ABF5D1)"} !important`
    },
    'td[colorname="yellow" i], th[colorname="yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-yellow-subtler, #FFF0B3)"} !important`
    },
    'td[colorname="red" i], th[colorname="red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtler, #FFBDAD)"} !important`
    },
    'td[colorname="purple" i], th[colorname="purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtler, #C0B6F2)"} !important`
    },
    'td[colorname="gray" i], th[colorname="gray" i]': {
        backgroundColor: `${"var(--ds-background-accent-gray-subtle, #B3BAC5)"} !important`
    },
    'td[colorname="dark blue" i], th[colorname="dark blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtle, #4C9AFF)"} !important`
    },
    'td[colorname="dark teal" i], th[colorname="dark teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtle, #79E2F2)"} !important`
    },
    'td[colorname="dark green" i], th[colorname="dark green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtle, #57D9A3)"} !important`
    },
    'td[colorname="dark yellow" i], th[colorname="dark yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-orange-subtle, #FFC400)"} !important`
    },
    'td[colorname="dark red" i], th[colorname="dark red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtle, #FF8F73)"} !important`
    },
    'td[colorname="dark purple" i], th[colorname="dark purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtle, #998DD9)"} !important`
    },
    [`.${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        position: 'relative',
        margin: `0 auto ${"var(--ds-space-200, 16px)"}`,
        boxSizing: 'border-box',
        /**
     * Fix block top alignment inside table cells.
     */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '.decisionItemView-content-wrap:first-of-type > div': {
            marginTop: 0
        }
    },
    [`.${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER}[data-number-column='true']`]: {
        paddingLeft: `${(0, $7yBx7.akEditorTableNumberColumnWidth) - 1}px`,
        clear: 'both'
    },
    [`.${(0, $cjLtO.TableSharedCssClassName).TABLE_RESIZER_CONTAINER}`]: {
        willChange: 'width, margin-left'
    },
    [`.${(0, $cjLtO.TableSharedCssClassName).TABLE_RESIZER_CONTAINER} table`]: {
        willChange: 'width'
    },
    [`.${(0, $cjLtO.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table`]: {
        margin: `${"var(--ds-space-300, 24px)"} 0 0 0`
    },
    [`.${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER} > table,
	.${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        margin: `${"var(--ds-space-300, 24px)"} ${"var(--ds-space-100, 8px)"} 0 0`
    },
    /* avoid applying styles to nested tables (possible via extensions) */ [`.${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER} > table,
	.${(0, $cjLtO.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
	.${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        borderCollapse: 'collapse',
        border: `${(0, $cjLtO.tableCellBorderWidth)}px solid ${`var(--ds-background-accent-gray-subtler, ${(0, $7yBx7.akEditorTableBorder)})`}`,
        tableLayout: 'fixed',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        width: '100%',
        '&[data-autosize="true"]': {
            tableLayout: 'auto'
        },
        '*': {
            boxSizing: 'border-box'
        },
        hr: {
            boxSizing: 'content-box'
        },
        tbody: {
            borderBottom: 'none'
        },
        'th td': {
            backgroundColor: "var(--ds-background-neutral-subtle, white)"
        },
        '> tbody > tr > td': {
            backgroundColor: "var(--ds-surface, #FFFFFF)"
        },
        th: {
            backgroundColor: `var(--ds-background-accent-gray-subtlest, ${(0, $7yBx7.akEditorTableToolbar)})`,
            textAlign: 'left',
            /* only apply this styling to codeblocks in default background headercells */ /* TODO this needs to be overhauled as it relies on unsafe selectors */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not([style]):not(.danger)': {
                [`.${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}:not(.danger)`]: {
                    backgroundColor: "var(--ds-surface-raised, rgb(235, 237, 240))",
                    [`&:not(.${0, $7yBx7.akEditorSelectedNodeClassName})`]: {
                        boxShadow: `0px 0px 0px 1px ${"var(--ds-border, transparent)"}`
                    },
                    [`.${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}`]: {
                        // originally copied from packages/editor/editor-shared-styles/src/overflow-shadow/overflow-shadow.ts
                        backgroundImage: `linear-gradient(
							to right,
							${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  )`,
                        backgroundColor: "var(--ds-background-neutral, rgb(235, 237, 240))"
                    },
                    [`.${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}`]: {
                        backgroundColor: "var(--ds-background-neutral, rgb(226, 229, 233))"
                    },
                    /* this is only relevant to the element taken care of by renderer */ '> [data-ds--code--code-block]': {
                        // originally copied from packages/editor/editor-shared-styles/src/overflow-shadow/overflow-shadow.ts
                        backgroundImage: `linear-gradient(
							to right,
							${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  )`,
                        backgroundColor: `${"var(--ds-background-neutral, rgb(235, 237, 240))"}!important`,
                        // selector lives inside @atlaskit/code
                        '--ds--code--line-number-bg-color': "var(--ds-background-neutral, rgb(226, 229, 233))"
                    }
                }
            }
        }
    }
});
const $28bec4b928772749$var$tableRendererHeaderStylesForTableCellOnly = /*#__PURE__*/ (0, $1NIU8.css)({
    [`.${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $cjLtO.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th, > tbody > tr > td': {
            minWidth: `${(0, $cjLtO.tableCellMinWidth)}px`,
            fontWeight: "var(--ds-font-weight-regular, 400)",
            verticalAlign: 'top',
            border: `${"var(--ds-border-width, 1px)"} solid ${`var(--ds-background-accent-gray-subtler, ${(0, $7yBx7.akEditorTableBorder)})`}`,
            borderRightWidth: 0,
            borderBottomWidth: 0,
            padding: "var(--ds-space-100, 8px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            'th p:not(:first-of-type), td p:not(:first-of-type)': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    }
});
const $28bec4b928772749$var$tableRendererNestedPanelStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    [`.${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER} .ak-editor-panel`]: {
        border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #d9dbea)"}`
    }
});
const $28bec4b928772749$var$tableStylesBackGroundClipForGeckoForTableCellOnly = /*#__PURE__*/ (0, $1NIU8.css)({
    [`.${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $cjLtO.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> tbody > tr > th, > tbody > tr > td': {
            backgroundClip: 'padding-box'
        }
    }
});
const $28bec4b928772749$var$firstNodeWithNotMarginTopWithNestedDnD = /*#__PURE__*/ (0, $1NIU8.css)({
    [`.${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $cjLtO.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th, > tbody > tr > td': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> :nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span))': {
                marginTop: 0
            }
        }
    }
});
const $28bec4b928772749$var$firstNodeWithNotMarginTop = /*#__PURE__*/ (0, $1NIU8.css)({
    [`.${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $cjLtO.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th, > tbody > tr > td': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> :first-child:not(style), > style:first-child + *': {
                marginTop: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> .ProseMirror-gapcursor:first-child + *, > style:first-child + .ProseMirror-gapcursor + *': {
                marginTop: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> .ProseMirror-gapcursor:first-child + span + *, > style:first-child + .ProseMirror-gapcursor + span + *': {
                marginTop: 0
            }
        }
    }
});
const $28bec4b928772749$var$rendererTableStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    [`.${(0, $iRC0e.RendererCssClassName).DOCUMENT} .${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        zIndex: 0,
        transition: `all 0.1s linear`,
        display: 'flex' /* needed to avoid position: fixed jumpiness in Chrome */ ,
        /** Shadow overrides */ [`&.${(0, $k6yTf.shadowClassNames).RIGHT_SHADOW}::after, &.${(0, $k6yTf.shadowClassNames).LEFT_SHADOW}::before`]: {
            top: `${(0, $cjLtO.tableMarginTop) - 1}px`,
            height: `calc(100% - ${(0, $cjLtO.tableMarginTop)}px)`,
            zIndex: `${(0, $7yBx7.akEditorStickyHeaderZIndex)}`,
            width: `${$28bec4b928772749$var$tableShadowWidth}px`,
            background: `linear-gradient(
					to left,
					transparent 0,
					${`var(--ds-shadow-overflow-spread, ${(0, $7bb4c1736002a04a$export$46987b49aab6d1a8)})`} 140%
				),
				linear-gradient(
					to right,
					${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px,
					transparent 1px
				)`
        },
        [`&.${(0, $k6yTf.shadowClassNames).RIGHT_SHADOW}::after`]: {
            background: `linear-gradient(
					to right,
					transparent 0,
					${`var(--ds-shadow-overflow-spread, ${(0, $7bb4c1736002a04a$export$46987b49aab6d1a8)})`} 140%
				),
				linear-gradient(
					to left,
					${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px,
					transparent 1px
				)`,
            right: `0px`
        },
        [`&
          .${(0, $3gw29.shadowObserverClassNames).SENTINEL_LEFT},
          &
          .${(0, $3gw29.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
            height: `calc(100% - ${(0, $cjLtO.tableMarginTop)}px)`
        }
    }
});
const $28bec4b928772749$var$stickyScrollbarStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    [`.${(0, $iRC0e.RendererCssClassName).DOCUMENT} .${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        position: 'relative',
        flexDirection: 'column',
        [`> .${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`]: {
            width: '100%',
            display: 'block',
            visibility: 'hidden',
            overflowX: 'auto',
            position: 'sticky',
            bottom: `${"var(--ds-space-0, 0px)"}`,
            zIndex: 1
        },
        [`> .${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM},
		> .${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP}`]: {
            position: 'absolute',
            width: '100%',
            height: '1px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '-1px',
            // need this to avoid sentinel being focused via keyboard
            // this still allows it to be detected by intersection observer
            visibility: 'hidden'
        },
        [`> .${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP}`]: {
            top: `${$28bec4b928772749$var$tableRowHeight * 3}px`
        },
        [`> .${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM}`]: {
            bottom: `${"var(--ds-space-250, 20px)"}` // MAX_BROWSER_SCROLLBAR_HEIGHT = 20;
        }
    }
});
const $28bec4b928772749$var$rendererTableHeaderEqualHeightStylesForTableCellOnly = /*#__PURE__*/ (0, $1NIU8.css)({
    [`.${(0, $iRC0e.RendererCssClassName).DOCUMENT} .${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $cjLtO.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            height: '1px' /* will be ignored */ ,
            marginLeft: 0,
            marginRight: 0
        }
    },
    [`.${(0, $cjLtO.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table > tbody > tr:first-of-type, .${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table > tbody > tr:first-of-type`]: {
        height: '100%',
        'td, th': {
            position: 'relative'
        }
    }
});
const $28bec4b928772749$var$rendererTableSortableColumnStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    [`.${(0, $iRC0e.RendererCssClassName).DOCUMENT} .${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $cjLtO.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            // allow nested heading links
            [`.${(0, $iRC0e.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}`]: {
                padding: 0,
                [`.${(0, $iRC0e.RendererCssClassName).SORTABLE_COLUMN}`]: {
                    width: '100%',
                    height: '100%',
                    padding: `${(0, $cjLtO.tableCellPadding)}px`,
                    borderWidth: '1.5px',
                    borderStyle: 'solid',
                    borderColor: `transparent`,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> *:first-child': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor:first-child + *, > style:first-child + .ProseMirror-gapcursor + *': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor:first-child + span + *, > style:first-child + .ProseMirror-gapcursor + span + *': {
                        marginTop: 0
                    },
                    '@supports selector(:focus-visible)': {
                        '&:focus': {
                            outline: 'unset'
                        },
                        '&:focus-visible': {
                            borderColor: `${`var(--ds-border-focused, ${(0, $7bb4c1736002a04a$export$e62e8919cca44969)})`}`
                        }
                    }
                },
                [`> .${(0, $iRC0e.RendererCssClassName).SORTABLE_COLUMN} > .${(0, $iRC0e.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER}`]: {
                    margin: 0,
                    [`.${0, $438179c68884651b$export$bd4f24d8b1e86b23}`]: {
                        opacity: 1,
                        transition: `opacity 0.2s ease-in-out`
                    }
                },
                [`> .${(0, $iRC0e.RendererCssClassName).SORTABLE_COLUMN}
						> .${(0, $iRC0e.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER}`]: {
                    [`.${0, $438179c68884651b$export$bd4f24d8b1e86b23}`]: {
                        opacity: 0,
                        '&:focus': {
                            opacity: 1
                        }
                    }
                },
                [`&:hover:not(
							:has(
									.${(0, $iRC0e.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}
										.${(0, $iRC0e.RendererCssClassName).SORTABLE_COLUMN}:hover
								)
						)
						> .${(0, $iRC0e.RendererCssClassName).SORTABLE_COLUMN}
						> .${(0, $iRC0e.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER}`]: {
                    [`.${0, $438179c68884651b$export$bd4f24d8b1e86b23}`]: {
                        opacity: 1
                    }
                }
            }
        }
    }
});
const $28bec4b928772749$var$rendererTableColumnStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    [`.${(0, $iRC0e.RendererCssClassName).DOCUMENT} .${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        'table[data-number-column="true"]': {
            [`.${(0, $iRC0e.RendererCssClassName).NUMBER_COLUMN}`]: {
                backgroundColor: `${"var(--ds-background-accent-gray-subtlest, #F1F2F4)"}`,
                borderRight: `${"var(--ds-border-width, 1px)"} solid
								${`var(--ds-background-accent-gray-subtler, ${(0, $7yBx7.akEditorTableBorder)})`}`,
                width: `${(0, $7yBx7.akEditorTableNumberColumnWidth)}px`,
                textAlign: 'center',
                color: `${`var(--ds-text-subtlest, ${(0, $7bb4c1736002a04a$export$f563ee71e9ee74cd)})`}`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: `${0.875} rem`
            },
            [`.fixed .${(0, $iRC0e.RendererCssClassName).NUMBER_COLUMN}`]: {
                borderRight: `0px none`
            }
        }
    }
});
const $28bec4b928772749$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinks = /*#__PURE__*/ (0, $1NIU8.css)({
    [`.${(0, $iRC0e.RendererCssClassName).DOCUMENT} .${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $cjLtO.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            [`.${(0, $iRC0e.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}`]: {
                [`.${(0, $iRC0e.RendererCssClassName).SORTABLE_COLUMN}`]: {
                    [`.${0, $a6S67.HeadingAnchorWrapperClassName}`]: {
                        position: 'unset'
                    },
                    '>': {
                        'h1, h2, h3, h4, h5, h6': {
                            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                            marginRight: '30px'
                        }
                    }
                }
            }
        }
    }
});
// @ts-expect-error - throw TS error when use !import in position.
const $28bec4b928772749$var$stickyHeaderStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    'tr[data-header-row].fixed': {
        position: 'fixed !important',
        display: 'flex',
        overflow: 'hidden',
        zIndex: `${(0, $7yBx7.akEditorStickyHeaderZIndex)}`,
        borderRight: `${"var(--ds-border-width, 1px)"} solid ${`var(--ds-background-accent-gray-subtler, ${(0, $7yBx7.akEditorTableBorder)})`}`,
        borderBottom: `${"var(--ds-border-width, 1px)"} solid ${`var(--ds-background-accent-gray-subtler, ${(0, $7yBx7.akEditorTableBorder)})`}`,
        /* this is to compensate for the table border */ transform: 'translateX(-1px)'
    },
    '.sticky > th': {
        zIndex: `${(0, $7yBx7.akEditorStickyHeaderZIndex)}`,
        position: 'fixed !important',
        top: 0
    },
    /* Make the number column header sticky */ '.sticky > td': {
        position: 'fixed !important',
        top: 0
    },
    /* add border for position: sticky
  and work around background-clip: padding-box
  bug for FF causing box-shadow bug in Chrome */ '.sticky th, .sticky td': {
        boxShadow: `0px 1px ${`var(--ds-background-accent-gray-subtler, ${(0, $7yBx7.akEditorTableBorder)})`},
			0px -0.5px ${`var(--ds-background-accent-gray-subtler, ${(0, $7yBx7.akEditorTableBorder)})`},
			inset -1px 0px ${`var(--ds-background-accent-gray-subtler, ${(0, $7yBx7.akEditorTableToolbar)})`},
			0px -1px ${`var(--ds-background-accent-gray-subtler, ${(0, $7yBx7.akEditorTableToolbar)})`}`
    },
    /* this will remove jumpiness caused in Chrome for sticky headers */ '.fixed + tr': {
        minHeight: '0px'
    }
});
const $28bec4b928772749$var$codeBlockAndLayoutStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    /*
   * We wrap CodeBlock in a grid to prevent it from overflowing the container of the renderer.
   * See ED-4159.
   */ '& .code-block': {
        maxWidth: '100%',
        display: 'block',
        position: 'relative',
        borderRadius: "var(--ds-radius-small, 3px)",
        /*
     * The overall renderer has word-wrap: break; which causes issues with
     * code block line numbers in Safari / iOS.
     */ wordWrap: 'normal'
    },
    '& .MediaGroup, & .code-block': {
        marginTop: `${(0, $7yBx7.blockNodesVerticalMargin)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:first-child': {
            marginTop: 0
        }
    },
    // We overwrite the rule that clears margin-top for first nested codeblocks, as
    // our lightweight codeblock dom structure will always nest the codeblock inside
    // an extra container div which would constantly be targeted. Now, top-level
    // lightweight codeblock containers will not be targeted.
    // NOTE: This must be added after other .code-block styles in the root
    // Renderer stylesheet.
    [`.${(0, $iRC0e.RendererCssClassName).DOCUMENT}
		> .${(0, $ka8WB.LightWeightCodeBlockCssClassName).CONTAINER}
		.${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        marginTop: (0, $7yBx7.blockNodesVerticalMargin)
    },
    '& [data-layout-section]': {
        marginTop: "var(--ds-space-250, 20px)",
        '& > div + div': {
            marginLeft: "var(--ds-space-400, 32px)"
        },
        [`@media screen and (max-width: ${0, $7yBx7.gridMediumMaxWidth}px)`]: {
            '& > div + div': {
                marginLeft: 0
            }
        },
        '& .MediaGroup, & .code-block': {
            marginTop: (0, $7yBx7.blockNodesVerticalMargin),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:first-child': {
                marginTop: 0
            }
        }
    },
    '& li': {
        '> .code-block': {
            margin: `${(0, $7yBx7.blockNodesVerticalMargin)} 0 0 0`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:first-child': {
            marginTop: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div:last-of-type.code-block': {
            marginBottom: (0, $7yBx7.blockNodesVerticalMargin)
        }
    }
});
const $28bec4b928772749$var$layoutSectionForAdvancedLayoutsStyles = {
    name: "4wptv0",
    styles: "& [data-layout-section]{& > div + div{margin-left:0;}}"
};
const $28bec4b928772749$var$gridRenderForCodeBlockStyles = {
    name: "18d2t58",
    styles: "& .code-block{display:grid;grid-template-columns:minmax(0, 1fr);& > span{grid-column:1;}}"
};
// This prevents https://product-fabric.atlassian.net/browse/ED-20924
const $28bec4b928772749$var$codeBlockInListSafariFixStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    [`&:not([data-node-type='decisionList']) > li,
		&:not(.${(0, $e2Ny4.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}) > li`]: {
        '&::before': {
            content: '" "',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $7yBx7.akEditorLineHeight)
        },
        [`> p:first-child,
			> .code-block:first-child,
			> .ProseMirror-gapcursor:first-child + .code-block`]: {
            marginTop: `-${(0, $7yBx7.akEditorLineHeight)}em !important`
        }
    }
});
const $28bec4b928772749$var$columnLayoutSharedStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '[data-layout-section]': {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media screen and (max-width: ${0, $7yBx7.gridMediumMaxWidth}px)`]: {
            flexDirection: 'column'
        }
    }
});
const $28bec4b928772749$var$columnLayoutResponsiveSharedStyle = {
    name: "ee7qh9",
    styles: "[data-layout-section]{display:flex;flex-direction:row;gap:var(--ds-space-100, 8px);& > *{flex:1;min-width:0;}& > .unsupportedBlockView-content-wrap{min-width:initial;}}.layout-section-container{container-type:inline-size;container-name:layout-area;}"
};
const $28bec4b928772749$var$columnLayoutResponsiveRendererStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.layout-section-container [data-layout-section]': {
        gap: "var(--ds-space-600, 48px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
        [`@container layout-area (max-width: ${$28bec4b928772749$var$LAYOUT_BREAKPOINT_RENDERER}px)`]: {
            flexDirection: 'column',
            gap: "var(--ds-space-400, 32px)"
        }
    }
});
const $28bec4b928772749$var$rendererAnnotationStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    "& [data-mark-type='annotation'][data-mark-annotation-state='active'] [data-annotation-mark], & [data-annotation-draft-mark][data-annotation-inline-node]": {
        background: `var(--ds-background-accent-yellow-subtler, ${(0, $7bb4c1736002a04a$export$41060a744ab0b7ae)})`,
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${`var(--ds-border-accent-yellow, ${(0, $7bb4c1736002a04a$export$c6930421db9fa514)})`}`,
        boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $7bb4c1736002a04a$export$d2d3bedfb276cac0)}, -1px 2px 3px ${(0, $7bb4c1736002a04a$export$d2d3bedfb276cac0)}`})`,
        cursor: 'pointer',
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"}`
    }
});
const $28bec4b928772749$var$rendererAnnotationStylesCommentHeightFix = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node]': {
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid transparent`,
        cursor: 'pointer',
        padding: `1px 0 ${"var(--ds-space-025, 2px)"}`,
        background: `var(--ds-background-accent-yellow-subtler, ${(0, $7bb4c1736002a04a$export$41060a744ab0b7ae)})`,
        borderBottomColor: `var(--ds-border-accent-yellow, ${(0, $7bb4c1736002a04a$export$c6930421db9fa514)})`,
        boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $7bb4c1736002a04a$export$d2d3bedfb276cac0)}, -1px 2px 3px ${(0, $7bb4c1736002a04a$export$d2d3bedfb276cac0)}`})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node][data-inline-card]': {
        padding: '5px 0 3px 0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node].date-lozenger-container': {
        paddingTop: "var(--ds-space-025, 2px)"
    }
});
const $28bec4b928772749$var$RENDERER_LIST_DENSE_GAP = `max(0px,calc((var(--ak-renderer-base-font-size) - ${(0, $7yBx7.akEditorFullPageDenseFontSize)}px)* (4/3)))`;
const $28bec4b928772749$var$TASKLIST_CONTAINER_DENSE_MARGIN = `max(calc(10px + (var(--ak-renderer-base-font-size) - ${(0, $7yBx7.akEditorFullPageDenseFontSize)}px) *( 2 / 3)))`;
const $28bec4b928772749$var$denseStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // Scale emoji size based on base font size
    // Default: 20px emoji at 16px base font
    // Scaled: 20px * (baseFontSize/16)
    // E.g., dense mode (13px base): 20px * (13/16) = 16.25px
    [`.${(0, $dXRfX.EmojiSharedCssClassName).EMOJI_IMAGE}`]: {
        height: `calc(${(0, $8iUeU.defaultEmojiHeight)} * var(--ak-renderer-base-font-size) / ${(0, $7yBx7.akEditorFullPageDefaultFontSize)})`,
        width: `calc(${(0, $8iUeU.defaultEmojiHeight)} * var(--ak-renderer-base-font-size) / ${(0, $7yBx7.akEditorFullPageDefaultFontSize)})`,
        maxHeight: `calc(${(0, $8iUeU.defaultEmojiHeight)} * var(--ak-renderer-base-font-size) / ${(0, $7yBx7.akEditorFullPageDefaultFontSize)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        img: {
            width: '100%',
            height: '100%',
            objectFit: 'contain'
        }
    },
    // Scale panel icon
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${(0, $iRC0e.RendererCssClassName).DOCUMENT} .ak-editor-panel .ak-editor-panel__icon`]: {
        height: "var(--ds-space-250, 20px)",
        width: "var(--ds-space-250, 20px)"
    },
    // Condense spacing across lists, tasks and decisions
    [`.${(0, $iRC0e.RendererCssClassName).DOCUMENT}`]: {
        // Adjacent list items
        'li + li': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $28bec4b928772749$var$RENDERER_LIST_DENSE_GAP
        },
        // Nested lists directly under an li (unordered and ordered)
        'li > ul, li > ol, .ak-ul li > ul, .ak-ul li > ol, .ak-ol li > ul, .ak-ol li > ol': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $28bec4b928772749$var$RENDERER_LIST_DENSE_GAP
        },
        // Task lists
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-task-list-local-id]': {
            // Task lists: container top margin
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $28bec4b928772749$var$TASKLIST_CONTAINER_DENSE_MARGIN
        },
        // Task lists: sibling items and nested lists
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-task-list-local-id] > * + *': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $28bec4b928772749$var$RENDERER_LIST_DENSE_GAP
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-task-list-local-id] [data-task-list-local-id], [data-task-local-id] [data-task-local-id]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $28bec4b928772749$var$RENDERER_LIST_DENSE_GAP
        }
    }
});
const $28bec4b928772749$export$8f0929e72efe521f = (props)=>{
    const { onClick: onClick, onMouseDown: onMouseDown, appearance: appearance, contentMode: contentMode, allowNestedHeaderLinks: allowNestedHeaderLinks, allowColumnSorting: allowColumnSorting, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, children: children, innerRef: innerRef, testId: testId } = props;
    // Scroll to localId functionality
    (0, $ePRGY.useScrollToLocalId)(innerRef, (0, $9Letn.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true));
    const isAdvancedLayoutsOn = (0, $92xoS.editorExperiment)('advanced_layouts', true);
    const isPreviewPanelResponsivenessOn = (0, $92xoS.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    });
    const baseFontSize = (0, $c3ajv.getBaseFontSize)(appearance, contentMode);
    const browser = (0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $7EdFW.getBrowserInfo)() : (0, $7EdFW.browser);
    return(// eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        ref: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        style: {
            '--ak-renderer-base-font-size': `${baseFontSize}px`,
            '--ak-renderer-editor-font-heading-h1': `${(0, $Vv4zU.default)('editor.font.heading.h1')}`,
            '--ak-renderer-editor-font-heading-h2': `${(0, $Vv4zU.default)('editor.font.heading.h2')}`,
            '--ak-renderer-editor-font-heading-h3': `${(0, $Vv4zU.default)('editor.font.heading.h3')}`,
            '--ak-renderer-editor-font-heading-h4': `${(0, $Vv4zU.default)('editor.font.heading.h4')}`,
            '--ak-renderer-editor-font-heading-h5': `${(0, $Vv4zU.default)('editor.font.heading.h5')}`,
            '--ak-renderer-editor-font-heading-h6': `${(0, $Vv4zU.default)('editor.font.heading.h6')}`,
            '--ak-renderer-editor-font-normal-text': `${(0, $Vv4zU.default)('editor.font.body')}`
        },
        css: [
            $28bec4b928772749$var$baseStyles,
            $28bec4b928772749$var$hideHeadingCopyLinkWrapperStyles,
            appearance === 'full-page' && isPreviewPanelResponsivenessOn && $28bec4b928772749$var$rendererFullPageStylesWithReducedPadding,
            appearance === 'full-page' && !isPreviewPanelResponsivenessOn && $28bec4b928772749$var$rendererFullPageStyles,
            appearance === 'full-width' && $28bec4b928772749$var$rendererFullWidthStyles,
            appearance === 'full-width' && !(0, $idsFq.isTableResizingEnabled)(appearance) && $28bec4b928772749$var$rendererFullWidthStylesForTableResizing,
            !(0, $eGOwo.fg)('aifc_create_enabled') && $28bec4b928772749$var$telepointerStyles,
            (0, $eGOwo.fg)('aifc_create_enabled') && $28bec4b928772749$var$rovoTelepointerStyles,
            $28bec4b928772749$var$whitespaceSharedStyles,
            $28bec4b928772749$var$blockquoteSharedStyles,
            (0, $eGOwo.fg)('platform_editor_typography_ugc') ? $28bec4b928772749$var$headingsSharedStylesWithEditorUGC : $28bec4b928772749$var$headingsSharedStyles,
            $28bec4b928772749$var$headingWithAlignmentStyles,
            $28bec4b928772749$var$ruleSharedStyles,
            (contentMode === 'compact' || contentMode === 'dense') && (0, $cbSL1.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $eGOwo.fg)('platform_editor_content_mode_button_mvp') && $28bec4b928772749$var$extensionStyle,
            (0, $eGOwo.fg)('platform_editor_typography_ugc') ? (0, $cbSL1.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $eGOwo.fg)('platform_editor_content_mode_button_mvp') ? $28bec4b928772749$var$paragraphStylesUGCScaledMargin : $28bec4b928772749$var$paragraphSharedStylesWithEditorUGC : (0, $cbSL1.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $eGOwo.fg)('platform_editor_content_mode_button_mvp') ? $28bec4b928772749$var$paragraphSharedStyleScaledMargin : $28bec4b928772749$var$paragraphSharedStyles,
            $28bec4b928772749$var$listsSharedStyles,
            browser.gecko && $28bec4b928772749$var$listsSharedStylesForGekko,
            $28bec4b928772749$var$indentationSharedStyles,
            (0, $eGOwo.fg)('platform_editor__renderer_indentation_text_margin') && $28bec4b928772749$var$indentationSharedStylesWithMarginFix,
            $28bec4b928772749$var$blockMarksSharedStyles,
            $28bec4b928772749$var$codeMarkSharedStyles,
            $28bec4b928772749$var$shadowSharedStyle,
            $28bec4b928772749$var$dateSharedStyle,
            $28bec4b928772749$var$textColorStyles,
            $28bec4b928772749$var$backgroundColorStyles,
            (0, $cbSL1.expValEquals)('platform_editor_text_highlight_padding', 'isEnabled', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            $28bec4b928772749$export$a365082c2a191514,
            $28bec4b928772749$var$tasksAndDecisionsStyles,
            $28bec4b928772749$var$smartCardStyles,
            $28bec4b928772749$var$smartCardStylesAvatarFix,
            (0, $92xoS.editorExperiment)('platform_editor_preview_panel_linking_exp', true) && $28bec4b928772749$var$headerSmartCardStyles,
            $28bec4b928772749$var$smartCardStylesAvatarMarginFix,
            $28bec4b928772749$var$smartCardStylesAvatarListZeroMarginTop,
            (0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes') && $28bec4b928772749$var$rendererAnnotationStyles,
            // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes') && (0, $eGOwo.fg)('annotations_align_editor_and_renderer_styles') && $28bec4b928772749$var$rendererAnnotationStylesCommentHeightFix,
            $28bec4b928772749$var$baseOtherStyles,
            allowNestedHeaderLinks && $28bec4b928772749$var$alignedHeadingAnchorStyle,
            $28bec4b928772749$var$mediaSingleSharedStyle,
            // merge firstWrappedMediaStyles with mediaSingleSharedStyle when clean up platform_editor_fix_media_in_renderer
            (0, $eGOwo.fg)('platform_editor_fix_media_in_renderer') && $28bec4b928772749$var$firstWrappedMediaStyles,
            $28bec4b928772749$var$tableSharedStyle,
            $28bec4b928772749$var$tableRendererHeaderStylesForTableCellOnly,
            (0, $eGOwo.fg)('platform_editor_bordered_panel_nested_in_table') && $28bec4b928772749$var$tableRendererNestedPanelStyles,
            $28bec4b928772749$var$isBackgroundClipBrowserFixNeeded() && $28bec4b928772749$var$tableStylesBackGroundClipForGeckoForTableCellOnly,
            (0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') ? $28bec4b928772749$var$firstNodeWithNotMarginTopWithNestedDnD : $28bec4b928772749$var$firstNodeWithNotMarginTop,
            $28bec4b928772749$var$rendererTableStyles,
            (0, $idsFq.isStickyScrollbarEnabled)(appearance) && $28bec4b928772749$var$stickyScrollbarStyles,
            $28bec4b928772749$var$rendererTableHeaderEqualHeightStylesForTableCellOnly,
            allowColumnSorting && $28bec4b928772749$var$rendererTableSortableColumnStyles,
            allowColumnSorting && allowNestedHeaderLinks && $28bec4b928772749$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinks,
            $28bec4b928772749$var$rendererTableColumnStyles,
            $28bec4b928772749$var$stickyHeaderStyles,
            $28bec4b928772749$var$codeBlockAndLayoutStyles,
            $28bec4b928772749$var$columnLayoutSharedStyle,
            isAdvancedLayoutsOn && $28bec4b928772749$var$columnLayoutResponsiveSharedStyle,
            isAdvancedLayoutsOn && $28bec4b928772749$var$columnLayoutResponsiveRendererStyles,
            isAdvancedLayoutsOn && $28bec4b928772749$var$layoutSectionForAdvancedLayoutsStyles,
            !useBlockRenderForCodeBlock && $28bec4b928772749$var$gridRenderForCodeBlockStyles,
            browser.safari && $28bec4b928772749$var$codeBlockInListSafariFixStyles,
            appearance === 'full-page' && !isPreviewPanelResponsivenessOn && $28bec4b928772749$var$responsiveBreakoutWidth,
            appearance === 'full-page' && isPreviewPanelResponsivenessOn && $28bec4b928772749$var$responsiveBreakoutWidthWithReducedPadding,
            appearance === 'full-width' && $28bec4b928772749$var$responsiveBreakoutWidthFullWidth,
            (0, $cbSL1.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $eGOwo.fg)('platform_editor_content_mode_button_mvp') && $28bec4b928772749$var$denseStyles
        ],
        "data-testid": testId
    }, children));
};

});
parcelRegister("ePRGY", function(module, exports) {
$parcel$export(module.exports, "useScrollToLocalId", () => $b26268eff82d271e$export$b61745354f522fe);

var $eJOHy = parcelRequire("eJOHy");

var $fceQU = parcelRequire("fceQU");
// Find editor node dom with localId - similar to confluence useScrollOnUrlChange.ts
const $b26268eff82d271e$var$getLocalIdSelector = (localId, container)=>{
    // Check if the element with data-local-id exists
    let element = container.querySelector(`[data-local-id="${localId}"]`);
    if (element) return element;
    // Special case for decision lists and task lists which already have localId
    element = container.querySelector(`[data-decision-list-local-id="${localId}"]`);
    if (element) return element;
    element = container.querySelector(`[data-task-list-local-id="${localId}"]`);
    if (element) return element;
    // Special case for tables which use data-table-local-id
    element = container.querySelector(`[data-table-local-id="${localId}"]`);
    if (element) return element;
    // Special case for extension, smart cards and media which use lowercase localid
    element = container.querySelector(`[localid="${localId}"]`);
    if (element) return element;
    return null;
};
const $b26268eff82d271e$export$b61745354f522fe = (containerRef, shouldScrollToLocalId)=>{
    (0, $eJOHy.useEffect)(()=>{
        // Only run in browser environment
        if (typeof window === 'undefined' || !containerRef?.current || !shouldScrollToLocalId) return;
        // Parse URL parameters for block ID
        const urlParams = new URLSearchParams(window.location.search);
        const blockId = urlParams.get('block');
        if (!blockId) return;
        let retryCount = 0;
        // 5 second timeout based on dashboard showing ~4.96s TTI load time
        const maxRetries = 20; // Maximum 20 retries (5 seconds at 250ms intervals)
        const retryInterval = 250; // Check every 250ms
        let intervalId = null;
        const scrollToElement = ()=>{
            if (containerRef?.current) {
                const element = $b26268eff82d271e$var$getLocalIdSelector(blockId, containerRef.current);
                if (element) {
                    element.scrollIntoView({
                        behavior: 'smooth'
                    });
                    return true;
                }
            }
            return false;
        };
        const attemptScroll = ()=>{
            retryCount++;
            // Try to scroll to element
            if (scrollToElement()) {
                if (intervalId) {
                    clearInterval(intervalId);
                    intervalId = null;
                }
                return true;
            }
            // Stop retrying if we've exceeded max retries
            if (retryCount >= maxRetries) {
                if (intervalId) {
                    clearInterval(intervalId);
                    intervalId = null;
                }
                return false;
            }
            return false;
        };
        // Try to scroll immediately
        if (attemptScroll()) return;
        if ((0, $fceQU.getDocument)()?.readyState === 'complete') // Document is already ready, try a few more times with delays
        // This handles cases where elements are added after document ready
        intervalId = setInterval(()=>{
            attemptScroll();
        }, retryInterval);
        else // Document not ready yet, wait for it and then retry
        intervalId = setInterval(()=>{
            if ((0, $fceQU.getDocument)()?.readyState === 'complete') attemptScroll();
            else if (retryCount >= maxRetries) // Stop retrying even if document isn't ready
            {
                if (intervalId) {
                    clearInterval(intervalId);
                    intervalId = null;
                }
            } else retryCount++;
        }, retryInterval);
        // Cleanup function
        return ()=>{
            if (intervalId) {
                clearInterval(intervalId);
                intervalId = null;
            }
        };
    }, [
        containerRef,
        shouldScrollToLocalId
    ]);
};

});

parcelRegister("9Letn", function(module, exports) {
$parcel$export(module.exports, "expValEqualsNoExposure", () => $83516221b3225979$export$63eebf86443a0a61);

var $803eB = parcelRequire("803eB");
function $83516221b3225979$export$63eebf86443a0a61(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue = null) {
    return (0, $803eB.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, false);
}

});

parcelRegister("dA9km", function(module, exports) {
$parcel$export(module.exports, "INLINE_IMAGE_WRAPPER_CLASS_NAME", () => $a764f646abaeec54$export$dd2e16f83ae6aa78);
$parcel$export(module.exports, "INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY", () => $a764f646abaeec54$export$7ab34e219ce6eef);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY", () => $a764f646abaeec54$export$263a8a844c370a89);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY", () => $a764f646abaeec54$export$b0d1f1e1fb3c4b46);
$parcel$export(module.exports, "wrapperStyle", () => $a764f646abaeec54$export$c4d4f06a25de97f);
$parcel$export(module.exports, "selectedStyle", () => $a764f646abaeec54$export$a7abb1b3dc25813f);
$parcel$export(module.exports, "borderStyle", () => $a764f646abaeec54$export$4d0a7f76ad443516);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $hgI1e = parcelRequire("hgI1e");
const $a764f646abaeec54$export$dd2e16f83ae6aa78 = 'media-inline-image-wrapper';
const $a764f646abaeec54$export$7ab34e219ce6eef = '--editor-media-inline-image-aspect-ratio';
const $a764f646abaeec54$export$263a8a844c370a89 = '--editor-media-inline-image-border-size';
const $a764f646abaeec54$export$b0d1f1e1fb3c4b46 = '--editor-media-inline-image-border-color';
// We implemented such selectors to ensure specificity:
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Nested and dynamic css calls are violations, needs manual remediation
const $a764f646abaeec54$var$inlineImageHeight = (height, margin = 0)=>/*#__PURE__*/ (0, $1NIU8.css)(">.mediaInlineView-content-wrap>.", $a764f646abaeec54$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap>.", $a764f646abaeec54$export$dd2e16f83ae6aa78, ",>.", $a764f646abaeec54$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .", $a764f646abaeec54$export$dd2e16f83ae6aa78, "{height:", height, "px;transform:translateY(", margin, "px);}");
const $a764f646abaeec54$export$dee15762144889b7 = /*#__PURE__*/ (0, $1NIU8.css)(".", $a764f646abaeec54$export$dd2e16f83ae6aa78, "{height:", (0, $hgI1e.referenceHeights)['p'], "px;transform:translateY(-2px);}h1{", $a764f646abaeec54$var$inlineImageHeight((0, $hgI1e.referenceHeights)['h1'], -3), ";}h2{", $a764f646abaeec54$var$inlineImageHeight((0, $hgI1e.referenceHeights)['h2'], -3), ";}h3{", $a764f646abaeec54$var$inlineImageHeight((0, $hgI1e.referenceHeights)['h3'], -2), ";}h4{", $a764f646abaeec54$var$inlineImageHeight((0, $hgI1e.referenceHeights)['h4'], -2), ";}h5{", $a764f646abaeec54$var$inlineImageHeight((0, $hgI1e.referenceHeights)['h5'], -2), ";}h6{", $a764f646abaeec54$var$inlineImageHeight((0, $hgI1e.referenceHeights)['h6'], -2), ";}");
const $a764f646abaeec54$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'inline-flex',
    cursor: 'pointer',
    justifyContent: 'center',
    alignItems: 'center',
    verticalAlign: 'middle',
    overflow: 'hidden',
    borderRadius: `${"var(--ds-radius-small, 3px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    aspectRatio: `var(${$a764f646abaeec54$export$7ab34e219ce6eef}, ${(0, $hgI1e.DEFAULT_INLINE_IMAGE_ASPECT_RATIO)})`,
    maxWidth: '100%'
});
const $a764f646abaeec54$export$a7abb1b3dc25813f = /*#__PURE__*/ (0, $1NIU8.css)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}`,
    outline: 'none'
});
const $a764f646abaeec54$export$4d0a7f76ad443516 = /*#__PURE__*/ (0, $1NIU8.css)({
    borderColor: `var(${$a764f646abaeec54$export$b0d1f1e1fb3c4b46})`,
    borderStyle: 'solid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `calc(var(${$a764f646abaeec54$export$263a8a844c370a89}, ${(0, $hgI1e.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 2px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderWidth: `calc(var(${$a764f646abaeec54$export$263a8a844c370a89}, ${(0, $hgI1e.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 1px)`,
    boxSizing: `border-box`
});

});
parcelRegister("hgI1e", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_IMAGE_WIDTH", () => $e1b709a355af1a7b$export$d722b7527b1834a8);
$parcel$export(module.exports, "DEFAULT_IMAGE_HEIGHT", () => $e1b709a355af1a7b$export$da894f7669b4e67c);
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_ASPECT_RATIO", () => $e1b709a355af1a7b$export$286cf28b87ad4b4f);
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_BORDER_SIZE", () => $e1b709a355af1a7b$export$64fe09732fb8680);
$parcel$export(module.exports, "referenceHeights", () => $e1b709a355af1a7b$export$c1317a9224e4d798);
const $e1b709a355af1a7b$export$d722b7527b1834a8 = 250;
const $e1b709a355af1a7b$export$da894f7669b4e67c = 200;
const $e1b709a355af1a7b$export$286cf28b87ad4b4f = $e1b709a355af1a7b$export$d722b7527b1834a8 / $e1b709a355af1a7b$export$da894f7669b4e67c;
const $e1b709a355af1a7b$export$64fe09732fb8680 = 0;
const $e1b709a355af1a7b$export$c1317a9224e4d798 = {
    p: 22,
    h1: 36,
    h2: 31,
    h3: 25,
    h4: 23,
    h5: 20,
    h6: 18
};

});


parcelRegister("fDsDd", function(module, exports) {
$parcel$export(module.exports, "DateSharedCssClassName", () => $2b5fce49fa2ad059$export$99cdf122d0bb9f95);
const $2b5fce49fa2ad059$export$99cdf122d0bb9f95 = {
    DATE_WRAPPER: `date-lozenger-container`,
    DATE_CONTAINER: 'dateView-content-wrap'
};

});

parcelRegister("laqWo", function(module, exports) {
$parcel$export(module.exports, "richMediaClassName", () => $7b0053d081be8618$export$cfe6da7d522d87bb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");
const $7b0053d081be8618$export$cfe6da7d522d87bb = 'rich-media-item';
const $7b0053d081be8618$var$wrappedMediaBreakoutPoint = 410;
const $7b0053d081be8618$export$d031611b96ba4cf0 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${$7b0053d081be8618$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${$7b0053d081be8618$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-right + .${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-left + .${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-right, .${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-right + .${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-left, .${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-left + .${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-left, .${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-right + .${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$7b0053d081be8618$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});
const $7b0053d081be8618$export$b51dea84d928a378 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${$7b0053d081be8618$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".mediaSingleView-content-wrap[layout^='wrap-']": {
        position: 'relative',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        zIndex: (0, $7yBx7.akEditorWrappedNodeZIndex)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${$7b0053d081be8618$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-right + .${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-left + .${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-right, .${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-right + .${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-left, .${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-left + .${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-left, .${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-right + .${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$7b0053d081be8618$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});

});

parcelRegister("e2Ny4", function(module, exports) {
$parcel$export(module.exports, "SmartCardSharedCssClassName", () => $dc5da4ab3a080f09$export$4ccd31bf665a88f6);
const $dc5da4ab3a080f09$export$4ccd31bf665a88f6 = {
    INLINE_CARD_CONTAINER: 'inlineCardView-content-wrap',
    BLOCK_CARD_CONTAINER: 'blockCardView-content-wrap',
    EMBED_CARD_CONTAINER: 'embedCardView-content-wrap',
    DATASOURCE_CONTAINER: 'datasourceView-content-wrap',
    LOADER_WRAPPER: 'loader-wrapper'
};

});

parcelRegister("gZAVf", function(module, exports) {
$parcel$export(module.exports, "TaskDecisionSharedCssClassName", () => $c7201827a86a9c90$export$a7172b75d403a0e4);
const $c7201827a86a9c90$export$a7172b75d403a0e4 = {
    DECISION_CONTAINER: 'decisionItemView-content-wrap',
    TASK_CONTAINER: 'taskItemView-content-wrap',
    //NOTE: value is a selector (data attribute), not a class name
    TASK_LIST_CONTAINER: '[data-node-type="actionList]',
    TASK_ITEM: 'task-item',
    TASK_CHECKBOX_CONTAINER: 'task-item-checkbox-wrap'
};

});

parcelRegister("ka8WB", function(module, exports) {
$parcel$export(module.exports, "LightWeightCodeBlockCssClassName", () => $bb090de99d5cd16d$export$afbde0e7339bed51);
$parcel$export(module.exports, "default", () => $bb090de99d5cd16d$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");
var $1rXAK = parcelRequire("1rXAK");

var $gBkUB = parcelRequire("gBkUB");

var $eM87S = parcelRequire("eM87S");

var $iRC0e = parcelRequire("iRC0e");
const $bb090de99d5cd16d$var$codeBlockSharedStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    [`.${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPED}
		> .${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}
		> .${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
        marginRight: "var(--ds-space-100, 8px)",
        code: {
            display: 'block',
            wordBreak: 'break-word',
            whiteSpace: 'pre-wrap'
        }
    },
    [`.${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}
		> .${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
        display: 'flex',
        flex: 1,
        code: {
            flexGrow: 1,
            whiteSpace: 'pre'
        }
    },
    [`.${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        position: 'relative',
        backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
        borderRadius: "var(--ds-radius-small, 3px)",
        margin: `${(0, $7yBx7.blockNodesVerticalMargin)} 0 0 0`,
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        minWidth: `${(0, $7yBx7.akEditorTableCellMinWidth)}px`,
        cursor: 'pointer',
        clear: 'both',
        '--ds--code--bg-color': 'transparent',
        '.code-block-gutter-pseudo-element::before': {
            content: '"attr(data-label)"'
        },
        /* This is necessary to allow for arrow key navigation in/out of code blocks in Firefox. */ whiteSpace: 'normal',
        [`.${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_START}`]: {
            position: 'absolute',
            visibility: 'hidden',
            height: '1.5rem',
            top: '0px',
            left: '0px'
        },
        [`${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_END}`]: {
            position: 'absolute',
            visibility: 'hidden',
            height: '1.5rem',
            bottom: '0px',
            right: '0px'
        },
        [`.${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}`]: {
            position: 'relative',
            backgroundColor: "var(--ds-background-neutral, #091E420F)",
            display: 'flex',
            borderRadius: "var(--ds-radius-small, 3px)",
            width: '100%',
            counterReset: 'line',
            overflowX: 'auto',
            backgroundImage: 'var(--ak-renderer-codeblock-content-wrapper-bg-img)',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'local, local, local, local, scroll, scroll, scroll, scroll',
            backgroundSize: `${"var(--ds-space-300, 24px)"} 100%,
				${"var(--ds-space-300, 24px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				1px 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				1px 100%`,
            backgroundPosition: `0 0,
				0 0,
				100% 0,
				100% 0,
				100% 0,
				100% 0,
				0 0,
				0 0`,
            /* Be careful if refactoring this; it is needed to keep arrow key navigation in Firefox consistent with other browsers. */ overflowY: 'hidden'
        },
        [`.${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}`]: {
            backgroundColor: "var(--ds-background-neutral, #091E420F)",
            position: 'relative',
            width: 'var(--lineNumberGutterWidth, 2rem)',
            padding: "var(--ds-space-100, 8px)",
            flexShrink: 0,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            boxSizing: 'content-box'
        },
        // This is a fix of marker of list item with code block.
        // The list item marker in Chrome is aligned by the baseline of the text,
        // that's why we need to add a text (content: "1") to the line number gutter to align
        // the list item marker with the text.
        // Without it, the list item marker will be aligned by the bottom of the code block.
        [`.${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}::before`]: {
            content: '"1"',
            visibility: 'hidden',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: '1.5rem'
        },
        [`.${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
            code: {
                tabSize: 4,
                cursor: 'text',
                color: "var(--ds-text, #172B4D)",
                borderRadius: "var(--ds-radius-small, 3px)",
                margin: "var(--ds-space-100, 8px)",
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: `${0.875}rem`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                lineHeight: '1.5rem'
            }
        },
        [`.${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET}`]: {
            pointerEvents: 'none',
            userSelect: 'none',
            width: 'var(--lineNumberGutterWidth, 2rem)',
            left: 0,
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            padding: `0px ${"var(--ds-space-100, 8px)"}`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: '1.5rem',
            textAlign: 'right',
            color: "var(--ds-text-subtlest, #505F79)",
            boxSizing: 'content-box'
        }
    }
});
const $bb090de99d5cd16d$var$lightWeightCodeBlockStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    [`.${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        cursor: 'text'
    }
});
const $bb090de99d5cd16d$export$afbde0e7339bed51 = {
    CONTAINER: 'light-weight-code-block'
};
const $bb090de99d5cd16d$export$3f1ff491ca7c4c4a = ()=>{
    // We overwrite the rule that clears margin-top for first nested codeblocks, as
    // our lightweight codeblock dom structure will always nest the codeblock inside
    // an extra container div which would constantly be targeted. Now, top-level
    // lightweight codeblock containers will not be targeted.
    // NOTE: This must be added after other .code-block styles in the root
    // Renderer stylesheet.
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $1NIU8.css)(".", (0, $iRC0e.RendererCssClassName).DOCUMENT, ">.", $bb090de99d5cd16d$export$afbde0e7339bed51.CONTAINER, " .", (0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, "{margin-top:", (0, $7yBx7.blockNodesVerticalMargin), ";}");
};
const $bb090de99d5cd16d$var$LightWeightCodeBlock = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ text: text, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, className: className }, ref)=>{
    const textRows = (0, $eJOHy.useMemo)(()=>(text ?? '').split('\n'), [
        text
    ]);
    const { renderBidiWarnings: renderBidiWarnings } = (0, $eM87S.useBidiWarnings)({
        enableWarningTooltip: codeBidiWarningTooltipEnabled
    });
    const classNames = [
        $bb090de99d5cd16d$export$afbde0e7339bed51.CONTAINER,
        className
    ].join(' ');
    const codeBlockBackgroundImage = (0, $1rXAK.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    });
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $bb090de99d5cd16d$var$codeBlockSharedStyles,
            $bb090de99d5cd16d$var$lightWeightCodeBlockStyles
        ],
        style: {
            '--ak-renderer-codeblock-content-wrapper-bg-img': codeBlockBackgroundImage
        }
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        className: (0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER
    }, textRows.map((_, index)=>// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            key: index
        }))), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        className: (0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("code", null, renderBidiWarnings(text))))));
});
var $bb090de99d5cd16d$export$2e2bcd8739ae039 = $bb090de99d5cd16d$var$LightWeightCodeBlock;

});
parcelRegister("eM87S", function(module, exports) {
$parcel$export(module.exports, "useBidiWarnings", () => $594eb3f722888f10$export$9fb9fe546a188c7b);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $hDNIq = parcelRequire("hDNIq");

var $brgNx = parcelRequire("brgNx");

var $2E9Su = parcelRequire("2E9Su");

var $cbSL1 = parcelRequire("cbSL1");
const $594eb3f722888f10$export$9fb9fe546a188c7b = ({ enableWarningTooltip: enableWarningTooltip = true })=>{
    const intl = (0, $lRq8t.default)();
    const warningLabel = intl.formatMessage((0, $brgNx.codeBidiWarningMessages).label);
    const renderBidiWarnings = (text)=>{
        if ((0, $cbSL1.expValEquals)('platform_editor_remove_bidi_char_warning', 'isEnabled', true)) return text;
        return (0, $2E9Su.default)(text, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hDNIq.default), {
                bidiCharacter: bidiCharacter,
                label: warningLabel,
                tooltipEnabled: enableWarningTooltip
            }, index));
    };
    return {
        renderBidiWarnings: renderBidiWarnings,
        warningLabel: warningLabel
    };
};

});


parcelRegister("Vv4zU", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff494cb19d6b1863$export$2e2bcd8739ae039);

var $eGOwo = parcelRequire("eGOwo");

var $hszUU = parcelRequire("hszUU");
function $ff494cb19d6b1863$var$editorUGCToken(path) {
    let tokens;
    if ((0, $eGOwo.fg)('platform_editor_typography_ugc')) tokens = (0, $hszUU.editorUGCTokensRefreshed);
    else tokens = (0, $hszUU.editorUGCTokens);
    return tokens[path];
}
var $ff494cb19d6b1863$export$2e2bcd8739ae039 = $ff494cb19d6b1863$var$editorUGCToken;

});
parcelRegister("hszUU", function(module, exports) {
$parcel$export(module.exports, "editorUGCTokens", () => $587fd41298381b81$export$4a3637dc6e2ae29e);
$parcel$export(module.exports, "editorUGCTokensRefreshed", () => $587fd41298381b81$export$63adc0ebe3278d31);
const $587fd41298381b81$export$4a3637dc6e2ae29e = {
    'editor.font.heading.h1': 'normal 500 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 500 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600 1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 700 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};
const $587fd41298381b81$export$95588e746468319e = {
    'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 600 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600  1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600  0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};
const $587fd41298381b81$export$63adc0ebe3278d31 = {
    'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 600 1.42857em/1.2 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600 1em/1.14286 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};

});


parcelRegister("c3ajv", function(module, exports) {
$parcel$export(module.exports, "getBaseFontSize", () => $99fc19356015857a$export$8e2864079bc476bd);

var $7yBx7 = parcelRequire("7yBx7");

var $cbSL1 = parcelRequire("cbSL1");
const $99fc19356015857a$export$8e2864079bc476bd = (appearance, contentMode)=>{
    if ((0, $cbSL1.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test')) {
        if (contentMode === ((0, $cbSL1.expValEquals)('confluence_content_mode_replace_dense_with_compact', 'cohort', 'test') ? 'compact' : 'dense')) return 0, $7yBx7.akEditorFullPageDenseFontSize;
    }
    return appearance && appearance !== 'comment' ? (0, $7yBx7.akEditorFullPageDefaultFontSize) : 14;
};

});

parcelRegister("8iUeU", function(module, exports) {
$parcel$export(module.exports, "customCategory", () => $2c4fbc100f789f14$export$5e4e3d1c3e43156a);
$parcel$export(module.exports, "frequentCategory", () => $2c4fbc100f789f14$export$78ccdc4be403c468);
$parcel$export(module.exports, "searchCategory", () => $2c4fbc100f789f14$export$1b0258512be88334);
$parcel$export(module.exports, "yourUploadsCategory", () => $2c4fbc100f789f14$export$42b510423367f354);
$parcel$export(module.exports, "customTitle", () => $2c4fbc100f789f14$export$5d0f2d8ee50f86f5);
$parcel$export(module.exports, "userCustomTitle", () => $2c4fbc100f789f14$export$1debc2f10cc69389);
$parcel$export(module.exports, "dataURLPrefix", () => $2c4fbc100f789f14$export$8ac325bfd32359b0);
$parcel$export(module.exports, "deleteEmojiLabel", () => $2c4fbc100f789f14$export$a330961542edfe6f);
$parcel$export(module.exports, "MAX_ORDINAL", () => $2c4fbc100f789f14$export$1a817f1886276c6d);
$parcel$export(module.exports, "defaultEmojiHeight", () => $2c4fbc100f789f14$export$3f99ac31dc0406db);
$parcel$export(module.exports, "emojiPickerWidth", () => $2c4fbc100f789f14$export$d171dc12fee2b1da);
$parcel$export(module.exports, "sizeGap", () => $2c4fbc100f789f14$export$c10ac8125a260041);
$parcel$export(module.exports, "defaultEmojiPickerSize", () => $2c4fbc100f789f14$export$5248fb9e0cccc41f);
$parcel$export(module.exports, "emojiPickerListHeight", () => $2c4fbc100f789f14$export$7722b8e9522021df);
$parcel$export(module.exports, "localStoragePrefix", () => $2c4fbc100f789f14$export$e394a0c530ae5631);
$parcel$export(module.exports, "selectedToneStorageKey", () => $2c4fbc100f789f14$export$79ee4ef84c545f8f);
$parcel$export(module.exports, "defaultCategories", () => $2c4fbc100f789f14$export$d7ab74456f1aa1ad);
$parcel$export(module.exports, "KeyboardKeys", () => $2c4fbc100f789f14$export$70f9e5bc10d7eac);
$parcel$export(module.exports, "KeyboardNavigationDirection", () => $2c4fbc100f789f14$export$1c4f2adc1f8e19d3);
$parcel$export(module.exports, "CATEGORYSELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $2c4fbc100f789f14$export$99130b698ea188ae);
$parcel$export(module.exports, "EMOJI_KEYBOARD_KEYS_SUPPORTED", () => $2c4fbc100f789f14$export$84b035f8d01101cc);
$parcel$export(module.exports, "TONESELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $2c4fbc100f789f14$export$e27d4e477c0cd4ec);
$parcel$export(module.exports, "EMOJIPICKERLIST_KEYBOARD_KEYS_SUPPORTED", () => $2c4fbc100f789f14$export$97027974dc06eeee);
$parcel$export(module.exports, "DEFAULT_TONE", () => $2c4fbc100f789f14$export$4f0ee90b28d6efc5);
$parcel$export(module.exports, "EMOJI_LIST_COLUMNS", () => $2c4fbc100f789f14$export$2829f3ec323f8ec0);
$parcel$export(module.exports, "EMOJI_LIST_PAGE_COUNT", () => $2c4fbc100f789f14$export$ce3a0e7d2d7d6ba2);
$parcel$export(module.exports, "EMOJI_SEARCH_DEBOUNCE", () => $2c4fbc100f789f14$export$858e8dc100a97278);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RENDERED_EXP", () => $2c4fbc100f789f14$export$83aab2ae64548423);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP", () => $2c4fbc100f789f14$export$66cabad5e268b05e);
const $2c4fbc100f789f14$export$5e4e3d1c3e43156a = 'CUSTOM';
const $2c4fbc100f789f14$export$78ccdc4be403c468 = 'FREQUENT';
const $2c4fbc100f789f14$export$2c4b04c3aacdf1b3 = 'SITE';
const $2c4fbc100f789f14$export$1b0258512be88334 = 'SEARCH';
const $2c4fbc100f789f14$export$42b510423367f354 = 'USER_CUSTOM';
const $2c4fbc100f789f14$export$5d0f2d8ee50f86f5 = 'allUploadsCustomCategory';
const $2c4fbc100f789f14$export$1debc2f10cc69389 = 'userUploadsCustomCategory';
const $2c4fbc100f789f14$export$8ac325bfd32359b0 = 'data:';
const $2c4fbc100f789f14$export$a330961542edfe6f = 'delete-emoji';
const $2c4fbc100f789f14$export$1a817f1886276c6d = 100000;
const $2c4fbc100f789f14$export$3f99ac31dc0406db = 20;
const $2c4fbc100f789f14$export$d171dc12fee2b1da = 350;
const $2c4fbc100f789f14$export$c10ac8125a260041 = 80;
const $2c4fbc100f789f14$export$5248fb9e0cccc41f = 'medium';
const $2c4fbc100f789f14$export$94f75d625e7801d3 = 260;
const $2c4fbc100f789f14$export$7ed599d166d65aea = 295;
const $2c4fbc100f789f14$export$7722b8e9522021df = $2c4fbc100f789f14$export$7ed599d166d65aea - 58; // picker height - actions height
const $2c4fbc100f789f14$export$e218e5cb105a0e22 = 54;
const $2c4fbc100f789f14$export$e67f617938b111f1 = $2c4fbc100f789f14$export$7ed599d166d65aea + $2c4fbc100f789f14$export$e218e5cb105a0e22;
const $2c4fbc100f789f14$export$e394a0c530ae5631 = 'fabric.emoji';
const $2c4fbc100f789f14$export$79ee4ef84c545f8f = `${$2c4fbc100f789f14$export$e394a0c530ae5631}.selectedTone`;
const $2c4fbc100f789f14$export$d7ab74456f1aa1ad = [
    'PEOPLE',
    'NATURE',
    'FOODS',
    'ACTIVITY',
    'PLACES',
    'OBJECTS',
    'SYMBOLS',
    'FLAGS'
];
var $2c4fbc100f789f14$export$70f9e5bc10d7eac = /*#__PURE__*/ function(KeyboardKeys) {
    KeyboardKeys["ArrowLeft"] = "ArrowLeft";
    KeyboardKeys["ArrowRight"] = "ArrowRight";
    KeyboardKeys["ArrowUp"] = "ArrowUp";
    KeyboardKeys["ArrowDown"] = "ArrowDown";
    KeyboardKeys["PageUp"] = "PageUp";
    KeyboardKeys["PageDown"] = "PageDown";
    KeyboardKeys["Home"] = "Home";
    KeyboardKeys["End"] = "End";
    KeyboardKeys["Enter"] = "Enter";
    KeyboardKeys["Tab"] = "Tab";
    KeyboardKeys["Space"] = " ";
    KeyboardKeys["Backspace"] = "Backspace";
    return KeyboardKeys;
}({});
var $2c4fbc100f789f14$export$1c4f2adc1f8e19d3 = /*#__PURE__*/ function(KeyboardNavigationDirection) {
    KeyboardNavigationDirection["Down"] = "Down";
    KeyboardNavigationDirection["Up"] = "Up";
    KeyboardNavigationDirection["Left"] = "Left";
    KeyboardNavigationDirection["Right"] = "Right";
    return KeyboardNavigationDirection;
}({});
const $2c4fbc100f789f14$export$99130b698ea188ae = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End"
];
const $2c4fbc100f789f14$export$84b035f8d01101cc = [
    "Enter",
    "Backspace",
    " "
];
const $2c4fbc100f789f14$export$e27d4e477c0cd4ec = [
    "Enter",
    "Tab",
    " "
];
const $2c4fbc100f789f14$export$97027974dc06eeee = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End",
    "ArrowUp",
    "ArrowDown",
    "PageUp",
    "PageDown"
];
const $2c4fbc100f789f14$export$4f0ee90b28d6efc5 = 0;
const $2c4fbc100f789f14$export$9f7de4293d27f3aa = 50;
const $2c4fbc100f789f14$export$41388d9a435030e6 = 'hipchat_migration_emoticons';
const $2c4fbc100f789f14$export$273d18db3ba5f6b1 = 'atlassian.fabric.emoji.picker';
const $2c4fbc100f789f14$export$2829f3ec323f8ec0 = 8;
const $2c4fbc100f789f14$export$ce3a0e7d2d7d6ba2 = 5;
const $2c4fbc100f789f14$export$858e8dc100a97278 = 150;
const $2c4fbc100f789f14$export$83aab2ae64548423 = 20;
const $2c4fbc100f789f14$export$66cabad5e268b05e = 100;

});

parcelRegister("dXRfX", function(module, exports) {
$parcel$export(module.exports, "EmojiSharedCssClassName", () => $ba76b0d4382ed38f$export$ee47248f9a998789);

const $ba76b0d4382ed38f$export$ee47248f9a998789 = {
    EMOJI_CONTAINER: 'emojiView-content-wrap',
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_NODE: (0, $eb4c5e773f9bbee2$export$b06c4aab1d012063),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_SPRITE: (0, $eb4c5e773f9bbee2$export$1c10634420a08d8a),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_IMAGE: (0, $eb4c5e773f9bbee2$export$da61cef1c8919f7c),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_PLACEHOLDER: (0, $eb4c5e773f9bbee2$export$c7187bbd1a7a9244)
};

});
const $eb4c5e773f9bbee2$export$8633a0edef8e95dd = 'emoji-common-selected';
const $eb4c5e773f9bbee2$export$860109dfd198259b = 'emoji-common-select-on-hover';
const $eb4c5e773f9bbee2$export$1c10634420a08d8a = 'emoji-common-emoji-sprite';
const $eb4c5e773f9bbee2$export$b06c4aab1d012063 = 'emoji-common-node';
const $eb4c5e773f9bbee2$export$da61cef1c8919f7c = 'emoji-common-emoji-image';
const $eb4c5e773f9bbee2$export$b11fa39b56a371f6 = 'emoji-common-deleteButton';
const $eb4c5e773f9bbee2$export$11462c0756c24ab6 = 'emoji-common-main-styles';
const $eb4c5e773f9bbee2$export$22b19c311e9caa4 = 'emoji-common-deletable';
const $eb4c5e773f9bbee2$export$c7187bbd1a7a9244 = 'emoji-common-placeholder';
const $eb4c5e773f9bbee2$export$b0fe756d87022806 = 'emoji-picker-add-emoji';



parcelRegister("goISJ", function(module, exports) {
$parcel$export(module.exports, "removeEmptySpaceAroundContent", () => $e351d9165cd2c4b0$export$c94cfc0c675062a1);
const $e351d9165cd2c4b0$export$c94cfc0c675062a1 = (document)=>{
    // Check if the document is valid
    if (!document || !document.content || !Array.isArray(document.content)) return document;
    // Check if the node is a meaningful content node meaning it is not an empty paragraph or a paragraph with only whitespace
    const isMeaningfulContentNode = (node)=>{
        // Check if the node is a non-empty paragraph or a non-paragraph node
        if (node.type !== 'paragraph') return true;
        // If the paragraph is empty, return false
        if (!node.content || node.content.length === 0) return false;
        // Check if paragraph has any content other than `hardBreak` or whitespace text nodes
        return node.content.some((child)=>{
            return !(child?.type === 'hardBreak' || child?.type === 'text' && typeof child.text === 'string' && child.text.trim() === '');
        });
    };
    const content = document.content;
    let firstContentIndex = -1;
    let lastContentIndex = -1;
    // Find the first and last paragraphs with content and check if they are meaningful
    for(let i = 0; i < content.length; i++)if (isMeaningfulContentNode(content[i])) {
        if (firstContentIndex === -1) firstContentIndex = i;
        lastContentIndex = i;
    }
    // If no content was found, return an empty document
    if (firstContentIndex === -1) return {
        ...document,
        content: []
    };
    // Slice the content array to include only paragraphs between the first and last content
    const trimmedContent = content.slice(firstContentIndex, lastContentIndex + 1);
    // Return a new document with the trimmed content
    return {
        ...document,
        content: trimmedContent
    };
};

});

parcelRegister("8AF0U", function(module, exports) {
$parcel$export(module.exports, "useMemoFromPropsDerivative", () => $da708a0839cc6084$export$80ffe7e3c6bf25c3);

var $eJOHy = parcelRequire("eJOHy");
function $da708a0839cc6084$export$80ffe7e3c6bf25c3(factory, propsDerivator, props) {
    // cache the last set of props
    const prev = (0, $eJOHy.useRef)(props);
    const prevFactory = (0, $eJOHy.useRef)(null);
    return (0, $eJOHy.useMemo)(()=>{
        // check if the serializer is already created
        let shouldCreate = !prevFactory.current;
        // check each prop to see if value has changed and also check if the number of props has changed
        if (prev.current !== props) {
            const propsEntries = Object.entries(props);
            shouldCreate = propsEntries.length !== Object.keys(prev.current).length || propsEntries.some(([key, prop])=>prev.current[key] !== prop);
        }
        prev.current = props;
        // If first time or any prop value has changed, create a new serializer
        if (shouldCreate) prevFactory.current = factory(propsDerivator(props));
        return prevFactory.current;
    }, // To keep deps consistent, here disable the exhaustive-deps rule to drop factory from the deps array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        propsDerivator,
        props
    ]);
}

});

parcelRegister("jWNZR", function(module, exports) {
$parcel$export(module.exports, "PortalContext", () => $8e263fa42711dda5$export$60d741e20e0aa309);
$parcel$export(module.exports, "usePortal", () => $8e263fa42711dda5$export$b1072f43c67b540c);

var $eJOHy = parcelRequire("eJOHy");
const $8e263fa42711dda5$export$60d741e20e0aa309 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(undefined);
function $8e263fa42711dda5$export$b1072f43c67b540c(props) {
    const portalFromContext = (0, $eJOHy.useContext)($8e263fa42711dda5$export$60d741e20e0aa309);
    return props?.portal || portalFromContext;
}

});

parcelRegister("53NHC", function(module, exports) {
$parcel$export(module.exports, "getWidthInfoPayload", () => $5a26e086cef62068$export$208d2421b73f3f86);

var $bMFKb = parcelRequire("bMFKb");
var $8MfCL = parcelRequire("8MfCL");
var $ey7La = parcelRequire("ey7La");

var $dyNYh = parcelRequire("dyNYh");
const $5a26e086cef62068$export$208d2421b73f3f86 = (renderer)=>{
    const tablesInfo = [];
    const tableWrappers = renderer.querySelectorAll('.pm-table-wrapper');
    // only send the event if there are tables on the page
    if (tableWrappers.length === 0) return undefined;
    tableWrappers.forEach((tableWrapper)=>{
        const table = tableWrapper.querySelector(':scope > table');
        if (table) {
            const isNestedTable = Boolean(table.closest('td, th'));
            tablesInfo.push({
                tableWidth: table.scrollWidth,
                hasScrollbar: tableWrapper.clientWidth < table.scrollWidth,
                isNestedTable: isNestedTable
            });
        }
    });
    const maxTableWidth = Math.max(...tablesInfo.map((table)=>table.tableWidth));
    const editorWidth = renderer.scrollWidth;
    return {
        action: (0, $ey7La.TABLE_ACTION).TABLE_WIDTH_INFO,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).TABLE,
        attributes: {
            editorWidth: editorWidth,
            editorWidthBreakpoint: (0, $dyNYh.getBreakpointKey)(editorWidth),
            tableWidthInfo: tablesInfo,
            maxTableWidthBreakpoint: (0, $dyNYh.getBreakpointKey)(maxTableWidth),
            hasTableWiderThanEditor: maxTableWidth > editorWidth,
            hasTableWithScrollbar: tablesInfo.some((table)=>table.hasScrollbar),
            mode: (0, $8MfCL.MODE).RENDERER
        },
        eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
    };
};

});
parcelRegister("8MfCL", function(module, exports) {
$parcel$export(module.exports, "PLATFORMS", () => $d58277a1cd1a5d50$export$a8d23193462f2b63);
$parcel$export(module.exports, "MODE", () => $d58277a1cd1a5d50$export$e48589d9e4824227);
$parcel$export(module.exports, "FULL_WIDTH_MODE", () => $d58277a1cd1a5d50$export$57453495b81e2dde);
$parcel$export(module.exports, "BROWSER_FREEZE_INTERACTION_TYPE", () => $d58277a1cd1a5d50$export$60a219cfaef9722);
var $d58277a1cd1a5d50$export$a8d23193462f2b63 = /*#__PURE__*/ function(PLATFORMS) {
    PLATFORMS["NATIVE"] = "mobileNative";
    PLATFORMS["HYBRID"] = "mobileHybrid";
    PLATFORMS["WEB"] = "web";
    return PLATFORMS;
}({});
var $d58277a1cd1a5d50$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
var $d58277a1cd1a5d50$export$57453495b81e2dde = /*#__PURE__*/ function(FULL_WIDTH_MODE) {
    FULL_WIDTH_MODE["FIXED_WIDTH"] = "fixedWidth";
    FULL_WIDTH_MODE["FULL_WIDTH"] = "fullWidth";
    return FULL_WIDTH_MODE;
}({});
var $d58277a1cd1a5d50$export$60a219cfaef9722 = /*#__PURE__*/ function(BROWSER_FREEZE_INTERACTION_TYPE) {
    BROWSER_FREEZE_INTERACTION_TYPE["LOADING"] = "loading";
    BROWSER_FREEZE_INTERACTION_TYPE["TYPING"] = "typing";
    BROWSER_FREEZE_INTERACTION_TYPE["CLICKING"] = "clicking";
    BROWSER_FREEZE_INTERACTION_TYPE["PASTING"] = "pasting";
    return BROWSER_FREEZE_INTERACTION_TYPE;
}({});

});

parcelRegister("ey7La", function(module, exports) {
$parcel$export(module.exports, "TABLE_ACTION", () => $1d46e73d9b1920d5$export$1627223e090990cf);
$parcel$export(module.exports, "TABLE_OVERFLOW_CHANGE_TRIGGER", () => $1d46e73d9b1920d5$export$e0b2ad636c1c8ab4);
$parcel$export(module.exports, "TABLE_STATUS", () => $1d46e73d9b1920d5$export$90dde066fa32cf2f);
$parcel$export(module.exports, "TABLE_DISPLAY_MODE", () => $1d46e73d9b1920d5$export$a62a68f32aa71693);
$parcel$export(module.exports, "CHANGE_ALIGNMENT_REASON", () => $1d46e73d9b1920d5$export$ba2dfc055a59d951);
var $1d46e73d9b1920d5$export$1627223e090990cf = /*#__PURE__*/ function(TABLE_ACTION) {
    TABLE_ACTION["DELETED"] = "deleted";
    TABLE_ACTION["CLEARED"] = "cleared";
    TABLE_ACTION["COLLAPSED"] = "collapsed";
    TABLE_ACTION["MERGED"] = "merged";
    TABLE_ACTION["SPLIT"] = "split";
    TABLE_ACTION["COLORED"] = "colored";
    TABLE_ACTION["TOGGLED_HEADER_COLUMN"] = "toggledHeaderColumn";
    TABLE_ACTION["TOGGLED_HEADER_ROW"] = "toggledHeaderRow";
    TABLE_ACTION["TOGGLED_NUMBER_COLUMN"] = "toggledNumberColumn";
    TABLE_ACTION["CHANGED_BREAKOUT_MODE"] = "changedBreakoutMode";
    TABLE_ACTION["CUT"] = "cut";
    TABLE_ACTION["COPIED"] = "copied";
    TABLE_ACTION["ADDED_ROW"] = "addedRow";
    TABLE_ACTION["ADDED_COLUMN"] = "addedColumn";
    TABLE_ACTION["DELETED_ROW"] = "deletedRow";
    TABLE_ACTION["DELETED_COLUMN"] = "deletedColumn";
    TABLE_ACTION["SORTED_COLUMN"] = "sortedColumn";
    TABLE_ACTION["REPLACED"] = "replaced";
    TABLE_ACTION["ATTEMPTED_TABLE_WIDTH_CHANGE"] = "attemptedTableWidthChange";
    TABLE_ACTION["DISTRIBUTED_COLUMNS_WIDTHS"] = "distributedColumnsWidths";
    TABLE_ACTION["FIXED"] = "fixed";
    TABLE_ACTION["RESIZED"] = "resized";
    TABLE_ACTION["RESIZE_PERF_SAMPLING"] = "resizePerfSampling";
    TABLE_ACTION["COLUMN_RESIZED"] = "columnResized";
    TABLE_ACTION["OVERFLOW_CHANGED"] = "overflowChanged";
    TABLE_ACTION["INITIAL_OVERFLOW_CAPTURED"] = "initialOverflowCaptured";
    TABLE_ACTION["MOVED_ROW"] = "movedRow";
    TABLE_ACTION["MOVED_COLUMN"] = "movedColumn";
    TABLE_ACTION["CLONED_ROW"] = "clonedRow";
    TABLE_ACTION["CLONED_COLUMN"] = "clonedColumn";
    /**
	 * This is a unique action that's used to track legacy table move behaviour flow of insert+copy+paste. Please use
	 * the MOVED_ROW | MOVED_COLUMN actions if you want to track events which move row/cols in a single step.
	 */ TABLE_ACTION["ROW_OR_COLUMN_MOVED"] = "rowOrColumnMoved";
    TABLE_ACTION["CHANGED_DISPLAY_MODE"] = "changedDisplayMode";
    TABLE_ACTION["CHANGED_ALIGNMENT"] = "changedAlignment";
    // Temporary to track usage of CONFCLOUD-78239 bug
    TABLE_ACTION["TABLE_CELL_BACKGROUND_FIXED"] = "tableCellBackgroundFixed";
    TABLE_ACTION["TABLE_WIDTH_INFO"] = "tableWidthInformation";
    return TABLE_ACTION;
}({});
var $1d46e73d9b1920d5$export$6b0804bad09b61c6 = /*#__PURE__*/ function(TABLE_BREAKOUT) {
    TABLE_BREAKOUT["WIDE"] = "wide";
    TABLE_BREAKOUT["FULL_WIDTH"] = "fullWidth";
    TABLE_BREAKOUT["NORMAL"] = "normal";
    return TABLE_BREAKOUT;
}({});
var $1d46e73d9b1920d5$export$e0b2ad636c1c8ab4 = /*#__PURE__*/ function(TABLE_OVERFLOW_CHANGE_TRIGGER) {
    TABLE_OVERFLOW_CHANGE_TRIGGER["EXTERNAL"] = "external";
    TABLE_OVERFLOW_CHANGE_TRIGGER["ADDED_COLUMN"] = "addedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DELETED_COLUMN"] = "deletedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["RESIZED_COLUMN"] = "resizedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["ENABLED_NUMBERED_COLUMN"] = "enabledNumberedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DISABLED_NUMBERED_COLUMN"] = "disabledNumberedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DISTRIBUTED_COLUMNS"] = "distributedColumnsWidths";
    TABLE_OVERFLOW_CHANGE_TRIGGER["RESIZED"] = "resizedTable";
    return TABLE_OVERFLOW_CHANGE_TRIGGER;
}({});
var $1d46e73d9b1920d5$export$90dde066fa32cf2f = /*#__PURE__*/ function(TABLE_STATUS) {
    TABLE_STATUS["SUCCESS"] = "success";
    TABLE_STATUS["CANCELLED"] = "cancelled";
    TABLE_STATUS["INVALID"] = "invalid";
    return TABLE_STATUS;
}({});
var $1d46e73d9b1920d5$export$a62a68f32aa71693 = /*#__PURE__*/ function(TABLE_DISPLAY_MODE) {
    TABLE_DISPLAY_MODE["FIXED"] = "fixed";
    TABLE_DISPLAY_MODE["DEFAULT"] = "default";
    TABLE_DISPLAY_MODE["INITIAL"] = "initial";
    return TABLE_DISPLAY_MODE;
}({});
var $1d46e73d9b1920d5$export$ba2dfc055a59d951 = /*#__PURE__*/ function(CHANGE_ALIGNMENT_REASON) {
    CHANGE_ALIGNMENT_REASON["TABLE_RESIZING"] = "tableResizing";
    CHANGE_ALIGNMENT_REASON["TABLE_COLUMN_RESIZED"] = "tableColumnResized";
    CHANGE_ALIGNMENT_REASON["EDITOR_APPEARANCE_CHANGED"] = "editorAppearanceChanged";
    CHANGE_ALIGNMENT_REASON["TOOLBAR_OPTION_CHANGED"] = "toolbarOptionChanged";
    return CHANGE_ALIGNMENT_REASON;
}({});

});



parcelRegister("3cc2J", function(module, exports) {
$parcel$export(module.exports, "useMediaClient", () => $d8e7b96ea4671e74$export$8b3e87ea56c3a345);

var $eJOHy = parcelRequire("eJOHy");

var $93R6D = parcelRequire("93R6D");

var $f7iZ0 = parcelRequire("f7iZ0");
const $d8e7b96ea4671e74$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $93R6D.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $f7iZ0.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};

});
parcelRegister("f7iZ0", function(module, exports) {
$parcel$export(module.exports, "MediaContext", () => $b977b15c2bc7301b$export$c94ff18a59d4c4d);
$parcel$export(module.exports, "MediaProvider", () => $b977b15c2bc7301b$export$57164260bc1f1218);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aRuva = parcelRequire("aRuva");

var $lMkQs = parcelRequire("lMkQs");
const $b977b15c2bc7301b$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(undefined);
const $b977b15c2bc7301b$export$57164260bc1f1218 = ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $eJOHy.useMemo)(()=>(0, $aRuva.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $lMkQs.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($b977b15c2bc7301b$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        },
        children: children
    });
};

});
parcelRegister("lMkQs", function(module, exports) {
$parcel$export(module.exports, "useMediaParsedSettings", () => $e0ef7db6f81da61d$export$d54af28440a5efc0);

var $eJOHy = parcelRequire("eJOHy");

var $4iDQM = parcelRequire("4iDQM");
const $e0ef7db6f81da61d$export$d54af28440a5efc0 = (mediaSettings = {})=>{
    const settings = (0, $eJOHy.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $4iDQM.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};

});
parcelRegister("4iDQM", function(module, exports) {
$parcel$export(module.exports, "defaultMediaUserPreferences", () => $fd3af50559080092$export$2d23ed2854ac1650);
// Currently only supports boolean, string. Uncomment below to support number
const $fd3af50559080092$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $fd3af50559080092$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($fd3af50559080092$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $fd3af50559080092$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $fd3af50559080092$export$2d23ed2854ac1650 = $fd3af50559080092$export$7e209e67b965bc63($fd3af50559080092$var$defaultUserPreferences);

});




parcelRegister("aWpPf", function(module, exports) {
$parcel$export(module.exports, "sanitizeUrl", () => $6d5c026f49702d9c$export$300bd6d67c49dbfc);
// taken from https://hello.atlassian.net/wiki/spaces/PRODSEC/pages/158006558/URI+scheme+Allow+listing
const $6d5c026f49702d9c$export$4da13fcc37d580b4 = [
    'javascript:',
    'data:',
    'vbscript:',
    'view-source:',
    'resource:',
    'about:',
    'chrome:',
    'livescript:',
    'mocha:',
    'file:',
    'mhtml:',
    'smb:'
];
const $6d5c026f49702d9c$export$300bd6d67c49dbfc = (urlString)=>{
    const url = new URL(urlString || '', window.location.href);
    return $6d5c026f49702d9c$export$4da13fcc37d580b4.includes(url.protocol) ? 'about:blank' : url.toString();
};

});


parcelRegister("gHU71", function(module, exports) {
$parcel$export(module.exports, "Badge", () => $c3842b929f9f9dd8$export$37acb3580601e69a);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $7q9BG = parcelRequire("7q9BG");
// Convert child to number if possible
// Badge `max` prop will only work if the child is a number
const $c3842b929f9f9dd8$var$getBadgeChildren = (forgeDoc)=>{
    const child = forgeDoc.children?.[0]?.props?.text;
    if (child && !isNaN(Number(child))) return Number(child);
    return child;
};
const $c3842b929f9f9dd8$export$bf0162d825d6e13 = {
    appearance: true,
    /**
	 * The value displayed within the badge. A badge should only be used in cases where you want to represent a number. Use a lozenge for non-numeric information.
	 *
	 * @type string | number
	 */ children: {
        value: 'getBadgeChildren(props.forgeDoc)'
    },
    max: true,
    testId: true
};
const $c3842b929f9f9dd8$export$37acb3580601e69a = (props)=>{
    const { appearance: appearance, max: max, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7q9BG.default), {
        appearance: appearance,
        children: $c3842b929f9f9dd8$var$getBadgeChildren(props.forgeDoc),
        max: max,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("eM6RF", function(module, exports) {
$parcel$export(module.exports, "Box", () => $4d800c25e3b74ed0$export$e71c4d32a2263218);
// The below lint rules are disabled because Box relies on building styles at runtime from in Forge apps
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766 */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766 */ 
var $gt9Am = parcelRequire("gt9Am");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $2kA5E = parcelRequire("2kA5E");

var $eJOHy = parcelRequire("eJOHy");
const $4d800c25e3b74ed0$export$bf0162d825d6e13 = {
    as: false,
    padding: true,
    paddingBlock: true,
    paddingBlockStart: true,
    paddingBlockEnd: true,
    paddingInline: true,
    paddingInlineStart: true,
    paddingInlineEnd: true,
    backgroundColor: true,
    children: true,
    ref: true,
    testId: true,
    'data-testid': false,
    xcss: {
        value: 'xcss && platformXCSS(xcssValidator(xcss) as PlatformXCSSParam)'
    },
    role: true,
    style: false
};
const $4d800c25e3b74ed0$export$e71c4d32a2263218 = (props)=>{
    const { padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, backgroundColor: backgroundColor, ref: ref, testId: testId, xcss: xcss, role: role } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        padding: padding,
        paddingBlock: paddingBlock,
        paddingBlockStart: paddingBlockStart,
        paddingBlockEnd: paddingBlockEnd,
        paddingInline: paddingInline,
        paddingInlineStart: paddingInlineStart,
        paddingInlineEnd: paddingInlineEnd,
        backgroundColor: backgroundColor,
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                children: props.render(c)
            }, c.key)),
        ref: ref,
        testId: testId,
        xcss: xcss && (0, $1DXK0.xcss)((0, $2kA5E.xcssValidator)(xcss)),
        role: role
    });
}; /**
 * @codegenEnd
 */ 

});
parcelRegister("2kA5E", function(module, exports) {
$parcel$export(module.exports, "xcssValidator", () => $8868265cd2b4bcf8$export$aa422b2708209a80);

var $1mRKQ = parcelRequire("1mRKQ");
const $8868265cd2b4bcf8$export$aa422b2708209a80 = (0, $1mRKQ.makeXCSSValidator)({
    // color related props
    color: true,
    boxShadow: true,
    opacity: true,
    backgroundColor: true,
    borderColor: true,
    borderBlockColor: true,
    borderBlockEndColor: true,
    borderBlockStartColor: true,
    borderBottomColor: true,
    borderInlineColor: true,
    borderInlineEndColor: true,
    borderInlineStartColor: true,
    borderLeftColor: true,
    borderRightColor: true,
    borderTopColor: true,
    overflow: {
        supportedValues: [
            'hidden',
            'visible',
            'scroll',
            'auto'
        ]
    },
    overflowX: {
        supportedValues: [
            'hidden',
            'visible',
            'scroll',
            'auto'
        ]
    },
    overflowY: {
        supportedValues: [
            'hidden',
            'visible',
            'scroll',
            'auto'
        ]
    },
    // layout and space related props
    display: {
        supportedValues: [
            'block',
            'inline-block',
            'inline',
            'none'
        ]
    },
    flexGrow: {
        allowCSS: true
    },
    width: {
        allowCSS: true
    },
    height: {
        allowCSS: true
    },
    minWidth: {
        allowCSS: true
    },
    maxWidth: {
        allowCSS: true
    },
    minHeight: {
        allowCSS: true
    },
    maxHeight: {
        allowCSS: true
    },
    margin: true,
    marginBlock: true,
    marginBlockEnd: true,
    marginBlockStart: true,
    marginBottom: true,
    marginInline: true,
    marginInlineEnd: true,
    marginInlineStart: true,
    marginLeft: true,
    marginRight: true,
    marginTop: true,
    padding: true,
    paddingBlock: true,
    paddingBlockEnd: true,
    paddingBlockStart: true,
    paddingBottom: true,
    paddingInline: true,
    paddingInlineEnd: true,
    paddingInlineStart: true,
    paddingLeft: true,
    paddingRight: true,
    paddingTop: true,
    // other box related props
    borderRadius: {
        supportedValues: [
            'border.radius'
        ]
    },
    borderBottomLeftRadius: {
        supportedValues: [
            'border.radius'
        ]
    },
    borderBottomRightRadius: {
        supportedValues: [
            'border.radius'
        ]
    },
    borderTopLeftRadius: {
        supportedValues: [
            'border.radius'
        ]
    },
    borderTopRightRadius: {
        supportedValues: [
            'border.radius'
        ]
    },
    borderEndEndRadius: {
        supportedValues: [
            'border.radius'
        ]
    },
    borderEndStartRadius: {
        supportedValues: [
            'border.radius'
        ]
    },
    borderStartEndRadius: {
        supportedValues: [
            'border.radius'
        ]
    },
    borderStartStartRadius: {
        supportedValues: [
            'border.radius'
        ]
    },
    borderWidth: {
        supportedValues: [
            'border.width'
        ]
    },
    borderBlockWidth: {
        supportedValues: [
            'border.width'
        ]
    },
    borderBlockEndWidth: {
        supportedValues: [
            'border.width'
        ]
    },
    borderBlockStartWidth: {
        supportedValues: [
            'border.width'
        ]
    },
    borderBottomWidth: {
        supportedValues: [
            'border.width'
        ]
    },
    borderInlineWidth: {
        supportedValues: [
            'border.width'
        ]
    },
    borderInlineEndWidth: {
        supportedValues: [
            'border.width'
        ]
    },
    borderInlineStartWidth: {
        supportedValues: [
            'border.width'
        ]
    },
    borderLeftWidth: {
        supportedValues: [
            'border.width'
        ]
    },
    borderRightWidth: {
        supportedValues: [
            'border.width'
        ]
    },
    borderTopWidth: {
        supportedValues: [
            'border.width'
        ]
    },
    // other props not in tokens based props
    borderTopStyle: {
        supportedValues: [
            'dotted',
            'dashed',
            'solid',
            'none',
            'hidden'
        ]
    },
    borderBottomStyle: {
        supportedValues: [
            'dotted',
            'dashed',
            'solid',
            'none',
            'hidden'
        ]
    },
    borderRightStyle: {
        supportedValues: [
            'dotted',
            'dashed',
            'solid',
            'none',
            'hidden'
        ]
    },
    borderLeftStyle: {
        supportedValues: [
            'dotted',
            'dashed',
            'solid',
            'none',
            'hidden'
        ]
    },
    borderStyle: {
        supportedValues: [
            'dotted',
            'dashed',
            'solid',
            'none',
            'hidden'
        ]
    },
    position: {
        supportedValues: [
            'relative',
            'static'
        ]
    }
});

});
parcelRegister("1mRKQ", function(module, exports) {
$parcel$export(module.exports, "makeXCSSValidator", () => $e833ec8fc6b8d311$export$4b24853998c191ec);

var $1DXK0 = parcelRequire("1DXK0");
const $e833ec8fc6b8d311$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
const $e833ec8fc6b8d311$var$REX_CSS_SIMPLE_STRING_PROP_VALUE = /^[a-zA-Z-]+$/;
const $e833ec8fc6b8d311$var$REX_CSS_WIDTH_PROP_VALUE = /^-?\d+(\.\d+)?(px|em|rem|%)?$/;
/**
 * Maintain a map of old -> new tokens to allow the Design System team to deprecate tokens without impacting Forge APIs
 * Key: old token (i.e. the value used in forge xcss)
 * Value: new token (i.e. the value that should be applied under the hood)
 *
 * This will transform any 'border.radius' value provided via forge xcss into the 'radius.small' token which is supported by platform xcss.
 */ const $e833ec8fc6b8d311$var$tokenReplacementMap = {
    'border.radius': 'radius.small'
};
// Note: we currently support only free formed size related props (e.g. width).
//       the validation logic should be extended to support other props in the future.
const $e833ec8fc6b8d311$var$defaultPropValidator = (rawValue)=>{
    const value = `${rawValue ?? ''}`.trim();
    return $e833ec8fc6b8d311$var$REX_CSS_SIMPLE_STRING_PROP_VALUE.test(value) || $e833ec8fc6b8d311$var$REX_CSS_WIDTH_PROP_VALUE.test(value);
};
const $e833ec8fc6b8d311$var$xcssValidateAndCleanup = (styleObj, supportedXCSSPropsSpec, isRoot = true)=>{
    return Object.entries(styleObj).reduce((targetStyleObj, [key, value])=>{
        if (typeof value === 'object' && $e833ec8fc6b8d311$var$safeSelectors.test(key) && isRoot) {
            // handle the case where the value is a media query or pseudo selector
            const cleanedValue = $e833ec8fc6b8d311$var$xcssValidateAndCleanup(value, supportedXCSSPropsSpec, false);
            if (cleanedValue && Object.keys(cleanedValue).length > 0) targetStyleObj[key] = cleanedValue;
        } else if (value) {
            if (supportedXCSSPropsSpec[key]?.(value)) {
                // handle the case where the value is a design token value of a token prop
                // or a string value of a standard css prop that passes the validator function
                // if defined.
                // Check if the token should be replaced by a different token or value
                if ($e833ec8fc6b8d311$var$tokenReplacementMap[value]) targetStyleObj[key] = $e833ec8fc6b8d311$var$tokenReplacementMap[value];
                else targetStyleObj[key] = value;
            } else // eslint-disable-next-line no-console
            console.warn(`Unexpected XCSS property provided: ${key}: ${value}`);
        } else // in case the prop is not supported.
        // eslint-disable-next-line no-console
        console.warn(`Unsupported XCSS property provided: ${key}: ${value}`);
        return targetStyleObj;
    }, {});
};
const $e833ec8fc6b8d311$var$isSupportedValuesConfig = (config)=>{
    return config !== true && 'supportedValues' in config && Array.isArray(config.supportedValues);
};
/**
 *
 * @param supportedXCSSProps - the list of css props to be supported for the intended component.
 *    If not provided, all the props will be supported. The props could be either standard css props
 *    or design token based props. If the prop is a design token based prop, the value of the prop
 *    will be validated against the design tokens map to ensure the value is a valid design token string.
 * @returns a function that takes a style object and returns a style object with only the supported props
 *    as specified in the supportedXCSSProps list. The props that are not supported will be removed from the
 *    returned style object and a warning will be logged in the console.
 */ const $e833ec8fc6b8d311$export$4b24853998c191ec = (supportedXCSSProps)=>{
    const supportedXCSSPropsSpec = Object.entries(supportedXCSSProps).reduce((acc, [prop, config])=>{
        let validator;
        if (config === true) {
            const tokensMapStyle = (0, $1DXK0.tokensMap)[prop];
            if (tokensMapStyle) {
                const tokenSet = new Set(Object.keys(tokensMapStyle));
                validator = (value)=>tokenSet.has(value);
            } else throw new Error('invalid validation config applied to token only props');
        } else if ($e833ec8fc6b8d311$var$isSupportedValuesConfig(config)) {
            const supportedValues = new Set(config.supportedValues);
            validator = (value)=>supportedValues.has(value);
        } else if (config?.allowCSS === true) validator = $e833ec8fc6b8d311$var$defaultPropValidator;
        if (validator) acc[prop] = validator;
        return acc;
    }, {});
    return (styleObj)=>$e833ec8fc6b8d311$var$xcssValidateAndCleanup(styleObj, supportedXCSSPropsSpec);
};

});



parcelRegister("554by", function(module, exports) {
$parcel$export(module.exports, "Button", () => $0e3c9a2792a0494c$export$353f5b6fc5456de1);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8AppO = parcelRequire("8AppO");
var $cK1L3 = parcelRequire("cK1L3");

var $iRtff = parcelRequire("iRtff");

var $5CSKW = parcelRequire("5CSKW");

var $eGOwo = parcelRequire("eGOwo");
const $0e3c9a2792a0494c$var$createIconComponent = (icon)=>{
    const Component = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $iRtff.IconComponent), {
            glyph: icon,
            label: icon
        });
    return Component;
};
/**
 * Mapping the deprecated 'none' spacing to 'compact'
 */ const $0e3c9a2792a0494c$var$mapDeprecatedSpacing = (spacing)=>spacing === 'none' ? 'compact' : spacing;
const $0e3c9a2792a0494c$var$OldButton = (props)=>{
    const { autoFocus: autoFocus, isDisabled: isDisabled, isSelected: isSelected, onBlur: onBlur, onClick: onClick, onFocus: onFocus, spacing: spacing, testId: testId, shouldFitContainer: shouldFitContainer, appearance: appearance, type: type, iconAfter: iconAfter, iconBefore: iconBefore } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                children: props.render(c)
            }, c.key)),
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onBlur: (0, $8AppO.adaptEventHandler)(onBlur),
        onClick: (0, $8AppO.adaptEventHandler)(onClick),
        onFocus: (0, $8AppO.adaptEventHandler)(onFocus),
        spacing: $0e3c9a2792a0494c$var$mapDeprecatedSpacing(spacing),
        testId: testId,
        shouldFitContainer: shouldFitContainer,
        appearance: appearance,
        type: type,
        iconAfter: iconAfter && $0e3c9a2792a0494c$var$createIconComponent(iconAfter),
        iconBefore: iconBefore && $0e3c9a2792a0494c$var$createIconComponent(iconBefore)
    });
};
const $0e3c9a2792a0494c$var$ButtonWithAnalytics = (props)=>{
    const { autoFocus: autoFocus, isDisabled: isDisabled, isSelected: isSelected, onBlur: onBlur, onClick: onClick, onFocus: onFocus, spacing: spacing, testId: testId, shouldFitContainer: shouldFitContainer, appearance: appearance, type: type, iconAfter: iconAfter, iconBefore: iconBefore } = props.forgeDoc.props;
    const adaptEventHandler = (0, $cK1L3.useAdaptEventHandler)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                children: props.render(c)
            }, c.key)),
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onBlur: adaptEventHandler(onBlur),
        onClick: adaptEventHandler(onClick),
        onFocus: adaptEventHandler(onFocus),
        spacing: $0e3c9a2792a0494c$var$mapDeprecatedSpacing(spacing),
        testId: testId,
        shouldFitContainer: shouldFitContainer,
        appearance: appearance,
        type: type,
        iconAfter: iconAfter && $0e3c9a2792a0494c$var$createIconComponent(iconAfter),
        iconBefore: iconBefore && $0e3c9a2792a0494c$var$createIconComponent(iconBefore)
    });
};
const $0e3c9a2792a0494c$export$353f5b6fc5456de1 = (props)=>{
    if ((0, $eGOwo.fg)('forge-ui-ui-kit-click-events')) return /*#__PURE__*/ (0, $gt9Am.jsx)($0e3c9a2792a0494c$var$ButtonWithAnalytics, {
        ...props
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)($0e3c9a2792a0494c$var$OldButton, {
        ...props
    });
};

});
parcelRegister("8AppO", function(module, exports) {
$parcel$export(module.exports, "adaptEventHandler", () => $ce164aca4af3a459$export$f956703109d01f6a);
/** The SyntheticEvent object is not serialisable and cannot be passed to the runtime/backend as is.
 * This function filters out all non serialisable arguments and maintains important properties of the event object.
 */ const $ce164aca4af3a459$var$getSerialisableEventObject = (syntheticEvent)=>{
    /** syntheticEvent.persist() is called to remove the synthetic event from React's event pool.
	 * Without this call, the properties of the event would be nullified after the event callback has been invoked,
	 * due to React's event pooling.
	 * By calling persist(), we ensure that the event properties remain available for the serialization process.
	 */ syntheticEvent?.persist?.();
    const target = syntheticEvent.target;
    const serialisableEvent = {
        bubbles: syntheticEvent.bubbles,
        cancelable: syntheticEvent.cancelable,
        defaultPrevented: syntheticEvent.defaultPrevented,
        eventPhase: syntheticEvent.eventPhase,
        isTrusted: syntheticEvent.isTrusted,
        target: {
            selectionStart: target?.selectionStart,
            selectionEnd: target?.selectionEnd,
            value: target?.value,
            checked: target?.checked,
            name: target?.name,
            id: target?.id,
            tagName: target?.tagName,
            type: target?.type
        },
        timeStamp: syntheticEvent.timeStamp,
        type: syntheticEvent.type
    };
    return serialisableEvent;
};
/**
 * Default handler args transformer that extract react synthetic event from
 * the handler args and creates a serialisable object so that it can be passed into the runtime.
 */ const $ce164aca4af3a459$var$nativeEventHandlerArgsTransformer = (...args)=>{
    const [event, ...rest] = args;
    return [
        $ce164aca4af3a459$var$getSerialisableEventObject(event),
        ...rest
    ];
};
const $ce164aca4af3a459$export$f956703109d01f6a = (sourceEventHandler)=>{
    if (!sourceEventHandler) return sourceEventHandler;
    return (...args)=>{
        sourceEventHandler(...$ce164aca4af3a459$var$nativeEventHandlerArgsTransformer(...args));
    };
};

});

parcelRegister("cK1L3", function(module, exports) {
$parcel$export(module.exports, "useAdaptEventHandler", () => $77fb0e0dd4421e81$export$5ce8c276f684a042);

var $eJOHy = parcelRequire("eJOHy");

var $cOZrT = parcelRequire("cOZrT");

var $grXB3 = parcelRequire("grXB3");

var $kpjEk = parcelRequire("kpjEk");

var $6QUJr = parcelRequire("6QUJr");

var $5EMLi = parcelRequire("5EMLi");
/** The SyntheticEvent object is not serialisable and cannot be passed to the runtime/backend as is.
 * This function filters out all non serialisable arguments and maintains important properties of the event object.
 */ const $77fb0e0dd4421e81$var$getSerialisableEventObject = (syntheticEvent)=>{
    /** syntheticEvent.persist() is called to remove the synthetic event from React's event pool.
	 * Without this call, the properties of the event would be nullified after the event callback has been invoked,
	 * due to React's event pooling.
	 * By calling persist(), we ensure that the event properties remain available for the serialization process.
	 */ syntheticEvent?.persist?.();
    const target = syntheticEvent.target;
    const serialisableEvent = {
        bubbles: syntheticEvent.bubbles,
        cancelable: syntheticEvent.cancelable,
        defaultPrevented: syntheticEvent.defaultPrevented,
        eventPhase: syntheticEvent.eventPhase,
        isTrusted: syntheticEvent.isTrusted,
        target: {
            selectionStart: target?.selectionStart,
            selectionEnd: target?.selectionEnd,
            value: target?.value,
            checked: target?.checked,
            name: target?.name,
            id: target?.id,
            tagName: target?.tagName,
            type: target?.type
        },
        timeStamp: syntheticEvent.timeStamp,
        type: syntheticEvent.type
    };
    return serialisableEvent;
};
const $77fb0e0dd4421e81$var$extractClickEvents = ([syntheticEvent, ...args])=>{
    if (!syntheticEvent.isTrusted) return [];
    return args?.filter((0, $5EMLi.isUIAnalyticsEvent)).filter((event)=>event.payload.action === 'clicked');
};
/**
 * Default handler args transformer that extract react synthetic event from
 * the handler args and creates a serialisable object so that it can be passed into the runtime.
 */ const $77fb0e0dd4421e81$var$nativeEventHandlerArgsTransformer = (...args)=>{
    const [event, ...rest] = args;
    return [
        $77fb0e0dd4421e81$var$getSerialisableEventObject(event),
        ...rest
    ];
};
const $77fb0e0dd4421e81$export$5ce8c276f684a042 = ()=>{
    const { trackExtensionClicked: trackExtensionClicked } = (0, $cOZrT.useForgeUiAnalyticsEvent)();
    const { captureEvent: captureEvent } = (0, $grXB3.usePerformanceAnalytics)();
    const { extensionType: extensionType, forgeEnvironment: forgeEnvironment } = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $kpjEk.RendererContext));
    /**
	 * @param sourceEventHandler the source event handler defined by the app user
	 * @returns the adapted event handler that can be safely invoked.
	 */ const adaptEventHandler = (0, $eJOHy.useCallback)((sourceEventHandler)=>{
        if (!sourceEventHandler) return sourceEventHandler;
        return (...args)=>{
            sourceEventHandler(...$77fb0e0dd4421e81$var$nativeEventHandlerArgsTransformer(...args));
            // try catch to avoid blocking the event handler in case of error
            try {
                // Detect and fire certain component interaction events for Forge-specific
                // tracking. Does not interfere with propagation to downstream handlers.
                $77fb0e0dd4421e81$var$extractClickEvents(args).forEach((event)=>{
                    const componentName = event.payload.attributes.componentName;
                    captureEvent({
                        type: 'user-interacted',
                        elapsed: (0, $6QUJr.getPerformanceMark)()
                    });
                    trackExtensionClicked({
                        extensionType: extensionType,
                        appType: 'UIKit',
                        componentName: componentName,
                        forgeEnvironment: forgeEnvironment,
                        baseUrl: window.location.origin
                    });
                });
            } catch (e) {}
        };
    }, [
        captureEvent,
        extensionType,
        forgeEnvironment,
        trackExtensionClicked
    ]);
    return adaptEventHandler;
};

});

parcelRegister("iRtff", function(module, exports) {
$parcel$export(module.exports, "IconComponent", () => $e826939a6c8fb402$export$f508444e7933c2b1);
$parcel$export(module.exports, "Icon", () => $e826939a6c8fb402$export$f04a61298a47a40f);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $fzk0D = parcelRequire("fzk0D");

var $kweLG = parcelRequire("kweLG");

var $1qwc4 = parcelRequire("1qwc4");

var $j5Zyu = parcelRequire("j5Zyu");
var $kpjEk = parcelRequire("kpjEk");

var $j5Zyu = parcelRequire("j5Zyu");
/**
 * The validateColor function and its helper functions could not be
 * moved to a separate file because it could potentially cause cyclic
 * dependencies since type IconColor must be defined here in order for
 * forge-react-types to recognise it.
 */ const $e826939a6c8fb402$var$iconTokenSet = new Set(Object.keys((0, $fzk0D.default)).filter((token)=>token.startsWith('color')));
const $e826939a6c8fb402$var$isInTokenSet = (color)=>$e826939a6c8fb402$var$iconTokenSet.has(color);
const $e826939a6c8fb402$export$69378c11ed599796 = (color)=>{
    if (!color) return undefined;
    if (!$e826939a6c8fb402$var$isInTokenSet(color)) {
        (0, $kweLG.default)(`[@forge/react: Icon] "${color}" is not a valid design token for color.`);
        return undefined;
    }
    return `var(${(0, $fzk0D.default)[color]})`;
};
const $e826939a6c8fb402$var$iconTokenSetLegacy = new Set(Object.keys((0, $fzk0D.default)).filter((token)=>token.startsWith('color.icon')));
const $e826939a6c8fb402$var$isInTokenSetLegacy = (color)=>$e826939a6c8fb402$var$iconTokenSetLegacy.has(color);
const $e826939a6c8fb402$export$fe4c6b7d8735b9f0 = (color)=>{
    if (!color) return undefined;
    if (!$e826939a6c8fb402$var$isInTokenSetLegacy(color)) {
        (0, $kweLG.default)(`[@forge/react: Icon] the value "${color}" is not a valid design token for primaryColor or secondaryColor.`);
        return undefined;
    }
    return `var(${(0, $fzk0D.default)[color]})`;
};
const $e826939a6c8fb402$export$f508444e7933c2b1 = ({ glyph: glyph, label: label, color: color, size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>{
    let Component;
    let forceSize = false;
    let spacing = 'none';
    const featurePreview = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $j5Zyu.FeaturePreviewContext));
    // Only use the backwards compatibility logic if the feature preview is not enabled.
    if (Boolean(featurePreview[0, $j5Zyu.ICONOGRAPHY_REFRESH]) === false) {
        // The new icons have different dimensions:
        // medium: 24px by 24px => 16px by 16px
        // small:  16px by 16px => 12px by 12px
        // https://atlassian.design/components/icon/examples#default-16px
        // To avoid breaking changes, use the "spacing" prop to revert back to the old dimensions.
        if (size === 'small') spacing = 'compact';
        if (size === 'medium' || size === undefined) spacing = 'spacious';
    }
    // Special lookup: backwards compatibility for legacy icons
    if (size && size === 'large') {
        // @ts-ignore: we don't generate types for the legacy icons, as they are only ever used for backwards compatibility for this very use case
        Component = (0, $1qwc4.IconGlyphs)[`LEGACY_${glyph}`];
        // If size="large" is used, but we don't have an icon, display the icon with the default size.
        // This would happen if a user decided to use swap the glyph for an "old" icon that is already using size="large".
        if (!Component) forceSize = true;
    }
    // Regular lookup
    if (!Component) // @ts-ignore: TS2322: Type 'IconNext | IconRemoved | IconReplaced' is not assignable to type 'string'.
    Component = (0, $1qwc4.IconGlyphs)[glyph];
    const { forgeEnvironment: forgeEnvironment } = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $kpjEk.RendererContext));
    if (forgeEnvironment !== 'PRODUCTION') {
        // Using an array avoids TS issues checking for an invalid value type
        if (size !== undefined && ![
            'small',
            'medium'
        ].includes(size)) (0, $kweLG.default)(`[@forge/react: Icon] Warning: The value "${size}" for the "size" prop has been deprecated and will be removed on the 22nd of December 2025. To avoid breaking changes, only use the values "small" or "medium". For more details, visit: https://atlassian.design/components/icon/usage#spacing-and-sizing`);
        if (primaryColor !== undefined) (0, $kweLG.default)(`[@forge/react: Icon] Warning: The "primaryColor" is deprecated and will be removed on the 22nd of December 2025. Please use the "color" prop instead. For more information, visit: https://developer.atlassian.com/platform/forge/ui-kit/components/icon/.`);
        if (secondaryColor !== undefined) (0, $kweLG.default)(`[@forge/react: Icon] Warning: The "secondaryColor" prop has been deprecated and will be removed on the 22nd of December 2025. Please refactor your code to avoid using this prop.`);
        if ((0, $1qwc4.iconRemoved).has(glyph)) (0, $kweLG.default)(`[@forge/react: Icon] The glyph "${glyph}" is deprecated and will be removed on the 22nd of December 2025. Visit https://atlassian.design/components/icon/migration-guide for information on finding a replacement.`);
        if ((0, $1qwc4.iconReplaced).has(glyph)) (0, $kweLG.default)(`[@forge/react: Icon] The icon "${glyph}" has been superseded and will be removed on the 22nd of December 2025. Visit https://atlassian.design/components/icon/migration-guide for information on the recommended replacement Icon.`);
    }
    if (!Component) {
        (0, $kweLG.default)(`[@forge/react: Icon] no icon found for the glyph "${glyph}".`);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {});
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
            // @ts-ignore: Jira only - TS2322: Type '{ label: string; glyph: Glyph; color: string | undefined; spacing: "none" | "compact" | "spacious" | undefined; size: "small" | "medium" | "large" | undefined; primaryColor: string | undefined; secondaryColor: string | undefined; LEGACY_size: "small" | ... 2 more ... | undefined; LEGACY_primaryColor: string | undefi...' is not assignable to type 'IntrinsicAttributes'
            label: label,
            glyph: glyph,
            color: $e826939a6c8fb402$export$69378c11ed599796(color || primaryColor),
            size: forceSize ? 'medium' : size,
            primaryColor: $e826939a6c8fb402$export$fe4c6b7d8735b9f0(color || primaryColor),
            secondaryColor: $e826939a6c8fb402$export$fe4c6b7d8735b9f0(secondaryColor),
            LEGACY_size: forceSize ? 'medium' : size,
            LEGACY_primaryColor: $e826939a6c8fb402$export$fe4c6b7d8735b9f0(color || primaryColor),
            LEGACY_secondaryColor: $e826939a6c8fb402$export$fe4c6b7d8735b9f0(secondaryColor),
            spacing: spacing
        })
    });
};
const $e826939a6c8fb402$export$f04a61298a47a40f = (props)=>{
    const { glyph: glyph, label: label, color: color, size: size, primaryColor: primaryColor, secondaryColor: secondaryColor } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)($e826939a6c8fb402$export$f508444e7933c2b1, {
        label: label,
        glyph: glyph,
        color: color,
        size: size,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
    });
};

});
parcelRegister("1qwc4", function(module, exports) {
$parcel$export(module.exports, "IconGlyphs", () => $da0900888ea6ceec$export$f7b1faa91259ef9d);
$parcel$export(module.exports, "iconRemoved", () => $da0900888ea6ceec$export$9ebdede3e2763d09);
$parcel$export(module.exports, "iconReplaced", () => $da0900888ea6ceec$export$cb2011f34d4d5169);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * lazy imports for all icons in @atlaskit/icon/glyph that are used in UI Kit 2 components
 *
 * @codegen <<SignedSource::6c12eb6932e3f871f11df690212a79e9>>
 * @codegenCommand yarn workspace @atlassian/forge-ui codegen icon
 * @codegenDependency ../../../../../../../design-system/icon/src/migration-map.tsx <<SignedSource::b9783a4416fa7e048f2053e7c565d70d>>
 * @codegenDependency ../../../../../../../design-system/icon/src/metadata-core.tsx <<SignedSource::25d9fd1c339e22a006ed2d4212faea9a>>
 */ /* eslint @repo/internal/codegen/signed-source-integrity: "warn" */ 
var $eJOHy = parcelRequire("eJOHy");




















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































const $da0900888ea6ceec$export$f7b1faa91259ef9d = {
    'activity': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5EZG4"))),
    'add-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("iyftM"))),
    'add-item': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("nRYGH"))),
    'addon': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4A7sd"))),
    'editor-align-center': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("iUAH0"))),
    'editor-align-left': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kHUnC"))),
    'editor-align-right': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eZjUq"))),
    'app-access': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1rJBZ"))),
    'archive': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6gk55"))),
    'arrow-down-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("76APO"))),
    'arrow-left-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("csVRj"))),
    'arrow-right-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hXugU"))),
    'arrow-up-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lID2C"))),
    'audio-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("iSuRd"))),
    'hipchat-audio-only': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("9g6bO"))),
    'bitbucket-branches': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("9Dnbk"))),
    'bitbucket-commits': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("j8foa"))),
    'bitbucket-pullrequests': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hh5Ik"))),
    'bitbucket-repos': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cgN4d"))),
    'bitbucket-snippets': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("ivMPA"))),
    'bitbucket-source': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lvC7D"))),
    'book': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bFMEz"))),
    'bullet-list': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hJTH0"))),
    'calendar-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("j0TrO"))),
    'camera-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("h2YFd"))),
    'checkbox': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("card0"))),
    'check-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("3TFuO")))),
    'check-circle-outline': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1kJ0i"))),
    'check': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("entZ3")))),
    'chevron-down-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dHRsa"))),
    'hipchat-chevron-down': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("6BxzS")))),
    'chevron-left-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5VpOw"))),
    'chevron-left-large': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("a2JSB")))),
    'chevron-right-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("cu3lN")))),
    'chevron-right-large': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("1kTzc")))),
    'chevron-up-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("l5dxV"))),
    'hipchat-chevron-up': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("jAF24")))),
    'child-issues': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bLBf3"))),
    'code': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4ft1P"))),
    'creditcard-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("1aFA1")))),
    'creditcard': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("liTkU"))),
    'detail-view': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jl8DW"))),
    'hipchat-dial-out': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2Nqdy"))),
    'discover-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3W24T"))),
    'discover': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("245b6"))),
    'document-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("50c1S"))),
    'document': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("g59EI"))),
    'documents': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1Ip2D"))),
    'drag-handler': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bJ0WL"))),
    'edit-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fFAIQ"))),
    'editor-add': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("kMmrb")))),
    'editor-align-image-center': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kpLyF"))),
    'editor-align-image-left': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gHrN8"))),
    'editor-align-image-right': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("9kULF"))),
    'editor-attachment': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6aFRA"))),
    'editor-background-color': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("a1C0K"))),
    'editor-bold': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("jaa3x")))),
    'editor-bullet-list': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("la331")))),
    'editor-close': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("5wxTT")))),
    'editor-code': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("cnLJM")))),
    'editor-collapse': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("40Chg"))),
    'editor-date': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("73PB0")))),
    'editor-decision': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("luDPF")))),
    'editor-divider': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8p2FD"))),
    'editor-done': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("6XkOW")))),
    'editor-edit': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7vgzR"))),
    'editor-emoji': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("lhPrb")))),
    'editor-error': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8vWTS"))),
    'editor-expand': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8pXNf"))),
    'editor-feedback': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("ca7Vd"))),
    'editor-file': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("frMkK"))),
    'editor-help': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eoybj"))),
    'editor-hint': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("epDWs"))),
    'editor-horizontal-rule': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("aBcWs")))),
    'editor-image': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("92GYt")))),
    'editor-image-resize': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8OdDr"))),
    'editor-indent': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("kwwiE")))),
    'editor-info': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("8pzQh")))),
    'editor-italic': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("ifOJ1")))),
    'editor-layout-single': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8jTPN"))),
    'editor-layout-three-equal': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dl1sX"))),
    'editor-layout-three-with-sidebars': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("72k4b"))),
    'editor-layout-two-equal': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("9or4V")))),
    'editor-layout-two-left-sidebar': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1Euh6"))),
    'editor-layout-two-right-sidebar': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5j9t6"))),
    'editor-link': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("9ucqS")))),
    'editor-media-center': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("iMaQc"))),
    'editor-media-full-width': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gclir"))),
    'editor-media-wide': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7KkVM"))),
    'editor-media-wrap-left': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("b61JR"))),
    'editor-media-wrap-right': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("52m8c"))),
    'editor-mention': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("hyxYz")))),
    'editor-more': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("i2fvj")))),
    'editor-note': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("ejT8C")))),
    'editor-number-list': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("5Xn4A")))),
    'editor-open': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2B5pu"))),
    'editor-outdent': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("hfYNh")))),
    'editor-panel': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("48zN8"))),
    'editor-photo': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("iXAYx"))),
    'editor-quote': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("9Bsqn"))),
    'editor-recent': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("9iURY"))),
    'editor-redo': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6MaVB"))),
    'editor-remove': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("2IYY2")))),
    'editor-search': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("dqx2X")))),
    'editor-settings': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hQUMP"))),
    'editor-success': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("i9bjW")))),
    'editor-table': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("dbsNQ")))),
    'editor-task': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aEbsM"))),
    'editor-text-style': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cOe7g"))),
    'editor-undo': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4m948"))),
    'editor-unlink': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("dQl2w")))),
    'editor-warning': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6iKNh"))),
    'emoji-activity': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cfod8"))),
    'emoji-custom': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("d0pMh"))),
    'emoji-emoji': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("9OXXP"))),
    'emoji-flags': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7EJgm"))),
    'emoji-food': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dHhjO"))),
    'emoji-frequent': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lDyNr"))),
    'emoji-keyboard': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1DQA8"))),
    'emoji-nature': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bj73O"))),
    'emoji-objects': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kxnUj"))),
    'emoji-people': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dd83o"))),
    'emoji-productivity': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5bFz4"))),
    'emoji-symbols': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8ohkf"))),
    'emoji-travel': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("56IFO"))),
    'error': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("1NG86")))),
    'export': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("a2JRb"))),
    'folder': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("erdE7"))),
    'followers': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3372Y"))),
    'graph-bar': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4NHwz"))),
    'graph-line': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gDJiM"))),
    'home-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fGMMA"))),
    'image-resize': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("f3ya9"))),
    'info': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("i4Iw4")))),
    'invite-team': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1MvU9"))),
    'issue': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4jzTf"))),
    'issue-raise': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("loIrT"))),
    'issues': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bL1lq"))),
    'jira-capture': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("e7UfA"))),
    'jira-labs': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("99Pab"))),
    'jira-test-session': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jfF5a"))),
    'label': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("9AAxU"))),
    'lightbulb-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("dcjtT")))),
    'like': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fUMvo"))),
    'link-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bUaYJ"))),
    'hipchat-lobby': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("74QoL"))),
    'lock-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eZ0B3"))),
    'lock-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("c0UF0"))),
    'lock': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2csxX"))),
    'media-services-actual-size': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aWqb3"))),
    'media-services-add-comment': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fSODg"))),
    'media-services-audio': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eEkBP"))),
    'media-services-code': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hy4in"))),
    'media-services-document': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hvI7r"))),
    'media-services-filter': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lbQ6h"))),
    'media-services-fit-to-page': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("a1Ii7"))),
    'media-services-full-screen': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dOr8n"))),
    'media-services-grid': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7j8CX"))),
    'media-services-image': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("goaJd"))),
    'media-services-line': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3t1p5"))),
    'media-services-preselected': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("ifbiw"))),
    'media-services-presentation': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("k2lyS"))),
    'media-services-scale-large': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dwPOW"))),
    'media-services-scale-small': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("i4OnP"))),
    'media-services-spreadsheet': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8c3RE"))),
    'media-services-video': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("iDVAO"))),
    'media-services-zoom-in': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4zOxa"))),
    'media-services-zoom-out': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("f57U1"))),
    'menu-expand': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8cC1A"))),
    'mobile': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kM7J9"))),
    'more': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jz8fZ"))),
    'more-vertical': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5nwfo"))),
    'notification-direct': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("h6J7e"))),
    'office-building-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lnNW6"))),
    'open': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kQKK8"))),
    'hipchat-outgoing-sound': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("9WUfm"))),
    'overview': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fm7rO"))),
    'page-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1ra7p"))),
    'people': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("hMpZ8")))),
    'person-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5KWT5"))),
    'person-with-tick': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kCr1v"))),
    'preferences': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("20wts"))),
    'question': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cH3kb"))),
    'questions': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aZtZY"))),
    'queues': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lRjs5"))),
    'quote': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("dTYnh")))),
    'radio': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("c0Po1"))),
    'recent': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1kLuM"))),
    'room-menu': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bq6e8"))),
    'schedule-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6uBW0"))),
    'schedule': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eq0qn"))),
    'hipchat-sd-video': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("f9zfW"))),
    'select-clear': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("5pWSu")))),
    'ship': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("6aKac")))),
    'shortcut': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("8rAKL")))),
    'sign-in': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("j11z9"))),
    'sign-out': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("ijNsw"))),
    'star-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("i1Kbr"))),
    'star': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("knSWj"))),
    'star-large': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7COM9"))),
    'subtask': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("93JYU"))),
    'suitcase': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("caQPU"))),
    'switcher': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4xIzF"))),
    'table': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("i9rrJ"))),
    'trash': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6nAdm"))),
    'tray': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2qYu0"))),
    'unlink': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("blDxg"))),
    'unlock-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3DgPs"))),
    'unlock-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2ptCg"))),
    'unlock': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bFDet"))),
    'upload': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jGFOv"))),
    'user-avatar-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("dvMQP")))),
    'vid-audio-on': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("13DeQ"))),
    'vid-camera-on': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8jM8E"))),
    'video-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("f7cbC"))),
    'video-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("9vaR1"))),
    'vid-full-screen-off': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("ql0b6"))),
    'vid-full-screen-on': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5jVIj"))),
    'vid-pause': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3pfZY"))),
    'vid-play': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("ewH8i"))),
    'vid-volume-full': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gYRNJ"))),
    'vid-volume-half': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aM3HT"))),
    'vid-volume-muted': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bBFOh"))),
    'warning': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("jkYbX")))),
    'watch-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1fSDl"))),
    'watch': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("koFqW"))),
    'world': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gVcrU"))),
    'world-small': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7ltfp"))),
    'add': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("57691"))),
    'app-switcher': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("9GAG6"))),
    'arrow-down': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jTIpD"))),
    'arrow-left': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("lqfmR")))),
    'arrow-right': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kcxeo"))),
    'arrow-up': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bAVbi"))),
    'attachment': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bCsrc"))),
    'audio': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("l31B4"))),
    'backlog': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2zt8F"))),
    'board': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("iF0J3"))),
    'calendar': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("3GKOL")))),
    'camera': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gobwF"))),
    'checkbox-indeterminate': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bRygf"))),
    'chevron-down': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("5lAAn")))),
    'chevron-left': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("iLv67"))),
    'chevron-right': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("dB1eP")))),
    'chevron-up': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6Mor3"))),
    'comment': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7gCMb"))),
    'component': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bNgFX"))),
    'copy': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("4TA31")))),
    'cross-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("kXEdL")))),
    'cross': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("6J9k6")))),
    'dashboard': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5SqcI"))),
    'decision': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8i49k"))),
    'department': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fdlP3"))),
    'download': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lvAjg"))),
    'edit': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eoryE"))),
    'email': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("dNLHm")))),
    'emoji-add': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("ak3RO"))),
    'emoji': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dTTrA"))),
    'feedback': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5i9TT"))),
    'file': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("emKLF"))),
    'filter': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3J6JV"))),
    'flag-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("byjTw"))),
    'home': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7Yo89"))),
    'image': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jl0Ps"))),
    'lightbulb': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bgfFr"))),
    'link': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("av9Of")))),
    'location': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lwlJv"))),
    'marketplace': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("qJT5V"))),
    'menu': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jkJMa"))),
    'notification': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7ADVe"))),
    'office-building': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fJX1L"))),
    'page': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5Is7s"))),
    'people-group': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("io0aX"))),
    'person': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("58frP")))),
    'premium': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hoj28"))),
    'question-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("k9Gmz")))),
    'redo': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("ivwel"))),
    'refresh': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7q4qN"))),
    'retry': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cFkFw"))),
    'roadmap': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3Yp75"))),
    'screen': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("24GzU"))),
    'search': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("i0iAU")))),
    'send': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aHSIv"))),
    'settings': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("kkiGo")))),
    'share': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("76Tlk"))),
    'sprint': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lCsqX"))),
    'stopwatch': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fZ6Im"))),
    'task': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("brHgq"))),
    'teams': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5TzfM"))),
    'undo': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jcrgp"))),
    'billing-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4wQqY"))),
    'billing': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("izYoX"))),
    'bitbucket-builds': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4mV01"))),
    'bitbucket-clone': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4URYH"))),
    'bitbucket-compare': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fm6q0"))),
    'bitbucket-forks': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6bk5T"))),
    'bitbucket-output': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5kHcX"))),
    'bitbucket-pipelines': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("11xtF"))),
    'camera-rotate': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dprUg"))),
    'camera-take-picture': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("c6c6w"))),
    'canvas': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("g12PG"))),
    'hipchat-chevron-double-down': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eV9E5"))),
    'hipchat-chevron-double-up': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("90eO2"))),
    'dropbox': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fDz61"))),
    'editor-addon': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4UPtj"))),
    'editor-advanced': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eg9mT"))),
    'editor-file-preview': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3sc9L"))),
    'editor-image-border': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("57zOb"))),
    'editor-remove-emoji': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lE8hi"))),
    'editor-strikethrough': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("qO03x"))),
    'editor-table-display-options': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aE1uf"))),
    'editor-text-color': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3ob62"))),
    'editor-underline': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hxvM5"))),
    'emoji-atlassian': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gFyU6"))),
    'folder-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lnYob"))),
    'following': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cPNom"))),
    'googledrive': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("9cdOY"))),
    'gsuite': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aIPLP"))),
    'highlights': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("k6gch"))),
    'image-border': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("k6iyf"))),
    'jira-failed-build-status': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cn8Wc"))),
    'list': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1Royr"))),
    'hipchat-media-attachment-count': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cPCOJ"))),
    'media-services-annotate': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eiXxm"))),
    'media-services-arrow': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("a6D1j"))),
    'media-services-blur': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eAstp"))),
    'media-services-brush': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5ZdZX"))),
    'media-services-button-option': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("ewvjF"))),
    'media-services-line-thickness': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("daEBz"))),
    'media-services-no-image': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jJw6o"))),
    'media-services-open-mediaviewer': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kIrJp"))),
    'media-services-oval': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("c0SXP"))),
    'media-services-pdf': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kj27R"))),
    'media-services-rectangle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("iRHgf"))),
    'media-services-text': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("52PFA")))),
    'media-services-unknown': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eWCJI"))),
    'media-services-zip': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4mG9s"))),
    'mention': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("l7iAz"))),
    'notification-all': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("akUEx"))),
    'pdf': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dBMVf"))),
    'person-with-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1sjLr"))),
    'person-with-cross': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("iUwam"))),
    'portfolio': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fboOn"))),
    'presence-active': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8JCLK"))),
    'presence-busy': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("M8Rxj"))),
    'presence-unavailable': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hABlI"))),
    'status': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("eta4I")))),
    'vid-audio-muted': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("apcuj"))),
    'vid-backward': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aPSWW"))),
    'vid-camera-off': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("ld6vq"))),
    'vid-connection-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4qGO3"))),
    'vid-forward': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("af22p"))),
    'vid-hang-up': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8HTiE"))),
    'vid-hd-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aakLu"))),
    'vid-raised-hand': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bzWAP"))),
    'vid-share-screen': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2OxZe"))),
    'vid-speaking-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4AQBL"))),
    'accessibility': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dFoE7"))),
    'ai-agent': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("fIzTE")))),
    'ai-chat': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("72yLJ"))),
    'ai-generative-text-summary': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3sVgy"))),
    'alert': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5NsuV"))),
    'align-image-center': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5vxCv"))),
    'align-image-left': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eAlde"))),
    'align-image-right': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("azUmM"))),
    'align-text-center': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2ia8C"))),
    'align-text-left': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cmP4Y"))),
    'align-text-right': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("25CF1"))),
    'angle-brackets': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("8lO5P")))),
    'api': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3l5q4"))),
    'app': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("kcLaf")))),
    'app-switcher-legacy': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8S3mW"))),
    'apps': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("bGbhe")))),
    'archive-box': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4YZhp"))),
    'arrow-down-left': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2lLxx"))),
    'arrow-down-right': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("ej3Uw"))),
    'arrow-up-left': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3hRwe"))),
    'arrow-up-right': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gFfel"))),
    'assets': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("ekU6o"))),
    'atlassian-intelligence': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("92Yni"))),
    'automation': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3uwVP"))),
    'basketball': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("e7ivW"))),
    'boards': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4Il1t"))),
    'book-with-bookmark': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6YFrd"))),
    'border': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("18VJY"))),
    'branch': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3xKip"))),
    'briefcase': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2c1v1"))),
    'bug': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("9UdpB")))),
    'calendar-plus': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kS4C1"))),
    'capture': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jO5w2"))),
    'card': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2P4zU"))),
    'cash': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("53IqS"))),
    'changes': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bRZvq"))),
    'chart-bar': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("g8Hx0"))),
    'chart-bubble': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("i7DNi"))),
    'chart-matrix': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("ktUn4"))),
    'chart-pie': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5bCK6"))),
    'chart-trend': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("94SLH"))),
    'chart-trend-down': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hYNq0"))),
    'chart-trend-up': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("h0FG3")))),
    'chat-widget': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5vOnP"))),
    'check-circle-unchecked': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7HRst"))),
    'check-mark': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("lwpci")))),
    'checkbox-checked': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5NY7E"))),
    'checkbox-unchecked': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dmteF"))),
    'chevron-double-left': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("ld0cd")))),
    'chevron-double-right': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("cqfIR")))),
    'child-work-items': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2WVd3"))),
    'clipboard': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7xht2"))),
    'clock': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("i5stJ")))),
    'close': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6snMl"))),
    'cloud-arrow-up': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("bzGVj")))),
    'collapse-horizontal': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("vYMR3"))),
    'collapse-vertical': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7P955"))),
    'comment-add': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("ee846"))),
    'commit': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lolnG"))),
    'compass': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("h6eqv"))),
    'content-width-narrow': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2EfT6"))),
    'content-width-wide': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4cEb8"))),
    'content-wrap-left': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("ivSas"))),
    'content-wrap-right': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2OD8g"))),
    'credit-card': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("2lxIs")))),
    'curly-brackets': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gJInV"))),
    'customize': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lSkUO"))),
    'data-flow': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("ll6L6"))),
    'data-number': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5aelq"))),
    'data-string': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aOBfL"))),
    'database': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4a0NG"))),
    'defect': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cOINl"))),
    'delete': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("4MicW")))),
    'device-mobile': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("DpqSH"))),
    'devices': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("clES7"))),
    'discovery': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("h4COp")))),
    'drag-handle-horizontal': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kj6su"))),
    'drag-handle-vertical': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7S0RQ"))),
    'edit-bulk': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bpxdm"))),
    'emoji-casual': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cyMDk"))),
    'emoji-neutral': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("b10Fx"))),
    'emoji-remove': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("f8Bbt"))),
    'epic': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("ch3nR"))),
    'exclamation-square': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("e0rn7"))),
    'expand-horizontal': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eXZKn"))),
    'expand-vertical': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5vAba"))),
    'eye-open': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("9XoIE"))),
    'eye-open-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fSqGE"))),
    'eye-open-strikethrough': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3x0Es"))),
    'feed': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("l3OR5"))),
    'field': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("e8P7t"))),
    'field-alert': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8MkTS"))),
    'field-checkbox-group': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5rCYm"))),
    'field-dropdown': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3k0fI"))),
    'field-radio-group': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("es3zL"))),
    'files': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4J6au"))),
    'flag': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4vCYu"))),
    'flask': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("72VHl"))),
    'focus-area': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8HVJW"))),
    'folder-closed': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hxYvX"))),
    'folder-open': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("l0PiJ"))),
    'form': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("b7jVu"))),
    'fullscreen-enter': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4WhMA"))),
    'fullscreen-exit': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2L4Og"))),
    'glasses': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4RsDq"))),
    'globe': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("iBgxn")))),
    'goal': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("9qes7")))),
    'grid': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("1U4zO")))),
    'grow-diagonal': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hVmch"))),
    'grow-horizontal': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dsTkE"))),
    'grow-vertical': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("g8La4"))),
    'hashtag': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("djBJn"))),
    'headphones': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("3XKBx")))),
    'heart': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("23SsX"))),
    'highlight': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("b4uWa"))),
    'image-fullscreen': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fBzgw"))),
    'image-inline': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dZ7zL"))),
    'image-scaled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fX8MF"))),
    'inbox': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("yGfRR"))),
    'incident': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3ODIv"))),
    'information': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aQ5Wv"))),
    'information-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("6BR9Q")))),
    'key-result': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hpeRC"))),
    'layout-one-column': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("9UDiB"))),
    'layout-three-columns': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("9Nvwv")))),
    'layout-three-columns-sidebars': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("AkBja"))),
    'layout-two-columns': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("fkTM0")))),
    'layout-two-columns-sidebar-left': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1WBN4"))),
    'layout-two-columns-sidebar-right': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8DYeg"))),
    'library': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2OfSL"))),
    'link-broken': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("25YjY")))),
    'link-external': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("9itkV")))),
    'list-bulleted': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("hJIkn")))),
    'list-checklist': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gCi0w"))),
    'list-numbered': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("bVHJR")))),
    'lobby-bell': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jhlcy"))),
    'lock-locked': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("9QgTI")))),
    'lock-unlocked': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("danCZ"))),
    'log-in': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("dWEml")))),
    'log-out': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("hAZjV")))),
    'magic-wand': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("b9AFO"))),
    'markdown': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lCGU8"))),
    'maximize': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("iGfe0"))),
    'megaphone': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kjCLb"))),
    'merge-failure': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bPDOj"))),
    'merge-success': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3nsv6"))),
    'microphone': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("9DvoS"))),
    'minimize': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("krbQZ"))),
    'minus': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("FvAEI")))),
    'minus-square': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6LsYj"))),
    'node': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bJgnj"))),
    'note': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("isw2P"))),
    'notification-muted': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("ig4wQ"))),
    'objective': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bNXS1"))),
    'on-call': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eqCFy"))),
    'operations': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("9mydb")))),
    'pages': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("e0ccO"))),
    'paint-bucket': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gGFKG"))),
    'paint-palette': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4CvnY"))),
    'panel-left': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5eMsJ"))),
    'panel-right': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6JWOy"))),
    'pen': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8BqTI"))),
    'person-add': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jaRJd"))),
    'person-added': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4Tcwg"))),
    'person-avatar': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("gNUuP")))),
    'person-offboard': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8lYf9"))),
    'person-remove': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("izqtz"))),
    'person-warning': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jQsjh"))),
    'phone': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4wrww"))),
    'pin': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("88MRH"))),
    'pin-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2ukfG"))),
    'plus-square': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dQioX"))),
    'power-plug': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hWNiU"))),
    'presenter-mode': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("ahztn"))),
    'printer': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("l0bbX"))),
    'priority-blocker': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6aCjv"))),
    'priority-critical': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6UVBP"))),
    'priority-high': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gHUmX"))),
    'priority-highest': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1hca1"))),
    'priority-low': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("djO5H"))),
    'priority-lowest': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kyhaI"))),
    'priority-major': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fu054"))),
    'priority-medium': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4l8I8"))),
    'priority-minor': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6lJQ4"))),
    'priority-trivial': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("e7YQz"))),
    'problem': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7I81R"))),
    'project': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("lmJ87")))),
    'project-status': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fveFI"))),
    'projection-screen': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5FN95"))),
    'pull-request': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bhluA"))),
    'pulse': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6F4NG"))),
    'quotation-mark': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("amerd")))),
    'radio-checked': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("etdCO"))),
    'radio-unchecked': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("iJFD4"))),
    'release': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("8Hdu4")))),
    'rovo-chat': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2g6bK"))),
    'scales': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("i4OR9"))),
    'scorecard': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lhCBK"))),
    'screen-plus': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("IUagn"))),
    'shapes': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cwzC4"))),
    'shield': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("79DMg"))),
    'shield-strikethrough': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lpvc6"))),
    'show-more-horizontal': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("NByNW")))),
    'show-more-vertical': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("QxUqW"))),
    'shrink-diagonal': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2hy9v"))),
    'shrink-horizontal': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2ya5m"))),
    'shrink-vertical': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fTMpY"))),
    'sidebar-collapse': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("h0CR3")))),
    'sidebar-expand': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("fq0Uu")))),
    'smart-link': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4gMn8"))),
    'smart-link-card': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2Pd1P"))),
    'smart-link-embed': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eRqyL"))),
    'smart-link-inline': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dT9jj"))),
    'smart-link-list': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bZWLM"))),
    'snippet': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fQowv"))),
    'sort-ascending': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eRBlK"))),
    'sort-descending': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gcn0b"))),
    'spreadsheet': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cPxN7"))),
    'star-starred': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1pgmc"))),
    'star-unstarred': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("aaIe7")))),
    'status-discovery': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2QnzO"))),
    'status-error': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("80DPg")))),
    'status-information': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("2R0ne")))),
    'status-success': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("3wl9L")))),
    'status-verified': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("acRfo")))),
    'status-warning': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("d8UFE")))),
    'story': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("hVZow")))),
    'stroke-weight-extra-large': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("k2Erv"))),
    'stroke-weight-large': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fl2JW"))),
    'stroke-weight-medium': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("a4xAE"))),
    'stroke-weight-small': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("k3JVi"))),
    'subtasks': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3CafX"))),
    'success': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("92DA1"))),
    'support': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("d3g28"))),
    'table-cell-clear': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("kmgRi")))),
    'table-cell-merge': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1tRql"))),
    'table-cell-split': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("f7E0W"))),
    'table-column-add-left': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cj2pt"))),
    'table-column-add-right': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1V5Tj"))),
    'table-column-delete': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eyVnU"))),
    'table-column-move-left': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3Ve0d"))),
    'table-column-move-right': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("axOZG"))),
    'table-columns-distribute': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5b7tP"))),
    'table-row-add-above': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("44kkl"))),
    'table-row-add-below': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8QeYq"))),
    'table-row-delete': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4ji9J"))),
    'table-row-move-down': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8JjEN"))),
    'table-row-move-up': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5K48F"))),
    'tag': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("P2zUI"))),
    'takeout-food': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("9eghX"))),
    'target': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jKe6u"))),
    'task-in-progress': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cqgtq"))),
    'task-to-do': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8o1FH"))),
    'tasks': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("iSqQx"))),
    'text': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("8hNRj")))),
    'text-bold': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("5iunZ")))),
    'text-heading': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6uC9y"))),
    'text-indent-left': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("5xSIi")))),
    'text-indent-right': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("6hGSl")))),
    'text-italic': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("lwr5e")))),
    'text-shorten': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8v6mm"))),
    'text-spellcheck': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("h7fcz"))),
    'text-strikethrough': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("bouBs")))),
    'text-style': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("6WP1Q")))),
    'text-underline': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("f2cYq")))),
    'text-wrap': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("gVpwy")))),
    'theme': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("enf1K")))),
    'thumbs-down': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lesoK"))),
    'thumbs-up': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4dLqJ"))),
    'timeline': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("i1vD7"))),
    'tools': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("9TAvZ"))),
    'transition': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jSCZ1"))),
    'translate': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jcu4u"))),
    'tree': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("f1QvK"))),
    'vehicle-car': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2ajVC"))),
    'video': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("bTWCd")))),
    'video-next': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jdi42"))),
    'video-next-overlay': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fjcfG"))),
    'video-pause': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1YRVW"))),
    'video-pause-overlay': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5aBxv"))),
    'video-play': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bQFZK"))),
    'video-play-overlay': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("62GUY"))),
    'video-previous': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7nEB9"))),
    'video-previous-overlay': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hMntu"))),
    'video-skip-backward-fifteen': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("43bn2"))),
    'video-skip-backward-ten': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fpWg8"))),
    'video-skip-forward-fifteen': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eMoGG"))),
    'video-skip-forward-ten': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("CFQSH"))),
    'video-stop': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dl9ME"))),
    'video-stop-overlay': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("faygV"))),
    'volume-high': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("iBJPb"))),
    'volume-low': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("25SZG"))),
    'volume-muted': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fMt8H"))),
    'whiteboard': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("funyL"))),
    'work-item': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("c59mr")))),
    'work-items': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kpuBm"))),
    'zoom-in': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("d5ATj"))),
    'zoom-out': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jeXlP"))),
    'LEGACY_activity': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("axsCd"))),
    'LEGACY_add': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("9Fm1W"))),
    'LEGACY_add-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lNFQy"))),
    'LEGACY_add-item': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hRePn"))),
    'LEGACY_addon': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("9PqOo"))),
    'LEGACY_app-access': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4wmSQ"))),
    'LEGACY_app-switcher': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7gWbN"))),
    'LEGACY_archive': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5mXw6"))),
    'LEGACY_arrow-down': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jUg0H"))),
    'LEGACY_arrow-down-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hgwWm"))),
    'LEGACY_arrow-left': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("h0mAD")))),
    'LEGACY_arrow-left-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3WBvT"))),
    'LEGACY_arrow-right': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fNCbK"))),
    'LEGACY_arrow-right-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("qavM1"))),
    'LEGACY_arrow-up': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hHXHT"))),
    'LEGACY_arrow-up-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aAtO9"))),
    'LEGACY_attachment': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5fhJg"))),
    'LEGACY_audio': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bsi2e"))),
    'LEGACY_audio-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hafIS"))),
    'LEGACY_backlog': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("iZiYj"))),
    'LEGACY_billing': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("izYoX"))),
    'LEGACY_billing-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4wQqY"))),
    'LEGACY_bitbucket-branches': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1YNKq"))),
    'LEGACY_bitbucket-builds': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4mV01"))),
    'LEGACY_bitbucket-clone': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4URYH"))),
    'LEGACY_bitbucket-commits': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7qTXR"))),
    'LEGACY_bitbucket-compare': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fm6q0"))),
    'LEGACY_bitbucket-forks': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6bk5T"))),
    'LEGACY_bitbucket-output': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5kHcX"))),
    'LEGACY_bitbucket-pipelines': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("11xtF"))),
    'LEGACY_bitbucket-pullrequests': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("GIowT"))),
    'LEGACY_bitbucket-repos': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eh8xN"))),
    'LEGACY_bitbucket-snippets': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6xXUa"))),
    'LEGACY_bitbucket-source': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eQkYx"))),
    'LEGACY_board': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("ibFjc"))),
    'LEGACY_book': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1pP3X"))),
    'LEGACY_bullet-list': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fLWi7"))),
    'LEGACY_calendar': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("76JV8")))),
    'LEGACY_calendar-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("96Apc"))),
    'LEGACY_camera': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dDfhe"))),
    'LEGACY_camera-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("zbjhX"))),
    'LEGACY_camera-rotate': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dprUg"))),
    'LEGACY_camera-take-picture': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("c6c6w"))),
    'LEGACY_canvas': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("g12PG"))),
    'LEGACY_check': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("2kdvq")))),
    'LEGACY_check-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("jhvt8")))),
    'LEGACY_check-circle-outline': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dmBba"))),
    'LEGACY_checkbox': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aMG9i"))),
    'LEGACY_checkbox-indeterminate': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4leDg"))),
    'LEGACY_chevron-down': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("1UIWS")))),
    'LEGACY_chevron-down-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kmdPb"))),
    'LEGACY_chevron-left': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bKbFx"))),
    'LEGACY_chevron-left-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3e3gt"))),
    'LEGACY_chevron-left-large': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("k9ooi")))),
    'LEGACY_chevron-right': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("fRBiY")))),
    'LEGACY_chevron-right-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("kYD0I")))),
    'LEGACY_chevron-right-large': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("czcci")))),
    'LEGACY_chevron-up': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cLNFy"))),
    'LEGACY_chevron-up-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gWjQ0"))),
    'LEGACY_child-issues': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6HxVA"))),
    'LEGACY_code': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jaaKd"))),
    'LEGACY_comment': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("e50Bu"))),
    'LEGACY_component': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bpWPz"))),
    'LEGACY_copy': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("hZKKB")))),
    'LEGACY_creditcard': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("h9t5B"))),
    'LEGACY_creditcard-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("646d9")))),
    'LEGACY_cross': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("laG04")))),
    'LEGACY_cross-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("jZF1f")))),
    'LEGACY_dashboard': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("a2dzl"))),
    'LEGACY_decision': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lUNrH"))),
    'LEGACY_department': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("iJZrp"))),
    'LEGACY_detail-view': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eAUE9"))),
    'LEGACY_discover': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("50tGD"))),
    'LEGACY_discover-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("ccTZm"))),
    'LEGACY_document': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("05bpU"))),
    'LEGACY_document-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1zWcV"))),
    'LEGACY_documents': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2Lfta"))),
    'LEGACY_download': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7XZaJ"))),
    'LEGACY_drag-handler': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bqrYs"))),
    'LEGACY_dropbox': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fDz61"))),
    'LEGACY_edit': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gIq8f"))),
    'LEGACY_edit-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2h2se"))),
    'LEGACY_editor-add': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("bKq60")))),
    'LEGACY_editor-addon': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4UPtj"))),
    'LEGACY_editor-advanced': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eg9mT"))),
    'LEGACY_editor-align-center': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("197JG"))),
    'LEGACY_editor-align-image-center': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8qapV"))),
    'LEGACY_editor-align-image-left': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dEt0o"))),
    'LEGACY_editor-align-image-right': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2h37v"))),
    'LEGACY_editor-align-left': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("a8jAd"))),
    'LEGACY_editor-align-right': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2pHPx"))),
    'LEGACY_editor-attachment': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bBmjU"))),
    'LEGACY_editor-background-color': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("Cs8TW"))),
    'LEGACY_editor-bold': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("b4zTI")))),
    'LEGACY_editor-bullet-list': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("hhyv8")))),
    'LEGACY_editor-close': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("6OLN4")))),
    'LEGACY_editor-code': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("Uzddr")))),
    'LEGACY_editor-collapse': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1Nb7L"))),
    'LEGACY_editor-date': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("cyebN")))),
    'LEGACY_editor-decision': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("fvh9f")))),
    'LEGACY_editor-divider': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gO5rE"))),
    'LEGACY_editor-done': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("37Ug4")))),
    'LEGACY_editor-edit': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3N9KL"))),
    'LEGACY_editor-emoji': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("gF0HQ")))),
    'LEGACY_editor-error': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kAbU2"))),
    'LEGACY_editor-expand': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("0Yz5o"))),
    'LEGACY_editor-feedback': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8HRPj"))),
    'LEGACY_editor-file': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("l3xZw"))),
    'LEGACY_editor-file-preview': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3sc9L"))),
    'LEGACY_editor-help': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bWcHV"))),
    'LEGACY_editor-hint': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gAhAq"))),
    'LEGACY_editor-horizontal-rule': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("k5n7B")))),
    'LEGACY_editor-image': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("3h9bV")))),
    'LEGACY_editor-image-border': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("57zOb"))),
    'LEGACY_editor-image-resize': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4k7ht"))),
    'LEGACY_editor-indent': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("eiUei")))),
    'LEGACY_editor-info': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("eAsyt")))),
    'LEGACY_editor-italic': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("lasBY")))),
    'LEGACY_editor-layout-single': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8EsJw"))),
    'LEGACY_editor-layout-three-equal': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lnadk"))),
    'LEGACY_editor-layout-three-with-sidebars': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3DkPn"))),
    'LEGACY_editor-layout-two-equal': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("kHKYy")))),
    'LEGACY_editor-layout-two-left-sidebar': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gLdes"))),
    'LEGACY_editor-layout-two-right-sidebar': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3iI0u"))),
    'LEGACY_editor-link': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("frcEo")))),
    'LEGACY_editor-media-center': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cwgo1"))),
    'LEGACY_editor-media-full-width': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("clXui"))),
    'LEGACY_editor-media-wide': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3Ih6p"))),
    'LEGACY_editor-media-wrap-left': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gPpf9"))),
    'LEGACY_editor-media-wrap-right': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fyq9U"))),
    'LEGACY_editor-mention': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("6cJsV")))),
    'LEGACY_editor-more': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("fES0B")))),
    'LEGACY_editor-note': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("94404")))),
    'LEGACY_editor-number-list': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("hM9Fu")))),
    'LEGACY_editor-open': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("llG54"))),
    'LEGACY_editor-outdent': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("8hxcF")))),
    'LEGACY_editor-panel': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("b676u"))),
    'LEGACY_editor-photo': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("coNMY"))),
    'LEGACY_editor-quote': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("95phr"))),
    'LEGACY_editor-recent': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("a3Vzm"))),
    'LEGACY_editor-redo': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8TXBT"))),
    'LEGACY_editor-remove': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("f7oSr")))),
    'LEGACY_editor-remove-emoji': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lE8hi"))),
    'LEGACY_editor-search': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("dPkHp")))),
    'LEGACY_editor-settings': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("ibxUD"))),
    'LEGACY_editor-strikethrough': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("qO03x"))),
    'LEGACY_editor-success': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("6BeTe")))),
    'LEGACY_editor-table': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("XRjx0")))),
    'LEGACY_editor-table-display-options': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aE1uf"))),
    'LEGACY_editor-task': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("a9Y5z")))),
    'LEGACY_editor-text-color': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3ob62"))),
    'LEGACY_editor-text-style': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("exniU")))),
    'LEGACY_editor-underline': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hxvM5"))),
    'LEGACY_editor-undo': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2ZVB1"))),
    'LEGACY_editor-unlink': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("bnsEu")))),
    'LEGACY_editor-warning': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("k89QS"))),
    'LEGACY_email': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("4ZN93")))),
    'LEGACY_emoji': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("acJe8"))),
    'LEGACY_emoji-add': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hOysi"))),
    'LEGACY_emoji-activity': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lyZCv"))),
    'LEGACY_emoji-atlassian': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gFyU6"))),
    'LEGACY_emoji-custom': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jOedN"))),
    'LEGACY_emoji-emoji': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("d88Xn"))),
    'LEGACY_emoji-flags': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eeAFc"))),
    'LEGACY_emoji-food': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8EbyJ"))),
    'LEGACY_emoji-frequent': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("pgD1c"))),
    'LEGACY_emoji-keyboard': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2xtKF"))),
    'LEGACY_emoji-nature': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fADd3"))),
    'LEGACY_emoji-objects': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bpyTT"))),
    'LEGACY_emoji-people': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("f3J6m"))),
    'LEGACY_emoji-productivity': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4x7zS"))),
    'LEGACY_emoji-symbols': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("j9jS8"))),
    'LEGACY_emoji-travel': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("CcgmX"))),
    'LEGACY_error': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("duLdC")))),
    'LEGACY_export': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7ibBx"))),
    'LEGACY_feedback': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2fuGi"))),
    'LEGACY_file': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1DK2N"))),
    'LEGACY_filter': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("46rU4"))),
    'LEGACY_flag-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kpHER"))),
    'LEGACY_folder': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7XKr3"))),
    'LEGACY_folder-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lnYob"))),
    'LEGACY_followers': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gr7DB"))),
    'LEGACY_following': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cPNom"))),
    'LEGACY_googledrive': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("9cdOY"))),
    'LEGACY_graph-bar': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1jMXj"))),
    'LEGACY_graph-line': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jXtYG"))),
    'LEGACY_gsuite': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aIPLP"))),
    'LEGACY_highlights': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("k6gch"))),
    'LEGACY_hipchat-audio-only': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5WsrD"))),
    'LEGACY_hipchat-chevron-double-down': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eV9E5"))),
    'LEGACY_hipchat-chevron-double-up': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("90eO2"))),
    'LEGACY_hipchat-chevron-down': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("lD65a")))),
    'LEGACY_hipchat-chevron-up': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("bIwqN")))),
    'LEGACY_hipchat-dial-out': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bcLSQ"))),
    'LEGACY_hipchat-lobby': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7PZNM"))),
    'LEGACY_hipchat-media-attachment-count': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cPCOJ"))),
    'LEGACY_hipchat-outgoing-sound': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3Uvbk"))),
    'LEGACY_hipchat-sd-video': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5AsjY"))),
    'LEGACY_home': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("g66wC"))),
    'LEGACY_home-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bIlY9"))),
    'LEGACY_image': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3eKdM"))),
    'LEGACY_image-border': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("k6iyf"))),
    'LEGACY_image-resize': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fX1Pk"))),
    'LEGACY_info': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("cDDv2")))),
    'LEGACY_invite-team': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gQDdL"))),
    'LEGACY_issue': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("88tEs"))),
    'LEGACY_issue-raise': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cyQXM"))),
    'LEGACY_issues': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6ZIkL"))),
    'LEGACY_jira-capture': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fH8G5"))),
    'LEGACY_jira-failed-build-status': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cn8Wc"))),
    'LEGACY_jira-labs': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1wbDv"))),
    'LEGACY_jira-test-session': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("j0QvP"))),
    'LEGACY_label': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lnXk0"))),
    'LEGACY_lightbulb': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eAmma"))),
    'LEGACY_lightbulb-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("i2Uod")))),
    'LEGACY_like': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("e0B6y"))),
    'LEGACY_link': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("a2o1i")))),
    'LEGACY_link-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jt0vj"))),
    'LEGACY_list': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1Royr"))),
    'LEGACY_location': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hpfLU"))),
    'LEGACY_lock': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("djnBL"))),
    'LEGACY_lock-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("djJr9"))),
    'LEGACY_lock-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("kKPzl")))),
    'LEGACY_marketplace': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jheAx"))),
    'LEGACY_media-services-actual-size': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("etSq4"))),
    'LEGACY_media-services-add-comment': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4Kxo1"))),
    'LEGACY_media-services-annotate': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eiXxm"))),
    'LEGACY_media-services-arrow': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("a6D1j"))),
    'LEGACY_media-services-audio': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gBCxG"))),
    'LEGACY_media-services-blur': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eAstp"))),
    'LEGACY_media-services-brush': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5ZdZX"))),
    'LEGACY_media-services-button-option': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("ewvjF"))),
    'LEGACY_media-services-code': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1SbDw"))),
    'LEGACY_media-services-document': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6mo8x"))),
    'LEGACY_media-services-filter': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("Yf1Va"))),
    'LEGACY_media-services-fit-to-page': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lRyIz"))),
    'LEGACY_media-services-full-screen': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8xKDw"))),
    'LEGACY_media-services-grid': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3UlY1"))),
    'LEGACY_media-services-image': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bHFww"))),
    'LEGACY_media-services-line': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8PTHr"))),
    'LEGACY_media-services-line-thickness': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("daEBz"))),
    'LEGACY_media-services-no-image': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jJw6o"))),
    'LEGACY_media-services-open-mediaviewer': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kIrJp"))),
    'LEGACY_media-services-oval': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("c0SXP"))),
    'LEGACY_media-services-pdf': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kj27R"))),
    'LEGACY_media-services-preselected': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kK7t8"))),
    'LEGACY_media-services-presentation': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3a68c"))),
    'LEGACY_media-services-rectangle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("iRHgf"))),
    'LEGACY_media-services-scale-large': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6SIxB"))),
    'LEGACY_media-services-scale-small': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dwvQx"))),
    'LEGACY_media-services-spreadsheet': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5I8wl"))),
    'LEGACY_media-services-text': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("52PFA")))),
    'LEGACY_media-services-unknown': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("eWCJI"))),
    'LEGACY_media-services-video': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8kzpV"))),
    'LEGACY_media-services-zip': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4mG9s"))),
    'LEGACY_media-services-zoom-in': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3fqM3"))),
    'LEGACY_media-services-zoom-out': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("9nbqs"))),
    'LEGACY_mention': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("l7iAz"))),
    'LEGACY_menu': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hvE4Q"))),
    'LEGACY_menu-expand': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1rcrH"))),
    'LEGACY_mobile': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fLlzt"))),
    'LEGACY_more': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aQ0Lk"))),
    'LEGACY_more-vertical': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2seYZ"))),
    'LEGACY_notification': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("l5GY2"))),
    'LEGACY_notification-all': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("akUEx"))),
    'LEGACY_notification-direct': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gKJE9"))),
    'LEGACY_office-building': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4O6SD"))),
    'LEGACY_office-building-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lOr5M"))),
    'LEGACY_open': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6Wjaq"))),
    'LEGACY_overview': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kQTTx"))),
    'LEGACY_page': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6kENQ"))),
    'LEGACY_page-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7HTlr"))),
    'LEGACY_pdf': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dBMVf"))),
    'LEGACY_people': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("9HVF4")))),
    'LEGACY_people-group': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aYmcy"))),
    'LEGACY_person': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("6NCZy")))),
    'LEGACY_person-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jrMtG"))),
    'LEGACY_person-with-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1sjLr"))),
    'LEGACY_person-with-cross': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("iUwam"))),
    'LEGACY_person-with-tick': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bQ7iR"))),
    'LEGACY_portfolio': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fboOn"))),
    'LEGACY_preferences': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5VPJY"))),
    'LEGACY_premium': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4EjXL"))),
    'LEGACY_presence-active': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8JCLK"))),
    'LEGACY_presence-busy': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("M8Rxj"))),
    'LEGACY_presence-unavailable': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hABlI"))),
    'LEGACY_question': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("iEJ32"))),
    'LEGACY_question-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("53vxQ")))),
    'LEGACY_questions': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5EdbP"))),
    'LEGACY_queues': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hbrEb"))),
    'LEGACY_quote': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("8KCrB")))),
    'LEGACY_radio': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("572Y0"))),
    'LEGACY_recent': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kjuUp"))),
    'LEGACY_redo': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("exckD"))),
    'LEGACY_refresh': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lEfaF"))),
    'LEGACY_retry': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1gz3S"))),
    'LEGACY_roadmap': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kn3qg"))),
    'LEGACY_room-menu': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7qVFS"))),
    'LEGACY_schedule': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5e7uw"))),
    'LEGACY_schedule-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hGeWn"))),
    'LEGACY_screen': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3biwk"))),
    'LEGACY_search': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("i1DfW")))),
    'LEGACY_select-clear': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("3VlSK")))),
    'LEGACY_send': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6TZpS"))),
    'LEGACY_settings': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("cytXm")))),
    'LEGACY_share': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4jdxN"))),
    'LEGACY_ship': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("01opv")))),
    'LEGACY_shortcut': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("lhaOC")))),
    'LEGACY_sign-in': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("6qSYw")))),
    'LEGACY_sign-out': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kiVwN"))),
    'LEGACY_sprint': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("gBjOL"))),
    'LEGACY_star': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("82lov"))),
    'LEGACY_star-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aCmtX"))),
    'LEGACY_star-large': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fRyUd"))),
    'LEGACY_status': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("eta4I")))),
    'LEGACY_stopwatch': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fowLT"))),
    'LEGACY_subtask': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hr6tQ"))),
    'LEGACY_suitcase': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3hTpc"))),
    'LEGACY_switcher': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8oAwh"))),
    'LEGACY_table': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bWIu4"))),
    'LEGACY_task': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2QLpH"))),
    'LEGACY_teams': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hVSj9"))),
    'LEGACY_trash': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3miRP"))),
    'LEGACY_tray': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7WWbR"))),
    'LEGACY_undo': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fjcOC"))),
    'LEGACY_unlink': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("g4fkL"))),
    'LEGACY_unlock': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2iqiy"))),
    'LEGACY_unlock-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("j9AZ9"))),
    'LEGACY_unlock-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("jDQyJ"))),
    'LEGACY_upload': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2gF6z"))),
    'LEGACY_user-avatar-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("g4Zdb")))),
    'LEGACY_vid-audio-muted': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("apcuj"))),
    'LEGACY_vid-audio-on': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aWY6T"))),
    'LEGACY_vid-backward': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aPSWW"))),
    'LEGACY_vid-camera-off': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("ld6vq"))),
    'LEGACY_vid-camera-on': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1zMU1"))),
    'LEGACY_vid-connection-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4qGO3"))),
    'LEGACY_vid-forward': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("af22p"))),
    'LEGACY_vid-full-screen-off': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cbUsA"))),
    'LEGACY_vid-full-screen-on': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("29nSC"))),
    'LEGACY_vid-hang-up': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8HTiE"))),
    'LEGACY_vid-hd-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aakLu"))),
    'LEGACY_vid-pause': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8LnSq"))),
    'LEGACY_vid-play': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("9NEyp"))),
    'LEGACY_vid-raised-hand': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bzWAP"))),
    'LEGACY_vid-share-screen': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2OxZe"))),
    'LEGACY_vid-speaking-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4AQBL"))),
    'LEGACY_vid-volume-full': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("04WeJ"))),
    'LEGACY_vid-volume-half': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("iUvxg"))),
    'LEGACY_vid-volume-muted': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("6Dv6q"))),
    'LEGACY_video-circle': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1uhII"))),
    'LEGACY_video-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1lulf"))),
    'LEGACY_warning': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("60rxg")))),
    'LEGACY_watch': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("krDxS"))),
    'LEGACY_watch-filled': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("8Sc2L"))),
    'LEGACY_world': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("HAIsX"))),
    'LEGACY_world-small': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2X60A")))
};
const $da0900888ea6ceec$export$9ebdede3e2763d09 = new Set([
    'billing-filled',
    'billing',
    'bitbucket-builds',
    'bitbucket-clone',
    'bitbucket-compare',
    'bitbucket-forks',
    'bitbucket-output',
    'bitbucket-pipelines',
    'camera-rotate',
    'camera-take-picture',
    'canvas',
    'hipchat-chevron-double-down',
    'hipchat-chevron-double-up',
    'dropbox',
    'editor-addon',
    'editor-advanced',
    'editor-file-preview',
    'editor-image-border',
    'editor-remove-emoji',
    'editor-strikethrough',
    'editor-table-display-options',
    'editor-text-color',
    'editor-underline',
    'emoji-atlassian',
    'folder-filled',
    'following',
    'googledrive',
    'gsuite',
    'highlights',
    'image-border',
    'jira-failed-build-status',
    'list',
    'hipchat-media-attachment-count',
    'media-services-annotate',
    'media-services-arrow',
    'media-services-blur',
    'media-services-brush',
    'media-services-button-option',
    'media-services-line-thickness',
    'media-services-no-image',
    'media-services-open-mediaviewer',
    'media-services-oval',
    'media-services-pdf',
    'media-services-rectangle',
    'media-services-text',
    'media-services-unknown',
    'media-services-zip',
    'mention',
    'notification-all',
    'pdf',
    'person-with-circle',
    'person-with-cross',
    'portfolio',
    'presence-active',
    'presence-busy',
    'presence-unavailable',
    'status',
    'vid-audio-muted',
    'vid-backward',
    'vid-camera-off',
    'vid-connection-circle',
    'vid-forward',
    'vid-hang-up',
    'vid-hd-circle',
    'vid-raised-hand',
    'vid-share-screen',
    'vid-speaking-circle'
]);
const $da0900888ea6ceec$export$cb2011f34d4d5169 = new Set([
    'activity',
    'add-circle',
    'add-item',
    'addon',
    'editor-align-center',
    'editor-align-left',
    'editor-align-right',
    'app-access',
    'archive',
    'arrow-down-circle',
    'arrow-left-circle',
    'arrow-right-circle',
    'arrow-up-circle',
    'audio-circle',
    'hipchat-audio-only',
    'bitbucket-branches',
    'bitbucket-commits',
    'bitbucket-pullrequests',
    'bitbucket-repos',
    'bitbucket-snippets',
    'bitbucket-source',
    'book',
    'bullet-list',
    'calendar-filled',
    'camera-filled',
    'checkbox',
    'check-circle',
    'check-circle-outline',
    'check',
    'chevron-down-circle',
    'hipchat-chevron-down',
    'chevron-left-circle',
    'chevron-left-large',
    'chevron-right-circle',
    'chevron-right-large',
    'chevron-up-circle',
    'hipchat-chevron-up',
    'child-issues',
    'code',
    'creditcard-filled',
    'creditcard',
    'detail-view',
    'hipchat-dial-out',
    'discover-filled',
    'discover',
    'document-filled',
    'document',
    'documents',
    'drag-handler',
    'edit-filled',
    'editor-add',
    'editor-align-image-center',
    'editor-align-image-left',
    'editor-align-image-right',
    'editor-attachment',
    'editor-background-color',
    'editor-bold',
    'editor-bullet-list',
    'editor-close',
    'editor-code',
    'editor-collapse',
    'editor-date',
    'editor-decision',
    'editor-divider',
    'editor-done',
    'editor-edit',
    'editor-emoji',
    'editor-error',
    'editor-expand',
    'editor-feedback',
    'editor-file',
    'editor-help',
    'editor-hint',
    'editor-horizontal-rule',
    'editor-image',
    'editor-image-resize',
    'editor-indent',
    'editor-info',
    'editor-italic',
    'editor-layout-single',
    'editor-layout-three-equal',
    'editor-layout-three-with-sidebars',
    'editor-layout-two-equal',
    'editor-layout-two-left-sidebar',
    'editor-layout-two-right-sidebar',
    'editor-link',
    'editor-media-center',
    'editor-media-full-width',
    'editor-media-wide',
    'editor-media-wrap-left',
    'editor-media-wrap-right',
    'editor-mention',
    'editor-more',
    'editor-note',
    'editor-number-list',
    'editor-open',
    'editor-outdent',
    'editor-panel',
    'editor-photo',
    'editor-quote',
    'editor-recent',
    'editor-redo',
    'editor-remove',
    'editor-search',
    'editor-settings',
    'editor-success',
    'editor-table',
    'editor-task',
    'editor-text-style',
    'editor-undo',
    'editor-unlink',
    'editor-warning',
    'emoji-activity',
    'emoji-custom',
    'emoji-emoji',
    'emoji-flags',
    'emoji-food',
    'emoji-frequent',
    'emoji-keyboard',
    'emoji-nature',
    'emoji-objects',
    'emoji-people',
    'emoji-productivity',
    'emoji-symbols',
    'emoji-travel',
    'error',
    'export',
    'folder',
    'followers',
    'graph-bar',
    'graph-line',
    'home-circle',
    'image-resize',
    'info',
    'invite-team',
    'issue',
    'issue-raise',
    'issues',
    'jira-capture',
    'jira-labs',
    'jira-test-session',
    'label',
    'lightbulb-filled',
    'like',
    'link-filled',
    'hipchat-lobby',
    'lock-circle',
    'lock-filled',
    'lock',
    'media-services-actual-size',
    'media-services-add-comment',
    'media-services-audio',
    'media-services-code',
    'media-services-document',
    'media-services-filter',
    'media-services-fit-to-page',
    'media-services-full-screen',
    'media-services-grid',
    'media-services-image',
    'media-services-line',
    'media-services-preselected',
    'media-services-presentation',
    'media-services-scale-large',
    'media-services-scale-small',
    'media-services-spreadsheet',
    'media-services-video',
    'media-services-zoom-in',
    'media-services-zoom-out',
    'menu-expand',
    'mobile',
    'more',
    'more-vertical',
    'notification-direct',
    'office-building-filled',
    'open',
    'hipchat-outgoing-sound',
    'overview',
    'page-filled',
    'people',
    'person-circle',
    'person-with-tick',
    'preferences',
    'question',
    'questions',
    'queues',
    'quote',
    'radio',
    'recent',
    'room-menu',
    'schedule-filled',
    'schedule',
    'hipchat-sd-video',
    'select-clear',
    'ship',
    'shortcut',
    'sign-in',
    'sign-out',
    'star-filled',
    'star',
    'star-large',
    'subtask',
    'suitcase',
    'switcher',
    'table',
    'trash',
    'tray',
    'unlink',
    'unlock-circle',
    'unlock-filled',
    'unlock',
    'upload',
    'user-avatar-circle',
    'vid-audio-on',
    'vid-camera-on',
    'video-circle',
    'video-filled',
    'vid-full-screen-off',
    'vid-full-screen-on',
    'vid-pause',
    'vid-play',
    'vid-volume-full',
    'vid-volume-half',
    'vid-volume-muted',
    'warning',
    'watch-filled',
    'watch',
    'world',
    'world-small'
]);

});
parcelRegister("5EZG4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("15bWo")
]).then(()=>parcelRequire('iJBL3'));

});

parcelRegister("iyftM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fIKES").then(()=>parcelRequire('l4cPj'));

});

parcelRegister("nRYGH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("k2s7n").then(()=>parcelRequire('196zp'));

});

parcelRegister("4A7sd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2U8zg").then(()=>parcelRequire('f9wiC'));

});

parcelRegister("iUAH0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eVVh2").then(()=>parcelRequire('57upj'));

});

parcelRegister("kHUnC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("clvZK").then(()=>parcelRequire('hQ4QQ'));

});

parcelRegister("eZjUq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6CWou").then(()=>parcelRequire('7GihV'));

});

parcelRegister("1rJBZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5LZAK").then(()=>parcelRequire('arAT1'));

});

parcelRegister("6gk55", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2DaUN").then(()=>parcelRequire('eKkOj'));

});

parcelRegister("76APO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7crGt").then(()=>parcelRequire('fcXuk'));

});

parcelRegister("csVRj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6YDWW").then(()=>parcelRequire('aJCX7'));

});

parcelRegister("hXugU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fcTqx").then(()=>parcelRequire('3qZZA'));

});

parcelRegister("lID2C", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3K7HO").then(()=>parcelRequire('l2yEk'));

});

parcelRegister("iSuRd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kHvWr").then(()=>parcelRequire('gau1G'));

});

parcelRegister("9g6bO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("92XsH").then(()=>parcelRequire('iWLFa'));

});

parcelRegister("9Dnbk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iGK8U").then(()=>parcelRequire('jlvUH'));

});

parcelRegister("j8foa", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kfktb").then(()=>parcelRequire('lyfmv'));

});

parcelRegister("hh5Ik", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ZBbVa").then(()=>parcelRequire('jVVB7'));

});

parcelRegister("cgN4d", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("j2Ov2").then(()=>parcelRequire('9owxV'));

});

parcelRegister("ivMPA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iA3zH").then(()=>parcelRequire('398LT'));

});

parcelRegister("lvC7D", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gVKM4").then(()=>parcelRequire('fWUAL'));

});

parcelRegister("bFMEz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jO2ep").then(()=>parcelRequire('gtWWT'));

});

parcelRegister("hJTH0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1GQ88").then(()=>parcelRequire('cRAIo'));

});

parcelRegister("j0TrO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("htt6T").then(()=>parcelRequire('cfd1T'));

});

parcelRegister("h2YFd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2xxue").then(()=>parcelRequire('ffSG0'));

});

parcelRegister("card0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bgYMf").then(()=>parcelRequire('bIGxD'));

});

parcelRegister("1kJ0i", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("eBfrw")
]).then(()=>parcelRequire('3C1GW'));

});

parcelRegister("entZ3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5e5baeaa2c36dad27a8b98ef155f7a5d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a77a78d359015cce$var$_react = $a77a78d359015cce$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a77a78d359015cce$var$_checkMark = $a77a78d359015cce$var$_interopRequireDefault((parcelRequire("lwpci")));

var $a77a78d359015cce$var$_check = $a77a78d359015cce$var$_interopRequireDefault((parcelRequire("2kdvq")));
function $a77a78d359015cce$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "CheckIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a77a78d359015cce$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $a77a78d359015cce$var$_react.default.createElement($a77a78d359015cce$var$_checkMark.default, Object.assign({
        name: "CheckMarkIcon",
        LEGACY_fallbackIcon: $a77a78d359015cce$var$_check.default
    }, props));
$a77a78d359015cce$var$CheckMarkIcon.displayName = 'CheckMarkIconMigration';
var $a77a78d359015cce$var$_default = module.exports.default = $a77a78d359015cce$var$CheckMarkIcon;

});
parcelRegister("lwpci", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bcf60af7e41b379d3a36d6fe455c57ca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fab021c59a8f6419$var$_react = $fab021c59a8f6419$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fab021c59a8f6419$var$_baseNew = $fab021c59a8f6419$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $fab021c59a8f6419$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fab021c59a8f6419$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $fab021c59a8f6419$var$_react.default.createElement($fab021c59a8f6419$var$_baseNew.default, Object.assign({
        name: "CheckMarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.959 3.97-7.25 9a.75.75 0 0 1-1.163.007l-3.5-4.25 1.158-.954 2.914 3.539 6.673-8.283z"/>`
    }, props));
$fab021c59a8f6419$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $fab021c59a8f6419$var$_default = module.exports.default = $fab021c59a8f6419$var$CheckMarkIcon;

});


parcelRegister("dHRsa", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8nnk4").then(()=>parcelRequire('7kfqR'));

});

parcelRegister("5VpOw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jtAqv").then(()=>parcelRequire('iSeW0'));

});

parcelRegister("a2JSB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8e8ea817ec2fe685ddbf301b825d4978>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $74fdae0df2a41f03$var$_react = $74fdae0df2a41f03$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $74fdae0df2a41f03$var$_chevronLeft = $74fdae0df2a41f03$var$_interopRequireDefault((parcelRequire("8PCRQ")));

var $74fdae0df2a41f03$var$_chevronLeftLarge = $74fdae0df2a41f03$var$_interopRequireDefault((parcelRequire("k9ooi")));
function $74fdae0df2a41f03$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $74fdae0df2a41f03$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $74fdae0df2a41f03$var$_react.default.createElement($74fdae0df2a41f03$var$_chevronLeft.default, Object.assign({
        name: "ChevronLeftIcon",
        LEGACY_fallbackIcon: $74fdae0df2a41f03$var$_chevronLeftLarge.default
    }, props));
$74fdae0df2a41f03$var$ChevronLeftIcon.displayName = 'ChevronLeftIconMigration';
var $74fdae0df2a41f03$var$_default = module.exports.default = $74fdae0df2a41f03$var$ChevronLeftIcon;

});
parcelRegister("8PCRQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8ee9ad5072a30451ff7ca2ddc0961d03>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66e13c6de5d90262$var$_react = $66e13c6de5d90262$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $66e13c6de5d90262$var$_baseNew = $66e13c6de5d90262$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $66e13c6de5d90262$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $66e13c6de5d90262$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $66e13c6de5d90262$var$_react.default.createElement($66e13c6de5d90262$var$_baseNew.default, Object.assign({
        name: "ChevronLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$66e13c6de5d90262$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $66e13c6de5d90262$var$_default = module.exports.default = $66e13c6de5d90262$var$ChevronLeftIcon;

});


parcelRegister("1kTzc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ffb3eee7b92db2782a45444d8dbb123a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f92c313e495a986$var$_react = $0f92c313e495a986$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0f92c313e495a986$var$_chevronRight = $0f92c313e495a986$var$_interopRequireDefault((parcelRequire("cQxBL")));

var $0f92c313e495a986$var$_chevronRightLarge = $0f92c313e495a986$var$_interopRequireDefault((parcelRequire("czcci")));
function $0f92c313e495a986$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Next page of pagination results, collapsed tree item, expand tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0f92c313e495a986$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $0f92c313e495a986$var$_react.default.createElement($0f92c313e495a986$var$_chevronRight.default, Object.assign({
        name: "ChevronRightIcon",
        LEGACY_fallbackIcon: $0f92c313e495a986$var$_chevronRightLarge.default
    }, props));
$0f92c313e495a986$var$ChevronRightIcon.displayName = 'ChevronRightIconMigration';
var $0f92c313e495a986$var$_default = module.exports.default = $0f92c313e495a986$var$ChevronRightIcon;

});

parcelRegister("l5dxV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("uEo6e").then(()=>parcelRequire('9bR8s'));

});

parcelRegister("bLBf3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("49cM0").then(()=>parcelRequire('cAQ2R'));

});

parcelRegister("4ft1P", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4Z2q8").then(()=>parcelRequire('ka71P'));

});

parcelRegister("liTkU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("8b76Y")
]).then(()=>parcelRequire('k7Q00'));

});

parcelRegister("jl8DW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ctTmP").then(()=>parcelRequire('eIIrM'));

});

parcelRegister("2Nqdy", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7fLPO").then(()=>parcelRequire('1A6Od'));

});

parcelRegister("3W24T", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("0TxbS").then(()=>parcelRequire('alQnK'));

});

parcelRegister("245b6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5yY6D").then(()=>parcelRequire('k2JVs'));

});

parcelRegister("50c1S", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ffitL").then(()=>parcelRequire('kSre2'));

});

parcelRegister("g59EI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2NUYW").then(()=>parcelRequire('iv6hb'));

});

parcelRegister("1Ip2D", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4NPrH").then(()=>parcelRequire('esonG'));

});

parcelRegister("bJ0WL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gO807").then(()=>parcelRequire('qhZuk'));

});

parcelRegister("fFAIQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bhYBS").then(()=>parcelRequire('lNdOF'));

});

parcelRegister("kMmrb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::14c96c4885e6c927729e770a6ffb9e6f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f209b1f071890324$var$_react = $f209b1f071890324$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f209b1f071890324$var$_add = $f209b1f071890324$var$_interopRequireDefault((parcelRequire("dcLzM")));

var $f209b1f071890324$var$_add2 = $f209b1f071890324$var$_interopRequireDefault((parcelRequire("bKq60")));
function $f209b1f071890324$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AddIcon.
 * This component is AddIcon, with `UNSAFE_fallbackIcon` set to "EditorAddIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f209b1f071890324$var$AddIcon = (props)=>/*#__PURE__*/ $f209b1f071890324$var$_react.default.createElement($f209b1f071890324$var$_add.default, Object.assign({
        name: "AddIcon",
        LEGACY_fallbackIcon: $f209b1f071890324$var$_add2.default
    }, props));
$f209b1f071890324$var$AddIcon.displayName = 'AddIconMigration';
var $f209b1f071890324$var$_default = module.exports.default = $f209b1f071890324$var$AddIcon;

});

parcelRegister("kpLyF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5WrjV").then(()=>parcelRequire('1tlkR'));

});

parcelRegister("gHrN8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4aQ01").then(()=>parcelRequire('2eFGH'));

});

parcelRegister("9kULF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("l5s3n").then(()=>parcelRequire('9kLgh'));

});

parcelRegister("6aFRA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3dJ8F").then(()=>parcelRequire('h6Ff1'));

});

parcelRegister("a1C0K", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("42ilD").then(()=>parcelRequire('heseR'));

});

parcelRegister("5wxTT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::18cd44b40ff8809efea24ae850576bc8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $405a3cd7d6c6872a$var$_react = $405a3cd7d6c6872a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $405a3cd7d6c6872a$var$_cross = $405a3cd7d6c6872a$var$_interopRequireDefault((parcelRequire("6zhpo")));

var $405a3cd7d6c6872a$var$_close = $405a3cd7d6c6872a$var$_interopRequireDefault((parcelRequire("6OLN4")));
function $405a3cd7d6c6872a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $405a3cd7d6c6872a$var$CrossIcon = (props)=>/*#__PURE__*/ $405a3cd7d6c6872a$var$_react.default.createElement($405a3cd7d6c6872a$var$_cross.default, Object.assign({
        name: "CrossIcon",
        LEGACY_fallbackIcon: $405a3cd7d6c6872a$var$_close.default
    }, props));
$405a3cd7d6c6872a$var$CrossIcon.displayName = 'CrossIconMigration';
var $405a3cd7d6c6872a$var$_default = module.exports.default = $405a3cd7d6c6872a$var$CrossIcon;

});

parcelRegister("40Chg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("32gue").then(()=>parcelRequire('b9jOK'));

});

parcelRegister("8p2FD", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9Mjjw").then(()=>parcelRequire('9wKvR'));

});

parcelRegister("6XkOW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::600b8f5df6a73844cbfa316238c6d2e9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5108674e45de2f8c$var$_react = $5108674e45de2f8c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5108674e45de2f8c$var$_checkMark = $5108674e45de2f8c$var$_interopRequireDefault((parcelRequire("lwpci")));

var $5108674e45de2f8c$var$_done = $5108674e45de2f8c$var$_interopRequireDefault((parcelRequire("37Ug4")));
function $5108674e45de2f8c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5108674e45de2f8c$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $5108674e45de2f8c$var$_react.default.createElement($5108674e45de2f8c$var$_checkMark.default, Object.assign({
        name: "CheckMarkIcon",
        LEGACY_fallbackIcon: $5108674e45de2f8c$var$_done.default
    }, props));
$5108674e45de2f8c$var$CheckMarkIcon.displayName = 'CheckMarkIconMigration';
var $5108674e45de2f8c$var$_default = module.exports.default = $5108674e45de2f8c$var$CheckMarkIcon;

});

parcelRegister("7vgzR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eUBCy").then(()=>parcelRequire('bIv5I'));

});

parcelRegister("8vWTS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cMC69").then(()=>parcelRequire('7aneS'));

});

parcelRegister("8pXNf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4gx8n").then(()=>parcelRequire('XRx2v'));

});

parcelRegister("ca7Vd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5OJzq").then(()=>parcelRequire('emIYj'));

});

parcelRegister("frMkK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dBkN1").then(()=>parcelRequire('eS81C'));

});

parcelRegister("eoybj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bE0mw").then(()=>parcelRequire('7HH4n'));

});

parcelRegister("epDWs", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("bK9Ew")
]).then(()=>parcelRequire('5WAQt'));

});

parcelRegister("8OdDr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2tMjx").then(()=>parcelRequire('6ec22'));

});

parcelRegister("8jTPN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5prMw").then(()=>parcelRequire('eiWvW'));

});

parcelRegister("dl1sX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dqDrJ").then(()=>parcelRequire('4uxmF'));

});

parcelRegister("72k4b", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2Rwew").then(()=>parcelRequire('6WKkC'));

});

parcelRegister("1Euh6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1hbU8").then(()=>parcelRequire('kZFtj'));

});

parcelRegister("5j9t6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("e9VaU").then(()=>parcelRequire('k9qb8'));

});

parcelRegister("iMaQc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4Awvr").then(()=>parcelRequire('3j0s1'));

});

parcelRegister("gclir", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("igmsI").then(()=>parcelRequire('i4pBY'));

});

parcelRegister("7KkVM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lkFiG").then(()=>parcelRequire('cgHXF'));

});

parcelRegister("b61JR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kv4iC").then(()=>parcelRequire('jvegN'));

});

parcelRegister("52m8c", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gl0m3").then(()=>parcelRequire('f5s66'));

});

parcelRegister("2B5pu", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6NJ21").then(()=>parcelRequire('5WJgP'));

});

parcelRegister("48zN8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("22apG").then(()=>parcelRequire('6J86O'));

});

parcelRegister("iXAYx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jpCvr").then(()=>parcelRequire('71SlU'));

});

parcelRegister("9Bsqn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bM4Ly").then(()=>parcelRequire('ffvAu'));

});

parcelRegister("9iURY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("7KD22")
]).then(()=>parcelRequire('2Dipt'));

});

parcelRegister("6MaVB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1VXlo").then(()=>parcelRequire('5DEXw'));

});

parcelRegister("dqx2X", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b2d61a8b9264c17f51d6b1ce92a21fc9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c675677f12a1926$var$_react = $9c675677f12a1926$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9c675677f12a1926$var$_search = $9c675677f12a1926$var$_interopRequireDefault((parcelRequire("dt3aG")));

var $9c675677f12a1926$var$_search2 = $9c675677f12a1926$var$_interopRequireDefault((parcelRequire("dPkHp")));
function $9c675677f12a1926$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SearchIcon.
 * This component is SearchIcon, with `UNSAFE_fallbackIcon` set to "EditorSearchIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9c675677f12a1926$var$SearchIcon = (props)=>/*#__PURE__*/ $9c675677f12a1926$var$_react.default.createElement($9c675677f12a1926$var$_search.default, Object.assign({
        name: "SearchIcon",
        LEGACY_fallbackIcon: $9c675677f12a1926$var$_search2.default
    }, props));
$9c675677f12a1926$var$SearchIcon.displayName = 'SearchIconMigration';
var $9c675677f12a1926$var$_default = module.exports.default = $9c675677f12a1926$var$SearchIcon;

});

parcelRegister("hQUMP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("iPJim")
]).then(()=>parcelRequire('7iUqh'));

});

parcelRegister("aEbsM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cfSLZ").then(()=>parcelRequire('2F3Za'));

});

parcelRegister("cOe7g", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dB4bX").then(()=>parcelRequire('iTco7'));

});

parcelRegister("4m948", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lGas3").then(()=>parcelRequire('8WDlD'));

});

parcelRegister("6iKNh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iR0Uw").then(()=>parcelRequire('88oIq'));

});

parcelRegister("cfod8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("RSFv0").then(()=>parcelRequire('dWQSr'));

});

parcelRegister("d0pMh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("58ZCb").then(()=>parcelRequire('dQmRx'));

});

parcelRegister("9OXXP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8V9UV").then(()=>parcelRequire('2tTvg'));

});

parcelRegister("7EJgm", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hvqFq").then(()=>parcelRequire('5H92h'));

});

parcelRegister("dHhjO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("do9CP").then(()=>parcelRequire('9wgg6'));

});

parcelRegister("lDyNr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("lNFnv")
]).then(()=>parcelRequire('joRfR'));

});

parcelRegister("1DQA8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cn8a4").then(()=>parcelRequire('gAJPK'));

});

parcelRegister("bj73O", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6jQjt").then(()=>parcelRequire('gSCsn'));

});

parcelRegister("kxnUj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("a7d62")
]).then(()=>parcelRequire('4pd44'));

});

parcelRegister("dd83o", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kBEvL").then(()=>parcelRequire('dBfxW'));

});

parcelRegister("5bFz4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("bVkeD")
]).then(()=>parcelRequire('3q9Jm'));

});

parcelRegister("8ohkf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5p1az").then(()=>parcelRequire('68yjx'));

});

parcelRegister("56IFO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4rODC").then(()=>parcelRequire('lqny5'));

});

parcelRegister("a2JRb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gCbFf").then(()=>parcelRequire('895TH'));

});

parcelRegister("erdE7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("idFp1").then(()=>parcelRequire('ifn8T'));

});

parcelRegister("3372Y", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jU0pu").then(()=>parcelRequire('2VMh0'));

});

parcelRegister("4NHwz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iCwUz").then(()=>parcelRequire('i33Qa'));

});

parcelRegister("gDJiM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ktbv9").then(()=>parcelRequire('3tum0'));

});

parcelRegister("fGMMA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8lTz4").then(()=>parcelRequire('eKrR2'));

});

parcelRegister("f3ya9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6mHDm").then(()=>parcelRequire('2wMV7'));

});

parcelRegister("1MvU9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jFGnw").then(()=>parcelRequire('95xtc'));

});

parcelRegister("4jzTf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1IaDy").then(()=>parcelRequire('5Etd3'));

});

parcelRegister("loIrT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1VOG0").then(()=>parcelRequire('d0DRA'));

});

parcelRegister("bL1lq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bHLvM").then(()=>parcelRequire('cajrN'));

});

parcelRegister("e7UfA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kNopA").then(()=>parcelRequire('3Dhfb'));

});

parcelRegister("99Pab", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cn1fk").then(()=>parcelRequire('oJqxg'));

});

parcelRegister("jfF5a", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kz89n").then(()=>parcelRequire('b43Uy'));

});

parcelRegister("9AAxU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("d2eTj").then(()=>parcelRequire('fYw7A'));

});

parcelRegister("fUMvo", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("l1bMV").then(()=>parcelRequire('6b4Xr'));

});

parcelRegister("bUaYJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kRbFj").then(()=>parcelRequire('98aOv'));

});

parcelRegister("74QoL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8R0Uw").then(()=>parcelRequire('d4C84'));

});

parcelRegister("eZ0B3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cVUuJ").then(()=>parcelRequire('6fCl5'));

});

parcelRegister("c0UF0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3roEx").then(()=>parcelRequire('eDFE1'));

});

parcelRegister("2csxX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bj9Pe").then(()=>parcelRequire('7icpf'));

});

parcelRegister("aWqb3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9X2cH").then(()=>parcelRequire('1hBh4'));

});

parcelRegister("fSODg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5VC0G").then(()=>parcelRequire('dlc8Q'));

});

parcelRegister("eEkBP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("d42tP").then(()=>parcelRequire('2VQWj'));

});

parcelRegister("hy4in", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cEFRt").then(()=>parcelRequire('8DQk2'));

});

parcelRegister("hvI7r", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aVzpn").then(()=>parcelRequire('2qdn3'));

});

parcelRegister("lbQ6h", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("8BrWs")
]).then(()=>parcelRequire('87LyQ'));

});

parcelRegister("a1Ii7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bXKJJ").then(()=>parcelRequire('3qmlA'));

});

parcelRegister("dOr8n", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hZ6ln").then(()=>parcelRequire('fHZfE'));

});

parcelRegister("7j8CX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jpgAW").then(()=>parcelRequire('jylD4'));

});

parcelRegister("goaJd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cjdCl").then(()=>parcelRequire('egKJ5'));

});

parcelRegister("3t1p5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jlw0L").then(()=>parcelRequire('5eNyq'));

});

parcelRegister("ifbiw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dSNy6").then(()=>parcelRequire('2KWgX'));

});

parcelRegister("k2lyS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("45DRC").then(()=>parcelRequire('gXTNd'));

});

parcelRegister("dwPOW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7YSlr").then(()=>parcelRequire('9gt51'));

});

parcelRegister("i4OnP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7GLMy").then(()=>parcelRequire('6ZlQ1'));

});

parcelRegister("8c3RE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hzTu5").then(()=>parcelRequire('7sFFK'));

});

parcelRegister("iDVAO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2lr6E").then(()=>parcelRequire('dKoa0'));

});

parcelRegister("4zOxa", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7SdSK").then(()=>parcelRequire('i8jzO'));

});

parcelRegister("f57U1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dmT44").then(()=>parcelRequire('a8ipI'));

});

parcelRegister("8cC1A", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6VUG6").then(()=>parcelRequire('2GFfB'));

});

parcelRegister("kM7J9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2pDH6").then(()=>parcelRequire('3JhWg'));

});

parcelRegister("jz8fZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lQwQZ").then(()=>parcelRequire('aMdh8'));

});

parcelRegister("5nwfo", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4Ytwp").then(()=>parcelRequire('iO13U'));

});

parcelRegister("h6J7e", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("dYlaM")
]).then(()=>parcelRequire('aCQLt'));

});

parcelRegister("lnNW6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("duiw3").then(()=>parcelRequire('9hb7e'));

});

parcelRegister("kQKK8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ccmKf").then(()=>parcelRequire('lmMkH'));

});

parcelRegister("9WUfm", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jhTnu").then(()=>parcelRequire('1FRaK'));

});

parcelRegister("fm7rO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iwo4w").then(()=>parcelRequire('2TWCz'));

});

parcelRegister("1ra7p", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5gyXd").then(()=>parcelRequire('agp1B'));

});

parcelRegister("hMpZ8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::77421a4093efbe74a1bbe8da5d5c5bff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cf1b13700915d1ca$var$_react = $cf1b13700915d1ca$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $cf1b13700915d1ca$var$_peopleGroup = $cf1b13700915d1ca$var$_interopRequireDefault((parcelRequire("hxN6p")));

var $cf1b13700915d1ca$var$_people = $cf1b13700915d1ca$var$_interopRequireDefault((parcelRequire("9HVF4")));
function $cf1b13700915d1ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PeopleGroupIcon.
 * This component is PeopleGroupIcon, with `UNSAFE_fallbackIcon` set to "PeopleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cf1b13700915d1ca$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $cf1b13700915d1ca$var$_react.default.createElement($cf1b13700915d1ca$var$_peopleGroup.default, Object.assign({
        name: "PeopleGroupIcon",
        LEGACY_fallbackIcon: $cf1b13700915d1ca$var$_people.default
    }, props));
$cf1b13700915d1ca$var$PeopleGroupIcon.displayName = 'PeopleGroupIconMigration';
var $cf1b13700915d1ca$var$_default = module.exports.default = $cf1b13700915d1ca$var$PeopleGroupIcon;

});

parcelRegister("5KWT5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("kA1cX")
]).then(()=>parcelRequire('izhQH'));

});

parcelRegister("kCr1v", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ivP0X").then(()=>parcelRequire('kJL32'));

});

parcelRegister("20wts", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("78zGn").then(()=>parcelRequire('7skWy'));

});

parcelRegister("cH3kb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("gLziw")
]).then(()=>parcelRequire('lrD2G'));

});

parcelRegister("aZtZY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gBVkE").then(()=>parcelRequire('4x9d9'));

});

parcelRegister("lRjs5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7ZGuC").then(()=>parcelRequire('a2cJp'));

});

parcelRegister("c0Po1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("28LiP").then(()=>parcelRequire('1qaHq'));

});

parcelRegister("1kLuM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("8tI7B")
]).then(()=>parcelRequire('defwj'));

});

parcelRegister("bq6e8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8vQPi").then(()=>parcelRequire('B2dH6'));

});

parcelRegister("6uBW0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("luCgO").then(()=>parcelRequire('lGDQJ'));

});

parcelRegister("eq0qn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eJyBR").then(()=>parcelRequire('jG5dJ'));

});

parcelRegister("f9zfW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gsf2D").then(()=>parcelRequire('iFgsP'));

});

parcelRegister("6aKac", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d0234a675d9b1e030b7622cea0db1767>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $47e77c5f4a34a646$var$_react = $47e77c5f4a34a646$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $47e77c5f4a34a646$var$_release = $47e77c5f4a34a646$var$_interopRequireDefault((parcelRequire("8Hdu4")));

var $47e77c5f4a34a646$var$_ship = $47e77c5f4a34a646$var$_interopRequireDefault((parcelRequire("01opv")));
function $47e77c5f4a34a646$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ReleaseIcon.
 * This component is ReleaseIcon, with `UNSAFE_fallbackIcon` set to "ShipIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $47e77c5f4a34a646$var$ReleaseIcon = (props)=>/*#__PURE__*/ $47e77c5f4a34a646$var$_react.default.createElement($47e77c5f4a34a646$var$_release.default, Object.assign({
        name: "ReleaseIcon",
        LEGACY_fallbackIcon: $47e77c5f4a34a646$var$_ship.default
    }, props));
$47e77c5f4a34a646$var$ReleaseIcon.displayName = 'ReleaseIconMigration';
var $47e77c5f4a34a646$var$_default = module.exports.default = $47e77c5f4a34a646$var$ReleaseIcon;

});
parcelRegister("8Hdu4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b5b008ccfed50bccf7a8bb78b89f8a48>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $654ccc84bbbfd6ed$var$_react = $654ccc84bbbfd6ed$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $654ccc84bbbfd6ed$var$_baseNew = $654ccc84bbbfd6ed$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $654ccc84bbbfd6ed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $654ccc84bbbfd6ed$var$ReleaseIcon = (props)=>/*#__PURE__*/ $654ccc84bbbfd6ed$var$_react.default.createElement($654ccc84bbbfd6ed$var$_baseNew.default, Object.assign({
        name: "ReleaseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2h3v2h2a.75.75 0 0 1 .648.372L11.18 7h4.069a.75.75 0 0 1 .646 1.132l-2.887 4.886a2 2 0 0 1-1.722.982H2a2 2 0 0 1-2-2V7.75A.75.75 0 0 1 .75 7H2V4.75A.75.75 0 0 1 2.75 4H4zm-.5 5h5.944L8.57 5.5H3.5zm-2 1.5V12a.5.5 0 0 0 .5.5h9.287a.5.5 0 0 0 .43-.246L13.936 8.5z" clip-rule="evenodd"/>`
    }, props));
$654ccc84bbbfd6ed$var$ReleaseIcon.displayName = 'ReleaseIcon';
var $654ccc84bbbfd6ed$var$_default = module.exports.default = $654ccc84bbbfd6ed$var$ReleaseIcon;

});


parcelRegister("j11z9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("gAWT7")
]).then(()=>parcelRequire('aHC81'));

});

parcelRegister("ijNsw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("3tvaB")
]).then(()=>parcelRequire('5CESm'));

});

parcelRegister("i1Kbr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8cG9a").then(()=>parcelRequire('1zDn7'));

});

parcelRegister("knSWj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("fV6N4")
]).then(()=>parcelRequire('4qcOB'));

});

parcelRegister("7COM9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("gTkz8")
]).then(()=>parcelRequire('jzA8h'));

});

parcelRegister("93JYU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kzCMD").then(()=>parcelRequire('kmi1F'));

});

parcelRegister("caQPU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eeNjU").then(()=>parcelRequire('1AHuQ'));

});

parcelRegister("4xIzF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ggiaN").then(()=>parcelRequire('6DxKg'));

});

parcelRegister("i9rrJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6IRvr").then(()=>parcelRequire('bvgV2'));

});

parcelRegister("6nAdm", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lHxnr").then(()=>parcelRequire('ihebN'));

});

parcelRegister("2qYu0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1SzkV").then(()=>parcelRequire('59s8T'));

});

parcelRegister("blDxg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kH7y9").then(()=>parcelRequire('75eaP'));

});

parcelRegister("3DgPs", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dbeOd").then(()=>parcelRequire('cis96'));

});

parcelRegister("2ptCg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dcWuM").then(()=>parcelRequire('3Vx3n'));

});

parcelRegister("bFDet", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gNH7X").then(()=>parcelRequire('bhsA0'));

});

parcelRegister("jGFOv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ajouS").then(()=>parcelRequire('2PadD'));

});

parcelRegister("13DeQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2wFoP").then(()=>parcelRequire('cs9Eu'));

});

parcelRegister("8jM8E", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4IxSb").then(()=>parcelRequire('1Marh'));

});

parcelRegister("f7cbC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2gdIM").then(()=>parcelRequire('ki8JG'));

});

parcelRegister("9vaR1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2WNCJ").then(()=>parcelRequire('7cId8'));

});

parcelRegister("ql0b6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("b0WL4").then(()=>parcelRequire('lvv6C'));

});

parcelRegister("5jVIj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4Zc8l").then(()=>parcelRequire('49lxd'));

});

parcelRegister("3pfZY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4SzJh").then(()=>parcelRequire('eBrft'));

});

parcelRegister("ewH8i", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1oWbP").then(()=>parcelRequire('iPUaD'));

});

parcelRegister("gYRNJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("39oCw").then(()=>parcelRequire('lDBvf'));

});

parcelRegister("aM3HT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4Meta").then(()=>parcelRequire('40Zwe'));

});

parcelRegister("bBFOh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gzS8W").then(()=>parcelRequire('5j1R8'));

});

parcelRegister("1fSDl", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9944g").then(()=>parcelRequire('kqRsv'));

});

parcelRegister("koFqW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8zrOr").then(()=>parcelRequire('dtTJ9'));

});

parcelRegister("gVcrU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("5apdb")
]).then(()=>parcelRequire('amvLf'));

});

parcelRegister("7ltfp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("kUoVo")
]).then(()=>parcelRequire('imc5x'));

});

parcelRegister("57691", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6FUNd").then(()=>parcelRequire('jQjGM'));

});

parcelRegister("9GAG6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("iL76j")
]).then(()=>parcelRequire('iz6z2'));

});

parcelRegister("jTIpD", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fSuue").then(()=>parcelRequire('3ZjSN'));

});

parcelRegister("kcxeo", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6wP54").then(()=>parcelRequire('bcitO'));

});

parcelRegister("bAVbi", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7eKSC").then(()=>parcelRequire('eHAfU'));

});

parcelRegister("bCsrc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gKXx1").then(()=>parcelRequire('4KX56'));

});

parcelRegister("l31B4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lqrxi").then(()=>parcelRequire('gqCTt'));

});

parcelRegister("2zt8F", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kB78Y").then(()=>parcelRequire('azIHD'));

});

parcelRegister("iF0J3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jhhI3").then(()=>parcelRequire('aFAJl'));

});

parcelRegister("3GKOL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e82594be434237a3254dda0015850bff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2af99c62070f9b2c$var$_react = $2af99c62070f9b2c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $2af99c62070f9b2c$var$_calendar = $2af99c62070f9b2c$var$_interopRequireDefault((parcelRequire("btkTq")));

var $2af99c62070f9b2c$var$_calendar2 = $2af99c62070f9b2c$var$_interopRequireDefault((parcelRequire("76JV8")));
function $2af99c62070f9b2c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CalendarIcon.
 * This component is CalendarIcon, with `UNSAFE_fallbackIcon` set to "CalendarIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2af99c62070f9b2c$var$CalendarIcon = (props)=>/*#__PURE__*/ $2af99c62070f9b2c$var$_react.default.createElement($2af99c62070f9b2c$var$_calendar.default, Object.assign({
        name: "CalendarIcon",
        LEGACY_fallbackIcon: $2af99c62070f9b2c$var$_calendar2.default
    }, props));
$2af99c62070f9b2c$var$CalendarIcon.displayName = 'CalendarIconMigration';
var $2af99c62070f9b2c$var$_default = module.exports.default = $2af99c62070f9b2c$var$CalendarIcon;

});
parcelRegister("btkTq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c44ca3af5d99d99573761123bc1c1f79>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $85a29c08b1b7d658$var$_react = $85a29c08b1b7d658$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $85a29c08b1b7d658$var$_baseNew = $85a29c08b1b7d658$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $85a29c08b1b7d658$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $85a29c08b1b7d658$var$CalendarIcon = (props)=>/*#__PURE__*/ $85a29c08b1b7d658$var$_react.default.createElement($85a29c08b1b7d658$var$_baseNew.default, Object.assign({
        name: "CalendarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$85a29c08b1b7d658$var$CalendarIcon.displayName = 'CalendarIcon';
var $85a29c08b1b7d658$var$_default = module.exports.default = $85a29c08b1b7d658$var$CalendarIcon;

});


parcelRegister("gobwF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("Qovwm").then(()=>parcelRequire('4oIfN'));

});

parcelRegister("bRygf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cKc5B").then(()=>parcelRequire('awyal'));

});

parcelRegister("iLv67", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("86bl6").then(()=>parcelRequire('hlJ0R'));

});

parcelRegister("6Mor3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hrv5W").then(()=>parcelRequire('5Z6td'));

});

parcelRegister("7gCMb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("erj8t").then(()=>parcelRequire('amxqt'));

});

parcelRegister("bNgFX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8ug3B").then(()=>parcelRequire('8BBLJ'));

});

parcelRegister("4TA31", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c375ed2b41c84b45c85c51ed117e320a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $390842c9527311f0$var$_react = $390842c9527311f0$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $390842c9527311f0$var$_copy = $390842c9527311f0$var$_interopRequireDefault((parcelRequire("lGr6J")));

var $390842c9527311f0$var$_copy2 = $390842c9527311f0$var$_interopRequireDefault((parcelRequire("hZKKB")));
function $390842c9527311f0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CopyIcon.
 * This component is CopyIcon, with `UNSAFE_fallbackIcon` set to "CopyIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $390842c9527311f0$var$CopyIcon = (props)=>/*#__PURE__*/ $390842c9527311f0$var$_react.default.createElement($390842c9527311f0$var$_copy.default, Object.assign({
        name: "CopyIcon",
        LEGACY_fallbackIcon: $390842c9527311f0$var$_copy2.default
    }, props));
$390842c9527311f0$var$CopyIcon.displayName = 'CopyIconMigration';
var $390842c9527311f0$var$_default = module.exports.default = $390842c9527311f0$var$CopyIcon;

});

parcelRegister("5SqcI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("aZrBF")
]).then(()=>parcelRequire('gi31n'));

});

parcelRegister("8i49k", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6Vxrf").then(()=>parcelRequire('iLOb4'));

});

parcelRegister("fdlP3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1AK05").then(()=>parcelRequire('gg3ZI'));

});

parcelRegister("lvAjg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fxgls").then(()=>parcelRequire('kHcBe'));

});

parcelRegister("eoryE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2kJ7W").then(()=>parcelRequire('bp0jd'));

});

parcelRegister("dNLHm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5776dc85eb34bd4bbf9313d62b1b5459>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a0c4d9df726ba45c$var$_react = $a0c4d9df726ba45c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a0c4d9df726ba45c$var$_email = $a0c4d9df726ba45c$var$_interopRequireDefault((parcelRequire("hluWa")));

var $a0c4d9df726ba45c$var$_email2 = $a0c4d9df726ba45c$var$_interopRequireDefault((parcelRequire("4ZN93")));
function $a0c4d9df726ba45c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EmailIcon.
 * This component is EmailIcon, with `UNSAFE_fallbackIcon` set to "EmailIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a0c4d9df726ba45c$var$EmailIcon = (props)=>/*#__PURE__*/ $a0c4d9df726ba45c$var$_react.default.createElement($a0c4d9df726ba45c$var$_email.default, Object.assign({
        name: "EmailIcon",
        LEGACY_fallbackIcon: $a0c4d9df726ba45c$var$_email2.default
    }, props));
$a0c4d9df726ba45c$var$EmailIcon.displayName = 'EmailIconMigration';
var $a0c4d9df726ba45c$var$_default = module.exports.default = $a0c4d9df726ba45c$var$EmailIcon;

});
parcelRegister("hluWa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11cac724462839f30810a0cf708cc3d1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca0c654a3a0a1b61$var$_react = $ca0c654a3a0a1b61$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $ca0c654a3a0a1b61$var$_baseNew = $ca0c654a3a0a1b61$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $ca0c654a3a0a1b61$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Email".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ca0c654a3a0a1b61$var$EmailIcon = (props)=>/*#__PURE__*/ $ca0c654a3a0a1b61$var$_react.default.createElement($ca0c654a3a0a1b61$var$_baseNew.default, Object.assign({
        name: "EmailIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v.529L8 8.128l6.5-3.6V4a.5.5 0 0 0-.5-.5zm12.5 2.743L8.363 9.641a.75.75 0 0 1-.726 0L1.5 6.243V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$ca0c654a3a0a1b61$var$EmailIcon.displayName = 'EmailIcon';
var $ca0c654a3a0a1b61$var$_default = module.exports.default = $ca0c654a3a0a1b61$var$EmailIcon;

});


parcelRegister("ak3RO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4kRJz").then(()=>parcelRequire('6VVS2'));

});

parcelRegister("dTTrA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8fpDH").then(()=>parcelRequire('aGMxL'));

});

parcelRegister("5i9TT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("f4Vi6").then(()=>parcelRequire('gvSye'));

});

parcelRegister("emKLF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hOvDm").then(()=>parcelRequire('l8WCu'));

});

parcelRegister("3J6JV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("9Kldc")
]).then(()=>parcelRequire('ek0LL'));

});

parcelRegister("byjTw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1A7FL").then(()=>parcelRequire('daaVW'));

});

parcelRegister("7Yo89", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("19dZT").then(()=>parcelRequire('gxfVm'));

});

parcelRegister("jl0Ps", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("91z3t").then(()=>parcelRequire('52fcO'));

});

parcelRegister("bgfFr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("klfge")
]).then(()=>parcelRequire('a9ULj'));

});

parcelRegister("lwlJv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ayZeo").then(()=>parcelRequire('63OXZ'));

});

parcelRegister("qJT5V", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hiDUx").then(()=>parcelRequire('1zDxH'));

});

parcelRegister("jkJMa", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fsreA").then(()=>parcelRequire('9YdD8'));

});

parcelRegister("7ADVe", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("lqB6V")
]).then(()=>parcelRequire('jZAJQ'));

});

parcelRegister("fJX1L", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("725ea").then(()=>parcelRequire('rZPcB'));

});

parcelRegister("5Is7s", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4K0PB").then(()=>parcelRequire('cdYRp'));

});

parcelRegister("io0aX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("7qc7K")
]).then(()=>parcelRequire('lG2jM'));

});

parcelRegister("58frP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29971dcd1e1cc09403d75aea4f4ed622>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3bc9aebef14ae896$var$_react = $3bc9aebef14ae896$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $3bc9aebef14ae896$var$_person = $3bc9aebef14ae896$var$_interopRequireDefault((parcelRequire("gm7H7")));

var $3bc9aebef14ae896$var$_person2 = $3bc9aebef14ae896$var$_interopRequireDefault((parcelRequire("6NCZy")));
function $3bc9aebef14ae896$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PersonIcon.
 * This component is PersonIcon, with `UNSAFE_fallbackIcon` set to "PersonIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3bc9aebef14ae896$var$PersonIcon = (props)=>/*#__PURE__*/ $3bc9aebef14ae896$var$_react.default.createElement($3bc9aebef14ae896$var$_person.default, Object.assign({
        name: "PersonIcon",
        LEGACY_fallbackIcon: $3bc9aebef14ae896$var$_person2.default
    }, props));
$3bc9aebef14ae896$var$PersonIcon.displayName = 'PersonIconMigration';
var $3bc9aebef14ae896$var$_default = module.exports.default = $3bc9aebef14ae896$var$PersonIcon;

});

parcelRegister("hoj28", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hkNE9").then(()=>parcelRequire('kMmgw'));

});

parcelRegister("ivwel", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kERrK").then(()=>parcelRequire('f3diu'));

});

parcelRegister("7q4qN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("g8BpB").then(()=>parcelRequire('i78b1'));

});

parcelRegister("cFkFw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3OPjU").then(()=>parcelRequire('8vLL9'));

});

parcelRegister("3Yp75", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("bEDzq")
]).then(()=>parcelRequire('2gsxL'));

});

parcelRegister("24GzU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kQ83D").then(()=>parcelRequire('b5HUz'));

});

parcelRegister("aHSIv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lvJ5n").then(()=>parcelRequire('fRHBu'));

});

parcelRegister("76Tlk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("g5ujc").then(()=>parcelRequire('dAv2D'));

});

parcelRegister("lCsqX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("goesq").then(()=>parcelRequire('hIRsw'));

});

parcelRegister("fZ6Im", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7Djx5").then(()=>parcelRequire('76mtb'));

});

parcelRegister("brHgq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("76xTz").then(()=>parcelRequire('3Y0kU'));

});

parcelRegister("5TzfM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("es1jB")
]).then(()=>parcelRequire('fwfzA'));

});

parcelRegister("jcrgp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ipkGz").then(()=>parcelRequire('6Sw2l'));

});

parcelRegister("dFoE7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("906hH").then(()=>parcelRequire('7SEhj'));

});

parcelRegister("fIzTE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e079be55658218810235742dfafa5bd4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b716cf63542993f9$var$_react = $b716cf63542993f9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $b716cf63542993f9$var$_baseNew = $b716cf63542993f9$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $b716cf63542993f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiAgent".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Rovo Agent.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b716cf63542993f9$var$AiAgentIcon = (props)=>/*#__PURE__*/ $b716cf63542993f9$var$_react.default.createElement($b716cf63542993f9$var$_baseNew.default, Object.assign({
        name: "AiAgentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.971.493a2 2 0 0 1 2.058 0l5 3A2 2 0 0 1 15 5.208v5.584a2 2 0 0 1-.971 1.715l-5 3a2 2 0 0 1-2.058 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .971-1.715zm1.286 1.286a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.429v5.584a.5.5 0 0 0 .243.429l1.098.66a4.25 4.25 0 1 1 8.318 0l1.098-.66a.5.5 0 0 0 .243-.429V5.208a.5.5 0 0 0-.243-.429zM8 8.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5" clip-rule="evenodd"/>`
    }, props));
$b716cf63542993f9$var$AiAgentIcon.displayName = 'AiAgentIcon';
var $b716cf63542993f9$var$_default = module.exports.default = $b716cf63542993f9$var$AiAgentIcon;

});

parcelRegister("72yLJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cgB5I").then(()=>parcelRequire('lWfml'));

});

parcelRegister("3sVgy", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cN3OU").then(()=>parcelRequire('8qRZP'));

});

parcelRegister("5NsuV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aTh4P").then(()=>parcelRequire('5FM0W'));

});

parcelRegister("5vxCv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8wxFC").then(()=>parcelRequire('1H3iv'));

});

parcelRegister("eAlde", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7ILTE").then(()=>parcelRequire('4Iuny'));

});

parcelRegister("azUmM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5mEoX").then(()=>parcelRequire('8JqPQ'));

});

parcelRegister("2ia8C", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fNsQj").then(()=>parcelRequire('lJX99'));

});

parcelRegister("cmP4Y", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("Ure5z").then(()=>parcelRequire('bpdtz'));

});

parcelRegister("25CF1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("MdYDm").then(()=>parcelRequire('dkMBa'));

});

parcelRegister("3l5q4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hyC1C").then(()=>parcelRequire('1SQvU'));

});

parcelRegister("8S3mW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hAzu1").then(()=>parcelRequire('2BtXU'));

});

parcelRegister("4YZhp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("faq1h").then(()=>parcelRequire('6ozsI'));

});

parcelRegister("2lLxx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("clPXM").then(()=>parcelRequire('96yzA'));

});

parcelRegister("ej3Uw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8tOAE").then(()=>parcelRequire('evLPK'));

});

parcelRegister("3hRwe", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8jh2d").then(()=>parcelRequire('hv4be'));

});

parcelRegister("gFfel", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fdvHb").then(()=>parcelRequire('ac080'));

});

parcelRegister("ekU6o", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("90TNn").then(()=>parcelRequire('6w1sx'));

});

parcelRegister("92Yni", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hZIiZ").then(()=>parcelRequire('fOqNz'));

});

parcelRegister("3uwVP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ky9Yp").then(()=>parcelRequire('dtpha'));

});

parcelRegister("e7ivW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4GNBO").then(()=>parcelRequire('f2AGc'));

});

parcelRegister("4Il1t", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("acuGh").then(()=>parcelRequire('iPYeg'));

});

parcelRegister("6YFrd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7ZbXZ").then(()=>parcelRequire('fsFOy'));

});

parcelRegister("18VJY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eibZO").then(()=>parcelRequire('1EAp9'));

});

parcelRegister("3xKip", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7lEZ8").then(()=>parcelRequire('awZZu'));

});

parcelRegister("2c1v1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4kdj2").then(()=>parcelRequire('jUPb8'));

});

parcelRegister("9UdpB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b1c065f0aa91b3c3f089345b7ec72ae8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7363bf5e9aa00467$var$_react = $7363bf5e9aa00467$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7363bf5e9aa00467$var$_baseNew = $7363bf5e9aa00467$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $7363bf5e9aa00467$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Bug".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Request types in JSM, bugs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7363bf5e9aa00467$var$BugIcon = (props)=>/*#__PURE__*/ $7363bf5e9aa00467$var$_react.default.createElement($7363bf5e9aa00467$var$_baseNew.default, Object.assign({
        name: "BugIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 2.5A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 8 2.5m3 1.52V4a3 3 0 0 0-6 0v.02c-.29.05-.553.182-.761.372l-.887-.633-.917-2.064-1.37.61.944 2.125c.09.204.234.38.416.51l1.325.946V7H.5v1.5h3.25v1.149l-1.15.958a1.25 1.25 0 0 0-.318.401L1.08 13.415l1.342.67 1.18-2.36.46-.383A4.25 4.25 0 0 0 8.001 14h.249A4 4 0 0 0 12 11.393l.4.333 1.18 2.36 1.34-.671-1.202-2.407a1.25 1.25 0 0 0-.318-.401l-1.15-.958V8.5h3.25V7h-3.25V5.886l1.325-.946a1.25 1.25 0 0 0 .416-.51l.944-2.125-1.37-.61-.917 2.064-.887.633A1.5 1.5 0 0 0 11 4.02M10.75 10V5.5h-5.5v4.443l.035.226A2.75 2.75 0 0 0 8 12.5h.249a2.5 2.5 0 0 0 2.5-2.5" clip-rule="evenodd"/>`
    }, props));
$7363bf5e9aa00467$var$BugIcon.displayName = 'BugIcon';
var $7363bf5e9aa00467$var$_default = module.exports.default = $7363bf5e9aa00467$var$BugIcon;

});

parcelRegister("kS4C1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aBU6D").then(()=>parcelRequire('iizuB'));

});

parcelRegister("jO5w2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9Bq7k").then(()=>parcelRequire('9t7Dt'));

});

parcelRegister("2P4zU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("31iUf").then(()=>parcelRequire('1gGyY'));

});

parcelRegister("53IqS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9Bsq4").then(()=>parcelRequire('fMkOJ'));

});

parcelRegister("bRZvq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eZGmx").then(()=>parcelRequire('4aDUk'));

});

parcelRegister("g8Hx0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("baIA4").then(()=>parcelRequire('amDP4'));

});

parcelRegister("i7DNi", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("l3Pfy").then(()=>parcelRequire('au7ul'));

});

parcelRegister("ktUn4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ithp8").then(()=>parcelRequire('5NTKt'));

});

parcelRegister("5bCK6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6TKas").then(()=>parcelRequire('gnNZR'));

});

parcelRegister("94SLH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kf69x").then(()=>parcelRequire('i2pAY'));

});

parcelRegister("hYNq0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lcqzB").then(()=>parcelRequire('8Y00B'));

});

parcelRegister("5vOnP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("a44ce").then(()=>parcelRequire('3srOK'));

});

parcelRegister("7HRst", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kvzBD").then(()=>parcelRequire('5Qre5'));

});

parcelRegister("5NY7E", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jUe6N").then(()=>parcelRequire('hagIH'));

});

parcelRegister("dmteF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lDkFF").then(()=>parcelRequire('lsTfm'));

});

parcelRegister("ld0cd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a1ef6001ab87a1d8d52e3fa36b1ca44>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f70af6cd1d0cef8e$var$_react = $f70af6cd1d0cef8e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f70af6cd1d0cef8e$var$_baseNew = $f70af6cd1d0cef8e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $f70af6cd1d0cef8e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Navigate to previous year in calendar/date picker
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f70af6cd1d0cef8e$var$ChevronDoubleLeftIcon = (props)=>/*#__PURE__*/ $f70af6cd1d0cef8e$var$_react.default.createElement($f70af6cd1d0cef8e$var$_baseNew.default, Object.assign({
        name: "ChevronDoubleLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m7.72 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L3.31 8l5.47-5.47z"/><path fill="currentcolor" d="m12.47 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L8.06 8l5.47-5.47z"/>`
    }, props));
$f70af6cd1d0cef8e$var$ChevronDoubleLeftIcon.displayName = 'ChevronDoubleLeftIcon';
var $f70af6cd1d0cef8e$var$_default = module.exports.default = $f70af6cd1d0cef8e$var$ChevronDoubleLeftIcon;

});

parcelRegister("cqfIR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5b4e628ea814f393cf264d604c04f2e9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $90b41be71667434a$var$_react = $90b41be71667434a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $90b41be71667434a$var$_baseNew = $90b41be71667434a$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $90b41be71667434a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Navigate to next year in calendar/date picker
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $90b41be71667434a$var$ChevronDoubleRightIcon = (props)=>/*#__PURE__*/ $90b41be71667434a$var$_react.default.createElement($90b41be71667434a$var$_baseNew.default, Object.assign({
        name: "ChevronDoubleRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m8.28 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L12.69 8 7.22 2.53z"/><path fill="currentcolor" d="m3.53 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L7.94 8 2.47 2.53z"/>`
    }, props));
$90b41be71667434a$var$ChevronDoubleRightIcon.displayName = 'ChevronDoubleRightIcon';
var $90b41be71667434a$var$_default = module.exports.default = $90b41be71667434a$var$ChevronDoubleRightIcon;

});

parcelRegister("2WVd3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("34mYp").then(()=>parcelRequire('4V9Yp'));

});

parcelRegister("7xht2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2jNTG").then(()=>parcelRequire('2NCJ7'));

});

parcelRegister("6snMl", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5P99A").then(()=>parcelRequire('l0U1U'));

});

parcelRegister("bzGVj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c02a973e1b80a41efb48b80326ffc315>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $86d44242ca1c7b8f$var$_react = $86d44242ca1c7b8f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $86d44242ca1c7b8f$var$_baseNew = $86d44242ca1c7b8f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $86d44242ca1c7b8f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CloudArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $86d44242ca1c7b8f$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $86d44242ca1c7b8f$var$_react.default.createElement($86d44242ca1c7b8f$var$_baseNew.default, Object.assign({
        name: "CloudArrowUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3a4.25 4.25 0 0 0-4.236 3.9.75.75 0 0 1-.565.668A2.251 2.251 0 0 0 3.75 12v1.5a3.75 3.75 0 0 1-1.418-7.222 5.751 5.751 0 0 1 11.239-.458A4 4 0 0 1 12 13.5V12a2.5 2.5 0 0 0 .712-4.897.75.75 0 0 1-.526-.59A4.25 4.25 0 0 0 8 3m0 4a.75.75 0 0 1 .53.22l3 3-1.06 1.06-1.72-1.72V16h-1.5V9.56l-1.72 1.72-1.06-1.06 3-3A.75.75 0 0 1 8 7" clip-rule="evenodd"/>`
    }, props));
$86d44242ca1c7b8f$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $86d44242ca1c7b8f$var$_default = module.exports.default = $86d44242ca1c7b8f$var$CloudArrowUpIcon;

});

parcelRegister("vYMR3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("x6CsX").then(()=>parcelRequire('jeFtr'));

});

parcelRegister("7P955", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cYNNT").then(()=>parcelRequire('e0Jak'));

});

parcelRegister("ee846", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("vgynd").then(()=>parcelRequire('G1EII'));

});

parcelRegister("lolnG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gzyRY").then(()=>parcelRequire('7XCnf'));

});

parcelRegister("h6eqv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4a4w6").then(()=>parcelRequire('hotVs'));

});

parcelRegister("2EfT6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("b8lCq").then(()=>parcelRequire('4Ltua'));

});

parcelRegister("4cEb8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7bjy1").then(()=>parcelRequire('dweXS'));

});

parcelRegister("ivSas", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ed4wU").then(()=>parcelRequire('2WniS'));

});

parcelRegister("2OD8g", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("biCSR").then(()=>parcelRequire('fgmtQ'));

});

parcelRegister("gJInV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1R8yl").then(()=>parcelRequire('ahwW5'));

});

parcelRegister("lSkUO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8Kt5b").then(()=>parcelRequire('iiRWr'));

});

parcelRegister("ll6L6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fEVep").then(()=>parcelRequire('5eLqg'));

});

parcelRegister("5aelq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bPvEf").then(()=>parcelRequire('bAn7e'));

});

parcelRegister("aOBfL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2KYlV").then(()=>parcelRequire('l3U2S'));

});

parcelRegister("4a0NG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gyQbS").then(()=>parcelRequire('lWB0f'));

});

parcelRegister("cOINl", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ld9Uk").then(()=>parcelRequire('VgyAW'));

});

parcelRegister("4MicW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f8e09626672d9215bf80d7cf3a8d93a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $37a9c4cf545b6d17$var$_react = $37a9c4cf545b6d17$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $37a9c4cf545b6d17$var$_baseNew = $37a9c4cf545b6d17$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $37a9c4cf545b6d17$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Delete".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing or deleting an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $37a9c4cf545b6d17$var$DeleteIcon = (props)=>/*#__PURE__*/ $37a9c4cf545b6d17$var$_react.default.createElement($37a9c4cf545b6d17$var$_baseNew.default, Object.assign({
        name: "DeleteIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 .75A.75.75 0 0 1 5.75 0h4.5a.75.75 0 0 1 .75.75V2.5h3.5V4h-1v10a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2V4h-1V2.5H5zM6.5 2.5h3v-1h-3zM4 4v10a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V4zm1.75 9V5.5h1.5V13zm3 0V5.5h1.5V13z" clip-rule="evenodd"/>`
    }, props));
$37a9c4cf545b6d17$var$DeleteIcon.displayName = 'DeleteIcon';
var $37a9c4cf545b6d17$var$_default = module.exports.default = $37a9c4cf545b6d17$var$DeleteIcon;

});

parcelRegister("DpqSH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cGMiU").then(()=>parcelRequire('gbo8S'));

});

parcelRegister("clES7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("knuQ3").then(()=>parcelRequire('8m4Cb'));

});

parcelRegister("kj6su", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bwQik").then(()=>parcelRequire('guSrZ'));

});

parcelRegister("7S0RQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("epgGV").then(()=>parcelRequire('5k2HF'));

});

parcelRegister("bpxdm", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("en17r").then(()=>parcelRequire('lx41M'));

});

parcelRegister("cyMDk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("69bE8").then(()=>parcelRequire('1BjZZ'));

});

parcelRegister("b10Fx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jybPN").then(()=>parcelRequire('ggW8r'));

});

parcelRegister("f8Bbt", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("62DUC").then(()=>parcelRequire('f0uWG'));

});

parcelRegister("ch3nR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("g7amP").then(()=>parcelRequire('gtN4u'));

});

parcelRegister("e0rn7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4VYQ6").then(()=>parcelRequire('gmJHq'));

});

parcelRegister("eXZKn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("Vmmy2").then(()=>parcelRequire('cc5Qv'));

});

parcelRegister("5vAba", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6ZJGz").then(()=>parcelRequire('1eEyb'));

});

parcelRegister("9XoIE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kFVzK").then(()=>parcelRequire('bkdrw'));

});

parcelRegister("fSqGE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("d7f2X").then(()=>parcelRequire('1VZsk'));

});

parcelRegister("3x0Es", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dt38J").then(()=>parcelRequire('55RJF'));

});

parcelRegister("l3OR5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("16BzS").then(()=>parcelRequire('8wQna'));

});

parcelRegister("e8P7t", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5Co4e").then(()=>parcelRequire('fRjRq'));

});

parcelRegister("8MkTS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7Rr5F").then(()=>parcelRequire('jEjtf'));

});

parcelRegister("5rCYm", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dCivC").then(()=>parcelRequire('8bN1h'));

});

parcelRegister("3k0fI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("63WWP").then(()=>parcelRequire('50VmZ'));

});

parcelRegister("es3zL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bOjyK").then(()=>parcelRequire('3jEPG'));

});

parcelRegister("4J6au", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7LvcJ").then(()=>parcelRequire('3VtMs'));

});

parcelRegister("4vCYu", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5TK3U").then(()=>parcelRequire('55ZrE'));

});

parcelRegister("72VHl", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("63tx1").then(()=>parcelRequire('bWYJ2'));

});

parcelRegister("8HVJW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4dUEB").then(()=>parcelRequire('kipwF'));

});

parcelRegister("hxYvX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3wLCJ").then(()=>parcelRequire('dCT0T'));

});

parcelRegister("l0PiJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eTIIn").then(()=>parcelRequire('ackQ5'));

});

parcelRegister("b7jVu", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("b7mki").then(()=>parcelRequire('8NrV4'));

});

parcelRegister("4WhMA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("b2U0l").then(()=>parcelRequire('ehWCo'));

});

parcelRegister("2L4Og", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5Zpch").then(()=>parcelRequire('db8Lu'));

});

parcelRegister("4RsDq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8y3F9").then(()=>parcelRequire('hDcr6'));

});

parcelRegister("1U4zO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17bb883bd3a73bc5f5c12f88ac81607a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $162e923fc261d827$var$_react = $162e923fc261d827$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $162e923fc261d827$var$_baseNew = $162e923fc261d827$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $162e923fc261d827$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Grid".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: spaces in Confluence, and grid view, all content in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $162e923fc261d827$var$GridIcon = (props)=>/*#__PURE__*/ $162e923fc261d827$var$_react.default.createElement($162e923fc261d827$var$_baseNew.default, Object.assign({
        name: "GridIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v4.25h4.75V2.5zm5.75 0v4.75h4.75V3a.5.5 0 0 0-.5-.5zm4.75 6.25H8.75v4.75H13a.5.5 0 0 0 .5-.5zM7.25 13.5V8.75H2.5V13a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$162e923fc261d827$var$GridIcon.displayName = 'GridIcon';
var $162e923fc261d827$var$_default = module.exports.default = $162e923fc261d827$var$GridIcon;

});

parcelRegister("hVmch", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("az3gU").then(()=>parcelRequire('XhTSt'));

});

parcelRegister("dsTkE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("a0NCx").then(()=>parcelRequire('2Vw4P'));

});

parcelRegister("g8La4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4fuEt").then(()=>parcelRequire('bhyNF'));

});

parcelRegister("djBJn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aB95y").then(()=>parcelRequire('5QzOg'));

});

parcelRegister("23SsX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lCNJg").then(()=>parcelRequire('6psOp'));

});

parcelRegister("b4uWa", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4ZBya").then(()=>parcelRequire('6EfBC'));

});

parcelRegister("fBzgw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6t2MT").then(()=>parcelRequire('7sYlT'));

});

parcelRegister("dZ7zL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("03ELB").then(()=>parcelRequire('lWy4q'));

});

parcelRegister("fX8MF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fHLos").then(()=>parcelRequire('6Ajhr'));

});

parcelRegister("yGfRR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dVMLi").then(()=>parcelRequire('foykc'));

});

parcelRegister("3ODIv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5BQO3").then(()=>parcelRequire('ljmsu'));

});

parcelRegister("aQ5Wv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("l0xvE").then(()=>parcelRequire('6eUFQ'));

});

parcelRegister("6BR9Q", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2379769942b452821345d3db8e1641c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4cff6ecfc53acec2$var$_react = $4cff6ecfc53acec2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4cff6ecfc53acec2$var$_baseNew = $4cff6ecfc53acec2$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $4cff6ecfc53acec2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "InformationCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: For highlighting information when less visual emphasis is needed within the UI compared to the filled information status icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4cff6ecfc53acec2$var$InformationCircleIcon = (props)=>/*#__PURE__*/ $4cff6ecfc53acec2$var$_react.default.createElement($4cff6ecfc53acec2$var$_baseNew.default, Object.assign({
        name: "InformationCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.25.25H6.5v-1.5H8a.75.75 0 0 1 .75.75v5h-1.5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$4cff6ecfc53acec2$var$InformationCircleIcon.displayName = 'InformationCircleIcon';
var $4cff6ecfc53acec2$var$_default = module.exports.default = $4cff6ecfc53acec2$var$InformationCircleIcon;

});

parcelRegister("hpeRC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2F0HM").then(()=>parcelRequire('9RMYL'));

});

parcelRegister("9UDiB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eU1VP").then(()=>parcelRequire('5BbQk'));

});

parcelRegister("9Nvwv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4cc30cca446ee2bc7bd4f679561c5adc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $72212488ee4829d1$var$_react = $72212488ee4829d1$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $72212488ee4829d1$var$_baseNew = $72212488ee4829d1$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $72212488ee4829d1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutThreeColumns".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 3 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $72212488ee4829d1$var$LayoutThreeColumnsIcon = (props)=>/*#__PURE__*/ $72212488ee4829d1$var$_react.default.createElement($72212488ee4829d1$var$_baseNew.default, Object.assign({
        name: "LayoutThreeColumnsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h1.5c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.5C.615 15 0 14.384 0 13.625zm1.5.125v11h1.25v-11zm4.25-.125C5.75 1.615 6.366 1 7.125 1h1.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.75c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h1.5v-11zm4.5-.125c0-.76.616-1.375 1.375-1.375h1.5C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.5c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h1.25v-11z" clip-rule="evenodd"/>`
    }, props));
$72212488ee4829d1$var$LayoutThreeColumnsIcon.displayName = 'LayoutThreeColumnsIcon';
var $72212488ee4829d1$var$_default = module.exports.default = $72212488ee4829d1$var$LayoutThreeColumnsIcon;

});

parcelRegister("AkBja", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bgQev").then(()=>parcelRequire('5abEo'));

});

parcelRegister("fkTM0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::41241beb7c997812002aebca60cfbf2e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b2a3fcb1778cfed1$var$_react = $b2a3fcb1778cfed1$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $b2a3fcb1778cfed1$var$_baseNew = $b2a3fcb1778cfed1$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $b2a3fcb1778cfed1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutTwoColumns".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 2 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b2a3fcb1778cfed1$var$LayoutTwoColumnsIcon = (props)=>/*#__PURE__*/ $b2a3fcb1778cfed1$var$_react.default.createElement($b2a3fcb1778cfed1$var$_baseNew.default, Object.assign({
        name: "LayoutTwoColumnsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h4.5c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-4.5C.615 15 0 14.384 0 13.625zm1.5.125v11h4.25v-11zm7.25-.125c0-.76.616-1.375 1.375-1.375h4.5C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-4.5c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h4.25v-11z" clip-rule="evenodd"/>`
    }, props));
$b2a3fcb1778cfed1$var$LayoutTwoColumnsIcon.displayName = 'LayoutTwoColumnsIcon';
var $b2a3fcb1778cfed1$var$_default = module.exports.default = $b2a3fcb1778cfed1$var$LayoutTwoColumnsIcon;

});

parcelRegister("1WBN4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6kLPy").then(()=>parcelRequire('9S9DZ'));

});

parcelRegister("8DYeg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1L20F").then(()=>parcelRequire('6FVgS'));

});

parcelRegister("2OfSL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1TOSZ").then(()=>parcelRequire('6qyXs'));

});

parcelRegister("9itkV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b603e49d606132e091f78e8fc1c638c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6c4c8d17c994b675$var$_react = $6c4c8d17c994b675$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $6c4c8d17c994b675$var$_baseNew = $6c4c8d17c994b675$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $6c4c8d17c994b675$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkExternal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6c4c8d17c994b675$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $6c4c8d17c994b675$var$_react.default.createElement($6c4c8d17c994b675$var$_baseNew.default, Object.assign({
        name: "LinkExternalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3v1.5zM10 1h4.25a.75.75 0 0 1 .75.75V6h-1.5V3.56L7.53 9.53 6.47 8.47l5.97-5.97H10z" clip-rule="evenodd"/>`
    }, props));
$6c4c8d17c994b675$var$LinkExternalIcon.displayName = 'LinkExternalIcon';
var $6c4c8d17c994b675$var$_default = module.exports.default = $6c4c8d17c994b675$var$LinkExternalIcon;

});

parcelRegister("hJIkn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::94ba737f8eb536b5803fd14d2e86416d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ce990635ee602485$var$_react = $ce990635ee602485$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $ce990635ee602485$var$_baseNew = $ce990635ee602485$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $ce990635ee602485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ce990635ee602485$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $ce990635ee602485$var$_react.default.createElement($ce990635ee602485$var$_baseNew.default, Object.assign({
        name: "ListBulletedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.5 4.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16 5H6V3.5h10zm0 7.5H6V11h10z" clip-rule="evenodd"/>`
    }, props));
$ce990635ee602485$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $ce990635ee602485$var$_default = module.exports.default = $ce990635ee602485$var$ListBulletedIcon;

});

parcelRegister("gCi0w", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kCrSA").then(()=>parcelRequire('crXlB'));

});

parcelRegister("jhlcy", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1KIaN").then(()=>parcelRequire('PwsJ9'));

});

parcelRegister("9QgTI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b170729cb10fdaa6c208ecbe5722b466>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $72a613e9f42e1e21$var$_react = $72a613e9f42e1e21$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $72a613e9f42e1e21$var$_baseNew = $72a613e9f42e1e21$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $72a613e9f42e1e21$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $72a613e9f42e1e21$var$LockLockedIcon = (props)=>/*#__PURE__*/ $72a613e9f42e1e21$var$_react.default.createElement($72a613e9f42e1e21$var$_baseNew.default, Object.assign({
        name: "LockLockedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$72a613e9f42e1e21$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $72a613e9f42e1e21$var$_default = module.exports.default = $72a613e9f42e1e21$var$LockLockedIcon;

});

parcelRegister("danCZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("sSJpO").then(()=>parcelRequire('ffGm1'));

});

parcelRegister("b9AFO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fMsqj").then(()=>parcelRequire('hnnug'));

});

parcelRegister("lCGU8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("90CLa").then(()=>parcelRequire('evT2J'));

});

parcelRegister("iGfe0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gWT2Y").then(()=>parcelRequire('7Xd97'));

});

parcelRegister("kjCLb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7hb3L").then(()=>parcelRequire('iqAEB'));

});

parcelRegister("bPDOj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gjmIC").then(()=>parcelRequire('guB6Y'));

});

parcelRegister("3nsv6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("Nqdap").then(()=>parcelRequire('j0bRy'));

});

parcelRegister("9DvoS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jgM23").then(()=>parcelRequire('39Wx8'));

});

parcelRegister("krbQZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("h8eeI").then(()=>parcelRequire('kGiTR'));

});

parcelRegister("6LsYj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("335Kh").then(()=>parcelRequire('4gFlY'));

});

parcelRegister("bJgnj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6dgfh").then(()=>parcelRequire('gQw6H'));

});

parcelRegister("isw2P", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iCBBr").then(()=>parcelRequire('fIxO7'));

});

parcelRegister("ig4wQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jBnCj").then(()=>parcelRequire('9osvt'));

});

parcelRegister("bNXS1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9U3Mo").then(()=>parcelRequire('1wxug'));

});

parcelRegister("eqCFy", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bwo3Q").then(()=>parcelRequire('1x4MN'));

});

parcelRegister("e0ccO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dAZkz").then(()=>parcelRequire('bjI3S'));

});

parcelRegister("gGFKG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("289s7").then(()=>parcelRequire('50CQu'));

});

parcelRegister("4CvnY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dMYd8").then(()=>parcelRequire('jAJJU'));

});

parcelRegister("5eMsJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1MHaT").then(()=>parcelRequire('gW3wf'));

});

parcelRegister("6JWOy", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jkzlI").then(()=>parcelRequire('f4WMd'));

});

parcelRegister("8BqTI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jmlf9").then(()=>parcelRequire('8kvot'));

});

parcelRegister("jaRJd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aDU9W").then(()=>parcelRequire('44BMx'));

});

parcelRegister("4Tcwg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4zgGL").then(()=>parcelRequire('2qERs'));

});

parcelRegister("8lYf9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1t0CA").then(()=>parcelRequire('gdZr0'));

});

parcelRegister("izqtz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6v9IN").then(()=>parcelRequire('gNFjT'));

});

parcelRegister("jQsjh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gvmF2").then(()=>parcelRequire('jqkUt'));

});

parcelRegister("4wrww", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3Nvfz").then(()=>parcelRequire('9ltyu'));

});

parcelRegister("88MRH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4AWn7").then(()=>parcelRequire('cQnQI'));

});

parcelRegister("2ukfG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1vGr8").then(()=>parcelRequire('hbFR0'));

});

parcelRegister("dQioX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fbkpl").then(()=>parcelRequire('cf3Mk'));

});

parcelRegister("hWNiU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("brOhQ").then(()=>parcelRequire('9WurS'));

});

parcelRegister("ahztn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lnpu0").then(()=>parcelRequire('4GqRf'));

});

parcelRegister("l0bbX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("co3FH").then(()=>parcelRequire('hwJUK'));

});

parcelRegister("6aCjv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kkES0").then(()=>parcelRequire('bPQUa'));

});

parcelRegister("6UVBP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("74uZK").then(()=>parcelRequire('eoPrT'));

});

parcelRegister("gHUmX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("k25wl").then(()=>parcelRequire('9dISB'));

});

parcelRegister("1hca1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("yxfEy").then(()=>parcelRequire('7YJX2'));

});

parcelRegister("djO5H", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dehp1").then(()=>parcelRequire('lRmW0'));

});

parcelRegister("kyhaI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jPEzh").then(()=>parcelRequire('72God'));

});

parcelRegister("fu054", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bmzPB").then(()=>parcelRequire('iBpSq'));

});

parcelRegister("4l8I8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dBHBX").then(()=>parcelRequire('bvt68'));

});

parcelRegister("6lJQ4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("avLBo").then(()=>parcelRequire('cf74N'));

});

parcelRegister("e7YQz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9wN8W").then(()=>parcelRequire('8nyVz'));

});

parcelRegister("7I81R", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("95YXh").then(()=>parcelRequire('gNXvC'));

});

parcelRegister("fveFI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("f9GEs").then(()=>parcelRequire('1cV3d'));

});

parcelRegister("5FN95", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jsZ2h").then(()=>parcelRequire('i930f'));

});

parcelRegister("bhluA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2Kuyo").then(()=>parcelRequire('MUJuW'));

});

parcelRegister("6F4NG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8Ypfg").then(()=>parcelRequire('dicM4'));

});

parcelRegister("amerd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1b5ace82dd4a8965510da799b9153030>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $78a7288f6e3e8955$var$_react = $78a7288f6e3e8955$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $78a7288f6e3e8955$var$_baseNew = $78a7288f6e3e8955$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $78a7288f6e3e8955$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuotationMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: blockquote, comment, testimonial, blogs in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $78a7288f6e3e8955$var$QuotationMarkIcon = (props)=>/*#__PURE__*/ $78a7288f6e3e8955$var$_react.default.createElement($78a7288f6e3e8955$var$_baseNew.default, Object.assign({
        name: "QuotationMarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5A2.5 2.5 0 0 0 5.5 10V9H2a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5zM9 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5a2.5 2.5 0 0 0 2.5-2.5V9H11a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$78a7288f6e3e8955$var$QuotationMarkIcon.displayName = 'QuotationMarkIcon';
var $78a7288f6e3e8955$var$_default = module.exports.default = $78a7288f6e3e8955$var$QuotationMarkIcon;

});

parcelRegister("etdCO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7DJxL").then(()=>parcelRequire('4bKh1'));

});

parcelRegister("iJFD4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6Nxfg").then(()=>parcelRequire('aYPbA'));

});

parcelRegister("2g6bK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lRP2A").then(()=>parcelRequire('4Tz5Y'));

});

parcelRegister("i4OR9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("16N9J").then(()=>parcelRequire('49cNF'));

});

parcelRegister("lhCBK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("g0RMV").then(()=>parcelRequire('cjq2C'));

});

parcelRegister("IUagn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4MYjL").then(()=>parcelRequire('hPMWQ'));

});

parcelRegister("cwzC4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6eJxC").then(()=>parcelRequire('34To1'));

});

parcelRegister("79DMg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aP9rL").then(()=>parcelRequire('2HwUT'));

});

parcelRegister("lpvc6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aHS49").then(()=>parcelRequire('kSxvF'));

});

parcelRegister("QxUqW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("0uXRI").then(()=>parcelRequire('xEGV6'));

});

parcelRegister("2hy9v", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aZXPJ").then(()=>parcelRequire('idu5j'));

});

parcelRegister("2ya5m", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bxPBn").then(()=>parcelRequire('gaTij'));

});

parcelRegister("fTMpY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9lNFs").then(()=>parcelRequire('eZWnk'));

});

parcelRegister("4gMn8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gwr6m").then(()=>parcelRequire('3EQqZ'));

});

parcelRegister("2Pd1P", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4pHmN").then(()=>parcelRequire('jPzEK'));

});

parcelRegister("eRqyL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bZ1FC").then(()=>parcelRequire('je1LG'));

});

parcelRegister("dT9jj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fjU4V").then(()=>parcelRequire('aWGP9'));

});

parcelRegister("bZWLM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8m1Mi").then(()=>parcelRequire('gLL5P'));

});

parcelRegister("fQowv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("disGW").then(()=>parcelRequire('3kN5w'));

});

parcelRegister("eRBlK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("grfSI").then(()=>parcelRequire('1GtTj'));

});

parcelRegister("gcn0b", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7XV6t").then(()=>parcelRequire('g48F1'));

});

parcelRegister("cPxN7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7cWhH").then(()=>parcelRequire('hUEbu'));

});

parcelRegister("1pgmc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9qyx8").then(()=>parcelRequire('gGgaG'));

});

parcelRegister("2QnzO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2Ff1R").then(()=>parcelRequire('83K4u'));

});

parcelRegister("acRfo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b50a6e4dd8b62d7d7bf2cfae0d8c6979>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76e454285004b3dd$var$_react = $76e454285004b3dd$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $76e454285004b3dd$var$_baseNew = $76e454285004b3dd$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $76e454285004b3dd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusVerified".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing verified content.
Filled status icons provide higher visual contrast draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $76e454285004b3dd$var$StatusVerifiedIcon = (props)=>/*#__PURE__*/ $76e454285004b3dd$var$_react.default.createElement($76e454285004b3dd$var$_baseNew.default, Object.assign({
        name: "StatusVerifiedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.85.444a1.713 1.713 0 0 1 2.301 0L10.3 1.486a.2.2 0 0 0 .15.055L12 1.48a1.71 1.71 0 0 1 1.762 1.479l.21 1.537a.2.2 0 0 0 .081.139l1.226.95c.696.54.87 1.52.4 2.266l-.828 1.312a.2.2 0 0 0-.027.158l.328 1.516a1.713 1.713 0 0 1-1.151 1.993l-1.477.474a.2.2 0 0 0-.123.103l-.723 1.372a1.713 1.713 0 0 1-2.162.787l-1.435-.587a.2.2 0 0 0-.161 0l-1.436.587a1.713 1.713 0 0 1-2.162-.787l-.723-1.372a.22.22 0 0 0-.124-.103L2 12.83a1.713 1.713 0 0 1-1.15-1.993l.327-1.516a.2.2 0 0 0-.027-.158L.322 7.852a1.713 1.713 0 0 1 .4-2.266l1.225-.95a.2.2 0 0 0 .081-.14l.21-1.536a1.71 1.71 0 0 1 1.763-1.48l1.55.06a.2.2 0 0 0 .15-.055zm-.1 9.384L4.826 7.519l-1.152.961 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$76e454285004b3dd$var$StatusVerifiedIcon.displayName = 'StatusVerifiedIcon';
var $76e454285004b3dd$var$_default = module.exports.default = $76e454285004b3dd$var$StatusVerifiedIcon;

});

parcelRegister("hVZow", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c7bb68234d60992450ed6f02b59a5e8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0e76235a9209c86$var$_react = $d0e76235a9209c86$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d0e76235a9209c86$var$_baseNew = $d0e76235a9209c86$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $d0e76235a9209c86$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Story".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for story work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d0e76235a9209c86$var$StoryIcon = (props)=>/*#__PURE__*/ $d0e76235a9209c86$var$_react.default.createElement($d0e76235a9209c86$var$_baseNew.default, Object.assign({
        name: "StoryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.518 3a.5.5 0 0 0-.5-.5H4.983a.5.5 0 0 0-.5.5v9.806L8 10.333l.431.304 3.087 2.169zm1.5 11.202a.776.776 0 0 1-1.122.694l-.099-.06L8 12.166l-3.796 2.67a.775.775 0 0 1-1.22-.634V3a2 2 0 0 1 2-2h6.035a2 2 0 0 1 2 2z"/>`
    }, props));
$d0e76235a9209c86$var$StoryIcon.displayName = 'StoryIcon';
var $d0e76235a9209c86$var$_default = module.exports.default = $d0e76235a9209c86$var$StoryIcon;

});

parcelRegister("k2Erv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("h4Smg").then(()=>parcelRequire('kk210'));

});

parcelRegister("fl2JW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lIMhp").then(()=>parcelRequire('ibkW0'));

});

parcelRegister("a4xAE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3aSzL").then(()=>parcelRequire('6bGTm'));

});

parcelRegister("k3JVi", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lKAjB").then(()=>parcelRequire('arR8o'));

});

parcelRegister("3CafX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2yQO1").then(()=>parcelRequire('d67Vm'));

});

parcelRegister("92DA1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2nRwY").then(()=>parcelRequire('5L9dB'));

});

parcelRegister("d3g28", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1pzf9").then(()=>parcelRequire('cIoVd'));

});

parcelRegister("1tRql", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9rKLd").then(()=>parcelRequire('kTzLR'));

});

parcelRegister("f7E0W", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("NFlEP").then(()=>parcelRequire('ackSe'));

});

parcelRegister("cj2pt", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9xQWj").then(()=>parcelRequire('2L6ci'));

});

parcelRegister("1V5Tj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hnVBe").then(()=>parcelRequire('8A2jh'));

});

parcelRegister("eyVnU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5NEf1").then(()=>parcelRequire('e1xJu'));

});

parcelRegister("3Ve0d", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7pnGT").then(()=>parcelRequire('5KV6E'));

});

parcelRegister("axOZG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7Y446").then(()=>parcelRequire('3v3Vj'));

});

parcelRegister("5b7tP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gr56x").then(()=>parcelRequire('2a3IQ'));

});

parcelRegister("44kkl", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hsbPE").then(()=>parcelRequire('jQRrP'));

});

parcelRegister("8QeYq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cbgbu").then(()=>parcelRequire('2DJbP'));

});

parcelRegister("4ji9J", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8uZOV").then(()=>parcelRequire('hIy02'));

});

parcelRegister("8JjEN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hiDc4").then(()=>parcelRequire('2XGFW'));

});

parcelRegister("5K48F", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fW9ia").then(()=>parcelRequire('jBFjy'));

});

parcelRegister("P2zUI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5GyZj").then(()=>parcelRequire('787ZT'));

});

parcelRegister("9eghX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1wh3V").then(()=>parcelRequire('luDIJ'));

});

parcelRegister("jKe6u", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2K71g").then(()=>parcelRequire('8F76Q'));

});

parcelRegister("cqgtq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lGwXm").then(()=>parcelRequire('iQybw'));

});

parcelRegister("8o1FH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lr4U0").then(()=>parcelRequire('aoeTu'));

});

parcelRegister("iSqQx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8B3qQ").then(()=>parcelRequire('ffQS3'));

});

parcelRegister("8hNRj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5e4d05a25c478251d31315596858be41>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $608696355e141648$var$_react = $608696355e141648$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $608696355e141648$var$_baseNew = $608696355e141648$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $608696355e141648$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Text".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for representing text objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $608696355e141648$var$TextIcon = (props)=>/*#__PURE__*/ $608696355e141648$var$_react.default.createElement($608696355e141648$var$_baseNew.default, Object.assign({
        name: "TextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.813 2.5H0V1h11v1.5H6.313V15h-1.5zM12 6.5V4h1.5v2.5H16V8h-2.5v5a.5.5 0 0 0 .5.5h2V15h-2a2 2 0 0 1-2-2V8h-2V6.5z" clip-rule="evenodd"/>`
    }, props));
$608696355e141648$var$TextIcon.displayName = 'TextIcon';
var $608696355e141648$var$_default = module.exports.default = $608696355e141648$var$TextIcon;

});

parcelRegister("6uC9y", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eHgSV").then(()=>parcelRequire('eGoG9'));

});

parcelRegister("8v6mm", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lVWr4").then(()=>parcelRequire('giSOD'));

});

parcelRegister("h7fcz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("81qU5").then(()=>parcelRequire('3zF1S'));

});

parcelRegister("lesoK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("a6OdX").then(()=>parcelRequire('7IrZa'));

});

parcelRegister("4dLqJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bFCl7").then(()=>parcelRequire('kUiRE'));

});

parcelRegister("i1vD7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9RBOx").then(()=>parcelRequire('68eav'));

});

parcelRegister("9TAvZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4SSkP").then(()=>parcelRequire('5vbLS'));

});

parcelRegister("jSCZ1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9bIA3").then(()=>parcelRequire('3ZKV6'));

});

parcelRegister("jcu4u", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("luYx3").then(()=>parcelRequire('1gtOK'));

});

parcelRegister("f1QvK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("P1s44").then(()=>parcelRequire('cAGKc'));

});

parcelRegister("2ajVC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3w87s").then(()=>parcelRequire('4PP3r'));

});

parcelRegister("bTWCd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::563b591bbaa180fc5c3a0e9071f2faa1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8aa24c8f6652c10c$var$_react = $8aa24c8f6652c10c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $8aa24c8f6652c10c$var$_baseNew = $8aa24c8f6652c10c$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $8aa24c8f6652c10c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Video".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for representing video content across Atlassian and Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8aa24c8f6652c10c$var$VideoIcon = (props)=>/*#__PURE__*/ $8aa24c8f6652c10c$var$_react.default.createElement($8aa24c8f6652c10c$var$_baseNew.default, Object.assign({
        name: "VideoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 4a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-7A.5.5 0 0 0 10 4zm-2 .5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v.218l2.137-1.203A1.25 1.25 0 0 1 16 4.605v6.79a1.25 1.25 0 0 1-1.863 1.09L12 11.282v.218a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm12 5.061 2.5 1.407V5.032L12 6.44z" clip-rule="evenodd"/>`
    }, props));
$8aa24c8f6652c10c$var$VideoIcon.displayName = 'VideoIcon';
var $8aa24c8f6652c10c$var$_default = module.exports.default = $8aa24c8f6652c10c$var$VideoIcon;

});

parcelRegister("jdi42", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cEVfr").then(()=>parcelRequire('lQaob'));

});

parcelRegister("fjcfG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("566Wk").then(()=>parcelRequire('4OWnt'));

});

parcelRegister("1YRVW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5S6FQ").then(()=>parcelRequire('gD4kC'));

});

parcelRegister("5aBxv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jPZC4").then(()=>parcelRequire('fts3l'));

});

parcelRegister("bQFZK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("diVuB").then(()=>parcelRequire('iKUFL'));

});

parcelRegister("62GUY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kJRc8").then(()=>parcelRequire('dVfs0'));

});

parcelRegister("7nEB9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("77Yki").then(()=>parcelRequire('fCp4X'));

});

parcelRegister("hMntu", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("c5x8o").then(()=>parcelRequire('ajKSQ'));

});

parcelRegister("43bn2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("h3JUd").then(()=>parcelRequire('ef83l'));

});

parcelRegister("fpWg8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("0CAU1").then(()=>parcelRequire('1LwF8'));

});

parcelRegister("eMoGG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2IHUE").then(()=>parcelRequire('acFUw'));

});

parcelRegister("CFQSH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aYfhn").then(()=>parcelRequire('ajohf'));

});

parcelRegister("dl9ME", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cvbLP").then(()=>parcelRequire('8j9DN'));

});

parcelRegister("faygV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9AHCA").then(()=>parcelRequire('9EIlP'));

});

parcelRegister("iBJPb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bJOZI").then(()=>parcelRequire('gsMPz'));

});

parcelRegister("25SZG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cDWNl").then(()=>parcelRequire('dX5iH'));

});

parcelRegister("fMt8H", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("f4Uo8").then(()=>parcelRequire('6BVw6'));

});

parcelRegister("funyL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iTZAy").then(()=>parcelRequire('6eLz4'));

});

parcelRegister("c59mr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5af16ea80f1d58312eb2e017eb04c22b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8cbd368cf037dfb6$var$_react = $8cbd368cf037dfb6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $8cbd368cf037dfb6$var$_baseNew = $8cbd368cf037dfb6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $8cbd368cf037dfb6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8cbd368cf037dfb6$var$WorkItemIcon = (props)=>/*#__PURE__*/ $8cbd368cf037dfb6$var$_react.default.createElement($8cbd368cf037dfb6$var$_baseNew.default, Object.assign({
        name: "WorkItemIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 4a.5.5 0 0 0-.4-.49L14 3.5H2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zm-2.927 1.983-4 4.75a.75.75 0 0 1-1.146 0l-2-2.375 1.146-.966L7 9.085l3.427-4.068zM16 12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12l.204.01A2 2 0 0 1 16 4z"/>`
    }, props));
$8cbd368cf037dfb6$var$WorkItemIcon.displayName = 'WorkItemIcon';
var $8cbd368cf037dfb6$var$_default = module.exports.default = $8cbd368cf037dfb6$var$WorkItemIcon;

});

parcelRegister("kpuBm", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("izi70").then(()=>parcelRequire('9AYOJ'));

});

parcelRegister("d5ATj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9ShB2").then(()=>parcelRequire('8a7MV'));

});

parcelRegister("jeXlP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1zfue").then(()=>parcelRequire('4ABXT'));

});


parcelRegister("j5Zyu", function(module, exports) {
$parcel$export(module.exports, "ICONOGRAPHY_REFRESH", () => $924907e7aad0f36a$export$c44dcb4ac245d131);
$parcel$export(module.exports, "FeaturePreviewContext", () => $924907e7aad0f36a$export$f9af3fb8cc704d8e);

var $eJOHy = parcelRequire("eJOHy");
const $924907e7aad0f36a$export$c44dcb4ac245d131 = 'iconography-refresh-early-adoption-2025-06';
const $924907e7aad0f36a$export$f9af3fb8cc704d8e = (0, $eJOHy.createContext)({
    [$924907e7aad0f36a$export$c44dcb4ac245d131]: false
});
const $924907e7aad0f36a$export$d34634bd9a1f8e23 = ()=>(0, $eJOHy.useContext)($924907e7aad0f36a$export$f9af3fb8cc704d8e);
const $924907e7aad0f36a$export$9600eab7eb2a5234 = $924907e7aad0f36a$export$f9af3fb8cc704d8e.Provider;

});



parcelRegister("8fgfE", function(module, exports) {
$parcel$export(module.exports, "ButtonGroup", () => $6408bf1b8ad158ac$export$69b1032f2ecdf404);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $48q59 = parcelRequire("48q59");
const $6408bf1b8ad158ac$export$bf0162d825d6e13 = {
    children: {
        value: "applyAppearanceToChildren(props.forgeDoc.children, props.render, appearance)",
        comment: "apply consistent appearance to children elements"
    },
    testId: true,
    label: true,
    titleId: true
};
/**
 * Applying the appearance prop directly to the children forgedocs.
 * It is because the logic for applying appearance to the children components
 * through React.cloneComponent can only be applied to the Forge component wrapper,
 * and not to the actual Button element.
 */ const $6408bf1b8ad158ac$var$applyAppearanceToChildren = (children, render, appearance)=>{
    if (!appearance) return children.map(render);
    return children.map((child)=>{
        if (child.type !== 'String') return render({
            ...child,
            props: {
                appearance: appearance,
                ...child.props
            }
        });
        return render(child);
    });
};
const $6408bf1b8ad158ac$export$69b1032f2ecdf404 = (props)=>{
    const { testId: testId, label: label, titleId: titleId, appearance: appearance } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $48q59.default), {
        // apply consistent appearance to children elements
        children: $6408bf1b8ad158ac$var$applyAppearanceToChildren(props.forgeDoc.children, props.render, appearance),
        testId: testId,
        label: label,
        titleId: titleId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("jcnYX", function(module, exports) {
$parcel$export(module.exports, "Calendar", () => $05bffee1b7500a0c$export$e1aef45b828286de);

var $gt9Am = parcelRequire("gt9Am");

var $8AppO = parcelRequire("8AppO");
parcelRequire("eJOHy");

var $cSUzd = parcelRequire("cSUzd");
const $05bffee1b7500a0c$export$bf0162d825d6e13 = {
    day: true,
    defaultDay: true,
    defaultMonth: true,
    defaultYear: true,
    defaultPreviouslySelected: true,
    defaultSelected: true,
    disabled: true,
    disabledDateFilter: false,
    maxDate: true,
    minDate: true,
    nextMonthLabel: true,
    onBlur: {
        value: "adaptEventHandler(onBlur)"
    },
    onChange: true,
    onFocus: {
        value: "adaptEventHandler(onFocus)"
    },
    onSelect: true,
    previouslySelected: true,
    previousMonthLabel: true,
    selected: true,
    today: true,
    year: true,
    locale: true,
    testId: true,
    weekStartDay: true,
    tabIndex: true
};
const $05bffee1b7500a0c$export$e1aef45b828286de = (props)=>{
    const { day: day, defaultDay: defaultDay, defaultMonth: defaultMonth, defaultYear: defaultYear, defaultPreviouslySelected: defaultPreviouslySelected, defaultSelected: defaultSelected, disabled: disabled, maxDate: maxDate, minDate: minDate, nextMonthLabel: nextMonthLabel, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onSelect: onSelect, previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, today: today, year: year, locale: locale, testId: testId, weekStartDay: weekStartDay, tabIndex: tabIndex } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cSUzd.default), {
        day: day,
        defaultDay: defaultDay,
        defaultMonth: defaultMonth,
        defaultYear: defaultYear,
        defaultPreviouslySelected: defaultPreviouslySelected,
        defaultSelected: defaultSelected,
        disabled: disabled,
        maxDate: maxDate,
        minDate: minDate,
        nextMonthLabel: nextMonthLabel,
        onBlur: (0, $8AppO.adaptEventHandler)(onBlur),
        onChange: onChange,
        onFocus: (0, $8AppO.adaptEventHandler)(onFocus),
        onSelect: onSelect,
        previouslySelected: previouslySelected,
        previousMonthLabel: previousMonthLabel,
        selected: selected,
        today: today,
        year: year,
        locale: locale,
        testId: testId,
        weekStartDay: weekStartDay,
        tabIndex: tabIndex
    });
}; /**
 * @codegenEnd
 */ 

});
parcelRegister("cSUzd", function(module, exports) {
$parcel$export(module.exports, "default", () => $d1db3bdfc4d701b2$export$2e2bcd8739ae039);
/* calendar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");

var $gl2vi = parcelRequire("gl2vi");

var $8IeH1 = parcelRequire("8IeH1");
var $78OnL = parcelRequire("78OnL");

var $hWhuM = parcelRequire("hWhuM");

var $jOHXZ = parcelRequire("jOHXZ");

var $1p4Fz = parcelRequire("1p4Fz");

var $h2Y6s = parcelRequire("h2Y6s");

var $7pqrO = parcelRequire("7pqrO");

var $8m7JM = parcelRequire("8m7JM");

var $5Pa93 = parcelRequire("5Pa93");

var $cM3gB = parcelRequire("cM3gB");

var $lPLOh = parcelRequire("lPLOh");

var $jtNxE = parcelRequire("jtNxE");
const $d1db3bdfc4d701b2$var$styles = {
    box: "_1e0c1o8l _uiztglyw"
};
const $d1db3bdfc4d701b2$var$analyticsAttributes = {
    componentName: 'calendar',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $d1db3bdfc4d701b2$var$InnerCalendar = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, $h2Y6s.blankStringArray), defaultSelected: defaultSelected = (0, $h2Y6s.blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, $3Vuhz.default), onChange: onChange = (0, $3Vuhz.default), onFocus: onFocus = (0, $3Vuhz.default), onSelect: onSelect = (0, $3Vuhz.default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
    const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, $7pqrO.default)({
        day: day,
        defaultDay: defaultDay,
        month: month,
        defaultMonth: defaultMonth,
        year: year,
        defaultYear: defaultYear,
        today: today,
        selected: selected,
        defaultSelected: defaultSelected,
        previouslySelected: previouslySelected,
        defaultPreviouslySelected: defaultPreviouslySelected
    });
    const [shouldSetFocus, setShouldSetFocus] = (0, $eJOHy.useState)(false);
    const onChangeWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        ...$d1db3bdfc4d701b2$var$analyticsAttributes
    });
    const { navigate: navigate, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear } = (0, $cM3gB.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        shouldSetFocus: [
            shouldSetFocus,
            setShouldSetFocus
        ],
        onChange: onChangeWithAnalytics
    });
    const onSelectWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onSelect,
        action: 'selected',
        analyticsData: analyticsContext,
        ...$d1db3bdfc4d701b2$var$analyticsAttributes
    });
    const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, $lPLOh.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            ,
            setPreviouslySelectedValue
        ],
        onSelect: onSelectWithAnalytics,
        navigate: navigate
    });
    const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, $8m7JM.default)({
        onFocus: onFocus,
        onBlur: onBlur
    });
    const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, $jtNxE.default)({
        locale: locale,
        weekStartDay: weekStartDay
    });
    const weeks = (0, $5Pa93.default)({
        day: dayValue,
        month: monthValue,
        year: yearValue,
        today: todayValue,
        selected: selectedValue,
        previouslySelected: previouslySelectedValue,
        disabled: disabled,
        disabledDateFilter: disabledDateFilter,
        minDate: minDate,
        maxDate: maxDate,
        daysLong: daysLong,
        weekStartDay: weekStartDay
    });
    const getNextMonthHeading = ()=>{
        // Next month is (currentMonth - 1) + 1, or just currentMonth in this
        // instance.
        const nextMonth = monthValue % 12;
        const showNextYear = monthValue === 12;
        return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
    };
    const getNextYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const nextYear = yearValue + 1;
        return `${monthsLong[thisMonth]} ${nextYear}`;
    };
    const getPreviousMonthHeading = ()=>{
        // Previous month is (monthValue - 1) - 1. Need to add 12 so the modulo
        // works as expected and stays positive.
        const previousMonth = (monthValue + 12 - 2) % 12;
        const showPreviousYear = monthValue === 1;
        return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
    };
    const getPreviousYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const previousYear = yearValue - 1;
        return `${monthsLong[thisMonth]} ${previousYear}`;
    };
    const headerId = (0, $gl2vi.useId)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: className,
        style: style,
        onBlur: handleContainerBlur,
        onFocus: handleContainerFocus,
        "data-testid": testId && `${testId}--container`,
        ref: ref,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            xcss: $d1db3bdfc4d701b2$var$styles.box,
            padding: "space.200",
            "aria-label": "calendar",
            testId: testId && `${testId}--calendar`,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                space: "space.150",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hWhuM.default // The month number needs to be translated to index in the month
                    ), {
                        // name array e.g. 1 (January) -> 0
                        monthLongTitle: monthsLong[monthValue - 1],
                        year: yearValue,
                        nextMonthLabel: nextMonthLabel,
                        previousMonthLabel: previousMonthLabel,
                        nextMonthHeading: getNextMonthHeading(),
                        nextYearHeading: getNextYearHeading(),
                        previousMonthHeading: getPreviousMonthHeading(),
                        previousYearHeading: getPreviousYearHeading(),
                        handleClickNextMonth: handleClickNextMonth,
                        handleClickNextYear: handleClickNextYear,
                        handleClickPrevMonth: handleClickPrevMonth,
                        handleClickPrevYear: handleClickPrevYear,
                        headerId: headerId,
                        tabIndex: tabIndex,
                        testId: testId
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
                        role: "grid",
                        onKeyDown: handleContainerKeyDown,
                        "aria-labelledby": headerId,
                        testId: testId && `${testId}--calendar-dates`,
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1p4Fz.default), {
                                daysShort: daysShort,
                                testId: testId
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jOHXZ.default), {
                                weeks: weeks,
                                handleClickDay: handleClickDay,
                                monthsLong: monthsLong,
                                shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
                                tabIndex: tabIndex,
                                testId: testId
                            })
                        ]
                    })
                ]
            })
        })
    });
});
/**
 * __Calendar__
 *
 * A calendar is used for date selection.
 *
 * - [Examples](https://atlassian.design/components/calendar/examples)
 * - [Code](https://atlassian.design/components/calendar/code)
 * - [Usage](https://atlassian.design/components/calendar/usage)
 */ const $d1db3bdfc4d701b2$var$Calendar = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function Calendar(props, ref) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)($d1db3bdfc4d701b2$var$InnerCalendar, {
        ...props,
        ref: ref
    });
}));
$d1db3bdfc4d701b2$var$Calendar.displayName = 'Calendar';
var $d1db3bdfc4d701b2$export$2e2bcd8739ae039 = $d1db3bdfc4d701b2$var$Calendar;

});
parcelRegister("hWhuM", function(module, exports) {
$parcel$export(module.exports, "default", () => $8fe58087a91a587c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $gl2vi = parcelRequire("gl2vi");

var $806LH = parcelRequire("806LH");

var $ld0cd = parcelRequire("ld0cd");

var $cqfIR = parcelRequire("cqfIR");

var $8PCRQ = parcelRequire("8PCRQ");

var $cQxBL = parcelRequire("cQxBL");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
const $8fe58087a91a587c$var$Header = /*#__PURE__*/ (0, $eJOHy.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousYearLabel: previousYearLabel = 'Previous year', previousMonthHeading: previousMonthHeading, previousYearHeading: previousYearHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextYearLabel: nextYearLabel = 'Next year', nextMonthHeading: nextMonthHeading, nextYearHeading: nextYearHeading, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
    const announceId = (0, $gl2vi.useId)();
    // All of this is because `aria-atomic` is not fully supported for different
    // assistive technologies. We want the value of the current month and year to
    // be announced, but *only* if that value has been interacted with since
    // being mounted. This allows us to conditionally apply the `aria-live`
    // attribute.  Without this, the `aria-live` property is set on mount and
    // overrides the default input's readout in downstream consumers (e.g.
    // datetime picker).
    const [hasInteractedWithMonthOrYear, setHasInteractedWithMonthOrYear] = (0, $eJOHy.useState)(false);
    const handlePrevMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevMonth(e);
    };
    const handlePrevYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevYear(e);
    };
    const handleNextMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextMonth(e);
    };
    const handleNextYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextYear(e);
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            space: "space.0",
            alignBlock: "center",
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                    space: "space.100",
                    alignBlock: "start",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevYearInteraction,
                            testId: testId && `${testId}--previous-year`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ld0cd))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${previousYearLabel}, ${previousYearHeading}`
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevMonthInteraction,
                            testId: testId && `${testId}--previous-month`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8PCRQ))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${previousMonthLabel}, ${previousMonthHeading}`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    "aria-live": hasInteractedWithMonthOrYear ? 'polite' : undefined,
                    id: announceId,
                    testId: testId && `${testId}--current-month-year--container`,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                        size: "xsmall",
                        as: "h2",
                        id: headerId,
                        testId: testId && `${testId}--current-month-year`,
                        children: `${monthLongTitle} ${year}`
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                    space: "space.100",
                    alignBlock: "end",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextMonthInteraction,
                            testId: testId && `${testId}--next-month`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${nextMonthLabel}, ${nextMonthHeading}`
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextYearInteraction,
                            testId: testId && `${testId}--next-year`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cqfIR))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${nextYearLabel}, ${nextYearHeading}`
                        })
                    ]
                })
            ]
        })
    });
});
$8fe58087a91a587c$var$Header.displayName = 'Header';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8fe58087a91a587c$export$2e2bcd8739ae039 = $8fe58087a91a587c$var$Header;

});

parcelRegister("jOHXZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $7776188040914bac$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");

var $17gD3 = parcelRequire("17gD3");

var $48tPc = parcelRequire("48tPc");
const $7776188040914bac$var$WeekDays = /*#__PURE__*/ (0, $eJOHy.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        role: "rowgroup",
        testId: testId && `${testId}--month`,
        children: weeks.map((week, i)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $48tPc.default), {
                testId: testId && `${testId}--week`,
                children: week.values.map((weekDay)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $17gD3.default), {
                        isDisabled: weekDay.isDisabled,
                        isFocused: weekDay.isFocused,
                        isToday: weekDay.isToday,
                        dayLong: weekDay.weekDayName,
                        month: weekDay.month,
                        monthLong: monthsLong[weekDay.month - 1],
                        onClick: handleClickDay,
                        isPreviouslySelected: weekDay.isPreviouslySelected,
                        isSelected: weekDay.isSelected,
                        isSibling: weekDay.isSiblingMonth,
                        year: weekDay.year,
                        shouldSetFocus: shouldSetFocus,
                        tabIndex: tabIndex,
                        testId: testId,
                        children: weekDay.day
                    }, `${week.id}-${weekDay.id}`))
            }, i))
    });
});
$7776188040914bac$var$WeekDays.displayName = 'WeekDays';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7776188040914bac$export$2e2bcd8739ae039 = $7776188040914bac$var$WeekDays;

});
parcelRegister("17gD3", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f55ebb7772d4c5d$export$2e2bcd8739ae039);
/* date.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3Vuhz = parcelRequire("3Vuhz");

var $hYvlq = parcelRequire("hYvlq");
const $7f55ebb7772d4c5d$var$dateCellSiblingStyle = null;
const $7f55ebb7772d4c5d$var$dateCellTodayStyle = null;
const $7f55ebb7772d4c5d$var$dateCellPrevSelectedStyle = null;
const $7f55ebb7772d4c5d$var$dateCellSelectedStyle = null;
const $7f55ebb7772d4c5d$var$dateCellDisabledStyle = null;
const $7f55ebb7772d4c5d$var$dateCellStyles = null;
const $7f55ebb7772d4c5d$var$Date = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, $3Vuhz.default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
    const dateRef = (0, $eJOHy.useRef)({
        day: day,
        month: month,
        year: year,
        isDisabled: isDisabled
    });
    (0, $eJOHy.useEffect)(()=>{
        dateRef.current = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
    }, [
        day,
        month,
        year,
        isDisabled
    ]);
    const focusRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
    }, [
        isFocused,
        shouldSetFocus
    ]);
    const handleClick = (0, $eJOHy.useCallback)(()=>{
        const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
        if (!isDisabledValue) onClick({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hYvlq.default), {
        role: "gridcell",
        alignItems: "center",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("button", {
            "aria-current": isToday ? 'date' : undefined,
            "aria-disabled": isDisabled || undefined,
            "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
            "aria-pressed": isSelected ? 'true' : 'false',
            tabIndex: isFocused ? tabIndex : -1,
            type: "button",
            onClick: handleClick,
            ref: focusRef,
            "data-disabled": isDisabled || undefined,
            "data-focused": isFocused || undefined,
            "data-prev-selected": isPreviouslySelected || undefined,
            "data-selected": isSelected || undefined,
            "data-sibling": isSibling || undefined,
            "data-today": isToday || undefined,
            "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`),
            className: (0, $hcewu.default)([
                "_kkk2n7od _2rkofajl _11c82smr _1h6d3acm _1dqonqa1 _189e1dm9 _1e0c1ule _kqswh2mm _16jlkb7n _bfhk18uv _syazj3m3 _80omtlke _85i51b66 _1q511b66 _y4tirdoj _bozgrdoj _y3gn1h6o _pojj194a _10knnqa1 _1wysdkaa _irr314ae _30l3j3m3 _1di61l7b _9h8hj3m3",
                isSibling && "_syaz1wmz _30l31wmz",
                isToday && "_syaz1ldt _k48p1igg _1ywu1ule _1qdgyh40 _18postnw _1hfk1r31 _aetrb3bt _1gufv77o _1czdv77o _g0nfv77o",
                isPreviouslySelected && "_bfhk29zg _syazc8hx _30l3c8hx",
                isSelected && "_bfhk1p4p _syazqueg _irr3quvt _30l31uqy",
                isDisabled && "_syaz7dlb _80om13gf _irr318uv _30l37dlb"
            ]),
            children: day
        })
    });
}));
$7f55ebb7772d4c5d$var$Date.displayName = 'Date';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7f55ebb7772d4c5d$export$2e2bcd8739ae039 = $7f55ebb7772d4c5d$var$Date;

});
parcelRegister("hYvlq", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e062987a137d87a$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $3e062987a137d87a$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $3e062987a137d87a$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $3e062987a137d87a$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $3e062987a137d87a$var$alignContentMap = {
    start: "_ae4vv2br",
    center: "_ae4v1h6o",
    end: "_ae4vh9n0",
    'space-between': "_ae4v1yb4",
    'space-around': "_ae4v1b1v",
    'space-evenly': "_ae4vitcz",
    stretch: "_ae4v1fhb"
};
const $3e062987a137d87a$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $3e062987a137d87a$var$baseStyles = {
    root: "_1e0c11p5 _vchhusvi"
};
const $3e062987a137d87a$var$gridAutoFlowMap = {
    row: "_wij2vrvc",
    column: "_wij21bp4",
    dense: "_wij218l3",
    'row dense': "_wij2j5tq",
    'column dense': "_wij2adhi"
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $3e062987a137d87a$var$Grid = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        id: id,
        role: role,
        className: (0, $hcewu.default)([
            $3e062987a137d87a$var$baseStyles.root,
            gap && $3e062987a137d87a$var$columnGapMap[gap],
            columnGap && $3e062987a137d87a$var$columnGapMap[columnGap],
            gap && $3e062987a137d87a$var$rowGapMap[gap],
            rowGap && $3e062987a137d87a$var$rowGapMap[rowGap],
            alignItems && $3e062987a137d87a$var$alignItemsMap[alignItems],
            alignContent && $3e062987a137d87a$var$alignContentMap[alignContent],
            justifyContent && $3e062987a137d87a$var$justifyContentMap[justifyContent],
            autoFlow && $3e062987a137d87a$var$gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$3e062987a137d87a$var$Grid.displayName = 'Grid';
var $3e062987a137d87a$export$2e2bcd8739ae039 = $3e062987a137d87a$var$Grid;

});


parcelRegister("48tPc", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f5de1de4465d4ec$export$2e2bcd8739ae039);
/* week-day-grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hYvlq = parcelRequire("hYvlq");
const $4f5de1de4465d4ec$var$styles = {
    templateColumns: "_yv0eloeq"
};
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */ const $4f5de1de4465d4ec$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
    const row = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hYvlq.default), {
        testId: testId,
        xcss: $4f5de1de4465d4ec$var$styles.templateColumns,
        role: "row",
        children: children
    });
    return isHidden ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "aria-hidden": "true",
        children: row
    }) : row;
};
var $4f5de1de4465d4ec$export$2e2bcd8739ae039 = $4f5de1de4465d4ec$var$WeekDayGrid;

});


parcelRegister("1p4Fz", function(module, exports) {
$parcel$export(module.exports, "default", () => $be65a37818b8364c$export$2e2bcd8739ae039);
/* week-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $3cMgR = parcelRequire("3cMgR");

var $48tPc = parcelRequire("48tPc");
const $be65a37818b8364c$var$styles = {
    columnHeader: "_1ul98pqr _o5721q9c _1e0c1txw _1bah1h6o"
};
const $be65a37818b8364c$var$WeekHeader = /*#__PURE__*/ (0, $eJOHy.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $48tPc.default), {
        isHidden: true,
        testId: testId && `${testId}--column-headers`,
        children: daysShort.map((shortDay)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                padding: "space.100",
                xcss: $be65a37818b8364c$var$styles.columnHeader,
                role: "columnheader",
                testId: testId && `${testId}--column-header`,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                    weight: "bold",
                    size: "UNSAFE_small",
                    align: "center",
                    color: "color.text.subtle",
                    children: shortDay
                })
            }, shortDay))
    });
});
$be65a37818b8364c$var$WeekHeader.displayName = 'WeekHeader';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$be65a37818b8364c$export$2e2bcd8739ae039 = $be65a37818b8364c$var$WeekHeader;

});

parcelRegister("h2Y6s", function(module, exports) {
$parcel$export(module.exports, "arrowKeys", () => $be18158d85881f31$export$8b15eca9c6d5c48a);
$parcel$export(module.exports, "daysPerWeek", () => $be18158d85881f31$export$3ae905d9742bef55);
$parcel$export(module.exports, "monthsPerYear", () => $be18158d85881f31$export$c9b7c010035d60c6);
$parcel$export(module.exports, "blankStringArray", () => $be18158d85881f31$export$8fa20d70624f8b9d);
const $be18158d85881f31$export$8b15eca9c6d5c48a = {
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right',
    ArrowUp: 'up'
};
const $be18158d85881f31$export$3ae905d9742bef55 = 7;
const $be18158d85881f31$export$c9b7c010035d60c6 = 12;
const $be18158d85881f31$export$8fa20d70624f8b9d = [];

});

parcelRegister("7pqrO", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd0ab84481a095dc$export$2e2bcd8739ae039);

var $7O2l7 = parcelRequire("7O2l7");

var $3c3v8 = parcelRequire("3c3v8");

var $ediHA = parcelRequire("ediHA");
function $dd0ab84481a095dc$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
    const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, $3c3v8.default)(()=>{
        const now = new Date();
        const thisDay = now.getDate();
        const thisMonth = now.getMonth() + 1;
        const thisYear = now.getFullYear();
        return {
            thisDay: thisDay,
            thisMonth: thisMonth,
            thisYear: thisYear
        };
    });
    const [dayValue, setDayValue] = (0, $7O2l7.default)(day, ()=>defaultDay || thisDay);
    const [monthValue, setMonthValue] = (0, $7O2l7.default)(month, ()=>defaultMonth || thisMonth);
    const [yearValue, setYearValue] = (0, $7O2l7.default)(year, ()=>defaultYear || thisYear);
    const [todayValue] = (0, $7O2l7.default)(today, ()=>today || `${thisYear}-${(0, $ediHA.default)(thisMonth)}-${(0, $ediHA.default)(thisDay)}`);
    const [selectedValue, setSelectedValue] = (0, $7O2l7.default)(selected, ()=>defaultSelected);
    const [previouslySelectedValue, setPreviouslySelectedValue] = (0, $7O2l7.default)(previouslySelected, ()=>defaultPreviouslySelected);
    return {
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        today: [
            todayValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ]
    };
}

});
parcelRegister("ediHA", function(module, exports) {
$parcel$export(module.exports, "default", () => $50fecd0d0148fc4a$export$2e2bcd8739ae039);
function $50fecd0d0148fc4a$export$2e2bcd8739ae039(num) {
    return num < 10 ? `0${num}` : `${num}`;
}

});


parcelRegister("8m7JM", function(module, exports) {
$parcel$export(module.exports, "default", () => $c971afa7669251e8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $c971afa7669251e8$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
    const handleContainerBlur = (0, $eJOHy.useCallback)((event)=>{
        onBlur(event);
    }, [
        onBlur
    ]);
    const handleContainerFocus = (0, $eJOHy.useCallback)((event)=>{
        onFocus(event);
    }, [
        onFocus
    ]);
    return {
        handleContainerBlur: handleContainerBlur,
        handleContainerFocus: handleContainerFocus
    };
}

});

parcelRegister("5Pa93", function(module, exports) {
$parcel$export(module.exports, "default", () => $6571678cf382b203$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $kQ82p = parcelRequire("kQ82p");

var $h2Y6s = parcelRequire("h2Y6s");

var $fdbAT = parcelRequire("fdbAT");

var $cFI4x = parcelRequire("cFI4x");
function $6571678cf382b203$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
    const shouldDisplaySixthWeek = calendar.length % 6;
    const calendarLastValue = calendar[calendar.length - 1];
    return (0, $eJOHy.useMemo)(()=>{
        // Some months jump between 5 and 6 weeks to display. In some cases 4 (Feb
        // with the 1st on a Monday etc). This ensures the UI doesn't jump around by
        // catering to always showing 6 weeks.
        if (shouldDisplaySixthWeek) {
            const lastDayIsSibling = calendarLastValue.siblingMonth;
            const sliceStart = lastDayIsSibling ? (0, $h2Y6s.daysPerWeek) : 0;
            return (0, $cFI4x.default)(year, month, {
                weekStartDay: weekStartDay
            }).slice(sliceStart, sliceStart + (0, $h2Y6s.daysPerWeek)).map((date)=>({
                    ...date,
                    siblingMonth: true
                }));
        }
    }, [
        calendarLastValue,
        month,
        shouldDisplaySixthWeek,
        weekStartDay,
        year
    ]);
}
function $6571678cf382b203$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
    const calendar = (0, $eJOHy.useMemo)(()=>(0, $cFI4x.default)(year, month - 1, {
            weekStartDay: weekStartDay
        }), [
        month,
        weekStartDay,
        year
    ]);
    const calendarWithSixthWeek = $6571678cf382b203$var$useGetCalendarWithSixthWeek(calendar, {
        month: month,
        year: year,
        weekStartDay: weekStartDay
    });
    if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
    const minDate = minDateString ? (0, $kQ82p.default)(minDateString) : undefined;
    const maxDate = maxDateString ? (0, $kQ82p.default)(maxDateString) : undefined;
    const needJsDate = minDateString || maxDateString;
    return (0, $eJOHy.useMemo)(()=>{
        const weeks = [];
        calendar.forEach((date)=>{
            const dateAsString = (0, $fdbAT.default)(date, {
                fixMonth: true
            });
            const JSDate = needJsDate ? (0, $kQ82p.default)(dateAsString) : undefined;
            let week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            const weekDayOffset = (date.weekDay - weekStartDay) % 7;
            // Define a bunch of `const`s
            const weekDayName = daysLong[weekDayOffset];
            const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            const isFocused = day === date.day && !date.siblingMonth;
            const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            const isSiblingMonth = !!date.siblingMonth;
            const isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        return weeks;
    }, [
        calendar,
        day,
        disabled,
        disabledDateFilter,
        minDate,
        maxDate,
        needJsDate,
        previouslySelected,
        selected,
        today,
        weekStartDay,
        daysLong
    ]);
}

});
parcelRegister("fdbAT", function(module, exports) {
$parcel$export(module.exports, "default", () => $33e505eaecca4d6d$export$2e2bcd8739ae039);

var $ediHA = parcelRequire("ediHA");
function $33e505eaecca4d6d$export$2e2bcd8739ae039(date, options) {
    return `${date.year}-${(0, $ediHA.default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, $ediHA.default)(date.day)}`;
}

});

parcelRegister("cFI4x", function(module, exports) {
$parcel$export(module.exports, "default", () => $5fc98c4c7dc36d65$export$2e2bcd8739ae039);
/**
 * Logic taken from https://github.com/WesSouza/calendar-base which is not maintained for quite sometime.
 * This will help us fixing any issue we might get or any new functionality we might want to support.
 * Not changing much code below. Just removed those parts which we don't need.
 */ 
var $h2Y6s = parcelRequire("h2Y6s");

var $d9oTA = parcelRequire("d9oTA");
function $5fc98c4c7dc36d65$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
    weekStartDay: 0
}) {
    const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
    const utcYear = date.getUTCFullYear();
    const utcMonth = date.getUTCMonth();
    const calendar = [];
    const firstDay = date.getUTCDay();
    const firstDate = -(((0, $h2Y6s.daysPerWeek) - weekStartDay + firstDay) % (0, $h2Y6s.daysPerWeek));
    const lastDate = (0, $d9oTA.default)(utcYear, utcMonth);
    const lastDay = (lastDate - firstDate) % (0, $h2Y6s.daysPerWeek);
    const lastDateOfPreviousMonth = (0, $d9oTA.default)(utcYear, utcMonth - 1);
    let dateCounter = firstDate;
    let currentDay;
    let currentDate;
    let currentDateObject = null;
    let calculatedMonth;
    let calculatedYear;
    const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, $h2Y6s.daysPerWeek) - lastDay : 0) + firstDate;
    while(dateCounter < maxDateCount){
        currentDate = dateCounter + 1;
        currentDay = ((dateCounter < 1 ? (0, $h2Y6s.daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, $h2Y6s.daysPerWeek);
        if (currentDate < 1 || currentDate > lastDate) {
            if (currentDate < 1) {
                calculatedMonth = utcMonth - 1;
                calculatedYear = utcYear;
                if (calculatedMonth < 0) {
                    calculatedMonth = (0, $h2Y6s.monthsPerYear) - 1;
                    calculatedYear--;
                }
                currentDate = lastDateOfPreviousMonth + currentDate;
            } else if (currentDate > lastDate) {
                calculatedMonth = utcMonth + 1;
                calculatedYear = utcYear;
                if (calculatedMonth > (0, $h2Y6s.monthsPerYear) - 1) {
                    calculatedMonth = 0;
                    calculatedYear++;
                }
                currentDate = dateCounter - lastDate + 1;
            }
            if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: calculatedMonth,
                year: calculatedYear,
                siblingMonth: true
            };
        } else currentDateObject = {
            day: currentDate,
            weekDay: currentDay,
            month: utcMonth,
            year: utcYear
        };
        calendar.push(currentDateObject);
        dateCounter++;
    }
    return calendar;
}

});
parcelRegister("d9oTA", function(module, exports) {
$parcel$export(module.exports, "default", () => $bdb6610bba124d19$export$2e2bcd8739ae039);
function $bdb6610bba124d19$export$2e2bcd8739ae039(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

});



parcelRegister("cM3gB", function(module, exports) {
$parcel$export(module.exports, "default", () => $e11abbd67514b7e7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $h2Y6s = parcelRequire("h2Y6s");

var $fdbAT = parcelRequire("fdbAT");

var $d9oTA = parcelRequire("d9oTA");
const $e11abbd67514b7e7$var$getNextMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === (0, $h2Y6s.monthsPerYear)) {
        month = 1;
        year += 1;
    } else month += 1;
    return {
        month: month,
        year: year
    };
};
const $e11abbd67514b7e7$var$getPrevMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === 1) {
        month = (0, $h2Y6s.monthsPerYear);
        year -= 1;
    } else month -= 1;
    return {
        month: month,
        year: year
    };
};
function $e11abbd67514b7e7$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
    const dateRef = (0, $eJOHy.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $eJOHy.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnChange = (0, $eJOHy.useCallback)(({ year: year, month: month, day: day, type: type })=>{
        const iso = (0, $fdbAT.default)({
            year: year,
            month: month,
            day: day
        });
        const isFocusableType = [
            'up',
            'down',
            'left',
            'right'
        ].includes(type);
        onChange({
            day: day,
            month: month,
            year: year,
            iso: iso,
            type: type
        });
        setDayValue(day);
        setMonthValue(month);
        setYearValue(year);
        setShouldSetFocus(isFocusableType);
    }, [
        onChange,
        setDayValue,
        setMonthValue,
        setYearValue,
        setShouldSetFocus
    ]);
    const navigate = (0, $eJOHy.useCallback)((type)=>{
        const { day: day, month: month, year: year } = dateRef.current;
        if (type === 'down') {
            const next = day + (0, $h2Y6s.daysPerWeek);
            const daysInMonth = (0, $d9oTA.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $e11abbd67514b7e7$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: next - daysInMonth,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'left') {
            const prev = day - 1;
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $e11abbd67514b7e7$var$getPrevMonth(month, year);
                const prevDay = (0, $d9oTA.default)(prevYear, prevMonth - 1);
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        } else if (type === 'right') {
            const next = day + 1;
            const daysInMonth = (0, $d9oTA.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $e11abbd67514b7e7$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: 1,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'up') {
            const prev = day - (0, $h2Y6s.daysPerWeek);
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $e11abbd67514b7e7$var$getPrevMonth(month, year);
                const prevDay = (0, $d9oTA.default)(prevYear, prevMonth - 1) + prev;
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        }
    }, [
        triggerOnChange
    ]);
    const handleClickNextMonth = (0, $eJOHy.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$e11abbd67514b7e7$var$getNextMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'nextMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickNextYear = (0, $eJOHy.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year + 1,
            type: 'nextYear'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevMonth = (0, $eJOHy.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$e11abbd67514b7e7$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'prevMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevYear = (0, $eJOHy.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year - 1,
            type: 'prevYear'
        });
    }, [
        triggerOnChange
    ]);
    return {
        navigate: navigate,
        handleClickNextMonth: handleClickNextMonth,
        handleClickNextYear: handleClickNextYear,
        handleClickPrevMonth: handleClickPrevMonth,
        handleClickPrevYear: handleClickPrevYear
    };
}

});

parcelRegister("lPLOh", function(module, exports) {
$parcel$export(module.exports, "default", () => $395ce53b4353da25$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $h2Y6s = parcelRequire("h2Y6s");

var $fdbAT = parcelRequire("fdbAT");
function $395ce53b4353da25$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
    const dateRef = (0, $eJOHy.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $eJOHy.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnSelect = (0, $eJOHy.useCallback)(({ year: year, month: month, day: day })=>{
        const iso = (0, $fdbAT.default)({
            year: year,
            month: month,
            day: day
        });
        onSelect({
            day: day,
            month: month,
            year: year,
            iso: iso
        });
        setPreviouslySelectedValue(selectedValue);
        setSelectedValue([
            iso
        ]);
    }, [
        onSelect,
        selectedValue,
        setPreviouslySelectedValue,
        setSelectedValue
    ]);
    const handleClickDay = (0, $eJOHy.useCallback)(({ year: year, month: month, day: day })=>{
        triggerOnSelect({
            year: year,
            month: month,
            day: day
        });
    }, [
        triggerOnSelect
    ]);
    const handleContainerKeyDown = (0, $eJOHy.useCallback)((e)=>{
        const { key: key } = e;
        const arrowKey = (0, $h2Y6s.arrowKeys)[key];
        if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            triggerOnSelect(dateRef.current);
        } else if (arrowKey) {
            e.preventDefault();
            navigate(arrowKey);
        }
    }, [
        triggerOnSelect,
        navigate
    ]);
    return {
        handleClickDay: handleClickDay,
        handleContainerKeyDown: handleContainerKeyDown
    };
}

});

parcelRegister("jtNxE", function(module, exports) {
$parcel$export(module.exports, "default", () => $01a6b7d4c4da291b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cK9J2 = parcelRequire("cK9J2");
function $01a6b7d4c4da291b$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
    const l10n = (0, $eJOHy.useMemo)(()=>(0, $cK9J2.createLocalizationProvider)(locale), [
        locale
    ]);
    const monthsLong = (0, $eJOHy.useMemo)(()=>l10n.getMonthsLong(), [
        l10n
    ]);
    const daysShort = (0, $eJOHy.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    const daysLong = (0, $eJOHy.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    return {
        monthsLong: monthsLong,
        daysShort: daysShort,
        daysLong: daysLong
    };
}

});
parcelRegister("cK9J2", function(module, exports) {
$parcel$export(module.exports, "createLocalizationProvider", () => $2150f4a906bcb332$export$ea56ca58f08ffa52);

var $4ZGCx = parcelRequire("4ZGCx");

var $ktSIT = parcelRequire("ktSIT");

var $92aEh = parcelRequire("92aEh");
const $2150f4a906bcb332$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $4ZGCx.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date, options = {})=>(0, $ktSIT.createDateParser)(normalizedLocale)(date, options);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $92aEh.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $92aEh.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};

});
parcelRegister("4ZGCx", function(module, exports) {
$parcel$export(module.exports, "normalizeLocale", () => $caa7b379de4e9e4d$export$dca0327c9b9c6498);
const $caa7b379de4e9e4d$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("ktSIT", function(module, exports) {
$parcel$export(module.exports, "createDateParser", () => $f0407708fddca50b$export$cfa2ef2687faeda2);

var $4ZGCx = parcelRequire("4ZGCx");

var $61I7t = parcelRequire("61I7t");
const $f0407708fddca50b$var$INVALID_DATE = new Date(NaN);
const $f0407708fddca50b$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $f0407708fddca50b$var$INVARIANT_DATE = (0, $61I7t.toDate)($f0407708fddca50b$var$INVARIANT);
const $f0407708fddca50b$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $f0407708fddca50b$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $f0407708fddca50b$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $f0407708fddca50b$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $f0407708fddca50b$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $4ZGCx.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($f0407708fddca50b$var$INVARIANT_DATE);
    const shortDate = $f0407708fddca50b$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($f0407708fddca50b$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $f0407708fddca50b$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($f0407708fddca50b$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($f0407708fddca50b$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($f0407708fddca50b$var$INVARIANT.day);
    return (date, options = {})=>{
        const dateMatch = $f0407708fddca50b$var$stripExtras(date).match($f0407708fddca50b$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $f0407708fddca50b$var$INVALID_DATE;
        const dateParts = $f0407708fddca50b$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $61I7t.normalizeDate)(extractedDate, options?.defaultFirstDay);
        if (!(0, $61I7t.isValid)(normalizedDate)) return $f0407708fddca50b$var$INVALID_DATE;
        return (0, $61I7t.toDate)(normalizedDate);
    };
};

});
parcelRegister("61I7t", function(module, exports) {
$parcel$export(module.exports, "toDate", () => $862914b96a01ecbb$export$e67a095c620b86fe);
$parcel$export(module.exports, "isValid", () => $862914b96a01ecbb$export$1ea939691cdc45b8);
$parcel$export(module.exports, "normalizeDate", () => $862914b96a01ecbb$export$fcc71269590ba0a8);
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ const $862914b96a01ecbb$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
const $862914b96a01ecbb$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
const $862914b96a01ecbb$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
const $862914b96a01ecbb$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && $862914b96a01ecbb$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
const $862914b96a01ecbb$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = $862914b96a01ecbb$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
const $862914b96a01ecbb$export$fcc71269590ba0a8 = (date, defaultFirstDay = false)=>{
    const now = $862914b96a01ecbb$export$abe96da78d4f59dd(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});


parcelRegister("92aEh", function(module, exports) {
$parcel$export(module.exports, "toFormattedParts", () => $0bfc942d7a009811$export$9b7ca29af37c192);
const $0bfc942d7a009811$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});





parcelRegister("2NKTO", function(module, exports) {
$parcel$export(module.exports, "Checkbox", () => $c6f8b582c99e0355$export$48513f6b9f8ce62d);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $86tBw = parcelRequire("86tBw");

var $8AppO = parcelRequire("8AppO");
const $c6f8b582c99e0355$export$bf0162d825d6e13 = {
    testId: true,
    defaultChecked: true,
    isChecked: true,
    isIndeterminate: true,
    label: true,
    size: false
};
const $c6f8b582c99e0355$export$48513f6b9f8ce62d = (props)=>{
    const { testId: testId, defaultChecked: defaultChecked, isChecked: isChecked, isIndeterminate: isIndeterminate, label: label, id: // Field props
    id, isRequired: isRequired, isDisabled: isDisabled, isInvalid: isInvalid, onChange: onChange, onBlur: onBlur, onFocus: onFocus, value: value, "aria-invalid": ariaInvalid, "aria-labelledby": ariaLabelledby, name: name } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $86tBw.default), {
        testId: testId,
        defaultChecked: defaultChecked,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        label: label,
        // Field props
        id: id,
        isRequired: isRequired,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        onChange: (0, $8AppO.adaptEventHandler)(onChange),
        onBlur: (0, $8AppO.adaptEventHandler)(onBlur),
        onFocus: (0, $8AppO.adaptEventHandler)(onFocus),
        value: value,
        "aria-invalid": ariaInvalid,
        "aria-labelledby": ariaLabelledby,
        name: name
    });
}; /**
 * @codegenEnd
 */ 

});
parcelRegister("86tBw", function(module, exports) {
$parcel$export(module.exports, "default", () => $43629aa548cc82fb$export$2e2bcd8739ae039);
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jrFnt = parcelRequire("jrFnt");

var $gyJTO = parcelRequire("gyJTO");

var $cM2mi = parcelRequire("cM2mi");
var $jJLKy = parcelRequire("jJLKy");
var $9ywMw = parcelRequire("9ywMw");
var $lsp6q = parcelRequire("lsp6q");
const $43629aa548cc82fb$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef78r4n _1h6r8r4n _smzg1nfn _1dk71nfn _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $43629aa548cc82fb$var$Checkbox = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $eJOHy.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $eJOHy.useRef)(null);
    const mergedRefs = (0, $gyJTO.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $eJOHy.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $jJLKy.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $hcewu.default)([
                    $43629aa548cc82fb$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cM2mi.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9ywMw.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lsp6q.default), {})
                ]
            })
        ]
    });
}));
$43629aa548cc82fb$var$Checkbox.displayName = 'Checkbox';
var $43629aa548cc82fb$export$2e2bcd8739ae039 = $43629aa548cc82fb$var$Checkbox;

});
parcelRegister("cM2mi", function(module, exports) {
$parcel$export(module.exports, "default", () => $b89a586a6c2ef726$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $2Swhg = parcelRequire("2Swhg");

var $eGOwo = parcelRequire("eGOwo");
function $b89a586a6c2ef726$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        if ((0, $eGOwo.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        if ((0, $eGOwo.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $b89a586a6c2ef726$var$CheckboxIcon = /*#__PURE__*/ (0, $eJOHy.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $eJOHy.useMemo)(()=>$b89a586a6c2ef726$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2Swhg.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                (0, $eGOwo.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    }));
});
var $b89a586a6c2ef726$export$2e2bcd8739ae039 = $b89a586a6c2ef726$var$CheckboxIcon;

});

parcelRegister("jJLKy", function(module, exports) {
$parcel$export(module.exports, "default", () => $4573aabb850f2ff0$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $4573aabb850f2ff0$var$baseStyles = null;
const $4573aabb850f2ff0$var$textLabelLayoutStyles = null;
const $4573aabb850f2ff0$var$disabledStyles = null;
const $4573aabb850f2ff0$var$labelStyles = null;
function $4573aabb850f2ff0$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("label", {
        className: (0, $hcewu.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazj3m3 _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1tvo _80om13gf",
            "_h5e3mag2 _1nzs11d3 _1eszzyvw _yp0jhh5a _ay2w1y1w _d51u10ko _phft1fmg _1g1funzk _l6wkzyvw _1dikhh5a _1sfg1q3k _fpdj1y1w _1yjc194a _oaj11fmg _1j3h1q3k _eawb1dzn _1rda1qbb _18q015t7 _13hr3acm",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("9ywMw", function(module, exports) {
$parcel$export(module.exports, "default", () => $94306373cce3a9fe$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $94306373cce3a9fe$var$labelTextStyles = null;
function $94306373cce3a9fe$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("lsp6q", function(module, exports) {
$parcel$export(module.exports, "default", () => $bafcc116ddbb4544$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $bafcc116ddbb4544$var$requiredIndicatorStyles = null;
function $bafcc116ddbb4544$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "aria-hidden": true,
        className: (0, $hcewu.default)([
            "_syaz1gtz _bozgv77o"
        ]),
        children: "*"
    });
}

});



parcelRegister("dDkXW", function(module, exports) {
$parcel$export(module.exports, "CheckboxGroup", () => $07a9f4817df026f5$export$4aa08d5625cb8ead);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");

var $86tBw = parcelRequire("86tBw");
const $07a9f4817df026f5$export$4aa08d5625cb8ead = (props)=>{
    const { name: name, options: options, value: value, onChange: onChange, defaultValue: defaultValue = [], isDisabled: isDisabled = false } = props.forgeDoc.props;
    const [selectedValues, setSelectedValues] = (0, $eJOHy.useState)(value ?? defaultValue);
    (0, $eJOHy.useEffect)(()=>{
        if (value) setSelectedValues(value);
    }, [
        value
    ]);
    const notStaticCheckbox = !value || onChange;
    const onCheckboxChange = (0, $eJOHy.useCallback)((event)=>{
        if (notStaticCheckbox) {
            const newSelectedValues = selectedValues.includes(event.target.value) ? selectedValues.filter((item)=>item !== event.target.value) : [
                ...selectedValues,
                event.target.value
            ];
            setSelectedValues(newSelectedValues);
            if (onChange) onChange(newSelectedValues);
        }
    }, [
        notStaticCheckbox,
        onChange,
        selectedValues,
        setSelectedValues
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        role: "group",
        children: options.map((item, index)=>{
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $86tBw.default), {
                name: name,
                value: item.value,
                label: item.label,
                isChecked: selectedValues.includes(item.value),
                isDisabled: item.isDisabled ?? isDisabled,
                onChange: onCheckboxChange
            }, index);
        })
    });
};

});

parcelRegister("ahoNd", function(module, exports) {
$parcel$export(module.exports, "Code", () => $4fc7739695d8fb69$export$52f0f02147b12c03);
// Note: codeBidi props are not exposed to prevent misuse by malicious developers

var $gt9Am = parcelRequire("gt9Am");

var $6AaeA = parcelRequire("6AaeA");
parcelRequire("eJOHy");

var $esi81 = parcelRequire("esi81");
const $4fc7739695d8fb69$export$bf0162d825d6e13 = {
    children: {
        value: 'getTextFromForgeDocChildren(props.forgeDoc)',
        comment: 'Only render string children'
    },
    testId: true
};
const $4fc7739695d8fb69$export$52f0f02147b12c03 = (props)=>{
    const { testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $esi81.default), {
        // Only render string children
        children: (0, $6AaeA.getTextFromForgeDocChildren)(props.forgeDoc),
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});
parcelRegister("6AaeA", function(module, exports) {
$parcel$export(module.exports, "getTextFromForgeDocChildren", () => $977863af0bccc47e$export$550573b096470df3);
const $977863af0bccc47e$export$550573b096470df3 = (forgeDoc)=>{
    return forgeDoc.children.map((child)=>{
        if (child?.props?.text) return child.props?.text;
        else return '';
    });
};

});


parcelRegister("43wzl", function(module, exports) {
$parcel$export(module.exports, "CodeBlock", () => $7eaa3e01a9264a57$export$6c415d1fdae3dfdb);
// codeBidi props are not allowed to prevent malicious developers from misusing them.

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $JQPCf = parcelRequire("JQPCf");
const $7eaa3e01a9264a57$export$bf0162d825d6e13 = {
    text: true,
    testId: true,
    showLineNumbers: true,
    language: true,
    highlight: true,
    highlightedStartText: true,
    highlightedEndText: true,
    shouldWrapLongLines: true
};
const $7eaa3e01a9264a57$export$6c415d1fdae3dfdb = (props)=>{
    const { text: text, testId: testId, showLineNumbers: showLineNumbers, language: language, highlight: highlight, highlightedStartText: highlightedStartText, highlightedEndText: highlightedEndText, shouldWrapLongLines: shouldWrapLongLines } = props.forgeDoc.props;
    // warning: showLineNumbers is deprecated;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $JQPCf.default), {
        text: text,
        testId: testId,
        showLineNumbers: showLineNumbers,
        language: language,
        highlight: highlight,
        highlightedStartText: highlightedStartText,
        highlightedEndText: highlightedEndText,
        shouldWrapLongLines: shouldWrapLongLines
    });
}; /**
 * @codegenEnd
 */ 

});
parcelRegister("JQPCf", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d29b310f5adcbb7$export$2e2bcd8739ae039);
/* code-block.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $4eDgu = parcelRequire("4eDgu");

var $bRPNB = parcelRequire("bRPNB");

var $eGOwo = parcelRequire("eGOwo");

var $1wVTG = parcelRequire("1wVTG");

var $gvE0s = parcelRequire("gvE0s");

var $2qMvj = parcelRequire("2qMvj");

var $9LvmA = parcelRequire("9LvmA");
const $9d29b310f5adcbb7$var$getCodeBlockStyles = {
    codeFontFlagOn: "_11c81u0j",
    codeFontFlagOff: "_1wyb1crf _k48pi7a9 _ect41odn",
    root: "_2rko12b0 _1dqoglyw _1e0c1txw _vwz4gktf _1reo1wug _o572qvpr _1eimjvyg _bfhktkvp _syaz1fxt _1ozdn7od _7xinn7od _t7aun7od _r28du2gc _tajqu2gc _1ohiu2gc _m802u2gc _i6ntu2gc _1w2xu2gc _1hmyegat _vblregat _vbulegat _196q1j08 _1vbw1j08 _1v9c1j08 _1srn17d7 _18r6myb0 _vyvc1n1a _1d4j1y44 _1f8gstnw _1pzyb3bt _ra6gww7y _13cdh2mm _1pp0126e _zvy9f705 _qcxof705 _qzn01a66 _j0l11wug _1weckb7n _1na21hna _vsnzgrf3 _x7c815vq _lh0y15vq _1m3815vq _qk1e15vq _12l6ysn8 _uga3ysn8 _mx8b7mnp _1kr87mnp _xo19t94y _1bemt94y _nalpstnw _151dstnw _1exb1q9c _1hgu1q9c _1mgnt94y _nhket94y _h909m7j4 _scgayz1z _ipl81e17 _40uk1l04 _i81p1a66 _1gx21e5h _1ls0df4r _vm2c1rh5 _12ok1rh5 _1ls01ule _rude1ule _1q16glyw _1io6glyw _juomusic _lcwuusic _pyovu2gc _ccm6u2gc _1ascu2gc _1yuau2gc _xr0w1a66 _4io21a66 _euyxusvi _cahfusvi _zhnuidpf _1amdidpf _mbgcpf9b _bu7zpf9b _131n1giz _gy101giz _1wfuwrk5 _16kzwrk5 _9kk3moej _cjus1w1g _9k2r1m30 _nhmw1m30 _yl021m30 _eiht5x2v _t9zb5x2v _mqok1w1g _3hsg1w1g _i7ngn7od _9wu1fb2s _1xcoh55r _1t361fxt _137bh55r _1k7d1fxt _97lipnps _12nh9lu1 _1g0517qg _i2ig10m5 _326z1fxt _113p131l _1n6tpnps _tgu817qg _1k47pnps _g0lx1fxt _ys4e131l _7gp8h55r _1yvq10m5 _1vww10m5 _1rju10m5 _1v0lh55r _wmyy17qg _748n17qg _1mfn17qg _1d7e17qg _p2vr17qg _19o610m5 _kxov17qg _1np517qg _m2f517qg _1b9tpnps _1tq6pnps _1rd2pnps _1pbkpnps _k3lipnps _13zt131l _2g12fb2s _k86b10m5 _b5iy131l _gti3131l _1f0gpnps _9d3e17qg _qdiapnps _72uvpnps",
    showLineNumbers: "_170714ej _1i3h1txw _16noidpf _h4fuidpf _pp6yidpf _1g4tidpf _11wmidpf _1bx8idpf",
    dontShowLineNumbers: "_1i3h1ule _16nou2gc _h4fuu2gc _pp6yu2gc _1g4tu2gc _11wmu2gc _1bx8u2gc",
    shouldWrapLongLines: "_13dgkb7n",
    dontWrapLongLines: "_13dgkb7n"
};
/**
 * __Code block__
 *
 * A code block highlights an entire block of code and keeps the formatting.
 *
 * - [Examples](https://atlassian.design/components/code/code-block/examples)
 * - [Code](https://atlassian.design/components/code/code-block/code)
 * - [Usage](https://atlassian.design/components/code/code-block/usage)
 */ const $9d29b310f5adcbb7$var$CodeBlock = /*#__PURE__*/ (0, $eJOHy.memo)(function CodeBlock({ showLineNumbers: showLineNumbers = true, shouldShowLineNumbers: shouldShowLineNumbers, firstLineNumber: firstLineNumber = 1, language: providedLanguage = 'text', highlight: highlight = '', highlightedStartText: highlightedStartText = 'Highlight start', highlightedEndText: highlightedEndText = 'Highlight end', testId: testId, text: text, codeBidiWarnings: codeBidiWarnings = true, hasBidiWarnings: hasBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, isBidiWarningTooltipEnabled: isBidiWarningTooltipEnabled, shouldWrapLongLines: shouldWrapLongLines = false, label: label = 'Scrollable content' }) {
    const scrollableRef = (0, $eJOHy.useRef)(null);
    const [showContentFocus, setShowContentFocus] = (0, $eJOHy.useState)(false);
    // Use children if provided, otherwise fall back to deprecated text prop
    const numLines = (text || '').split('\n').length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
    const lineNumberWidth = numLines ? (0, $gvE0s.getLineNumWidth)(numLines) : 0;
    // Use new props if provided, otherwise fall back to deprecated props
    const shouldShowLineNumbersValue = shouldShowLineNumbers !== undefined ? shouldShowLineNumbers : showLineNumbers;
    const shouldShowBidiWarnings = hasBidiWarnings !== undefined ? hasBidiWarnings : codeBidiWarnings;
    const shouldEnableTooltip = isBidiWarningTooltipEnabled !== undefined ? isBidiWarningTooltipEnabled : codeBidiWarningTooltipEnabled;
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $eJOHy.useEffect)(()=>{
        const schedule = (0, $bRPNB.default)(()=>{
            const target = scrollableRef.current;
            target && setShowContentFocus(target.scrollWidth > target.clientWidth);
        });
        schedule();
        const unbindWindowEvent = (0, $4eDgu.bind)(window, {
            type: 'resize',
            listener: schedule
        });
        return unbindWindowEvent;
    }, [
        scrollableRef
    ]);
    const { getHighlightStyles: getHighlightStyles, highlightedLines: highlightedLines } = (0, $1wVTG.useHighlightLines)({
        highlight: highlight,
        testId: testId
    });
    const getLineProps = (0, $eJOHy.useCallback)((line)=>getHighlightStyles(line, highlightedLines), [
        getHighlightStyles,
        highlightedLines
    ]);
    const language = (0, $eJOHy.useMemo)(()=>(0, $2qMvj.normalizeLanguage)(providedLanguage), [
        providedLanguage
    ]);
    // https://product-fabric.atlassian.net/browse/DST-2472
    const languageToUse = text ? language : 'text';
    // https://product-fabric.atlassian.net/browse/DSP-22927
    const useCodeFont = (0, $eGOwo.fg)('platform_dst_code-token');
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9LvmA.default), {
        "data-code-lang": language,
        "data-ds--code--code-block": "",
        testId: testId,
        language: languageToUse,
        style: {
            '--ads-code-line-number-width': `calc(${lineNumberWidth} + 16px)`,
            '--ads-highlighted-start-text': highlightedStartText,
            '--ads-highlighted-end-text': highlightedEndText
        },
        showLineNumbers: shouldShowLineNumbersValue,
        firstLineNumber: firstLineNumber,
        lineProps: getLineProps,
        // shouldCreateParentElementForLines is needed to pass down props to each line.
        // This is necessary for both line highlighting and testId's, as each of
        // these rely on a data attribute being passed down to lines.
        shouldCreateParentElementForLines: highlight.length > 0 || !!testId,
        shouldWrapLongLines: shouldWrapLongLines,
        codeBidiWarnings: shouldShowBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: shouldEnableTooltip,
        text: text,
        tabIndex: showContentFocus ? '0' : undefined,
        "aria-label": showContentFocus ? label : undefined,
        role: showContentFocus ? 'region' : undefined,
        scrollRef: scrollableRef,
        className: (0, $hcewu.default)([
            useCodeFont ? $9d29b310f5adcbb7$var$getCodeBlockStyles.codeFontFlagOn : $9d29b310f5adcbb7$var$getCodeBlockStyles.codeFontFlagOff,
            $9d29b310f5adcbb7$var$getCodeBlockStyles.root,
            shouldWrapLongLines ? $9d29b310f5adcbb7$var$getCodeBlockStyles.shouldWrapLongLines : $9d29b310f5adcbb7$var$getCodeBlockStyles.dontWrapLongLines,
            shouldShowLineNumbersValue ? $9d29b310f5adcbb7$var$getCodeBlockStyles.showLineNumbers : $9d29b310f5adcbb7$var$getCodeBlockStyles.dontShowLineNumbers
        ])
    });
});
var $9d29b310f5adcbb7$export$2e2bcd8739ae039 = $9d29b310f5adcbb7$var$CodeBlock;

});
parcelRegister("1wVTG", function(module, exports) {
$parcel$export(module.exports, "useHighlightLines", () => $118a07406fdcc42b$export$84415a200bdf33ed);

var $eJOHy = parcelRequire("eJOHy");
const $118a07406fdcc42b$var$DEFAULT_LINE_EL_ATTR_OBJ = {
    'data-ds--code--row': ''
};
const $118a07406fdcc42b$var$getLineStyleObject = (lineNumber, testId)=>{
    return testId ? {
        'data-testid': `${testId}-line-${lineNumber}`,
        ...$118a07406fdcc42b$var$DEFAULT_LINE_EL_ATTR_OBJ
    } : $118a07406fdcc42b$var$DEFAULT_LINE_EL_ATTR_OBJ;
};
const $118a07406fdcc42b$export$84415a200bdf33ed = ({ highlight: highlight = '', testId: testId })=>{
    const highlightedLines = (0, $eJOHy.useMemo)(()=>{
        if (!highlight) return [];
        return highlight.split(',').map((num)=>{
            if (num.indexOf('-') > 0) {
                // We found a line group, e.g. 1-3
                const [from, to] = num.split('-').map(Number)// Sort by lowest value first, highest value last.
                .sort((a, b)=>a - b);
                return Array(to + 1).fill(undefined).map((_, index)=>index).slice(from, to + 1);
            }
            return Number(num);
        }).reduce((acc, val)=>acc.concat(val), []) || [];
    }, [
        highlight
    ]);
    const getHighlightStyles = (0, $eJOHy.useCallback)((lineNumber, highlightedLines)=>{
        if (!highlight || highlightedLines.length === 0) return $118a07406fdcc42b$var$getLineStyleObject(lineNumber, testId);
        if (highlightedLines.includes(lineNumber)) {
            const highlightedDataAttrObj = {
                'data-ds--code--row--highlight': ''
            };
            return {
                ...highlightedDataAttrObj,
                ...$118a07406fdcc42b$var$getLineStyleObject(lineNumber, testId)
            };
        }
        return $118a07406fdcc42b$var$getLineStyleObject(lineNumber, testId);
    }, [
        highlight,
        testId
    ]);
    return {
        getHighlightStyles: getHighlightStyles,
        highlightedLines: highlightedLines
    };
};

});

parcelRegister("gvE0s", function(module, exports) {
$parcel$export(module.exports, "getLineNumWidth", () => $505da49d0d7d5a0b$export$cb7aec0206b595d2);
const $505da49d0d7d5a0b$export$cb7aec0206b595d2 = (numLines)=>{
    return !numLines ? '1ch' : `${numLines.toFixed(0).length}ch`;
};

});

parcelRegister("2qMvj", function(module, exports) {
$parcel$export(module.exports, "normalizeLanguage", () => $aca27a94c0d64a9d$export$f38728011c178796);

var $LFmXM = parcelRequire("LFmXM");

var $236Qa = parcelRequire("236Qa");
const $aca27a94c0d64a9d$export$f38728011c178796 = (0, $LFmXM.default)((language)=>{
    if (!language) return '';
    const match = (0, $236Qa.SUPPORTED_LANGUAGES).find((val)=>{
        return val.name === language || val.alias.includes(language);
    });
    // Fallback to plain monospaced text if language passed but not supported
    return match ? match.value : 'text';
});

});
parcelRegister("236Qa", function(module, exports) {
$parcel$export(module.exports, "SUPPORTED_LANGUAGES", () => $32521280e8fb1b12$export$7c77c3a9bb93870d);
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages

const $32521280e8fb1b12$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'TOML',
        alias: [
            'toml'
        ],
        value: 'toml'
    },
    {
        name: 'Handlebars',
        alias: [
            'handlebars',
            'mustache'
        ],
        value: 'handlebars'
    },
    {
        name: 'Gherkin',
        alias: [
            'gherkin',
            'cucumber'
        ],
        value: 'gherkin'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    },
    {
        name: 'Markdown',
        alias: [
            'markdown'
        ],
        value: 'markdown'
    }
];

});


parcelRegister("9LvmA", function(module, exports) {
$parcel$export(module.exports, "default", () => $5cdbe531236814ef$export$2e2bcd8739ae039);
/**
 * Original library: https://github.com/react-syntax-highlighter/react-syntax-highlighter
 * All modifications by Atlassian
 */ /**
 * MIT License
 *
 * Copyright (c) 2019 Conor Hastings
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * __Syntax Highlighter__
 *
 * A syntax highlighter based on top of [refractor](https://github.com/wooorm/refractor).
 * @atlaskit/code uses this under-the-hood, but it is not intended for public consumption.
 * You should be using @atlaskit/code directly.
 */ 
var $2Csjy = parcelRequire("2Csjy");
var $5cdbe531236814ef$export$2e2bcd8739ae039 = (0, $2Csjy.default);

});
parcelRegister("2Csjy", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a371b7eb48e23c4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $9JmNq = parcelRequire("9JmNq");
// Uses the loader method of async bundling
// Instantiates highligher as a singleton, loading refractor only once per page (refractor/prism are singleton modules)
const $1a371b7eb48e23c4$var$generator = (options)=>{
    const { loader: loader } = options;
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class AsyncHighlighter extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
        static{
            this.astGenerator = null;
        }
        static{
            this.highlightInstance = (0, $9JmNq.default);
        }
        // Useful in tests
        static preload() {
            return AsyncHighlighter.loadAstGenerator();
        }
        static loadAstGenerator() {
            AsyncHighlighter.astGeneratorPromise = loader().then((astGenerator)=>{
                AsyncHighlighter.astGenerator = astGenerator;
                return astGenerator;
            });
            return AsyncHighlighter.astGeneratorPromise;
        }
        componentDidMount() {
            if (!AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.loadAstGenerator();
            if (!AsyncHighlighter.astGenerator && AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.astGeneratorPromise.then(()=>{
                this.forceUpdate();
            });
        }
        render() {
            return /*#__PURE__*/ (0, $gt9Am.jsx)(AsyncHighlighter.highlightInstance, {
                ...this.props,
                astGenerator: AsyncHighlighter.astGenerator
            });
        }
    }
    return AsyncHighlighter;
};

const $1a371b7eb48e23c4$var$asyncGenerator = $1a371b7eb48e23c4$var$generator({
    loader: ()=>(parcelRequire("1WK8s")).then((module)=>{
            // Webpack 3 returns module.exports as default as module, but webpack 4 returns module.exports as module.default
            return module.default || module;
        })
});
var $1a371b7eb48e23c4$export$2e2bcd8739ae039 = $1a371b7eb48e23c4$var$asyncGenerator;

});
parcelRegister("9JmNq", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb3e56997f5681d6$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $31Mrt = parcelRequire("31Mrt");

var $aRMho = parcelRequire("aRMho");
/**
 * Takes in a code string and (in the default behaviour):
 * - Uses refractor to turn it into a tree structure with highlighting metadata
 * - Collapses this tree into lines for a renderer
 * - Passes these lines to a React renderer
 *
 * In future, the final step could have a custom renderer.
 */ const $bb3e56997f5681d6$var$Highlight = /*#__PURE__*/ (0, $eJOHy.memo)(function Highlight({ language: language = 'text', testId: testId, text: text = '', codeTagProps: codeTagProps = {
    className: `language-${language}`
}, showLineNumbers: showLineNumbers = false, firstLineNumber: firstLineNumber = 1, shouldCreateParentElementForLines: shouldCreateParentElementForLines = false, shouldWrapLongLines: shouldWrapLongLines = false, lineProps: lineProps = {}, codeBidiWarnings: codeBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, astGenerator: astGenerator = null, ...rest }) {
    // TODO maybe we call this code or text everywhere; for now we match the API in
    // @atlaskit/codeblock
    const code = text;
    const generatorClassName = 'prismjs';
    const containerProps = {
        ...rest,
        ref: rest.scrollRef,
        'data-testid': testId,
        className: rest.className ? `${generatorClassName} ${rest.className}` : generatorClassName
    };
    if (containerProps.hasOwnProperty('scrollRef')) delete containerProps['scrollRef'];
    if (shouldWrapLongLines) codeTagProps.style = {
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word'
    };
    else codeTagProps.style = {
        whiteSpace: 'pre'
    };
    const codeBidiWarningConfig = {
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
    };
    // Tree + logic into rows
    const rows = (0, $31Mrt.default)({
        astGenerator: astGenerator,
        code: code,
        language: language,
        shouldCreateParentElementForLines: shouldCreateParentElementForLines || !!shouldWrapLongLines,
        lineProps: lineProps,
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber
    });
    // Rows + logic into a renderer
    return (0, $aRMho.default)({
        containerProps: containerProps,
        codeTagProps: codeTagProps,
        rows: rows,
        codeBidiWarningConfig: codeBidiWarningConfig
    });
});
var $bb3e56997f5681d6$export$2e2bcd8739ae039 = $bb3e56997f5681d6$var$Highlight;

});
parcelRegister("31Mrt", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad9006a9331ecad2$export$2e2bcd8739ae039);

var $iWzFr = parcelRequire("iWzFr");

var $8RUxU = parcelRequire("8RUxU");

var $26DGa = parcelRequire("26DGa");

var $f2iL7 = parcelRequire("f2iL7");
const $ad9006a9331ecad2$var$newLineRegex = /\n/g;
function $ad9006a9331ecad2$var$getNewLines(str) {
    return str.match($ad9006a9331ecad2$var$newLineRegex);
}
function $ad9006a9331ecad2$export$2e2bcd8739ae039({ astGenerator: astGenerator, code: code, language: language, shouldCreateParentElementForLines: shouldCreateParentElementForLines, lineProps: lineProps, showLineNumbers: showLineNumbers, firstLineNumber: firstLineNumber = 1 }) {
    const codeTree = (0, $f2iL7.default)(language, code, astGenerator);
    const startingLineNumber = firstLineNumber > 0 ? firstLineNumber : 1;
    const createLine = (0, $iWzFr.default)(lineProps, shouldCreateParentElementForLines, showLineNumbers);
    const newTree = [];
    let lastLineBreakIndex = -1;
    let index = 0;
    // Seems odd we flatten the tree immediately - what work could we do on it more performantly than on the lines?
    const tree = (0, $26DGa.default)(codeTree);
    while(index < tree.length){
        const testNode = tree[index];
        if (testNode.type === 'text') {
            index++;
            continue;
        }
        const node = testNode;
        const firstChildNode = node.children[0];
        if (firstChildNode.type === 'text') {
            const { value: value } = firstChildNode;
            const newLines = $ad9006a9331ecad2$var$getNewLines(value);
            if (newLines) {
                const splitValue = value.split('\n');
                splitValue.forEach((text, i)=>{
                    const lineNumber = newTree.length + startingLineNumber;
                    const newChild = {
                        type: 'text',
                        value: `${text}\n`
                    };
                    // if it's the first line
                    if (i === 0) {
                        const children = tree.slice(lastLineBreakIndex + 1, index).concat((0, $8RUxU.default)({
                            children: [
                                newChild
                            ],
                            className: node.properties.className,
                            lineNumber: lineNumber
                        }));
                        const line = createLine(children, lineNumber);
                        newTree.push(line);
                    // if it's the last line
                    } else if (i === splitValue.length - 1) {
                        const nextNode = tree[index + 1];
                        const stringChild = nextNode && nextNode.children && nextNode.children[0];
                        // Similar to newChild above, but no newline
                        const lastLineInPreviousSpan = {
                            type: 'text',
                            value: `${text}`
                        };
                        if (stringChild) {
                            const newElem = (0, $8RUxU.default)({
                                children: [
                                    lastLineInPreviousSpan
                                ],
                                className: node.properties.className,
                                lineNumber: lineNumber
                            });
                            tree.splice(index + 1, 0, newElem);
                        } else {
                            const children = [
                                lastLineInPreviousSpan
                            ];
                            const line = createLine(children, lineNumber, node.properties.className);
                            newTree.push(line);
                        }
                    // if it's neither the first nor the last line
                    } else {
                        const children = [
                            newChild
                        ];
                        const line = createLine(children, lineNumber, node.properties.className);
                        newTree.push(line);
                    }
                });
                lastLineBreakIndex = index;
            }
        }
        index++;
    }
    if (lastLineBreakIndex !== tree.length - 1) {
        const children = tree.slice(lastLineBreakIndex + 1, tree.length);
        if (children && children.length) {
            const lineNumber = newTree.length + startingLineNumber;
            const line = createLine(children, lineNumber);
            newTree.push(line);
        }
    }
    if (shouldCreateParentElementForLines) return newTree;
    // If shouldCreateParentElementForLines was off, we still have a tree structure we need to flatten
    // We have (RefractorNode | RefractorNode[])[] but need RefractorNode[]
    // This seems like a code smell to review
    return newTree.flat(1);
}

});
parcelRegister("iWzFr", function(module, exports) {
$parcel$export(module.exports, "default", () => $4195943504268cef$export$2e2bcd8739ae039);

var $8RUxU = parcelRequire("8RUxU");

var $cyPrZ = parcelRequire("cyPrZ");
function $4195943504268cef$var$createLineGenerator(lineProps, shouldCreateParentElementForLines, showLineNumbers) {
    return (children, lineNumber, className = [])=>{
        // Needed for more complex line creation
        if (shouldCreateParentElementForLines || className.length > 0) return (0, $8RUxU.default)({
            children: children,
            lineNumber: lineNumber,
            showLineNumbers: showLineNumbers,
            lineProps: lineProps,
            className: className
        });
        else {
            // Simple line creation without the bells and whistles
            if (showLineNumbers && lineNumber) children.unshift((0, $cyPrZ.default)(lineNumber));
            return children;
        }
    };
}
var $4195943504268cef$export$2e2bcd8739ae039 = $4195943504268cef$var$createLineGenerator;

});
parcelRegister("8RUxU", function(module, exports) {
$parcel$export(module.exports, "default", () => $20548ef38714ae82$export$2e2bcd8739ae039);

var $cyPrZ = parcelRequire("cyPrZ");
function $20548ef38714ae82$export$2e2bcd8739ae039({ children: children, lineNumber: lineNumber, showLineNumbers: showLineNumbers, shouldShowLineNumbers: shouldShowLineNumbers, lineProps: lineProps = {}, className: className = [] }) {
    // Use new prop if provided, otherwise fall back to deprecated prop
    const shouldShowLineNumbersValue = shouldShowLineNumbers !== undefined ? shouldShowLineNumbers : showLineNumbers;
    const propsPassedInFromCodeBlock = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
    const properties = {
        ...propsPassedInFromCodeBlock,
        className: className
    };
    let currentChildren = children;
    if (lineNumber && shouldShowLineNumbersValue) {
        // When syntax highlighting is NOT turned on, the entire LOC is just a single
        // child. We can then happily create the line number and the LOC as siblings...
        if (currentChildren.length === 1) currentChildren = [
            (0, $cyPrZ.default)(lineNumber),
            ...currentChildren
        ];
        else // ... However, when syntax highlighting IS on, a span is created for each
        // tokenised node in the AST (eg. <span>import</span><span>React</span>).
        // When shouldWrapLongLines is true, the row becomes `display: flex` and
        // forces all its children to be equal height. This can be a source of
        // visual bugs where a LOC is broken up weirdly into segments.
        //
        //  +---------------------------------------+
        //  | row                                   |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  |  |line| |key    | |keywords| |key   | |
        //  |  |no. | |word   | |        | |word  | |
        //  |  |    | |       | |        | |      | |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  +---------------------------------------+
        //
        // Nesting the children one layer deeper (i.e. creating an extra span)
        // ensures that the line number and the ENTIRE line of code are aligned by
        // the parent flexbox (the row).
        //
        //  +---------------------------------------------+
        //  | row                                         |
        //  | +----+  +--------------------------------+  |
        //  | |line|  | extra span we are creating     |  |
        //  | |no. |  |  +-------+ +--------+ +------+ |  |
        //  | |    |  |  |key    | |keywords| |key   | |  |
        //  | |    |  |  |word   | |        | |word  | |  |
        //  | |    |  |  |       | |        | |      | |  |
        //  | |    |  |  +-------+ +--------+ +------+ |  |
        //  | +----+  +--------------------------------+  |
        //  +---------------------------------------------+
        //
        currentChildren = [
            (0, $cyPrZ.default)(lineNumber),
            {
                type: 'element',
                tagName: 'span',
                properties: {
                    className: []
                },
                children: currentChildren
            }
        ];
    }
    return {
        type: 'element',
        tagName: 'span',
        properties: properties,
        children: currentChildren
    };
}

});
parcelRegister("cyPrZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $03d9e4c0cc14d81b$export$2e2bcd8739ae039);
function $03d9e4c0cc14d81b$export$2e2bcd8739ae039(lineNumber) {
    return {
        type: 'element',
        tagName: 'span',
        properties: {
            key: `line-number--${lineNumber}`,
            className: [
                'comment',
                'linenumber',
                'ds-line-number'
            ],
            // We're placing the lineNumber in a data-attr on an empty span (hence the
            // empty children array below). This allows CodeBlock to use CSS to
            // generate the content in a pseudo-element, which is a fix for a bug
            // where line numbers were being copied (CSS content can't be copied)
            // https://product-fabric.atlassian.net/browse/DSP-2729
            'data-ds--line-number': lineNumber
        },
        children: []
    };
}

});



parcelRegister("26DGa", function(module, exports) {
$parcel$export(module.exports, "default", () => $380a054e11b3c43e$export$2e2bcd8739ae039);

var $8RUxU = parcelRequire("8RUxU");
function $380a054e11b3c43e$export$2e2bcd8739ae039(tree, offset = 0, className = []) {
    let newTree = [];
    for(let i = 0; i < tree.length; i++){
        const node = tree[i];
        if (node.type === 'text') newTree.push((0, $8RUxU.default)({
            children: [
                node
            ],
            lineNumber: offset,
            className: className
        }));
        else if (node.children) {
            const classNames = className.concat(node.properties.className || []);
            $380a054e11b3c43e$export$2e2bcd8739ae039(node.children, offset + 1, classNames).forEach((i)=>newTree.push(i));
        }
    }
    return newTree;
}

});

parcelRegister("f2iL7", function(module, exports) {
$parcel$export(module.exports, "default", () => $a951287c386786be$export$2e2bcd8739ae039);
function $a951287c386786be$export$2e2bcd8739ae039(language, code, astGenerator) {
    if (language === 'text' || !astGenerator) return [
        {
            type: 'text',
            value: code
        }
    ];
    try {
        return astGenerator.highlight(code, language);
    } catch (e) {
        return [
            {
                type: 'text',
                value: code
            }
        ];
    }
}

});


parcelRegister("aRMho", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ec570abb3fe649d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $JWUl7 = parcelRequire("JWUl7");
function $9ec570abb3fe649d$export$2e2bcd8739ae039({ containerProps: containerProps, codeTagProps: codeTagProps, rows: rows, codeBidiWarningConfig: codeBidiWarningConfig }) {
    const renderedRows = rows.map((node, i)=>(0, $JWUl7.default)({
            node: node,
            codeBidiWarningConfig: codeBidiWarningConfig,
            key: `code-segment${i}`
        }));
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...containerProps,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("code", {
            ...codeTagProps,
            children: renderedRows
        })
    });
}

});
parcelRegister("JWUl7", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed639690821efdab$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hDNIq = parcelRequire("hDNIq");

var $2E9Su = parcelRequire("2E9Su");

var $a4ixf = parcelRequire("a4ixf");
function $ed639690821efdab$var$createClassNameString(classNames) {
    return classNames ? classNames.join(' ') : '';
}
function $ed639690821efdab$export$2e2bcd8739ae039({ node: node, codeBidiWarningConfig: codeBidiWarningConfig, key: key }) {
    if (node.type === 'text') {
        const { value: value } = node;
        // occasionally a numeric value is passed when the type is text
        const textValue = `${value}`;
        if (codeBidiWarningConfig.codeBidiWarnings) {
            const decorated = (0, $2E9Su.default)(textValue, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hDNIq.default), {
                    bidiCharacter: bidiCharacter,
                    label: codeBidiWarningConfig.codeBidiWarningLabel,
                    isTooltipEnabled: codeBidiWarningConfig.codeBidiWarningTooltipEnabled
                }, index));
            return decorated;
        }
        return textValue;
    } else {
        const { properties: properties, tagName: tagName } = node;
        const childrenCreator = (0, $a4ixf.default)(codeBidiWarningConfig);
        const props = {
            ...properties,
            className: $ed639690821efdab$var$createClassNameString(properties.className)
        };
        const children = childrenCreator(node.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(tagName, {
            key: key,
            ...props
        }, children);
    }
}

});
parcelRegister("a4ixf", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0ac4ebb91026fe6$export$2e2bcd8739ae039);

var $JWUl7 = parcelRequire("JWUl7");
function $e0ac4ebb91026fe6$export$2e2bcd8739ae039(codeBidiWarningConfig) {
    let childrenCount = 0;
    return (children)=>{
        childrenCount += 1;
        return children.map((child, i)=>(0, $JWUl7.default)({
                node: child,
                codeBidiWarningConfig: codeBidiWarningConfig,
                key: `code-segment-${childrenCount}-${i}`
            }));
    };
}

});




parcelRegister("1WK8s", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5sFLQ").then(()=>parcelRequire('5eKjD'));

});





parcelRegister("9lJqz", function(module, exports) {
$parcel$export(module.exports, "Comment", () => $86e6119183b5ed1b$export$4d299b491347818a);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8AppO = parcelRequire("8AppO");

var $9KjXM = parcelRequire("9KjXM");
var $9t4p2 = parcelRequire("9t4p2");
var $03sUt = parcelRequire("03sUt");
var $1HgJQ = parcelRequire("1HgJQ");
var $c5ML0 = parcelRequire("c5ML0");
const $86e6119183b5ed1b$export$4d299b491347818a = (props)=>{
    const { actions: actions, afterContent: afterContent, author: author, edited: edited, errorActions: errorActions, errorIconLabel: errorIconLabel, headingLevel: headingLevel, highlighted: highlighted, id: id, isError: isError, isSaving: isSaving, restrictedTo: restrictedTo, savingText: savingText, shouldRenderNestedCommentsInline: shouldRenderNestedCommentsInline, testId: testId, time: time, type: type } = props.forgeDoc.props;
    const avatarForgeDoc = props.forgeDoc.children.find((child)=>{
        if (child.type === 'ContentWrapper' && child.props?.name === 'avatar') return child;
    });
    const contentForgeDoc = props.forgeDoc.children.find((child)=>{
        if (child.type === 'ContentWrapper' && child.props?.name === 'content') return child;
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c5ML0.default), {
        actions: actions?.map((action, index)=>{
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9KjXM.default), {
                onClick: (0, $8AppO.adaptEventHandler)(action?.onClick),
                children: action.text
            }, index);
        }),
        afterContent: afterContent,
        author: author ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9t4p2.default), {
            onClick: (0, $8AppO.adaptEventHandler)(author?.onClick),
            children: author.text
        }) : undefined,
        avatar: avatarForgeDoc?.children.map(props.render),
        children: props.forgeDoc.children.filter((child)=>child.type !== 'ContentWrapper').map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                children: props.render(c)
            }, c.key)),
        content: contentForgeDoc?.children.map(props.render),
        edited: edited ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $03sUt.default), {
            children: edited
        }) : undefined,
        errorActions: errorActions?.map((action, index)=>{
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9KjXM.default), {
                onClick: (0, $8AppO.adaptEventHandler)(action?.onClick),
                children: action.text
            }, index);
        }),
        errorIconLabel: errorIconLabel,
        headingLevel: headingLevel,
        highlighted: highlighted,
        id: id,
        isError: isError,
        isSaving: isSaving,
        restrictedTo: restrictedTo,
        savingText: savingText,
        shouldRenderNestedCommentsInline: shouldRenderNestedCommentsInline,
        testId: testId,
        time: time ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1HgJQ.default), {
            onClick: (0, $8AppO.adaptEventHandler)(time?.onClick),
            children: time.text
        }) : undefined,
        type: type
    });
};

});
parcelRegister("9KjXM", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c92a0f8f871e3fe$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $goZPP = parcelRequire("goZPP");
const $6c92a0f8f871e3fe$var$ActionItem = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, onClick: providedOnClick, onFocus: onFocus, onMouseOver: onMouseOver, isDisabled: isDisabled }, ref)=>{
    const onClick = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>providedOnClick && providedOnClick(event, analyticsEvent),
        action: 'clicked',
        componentName: 'commentAction',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    return(/**
     * It is not normally acceptable to add click and key handlers to non-interactive
     * elements as this is an accessibility anti-pattern. However, because this
     * instance is to add support for analytics instead of creating an inaccessible
     * custom element, we can add role="presentation" so that there are no negative
     * impacts to assistive technologies.
     */ // eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        role: "presentation",
        onClick: onClick,
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
            ref: ref,
            appearance: "subtle-link",
            spacing: "none",
            type: "button",
            isDisabled: isDisabled,
            children: children
        })
    }));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6c92a0f8f871e3fe$export$2e2bcd8739ae039 = $6c92a0f8f871e3fe$var$ActionItem;

});

parcelRegister("9t4p2", function(module, exports) {
$parcel$export(module.exports, "default", () => $7709281d8408a743$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $cDmUI = parcelRequire("cDmUI");
const $7709281d8408a743$var$Author = ({ children: children, href: href, onClick: providedOnClick, onFocus: onFocus, onMouseOver: onMouseOver })=>{
    const onClick = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>providedOnClick && providedOnClick(event, analyticsEvent),
        action: 'clicked',
        componentName: 'commentAuthor',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cDmUI.default), {
        hasAuthor: true,
        href: href,
        onClick: onClick,
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        children: children
    });
};
$7709281d8408a743$var$Author.displayName = 'CommentAuthor';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7709281d8408a743$export$2e2bcd8739ae039 = $7709281d8408a743$var$Author;

});
parcelRegister("cDmUI", function(module, exports) {
$parcel$export(module.exports, "default", () => $92574fe7910bd750$export$2e2bcd8739ae039);
/* field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $lc0OY = parcelRequire("lc0OY");
const $92574fe7910bd750$var$textStyles = {
    root: "_syaz1gjq"
};
const $92574fe7910bd750$var$anchorStyles = {
    root: "_4bfu18uv _1hmsglyw _ajmmnqa1 _9oik18uv _1bnx8stv _jf4cnqa1 _30l314q2 _1nrm18uv _c2waglyw _1iohnqa1 _9h8h16c2"
};
const $92574fe7910bd750$var$noAuthorStyles = {
    root: "_k48p1kw7"
};
const $92574fe7910bd750$var$hasAuthorStyles = {
    root: "_k48p1wq8"
};
/**
 * __Field__
 *
 * A field appears in the comment header to add metadata to the comment.
 *
 * @internal
 */ const $92574fe7910bd750$var$Field = ({ children: children, hasAuthor: hasAuthor, href: href, onClick: onClick, onFocus: onFocus, onMouseOver: onMouseOver, testId: testId })=>{
    return href ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lc0OY.default), {
        href: href,
        xcss: (0, $6qaBj.cx)($92574fe7910bd750$var$textStyles.root, $92574fe7910bd750$var$anchorStyles.root, hasAuthor ? $92574fe7910bd750$var$hasAuthorStyles.root : $92574fe7910bd750$var$noAuthorStyles.root),
        onClick: onClick,
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        testId: testId,
        children: children
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        /**
   * It is not normally acceptable to add key handlers to non-interactive elements
   * as this is an accessibility anti-pattern. However, because this instance is
   * to add support for analytics instead of creating an inaccessible
   * custom element, we can add role="presentation" so that there are no negative
   * impacts to assistive technologies.
   */ role: "presentation",
        onClick: onClick,
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        "data-testid": testId,
        className: (0, $hcewu.default)([
            $92574fe7910bd750$var$textStyles.root,
            hasAuthor ? $92574fe7910bd750$var$hasAuthorStyles.root : $92574fe7910bd750$var$noAuthorStyles.root
        ]),
        children: children
    });
};
var $92574fe7910bd750$export$2e2bcd8739ae039 = $92574fe7910bd750$var$Field;

});


parcelRegister("03sUt", function(module, exports) {
$parcel$export(module.exports, "default", () => $02c18c2f02c9d3e0$export$2e2bcd8739ae039);
/* edited.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
parcelRequire("eJOHy");
const $02c18c2f02c9d3e0$var$editedContentStyles = {
    root: "_syaz1wmz"
};
const $02c18c2f02c9d3e0$var$Edited = ({ children: children, onFocus: onFocus, onMouseOver: onMouseOver })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        className: (0, $hcewu.default)([
            $02c18c2f02c9d3e0$var$editedContentStyles.root
        ]),
        children: children
    });
$02c18c2f02c9d3e0$var$Edited.displayName = 'Edited';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$02c18c2f02c9d3e0$export$2e2bcd8739ae039 = $02c18c2f02c9d3e0$var$Edited;

});

parcelRegister("1HgJQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f01b4d39ce5280b9$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $cDmUI = parcelRequire("cDmUI");
const $f01b4d39ce5280b9$var$CommentTime = ({ children: children, href: href, onClick: providedOnClick, onFocus: onFocus, onMouseOver: onMouseOver })=>{
    const onClick = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>providedOnClick && providedOnClick(event, analyticsEvent),
        action: 'clicked',
        componentName: 'commentTime',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cDmUI.default), {
        href: href,
        onClick: onClick,
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        children: children
    });
};
$f01b4d39ce5280b9$var$CommentTime.displayName = 'CommentTime';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f01b4d39ce5280b9$export$2e2bcd8739ae039 = $f01b4d39ce5280b9$var$CommentTime;

});

parcelRegister("c5ML0", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9c450faebe35312$export$2e2bcd8739ae039);
/* comment.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
var $78OnL = parcelRequire("78OnL");

var $8TN86 = parcelRequire("8TN86");

var $38ymg = parcelRequire("38ymg");

var $ccUTU = parcelRequire("ccUTU");
const $c9c450faebe35312$var$textStyles = {
    root: "_syaz1fxt",
    disabled: "_syaz1lh4"
};
/**
 * __Comment__
 *
 * Comments enable discussions on an entity such as a page, blog post, work item, or pull request.
 */ const $c9c450faebe35312$var$Comment = ({ actions: actions = [], restrictedTo: restrictedTo = '', highlighted: highlighted = false, isSaving: isSaving = false, savingText: savingText = 'Sending...', isError: isError = false, errorActions: errorActions = [], errorIconLabel: errorIconLabel = '', author: author, avatar: avatar, children: children, content: content, edited: edited, time: time, type: type, testId: testId, id: id, afterContent: afterContent, shouldRenderNestedCommentsInline: shouldRenderNestedCommentsInline, headingLevel: headingLevel = '3', shouldHeaderWrap: shouldHeaderWrap })=>{
    const headerProps = {
        author: author,
        edited: edited,
        isError: isError,
        isSaving: isSaving,
        restrictedTo: restrictedTo,
        savingText: savingText,
        time: time,
        type: type,
        headingLevel: headingLevel,
        shouldHeaderWrap: shouldHeaderWrap
    };
    const footerProps = {
        actions: actions,
        errorActions: errorActions,
        errorIconLabel: errorIconLabel,
        isError: isError,
        isSaving: isSaving
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ccUTU.default), {
        testId: testId,
        shouldRenderNestedCommentsInline: shouldRenderNestedCommentsInline,
        id: id,
        avatar: avatar,
        content: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
            space: "space.075",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                    space: "space.050",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38ymg.default), {
                            testId: testId && `${testId}-header`,
                            ...headerProps
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                            testId: testId && `${testId}-content`,
                            xcss: (0, $6qaBj.cx)($c9c450faebe35312$var$textStyles.root, (isSaving || isError) && $c9c450faebe35312$var$textStyles.disabled),
                            children: content
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8TN86.default), {
                    testId: testId && `${testId}-footer`,
                    ...footerProps
                }),
                afterContent
            ]
        }),
        highlighted: highlighted,
        children: children
    });
};
$c9c450faebe35312$var$Comment.displayName = 'Comment';
var $c9c450faebe35312$export$2e2bcd8739ae039 = $c9c450faebe35312$var$Comment;

});
parcelRegister("8TN86", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a9c7139302adec1$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $jkYbX = parcelRequire("jkYbX");

var $3Wh6p = parcelRequire("3Wh6p");

/**
 * __Footer items__
 *
 * The footer items in the comment. Usually reserved for error messages.
 *
 * @internal
 */ const $6a9c7139302adec1$var$Footer = ({ actions: actions = [], errorActions: errorActions = [], errorIconLabel: errorIconLabel, isError: isError, isSaving: isSaving, testId: testId })=>{
    if (isSaving || !(actions.length || errorActions.length)) return null;
    const items = isError ? errorActions : actions;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3Wh6p.default), {
        alignBlock: "center",
        shouldWrap: true,
        testId: testId,
        space: "space.100",
        separator: "\xb7",
        children: [
            isError && /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))), {
                spacing: "spacious",
                color: `var(--ds-icon-warning, ${(0, $7bb4c1736002a04a$export$874739ea9e379ab6)})`,
                label: errorIconLabel ? errorIconLabel : ''
            }),
            items.map((item, key)=>Object.assign({}, item, {
                    key: key
                }))
        ]
    });
};
$6a9c7139302adec1$var$Footer.displayName = 'CommentFooter';
var $6a9c7139302adec1$export$2e2bcd8739ae039 = $6a9c7139302adec1$var$Footer;

});

parcelRegister("38ymg", function(module, exports) {
$parcel$export(module.exports, "default", () => $04f21d475eb83884$export$2e2bcd8739ae039);
/* header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $9QgTI = parcelRequire("9QgTI");

var $kKPzl = parcelRequire("kKPzl");

var $jdqdp = parcelRequire("jdqdp");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
var $3cMgR = parcelRequire("3cMgR");
const $04f21d475eb83884$var$headingStyles = {
    root: "_11c82smr"
};
const $04f21d475eb83884$var$iconWrapperStyles = {
    root: "_18zrv77o _1e0c1txw"
};
const $04f21d475eb83884$var$headerItemStyles = {
    root: "_o5721q9c _1o9zidpf"
};
const $04f21d475eb83884$var$authorBoxStyles = {
    root: "_1nmz9jpi _1ul9idpf _p12f1osq"
};
/**
 * __Header items__
 *
 * Comment header items.
 *
 * @internal
 */ const $04f21d475eb83884$var$Header = ({ author: author, edited: edited, isError: isError, isSaving: isSaving, restrictedTo: restrictedTo, savingText: savingText, time: time, testId: testId, type: type, headingLevel: headingLevel = '3', shouldHeaderWrap: shouldHeaderWrap })=>{
    const Heading = `h${headingLevel}`;
    const shouldRender = author || time || restrictedTo || isSaving && savingText || edited || type;
    return shouldRender ? /*#__PURE__*/ (0, $gt9Am.jsx)(Heading, {
        className: (0, $hcewu.default)([
            $04f21d475eb83884$var$headingStyles.root
        ]),
        children: shouldHeaderWrap === false ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            alignBlock: "center",
            testId: testId,
            space: "space.100",
            as: "span",
            shouldWrap: false,
            children: [
                author,
                type && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
                    testId: testId && `${testId}-type`,
                    children: type
                }),
                time && !isSaving && !isError && time,
                edited || null,
                isSaving ? savingText : null,
                restrictedTo && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                    color: "color.text.subtlest",
                    children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                        alignBlock: "center",
                        space: "space.050",
                        as: "span",
                        children: [
                            "\u2022",
                            (0, $eGOwo.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                                as: "span",
                                xcss: $04f21d475eb83884$var$iconWrapperStyles.root,
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9QgTI))), {
                                    color: "currentColor",
                                    label: "",
                                    size: "small"
                                })
                            }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kKPzl))), {
                                size: "small",
                                label: ""
                            }),
                            restrictedTo
                        ]
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            alignBlock: "center",
            testId: testId,
            space: "space.100",
            rowSpace: "space.0",
            as: "span",
            shouldWrap: true,
            children: [
                author && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    as: "span",
                    xcss: $04f21d475eb83884$var$authorBoxStyles.root,
                    children: author
                }),
                type && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    as: "span",
                    xcss: $04f21d475eb83884$var$headerItemStyles.root,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
                        testId: testId && `${testId}-type`,
                        children: type
                    })
                }),
                time && !isSaving && !isError && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    as: "span",
                    xcss: $04f21d475eb83884$var$headerItemStyles.root,
                    children: time
                }),
                edited && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    as: "span",
                    xcss: $04f21d475eb83884$var$headerItemStyles.root,
                    children: edited
                }),
                isSaving && savingText && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    as: "span",
                    xcss: $04f21d475eb83884$var$headerItemStyles.root,
                    children: savingText
                }),
                restrictedTo && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    as: "span",
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                        color: "color.text.subtlest",
                        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                            alignBlock: "center",
                            space: "space.050",
                            as: "span",
                            children: [
                                (0, $eGOwo.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                                    as: "span",
                                    xcss: $04f21d475eb83884$var$iconWrapperStyles.root,
                                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9QgTI))), {
                                        color: "currentColor",
                                        label: "",
                                        size: "small"
                                    })
                                }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kKPzl))), {
                                    size: "small",
                                    label: ""
                                }),
                                restrictedTo
                            ]
                        })
                    })
                })
            ]
        })
    }) : null;
};
$04f21d475eb83884$var$Header.displayName = 'CommentHeader';
var $04f21d475eb83884$export$2e2bcd8739ae039 = $04f21d475eb83884$var$Header;

});

parcelRegister("ccUTU", function(module, exports) {
$parcel$export(module.exports, "default", () => $dbf3bea8d80b623f$export$2e2bcd8739ae039);
/* layout.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
var $hYvlq = parcelRequire("hYvlq");
var $78OnL = parcelRequire("78OnL");

var $6U04G = parcelRequire("6U04G");

var $jBvI2 = parcelRequire("jBvI2");
const $dbf3bea8d80b623f$var$containerStyles = {
    root: "_kqswh2mm _yv0e5bpd _1lmc1gx3"
};
const $dbf3bea8d80b623f$var$inlineCommentStyles = {
    root: "_1lmc1rav"
};
const $dbf3bea8d80b623f$var$noChildrenStyles = {
    root: "_1lmcvpz5"
};
// if the background is appied on Box and tokens are not switched on it breaks.
// This can be safely removed (and applied on Box) when tokens are on by default
const $dbf3bea8d80b623f$var$highlightOverlayStyles = {
    root: "_1r04x0bf _nd5l1sux _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _kqswstnw _lcxvglyw"
};
const $dbf3bea8d80b623f$var$stackOverrideStyles = {
    root: "_nd5l1dav _1q511ejb"
};
/**
 * __CommentLayout__
 *
 * The base layout for the comment component.
 *
 */ const $dbf3bea8d80b623f$var$Layout = ({ content: content, children: children, highlighted: highlighted, id: id, shouldRenderNestedCommentsInline: shouldRenderNestedCommentsInline, testId: testId, avatar: avatar })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $hYvlq.default), {
        gap: "space.100",
        xcss: (0, $6qaBj.cx)($dbf3bea8d80b623f$var$containerStyles.root, shouldRenderNestedCommentsInline && $dbf3bea8d80b623f$var$inlineCommentStyles.root, !children && $dbf3bea8d80b623f$var$noChildrenStyles.root),
        testId: testId,
        id: id,
        children: [
            avatar && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6U04G.default), {
                children: avatar
            }),
            content && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jBvI2.default), {
                children: content
            }),
            children && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $78OnL.default), {
                xcss: $dbf3bea8d80b623f$var$stackOverrideStyles.root,
                space: "space.400",
                children: children
            }),
            highlighted && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $dbf3bea8d80b623f$var$highlightOverlayStyles.root,
                backgroundColor: "color.background.neutral",
                testId: testId && `${testId}-highlighted`
            })
        ]
    });
$dbf3bea8d80b623f$var$Layout.displayName = 'CommentLayout';
var $dbf3bea8d80b623f$export$2e2bcd8739ae039 = $dbf3bea8d80b623f$var$Layout;

});
parcelRegister("6U04G", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2d5385031ff3306$export$2e2bcd8739ae039);
/* avatar-slot.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
const $b2d5385031ff3306$var$avatarSectionStyles = {
    root: "_nd5l1ofd"
};
/**
 * __Avatar slot is used to nest an avatar in a comment__
 *
 * The avatar slot is used to nest an avatar in a comment's layout.
 *
 */ const $b2d5385031ff3306$var$AvatarSlot = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: $b2d5385031ff3306$var$avatarSectionStyles.root,
        children: children
    });
var $b2d5385031ff3306$export$2e2bcd8739ae039 = $b2d5385031ff3306$var$AvatarSlot;

});

parcelRegister("jBvI2", function(module, exports) {
$parcel$export(module.exports, "default", () => $dcfc820f397ada62$export$2e2bcd8739ae039);
/* content-slot.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $dcfc820f397ada62$var$contentSlotStyles = {
    root: "_nd5l8niw _1ul9idpf _1q51v77o _slp31hna"
};
/**
 * __ContentSlot__
 *
 * The content slot is used to nest content in a comment's layout. It should be used inside a CommentLayout.
 *
 */ const $dcfc820f397ada62$var$ContentSlot = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            $dcfc820f397ada62$var$contentSlotStyles.root
        ]),
        children: children
    });
var $dcfc820f397ada62$export$2e2bcd8739ae039 = $dcfc820f397ada62$var$ContentSlot;

});




parcelRegister("bYyH2", function(module, exports) {
$parcel$export(module.exports, "DatePicker", () => $06fb7723f809c6c8$export$5109c6dd95d8fb00);
/**
 * Type for date picker had to be defined here because the type could not be imported from the datepicker module.
 * It is being declared in typings/atlaskit.d.ts which is preventing imports. If removed, type errors are introduced in components
 * outside of this package.
 *
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $iUa8i = parcelRequire("iUa8i");

var $8AppO = parcelRequire("8AppO");
const $06fb7723f809c6c8$export$bf0162d825d6e13 = {
    appearance: true,
    defaultIsOpen: true,
    autoFocus: true,
    defaultValue: true,
    disabled: true,
    disabledDateFilter: false,
    maxDate: true,
    minDate: true,
    isOpen: {
        replaceLine: true,
        value: '{...(isOpen ? { isOpen }: undefined)}',
        comment: 'undefined is evaluated as true when isOpen is being explicitly set'
    },
    nextMonthLabel: true,
    parseInputValue: false,
    formatDisplayLabel: false,
    previousMonthLabel: true,
    selectProps: true,
    spacing: true,
    dateFormat: true,
    shouldShowCalendarButton: true,
    placeholder: true,
    locale: true,
    testId: true,
    weekStartDay: true,
    onChange: true,
    value: {
        replaceLine: true,
        value: '{...(value !== undefined ? { value }: undefined)}',
        comment: 'Explicitly setting value to undefined is causing issues'
    }
};
const $06fb7723f809c6c8$export$5109c6dd95d8fb00 = (props)=>{
    const { appearance: appearance, defaultIsOpen: defaultIsOpen, autoFocus: autoFocus, defaultValue: defaultValue, disabled: disabled, maxDate: maxDate, minDate: minDate, isOpen: isOpen, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps, spacing: spacing, dateFormat: dateFormat, shouldShowCalendarButton: shouldShowCalendarButton, placeholder: placeholder, locale: locale, testId: testId, weekStartDay: weekStartDay, onChange: onChange, value: value, id: // Field props
    id, isRequired: isRequired, isDisabled: isDisabled, isInvalid: isInvalid, onBlur: onBlur, onFocus: onFocus, "aria-invalid": ariaInvalid, "aria-labelledby": ariaLabelledby, name: name } = props.forgeDoc.props;
    // warning: appearance is deprecated;
    // warning: defaultIsOpen is deprecated;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iUa8i.default), {
        appearance: appearance,
        defaultIsOpen: defaultIsOpen,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        disabled: disabled,
        maxDate: maxDate,
        minDate: minDate,
        ...isOpen ? {
            isOpen: isOpen
        } : undefined,
        nextMonthLabel: nextMonthLabel,
        previousMonthLabel: previousMonthLabel,
        selectProps: selectProps,
        spacing: spacing,
        dateFormat: dateFormat,
        shouldShowCalendarButton: shouldShowCalendarButton,
        placeholder: placeholder,
        locale: locale,
        testId: testId,
        weekStartDay: weekStartDay,
        onChange: onChange,
        ...value !== undefined ? {
            value: value
        } : undefined,
        // Field props
        id: id,
        isRequired: isRequired,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        onBlur: (0, $8AppO.adaptEventHandler)(onBlur),
        onFocus: (0, $8AppO.adaptEventHandler)(onFocus),
        "aria-invalid": ariaInvalid,
        "aria-labelledby": ariaLabelledby,
        name: name
    });
}; /**
 * @codegenEnd
 */ 

});
parcelRegister("iUa8i", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8d7b5e7995f81e7$export$2e2bcd8739ae039);

var $eGOwo = parcelRequire("eGOwo");

var $1BRZx = parcelRequire("1BRZx");

var $lLHJE = parcelRequire("lLHJE");

var $k2Uo2 = parcelRequire("k2Uo2");
const $b8d7b5e7995f81e7$var$DatePicker = (0, $1BRZx.componentWithCondition)(()=>(0, $eGOwo.fg)('dst-date-picker-use-functional-component'), (0, $k2Uo2.default), (0, $lLHJE.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b8d7b5e7995f81e7$export$2e2bcd8739ae039 = $b8d7b5e7995f81e7$var$DatePicker;

});
parcelRegister("1BRZx", function(module, exports) {
$parcel$export(module.exports, "componentWithCondition", () => $48de19f2c65a8561$export$6e8ea24b15199873);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $48de19f2c65a8561$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
        condition() ? /*#__PURE__*/ (0, $gt9Am.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    return ComponentWithCondition;
}

});

parcelRegister("lLHJE", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fe32780a1f5c05c$export$2e2bcd8739ae039);
/* date-picker-class.tsx generated by @compiled/babel-plugin v0.36.1 */ /// <reference types="node" />

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dBLX0 = parcelRequire("dBLX0");
var $kQ82p = parcelRequire("kQ82p");

var $5fWw9 = parcelRequire("5fWw9");
var $dUaMU = parcelRequire("dUaMU");
var $4J0ad = parcelRequire("4J0ad");

var $Ay1uj = parcelRequire("Ay1uj");

var $6qaBj = parcelRequire("6qaBj");

var $gl2vi = parcelRequire("gl2vi");

var $3GKOL = parcelRequire("3GKOL");

var $cK9J2 = parcelRequire("cK9J2");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");

var $c4OV1 = parcelRequire("c4OV1");
var $e9zKl = parcelRequire("e9zKl");

var $RoXqn = parcelRequire("RoXqn");

var $47or1 = parcelRequire("47or1");

var $hmV0i = parcelRequire("hmV0i");

var $gNwsY = parcelRequire("gNwsY");

var $1u9xN = parcelRequire("1u9xN");

var $7OE9J = parcelRequire("7OE9J");
const $2fe32780a1f5c05c$var$packageName = "platform-pkg";
const $2fe32780a1f5c05c$var$packageVersion = "0.0.0-use.local";
const $2fe32780a1f5c05c$var$datePickerDefaultProps = {
    defaultIsOpen: false,
    defaultValue: '',
    disabled: [],
    disabledDateFilter: (_)=>false,
    locale: 'en-US',
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{} /* eslint-enable @repo/internal/react/use-noop */ 
};
const $2fe32780a1f5c05c$var$styles = {
    pickerContainerStyles: "_kqswh2mm",
    iconContainerStyles: "_v564vrg3 _1e0c1txw _4t3i1osq _kqswstnw _4cvr1h6o _i0dl1kw7 _syaz131l _152tze3t _rjxpze3t _30l31gjq",
    iconSpacingWithClearButtonStyles: "_12l2xy5q",
    iconSpacingWithoutClearButtonStyles: "_12l21b66",
    dropdownIndicatorStyles: "_1ul91k8s _1tke1k8s _1e0c1txw _4cvr1h6o _1bah1h6o"
}; // eslint-disable-next-line @repo/internal/react/no-class-components
class $2fe32780a1f5c05c$export$df43d21f5faca9f7 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = $2fe32780a1f5c05c$var$datePickerDefaultProps;
    }
    constructor(props){
        super(props), this.containerRef = null, this.calendarRef = /*#__PURE__*/ (0, $eJOHy.createRef)(), this.calendarButtonRef = /*#__PURE__*/ (0, $eJOHy.createRef)(), // correctly to allow controlled/uncontrolled usage.
        this.getValue = ()=>this.props.value ?? this.state.value, this.getIsOpen = ()=>this.props.isOpen ?? this.state.isOpen, this.onCalendarChange = ({ iso: iso })=>{
            this.setState({
                calendarValue: (0, $47or1.getParsedISO)({
                    iso: iso
                })
            });
        }, this.onCalendarSelect = ({ iso: iso })=>{
            this.setState({
                selectInputValue: '',
                isOpen: false,
                calendarValue: iso,
                value: iso,
                wasOpenedFromCalendarButton: false
            });
            this.props.onChange(iso); // Yes, this is not ideal. The alternative is to be able to place a ref
            // on the inner input of Select itself, which would require a lot of
            // extra stuff in the Select component for only this one thing. While
            // this would be more "React-y", it doesn't seem to pose any other
            // benefits. Performance-wise, we are only searching within the
            // container, so it's quick.
            if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
            else {
                const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                innerCombobox?.focus();
            }
            this.setState({
                isOpen: false
            });
        }, this.onInputClick = ()=>{
            if (!this.props.isDisabled && !this.getIsOpen()) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        }, this.onContainerBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (!this.containerRef?.contains(newlyFocusedElement)) {
                this.setState({
                    isOpen: false,
                    shouldSetFocusOnCurrentDay: false,
                    wasOpenedFromCalendarButton: false
                });
                this.props.onBlur(event);
            }
        }, this.onContainerFocus = ()=>{
            this.setState({
                shouldSetFocusOnCurrentDay: false
            });
        }, this.onSelectBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (this.state.clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else if (!this.containerRef?.contains(newlyFocusedElement)) // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            this.setState({
                isOpen: false,
                isFocused: false,
                wasOpenedFromCalendarButton: false
            });
        }, this.onSelectFocus = (event)=>{
            const { clearingFromIcon: clearingFromIcon } = this.state;
            const value = this.getValue();
            if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else this.setState({
                // Don't open when focused into via keyboard if the calendar button is present
                isOpen: !this.props.shouldShowCalendarButton,
                calendarValue: value,
                isFocused: true,
                wasOpenedFromCalendarButton: false
            });
            this.props.onFocus(event);
        }, this.onTextInput = (event)=>{
            const inputValue = event.target.value;
            if (inputValue) {
                const parsed = (0, $47or1.parseDate)(inputValue, {
                    parseInputValue: this.props.parseInputValue,
                    dateFormat: this.props.dateFormat,
                    l10n: this.state.l10n
                }); // Only try to set the date if we have month & day
                if (parsed && (0, $dBLX0.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
                // this is the format expected by the @atlaskit/calendar component
                this.setState({
                    calendarValue: (0, $1u9xN.getShortISOString)(parsed)
                });
            }
            this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        }, this.onInputKeyDown = (event)=>{
            const { calendarValue: calendarValue } = this.state;
            const value = this.getValue();
            const keyPressed = event.key.toLowerCase(); // If the input is focused and the calendar is not visible, handle space and enter clicks
            if (!this.state.isOpen && (keyPressed === 'enter' || keyPressed === ' ')) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
            switch(keyPressed){
                case 'escape':
                    // Yes, this is not ideal. The alternative is to be able to place a ref
                    // on the inner input of Select itself, which would require a lot of
                    // extra stuff in the Select component for only this one thing. While
                    // this would be more "React-y", it doesn't seem to pose any other
                    // benefits. Performance-wise, we are only searching within the
                    // container, so it's quick.
                    if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
                    else {
                        const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                        innerCombobox?.focus();
                    }
                    this.setState({
                        isOpen: false,
                        shouldSetFocusOnCurrentDay: false,
                        wasOpenedFromCalendarButton: false
                    });
                    break;
                case 'backspace':
                case 'delete':
                    {
                        const inputCount = 0;
                        if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) // If being cleared from keyboard, don't change behaviour
                        this.setState({
                            clearingFromIcon: false,
                            value: ''
                        });
                        break;
                    }
                case 'enter':
                    if (!this.state.isOpen) return;
                     // Prevent form submission when a date is selected
                    // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                    // for more details.
                    event.preventDefault();
                    if (!(0, $47or1.isDateDisabled)(calendarValue, {
                        disabled: this.props.disabled
                    })) {
                        // Get a safe `calendarValue` in case the value exceeds the maximum
                        // allowed by ISO 8601
                        const safeCalendarValue = (0, $1u9xN.getSafeCalendarValue)(calendarValue);
                        const valueChanged = safeCalendarValue !== value;
                        this.setState({
                            selectInputValue: '',
                            isOpen: false,
                            value: safeCalendarValue,
                            calendarValue: safeCalendarValue,
                            wasOpenedFromCalendarButton: false
                        });
                        if (valueChanged) this.props.onChange(safeCalendarValue);
                    }
                    break;
                case 'arrowdown':
                case 'arrowup':
                    if (!this.state.shouldSetFocusOnCurrentDay) this.setState({
                        isOpen: true,
                        shouldSetFocusOnCurrentDay: true
                    });
                    break;
                default:
                    break;
            }
        }, this.onCalendarButtonKeyDown = (e)=>{
            // Don't allow an arrow up or down to open the menu, since the input key
            // down handler is actually on the parent.
            if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
             // We want to stop this from triggering other keydown events, particularly
            // for space and enter presses. Otherwise, it opens and then closes
            // immediately.
            if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
                e.stopPropagation();
                this.setState({
                    isKeyDown: true,
                    wasOpenedFromCalendarButton: true
                });
            }
        } // This event handler is triggered from both keydown and click. It's weird.
        , this.onCalendarButtonClick = (e)=>{
            this.setState({
                isOpen: !this.state.isOpen,
                wasOpenedFromCalendarButton: true
            }, ()=>{
                // We don't want the focus to move if this is a click event
                if (!this.state.isKeyDown) return;
                this.setState({
                    isKeyDown: false
                }); // Focus on the first button within the calendar
                this.calendarRef?.current?.querySelector('button')?.focus();
            });
            e.stopPropagation();
        }, this.onClear = ()=>{
            let changedState = {
                value: '',
                calendarValue: this.props.defaultValue || (0, $1u9xN.getShortISOString)(new Date())
            };
            if (!this.props.hideIcon) changedState = {
                ...changedState,
                clearingFromIcon: true
            };
            this.setState(changedState);
            this.props.onChange('');
        } // `unknown` is used because `value` is unused so it does not matter.
        , this.onSelectChange = (_value, action)=>{
            // Used for native clear event in React Select
            // Triggered when clicking ClearIndicator or backspace with no value
            if (action.action === 'clear') this.onClear();
        }, this.handleSelectInputChange = (selectInputValue, actionMeta)=>{
            const onInputChange = this.props.selectProps?.onInputChange;
            if (onInputChange) onInputChange(selectInputValue, actionMeta);
            this.setState({
                selectInputValue: selectInputValue
            });
        }, this.getContainerRef = (ref)=>{
            const oldRef = this.containerRef;
            this.containerRef = ref; // Cause a re-render if we're getting the container ref for the first time
            // as the layered menu requires it for dimension calculation
            if (oldRef == null && ref != null) this.forceUpdate();
        };
        this.state = {
            isKeyDown: false,
            isOpen: this.props.defaultIsOpen,
            isFocused: false,
            clearingFromIcon: false,
            selectInputValue: this.props.selectProps?.inputValue || '',
            value: this.props.value || this.props.defaultValue,
            calendarValue: this.props.value || this.props.defaultValue || (0, $1u9xN.getShortISOString)(new Date()),
            l10n: (0, $cK9J2.createLocalizationProvider)(this.props.locale),
            locale: this.props.locale,
            shouldSetFocusOnCurrentDay: false,
            wasOpenedFromCalendarButton: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.locale !== prevState.locale) return {
            l10n: (0, $cK9J2.createLocalizationProvider)(nextProps.locale),
            locale: nextProps.locale
        };
        else return null;
    }
    render() {
        const { appearance: appearance = 'default', 'aria-describedby': ariaDescribedBy, autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', disabled: disabled, disabledDateFilter: disabledDateFilter, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($3GKOL))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', locale: locale, maxDate: maxDate, minDate: minDate, name: name = '', nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', testId: testId, weekStartDay: weekStartDay } = this.props;
        const { calendarValue: calendarValue, selectInputValue: selectInputValue } = this.state;
        const value = this.getValue();
        let actualSelectInputValue;
        actualSelectInputValue = selectInputValue;
        const menuIsOpen = this.getIsOpen() && !isDisabled;
        const showClearIndicator = Boolean((value || selectInputValue) && !hideIcon);
        let clearIndicator = Icon;
        if ((0, $eGOwo.fg)('platform-visual-refresh-icons')) clearIndicator = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $2fe32780a1f5c05c$var$styles.dropdownIndicatorStyles,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                    ...props
                })
            });
        const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
        const selectComponents = {
            DropdownIndicator: shouldShowCalendarButton ? (0, $RoXqn.EmptyComponent) : dropDownIcon,
            // Only use this new container component if the calendar button is shown.
            // Otherwise, it throws errors downstream for some reason
            ...shouldShowCalendarButton ? {
                IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hmV0i.IndicatorsContainer), {
                        ...props,
                        showClearIndicator: showClearIndicator
                    })
            } : {},
            Menu: $gNwsY.Menu,
            // SingleValue is defined in the render because of UI generator limitations
            ...!showClearIndicator && {
                ClearIndicator: (0, $RoXqn.EmptyComponent)
            },
            ...selectProps.components
        };
        const { styles: selectStyles = {} } = selectProps;
        const disabledStyle = isDisabled ? {
            pointerEvents: 'none',
            color: "var(--ds-icon-disabled, inherit)"
        } : {};
        const calendarProps = {
            calendarContainerRef: this.containerRef,
            calendarDisabled: disabled,
            calendarDisabledDateFilter: disabledDateFilter,
            calendarMaxDate: maxDate,
            calendarMinDate: minDate,
            calendarRef: this.calendarRef,
            calendarValue: value && (0, $1u9xN.getShortISOString)((0, $kQ82p.default)(value)),
            calendarView: calendarValue,
            onCalendarChange: this.onCalendarChange,
            onCalendarSelect: this.onCalendarSelect,
            calendarLocale: locale,
            calendarWeekStartDay: weekStartDay,
            shouldSetFocusOnCurrentDay: this.state.shouldSetFocusOnCurrentDay,
            menuInnerWrapper: this.props.menuInnerWrapper
        }; // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
        const mergedStyles = (0, $e9zKl.mergeStyles)(selectStyles, {
            control: (base)=>({
                    ...base,
                    ...disabledStyle
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    // ICON_PADDING = 2
                    paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
                })
        });
        const initialValue = value ? {
            label: (0, $47or1.formatDate)(value, {
                formatDisplayLabel: this.props.formatDisplayLabel,
                dateFormat: this.props.dateFormat,
                l10n: this.state.l10n
            }),
            value: value
        } : null; // `label` takes precedence of the `inputLabel`
        const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
        return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            ...innerProps,
            role: "presentation",
            onBlur: this.onContainerBlur,
            onFocus: this.onContainerFocus,
            onClick: this.onInputClick,
            onInput: this.onTextInput,
            onKeyDown: this.onInputKeyDown,
            ref: this.getContainerRef,
            "data-testid": testId && `${testId}--container`,
            className: (0, $hcewu.default)([
                $2fe32780a1f5c05c$var$styles.pickerContainerStyles
            ]),
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value,
                    "data-testid": testId && `${testId}--input`
                }),
                (0, $eGOwo.fg)('platform-dtp_a11y_fix-dsp-23950') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gl2vi.IdProvider), {
                    children: ({ id: valueId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $c4OV1.default), {
                            appearance: this.props.appearance,
                            "aria-describedby": ariaDescribedBy ? `${ariaDescribedBy} ${valueId}` : valueId,
                            label: label || undefined,
                            autoFocus: autoFocus,
                            clearControlLabel: clearControlLabel,
                            closeMenuOnSelect: true,
                            enableAnimation: false,
                            inputId: id,
                            inputValue: actualSelectInputValue,
                            isDisabled: isDisabled,
                            isRequired: isRequired,
                            menuIsOpen: menuIsOpen,
                            onBlur: this.onSelectBlur,
                            onChange: this.onSelectChange,
                            onFocus: this.onSelectFocus,
                            onInputChange: this.handleSelectInputChange,
                            placeholder: (0, $47or1.getPlaceholder)({
                                placeholder: this.props.placeholder,
                                l10n: this.state.l10n
                            }),
                            styles: mergedStyles,
                            value: initialValue,
                            ...selectProps,
                            // up when you alter some of the properties in the `selectComponents`
                            // object. These errors are still present, and I suspect have always
                            // been present, without changing the unrelated code. Ignoring as the
                            // component still works as expected despite this error. And also
                            // because the select refresh team may solve it later.
                            components: {
                                ...selectComponents,
                                SingleValue: (0, $7OE9J.makeSingleValue)({
                                    id: valueId,
                                    lang: this.props.locale
                                })
                            },
                            // selectProps or not and what wil be overwritten
                            isClearable: true,
                            isInvalid: isInvalid,
                            spacing: spacing,
                            testId: testId,
                            // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
                            calendarContainerRef: calendarProps.calendarContainerRef,
                            calendarDisabled: calendarProps.calendarDisabled,
                            calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                            calendarLocale: calendarProps.calendarLocale,
                            calendarMaxDate: calendarProps.calendarMaxDate,
                            calendarMinDate: calendarProps.calendarMinDate,
                            calendarRef: calendarProps.calendarRef,
                            calendarValue: calendarProps.calendarValue,
                            calendarView: calendarProps.calendarView,
                            calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                            nextMonthLabel: nextMonthLabel,
                            onCalendarChange: calendarProps.onCalendarChange,
                            onCalendarSelect: calendarProps.onCalendarSelect,
                            previousMonthLabel: previousMonthLabel,
                            shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
                            menuInnerWrapper: calendarProps.menuInnerWrapper
                        })
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c4OV1.default), {
                    appearance: this.props.appearance,
                    "aria-describedby": ariaDescribedBy,
                    label: label || undefined,
                    autoFocus: autoFocus,
                    clearControlLabel: clearControlLabel,
                    closeMenuOnSelect: true,
                    enableAnimation: false,
                    inputId: id,
                    inputValue: actualSelectInputValue,
                    isDisabled: isDisabled,
                    isRequired: isRequired,
                    menuIsOpen: menuIsOpen,
                    onBlur: this.onSelectBlur,
                    onChange: this.onSelectChange,
                    onFocus: this.onSelectFocus,
                    onInputChange: this.handleSelectInputChange,
                    placeholder: (0, $47or1.getPlaceholder)({
                        placeholder: this.props.placeholder,
                        l10n: this.state.l10n
                    }),
                    styles: mergedStyles,
                    value: initialValue,
                    ...selectProps,
                    // up when you alter some of the properties in the `selectComponents`
                    // object. These errors are still present, and I suspect have always
                    // been present, without changing the unrelated code. Ignoring as the
                    // component still works as expected despite this error. And also
                    // because the select refresh team may solve it later.
                    components: {
                        ...selectComponents,
                        SingleValue: (0, $7OE9J.makeSingleValue)({
                            lang: this.props.locale
                        })
                    },
                    // selectProps or not and what wil be overwritten
                    isClearable: true,
                    isInvalid: isInvalid,
                    spacing: spacing,
                    testId: testId,
                    // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
                    calendarContainerRef: calendarProps.calendarContainerRef,
                    calendarDisabled: calendarProps.calendarDisabled,
                    calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                    calendarLocale: calendarProps.calendarLocale,
                    calendarMaxDate: calendarProps.calendarMaxDate,
                    calendarMinDate: calendarProps.calendarMinDate,
                    calendarRef: calendarProps.calendarRef,
                    calendarValue: calendarProps.calendarValue,
                    calendarView: calendarProps.calendarView,
                    calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                    nextMonthLabel: nextMonthLabel,
                    onCalendarChange: calendarProps.onCalendarChange,
                    onCalendarSelect: calendarProps.onCalendarSelect,
                    previousMonthLabel: previousMonthLabel,
                    shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
                    menuInnerWrapper: calendarProps.menuInnerWrapper
                }),
                shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gl2vi.IdProvider), {
                    prefix: "open-calendar-label--",
                    children: ({ id: openCalendarLabelId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                            xcss: (0, $6qaBj.cx)($2fe32780a1f5c05c$var$styles.iconContainerStyles, value && !hideIcon ? $2fe32780a1f5c05c$var$styles.iconSpacingWithClearButtonStyles : $2fe32780a1f5c05c$var$styles.iconSpacingWithoutClearButtonStyles),
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                                appearance: "subtle",
                                label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
                                "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
                                id: openCalendarLabelId,
                                icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3GKOL))), {
                                        ...iconProps,
                                        color: "var(--ds-icon, #44546F)"
                                    }),
                                onClick: this.onCalendarButtonClick,
                                onKeyDown: this.onCalendarButtonKeyDown,
                                ref: this.calendarButtonRef,
                                testId: testId && `${testId}--open-calendar-button`
                            })
                        })
                }) : null
            ]
        });
    }
}
const $2fe32780a1f5c05c$var$DatePicker = (0, $dUaMU.default)({
    componentName: 'datePicker',
    packageName: $2fe32780a1f5c05c$var$packageName,
    packageVersion: $2fe32780a1f5c05c$var$packageVersion
})((0, $4J0ad.default)({
    onChange: (0, $5fWw9.default)('atlaskit')({
        action: 'selectedDate',
        actionSubject: 'datePicker',
        attributes: {
            componentName: 'datePicker',
            packageName: $2fe32780a1f5c05c$var$packageName,
            packageVersion: $2fe32780a1f5c05c$var$packageVersion
        }
    })
})($2fe32780a1f5c05c$export$df43d21f5faca9f7));
var $2fe32780a1f5c05c$export$2e2bcd8739ae039 = $2fe32780a1f5c05c$var$DatePicker;

});
parcelRegister("RoXqn", function(module, exports) {
$parcel$export(module.exports, "EmptyComponent", () => $f314d4d8e1112a31$export$5e30e9a24d6c1203);
$parcel$export(module.exports, "placeholderDatetime", () => $f314d4d8e1112a31$export$fff8babee5abe3e2);
$parcel$export(module.exports, "defaultTimes", () => $f314d4d8e1112a31$export$b42ffb9f09b1861b);
$parcel$export(module.exports, "defaultTimeFormat", () => $f314d4d8e1112a31$export$9e6d8fcf62256b85);
$parcel$export(module.exports, "defaultDateFormat", () => $f314d4d8e1112a31$export$75032c84f56650eb);
$parcel$export(module.exports, "padToTwo", () => $f314d4d8e1112a31$export$a7de57e5b672ccdb);
$parcel$export(module.exports, "formatDateTimeZoneIntoIso", () => $f314d4d8e1112a31$export$2eeb05a2ecc2ce0a);
/**
 * This component is used to hide portions of Select component.
 */ const $f314d4d8e1112a31$export$5e30e9a24d6c1203 = ()=>null;
const $f314d4d8e1112a31$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
const $f314d4d8e1112a31$export$b42ffb9f09b1861b = [
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00'
];
const $f314d4d8e1112a31$export$9e6d8fcf62256b85 = 'h:mma';
const $f314d4d8e1112a31$export$75032c84f56650eb = 'YYYY/MM/DD';
function $f314d4d8e1112a31$export$a7de57e5b672ccdb(number) {
    return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
}
function $f314d4d8e1112a31$export$2eeb05a2ecc2ce0a(date, time, zone) {
    // 12:00 => 12:00, 1:00 => 01:00
    const needsLeadingZero = /^\d:/;
    const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
    return `${date}T${sanitizedTime}${zone}`;
}

});

parcelRegister("47or1", function(module, exports) {
$parcel$export(module.exports, "isDateDisabled", () => $0a9aca5af48d76f0$export$d38e7e283938128c);
$parcel$export(module.exports, "getParsedISO", () => $0a9aca5af48d76f0$export$38db26406d1a1ee2);
$parcel$export(module.exports, "parseDate", () => $0a9aca5af48d76f0$export$6b862160d295c8e);
$parcel$export(module.exports, "formatDate", () => $0a9aca5af48d76f0$export$3ae94a2503e890a1);
$parcel$export(module.exports, "getPlaceholder", () => $0a9aca5af48d76f0$export$d3f5c5e0a5023fa0);
/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ 
var $57raR = parcelRequire("57raR");
var $cBFyu = parcelRequire("cBFyu");
var $kQ82p = parcelRequire("kQ82p");

var $5PwWU = parcelRequire("5PwWU");

var $RoXqn = parcelRequire("RoXqn");
const $0a9aca5af48d76f0$export$d38e7e283938128c = (date, di)=>{
    const { disabled: disabled } = di;
    return disabled.indexOf(date) > -1;
};
const $0a9aca5af48d76f0$export$38db26406d1a1ee2 = (di)=>{
    const { iso: iso } = di;
    const [year, month, date] = iso.split('-');
    let newIso = iso;
    const parsedDate = parseInt(date, 10);
    const parsedMonth = parseInt(month, 10);
    const parsedYear = parseInt(year, 10);
    const lastDayInMonth = (0, $cBFyu.default)(new Date(parsedYear, parsedMonth - 1)).getDate();
    if (lastDayInMonth < parsedDate) newIso = `${parsedYear}-${(0, $RoXqn.padToTwo)(parsedMonth)}-${(0, $RoXqn.padToTwo)(lastDayInMonth)}`;
    else newIso = `${parsedYear}-${(0, $RoXqn.padToTwo)(parsedMonth)}-${(0, $RoXqn.padToTwo)(parsedDate)}`;
    return newIso;
};
const $0a9aca5af48d76f0$export$6b862160d295c8e = (date, di)=>{
    const { parseInputValue: parseInputValue, dateFormat: dateFormat, l10n: l10n } = di;
    if (parseInputValue) return parseInputValue(date, dateFormat || (0, $RoXqn.defaultDateFormat));
    return l10n.parseDate(date);
};
const $0a9aca5af48d76f0$export$3ae94a2503e890a1 = (value, di)=>{
    const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat, l10n: l10n } = di;
    if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, $RoXqn.defaultDateFormat));
    const date = (0, $kQ82p.default)(value);
    return dateFormat ? (0, $57raR.default)(date, (0, $5PwWU.convertTokens)(dateFormat)) : l10n.formatDate(date);
};
const $0a9aca5af48d76f0$export$d3f5c5e0a5023fa0 = (di)=>{
    const { placeholder: placeholder, l10n: l10n } = di;
    return placeholder || l10n.formatDate((0, $RoXqn.placeholderDatetime));
};

});
parcelRegister("5PwWU", function(module, exports) {
$parcel$export(module.exports, "convertTokens", () => $0e0ecc26a93a278c$export$4d5430175be73d45);
// https://github.com/date-fns/date-fns-upgrade/blob/master/src/v2/convertTokens/index.ts
const $0e0ecc26a93a278c$var$tokensMap = {
    // 'D MMMM': '',
    // 'Do MMMM': '',
    // 'DD MMMM': '',
    M: 'L',
    Mo: 'Mo',
    MM: 'LL',
    MMM: 'LLL',
    MMMM: 'LLLL',
    Q: 'q',
    Qo: 'qo',
    D: 'd',
    Do: 'do',
    DD: 'dd',
    DDD: 'D',
    DDDo: 'Do',
    DDDD: 'DDD',
    d: 'i',
    do: 'io',
    dd: 'iiiiii',
    ddd: 'iii',
    dddd: 'iiii',
    A: 'a',
    a: 'a',
    aa: 'aaaa',
    E: 'i',
    W: 'I',
    Wo: 'Io',
    WW: 'II',
    YY: 'yy',
    YYYY: 'yyyy',
    GG: 'RR',
    GGGG: 'RRRR',
    H: 'H',
    HH: 'HH',
    h: 'h',
    hh: 'hh',
    m: 'm',
    mm: 'mm',
    s: 's',
    ss: 'ss',
    S: 'S',
    SS: 'SS',
    SSS: 'SSS',
    Z: 'xxx',
    ZZ: 'xx',
    X: 't',
    x: 'T'
};
const $0e0ecc26a93a278c$var$v1tokens = Object.keys($0e0ecc26a93a278c$var$tokensMap).sort().reverse();
const $0e0ecc26a93a278c$var$tokensRegExp = new RegExp(// v1 escape string (unsure the purpose of post-pipe capture group)
"(\\[[^\\[]*\\])|(\\\\)?('.+'|" + // All v1 tokens
$0e0ecc26a93a278c$var$v1tokens.join('|') + '|.)', 'g');
function $0e0ecc26a93a278c$export$4d5430175be73d45(format) {
    const tokensCaptures = format.match($0e0ecc26a93a278c$var$tokensRegExp);
    if (!tokensCaptures) return format;
    return tokensCaptures.reduce((parsed, tokenString, index)=>{
        const v2token = $0e0ecc26a93a278c$var$tokensMap[tokenString];
        if (!v2token) {
            const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
            if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
            else parsed.escapedTextBuffer.push(tokenString);
        }
        const endOfString = index === tokensCaptures.length - 1;
        if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
            // This allows double parentheses to be rendered correctly
            // according to date-fns's spec.
            // https://date-fns.org/v2.29.3/docs/format
            //
            // We have to keep the single quote and then remove it because
            // browser support for lookahead/behind is low and causes breaking
            // errors (HOT-104152)
            const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
            parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
            parsed.escapedTextBuffer = [];
        }
        if (v2token) parsed.formatBuffer.push(v2token);
        return parsed;
    }, {
        formatBuffer: [],
        escapedTextBuffer: []
    }).formatBuffer.join('');
}

});


parcelRegister("hmV0i", function(module, exports) {
$parcel$export(module.exports, "IndicatorsContainer", () => $85a1248019ae74fb$export$d0ffd7e649cab6f);
/* indicators-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6XEne = parcelRequire("6XEne");
const $85a1248019ae74fb$var$styles = {
    calendarButtonInclusionStyles: "_ahbqxy5q",
    calendarButtonOnlyInclusionStyles: "_ahbq1ejb"
};
const $85a1248019ae74fb$export$d0ffd7e649cab6f = ({ showClearIndicator: showClearIndicator, ...rest })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            showClearIndicator ? $85a1248019ae74fb$var$styles.calendarButtonInclusionStyles : $85a1248019ae74fb$var$styles.calendarButtonOnlyInclusionStyles
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).IndicatorsContainer, {
            ...rest
        })
    });

});

parcelRegister("gNwsY", function(module, exports) {
$parcel$export(module.exports, "Menu", () => $41b3b0700e22b1c1$export$d9b273488cd8ce6f);
/* menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dBLX0 = parcelRequire("dBLX0");
var $kQ82p = parcelRequire("kQ82p");

var $cSUzd = parcelRequire("cSUzd");

var $3rigy = parcelRequire("3rigy");

var $7G7nX = parcelRequire("7G7nX");
/**
 * @param isos A series of ISO dates.
 * @returns The last valid date within the array of ISO strings.
 */ function $41b3b0700e22b1c1$var$getValidDate(isos) {
    return isos.reduce((acc, iso)=>{
        const date = (0, $kQ82p.default)(iso);
        return (0, $dBLX0.default)(date) ? {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear()
        } : acc;
    }, {});
}
const $41b3b0700e22b1c1$var$menuStyles = null;
const $41b3b0700e22b1c1$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>{
    const { calendarValue: calendarValue, calendarView: calendarView, menuInnerWrapper: MenuInnerWrapper } = selectProps;
    const { day: day, month: month, year: year } = $41b3b0700e22b1c1$var$getValidDate([
        calendarValue,
        calendarView
    ]);
    const onMenuMouseDown = (event)=>{
        if (event.button !== 0) return;
        event.stopPropagation();
        event.preventDefault();
    };
    const Wrapper = typeof MenuInnerWrapper === 'function' ? MenuInnerWrapper : (0, $eJOHy.Fragment);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3rigy.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7G7nX.default), {
            inputValue: selectProps.inputValue,
            containerRef: selectProps.calendarContainerRef,
            content: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                ...innerProps,
                onMouseDown: onMenuMouseDown,
                className: (0, $hcewu.default)([
                    "_2rko12b0 _1reo15vq _18m915vq _1pbyowjs _bfhk1bhr _16qs1cd0"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(Wrapper, {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cSUzd.default), {
                        day: day,
                        month: month,
                        year: year,
                        disabled: selectProps.calendarDisabled,
                        disabledDateFilter: selectProps.calendarDisabledDateFilter,
                        minDate: selectProps.calendarMinDate,
                        maxDate: selectProps.calendarMaxDate,
                        nextMonthLabel: selectProps.nextMonthLabel,
                        onChange: selectProps.onCalendarChange,
                        onSelect: selectProps.onCalendarSelect,
                        previousMonthLabel: selectProps.previousMonthLabel,
                        ref: selectProps.calendarRef,
                        selected: [
                            selectProps.calendarValue
                        ],
                        shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
                        locale: selectProps.calendarLocale,
                        testId: selectProps.testId && `${selectProps.testId}--calendar`,
                        weekStartDay: selectProps.calendarWeekStartDay
                    })
                })
            }),
            testId: selectProps.testId
        })
    });
};

});
parcelRegister("7G7nX", function(module, exports) {
$parcel$export(module.exports, "default", () => $68ce7a484b05c143$export$2e2bcd8739ae039);
/* fixed-layer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $3Vuhz = parcelRequire("3Vuhz");

var $anoAR = parcelRequire("anoAR");

var $6G5P1 = parcelRequire("6G5P1");
var $8qmYl = parcelRequire("8qmYl");
var $azjc1 = parcelRequire("azjc1");
const $68ce7a484b05c143$var$styles = {
    root: "_bfhk18uv _kqswstnw _154ize3t",
    popperStyles: "_1pbyowjs"
};
class $68ce7a484b05c143$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.inputValue !== this.props.inputValue) this.update();
    }
    render() {
        const { containerRef: containerRef, content: content, testId: testId } = this.props;
        // Wait for containerRef callback to cause a re-render
        if (!containerRef) return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {});
        const divStyles = {
            height: containerRef.getBoundingClientRect().height,
            // Don't block the clear button
            width: containerRef.getBoundingClientRect().width - parseInt((0, $anoAR.sizes).small.slice(0, -2)) - 8
        };
        return(/* Need to wrap layer in a fixed position div so that it will render its content as fixed
       * We need to set the intial top value to where the container is and zIndex so that it still
       * applies since we're creating a new stacking context. */ /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6G5P1.Manager), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $azjc1.Reference), {
                    children: ({ ref: ref })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            ref: ref,
                            "data-layer-child": true,
                            style: divStyles,
                            className: (0, $hcewu.default)([
                                $68ce7a484b05c143$var$styles.root
                            ])
                        })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8qmYl.Popper), {
                    children: ({ ref: ref, style: style, update: update })=>{
                        this.update = update;
                        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            ref: ref,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            style: style,
                            "data-testid": testId && `${testId}--popper--container`,
                            className: (0, $hcewu.default)([
                                $68ce7a484b05c143$var$styles.popperStyles
                            ]),
                            children: content
                        });
                    }
                })
            ]
        }));
    }
    constructor(...args){
        super(...args), this.update = (0, $3Vuhz.default);
    }
}

});
parcelRegister("anoAR", function(module, exports) {
$parcel$export(module.exports, "sizes", () => $19bef17192bf3a9c$export$c647cb0ee6e282fe);
const $19bef17192bf3a9c$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
const $19bef17192bf3a9c$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
const $19bef17192bf3a9c$export$62ad7b0c781000e9 = {
    small: {
        width: $19bef17192bf3a9c$export$c647cb0ee6e282fe.small,
        height: $19bef17192bf3a9c$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $19bef17192bf3a9c$export$c647cb0ee6e282fe.medium,
        height: $19bef17192bf3a9c$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $19bef17192bf3a9c$export$c647cb0ee6e282fe.large,
        height: $19bef17192bf3a9c$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $19bef17192bf3a9c$export$c647cb0ee6e282fe.xlarge,
        height: $19bef17192bf3a9c$export$c647cb0ee6e282fe.xlarge
    }
};

});



parcelRegister("1u9xN", function(module, exports) {
$parcel$export(module.exports, "getShortISOString", () => $a3c204a1b42604a4$export$77d5bc49fed7ef14);
$parcel$export(module.exports, "getSafeCalendarValue", () => $a3c204a1b42604a4$export$ff525416014fb67d);

var $57raR = parcelRequire("57raR");

var $5PwWU = parcelRequire("5PwWU");
function $a3c204a1b42604a4$export$77d5bc49fed7ef14(date) {
    return (0, $57raR.default)(date, (0, $5PwWU.convertTokens)('YYYY-MM-DD'));
}
function $a3c204a1b42604a4$export$ff525416014fb67d(calendarValue) {
    // If `calendarValue` has a year that is greater than 9999, default to
    // today's date
    const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
    if (yearIsOverLimit) return $a3c204a1b42604a4$export$77d5bc49fed7ef14(new Date());
    return calendarValue;
}

});

parcelRegister("7OE9J", function(module, exports) {
$parcel$export(module.exports, "makeSingleValue", () => $8e54d9aa121b2675$export$6e30bf8cb1347b56);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $6XEne = parcelRequire("6XEne");
const $8e54d9aa121b2675$export$6e30bf8cb1347b56 = // TODO: Make ID required
({ id: id, lang: lang })=>({ children: children, className: className, clearValue: clearValue, cx: cx, data: data, getStyles: getStyles, getValue: getValue, hasValue: hasValue, isDisabled: isDisabled, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, ...rest })=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).SingleValue, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            data: data,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: {
                ...(0, $eGOwo.fg)('platform-dtp_a11y_fix-dsp-23950') ? {
                    id: id
                } : {},
                lang: lang
            },
            isDisabled: isDisabled,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            children: children
        });
    };

});


parcelRegister("k2Uo2", function(module, exports) {
$parcel$export(module.exports, "default", () => $00683ba6c52d5435$export$2e2bcd8739ae039);
/* date-picker-fc.tsx generated by @compiled/babel-plugin v0.36.1 */ /// <reference types="node" />
// for typing `process`

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dBLX0 = parcelRequire("dBLX0");
var $kQ82p = parcelRequire("kQ82p");

var $jrFnt = parcelRequire("jrFnt");

var $Ay1uj = parcelRequire("Ay1uj");

var $6qaBj = parcelRequire("6qaBj");

var $gl2vi = parcelRequire("gl2vi");

var $3GKOL = parcelRequire("3GKOL");

var $cK9J2 = parcelRequire("cK9J2");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");

var $c4OV1 = parcelRequire("c4OV1");
var $e9zKl = parcelRequire("e9zKl");

var $RoXqn = parcelRequire("RoXqn");

var $47or1 = parcelRequire("47or1");

var $hmV0i = parcelRequire("hmV0i");

var $gNwsY = parcelRequire("gNwsY");

var $1u9xN = parcelRequire("1u9xN");

var $7OE9J = parcelRequire("7OE9J");
const $00683ba6c52d5435$var$packageName = "platform-pkg";
const $00683ba6c52d5435$var$packageVersion = "0.0.0-use.local";
const $00683ba6c52d5435$var$styles = {
    pickerContainerStyle: "_kqswh2mm",
    dropdownIndicatorStyles: "_1ul91k8s _1tke1k8s _1e0c1txw _4cvr1h6o _1bah1h6o",
    iconContainerStyles: "_v564vrg3 _1e0c1txw _4t3i1osq _kqswstnw _4cvr1h6o _i0dl1kw7 _syaz131l _152tze3t _rjxpze3t _30l31gjq",
    iconSpacingWithClearButtonStyles: "_12l2xy5q",
    iconSpacingWithoutClearButtonStyles: "_12l21b66"
};
const $00683ba6c52d5435$var$analyticsAttributes = {
    componentName: 'datePicker',
    packageName: $00683ba6c52d5435$var$packageName,
    packageVersion: $00683ba6c52d5435$var$packageVersion
}; /**
    * __Date picker__
    *
    * A date picker allows the user to select a particular date.
    *
    * - [Examples](https://atlassian.design/components/datetime-picker/date-picker/examples)
    * - [Code](https://atlassian.design/components/datetime-picker/date-picker/code)
    * - [Usage](https://atlassian.design/components/datetime-picker/date-picker/usage)
    */ 
const $00683ba6c52d5435$var$DatePicker = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, forwardedRef)=>{
    const containerRef = (0, $eJOHy.useRef)(null);
    const calendarRef = (0, $eJOHy.useRef)(null);
    const calendarButtonRef = (0, $eJOHy.useRef)(null);
    const { appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', disabled: disabled = [], disabledDateFilter: disabledDateFilter = (_)=>false, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($3GKOL))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', name: name = '', onBlur: /* eslint-disable @repo/internal/react/use-noop */ onBlur = (_event)=>{}, onChange: onChangeProp = (_value)=>{}, onFocus: onFocus = (_event)=>{}, selectProps: /* eslint-enable @repo/internal/react/use-noop */ selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', locale: propLocale = 'en-US', value: propValue, isOpen: isOpenProp, maxDate: maxDate, minDate: minDate, weekStartDay: weekStartDay, formatDisplayLabel: formatDisplayLabel, testId: testId, 'aria-describedby': ariaDescribedBy, placeholder: placeholder, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, ...rest } = props;
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(defaultIsOpen);
    const [_, setIsFocused] = (0, $eJOHy.useState)(false);
    const [clearingFromIcon, setClearingFromIcon] = (0, $eJOHy.useState)(false);
    const [selectInputValue, setSelectInputValue] = (0, $eJOHy.useState)(selectProps.inputValue);
    const [value, setValue] = (0, $eJOHy.useState)(propValue || defaultValue);
    const [calendarValue, setCalendarValue] = (0, $eJOHy.useState)(propValue || defaultValue || (0, $1u9xN.getShortISOString)(new Date()));
    const [l10n, setL10n] = (0, $eJOHy.useState)((0, $cK9J2.createLocalizationProvider)(propLocale));
    const [locale, setLocale] = (0, $eJOHy.useState)(propLocale);
    const [shouldSetFocusOnCurrentDay, setShouldSetFocusOnCurrentDay] = (0, $eJOHy.useState)(false);
    const [isKeyDown, setIsKeyDown] = (0, $eJOHy.useState)(false);
    const [wasOpenedFromCalendarButton, setWasOpenedFromCalendarButton] = (0, $eJOHy.useState)(false); // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $eJOHy.useReducer)((x)=>!x, true);
    const onChangePropWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onChangeProp,
        action: 'selectedDate',
        actionSubject: 'datePicker',
        ...$00683ba6c52d5435$var$analyticsAttributes
    });
    if (propLocale !== locale) {
        setL10n((0, $cK9J2.createLocalizationProvider)(propLocale));
        setLocale(propLocale);
    }
    (0, $eJOHy.useEffect)(()=>{
        // We don't want the focus to move if this is a click event
        if (!isKeyDown) return;
        if (isOpen && wasOpenedFromCalendarButton) {
            setIsKeyDown(false); // Focus on the first button within the calendar
            calendarRef?.current?.querySelector('button')?.focus();
        }
    }, [
        isKeyDown,
        calendarRef,
        isOpen,
        wasOpenedFromCalendarButton
    ]);
    const getValue = ()=>propValue ?? value;
    const getIsOpen = ()=>isOpenProp ?? isOpen;
    const onCalendarChange = ({ iso: iso })=>{
        setCalendarValue((0, $47or1.getParsedISO)({
            iso: iso
        }));
    };
    const onCalendarSelect = ({ iso: iso })=>{
        setSelectInputValue('');
        setIsOpen(false);
        setCalendarValue(iso);
        setValue(iso);
        setWasOpenedFromCalendarButton(false);
        onChangePropWithAnalytics(iso); // Yes, this is not ideal. The alternative is to be able to place a ref
        // on the inner input of Select itself, which would require a lot of
        // extra stuff in the Select component for only this one thing. While
        // this would be more "React-y", it doesn't seem to pose any other
        // benefits. Performance-wise, we are only searching within the
        // container, so it's quick.
        if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
        else {
            const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
            innerCombobox?.focus();
        }
        setIsOpen(false);
    };
    const onInputClick = ()=>{
        if (!isDisabled && !getIsOpen()) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onContainerBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (!containerRef?.current?.contains(newlyFocusedElement)) {
            setIsOpen(false);
            setShouldSetFocusOnCurrentDay(false);
            setWasOpenedFromCalendarButton(false);
            onBlur(event);
        }
    };
    const onContainerFocus = ()=>{
        setShouldSetFocusOnCurrentDay(false);
    };
    const onSelectBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
        setClearingFromIcon(false);
        else if (!containerRef?.current?.contains(newlyFocusedElement)) {
            // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            setIsOpen(false);
            setIsFocused(false);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onSelectFocus = (event)=>{
        const value = getValue();
        if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
        setClearingFromIcon(false);
        else {
            // Don't open when focused into via keyboard if the calendar button is present
            setIsOpen(!shouldShowCalendarButton);
            setCalendarValue(value);
            setIsFocused(true);
            setWasOpenedFromCalendarButton(false);
        }
        onFocus(event);
    };
    const onTextInput = (event)=>{
        const inputValue = event.target.value;
        if (inputValue) {
            const parsed = (0, $47or1.parseDate)(inputValue, {
                parseInputValue: rest?.parseInputValue,
                dateFormat: rest?.dateFormat,
                l10n: l10n
            }); // Only try to set the date if we have month & day
            if (parsed && (0, $dBLX0.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
            // this is the format expected by the @atlaskit/calendar component
            setCalendarValue((0, $1u9xN.getShortISOString)(parsed));
        }
        setIsOpen(true);
        setWasOpenedFromCalendarButton(false);
    };
    const onInputKeyDown = (event)=>{
        const value = getValue();
        const keyPressed = event.key.toLowerCase(); // If the input is focused and the calendar is not visible, handle space and enter clicks
        if (!isOpen && (keyPressed === 'enter' || keyPressed === ' ')) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
        switch(keyPressed){
            case 'escape':
                // Yes, this is not ideal. The alternative is to be able to place a ref
                // on the inner input of Select itself, which would require a lot of
                // extra stuff in the Select component for only this one thing. While
                // this would be more "React-y", it doesn't seem to pose any other
                // benefits. Performance-wise, we are only searching within the
                // container, so it's quick.
                if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
                else {
                    const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                    innerCombobox?.focus();
                }
                setIsOpen(false);
                setShouldSetFocusOnCurrentDay(false);
                setWasOpenedFromCalendarButton(false);
                break;
            case 'backspace':
            case 'delete':
                {
                    const inputCount = 0;
                    if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) {
                        // If being cleared from keyboard, don't change behaviour
                        setClearingFromIcon(false);
                        setValue('');
                    }
                    break;
                }
            case 'enter':
                if (!isOpen) return;
                 // Prevent form submission when a date is selected
                // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                // for more details.
                event.preventDefault();
                if (!(0, $47or1.isDateDisabled)(calendarValue, {
                    disabled: disabled
                })) {
                    // Get a safe `calendarValue` in case the value exceeds the maximum
                    // allowed by ISO 8601
                    const safeCalendarValue = (0, $1u9xN.getSafeCalendarValue)(calendarValue);
                    const valueChanged = safeCalendarValue !== value;
                    setSelectInputValue('');
                    setIsOpen(false);
                    setValue(safeCalendarValue);
                    setCalendarValue(safeCalendarValue);
                    setWasOpenedFromCalendarButton(wasOpenedFromCalendarButton);
                    if (valueChanged) onChangePropWithAnalytics(safeCalendarValue);
                }
                break;
            case 'arrowdown':
            case 'arrowup':
                if (!shouldSetFocusOnCurrentDay) {
                    setIsOpen(true);
                    setShouldSetFocusOnCurrentDay(true);
                }
                break;
            default:
                break;
        }
    };
    const onCalendarButtonKeyDown = (e)=>{
        // Don't allow an arrow up or down to open the menu, since the input key
        // down handler is actually on the parent.
        if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
         // We want to stop this from triggering other keydown events, particularly
        // for space and enter presses. Otherwise, it opens and then closes
        // immediately.
        if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
            e.stopPropagation();
            setIsKeyDown(true);
            setWasOpenedFromCalendarButton(true);
        }
    }; // This event handler is triggered from both keydown and click. It's weird.
    const onCalendarButtonClick = (e)=>{
        setIsOpen((isOpen)=>{
            if (isOpen) {
                props.selectProps?.onMenuClose?.();
                return false;
            } else {
                props.selectProps?.onMenuOpen?.();
                return true;
            }
        });
        setWasOpenedFromCalendarButton(true);
        e.stopPropagation();
    };
    const onClear = ()=>{
        setValue('');
        setCalendarValue(defaultValue || (0, $1u9xN.getShortISOString)(new Date()));
        if (!hideIcon) setClearingFromIcon(true);
        onChangePropWithAnalytics('');
    }; // `unknown` is used because `value` is unused so it does not matter.
    const onSelectChange = (_value, action)=>{
        // Used for native clear event in React Select
        // Triggered when clicking ClearIndicator or backspace with no value
        if (action.action === 'clear') onClear();
    };
    const handleSelectInputChange = (selectInputValue, actionMeta)=>{
        if (selectProps.onInputChange) selectProps.onInputChange(selectInputValue, actionMeta);
        setSelectInputValue(selectInputValue);
    };
    const getContainerRef = (0, $eJOHy.useCallback)((ref)=>{
        const oldRef = containerRef.current;
        containerRef.current = ref; // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef == null && ref != null) forceUpdate();
    }, [
        containerRef
    ]);
    const getterValue = getValue();
    let actualSelectInputValue;
    actualSelectInputValue = selectInputValue;
    const menuIsOpen = getIsOpen() && !isDisabled;
    const showClearIndicator = Boolean((getterValue || selectInputValue) && !hideIcon);
    let clearIndicator = Icon;
    if ((0, $eGOwo.fg)('platform-visual-refresh-icons')) clearIndicator = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            xcss: $00683ba6c52d5435$var$styles.dropdownIndicatorStyles,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                ...props
            })
        });
    const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
    const valueId = (0, $gl2vi.useId)();
    const SingleValue = (0, $7OE9J.makeSingleValue)({
        id: valueId,
        lang: propLocale
    });
    const selectComponents = {
        ...selectProps.components,
        DropdownIndicator: shouldShowCalendarButton ? (0, $RoXqn.EmptyComponent) : dropDownIcon,
        // Only use this new container component if the calendar button is shown.
        // Otherwise, it throws errors downstream for some reason
        ...shouldShowCalendarButton ? {
            IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hmV0i.IndicatorsContainer), {
                    ...props,
                    showClearIndicator: showClearIndicator
                })
        } : {},
        Menu: $gNwsY.Menu,
        SingleValue: SingleValue,
        ...!showClearIndicator && {
            ClearIndicator: (0, $RoXqn.EmptyComponent)
        }
    };
    const { styles: selectStyles = {} } = selectProps;
    const disabledStyle = isDisabled ? {
        pointerEvents: 'none',
        color: "var(--ds-icon-disabled, inherit)"
    } : {};
    const calendarProps = {
        calendarContainerRef: containerRef.current,
        calendarDisabled: disabled,
        calendarDisabledDateFilter: disabledDateFilter,
        calendarMaxDate: maxDate,
        calendarMinDate: minDate,
        calendarRef: calendarRef,
        calendarValue: getterValue && (0, $1u9xN.getShortISOString)((0, $kQ82p.default)(getterValue)),
        calendarView: calendarValue,
        onCalendarChange: onCalendarChange,
        onCalendarSelect: onCalendarSelect,
        calendarLocale: locale,
        calendarWeekStartDay: weekStartDay,
        shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay,
        /**
     * This overrides the inner wrapper the Calendar.
     * @private Please use this with extreme caution, this API may be changed in the future.
     */ menuInnerWrapper: props?.menuInnerWrapper
    }; // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $e9zKl.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base,
                ...disabledStyle
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: "var(--ds-space-025, 2px)",
                // ICON_PADDING = 2
                paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
            })
    });
    const initialValue = getterValue ? {
        label: (0, $47or1.formatDate)(getterValue, {
            formatDisplayLabel: formatDisplayLabel,
            dateFormat: rest?.dateFormat,
            l10n: l10n
        }),
        value: getterValue
    } : null; // `label` takes precedence of the `inputLabel`
    const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
    const openCalendarLabelId = `open-calendar-label--${(0, $gl2vi.useId)()}`;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        ...innerProps,
        "data-testid": testId && `${testId}--container`,
        onBlur: onContainerBlur,
        onFocus: onContainerFocus,
        onClick: onInputClick,
        onInput: onTextInput,
        onKeyDown: onInputKeyDown,
        ref: getContainerRef,
        role: "presentation",
        className: (0, $hcewu.default)([
            $00683ba6c52d5435$var$styles.pickerContainerStyle
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                name: name,
                type: "hidden",
                value: getterValue,
                "data-testid": testId && `${testId}--input`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c4OV1.default), {
                appearance: appearance,
                "aria-describedby": (0, $eGOwo.fg)('platform-dtp_a11y_fix-dsp-23950') ? ariaDescribedBy ? `${ariaDescribedBy} ${valueId}` : valueId : ariaDescribedBy,
                label: label || undefined,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                closeMenuOnSelect: true,
                enableAnimation: false,
                inputId: id,
                inputValue: actualSelectInputValue,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: menuIsOpen,
                onBlur: onSelectBlur,
                onChange: onSelectChange,
                onFocus: onSelectFocus,
                onInputChange: handleSelectInputChange,
                placeholder: (0, $47or1.getPlaceholder)({
                    placeholder: placeholder,
                    l10n: l10n
                }),
                // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
                styles: mergedStyles,
                value: initialValue,
                ...selectProps,
                // up when you alter some of the properties in the `selectComponents`
                // object. These errors are still present, and I suspect have always
                // been present, without changing the unrelated code. Ignoring as the
                // component still works as expected despite this error. And also
                // because the select refresh team may solve it later.
                components: selectComponents,
                // selectProps or not and what wil be overwritten
                isClearable: true,
                isInvalid: isInvalid,
                spacing: spacing,
                testId: testId,
                // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
                calendarContainerRef: calendarProps.calendarContainerRef,
                calendarDisabled: calendarProps.calendarDisabled,
                calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                calendarLocale: calendarProps.calendarLocale,
                calendarMaxDate: calendarProps.calendarMaxDate,
                calendarMinDate: calendarProps.calendarMinDate,
                calendarRef: calendarProps.calendarRef,
                calendarValue: calendarProps.calendarValue,
                calendarView: calendarProps.calendarView,
                calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                nextMonthLabel: nextMonthLabel,
                onCalendarChange: calendarProps.onCalendarChange,
                onCalendarSelect: calendarProps.onCalendarSelect,
                previousMonthLabel: previousMonthLabel,
                shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
                menuInnerWrapper: calendarProps.menuInnerWrapper
            }),
            shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: (0, $6qaBj.cx)($00683ba6c52d5435$var$styles.iconContainerStyles, value && !hideIcon ? $00683ba6c52d5435$var$styles.iconSpacingWithClearButtonStyles : $00683ba6c52d5435$var$styles.iconSpacingWithoutClearButtonStyles),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                    appearance: "subtle",
                    label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
                    "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
                    id: openCalendarLabelId,
                    icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3GKOL))), {
                            ...iconProps,
                            color: "var(--ds-icon, #44546F)"
                        }),
                    onClick: onCalendarButtonClick,
                    onKeyDown: onCalendarButtonKeyDown,
                    ref: calendarButtonRef,
                    testId: testId && `${testId}--open-calendar-button`
                })
            }) : null
        ]
    });
});
var $00683ba6c52d5435$export$2e2bcd8739ae039 = $00683ba6c52d5435$var$DatePicker;

});



parcelRegister("7aicR", function(module, exports) {
$parcel$export(module.exports, "DynamicTable", () => $c1c9ab6771d76887$export$af35fa26cfd84ce3);
// stateful version of DynamicTable from @atlaskit

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDTK4 = parcelRequire("kDTK4");

var $5aix7 = parcelRequire("5aix7");

var $dTcg2 = parcelRequire("dTcg2");
/**
 * Non working props excluded:
 * isRankingDisabled
 * onPageRowsUpdate
 * onSort
 */ const $c1c9ab6771d76887$var$renderCellForgeDoc = (cells, render)=>cells.filter((cell)=>cell.type === 'Cell').map((cell)=>{
        const { children: children, props: cellProps } = cell;
        const { cellKey: cellKey, ...restProps } = cellProps || {};
        return {
            ...restProps,
            key: cellKey,
            content: children.map(render).flat()
        };
    });
const $c1c9ab6771d76887$export$af35fa26cfd84ce3 = (props)=>{
    if (props.forgeDoc.children.length === 0) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dTcg2.DynamicTable), {
        ...props
    });
    const { caption: caption, defaultPage: defaultPage, defaultSortKey: defaultSortKey, defaultSortOrder: defaultSortOrder, emptyView: emptyView, highlightedRowIndex: highlightedRowIndex, isFixedSize: isFixedSize, isLoading: isLoading, isRankable: isRankable, label: label, loadingSpinnerSize: loadingSpinnerSize, onRankEnd: onRankEnd, onRankStart: onRankStart, onSetPage: onSetPage, page: page, paginationi18n: paginationi18n, rowsPerPage: rowsPerPage, sortKey: sortKey, sortOrder: sortOrder, testId: testId } = props.forgeDoc.props;
    const headForgeDoc = props.forgeDoc.children.find((child)=>child.type === 'ContentWrapper' && child.props?.name === 'head');
    const head = headForgeDoc ? {
        cells: $c1c9ab6771d76887$var$renderCellForgeDoc(headForgeDoc?.children, props.render)
    } : undefined;
    const rowsForgeDoc = props.forgeDoc.children.find((child)=>child.type === 'ContentWrapper' && child.props?.name === 'rows');
    const rows = rowsForgeDoc?.children.filter((row)=>row.type === 'Row').map((row)=>{
        const { children: children, props: rowProps } = row;
        const { rowKey: rowKey, ...restProps } = rowProps || {};
        return {
            ...restProps,
            key: rowKey,
            cells: $c1c9ab6771d76887$var$renderCellForgeDoc(children, props.render)
        };
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDTK4.default), {
        caption: caption,
        defaultPage: defaultPage,
        defaultSortKey: defaultSortKey,
        defaultSortOrder: defaultSortOrder,
        emptyView: emptyView ? props.render((0, $5aix7.elementToForgeDoc)(emptyView)) : undefined,
        head: head,
        highlightedRowIndex: highlightedRowIndex,
        isFixedSize: isFixedSize,
        isLoading: isLoading,
        isRankable: isRankable,
        label: label,
        loadingSpinnerSize: loadingSpinnerSize,
        onRankEnd: onRankEnd,
        onRankStart: onRankStart,
        onSetPage: onSetPage,
        page: page,
        paginationi18n: paginationi18n,
        rowsPerPage: rowsPerPage,
        rows: rows,
        sortKey: sortKey,
        sortOrder: sortOrder,
        testId: testId
    });
};

});
parcelRegister("kDTK4", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f2b3f32465e4e4b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3Vuhz = parcelRequire("3Vuhz");

var $aXVGO = parcelRequire("aXVGO");

var $lOOiG = parcelRequire("lOOiG");
class $1f2b3f32465e4e4b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            defaultPage: 1,
            isLoading: false,
            isFixedSize: false,
            isRankable: false,
            onSetPage: (0, $3Vuhz.default),
            onSort: (0, $3Vuhz.default),
            rowsPerPage: Infinity
        };
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        const sortKey = newProps.sortKey || this.state.sortKey;
        const sortOrder = newProps.sortOrder || this.state.sortOrder;
        const page = newProps.page || this.state.page;
        this.setState({
            page: page,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rows: newProps.rows
        });
    }
    render() {
        const { page: page, sortKey: sortKey, sortOrder: sortOrder, rows: rows } = this.state;
        const { caption: caption, emptyView: emptyView, head: head, highlightedRowIndex: highlightedRowIndex, loadingSpinnerSize: loadingSpinnerSize, isLoading: isLoading, loadingLabel: loadingLabel, isFixedSize: isFixedSize, isRankable: isRankable, isRankingDisabled: isRankingDisabled, rowsPerPage: rowsPerPage, paginationi18n: paginationi18n, onRankStart: onRankStart, onPageRowsUpdate: onPageRowsUpdate, testId: testId, label: label } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lOOiG.default), {
            paginationi18n: paginationi18n,
            caption: caption,
            emptyView: emptyView,
            head: head,
            highlightedRowIndex: highlightedRowIndex,
            loadingSpinnerSize: loadingSpinnerSize,
            isLoading: isLoading,
            loadingLabel: loadingLabel,
            isFixedSize: isFixedSize,
            onSetPage: this.onSetPageHandler,
            onSort: this.onSortHandler,
            page: page,
            rows: rows,
            rowsPerPage: rowsPerPage,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRankable: isRankable,
            isRankingDisabled: isRankingDisabled,
            onRankEnd: this.onRankEndHandler,
            onRankStart: onRankStart,
            onPageRowsUpdate: onPageRowsUpdate,
            testId: testId,
            label: label
        });
    }
    constructor(...args){
        super(...args), this.state = {
            page: this.props.defaultPage,
            sortKey: this.props.defaultSortKey,
            sortOrder: this.props.defaultSortOrder,
            rows: this.props.rows
        }, this.onSetPageHandler = (page, analyticsEvent)=>{
            const { onSetPage: onSetPage } = this.props;
            if (onSetPage) {
                onSetPage(page, analyticsEvent);
                this.setState({
                    page: page
                });
            }
        }, this.onSortHandler = ({ key: key, item: item, sortOrder: sortOrder }, analyticsEvent)=>{
            const { onSort: onSort } = this.props;
            if (onSort) {
                onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrder
                }, analyticsEvent);
                this.setState({
                    sortKey: key,
                    sortOrder: sortOrder
                });
            }
        }, this.onRankEndIfExistsHandler = (params)=>{
            if (this.props.onRankEnd) this.props.onRankEnd(params);
        }, this.onRankEndHandler = (params)=>{
            const { destination: destination } = params;
            const { rows: rows, page: page } = this.state;
            const { rowsPerPage: rowsPerPage } = this.props;
            if (!destination || !rows) {
                this.onRankEndIfExistsHandler(params);
                return;
            }
            const reordered = (0, $aXVGO.reorderRows)(params, rows, page, rowsPerPage);
            this.setState({
                rows: reordered
            });
            this.onRankEndIfExistsHandler(params);
        };
    }
}

});
parcelRegister("aXVGO", function(module, exports) {
$parcel$export(module.exports, "getPageRows", () => $d0bfac7c95a14ce3$export$3987dc24b734dcab);
$parcel$export(module.exports, "assertIsSortable", () => $d0bfac7c95a14ce3$export$5eb35a4771ec4090);
$parcel$export(module.exports, "validateSortKey", () => $d0bfac7c95a14ce3$export$9133f5a8bfe8a200);
$parcel$export(module.exports, "inlineStylesIfRanking", () => $d0bfac7c95a14ce3$export$a601f1775e10043f);
$parcel$export(module.exports, "reorderRows", () => $d0bfac7c95a14ce3$export$c476bbe5da59992d);
const $d0bfac7c95a14ce3$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
const $d0bfac7c95a14ce3$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
const $d0bfac7c95a14ce3$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
const $d0bfac7c95a14ce3$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
const $d0bfac7c95a14ce3$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
const $d0bfac7c95a14ce3$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = $d0bfac7c95a14ce3$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    const toIndex = $d0bfac7c95a14ce3$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});

parcelRegister("lOOiG", function(module, exports) {
$parcel$export(module.exports, "default", () => $976d89647138dbc1$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");


var $aXVGO = parcelRequire("aXVGO");

var $khVsD = parcelRequire("khVsD");

var $1NCSA = parcelRequire("1NCSA");

var $bEPjZ = parcelRequire("bEPjZ");

var $04ZiM = parcelRequire("04ZiM");

var $foLeX = parcelRequire("foLeX");

var $goxGh = parcelRequire("goxGh");

var $5hPH6 = parcelRequire("5hPH6");

var $iXYwm = parcelRequire("iXYwm");
function $976d89647138dbc1$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $861def5c205d1816$export$b6abcf7fa1d94f65:
            return 0, $861def5c205d1816$export$1dee026a19752d6b;
        case 0, $861def5c205d1816$export$1dee026a19752d6b:
            return 0, $861def5c205d1816$export$b6abcf7fa1d94f65;
        default:
            return currentSortOrder;
    }
}
const $976d89647138dbc1$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $3Vuhz.default), onSort: providedOnSort = (0, $3Vuhz.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $3Vuhz.default), onRankEnd: providedOnRankEnd = (0, $3Vuhz.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: 'Previous Page',
    next: 'Next Page',
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $eJOHy.useState)(false);
    const tableBodyRef = (0, $eJOHy.useRef)(null);
    const onSort = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onRankEnd = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    (0, $eJOHy.useEffect)(()=>{
        (0, $aXVGO.validateSortKey)(sortKey, head);
        (0, $aXVGO.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === (0, $861def5c205d1816$export$b6abcf7fa1d94f65)) {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? (0, $861def5c205d1816$export$1dee026a19752d6b) : $976d89647138dbc1$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page, event)=>{
        onSetPage(page, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params)=>{
        setIsRanking(false);
        onRankEnd(params);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $aXVGO.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $861def5c205d1816$export$7b93a10c0fefe3e3) : (0, $861def5c205d1816$export$71dd4c8ecd45e95f);
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1NCSA.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1NCSA.EmptyViewContainer), {
            testId: testId,
            children: emptyView
        });
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goxGh.default), {
                isLoading: isLoading && rowsExist,
                spinnerSize: spinnerSize,
                targetRef: ()=>tableBodyRef.current,
                testId: testId,
                loadingLabel: loadingLabel,
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $khVsD.Table), {
                    isFixedSize: isFixedSize,
                    "aria-label": label,
                    hasDataRow: rowsExist,
                    testId: testId,
                    isLoading: isLoading,
                    children: [
                        !!caption && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $khVsD.Caption), {
                            children: caption
                        }),
                        head && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iXYwm.default), {
                            head: head,
                            onSort: onSortHandler,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            isRanking: isRanking,
                            isRankable: isRankable,
                            testId: testId
                        }),
                        rowsExist && /*#__PURE__*/ (0, $gt9Am.jsx)($976d89647138dbc1$var$TableBody, {
                            ref: tableBodyRef,
                            highlightedRowIndex: highlightedRowIndex,
                            rows: rows,
                            head: head,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            rowsPerPage: rowsPerPage,
                            page: getPageNumber,
                            isFixedSize: isFixedSize || false,
                            onPageRowsUpdate: onPageRowsUpdate,
                            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
                            testId: testId,
                            isRankable: isRankable,
                            isRanking: isRanking,
                            onRankStart: onRankStartHandler,
                            onRankEnd: onRankEndHandler,
                            isRankingDisabled: isRankingDisabled || isLoading || false
                        })
                    ]
                })
            }),
            totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $khVsD.PaginationWrapper), {
                testId: testId,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5hPH6.default), {
                    value: getPageNumber,
                    onChange: onSetPageHandler,
                    total: totalPages,
                    i18n: paginationi18n,
                    isDisabled: isLoading,
                    testId: testId
                })
            }),
            !rowsExist && emptyBody && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $foLeX.default), {
                isLoading: isLoading,
                spinnerSize: (0, $861def5c205d1816$export$7b93a10c0fefe3e3),
                testId: testId,
                loadingLabel: loadingLabel,
                children: emptyBody
            })
        ]
    });
};

const $976d89647138dbc1$var$RankableTableBody = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("itCCG")));
const $976d89647138dbc1$var$TableBody = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bEPjZ.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $04ZiM.ErrorBoundary), {
        fallback: nonRankableBody,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
            fallback: nonRankableBody,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($976d89647138dbc1$var$RankableTableBody, {
                ref: ref,
                ...bodyProps,
                isRanking: isRanking,
                onRankStart: onRankStart,
                onRankEnd: onRankEnd,
                isRankingDisabled: isRankingDisabled
            })
        })
    }) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$976d89647138dbc1$export$2e2bcd8739ae039 = $976d89647138dbc1$var$DynamicTable;

});
const $861def5c205d1816$export$1dee026a19752d6b = 'ASC';
const $861def5c205d1816$export$b6abcf7fa1d94f65 = 'DESC';
const $861def5c205d1816$export$71dd4c8ecd45e95f = 'small';
const $861def5c205d1816$export$7b93a10c0fefe3e3 = 'large';
const $861def5c205d1816$export$3843c586a90b9cbf = 0.22;

parcelRegister("khVsD", function(module, exports) {
$parcel$export(module.exports, "Table", () => $fd7ebbab92fbe669$export$54ec01a60f47d33d);
$parcel$export(module.exports, "Caption", () => $fd7ebbab92fbe669$export$32fbfacc5d962e0c);
$parcel$export(module.exports, "PaginationWrapper", () => $fd7ebbab92fbe669$export$3e5e12dc01f20a43);
/* dynamic-table.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $fd7ebbab92fbe669$var$fixedSizeTableStyles = null;
const $fd7ebbab92fbe669$var$tableStyles = null;
const $fd7ebbab92fbe669$var$bodyBorder = null;
const $fd7ebbab92fbe669$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("table", {
        inert: isLoading ? '' : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-bg': "var(--ds-background-neutral-subtle-hovered, #091E420F)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-highlighted-bg': "var(--ds-background-selected, #E9F2FF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-highlighted-bg': "var(--ds-background-selected-hovered, #CCE0FF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-row-focus-outline': "var(--ds-border-focused, #388BFF)"
        },
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`,
        className: (0, $hcewu.default)([
            "_1bsb1osq _yq5h18uv _btyzidpf _ect41gqc",
            isFixedSize && "_1kqm1n9t",
            hasDataRow && "_179r187z"
        ]),
        children: children
    });
});
const $fd7ebbab92fbe669$var$captionStyles = null;
const $fd7ebbab92fbe669$export$32fbfacc5d962e0c = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)("caption", {
        className: (0, $hcewu.default)([
            "_11c8lodh _6rthu2gc _1pfh1ejb _m6k41e03"
        ]),
        children: children
    });
const $fd7ebbab92fbe669$var$paginationWrapperStyles = null;
const $fd7ebbab92fbe669$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--pagination--container`,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1h6o"
        ]),
        children: children
    });

});

parcelRegister("1NCSA", function(module, exports) {
$parcel$export(module.exports, "EmptyViewWithFixedHeight", () => $b2a7a5f88e6f100c$export$8f45b9407d4090d7);
$parcel$export(module.exports, "EmptyViewContainer", () => $b2a7a5f88e6f100c$export$381ea436de119582);
/* empty-body.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $b2a7a5f88e6f100c$var$fixedHeightStyles = null;
const $b2a7a5f88e6f100c$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`,
        className: (0, $hcewu.default)([
            "_4t3i1jdh"
        ]),
        children: children
    });
const $b2a7a5f88e6f100c$var$emptyViewContainerStyles = null;
const $b2a7a5f88e6f100c$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-container`,
        className: (0, $hcewu.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1bsb1ssb _y3gn1h6o"
        ]),
        children: children
    });
};

});

parcelRegister("bEPjZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c021f4be43795a4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jNhOC = parcelRequire("jNhOC");

var $lW0bH = parcelRequire("lW0bH");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $2c021f4be43795a4$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef,
            children: pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $lW0bH.default), {
                    head: head,
                    isFixedSize: isFixedSize,
                    row: row,
                    isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                    testId: testId
                }, row.key || rowIndex))
        });
    }
}
const $2c021f4be43795a4$var$Body = (0, $jNhOC.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($2c021f4be43795a4$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2c021f4be43795a4$export$2e2bcd8739ae039 = $2c021f4be43795a4$var$Body;

});
parcelRegister("jNhOC", function(module, exports) {
$parcel$export(module.exports, "default", () => $835026024c70c744$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");


var $aXVGO = parcelRequire("aXVGO");
const $835026024c70c744$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
    }
    return undefined;
};
// sort all rows based on sort key and order
const $835026024c70c744$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === (0, $861def5c205d1816$export$1dee026a19752d6b) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $835026024c70c744$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $835026024c70c744$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $835026024c70c744$export$2e2bcd8739ae039(WrappedComponent) {
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $aXVGO.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $835026024c70c744$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $aXVGO.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args), this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
        return /*#__PURE__*/ (0, $gt9Am.jsx)(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("lW0bH", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4bfc9d23dedd74e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5ljLr = parcelRequire("5ljLr");

var $268TF = parcelRequire("268TF");
const $c4bfc9d23dedd74e$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $268TF.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`,
        children: cells.map((cell, cellIndex)=>{
            const { content: content, testId: cellTestId, ...restCellProps } = cell;
            const { shouldTruncate: shouldTruncate, width: width } = (head || {
                cells: []
            }).cells[cellIndex] || {};
            return /*#__PURE__*/ (0, $eJOHy.createElement)((0, $5ljLr.TableBodyCell), {
                "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                ...restCellProps,
                isFixedSize: isFixedSize,
                key: cellIndex,
                shouldTruncate: shouldTruncate,
                width: width
            }, content);
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c4bfc9d23dedd74e$export$2e2bcd8739ae039 = $c4bfc9d23dedd74e$var$Row;

});
parcelRegister("5ljLr", function(module, exports) {
$parcel$export(module.exports, "TableBodyCell", () => $6d87de66ba7880ae$export$948e91fcef170792);
/* table-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $1eoPo = parcelRequire("1eoPo");
const $6d87de66ba7880ae$var$fixedSizeTruncateStyles = null;
const $6d87de66ba7880ae$var$overflowTruncateStyles = null;
const $6d87de66ba7880ae$var$truncationWidthStyles = null;
const $6d87de66ba7880ae$var$cellStyles = null;
const $6d87de66ba7880ae$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("td", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $1eoPo.getTruncationStyleVars)({
            width: width
        }),
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            "_19itglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            props.className
        ]),
        ...props
    });

});
parcelRegister("1eoPo", function(module, exports) {
$parcel$export(module.exports, "getTruncationStyleVars", () => $91687adffdb20f71$export$5e6497a652ae30b5);
const $91687adffdb20f71$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $91687adffdb20f71$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$91687adffdb20f71$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;

});


parcelRegister("268TF", function(module, exports) {
$parcel$export(module.exports, "TableBodyRow", () => $a53c59e604030c6d$export$45f39d9c38b886d5);
/* table-row.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $a53c59e604030c6d$var$rowStyles = null;
const $a53c59e604030c6d$var$rowBackgroundStyles = null;
const $a53c59e604030c6d$var$rowHighlightedBackgroundStyles = null;
const $a53c59e604030c6d$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, className: className, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("tr", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        /**
   * We rely on this `className` for the `RankableTableBodyRow` to apply extra styles.
   * With Compiled it needs to be statically analyzable. It does not get applied via spread props.
   */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_bfhk1w7a _1ygbsglb _1ah312gs",
            isHighlighted ? "_bfhktkjs _irr31ae3" : "_irr3s8ts",
            className
        ]),
        ...rest,
        ref: ref,
        "data-testid": testId,
        children: children
    });
});

});



parcelRegister("04ZiM", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $fd6eb2a47216dc9b$export$e926676385687eaf);

var $eJOHy = parcelRequire("eJOHy");
class $fd6eb2a47216dc9b$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("foLeX", function(module, exports) {
$parcel$export(module.exports, "default", () => $7869f2e695a66a65$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7ep4S = parcelRequire("7ep4S");


var $CEHHO = parcelRequire("CEHHO");
class $7869f2e695a66a65$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $861def5c205d1816$export$7b93a10c0fefe3e3),
            contentsOpacity: (0, $861def5c205d1816$export$3843c586a90b9cbf),
            loadingLabel: 'Loading table'
        };
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $CEHHO.Container), {
            testId: testId,
            children: [
                !isLoading ? children : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $CEHHO.ContentsContainer), {
                    contentsOpacity: contentsOpacity,
                    testId: testId,
                    children: children
                }),
                isLoading && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $CEHHO.SpinnerContainer), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                        size: spinnerSize,
                        testId: testId && `${testId}--loadingSpinner`,
                        label: loadingLabel
                    })
                })
            ]
        });
    }
}

});
parcelRegister("CEHHO", function(module, exports) {
$parcel$export(module.exports, "Container", () => $dfc2e003c707e1fb$export$42a852a2b6b56249);
$parcel$export(module.exports, "ContentsContainer", () => $dfc2e003c707e1fb$export$67c29eae8ae2137a);
$parcel$export(module.exports, "SpinnerContainer", () => $dfc2e003c707e1fb$export$a5e06607a5ac6158);
/* loading-container.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $dfc2e003c707e1fb$export$c335a80381ec61f5 = '--contents-opacity';
const $dfc2e003c707e1fb$var$containerStyles = null;
const $dfc2e003c707e1fb$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--container`,
        className: (0, $hcewu.default)([
            "_kqswh2mm"
        ]),
        children: children
    });
const $dfc2e003c707e1fb$var$contentsContainerStyles = null;
const $dfc2e003c707e1fb$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            [$dfc2e003c707e1fb$export$c335a80381ec61f5]: contentsOpacity
        },
        "data-testid": testId && `${testId}--contents--container`,
        className: (0, $hcewu.default)([
            "_tzy4saf5 _lcxvglyw"
        ]),
        children: children
    });
const $dfc2e003c707e1fb$var$spinnerContainerStyles = null;
const $dfc2e003c707e1fb$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--spinner--container`,
        className: (0, $hcewu.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o"
        ]),
        children: children
    });

});


parcelRegister("goxGh", function(module, exports) {
$parcel$export(module.exports, "default", () => $313fee558443ede2$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7ep4S = parcelRequire("7ep4S");


var $3rtaW = parcelRequire("3rtaW");
class $313fee558443ede2$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $861def5c205d1816$export$7b93a10c0fefe3e3),
            contentsOpacity: `var(--ds-opacity-loading, ${`${0, $861def5c205d1816$export$3843c586a90b9cbf}`})`,
            loadingLabel: 'Loading table'
        };
    }
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = this.spinnerRef?.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = this.containerRef?.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3rtaW.Container), {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3rtaW.SpinnerBackdrop), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3rtaW.SpinnerContainer), {
                        ref: this.spinnerRef,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                            size: spinnerSize,
                            testId: testId && `${testId}--loadingSpinner`,
                            label: loadingLabel
                        })
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.spinnerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        }, this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        }, this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        }, this.componentWillUnmount = ()=>{
            this.detachListeners();
        }, this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef?.();
            return target || this.containerRef.current;
        }, this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps), this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        }, this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        }, this.handleResize = ()=>{
            this.updateSpinnerPosition();
        }, this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        }, this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        }, this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}

});
parcelRegister("3rtaW", function(module, exports) {
$parcel$export(module.exports, "Container", () => $dcd16b6cedc99af6$export$42a852a2b6b56249);
$parcel$export(module.exports, "SpinnerBackdrop", () => $dcd16b6cedc99af6$export$aa207050321b0c53);
$parcel$export(module.exports, "SpinnerContainer", () => $dcd16b6cedc99af6$export$a5e06607a5ac6158);
/* loading-container-advanced.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $dcd16b6cedc99af6$var$containerStyles = null;
const $dcd16b6cedc99af6$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ...rest,
        "data-testid": testId,
        ref: ref,
        className: (0, $hcewu.default)([
            "_kqswh2mm _6rth1ejb"
        ]),
        children: children
    });
});
const $dcd16b6cedc99af6$var$spinnerBackdropStyles = null;
const $dcd16b6cedc99af6$export$aa207050321b0c53 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--spinner-backdrop`,
        className: (0, $hcewu.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _lcxvglyw"
        ]),
        children: children
    });
const $dcd16b6cedc99af6$var$spinnerContainerStyles = null;
const $dcd16b6cedc99af6$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: ref,
        className: (0, $hcewu.default)([
            "_kqswh2mm _152tidpf"
        ]),
        children: children
    }));

});


parcelRegister("5hPH6", function(module, exports) {
$parcel$export(module.exports, "default", () => $d482c3e387def2e8$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $b3eVo = parcelRequire("b3eVo");
class $d482c3e387def2e8$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b3eVo.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n?.label,
            nextLabel: i18n?.next,
            previousLabel: i18n?.prev,
            pageLabel: i18n?.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args), this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}

});
parcelRegister("b3eVo", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e9938bbbd4852c0$export$2e2bcd8739ae039);
/* pagination.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");

var $7O2l7 = parcelRequire("7O2l7");

var $a2JSB = parcelRequire("a2JSB");

var $1kTzc = parcelRequire("1kTzc");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");

var $2xCo3 = parcelRequire("2xCo3");

var $6CP4r = parcelRequire("6CP4r");

var $3IiVn = parcelRequire("3IiVn");

var $1CN10 = parcelRequire("1CN10");

var $1hfAD = parcelRequire("1hfAD");
const $2e9938bbbd4852c0$var$styles = {
    paginationMenu: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t",
    paginationMenuItem: "_1pfhze3t _ect41gqc",
    navigatorIconWrapper: "_18zr12x7"
};
const $2e9938bbbd4852c0$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $2e9938bbbd4852c0$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($a2JSB))) : (0, (/*@__PURE__*/$parcel$interopDefault($1kTzc)));
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "span",
        xcss: $2e9938bbbd4852c0$var$styles.navigatorIconWrapper,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(Chevron, {
            label: "",
            LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
            color: "currentColor",
            size: "small"
        })
    });
}
function $2e9938bbbd4852c0$var$InnerPagination({ components: components = (0, $1CN10.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $1CN10.emptyObject), max: max = 7, onChange: onChange = (0, $3Vuhz.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $3IiVn.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $7O2l7.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$2e9938bbbd4852c0$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
            as: "li",
            xcss: $2e9938bbbd4852c0$var$styles.paginationMenuItem,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6CP4r.default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`,
                children: getPageLabel ? getPageLabel(page, currPageIndex) : page
            })
        }, `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`);
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            space: "space.0",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2xCo3.default), {
                    component: components.Previous,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue - 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === 0,
                    iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)($2e9938bbbd4852c0$var$NavigatorIcon, {
                        chevronDirection: "left"
                    }),
                    "aria-label": previousLabel,
                    testId: testId && `${testId}--left-navigator`
                }, "left-navigator"),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                    space: "space.0",
                    alignBlock: "baseline",
                    as: "ul",
                    xcss: $2e9938bbbd4852c0$var$styles.paginationMenu,
                    children: (0, $1hfAD.default)(pages, selectedIndexValue, {
                        max: max,
                        ellipsis: renderEllipsis,
                        transform: transform
                    }, testId)
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2xCo3.default), {
                    component: components.Next,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue + 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
                    iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)($2e9938bbbd4852c0$var$NavigatorIcon, {
                        chevronDirection: "right"
                    }),
                    "aria-label": nextLabel,
                    testId: testId && `${testId}--right-navigator`
                }, "right-navigator")
            ]
        })
    }));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $2e9938bbbd4852c0$var$Pagination = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)($2e9938bbbd4852c0$var$InnerPagination));
var $2e9938bbbd4852c0$export$2e2bcd8739ae039 = $2e9938bbbd4852c0$var$Pagination;

});
parcelRegister("2xCo3", function(module, exports) {
$parcel$export(module.exports, "default", () => $390a465a7b875c7d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");
function $390a465a7b875c7d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("6CP4r", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7a0738c73e50f62$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");
function $a7a0738c73e50f62$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("3IiVn", function(module, exports) {
$parcel$export(module.exports, "default", () => $eee95bde3b212432$export$2e2bcd8739ae039);
/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $3cMgR = parcelRequire("3cMgR");

var $6fs4r = parcelRequire("6fs4r");
const $eee95bde3b212432$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $eee95bde3b212432$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "li",
        testId: testId,
        xcss: $eee95bde3b212432$var$styles.container,
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3cMgR.default), {
            testId: testId && `${testId}-text`,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6fs4r.default), {
                    children: [
                        "Skipped pages from ",
                        from,
                        " to ",
                        to
                    ]
                }),
                "\u2026"
            ]
        })
    }, key);
}

});

parcelRegister("1CN10", function(module, exports) {
$parcel$export(module.exports, "emptyObject", () => $1b85b3c8ab534085$export$3f860eba1218f8d3);
const $1b85b3c8ab534085$export$3f860eba1218f8d3 = {};

});

parcelRegister("1hfAD", function(module, exports) {
$parcel$export(module.exports, "default", () => $916df7f6e7c50105$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $916df7f6e7c50105$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $LFmXM.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $916df7f6e7c50105$export$2e2bcd8739ae039 = $916df7f6e7c50105$var$collapseRange;

});



parcelRegister("iXYwm", function(module, exports) {
$parcel$export(module.exports, "default", () => $eab3a1b41c933c64$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aXVGO = parcelRequire("aXVGO");

var $6d05d = parcelRequire("6d05d");

var $2YodG = parcelRequire("2YodG");

var $dYUdf = parcelRequire("dYUdf");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $eab3a1b41c933c64$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    constructor(props){
        super(props);
        this.state = {
            activeSortButtonId: null
        };
    }
    UNSAFE_componentWillMount() {
        (0, $aXVGO.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $aXVGO.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        const { activeSortButtonId: activeSortButtonId } = this.state;
        if (!head) return null;
        const HeadCellComponent = isRankable ? (0, $2YodG.default) : (0, $dYUdf.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6d05d.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("tr", {
                children: cells.map((cell, index)=>{
                    const { ascendingSortTooltip: ascendingSortTooltip, buttonAriaRoleDescription: buttonAriaRoleDescription, colSpan: colSpan, content: content, descendingSortTooltip: descendingSortTooltip, isIconOnlyHeader: isIconOnlyHeader, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
                    // the API.
                    ...restCellProps } = cell;
                    const headCellId = `head-cell-${index}`;
                    const handleClick = ()=>{
                        this.setState({
                            activeSortButtonId: headCellId
                        });
                        if (isSortable) onSort(cell)();
                    };
                    return /*#__PURE__*/ (0, $gt9Am.jsx)(HeadCellComponent, {
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isIconOnlyHeader: isIconOnlyHeader,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        headCellId: headCellId,
                        activeSortButtonId: activeSortButtonId,
                        onClick: handleClick,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ascendingSortTooltip: ascendingSortTooltip,
                        descendingSortTooltip: descendingSortTooltip,
                        buttonAriaRoleDescription: buttonAriaRoleDescription,
                        ...restCellProps
                    }, key || index);
                })
            })
        });
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$eab3a1b41c933c64$export$2e2bcd8739ae039 = $eab3a1b41c933c64$var$TableHead;

});
parcelRegister("6d05d", function(module, exports) {
$parcel$export(module.exports, "Head", () => $8e34007a1dac0529$export$e93312b7773dfcac);
$parcel$export(module.exports, "HeadCell", () => $8e34007a1dac0529$export$4e8024263ace498b);
/* table-head.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");


var $1eoPo = parcelRequire("1eoPo");
const $8e34007a1dac0529$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $8e34007a1dac0529$var$rankingStyles = null;
const $8e34007a1dac0529$var$headStyles = null;
const $8e34007a1dac0529$var$overflowTruncateStyles = null;
const $8e34007a1dac0529$var$truncationWidthStyles = null;
const $8e34007a1dac0529$var$fixedSizeTruncateStyles = null;
const $8e34007a1dac0529$var$cellStyles = null;
const $8e34007a1dac0529$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("thead", {
        "data-testid": testId,
        ...props,
        className: (0, $hcewu.default)([
            "_179rglyw",
            isRanking && "_1e0c1ule"
        ])
    });
};
const $8e34007a1dac0529$var$headCellBaseStyles = null;
const $8e34007a1dac0529$export$4e8024263ace498b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $1eoPo.getTruncationStyleVars)({
            width: width
        }),
        [$8e34007a1dac0529$var$CSS_VAR_TEXT_COLOR]: "var(--ds-text-subtlest, #626F86)"
    };
    const isASC = sortOrder === (0, $861def5c205d1816$export$1dee026a19752d6b);
    const isDESC = sortOrder === (0, $861def5c205d1816$export$b6abcf7fa1d94f65);
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
        return;
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mergedStyles,
        onClick: undefined,
        ref: ref,
        "data-testid": testId,
        ...rest,
        className: (0, $hcewu.default)([
            "_izbqglyw _h7alglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            "_11c8dcr7 _179r187z _mqm2glyw _kqswh2mm _syaz34id _k48pmoej _y3gn1e5h _s7n4nkob _1ygbi3bv",
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq"
        ]),
        children: children
    });
});

});

parcelRegister("2YodG", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8fde9bd86f03325$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $fTTHR = parcelRequire("fTTHR");

var $aXVGO = parcelRequire("aXVGO");

var $dYUdf = parcelRequire("dYUdf");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $e8fde9bd86f03325$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $aXVGO.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dYUdf.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $e8fde9bd86f03325$var$RankableTableHeadCell = (0, $fTTHR.default)($e8fde9bd86f03325$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e8fde9bd86f03325$export$2e2bcd8739ae039 = $e8fde9bd86f03325$var$RankableTableHeadCell;

});
parcelRegister("fTTHR", function(module, exports) {
$parcel$export(module.exports, "default", () => $173dc77e0c07b527$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $173dc77e0c07b527$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args), this.state = {
                refWidth: 0,
                refHeight: 0
            }, this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            }, this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("dYUdf", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5386cb5a0fc1b36$export$2e2bcd8739ae039);
/* table-head-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8Gywp = parcelRequire("8Gywp");

var $aDbql = parcelRequire("aDbql");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");
var $46R8N = parcelRequire("46R8N");

var $k71qx = parcelRequire("k71qx");


var $6d05d = parcelRequire("6d05d");
const $f5386cb5a0fc1b36$var$styles = {
    buttonWrapper: "_1e0c1txw _bfhk18uv _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _d0altlke",
    sortIconHiddenWrapper: "_1e0c1txw _tzy4idpf _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1h7hkb7n",
    sortIconVisibleWrapper: "_1e0c1txw _tzy4kb7n _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    hideIconHeaderWrapper: "_tzy4idpf _18u010v4",
    visibleHeaderWrapper: "_tzy4kb7n _u5f31b66"
};
const $f5386cb5a0fc1b36$var$headCellStyles = {
    headCellContainer: "_1e0c1txw _4cvr1h6o",
    text: "_11c81o8v _syaz1gjq _k48pmoej"
};
const $f5386cb5a0fc1b36$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, sortOrder: sortOrder, onClick: onClick, headCellId: headCellId, activeSortButtonId: activeSortButtonId, ascendingSortTooltip: ascendingSortTooltip = 'Sort ascending', descendingSortTooltip: descendingSortTooltip = 'Sort descending', buttonAriaRoleDescription: buttonAriaRoleDescription = 'Sort button', isIconOnlyHeader: isIconOnlyHeader, ...rest })=>{
    const [isHovered, setIsHovered] = (0, $eJOHy.useState)(false);
    const [isFocused, setIsFocused] = (0, $eJOHy.useState)(false);
    const isActive = headCellId === activeSortButtonId || sortOrder !== undefined;
    const isSortIconVisible = isHovered || isActive || isFocused;
    const isVisibleIconOnlyHeader = isSortIconVisible && isIconOnlyHeader;
    const shouldRenderSortIcon = !isIconOnlyHeader || isSortIconVisible || isIconOnlyHeader && !isFocused;
    const handleFocus = (0, $eJOHy.useCallback)(()=>{
        setIsFocused?.(true);
    }, [
        setIsFocused
    ]);
    const handleBlur = (0, $eJOHy.useCallback)(()=>{
        setIsFocused?.(false);
    }, [
        setIsFocused
    ]);
    const handleMouseEnter = (0, $eJOHy.useCallback)(()=>{
        setIsHovered(true);
    }, [
        setIsHovered
    ]);
    const handleMouseLeave = (0, $eJOHy.useCallback)(()=>{
        setIsHovered(false);
    }, [
        setIsHovered
    ]);
    const visuallyRefreshedButton = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: $f5386cb5a0fc1b36$var$headCellStyles.headCellContainer,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
            content: sortOrder === (0, $861def5c205d1816$export$1dee026a19752d6b) ? ascendingSortTooltip : descendingSortTooltip,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $46R8N.default), {
                onClick: onClick,
                xcss: $f5386cb5a0fc1b36$var$styles.buttonWrapper,
                "aria-roledescription": buttonAriaRoleDescription,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2sLVw.default), {
                        xcss: isVisibleIconOnlyHeader ? $f5386cb5a0fc1b36$var$styles.hideIconHeaderWrapper : $f5386cb5a0fc1b36$var$styles.visibleHeaderWrapper,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            className: (0, $hcewu.default)([
                                $f5386cb5a0fc1b36$var$headCellStyles.text
                            ]),
                            children: content
                        })
                    }),
                    shouldRenderSortIcon && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2sLVw.default), {
                        xcss: isSortIconVisible ? $f5386cb5a0fc1b36$var$styles.sortIconVisibleWrapper : $f5386cb5a0fc1b36$var$styles.sortIconHiddenWrapper,
                        children: sortOrder === (0, $861def5c205d1816$export$1dee026a19752d6b) ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aDbql))), {
                            label: "",
                            color: "var(--ds-text-subtle, #44546F)",
                            testId: testId && `${testId}--up--icon`
                        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Gywp))), {
                            label: "",
                            color: "var(--ds-text-subtle, #44546F)",
                            testId: testId && `${testId}--down--icon`
                        })
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6d05d.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        isSortable: isSortable,
        sortOrder: sortOrder,
        children: isSortable ? visuallyRefreshedButton : content
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f5386cb5a0fc1b36$export$2e2bcd8739ae039 = $f5386cb5a0fc1b36$var$TableHeadCell;

});
parcelRegister("8Gywp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fcfd9fc2877ad309c8a5d6e5d6ea9482>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $652d0645e24346a6$var$_react = $652d0645e24346a6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $652d0645e24346a6$var$_baseNew = $652d0645e24346a6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $652d0645e24346a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $652d0645e24346a6$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $652d0645e24346a6$var$_react.default.createElement($652d0645e24346a6$var$_baseNew.default, Object.assign({
        name: "ArrowDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$652d0645e24346a6$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $652d0645e24346a6$var$_default = module.exports.default = $652d0645e24346a6$var$ArrowDownIcon;

});

parcelRegister("aDbql", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be13ec6c7b346b13ffda97746cc85c67>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7bd6687a611ada9e$var$_react = $7bd6687a611ada9e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7bd6687a611ada9e$var$_baseNew = $7bd6687a611ada9e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $7bd6687a611ada9e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7bd6687a611ada9e$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $7bd6687a611ada9e$var$_react.default.createElement($7bd6687a611ada9e$var$_baseNew.default, Object.assign({
        name: "ArrowUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$7bd6687a611ada9e$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $7bd6687a611ada9e$var$_default = module.exports.default = $7bd6687a611ada9e$var$ArrowUpIcon;

});




parcelRegister("itCCG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("4aw4p")
]).then(()=>parcelRequire('l7wPr'));

});



parcelRegister("5aix7", function(module, exports) {
$parcel$export(module.exports, "elementToForgeDoc", () => $6b3e4b198632dd5f$export$1b341f978fa5ef9a);

var $8KLBw = parcelRequire("8KLBw");
const $6b3e4b198632dd5f$var$Fragment = 'Fragment';
// Handles the different cases of React's fragment component
const $6b3e4b198632dd5f$var$isReactFragment = (type)=>type === 'Symbol(react.fragment)' || type === 'fragment' || type === undefined;
// Filter out any children that contain only whitespace
const $6b3e4b198632dd5f$var$filterEmptyReactChildren = (children)=>{
    // Ensuring children is an array here as single elements will be an object
    // React.Children.toArray is not used as certain components could be passing JSX as an object to elementToForgeDoc
    const childrenAsArray = Array.isArray(children) ? children : [
        children
    ];
    return childrenAsArray.filter((child)=>!!child && (typeof child !== 'string' || child.trim() !== ''));
};
// converts react element(s) to forgeDoc(s) recursively
// and additionally prune and cleanup unnecessary empty fragments
const $6b3e4b198632dd5f$var$elementToForgeDocConversionWithFragmentHandling = (elem, isRoot = false)=>{
    // Handles string child for components
    if (typeof elem === 'string' || typeof elem === 'number') return {
        type: 'String',
        props: {
            text: elem
        },
        children: []
    };
    else if (Array.isArray(elem)) return elem.flatMap((e)=>$6b3e4b198632dd5f$var$elementToForgeDocConversionWithFragmentHandling(e));
    else if (typeof elem === 'object') {
        let type = elem.type?.toString();
        const key = (0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))();
        if ($6b3e4b198632dd5f$var$isReactFragment(type)) {
            type = $6b3e4b198632dd5f$var$Fragment;
            if (!isRoot) {
                const { children: children } = elem.props;
                return $6b3e4b198632dd5f$var$elementToForgeDocConversionWithFragmentHandling($6b3e4b198632dd5f$var$filterEmptyReactChildren(children));
            }
        }
        // Remove children from props as we handle them separately
        const { children: children, ...rest } = elem.props;
        const props = rest;
        return {
            type: type,
            key: key,
            props: props,
            children: $6b3e4b198632dd5f$var$elementToForgeDocConversionWithFragmentHandling($6b3e4b198632dd5f$var$filterEmptyReactChildren(children))
        };
    }
    throw new Error(`Can\'t create ForgeDoc from ${elem}`);
};
const $6b3e4b198632dd5f$export$1b341f978fa5ef9a = (elem)=>{
    const forgeDoc = $6b3e4b198632dd5f$var$elementToForgeDocConversionWithFragmentHandling(elem, true);
    if (Array.isArray(forgeDoc)) throw new Error('Multiple root fragments are not supported');
    return forgeDoc;
};

});

parcelRegister("dTcg2", function(module, exports) {
$parcel$export(module.exports, "DynamicTable", () => $2e0a122f234d26fb$export$af35fa26cfd84ce3);
// stateful version of DynamicTable from @atlaskit

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5aix7 = parcelRequire("5aix7");

var $kDTK4 = parcelRequire("kDTK4");
const $2e0a122f234d26fb$export$bf0162d825d6e13 = {
    createAnalyticsEvent: false,
    caption: true,
    defaultPage: true,
    defaultSortKey: true,
    defaultSortOrder: true,
    emptyView: {
        value: 'emptyView ? props.render(elementToForgeDoc(emptyView)) as ReactElement : undefined'
    },
    head: {
        value: 'head ? renderRow(head, props.render): undefined',
        comment: "Rendering each cell's content as one React element"
    },
    highlightedRowIndex: true,
    isFixedSize: true,
    isLoading: true,
    isRankable: true,
    label: true,
    loadingSpinnerSize: true,
    onRankEnd: true,
    onRankStart: true,
    onSetPage: true,
    page: true,
    paginationi18n: true,
    rowsPerPage: true,
    rows: {
        value: 'rows?.map((r) => renderRow(r, props.render))',
        comment: "Rendering each cell's content as one React element"
    },
    sortKey: true,
    sortOrder: true,
    testId: true
};
const $2e0a122f234d26fb$var$renderRow = (row, render)=>{
    // not supporting onClick and onKeyPress to simplify API
    const { cells: cells, onClick: onClick, onKeyPress: onKeyPress, ...rest } = row;
    return {
        ...rest,
        cells: cells.map((cell)=>{
            const preRenderedContent = cell.content !== undefined ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
                children: render((0, $5aix7.elementToForgeDoc)(cell.content))
            }, cell.key) : null;
            return {
                ...cell,
                content: preRenderedContent
            };
        })
    };
};
const $2e0a122f234d26fb$export$af35fa26cfd84ce3 = (props)=>{
    const { caption: caption, defaultPage: defaultPage, defaultSortKey: defaultSortKey, defaultSortOrder: defaultSortOrder, emptyView: emptyView, head: head, highlightedRowIndex: highlightedRowIndex, isFixedSize: isFixedSize, isLoading: isLoading, isRankable: isRankable, label: label, loadingSpinnerSize: loadingSpinnerSize, onRankEnd: onRankEnd, onRankStart: onRankStart, onSetPage: onSetPage, page: page, paginationi18n: paginationi18n, rowsPerPage: rowsPerPage, rows: rows, sortKey: sortKey, sortOrder: sortOrder, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDTK4.default), {
        caption: caption,
        defaultPage: defaultPage,
        defaultSortKey: defaultSortKey,
        defaultSortOrder: defaultSortOrder,
        emptyView: emptyView ? props.render((0, $5aix7.elementToForgeDoc)(emptyView)) : undefined,
        // Rendering each cell's content as one React element
        head: head ? $2e0a122f234d26fb$var$renderRow(head, props.render) : undefined,
        highlightedRowIndex: highlightedRowIndex,
        isFixedSize: isFixedSize,
        isLoading: isLoading,
        isRankable: isRankable,
        label: label,
        loadingSpinnerSize: loadingSpinnerSize,
        onRankEnd: onRankEnd,
        onRankStart: onRankStart,
        onSetPage: onSetPage,
        page: page,
        paginationi18n: paginationi18n,
        rowsPerPage: rowsPerPage,
        // Rendering each cell's content as one React element
        rows: rows?.map((r)=>$2e0a122f234d26fb$var$renderRow(r, props.render)),
        sortKey: sortKey,
        sortOrder: sortOrder,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});


parcelRegister("jjGAp", function(module, exports) {
$parcel$export(module.exports, "EmptyState", () => $b9bbf9242b8f5ce2$export$fddf379e22a74b00);

var $gt9Am = parcelRequire("gt9Am");

var $5aix7 = parcelRequire("5aix7");
parcelRequire("eJOHy");

var $6MnLl = parcelRequire("6MnLl");
const $b9bbf9242b8f5ce2$export$bf0162d825d6e13 = {
    buttonGroupLabel: true,
    description: {
        value: 'description ? props.render(elementToForgeDoc(description as ReactElement)) : undefined'
    },
    header: true,
    headingLevel: true,
    imageHeight: false,
    imageUrl: false,
    imageWidth: false,
    isLoading: true,
    maxImageHeight: false,
    maxImageWidth: false,
    primaryAction: {
        value: 'primaryAction ? props.render(elementToForgeDoc(primaryAction as ReactElement)) : undefined'
    },
    renderImage: false,
    secondaryAction: {
        value: 'secondaryAction ? props.render(elementToForgeDoc(secondaryAction as ReactElement)) : undefined'
    },
    tertiaryAction: {
        value: 'tertiaryAction ? props.render(elementToForgeDoc(tertiaryAction as ReactElement)) : undefined'
    },
    testId: true,
    width: true
};
const $b9bbf9242b8f5ce2$export$fddf379e22a74b00 = (props)=>{
    const { buttonGroupLabel: buttonGroupLabel, description: description, header: header, headingLevel: headingLevel, isLoading: isLoading, primaryAction: primaryAction, secondaryAction: secondaryAction, tertiaryAction: tertiaryAction, testId: testId, width: width } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6MnLl.default), {
        buttonGroupLabel: buttonGroupLabel,
        description: description ? props.render((0, $5aix7.elementToForgeDoc)(description)) : undefined,
        header: header,
        headingLevel: headingLevel,
        isLoading: isLoading,
        primaryAction: primaryAction ? props.render((0, $5aix7.elementToForgeDoc)(primaryAction)) : undefined,
        secondaryAction: secondaryAction ? props.render((0, $5aix7.elementToForgeDoc)(secondaryAction)) : undefined,
        tertiaryAction: tertiaryAction ? props.render((0, $5aix7.elementToForgeDoc)(tertiaryAction)) : undefined,
        testId: testId,
        width: width
    });
}; /**
 * @codegenEnd
 */  /* eslint @repo/internal/codegen/signed-source-integrity: "warn" */ 

});

parcelRegister("2EmTa", function(module, exports) {
$parcel$export(module.exports, "ErrorMessage", () => $4dcb17397562abee$export$915e9e7bd4f0f96d);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $fKXve = parcelRequire("fKXve");
const $4dcb17397562abee$export$bf0162d825d6e13 = {
    children: true,
    testId: true
};
const $4dcb17397562abee$export$915e9e7bd4f0f96d = (props)=>{
    const { testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fKXve.ErrorMessage), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                children: props.render(c)
            }, c.key)),
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("1vOwE", function(module, exports) {
$parcel$export(module.exports, "FileCard", () => $b89a613937e1f46a$export$593fd10f7e6c6505);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $5CSKW = parcelRequire("5CSKW");

var $c9qWp = parcelRequire("c9qWp");

var $jvbqF = parcelRequire("jvbqF");

var $fJNLD = parcelRequire("fJNLD");

var $6D1qw = parcelRequire("6D1qw");

var $bTWCd = parcelRequire("bTWCd");

var $6zhpo = parcelRequire("6zhpo");

var $5Mb5i = parcelRequire("5Mb5i");

var $fKXve = parcelRequire("fKXve");
/**
 * Format file size in human-readable format
 */ const $b89a613937e1f46a$var$formatFileSize = (bytes)=>{
    if (bytes === 0) return '0 B';
    const k = 1024;
    const sizes = [
        'B',
        'KB',
        'MB',
        'GB',
        'TB'
    ];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`;
};
/**
 * Get file extension from filename (if included)
 */ const $b89a613937e1f46a$var$getFileExtension = (fileName)=>{
    const lastDot = fileName.lastIndexOf('.');
    return lastDot > 0 ? fileName.substring(lastDot + 1).toUpperCase() : '';
};
/**
 * Get file extension from MIME type by parsing the type
 */ const $b89a613937e1f46a$var$getExtensionFromMimeType = (mimeType)=>{
    // Extract the subtype from MIME type (e.g., "image/png" -> "png")
    const parts = mimeType.split('/');
    if (parts.length === 2) return parts[1].toUpperCase();
    return '';
};
/**
 * Get the appropriate icon component based on MIME type
 */ const $b89a613937e1f46a$var$getFileIcon = (mimeType)=>{
    if (!mimeType) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jvbqF))), {
        label: "File"
    });
    const type = mimeType.toLowerCase();
    if (type.startsWith('image/')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fJNLD))), {
        label: "Image file"
    });
    if (type.startsWith('audio/')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6D1qw))), {
        label: "Audio file"
    });
    if (type.startsWith('video/')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bTWCd))), {
        label: "Video file"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jvbqF))), {
        label: "File"
    });
};
const $b89a613937e1f46a$var$styles = {
    card: "_2rko12b0 _v5641hdd _zulppxbi _1dqonqa1 _189ee4h9 _1h6dmuej _1e0c1txw _4cvr1h6o _1bsb1osq _4t3i1wug _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    fileIcon: "_1e0c1txw _4cvr1h6o _1bah1h6o",
    fileInfo: "_16jlkb7n _1o9zkb7n _i0dlf1ug",
    actionButtons: "_1e0c1txw _4cvr1h6o",
    progressBar: "_ca0qu2gc"
};
const $b89a613937e1f46a$export$593fd10f7e6c6505 = (props)=>{
    const { fileName: fileName, fileSize: fileSize, fileType: fileType, canDelete: canDelete = true, canDownload: canDownload = true, onDelete: onDelete, onDownload: onDownload, isUploading: isUploading = false, uploadProgress: uploadProgress = 0, testId: testId, error: error } = props.forgeDoc.props;
    const formattedSize = fileSize ? $b89a613937e1f46a$var$formatFileSize(fileSize || 0) : undefined;
    const fileExtension = fileType ? $b89a613937e1f46a$var$getExtensionFromMimeType(fileType) : $b89a613937e1f46a$var$getFileExtension(fileName);
    const handleDownload = (e)=>{
        e.stopPropagation();
        onDownload?.();
    };
    const handleDelete = (e)=>{
        e.stopPropagation();
        onDelete?.();
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
        xcss: $b89a613937e1f46a$var$styles.card,
        backgroundColor: "elevation.surface.raised",
        onMouseEnter: (e)=>{
            e.currentTarget.style.backgroundColor = "var(--ds-background-neutral-subtle-hovered, #F4F5F7)";
        },
        onMouseLeave: (e)=>{
            e.currentTarget.style.backgroundColor = "var(--ds-surface-raised, #FFFFFF)";
        },
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $b89a613937e1f46a$var$styles.fileIcon,
                children: $b89a613937e1f46a$var$getFileIcon(fileType)
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                space: "space.050",
                xcss: $b89a613937e1f46a$var$styles.fileInfo,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                        children: fileName
                    }),
                    error ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fKXve.ErrorMessage), {
                        children: error
                    }) : isUploading ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                        xcss: $b89a613937e1f46a$var$styles.progressBar,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c9qWp.default), {
                            value: uploadProgress,
                            ariaLabel: `${fileName} is currently uploading`
                        })
                    }) : (fileExtension || formattedSize) && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                        color: "color.text.subtle",
                        children: [
                            fileExtension,
                            formattedSize
                        ].filter(Boolean).join(" \u2022 ")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
                xcss: $b89a613937e1f46a$var$styles.actionButtons,
                children: [
                    canDownload && !isUploading && !error && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                        appearance: "subtle",
                        onClick: handleDownload,
                        "aria-label": `download ${fileName}`,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5Mb5i))), {
                            label: "Download"
                        })
                    }),
                    canDelete && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                        appearance: "subtle",
                        onClick: handleDelete,
                        "aria-label": `delete ${fileName}`,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))), {
                            label: "Delete"
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("c9qWp", function(module, exports) {
$parcel$export(module.exports, "default", () => $f72ae726177d4e89$export$2e2bcd8739ae039);
/* progress-bar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
const $f72ae726177d4e89$var$MIN_VALUE = 0;
const $f72ae726177d4e89$var$MAX_VALUE = 1;
const $f72ae726177d4e89$var$increasingBarAnimation = null;
const $f72ae726177d4e89$var$decreasingBarAnimation = null;
const $f72ae726177d4e89$var$containerStyles = null;
const $f72ae726177d4e89$var$containerAppearance = {
    default: "_bfhk1t45",
    success: "_bfhk1t45",
    inverse: "_bfhklgn7"
};
const $f72ae726177d4e89$var$barAppearance = {
    default: "_bfhk1wby",
    success: "_bfhk1bh5",
    inverse: "_bfhkvuon"
};
const $f72ae726177d4e89$var$barStyles = null;
const $f72ae726177d4e89$var$determinateBarStyles = null;
const $f72ae726177d4e89$var$increasingBarStyles = null;
const $f72ae726177d4e89$var$decreasingBarStyles = null;
/**
 * __Progress bar__
 *
 * A progress bar displays the status of a given process.
 *
 * - [Examples](https://atlassian.design/components/progress-bar/examples)
 * - [Code](https://atlassian.design/components/progress-bar/code)
 * - [Usage](https://atlassian.design/components/progress-bar/usage)
 */ const $f72ae726177d4e89$var$ProgressBar = ({ appearance: appearance = 'default', ariaLabel: ariaLabel, isIndeterminate: isIndeterminate = false, testId: testId = 'progress-bar', value: value = 0 })=>{
    const valueParsed = isIndeterminate ? $f72ae726177d4e89$var$MIN_VALUE : Math.max($f72ae726177d4e89$var$MIN_VALUE, Math.min(value, $f72ae726177d4e89$var$MAX_VALUE));
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        role: "progressbar",
        "aria-label": ariaLabel,
        "aria-valuemin": $f72ae726177d4e89$var$MIN_VALUE,
        "aria-valuenow": valueParsed,
        "aria-valuemax": $f72ae726177d4e89$var$MAX_VALUE,
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_2rkofajl _1reo15vq _18m915vq _1bsb1osq _4t3ii2wt _kqswh2mm _bfhk1t45",
            $f72ae726177d4e89$var$containerAppearance[appearance]
        ]),
        children: isIndeterminate ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                    className: (0, $hcewu.default)([
                        "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
                        $f72ae726177d4e89$var$barAppearance[appearance],
                        "_5sagymdr _tip812c5 _j7hq7g40"
                    ])
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                    className: (0, $hcewu.default)([
                        "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
                        $f72ae726177d4e89$var$barAppearance[appearance],
                        "_ju251bs3 _5sagymdr _tip812c5 _j7hqio0v"
                    ])
                })
            ]
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            style: {
                width: `${Number(value) * 100}%`
            },
            className: (0, $hcewu.default)([
                "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
                $f72ae726177d4e89$var$barAppearance[appearance],
                "_v564calv"
            ])
        })
    });
};
var $f72ae726177d4e89$export$2e2bcd8739ae039 = $f72ae726177d4e89$var$ProgressBar;

});

parcelRegister("jvbqF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::51c2fad80696a752d051082f1f9faaf4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e329c724a11ab833$var$_react = $e329c724a11ab833$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e329c724a11ab833$var$_baseNew = $e329c724a11ab833$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $e329c724a11ab833$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e329c724a11ab833$var$FileIcon = (props)=>/*#__PURE__*/ $e329c724a11ab833$var$_react.default.createElement($e329c724a11ab833$var$_baseNew.default, Object.assign({
        name: "FileIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.25c0-.52-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v8a.5.5 0 0 1-.5.5zm7.94-10H9.5V2.06z" clip-rule="evenodd"/>`
    }, props));
$e329c724a11ab833$var$FileIcon.displayName = 'FileIcon';
var $e329c724a11ab833$var$_default = module.exports.default = $e329c724a11ab833$var$FileIcon;

});

parcelRegister("fJNLD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ad20bbceb59bcdcbded64441a3f93ce4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b751a9bb99d4e227$var$_react = $b751a9bb99d4e227$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $b751a9bb99d4e227$var$_baseNew = $b751a9bb99d4e227$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $b751a9bb99d4e227$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Image".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: images, image upload.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b751a9bb99d4e227$var$ImageIcon = (props)=>/*#__PURE__*/ $b751a9bb99d4e227$var$_react.default.createElement($b751a9bb99d4e227$var$_baseNew.default, Object.assign({
        name: "ImageIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.75 4a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5"/><path fill="currentcolor" fill-rule="evenodd" d="M13 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zM3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h.644l6.274-7.723.053-.058a.75.75 0 0 1 1.06 0L13.5 8.19V3a.5.5 0 0 0-.5-.5zm2.575 11H13a.5.5 0 0 0 .5-.5v-2.69l-2.943-2.943z" clip-rule="evenodd"/>`
    }, props));
$b751a9bb99d4e227$var$ImageIcon.displayName = 'ImageIcon';
var $b751a9bb99d4e227$var$_default = module.exports.default = $b751a9bb99d4e227$var$ImageIcon;

});

parcelRegister("6D1qw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b5ae331244e5ce5f0d911605ea315070>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4d377de9253f47e1$var$_react = $4d377de9253f47e1$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4d377de9253f47e1$var$_baseNew = $4d377de9253f47e1$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $4d377de9253f47e1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Audio".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/core/audio
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4d377de9253f47e1$var$AudioIcon = (props)=>/*#__PURE__*/ $4d377de9253f47e1$var$_react.default.createElement($4d377de9253f47e1$var$_baseNew.default, Object.assign({
        name: "AudioIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.746 1.188A.75.75 0 0 1 15 1.75V11a3 3 0 1 1-3-3h1.5V5.85L7 6.662V12a3 3 0 1 1-3-3h1.5V2.75a.75.75 0 0 1 .657-.744l8-1a.75.75 0 0 1 .59.182M5.5 10.5H4A1.5 1.5 0 1 0 5.5 12zM7 5.15l6.5-.812V2.6L7 3.412zm6.5 4.35H12a1.5 1.5 0 1 0 1.5 1.5z" clip-rule="evenodd"/>`
    }, props));
$4d377de9253f47e1$var$AudioIcon.displayName = 'AudioIcon';
var $4d377de9253f47e1$var$_default = module.exports.default = $4d377de9253f47e1$var$AudioIcon;

});

parcelRegister("5Mb5i", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::856226f5e73dfc11c44d43d912e311e0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $434a088e5f2bb7a6$var$_react = $434a088e5f2bb7a6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $434a088e5f2bb7a6$var$_baseNew = $434a088e5f2bb7a6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $434a088e5f2bb7a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Download".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $434a088e5f2bb7a6$var$DownloadIcon = (props)=>/*#__PURE__*/ $434a088e5f2bb7a6$var$_react.default.createElement($434a088e5f2bb7a6$var$_baseNew.default, Object.assign({
        name: "DownloadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v7.44l2.72-2.72 1.06 1.06-4 4a.75.75 0 0 1-1.06 0l-4-4 1.06-1.06 2.72 2.72V1zM1 13V9h1.5v4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9H15v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$434a088e5f2bb7a6$var$DownloadIcon.displayName = 'DownloadIcon';
var $434a088e5f2bb7a6$var$_default = module.exports.default = $434a088e5f2bb7a6$var$DownloadIcon;

});


parcelRegister("1JS9A", function(module, exports) {
$parcel$export(module.exports, "FilePicker", () => $0246d99e208034c4$export$54dc470bcc5c41d1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5CSKW = parcelRequire("5CSKW");

var $bzGVj = parcelRequire("bzGVj");

var $8IeH1 = parcelRequire("8IeH1");
var $3cMgR = parcelRequire("3cMgR");

var $6CugT = parcelRequire("6CugT");
parcelRequire("axsXh");
var $1HnDU = parcelRequire("1HnDU");

var $5Ovjr = parcelRequire("5Ovjr");
var $0246d99e208034c4$require$Buffer = $5Ovjr.Buffer;
const $0246d99e208034c4$var$dropzoneStyle = null;
const $0246d99e208034c4$var$inDropzoneStyle = null;
const $0246d99e208034c4$var$notInDropzoneStyle = null;
const $0246d99e208034c4$var$serializeFiles = async (files)=>{
    return Promise.all(files.map(async (file)=>{
        const buffer = await file.arrayBuffer();
        return {
            name: file.name,
            type: file.type,
            size: file.size,
            data: $0246d99e208034c4$require$Buffer.from(buffer).toString('base64')
        };
    }));
};
const $0246d99e208034c4$export$54dc470bcc5c41d1 = (props)=>{
    const { description: description, label: label, onChange: onChange, testId: testId } = props.forgeDoc.props;
    const [inDropzone, setInDropzone] = (0, $eJOHy.useState)(false);
    const inputRef = (0, $eJOHy.useRef)(null);
    const dropRef = (0, $eJOHy.useRef)(null);
    const onInputTriggerClick = (0, $eJOHy.useCallback)(()=>{
        inputRef.current?.click();
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        const element = dropRef.current;
        if (!element) return;
        return (0, $6CugT.dropTargetForExternal)({
            element: element,
            onDragEnter: ()=>{
                setInDropzone(true);
            },
            onDragLeave: ()=>{
                setInDropzone(false);
            },
            onDrop: onChange ? async ({ source: source })=>{
                const files = await (0, $1HnDU.getFiles)({
                    source: source
                });
                const serializedFiles = await $0246d99e208034c4$var$serializeFiles(files);
                await onChange(serializedFiles);
            } : undefined
        });
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
        testId: testId,
        children: [
            label && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                weight: "bold",
                size: "small",
                children: label
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                type: "file",
                multiple: true,
                onChange: onChange ? async (e)=>{
                    const files = Array.from(e.target.files || []);
                    const serializedFiles = await $0246d99e208034c4$var$serializeFiles(files);
                    await onChange(serializedFiles);
                } : undefined,
                hidden: true,
                ref: inputRef
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                ref: dropRef,
                className: (0, $hcewu.default)([
                    "_2rko12b0 _1dqogq9o _189ee4h9 _1h6d1elr _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _y3gn1h6o",
                    inDropzone ? "_1h6d1yqz _bfhkavxe" : "_1h6d1elr"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3cMgR.default), {
                    color: inDropzone ? 'color.text.selected' : 'color.text.subtlest',
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bzGVj))), {
                            label: "file-picker-icon",
                            color: inDropzone ? "var(--ds-icon-selected, #0C66E4)" : "var(--ds-icon, #44546F)"
                        }),
                        '  ',
                        "Drop files to attach or",
                        '  ',
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                            onClick: onInputTriggerClick,
                            children: "Browse"
                        })
                    ]
                })
            }),
            description && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                size: "small",
                color: "color.text.subtlest",
                children: description
            })
        ]
    });
};

});
parcelRegister("axsXh", function(module, exports) {
$parcel$export(module.exports, "getFiles", () => (parcelRequire("1HnDU")).getFiles);
$parcel$export(module.exports, "containsFiles", () => (parcelRequire("1HnDU")).containsFiles);

var $1HnDU = parcelRequire("1HnDU");

});
parcelRegister("1HnDU", function(module, exports) {
$parcel$export(module.exports, "containsFiles", () => $b73d37cb3322e979$export$ed3e218cf6ca2bc6);
$parcel$export(module.exports, "getFiles", () => $b73d37cb3322e979$export$d964e69f1fd5fd4c);
function $b73d37cb3322e979$export$ed3e218cf6ca2bc6({ source: source }) {
    return source.types.includes('Files');
}
function $b73d37cb3322e979$export$d964e69f1fd5fd4c({ source: source }) {
    return source.items// unlike other media types, for files:
    // item.kind is 'file'
    // item.type is the type of file eg 'image/jpg'
    // for other media types, item.type is the mime format
    .filter((item)=>item.kind === 'file').map((item)=>item.getAsFile()).filter((file)=>file != null);
}

});



parcelRegister("lfmiP", function(module, exports) {
$parcel$export(module.exports, "Flex", () => $0df2977e214da29b$export$f51f4c4ede09e011);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lmgo6 = parcelRequire("lmgo6");
const $0df2977e214da29b$export$bf0162d825d6e13 = {
    children: true,
    as: false,
    justifyContent: true,
    alignItems: true,
    columnGap: true,
    gap: true,
    rowGap: true,
    direction: true,
    wrap: true,
    testId: true,
    'data-testid': false,
    role: true,
    xcss: false
};
const $0df2977e214da29b$export$f51f4c4ede09e011 = (props)=>{
    const { justifyContent: justifyContent, alignItems: alignItems, columnGap: columnGap, gap: gap, rowGap: rowGap, direction: direction, wrap: wrap, testId: testId, role: role } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lmgo6.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                children: props.render(c)
            }, c.key)),
        justifyContent: justifyContent,
        alignItems: alignItems,
        columnGap: columnGap,
        gap: gap,
        rowGap: rowGap,
        direction: direction,
        wrap: wrap,
        testId: testId,
        role: role
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("6boT6", function(module, exports) {
$parcel$export(module.exports, "Form", () => $2c22fdf0b498f9f8$export$a7fed597f4b8afd8);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $2c22fdf0b498f9f8$export$a7fed597f4b8afd8 = (props)=>{
    const { onSubmit: onSubmit } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("form", {
        onSubmit: (e)=>{
            e.preventDefault();
            onSubmit();
        },
        children: props.forgeDoc.children.map(props.render)
    });
};
const $2c22fdf0b498f9f8$export$c24727297075ec6a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(null);

});

parcelRegister("2VICx", function(module, exports) {
$parcel$export(module.exports, "FormFooter", () => $9b2ffd6c95088acc$export$e7277fd05612133d);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eRpdx = parcelRequire("eRpdx");
const $9b2ffd6c95088acc$export$bf0162d825d6e13 = {
    children: true,
    /**
	 * Sets the alignment of the footer contents. This is often a button. Defaults to `end`.
	 */ align: true
};
const $9b2ffd6c95088acc$export$e7277fd05612133d = (props)=>{
    const { align: align } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eRpdx.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                children: props.render(c)
            }, c.key)),
        align: align
    });
}; /**
 * @codegenEnd
 */ 

});
parcelRegister("eRpdx", function(module, exports) {
$parcel$export(module.exports, "default", () => $6411efa125c19813$export$2e2bcd8739ae039);
/* form-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $6411efa125c19813$var$formFooterWrapperStyles = null;
const $6411efa125c19813$var$justifyContentStyles = null;
function $6411efa125c19813$export$2e2bcd8739ae039({ align: align = 'end', children: children }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("footer", {
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bahesu3 _1pfh1ejb",
            align === 'start' && "_1bah1y6m"
        ]),
        children: children
    });
}

});


parcelRegister("i14JQ", function(module, exports) {
$parcel$export(module.exports, "FormHeader", () => $86803a9d3a573329$export$97ee2cbf37e5ebfe);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5toMF = parcelRequire("5toMF");
const $86803a9d3a573329$export$bf0162d825d6e13 = {
    title: true,
    description: true,
    children: true
};
const $86803a9d3a573329$export$97ee2cbf37e5ebfe = (props)=>{
    const { title: title, description: description } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5toMF.default), {
        title: title,
        description: description,
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                children: props.render(c)
            }, c.key))
    });
}; /**
 * @codegenEnd
 */ 

});
parcelRegister("5toMF", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fdcc349995b46d5$export$2e2bcd8739ae039);
/* form-header.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-primitives */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $806LH = parcelRequire("806LH");
const $2fdcc349995b46d5$var$formHeaderContentStyles = null;
const $2fdcc349995b46d5$var$formHeaderDescriptionStyles = null;
/**
 * __Form header__.
 *
 * A form header contains the form component's heading and subheadings. This provides the correct padding
 * and styling for it.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout).
 */ const $2fdcc349995b46d5$var$FormHeader = ({ children: children, description: description, title: title })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        children: [
            title && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                size: "large",
                children: title
            }),
            description && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    "_1pfhu2gc"
                ]),
                children: description
            }),
            children && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    "_1ul91osq _1pfhu2gc"
                ]),
                children: children
            })
        ]
    });
};
var $2fdcc349995b46d5$export$2e2bcd8739ae039 = $2fdcc349995b46d5$var$FormHeader;

});


parcelRegister("expKe", function(module, exports) {
$parcel$export(module.exports, "FormSection", () => $56eb3f6080f858cc$export$b5ff61ac8b0a660f);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $bUGwX = parcelRequire("bUGwX");
const $56eb3f6080f858cc$export$bf0162d825d6e13 = {
    title: true,
    children: true,
    description: true
};
const $56eb3f6080f858cc$export$b5ff61ac8b0a660f = (props)=>{
    const { title: title, description: description } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bUGwX.default), {
        title: title,
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                children: props.render(c)
            }, c.key)),
        description: description
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("ewtb5", function(module, exports) {
$parcel$export(module.exports, "Grid", () => $989c45d945df5169$export$ef2184bd89960b14);
// Note that the prop `templateAreas` is removed as it requires child components to use `style`

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aewX5 = parcelRequire("aewX5");
const $989c45d945df5169$export$bf0162d825d6e13 = {
    children: true,
    as: false,
    justifyContent: true,
    justifyItems: true,
    alignItems: true,
    alignContent: true,
    columnGap: true,
    gap: true,
    rowGap: true,
    autoFlow: true,
    templateRows: true,
    templateColumns: true,
    templateAreas: false,
    id: true,
    testId: true,
    'data-testid': false,
    role: true,
    xcss: false
};
const $989c45d945df5169$export$ef2184bd89960b14 = (props)=>{
    const { justifyContent: justifyContent, justifyItems: justifyItems, alignItems: alignItems, alignContent: alignContent, columnGap: columnGap, gap: gap, rowGap: rowGap, autoFlow: autoFlow, templateRows: templateRows, templateColumns: templateColumns, id: id, testId: testId, role: role } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aewX5.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                children: props.render(c)
            }, c.key)),
        justifyContent: justifyContent,
        justifyItems: justifyItems,
        alignItems: alignItems,
        alignContent: alignContent,
        columnGap: columnGap,
        gap: gap,
        rowGap: rowGap,
        autoFlow: autoFlow,
        templateRows: templateRows,
        templateColumns: templateColumns,
        id: id,
        testId: testId,
        role: role
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("ef4Xa", function(module, exports) {
$parcel$export(module.exports, "Heading", () => $6f6e6157cf4dc591$export$a8a3e93435678ff9);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $806LH = parcelRequire("806LH");
const $6f6e6157cf4dc591$export$bf0162d825d6e13 = {
    size: {
        excludeFromDeconstruct: false,
        value: 'size ? size : getSize(as)',
        type: 'Sizes'
    },
    color: true,
    as: {
        excludeFromDeconstruct: false,
        value: 'onlyAllowHeadingTag(as)'
    },
    children: true,
    id: true,
    testId: true
};
const $6f6e6157cf4dc591$var$onlyAllowHeadingTag = (asProp)=>{
    if (!asProp) return undefined;
    if (asProp && [
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'div',
        'span'
    ].includes(asProp)) return asProp;
    throw Error(`${asProp} is an invalid heading tag. Please use one of h1, h2, h3, h4, h5, h6, div, span.`);
};
const $6f6e6157cf4dc591$var$getSize = (asProp)=>{
    if (!asProp) return 'xlarge';
    const sizeMap = {
        h1: 'xlarge',
        h2: 'large',
        h3: 'medium',
        h4: 'small',
        h5: 'xsmall',
        h6: 'xxsmall'
    };
    return sizeMap[asProp];
};
const $6f6e6157cf4dc591$export$a8a3e93435678ff9 = (props)=>{
    const { size: size, color: color, as: as, id: id, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
        size: size ? size : $6f6e6157cf4dc591$var$getSize(as),
        color: color,
        as: $6f6e6157cf4dc591$var$onlyAllowHeadingTag(as),
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                children: props.render(c)
            }, c.key)),
        id: id,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("cD3pl", function(module, exports) {
$parcel$export(module.exports, "HelperMessage", () => $5ef2c126fbe5561f$export$8fbe3c7d0ed2c683);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $fKXve = parcelRequire("fKXve");
const $5ef2c126fbe5561f$export$bf0162d825d6e13 = {
    children: true,
    testId: true
};
const $5ef2c126fbe5561f$export$8fbe3c7d0ed2c683 = (props)=>{
    const { testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fKXve.HelperMessage), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                children: props.render(c)
            }, c.key)),
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("1jJ11", function(module, exports) {
$parcel$export(module.exports, "Image", () => $74221ad44d2def16$export$3e431a229df88919);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1gAFw = parcelRequire("1gAFw");

var $MyJAf = parcelRequire("MyJAf");
const $74221ad44d2def16$export$baab7c95ad93ac5a = {
    xsmall: '25%',
    small: '37.5%',
    medium: '50%',
    large: '75%',
    xlarge: '100%'
};
function $74221ad44d2def16$var$ImageInner({ forgeDoc: forgeDoc }) {
    const { src: src, alt: alt, size: size = 'xlarge', width: width, height: height } = forgeDoc.props;
    const isCustomSize = width || height;
    const fixedImageSize = $74221ad44d2def16$export$baab7c95ad93ac5a[size] ? $74221ad44d2def16$export$baab7c95ad93ac5a[size] : '100%';
    const maxWidth = isCustomSize ? '100%' : fixedImageSize; // the width and height props will override the size prop
    return /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 'auto',
            maxWidth: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            maxWidth,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            textAlign: 'center'
        },
        src: src,
        alt: alt,
        width: width,
        height: height
    });
}
const $74221ad44d2def16$var$ImageWithSrcValidation = (props)=>{
    const { src: src } = props.forgeDoc.props;
    const isValidUrl = (0, $1gAFw.useIsValidImageUrl)(src);
    if (isValidUrl) return /*#__PURE__*/ (0, $gt9Am.jsx)($74221ad44d2def16$var$ImageInner, {
        ...props
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $MyJAf.EgressErrorMessage), {
        url: src
    });
};
const $74221ad44d2def16$export$3e431a229df88919 = (props)=>{
    const { src: src } = props.forgeDoc.props;
    const isAbsolutePath = src.startsWith('/');
    // If `src` is an absolute path, we can render the image immediately.
    // The resolved path will be routed to the tenant domain which is already authorised in our egress service so no validation is required.
    // This is required as Confluence endpoints tend to return absolute paths for avatar images.
    if (isAbsolutePath) return /*#__PURE__*/ (0, $gt9Am.jsx)($74221ad44d2def16$var$ImageInner, {
        ...props
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)($74221ad44d2def16$var$ImageWithSrcValidation, {
        ...props
    });
};

});

parcelRegister("96r6J", function(module, exports) {
$parcel$export(module.exports, "Inline", () => $b713b54e16ca203a$export$fbae5b5ffd8af05e);
// Grow is being excluded at the moment as it requires a Box component to have `flexGrow: 1` as a property

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3Wh6p = parcelRequire("3Wh6p");
const $b713b54e16ca203a$export$bf0162d825d6e13 = {
    children: true,
    alignBlock: true,
    alignInline: true,
    spread: true,
    grow: true,
    space: true,
    shouldWrap: true,
    separator: true,
    rowSpace: true,
    testId: true
};
const $b713b54e16ca203a$export$fbae5b5ffd8af05e = (props)=>{
    const { alignBlock: alignBlock, alignInline: alignInline, spread: spread, grow: grow, space: space, shouldWrap: shouldWrap, separator: separator, rowSpace: rowSpace, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3Wh6p.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                children: props.render(c)
            }, c.key)),
        alignBlock: alignBlock,
        alignInline: alignInline,
        spread: spread,
        grow: grow,
        space: space,
        shouldWrap: shouldWrap,
        separator: separator,
        rowSpace: rowSpace,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("3iGWx", function(module, exports) {
$parcel$export(module.exports, "InlineEdit", () => $2d830d5400f0379e$export$97bda0f90d93904c);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6FuZ5 = parcelRequire("6FuZ5");
const $2d830d5400f0379e$var$noop = ()=>{};
const $2d830d5400f0379e$export$97bda0f90d93904c = (props)=>{
    const { label: label, startWithEditViewOpen: startWithEditViewOpen = false, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur = false, hideActionButtons: hideActionButtons = false, isRequired: isRequired = false, readViewFitContainerWidth: readViewFitContainerWidth = false, editButtonLabel: editButtonLabel = 'Edit', confirmButtonLabel: confirmButtonLabel = 'Confirm', cancelButtonLabel: cancelButtonLabel = 'Cancel', defaultValue: defaultValue, isEditing: isEditing, onConfirm: providedOnConfirm = $2d830d5400f0379e$var$noop, onCancel: providedOnCancel = $2d830d5400f0379e$var$noop, onEdit: providedOnEdit = $2d830d5400f0379e$var$noop } = props.forgeDoc.props;
    const readViewForgeDoc = props.forgeDoc.children.find((child)=>{
        if (child.type === 'ContentWrapper' && child.props?.name === 'readView') return child;
    });
    const editViewForgeDoc = props.forgeDoc.children.find((child)=>{
        if (child.type === 'ContentWrapper' && child.props?.name === 'editView') return child;
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6FuZ5.default), {
        label: label,
        startWithEditViewOpen: startWithEditViewOpen,
        keepEditViewOpenOnBlur: keepEditViewOpenOnBlur,
        hideActionButtons: hideActionButtons,
        isRequired: isRequired,
        readViewFitContainerWidth: readViewFitContainerWidth,
        editButtonLabel: editButtonLabel,
        confirmButtonLabel: confirmButtonLabel,
        cancelButtonLabel: cancelButtonLabel,
        defaultValue: defaultValue,
        isEditing: isEditing,
        readView: ()=>readViewForgeDoc?.children.map(props.render),
        editView: ()=>editViewForgeDoc?.children.map(props.render),
        onConfirm: providedOnConfirm,
        onCancel: providedOnCancel,
        onEdit: providedOnEdit
    });
};

});
parcelRegister("6FuZ5", function(module, exports) {
$parcel$export(module.exports, "default", () => $62e487e87e8a09dc$export$2e2bcd8739ae039);
/* inline-edit.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $6svxr = parcelRequire("6svxr");

var $3L3Os = parcelRequire("3L3Os");

var $eGOwo = parcelRequire("eGOwo");

var $46R8N = parcelRequire("46R8N");

var $6fs4r = parcelRequire("6fs4r");

var $JpPJd = parcelRequire("JpPJd");

var $bMFcf = parcelRequire("bMFcf");

var $bVPmc = parcelRequire("bVPmc");
const $62e487e87e8a09dc$var$fieldStyles = null;
const $62e487e87e8a09dc$var$analyticsAttributes = {
    componentName: 'inlineEdit',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $62e487e87e8a09dc$var$InnerInlineEdit = (props)=>{
    const { startWithEditViewOpen: startWithEditViewOpen = false, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur = false, hideActionButtons: hideActionButtons = false, isRequired: isRequired = false, readViewFitContainerWidth: readViewFitContainerWidth = false, editButtonLabel: editButtonLabel = 'Edit', editLabel: editLabel = 'edit', confirmButtonLabel: confirmButtonLabel = 'Confirm', cancelButtonLabel: cancelButtonLabel = 'Cancel', defaultValue: defaultValue, isEditing: isEditing, label: label, validate: validate, readView: readView, editView: editView, analyticsContext: analyticsContext, onConfirm: providedOnConfirm, onCancel: providedOnCancel, onEdit: providedOnEdit, testId: testId } = props;
    const wasFocusReceivedSinceLastBlurRef = (0, $eJOHy.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const [isEditingState, setEditingState] = (0, $eJOHy.useState)(startWithEditViewOpen);
    const timerRef = (0, $eJOHy.useRef)();
    const { editButtonRef: editButtonRef, editViewRef: editViewRef, shouldBeEditing: shouldBeEditing, doNotFocusOnEditButton: doNotFocusOnEditButton } = (0, $bMFcf.default)(isEditing, isEditingState);
    const onCancel = (0, $eJOHy.useCallback)(()=>{
        if (isControlled) setEditingState(false);
        providedOnCancel?.();
    }, [
        isControlled,
        providedOnCancel
    ]);
    const onEditRequested = (0, $eJOHy.useCallback)(()=>{
        if (isControlled) setEditingState(true);
        providedOnEdit?.();
        if (shouldBeEditing && editViewRef.current) editViewRef.current.focus();
    }, [
        isControlled,
        shouldBeEditing,
        editViewRef,
        providedOnEdit
    ]);
    const onConfirm = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            if (isControlled) setEditingState(false);
            providedOnConfirm(value, analyticsEvent);
        },
        action: 'confirmed',
        analyticsData: analyticsContext,
        ...$62e487e87e8a09dc$var$analyticsAttributes
    });
    const onCancelClick = (0, $eJOHy.useCallback)((event)=>{
        event.preventDefault();
        onCancel();
    }, [
        onCancel
    ]);
    const tryAutoSubmitWhenBlur = (0, $eJOHy.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        // Ignore if the provided ref is a function. This is used to make the
        // typechecking accurate. Inline edit only uses one type of ref, so this
        // will never trigger.
        if (typeof formRef === 'function') return;
        if (!isFieldInvalid && !wasFocusReceivedSinceLastBlurRef.current && formRef.current) {
            doNotFocusOnEditButton();
            if (formRef.current.checkValidity()) onSubmit();
        }
    }, [
        doNotFocusOnEditButton
    ]); /**
                                 * If keepEditViewOpenOnBlur prop is set to false, will call confirmIfUnfocused() which
                                 *  confirms the value, if the focus is not transferred to the action buttons.
                                 *
                                 *  When you're in `editing` state, the focus will be on the input field. And if you use keyboard
                                 *  to navigate to `submit` button, this function will be invoked. Then function `onEditViewWrapperFocus`
                                 *  will be called, the timeout used here is making sure `onEditViewWrapperFocus` is always called before
                                 *  `autoSubmitWhenBlur`.
                                 *
                                 *  There are two paths here the function can be triggered:
                                 *
                                 *  - focus on input first, and then use keyboard to `submit`
                                 *  - focus on input first, and then click anywhere else on the page (outside of edit view wrapper) to `submit` (auto save).
                                 */ 
    const onEditViewWrapperBlur = (0, $eJOHy.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!keepEditViewOpenOnBlur) {
            wasFocusReceivedSinceLastBlurRef.current = false;
            timerRef.current = setTimeout(()=>tryAutoSubmitWhenBlur(isFieldInvalid, onSubmit, formRef), 0);
        }
    }, [
        keepEditViewOpenOnBlur,
        tryAutoSubmitWhenBlur
    ]); /**
                                                        * Gets called when focus is transferred to the editView, or action buttons.
                                                        *
                                                        * There are three paths here the function can be called:
                                                        *
                                                        * - when a user click the `editView`
                                                        * - when a user use keyboard to tab into `editView`
                                                        * - when a user use keyboard to tab into `submit` when they were on input field.
                                                        */ 
    const onEditViewWrapperFocus = (0, $eJOHy.useCallback)(()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
    }, []);
    const concatenatedEditButtonLabel = ()=>{
        if (label) return `${editButtonLabel}, ${label}, ${editLabel}`;
        return `${editButtonLabel}, ${editLabel}`;
    };
    const renderReadView = ()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bVPmc.default), {
            editButtonLabel: concatenatedEditButtonLabel(),
            onEditRequested: onEditRequested,
            postReadViewClick: doNotFocusOnEditButton,
            editButtonRef: editButtonRef,
            readViewFitContainerWidth: readViewFitContainerWidth,
            readView: readView,
            testId: testId
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3L3Os.default), {
        onSubmit: (data)=>onConfirm(data.inlineEdit),
        children: ({ formProps: { onKeyDown: onKeyDown, onSubmit: onSubmit, ref: formRef }, reset: reset })=>/*#__PURE__*/ (0, $gt9Am.jsx)("form", {
                /**
                 * It is not normally acceptable to add key handlers to non-interactive elements
                 * as this is an accessibility anti-pattern. However, because this instance is
                 * to add support for keyboard functionality instead of creating an inaccessible
                 * custom element, we can add role="presentation" so that there is no negative
                 * impacts to assistive technologies.
                 */ role: "presentation",
                onKeyDown: (e)=>{
                    onKeyDown(e);
                    if (e.key === 'Esc' || e.key === 'Escape') {
                        reset();
                        onCancel();
                    }
                },
                onSubmit: onSubmit,
                ref: formRef,
                // This is because due to some default focus being applied to the form element, the inline edit component
                // was being focused automatically and causing scroll issues in issue view
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: (0, $eGOwo.fg)('platform_design_system_inline_edit_dont_focus') ? 'dont-default-focus' : undefined,
                children: shouldBeEditing ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6svxr.default), {
                    name: "inlineEdit",
                    label: label,
                    defaultValue: defaultValue,
                    validate: validate,
                    isRequired: isRequired,
                    children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                            onBlur: (e)=>{
                                if (!e.currentTarget.contains(e.relatedTarget)) onEditViewWrapperBlur(fieldProps.isInvalid, onSubmit, formRef);
                            },
                            onFocus: onEditViewWrapperFocus,
                            className: (0, $hcewu.default)([
                                "_p12f1osq _kqswh2mm"
                            ]),
                            children: [
                                editView({
                                    ...fieldProps,
                                    errorMessage: error
                                }, editViewRef),
                                !hideActionButtons ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $JpPJd.default), {
                                    testId: testId,
                                    cancelButtonLabel: cancelButtonLabel,
                                    confirmButtonLabel: confirmButtonLabel,
                                    onMouseDown: ()=>{
                                        /**
             * Prevents focus on edit button only if mouse is used to click button, but not when keyboard is used
             */ doNotFocusOnEditButton();
                                    },
                                    onCancelClick: (e)=>{
                                        reset();
                                        onCancelClick(e);
                                    }
                                }) : /**
           * This is to allow Ctrl + Enter to submit without action buttons
           */ /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
                                    hidden: true,
                                    type: "submit",
                                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6fs4r.default), {
                                        children: "Submit"
                                    })
                                })
                            ]
                        })
                }, "edit-view" // used for reset to default value
                ) : /**
       * Field is used here only for the label and spacing
       */ /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6svxr.default), {
                    name: "inlineEdit",
                    label: label,
                    defaultValue: "",
                    isRequired: isRequired,
                    children: renderReadView
                }, "read-view" // used for reset to default value
                )
            })
    });
};
const $62e487e87e8a09dc$var$InlineEdit = (props)=>{
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $gt9Am.jsx)($62e487e87e8a09dc$var$InnerInlineEdit, {
        ...props
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $62e487e87e8a09dc$export$2e2bcd8739ae039 = $62e487e87e8a09dc$var$InlineEdit;

});
parcelRegister("JpPJd", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd77e55f5b6541b9$export$2e2bcd8739ae039);
/* buttons.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $Ay1uj = parcelRequire("Ay1uj");

var $6zhpo = parcelRequire("6zhpo");

var $entZ3 = parcelRequire("entZ3");

var $laG04 = parcelRequire("laG04");
const $bd77e55f5b6541b9$var$buttonsContainerStyles = null;
const $bd77e55f5b6541b9$var$buttonWrapperBaseStyles = null;
const $bd77e55f5b6541b9$var$Buttons = ({ confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        className: (0, $hcewu.default)([
            "_1e0c1txw _kqswstnw _1o9zidpf _152t1osq _rjxpidpf _1pfh12x7"
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                tabIndex: -1,
                className: (0, $hcewu.default)([
                    "_2rkofajl _11c82smr _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs1mxi _1mpy1b66 _1nlxe0lp _l2uv1d38 _7mfv1dzg _szlb1x4z"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                    type: "submit",
                    icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($entZ3))), {
                            ...iconProps,
                            LEGACY_size: "small",
                            size: "small"
                        }),
                    onMouseDown: onMouseDown,
                    label: confirmButtonLabel,
                    testId: testId && `${testId}--confirm`
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                tabIndex: -1,
                className: (0, $hcewu.default)([
                    "_2rkofajl _11c82smr _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs1mxi _1mpy1b66 _1nlxe0lp _l2uv1d38 _7mfv1dzg _szlb1x4z"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                    icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))), {
                            ...iconProps,
                            LEGACY_size: "small",
                            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($laG04))),
                            size: "small"
                        }),
                    label: cancelButtonLabel,
                    onClick: onCancelClick,
                    onMouseDown: onMouseDown,
                    testId: testId && `${testId}--cancel`
                })
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bd77e55f5b6541b9$export$2e2bcd8739ae039 = $bd77e55f5b6541b9$var$Buttons;

});

parcelRegister("bMFcf", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc8979cc798952aa$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $cc8979cc798952aa$var$usePrevious = (value)=>{
    const ref = (0, $eJOHy.useRef)();
    (0, $eJOHy.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $cc8979cc798952aa$var$useButtonFocusHook = (isEditing, isEditingState)=>{
    const editButtonRef = (0, $eJOHy.useRef)(null);
    const editViewRef = (0, $eJOHy.useRef)();
    const preventFocusOnEditButtonRef = (0, $eJOHy.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const shouldBeEditing = isControlled ? isEditingState : isEditing;
    const prevIsEditing = $cc8979cc798952aa$var$usePrevious(shouldBeEditing);
    (0, $eJOHy.useEffect)(()=>{
        if (isEditingState && editViewRef.current) editViewRef.current.focus();
    }, [
        editViewRef,
        isEditingState
    ]);
    (0, $eJOHy.useEffect)(()=>{
        /**
		 * This logic puts the focus on the edit button after confirming using
		 * the confirm button or using the keyboard to confirm, but not when
		 * it is confirmed by wrapper blur
		 */ if (prevIsEditing && !shouldBeEditing) {
            if (preventFocusOnEditButtonRef && preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
            else if (editButtonRef && editButtonRef.current) // @ts-ignore
            editButtonRef.current.focus();
        }
    }, [
        prevIsEditing,
        shouldBeEditing
    ]);
    const doNotFocusOnEditButton = ()=>preventFocusOnEditButtonRef.current = true;
    return {
        editButtonRef: editButtonRef,
        editViewRef: editViewRef,
        shouldBeEditing: shouldBeEditing,
        doNotFocusOnEditButton: doNotFocusOnEditButton
    };
};
var $cc8979cc798952aa$export$2e2bcd8739ae039 = $cc8979cc798952aa$var$useButtonFocusHook;

});

parcelRegister("bVPmc", function(module, exports) {
$parcel$export(module.exports, "default", () => $63c6797058a2257d$export$2e2bcd8739ae039);
/* read-view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $46R8N = parcelRequire("46R8N");
const $63c6797058a2257d$var$readViewContainerStyles = null;
const $63c6797058a2257d$var$editButtonStyles = {
    root: "_12ji1r31 _1qu2glyw _12y3idpf _189eidpf _1dqoglyw _1h6d3acm _1e0c1ule _1pfhze3t _12l2ze3t _6rthze3t _ahbqze3t _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _r06hglyw _bfhk18uv _vwz4kb7n _1xp41p6i _14lydkaa _1j8znqa1 _mizu1r31 _ra3xglyw _128midpf"
};
const $63c6797058a2257d$var$readViewWrapperStyles = null;
const $63c6797058a2257d$var$readViewFitContainerWidthStyles = null;
const $63c6797058a2257d$var$DRAG_THRESHOLD = 5;
const $63c6797058a2257d$var$ReadView = ({ editButtonLabel: editButtonLabel, onEditRequested: onEditRequested, postReadViewClick: postReadViewClick, editButtonRef: editButtonRef, readViewFitContainerWidth: readViewFitContainerWidth, readView: readView, testId: testId })=>{
    const startX = (0, $eJOHy.useRef)(0);
    const startY = (0, $eJOHy.useRef)(0);
    const mouseHasMovedAfterMouseDown = (event)=>{
        return Math.abs(startX.current - event.clientX) >= $63c6797058a2257d$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $63c6797058a2257d$var$DRAG_THRESHOLD;
    };
    const onReadViewClick = (event)=>{
        const element = event.target;
        /**
     * If a link is clicked in the read view, default action should be taken
     */ if (element.tagName.toLowerCase() !== 'a' && !mouseHasMovedAfterMouseDown(event)) {
            event.preventDefault();
            onEditRequested();
            postReadViewClick();
        }
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        className: (0, $hcewu.default)([
            "_vwz4kb7n"
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
                xcss: $63c6797058a2257d$var$editButtonStyles.root,
                onClick: onEditRequested,
                ref: editButtonRef,
                testId: testId && `${testId}--edit-button`,
                "aria-label": editButtonLabel
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                /**
     * It is not normally acceptable to add click handlers to non-interactive elements
     * as this is an accessibility anti-pattern. However, because this instance is
     * account for clicking on links that may be embedded within inline-edit and not
     * creating an inaccessible custom element, we can add role="presentation" so that
     * there is no negative impacts to assistive technologies.
     * (Why links are embeeded in inline-edit is for another day...)
     */ role: "presentation",
                onClick: onReadViewClick,
                onMouseDown: (e)=>{
                    startX.current = e.clientX;
                    startY.current = e.clientY;
                },
                "data-read-view-fit-container-width": readViewFitContainerWidth,
                className: (0, $hcewu.default)([
                    "_2rkofajl _v564thzt _1h6d3acm _1dqonqa1 _189e1dm9 _1e0c1o8l _vchhusvi _1bsb1wug _p12f1osq _irr314ae",
                    readViewFitContainerWidth && "_1bsb1osq"
                ]),
                children: readView()
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$63c6797058a2257d$export$2e2bcd8739ae039 = $63c6797058a2257d$var$ReadView;

});



parcelRegister("gzuLh", function(module, exports) {
$parcel$export(module.exports, "Label", () => $6c46c23c34a8e192$export$b04be29aa201d4f5);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $cDJ0f = parcelRequire("cDJ0f");
const $6c46c23c34a8e192$export$bf0162d825d6e13 = {
    /**
	 * Content of the label.
	 */ children: true,
    /**
	 * The unique identifier to match the label to the field component `id`.
	 */ htmlFor: {
        value: 'labelFor',
        excludeFromDeconstruct: true,
        comment: 'labelFor as prop name to remove reference to HTML'
    },
    /**
	 * The unique identifier for the label.
	 */ id: true,
    testId: true
};
const $6c46c23c34a8e192$export$b04be29aa201d4f5 = (props)=>{
    const { id: id, testId: testId, labelFor: labelFor } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cDJ0f.Label), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                children: props.render(c)
            }, c.key)),
        // labelFor as prop name to remove reference to HTML
        htmlFor: labelFor,
        id: id,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("jePLG", function(module, exports) {
$parcel$export(module.exports, "Link", () => $4c791fc40e8b20d1$export$a6c7ac8248d6e38a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kpjEk = parcelRequire("kpjEk");

var $asA27 = parcelRequire("asA27");

var $aWpPf = parcelRequire("aWpPf");
const $4c791fc40e8b20d1$export$a6c7ac8248d6e38a = (props)=>{
    const { egress: egress, properties: properties } = (0, $eJOHy.useContext)((0, $kpjEk.RendererContext));
    const { forgeDoc: forgeDoc, render: render } = props;
    const { href: href, openNewTab: openNewTab } = forgeDoc.props;
    const extension = {
        egress: egress,
        properties: properties
    };
    const { onNavigate: onNavigate, getModalJsx: getModalJsx } = (0, $asA27.useNavigation)({
        extension: extension
    });
    const santizedUrl = (0, $aWpPf.sanitizeUrl)(href);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
        children: [
            getModalJsx(),
            /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
                target: openNewTab ? '_blank' : undefined,
                href: santizedUrl,
                onClick: (e)=>{
                    // stop the usual navigation event from anchor tags
                    e.preventDefault();
                    onNavigate({
                        type: openNewTab ? 'new-tab' : 'same-tab',
                        url: santizedUrl
                    });
                },
                rel: "noopener noreferrer",
                children: forgeDoc.children.map(render)
            })
        ]
    });
};

});

parcelRegister("4N3qz", function(module, exports) {
$parcel$export(module.exports, "LinkButton", () => $beb8fb3ee6244e6d$export$29d11c0fe2fc51d8);
/* link-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $5bY40 = parcelRequire("5bY40");

var $aWpPf = parcelRequire("aWpPf");

var $8AppO = parcelRequire("8AppO");
var $cK1L3 = parcelRequire("cK1L3");

var $215So = parcelRequire("215So");

var $eGOwo = parcelRequire("eGOwo");

var $kpjEk = parcelRequire("kpjEk");

var $asA27 = parcelRequire("asA27");
const $beb8fb3ee6244e6d$var$defaultStyle = null;
const $beb8fb3ee6244e6d$var$primaryStyle = null;
const $beb8fb3ee6244e6d$var$warningStyle = null;
const $beb8fb3ee6244e6d$var$dangerStyle = null;
const $beb8fb3ee6244e6d$var$discoveryStyle = null;
const $beb8fb3ee6244e6d$var$subtleStyle = null;
/**
 * Mapping the deprecated 'link' and 'subtle-link' appearances to 'subtle'
 */ const $beb8fb3ee6244e6d$var$mapDeprecatedAppearances = (appearance)=>appearance === 'link' || appearance === 'subtle-link' ? 'subtle' : appearance;
/**
 * Mapping the deprecated 'none' spacing to 'compact'
 */ const $beb8fb3ee6244e6d$var$mapDeprecatedSpacing = (spacing)=>spacing === 'none' ? 'compact' : spacing;
const $beb8fb3ee6244e6d$var$BaseLinkButton = (props)=>{
    const { target: target, href: href, autoFocus: autoFocus, isDisabled: isDisabled, isSelected: isSelected, onBlur: onBlur, onClick: onClick, onFocus: onFocus, spacing: spacing, testId: testId, shouldFitContainer: shouldFitContainer, appearance: appearance } = props.forgeDoc.props;
    const { egress: egress, properties: properties } = (0, $eJOHy.useContext)((0, $kpjEk.RendererContext));
    const extension = {
        egress: egress,
        properties: properties
    };
    const { onNavigate: onNavigate, getModalJsx: getModalJsx } = (0, $asA27.useNavigation)({
        extension: extension
    });
    const openNewTab = target === '_blank';
    const santizedUrl = (0, $aWpPf.sanitizeUrl)(href);
    const onClickWithSafeNavigation = (event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        if (href) onNavigate({
            type: openNewTab ? 'new-tab' : 'same-tab',
            url: santizedUrl
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
        children: [
            (0, $eGOwo.fg)('forge-ui-link-button-safe-navigation') ? getModalJsx() : null,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5bY40.default), {
                target: target,
                // safety measure
                href: santizedUrl,
                // safety measure
                rel: 'noopener noreferrer',
                children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                        children: props.render(c)
                    }, c.key)),
                autoFocus: autoFocus,
                isDisabled: isDisabled,
                isSelected: isSelected,
                onBlur: (0, $8AppO.adaptEventHandler)(onBlur),
                onClick: (e, ...args)=>{
                    // stop the default navigation behaviour from anchor tags
                    if ((0, $eGOwo.fg)('forge-ui-link-button-safe-navigation')) {
                        e.preventDefault();
                        (0, $8AppO.adaptEventHandler)?.(onClickWithSafeNavigation)?.(e, ...args);
                    } else (0, $8AppO.adaptEventHandler)?.(onClick)?.(e, ...args);
                },
                onFocus: (0, $8AppO.adaptEventHandler)(onFocus),
                spacing: $beb8fb3ee6244e6d$var$mapDeprecatedSpacing(spacing),
                testId: testId,
                shouldFitContainer: shouldFitContainer,
                appearance: $beb8fb3ee6244e6d$var$mapDeprecatedAppearances(appearance)
            })
        ]
    });
};
const $beb8fb3ee6244e6d$var$BaseLinkButtonWithAnalytics = (props)=>{
    const { target: target, href: href, autoFocus: autoFocus, isDisabled: isDisabled, isSelected: isSelected, onBlur: onBlur, onClick: onClick, onFocus: onFocus, spacing: spacing, testId: testId, shouldFitContainer: shouldFitContainer, appearance: appearance } = props.forgeDoc.props;
    const adaptEventHandler = (0, $cK1L3.useAdaptEventHandler)();
    const { egress: egress, properties: properties } = (0, $eJOHy.useContext)((0, $kpjEk.RendererContext));
    const extension = {
        egress: egress,
        properties: properties
    };
    const { onNavigate: onNavigate, getModalJsx: getModalJsx } = (0, $asA27.useNavigation)({
        extension: extension
    });
    const openNewTab = target === '_blank';
    const santizedUrl = (0, $aWpPf.sanitizeUrl)(href);
    const onClickWithSafeNavigation = (event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        if (href) onNavigate({
            type: openNewTab ? 'new-tab' : 'same-tab',
            url: santizedUrl
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
        children: [
            (0, $eGOwo.fg)('forge-ui-link-button-safe-navigation') ? getModalJsx() : null,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5bY40.default), {
                target: target,
                // safety measure
                href: santizedUrl,
                // safety measure
                rel: 'noopener noreferrer',
                children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                        children: props.render(c)
                    }, c.key)),
                autoFocus: autoFocus,
                isDisabled: isDisabled,
                isSelected: isSelected,
                onBlur: adaptEventHandler(onBlur),
                onClick: (e, ...args)=>{
                    // stop the default navigation behaviour from anchor tags
                    if ((0, $eGOwo.fg)('forge-ui-link-button-safe-navigation')) {
                        e.preventDefault();
                        adaptEventHandler?.(onClickWithSafeNavigation)?.(e, ...args);
                    } else adaptEventHandler?.(onClick)?.(e, ...args);
                },
                onFocus: adaptEventHandler(onFocus),
                spacing: $beb8fb3ee6244e6d$var$mapDeprecatedSpacing(spacing),
                testId: testId,
                shouldFitContainer: shouldFitContainer,
                appearance: $beb8fb3ee6244e6d$var$mapDeprecatedAppearances(appearance)
            })
        ]
    });
};
const $beb8fb3ee6244e6d$var$Component = (props)=>{
    if ((0, $eGOwo.fg)('forge-ui-performance-analytics-provider')) return /*#__PURE__*/ (0, $gt9Am.jsx)($beb8fb3ee6244e6d$var$BaseLinkButtonWithAnalytics, {
        ...props
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)($beb8fb3ee6244e6d$var$BaseLinkButton, {
        ...props
    });
};
const $beb8fb3ee6244e6d$export$29d11c0fe2fc51d8 = (props)=>{
    const isBylineItem = (0, $215So.useIsBylineItem)();
    const { appearance: appearance } = props.forgeDoc.props;
    // This overrides global anchor tag styling that affects link button in byline content apps
    return isBylineItem ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            appearance === undefined && "_1tjq10s3",
            appearance === 'primary' && "_1tjq15cr",
            appearance === 'warning' && "_1tjqal3n",
            appearance === 'danger' && "_1tjq15cr",
            appearance === 'discovery' && "_1tjq15cr",
            appearance === 'subtle' && "_1tjq10s3"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($beb8fb3ee6244e6d$var$Component, {
            ...props
        })
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)($beb8fb3ee6244e6d$var$Component, {
        ...props
    });
};

});
parcelRegister("215So", function(module, exports) {
$parcel$export(module.exports, "useIsMacro", () => $e3f9f4f6acda7009$export$aabfca967ce25e7e);
$parcel$export(module.exports, "useIsBylineItem", () => $e3f9f4f6acda7009$export$30f7d67d7263f4a6);

var $eJOHy = parcelRequire("eJOHy");

var $kpjEk = parcelRequire("kpjEk");
const $e3f9f4f6acda7009$export$aabfca967ce25e7e = ()=>{
    const { extensionType: extensionType } = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $kpjEk.RendererContext));
    return extensionType === 'xen:macro';
};
const $e3f9f4f6acda7009$export$30f7d67d7263f4a6 = ()=>{
    const { extensionType: extensionType } = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $kpjEk.RendererContext));
    return extensionType === 'confluence:contentBylineItem';
};

});


parcelRegister("ejoUA", function(module, exports) {
$parcel$export(module.exports, "List", () => $c199dab9af39b0e6$export$54c2e3dc7acea9f5);
/* list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $215So = parcelRequire("215So");
const $c199dab9af39b0e6$var$defaultMarginStyle = null;
const $c199dab9af39b0e6$var$styles = {
    macroMargin: "_18u01b66 _19pku2gc"
};
const $c199dab9af39b0e6$var$defaultStyle = null;
// bullet style ordering
const $c199dab9af39b0e6$var$UNORDERED_LIST_STYLES = [
    'disc',
    'circle',
    'square'
];
const $c199dab9af39b0e6$var$ORDERED_LIST_STYLES = [
    'decimal',
    'lower-alpha',
    'lower-roman'
];
const $c199dab9af39b0e6$export$54c2e3dc7acea9f5 = (props)=>{
    const { forgeDoc: forgeDoc, render: render } = props;
    const { type: type } = props.forgeDoc.props;
    const forgeDocWithData = forgeDoc;
    // initialise indentLevel to 0 and add to forgeDocWithData
    if (forgeDocWithData.data === undefined) forgeDocWithData.data = {
        indentLevel: 0
    };
    // the indentLevel is used to determine the list item style that should be rendered for that level
    const { indentLevel: indentLevel } = forgeDocWithData.data;
    const isMacro = (0, $215So.useIsMacro)();
    // set the list style according to the list type
    const listType = type === 'ordered' ? $c199dab9af39b0e6$var$ORDERED_LIST_STYLES : $c199dab9af39b0e6$var$UNORDERED_LIST_STYLES;
    // pass iterated indentLevel to child
    forgeDocWithData.children.forEach((child)=>{
        // This `if` block needs to be deprecated. `List` children should always be `ListItem`s, not another `List`
        // Using `List` as a child of `List` fails accessibility tests
        if (child.type === 'List') child.data = {
            ...child.data,
            indentLevel: indentLevel + 1
        };
        if (child.type === 'ListItem') // Iterate through children of `ListItem` to find any `List` children to pass indentLevel
        // This is to render the correct list style
        child.children.forEach((grandChild)=>{
            if (grandChild.type === 'List') grandChild.data = {
                ...child.data,
                indentLevel: indentLevel + 1
            };
        });
    });
    const listChildren = forgeDocWithData.children.map((child)=>render(child));
    // We have to use "style" here since the value for the "list-style-type" property is dynamic (based on the indentation level).
    // Compiled does not support dynamic values and @compiled/babel-plugin would not be able to transform this code.
    // See https://atlassian.design/components/eslint-plugin-ui-styling-standard/migration-guide#dynamic-styles
    const listComponent = type === 'ordered' ? /*#__PURE__*/ (0, $gt9Am.jsx)("ol", {
        style: {
            listStyleType: listType[indentLevel % listType.length]
        },
        className: (0, $hcewu.default)([
            "_vwz41ejb _xhc01b66",
            "_18u0mgjw"
        ]),
        children: listChildren
    }, forgeDocWithData.key) : /*#__PURE__*/ (0, $gt9Am.jsx)("ul", {
        style: {
            listStyleType: listType[indentLevel % listType.length]
        },
        className: (0, $hcewu.default)([
            "_vwz41ejb _xhc01b66",
            "_18u0mgjw"
        ]),
        children: listChildren
    }, forgeDocWithData.key);
    if (isMacro && indentLevel === 0) // Applying an additional margin when used in a macro extension point as the editor contains styling that causes decimal bullets to overflow and be cut off. The additional margin shifts the List component to prevent the cut off.
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: $c199dab9af39b0e6$var$styles.macroMargin,
        children: listComponent
    });
    return listComponent;
};

});

parcelRegister("8i2Q3", function(module, exports) {
$parcel$export(module.exports, "ListItem", () => $62e59d42378b640f$export$a7b06bfba60a8a78);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $62e59d42378b640f$export$a7b06bfba60a8a78 = (props)=>{
    const { forgeDoc: forgeDoc, render: render } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("li", {
        children: forgeDoc.children.map(render)
    }, forgeDoc.key);
};

});

parcelRegister("lejfd", function(module, exports) {
$parcel$export(module.exports, "LoadingButton", () => $f944a69f832cf301$export$4ec83e90d030b2f3);
/* loading-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $215So = parcelRequire("215So");

var $8AppO = parcelRequire("8AppO");
var $cK1L3 = parcelRequire("cK1L3");

var $eJOHy = parcelRequire("eJOHy");

var $cA0Y2 = parcelRequire("cA0Y2");

var $eGOwo = parcelRequire("eGOwo");
const $f944a69f832cf301$var$buttonStyle = null;
const $f944a69f832cf301$var$OldLoadingButton = (props)=>{
    const { appearance: appearance, autoFocus: autoFocus, isDisabled: isDisabled, isSelected: isSelected, onBlur: onBlur, onClick: onClick, onFocus: onFocus, spacing: spacing, testId: testId, shouldFitContainer: shouldFitContainer, type: type, isLoading: isLoading } = props.forgeDoc.props;
    const isMacro = (0, $215So.useIsMacro)();
    const isBylineItem = (0, $215So.useIsBylineItem)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            (isMacro || isBylineItem) && "_11c82smr"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cA0Y2.default), {
            children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                    children: props.render(c)
                }, c.key)),
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onBlur: (0, $8AppO.adaptEventHandler)(onBlur),
            onClick: (0, $8AppO.adaptEventHandler)(onClick),
            onFocus: (0, $8AppO.adaptEventHandler)(onFocus),
            spacing: spacing,
            testId: testId,
            shouldFitContainer: shouldFitContainer,
            type: type,
            isLoading: isLoading
        })
    });
};
const $f944a69f832cf301$var$LoadingButtonWithAnalytics = (props)=>{
    const { appearance: appearance, autoFocus: autoFocus, isDisabled: isDisabled, isSelected: isSelected, onBlur: onBlur, onClick: onClick, onFocus: onFocus, spacing: spacing, testId: testId, shouldFitContainer: shouldFitContainer, type: type, isLoading: isLoading } = props.forgeDoc.props;
    const isMacro = (0, $215So.useIsMacro)();
    const isBylineItem = (0, $215So.useIsBylineItem)();
    const adaptEventHandler = (0, $cK1L3.useAdaptEventHandler)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            (isMacro || isBylineItem) && "_11c82smr"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cA0Y2.default), {
            children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                    children: props.render(c)
                }, c.key)),
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onBlur: adaptEventHandler(onBlur),
            onClick: adaptEventHandler(onClick),
            onFocus: adaptEventHandler(onFocus),
            spacing: spacing,
            testId: testId,
            shouldFitContainer: shouldFitContainer,
            type: type,
            isLoading: isLoading
        })
    });
};
const $f944a69f832cf301$export$4ec83e90d030b2f3 = (props)=>{
    if ((0, $eGOwo.fg)('forge-ui-performance-analytics-provider')) return /*#__PURE__*/ (0, $gt9Am.jsx)($f944a69f832cf301$var$LoadingButtonWithAnalytics, {
        ...props
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)($f944a69f832cf301$var$OldLoadingButton, {
        ...props
    });
};

});

parcelRegister("d5oRz", function(module, exports) {
$parcel$export(module.exports, "Lozenge", () => $86ea509ca925bc8c$export$a31cbe1bf5463979);

var $gt9Am = parcelRequire("gt9Am");

var $6AaeA = parcelRequire("6AaeA");
parcelRequire("eJOHy");

var $jdqdp = parcelRequire("jdqdp");
const $86ea509ca925bc8c$export$bf0162d825d6e13 = {
    appearance: true,
    children: {
        value: 'getTextFromForgeDocChildren(props.forgeDoc)',
        comment: 'Lozenge should only accept plain text as children'
    },
    isBold: true,
    maxWidth: true,
    testId: true
};
const $86ea509ca925bc8c$export$a31cbe1bf5463979 = (props)=>{
    const { appearance: appearance, isBold: isBold, maxWidth: maxWidth, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
        appearance: appearance,
        // Lozenge should only accept plain text as children
        children: (0, $6AaeA.getTextFromForgeDocChildren)(props.forgeDoc),
        isBold: isBold,
        maxWidth: maxWidth,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("lArQs", function(module, exports) {
$parcel$export(module.exports, "Modal", () => $eba679078a17b7a9$export$2b77a92f1a5ad772);

var $gt9Am = parcelRequire("gt9Am");

var $8AppO = parcelRequire("8AppO");

var $eJOHy = parcelRequire("eJOHy");

var $gHHv2 = parcelRequire("gHHv2");
const $eba679078a17b7a9$export$bf0162d825d6e13 = {
    autoFocus: true,
    children: true,
    height: true,
    width: true,
    onClose: {
        value: 'adaptEventHandler(onClose) as OnCloseHandler'
    },
    onCloseComplete: false,
    onOpenComplete: false,
    onStackChange: false,
    shouldScrollInViewport: true,
    shouldCloseOnOverlayClick: false,
    shouldCloseOnEscapePress: false,
    shouldReturnFocus: false,
    isBlanketHidden: false,
    stackIndex: false,
    label: true,
    testId: true
};
const $eba679078a17b7a9$export$2b77a92f1a5ad772 = (props)=>{
    const { autoFocus: autoFocus, height: height, width: width, onClose: onClose, shouldScrollInViewport: shouldScrollInViewport, label: label, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gHHv2.default), {
        autoFocus: autoFocus,
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                children: props.render(c)
            }, c.key)),
        height: height,
        width: width,
        onClose: (0, $8AppO.adaptEventHandler)(onClose),
        shouldScrollInViewport: shouldScrollInViewport,
        label: label,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("c9GiM", function(module, exports) {
$parcel$export(module.exports, "ModalBody", () => $8fd844caa4ea2c42$export$cb540d8b0ef7906c);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ik0CA = parcelRequire("ik0CA");
const $8fd844caa4ea2c42$export$bf0162d825d6e13 = {
    children: true,
    testId: true
};
const $8fd844caa4ea2c42$export$cb540d8b0ef7906c = (props)=>{
    const { testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ik0CA.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                children: props.render(c)
            }, c.key)),
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("bTGrp", function(module, exports) {
$parcel$export(module.exports, "ModalFooter", () => $e1365ab62f90dce4$export$519437715052e656);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kseeK = parcelRequire("kseeK");
const $e1365ab62f90dce4$export$bf0162d825d6e13 = {
    children: true,
    testId: true
};
const $e1365ab62f90dce4$export$519437715052e656 = (props)=>{
    const { testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kseeK.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                children: props.render(c)
            }, c.key)),
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("kAv0k", function(module, exports) {
$parcel$export(module.exports, "ModalHeader", () => $a6ee5182c73c2157$export$f50a68e3694789ee);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $2qG7I = parcelRequire("2qG7I");
const $a6ee5182c73c2157$export$bf0162d825d6e13 = {
    children: true,
    testId: true
};
const $a6ee5182c73c2157$export$f50a68e3694789ee = (props)=>{
    const { testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2qG7I.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                children: props.render(c)
            }, c.key)),
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("adx0N", function(module, exports) {
$parcel$export(module.exports, "ModalTitle", () => $35fe00f39dd09c5e$export$b26fae16ba5468aa);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5a9Ro = parcelRequire("5a9Ro");
const $35fe00f39dd09c5e$export$bf0162d825d6e13 = {
    appearance: true,
    children: true,
    isMultiline: true,
    testId: true
};
const $35fe00f39dd09c5e$export$b26fae16ba5468aa = (props)=>{
    const { appearance: appearance, isMultiline: isMultiline, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5a9Ro.default), {
        appearance: appearance,
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                children: props.render(c)
            }, c.key)),
        isMultiline: isMultiline,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("97FvP", function(module, exports) {
$parcel$export(module.exports, "ModalTransition", () => $404810d318321a3b$export$f0a3ab1cc2e7e9a6);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $956it = parcelRequire("956it");
const $404810d318321a3b$export$bf0162d825d6e13 = {
    children: true
};
const $404810d318321a3b$export$f0a3ab1cc2e7e9a6 = (props)=>{
    const {} = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $956it.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                children: props.render(c)
            }, c.key))
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("ir6Lo", function(module, exports) {
$parcel$export(module.exports, "Popup", () => $2653cf6e2c712c90$export$129a32eedafa97c5);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kJsb4 = parcelRequire("kJsb4");

var $8IeH1 = parcelRequire("8IeH1");

var $6qaBj = parcelRequire("6qaBj");
// This is required to keep the div width wrapped around the contents of trigger instead of the full width of the parent
const $2653cf6e2c712c90$var$styles = {
    triggerContainer: "_1e0c1o8l",
    fullWidth: "_1bsb1osq"
};
const $2653cf6e2c712c90$export$129a32eedafa97c5 = (props)=>{
    const { isOpen: isOpen, id: providedId, testId: testId, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary, shouldFlip: shouldFlip, placement: placement, fallbackPlacements: fallbackPlacements, autoFocus: autoFocus, shouldRenderToParent: shouldRenderToParent, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick, shouldFitContainer: shouldFitContainer, shouldDisableFocusLock: shouldDisableFocusLock, strategy: strategy, role: role, label: label, titleId: titleId } = props.forgeDoc.props;
    const contentForgeDoc = props.forgeDoc.children.find((child)=>{
        if (child.type === 'ContentWrapper' && child.props?.name === 'content') return child;
    });
    const triggerForgeDoc = props.forgeDoc.children.find((child)=>{
        if (child.type === 'ContentWrapper' && child.props?.name === 'trigger') return child;
    });
    // Trigger props need to be passed internally here because it contains a ref object which can't be passed in the runtime
    // The double span is a workaround to ensure the span is wrapped around the popup trigger component without it extending the width of the container when used within `Inline`. Otherwise, the popup trigger component will extend the width of the container.
    const TriggerComponent = ({ triggerProps: triggerProps, shouldFitContainer: shouldFitContainer })=>{
        // aria props removed as they fail accessibility tests when passed into a span
        const { 'aria-expanded': _expanded, 'aria-haspopup': _popup, ...restTriggerProps } = triggerProps;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            as: "span",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                as: "span",
                xcss: (0, $6qaBj.cx)($2653cf6e2c712c90$var$styles.triggerContainer, shouldFitContainer && $2653cf6e2c712c90$var$styles.fullWidth),
                ...restTriggerProps,
                children: triggerForgeDoc?.children.map(props.render)
            })
        });
    };
    /**
   * This check is necessary because of the conditional typing for PopupProps in ADS.
   * It has a union type `type PopupProps = StandardPopupProps | ShouldFitContainerPopupProps` where combined,
   * the `shouldFitContainer` prop is actually typed `(false | undefined) OR true`.
   * However, this resolves as `boolean | undefined`, which does not match the ADS typing. Therefore we need to declare two versions -
   * where `shouldFitContainer` is explicitly true (to match `ShouldFitContainerPopupProps`), and false (to match StandardPopupProps).
   */ if (shouldFitContainer) return(// eslint-disable-next-line @atlaskit/design-system/use-should-render-to-parent
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJsb4.default), {
        content: ()=>contentForgeDoc?.children.map(props.render),
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        id: providedId,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldFitContainer: shouldFitContainer,
        shouldRenderToParent: shouldRenderToParent ? shouldRenderToParent : undefined,
        strategy: strategy ? 'absolute' : undefined,
        shouldDisableFocusLock: shouldDisableFocusLock,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)(TriggerComponent, {
                triggerProps: triggerProps,
                shouldFitContainer: true
            }),
        role: role,
        label: label,
        titleId: titleId
    }));
    return(// eslint-disable-next-line @atlaskit/design-system/use-should-render-to-parent
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJsb4.default), {
        content: ()=>contentForgeDoc?.children.map(props.render),
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        id: providedId,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldRenderToParent: shouldRenderToParent,
        shouldFitContainer: shouldFitContainer,
        shouldDisableFocusLock: shouldDisableFocusLock,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)(TriggerComponent, {
                triggerProps: triggerProps
            }),
        strategy: strategy,
        role: role,
        label: label,
        titleId: titleId
    }));
};

});

parcelRegister("9p7FN", function(module, exports) {
$parcel$export(module.exports, "Pressable", () => $bb29d91bd6cc05e5$export$27c701ed9e449e99);
// The below lint rules are disabled because Pressable relies on building styles at runtime from in Forge apps
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766 */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766 */ 
var $gt9Am = parcelRequire("gt9Am");

var $8AppO = parcelRequire("8AppO");
var $cK1L3 = parcelRequire("cK1L3");

var $2kA5E = parcelRequire("2kA5E");

var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");
const $bb29d91bd6cc05e5$var$OldPressable = (props)=>{
    const { backgroundColor: backgroundColor, isDisabled: isDisabled, onClick: onClick, padding: padding, paddingBlock: paddingBlock, paddingBlockEnd: paddingBlockEnd, paddingBlockStart: paddingBlockStart, paddingInline: paddingInline, paddingInlineEnd: paddingInlineEnd, paddingInlineStart: paddingInlineStart, testId: testId, xcss: xcss } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bQP4O.default), {
        backgroundColor: backgroundColor,
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                children: props.render(c)
            }, c.key)),
        isDisabled: isDisabled,
        onClick: (0, $8AppO.adaptEventHandler)(onClick),
        padding: padding,
        paddingBlock: paddingBlock,
        paddingBlockEnd: paddingBlockEnd,
        paddingBlockStart: paddingBlockStart,
        paddingInline: paddingInline,
        paddingInlineEnd: paddingInlineEnd,
        paddingInlineStart: paddingInlineStart,
        testId: testId,
        xcss: xcss && (0, $1DXK0.xcss)((0, $2kA5E.xcssValidator)(xcss))
    });
};
const $bb29d91bd6cc05e5$var$PressableWithAnalytics = (props)=>{
    const { backgroundColor: backgroundColor, isDisabled: isDisabled, onClick: onClick, padding: padding, paddingBlock: paddingBlock, paddingBlockEnd: paddingBlockEnd, paddingBlockStart: paddingBlockStart, paddingInline: paddingInline, paddingInlineEnd: paddingInlineEnd, paddingInlineStart: paddingInlineStart, testId: testId, xcss: xcss } = props.forgeDoc.props;
    const adaptEventHandler = (0, $cK1L3.useAdaptEventHandler)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bQP4O.default), {
        backgroundColor: backgroundColor,
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                children: props.render(c)
            }, c.key)),
        isDisabled: isDisabled,
        onClick: adaptEventHandler(onClick),
        padding: padding,
        paddingBlock: paddingBlock,
        paddingBlockEnd: paddingBlockEnd,
        paddingBlockStart: paddingBlockStart,
        paddingInline: paddingInline,
        paddingInlineEnd: paddingInlineEnd,
        paddingInlineStart: paddingInlineStart,
        testId: testId,
        xcss: xcss && (0, $1DXK0.xcss)((0, $2kA5E.xcssValidator)(xcss))
    });
};
const $bb29d91bd6cc05e5$export$27c701ed9e449e99 = (props)=>{
    if ((0, $eGOwo.fg)('forge-ui-performance-analytics-provider')) return /*#__PURE__*/ (0, $gt9Am.jsx)($bb29d91bd6cc05e5$var$PressableWithAnalytics, {
        ...props
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)($bb29d91bd6cc05e5$var$OldPressable, {
        ...props
    });
};

});

parcelRegister("a71Pf", function(module, exports) {
$parcel$export(module.exports, "ProgressBar", () => $ae82136f79e130f7$export$c17561cb55d4db30);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $c9qWp = parcelRequire("c9qWp");
const $ae82136f79e130f7$export$bf0162d825d6e13 = {
    appearance: true,
    ariaLabel: true,
    isIndeterminate: true,
    testId: true,
    value: true
};
const $ae82136f79e130f7$export$c17561cb55d4db30 = (props)=>{
    const { appearance: appearance, ariaLabel: ariaLabel, isIndeterminate: isIndeterminate, testId: testId, value: value } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c9qWp.default), {
        appearance: appearance,
        ariaLabel: ariaLabel,
        isIndeterminate: isIndeterminate,
        testId: testId,
        value: value
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("f1JOx", function(module, exports) {
$parcel$export(module.exports, "ProgressTracker", () => $47e9c50ed408f0de$export$50a55323bc54fb79);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $aRF1Q = parcelRequire("aRF1Q");
const $47e9c50ed408f0de$export$bf0162d825d6e13 = {
    animated: true,
    items: {
        value: 'filterItems(items)'
    },
    label: true,
    spacing: true,
    testId: true
};
// Filters out href from items. @forge/bridge router must be used in onClick for in app navigation
const $47e9c50ed408f0de$var$filterItems = (items)=>{
    return items.map((item)=>{
        // removes href and noLink props
        const { href: href, noLink: noLink, ...rest } = item;
        return {
            ...rest,
            noLink: !rest.onClick
        };
    });
};
const $47e9c50ed408f0de$export$50a55323bc54fb79 = (props)=>{
    const { animated: animated, items: items, label: label, spacing: spacing, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aRF1Q.default), {
        animated: animated,
        items: $47e9c50ed408f0de$var$filterItems(items),
        label: label,
        spacing: spacing,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});
parcelRegister("aRF1Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $673a88fb7ded6f73$export$2e2bcd8739ae039);
/* progress-tracker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dn13J = parcelRequire("dn13J");

var $bWzAa = parcelRequire("bWzAa");
const $673a88fb7ded6f73$var$containerStyles = null;
const $673a88fb7ded6f73$var$spacingOptions = {
    comfortable: "var(--ds-space-500, 40px)",
    cozy: "var(--ds-space-200, 16px)",
    // @deprecated left for backwards compatibility
    cosy: "var(--ds-space-200, 16px)",
    compact: "var(--ds-space-050, 4px)"
};
/**
 * __Progress tracker__
 *
 * A progress tracker displays the steps and progress through a journey.
 *
 * - [Examples](https://atlassian.design/components/progress-tracker/examples)
 * - [Code](https://atlassian.design/components/progress-tracker/code)
 * - [Usage](https://atlassian.design/components/progress-tracker/usage)
 */ const $673a88fb7ded6f73$var$ProgressTracker = ({ items: items = [], spacing: spacing = 'cozy', render: render = {
    link: ({ item: item })=>// Anchor content is coming from another location
        // eslint-disable-next-line @atlassian/a11y/anchor-has-content
        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dn13J.default), {
            ...item
        })
}, animated: animated = true, testId: testId, label: label = 'Progress' })=>{
    const prevItems = (0, $eJOHy.useRef)(items.map((stage)=>({
            ...stage,
            percentageComplete: 0
        })));
    const previousStages = items.map((stage)=>{
        const oldStage = prevItems.current?.find((st)=>st.id === stage.id);
        return !!oldStage ? oldStage : stage;
    });
    (0, $eJOHy.useEffect)(()=>{
        prevItems.current = items;
    }, [
        items
    ]);
    const progressChanges = items.filter((stage, index)=>stage.percentageComplete !== previousStages[index].percentageComplete).length;
    const totalStepsForward = items.filter((stage, index)=>stage.percentageComplete > previousStages[index].percentageComplete).length;
    const totalStepsBack = items.filter((stage, index)=>stage.percentageComplete < previousStages[index].percentageComplete).length;
    let stepsForward = totalStepsForward;
    let stepsBack = totalStepsBack;
    const progressItems = items.map((stage, index)=>{
        let transitionSpeed = 0;
        let transitionDelay = 0;
        const transitionEasing = progressChanges > 1 ? 'linear' : 'cubic-bezier(0.15,1,0.3,1)';
        if (animated) {
            transitionSpeed = progressChanges > 1 ? 50 : 300;
            if (stage.percentageComplete < previousStages[index].percentageComplete) {
                /**
         * Load each transition sequentially in reverse.
         */ transitionDelay = (stepsBack - 1) * transitionSpeed;
                stepsBack -= 1;
            } else if (stage.percentageComplete > previousStages[index].percentageComplete) {
                /**
         * Load each transition sequentially.
         */ transitionDelay = (totalStepsForward - stepsForward) * transitionSpeed;
                stepsForward -= 1;
            }
        }
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bWzAa.default), {
            transitionSpeed: transitionSpeed,
            transitionDelay: transitionDelay,
            transitionEasing: transitionEasing,
            item: stage,
            render: render
        }, stage.id);
    });
    const listInlineStyles = {
        gridTemplateColumns: `repeat(${items.length}, 1fr)`,
        ['--ds--pt--sp']: $673a88fb7ded6f73$var$spacingOptions[spacing],
        maxWidth: 80 * items.length * 2
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)("ol", {
        "data-testid": testId,
        style: listInlineStyles,
        "aria-label": label,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _zulp6odm _1e0c11p5 _1bsb1osq _2mzuglyw _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _rxvc1jfw"
        ]),
        children: progressItems
    });
};
var $673a88fb7ded6f73$export$2e2bcd8739ae039 = $673a88fb7ded6f73$var$ProgressTracker;

});
parcelRegister("dn13J", function(module, exports) {
$parcel$export(module.exports, "default", () => $151739357ade899d$export$2e2bcd8739ae039);
/* link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lc0OY = parcelRequire("lc0OY");
const $151739357ade899d$var$styles = {
    anchor: "_4bfu18uv _1hmsglyw _ajmmnqa1 _11c81kw7 _syaz1fxt _9oik18uv _1bnx8stv _jf4cnqa1 _30l314q2 _9h8h16c2"
};
/**
 * __Progress tracker link__
 */ const $151739357ade899d$var$Link = ({ href: href, onClick: onClick, label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lc0OY.default), {
        xcss: $151739357ade899d$var$styles.anchor,
        // TODO: We should not be rendering empty hrefs on anchors. This should be plain text or a button/pressable if `onClick` is provided.
        href: href || '',
        onClick: onClick,
        testId: testId,
        children: label
    });
};
var $151739357ade899d$export$2e2bcd8739ae039 = $151739357ade899d$var$Link;

});

parcelRegister("bWzAa", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d74f7a11b9428b4$export$2e2bcd8739ae039);
/* stage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $bmZ1f = parcelRequire("bmZ1f");

var $8IeH1 = parcelRequire("8IeH1");


var $63Z7a = parcelRequire("63Z7a");

var $358Lz = parcelRequire("358Lz");
const $2d74f7a11b9428b4$var$styles = {
    listItemContent: "_1bsb1osq _kqswh2mm"
};
const $2d74f7a11b9428b4$var$textColor = {
    unvisited: "_syaz131l",
    current: "_syaz1e6v",
    visited: "_syaz1fxt",
    disabled: "_syaz1lh4"
};
const $2d74f7a11b9428b4$var$fontWeight = {
    unvisited: "_k48pi7a9",
    current: "_k48pmoej",
    visited: "_k48pmoej",
    disabled: "_k48pmoej"
};
const $2d74f7a11b9428b4$var$getMarkerColor = ({ status: status, percentageCompleted: percentageCompleted })=>{
    switch(status){
        case 'unvisited':
            return `var(--ds-icon-subtle, ${0, $7bb4c1736002a04a$export$5f71e19f3a7ad9de})`;
        case 'current':
        case 'visited':
            return `var(--ds-icon-brand, ${0, $7bb4c1736002a04a$export$e62e8919cca44969})`;
        case 'disabled':
            if (percentageCompleted === 0) return `var(--ds-icon-disabled, ${0, $7bb4c1736002a04a$export$5f71e19f3a7ad9de})`;
            // If the percentage completed is greater than 0, we show the brand colour, so that the marker (circle) blends in with the progress bar.
            // Otherwise, the grey marker would be visible within the progress bar.
            return `var(--ds-icon-brand, ${0, $7bb4c1736002a04a$export$e62e8919cca44969})`;
        default:
            return;
    }
};
const $2d74f7a11b9428b4$var$listItemStyles = null;
const $2d74f7a11b9428b4$var$titleStyles = null;
class $2d74f7a11b9428b4$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    constructor(props){
        super(props), this.nodeRefMarker = /*#__PURE__*/ (0, $eJOHy.createRef)(), this.nodeRefBar = /*#__PURE__*/ (0, $eJOHy.createRef)(), this.nodeRefTitle = /*#__PURE__*/ (0, $eJOHy.createRef)(), this.onEntered = ()=>{
            this.setState({
                transitioning: false,
                oldMarkerColor: $2d74f7a11b9428b4$var$getMarkerColor({
                    status: this.props.item.status,
                    percentageCompleted: this.props.item.percentageComplete
                }),
                oldPercentageComplete: this.props.item.percentageComplete
            });
        };
        this.state = {
            transitioning: false,
            oldMarkerColor: $2d74f7a11b9428b4$var$getMarkerColor({
                status: this.props.item.status,
                percentageCompleted: this.props.item.percentageComplete
            }),
            oldPercentageComplete: 0
        };
    }
    UNSAFE_componentWillMount() {
        this.setState({
            ...this.state,
            transitioning: true
        });
    }
    UNSAFE_componentWillReceiveProps() {
        this.setState({
            ...this.state,
            transitioning: true
        });
    }
    shouldShowLink() {
        return this.props.item.status === 'visited' && // TODO: `noLink` is unnecessary as we should just be detecting if the `href` is set...
        !this.props.item.noLink;
    }
    render() {
        const { item: item, render: render, transitionDelay: transitionDelay, transitionSpeed: transitionSpeed, transitionEasing: transitionEasing, testId: testId } = this.props;
        const ariaCurrent = item.status === 'current' ? 'step' : 'false';
        const listInlineStyles = {
            ['--ds--pt--ts']: `${transitionSpeed}ms`,
            ['--ds--pt--td']: `${transitionDelay}ms`,
            ['--ds--pt--te']: transitionEasing,
            ['--ds--pt--mc']: this.state.oldMarkerColor,
            ['--ds--pt--bg']: $2d74f7a11b9428b4$var$getMarkerColor({
                status: item.status,
                percentageCompleted: item.percentageComplete
            }),
            listStyleType: 'none'
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)("li", {
            "data-testid": testId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: listInlineStyles,
            "aria-current": ariaCurrent,
            className: (0, $hcewu.default)([
                "_6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _1i4q1hna"
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
                xcss: $2d74f7a11b9428b4$var$styles.listItemContent,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bmZ1f.default), {
                        appear: true,
                        in: this.state.transitioning,
                        onEntered: this.onEntered,
                        timeout: transitionDelay + transitionSpeed,
                        classNames: "fade",
                        nodeRef: this.nodeRefMarker,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $358Lz.default), {
                            testId: testId && `${testId}-marker`
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bmZ1f.default), {
                        appear: true,
                        in: this.state.transitioning,
                        onEntered: this.onEntered,
                        timeout: transitionDelay + transitionSpeed,
                        classNames: "fade",
                        nodeRef: this.nodeRefBar,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $63Z7a.default), {
                            testId: testId && `${testId}-bar`,
                            percentageComplete: item.percentageComplete
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bmZ1f.default), {
                        appear: true,
                        in: this.state.transitioning,
                        onEntered: this.onEntered,
                        timeout: transitionDelay + transitionSpeed,
                        classNames: "fade",
                        nodeRef: this.nodeRefTitle,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            "data-testid": testId && `${testId}-title`,
                            className: (0, $hcewu.default)([
                                "_11c82smr _v564ph28 _1pfhv47k _y3gn1h6o _1t9yph28 _1ez2kb7n _1uuw17dr",
                                $2d74f7a11b9428b4$var$textColor[item.status],
                                $2d74f7a11b9428b4$var$fontWeight[item.status]
                            ]),
                            children: this.shouldShowLink() ? render.link({
                                item: item
                            }) : item.label
                        })
                    })
                ]
            })
        });
    }
}

});
parcelRegister("63Z7a", function(module, exports) {
$parcel$export(module.exports, "default", () => $52eaafb58d2c0228$export$2e2bcd8739ae039);
/* bar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $52eaafb58d2c0228$var$spacing = {
    comfortable: "var(--ds-space-500, 40px)",
    cosy: "var(--ds-space-200, 16px)",
    compact: "var(--ds-space-050, 4px)"
};
const $52eaafb58d2c0228$var$progressBarStyles = null;
/**
 * __Progress bar__
 *
 * A progress bar describes the horizontal tracking bar that traverses each individual step.
 *
 */ const $52eaafb58d2c0228$var$ProgressBar = ({ percentageComplete: percentageComplete, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        style: {
            width: `calc(${percentageComplete}% + ${percentageComplete / 100} * calc(var(--ds--pt--sp, ${$52eaafb58d2c0228$var$spacing.cosy}) + ${"var(--ds-space-050, 4px)"}))`
        },
        className: (0, $hcewu.default)([
            "_v564d86a _4t3iu2gc _kqswstnw _bfhkq17z _1einu2gc _5fbcu2gc _1e021ssb _t9ecymk3 _1lww1oqq"
        ])
    });
var $52eaafb58d2c0228$export$2e2bcd8739ae039 = $52eaafb58d2c0228$var$ProgressBar;

});

parcelRegister("358Lz", function(module, exports) {
$parcel$export(module.exports, "default", () => $dbc8abdb1ba13d3d$export$2e2bcd8739ae039);
/* marker.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $dbc8abdb1ba13d3d$var$progressMarkerStyles = null;
/**
 * __Progress marker__
 *
 * Similar to `@atlaskit/progress-indicator`, a small visual circle marker
 */ const $dbc8abdb1ba13d3d$var$ProgressMarker = ({ testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_2rkou2gc _v5645rui _1bsbu2gc _4t3iu2gc _kqswstnw _bfhkr3ku _1e021ssb _t9ec157a _1lww1oqq _1uuw17dr _1ez2kb7n _1190pbrw _1ia8r3ku"
        ])
    });
var $dbc8abdb1ba13d3d$export$2e2bcd8739ae039 = $dbc8abdb1ba13d3d$var$ProgressMarker;

});




parcelRegister("6w9NU", function(module, exports) {
$parcel$export(module.exports, "Radio", () => $3f9b7c2eda5b27ce$export$d7b12c4107be0d61);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gPG64 = parcelRequire("gPG64");

var $8AppO = parcelRequire("8AppO");
const $3f9b7c2eda5b27ce$export$bf0162d825d6e13 = {
    label: true,
    testId: true,
    isChecked: true,
    ariaLabel: true,
    onInvalid: true
};
const $3f9b7c2eda5b27ce$export$d7b12c4107be0d61 = (props)=>{
    const { label: label, testId: testId, isChecked: isChecked, ariaLabel: ariaLabel, onInvalid: onInvalid, id: // Field props
    id, isRequired: isRequired, isDisabled: isDisabled, isInvalid: isInvalid, onChange: onChange, onBlur: onBlur, onFocus: onFocus, value: value, "aria-invalid": ariaInvalid, "aria-labelledby": ariaLabelledby, name: name } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPG64.default), {
        label: label,
        testId: testId,
        isChecked: isChecked,
        ariaLabel: ariaLabel,
        onInvalid: onInvalid,
        // Field props
        id: id,
        isRequired: isRequired,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        onChange: (0, $8AppO.adaptEventHandler)(onChange),
        onBlur: (0, $8AppO.adaptEventHandler)(onBlur),
        onFocus: (0, $8AppO.adaptEventHandler)(onFocus),
        value: value,
        "aria-invalid": ariaInvalid,
        "aria-labelledby": ariaLabelledby,
        name: name
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("befiz", function(module, exports) {
$parcel$export(module.exports, "RadioGroup", () => $8a0e9c2cfae9238b$export$a98f0dcb43a68a25);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $a6tuu = parcelRequire("a6tuu");

var $8AppO = parcelRequire("8AppO");
const $8a0e9c2cfae9238b$export$bf0162d825d6e13 = {
    defaultValue: true,
    options: true,
    onInvalid: true,
    testId: true
};
const $8a0e9c2cfae9238b$export$a98f0dcb43a68a25 = (props)=>{
    const { defaultValue: defaultValue, options: options, onInvalid: onInvalid, testId: testId, isRequired: // Field props
    isRequired, isDisabled: isDisabled, isInvalid: isInvalid, onChange: onChange, value: value, "aria-labelledby": ariaLabelledby, name: name } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $a6tuu.default), {
        defaultValue: defaultValue,
        options: options,
        onInvalid: onInvalid,
        testId: testId,
        // Field props
        isRequired: isRequired,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        onChange: (0, $8AppO.adaptEventHandler)(onChange),
        value: value,
        "aria-labelledby": ariaLabelledby,
        name: name
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("7urwA", function(module, exports) {
$parcel$export(module.exports, "Range", () => $39f91c0d838488f4$export$9a58ef0d7ad3278c);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $MevUn = parcelRequire("MevUn");

var $8AppO = parcelRequire("8AppO");
const $39f91c0d838488f4$export$bf0162d825d6e13 = {
    defaultValue: true,
    max: true,
    min: true,
    step: true,
    testId: true,
    onChange: true
};
const $39f91c0d838488f4$export$9a58ef0d7ad3278c = (props)=>{
    const { defaultValue: defaultValue, max: max, min: min, step: step, testId: testId, onChange: onChange, id: // Field props
    id, isDisabled: isDisabled, onBlur: onBlur, onFocus: onFocus, value: value, "aria-invalid": ariaInvalid, "aria-labelledby": ariaLabelledby, name: name } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $MevUn.default), {
        defaultValue: defaultValue,
        max: max,
        min: min,
        step: step,
        testId: testId,
        onChange: onChange,
        // Field props
        id: id,
        isDisabled: isDisabled,
        onBlur: (0, $8AppO.adaptEventHandler)(onBlur),
        onFocus: (0, $8AppO.adaptEventHandler)(onFocus),
        value: value,
        "aria-invalid": ariaInvalid,
        "aria-labelledby": ariaLabelledby,
        name: name
    });
}; /**
 * @codegenEnd
 */ 

});
parcelRegister("MevUn", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c0f57dfc7b1472c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3Vuhz = parcelRequire("3Vuhz");

var $dbgh6 = parcelRequire("dbgh6");
const $9c0f57dfc7b1472c$var$snapToStep = (value, min, step)=>{
    // Normalise the value to allow for division properly with different min values
    const adjustedValue = value - min;
    // Find the number of steps the value covers
    const numSteps = Math.round(adjustedValue / step);
    // Convert numSteps back into original range
    return numSteps * step + min;
};
const $9c0f57dfc7b1472c$var$getRoundedPercentValue = (value, min, max, step)=>{
    let percent = '0';
    if (min < max && value > min) {
        const snappedValue = $9c0f57dfc7b1472c$var$snapToStep(value, min, step);
        percent = ((snappedValue - min) / (max - min) * 100).toFixed(2);
    }
    return percent;
};
const $9c0f57dfc7b1472c$var$noop = (0, $3Vuhz.default);
/**
 * __Range__
 *
 * A range lets users choose an approximate value on a slider.
 *
 * - [Examples](https://atlassian.design/components/range/examples)
 * - [Code](https://atlassian.design/components/range/code)
 * - [Usage](https://atlassian.design/components/range/usage)
 */ const $9c0f57dfc7b1472c$var$Range = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function Range(props, ref) {
    const { isDisabled: isDisabled = false, defaultValue: defaultValue = 50, max: max = 100, min: min = 0, onChange: onChange = $9c0f57dfc7b1472c$var$noop, step: step = 1, value: propsValue, testId: testId, ...rest } = props;
    const spreadProps = {
        max: max,
        min: min,
        step: step,
        ref: ref,
        ...rest
    };
    const [value, setValue] = (0, $eJOHy.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const handleChange = (0, $eJOHy.useCallback)((e)=>{
        const newValue = Number(e.target.value);
        setValue(newValue);
        // Note use of newValue to ensure up=to-date value is used
        onChange(newValue);
    }, [
        onChange
    ]);
    const renderValue = propsValue !== undefined ? propsValue : value;
    const valuePercent = $9c0f57dfc7b1472c$var$getRoundedPercentValue(renderValue, min, max, step);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dbgh6.Input), {
        type: "range",
        disabled: isDisabled,
        onChange: handleChange,
        value: renderValue,
        valuePercent: valuePercent,
        "data-testid": testId,
        ...spreadProps
    });
});
var $9c0f57dfc7b1472c$export$2e2bcd8739ae039 = $9c0f57dfc7b1472c$var$Range;

});
parcelRegister("dbgh6", function(module, exports) {
$parcel$export(module.exports, "Input", () => $b65ac72e66820907$export$f5b8910cec6cf069);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $b65ac72e66820907$var$rangeHeight = 40; // Height of the range input, used for the track and thumb
const $b65ac72e66820907$var$trackHeight = 6; // Height of the track, used for the track and thumb
const $b65ac72e66820907$var$thumbSize = "var(--ds-space-200, 16px)"; // Size of the thumb, used for the thumb styles
// Styles are split up to avoid edge-cases with TS implementations between `css` and `cssMap` with some
// of these edge-case pseudo-selectors.
// Previously, in Emotion, these selectors weren't consolidated, eg. `&::webkit-thumb, &::moz-thumb`
// would not be parsed by either browser, but this may no longer be the case in Compiled
const $b65ac72e66820907$var$webkitStyles = null;
const $b65ac72e66820907$var$firefoxStyles = null;
const $b65ac72e66820907$var$baseStyles = null;
const $b65ac72e66820907$var$themeStyles = null;
const $b65ac72e66820907$var$trackStyles = {
    root: "_1bsb1osq _4t3i1ylp _kqswh2mm _14mj1qll _1ywu1ule _z0ai1y44 _1qdg1y44 _18postnw _1hfk1b6k _aetrb3bt _19nq1ssb _g0nfo1yi",
    disabled: "_1peq2wxo"
};
const $b65ac72e66820907$var$rangeA11yStyles = null;
const $b65ac72e66820907$export$f5b8910cec6cf069 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { valuePercent: valuePercent, style: style, ...strippedProps } = props;
    const input = /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
        ...strippedProps,
        style: {
            // We are creating a css variable to control the "progress" portion of the range input
            // This avoids us needing to create a new css class for each new percentage value
            '--track-fg-width': `${valuePercent}%`
        },
        ref: ref,
        className: (0, $hcewu.default)([
            "_1bsb1osq _4t3i1ylp _bfhk18uv _j5dh13gf _1j552wxo _nt751r31 _49pcglyw _1hvw1o36",
            "_wstuglyw _h2ksglyw _1kdl1qll _m8f8bpmo _1yz62hjt _1bdkusvi _u98zpxbi _1j70pxbi _1esf5udg _4w431ik2 _yfyntlke _1sdc196n _18k7v77o _1cdcglyw _10lridpf _g6tdlb4i _vi4t2hjt _1g2h1osq _168l1y44 _9u3f2hce _1g741hsc _1d8tmgnk _np53xlkz _18tdtlke _1p201osq _1yte13gf _5i7a13gf",
            "_1yq0glyw _108m1qll _1rf3bpmo _1yeu2hjt _g4ppusvi _r763pxbi _1mn5pxbi _12el5udg _1oqe1ik2 _10o7tlke _1kzev77o _15raidpf _e8hnidpf _37ywlb4i _1tcb2hjt _aoww1osq _1kd2i2wt _vt2s1w6o _1ssqtlke _ru37idpf _1gvolb4i _1nx42hjt _1f5t1osq _142y1y44 _d7w62hce _b3fmtlke _1vq313gf _1fov13gf _34m613gf",
            "_14h11kge _15dp1yrq _18lxyvsn _jxar1eo5 _ydqghkel _1jhc1eo5 _1ruc16ss _164c194a",
            "_1drq1b6k _15dp1vck _18lx1b6k _g6tdfajl _168li2wt _37ywfajl _1kd2i2wt _1sdc1lpd _ydqgmpja"
        ])
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            $b65ac72e66820907$var$trackStyles.root,
            strippedProps.disabled && $b65ac72e66820907$var$trackStyles.disabled
        ]),
        children: input
    });
});
$b65ac72e66820907$export$f5b8910cec6cf069.displayName = 'InputRange';

});



parcelRegister("3lTFF", function(module, exports) {
$parcel$export(module.exports, "RequiredAsterisk", () => $0fc869b0b75daddf$export$a4bb55a1e3b8a49f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lP4Q7 = parcelRequire("lP4Q7");
const $0fc869b0b75daddf$export$bf0162d825d6e13 = {};
const $0fc869b0b75daddf$export$a4bb55a1e3b8a49f = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lP4Q7.default), {});
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("9NmWB", function(module, exports) {
$parcel$export(module.exports, "SectionMessage", () => $1728c6887a0addd6$export$a36903bd214cec06);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $5aix7 = parcelRequire("5aix7");

var $eJOHy = parcelRequire("eJOHy");

var $iHPvF = parcelRequire("iHPvF");

var $215So = parcelRequire("215So");
const $1728c6887a0addd6$var$renderActions = (render, actions)=>Array.isArray(actions) ? actions.map((action)=>render((0, $5aix7.elementToForgeDoc)(action))) : [
        render((0, $5aix7.elementToForgeDoc)(actions))
    ];
const $1728c6887a0addd6$var$macroStyle = null;
const $1728c6887a0addd6$export$a36903bd214cec06 = (props)=>{
    const { appearance: appearance, title: title, actions: actions, testId: testId } = props.forgeDoc.props;
    const isMacro = (0, $215So.useIsMacro)();
    if (isMacro) return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            "_17b0s13h"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iHPvF.default), {
            children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                    children: props.render(c)
                }, c.key)),
            appearance: appearance,
            title: title,
            // pre-render actions before inserting as props
            actions: actions ? $1728c6887a0addd6$var$renderActions(props.render, actions) : undefined,
            testId: testId
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iHPvF.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                children: props.render(c)
            }, c.key)),
        appearance: appearance,
        title: title,
        // pre-render actions before inserting as props
        actions: actions ? $1728c6887a0addd6$var$renderActions(props.render, actions) : undefined,
        testId: testId
    });
};

});

parcelRegister("50DNI", function(module, exports) {
$parcel$export(module.exports, "SectionMessageAction", () => $2fe6e4126a21982b$export$22cf410f36f6c7c1);

var $gt9Am = parcelRequire("gt9Am");

var $aWpPf = parcelRequire("aWpPf");

var $8AppO = parcelRequire("8AppO");

var $eJOHy = parcelRequire("eJOHy");

var $akOEX = parcelRequire("akOEX");
const $2fe6e4126a21982b$export$bf0162d825d6e13 = {
    children: true,
    linkComponent: false,
    onClick: {
        value: 'adaptEventHandler(onClick)'
    },
    href: {
        value: 'href ? sanitizeUrl(href): undefined',
        comment: 'safety measure'
    },
    testId: true
};
const $2fe6e4126a21982b$export$22cf410f36f6c7c1 = (props)=>{
    const { onClick: onClick, href: href, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $akOEX.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                children: props.render(c)
            }, c.key)),
        onClick: (0, $8AppO.adaptEventHandler)(onClick),
        // safety measure
        href: href ? (0, $aWpPf.sanitizeUrl)(href) : undefined,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});
parcelRegister("akOEX", function(module, exports) {
$parcel$export(module.exports, "default", () => $6330b1bed100d78d$export$2e2bcd8739ae039);
/* section-message-action.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $6qaBj = parcelRequire("6qaBj");

var $eJ9f5 = parcelRequire("eJ9f5");

var $8IeH1 = parcelRequire("8IeH1");
var $46R8N = parcelRequire("46R8N");
const $6330b1bed100d78d$var$styles = {
    common: "_11c82smr",
    anchor: "_k48pi7a9",
    pressable: "_syaz14q2 _k48p1wq8 _bfhk18uv _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik18uv _1bnx8stv _jf4cnqa1 _30l314q2 _9h8h16c2"
};
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ const $6330b1bed100d78d$var$SectionMessageAction = /*#__PURE__*/ (0, $eJOHy.memo)(function SectionMessageAction({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent, target: target }) {
    if (!linkComponent) {
        if (href) return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            className: (0, $hcewu.default)([
                $6330b1bed100d78d$var$styles.common,
                $6330b1bed100d78d$var$styles.anchor
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ9f5.default), {
                testId: testId,
                onClick: onClick,
                href: href,
                target: target,
                children: children
            })
        });
        if (onClick) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
            testId: testId,
            onClick: onClick,
            xcss: (0, $6qaBj.cx)($6330b1bed100d78d$var$styles.common, $6330b1bed100d78d$var$styles.pressable),
            children: children
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            as: "span",
            testId: testId,
            xcss: $6330b1bed100d78d$var$styles.common,
            children: children
        });
    }
    // TODO: Remove this once the deprecated `linkComponent` prop is removed.
    return onClick || href ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined,
        children: children
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
        children: children
    });
});
var $6330b1bed100d78d$export$2e2bcd8739ae039 = $6330b1bed100d78d$var$SectionMessageAction;

});


parcelRegister("3KcxV", function(module, exports) {
$parcel$export(module.exports, "Select", () => $e25b49a318297c22$export$ef9b1a59e592288f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $c4OV1 = parcelRequire("c4OV1");

var $8AppO = parcelRequire("8AppO");

var $hmQK4 = parcelRequire("hmQK4");
const $e25b49a318297c22$export$ef9b1a59e592288f = (props)=>{
    const { spacing: spacing, appearance: appearance, testId: testId, autoFocus: autoFocus, defaultValue: defaultValue, closeMenuOnSelect: closeMenuOnSelect, inputValue: inputValue, inputId: inputId, isClearable: isClearable, isLoading: isLoading, isMulti: isMulti, isSearchable: isSearchable, menuIsOpen: menuIsOpen, openMenuOnFocus: openMenuOnFocus, onInputChange: onInputChange, options: options, placeholder: placeholder, onChange: onChange, isRequired: isRequired, id: // Field props
    id, isDisabled: isDisabled, isInvalid: isInvalid, onBlur: onBlur, onFocus: onFocus, value: value, name: name } = props.forgeDoc.props;
    return(// Portal is required to render the menu as a sibling of the select container so that it appears ontop of the parent when used within ModalBody
    // ModalBody is a scrollable area and the menu is hidden when rendered within it
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hmQK4.PortalConsumer), {
        children: (portal)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $c4OV1.SelectWithoutAnalytics), {
                spacing: spacing,
                appearance: appearance,
                testId: testId,
                autoFocus: autoFocus,
                defaultValue: defaultValue,
                closeMenuOnSelect: closeMenuOnSelect,
                inputValue: inputValue,
                inputId: id || inputId,
                isClearable: isClearable,
                isLoading: isLoading,
                isMulti: isMulti,
                isSearchable: isSearchable,
                menuIsOpen: menuIsOpen,
                openMenuOnFocus: openMenuOnFocus,
                menuPortalTarget: portal,
                isRequired: isRequired,
                // onInputChange must return a void type for this to work
                onInputChange: (value, metaData)=>{
                    onInputChange?.(value, metaData);
                    return;
                },
                options: options,
                placeholder: placeholder,
                onChange: onChange,
                // Field props
                isDisabled: isDisabled,
                isInvalid: isInvalid,
                onBlur: (0, $8AppO.adaptEventHandler)(onBlur),
                onFocus: (0, $8AppO.adaptEventHandler)(onFocus),
                value: value,
                name: name
            })
    }));
};

});

parcelRegister("1YFAh", function(module, exports) {
$parcel$export(module.exports, "Spinner", () => $f3703512a8b26103$export$7f7cbe89f1eacd2);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $7ep4S = parcelRequire("7ep4S");
const $f3703512a8b26103$export$bf0162d825d6e13 = {
    appearance: true,
    delay: true,
    interactionName: false,
    label: true,
    size: true,
    testId: true
};
const $f3703512a8b26103$export$7f7cbe89f1eacd2 = (props)=>{
    const { appearance: appearance, delay: delay, label: label, size: size, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
        appearance: appearance,
        delay: delay,
        label: label,
        size: size,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("68m2D", function(module, exports) {
$parcel$export(module.exports, "Stack", () => $4a547ef1986a23f0$export$694e0d28c7ffc90c);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $dW738 = parcelRequire("dW738");
const $4a547ef1986a23f0$export$bf0162d825d6e13 = {
    children: true,
    alignBlock: true,
    alignInline: true,
    grow: true,
    space: true,
    spread: true,
    testId: true
};
const $4a547ef1986a23f0$export$694e0d28c7ffc90c = (props)=>{
    const { alignBlock: alignBlock, alignInline: alignInline, grow: grow, space: space, spread: spread, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dW738.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                children: props.render(c)
            }, c.key)),
        alignBlock: alignBlock,
        alignInline: alignInline,
        grow: grow,
        space: space,
        spread: spread,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("pec4g", function(module, exports) {
$parcel$export(module.exports, "Strong", () => $7bb4470c0f57a6a9$export$f301627d437cff88);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5qJVF = parcelRequire("5qJVF");

var $kweLG = parcelRequire("kweLG");

var $kpjEk = parcelRequire("kpjEk");
const $7bb4470c0f57a6a9$export$f301627d437cff88 = (props)=>{
    const { extensionType: extensionType, forgeEnvironment: forgeEnvironment } = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $kpjEk.RendererContext));
    const isMacro = extensionType === 'xen:macro';
    const isProduction = forgeEnvironment === 'PRODUCTION';
    if (!isProduction) (0, $kweLG.default)(`[@forge/react: Strong] Warning: The "Strong" component is deprecated and will be removed on the 28th of August 2025. Please use the "Text" component instead. For more information, visit: https://developer.atlassian.com/platform/forge/ui-kit/components/text/.`);
    return(// `p` tag in editor/page is set to 16px. The strong element is using the Text component which sets it to 14px. Resetting to large to match with the rest of the editor/page styles. In other modules, this would default to 14px to match with the rest of the typography styles.
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
        size: isMacro ? 'large' : undefined,
        as: "strong",
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                children: props.render(c)
            }, c.key))
    }));
};

});

parcelRegister("4hJhN", function(module, exports) {
$parcel$export(module.exports, "Tab", () => $2ab6d5e055afc462$export$3e41faf802a29e71);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $41h42 = parcelRequire("41h42");
const $2ab6d5e055afc462$export$bf0162d825d6e13 = {
    children: true,
    testId: true
};
const $2ab6d5e055afc462$export$3e41faf802a29e71 = (props)=>{
    const { testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $41h42.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                children: props.render(c)
            }, c.key)),
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});
parcelRegister("41h42", function(module, exports) {
$parcel$export(module.exports, "default", () => $c693230e7a8a8f94$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $g6Dmv = parcelRequire("g6Dmv");
var $3cMgR = parcelRequire("3cMgR");

var $lcHWu = parcelRequire("lcHWu");
/**
 * __Tab__
 *
 * Tab represents an individual Tab displayed in a TabList.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $c693230e7a8a8f94$var$Tab = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function Tab({ children: children, testId: testId }, ref) {
    const { onClick: onClick, id: id, 'aria-controls': ariaControls, 'aria-posinset': ariaPosinset, 'aria-selected': ariaSelected, 'aria-setsize': ariaSetsize, onKeyDown: onKeyDown, role: role, tabIndex: tabIndex } = (0, $lcHWu.useTab)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $g6Dmv.default), {
        as: "div",
        isInset: true,
        testId: testId,
        onClick: onClick,
        id: id,
        "aria-controls": ariaControls,
        "aria-posinset": ariaPosinset,
        "aria-selected": ariaSelected,
        "aria-setsize": ariaSetsize,
        onKeyDown: onKeyDown,
        role: role,
        tabIndex: tabIndex,
        ref: ref,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
            weight: "medium",
            color: "inherit",
            maxLines: 1,
            children: children
        })
    });
});
var $c693230e7a8a8f94$export$2e2bcd8739ae039 = $c693230e7a8a8f94$var$Tab;

});
parcelRegister("lcHWu", function(module, exports) {
$parcel$export(module.exports, "useTab", () => $91221b4997543842$export$fdf4756d5b8ef90a);
$parcel$export(module.exports, "useTabList", () => $91221b4997543842$export$773e389e644c5874);
$parcel$export(module.exports, "useTabPanel", () => $91221b4997543842$export$fae0121b5afe572d);

var $eJOHy = parcelRequire("eJOHy");

var $4OxCz = parcelRequire("4OxCz");
const $91221b4997543842$export$fdf4756d5b8ef90a = ()=>{
    const tabData = (0, $eJOHy.useContext)((0, $4OxCz.TabContext));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
};
const $91221b4997543842$export$773e389e644c5874 = ()=>{
    const tabListData = (0, $eJOHy.useContext)((0, $4OxCz.TabListContext));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
};
const $91221b4997543842$export$fae0121b5afe572d = ()=>{
    const tabPanelData = (0, $eJOHy.useContext)((0, $4OxCz.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
};

});
parcelRegister("4OxCz", function(module, exports) {
$parcel$export(module.exports, "TabContext", () => $079a819a44225d4e$export$5a5d356ca5f10a0a);
$parcel$export(module.exports, "TabListContext", () => $079a819a44225d4e$export$aa6907f9fd69e93b);
$parcel$export(module.exports, "TabPanelContext", () => $079a819a44225d4e$export$2054129d247c3102);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $eJOHy = parcelRequire("eJOHy");
const $079a819a44225d4e$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $079a819a44225d4e$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $079a819a44225d4e$export$2054129d247c3102 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);

});




parcelRegister("6NjIV", function(module, exports) {
$parcel$export(module.exports, "TabList", () => $5efb21a671ec3d9b$export$e51a686c67fdaa2d);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $7oCv0 = parcelRequire("7oCv0");
const $5efb21a671ec3d9b$export$bf0162d825d6e13 = {
    children: {
        value: "props.forgeDoc.children.flatMap((c) => c.type === 'String' ? [] : props.render(c))",
        comment: 'Filter out line spacing strings as TabList should only have Tab children'
    }
};
const $5efb21a671ec3d9b$export$e51a686c67fdaa2d = (props)=>{
    const {} = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7oCv0.default), {
        // Filter out line spacing strings as TabList should only have Tab children
        children: props.forgeDoc.children.flatMap((c)=>c.type === 'String' ? [] : props.render(c))
    });
}; /**
 * @codegenEnd
 */ 

});
parcelRegister("7oCv0", function(module, exports) {
$parcel$export(module.exports, "default", () => $b96e2c7b7779acd6$export$2e2bcd8739ae039);
/* tab-list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lcHWu = parcelRequire("lcHWu");

var $4OxCz = parcelRequire("4OxCz");
const $b96e2c7b7779acd6$var$baseStyles = null;
const $b96e2c7b7779acd6$var$tabListStyles = null;
/**
 * __TabList__
 *
 * A TabList groups `Tab` components together.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $b96e2c7b7779acd6$var$TabList = ({ children: children })=>{
    const { tabsId: tabsId, selected: selected, onChange: onChange } = (0, $lcHWu.useTabList)();
    const ref = /*#__PURE__*/ (0, $eJOHy.createRef)();
    // Don't include any conditional children
    const childrenArray = (0, $eJOHy.Children).toArray(children).filter(Boolean);
    const length = childrenArray.length;
    const selectTabByIndex = (0, $eJOHy.useCallback)((index)=>{
        const newSelectedNode = ref.current?.querySelector(`[id='${tabsId}-${index}']`);
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    const onKeyDown = (0, $eJOHy.useCallback)((e)=>{
        if (![
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(e.key)) return;
        // preventing horizontal or vertical scroll
        e.preventDefault();
        const lastTabIndex = length - 1;
        if ([
            'Home',
            'End'
        ].includes(e.key)) {
            const newSelected = e.key === 'Home' ? 0 : lastTabIndex;
            selectTabByIndex(newSelected);
            return;
        }
        // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        const selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
        const modifier = e.key === 'ArrowRight' ? 1 : -1;
        let newSelected = selectedIndex + modifier;
        if (newSelected < 0 || newSelected >= length) // Cycling focus to move from last to first and from first to last
        newSelected = newSelected < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected);
    }, [
        length,
        selectTabByIndex
    ]);
    // Memoized so the function isn't recreated each time
    const getTabWithContext = (0, $eJOHy.useCallback)(({ tab: tab, isSelected: isSelected, index: index })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $4OxCz.TabContext).Provider, {
            value: {
                onClick: ()=>onChange(index),
                onKeyDown: onKeyDown,
                'aria-setsize': length,
                role: 'tab',
                id: `${tabsId}-${index}`,
                'aria-posinset': index + 1,
                'aria-selected': isSelected,
                'aria-controls': `${tabsId}-${index}-tab`,
                tabIndex: isSelected ? 0 : -1
            },
            children: tab
        }, index), [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        role: "tablist",
        ref: ref,
        className: (0, $hcewu.default)([
            "_1e0c1txw _kqswh2mm _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            "_k48p1wq8 _ahbqx0bf _gpbcidpf _10vzidpf _1mmwidpf _15plidpf _7hip15vq _1fud15vq _bb0mh2mm _1quzjjyb _rzxytlke _1ofh12x7 _pryi12x7 _1a85u2gc _rmpau2gc _1dze1l2s _1tms1q9c _fiizidpf _1xrmidpf _xyihidpf _166qidpf _1lzu8wxv _24g71kw7 _140sidpf _lycustnw _15d8b3bt _1fztidpf _wd7eu2gc _1olcu2gc _1oazdud1 _w9ewidpf _170tidpf _y1g1idpf _1nvfidpf _1b8d8wxv _1n121kw7 _7p9oidpf _o2e1stnw _16u6b3bt _1yk1idpf _1lbou2gc _1c9uu2gc _1i201ouy _bppridpf _1mbxidpf _kn0bidpf _wsgdidpf _rsmzwg2n _1m0e1kw7 _93pdidpf _1sglstnw _1ksob3bt _1p9sidpf _1qa1u2gc _1jjcu2gc _fiem1ldt _pascidpf _eid3idpf _zr3eidpf _fntnidpf _1mp41kw7 _kfgte4h9 _1cs8stnw _1rushloo _1kt9b3bt _1fkridpf _1enwidpf _z5wtu2gc"
        ]),
        children: childrenArray.map((child, index)=>getTabWithContext({
                tab: child,
                index: index,
                isSelected: index === selected
            }))
    });
};
var $b96e2c7b7779acd6$export$2e2bcd8739ae039 = $b96e2c7b7779acd6$var$TabList;

});


parcelRegister("5O40n", function(module, exports) {
$parcel$export(module.exports, "TabPanel", () => $e26e2e337938974e$export$3d96ec278d3efce4);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $2cSdF = parcelRequire("2cSdF");
const $e26e2e337938974e$export$bf0162d825d6e13 = {
    children: true,
    testId: true
};
const $e26e2e337938974e$export$3d96ec278d3efce4 = (props)=>{
    const { testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2cSdF.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                children: props.render(c)
            }, c.key)),
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});
parcelRegister("2cSdF", function(module, exports) {
$parcel$export(module.exports, "default", () => $9291670942049679$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $g6Dmv = parcelRequire("g6Dmv");

var $lcHWu = parcelRequire("lcHWu");
// Note this is not being memoized as children is an unstable reference
/**
 * __TabPanel__
 *
 * A TabPanel houses the contents of a Tab.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $9291670942049679$var$TabPanel = ({ children: children, testId: testId })=>{
    const { role: role, id: id, hidden: hidden, 'aria-labelledby': ariaLabelledBy, tabIndex: tabIndex } = (0, $lcHWu.useTabPanel)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $g6Dmv.default), {
        as: "div",
        isInset: true,
        testId: testId,
        role: role,
        id: id,
        hidden: hidden,
        "aria-labelledby": ariaLabelledBy,
        tabIndex: tabIndex,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
            children: children
        })
    });
};
var $9291670942049679$export$2e2bcd8739ae039 = $9291670942049679$var$TabPanel;

});


parcelRegister("h2oYB", function(module, exports) {
$parcel$export(module.exports, "Tabs", () => $916f3472889f0b66$export$b2539bed5023c21c);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $cpHe2 = parcelRequire("cpHe2");
const $916f3472889f0b66$export$bf0162d825d6e13 = {
    id: true,
    children: {
        value: "props.forgeDoc.children.flatMap((c) => c.type === 'String' ? [] : props.render(c))",
        comment: 'Filter out line spacing strings as Tabs should only have TabList & TabPanel children'
    },
    defaultSelected: true,
    onChange: true,
    selected: true,
    shouldUnmountTabPanelOnChange: true,
    testId: true
};
const $916f3472889f0b66$export$b2539bed5023c21c = (props)=>{
    const { id: id, defaultSelected: defaultSelected, onChange: onChange, selected: selected, shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cpHe2.default), {
        id: id,
        // Filter out line spacing strings as Tabs should only have TabList & TabPanel children
        children: props.forgeDoc.children.flatMap((c)=>c.type === 'String' ? [] : props.render(c)),
        defaultSelected: defaultSelected,
        onChange: onChange,
        selected: selected,
        shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});
parcelRegister("cpHe2", function(module, exports) {
$parcel$export(module.exports, "default", () => $03090e4bd6ee746b$export$2e2bcd8739ae039);
/* tabs.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jrFnt = parcelRequire("jrFnt");

var $4OxCz = parcelRequire("4OxCz");
const $03090e4bd6ee746b$var$baseStyles = null;
const $03090e4bd6ee746b$var$tabsStyles = null;
const $03090e4bd6ee746b$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $03090e4bd6ee746b$var$getTabPanelWithContext = ({ tabPanel: tabPanel, index: index, isSelected: isSelected, tabsId: tabsId })=>// Ensure tabPanel exists in case it has been removed
    tabPanel && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4OxCz.TabPanelContext).Provider, {
        value: {
            role: 'tabpanel',
            id: `${tabsId}-${index}-tab`,
            hidden: isSelected ? undefined : true,
            'aria-labelledby': `${tabsId}-${index}`,
            tabIndex: isSelected ? 0 : -1
        },
        children: tabPanel
    }, index); /**
                                * __Tabs__
                                *
                                * Tabs acts as a container for all Tab components.
                                *
                                * - [Examples](https://atlassian.design/components/tabs/examples)
                                * - [Code](https://atlassian.design/components/tabs/code)
                                * - [Usage](https://atlassian.design/components/tabs/usage)
                                */ 
const $03090e4bd6ee746b$var$Tabs = (props)=>{
    const { shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange = false, selected: SelectedType, defaultSelected: defaultSelected, onChange: onChangeProp, id: id, analyticsContext: analyticsContext, children: children, testId: testId } = props;
    const [selectedState, setSelected] = (0, $eJOHy.useState)(SelectedType || defaultSelected || 0);
    const selected = SelectedType === undefined ? selectedState : SelectedType;
    const childrenArray = (0, $eJOHy.Children).toArray(children) // Don't include any conditional children
    .filter((child)=>Boolean(child)); // First child should be a tabList followed by tab panels
    const [tabList, ...tabPanels] = childrenArray; // Keep track of visited and add to a set
    const visited = (0, $eJOHy.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    const onChange = (0, $eJOHy.useCallback)((index, analyticsEvent)=>{
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    const onChangeAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$03090e4bd6ee746b$var$analyticsAttributes
    });
    const tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $03090e4bd6ee746b$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map((tabIndex)=>$03090e4bd6ee746b$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        }));
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c1txw _p12f1osq _1tkeidpf _i0dl1osq _2lx21bp4 _16jlkb7n",
            "_1c3y1txw _ftfaidpf _18i0kb7n _185bglyw"
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4OxCz.TabListContext).Provider, {
                value: {
                    selected: selected,
                    onChange: onChangeAnalytics,
                    tabsId: id
                },
                children: tabList
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
                children: tabPanelsWithContext
            })
        ]
    });
};
var $03090e4bd6ee746b$export$2e2bcd8739ae039 = $03090e4bd6ee746b$var$Tabs;

});


parcelRegister("cefYx", function(module, exports) {
$parcel$export(module.exports, "SimpleTag", () => $044f1dc5d8460871$export$774e1ef5dc84ebd4);

var $gt9Am = parcelRequire("gt9Am");

var $5aix7 = parcelRequire("5aix7");

var $aWpPf = parcelRequire("aWpPf");
parcelRequire("eJOHy");

var $ewOxf = parcelRequire("ewOxf");
const $044f1dc5d8460871$export$bf0162d825d6e13 = {
    text: true,
    appearance: true,
    color: true,
    elemBefore: {
        value: 'elemBefore ? props.render(elementToForgeDoc(elemBefore as React.ReactElement)): null',
        comment: 'forge/react reconciler does not convert components in props into ForgeDoc. We need to do it manually here'
    },
    href: {
        value: 'href ? sanitizeUrl(href) : undefined'
    },
    linkComponent: false,
    testId: true
};
const $044f1dc5d8460871$export$774e1ef5dc84ebd4 = (props)=>{
    const { text: text, appearance: appearance, color: color, elemBefore: elemBefore, href: href, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ewOxf.default), {
        text: text,
        appearance: appearance,
        color: color,
        // forge/react reconciler does not convert components in props into ForgeDoc. We need to do it manually here
        elemBefore: elemBefore ? props.render((0, $5aix7.elementToForgeDoc)(elemBefore)) : null,
        href: href ? (0, $aWpPf.sanitizeUrl)(href) : undefined,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});
parcelRegister("ewOxf", function(module, exports) {
$parcel$export(module.exports, "default", () => $935d42f1f33a5e95$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $1fStw = parcelRequire("1fStw");

var $40nZT = parcelRequire("40nZT");

var $6UE2q = parcelRequire("6UE2q");
const $935d42f1f33a5e95$var$SimpleTagComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, color: color = 'standard', href: href, testId: testId, text: text = '', linkComponent: linkComponent }, ref)=>{
    const content = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6UE2q.default), {
        elemBefore: elemBefore,
        isRemovable: false,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent,
        testId: testId
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1fStw.default), {
        ref: ref,
        testId: testId,
        href: href,
        appearance: appearance,
        color: color,
        before: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $40nZT.default), {
            elemBefore: elemBefore
        }),
        contentElement: content
    });
});
/**
 * __Simple tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * `SimpleTag` is the default form of a tag, where text is required. Tags with static text can be used as a flag or as a reference to an object or attribute.
 *
 * - [Examples](https://atlassian.design/components/tag/examples)
 * - [Code](https://atlassian.design/components/tag/code)
 * - [Usage](https://atlassian.design/components/tag/usage)
 */ const $935d42f1f33a5e95$var$SimpleTag = /*#__PURE__*/ (0, $eJOHy.memo)($935d42f1f33a5e95$var$SimpleTagComponent);
var $935d42f1f33a5e95$export$2e2bcd8739ae039 = $935d42f1f33a5e95$var$SimpleTag;

});
parcelRegister("1fStw", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb40a4175fb93ea9$export$2e2bcd8739ae039);
/* base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
// Border colors - Hardcoded for Visual Refresh - to be removed with labelling system work
const $eb40a4175fb93ea9$var$borderColors = {
    standard: "_1h6d14je",
    blue: "_1h6duisw",
    red: "_1h6da2c0",
    yellow: "_1h6deh2r",
    green: "_1h6d18uw",
    teal: "_1h6d1ug6",
    purple: "_1h6d157s",
    lime: "_1h6dn0nx",
    magenta: "_1h6d1lf6",
    orange: "_1h6dh727",
    grey: "_1h6d14je",
    standardLink: "_1h6d14je",
    blueLight: "_1h6duisw",
    redLight: "_1h6da2c0",
    yellowLight: "_1h6deh2r",
    greenLight: "_1h6d18uw",
    tealLight: "_1h6d1ug6",
    purpleLight: "_1h6d157s",
    limeLight: "_1h6dn0nx",
    magentaLight: "_1h6d1lf6",
    orangeLight: "_1h6dh727",
    greyLight: "_1h6d14je"
};
const $eb40a4175fb93ea9$var$baseStyles = null;
const $eb40a4175fb93ea9$var$interactiveStyles = null;
const $eb40a4175fb93ea9$var$focusRingStyles = null;
const $eb40a4175fb93ea9$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, appearance: appearance = 'default', style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("span", {
        ...other,
        ref: ref,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_zulp1b66 _2rko12b0 _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3iv47k _kqswh2mm _4cvr1h6o _bfhk1w7a _syaz1fxt _80om73ad",
            isInteractive && "_1e381q03 _7glxv77o",
            isLink && "_irr3166n _1di61dty",
            $eb40a4175fb93ea9$var$borderColors[color],
            className
        ]),
        "data-testid": testId,
        children: [
            before,
            contentElement,
            after
        ]
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$eb40a4175fb93ea9$export$2e2bcd8739ae039 = $eb40a4175fb93ea9$var$BaseTag;

});

parcelRegister("40nZT", function(module, exports) {
$parcel$export(module.exports, "default", () => $dae242ab93c29e38$export$2e2bcd8739ae039);
/* before.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $dae242ab93c29e38$var$beforeElementStyles = null;
const $dae242ab93c29e38$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            "_1e0c1txw _4t3i7vkz _4cvr1h6o _1bah1h6o _152tze3t"
        ]),
        children: elemBefore
    }) : null;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$dae242ab93c29e38$export$2e2bcd8739ae039 = $dae242ab93c29e38$var$Before;

});

parcelRegister("6UE2q", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d73caba6a9e3a1c$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $6d73caba6a9e3a1c$var$baseStyles = null;
const $6d73caba6a9e3a1c$var$linkStyles = null;
const $6d73caba6a9e3a1c$var$hasAfterStyles = null;
const $6d73caba6a9e3a1c$var$Content = ({ isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent, testId: testId })=>{
    const Link = linkComponent ?? 'a';
    if (href) return /*#__PURE__*/ (0, $gt9Am.jsx)(Link, {
        href: href,
        "data-color": color,
        "data-testid": testId ? `${testId}--link` : undefined,
        className: (0, $hcewu.default)([
            "_11c82smr _1reo15vq _18m915vq _p12fmgvx _1bto1l2s _o5721q9c",
            "_4bfu18uv _1hmsglyw _ajmmnqa1 _syaz1fxt _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnx8stv _jf4cnqa1 _30l31fxt _1nrm18uv _c2wa8stv _1iohnqa1 _9h8h1fxt",
            isRemovable && "_p12f1lit"
        ]),
        children: text
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            "_11c82smr _1reo15vq _18m915vq _p12fmgvx _1bto1l2s _o5721q9c",
            isRemovable && "_p12f1lit"
        ]),
        children: text
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6d73caba6a9e3a1c$export$2e2bcd8739ae039 = $6d73caba6a9e3a1c$var$Content;

});



parcelRegister("3FS7N", function(module, exports) {
$parcel$export(module.exports, "TagGroup", () => $958280c7532fe4e6$export$67ea30858aaf75e3);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $9ewtR = parcelRequire("9ewtR");
const $958280c7532fe4e6$export$bf0162d825d6e13 = {
    children: true,
    alignment: true
};
const $958280c7532fe4e6$export$67ea30858aaf75e3 = (props)=>{
    const { alignment: alignment } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9ewtR.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                children: props.render(c)
            }, c.key)),
        alignment: alignment
    });
}; /**
 * @codegenEnd
 */ 

});
parcelRegister("9ewtR", function(module, exports) {
$parcel$export(module.exports, "default", () => $07b7decad61e4cb4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $07b7decad61e4cb4$var$baseStyles = null;
const $07b7decad61e4cb4$var$justifyStartStyles = null;
const $07b7decad61e4cb4$var$justifyEndStyles = null;
/**
 * __Tag group__
 *
 * A tag group controls the layout and alignment for a collection of tags.
 *
 * - [Examples](https://atlassian.design/components/tag-group/examples)
 * - [Code](https://atlassian.design/components/tag-group/code)
 * - [Usage](https://atlassian.design/components/tag-group/usage)
 */ const $07b7decad61e4cb4$var$TagGroup = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ alignment: alignment = 'start', titleId: titleId, label: label, children: children }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        role: "group",
        ref: ref,
        "aria-label": label,
        "aria-labelledby": titleId,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bsb1osq _1n261g80",
            alignment === 'start' && "_1bah1y6m",
            alignment === 'end' && "_1bahesu3"
        ]),
        children: children
    });
});
var $07b7decad61e4cb4$export$2e2bcd8739ae039 = $07b7decad61e4cb4$var$TagGroup;

});


parcelRegister("3oQzb", function(module, exports) {
$parcel$export(module.exports, "PatchedText", () => $0b1476fd100b578a$export$40702e9f235b31be);
/* index.partial.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $k0ahr = parcelRequire("k0ahr");

var $kpjEk = parcelRequire("kpjEk");

var $7rgPd = parcelRequire("7rgPd");

var $eJOHy = parcelRequire("eJOHy");

var $3cMgR = parcelRequire("3cMgR");
const $0b1476fd100b578a$export$bf0162d825d6e13 = {
    align: true,
    as: {
        excludeFromDeconstruct: false,
        value: 'as === "strike" ? "span" : as'
    },
    color: true,
    maxLines: true,
    size: true,
    weight: true,
    children: true,
    testId: true,
    xcss: {
        excludeFromDeconstruct: true,
        value: 'cx(styles.regular, as === "strike" && styles.lineThrough)'
    }
};
const $0b1476fd100b578a$var$styles = {
    regular: "_1i4q4jg8",
    lineThrough: "_1hms1911"
};
// If we're displaying a paragraph, unfortunately we still need to bring back the styles to add a top margin
// (unless the wrapper is the first one) to be fully backwards compatible with the legacy component.
const $0b1476fd100b578a$var$wrapperStyles = null;
// Override whitespace:nowrap styling inherited from confluence:ContentBylineItem wrapper
const $0b1476fd100b578a$var$confluenceBylineItemStyle = null;
const $0b1476fd100b578a$export$5f1af8db9871e1d6 = (props)=>{
    const { align: align, as: as, color: color, maxLines: maxLines, size: size, weight: weight, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
        align: align,
        as: as === 'strike' ? 'span' : as,
        color: color,
        maxLines: maxLines,
        size: size,
        weight: weight,
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                children: props.render(c)
            }, c.key)),
        testId: testId,
        xcss: (0, $k0ahr.cx)($0b1476fd100b578a$var$styles.regular, as === 'strike' && $0b1476fd100b578a$var$styles.lineThrough)
    });
};
const $0b1476fd100b578a$export$40702e9f235b31be = (props)=>{
    const textProps = props.forgeDoc.props;
    const componentProps = {
        ...props.forgeDoc.props
    };
    // ADS Text will set value for "color" if none is provided. Since the only way to adjust the color of texts in
    // Forge UI was by using the `xcss` prop on a <Box>, we need to make sure that inheritance of that color
    // is still possible, otherwise we would not be backwards compatible.
    // We can achieve this by setting the default value for "color" to "inherit" if it is not provided.
    componentProps.color = textProps.color === undefined ? 'inherit' : textProps.color;
    const needsWrapper = componentProps.as === 'p' || componentProps.as === undefined;
    const { extensionType: extensionType } = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $kpjEk.RendererContext));
    const isConfluenceByLine = extensionType === 'confluence:contentBylineItem';
    // If we don't have to worry about any margins (all inline elements), we can use the platform Text component directly
    if (!needsWrapper) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7rgPd.InlineContext).Provider, {
        value: {
            inline: true
        },
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($0b1476fd100b578a$export$5f1af8db9871e1d6, {
            render: props.render,
            dispatch: props.dispatch,
            forgeDoc: {
                children: props.forgeDoc.children,
                type: props.forgeDoc.type,
                props: componentProps
            }
        })
    });
    // Default to <p> for backwards compatibility
    if (textProps.as === undefined) componentProps.as = 'p';
    // Use the wrapper to add the margin-top for all paragraphs except the first one
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_168kutpp",
            isConfluenceByLine && "_o5724jg8"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7rgPd.InlineContext).Provider, {
            value: {
                inline: true
            },
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($0b1476fd100b578a$export$5f1af8db9871e1d6, {
                render: props.render,
                dispatch: props.dispatch,
                forgeDoc: {
                    children: props.forgeDoc.children,
                    type: props.forgeDoc.type,
                    props: componentProps
                }
            })
        })
    });
};

});

parcelRegister("4xqqE", function(module, exports) {
$parcel$export(module.exports, "TextArea", () => $2d589f0696282d22$export$f5c9f3c2c4054eec);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $dQmi3 = parcelRequire("dQmi3");

var $8AppO = parcelRequire("8AppO");

var $hHFUz = parcelRequire("hHFUz");
const $2d589f0696282d22$export$f5c9f3c2c4054eec = (props)=>{
    const { appearance: appearance, defaultValue: defaultValue, isCompact: isCompact, isMonospaced: isMonospaced, isReadOnly: isReadOnly, maxHeight: maxHeight, minimumRows: minimumRows, placeholder: placeholder, resize: resize, spellCheck: spellCheck, testId: testId, maxLength: maxLength, minLength: minLength, autoFocus: autoFocus, id: // Field props
    id, isRequired: isRequired, isDisabled: isDisabled, isInvalid: isInvalid, onChange: onChange, onBlur: onBlur, onFocus: onFocus, value: value, 'aria-invalid': ariaInvalid, 'aria-labelledby': ariaLabelledby, name: name } = props.forgeDoc.props;
    const { onChangeWithCursorState: onChangeWithCursorState, inputRef: inputRef } = (0, $hHFUz.useCursorState)(value, onChange);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dQmi3.default), {
        // @ts-ignore type from ADS is missing the ref object. It is still supported
        ref: inputRef,
        appearance: appearance,
        defaultValue: defaultValue,
        isCompact: isCompact,
        isMonospaced: isMonospaced,
        isReadOnly: isReadOnly,
        maxHeight: maxHeight,
        minimumRows: minimumRows,
        placeholder: placeholder,
        resize: resize,
        spellCheck: spellCheck,
        testId: testId,
        maxLength: maxLength,
        minLength: minLength,
        autoFocus: autoFocus,
        // Field props
        id: id,
        isRequired: isRequired,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        onChange: (0, $8AppO.adaptEventHandler)(onChangeWithCursorState),
        onBlur: (0, $8AppO.adaptEventHandler)(onBlur),
        onFocus: (0, $8AppO.adaptEventHandler)(onFocus),
        value: value,
        "aria-invalid": ariaInvalid,
        "aria-labelledby": ariaLabelledby,
        name: name
    });
};

});
parcelRegister("dQmi3", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef995104f62942f4$export$2e2bcd8739ae039);
/* text-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $eGOwo = parcelRequire("eGOwo");
const $ef995104f62942f4$var$packageName = "platform-pkg";
const $ef995104f62942f4$var$packageVersion = "0.0.0-use.local";
const $ef995104f62942f4$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $ef995104f62942f4$var$packageName,
    packageVersion: $ef995104f62942f4$var$packageVersion
};
const $ef995104f62942f4$var$lineHeightBase = 20;
const $ef995104f62942f4$var$lineHeightCompact = 16;
const $ef995104f62942f4$var$compactVerticalPadding = 2;
const $ef995104f62942f4$var$verticalPadding = 6;
const $ef995104f62942f4$var$transitionDuration = '0.2s';
const $ef995104f62942f4$var$borderWidth = 2;
const $ef995104f62942f4$var$baseStyles = null;
const $ef995104f62942f4$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp821elr _1ltx1j9a _1bqs13gt _z1pvsyzs _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _17km1v6z _wg601v6z _858u1p6i _jomrr01l _7ehiq049 _186j1p6i _qu18syzs",
    subtle: "_1dqonqa1 _kp823acm _1ltx18uv _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _wg601v6z _17km1v6z _858u1p6i _jomrr01l _7ehiq049",
    none: "_1dqoglyw _kp823acm _1ltx18uv _19wt3acm _12ym18uv _19qkv77o _zedr12x7 _1dbiv77o _1etu12x7 _1itd12x7 _wg6012x7 _1a4912x7 _17km12x7 _858u3acm _jomr18uv _7ehinruj"
};
const $ef995104f62942f4$var$fontStyles = {
    default: "_ect41gqc",
    monospace: "_ect41odn _1tn22smr _14mdudxr",
    large: "_11c81ixg _1tn22smr"
};
const $ef995104f62942f4$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $ef995104f62942f4$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $ef995104f62942f4$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $ef995104f62942f4$var$InnerTextArea = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const ourRef = (0, $eJOHy.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $eJOHy.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $ef995104f62942f4$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$ef995104f62942f4$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$ef995104f62942f4$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $eJOHy.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $ef995104f62942f4$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rkofajl _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazj3m3 _slp31hna _153g78r2 _usy4mag2 _1a2sr6rt _vbqb9jg2 _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra78r2 _ibjd10ko _6zpvr6rt _19k01y1w _1idr1wmz _1lep9jg2 _nmhq1fiz _1n388sxn _1luh194a _ndzbr01l _1vj01cu8",
            $ef995104f62942f4$var$appearanceStyles[appearance],
            (0, $eGOwo.fg)('platform_design_system_team_safari_input_fix') && $ef995104f62942f4$var$fontStyles['large'],
            $ef995104f62942f4$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $ef995104f62942f4$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $awdRS.default)($ef995104f62942f4$var$lineHeightCompact * minimumRows + $ef995104f62942f4$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $awdRS.default)($ef995104f62942f4$var$lineHeightBase * minimumRows + $ef995104f62942f4$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $ef995104f62942f4$var$TextArea = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)($ef995104f62942f4$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$ef995104f62942f4$var$TextArea.displayName = 'TextArea';
var $ef995104f62942f4$export$2e2bcd8739ae039 = $ef995104f62942f4$var$TextArea;

});

parcelRegister("hHFUz", function(module, exports) {
$parcel$export(module.exports, "useCursorState", () => $c590d0f5c9dc53ea$export$7dee127706cff7f2);

var $eJOHy = parcelRequire("eJOHy");
const $c590d0f5c9dc53ea$export$7dee127706cff7f2 = (value, onChange)=>{
    const inputRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const [cursor, setCursor] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        const input = inputRef.current;
        if (input && cursor !== null && input.selectionStart !== cursor) input.setSelectionRange(cursor, cursor);
    }, [
        inputRef,
        cursor,
        value
    ]);
    const onChangeWithCursorState = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((e)=>{
        onChange?.(e);
        if (e.target.selectionStart) setCursor(e.target?.selectionStart);
    }, [
        onChange
    ]);
    if (!onChange) return {
        onChangeWithCursorState: undefined,
        inputRef: inputRef
    };
    return {
        onChangeWithCursorState: onChangeWithCursorState,
        inputRef: inputRef
    };
};

});


parcelRegister("2FRLC", function(module, exports) {
$parcel$export(module.exports, "Textfield", () => $b16d7b68aa111d60$export$d66ddc2063fc70a7);

var $gt9Am = parcelRequire("gt9Am");

var $5aix7 = parcelRequire("5aix7");
parcelRequire("eJOHy");

var $sY9BV = parcelRequire("sY9BV");

var $8AppO = parcelRequire("8AppO");

var $hHFUz = parcelRequire("hHFUz");
const $b16d7b68aa111d60$export$d66ddc2063fc70a7 = (props)=>{
    const { appearance: appearance, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact, autoFocus: autoFocus, isReadOnly: isReadOnly, isMonospaced: isMonospaced, placeholder: placeholder, testId: testId, width: width, type: type, defaultValue: defaultValue, min: min, max: max, maxLength: maxLength, minLength: minLength, pattern: pattern, id: // Field props
    id, isRequired: isRequired, isDisabled: isDisabled, isInvalid: isInvalid, onChange: onChange, onBlur: onBlur, onFocus: onFocus, value: value, 'aria-invalid': ariaInvalid, 'aria-labelledby': ariaLabelledby, name: name } = props.forgeDoc.props;
    const { onChangeWithCursorState: onChangeWithCursorState, inputRef: inputRef } = (0, $hHFUz.useCursorState)(value, onChange);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $sY9BV.default), {
        ref: inputRef,
        appearance: appearance,
        // forge/react reconciler does not convert components in props into ForgeDoc. We need to do it manually here
        elemAfterInput: elemAfterInput ? props.render((0, $5aix7.elementToForgeDoc)(elemAfterInput)) : null,
        // forge/react reconciler does not convert components in props into ForgeDoc. We need to do it manually here
        elemBeforeInput: elemBeforeInput ? props.render((0, $5aix7.elementToForgeDoc)(elemBeforeInput)) : null,
        isCompact: isCompact,
        autoFocus: autoFocus,
        isReadOnly: isReadOnly,
        isMonospaced: isMonospaced,
        placeholder: placeholder,
        testId: testId,
        width: width,
        type: type,
        defaultValue: defaultValue,
        min: min,
        max: max,
        maxLength: maxLength,
        minLength: minLength,
        pattern: pattern,
        // Field props
        id: id,
        isRequired: isRequired,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        onChange: (0, $8AppO.adaptEventHandler)(onChangeWithCursorState),
        onBlur: (0, $8AppO.adaptEventHandler)(onBlur),
        onFocus: (0, $8AppO.adaptEventHandler)(onFocus),
        value: value,
        "aria-invalid": ariaInvalid,
        "aria-labelledby": ariaLabelledby,
        name: name
    });
};

});

parcelRegister("eqXEa", function(module, exports) {
$parcel$export(module.exports, "TimePicker", () => $b2eecf84f283c6a9$export$5f876910ea565cd3);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fkh8F = parcelRequire("fkh8F");

var $8AppO = parcelRequire("8AppO");
const $b2eecf84f283c6a9$export$bf0162d825d6e13 = {
    appearance: true,
    defaultIsOpen: true,
    autoFocus: true,
    defaultValue: true,
    formatDisplayLabel: false,
    innerProps: false,
    isOpen: true,
    label: true,
    parseInputValue: false,
    spacing: true,
    times: true,
    timeIsEditable: true,
    hideIcon: true,
    timeFormat: true,
    placeholder: true,
    locale: true,
    testId: true,
    selectProps: true,
    onChange: true,
    value: {
        replaceLine: true,
        value: '{...(value !== undefined ? { value }: undefined) }',
        comment: 'Explicitly setting value to undefined is causing issues'
    }
};
const $b2eecf84f283c6a9$export$5f876910ea565cd3 = (props)=>{
    const { appearance: appearance, defaultIsOpen: defaultIsOpen, autoFocus: autoFocus, defaultValue: defaultValue, isOpen: isOpen, label: label, spacing: spacing, times: times, timeIsEditable: timeIsEditable, hideIcon: hideIcon, timeFormat: timeFormat, placeholder: placeholder, locale: locale, testId: testId, selectProps: selectProps, onChange: onChange, value: value, id: // Field props
    id, isRequired: isRequired, isDisabled: isDisabled, isInvalid: isInvalid, onBlur: onBlur, onFocus: onFocus, "aria-invalid": ariaInvalid, "aria-labelledby": ariaLabelledby, name: name } = props.forgeDoc.props;
    // warning: appearance is deprecated;
    // warning: defaultIsOpen is deprecated;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fkh8F.default), {
        appearance: appearance,
        defaultIsOpen: defaultIsOpen,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        isOpen: isOpen,
        label: label,
        spacing: spacing,
        times: times,
        timeIsEditable: timeIsEditable,
        hideIcon: hideIcon,
        timeFormat: timeFormat,
        placeholder: placeholder,
        locale: locale,
        testId: testId,
        selectProps: selectProps,
        onChange: onChange,
        ...value !== undefined ? {
            value: value
        } : undefined,
        // Field props
        id: id,
        isRequired: isRequired,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        onBlur: (0, $8AppO.adaptEventHandler)(onBlur),
        onFocus: (0, $8AppO.adaptEventHandler)(onFocus),
        "aria-invalid": ariaInvalid,
        "aria-labelledby": ariaLabelledby,
        name: name
    });
}; /**
 * @codegenEnd
 */ 

});
parcelRegister("fkh8F", function(module, exports) {
$parcel$export(module.exports, "default", () => $bbd2b423b4bc9ae0$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $57raR = parcelRequire("57raR");
var $dBLX0 = parcelRequire("dBLX0");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");

var $cK9J2 = parcelRequire("cK9J2");

var $kVcjU = parcelRequire("kVcjU");
var $c4OV1 = parcelRequire("c4OV1");
var $e9zKl = parcelRequire("e9zKl");

var $RoXqn = parcelRequire("RoXqn");

var $icQS1 = parcelRequire("icQS1");

var $kdGko = parcelRequire("kdGko");

var $5PwWU = parcelRequire("5PwWU");

var $7OE9J = parcelRequire("7OE9J");
const $bbd2b423b4bc9ae0$var$packageName = "platform-pkg";
const $bbd2b423b4bc9ae0$var$packageVersion = "0.0.0-use.local";
const $bbd2b423b4bc9ae0$var$menuStyles = {
    /* Need to remove default absolute positioning as that causes issues with position fixed */ position: 'static',
    /* Need to add overflow to the element with max-height, otherwise causes overflow issues in IE11 */ overflowY: 'auto',
    /* React-Popper has already offset the menu so we need to reset the margin, otherwise the offset value is doubled */ margin: 0
};
const $bbd2b423b4bc9ae0$var$analyticsAttributes = {
    componentName: 'timePicker',
    packageName: $bbd2b423b4bc9ae0$var$packageName,
    packageVersion: $bbd2b423b4bc9ae0$var$packageVersion
};
/**
 * __Time picker__
 *
 * A time picker allows the user to select a specific time.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/time-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/time-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/time-picker/usage)
 */ const $bbd2b423b4bc9ae0$var$TimePicker = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear timepicker', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', formatDisplayLabel: formatDisplayLabel, hideIcon: hideIcon = false, id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, isOpen: providedIsOpen, label: label = '', locale: locale = 'en-US', name: name = '', onBlur: providedOnBlur = (0, $3Vuhz.default), onChange: providedOnChange = (0, $3Vuhz.default), onFocus: providedOnFocus = (0, $3Vuhz.default), parseInputValue: parseInputValue = (time, _timeFormat)=>(0, $kdGko.default)(time), placeholder: placeholder, selectProps: selectProps = {}, spacing: spacing = 'default', testId: testId, timeFormat: timeFormat, timeIsEditable: timeIsEditable = false, times: times = (0, $RoXqn.defaultTimes), value: providedValue }, ref)=>{
    const [containerRef, setContainerRef] = (0, $eJOHy.useState)(null);
    /**
   * When being cleared from the icon the TimePicker is blurred.
   * This variable defines whether the default onMenuOpen or onMenuClose
   * events should behave as normal
   */ const [clearingFromIcon, setClearingFromIcon] = (0, $eJOHy.useState)(false);
    // TODO: Remove isFocused? Does it do anything?
    const [_, setIsFocused] = (0, $eJOHy.useState)(false);
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(defaultIsOpen);
    const [value, setValue] = (0, $eJOHy.useState)(defaultValue);
    // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $eJOHy.useReducer)((x)=>x + 1, 0);
    const providedOnChangeWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: providedOnChange,
        action: 'selectedTime',
        ...$bbd2b423b4bc9ae0$var$analyticsAttributes
    });
    (0, $eJOHy.useEffect)(()=>{
        if (providedValue) setValue(providedValue);
    }, [
        providedValue
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (providedIsOpen) setIsOpen(providedIsOpen);
    }, [
        providedIsOpen
    ]);
    const onChange = (0, $eJOHy.useCallback)((newValue, action)=>{
        const rawValue = newValue ? newValue.value || newValue : '';
        const finalValue = rawValue.toString();
        setValue(finalValue);
        if (action && action.action === 'clear') setClearingFromIcon(true);
        providedOnChangeWithAnalytics(finalValue);
    }, [
        providedOnChangeWithAnalytics
    ]);
    /**
   * Only allow custom times if timeIsEditable prop is true
   */ const onCreateOption = (inputValue)=>{
        if (timeIsEditable) {
            let sanitizedInput;
            try {
                sanitizedInput = parseInputValue(inputValue, timeFormat || (0, $RoXqn.defaultTimeFormat));
            } catch (e) {
                return; // do nothing, the main validation should happen in the form
            }
            const includesSeconds = !!(timeFormat && /[:.]?(s|ss)/.test(timeFormat));
            const formatFormat = includesSeconds ? 'HH:mm:ss' : 'HH:mm';
            const formattedValue = (0, $57raR.default)(sanitizedInput, formatFormat) || '';
            setValue(formattedValue);
            providedOnChangeWithAnalytics(formattedValue);
        } else providedOnChangeWithAnalytics(inputValue);
    };
    const onMenuOpen = ()=>{
        // Don't open menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(true);
    };
    const onMenuClose = ()=>{
        // Don't close menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(false);
    };
    const setInternalContainerRef = (ref)=>{
        const oldRef = containerRef;
        setContainerRef(ref);
        // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef === null && ref !== null) forceUpdate();
    };
    const onBlur = (event)=>{
        setIsFocused(false);
        providedOnBlur(event);
    };
    const onFocus = (event)=>{
        setIsFocused(true);
        providedOnFocus(event);
    };
    const onSelectKeyDown = (event)=>{
        const { key: key } = event;
        const keyPressed = key.toLowerCase();
        if (clearingFromIcon && (keyPressed === 'backspace' || keyPressed === 'delete')) // If being cleared from keyboard, don't change behaviour
        setClearingFromIcon(false);
    };
    const ICON_PADDING = 2;
    const GRID_SIZE = 8;
    const l10n = (0, $cK9J2.createLocalizationProvider)(locale);
    const { styles: selectStyles = {}, ...otherSelectProps } = selectProps;
    const SelectComponent = timeIsEditable ? (0, $kVcjU.default) : (0, $c4OV1.default);
    /**
   * There are multiple props that can change how the time is formatted.
   * The priority of props used is:
   *   1. formatDisplayLabel
   *   2. timeFormat
   *   3. locale
   */ const formatTime = (time)=>{
        if (formatDisplayLabel) return formatDisplayLabel(time, timeFormat || (0, $RoXqn.defaultTimeFormat));
        const date = (0, $kdGko.default)(time);
        if (!(date instanceof Date)) return '';
        if (!(0, $dBLX0.default)(date)) return time;
        if (timeFormat) return (0, $57raR.default)(date, (0, $5PwWU.convertTokens)(timeFormat));
        return l10n.formatTime(date);
    };
    const options = times.map((time)=>{
        return {
            label: formatTime(time),
            value: time
        };
    });
    let initialValue;
    if (providedValue !== null && providedValue !== undefined && providedValue !== '') initialValue = {
        label: formatTime(providedValue),
        value: providedValue
    };
    else if (providedValue !== '' && value) initialValue = {
        label: formatTime(value),
        value: value
    };
    else initialValue = null;
    const SingleValue = (0, $7OE9J.makeSingleValue)({
        lang: locale
    });
    const selectComponents = {
        DropdownIndicator: (0, $RoXqn.EmptyComponent),
        Menu: (0, $icQS1.FixedLayerMenu),
        SingleValue: SingleValue,
        ...hideIcon && {
            ClearIndicator: (0, $RoXqn.EmptyComponent)
        }
    };
    const renderIconContainer = Boolean(!hideIcon && value);
    // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $e9zKl.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base
            }),
        menu: (base)=>({
                ...base,
                ...$bbd2b423b4bc9ae0$var$menuStyles,
                // Fixed positioned elements no longer inherit width from their parent, so we must explicitly set the
                // menu width to the width of our container
                width: containerRef ? containerRef.getBoundingClientRect().width : 'auto'
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: renderIconContainer ? ICON_PADDING : 0,
                paddingRight: renderIconContainer ? GRID_SIZE - ICON_PADDING : 0
            })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        ...innerProps,
        ref: setInternalContainerRef,
        "data-testid": testId && `${testId}--container`,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                name: name,
                type: "hidden",
                value: value,
                "data-testid": testId && `${testId}--input`,
                onKeyDown: onSelectKeyDown
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)(SelectComponent, {
                "aria-describedby": ariaDescribedBy,
                "aria-label": label || undefined,
                appearance: appearance,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                // @ts-ignore - Type mismatch with components - workaround for help-center local consumption
                components: selectComponents,
                inputId: id,
                isClearable: true,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: isOpen && !isDisabled,
                menuPlacement: "auto",
                openMenuOnFocus: true,
                onBlur: onBlur,
                onCreateOption: onCreateOption,
                // @ts-ignore - Type mismatch with onChange handler - workaround for help-center local consumption
                onChange: onChange,
                options: options,
                onFocus: onFocus,
                onMenuOpen: onMenuOpen,
                onMenuClose: onMenuClose,
                placeholder: placeholder || l10n.formatTime((0, $RoXqn.placeholderDatetime)),
                // @ts-ignore - Type mismatch with styles config - workaround for help-center local consumption
                styles: mergedStyles,
                value: initialValue,
                spacing: spacing,
                // We need this to get things to work, even though it's not supported.
                // @ts-ignore
                fixedLayerRef: containerRef,
                isInvalid: isInvalid,
                testId: testId,
                ...otherSelectProps
            })
        ]
    });
});
var $bbd2b423b4bc9ae0$export$2e2bcd8739ae039 = $bbd2b423b4bc9ae0$var$TimePicker;

});
parcelRegister("kVcjU", function(module, exports) {
$parcel$export(module.exports, "default", () => $a77c87292d58cd15$export$2e2bcd8739ae039);

var $dSBuj = parcelRequire("dSBuj");

var $dDv66 = parcelRequire("dDv66");
const $a77c87292d58cd15$var$CreatableSelect = (0, $dDv66.default)((0, $dSBuj.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a77c87292d58cd15$export$2e2bcd8739ae039 = $a77c87292d58cd15$var$CreatableSelect;

});
parcelRegister("dSBuj", function(module, exports) {
$parcel$export(module.exports, "default", () => $bfa75c11ff37aa8b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useCreatable", () => (parcelRequire("9gNEN")).default);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5tlgh = parcelRequire("5tlgh");

var $9gNEN = parcelRequire("9gNEN");

var $gVVTN = parcelRequire("gVVTN");
const $bfa75c11ff37aa8b$var$CreatableSelect = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const creatableProps = (0, $gVVTN.default)(props);
    const selectProps = (0, $9gNEN.default)(creatableProps);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5tlgh.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bfa75c11ff37aa8b$export$2e2bcd8739ae039 = $bfa75c11ff37aa8b$var$CreatableSelect;

});
parcelRegister("9gNEN", function(module, exports) {
$parcel$export(module.exports, "default", () => $59d3993c69e6bf3a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $20dEN = parcelRequire("20dEN");

var $gNnQq = parcelRequire("gNnQq");
const $59d3993c69e6bf3a$var$compareOption = (inputValue = '', option, accessors)=>{
    const candidate = String(inputValue).toLowerCase();
    const optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    const optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
const $59d3993c69e6bf3a$var$builtins = {
    formatCreateLabel: (inputValue)=>`Create "${inputValue}"`,
    isValidNewOption: (inputValue, selectValue, selectOptions, accessors)=>!(!inputValue || selectValue.some((option)=>$59d3993c69e6bf3a$var$compareOption(inputValue, option, accessors)) || selectOptions.some((option)=>$59d3993c69e6bf3a$var$compareOption(inputValue, option, accessors))),
    getNewOptionData: (inputValue, optionLabel)=>({
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        })
};
function $59d3993c69e6bf3a$export$2e2bcd8739ae039({ allowCreateWhileLoading: allowCreateWhileLoading = false, createOptionPosition: createOptionPosition = 'last', formatCreateLabel: formatCreateLabel = $59d3993c69e6bf3a$var$builtins.formatCreateLabel, isValidNewOption: isValidNewOption = $59d3993c69e6bf3a$var$builtins.isValidNewOption, getNewOptionData: //@ts-ignore
getNewOptionData = $59d3993c69e6bf3a$var$builtins.getNewOptionData, onCreateOption: onCreateOption, options: propsOptions = [], onChange: propsOnChange, ...restSelectProps }) {
    const { getOptionValue: getOptionValue = (0, $20dEN.getOptionValue), getOptionLabel: getOptionLabel = (0, $20dEN.getOptionLabel), inputValue: inputValue, isLoading: isLoading, isMulti: isMulti, value: value, name: name } = restSelectProps;
    const newOption = (0, $eJOHy.useMemo)(()=>isValidNewOption(inputValue, (0, $gNnQq.cleanValue)(value), propsOptions, {
            getOptionValue: getOptionValue,
            getOptionLabel: getOptionLabel
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel,
        getOptionValue,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    const options = (0, $eJOHy.useMemo)(()=>(allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption,
            ...propsOptions
        ] : [
            ...propsOptions,
            newOption
        ] : propsOptions, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    const onChange = (0, $eJOHy.useCallback)((newValue, actionMeta)=>{
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        const valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                const newOptionData = getNewOptionData(inputValue, inputValue);
                const newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $gNnQq.valueTernary)(isMulti, [
                    ...(0, $gNnQq.cleanValue)(value),
                    newOptionData
                ], newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return {
        ...restSelectProps,
        options: options,
        onChange: onChange
    };
}

});



parcelRegister("icQS1", function(module, exports) {
$parcel$export(module.exports, "FixedLayerMenu", () => $c710cd93a504ed53$export$982ad994195b4356);
/* fixed-layer-menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6XEne = parcelRequire("6XEne");

var $7G7nX = parcelRequire("7G7nX");
const $c710cd93a504ed53$export$982ad994195b4356 = ({ className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getValue: getValue, hasValue: hasValue, innerProps: innerProps, innerRef: innerRef, isLoading: isLoading, isMulti: isMulti, isRtl: isRtl, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, minMenuHeight: minMenuHeight, options: options, placement: placement, selectOption: selectOption, selectProps: selectProps, setValue: setValue, children: children, ...rest })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $7G7nX.default), {
        inputValue: selectProps.inputValue,
        //@ts-ignore react-select unsupported props
        containerRef: selectProps.fixedLayerRef,
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).Menu, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: innerProps,
            innerRef: innerRef,
            isLoading: isLoading,
            isMulti: isMulti,
            isRtl: isRtl,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView,
            minMenuHeight: minMenuHeight,
            options: options,
            placement: placement,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            children: children
        }),
        //@ts-ignore react-select unsupported props
        testId: selectProps.testId
    });

});

parcelRegister("kdGko", function(module, exports) {
$parcel$export(module.exports, "default", () => $f14a3d51f762a0dc$export$2e2bcd8739ae039);
const $f14a3d51f762a0dc$var$map24 = {
    '12': '12',
    '01': '13',
    '02': '14',
    '03': '15',
    '04': '16',
    '05': '17',
    '06': '18',
    '07': '19',
    '08': '20',
    '09': '21',
    '10': '22',
    '11': '23'
};
function $f14a3d51f762a0dc$export$1ea939691cdc45b8(timeString) {
    /**
	 * Regex match for `12:34`, `12:34:56`, `1:23:56 p`, `1:23:56PM`, and a bit more…
	 */ const time = timeString.trim().match(/([012]?[\d])(?::([0-5][\d]))?(?::([0-5][\d]))?\s*([ap]m?)?/i);
    /**
	 * Regex match for `1234`, `12:34`, `12.34`, `123456`, `12:34:56`, `12.34.56`
	 */ const time24hr = timeString.trim().match(/([012][\d])[:.]?([0-5][\d])([:.]?([0-5][\d]))?/);
    /**
	 * Convert `2:34:56 pm` down to `23456`
	 */ const num = timeString.replace(/[^0-9]/g, '');
    const includesSeconds = time && time[1] !== undefined && time[2] !== undefined && time[3] !== undefined || time24hr && time24hr[1] !== undefined && time24hr[2] !== undefined && time24hr[4] !== undefined;
    if (!time && !time24hr) return false;
    if (time && !time[1]) return false;
    if (num.length > 6) return false;
    if (num.length > 4 && !includesSeconds) return false;
    if (num.length === 2 && parseInt(num, 10) > 12) return false;
    return true;
}
function $f14a3d51f762a0dc$export$49c81d9f91c512ce(time) {
    return time.replace(/[:.]/g, '');
}
function $f14a3d51f762a0dc$var$formatSemi24(time) {
    if (time.length === 1) return `0${time}00`;
    if (time.length === 2) return `${time}00`;
    if (time.length === 3 || time.length === 5) return `0${time}`;
    return time;
}
function $f14a3d51f762a0dc$var$checkHour(hour, meridiem) {
    if (hour > '24') return null;
    if (hour === '12' && meridiem === 'a') return '00';
    if (hour < '12' && meridiem === 'p') return $f14a3d51f762a0dc$var$map24[hour];
    return hour;
}
function $f14a3d51f762a0dc$var$checkMinuteSecond(value) {
    if (value > '59') return null;
    return value;
}
function $f14a3d51f762a0dc$export$6137ce2c9c5166bb(time) {
    const timeArray = time.toLowerCase().split(/(p|a)/i);
    const meridiem = timeArray[1];
    const semi24 = $f14a3d51f762a0dc$var$formatSemi24(timeArray[0].trim());
    const hour = $f14a3d51f762a0dc$var$checkHour(semi24.substring(0, 2), meridiem);
    const minute = $f14a3d51f762a0dc$var$checkMinuteSecond(semi24.substring(2, 4));
    const seconds = semi24.length === 6 && $f14a3d51f762a0dc$var$checkMinuteSecond(semi24.substring(4, 6));
    if (!hour || !minute) return null;
    return {
        hour: parseInt(hour, 10),
        minute: parseInt(minute, 10),
        seconds: parseInt(seconds || '0', 10) || 0
    };
}
function $f14a3d51f762a0dc$var$assignToDate(time) {
    const dateTime = new Date();
    dateTime.setHours(time.hour);
    dateTime.setMinutes(time.minute);
    // milliseconds is not supported
    dateTime.setSeconds(time.seconds || 0, 0);
    return dateTime;
}
function $f14a3d51f762a0dc$export$2e2bcd8739ae039(time) {
    const trimmedTime = time.toString().trim();
    if (!$f14a3d51f762a0dc$export$1ea939691cdc45b8(trimmedTime)) throw RangeError('invalid time format');
    const time1 = $f14a3d51f762a0dc$export$49c81d9f91c512ce(trimmedTime);
    const time2 = $f14a3d51f762a0dc$export$6137ce2c9c5166bb(time1);
    if (!time2) throw RangeError('invalid time format');
    return $f14a3d51f762a0dc$var$assignToDate(time2);
}

});



parcelRegister("1Mlgx", function(module, exports) {
$parcel$export(module.exports, "Toggle", () => $2f54da15d97b525f$export$bea8ebba691c5813);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8CBYv = parcelRequire("8CBYv");

var $8AppO = parcelRequire("8AppO");
const $2f54da15d97b525f$export$bf0162d825d6e13 = {
    size: true,
    testId: true,
    defaultChecked: true,
    isChecked: true,
    label: true
};
const $2f54da15d97b525f$export$bea8ebba691c5813 = (props)=>{
    const { size: size, testId: testId, defaultChecked: defaultChecked, isChecked: isChecked, label: label, id: // Field props
    id, isDisabled: isDisabled, onChange: onChange, onBlur: onBlur, onFocus: onFocus, value: value, name: name } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8CBYv.default), {
        size: size,
        testId: testId,
        defaultChecked: defaultChecked,
        isChecked: isChecked,
        label: label,
        // Field props
        id: id,
        isDisabled: isDisabled,
        onChange: (0, $8AppO.adaptEventHandler)(onChange),
        onBlur: (0, $8AppO.adaptEventHandler)(onBlur),
        onFocus: (0, $8AppO.adaptEventHandler)(onFocus),
        value: value,
        name: name
    });
}; /**
 * @codegenEnd
 */ 

});
parcelRegister("8CBYv", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b71259385cf6352$export$2e2bcd8739ae039);
/* toggle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");

var $gl2vi = parcelRequire("gl2vi");

var $6XkOW = parcelRequire("6XkOW");

var $5wxTT = parcelRequire("5wxTT");

var $eGOwo = parcelRequire("eGOwo");

var $7ep4S = parcelRequire("7ep4S");

var $6fs4r = parcelRequire("6fs4r");

var $hqCmO = parcelRequire("hqCmO");
const $8b71259385cf6352$var$LOADING_LABEL = ', Loading';
const $8b71259385cf6352$var$basicStyles = null;
const $8b71259385cf6352$var$iconStyles = null;
const $8b71259385cf6352$var$sizeStyles = {
    regular: "_2rkopxbi _4t3ipxbi _1bsbxy5q _kfgtutpp _1mp41crf _p9c41fbe",
    large: "_2rkov47k _4t3iv47k _1bsb1jfw _kfgtpxbi _1mp47vkz _p9c4w12q"
};
const $8b71259385cf6352$var$noop = (0, $3Vuhz.default);
const $8b71259385cf6352$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $8b71259385cf6352$var$iconSizeMap = {
    regular: 'small',
    large: 'medium'
}; /**
    * __Toggle__
    *
    * A toggle is used to view or switch between enabled or disabled states.
    *
    * - [Examples](https://atlassian.design/components/toggle/examples)
    * - [Code](https://atlassian.design/components/toggle/code)
    * - [Usage](https://atlassian.design/components/toggle/usage)
    */ 
const $8b71259385cf6352$var$Toggle = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $8b71259385cf6352$var$noop, onChange: providedChange = $8b71259385cf6352$var$noop, onFocus: providedFocus = $8b71259385cf6352$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, isLoading: isLoading, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $eJOHy.useState)(defaultChecked);
    const loadingLabelId = (0, $gl2vi.useId)();
    const handleBlur = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: providedOnBlur,
        action: 'blur',
        analyticsData: analyticsContext,
        ...$8b71259385cf6352$var$analyticsAttributes
    });
    const handleFocus = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$8b71259385cf6352$var$analyticsAttributes
    });
    const handleChange = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$8b71259385cf6352$var$analyticsAttributes
    });
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined
    };
    const legacyIconSize = $8b71259385cf6352$var$iconSizeMap[size];
    const labelId = (0, $gl2vi.useId)();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("label", {
        ...controlProps,
        className: (0, $hcewu.default)([
            "_v564kete _1h6d3acm _1dqonqa1 _189e1dm9 _1e0c1o8l _vchh18uv _kqswh2mm _1y1m1ntv _bfhk76s1 _syaz5w2r _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5v77o _1q51v77o _y4tiv77o _bozgv77o _1i2uidpf _1i3tidpf _se28idpf _3tunidpf _1423idpf _1hrtidpf _1bz2idpf _rqfvidpf _1yc0glyw _onsr1snc _1vgmagmp _1av610yn _1ulhidpf _rfx31qll _pdykkete _1cs8stnw _1rus5w2r _1kt9b3bt _1fkr1y44 _z5wt1y44 _7dwzglyw _1ys4194a _krlfnqa1 _ju3ddkaa _1bki1y1w _1flt1y1w _3xv21y1w _9471g4a2 _ucab5w2r _mqf815t7 _3dj215t7 _1dl915t7 _1div5w2r _1il8kb7n _y54d5w2r _irr353wy _d0altlke _19ja13gf _8muf13gf _1k1q13gf _1plud4ly _1uo853wy _178c1y1w _16rslghj _i5ec1w7i",
            size === 'large' && !(0, $eGOwo.fg)('platform-visual-refresh-icons') && "_1n82gktf _19vpgktf",
            $8b71259385cf6352$var$sizeStyles[size]
        ]),
        children: [
            label ? /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                id: labelId,
                hidden: true,
                children: isLoading ? `${label}${$8b71259385cf6352$var$LOADING_LABEL}` : label
            }) : null,
            /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                ref: ref,
                checked: shouldChecked,
                disabled: isDisabled,
                id: id,
                name: name,
                onBlur: handleBlur,
                onChange: handleChange,
                onFocus: handleFocus,
                type: "checkbox",
                value: value,
                "data-testid": testId && `${testId}--input`,
                "aria-labelledby": isLoading && label ? `${labelId} ${loadingLabelId}` : label ? labelId : undefined,
                "aria-describedby": descriptionId
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hqCmO.default), {
                size: size,
                isHidden: !shouldChecked,
                position: "left",
                children: isLoading && shouldChecked ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                    size: "xsmall",
                    appearance: "invert"
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6XkOW))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-check-icon`,
                    size: "small"
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hqCmO.default), {
                size: size,
                isHidden: shouldChecked,
                position: "right",
                children: isLoading && !shouldChecked ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                    size: "xsmall",
                    appearance: "invert"
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5wxTT))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-cross-icon`,
                    size: "small"
                })
            }),
            isLoading && !label && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6fs4r.default), {
                id: loadingLabelId,
                children: $8b71259385cf6352$var$LOADING_LABEL
            })
        ]
    });
}));
$8b71259385cf6352$var$Toggle.displayName = 'Toggle';
var $8b71259385cf6352$export$2e2bcd8739ae039 = $8b71259385cf6352$var$Toggle;

});
parcelRegister("hqCmO", function(module, exports) {
$parcel$export(module.exports, "default", () => $d938694e808b84dc$export$2e2bcd8739ae039);
/* icon-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");
const $d938694e808b84dc$var$styles = {
    iconContainer: "_v5641hrg _1e0c116y _4cvr1h6o _1bah1h6o _kqswstnw _152tv77o",
    iconContainerRegular: "_1bsb7vkz _4t3i7vkz",
    iconContainerLarge: "_1bsbgktf _4t3igktf",
    hidden: "_tzy4idpf",
    left: "_1e021l7b",
    right: "_rjxp1l7b"
};
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $d938694e808b84dc$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "span",
        xcss: (0, $6qaBj.cx)($d938694e808b84dc$var$styles.iconContainer, isHidden && (0, $eGOwo.fg)('platform-visual-refresh-icons') && $d938694e808b84dc$var$styles.hidden, size === 'regular' && $d938694e808b84dc$var$styles.iconContainerRegular, size === 'large' && $d938694e808b84dc$var$styles.iconContainerLarge, position === 'left' && $d938694e808b84dc$var$styles.left, position === 'right' && $d938694e808b84dc$var$styles.right),
        children: children
    });
};
var $d938694e808b84dc$export$2e2bcd8739ae039 = $d938694e808b84dc$var$IconContainer;

});



parcelRegister("1pn5e", function(module, exports) {
$parcel$export(module.exports, "Tooltip", () => $b3e93ee9937a8de4$export$28c660c63b792dea);
/**
 * Excluded props to simplify API:
 * - strategy
 * - hideTooltipOnClick
 * - hideTooltipOnMouseDown
 * - onHide
 * - onShow
 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");
const $b3e93ee9937a8de4$export$bf0162d825d6e13 = {
    children: true,
    position: true,
    mousePosition: true,
    content: true,
    truncate: true,
    testId: true,
    delay: true,
    onShow: false,
    onHide: false,
    hideTooltipOnClick: false,
    hideTooltipOnMouseDown: false,
    strategy: false
};
const $b3e93ee9937a8de4$export$28c660c63b792dea = (props)=>{
    const { position: position, mousePosition: mousePosition, content: content, truncate: truncate, testId: testId, delay: delay } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                children: props.render(c)
            }, c.key)),
        position: position,
        mousePosition: mousePosition,
        content: content,
        truncate: truncate,
        testId: testId,
        delay: delay
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("1amvD", function(module, exports) {
$parcel$export(module.exports, "ValidMessage", () => $4e7083afe3806532$export$5505afb209a532c8);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $fKXve = parcelRequire("fKXve");
const $4e7083afe3806532$export$bf0162d825d6e13 = {
    children: true,
    testId: true
};
const $4e7083afe3806532$export$5505afb209a532c8 = (props)=>{
    const { testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fKXve.ValidMessage), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                children: props.render(c)
            }, c.key)),
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("bEvoj", function(module, exports) {
$parcel$export(module.exports, "forgePropsAreEqual", () => $1747149061b34b01$export$5d1c9ea31ee6a28f);
/**
 * this function assume the inputs are not same object, and hence
 * it doesn't check for reference equality.
 *
 * Additionally, it check keys of the object and then check the values
 * for better performance.
 */ const $1747149061b34b01$var$objectValuesAreEqual = (prev, next, valuesAreEqual)=>{
    const keys = Object.keys(prev);
    const length = keys.length;
    if (length !== Object.keys(next).length) return false;
    // there are two small optimization techniques used in this file:
    // 1. using decrementing for loop instead of incrementing for loop,
    //    to reduce 1 instruction per iteration.
    // 2. for object equality check, we check the key match first and then
    //    the value match. This is to identify the inequality as soon as possible.
    for(let i = length; i-- !== 0;){
        if (!(keys[i] in next)) return false;
    }
    for(let i = length; i-- !== 0;){
        const key = keys[i];
        if (!valuesAreEqual(prev[key], next[key])) return false;
    }
    return true;
};
/**
 * Some of the ideas are based on https://github.com/FormidableLabs/react-fast-compare
 */ const $1747149061b34b01$var$forgeDocPropValuesAreEqual = (prev, next)=>{
    if (prev === next) return true;
    else if (!prev || !next) return false;
    else if (typeof prev === 'function' && typeof next === 'function') // if the function is a crossDomainFunctionWrapper (i.e. post-bot),
    // then we can check if the function is the same by looking at the
    // __id__ property.
    return prev.__id__ === next.__id__;
    else if (typeof prev === 'object' && typeof next === 'object') {
        if (prev.constructor !== next.constructor) return false;
        else if (Array.isArray(prev)) {
            const length = prev.length;
            if (length !== next.length) return false;
            for(let i = length; i-- !== 0;){
                if (!$1747149061b34b01$var$forgeDocPropValuesAreEqual(prev[i], next[i])) return false;
            }
            return true;
        } else if (prev.valueOf !== Object.prototype.valueOf && typeof prev.valueOf === 'function' && typeof next.valueOf === 'function') return prev.valueOf() === next.valueOf();
        else if (prev.toString !== Object.prototype.toString && typeof prev.toString === 'function' && typeof next.toString === 'function') return prev.toString() === next.toString();
        return $1747149061b34b01$var$objectValuesAreEqual(prev, next, $1747149061b34b01$var$forgeDocPropValuesAreEqual);
    }
    return false;
};
const $1747149061b34b01$var$forgeDocPropsAreEqual = (prev, next)=>{
    if (prev === next) return true;
    else if (!prev || !next) return false;
    return $1747149061b34b01$var$objectValuesAreEqual(prev, next, $1747149061b34b01$var$forgeDocPropValuesAreEqual);
};
/**
 * the function is used to cache the hasChanged value in the ForgeDoc.
 * Please note, the cached result need to be stored in the next prop not the prev prop.
 * This is because react internally caches the props, and the cache become stale
 * at every render, if the calculation depends on the prev prop, the stale cache
 * will impact the accuracy of the result.
 */ const $1747149061b34b01$var$cacheForgeDocHasChanged = (nextDoc, hasChanged)=>{
    nextDoc.hasChanged = hasChanged;
    return !hasChanged;
};
const $1747149061b34b01$var$forgeDocsAreEqual = (prev, next)=>{
    if (next.hasChanged !== undefined) return !next.hasChanged;
    else if (prev === next) return $1747149061b34b01$var$cacheForgeDocHasChanged(next, false);
    else if (!prev || !next) return next ? $1747149061b34b01$var$cacheForgeDocHasChanged(next, true) : false;
    if (prev.type !== next.type || prev.key !== next.key) return $1747149061b34b01$var$cacheForgeDocHasChanged(next, true);
    else if (prev.children !== next.children) {
        if (prev.children?.length !== next.children?.length) return $1747149061b34b01$var$cacheForgeDocHasChanged(next, true);
        const length = prev.children?.length ?? 0;
        for(let i = length; i-- !== 0;){
            if (!$1747149061b34b01$var$forgeDocsAreEqual(prev.children[i], next.children[i])) return $1747149061b34b01$var$cacheForgeDocHasChanged(next, true);
        }
    }
    return $1747149061b34b01$var$cacheForgeDocHasChanged(next, !$1747149061b34b01$var$forgeDocPropsAreEqual(prev.props, next.props));
};
const $1747149061b34b01$export$5d1c9ea31ee6a28f = (prev, next)=>$1747149061b34b01$var$forgeDocsAreEqual(prev.forgeDoc, next.forgeDoc);

});


parcelRegister("lfx7V", function(module, exports) {
$parcel$export(module.exports, "importMapChartsMemo", () => $35275f80d844d353$export$534226a750271d58);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $c8xtS = parcelRequire("c8xtS");
var $I1vLj = parcelRequire("I1vLj");
var $PUNWB = parcelRequire("PUNWB");
var $ehSwd = parcelRequire("ehSwd");
var $eNBDU = parcelRequire("eNBDU");
var $bvE9g = parcelRequire("bvE9g");
var $7Ra7U = parcelRequire("7Ra7U");

var $bEvoj = parcelRequire("bEvoj");
const $35275f80d844d353$export$7cbf6225478f6479 = {
    BarChart: (args)=>/*#__PURE__*/ (0, $gt9Am.jsx)($c8xtS.BarChart, {
            ...args
        }),
    StackBarChart: (args)=>/*#__PURE__*/ (0, $gt9Am.jsx)($7Ra7U.StackBarChart, {
            ...args
        }),
    HorizontalStackBarChart: (args)=>/*#__PURE__*/ (0, $gt9Am.jsx)($ehSwd.HorizontalStackBarChart, {
            ...args
        }),
    HorizontalBarChart: (args)=>/*#__PURE__*/ (0, $gt9Am.jsx)($PUNWB.HorizontalBarChart, {
            ...args
        }),
    LineChart: (args)=>/*#__PURE__*/ (0, $gt9Am.jsx)($eNBDU.LineChart, {
            ...args
        }),
    PieChart: (args)=>/*#__PURE__*/ (0, $gt9Am.jsx)($bvE9g.PieChart, {
            ...args
        }),
    DonutChart: (args)=>/*#__PURE__*/ (0, $gt9Am.jsx)($I1vLj.DonutChart, {
            ...args
        })
};
const $35275f80d844d353$export$534226a750271d58 = Object.entries($35275f80d844d353$export$7cbf6225478f6479).reduce((agg, [key, Component])=>{
    agg[key] = /*#__PURE__*/ (0, $eJOHy.memo)(Component, (0, $bEvoj.forgePropsAreEqual));
    return agg;
}, {});

});
parcelRegister("c8xtS", function(module, exports) {
$parcel$export(module.exports, "BarChart", () => $c24d62721e7b8f7d$export$94aefc399ef206a9);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aJxrb = parcelRequire("aJxrb");

const $c24d62721e7b8f7d$var$PlatformBarChart = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("j9Hl5")).then((module)=>({
            default: module.BarChart
        })));

const $c24d62721e7b8f7d$var$Title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("j9Hl5")).then((module)=>({
            default: module.BarChart.elements.Title
        })));

const $c24d62721e7b8f7d$var$SubTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("j9Hl5")).then((module)=>({
            default: module.BarChart.elements.SubTitle
        })));
const $c24d62721e7b8f7d$var$BaseBarChart = (props)=>{
    const { width: width, height: height, data: data, xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor, title: title, subtitle: subtitle } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)($c24d62721e7b8f7d$var$PlatformBarChart, {
        width: width,
        height: height ? height : 400,
        data: data,
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        colorAccessor: colorAccessor,
        children: [
            title && /*#__PURE__*/ (0, $gt9Am.jsx)($c24d62721e7b8f7d$var$Title, {
                children: title
            }),
            subtitle && /*#__PURE__*/ (0, $gt9Am.jsx)($c24d62721e7b8f7d$var$SubTitle, {
                children: subtitle
            })
        ]
    });
};
const $c24d62721e7b8f7d$export$94aefc399ef206a9 = (0, $aJxrb.withConfluenceStyleWrapper)($c24d62721e7b8f7d$var$BaseBarChart);

});
parcelRegister("aJxrb", function(module, exports) {
$parcel$export(module.exports, "withConfluenceStyleWrapper", () => $d59c4b8e8d732aad$export$579859975dfcad56);
/* confluenceStyleWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $e3ekx = parcelRequire("e3ekx");

var $7rhaX = parcelRequire("7rhaX");
// This overrides Confluence webpack styling that affects chart components in confluence modules
const $d59c4b8e8d732aad$var$chartStyle = null;
// Styling override in Safari for UI Kit chart y-axis (axis-left) label that gets overlapped by chart plot.
// (See https://ecosystem-platform.atlassian.net/browse/EXT-3078)
const $d59c4b8e8d732aad$var$safariChartStyle = null;
const $d59c4b8e8d732aad$export$579859975dfcad56 = (ChartComponent)=>{
    return function ConfluenceStyleWrapper(props) {
        const isConfluenceModule = (0, $7rhaX.useIsConfluenceModule)();
        return isConfluenceModule ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            className: (0, $hcewu.default)([
                "_1hur1o8v _15ywze3t _xlx2ze3t _ohs2131l _v8kv1o8v _1t4h131l _12r8nbxd _tc2g1gjq _1prk2smr _1x821gjq _59ea1vhk _9y82ze3t _7ve0ze3t _zi1a131l _125ipxbi",
                (0, $e3ekx.isSafari)() && "_15xdc38t"
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(ChartComponent, {
                ...props
            })
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)(ChartComponent, {
            ...props
        });
    };
};

});
parcelRegister("e3ekx", function(module, exports) {
$parcel$export(module.exports, "isSafari", () => $7853b790472beeee$export$95df08bae54cb4df);
const $7853b790472beeee$export$95df08bae54cb4df = ()=>{
    if (typeof window !== 'undefined' && window.navigator != null) {
        const ua = window.navigator.userAgent?.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
};

});

parcelRegister("7rhaX", function(module, exports) {
$parcel$export(module.exports, "useIsConfluenceModule", () => $883f3d3b74e840c7$export$ad87aa198ab86978);

var $eJOHy = parcelRequire("eJOHy");

var $kpjEk = parcelRequire("kpjEk");
const $883f3d3b74e840c7$export$ad87aa198ab86978 = ()=>{
    const { extensionType: extensionType } = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $kpjEk.RendererContext));
    return extensionType === 'xen:macro' || !!extensionType?.startsWith('confluence');
};

});


parcelRegister("j9Hl5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6YqGY").then(()=>parcelRequire('8EvCY'));

});


parcelRegister("I1vLj", function(module, exports) {
$parcel$export(module.exports, "DonutChart", () => $21bf9bccaa447113$export$533707e2f61b59ec);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aJxrb = parcelRequire("aJxrb");

const $21bf9bccaa447113$var$PlatformDonutChart = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("j9Hl5")).then((module)=>({
            default: module.DonutChart
        })));

const $21bf9bccaa447113$var$Title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("j9Hl5")).then((module)=>({
            default: module.DonutChart.elements.Title
        })));

const $21bf9bccaa447113$var$SubTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("j9Hl5")).then((module)=>({
            default: module.DonutChart.elements.SubTitle
        })));

const $21bf9bccaa447113$var$MarkLabels = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("j9Hl5")).then((module)=>({
            default: module.DonutChart.elements.MarkLabels
        })));
const $21bf9bccaa447113$var$BaseDonutChart = (props)=>{
    const { width: width, height: height, data: data, colorAccessor: colorAccessor, labelAccessor: labelAccessor, valueAccessor: valueAccessor, title: title, subtitle: subtitle, showMarkLabels: showMarkLabels, innerRadius: innerRadius, outerRadius: outerRadius } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)($21bf9bccaa447113$var$PlatformDonutChart, {
        width: width,
        height: height ? height : 400,
        data: data,
        colorAccessor: colorAccessor,
        valueAccessor: valueAccessor,
        labelAccessor: labelAccessor,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)($21bf9bccaa447113$var$MarkLabels, {
                hide: !showMarkLabels
            }),
            title && /*#__PURE__*/ (0, $gt9Am.jsx)($21bf9bccaa447113$var$Title, {
                children: title
            }),
            subtitle && /*#__PURE__*/ (0, $gt9Am.jsx)($21bf9bccaa447113$var$SubTitle, {
                children: subtitle
            })
        ]
    });
};
const $21bf9bccaa447113$export$533707e2f61b59ec = (0, $aJxrb.withConfluenceStyleWrapper)($21bf9bccaa447113$var$BaseDonutChart);

});

parcelRegister("PUNWB", function(module, exports) {
$parcel$export(module.exports, "HorizontalBarChart", () => $faa6ee6ad7dac38b$export$2d84115b1316e023);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aJxrb = parcelRequire("aJxrb");

const $faa6ee6ad7dac38b$var$PlatformHorizontalBarChart = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("j9Hl5")).then((module)=>({
            default: module.HorizontalBarChart
        })));

const $faa6ee6ad7dac38b$var$Title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("j9Hl5")).then((module)=>({
            default: module.HorizontalBarChart.elements.Title
        })));

const $faa6ee6ad7dac38b$var$SubTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("j9Hl5")).then((module)=>({
            default: module.HorizontalBarChart.elements.SubTitle
        })));
const $faa6ee6ad7dac38b$var$BaseHorizontalBarChart = (props)=>{
    const { width: width, height: height, data: data, xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor, title: title, subtitle: subtitle } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)($faa6ee6ad7dac38b$var$PlatformHorizontalBarChart, {
        width: width,
        height: height ? height : 400,
        data: data,
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        colorAccessor: colorAccessor,
        children: [
            title && /*#__PURE__*/ (0, $gt9Am.jsx)($faa6ee6ad7dac38b$var$Title, {
                children: title
            }),
            subtitle && /*#__PURE__*/ (0, $gt9Am.jsx)($faa6ee6ad7dac38b$var$SubTitle, {
                children: subtitle
            })
        ]
    });
};
const $faa6ee6ad7dac38b$export$2d84115b1316e023 = (0, $aJxrb.withConfluenceStyleWrapper)($faa6ee6ad7dac38b$var$BaseHorizontalBarChart);

});

parcelRegister("ehSwd", function(module, exports) {
$parcel$export(module.exports, "HorizontalStackBarChart", () => $544ccb3e3dac126b$export$68d163a36b4f8e7c);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aJxrb = parcelRequire("aJxrb");

const $544ccb3e3dac126b$var$PlatformHorizontalStackBarChart = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("j9Hl5")).then((module)=>({
            default: module.HorizontalStackBarChart
        })));

const $544ccb3e3dac126b$var$Title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("j9Hl5")).then((module)=>({
            default: module.HorizontalStackBarChart.elements.Title
        })));

const $544ccb3e3dac126b$var$SubTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("j9Hl5")).then((module)=>({
            default: module.HorizontalStackBarChart.elements.SubTitle
        })));
const $544ccb3e3dac126b$var$BaseHorizontalStackBarChart = (props)=>{
    const { width: width, height: height, data: data, xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor, title: title, subtitle: subtitle } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)($544ccb3e3dac126b$var$PlatformHorizontalStackBarChart, {
        width: width,
        height: height ? height : 400,
        data: data,
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        colorAccessor: colorAccessor,
        children: [
            title && /*#__PURE__*/ (0, $gt9Am.jsx)($544ccb3e3dac126b$var$Title, {
                children: title
            }),
            subtitle && /*#__PURE__*/ (0, $gt9Am.jsx)($544ccb3e3dac126b$var$SubTitle, {
                children: subtitle
            })
        ]
    });
};
const $544ccb3e3dac126b$export$68d163a36b4f8e7c = (0, $aJxrb.withConfluenceStyleWrapper)($544ccb3e3dac126b$var$BaseHorizontalStackBarChart);

});

parcelRegister("eNBDU", function(module, exports) {
$parcel$export(module.exports, "LineChart", () => $9c14892907952687$export$54d0e8420ac838ac);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aJxrb = parcelRequire("aJxrb");

const $9c14892907952687$var$PlatformLineChart = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("j9Hl5")).then((module)=>({
            default: module.LineChart
        })));

const $9c14892907952687$var$Title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("j9Hl5")).then((module)=>({
            default: module.LineChart.elements.Title
        })));

const $9c14892907952687$var$SubTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("j9Hl5")).then((module)=>({
            default: module.LineChart.elements.SubTitle
        })));
const $9c14892907952687$var$BaseLineChart = (props)=>{
    const { width: width, height: height, data: data, xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor, title: title, subtitle: subtitle } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)($9c14892907952687$var$PlatformLineChart, {
        width: width,
        height: height ? height : 400,
        data: data,
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        colorAccessor: colorAccessor,
        children: [
            title && /*#__PURE__*/ (0, $gt9Am.jsx)($9c14892907952687$var$Title, {
                children: title
            }),
            subtitle && /*#__PURE__*/ (0, $gt9Am.jsx)($9c14892907952687$var$SubTitle, {
                children: subtitle
            })
        ]
    });
};
const $9c14892907952687$export$54d0e8420ac838ac = (0, $aJxrb.withConfluenceStyleWrapper)($9c14892907952687$var$BaseLineChart);

});

parcelRegister("bvE9g", function(module, exports) {
$parcel$export(module.exports, "PieChart", () => $95e57cb102b6375d$export$b99d3348f709c998);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aJxrb = parcelRequire("aJxrb");

const $95e57cb102b6375d$var$PlatformPieChart = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("j9Hl5")).then((module)=>({
            default: module.PieChart
        })));

const $95e57cb102b6375d$var$Title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("j9Hl5")).then((module)=>({
            default: module.PieChart.elements.Title
        })));

const $95e57cb102b6375d$var$SubTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("j9Hl5")).then((module)=>({
            default: module.PieChart.elements.SubTitle
        })));

const $95e57cb102b6375d$var$MarkLabels = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("j9Hl5")).then((module)=>({
            default: module.PieChart.elements.MarkLabels
        })));
const $95e57cb102b6375d$var$BasePieChart = (props)=>{
    const { width: width, height: height, data: data, colorAccessor: colorAccessor, labelAccessor: labelAccessor, valueAccessor: valueAccessor, title: title, subtitle: subtitle, showMarkLabels: showMarkLabels } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)($95e57cb102b6375d$var$PlatformPieChart, {
        width: width,
        height: height ? height : 400,
        data: data,
        colorAccessor: colorAccessor,
        valueAccessor: valueAccessor,
        labelAccessor: labelAccessor,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)($95e57cb102b6375d$var$MarkLabels, {
                hide: !showMarkLabels
            }),
            title && /*#__PURE__*/ (0, $gt9Am.jsx)($95e57cb102b6375d$var$Title, {
                children: title
            }),
            subtitle && /*#__PURE__*/ (0, $gt9Am.jsx)($95e57cb102b6375d$var$SubTitle, {
                children: subtitle
            })
        ]
    });
};
const $95e57cb102b6375d$export$b99d3348f709c998 = (0, $aJxrb.withConfluenceStyleWrapper)($95e57cb102b6375d$var$BasePieChart);

});

parcelRegister("7Ra7U", function(module, exports) {
$parcel$export(module.exports, "StackBarChart", () => $b824adb8077f0ec6$export$a0048b2d4c7b0c89);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aJxrb = parcelRequire("aJxrb");

const $b824adb8077f0ec6$var$PlatformStackBarChart = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("j9Hl5")).then((module)=>({
            default: module.StackBarChart
        })));

const $b824adb8077f0ec6$var$Title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("j9Hl5")).then((module)=>({
            default: module.StackBarChart.elements.Title
        })));

const $b824adb8077f0ec6$var$SubTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("j9Hl5")).then((module)=>({
            default: module.StackBarChart.elements.SubTitle
        })));
const $b824adb8077f0ec6$var$BaseStackBarChart = (props)=>{
    const { width: width, height: height, data: data, xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor, title: title, subtitle: subtitle } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)($b824adb8077f0ec6$var$PlatformStackBarChart, {
        width: width,
        height: height ? height : 400,
        data: data,
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        colorAccessor: colorAccessor,
        children: [
            title && /*#__PURE__*/ (0, $gt9Am.jsx)($b824adb8077f0ec6$var$Title, {
                children: title
            }),
            subtitle && /*#__PURE__*/ (0, $gt9Am.jsx)($b824adb8077f0ec6$var$SubTitle, {
                children: subtitle
            })
        ]
    });
};
const $b824adb8077f0ec6$export$a0048b2d4c7b0c89 = (0, $aJxrb.withConfluenceStyleWrapper)($b824adb8077f0ec6$var$BaseStackBarChart);

});



parcelRegister("j1aXw", function(module, exports) {
$parcel$export(module.exports, "FrameCount", () => $c8d9d4b0c44e1549$export$61945ff869c3ddb);
$parcel$export(module.exports, "default", () => $c8d9d4b0c44e1549$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $c8d9d4b0c44e1549$export$61945ff869c3ddb = /*#__PURE__*/ (0, $eJOHy.createContext)({
    frameCount: 0,
    setFrameCount: ()=>{}
});
const $c8d9d4b0c44e1549$var$FrameCountProvider = ({ children: children })=>{
    const [frameCount, setFrameCount] = (0, $eJOHy.useState)(0);
    const value = {
        frameCount: frameCount,
        setFrameCount: setFrameCount
    };
    (0, $eJOHy.useEffect)(()=>{
        if (frameCount > 1) throw new Error('Max limit of one frame component per module.');
    }, [
        frameCount
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($c8d9d4b0c44e1549$export$61945ff869c3ddb.Provider, {
        value: value,
        children: children
    });
};
var $c8d9d4b0c44e1549$export$2e2bcd8739ae039 = $c8d9d4b0c44e1549$var$FrameCountProvider;

});

parcelRegister("j05LD", function(module, exports) {
$parcel$export(module.exports, "useSendRendererRenderedAnalytics", () => $0d80c93ef0a70747$export$1e4237f96323a8a1);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $cOZrT = parcelRequire("cOZrT");

var $6yq62 = parcelRequire("6yq62");
const $0d80c93ef0a70747$export$1e4237f96323a8a1 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { page: source } = (0, $6yq62.useMetricsContext)();
    (0, $eJOHy.useEffect)(()=>{
        (0, $cOZrT.trackRendererRendered)(createAnalyticsEvent, {
            source: source,
            target: 'renderer'
        });
    });
};

});


parcelRegister("c05dT", function(module, exports) {
$parcel$export(module.exports, "makeUser", () => $7d9e4a9a034c75f5$export$4e4c41e4152a9f8a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");

var $a5I65 = parcelRequire("a5I65");

var $7rgPd = parcelRequire("7rgPd");

var $8IVtX = parcelRequire("8IVtX");
var $5DgXR = parcelRequire("5DgXR");

var $7q9BG = parcelRequire("7q9BG");
const $7d9e4a9a034c75f5$var$containerStyle = null;
const $7d9e4a9a034c75f5$var$messages = (0, $7qGN1.defineMessages)({
    unknownUser: {
        id: 'confluence.user.unknown.user.message',
        defaultMessage: 'Unknown User',
        description: 'This is a fallback message that displays when a username is not known.'
    }
});
const $7d9e4a9a034c75f5$var$Avatar = ({ name: name, picture: picture, hideDisplayName: hideDisplayName })=>{
    if (hideDisplayName) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5DgXR.default), {
        name: name,
        src: picture
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // Reduce Atlaskit padding to vertically-align with other components
        className: (0, $hcewu.default)([
            "_1gzjidpf _1plv18uv _1r3373ad"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IVtX.default), {
            avatar: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5DgXR.default), {
                name: name,
                src: picture
            }),
            primaryText: name
        })
    });
};
function $7d9e4a9a034c75f5$var$UserInline({ name: name }) {
    const intl = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7q9BG.default), {
        appearance: "primary",
        children: name || intl.formatMessage($7d9e4a9a034c75f5$var$messages.unknownUser)
    });
}
const $7d9e4a9a034c75f5$var$User = ({ accountId: accountId, client: client, hideDisplayName: hideDisplayName })=>{
    const { picture: picture, name: name } = (0, $a5I65.useUser)(accountId, client);
    const { inline: inline } = (0, $7rgPd.useInlineContext)();
    if (!picture && !name) return null;
    if (inline) return /*#__PURE__*/ (0, $gt9Am.jsx)($7d9e4a9a034c75f5$var$UserInline, {
        name: name
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)($7d9e4a9a034c75f5$var$Avatar, {
        name: name,
        picture: picture,
        hideDisplayName: hideDisplayName
    });
};
const $7d9e4a9a034c75f5$export$4e4c41e4152a9f8a = ({ client: client })=>{
    return function UserFnNext({ forgeDoc: { props: props } }) {
        const { accountId: accountId, hideDisplayName: hideDisplayName } = props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)($7d9e4a9a034c75f5$var$User, {
            accountId: accountId,
            client: client,
            hideDisplayName: hideDisplayName
        });
    };
};

});
parcelRegister("a5I65", function(module, exports) {
$parcel$export(module.exports, "useUsers", () => $2aed8c91b8726c4a$export$90f4370c54dd43c9);
$parcel$export(module.exports, "useUser", () => $2aed8c91b8726c4a$export$23bbbc4533528f03);

var $1fMqv = parcelRequire("1fMqv");

var $kuAvn = parcelRequire("kuAvn");

var $cwqPy = parcelRequire("cwqPy");
const $2aed8c91b8726c4a$export$25f4d46d5dabadfc = (0, $kuAvn.default)`
	query forge_ui_userQuery($accountId: ID!) {
		user(accountId: $accountId) {
			name
			picture
		}
	}
`;
const $2aed8c91b8726c4a$export$ef7fb495aeba8901 = (0, $kuAvn.default)`
	query forge_ui_usersQuery($accountIds: [ID!]!) {
		users(accountIds: $accountIds) {
			name
			accountId
			picture
		}
	}
`;
const $2aed8c91b8726c4a$export$90f4370c54dd43c9 = (accountIds, client)=>{
    const nonEmptyAccountIds = accountIds.filter((id)=>!(id === ''));
    const { data: data } = (0, $1fMqv.useQuery)($2aed8c91b8726c4a$export$ef7fb495aeba8901, {
        variables: {
            accountIds: nonEmptyAccountIds
        },
        client: client,
        context: {
            headers: {
                'atl-attribution': (0, $cwqPy.createAtlAttributionHeader)()
            }
        }
    });
    let users = {};
    if (data && data.users) users = data.users.reduce((prev, user)=>{
        if (user.accountId) prev[user.accountId] = {
            picture: user.picture,
            accountId: user.accountId,
            name: user.name
        };
        return prev;
    }, {});
    return users;
};
const $2aed8c91b8726c4a$export$23bbbc4533528f03 = (accountId, client)=>{
    const { data: data } = (0, $1fMqv.useQuery)($2aed8c91b8726c4a$export$25f4d46d5dabadfc, {
        variables: {
            accountId: accountId
        },
        skip: !accountId,
        client: client,
        context: {
            headers: {
                'atl-attribution': (0, $cwqPy.createAtlAttributionHeader)()
            }
        }
    });
    if (data && data.user) {
        const { picture: picture, name: name } = data.user;
        return {
            name: name,
            picture: picture
        };
    }
    return {
        name: '',
        picture: ''
    };
};

});

parcelRegister("8IVtX", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c75ba3e928cc567$export$2e2bcd8739ae039);
/* avatar-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $3cMgR = parcelRequire("3cMgR");

var $j8kj1 = parcelRequire("j8kj1");
const $5c75ba3e928cc567$var$bgColorCssVar = '--avatar-item-bg-color';
const $5c75ba3e928cc567$var$styles = {
    root: "_2rkofajl _12ji1r31 _1qu2glyw _12y31o36 _4bfu18uv _1hmsglyw _ajmmnqa1 _1h6d3acm _1dqonqa1 _189e1dm9 _1e0c1txw _vchhusvi _1bsb1osq _4cvr1h6o _bfhk1g13 _syaz1kw7 _1wyb1kw7 _zg8l4jg8 _k48pi7a9 _vwz4kb7n _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i51b66 _1q511b66 _y4ti1b66 _bozg1b66 _y3gn1e5h",
    rootDisabled: "_80om13gf _tzy41e4z _lcxvglyw",
    rootInteractive: "_nt751r31 _49pcglyw _1hvw1o36 _858u194a _9oik18uv _1bnxglyw _jf4cnqa1 _irr314ae _d0altlke _1di61l7b",
    avatarItem: "_16jlkb7n _1o9zkb7n _i0dl1osq _1ul9idpf _p12f1osq _vwz419ii _bozgu2gc",
    baseText: "_1e0c1ule _syaz1fxt",
    truncation: "_1reo15vq _1bto1l2s _o5721q9c",
    secondaryTextLegacy: "_syaz131l _1wyb181o"
};
/**
 * __Avatar item__
 *
 * An avatar item is a wrapper that goes around an avatar when it's displayed alongside text, such as a name or status.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-item/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-item/code)
 */ const $5c75ba3e928cc567$var$AvatarItem = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ avatar: avatar, backgroundColor: backgroundColor = 'transparent', isTruncationDisabled: isTruncationDisabled, href: href, isDisabled: isDisabled, onClick: onClick, primaryText: primaryText, secondaryText: secondaryText, target: target, testId: testId, label: label }, ref)=>{
    const Container = (0, $j8kj1.getCustomElement)(isDisabled, href, onClick);
    const isInteractive = Boolean(onClick || href);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)(Container, {
        style: {
            [$5c75ba3e928cc567$var$bgColorCssVar]: backgroundColor
        },
        ref: ref,
        "aria-label": isInteractive ? label : undefined,
        onClick: onClick,
        disabled: isDisabled,
        "data-testid": testId ? `${testId}--itemInner` : undefined,
        type: Container === 'button' ? 'button' : undefined,
        ...href && {
            href: href,
            target: target,
            rel: target === '_blank' ? 'noopener noreferrer' : undefined
        },
        className: (0, $hcewu.default)([
            $5c75ba3e928cc567$var$styles.root,
            isInteractive && $5c75ba3e928cc567$var$styles.rootInteractive,
            isDisabled && $5c75ba3e928cc567$var$styles.rootDisabled
        ]),
        children: [
            avatar,
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    $5c75ba3e928cc567$var$styles.avatarItem
                ]),
                children: (0, $eGOwo.fg)('platform.design-system-team.avatar-item-font-size_830x6') ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                            maxLines: isTruncationDisabled ? undefined : 1,
                            children: primaryText
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                            color: "color.text.subtlest",
                            maxLines: isTruncationDisabled ? undefined : 1,
                            size: "UNSAFE_small",
                            children: secondaryText
                        })
                    ]
                }) : /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            className: (0, $hcewu.default)([
                                $5c75ba3e928cc567$var$styles.baseText,
                                !isTruncationDisabled && $5c75ba3e928cc567$var$styles.truncation
                            ]),
                            children: primaryText
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            className: (0, $hcewu.default)([
                                $5c75ba3e928cc567$var$styles.baseText,
                                $5c75ba3e928cc567$var$styles.secondaryTextLegacy,
                                !isTruncationDisabled && $5c75ba3e928cc567$var$styles.truncation
                            ]),
                            children: secondaryText
                        })
                    ]
                })
            })
        ]
    });
});
$5c75ba3e928cc567$var$AvatarItem.displayName = 'AvatarItem';
var $5c75ba3e928cc567$export$2e2bcd8739ae039 = $5c75ba3e928cc567$var$AvatarItem;

});
parcelRegister("j8kj1", function(module, exports) {
$parcel$export(module.exports, "getCustomElement", () => $a0d6c3f6d2433409$export$83ee468102cdf04c);
$parcel$export(module.exports, "getAppearanceForAppType", () => $a0d6c3f6d2433409$export$6b45b5bd2259198a);
const $a0d6c3f6d2433409$export$83ee468102cdf04c = (isDisabled, href, onClick)=>{
    if (href && !isDisabled) return 'a';
    if (onClick || isDisabled) return 'button';
    return 'span';
};
function $a0d6c3f6d2433409$export$6b45b5bd2259198a(appType) {
    switch(appType){
        case 'agent':
            return 'hexagon';
        case 'user':
        case 'system':
        default:
            return 'circle';
    }
}

});


parcelRegister("5DgXR", function(module, exports) {
$parcel$export(module.exports, "default", () => $f07091e9efaebfd0$export$2e2bcd8739ae039);
/* avatar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $ftN6c = parcelRequire("ftN6c");

var $gl2vi = parcelRequire("gl2vi");

var $iwbbq = parcelRequire("iwbbq");

var $l8fMV = parcelRequire("l8fMV");

var $fXN6p = parcelRequire("fXN6p");

var $1vYnd = parcelRequire("1vYnd");

var $bLsBv = parcelRequire("bLsBv");

var $j8kj1 = parcelRequire("j8kj1");
const $f07091e9efaebfd0$var$packageName = "platform-pkg";
const $f07091e9efaebfd0$var$packageVersion = "0.0.0-use.local";
const $f07091e9efaebfd0$var$containerStyles = null; // eslint-disable-next-line @repo/internal/react/consistent-types-definitions
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ const $f07091e9efaebfd0$var$Avatar = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ analyticsContext: analyticsContext, appearance: appearance = 'circle', label: label, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, name: name, onClick: onClick, presence: presence, size: sizeProp, src: src, stackIndex: stackIndex, status: status, target: target, testId: testId, as: AvatarContainer = 'div', isDecorative: isDecorative = false, imgLoading: imgLoading }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const context = (0, $l8fMV.useAvatarContext)();
    const size = sizeProp || context?.size || 'medium';
    const customPresenceNode = /*#__PURE__*/ (0, $eJOHy.isValidElement)(presence) ? presence : null;
    const customStatusNode = /*#__PURE__*/ (0, $eJOHy.isValidElement)(status) ? status : null;
    const isValidIconSize = size !== 'xxlarge' && size !== 'xsmall';
    const lastAnalytics = (0, $eJOHy.useRef)(analyticsContext);
    const labelId = (0, $gl2vi.useId)();
    (0, $eJOHy.useEffect)(()=>{
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    const onClickHandler = (0, $eJOHy.useCallback)((event)=>{
        if (isDisabled || typeof onClick !== 'function') return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'avatar',
            attributes: {
                componentName: 'avatar',
                packageName: $f07091e9efaebfd0$var$packageName,
                packageVersion: $f07091e9efaebfd0$var$packageVersion
            }
        }); /**
         * To avoid wrapping this component in AnalyticsContext we manually
         * push the parent context's meta data into the context.
         */ 
        const context = {
            componentName: 'avatar',
            packageName: $f07091e9efaebfd0$var$packageName,
            packageVersion: $f07091e9efaebfd0$var$packageVersion,
            ...lastAnalytics.current
        };
        analyticsEvent.context.push(context); /**
                                           * Replicating the logic in the `withAnalyticsEvents` HOC.
                                           */ 
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    const isPresence = isValidIconSize && presence && !status;
    const isStatus = isValidIconSize && status; // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    const defaultLabel = [
        name,
        isStatus && !customStatusNode && `(${status})`,
        isPresence && !customPresenceNode && `(${presence})`
    ].filter(Boolean).join(' ');
    const isInteractive = onClick || href || isDisabled;
    const containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l8fMV.EnsureIsInsideAvatarContext).Provider, {
        value: true,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)(AvatarContainer, {
            "data-testid": testId,
            role: containerShouldBeImage ? 'img' : undefined,
            "aria-labelledby": containerShouldBeImage && !isDecorative ? labelId : undefined,
            style: {
                zIndex: stackIndex
            },
            className: (0, $hcewu.default)([
                "_12ji1r31 _1qu2glyw _12y3idpf _1e0c1o8l _kqswh2mm"
            ]),
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l8fMV.AvatarContentContext).Provider, {
                    value: {
                        as: (0, $j8kj1.getCustomElement)(isDisabled, href, onClick),
                        appearance: appearance,
                        borderColor: borderColor,
                        href: href,
                        isDisabled: isDisabled,
                        label: label || defaultLabel,
                        onClick: isInteractive ? onClickHandler : undefined,
                        ref: ref,
                        size: size,
                        stackIndex: stackIndex,
                        target: target,
                        testId: testId ? `${testId}--inner` : undefined,
                        avatarImage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fXN6p.default), {
                            alt: !containerShouldBeImage && src ? name : undefined,
                            src: src,
                            appearance: appearance,
                            size: size,
                            testId: testId,
                            imgLoading: imgLoading
                        })
                    },
                    children: children || /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iwbbq.AvatarContent), {})
                }),
                isPresence && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1vYnd.PresenceWrapper), {
                    appearance: appearance,
                    size: size,
                    presence: typeof presence === 'string' ? presence : undefined,
                    testId: testId,
                    children: customPresenceNode
                }),
                isStatus && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bLsBv.StatusWrapper), {
                    appearance: appearance,
                    size: size,
                    borderColor: borderColor,
                    status: typeof status === 'string' ? status : undefined,
                    testId: testId,
                    children: customStatusNode
                }),
                containerShouldBeImage ? /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                    "data-testid": testId && `${testId}--label`,
                    id: labelId,
                    hidden: true,
                    children: defaultLabel
                }) : undefined
            ]
        })
    });
});
$f07091e9efaebfd0$var$Avatar.displayName = 'Avatar';
var $f07091e9efaebfd0$export$2e2bcd8739ae039 = $f07091e9efaebfd0$var$Avatar;

});
parcelRegister("iwbbq", function(module, exports) {
$parcel$export(module.exports, "AvatarContent", () => $8203d1394f4a7c47$export$47fbc0b44cae5559);
/* avatar-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $l8fMV = parcelRequire("l8fMV");
const $8203d1394f4a7c47$var$boxShadowCssVar = '--avatar-box-shadow';
const $8203d1394f4a7c47$var$bgColorCssVar = '--avatar-bg-color';
const $8203d1394f4a7c47$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk18uv _aetrf705 _1peqidpf _11fnglyw _1ejjglyw _mizu194a _1ah3v77o _ra3xnqa1 _128mdkaa _4dave4h9",
    circle: "_2rko1qll _14mj1qll",
    square: "_2rkol0p1",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peqs237"
};
const $8203d1394f4a7c47$var$unboundStyles = {
    root: "_vchh18uv _bfhkcxp3 _16qs1nhn",
    hexagonFocusContainer: "_1rjc1wgn _18zr1dm9 _1mou5h37 _bfhk18uv _mkrz1k6g _1o9o1p6i",
    hexagonBorderContainer: "_1rjcf6hp _18zruxly _bfhkcxp3 _mkrz1kw7 _1o9ovuon",
    hexagon: "_2rkoidpf _mkrz1kw7 _16qsn7od _14mjidpf _1ejjn7od _128midpf _4davidpf",
    interactive: "_80omtlke _4tpuw83z _ez1ykb7n _gcm11et6 _eeh8kb7n _jlxit94y"
};
const $8203d1394f4a7c47$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $8203d1394f4a7c47$var$marginAdjustmentMap = {
    xsmall: "_195gcwjc",
    small: "_195gcwjc",
    medium: "_195gs7t4",
    large: "_195gs7t4",
    xlarge: "_195g8ocb",
    xxlarge: "_195g1ukp"
};
const $8203d1394f4a7c47$var$borderRadiusMap = {
    xsmall: "_2rkolb4i _14mjlb4i",
    small: "_2rkolb4i _14mjlb4i",
    medium: "_2rko12b0 _14mj12b0",
    large: "_2rko12b0 _14mj12b0",
    xlarge: "_2rko1qi0 _14mj1qi0",
    xxlarge: "_2rkopb1k _14mjpb1k"
};
const $8203d1394f4a7c47$export$47fbc0b44cae5559 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children }, ref)=>{
    (0, $l8fMV.useEnsureIsInsideAvatar)();
    const { as: Container, appearance: appearance, avatarImage: avatarImage, borderColor: borderColor = "var(--ds-surface, #FFFFFF)", href: href, isDisabled: isDisabled, label: label, onClick: onClick, ref: contextRef, tabIndex: tabIndex, target: target, testId: testId, size: size, stackIndex: stackIndex } = (0, $l8fMV.useAvatarContent)();
    const isInteractive = Boolean(onClick || href || isDisabled);
    const renderedContent = /*#__PURE__*/ (0, $gt9Am.jsx)(Container, {
        style: {
            [$8203d1394f4a7c47$var$bgColorCssVar]: borderColor,
            [$8203d1394f4a7c47$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        ref: ref || contextRef,
        "aria-label": isInteractive ? label : undefined,
        onClick: onClick,
        tabIndex: tabIndex,
        "data-testid": testId,
        disabled: isDisabled,
        type: Container === 'button' ? 'button' : undefined,
        ...href && {
            href: href,
            target: target,
            rel: target === '_blank' ? 'noopener noreferrer' : undefined
        },
        className: (0, $hcewu.default)([
            $8203d1394f4a7c47$var$unboundStyles.root,
            $8203d1394f4a7c47$var$styles.root,
            !(0, $eGOwo.fg)('platform_dst_avatar_tile') && $8203d1394f4a7c47$var$borderRadiusMap[size],
            appearance === 'square' && (0, $eGOwo.fg)('platform_dst_avatar_tile') && $8203d1394f4a7c47$var$styles.square,
            appearance === 'circle' && $8203d1394f4a7c47$var$styles.circle,
            appearance === 'hexagon' && $8203d1394f4a7c47$var$unboundStyles.hexagon,
            $8203d1394f4a7c47$var$widthHeightMap[size],
            stackIndex !== undefined && $8203d1394f4a7c47$var$styles.positionRelative,
            isInteractive && !isDisabled && $8203d1394f4a7c47$var$unboundStyles.interactive,
            isDisabled && $8203d1394f4a7c47$var$styles.disabled
        ]),
        children: children || avatarImage
    });
    if (appearance !== 'hexagon') return renderedContent;
    // For a Hexagon Avatar in order to have hexagonal "border" and "outline", we have to
    // layer multiple elements and use their background colors to create the different layers.
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            [$8203d1394f4a7c47$var$bgColorCssVar]: borderColor,
            [$8203d1394f4a7c47$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        "data-testid": testId ? `${testId}-hexagon-focus-container` : 'hexagon-focus-container',
        className: (0, $hcewu.default)([
            $8203d1394f4a7c47$var$unboundStyles.hexagonFocusContainer,
            $8203d1394f4a7c47$var$marginAdjustmentMap[size]
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": testId ? `${testId}-hexagon-border-container` : 'hexagon-border-container',
            className: (0, $hcewu.default)([
                $8203d1394f4a7c47$var$unboundStyles.hexagonBorderContainer
            ]),
            children: renderedContent
        })
    });
});

});
parcelRegister("l8fMV", function(module, exports) {
$parcel$export(module.exports, "AvatarContext", () => $db36d751aea51dd5$export$a20dad690e1279e2);
$parcel$export(module.exports, "useAvatarContext", () => $db36d751aea51dd5$export$b50b87a1c4086b23);
$parcel$export(module.exports, "AvatarContentContext", () => $db36d751aea51dd5$export$b983474ddd0b6d28);
$parcel$export(module.exports, "useAvatarContent", () => $db36d751aea51dd5$export$79d078b69b7e4842);
$parcel$export(module.exports, "EnsureIsInsideAvatarContext", () => $db36d751aea51dd5$export$6b4cbd90d24955ad);
$parcel$export(module.exports, "useEnsureIsInsideAvatar", () => $db36d751aea51dd5$export$7db5c57474082dd9);

var $eJOHy = parcelRequire("eJOHy");
const $db36d751aea51dd5$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $db36d751aea51dd5$export$b50b87a1c4086b23 = ()=>(0, $eJOHy.useContext)($db36d751aea51dd5$export$a20dad690e1279e2);
const $db36d751aea51dd5$var$defaultAvatarContentProps = {
    as: 'span',
    appearance: 'circle',
    avatarImage: null,
    ref: null,
    size: 'medium'
};
const $db36d751aea51dd5$export$b983474ddd0b6d28 = /*#__PURE__*/ (0, $eJOHy.createContext)($db36d751aea51dd5$var$defaultAvatarContentProps);
const $db36d751aea51dd5$export$79d078b69b7e4842 = ()=>(0, $eJOHy.useContext)($db36d751aea51dd5$export$b983474ddd0b6d28);
const $db36d751aea51dd5$export$6b4cbd90d24955ad = /*#__PURE__*/ (0, $eJOHy.createContext)(false);
const $db36d751aea51dd5$export$7db5c57474082dd9 = ()=>{
    const context = (0, $eJOHy.useContext)($db36d751aea51dd5$export$6b4cbd90d24955ad);
    if (!context) throw new Error('Avatar sub-components must be used within a Avatar component.');
};

});


parcelRegister("fXN6p", function(module, exports) {
$parcel$export(module.exports, "default", () => $ecc568d6eea7f169$export$2e2bcd8739ae039);
/* avatar-image.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $fIzTE = parcelRequire("fIzTE");

var $58frP = parcelRequire("58frP");

var $6aKac = parcelRequire("6aKac");
const $ecc568d6eea7f169$var$styles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq",
    icon: "_1e0c1txw _1bsb1osq _4t3i1osq _bfhk1v33",
    circle: "_2rko1rr0",
    hexagon: "_mkrz1k6g"
};
const $ecc568d6eea7f169$var$borderRadiusMap = {
    xsmall: "_2rkolb4i",
    small: "_2rkolb4i",
    medium: "_2rko12b0",
    large: "_2rko12b0",
    xlarge: "_2rko1qi0",
    xxlarge: "_2rkopb1k"
};
const $ecc568d6eea7f169$var$nestedSvgStylesMap = {
    xsmall: "_w8l57vkz _17527vkz",
    small: "_w8l51tcg _17521tcg",
    medium: "_w8l5zwfg _1752zwfg",
    large: "_w8l51ylp _17521ylp",
    xlarge: "_w8l516xz _175216xz",
    xxlarge: "_w8l51qr7 _17521qr7"
};
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ const $ecc568d6eea7f169$var$AvatarImage = ({ alt: alt = '', src: src, appearance: appearance, size: size, testId: testId, imgLoading: imgLoading })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $eJOHy.useState)(false);
    // If src changes, reset state
    (0, $eJOHy.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) {
        let renderedIcon;
        switch(appearance){
            case 'circle':
                renderedIcon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($58frP))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #626F86)",
                    testId: testId && `${testId}--person`,
                    spacing: "spacious",
                    LEGACY_secondaryColor: "var(--ds-icon-subtle, #626F86)"
                });
                break;
            case 'hexagon':
                renderedIcon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fIzTE))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #626F86)",
                    testId: testId && `${testId}--agent`,
                    spacing: "spacious"
                });
                break;
            default:
            case 'square':
                renderedIcon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6aKac))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #626F86)",
                    testId: testId && `${testId}--ship`,
                    spacing: "spacious",
                    LEGACY_secondaryColor: "var(--ds-icon-subtle, #626F86)"
                });
                break;
        }
        return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            className: (0, $hcewu.default)([
                $ecc568d6eea7f169$var$styles.icon,
                $ecc568d6eea7f169$var$nestedSvgStylesMap[size]
            ]),
            children: renderedIcon
        });
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
        loading: imgLoading,
        src: src,
        alt: alt,
        "data-testid": testId && `${testId}--image`,
        onError: ()=>setHasImageErrored(true),
        "aria-hidden": !alt ? true : undefined,
        "data-vc": testId ? `${testId}--image` : 'avatar-image',
        "data-ssr-placeholder-ignored": true,
        className: (0, $hcewu.default)([
            $ecc568d6eea7f169$var$styles.image,
            $ecc568d6eea7f169$var$borderRadiusMap[size],
            appearance === 'circle' && $ecc568d6eea7f169$var$styles.circle,
            appearance === 'hexagon' && $ecc568d6eea7f169$var$styles.hexagon
        ])
    });
};
var $ecc568d6eea7f169$export$2e2bcd8739ae039 = $ecc568d6eea7f169$var$AvatarImage;

});

parcelRegister("1vYnd", function(module, exports) {
$parcel$export(module.exports, "default", () => $f037724b2472c000$export$2e2bcd8739ae039);
$parcel$export(module.exports, "PresenceWrapper", () => $f037724b2472c000$export$972c5e90200fa0ef);
/* presence.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");


var $25TOm = parcelRequire("25TOm");
const $f037724b2472c000$var$BusyIndicator = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
    children: [
        /*#__PURE__*/ (0, $gt9Am.jsx)("circle", {
            fill: `var(--ds-icon-danger, ${(0, $7bb4c1736002a04a$export$4a7404f376229999)})`,
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fill: `var(--ds-surface-overlay, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
            d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
        })
    ]
});
const $f037724b2472c000$var$FocusIndicator = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
    children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
        fill: `var(--ds-icon-discovery, ${(0, $7bb4c1736002a04a$export$b48405b95304b5a1)})`,
        d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
    })
});
const $f037724b2472c000$var$OfflineIndicator = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
    children: [
        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fill: `var(--ds-text-subtlest, ${(0, $7bb4c1736002a04a$export$f563ee71e9ee74cd)})`,
            d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
        }),
        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fill: `var(--ds-surface-overlay, ${(0, $7bb4c1736002a04a$export$1ce2d1575d444ceb)})`,
            d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
        })
    ]
});
const $f037724b2472c000$var$OnlineIndicator = /*#__PURE__*/ (0, $gt9Am.jsx)("circle", {
    fill: `var(--ds-icon-success, ${(0, $7bb4c1736002a04a$export$940e1f69e873f202)})`,
    cx: "4",
    cy: "4",
    r: "4"
});
function $f037724b2472c000$var$getPresence(presence) {
    switch(presence){
        case 'busy':
            return $f037724b2472c000$var$BusyIndicator;
        case 'focus':
            return $f037724b2472c000$var$FocusIndicator;
        case 'offline':
            return $f037724b2472c000$var$OfflineIndicator;
        case 'online':
            return $f037724b2472c000$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ const $f037724b2472c000$var$AvatarPresence = ({ borderColor: borderColor, children: children, presence: presence })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $25TOm.default), {
        bgColor: borderColor,
        children: presence ? /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
            height: "100%",
            version: "1.1",
            viewBox: "0 0 8 8",
            width: "100%",
            xmlns: "http://www.w3.org/2000/svg",
            children: $f037724b2472c000$var$getPresence(presence)
        }) : children
    });
var $f037724b2472c000$export$2e2bcd8739ae039 = $f037724b2472c000$var$AvatarPresence;
const $f037724b2472c000$var$styles = {
    root: "_kqswstnw _lcxvglyw"
};
const $f037724b2472c000$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
const $f037724b2472c000$var$circleIconOffsetMap = {
    small: "_94n5idpf _1xi2idpf",
    medium: "_94n5idpf _1xi2idpf",
    large: "_94n5t94y _1xi2t94y",
    xlarge: "_94n51v6z _1xi21v6z"
};
const $f037724b2472c000$var$squareIconOffsetMap = {
    root: "_94n5myb0 _1xi2myb0"
};
const $f037724b2472c000$var$hexagonIconOffsetMap = {
    small: "_94n51n1a _1xi21n1a",
    medium: "_94n51n1a _1xi21n1a",
    large: "_94n51y44 _1xi2myb0",
    xlarge: "_94n5l52n _1xi21lpd"
};
const $f037724b2472c000$export$972c5e90200fa0ef = ({ size: size, appearance: appearance, children: children, borderColor: borderColor, presence: presence, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--presence`,
        className: (0, $hcewu.default)([
            $f037724b2472c000$var$styles.root,
            $f037724b2472c000$var$iconSizeMap[size],
            $f037724b2472c000$var$circleIconOffsetMap[size],
            appearance === 'square' && $f037724b2472c000$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $f037724b2472c000$var$hexagonIconOffsetMap[size]
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($f037724b2472c000$var$AvatarPresence, {
            borderColor: borderColor,
            presence: !children ? presence : undefined,
            children: children
        })
    });
};

});
parcelRegister("25TOm", function(module, exports) {
$parcel$export(module.exports, "default", () => $7047ac8a6cd37baf$export$2e2bcd8739ae039);
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $7047ac8a6cd37baf$var$styles = {
    root: "_2rko1qll _1reo15vq _18m915vq _189e1dm9 _1dqonqa1 _1e0c1txw _vchhusvi _1bsb1osq _4t3i1osq _4cvr1h6o _ae4v1h6o _bfhk1bhr"
};
const $7047ac8a6cd37baf$var$unboundStyles = {
    root: "_1h6d1bhr"
};
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ const $7047ac8a6cd37baf$var$IconWrapper = ({ bgColor: bgColor, children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        role: "presentation",
        style: {
            borderColor: bgColor,
            backgroundColor: bgColor
        },
        className: (0, $hcewu.default)([
            $7047ac8a6cd37baf$var$styles.root,
            $7047ac8a6cd37baf$var$unboundStyles.root
        ]),
        children: children
    });
var $7047ac8a6cd37baf$export$2e2bcd8739ae039 = $7047ac8a6cd37baf$var$IconWrapper;

});


parcelRegister("bLsBv", function(module, exports) {
$parcel$export(module.exports, "StatusWrapper", () => $bf1e9e3522c549b8$export$8045894f255f9726);
/* status.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");


var $25TOm = parcelRequire("25TOm");
const $bf1e9e3522c549b8$var$styles = {
    root: "_kqswstnw"
};
const $bf1e9e3522c549b8$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
const $bf1e9e3522c549b8$var$circleIconOffsetMap = {
    small: "_rjxpidpf _152tidpf",
    medium: "_rjxpidpf _152tidpf",
    large: "_rjxpt94y _152tt94y",
    xlarge: "_rjxp1v6z _152t1v6z"
};
const $bf1e9e3522c549b8$var$squareIconOffsetMap = {
    root: "_rjxpidpf _152tidpf"
};
const $bf1e9e3522c549b8$var$hexagonIconOffsetMap = {
    small: "_rjxp1n1a _152t1n1a",
    medium: "_rjxp1n1a _152t1n1a",
    large: "_rjxpmyb0 _152t1y44",
    xlarge: "_rjxp1lpd _152tl52n"
};
const $bf1e9e3522c549b8$var$ApprovedIndicator = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
    children: [
        /*#__PURE__*/ (0, $gt9Am.jsx)("circle", {
            fill: `var(--ds-icon-success, ${(0, $7bb4c1736002a04a$export$a49394138f7b8e85)})`,
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fill: `var(--ds-surface-overlay, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
            d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
        })
    ]
});
const $bf1e9e3522c549b8$var$DeclinedIndicator = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
    children: [
        /*#__PURE__*/ (0, $gt9Am.jsx)("circle", {
            fill: `var(--ds-icon-danger, ${(0, $7bb4c1736002a04a$export$2010d0fb4295b346)})`,
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fill: `var(--ds-surface-overlay, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
            d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
        })
    ]
});
const $bf1e9e3522c549b8$var$LockedIndicator = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
    children: [
        /*#__PURE__*/ (0, $gt9Am.jsx)("circle", {
            fill: `var(--ds-text-subtlest, ${(0, $7bb4c1736002a04a$export$1ce2d1575d444ceb)})`,
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fill: `var(--ds-surface-overlay, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`,
            d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
        })
    ]
});
function $bf1e9e3522c549b8$var$getStatus(status) {
    switch(status){
        case 'approved':
            return $bf1e9e3522c549b8$var$ApprovedIndicator;
        case 'declined':
            return $bf1e9e3522c549b8$var$DeclinedIndicator;
        case 'locked':
            return $bf1e9e3522c549b8$var$LockedIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ const $bf1e9e3522c549b8$var$AvatarStatus = ({ borderColor: borderColor, children: children, status: status })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $25TOm.default), {
        bgColor: borderColor,
        children: status ? /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
            height: "100%",
            version: "1.1",
            viewBox: "0 0 8 8",
            width: "100%",
            xmlns: "http://www.w3.org/2000/svg",
            children: $bf1e9e3522c549b8$var$getStatus(status)
        }) : children
    });
var $bf1e9e3522c549b8$export$2e2bcd8739ae039 = $bf1e9e3522c549b8$var$AvatarStatus;
const $bf1e9e3522c549b8$export$8045894f255f9726 = ({ size: size, status: status, appearance: appearance, borderColor: borderColor, children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--status`,
        className: (0, $hcewu.default)([
            $bf1e9e3522c549b8$var$styles.root,
            $bf1e9e3522c549b8$var$iconSizeMap[size],
            $bf1e9e3522c549b8$var$circleIconOffsetMap[size],
            appearance === 'square' && $bf1e9e3522c549b8$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $bf1e9e3522c549b8$var$hexagonIconOffsetMap[size]
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($bf1e9e3522c549b8$var$AvatarStatus, {
            borderColor: borderColor,
            status: !children ? status : undefined,
            children: children
        })
    });
};

});



parcelRegister("6siRN", function(module, exports) {
$parcel$export(module.exports, "makeUserGroup", () => $1aaeefa0a3756a54$export$30420ba0b3cd13e0);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $a5I65 = parcelRequire("a5I65");

var $7rgPd = parcelRequire("7rgPd");

const $1aaeefa0a3756a54$var$AKAvatarGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("eUSVc")));

const $1aaeefa0a3756a54$var$AKBadge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("dW7Vf")));
function $1aaeefa0a3756a54$export$a2cdaa6af5c46e54(users, accountIds, intl) {
    // order should match accountIds
    return accountIds.map((key)=>{
        const { name: name = intl.formatMessage($1aaeefa0a3756a54$var$messages.unknownUserMessage), picture: picture = '' } = users[key] || {};
        return {
            key: key,
            name: name,
            src: picture
        };
    });
}
function $1aaeefa0a3756a54$export$7962e827ea8ac95f({ data: data }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)($1aaeefa0a3756a54$var$AKAvatarGroup, {
        appearance: "stack",
        data: data
    });
}
function $1aaeefa0a3756a54$var$More({ data: data }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)($1aaeefa0a3756a54$var$AKBadge, {
        children: `+${data.length}`
    });
}
function $1aaeefa0a3756a54$export$82c3b28526691c79({ data: data }) {
    const end = Math.max(Math.min(8, data.length), 0); // 4 would be the same as AvatarStack
    const shown = data.slice(0, end);
    const more = data.slice(end);
    const hasMore = more.length > 0;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("span", {
        children: [
            shown.map(({ name: name }, i)=>{
                return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)($1aaeefa0a3756a54$var$AKBadge, {
                            appearance: "primary",
                            children: name
                        }),
                        hasMore || i !== end - 1 ? ' ' : null
                    ]
                });
            }),
            hasMore ? /*#__PURE__*/ (0, $gt9Am.jsx)($1aaeefa0a3756a54$var$More, {
                data: more
            }) : null
        ]
    });
}
// @ts-ignore setting z index to 0 so that the avatars do not overlap other components
const $1aaeefa0a3756a54$var$avatarStackWrapper = (0, $1DXK0.xcss)({
    zIndex: 0,
    position: 'relative'
});
function $1aaeefa0a3756a54$export$2e2bcd8739ae039({ accountIds: accountIds, client: client }) {
    const users = (0, $a5I65.useUsers)(accountIds, client);
    const intl = (0, $lRq8t.default)();
    const data = $1aaeefa0a3756a54$export$a2cdaa6af5c46e54(users, accountIds, intl);
    const { inline: inline } = (0, $7rgPd.useInlineContext)();
    if (inline) return /*#__PURE__*/ (0, $gt9Am.jsx)($1aaeefa0a3756a54$export$82c3b28526691c79, {
        data: data
    });
    return(// Each avatar in an avatar stack has a z index value applied.
    // Setting a container with a z index here to 0 so that the avatars do no overlap other components such as the Select menu
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        xcss: $1aaeefa0a3756a54$var$avatarStackWrapper,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($1aaeefa0a3756a54$export$7962e827ea8ac95f, {
            data: data
        })
    }));
}
function $1aaeefa0a3756a54$export$63abfa3ed5832db7({ children: children }) {
    const accountIds = children.map((child)=>{
        if (child.type !== 'User' && child.type !== 'Avatar') return '';
        const { props: props } = child;
        const { accountId: accountId } = props;
        return accountId;
    }).filter((x)=>x);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($1aaeefa0a3756a54$export$2e2bcd8739ae039, {
        accountIds: accountIds,
        client: undefined
    });
}
function $1aaeefa0a3756a54$export$30420ba0b3cd13e0({ client: client }) {
    return function avatarStackNext({ forgeDoc: { children: children } }) {
        const accountIds = children.map((child)=>{
            if (child.type !== 'User' && child.type !== 'Avatar') return '';
            const { props: props } = child;
            const { accountId: accountId } = props;
            return accountId;
        }).filter((x)=>x);
        return /*#__PURE__*/ (0, $gt9Am.jsx)($1aaeefa0a3756a54$export$2e2bcd8739ae039, {
            accountIds: accountIds,
            client: client
        });
    };
}
const $1aaeefa0a3756a54$var$messages = (0, $7qGN1.defineMessages)({
    unknownUserMessage: {
        id: 'confluence.user.group.unknown.user.message',
        defaultMessage: 'Unknown User',
        description: "This is a fallback message that is visible when a user's name is unknown."
    }
});

});
parcelRegister("eUSVc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hS8JC").then(()=>parcelRequire('1G0hy'));

});


parcelRegister("3k3Gm", function(module, exports) {
$parcel$export(module.exports, "makeNativeUserPicker", () => $8185e7c2bb331f27$export$57fb7dc1c2438e62);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $a5I65 = parcelRequire("a5I65");

var $d005z = parcelRequire("d005z");

var $6PxFA = parcelRequire("6PxFA");

// Format the values(UserData) returned from useUsers hook, to pass to defaultValue prop
const $8185e7c2bb331f27$var$hydrateDefaultValue = (users, isMulti = false)=>{
    const defaultValues = [];
    for(const userId in users){
        const { name: name, picture: picture } = users[userId];
        // Only grabbing the values where user name exist
        if (name) defaultValues.push({
            name: name,
            avatarUrl: picture,
            id: userId,
            type: 'user'
        });
    }
    return isMulti ? defaultValues : defaultValues[0];
};
const $8185e7c2bb331f27$var$UserPickerFn = ({ client: client, mentionProvider: mentionProvider, accountId: accountId, cloudId: cloudId, productAttributes: productAttributes, productKey: productKey, baseUrl: baseUrl, props: props })=>{
    const { name: name, label: label, placeholder: placeholder, description: description, // Warning: Smart user picker ONLY supports default value hydration
    // of *users*, not groups!
    defaultValue: defaultUserValue = '', isRequired: isRequired, isMulti: isMulti, includeUsers: includeUsers, includeGroups: includeGroups, onChange: onChange } = props;
    const query = (0, $d005z.useMentionResource)(mentionProvider);
    const accountIds = Array.isArray(defaultUserValue) ? defaultUserValue : [
        defaultUserValue
    ];
    const usersData = (0, $a5I65.useUsers)(accountIds, client);
    // Hydrate the default value ourselves, since we are controlling value from <Field>
    // component value. It will get passed into the user picker as simply `value`.
    const hydratedDefaultValue = $8185e7c2bb331f27$var$hydrateDefaultValue(usersData, isMulti);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6PxFA.UserPicker), {
        accountId: accountId,
        cloudId: cloudId,
        productAttributes: productAttributes,
        productKey: productKey,
        mentionProvider: mentionProvider,
        name: name,
        label: label,
        placeholder: placeholder,
        description: description,
        defaultValue: hydratedDefaultValue,
        isRequired: isRequired,
        isMulti: isMulti,
        includeUsers: includeUsers,
        includeGroups: includeGroups,
        baseUrl: baseUrl,
        onChange: onChange,
        query: query
    });
};
const $8185e7c2bb331f27$export$89c0f5a165dc562a = ({ query: query, accountId: accountId, cloudId: cloudId, productKey: productKey, baseUrl: baseUrl })=>{
    return function UserPickerNext({ forgeDoc: { props: props } }) {
        const { name: name, label: label, placeholder: placeholder, description: description, isRequired: isRequired, isMulti: isMulti, includeUsers: includeUsers, includeGroups: includeGroups, onChange: onChange, defaultValue: defaultUserId } = props;
        const [defaultValueLoaded, setDefaultValueLoaded] = (0, $eJOHy.useState)(!defaultUserId);
        const [defaultValue, setDefaultValue] = (0, $eJOHy.useState)();
        (0, $eJOHy.useEffect)(()=>{
            if (defaultUserId && !defaultValueLoaded) query().then((users)=>{
                const targetUsers = users.filter(({ id: id })=>Array.isArray(defaultUserId) ? defaultUserId.includes(id) : defaultUserId === id);
                if (targetUsers.length === 0) setDefaultValue(undefined);
                else if (isMulti) setDefaultValue(targetUsers);
                else setDefaultValue(targetUsers[0]);
                setDefaultValueLoaded(true);
            });
        }, [
            isMulti,
            defaultUserId,
            defaultValueLoaded,
            setDefaultValue,
            setDefaultValueLoaded
        ]);
        if (!defaultValueLoaded) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: null
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6PxFA.UserPicker), {
            accountId: accountId,
            cloudId: cloudId,
            productKey: productKey,
            baseUrl: baseUrl,
            name: name,
            label: label,
            placeholder: placeholder,
            description: description,
            isRequired: isRequired,
            isMulti: isMulti,
            includeUsers: includeUsers,
            includeGroups: includeGroups,
            onChange: onChange,
            query: query,
            defaultValue: defaultValue
        });
    };
};
const $8185e7c2bb331f27$export$57fb7dc1c2438e62 = ({ client: client, mentionProvider: mentionProvider, accountId: accountId, cloudId: cloudId, productKey: productKey, baseUrl: baseUrl, productAttributes: productAttributes })=>{
    return function UserPickerNext({ forgeDoc: { props: props } }) {
        return /*#__PURE__*/ (0, $gt9Am.jsx)($8185e7c2bb331f27$var$UserPickerFn, {
            props: props,
            client: client,
            mentionProvider: mentionProvider,
            accountId: accountId,
            cloudId: cloudId,
            productAttributes: productAttributes,
            productKey: productKey,
            baseUrl: baseUrl
        });
    };
};

});
parcelRegister("d005z", function(module, exports) {
$parcel$export(module.exports, "useMentionResource", () => $fc97d49bc5a78dd8$export$f4d09562dcb13ab);

var $eJOHy = parcelRequire("eJOHy");
// Key for registering and unregistering the subscriber
const $fc97d49bc5a78dd8$var$MENTION_SUBSCRIBER_KEY = 'forge-ui-user-select';
const $fc97d49bc5a78dd8$var$mentionResultsToUsers = (results)=>{
    return results.map((result)=>({
            id: result.id,
            name: result.name,
            avatarUrl: result.avatarUrl || '',
            type: 'user'
        })).filter((user)=>typeof user.name !== 'undefined');
};
const $fc97d49bc5a78dd8$export$f4d09562dcb13ab = (mentionProvider)=>{
    const query = (0, $eJOHy.useCallback)(async (search)=>{
        const provider = await mentionProvider;
        if (provider && search) return new Promise((resolve)=>{
            provider.filter(search);
            provider.subscribe($fc97d49bc5a78dd8$var$MENTION_SUBSCRIBER_KEY, (results)=>{
                provider.unsubscribe($fc97d49bc5a78dd8$var$MENTION_SUBSCRIBER_KEY);
                resolve($fc97d49bc5a78dd8$var$mentionResultsToUsers(results));
            }, ()=>{
                provider.unsubscribe($fc97d49bc5a78dd8$var$MENTION_SUBSCRIBER_KEY);
                resolve([]);
            });
        });
        return Promise.resolve([]);
    }, [
        mentionProvider
    ]);
    if (mentionProvider) return query;
};

});

parcelRegister("6PxFA", function(module, exports) {
$parcel$export(module.exports, "UserPicker", () => $00bd0123a733568a$export$83e0c73b09b3a9cd);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $o0Fzr = parcelRequire("o0Fzr");

var $ewHZ5 = parcelRequire("ewHZ5");

var $1v8Pz = parcelRequire("1v8Pz");

var $fKXve = parcelRequire("fKXve");

var $hmQK4 = parcelRequire("hmQK4");

var $jTA4M = parcelRequire("jTA4M");
const $00bd0123a733568a$var$BITBUCKET_FIELD_ID = 'BitbucketMentions';
// the value prop in UserPicker component can only take undefined for empty value.
// null is not allowed and will resulted in unexpected behavior.
const $00bd0123a733568a$var$ensureUserPickerValue = (value)=>{
    if (!value || Array.isArray(value) && value.length === 0) return undefined;
    return value;
};
// by forcing a key update when defaultValue is present, we force the SmartUserPicker to re-render.
// this is because the SmartUserPicker does not re-render when the defaultValue changes in its
// current implementation.
const $00bd0123a733568a$var$makeUserPickerKey = (id, defaultValue)=>{
    if (!defaultValue || Array.isArray(defaultValue) && defaultValue.length === 0) return id;
    return `${id}-with-default`;
};
const $00bd0123a733568a$var$RawUserPicker = ({ id: id, name: name, description: description, placeholder: placeholder, isMulti: isMulti, includeUsers: includeUsers = true, includeGroups: includeGroups = false, accountId: currentAccountId, cloudId: suppliedCloudId, productKey: productKey, baseUrl: baseUrl, onChange: onChange, query: query, defaultValue: defaultValue, value: providedValue, width: width, productAttributes: productAttributes })=>{
    const [value, setValue] = (0, $eJOHy.useState)(defaultValue);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hmQK4.PortalConsumer), {
        children: (portal)=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                children: [
                    suppliedCloudId && productKey ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1v8Pz.default), {
                        onChange: (user)=>onChange?.(user),
                        isMulti: isMulti,
                        menuPortalTarget: portal || undefined,
                        noOptionsMessage: ()=>null,
                        placeholder: placeholder,
                        width: width,
                        fieldId: // Bitbucket User Recommendations does not support generic contextType
                        productKey === 'bitbucket' ? $00bd0123a733568a$var$BITBUCKET_FIELD_ID : id,
                        debounceTime: 400,
                        includeUsers: includeUsers,
                        includeGroups: includeGroups,
                        siteId: suppliedCloudId,
                        productAttributes: productAttributes,
                        // If principalId === 'Context', upstream attempts to use other context
                        // to discover the principal ID
                        principalId: currentAccountId ?? 'Context',
                        productKey: productKey,
                        baseUrl: baseUrl,
                        inputId: name || id,
                        defaultValue: defaultValue,
                        // Override the default height of user picker so that it aligns with other input components from design system
                        styles: {
                            control: (base)=>({
                                    ...base,
                                    minHeight: '40px',
                                    height: '40px'
                                })
                        }
                    }, $00bd0123a733568a$var$makeUserPickerKey(id, defaultValue)) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ewHZ5.UserPicker), {
                        value: $00bd0123a733568a$var$ensureUserPickerValue(providedValue ?? value),
                        onChange: (user)=>{
                            setValue(user);
                            onChange?.(user);
                        },
                        // Override the default height of user picker so that it aligns with other input components from design system
                        styles: {
                            control: (base)=>({
                                    ...base,
                                    minHeight: '40px',
                                    height: '40px'
                                })
                        },
                        isMulti: isMulti,
                        menuPortalTarget: portal || undefined,
                        noOptionsMessage: ()=>null,
                        placeholder: placeholder,
                        width: width,
                        loadOptions: query,
                        fieldId: null,
                        inputId: id,
                        defaultValue: defaultValue
                    }),
                    description && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fKXve.HelperMessage), {
                        children: description
                    })
                ]
            })
    });
};
const $00bd0123a733568a$export$83e0c73b09b3a9cd = (props)=>{
    const uid = (0, $o0Fzr.useUID)();
    const { name: name, isRequired: isRequired, label: label } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            label && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jTA4M.Label), {
                name: name,
                isRequired: isRequired,
                label: label
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)($00bd0123a733568a$var$RawUserPicker, {
                id: name || uid,
                width: "100%",
                ...props
            })
        ]
    });
};

});
parcelRegister("ewHZ5", function(module, exports) {
$parcel$export(module.exports, "UserPicker", () => $1e85aa7b9e874556$export$83e0c73b09b3a9cd);
/* UserPicker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $4J0ad = parcelRequire("4J0ad");

var $kVcjU = parcelRequire("kVcjU");
var $c4OV1 = parcelRequire("c4OV1");

var $g0oDq = parcelRequire("g0oDq");

var $eJOHy = parcelRequire("eJOHy");

var $1icyy = parcelRequire("1icyy");

var $7Vnqr = parcelRequire("7Vnqr");

var $6jfsf = parcelRequire("6jfsf");

var $lLpLo = parcelRequire("lLpLo");

var $f9tKr = parcelRequire("f9tKr");

var $61zL7 = parcelRequire("61zL7");

var $48bcP = parcelRequire("48bcP");

var $1FdfR = parcelRequire("1FdfR");

var $aXKmr = parcelRequire("aXKmr");

var $eGOwo = parcelRequire("eGOwo");
class $1e85aa7b9e874556$export$164f4d95e5d7e2f5 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    constructor(props){
        super(props);
        this.ufoId = (0, $aXKmr.v4)();
        const experienceForId = (0, $1FdfR.userPickerRenderedUfoExperience).getInstance(this.ufoId);
        if (![
            (0, $g0oDq.UFOExperienceState).IN_PROGRESS.id,
            (0, $g0oDq.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.start();
    }
    static{
        this.defaultProps = {
            width: 350,
            isMulti: false
        };
    }
    componentDidMount() {
        const experienceForId = (0, $1FdfR.userPickerRenderedUfoExperience).getInstance(this.ufoId);
        // Send UFO success if the experience is still in progress i.e. hasn't failed
        if ([
            (0, $g0oDq.UFOExperienceState).IN_PROGRESS.id,
            (0, $g0oDq.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.success();
    }
    render() {
        const { emailLabel: emailLabel, allowEmail: allowEmail, suggestEmailsForDomain: suggestEmailsForDomain, isMulti: isMulti, isValidEmail: isValidEmail, anchor: anchor, menuPortalTarget: menuPortalTarget, menuPosition: menuPosition, menuShouldBlockScroll: menuShouldBlockScroll, captureMenuScroll: captureMenuScroll, closeMenuOnScroll: closeMenuOnScroll, loadUserSource: loadUserSource, required: required = false, showClearIndicator: showClearIndicator = false } = this.props;
        const width = this.props.width;
        const SelectComponent = allowEmail ? (0, $kVcjU.default) : (0, $c4OV1.default);
        const creatableProps = suggestEmailsForDomain ? (0, $f9tKr.getCreatableSuggestedEmailProps)(suggestEmailsForDomain, isValidEmail) : (0, $lLpLo.getCreatableProps)(isValidEmail);
        const defaultPickerProps = {
            closeMenuOnScroll: closeMenuOnScroll,
            menuPortalTarget: menuPortalTarget,
            menuPosition: menuPosition,
            menuShouldBlockScroll: menuShouldBlockScroll,
            captureMenuScroll: captureMenuScroll,
            required: required
        };
        const pickerProps = allowEmail ? {
            ...defaultPickerProps,
            ...creatableProps,
            emailLabel: emailLabel
        } : {
            ...defaultPickerProps
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1FdfR.UfoErrorBoundary), {
            id: this.ufoId,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $61zL7.default), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $48bcP.ExusUserSourceProvider), {
                    fetchUserSource: loadUserSource,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1icyy.BaseUserPickerWithoutAnalytics), {
                        ...this.props,
                        forwardedRef: this.props.forwardedRef,
                        width: width,
                        SelectComponent: SelectComponent,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        styles: (0, $7Vnqr.getStyles)(width, isMulti, this.props.appearance === 'compact', this.props.styles, (0, $eGOwo.fg)('platform-component-visual-refresh'), false, (0, $eGOwo.fg)('jifjam_bulk_operations') ? this.props.height : undefined),
                        components: (0, $6jfsf.getComponents)(isMulti, anchor, showClearIndicator, this.props?.components ? this.props.components : {}),
                        pickerProps: pickerProps
                    })
                })
            })
        });
    }
}
const $1e85aa7b9e874556$export$83e0c73b09b3a9cd = (0, $4J0ad.default)()($1e85aa7b9e874556$export$164f4d95e5d7e2f5);

});
parcelRegister("1icyy", function(module, exports) {
$parcel$export(module.exports, "BaseUserPickerWithoutAnalytics", () => $35423b4ef08403b2$export$b4ff48c8d43b18c3);

var $gt9Am = parcelRequire("gt9Am");

var $4J0ad = parcelRequire("4J0ad");

var $g0oDq = parcelRequire("g0oDq");

var $3s8bj = parcelRequire("3s8bj");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $aXKmr = parcelRequire("aXKmr");

var $lyKnh = parcelRequire("lyKnh");

var $4yPQa = parcelRequire("4yPQa");

var $aemwP = parcelRequire("aemwP");

var $bp6ad = parcelRequire("bp6ad");

var $ersOA = parcelRequire("ersOA");

var $1FdfR = parcelRequire("1FdfR");

var $eGOwo = parcelRequire("eGOwo");
const $35423b4ef08403b2$var$loadingMessage = ()=>null;
const $35423b4ef08403b2$var$classNamePrefix = 'fabric-user-picker';
class $35423b4ef08403b2$export$b4ff48c8d43b18c3 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            isMulti: false,
            subtle: false,
            noBorder: false,
            textFieldBackgroundColor: false,
            isClearable: true,
            loadOptionsErrorMessage: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $aemwP.messages).errorMessage
                }),
            openMenuOnClick: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const derivedState = {};
        if (nextProps.isDisabled || nextProps.disableInput) derivedState.menuIsOpen = false;
        if (nextProps.open !== undefined) derivedState.menuIsOpen = nextProps.open;
        if (nextProps.value !== undefined) derivedState.value = (0, $bp6ad.optionToSelectableOptions)(nextProps.value);
        else if ((0, $bp6ad.isDefaultValuePopulated)(nextProps.defaultValue) && !prevState.isDefaultSet) {
            derivedState.value = (0, $bp6ad.optionToSelectableOptions)(nextProps.defaultValue);
            derivedState.isDefaultSet = true;
        }
        if (nextProps.search !== undefined && nextProps.search !== prevState.inputValue) derivedState.inputValue = nextProps.search;
        if (nextProps.options !== undefined) derivedState.options = nextProps.options;
        return derivedState;
    }
    constructor(props){
        super(props), this.getSessionId = ()=>this.session && this.session.id ? this.session.id : undefined, this.withSelectRef = (callback)=>()=>{
                if (this.selectRef) callback(this.selectRef);
            }, this.nextOption = this.withSelectRef((select)=>select.focusOption('down')), this.previousOption = this.withSelectRef((select)=>select.focusOption('up')), this.focus = ()=>{
            if (this.selectRef && this.selectRef.focus) this.selectRef.focus();
        }, this.blur = ()=>{
            if (this.selectRef && this.selectRef.blur) this.selectRef.blur();
        }, this.selectOption = this.withSelectRef((select)=>{
            const focusedOption = select.state.focusedOption;
            select.selectOption(focusedOption);
        }), // value = null if user deletes the last item in the user picker
        this.handleChange = (value, { action: action, removedValue: removedValue, option: option })=>{
            if (removedValue && removedValue.data.fixed) return;
            this.resetInputState();
            const { onChange: onChange, onSelection: onSelection, onClear: onClear, isMulti: isMulti } = this.props;
            (0, $bp6ad.callCallback)(onChange, (0, $bp6ad.extractOptionValue)(value), action);
            switch(action){
                case 'select-option':
                    if (value) (0, $bp6ad.callCallback)(onSelection, (0, $bp6ad.extractOptionValue)(value), this.getSessionId(), this);
                    this.fireEvent((0, $lyKnh.selectEvent), isMulti ? option : value);
                    this.session = isMulti ? (0, $lyKnh.startSession)() : undefined;
                    break;
                case 'clear':
                    (0, $bp6ad.callCallback)(onClear);
                    this.fireEvent((0, $lyKnh.clearEvent));
                    break;
                case 'remove-value':
                case 'pop-value':
                    if (removedValue) this.fireEvent((0, $lyKnh.deleteEvent), removedValue.data);
                    break;
            }
            this.fireEvent((0, $lyKnh.searchedEvent));
            if (removedValue && this.state.value && Array.isArray(this.state.value)) {
                const remainingValues = this.state.value.filter((val)=>val.data.id !== removedValue.data.id);
                this.setState({
                    value: remainingValues ? remainingValues : [],
                    menuIsOpen: true
                });
            }
            if (!this.props.value) this.setState({
                value: value ? value : []
            });
        }, this.handleSelectRef = (ref)=>{
            this.selectRef = ref;
        }, this.addOptions = (0, $4yPQa.batchByKey)((request, newOptions)=>{
            const { resolving: resolving } = this.state;
            this.setState(({ inflightRequest: inflightRequest, options: options, count: count })=>{
                if (inflightRequest.toString() === request) return {
                    options: (resolving ? options : []).concat(newOptions.reduce((nextOptions, item)=>Array.isArray(item) ? nextOptions.concat(item[0]) : nextOptions.concat(item), [])),
                    count: count - newOptions.length,
                    resolving: count - newOptions.length !== 0
                };
                return null;
            });
        }), this.handleLoadOptionsError = ()=>{
            const { count: count } = this.state;
            const newCount = count - 1;
            const resolving = newCount !== 0;
            let showError = false;
            if (!resolving) showError = true;
            this.setState({
                count: newCount,
                resolving: resolving,
                showError: showError
            });
            this.fireEvent((0, $lyKnh.failedEvent));
        }, this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) {
                const inflightRequest = this.state.inflightRequest + 1;
                const result = this.session && this.session.id ? loadOptions(search, this.session.id) : loadOptions(search);
                const addOptions = this.addOptions.bind(this, inflightRequest.toString());
                let count = 0;
                if ((0, $bp6ad.isIterable)(result)) for (const value of result){
                    Promise.resolve(value).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                else {
                    Promise.resolve(result).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                this.setState({
                    inflightRequest: inflightRequest,
                    count: count,
                    resolving: count !== 0,
                    options: []
                });
            }
        }, 200), this.abortOptionsShownUfoExperience = ()=>{
            if (this.optionsShownUfoExperienceInstance.state.id === (0, $g0oDq.UFOExperienceState).STARTED.id) // There may be an existing UFO timing running from previous key entry or focus,
            // so abort it and restart it just in case.
            this.optionsShownUfoExperienceInstance.abort();
        }, this.startOptionsShownUfoExperience = ()=>{
            this.abortOptionsShownUfoExperience();
            this.optionsShownUfoExperienceInstance.start();
        }, this.executeLoadOptions = (search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) this.setState({
                resolving: true,
                showError: false
            }, ()=>this.debouncedLoadOptions(search));
        }, this.handleFocus = (event)=>{
            const { value: value, menuIsOpen: menuIsOpen } = this.state;
            if (!menuIsOpen || !this.session) this.startSession();
            this.startOptionsShownUfoExperience();
            (0, $bp6ad.callCallback)(this.props.onFocus, this.getSessionId());
            if (!this.isMenuOpenOnClickForSingleSelect) {
                this.setState({
                    menuIsOpen: true
                });
                if (!this.props.isMulti && (0, $bp6ad.isSingleValue)(value)) {
                    const input = event.target;
                    this.setState({
                        inputValue: value.label
                    }, ()=>{
                        if (input instanceof HTMLInputElement) input.setSelectionRange(0, value.label.length);
                    });
                }
            }
        }, this.resetInputState = ()=>{
            // Prevent filter if query typed, then blurred with no selection
            this.setState({
                inputValue: ''
            });
            (0, $bp6ad.callCallback)(this.props.onInputChange, '', this.getSessionId());
        }, this.handleBlur = ()=>{
            (0, $bp6ad.callCallback)(this.props.onBlur, this.getSessionId());
            if ((0, $bp6ad.isPopupUserPickerByComponent)(this.props.SelectComponent)) return;
            this.resetInputState();
            this.abortOptionsShownUfoExperience();
            this.setState({
                menuIsOpen: false,
                initialFocusHandled: false,
                options: []
            });
        }, this.handleOpen = ()=>{
            (0, $bp6ad.callCallback)(this.props.onOpen, this.getSessionId());
            this.setState({
                menuIsOpen: true
            });
        }, this.handleClose = ()=>{
            this.resetInputState();
            (0, $bp6ad.callCallback)(this.props.onClose, this.getSessionId());
            this.setState({
                menuIsOpen: false,
                options: []
            });
        }, this.handleInputChange = (search, { action: action })=>{
            if (action === 'input-change' || action === 'set-value') {
                (0, $bp6ad.callCallback)(this.props.onInputChange, search, this.getSessionId());
                this.setState({
                    inputValue: search
                });
                this.startOptionsShownUfoExperience();
            }
        }, this.fireEvent = (eventCreator, ...args)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) (0, $lyKnh.createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, this.session, this.journeyId, ...args))(createAnalyticsEvent);
        }, this.startSession = ()=>{
            this.session = (0, $lyKnh.startSession)();
            this.journeyId = this.getSessionId();
            this.fireEvent((0, $lyKnh.focusEvent));
        }, this.handleKeyDown = (event)=>{
            if (!this.isMenuOpenOnClickForSingleSelect) {
                // Escape
                if (event.keyCode === 27) this.blur();
                // Space
                if (event.keyCode === 32 && !this.state.inputValue) {
                    event.preventDefault();
                    !this.props.disableInput && this.setState({
                        inputValue: ' '
                    });
                }
            }
            if (this.session) {
                this.session.lastKey = event.keyCode;
                switch(event.keyCode){
                    // KeyUp 38
                    case 38:
                        this.session.upCount++;
                        break;
                    // KeyDown 40
                    case 40:
                        this.session.downCount++;
                        break;
                }
            }
            this.props.onKeyDown && this.props.onKeyDown(event);
        }, this.handleClearIndicatorHover = (hoveringClearIndicator)=>{
            this.setState({
                hoveringClearIndicator: hoveringClearIndicator
            });
        }, this.getOptions = ()=>{
            const options = (0, $bp6ad.getOptions)(this.state.options) || [];
            const { maxOptions: maxOptions, isMulti: isMulti, groupByTypeOrder: groupByTypeOrder } = this.props;
            if (maxOptions === 0) return [];
            if (maxOptions && maxOptions > 0 && maxOptions < options.length) {
                const { value: value } = this.state;
                let filteredOptions = options;
                // Filter out previously selected options
                if (isMulti && Array.isArray(value)) {
                    const valueIds = value.map((item)=>item.data.id);
                    filteredOptions = options.filter((option)=>valueIds.indexOf(option.data.id) === -1);
                }
                return groupByTypeOrder ? (0, $ersOA.groupOptionsByType)(filteredOptions.slice(0, maxOptions), groupByTypeOrder) : filteredOptions.slice(0, maxOptions);
            }
            return groupByTypeOrder ? (0, $ersOA.groupOptionsByType)(options, groupByTypeOrder) : options;
        }, this.getAppearance = ()=>this.props.appearance ? this.props.appearance : 'normal', this.handleClickDraggableParentComponent = ()=>{
            if (this.state.initialFocusHandled) {
                // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                if (this.state.menuIsOpen) this.handleClose();
                else this.handleOpen();
            } else if (!this.state.menuIsOpen && !this.isMenuOpenOnClickForSingleSelect) {
                // Trigger focus state when ValueContainer is clicked for the first time
                // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                // to manage the state of the dropdown menu
                this.focus();
                this.setState(()=>({
                        initialFocusHandled: true
                    }));
            }
        };
        this.state = {
            options: [],
            isDefaultSet: false,
            inflightRequest: 0,
            count: 0,
            hoveringClearIndicator: false,
            menuIsOpen: !!this.props.open,
            inputValue: props.search || '',
            resolving: false,
            showError: false,
            initialFocusHandled: false
        };
        this.optionsShownUfoExperienceInstance = (0, $1FdfR.userPickerOptionsShownUfoExperience).getInstance((0, $aXKmr.v4)());
        if (this.props.forwardedRef) {
            const refValue = {
                focus: this.focus,
                blur: this.blur
            };
            if (typeof this.props.forwardedRef === 'function') this.props.forwardedRef(refValue);
            else this.props.forwardedRef.current = refValue;
        }
    }
    get isMenuOpenOnClickForSingleSelect() {
        return this.props.openMenuOnClick && !this.props.isMulti;
    }
    componentDidMount() {
        const { open: open, search: search } = this.props;
        // load options when the picker open
        if (open) {
            if (!this.session) this.startSession();
            this.executeLoadOptions(search);
        }
    }
    componentDidUpdate(_, prevState) {
        const { menuIsOpen: menuIsOpen, options: options, resolving: resolving, count: count, inputValue: inputValue } = this.state;
        // Create a new session when the menu is opened and there is no session
        if (menuIsOpen && !prevState.menuIsOpen && !this.session) this.startSession();
        // Load options when user picker opens or when input value changes
        if (menuIsOpen && !prevState.menuIsOpen || inputValue !== prevState.inputValue) this.executeLoadOptions(inputValue);
        if (!menuIsOpen && prevState.menuIsOpen && this.session) {
            this.fireEvent((0, $lyKnh.cancelEvent), prevState);
            this.session = undefined;
        }
        if (menuIsOpen && (!prevState.menuIsOpen && options.length > 0 || options.length !== prevState.options.length)) this.fireEvent((0, $lyKnh.searchedEvent));
        if (this.state.inputValue !== prevState.inputValue) {
            if (this.session) this.session.inputChangeTime = Date.now();
        }
        if (menuIsOpen && (!_.loadOptions || prevState.menuIsOpen) && count === 0 && !resolving && [
            (0, $g0oDq.UFOExperienceState).STARTED.id,
            (0, $g0oDq.UFOExperienceState).IN_PROGRESS.id
        ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success();
    }
    get ariaProps() {
        const ariaLabels = Object.keys(this.props).filter((key)=>key.startsWith('aria-'));
        const props = {
            ...this.props
        };
        return ariaLabels.reduce((obj, key)=>({
                ...obj,
                [key]: props[key]
            }), {});
    }
    render() {
        const { isMulti: isMulti, isLoading: isLoading, subtle: subtle, noBorder: noBorder, placeholder: placeholder, isClearable: isClearable, isDisabled: isDisabled, isInvalid: isInvalid, clearValueLabel: clearValueLabel, menuMinWidth: menuMinWidth, menuPortalTarget: menuPortalTarget, loadOptionsErrorMessage: loadOptionsErrorMessage, addMoreMessage: addMoreMessage, noOptionsMessage: noOptionsMessage, footer: footer, disableInput: disableInput, components: components, pickerProps: pickerProps, SelectComponent: SelectComponent, styles: styles, autoFocus: autoFocus, fieldId: fieldId, inputId: inputId, maxPickerHeight: maxPickerHeight, textFieldBackgroundColor: textFieldBackgroundColor, ariaLabelledBy: ariaLabelledBy, ariaDescribedBy: ariaDescribedBy, ariaLive: ariaLive, ariaLabel: ariaLabel, name: name, header: header, required: required, UNSAFE_hasDraggableParentComponent: UNSAFE_hasDraggableParentComponent, placeholderAvatar: placeholderAvatar } = this.props;
        const { count: count, hoveringClearIndicator: hoveringClearIndicator, menuIsOpen: menuIsOpen, value: value, inputValue: inputValue, resolving: resolving, showError: showError } = this.state;
        const appearance = this.getAppearance();
        // these props override the default select menu open and close
        const menuOpenDeciderProps = {
            ...!this.isMenuOpenOnClickForSingleSelect && {
                menuIsOpen: menuIsOpen,
                blurInputOnSelect: !isMulti,
                openMenuOnFocus: true
            }
        };
        const { 'aria-labelledby': ariaLabelledByStandard, 'aria-describedby': ariaDescribedByStandard, ...restAriaProps } = this.ariaProps;
        return /*#__PURE__*/ (0, $gt9Am.jsx)(SelectComponent, {
            name: name,
            value: value,
            autoFocus: autoFocus !== undefined ? autoFocus : menuIsOpen,
            labelId: (0, $eGOwo.fg)('user_picker_migrate_aria_label_description') ? ariaLabelledBy ?? ariaLabelledByStandard : undefined,
            "aria-labelledby": (0, $eGOwo.fg)('user_picker_migrate_aria_label_description') ? undefined : ariaLabelledBy,
            descriptionId: (0, $eGOwo.fg)('user_picker_migrate_aria_label_description') ? ariaDescribedBy ?? ariaDescribedByStandard : undefined,
            "aria-describedby": (0, $eGOwo.fg)('user_picker_migrate_aria_label_description') ? undefined : ariaDescribedBy,
            "aria-live": ariaLive,
            "aria-required": required,
            required: required,
            ref: this.handleSelectRef,
            isMulti: isMulti,
            options: this.getOptions(),
            styles: styles,
            enableAnimation: isMulti,
            components: components,
            inputValue: inputValue,
            isLoading: count > 0 || resolving || isLoading,
            loadingMessage: $35423b4ef08403b2$var$loadingMessage,
            menuPlacement: "auto",
            placeholder: placeholder ?? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $aemwP.messages).placeholder
            }),
            label: ariaLabel,
            addMoreMessage: addMoreMessage,
            classNamePrefix: $35423b4ef08403b2$var$classNamePrefix,
            hoveringClearIndicator: hoveringClearIndicator,
            appearance: appearance,
            isClearable: isClearable,
            noBorder: noBorder,
            subtle: subtle,
            closeMenuOnSelect: !isMulti,
            noOptionsMessage: showError ? loadOptionsErrorMessage : typeof noOptionsMessage === 'function' ? noOptionsMessage : ()=>noOptionsMessage,
            footer: footer,
            isDisabled: isDisabled,
            isInvalid: isInvalid,
            isFocused: menuIsOpen,
            backspaceRemovesValue: isMulti,
            filterOption: null,
            clearValueLabel: clearValueLabel,
            menuMinWidth: menuMinWidth,
            menuPortalTarget: menuPortalTarget,
            disableInput: disableInput || isDisabled,
            instanceId: fieldId,
            inputId: inputId,
            onChange: this.handleChange,
            onMenuOpen: this.handleOpen,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onMenuClose: this.handleClose,
            onInputChange: this.handleInputChange,
            onClearIndicatorHover: this.handleClearIndicatorHover,
            onKeyDown: this.handleKeyDown,
            maxPickerHeight: maxPickerHeight,
            textFieldBackgroundColor: textFieldBackgroundColor,
            header: header,
            placeholderAvatar: placeholderAvatar,
            ...(0, $eGOwo.fg)('user_picker_migrate_aria_label_description') ? restAriaProps : this.ariaProps,
            ...pickerProps,
            ...UNSAFE_hasDraggableParentComponent && {
                onValueContainerClick: this.handleClickDraggableParentComponent
            },
            ...menuOpenDeciderProps
        });
    }
}
const $35423b4ef08403b2$export$d099ade7b4f4d2a4 = (0, $4J0ad.default)()($35423b4ef08403b2$export$b4ff48c8d43b18c3);

});
parcelRegister("lyKnh", function(module, exports) {
$parcel$export(module.exports, "startSession", () => $90f09ed730154930$export$c0d84948cecf78d8);
$parcel$export(module.exports, "createAndFireEventInElementsChannel", () => $90f09ed730154930$export$53eef0dcd9611650);
$parcel$export(module.exports, "focusEvent", () => $90f09ed730154930$export$e7818c470f37c4bd);
$parcel$export(module.exports, "clearEvent", () => $90f09ed730154930$export$7b5800e732182efb);
$parcel$export(module.exports, "deleteEvent", () => $90f09ed730154930$export$95711ec6c6227e9a);
$parcel$export(module.exports, "cancelEvent", () => $90f09ed730154930$export$e9caaaecfee38128);
$parcel$export(module.exports, "selectEvent", () => $90f09ed730154930$export$48143d759475d90f);
$parcel$export(module.exports, "searchedEvent", () => $90f09ed730154930$export$911fb7184b6037eb);
$parcel$export(module.exports, "failedEvent", () => $90f09ed730154930$export$c2aec355fef65c9c);
$parcel$export(module.exports, "userInfoEvent", () => $90f09ed730154930$export$f541f04954b0c11e);

var $5fWw9 = parcelRequire("5fWw9");

var $aXKmr = parcelRequire("aXKmr");

var $bp6ad = parcelRequire("bp6ad");
const $90f09ed730154930$var$packageName = "platform-pkg";
const $90f09ed730154930$var$packageVersion = "0.0.0-use.local";
const $90f09ed730154930$var$UUID_REGEXP_TEAMS_GROUPS = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $90f09ed730154930$var$UUID_REGEXP_OLD_AAID = /^[a-fA-F0-9]{1,8}:[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $90f09ed730154930$var$UUID_REGEXP_NEW_AAID = /^[a-fA-F0-9]{24,24}$/;
const $90f09ed730154930$export$c0d84948cecf78d8 = ()=>({
        id: (0, $aXKmr.v4)(),
        start: Date.now(),
        inputChangeTime: Date.now(),
        upCount: 0,
        downCount: 0,
        lastKey: undefined
    });
const $90f09ed730154930$export$53eef0dcd9611650 = (0, $5fWw9.default)('fabric-elements');
const $90f09ed730154930$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            packageName: $90f09ed730154930$var$packageName,
            packageVersion: $90f09ed730154930$var$packageVersion,
            ...attributes
        }
    });
const $90f09ed730154930$var$checkValidId = (id)=>{
    return $90f09ed730154930$var$UUID_REGEXP_NEW_AAID.test(id) || $90f09ed730154930$var$UUID_REGEXP_OLD_AAID.test(id) || $90f09ed730154930$var$UUID_REGEXP_TEAMS_GROUPS.test(id);
};
const $90f09ed730154930$var$optionData2Analytics = (option)=>{
    const { id: id, type: type } = option;
    // id's of email types are emails which is PII
    const validatedData = {
        id: $90f09ed730154930$var$checkValidId(id) ? id : null,
        type: type || null
    };
    if ((0, $bp6ad.isExternalUser)(option)) return {
        ...validatedData,
        type: 'external_user',
        sources: option.sources,
        externalUserType: option.externalUserType
    };
    if ((0, $bp6ad.isCustom)(option) && option.analyticsType) return {
        ...validatedData,
        type: option.analyticsType
    };
    return validatedData;
};
const $90f09ed730154930$var$buildValueForAnalytics = (value)=>{
    if (value) {
        const valueToConvert = Array.isArray(value) ? value : [
            value
        ];
        return valueToConvert.map(({ data: data })=>$90f09ed730154930$var$optionData2Analytics(data));
    }
    return [];
};
const $90f09ed730154930$var$createDefaultPickerAttributes = (props, session, journeyId)=>({
        context: props.fieldId,
        sessionId: $90f09ed730154930$var$sessionId(session),
        pickerType: $90f09ed730154930$var$pickerType(props),
        journeyId: journeyId
    });
const $90f09ed730154930$export$e7818c470f37c4bd = (props, state, session, journeyId)=>$90f09ed730154930$var$createEvent('ui', 'focused', 'userPicker', {
        ...$90f09ed730154930$var$createDefaultPickerAttributes(props, session, journeyId),
        values: $90f09ed730154930$var$buildValueForAnalytics(state.value)
    });
const $90f09ed730154930$export$7b5800e732182efb = (props, state, session, journeyId)=>$90f09ed730154930$var$createEvent('ui', 'cleared', 'userPicker', {
        ...$90f09ed730154930$var$createDefaultPickerAttributes(props, session, journeyId),
        pickerOpen: state.menuIsOpen,
        values: $90f09ed730154930$var$values(state)
    });
const $90f09ed730154930$export$95711ec6c6227e9a = (props, state, session, journeyId, ...args)=>$90f09ed730154930$var$createEvent('ui', 'deleted', 'userPickerItem', {
        context: props.fieldId,
        sessionId: $90f09ed730154930$var$sessionId(session),
        journeyId: journeyId,
        value: $90f09ed730154930$var$optionData2Analytics(args[0]),
        pickerOpen: state.menuIsOpen
    });
const $90f09ed730154930$export$e9caaaecfee38128 = (props, _, session, journeyId, ...args)=>$90f09ed730154930$var$createEvent('ui', 'cancelled', 'userPicker', {
        ...$90f09ed730154930$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $90f09ed730154930$var$sessionDuration(session),
        queryLength: $90f09ed730154930$var$queryLength(args[0]),
        spaceInQuery: $90f09ed730154930$var$spaceInQuery(args[0]),
        upKeyCount: $90f09ed730154930$var$upKeyCount(session),
        downKeyCount: $90f09ed730154930$var$downKeyCount(session)
    });
const $90f09ed730154930$export$48143d759475d90f = (props, state, session, journeyId, ...args)=>{
    return $90f09ed730154930$var$createEvent('ui', $90f09ed730154930$var$selectEventType(session), 'userPicker', {
        ...$90f09ed730154930$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $90f09ed730154930$var$sessionDuration(session),
        position: $90f09ed730154930$var$position(state, args[0]),
        queryLength: $90f09ed730154930$var$queryLength(state),
        spaceInQuery: $90f09ed730154930$var$spaceInQuery(state),
        upKeyCount: $90f09ed730154930$var$upKeyCount(session),
        downKeyCount: $90f09ed730154930$var$downKeyCount(session),
        result: $90f09ed730154930$var$result(args[0]),
        numberOfResults: $90f09ed730154930$var$numberOfResults(state)
    });
};
const $90f09ed730154930$export$911fb7184b6037eb = (props, state, session, journeyId)=>{
    const searchResults = $90f09ed730154930$var$results(state);
    return $90f09ed730154930$var$createEvent('operational', 'searched', 'userPicker', {
        ...$90f09ed730154930$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $90f09ed730154930$var$sessionDuration(session),
        durationSinceInputChange: $90f09ed730154930$var$durationSinceInputChange(session),
        queryLength: $90f09ed730154930$var$queryLength(state),
        isLoading: $90f09ed730154930$var$isLoading(props, state),
        results: searchResults,
        numberOfResults: searchResults.length
    });
};
const $90f09ed730154930$export$c2aec355fef65c9c = (props, _, session, journeyId)=>$90f09ed730154930$var$createEvent('operational', 'failed', 'userPicker', {
        ...$90f09ed730154930$var$createDefaultPickerAttributes(props, session, journeyId)
    });
const $90f09ed730154930$export$f541f04954b0c11e = (sources, accountId)=>$90f09ed730154930$var$createEvent('ui', 'displayed', 'userInfo', {
        sources: sources,
        // accountId can be PII if it is an email so check that it's an AAID first
        accountId: $90f09ed730154930$var$checkValidId(accountId) ? accountId : null
    });
function $90f09ed730154930$var$queryLength(state) {
    return state.inputValue.length;
}
function $90f09ed730154930$var$selectEventType(session) {
    return session && session.lastKey === 13 ? 'pressed' : 'clicked';
}
function $90f09ed730154930$var$upKeyCount(session) {
    return session ? session.upCount : null;
}
function $90f09ed730154930$var$downKeyCount(session) {
    return session ? session.downCount : null;
}
function $90f09ed730154930$var$spaceInQuery(state) {
    return state.inputValue.indexOf(' ') !== -1;
}
function $90f09ed730154930$var$sessionDuration(session) {
    return session ? Date.now() - session.start : null;
}
function $90f09ed730154930$var$durationSinceInputChange(session) {
    return session ? Date.now() - session.inputChangeTime : null;
}
function $90f09ed730154930$var$sessionId(session) {
    return session && session.id;
}
function $90f09ed730154930$var$position(state, value) {
    return value ? state.options.findIndex((option)=>option === value.data) : -1;
}
function $90f09ed730154930$var$pickerType(props) {
    return props.isMulti ? 'multi' : 'single';
}
function $90f09ed730154930$var$result(option) {
    return option ? $90f09ed730154930$var$optionData2Analytics(option.data) : null;
}
function $90f09ed730154930$var$results(state) {
    return (state.options || []).map($90f09ed730154930$var$optionData2Analytics);
}
function $90f09ed730154930$var$isLoading(props, state) {
    return state.count > 0 || props.isLoading;
}
function $90f09ed730154930$var$values(state) {
    return state.value ? Array.isArray(state.value) ? state.value.map((option)=>$90f09ed730154930$var$optionData2Analytics(option.data)) : [
        $90f09ed730154930$var$optionData2Analytics(state.value.data)
    ] : [];
}
function $90f09ed730154930$var$numberOfResults(state) {
    return (state.options || []).length;
}

});
parcelRegister("bp6ad", function(module, exports) {
$parcel$export(module.exports, "isExternalUser", () => $144d288a5555e012$export$f6058dbcb5980cb);
$parcel$export(module.exports, "isUser", () => $144d288a5555e012$export$2e44165f1da65304);
$parcel$export(module.exports, "isTeam", () => $144d288a5555e012$export$f8c4277cb588611f);
$parcel$export(module.exports, "isGroup", () => $144d288a5555e012$export$d7976824e9f55785);
$parcel$export(module.exports, "isEmail", () => $144d288a5555e012$export$7fbbfbca30081d0);
$parcel$export(module.exports, "isCustom", () => $144d288a5555e012$export$d3a8f0b77e9737fc);
$parcel$export(module.exports, "isDefaultValuePopulated", () => $144d288a5555e012$export$d6978985a41b0c8);
$parcel$export(module.exports, "extractOptionValue", () => $144d288a5555e012$export$7ae97131df521bff);
$parcel$export(module.exports, "isIterable", () => $144d288a5555e012$export$9652023d9040757);
$parcel$export(module.exports, "getOptions", () => $144d288a5555e012$export$d2312e68e1f5ad00);
$parcel$export(module.exports, "optionToSelectableOptions", () => $144d288a5555e012$export$e6fda14a194bcbcc);
$parcel$export(module.exports, "getAvatarSize", () => $144d288a5555e012$export$695fb564e621339a);
$parcel$export(module.exports, "isChildInput", () => $144d288a5555e012$export$3c62cf9a01367f27);
$parcel$export(module.exports, "isSingleValue", () => $144d288a5555e012$export$203c2bd2662d1ca2);
$parcel$export(module.exports, "hasValue", () => $144d288a5555e012$export$96bdbc84526f3739);
$parcel$export(module.exports, "callCallback", () => $144d288a5555e012$export$df325aa844b03c31);
$parcel$export(module.exports, "getAvatarUrl", () => $144d288a5555e012$export$b4f8f1f54acec99b);
$parcel$export(module.exports, "isPopupUserPickerByComponent", () => $144d288a5555e012$export$4f60a74234178416);
$parcel$export(module.exports, "isLozengeText", () => $144d288a5555e012$export$5419897287f5f1c7);

var $LFmXM = parcelRequire("LFmXM");


var $sl8jM = parcelRequire("sl8jM");
const $144d288a5555e012$export$f6058dbcb5980cb = (option)=>option.type === (0, $f4e041c5b2b1b75c$export$50042ec1d2e00e63) || Boolean(option.isExternal);
const $144d288a5555e012$export$2e44165f1da65304 = (option)=>option.type === undefined || option.type === (0, $f4e041c5b2b1b75c$export$8436e53e45ffe15b);
const $144d288a5555e012$export$f8c4277cb588611f = (option)=>option.type === (0, $f4e041c5b2b1b75c$export$26bc40b960693765);
const $144d288a5555e012$export$d7976824e9f55785 = (option)=>option.type === (0, $f4e041c5b2b1b75c$export$d460f747b73abb10);
const $144d288a5555e012$export$7fbbfbca30081d0 = (option)=>option.type === (0, $f4e041c5b2b1b75c$export$6662b3461398ef8c);
const $144d288a5555e012$export$d3a8f0b77e9737fc = (option)=>option.type === (0, $f4e041c5b2b1b75c$export$eafd0979afa5b224);
const $144d288a5555e012$export$d6978985a41b0c8 = (value)=>value && !Array.isArray(value) || Array.isArray(value) && value.length > 0;
const $144d288a5555e012$var$isOptionData = (option)=>option.name !== undefined;
const $144d288a5555e012$export$3f993c492bd6c728 = (option)=>{
    if ($144d288a5555e012$var$isOptionData(option)) return {
        data: option,
        isDisabled: option.isDisabled,
        label: option.name,
        value: option.id
    };
    else return {
        data: {
            ...option,
            name: option.id
        },
        isDisabled: option.isDisabled,
        label: option.id,
        value: option.id
    };
};
const $144d288a5555e012$export$7ae97131df521bff = (value)=>{
    if (!value) return undefined;
    if (Array.isArray(value)) return value.map(({ data: option })=>option);
    return value.data;
};
const $144d288a5555e012$export$9652023d9040757 = (a)=>typeof a?.[Symbol.iterator] === 'function';
const $144d288a5555e012$export$d2312e68e1f5ad00 = (0, $LFmXM.default)((options)=>options.map($144d288a5555e012$export$3f993c492bd6c728));
const $144d288a5555e012$export$e6fda14a194bcbcc = (0, $LFmXM.default)((defaultValue)=>{
    if (!defaultValue) return null;
    if (Array.isArray(defaultValue)) return defaultValue.map($144d288a5555e012$export$3f993c492bd6c728);
    return $144d288a5555e012$export$3f993c492bd6c728(defaultValue);
});
const $144d288a5555e012$export$695fb564e621339a = (appearance)=>appearance === 'big' ? 'medium' : appearance === 'multi' ? 'xsmall' : 'small';
const $144d288a5555e012$export$3c62cf9a01367f27 = (child)=>child && typeof child === 'object' && child.props && child.props.type === 'text';
const $144d288a5555e012$export$203c2bd2662d1ca2 = (value)=>!!value && !Array.isArray(value);
const $144d288a5555e012$export$96bdbc84526f3739 = (value)=>!!value && value.trim().length > 0;
const $144d288a5555e012$export$df325aa844b03c31 = (callback, ...args)=>{
    if (typeof callback === 'function') try {
        //  there is mystery error in IE 11, so we need this try-catch
        return callback(...args);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('@atlassian/user-select: an error happening in `callCallback`: ', error);
    }
    return undefined;
};
const $144d288a5555e012$export$b4f8f1f54acec99b = (optionData)=>{
    if ($144d288a5555e012$export$2e44165f1da65304(optionData) || $144d288a5555e012$export$f8c4277cb588611f(optionData) || $144d288a5555e012$export$d3a8f0b77e9737fc(optionData) || $144d288a5555e012$export$f6058dbcb5980cb(optionData)) return optionData.avatarUrl;
    return undefined;
};
const $144d288a5555e012$export$4f60a74234178416 = (SelectComponent)=>SelectComponent === (0, $sl8jM.default);
const $144d288a5555e012$export$7add003953ca6733 = (selectProps)=>selectProps.searchThreshold === -1;
const $144d288a5555e012$export$5419897287f5f1c7 = (lozengeProp)=>{
    return lozengeProp?.hasOwnProperty('text') || false;
};

});
const $f4e041c5b2b1b75c$export$8436e53e45ffe15b = 'user';
const $f4e041c5b2b1b75c$export$50042ec1d2e00e63 = 'external_user';
const $f4e041c5b2b1b75c$export$26bc40b960693765 = 'team';
const $f4e041c5b2b1b75c$export$d460f747b73abb10 = 'group';
const $f4e041c5b2b1b75c$export$6662b3461398ef8c = 'email';
const $f4e041c5b2b1b75c$export$eafd0979afa5b224 = 'custom';

parcelRegister("sl8jM", function(module, exports) {
$parcel$export(module.exports, "default", () => $f040ddaa0ef5501e$export$2e2bcd8739ae039);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");

var $aQK2r = parcelRequire("aQK2r");

var $1Q3jn = parcelRequire("1Q3jn");

var $7QJq6 = parcelRequire("7QJq6");
var $i0xNm = parcelRequire("i0xNm");
var $lEbH4 = parcelRequire("lEbH4");

var $5yteI = parcelRequire("5yteI");

var $gl2vi = parcelRequire("gl2vi");

var $eGOwo = parcelRequire("eGOwo");

var $e9zKl = parcelRequire("e9zKl");


var $c4OV1 = parcelRequire("c4OV1");

var $5nAXq = parcelRequire("5nAXq");

var $ctyCN = parcelRequire("ctyCN");
/**
 * Are we rendering on the client or server?
 */ const $f040ddaa0ef5501e$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
// ==============================
// Class
// ==============================
const $f040ddaa0ef5501e$var$modifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            altAxis: true,
            altBoundary: true
        }
    }
];
/**
 * The new defaults match the default modifiers of `@atlaskit/popper`.
 *
 * In the future we should investigate using `@atlaskit/popper` instead of
 * consuming `react-popper` directly.
 *
 * Previously the select popup would slide over the trigger to try to stay visible.
 * This behavior could actually cause it to go offscreen.
 *
 * Now it will stay anchored above / below the trigger and cause the
 * clipping parent to scroll if necessary. This aligns with other popups.
 */ const $f040ddaa0ef5501e$var$newDefaultModifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            rootBoundary: 'document'
        }
    },
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: 5,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
const $f040ddaa0ef5501e$var$defaultPopperProps = {
    modifiers: $f040ddaa0ef5501e$var$modifiers,
    placement: 'bottom-start'
};
const $f040ddaa0ef5501e$var$newDefaultPopperProps = {
    modifiers: $f040ddaa0ef5501e$var$newDefaultModifiers,
    placement: 'bottom-start'
};
const $f040ddaa0ef5501e$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
class $f040ddaa0ef5501e$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    static{
        this.defaultProps = {
            closeMenuOnSelect: true,
            shouldCloseMenuOnTab: true,
            components: {},
            maxMenuHeight: 300,
            maxMenuWidth: 440,
            minMenuWidth: 220,
            popperProps: {},
            isSearchable: true,
            searchThreshold: 5,
            styles: {},
            options: []
        };
    }
    static getDerivedStateFromProps(props, state) {
        const newState = {};
        // Merge consumer and default popper props
        const mergedPopperProps = {
            ...(0, $eGOwo.fg)('platform_dst_nav4_layering_in_main_slot_fixes') ? $f040ddaa0ef5501e$var$newDefaultPopperProps : $f040ddaa0ef5501e$var$defaultPopperProps,
            ...props.popperProps
        };
        if (!(0, $5yteI.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
        // Merge consumer and default components
        const mergedComponents = {
            ...(0, $5nAXq.defaultComponents),
            ...props.components
        };
        if (!(0, $5yteI.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
        if (!$f040ddaa0ef5501e$var$isEmpty(newState)) return newState;
        return null;
    }
    componentDidMount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick = (0, $4eDgu.bind)(window, {
            type: 'click',
            listener: this.handleClick,
            options: {
                capture: true
            }
        });
    }
    componentWillUnmount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick?.();
        this.unbindWindowClick = null;
        this.unbindWindowKeydown?.();
        this.unbindWindowKeydown = null;
    }
    componentDidUpdate(prevProps) {
        const { isOpen: isOpen } = this.props;
        if (prevProps.isOpen !== isOpen) {
            if (isOpen === true) this.open({
                controlOverride: true
            });
            else if (isOpen === false) this.close({
                controlOverride: true
            });
        }
    }
    render() {
        const { target: target } = this.props;
        const { isOpen: isOpen } = this.state;
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $7QJq6.Manager), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gl2vi.IdProvider), {
                    postfix: "-popup-select",
                    children: ({ id: id })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lEbH4.Reference), {
                                    children: ({ ref: ref })=>target && target({
                                            isOpen: isOpen,
                                            onKeyDown: this.handleTargetKeyDown,
                                            ref: this.resolveTargetRef(ref),
                                            // Should technically be 'dialog' by default instead of 'true' via AriaAttributes, but will require further changes.
                                            // See go/DSP-22283
                                            'aria-haspopup': 'true',
                                            'aria-expanded': isOpen,
                                            'aria-controls': isOpen ? id : undefined
                                        })
                                }),
                                this.renderSelect(id)
                            ]
                        })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ctyCN.NotifyOpenLayerObserver), {
                    isOpen: this.state.isOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.menuRef = null, this.selectRef = null, this.targetRef = null, this.unbindWindowClick = null, this.unbindWindowKeydown = null, this.defaultStyles = {
            groupHeading: (provided)=>({
                    ...provided,
                    color: `var(--ds-text-subtlest, ${0, $7bb4c1736002a04a$export$eaa8c8a70ac22806})`
                })
        }, this.isOpenControlled = this.props.isOpen !== undefined, this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen, this.state = {
            focusLockEnabled: false,
            isOpen: this.defaultOpenState ?? false,
            mergedComponents: (0, $5nAXq.defaultComponents),
            mergedPopperProps: (0, $eGOwo.fg)('platform_dst_nav4_layering_in_main_slot_fixes') ? $f040ddaa0ef5501e$var$newDefaultPopperProps : $f040ddaa0ef5501e$var$defaultPopperProps
        }, // Event Handlers
        // ==============================
        this.handleTargetKeyDown = (event)=>{
            switch(event.key){
                case 'ArrowDown':
                    this.open();
                    break;
                default:
            }
        }, this.handleKeyDown = (event)=>{
            //We shouldn't close PopupSelect on tab event if there are custom interactive element.
            const tabEvent = event.key === 'Tab' && event.shiftKey || event.key === 'Tab';
            if (this.props.shouldCloseMenuOnTab && tabEvent) this.close();
            switch(event.key){
                case 'Escape':
                case 'Esc':
                    this.close();
                    break;
                default:
            }
            if (this.props.onKeyDown) /* @ts-ignore - updating type of event React.KeyboardEvent effects the unbindWindowsKeyDown listener. Check if this can be fixed once the component gets refactor to functional */ this.props.onKeyDown(event);
        }, this.handleClick = ({ target: target })=>{
            const { isOpen: isOpen } = this.state;
            // appease flow
            if (!(target instanceof Element)) return;
            // NOTE: Why not use the <Blanket /> component to close?
            // We don't want to interupt the user's flow. Taking this approach allows
            // user to click "through" to other elements and close the popout.
            if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
            // open on target click -- we can't trust consumers to spread the onClick
            // property to the target
            if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
        }, this.handleSelectChange = (value, actionMeta)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
            if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
            if (onChange) onChange(value, actionMeta);
        }, this.handleFirstPopperUpdate = ()=>{
            // When the popup opens it's focused into. Since the popup is inside a portal, it's position is
            // initially set to 0,0 - this causes the window scroll position to jump to the top. To prevent
            // this we defer enabling the focus-lock until after Popper has positioned the popup the first time.
            this.setState({
                focusLockEnabled: true
            });
        }, // Internal Lifecycle
        // ==============================
        /**
   * Opens the popup
   *
   * @param options.controlOverride  - Force the popup to open when it's open state is being controlled
   */ this.open = (options)=>{
            const { onOpen: onOpen, onMenuOpen: onMenuOpen } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup opening if it's open state is already being controlled
            return;
            if (onOpen) onOpen();
            if (onMenuOpen) onMenuOpen();
            this.setState({
                isOpen: true
            }, ()=>{
                if (this.selectRef) this.selectRef.select?.openMenu('first');
            });
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown = (0, $4eDgu.bind)(window, {
                type: 'keydown',
                listener: this.handleKeyDown,
                options: {
                    capture: true
                }
            });
        }, /**
   * Closes the popup
   *
   * @param options.controlOverride  - Force the popup to close when it's open state is being controlled
   */ this.close = (options)=>{
            //@ts-ignore react-select unsupported props
            const { onClose: onClose, onMenuClose: onMenuClose } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup closing if it's open state is already being controlled
            return;
            if (onClose) onClose();
            if (onMenuClose) onMenuClose();
            this.setState({
                isOpen: false
            });
            this.setState({
                focusLockEnabled: false
            });
            if (this.targetRef != null) this.targetRef.focus();
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        }, // Refs
        // ==============================
        this.resolveTargetRef = (popperRef)=>(ref)=>{
                // avoid thrashing fn calls
                if (!this.targetRef && popperRef && ref) {
                    this.targetRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                }
            }, this.resolveMenuRef = (popperRef)=>(ref)=>{
                this.menuRef = ref;
                if (typeof popperRef === 'function') popperRef(ref);
                else popperRef.current = ref;
            }, this.getSelectRef = (ref)=>{
            this.selectRef = ref;
        }, // Utils
        // ==============================
        // account for groups when counting options
        // this may need to be recursive, right now it just counts one level
        this.getItemCount = ()=>{
            const { options: options } = this.props;
            let count = 0;
            options.forEach((groupOrOption)=>{
                if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                else count++;
            });
            return count;
        }, this.getMaxHeight = ()=>{
            const { maxMenuHeight: maxMenuHeight } = this.props;
            if (!this.selectRef) return maxMenuHeight;
            // subtract the control height to maintain consistency
            const showSearchControl = this.showSearchControl();
            const controlRef = this.selectRef.select?.controlRef;
            const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
            const maxHeight = maxMenuHeight - offsetHeight;
            return maxHeight;
        }, // if the threshold is exceeded, AND isSearchable is true, then display the search control
        this.showSearchControl = ()=>{
            const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
            return isSearchable && this.getItemCount() > searchThreshold;
        }, // Renderers
        // ==============================
        this.renderSelect = (id)=>{
            const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, ...props } = this.props;
            const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
            const showSearchControl = this.showSearchControl();
            const portalDestination = $f040ddaa0ef5501e$var$canUseDOM() ? document.body : null;
            if (!portalDestination || !isOpen) return null;
            const selectComponents = {
                ...mergedComponents,
                Control: showSearchControl ? mergedComponents.Control : (0, $5nAXq.DummyControl)
            };
            // @ts-ignore - TS7030: Not all code paths return a value - causing issues for help-center local consumption with TS 5.9.2
            const getLabel = ()=>{
                if (label) return label;
                else if (typeof placeholder === 'string') return placeholder;
                return undefined;
            };
            const popper = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i0xNm.Popper), {
                ...mergedPopperProps,
                onFirstUpdate: (state)=>{
                    this.handleFirstPopperUpdate();
                    mergedPopperProps.onFirstUpdate?.(state);
                },
                children: ({ placement: placement, ref: ref, style: style })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $5nAXq.MenuDialog), {
                        // There is not a limited amount of values for the widths, so they need to remain dynamic.
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: {
                            ...style,
                            maxWidth: maxMenuWidth,
                            minWidth: minMenuWidth
                        },
                        "data-placement": placement,
                        id: id,
                        testId: testId,
                        ref: this.resolveMenuRef(ref),
                        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $1Q3jn.default), {
                            disabled: !focusLockEnabled,
                            returnFocus: true,
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c4OV1.default), {
                                    label: getLabel(),
                                    backspaceRemovesValue: false,
                                    controlShouldRenderValue: false,
                                    isClearable: false,
                                    tabSelectsValue: false,
                                    menuIsOpen: true,
                                    placeholder: placeholder,
                                    ref: this.getSelectRef,
                                    ...props,
                                    isSearchable: showSearchControl,
                                    styles: (0, $e9zKl.mergeStyles)(this.defaultStyles, props.styles || {}),
                                    maxMenuHeight: this.getMaxHeight(),
                                    components: selectComponents,
                                    onChange: this.handleSelectChange,
                                    testId: testId
                                }),
                                footer
                            ]
                        })
                    })
            });
            return mergedPopperProps.strategy === 'fixed' ? popper : /*#__PURE__*/ (0, $aQK2r.createPortal)(popper, portalDestination);
        }, this.handleOpenLayerObserverCloseSignal = ()=>{
            this.close();
        };
    }
}

});
parcelRegister("7QJq6", function(module, exports) {
$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $5b709f3958b336e6$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $5b709f3958b336e6$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $5b709f3958b336e6$export$d0d38e7dec7a1a61);

var $eJOHy = parcelRequire("eJOHy");
var $5b709f3958b336e6$export$3dbd3405086fec7b = $eJOHy.createContext();
var $5b709f3958b336e6$export$cbabb21c2529b130 = $eJOHy.createContext();
function $5b709f3958b336e6$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $eJOHy.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $eJOHy.useRef(false);
    $eJOHy.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $eJOHy.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $eJOHy.createElement($5b709f3958b336e6$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $eJOHy.createElement($5b709f3958b336e6$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("i0xNm", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $d1c2711317bcdd69$export$badac9ada3a0bdf9);

var $eJOHy = parcelRequire("eJOHy");

var $7QJq6 = parcelRequire("7QJq6");

var $65sWw = parcelRequire("65sWw");

var $8E4Pq = parcelRequire("8E4Pq");
var $d1c2711317bcdd69$var$NOOP = function NOOP() {
    return void 0;
};
var $d1c2711317bcdd69$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $d1c2711317bcdd69$var$EMPTY_MODIFIERS = [];
function $d1c2711317bcdd69$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $d1c2711317bcdd69$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $eJOHy.useContext((0, $7QJq6.ManagerReferenceNodeContext));
    var _React$useState = $eJOHy.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $eJOHy.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $eJOHy.useEffect(function() {
        (0, $65sWw.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $eJOHy.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $8E4Pq.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $eJOHy.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $d1c2711317bcdd69$var$NOOP,
            update: update || $d1c2711317bcdd69$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $65sWw.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("65sWw", function(module, exports) {
$parcel$export(module.exports, "unwrapArray", () => $46e9a926da059f7f$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $46e9a926da059f7f$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $46e9a926da059f7f$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $46e9a926da059f7f$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $46e9a926da059f7f$export$700979bc83e7db82);

var $eJOHy = parcelRequire("eJOHy");
var $46e9a926da059f7f$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $46e9a926da059f7f$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $46e9a926da059f7f$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $46e9a926da059f7f$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $46e9a926da059f7f$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $46e9a926da059f7f$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $eJOHy.useLayoutEffect : $eJOHy.useEffect;

});

parcelRegister("8E4Pq", function(module, exports) {
$parcel$export(module.exports, "usePopper", () => $64b5cdf5dd511d2b$export$f4d5bf230a36dd6e);

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $gnxAv = parcelRequire("gnxAv");

var $aVrYR = parcelRequire("aVrYR");

var $65sWw = parcelRequire("65sWw");
var $64b5cdf5dd511d2b$var$EMPTY_MODIFIERS = [];
var $64b5cdf5dd511d2b$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $eJOHy.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $64b5cdf5dd511d2b$var$EMPTY_MODIFIERS
    };
    var _React$useState = $eJOHy.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $eJOHy.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $aQK2r.flushSync(function() {
                    setState({
                        styles: (0, $65sWw.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $65sWw.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $eJOHy.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($aVrYR)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $eJOHy.useRef();
    (0, $65sWw.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $65sWw.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $gnxAv.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("gnxAv", function(module, exports) {
$parcel$export(module.exports, "createPopper", () => $bec8d928f7873785$export$8f7491d57c8f97a9);

var $heIbG = parcelRequire("heIbG");

var $bMX9T = parcelRequire("bMX9T");

var $3lXAT = parcelRequire("3lXAT");

var $9rdGq = parcelRequire("9rdGq");

var $9HkoV = parcelRequire("9HkoV");

var $f7Vnd = parcelRequire("f7Vnd");

var $6DBHs = parcelRequire("6DBHs");

var $31C6T = parcelRequire("31C6T");

var $a6oPx = parcelRequire("a6oPx");

var $c2Bzy = parcelRequire("c2Bzy");


var $bec8d928f7873785$export$d34966752335dd47 = [
    (0, $bMX9T.default),
    (0, $3lXAT.default),
    (0, $9rdGq.default),
    (0, $9HkoV.default),
    (0, $f7Vnd.default),
    (0, $6DBHs.default),
    (0, $31C6T.default),
    (0, $a6oPx.default),
    (0, $c2Bzy.default)
];
var $bec8d928f7873785$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $heIbG.popperGenerator)({
    defaultModifiers: $bec8d928f7873785$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("heIbG", function(module, exports) {
$parcel$export(module.exports, "popperGenerator", () => $c8c60531711653f3$export$ed5e13716264f202);

var $elLvv = parcelRequire("elLvv");

var $9J30E = parcelRequire("9J30E");

var $kXPOQ = parcelRequire("kXPOQ");

var $5hADZ = parcelRequire("5hADZ");

var $467x6 = parcelRequire("467x6");

var $bQzW7 = parcelRequire("bQzW7");

var $287ko = parcelRequire("287ko");


var $gg6Qu = parcelRequire("gg6Qu");
var $c8c60531711653f3$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $c8c60531711653f3$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $c8c60531711653f3$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $c8c60531711653f3$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $c8c60531711653f3$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $gg6Qu.isElement)(reference) ? (0, $kXPOQ.default)(reference) : reference.contextElement ? (0, $kXPOQ.default)(reference.contextElement) : [],
                    popper: (0, $kXPOQ.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $467x6.default)((0, $287ko.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$c8c60531711653f3$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $elLvv.default)(reference, (0, $5hADZ.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $9J30E.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $bQzW7.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$c8c60531711653f3$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $c8c60531711653f3$export$8f7491d57c8f97a9 = /*#__PURE__*/ $c8c60531711653f3$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("elLvv", function(module, exports) {
$parcel$export(module.exports, "default", () => $a727e0cb46add6f0$export$2e2bcd8739ae039);

var $k65dW = parcelRequire("k65dW");

var $g4m1c = parcelRequire("g4m1c");

var $4baem = parcelRequire("4baem");

var $gg6Qu = parcelRequire("gg6Qu");

var $2uwXd = parcelRequire("2uwXd");

var $7gyBU = parcelRequire("7gyBU");

var $9Uhst = parcelRequire("9Uhst");

var $8amqe = parcelRequire("8amqe");
function $a727e0cb46add6f0$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $8amqe.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $8amqe.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $a727e0cb46add6f0$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $gg6Qu.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $gg6Qu.isHTMLElement)(offsetParent) && $a727e0cb46add6f0$var$isElementScaled(offsetParent);
    var documentElement = (0, $7gyBU.default)(offsetParent);
    var rect = (0, $k65dW.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $4baem.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $9Uhst.default)(documentElement)) scroll = (0, $g4m1c.default)(offsetParent);
        if ((0, $gg6Qu.isHTMLElement)(offsetParent)) {
            offsets = (0, $k65dW.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $2uwXd.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("k65dW", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea186b851f3316f0$export$2e2bcd8739ae039);

var $gg6Qu = parcelRequire("gg6Qu");

var $8amqe = parcelRequire("8amqe");

var $fWmj3 = parcelRequire("fWmj3");

var $2aPrh = parcelRequire("2aPrh");
function $ea186b851f3316f0$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $gg6Qu.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $8amqe.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $8amqe.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $gg6Qu.isElement)(element) ? (0, $fWmj3.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $2aPrh.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("gg6Qu", function(module, exports) {
$parcel$export(module.exports, "isElement", () => $bd63735f7342e30f$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $bd63735f7342e30f$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $bd63735f7342e30f$export$af51f0f06c0f328a);

var $fWmj3 = parcelRequire("fWmj3");
function $bd63735f7342e30f$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $fWmj3.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $bd63735f7342e30f$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $fWmj3.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $bd63735f7342e30f$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $fWmj3.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("fWmj3", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9ad935b388d902f$export$2e2bcd8739ae039);
function $b9ad935b388d902f$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("8amqe", function(module, exports) {
$parcel$export(module.exports, "max", () => $5f20a67c3007211c$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $5f20a67c3007211c$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $5f20a67c3007211c$export$2077e0241d6afd3c);
var $5f20a67c3007211c$export$8960430cfd85939f = Math.max;
var $5f20a67c3007211c$export$96ec731ed4dcb222 = Math.min;
var $5f20a67c3007211c$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("2aPrh", function(module, exports) {
$parcel$export(module.exports, "default", () => $19546aaa985cfe85$export$2e2bcd8739ae039);

var $jfbGV = parcelRequire("jfbGV");
function $19546aaa985cfe85$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $jfbGV.default)());
}

});
parcelRegister("jfbGV", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0287cade039ed57$export$2e2bcd8739ae039);
function $e0287cade039ed57$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("g4m1c", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb2e196d14a21ebf$export$2e2bcd8739ae039);

var $cOno9 = parcelRequire("cOno9");

var $fWmj3 = parcelRequire("fWmj3");

var $gg6Qu = parcelRequire("gg6Qu");

var $cjw1I = parcelRequire("cjw1I");
function $bb2e196d14a21ebf$export$2e2bcd8739ae039(node) {
    if (node === (0, $fWmj3.default)(node) || !(0, $gg6Qu.isHTMLElement)(node)) return (0, $cOno9.default)(node);
    else return (0, $cjw1I.default)(node);
}

});
parcelRegister("cOno9", function(module, exports) {
$parcel$export(module.exports, "default", () => $953c4c05b181c08e$export$2e2bcd8739ae039);

var $fWmj3 = parcelRequire("fWmj3");
function $953c4c05b181c08e$export$2e2bcd8739ae039(node) {
    var win = (0, $fWmj3.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("cjw1I", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f701a3aded86182$export$2e2bcd8739ae039);
function $8f701a3aded86182$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("4baem", function(module, exports) {
$parcel$export(module.exports, "default", () => $30b0201497441060$export$2e2bcd8739ae039);
function $30b0201497441060$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("2uwXd", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d07f21abc9989f4$export$2e2bcd8739ae039);

var $k65dW = parcelRequire("k65dW");

var $7gyBU = parcelRequire("7gyBU");

var $cOno9 = parcelRequire("cOno9");
function $1d07f21abc9989f4$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $k65dW.default)((0, $7gyBU.default)(element)).left + (0, $cOno9.default)(element).scrollLeft;
}

});
parcelRegister("7gyBU", function(module, exports) {
$parcel$export(module.exports, "default", () => $54a4dfebec89ee7e$export$2e2bcd8739ae039);

var $gg6Qu = parcelRequire("gg6Qu");
function $54a4dfebec89ee7e$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $gg6Qu.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("9Uhst", function(module, exports) {
$parcel$export(module.exports, "default", () => $7366e2de4224a174$export$2e2bcd8739ae039);

var $gJ1QC = parcelRequire("gJ1QC");
function $7366e2de4224a174$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $gJ1QC.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("gJ1QC", function(module, exports) {
$parcel$export(module.exports, "default", () => $c2d24838526c2191$export$2e2bcd8739ae039);

var $fWmj3 = parcelRequire("fWmj3");
function $c2d24838526c2191$export$2e2bcd8739ae039(element) {
    return (0, $fWmj3.default)(element).getComputedStyle(element);
}

});



parcelRegister("9J30E", function(module, exports) {
$parcel$export(module.exports, "default", () => $714aa6a5cb9954a0$export$2e2bcd8739ae039);

var $k65dW = parcelRequire("k65dW");
function $714aa6a5cb9954a0$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $k65dW.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("kXPOQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f431837fa9e8ca57$export$2e2bcd8739ae039);

var $2CQVf = parcelRequire("2CQVf");

var $5ewz1 = parcelRequire("5ewz1");

var $fWmj3 = parcelRequire("fWmj3");

var $9Uhst = parcelRequire("9Uhst");
function $f431837fa9e8ca57$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2CQVf.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $fWmj3.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $9Uhst.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($f431837fa9e8ca57$export$2e2bcd8739ae039((0, $5ewz1.default)(target)));
}

});
parcelRegister("2CQVf", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e982ea2e37d1ae0$export$2e2bcd8739ae039);

var $5ewz1 = parcelRequire("5ewz1");

var $9Uhst = parcelRequire("9Uhst");

var $4baem = parcelRequire("4baem");

var $gg6Qu = parcelRequire("gg6Qu");
function $1e982ea2e37d1ae0$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $4baem.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $gg6Qu.isHTMLElement)(node) && (0, $9Uhst.default)(node)) return node;
    return $1e982ea2e37d1ae0$export$2e2bcd8739ae039((0, $5ewz1.default)(node));
}

});
parcelRegister("5ewz1", function(module, exports) {
$parcel$export(module.exports, "default", () => $3cf7850ed94ba01d$export$2e2bcd8739ae039);

var $4baem = parcelRequire("4baem");

var $7gyBU = parcelRequire("7gyBU");

var $gg6Qu = parcelRequire("gg6Qu");
function $3cf7850ed94ba01d$export$2e2bcd8739ae039(element) {
    if ((0, $4baem.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $gg6Qu.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $7gyBU.default)(element) // fallback
    );
}

});



parcelRegister("5hADZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d8af70a4a661074$export$2e2bcd8739ae039);

var $fWmj3 = parcelRequire("fWmj3");

var $4baem = parcelRequire("4baem");

var $gJ1QC = parcelRequire("gJ1QC");

var $gg6Qu = parcelRequire("gg6Qu");

var $fJU2S = parcelRequire("fJU2S");

var $5ewz1 = parcelRequire("5ewz1");

var $jfbGV = parcelRequire("jfbGV");
function $3d8af70a4a661074$var$getTrueOffsetParent(element) {
    if (!(0, $gg6Qu.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $gJ1QC.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $3d8af70a4a661074$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $jfbGV.default)());
    var isIE = /Trident/i.test((0, $jfbGV.default)());
    if (isIE && (0, $gg6Qu.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $gJ1QC.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $5ewz1.default)(element);
    if ((0, $gg6Qu.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $gg6Qu.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $4baem.default)(currentNode)) < 0){
        var css = (0, $gJ1QC.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $3d8af70a4a661074$export$2e2bcd8739ae039(element) {
    var window = (0, $fWmj3.default)(element);
    var offsetParent = $3d8af70a4a661074$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $fJU2S.default)(offsetParent) && (0, $gJ1QC.default)(offsetParent).position === 'static')offsetParent = $3d8af70a4a661074$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $4baem.default)(offsetParent) === 'html' || (0, $4baem.default)(offsetParent) === 'body' && (0, $gJ1QC.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $3d8af70a4a661074$var$getContainingBlock(element) || window;
}

});
parcelRegister("fJU2S", function(module, exports) {
$parcel$export(module.exports, "default", () => $b756886c0c925609$export$2e2bcd8739ae039);

var $4baem = parcelRequire("4baem");
function $b756886c0c925609$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $4baem.default)(element)) >= 0;
}

});


parcelRegister("467x6", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fbd90d3076093ac$export$2e2bcd8739ae039);

var $1LHyG = parcelRequire("1LHyG");
function $2fbd90d3076093ac$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $2fbd90d3076093ac$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $2fbd90d3076093ac$var$order(modifiers); // order based on phase
    return (0, $1LHyG.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("1LHyG", function(module, exports) {
$parcel$export(module.exports, "top", () => $149bf80282ae6f0a$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $149bf80282ae6f0a$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $149bf80282ae6f0a$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $149bf80282ae6f0a$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $149bf80282ae6f0a$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $149bf80282ae6f0a$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $149bf80282ae6f0a$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $149bf80282ae6f0a$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $149bf80282ae6f0a$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $149bf80282ae6f0a$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $149bf80282ae6f0a$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $149bf80282ae6f0a$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $149bf80282ae6f0a$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $149bf80282ae6f0a$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $149bf80282ae6f0a$export$d087d3878fdf71d5);
var $149bf80282ae6f0a$export$1e95b668f3b82d = 'top';
var $149bf80282ae6f0a$export$40e543e69a8b3fbb = 'bottom';
var $149bf80282ae6f0a$export$79ffe56a765070d2 = 'right';
var $149bf80282ae6f0a$export$eabcd2c8791e7bf4 = 'left';
var $149bf80282ae6f0a$export$dfb5619354ba860 = 'auto';
var $149bf80282ae6f0a$export$aec2ce47c367b8c3 = [
    $149bf80282ae6f0a$export$1e95b668f3b82d,
    $149bf80282ae6f0a$export$40e543e69a8b3fbb,
    $149bf80282ae6f0a$export$79ffe56a765070d2,
    $149bf80282ae6f0a$export$eabcd2c8791e7bf4
];
var $149bf80282ae6f0a$export$b3571188c770cc5a = 'start';
var $149bf80282ae6f0a$export$bd5df0f255a350f8 = 'end';
var $149bf80282ae6f0a$export$390fd549c5303b4d = 'clippingParents';
var $149bf80282ae6f0a$export$d7b7311ec04a3e8f = 'viewport';
var $149bf80282ae6f0a$export$ae5ab1c730825774 = 'popper';
var $149bf80282ae6f0a$export$ca50aac9f3ba507f = 'reference';
var $149bf80282ae6f0a$export$368f9a87e87fa4e1 = /*#__PURE__*/ $149bf80282ae6f0a$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $149bf80282ae6f0a$export$b3571188c770cc5a,
        placement + "-" + $149bf80282ae6f0a$export$bd5df0f255a350f8
    ]);
}, []);
var $149bf80282ae6f0a$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($149bf80282ae6f0a$export$aec2ce47c367b8c3, [
    $149bf80282ae6f0a$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $149bf80282ae6f0a$export$b3571188c770cc5a,
        placement + "-" + $149bf80282ae6f0a$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $149bf80282ae6f0a$export$421679a7c3d56e = 'beforeRead';
var $149bf80282ae6f0a$export$aafa59e2e03f2942 = 'read';
var $149bf80282ae6f0a$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $149bf80282ae6f0a$export$c65e99957a05207c = 'beforeMain';
var $149bf80282ae6f0a$export$f22da7240b7add18 = 'main';
var $149bf80282ae6f0a$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $149bf80282ae6f0a$export$8d4d2d70e7d46032 = 'beforeWrite';
var $149bf80282ae6f0a$export$68d8715fc104d294 = 'write';
var $149bf80282ae6f0a$export$70a6e5159acce2e6 = 'afterWrite';
var $149bf80282ae6f0a$export$d087d3878fdf71d5 = [
    $149bf80282ae6f0a$export$421679a7c3d56e,
    $149bf80282ae6f0a$export$aafa59e2e03f2942,
    $149bf80282ae6f0a$export$6964f6c886723980,
    $149bf80282ae6f0a$export$c65e99957a05207c,
    $149bf80282ae6f0a$export$f22da7240b7add18,
    $149bf80282ae6f0a$export$bab79516f2d662fe,
    $149bf80282ae6f0a$export$8d4d2d70e7d46032,
    $149bf80282ae6f0a$export$68d8715fc104d294,
    $149bf80282ae6f0a$export$70a6e5159acce2e6
];

});


parcelRegister("bQzW7", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a006d460a409cf5$export$2e2bcd8739ae039);
function $8a006d460a409cf5$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("287ko", function(module, exports) {
$parcel$export(module.exports, "default", () => $18d203526ff3d300$export$2e2bcd8739ae039);
function $18d203526ff3d300$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("bMX9T", function(module, exports) {
$parcel$export(module.exports, "default", () => $89521114592bb4c0$export$2e2bcd8739ae039);

var $fWmj3 = parcelRequire("fWmj3");
var $89521114592bb4c0$var$passive = {
    passive: true
};
function $89521114592bb4c0$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $fWmj3.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $89521114592bb4c0$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $89521114592bb4c0$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $89521114592bb4c0$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $89521114592bb4c0$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $89521114592bb4c0$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $89521114592bb4c0$var$effect,
    data: {}
};

});

parcelRegister("3lXAT", function(module, exports) {
$parcel$export(module.exports, "default", () => $27118f602f9fb7ed$export$2e2bcd8739ae039);

var $fl9ah = parcelRequire("fl9ah");
function $27118f602f9fb7ed$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $fl9ah.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $27118f602f9fb7ed$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $27118f602f9fb7ed$var$popperOffsets,
    data: {}
};

});
parcelRegister("fl9ah", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2afed1d882b4807$export$2e2bcd8739ae039);

var $ix6Fe = parcelRequire("ix6Fe");

var $3nitp = parcelRequire("3nitp");

var $aRMwh = parcelRequire("aRMwh");

var $1LHyG = parcelRequire("1LHyG");
function $b2afed1d882b4807$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $ix6Fe.default)(placement) : null;
    var variation = placement ? (0, $3nitp.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1LHyG.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1LHyG.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1LHyG.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1LHyG.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $aRMwh.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $1LHyG.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1LHyG.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("ix6Fe", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7e07a637cd667c6$export$2e2bcd8739ae039);

function $d7e07a637cd667c6$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("3nitp", function(module, exports) {
$parcel$export(module.exports, "default", () => $2751d9819e47949e$export$2e2bcd8739ae039);
function $2751d9819e47949e$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("aRMwh", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e947d96e10112da$export$2e2bcd8739ae039);
function $7e947d96e10112da$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("9rdGq", function(module, exports) {
$parcel$export(module.exports, "default", () => $6df13fe20ccb3860$export$2e2bcd8739ae039);

var $1LHyG = parcelRequire("1LHyG");

var $5hADZ = parcelRequire("5hADZ");

var $fWmj3 = parcelRequire("fWmj3");

var $7gyBU = parcelRequire("7gyBU");

var $gJ1QC = parcelRequire("gJ1QC");

var $ix6Fe = parcelRequire("ix6Fe");

var $3nitp = parcelRequire("3nitp");

var $8amqe = parcelRequire("8amqe");
var $6df13fe20ccb3860$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $6df13fe20ccb3860$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $8amqe.round)(x * dpr) / dpr || 0,
        y: (0, $8amqe.round)(y * dpr) / dpr || 0
    };
}
function $6df13fe20ccb3860$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $1LHyG.left);
    var sideY = (0, $1LHyG.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $5hADZ.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $fWmj3.default)(popper)) {
            offsetParent = (0, $7gyBU.default)(popper);
            if ((0, $gJ1QC.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1LHyG.top) || (placement === (0, $1LHyG.left) || placement === (0, $1LHyG.right)) && variation === (0, $1LHyG.end)) {
            sideY = (0, $1LHyG.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1LHyG.left) || (placement === (0, $1LHyG.top) || placement === (0, $1LHyG.bottom)) && variation === (0, $1LHyG.end)) {
            sideX = (0, $1LHyG.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $6df13fe20ccb3860$var$unsetSides);
    var _ref4 = roundOffsets === true ? $6df13fe20ccb3860$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $fWmj3.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $6df13fe20ccb3860$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $ix6Fe.default)(state.placement),
        variation: (0, $3nitp.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $6df13fe20ccb3860$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $6df13fe20ccb3860$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $6df13fe20ccb3860$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $6df13fe20ccb3860$var$computeStyles,
    data: {}
};

});

parcelRegister("9HkoV", function(module, exports) {
$parcel$export(module.exports, "default", () => $70f7f4679a787bbc$export$2e2bcd8739ae039);

var $4baem = parcelRequire("4baem");

var $gg6Qu = parcelRequire("gg6Qu");
// and applies them to the HTMLElements such as popper and arrow
function $70f7f4679a787bbc$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $gg6Qu.isHTMLElement)(element) || !(0, $4baem.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $70f7f4679a787bbc$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $gg6Qu.isHTMLElement)(element) || !(0, $4baem.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $70f7f4679a787bbc$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $70f7f4679a787bbc$var$applyStyles,
    effect: $70f7f4679a787bbc$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("f7Vnd", function(module, exports) {
$parcel$export(module.exports, "default", () => $b034039cedbbe126$export$2e2bcd8739ae039);

var $ix6Fe = parcelRequire("ix6Fe");

var $1LHyG = parcelRequire("1LHyG");
function $b034039cedbbe126$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $ix6Fe.default)(placement);
    var invertDistance = [
        (0, $1LHyG.left),
        (0, $1LHyG.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1LHyG.left),
        (0, $1LHyG.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $b034039cedbbe126$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1LHyG.placements).reduce(function(acc, placement) {
        acc[placement] = $b034039cedbbe126$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $b034039cedbbe126$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $b034039cedbbe126$var$offset
};

});

parcelRegister("6DBHs", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d53a105c719d71f$export$2e2bcd8739ae039);

var $jEhSs = parcelRequire("jEhSs");

var $ix6Fe = parcelRequire("ix6Fe");

var $3nM6l = parcelRequire("3nM6l");

var $2L52j = parcelRequire("2L52j");

var $zvQQI = parcelRequire("zvQQI");

var $1LHyG = parcelRequire("1LHyG");

var $3nitp = parcelRequire("3nitp");
function $4d53a105c719d71f$var$getExpandedFallbackPlacements(placement) {
    if ((0, $ix6Fe.default)(placement) === (0, $1LHyG.auto)) return [];
    var oppositePlacement = (0, $jEhSs.default)(placement);
    return [
        (0, $3nM6l.default)(placement),
        oppositePlacement,
        (0, $3nM6l.default)(oppositePlacement)
    ];
}
function $4d53a105c719d71f$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $ix6Fe.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $jEhSs.default)(preferredPlacement)
    ] : $4d53a105c719d71f$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $ix6Fe.default)(placement) === (0, $1LHyG.auto) ? (0, $zvQQI.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $ix6Fe.default)(placement);
        var isStartVariation = (0, $3nitp.default)(placement) === (0, $1LHyG.start);
        var isVertical = [
            (0, $1LHyG.top),
            (0, $1LHyG.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $2L52j.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1LHyG.right) : (0, $1LHyG.left) : isStartVariation ? (0, $1LHyG.bottom) : (0, $1LHyG.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $jEhSs.default)(mainVariationSide);
        var altVariationSide = (0, $jEhSs.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $4d53a105c719d71f$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $4d53a105c719d71f$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("jEhSs", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4df9ecf09fd7b98$export$2e2bcd8739ae039);
var $e4df9ecf09fd7b98$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $e4df9ecf09fd7b98$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $e4df9ecf09fd7b98$var$hash[matched];
    });
}

});

parcelRegister("3nM6l", function(module, exports) {
$parcel$export(module.exports, "default", () => $2768d4fade00acc0$export$2e2bcd8739ae039);
var $2768d4fade00acc0$var$hash = {
    start: 'end',
    end: 'start'
};
function $2768d4fade00acc0$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $2768d4fade00acc0$var$hash[matched];
    });
}

});

parcelRegister("2L52j", function(module, exports) {
$parcel$export(module.exports, "default", () => $2023e0a84dae9603$export$2e2bcd8739ae039);

var $9x9tN = parcelRequire("9x9tN");

var $7gyBU = parcelRequire("7gyBU");

var $k65dW = parcelRequire("k65dW");

var $fl9ah = parcelRequire("fl9ah");

var $in7or = parcelRequire("in7or");

var $1LHyG = parcelRequire("1LHyG");

var $gg6Qu = parcelRequire("gg6Qu");

var $LmsI1 = parcelRequire("LmsI1");

var $dOabu = parcelRequire("dOabu");
function $2023e0a84dae9603$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1LHyG.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1LHyG.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1LHyG.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $LmsI1.default)(typeof padding !== 'number' ? padding : (0, $dOabu.default)(padding, (0, $1LHyG.basePlacements)));
    var altContext = elementContext === (0, $1LHyG.popper) ? (0, $1LHyG.reference) : (0, $1LHyG.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $9x9tN.default)((0, $gg6Qu.isElement)(element) ? element : element.contextElement || (0, $7gyBU.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $k65dW.default)(state.elements.reference);
    var popperOffsets = (0, $fl9ah.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $in7or.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1LHyG.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1LHyG.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1LHyG.right),
                (0, $1LHyG.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1LHyG.top),
                (0, $1LHyG.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("9x9tN", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f0e8c9530387084$export$2e2bcd8739ae039);

var $1LHyG = parcelRequire("1LHyG");

var $3xt5L = parcelRequire("3xt5L");

var $9oWt3 = parcelRequire("9oWt3");

var $kXPOQ = parcelRequire("kXPOQ");

var $5hADZ = parcelRequire("5hADZ");

var $7gyBU = parcelRequire("7gyBU");

var $gJ1QC = parcelRequire("gJ1QC");

var $gg6Qu = parcelRequire("gg6Qu");

var $k65dW = parcelRequire("k65dW");

var $5ewz1 = parcelRequire("5ewz1");

var $96vJk = parcelRequire("96vJk");

var $4baem = parcelRequire("4baem");

var $in7or = parcelRequire("in7or");

var $8amqe = parcelRequire("8amqe");
function $6f0e8c9530387084$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $k65dW.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $6f0e8c9530387084$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1LHyG.viewport) ? (0, $in7or.default)((0, $3xt5L.default)(element, strategy)) : (0, $gg6Qu.isElement)(clippingParent) ? $6f0e8c9530387084$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $in7or.default)((0, $9oWt3.default)((0, $7gyBU.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $6f0e8c9530387084$var$getClippingParents(element) {
    var clippingParents = (0, $kXPOQ.default)((0, $5ewz1.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $gJ1QC.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $gg6Qu.isHTMLElement)(element) ? (0, $5hADZ.default)(element) : element;
    if (!(0, $gg6Qu.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $gg6Qu.isElement)(clippingParent) && (0, $96vJk.default)(clippingParent, clipperElement) && (0, $4baem.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $6f0e8c9530387084$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $6f0e8c9530387084$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $6f0e8c9530387084$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $8amqe.max)(rect.top, accRect.top);
        accRect.right = (0, $8amqe.min)(rect.right, accRect.right);
        accRect.bottom = (0, $8amqe.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $8amqe.max)(rect.left, accRect.left);
        return accRect;
    }, $6f0e8c9530387084$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("3xt5L", function(module, exports) {
$parcel$export(module.exports, "default", () => $293b0537fae813b9$export$2e2bcd8739ae039);

var $fWmj3 = parcelRequire("fWmj3");

var $7gyBU = parcelRequire("7gyBU");

var $2uwXd = parcelRequire("2uwXd");

var $2aPrh = parcelRequire("2aPrh");
function $293b0537fae813b9$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $fWmj3.default)(element);
    var html = (0, $7gyBU.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $2aPrh.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $2uwXd.default)(element),
        y: y
    };
}

});

parcelRegister("9oWt3", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d83b5603b3586ee$export$2e2bcd8739ae039);

var $7gyBU = parcelRequire("7gyBU");

var $gJ1QC = parcelRequire("gJ1QC");

var $2uwXd = parcelRequire("2uwXd");

var $cOno9 = parcelRequire("cOno9");

var $8amqe = parcelRequire("8amqe");
function $6d83b5603b3586ee$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $7gyBU.default)(element);
    var winScroll = (0, $cOno9.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $8amqe.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $8amqe.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $2uwXd.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $gJ1QC.default)(body || html).direction === 'rtl') x += (0, $8amqe.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("96vJk", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a0d498ab041b2ae$export$2e2bcd8739ae039);

var $gg6Qu = parcelRequire("gg6Qu");
function $6a0d498ab041b2ae$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $gg6Qu.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("in7or", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6001c20f097600c$export$2e2bcd8739ae039);
function $d6001c20f097600c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("LmsI1", function(module, exports) {
$parcel$export(module.exports, "default", () => $08e5d065659557f4$export$2e2bcd8739ae039);

var $hiKju = parcelRequire("hiKju");
function $08e5d065659557f4$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $hiKju.default)(), paddingObject);
}

});
parcelRegister("hiKju", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9880af3f66b6790$export$2e2bcd8739ae039);
function $c9880af3f66b6790$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("dOabu", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0d7d8467385dc15$export$2e2bcd8739ae039);
function $a0d7d8467385dc15$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("zvQQI", function(module, exports) {
$parcel$export(module.exports, "default", () => $06abfa066cc434b3$export$2e2bcd8739ae039);

var $3nitp = parcelRequire("3nitp");

var $1LHyG = parcelRequire("1LHyG");

var $2L52j = parcelRequire("2L52j");

var $ix6Fe = parcelRequire("ix6Fe");
function $06abfa066cc434b3$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1LHyG.placements) : _options$allowedAutoP;
    var variation = (0, $3nitp.default)(placement);
    var placements = variation ? flipVariations ? (0, $1LHyG.variationPlacements) : (0, $1LHyG.variationPlacements).filter(function(placement) {
        return (0, $3nitp.default)(placement) === variation;
    }) : (0, $1LHyG.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $2L52j.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $ix6Fe.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("31C6T", function(module, exports) {
$parcel$export(module.exports, "default", () => $233f06fcebd46aab$export$2e2bcd8739ae039);

var $1LHyG = parcelRequire("1LHyG");

var $ix6Fe = parcelRequire("ix6Fe");

var $aRMwh = parcelRequire("aRMwh");

var $52Fp0 = parcelRequire("52Fp0");

var $hPHoq = parcelRequire("hPHoq");

var $9J30E = parcelRequire("9J30E");

var $5hADZ = parcelRequire("5hADZ");

var $2L52j = parcelRequire("2L52j");

var $3nitp = parcelRequire("3nitp");

var $hiKju = parcelRequire("hiKju");

var $8amqe = parcelRequire("8amqe");
function $233f06fcebd46aab$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $2L52j.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $ix6Fe.default)(state.placement);
    var variation = (0, $3nitp.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $aRMwh.default)(basePlacement);
    var altAxis = (0, $52Fp0.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $1LHyG.top) : (0, $1LHyG.left);
        var altSide = mainAxis === 'y' ? (0, $1LHyG.bottom) : (0, $1LHyG.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1LHyG.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1LHyG.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $9J30E.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $hiKju.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $hPHoq.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $5hADZ.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $hPHoq.within)(tether ? (0, $8amqe.min)(min, tetherMin) : min, offset, tether ? (0, $8amqe.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $1LHyG.top) : (0, $1LHyG.left);
        var _altSide = mainAxis === 'x' ? (0, $1LHyG.bottom) : (0, $1LHyG.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1LHyG.top),
            (0, $1LHyG.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $hPHoq.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $hPHoq.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $233f06fcebd46aab$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $233f06fcebd46aab$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("52Fp0", function(module, exports) {
$parcel$export(module.exports, "default", () => $3abd4144d8cebe00$export$2e2bcd8739ae039);
function $3abd4144d8cebe00$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("hPHoq", function(module, exports) {
$parcel$export(module.exports, "within", () => $cfb8dc0327546b5f$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $cfb8dc0327546b5f$export$86c8af6d3ef0b4a);

var $8amqe = parcelRequire("8amqe");
function $cfb8dc0327546b5f$export$f28d906d67a997f3(min, value, max) {
    return (0, $8amqe.max)(min, (0, $8amqe.min)(value, max));
}
function $cfb8dc0327546b5f$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $cfb8dc0327546b5f$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("a6oPx", function(module, exports) {
$parcel$export(module.exports, "default", () => $75adb9ab5729b460$export$2e2bcd8739ae039);

var $ix6Fe = parcelRequire("ix6Fe");

var $9J30E = parcelRequire("9J30E");

var $96vJk = parcelRequire("96vJk");

var $5hADZ = parcelRequire("5hADZ");

var $aRMwh = parcelRequire("aRMwh");

var $hPHoq = parcelRequire("hPHoq");

var $LmsI1 = parcelRequire("LmsI1");

var $dOabu = parcelRequire("dOabu");

var $1LHyG = parcelRequire("1LHyG");
var $75adb9ab5729b460$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $LmsI1.default)(typeof padding !== 'number' ? padding : (0, $dOabu.default)(padding, (0, $1LHyG.basePlacements)));
};
function $75adb9ab5729b460$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $ix6Fe.default)(state.placement);
    var axis = (0, $aRMwh.default)(basePlacement);
    var isVertical = [
        (0, $1LHyG.left),
        (0, $1LHyG.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $75adb9ab5729b460$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $9J30E.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $1LHyG.top) : (0, $1LHyG.left);
    var maxProp = axis === 'y' ? (0, $1LHyG.bottom) : (0, $1LHyG.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $5hADZ.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $hPHoq.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $75adb9ab5729b460$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $96vJk.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $75adb9ab5729b460$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $75adb9ab5729b460$var$arrow,
    effect: $75adb9ab5729b460$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("c2Bzy", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c42d10fef006a34$export$2e2bcd8739ae039);

var $1LHyG = parcelRequire("1LHyG");

var $2L52j = parcelRequire("2L52j");
function $8c42d10fef006a34$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $8c42d10fef006a34$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1LHyG.top),
        (0, $1LHyG.right),
        (0, $1LHyG.bottom),
        (0, $1LHyG.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $8c42d10fef006a34$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $2L52j.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $2L52j.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $8c42d10fef006a34$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $8c42d10fef006a34$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $8c42d10fef006a34$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $8c42d10fef006a34$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $8c42d10fef006a34$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $8c42d10fef006a34$var$hide
};

});




parcelRegister("lEbH4", function(module, exports) {
$parcel$export(module.exports, "Reference", () => $fc26678a4f3d738c$export$e0be378c32fb70a7);

var $eJOHy = parcelRequire("eJOHy");

var $9Hk5t = parcelRequire("9Hk5t");

var $7QJq6 = parcelRequire("7QJq6");

var $65sWw = parcelRequire("65sWw");
function $fc26678a4f3d738c$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $eJOHy.useContext((0, $7QJq6.ManagerReferenceNodeSetterContext));
    var refHandler = $eJOHy.useCallback(function(node) {
        (0, $65sWw.setRef)(innerRef, node);
        (0, $65sWw.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $eJOHy.useEffect(function() {
        return function() {
            return (0, $65sWw.setRef)(innerRef, null);
        };
    }, []);
    $eJOHy.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9Hk5t)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $65sWw.unwrapArray)(children)({
        ref: refHandler
    });
}

});

parcelRegister("5yteI", function(module, exports) {
$parcel$export(module.exports, "shallowEqualObjects", () => $40b6ce70abc0b2ca$export$3e67810a3f0e9f1c);
function $40b6ce70abc0b2ca$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $40b6ce70abc0b2ca$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $40b6ce70abc0b2ca$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $40b6ce70abc0b2ca$export$967a6b9924a689f7(a, b);
    return $40b6ce70abc0b2ca$export$3e67810a3f0e9f1c(a, b);
}

});

parcelRegister("5nAXq", function(module, exports) {
$parcel$export(module.exports, "MenuDialog", () => $962253e5722485a0$export$c94219dad7c0e37d);
$parcel$export(module.exports, "DummyControl", () => $962253e5722485a0$export$87ce933b7fc29b8c);
$parcel$export(module.exports, "defaultComponents", () => $962253e5722485a0$export$71abc632aa29e6fe);
/* components.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dqx2X = parcelRequire("dqx2X");

var $6XEne = parcelRequire("6XEne");

var $6fs4r = parcelRequire("6fs4r");
const $962253e5722485a0$var$menuDialogStyles = null;
const $962253e5722485a0$export$c94219dad7c0e37d = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, id: id, style: style, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        id: id,
        "data-testid": testId && `${testId}--menu`,
        className: (0, $hcewu.default)([
            "_2rko12b0 _1pby16oo _bfhk1bhr _16qseva7"
        ]),
        children: children
    });
});
// ==============================
// Custom Components
// ==============================
const $962253e5722485a0$var$dropdownStyles = null;
const $962253e5722485a0$var$DropdownIndicator = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_1bsbzwfg _12l2v77o _y3gn1h6o"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dqx2X))), {
            color: "currentColor",
            label: ""
        })
    });
const $962253e5722485a0$var$controlStyles = null;
const $962253e5722485a0$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: innerRef,
        className: (0, $hcewu.default)([
            "_85i51b66 _1q51u2gc _y4tiu2gc _bozgu2gc"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).Control, {
            ...props,
            innerProps: innerProps
        })
    });
const $962253e5722485a0$export$87ce933b7fc29b8c = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $6fs4r.default), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).Control, {
            ...props
        })
    });
// NOTE `props` intentionally omitted from `Fragment`
const $962253e5722485a0$var$Menu = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ...innerProps,
        children: children
    });
// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
const $962253e5722485a0$var$ClearIndicator = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).ClearIndicator, {
        ...props
    });
const $962253e5722485a0$var$MultiValueRemove = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).MultiValueRemove, {
        ...props
    });
const $962253e5722485a0$export$71abc632aa29e6fe = {
    Control: $962253e5722485a0$var$Control,
    DropdownIndicator: $962253e5722485a0$var$DropdownIndicator,
    Menu: $962253e5722485a0$var$Menu,
    ClearIndicator: $962253e5722485a0$var$ClearIndicator,
    MultiValueRemove: $962253e5722485a0$var$MultiValueRemove
};

});

parcelRegister("ctyCN", function(module, exports) {
$parcel$export(module.exports, "NotifyOpenLayerObserver", () => $5efc0b15e3dedaed$export$17baa7c95b6ba1b8);

var $5NYi5 = parcelRequire("5NYi5");
function $5efc0b15e3dedaed$export$17baa7c95b6ba1b8({ isOpen: isOpen, onClose: onClose }) {
    // @ts-ignore error TS2353: Object literal may only specify known properties, and &#39;onClose&#39; does not exist in type &#39;{ isOpen?: boolean | undefined; }&#39;.
    (0, $5NYi5.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}

});




parcelRegister("4yPQa", function(module, exports) {
$parcel$export(module.exports, "batchByKey", () => $0defaf7e1ec76e58$export$da86c38211c1c0a8);
function $0defaf7e1ec76e58$export$da86c38211c1c0a8(callback) {
    const calls = {};
    return (key, ...args)=>{
        if (!calls[key]) {
            window.setTimeout(()=>{
                callback(key, calls[key]);
                delete calls[key];
            });
            calls[key] = [];
        }
        calls[key].push(args);
    };
}

});

parcelRegister("aemwP", function(module, exports) {
$parcel$export(module.exports, "messages", () => $909cb0f93070a370$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $909cb0f93070a370$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    placeholder: {
        id: 'fabric.elements.user-picker.placeholder',
        defaultMessage: 'Enter people or teams...',
        description: 'Placeholder description for empty user/team/email select field.'
    },
    addMore: {
        id: 'fabric.elements.user-picker.placeholder.add-more',
        defaultMessage: 'add more people...',
        description: 'Placeholder for multi user picker when the field is not empty.'
    },
    remove: {
        id: 'fabric.elements.user-picker.multi.remove-item',
        defaultMessage: 'Remove',
        description: 'Tooltip for the single item remove button in a multi user select field.'
    },
    clear: {
        id: 'fabric.elements.user-picker.single.clear',
        defaultMessage: 'Clear',
        description: 'Tooltip for clear button in the single user select field.'
    },
    errorMessage: {
        id: 'fabric.elements.user-picker.error.message',
        defaultMessage: 'Something went wrong',
        description: 'Error message to display when options fail to load.'
    },
    memberCountWithoutYou: {
        id: 'fabric.elements.user-picker.team.member.count',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}",
        description: 'Byline to show the number of members in the team when the current user is not a member of the team'
    },
    memberCountWithYou: {
        id: 'fabric.elements.user-picker.team.member.count.including.you',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you",
        description: 'Byline to show the number of members in the team when the current user is also a member of the team'
    },
    plus50MembersWithoutYou: {
        id: 'fabric.elements.user-picker.team.member.50plus',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the number of members in the team when the number exceeds 50'
    },
    plus50MembersWithYou: {
        id: 'fabric.elements.user-picker.team.member.50plus.including.you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the number of members in the team when the number exceeds 50 and also includes the current user'
    },
    addEmail: {
        id: 'fabric.elements.user-picker.email.add',
        defaultMessage: 'Add user',
        description: 'Byline for valid email option.'
    },
    selectToAddEmail: {
        id: 'fabric.elements.user-picker.email.select.to.add',
        defaultMessage: 'Select an email address',
        description: 'Byline for valid email option.'
    },
    continueToAddEmail: {
        id: 'fabric.elements.user-picker.email.add.potential',
        defaultMessage: 'Enter an email address',
        description: 'Byline for a potentially valid email option.'
    },
    groupByline: {
        id: 'fabric.elements.user-picker.group.byline',
        defaultMessage: 'Admin-managed group',
        description: 'Byline for admin-managed groups'
    },
    externalUserSourcesHeading: {
        id: 'fabric.elements.user-picker.external.sourced.from',
        defaultMessage: 'Found in:',
        description: 'From where the external user is coming'
    },
    externalUserSourcesError: {
        id: 'fabric.elements.user-picker.external.sourced.error',
        defaultMessage: "We can't connect you right now.",
        description: "Error message when we can't fetch a user's import sources"
    },
    slackProvider: {
        id: 'fabric.elements.user-picker.slack.provider',
        defaultMessage: 'Slack',
        description: 'This external user is sourced from Slack provider'
    },
    googleProvider: {
        id: 'fabric.elements.user-picker.google.provider',
        defaultMessage: 'Google',
        description: 'This external user is sourced from Google provider'
    },
    microsoftProvider: {
        id: 'fabric.elements.user-picker.microsoft.provider',
        defaultMessage: 'Microsoft',
        description: 'This external user is sourced from Microsoft provider'
    },
    gitHubProvider: {
        id: 'fabric.elements.user-picker.github.provider',
        defaultMessage: 'GitHub',
        description: 'This external user is sourced from GitHub provider'
    },
    jiraSource: {
        id: 'fabric.elements.user-picker.source.jira',
        defaultMessage: 'Jira',
        description: 'This external user is sourced from Jira'
    },
    confluenceSource: {
        id: 'fabric.elements.user-picker.source.confluence',
        defaultMessage: 'Confluence',
        description: 'This external user is sourced from Confluence'
    },
    otherAtlassianSource: {
        id: 'fabric.elements.user-picker.source.other-atlassian',
        defaultMessage: 'Other Atlassian products',
        description: 'This external user is sourced from Atlassian products other than Jira and Confluence'
    },
    otherAtlassianSourceAppify: {
        id: 'fabric.elements.user-picker.source.other-atlassian-appify',
        defaultMessage: 'Other Atlassian apps',
        description: 'This external user is sourced from Atlassian products other than Jira and Confluence'
    },
    memberLozengeText: {
        id: 'fabric.elements.user-picker.member.lozenge.text',
        defaultMessage: 'MEMBER',
        description: 'Text within the Lozenge when the user is a workspace member'
    },
    guestLozengeText: {
        id: 'fabric.elements.user-picker.guest.lozenge.text',
        defaultMessage: 'GUEST',
        description: 'Text within the lozenge when the user is a guest of confluence'
    },
    guestUserLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.user',
        defaultMessage: 'Guests can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for guest lozenge showing that a user is a guest in Confluence'
    },
    guestGroupLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.group',
        defaultMessage: 'Guest groups can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for lozenge showing that a group is for guests in Confluence'
    },
    userTypeLabel: {
        id: 'fabric.elements.user-picker.user.type.label',
        defaultMessage: 'People',
        description: 'Label for user type'
    },
    teamTypeLabel: {
        id: 'fabric.elements.user-picker.team.type.label',
        defaultMessage: 'Teams',
        description: 'Label for team type'
    },
    emailTypeLabel: {
        id: 'fabric.elements.user-picker.email.type.label',
        defaultMessage: 'Emails',
        description: 'Label for email type'
    },
    groupTypeLabel: {
        id: 'fabric.elements.user-picker.group.type.label',
        defaultMessage: 'Groups',
        description: 'Label for group type'
    },
    externalUserTypeLabel: {
        id: 'fabric.elements.user-picker.external.user.type.label',
        defaultMessage: 'External Users',
        description: 'Label for external user type'
    },
    customTypeLabel: {
        id: 'fabric.elements.user-picker.custom.type.label',
        defaultMessage: 'Customs',
        description: 'Label for custom type'
    },
    otherTypeLabel: {
        id: 'fabric.elements.user-picker.other.type.label',
        defaultMessage: 'Others',
        description: 'Label for other type'
    }
});

});

parcelRegister("ersOA", function(module, exports) {
$parcel$export(module.exports, "groupOptionsByType", () => $b84ef595e65cee7a$export$393a985f7dd07cfe);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $LFmXM = parcelRequire("LFmXM");

var $aemwP = parcelRequire("aemwP");
const $b84ef595e65cee7a$var$getLabelForType = (type)=>{
    switch(type){
        case 'user':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $aemwP.messages).userTypeLabel
            });
        case 'team':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $aemwP.messages).teamTypeLabel
            });
        case 'group':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $aemwP.messages).groupTypeLabel
            });
        case 'custom':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $aemwP.messages).customTypeLabel
            });
        case 'external_user':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $aemwP.messages).externalUserTypeLabel
            });
        default:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $aemwP.messages).otherTypeLabel
            });
    }
};
const $b84ef595e65cee7a$export$393a985f7dd07cfe = (0, $LFmXM.default)((options, groupByTypeOrder)=>{
    // If groupByTypeOrder is empty, just return the original options
    if (groupByTypeOrder.length === 0) return options;
    const groupedMap = new Map();
    options.forEach((option)=>{
        const type = option.data.type || 'other';
        if (!groupedMap.has(type)) groupedMap.set(type, []);
        groupedMap.get(type).push(option);
    });
    const result = [];
    // add groups in the specified order
    // type is not in groupByTypeOrder, don't add it to the result
    groupByTypeOrder.forEach((type)=>{
        if (groupedMap.has(type)) {
            result.push({
                label: $b84ef595e65cee7a$var$getLabelForType(type),
                options: groupedMap.get(type)
            });
            groupedMap.delete(type);
        }
    });
    return result;
});

});

parcelRegister("1FdfR", function(module, exports) {
$parcel$export(module.exports, "userPickerRenderedUfoExperience", () => $7336f83ae434c834$export$b49757166e1acfc2);
$parcel$export(module.exports, "userPickerOptionsShownUfoExperience", () => $7336f83ae434c834$export$135a264e0da507ae);
$parcel$export(module.exports, "UfoErrorBoundary", () => $7336f83ae434c834$export$5ef1c2550074a375);

var $eJOHy = parcelRequire("eJOHy");

var $9iIu4 = parcelRequire("9iIu4");
var $aRnO1 = parcelRequire("aRnO1");
var $g0oDq = parcelRequire("g0oDq");
const $7336f83ae434c834$export$b49757166e1acfc2 = new (0, $9iIu4.ConcurrentExperience)('user-picker-rendered', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $aRnO1.ExperienceTypes).Load,
    performanceType: (0, $aRnO1.ExperiencePerformanceTypes).PageSegmentLoad
});
const $7336f83ae434c834$export$135a264e0da507ae = new (0, $9iIu4.ConcurrentExperience)('user-picker-options-shown', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $aRnO1.ExperienceTypes).Operation,
    performanceType: (0, $aRnO1.ExperiencePerformanceTypes).InlineResult
});
class $7336f83ae434c834$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidCatch() {
        const instance = $7336f83ae434c834$export$b49757166e1acfc2.getInstance(this.props.id);
        if (instance.state.id !== (0, $g0oDq.UFOExperienceState).FAILED.id) instance.failure();
    }
    render() {
        return this.props.children;
    }
}

});


parcelRegister("7Vnqr", function(module, exports) {
$parcel$export(module.exports, "getStyles", () => $b204074a529ee29d$export$ffd58b7f6f099a57);
$parcel$export(module.exports, "getPopupStyles", () => $b204074a529ee29d$export$4e983f376ad8a3af);


var $LFmXM = parcelRequire("LFmXM");

var $e9zKl = parcelRequire("e9zKl");

var $eGOwo = parcelRequire("eGOwo");
const $b204074a529ee29d$export$59c188914e58c94b = "var(--ds-space-075, 6px)";
const $b204074a529ee29d$export$53937c04f7dfc2ae = 6;
const $b204074a529ee29d$export$2c62ba763e976c54 = 39;
const $b204074a529ee29d$export$ffd58b7f6f099a57 = (0, $LFmXM.default)((width, isMulti, isCompact, overrideStyles, isVisualRefresh, isPopupStyles, height)=>{
    let styles = {
        menu: (css, state)=>({
                ...css,
                width: width,
                minWidth: state.selectProps.menuMinWidth,
                zIndex: '400'
            }),
        menuList: (css)=>({
                ...css,
                zIndex: '400'
            }),
        control: (css, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                width: width,
                borderColor: state.isFocused ? `var(--ds-border-focused, ${css.borderColor})` : state.isInvalid ? `var(--ds-border-danger, ${0, $7bb4c1736002a04a$export$2010d0fb4295b346})` : state.selectProps.subtle || state.selectProps.noBorder ? 'transparent' : `var(--ds-border-input, ${0, $7bb4c1736002a04a$export$7c87d337fb91a97d})`,
                backgroundColor: state.isFocused ? `var(--ds-background-input, ${css['backgroundColor']})` : state.selectProps.subtle ? 'transparent' : state.selectProps.textFieldBackgroundColor ? `var(--ds-background-input, ${0, $7bb4c1736002a04a$export$e655ef011c4aa1a2})` : `var(--ds-background-input, ${0, $7bb4c1736002a04a$export$9fdfb749e33cdf97})`,
                '&:hover .fabric-user-picker__clear-indicator': {
                    opacity: 1
                },
                ':hover': {
                    ...css[':hover'],
                    borderColor: state.isFocused ? css[':hover'] ? `var(--ds-border-focused, ${css[':hover'].borderColor})` : `var(--ds-border-focused, ${0, $7bb4c1736002a04a$export$ecfc1dff386a3e7a})` : state.isInvalid ? `var(--ds-border-danger, ${0, $7bb4c1736002a04a$export$2010d0fb4295b346})` : state.selectProps.subtle ? 'transparent' : `var(--ds-border-input, ${0, $7bb4c1736002a04a$export$7c87d337fb91a97d})`,
                    backgroundColor: state.selectProps.subtle && state.selectProps.hoveringClearIndicator ? `var(--ds-background-danger, ${0, $7bb4c1736002a04a$export$4b84fd0e2c617bd})` : state.isFocused ? css[':hover'] ? `var(--ds-background-input, ${css[':hover'].backgroundColor})` : `var(--ds-background-input, ${0, $7bb4c1736002a04a$export$29a4f05edc054374})` : state.isDisabled ? `var(--ds-background-disabled, ${0, $7bb4c1736002a04a$export$e655ef011c4aa1a2})` : `var(--ds-background-input-hovered, ${0, $7bb4c1736002a04a$export$3e51e8f1440314ba})`
                },
                padding: 0,
                minHeight: height && (0, $eGOwo.fg)('jifjam_bulk_operations') || isCompact ? 'none' : 44,
                /* IE 11 needs to set height explicitly to be vertical align when being in not compact mode */ height: height && (0, $eGOwo.fg)('jifjam_bulk_operations') ? height : isCompact || isMulti ? '100%' : 44,
                maxWidth: '100%'
            };
        },
        clearIndicator: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, paddingLeft: paddingLeft, paddingRight: paddingRight, ...css })=>({
                ...css,
                // By default show clear indicator, except for on devices where "hover" is supported.
                // This means mobile devices (which do not support hover) will be able to see the clear indicator.
                opacity: 1,
                '@media (hover: hover) and (pointer: fine)': {
                    opacity: 0
                },
                transition: css.transition + ', opacity 150ms',
                paddingTop: 0,
                padding: 0,
                ':hover': {
                    color: `var(--ds-icon-danger, ${0, $7bb4c1736002a04a$export$2010d0fb4295b346})`
                }
            }),
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        valueContainer: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, position: position, ...css }, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                gridTemplateColumns: 'auto 1fr',
                paddingTop: isCompact ? 0 : $b204074a529ee29d$export$59c188914e58c94b,
                paddingBottom: isCompact ? 0 : $b204074a529ee29d$export$59c188914e58c94b,
                paddingLeft: isMulti ? $b204074a529ee29d$export$59c188914e58c94b : 0,
                overflowX: 'hidden',
                overflowY: 'auto',
                scrollbarWidth: 'none',
                maxHeight: state.selectProps.maxPickerHeight || '100%',
                '::-webkit-scrollbar': {
                    width: 0,
                    background: 'transparent'
                }
            };
        },
        multiValue: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'default'
            }),
        multiValueLabel: (css)=>({
                ...css,
                display: 'flex'
            }),
        multiValueRemove: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'pointer'
            }),
        placeholder: (css, state)=>{
            // fix styling in IE 11: when the position is absolute and `left` prop is not defined,
            // IE and other browsers auto calculate value of "left" prop differently,
            // so we want to explicitly set value for the `left` property
            if (css.position === 'absolute' && !css.left) css.left = `${$b204074a529ee29d$export$59c188914e58c94b}px`;
            return {
                ...css,
                gridArea: '1/2/2/3',
                paddingLeft: state.selectProps.isMulti ? 0 : $b204074a529ee29d$export$59c188914e58c94b,
                /* Margin left right of 2px set by default */ // margin: `0 ${BORDER_PADDING}px`,
                margin: 0,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            };
        },
        option: (css)=>{
            if (isVisualRefresh) return {
                ...css,
                overflow: 'hidden',
                paddingLeft: isPopupStyles ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)",
                paddingRight: isPopupStyles ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)"
            };
            return {
                ...css,
                overflow: 'hidden'
            };
        },
        input: (css, state)=>({
                ...css,
                gridArea: '1/2/2/3',
                gridTemplateColumns: isMulti && state.placeholder ? '0 123px' : css.gridTemplateColumns,
                /* Necessary to make input height and tag height the same. */ margin: `${"var(--ds-space-050, 4px)"} 0`,
                /* Padding top and bottom of 2 is set by default. */ paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: state.selectProps.isMulti ? 0 : $b204074a529ee29d$export$59c188914e58c94b,
                '& input::placeholder': {
                    /* Chrome, Firefox, Opera, Safari 10.1+ */ color: `var(--ds-text-subtlest, ${0, $7bb4c1736002a04a$export$d6447c357493214f})`,
                    opacity: 1 /* Firefox */ 
                },
                '& input:-ms-input-placeholder': {
                    /* Internet Explorer 10-11 */ color: `var(--ds-text-subtlest, ${0, $7bb4c1736002a04a$export$d6447c357493214f})`
                }
            }),
        singleValue: (css)=>({
                ...css,
                margin: 0,
                gridArea: '1/2/2/3'
            })
    };
    return overrideStyles ? (0, $e9zKl.mergeStyles)(styles, overrideStyles) : styles;
});
const $b204074a529ee29d$export$4e983f376ad8a3af = (0, $LFmXM.default)((width, isMulti, overrideStyles, isVisualRefresh)=>({
        ...$b204074a529ee29d$export$ffd58b7f6f099a57(width, isMulti, false, overrideStyles, isVisualRefresh, true)
    }));

});

parcelRegister("6jfsf", function(module, exports) {
$parcel$export(module.exports, "getComponents", () => $3d7d6756f5b5a2a8$export$4e811121b221213b);
$parcel$export(module.exports, "getPopupComponents", () => $3d7d6756f5b5a2a8$export$19205fd341a6bb08);

var $LFmXM = parcelRequire("LFmXM");

var $7voaJ = parcelRequire("7voaJ");

var $1vhOe = parcelRequire("1vhOe");

var $1dESj = parcelRequire("1dESj");

var $bOZ4r = parcelRequire("bOZ4r");

var $dY5oB = parcelRequire("dY5oB");

var $3uumP = parcelRequire("3uumP");

var $bVfPa = parcelRequire("bVfPa");

var $6FUJ9 = parcelRequire("6FUJ9");

var $gIhcD = parcelRequire("gIhcD");

var $75q59 = parcelRequire("75q59");

var $716IA = parcelRequire("716IA");
const $3d7d6756f5b5a2a8$export$4e811121b221213b = (0, $LFmXM.default)((multi, anchor, showClearIndicator, customComponents)=>{
    if (anchor) return {
        Control: anchor,
        Option: $bOZ4r.Option
    };
    else return {
        MultiValue: $1vhOe.MultiValue,
        DropdownIndicator: null,
        SingleValue: $dY5oB.SingleValue,
        ClearIndicator: showClearIndicator || !multi ? (0, $7voaJ.ClearIndicator) : null,
        Option: $bOZ4r.Option,
        ValueContainer: multi ? (0, $1dESj.MultiValueContainer) : (0, $bVfPa.SingleValueContainer),
        Input: $3uumP.Input,
        Menu: $75q59.Menu,
        Control: $716IA.default,
        ...customComponents ? customComponents : {}
    };
});
const $3d7d6756f5b5a2a8$export$19205fd341a6bb08 = (0, $LFmXM.default)((hasPopupTitle)=>{
    const baseProps = {
        DropdownIndicator: null,
        SingleValue: $dY5oB.SingleValue,
        ClearIndicator: $7voaJ.ClearIndicator,
        Option: $bOZ4r.Option,
        ValueContainer: (0, $bVfPa.SingleValueContainer),
        Input: (0, $6FUJ9.PopupInput)
    };
    if (hasPopupTitle) return {
        ...baseProps,
        Control: (0, $gIhcD.PopupControl)
    };
    return baseProps;
});

});
parcelRegister("7voaJ", function(module, exports) {
$parcel$export(module.exports, "ClearIndicator", () => $c06818ca522ce9a4$export$ecf9cf59142dd54a);
/* ClearIndicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6XEne = parcelRequire("6XEne");

const $c06818ca522ce9a4$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("kMzLg")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $c06818ca522ce9a4$var$clearIndicatorStyles = {
    root: "_v5641ppt _tzy4kb7n _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _30l3s4qr _1mhjgrf3"
};
class $c06818ca522ce9a4$export$ecf9cf59142dd54a extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    render() {
        const { //@ts-ignore react-select unsupported props
        selectProps: { clearValueLabel: clearValueLabel } } = this.props;
        const Indicator = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).ClearIndicator, {
            ...this.props,
            innerProps: {
                ...this.props.innerProps,
                onMouseDown: this.handleMouseDown
            },
            xcss: $c06818ca522ce9a4$var$clearIndicatorStyles.root
        });
        return clearValueLabel ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Suspense, {
            fallback: Indicator,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($c06818ca522ce9a4$var$AsyncTooltip, {
                content: clearValueLabel,
                children: Indicator
            })
        }) : Indicator;
    }
    constructor(...args){
        super(...args), this.handleMouseDown = (event)=>{
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            // Prevent focus when clear on blurred state
            const { clearValue: clearValue, selectProps: selectProps } = this.props;
            clearValue();
            //@ts-ignore react-select unsupported props
            if (selectProps && !selectProps.isFocused) event.stopPropagation();
        };
    }
}

});

parcelRegister("1vhOe", function(module, exports) {
$parcel$export(module.exports, "MultiValue", () => $340817c48ea29dd5$export$419cdf50db8b579);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $6XEne = parcelRequire("6XEne");

var $1NIU8 = parcelRequire("1NIU8");

var $8FxQe = parcelRequire("8FxQe");

var $k7nMY = parcelRequire("k7nMY");

var $bp6ad = parcelRequire("bp6ad");

var $hMpZ8 = parcelRequire("hMpZ8");

var $lXcOw = parcelRequire("lXcOw");
function $340817c48ea29dd5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $340817c48ea29dd5$export$118122ebc1e626fa = (valueContainer, control)=>{
    const { top: top, height: height } = valueContainer.getBoundingClientRect();
    const { height: controlHeight } = control.getBoundingClientRect();
    if (top - height < 0) valueContainer.scrollIntoView();
    if (top + height > controlHeight) valueContainer.scrollIntoView(false);
};
const $340817c48ea29dd5$var$groupTagContainer = (0, $1DXK0.xcss)({
    paddingLeft: 'space.025',
    marginTop: 'space.025'
});
const $340817c48ea29dd5$var$nameWrapper = {
    name: "1ebbz80",
    styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);padding-left:var(--ds-space-050, 4px)"
};
class $340817c48ea29dd5$export$419cdf50db8b579 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    constructor(props){
        super(props), this.getElemBefore = ()=>{
            const { data: { data: data } } = this.props;
            if ((0, $bp6ad.isEmail)(data)) // This element is a decorative icon and does not require a label
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8FxQe.AddOptionAvatar), {
                isLozenge: true,
                isPendingAction: data.isPendingAction
            });
            if ((0, $bp6ad.isGroup)(data)) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8nu6j.default), {
                xcss: $340817c48ea29dd5$var$groupTagContainer
            }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hMpZ8))), {
                LEGACY_margin: "-2px 0 0 0",
                color: "currentColor",
                label: "" // This element is a decorative icon and does not require a label
                ,
                LEGACY_size: "small"
            }));
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k7nMY.SizeableAvatar), {
                appearance: "multi",
                src: (0, $bp6ad.getAvatarUrl)(data),
                type: (0, $bp6ad.isTeam)(data) ? 'team' : 'person'
            });
        }, this.getElemAfter = ()=>{
            const { data: { data: data } } = this.props;
            if ((0, $bp6ad.isTeam)(data) && data.verified) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $lXcOw.VerifiedTeamIcon), null);
            return null;
        };
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef();
    }
    componentDidUpdate() {
        const { isFocused: isFocused } = this.props;
        if (isFocused && this.containerRef.current && this.containerRef.current.parentElement && this.containerRef.current.parentElement.parentElement) $340817c48ea29dd5$export$118122ebc1e626fa(this.containerRef.current, this.containerRef.current.parentElement.parentElement);
    }
    shouldComponentUpdate(nextProps) {
        const { data: { label: label, data: data }, innerProps: innerProps, isFocused: isFocused } = this.props;
        const { data: { label: nextLabel, data: nextData }, innerProps: nextInnerProps, isFocused: nextIsFocused } = nextProps;
        // We can ignore onRemove here because it is an anonymous function
        // that will be recreated every time but with the same implementation.
        return data !== nextData || label !== nextLabel || innerProps !== nextInnerProps || isFocused !== nextIsFocused;
    }
    render() {
        const { children: children, innerProps: innerProps, ...rest } = this.props;
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $6XEne.components).MultiValue, {
            ...rest,
            innerProps: {
                ref: this.containerRef
            },
            cropWithEllipsis: false
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $3Wh6p.default), {
            alignBlock: "center"
        }, this.getElemBefore(), " ", /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $340817c48ea29dd5$var$nameWrapper
        }, children), this.getElemAfter()));
    }
}

});
parcelRegister("8FxQe", function(module, exports) {
$parcel$export(module.exports, "AddOptionAvatar", () => $b392ae2eb4910fe7$export$df396db45e491922);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $dNLHm = parcelRequire("dNLHm");


var $1NIU8 = parcelRequire("1NIU8");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");
const $b392ae2eb4910fe7$var$getEmailAvatarWrapperStyle = (isLozenge, isPendingAction)=>{
    const padding = isLozenge ? `${"var(--ds-space-0, 0px)"}` : `${"var(--ds-space-050, 4px)"}`;
    const backgroundColor = isPendingAction && (0, $eGOwo.fg)('twcg-444-invite-usd-improvements-m2-gate') ? "var(--ds-background-warning, #FFF7D6)" : `var(--ds-background-neutral, ${0, $7bb4c1736002a04a$export$1ce2d1575d444ceb})`;
    return /*#__PURE__*/ (0, $1NIU8.css)({
        padding: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding,
        backgroundColor: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor,
        borderRadius: "var(--ds-radius-full, 9999px)",
        display: 'flex',
        alignItems: 'center',
        marginLeft: "var(--ds-space-025, 2px)"
    });
};
const $b392ae2eb4910fe7$export$df396db45e491922 = ({ isLozenge: isLozenge, label: label, isPendingAction: isPendingAction })=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $b392ae2eb4910fe7$var$getEmailAvatarWrapperStyle(isLozenge, isPendingAction)
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dNLHm))), {
        testId: "add-option-avatar-email-icon",
        label: label || '',
        LEGACY_size: isLozenge ? 'small' : 'medium',
        LEGACY_margin: "0 0 0 -2px",
        color: isPendingAction && (0, $eGOwo.fg)('twcg-444-invite-usd-improvements-m2-gate') ? "var(--ds-text-warning, #A54800)" : `var(--ds-text-subtle, ${0, $7bb4c1736002a04a$export$c39c0fe0f26207ae})`
    })));
};

});

parcelRegister("k7nMY", function(module, exports) {
$parcel$export(module.exports, "SizeableAvatar", () => $d0269580cbf343f0$export$44d81a88129649da);

var $gt9Am = parcelRequire("gt9Am");

var $5DgXR = parcelRequire("5DgXR");

var $6qS8z = parcelRequire("6qS8z");

var $eJOHy = parcelRequire("eJOHy");

var $bp6ad = parcelRequire("bp6ad");
class $d0269580cbf343f0$export$44d81a88129649da extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    render() {
        const { src: src, presence: presence, appearance: appearance, type: type = 'person', avatarAppearanceShape: avatarAppearanceShape } = this.props;
        const props = {
            size: (0, $bp6ad.getAvatarSize)(appearance),
            src: src,
            borderColor: 'transparent',
            presence: presence,
            ...avatarAppearanceShape && {
                appearance: avatarAppearanceShape
            }
        };
        return type === 'team' ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6qS8z.default), {
            ...props
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5DgXR.default), {
            ...props
        });
    }
}

});
parcelRegister("6qS8z", function(module, exports) {
$parcel$export(module.exports, "default", () => $502b93618fdc9c00$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5DgXR = parcelRequire("5DgXR");


var $6qfsx = parcelRequire("6qfsx");
const $502b93618fdc9c00$export$ebe0b8fe8b6acbfd = `var(--ds-icon-inverse, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`;
const $502b93618fdc9c00$export$72502e51aebdd94e = `var(--ds-icon-subtle, ${(0, $7bb4c1736002a04a$export$7c87d337fb91a97d)})`;
function $502b93618fdc9c00$export$2e2bcd8739ae039({ testId: testId, src: src, size: size = 'medium', teamId: teamId = '', ...props }) {
    // Strip ARI in case the teamId was given in that format
    teamId = teamId.replace('ari:cloud:identity::team/', '');
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5DgXR.default), {
        appearance: "square",
        ...props,
        size: size,
        src: src,
        testId: `${testId}-team-avatar`,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6qfsx.TeamAvatarImage), {
            src: src,
            size: size,
            testId: testId,
            teamId: teamId
        })
    });
}

});
parcelRegister("6qfsx", function(module, exports) {
$parcel$export(module.exports, "TeamAvatarImage", () => $deb06dadb11ac687$export$ac3673635a5387be);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $efgFx = parcelRequire("efgFx");

var $aYBsz = parcelRequire("aYBsz");
const $deb06dadb11ac687$var$boxShadowCssVar = '--avatar-box-shadow';
const $deb06dadb11ac687$var$bgColorCssVar = '--avatar-bg-color';
/**
 * We need to maintan the container styles manually until Avatar provides the correct border radius.
 * After that we can return to wrapping in <AvatarContent> rather than span
 */ const $deb06dadb11ac687$var$containerStyles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk18uv _aetrf705 _1peqidpf _11fnglyw",
    circle: "_2rko1qll _14mj1qll",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peqs237"
};
const $deb06dadb11ac687$var$unboundStyles = {
    root: "_vchh18uv _bfhkcxp3 _16qs1nhn",
    interactive: "_80omtlke _4tpuw83z _ez1ykb7n _gcm11et6 _eeh8kb7n _jlxit94y"
};
const $deb06dadb11ac687$var$avatarImageStyles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq"
};
const $deb06dadb11ac687$var$SIZES = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $deb06dadb11ac687$var$borderRadiusMap = {
    xsmall: "_2rkol0p1",
    small: "_2rkol0p1",
    medium: "_2rkol0p1",
    large: "_2rkol0p1",
    xlarge: "_2rkol0p1",
    xxlarge: "_2rkol0p1"
};
const $deb06dadb11ac687$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $deb06dadb11ac687$export$ac3673635a5387be = ({ alt: alt = '', src: src, size: size, testId: testId, teamId: teamId })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $eJOHy.useState)(false);
    const avatarSrc = (0, $aYBsz.getTeamAvatarSrc)(src, teamId);
    // If src changes, reset state
    (0, $eJOHy.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        avatarSrc
    ]);
    if (!avatarSrc || hasImageErrored) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $efgFx.FallbackAvatar), {
        "aria-label": alt,
        width: $deb06dadb11ac687$var$SIZES[size],
        height: $deb06dadb11ac687$var$SIZES[size],
        "data-testid": testId
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId,
        "aria-label": alt,
        className: (0, $hcewu.default)([
            $deb06dadb11ac687$var$unboundStyles.root,
            $deb06dadb11ac687$var$containerStyles.root,
            $deb06dadb11ac687$var$borderRadiusMap[size],
            $deb06dadb11ac687$var$widthHeightMap[size]
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
            src: avatarSrc,
            alt: alt,
            "data-testid": testId && `${testId}--image`,
            onError: ()=>setHasImageErrored(true),
            className: (0, $hcewu.default)([
                $deb06dadb11ac687$var$avatarImageStyles.image
            ])
        })
    });
};

});
parcelRegister("efgFx", function(module, exports) {
$parcel$export(module.exports, "FallbackAvatar", () => $9a97cfaf5fcee5b8$export$eb63dcc490f6bbcd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
const $9a97cfaf5fcee5b8$var$styles = {
    wrapper: "_1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o"
};
function $9a97cfaf5fcee5b8$export$eb63dcc490f6bbcd(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: $9a97cfaf5fcee5b8$var$styles.wrapper,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                    clipPath: "url(#clip0_2032_552)",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "#DCDFE4"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            d: "M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            d: "M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z",
                            fill: "#44546F"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)("clipPath", {
                        id: "clip0_2032_552",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
}

});

parcelRegister("aYBsz", function(module, exports) {
$parcel$export(module.exports, "getTeamAvatarSrc", () => $70cc3a7a823af077$export$59ff7d19feb890b6);
/**
 * If a src value is given, we'll use that directly.
 * Otherwise we'll generate a static URL from the teamId.
 * If neither are provided, return undefined so that the fallback will be used.
 */ function $70cc3a7a823af077$export$59ff7d19feb890b6(src, teamId) {
    if (src) return src;
    else if (teamId) return `/gateway/api/v4/teams/${teamId}/avatar`;
    return undefined;
}

});




parcelRegister("lXcOw", function(module, exports) {
$parcel$export(module.exports, "VerifiedTeamIcon", () => $c2242de582b8e66d$export$d7949f68d31e5edd);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $acRfo = parcelRequire("acRfo");

var $k71qx = parcelRequire("k71qx");

var $6dApG = parcelRequire("6dApG");
const $c2242de582b8e66d$export$d7949f68d31e5edd = ({ label: label = 'Verified Team', showTooltip: showTooltip, customTooltipContent: customTooltipContent, size: size = 'medium' })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const tooltipContent = showTooltip ? customTooltipContent || formatMessage((0, $6dApG.messages).verifiedIconDefaultTooltip) : undefined;
    return tooltipContent ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: tooltipContent,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("span", {
            tabIndex: 0,
            role: "button",
            "data-testid": "verified-team-icon",
            children: [
                ' ',
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acRfo))), {
                    color: "var(--ds-icon-accent-blue, #1D7AFC)",
                    size: size,
                    label: tooltipContent,
                    spacing: "spacious"
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acRfo))), {
        color: "var(--ds-icon-accent-blue, #1D7AFC)",
        size: size,
        spacing: "spacious",
        label: label
    });
};

});
parcelRegister("6dApG", function(module, exports) {
$parcel$export(module.exports, "messages", () => $369d053bcf2cee48$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $369d053bcf2cee48$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    verifiedIconDefaultTooltip: {
        id: 'ptc-directory.team-profile-page.team-name.verified-team.icon.tooltip',
        defaultMessage: 'Managed teams are verified because they can only be changed by an admin.',
        description: 'Tooltip text for the verified team icon'
    }
});

});



parcelRegister("1dESj", function(module, exports) {
$parcel$export(module.exports, "MultiValueContainer", () => $d3c7ccc28b39ddcc$export$cf9cf2a30a59265c);
/* MultiValueContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $6XEne = parcelRequire("6XEne");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $aemwP = parcelRequire("aemwP");

var $bp6ad = parcelRequire("bp6ad");

var $bM37l = parcelRequire("bM37l");
const $d3c7ccc28b39ddcc$var$valueContainerStyles = {
    root: "_yv0e5bpd _ca0q12x7 _n3td12x7 _19bv12x7 _1reo15vq _18m91wug _1fjgglyw _c71l1osq _1suq18uv _1ke8idpf"
};
class $d3c7ccc28b39ddcc$export$cf9cf2a30a59265c extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    static getDerivedStateFromProps(nextProps, prevState) {
        return {
            valueSize: nextProps.getValue ? nextProps.getValue().length : 0,
            previousValueSize: prevState.valueSize
        };
    }
    constructor(props){
        super(props), this.timeoutId = null, this.scrollToBottom = ()=>{
            this.timeoutId = window.setTimeout(()=>{
                const { ref: { current: current } } = this.valueContainerInnerProps;
                if (current !== null) current.scrollTop = current.scrollHeight;
                this.timeoutId = null;
            });
        }, this.showPlaceholder = ()=>{
            const { selectProps: { value: value } } = this.props;
            return value && value.length > 0;
        }, this.addPlaceholder = (placeholder)=>{
            const children = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(this.props.children, (child)=>(0, $bp6ad.isChildInput)(child) && this.showPlaceholder() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(child, {
                    placeholder: placeholder
                }) : child);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
                children: children
            });
        }, this.renderChildren = ()=>{
            const { //@ts-ignore react-select unsupported props
            selectProps: { addMoreMessage: addMoreMessage, isDisabled: isDisabled } } = this.props;
            // Do not render "Add more..." message if picker is disabled
            if (isDisabled) return this.props.children;
            if (addMoreMessage === undefined) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $aemwP.messages).addMore,
                children: (addMore)=>{
                    let addMoreMessages = addMore;
                    if (addMore && typeof addMore === 'string') addMoreMessages = [
                        addMore
                    ];
                    const placeholder = addMoreMessages?.join('') ?? '';
                    return this.addPlaceholder(placeholder);
                }
            });
            return this.addPlaceholder(addMoreMessage);
        }, //@ts-ignore react-select unsupported props
        this.onValueContainerClick = this.props.selectProps.onValueContainerClick;
        this.state = {
            valueSize: 0,
            previousValueSize: 0
        };
        this.valueContainerInnerProps = {
            ref: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef()
        };
    }
    componentDidUpdate() {
        const { previousValueSize: previousValueSize, valueSize: valueSize } = this.state;
        //@ts-ignore react-select unsupported props
        const { isFocused: isFocused } = this.props.selectProps;
        if (valueSize > previousValueSize && isFocused) {
            if (this.timeoutId) {
                window.clearTimeout(this.timeoutId);
                this.timeoutId = null;
            }
            this.scrollToBottom();
        }
    }
    componentWillUnmount() {
        if (this.timeoutId) window.clearTimeout(this.timeoutId);
    }
    render() {
        const { children: children, innerProps: innerProps, ...valueContainerProps } = this.props;
        const props = {
            ...valueContainerProps,
            innerProps: this.valueContainerInnerProps
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bM37l.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).ValueContainer, {
                ...props,
                xcss: $d3c7ccc28b39ddcc$var$valueContainerStyles.root,
                children: this.renderChildren()
            })
        });
    }
}

});
parcelRegister("bM37l", function(module, exports) {
$parcel$export(module.exports, "default", () => $892064a436200311$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");
function $892064a436200311$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Conditional wrapper for the ValueContainer in Select. Provides a workaround
 * for issues using react-select on react-beautiful-dnd Draggable elements.
 * @returns
 */ var $892064a436200311$var$_ref = {
    name: "1ff36h2",
    styles: "flex-grow:1"
};
const $892064a436200311$var$ValueContainerWrapper = ({ children: children, isEnabled: isEnabled, onMouseDown: onMouseDown })=>{
    return isEnabled ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlassian/a11y/no-static-element-interactions -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $892064a436200311$var$_ref,
        onMouseDown: onMouseDown
    }, children) : children;
};
var $892064a436200311$export$2e2bcd8739ae039 = $892064a436200311$var$ValueContainerWrapper;

});


parcelRegister("bOZ4r", function(module, exports) {
$parcel$export(module.exports, "Option", () => $07ff0c926ef0e179$export$36d18380658d5d20);

var $gt9Am = parcelRequire("gt9Am");

var $8IeH1 = parcelRequire("8IeH1");

var $6XEne = parcelRequire("6XEne");

var $k71qx = parcelRequire("k71qx");

var $eJOHy = parcelRequire("eJOHy");

var $b5om0 = parcelRequire("b5om0");

var $9efgr = parcelRequire("9efgr");

var $k0Plf = parcelRequire("k0Plf");

var $2tKwH = parcelRequire("2tKwH");

var $4A9Tu = parcelRequire("4A9Tu");

var $5wrPY = parcelRequire("5wrPY");

var $bp6ad = parcelRequire("bp6ad");

var $2lvD5 = parcelRequire("2lvD5");
const $07ff0c926ef0e179$var$defaultOption = ({ data: { data: data }, isSelected: isSelected, status: status })=>// @ts-expect-error - <UserOption> expects `data` to be of User interface, but data is OptionData interface by default. Check if the `user` props in UserOption should also accept OptionData or refactor this file to accept generics
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b5om0.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
const $07ff0c926ef0e179$var$dataOption = ({ data: { data: data }, isSelected: isSelected, status: status, selectProps: selectProps })=>{
    if ((0, $bp6ad.isExternalUser)(data)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9efgr.default), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $bp6ad.isUser)(data)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b5om0.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $bp6ad.isEmail)(data)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4A9Tu.default), {
        email: data,
        emailValidity: (0, $2lvD5.isValidEmail)(data.id),
        isSelected: isSelected,
        label: selectProps.emailLabel
    });
    if ((0, $bp6ad.isTeam)(data)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k0Plf.default), {
        team: data,
        isSelected: isSelected
    });
    if ((0, $bp6ad.isGroup)(data)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2tKwH.default), {
        group: data,
        isSelected: isSelected
    });
    if ((0, $bp6ad.isCustom)(data)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5wrPY.default), {
        data: data,
        isSelected: isSelected
    });
    return null;
};
const $07ff0c926ef0e179$var$dataOptionWithTooltip = (props)=>{
    if (props.data?.data?.tooltip) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: props.data?.data?.tooltip,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                ...tooltipProps,
                children: $07ff0c926ef0e179$var$dataOption(props)
            })
    });
    return $07ff0c926ef0e179$var$dataOption(props);
};
const $07ff0c926ef0e179$export$36d18380658d5d20 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).Option, {
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Suspense, {
            fallback: $07ff0c926ef0e179$var$defaultOption(props),
            children: $07ff0c926ef0e179$var$dataOptionWithTooltip(props)
        })
    });

});
parcelRegister("b5om0", function(module, exports) {
$parcel$export(module.exports, "UserOption", () => $0453b1bfd2244edc$export$8e59f78010871662);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $j8kj1 = parcelRequire("j8kj1");


var $1NIU8 = parcelRequire("1NIU8");

var $eJOHy = parcelRequire("eJOHy");

var $6pxNU = parcelRequire("6pxNU");

var $55xVv = parcelRequire("55xVv");

var $k7nMY = parcelRequire("k7nMY");

var $bp6ad = parcelRequire("bp6ad");

var $eGOwo = parcelRequire("eGOwo");
class $0453b1bfd2244edc$export$8e59f78010871662 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $6pxNU.AvatarItemOption), {
            avatar: this.renderAvatar(),
            lozenge: this.getLozengeProps(),
            isDisabled: this.props.user.isDisabled,
            primaryText: this.getPrimaryText(),
            secondaryText: this.renderSecondaryText()
        });
    }
    constructor(...args){
        super(...args), this.getPrimaryText = ()=>{
            const { user: { name: name, publicName: publicName, highlight: highlight } } = this.props;
            const result = [
                /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
                    key: "name",
                    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    css: (0, $6pxNU.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $7bb4c1736002a04a$export$b3de0ae08da2ce64})` : `var(--ds-text, ${0, $7bb4c1736002a04a$export$7d61b15e0da132af})`)
                }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $55xVv.HighlightText), {
                    highlights: highlight && highlight.name
                }, name))
            ];
            if ((0, $bp6ad.hasValue)(publicName) && name.trim() !== publicName.trim()) result.push(/*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                key: "publicName"
            }, ' ', /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $6pxNU.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $7bb4c1736002a04a$export$b3de0ae08da2ce64})` : `var(--ds-text-subtlest, ${0, $7bb4c1736002a04a$export$f563ee71e9ee74cd})`)
            }, "(", /*#__PURE__*/ (0, $1NIU8.jsx)((0, $55xVv.HighlightText), {
                highlights: highlight && highlight.publicName
            }, publicName), ")")));
            return result;
        }, this.renderSecondaryText = ()=>this.props.user.byline ? /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $6pxNU.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $7bb4c1736002a04a$export$b3de0ae08da2ce64})` : `var(--ds-text-subtlest, ${0, $7bb4c1736002a04a$export$f563ee71e9ee74cd})`)
            }, this.props.user.byline) : undefined, this.renderAvatar = ()=>{
            const { user: { avatarUrl: avatarUrl, appType: appType }, status: status } = this.props;
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k7nMY.SizeableAvatar), {
                appearance: (0, $eGOwo.fg)('platform-component-visual-refresh') ? 'medium' : 'big',
                src: avatarUrl,
                presence: status,
                avatarAppearanceShape: (0, $eGOwo.fg)('jira_ai_agent_avatar_user_picker_user_option') ? (0, $j8kj1.getAppearanceForAppType)(appType) : undefined
            });
        }, this.getLozengeProps = ()=>typeof this.props.user.lozenge === 'string' ? {
                text: this.props.user.lozenge
            } : this.props.user.lozenge;
    }
}

});
parcelRegister("6pxNU", function(module, exports) {
$parcel$export(module.exports, "textWrapper", () => $8382733eea54494c$export$aa6223da92b253dd);
$parcel$export(module.exports, "AvatarItemOption", () => $8382733eea54494c$export$164a9d9b3b86dd0c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $jdqdp = parcelRequire("jdqdp");

var $bp6ad = parcelRequire("bp6ad");
function $8382733eea54494c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

const $8382733eea54494c$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("kMzLg")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $8382733eea54494c$var$wrapper = (isDisabled)=>/*#__PURE__*/ (0, $1NIU8.css)({
        alignItems: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1,
        outline: 'none',
        margin: 0,
        width: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: isDisabled ? "var(--ds-opacity-disabled, 0.4)" : undefined
    });
const $8382733eea54494c$var$optionWrapper = {
    name: "13552d7",
    styles: "max-width:100%;min-width:0;line-height:1.4;padding-left:var(--ds-space-100, 8px)"
};
const $8382733eea54494c$var$getTextStyle = (isSecondary)=>{
    const secondaryCssArgs = isSecondary ? {
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
    } : {};
    return /*#__PURE__*/ (0, $1NIU8.css)({
        margin: 0,
        overflowX: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...secondaryCssArgs
    });
};
const $8382733eea54494c$var$additionalInfo = {
    name: "1hvgowa",
    styles: "float:right;margin-left:var(--ds-space-100, 8px)"
};
const $8382733eea54494c$export$aa6223da92b253dd = (color)=>/*#__PURE__*/ (0, $1NIU8.css)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'inline',
        color: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color
    });
const $8382733eea54494c$export$164a9d9b3b86dd0c = ({ avatar: avatar, isDisabled: isDisabled, lozenge: lozenge, primaryText: primaryText, secondaryText: secondaryText })=>{
    const renderLozenge = ()=>{
        if ((0, $bp6ad.isLozengeText)(lozenge)) {
            if (lozenge?.tooltip) // Note that entire Lozenge must be wrapped in the Tooltip (rather than just the
            // Lozenge text) or tooltip won't work
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Suspense, {
                fallback: /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jdqdp.default), lozenge, lozenge.text)
            }, /*#__PURE__*/ (0, $1NIU8.jsx)($8382733eea54494c$var$AsyncTooltip, {
                content: lozenge.tooltip
            }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jdqdp.default), lozenge, lozenge.text)));
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jdqdp.default), lozenge, lozenge.text);
        }
        return lozenge;
    };
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $8382733eea54494c$var$wrapper(isDisabled)
    }, avatar, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $8382733eea54494c$var$optionWrapper
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", null, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $8382733eea54494c$var$getTextStyle()
    }, primaryText), secondaryText && /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $8382733eea54494c$var$getTextStyle(true)
    }, secondaryText))), lozenge && /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $8382733eea54494c$var$additionalInfo
    }, renderLozenge())));
};

});

parcelRegister("55xVv", function(module, exports) {
$parcel$export(module.exports, "HighlightText", () => $9cb1b36ba7348cca$export$bb02e7bc6e1a7119);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
class $9cb1b36ba7348cca$export$bb02e7bc6e1a7119 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    render() {
        const { children: children, highlights: highlights } = this.props;
        const parts = [];
        let lastIndex = 0;
        if (highlights) highlights.sort((a, b)=>a.start - b.start).reduce((highlights, highlight)=>{
            const lastHighlight = highlights[highlights.length - 1];
            if (!lastHighlight || highlight.start > lastHighlight.end + 1) return highlights.concat(highlight);
            if (highlight.end > lastHighlight.end) lastHighlight.end = highlight.end;
            return highlights;
        }, []).forEach((highlight)=>{
            const { start: start, end: end } = highlight;
            if (start >= end) return;
            if (start > lastIndex) parts.push({
                value: children.substring(lastIndex, start),
                matches: false
            });
            parts.push({
                value: children.substring(start, end + 1),
                matches: true
            });
            lastIndex = end + 1;
        });
        if (lastIndex < children.length) parts.push({
            value: children.substring(lastIndex, children.length),
            matches: false
        });
        return parts.map((part, index)=>{
            if (part.matches) return /*#__PURE__*/ (0, $gt9Am.jsx)("b", {
                children: part.value
            }, index);
            return part.value;
        });
    }
}

});


parcelRegister("9efgr", function(module, exports) {
$parcel$export(module.exports, "default", () => $980dbe247ee3b37d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

const $980dbe247ee3b37d$var$AsyncExternalUserOption = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("zvTks")).then((module)=>{
        return {
            default: module.ExternalUserOption
        };
    }));
var $980dbe247ee3b37d$export$2e2bcd8739ae039 = $980dbe247ee3b37d$var$AsyncExternalUserOption;

});
parcelRegister("zvTks", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("cm3wZ")
]).then(()=>parcelRequire('4cxzb'));

});


parcelRegister("k0Plf", function(module, exports) {
$parcel$export(module.exports, "default", () => $95d6477fc9cb5ac2$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

const $95d6477fc9cb5ac2$var$AsyncTeamOption = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("ampxd")).then((module)=>{
        return {
            default: module.TeamOption
        };
    }));
var $95d6477fc9cb5ac2$export$2e2bcd8739ae039 = $95d6477fc9cb5ac2$var$AsyncTeamOption;

});
parcelRegister("ampxd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dVG7s").then(()=>parcelRequire('1S96L'));

});


parcelRegister("2tKwH", function(module, exports) {
$parcel$export(module.exports, "default", () => $0aaf40607abeee08$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

const $0aaf40607abeee08$var$AsyncGroupOption = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("8Gji4")).then((module)=>{
        return {
            default: module.GroupOption
        };
    }));
var $0aaf40607abeee08$export$2e2bcd8739ae039 = $0aaf40607abeee08$var$AsyncGroupOption;

});
parcelRegister("8Gji4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bwgIM").then(()=>parcelRequire('kSMc2'));

});


parcelRegister("4A9Tu", function(module, exports) {
$parcel$export(module.exports, "default", () => $eed72ec3262bf21d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

const $eed72ec3262bf21d$var$AsyncEmailOption = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("dyBmT")).then((module)=>{
        return {
            default: module.EmailOption
        };
    }));
var $eed72ec3262bf21d$export$2e2bcd8739ae039 = $eed72ec3262bf21d$var$AsyncEmailOption;

});
parcelRegister("dyBmT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8aLon").then(()=>parcelRequire('hpXeN'));

});


parcelRegister("5wrPY", function(module, exports) {
$parcel$export(module.exports, "default", () => $6711e764ffd94797$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

const $6711e764ffd94797$var$AsyncCustomOption = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("riO7J")).then((module)=>{
        return {
            default: module.CustomOption
        };
    }));
var $6711e764ffd94797$export$2e2bcd8739ae039 = $6711e764ffd94797$var$AsyncCustomOption;

});
parcelRegister("riO7J", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4SKbF").then(()=>parcelRequire('hVJCF'));

});


parcelRegister("2lvD5", function(module, exports) {
$parcel$export(module.exports, "isValidEmail", () => $f55e7fe2bf1c50c8$export$371e338370561054);
const $f55e7fe2bf1c50c8$var$validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
const $f55e7fe2bf1c50c8$var$potentialRegex = /^[^\s@]+@[^\s@]*$/i;
const $f55e7fe2bf1c50c8$export$371e338370561054 = (inputText)=>{
    if (inputText.match($f55e7fe2bf1c50c8$var$validRegex)) return 'VALID';
    if (inputText.match($f55e7fe2bf1c50c8$var$potentialRegex)) return 'POTENTIAL';
    return 'INVALID';
};

});


parcelRegister("dY5oB", function(module, exports) {
$parcel$export(module.exports, "SingleValue", () => $dd81b53dbb8a3847$export$1949dac661ba6e3a);
/* SingleValue.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6XEne = parcelRequire("6XEne");

var $k7nMY = parcelRequire("k7nMY");

var $bp6ad = parcelRequire("bp6ad");

var $lXcOw = parcelRequire("lXcOw");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");
var $6djmC = parcelRequire("6djmC");
const $dd81b53dbb8a3847$var$styles = {
    avatarItem: "_1reo15vq _18m915vq _4cvr1h6o _1ul953f4",
    avatarItemTextWrapper: "_16jlkb7n _1o9zkb7n _i0dl1osq _1ul9idpf _p12f1osq _bozgu2gc _vwz419ii",
    avatarItemText: "_syaz1fxt _1reo15vq _1bto1l2s _o5721q9c"
};
const $dd81b53dbb8a3847$var$ElementAfter = (props)=>{
    const { data: { data: data } } = props;
    if ((0, $bp6ad.isTeam)(data) && data.verified) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lXcOw.VerifiedTeamIcon), {});
    return null;
};
const $dd81b53dbb8a3847$export$1949dac661ba6e3a = (props)=>{
    const { data: { label: label, data: data }, //@ts-ignore react-select unsupported props
    selectProps: { appearance: appearance, isFocused: isFocused } } = props;
    return !isFocused ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).SingleValue, {
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $2sLVw.default), {
            xcss: $dd81b53dbb8a3847$var$styles.avatarItem,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k7nMY.SizeableAvatar), {
                    src: (0, $bp6ad.getAvatarUrl)(data),
                    appearance: appearance,
                    type: (0, $bp6ad.isTeam)(data) ? 'team' : 'person'
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    xcss: $dd81b53dbb8a3847$var$styles.avatarItem,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            $dd81b53dbb8a3847$var$styles.avatarItemTextWrapper
                        ]),
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                            xcss: $dd81b53dbb8a3847$var$styles.avatarItemText,
                            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                                alignBlock: "center",
                                children: [
                                    label,
                                    /*#__PURE__*/ (0, $gt9Am.jsx)($dd81b53dbb8a3847$var$ElementAfter, {
                                        ...props
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    }) : null;
};

});

parcelRegister("3uumP", function(module, exports) {
$parcel$export(module.exports, "Input", () => $52276fbb29701503$export$f5b8910cec6cf069);
/* Input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6XEne = parcelRequire("6XEne");
const $52276fbb29701503$var$inputStyles = {
    root: "_5ce6131l _1ir3kb7n _h5gq131l"
};
class $52276fbb29701503$export$f5b8910cec6cf069 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    /**
   * Overrides the default behaviour of react-select lib
   *
   * The getter is a workaround for original behaviour of the react-select lib.
   * Placeholder and Input are linked not via label, aria-label or aria-labeledby, but through aria-describedby.
   * Basically in the getter we reassign Placeholder ID from aria-describedby to aria-labelledby
   * {@link https://github.com/JedWatson/react-select/issues/5651#issue-1731353197 GitHub}
   */ get ariaLabelledBy() {
        return this.props['aria-labelledby'] ?? this.props['aria-describedby'];
    }
    get ariaDescribedBy() {
        return this.props.selectProps?.['aria-describedby'] ?? this.props['aria-describedby'];
    }
    render() {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).Input, {
            ...this.props,
            "aria-labelledby": this.ariaLabelledBy,
            "aria-describedby": this.ariaDescribedBy,
            innerRef: this.props.innerRef,
            onKeyPress: this.handleKeyPress,
            xcss: $52276fbb29701503$var$inputStyles.root
        });
    }
    constructor(...args){
        super(...args), // onKeyPress is used instead as
        // react-select is using onKeyDown for capturing keyboard input
        this.handleKeyPress = (e)=>{
            if (e.key === 'Enter') e.preventDefault();
            //@ts-ignore react-select unsupported props
            if (this.props.selectProps?.disableInput) e.preventDefault();
        };
    }
}

});

parcelRegister("bVfPa", function(module, exports) {
$parcel$export(module.exports, "SingleValueContainer", () => $5b6f667c12b37e80$export$afa5f855316c6a48);
/* SingleValueContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6XEne = parcelRequire("6XEne");

var $k7nMY = parcelRequire("k7nMY");

var $bM37l = parcelRequire("bM37l");
const $5b6f667c12b37e80$var$valueContainerStyles = {
    root: "_yv0e5bpd _ca0q12x7 _n3td12x7 _19bvze3t _1reo15vq _18m91wug _1fjgglyw _c71l1osq _1suq18uv _1ke8idpf"
};
const $5b6f667c12b37e80$var$placeholderIconContainer = null;
const $5b6f667c12b37e80$var$wrapperStyle = null;
const $5b6f667c12b37e80$var$showUserAvatar = (inputValue, value)=>value && value.data && inputValue === value.label;
class $5b6f667c12b37e80$export$afa5f855316c6a48 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { children: children, ...valueContainerProps } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bM37l.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6XEne.components).ValueContainer, {
                ...valueContainerProps,
                xcss: $5b6f667c12b37e80$var$valueContainerStyles.root,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            "_nd5l1kqh _19bv12x7 _vwz4idpf"
                        ]),
                        children: this.renderAvatar()
                    }),
                    children
                ]
            })
        });
    }
    constructor(...args){
        super(...args), this.renderAvatar = ()=>{
            const { hasValue: hasValue, //@ts-ignore react-select unsupported props
            selectProps: { appearance: appearance, isFocused: isFocused, inputValue: inputValue, value: value, placeholderAvatar: placeholderAvatar } } = this.props;
            if (isFocused || !hasValue) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k7nMY.SizeableAvatar), {
                appearance: appearance,
                type: placeholderAvatar,
                src: $5b6f667c12b37e80$var$showUserAvatar(inputValue, value) ? value.data.avatarUrl : undefined
            });
            return null;
        }, //@ts-ignore react-select unsupported props
        this.onValueContainerClick = this.props.selectProps.onValueContainerClick, this.Wrapper = ({ children: children })=>{
            return this.onValueContainerClick ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                onMouseDown: this.onValueContainerClick,
                className: (0, $hcewu.default)([
                    "_16jlkb7n"
                ]),
                children: children
            }) : children;
        };
    }
}

});

parcelRegister("6FUJ9", function(module, exports) {
$parcel$export(module.exports, "PopupInput", () => $cd9d7ed309b03307$export$d8edbfd510a7db82);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3uumP = parcelRequire("3uumP");
class $cd9d7ed309b03307$export$d8edbfd510a7db82 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidMount() {
        if (this.ref) // @ts-ignore
        this.ref.select();
    }
    render() {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3uumP.Input), {
            ...this.props,
            innerRef: this.handleInnerRef
        });
    }
    constructor(...args){
        super(...args), this.ref = null, this.handleInnerRef = (ref)=>{
            this.ref = ref;
            if (this.props.innerRef) this.props.innerRef(ref);
        };
    }
}

});

parcelRegister("gIhcD", function(module, exports) {
$parcel$export(module.exports, "PopupControl", () => $d6cc2469d7e5c609$export$a0cb1b4352357fcc);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");


var $716IA = parcelRequire("716IA");
const $d6cc2469d7e5c609$var$controlWrapper = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'flex',
    flexDirection: 'column',
    padding: `0px ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
});
const $d6cc2469d7e5c609$var$labelStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    color: `var(--ds-text-subtlest, ${(0, $7bb4c1736002a04a$export$f563ee71e9ee74cd)})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    paddingBottom: "var(--ds-space-050, 4px)",
    paddingLeft: "var(--ds-space-0, 0px)",
    paddingRight: "var(--ds-space-0, 0px)",
    paddingTop: "var(--ds-space-250, 20px)"
});
class $d6cc2469d7e5c609$export$a0cb1b4352357fcc extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    render() {
        const { //@ts-ignore react-select unsupported props
        selectProps: { popupTitle: popupTitle } } = this.props;
        return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $d6cc2469d7e5c609$var$controlWrapper
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $d6cc2469d7e5c609$var$labelStyle
        }, popupTitle), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $716IA.default), this.props));
    }
}

});
parcelRegister("716IA", function(module, exports) {
$parcel$export(module.exports, "default", () => $3518ae22f57ffbfc$export$2e2bcd8739ae039);
/* Control.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6XEne = parcelRequire("6XEne");

var $k0ahr = parcelRequire("k0ahr");
const $3518ae22f57ffbfc$var$controlStyles = {
    invalid: "_1h6d1bqt _4cvx1bqt",
    focused: "_1h6d1p6i _bfhk1j9a _4cvx1p6i _irr31j9a",
    disabled: "_irr3syzs",
    subtle: "_1h6d3acm _bfhk18uv _4cvx3acm _irr31gly",
    root: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1h6d1elr _bfhk1j9a _p12f1osq _14regrf3 _4cvx1elr _irr31d5g _1a98zg3v",
    compact: "_1tke1wug"
};
const $3518ae22f57ffbfc$var$Control = (props)=>{
    const isCompact = props.appearance === 'compact';
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).Control, {
        ...props,
        xcss: (0, $k0ahr.cx)($3518ae22f57ffbfc$var$controlStyles.root, isCompact && $3518ae22f57ffbfc$var$controlStyles.compact, (props.selectProps.subtle || props.selectProps.noBorder) && $3518ae22f57ffbfc$var$controlStyles.subtle, props.isFocused && $3518ae22f57ffbfc$var$controlStyles.focused, props.isInvalid && $3518ae22f57ffbfc$var$controlStyles.invalid, props.isDisabled && $3518ae22f57ffbfc$var$controlStyles.disabled)
    });
};
var $3518ae22f57ffbfc$export$2e2bcd8739ae039 = $3518ae22f57ffbfc$var$Control;

});


parcelRegister("75q59", function(module, exports) {
$parcel$export(module.exports, "Menu", () => $71e9f791cbbda468$export$d9b273488cd8ce6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $6XEne = parcelRequire("6XEne");

var $1NIU8 = parcelRequire("1NIU8");
const $71e9f791cbbda468$var$getFooterStyle = ()=>{
    return /*#__PURE__*/ (0, $1NIU8.css)({
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`
    });
};
class $71e9f791cbbda468$export$d9b273488cd8ce6f extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $6XEne.components).Menu, this.props, this.props.selectProps.header, this.props.children, this.props.selectProps.footer && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $71e9f791cbbda468$var$getFooterStyle()
        }, this.props.selectProps.footer));
    }
}

});


parcelRegister("lLpLo", function(module, exports) {
$parcel$export(module.exports, "getCreatableProps", () => $03d6b2df141c86e7$export$36f97d8afa97203d);

var $LFmXM = parcelRequire("LFmXM");


var $2lvD5 = parcelRequire("2lvD5");

var $bp6ad = parcelRequire("bp6ad");
const $03d6b2df141c86e7$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $03d6b2df141c86e7$var$isValidNewOption = (isValidEmail = (0, $2lvD5.isValidEmail))=>(inputValue)=>inputValue && $03d6b2df141c86e7$var$validOption.includes(isValidEmail(inputValue));
const $03d6b2df141c86e7$var$getNewOptionData = (inputValue)=>({
        label: inputValue,
        value: inputValue,
        data: {
            id: inputValue,
            name: inputValue,
            type: (0, $f4e041c5b2b1b75c$export$6662b3461398ef8c)
        }
    });
const $03d6b2df141c86e7$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
const $03d6b2df141c86e7$var$isOptionDisabled = (isValidEmail = (0, $2lvD5.isValidEmail))=>(option)=>{
        if ((0, $bp6ad.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
function $03d6b2df141c86e7$var$creatableProps(isValidEmail) {
    return {
        allowCreateWhileLoading: true,
        createOptionPosition: 'first',
        isValidNewOption: $03d6b2df141c86e7$var$isValidNewOption(isValidEmail),
        getNewOptionData: $03d6b2df141c86e7$var$getNewOptionData,
        formatCreateLabel: $03d6b2df141c86e7$var$formatCreateLabel,
        isOptionDisabled: $03d6b2df141c86e7$var$isOptionDisabled(isValidEmail)
    };
}
const $03d6b2df141c86e7$export$36f97d8afa97203d = (0, $LFmXM.default)($03d6b2df141c86e7$var$creatableProps);

});

parcelRegister("f9tKr", function(module, exports) {
$parcel$export(module.exports, "getCreatableSuggestedEmailProps", () => $dfbcb54d733de433$export$34b9dd2dd6a225e5);

var $LFmXM = parcelRequire("LFmXM");


var $2lvD5 = parcelRequire("2lvD5");

var $bp6ad = parcelRequire("bp6ad");
const $dfbcb54d733de433$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $dfbcb54d733de433$var$isValidNewOption = (inputValue)=>inputValue && inputValue.length > 0;
// Generates suggested option data based on user input and validity of the input (if it is an email or not);
const $dfbcb54d733de433$var$getNewOptionData = (isValidEmail = (0, $2lvD5.isValidEmail), emailDomain)=>(inputValue)=>{
        if (!inputValue) return null;
        const isEmail = inputValue && $dfbcb54d733de433$var$validOption.includes(isValidEmail(inputValue));
        const value = isEmail ? inputValue : `${inputValue.replace(/\s+/g, '.').toLocaleLowerCase()}@${emailDomain}`;
        return {
            label: value,
            value: value,
            data: {
                id: value,
                name: value,
                type: (0, $f4e041c5b2b1b75c$export$6662b3461398ef8c),
                suggestion: true
            }
        };
    };
const $dfbcb54d733de433$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
// Option will not be selectable until the email value is valid and can actually be invited
const $dfbcb54d733de433$var$isOptionDisabled = (isValidEmail = (0, $2lvD5.isValidEmail))=>(option)=>{
        if ((0, $bp6ad.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
const $dfbcb54d733de433$export$34b9dd2dd6a225e5 = (0, $LFmXM.default)((emailDomain, isValidEmail)=>({
        allowCreateWhileLoading: true,
        createOptionPosition: 'last',
        isValidNewOption: $dfbcb54d733de433$var$isValidNewOption,
        getNewOptionData: $dfbcb54d733de433$var$getNewOptionData(isValidEmail, emailDomain),
        formatCreateLabel: $dfbcb54d733de433$var$formatCreateLabel,
        isOptionDisabled: $dfbcb54d733de433$var$isOptionDisabled(isValidEmail)
    }));

});

parcelRegister("61zL7", function(module, exports) {
$parcel$export(module.exports, "default", () => $5315f7e1f1805a55$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4nehu = parcelRequire("4nehu");
var $lRq8t = parcelRequire("lRq8t");

var $3VTWQ = parcelRequire("3VTWQ");
const $5315f7e1f1805a55$var$EMPTY = {};
const $5315f7e1f1805a55$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState($5315f7e1f1805a55$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        let aborted = false;
        setMessages($5315f7e1f1805a55$var$EMPTY);
        (0, $3VTWQ.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $5315f7e1f1805a55$var$MessagesIntlProvider = (props)=>{
    const intl = (0, $lRq8t.default)();
    const { children: children } = props;
    const messages = $5315f7e1f1805a55$var$useI18n(intl.locale);
    const mergedMessages = (0, $eJOHy.useMemo)(()=>{
        return {
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        locale: intl.locale,
        messages: mergedMessages,
        children: children
    });
};
var $5315f7e1f1805a55$export$2e2bcd8739ae039 = $5315f7e1f1805a55$var$MessagesIntlProvider;

});
parcelRegister("3VTWQ", function(module, exports) {
$parcel$export(module.exports, "getMessagesForLocale", () => $10ce0748906381fc$export$d0a3169680473b6c);
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 






























const $10ce0748906381fc$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("ekiI8")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("fgm4J")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("drBO7")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("33qfR")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("b8fOo")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("bWIrP")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("3sK4f")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("0YUKd")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("cQwBF")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("lAFFG")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("gk7oQ")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("i90HO")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("c2jzR")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("5EpIH")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("2AW9v")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("3NUXI")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("fU2cZ")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("cpPSG")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("2yNwc")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("9fIis")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("iGZEx")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("35ZX7")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("5V9Ev")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("a3nUu")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("fQJx5")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("5YgKO")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("1WOBW")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("17hu4")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("2nKr7")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("240nm")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $10ce0748906381fc$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("33qfR")).then((mod)=>mod.default);
            }
    }
};

});
parcelRegister("ekiI8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3Rau7").then(()=>parcelRequire('daQ47'));

});

parcelRegister("fgm4J", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5088Q").then(()=>parcelRequire('3gwUr'));

});

parcelRegister("drBO7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jYDLH").then(()=>parcelRequire('4TktE'));

});

parcelRegister("33qfR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5cN1A").then(()=>parcelRequire('9UkW6'));

});

parcelRegister("b8fOo", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6KBLY").then(()=>parcelRequire('keQOQ'));

});

parcelRegister("bWIrP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("22pZ8").then(()=>parcelRequire('j96ER'));

});

parcelRegister("3sK4f", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("l8VWt").then(()=>parcelRequire('lJB7m'));

});

parcelRegister("0YUKd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8pdE4").then(()=>parcelRequire('lrhH1'));

});

parcelRegister("cQwBF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cTgaJ").then(()=>parcelRequire('9bXg4'));

});

parcelRegister("lAFFG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fW1As").then(()=>parcelRequire('ghDtB'));

});

parcelRegister("gk7oQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("31wTJ").then(()=>parcelRequire('fBK8V'));

});

parcelRegister("i90HO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8zZ5r").then(()=>parcelRequire('fOaod'));

});

parcelRegister("c2jzR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gB4Se").then(()=>parcelRequire('55LdR'));

});

parcelRegister("5EpIH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6jN77").then(()=>parcelRequire('4Wmwb'));

});

parcelRegister("2AW9v", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7uPiT").then(()=>parcelRequire('hHM7Q'));

});

parcelRegister("3NUXI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2BwB1").then(()=>parcelRequire('btRta'));

});

parcelRegister("fU2cZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("joqnM").then(()=>parcelRequire('deJm0'));

});

parcelRegister("cpPSG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("80ngU").then(()=>parcelRequire('eWFII'));

});

parcelRegister("2yNwc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gZaei").then(()=>parcelRequire('73cSD'));

});

parcelRegister("9fIis", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hjmdM").then(()=>parcelRequire('a0Otm'));

});

parcelRegister("iGZEx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jRFFA").then(()=>parcelRequire('hTW3c'));

});

parcelRegister("35ZX7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bngha").then(()=>parcelRequire('bO1y4'));

});

parcelRegister("5V9Ev", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iHx0h").then(()=>parcelRequire('h8Ntk'));

});

parcelRegister("a3nUu", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7LPdQ").then(()=>parcelRequire('7UfC0'));

});

parcelRegister("fQJx5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2miED").then(()=>parcelRequire('aHlPd'));

});

parcelRegister("5YgKO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6Clan").then(()=>parcelRequire('gEBJz'));

});

parcelRegister("1WOBW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("b01pn").then(()=>parcelRequire('js5pv'));

});

parcelRegister("17hu4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fhoQ2").then(()=>parcelRequire('5Pm4u'));

});

parcelRegister("2nKr7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("i7U3b").then(()=>parcelRequire('cVDSh'));

});

parcelRegister("240nm", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5JnGw").then(()=>parcelRequire('kzp7K'));

});



parcelRegister("48bcP", function(module, exports) {
$parcel$export(module.exports, "ExusUserSourceProvider", () => $8b385761409405b0$export$bcd5c65b586ee3c3);
$parcel$export(module.exports, "useUserSource", () => $8b385761409405b0$export$c6c0c1a2bac363f);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $8b385761409405b0$var$ExusUserSourceContext = /*#__PURE__*/ (0, $eJOHy.createContext)({});
const $8b385761409405b0$export$bcd5c65b586ee3c3 = ({ fetchUserSource: fetchUserSource, children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)($8b385761409405b0$var$ExusUserSourceContext.Provider, {
        value: {
            fetchUserSource: fetchUserSource
        },
        children: children
    });
const $8b385761409405b0$export$c6c0c1a2bac363f = (accountId, shouldFetchSources, existingSources)=>{
    const { fetchUserSource: fetchUserSource } = (0, $eJOHy.useContext)($8b385761409405b0$var$ExusUserSourceContext);
    const [externalSources, setExternalSources] = (0, $eJOHy.useState)([]);
    const [loading, setLoading] = (0, $eJOHy.useState)(true);
    const [error, setError] = (0, $eJOHy.useState)(null);
    const abortController = (0, $eJOHy.useMemo)(()=>{
        if (typeof AbortController === 'undefined') return;
        return new AbortController();
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        let isMounted = true;
        const cleanup = ()=>{
            abortController?.abort();
            isMounted = false;
        };
        if (!fetchUserSource || !shouldFetchSources) {
            setLoading(false);
            return cleanup;
        }
        fetchUserSource(accountId, abortController?.signal).then((externalSources)=>{
            if (!isMounted) return;
            setLoading(false);
            const externalSourceTypes = externalSources.map((source)=>source.sourceType);
            setExternalSources(externalSourceTypes);
        }).catch((error)=>{
            if (!isMounted) return;
            setLoading(false);
            setError(error);
        });
        return cleanup;
    }, [
        fetchUserSource,
        accountId,
        abortController,
        shouldFetchSources
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            sources: Array.from(new Set([
                ...existingSources ?? [],
                ...externalSources
            ])),
            loading: loading,
            error: error
        }), [
        error,
        existingSources,
        externalSources,
        loading
    ]);
};

});


parcelRegister("1v8Pz", function(module, exports) {
$parcel$export(module.exports, "default", () => $529368ddc15ccc11$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lW5Jn = parcelRequire("lW5Jn");

var $eeq1r = parcelRequire("eeq1r");

var $5Pgl9 = parcelRequire("5Pgl9");
const $529368ddc15ccc11$var$SmartUserPickerWithIntlProvider = (props)=>{
    const ufoId = props.inputId || props.fieldId;
    (0, $5Pgl9.useUFOConcurrentExperience)((0, $5Pgl9.smartUserPickerRenderedUfoExperience), ufoId);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5Pgl9.UfoErrorBoundary), {
        id: ufoId,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eeq1r.default), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lW5Jn.SmartUserPicker), {
                ...props
            })
        })
    });
};
var $529368ddc15ccc11$export$2e2bcd8739ae039 = $529368ddc15ccc11$var$SmartUserPickerWithIntlProvider;

});
parcelRegister("lW5Jn", function(module, exports) {
$parcel$export(module.exports, "SmartUserPicker", () => $efcf1f45f5488268$export$9eedb6e5d313efdb);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $aXKmr = parcelRequire("aXKmr");

var $4J0ad = parcelRequire("4J0ad");

var $LFmXM = parcelRequire("LFmXM");

var $6YFG2 = parcelRequire("6YFG2");

var $g0oDq = parcelRequire("g0oDq");

var $ewHZ5 = parcelRequire("ewHZ5");
var $bp6ad = parcelRequire("bp6ad");
var $2lvD5 = parcelRequire("2lvD5");

var $eGOwo = parcelRequire("eGOwo");

var $3KPN3 = parcelRequire("3KPN3");

var $eeq1r = parcelRequire("eeq1r");

var $3tZlw = parcelRequire("3tZlw");

var $3ROyJ = parcelRequire("3ROyJ");
var $30jJs = parcelRequire("30jJs");

var $5Pgl9 = parcelRequire("5Pgl9");
const $efcf1f45f5488268$var$DEFAULT_DEBOUNCE_TIME_MS = 150;
const $efcf1f45f5488268$var$ufoEndStateConfig = (fieldId)=>{
    return {
        metadata: {
            contextType: fieldId
        }
    };
};
const $efcf1f45f5488268$var$hasContextChanged = (oldContext, newContext)=>oldContext.siteId !== newContext.siteId || oldContext.orgId !== newContext.orgId || oldContext.productKey !== newContext.productKey || oldContext.principalId !== newContext.principalId || oldContext.containerId !== newContext.containerId || oldContext.objectId !== newContext.objectId || oldContext.childObjectId !== newContext.childObjectId;
const $efcf1f45f5488268$var$stringContains = (str, substr)=>{
    if (str === null || str === undefined) return false;
    if (substr === null || substr === '' || substr === undefined) return true;
    return str.toLowerCase().includes(substr.toLowerCase());
};
const $efcf1f45f5488268$var$getUsersForAnalytics = (users)=>(users || []).map(({ id: id, type: type })=>({
            id: id,
            type: type
        }));
const $efcf1f45f5488268$var$checkIf500Event = (statusCode)=>500 <= statusCode && statusCode < 600;
const $efcf1f45f5488268$var$isEmailQuery = (query)=>{
    return (0, $2lvD5.isValidEmail)(query.trim()) === 'VALID';
};
class $efcf1f45f5488268$export$9b9bd453d1d4e4ce extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            baseUrl: '',
            includeUsers: true,
            includeGroups: false,
            includeTeams: false,
            includeNonLicensedUsers: false,
            displayEmailInByline: false,
            prefetch: false,
            principalId: 'Context',
            debounceTime: $efcf1f45f5488268$var$DEFAULT_DEBOUNCE_TIME_MS,
            userResolvers: [],
            enableEmailSearch: false,
            allowEmailSelectionWhenEmailMatched: true
        };
    }
    constructor(props){
        super(props), this.state = {
            users: [],
            loading: false,
            closed: true,
            query: '',
            defaultValue: [],
            bootstrapOptions: []
        }, // Track if the last search was an email search that found matches
        this.lastEmailSearchFoundMatches = false, this.abortOptionsShownUfoExperience = ()=>{
            if (this.optionsShownUfoExperienceInstance.state.id === (0, $g0oDq.UFOExperienceState).STARTED.id) // There may be an existing UFO timing running from previous key entry or focus,
            // so abort it and restart it just in case.
            this.optionsShownUfoExperienceInstance.abort();
        }, this.startOptionsShownUfoExperience = ()=>{
            this.abortOptionsShownUfoExperience();
            this.optionsShownUfoExperienceInstance.start();
        }, this.fireEvent = (eventCreator, ...args)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) (0, $3KPN3.createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, ...args))(createAnalyticsEvent);
        }, this.filterOptions = (users, query, propFilterOptions)=>propFilterOptions ? propFilterOptions(users, query) : users, this.memoizedFilterOptions = (0, $LFmXM.default)(this.filterOptions), this.getUsers = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(async ()=>{
            const { query: query, sessionId: sessionId, closed: closed } = this.state;
            const { baseUrl: baseUrl, childObjectId: childObjectId, containerId: containerId, fieldId: fieldId, includeGroups: includeGroups, includeTeams: includeTeams, includeUsers: includeUsers, includeNonLicensedUsers: includeNonLicensedUsers, intl: intl, maxOptions: maxOptions, objectId: objectId, onEmpty: onEmpty, onError: onError, overrideByline: overrideByline, displayEmailInByline: displayEmailInByline, orgId: orgId, principalId: principalId, productAttributes: productAttributes, productKey: productKey, searchQueryFilter: searchQueryFilter, siteId: siteId, transformOptions: transformOptions, userResolvers: userResolvers, enableEmailSearch: enableEmailSearch } = this.props;
            const maxNumberOfResults = maxOptions || 100;
            const startTime = window.performance.now();
            // Check if this is an email search
            const isEmail = enableEmailSearch && $efcf1f45f5488268$var$isEmailQuery(query);
            const recommendationsRequest = {
                baseUrl: baseUrl,
                context: {
                    containerId: containerId,
                    contextType: fieldId,
                    objectId: objectId,
                    principalId: principalId,
                    productKey: productKey,
                    siteId: siteId,
                    organizationId: orgId,
                    childObjectId: childObjectId,
                    sessionId: sessionId,
                    productAttributes: productAttributes
                },
                includeUsers: includeUsers,
                includeGroups: // For email searches, disable groups and teams
                includeGroups,
                includeTeams: includeTeams,
                includeNonLicensedUsers: includeNonLicensedUsers,
                maxNumberOfResults: maxNumberOfResults,
                query: query,
                searchEmail: isEmail,
                /*
				For email-based searches, we have decided to filter out apps.
				Also - because the other 2 filters ((NOT not_mentionable:true) AND (account_status:active)) are included
				when filter is empty, they have been added here to maintain consistency.

				Further ref: https://developer.atlassian.com/platform/user-recommendations/guides/frequently-asked-questions/#filter-behavior
			 */ searchQueryFilter: isEmail && !searchQueryFilter ? '(NOT not_mentionable:true) AND (account_status:active) AND (NOT account_type:app)' : searchQueryFilter
            };
            try {
                const { query: query } = this.state;
                this.fireEvent((0, $3KPN3.requestUsersEvent));
                let recommendedUsers;
                if ((0, $eGOwo.fg)('twcg-444-invite-usd-improvements-m2-gate')) {
                    const userRecommendationsPromise = (0, $3ROyJ.default)(recommendationsRequest, intl);
                    const userResolversPromises = (userResolvers ?? []).map((resolver)=>resolver(query).catch((error)=>{
                            this.fireEvent((0, $3KPN3.failedUserResolversEvent), {
                                resolverName: resolver.name,
                                error: error
                            });
                            return [];
                        }));
                    const [mainRecommendations, ...userResolverResults] = await Promise.all([
                        userRecommendationsPromise,
                        ...userResolversPromises
                    ]);
                    recommendedUsers = [
                        mainRecommendations,
                        ...userResolverResults
                    ].flat();
                } else recommendedUsers = await (0, $3ROyJ.default)(recommendationsRequest, intl);
                if (overrideByline) {
                    for (let option of recommendedUsers)if ((0, $bp6ad.isUser)(option) || (0, $bp6ad.isExternalUser)(option) || (0, $bp6ad.isTeam)(option)) option.byline = overrideByline(option);
                }
                if (displayEmailInByline) {
                    for (let option of recommendedUsers)if ((0, $bp6ad.isUser)(option) || (0, $bp6ad.isExternalUser)(option)) {
                        if (option.userType === (0, $3tZlw.UserEntityType).DEFAULT || option.userType === (0, $3tZlw.UserEntityType).CUSTOMER) // Respect existing byline if present
                        {
                            if (option.email && !option.byline) option.byline = option.email;
                        }
                    }
                }
                // Track if email search found matches for conditional allowEmail logic
                if (isEmail) this.lastEmailSearchFoundMatches = recommendedUsers.length > 0;
                else this.lastEmailSearchFoundMatches = false;
                const elapsedTimeMilli = window.performance.now() - startTime;
                const transformedOptions = transformOptions ? await transformOptions(recommendedUsers, query) : recommendedUsers;
                const displayedUsers = transformedOptions.length === 0 && onEmpty ? await onEmpty(query) ?? [] : transformedOptions;
                this.setState((state)=>{
                    const applicable = state.query === query;
                    const users = applicable ? displayedUsers : state.users;
                    const loading = !applicable;
                    this.fireEvent((0, $3KPN3.successfulRequestUsersEvent), {
                        users: $efcf1f45f5488268$var$getUsersForAnalytics(recommendedUsers),
                        elapsedTimeMilli: elapsedTimeMilli,
                        displayedUsers: $efcf1f45f5488268$var$getUsersForAnalytics(displayedUsers),
                        productAttributes: productAttributes,
                        applicable: applicable,
                        ...(0, $eGOwo.fg)('twcg-444-invite-usd-improvements-m2-gate') && {
                            userResolvers: Array.isArray(userResolvers) ? userResolvers.map((resolver)=>resolver.name) : []
                        }
                    });
                    return {
                        users: users,
                        loading: loading
                    };
                });
            } catch (e) {
                const is5xxEvent = $efcf1f45f5488268$var$checkIf500Event(e.statusCode);
                if (!closed && !onError && is5xxEvent) // If the user lookup fails while the menu is open, and the consumer is not providing a
                // fallback data source via the onError prop, then send UFO failure
                this.optionsShownUfoExperienceInstance.failure($efcf1f45f5488268$var$ufoEndStateConfig(this.props.fieldId));
                this.setState({
                    users: []
                });
                let onErrorProducedError = false;
                let defaultUsers = [];
                try {
                    defaultUsers = onError ? await onError(e, recommendationsRequest) || [] : [];
                } catch (error) {
                    onErrorProducedError = true;
                }
                if (onErrorProducedError && is5xxEvent) // Log error from fallback data source `onError` to UFO
                this.optionsShownUfoExperienceInstance.failure($efcf1f45f5488268$var$ufoEndStateConfig(this.props.fieldId));
                if (!is5xxEvent && (!onError && !closed || onErrorProducedError)) this.abortOptionsShownUfoExperience();
                this.setState({
                    users: defaultUsers,
                    loading: false
                });
                const elapsedTimeMilli = window.performance.now() - startTime;
                this.fireEvent((0, $3KPN3.failedRequestUsersEvent), {
                    elapsedTimeMilli: elapsedTimeMilli,
                    productAttributes: productAttributes
                });
            }
        }, this.props.debounceTime ?? 0), this.onInputChange = (newQuery, sessionId)=>{
            const query = newQuery || '';
            const { closed: closed } = this.state;
            if (query === this.state.query) return;
            if (!closed) {
                // If the input has been typed into and the dropdown has not been closed
                // (i.e. input blurred) then start the UFO timer.
                // If there's a previous UFO timer running for the same "options shown" experience,
                // it will be aborted first.
                this.startOptionsShownUfoExperience();
                this.setState({
                    loading: true,
                    query: query,
                    sessionId: sessionId
                });
                if (this.props.onInputChange) this.props.onInputChange(query, sessionId);
            }
        }, this.filterUsers = ()=>{
            const { loading: loading, users: users, query: query } = this.state;
            const filteredUsers = this.memoizedFilterOptions(users, query, this.props.filterOptions);
            //If bootstrapOptions have been passed in and it is bootstrap
            if (this.props.bootstrapOptions && this.props.bootstrapOptions.length !== 0 && query === '') {
                const bootstrapFilteredUsers = this.memoizedFilterOptions(this.props.bootstrapOptions, query, this.props.filterOptions);
                this.fireEvent((0, $3KPN3.filterUsersEvent), {
                    filtered: $efcf1f45f5488268$var$getUsersForAnalytics(bootstrapFilteredUsers),
                    all: $efcf1f45f5488268$var$getUsersForAnalytics(this.props.bootstrapOptions)
                });
                return bootstrapFilteredUsers;
            }
            // while when not loading just return already filtered result from server.
            if (!loading) return filteredUsers;
            const queryFilteredUsers = filteredUsers.filter((user)=>$efcf1f45f5488268$var$stringContains(user.name, query));
            this.fireEvent((0, $3KPN3.filterUsersEvent), {
                filtered: $efcf1f45f5488268$var$getUsersForAnalytics(queryFilteredUsers),
                all: $efcf1f45f5488268$var$getUsersForAnalytics(users)
            });
            // when loading filter previous result.
            return filteredUsers;
        }, this.onFocus = (sessionId)=>{
            const state = {
                closed: false
            };
            this.startOptionsShownUfoExperience();
            if (this.state.users.length === 0) {
                state.sessionId = sessionId;
                state.loading = true;
            } else this.fireEvent((0, $3KPN3.preparedUsersLoadedEvent), {
                users: $efcf1f45f5488268$var$getUsersForAnalytics(this.state.users),
                preparedSessionId: this.state.sessionId,
                sessionId: sessionId
            });
            this.setState((currentState)=>({
                    ...currentState,
                    ...state
                }));
            if (this.props.onFocus) this.props.onFocus(sessionId);
        }, this.onBlur = (sessionId)=>{
            this.getUsers.cancel();
            this.abortOptionsShownUfoExperience();
            // clear old users if query is populated so that on refocus,
            // the old list is not shown
            const users = this.state.query.length === 0 ? this.state.users : [];
            this.setState({
                loading: false,
                closed: true,
                users: users
            });
            if (this.props.onBlur) this.props.onBlur(sessionId);
        };
        this.optionsShownUfoExperienceInstance = (0, $5Pgl9.smartUserPickerOptionsShownUfoExperience).getInstance(props.inputId || props.fieldId);
    }
    async componentDidMount() {
        try {
            const value = await (0, $30jJs.default)(this.props.baseUrl, this.props.defaultValue, this.props.productKey, this.props.siteId);
            this.setState({
                defaultValue: value
            });
        } catch (e) {
            const defaultValue = await (this.props.onValueError ? this.props.onValueError(e, this.props.defaultValue) || Promise.resolve([]) : Promise.resolve([]));
            this.setState({
                defaultValue: defaultValue
            });
        }
        const { prefetch: prefetch } = this.props;
        if (prefetch) {
            const sessionId = (0, $aXKmr.v4)();
            this.fireEvent((0, $3KPN3.mountedWithPrefetchEvent), {
                sessionId: sessionId
            });
            this.setState({
                sessionId: sessionId
            });
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if ($efcf1f45f5488268$var$hasContextChanged(prevProps, this.props) || this.props.fieldId !== prevProps.fieldId) this.setState({
            users: []
        });
        if ((this.state.sessionId !== prevState.sessionId || this.state.query !== prevState.query) && (this.state.query !== '' || !this.props.bootstrapOptions)) this.getUsers();
        else if (!this.state.closed && !this.state.loading) // If the component has rendered (including its dropdown list) and it
        // is not loading anything further, send the success UFO event
        {
            if (![
                (0, $g0oDq.UFOExperienceState).FAILED.id,
                (0, $g0oDq.UFOExperienceState).SUCCEEDED.id,
                (0, $g0oDq.UFOExperienceState).ABORTED.id
            ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success($efcf1f45f5488268$var$ufoEndStateConfig(this.props.fieldId));
        }
    }
    render() {
        const { allowEmail: allowEmail, enableEmailSearch: enableEmailSearch, allowEmailSelectionWhenEmailMatched: allowEmailSelectionWhenEmailMatched, ...restProps } = this.props;
        // Determine whether to allow email selection based on allowEmailSelectionWhenEmailMatched, if needed
        let shouldAllowEmail = allowEmail;
        if (allowEmail && enableEmailSearch && !allowEmailSelectionWhenEmailMatched) {
            // Only allow email selection if we're in an email search that found no matches
            const isCurrentQueryEmail = $efcf1f45f5488268$var$isEmailQuery(this.state.query);
            shouldAllowEmail = !isCurrentQueryEmail || !this.lastEmailSearchFoundMatches;
        }
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eeq1r.default), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ewHZ5.UserPicker), {
                ...restProps,
                allowEmail: shouldAllowEmail,
                onInputChange: this.onInputChange,
                onBlur: this.onBlur,
                onFocus: this.onFocus,
                defaultValue: this.state.defaultValue,
                isLoading: this.props.isLoading || this.state.loading && !this.state.closed && (!this.props.bootstrapOptions || this.state.query !== ''),
                options: this.filterUsers()
            })
        });
    }
}
const $efcf1f45f5488268$export$9eedb6e5d313efdb = (0, $4J0ad.default)()((0, $6YFG2.default)($efcf1f45f5488268$export$9b9bd453d1d4e4ce));

});
parcelRegister("3KPN3", function(module, exports) {
$parcel$export(module.exports, "createAndFireEventInElementsChannel", () => $87a372decffff69d$export$53eef0dcd9611650);
$parcel$export(module.exports, "preparedUsersLoadedEvent", () => $87a372decffff69d$export$185f4c3d9b7ef9bf);
$parcel$export(module.exports, "mountedWithPrefetchEvent", () => $87a372decffff69d$export$9cfb4251e50d7b91);
$parcel$export(module.exports, "filterUsersEvent", () => $87a372decffff69d$export$fbba77127d7cb173);
$parcel$export(module.exports, "requestUsersEvent", () => $87a372decffff69d$export$1762ed8845ff2d9b);
$parcel$export(module.exports, "successfulRequestUsersEvent", () => $87a372decffff69d$export$bfc020018aa738d0);
$parcel$export(module.exports, "failedRequestUsersEvent", () => $87a372decffff69d$export$738aca68b593db8e);
$parcel$export(module.exports, "failedUserResolversEvent", () => $87a372decffff69d$export$b9358131e14a4b0b);

var $5fWw9 = parcelRequire("5fWw9");

var $aXKmr = parcelRequire("aXKmr");
const $87a372decffff69d$var$packageName = "platform-pkg";
const $87a372decffff69d$var$packageVersion = "0.0.0-use.local";
const $87a372decffff69d$export$c0d84948cecf78d8 = ()=>({
        id: (0, $aXKmr.v4)(),
        start: Date.now(),
        inputChangeTime: Date.now(),
        upCount: 0,
        downCount: 0,
        lastKey: undefined
    });
const $87a372decffff69d$export$53eef0dcd9611650 = (0, $5fWw9.default)('fabric-elements');
const $87a372decffff69d$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            packageName: $87a372decffff69d$var$packageName,
            packageVersion: $87a372decffff69d$var$packageVersion,
            ...attributes
        }
    });
const $87a372decffff69d$var$createDefaultSmartPickerAttributes = (props, state)=>{
    const { fieldId: fieldId, objectId: objectId, containerId: containerId, childObjectId: childObjectId, prefetch: prefetch, maxOptions: maxOptions, includeTeams: includeTeams, productKey: productKey, principalId: principalId, siteId: siteId, orgId: orgId, filterOptions: filterOptions } = props;
    const { sessionId: sessionId, query: query } = state;
    const maxNumberOfResults = maxOptions || 100;
    return {
        context: fieldId,
        childObjectId: childObjectId,
        containerId: containerId,
        hasFilterOptions: Boolean(filterOptions),
        includeTeams: includeTeams,
        maxNumberOfResults: maxNumberOfResults,
        objectId: objectId,
        prefetch: prefetch,
        principalId: principalId,
        productKey: productKey,
        queryLength: (query || '').length,
        siteId: siteId,
        orgId: orgId,
        sessionId: sessionId
    };
};
const $87a372decffff69d$var$createSmartUserPickerEvent = (action, actionSubect, attributes = {})=>({
        source: 'smart-user-picker',
        ...$87a372decffff69d$var$createEvent('operational', action, actionSubect, attributes)
    });
const $87a372decffff69d$export$185f4c3d9b7ef9bf = (props, state, attributes = {})=>$87a372decffff69d$var$createSmartUserPickerEvent('loaded', 'preparedUsers', {
        ...$87a372decffff69d$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $87a372decffff69d$export$9cfb4251e50d7b91 = (props, state, attributes = {})=>$87a372decffff69d$var$createSmartUserPickerEvent('mounted', 'prefetch', {
        ...$87a372decffff69d$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $87a372decffff69d$export$fbba77127d7cb173 = (props, state, attributes = {})=>$87a372decffff69d$var$createSmartUserPickerEvent('filtered', 'users', {
        ...$87a372decffff69d$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $87a372decffff69d$export$1762ed8845ff2d9b = (props, state, attributes = {})=>$87a372decffff69d$var$createSmartUserPickerEvent('requested', 'users', {
        ...$87a372decffff69d$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $87a372decffff69d$export$bfc020018aa738d0 = (props, state, attributes = {})=>$87a372decffff69d$var$createSmartUserPickerEvent('successful', 'usersRequest', {
        ...$87a372decffff69d$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $87a372decffff69d$export$738aca68b593db8e = (props, state, attributes = {})=>$87a372decffff69d$var$createSmartUserPickerEvent('failed', 'usersRequest', {
        ...$87a372decffff69d$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $87a372decffff69d$export$b9358131e14a4b0b = (props, state, attributes = {})=>$87a372decffff69d$var$createSmartUserPickerEvent('failed', 'userResolversRequest', {
        ...$87a372decffff69d$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });

});

parcelRegister("eeq1r", function(module, exports) {
$parcel$export(module.exports, "default", () => $23b0a0981d1542b0$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6YFG2 = parcelRequire("6YFG2");
var $4nehu = parcelRequire("4nehu");

var $7fN1G = parcelRequire("7fN1G");
const $23b0a0981d1542b0$var$EMPTY = {};
const $23b0a0981d1542b0$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState($23b0a0981d1542b0$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        let aborted = false;
        setMessages($23b0a0981d1542b0$var$EMPTY);
        (0, $7fN1G.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $23b0a0981d1542b0$var$MessagesIntlProvider = (props)=>{
    const { intl: intl, children: children } = props;
    const messages = $23b0a0981d1542b0$var$useI18n(intl.locale);
    const mergedMessages = (0, $eJOHy.useMemo)(()=>{
        return {
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        locale: intl.locale,
        messages: mergedMessages,
        children: children
    });
};
var $23b0a0981d1542b0$export$2e2bcd8739ae039 = (0, $6YFG2.default)($23b0a0981d1542b0$var$MessagesIntlProvider);

});
parcelRegister("7fN1G", function(module, exports) {
$parcel$export(module.exports, "getMessagesForLocale", () => $854557b06cad8001$export$d0a3169680473b6c);
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 





























const $854557b06cad8001$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("khj3i")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("8iBMO")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("eici8")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("3iD7E")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("iIuUG")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("6N0Tv")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("vgwCL")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("k3EAO")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("kU5ax")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("4p6Fl")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("92eLS")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("aQ2fT")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("3rnuY")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("iNZuF")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("gGXh7")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("hMUHg")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("3oecB")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("fOKRP")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("gGFCO")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("hoGou")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("dCtD0")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("SeHZi")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("8EFHH")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("gRy4z")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("a9itp")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("dSqQH")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("aa8ZN")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("3MBIr")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("2FCwZ")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $854557b06cad8001$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("3iD7E")).then((mod)=>mod.default);
            }
    }
};

});
parcelRegister("khj3i", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lqbZ7").then(()=>parcelRequire('6l3q7'));

});

parcelRegister("8iBMO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2o3ud").then(()=>parcelRequire('bGXHO'));

});

parcelRegister("eici8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6IFmc").then(()=>parcelRequire('jOGSG'));

});

parcelRegister("3iD7E", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("g2azy").then(()=>parcelRequire('3y2l5'));

});

parcelRegister("iIuUG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6xkn1").then(()=>parcelRequire('hLoZh'));

});

parcelRegister("6N0Tv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jTO9r").then(()=>parcelRequire('h7dNX'));

});

parcelRegister("vgwCL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4zF1d").then(()=>parcelRequire('3AMQa'));

});

parcelRegister("k3EAO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1cYf6").then(()=>parcelRequire('27TU8'));

});

parcelRegister("kU5ax", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("T3Eou").then(()=>parcelRequire('43TWg'));

});

parcelRegister("4p6Fl", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3UzWf").then(()=>parcelRequire('gicrK'));

});

parcelRegister("92eLS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("goX36").then(()=>parcelRequire('dHHKW'));

});

parcelRegister("aQ2fT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kd2mS").then(()=>parcelRequire('hDyjh'));

});

parcelRegister("3rnuY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hjSai").then(()=>parcelRequire('67Wxi'));

});

parcelRegister("iNZuF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("14Bbk").then(()=>parcelRequire('lXK09'));

});

parcelRegister("gGXh7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7WVoE").then(()=>parcelRequire('gHgDK'));

});

parcelRegister("hMUHg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hqvIQ").then(()=>parcelRequire('2dBQ9'));

});

parcelRegister("3oecB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8GcsS").then(()=>parcelRequire('1ADXg'));

});

parcelRegister("fOKRP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2rOPB").then(()=>parcelRequire('blrZT'));

});

parcelRegister("gGFCO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("68yz2").then(()=>parcelRequire('3KwDQ'));

});

parcelRegister("hoGou", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("63rje").then(()=>parcelRequire('85XJa'));

});

parcelRegister("dCtD0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jdMF4").then(()=>parcelRequire('kPUCC'));

});

parcelRegister("SeHZi", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("c02Om").then(()=>parcelRequire('gvzWw'));

});

parcelRegister("8EFHH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cnxxZ").then(()=>parcelRequire('awnYY'));

});

parcelRegister("gRy4z", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1cRAv").then(()=>parcelRequire('3JjhD'));

});

parcelRegister("a9itp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9ORG4").then(()=>parcelRequire('gSXcf'));

});

parcelRegister("dSqQH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hdhCF").then(()=>parcelRequire('1LTrq'));

});

parcelRegister("aa8ZN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hXbHP").then(()=>parcelRequire('12gCS'));

});

parcelRegister("3MBIr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jtHE4").then(()=>parcelRequire('g8de5'));

});

parcelRegister("2FCwZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9s1QQ").then(()=>parcelRequire('5LINw'));

});



parcelRegister("3tZlw", function(module, exports) {
$parcel$export(module.exports, "EntityType", () => $4a3a3464a4c6b5d9$export$8eda7e02f8f033b2);
$parcel$export(module.exports, "UserEntityType", () => $4a3a3464a4c6b5d9$export$ef0ef29634e52a6b);
var $4a3a3464a4c6b5d9$export$8eda7e02f8f033b2 = /*#__PURE__*/ function(EntityType) {
    EntityType["USER"] = "USER";
    EntityType["TEAM"] = "TEAM";
    EntityType["GROUP"] = "GROUP";
    return EntityType;
}({});
var $4a3a3464a4c6b5d9$export$ef0ef29634e52a6b = /*#__PURE__*/ function(UserEntityType) {
    UserEntityType["DEFAULT"] = "DEFAULT";
    UserEntityType["APP"] = "APP";
    UserEntityType["CUSTOMER"] = "CUSTOMER";
    UserEntityType["SYSTEM"] = "SYSTEM";
    return UserEntityType;
}({});

});

parcelRegister("3ROyJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d267c2f51de75c1$export$2e2bcd8739ae039);

var $46EnI = parcelRequire("46EnI");

var $imaWq = parcelRequire("imaWq");
const $3d267c2f51de75c1$var$getUserRecommendations = (request, intl)=>{
    const url = (0, $imaWq.config).getRecommendationServiceUrl(request.baseUrl || '');
    return fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            context: request.context,
            includeUsers: request.includeUsers,
            includeGroups: request.includeGroups,
            includeTeams: request.includeTeams,
            includeNonLicensedUsers: request.includeNonLicensedUsers,
            maxNumberOfResults: request.maxNumberOfResults,
            performSearchQueryOnly: false,
            searchQuery: {
                cpusQueryHighlights: {
                    query: '',
                    field: ''
                },
                ...request.context?.productAttributes?.isEntitledConfluenceExternalCollaborator && {
                    productAccessPermissionIds: [
                        'write',
                        'external-collaborator-write'
                    ]
                },
                customQuery: '',
                customerDirectoryId: '',
                filter: request.searchQueryFilter || '',
                minimumAccessLevel: 'APPLICATION',
                queryString: request.query,
                restrictTo: {
                    userIds: [],
                    groupIds: []
                },
                searchUserbase: false,
                searchEmail: request.searchEmail
            }
        })
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling smart service, statusCode=${response.status}, statusText=${response.statusText}`,
            statusCode: response.status
        });
    }).then((response)=>(0, $46EnI.transformUsers)(response, intl));
};
var $3d267c2f51de75c1$export$2e2bcd8739ae039 = $3d267c2f51de75c1$var$getUserRecommendations;

});
parcelRegister("46EnI", function(module, exports) {
$parcel$export(module.exports, "transformUsers", () => $ba73f811ffd2c3c2$export$fb8c90bfc4beaa59);


var $9ySOS = parcelRequire("9ySOS");

var $3tZlw = parcelRequire("3tZlw");
const $ba73f811ffd2c3c2$var$getLozenzeProperties = (entity, intl)=>{
    if (entity.attributes?.workspaceMember) return intl.formatMessage((0, $9ySOS.messages).memberLozengeText);
    if (entity.attributes?.isConfluenceExternalCollaborator) {
        const lozengeTooltipMessage = entity.entityType === (0, $3tZlw.EntityType).GROUP ? (0, $9ySOS.messages).guestGroupLozengeTooltip : (0, $9ySOS.messages).guestUserLozengeTooltip;
        return {
            text: intl.formatMessage((0, $9ySOS.messages).guestLozengeText),
            tooltip: intl.formatMessage(lozengeTooltipMessage),
            appearance: 'default'
        };
    }
    return undefined;
};
const $ba73f811ffd2c3c2$var$transformUser = (item, intl)=>{
    const type = item.entityType;
    if (type === (0, $3tZlw.EntityType).USER) {
        const user = item;
        const lozenge = $ba73f811ffd2c3c2$var$getLozenzeProperties(user, intl);
        return {
            id: user.id,
            type: user.nonLicensedUser ? (0, $f4e041c5b2b1b75c$export$50042ec1d2e00e63) : (0, $f4e041c5b2b1b75c$export$8436e53e45ffe15b),
            userType: user.userType,
            avatarUrl: user.avatarUrl,
            name: user.name,
            email: user.email,
            title: user.title,
            lozenge: lozenge,
            tooltip: user.name,
            isExternal: Boolean(user.nonLicensedUser),
            sources: user.nonLicensedUser ? [
                'other-atlassian'
            ] : undefined
        };
    }
    if (type === (0, $3tZlw.EntityType).TEAM) {
        const team = item;
        return {
            id: team.id,
            type: (0, $f4e041c5b2b1b75c$export$26bc40b960693765),
            description: team.description || '',
            name: team.displayName || '',
            memberCount: team.memberCount,
            members: team.members,
            includesYou: team.includesYou,
            avatarUrl: team.largeAvatarImageUrl || team.smallAvatarImageUrl,
            tooltip: team.displayName,
            verified: team.verified
        };
    }
    if (type === (0, $3tZlw.EntityType).GROUP) {
        const group = item;
        const lozenge = $ba73f811ffd2c3c2$var$getLozenzeProperties(group, intl);
        return {
            id: group.id,
            type: (0, $f4e041c5b2b1b75c$export$d460f747b73abb10),
            name: group.name || '',
            lozenge: lozenge
        };
    }
    return;
};
const $ba73f811ffd2c3c2$export$fb8c90bfc4beaa59 = (serverResponse, intl)=>(serverResponse.recommendedUsers || []).map((item)=>$ba73f811ffd2c3c2$var$transformUser(item, intl)).filter((user)=>!!user).map((user)=>user);

});
parcelRegister("9ySOS", function(module, exports) {
$parcel$export(module.exports, "messages", () => $fcb92c9e6b48a947$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $fcb92c9e6b48a947$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    externalUserSourcesHeading: {
        id: 'fabric.elements.user-picker.external.sourced.from',
        defaultMessage: 'Found in:',
        description: 'From where the external user is coming'
    },
    slackProvider: {
        id: 'fabric.elements.user-picker.slack.provider',
        defaultMessage: 'Slack',
        description: 'This external user is sourced from Slack provider'
    },
    googleProvider: {
        id: 'fabric.elements.user-picker.google.provider',
        defaultMessage: 'Google',
        description: 'This external user is sourced from Google provider'
    },
    microsoftProvider: {
        id: 'fabric.elements.user-picker.microsoft.provider',
        defaultMessage: 'Microsoft',
        description: 'This external user is sourced from Microsoft provider'
    },
    gitHubProvider: {
        id: 'fabric.elements.user-picker.github.provider',
        defaultMessage: 'GitHub',
        description: 'This external user is sourced from GitHub provider'
    },
    memberLozengeText: {
        id: 'fabric.elements.user-picker.member.lozenge.text',
        defaultMessage: 'MEMBER',
        description: 'Text within the Lozenge when the user is a workspace member'
    },
    guestLozengeText: {
        id: 'fabric.elements.user-picker.guest.lozenge.text',
        defaultMessage: 'GUEST',
        description: 'Text within the lozenge when the user is a guest of confluence'
    },
    guestUserLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.user',
        defaultMessage: 'Guests can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for guest lozenge showing that a user is a guest in Confluence'
    },
    guestGroupLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.group',
        defaultMessage: 'Guest groups can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for lozenge showing that a group is for guests in Confluence'
    }
});

});


parcelRegister("imaWq", function(module, exports) {
$parcel$export(module.exports, "config", () => $11780213688da020$export$e506a1d27d1eaa20);
const $11780213688da020$export$e506a1d27d1eaa20 = {
    getRecommendationServiceUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/v1/recommendations` : '/gateway/api/v1/recommendations';
    },
    getUsersServiceUrl (productKey, baseUrl = '') {
        return productKey === 'jira' ? `${baseUrl}/rest/api/3/user/bulk` : `${baseUrl}/wiki/rest/api/user/bulk`;
    },
    getGraphQLUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/graphql` : `/gateway/api/graphql`;
    },
    getTeamsUrl (id, baseUrl, siteId) {
        return baseUrl ? `${baseUrl}/gateway/api/v4/teams/${id}?siteId=${siteId ?? 'None'}` : `/gateway/api/v4/teams/${id}?siteId=${siteId ?? 'None'}`;
    }
};

});


parcelRegister("30jJs", function(module, exports) {
$parcel$export(module.exports, "default", () => $d286287b961e656e$export$2e2bcd8739ae039);


var $imaWq = parcelRequire("imaWq");

var $jc66e = parcelRequire("jc66e");

var $8FvAU = parcelRequire("8FvAU");

var $B1j5f = parcelRequire("B1j5f");
const $d286287b961e656e$var$getHydratedUsersFromProducts = (request)=>{
    const url = `${(0, $imaWq.config).getUsersServiceUrl(request.productKey, request.baseUrl)}`;
    let params = new URLSearchParams();
    request.accountIds.map((id)=>params.append('accountId', id));
    params.append('maxResults', '2000');
    return fetch(`${url}?${params}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        }
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling users service, statusCode=${response.status}, statusText=${response.statusText}`
        });
    }).then(request.productKey === 'jira' ? $d286287b961e656e$var$transformJiraUsers : $d286287b961e656e$var$transformConfluenceUsers);
};
const $d286287b961e656e$var$transformJiraUsers = (userResponse)=>userResponse.values.map($d286287b961e656e$var$transformJiraUser).filter((user)=>!!user).map((user)=>user);
const $d286287b961e656e$var$transformJiraUser = (item)=>{
    if (!item) return null;
    return {
        id: item.accountId,
        type: (0, $f4e041c5b2b1b75c$export$8436e53e45ffe15b),
        avatarUrl: item.avatarUrls ? item.avatarUrls['16x16'] : '',
        name: item.displayName,
        email: item.emailAddress
    };
};
const $d286287b961e656e$var$transformConfluenceUsers = (userResponse)=>userResponse.results.map($d286287b961e656e$var$transformConfluenceUser).filter((user)=>!!user).map((user)=>user);
const $d286287b961e656e$var$transformConfluenceUser = (item)=>{
    if (!item) return null;
    return {
        id: item.accountId,
        type: (0, $f4e041c5b2b1b75c$export$8436e53e45ffe15b),
        avatarUrl: item.profilePicture ? item.profilePicture.path : '',
        name: item.publicName,
        email: item.email
    };
};
const $d286287b961e656e$var$sortResults = (options, sortIds)=>{
    const resultsMap = new Map(options.map((option)=>[
            option && option.id,
            option
        ]));
    return sortIds.map((option)=>{
        const user = resultsMap.get(option.id);
        if (user) return user;
        return {
            id: option.id,
            type: option.type,
            name: (0, $B1j5f.UNKNOWN)
        };
    });
};
const $d286287b961e656e$var$isOptionData = (option)=>{
    return option.name !== undefined;
};
const $d286287b961e656e$var$hydrateTeamIds = async (baseUrl, values, siteId)=>{
    if (values.length === 0) return [];
    const legionPromises = values.map((value)=>(0, $8FvAU.default)({
            baseUrl: baseUrl,
            id: value.id,
            siteId: siteId
        }));
    return await Promise.all(legionPromises);
};
const $d286287b961e656e$var$hydrateAccountIds = async (baseUrl, productKey, values)=>{
    if (values.length === 0) return [];
    const accountIds = values.map((val)=>val.id);
    //if we are not jira or confluence then use PRS platform hydration
    return productKey === 'jira' || productKey === 'confluence' ? await $d286287b961e656e$var$getHydratedUsersFromProducts({
        baseUrl: baseUrl,
        productKey: productKey,
        accountIds: accountIds
    }) : await (0, $jc66e.default)(baseUrl, accountIds);
};
async function $d286287b961e656e$var$hydrateDefaultValues(baseUrl, value, productKey, siteId) {
    //return if no value
    if (!value || Array.isArray(value) && value.length === 0) return [];
    const values = Array.isArray(value) ? value : [
        value
    ];
    // return if all hydrated
    if (!values.some((val)=>!$d286287b961e656e$var$isOptionData(val))) return value;
    const [hydratedUsers, hydratedTeams] = await Promise.all([
        $d286287b961e656e$var$hydrateAccountIds(baseUrl, productKey, values.filter((val)=>!$d286287b961e656e$var$isOptionData(val) && val.type === 'user')),
        $d286287b961e656e$var$hydrateTeamIds(baseUrl, values.filter((val)=>!$d286287b961e656e$var$isOptionData(val) && val.type === 'team'), siteId)
    ]);
    const hydratedOptions = values.filter((val)=>$d286287b961e656e$var$isOptionData(val)).map((val)=>val).concat(hydratedUsers).concat(hydratedTeams);
    return $d286287b961e656e$var$sortResults(hydratedOptions, values);
}
var $d286287b961e656e$export$2e2bcd8739ae039 = $d286287b961e656e$var$hydrateDefaultValues;

});
parcelRegister("jc66e", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b9f91f3ca057d13$export$2e2bcd8739ae039);

var $B1j5f = parcelRequire("B1j5f");

var $h5Mhk = parcelRequire("h5Mhk");

var $imaWq = parcelRequire("imaWq");
/**
 * @param  {string} accountIds ids to hydrate
 * @return GraphQL Query
 */ const $0b9f91f3ca057d13$var$buildUsersQuery = (accountIds)=>({
        query: `query usersQuery($accountIds: [ID!]!) {
    users(accountIds: $accountIds) {
      name
      accountId
      picture
    }
  }`,
        variables: {
            accountIds: accountIds
        }
    });
const $0b9f91f3ca057d13$var$makeRequest = async (url, accountIds)=>{
    const query = $0b9f91f3ca057d13$var$buildUsersQuery(accountIds);
    return await (0, $h5Mhk.graphqlQuery)(url, query);
};
const $0b9f91f3ca057d13$var$modifyResponse = (users)=>users.map(({ accountId: accountId, name: name, picture: picture })=>({
            avatarUrl: picture,
            id: accountId,
            name: name,
            type: 'user'
        }));
const $0b9f91f3ca057d13$var$getHydratedUsers = (baseUrl, userIds)=>{
    const url = (0, $imaWq.config).getGraphQLUrl(baseUrl);
    return new Promise((resolve)=>{
        $0b9f91f3ca057d13$var$makeRequest(url, userIds).then((data)=>{
            resolve($0b9f91f3ca057d13$var$modifyResponse(data.users));
        }).catch(()=>{
            // on network error, return original list with label 'Unknown'
            resolve(userIds.map((id)=>({
                    ...(0, $B1j5f.UNKNOWN_USER),
                    id: id
                })));
        });
    });
};
var $0b9f91f3ca057d13$export$2e2bcd8739ae039 = $0b9f91f3ca057d13$var$getHydratedUsers;

});
parcelRegister("B1j5f", function(module, exports) {
$parcel$export(module.exports, "UNKNOWN", () => $acb7dc57b5f8fcc9$export$78244dbb77cfa6b6);
$parcel$export(module.exports, "UNKNOWN_USER", () => $acb7dc57b5f8fcc9$export$d1f5101c0939e3fe);
$parcel$export(module.exports, "UNKNOWN_TEAM", () => $acb7dc57b5f8fcc9$export$8144dcfc9025ca57);
const $acb7dc57b5f8fcc9$export$78244dbb77cfa6b6 = 'Unknown';
const $acb7dc57b5f8fcc9$export$d1f5101c0939e3fe = {
    id: $acb7dc57b5f8fcc9$export$78244dbb77cfa6b6,
    name: $acb7dc57b5f8fcc9$export$78244dbb77cfa6b6,
    type: 'user'
};
const $acb7dc57b5f8fcc9$export$8144dcfc9025ca57 = {
    id: $acb7dc57b5f8fcc9$export$78244dbb77cfa6b6,
    name: $acb7dc57b5f8fcc9$export$78244dbb77cfa6b6,
    type: 'team'
};

});

parcelRegister("h5Mhk", function(module, exports) {
$parcel$export(module.exports, "graphqlQuery", () => $3301920d4c736ea0$export$74eb8d79ae3e02b5);
const $3301920d4c736ea0$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
function $3301920d4c736ea0$export$74eb8d79ae3e02b5(serviceUrl, query) {
    const headers = $3301920d4c736ea0$var$buildHeaders();
    return fetch(new Request(`${serviceUrl}`, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    })).then((response)=>{
        if (!response.ok) return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
        return response;
    }).then((response)=>response.json()).then((json)=>{
        if (json.errors) return Promise.reject({
            reason: json.errors[0]?.category || 'default'
        });
        return json.data;
    });
}

});


parcelRegister("8FvAU", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c205bf20b7e525a$export$2e2bcd8739ae039);

var $imaWq = parcelRequire("imaWq");

var $B1j5f = parcelRequire("B1j5f");
const $2c205bf20b7e525a$var$transformTeam = (team, id)=>{
    return {
        id: id,
        name: team.displayName,
        type: 'team',
        avatarUrl: team.smallAvatarImageUrl
    };
};
const $2c205bf20b7e525a$var$hydrateTeamFromLegion = (request)=>{
    const url = (0, $imaWq.config).getTeamsUrl(request.id, request.baseUrl, request.siteId);
    return fetch(url, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        }
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling Legion, statusCode=${response.status}, statusText=${response.statusText}`
        });
    }).then((response)=>{
        return $2c205bf20b7e525a$var$transformTeam(response, request.id);
    }).catch(()=>({
            ...(0, $B1j5f.UNKNOWN_TEAM),
            id: request.id
        }));
};
var $2c205bf20b7e525a$export$2e2bcd8739ae039 = $2c205bf20b7e525a$var$hydrateTeamFromLegion;

});


parcelRegister("5Pgl9", function(module, exports) {
$parcel$export(module.exports, "smartUserPickerRenderedUfoExperience", () => $d29a1946a924977c$export$df77da4c0210f1c1);
$parcel$export(module.exports, "smartUserPickerOptionsShownUfoExperience", () => $d29a1946a924977c$export$a0e7cca3ab9586eb);
$parcel$export(module.exports, "useUFOConcurrentExperience", () => $d29a1946a924977c$export$e5e0512991825310);
$parcel$export(module.exports, "UfoErrorBoundary", () => $d29a1946a924977c$export$5ef1c2550074a375);

var $eJOHy = parcelRequire("eJOHy");

var $9iIu4 = parcelRequire("9iIu4");
var $aRnO1 = parcelRequire("aRnO1");
var $g0oDq = parcelRequire("g0oDq");
const $d29a1946a924977c$var$COMPONENT_NAME = 'smart-user-picker';
const $d29a1946a924977c$export$df77da4c0210f1c1 = new (0, $9iIu4.ConcurrentExperience)('smart-user-picker-rendered', {
    platform: {
        component: $d29a1946a924977c$var$COMPONENT_NAME
    },
    type: (0, $aRnO1.ExperienceTypes).Load,
    performanceType: (0, $aRnO1.ExperiencePerformanceTypes).PageSegmentLoad
});
const $d29a1946a924977c$export$a0e7cca3ab9586eb = new (0, $9iIu4.ConcurrentExperience)('smart-user-picker-options-shown', {
    platform: {
        component: $d29a1946a924977c$var$COMPONENT_NAME
    },
    type: (0, $aRnO1.ExperienceTypes).Operation,
    performanceType: (0, $aRnO1.ExperiencePerformanceTypes).InlineResult
});
const $d29a1946a924977c$export$e5e0512991825310 = (experience, id)=>{
    const experienceForId = experience.getInstance(id);
    // Equivalent to componentWillMount - replace with @atlaskit/ufo's
    // useUFOComponentExperience when it supports ConcurrentExperience.
    (0, $eJOHy.useState)(()=>{
        experienceForId.start();
    });
    // Replace with @atlaskit/ufo's <ExperienceSuccess> when it supports ConcurrentExperience
    (0, $eJOHy.useEffect)(()=>{
        if (experienceForId.state !== (0, $g0oDq.UFOExperienceState)['FAILED']) experienceForId.success();
        return ()=>{
            if ([
                (0, $g0oDq.UFOExperienceState)['STARTED'],
                (0, $g0oDq.UFOExperienceState)['IN_PROGRESS']
            ].includes(experienceForId.state)) experienceForId.abort();
        };
    // We only want this useEffect to run once after component mount, so no deps are needed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
class $d29a1946a924977c$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidCatch() {
        $d29a1946a924977c$export$df77da4c0210f1c1.getInstance(this.props.id).failure();
    }
    render() {
        return this.props.children;
    }
}

});



parcelRegister("jTA4M", function(module, exports) {
$parcel$export(module.exports, "Label", () => $6e503856f41777f2$export$b04be29aa201d4f5);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3Wh6p = parcelRequire("3Wh6p");
var $5qJVF = parcelRequire("5qJVF");

const $6e503856f41777f2$var$AKLabel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("de5df")).then((module)=>({
            default: module.Label
        })));
const $6e503856f41777f2$export$b04be29aa201d4f5 = ({ isRequired: isRequired, label: label, name: name })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($6e503856f41777f2$var$AKLabel, {
        htmlFor: name,
        id: `${name}-label`,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3Wh6p.default), {
            space: "space.025",
            children: [
                label,
                isRequired && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                    as: "strong",
                    color: "color.text.danger",
                    size: "UNSAFE_small",
                    children: "*"
                })
            ]
        })
    });
};

});



parcelRegister("8iFcj", function(module, exports) {
$parcel$export(module.exports, "WebRuntime", () => $b0afe8d4d8eacfd4$export$c9565324b088e0b8);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8wxIz = parcelRequire("8wxIz");

var $eGOwo = parcelRequire("eGOwo");

var $7pA0u = parcelRequire("7pA0u");
const $b0afe8d4d8eacfd4$export$c9565324b088e0b8 = ({ setForgeDoc: setForgeDoc, setError: setError, accountId: accountId, apolloClient: apolloClient, contextIds: contextIds, extension: extension, components: components, coreData: coreData, extensionData: extensionData, extensionPayload: extensionPayload, extensionViewData: extensionViewData, getContextToken: getContextToken, timezone: timezone, locale: locale, bridge: bridge, ...restProps })=>{
    const forgeReactMajorVersion = (0, $eJOHy.useRef)(null);
    const macroConfigUpdateImprovementEnabled = (0, $eGOwo.fg)('forge-ui-macro-config-update-improvement');
    const combinedBridge = {
        onError: ({ error: error })=>{
            if (setError) setError(error);
        },
        ...bridge,
        reconcile: ({ forgeDoc: forgeDoc })=>{
            Object.freeze(forgeDoc);
            setForgeDoc(forgeDoc);
            if (macroConfigUpdateImprovementEnabled && forgeReactMajorVersion.current === null && forgeDoc.forgeReactMajorVersion) forgeReactMajorVersion.current = forgeDoc.forgeReactMajorVersion;
        }
    };
    const getCurrentForgeReactMajorVersion = (0, $7pA0u.useCallbackOne)(()=>{
        return forgeReactMajorVersion.current;
    }, [
        forgeReactMajorVersion
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8wxIz.Iframe), {
        accountId: accountId,
        apolloClient: apolloClient,
        contextIds: contextIds,
        extension: extension,
        coreData: coreData,
        components: components,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionViewData: extensionViewData,
        getContextToken: getContextToken,
        timezone: timezone,
        locale: locale,
        bridge: combinedBridge,
        isHidden: true,
        getCurrentForgeReactMajorVersion: macroConfigUpdateImprovementEnabled ? getCurrentForgeReactMajorVersion : undefined,
        ...restProps,
        onError: (err)=>setError && setError(new Error(err))
    });
};

});

parcelRegister("h5IVr", function(module, exports) {
$parcel$export(module.exports, "uncurlyUuid", () => $5ac525b24792d305$export$3a1a8bfb58a690be);
const $5ac525b24792d305$var$uuidRe = new RegExp('^{([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})}$');
const $5ac525b24792d305$export$3a1a8bfb58a690be = (uuid)=>{
    const match = $5ac525b24792d305$var$uuidRe.exec(uuid);
    if (!match) return '';
    return match[1];
};

});


parcelRegister("kb5ps", function(module, exports) {
$parcel$export(module.exports, "makeFrame", () => $001d75e608f0eeda$export$1f1ebfe6da5b177c);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $j1aXw = parcelRequire("j1aXw");

var $bEvoj = parcelRequire("bEvoj");
const $001d75e608f0eeda$var$Frame = ({ forgeDoc: forgeDoc, IframeRenderer: IframeRenderer })=>{
    const { setFrameCount: setFrameCount } = (0, $eJOHy.useContext)((0, $j1aXw.FrameCount));
    (0, $eJOHy.useEffect)(()=>{
        setFrameCount((prevCount)=>prevCount + 1);
        return ()=>setFrameCount((prevCount)=>prevCount - 1);
    }, [
        setFrameCount
    ]);
    const { resource: resource, frameId: frameId } = forgeDoc.props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)(IframeRenderer, {
        resource: resource,
        frameId: frameId
    });
};
const $001d75e608f0eeda$var$FrameMemo = /*#__PURE__*/ (0, $eJOHy.memo)($001d75e608f0eeda$var$Frame, (0, $bEvoj.forgePropsAreEqual));
const $001d75e608f0eeda$export$1f1ebfe6da5b177c = (IframeRenderer)=>{
    return (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)($001d75e608f0eeda$var$FrameMemo, {
            ...props,
            IframeRenderer: IframeRenderer
        });
};

});

parcelRegister("8jQS9", function(module, exports) {
$parcel$export(module.exports, "makeModalThreeLOPrompt", () => $edeb570c1d3d0401$export$ee02671eeeecd75);
$parcel$export(module.exports, "makeModalThreeLOPromptForCustomUI", () => $edeb570c1d3d0401$export$85a504818a81117d);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7qGN1 = parcelRequire("7qGN1");
var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $5AgM9 = parcelRequire("5AgM9");

var $5qJVF = parcelRequire("5qJVF");

const $edeb570c1d3d0401$var$AKModalDialog = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("j5ZQQ")));

const $edeb570c1d3d0401$var$AKModalTransition = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("j5ZQQ")).then((module)=>({
            default: module.ModalTransition
        })));

const $edeb570c1d3d0401$var$AKModalHeader = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("2qG7I"))));

const $edeb570c1d3d0401$var$AKModalTitle = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("5a9Ro"))));

const $edeb570c1d3d0401$var$AKModalBody = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("ik0CA"))));

const $edeb570c1d3d0401$var$AKModalFooter = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("kseeK"))));

const $edeb570c1d3d0401$var$AKButton = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bdwGa")));

const $edeb570c1d3d0401$var$SectionMessage = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3O8m5")));
const $edeb570c1d3d0401$var$ModalThreeLOPrompt = ({ onClose: onClose = ()=>{}, isBlanketHidden: isBlanketHidden, ...props })=>{
    const { loading: loading, startAuth: startAuth, promptMessage: promptMessage, buttonText: buttonText } = (0, $5AgM9.useAuth)(props);
    const { authUrl: authUrl } = props;
    const isAuthUrlEmpty = !authUrl || authUrl === '';
    const intl = (0, $lRq8t.default)();
    const { modalTitle: modalTitle, modalBody: modalBody } = isAuthUrlEmpty ? {
        modalTitle: intl.formatMessage($edeb570c1d3d0401$var$messages.modalErrorTitle),
        modalBody: /*#__PURE__*/ (0, $gt9Am.jsx)($edeb570c1d3d0401$var$SectionMessage, {
            appearance: "error",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                as: "p",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...$edeb570c1d3d0401$var$messages.noAuthURLErrorMessage
                })
            })
        })
    } : {
        modalTitle: intl.formatMessage($edeb570c1d3d0401$var$messages.modalAccessRequiredTitle),
        modalBody: promptMessage
    };
    const [isModalOpen, setIsModalOpen] = (0, $eJOHy.useState)(true);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($edeb570c1d3d0401$var$AKModalTransition, {
        children: isModalOpen && /*#__PURE__*/ (0, $gt9Am.jsxs)($edeb570c1d3d0401$var$AKModalDialog, {
            onClose: ()=>{
                setIsModalOpen(false);
                onClose();
            },
            isBlanketHidden: isBlanketHidden,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)($edeb570c1d3d0401$var$AKModalHeader, {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)($edeb570c1d3d0401$var$AKModalTitle, {
                        children: modalTitle
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)($edeb570c1d3d0401$var$AKModalBody, {
                    children: modalBody
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)($edeb570c1d3d0401$var$AKModalFooter, {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)($edeb570c1d3d0401$var$AKButton, {
                            appearance: "subtle",
                            onClick: ()=>{
                                setIsModalOpen(false);
                                onClose();
                            },
                            children: "Cancel"
                        }),
                        !isAuthUrlEmpty && /*#__PURE__*/ (0, $gt9Am.jsx)($edeb570c1d3d0401$var$AKButton, {
                            appearance: "primary",
                            autoFocus: true,
                            isLoading: loading,
                            onClick: startAuth,
                            children: buttonText
                        })
                    ]
                })
            ]
        })
    });
};
var $edeb570c1d3d0401$export$2e2bcd8739ae039 = $edeb570c1d3d0401$var$ModalThreeLOPrompt;
const $edeb570c1d3d0401$export$ee02671eeeecd75 = ({ onClose: onClose, appName: appName })=>{
    return function modalThreeLOPrompt({ forgeDoc: { props: props }, dispatch: dispatch }) {
        const { message: message, authUrl: authUrl, promptText: promptText } = props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)($edeb570c1d3d0401$var$ModalThreeLOPrompt, {
            message: message,
            authUrl: authUrl,
            promptText: promptText,
            onSuccess: ()=>dispatch({
                    type: 'render',
                    extensionData: {}
                }),
            appName: appName,
            onClose: onClose
        });
    };
};
const $edeb570c1d3d0401$export$85a504818a81117d = ({ onClose: onClose, appName: appName, isBlanketHidden: isBlanketHidden = false })=>{
    return (props)=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)($edeb570c1d3d0401$var$ModalThreeLOPrompt, {
            ...props,
            appName: appName,
            onClose: onClose,
            isBlanketHidden: isBlanketHidden
        });
    };
};
const $edeb570c1d3d0401$var$messages = (0, $7qGN1.defineMessages)({
    noAuthURLErrorMessage: {
        id: 'confluence.threeLOPrompt.modal.no.authURL.error-message',
        defaultMessage: 'Consent URL not found. Please refresh the page and try again.',
        description: 'This text is displayed when the URL that gives an app certain permissions is not present.'
    },
    modalErrorTitle: {
        id: 'confluence.threeLOPrompt.modal.error.title',
        defaultMessage: 'Error',
        description: 'This is the title assigned to a modal when there is an error with this component'
    },
    modalAccessRequiredTitle: {
        id: 'confluence.threeLOPrompt.modal.access.required.title',
        defaultMessage: 'Access required',
        description: "This is the title assigned to a modal when access to the user's account is required."
    }
});

});

parcelRegister("33gLE", function(module, exports) {
$parcel$export(module.exports, "ForgeUIExtensionAnalyticsContext", () => $484bfaa2616fe32e$export$5c431bb5ef7d7900);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $e2B2h = parcelRequire("e2B2h");

var $7TDrv = parcelRequire("7TDrv");
const $484bfaa2616fe32e$export$5c431bb5ef7d7900 = ({ extensionId: extensionId, localId: localId, children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
        data: {
            forgeUIAttributes: {
                localId: localId,
                ...(0, $7TDrv.extensionIdToAnalyticsAttributes)(extensionId)
            }
        },
        children: children
    });
};

});
parcelRegister("7TDrv", function(module, exports) {
$parcel$export(module.exports, "extensionIdToAnalyticsAttributes", () => $5700838aaedc0c28$export$d4650cd03b563908);

var $63yBZ = parcelRequire("63yBZ");
function $5700838aaedc0c28$export$d4650cd03b563908(extensionId) {
    if (!extensionId) return {};
    try {
        const ari = (0, $63yBZ.parse)(extensionId);
        if (!ari.resourceId) return {};
        const [appId, environmentId, groupId, extensionKey] = ari.resourceId.split('/');
        return {
            appId: appId,
            environmentId: environmentId,
            groupId: groupId,
            extensionKey: extensionKey
        };
    } catch  {
        return {};
    }
}

});


parcelRegister("fqHZI", function(module, exports) {
$parcel$export(module.exports, "UFOSegmentForgeUnifiedWebRendererRollout", () => $e795e12c439912dc$export$31f657a5c2c592d6);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kioCn = parcelRequire("kioCn");

var $eFZhA = parcelRequire("eFZhA");
const $e795e12c439912dc$var$UFOSegmentForgeUnifiedWebRenderer = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $eFZhA.UFOThirdPartySegment), {
        name: "forge-ui-app-content-root",
        children: children
    });
const $e795e12c439912dc$export$31f657a5c2c592d6 = (0, $kioCn.componentWithFG)('forge-ui-performance-analytics-provider', $e795e12c439912dc$var$UFOSegmentForgeUnifiedWebRenderer, (0, $eJOHy.Fragment));

});

parcelRegister("k5OQG", function(module, exports) {
$parcel$export(module.exports, "PerformanceHoldAttributionAnchorRollout", () => $9019aa2a2aa7d5ba$export$4304f91d6e983d05);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hByHz = parcelRequire("hByHz");

var $6QUJr = parcelRequire("6QUJr");

var $grXB3 = parcelRequire("grXB3");

var $kioCn = parcelRequire("kioCn");

var $dLR8J = parcelRequire("dLR8J");
// Maximum time we would expect an app initialization to take.
const $9019aa2a2aa7d5ba$var$HOLD_MS_APP_INIT_TIMEOUT = 6000;
const $9019aa2a2aa7d5ba$var$HOLD_MS_FRAME_INITIALISED = 2000;
const $9019aa2a2aa7d5ba$var$HOLD_MS_RESOURCE_REQUEST_TIMEOUT = 5000;
const $9019aa2a2aa7d5ba$var$HOLD_MS_CATCH_LATENT_REQUESTS = 350;
const $9019aa2a2aa7d5ba$var$holdResourceStartEvents = new Set([
    'product-api-request-initiated',
    'resolver-invoke-initiated'
]);
const $9019aa2a2aa7d5ba$var$holdResourceEndEvents = new Set([
    'product-api-requested',
    'resolver-invoked'
]);
const $9019aa2a2aa7d5ba$var$holdAffectingEvents = new Set([
    ...$9019aa2a2aa7d5ba$var$holdResourceStartEvents,
    ...$9019aa2a2aa7d5ba$var$holdResourceEndEvents,
    'navigation-timing',
    'user-interacted'
]);
const $9019aa2a2aa7d5ba$export$e286348a1f2b0a60 = ({ children: children })=>{
    const timelineRef = (0, $eJOHy.useContext)((0, $hByHz.PerformanceAnalyticsContext));
    const { captureEvent: captureEvent } = (0, $grXB3.usePerformanceAnalytics)();
    const appRuntimeInitiated = (0, $eJOHy.useRef)(false);
    const [holdState, setHoldState] = (0, $eJOHy.useState)('holding');
    const releaseTimeoutRef = (0, $eJOHy.useRef)();
    const holdResourcesStartedCountRef = (0, $eJOHy.useRef)(0);
    const holdResourcesFinishedCountRef = (0, $eJOHy.useRef)(0);
    const releaseHold = (0, $eJOHy.useCallback)(()=>{
        clearTimeout(releaseTimeoutRef.current);
        setHoldState('released');
    }, [
        setHoldState
    ]);
    const retainHoldFor = (0, $eJOHy.useCallback)((holdFor)=>{
        clearTimeout(releaseTimeoutRef.current);
        releaseTimeoutRef.current = setTimeout(releaseHold, holdFor);
    }, [
        releaseHold
    ]);
    const handleEvent = (0, $eJOHy.useCallback)((event)=>{
        if (!$9019aa2a2aa7d5ba$var$holdAffectingEvents.has(event.type)) return;
        // Drop holds on user interaction (timeline invalidated).
        if (event.type === 'user-interacted') {
            releaseHold();
            return;
        }
        // Keep track of requests starting and finished, don't consider in holding
        // logic until the app has initialised.
        const resourceHoldStarted = $9019aa2a2aa7d5ba$var$holdResourceStartEvents.has(event.type);
        const resourceHoldFinished = $9019aa2a2aa7d5ba$var$holdResourceEndEvents.has(event.type);
        if (resourceHoldStarted) holdResourcesStartedCountRef.current += 1;
        else if (resourceHoldFinished) holdResourcesFinishedCountRef.current += 1;
        const activeResourceRequests = holdResourcesStartedCountRef.current - holdResourcesFinishedCountRef.current;
        // Retain unconditional hold until 'navigation-timing' is received to indicate
        // that the frame runtime has initialised correctly.
        if (!appRuntimeInitiated.current) {
            if (event.type === 'navigation-timing') {
                appRuntimeInitiated.current = true;
                retainHoldFor(activeResourceRequests > 0 ? $9019aa2a2aa7d5ba$var$HOLD_MS_RESOURCE_REQUEST_TIMEOUT : $9019aa2a2aa7d5ba$var$HOLD_MS_FRAME_INITIALISED);
            }
            return;
        }
        // On new resource holds, reset to default resource request timeout.
        if (resourceHoldStarted) retainHoldFor($9019aa2a2aa7d5ba$var$HOLD_MS_RESOURCE_REQUEST_TIMEOUT);
        // Retain hold until all active requests are finished.
        if (activeResourceRequests > 0) return;
        // No active resource requests, wait a moment to catch any new resource
        // requests initiated by the app runtime.
        retainHoldFor($9019aa2a2aa7d5ba$var$HOLD_MS_CATCH_LATENT_REQUESTS);
    }, [
        releaseHold,
        retainHoldFor
    ]);
    // Event listener management.
    (0, $eJOHy.useEffect)(()=>{
        // Default timeout for app init, so we don't indefinitely on e.g. for
        // unhandled app errors.
        retainHoldFor($9019aa2a2aa7d5ba$var$HOLD_MS_APP_INIT_TIMEOUT);
        const { listeners: listeners } = timelineRef.current;
        listeners.add(handleEvent);
        return ()=>{
            clearTimeout(releaseTimeoutRef.current);
            listeners.delete(handleEvent);
        };
    }, [
        timelineRef,
        handleEvent,
        retainHoldFor
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // On hold state change or component dismount: flag release in timeline.
        return ()=>{
            if (holdState === 'holding') captureEvent({
                type: 'page-hold-released',
                elapsed: (0, $6QUJr.getPerformanceMark)()
            });
        };
    }, [
        holdState,
        captureEvent
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dLR8J.default), {
                name: "forge-ui-app-content-ttai-wait-v2",
                hold: holdState === 'holding'
            }),
            children
        ]
    });
};
const $9019aa2a2aa7d5ba$export$4304f91d6e983d05 = (0, $kioCn.componentWithFG)('forge-ui-performance-analytics-provider', $9019aa2a2aa7d5ba$export$e286348a1f2b0a60, (0, $eJOHy.Fragment));

});


parcelRegister("480ZQ", function(module, exports) {
$parcel$export(module.exports, "useBridgeWithMetrics", () => $27baf65a20990f23$export$c81ffa3da6e9c014);
$parcel$export(module.exports, "useCustomBridgeMethodsWithMetrics", () => $27baf65a20990f23$export$f91a43ae1315b0fc);

var $eJOHy = parcelRequire("eJOHy");

var $av1az = parcelRequire("av1az");

var $ePLco = parcelRequire("ePLco");

var $gnlrl = parcelRequire("gnlrl");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $27baf65a20990f23$var$useWithMetrics = (methods, extension, entryPoint, reporters)=>(0, $eJOHy.useMemo)(()=>{
        if (methods == null) return methods;
        const wrapped = {
            ...methods
        };
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const keys = Object.keys(wrapped);
        const forgeType = (0, $av1az.getForgeUIType)(extension);
        const { id: extensionId, type: moduleType, environmentType: envType } = extension;
        const { appId: appId, envId: envId } = (0, $ePLco.parseExtensionId)(extensionId);
        keys.forEach((methodName)=>{
            /** Allows passthrough properties that are difened in the bridge like `basePath` `history` */ if (typeof wrapped[methodName] !== 'function') return;
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            wrapped[methodName] = (...args)=>{
                const methodHandler = methods[methodName];
                const fireEvent = (reporter, // eslint-disable-next-line @typescript-eslint/no-explicit-any
                extraAttributes)=>reporter(methodName, {
                        forgeType: forgeType,
                        appId: appId,
                        envId: envId,
                        entryPoint: entryPoint,
                        moduleType: moduleType,
                        envType: envType,
                        ...extraAttributes
                    });
                fireEvent(reporters.fireTrackMethodCalledEvent);
                try {
                    const callResult = methodHandler(...args);
                    Promise.resolve(callResult).catch((error)=>{
                        fireEvent(reporters.fireOperationalMethodFailedAsyncEvent, {
                            error: error
                        });
                    });
                    return callResult;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    fireEvent(reporters.fireOperationalMethodFailedSyncEvent, {
                        error: error
                    });
                    throw error;
                }
            };
        });
        return wrapped;
    }, [
        methods,
        reporters.fireTrackMethodCalledEvent,
        reporters.fireOperationalMethodFailedAsyncEvent,
        reporters.fireOperationalMethodFailedSyncEvent,
        extension,
        entryPoint
    ]);
const $27baf65a20990f23$export$c81ffa3da6e9c014 = (bridge, extension, entryPoint)=>$27baf65a20990f23$var$useWithMetrics(bridge, extension, entryPoint, (0, $gnlrl.bridgeReporter));
const $27baf65a20990f23$export$f91a43ae1315b0fc = (customBridgeMethods, extension, entryPoint)=>$27baf65a20990f23$var$useWithMetrics(customBridgeMethods, extension, entryPoint, (0, $gnlrl.customBridgeMethodsReporter));

});
parcelRegister("gnlrl", function(module, exports) {
$parcel$export(module.exports, "bridgeReporter", () => $798753569dd0c7aa$export$b19151769733ca26);
$parcel$export(module.exports, "customBridgeMethodsReporter", () => $798753569dd0c7aa$export$723f572c5e7279ea);

var $5IiZP = parcelRequire("5IiZP");

var $1GZq2 = parcelRequire("1GZq2");
// ---------------
// Bridge reporter
// ---------------
const $798753569dd0c7aa$var$bridgeEventId = (0, $5IiZP.toEventId)('bridge');
const $798753569dd0c7aa$var$fireTrackBridgeMethodCalledEvent = (methodName, attributes)=>(0, $1GZq2.fireTrackEvent)(`${methodName} called`, {
        id: $798753569dd0c7aa$var$bridgeEventId,
        attributes: attributes
    });
const $798753569dd0c7aa$var$fireOperationalBridgeMethodFailedSyncEvent = (methodName, attributes)=>(0, $1GZq2.fireOperationalEvent)(`${methodName} failed sync`, {
        id: $798753569dd0c7aa$var$bridgeEventId,
        attributes: attributes
    });
const $798753569dd0c7aa$var$fireOperationalBridgeMethodFailedAsyncEvent = (methodName, attributes)=>(0, $1GZq2.fireOperationalEvent)(`${methodName} failed async`, {
        id: $798753569dd0c7aa$var$bridgeEventId,
        attributes: attributes
    });
// ------------------------------
// Custom bridge method reporters
// ------------------------------
const $798753569dd0c7aa$var$customBridgeMethodEventId = (0, $5IiZP.toEventId)('customBridgeMethod');
const $798753569dd0c7aa$var$fireTrackCustomBridgeMethodCalledEvent = (methodName, attributes)=>(0, $1GZq2.fireTrackEvent)(`${methodName} called`, {
        id: $798753569dd0c7aa$var$customBridgeMethodEventId,
        attributes: attributes
    });
const $798753569dd0c7aa$var$fireOperationalCustomBridgeMethodFailedSyncEvent = (methodName, attributes)=>(0, $1GZq2.fireOperationalEvent)(`${methodName} failed sync`, {
        id: $798753569dd0c7aa$var$customBridgeMethodEventId,
        attributes: attributes
    });
const $798753569dd0c7aa$var$fireOperationalCustomBridgeMethodFailedAsyncEvent = (methodName, attributes)=>(0, $1GZq2.fireOperationalEvent)(`${methodName} failed async`, {
        id: $798753569dd0c7aa$var$customBridgeMethodEventId,
        attributes: attributes
    });
const $798753569dd0c7aa$export$b19151769733ca26 = {
    fireTrackMethodCalledEvent: $798753569dd0c7aa$var$fireTrackBridgeMethodCalledEvent,
    fireOperationalMethodFailedSyncEvent: $798753569dd0c7aa$var$fireOperationalBridgeMethodFailedSyncEvent,
    fireOperationalMethodFailedAsyncEvent: $798753569dd0c7aa$var$fireOperationalBridgeMethodFailedAsyncEvent
};
const $798753569dd0c7aa$export$723f572c5e7279ea = {
    fireTrackMethodCalledEvent: $798753569dd0c7aa$var$fireTrackCustomBridgeMethodCalledEvent,
    fireOperationalMethodFailedSyncEvent: $798753569dd0c7aa$var$fireOperationalCustomBridgeMethodFailedSyncEvent,
    fireOperationalMethodFailedAsyncEvent: $798753569dd0c7aa$var$fireOperationalCustomBridgeMethodFailedAsyncEvent
};

});


parcelRegister("9QgpA", function(module, exports) {
$parcel$export(module.exports, "useFlagProvider", () => $52b469a63f006e06$export$1e7ae4e18cd596dc);

var $eJOHy = parcelRequire("eJOHy");

var $jn1Cb = parcelRequire("jn1Cb");
var $cSXp8 = parcelRequire("cSXp8");

var $9cnQ2 = parcelRequire("9cnQ2");
const $52b469a63f006e06$var$createFlagConfiguration = (flagOptions)=>{
    const { title: title, description: description, type: type, appearance: appearance, actions: actions } = flagOptions;
    return {
        ...flagOptions,
        messageId: `forge.forge-ui-controllers.controllers.product-flags.flag.${flagOptions.id}`,
        messageType: 'transactional',
        title: [
            (0, $9cnQ2.default).flagTitle,
            {
                title: title
            }
        ],
        description: [
            (0, $9cnQ2.default).flagDescription,
            {
                description: description
            }
        ],
        // fallback since both appearance and type are optional
        type: appearance ?? type ?? 'info',
        actions: actions?.map(({ text: text, onClick: onClick })=>({
                onClick: ()=>onClick(),
                content: [
                    (0, $9cnQ2.default).flagActionText,
                    {
                        text: text
                    }
                ]
            }))
    };
};
const $52b469a63f006e06$export$1e7ae4e18cd596dc = ()=>{
    const [flagIds, setFlagIds] = (0, $eJOHy.useState)({});
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $cSXp8.useFlagsService)();
    const createFlag = (0, $eJOHy.useCallback)((flagOptions)=>{
        const { id: rawId } = flagOptions;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const id = (0, $jn1Cb.toFlagId)(rawId);
        setFlagIds({
            ...flagIds,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            [rawId]: id
        });
        const flagConfiguration = $52b469a63f006e06$var$createFlagConfiguration({
            ...flagOptions,
            id: id
        });
        showFlag(flagConfiguration);
        return true;
    }, [
        flagIds,
        showFlag
    ]);
    const closeFlag = (0, $eJOHy.useCallback)(({ id: id })=>{
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (!flagIds[id]) return false;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        dismissFlag(flagIds[id]);
        return true;
    }, [
        dismissFlag,
        flagIds
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            showFlag: createFlag,
            closeFlag: closeFlag
        }), [
        closeFlag,
        createFlag
    ]);
};

});
parcelRegister("9cnQ2", function(module, exports) {
$parcel$export(module.exports, "default", () => $decc13751763c491$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $decc13751763c491$var$messages = (0, $7qGN1.defineMessages)({
    flagTitle: {
        "id": "forge-ui-controllers.controllers.product-flags.flag-title",
        "defaultMessage": "{title}"
    },
    flagDescription: {
        "id": "forge-ui-controllers.controllers.product-flags.flag-description",
        "defaultMessage": "{description}"
    },
    flagActionText: {
        "id": "forge-ui-controllers.controllers.product-flags.flag-action-text",
        "defaultMessage": "{text}"
    }
});
var $decc13751763c491$export$2e2bcd8739ae039 = $decc13751763c491$var$messages;

});


parcelRegister("6lorv", function(module, exports) {
$parcel$export(module.exports, "isGenericIssueExtensionData", () => $1ecb01fffed4dc86$export$f72c2658d80d2789);
const $1ecb01fffed4dc86$export$f72c2658d80d2789 = (extensionData)=>'issue' in extensionData && 'project' in extensionData;

});

parcelRegister("2c40P", function(module, exports) {
$parcel$export(module.exports, "getApolloClient", () => $faf59e42a64554ae$export$1e6cfeaf8b88bd01);

var $4UxGM = parcelRequire("4UxGM");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $faf59e42a64554ae$var$apolloClient;
const $faf59e42a64554ae$export$1e6cfeaf8b88bd01 = ()=>{
    if (!$faf59e42a64554ae$var$apolloClient) $faf59e42a64554ae$var$apolloClient = (0, $4UxGM.clientCreator)();
    return $faf59e42a64554ae$var$apolloClient;
};

});
parcelRegister("4UxGM", function(module, exports) {
$parcel$export(module.exports, "clientCreator", () => $7782376a7283276b$export$de66868aab9e79ea);

var $9Dhvc = parcelRequire("9Dhvc");

var $ifBQy = parcelRequire("ifBQy");

var $eezJL = parcelRequire("eezJL");

var $7oe8F = parcelRequire("7oe8F");

var $i8eSF = parcelRequire("i8eSF");

var $eHpnE = parcelRequire("eHpnE");

var $a6bRt = parcelRequire("a6bRt");

var $g4okI = parcelRequire("g4okI");

var $eSnSE = parcelRequire("eSnSE");

var $1fQNI = parcelRequire("1fQNI");
const $7782376a7283276b$var$APOLLO_CLIENT_ID = 'GATEWAY';
const $7782376a7283276b$var$CACHE_NAME = `apollo-cache/${$7782376a7283276b$var$APOLLO_CLIENT_ID}`;
const $7782376a7283276b$var$LOG_NAMESPACE = `apollo.${$7782376a7283276b$var$APOLLO_CLIENT_ID}.error.graphql`;
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $7782376a7283276b$var$isSsrSuccessful = ()=>false ? true : !window || !window.SPA_STATE;
const $7782376a7283276b$var$NETWORK_ERRORS_COUNTER_KEY = 'networkErrorsCounter';
const $7782376a7283276b$var$retryLink = new (0, $a6bRt.RetryLink)({
    delay: {
        initial: 5000,
        max: 5000
    },
    attempts: {
        max: 2,
        retryIf: (networkError)=>networkError && !networkError.statusCode
    }
});
const $7782376a7283276b$var$errorLink = (0, $i8eSF.onError)(({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    if (graphQLErrors) {
        if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ message: message, locations: locations, path: path })=>(0, $eSnSE.default).safeErrorWithoutCustomerData($7782376a7283276b$var$LOG_NAMESPACE, `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`, {
                message: JSON.stringify(message),
                path: JSON.stringify(path),
                locations: JSON.stringify(locations)
            }));
        else (0, $eSnSE.default).safeErrorWithoutCustomerData($7782376a7283276b$var$LOG_NAMESPACE, '[GraphQL error]: Unexpected error message format', {
            message: JSON.stringify(graphQLErrors)
        });
    }
    if (networkError) {
        const occuredNetworkErrorsBefore = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(operation.getContext(), [
            $7782376a7283276b$var$NETWORK_ERRORS_COUNTER_KEY
        ], 0);
        (0, $eSnSE.default).safeErrorWithoutCustomerData($7782376a7283276b$var$LOG_NAMESPACE, `[Network error]: ${networkError}, attempt ${occuredNetworkErrorsBefore + 1}`);
        operation.setContext({
            [$7782376a7283276b$var$NETWORK_ERRORS_COUNTER_KEY]: occuredNetworkErrorsBefore + 1
        });
    }
});
const $7782376a7283276b$var$cache = new (0, $ifBQy.InMemoryCache)({
    cacheRedirects: {
        Query: {
            ...(0, $g4okI.fragmentCacheRedirect)()
        }
    },
    dataIdFromObject: (object)=>object.id
})// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
.restore(!$7782376a7283276b$var$isSsrSuccessful() && window.SPA_STATE[$7782376a7283276b$var$CACHE_NAME] || {});
const $7782376a7283276b$export$de66868aab9e79ea = ()=>{
    const uri = '/gateway/api/graphql';
    const link = (0, $7oe8F.ApolloLink).from([
        $7782376a7283276b$var$retryLink,
        $7782376a7283276b$var$errorLink,
        (0, $1fQNI.UFOLoggerLink),
        (0, $g4okI.fragmentLinkState)($7782376a7283276b$var$cache),
        new (0, $eHpnE.HttpLink)({
            uri: uri,
            credentials: 'same-origin'
        })
    ]);
    return new (0, $eezJL.ApolloClient)({
        name: $7782376a7283276b$var$APOLLO_CLIENT_ID,
        ssrMode: $7782376a7283276b$var$isSsrSuccessful(),
        // @ts-expect-error - TS2345 - Argument of type '{ name: string; ssrMode: boolean; addTypename: boolean; link: ApolloLink; cache: InMemoryCache; connectToDevTools: boolean; }' is not assignable to parameter of type 'ApolloClientOptions<NormalizedCacheObject>'.
        addTypename: true,
        link: link,
        cache: $7782376a7283276b$var$cache,
        connectToDevTools: false
    });
};

});
parcelRegister("ifBQy", function(module, exports) {
$parcel$export(module.exports, "IntrospectionFragmentMatcher", () => $d496fc3ebf2f1ece$export$3b71c6b829c99d21);
$parcel$export(module.exports, "defaultDataIdFromObject", () => $d496fc3ebf2f1ece$export$bd03c5a9c99d6bce);
$parcel$export(module.exports, "InMemoryCache", () => $d496fc3ebf2f1ece$export$467265324939f47f);

var $dnskZ = parcelRequire("dnskZ");

var $8haCz = parcelRequire("8haCz");

var $jFDfc = parcelRequire("jFDfc");
var $hR4hP = parcelRequire("hR4hP");

var $9WJrj = parcelRequire("9WJrj");

var $lDEi6 = parcelRequire("lDEi6");
var $d496fc3ebf2f1ece$var$haveWarned = false;
function $d496fc3ebf2f1ece$var$shouldWarn() {
    var answer = !$d496fc3ebf2f1ece$var$haveWarned;
    if (!(0, $jFDfc.isTest)()) $d496fc3ebf2f1ece$var$haveWarned = true;
    return answer;
}
var $d496fc3ebf2f1ece$export$5d3fcf53267091de = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            $d496fc3ebf2f1ece$var$shouldWarn();
            return 'heuristic';
        }
        if (__typename === typeCondition) return true;
        $d496fc3ebf2f1ece$var$shouldWarn();
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}();
var $d496fc3ebf2f1ece$export$3b71c6b829c99d21 = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, $lDEi6.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        (0, $lDEi6.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var $d496fc3ebf2f1ece$var$hasOwn = Object.prototype.hasOwnProperty;
var $d496fc3ebf2f1ece$var$DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, $9WJrj.wrap)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if ($d496fc3ebf2f1ece$var$hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!$d496fc3ebf2f1ece$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function $d496fc3ebf2f1ece$var$defaultNormalizedCacheFactory(seed) {
    return new $d496fc3ebf2f1ece$var$DepTrackingCache(seed);
}
var $d496fc3ebf2f1ece$export$628ef07ba8965f12 = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $9WJrj.KeyTrie)((0, $jFDfc.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, $9WJrj.wrap)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof $d496fc3ebf2f1ece$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, $9WJrj.wrap)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $d496fc3ebf2f1ece$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, $9WJrj.wrap)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $d496fc3ebf2f1ece$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, $jFDfc.getQueryDefinition)(query);
        variables = (0, $jFDfc.assign)({}, (0, $jFDfc.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query'
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, $lDEi6.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, $hR4hP.equal)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $d496fc3ebf2f1ece$var$defaultFragmentMatcher : _b;
        var mainDefinition = (0, $jFDfc.getMainDefinition)(query);
        var fragments = (0, $jFDfc.getFragmentDefinitions)(query);
        var fragmentMap = (0, $jFDfc.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $jFDfc.shouldInclude)(selection, variables)) return;
            if ((0, $jFDfc.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, $jFDfc.resultKeyNameFromField)(selection)] = fieldResult, _a));
            } else {
                var fragment = void 0;
                if ((0, $jFDfc.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, $lDEi6.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, $jFDfc.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, $jFDfc.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, $jFDfc.resultKeyNameFromField)(field),
            directives: (0, $jFDfc.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = $d496fc3ebf2f1ece$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            $d496fc3ebf2f1ece$var$assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            $d496fc3ebf2f1ece$var$assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $d496fc3ebf2f1ece$var$assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, $jFDfc.isIdValue)(value)) throw new (0, $lDEi6.InvariantError)(10);
}
function $d496fc3ebf2f1ece$var$defaultFragmentMatcher() {
    return true;
}
function $d496fc3ebf2f1ece$export$7a4899fe13f33235(idValue) {
    (0, $lDEi6.invariant)((0, $jFDfc.isIdValue)(idValue), 11);
}
function $d496fc3ebf2f1ece$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, $jFDfc.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, $jFDfc.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === 'undefined') return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, $jFDfc.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var $d496fc3ebf2f1ece$export$ee7258b8691956a3 = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function $d496fc3ebf2f1ece$export$7e2b40d1002de152(seed) {
    return new $d496fc3ebf2f1ece$export$ee7258b8691956a3(seed);
}
var $d496fc3ebf2f1ece$export$de4e6870dc6ac801 = function(_super) {
    (0, $dnskZ.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error);
function $d496fc3ebf2f1ece$export$fb86e3236e77e3(error, document) {
    var enhancedError = new $d496fc3ebf2f1ece$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var $d496fc3ebf2f1ece$export$eb8361c5d132fb8f = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $d496fc3ebf2f1ece$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $d496fc3ebf2f1ece$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, $jFDfc.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, $jFDfc.assign)({}, (0, $jFDfc.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, $jFDfc.createFragmentMap)((0, $jFDfc.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw $d496fc3ebf2f1ece$export$fb86e3236e77e3(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $jFDfc.shouldInclude)(selection, variables)) return;
            if ((0, $jFDfc.isField)(selection)) {
                var resultFieldKey = (0, $jFDfc.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'defer';
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'client';
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, $jFDfc.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, $lDEi6.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = (0, $jFDfc.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new $d496fc3ebf2f1ece$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, $jFDfc.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, $jFDfc.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
            type: 'json',
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!$d496fc3ebf2f1ece$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, $lDEi6.invariant)(!semanticId || !$d496fc3ebf2f1ece$var$isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!$d496fc3ebf2f1ece$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, $jFDfc.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, $jFDfc.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, $lDEi6.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, $lDEi6.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else $d496fc3ebf2f1ece$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, $hR4hP.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!$d496fc3ebf2f1ece$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, $jFDfc.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function $d496fc3ebf2f1ece$var$isGeneratedId(id) {
    return id[0] === '$';
}
function $d496fc3ebf2f1ece$var$mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, $jFDfc.isIdValue)(value) && $d496fc3ebf2f1ece$var$isGeneratedId(value.id) && (0, $jFDfc.isIdValue)(realValue) && !(0, $hR4hP.equal)(value, realValue) && $d496fc3ebf2f1ece$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, generated), real);
    if ((0, $hR4hP.equal)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function $d496fc3ebf2f1ece$var$isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var $d496fc3ebf2f1ece$var$defaultConfig = {
    fragmentMatcher: new $d496fc3ebf2f1ece$export$5d3fcf53267091de(),
    dataIdFromObject: $d496fc3ebf2f1ece$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function $d496fc3ebf2f1ece$export$bd03c5a9c99d6bce(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var $d496fc3ebf2f1ece$var$hasOwn$1 = Object.prototype.hasOwnProperty;
var $d496fc3ebf2f1ece$var$OptimisticCacheLayer = function(_super) {
    (0, $dnskZ.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return $d496fc3ebf2f1ece$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}($d496fc3ebf2f1ece$export$ee7258b8691956a3);
var $d496fc3ebf2f1ece$export$467265324939f47f = function(_super) {
    (0, $dnskZ.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, $9WJrj.KeyTrie)((0, $jFDfc.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, $d496fc3ebf2f1ece$var$defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new $d496fc3ebf2f1ece$var$DepTrackingCache() : new $d496fc3ebf2f1ece$export$ee7258b8691956a3();
        _this.optimisticData = _this.data;
        _this.storeWriter = new $d496fc3ebf2f1ece$export$eb8361c5d132fb8f();
        _this.storeReader = new $d496fc3ebf2f1ece$export$628ef07ba8965f12({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, $9WJrj.wrap)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof $d496fc3ebf2f1ece$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        return function() {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, $lDEi6.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof $d496fc3ebf2f1ece$var$OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') this.data = this.optimisticData = new $d496fc3ebf2f1ece$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $jFDfc.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!this.silenceBroadcast) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c);
        });
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, $8haCz.ApolloCache));

});
parcelRegister("8haCz", function(module, exports) {
$parcel$export(module.exports, "ApolloCache", () => $60682668fc3daa4e$export$5fc74f25506aa9c);

var $jFDfc = parcelRequire("jFDfc");
function $60682668fc3daa4e$var$queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $60682668fc3daa4e$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            op
        ]
    };
    return out;
}
function $60682668fc3daa4e$var$fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType'
            }
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $60682668fc3daa4e$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            frag
        ]
    };
    return out;
}
function $60682668fc3daa4e$var$selectionSetFromObj(obj) {
    if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
    if (Array.isArray(obj)) return $60682668fc3daa4e$var$selectionSetFromObj(obj[0]);
    var selections = [];
    Object.keys(obj).forEach(function(key) {
        var nestedSelSet = $60682668fc3daa4e$var$selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key
            },
            selectionSet: nestedSelSet || undefined
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections
    };
    return selectionSet;
}
var $60682668fc3daa4e$var$justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename'
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null
                    }
                ]
            }
        }
    ]
};
var $60682668fc3daa4e$export$5fc74f25506aa9c = function() {
    function ApolloCache() {}
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: (0, $jFDfc.getFragmentQueryDocument)(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: (0, $jFDfc.getFragmentQueryDocument)(options.fragment, options.fragmentName)
        });
    };
    ApolloCache.prototype.writeData = function(_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: $60682668fc3daa4e$var$justTypenameQuery
                });
            } catch (e) {}
            var __typename = typenameResult && typenameResult.__typename || '__ClientData';
            var dataToWrite = Object.assign({
                __typename: __typename
            }, data);
            this.writeFragment({
                id: id,
                fragment: $60682668fc3daa4e$var$fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite
            });
        } else this.writeQuery({
            query: $60682668fc3daa4e$var$queryFromPojo(data),
            data: data
        });
    };
    return ApolloCache;
}();
var $60682668fc3daa4e$export$94affb487e701bf2;
$60682668fc3daa4e$export$94affb487e701bf2 || ($60682668fc3daa4e$export$94affb487e701bf2 = {});

});

parcelRegister("9WJrj", function(module, exports) {
$parcel$export(module.exports, "KeyTrie", () => $73dcc72a68d15397$export$6bd8d8299be3ac82);
$parcel$export(module.exports, "wrap", () => $73dcc72a68d15397$export$4997ffc0176396a6);

var $hUWo2 = parcelRequire("hUWo2");
function $73dcc72a68d15397$var$defaultDispose() {}
var $73dcc72a68d15397$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $73dcc72a68d15397$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $73dcc72a68d15397$var$parentEntrySlot = new (0, $hUWo2.Slot)();
var $73dcc72a68d15397$var$reusableEmptyArray = [];
var $73dcc72a68d15397$var$emptySetPool = [];
var $73dcc72a68d15397$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $73dcc72a68d15397$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $73dcc72a68d15397$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $73dcc72a68d15397$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $73dcc72a68d15397$var$valueCopy(value) {
    return value.slice(0);
}
var $73dcc72a68d15397$var$Entry = /** @class */ function() {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function() {
        $73dcc72a68d15397$var$assert(!this.recomputing, "already recomputing");
        if (!$73dcc72a68d15397$var$rememberParent(this) && $73dcc72a68d15397$var$maybeReportOrphan(this)) // The recipient of the entry.reportOrphan callback decided to dispose
        // of this orphan entry by calling entry.dispose(), so we don't need to
        // (and should not) proceed with the recomputation.
        return void 0;
        return $73dcc72a68d15397$var$mightBeDirty(this) ? $73dcc72a68d15397$var$reallyRecompute(this) : $73dcc72a68d15397$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $73dcc72a68d15397$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $73dcc72a68d15397$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $73dcc72a68d15397$var$forgetChildren(this).forEach($73dcc72a68d15397$var$maybeReportOrphan);
        $73dcc72a68d15397$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $73dcc72a68d15397$var$forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}();
function $73dcc72a68d15397$var$rememberParent(child) {
    var parent = $73dcc72a68d15397$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($73dcc72a68d15397$var$mightBeDirty(child)) $73dcc72a68d15397$var$reportDirtyChild(parent, child);
        else $73dcc72a68d15397$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $73dcc72a68d15397$var$reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = $73dcc72a68d15397$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $73dcc72a68d15397$var$parentEntrySlot.withValue(entry, $73dcc72a68d15397$var$recomputeNewValue, [
        entry
    ]);
    if ($73dcc72a68d15397$var$maybeSubscribe(entry)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $73dcc72a68d15397$var$setClean(entry);
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach($73dcc72a68d15397$var$maybeReportOrphan);
    return $73dcc72a68d15397$var$valueGet(entry.value);
}
function $73dcc72a68d15397$var$recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $73dcc72a68d15397$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $73dcc72a68d15397$var$setClean(entry) {
    entry.dirty = false;
    if ($73dcc72a68d15397$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $73dcc72a68d15397$var$reportClean(entry);
}
function $73dcc72a68d15397$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $73dcc72a68d15397$var$reportDirtyChild(parent, child);
    });
}
function $73dcc72a68d15397$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $73dcc72a68d15397$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $73dcc72a68d15397$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $73dcc72a68d15397$var$assert(parent.childValues.has(child));
    $73dcc72a68d15397$var$assert($73dcc72a68d15397$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $73dcc72a68d15397$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $73dcc72a68d15397$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $73dcc72a68d15397$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $73dcc72a68d15397$var$assert(parent.childValues.has(child));
    $73dcc72a68d15397$var$assert(!$73dcc72a68d15397$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $73dcc72a68d15397$var$valueCopy(child.value));
    else if (!$73dcc72a68d15397$var$valueIs(childValue, child.value)) parent.setDirty();
    $73dcc72a68d15397$var$removeDirtyChild(parent, child);
    if ($73dcc72a68d15397$var$mightBeDirty(parent)) return;
    $73dcc72a68d15397$var$reportClean(parent);
}
function $73dcc72a68d15397$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($73dcc72a68d15397$var$emptySetPool.length < $73dcc72a68d15397$var$POOL_TARGET_SIZE) $73dcc72a68d15397$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function $73dcc72a68d15397$var$maybeReportOrphan(entry) {
    return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function $73dcc72a68d15397$var$forgetChildren(parent) {
    var children = $73dcc72a68d15397$var$reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function(_value, child) {
            $73dcc72a68d15397$var$forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $73dcc72a68d15397$var$assert(parent.dirtyChildren === null);
    return children;
}
function $73dcc72a68d15397$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $73dcc72a68d15397$var$removeDirtyChild(parent, child);
}
function $73dcc72a68d15397$var$maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") try {
        $73dcc72a68d15397$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function $73dcc72a68d15397$var$maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $73dcc72a68d15397$export$6bd8d8299be3ac82 = /** @class */ function() {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        array.forEach(function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $73dcc72a68d15397$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}();
function $73dcc72a68d15397$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $73dcc72a68d15397$var$keyTrie = new $73dcc72a68d15397$export$6bd8d8299be3ac82(typeof WeakMap === "function");
function $73dcc72a68d15397$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $73dcc72a68d15397$var$keyTrie.lookupArray(args);
}
var $73dcc72a68d15397$var$caches = new Set();
function $73dcc72a68d15397$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $73dcc72a68d15397$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || $73dcc72a68d15397$export$cd3144f8dd136006;
    function optimistic() {
        if (disposable && !$73dcc72a68d15397$var$parentEntrySlot.hasValue()) // If there's no current parent computation, and this wrapped
        // function is disposable (meaning we don't care about entry.value,
        // just dependency tracking), then we can short-cut everything else
        // in this function, because entry.recompute() is going to recycle
        // the entry object without recomputing anything, anyway.
        return void 0;
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) entry.args = args;
        else {
            entry = new $73dcc72a68d15397$var$Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) entry.reportOrphan = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $73dcc72a68d15397$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$73dcc72a68d15397$var$parentEntrySlot.hasValue()) {
            $73dcc72a68d15397$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $73dcc72a68d15397$var$caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function() {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) child.setDirty();
    };
    return optimistic;
}

});
parcelRegister("hUWo2", function(module, exports) {
$parcel$export(module.exports, "Slot", () => $d0b4f509668bceb7$export$8c6ed5c666ac1360);
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $d0b4f509668bceb7$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $d0b4f509668bceb7$var$MISSING_VALUE = {};
var $d0b4f509668bceb7$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $d0b4f509668bceb7$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $d0b4f509668bceb7$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $d0b4f509668bceb7$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $d0b4f509668bceb7$var$MISSING_VALUE) break;
                if (context_1 !== $d0b4f509668bceb7$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $d0b4f509668bceb7$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($d0b4f509668bceb7$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $d0b4f509668bceb7$var$currentContext.slots[this.id] = $d0b4f509668bceb7$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $d0b4f509668bceb7$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $d0b4f509668bceb7$var$currentContext;
            $d0b4f509668bceb7$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $d0b4f509668bceb7$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $d0b4f509668bceb7$var$currentContext;
            return function() {
                var saved = $d0b4f509668bceb7$var$currentContext;
                try {
                    $d0b4f509668bceb7$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $d0b4f509668bceb7$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($d0b4f509668bceb7$var$currentContext) {
                var saved = $d0b4f509668bceb7$var$currentContext;
                try {
                    $d0b4f509668bceb7$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $d0b4f509668bceb7$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $d0b4f509668bceb7$var$globalKey = "@wry/context:Slot";
var $d0b4f509668bceb7$var$host = Array;
var $d0b4f509668bceb7$export$8c6ed5c666ac1360 = $d0b4f509668bceb7$var$host[$d0b4f509668bceb7$var$globalKey] || function() {
    var Slot = $d0b4f509668bceb7$var$makeSlotClass();
    try {
        Object.defineProperty($d0b4f509668bceb7$var$host, $d0b4f509668bceb7$var$globalKey, {
            value: $d0b4f509668bceb7$var$host[$d0b4f509668bceb7$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $d0b4f509668bceb7$export$2385a24977818dd0 = $d0b4f509668bceb7$export$8c6ed5c666ac1360.bind, $d0b4f509668bceb7$export$9fa6f2e300a97f8 = $d0b4f509668bceb7$export$8c6ed5c666ac1360.noContext;
function $d0b4f509668bceb7$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($d0b4f509668bceb7$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $d0b4f509668bceb7$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $d0b4f509668bceb7$export$2385a24977818dd0(gen.next);
        var boundThrow = $d0b4f509668bceb7$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($d0b4f509668bceb7$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $d0b4f509668bceb7$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $d0b4f509668bceb7$var$wrappedFibers = [];
function $d0b4f509668bceb7$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($d0b4f509668bceb7$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $d0b4f509668bceb7$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $d0b4f509668bceb7$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});



parcelRegister("i8eSF", function(module, exports) {
$parcel$export(module.exports, "onError", () => $d334845f424573c9$export$2288787135a8f66e);

var $dnskZ = parcelRequire("dnskZ");

var $7oe8F = parcelRequire("7oe8F");
var $1ZCcZ = parcelRequire("1ZCcZ");
function $d334845f424573c9$export$2288787135a8f66e(errorHandler) {
    return new (0, $7oe8F.ApolloLink)(function(operation, forward) {
        return new (0, $1ZCcZ.default)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $d334845f424573c9$export$d2c8415987899609 = function(_super) {
    (0, $dnskZ.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $d334845f424573c9$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $7oe8F.ApolloLink));

});

parcelRegister("eHpnE", function(module, exports) {
$parcel$export(module.exports, "HttpLink", () => $ab38c4d93356db03$export$f4bbf1aec241cc1);

var $dnskZ = parcelRequire("dnskZ");

var $7oe8F = parcelRequire("7oe8F");
var $1ZCcZ = parcelRequire("1ZCcZ");

var $1pDgh = parcelRequire("1pDgh");
var $ab38c4d93356db03$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, $dnskZ.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries",
        "abortErrorDoesNotCauseError"
    ]);
    (0, $1pDgh.checkFetcher)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $7oe8F.ApolloLink)(function(operation) {
        var chosenURI = (0, $1pDgh.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $dnskZ.__assign)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $1pDgh.selectHttpOptionsAndBody)(operation, (0, $1pDgh.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, $1pDgh.createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if (options.method === 'GET') {
            var _d = $ab38c4d93356db03$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $7oe8F.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $1pDgh.serializeFetchParameter)(body, 'Payload');
        } catch (parseError) {
            return (0, $7oe8F.fromError)(parseError);
        }
        return new (0, $1ZCcZ.default)(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $1pDgh.parseAndCheckHttpResponse)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};
function $ab38c4d93356db03$var$rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $1pDgh.serializeFetchParameter)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $1pDgh.serializeFetchParameter)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}
var $ab38c4d93356db03$export$f4bbf1aec241cc1 = function(_super) {
    (0, $dnskZ.__extends)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, $ab38c4d93356db03$export$95180a16573d6675(opts).request) || this;
    }
    return HttpLink;
}((0, $7oe8F.ApolloLink));

});
parcelRegister("1pDgh", function(module, exports) {
$parcel$export(module.exports, "fallbackHttpConfig", () => $107694c730f3c7b9$export$dd86f00dc866e75d);
$parcel$export(module.exports, "parseAndCheckHttpResponse", () => $107694c730f3c7b9$export$d4051215bea0639f);
$parcel$export(module.exports, "checkFetcher", () => $107694c730f3c7b9$export$8423f0cd3773115e);
$parcel$export(module.exports, "createSignalIfSupported", () => $107694c730f3c7b9$export$f5853cd1fc39aea6);
$parcel$export(module.exports, "selectHttpOptionsAndBody", () => $107694c730f3c7b9$export$a00ebfd5f1eebfb1);
$parcel$export(module.exports, "serializeFetchParameter", () => $107694c730f3c7b9$export$5f8e80ac52052e28);
$parcel$export(module.exports, "selectURI", () => $107694c730f3c7b9$export$63ccc2571850f81a);

var $dnskZ = parcelRequire("dnskZ");

var $6NFTG = parcelRequire("6NFTG");

var $lDEi6 = parcelRequire("lDEi6");
var $107694c730f3c7b9$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $107694c730f3c7b9$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $107694c730f3c7b9$var$defaultOptions = {
    method: 'POST'
};
var $107694c730f3c7b9$export$dd86f00dc866e75d = {
    http: $107694c730f3c7b9$var$defaultHttpOptions,
    headers: $107694c730f3c7b9$var$defaultHeaders,
    options: $107694c730f3c7b9$var$defaultOptions
};
var $107694c730f3c7b9$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var $107694c730f3c7b9$export$d4051215bea0639f = function(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = 'ServerParseError';
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                return Promise.reject(parseError);
            }
        }).then(function(result) {
            if (response.status >= 300) $107694c730f3c7b9$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $107694c730f3c7b9$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
};
var $107694c730f3c7b9$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined') library = 'node-fetch';
        throw new (0, $lDEi6.InvariantError)(1);
    }
};
var $107694c730f3c7b9$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};
var $107694c730f3c7b9$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $dnskZ.__assign)({}, fallbackConfig.options, {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http;
    configs.forEach(function(config) {
        options = (0, $dnskZ.__assign)({}, options, config.options, {
            headers: (0, $dnskZ.__assign)({}, options.headers, config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $dnskZ.__assign)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $6NFTG.print)(query);
    return {
        options: options,
        body: body
    };
};
var $107694c730f3c7b9$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $lDEi6.InvariantError)(2);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var $107694c730f3c7b9$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};

});


parcelRegister("a6bRt", function(module, exports) {
$parcel$export(module.exports, "RetryLink", () => $75a3aa60951dc58d$export$943d544ad120494a);

var $dnskZ = parcelRequire("dnskZ");

var $7oe8F = parcelRequire("7oe8F");
var $1ZCcZ = parcelRequire("1ZCcZ");
function $75a3aa60951dc58d$var$buildDelayFunction(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) delay = Math.random() * delay;
        return delay;
    };
}
function $75a3aa60951dc58d$var$buildRetryFunction(retryOptions) {
    var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
        if (count >= max) return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}
var $75a3aa60951dc58d$var$RetryableOperation = function() {
    function RetryableOperation(operation, nextLink, delayFor, retryIf) {
        var _this = this;
        this.operation = operation;
        this.nextLink = nextLink;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.retryCount = 0;
        this.values = [];
        this.complete = false;
        this.canceled = false;
        this.observers = [];
        this.currentSubscription = null;
        this.onNext = function(value) {
            _this.values.push(value);
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.next(value);
            }
        };
        this.onComplete = function() {
            _this.complete = true;
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.complete();
            }
        };
        this.onError = function(error) {
            return (0, $dnskZ.__awaiter)(_this, void 0, void 0, function() {
                var shouldRetry, _i, _a, observer;
                return (0, $dnskZ.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.retryCount += 1;
                            return [
                                4,
                                this.retryIf(this.retryCount, this.operation, error)
                            ];
                        case 1:
                            shouldRetry = _b.sent();
                            if (shouldRetry) {
                                this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                return [
                                    2
                                ];
                            }
                            this.error = error;
                            for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                observer = _a[_i];
                                if (!observer) continue;
                                observer.error(error);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        };
    }
    RetryableOperation.prototype.subscribe = function(observer) {
        if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
        this.observers.push(observer);
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var value = _a[_i];
            observer.next(value);
        }
        if (this.complete) observer.complete();
        else if (this.error) observer.error(this.error);
    };
    RetryableOperation.prototype.unsubscribe = function(observer) {
        var index = this.observers.indexOf(observer);
        if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
        this.observers[index] = null;
        if (this.observers.every(function(o) {
            return o === null;
        })) this.cancel();
    };
    RetryableOperation.prototype.start = function() {
        if (this.currentSubscription) return;
        this.try();
    };
    RetryableOperation.prototype.cancel = function() {
        if (this.currentSubscription) this.currentSubscription.unsubscribe();
        clearTimeout(this.timerId);
        this.timerId = null;
        this.currentSubscription = null;
        this.canceled = true;
    };
    RetryableOperation.prototype.try = function() {
        this.currentSubscription = this.nextLink(this.operation).subscribe({
            next: this.onNext,
            error: this.onError,
            complete: this.onComplete
        });
    };
    RetryableOperation.prototype.scheduleRetry = function(delay) {
        var _this = this;
        if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
        this.timerId = setTimeout(function() {
            _this.timerId = null;
            _this.try();
        }, delay);
    };
    return RetryableOperation;
}();
var $75a3aa60951dc58d$export$943d544ad120494a = function(_super) {
    (0, $dnskZ.__extends)(RetryLink, _super);
    function RetryLink(options) {
        var _this = _super.call(this) || this;
        var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
        _this.delayFor = typeof delay === 'function' ? delay : $75a3aa60951dc58d$var$buildDelayFunction(delay);
        _this.retryIf = typeof attempts === 'function' ? attempts : $75a3aa60951dc58d$var$buildRetryFunction(attempts);
        return _this;
    }
    RetryLink.prototype.request = function(operation, nextLink) {
        var retryable = new $75a3aa60951dc58d$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
        retryable.start();
        return new (0, $1ZCcZ.default)(function(observer) {
            retryable.subscribe(observer);
            return function() {
                retryable.unsubscribe(observer);
            };
        });
    };
    return RetryLink;
}((0, $7oe8F.ApolloLink));

});

parcelRegister("g4okI", function(module, exports) {
$parcel$export(module.exports, "fragmentCacheRedirect", () => $bb2fe5188907aceb$export$5133c88128301697);
$parcel$export(module.exports, "fragmentLinkState", () => $bb2fe5188907aceb$export$3f9ecfb4d42ab23d);

var $jFDfc = parcelRequire("jFDfc");

var $fT6ea = parcelRequire("fT6ea");

var $ifBQy = parcelRequire("ifBQy");
function $bb2fe5188907aceb$export$5133c88128301697(dataIdFromObject) {
    if (dataIdFromObject === void 0) dataIdFromObject = (0, $ifBQy.defaultDataIdFromObject);
    return {
        getFragment: function(_, _a) {
            var id = _a.id, __typename = _a.__typename;
            return (0, $jFDfc.toIdValue)(dataIdFromObject({
                __typename: __typename,
                id: id
            }));
        }
    };
}
function $bb2fe5188907aceb$export$3f9ecfb4d42ab23d(apolloCache) {
    return (0, $fT6ea.withClientState)({
        cache: apolloCache,
        resolvers: {
            Query: {
                getFragment: function(_, _a, _b) {
                    var __typename = _a.__typename, id = _a.id;
                    var cache = _b.cache;
                    var fragmentId = cache.config.dataIdFromObject({
                        __typename: __typename,
                        id: id
                    });
                    return cache.data.data[fragmentId];
                }
            }
        }
    });
}

});
parcelRegister("fT6ea", function(module, exports) {
$parcel$export(module.exports, "withClientState", () => $b910d2b7906fe912$export$a13f755900e15d9e);

var $7oe8F = parcelRequire("7oe8F");
var $1ZCcZ = parcelRequire("1ZCcZ");

var $jFDfc = parcelRequire("jFDfc");

var $aW6ai = parcelRequire("aW6ai");

var $fhjWZ = parcelRequire("fhjWZ");
var $b910d2b7906fe912$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $b910d2b7906fe912$var$graphql = $aW6ai.graphql;
var $b910d2b7906fe912$var$capitalizeFirstLetter = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var $b910d2b7906fe912$export$a13f755900e15d9e = function(clientStateConfig) {
    if (clientStateConfig === void 0) clientStateConfig = {
        resolvers: {},
        defaults: {}
    };
    var defaults = clientStateConfig.defaults, cache = clientStateConfig.cache, typeDefs = clientStateConfig.typeDefs, fragmentMatcher = clientStateConfig.fragmentMatcher;
    if (cache && defaults) cache.writeData({
        data: defaults
    });
    return new (function(_super) {
        $b910d2b7906fe912$var$__extends(StateLink, _super);
        function StateLink() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        StateLink.prototype.writeDefaults = function() {
            if (cache && defaults) cache.writeData({
                data: defaults
            });
        };
        StateLink.prototype.request = function(operation, forward) {
            if (forward === void 0) forward = function() {
                return (0, $1ZCcZ.default).of({
                    data: {}
                });
            };
            if (typeDefs) {
                var directives_1 = 'directive @client on FIELD';
                var definition_1 = (0, $fhjWZ.normalizeTypeDefs)(typeDefs);
                operation.setContext(function(_a) {
                    var _b = _a.schemas, schemas = _b === void 0 ? [] : _b;
                    return {
                        schemas: schemas.concat([
                            {
                                definition: definition_1,
                                directives: directives_1
                            }
                        ])
                    };
                });
            }
            var isClient = (0, $jFDfc.hasDirectives)([
                'client'
            ], operation.query);
            if (!isClient) return forward(operation);
            var resolvers = typeof clientStateConfig.resolvers === 'function' ? clientStateConfig.resolvers() : clientStateConfig.resolvers;
            var server = (0, $fhjWZ.removeClientSetsFromDocument)(operation.query);
            var query = operation.query;
            var type = $b910d2b7906fe912$var$capitalizeFirstLetter(((0, $jFDfc.getMainDefinition)(query) || {}).operation) || 'Query';
            var resolver = function(fieldName, rootValue, args, context, info) {
                if (rootValue === void 0) rootValue = {};
                var resultKey = info.resultKey;
                var aliasedNode = rootValue[resultKey];
                var preAliasingNode = rootValue[fieldName];
                var aliasNeeded = resultKey !== fieldName;
                if (aliasedNode !== undefined || preAliasingNode !== undefined) return aliasedNode || preAliasingNode;
                var resolverMap = resolvers[rootValue.__typename || type];
                if (resolverMap) {
                    var resolve = resolverMap[fieldName];
                    if (resolve) return resolve(rootValue, args, context, info);
                }
                return (aliasNeeded ? aliasedNode : preAliasingNode) || (defaults || {})[fieldName];
            };
            if (server) operation.query = server;
            var obs = server && forward ? forward(operation) : (0, $1ZCcZ.default).of({
                data: {}
            });
            return new (0, $1ZCcZ.default)(function(observer) {
                var complete = false;
                var handlingNext = false;
                obs.subscribe({
                    next: function(_a) {
                        var data = _a.data, errors = _a.errors;
                        var observerErrorHandler = observer.error.bind(observer);
                        var context = operation.getContext();
                        handlingNext = true;
                        $b910d2b7906fe912$var$graphql(resolver, query, data, context, operation.variables, {
                            fragmentMatcher: fragmentMatcher
                        }).then(function(nextData) {
                            observer.next({
                                data: nextData,
                                errors: errors
                            });
                            if (complete) observer.complete();
                            handlingNext = false;
                        }).catch(observerErrorHandler);
                    },
                    error: observer.error.bind(observer),
                    complete: function() {
                        if (!handlingNext) observer.complete();
                        complete = true;
                    }
                });
            });
        };
        return StateLink;
    }((0, $7oe8F.ApolloLink)))();
};

});
parcelRegister("aW6ai", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dnskZ = parcelRequire("dnskZ");

var $jFDfc = parcelRequire("jFDfc");

var $mY9dA = parcelRequire("mY9dA");
function $7f641a6fdcb80040$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $jFDfc.getMainDefinition(document);
    var fragments = $jFDfc.getFragmentDefinitions(document);
    var fragmentMap = $jFDfc.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $7f641a6fdcb80040$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $7f641a6fdcb80040$var$graphql;
function $7f641a6fdcb80040$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    return $dnskZ.__awaiter(this, void 0, void 0, function() {
        var fragmentMap, contextValue, variables, result, execute;
        var _this = this;
        return $dnskZ.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
                    result = {};
                    execute = function(selection) {
                        return $dnskZ.__awaiter(_this, void 0, void 0, function() {
                            var fieldResult, resultFieldKey, fragment, typeCondition, fragmentResult;
                            return $dnskZ.__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!$jFDfc.shouldInclude(selection, variables)) return [
                                            2
                                        ];
                                        if (!$jFDfc.isField(selection)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            $7f641a6fdcb80040$var$executeField(selection, rootValue, execContext)
                                        ];
                                    case 1:
                                        fieldResult = _a.sent();
                                        resultFieldKey = $jFDfc.resultKeyNameFromField(selection);
                                        if (fieldResult !== undefined) {
                                            if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                                            else $mY9dA.merge(result[resultFieldKey], fieldResult);
                                        }
                                        return [
                                            2
                                        ];
                                    case 2:
                                        if ($jFDfc.isInlineFragment(selection)) fragment = selection;
                                        else {
                                            fragment = fragmentMap[selection.name.value];
                                            if (!fragment) throw new Error("No fragment named " + selection.name.value);
                                        }
                                        typeCondition = fragment.typeCondition.name.value;
                                        if (!execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            $7f641a6fdcb80040$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext)
                                        ];
                                    case 3:
                                        fragmentResult = _a.sent();
                                        $mY9dA.merge(result, fragmentResult);
                                        _a.label = 4;
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    };
                    return [
                        4,
                        Promise.all(selectionSet.selections.map(execute))
                    ];
                case 1:
                    _a.sent();
                    if (execContext.resultMapper) return [
                        2,
                        execContext.resultMapper(result, rootValue)
                    ];
                    return [
                        2,
                        result
                    ];
            }
        });
    });
}
function $7f641a6fdcb80040$var$executeField(field, rootValue, execContext) {
    return $dnskZ.__awaiter(this, void 0, void 0, function() {
        var variables, contextValue, resolver, fieldName, args, info, result;
        return $dnskZ.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
                    fieldName = field.name.value;
                    args = $jFDfc.argumentsObjectFromField(field, variables);
                    info = {
                        isLeaf: !field.selectionSet,
                        resultKey: $jFDfc.resultKeyNameFromField(field),
                        directives: $jFDfc.getDirectiveInfoFromField(field, variables),
                        field: field
                    };
                    return [
                        4,
                        resolver(fieldName, rootValue, args, contextValue, info)
                    ];
                case 1:
                    result = _a.sent();
                    if (!field.selectionSet) return [
                        2,
                        result
                    ];
                    if (result == null) return [
                        2,
                        result
                    ];
                    if (Array.isArray(result)) return [
                        2,
                        $7f641a6fdcb80040$var$executeSubSelectedArray(field, result, execContext)
                    ];
                    return [
                        2,
                        $7f641a6fdcb80040$var$executeSelectionSet(field.selectionSet, result, execContext)
                    ];
            }
        });
    });
}
function $7f641a6fdcb80040$var$executeSubSelectedArray(field, result, execContext) {
    return Promise.all(result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $7f641a6fdcb80040$var$executeSubSelectedArray(field, item, execContext);
        return $7f641a6fdcb80040$var$executeSelectionSet(field.selectionSet, item, execContext);
    }));
}

});
parcelRegister("mY9dA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jFDfc = parcelRequire("jFDfc");
function $0450b643c808decc$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (variableValues === void 0) variableValues = {};
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $jFDfc.getMainDefinition(document);
    var fragments = $jFDfc.getFragmentDefinitions(document);
    var fragmentMap = $jFDfc.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $0450b643c808decc$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $0450b643c808decc$var$graphql;
function $0450b643c808decc$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
    var result = {};
    selectionSet.selections.forEach(function(selection) {
        if (variables && !$jFDfc.shouldInclude(selection, variables)) return;
        if ($jFDfc.isField(selection)) {
            var fieldResult = $0450b643c808decc$var$executeField(selection, rootValue, execContext);
            var resultFieldKey = $jFDfc.resultKeyNameFromField(selection);
            if (fieldResult !== undefined) {
                if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                else $0450b643c808decc$var$merge(result[resultFieldKey], fieldResult);
            }
        } else {
            var fragment = void 0;
            if ($jFDfc.isInlineFragment(selection)) fragment = selection;
            else {
                fragment = fragmentMap[selection.name.value];
                if (!fragment) throw new Error("No fragment named " + selection.name.value);
            }
            var typeCondition = fragment.typeCondition.name.value;
            if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                var fragmentResult = $0450b643c808decc$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                $0450b643c808decc$var$merge(result, fragmentResult);
            }
        }
    });
    if (execContext.resultMapper) return execContext.resultMapper(result, rootValue);
    return result;
}
function $0450b643c808decc$var$executeField(field, rootValue, execContext) {
    var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
    var fieldName = field.name.value;
    var args = $jFDfc.argumentsObjectFromField(field, variables);
    var info = {
        isLeaf: !field.selectionSet,
        resultKey: $jFDfc.resultKeyNameFromField(field),
        directives: $jFDfc.getDirectiveInfoFromField(field, variables),
        field: field
    };
    var result = resolver(fieldName, rootValue, args, contextValue, info);
    if (!field.selectionSet) return result;
    if (result == null) return result;
    if (Array.isArray(result)) return $0450b643c808decc$var$executeSubSelectedArray(field, result, execContext);
    return $0450b643c808decc$var$executeSelectionSet(field.selectionSet, result, execContext);
}
function $0450b643c808decc$var$executeSubSelectedArray(field, result, execContext) {
    return result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $0450b643c808decc$var$executeSubSelectedArray(field, item, execContext);
        return $0450b643c808decc$var$executeSelectionSet(field.selectionSet, item, execContext);
    });
}
var $0450b643c808decc$var$hasOwn = Object.prototype.hasOwnProperty;
function $0450b643c808decc$var$merge(dest, src) {
    if (src !== null && typeof src === 'object') Object.keys(src).forEach(function(key) {
        var srcVal = src[key];
        if (!$0450b643c808decc$var$hasOwn.call(dest, key)) dest[key] = srcVal;
        else $0450b643c808decc$var$merge(dest[key], srcVal);
    });
}
module.exports.merge = $0450b643c808decc$var$merge;

});


parcelRegister("fhjWZ", function(module, exports) {
$parcel$export(module.exports, "removeClientSetsFromDocument", () => $b1f7eb4fa92dcb3d$export$8eae69e876ee321e);
$parcel$export(module.exports, "normalizeTypeDefs", () => $b1f7eb4fa92dcb3d$export$467f9c465e4ace4e);

var $6NFTG = parcelRequire("6NFTG");

var $jFDfc = parcelRequire("jFDfc");
var $b1f7eb4fa92dcb3d$var$connectionRemoveConfig = {
    test: function(directive) {
        return directive.name.value === 'client';
    },
    remove: true
};
var $b1f7eb4fa92dcb3d$var$removed = new Map();
function $b1f7eb4fa92dcb3d$export$8eae69e876ee321e(query) {
    var cached = $b1f7eb4fa92dcb3d$var$removed.get(query);
    if (cached) return cached;
    (0, $jFDfc.checkDocument)(query);
    var docClone = (0, $jFDfc.removeDirectivesFromDocument)([
        $b1f7eb4fa92dcb3d$var$connectionRemoveConfig
    ], query);
    $b1f7eb4fa92dcb3d$var$removed.set(query, docClone);
    return docClone;
}
function $b1f7eb4fa92dcb3d$export$467f9c465e4ace4e(typeDefs) {
    var defs = Array.isArray(typeDefs) ? typeDefs : [
        typeDefs
    ];
    return defs.map(function(typeDef) {
        return typeof typeDef === 'string' ? typeDef : (0, $6NFTG.print)(typeDef);
    }).map(function(str) {
        return str.trim();
    }).join('\n');
}

});



parcelRegister("1fQNI", function(module, exports) {
$parcel$export(module.exports, "UFOLoggerLink", () => $a01de03b371744d9$export$fb326ed954631f3f);

var $7oe8F = parcelRequire("7oe8F");

var $2QO3b = parcelRequire("2QO3b");
const $a01de03b371744d9$export$fb326ed954631f3f = new (0, $7oe8F.ApolloLink)((operation, forward)=>{
    const networkStart = performance.now();
    return forward(operation).map((response)=>{
        const networkComplete = performance.now();
        const operationName = operation.operationName ?? 'unnamed';
        (0, $2QO3b.addSpanToAll)('graphql', operationName, [
            {
                name: 'network'
            }
        ], networkStart, networkComplete);
        return response;
    });
});

});



parcelRegister("kU13U", function(module, exports) {
$parcel$export(module.exports, "isExtensionVisible", () => $6d662423b598e6b2$export$41e48b53c2cc2013);
$parcel$export(module.exports, "isExtensionHidden", () => $6d662423b598e6b2$export$3f5b3e61d567ef3);
$parcel$export(module.exports, "isExtensionHiddenByAppAccessRules", () => $6d662423b598e6b2$export$5c38dfa9d1f96e61);
const $6d662423b598e6b2$export$41e48b53c2cc2013 = (extension)=>!extension.hiddenBy;
const $6d662423b598e6b2$export$3f5b3e61d567ef3 = (extension)=>!!extension.hiddenBy;
const $6d662423b598e6b2$export$5c38dfa9d1f96e61 = (extension)=>extension.hiddenBy === 'AppAccessRules';
const $6d662423b598e6b2$export$3cc53b8cca25d64 = (extension)=>extension.hiddenBy === 'DisplayConditions';

});

parcelRegister("cMh2U", function(module, exports) {
$parcel$export(module.exports, "UserMentionProvider", () => $617fc779d4e45022$export$5dd888a6445ed862);

var $b5RwB = parcelRequire("b5RwB");

var $bQFKU = parcelRequire("bQFKU");
class $617fc779d4e45022$export$5dd888a6445ed862 extends (0, $bQFKU.AbstractMentionProvider) {
    constructor(issueKey, loggedInAccountId, projectType, createAnalyticsEvent){
        super(projectType, createAnalyticsEvent), this.getQueryString = (query, contextIdentifier)=>(0, $b5RwB.stringify)({
                query: query,
                issueKey: this.issueKey,
                maxResults: 10,
                ...contextIdentifier
            }), this.getUrl = (queryString)=>`/rest/internal/2/user/mention/search?${queryString}`, this.shouldHighlightMention = (mention)=>mention.id === this.loggedInAccountId;
        this.issueKey = issueKey;
        this.loggedInAccountId = loggedInAccountId;
    }
}

});
parcelRegister("bQFKU", function(module, exports) {
$parcel$export(module.exports, "AbstractMentionProvider", () => $9c67832c1020a971$export$1503942bd70a06a4);

var $3s8bj = parcelRequire("3s8bj");

var $jPROM = parcelRequire("jPROM");

var $LFmXM = parcelRequire("LFmXM");

var $231b4 = parcelRequire("231b4");

var $aYncF = parcelRequire("aYncF");

var $hgi0g = parcelRequire("hgi0g");

var $lMRlJ = parcelRequire("lMRlJ");

var $hWeHP = parcelRequire("hWeHP");

var $4cTDP = parcelRequire("4cTDP");

var $8w0eW = parcelRequire("8w0eW");
// this is naughty, but AbstractMentionProvider using getTenantContext_DEPRECATED_DO_NOT_USE was more
// naughty and would crash the whole issue view
const $9c67832c1020a971$var$getIsAdmin = (0, $LFmXM.default)(()=>(0, $hWeHP.default)('ajs-is-admin') === 'true');
const $9c67832c1020a971$var$MENTION_DEBOUNCE_MS = 150;
class $9c67832c1020a971$export$1503942bd70a06a4 extends (0, $231b4.AbstractMentionResource) {
    constructor(projectType, createAnalyticsEvent){
        super(), this.debouncedFilter = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((query, contextIdentifier)=>{
            const currentSearchTime = Date.now();
            // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
            return this.search(query, contextIdentifier).then((mentionResult)=>{
                // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
                this.activeSearches.delete(query);
                // discard the response from previous requests
                if (currentSearchTime > this.lastSearchTime) {
                    this.lastSearchTime = currentSearchTime;
                    this._notifyListeners(mentionResult, {
                        duration: Date.now() - currentSearchTime
                    });
                }
                this._notifyAllResultsListeners(mentionResult);
            }).catch((e)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(query) && query.length > 0) this.activeSearches.delete(query);
                this._notifyErrorListeners(e);
            });
        }, $9c67832c1020a971$var$MENTION_DEBOUNCE_MS);
        this.lastSearchTime = 0;
        this.activeSearches = new Set();
        this.productName = (0, $8w0eW.subProductFromProjectType)(projectType);
        this.userRole = ((0, $4cTDP.fg)('jfp-magma-hot-121723') ? $9c67832c1020a971$var$getIsAdmin() : (0, $aYncF.getTenantContext_DEPRECATED_DO_NOT_USE)().isAdmin) ? 'admin' : 'basic';
        this.onInviteItemClick = ()=>{
            (0, $lMRlJ.triggerOpenModal)(createAnalyticsEvent ?? null, {
                inviteFlow: 'mention'
            });
        };
        this.shouldEnableInvite = true;
        this.isEligibleXProductUserInvite = false;
        this.inviteXProductUser = ()=>Promise.resolve();
    }
    isFiltering(query) {
        return this.activeSearches.has(query);
    }
    filter(query, contextIdentifier) {
        return this.debouncedFilter(query, contextIdentifier);
    }
    search(query, context) {
        const queryString = this.getQueryString(query, context);
        const url = this.getUrl(queryString);
        this.activeSearches.add(query);
        return this.fetchMentions(url).then((users)=>users.map((user)=>({
                    name: user.displayName,
                    mentionName: user.displayName,
                    nickname: user.displayName,
                    id: user.accountId,
                    avatarUrl: user.avatarUrls['48x48']
                }))).then((mentions)=>({
                query: query,
                mentions: mentions
            }));
    }
    // Allow concrete subclasses to override this method so fetch calls can be instrumented
    fetchMentions(url) {
        return (0, $hgi0g.default)(url);
    }
}

});
parcelRegister("231b4", function(module, exports) {
$parcel$export(module.exports, "AbstractMentionResource", () => $ccd5ccb172c3212e$export$8576ba1ed2760927);
$parcel$export(module.exports, "isResolvingMentionProvider", () => $ccd5ccb172c3212e$export$ae1fce5f69858ef3);

var $kp3br = parcelRequire("kp3br");

var $49R7i = parcelRequire("49R7i");

var $lAjeM = parcelRequire("lAjeM");

var $bPSqT = parcelRequire("bPSqT");

var $3s8bj = parcelRequire("3s8bj");
const $ccd5ccb172c3212e$var$MAX_QUERY_ITEMS = 100;
const $ccd5ccb172c3212e$var$MAX_NOTIFIED_ITEMS = 20;
const $ccd5ccb172c3212e$var$emptySecurityProvider = ()=>{
    return {
        params: {},
        headers: {}
    };
};
class $ccd5ccb172c3212e$export$4529f10aed0950d4 {
    constructor(){
        this.changeListeners = new Map();
        this.allResultsListeners = new Map();
        this.errListeners = new Map();
        this.infoListeners = new Map();
        this.analyticsListeners = new Map();
    }
    subscribe(key, callback, errCallback, infoCallback, allResultsCallback, analyticsListeners) {
        if (callback) this.changeListeners.set(key, callback);
        if (errCallback) this.errListeners.set(key, errCallback);
        if (infoCallback) this.infoListeners.set(key, infoCallback);
        if (allResultsCallback) this.allResultsListeners.set(key, allResultsCallback);
        if (analyticsListeners) this.analyticsListeners.set(key, analyticsListeners);
    }
    unsubscribe(key) {
        this.changeListeners.delete(key);
        this.errListeners.delete(key);
        this.infoListeners.delete(key);
        this.allResultsListeners.delete(key);
        this.analyticsListeners.delete(key);
    }
}
class $ccd5ccb172c3212e$export$8576ba1ed2760927 extends $ccd5ccb172c3212e$export$4529f10aed0950d4 {
    shouldHighlightMention(_mention) {
        return false;
    }
    // eslint-disable-next-line class-methods-use-this
    filter(query) {
        throw new Error(`not yet implemented.\nParams: query=${query}`);
    }
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    recordMentionSelection(_mention) {
    // Do nothing
    }
    isFiltering(_query) {
        return false;
    }
    _notifyListeners(mentionsResult, stats) {
        (0, $lAjeM.default)('ak-mention-resource._notifyListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $ccd5ccb172c3212e$var$MAX_NOTIFIED_ITEMS), mentionsResult.query, stats);
            } catch (e) {
                // ignore error from listener
                (0, $lAjeM.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAllResultsListeners(mentionsResult) {
        (0, $lAjeM.default)('ak-mention-resource._notifyAllResultsListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.allResultsListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $ccd5ccb172c3212e$var$MAX_NOTIFIED_ITEMS), mentionsResult.query);
            } catch (e) {
                // ignore error from listener
                (0, $lAjeM.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyErrorListeners(error, query) {
        this.errListeners.forEach((listener, key)=>{
            try {
                listener(error, query);
            } catch (e) {
                // ignore error from listener
                (0, $lAjeM.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyInfoListeners(info) {
        this.infoListeners.forEach((listener, key)=>{
            try {
                listener(info);
            } catch (e) {
                // ignore error fromr listener
                (0, $lAjeM.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAnalyticsListeners(event, actionSubject, action, attributes) {
        this.analyticsListeners.forEach((listener, key)=>{
            try {
                listener(event, actionSubject, action, attributes);
            } catch (e) {
                // ignore error from listener
                (0, $lAjeM.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
class $ccd5ccb172c3212e$export$5a4331e3e1c43553 extends $ccd5ccb172c3212e$export$8576ba1ed2760927 {
    constructor(config){
        super();
        this.verifyMentionConfig(config);
        this.config = config;
        this.lastReturnedSearch = 0;
        this.activeSearches = new Set();
        this.productName = config.productName;
        this.shouldEnableInvite = !!config.shouldEnableInvite;
        this.onInviteItemClick = config.onInviteItemClick;
        this.inviteXProductUser = config.inviteXProductUser;
        this.userRole = config.userRole || 'basic';
        if (this.config.debounceTime) this.filter = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(this.filter, this.config.debounceTime);
    }
    shouldHighlightMention(mention) {
        if (this.config.shouldHighlightMention) return this.config.shouldHighlightMention(mention);
        return false;
    }
    notify(searchTime, mentionResult, query) {
        if (searchTime > this.lastReturnedSearch) {
            this.lastReturnedSearch = searchTime;
            this._notifyListeners(mentionResult, {
                duration: Date.now() - searchTime
            });
        } else {
            const date = new Date(searchTime).toISOString().substr(17, 6);
            (0, $lAjeM.default)('Stale search result, skipping', date, query); // eslint-disable-line no-console, max-len
        }
        this._notifyAllResultsListeners(mentionResult);
    }
    notifyError(error, query) {
        this._notifyErrorListeners(error, query);
        if (query) this.activeSearches.delete(query);
    }
    async filter(query, contextIdentifier) {
        try {
            const searchTime = Date.now();
            let results;
            if (!query) results = await this.initialState(contextIdentifier);
            else {
                this.activeSearches.add(query);
                const searchResponse = this.search(query, contextIdentifier);
                results = await searchResponse.mentions;
            }
            this.notify(searchTime, results, query);
        } catch (error) {
            this.notifyError(error, query);
        }
    }
    isFiltering(query) {
        return this.activeSearches.has(query);
    }
    resolveMentionName(id) {
        if (!this.config.mentionNameResolver) return {
            id: id,
            name: '',
            status: (0, $49R7i.MentionNameStatus).UNKNOWN
        };
        return this.config.mentionNameResolver.lookupName(id);
    }
    cacheMentionName(id, mentionName) {
        if (!this.config.mentionNameResolver) return;
        this.config.mentionNameResolver.cacheName(id, mentionName);
    }
    supportsMentionNameResolving() {
        return !!this.config.mentionNameResolver;
    }
    updateActiveSearches(query) {
        this.activeSearches.add(query);
    }
    verifyMentionConfig(config) {
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.securityProvider) config.securityProvider = $ccd5ccb172c3212e$var$emptySecurityProvider;
    }
    initialState(contextIdentifier) {
        return this.remoteInitialState(contextIdentifier);
    }
    /**
	 * Clear a context object to generate query params by removing empty
	 * strings, `undefined` and empty values.
	 *
	 * @param contextIdentifier the current context identifier
	 * @returns a safe context for query encoding
	 */ clearContext(contextIdentifier = {}) {
        return Object.keys(contextIdentifier).filter((key)=>contextIdentifier[key]).reduce((context, key)=>({
                [key]: contextIdentifier[key],
                ...context
            }), {});
    }
    getQueryParams(contextIdentifier) {
        const configParams = {};
        if (this.config.containerId) configParams['containerId'] = this.config.containerId;
        if (this.config.productId) configParams['productIdentifier'] = this.config.productId;
        // if contextParams exist then it will override configParams for containerId
        return {
            ...configParams,
            ...this.clearContext(contextIdentifier)
        };
    }
    /**
	 * Returns the initial mention display list before a search is performed for the specified
	 * container.
	 *
	 * @param contextIdentifier
	 * @returns Promise
	 */ async remoteInitialState(contextIdentifier) {
        const queryParams = this.getQueryParams(contextIdentifier);
        const options = {
            path: 'bootstrap',
            queryParams: queryParams
        };
        try {
            const result = await (0, $kp3br.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $bPSqT.SLI_EVENT_TYPE), (0, $49R7i.SliNames).INITIAL_STATE, (0, $49R7i.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, '');
        } catch (error) {
            this._notifyAnalyticsListeners((0, $bPSqT.SLI_EVENT_TYPE), (0, $49R7i.SliNames).INITIAL_STATE, (0, $49R7i.Actions).FAILED);
            throw error;
        }
    }
    search(query, contextIdentifier) {
        return {
            mentions: this.remoteSearch(query, contextIdentifier)
        };
    }
    async remoteSearch(query, contextIdentifier) {
        const options = {
            path: 'search',
            queryParams: {
                query: query,
                limit: $ccd5ccb172c3212e$var$MAX_QUERY_ITEMS,
                ...this.getQueryParams(contextIdentifier)
            }
        };
        try {
            const result = await (0, $kp3br.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $bPSqT.SLI_EVENT_TYPE), (0, $49R7i.SliNames).SEARCH, (0, $49R7i.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, query);
        } catch (error) {
            this._notifyAnalyticsListeners((0, $bPSqT.SLI_EVENT_TYPE), (0, $49R7i.SliNames).SEARCH, (0, $49R7i.Actions).FAILED);
            throw error;
        }
    }
    transformServiceResponse(result, query) {
        const mentions = result.mentions.map((mention)=>{
            let lozenge;
            if ((0, $49R7i.isAppMention)(mention)) lozenge = mention.userType;
            else if ((0, $49R7i.isTeamMention)(mention)) lozenge = mention.userType;
            return {
                ...mention,
                lozenge: lozenge,
                query: query
            };
        });
        return {
            ...result,
            mentions: mentions,
            query: result.query || query
        };
    }
}
class $ccd5ccb172c3212e$export$65bd6083489bd8bb {
    constructor(statusCode, statusMessage){
        this.statusCode = statusCode;
        this.message = statusMessage;
        this.name = 'HttpError';
        this.stack = new Error().stack;
    }
}
const $ccd5ccb172c3212e$export$ae1fce5f69858ef3 = (p)=>!!(p && p.supportsMentionNameResolving && p.supportsMentionNameResolving());
var $ccd5ccb172c3212e$export$2e2bcd8739ae039 = $ccd5ccb172c3212e$export$5a4331e3e1c43553;

});
parcelRegister("kp3br", function(module, exports) {
$parcel$export(module.exports, "AbstractResource", () => (parcelRequire("7Eo2D")).AbstractResource);
$parcel$export(module.exports, "utils", () => $6d8672354a8f8023$export$eab97d15b1788b8d);
parcelRequire("cVQsv");
parcelRequire("7Eo2D");

var $cT1cs = parcelRequire("cT1cs");

var $dyzJo = parcelRequire("dyzJo");
const $6d8672354a8f8023$export$eab97d15b1788b8d = $cT1cs;
const $6d8672354a8f8023$export$3b4c04cf7dad0e50 = $dyzJo;

});
parcelRegister("cVQsv", function(module, exports) {
$parcel$export(module.exports, "buildCredentials", () => $f9c5af0d8b1f4531$export$2ac26f1ab7eda637);
const $f9c5af0d8b1f4531$export$2ac26f1ab7eda637 = (secOptions)=>{
    return secOptions && secOptions.omitCredentials ? 'omit' : 'include';
};

});

parcelRegister("7Eo2D", function(module, exports) {
$parcel$export(module.exports, "AbstractResource", () => $33168f42924c071f$export$4529f10aed0950d4);
class $33168f42924c071f$export$4529f10aed0950d4 {
    subscribe(onChange) {
        this.listeners.add(onChange);
        if (this.lastResult) // Notify subscribe of last result (i.e. initial state)
        onChange.result(this.lastResult);
    }
    unsubscribe(onChange) {
        this.listeners.delete(onChange);
    }
    notifyResult(result) {
        this.listeners.forEach((onChange)=>{
            onChange.result(result);
        });
    }
    notifyError(error) {
        this.listeners.forEach((onChange)=>{
            if (onChange.error) onChange.error(error);
        });
    }
    notifyInfo(info) {
        this.listeners.forEach((onChange)=>{
            if (onChange.info) onChange.info(info);
        });
    }
    notifyNotReady() {
        this.listeners.forEach((onChange)=>{
            if (onChange.notReady) onChange.notReady();
        });
    }
    constructor(){
        this.listeners = new Set();
    }
}

});

parcelRegister("cT1cs", function(module, exports) {
$parcel$export(module.exports, "requestService", () => $8293192fd096fa7a$export$97bfde5a702aaeca);

var $fiPhB = parcelRequire("fiPhB");

var $eGOwo = parcelRequire("eGOwo");

var $4iJGP = parcelRequire("4iJGP");

var $cVQsv = parcelRequire("cVQsv");

var $2Ndb8 = parcelRequire("2Ndb8");
const $8293192fd096fa7a$export$97bfde5a702aaeca = (serviceConfig, options)=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options || (0, $2Ndb8.defaultRequestServiceOptions);
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $2Ndb8.buildUrl)(url, path, queryParams, secOptions);
    const headers = (0, $2Ndb8.buildHeaders)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $cVQsv.buildCredentials)(secOptions);
    const ignoreResponsePayload = options?.ignoreResponsePayload || false;
    // Get tracing headers from UFO
    const TRACING_HEADER_FOR_SERVICE_UTIL = 'platform_collab_provider_tracingheaders';
    const tracingHeaderEnabled = (0, $eGOwo.fg)('platform_collab_provider_tracingheaders');
    (0, $4iJGP.addFeatureFlagAccessed)(TRACING_HEADER_FOR_SERVICE_UTIL, tracingHeaderEnabled);
    let tracingHeaders = {};
    if (tracingHeaderEnabled) tracingHeaders = (0, $fiPhB.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    return fetch(requestUrl, requestOptions).then((response)=>{
        if (response.status === 204) return Promise.resolve();
        else if (response.ok) return ignoreResponsePayload ? Promise.resolve() : response.json();
        else if (response.status === 401 && refreshedSecurityProvider) // auth issue - try once
        return refreshedSecurityProvider().then((newSecOptions)=>{
            const retryServiceConfig = {
                url: url,
                securityProvider: ()=>newSecOptions
            };
            return $8293192fd096fa7a$export$97bfde5a702aaeca(retryServiceConfig, options);
        });
        return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
    });
};

});
parcelRegister("2Ndb8", function(module, exports) {
$parcel$export(module.exports, "defaultRequestServiceOptions", () => $fdc006ca8b04950a$export$160dbda113bfad3b);
$parcel$export(module.exports, "buildUrl", () => $fdc006ca8b04950a$export$b5cd97dee32de81d);
$parcel$export(module.exports, "buildHeaders", () => $fdc006ca8b04950a$export$7d6ed858a91629c3);
const $fdc006ca8b04950a$export$160dbda113bfad3b = {};
const $fdc006ca8b04950a$export$b5cd97dee32de81d = (baseUrl, path = '', queryParams, secOptions)=>{
    const searchParam = new URLSearchParams(// For relative urls, the URL class requires base to be set. It's ignored if a url is not relative.
    // Since we only care about search params it is fine to have any base url here.
    new URL(baseUrl, 'https://BASE_FALLBACK').search || undefined);
    baseUrl = baseUrl.split('?')[0];
    if (queryParams) {
        for(const key in queryParams)if (({}).hasOwnProperty.call(queryParams, key)) searchParam.append(key, queryParams[key]);
    }
    if (secOptions && secOptions.params) {
        for(const key in secOptions.params)if (({}).hasOwnProperty.call(secOptions.params, key)) {
            const values = secOptions.params[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)searchParam.append(key, values[i]);
            else searchParam.append(key, values);
        }
    }
    let separator = '';
    if (path && baseUrl.substr(-1) !== '/' && !path.startsWith('/')) separator = '/';
    let params = searchParam.toString();
    if (params) params = '?' + params;
    return `${baseUrl}${separator}${path}${params}`;
};
const $fdc006ca8b04950a$var$addToHeaders = (headers, keyValues)=>{
    if (keyValues) {
        for(const key in keyValues)if (({}).hasOwnProperty.call(keyValues, key)) {
            const values = keyValues[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)headers[key] = values[i];
            else headers[key] = values;
        }
    }
};
const $fdc006ca8b04950a$export$7d6ed858a91629c3 = (secOptions, extraHeaders)=>{
    const headers = {};
    $fdc006ca8b04950a$var$addToHeaders(headers, extraHeaders);
    if (secOptions) $fdc006ca8b04950a$var$addToHeaders(headers, secOptions.headers);
    return headers;
};

});


parcelRegister("dyzJo", function(module, exports) {
$parcel$export(module.exports, "requestServiceMultipart", () => $94befa78e14abede$export$8b13532c81e8ac89);

var $hCu6N = parcelRequire("hCu6N");

var $cVQsv = parcelRequire("cVQsv");

var $2Ndb8 = parcelRequire("2Ndb8");

var $eGOwo = parcelRequire("eGOwo");

var $4iJGP = parcelRequire("4iJGP");

var $fiPhB = parcelRequire("fiPhB");
const $94befa78e14abede$export$8b13532c81e8ac89 = async (serviceConfig, options = (0, $2Ndb8.defaultRequestServiceOptions))=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options;
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $2Ndb8.buildUrl)(url, path, queryParams, secOptions);
    const headers = (0, $2Ndb8.buildHeaders)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $cVQsv.buildCredentials)(secOptions);
    // Get tracing headers from UFO
    const TRACING_HEADER_FOR_SERVICE_UTIL = 'platform_collab_provider_tracingheaders';
    const tracingHeaderEnabled = (0, $eGOwo.fg)('platform_collab_provider_tracingheaders');
    (0, $4iJGP.addFeatureFlagAccessed)(TRACING_HEADER_FOR_SERVICE_UTIL, tracingHeaderEnabled);
    let tracingHeaders = {};
    if (tracingHeaderEnabled) tracingHeaders = (0, $fiPhB.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    const fetchResponse = await fetch(requestUrl, requestOptions);
    const parts = await (0, $hCu6N.meros)(fetchResponse);
    if (fetchResponse.ok && fetchResponse.status !== 204) {
        if (parts[Symbol.asyncIterator] < 'u') // this lets us know that the response is multipart
        //
        // 	((parts as PartsGenerator)[Symbol.asyncIterator] as any) < 'u' came from the `meros` docs:
        //	https://github.com/maraisr/meros/blob/dec4feaa24090b94e8ac42fab1aff38a1e521680/readme.md
        // 	Look for expand section `If the content-type is NOT a multipart, then meros will resolve with the response argument.`
        return {
            isMultipart: true,
            parts: parts
        };
        return {
            isMultipart: false,
            body: await parts.json()
        };
    } else if (fetchResponse.status === 401 && refreshedSecurityProvider) // auth issue - try once
    return refreshedSecurityProvider().then((newSecOptions)=>{
        const retryServiceConfig = {
            url: url,
            securityProvider: ()=>newSecOptions
        };
        return $94befa78e14abede$export$8b13532c81e8ac89(retryServiceConfig, options);
    });
    return Promise.reject({
        code: fetchResponse.status,
        reason: fetchResponse.statusText
    });
};

});
parcelRegister("hCu6N", function(module, exports) {
$parcel$export(module.exports, "meros", () => $cd3d5734723579c0$export$74e0a034be2368c7);
var $cd3d5734723579c0$var$e = new TextDecoder;
async function $cd3d5734723579c0$export$74e0a034be2368c7(t, n) {
    if (!t.ok || !t.body || t.bodyUsed) return t;
    let i = t.headers.get("content-type");
    if (!i || !~i.indexOf("multipart/")) return t;
    let l = i.indexOf("boundary="), r = "-";
    if (~l) {
        let e = l + 9, t = i.indexOf(";", e);
        r = i.slice(e, t > -1 ? t : void 0).trim().replace(/"/g, "");
    }
    return async function*(t, n, i) {
        let l, r, d, o = t.getReader(), a = !i || !i.multiple, f = n.length, s = "", c = [];
        try {
            let t;
            e: for(; !(t = await o.read()).done;){
                let i = $cd3d5734723579c0$var$e.decode(t.value);
                l = s.length, s += i;
                let o = i.indexOf(n);
                for(~o ? l += o : l = s.indexOf(n), c = []; ~l;){
                    let e = s.slice(0, l), t = s.slice(l + f);
                    if (r) {
                        let n = e.indexOf("\r\n\r\n") + 4, i = e.lastIndexOf("\r\n", n), l = !1, r = e.slice(n, i > -1 ? void 0 : i), o = String(e.slice(0, n)).trim().split("\r\n"), f = {}, s = o.length;
                        for(; d = o[--s]; d = d.split(": "), f[d.shift().toLowerCase()] = d.join(": "));
                        if (d = f["content-type"], d && ~d.indexOf("application/json")) try {
                            r = JSON.parse(r), l = !0;
                        } catch (e) {}
                        if (d = {
                            headers: f,
                            body: r,
                            json: l
                        }, a ? yield d : c.push(d), "--" === t.slice(0, 2)) break e;
                    } else n = "\r\n" + n, r = f += 2;
                    s = t, l = s.indexOf(n);
                }
                c.length && (yield c);
            }
        } finally{
            c.length && (yield c), await o.cancel();
        }
    }(t.body, `--${r}`, n);
}

});



parcelRegister("49R7i", function(module, exports) {
$parcel$export(module.exports, "MentionType", () => $35dcc6829e4a1d1d$export$2102863a3c660c6b);
$parcel$export(module.exports, "UserAccessLevel", () => $35dcc6829e4a1d1d$export$81124e6148ca5db0);
$parcel$export(module.exports, "UserType", () => $35dcc6829e4a1d1d$export$8436e53e45ffe15b);
$parcel$export(module.exports, "SliNames", () => $35dcc6829e4a1d1d$export$7afb0727c7d7e8af);
$parcel$export(module.exports, "ComponentNames", () => $35dcc6829e4a1d1d$export$5c42d9dea6d035c1);
$parcel$export(module.exports, "Actions", () => $35dcc6829e4a1d1d$export$b52183d5cfb26dc9);
$parcel$export(module.exports, "MentionNameStatus", () => $35dcc6829e4a1d1d$export$b8fa67dc54502853);
$parcel$export(module.exports, "isRestricted", () => $35dcc6829e4a1d1d$export$dbaa15dc1820b89a);
$parcel$export(module.exports, "isSpecialMention", () => $35dcc6829e4a1d1d$export$37b8dcac6198c514);
$parcel$export(module.exports, "isAppMention", () => $35dcc6829e4a1d1d$export$eb590c844d13454c);
$parcel$export(module.exports, "isTeamMention", () => $35dcc6829e4a1d1d$export$803b1379348dbfd5);
$parcel$export(module.exports, "isSpecialMentionText", () => $35dcc6829e4a1d1d$export$d13d4f976b36a397);
$parcel$export(module.exports, "isPromise", () => $35dcc6829e4a1d1d$export$4369c812aac99591);
var $35dcc6829e4a1d1d$export$2102863a3c660c6b = /*#__PURE__*/ function(MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
    return MentionType;
}({});
var $35dcc6829e4a1d1d$export$81124e6148ca5db0 = /*#__PURE__*/ function(UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
    return UserAccessLevel;
}({});
var $35dcc6829e4a1d1d$export$8436e53e45ffe15b = /*#__PURE__*/ function(UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
    return UserType;
}({});
var $35dcc6829e4a1d1d$export$7afb0727c7d7e8af = /*#__PURE__*/ function(SliNames) {
    SliNames["SEARCH"] = "searchUser";
    SliNames["SEARCH_TEAM"] = "searchTeam";
    SliNames["INITIAL_STATE"] = "initialState";
    SliNames["SELECT"] = "select";
    SliNames["SELECT_TEAM"] = "selectTeam";
    return SliNames;
}({});
var $35dcc6829e4a1d1d$export$5c42d9dea6d035c1 = /*#__PURE__*/ function(ComponentNames) {
    ComponentNames["TYPEAHEAD"] = "mentionTypeahead";
    ComponentNames["MENTION"] = "mention";
    return ComponentNames;
}({});
var $35dcc6829e4a1d1d$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["VIEWED"] = "viewed";
    Actions["CLICKED"] = "clicked";
    Actions["CLOSED"] = "closed";
    Actions["SUCCEEDED"] = "succeeded";
    Actions["FAILED"] = "failed";
    return Actions;
}({});
var $35dcc6829e4a1d1d$export$b8fa67dc54502853 = /*#__PURE__*/ function(MentionNameStatus) {
    MentionNameStatus[MentionNameStatus["UNKNOWN"] = 0] = "UNKNOWN";
    MentionNameStatus[MentionNameStatus["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
    MentionNameStatus[MentionNameStatus["OK"] = 2] = "OK";
    return MentionNameStatus;
}({});
function $35dcc6829e4a1d1d$export$dbaa15dc1820b89a(accessLevel) {
    return !!accessLevel && accessLevel === $35dcc6829e4a1d1d$export$81124e6148ca5db0[0];
}
function $35dcc6829e4a1d1d$export$37b8dcac6198c514(mention) {
    return !!mention.userType && mention.userType === $35dcc6829e4a1d1d$export$8436e53e45ffe15b[1];
}
function $35dcc6829e4a1d1d$export$eb590c844d13454c(mention) {
    return mention.userType && mention.userType === $35dcc6829e4a1d1d$export$8436e53e45ffe15b[2];
}
function $35dcc6829e4a1d1d$export$803b1379348dbfd5(mention) {
    return mention.userType && mention.userType === $35dcc6829e4a1d1d$export$8436e53e45ffe15b[3];
}
function $35dcc6829e4a1d1d$export$d13d4f976b36a397(mentionText) {
    return mentionText && (mentionText === '@all' || mentionText === '@here');
}
const $35dcc6829e4a1d1d$export$4369c812aac99591 = (p)=>!!(p && p.then);

});

parcelRegister("lAjeM", function(module, exports) {
$parcel$export(module.exports, "default", () => $11dfa2f74f082c3a$export$2e2bcd8739ae039);
let $11dfa2f74f082c3a$var$debugEnabled = false;
let $11dfa2f74f082c3a$var$stacktracesEnabled = false;
function $11dfa2f74f082c3a$export$748ada60eaf985cc(enable) {
    $11dfa2f74f082c3a$var$debugEnabled = enable;
}
function $11dfa2f74f082c3a$export$4f7017086af31c25(enable) {
    $11dfa2f74f082c3a$var$stacktracesEnabled = enable;
}
function $11dfa2f74f082c3a$export$2a858f450a2f66d() {
    if ($11dfa2f74f082c3a$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $11dfa2f74f082c3a$export$2e2bcd8739ae039(msg, ...args) {
    if ($11dfa2f74f082c3a$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("bPSqT", function(module, exports) {
$parcel$export(module.exports, "SLI_EVENT_TYPE", () => $504a08bf167f720e$export$245097525aef1262);
$parcel$export(module.exports, "SMART_EVENT_TYPE", () => $504a08bf167f720e$export$c724588856bbfbcf);
$parcel$export(module.exports, "fireAnalyticsMentionEvent", () => $504a08bf167f720e$export$44902bc7b3f0b09f);
$parcel$export(module.exports, "fireAnalyticsMentionHydrationEvent", () => $504a08bf167f720e$export$91b2fa6a0fe06408);



var $49R7i = parcelRequire("49R7i");
const $504a08bf167f720e$var$packageName = "platform-pkg";
const $504a08bf167f720e$var$packageVersion = "0.0.0-use.local";
const $504a08bf167f720e$export$245097525aef1262 = 'sli';
const $504a08bf167f720e$export$c724588856bbfbcf = 'smart';
const $504a08bf167f720e$export$a823474ae5cb9e9c = (props)=>(action, duration, userIds = [], query)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $49R7i.ComponentNames).TYPEAHEAD,
                attributes: {
                    packageName: $504a08bf167f720e$var$packageName,
                    packageVersion: $504a08bf167f720e$var$packageVersion,
                    componentName: (0, $49R7i.ComponentNames).MENTION,
                    duration: Math.round(duration),
                    userIds: userIds,
                    queryLength: query ? query.length : 0
                },
                eventType: (0, $d6f34b7bd34f6138$export$12346a674644c156)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $ab7a4be2f9c8c36f$export$d821aa4c8afb384e));
        }
    };
const $504a08bf167f720e$export$44902bc7b3f0b09f = (createEvent)=>(actionSubject, action, text, id, accessLevel)=>{
        const payload = {
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $d6f34b7bd34f6138$export$a1562d08625f5d7e),
            attributes: {
                packageName: $504a08bf167f720e$var$packageName,
                packageVersion: $504a08bf167f720e$var$packageVersion,
                componentName: (0, $49R7i.ComponentNames).MENTION,
                accessLevel: accessLevel,
                isSpecial: (0, $49R7i.isSpecialMentionText)(text),
                userId: id
            }
        };
        const event = createEvent(payload);
        event.fire((0, $ab7a4be2f9c8c36f$export$d821aa4c8afb384e));
        return event;
    };
const $504a08bf167f720e$export$c8b245b690e10169 = (props)=>(actionSubject, action)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = $504a08bf167f720e$export$c357a2872628de7c(actionSubject, action);
            props.createAnalyticsEvent(eventPayload).fire((0, $ab7a4be2f9c8c36f$export$d821aa4c8afb384e));
        }
    };
const $504a08bf167f720e$export$c357a2872628de7c = (actionSubject, action, attributes)=>{
    const eventPayload = {
        action: action,
        actionSubject: actionSubject,
        eventType: (0, $d6f34b7bd34f6138$export$12346a674644c156),
        attributes: {
            packageName: $504a08bf167f720e$var$packageName,
            packageVersion: $504a08bf167f720e$var$packageVersion,
            componentName: (0, $49R7i.ComponentNames).MENTION,
            ...attributes
        }
    };
    return eventPayload;
};
const $504a08bf167f720e$export$91b2fa6a0fe06408 = (props)=>(action, userId, fromCache, duration)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $49R7i.ComponentNames).MENTION,
                actionSubjectId: 'hydration',
                attributes: {
                    packageName: $504a08bf167f720e$var$packageName,
                    packageVersion: $504a08bf167f720e$var$packageVersion,
                    componentName: (0, $49R7i.ComponentNames).MENTION,
                    userId: userId,
                    fromCache: fromCache,
                    duration: Math.round(duration)
                },
                eventType: (0, $d6f34b7bd34f6138$export$12346a674644c156)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $ab7a4be2f9c8c36f$export$d821aa4c8afb384e));
        }
    };
// OLD Analytics
const $504a08bf167f720e$var$MENTION_ANALYTICS_PREFIX = 'atlassian.fabric.mention';
const $504a08bf167f720e$export$34ac71ce24cddec2 = (firePrivateAnalyticsEvent)=>(eventName, text, accessLevel)=>{
        if (firePrivateAnalyticsEvent) firePrivateAnalyticsEvent(`${$504a08bf167f720e$var$MENTION_ANALYTICS_PREFIX}.${eventName}`, {
            accessLevel: accessLevel,
            isSpecial: (0, $49R7i.isSpecialMentionText)(text)
        });
    };

});
const $ab7a4be2f9c8c36f$export$d821aa4c8afb384e = 'fabric-elements';



parcelRegister("lMRlJ", function(module, exports) {
$parcel$export(module.exports, "useInvitePeopleModal", () => $4e329b8cb1486bd7$export$b9ec44715ae5ad99);
$parcel$export(module.exports, "triggerOpenModal", () => $4e329b8cb1486bd7$export$3da9a54757b29739);

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");
var $14kUX = parcelRequire("14kUX");

var $ec6Db = parcelRequire("ec6Db");
const $4e329b8cb1486bd7$var$CONTROLLER_NAME = 'invite-people-modal';
const $4e329b8cb1486bd7$var$initialState = {
    isOpen: false,
    inviteFlow: 'unknown',
    continueUrl: undefined,
    source: undefined,
    subProduct: undefined
};
const $4e329b8cb1486bd7$var$Store = (0, $GtRbT.createStore)({
    name: $4e329b8cb1486bd7$var$CONTROLLER_NAME,
    initialState: $4e329b8cb1486bd7$var$initialState,
    actions: {
        openModal: (createAnalyticsEvent, { inviteFlow: inviteFlow, analyticsSource: analyticsSource, continueUrl: continueUrl, source: source, subProduct: subProduct, analyticsAttributes: analyticsAttributes })=>({ setState: setState })=>{
                (0, $ec6Db.fireAddTeammatetoJiraAnalytics)({
                    createAnalyticsEvent: createAnalyticsEvent,
                    inviteFlow: inviteFlow,
                    analyticsSource: analyticsSource,
                    source: source,
                    analyticsAttributes: analyticsAttributes
                });
                setState({
                    isOpen: true,
                    inviteFlow: inviteFlow,
                    continueUrl: continueUrl,
                    source: source,
                    subProduct: subProduct
                });
            },
        closeModal: ()=>({ setState: setState })=>setState($4e329b8cb1486bd7$var$initialState)
    }
});
const $4e329b8cb1486bd7$export$b9ec44715ae5ad99 = (0, $iJq0l.createHook)($4e329b8cb1486bd7$var$Store);
const $4e329b8cb1486bd7$export$42437f35b39968af = (0, $6E16M.createContainer)($4e329b8cb1486bd7$var$Store, {
    onInit: ()=>({ setState: setState }, { isOpen: isOpen })=>{
            setState({
                isOpen: isOpen
            });
        }
});
const $4e329b8cb1486bd7$export$c109a2947e32aee9 = (0, $ht3nQ.createSubscriber)($4e329b8cb1486bd7$var$Store, {
    displayName: 'InvitePeopleModalSubscriber',
    selector: (state)=>state.isOpen
});
const $4e329b8cb1486bd7$export$3da9a54757b29739 = (createAnalyticsEvent, contextConfig)=>{
    (0, $14kUX.defaultRegistry).getStore($4e329b8cb1486bd7$var$Store)?.actions.openModal(createAnalyticsEvent, contextConfig);
};

});
parcelRegister("ec6Db", function(module, exports) {
$parcel$export(module.exports, "AnalyticsProvider", () => $f0e7c62e1985a15a$export$1b581a2ec13e37f1);
$parcel$export(module.exports, "fireAddTeammatetoJiraAnalytics", () => $f0e7c62e1985a15a$export$21b810258e82d438);

var $eJOHy = parcelRequire("eJOHy");

var $8QoO2 = parcelRequire("8QoO2");

var $kRgKj = parcelRequire("kRgKj");
var $2xVsC = parcelRequire("2xVsC");

var $2Mqjh = parcelRequire("2Mqjh");

var $bDk9X = parcelRequire("bDk9X");
const $f0e7c62e1985a15a$var$useAnalyticsClient = ()=>{
    const analyticsWebClientRef = (0, $eJOHy.useRef)((0, $2Mqjh.getAnalyticsWebClientPromise)());
    return {
        sendEvent: (analyticsEvent)=>{
            analyticsWebClientRef.current.then((webClient)=>webClient.sendEvent((0, $2xVsC.getEvent)(analyticsEvent)));
        }
    };
};
const $f0e7c62e1985a15a$export$1b581a2ec13e37f1 = ({ children: children })=>{
    const { sendEvent: sendEvent } = $f0e7c62e1985a15a$var$useAnalyticsClient();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8QoO2.default), {
        channel: "peopleAndTeams",
        onEvent: sendEvent
    }, children);
};
const $f0e7c62e1985a15a$var$sendAnalyticsClientUIEvent = async (createAnalyticsEvent, analyticsPayload)=>{
    if (createAnalyticsEvent) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), // @ts-expect-error Argument of type '[string, string, Attributes | undefined]' is not assignable to parameter of type 'RestArguments'.
    `${analyticsPayload.actionSubject} ${analyticsPayload.action}`, analyticsPayload?.actionSubjectId, analyticsPayload.attributes);
    else {
        const webAnalyticsClient = await (0, $2Mqjh.getAnalyticsWebClientPromise)();
        const analyticsClient = webAnalyticsClient.getInstance();
        // SSR doesn't have an analytics client
        if (analyticsClient) analyticsClient.sendUIEvent(analyticsPayload);
    }
};
const $f0e7c62e1985a15a$export$21b810258e82d438 = async ({ createAnalyticsEvent: createAnalyticsEvent, inviteFlow: inviteFlow, analyticsSource: analyticsSource, source: source, analyticsAttributes: analyticsAttributes })=>{
    const analyticsPayload = {
        action: 'clicked',
        actionSubject: 'addTeammatetoJira',
        product: 'jira',
        attributes: {
            source: inviteFlow ? (0, $bDk9X.getSourceByInviteFlow)(inviteFlow) : source,
            ...analyticsAttributes
        },
        source: analyticsSource != null && analyticsSource !== '' ? analyticsSource : 'unknown'
    };
    $f0e7c62e1985a15a$var$sendAnalyticsClientUIEvent(createAnalyticsEvent, analyticsPayload);
};

});
parcelRegister("bDk9X", function(module, exports) {
$parcel$export(module.exports, "getSourceByInviteFlow", () => $7650e673c142be40$export$c35cd18e9d0123e3);
const $7650e673c142be40$export$c35cd18e9d0123e3 = (inviteFlow)=>{
    let source = inviteFlow;
    if (inviteFlow === 'mention') source = 'mentionInEditor';
    else if (inviteFlow === 'assignee') source = 'assigneeField';
    return source;
};

});



parcelRegister("8w0eW", function(module, exports) {
$parcel$export(module.exports, "subProductFromProjectType", () => $1cc9a356cc2374f5$export$246e1e2a5c86a633);

var $FhXEJ = parcelRequire("FhXEJ");
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $1cc9a356cc2374f5$var$SERVICEDESK_APPLICATION_ROLE = 'jira-servicedesk';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $1cc9a356cc2374f5$var$SOFTWARE_APPLICATION_ROLE = 'jira-software';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $1cc9a356cc2374f5$var$CORE_APPLICATION_ROLE = 'jira-core';
const $1cc9a356cc2374f5$export$246e1e2a5c86a633 = (projectType)=>{
    switch(projectType){
        case 0, $FhXEJ.SERVICE_DESK_PROJECT:
            return 'Jira Service Management';
        default:
            return 'Jira';
    }
};

});



parcelRegister("1M2hR", function(module, exports) {
$parcel$export(module.exports, "useLocale", () => $22bfd94a936ddbb0$export$43bb16f9c6d9e3f7);
$parcel$export(module.exports, "useNativeLocale", () => $22bfd94a936ddbb0$export$31652d9c30d7d3f3);

var $eJOHy = parcelRequire("eJOHy");

var $jbr6p = parcelRequire("jbr6p");

var $koAZ4 = parcelRequire("koAZ4");
const $22bfd94a936ddbb0$export$43bb16f9c6d9e3f7 = ()=>{
    const tenantContext = (0, $koAZ4.useTenantContext)();
    return tenantContext && tenantContext.locale || (0, $jbr6p.defaultLocale);
};
const $22bfd94a936ddbb0$export$31652d9c30d7d3f3 = ()=>{
    const locale = $22bfd94a936ddbb0$export$43bb16f9c6d9e3f7();
    const standardizedLocale = (0, $eJOHy.useMemo)(()=>(0, $jbr6p.standardizeLocale)(locale), [
        locale
    ]);
    return standardizedLocale;
};

});

parcelRegister("3tDJ4", function(module, exports) {
$parcel$export(module.exports, "ChromelessEditor", () => $450987cb52d37d39$export$5252bd745392dcde);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $fZhgz = parcelRequire("fZhgz");

var $lovmf = parcelRequire("lovmf");

var $bXaOH = parcelRequire("bXaOH");
const $450987cb52d37d39$export$5252bd745392dcde = (props)=>{
    const { onChange: onChange, defaultValue: defaultValue, features: features, isDisabled: isDisabled } = props.forgeDoc.props;
    const transformer = (0, $eJOHy.useMemo)(()=>new (0, $lovmf.JSONTransformer)(), []);
    const { preset: preset } = (0, $bXaOH.usePresetByFeatures)('chromeless', features);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fZhgz.ChromelessEditor), {
        disabled: isDisabled,
        defaultValue: defaultValue,
        preset: preset,
        onChange: (editorView)=>{
            const jsonDocNode = transformer.encode(editorView.state.doc);
            onChange?.(jsonDocNode);
        }
    });
};

});
parcelRegister("fZhgz", function(module, exports) {
$parcel$export(module.exports, "ChromelessEditor", () => $c457109428942902$export$5252bd745392dcde);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lGWJD = parcelRequire("lGWJD");

var $5bg1T = parcelRequire("5bg1T");
function $c457109428942902$export$5252bd745392dcde(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lGWJD.CoreEditor), {
        ...props,
        appearance: "chromeless",
        AppearanceComponent: (0, $5bg1T.default)
    });
}

});
parcelRegister("lGWJD", function(module, exports) {
$parcel$export(module.exports, "CoreEditor", () => $d93d62d948ab1b4f$export$be7eaacc86ce4514);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $cSmYj = parcelRequire("cSmYj");

var $8KLBw = parcelRequire("8KLBw");

var $eUaD0 = parcelRequire("eUaD0");

var $ftN6c = parcelRequire("ftN6c");

var $bMFKb = parcelRequire("bMFKb");
var $cd124 = parcelRequire("cd124");

var $hvjqZ = parcelRequire("hvjqZ");

var $dyNYh = parcelRequire("dyNYh");

var $2pwTW = parcelRequire("2pwTW");

var $kCWwL = parcelRequire("kCWwL");

var $hUQD4 = parcelRequire("hUQD4");

var $1ZFgR = parcelRequire("1ZFgR");

var $k9jP1 = parcelRequire("k9jP1");

var $7rP03 = parcelRequire("7rP03");

var $hk8Wh = parcelRequire("hk8Wh");

var $1PCVi = parcelRequire("1PCVi");

var $1NJcR = parcelRequire("1NJcR");

var $fy7ur = parcelRequire("fy7ur");

var $fwDw9 = parcelRequire("fwDw9");
/**
 * Editor wrapper that deals with the lifecycle logic of the editor
 * @param passedProps
 * @example
 */ function $d93d62d948ab1b4f$var$Editor(passedProps) {
    const propsRef = (0, $eJOHy.useRef)(passedProps);
    const props = (0, $1NJcR.default)(passedProps);
    (0, $eJOHy.useMemo)(()=>{
        propsRef.current = props;
    }, [
        props
    ]);
    const editorContext = (0, $kCWwL.useEditorContext)();
    const editorActionsPlaceholderInstance = (0, $eJOHy.useMemo)(()=>new (0, $2pwTW.default)(), []);
    const editorActions = editorContext.editorActions || editorActionsPlaceholderInstance;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleAnalyticsEvent = (0, $eJOHy.useCallback)((data)=>{
        (0, $cd124.fireAnalyticsEvent)(createAnalyticsEvent)(data);
    }, [
        createAnalyticsEvent
    ]);
    const getFeatureFlagsFromRef = (0, $eJOHy.useCallback)(()=>{
        return {
            ...(0, $hUQD4.createFeatureFlagsFromProps)(propsRef.current.featureFlags),
            useNativeCollabPlugin: Boolean(typeof propsRef.current.collabEdit?.useNativePlugin === 'boolean' ? !!propsRef.current.collabEdit?.useNativePlugin : false)
        };
    }, []);
    const onEditorCreated = (0, $eJOHy.useCallback)((instance)=>{
        const { contextIdentifierProvider: contextIdentifierProvider, onEditorReady: onEditorReady, featureFlags: featureFlags } = propsRef.current;
        editorActions._privateRegisterEditor(instance.view, instance.eventDispatcher, instance.transformer, getFeatureFlagsFromRef);
        if (onEditorReady) {
            (0, $hvjqZ.startMeasure)((0, $1ZFgR.default).ON_EDITOR_READY_CALLBACK);
            onEditorReady(editorActions);
            (0, $hvjqZ.stopMeasure)((0, $1ZFgR.default).ON_EDITOR_READY_CALLBACK, (0, $fwDw9.default)((0, $bMFKb.ACTION).ON_EDITOR_READY_CALLBACK, {
                contextIdentifierProvider: contextIdentifierProvider,
                featureFlags: featureFlags
            }, createAnalyticsEvent));
        }
    }, [
        editorActions,
        createAnalyticsEvent,
        getFeatureFlagsFromRef,
        propsRef
    ]);
    const onEditorDestroyed = (0, $eJOHy.useCallback)((_instance)=>{
        const { onDestroy: onDestroy } = propsRef.current;
        editorActions._privateUnregisterEditor();
        if (onDestroy) onDestroy();
    }, [
        editorActions,
        propsRef
    ]);
    (0, $1PCVi.default)(props, createAnalyticsEvent);
    const providerFactory = (0, $fy7ur.default)(props, editorActions, createAnalyticsEvent);
    const { onSave: onSaveFromProps } = props;
    const handleSave = (0, $eJOHy.useCallback)((view)=>{
        if (onSaveFromProps) onSaveFromProps(view);
    }, [
        onSaveFromProps
    ]);
    const isFullPageApperance = Boolean(props.appearance && [
        'full-page',
        'full-width'
    ].includes(props.appearance));
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, isFullPageApperance ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $7rP03.EditorINPMetrics), null) : null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $hk8Wh.EditorInternal), {
        props: props,
        handleAnalyticsEvent: handleAnalyticsEvent,
        createAnalyticsEvent: createAnalyticsEvent,
        preset: props.preset,
        handleSave: handleSave,
        editorActions: editorActions,
        onEditorCreated: onEditorCreated,
        onEditorDestroyed: onEditorDestroyed,
        providerFactory: providerFactory,
        AppearanceComponent: props.AppearanceComponent
    }));
}
const $d93d62d948ab1b4f$var$useMemoEditorFeatureFlags = (featureFlags)=>{
    const ffRef = (0, $eJOHy.useRef)(featureFlags);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(ffRef.current, featureFlags)) ffRef.current = featureFlags;
    return ffRef.current;
};
function $d93d62d948ab1b4f$export$be7eaacc86ce4514(props) {
    const editorSessionId = (0, $eJOHy.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))());
    const data = (0, $eJOHy.useMemo)(()=>{
        return {
            packageName: (0, $k9jP1.name),
            packageVersion: (0, $k9jP1.version),
            componentName: 'editorCore',
            appearance: (0, $dyNYh.getAnalyticsAppearance)(props.appearance),
            editorSessionId: editorSessionId.current
        };
    }, [
        props.appearance
    ]);
    const memodEditorFeatureFlags = $d93d62d948ab1b4f$var$useMemoEditorFeatureFlags(props.featureFlags);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eUaD0.FabricEditorAnalyticsContext), {
        // @ts-expect-error Type 'string' is not assignable to type '"editorCore" | "renderer"'.
        data: data
    }, /*#__PURE__*/ (0, $1NIU8.jsx)($d93d62d948ab1b4f$var$Editor, {
        ...props,
        featureFlags: memodEditorFeatureFlags
    }));
}
$d93d62d948ab1b4f$export$be7eaacc86ce4514.propTypes = {
    minHeight: ({ appearance: appearance, minHeight: minHeight })=>{
        if (minHeight && appearance && ![
            'comment',
            'chromeless'
        ].includes(appearance)) return new Error('minHeight only supports editor appearance chromeless and comment for Editor');
        return null;
    }
};
var $d93d62d948ab1b4f$export$2e2bcd8739ae039 = $d93d62d948ab1b4f$export$be7eaacc86ce4514;

});
parcelRegister("cd124", function(module, exports) {
$parcel$export(module.exports, "editorAnalyticsChannel", () => $00836d68af125af6$export$1467dbbb3bb418c6);
$parcel$export(module.exports, "fireAnalyticsEvent", () => $00836d68af125af6$export$c7d191551feb734);

var $bgewf = parcelRequire("bgewf");

var $b1YJC = parcelRequire("b1YJC");
const $00836d68af125af6$export$1467dbbb3bb418c6 = (0, $bgewf.FabricChannel).editor;
const $00836d68af125af6$export$c7d191551feb734 = (createAnalyticsEvent, options)=>({ payload: payload, channel: channel = $00836d68af125af6$export$1467dbbb3bb418c6 })=>{
        if (!createAnalyticsEvent) return;
        if (options?.immediate) {
            createAnalyticsEvent(payload)?.fire(channel);
            return;
        }
        const queue = (0, $b1YJC.AnalyticsQueue).get();
        queue.schedule(()=>createAnalyticsEvent(payload)?.fire(channel));
    };

});
parcelRegister("b1YJC", function(module, exports) {
$parcel$export(module.exports, "AnalyticsQueue", () => $d318da68cac51402$export$b44c4ba8fe19bbc7);

var $LFmXM = parcelRequire("LFmXM");
class $d318da68cac51402$export$b44c4ba8fe19bbc7 {
    static{
        this.get = (0, $LFmXM.default)(()=>new $d318da68cac51402$export$b44c4ba8fe19bbc7());
    }
    constructor(){
        this.tasks = [];
        this.running = false;
    }
    request(fn) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (window.requestIdleCallback) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.requestIdleCallback(fn);
        else {
            const start = performance.now();
            setTimeout(()=>{
                fn({
                    didTimeout: false,
                    timeRemaining: ()=>Math.max(0, 50 - (performance.now() - start))
                });
            }, 0);
        }
    }
    pending() {
        // Defensive coding as navigator.scheduling.isInputPending is an experimental API
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (typeof window.navigator?.scheduling?.isInputPending === 'function') // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return window.navigator?.scheduling?.isInputPending() === true;
        return false;
    }
    process() {
        if (this.running) return;
        this.running = true;
        this.request((deadline)=>{
            while(deadline.timeRemaining() > 0 && this.tasks.length > 0 && !this.pending()){
                const task = this.tasks.shift();
                if (task) task();
            }
            this.running = false;
            if (this.tasks.length > 0) this.process();
        });
    }
    schedule(task) {
        this.tasks.push(task);
        this.process();
    }
}

});


parcelRegister("2pwTW", function(module, exports) {
$parcel$export(module.exports, "default", () => $d0c717bcbbc27c7c$export$2e2bcd8739ae039);

var $bMFKb = parcelRequire("bMFKb");

var $aoyv9 = parcelRequire("aoyv9");

var $51k6y = parcelRequire("51k6y");

var $dyNYh = parcelRequire("dyNYh");

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");

var $1zRDH = parcelRequire("1zRDH");

var $dLCMh = parcelRequire("dLCMh");

var $98LxN = parcelRequire("98LxN");

var $lgr6j = parcelRequire("lgr6j");

var $kWYFo = parcelRequire("kWYFo");

var $dtmLc = parcelRequire("dtmLc");
// Please, do not copy or use this kind of code below
// @ts-ignore
const $d0c717bcbbc27c7c$var$fakePluginKey = {
    key: 'nativeCollabProviderPlugin$',
    getState: (state)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return state['nativeCollabProviderPlugin$'];
    }
};
class $d0c717bcbbc27c7c$export$2e2bcd8739ae039 {
    static from(view, eventDispatcher, transformer) {
        const editorActions = new $d0c717bcbbc27c7c$export$2e2bcd8739ae039();
        editorActions._privateRegisterEditor(view, eventDispatcher, transformer);
        return editorActions;
    }
    //#region private
    // This method needs to be public for context based helper components.
    _privateGetEditorView() {
        return this.editorView;
    }
    _privateGetEventDispatcher() {
        return this.eventDispatcher;
    }
    getFeatureFlags() {
        return {};
    }
    // This method needs to be public for EditorContext component.
    _privateRegisterEditor(editorView, eventDispatcher, contentTransformer, getFeatureFlags = ()=>({})) {
        this.contentTransformer = contentTransformer;
        this.eventDispatcher = eventDispatcher;
        this.getFeatureFlags = getFeatureFlags;
        if (!this.editorView && editorView) {
            this.editorView = editorView;
            this.listeners.forEach((cb)=>cb(editorView, eventDispatcher));
        } else if (this.editorView !== editorView) throw new Error("Editor has already been registered! It's not allowed to re-register editor with the new Editor instance.");
        if (this.contentTransformer) this.contentEncode = this.contentTransformer.encode.bind(this.contentTransformer);
    }
    // This method needs to be public for EditorContext component.
    _privateUnregisterEditor() {
        this.editorView = undefined;
        this.contentTransformer = undefined;
        this.contentEncode = undefined;
        this.eventDispatcher = undefined;
        this.getFeatureFlags = ()=>({});
    }
    _privateSubscribe(cb) {
        // If editor is registered and somebody is trying to add a listener,
        // just call it first.
        if (this.editorView && this.eventDispatcher) cb(this.editorView, this.eventDispatcher);
        this.listeners.push(cb);
    }
    _privateUnsubscribe(cb) {
        this.listeners = this.listeners.filter((c)=>c !== cb);
    }
    //#endregion
    focus({ scrollIntoView: scrollIntoView } = {
        scrollIntoView: true
    }) {
        if (!this.editorView || this.editorView.hasFocus()) return false;
        this.editorView.focus();
        if (scrollIntoView ?? true) this.editorView.dispatch(this.editorView.state.tr.scrollIntoView());
        return true;
    }
    blur() {
        if (!this.editorView || !this.editorView.hasFocus()) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.editorView.dom.blur();
        return true;
    }
    clear() {
        if (!this.editorView) return false;
        const editorView = this.editorView;
        const { state: state } = editorView;
        const tr = editorView.state.tr.setSelection((0, $3lIcL.TextSelection).create(state.doc, 0, state.doc.nodeSize - 2)).deleteSelection();
        editorView.dispatch(tr);
        return true;
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
	 * @deprecated This is deprecated and is no longer maintained.
	 *
	 * Use the `requestDocument` API from `editorAPI` (ie. `editorApi?.core?.actions.requestDocument( ... ))
	 * it has inbuilt throttling and is designed for use with `ComposableEditor`.
	 *
	 * Docs on its usage are available from: https://atlaskit.atlassian.com/packages/editor/editor-core
	 *
	 * WARNING: this may be called repeatedly, async with care
	 */ async getValue() {
        const { editorView: editorView } = this;
        if (!editorView) return;
        const doc = await (0, $1zRDH.getEditorValueWithMedia)(editorView);
        const json = (0, $dtmLc.toJSON)(doc);
        if (!this.contentEncode) return json;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const nodeSanitized = (0, $3xw6l.Node).fromJSON(this.editorView.state.schema, json);
        try {
            return this.contentEncode(nodeSanitized);
        } catch (e) {
            this.dispatchAnalyticsEvent({
                action: (0, $bMFKb.ACTION).DOCUMENT_PROCESSING_ERROR,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
                eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorMessage: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to encode one or more nested tables' : undefined}`
                }
            });
            throw e;
        }
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
	 * @deprecated - please use `getNodeWithPosByLocalId` found in the core plugin actions instead
	 * @example
	  	const { editorApi, preset } = usePreset(...);
		const extensionAPI = editorAPI?.extension?.actions?.api();
		// Use nodeWithPos as desired
		const nodeWithPos = extensionAPI.getNodeWithPosByLocalId(localId);
		const node = nodeWithPos.node;
		const nodePos = nodeWithPos.pos;
	 */ getNodeByLocalId(id) {
        if (this.editorView?.state) {
            const nodes = (0, $kWYFo.findNodePosByLocalIds)(this.editorView?.state, [
                id
            ]);
            const node = nodes.length >= 1 ? nodes[0] : undefined;
            return node?.node;
        }
    }
    getNodeByFragmentLocalId(id) {
        if (this.editorView?.state) {
            const nodes = (0, $98LxN.findNodePosByFragmentLocalIds)(this.editorView?.state, [
                id
            ]);
            return nodes.length > 0 ? nodes[0].node : undefined;
        }
    }
    /**
	 * This method will return the currently selected `Node` if the selection is a `Node`.
	 * Otherwise, if the selection is textual or a non-selectable `Node` within another selectable `Node`, the closest selectable parent `Node` will be returned.
	 */ getSelectedNode() {
        if (this.editorView?.state?.selection) {
            const { selection: selection } = this.editorView.state;
            if (selection instanceof (0, $3lIcL.NodeSelection)) return selection.node;
            return (0, $BmspC.findParentNode)((node)=>Boolean(node.type.spec.selectable))(selection)?.node;
        }
    }
    isDocumentEmpty() {
        // Unlikely case when editorView has been destroyed before calling isDocumentEmpty,
        // we treat this case as if document was empty.
        if (!this.editorView) return true;
        return (0, $lgr6j.isEmptyDocument)(this.editorView.state.doc);
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
	 * @deprecated - please use `replaceDocument` found in the core plugin actions instead
	 * using this will reset your Editor State which could cause some things to break (like emojis)
	 * @example - use the `replaceDocument` from the core plugin actions instead
	 * ```ts
	 * const { editorApi, preset } = usePreset(...);
		// where you need it
		editorApi?.core.actions.replaceDocument(value);
		return <ComposableEditor preset={preset} ... />
	 */ replaceDocument(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    rawValue, shouldScrollToBottom = true, // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /** @deprecated [ED-14158] shouldAddToHistory is not being used in this function */ shouldAddToHistory = true) {
        (0, $dLCMh.default)('EditorActions.replaceDocument', {
            shouldAddToHistory: shouldAddToHistory
        }, [
            {
                property: 'shouldAddToHistory',
                description: '[ED-14158] EditorActions.replaceDocument does not use the shouldAddToHistory arg',
                type: 'removed'
            }
        ]);
        if (!this.editorView || rawValue === undefined || rawValue === null) return false;
        if (this.eventDispatcher) this.eventDispatcher.emit('resetEditorState', {
            doc: rawValue,
            shouldScrollToBottom: shouldScrollToBottom
        });
        return true;
    }
    replaceSelection(rawValue, tryToReplace, position) {
        if (!this.editorView) return false;
        const { state: state } = this.editorView;
        if (!rawValue) {
            const tr = state.tr.deleteSelection().scrollIntoView();
            this.editorView.dispatch(tr);
            return true;
        }
        const { schema: schema } = state;
        const content = Array.isArray(rawValue) ? (0, $51k6y.processRawFragmentValue)(schema, rawValue, undefined, undefined, undefined, this.dispatchAnalyticsEvent) : (0, $51k6y.processRawValue)(schema, rawValue, undefined, undefined, undefined, this.dispatchAnalyticsEvent);
        if (!content) return false;
        // try to find a place in the document where to insert a node if its not allowed at the cursor position by schema
        this.editorView.dispatch((0, $BmspC.safeInsert)(content, position, tryToReplace)(state.tr).scrollIntoView());
        return true;
    }
    appendText(text) {
        if (!this.editorView || !text) return false;
        const { state: state } = this.editorView;
        const lastChild = state.doc.lastChild;
        if (lastChild && lastChild.type !== state.schema.nodes.paragraph) return false;
        const tr = state.tr.insertText(text).scrollIntoView();
        this.editorView.dispatch(tr);
        return true;
    }
    constructor(){
        this.listeners = [];
        this.dispatchAnalyticsEvent = (payload)=>{
            if (this.eventDispatcher) {
                const dispatch = (0, $aoyv9.createDispatch)(this.eventDispatcher);
                dispatch((0, $dyNYh.analyticsEventKey), {
                    payload: payload
                });
            }
        };
        /**
	 * If editor is using new collab service,
	 * we want editor to call the collab provider to
	 * retrieve the final acknowledged state of the
	 * editor. The final acknowledged editor state
	 * refers to the latest state of editor with confirmed
	 * steps.
	 */ this.getResolvedEditorState = async (reason)=>{
            const { useNativeCollabPlugin: useNativeCollabPlugin } = this.getFeatureFlags();
            if (!this.editorView) throw new Error('Called getResolvedEditorState before editorView is ready');
            if (!useNativeCollabPlugin) {
                const editorValue = await this.getValue();
                if (!editorValue) throw new Error('editorValue is undefined');
                return {
                    content: editorValue,
                    title: null,
                    stepVersion: -1
                };
            }
            const editorView = this.editorView;
            await (0, $1zRDH.getEditorValueWithMedia)(editorView);
            const collabEditState = $d0c717bcbbc27c7c$var$fakePluginKey.getState(editorView.state);
            return collabEditState?.getFinalAcknowledgedState(reason);
        };
    }
}

});
parcelRegister("aoyv9", function(module, exports) {
$parcel$export(module.exports, "EventDispatcher", () => $b11d9cb9e7b224cf$export$ec8b666c5fe2c75a);
$parcel$export(module.exports, "createDispatch", () => $b11d9cb9e7b224cf$export$f57f9cc7ce57b7d0);
class $b11d9cb9e7b224cf$export$ec8b666c5fe2c75a {
    on(event, cb) {
        if (!this.listeners[event]) this.listeners[event] = new Set();
        this.listeners[event].add(cb);
    }
    has(event, cb) {
        if (!this.listeners[event]) return false;
        return this.listeners[event].has(cb);
    }
    off(event, cb) {
        if (!this.listeners[event]) return;
        if (this.listeners[event].has(cb)) this.listeners[event].delete(cb);
    }
    emit(event, data) {
        if (!this.listeners[event]) return;
        this.listeners[event].forEach((cb)=>cb(data));
    }
    destroy() {
        this.listeners = {};
    }
    constructor(){
        this.listeners = {};
    }
}
function $b11d9cb9e7b224cf$var$getEventFromEventName(eventName) {
    return typeof eventName === 'string' ? eventName : eventName.key;
}
function $b11d9cb9e7b224cf$export$f57f9cc7ce57b7d0(eventDispatcher) {
    return (eventName, data)=>{
        if (!eventName) throw new Error('event name is required!');
        eventDispatcher.emit($b11d9cb9e7b224cf$var$getEventFromEventName(eventName), data);
    };
}

});

parcelRegister("51k6y", function(module, exports) {
$parcel$export(module.exports, "processRawValueWithoutValidation", () => $a4056244480d3585$export$cafe23194e65f591);
$parcel$export(module.exports, "processRawValue", () => $a4056244480d3585$export$f1a0a61081c3ed62);
$parcel$export(module.exports, "processRawFragmentValue", () => $a4056244480d3585$export$89b7989c347e6a7b);

var $krqJC = parcelRequire("krqJC");
var $5krZp = parcelRequire("5krZp");
var $igmrQ = parcelRequire("igmrQ");
var $djAo6 = parcelRequire("djAo6");
var $jF4Mi = parcelRequire("jF4Mi");
var $iKCq6 = parcelRequire("iKCq6");
var $cdRsw = parcelRequire("cdRsw");

var $3xw6l = parcelRequire("3xw6l");

var $bMFKb = parcelRequire("bMFKb");

var $fIcYL = parcelRequire("fIcYL");

var $3mTkR = parcelRequire("3mTkR");

var $3Ussg = parcelRequire("3Ussg");
const $a4056244480d3585$var$transformNestedTablesWithAnalytics = (node, dispatchAnalyticsEvent)=>{
    try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $jF4Mi.transformNestedTablesIncomingDocument)(node);
        if (isTransformed && dispatchAnalyticsEvent) {
            dispatchAnalyticsEvent({
                action: (0, $bMFKb.ACTION).NESTED_TABLE_TRANSFORMED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
                eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
            });
            return {
                transformedAdf: transformedAdf,
                isTransformed: isTransformed
            };
        }
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Failed to transform one or more nested tables in the document');
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).DOCUMENT_PROCESSING_ERROR,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
            attributes: {
                errorMessage: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to transform one or more nested tables' : undefined}`
            }
        });
    }
    return {
        transformedAdf: node,
        isTransformed: false
    };
};
function $a4056244480d3585$export$cafe23194e65f591(schema, value, dispatchAnalyticsEvent) {
    if (!value) return;
    let node;
    if (typeof value === 'string') try {
        node = JSON.parse(value);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(`Error processing value: ${value} isn't a valid JSON`);
        return;
    }
    else node = value;
    // Convert nested-table extensions into nested tables
    const { transformedAdf: transformedAdf } = $a4056244480d3585$var$transformNestedTablesWithAnalytics(node, dispatchAnalyticsEvent);
    return (0, $3xw6l.Node).fromJSON(schema, transformedAdf);
}
function $a4056244480d3585$export$f1a0a61081c3ed62(schema, value, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent) {
    if (!value) return;
    let node;
    if (typeof value === 'string') try {
        if (contentTransformer) {
            const doc = contentTransformer.parse(value);
            node = doc.toJSON();
        } else node = JSON.parse(value);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(`Error processing value: ${value} isn't a valid JSON`);
        return;
    }
    else node = value;
    if (Array.isArray(node)) {
        // eslint-disable-next-line no-console
        console.error(`Error processing value: ${node} is an array, but it must be an object.`);
        return;
    }
    try {
        // ProseMirror always require a child under doc
        if (node.type === 'doc') {
            if (Array.isArray(node.content) && node.content.length === 0) node.content.push({
                type: 'paragraph',
                content: []
            });
            // Just making sure doc is always valid
            if (!node.version) node.version = 1;
        }
        if (contentTransformer) return (0, $3xw6l.Node).fromJSON(schema, node);
        // link mark on mediaSingle is deprecated, need to move link mark to child media node
        // https://product-fabric.atlassian.net/browse/ED-14043
        let { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $djAo6.transformMediaLinkMarks)(node);
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).MEDIA_LINK_TRANSFORMED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
        });
        // See: HOT-97965 https://product-fabric.atlassian.net/browse/ED-14400
        // We declared in code mark spec that links and marks should not co-exist on
        // text nodes. This util strips code marks from bad text nodes and preserves links.
        // Otherwise, prosemirror will try to repair the invalid document by stripping links
        // and preserving code marks during content changes.
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $cdRsw.transformTextLinkCodeMarks)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).TEXT_LINK_MARK_TRANSFORMED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
        });
        let discardedMarks = [];
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed, discardedMarks: discardedMarks } = (0, $krqJC.transformDedupeMarks)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).DEDUPE_MARKS_TRANSFORMED_V2,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
            attributes: {
                /** UGC WARNING
					 *
					 * DO NOT include the `mark` attributes inside, we map here to only
					 * extract the mark type as that is the only non-UGC safe information
					 * that we can add to event-attributes
					 *
					 */ discardedMarkTypes: discardedMarks.map((mark)=>mark.type)
            }
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $iKCq6.transformNodesMissingContent)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).NODES_MISSING_CONTENT_TRANSFORMED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $5krZp.transformIndentationMarks)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).INDENTATION_MARKS_TRANSFORMED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $igmrQ.transformInvalidMediaContent)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).INVALID_MEDIA_CONTENT_TRANSFORMED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
        });
        // Convert nested-table extensions into nested tables
        ({ transformedAdf: transformedAdf } = $a4056244480d3585$var$transformNestedTablesWithAnalytics(transformedAdf, dispatchAnalyticsEvent));
        if (dispatchAnalyticsEvent) {
            const hasSingleColumnLayout = transformedAdf.content?.some((node)=>node && node.type === 'layoutSection' && node.content?.length === 1);
            if (hasSingleColumnLayout) dispatchAnalyticsEvent({
                action: (0, $bMFKb.ACTION).SINGLE_COL_LAYOUT_DETECTED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
                eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
            });
        }
        const entity = (0, $3Ussg.validateADFEntity)(schema, transformedAdf || node, dispatchAnalyticsEvent);
        const newEntity = $a4056244480d3585$var$maySanitizePrivateContent(entity, providerFactory, sanitizePrivateContent);
        const parsedDoc = (0, $3xw6l.Node).fromJSON(schema, newEntity);
        // throws an error if the document is invalid
        try {
            parsedDoc.check();
        } catch (err) {
            if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                action: (0, $bMFKb.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
                eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
            });
            throw err;
        }
        if (dispatchAnalyticsEvent) (0, $3mTkR.findAndTrackUnsupportedContentNodes)(parsedDoc, schema, dispatchAnalyticsEvent);
        return parsedDoc;
    } catch (e) {
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).DOCUMENT_PROCESSING_ERROR,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
        });
        // eslint-disable-next-line no-console
        console.error(`Error processing document:\n${e instanceof Error ? e.message : String(e)}\n\n`, JSON.stringify(node));
        if ($a4056244480d3585$var$isProseMirrorSchemaCheckError(e)) throw e;
        return;
    }
}
function $a4056244480d3585$export$89b7989c347e6a7b(schema, value, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent) {
    if (!value) return;
    const adfEntities = value.map((item)=>$a4056244480d3585$export$f1a0a61081c3ed62(schema, item, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent)).filter((item)=>Boolean(item));
    if (adfEntities.length === 0) return;
    return (0, $3xw6l.Fragment).from(adfEntities);
}
function $a4056244480d3585$var$isProseMirrorSchemaCheckError(error) {
    return error instanceof RangeError && // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    (!!error.message.match(/^Invalid collection of marks for node/) || // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    !!error.message.match(/^Invalid content for node/));
}
const $a4056244480d3585$var$maySanitizePrivateContent = (entity, providerFactory, sanitizePrivateContent)=>{
    if (sanitizePrivateContent && providerFactory) return (0, $fIcYL.sanitizeNodeForPrivacy)(entity, providerFactory);
    return entity;
};

});
parcelRegister("krqJC", function(module, exports) {
$parcel$export(module.exports, "transformDedupeMarks", () => $e6b88b763f6730b1$export$af4e387303482581);

var $0mclG = parcelRequire("0mclG");
// This is the set of marks that we wont allow in duplicate to
// exist on a given node, regardless of their attributes. We do
// not include annotations here, because we do allow duplicate
// annotations as long as they have unique id attributes (valid scenario)
const $e6b88b763f6730b1$var$markDuplicatesDisallowed = new Set([
    'strong',
    'underline',
    'textColor',
    'link',
    'em',
    'subsup',
    'strike',
    'backgroundColor'
]);
const $e6b88b763f6730b1$var$maybeHasDisallowedDuplicateMarks = (node)=>{
    const markTypes = node.marks?.map((mark)=>mark.type)?.filter((markType)=>// For annotations, we are performing the same cheap check
        // for duplicates by type, without considering IDs, to quickly determine
        // whether there may be potential deduping targets.
        // In the actual deduping logic in maybeRemoveDisallowedDuplicateMarks,
        // we correctly/safely dedupe annotations by their unique IDs.
        $e6b88b763f6730b1$var$markDuplicatesDisallowed.has(markType) || markType === 'annotation');
    if (!markTypes?.length) return false;
    return new Set(markTypes).size !== markTypes.length;
};
const $e6b88b763f6730b1$var$maybeRemoveDisallowedDuplicateMarks = (node)=>{
    const quota = new Map();
    const annotationsQuota = new Map();
    const discardedMarks = [];
    $e6b88b763f6730b1$var$markDuplicatesDisallowed.forEach((mark)=>{
        quota.set(mark, false);
    });
    if (!node.marks) return {
        discardedMarks: discardedMarks
    };
    const dedupedMarks = node.marks.filter((mark)=>{
        const markType = mark.type;
        if (markType === 'annotation') {
            const id = mark.attrs?.id;
            if (annotationsQuota.has(id)) {
                discardedMarks.push(mark);
                return false;
            } else {
                annotationsQuota.set(id, true);
                return true;
            }
        }
        if (quota.has(markType)) {
            if (!quota.get(markType)) {
                quota.set(markType, true);
                return true;
            } else {
                discardedMarks.push(mark);
                return false;
            }
        }
        return true;
    });
    return {
        node: {
            ...node,
            marks: dedupedMarks
        },
        discardedMarks: discardedMarks
    };
};
const $e6b88b763f6730b1$export$af4e387303482581 = (adf)=>{
    let isTransformed = false;
    const discardedMarks = [];
    const transformedAdf = (0, $0mclG.traverse)(adf, {
        text: (node)=>{
            if ($e6b88b763f6730b1$var$maybeHasDisallowedDuplicateMarks(node)) {
                const result = $e6b88b763f6730b1$var$maybeRemoveDisallowedDuplicateMarks(node);
                const resultDiscardedMarks = result.discardedMarks;
                if (resultDiscardedMarks.length) {
                    discardedMarks.push(...resultDiscardedMarks);
                    isTransformed = true;
                    return result.node;
                }
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed,
        discardedMarks: discardedMarks
    };
};

});

parcelRegister("5krZp", function(module, exports) {
$parcel$export(module.exports, "transformIndentationMarks", () => $816655705743962e$export$c06e4b521519af22);

var $0mclG = parcelRequire("0mclG");
const $816655705743962e$var$hasChildHeadingWithIndentation = (node)=>node.content?.some((childNode)=>childNode?.type === 'heading' && childNode?.marks?.some((mark)=>mark.type === 'indentation')) ?? false;
const $816655705743962e$var$removeIndentationFromHeadings = (node)=>{
    return {
        ...node,
        content: node.content?.map((childNode)=>{
            if (childNode?.type === 'heading') return {
                ...childNode,
                marks: childNode.marks?.filter((mark)=>mark.type !== 'indentation')
            };
            return childNode;
        })
    };
};
const $816655705743962e$export$c06e4b521519af22 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $0mclG.traverse)(adf, {
        tableCell: (node)=>{
            if ($816655705743962e$var$hasChildHeadingWithIndentation(node)) {
                isTransformed = true;
                return $816655705743962e$var$removeIndentationFromHeadings(node);
            }
            return;
        },
        tableHeader: (node)=>{
            if ($816655705743962e$var$hasChildHeadingWithIndentation(node)) {
                isTransformed = true;
                return $816655705743962e$var$removeIndentationFromHeadings(node);
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("igmrQ", function(module, exports) {
$parcel$export(module.exports, "transformInvalidMediaContent", () => $70a64ef7adeadfa6$export$1c8c16d74c7a63bf);

var $0mclG = parcelRequire("0mclG");

var $i429R = parcelRequire("i429R");
const $70a64ef7adeadfa6$var$getChildrenTypeCounts = (nodeContent, allowedTypes)=>{
    const childrenTypes = {};
    nodeContent.forEach((childNode)=>{
        if (!childNode?.type || !allowedTypes.includes(childNode.type)) return;
        if (!childrenTypes[childNode.type]) {
            childrenTypes[childNode.type] = 1;
            return;
        }
        childrenTypes[childNode.type]++;
    });
    return childrenTypes;
};
const $70a64ef7adeadfa6$var$removeDuplicatedNodes = (type, content, predicate)=>{
    let maxIterations = 10;
    let childrenTypeCounts = $70a64ef7adeadfa6$var$getChildrenTypeCounts(content, [
        type
    ])[type];
    let firstPredicateNodeIndex = content.findIndex(predicate);
    while(childrenTypeCounts > 1 && firstPredicateNodeIndex > -1 && maxIterations-- > 0){
        content.splice(firstPredicateNodeIndex, 1);
        firstPredicateNodeIndex = content.findIndex(predicate);
        childrenTypeCounts = $70a64ef7adeadfa6$var$getChildrenTypeCounts(content, [
            type
        ])[type];
    }
};
/**
 * @param  {{[type:string]:number}} allowedTypes - array types allowed to deduplicate
 */ const $70a64ef7adeadfa6$var$deduplicateMediaSingleChildren = (node, allowedTypes)=>{
    if (!node.content) return;
    const content = [
        ...node.content
    ];
    Object.keys(allowedTypes).forEach((type)=>{
        //prioritise removing empty nodes first
        $70a64ef7adeadfa6$var$removeDuplicatedNodes(type, content, (node)=>node?.type === type && (0, $i429R.isEmpty)(node));
        //remove other remaining dupicates
        $70a64ef7adeadfa6$var$removeDuplicatedNodes(type, content, (node)=>node?.type === type);
    });
    return {
        ...node,
        content: content
    };
};
const $70a64ef7adeadfa6$export$1c8c16d74c7a63bf = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $0mclG.traverse)(adf, {
        mediaSingle: (node)=>{
            if (!node?.content?.length) return;
            const disallowedDuplicateTypes = [
                'media',
                'caption'
            ];
            const childrenTypes = $70a64ef7adeadfa6$var$getChildrenTypeCounts(node.content, disallowedDuplicateTypes);
            if (Object.values(childrenTypes).some((occurences)=>occurences > 1)) {
                isTransformed = true;
                return $70a64ef7adeadfa6$var$deduplicateMediaSingleChildren(node, childrenTypes);
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});
parcelRegister("i429R", function(module, exports) {
$parcel$export(module.exports, "isEmpty", () => $f633a00593707962$export$dd1bc94b04021eeb);
const $f633a00593707962$export$dd1bc94b04021eeb = (node)=>!node?.content?.length;

});


parcelRegister("iKCq6", function(module, exports) {
$parcel$export(module.exports, "transformNodesMissingContent", () => $98796c1208bbd0b8$export$652814b83c30d251);

var $0mclG = parcelRequire("0mclG");

var $lfq9L = parcelRequire("lfq9L");
var $h9WvI = parcelRequire("h9WvI");
var $fe5Ef = parcelRequire("fe5Ef");
var $dr60v = parcelRequire("dr60v");

var $i429R = parcelRequire("i429R");
const $98796c1208bbd0b8$var$getMaxColumnsCountForTable = (tableNode)=>{
    let colsInRow = 1;
    tableNode.content?.forEach((childNode)=>{
        if (childNode?.type === 'tableRow' && typeof childNode.content?.length === 'number' && childNode.content.length > colsInRow) colsInRow = childNode.content.length;
    });
    return colsInRow;
};
const $98796c1208bbd0b8$var$createValidEmptyContent = (node)=>{
    switch(node.type){
        case 'tableCell':
            return [
                (0, $h9WvI.paragraph)()
            ];
        default:
            return [];
    }
};
const $98796c1208bbd0b8$var$fixIfTableCellInvalidEmpty = (reportTransform)=>(node)=>{
        if ((0, $i429R.isEmpty)(node)) {
            reportTransform();
            return {
                ...node,
                content: $98796c1208bbd0b8$var$createValidEmptyContent(node)
            };
        }
        return;
    };
const $98796c1208bbd0b8$var$hasNonListItemChildren = (node)=>node.content?.some((node)=>node?.type !== 'listItem');
const $98796c1208bbd0b8$var$hasEmptyListItemChildren = (node)=>node.content?.some((childNode)=>childNode?.type === 'listItem' && !childNode.content?.length);
const $98796c1208bbd0b8$var$tryCreateValidListItemWrappedChildren = (parentListNode)=>{
    return parentListNode.content?.map((childNode)=>{
        if (childNode) switch(childNode.type){
            case 'listItem':
                if ((0, $i429R.isEmpty)(childNode)) {
                    const result = (0, $lfq9L.listItem)([
                        (0, $h9WvI.paragraph)()
                    ]);
                    return result;
                }
                return childNode;
            case 'text':
                return (0, $lfq9L.listItem)([
                    (0, $h9WvI.paragraph)(childNode)
                ]);
            default:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return (0, $lfq9L.listItem)([
                    childNode
                ]);
        }
        return childNode;
    });
};
const $98796c1208bbd0b8$var$fixIfListParentWithInvalidListItemChildren = (reportTransform)=>(node)=>{
        if ($98796c1208bbd0b8$var$hasNonListItemChildren(node) || $98796c1208bbd0b8$var$hasEmptyListItemChildren(node)) {
            reportTransform();
            return {
                ...node,
                content: $98796c1208bbd0b8$var$tryCreateValidListItemWrappedChildren(node)
            };
        }
        return;
    };
const $98796c1208bbd0b8$var$hasNonTableRowChildren = (node)=>node.content?.some((node)=>node?.type !== 'tableRow');
const $98796c1208bbd0b8$var$tryCreateValidTableRowWrappedChildren = (parentTableNode)=>{
    const maxColsCount = $98796c1208bbd0b8$var$getMaxColumnsCountForTable(parentTableNode);
    return parentTableNode.content?.map((childNode)=>{
        if (childNode) switch(childNode.type){
            case 'text':
                return (0, $dr60v.tableRow)([
                    (0, $fe5Ef.tableCell)({})((0, $h9WvI.paragraph)(childNode)),
                    ...new Array(maxColsCount - 1).fill((0, $fe5Ef.tableCell)({})((0, $h9WvI.paragraph)()))
                ]);
            case 'tableCell':
                return (0, $dr60v.tableRow)([
                    childNode
                ]);
            case 'tableRow':
                if ((0, $i429R.isEmpty)(childNode)) return (0, $dr60v.tableRow)([
                    ...new Array(maxColsCount).fill((0, $fe5Ef.tableCell)({})((0, $h9WvI.paragraph)()))
                ]);
                return childNode;
            default:
                return childNode;
        }
        return childNode;
    });
};
const $98796c1208bbd0b8$var$hasEmptyTableRowChildren = (node)=>node?.content?.some((node)=>node?.type === 'tableRow' && node?.content?.length === 0) || undefined;
const $98796c1208bbd0b8$var$fixIfTableParentWithInvalidTableRowChildren = (reportTransform)=>(node)=>{
        if ($98796c1208bbd0b8$var$hasEmptyTableRowChildren(node) || $98796c1208bbd0b8$var$hasNonTableRowChildren(node)) {
            reportTransform();
            return {
                ...node,
                content: $98796c1208bbd0b8$var$tryCreateValidTableRowWrappedChildren(node)
            };
        }
        return;
    };
const $98796c1208bbd0b8$var$removeMediaSingleWithNoContent = (reportTransform)=>(node)=>{
        if ((0, $i429R.isEmpty)(node)) {
            reportTransform();
            return false;
        }
        return;
    };
const $98796c1208bbd0b8$export$652814b83c30d251 = (adf)=>{
    let isTransformed = false;
    const reportTransform = ()=>{
        isTransformed = true;
    };
    let transformedAdf = (0, $0mclG.traverse)(adf, {
        tableCell: $98796c1208bbd0b8$var$fixIfTableCellInvalidEmpty(reportTransform)
    });
    // Empty mediaSingle nodes get stripped from the document and so this transform
    // will create an empty listItem if the media node is in a list. Empty listItems
    // are invalid adf, so we need to transform the mediaSingle nodes first.
    transformedAdf = (0, $0mclG.traverse)(transformedAdf || adf, {
        mediaSingle: $98796c1208bbd0b8$var$removeMediaSingleWithNoContent(reportTransform)
    });
    transformedAdf = (0, $0mclG.traverse)(transformedAdf || adf, {
        bulletList: $98796c1208bbd0b8$var$fixIfListParentWithInvalidListItemChildren(reportTransform),
        orderedList: $98796c1208bbd0b8$var$fixIfListParentWithInvalidListItemChildren(reportTransform),
        table: $98796c1208bbd0b8$var$fixIfTableParentWithInvalidTableRowChildren(reportTransform)
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});
parcelRegister("lfq9L", function(module, exports) {
$parcel$export(module.exports, "listItem", () => $61dc1d317d068dab$export$76c7e83ecc9cdf05);
const $61dc1d317d068dab$export$76c7e83ecc9cdf05 = (content)=>({
        type: 'listItem',
        content: content
    });

});

parcelRegister("h9WvI", function(module, exports) {
$parcel$export(module.exports, "paragraph", () => $a115ad2cfdf9cafd$export$9c206ddddb32a9b);

var $adSqf = parcelRequire("adSqf");
const $a115ad2cfdf9cafd$export$9c206ddddb32a9b = (...content)=>({
        type: 'paragraph',
        content: (0, $adSqf.createTextNodes)(content)
    });

});
parcelRegister("adSqf", function(module, exports) {
$parcel$export(module.exports, "createTextNodes", () => $945ad05c4de9a74c$export$3a269a5941b62f04);

var $2XNdt = parcelRequire("2XNdt");
function $945ad05c4de9a74c$export$3a269a5941b62f04(nodes) {
    return nodes.map($945ad05c4de9a74c$export$72b9432ea0656b50);
}
function $945ad05c4de9a74c$export$72b9432ea0656b50(str) {
    return typeof str === 'string' ? (0, $2XNdt.text)(str) : str;
}

});
parcelRegister("2XNdt", function(module, exports) {
$parcel$export(module.exports, "text", () => $dace89db06dc46be$export$6f093cfa640b7166);
const $dace89db06dc46be$export$6f093cfa640b7166 = (text)=>({
        type: 'text',
        text: text
    });

});



parcelRegister("fe5Ef", function(module, exports) {
$parcel$export(module.exports, "tableCell", () => $506ded3492622aa6$export$e1e720e5f4603e6a);
const $506ded3492622aa6$export$e1e720e5f4603e6a = (attrs)=>(...content)=>({
            type: 'tableCell',
            attrs: attrs,
            content: content
        });

});

parcelRegister("dr60v", function(module, exports) {
$parcel$export(module.exports, "tableRow", () => $4e0b8a40e6638685$export$ce666bf02318c957);
const $4e0b8a40e6638685$export$ce666bf02318c957 = (content)=>({
        type: 'tableRow',
        content: content
    });

});


parcelRegister("cdRsw", function(module, exports) {
$parcel$export(module.exports, "transformTextLinkCodeMarks", () => $a8aa57247cebadf0$export$3d531d2daf0e8a14);

var $0mclG = parcelRequire("0mclG");
const $a8aa57247cebadf0$var$hasLinkAndCodeMarks = (node)=>{
    const marks = node.marks?.map((mark)=>mark.type);
    return marks?.includes('link') && marks?.includes('code');
};
const $a8aa57247cebadf0$var$removeCodeMarks = (node)=>{
    if (node.marks) return {
        ...node,
        marks: node.marks.filter((mark)=>mark.type !== 'code')
    };
    return node;
};
const $a8aa57247cebadf0$export$3d531d2daf0e8a14 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $0mclG.traverse)(adf, {
        text: (node)=>{
            if ($a8aa57247cebadf0$var$hasLinkAndCodeMarks(node)) {
                isTransformed = true;
                return $a8aa57247cebadf0$var$removeCodeMarks(node);
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("fIcYL", function(module, exports) {
$parcel$export(module.exports, "sanitizeNodeForPrivacy", () => $172bab980f7d6e6f$export$8a32f625580e0a06);

var $0mclG = parcelRequire("0mclG");

var $231b4 = parcelRequire("231b4");
function $172bab980f7d6e6f$export$8a32f625580e0a06(json, providerFactory) {
    const mentionNames = new Map();
    let hasCacheableMentions = false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedJSON = (0, $0mclG.traverse)(json, {
        mention: (node)=>{
            if (node.attrs && node.attrs.text) {
                hasCacheableMentions = true;
                // Remove @ prefix
                const text = node.attrs.text;
                const name = text.startsWith('@') ? text.slice(1) : text;
                mentionNames.set(node.attrs.id, name);
            }
            return {
                ...node,
                attrs: {
                    ...node.attrs,
                    text: ''
                }
            };
        }
    });
    if (hasCacheableMentions && providerFactory) {
        const handler = (_name, providerPromise)=>{
            if (providerPromise) providerPromise.then((provider)=>{
                if ((0, $231b4.isResolvingMentionProvider)(provider)) {
                    mentionNames.forEach((name, id)=>{
                        provider.cacheMentionName(id, name);
                    });
                    mentionNames.clear();
                    providerFactory.unsubscribe('mentionProvider', handler);
                }
            });
        };
        providerFactory.subscribe('mentionProvider', handler);
    }
    return sanitizedJSON;
}

});


parcelRegister("1zRDH", function(module, exports) {
$parcel$export(module.exports, "getEditorValueWithMedia", () => $1072be5483a485cf$export$99c45752ffdaa598);
// Please, do not copy or use this kind of code below
// @ts-ignore
const $1072be5483a485cf$var$mediaPluginKey = {
    key: 'mediaPlugin$',
    getState: (state)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return state['mediaPlugin$'];
    }
};
async function $1072be5483a485cf$export$99c45752ffdaa598(editorView) {
    const mediaPluginState = editorView.state && $1072be5483a485cf$var$mediaPluginKey.getState(editorView.state);
    if (mediaPluginState && mediaPluginState.waitForMediaUpload) await mediaPluginState.waitForPendingTasks();
    return editorView.state.doc;
}

});

parcelRegister("dLCMh", function(module, exports) {
$parcel$export(module.exports, "default", () => $64b694e1960e5cc1$export$2e2bcd8739ae039);
function $64b694e1960e5cc1$var$deprecationWarnings(className, props, deprecations) {
    return;
}
var $64b694e1960e5cc1$export$2e2bcd8739ae039 = $64b694e1960e5cc1$var$deprecationWarnings;

});

parcelRegister("98LxN", function(module, exports) {
$parcel$export(module.exports, "findNodePosByFragmentLocalIds", () => $c3ac6deb3e3077bc$export$1dc8bea8646ac811);
const $c3ac6deb3e3077bc$export$1dc8bea8646ac811 = (state, ids)=>{
    if (ids.length === 0) return [];
    const nodes = [];
    const localIdSet = new Set(ids);
    state.doc.descendants((node, pos)=>{
        const fragmentLocalIdList = node.marks?.filter((m)=>m.type.name === 'fragment').map((m)=>m.attrs?.localId).filter((id)=>id && localIdSet.has(id));
        if (fragmentLocalIdList.length > 0) nodes.push({
            node: node,
            pos: pos
        });
        // stop traversing once we found all the nodes
        return localIdSet.size !== nodes.length;
    });
    return nodes;
};

});

parcelRegister("lgr6j", function(module, exports) {
$parcel$export(module.exports, "isEmptyDocument", () => $28d5451797013a88$export$2da47a16c0b6bcb);
/**
 * Temporary file which extracts function from `editor-common`.
 *
 * Eventually we will deprecate and delete EditorActions. This is here to
 * help decouple it from editor-common
 */ function $28d5451797013a88$export$b648602b09795358(node) {
    return !!node && node.type.name === 'paragraph' && !node.childCount;
}
function $28d5451797013a88$export$2da47a16c0b6bcb(node) {
    const nodeChild = node.content.firstChild;
    if (node.childCount !== 1 || !nodeChild) return false;
    return $28d5451797013a88$export$b648602b09795358(nodeChild);
}

});

parcelRegister("kWYFo", function(module, exports) {
$parcel$export(module.exports, "findNodePosByLocalIds", () => $8a10f65a200ea998$export$947fc26275418e36);
/**
 * Temporary file which extracts function from `editor-common`.
 *
 * Eventually we will deprecate and delete EditorActions. This is here to
 * help decouple it from editor-common
 */ const $8a10f65a200ea998$export$947fc26275418e36 = (state, ids, option = {})=>{
    if (ids.length === 0) return [];
    const nodes = [];
    const localIdSet = new Set(ids);
    if (option.includeDocNode && localIdSet.has(state.doc.attrs?.localId)) nodes.push({
        node: state.doc,
        pos: 0
    });
    state.doc.descendants((node, pos)=>{
        if (localIdSet.has(node.attrs?.localId)) nodes.push({
            node: node,
            pos: pos
        });
        // stop traversing once we found all the nodes
        return localIdSet.size !== nodes.length;
    });
    return nodes;
};

});

parcelRegister("dtmLc", function(module, exports) {
$parcel$export(module.exports, "toJSON", () => $50c5f8cc57b19c60$export$54fd2c36b5cc6731);
/**
 * Temporary file which extracts function from `editor-common`.
 *
 * Eventually we will deprecate and delete EditorActions. This is here to
 * help decouple it from editor-common
 */ 
var $lovmf = parcelRequire("lovmf");
const $50c5f8cc57b19c60$var$transformer = new (0, $lovmf.JSONTransformer)();
function $50c5f8cc57b19c60$export$54fd2c36b5cc6731(node) {
    return $50c5f8cc57b19c60$var$transformer.encode(node);
}

});


parcelRegister("kCWwL", function(module, exports) {
$parcel$export(module.exports, "useEditorContext", () => $61d12d29fead659b$export$b119c82498f162a5);
$parcel$export(module.exports, "default", () => $61d12d29fead659b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $cT3Ey = parcelRequire("cT3Ey");

var $dWjPG = parcelRequire("dWjPG");

var $2pwTW = parcelRequire("2pwTW");
const $61d12d29fead659b$export$b119c82498f162a5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $dWjPG.EditorContext));
class $61d12d29fead659b$export$797df872f5526664 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    constructor(props){
        super(props);
    }
    render() {
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $gt9Am.jsx)($61d12d29fead659b$var$LegacyEditorContextNew, {
            ...this.props,
            children: this.props.children
        });
    }
}
function $61d12d29fead659b$var$LegacyEditorContextNew({ children: children, editorActions: editorActions }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dWjPG.EditorContext).Provider, {
        value: {
            editorActions: editorActions ?? new (0, $2pwTW.default)()
        },
        children: children
    });
}
class $61d12d29fead659b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.childContextTypes = {
            editorActions: (0, (/*@__PURE__*/$parcel$interopDefault($cT3Ey))).object
        };
    }
    constructor(props){
        super(props);
        this.editorActions = props.editorActions || new (0, $2pwTW.default)();
    }
    getChildContext() {
        return {
            editorActions: this.editorActions
        };
    }
    render() {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dWjPG.EditorContext).Provider, {
            value: this.getChildContext(),
            children: this.props.children
        });
    }
}

});
parcelRegister("dWjPG", function(module, exports) {
$parcel$export(module.exports, "EditorContext", () => $cbb76531ff6b3d2e$export$27b8dd149e32f6c7);

var $eJOHy = parcelRequire("eJOHy");
const $cbb76531ff6b3d2e$export$27b8dd149e32f6c7 = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext({});

});


parcelRegister("hUQD4", function(module, exports) {
$parcel$export(module.exports, "createFeatureFlagsFromProps", () => $89800ae9585acbb0$export$63102b0cbe181144);

var $jgFE8 = parcelRequire("jgFE8");
function $89800ae9585acbb0$var$verifyJSON(json) {
    try {
        return JSON.parse(json);
    } catch (e) {
        return undefined;
    }
}
function $89800ae9585acbb0$var$getSpellCheck(featureFlags) {
    if (!!featureFlags?.['disableSpellcheckByBrowser']) return typeof featureFlags?.['disableSpellcheckByBrowser'] === 'object' ? featureFlags?.['disableSpellcheckByBrowser'] : typeof featureFlags?.['disableSpellcheckByBrowser'] === 'string' ? $89800ae9585acbb0$var$verifyJSON(featureFlags?.['disableSpellcheckByBrowser']) : undefined;
    if (!!featureFlags?.['disable-spellcheck-by-browser']) return typeof featureFlags?.['disable-spellcheck-by-browser'] === 'object' ? featureFlags?.['disable-spellcheck-by-browser'] : typeof featureFlags?.['disable-spellcheck-by-browser'] === 'string' ? $89800ae9585acbb0$var$verifyJSON(featureFlags?.['disable-spellcheck-by-browser']) : undefined;
    return undefined;
}
function $89800ae9585acbb0$export$63102b0cbe181144(featureFlags) {
    const normalizedFeatureFlags = (0, $jgFE8.normalizeFeatureFlags)(featureFlags);
    return {
        ...normalizedFeatureFlags,
        catchAllTracking: false,
        showAvatarGroupAsPlugin: Boolean(typeof featureFlags?.showAvatarGroupAsPlugin === 'boolean' ? !!featureFlags?.showAvatarGroupAsPlugin : false),
        errorBoundaryDocStructure: Boolean(typeof featureFlags?.useErrorBoundaryDocStructure === 'boolean' ? !!featureFlags?.useErrorBoundaryDocStructure : false),
        synchronyErrorDocStructure: Boolean(typeof featureFlags?.synchronyErrorDocStructure === 'boolean' ? !!featureFlags?.synchronyErrorDocStructure : false),
        enableViewUpdateSubscription: Boolean(typeof featureFlags?.enableViewUpdateSubscription === 'boolean' ? !!featureFlags?.enableViewUpdateSubscription : false),
        collabAvatarScroll: Boolean(typeof featureFlags?.collabAvatarScroll === 'boolean' ? !!featureFlags?.collabAvatarScroll : false),
        twoLineEditorToolbar: Boolean(typeof featureFlags?.twoLineEditorToolbar === 'boolean' ? !!featureFlags?.twoLineEditorToolbar : false),
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        disableSpellcheckByBrowser: $89800ae9585acbb0$var$getSpellCheck(featureFlags)
    };
}

});

parcelRegister("1ZFgR", function(module, exports) {
$parcel$export(module.exports, "default", () => $a50c41b70f4c9cc8$export$2e2bcd8739ae039);
var $a50c41b70f4c9cc8$export$2e2bcd8739ae039 = {
    EDITOR_MOUNTED: 'Editor Component Mount Time',
    PROSEMIRROR_RENDERED: 'ProseMirror Render Time',
    PROSEMIRROR_CONTENT_RENDERED: 'ProseMirror Content Render Time',
    ON_EDITOR_READY_CALLBACK: 'onEditorReady Callback Duration'
};

});

parcelRegister("k9jP1", function(module, exports) {
$parcel$export(module.exports, "name", () => $6f0d45a1741f1dcc$export$a8ff84c12d48cfa6);
$parcel$export(module.exports, "version", () => $6f0d45a1741f1dcc$export$83d89fbfd8236492);
const $6f0d45a1741f1dcc$export$a8ff84c12d48cfa6 = "platform-pkg";
const $6f0d45a1741f1dcc$export$83d89fbfd8236492 = "0.0.0-use.local";

});

parcelRegister("7rP03", function(module, exports) {
$parcel$export(module.exports, "EditorINPMetrics", () => $2873978d0730d0bc$export$5942461441325be9);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $ftN6c = parcelRequire("ftN6c");

var $bMFKb = parcelRequire("bMFKb");
var $cd124 = parcelRequire("cd124");

var $59Ldo = parcelRequire("59Ldo");

var $2QO3b = parcelRequire("2QO3b");
const $2873978d0730d0bc$export$5942461441325be9 = ()=>{
    const analyticsEvents = (0, $ftN6c.useAnalyticsEvents)();
    // onMount lifecycle hook
    (0, $eJOHy.useEffect)(()=>{
        let cleanupFn;
        const cleanupIdleCallback = $2873978d0730d0bc$var$createIdleCallback(()=>{
            cleanupFn = (0, $59Ldo.setupINPTracking)(({ value: value })=>{
                const interaction = (0, $2QO3b.getActiveInteraction)();
                const ufoName = interaction?.ufoName;
                $2873978d0730d0bc$var$sendAnalytics(analyticsEvents.createAnalyticsEvent, value, ufoName);
            });
        });
        // Cleanup function that will be called when the component unmounts
        return ()=>{
            cleanupIdleCallback();
            cleanupFn?.();
        };
    // Using hook as mount lifecycle hook.
    // We do not need to set dependency on analyticsEvents since we are using the analyticsEvents object reference
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // This component doesn't render anything
    return null;
};
const $2873978d0730d0bc$var$sendAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((createAnalyticsEvent, value, ufoName)=>{
    (0, $cd124.fireAnalyticsEvent)(createAnalyticsEvent)({
        payload: {
            // @ts-expect-error Temporary data
            action: 'inp',
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
            attributes: {
                inp: value,
                ufoName: ufoName
            }
        }
    });
}, 1000, {
    trailing: true
});
const $2873978d0730d0bc$var$createIdleCallback = (callback)=>{
    if (typeof window.requestIdleCallback === 'function') {
        const id = window.requestIdleCallback(callback);
        return ()=>window.cancelIdleCallback(id);
    }
    // Fallback to setTimeout with 0 delay if requestIdleCallback is not available
    const id = window.setTimeout(callback, 0);
    return ()=>window.clearTimeout(id);
};

});
parcelRegister("59Ldo", function(module, exports) {
$parcel$export(module.exports, "setupINPTracking", () => $cb7c07d5eaf82a22$export$56930d9a67e0aae6);

var $74C10 = parcelRequire("74C10");

var $igDjg = parcelRequire("igDjg");
const $cb7c07d5eaf82a22$export$56930d9a67e0aae6 = (callback)=>{
    if (!$cb7c07d5eaf82a22$var$isINPSupported()) return;
    return (0, $74C10.onINP)((metric)=>{
        callback({
            value: metric.value
        });
    });
};
const $cb7c07d5eaf82a22$var$isINPSupported = ()=>{
    const isSSR = !window || typeof $igDjg !== 'undefined' && Boolean($igDjg?.env?.REACT_SSR || false);
    if (isSSR) return false;
    // Return if the browser doesn't support all APIs needed to measure INP.
    if (!('PerformanceEventTiming' in window && 'interactionId' in PerformanceEventTiming.prototype)) return false;
    if (!PerformanceObserver.supportedEntryTypes.includes('event') && !PerformanceObserver.supportedEntryTypes.includes('first-input')) return false;
    return true;
};

});
parcelRegister("74C10", function(module, exports) {
$parcel$export(module.exports, "onINP", () => $ff320fc665a8f45c$export$7df4b36ecaed99e1);
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/onINP.ts

var $9rvy8 = parcelRequire("9rvy8");

var $f5yKN = parcelRequire("f5yKN");

var $aiUnN = parcelRequire("aiUnN");

var $69eZD = parcelRequire("69eZD");
const $ff320fc665a8f45c$export$7df4b36ecaed99e1 = (callback)=>{
    const metric = {
        value: 0,
        delta: 0,
        entries: []
    };
    const reporter = (0, $9rvy8.bindReporter)(callback);
    const interactionManager = new (0, $f5yKN.InteractionManager)();
    const handleEntries = (entries)=>{
        (0, $69eZD.whenIdle)(()=>{
            entries.forEach((entry)=>interactionManager.processInteractionEntry(entry));
            const inp = interactionManager.estimateP98LongestInteraction();
            if (inp && inp.latency !== metric.value) {
                metric.value = inp.latency;
                metric.entries = entries;
                reporter(metric);
            }
        });
    };
    const po = $ff320fc665a8f45c$var$observeInteractionEvent(handleEntries);
    const onHiddenCleanup = (0, $aiUnN.onHidden)(()=>{
        handleEntries(po.takeRecords());
        reporter(metric);
    });
    return ()=>{
        po.disconnect();
        interactionManager.cleanup();
        onHiddenCleanup();
    };
};
const $ff320fc665a8f45c$var$observeInteractionEvent = (callback)=>{
    const po = new PerformanceObserver((list)=>{
        // Delay by a microtask to workaround a bug in Safari where the
        // callback is invoked immediately, rather than in a separate task.
        // See: https://github.com/GoogleChrome/web-vitals/issues/277
        Promise.resolve().then(()=>{
            callback(list.getEntries());
        });
    });
    // Event Timing entries have their durations rounded to the nearest 8ms,
    // so a duration of 40ms would be any event that spans 2.5 or more frames
    // at 60Hz. This threshold is chosen to strike a balance between usefulness
    // and performance. Running this callback for any interaction that spans
    // just one or two frames is likely not worth the insight that could be
    // gained.
    if (PerformanceObserver.supportedEntryTypes.includes('event')) po.observe({
        type: 'event',
        buffered: true,
        durationThreshold: 40
    });
    if (PerformanceObserver.supportedEntryTypes.includes('first-input')) po.observe({
        type: 'first-input',
        buffered: true
    });
    return po;
};

});
parcelRegister("9rvy8", function(module, exports) {
$parcel$export(module.exports, "bindReporter", () => $fdd0dd6328969e43$export$17679dccdd551979);
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/bindReporter.ts
const $fdd0dd6328969e43$export$17679dccdd551979 = (callback)=>{
    let prevValue;
    let delta;
    return (metric)=>{
        if (metric.value >= 0) {
            delta = metric.value - (prevValue || 0);
            // Report the metric if there's a non-zero delta or if no previous
            // value exists (which can happen in the case of the document becoming
            // hidden when the metric value is 0).
            // See: https://github.com/GoogleChrome/web-vitals/issues/14
            if (delta || prevValue === undefined) {
                prevValue = metric.value;
                metric.delta = delta;
                callback(metric);
            }
        }
    };
};

});

parcelRegister("f5yKN", function(module, exports) {
$parcel$export(module.exports, "InteractionManager", () => $07782c762f135a93$export$aaa80641d584351c);
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/interactions.ts

var $lI9Ca = parcelRequire("lI9Ca");
class $07782c762f135a93$export$aaa80641d584351c {
    static{
        this.MAX_INTERACTIONS_TO_CONSIDER = 10;
    }
    constructor(){
        this.longestInteractionList = [];
        this.longestInteractionMap = new Map();
        this.interactionCountPolyfill = new (0, $lI9Ca.InteractionCountPolyfill)();
    }
    cleanup() {
        this.interactionCountPolyfill.cleanup();
    }
    /**
	 * Returns the estimated p98 longest interaction based on the stored
	 * interaction candidates and the interaction count for the current page.
	 */ estimateP98LongestInteraction() {
        const candidateInteractionIndex = Math.min(this.longestInteractionList.length - 1, Math.floor(this.interactionCountPolyfill.getInteractionCount() / 50));
        return this.longestInteractionList[candidateInteractionIndex];
    }
    /**
	 * Takes a performance entry and adds it to the list of worst interactions
	 * if its duration is long enough to make it among the worst. If the
	 * entry is part of an existing interaction, it is merged and the latency
	 * and entries list is updated as needed.
	 */ processInteractionEntry(entry) {
        // Skip further processing for entries that cannot be INP candidates.
        if (!(entry.interactionId || entry.entryType === 'first-input')) return;
        // The least-long of the 10 longest interactions.
        const minLongestInteraction = this.longestInteractionList[this.longestInteractionList.length - 1];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const existingInteraction = this.longestInteractionMap.get(entry.interactionId);
        // Only process the entry if it's possibly one of the ten longest,
        // or if it's part of an existing interaction.
        if (existingInteraction || this.longestInteractionList.length < $07782c762f135a93$export$aaa80641d584351c.MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
            // If the interaction already exists, update it. Otherwise create one.
            if (existingInteraction) {
                // If the new entry has a longer duration, replace the old entries,
                // otherwise add to the array.
                if (entry.duration > existingInteraction.latency) {
                    existingInteraction.entries = [
                        entry
                    ];
                    existingInteraction.latency = entry.duration;
                } else if (entry.duration === existingInteraction.latency && entry.startTime === existingInteraction.entries[0].startTime) existingInteraction.entries.push(entry);
            } else {
                const interaction = {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: entry.interactionId,
                    latency: entry.duration,
                    entries: [
                        entry
                    ]
                };
                this.longestInteractionMap.set(interaction.id, interaction);
                this.longestInteractionList.push(interaction);
            }
            // Sort the entries by latency (descending) and keep only the top ten.
            this.longestInteractionList.sort((a, b)=>b.latency - a.latency);
            if (this.longestInteractionList.length > $07782c762f135a93$export$aaa80641d584351c.MAX_INTERACTIONS_TO_CONSIDER) this.longestInteractionList.splice($07782c762f135a93$export$aaa80641d584351c.MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>this.longestInteractionMap.delete(i.id));
        }
    }
}

});
parcelRegister("lI9Ca", function(module, exports) {
$parcel$export(module.exports, "InteractionCountPolyfill", () => $d7103430ac5809b3$export$51e52147760fc784);
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/polyfills/interactionCountPolyfill.ts
class $d7103430ac5809b3$export$51e52147760fc784 {
    constructor(){
        this.interactionCountEstimate = 0;
        this.minKnownInteractionId = Infinity;
        this.maxKnownInteractionId = 0;
        if ('interactionCount' in performance || this.po) return;
        if (!PerformanceObserver.supportedEntryTypes.includes('event')) return;
        this.po = new PerformanceObserver((list)=>{
            // Delay by a microtask to workaround a bug in Safari where the
            // callback is invoked immediately, rather than in a separate task.
            // See: https://github.com/GoogleChrome/web-vitals/issues/277
            Promise.resolve().then(()=>{
                this.updateEstimate(list.getEntries());
            });
        });
        this.po.observe({
            type: 'event',
            buffered: true,
            durationThreshold: 0
        });
    }
    cleanup() {
        this.po?.disconnect();
    }
    updateEstimate(entries) {
        entries.forEach((e)=>{
            if (e.interactionId) {
                this.minKnownInteractionId = Math.min(this.minKnownInteractionId, e.interactionId);
                this.maxKnownInteractionId = Math.max(this.maxKnownInteractionId, e.interactionId);
                this.interactionCountEstimate = this.maxKnownInteractionId ? (this.maxKnownInteractionId - this.minKnownInteractionId) / 7 + 1 : 0;
            }
        });
    }
    /**
	 * Returns the `interactionCount` value using the native API (if available)
	 * or the polyfill estimate in this module.
	 */ getInteractionCount() {
        return this.po ? this.interactionCountEstimate : performance.interactionCount || 0;
    }
}

});


parcelRegister("aiUnN", function(module, exports) {
$parcel$export(module.exports, "onHidden", () => $123034d5ec99c082$export$91ec2be6fdd8f1b4);
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/onHidden.ts
const $123034d5ec99c082$export$91ec2be6fdd8f1b4 = (cb)=>{
    const handleVisibilityChange = ()=>{
        if (document.visibilityState === 'hidden') cb();
    };
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return ()=>{
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
};

});

parcelRegister("69eZD", function(module, exports) {
$parcel$export(module.exports, "whenIdle", () => $845c084e2c0211be$export$4d9952dcbf5b2792);
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/whenIdle.ts

var $aiUnN = parcelRequire("aiUnN");
const $845c084e2c0211be$export$4d9952dcbf5b2792 = (cb)=>{
    const rIC = window.requestIdleCallback || window.setTimeout;
    let handle = -1;
    cb = $845c084e2c0211be$var$runOnce(cb);
    // If the document is hidden, run the callback immediately, otherwise
    // race an idle callback with the next `visibilitychange` event.
    if (document.visibilityState === 'hidden') cb();
    else {
        const cleanup = (0, $aiUnN.onHidden)(()=>{
            cb();
            cleanup();
        });
        handle = rIC(()=>{
            cb();
            cleanup();
        });
    }
    return handle;
};
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/runOnce.ts
const $845c084e2c0211be$var$runOnce = (cb)=>{
    let called = false;
    return ()=>{
        if (!called) {
            cb();
            called = true;
        }
    };
};

});




parcelRegister("hk8Wh", function(module, exports) {
$parcel$export(module.exports, "EditorInternal", () => $817212d4106d8dfd$export$2617c0dabe49c335);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $bMFKb = parcelRequire("bMFKb");

var $i2Pif = parcelRequire("i2Pif");

var $8kDPZ = parcelRequire("8kDPZ");

var $jLBRN = parcelRequire("jLBRN");

var $kCWwL = parcelRequire("kCWwL");

var $6HxkX = parcelRequire("6HxkX");

var $hUQD4 = parcelRequire("hUQD4");

var $i5btK = parcelRequire("i5btK");

var $gk7i7 = parcelRequire("gk7i7");

var $dLePd = parcelRequire("dLePd");
function $817212d4106d8dfd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $817212d4106d8dfd$var$editorContainerStyles = {
    name: "zxsb69",
    styles: "position:relative;width:100%;height:100%"
};
const $817212d4106d8dfd$export$2617c0dabe49c335 = /*#__PURE__*/ (0, $eJOHy.memo)(({ props: props, handleAnalyticsEvent: handleAnalyticsEvent, createAnalyticsEvent: createAnalyticsEvent, handleSave: handleSave, editorActions: editorActions, providerFactory: providerFactory, onEditorCreated: onEditorCreated, onEditorDestroyed: onEditorDestroyed, preset: preset, AppearanceComponent: AppearanceComponent })=>{
    const overriddenEditorProps = {
        ...props,
        onSave: props.onSave ? handleSave : undefined,
        // noop all analytic events, even if a handler is still passed.
        analyticsHandler: undefined
    };
    const featureFlags = (0, $hUQD4.createFeatureFlagsFromProps)(props.featureFlags);
    // Render tracking is firing too many events in Jira so we are disabling them for now. See - https://product-fabric.atlassian.net/browse/ED-25616
    // Also firing too many events for the legacy content macro, so disabling for now. See - https://product-fabric.atlassian.net/browse/ED-26650
    const renderTrackingEnabled = false;
    const useShallow = false;
    const [portalProviderAPI, PortalRenderer] = (0, $i2Pif.usePortalProvider)();
    const [nodeViewPortalProviderAPI, NodeViewPortalRenderer] = (0, $i2Pif.usePortalProvider)();
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, renderTrackingEnabled && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $i5btK.RenderTracking), {
        componentProps: props,
        action: (0, $bMFKb.ACTION).RE_RENDERED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
        handleAnalyticsEvent: handleAnalyticsEvent,
        propsToIgnore: [
            'defaultValue'
        ],
        useShallow: useShallow
    }), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8kDPZ.default), {
        errorTracking: true,
        createAnalyticsEvent: createAnalyticsEvent,
        contextIdentifierProvider: props.contextIdentifierProvider,
        featureFlags: featureFlags
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $817212d4106d8dfd$var$editorContainerStyles
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $kCWwL.default), {
        editorActions: editorActions
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $6HxkX.IntlProviderIfMissingWrapper), null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jLBRN.default), {
        editorProps: overriddenEditorProps,
        createAnalyticsEvent: createAnalyticsEvent,
        portalProviderAPI: portalProviderAPI,
        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
        providerFactory: providerFactory,
        onEditorCreated: onEditorCreated,
        onEditorDestroyed: onEditorDestroyed,
        disabled: props.disabled,
        preset: preset,
        render: ({ editor: editor, view: view, eventDispatcher: eventDispatcher, config: config, dispatchAnalyticsEvent: dispatchAnalyticsEvent, editorRef: editorRef, editorAPI: editorAPI })=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, $gk7i7.BaseThemeWrapper), {
                baseFontSize: (0, $dLePd.getBaseFontSize)(props.appearance, props.contentMode)
            }, /*#__PURE__*/ (0, $1NIU8.jsx)(AppearanceComponent, {
                innerRef: editorRef,
                editorAPI: editorAPI,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                appearance: props.appearance,
                disabled: props.disabled,
                editorActions: editorActions,
                editorDOMElement: editor,
                editorView: view,
                providerFactory: providerFactory,
                eventDispatcher: eventDispatcher,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                maxHeight: props.maxHeight,
                minHeight: props.minHeight,
                onSave: props.onSave ? handleSave : undefined,
                onCancel: props.onCancel,
                popupsMountPoint: props.popupsMountPoint,
                popupsBoundariesElement: props.popupsBoundariesElement,
                popupsScrollableElement: props.popupsScrollableElement,
                contentComponents: config.contentComponents,
                contentMode: props.contentMode,
                primaryToolbarComponents: config.primaryToolbarComponents,
                primaryToolbarIconBefore: props.primaryToolbarIconBefore,
                secondaryToolbarComponents: config.secondaryToolbarComponents,
                customContentComponents: props.contentComponents,
                customPrimaryToolbarComponents: props.primaryToolbarComponents,
                customSecondaryToolbarComponents: props.secondaryToolbarComponents,
                contextPanel: props.contextPanel,
                collabEdit: props.collabEdit,
                persistScrollGutter: props.persistScrollGutter,
                enableToolbarMinWidth: props.featureFlags?.toolbarMinWidthOverflow != null ? !!props.featureFlags?.toolbarMinWidthOverflow : props.allowUndoRedoButtons,
                useStickyToolbar: props.useStickyToolbar,
                featureFlags: featureFlags,
                pluginHooks: config.pluginHooks,
                __livePage: props.__livePage,
                preset: preset
            }))
    }), /*#__PURE__*/ (0, $1NIU8.jsx)(PortalRenderer, null), /*#__PURE__*/ (0, $1NIU8.jsx)(NodeViewPortalRenderer, null)))))));
});

});
parcelRegister("i2Pif", function(module, exports) {
$parcel$export(module.exports, "usePortalProvider", () => $4646bebc3aa0f491$export$9b00782c24eb3d6b);

var $eJOHy = parcelRequire("eJOHy");

var $1qnsL = parcelRequire("1qnsL");

var $fn460 = parcelRequire("fn460");
function $4646bebc3aa0f491$export$9b00782c24eb3d6b() {
    const portalManager = (0, $eJOHy.useMemo)(()=>new (0, $fn460.PortalManager)(), []);
    const PortalRenderer = (0, $eJOHy.useMemo)(()=>(0, $1qnsL.createPortalRendererComponent)(portalManager), [
        portalManager
    ]);
    const portalProviderAPI = (0, $eJOHy.useMemo)(()=>(0, $1qnsL.getPortalProviderAPI)(portalManager), [
        portalManager
    ]);
    // Cleanup on unmount
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            portalProviderAPI.destroy();
        };
    }, [
        portalManager,
        portalProviderAPI
    ]);
    return [
        portalProviderAPI,
        PortalRenderer
    ];
}

});
parcelRegister("1qnsL", function(module, exports) {
$parcel$export(module.exports, "createPortalRendererComponent", () => $6429de9c70dbffb7$export$adfaaa25a1ea6e69);
$parcel$export(module.exports, "getPortalProviderAPI", () => $6429de9c70dbffb7$export$3a6b5f5c5bba4bde);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $hUHRU = parcelRequire("hUHRU");
function $6429de9c70dbffb7$export$adfaaa25a1ea6e69(portalManager) {
    return function PortalRenderer() {
        const [buckets, setBuckets] = (0, $eJOHy.useState)(portalManager.getBuckets());
        (0, $eJOHy.useLayoutEffect)(()=>{
            portalManager.registerPortalRenderer(setBuckets);
            return ()=>{
                portalManager.unregisterPortalRenderer();
            };
        }, []);
        const portalsElements = (0, $eJOHy.useMemo)(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        ()=>buckets.map((_, i)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hUHRU.PortalBucket), {
                    id: i,
                    portalManager: portalManager
                }, i)), [
            buckets
        ]);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: portalsElements
        });
    };
}
const $6429de9c70dbffb7$export$eab0ea19ad3bed77 = ({ getChildren: getChildren, onBeforeRender: onBeforeRender })=>{
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (onBeforeRender) onBeforeRender();
    }, [
        onBeforeRender
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: getChildren()
    });
};
const $6429de9c70dbffb7$var$PortalRenderWrapper = /*#__PURE__*/ (0, $eJOHy.memo)($6429de9c70dbffb7$export$eab0ea19ad3bed77);
$6429de9c70dbffb7$var$PortalRenderWrapper.displayName = 'PortalRenderWrapper';
const $6429de9c70dbffb7$export$3a6b5f5c5bba4bde = (portalManager)=>{
    const portalsMap = new Map();
    return {
        render: (children, container, key, onBeforeReactDomRender, immediate = false)=>{
            if (typeof onBeforeReactDomRender === 'function') {
                const portal = /*#__PURE__*/ (0, $aQK2r.createPortal)(/*#__PURE__*/ (0, $gt9Am.jsx)($6429de9c70dbffb7$var$PortalRenderWrapper, {
                    getChildren: children,
                    onBeforeRender: onBeforeReactDomRender
                }), container, key);
                portalsMap.set(key, portalManager.registerPortal(key, portal, immediate));
            } else {
                const portal = /*#__PURE__*/ (0, $aQK2r.createPortal)(children(), container, key);
                portalsMap.set(key, portalManager.registerPortal(key, portal, immediate));
            }
        },
        remove: (key)=>{
            portalsMap.get(key)?.();
            portalsMap.delete(key);
        },
        destroy: ()=>{
            portalsMap.clear();
            portalManager.destroy();
        }
    };
};

});
parcelRegister("hUHRU", function(module, exports) {
$parcel$export(module.exports, "PortalBucket", () => $564ebff32eef59b5$export$828f0f29e8293a07);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $564ebff32eef59b5$export$828f0f29e8293a07({ id: id, portalManager: portalManager }) {
    // State to hold the current portals for this bucket
    const [portals, setPortals] = (0, $eJOHy.useState)({});
    // Effect to register/unregister this bucket with the portal manager on mount/unmount
    (0, $eJOHy.useLayoutEffect)(()=>{
        portalManager.registerBucket(id, setPortals);
        return ()=>{
            portalManager.unregisterBucket(id);
        };
    }, [
        id,
        portalManager
    ]);
    // Memoize the portal elements to avoid unnecessary re-renders
    const portalElements = (0, $eJOHy.useMemo)(()=>Object.values(portals), [
        portals
    ]);
    // Render the current portal elements
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: portalElements
    });
}

});


parcelRegister("fn460", function(module, exports) {
$parcel$export(module.exports, "PortalManager", () => $20f010b4fef23297$export$52c7ef79917c2f38);

var $6DCNy = parcelRequire("6DCNy");

var $cbSL1 = parcelRequire("cbSL1");
const $20f010b4fef23297$var$DEFAULT_INITIAL_BUCKETS = 50;
const $20f010b4fef23297$var$DEFAULT_MAX_BUCKET_CAPACITY = 50;
const $20f010b4fef23297$var$DEFAULT_SCALE_RATIO = 0.5;
const $20f010b4fef23297$var$DEFAULT_THROTTLE_DELAY = 16; // ~60fps for smooth updates
/**
 * Creates an empty bucket object with a specified capacity. Each bucket is designed
 * to hold a certain number of React portals and has an associated updater function
 * which can be null initially.
 *
 * @function createEmptyBucket
 * @param {number} capacity - The maximum capacity of the bucket.
 * @returns {PortalBucketType} An object representing an empty bucket with the specified capacity.
 */ function $20f010b4fef23297$var$createEmptyBucket(capacity) {
    return {
        portals: {},
        capacity: capacity,
        updater: null
    };
}
class $20f010b4fef23297$export$52c7ef79917c2f38 {
    constructor(initialBuckets = $20f010b4fef23297$var$DEFAULT_INITIAL_BUCKETS, maxBucketCapacity = $20f010b4fef23297$var$DEFAULT_MAX_BUCKET_CAPACITY, scaleRatio = $20f010b4fef23297$var$DEFAULT_SCALE_RATIO, throttleDelay = $20f010b4fef23297$var$DEFAULT_THROTTLE_DELAY){
        /**
	 * Controls whether to use throttled updates or immediate synchronous updates.
	 * During initial load, we use synchronous updates to avoid delays and ensure immediate responsiveness.
	 * After the initial load period (one RAF cycle), we switch to throttled updates for better performance.
	 */ this.shouldUseThrottledUpdates = false;
        this.maxBucketCapacity = maxBucketCapacity;
        this.scaleRatio = scaleRatio;
        this.throttleDelay = throttleDelay;
        // Initialise buckets array by creating an array of length `initialBuckets` containing empty buckets
        this.buckets = Array.from({
            length: initialBuckets
        }, ()=>$20f010b4fef23297$var$createEmptyBucket(maxBucketCapacity));
        this.portalToBucketMap = new Map();
        this.availableBuckets = new Set(Array.from({
            length: initialBuckets
        }, (_, i)=>i));
        this.portalRendererUpdater = null;
        this.scaleCapacityThreshold = maxBucketCapacity / 2;
        this.throttledBucketUpdaters = new Map();
    }
    getCurrentBucket() {
        return this.availableBuckets.values().next().value;
    }
    createBucket() {
        const currentBucket = this.getCurrentBucket();
        //If the current bucket has capacity, skip this logic
        // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
        if (this.buckets[currentBucket].capacity > 0) return;
        else // The current bucket is full, delete the bucket from the list of available buckets
        // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
        this.availableBuckets.delete(currentBucket);
        // Skip creating new bucket if there are buckets still available
        if (this.availableBuckets.size > 0) return;
        // Scale the buckets up only if there are no available buckets left
        // Calculate how many new buckets need to be added
        const numBucketsToAdd = Math.floor(this.buckets.length * this.scaleRatio);
        this.buckets = [
            ...this.buckets
        ];
        for(let i = 0; i < numBucketsToAdd; i++){
            this.buckets.push($20f010b4fef23297$var$createEmptyBucket(this.maxBucketCapacity));
            this.availableBuckets.add(this.buckets.length - 1);
        }
        this.portalRendererUpdater?.(this.buckets);
    }
    getOrCreateThrottledUpdater(id) {
        if (!this.throttledBucketUpdaters.has(id)) {
            const throttledUpdater = (0, (/*@__PURE__*/$parcel$interopDefault($6DCNy)))(()=>{
                this.buckets[id]?.updater?.(()=>({
                        ...this.buckets[id].portals
                    }));
            }, this.throttleDelay);
            this.throttledBucketUpdaters.set(id, throttledUpdater);
        }
        return this.throttledBucketUpdaters.get(id);
    }
    getBuckets() {
        return this.buckets;
    }
    registerBucket(id, updater) {
        this.buckets[id].updater = updater;
        this.buckets[id].updater?.(()=>({
                ...this.buckets[id].portals
            }));
    }
    unregisterBucket(id) {
        this.buckets[id].updater = null;
        // Clean up throttled updater when bucket is unregistered
        if (this.throttledBucketUpdaters.has(id)) {
            this.throttledBucketUpdaters.get(id)?.cancel();
            this.throttledBucketUpdaters.delete(id);
        }
    }
    updateBuckets(id, immediate = false) {
        if (!this.throttleActivationRAFId && (0, $cbSL1.expValEquals)('platform_editor_debounce_portal_provider', 'isEnabled', true)) this.throttleActivationRAFId = requestAnimationFrame(()=>{
            this.shouldUseThrottledUpdates = true;
        });
        if (immediate || !this.shouldUseThrottledUpdates || !(0, $cbSL1.expValEquals)('platform_editor_debounce_portal_provider', 'isEnabled', true)) {
            // Cancel any pending throttled update and update immediately
            if (this.throttledBucketUpdaters.has(id)) this.throttledBucketUpdaters.get(id)?.cancel();
            this.buckets[id].updater?.(()=>({
                    ...this.buckets[id].portals
                }));
        } else // Use throttled update for smooth, regular updates
        this.getOrCreateThrottledUpdater(id)?.();
    }
    registerPortal(key, portal, immediate = false) {
        this.createBucket();
        // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
        this.buckets[this.getCurrentBucket()].capacity -= 1;
        const id = this.portalToBucketMap.get(key) ?? this.getCurrentBucket();
        // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
        this.portalToBucketMap.set(key, id);
        // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
        if (this.buckets[id].portals[key] !== portal) {
            // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
            this.buckets[id].portals[key] = portal;
            // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
            this.updateBuckets(id, immediate);
        }
        //returns a function to unregister the portal
        return ()=>{
            // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
            delete this.buckets[id].portals[key];
            this.portalToBucketMap.delete(key);
            // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
            this.buckets[id].capacity += 1;
            // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
            if (this.buckets[id].capacity > this.scaleCapacityThreshold) // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
            this.availableBuckets.add(id);
            // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
            this.updateBuckets(id, immediate);
        };
    }
    registerPortalRenderer(updater) {
        if (!this.portalRendererUpdater) updater(()=>this.buckets);
        this.portalRendererUpdater = updater;
    }
    unregisterPortalRenderer() {
        this.portalRendererUpdater = null;
    }
    /**
	 * Cleans up resources used by the PortalManager. This includes clearing all portals,
	 * unregistering all buckets, and resetting internal state.
	 */ destroy() {
        // Cancel all pending throttled updates
        this.throttledBucketUpdaters.forEach((updater)=>{
            updater.cancel();
        });
        this.throttledBucketUpdaters.clear();
        // Iterate through each bucket and clear its portals and unset the updater function
        this.buckets.forEach((bucket, id)=>{
            bucket.portals = {}; // Clearing all portals from the bucket
            bucket.updater = null; // Unsetting the bucket's updater function
            this.availableBuckets.add(id); // Mark all buckets as available
        });
        this.portalToBucketMap.clear();
        this.portalRendererUpdater = null;
        this.availableBuckets = new Set(this.buckets.map((_, index)=>index));
    }
}

});


parcelRegister("8kDPZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $b525350fd30c7c95$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $bMFKb = parcelRequire("bMFKb");
var $cd124 = parcelRequire("cd124");

var $eemFN = parcelRequire("eemFN");

var $jjlK8 = parcelRequire("jjlK8");

var $djRdf = parcelRequire("djRdf");

var $6L9Sq = parcelRequire("6L9Sq");

var $52SlE = parcelRequire("52SlE");
class $b525350fd30c7c95$export$d6d3bedcc5fc09c8 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            rethrow: true,
            errorTracking: true
        };
    }
    constructor(props){
        super(props), this.browserExtensions = undefined, this.state = {
            error: undefined
        }, this.sendErrorData = async (analyticsErrorPayload)=>{
            const product = await this.getProductName();
            const { error: error, errorInfo: errorInfo } = analyticsErrorPayload;
            const sharedId = (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))();
            const browserInfo = window?.navigator?.userAgent || 'unknown';
            const attributes = {
                product: product,
                browserInfo: browserInfo,
                error: error.toString(),
                errorInfo: errorInfo,
                errorId: sharedId,
                browserExtensions: this.browserExtensions,
                docStructure: this.featureFlags.errorBoundaryDocStructure && this.props.editorView ? (0, $eemFN.getDocStructure)(this.props.editorView.state.doc, {
                    compact: true
                }) : undefined,
                outdatedBrowser: (0, $6L9Sq.isOutdatedBrowser)(browserInfo)
            };
            this.fireAnalyticsEvent({
                action: (0, $bMFKb.ACTION).EDITOR_CRASHED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
                eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
                attributes: attributes
            });
            this.fireAnalyticsEvent({
                action: (0, $bMFKb.ACTION).EDITOR_CRASHED_ADDITIONAL_INFORMATION,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
                eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorId: sharedId
                }
            });
            (0, $djRdf.logException)(error, {
                location: 'editor-core/create-editor',
                product: product
            });
        }, this.getProductName = async ()=>{
            const { contextIdentifierProvider: contextIdentifierProvider } = this.props;
            if (contextIdentifierProvider) {
                const context = await contextIdentifierProvider;
                if (context.product) return context.product;
            }
            return 'atlaskit';
        }, this.fireAnalyticsEvent = (event)=>{
            this.props.createAnalyticsEvent?.(event).fire((0, $cd124.editorAnalyticsChannel));
        };
        this.featureFlags = props.featureFlags;
    }
    componentDidCatch(error, errorInfo) {
        // Only report and re-render once, to avoid over-reporting errors and infinite rerendering
        if (this.state.error) return;
        if (this.props.errorTracking) this.sendErrorData({
            error: error,
            errorInfo: errorInfo,
            errorStack: error.stack
        });
        // Update state to allow a re-render to attempt graceful recovery (in the event that
        // the error was caused by a race condition or is intermittent)
        this.setState({
            error: error
        }, ()=>{
            if (this.props.rethrow) // Now that a re-render has occurred, we re-throw to allow product error boundaries
            // to catch and handle the error too.
            //
            // Note that when rethrowing inside a error boundary, the stack trace
            // from a higher error boundary's componentDidCatch.info param will reset
            // to this component, instead of the original component which threw it.
            throw error;
        });
    }
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // FIXME: This is causing more problems then it's solving. The async check to sniff the browser extensions is block some
    // react unit tests. Essentially jest never completes and just hangs. This was code was added 3yrs ago so that errors
    // would detail if the browser had grammarly extension installed or not. I'm not sure if anyone has every inspecting this
    // as it doesn't look like any dashboards exist for it.
    // You can see the open handles that are block tests if you run unit tests with --detectOpenHandles
    // async componentDidMount() {
    // 	this.browserExtensions = await sniffUserBrowserExtensions({
    // 		extensions: ['grammarly'],
    // 		async: true,
    // 		asyncTimeoutMs: 20000,
    // 	});
    // }
    render() {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jjlK8.IntlErrorBoundary), {
            children: this.props.children
        });
    }
}
var $b525350fd30c7c95$export$2e2bcd8739ae039 = (0, $52SlE.WithEditorView)($b525350fd30c7c95$export$d6d3bedcc5fc09c8);

});
parcelRegister("eemFN", function(module, exports) {
$parcel$export(module.exports, "getDocStructure", () => $d9ff8bf4a728f56a$export$6451b72139862cbd);
const $d9ff8bf4a728f56a$var$hash = {
    nodes: {
        doc: 'doc',
        paragraph: 'p',
        text: 't',
        bulletList: 'ul',
        orderedList: 'ol',
        listItem: 'li',
        heading: 'h',
        blockquote: 'blockq',
        codeBlock: 'codebl',
        panel: 'pnl',
        rule: 'rl',
        hardBreak: 'br',
        mention: 'ment',
        emoji: 'emj',
        image: 'img',
        caption: 'cap',
        media: 'media',
        mediaGroup: 'mediag',
        mediaSingle: 'medias',
        plain: 'pln',
        table: 'table',
        tableCell: 'td',
        tableHeader: 'th',
        tableRow: 'tr',
        decisionList: 'dl',
        decisionItem: 'di',
        taskList: 'tl',
        taskItem: 'ti',
        extension: 'ext',
        inlineExtension: 'exti',
        bodiedExtension: 'extb',
        multiBodiedExtension: 'extmbe',
        extensionFrame: 'extfrm',
        status: 'sts',
        placeholder: 'plh',
        inlineCard: 'cardi',
        blockCard: 'cardb',
        embedCard: 'carde',
        expand: 'exp',
        nestedExpand: 'expn',
        unsupportedBlock: 'unsupb',
        unsupportedInline: 'unsupi',
        unknownBlock: 'unkb',
        date: 'date'
    },
    marks: {
        em: 'em',
        strong: 'strong',
        code: 'code',
        strike: 'strike',
        underline: 'undline',
        link: 'lnk',
        subsup: 'subsup',
        textColor: 'txtclr',
        unsupportedMark: 'unsupmrk',
        unsupportedNodeAttribute: 'unsupnattr',
        annotation: 'anno'
    }
};
function $d9ff8bf4a728f56a$var$shortHash(type, isMark) {
    const code = $d9ff8bf4a728f56a$var$hash[isMark ? 'marks' : 'nodes'][type];
    return code ? code : type;
}
function $d9ff8bf4a728f56a$var$compactStringifier(node) {
    const isContentEmpty = !node.content;
    const isTextNode = node?.type === 'text';
    const hasMarks = node.marks?.length;
    const isContentArray = Array.isArray(node.content);
    const marks = (child)=>{
        if (hasMarks) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return node.marks.reduce((str, mark)=>`${$d9ff8bf4a728f56a$var$shortHash(mark, true)}(${str})`, child);
        return child;
    };
    let content;
    if (isTextNode) content = String(node.nodeSize);
    else if (isContentEmpty) content = '';
    else if (isContentArray) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    content = node.content.map((node)=>$d9ff8bf4a728f56a$var$compactStringifier(node)).join(',');
    return marks(`${$d9ff8bf4a728f56a$var$shortHash(node.type, false)}(${content})`);
}
const $d9ff8bf4a728f56a$export$6451b72139862cbd = (doc, options)=>{
    try {
        const result = $d9ff8bf4a728f56a$var$getBlockNode(doc, 0);
        if (options?.compact) return $d9ff8bf4a728f56a$var$compactStringifier(result);
        return result;
    } catch (error) {
        return `Error logging document structure: ${error}`;
    }
};
const $d9ff8bf4a728f56a$var$getBlockNode = (node, pos)=>{
    const blockNode = {
        type: node.type.name,
        pos: pos,
        nodeSize: node.nodeSize
    };
    const content = $d9ff8bf4a728f56a$var$getBlockNodeContent(node.content, pos);
    if (content.length > 0) blockNode.content = content;
    const marks = $d9ff8bf4a728f56a$var$getMarks(node);
    if (marks.length > 0) blockNode.marks = marks;
    return blockNode;
};
const $d9ff8bf4a728f56a$var$getBlockNodeContent = (node, pos)=>{
    if (!node || !node.content || !node.content.length) return [];
    let blockNodeContent = [];
    const { content: content } = node;
    if (content[0].isBlock) {
        // children are block nodes
        let prevNode;
        blockNodeContent = content.map((node)=>{
            pos += prevNode ? prevNode.nodeSize : 1;
            prevNode = node;
            return $d9ff8bf4a728f56a$var$getBlockNode(node, pos);
        });
    } else {
        // children are inline nodes .
        const result = $d9ff8bf4a728f56a$var$getInlineNodes(content, pos);
        blockNodeContent = result.inlineNodes;
        pos = result.pos;
    }
    return blockNodeContent;
};
const $d9ff8bf4a728f56a$var$getInlineNodes = (nodes, pos)=>{
    const inlineNodes = nodes.map((node)=>{
        const { nodeSize: nodeSize } = node;
        const inlineNode = {
            type: node.type.name,
            pos: pos,
            nodeSize: nodeSize
        };
        const marks = $d9ff8bf4a728f56a$var$getMarks(node);
        if (marks.length > 0) inlineNode.marks = marks;
        pos += nodeSize;
        return inlineNode;
    });
    return {
        inlineNodes: inlineNodes,
        pos: pos
    };
};
const $d9ff8bf4a728f56a$var$getMarks = (node)=>node.marks.map((mark)=>mark.type.name);

});

parcelRegister("6L9Sq", function(module, exports) {
$parcel$export(module.exports, "isOutdatedBrowser", () => $93aebe4619b5fb8c$export$12d09524e028927);
const $93aebe4619b5fb8c$export$12d09524e028927 = (userAgent)=>{
    // Take browsers in both Desktop and Mobile (includes Chrome, Firefox, Edge and Safari) within last 2 years
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const chrome = /Chrome\//.test(userAgent) && !/OPR\//.test(userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const chromeVersion = chrome ? parseInt((userAgent.match(/Chrome\/(\d+)/) || [])[1], 10) : 0;
    if (chromeVersion >= 84) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const gecko = /gecko\/\d/i.test(userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const geckoVersion = gecko ? parseInt((userAgent.match(/Firefox\/(\d+)/) || [])[1], 10) : 0;
    if (geckoVersion >= 84) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const edge = /Edge\/(\d+)/.exec(userAgent);
    const edgeVersion = edge ? +edge[1] : 0;
    if (edgeVersion >= 84) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const safari = !chrome && !gecko && /Version\/([0-9\._]+).*Safari/.test(userAgent);
    const safariVersion = safari ? // eslint-disable-next-line require-unicode-regexp
    parseInt((userAgent.match(/Version\/([0-9\._]+).*Safari/) || [])[1], 10) : 0;
    if (safariVersion >= 12) return false;
    return true;
};

});

parcelRegister("52SlE", function(module, exports) {
$parcel$export(module.exports, "WithEditorView", () => $e8537f9f2fd3cf1d$export$cf381084b490bd31);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kCWwL = parcelRequire("kCWwL");
const $e8537f9f2fd3cf1d$export$cf381084b490bd31 = (WrappedComponent)=>{
    const _WithFeatureFlags = (props)=>{
        const { editorActions: editorActions } = (0, $kCWwL.useEditorContext)();
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
            ...props,
            editorView: editorActions?._privateGetEditorView()
        }));
    };
    return _WithFeatureFlags;
};

});


parcelRegister("jLBRN", function(module, exports) {
$parcel$export(module.exports, "ReactEditorView", () => $97220bff0cbd31bb$export$e7d1b1cbca007e16);
$parcel$export(module.exports, "default", () => $97220bff0cbd31bb$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6YFG2 = parcelRequire("6YFG2");

var $8KLBw = parcelRequire("8KLBw");

var $bMFKb = parcelRequire("bMFKb");
var $cd124 = parcelRequire("cd124");
var $8MfCL = parcelRequire("8MfCL");

var $fNh22 = parcelRequire("fNh22");

var $aoyv9 = parcelRequire("aoyv9");

var $2Kn3g = parcelRequire("2Kn3g");
var $5ZVTg = parcelRequire("5ZVTg");

var $elRHR = parcelRequire("elRHR");

var $jgFE8 = parcelRequire("jgFE8");

var $65rqJ = parcelRequire("65rqJ");

var $Sk9g1 = parcelRequire("Sk9g1");

var $dTLXq = parcelRequire("dTLXq");

var $51k6y = parcelRequire("51k6y");

var $g9imq = parcelRequire("g9imq");

var $dyNYh = parcelRequire("dyNYh");

var $bnAxN = parcelRequire("bnAxN");

var $3lIcL = parcelRequire("3lIcL");

var $b7EWj = parcelRequire("b7EWj");

var $eGOwo = parcelRequire("eGOwo");

var $2QO3b = parcelRequire("2QO3b");

var $cbSL1 = parcelRequire("cbSL1");

var $g6YpQ = parcelRequire("g6YpQ");

var $jy3uD = parcelRequire("jy3uD");

var $hUQD4 = parcelRequire("hUQD4");

var $4wM3w = parcelRequire("4wM3w");

var $9SjCv = parcelRequire("9SjCv");

var $7uu4v = parcelRequire("7uu4v");

var $i5btK = parcelRequire("i5btK");

var $1ZFgR = parcelRequire("1ZFgR");


var $20Ctl = parcelRequire("20Ctl");

var $lAhIB = parcelRequire("lAhIB");

var $3bqXX = parcelRequire("3bqXX");

var $erdK2 = parcelRequire("erdK2");

var $jGMZf = parcelRequire("jGMZf");

var $aHrTy = parcelRequire("aHrTy");

var $YsDKQ = parcelRequire("YsDKQ");

var $l9xeW = parcelRequire("l9xeW");

var $2afhI = parcelRequire("2afhI");
const $97220bff0cbd31bb$var$EDIT_AREA_ID = 'ak-editor-textarea';
function $97220bff0cbd31bb$export$e7d1b1cbca007e16(props) {
    const { preset: preset, editorProps: { appearance: nextAppearance, disabled: disabled, featureFlags: editorPropFeatureFlags, errorReporterHandler: errorReporterHandler, defaultValue: defaultValue, shouldFocus: shouldFocus, __livePage: __livePage }, onEditorCreated: onEditorCreated, onEditorDestroyed: onEditorDestroyed } = props;
    const [editorAPI, setEditorAPI] = (0, $eJOHy.useState)(undefined);
    const editorRef = (0, $eJOHy.useRef)(null);
    const viewRef = (0, $eJOHy.useRef)();
    const focusTimeoutId = (0, $eJOHy.useRef)();
    // ProseMirror is instantiated prior to the initial React render cycle,
    // so we allow transactions by default, to avoid discarding the initial one.
    const canDispatchTransactions = (0, $eJOHy.useRef)(true);
    const editorId = (0, $eJOHy.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))());
    const eventDispatcher = (0, $eJOHy.useMemo)(()=>new (0, $aoyv9.EventDispatcher)(), []);
    const config = (0, $eJOHy.useRef)({
        nodes: [],
        marks: [],
        pmPlugins: [],
        contentComponents: [],
        pluginHooks: [],
        primaryToolbarComponents: [],
        secondaryToolbarComponents: [],
        onEditorViewStateUpdatedCallbacks: []
    });
    const contentTransformer = (0, $eJOHy.useRef)(undefined);
    const featureFlags = (0, $eJOHy.useMemo)(()=>(0, $hUQD4.createFeatureFlagsFromProps)(editorPropFeatureFlags), [
        editorPropFeatureFlags
    ]);
    const getEditorState = (0, $eJOHy.useCallback)(()=>viewRef.current?.state, []);
    const getEditorView = (0, $eJOHy.useCallback)(()=>viewRef.current, []);
    const dispatch = (0, $eJOHy.useMemo)(()=>(0, $aoyv9.createDispatch)(eventDispatcher), [
        eventDispatcher
    ]);
    const errorReporter = (0, $eJOHy.useMemo)(()=>(0, $20Ctl.createErrorReporter)(errorReporterHandler), [
        errorReporterHandler
    ]);
    const handleAnalyticsEvent = (0, $eJOHy.useCallback)((payload)=>{
        (0, $cd124.fireAnalyticsEvent)(props.createAnalyticsEvent)(payload);
    }, [
        props.createAnalyticsEvent
    ]);
    const dispatchAnalyticsEvent = (0, $eJOHy.useCallback)((payload)=>{
        const dispatch = (0, $aoyv9.createDispatch)(eventDispatcher);
        dispatch((0, $dyNYh.analyticsEventKey), {
            payload: payload
        });
    }, [
        eventDispatcher
    ]);
    const pluginInjectionAPI = (0, $eJOHy.useRef)(new (0, $dTLXq.EditorPluginInjectionAPI)({
        getEditorState: getEditorState,
        getEditorView: getEditorView,
        fireAnalyticsEvent: handleAnalyticsEvent
    }));
    const createEditorState = (0, $eJOHy.useCallback)((options)=>{
        let schema;
        if (viewRef.current) {
            if (options.resetting) /**
					 * ReactEditorView currently does NOT handle dynamic schema,
					 * We are reusing the existing schema, and rely on #reconfigureState
					 * to update `this.config`
					 */ schema = viewRef.current.state.schema;
            else {
                /**
					 * There's presently a number of issues with changing the schema of a
					 * editor inflight. A significant issue is that we lose the ability
					 * to keep track of a user's history as the internal plugin state
					 * keeps a list of Steps to undo/redo (which are tied to the schema).
					 * Without a good way to do work around this, we prevent this for now.
					 */ // eslint-disable-next-line no-console
                console.warn('The editor does not support changing the schema dynamically.');
                return viewRef.current.state;
            }
        } else {
            config.current = (0, $20Ctl.processPluginsList)((0, $lAhIB.default)(options.props.preset, props.editorProps, pluginInjectionAPI.current));
            schema = (0, $3bqXX.createSchema)(config.current);
            setEditorAPI(pluginInjectionAPI.current.api());
        }
        const { contentTransformerProvider: contentTransformerProvider } = options.props.editorProps;
        const plugins = (0, $20Ctl.createPMPlugins)({
            schema: schema,
            dispatch: dispatch,
            errorReporter: errorReporter,
            editorConfig: config.current,
            eventDispatcher: eventDispatcher,
            providerFactory: options.props.providerFactory,
            portalProviderAPI: props.portalProviderAPI,
            nodeViewPortalProviderAPI: props.nodeViewPortalProviderAPI,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            featureFlags: featureFlags,
            getIntl: ()=>props.intl,
            onEditorStateUpdated: pluginInjectionAPI.current.onEditorViewUpdated
        });
        contentTransformer.current = contentTransformerProvider ? contentTransformerProvider(schema) : undefined;
        const api = pluginInjectionAPI.current.api();
        // If we have a doc prop, we need to process it into a PMNode
        let doc;
        if (options.doc) {
            // if the collabEdit API is set, skip this validation due to potential pm validation errors
            // from docs that end up with invalid marks after processing (See #hot-111702 for more details)
            if (api?.collabEdit !== undefined || options.props.editorProps.skipValidation) doc = (0, $51k6y.processRawValueWithoutValidation)(schema, options.doc, dispatchAnalyticsEvent);
            else doc = (0, $51k6y.processRawValue)(schema, options.doc, options.props.providerFactory, options.props.editorProps.sanitizePrivateContent, contentTransformer.current, dispatchAnalyticsEvent);
        }
        const isViewMode = api?.editorViewMode?.sharedState.currentState().mode === 'view';
        let selection;
        if (doc) {
            if (isViewMode) {
                const emptySelection = new (0, $3lIcL.TextSelection)(doc.resolve(0));
                return (0, $3lIcL.EditorState).create({
                    schema: schema,
                    plugins: plugins,
                    doc: doc,
                    selection: emptySelection
                });
            } else selection = options.selectionAtStart ? (0, $3lIcL.Selection).atStart(doc) : (0, $3lIcL.Selection).atEnd(doc);
        }
        // Workaround for ED-3507: When media node is the last element, scrollIntoView throws an error
        const patchedSelection = selection ? (0, $3lIcL.Selection).findFrom(selection.$head, -1, true) || undefined : undefined;
        return (0, $3lIcL.EditorState).create({
            schema: schema,
            plugins: plugins,
            doc: doc,
            selection: patchedSelection
        });
    }, [
        errorReporter,
        featureFlags,
        props.intl,
        props.portalProviderAPI,
        props.nodeViewPortalProviderAPI,
        props.editorProps,
        dispatchAnalyticsEvent,
        eventDispatcher,
        dispatch
    ]);
    const initialEditorState = (0, $eJOHy.useMemo)(()=>createEditorState({
            props: props,
            doc: defaultValue,
            // ED-4759: Don't set selection at end for full-page editor - should be at start.
            selectionAtStart: (0, $7uu4v.isFullPage)(nextAppearance)
        }), // This is only used for the initial state - afterwards we will have `viewRef` available for use
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const getCurrentEditorState = (0, $eJOHy.useCallback)(()=>{
        return viewRef.current?.state ?? initialEditorState;
    }, [
        initialEditorState
    ]);
    const blur = (0, $eJOHy.useCallback)(()=>{
        if (!viewRef.current) return;
        if (viewRef.current.dom instanceof HTMLElement && viewRef.current.hasFocus()) viewRef.current.dom.blur();
        // The selectionToDOM method uses the document selection to determine currently selected node
        // We need to mimic blurring this as it seems doing the above is not enough.
        // @ts-expect-error
        const sel = viewRef.current.root.getSelection();
        if (sel) sel.removeAllRanges();
    }, []);
    const resetEditorState = (0, $eJOHy.useCallback)(({ doc: doc, shouldScrollToBottom: shouldScrollToBottom })=>{
        if (!viewRef.current) return;
        // We cannot currently guarantee when all the portals will have re-rendered during a reconfigure
        // so we blur here to stop ProseMirror from trying to apply selection to detached nodes or
        // nodes that haven't been re-rendered to the document yet.
        blur();
        const newEditorState = createEditorState({
            props: props,
            doc: doc,
            resetting: true,
            selectionAtStart: !shouldScrollToBottom
        });
        viewRef.current.updateState(newEditorState);
        props.editorProps.onChange?.(viewRef.current, {
            source: 'local',
            isDirtyChange: false
        });
    }, [
        blur,
        createEditorState,
        props
    ]);
    // Initialise phase
    // Using constructor hook so we setup and dispatch analytics before anything else
    (0, $2Kn3g.default)(()=>{
        // This needs to be before initialising editorState because
        // we dispatch analytics events in plugin initialisation
        eventDispatcher.on((0, $dyNYh.analyticsEventKey), handleAnalyticsEvent);
        eventDispatcher.on('resetEditorState', resetEditorState);
        dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).STARTED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
            attributes: {
                platform: (0, $8MfCL.PLATFORMS).WEB,
                featureFlags: featureFlags ? (0, $jgFE8.getEnabledFeatureFlagKeys)(featureFlags) : [],
                accountLocale: props.intl?.locale,
                browserLocale: window.navigator.language
            },
            eventType: (0, $bMFKb.EVENT_TYPE).UI
        });
    });
    (0, $eJOHy.useLayoutEffect)(()=>{
        // Transaction dispatching is already enabled by default prior to
        // mounting, but we reset it here, just in case the editor view
        // instance is ever recycled (mounted again after unmounting) with
        // the same key.
        // AND since React 18 effects may run multiple times so we need to ensure
        // this is reset so that transactions are still allowed.
        // Although storing mounted state is an anti-pattern in React,
        // we do so here so that we can intercept and abort asynchronous
        // ProseMirror transactions when a dismount is imminent.
        canDispatchTransactions.current = true;
        return ()=>{
            // We can ignore any transactions from this point onwards.
            // This serves to avoid potential runtime exceptions which could arise
            // from an async dispatched transaction after it's unmounted.
            canDispatchTransactions.current = false;
        };
    }, []);
    // Cleanup
    (0, $eJOHy.useLayoutEffect)(()=>{
        return ()=>{
            const focusTimeoutIdCurrent = focusTimeoutId.current;
            if (focusTimeoutIdCurrent) clearTimeout(focusTimeoutIdCurrent);
            if (viewRef.current) {
                // Destroy the state if the Editor is being unmounted
                const editorState = viewRef.current.state;
                editorState.plugins.forEach((plugin)=>{
                    const state = plugin.getState(editorState);
                    if (state && state.destroy) state.destroy();
                });
            }
            eventDispatcher.destroy();
        // this.view will be destroyed when React unmounts in handleEditorViewRef
        };
    }, [
        eventDispatcher
    ]);
    const reconfigureState = (0, $eJOHy.useCallback)((props)=>{
        if (!viewRef.current) return;
        // We cannot currently guarantee when all the portals will have re-rendered during a reconfigure
        // so we blur here to stop ProseMirror from trying to apply selection to detached nodes or
        // nodes that haven't been re-rendered to the document yet.
        blur();
        const editorPlugins = (0, $lAhIB.default)(props.preset, props.editorProps, pluginInjectionAPI.current);
        config.current = (0, $20Ctl.processPluginsList)(editorPlugins);
        const state = viewRef.current.state;
        const plugins = (0, $20Ctl.createPMPlugins)({
            schema: state.schema,
            dispatch: dispatch,
            errorReporter: errorReporter,
            editorConfig: config.current,
            eventDispatcher: eventDispatcher,
            providerFactory: props.providerFactory,
            portalProviderAPI: props.portalProviderAPI,
            nodeViewPortalProviderAPI: props.nodeViewPortalProviderAPI,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            featureFlags: featureFlags,
            getIntl: ()=>props.intl,
            onEditorStateUpdated: pluginInjectionAPI.current.onEditorViewUpdated
        });
        const newState = state.reconfigure({
            plugins: plugins
        });
        // need to update the state first so when the view builds the nodeviews it is
        // using the latest plugins
        viewRef.current.updateState(newState);
        return viewRef.current.update({
            ...viewRef.current.props,
            state: newState
        });
    }, [
        blur,
        dispatchAnalyticsEvent,
        eventDispatcher,
        dispatch,
        errorReporter,
        featureFlags
    ]);
    const onEditorViewUpdated = (0, $eJOHy.useCallback)(({ originalTransaction: originalTransaction, transactions: transactions, oldEditorState: oldEditorState, newEditorState: newEditorState })=>{
        config.current?.onEditorViewStateUpdatedCallbacks.forEach((entry)=>{
            entry.callback({
                originalTransaction: originalTransaction,
                transactions: transactions,
                oldEditorState: oldEditorState,
                newEditorState: newEditorState
            });
        });
    }, []);
    const dispatchTransaction = (0, $l9xeW.useDispatchTransaction)({
        onChange: props.editorProps.onChange,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        onEditorViewUpdated: onEditorViewUpdated,
        isRemoteReplaceDocumentTransaction: pluginInjectionAPI.current.api()?.collabEdit?.actions?.isRemoteReplaceDocumentTransaction
    });
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Remove these when we deprecate these props from editor-props - smartLinks is unfortunately still used in some places, we can sidestep this problem if we move everyone across to ComposableEditor and deprecate Editor
    const UNSAFE_cards = props.editorProps.UNSAFE_cards;
    const smartLinks = props.editorProps.smartLinks;
    // Temporary to replace provider factory while migration to `ComposableEditor` occurs
    (0, $jy3uD.useProviders)({
        editorApi: editorAPI,
        contextIdentifierProvider: props.editorProps.contextIdentifierProvider,
        mediaProvider: props.editorProps.media?.provider,
        mentionProvider: props.editorProps.mentionProvider,
        cardProvider: props.editorProps.linking?.smartLinks?.provider || smartLinks && smartLinks.provider || UNSAFE_cards && UNSAFE_cards.provider,
        emojiProvider: props.editorProps.emojiProvider,
        autoformattingProvider: props.editorProps.autoformattingProvider,
        taskDecisionProvider: props.editorProps.taskDecisionProvider
    });
    const getDirectEditorProps = (0, $eJOHy.useCallback)((state)=>{
        return {
            state: state ?? getCurrentEditorState(),
            dispatchTransaction: (tr)=>{
                // Block stale transactions:
                // Prevent runtime exceptions from async transactions that would attempt to
                // update the DOM after React has unmounted the Editor.
                if (canDispatchTransactions.current) dispatchTransaction(viewRef.current, tr);
            },
            // Disables the contentEditable attribute of the editor if the editor is disabled
            editable: (_state)=>!disabled,
            attributes: {
                'data-gramm': 'false'
            }
        };
    }, [
        dispatchTransaction,
        disabled,
        getCurrentEditorState
    ]);
    const createEditorView = (0, $eJOHy.useCallback)((node)=>{
        // Creates the editor-view from this.editorState. If an editor has been mounted
        // previously, this will contain the previous state of the editor.
        const view = new (0, $b7EWj.EditorView)({
            mount: node
        }, getDirectEditorProps());
        viewRef.current = view;
        (0, $65rqJ.measureRender)((0, $1ZFgR.default).PROSEMIRROR_RENDERED, ({ duration: duration, startTime: startTime, distortedDuration: distortedDuration })=>{
            const proseMirrorRenderedSeverity = (0, $dyNYh.getAnalyticsEventSeverity)(duration, (0, $96851126f0c152a2$export$646a6982857f2cd5), (0, $96851126f0c152a2$export$79d7eac6cbb6352d));
            if (viewRef.current) {
                const nodes = (0, $4wM3w.getNodesCount)(viewRef.current.state.doc);
                const ttfb = (0, $Sk9g1.getResponseEndTime)();
                const contextIdentifier = pluginInjectionAPI.current.api().base?.sharedState.currentState();
                const nodesInViewport = (0, $9SjCv.getNodesVisibleInViewport)(viewRef.current.dom);
                const nodeSize = viewRef.current.state.doc.nodeSize;
                const { totalNodes: totalNodes, nodeSizeBucket: nodeSizeBucket } = (0, $cbSL1.expValEquals)('cc_editor_insm_doc_size_stats', 'isEnabled', true) ? {
                    totalNodes: Object.values(nodes).reduce((acc, curr)=>acc + curr, 0),
                    // Computed on client for dimension bucketing in Statsig
                    nodeSizeBucket: (()=>{
                        switch(true){
                            case nodeSize < 10000:
                                return '<10000';
                            case nodeSize < 20000:
                                return '<20000';
                            case nodeSize < 30000:
                                return '<30000';
                            case nodeSize < 40000:
                                return '<40000';
                            case nodeSize < 50000:
                                return '<50000';
                            default:
                                return '50000+';
                        }
                    })()
                } : {};
                dispatchAnalyticsEvent({
                    action: (0, $bMFKb.ACTION).PROSEMIRROR_RENDERED,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
                    attributes: {
                        duration: duration,
                        startTime: startTime,
                        nodes: nodes,
                        nodesInViewport: nodesInViewport,
                        nodeSize: nodeSize,
                        nodeSizeBucket: nodeSizeBucket,
                        totalNodes: totalNodes,
                        ttfb: ttfb,
                        severity: proseMirrorRenderedSeverity,
                        objectId: contextIdentifier?.objectId,
                        distortedDuration: distortedDuration
                    },
                    eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
                });
            }
        });
        pluginInjectionAPI.current.onEditorViewUpdated({
            newEditorState: viewRef.current.state,
            oldEditorState: undefined
        });
        return view;
    }, [
        getDirectEditorProps,
        dispatchAnalyticsEvent
    ]);
    const [editorView, setEditorView] = (0, $eJOHy.useState)(undefined);
    // Detects if the editor is nested inside an extension - ie. it is a Legacy Content Extension (LCE)
    const isNestedEditor = (0, $eJOHy.useRef)(null);
    const isNestedEditorCalculated = (0, $eJOHy.useRef)(false);
    if ((0, $eGOwo.fg)('platform_editor_lce_scrolltop_mitigation')) {
        if (editorRef.current !== null && !isNestedEditorCalculated.current) {
            isNestedEditor.current = !!editorRef.current?.closest('.extension-editable-area');
            isNestedEditorCalculated.current = true;
        }
    }
    const originalScrollToRestore = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(!isNestedEditor.current && (0, $7uu4v.isFullPage)(props.editorProps.appearance) ? document.querySelector('[data-editor-scroll-container]')?.scrollTop : undefined);
    const mitigateScrollJump = // The feature gate here is being used to avoid potential bugs with the scroll restoration code
    // moving it to the end of the expression negates the point of the feature gate
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $7uu4v.isFullPage)(props.editorProps.appearance) && originalScrollToRestore.current && originalScrollToRestore.current !== 0;
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (shouldFocus && editorView?.props.editable?.(editorView.state) && (0, $eGOwo.fg)('platform_editor_react_18_autofocus_fix')) {
            if (!mitigateScrollJump) {
                const liveDocWithContent = (__livePage || (0, $cbSL1.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)) && !(0, $bnAxN.isEmptyDocument)(editorView.state.doc);
                if (!liveDocWithContent) focusTimeoutId.current = (0, $YsDKQ.handleEditorFocus)(editorView);
                if ((0, $cbSL1.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true) && (0, $eGOwo.fg)('cc_editor_focus_before_editor_on_load')) {
                    if (!disabled && shouldFocus && !(0, $bnAxN.isEmptyDocument)(editorView.state.doc)) (0, $jGMZf.focusEditorElement)(editorId.current);
                }
            }
        }
    }, [
        editorView,
        shouldFocus,
        __livePage,
        mitigateScrollJump,
        disabled
    ]);
    const scrollElement = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef();
    const possibleListeners = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef([]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        return ()=>{
            if (scrollElement.current) // eslint-disable-next-line react-hooks/exhaustive-deps
            for (const possibleListener of possibleListeners.current)// eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            scrollElement.current?.removeEventListener(...possibleListener);
            scrollElement.current = null;
        };
    }, []);
    const handleEditorViewRef = (0, $eJOHy.useCallback)((node)=>{
        if ((0, $g6YpQ.expVal)('platform_editor_no_ssr', 'isEnabled', false) && (0, $fNh22.isSSR)()) return;
        if (node) {
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            scrollElement.current = document.querySelector('[data-editor-scroll-container]');
            const cleanupListeners = ()=>{
                // eslint-disable-next-line react-hooks/exhaustive-deps
                for (const possibleListener of possibleListeners.current)// eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                scrollElement.current?.removeEventListener(...possibleListener);
            };
            if (scrollElement.current) {
                const wheelAbortHandler = ()=>{
                    const activeInteraction = (0, $2QO3b.getActiveInteraction)();
                    if (activeInteraction && [
                        'edit-page',
                        'live-edit'
                    ].includes(activeInteraction.ufoName)) (0, $2QO3b.abortAll)('new_interaction', `wheel-on-editor-element`);
                    cleanupListeners();
                };
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                scrollElement.current.addEventListener('wheel', wheelAbortHandler);
                possibleListeners.current.push([
                    'wheel',
                    wheelAbortHandler
                ]);
                const scrollAbortHandler = ()=>{
                    const activeInteraction = (0, $2QO3b.getActiveInteraction)();
                    if (activeInteraction && [
                        'edit-page',
                        'live-edit'
                    ].includes(activeInteraction.ufoName)) (0, $2QO3b.abortAll)('new_interaction', `scroll-on-editor-element`);
                    cleanupListeners();
                };
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                scrollElement.current.addEventListener('scroll', scrollAbortHandler);
                possibleListeners.current.push([
                    'scroll',
                    scrollAbortHandler
                ]);
            }
        }
        if (!viewRef.current && node) {
            (0, $elRHR.nodeVisibilityManager)(node).initialiseNodeObserver();
            const view = createEditorView(node);
            if (mitigateScrollJump) {
                const scrollElement = document.querySelector('[data-editor-scroll-container]');
                scrollElement?.scrollTo({
                    top: originalScrollToRestore.current,
                    behavior: 'instant'
                });
            }
            onEditorCreated({
                view: view,
                config: config.current,
                eventDispatcher: eventDispatcher,
                transformer: contentTransformer.current
            });
            if ((0, $eGOwo.fg)('platform_editor_react_18_autofocus_fix')) {
                /**
					 * Defer using startTransition when it is available (in React 18) to fix
					 * autofocus bug where React 18's concurrent rendering mode interferes with
					 * setTimeout used in handleEditorFocus, causing autofocus to break.
					 */ const react18OnlyStartTransition = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy)))?.startTransition ?? ((fn)=>fn());
                react18OnlyStartTransition(()=>{
                    // Force React to re-render so consumers get a reference to the editor view
                    setEditorView(view);
                });
            } else {
                if (shouldFocus && view.props.editable && view.props.editable(view.state)) {
                    if (!mitigateScrollJump) {
                        const isLivePageWithContent = (__livePage || (0, $cbSL1.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)) && !(0, $bnAxN.isEmptyDocument)(view.state.doc);
                        if (!isLivePageWithContent && shouldFocus && view.props.editable && view.props.editable(view.state)) focusTimeoutId.current = (0, $YsDKQ.handleEditorFocus)(view);
                        if ((0, $cbSL1.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true) && (0, $eGOwo.fg)('cc_editor_focus_before_editor_on_load')) {
                            if (shouldFocus && view.props.editable && view.props.editable(view.state) && !(0, $bnAxN.isEmptyDocument)(view.state.doc)) (0, $jGMZf.focusEditorElement)(editorId.current);
                        }
                    }
                }
                // Force React to re-render so consumers get a reference to the editor view
                setEditorView(view);
            }
        } else if (viewRef.current && !node) {
            // When the appearance is changed, React will call handleEditorViewRef with node === null
            // to destroy the old EditorView, before calling this method again with node === div to
            // create the new EditorView
            onEditorDestroyed({
                view: viewRef.current,
                config: config.current,
                eventDispatcher: eventDispatcher,
                transformer: contentTransformer.current
            });
            const wasAnalyticsDisconnected = !eventDispatcher.has((0, $dyNYh.analyticsEventKey), handleAnalyticsEvent);
            // If we disabled event listening for some reason we should re-enable it temporarily while we destroy
            // the view for any analytics that occur there.
            if (wasAnalyticsDisconnected) {
                eventDispatcher.on((0, $dyNYh.analyticsEventKey), handleAnalyticsEvent);
                viewRef.current.destroy(); // Destroys the dom node & all node views
                eventDispatcher.off((0, $dyNYh.analyticsEventKey), handleAnalyticsEvent);
            } else viewRef.current.destroy(); // Destroys the dom node & all node views
            (0, $elRHR.nodeVisibilityManager)(viewRef.current.dom).disconnect();
            viewRef.current = undefined;
        }
    }, [
        createEditorView,
        onEditorCreated,
        eventDispatcher,
        shouldFocus,
        __livePage,
        onEditorDestroyed,
        handleAnalyticsEvent,
        mitigateScrollJump
    ]);
    const createEditor = (0, $eJOHy.useCallback)((assistiveLabel, assistiveDescribedBy)=>{
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
            children: [
                (0, $eGOwo.fg)('cc_editor_focus_before_editor_on_load') && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    tabIndex: -1,
                    "data-focus-id": editorId.current,
                    "data-testid": "react-editor-view-inital-focus-element"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: `ProseMirror ${(0, $aHrTy.getUAPrefix)()}`,
                    ref: handleEditorViewRef,
                    "aria-label": assistiveLabel || props.intl.formatMessage((0, $erdK2.editorMessages).editorAssistiveLabel),
                    // setting aria-multiline to true when not mobile appearance.
                    //  because somehow mobile tests are failing when it set.
                    //  don't know why that is happening.
                    // Created https://product-fabric.atlassian.net/jira/servicedesk/projects/DTR/queues/issue/DTR-1675
                    //  to investigate further.
                    "aria-multiline": true,
                    role: "textbox",
                    id: $97220bff0cbd31bb$var$EDIT_AREA_ID,
                    "aria-describedby": assistiveDescribedBy,
                    "data-editor-id": editorId.current,
                    "data-vc-ignore-if-no-layout-shift": true,
                    // eslint-disable-next-line react/no-danger -- needed for SSR and hydration so react keeps the HTML untouched
                    dangerouslySetInnerHTML: (0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? {
                        __html: ''
                    } : undefined
                }, "ProseMirror")
            ]
        });
    }, [
        handleEditorViewRef,
        props.intl
    ]);
    const previousPreset = (0, $5ZVTg.default)(preset);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (previousPreset && previousPreset !== preset) reconfigureState(props);
    }, [
        reconfigureState,
        previousPreset,
        preset,
        props
    ]);
    const previousDisabledState = (0, $5ZVTg.default)(disabled);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (viewRef.current && previousDisabledState !== disabled) {
            // Disables the contentEditable attribute of the editor if the editor is disabled
            viewRef.current.setProps({
                editable: (_state)=>!disabled
            });
            const isLivePageWithContent = (__livePage || (0, $cbSL1.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)) && !(0, $bnAxN.isEmptyDocument)(viewRef.current.state.doc);
            if (!disabled && shouldFocus && !isLivePageWithContent) focusTimeoutId.current = (0, $YsDKQ.handleEditorFocus)(viewRef.current);
            if ((0, $cbSL1.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true) && (0, $eGOwo.fg)('cc_editor_focus_before_editor_on_load')) {
                if (!disabled && shouldFocus && !(0, $bnAxN.isEmptyDocument)(viewRef.current.state.doc)) (0, $jGMZf.focusEditorElement)(editorId.current);
            }
        }
    }, [
        disabled,
        shouldFocus,
        previousDisabledState,
        __livePage
    ]);
    (0, $2afhI.useFireFullWidthEvent)(nextAppearance, dispatchAnalyticsEvent);
    const editor = (0, $eJOHy.useMemo)(()=>createEditor(props.editorProps.assistiveLabel, props.editorProps.assistiveDescribedBy), // `createEditor` changes a little too frequently - we don't want to recreate the editor view in this case
    // We should follow-up
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        props.editorProps.assistiveLabel,
        props.editorProps.assistiveDescribedBy
    ]);
    // Render tracking is firing too many events in Jira so we are disabling them for now. See - https://product-fabric.atlassian.net/browse/ED-25616
    // Also firing too many events for the legacy content macro, so disabling for now. See - https://product-fabric.atlassian.net/browse/ED-26650
    const renderTrackingEnabled = false;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $g9imq.default).Provider, {
        value: {
            editorRef: editorRef,
            editorView: viewRef.current,
            popupsMountPoint: props.editorProps.popupsMountPoint
        },
        children: [
            renderTrackingEnabled && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i5btK.RenderTracking), {
                componentProps: props,
                action: (0, $bMFKb.ACTION).RE_RENDERED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).REACT_EDITOR_VIEW,
                handleAnalyticsEvent: handleAnalyticsEvent,
                useShallow: true
            }),
            props.render ? props.render?.({
                editor: editor,
                view: viewRef.current,
                config: config.current,
                eventDispatcher: eventDispatcher,
                transformer: contentTransformer.current,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                editorRef: editorRef,
                editorAPI: editorAPI
            }) ?? editor : editor
        ]
    });
}
var // Preserving exact type generated by TypeScript
// eslint-disable-next-line @typescript-eslint/ban-types
$97220bff0cbd31bb$export$2e2bcd8739ae039 = (0, $6YFG2.default)($97220bff0cbd31bb$export$e7d1b1cbca007e16);

});
parcelRegister("2Kn3g", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae227f9278e93289$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $ae227f9278e93289$export$2e2bcd8739ae039(callback) {
    const hasRun = (0, $eJOHy.useRef)(false);
    if (!hasRun.current) {
        callback();
        hasRun.current = true;
    }
}

});

parcelRegister("5ZVTg", function(module, exports) {
$parcel$export(module.exports, "default", () => $45ec14eb37dd32c0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $45ec14eb37dd32c0$export$2e2bcd8739ae039(value, initialValue) {
    const ref = (0, $eJOHy.useRef)(initialValue);
    (0, $eJOHy.useEffect)(()=>{
        // Setting the value to ref.current inside an effect, or otherwise the behaviour in staging/prod doesn't match with local
        // In local, the double rendering in react dev mode causes the previous value to be the same as next value immediately after
        // In prod and staging, double rendering is not done since that is a react prod build
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("elRHR", function(module, exports) {
$parcel$export(module.exports, "nodeVisibilityManager", () => $e7860a8853372d80$export$565ab8668cdfbb7c);
// Use this selector to set the intersection observer boundary for editor's inline node views
// If this does not exist, it will use the IntersectionObserver's default root
const $e7860a8853372d80$var$INTERSECTION_OBSERVER_ROOT_SELECTOR = '[data-editor-scroll-container="true"]';
const $e7860a8853372d80$var$editorObservers = new WeakMap();
const $e7860a8853372d80$var$callbackMap = new WeakMap();
const $e7860a8853372d80$export$565ab8668cdfbb7c = (editorElement)=>{
    // Warning! do not reference editorElement outside of internal functions.
    // editorElement is passed to allow support for multiple editors,
    const unObserveInternal = (nodeElement)=>{
        $e7860a8853372d80$var$editorObservers.get(editorElement)?.unobserve(nodeElement);
        $e7860a8853372d80$var$callbackMap.delete(nodeElement);
    };
    const observe = (observerConfig)=>{
        $e7860a8853372d80$var$callbackMap.set(observerConfig.element, observerConfig);
        $e7860a8853372d80$var$editorObservers.get(editorElement)?.observe(observerConfig.element);
        // return clean up
        return ()=>{
            // consumer needs to unobserve on destroy if their element
            // was observed but never scrolled into view
            unObserveInternal(observerConfig.element);
        };
    };
    const initialiseNodeObserver = ()=>{
        if ($e7860a8853372d80$var$editorObservers.has(editorElement)) return;
        const intersectionObserverOptions = {
            root: editorElement.closest($e7860a8853372d80$var$INTERSECTION_OBSERVER_ROOT_SELECTOR),
            rootMargin: '0px 0px 100px 0px',
            threshold: 0
        };
        const editorObserver = new IntersectionObserver((entries)=>entries.map((entry)=>({
                    entry: entry,
                    callback: $e7860a8853372d80$var$callbackMap.get(entry.target)
                }))// Invoke callbacks together to group browser rendering
            // Avoiding requestAnimationFrame to reduce visual flickering
            .forEach(({ entry: entry, callback: callback })=>{
                if (entry.isIntersecting) {
                    callback?.onFirstVisible();
                    if (entry.target instanceof HTMLElement) // immediately unobserve the element after it is visible
                    unObserveInternal(entry.target);
                }
            }), intersectionObserverOptions);
        $e7860a8853372d80$var$editorObservers.set(editorElement, editorObserver);
    };
    const disconnect = ()=>{
        $e7860a8853372d80$var$editorObservers.get(editorElement)?.disconnect();
        $e7860a8853372d80$var$editorObservers.delete(editorElement);
    };
    return {
        initialiseNodeObserver: initialiseNodeObserver,
        observe: observe,
        disconnect: disconnect
    };
};

});

parcelRegister("dTLXq", function(module, exports) {
$parcel$export(module.exports, "EditorPluginInjectionAPI", () => $704f9873d73e1f00$export$50ccbedb1c6559a0);

var $cSmYj = parcelRequire("cSmYj");

var $6DCNy = parcelRequire("6DCNy");

var $kIy7e = parcelRequire("kIy7e");
function $704f9873d73e1f00$var$hasGetSharedState(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
plugin) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return typeof plugin.getSharedState === 'function';
}
function $704f9873d73e1f00$var$hasActions(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
plugin) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return typeof plugin.actions === 'object';
}
function $704f9873d73e1f00$var$hasCommands(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
plugin) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return typeof plugin.commands === 'object';
}
const $704f9873d73e1f00$var$filterPluginsWithListeners = ({ listeners: listeners, plugins: plugins })=>Array.from(listeners.keys()).map((pluginName)=>plugins.get(pluginName)).filter((plugin)=>plugin !== undefined && $704f9873d73e1f00$var$hasGetSharedState(plugin));
const $704f9873d73e1f00$var$extractSharedStateFromPlugins = ({ oldEditorState: oldEditorState, newEditorState: newEditorState, plugins: plugins })=>{
    const isInitialization = !oldEditorState && newEditorState;
    const result = new Map();
    for (const plugin of plugins){
        if (!plugin || !$704f9873d73e1f00$var$hasGetSharedState(plugin)) continue;
        const nextSharedState = plugin.getSharedState(newEditorState);
        const prevSharedState = !isInitialization && oldEditorState ? plugin.getSharedState(oldEditorState) : undefined;
        const isSamePluginState = (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(prevSharedState, nextSharedState);
        if (isInitialization || !isSamePluginState) result.set(plugin.name, {
            nextSharedState: nextSharedState,
            prevSharedState: prevSharedState
        });
    }
    return result;
};
const $704f9873d73e1f00$var$THROTTLE_CALLS_FOR_MILLISECONDS = 0;
const $704f9873d73e1f00$var$notifyListenersThrottled = (0, (/*@__PURE__*/$parcel$interopDefault($6DCNy)))(({ listeners: listeners, updatesToNotifyQueue: updatesToNotifyQueue })=>{
    const callbacks = [];
    for (const [pluginName, diffs] of updatesToNotifyQueue.entries()){
        const pluginListeners = listeners.get(pluginName) || [];
        pluginListeners.forEach((callback)=>{
            diffs.forEach((diff)=>{
                callbacks.push(callback.bind(callback, diff));
            });
        });
    }
    updatesToNotifyQueue.clear();
    if (callbacks.length === 0) return;
    callbacks.reverse().forEach((cb)=>{
        cb();
    });
}, $704f9873d73e1f00$var$THROTTLE_CALLS_FOR_MILLISECONDS);
class $704f9873d73e1f00$export$855252f33d470a3f {
}
class $704f9873d73e1f00$var$ActionsAPI {
    createAPI(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    plugin) {
        if (!plugin || !$704f9873d73e1f00$var$hasActions(plugin)) return {};
        return new Proxy(plugin.actions || {}, {
            get: function(target, prop, receiver) {
                // We will be able to track perfomance here
                return Reflect.get(target, prop);
            }
        });
    }
}
class $704f9873d73e1f00$var$EditorCommandsAPI {
    createAPI(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    plugin) {
        if (!plugin || !$704f9873d73e1f00$var$hasCommands(plugin)) return {};
        return new Proxy(plugin.commands || {}, {
            get: function(target, prop, receiver) {
                // We will be able to track perfomance here
                return Reflect.get(target, prop);
            }
        });
    }
}
class $704f9873d73e1f00$export$da7528f3fb233b4a {
    constructor({ getEditorState: getEditorState }){
        this.updatesToNotifyQueue = new Map();
        this.getEditorState = getEditorState;
        this.listeners = new Map();
    }
    createAPI(plugin) {
        if (!plugin) return {
            currentState: ()=>undefined,
            onChange: (sub)=>{
                return ()=>{};
            }
        };
        const pluginName = plugin.name;
        return {
            currentState: ()=>{
                if (!$704f9873d73e1f00$var$hasGetSharedState(plugin)) return undefined;
                const state = this.getEditorState();
                return plugin.getSharedState(state);
            },
            onChange: (sub)=>{
                const pluginListeners = this.listeners.get(pluginName) || new Set();
                pluginListeners.add(sub);
                this.listeners.set(pluginName, pluginListeners);
                return ()=>this.cleanupSubscription(pluginName, sub);
            }
        };
    }
    cleanupSubscription(pluginName, sub) {
        (this.listeners.get(pluginName) || new Set()).delete(sub);
    }
    notifyListeners({ newEditorState: newEditorState, oldEditorState: oldEditorState, plugins: plugins }) {
        const { listeners: listeners, updatesToNotifyQueue: updatesToNotifyQueue } = this;
        const pluginsFiltered = $704f9873d73e1f00$var$filterPluginsWithListeners({
            plugins: plugins,
            listeners: listeners
        });
        const sharedStateDiffs = $704f9873d73e1f00$var$extractSharedStateFromPlugins({
            oldEditorState: oldEditorState,
            newEditorState: newEditorState,
            plugins: pluginsFiltered
        });
        if (sharedStateDiffs.size === 0) return;
        for (const [pluginName, nextDiff] of sharedStateDiffs){
            const currentDiffQueue = updatesToNotifyQueue.get(pluginName) || [];
            updatesToNotifyQueue.set(pluginName, [
                ...currentDiffQueue,
                nextDiff
            ]);
        }
        $704f9873d73e1f00$var$notifyListenersThrottled({
            updatesToNotifyQueue: updatesToNotifyQueue,
            listeners: listeners
        });
    }
    destroy() {
        this.listeners.clear();
        this.updatesToNotifyQueue.clear();
    }
}
const $704f9873d73e1f00$var$editorAPICache = new WeakMap();
class $704f9873d73e1f00$export$50ccbedb1c6559a0 {
    constructor({ getEditorState: getEditorState, getEditorView: getEditorView, fireAnalyticsEvent: fireAnalyticsEvent }){
        this.onEditorViewUpdated = ({ newEditorState: newEditorState, oldEditorState: oldEditorState })=>{
            this.sharedStateAPI.notifyListeners({
                newEditorState: newEditorState,
                oldEditorState: oldEditorState,
                plugins: this.plugins
            });
        };
        this.onEditorPluginInitialized = (plugin)=>{
            this.addPlugin(plugin);
        };
        this.addPlugin = (plugin)=>{
            // Plugins other than `core` are checked by the preset itself
            // For some reason in some tests we have duplicates that are missed.
            // To follow-up in ED-19611
            if (plugin.name === 'core' && this.plugins.has(plugin.name)) throw new Error(`Plugin ${plugin.name} has already been initialised in the Editor API!
        There cannot be duplicate plugins or you will have unexpected behaviour`);
            this.plugins.set(plugin.name, plugin);
        };
        this.getPluginByName = (pluginName)=>{
            const plugin = this.plugins.get(pluginName);
            return plugin;
        };
        this.sharedStateAPI = new $704f9873d73e1f00$export$da7528f3fb233b4a({
            getEditorState: getEditorState
        });
        this.plugins = new Map();
        this.actionsAPI = new $704f9873d73e1f00$var$ActionsAPI();
        this.commandsAPI = new $704f9873d73e1f00$var$EditorCommandsAPI();
        // Special core plugin that is always added
        this.addPlugin((0, $kIy7e.corePlugin)({
            config: {
                getEditorView: getEditorView,
                fireAnalyticsEvent: fireAnalyticsEvent
            }
        }));
    }
    createAPI() {
        const { sharedStateAPI: sharedStateAPI, actionsAPI: actionsAPI, commandsAPI: commandsAPI, getPluginByName: getPluginByName } = this;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new Proxy({}, {
            get: function(target, prop, receiver) {
                // If we pass this as a prop React hates us
                // Let's just reflect the result and ignore these
                if (prop === 'toJSON') return Reflect.get(target, prop);
                const plugin = getPluginByName(prop);
                if (!plugin) return undefined;
                const sharedState = sharedStateAPI.createAPI(plugin);
                const actions = actionsAPI.createAPI(plugin);
                const commands = commandsAPI.createAPI(plugin);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const proxyCoreAPI = {
                    sharedState: sharedState,
                    actions: actions,
                    commands: commands
                };
                return proxyCoreAPI;
            }
        });
    }
    api() {
        if (!$704f9873d73e1f00$var$editorAPICache.get(this)) $704f9873d73e1f00$var$editorAPICache.set(this, this.createAPI());
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return $704f9873d73e1f00$var$editorAPICache.get(this);
    }
}

});
parcelRegister("kIy7e", function(module, exports) {
$parcel$export(module.exports, "corePlugin", () => $845d74fa02e6f2aa$export$71ab138dd170c35);

var $3xw6l = parcelRequire("3xw6l");

var $eGOwo = parcelRequire("eGOwo");

var $7wniU = parcelRequire("7wniU");

var $51k6y = parcelRequire("51k6y");

var $8GLF3 = parcelRequire("8GLF3");

var $eUMHn = parcelRequire("eUMHn");
const $845d74fa02e6f2aa$export$71ab138dd170c35 = ({ config: config })=>{
    // Create the document request throttler per editor (rather than at a module level)
    const scheduleDocumentRequest = (0, $eUMHn.createThrottleSchedule)((0, $eUMHn.returnDocumentRequest));
    return {
        name: 'core',
        getSharedState (state) {
            return {
                schema: state?.schema
            };
        },
        actions: {
            execute: (command)=>{
                const editorView = config?.getEditorView();
                if (!editorView || !command) return false;
                const { state: state, dispatch: dispatch } = editorView;
                return (0, $8GLF3.editorCommandToPMCommand)(command)(state, dispatch);
            },
            // Code copied from `EditorActions.focus()`
            focus: (options)=>{
                const editorView = config?.getEditorView();
                if (!editorView || editorView.hasFocus()) return false;
                editorView.focus();
                if (options?.scrollIntoView ?? true) editorView.dispatch(editorView.state.tr.scrollIntoView());
                return true;
            },
            // Code copied from `EditorActions.blur()`
            blur: ()=>{
                const editorView = config?.getEditorView();
                if (!editorView || !editorView.hasFocus()) return false;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                editorView.dom.blur();
                return true;
            },
            scrollToPos (pos, scrollOptions) {
                const editorView = config?.getEditorView();
                if (!editorView) return false;
                const tr = editorView.state.tr;
                const isValidPos = typeof pos === 'number' && pos >= 0 && pos <= tr.doc.content.size;
                if (!isValidPos) return false;
                const dom = editorView.domAtPos(pos).node;
                if (!(dom instanceof Element)) {
                    // If it's not an element (e.g. #text node), we'll try the parent.
                    // This is expected to cover most of the scenarios, if not, window.scrollTo is an alternative
                    if (dom.parentNode instanceof Element) {
                        dom.parentNode.scrollIntoView(scrollOptions);
                        return true;
                    }
                    return false;
                }
                dom.scrollIntoView(scrollOptions);
                return true;
            },
            replaceDocument: (replaceValue, options)=>{
                const editorView = config?.getEditorView();
                if (!editorView || replaceValue === undefined || replaceValue === null) return false;
                const { state: state } = editorView;
                const { schema: schema } = state;
                const content = options?.skipValidation ? (0, $51k6y.processRawValueWithoutValidation)(schema, replaceValue) : Array.isArray(replaceValue) ? (0, $51k6y.processRawFragmentValue)(schema, replaceValue) : (0, $51k6y.processRawValue)(schema, replaceValue);
                // Don't replace the document if it's the same document, as full size
                // replace transactions cause issues for collaborative editing and
                // content reconciliation (eg. inline comments getting dropped)
                if (content instanceof (0, $3xw6l.Node) && state.doc.eq(content)) return false;
                if (content) {
                    const tr = state.tr.replaceWith(0, state.doc.nodeSize - 2, content);
                    if (options?.addToHistory === false) tr.setMeta('addToHistory', false);
                    if (options?.scrollIntoView ?? true) editorView.dispatch(tr.scrollIntoView());
                    else if ((0, $eGOwo.fg)('aifc_create_enabled')) editorView.dispatch(tr.setMeta('scrollIntoView', false));
                    return true;
                }
                return false;
            },
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            requestDocument (onReceive, options) {
                const view = config?.getEditorView() ?? null;
                scheduleDocumentRequest(view, onReceive, options?.transformer, config?.fireAnalyticsEvent, options?.alwaysFire);
            },
            createTransformer (cb) {
                const view = config?.getEditorView() ?? null;
                if (!view?.state.schema) return undefined;
                return cb(view?.state.schema);
            },
            getAnchorIdForNode (node, pos) {
                const view = config?.getEditorView() ?? null;
                if (!view) return undefined;
                const cachedId = (0, $7wniU.getNodeIdProvider)(view).getIdForNode(node);
                if (cachedId) return cachedId;
                if (pos < 0) return undefined;
                const nodeDOM = view.nodeDOM(pos);
                if (nodeDOM instanceof HTMLElement) return nodeDOM.getAttribute('data-node-anchor') || undefined;
                return undefined;
            }
        }
    };
};

});
parcelRegister("7wniU", function(module, exports) {
$parcel$export(module.exports, "getNodeIdProvider", () => $6d40d38debb273ca$export$753ee9749f6df320);

var $xOBYC = parcelRequire("xOBYC");
class $6d40d38debb273ca$export$d6cb5c66663ecf49 {
    // We use pos to generate unique ids for each node at a specific position
    // This is to ensure the same ADF will always generate the same DOM initially
    getOrGenerateId(node, pos) {
        if (this.cache.has(node)) return this.cache.get(node);
        let idSuffix = '';
        if (this.existingPos.get(pos)) idSuffix = `-${(this.count++).toString(36)}`;
        else this.existingPos.set(pos, true);
        const anchorName = `--anchor-${node.type.name}-${pos}${idSuffix}`;
        this.cache.set(node, anchorName);
        return anchorName;
    }
    getIdForNode(node) {
        return this.cache.get(node) || undefined;
    }
    constructor(){
        this.cache = new WeakMap();
        this.count = BigInt(0);
        this.existingPos = new (0, $xOBYC.DynamicBitArray)();
    }
}
const $6d40d38debb273ca$var$nodeIdProviderMap = new WeakMap();
const $6d40d38debb273ca$export$753ee9749f6df320 = (editorView)=>{
    if (!$6d40d38debb273ca$var$nodeIdProviderMap.has(editorView)) {
        const provider = new $6d40d38debb273ca$export$d6cb5c66663ecf49();
        $6d40d38debb273ca$var$nodeIdProviderMap.set(editorView, provider);
        return provider;
    }
    // This is based on the fact that editorView is a singleton.
    return $6d40d38debb273ca$var$nodeIdProviderMap.get(editorView);
};

});
parcelRegister("xOBYC", function(module, exports) {
$parcel$export(module.exports, "DynamicBitArray", () => $00f5e30673f1e598$export$fdc385e5a167108c);
const $00f5e30673f1e598$var$DEFAULT_CHUNK_SIZE = 4096; // Default chunk size in bits
class $00f5e30673f1e598$export$fdc385e5a167108c {
    constructor(chunkSize = $00f5e30673f1e598$var$DEFAULT_CHUNK_SIZE){
        this.chunkSize = chunkSize;
        this.chunkTotalBitSize = this.chunkSize * 8;
        this.bitArrays = [];
    }
    set(index, value) {
        const bitArray = this.getChunk(index);
        const byteOffset = index % this.chunkTotalBitSize;
        const byteIndex = Math.floor(byteOffset / 8); // Get the byte index
        const bitOffset = byteOffset % 8; // Get the bit offset within the byte
        if (value) bitArray[byteIndex] |= 1 << bitOffset; // set the bit
        else bitArray[byteIndex] &= ~(1 << bitOffset); // clear the bit
    }
    get(index) {
        const bitArray = this.getChunk(index);
        const byteOffset = index % this.chunkTotalBitSize;
        const byteIndex = Math.floor(byteOffset / 8); // Get the byte index
        const bitOffset = byteOffset % 8; // Get the bit offset within the byte
        return (bitArray[byteIndex] & 1 << bitOffset) !== 0; // Check if the bit is set
    }
    getChunk(index) {
        const chunkIndex = Math.floor(index / this.chunkTotalBitSize);
        if (!this.bitArrays[chunkIndex]) this.bitArrays[chunkIndex] = new Uint8Array(this.chunkSize);
        return this.bitArrays[chunkIndex];
    }
}

});


parcelRegister("8GLF3", function(module, exports) {
$parcel$export(module.exports, "editorCommandToPMCommand", () => $84844af15cb36364$export$bd352a83a17b2af8);
$parcel$export(module.exports, "PassiveTransaction", () => $84844af15cb36364$export$95069e054e554fa9);

var $3lIcL = parcelRequire("3lIcL");
function $84844af15cb36364$export$bd352a83a17b2af8(command) {
    return ({ tr: tr }, dispatch)=>{
        const newTr = command?.({
            tr: tr
        });
        if (!newTr) return false;
        if (newTr instanceof $84844af15cb36364$export$95069e054e554fa9) return true;
        dispatch?.(newTr);
        return true;
    };
}
class $84844af15cb36364$export$95069e054e554fa9 extends (0, $3lIcL.Transaction) {
    // This is very cheeky but this should never be used outside its intended
    // purpose - it will likely crash the editor so we should get an early warning
    // signal
    constructor(){
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        super({});
    }
}

});

parcelRegister("eUMHn", function(module, exports) {
$parcel$export(module.exports, "createThrottleSchedule", () => $b9d5029668f0e8c6$export$6a1dd68d75badcc7);
$parcel$export(module.exports, "returnDocumentRequest", () => $b9d5029668f0e8c6$export$dce79649e5264171);

var $lovmf = parcelRequire("lovmf");

var $3xw6l = parcelRequire("3xw6l");

var $eGOwo = parcelRequire("eGOwo");

var $bMFKb = parcelRequire("bMFKb");
const $b9d5029668f0e8c6$var$transformer = new (0, $lovmf.JSONTransformer)();
function $b9d5029668f0e8c6$export$54fd2c36b5cc6731(node) {
    return $b9d5029668f0e8c6$var$transformer.encode(node);
}
function $b9d5029668f0e8c6$export$6a1dd68d75badcc7(callback) {
    let frameId;
    let lastArgs;
    const delayedCallbacks = [];
    const wrapperFn = (...args)=>{
        const lastArgsBefore = lastArgs;
        lastArgs = args;
        if (frameId) {
            if ((0, $eGOwo.fg)('aifc_create_enabled')) {
                if (lastArgsBefore) {
                    const [_v, _c, _t, _f, alwaysFire] = lastArgsBefore;
                    if (alwaysFire) delayedCallbacks.push(lastArgsBefore);
                }
            }
            return;
        }
        // If `requestIdleCallback` doesn't exist - fallback to `requestAnimationFrame`
        const delayFunction = globalThis.requestIdleCallback ?? globalThis.requestAnimationFrame;
        frameId = delayFunction(()=>{
            frameId = undefined;
            if (lastArgs) {
                if ((0, $eGOwo.fg)('aifc_create_enabled')) delayedCallbacks.forEach((savedArgs)=>{
                    callback(...savedArgs);
                });
                callback(...lastArgs);
            }
        }, {
            timeout: 100
        });
    };
    return wrapperFn;
}
function $b9d5029668f0e8c6$export$dce79649e5264171(editorView, callback, transformer, fireAnalyticsEvent, alwaysFire) {
    const { doc: doc, schema: schema } = editorView?.state ?? {};
    if (!doc || !schema) return undefined;
    try {
        const json = $b9d5029668f0e8c6$export$54fd2c36b5cc6731(doc);
        if (typeof transformer === 'undefined') callback(json);
        else {
            const nodeSanitized = (0, $3xw6l.Node).fromJSON(schema, json);
            callback(transformer.encode(nodeSanitized));
        }
    } catch (e) {
        fireAnalyticsEvent?.({
            payload: {
                action: (0, $bMFKb.ACTION).DOCUMENT_PROCESSING_ERROR,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
                eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorMessage: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to transform one or more nested tables' : undefined}`
                }
            }
        });
        throw e;
    }
}

});



parcelRegister("g9imq", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7d0384bd404ebe9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $a7d0384bd404ebe9$var$ReactEditorViewContext = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext({});
var $a7d0384bd404ebe9$export$2e2bcd8739ae039 = $a7d0384bd404ebe9$var$ReactEditorViewContext;

});

parcelRegister("bnAxN", function(module, exports) {
$parcel$export(module.exports, "getStepRange", () => $ae49a9482438fce3$export$c8e611b6ac095e6d);
$parcel$export(module.exports, "hasDocAsParent", () => $ae49a9482438fce3$export$f76a7d770092ea11);
$parcel$export(module.exports, "isEmptyDocument", () => $ae49a9482438fce3$export$2da47a16c0b6bcb);
$parcel$export(module.exports, "bracketTyped", () => $ae49a9482438fce3$export$df0539d254c75c33);
$parcel$export(module.exports, "nodesBetweenChanged", () => $ae49a9482438fce3$export$f9e52d2e832a6aae);
$parcel$export(module.exports, "hasVisibleContent", () => $ae49a9482438fce3$export$c9083db5521330d3);
$parcel$export(module.exports, "isSelectionEndOfParagraph", () => $ae49a9482438fce3$export$435c1d4e61a8723b);
$parcel$export(module.exports, "getChangedNodes", () => $ae49a9482438fce3$export$fd9c3e0f31aab835);
$parcel$export(module.exports, "isReplaceDocOperation", () => $ae49a9482438fce3$export$b81ebf241519dbe1);
$parcel$export(module.exports, "areNodesEqualIgnoreAttrs", () => $ae49a9482438fce3$export$e3b603f98921291f);

var $2f1HK = parcelRequire("2f1HK");

var $lzEKq = parcelRequire("lzEKq");

var $eGOwo = parcelRequire("eGOwo");

var $5Z3Rm = parcelRequire("5Z3Rm");
const $ae49a9482438fce3$export$c8e611b6ac095e6d = (transaction)=>{
    let from = -1;
    let to = -1;
    transaction.mapping.maps.forEach((stepMap, index)=>{
        stepMap.forEach((oldStart, oldEnd)=>{
            const newStart = transaction.mapping.slice(index).map(oldStart, -1);
            const newEnd = transaction.mapping.slice(index).map(oldEnd);
            from = newStart < from || from === -1 ? newStart : from;
            to = newEnd > to || to === -1 ? newEnd : to;
            // See ticket https://hello.jira.atlassian.cloud/browse/EDITOR-1223 and
            // PR https://bitbucket.org/atlassian/atlassian-frontend-monorepo/pull-requests/208332/overview
            // to see why use clamp here
            if ((0, $eGOwo.fg)('aifc_create_enabled')) {
                const docSize = transaction.doc.content.size;
                from = (0, (/*@__PURE__*/$parcel$interopDefault($2f1HK)))(from, 0, docSize);
                to = (0, (/*@__PURE__*/$parcel$interopDefault($2f1HK)))(to, 0, docSize);
            }
        });
    });
    if (from !== -1) return {
        from: from,
        to: to
    };
    return null;
};
function $ae49a9482438fce3$export$f76a7d770092ea11($anchor) {
    return $anchor.depth === 1;
}
function $ae49a9482438fce3$export$2da47a16c0b6bcb(node) {
    const nodeChild = node.content.firstChild;
    if (node.childCount !== 1 || !nodeChild) return false;
    return (0, $5Z3Rm.isEmptyParagraph)(nodeChild);
}
function $ae49a9482438fce3$export$df0539d254c75c33(state) {
    const { selection: selection } = state;
    const { $cursor: $cursor, $anchor: $anchor } = selection;
    if (!$cursor) return false;
    const node = $cursor.nodeBefore;
    if (!node) return false;
    if (node.type.name === 'text' && node.text === '{') {
        const paragraphNode = $anchor.node();
        return paragraphNode.marks.length === 0 && $ae49a9482438fce3$export$f76a7d770092ea11($anchor);
    }
    return false;
}
function $ae49a9482438fce3$export$f9e52d2e832a6aae(tr, f, startPos) {
    const stepRange = $ae49a9482438fce3$export$c8e611b6ac095e6d(tr);
    if (!stepRange) return;
    tr.doc.nodesBetween(stepRange.from, stepRange.to, f, startPos);
}
function $ae49a9482438fce3$export$c9083db5521330d3(node) {
    const isInlineNodeHasVisibleContent = (inlineNode)=>{
        return inlineNode.isText ? !!inlineNode.textContent.trim() : inlineNode.type.name !== 'hardBreak';
    };
    if (node.isInline) return isInlineNodeHasVisibleContent(node);
    else if (node.isBlock && (node.isLeaf || node.isAtom)) return true;
    else if (!node.childCount) return false;
    for(let index = 0; index < node.childCount; index++){
        const child = node.child(index);
        const invisibleNodeTypes = [
            'paragraph',
            'text',
            'hardBreak'
        ];
        if (!invisibleNodeTypes.includes(child.type.name) || $ae49a9482438fce3$export$c9083db5521330d3(child)) return true;
    }
    return false;
}
const $ae49a9482438fce3$export$435c1d4e61a8723b = (state)=>state.selection.$to.parent.type === state.schema.nodes.paragraph && state.selection.$to.pos === state.doc.resolve(state.selection.$to.pos).end();
function $ae49a9482438fce3$var$getChangedNodesIn({ tr: tr, doc: doc }) {
    const nodes = [];
    const stepRange = $ae49a9482438fce3$export$c8e611b6ac095e6d(tr);
    if (!stepRange) return nodes;
    const from = Math.min(doc.nodeSize - 2, stepRange.from);
    const to = Math.min(doc.nodeSize - 2, stepRange.to);
    doc.nodesBetween(from, to, (node, pos)=>{
        nodes.push({
            node: node,
            pos: pos
        });
    });
    return nodes;
}
function $ae49a9482438fce3$export$fd9c3e0f31aab835(tr) {
    return $ae49a9482438fce3$var$getChangedNodesIn({
        tr: tr,
        doc: tr.doc
    });
}
const $ae49a9482438fce3$export$b81ebf241519dbe1 = (transactions, oldState)=>{
    return transactions.some((tr)=>{
        if (tr.getMeta('replaceDocument')) return true;
        const hasStepReplacingEntireDocument = tr.steps.some((step)=>{
            if (!(step instanceof (0, $lzEKq.ReplaceStep))) return false;
            const isStepReplacingFromDocStart = step.from === 0;
            const isStepReplacingUntilTheEndOfDocument = step.to === oldState.doc.content.size;
            if (!isStepReplacingFromDocStart || !isStepReplacingUntilTheEndOfDocument) return false;
            return true;
        });
        return hasStepReplacingEntireDocument;
    });
};
function $ae49a9482438fce3$export$e3b603f98921291f(node1, node2) {
    if (node1.isText) return node1.eq(node2);
    return node1 === node2 || node1.hasMarkup(node2.type, node1.attrs, node2.marks) && $ae49a9482438fce3$var$areFragmentsEqual(node1.content, node2.content);
}
function $ae49a9482438fce3$var$areFragmentsEqual(frag1, frag2) {
    if (frag1.content.length !== frag2.content.length) return false;
    let childrenEqual = true;
    frag1.content.forEach((child, i)=>{
        const otherChild = frag2.child(i);
        if (child === otherChild || otherChild && $ae49a9482438fce3$export$e3b603f98921291f(child, otherChild)) return;
        childrenEqual = false;
    });
    return childrenEqual;
}

});
parcelRegister("2f1HK", function(module, exports) {

var $hyPlD = parcelRequire("hyPlD");

var $fQnJZ = parcelRequire("fQnJZ");
/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */ function $1a1e4df8c91caf77$var$clamp(number, lower, upper) {
    if (upper === undefined) {
        upper = lower;
        lower = undefined;
    }
    if (upper !== undefined) {
        upper = $fQnJZ(upper);
        upper = upper === upper ? upper : 0;
    }
    if (lower !== undefined) {
        lower = $fQnJZ(lower);
        lower = lower === lower ? lower : 0;
    }
    return $hyPlD($fQnJZ(number), lower, upper);
}
module.exports = $1a1e4df8c91caf77$var$clamp;

});
parcelRegister("hyPlD", function(module, exports) {
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */ function $cc8d7144fabccd11$var$baseClamp(number, lower, upper) {
    if (number === number) {
        if (upper !== undefined) number = number <= upper ? number : upper;
        if (lower !== undefined) number = number >= lower ? number : lower;
    }
    return number;
}
module.exports = $cc8d7144fabccd11$var$baseClamp;

});


parcelRegister("5Z3Rm", function(module, exports) {
$parcel$export(module.exports, "isEmptyParagraph", () => $31528faad45fc8ad$export$b648602b09795358);
$parcel$export(module.exports, "stepHasSlice", () => $31528faad45fc8ad$export$53780b185b887309);
$parcel$export(module.exports, "stepAddsOneOf", () => $31528faad45fc8ad$export$f4d51ccab05f55c9);
$parcel$export(module.exports, "extractSliceFromStep", () => $31528faad45fc8ad$export$d0a9dfe2556a9577);
$parcel$export(module.exports, "isTextSelection", () => $31528faad45fc8ad$export$38b50bf35e79aaf3);
$parcel$export(module.exports, "isElementInTableCell", () => $31528faad45fc8ad$export$5588122b9eea7733);
$parcel$export(module.exports, "isLastItemMediaGroup", () => $31528faad45fc8ad$export$142c0ee6457f50d6);
$parcel$export(module.exports, "setNodeSelection", () => $31528faad45fc8ad$export$a367515ca2c9ace1);
$parcel$export(module.exports, "setTextSelection", () => $31528faad45fc8ad$export$1df6d14df6b0b758);
$parcel$export(module.exports, "nonNullable", () => $31528faad45fc8ad$export$26128561c93f5847);
$parcel$export(module.exports, "isValidPosition", () => $31528faad45fc8ad$export$de0495c7bd37bf4e);
$parcel$export(module.exports, "isInLayoutColumn", () => $31528faad45fc8ad$export$2de06a6e688827fd);
$parcel$export(module.exports, "filterChildrenBetween", () => $31528faad45fc8ad$export$e46323d96cf32194);
$parcel$export(module.exports, "removeBlockMarks", () => $31528faad45fc8ad$export$fba8af3b998832b9);

var $3lIcL = parcelRequire("3lIcL");

var $lzEKq = parcelRequire("lzEKq");

var $BmspC = parcelRequire("BmspC");

var $cwzAY = parcelRequire("cwzAY");

var $7SIsS = parcelRequire("7SIsS");
function $31528faad45fc8ad$export$b648602b09795358(node) {
    return !!node && node.type.name === 'paragraph' && !node.childCount;
}
const $31528faad45fc8ad$export$53780b185b887309 = (step)=>step && step.hasOwnProperty('slice');
function $31528faad45fc8ad$export$f4d51ccab05f55c9(step, nodeTypes) {
    let adds = false;
    if (!$31528faad45fc8ad$export$53780b185b887309(step)) return adds;
    step.slice.content.descendants((node)=>{
        if (nodeTypes.has(node.type)) adds = true;
        return !adds;
    });
    return adds;
}
const $31528faad45fc8ad$export$d0a9dfe2556a9577 = (step)=>{
    if (!(step instanceof (0, $lzEKq.ReplaceStep)) && !(step instanceof (0, $lzEKq.ReplaceAroundStep))) return null;
    // @ts-ignore This is by design. Slice is a private property, but accesible, from ReplaceStep.
    // However, we need to read it to found if the step was adding a newline
    const slice = step.slice;
    return slice;
};
const $31528faad45fc8ad$export$38b50bf35e79aaf3 = (selection)=>selection instanceof (0, $3lIcL.TextSelection);
const $31528faad45fc8ad$export$5588122b9eea7733 = (element)=>{
    return (0, $7SIsS.closest)(element, 'td, th');
};
const $31528faad45fc8ad$export$142c0ee6457f50d6 = (node)=>{
    const { content: content } = node;
    return !!content.lastChild && content.lastChild.type.name === 'mediaGroup';
};
const $31528faad45fc8ad$export$a367515ca2c9ace1 = (view, pos)=>{
    const { state: state, dispatch: dispatch } = view;
    if (!isFinite(pos)) return;
    const tr = state.tr.setSelection((0, $3lIcL.NodeSelection).create(state.doc, pos));
    dispatch(tr);
};
function $31528faad45fc8ad$export$1df6d14df6b0b758(view, anchor, head) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr.setSelection((0, $3lIcL.TextSelection).create(state.doc, anchor, head));
    dispatch(tr);
}
function $31528faad45fc8ad$export$abad69d764760c05(view) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr.setSelection(new (0, $3lIcL.AllSelection)(view.state.doc));
    dispatch(tr);
}
function $31528faad45fc8ad$export$8f10f8581a0e9ba2(view, anchor, head) {
    const { state: state, dispatch: dispatch } = view;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dispatch(state.tr.setSelection((0, $cwzAY.CellSelection).create(state.doc, anchor, head)));
}
function $31528faad45fc8ad$export$26128561c93f5847(value) {
    return value !== null && value !== undefined;
}
const $31528faad45fc8ad$export$de0495c7bd37bf4e = (pos, state)=>{
    if (typeof pos !== 'number') return false;
    if (pos >= 0 && pos <= state.doc.resolve(0).end()) return true;
    return false;
};
const $31528faad45fc8ad$export$2de06a6e688827fd = (state)=>{
    return (0, $BmspC.hasParentNodeOfType)(state.schema.nodes.layoutSection)(state.selection);
};
function $31528faad45fc8ad$export$e46323d96cf32194(doc, from, to, predicate) {
    const results = [];
    doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (predicate(node, pos, parent)) results.push({
            node: node,
            pos: pos
        });
    });
    return results;
}
const $31528faad45fc8ad$export$fba8af3b998832b9 = (state, marks)=>{
    const { selection: selection, schema: schema } = state;
    let { tr: tr } = state;
    // Marks might not exist in Schema
    const marksToRemove = marks.filter(Boolean);
    if (marksToRemove.length === 0) return undefined;
    /** Saves an extra dispatch */ let blockMarksExists = false;
    const hasMark = (mark)=>marksToRemove.indexOf(mark.type) > -1;
    /**
	 * When you need to toggle the selection
	 * when another type which does not allow alignment is applied
	 */ state.doc.nodesBetween(selection.from, selection.to, (node, pos)=>{
        if (node.type === schema.nodes.paragraph && node.marks.some(hasMark)) {
            blockMarksExists = true;
            const resolvedPos = state.doc.resolve(pos);
            const withoutBlockMarks = node.marks.filter($31528faad45fc8ad$var$not(hasMark));
            tr = tr.setNodeMarkup(resolvedPos.pos, undefined, node.attrs, withoutBlockMarks);
        }
    });
    return blockMarksExists ? tr : undefined;
};
const $31528faad45fc8ad$var$not = (fn)=>(arg)=>!fn(arg);

});


parcelRegister("b7EWj", function(module, exports) {
$parcel$export(module.exports, "Decoration", () => $81901ae0222f0506$export$10e30b733df217ea);
$parcel$export(module.exports, "DecorationSet", () => $81901ae0222f0506$export$93bf62eb445cec98);
$parcel$export(module.exports, "EditorView", () => $81901ae0222f0506$export$eece2fccabbb77c5);

var $3lIcL = parcelRequire("3lIcL");

var $3xw6l = parcelRequire("3xw6l");

var $lzEKq = parcelRequire("lzEKq");
const $81901ae0222f0506$var$domIndex = function(node) {
    for(var index = 0;; index++){
        node = node.previousSibling;
        if (!node) return index;
    }
};
const $81901ae0222f0506$var$parentNode = function(node) {
    let parent = node.assignedSlot || node.parentNode;
    return parent && parent.nodeType == 11 ? parent.host : parent;
};
let $81901ae0222f0506$var$reusedRange = null;
// Note that this will always return the same range, because DOM range
// objects are every expensive, and keep slowing down subsequent DOM
// updates, for some reason.
const $81901ae0222f0506$var$textRange = function(node, from, to) {
    let range = $81901ae0222f0506$var$reusedRange || ($81901ae0222f0506$var$reusedRange = document.createRange());
    range.setEnd(node, to == null ? node.nodeValue.length : to);
    range.setStart(node, from || 0);
    return range;
};
const $81901ae0222f0506$var$clearReusedRange = function() {
    $81901ae0222f0506$var$reusedRange = null;
};
// Scans forward and backward through DOM positions equivalent to the
// given one to see if the two are in the same place (i.e. after a
// text node vs at the end of that text node)
const $81901ae0222f0506$var$isEquivalentPosition = function(node, off, targetNode, targetOff) {
    return targetNode && ($81901ae0222f0506$var$scanFor(node, off, targetNode, targetOff, -1) || $81901ae0222f0506$var$scanFor(node, off, targetNode, targetOff, 1));
};
const $81901ae0222f0506$var$atomElements = /^(img|br|input|textarea|hr)$/i;
function $81901ae0222f0506$var$scanFor(node, off, targetNode, targetOff, dir) {
    for(;;){
        if (node == targetNode && off == targetOff) return true;
        if (off == (dir < 0 ? 0 : $81901ae0222f0506$var$nodeSize(node))) {
            let parent = node.parentNode;
            if (!parent || parent.nodeType != 1 || $81901ae0222f0506$var$hasBlockDesc(node) || $81901ae0222f0506$var$atomElements.test(node.nodeName) || node.contentEditable == "false") return false;
            off = $81901ae0222f0506$var$domIndex(node) + (dir < 0 ? 0 : 1);
            node = parent;
        } else if (node.nodeType == 1) {
            node = node.childNodes[off + (dir < 0 ? -1 : 0)];
            if (node.contentEditable == "false") return false;
            off = dir < 0 ? $81901ae0222f0506$var$nodeSize(node) : 0;
        } else return false;
    }
}
function $81901ae0222f0506$var$nodeSize(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $81901ae0222f0506$var$textNodeBefore$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset) return node;
        if (node.nodeType == 1 && offset > 0) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset - 1];
            offset = $81901ae0222f0506$var$nodeSize(node);
        } else if (node.parentNode && !$81901ae0222f0506$var$hasBlockDesc(node)) {
            offset = $81901ae0222f0506$var$domIndex(node);
            node = node.parentNode;
        } else return null;
    }
}
function $81901ae0222f0506$var$textNodeAfter$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset < node.nodeValue.length) return node;
        if (node.nodeType == 1 && offset < node.childNodes.length) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset];
            offset = 0;
        } else if (node.parentNode && !$81901ae0222f0506$var$hasBlockDesc(node)) {
            offset = $81901ae0222f0506$var$domIndex(node) + 1;
            node = node.parentNode;
        } else return null;
    }
}
function $81901ae0222f0506$var$isOnEdge(node, offset, parent) {
    for(let atStart = offset == 0, atEnd = offset == $81901ae0222f0506$var$nodeSize(node); atStart || atEnd;){
        if (node == parent) return true;
        let index = $81901ae0222f0506$var$domIndex(node);
        node = node.parentNode;
        if (!node) return false;
        atStart = atStart && index == 0;
        atEnd = atEnd && index == $81901ae0222f0506$var$nodeSize(node);
    }
}
function $81901ae0222f0506$var$hasBlockDesc(dom) {
    let desc;
    for(let cur = dom; cur; cur = cur.parentNode)if (desc = cur.pmViewDesc) break;
    return desc && desc.node && desc.node.isBlock && (desc.dom == dom || desc.contentDOM == dom);
}
// Work around Chrome issue https://bugs.chromium.org/p/chromium/issues/detail?id=447523
// (isCollapsed inappropriately returns true in shadow dom)
const $81901ae0222f0506$var$selectionCollapsed = function(domSel) {
    return domSel.focusNode && $81901ae0222f0506$var$isEquivalentPosition(domSel.focusNode, domSel.focusOffset, domSel.anchorNode, domSel.anchorOffset);
};
function $81901ae0222f0506$var$keyEvent(keyCode, key) {
    let event = document.createEvent("Event");
    event.initEvent("keydown", true, true);
    event.keyCode = keyCode;
    event.key = event.code = key;
    return event;
}
function $81901ae0222f0506$var$deepActiveElement(doc) {
    let elt = doc.activeElement;
    while(elt && elt.shadowRoot)elt = elt.shadowRoot.activeElement;
    return elt;
}
function $81901ae0222f0506$var$caretFromPoint(doc, x, y) {
    if (doc.caretPositionFromPoint) try {
        let pos = doc.caretPositionFromPoint(x, y);
        // Clip the offset, because Chrome will return a text offset
        // into <input> nodes, which can't be treated as a regular DOM
        // offset
        if (pos) return {
            node: pos.offsetNode,
            offset: Math.min($81901ae0222f0506$var$nodeSize(pos.offsetNode), pos.offset)
        };
    } catch (_) {}
    if (doc.caretRangeFromPoint) {
        let range = doc.caretRangeFromPoint(x, y);
        if (range) return {
            node: range.startContainer,
            offset: Math.min($81901ae0222f0506$var$nodeSize(range.startContainer), range.startOffset)
        };
    }
}
const $81901ae0222f0506$var$nav = typeof navigator != "undefined" ? navigator : null;
const $81901ae0222f0506$var$doc = typeof document != "undefined" ? document : null;
const $81901ae0222f0506$var$agent = $81901ae0222f0506$var$nav && $81901ae0222f0506$var$nav.userAgent || "";
const $81901ae0222f0506$var$ie_edge = /Edge\/(\d+)/.exec($81901ae0222f0506$var$agent);
const $81901ae0222f0506$var$ie_upto10 = /MSIE \d/.exec($81901ae0222f0506$var$agent);
const $81901ae0222f0506$var$ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec($81901ae0222f0506$var$agent);
const $81901ae0222f0506$var$ie = !!($81901ae0222f0506$var$ie_upto10 || $81901ae0222f0506$var$ie_11up || $81901ae0222f0506$var$ie_edge);
const $81901ae0222f0506$var$ie_version = $81901ae0222f0506$var$ie_upto10 ? document.documentMode : $81901ae0222f0506$var$ie_11up ? +$81901ae0222f0506$var$ie_11up[1] : $81901ae0222f0506$var$ie_edge ? +$81901ae0222f0506$var$ie_edge[1] : 0;
const $81901ae0222f0506$var$gecko = !$81901ae0222f0506$var$ie && /gecko\/(\d+)/i.test($81901ae0222f0506$var$agent);
$81901ae0222f0506$var$gecko && (/Firefox\/(\d+)/.exec($81901ae0222f0506$var$agent) || [
    0,
    0
])[1];
const $81901ae0222f0506$var$_chrome = !$81901ae0222f0506$var$ie && /Chrome\/(\d+)/.exec($81901ae0222f0506$var$agent);
const $81901ae0222f0506$var$chrome = !!$81901ae0222f0506$var$_chrome;
const $81901ae0222f0506$var$chrome_version = $81901ae0222f0506$var$_chrome ? +$81901ae0222f0506$var$_chrome[1] : 0;
const $81901ae0222f0506$var$safari = !$81901ae0222f0506$var$ie && !!$81901ae0222f0506$var$nav && /Apple Computer/.test($81901ae0222f0506$var$nav.vendor);
// Is true for both iOS and iPadOS for convenience
const $81901ae0222f0506$var$ios = $81901ae0222f0506$var$safari && (/Mobile\/\w+/.test($81901ae0222f0506$var$agent) || !!$81901ae0222f0506$var$nav && $81901ae0222f0506$var$nav.maxTouchPoints > 2);
const $81901ae0222f0506$var$mac = $81901ae0222f0506$var$ios || ($81901ae0222f0506$var$nav ? /Mac/.test($81901ae0222f0506$var$nav.platform) : false);
const $81901ae0222f0506$var$windows = $81901ae0222f0506$var$nav ? /Win/.test($81901ae0222f0506$var$nav.platform) : false;
const $81901ae0222f0506$var$android = /Android \d/.test($81901ae0222f0506$var$agent);
const $81901ae0222f0506$var$webkit = !!$81901ae0222f0506$var$doc && "webkitFontSmoothing" in $81901ae0222f0506$var$doc.documentElement.style;
const $81901ae0222f0506$var$webkit_version = $81901ae0222f0506$var$webkit ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [
    0,
    0
])[1] : 0;
function $81901ae0222f0506$var$windowRect(doc) {
    let vp = doc.defaultView && doc.defaultView.visualViewport;
    if (vp) return {
        left: 0,
        right: vp.width,
        top: 0,
        bottom: vp.height
    };
    return {
        left: 0,
        right: doc.documentElement.clientWidth,
        top: 0,
        bottom: doc.documentElement.clientHeight
    };
}
function $81901ae0222f0506$var$getSide(value, side) {
    return typeof value == "number" ? value : value[side];
}
function $81901ae0222f0506$var$clientRect(node) {
    let rect = node.getBoundingClientRect();
    // Adjust for elements with style "transform: scale()"
    let scaleX = rect.width / node.offsetWidth || 1;
    let scaleY = rect.height / node.offsetHeight || 1;
    // Make sure scrollbar width isn't included in the rectangle
    return {
        left: rect.left,
        right: rect.left + node.clientWidth * scaleX,
        top: rect.top,
        bottom: rect.top + node.clientHeight * scaleY
    };
}
function $81901ae0222f0506$var$scrollRectIntoView(view, rect, startDOM) {
    let scrollThreshold = view.someProp("scrollThreshold") || 0, scrollMargin = view.someProp("scrollMargin") || 5;
    let doc = view.dom.ownerDocument;
    for(let parent = startDOM || view.dom;; parent = $81901ae0222f0506$var$parentNode(parent)){
        if (!parent) break;
        if (parent.nodeType != 1) continue;
        let elt = parent;
        let atTop = elt == doc.body;
        let bounding = atTop ? $81901ae0222f0506$var$windowRect(doc) : $81901ae0222f0506$var$clientRect(elt);
        let moveX = 0, moveY = 0;
        if (rect.top < bounding.top + $81901ae0222f0506$var$getSide(scrollThreshold, "top")) moveY = -(bounding.top - rect.top + $81901ae0222f0506$var$getSide(scrollMargin, "top"));
        else if (rect.bottom > bounding.bottom - $81901ae0222f0506$var$getSide(scrollThreshold, "bottom")) moveY = rect.bottom - rect.top > bounding.bottom - bounding.top ? rect.top + $81901ae0222f0506$var$getSide(scrollMargin, "top") - bounding.top : rect.bottom - bounding.bottom + $81901ae0222f0506$var$getSide(scrollMargin, "bottom");
        if (rect.left < bounding.left + $81901ae0222f0506$var$getSide(scrollThreshold, "left")) moveX = -(bounding.left - rect.left + $81901ae0222f0506$var$getSide(scrollMargin, "left"));
        else if (rect.right > bounding.right - $81901ae0222f0506$var$getSide(scrollThreshold, "right")) moveX = rect.right - bounding.right + $81901ae0222f0506$var$getSide(scrollMargin, "right");
        if (moveX || moveY) {
            if (atTop) doc.defaultView.scrollBy(moveX, moveY);
            else {
                let startX = elt.scrollLeft, startY = elt.scrollTop;
                if (moveY) elt.scrollTop += moveY;
                if (moveX) elt.scrollLeft += moveX;
                let dX = elt.scrollLeft - startX, dY = elt.scrollTop - startY;
                rect = {
                    left: rect.left - dX,
                    top: rect.top - dY,
                    right: rect.right - dX,
                    bottom: rect.bottom - dY
                };
            }
        }
        if (atTop || /^(fixed|sticky)$/.test(getComputedStyle(parent).position)) break;
    }
}
// Store the scroll position of the editor's parent nodes, along with
// the top position of an element near the top of the editor, which
// will be used to make sure the visible viewport remains stable even
// when the size of the content above changes.
function $81901ae0222f0506$var$storeScrollPos(view) {
    let rect = view.dom.getBoundingClientRect(), startY = Math.max(0, rect.top);
    let refDOM, refTop;
    for(let x = (rect.left + rect.right) / 2, y = startY + 1; y < Math.min(innerHeight, rect.bottom); y += 5){
        let dom = view.root.elementFromPoint(x, y);
        if (!dom || dom == view.dom || !view.dom.contains(dom)) continue;
        let localRect = dom.getBoundingClientRect();
        if (localRect.top >= startY - 20) {
            refDOM = dom;
            refTop = localRect.top;
            break;
        }
    }
    return {
        refDOM: refDOM,
        refTop: refTop,
        stack: $81901ae0222f0506$var$scrollStack(view.dom)
    };
}
function $81901ae0222f0506$var$scrollStack(dom) {
    let stack = [], doc = dom.ownerDocument;
    for(let cur = dom; cur; cur = $81901ae0222f0506$var$parentNode(cur)){
        stack.push({
            dom: cur,
            top: cur.scrollTop,
            left: cur.scrollLeft
        });
        if (dom == doc) break;
    }
    return stack;
}
// Reset the scroll position of the editor's parent nodes to that what
// it was before, when storeScrollPos was called.
function $81901ae0222f0506$var$resetScrollPos({ refDOM: refDOM, refTop: refTop, stack: stack }) {
    let newRefTop = refDOM ? refDOM.getBoundingClientRect().top : 0;
    $81901ae0222f0506$var$restoreScrollStack(stack, newRefTop == 0 ? 0 : newRefTop - refTop);
}
function $81901ae0222f0506$var$restoreScrollStack(stack, dTop) {
    for(let i = 0; i < stack.length; i++){
        let { dom: dom, top: top, left: left } = stack[i];
        if (dom.scrollTop != top + dTop) dom.scrollTop = top + dTop;
        if (dom.scrollLeft != left) dom.scrollLeft = left;
    }
}
let $81901ae0222f0506$var$preventScrollSupported = null;
// Feature-detects support for .focus({preventScroll: true}), and uses
// a fallback kludge when not supported.
function $81901ae0222f0506$var$focusPreventScroll(dom) {
    if (dom.setActive) return dom.setActive(); // in IE
    if ($81901ae0222f0506$var$preventScrollSupported) return dom.focus($81901ae0222f0506$var$preventScrollSupported);
    let stored = $81901ae0222f0506$var$scrollStack(dom);
    dom.focus($81901ae0222f0506$var$preventScrollSupported == null ? {
        get preventScroll () {
            $81901ae0222f0506$var$preventScrollSupported = {
                preventScroll: true
            };
            return true;
        }
    } : undefined);
    if (!$81901ae0222f0506$var$preventScrollSupported) {
        $81901ae0222f0506$var$preventScrollSupported = false;
        $81901ae0222f0506$var$restoreScrollStack(stored, 0);
    }
}
function $81901ae0222f0506$var$findOffsetInNode(node, coords) {
    let closest, dxClosest = 2e8, coordsClosest, offset = 0;
    let rowBot = coords.top, rowTop = coords.top;
    let firstBelow, coordsBelow;
    for(let child = node.firstChild, childIndex = 0; child; child = child.nextSibling, childIndex++){
        let rects;
        if (child.nodeType == 1) rects = child.getClientRects();
        else if (child.nodeType == 3) rects = $81901ae0222f0506$var$textRange(child).getClientRects();
        else continue;
        for(let i = 0; i < rects.length; i++){
            let rect = rects[i];
            if (rect.top <= rowBot && rect.bottom >= rowTop) {
                rowBot = Math.max(rect.bottom, rowBot);
                rowTop = Math.min(rect.top, rowTop);
                let dx = rect.left > coords.left ? rect.left - coords.left : rect.right < coords.left ? coords.left - rect.right : 0;
                if (dx < dxClosest) {
                    closest = child;
                    dxClosest = dx;
                    coordsClosest = dx && closest.nodeType == 3 ? {
                        left: rect.right < coords.left ? rect.right : rect.left,
                        top: coords.top
                    } : coords;
                    if (child.nodeType == 1 && dx) offset = childIndex + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0);
                    continue;
                }
            } else if (rect.top > coords.top && !firstBelow && rect.left <= coords.left && rect.right >= coords.left) {
                firstBelow = child;
                coordsBelow = {
                    left: Math.max(rect.left, Math.min(rect.right, coords.left)),
                    top: rect.top
                };
            }
            if (!closest && (coords.left >= rect.right && coords.top >= rect.top || coords.left >= rect.left && coords.top >= rect.bottom)) offset = childIndex + 1;
        }
    }
    if (!closest && firstBelow) {
        closest = firstBelow;
        coordsClosest = coordsBelow;
        dxClosest = 0;
    }
    if (closest && closest.nodeType == 3) return $81901ae0222f0506$var$findOffsetInText(closest, coordsClosest);
    if (!closest || dxClosest && closest.nodeType == 1) return {
        node: node,
        offset: offset
    };
    return $81901ae0222f0506$var$findOffsetInNode(closest, coordsClosest);
}
function $81901ae0222f0506$var$findOffsetInText(node, coords) {
    let len = node.nodeValue.length;
    let range = document.createRange();
    for(let i = 0; i < len; i++){
        range.setEnd(node, i + 1);
        range.setStart(node, i);
        let rect = $81901ae0222f0506$var$singleRect(range, 1);
        if (rect.top == rect.bottom) continue;
        if ($81901ae0222f0506$var$inRect(coords, rect)) return {
            node: node,
            offset: i + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0)
        };
    }
    return {
        node: node,
        offset: 0
    };
}
function $81901ae0222f0506$var$inRect(coords, rect) {
    return coords.left >= rect.left - 1 && coords.left <= rect.right + 1 && coords.top >= rect.top - 1 && coords.top <= rect.bottom + 1;
}
function $81901ae0222f0506$var$targetKludge(dom, coords) {
    let parent = dom.parentNode;
    if (parent && /^li$/i.test(parent.nodeName) && coords.left < dom.getBoundingClientRect().left) return parent;
    return dom;
}
function $81901ae0222f0506$var$posFromElement(view, elt, coords) {
    let { node: node, offset: offset } = $81901ae0222f0506$var$findOffsetInNode(elt, coords), bias = -1;
    if (node.nodeType == 1 && !node.firstChild) {
        let rect = node.getBoundingClientRect();
        bias = rect.left != rect.right && coords.left > (rect.left + rect.right) / 2 ? 1 : -1;
    }
    return view.docView.posFromDOM(node, offset, bias);
}
function $81901ae0222f0506$var$posFromCaret(view, node, offset, coords) {
    // Browser (in caretPosition/RangeFromPoint) will agressively
    // normalize towards nearby inline nodes. Since we are interested in
    // positions between block nodes too, we first walk up the hierarchy
    // of nodes to see if there are block nodes that the coordinates
    // fall outside of. If so, we take the position before/after that
    // block. If not, we call `posFromDOM` on the raw node/offset.
    let outsideBlock = -1;
    for(let cur = node, sawBlock = false;;){
        if (cur == view.dom) break;
        let desc = view.docView.nearestDesc(cur, true), rect;
        if (!desc) return null;
        if (desc.dom.nodeType == 1 && (desc.node.isBlock && desc.parent || !desc.contentDOM) && // Ignore elements with zero-size bounding rectangles
        ((rect = desc.dom.getBoundingClientRect()).width || rect.height)) {
            if (desc.node.isBlock && desc.parent) {
                // Only apply the horizontal test to the innermost block. Vertical for any parent.
                if (!sawBlock && rect.left > coords.left || rect.top > coords.top) outsideBlock = desc.posBefore;
                else if (!sawBlock && rect.right < coords.left || rect.bottom < coords.top) outsideBlock = desc.posAfter;
                sawBlock = true;
            }
            if (!desc.contentDOM && outsideBlock < 0 && !desc.node.isText) {
                // If we are inside a leaf, return the side of the leaf closer to the coords
                let before = desc.node.isBlock ? coords.top < (rect.top + rect.bottom) / 2 : coords.left < (rect.left + rect.right) / 2;
                return before ? desc.posBefore : desc.posAfter;
            }
        }
        cur = desc.dom.parentNode;
    }
    return outsideBlock > -1 ? outsideBlock : view.docView.posFromDOM(node, offset, -1);
}
function $81901ae0222f0506$var$elementFromPoint(element, coords, box) {
    let len = element.childNodes.length;
    if (len && box.top < box.bottom) for(let startI = Math.max(0, Math.min(len - 1, Math.floor(len * (coords.top - box.top) / (box.bottom - box.top)) - 2)), i = startI;;){
        let child = element.childNodes[i];
        if (child.nodeType == 1) {
            let rects = child.getClientRects();
            for(let j = 0; j < rects.length; j++){
                let rect = rects[j];
                if ($81901ae0222f0506$var$inRect(coords, rect)) return $81901ae0222f0506$var$elementFromPoint(child, coords, rect);
            }
        }
        if ((i = (i + 1) % len) == startI) break;
    }
    return element;
}
// Given an x,y position on the editor, get the position in the document.
function $81901ae0222f0506$var$posAtCoords(view, coords) {
    let doc = view.dom.ownerDocument, node, offset = 0;
    let caret = $81901ae0222f0506$var$caretFromPoint(doc, coords.left, coords.top);
    if (caret) ({ node: node, offset: offset } = caret);
    let elt = (view.root.elementFromPoint ? view.root : doc).elementFromPoint(coords.left, coords.top);
    let pos;
    if (!elt || !view.dom.contains(elt.nodeType != 1 ? elt.parentNode : elt)) {
        let box = view.dom.getBoundingClientRect();
        if (!$81901ae0222f0506$var$inRect(coords, box)) return null;
        elt = $81901ae0222f0506$var$elementFromPoint(view.dom, coords, box);
        if (!elt) return null;
    }
    // Safari's caretRangeFromPoint returns nonsense when on a draggable element
    if ($81901ae0222f0506$var$safari) {
        for(let p = elt; node && p; p = $81901ae0222f0506$var$parentNode(p))if (p.draggable) node = undefined;
    }
    elt = $81901ae0222f0506$var$targetKludge(elt, coords);
    if (node) {
        if ($81901ae0222f0506$var$gecko && node.nodeType == 1) {
            // Firefox will sometimes return offsets into <input> nodes, which
            // have no actual children, from caretPositionFromPoint (#953)
            offset = Math.min(offset, node.childNodes.length);
            // It'll also move the returned position before image nodes,
            // even if those are behind it.
            if (offset < node.childNodes.length) {
                let next = node.childNodes[offset], box;
                if (next.nodeName == "IMG" && (box = next.getBoundingClientRect()).right <= coords.left && box.bottom > coords.top) offset++;
            }
        }
        let prev;
        // When clicking above the right side of an uneditable node, Chrome will report a cursor position after that node.
        if ($81901ae0222f0506$var$webkit && offset && node.nodeType == 1 && (prev = node.childNodes[offset - 1]).nodeType == 1 && prev.contentEditable == "false" && prev.getBoundingClientRect().top >= coords.top) offset--;
        // Suspiciously specific kludge to work around caret*FromPoint
        // never returning a position at the end of the document
        if (node == view.dom && offset == node.childNodes.length - 1 && node.lastChild.nodeType == 1 && coords.top > node.lastChild.getBoundingClientRect().bottom) pos = view.state.doc.content.size;
        else if (offset == 0 || node.nodeType != 1 || node.childNodes[offset - 1].nodeName != "BR") pos = $81901ae0222f0506$var$posFromCaret(view, node, offset, coords);
    }
    if (pos == null) pos = $81901ae0222f0506$var$posFromElement(view, elt, coords);
    let desc = view.docView.nearestDesc(elt, true);
    return {
        pos: pos,
        inside: desc ? desc.posAtStart - desc.border : -1
    };
}
function $81901ae0222f0506$var$nonZero(rect) {
    return rect.top < rect.bottom || rect.left < rect.right;
}
function $81901ae0222f0506$var$singleRect(target, bias) {
    let rects = target.getClientRects();
    if (rects.length) {
        let first = rects[bias < 0 ? 0 : rects.length - 1];
        if ($81901ae0222f0506$var$nonZero(first)) return first;
    }
    return Array.prototype.find.call(rects, $81901ae0222f0506$var$nonZero) || target.getBoundingClientRect();
}
const $81901ae0222f0506$var$BIDI = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
// Given a position in the document model, get a bounding box of the
// character at that position, relative to the window.
function $81901ae0222f0506$var$coordsAtPos(view, pos, side) {
    let { node: node, offset: offset, atom: atom } = view.docView.domFromPos(pos, side < 0 ? -1 : 1);
    let supportEmptyRange = $81901ae0222f0506$var$webkit || $81901ae0222f0506$var$gecko;
    if (node.nodeType == 3) {
        // These browsers support querying empty text ranges. Prefer that in
        // bidi context or when at the end of a node.
        if (supportEmptyRange && ($81901ae0222f0506$var$BIDI.test(node.nodeValue) || (side < 0 ? !offset : offset == node.nodeValue.length))) {
            let rect = $81901ae0222f0506$var$singleRect($81901ae0222f0506$var$textRange(node, offset, offset), side);
            // Firefox returns bad results (the position before the space)
            // when querying a position directly after line-broken
            // whitespace. Detect this situation and and kludge around it
            if ($81901ae0222f0506$var$gecko && offset && /\s/.test(node.nodeValue[offset - 1]) && offset < node.nodeValue.length) {
                let rectBefore = $81901ae0222f0506$var$singleRect($81901ae0222f0506$var$textRange(node, offset - 1, offset - 1), -1);
                if (rectBefore.top == rect.top) {
                    let rectAfter = $81901ae0222f0506$var$singleRect($81901ae0222f0506$var$textRange(node, offset, offset + 1), -1);
                    if (rectAfter.top != rect.top) return $81901ae0222f0506$var$flattenV(rectAfter, rectAfter.left < rectBefore.left);
                }
            }
            return rect;
        } else {
            let from = offset, to = offset, takeSide = side < 0 ? 1 : -1;
            if (side < 0 && !offset) {
                to++;
                takeSide = -1;
            } else if (side >= 0 && offset == node.nodeValue.length) {
                from--;
                takeSide = 1;
            } else if (side < 0) from--;
            else to++;
            return $81901ae0222f0506$var$flattenV($81901ae0222f0506$var$singleRect($81901ae0222f0506$var$textRange(node, from, to), takeSide), takeSide < 0);
        }
    }
    let $dom = view.state.doc.resolve(pos - (atom || 0));
    // Return a horizontal line in block context
    if (!$dom.parent.inlineContent) {
        if (atom == null && offset && (side < 0 || offset == $81901ae0222f0506$var$nodeSize(node))) {
            let before = node.childNodes[offset - 1];
            if (before.nodeType == 1) return $81901ae0222f0506$var$flattenH(before.getBoundingClientRect(), false);
        }
        if (atom == null && offset < $81901ae0222f0506$var$nodeSize(node)) {
            let after = node.childNodes[offset];
            if (after.nodeType == 1) return $81901ae0222f0506$var$flattenH(after.getBoundingClientRect(), true);
        }
        return $81901ae0222f0506$var$flattenH(node.getBoundingClientRect(), side >= 0);
    }
    // Inline, not in text node (this is not Bidi-safe)
    if (atom == null && offset && (side < 0 || offset == $81901ae0222f0506$var$nodeSize(node))) {
        let before = node.childNodes[offset - 1];
        let target = before.nodeType == 3 ? $81901ae0222f0506$var$textRange(before, $81901ae0222f0506$var$nodeSize(before) - (supportEmptyRange ? 0 : 1)) : before.nodeType == 1 && (before.nodeName != "BR" || !before.nextSibling) ? before : null;
        if (target) return $81901ae0222f0506$var$flattenV($81901ae0222f0506$var$singleRect(target, 1), false);
    }
    if (atom == null && offset < $81901ae0222f0506$var$nodeSize(node)) {
        let after = node.childNodes[offset];
        while(after.pmViewDesc && after.pmViewDesc.ignoreForCoords)after = after.nextSibling;
        let target = !after ? null : after.nodeType == 3 ? $81901ae0222f0506$var$textRange(after, 0, supportEmptyRange ? 0 : 1) : after.nodeType == 1 ? after : null;
        if (target) return $81901ae0222f0506$var$flattenV($81901ae0222f0506$var$singleRect(target, -1), true);
    }
    // All else failed, just try to get a rectangle for the target node
    return $81901ae0222f0506$var$flattenV($81901ae0222f0506$var$singleRect(node.nodeType == 3 ? $81901ae0222f0506$var$textRange(node) : node, -side), side >= 0);
}
function $81901ae0222f0506$var$flattenV(rect, left) {
    if (rect.width == 0) return rect;
    let x = left ? rect.left : rect.right;
    return {
        top: rect.top,
        bottom: rect.bottom,
        left: x,
        right: x
    };
}
function $81901ae0222f0506$var$flattenH(rect, top) {
    if (rect.height == 0) return rect;
    let y = top ? rect.top : rect.bottom;
    return {
        top: y,
        bottom: y,
        left: rect.left,
        right: rect.right
    };
}
function $81901ae0222f0506$var$withFlushedState(view, state, f) {
    let viewState = view.state, active = view.root.activeElement;
    if (viewState != state) view.updateState(state);
    if (active != view.dom) view.focus();
    try {
        return f();
    } finally{
        if (viewState != state) view.updateState(viewState);
        if (active != view.dom && active) active.focus();
    }
}
// Whether vertical position motion in a given direction
// from a position would leave a text block.
function $81901ae0222f0506$var$endOfTextblockVertical(view, state, dir) {
    let sel = state.selection;
    let $pos = dir == "up" ? sel.$from : sel.$to;
    return $81901ae0222f0506$var$withFlushedState(view, state, ()=>{
        let { node: dom } = view.docView.domFromPos($pos.pos, dir == "up" ? -1 : 1);
        for(;;){
            let nearest = view.docView.nearestDesc(dom, true);
            if (!nearest) break;
            if (nearest.node.isBlock) {
                dom = nearest.contentDOM || nearest.dom;
                break;
            }
            dom = nearest.dom.parentNode;
        }
        let coords = $81901ae0222f0506$var$coordsAtPos(view, $pos.pos, 1);
        for(let child = dom.firstChild; child; child = child.nextSibling){
            let boxes;
            if (child.nodeType == 1) boxes = child.getClientRects();
            else if (child.nodeType == 3) boxes = $81901ae0222f0506$var$textRange(child, 0, child.nodeValue.length).getClientRects();
            else continue;
            for(let i = 0; i < boxes.length; i++){
                let box = boxes[i];
                if (box.bottom > box.top + 1 && (dir == "up" ? coords.top - box.top > (box.bottom - coords.top) * 2 : box.bottom - coords.bottom > (coords.bottom - box.top) * 2)) return false;
            }
        }
        return true;
    });
}
const $81901ae0222f0506$var$maybeRTL = /[\u0590-\u08ac]/;
function $81901ae0222f0506$var$endOfTextblockHorizontal(view, state, dir) {
    let { $head: $head } = state.selection;
    if (!$head.parent.isTextblock) return false;
    let offset = $head.parentOffset, atStart = !offset, atEnd = offset == $head.parent.content.size;
    let sel = view.domSelection();
    if (!sel) return $head.pos == $head.start() || $head.pos == $head.end();
    // If the textblock is all LTR, or the browser doesn't support
    // Selection.modify (Edge), fall back to a primitive approach
    if (!$81901ae0222f0506$var$maybeRTL.test($head.parent.textContent) || !sel.modify) return dir == "left" || dir == "backward" ? atStart : atEnd;
    return $81901ae0222f0506$var$withFlushedState(view, state, ()=>{
        // This is a huge hack, but appears to be the best we can
        // currently do: use `Selection.modify` to move the selection by
        // one character, and see if that moves the cursor out of the
        // textblock (or doesn't move it at all, when at the start/end of
        // the document).
        let { focusNode: oldNode, focusOffset: oldOff, anchorNode: anchorNode, anchorOffset: anchorOffset } = view.domSelectionRange();
        let oldBidiLevel = sel.caretBidiLevel // Only for Firefox
        ;
        sel.modify("move", dir, "character");
        let parentDOM = $head.depth ? view.docView.domAfterPos($head.before()) : view.dom;
        let { focusNode: newNode, focusOffset: newOff } = view.domSelectionRange();
        let result = newNode && !parentDOM.contains(newNode.nodeType == 1 ? newNode : newNode.parentNode) || oldNode == newNode && oldOff == newOff;
        // Restore the previous selection
        try {
            sel.collapse(anchorNode, anchorOffset);
            if (oldNode && (oldNode != anchorNode || oldOff != anchorOffset) && sel.extend) sel.extend(oldNode, oldOff);
        } catch (_) {}
        if (oldBidiLevel != null) sel.caretBidiLevel = oldBidiLevel;
        return result;
    });
}
let $81901ae0222f0506$var$cachedState = null;
let $81901ae0222f0506$var$cachedDir = null;
let $81901ae0222f0506$var$cachedResult = false;
function $81901ae0222f0506$var$endOfTextblock(view, state, dir) {
    if ($81901ae0222f0506$var$cachedState == state && $81901ae0222f0506$var$cachedDir == dir) return $81901ae0222f0506$var$cachedResult;
    $81901ae0222f0506$var$cachedState = state;
    $81901ae0222f0506$var$cachedDir = dir;
    return $81901ae0222f0506$var$cachedResult = dir == "up" || dir == "down" ? $81901ae0222f0506$var$endOfTextblockVertical(view, state, dir) : $81901ae0222f0506$var$endOfTextblockHorizontal(view, state, dir);
}
// View descriptions are data structures that describe the DOM that is
// used to represent the editor's content. They are used for:
//
// - Incremental redrawing when the document changes
//
// - Figuring out what part of the document a given DOM position
//   corresponds to
//
// - Wiring in custom implementations of the editing interface for a
//   given node
//
// They form a doubly-linked mutable tree, starting at `view.docView`.
const $81901ae0222f0506$var$NOT_DIRTY = 0, $81901ae0222f0506$var$CHILD_DIRTY = 1, $81901ae0222f0506$var$CONTENT_DIRTY = 2, $81901ae0222f0506$var$NODE_DIRTY = 3;
// Superclass for the various kinds of descriptions. Defines their
// basic structure and shared methods.
class $81901ae0222f0506$var$ViewDesc {
    constructor(parent, children, dom, // This is the node that holds the child views. It may be null for
    // descs that don't have children.
    contentDOM){
        this.parent = parent;
        this.children = children;
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.dirty = $81901ae0222f0506$var$NOT_DIRTY;
        // An expando property on the DOM node provides a link back to its
        // description.
        dom.pmViewDesc = this;
    }
    // Used to check whether a given description corresponds to a
    // widget/mark/node.
    matchesWidget(widget) {
        return false;
    }
    matchesMark(mark) {
        return false;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return false;
    }
    matchesHack(nodeName) {
        return false;
    }
    // When parsing in-editor content (in domchange.js), we allow
    // descriptions to determine the parse rules that should be used to
    // parse them.
    parseRule() {
        return null;
    }
    // Used by the editor's event handler to ignore events that come
    // from certain descs.
    stopEvent(event) {
        return false;
    }
    // The size of the content represented by this desc.
    get size() {
        let size = 0;
        for(let i = 0; i < this.children.length; i++)size += this.children[i].size;
        return size;
    }
    // For block nodes, this represents the space taken up by their
    // start/end tokens.
    get border() {
        return 0;
    }
    destroy() {
        this.parent = undefined;
        if (this.dom.pmViewDesc == this) this.dom.pmViewDesc = undefined;
        for(let i = 0; i < this.children.length; i++)this.children[i].destroy();
    }
    posBeforeChild(child) {
        for(let i = 0, pos = this.posAtStart;; i++){
            let cur = this.children[i];
            if (cur == child) return pos;
            pos += cur.size;
        }
    }
    get posBefore() {
        return this.parent.posBeforeChild(this);
    }
    get posAtStart() {
        return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
    }
    get posAfter() {
        return this.posBefore + this.size;
    }
    get posAtEnd() {
        return this.posAtStart + this.size - 2 * this.border;
    }
    localPosFromDOM(dom, offset, bias) {
        // If the DOM position is in the content, use the child desc after
        // it to figure out a position.
        if (this.contentDOM && this.contentDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode)) {
            if (bias < 0) {
                let domBefore, desc;
                if (dom == this.contentDOM) domBefore = dom.childNodes[offset - 1];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domBefore = dom.previousSibling;
                }
                while(domBefore && !((desc = domBefore.pmViewDesc) && desc.parent == this))domBefore = domBefore.previousSibling;
                return domBefore ? this.posBeforeChild(desc) + desc.size : this.posAtStart;
            } else {
                let domAfter, desc;
                if (dom == this.contentDOM) domAfter = dom.childNodes[offset];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domAfter = dom.nextSibling;
                }
                while(domAfter && !((desc = domAfter.pmViewDesc) && desc.parent == this))domAfter = domAfter.nextSibling;
                return domAfter ? this.posBeforeChild(desc) : this.posAtEnd;
            }
        }
        // Otherwise, use various heuristics, falling back on the bias
        // parameter, to determine whether to return the position at the
        // start or at the end of this view desc.
        let atEnd;
        if (dom == this.dom && this.contentDOM) atEnd = offset > $81901ae0222f0506$var$domIndex(this.contentDOM);
        else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM)) atEnd = dom.compareDocumentPosition(this.contentDOM) & 2;
        else if (this.dom.firstChild) {
            if (offset == 0) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = false;
                    break;
                }
                if (search.previousSibling) break;
            }
            if (atEnd == null && offset == dom.childNodes.length) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = true;
                    break;
                }
                if (search.nextSibling) break;
            }
        }
        return (atEnd == null ? bias > 0 : atEnd) ? this.posAtEnd : this.posAtStart;
    }
    nearestDesc(dom, onlyNodes = false) {
        for(let first = true, cur = dom; cur; cur = cur.parentNode){
            let desc = this.getDesc(cur), nodeDOM;
            if (desc && (!onlyNodes || desc.node)) {
                // If dom is outside of this desc's nodeDOM, don't count it.
                if (first && (nodeDOM = desc.nodeDOM) && !(nodeDOM.nodeType == 1 ? nodeDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode) : nodeDOM == dom)) first = false;
                else return desc;
            }
        }
    }
    getDesc(dom) {
        let desc = dom.pmViewDesc;
        for(let cur = desc; cur; cur = cur.parent)if (cur == this) return desc;
    }
    posFromDOM(dom, offset, bias) {
        for(let scan = dom; scan; scan = scan.parentNode){
            let desc = this.getDesc(scan);
            if (desc) return desc.localPosFromDOM(dom, offset, bias);
        }
        return -1;
    }
    // Find the desc for the node after the given pos, if any. (When a
    // parent node overrode rendering, there might not be one.)
    descAt(pos) {
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == pos && end != offset) {
                while(!child.border && child.children.length)child = child.children[0];
                return child;
            }
            if (pos < end) return child.descAt(pos - offset - child.border);
            offset = end;
        }
    }
    domFromPos(pos, side) {
        if (!this.contentDOM) return {
            node: this.dom,
            offset: 0,
            atom: pos + 1
        };
        // First find the position in the child array
        let i = 0, offset = 0;
        for(let curPos = 0; i < this.children.length; i++){
            let child = this.children[i], end = curPos + child.size;
            if (end > pos || child instanceof $81901ae0222f0506$var$TrailingHackViewDesc) {
                offset = pos - curPos;
                break;
            }
            curPos = end;
        }
        // If this points into the middle of a child, call through
        if (offset) return this.children[i].domFromPos(offset - this.children[i].border, side);
        // Go back if there were any zero-length widgets with side >= 0 before this point
        for(let prev; i && !(prev = this.children[i - 1]).size && prev instanceof $81901ae0222f0506$var$WidgetViewDesc && prev.side >= 0; i--);
        // Scan towards the first useable node
        if (side <= 0) {
            let prev, enter = true;
            for(;; i--, enter = false){
                prev = i ? this.children[i - 1] : null;
                if (!prev || prev.dom.parentNode == this.contentDOM) break;
            }
            if (prev && side && enter && !prev.border && !prev.domAtom) return prev.domFromPos(prev.size, side);
            return {
                node: this.contentDOM,
                offset: prev ? $81901ae0222f0506$var$domIndex(prev.dom) + 1 : 0
            };
        } else {
            let next, enter = true;
            for(;; i++, enter = false){
                next = i < this.children.length ? this.children[i] : null;
                if (!next || next.dom.parentNode == this.contentDOM) break;
            }
            if (next && enter && !next.border && !next.domAtom) return next.domFromPos(0, side);
            return {
                node: this.contentDOM,
                offset: next ? $81901ae0222f0506$var$domIndex(next.dom) : this.contentDOM.childNodes.length
            };
        }
    }
    // Used to find a DOM range in a single parent for a given changed
    // range.
    parseRange(from, to, base = 0) {
        if (this.children.length == 0) return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: 0,
            toOffset: this.contentDOM.childNodes.length
        };
        let fromOffset = -1, toOffset = -1;
        for(let offset = base, i = 0;; i++){
            let child = this.children[i], end = offset + child.size;
            if (fromOffset == -1 && from <= end) {
                let childBase = offset + child.border;
                // FIXME maybe descend mark views to parse a narrower range?
                if (from >= childBase && to <= end - child.border && child.node && child.contentDOM && this.contentDOM.contains(child.contentDOM)) return child.parseRange(from, to, childBase);
                from = offset;
                for(let j = i; j > 0; j--){
                    let prev = this.children[j - 1];
                    if (prev.size && prev.dom.parentNode == this.contentDOM && !prev.emptyChildAt(1)) {
                        fromOffset = $81901ae0222f0506$var$domIndex(prev.dom) + 1;
                        break;
                    }
                    from -= prev.size;
                }
                if (fromOffset == -1) fromOffset = 0;
            }
            if (fromOffset > -1 && (end > to || i == this.children.length - 1)) {
                to = end;
                for(let j = i + 1; j < this.children.length; j++){
                    let next = this.children[j];
                    if (next.size && next.dom.parentNode == this.contentDOM && !next.emptyChildAt(-1)) {
                        toOffset = $81901ae0222f0506$var$domIndex(next.dom);
                        break;
                    }
                    to += next.size;
                }
                if (toOffset == -1) toOffset = this.contentDOM.childNodes.length;
                break;
            }
            offset = end;
        }
        return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: fromOffset,
            toOffset: toOffset
        };
    }
    emptyChildAt(side) {
        if (this.border || !this.contentDOM || !this.children.length) return false;
        let child = this.children[side < 0 ? 0 : this.children.length - 1];
        return child.size == 0 || child.emptyChildAt(side);
    }
    domAfterPos(pos) {
        let { node: node, offset: offset } = this.domFromPos(pos, 0);
        if (node.nodeType != 1 || offset == node.childNodes.length) throw new RangeError("No node after pos " + pos);
        return node.childNodes[offset];
    }
    // View descs are responsible for setting any selection that falls
    // entirely inside of them, so that custom implementations can do
    // custom things with the selection. Note that this falls apart when
    // a selection starts in such a node and ends in another, in which
    // case we just use whatever domFromPos produces as a best effort.
    setSelection(anchor, head, view, force = false) {
        // If the selection falls entirely in a child, give it to that child
        let from = Math.min(anchor, head), to = Math.max(anchor, head);
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (from > offset && to < end) return child.setSelection(anchor - offset - child.border, head - offset - child.border, view, force);
            offset = end;
        }
        let anchorDOM = this.domFromPos(anchor, anchor ? -1 : 1);
        let headDOM = head == anchor ? anchorDOM : this.domFromPos(head, head ? -1 : 1);
        let domSel = view.root.getSelection();
        let selRange = view.domSelectionRange();
        let brKludge = false;
        // On Firefox, using Selection.collapse to put the cursor after a
        // BR node for some reason doesn't always work (#1073). On Safari,
        // the cursor sometimes inexplicable visually lags behind its
        // reported position in such situations (#1092).
        if (($81901ae0222f0506$var$gecko || $81901ae0222f0506$var$safari) && anchor == head) {
            let { node: node, offset: offset } = anchorDOM;
            if (node.nodeType == 3) {
                brKludge = !!(offset && node.nodeValue[offset - 1] == "\n");
                // Issue #1128
                if (brKludge && offset == node.nodeValue.length) for(let scan = node, after; scan; scan = scan.parentNode){
                    if (after = scan.nextSibling) {
                        if (after.nodeName == "BR") anchorDOM = headDOM = {
                            node: after.parentNode,
                            offset: $81901ae0222f0506$var$domIndex(after) + 1
                        };
                        break;
                    }
                    let desc = scan.pmViewDesc;
                    if (desc && desc.node && desc.node.isBlock) break;
                }
            } else {
                let prev = node.childNodes[offset - 1];
                brKludge = prev && (prev.nodeName == "BR" || prev.contentEditable == "false");
            }
        }
        // Firefox can act strangely when the selection is in front of an
        // uneditable node. See #1163 and https://bugzilla.mozilla.org/show_bug.cgi?id=1709536
        if ($81901ae0222f0506$var$gecko && selRange.focusNode && selRange.focusNode != headDOM.node && selRange.focusNode.nodeType == 1) {
            let after = selRange.focusNode.childNodes[selRange.focusOffset];
            if (after && after.contentEditable == "false") force = true;
        }
        if (!(force || brKludge && $81901ae0222f0506$var$safari) && $81901ae0222f0506$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, selRange.anchorNode, selRange.anchorOffset) && $81901ae0222f0506$var$isEquivalentPosition(headDOM.node, headDOM.offset, selRange.focusNode, selRange.focusOffset)) return;
        // Selection.extend can be used to create an 'inverted' selection
        // (one where the focus is before the anchor), but not all
        // browsers support it yet.
        let domSelExtended = false;
        if ((domSel.extend || anchor == head) && !brKludge) {
            domSel.collapse(anchorDOM.node, anchorDOM.offset);
            try {
                if (anchor != head) domSel.extend(headDOM.node, headDOM.offset);
                domSelExtended = true;
            } catch (_) {
            // In some cases with Chrome the selection is empty after calling
            // collapse, even when it should be valid. This appears to be a bug, but
            // it is difficult to isolate. If this happens fallback to the old path
            // without using extend.
            // Similarly, this could crash on Safari if the editor is hidden, and
            // there was no selection.
            }
        }
        if (!domSelExtended) {
            if (anchor > head) {
                let tmp = anchorDOM;
                anchorDOM = headDOM;
                headDOM = tmp;
            }
            let range = document.createRange();
            range.setEnd(headDOM.node, headDOM.offset);
            range.setStart(anchorDOM.node, anchorDOM.offset);
            domSel.removeAllRanges();
            domSel.addRange(range);
        }
    }
    ignoreMutation(mutation) {
        return !this.contentDOM && mutation.type != "selection";
    }
    get contentLost() {
        return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
    }
    // Remove a subtree of the element tree that has been touched
    // by a DOM change, so that the next update will redraw it.
    markDirty(from, to) {
        for(let offset = 0, i = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == end ? from <= end && to >= offset : from < end && to > offset) {
                let startInside = offset + child.border, endInside = end - child.border;
                if (from >= startInside && to <= endInside) {
                    this.dirty = from == offset || to == end ? $81901ae0222f0506$var$CONTENT_DIRTY : $81901ae0222f0506$var$CHILD_DIRTY;
                    if (from == startInside && to == endInside && (child.contentLost || child.dom.parentNode != this.contentDOM)) child.dirty = $81901ae0222f0506$var$NODE_DIRTY;
                    else child.markDirty(from - startInside, to - startInside);
                    return;
                } else child.dirty = child.dom == child.contentDOM && child.dom.parentNode == this.contentDOM && !child.children.length ? $81901ae0222f0506$var$CONTENT_DIRTY : $81901ae0222f0506$var$NODE_DIRTY;
            }
            offset = end;
        }
        this.dirty = $81901ae0222f0506$var$CONTENT_DIRTY;
    }
    markParentsDirty() {
        let level = 1;
        for(let node = this.parent; node; node = node.parent, level++){
            let dirty = level == 1 ? $81901ae0222f0506$var$CONTENT_DIRTY : $81901ae0222f0506$var$CHILD_DIRTY;
            if (node.dirty < dirty) node.dirty = dirty;
        }
    }
    get domAtom() {
        return false;
    }
    get ignoreForCoords() {
        return false;
    }
    isText(text) {
        return false;
    }
}
// A widget desc represents a widget decoration, which is a DOM node
// drawn between the document nodes.
class $81901ae0222f0506$var$WidgetViewDesc extends $81901ae0222f0506$var$ViewDesc {
    constructor(parent, widget, view, pos){
        let self, dom = widget.type.toDOM;
        if (typeof dom == "function") dom = dom(view, ()=>{
            if (!self) return pos;
            if (self.parent) return self.parent.posBeforeChild(self);
        });
        if (!widget.type.spec.raw) {
            if (dom.nodeType != 1) {
                let wrap = document.createElement("span");
                wrap.appendChild(dom);
                dom = wrap;
            }
            dom.contentEditable = "false";
            dom.classList.add("ProseMirror-widget");
        }
        super(parent, [], dom, null);
        this.widget = widget;
        this.widget = widget;
        self = this;
    }
    matchesWidget(widget) {
        return this.dirty == $81901ae0222f0506$var$NOT_DIRTY && widget.type.eq(this.widget.type);
    }
    parseRule() {
        return {
            ignore: true
        };
    }
    stopEvent(event) {
        let stop = this.widget.spec.stopEvent;
        return stop ? stop(event) : false;
    }
    ignoreMutation(mutation) {
        return mutation.type != "selection" || this.widget.spec.ignoreSelection;
    }
    destroy() {
        this.widget.type.destroy(this.dom);
        super.destroy();
    }
    get domAtom() {
        return true;
    }
    get side() {
        return this.widget.type.side;
    }
}
class $81901ae0222f0506$var$CompositionViewDesc extends $81901ae0222f0506$var$ViewDesc {
    constructor(parent, dom, textDOM, text){
        super(parent, [], dom, null);
        this.textDOM = textDOM;
        this.text = text;
    }
    get size() {
        return this.text.length;
    }
    localPosFromDOM(dom, offset) {
        if (dom != this.textDOM) return this.posAtStart + (offset ? this.size : 0);
        return this.posAtStart + offset;
    }
    domFromPos(pos) {
        return {
            node: this.textDOM,
            offset: pos
        };
    }
    ignoreMutation(mut) {
        return mut.type === 'characterData' && mut.target.nodeValue == mut.oldValue;
    }
}
// A mark desc represents a mark. May have multiple children,
// depending on how the mark is split. Note that marks are drawn using
// a fixed nesting order, for simplicity and predictability, so in
// some cases they will be split more often than would appear
// necessary.
class $81901ae0222f0506$var$MarkViewDesc extends $81901ae0222f0506$var$ViewDesc {
    constructor(parent, mark, dom, contentDOM, spec){
        super(parent, [], dom, contentDOM);
        this.mark = mark;
        this.spec = spec;
    }
    static create(parent, mark, inline, view) {
        let custom = view.nodeViews[mark.type.name];
        let spec = custom && custom(mark, view, inline);
        if (!spec || !spec.dom) spec = (0, $3xw6l.DOMSerializer).renderSpec(document, mark.type.spec.toDOM(mark, inline), null, mark.attrs);
        return new $81901ae0222f0506$var$MarkViewDesc(parent, mark, spec.dom, spec.contentDOM || spec.dom, spec);
    }
    parseRule() {
        if (this.dirty & $81901ae0222f0506$var$NODE_DIRTY || this.mark.type.spec.reparseInView) return null;
        return {
            mark: this.mark.type.name,
            attrs: this.mark.attrs,
            contentElement: this.contentDOM
        };
    }
    matchesMark(mark) {
        return this.dirty != $81901ae0222f0506$var$NODE_DIRTY && this.mark.eq(mark);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        // Move dirty info to nearest node view
        if (this.dirty != $81901ae0222f0506$var$NOT_DIRTY) {
            let parent = this.parent;
            while(!parent.node)parent = parent.parent;
            if (parent.dirty < this.dirty) parent.dirty = this.dirty;
            this.dirty = $81901ae0222f0506$var$NOT_DIRTY;
        }
    }
    slice(from, to, view) {
        let copy = $81901ae0222f0506$var$MarkViewDesc.create(this.parent, this.mark, true, view);
        let nodes = this.children, size = this.size;
        if (to < size) nodes = $81901ae0222f0506$var$replaceNodes(nodes, to, size, view);
        if (from > 0) nodes = $81901ae0222f0506$var$replaceNodes(nodes, 0, from, view);
        for(let i = 0; i < nodes.length; i++)nodes[i].parent = copy;
        copy.children = nodes;
        return copy;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
    destroy() {
        if (this.spec.destroy) this.spec.destroy();
        super.destroy();
    }
}
// Node view descs are the main, most common type of view desc, and
// correspond to an actual node in the document. Unlike mark descs,
// they populate their child array themselves.
class $81901ae0222f0506$var$NodeViewDesc extends $81901ae0222f0506$var$ViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos){
        super(parent, [], dom, contentDOM);
        this.node = node;
        this.outerDeco = outerDeco;
        this.innerDeco = innerDeco;
        this.nodeDOM = nodeDOM;
    }
    // By default, a node is rendered using the `toDOM` method from the
    // node type spec. But client code can use the `nodeViews` spec to
    // supply a custom node view, which can influence various aspects of
    // the way the node works.
    //
    // (Using subclassing for this was intentionally decided against,
    // since it'd require exposing a whole slew of finicky
    // implementation details to the user code that they probably will
    // never need.)
    static create(parent, node, outerDeco, innerDeco, view, pos) {
        let custom = view.nodeViews[node.type.name], descObj;
        let spec = custom && custom(node, view, ()=>{
            // (This is a function that allows the custom view to find its
            // own position)
            if (!descObj) return pos;
            if (descObj.parent) return descObj.parent.posBeforeChild(descObj);
        }, outerDeco, innerDeco);
        let dom = spec && spec.dom, contentDOM = spec && spec.contentDOM;
        if (node.isText) {
            if (!dom) dom = document.createTextNode(node.text);
            else if (dom.nodeType != 3) throw new RangeError("Text must be rendered as a DOM text node");
        } else if (!dom) {
            let spec = (0, $3xw6l.DOMSerializer).renderSpec(document, node.type.spec.toDOM(node), null, node.attrs);
            ({ dom: dom, contentDOM: contentDOM } = spec);
        }
        if (!contentDOM && !node.isText && dom.nodeName != "BR") {
            if (!dom.hasAttribute("contenteditable")) dom.contentEditable = "false";
            if (node.type.spec.draggable) dom.draggable = true;
        }
        let nodeDOM = dom;
        dom = $81901ae0222f0506$var$applyOuterDeco(dom, outerDeco, node);
        if (spec) return descObj = new $81901ae0222f0506$var$CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, spec, view, pos + 1);
        else if (node.isText) return new $81901ae0222f0506$var$TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view);
        else return new $81901ae0222f0506$var$NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, view, pos + 1);
    }
    parseRule() {
        // Experimental kludge to allow opt-in re-parsing of nodes
        if (this.node.type.spec.reparseInView) return null;
        // FIXME the assumption that this can always return the current
        // attrs means that if the user somehow manages to change the
        // attrs in the dom, that won't be picked up. Not entirely sure
        // whether this is a problem
        let rule = {
            node: this.node.type.name,
            attrs: this.node.attrs
        };
        if (this.node.type.whitespace == "pre") rule.preserveWhitespace = "full";
        if (!this.contentDOM) rule.getContent = ()=>this.node.content;
        else if (!this.contentLost) rule.contentElement = this.contentDOM;
        else {
            // Chrome likes to randomly recreate parent nodes when
            // backspacing things. When that happens, this tries to find the
            // new parent.
            for(let i = this.children.length - 1; i >= 0; i--){
                let child = this.children[i];
                if (this.dom.contains(child.dom.parentNode)) {
                    rule.contentElement = child.dom.parentNode;
                    break;
                }
            }
            if (!rule.contentElement) rule.getContent = ()=>(0, $3xw6l.Fragment).empty;
        }
        return rule;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return this.dirty == $81901ae0222f0506$var$NOT_DIRTY && node.eq(this.node) && $81901ae0222f0506$var$sameOuterDeco(outerDeco, this.outerDeco) && innerDeco.eq(this.innerDeco);
    }
    get size() {
        return this.node.nodeSize;
    }
    get border() {
        return this.node.isLeaf ? 0 : 1;
    }
    // Syncs `this.children` to match `this.node.content` and the local
    // decorations, possibly introducing nesting for marks. Then, in a
    // separate step, syncs the DOM inside `this.contentDOM` to
    // `this.children`.
    updateChildren(view, pos) {
        let inline = this.node.inlineContent, off = pos;
        let composition = view.composing ? this.localCompositionInfo(view, pos) : null;
        let localComposition = composition && composition.pos > -1 ? composition : null;
        let compositionInChild = composition && composition.pos < 0;
        let updater = new $81901ae0222f0506$var$ViewTreeUpdater(this, localComposition && localComposition.node, view);
        $81901ae0222f0506$var$iterDeco(this.node, this.innerDeco, (widget, i, insideNode)=>{
            if (widget.spec.marks) updater.syncToMarks(widget.spec.marks, inline, view);
            else if (widget.type.side >= 0 && !insideNode) updater.syncToMarks(i == this.node.childCount ? (0, $3xw6l.Mark).none : this.node.child(i).marks, inline, view);
            // If the next node is a desc matching this widget, reuse it,
            // otherwise insert the widget as a new view desc.
            updater.placeWidget(widget, view, off);
        }, (child, outerDeco, innerDeco, i)=>{
            // Make sure the wrapping mark descs match the node's marks.
            updater.syncToMarks(child.marks, inline, view);
            // Try several strategies for drawing this node
            let compIndex;
            if (updater.findNodeMatch(child, outerDeco, innerDeco, i)) ;
            else if (compositionInChild && view.state.selection.from > off && view.state.selection.to < off + child.nodeSize && (compIndex = updater.findIndexWithChild(composition.node)) > -1 && updater.updateNodeAt(child, outerDeco, innerDeco, compIndex, view)) ;
            else if (updater.updateNextNode(child, outerDeco, innerDeco, view, i, off)) ;
            else // Add it as a new view
            updater.addNode(child, outerDeco, innerDeco, view, off);
            off += child.nodeSize;
        });
        // Drop all remaining descs after the current position.
        updater.syncToMarks([], inline, view);
        if (this.node.isTextblock) updater.addTextblockHacks();
        updater.destroyRest();
        // Sync the DOM if anything changed
        if (updater.changed || this.dirty == $81901ae0222f0506$var$CONTENT_DIRTY) {
            // May have to protect focused DOM from being changed if a composition is active
            if (localComposition) this.protectLocalComposition(view, localComposition);
            $81901ae0222f0506$var$renderDescs(this.contentDOM, this.children, view);
            if ($81901ae0222f0506$var$ios) $81901ae0222f0506$var$iosHacks(this.dom);
        }
    }
    localCompositionInfo(view, pos) {
        // Only do something if both the selection and a focused text node
        // are inside of this node
        let { from: from, to: to } = view.state.selection;
        if (!(view.state.selection instanceof (0, $3lIcL.TextSelection)) || from < pos || to > pos + this.node.content.size) return null;
        let textNode = view.input.compositionNode;
        if (!textNode || !this.dom.contains(textNode.parentNode)) return null;
        if (this.node.inlineContent) {
            // Find the text in the focused node in the node, stop if it's not
            // there (may have been modified through other means, in which
            // case it should overwritten)
            let text = textNode.nodeValue;
            let textPos = $81901ae0222f0506$var$findTextInFragment(this.node.content, text, from - pos, to - pos);
            return textPos < 0 ? null : {
                node: textNode,
                pos: textPos,
                text: text
            };
        } else return {
            node: textNode,
            pos: -1,
            text: ""
        };
    }
    protectLocalComposition(view, { node: node, pos: pos, text: text }) {
        // The node is already part of a local view desc, leave it there
        if (this.getDesc(node)) return;
        // Create a composition view for the orphaned nodes
        let topNode = node;
        for(;; topNode = topNode.parentNode){
            if (topNode.parentNode == this.contentDOM) break;
            while(topNode.previousSibling)topNode.parentNode.removeChild(topNode.previousSibling);
            while(topNode.nextSibling)topNode.parentNode.removeChild(topNode.nextSibling);
            if (topNode.pmViewDesc) topNode.pmViewDesc = undefined;
        }
        let desc = new $81901ae0222f0506$var$CompositionViewDesc(this, topNode, node, text);
        view.input.compositionNodes.push(desc);
        // Patch up this.children to contain the composition view
        this.children = $81901ae0222f0506$var$replaceNodes(this.children, pos, pos + text.length, view, desc);
    }
    // If this desc must be updated to match the given node decoration,
    // do so and return true.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $81901ae0222f0506$var$NODE_DIRTY || !node.sameMarkup(this.node)) return false;
        this.updateInner(node, outerDeco, innerDeco, view);
        return true;
    }
    updateInner(node, outerDeco, innerDeco, view) {
        this.updateOuterDeco(outerDeco);
        this.node = node;
        this.innerDeco = innerDeco;
        if (this.contentDOM) this.updateChildren(view, this.posAtStart);
        this.dirty = $81901ae0222f0506$var$NOT_DIRTY;
    }
    updateOuterDeco(outerDeco) {
        if ($81901ae0222f0506$var$sameOuterDeco(outerDeco, this.outerDeco)) return;
        let needsWrap = this.nodeDOM.nodeType != 1;
        let oldDOM = this.dom;
        this.dom = $81901ae0222f0506$var$patchOuterDeco(this.dom, this.nodeDOM, $81901ae0222f0506$var$computeOuterDeco(this.outerDeco, this.node, needsWrap), $81901ae0222f0506$var$computeOuterDeco(outerDeco, this.node, needsWrap));
        if (this.dom != oldDOM) {
            oldDOM.pmViewDesc = undefined;
            this.dom.pmViewDesc = this;
        }
        this.outerDeco = outerDeco;
    }
    // Mark this node as being the selected node.
    selectNode() {
        if (this.nodeDOM.nodeType == 1) this.nodeDOM.classList.add("ProseMirror-selectednode");
        if (this.contentDOM || !this.node.type.spec.draggable) this.dom.draggable = true;
    }
    // Remove selected node marking from this node.
    deselectNode() {
        if (this.nodeDOM.nodeType == 1) {
            this.nodeDOM.classList.remove("ProseMirror-selectednode");
            if (this.contentDOM || !this.node.type.spec.draggable) this.dom.removeAttribute("draggable");
        }
    }
    get domAtom() {
        return this.node.isAtom;
    }
}
// Create a view desc for the top-level document node, to be exported
// and used by the view class.
function $81901ae0222f0506$var$docViewDesc(doc, outerDeco, innerDeco, dom, view) {
    $81901ae0222f0506$var$applyOuterDeco(dom, outerDeco, doc);
    let docView = new $81901ae0222f0506$var$NodeViewDesc(undefined, doc, outerDeco, innerDeco, dom, dom, dom, view, 0);
    if (docView.contentDOM) docView.updateChildren(view, 0);
    return docView;
}
class $81901ae0222f0506$var$TextViewDesc extends $81901ae0222f0506$var$NodeViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, nodeDOM, view){
        super(parent, node, outerDeco, innerDeco, dom, null, nodeDOM, view, 0);
    }
    parseRule() {
        let skip = this.nodeDOM.parentNode;
        while(skip && skip != this.dom && !skip.pmIsDeco)skip = skip.parentNode;
        return {
            skip: skip || true
        };
    }
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $81901ae0222f0506$var$NODE_DIRTY || this.dirty != $81901ae0222f0506$var$NOT_DIRTY && !this.inParent() || !node.sameMarkup(this.node)) return false;
        this.updateOuterDeco(outerDeco);
        if ((this.dirty != $81901ae0222f0506$var$NOT_DIRTY || node.text != this.node.text) && node.text != this.nodeDOM.nodeValue) {
            this.nodeDOM.nodeValue = node.text;
            if (view.trackWrites == this.nodeDOM) view.trackWrites = null;
        }
        this.node = node;
        this.dirty = $81901ae0222f0506$var$NOT_DIRTY;
        return true;
    }
    inParent() {
        let parentDOM = this.parent.contentDOM;
        for(let n = this.nodeDOM; n; n = n.parentNode)if (n == parentDOM) return true;
        return false;
    }
    domFromPos(pos) {
        return {
            node: this.nodeDOM,
            offset: pos
        };
    }
    localPosFromDOM(dom, offset, bias) {
        if (dom == this.nodeDOM) return this.posAtStart + Math.min(offset, this.node.text.length);
        return super.localPosFromDOM(dom, offset, bias);
    }
    ignoreMutation(mutation) {
        return mutation.type != "characterData" && mutation.type != "selection";
    }
    slice(from, to, view) {
        let node = this.node.cut(from, to), dom = document.createTextNode(node.text);
        return new $81901ae0222f0506$var$TextViewDesc(this.parent, node, this.outerDeco, this.innerDeco, dom, dom, view);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        if (this.dom != this.nodeDOM && (from == 0 || to == this.nodeDOM.nodeValue.length)) this.dirty = $81901ae0222f0506$var$NODE_DIRTY;
    }
    get domAtom() {
        return false;
    }
    isText(text) {
        return this.node.text == text;
    }
}
// A dummy desc used to tag trailing BR or IMG nodes created to work
// around contentEditable terribleness.
class $81901ae0222f0506$var$TrailingHackViewDesc extends $81901ae0222f0506$var$ViewDesc {
    parseRule() {
        return {
            ignore: true
        };
    }
    matchesHack(nodeName) {
        return this.dirty == $81901ae0222f0506$var$NOT_DIRTY && this.dom.nodeName == nodeName;
    }
    get domAtom() {
        return true;
    }
    get ignoreForCoords() {
        return this.dom.nodeName == "IMG";
    }
}
// A separate subclass is used for customized node views, so that the
// extra checks only have to be made for nodes that are actually
// customized.
class $81901ae0222f0506$var$CustomNodeViewDesc extends $81901ae0222f0506$var$NodeViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, spec, view, pos){
        super(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos);
        this.spec = spec;
    }
    // A custom `update` method gets to decide whether the update goes
    // through. If it does, and there's a `contentDOM` node, our logic
    // updates the children.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $81901ae0222f0506$var$NODE_DIRTY) return false;
        if (this.spec.update && (this.node.type == node.type || this.spec.multiType)) {
            let result = this.spec.update(node, outerDeco, innerDeco);
            if (result) this.updateInner(node, outerDeco, innerDeco, view);
            return result;
        } else if (!this.contentDOM && !node.isLeaf) return false;
        else return super.update(node, outerDeco, innerDeco, view);
    }
    selectNode() {
        this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
    }
    deselectNode() {
        this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
    }
    setSelection(anchor, head, view, force) {
        this.spec.setSelection ? this.spec.setSelection(anchor, head, view.root) : super.setSelection(anchor, head, view, force);
    }
    destroy() {
        if (this.spec.destroy) this.spec.destroy();
        super.destroy();
    }
    stopEvent(event) {
        return this.spec.stopEvent ? this.spec.stopEvent(event) : false;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
}
// Sync the content of the given DOM node with the nodes associated
// with the given array of view descs, recursing into mark descs
// because this should sync the subtree for a whole node at a time.
function $81901ae0222f0506$var$renderDescs(parentDOM, descs, view) {
    let dom = parentDOM.firstChild, written = false;
    for(let i = 0; i < descs.length; i++){
        let desc = descs[i], childDOM = desc.dom;
        if (childDOM.parentNode == parentDOM) {
            while(childDOM != dom){
                dom = $81901ae0222f0506$var$rm(dom);
                written = true;
            }
            dom = dom.nextSibling;
        } else {
            written = true;
            parentDOM.insertBefore(childDOM, dom);
        }
        if (desc instanceof $81901ae0222f0506$var$MarkViewDesc) {
            let pos = dom ? dom.previousSibling : parentDOM.lastChild;
            $81901ae0222f0506$var$renderDescs(desc.contentDOM, desc.children, view);
            dom = pos ? pos.nextSibling : parentDOM.firstChild;
        }
    }
    while(dom){
        dom = $81901ae0222f0506$var$rm(dom);
        written = true;
    }
    if (written && view.trackWrites == parentDOM) view.trackWrites = null;
}
const $81901ae0222f0506$var$OuterDecoLevel = function(nodeName) {
    if (nodeName) this.nodeName = nodeName;
};
$81901ae0222f0506$var$OuterDecoLevel.prototype = Object.create(null);
const $81901ae0222f0506$var$noDeco = [
    new $81901ae0222f0506$var$OuterDecoLevel
];
function $81901ae0222f0506$var$computeOuterDeco(outerDeco, node, needsWrap) {
    if (outerDeco.length == 0) return $81901ae0222f0506$var$noDeco;
    let top = needsWrap ? $81901ae0222f0506$var$noDeco[0] : new $81901ae0222f0506$var$OuterDecoLevel, result = [
        top
    ];
    for(let i = 0; i < outerDeco.length; i++){
        let attrs = outerDeco[i].type.attrs;
        if (!attrs) continue;
        if (attrs.nodeName) result.push(top = new $81901ae0222f0506$var$OuterDecoLevel(attrs.nodeName));
        for(let name in attrs){
            let val = attrs[name];
            if (val == null) continue;
            if (needsWrap && result.length == 1) result.push(top = new $81901ae0222f0506$var$OuterDecoLevel(node.isInline ? "span" : "div"));
            if (name == "class") top.class = (top.class ? top.class + " " : "") + val;
            else if (name == "style") top.style = (top.style ? top.style + ";" : "") + val;
            else if (name != "nodeName") top[name] = val;
        }
    }
    return result;
}
function $81901ae0222f0506$var$patchOuterDeco(outerDOM, nodeDOM, prevComputed, curComputed) {
    // Shortcut for trivial case
    if (prevComputed == $81901ae0222f0506$var$noDeco && curComputed == $81901ae0222f0506$var$noDeco) return nodeDOM;
    let curDOM = nodeDOM;
    for(let i = 0; i < curComputed.length; i++){
        let deco = curComputed[i], prev = prevComputed[i];
        if (i) {
            let parent;
            if (prev && prev.nodeName == deco.nodeName && curDOM != outerDOM && (parent = curDOM.parentNode) && parent.nodeName.toLowerCase() == deco.nodeName) curDOM = parent;
            else {
                parent = document.createElement(deco.nodeName);
                parent.pmIsDeco = true;
                parent.appendChild(curDOM);
                prev = $81901ae0222f0506$var$noDeco[0];
                curDOM = parent;
            }
        }
        $81901ae0222f0506$var$patchAttributes(curDOM, prev || $81901ae0222f0506$var$noDeco[0], deco);
    }
    return curDOM;
}
function $81901ae0222f0506$var$patchAttributes(dom, prev, cur) {
    for(let name in prev)if (name != "class" && name != "style" && name != "nodeName" && !(name in cur)) dom.removeAttribute(name);
    for(let name in cur)if (name != "class" && name != "style" && name != "nodeName" && cur[name] != prev[name]) dom.setAttribute(name, cur[name]);
    if (prev.class != cur.class) {
        let prevList = prev.class ? prev.class.split(" ").filter(Boolean) : [];
        let curList = cur.class ? cur.class.split(" ").filter(Boolean) : [];
        for(let i = 0; i < prevList.length; i++)if (curList.indexOf(prevList[i]) == -1) dom.classList.remove(prevList[i]);
        for(let i = 0; i < curList.length; i++)if (prevList.indexOf(curList[i]) == -1) dom.classList.add(curList[i]);
        if (dom.classList.length == 0) dom.removeAttribute("class");
    }
    if (prev.style != cur.style) {
        if (prev.style) {
            let prop = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, m;
            while(m = prop.exec(prev.style))dom.style.removeProperty(m[1]);
        }
        if (cur.style) dom.style.cssText += cur.style;
    }
}
function $81901ae0222f0506$var$applyOuterDeco(dom, deco, node) {
    return $81901ae0222f0506$var$patchOuterDeco(dom, dom, $81901ae0222f0506$var$noDeco, $81901ae0222f0506$var$computeOuterDeco(deco, node, dom.nodeType != 1));
}
function $81901ae0222f0506$var$sameOuterDeco(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!a[i].type.eq(b[i].type)) return false;
    return true;
}
// Remove a DOM node and return its next sibling.
function $81901ae0222f0506$var$rm(dom) {
    let next = dom.nextSibling;
    dom.parentNode.removeChild(dom);
    return next;
}
// Helper class for incrementally updating a tree of mark descs and
// the widget and node descs inside of them.
class $81901ae0222f0506$var$ViewTreeUpdater {
    constructor(top, lock, view){
        this.lock = lock;
        this.view = view;
        // Index into `this.top`'s child array, represents the current
        // update position.
        this.index = 0;
        // When entering a mark, the current top and index are pushed
        // onto this.
        this.stack = [];
        // Tracks whether anything was changed
        this.changed = false;
        this.top = top;
        this.preMatch = $81901ae0222f0506$var$preMatch(top.node.content, top);
    }
    // Destroy and remove the children between the given indices in
    // `this.top`.
    destroyBetween(start, end) {
        if (start == end) return;
        for(let i = start; i < end; i++)this.top.children[i].destroy();
        this.top.children.splice(start, end - start);
        this.changed = true;
    }
    // Destroy all remaining children in `this.top`.
    destroyRest() {
        this.destroyBetween(this.index, this.top.children.length);
    }
    // Sync the current stack of mark descs with the given array of
    // marks, reusing existing mark descs when possible.
    syncToMarks(marks, inline, view) {
        let keep = 0, depth = this.stack.length >> 1;
        let maxKeep = Math.min(depth, marks.length);
        while(keep < maxKeep && (keep == depth - 1 ? this.top : this.stack[keep + 1 << 1]).matchesMark(marks[keep]) && marks[keep].type.spec.spanning !== false)keep++;
        while(keep < depth){
            this.destroyRest();
            this.top.dirty = $81901ae0222f0506$var$NOT_DIRTY;
            this.index = this.stack.pop();
            this.top = this.stack.pop();
            depth--;
        }
        while(depth < marks.length){
            this.stack.push(this.top, this.index + 1);
            let found = -1;
            for(let i = this.index; i < Math.min(this.index + 3, this.top.children.length); i++){
                let next = this.top.children[i];
                if (next.matchesMark(marks[depth]) && !this.isLocked(next.dom)) {
                    found = i;
                    break;
                }
            }
            if (found > -1) {
                if (found > this.index) {
                    this.changed = true;
                    this.destroyBetween(this.index, found);
                }
                this.top = this.top.children[this.index];
            } else {
                let markDesc = $81901ae0222f0506$var$MarkViewDesc.create(this.top, marks[depth], inline, view);
                this.top.children.splice(this.index, 0, markDesc);
                this.top = markDesc;
                this.changed = true;
            }
            this.index = 0;
            depth++;
        }
    }
    // Try to find a node desc matching the given data. Skip over it and
    // return true when successful.
    findNodeMatch(node, outerDeco, innerDeco, index) {
        let found = -1, targetDesc;
        if (index >= this.preMatch.index && (targetDesc = this.preMatch.matches[index - this.preMatch.index]).parent == this.top && targetDesc.matchesNode(node, outerDeco, innerDeco)) found = this.top.children.indexOf(targetDesc, this.index);
        else for(let i = this.index, e = Math.min(this.top.children.length, i + 5); i < e; i++){
            let child = this.top.children[i];
            if (child.matchesNode(node, outerDeco, innerDeco) && !this.preMatch.matched.has(child)) {
                found = i;
                break;
            }
        }
        if (found < 0) return false;
        this.destroyBetween(this.index, found);
        this.index++;
        return true;
    }
    updateNodeAt(node, outerDeco, innerDeco, index, view) {
        let child = this.top.children[index];
        if (child.dirty == $81901ae0222f0506$var$NODE_DIRTY && child.dom == child.contentDOM) child.dirty = $81901ae0222f0506$var$CONTENT_DIRTY;
        if (!child.update(node, outerDeco, innerDeco, view)) return false;
        this.destroyBetween(this.index, index);
        this.index++;
        return true;
    }
    findIndexWithChild(domNode) {
        for(;;){
            let parent = domNode.parentNode;
            if (!parent) return -1;
            if (parent == this.top.contentDOM) {
                let desc = domNode.pmViewDesc;
                if (desc) for(let i = this.index; i < this.top.children.length; i++){
                    if (this.top.children[i] == desc) return i;
                }
                return -1;
            }
            domNode = parent;
        }
    }
    // Try to update the next node, if any, to the given data. Checks
    // pre-matches to avoid overwriting nodes that could still be used.
    updateNextNode(node, outerDeco, innerDeco, view, index, pos) {
        for(let i = this.index; i < this.top.children.length; i++){
            let next = this.top.children[i];
            if (next instanceof $81901ae0222f0506$var$NodeViewDesc) {
                let preMatch = this.preMatch.matched.get(next);
                if (preMatch != null && preMatch != index) return false;
                let nextDOM = next.dom, updated;
                // Can't update if nextDOM is or contains this.lock, except if
                // it's a text node whose content already matches the new text
                // and whose decorations match the new ones.
                let locked = this.isLocked(nextDOM) && !(node.isText && next.node && next.node.isText && next.nodeDOM.nodeValue == node.text && next.dirty != $81901ae0222f0506$var$NODE_DIRTY && $81901ae0222f0506$var$sameOuterDeco(outerDeco, next.outerDeco));
                if (!locked && next.update(node, outerDeco, innerDeco, view)) {
                    this.destroyBetween(this.index, i);
                    if (next.dom != nextDOM) this.changed = true;
                    this.index++;
                    return true;
                } else if (!locked && (updated = this.recreateWrapper(next, node, outerDeco, innerDeco, view, pos))) {
                    this.destroyBetween(this.index, i);
                    this.top.children[this.index] = updated;
                    if (updated.contentDOM) {
                        updated.dirty = $81901ae0222f0506$var$CONTENT_DIRTY;
                        updated.updateChildren(view, pos + 1);
                        updated.dirty = $81901ae0222f0506$var$NOT_DIRTY;
                    }
                    this.changed = true;
                    this.index++;
                    return true;
                }
                break;
            }
        }
        return false;
    }
    // When a node with content is replaced by a different node with
    // identical content, move over its children.
    recreateWrapper(next, node, outerDeco, innerDeco, view, pos) {
        if (next.dirty || node.isAtom || !next.children.length || !next.node.content.eq(node.content) || !$81901ae0222f0506$var$sameOuterDeco(outerDeco, next.outerDeco) || !innerDeco.eq(next.innerDeco)) return null;
        let wrapper = $81901ae0222f0506$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (wrapper.contentDOM) {
            wrapper.children = next.children;
            next.children = [];
            for (let ch of wrapper.children)ch.parent = wrapper;
        }
        next.destroy();
        return wrapper;
    }
    // Insert the node as a newly created node desc.
    addNode(node, outerDeco, innerDeco, view, pos) {
        let desc = $81901ae0222f0506$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (desc.contentDOM) desc.updateChildren(view, pos + 1);
        this.top.children.splice(this.index++, 0, desc);
        this.changed = true;
    }
    placeWidget(widget, view, pos) {
        let next = this.index < this.top.children.length ? this.top.children[this.index] : null;
        if (next && next.matchesWidget(widget) && (widget == next.widget || !next.widget.type.toDOM.parentNode)) this.index++;
        else {
            let desc = new $81901ae0222f0506$var$WidgetViewDesc(this.top, widget, view, pos);
            this.top.children.splice(this.index++, 0, desc);
            this.changed = true;
        }
    }
    // Make sure a textblock looks and behaves correctly in
    // contentEditable.
    addTextblockHacks() {
        let lastChild = this.top.children[this.index - 1], parent = this.top;
        while(lastChild instanceof $81901ae0222f0506$var$MarkViewDesc){
            parent = lastChild;
            lastChild = parent.children[parent.children.length - 1];
        }
        if (!lastChild || // Empty textblock
        !(lastChild instanceof $81901ae0222f0506$var$TextViewDesc) || /\n$/.test(lastChild.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(lastChild.node.text)) {
            // Avoid bugs in Safari's cursor drawing (#1165) and Chrome's mouse selection (#1152)
            if (($81901ae0222f0506$var$safari || $81901ae0222f0506$var$chrome) && lastChild && lastChild.dom.contentEditable == "false") this.addHackNode("IMG", parent);
            this.addHackNode("BR", this.top);
        }
    }
    addHackNode(nodeName, parent) {
        if (parent == this.top && this.index < parent.children.length && parent.children[this.index].matchesHack(nodeName)) this.index++;
        else {
            let dom = document.createElement(nodeName);
            if (nodeName == "IMG") {
                dom.className = "ProseMirror-separator";
                dom.alt = "";
            }
            if (nodeName == "BR") dom.className = "ProseMirror-trailingBreak";
            let hack = new $81901ae0222f0506$var$TrailingHackViewDesc(this.top, [], dom, null);
            if (parent != this.top) parent.children.push(hack);
            else parent.children.splice(this.index++, 0, hack);
            this.changed = true;
        }
    }
    isLocked(node) {
        return this.lock && (node == this.lock || node.nodeType == 1 && node.contains(this.lock.parentNode));
    }
}
// Iterate from the end of the fragment and array of descs to find
// directly matching ones, in order to avoid overeagerly reusing those
// for other nodes. Returns the fragment index of the first node that
// is part of the sequence of matched nodes at the end of the
// fragment.
function $81901ae0222f0506$var$preMatch(frag, parentDesc) {
    let curDesc = parentDesc, descI = curDesc.children.length;
    let fI = frag.childCount, matched = new Map, matches = [];
    outer: while(fI > 0){
        let desc;
        for(;;){
            if (descI) {
                let next = curDesc.children[descI - 1];
                if (next instanceof $81901ae0222f0506$var$MarkViewDesc) {
                    curDesc = next;
                    descI = next.children.length;
                } else {
                    desc = next;
                    descI--;
                    break;
                }
            } else if (curDesc == parentDesc) break outer;
            else {
                // FIXME
                descI = curDesc.parent.children.indexOf(curDesc);
                curDesc = curDesc.parent;
            }
        }
        let node = desc.node;
        if (!node) continue;
        if (node != frag.child(fI - 1)) break;
        --fI;
        matched.set(desc, fI);
        matches.push(desc);
    }
    return {
        index: fI,
        matched: matched,
        matches: matches.reverse()
    };
}
function $81901ae0222f0506$var$compareSide(a, b) {
    return a.type.side - b.type.side;
}
// This function abstracts iterating over the nodes and decorations in
// a fragment. Calls `onNode` for each node, with its local and child
// decorations. Splits text nodes when there is a decoration starting
// or ending inside of them. Calls `onWidget` for each widget.
function $81901ae0222f0506$var$iterDeco(parent, deco, onWidget, onNode) {
    let locals = deco.locals(parent), offset = 0;
    // Simple, cheap variant for when there are no local decorations
    if (locals.length == 0) {
        for(let i = 0; i < parent.childCount; i++){
            let child = parent.child(i);
            onNode(child, locals, deco.forChild(offset, child), i);
            offset += child.nodeSize;
        }
        return;
    }
    let decoIndex = 0, active = [], restNode = null;
    for(let parentIndex = 0;;){
        let widget, widgets;
        while(decoIndex < locals.length && locals[decoIndex].to == offset){
            let next = locals[decoIndex++];
            if (next.widget) {
                if (!widget) widget = next;
                else (widgets || (widgets = [
                    widget
                ])).push(next);
            }
        }
        if (widget) {
            if (widgets) {
                widgets.sort($81901ae0222f0506$var$compareSide);
                for(let i = 0; i < widgets.length; i++)onWidget(widgets[i], parentIndex, !!restNode);
            } else onWidget(widget, parentIndex, !!restNode);
        }
        let child, index;
        if (restNode) {
            index = -1;
            child = restNode;
            restNode = null;
        } else if (parentIndex < parent.childCount) {
            index = parentIndex;
            child = parent.child(parentIndex++);
        } else break;
        for(let i = 0; i < active.length; i++)if (active[i].to <= offset) active.splice(i--, 1);
        while(decoIndex < locals.length && locals[decoIndex].from <= offset && locals[decoIndex].to > offset)active.push(locals[decoIndex++]);
        let end = offset + child.nodeSize;
        if (child.isText) {
            let cutAt = end;
            if (decoIndex < locals.length && locals[decoIndex].from < cutAt) cutAt = locals[decoIndex].from;
            for(let i = 0; i < active.length; i++)if (active[i].to < cutAt) cutAt = active[i].to;
            if (cutAt < end) {
                restNode = child.cut(cutAt - offset);
                child = child.cut(0, cutAt - offset);
                end = cutAt;
                index = -1;
            }
        } else while(decoIndex < locals.length && locals[decoIndex].to < end)decoIndex++;
        let outerDeco = child.isInline && !child.isLeaf ? active.filter((d)=>!d.inline) : active.slice();
        onNode(child, outerDeco, deco.forChild(offset, child), index);
        offset = end;
    }
}
// List markers in Mobile Safari will mysteriously disappear
// sometimes. This works around that.
function $81901ae0222f0506$var$iosHacks(dom) {
    if (dom.nodeName == "UL" || dom.nodeName == "OL") {
        let oldCSS = dom.style.cssText;
        dom.style.cssText = oldCSS + "; list-style: square !important";
        window.getComputedStyle(dom).listStyle;
        dom.style.cssText = oldCSS;
    }
}
// Find a piece of text in an inline fragment, overlapping from-to
function $81901ae0222f0506$var$findTextInFragment(frag, text, from, to) {
    for(let i = 0, pos = 0; i < frag.childCount && pos <= to;){
        let child = frag.child(i++), childStart = pos;
        pos += child.nodeSize;
        if (!child.isText) continue;
        let str = child.text;
        while(i < frag.childCount){
            let next = frag.child(i++);
            pos += next.nodeSize;
            if (!next.isText) break;
            str += next.text;
        }
        if (pos >= from) {
            if (pos >= to && str.slice(to - text.length - childStart, to - childStart) == text) return to - text.length;
            let found = childStart < to ? str.lastIndexOf(text, to - childStart - 1) : -1;
            if (found >= 0 && found + text.length + childStart >= from) return childStart + found;
            if (from == to && str.length >= to + text.length - childStart && str.slice(to - childStart, to - childStart + text.length) == text) return to;
        }
    }
    return -1;
}
// Replace range from-to in an array of view descs with replacement
// (may be null to just delete). This goes very much against the grain
// of the rest of this code, which tends to create nodes with the
// right shape in one go, rather than messing with them after
// creation, but is necessary in the composition hack.
function $81901ae0222f0506$var$replaceNodes(nodes, from, to, view, replacement) {
    let result = [];
    for(let i = 0, off = 0; i < nodes.length; i++){
        let child = nodes[i], start = off, end = off += child.size;
        if (start >= to || end <= from) result.push(child);
        else {
            if (start < from) result.push(child.slice(0, from - start, view));
            if (replacement) {
                result.push(replacement);
                replacement = undefined;
            }
            if (end > to) result.push(child.slice(to - start, child.size, view));
        }
    }
    return result;
}
function $81901ae0222f0506$var$selectionFromDOM(view, origin = null) {
    let domSel = view.domSelectionRange(), doc = view.state.doc;
    if (!domSel.focusNode) return null;
    let nearestDesc = view.docView.nearestDesc(domSel.focusNode), inWidget = nearestDesc && nearestDesc.size == 0;
    let head = view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset, 1);
    if (head < 0) return null;
    let $head = doc.resolve(head), anchor, selection;
    if ($81901ae0222f0506$var$selectionCollapsed(domSel)) {
        anchor = head;
        while(nearestDesc && !nearestDesc.node)nearestDesc = nearestDesc.parent;
        let nearestDescNode = nearestDesc.node;
        if (nearestDesc && nearestDescNode.isAtom && (0, $3lIcL.NodeSelection).isSelectable(nearestDescNode) && nearestDesc.parent && !(nearestDescNode.isInline && $81901ae0222f0506$var$isOnEdge(domSel.focusNode, domSel.focusOffset, nearestDesc.dom))) {
            let pos = nearestDesc.posBefore;
            selection = new (0, $3lIcL.NodeSelection)(head == pos ? $head : doc.resolve(pos));
        }
    } else {
        if (domSel instanceof view.dom.ownerDocument.defaultView.Selection && domSel.rangeCount > 1) {
            let min = head, max = head;
            for(let i = 0; i < domSel.rangeCount; i++){
                let range = domSel.getRangeAt(i);
                min = Math.min(min, view.docView.posFromDOM(range.startContainer, range.startOffset, 1));
                max = Math.max(max, view.docView.posFromDOM(range.endContainer, range.endOffset, -1));
            }
            if (min < 0) return null;
            [anchor, head] = max == view.state.selection.anchor ? [
                max,
                min
            ] : [
                min,
                max
            ];
            $head = doc.resolve(head);
        } else anchor = view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset, 1);
        if (anchor < 0) return null;
    }
    let $anchor = doc.resolve(anchor);
    if (!selection) {
        let bias = origin == "pointer" || view.state.selection.head < $head.pos && !inWidget ? 1 : -1;
        selection = $81901ae0222f0506$var$selectionBetween(view, $anchor, $head, bias);
    }
    return selection;
}
function $81901ae0222f0506$var$editorOwnsSelection(view) {
    return view.editable ? view.hasFocus() : $81901ae0222f0506$var$hasSelection(view) && document.activeElement && document.activeElement.contains(view.dom);
}
function $81901ae0222f0506$var$selectionToDOM(view, force = false) {
    let sel = view.state.selection;
    $81901ae0222f0506$var$syncNodeSelection(view, sel);
    if (!$81901ae0222f0506$var$editorOwnsSelection(view)) return;
    // The delayed drag selection causes issues with Cell Selections
    // in Safari. And the drag selection delay is to workarond issues
    // which only present in Chrome.
    if (!force && view.input.mouseDown && view.input.mouseDown.allowDefault && $81901ae0222f0506$var$chrome) {
        let domSel = view.domSelectionRange(), curSel = view.domObserver.currentSelection;
        if (domSel.anchorNode && curSel.anchorNode && $81901ae0222f0506$var$isEquivalentPosition(domSel.anchorNode, domSel.anchorOffset, curSel.anchorNode, curSel.anchorOffset)) {
            view.input.mouseDown.delayedSelectionSync = true;
            view.domObserver.setCurSelection();
            return;
        }
    }
    view.domObserver.disconnectSelection();
    if (view.cursorWrapper) $81901ae0222f0506$var$selectCursorWrapper(view);
    else {
        let { anchor: anchor, head: head } = sel, resetEditableFrom, resetEditableTo;
        if ($81901ae0222f0506$var$brokenSelectBetweenUneditable && !(sel instanceof (0, $3lIcL.TextSelection))) {
            if (!sel.$from.parent.inlineContent) resetEditableFrom = $81901ae0222f0506$var$temporarilyEditableNear(view, sel.from);
            if (!sel.empty && !sel.$from.parent.inlineContent) resetEditableTo = $81901ae0222f0506$var$temporarilyEditableNear(view, sel.to);
        }
        view.docView.setSelection(anchor, head, view, force);
        if ($81901ae0222f0506$var$brokenSelectBetweenUneditable) {
            if (resetEditableFrom) $81901ae0222f0506$var$resetEditable(resetEditableFrom);
            if (resetEditableTo) $81901ae0222f0506$var$resetEditable(resetEditableTo);
        }
        if (sel.visible) view.dom.classList.remove("ProseMirror-hideselection");
        else {
            view.dom.classList.add("ProseMirror-hideselection");
            if ("onselectionchange" in document) $81901ae0222f0506$var$removeClassOnSelectionChange(view);
        }
    }
    view.domObserver.setCurSelection();
    view.domObserver.connectSelection();
}
// Kludge to work around Webkit not allowing a selection to start/end
// between non-editable block nodes. We briefly make something
// editable, set the selection, then set it uneditable again.
const $81901ae0222f0506$var$brokenSelectBetweenUneditable = $81901ae0222f0506$var$safari || $81901ae0222f0506$var$chrome && $81901ae0222f0506$var$chrome_version < 63;
function $81901ae0222f0506$var$temporarilyEditableNear(view, pos) {
    let { node: node, offset: offset } = view.docView.domFromPos(pos, 0);
    let after = offset < node.childNodes.length ? node.childNodes[offset] : null;
    let before = offset ? node.childNodes[offset - 1] : null;
    if ($81901ae0222f0506$var$safari && after && after.contentEditable == "false") return $81901ae0222f0506$var$setEditable(after);
    if ((!after || after.contentEditable == "false") && (!before || before.contentEditable == "false")) {
        if (after) return $81901ae0222f0506$var$setEditable(after);
        else if (before) return $81901ae0222f0506$var$setEditable(before);
    }
}
function $81901ae0222f0506$var$setEditable(element) {
    element.contentEditable = "true";
    if ($81901ae0222f0506$var$safari && element.draggable) {
        element.draggable = false;
        element.wasDraggable = true;
    }
    return element;
}
function $81901ae0222f0506$var$resetEditable(element) {
    element.contentEditable = "false";
    if (element.wasDraggable) {
        element.draggable = true;
        element.wasDraggable = null;
    }
}
function $81901ae0222f0506$var$removeClassOnSelectionChange(view) {
    let doc = view.dom.ownerDocument;
    doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
    let domSel = view.domSelectionRange();
    let node = domSel.anchorNode, offset = domSel.anchorOffset;
    doc.addEventListener("selectionchange", view.input.hideSelectionGuard = ()=>{
        if (domSel.anchorNode != node || domSel.anchorOffset != offset) {
            doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
            setTimeout(()=>{
                if (!$81901ae0222f0506$var$editorOwnsSelection(view) || view.state.selection.visible) view.dom.classList.remove("ProseMirror-hideselection");
            }, 20);
        }
    });
}
function $81901ae0222f0506$var$selectCursorWrapper(view) {
    let domSel = view.domSelection(), range = document.createRange();
    if (!domSel) return;
    let node = view.cursorWrapper.dom, img = node.nodeName == "IMG";
    if (img) range.setStart(node.parentNode, $81901ae0222f0506$var$domIndex(node) + 1);
    else range.setStart(node, 0);
    range.collapse(true);
    domSel.removeAllRanges();
    domSel.addRange(range);
    // Kludge to kill 'control selection' in IE11 when selecting an
    // invisible cursor wrapper, since that would result in those weird
    // resize handles and a selection that considers the absolutely
    // positioned wrapper, rather than the root editable node, the
    // focused element.
    if (!img && !view.state.selection.visible && $81901ae0222f0506$var$ie && $81901ae0222f0506$var$ie_version <= 11) {
        node.disabled = true;
        node.disabled = false;
    }
}
function $81901ae0222f0506$var$syncNodeSelection(view, sel) {
    if (sel instanceof (0, $3lIcL.NodeSelection)) {
        let desc = view.docView.descAt(sel.from);
        if (desc != view.lastSelectedViewDesc) {
            $81901ae0222f0506$var$clearNodeSelection(view);
            if (desc) desc.selectNode();
            view.lastSelectedViewDesc = desc;
        }
    } else $81901ae0222f0506$var$clearNodeSelection(view);
}
// Clear all DOM statefulness of the last node selection.
function $81901ae0222f0506$var$clearNodeSelection(view) {
    if (view.lastSelectedViewDesc) {
        if (view.lastSelectedViewDesc.parent) view.lastSelectedViewDesc.deselectNode();
        view.lastSelectedViewDesc = undefined;
    }
}
function $81901ae0222f0506$var$selectionBetween(view, $anchor, $head, bias) {
    return view.someProp("createSelectionBetween", (f)=>f(view, $anchor, $head)) || (0, $3lIcL.TextSelection).between($anchor, $head, bias);
}
function $81901ae0222f0506$var$hasFocusAndSelection(view) {
    if (view.editable && !view.hasFocus()) return false;
    return $81901ae0222f0506$var$hasSelection(view);
}
function $81901ae0222f0506$var$hasSelection(view) {
    let sel = view.domSelectionRange();
    if (!sel.anchorNode) return false;
    try {
        // Firefox will raise 'permission denied' errors when accessing
        // properties of `sel.anchorNode` when it's in a generated CSS
        // element.
        return view.dom.contains(sel.anchorNode.nodeType == 3 ? sel.anchorNode.parentNode : sel.anchorNode) && (view.editable || view.dom.contains(sel.focusNode.nodeType == 3 ? sel.focusNode.parentNode : sel.focusNode));
    } catch (_) {
        return false;
    }
}
function $81901ae0222f0506$var$anchorInRightPlace(view) {
    let anchorDOM = view.docView.domFromPos(view.state.selection.anchor, 0);
    let domSel = view.domSelectionRange();
    return $81901ae0222f0506$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset);
}
function $81901ae0222f0506$var$moveSelectionBlock(state, dir) {
    let { $anchor: $anchor, $head: $head } = state.selection;
    let $side = dir > 0 ? $anchor.max($head) : $anchor.min($head);
    let $start = !$side.parent.inlineContent ? $side : $side.depth ? state.doc.resolve(dir > 0 ? $side.after() : $side.before()) : null;
    return $start && (0, $3lIcL.Selection).findFrom($start, dir);
}
function $81901ae0222f0506$var$apply(view, sel) {
    view.dispatch(view.state.tr.setSelection(sel).scrollIntoView());
    return true;
}
function $81901ae0222f0506$var$selectHorizontally(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $3lIcL.TextSelection)) {
        if (mods.indexOf("s") > -1) {
            let { $head: $head } = sel, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter;
            if (!node || node.isText || !node.isLeaf) return false;
            let $newHead = view.state.doc.resolve($head.pos + node.nodeSize * (dir < 0 ? -1 : 1));
            return $81901ae0222f0506$var$apply(view, new (0, $3lIcL.TextSelection)(sel.$anchor, $newHead));
        } else if (!sel.empty) return false;
        else if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) {
            let next = $81901ae0222f0506$var$moveSelectionBlock(view.state, dir);
            if (next && next instanceof (0, $3lIcL.NodeSelection)) return $81901ae0222f0506$var$apply(view, next);
            return false;
        } else if (!($81901ae0222f0506$var$mac && mods.indexOf("m") > -1)) {
            let $head = sel.$head, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter, desc;
            if (!node || node.isText) return false;
            let nodePos = dir < 0 ? $head.pos - node.nodeSize : $head.pos;
            if (!(node.isAtom || (desc = view.docView.descAt(nodePos)) && !desc.contentDOM)) return false;
            if ((0, $3lIcL.NodeSelection).isSelectable(node)) return $81901ae0222f0506$var$apply(view, new (0, $3lIcL.NodeSelection)(dir < 0 ? view.state.doc.resolve($head.pos - node.nodeSize) : $head));
            else if ($81901ae0222f0506$var$webkit) // Chrome and Safari will introduce extra pointless cursor
            // positions around inline uneditable nodes, so we have to
            // take over and move the cursor past them (#937)
            return $81901ae0222f0506$var$apply(view, new (0, $3lIcL.TextSelection)(view.state.doc.resolve(dir < 0 ? nodePos : nodePos + node.nodeSize)));
            else return false;
        }
    } else if (sel instanceof (0, $3lIcL.NodeSelection) && sel.node.isInline) return $81901ae0222f0506$var$apply(view, new (0, $3lIcL.TextSelection)(dir > 0 ? sel.$to : sel.$from));
    else {
        let next = $81901ae0222f0506$var$moveSelectionBlock(view.state, dir);
        if (next) return $81901ae0222f0506$var$apply(view, next);
        return false;
    }
}
function $81901ae0222f0506$var$nodeLen(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $81901ae0222f0506$var$isIgnorable(dom, dir) {
    let desc = dom.pmViewDesc;
    return desc && desc.size == 0 && (dir < 0 || dom.nextSibling || dom.nodeName != "BR");
}
function $81901ae0222f0506$var$skipIgnoredNodes(view, dir) {
    return dir < 0 ? $81901ae0222f0506$var$skipIgnoredNodesBefore(view) : $81901ae0222f0506$var$skipIgnoredNodesAfter(view);
}
// Make sure the cursor isn't directly after one or more ignored
// nodes, which will confuse the browser's cursor motion logic.
function $81901ae0222f0506$var$skipIgnoredNodesBefore(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let moveNode, moveOffset, force = false;
    // Gecko will do odd things when the selection is directly in front
    // of a non-editable node, so in that case, move it into the next
    // node if possible. Issue prosemirror/prosemirror#832.
    if ($81901ae0222f0506$var$gecko && node.nodeType == 1 && offset < $81901ae0222f0506$var$nodeLen(node) && $81901ae0222f0506$var$isIgnorable(node.childNodes[offset], -1)) force = true;
    for(;;){
        if (offset > 0) {
            if (node.nodeType != 1) break;
            else {
                let before = node.childNodes[offset - 1];
                if ($81901ae0222f0506$var$isIgnorable(before, -1)) {
                    moveNode = node;
                    moveOffset = --offset;
                } else if (before.nodeType == 3) {
                    node = before;
                    offset = node.nodeValue.length;
                } else break;
            }
        } else if ($81901ae0222f0506$var$isBlockNode(node)) break;
        else {
            let prev = node.previousSibling;
            while(prev && $81901ae0222f0506$var$isIgnorable(prev, -1)){
                moveNode = node.parentNode;
                moveOffset = $81901ae0222f0506$var$domIndex(prev);
                prev = prev.previousSibling;
            }
            if (!prev) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = 0;
            } else {
                node = prev;
                offset = $81901ae0222f0506$var$nodeLen(node);
            }
        }
    }
    if (force) $81901ae0222f0506$var$setSelFocus(view, node, offset);
    else if (moveNode) $81901ae0222f0506$var$setSelFocus(view, moveNode, moveOffset);
}
// Make sure the cursor isn't directly before one or more ignored
// nodes.
function $81901ae0222f0506$var$skipIgnoredNodesAfter(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let len = $81901ae0222f0506$var$nodeLen(node);
    let moveNode, moveOffset;
    for(;;){
        if (offset < len) {
            if (node.nodeType != 1) break;
            let after = node.childNodes[offset];
            if ($81901ae0222f0506$var$isIgnorable(after, 1)) {
                moveNode = node;
                moveOffset = ++offset;
            } else break;
        } else if ($81901ae0222f0506$var$isBlockNode(node)) break;
        else {
            let next = node.nextSibling;
            while(next && $81901ae0222f0506$var$isIgnorable(next, 1)){
                moveNode = next.parentNode;
                moveOffset = $81901ae0222f0506$var$domIndex(next) + 1;
                next = next.nextSibling;
            }
            if (!next) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = len = 0;
            } else {
                node = next;
                offset = 0;
                len = $81901ae0222f0506$var$nodeLen(node);
            }
        }
    }
    if (moveNode) $81901ae0222f0506$var$setSelFocus(view, moveNode, moveOffset);
}
function $81901ae0222f0506$var$isBlockNode(dom) {
    let desc = dom.pmViewDesc;
    return desc && desc.node && desc.node.isBlock;
}
function $81901ae0222f0506$var$textNodeAfter(node, offset) {
    while(node && offset == node.childNodes.length && !$81901ae0222f0506$var$hasBlockDesc(node)){
        offset = $81901ae0222f0506$var$domIndex(node) + 1;
        node = node.parentNode;
    }
    while(node && offset < node.childNodes.length){
        let next = node.childNodes[offset];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = 0;
    }
}
function $81901ae0222f0506$var$textNodeBefore(node, offset) {
    while(node && !offset && !$81901ae0222f0506$var$hasBlockDesc(node)){
        offset = $81901ae0222f0506$var$domIndex(node);
        node = node.parentNode;
    }
    while(node && offset){
        let next = node.childNodes[offset - 1];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = node.childNodes.length;
    }
}
function $81901ae0222f0506$var$setSelFocus(view, node, offset) {
    if (node.nodeType != 3) {
        let before, after;
        if (after = $81901ae0222f0506$var$textNodeAfter(node, offset)) {
            node = after;
            offset = 0;
        } else if (before = $81901ae0222f0506$var$textNodeBefore(node, offset)) {
            node = before;
            offset = before.nodeValue.length;
        }
    }
    let sel = view.domSelection();
    if (!sel) return;
    if ($81901ae0222f0506$var$selectionCollapsed(sel)) {
        let range = document.createRange();
        range.setEnd(node, offset);
        range.setStart(node, offset);
        sel.removeAllRanges();
        sel.addRange(range);
    } else if (sel.extend) sel.extend(node, offset);
    view.domObserver.setCurSelection();
    let { state: state } = view;
    // If no state update ends up happening, reset the selection.
    setTimeout(()=>{
        if (view.state == state) $81901ae0222f0506$var$selectionToDOM(view);
    }, 50);
}
function $81901ae0222f0506$var$findDirection(view, pos) {
    let $pos = view.state.doc.resolve(pos);
    if (!($81901ae0222f0506$var$chrome || $81901ae0222f0506$var$windows) && $pos.parent.inlineContent) {
        let coords = view.coordsAtPos(pos);
        if (pos > $pos.start()) {
            let before = view.coordsAtPos(pos - 1);
            let mid = (before.top + before.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(before.left - coords.left) > 1) return before.left < coords.left ? "ltr" : "rtl";
        }
        if (pos < $pos.end()) {
            let after = view.coordsAtPos(pos + 1);
            let mid = (after.top + after.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(after.left - coords.left) > 1) return after.left > coords.left ? "ltr" : "rtl";
        }
    }
    let computed = getComputedStyle(view.dom).direction;
    return computed == "rtl" ? "rtl" : "ltr";
}
// Check whether vertical selection motion would involve node
// selections. If so, apply it (if not, the result is left to the
// browser)
function $81901ae0222f0506$var$selectVertically(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $3lIcL.TextSelection) && !sel.empty || mods.indexOf("s") > -1) return false;
    if ($81901ae0222f0506$var$mac && mods.indexOf("m") > -1) return false;
    let { $from: $from, $to: $to } = sel;
    if (!$from.parent.inlineContent || view.endOfTextblock(dir < 0 ? "up" : "down")) {
        let next = $81901ae0222f0506$var$moveSelectionBlock(view.state, dir);
        if (next && next instanceof (0, $3lIcL.NodeSelection)) return $81901ae0222f0506$var$apply(view, next);
    }
    if (!$from.parent.inlineContent) {
        let side = dir < 0 ? $from : $to;
        let beyond = sel instanceof (0, $3lIcL.AllSelection) ? (0, $3lIcL.Selection).near(side, dir) : (0, $3lIcL.Selection).findFrom(side, dir);
        return beyond ? $81901ae0222f0506$var$apply(view, beyond) : false;
    }
    return false;
}
function $81901ae0222f0506$var$stopNativeHorizontalDelete(view, dir) {
    if (!(view.state.selection instanceof (0, $3lIcL.TextSelection))) return true;
    let { $head: $head, $anchor: $anchor, empty: empty } = view.state.selection;
    if (!$head.sameParent($anchor)) return true;
    if (!empty) return false;
    if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) return true;
    let nextNode = !$head.textOffset && (dir < 0 ? $head.nodeBefore : $head.nodeAfter);
    if (nextNode && !nextNode.isText) {
        let tr = view.state.tr;
        if (dir < 0) tr.delete($head.pos - nextNode.nodeSize, $head.pos);
        else tr.delete($head.pos, $head.pos + nextNode.nodeSize);
        view.dispatch(tr);
        return true;
    }
    return false;
}
function $81901ae0222f0506$var$switchEditable(view, node, state) {
    view.domObserver.stop();
    node.contentEditable = state;
    view.domObserver.start();
}
// Issue #867 / #1090 / https://bugs.chromium.org/p/chromium/issues/detail?id=903821
// In which Safari (and at some point in the past, Chrome) does really
// wrong things when the down arrow is pressed when the cursor is
// directly at the start of a textblock and has an uneditable node
// after it
function $81901ae0222f0506$var$safariDownArrowBug(view) {
    if (!$81901ae0222f0506$var$safari || view.state.selection.$head.parentOffset > 0) return false;
    let { focusNode: focusNode, focusOffset: focusOffset } = view.domSelectionRange();
    if (focusNode && focusNode.nodeType == 1 && focusOffset == 0 && focusNode.firstChild && focusNode.firstChild.contentEditable == "false") {
        let child = focusNode.firstChild;
        $81901ae0222f0506$var$switchEditable(view, child, "true");
        setTimeout(()=>$81901ae0222f0506$var$switchEditable(view, child, "false"), 20);
    }
    return false;
}
// A backdrop key mapping used to make sure we always suppress keys
// that have a dangerous default effect, even if the commands they are
// bound to return false, and to make sure that cursor-motion keys
// find a cursor (as opposed to a node selection) when pressed. For
// cursor-motion keys, the code in the handlers also takes care of
// block selections.
function $81901ae0222f0506$var$getMods(event) {
    let result = "";
    if (event.ctrlKey) result += "c";
    if (event.metaKey) result += "m";
    if (event.altKey) result += "a";
    if (event.shiftKey) result += "s";
    return result;
}
function $81901ae0222f0506$var$captureKeyDown(view, event) {
    let code = event.keyCode, mods = $81901ae0222f0506$var$getMods(event);
    if (code == 8 || $81901ae0222f0506$var$mac && code == 72 && mods == "c") return $81901ae0222f0506$var$stopNativeHorizontalDelete(view, -1) || $81901ae0222f0506$var$skipIgnoredNodes(view, -1);
    else if (code == 46 && !event.shiftKey || $81901ae0222f0506$var$mac && code == 68 && mods == "c") return $81901ae0222f0506$var$stopNativeHorizontalDelete(view, 1) || $81901ae0222f0506$var$skipIgnoredNodes(view, 1);
    else if (code == 13 || code == 27) return true;
    else if (code == 37 || $81901ae0222f0506$var$mac && code == 66 && mods == "c") {
        let dir = code == 37 ? $81901ae0222f0506$var$findDirection(view, view.state.selection.from) == "ltr" ? -1 : 1 : -1;
        return $81901ae0222f0506$var$selectHorizontally(view, dir, mods) || $81901ae0222f0506$var$skipIgnoredNodes(view, dir);
    } else if (code == 39 || $81901ae0222f0506$var$mac && code == 70 && mods == "c") {
        let dir = code == 39 ? $81901ae0222f0506$var$findDirection(view, view.state.selection.from) == "ltr" ? 1 : -1 : 1;
        return $81901ae0222f0506$var$selectHorizontally(view, dir, mods) || $81901ae0222f0506$var$skipIgnoredNodes(view, dir);
    } else if (code == 38 || $81901ae0222f0506$var$mac && code == 80 && mods == "c") return $81901ae0222f0506$var$selectVertically(view, -1, mods) || $81901ae0222f0506$var$skipIgnoredNodes(view, -1);
    else if (code == 40 || $81901ae0222f0506$var$mac && code == 78 && mods == "c") return $81901ae0222f0506$var$safariDownArrowBug(view) || $81901ae0222f0506$var$selectVertically(view, 1, mods) || $81901ae0222f0506$var$skipIgnoredNodes(view, 1);
    else if (mods == ($81901ae0222f0506$var$mac ? "m" : "c") && (code == 66 || code == 73 || code == 89 || code == 90)) return true;
    return false;
}
function $81901ae0222f0506$var$serializeForClipboard(view, slice) {
    view.someProp("transformCopied", (f)=>{
        slice = f(slice, view);
    });
    let context = [], { content: content, openStart: openStart, openEnd: openEnd } = slice;
    while(openStart > 1 && openEnd > 1 && content.childCount == 1 && content.firstChild.childCount == 1){
        openStart--;
        openEnd--;
        let node = content.firstChild;
        context.push(node.type.name, node.attrs != node.type.defaultAttrs ? node.attrs : null);
        content = node.content;
    }
    let serializer = view.someProp("clipboardSerializer") || (0, $3xw6l.DOMSerializer).fromSchema(view.state.schema);
    let doc = $81901ae0222f0506$var$detachedDoc(), wrap = doc.createElement("div");
    wrap.appendChild(serializer.serializeFragment(content, {
        document: doc
    }));
    let firstChild = wrap.firstChild, needsWrap, wrappers = 0;
    while(firstChild && firstChild.nodeType == 1 && (needsWrap = $81901ae0222f0506$var$wrapMap[firstChild.nodeName.toLowerCase()])){
        for(let i = needsWrap.length - 1; i >= 0; i--){
            let wrapper = doc.createElement(needsWrap[i]);
            while(wrap.firstChild)wrapper.appendChild(wrap.firstChild);
            wrap.appendChild(wrapper);
            wrappers++;
        }
        firstChild = wrap.firstChild;
    }
    if (firstChild && firstChild.nodeType == 1) firstChild.setAttribute("data-pm-slice", `${openStart} ${openEnd}${wrappers ? ` -${wrappers}` : ""} ${JSON.stringify(context)}`);
    let text = view.someProp("clipboardTextSerializer", (f)=>f(slice, view)) || slice.content.textBetween(0, slice.content.size, "\n\n");
    return {
        dom: wrap,
        text: text,
        slice: slice
    };
}
// Read a slice of content from the clipboard (or drop data).
function $81901ae0222f0506$var$parseFromClipboard(view, text, html, plainText, $context) {
    let inCode = $context.parent.type.spec.code;
    let dom, slice;
    if (!html && !text) return null;
    let asText = text && (plainText || inCode || !html);
    if (asText) {
        view.someProp("transformPastedText", (f)=>{
            text = f(text, inCode || plainText, view);
        });
        if (inCode) return text ? new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(view.state.schema.text(text.replace(/\r\n?/g, "\n"))), 0, 0) : (0, $3xw6l.Slice).empty;
        let parsed = view.someProp("clipboardTextParser", (f)=>f(text, $context, plainText, view));
        if (parsed) slice = parsed;
        else {
            let marks = $context.marks();
            let { schema: schema } = view.state, serializer = (0, $3xw6l.DOMSerializer).fromSchema(schema);
            dom = document.createElement("div");
            text.split(/(?:\r\n?|\n)+/).forEach((block)=>{
                let p = dom.appendChild(document.createElement("p"));
                if (block) p.appendChild(serializer.serializeNode(schema.text(block, marks)));
            });
        }
    } else {
        view.someProp("transformPastedHTML", (f)=>{
            html = f(html, view);
        });
        dom = $81901ae0222f0506$var$readHTML(html);
        if ($81901ae0222f0506$var$webkit) $81901ae0222f0506$var$restoreReplacedSpaces(dom);
    }
    let contextNode = dom && dom.querySelector("[data-pm-slice]");
    let sliceData = contextNode && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(contextNode.getAttribute("data-pm-slice") || "");
    if (sliceData && sliceData[3]) for(let i = +sliceData[3]; i > 0; i--){
        let child = dom.firstChild;
        while(child && child.nodeType != 1)child = child.nextSibling;
        if (!child) break;
        dom = child;
    }
    if (!slice) {
        let parser = view.someProp("clipboardParser") || view.someProp("domParser") || (0, $3xw6l.DOMParser).fromSchema(view.state.schema);
        slice = parser.parseSlice(dom, {
            preserveWhitespace: !!(asText || sliceData),
            context: $context,
            ruleFromNode (dom) {
                if (dom.nodeName == "BR" && !dom.nextSibling && dom.parentNode && !$81901ae0222f0506$var$inlineParents.test(dom.parentNode.nodeName)) return {
                    ignore: true
                };
                return null;
            }
        });
    }
    if (sliceData) slice = $81901ae0222f0506$var$addContext($81901ae0222f0506$var$closeSlice(slice, +sliceData[1], +sliceData[2]), sliceData[4]);
    else {
        slice = (0, $3xw6l.Slice).maxOpen($81901ae0222f0506$var$normalizeSiblings(slice.content, $context), true);
        if (slice.openStart || slice.openEnd) {
            let openStart = 0, openEnd = 0;
            for(let node = slice.content.firstChild; openStart < slice.openStart && !node.type.spec.isolating; openStart++, node = node.firstChild);
            for(let node = slice.content.lastChild; openEnd < slice.openEnd && !node.type.spec.isolating; openEnd++, node = node.lastChild);
            slice = $81901ae0222f0506$var$closeSlice(slice, openStart, openEnd);
        }
    }
    view.someProp("transformPasted", (f)=>{
        slice = f(slice, view);
    });
    return slice;
}
const $81901ae0222f0506$var$inlineParents = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
// Takes a slice parsed with parseSlice, which means there hasn't been
// any content-expression checking done on the top nodes, tries to
// find a parent node in the current context that might fit the nodes,
// and if successful, rebuilds the slice so that it fits into that parent.
//
// This addresses the problem that Transform.replace expects a
// coherent slice, and will fail to place a set of siblings that don't
// fit anywhere in the schema.
function $81901ae0222f0506$var$normalizeSiblings(fragment, $context) {
    if (fragment.childCount < 2) return fragment;
    for(let d = $context.depth; d >= 0; d--){
        let parent = $context.node(d);
        let match = parent.contentMatchAt($context.index(d));
        let lastWrap, result = [];
        fragment.forEach((node)=>{
            if (!result) return;
            let wrap = match.findWrapping(node.type), inLast;
            if (!wrap) return result = null;
            if (inLast = result.length && lastWrap.length && $81901ae0222f0506$var$addToSibling(wrap, lastWrap, node, result[result.length - 1], 0)) result[result.length - 1] = inLast;
            else {
                if (result.length) result[result.length - 1] = $81901ae0222f0506$var$closeRight(result[result.length - 1], lastWrap.length);
                let wrapped = $81901ae0222f0506$var$withWrappers(node, wrap);
                result.push(wrapped);
                match = match.matchType(wrapped.type);
                lastWrap = wrap;
            }
        });
        if (result) return (0, $3xw6l.Fragment).from(result);
    }
    return fragment;
}
function $81901ae0222f0506$var$withWrappers(node, wrap, from = 0) {
    for(let i = wrap.length - 1; i >= from; i--)node = wrap[i].create(null, (0, $3xw6l.Fragment).from(node));
    return node;
}
// Used to group adjacent nodes wrapped in similar parents by
// normalizeSiblings into the same parent node
function $81901ae0222f0506$var$addToSibling(wrap, lastWrap, node, sibling, depth) {
    if (depth < wrap.length && depth < lastWrap.length && wrap[depth] == lastWrap[depth]) {
        let inner = $81901ae0222f0506$var$addToSibling(wrap, lastWrap, node, sibling.lastChild, depth + 1);
        if (inner) return sibling.copy(sibling.content.replaceChild(sibling.childCount - 1, inner));
        let match = sibling.contentMatchAt(sibling.childCount);
        if (match.matchType(depth == wrap.length - 1 ? node.type : wrap[depth + 1])) return sibling.copy(sibling.content.append((0, $3xw6l.Fragment).from($81901ae0222f0506$var$withWrappers(node, wrap, depth + 1))));
    }
}
function $81901ae0222f0506$var$closeRight(node, depth) {
    if (depth == 0) return node;
    let fragment = node.content.replaceChild(node.childCount - 1, $81901ae0222f0506$var$closeRight(node.lastChild, depth - 1));
    let fill = node.contentMatchAt(node.childCount).fillBefore((0, $3xw6l.Fragment).empty, true);
    return node.copy(fragment.append(fill));
}
function $81901ae0222f0506$var$closeRange(fragment, side, from, to, depth, openEnd) {
    let node = side < 0 ? fragment.firstChild : fragment.lastChild, inner = node.content;
    if (fragment.childCount > 1) openEnd = 0;
    if (depth < to - 1) inner = $81901ae0222f0506$var$closeRange(inner, side, from, to, depth + 1, openEnd);
    if (depth >= from) inner = side < 0 ? node.contentMatchAt(0).fillBefore(inner, openEnd <= depth).append(inner) : inner.append(node.contentMatchAt(node.childCount).fillBefore((0, $3xw6l.Fragment).empty, true));
    return fragment.replaceChild(side < 0 ? 0 : fragment.childCount - 1, node.copy(inner));
}
function $81901ae0222f0506$var$closeSlice(slice, openStart, openEnd) {
    if (openStart < slice.openStart) slice = new (0, $3xw6l.Slice)($81901ae0222f0506$var$closeRange(slice.content, -1, openStart, slice.openStart, 0, slice.openEnd), openStart, slice.openEnd);
    if (openEnd < slice.openEnd) slice = new (0, $3xw6l.Slice)($81901ae0222f0506$var$closeRange(slice.content, 1, openEnd, slice.openEnd, 0, 0), slice.openStart, openEnd);
    return slice;
}
// Trick from jQuery -- some elements must be wrapped in other
// elements for innerHTML to work. I.e. if you do `div.innerHTML =
// "<td>..</td>"` the table cells are ignored.
const $81901ae0222f0506$var$wrapMap = {
    thead: [
        "table"
    ],
    tbody: [
        "table"
    ],
    tfoot: [
        "table"
    ],
    caption: [
        "table"
    ],
    colgroup: [
        "table"
    ],
    col: [
        "table",
        "colgroup"
    ],
    tr: [
        "table",
        "tbody"
    ],
    td: [
        "table",
        "tbody",
        "tr"
    ],
    th: [
        "table",
        "tbody",
        "tr"
    ]
};
let $81901ae0222f0506$var$_detachedDoc = null;
function $81901ae0222f0506$var$detachedDoc() {
    return $81901ae0222f0506$var$_detachedDoc || ($81901ae0222f0506$var$_detachedDoc = document.implementation.createHTMLDocument("title"));
}
let $81901ae0222f0506$var$_policy = null;
function $81901ae0222f0506$var$maybeWrapTrusted(html) {
    let trustedTypes = window.trustedTypes;
    if (!trustedTypes) return html;
    // With the require-trusted-types-for CSP, Chrome will block
    // innerHTML, even on a detached document. This wraps the string in
    // a way that makes the browser allow us to use its parser again.
    if (!$81901ae0222f0506$var$_policy) $81901ae0222f0506$var$_policy = trustedTypes.createPolicy("ProseMirrorClipboard", {
        createHTML: (s)=>s
    });
    return $81901ae0222f0506$var$_policy.createHTML(html);
}
function $81901ae0222f0506$var$readHTML(html) {
    let metas = /^(\s*<meta [^>]*>)*/.exec(html);
    if (metas) html = html.slice(metas[0].length);
    let elt = $81901ae0222f0506$var$detachedDoc().createElement("div");
    let firstTag = /<([a-z][^>\s]+)/i.exec(html), wrap;
    if (wrap = firstTag && $81901ae0222f0506$var$wrapMap[firstTag[1].toLowerCase()]) html = wrap.map((n)=>"<" + n + ">").join("") + html + wrap.map((n)=>"</" + n + ">").reverse().join("");
    elt.innerHTML = $81901ae0222f0506$var$maybeWrapTrusted(html);
    if (wrap) for(let i = 0; i < wrap.length; i++)elt = elt.querySelector(wrap[i]) || elt;
    return elt;
}
// Webkit browsers do some hard-to-predict replacement of regular
// spaces with non-breaking spaces when putting content on the
// clipboard. This tries to convert such non-breaking spaces (which
// will be wrapped in a plain span on Chrome, a span with class
// Apple-converted-space on Safari) back to regular spaces.
function $81901ae0222f0506$var$restoreReplacedSpaces(dom) {
    let nodes = dom.querySelectorAll($81901ae0222f0506$var$chrome ? "span:not([class]):not([style])" : "span.Apple-converted-space");
    for(let i = 0; i < nodes.length; i++){
        let node = nodes[i];
        if (node.childNodes.length == 1 && node.textContent == "\u00a0" && node.parentNode) node.parentNode.replaceChild(dom.ownerDocument.createTextNode(" "), node);
    }
}
function $81901ae0222f0506$var$addContext(slice, context) {
    if (!slice.size) return slice;
    let schema = slice.content.firstChild.type.schema, array;
    try {
        array = JSON.parse(context);
    } catch (e) {
        return slice;
    }
    let { content: content, openStart: openStart, openEnd: openEnd } = slice;
    for(let i = array.length - 2; i >= 0; i -= 2){
        let type = schema.nodes[array[i]];
        if (!type || type.hasRequiredAttrs()) break;
        content = (0, $3xw6l.Fragment).from(type.create(array[i + 1], content));
        openStart++;
        openEnd++;
    }
    return new (0, $3xw6l.Slice)(content, openStart, openEnd);
}
// A collection of DOM events that occur within the editor, and callback functions
// to invoke when the event fires.
const $81901ae0222f0506$var$handlers = {};
const $81901ae0222f0506$var$editHandlers = {};
const $81901ae0222f0506$var$passiveHandlers = {
    touchstart: true,
    touchmove: true
};
class $81901ae0222f0506$var$InputState {
    constructor(){
        this.shiftKey = false;
        this.mouseDown = null;
        this.lastKeyCode = null;
        this.lastKeyCodeTime = 0;
        this.lastClick = {
            time: 0,
            x: 0,
            y: 0,
            type: ""
        };
        this.lastSelectionOrigin = null;
        this.lastSelectionTime = 0;
        this.lastIOSEnter = 0;
        this.lastIOSEnterFallbackTimeout = -1;
        this.lastFocus = 0;
        this.lastTouch = 0;
        this.lastChromeDelete = 0;
        this.composing = false;
        this.compositionNode = null;
        this.composingTimeout = -1;
        this.compositionNodes = [];
        this.compositionEndedAt = -200000000;
        this.compositionID = 1;
        // Set to a composition ID when there are pending changes at compositionend
        this.compositionPendingChanges = 0;
        this.domChangeCount = 0;
        this.eventHandlers = Object.create(null);
        this.hideSelectionGuard = null;
    }
}
function $81901ae0222f0506$var$initInput(view) {
    for(let event in $81901ae0222f0506$var$handlers){
        let handler = $81901ae0222f0506$var$handlers[event];
        view.dom.addEventListener(event, view.input.eventHandlers[event] = (event)=>{
            if ($81901ae0222f0506$var$eventBelongsToView(view, event) && !$81901ae0222f0506$var$runCustomHandler(view, event) && (view.editable || !(event.type in $81901ae0222f0506$var$editHandlers))) handler(view, event);
        }, $81901ae0222f0506$var$passiveHandlers[event] ? {
            passive: true
        } : undefined);
    }
    // On Safari, for reasons beyond my understanding, adding an input
    // event handler makes an issue where the composition vanishes when
    // you press enter go away.
    if ($81901ae0222f0506$var$safari) view.dom.addEventListener("input", ()=>null);
    $81901ae0222f0506$var$ensureListeners(view);
}
function $81901ae0222f0506$var$setSelectionOrigin(view, origin) {
    view.input.lastSelectionOrigin = origin;
    view.input.lastSelectionTime = Date.now();
}
function $81901ae0222f0506$var$destroyInput(view) {
    view.domObserver.stop();
    for(let type in view.input.eventHandlers)view.dom.removeEventListener(type, view.input.eventHandlers[type]);
    clearTimeout(view.input.composingTimeout);
    clearTimeout(view.input.lastIOSEnterFallbackTimeout);
}
function $81901ae0222f0506$var$ensureListeners(view) {
    view.someProp("handleDOMEvents", (currentHandlers)=>{
        for(let type in currentHandlers)if (!view.input.eventHandlers[type]) view.dom.addEventListener(type, view.input.eventHandlers[type] = (event)=>$81901ae0222f0506$var$runCustomHandler(view, event));
    });
}
function $81901ae0222f0506$var$runCustomHandler(view, event) {
    return view.someProp("handleDOMEvents", (handlers)=>{
        let handler = handlers[event.type];
        return handler ? handler(view, event) || event.defaultPrevented : false;
    });
}
function $81901ae0222f0506$var$eventBelongsToView(view, event) {
    if (!event.bubbles) return true;
    if (event.defaultPrevented) return false;
    for(let node = event.target; node != view.dom; node = node.parentNode)if (!node || node.nodeType == 11 || node.pmViewDesc && node.pmViewDesc.stopEvent(event)) return false;
    return true;
}
function $81901ae0222f0506$var$dispatchEvent(view, event) {
    if (!$81901ae0222f0506$var$runCustomHandler(view, event) && $81901ae0222f0506$var$handlers[event.type] && (view.editable || !(event.type in $81901ae0222f0506$var$editHandlers))) $81901ae0222f0506$var$handlers[event.type](view, event);
}
$81901ae0222f0506$var$editHandlers.keydown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.keyCode == 16 || event.shiftKey;
    if ($81901ae0222f0506$var$inOrNearComposition(view, event)) return;
    view.input.lastKeyCode = event.keyCode;
    view.input.lastKeyCodeTime = Date.now();
    // Suppress enter key events on Chrome Android, because those tend
    // to be part of a confused sequence of composition events fired,
    // and handling them eagerly tends to corrupt the input.
    if ($81901ae0222f0506$var$android && $81901ae0222f0506$var$chrome && event.keyCode == 13) return;
    if (event.keyCode != 229) view.domObserver.forceFlush();
    // On iOS, if we preventDefault enter key presses, the virtual
    // keyboard gets confused. So the hack here is to set a flag that
    // makes the DOM change code recognize that what just happens should
    // be replaced by whatever the Enter key handlers do.
    if ($81901ae0222f0506$var$ios && event.keyCode == 13 && !event.ctrlKey && !event.altKey && !event.metaKey) {
        let now = Date.now();
        view.input.lastIOSEnter = now;
        view.input.lastIOSEnterFallbackTimeout = setTimeout(()=>{
            if (view.input.lastIOSEnter == now) {
                view.someProp("handleKeyDown", (f)=>f(view, $81901ae0222f0506$var$keyEvent(13, "Enter")));
                view.input.lastIOSEnter = 0;
            }
        }, 200);
    } else if (view.someProp("handleKeyDown", (f)=>f(view, event)) || $81901ae0222f0506$var$captureKeyDown(view, event)) event.preventDefault();
    else $81901ae0222f0506$var$setSelectionOrigin(view, "key");
};
$81901ae0222f0506$var$editHandlers.keyup = (view, event)=>{
    if (event.keyCode == 16) view.input.shiftKey = false;
};
$81901ae0222f0506$var$editHandlers.keypress = (view, _event)=>{
    let event = _event;
    if ($81901ae0222f0506$var$inOrNearComposition(view, event) || !event.charCode || event.ctrlKey && !event.altKey || $81901ae0222f0506$var$mac && event.metaKey) return;
    if (view.someProp("handleKeyPress", (f)=>f(view, event))) {
        event.preventDefault();
        return;
    }
    let sel = view.state.selection;
    if (!(sel instanceof (0, $3lIcL.TextSelection)) || !sel.$from.sameParent(sel.$to)) {
        let text = String.fromCharCode(event.charCode);
        if (!/[\r\n]/.test(text) && !view.someProp("handleTextInput", (f)=>f(view, sel.$from.pos, sel.$to.pos, text))) view.dispatch(view.state.tr.insertText(text).scrollIntoView());
        event.preventDefault();
    }
};
function $81901ae0222f0506$var$eventCoords(event) {
    return {
        left: event.clientX,
        top: event.clientY
    };
}
function $81901ae0222f0506$var$isNear(event, click) {
    let dx = click.x - event.clientX, dy = click.y - event.clientY;
    return dx * dx + dy * dy < 100;
}
function $81901ae0222f0506$var$runHandlerOnContext(view, propName, pos, inside, event) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        if (view.someProp(propName, (f)=>i > $pos.depth ? f(view, pos, $pos.nodeAfter, $pos.before(i), event, true) : f(view, pos, $pos.node(i), $pos.before(i), event, false))) return true;
    }
    return false;
}
function $81901ae0222f0506$var$updateSelection(view, selection, origin) {
    if (!view.focused) view.focus();
    if (view.state.selection.eq(selection)) return;
    let tr = view.state.tr.setSelection(selection);
    if (origin == "pointer") tr.setMeta("pointer", true);
    view.dispatch(tr);
}
function $81901ae0222f0506$var$selectClickedLeaf(view, inside) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside), node = $pos.nodeAfter;
    if (node && node.isAtom && (0, $3lIcL.NodeSelection).isSelectable(node)) {
        $81901ae0222f0506$var$updateSelection(view, new (0, $3lIcL.NodeSelection)($pos), "pointer");
        return true;
    }
    return false;
}
function $81901ae0222f0506$var$selectClickedNode(view, inside) {
    if (inside == -1) return false;
    let sel = view.state.selection, selectedNode, selectAt;
    if (sel instanceof (0, $3lIcL.NodeSelection)) selectedNode = sel.node;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        if ((0, $3lIcL.NodeSelection).isSelectable(node)) {
            if (selectedNode && sel.$from.depth > 0 && i >= sel.$from.depth && $pos.before(sel.$from.depth + 1) == sel.$from.pos) selectAt = $pos.before(sel.$from.depth);
            else selectAt = $pos.before(i);
            break;
        }
    }
    if (selectAt != null) {
        $81901ae0222f0506$var$updateSelection(view, (0, $3lIcL.NodeSelection).create(view.state.doc, selectAt), "pointer");
        return true;
    } else return false;
}
function $81901ae0222f0506$var$handleSingleClick(view, pos, inside, event, selectNode) {
    return $81901ae0222f0506$var$runHandlerOnContext(view, "handleClickOn", pos, inside, event) || view.someProp("handleClick", (f)=>f(view, pos, event)) || (selectNode ? $81901ae0222f0506$var$selectClickedNode(view, inside) : $81901ae0222f0506$var$selectClickedLeaf(view, inside));
}
function $81901ae0222f0506$var$handleDoubleClick(view, pos, inside, event) {
    return $81901ae0222f0506$var$runHandlerOnContext(view, "handleDoubleClickOn", pos, inside, event) || view.someProp("handleDoubleClick", (f)=>f(view, pos, event));
}
function $81901ae0222f0506$var$handleTripleClick(view, pos, inside, event) {
    return $81901ae0222f0506$var$runHandlerOnContext(view, "handleTripleClickOn", pos, inside, event) || view.someProp("handleTripleClick", (f)=>f(view, pos, event)) || $81901ae0222f0506$var$defaultTripleClick(view, inside, event);
}
function $81901ae0222f0506$var$defaultTripleClick(view, inside, event) {
    if (event.button != 0) return false;
    let doc = view.state.doc;
    if (inside == -1) {
        if (doc.inlineContent) {
            $81901ae0222f0506$var$updateSelection(view, (0, $3lIcL.TextSelection).create(doc, 0, doc.content.size), "pointer");
            return true;
        }
        return false;
    }
    let $pos = doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        let nodePos = $pos.before(i);
        if (node.inlineContent) $81901ae0222f0506$var$updateSelection(view, (0, $3lIcL.TextSelection).create(doc, nodePos + 1, nodePos + 1 + node.content.size), "pointer");
        else if ((0, $3lIcL.NodeSelection).isSelectable(node)) $81901ae0222f0506$var$updateSelection(view, (0, $3lIcL.NodeSelection).create(doc, nodePos), "pointer");
        else continue;
        return true;
    }
}
function $81901ae0222f0506$var$forceDOMFlush(view) {
    return $81901ae0222f0506$var$endComposition(view);
}
const $81901ae0222f0506$var$selectNodeModifier = $81901ae0222f0506$var$mac ? "metaKey" : "ctrlKey";
$81901ae0222f0506$var$handlers.mousedown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.shiftKey;
    let flushed = $81901ae0222f0506$var$forceDOMFlush(view);
    let now = Date.now(), type = "singleClick";
    if (now - view.input.lastClick.time < 500 && $81901ae0222f0506$var$isNear(event, view.input.lastClick) && !event[$81901ae0222f0506$var$selectNodeModifier]) {
        if (view.input.lastClick.type == "singleClick") type = "doubleClick";
        else if (view.input.lastClick.type == "doubleClick") type = "tripleClick";
    }
    view.input.lastClick = {
        time: now,
        x: event.clientX,
        y: event.clientY,
        type: type
    };
    let pos = view.posAtCoords($81901ae0222f0506$var$eventCoords(event));
    if (!pos) return;
    if (type == "singleClick") {
        if (view.input.mouseDown) view.input.mouseDown.done();
        view.input.mouseDown = new $81901ae0222f0506$var$MouseDown(view, pos, event, !!flushed);
    } else if ((type == "doubleClick" ? $81901ae0222f0506$var$handleDoubleClick : $81901ae0222f0506$var$handleTripleClick)(view, pos.pos, pos.inside, event)) event.preventDefault();
    else $81901ae0222f0506$var$setSelectionOrigin(view, "pointer");
};
class $81901ae0222f0506$var$MouseDown {
    constructor(view, pos, event, flushed){
        this.view = view;
        this.pos = pos;
        this.event = event;
        this.flushed = flushed;
        this.delayedSelectionSync = false;
        this.mightDrag = null;
        this.startDoc = view.state.doc;
        this.selectNode = !!event[$81901ae0222f0506$var$selectNodeModifier];
        this.allowDefault = event.shiftKey;
        let targetNode, targetPos;
        if (pos.inside > -1) {
            targetNode = view.state.doc.nodeAt(pos.inside);
            targetPos = pos.inside;
        } else {
            let $pos = view.state.doc.resolve(pos.pos);
            targetNode = $pos.parent;
            targetPos = $pos.depth ? $pos.before() : 0;
        }
        const target = flushed ? null : event.target;
        const targetDesc = target ? view.docView.nearestDesc(target, true) : null;
        this.target = targetDesc && targetDesc.dom.nodeType == 1 ? targetDesc.dom : null;
        let { selection: selection } = view.state;
        if (event.button == 0 && targetNode.type.spec.draggable && targetNode.type.spec.selectable !== false || selection instanceof (0, $3lIcL.NodeSelection) && selection.from <= targetPos && selection.to > targetPos) this.mightDrag = {
            node: targetNode,
            pos: targetPos,
            addAttr: !!(this.target && !this.target.draggable),
            setUneditable: !!(this.target && $81901ae0222f0506$var$gecko && !this.target.hasAttribute("contentEditable"))
        };
        if (this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable)) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.draggable = true;
            if (this.mightDrag.setUneditable) setTimeout(()=>{
                if (this.view.input.mouseDown == this) this.target.setAttribute("contentEditable", "false");
            }, 20);
            this.view.domObserver.start();
        }
        view.root.addEventListener("mouseup", this.up = this.up.bind(this));
        view.root.addEventListener("mousemove", this.move = this.move.bind(this));
        $81901ae0222f0506$var$setSelectionOrigin(view, "pointer");
    }
    done() {
        this.view.root.removeEventListener("mouseup", this.up);
        this.view.root.removeEventListener("mousemove", this.move);
        if (this.mightDrag && this.target) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.removeAttribute("draggable");
            if (this.mightDrag.setUneditable) this.target.removeAttribute("contentEditable");
            this.view.domObserver.start();
        }
        if (this.delayedSelectionSync) setTimeout(()=>$81901ae0222f0506$var$selectionToDOM(this.view));
        this.view.input.mouseDown = null;
    }
    up(event) {
        this.done();
        if (!this.view.dom.contains(event.target)) return;
        let pos = this.pos;
        if (this.view.state.doc != this.startDoc) pos = this.view.posAtCoords($81901ae0222f0506$var$eventCoords(event));
        this.updateAllowDefault(event);
        if (this.allowDefault || !pos) $81901ae0222f0506$var$setSelectionOrigin(this.view, "pointer");
        else if ($81901ae0222f0506$var$handleSingleClick(this.view, pos.pos, pos.inside, event, this.selectNode)) event.preventDefault();
        else if (event.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
        $81901ae0222f0506$var$safari && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
        // cursor, but still report that the node is selected
        // when asked through getSelection. You'll then get a
        // situation where clicking at the point where that
        // (hidden) cursor is doesn't change the selection, and
        // thus doesn't get a reaction from ProseMirror. This
        // works around that.
        $81901ae0222f0506$var$chrome && !this.view.state.selection.visible && Math.min(Math.abs(pos.pos - this.view.state.selection.from), Math.abs(pos.pos - this.view.state.selection.to)) <= 2)) {
            $81901ae0222f0506$var$updateSelection(this.view, (0, $3lIcL.Selection).near(this.view.state.doc.resolve(pos.pos)), "pointer");
            event.preventDefault();
        } else $81901ae0222f0506$var$setSelectionOrigin(this.view, "pointer");
    }
    move(event) {
        this.updateAllowDefault(event);
        $81901ae0222f0506$var$setSelectionOrigin(this.view, "pointer");
        if (event.buttons == 0) this.done();
    }
    updateAllowDefault(event) {
        if (!this.allowDefault && (Math.abs(this.event.x - event.clientX) > 4 || Math.abs(this.event.y - event.clientY) > 4)) this.allowDefault = true;
    }
}
$81901ae0222f0506$var$handlers.touchstart = (view)=>{
    view.input.lastTouch = Date.now();
    $81901ae0222f0506$var$forceDOMFlush(view);
    $81901ae0222f0506$var$setSelectionOrigin(view, "pointer");
};
$81901ae0222f0506$var$handlers.touchmove = (view)=>{
    view.input.lastTouch = Date.now();
    $81901ae0222f0506$var$setSelectionOrigin(view, "pointer");
};
$81901ae0222f0506$var$handlers.contextmenu = (view)=>$81901ae0222f0506$var$forceDOMFlush(view);
function $81901ae0222f0506$var$inOrNearComposition(view, event) {
    if (view.composing) return true;
    // See https://www.stum.de/2016/06/24/handling-ime-events-in-javascript/.
    // On Japanese input method editors (IMEs), the Enter key is used to confirm character
    // selection. On Safari, when Enter is pressed, compositionend and keydown events are
    // emitted. The keydown event triggers newline insertion, which we don't want.
    // This method returns true if the keydown event should be ignored.
    // We only ignore it once, as pressing Enter a second time *should* insert a newline.
    // Furthermore, the keydown event timestamp must be close to the compositionEndedAt timestamp.
    // This guards against the case where compositionend is triggered without the keyboard
    // (e.g. character confirmation may be done with the mouse), and keydown is triggered
    // afterwards- we wouldn't want to ignore the keydown event in this case.
    if ($81901ae0222f0506$var$safari && Math.abs(event.timeStamp - view.input.compositionEndedAt) < 500) {
        view.input.compositionEndedAt = -200000000;
        return true;
    }
    return false;
}
// Drop active composition after 5 seconds of inactivity on Android
const $81901ae0222f0506$var$timeoutComposition = $81901ae0222f0506$var$android ? 5000 : -1;
$81901ae0222f0506$var$editHandlers.compositionstart = $81901ae0222f0506$var$editHandlers.compositionupdate = (view)=>{
    if (!view.composing) {
        view.domObserver.flush();
        let { state: state } = view, $pos = state.selection.$to;
        if (state.selection instanceof (0, $3lIcL.TextSelection) && (state.storedMarks || !$pos.textOffset && $pos.parentOffset && $pos.nodeBefore.marks.some((m)=>m.type.spec.inclusive === false))) {
            // Need to wrap the cursor in mark nodes different from the ones in the DOM context
            view.markCursor = view.state.storedMarks || $pos.marks();
            $81901ae0222f0506$var$endComposition(view, true);
            view.markCursor = null;
        } else {
            $81901ae0222f0506$var$endComposition(view, !state.selection.empty);
            // In firefox, if the cursor is after but outside a marked node,
            // the inserted text won't inherit the marks. So this moves it
            // inside if necessary.
            if ($81901ae0222f0506$var$gecko && state.selection.empty && $pos.parentOffset && !$pos.textOffset && $pos.nodeBefore.marks.length) {
                let sel = view.domSelectionRange();
                for(let node = sel.focusNode, offset = sel.focusOffset; node && node.nodeType == 1 && offset != 0;){
                    let before = offset < 0 ? node.lastChild : node.childNodes[offset - 1];
                    if (!before) break;
                    if (before.nodeType == 3) {
                        let sel = view.domSelection();
                        if (sel) sel.collapse(before, before.nodeValue.length);
                        break;
                    } else {
                        node = before;
                        offset = -1;
                    }
                }
            }
        }
        view.input.composing = true;
    }
    $81901ae0222f0506$var$scheduleComposeEnd(view, $81901ae0222f0506$var$timeoutComposition);
};
$81901ae0222f0506$var$editHandlers.compositionend = (view, event)=>{
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = event.timeStamp;
        view.input.compositionPendingChanges = view.domObserver.pendingRecords().length ? view.input.compositionID : 0;
        view.input.compositionNode = null;
        if (view.input.compositionPendingChanges) Promise.resolve().then(()=>view.domObserver.flush());
        view.input.compositionID++;
        $81901ae0222f0506$var$scheduleComposeEnd(view, 20);
    }
};
function $81901ae0222f0506$var$scheduleComposeEnd(view, delay) {
    clearTimeout(view.input.composingTimeout);
    if (delay > -1) view.input.composingTimeout = setTimeout(()=>$81901ae0222f0506$var$endComposition(view), delay);
}
function $81901ae0222f0506$var$clearComposition(view) {
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = $81901ae0222f0506$var$timestampFromCustomEvent();
    }
    while(view.input.compositionNodes.length > 0)view.input.compositionNodes.pop().markParentsDirty();
}
function $81901ae0222f0506$var$findCompositionNode(view) {
    let sel = view.domSelectionRange();
    if (!sel.focusNode) return null;
    let textBefore = $81901ae0222f0506$var$textNodeBefore$1(sel.focusNode, sel.focusOffset);
    let textAfter = $81901ae0222f0506$var$textNodeAfter$1(sel.focusNode, sel.focusOffset);
    if (textBefore && textAfter && textBefore != textAfter) {
        let descAfter = textAfter.pmViewDesc, lastChanged = view.domObserver.lastChangedTextNode;
        if (textBefore == lastChanged || textAfter == lastChanged) return lastChanged;
        if (!descAfter || !descAfter.isText(textAfter.nodeValue)) return textAfter;
        else if (view.input.compositionNode == textAfter) {
            let descBefore = textBefore.pmViewDesc;
            if (!(!descBefore || !descBefore.isText(textBefore.nodeValue))) return textAfter;
        }
    }
    return textBefore || textAfter;
}
function $81901ae0222f0506$var$timestampFromCustomEvent() {
    let event = document.createEvent("Event");
    event.initEvent("event", true, true);
    return event.timeStamp;
}
/**
@internal
*/ function $81901ae0222f0506$var$endComposition(view, restarting = false) {
    if ($81901ae0222f0506$var$android && view.domObserver.flushingSoon >= 0) return;
    view.domObserver.forceFlush();
    $81901ae0222f0506$var$clearComposition(view);
    if (restarting || view.docView && view.docView.dirty) {
        let sel = $81901ae0222f0506$var$selectionFromDOM(view);
        if (sel && !sel.eq(view.state.selection)) view.dispatch(view.state.tr.setSelection(sel));
        else if ((view.markCursor || restarting) && !view.state.selection.empty) view.dispatch(view.state.tr.deleteSelection());
        else view.updateState(view.state);
        return true;
    }
    return false;
}
function $81901ae0222f0506$var$captureCopy(view, dom) {
    // The extra wrapper is somehow necessary on IE/Edge to prevent the
    // content from being mangled when it is put onto the clipboard
    if (!view.dom.parentNode) return;
    let wrap = view.dom.parentNode.appendChild(document.createElement("div"));
    wrap.appendChild(dom);
    wrap.style.cssText = "position: fixed; left: -10000px; top: 10px";
    let sel = getSelection(), range = document.createRange();
    range.selectNodeContents(dom);
    // Done because IE will fire a selectionchange moving the selection
    // to its start when removeAllRanges is called and the editor still
    // has focus (which will mess up the editor's selection state).
    view.dom.blur();
    sel.removeAllRanges();
    sel.addRange(range);
    setTimeout(()=>{
        if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
        view.focus();
    }, 50);
}
// This is very crude, but unfortunately both these browsers _pretend_
// that they have a clipboard API—all the objects and methods are
// there, they just don't work, and they are hard to test.
const $81901ae0222f0506$var$brokenClipboardAPI = $81901ae0222f0506$var$ie && $81901ae0222f0506$var$ie_version < 15 || $81901ae0222f0506$var$ios && $81901ae0222f0506$var$webkit_version < 604;
$81901ae0222f0506$var$handlers.copy = $81901ae0222f0506$var$editHandlers.cut = (view, _event)=>{
    let event = _event;
    let sel = view.state.selection, cut = event.type == "cut";
    if (sel.empty) return;
    // IE and Edge's clipboard interface is completely broken
    let data = $81901ae0222f0506$var$brokenClipboardAPI ? null : event.clipboardData;
    let slice = sel.content(), { dom: dom, text: text } = $81901ae0222f0506$var$serializeForClipboard(view, slice);
    if (data) {
        event.preventDefault();
        data.clearData();
        data.setData("text/html", dom.innerHTML);
        data.setData("text/plain", text);
    } else $81901ae0222f0506$var$captureCopy(view, dom);
    if (cut) view.dispatch(view.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function $81901ae0222f0506$var$sliceSingleNode(slice) {
    return slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1 ? slice.content.firstChild : null;
}
function $81901ae0222f0506$var$capturePaste(view, event) {
    if (!view.dom.parentNode) return;
    let plainText = view.input.shiftKey || view.state.selection.$from.parent.type.spec.code;
    let target = view.dom.parentNode.appendChild(document.createElement(plainText ? "textarea" : "div"));
    if (!plainText) target.contentEditable = "true";
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.focus();
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    setTimeout(()=>{
        view.focus();
        if (target.parentNode) target.parentNode.removeChild(target);
        if (plainText) $81901ae0222f0506$var$doPaste(view, target.value, null, plain, event);
        else $81901ae0222f0506$var$doPaste(view, target.textContent, target.innerHTML, plain, event);
    }, 50);
}
function $81901ae0222f0506$var$doPaste(view, text, html, preferPlain, event) {
    let slice = $81901ae0222f0506$var$parseFromClipboard(view, text, html, preferPlain, view.state.selection.$from);
    if (view.someProp("handlePaste", (f)=>f(view, event, slice || (0, $3xw6l.Slice).empty))) return true;
    if (!slice) return false;
    let singleNode = $81901ae0222f0506$var$sliceSingleNode(slice);
    let tr = singleNode ? view.state.tr.replaceSelectionWith(singleNode, preferPlain) : view.state.tr.replaceSelection(slice);
    view.dispatch(tr.scrollIntoView().setMeta("paste", true).setMeta("uiEvent", "paste"));
    return true;
}
function $81901ae0222f0506$var$getText(clipboardData) {
    let text = clipboardData.getData("text/plain") || clipboardData.getData("Text");
    if (text) return text;
    let uris = clipboardData.getData("text/uri-list");
    return uris ? uris.replace(/\r?\n/g, " ") : "";
}
$81901ae0222f0506$var$editHandlers.paste = (view, _event)=>{
    let event = _event;
    // Handling paste from JavaScript during composition is very poorly
    // handled by browsers, so as a dodgy but preferable kludge, we just
    // let the browser do its native thing there, except on Android,
    // where the editor is almost always composing.
    if (view.composing && !$81901ae0222f0506$var$android) return;
    let data = $81901ae0222f0506$var$brokenClipboardAPI ? null : event.clipboardData;
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    if (data && $81901ae0222f0506$var$doPaste(view, $81901ae0222f0506$var$getText(data), data.getData("text/html"), plain, event)) event.preventDefault();
    else $81901ae0222f0506$var$capturePaste(view, event);
};
class $81901ae0222f0506$var$Dragging {
    constructor(slice, move, node){
        this.slice = slice;
        this.move = move;
        this.node = node;
    }
}
const $81901ae0222f0506$var$dragCopyModifier = $81901ae0222f0506$var$mac ? "altKey" : "ctrlKey";
$81901ae0222f0506$var$handlers.dragstart = (view, _event)=>{
    let event = _event;
    let mouseDown = view.input.mouseDown;
    if (mouseDown) mouseDown.done();
    if (!event.dataTransfer) return;
    let sel = view.state.selection;
    let pos = sel.empty ? null : view.posAtCoords($81901ae0222f0506$var$eventCoords(event));
    let node;
    if (pos && pos.pos >= sel.from && pos.pos <= (sel instanceof (0, $3lIcL.NodeSelection) ? sel.to - 1 : sel.to)) ;
    else if (mouseDown && mouseDown.mightDrag) node = (0, $3lIcL.NodeSelection).create(view.state.doc, mouseDown.mightDrag.pos);
    else if (event.target && event.target.nodeType == 1) {
        let desc = view.docView.nearestDesc(event.target, true);
        if (desc && desc.node.type.spec.draggable && desc != view.docView) node = (0, $3lIcL.NodeSelection).create(view.state.doc, desc.posBefore);
    }
    let draggedSlice = (node || view.state.selection).content();
    let { dom: dom, text: text, slice: slice } = $81901ae0222f0506$var$serializeForClipboard(view, draggedSlice);
    // Pre-120 Chrome versions clear files when calling `clearData` (#1472)
    if (!event.dataTransfer.files.length || !$81901ae0222f0506$var$chrome || $81901ae0222f0506$var$chrome_version > 120) event.dataTransfer.clearData();
    event.dataTransfer.setData($81901ae0222f0506$var$brokenClipboardAPI ? "Text" : "text/html", dom.innerHTML);
    // See https://github.com/ProseMirror/prosemirror/issues/1156
    event.dataTransfer.effectAllowed = "copyMove";
    if (!$81901ae0222f0506$var$brokenClipboardAPI) event.dataTransfer.setData("text/plain", text);
    view.dragging = new $81901ae0222f0506$var$Dragging(slice, !event[$81901ae0222f0506$var$dragCopyModifier], node);
};
$81901ae0222f0506$var$handlers.dragend = (view)=>{
    let dragging = view.dragging;
    window.setTimeout(()=>{
        if (view.dragging == dragging) view.dragging = null;
    }, 50);
};
$81901ae0222f0506$var$editHandlers.dragover = $81901ae0222f0506$var$editHandlers.dragenter = (_, e)=>e.preventDefault();
$81901ae0222f0506$var$editHandlers.drop = (view, _event)=>{
    let event = _event;
    let dragging = view.dragging;
    view.dragging = null;
    if (!event.dataTransfer) return;
    let eventPos = view.posAtCoords($81901ae0222f0506$var$eventCoords(event));
    if (!eventPos) return;
    let $mouse = view.state.doc.resolve(eventPos.pos);
    let slice = dragging && dragging.slice;
    if (slice) view.someProp("transformPasted", (f)=>{
        slice = f(slice, view);
    });
    else slice = $81901ae0222f0506$var$parseFromClipboard(view, $81901ae0222f0506$var$getText(event.dataTransfer), $81901ae0222f0506$var$brokenClipboardAPI ? null : event.dataTransfer.getData("text/html"), false, $mouse);
    let move = !!(dragging && !event[$81901ae0222f0506$var$dragCopyModifier]);
    if (view.someProp("handleDrop", (f)=>f(view, event, slice || (0, $3xw6l.Slice).empty, move))) {
        event.preventDefault();
        return;
    }
    if (!slice) return;
    event.preventDefault();
    let insertPos = slice ? (0, $lzEKq.dropPoint)(view.state.doc, $mouse.pos, slice) : $mouse.pos;
    if (insertPos == null) insertPos = $mouse.pos;
    let tr = view.state.tr;
    if (move) {
        let { node: node } = dragging;
        if (node) node.replace(tr);
        else tr.deleteSelection();
    }
    let pos = tr.mapping.map(insertPos);
    let isNode = slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1;
    let beforeInsert = tr.doc;
    if (isNode) tr.replaceRangeWith(pos, pos, slice.content.firstChild);
    else tr.replaceRange(pos, pos, slice);
    if (tr.doc.eq(beforeInsert)) return;
    let $pos = tr.doc.resolve(pos);
    if (isNode && (0, $3lIcL.NodeSelection).isSelectable(slice.content.firstChild) && $pos.nodeAfter && $pos.nodeAfter.sameMarkup(slice.content.firstChild)) tr.setSelection(new (0, $3lIcL.NodeSelection)($pos));
    else {
        let end = tr.mapping.map(insertPos);
        tr.mapping.maps[tr.mapping.maps.length - 1].forEach((_from, _to, _newFrom, newTo)=>end = newTo);
        tr.setSelection($81901ae0222f0506$var$selectionBetween(view, $pos, tr.doc.resolve(end)));
    }
    view.focus();
    view.dispatch(tr.setMeta("uiEvent", "drop"));
};
$81901ae0222f0506$var$handlers.focus = (view)=>{
    view.input.lastFocus = Date.now();
    if (!view.focused) {
        view.domObserver.stop();
        view.dom.classList.add("ProseMirror-focused");
        view.domObserver.start();
        view.focused = true;
        setTimeout(()=>{
            if (view.docView && view.hasFocus() && !view.domObserver.currentSelection.eq(view.domSelectionRange())) $81901ae0222f0506$var$selectionToDOM(view);
        }, 20);
    }
};
$81901ae0222f0506$var$handlers.blur = (view, _event)=>{
    let event = _event;
    if (view.focused) {
        view.domObserver.stop();
        view.dom.classList.remove("ProseMirror-focused");
        view.domObserver.start();
        if (event.relatedTarget && view.dom.contains(event.relatedTarget)) view.domObserver.currentSelection.clear();
        view.focused = false;
    }
};
$81901ae0222f0506$var$handlers.beforeinput = (view, _event)=>{
    let event = _event;
    // We should probably do more with beforeinput events, but support
    // is so spotty that I'm still waiting to see where they are going.
    // Very specific hack to deal with backspace sometimes failing on
    // Chrome Android when after an uneditable node.
    if ($81901ae0222f0506$var$chrome && $81901ae0222f0506$var$android && event.inputType == "deleteContentBackward") {
        view.domObserver.flushSoon();
        let { domChangeCount: domChangeCount } = view.input;
        setTimeout(()=>{
            if (view.input.domChangeCount != domChangeCount) return; // Event already had some effect
            // This bug tends to close the virtual keyboard, so we refocus
            view.dom.blur();
            view.focus();
            if (view.someProp("handleKeyDown", (f)=>f(view, $81901ae0222f0506$var$keyEvent(8, "Backspace")))) return;
            let { $cursor: $cursor } = view.state.selection;
            // Crude approximation of backspace behavior when no command handled it
            if ($cursor && $cursor.pos > 0) view.dispatch(view.state.tr.delete($cursor.pos - 1, $cursor.pos).scrollIntoView());
        }, 50);
    }
};
// Make sure all handlers get registered
for(let prop in $81901ae0222f0506$var$editHandlers)$81901ae0222f0506$var$handlers[prop] = $81901ae0222f0506$var$editHandlers[prop];
function $81901ae0222f0506$var$compareObjs(a, b) {
    if (a == b) return true;
    for(let p in a)if (a[p] !== b[p]) return false;
    for(let p in b)if (!(p in a)) return false;
    return true;
}
class $81901ae0222f0506$var$WidgetType {
    constructor(toDOM, spec){
        this.toDOM = toDOM;
        this.spec = spec || $81901ae0222f0506$var$noSpec;
        this.side = this.spec.side || 0;
    }
    map(mapping, span, offset, oldOffset) {
        let { pos: pos, deleted: deleted } = mapping.mapResult(span.from + oldOffset, this.side < 0 ? -1 : 1);
        return deleted ? null : new $81901ae0222f0506$export$10e30b733df217ea(pos - offset, pos - offset, this);
    }
    valid() {
        return true;
    }
    eq(other) {
        return this == other || other instanceof $81901ae0222f0506$var$WidgetType && (this.spec.key && this.spec.key == other.spec.key || this.toDOM == other.toDOM && $81901ae0222f0506$var$compareObjs(this.spec, other.spec));
    }
    destroy(node) {
        if (this.spec.destroy) this.spec.destroy(node);
    }
}
class $81901ae0222f0506$var$InlineType {
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $81901ae0222f0506$var$noSpec;
    }
    map(mapping, span, offset, oldOffset) {
        let from = mapping.map(span.from + oldOffset, this.spec.inclusiveStart ? -1 : 1) - offset;
        let to = mapping.map(span.to + oldOffset, this.spec.inclusiveEnd ? 1 : -1) - offset;
        return from >= to ? null : new $81901ae0222f0506$export$10e30b733df217ea(from, to, this);
    }
    valid(_, span) {
        return span.from < span.to;
    }
    eq(other) {
        return this == other || other instanceof $81901ae0222f0506$var$InlineType && $81901ae0222f0506$var$compareObjs(this.attrs, other.attrs) && $81901ae0222f0506$var$compareObjs(this.spec, other.spec);
    }
    static is(span) {
        return span.type instanceof $81901ae0222f0506$var$InlineType;
    }
    destroy() {}
}
class $81901ae0222f0506$var$NodeType {
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $81901ae0222f0506$var$noSpec;
    }
    map(mapping, span, offset, oldOffset) {
        let from = mapping.mapResult(span.from + oldOffset, 1);
        if (from.deleted) return null;
        let to = mapping.mapResult(span.to + oldOffset, -1);
        if (to.deleted || to.pos <= from.pos) return null;
        return new $81901ae0222f0506$export$10e30b733df217ea(from.pos - offset, to.pos - offset, this);
    }
    valid(node, span) {
        let { index: index, offset: offset } = node.content.findIndex(span.from), child;
        return offset == span.from && !(child = node.child(index)).isText && offset + child.nodeSize == span.to;
    }
    eq(other) {
        return this == other || other instanceof $81901ae0222f0506$var$NodeType && $81901ae0222f0506$var$compareObjs(this.attrs, other.attrs) && $81901ae0222f0506$var$compareObjs(this.spec, other.spec);
    }
    destroy() {}
}
/**
Decoration objects can be provided to the view through the
[`decorations` prop](https://prosemirror.net/docs/ref/#view.EditorProps.decorations). They come in
several variants—see the static members of this class for details.
*/ class $81901ae0222f0506$export$10e30b733df217ea {
    /**
    @internal
    */ constructor(/**
    The start position of the decoration.
    */ from, /**
    The end position. Will be the same as `from` for [widget
    decorations](https://prosemirror.net/docs/ref/#view.Decoration^widget).
    */ to, /**
    @internal
    */ type){
        this.from = from;
        this.to = to;
        this.type = type;
    }
    /**
    @internal
    */ copy(from, to) {
        return new $81901ae0222f0506$export$10e30b733df217ea(from, to, this.type);
    }
    /**
    @internal
    */ eq(other, offset = 0) {
        return this.type.eq(other.type) && this.from + offset == other.from && this.to + offset == other.to;
    }
    /**
    @internal
    */ map(mapping, offset, oldOffset) {
        return this.type.map(mapping, this, offset, oldOffset);
    }
    /**
    Creates a widget decoration, which is a DOM node that's shown in
    the document at the given position. It is recommended that you
    delay rendering the widget by passing a function that will be
    called when the widget is actually drawn in a view, but you can
    also directly pass a DOM node. `getPos` can be used to find the
    widget's current document position.
    */ static widget(pos, toDOM, spec) {
        return new $81901ae0222f0506$export$10e30b733df217ea(pos, pos, new $81901ae0222f0506$var$WidgetType(toDOM, spec));
    }
    /**
    Creates an inline decoration, which adds the given attributes to
    each inline node between `from` and `to`.
    */ static inline(from, to, attrs, spec) {
        return new $81901ae0222f0506$export$10e30b733df217ea(from, to, new $81901ae0222f0506$var$InlineType(attrs, spec));
    }
    /**
    Creates a node decoration. `from` and `to` should point precisely
    before and after a node in the document. That node, and only that
    node, will receive the given attributes.
    */ static node(from, to, attrs, spec) {
        return new $81901ae0222f0506$export$10e30b733df217ea(from, to, new $81901ae0222f0506$var$NodeType(attrs, spec));
    }
    /**
    The spec provided when creating this decoration. Can be useful
    if you've stored extra information in that object.
    */ get spec() {
        return this.type.spec;
    }
    /**
    @internal
    */ get inline() {
        return this.type instanceof $81901ae0222f0506$var$InlineType;
    }
    /**
    @internal
    */ get widget() {
        return this.type instanceof $81901ae0222f0506$var$WidgetType;
    }
}
const $81901ae0222f0506$var$none = [], $81901ae0222f0506$var$noSpec = {};
/**
A collection of [decorations](https://prosemirror.net/docs/ref/#view.Decoration), organized in such
a way that the drawing algorithm can efficiently use and compare
them. This is a persistent data structure—it is not modified,
updates create a new value.
*/ class $81901ae0222f0506$export$93bf62eb445cec98 {
    /**
    @internal
    */ constructor(local, children){
        this.local = local.length ? local : $81901ae0222f0506$var$none;
        this.children = children.length ? children : $81901ae0222f0506$var$none;
    }
    /**
    Create a set of decorations, using the structure of the given
    document. This will consume (modify) the `decorations` array, so
    you must make a copy if you want need to preserve that.
    */ static create(doc, decorations) {
        return decorations.length ? $81901ae0222f0506$var$buildTree(decorations, doc, 0, $81901ae0222f0506$var$noSpec) : $81901ae0222f0506$var$empty;
    }
    /**
    Find all decorations in this set which touch the given range
    (including decorations that start or end directly at the
    boundaries) and match the given predicate on their spec. When
    `start` and `end` are omitted, all decorations in the set are
    considered. When `predicate` isn't given, all decorations are
    assumed to match.
    */ find(start, end, predicate) {
        let result = [];
        this.findInner(start == null ? 0 : start, end == null ? 1e9 : end, result, 0, predicate);
        return result;
    }
    findInner(start, end, result, offset, predicate) {
        for(let i = 0; i < this.local.length; i++){
            let span = this.local[i];
            if (span.from <= end && span.to >= start && (!predicate || predicate(span.spec))) result.push(span.copy(span.from + offset, span.to + offset));
        }
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] < end && this.children[i + 1] > start) {
            let childOff = this.children[i] + 1;
            this.children[i + 2].findInner(start - childOff, end - childOff, result, offset + childOff, predicate);
        }
    }
    /**
    Map the set of decorations in response to a change in the
    document.
    */ map(mapping, doc, options) {
        if (this == $81901ae0222f0506$var$empty || mapping.maps.length == 0) return this;
        return this.mapInner(mapping, doc, 0, 0, options || $81901ae0222f0506$var$noSpec);
    }
    /**
    @internal
    */ mapInner(mapping, node, offset, oldOffset, options) {
        let newLocal;
        for(let i = 0; i < this.local.length; i++){
            let mapped = this.local[i].map(mapping, offset, oldOffset);
            if (mapped && mapped.type.valid(node, mapped)) (newLocal || (newLocal = [])).push(mapped);
            else if (options.onRemove) options.onRemove(this.local[i].spec);
        }
        if (this.children.length) return $81901ae0222f0506$var$mapChildren(this.children, newLocal || [], mapping, node, offset, oldOffset, options);
        else return newLocal ? new $81901ae0222f0506$export$93bf62eb445cec98(newLocal.sort($81901ae0222f0506$var$byPos), $81901ae0222f0506$var$none) : $81901ae0222f0506$var$empty;
    }
    /**
    Add the given array of decorations to the ones in the set,
    producing a new set. Consumes the `decorations` array. Needs
    access to the current document to create the appropriate tree
    structure.
    */ add(doc, decorations) {
        if (!decorations.length) return this;
        if (this == $81901ae0222f0506$var$empty) return $81901ae0222f0506$export$93bf62eb445cec98.create(doc, decorations);
        return this.addInner(doc, decorations, 0);
    }
    addInner(doc, decorations, offset) {
        let children, childIndex = 0;
        doc.forEach((childNode, childOffset)=>{
            let baseOffset = childOffset + offset, found;
            if (!(found = $81901ae0222f0506$var$takeSpansForNode(decorations, childNode, baseOffset))) return;
            if (!children) children = this.children.slice();
            while(childIndex < children.length && children[childIndex] < childOffset)childIndex += 3;
            if (children[childIndex] == childOffset) children[childIndex + 2] = children[childIndex + 2].addInner(childNode, found, baseOffset + 1);
            else children.splice(childIndex, 0, childOffset, childOffset + childNode.nodeSize, $81901ae0222f0506$var$buildTree(found, childNode, baseOffset + 1, $81901ae0222f0506$var$noSpec));
            childIndex += 3;
        });
        let local = $81901ae0222f0506$var$moveSpans(childIndex ? $81901ae0222f0506$var$withoutNulls(decorations) : decorations, -offset);
        for(let i = 0; i < local.length; i++)if (!local[i].type.valid(doc, local[i])) local.splice(i--, 1);
        return new $81901ae0222f0506$export$93bf62eb445cec98(local.length ? this.local.concat(local).sort($81901ae0222f0506$var$byPos) : this.local, children || this.children);
    }
    /**
    Create a new set that contains the decorations in this set, minus
    the ones in the given array.
    */ remove(decorations) {
        if (decorations.length == 0 || this == $81901ae0222f0506$var$empty) return this;
        return this.removeInner(decorations, 0);
    }
    removeInner(decorations, offset) {
        let children = this.children, local = this.local;
        for(let i = 0; i < children.length; i += 3){
            let found;
            let from = children[i] + offset, to = children[i + 1] + offset;
            for(let j = 0, span; j < decorations.length; j++)if (span = decorations[j]) {
                if (span.from > from && span.to < to) {
                    decorations[j] = null;
                    (found || (found = [])).push(span);
                }
            }
            if (!found) continue;
            if (children == this.children) children = this.children.slice();
            let removed = children[i + 2].removeInner(found, from + 1);
            if (removed != $81901ae0222f0506$var$empty) children[i + 2] = removed;
            else {
                children.splice(i, 3);
                i -= 3;
            }
        }
        if (local.length) {
            for(let i = 0, span; i < decorations.length; i++)if (span = decorations[i]) {
                for(let j = 0; j < local.length; j++)if (local[j].eq(span, offset)) {
                    if (local == this.local) local = this.local.slice();
                    local.splice(j--, 1);
                }
            }
        }
        if (children == this.children && local == this.local) return this;
        return local.length || children.length ? new $81901ae0222f0506$export$93bf62eb445cec98(local, children) : $81901ae0222f0506$var$empty;
    }
    forChild(offset, node) {
        if (this == $81901ae0222f0506$var$empty) return this;
        if (node.isLeaf) return $81901ae0222f0506$export$93bf62eb445cec98.empty;
        let child, local;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] >= offset) {
            if (this.children[i] == offset) child = this.children[i + 2];
            break;
        }
        let start = offset + 1, end = start + node.content.size;
        for(let i = 0; i < this.local.length; i++){
            let dec = this.local[i];
            if (dec.from < end && dec.to > start && dec.type instanceof $81901ae0222f0506$var$InlineType) {
                let from = Math.max(start, dec.from) - start, to = Math.min(end, dec.to) - start;
                if (from < to) (local || (local = [])).push(dec.copy(from, to));
            }
        }
        if (local) {
            let localSet = new $81901ae0222f0506$export$93bf62eb445cec98(local.sort($81901ae0222f0506$var$byPos), $81901ae0222f0506$var$none);
            return child ? new $81901ae0222f0506$var$DecorationGroup([
                localSet,
                child
            ]) : localSet;
        }
        return child || $81901ae0222f0506$var$empty;
    }
    /**
    @internal
    */ eq(other) {
        if (this == other) return true;
        if (!(other instanceof $81901ae0222f0506$export$93bf62eb445cec98) || this.local.length != other.local.length || this.children.length != other.children.length) return false;
        for(let i = 0; i < this.local.length; i++)if (!this.local[i].eq(other.local[i])) return false;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] != other.children[i] || this.children[i + 1] != other.children[i + 1] || !this.children[i + 2].eq(other.children[i + 2])) return false;
        return true;
    }
    /**
    @internal
    */ locals(node) {
        return $81901ae0222f0506$var$removeOverlap(this.localsInner(node));
    }
    /**
    @internal
    */ localsInner(node) {
        if (this == $81901ae0222f0506$var$empty) return $81901ae0222f0506$var$none;
        if (node.inlineContent || !this.local.some($81901ae0222f0506$var$InlineType.is)) return this.local;
        let result = [];
        for(let i = 0; i < this.local.length; i++)if (!(this.local[i].type instanceof $81901ae0222f0506$var$InlineType)) result.push(this.local[i]);
        return result;
    }
    forEachSet(f) {
        f(this);
    }
}
/**
The empty set of decorations.
*/ $81901ae0222f0506$export$93bf62eb445cec98.empty = new $81901ae0222f0506$export$93bf62eb445cec98([], []);
/**
@internal
*/ $81901ae0222f0506$export$93bf62eb445cec98.removeOverlap = $81901ae0222f0506$var$removeOverlap;
const $81901ae0222f0506$var$empty = $81901ae0222f0506$export$93bf62eb445cec98.empty;
// An abstraction that allows the code dealing with decorations to
// treat multiple DecorationSet objects as if it were a single object
// with (a subset of) the same interface.
class $81901ae0222f0506$var$DecorationGroup {
    constructor(members){
        this.members = members;
    }
    map(mapping, doc) {
        const mappedDecos = this.members.map((member)=>member.map(mapping, doc, $81901ae0222f0506$var$noSpec));
        return $81901ae0222f0506$var$DecorationGroup.from(mappedDecos);
    }
    forChild(offset, child) {
        if (child.isLeaf) return $81901ae0222f0506$export$93bf62eb445cec98.empty;
        let found = [];
        for(let i = 0; i < this.members.length; i++){
            let result = this.members[i].forChild(offset, child);
            if (result == $81901ae0222f0506$var$empty) continue;
            if (result instanceof $81901ae0222f0506$var$DecorationGroup) found = found.concat(result.members);
            else found.push(result);
        }
        return $81901ae0222f0506$var$DecorationGroup.from(found);
    }
    eq(other) {
        if (!(other instanceof $81901ae0222f0506$var$DecorationGroup) || other.members.length != this.members.length) return false;
        for(let i = 0; i < this.members.length; i++)if (!this.members[i].eq(other.members[i])) return false;
        return true;
    }
    locals(node) {
        let result, sorted = true;
        for(let i = 0; i < this.members.length; i++){
            let locals = this.members[i].localsInner(node);
            if (!locals.length) continue;
            if (!result) result = locals;
            else {
                if (sorted) {
                    result = result.slice();
                    sorted = false;
                }
                for(let j = 0; j < locals.length; j++)result.push(locals[j]);
            }
        }
        return result ? $81901ae0222f0506$var$removeOverlap(sorted ? result : result.sort($81901ae0222f0506$var$byPos)) : $81901ae0222f0506$var$none;
    }
    // Create a group for the given array of decoration sets, or return
    // a single set when possible.
    static from(members) {
        switch(members.length){
            case 0:
                return $81901ae0222f0506$var$empty;
            case 1:
                return members[0];
            default:
                return new $81901ae0222f0506$var$DecorationGroup(members.every((m)=>m instanceof $81901ae0222f0506$export$93bf62eb445cec98) ? members : members.reduce((r, m)=>r.concat(m instanceof $81901ae0222f0506$export$93bf62eb445cec98 ? m : m.members), []));
        }
    }
    forEachSet(f) {
        for(let i = 0; i < this.members.length; i++)this.members[i].forEachSet(f);
    }
}
function $81901ae0222f0506$var$mapChildren(oldChildren, newLocal, mapping, node, offset, oldOffset, options) {
    let children = oldChildren.slice();
    // Mark the children that are directly touched by changes, and
    // move those that are after the changes.
    for(let i = 0, baseOffset = oldOffset; i < mapping.maps.length; i++){
        let moved = 0;
        mapping.maps[i].forEach((oldStart, oldEnd, newStart, newEnd)=>{
            let dSize = newEnd - newStart - (oldEnd - oldStart);
            for(let i = 0; i < children.length; i += 3){
                let end = children[i + 1];
                if (end < 0 || oldStart > end + baseOffset - moved) continue;
                let start = children[i] + baseOffset - moved;
                if (oldEnd >= start) children[i + 1] = oldStart <= start ? -2 : -1;
                else if (oldStart >= baseOffset && dSize) {
                    children[i] += dSize;
                    children[i + 1] += dSize;
                }
            }
            moved += dSize;
        });
        baseOffset = mapping.maps[i].map(baseOffset, -1);
    }
    // Find the child nodes that still correspond to a single node,
    // recursively call mapInner on them and update their positions.
    let mustRebuild = false;
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
        if (children[i + 1] == -2) {
            mustRebuild = true;
            children[i + 1] = -1;
            continue;
        }
        let from = mapping.map(oldChildren[i] + oldOffset), fromLocal = from - offset;
        if (fromLocal < 0 || fromLocal >= node.content.size) {
            mustRebuild = true;
            continue;
        }
        // Must read oldChildren because children was tagged with -1
        let to = mapping.map(oldChildren[i + 1] + oldOffset, -1), toLocal = to - offset;
        let { index: index, offset: childOffset } = node.content.findIndex(fromLocal);
        let childNode = node.maybeChild(index);
        if (childNode && childOffset == fromLocal && childOffset + childNode.nodeSize == toLocal) {
            let mapped = children[i + 2].mapInner(mapping, childNode, from + 1, oldChildren[i] + oldOffset + 1, options);
            if (mapped != $81901ae0222f0506$var$empty) {
                children[i] = fromLocal;
                children[i + 1] = toLocal;
                children[i + 2] = mapped;
            } else {
                children[i + 1] = -2;
                mustRebuild = true;
            }
        } else mustRebuild = true;
    }
    // Remaining children must be collected and rebuilt into the appropriate structure
    if (mustRebuild) {
        let decorations = $81901ae0222f0506$var$mapAndGatherRemainingDecorations(children, oldChildren, newLocal, mapping, offset, oldOffset, options);
        let built = $81901ae0222f0506$var$buildTree(decorations, node, 0, options);
        newLocal = built.local;
        for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
            children.splice(i, 3);
            i -= 3;
        }
        for(let i = 0, j = 0; i < built.children.length; i += 3){
            let from = built.children[i];
            while(j < children.length && children[j] < from)j += 3;
            children.splice(j, 0, built.children[i], built.children[i + 1], built.children[i + 2]);
        }
    }
    return new $81901ae0222f0506$export$93bf62eb445cec98(newLocal.sort($81901ae0222f0506$var$byPos), children);
}
function $81901ae0222f0506$var$moveSpans(spans, offset) {
    if (!offset || !spans.length) return spans;
    let result = [];
    for(let i = 0; i < spans.length; i++){
        let span = spans[i];
        result.push(new $81901ae0222f0506$export$10e30b733df217ea(span.from + offset, span.to + offset, span.type));
    }
    return result;
}
function $81901ae0222f0506$var$mapAndGatherRemainingDecorations(children, oldChildren, decorations, mapping, offset, oldOffset, options) {
    // Gather all decorations from the remaining marked children
    function gather(set, oldOffset) {
        for(let i = 0; i < set.local.length; i++){
            let mapped = set.local[i].map(mapping, offset, oldOffset);
            if (mapped) decorations.push(mapped);
            else if (options.onRemove) options.onRemove(set.local[i].spec);
        }
        for(let i = 0; i < set.children.length; i += 3)gather(set.children[i + 2], set.children[i] + oldOffset + 1);
    }
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] == -1) gather(children[i + 2], oldChildren[i] + oldOffset + 1);
    return decorations;
}
function $81901ae0222f0506$var$takeSpansForNode(spans, node, offset) {
    if (node.isLeaf) return null;
    let end = offset + node.nodeSize, found = null;
    for(let i = 0, span; i < spans.length; i++)if ((span = spans[i]) && span.from > offset && span.to < end) {
        (found || (found = [])).push(span);
        spans[i] = null;
    }
    return found;
}
function $81901ae0222f0506$var$withoutNulls(array) {
    let result = [];
    for(let i = 0; i < array.length; i++)if (array[i] != null) result.push(array[i]);
    return result;
}
// Build up a tree that corresponds to a set of decorations. `offset`
// is a base offset that should be subtracted from the `from` and `to`
// positions in the spans (so that we don't have to allocate new spans
// for recursive calls).
function $81901ae0222f0506$var$buildTree(spans, node, offset, options) {
    let children = [], hasNulls = false;
    node.forEach((childNode, localStart)=>{
        let found = $81901ae0222f0506$var$takeSpansForNode(spans, childNode, localStart + offset);
        if (found) {
            hasNulls = true;
            let subtree = $81901ae0222f0506$var$buildTree(found, childNode, offset + localStart + 1, options);
            if (subtree != $81901ae0222f0506$var$empty) children.push(localStart, localStart + childNode.nodeSize, subtree);
        }
    });
    let locals = $81901ae0222f0506$var$moveSpans(hasNulls ? $81901ae0222f0506$var$withoutNulls(spans) : spans, -offset).sort($81901ae0222f0506$var$byPos);
    for(let i = 0; i < locals.length; i++)if (!locals[i].type.valid(node, locals[i])) {
        if (options.onRemove) options.onRemove(locals[i].spec);
        locals.splice(i--, 1);
    }
    return locals.length || children.length ? new $81901ae0222f0506$export$93bf62eb445cec98(locals, children) : $81901ae0222f0506$var$empty;
}
// Used to sort decorations so that ones with a low start position
// come first, and within a set with the same start position, those
// with an smaller end position come first.
function $81901ae0222f0506$var$byPos(a, b) {
    return a.from - b.from || a.to - b.to;
}
// Scan a sorted array of decorations for partially overlapping spans,
// and split those so that only fully overlapping spans are left (to
// make subsequent rendering easier). Will return the input array if
// no partially overlapping spans are found (the common case).
function $81901ae0222f0506$var$removeOverlap(spans) {
    let working = spans;
    for(let i = 0; i < working.length - 1; i++){
        let span = working[i];
        if (span.from != span.to) for(let j = i + 1; j < working.length; j++){
            let next = working[j];
            if (next.from == span.from) {
                if (next.to != span.to) {
                    if (working == spans) working = spans.slice();
                    // Followed by a partially overlapping larger span. Split that
                    // span.
                    working[j] = next.copy(next.from, span.to);
                    $81901ae0222f0506$var$insertAhead(working, j + 1, next.copy(span.to, next.to));
                }
                continue;
            } else {
                if (next.from < span.to) {
                    if (working == spans) working = spans.slice();
                    // The end of this one overlaps with a subsequent span. Split
                    // this one.
                    working[i] = span.copy(span.from, next.from);
                    $81901ae0222f0506$var$insertAhead(working, j, span.copy(next.from, span.to));
                }
                break;
            }
        }
    }
    return working;
}
function $81901ae0222f0506$var$insertAhead(array, i, deco) {
    while(i < array.length && $81901ae0222f0506$var$byPos(deco, array[i]) > 0)i++;
    array.splice(i, 0, deco);
}
// Get the decorations associated with the current props of a view.
function $81901ae0222f0506$var$viewDecorations(view) {
    let found = [];
    view.someProp("decorations", (f)=>{
        let result = f(view.state);
        if (result && result != $81901ae0222f0506$var$empty) found.push(result);
    });
    if (view.cursorWrapper) found.push($81901ae0222f0506$export$93bf62eb445cec98.create(view.state.doc, [
        view.cursorWrapper.deco
    ]));
    return $81901ae0222f0506$var$DecorationGroup.from(found);
}
const $81901ae0222f0506$var$observeOptions = {
    childList: true,
    characterData: true,
    characterDataOldValue: true,
    attributes: true,
    attributeOldValue: true,
    subtree: true
};
// IE11 has very broken mutation observers, so we also listen to DOMCharacterDataModified
const $81901ae0222f0506$var$useCharData = $81901ae0222f0506$var$ie && $81901ae0222f0506$var$ie_version <= 11;
class $81901ae0222f0506$var$SelectionState {
    constructor(){
        this.anchorNode = null;
        this.anchorOffset = 0;
        this.focusNode = null;
        this.focusOffset = 0;
    }
    set(sel) {
        this.anchorNode = sel.anchorNode;
        this.anchorOffset = sel.anchorOffset;
        this.focusNode = sel.focusNode;
        this.focusOffset = sel.focusOffset;
    }
    clear() {
        this.anchorNode = this.focusNode = null;
    }
    eq(sel) {
        return sel.anchorNode == this.anchorNode && sel.anchorOffset == this.anchorOffset && sel.focusNode == this.focusNode && sel.focusOffset == this.focusOffset;
    }
}
class $81901ae0222f0506$var$DOMObserver {
    constructor(view, handleDOMChange){
        this.view = view;
        this.handleDOMChange = handleDOMChange;
        this.queue = [];
        this.flushingSoon = -1;
        this.observer = null;
        this.currentSelection = new $81901ae0222f0506$var$SelectionState;
        this.onCharData = null;
        this.suppressingSelectionUpdates = false;
        this.lastChangedTextNode = null;
        this.observer = window.MutationObserver && new window.MutationObserver((mutations)=>{
            for(let i = 0; i < mutations.length; i++)this.queue.push(mutations[i]);
            // IE11 will sometimes (on backspacing out a single character
            // text node after a BR node) call the observer callback
            // before actually updating the DOM, which will cause
            // ProseMirror to miss the change (see #930)
            if ($81901ae0222f0506$var$ie && $81901ae0222f0506$var$ie_version <= 11 && mutations.some((m)=>m.type == "childList" && m.removedNodes.length || m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length)) this.flushSoon();
            else this.flush();
        });
        if ($81901ae0222f0506$var$useCharData) this.onCharData = (e)=>{
            this.queue.push({
                target: e.target,
                type: "characterData",
                oldValue: e.prevValue
            });
            this.flushSoon();
        };
        this.onSelectionChange = this.onSelectionChange.bind(this);
    }
    flushSoon() {
        if (this.flushingSoon < 0) this.flushingSoon = window.setTimeout(()=>{
            this.flushingSoon = -1;
            this.flush();
        }, 20);
    }
    forceFlush() {
        if (this.flushingSoon > -1) {
            window.clearTimeout(this.flushingSoon);
            this.flushingSoon = -1;
            this.flush();
        }
    }
    start() {
        if (this.observer) {
            this.observer.takeRecords();
            this.observer.observe(this.view.dom, $81901ae0222f0506$var$observeOptions);
        }
        if (this.onCharData) this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
        this.connectSelection();
    }
    stop() {
        if (this.observer) {
            let take = this.observer.takeRecords();
            if (take.length) {
                for(let i = 0; i < take.length; i++)this.queue.push(take[i]);
                window.setTimeout(()=>this.flush(), 20);
            }
            this.observer.disconnect();
        }
        if (this.onCharData) this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
        this.disconnectSelection();
    }
    connectSelection() {
        this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
    }
    disconnectSelection() {
        this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
    }
    suppressSelectionUpdates() {
        this.suppressingSelectionUpdates = true;
        setTimeout(()=>this.suppressingSelectionUpdates = false, 50);
    }
    onSelectionChange() {
        if (!$81901ae0222f0506$var$hasFocusAndSelection(this.view)) return;
        if (this.suppressingSelectionUpdates) return $81901ae0222f0506$var$selectionToDOM(this.view);
        // Deletions on IE11 fire their events in the wrong order, giving
        // us a selection change event before the DOM changes are
        // reported.
        if ($81901ae0222f0506$var$ie && $81901ae0222f0506$var$ie_version <= 11 && !this.view.state.selection.empty) {
            let sel = this.view.domSelectionRange();
            // Selection.isCollapsed isn't reliable on IE
            if (sel.focusNode && $81901ae0222f0506$var$isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset)) return this.flushSoon();
        }
        this.flush();
    }
    setCurSelection() {
        this.currentSelection.set(this.view.domSelectionRange());
    }
    ignoreSelectionChange(sel) {
        if (!sel.focusNode) return true;
        let ancestors = new Set, container;
        for(let scan = sel.focusNode; scan; scan = $81901ae0222f0506$var$parentNode(scan))ancestors.add(scan);
        for(let scan = sel.anchorNode; scan; scan = $81901ae0222f0506$var$parentNode(scan))if (ancestors.has(scan)) {
            container = scan;
            break;
        }
        let desc = container && this.view.docView.nearestDesc(container);
        if (desc && desc.ignoreMutation({
            type: "selection",
            target: container.nodeType == 3 ? container.parentNode : container
        })) {
            this.setCurSelection();
            return true;
        }
    }
    pendingRecords() {
        if (this.observer) for (let mut of this.observer.takeRecords())this.queue.push(mut);
        return this.queue;
    }
    flush() {
        let { view: view } = this;
        if (!view.docView || this.flushingSoon > -1) return;
        let mutations = this.pendingRecords();
        if (mutations.length) this.queue = [];
        let sel = view.domSelectionRange();
        let newSel = !this.suppressingSelectionUpdates && !this.currentSelection.eq(sel) && $81901ae0222f0506$var$hasFocusAndSelection(view) && !this.ignoreSelectionChange(sel);
        let from = -1, to = -1, typeOver = false, added = [];
        if (view.editable) for(let i = 0; i < mutations.length; i++){
            let result = this.registerMutation(mutations[i], added);
            if (result) {
                from = from < 0 ? result.from : Math.min(result.from, from);
                to = to < 0 ? result.to : Math.max(result.to, to);
                if (result.typeOver) typeOver = true;
            }
        }
        if ($81901ae0222f0506$var$gecko && added.length) {
            let brs = added.filter((n)=>n.nodeName == "BR");
            if (brs.length == 2) {
                let [a, b] = brs;
                if (a.parentNode && a.parentNode.parentNode == b.parentNode) b.remove();
                else a.remove();
            } else {
                let { focusNode: focusNode } = this.currentSelection;
                for (let br of brs){
                    let parent = br.parentNode;
                    if (parent && parent.nodeName == "LI" && (!focusNode || $81901ae0222f0506$var$blockParent(view, focusNode) != parent)) br.remove();
                }
            }
        }
        let readSel = null;
        // If it looks like the browser has reset the selection to the
        // start of the document after focus, restore the selection from
        // the state
        if (from < 0 && newSel && view.input.lastFocus > Date.now() - 200 && Math.max(view.input.lastTouch, view.input.lastClick.time) < Date.now() - 300 && $81901ae0222f0506$var$selectionCollapsed(sel) && (readSel = $81901ae0222f0506$var$selectionFromDOM(view)) && readSel.eq((0, $3lIcL.Selection).near(view.state.doc.resolve(0), 1))) {
            view.input.lastFocus = 0;
            $81901ae0222f0506$var$selectionToDOM(view);
            this.currentSelection.set(sel);
            view.scrollToSelection();
        } else if (from > -1 || newSel) {
            if (from > -1) {
                view.docView.markDirty(from, to);
                $81901ae0222f0506$var$checkCSS(view);
            }
            this.handleDOMChange(from, to, typeOver, added);
            if (view.docView && view.docView.dirty) view.updateState(view.state);
            else if (!this.currentSelection.eq(sel)) $81901ae0222f0506$var$selectionToDOM(view);
            this.currentSelection.set(sel);
        }
    }
    registerMutation(mut, added) {
        // Ignore mutations inside nodes that were already noted as inserted
        if (added.indexOf(mut.target) > -1) return null;
        let desc = this.view.docView.nearestDesc(mut.target);
        if (mut.type == "attributes" && (desc == this.view.docView || mut.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
        mut.attributeName == "style" && !mut.oldValue && !mut.target.getAttribute("style"))) return null;
        if (!desc || desc.ignoreMutation(mut)) return null;
        if (mut.type == "childList") {
            for(let i = 0; i < mut.addedNodes.length; i++){
                let node = mut.addedNodes[i];
                added.push(node);
                if (node.nodeType == 3) this.lastChangedTextNode = node;
            }
            if (desc.contentDOM && desc.contentDOM != desc.dom && !desc.contentDOM.contains(mut.target)) return {
                from: desc.posBefore,
                to: desc.posAfter
            };
            let prev = mut.previousSibling, next = mut.nextSibling;
            if ($81901ae0222f0506$var$ie && $81901ae0222f0506$var$ie_version <= 11 && mut.addedNodes.length) // IE11 gives us incorrect next/prev siblings for some
            // insertions, so if there are added nodes, recompute those
            for(let i = 0; i < mut.addedNodes.length; i++){
                let { previousSibling: previousSibling, nextSibling: nextSibling } = mut.addedNodes[i];
                if (!previousSibling || Array.prototype.indexOf.call(mut.addedNodes, previousSibling) < 0) prev = previousSibling;
                if (!nextSibling || Array.prototype.indexOf.call(mut.addedNodes, nextSibling) < 0) next = nextSibling;
            }
            let fromOffset = prev && prev.parentNode == mut.target ? $81901ae0222f0506$var$domIndex(prev) + 1 : 0;
            let from = desc.localPosFromDOM(mut.target, fromOffset, -1);
            let toOffset = next && next.parentNode == mut.target ? $81901ae0222f0506$var$domIndex(next) : mut.target.childNodes.length;
            let to = desc.localPosFromDOM(mut.target, toOffset, 1);
            return {
                from: from,
                to: to
            };
        } else if (mut.type == "attributes") return {
            from: desc.posAtStart - desc.border,
            to: desc.posAtEnd + desc.border
        };
        else {
            this.lastChangedTextNode = mut.target;
            return {
                from: desc.posAtStart,
                to: desc.posAtEnd,
                // An event was generated for a text change that didn't change
                // any text. Mark the dom change to fall back to assuming the
                // selection was typed over with an identical value if it can't
                // find another change.
                typeOver: mut.target.nodeValue == mut.oldValue
            };
        }
    }
}
let $81901ae0222f0506$var$cssChecked = new WeakMap();
let $81901ae0222f0506$var$cssCheckWarned = false;
function $81901ae0222f0506$var$checkCSS(view) {
    if ($81901ae0222f0506$var$cssChecked.has(view)) return;
    $81901ae0222f0506$var$cssChecked.set(view, null);
    if ([
        'normal',
        'nowrap',
        'pre-line'
    ].indexOf(getComputedStyle(view.dom).whiteSpace) !== -1) {
        view.requiresGeckoHackNode = $81901ae0222f0506$var$gecko;
        if ($81901ae0222f0506$var$cssCheckWarned) return;
        console["warn"]("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package.");
        $81901ae0222f0506$var$cssCheckWarned = true;
    }
}
function $81901ae0222f0506$var$rangeToSelectionRange(view, range) {
    let anchorNode = range.startContainer, anchorOffset = range.startOffset;
    let focusNode = range.endContainer, focusOffset = range.endOffset;
    let currentAnchor = view.domAtPos(view.state.selection.anchor);
    // Since such a range doesn't distinguish between anchor and head,
    // use a heuristic that flips it around if its end matches the
    // current anchor.
    if ($81901ae0222f0506$var$isEquivalentPosition(currentAnchor.node, currentAnchor.offset, focusNode, focusOffset)) [anchorNode, anchorOffset, focusNode, focusOffset] = [
        focusNode,
        focusOffset,
        anchorNode,
        anchorOffset
    ];
    return {
        anchorNode: anchorNode,
        anchorOffset: anchorOffset,
        focusNode: focusNode,
        focusOffset: focusOffset
    };
}
// Used to work around a Safari Selection/shadow DOM bug
// Based on https://github.com/codemirror/dev/issues/414 fix
function $81901ae0222f0506$var$safariShadowSelectionRange(view, selection) {
    if (selection.getComposedRanges) {
        let range = selection.getComposedRanges(view.root)[0];
        if (range) return $81901ae0222f0506$var$rangeToSelectionRange(view, range);
    }
    let found;
    function read(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        found = event.getTargetRanges()[0];
    }
    // Because Safari (at least in 2018-2022) doesn't provide regular
    // access to the selection inside a shadowRoot, we have to perform a
    // ridiculous hack to get at it—using `execCommand` to trigger a
    // `beforeInput` event so that we can read the target range from the
    // event.
    view.dom.addEventListener("beforeinput", read, true);
    document.execCommand("indent");
    view.dom.removeEventListener("beforeinput", read, true);
    return found ? $81901ae0222f0506$var$rangeToSelectionRange(view, found) : null;
}
function $81901ae0222f0506$var$blockParent(view, node) {
    for(let p = node.parentNode; p && p != view.dom; p = p.parentNode){
        let desc = view.docView.nearestDesc(p, true);
        if (desc && desc.node.isBlock) return p;
    }
    return null;
}
// Note that all referencing and parsing is done with the
// start-of-operation selection and document, since that's the one
// that the DOM represents. If any changes came in in the meantime,
// the modification is mapped over those before it is applied, in
// readDOMChange.
function $81901ae0222f0506$var$parseBetween(view, from_, to_) {
    let { node: parent, fromOffset: fromOffset, toOffset: toOffset, from: from, to: to } = view.docView.parseRange(from_, to_);
    let domSel = view.domSelectionRange();
    let find;
    let anchor = domSel.anchorNode;
    if (anchor && view.dom.contains(anchor.nodeType == 1 ? anchor : anchor.parentNode)) {
        find = [
            {
                node: anchor,
                offset: domSel.anchorOffset
            }
        ];
        if (!$81901ae0222f0506$var$selectionCollapsed(domSel)) find.push({
            node: domSel.focusNode,
            offset: domSel.focusOffset
        });
    }
    // Work around issue in Chrome where backspacing sometimes replaces
    // the deleted content with a random BR node (issues #799, #831)
    if ($81901ae0222f0506$var$chrome && view.input.lastKeyCode === 8) for(let off = toOffset; off > fromOffset; off--){
        let node = parent.childNodes[off - 1], desc = node.pmViewDesc;
        if (node.nodeName == "BR" && !desc) {
            toOffset = off;
            break;
        }
        if (!desc || desc.size) break;
    }
    let startDoc = view.state.doc;
    let parser = view.someProp("domParser") || (0, $3xw6l.DOMParser).fromSchema(view.state.schema);
    let $from = startDoc.resolve(from);
    let sel = null, doc = parser.parse(parent, {
        topNode: $from.parent,
        topMatch: $from.parent.contentMatchAt($from.index()),
        topOpen: true,
        from: fromOffset,
        to: toOffset,
        preserveWhitespace: $from.parent.type.whitespace == "pre" ? "full" : true,
        findPositions: find,
        ruleFromNode: $81901ae0222f0506$var$ruleFromNode,
        context: $from
    });
    if (find && find[0].pos != null) {
        let anchor = find[0].pos, head = find[1] && find[1].pos;
        if (head == null) head = anchor;
        sel = {
            anchor: anchor + from,
            head: head + from
        };
    }
    return {
        doc: doc,
        sel: sel,
        from: from,
        to: to
    };
}
function $81901ae0222f0506$var$ruleFromNode(dom) {
    let desc = dom.pmViewDesc;
    if (desc) return desc.parseRule();
    else if (dom.nodeName == "BR" && dom.parentNode) {
        // Safari replaces the list item or table cell with a BR
        // directly in the list node (?!) if you delete the last
        // character in a list item or table cell (#708, #862)
        if ($81901ae0222f0506$var$safari && /^(ul|ol)$/i.test(dom.parentNode.nodeName)) {
            let skip = document.createElement("div");
            skip.appendChild(document.createElement("li"));
            return {
                skip: skip
            };
        } else if (dom.parentNode.lastChild == dom || $81901ae0222f0506$var$safari && /^(tr|table)$/i.test(dom.parentNode.nodeName)) return {
            ignore: true
        };
    } else if (dom.nodeName == "IMG" && dom.getAttribute("mark-placeholder")) return {
        ignore: true
    };
    return null;
}
const $81901ae0222f0506$var$isInline = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function $81901ae0222f0506$var$readDOMChange(view, from, to, typeOver, addedNodes) {
    let compositionID = view.input.compositionPendingChanges || (view.composing ? view.input.compositionID : 0);
    view.input.compositionPendingChanges = 0;
    if (from < 0) {
        let origin = view.input.lastSelectionTime > Date.now() - 50 ? view.input.lastSelectionOrigin : null;
        let newSel = $81901ae0222f0506$var$selectionFromDOM(view, origin);
        if (newSel && !view.state.selection.eq(newSel)) {
            if ($81901ae0222f0506$var$chrome && $81901ae0222f0506$var$android && view.input.lastKeyCode === 13 && Date.now() - 100 < view.input.lastKeyCodeTime && view.someProp("handleKeyDown", (f)=>f(view, $81901ae0222f0506$var$keyEvent(13, "Enter")))) return;
            let tr = view.state.tr.setSelection(newSel);
            if (origin == "pointer") tr.setMeta("pointer", true);
            else if (origin == "key") tr.scrollIntoView();
            if (compositionID) tr.setMeta("composition", compositionID);
            view.dispatch(tr);
        }
        return;
    }
    let $before = view.state.doc.resolve(from);
    let shared = $before.sharedDepth(to);
    from = $before.before(shared + 1);
    to = view.state.doc.resolve(to).after(shared + 1);
    let sel = view.state.selection;
    let parse = $81901ae0222f0506$var$parseBetween(view, from, to);
    let doc = view.state.doc, compare = doc.slice(parse.from, parse.to);
    let preferredPos, preferredSide;
    // Prefer anchoring to end when Backspace is pressed
    if (view.input.lastKeyCode === 8 && Date.now() - 100 < view.input.lastKeyCodeTime) {
        preferredPos = view.state.selection.to;
        preferredSide = "end";
    } else {
        preferredPos = view.state.selection.from;
        preferredSide = "start";
    }
    view.input.lastKeyCode = null;
    let change = $81901ae0222f0506$var$findDiff(compare.content, parse.doc.content, parse.from, preferredPos, preferredSide);
    if (change) view.input.domChangeCount++;
    if (($81901ae0222f0506$var$ios && view.input.lastIOSEnter > Date.now() - 225 || $81901ae0222f0506$var$android) && addedNodes.some((n)=>n.nodeType == 1 && !$81901ae0222f0506$var$isInline.test(n.nodeName)) && (!change || change.endA >= change.endB) && view.someProp("handleKeyDown", (f)=>f(view, $81901ae0222f0506$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    if (!change) {
        if (typeOver && sel instanceof (0, $3lIcL.TextSelection) && !sel.empty && sel.$head.sameParent(sel.$anchor) && !view.composing && !(parse.sel && parse.sel.anchor != parse.sel.head)) change = {
            start: sel.from,
            endA: sel.to,
            endB: sel.to
        };
        else {
            if (parse.sel) {
                let sel = $81901ae0222f0506$var$resolveSelection(view, view.state.doc, parse.sel);
                if (sel && !sel.eq(view.state.selection)) {
                    let tr = view.state.tr.setSelection(sel);
                    if (compositionID) tr.setMeta("composition", compositionID);
                    view.dispatch(tr);
                }
            }
            return;
        }
    }
    // Handle the case where overwriting a selection by typing matches
    // the start or end of the selected content, creating a change
    // that's smaller than what was actually overwritten.
    if (view.state.selection.from < view.state.selection.to && change.start == change.endB && view.state.selection instanceof (0, $3lIcL.TextSelection)) {
        if (change.start > view.state.selection.from && change.start <= view.state.selection.from + 2 && view.state.selection.from >= parse.from) change.start = view.state.selection.from;
        else if (change.endA < view.state.selection.to && change.endA >= view.state.selection.to - 2 && view.state.selection.to <= parse.to) {
            change.endB += view.state.selection.to - change.endA;
            change.endA = view.state.selection.to;
        }
    }
    // IE11 will insert a non-breaking space _ahead_ of the space after
    // the cursor space when adding a space before another space. When
    // that happened, adjust the change to cover the space instead.
    if ($81901ae0222f0506$var$ie && $81901ae0222f0506$var$ie_version <= 11 && change.endB == change.start + 1 && change.endA == change.start && change.start > parse.from && parse.doc.textBetween(change.start - parse.from - 1, change.start - parse.from + 1) == " \u00a0") {
        change.start--;
        change.endA--;
        change.endB--;
    }
    let $from = parse.doc.resolveNoCache(change.start - parse.from);
    let $to = parse.doc.resolveNoCache(change.endB - parse.from);
    let $fromA = doc.resolve(change.start);
    let inlineChange = $from.sameParent($to) && $from.parent.inlineContent && $fromA.end() >= change.endA;
    let nextSel;
    // If this looks like the effect of pressing Enter (or was recorded
    // as being an iOS enter press), just dispatch an Enter key instead.
    if (($81901ae0222f0506$var$ios && view.input.lastIOSEnter > Date.now() - 225 && (!inlineChange || addedNodes.some((n)=>n.nodeName == "DIV" || n.nodeName == "P")) || !inlineChange && $from.pos < parse.doc.content.size && !$from.sameParent($to) && (nextSel = (0, $3lIcL.Selection).findFrom(parse.doc.resolve($from.pos + 1), 1, true)) && nextSel.head == $to.pos) && view.someProp("handleKeyDown", (f)=>f(view, $81901ae0222f0506$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    // Same for backspace
    if (view.state.selection.anchor > change.start && $81901ae0222f0506$var$looksLikeBackspace(doc, change.start, change.endA, $from, $to) && view.someProp("handleKeyDown", (f)=>f(view, $81901ae0222f0506$var$keyEvent(8, "Backspace")))) {
        if ($81901ae0222f0506$var$android && $81901ae0222f0506$var$chrome) view.domObserver.suppressSelectionUpdates(); // #820
        return;
    }
    // Chrome will occasionally, during composition, delete the
    // entire composition and then immediately insert it again. This is
    // used to detect that situation.
    if ($81901ae0222f0506$var$chrome && change.endB == change.start) view.input.lastChromeDelete = Date.now();
    // This tries to detect Android virtual keyboard
    // enter-and-pick-suggestion action. That sometimes (see issue
    // #1059) first fires a DOM mutation, before moving the selection to
    // the newly created block. And then, because ProseMirror cleans up
    // the DOM selection, it gives up moving the selection entirely,
    // leaving the cursor in the wrong place. When that happens, we drop
    // the new paragraph from the initial change, and fire a simulated
    // enter key afterwards.
    if ($81901ae0222f0506$var$android && !inlineChange && $from.start() != $to.start() && $to.parentOffset == 0 && $from.depth == $to.depth && parse.sel && parse.sel.anchor == parse.sel.head && parse.sel.head == change.endA) {
        change.endB -= 2;
        $to = parse.doc.resolveNoCache(change.endB - parse.from);
        setTimeout(()=>{
            view.someProp("handleKeyDown", function(f) {
                return f(view, $81901ae0222f0506$var$keyEvent(13, "Enter"));
            });
        }, 20);
    }
    let chFrom = change.start, chTo = change.endA;
    let tr, storedMarks, markChange;
    if (inlineChange) {
        if ($from.pos == $to.pos) {
            // IE11 sometimes weirdly moves the DOM selection around after
            // backspacing out the first element in a textblock
            if ($81901ae0222f0506$var$ie && $81901ae0222f0506$var$ie_version <= 11 && $from.parentOffset == 0) {
                view.domObserver.suppressSelectionUpdates();
                setTimeout(()=>$81901ae0222f0506$var$selectionToDOM(view), 20);
            }
            tr = view.state.tr.delete(chFrom, chTo);
            storedMarks = doc.resolve(change.start).marksAcross(doc.resolve(change.endA));
        } else if (change.endA == change.endB && (markChange = $81901ae0222f0506$var$isMarkChange($from.parent.content.cut($from.parentOffset, $to.parentOffset), $fromA.parent.content.cut($fromA.parentOffset, change.endA - $fromA.start())))) {
            tr = view.state.tr;
            if (markChange.type == "add") tr.addMark(chFrom, chTo, markChange.mark);
            else tr.removeMark(chFrom, chTo, markChange.mark);
        } else if ($from.parent.child($from.index()).isText && $from.index() == $to.index() - ($to.textOffset ? 0 : 1)) {
            // Both positions in the same text node -- simply insert text
            let text = $from.parent.textBetween($from.parentOffset, $to.parentOffset);
            if (view.someProp("handleTextInput", (f)=>f(view, chFrom, chTo, text))) return;
            tr = view.state.tr.insertText(text, chFrom, chTo);
        }
    }
    if (!tr) tr = view.state.tr.replace(chFrom, chTo, parse.doc.slice(change.start - parse.from, change.endB - parse.from));
    if (parse.sel) {
        let sel = $81901ae0222f0506$var$resolveSelection(view, tr.doc, parse.sel);
        // Chrome will sometimes, during composition, report the
        // selection in the wrong place. If it looks like that is
        // happening, don't update the selection.
        // Edge just doesn't move the cursor forward when you start typing
        // in an empty block or between br nodes.
        if (sel && !($81901ae0222f0506$var$chrome && view.composing && sel.empty && (change.start != change.endB || view.input.lastChromeDelete < Date.now() - 100) && (sel.head == chFrom || sel.head == tr.mapping.map(chTo) - 1) || $81901ae0222f0506$var$ie && sel.empty && sel.head == chFrom)) tr.setSelection(sel);
    }
    if (storedMarks) tr.ensureMarks(storedMarks);
    if (compositionID) tr.setMeta("composition", compositionID);
    view.dispatch(tr.scrollIntoView());
}
function $81901ae0222f0506$var$resolveSelection(view, doc, parsedSel) {
    if (Math.max(parsedSel.anchor, parsedSel.head) > doc.content.size) return null;
    return $81901ae0222f0506$var$selectionBetween(view, doc.resolve(parsedSel.anchor), doc.resolve(parsedSel.head));
}
// Given two same-length, non-empty fragments of inline content,
// determine whether the first could be created from the second by
// removing or adding a single mark type.
function $81901ae0222f0506$var$isMarkChange(cur, prev) {
    let curMarks = cur.firstChild.marks, prevMarks = prev.firstChild.marks;
    let added = curMarks, removed = prevMarks, type, mark, update;
    for(let i = 0; i < prevMarks.length; i++)added = prevMarks[i].removeFromSet(added);
    for(let i = 0; i < curMarks.length; i++)removed = curMarks[i].removeFromSet(removed);
    if (added.length == 1 && removed.length == 0) {
        mark = added[0];
        type = "add";
        update = (node)=>node.mark(mark.addToSet(node.marks));
    } else if (added.length == 0 && removed.length == 1) {
        mark = removed[0];
        type = "remove";
        update = (node)=>node.mark(mark.removeFromSet(node.marks));
    } else return null;
    let updated = [];
    for(let i = 0; i < prev.childCount; i++)updated.push(update(prev.child(i)));
    if ((0, $3xw6l.Fragment).from(updated).eq(cur)) return {
        mark: mark,
        type: type
    };
}
function $81901ae0222f0506$var$looksLikeBackspace(old, start, end, $newStart, $newEnd) {
    if (end - start <= $newEnd.pos - $newStart.pos || // newEnd must point directly at or after the end of the block that newStart points into
    $81901ae0222f0506$var$skipClosingAndOpening($newStart, true, false) < $newEnd.pos) return false;
    let $start = old.resolve(start);
    // Handle the case where, rather than joining blocks, the change just removed an entire block
    if (!$newStart.parent.isTextblock) {
        let after = $start.nodeAfter;
        return after != null && end == start + after.nodeSize;
    }
    // Start must be at the end of a block
    if ($start.parentOffset < $start.parent.content.size || !$start.parent.isTextblock) return false;
    let $next = old.resolve($81901ae0222f0506$var$skipClosingAndOpening($start, true, true));
    // The next textblock must start before end and end near it
    if (!$next.parent.isTextblock || $next.pos > end || $81901ae0222f0506$var$skipClosingAndOpening($next, true, false) < end) return false;
    // The fragments after the join point must match
    return $newStart.parent.content.cut($newStart.parentOffset).eq($next.parent.content);
}
function $81901ae0222f0506$var$skipClosingAndOpening($pos, fromEnd, mayOpen) {
    let depth = $pos.depth, end = fromEnd ? $pos.end() : $pos.pos;
    while(depth > 0 && (fromEnd || $pos.indexAfter(depth) == $pos.node(depth).childCount)){
        depth--;
        end++;
        fromEnd = false;
    }
    if (mayOpen) {
        let next = $pos.node(depth).maybeChild($pos.indexAfter(depth));
        while(next && !next.isLeaf){
            next = next.firstChild;
            end++;
        }
    }
    return end;
}
function $81901ae0222f0506$var$findDiff(a, b, pos, preferredPos, preferredSide) {
    let start = a.findDiffStart(b, pos);
    if (start == null) return null;
    let { a: endA, b: endB } = a.findDiffEnd(b, pos + a.size, pos + b.size);
    if (preferredSide == "end") {
        let adjust = Math.max(0, start - Math.min(endA, endB));
        preferredPos -= endA + adjust - start;
    }
    if (endA < start && a.size < b.size) {
        let move = preferredPos <= start && preferredPos >= endA ? start - preferredPos : 0;
        start -= move;
        if (start && start < b.size && $81901ae0222f0506$var$isSurrogatePair(b.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endB = start + (endB - endA);
        endA = start;
    } else if (endB < start) {
        let move = preferredPos <= start && preferredPos >= endB ? start - preferredPos : 0;
        start -= move;
        if (start && start < a.size && $81901ae0222f0506$var$isSurrogatePair(a.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endA = start + (endA - endB);
        endB = start;
    }
    return {
        start: start,
        endA: endA,
        endB: endB
    };
}
function $81901ae0222f0506$var$isSurrogatePair(str) {
    if (str.length != 2) return false;
    let a = str.charCodeAt(0), b = str.charCodeAt(1);
    return a >= 0xDC00 && a <= 0xDFFF && b >= 0xD800 && b <= 0xDBFF;
}
/**
@internal
*/ const $81901ae0222f0506$export$38b79e3fdcfcfd68 = $81901ae0222f0506$var$serializeForClipboard;
/**
@internal
*/ const $81901ae0222f0506$export$5d42ca91c11c9e4d = $81901ae0222f0506$var$parseFromClipboard;
/**
@internal
*/ const $81901ae0222f0506$export$76b14d3c719c32fc = $81901ae0222f0506$var$endComposition;
/**
An editor view manages the DOM structure that represents an
editable document. Its state and behavior are determined by its
[props](https://prosemirror.net/docs/ref/#view.DirectEditorProps).
*/ class $81901ae0222f0506$export$eece2fccabbb77c5 {
    /**
    Create a view. `place` may be a DOM node that the editor should
    be appended to, a function that will place it into the document,
    or an object whose `mount` property holds the node to use as the
    document container. If it is `null`, the editor will not be
    added to the document.
    */ constructor(place, props){
        this._root = null;
        /**
        @internal
        */ this.focused = false;
        /**
        Kludge used to work around a Chrome bug @internal
        */ this.trackWrites = null;
        this.mounted = false;
        /**
        @internal
        */ this.markCursor = null;
        /**
        @internal
        */ this.cursorWrapper = null;
        /**
        @internal
        */ this.lastSelectedViewDesc = undefined;
        /**
        @internal
        */ this.input = new $81901ae0222f0506$var$InputState;
        this.prevDirectPlugins = [];
        this.pluginViews = [];
        /**
        Holds `true` when a hack node is needed in Firefox to prevent the
        [space is eaten issue](https://github.com/ProseMirror/prosemirror/issues/651)
        @internal
        */ this.requiresGeckoHackNode = false;
        /**
        When editor content is being dragged, this object contains
        information about the dragged slice and whether it is being
        copied or moved. At any other time, it is null.
        */ this.dragging = null;
        this._props = props;
        this.state = props.state;
        this.directPlugins = props.plugins || [];
        this.directPlugins.forEach($81901ae0222f0506$var$checkStateComponent);
        this.dispatch = this.dispatch.bind(this);
        this.dom = place && place.mount || document.createElement("div");
        if (place) {
            if (place.appendChild) place.appendChild(this.dom);
            else if (typeof place == "function") place(this.dom);
            else if (place.mount) this.mounted = true;
        }
        this.editable = $81901ae0222f0506$var$getEditable(this);
        $81901ae0222f0506$var$updateCursorWrapper(this);
        this.nodeViews = $81901ae0222f0506$var$buildNodeViews(this);
        this.docView = $81901ae0222f0506$var$docViewDesc(this.state.doc, $81901ae0222f0506$var$computeDocDeco(this), $81901ae0222f0506$var$viewDecorations(this), this.dom, this);
        this.domObserver = new $81901ae0222f0506$var$DOMObserver(this, (from, to, typeOver, added)=>$81901ae0222f0506$var$readDOMChange(this, from, to, typeOver, added));
        this.domObserver.start();
        $81901ae0222f0506$var$initInput(this);
        this.updatePluginViews();
    }
    /**
    Holds `true` when a
    [composition](https://w3c.github.io/uievents/#events-compositionevents)
    is active.
    */ get composing() {
        return this.input.composing;
    }
    /**
    The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
    */ get props() {
        if (this._props.state != this.state) {
            let prev = this._props;
            this._props = {};
            for(let name in prev)this._props[name] = prev[name];
            this._props.state = this.state;
        }
        return this._props;
    }
    /**
    Update the view's props. Will immediately cause an update to
    the DOM.
    */ update(props) {
        if (props.handleDOMEvents != this._props.handleDOMEvents) $81901ae0222f0506$var$ensureListeners(this);
        let prevProps = this._props;
        this._props = props;
        if (props.plugins) {
            props.plugins.forEach($81901ae0222f0506$var$checkStateComponent);
            this.directPlugins = props.plugins;
        }
        this.updateStateInner(props.state, prevProps);
    }
    /**
    Update the view by updating existing props object with the object
    given as argument. Equivalent to `view.update(Object.assign({},
    view.props, props))`.
    */ setProps(props) {
        let updated = {};
        for(let name in this._props)updated[name] = this._props[name];
        updated.state = this.state;
        for(let name in props)updated[name] = props[name];
        this.update(updated);
    }
    /**
    Update the editor's `state` prop, without touching any of the
    other props.
    */ updateState(state) {
        this.updateStateInner(state, this._props);
    }
    updateStateInner(state, prevProps) {
        var _a;
        let prev = this.state, redraw = false, updateSel = false;
        // When stored marks are added, stop composition, so that they can
        // be displayed.
        if (state.storedMarks && this.composing) {
            $81901ae0222f0506$var$clearComposition(this);
            updateSel = true;
        }
        this.state = state;
        let pluginsChanged = prev.plugins != state.plugins || this._props.plugins != prevProps.plugins;
        if (pluginsChanged || this._props.plugins != prevProps.plugins || this._props.nodeViews != prevProps.nodeViews) {
            let nodeViews = $81901ae0222f0506$var$buildNodeViews(this);
            if ($81901ae0222f0506$var$changedNodeViews(nodeViews, this.nodeViews)) {
                this.nodeViews = nodeViews;
                redraw = true;
            }
        }
        if (pluginsChanged || prevProps.handleDOMEvents != this._props.handleDOMEvents) $81901ae0222f0506$var$ensureListeners(this);
        this.editable = $81901ae0222f0506$var$getEditable(this);
        $81901ae0222f0506$var$updateCursorWrapper(this);
        let innerDeco = $81901ae0222f0506$var$viewDecorations(this), outerDeco = $81901ae0222f0506$var$computeDocDeco(this);
        let scroll = prev.plugins != state.plugins && !prev.doc.eq(state.doc) ? "reset" : state.scrollToSelection > prev.scrollToSelection ? "to selection" : "preserve";
        let updateDoc = redraw || !this.docView.matchesNode(state.doc, outerDeco, innerDeco);
        if (updateDoc || !state.selection.eq(prev.selection)) updateSel = true;
        let oldScrollPos = scroll == "preserve" && updateSel && this.dom.style.overflowAnchor == null && $81901ae0222f0506$var$storeScrollPos(this);
        if (updateSel) {
            this.domObserver.stop();
            // Work around an issue in Chrome, IE, and Edge where changing
            // the DOM around an active selection puts it into a broken
            // state where the thing the user sees differs from the
            // selection reported by the Selection object (#710, #973,
            // #1011, #1013, #1035).
            let forceSelUpdate = updateDoc && ($81901ae0222f0506$var$ie || $81901ae0222f0506$var$chrome) && !this.composing && !prev.selection.empty && !state.selection.empty && $81901ae0222f0506$var$selectionContextChanged(prev.selection, state.selection);
            if (updateDoc) {
                // If the node that the selection points into is written to,
                // Chrome sometimes starts misreporting the selection, so this
                // tracks that and forces a selection reset when our update
                // did write to the node.
                let chromeKludge = $81901ae0222f0506$var$chrome ? this.trackWrites = this.domSelectionRange().focusNode : null;
                if (this.composing) this.input.compositionNode = $81901ae0222f0506$var$findCompositionNode(this);
                if (redraw || !this.docView.update(state.doc, outerDeco, innerDeco, this)) {
                    this.docView.updateOuterDeco(outerDeco);
                    this.docView.destroy();
                    this.docView = $81901ae0222f0506$var$docViewDesc(state.doc, outerDeco, innerDeco, this.dom, this);
                }
                if (chromeKludge && !this.trackWrites) forceSelUpdate = true;
            }
            // Work around for an issue where an update arriving right between
            // a DOM selection change and the "selectionchange" event for it
            // can cause a spurious DOM selection update, disrupting mouse
            // drag selection.
            if (forceSelUpdate || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && $81901ae0222f0506$var$anchorInRightPlace(this))) $81901ae0222f0506$var$selectionToDOM(this, forceSelUpdate);
            else {
                $81901ae0222f0506$var$syncNodeSelection(this, state.selection);
                this.domObserver.setCurSelection();
            }
            this.domObserver.start();
        }
        this.updatePluginViews(prev);
        if (((_a = this.dragging) === null || _a === void 0 ? void 0 : _a.node) && !prev.doc.eq(state.doc)) this.updateDraggedNode(this.dragging, prev);
        if (scroll == "reset") this.dom.scrollTop = 0;
        else if (scroll == "to selection") this.scrollToSelection();
        else if (oldScrollPos) $81901ae0222f0506$var$resetScrollPos(oldScrollPos);
    }
    /**
    @internal
    */ scrollToSelection() {
        let startDOM = this.domSelectionRange().focusNode;
        if (this.someProp("handleScrollToSelection", (f)=>f(this))) ;
        else if (this.state.selection instanceof (0, $3lIcL.NodeSelection)) {
            let target = this.docView.domAfterPos(this.state.selection.from);
            if (target.nodeType == 1) $81901ae0222f0506$var$scrollRectIntoView(this, target.getBoundingClientRect(), startDOM);
        } else $81901ae0222f0506$var$scrollRectIntoView(this, this.coordsAtPos(this.state.selection.head, 1), startDOM);
    }
    destroyPluginViews() {
        let view;
        while(view = this.pluginViews.pop())if (view.destroy) view.destroy();
    }
    updatePluginViews(prevState) {
        if (!prevState || prevState.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
            this.prevDirectPlugins = this.directPlugins;
            this.destroyPluginViews();
            for(let i = 0; i < this.directPlugins.length; i++){
                let plugin = this.directPlugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
            for(let i = 0; i < this.state.plugins.length; i++){
                let plugin = this.state.plugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
        } else for(let i = 0; i < this.pluginViews.length; i++){
            let pluginView = this.pluginViews[i];
            if (pluginView.update) pluginView.update(this, prevState);
        }
    }
    updateDraggedNode(dragging, prev) {
        let sel = dragging.node, found = -1;
        if (this.state.doc.nodeAt(sel.from) == sel.node) found = sel.from;
        else {
            let movedPos = sel.from + (this.state.doc.content.size - prev.doc.content.size);
            let moved = movedPos > 0 && this.state.doc.nodeAt(movedPos);
            if (moved == sel.node) found = movedPos;
        }
        this.dragging = new $81901ae0222f0506$var$Dragging(dragging.slice, dragging.move, found < 0 ? undefined : (0, $3lIcL.NodeSelection).create(this.state.doc, found));
    }
    someProp(propName, f) {
        let prop = this._props && this._props[propName], value;
        if (prop != null && (value = f ? f(prop) : prop)) return value;
        for(let i = 0; i < this.directPlugins.length; i++){
            let prop = this.directPlugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
        let plugins = this.state.plugins;
        if (plugins) for(let i = 0; i < plugins.length; i++){
            let prop = plugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
    }
    /**
    Query whether the view has focus.
    */ hasFocus() {
        // Work around IE not handling focus correctly if resize handles are shown.
        // If the cursor is inside an element with resize handles, activeElement
        // will be that element instead of this.dom.
        if ($81901ae0222f0506$var$ie) {
            // If activeElement is within this.dom, and there are no other elements
            // setting `contenteditable` to false in between, treat it as focused.
            let node = this.root.activeElement;
            if (node == this.dom) return true;
            if (!node || !this.dom.contains(node)) return false;
            while(node && this.dom != node && this.dom.contains(node)){
                if (node.contentEditable == 'false') return false;
                node = node.parentElement;
            }
            return true;
        }
        return this.root.activeElement == this.dom;
    }
    /**
    Focus the editor.
    */ focus() {
        this.domObserver.stop();
        if (this.editable) $81901ae0222f0506$var$focusPreventScroll(this.dom);
        $81901ae0222f0506$var$selectionToDOM(this);
        this.domObserver.start();
    }
    /**
    Get the document root in which the editor exists. This will
    usually be the top-level `document`, but might be a [shadow
    DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
    root if the editor is inside one.
    */ get root() {
        let cached = this._root;
        if (cached == null) {
            for(let search = this.dom.parentNode; search; search = search.parentNode)if (search.nodeType == 9 || search.nodeType == 11 && search.host) {
                if (!search.getSelection) Object.getPrototypeOf(search).getSelection = ()=>search.ownerDocument.getSelection();
                return this._root = search;
            }
        }
        return cached || document;
    }
    /**
    When an existing editor view is moved to a new document or
    shadow tree, call this to make it recompute its root.
    */ updateRoot() {
        this._root = null;
    }
    /**
    Given a pair of viewport coordinates, return the document
    position that corresponds to them. May return null if the given
    coordinates aren't inside of the editor. When an object is
    returned, its `pos` property is the position nearest to the
    coordinates, and its `inside` property holds the position of the
    inner node that the position falls inside of, or -1 if it is at
    the top level, not in any node.
    */ posAtCoords(coords) {
        return $81901ae0222f0506$var$posAtCoords(this, coords);
    }
    /**
    Returns the viewport rectangle at a given document position.
    `left` and `right` will be the same number, as this returns a
    flat cursor-ish rectangle. If the position is between two things
    that aren't directly adjacent, `side` determines which element
    is used. When < 0, the element before the position is used,
    otherwise the element after.
    */ coordsAtPos(pos, side = 1) {
        return $81901ae0222f0506$var$coordsAtPos(this, pos, side);
    }
    /**
    Find the DOM position that corresponds to the given document
    position. When `side` is negative, find the position as close as
    possible to the content before the position. When positive,
    prefer positions close to the content after the position. When
    zero, prefer as shallow a position as possible.
    
    Note that you should **not** mutate the editor's internal DOM,
    only inspect it (and even that is usually not necessary).
    */ domAtPos(pos, side = 0) {
        return this.docView.domFromPos(pos, side);
    }
    /**
    Find the DOM node that represents the document node after the
    given position. May return `null` when the position doesn't point
    in front of a node or if the node is inside an opaque node view.
    
    This is intended to be able to call things like
    `getBoundingClientRect` on that DOM node. Do **not** mutate the
    editor DOM directly, or add styling this way, since that will be
    immediately overriden by the editor as it redraws the node.
    */ nodeDOM(pos) {
        let desc = this.docView.descAt(pos);
        return desc ? desc.nodeDOM : null;
    }
    /**
    Find the document position that corresponds to a given DOM
    position. (Whenever possible, it is preferable to inspect the
    document structure directly, rather than poking around in the
    DOM, but sometimes—for example when interpreting an event
    target—you don't have a choice.)
    
    The `bias` parameter can be used to influence which side of a DOM
    node to use when the position is inside a leaf node.
    */ posAtDOM(node, offset, bias = -1) {
        let pos = this.docView.posFromDOM(node, offset, bias);
        if (pos == null) throw new RangeError("DOM position not inside the editor");
        return pos;
    }
    /**
    Find out whether the selection is at the end of a textblock when
    moving in a given direction. When, for example, given `"left"`,
    it will return true if moving left from the current cursor
    position would leave that position's parent textblock. Will apply
    to the view's current state by default, but it is possible to
    pass a different state.
    */ endOfTextblock(dir, state) {
        return $81901ae0222f0506$var$endOfTextblock(this, state || this.state, dir);
    }
    /**
    Run the editor's paste logic with the given HTML string. The
    `event`, if given, will be passed to the
    [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
    */ pasteHTML(html, event) {
        return $81901ae0222f0506$var$doPaste(this, "", html, false, event || new ClipboardEvent("paste"));
    }
    /**
    Run the editor's paste logic with the given plain-text input.
    */ pasteText(text, event) {
        return $81901ae0222f0506$var$doPaste(this, text, null, true, event || new ClipboardEvent("paste"));
    }
    /**
    Removes the editor from the DOM and destroys all [node
    views](https://prosemirror.net/docs/ref/#view.NodeView).
    */ destroy() {
        if (!this.docView) return;
        $81901ae0222f0506$var$destroyInput(this);
        this.destroyPluginViews();
        if (this.mounted) {
            this.docView.update(this.state.doc, [], $81901ae0222f0506$var$viewDecorations(this), this);
            this.dom.textContent = "";
        } else if (this.dom.parentNode) this.dom.parentNode.removeChild(this.dom);
        this.docView.destroy();
        this.docView = null;
        $81901ae0222f0506$var$clearReusedRange();
    }
    /**
    This is true when the view has been
    [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
    used anymore).
    */ get isDestroyed() {
        return this.docView == null;
    }
    /**
    Used for testing.
    */ dispatchEvent(event) {
        return $81901ae0222f0506$var$dispatchEvent(this, event);
    }
    /**
    Dispatch a transaction. Will call
    [`dispatchTransaction`](https://prosemirror.net/docs/ref/#view.DirectEditorProps.dispatchTransaction)
    when given, and otherwise defaults to applying the transaction to
    the current state and calling
    [`updateState`](https://prosemirror.net/docs/ref/#view.EditorView.updateState) with the result.
    This method is bound to the view instance, so that it can be
    easily passed around.
    */ dispatch(tr) {
        let dispatchTransaction = this._props.dispatchTransaction;
        if (dispatchTransaction) dispatchTransaction.call(this, tr);
        else this.updateState(this.state.apply(tr));
    }
    /**
    @internal
    */ domSelectionRange() {
        let sel = this.domSelection();
        if (!sel) return {
            focusNode: null,
            focusOffset: 0,
            anchorNode: null,
            anchorOffset: 0
        };
        return $81901ae0222f0506$var$safari && this.root.nodeType === 11 && $81901ae0222f0506$var$deepActiveElement(this.dom.ownerDocument) == this.dom && $81901ae0222f0506$var$safariShadowSelectionRange(this, sel) || sel;
    }
    /**
    @internal
    */ domSelection() {
        return this.root.getSelection();
    }
}
function $81901ae0222f0506$var$computeDocDeco(view) {
    let attrs = Object.create(null);
    attrs.class = "ProseMirror";
    attrs.contenteditable = String(view.editable);
    view.someProp("attributes", (value)=>{
        if (typeof value == "function") value = value(view.state);
        if (value) for(let attr in value){
            if (attr == "class") attrs.class += " " + value[attr];
            else if (attr == "style") attrs.style = (attrs.style ? attrs.style + ";" : "") + value[attr];
            else if (!attrs[attr] && attr != "contenteditable" && attr != "nodeName") attrs[attr] = String(value[attr]);
        }
    });
    if (!attrs.translate) attrs.translate = "no";
    return [
        $81901ae0222f0506$export$10e30b733df217ea.node(0, view.state.doc.content.size, attrs)
    ];
}
function $81901ae0222f0506$var$updateCursorWrapper(view) {
    if (view.markCursor) {
        let dom = document.createElement("img");
        dom.className = "ProseMirror-separator";
        dom.setAttribute("mark-placeholder", "true");
        dom.setAttribute("alt", "");
        view.cursorWrapper = {
            dom: dom,
            deco: $81901ae0222f0506$export$10e30b733df217ea.widget(view.state.selection.from, dom, {
                raw: true,
                marks: view.markCursor
            })
        };
    } else view.cursorWrapper = null;
}
function $81901ae0222f0506$var$getEditable(view) {
    return !view.someProp("editable", (value)=>value(view.state) === false);
}
function $81901ae0222f0506$var$selectionContextChanged(sel1, sel2) {
    let depth = Math.min(sel1.$anchor.sharedDepth(sel1.head), sel2.$anchor.sharedDepth(sel2.head));
    return sel1.$anchor.start(depth) != sel2.$anchor.start(depth);
}
function $81901ae0222f0506$var$buildNodeViews(view) {
    let result = Object.create(null);
    function add(obj) {
        for(let prop in obj)if (!Object.prototype.hasOwnProperty.call(result, prop)) result[prop] = obj[prop];
    }
    view.someProp("nodeViews", add);
    view.someProp("markViews", add);
    return result;
}
function $81901ae0222f0506$var$changedNodeViews(a, b) {
    let nA = 0, nB = 0;
    for(let prop in a){
        if (a[prop] != b[prop]) return true;
        nA++;
    }
    for(let _ in b)nB++;
    return nA != nB;
}
function $81901ae0222f0506$var$checkStateComponent(plugin) {
    if (plugin.spec.state || plugin.spec.filterTransaction || plugin.spec.appendTransaction) throw new RangeError("Plugins passed directly to the view must not have a state component");
}

});

parcelRegister("jy3uD", function(module, exports) {
$parcel$export(module.exports, "useProviders", () => $28460a4a7ff5961c$export$e4c19534640d7866);

var $eJOHy = parcelRequire("eJOHy");
const $28460a4a7ff5961c$export$e4c19534640d7866 = ({ editorApi: editorApi, contextIdentifierProvider: contextIdentifierProvider, mediaProvider: mediaProvider, mentionProvider: mentionProvider, cardProvider: cardProvider, emojiProvider: emojiProvider, autoformattingProvider: autoformattingProvider, taskDecisionProvider: taskDecisionProvider })=>{
    (0, $eJOHy.useEffect)(()=>{
        async function setProvider() {
            if (!contextIdentifierProvider) return;
            const provider = await contextIdentifierProvider;
            editorApi?.core?.actions.execute(editorApi?.contextIdentifier?.commands.setProvider({
                contextIdentifierProvider: provider
            }));
        }
        setProvider();
    }, [
        contextIdentifierProvider,
        editorApi
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (mediaProvider) editorApi?.media?.actions.setProvider(mediaProvider);
    }, [
        mediaProvider,
        editorApi
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (mentionProvider) editorApi?.mention?.actions.setProvider(mentionProvider);
    }, [
        mentionProvider,
        editorApi
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (cardProvider) editorApi?.card?.actions.setProvider(cardProvider);
    }, [
        cardProvider,
        editorApi
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (emojiProvider) editorApi?.emoji?.actions.setProvider(emojiProvider);
    }, [
        emojiProvider,
        editorApi
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (autoformattingProvider) editorApi?.customAutoformat?.actions.setProvider(autoformattingProvider);
    }, [
        autoformattingProvider,
        editorApi
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (taskDecisionProvider) editorApi?.taskDecision?.actions.setProvider(taskDecisionProvider);
    }, [
        taskDecisionProvider,
        editorApi
    ]);
};

});

parcelRegister("4wM3w", function(module, exports) {
$parcel$export(module.exports, "getNodesCount", () => $471f23ad30427f69$export$3674f49b2d541ad);
function $471f23ad30427f69$export$3674f49b2d541ad(node) {
    const count = {};
    node.nodesBetween(0, node.nodeSize - 2, (node)=>{
        count[node.type.name] = (count[node.type.name] || 0) + 1;
    });
    return count;
}

});

parcelRegister("9SjCv", function(module, exports) {
$parcel$export(module.exports, "getNodesVisibleInViewport", () => $2b1fb9826893fbc8$export$f20e3cf045904cb);
/**
 * Check if a DOM element is visible within the viewport. We deem a node visible if the top left corner coordinate is within the viewport.
 * This may not look visible, and may include a node that looks below the fold – but it's more than 0 pixels within the viewport.
 */ const $2b1fb9826893fbc8$export$9c8a351faafa8fbb = (node)=>{
    const rect = node.getBoundingClientRect();
    const isVisible = rect.x >= 0 && rect.x < window.innerWidth && rect.y >= 0 && rect.y < window.innerHeight;
    return isVisible;
};
const $2b1fb9826893fbc8$export$f20e3cf045904cb = (editorDom)=>{
    const MAX_NODES_TO_COUNT = 200;
    const pmNodesList = editorDom.querySelectorAll('[data-prosemirror-node-name]');
    const nodesTypeCounter = {};
    for(let i = 0; i < Math.min(MAX_NODES_TO_COUNT, pmNodesList.length); i++){
        const node = pmNodesList[i];
        const type = node.getAttribute('data-prosemirror-node-name');
        // No valid prosemirrornode type, skip.
        if (!type) continue;
        const isVisible = $2b1fb9826893fbc8$export$9c8a351faafa8fbb(node);
        // Not a visible node, end counting.
        if (!isVisible) break;
        nodesTypeCounter[type] = (nodesTypeCounter[type] || 0) + 1;
    }
    return nodesTypeCounter;
};

});

parcelRegister("7uu4v", function(module, exports) {
$parcel$export(module.exports, "isFullPage", () => $95a6cae108f6bd6d$export$2800a15841f40ad7);
function $95a6cae108f6bd6d$export$2800a15841f40ad7(appearance) {
    return appearance === 'full-page' || appearance === 'full-width';
}

});

parcelRegister("i5btK", function(module, exports) {
$parcel$export(module.exports, "RenderTracking", () => $d2210bfe5222be2d$export$fe16de086fea1f5f);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $bMFKb = parcelRequire("bMFKb");

var $4I56P = parcelRequire("4I56P");
function $d2210bfe5222be2d$export$fe16de086fea1f5f(props) {
    const debouncedHandleAnalyticsEvent = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(props.handleAnalyticsEvent, 500), [
        props.handleAnalyticsEvent
    ]);
    (0, $4I56P.useComponentRenderTracking)({
        onRender: ({ renderCount: renderCount, propsDifference: propsDifference })=>{
            if (!renderCount) return;
            debouncedHandleAnalyticsEvent({
                payload: {
                    action: props.action,
                    actionSubject: props.actionSubject,
                    attributes: {
                        count: renderCount,
                        propsDifference: propsDifference
                    },
                    eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
                }
            });
        },
        propsDiffingOptions: {
            enabled: true,
            props: props.componentProps,
            propsToIgnore: props.propsToIgnore,
            useShallow: props.useShallow
        },
        zeroBasedCount: true
    });
    return null;
}

});
parcelRegister("4I56P", function(module, exports) {
$parcel$export(module.exports, "useComponentRenderTracking", () => $f04fad825597ef75$export$ebce6d7d8ca67353);

var $eJOHy = parcelRequire("eJOHy");

var $8KLBw = parcelRequire("8KLBw");

var $kBfYv = parcelRequire("kBfYv");
function $f04fad825597ef75$export$ebce6d7d8ca67353({ onRender: onRender, propsDiffingOptions: propsDiffingOptions, zeroBasedCount: zeroBasedCount = true }) {
    const propsRef = (0, $eJOHy.useRef)();
    const renderCountRef = (0, $eJOHy.useRef)(zeroBasedCount ? 0 : 1);
    const { current: componentId } = (0, $eJOHy.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))());
    (0, $eJOHy.useEffect)(()=>{
        const lastProps = propsRef.current;
        const renderCount = renderCountRef.current;
        let propsDifference;
        if (propsDiffingOptions?.enabled && lastProps) propsDifference = propsDiffingOptions?.useShallow ? (0, $kBfYv.getShallowPropsDifference)(lastProps, propsDiffingOptions.props) : (0, $kBfYv.getPropsDifference)(lastProps, propsDiffingOptions.props, 0, 2, propsDiffingOptions?.propsToIgnore);
        const result = {
            renderCount: renderCount,
            propsDifference: propsDifference,
            componentId: componentId
        };
        onRender(result);
        if (propsDiffingOptions?.enabled) propsRef.current = propsDiffingOptions.props;
        renderCountRef.current = renderCountRef.current + 1;
    }); // No dependencies run on each render
}

});
parcelRegister("kBfYv", function(module, exports) {
$parcel$export(module.exports, "getPropsDifference", () => $fe2c7fa63ac56f38$export$d438af18e3a25d10);
$parcel$export(module.exports, "getShallowPropsDifference", () => $fe2c7fa63ac56f38$export$418b0a935c0a0030);

var $eJOHy = parcelRequire("eJOHy");
const $fe2c7fa63ac56f38$export$74743eda5dda3ccf = Object.keys;
const $fe2c7fa63ac56f38$export$aedd1a2d18cbf42b = (object1, object2)=>{
    const oldKeys = object1 !== null ? $fe2c7fa63ac56f38$export$74743eda5dda3ccf(object1) : [];
    const newKeys = object2 !== null ? $fe2c7fa63ac56f38$export$74743eda5dda3ccf(object2) : [];
    const removed = oldKeys.filter((key)=>!newKeys.includes(key));
    const added = newKeys.filter((key)=>!oldKeys.includes(key));
    const common = oldKeys.filter((key)=>newKeys.includes(key));
    return {
        added: added,
        common: common,
        removed: removed
    };
};
const $fe2c7fa63ac56f38$export$f4c1dafc9df1f03 = (value)=>{
    const valueType = typeof value;
    if (value === null) return 'null';
    else if (value === undefined) return 'undefined';
    else if (valueType === 'string' || valueType === 'number') return value;
    else if (valueType === 'symbol') return value.toString();
    else if (valueType === 'function') return `function:${value.name}`;
    else if (valueType === 'object') return {
        type: 'object',
        keys: Object.keys(value)
    };
};
const $fe2c7fa63ac56f38$export$d438af18e3a25d10 = (object1, object2, curDepth = 0, maxDepth = 2, keysToIgnore = [])=>{
    const { added: added, common: common, removed: removed } = $fe2c7fa63ac56f38$export$aedd1a2d18cbf42b(object1, object2);
    const changed = [];
    common.forEach((key)=>{
        const value1 = object1[key];
        const value2 = object2[key];
        const value1Type = typeof value1;
        const value2Type = typeof value2;
        // Do comparision only if values doesn't match (or reference to same object in memory).
        // Or if key does not exist in keys to ignore.
        if (value1 !== value2 && keysToIgnore.indexOf(key) === -1) {
            // if both key value are objects and not referencing same object in memory.
            //  then get recursive difference.
            if ((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(value1) || (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(value2)) changed.push({
                key: key,
                reactElementChanged: true
            });
            else if (value1Type === 'object' && value2Type === 'object') {
                if (curDepth <= maxDepth) {
                    const difference = $fe2c7fa63ac56f38$export$d438af18e3a25d10(value1, value2, curDepth + 1, maxDepth);
                    changed.push({
                        key: key,
                        difference: difference
                    });
                } else changed.push({
                    key: key,
                    maxDepthReached: true
                });
            } else changed.push({
                key: key,
                oldValue: $fe2c7fa63ac56f38$export$f4c1dafc9df1f03(value1),
                newValue: $fe2c7fa63ac56f38$export$f4c1dafc9df1f03(value2)
            });
        }
    });
    return {
        added: added,
        changed: changed,
        removed: removed
    };
};
const $fe2c7fa63ac56f38$export$418b0a935c0a0030 = (object1, object2)=>{
    const { added: added, common: common, removed: removed } = $fe2c7fa63ac56f38$export$aedd1a2d18cbf42b(object1, object2);
    const changed = common.filter((key)=>object1[key] !== object2[key]);
    return {
        added: added,
        changed: changed,
        removed: removed
    };
};

});



const $96851126f0c152a2$export$646a6982857f2cd5 = 2000;
const $96851126f0c152a2$export$79d7eac6cbb6352d = 3000;
const $96851126f0c152a2$export$7d7bd496a5206996 = 100;

parcelRegister("20Ctl", function(module, exports) {
$parcel$export(module.exports, "fixExcludes", () => $7ef871dfed7bb538$export$ef6c09ff452189fa);
$parcel$export(module.exports, "processPluginsList", () => $7ef871dfed7bb538$export$7265233e78178a4);
$parcel$export(module.exports, "createPMPlugins", () => $7ef871dfed7bb538$export$169329cb2979ef81);
$parcel$export(module.exports, "createErrorReporter", () => $7ef871dfed7bb538$export$e98521bb0cea2db1);

var $hvPOH = parcelRequire("hvPOH");

var $87fb1 = parcelRequire("87fb1");

var $cbSL1 = parcelRequire("cbSL1");

var $iM8mR = parcelRequire("iM8mR");

var $77GEN = parcelRequire("77GEN");
function $7ef871dfed7bb538$export$935d38a2e170d1f3(a, b) {
    return a.rank - b.rank;
}
function $7ef871dfed7bb538$export$ef6c09ff452189fa(marks) {
    const markKeys = Object.keys(marks);
    const markGroups = new Set(markKeys.map((mark)=>marks[mark].group));
    markKeys.forEach((markKey)=>{
        const mark = marks[markKey];
        if (mark.excludes) mark.excludes = mark.excludes.split(' ').filter((group)=>markGroups.has(group)).join(' ');
    });
    return marks;
}
function $7ef871dfed7bb538$export$7265233e78178a4(plugins) {
    /**
	 * First pass to collect pluginsOptions
	 */ const pluginsOptions = plugins.reduce((acc, plugin)=>{
        if (plugin.pluginsOptions) Object.keys(plugin.pluginsOptions).forEach((pluginName)=>{
            if (!acc[pluginName]) acc[pluginName] = [];
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            acc[pluginName].push(plugin.pluginsOptions[pluginName]);
        });
        return acc;
    }, {});
    /**
	 * Process plugins
	 */ return plugins.reduce((acc, plugin)=>{
        if (plugin.pmPlugins) acc.pmPlugins.push(...plugin.pmPlugins(plugin.name ? pluginsOptions[plugin.name] : undefined));
        if (plugin.nodes) acc.nodes.push(...plugin.nodes());
        if (plugin.marks) acc.marks.push(...plugin.marks());
        if (plugin.contentComponent) acc.contentComponents.push(plugin.contentComponent);
        if (plugin.usePluginHook) acc.pluginHooks.push(plugin.usePluginHook);
        if (plugin.primaryToolbarComponent) acc.primaryToolbarComponents.push(plugin.primaryToolbarComponent);
        if (plugin.secondaryToolbarComponent) acc.secondaryToolbarComponents.push(plugin.secondaryToolbarComponent);
        if (plugin.onEditorViewStateUpdated) acc.onEditorViewStateUpdatedCallbacks.push({
            pluginName: plugin.name,
            callback: plugin.onEditorViewStateUpdated
        });
        return acc;
    }, {
        nodes: [],
        marks: [],
        pmPlugins: [],
        contentComponents: [],
        pluginHooks: [],
        primaryToolbarComponents: [],
        secondaryToolbarComponents: [],
        onEditorViewStateUpdatedCallbacks: []
    });
}
function $7ef871dfed7bb538$export$169329cb2979ef81(config) {
    const { editorConfig: editorConfig } = config;
    const pmPlugins = editorConfig.pmPlugins.sort((0, $87fb1.sortByOrder)('plugins')).map(({ plugin: plugin })=>plugin({
            schema: config.schema,
            dispatch: config.dispatch,
            eventDispatcher: config.eventDispatcher,
            providerFactory: config.providerFactory,
            errorReporter: config.errorReporter,
            portalProviderAPI: config.portalProviderAPI,
            nodeViewPortalProviderAPI: config.nodeViewPortalProviderAPI,
            dispatchAnalyticsEvent: config.dispatchAnalyticsEvent,
            featureFlags: config.featureFlags || {},
            getIntl: config.getIntl
        })).filter((plugin)=>typeof plugin !== 'undefined');
    if ((0, $cbSL1.expValEquals)('platform_editor_native_anchor_support', 'isEnabled', true)) pmPlugins.push((0, $iM8mR.createEditorNativeAnchorSupportPlugin)(config.schema));
    if (config.onEditorStateUpdated !== undefined) return [
        (0, $77GEN.createEditorStateNotificationPlugin)(config.onEditorStateUpdated, config.editorConfig.onEditorViewStateUpdatedCallbacks),
        ...pmPlugins
    ];
    return pmPlugins;
}
function $7ef871dfed7bb538$export$e98521bb0cea2db1(errorReporterHandler) {
    const errorReporter = new (0, $hvPOH.ErrorReporter)();
    if (errorReporterHandler) errorReporter.handler = errorReporterHandler;
    return errorReporter;
}

});
parcelRegister("hvPOH", function(module, exports) {
$parcel$export(module.exports, "ErrorReporter", () => $faec646cd0648651$export$88da0ac32d9c271e);
class $faec646cd0648651$export$88da0ac32d9c271e {
    captureMessage(msg, tags) {
        if (this.handlerStorage) this.handlerStorage.captureMessage(msg, tags);
    }
    captureException(err, tags) {
        if (this.handlerStorage) this.handlerStorage.captureException(err, tags);
    }
    set handler(handler) {
        this.handlerStorage = handler;
    }
    constructor(){
        this.handlerStorage = null;
    }
}

});

parcelRegister("87fb1", function(module, exports) {
$parcel$export(module.exports, "sortByOrder", () => $e9789850f723efcf$export$49afdc3354d5c84e);
$parcel$export(module.exports, "sortByOrderWithTypeName", () => $e9789850f723efcf$export$b4ae7ad1c009d0a1);
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
// @deprecated
// @private This rank is not stable and should not be trusted. If you need to change this file, please let the Editor lego team know about it
const $e9789850f723efcf$export$d4a08ec0aa6e0cef = {
    plugins: [
        'featureFlagsContextPlugin',
        'compositionPlugin',
        'inlineCursorTargetPlugin',
        'typeAhead',
        'typeAheadInsertItem',
        'focusHandlerPlugin',
        'frozenEditor',
        'submitEditor',
        'saveOnEnter',
        'customAutoformatting',
        'newlinePreserveMarksPlugin',
        'imageUpload',
        'imageUploadInputRule',
        'clipboard',
        'paste',
        'pasteKeymap',
        'mention',
        'mentionInputRule',
        'mentionKeymap',
        'emoji',
        'placeholderText',
        'emojiInputRule',
        'emojiKeymap',
        'emojiAsciiInputRule',
        'blockType',
        'quickInsert',
        'tasksAndDecisions',
        'blockTypeInputRule',
        'tasksAndDecisionsInputRule',
        'list',
        'typeAheadKeymap',
        'typeAheadInputRule',
        'date',
        'dateKeymap',
        // This should be always after `typeAheadKeymap` & `emojiKeymap`
        'indentationKeymap',
        'textColor',
        'highlight',
        'highlightKeymap',
        'alignmentPlugin',
        'listInputRule',
        'listKeymap',
        'codeBlock',
        'codeBlockIDEKeyBindings',
        'codeBlockKeyMap',
        'textFormatting',
        'textFormattingCursor',
        'textFormattingInputRule',
        'textFormattingSmartRule',
        'textFormattingClear',
        'textFormattingKeymap',
        // task/decisions keymap needs to be above table keymap so can indent actions in a table
        'tasksAndDecisionsKeyMap',
        // expand and table keymaps need to be above selection keymap to add their custom selection behaviour:
        // https://product-fabric.atlassian.net/wiki/spaces/E/pages/1113098008/Selection+Guide#Special-Cases
        'expandKeymap',
        'tableSelectionKeymap',
        'tableKeymap',
        'captionKeymap',
        // media keymap above selection keymap to allow navigating past the mediaSingle node
        'mediaKeymap',
        // selection keymap needs to be above gap cursor keymap so it can set node selections from
        // left/right arrows
        'selectionKeymap',
        'gapCursorKeymap',
        'gapCursor',
        'syncUrlText',
        'fakeCursorToolbarPlugin',
        'hyperLink',
        'table',
        'tableDecorations',
        'hyperlinkInputRule',
        'tablePMColResizing',
        'hyperlinkKeymap',
        'tableColResizing',
        'undoRedoKeyMap',
        'blockTypeKeyMap',
        'tableEditing',
        'filterStepsPlugin',
        'pmCollab',
        'collab',
        'ruleInputRule',
        'ruleKeymap',
        'panel',
        'media',
        'mediaSingleKeymap',
        'mediaEditor',
        'unsupportedContent',
        'jiraIssue',
        'helpDialog',
        'helpDialogKeymap',
        'macro',
        'expand',
        'extension',
        'layout',
        'contextPanel',
        'selectionToolbar',
        'floatingToolbar',
        'clearMarksOnChange',
        'reactNodeView',
        'history',
        'undoRedoPlugin',
        'codeBlockIndent',
        'placeholder',
        'width',
        'maxContentSize',
        'multilineContent',
        'grid',
        'mobileDimensions',
        'scrollGutterPlugin',
        'analytics',
        'findReplace',
        'selection',
        'avatarGroup',
        'viewUpdateSubscription',
        'beforePrimaryToolbar',
        'inlineCode'
    ],
    nodes: [
        'doc',
        'paragraph',
        'text',
        'bulletList',
        'orderedList',
        'listItem',
        'heading',
        'blockquote',
        'codeBlock',
        'rule',
        'panel',
        'mention',
        'confluenceUnsupportedBlock',
        'confluenceUnsupportedInline',
        'unsupportedBlock',
        'unsupportedInline',
        'confluenceJiraIssue',
        'hardBreak',
        'emoji',
        'placeholder',
        'mediaSingle',
        'mediaGroup',
        'table',
        'expand',
        'nestedExpand',
        'media',
        'tableHeader',
        'decisionList',
        'tableRow',
        'decisionItem',
        'tableCell',
        'taskList',
        'taskItem',
        'extension',
        'bodiedExtension',
        'multiBodiedExtension',
        'inlineExtension',
        'layoutSection',
        'layoutColumn',
        'inlineCard',
        'blockCard',
        'embedCard'
    ],
    marks: [
        // Fragment mark is both for inline and block elements
        'fragment',
        // Inline marks
        'link',
        'em',
        'strong',
        'textColor',
        'backgroundColor',
        'strike',
        'subsup',
        'underline',
        'code',
        'typeAheadQuery',
        // Block marks
        'alignment',
        'breakout',
        'indentation',
        'annotation',
        'dataConsumer',
        'border',
        // Unsupported mark
        'unsupportedMark',
        'unsupportedNodeAttribute'
    ]
};
function $e9789850f723efcf$export$49afdc3354d5c84e(item) {
    return function(a, b) {
        return $e9789850f723efcf$export$d4a08ec0aa6e0cef[item].indexOf(a.name) - $e9789850f723efcf$export$d4a08ec0aa6e0cef[item].indexOf(b.name);
    };
}
function $e9789850f723efcf$export$b4ae7ad1c009d0a1(item) {
    return function(a, b) {
        return $e9789850f723efcf$export$d4a08ec0aa6e0cef[item].indexOf(a.type.name) - $e9789850f723efcf$export$d4a08ec0aa6e0cef[item].indexOf(b.type.name);
    };
}

});

parcelRegister("iM8mR", function(module, exports) {
$parcel$export(module.exports, "createEditorNativeAnchorSupportPlugin", () => $9b87e25dcfccdc32$export$dc8df63091e87b7a);

var $i8KtF = parcelRequire("i8KtF");

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $cbSL1 = parcelRequire("cbSL1");
const $9b87e25dcfccdc32$var$injectNodeViewNodeTypeList = [
    'paragraph',
    'heading',
    'bulletList',
    'orderedList',
    'blockquote',
    'rule',
    'decisionList',
    'taskList',
    'layoutColumn',
    'hardBreak'
];
const $9b87e25dcfccdc32$var$injectNodeViewNodeTypeConditionalList = [
    ...$9b87e25dcfccdc32$var$injectNodeViewNodeTypeList,
    // nodes that have custom nodeView behind experiment/FG
    'layoutSection'
];
const $9b87e25dcfccdc32$var$key = new (0, $3lIcL.PluginKey)('editorNativeAnchorSupportPlugin');
const $9b87e25dcfccdc32$export$dc8df63091e87b7a = (schema)=>{
    const nodeViewEntries = [];
    const injectList = (0, $cbSL1.expValEquals)('advanced_layouts', 'isEnabled', true) && !(0, $cbSL1.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true) ? $9b87e25dcfccdc32$var$injectNodeViewNodeTypeList : $9b87e25dcfccdc32$var$injectNodeViewNodeTypeConditionalList;
    schema.spec.nodes.forEach((nodeName, nodeSpec)=>{
        if (injectList.includes(nodeName)) {
            if (nodeSpec.toDOM && typeof nodeSpec.toDOM === 'function') {
                const toDOM = nodeSpec.toDOM.bind(nodeSpec);
                nodeViewEntries.push([
                    nodeName,
                    (node)=>(0, $3xw6l.DOMSerializer).renderSpec(document, toDOM(node))
                ]);
            }
        }
    });
    return new (0, $i8KtF.SafePlugin)({
        key: $9b87e25dcfccdc32$var$key,
        props: {
            nodeViews: Object.fromEntries(nodeViewEntries)
        }
    });
};

});
parcelRegister("i8KtF", function(module, exports) {
$parcel$export(module.exports, "SafePlugin", () => $a4dc9f7f39fa0cc1$export$1d44e2741b8f180d);

var $3lIcL = parcelRequire("3lIcL");

var $cbSL1 = parcelRequire("cbSL1");

var $7wniU = parcelRequire("7wniU");

var $dcW7A = parcelRequire("dcW7A");
const $a4dc9f7f39fa0cc1$export$286bb6e3f51916b5 = ({ nodeOrMark: nodeOrMark, dom: dom, options: options })=>{
    const metadata = (0, $dcW7A.createProseMirrorMetadata)(nodeOrMark, options);
    Object.entries(metadata).forEach(([name, value])=>{
        dom.setAttribute(name, value);
        if (name === 'data-node-anchor' && (0, $cbSL1.expValEquals)('platform_editor_native_anchor_support', 'isEnabled', true)) dom.style.setProperty('anchor-name', value);
    });
};
// Wraper to avoid any exception during the get pos operation
// See this https://hello.atlassian.net/wiki/spaces/EDITOR/pages/2849713193/ED-19672+Extensions+Regression
// And this https://discuss.prosemirror.net/t/possible-bug-on-viewdesc-posbeforechild/5783
const $a4dc9f7f39fa0cc1$var$wrapGetPosExceptions = (spec)=>{
    if (!spec?.props?.nodeViews) return spec;
    const unsafeNodeViews = spec.props.nodeViews;
    let nodeIdProvider;
    const safeNodeViews = new Proxy(unsafeNodeViews, {
        get (target, prop, receiver) {
            const safeNodeView = new Proxy(Reflect.get(target, prop, receiver), {
                apply (target, thisArg, argumentsList) {
                    const [node, view, unsafeGetPos, ...more] = argumentsList;
                    if (!nodeIdProvider && (0, $cbSL1.expValEquals)('platform_editor_native_anchor_support', 'isEnabled', true)) nodeIdProvider = (0, $7wniU.getNodeIdProvider)(view);
                    const safeGetPos = (()=>{
                        try {
                            return unsafeGetPos();
                        } catch (e) {
                            return;
                        }
                    // eslint-disable-next-line no-extra-bind
                    }).bind(thisArg);
                    const result = Reflect.apply(target, thisArg, [
                        node,
                        view,
                        safeGetPos,
                        ...more
                    ]);
                    if (result?.dom instanceof HTMLElement) {
                        // we only attach metadata to the dom if its position is known
                        const pos = safeGetPos();
                        const options = pos !== undefined && (0, $cbSL1.expValEquals)('platform_editor_native_anchor_support', 'isEnabled', true) ? {
                            anchrorId: nodeIdProvider?.getOrGenerateId(node, pos)
                        } : undefined;
                        $a4dc9f7f39fa0cc1$export$286bb6e3f51916b5({
                            nodeOrMark: node,
                            dom: result.dom,
                            options: options
                        });
                    }
                    return result;
                }
            });
            return safeNodeView;
        }
    });
    spec.props.nodeViews = safeNodeViews;
    return spec;
};
class $a4dc9f7f39fa0cc1$export$1d44e2741b8f180d extends (0, $3lIcL.Plugin) {
    constructor(spec){
        super($a4dc9f7f39fa0cc1$var$wrapGetPosExceptions(spec));
    }
}

});
parcelRegister("dcW7A", function(module, exports) {
$parcel$export(module.exports, "createProseMirrorMetadata", () => $dfff3f43c3f35139$export$3d8be158d19aadd1);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $3xw6l = parcelRequire("3xw6l");

var $cbSL1 = parcelRequire("cbSL1");
const $dfff3f43c3f35139$var$isPMNode = (nodeOrMark)=>{
    return nodeOrMark instanceof (0, $3xw6l.Node) || Array.isArray(nodeOrMark.marks);
};
const $dfff3f43c3f35139$export$3d8be158d19aadd1 = (nodeOrMark, options)=>{
    const name = nodeOrMark.type.name;
    const isNode = $dfff3f43c3f35139$var$isPMNode(nodeOrMark);
    const commonAttributes = {
        'data-prosemirror-content-type': isNode ? 'node' : 'mark'
    };
    if (!isNode) return {
        ...commonAttributes,
        ['data-prosemirror-mark-name']: name
    };
    commonAttributes['data-prosemirror-node-name'] = name;
    if (nodeOrMark.type.isBlock) commonAttributes['data-prosemirror-node-block'] = 'true';
    if (nodeOrMark.type.isInline) commonAttributes['data-prosemirror-node-inline'] = 'true';
    if (options?.anchrorId !== undefined && (0, $cbSL1.expValEquals)('platform_editor_native_anchor_support', 'isEnabled', true)) commonAttributes['data-node-anchor'] = options.anchrorId;
    return commonAttributes;
};

});



parcelRegister("77GEN", function(module, exports) {
$parcel$export(module.exports, "createEditorStateNotificationPlugin", () => $e8e530777077b88e$export$e0355cecc74597d);

var $i8KtF = parcelRequire("i8KtF");

var $3lIcL = parcelRequire("3lIcL");
const $e8e530777077b88e$var$key = new (0, $3lIcL.PluginKey)('editorStateNotificationPlugin');
const $e8e530777077b88e$export$e0355cecc74597d = (onEditorStateUpdated, onEditorViewStateUpdatedCallbacks)=>{
    const transactions = [];
    return new (0, $i8KtF.SafePlugin)({
        key: $e8e530777077b88e$var$key,
        state: {
            init () {
                return {
                    latestTransaction: undefined
                };
            },
            apply (tr) {
                transactions.push(tr);
                return {
                    latestTransaction: tr
                };
            }
        },
        view: ()=>{
            return {
                update: (view, oldEditorState)=>{
                    onEditorStateUpdated({
                        oldEditorState: oldEditorState,
                        newEditorState: view.state
                    });
                }
            };
        }
    });
};

});


parcelRegister("lAhIB", function(module, exports) {
$parcel$export(module.exports, "getDefaultPresetOptionsFromEditorProps", () => $dd4c359a0cdf2540$export$fdea1e40b8747a5b);
$parcel$export(module.exports, "default", () => $dd4c359a0cdf2540$export$2e2bcd8739ae039);

var $hUQD4 = parcelRequire("hUQD4");

var $7uu4v = parcelRequire("7uu4v");
const $dd4c359a0cdf2540$var$isCodeBlockAllowed = (options)=>{
    const exclude = options && options.allowBlockType && options.allowBlockType.exclude ? options.allowBlockType.exclude : [];
    return exclude.indexOf('codeBlock') === -1;
};
function $dd4c359a0cdf2540$export$f94443780f769f8(props) {
    const { appearance: appearance } = props;
    if ((0, $7uu4v.isFullPage)(appearance)) // Full Page appearance uses a scrollable div wrapper.
    return {
        getScrollElement: ()=>document.querySelector('.fabric-editor-popup-scroll-parent')
    };
    return undefined;
}
function $dd4c359a0cdf2540$export$fdea1e40b8747a5b(props, createAnalyticsEvent) {
    const appearance = props.appearance;
    const cardOptions = props.linking?.smartLinks || props.smartLinks || props.UNSAFE_cards;
    return {
        ...props,
        createAnalyticsEvent: createAnalyticsEvent,
        typeAhead: {
            isMobile: false
        },
        featureFlags: (0, $hUQD4.createFeatureFlagsFromProps)(props.featureFlags),
        paste: {
            cardOptions: cardOptions,
            sanitizePrivateContent: props.sanitizePrivateContent
        },
        base: {
            allowInlineCursorTarget: true,
            allowScrollGutter: $dd4c359a0cdf2540$export$f94443780f769f8(props)
        },
        blockType: {
            lastNodeMustBeParagraph: appearance === 'comment' || appearance === 'chromeless',
            allowBlockType: props.allowBlockType,
            isUndoRedoButtonsEnabled: props.allowUndoRedoButtons
        },
        placeholder: {
            placeholder: props.placeholder,
            placeholderBracketHint: props.placeholderBracketHint
        },
        textFormatting: {
            ...props.textFormatting || {},
            responsiveToolbarMenu: props.textFormatting?.responsiveToolbarMenu != null ? props.textFormatting.responsiveToolbarMenu : props.allowUndoRedoButtons
        },
        submitEditor: props.onSave,
        quickInsert: {
            enableElementBrowser: props.elementBrowser && props.elementBrowser.showModal,
            elementBrowserHelpUrl: props.elementBrowser && props.elementBrowser.helpUrl,
            disableDefaultItems: props.quickInsert && typeof props.quickInsert !== 'boolean' && props.quickInsert.disableDefaultItems || false,
            headless: false,
            emptyStateHandler: props.elementBrowser && props.elementBrowser.emptyStateHandler,
            prioritySortingFn: props.quickInsert && typeof props.quickInsert !== 'boolean' && props.quickInsert.prioritySortingFn || undefined,
            onInsert: props.quickInsert && typeof props.quickInsert !== 'boolean' && props.quickInsert.onInsert || undefined
        },
        selection: {
            useLongPressSelection: false
        },
        hyperlinkOptions: {
            editorAppearance: props.appearance,
            linkPicker: props.linking?.linkPicker,
            onClickCallback: cardOptions?.onClickCallback,
            platform: 'web',
            autoLinkOnBlur: props.linking?.autoLinkOnBlur
        },
        codeBlock: {
            ...props.codeBlock,
            useLongPressSelection: false,
            allowCompositionInputOverride: false
        }
    };
}
function $dd4c359a0cdf2540$export$2e2bcd8739ae039(// eslint-disable-next-line @typescript-eslint/no-explicit-any
preset, props, pluginInjectionAPI) {
    const excludes = new Set();
    if (!$dd4c359a0cdf2540$var$isCodeBlockAllowed({
        allowBlockType: props.allowBlockType
    })) excludes.add('codeBlock');
    return preset.build({
        pluginInjectionAPI: pluginInjectionAPI,
        excludePlugins: excludes
    });
}

});

parcelRegister("3bqXX", function(module, exports) {
$parcel$export(module.exports, "createSchema", () => $e8b30a46e98c48b5$export$5f4ce795563f4211);

var $mYA6R = parcelRequire("mYA6R");

var $87fb1 = parcelRequire("87fb1");

var $dcW7A = parcelRequire("dcW7A");

var $3xw6l = parcelRequire("3xw6l");

var $20Ctl = parcelRequire("20Ctl");
const $e8b30a46e98c48b5$export$29c1e593063b23a7 = ({ nodeOrMark: nodeOrMark, domSpec: domSpec })=>{
    if (!Array.isArray(domSpec)) return domSpec;
    const maybeDefinedAttributes = domSpec[1];
    const metadata = (0, $dcW7A.createProseMirrorMetadata)(nodeOrMark);
    const hasDefinedAttributes = typeof maybeDefinedAttributes === 'object' && !Array.isArray(maybeDefinedAttributes);
    if (hasDefinedAttributes) domSpec[1] = Object.assign(maybeDefinedAttributes, metadata);
    else domSpec.splice(1, 0, metadata);
    return domSpec;
};
const $e8b30a46e98c48b5$export$48404bb361c0cbc1 = (toDOM)=>{
    return new Proxy(toDOM, {
        apply (target, thisArg, argumentsList) {
            const domSpec = Reflect.apply(target, thisArg, argumentsList);
            if (!Array.isArray(domSpec)) return domSpec;
            const nodeOrMark = argumentsList[0];
            return $e8b30a46e98c48b5$export$29c1e593063b23a7({
                nodeOrMark: nodeOrMark,
                domSpec: domSpec
            });
        }
    });
};
const $e8b30a46e98c48b5$export$83e999ea28e263f4 = (spec)=>{
    return new Proxy(spec, {
        get (target, prop, receiver) {
            const result = Reflect.get(target, prop, receiver);
            if (prop === 'toDOM' && typeof result === 'function') return $e8b30a46e98c48b5$export$48404bb361c0cbc1(result);
            return result;
        }
    });
};
function $e8b30a46e98c48b5$export$5f4ce795563f4211(editorConfig) {
    const marks = (0, $20Ctl.fixExcludes)(editorConfig.marks.sort((0, $87fb1.sortByOrder)('marks')).reduce((acc, mark)=>{
        acc[mark.name] = $e8b30a46e98c48b5$export$83e999ea28e263f4(mark.mark);
        return acc;
    }, {}));
    const nodes = (0, $mYA6R.sanitizeNodes)(editorConfig.nodes.sort((0, $87fb1.sortByOrder)('nodes')).reduce((acc, node)=>{
        acc[node.name] = $e8b30a46e98c48b5$export$83e999ea28e263f4(node.node);
        return acc;
    }, {}), marks);
    return new (0, $3xw6l.Schema)({
        nodes: nodes,
        marks: marks
    });
}

});

parcelRegister("erdK2", function(module, exports) {
$parcel$export(module.exports, "editorMessages", () => $2286d73db242209a$export$3b488057bfc1868f);

var $7qGN1 = parcelRequire("7qGN1");
const $2286d73db242209a$export$3b488057bfc1868f = (0, $7qGN1.defineMessages)({
    editorAssistiveLabel: {
        id: 'fabric.editor.editorAssistiveLabel',
        defaultMessage: 'Main content area, start typing to enter text.',
        description: 'Text that is read out by screen reader when the main editor is in focus'
    }
});

});

parcelRegister("jGMZf", function(module, exports) {
$parcel$export(module.exports, "focusEditorElement", () => $915a296db7ba8f47$export$32ec9f77297f7957);
function $915a296db7ba8f47$export$32ec9f77297f7957(editorId) {
    const parentElement = document.querySelector(`[data-focus-id="${editorId}"]`);
    if (!(parentElement instanceof HTMLElement)) return;
    parentElement.focus({
        preventScroll: true
    });
}

});

parcelRegister("aHrTy", function(module, exports) {
$parcel$export(module.exports, "getUAPrefix", () => $b5624795138593b4$export$11a24c7b1b4aab81);

var $7EdFW = parcelRequire("7EdFW");

var $cbSL1 = parcelRequire("cbSL1");
function $b5624795138593b4$export$11a24c7b1b4aab81() {
    const browser = (0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $7EdFW.getBrowserInfo)() : (0, $7EdFW.browser);
    if (browser.chrome) return 'ua-chrome';
    else if (browser.ie) return 'ua-ie';
    else if (browser.gecko) return 'ua-firefox';
    else if (browser.safari) return 'ua-safari';
    return '';
}

});

parcelRegister("YsDKQ", function(module, exports) {
$parcel$export(module.exports, "handleEditorFocus", () => $a4100354ae27cad3$export$ebebb7f5b9271fd7);

var $eJOHy = parcelRequire("eJOHy");

var $3lIcL = parcelRequire("3lIcL");

var $eGOwo = parcelRequire("eGOwo");
function $a4100354ae27cad3$export$ebebb7f5b9271fd7(view) {
    if (view?.hasFocus()) return;
    /**
	 * If startTransition is available (in React 18),
	 * don't use setTimeout as startTransition will be used in ReactEditorViewNext.
	 * setTimeout(fn, 0) will not defer the focus reliably in React 18 with
	 * concurrent rendering.
	 */ const react16OnlySetTimeout = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy)))?.startTransition && (0, $eGOwo.fg)('platform_editor_react_18_autofocus_fix') ? (fn)=>fn() : (fn)=>window.setTimeout(fn, 0);
    return react16OnlySetTimeout(()=>{
        // Due to race conditions during editor lifecycle transitions (e.g. SPA route changes during opening or closing)
        // where the view (and its internal docView) may have been destroyed, the timeout callback may fire on a stale view.
        // Bail out in that scenario to prevent operating on an unmounted view.
        if (view?.isDestroyed) return;
        if (view?.hasFocus()) return;
        if (!window.getSelection) {
            view?.focus();
            return;
        }
        const domSelection = window.getSelection();
        if (!domSelection || domSelection.rangeCount === 0) {
            view?.focus();
            return;
        }
        const range = domSelection.getRangeAt(0);
        // if selection is outside editor focus and exit
        if (view && range.startContainer.contains(view.dom)) {
            view.focus();
            return;
        }
        // set cursor/selection and focus
        const anchor = view?.posAtDOM(range.startContainer, range.startOffset);
        const head = view?.posAtDOM(range.endContainer, range.endOffset);
        // if anchor or head < 0 focus and exit
        if (anchor && anchor < 0 || head && head < 0) {
            view?.focus();
            return;
        }
        if (view && anchor) {
            const selection = (0, $3lIcL.TextSelection).create(view.state.doc, anchor, head);
            const tr = view.state.tr.setSelection(selection);
            view.dispatch(tr);
            view.focus();
        }
    });
}

});

parcelRegister("l9xeW", function(module, exports) {
$parcel$export(module.exports, "useDispatchTransaction", () => $f8bca0dfb61d7ce4$export$b582387940572fe7);

var $eJOHy = parcelRequire("eJOHy");

var $bMFKb = parcelRequire("bMFKb");
var $jXreb = parcelRequire("jXreb");

var $eh3wX = parcelRequire("eh3wX");

var $eemFN = parcelRequire("eemFN");

var $hvjqZ = parcelRequire("hvjqZ");

var $7e31w = parcelRequire("7e31w");

var $ep3X6 = parcelRequire("ep3X6");

var $kNGyI = parcelRequire("kNGyI");

var $1Jh1r = parcelRequire("1Jh1r");
const $f8bca0dfb61d7ce4$export$b582387940572fe7 = ({ onChange: onChange, dispatchAnalyticsEvent: dispatchAnalyticsEvent, onEditorViewUpdated: onEditorViewUpdated, isRemoteReplaceDocumentTransaction: isRemoteReplaceDocumentTransaction })=>{
    // We need to have a ref to the latest `onChange` since the `dispatchTransaction` gets captured
    const onChangeRef = (0, $eJOHy.useRef)(onChange);
    (0, $eJOHy.useEffect)(()=>{
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    const dispatchTransaction = (0, $eJOHy.useCallback)((view, unsafeTransaction)=>{
        if (!view) return;
        const nodes = (0, $7e31w.findChangedNodesFromTransaction)(unsafeTransaction);
        const changedNodesValid = (0, $1Jh1r.validateNodes)(nodes);
        const transaction = new Proxy(unsafeTransaction, (0, $ep3X6.freezeUnsafeTransactionProperties)({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            pluginKey: 'unknown-reacteditorview'
        }));
        // If the transaction is a remote replaceDocument transaction, we should skip validation.
        // Remote replaceDocument transactions are fired when the document is replaced by initialization of editor-plugin-collab-edit
        // If there is a discrepancy in the ProseMirror schema at initialization, it results in the editor being loaded with no content,
        // giving the user the impression that content has been lost
        const isRemoteReplace = isRemoteReplaceDocumentTransaction ? isRemoteReplaceDocumentTransaction(transaction) : false;
        if (changedNodesValid || isRemoteReplace) {
            const oldEditorState = view.state;
            // go ahead and update the state now we know the transaction is good
            const { state: newEditorState, transactions: transactions } = view.state.applyTransaction(transaction);
            if (newEditorState === oldEditorState) return;
            view.updateState(newEditorState);
            onEditorViewUpdated({
                originalTransaction: transaction,
                transactions: transactions,
                oldEditorState: oldEditorState,
                newEditorState: newEditorState
            });
            if (onChangeRef.current && transaction.docChanged) {
                const source = transaction.getMeta('isRemote') ? 'remote' : 'local';
                const isDirtyChange = (0, $eh3wX.isDirtyTransaction)(transaction);
                (0, $hvjqZ.startMeasure)((0, $kNGyI.EVENT_NAME_ON_CHANGE));
                onChangeRef.current(view, {
                    source: source,
                    isDirtyChange: isDirtyChange
                });
                (0, $hvjqZ.stopMeasure)((0, $kNGyI.EVENT_NAME_ON_CHANGE));
            }
        }
        if (!changedNodesValid) {
            const invalidNodes = nodes.filter((node)=>!(0, $1Jh1r.validNode)(node)).map((node)=>(0, $eemFN.getDocStructure)(node, {
                    compact: true
                }));
            dispatchAnalyticsEvent({
                action: (0, $bMFKb.ACTION).DISPATCHED_INVALID_TRANSACTION,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
                eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    analyticsEventPayloads: (0, $jXreb.getAnalyticsEventsFromTransaction)(transaction),
                    invalidNodes: invalidNodes,
                    isRemoteReplaceDocumentTransaction: isRemoteReplace
                }
            });
        }
    }, [
        dispatchAnalyticsEvent,
        onEditorViewUpdated,
        isRemoteReplaceDocumentTransaction
    ]);
    return dispatchTransaction;
};

});
parcelRegister("jXreb", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsEventsFromTransaction", () => $e31252f9eb83bc39$export$d9985be1ece4b7ee);

var $ivREi = parcelRequire("ivREi");
function $e31252f9eb83bc39$export$d9985be1ece4b7ee(tr) {
    return tr.steps.filter((step)=>step instanceof (0, $ivREi.AnalyticsStep)).reduce((acc, step)=>[
            ...acc,
            ...step.analyticsEvents
        ], []);
}

});
parcelRegister("ivREi", function(module, exports) {
$parcel$export(module.exports, "AnalyticsStep", () => $d7a4bccb738f760c$export$cc33374693c7fb23);

var $7M3Wu = parcelRequire("7M3Wu");

var $lzEKq = parcelRequire("lzEKq");

var $3xw6l = parcelRequire("3xw6l");
const $d7a4bccb738f760c$export$9126078e8b0f76e4 = 'atlaskit-analytics';
const $d7a4bccb738f760c$export$89a6d622be04d823 = 'atlaskit-analytics-invert';
var $d7a4bccb738f760c$var$HISTORY_ACTIONS = /*#__PURE__*/ function(HISTORY_ACTIONS) {
    HISTORY_ACTIONS["UNDID"] = "undid";
    HISTORY_ACTIONS["REDID"] = "redid";
    return HISTORY_ACTIONS;
}($d7a4bccb738f760c$var$HISTORY_ACTIONS || {});
/** Creates undo event from a normal analytics event */ function $d7a4bccb738f760c$var$createUndoEvent(analyticsEvent) {
    var _analyticsEvent$paylo;
    return {
        ...analyticsEvent,
        payload: {
            action: $d7a4bccb738f760c$var$HISTORY_ACTIONS.UNDID,
            actionSubject: analyticsEvent.payload.actionSubject,
            actionSubjectId: analyticsEvent.payload.action,
            attributes: {
                ...analyticsEvent.payload.attributes,
                actionSubjectId: analyticsEvent.payload.actionSubjectId,
                inputMethod: ((_analyticsEvent$paylo = analyticsEvent.payload.attributes) === null || _analyticsEvent$paylo === void 0 ? void 0 : _analyticsEvent$paylo.inputMethod) || ''
            },
            eventType: 'track'
        }
    };
}
/** Toggles event action between undo & redo */ const $d7a4bccb738f760c$var$toggleEventAction = (analyticsEvent)=>({
        ...analyticsEvent,
        payload: {
            ...analyticsEvent.payload,
            action: analyticsEvent.payload.action === $d7a4bccb738f760c$var$HISTORY_ACTIONS.UNDID ? $d7a4bccb738f760c$var$HISTORY_ACTIONS.REDID : $d7a4bccb738f760c$var$HISTORY_ACTIONS.UNDID
        }
    });
function $d7a4bccb738f760c$var$isHistoryAnalyticsEvent(event) {
    return event.payload.action === $d7a4bccb738f760c$var$HISTORY_ACTIONS.UNDID || event.payload.action === $d7a4bccb738f760c$var$HISTORY_ACTIONS.REDID;
}
class $d7a4bccb738f760c$export$cc33374693c7fb23 extends (0, $lzEKq.Step) {
    constructor(analyticsEvents, actionsToIgnore = [], pos // Used to create the map, prevent splitting history.
    ){
        super();
        (0, $7M3Wu.default)(this, "analyticsEvents", []);
        (0, $7M3Wu.default)(this, "actionsToIgnore", []);
        this.analyticsEvents = analyticsEvents;
        this.actionsToIgnore = actionsToIgnore;
        this.pos = pos;
    }
    /**
   * Generate new undo/redo analytics event when step is inverted
   */ invert() {
        const analyticsEvents = this.analyticsEvents.filter((analyticsEvent)=>this.actionsToIgnore.indexOf(analyticsEvent.payload.action) === -1).map((analyticsEvent)=>{
            if ($d7a4bccb738f760c$var$isHistoryAnalyticsEvent(analyticsEvent)) return $d7a4bccb738f760c$var$toggleEventAction(analyticsEvent);
            else return $d7a4bccb738f760c$var$createUndoEvent(analyticsEvent);
        });
        return new $d7a4bccb738f760c$export$cc33374693c7fb23(analyticsEvents, []);
    }
    apply(doc) {
        return (0, $lzEKq.StepResult).ok(doc);
    }
    map(mapping) {
        let newPos = this.pos;
        if (typeof newPos === 'number') newPos = mapping.map(newPos);
        // Return the same events, this step will never be removed
        return new $d7a4bccb738f760c$export$cc33374693c7fb23(this.analyticsEvents, this.actionsToIgnore, newPos);
    }
    getMap() {
        if (typeof this.pos === 'number') return new (0, $lzEKq.StepMap)([
            this.pos,
            0,
            0
        ]);
        return new (0, $lzEKq.StepMap)([]);
    }
    merge(other) {
        if (other instanceof $d7a4bccb738f760c$export$cc33374693c7fb23) {
            const otherAnalyticsEvents = other.analyticsEvents;
            return new $d7a4bccb738f760c$export$cc33374693c7fb23([
                ...otherAnalyticsEvents,
                ...this.analyticsEvents
            ]);
        }
        return null;
    }
    toJSON() {
        return {
            stepType: $d7a4bccb738f760c$export$9126078e8b0f76e4
        };
    }
    static fromJSON() {
        return new (0, $lzEKq.ReplaceStep)(0, 0, (0, $3xw6l.Slice).empty);
    }
}
/** Register this step with Prosemirror */ (0, $lzEKq.Step).jsonID($d7a4bccb738f760c$export$9126078e8b0f76e4, $d7a4bccb738f760c$export$cc33374693c7fb23);

});


parcelRegister("eh3wX", function(module, exports) {
$parcel$export(module.exports, "PROVIDER_ERROR_CODE", () => $baa7c1787ff83074$export$54cb529986e2487b);
$parcel$export(module.exports, "DisconnectReason", () => $baa7c1787ff83074$export$258d16488300d83f);
$parcel$export(module.exports, "TELEPOINTER_DIM_CLASS", () => $baa7c1787ff83074$export$75f1e2b0ae2c8197);
$parcel$export(module.exports, "TELEPOINTER_PULSE_CLASS", () => $baa7c1787ff83074$export$44ee82a2b1106d13);
$parcel$export(module.exports, "TELEPOINTER_PULSE_DURING_TR_CLASS", () => $baa7c1787ff83074$export$15875d5e8ce4fd42);
$parcel$export(module.exports, "TELEPOINTER_PULSE_DURING_TR_DURATION_MS", () => $baa7c1787ff83074$export$cea3f62f94f5fdf0);
$parcel$export(module.exports, "TELEPOINTER_DATA_SESSION_ID_ATTR", () => $baa7c1787ff83074$export$74788e2dc4d9be50);
$parcel$export(module.exports, "isDirtyTransaction", () => $baa7c1787ff83074$export$c500b1bc696a0abc);
$parcel$export(module.exports, "tintDirtyTransaction", () => $baa7c1787ff83074$export$f25182515d14d793);

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");

var $01wZP = parcelRequire("01wZP");
var $baa7c1787ff83074$export$54cb529986e2487b = /*#__PURE__*/ function(PROVIDER_ERROR_CODE) {
    PROVIDER_ERROR_CODE["NO_PERMISSION_ERROR"] = "NO_PERMISSION_ERROR";
    PROVIDER_ERROR_CODE["INVALID_USER_TOKEN"] = "INVALID_USER_TOKEN";
    PROVIDER_ERROR_CODE["DOCUMENT_NOT_FOUND"] = "DOCUMENT_NOT_FOUND";
    PROVIDER_ERROR_CODE["LOCKED"] = "LOCKED";
    PROVIDER_ERROR_CODE["FAIL_TO_SAVE"] = "FAIL_TO_SAVE";
    PROVIDER_ERROR_CODE["DOCUMENT_RESTORE_ERROR"] = "DOCUMENT_RESTORE_ERROR";
    PROVIDER_ERROR_CODE["INITIALISATION_ERROR"] = "INITIALISATION_ERROR";
    PROVIDER_ERROR_CODE["NETWORK_ISSUE"] = "NETWORK_ISSUE";
    PROVIDER_ERROR_CODE["INVALID_PROVIDER_CONFIGURATION"] = "INVALID_PROVIDER_CONFIGURATION";
    PROVIDER_ERROR_CODE["INTERNAL_SERVICE_ERROR"] = "INTERNAL_SERVICE_ERROR";
    PROVIDER_ERROR_CODE["DOCUMENT_UPDATE_ERROR"] = "DOCUMENT_UPDATE_ERROR";
    return PROVIDER_ERROR_CODE;
}({});
var $baa7c1787ff83074$export$258d16488300d83f = /*#__PURE__*/ function(DisconnectReason) {
    DisconnectReason["CLIENT_DISCONNECT"] = "CLIENT_DISCONNECT";
    DisconnectReason["SERVER_DISCONNECT"] = "SERVER_DISCONNECT";
    DisconnectReason["SOCKET_CLOSED"] = "SOCKET_CLOSED";
    DisconnectReason["SOCKET_ERROR"] = "SOCKET_ERROR";
    DisconnectReason["SOCKET_TIMEOUT"] = "SOCKET_TIMEOUT";
    DisconnectReason["UNKNOWN_DISCONNECT"] = "UNKNOWN_DISCONNECT";
    return DisconnectReason;
}({});
const $baa7c1787ff83074$var$telepointerColorStyle = (backgroundColor, textColor, index)=>{
    const { colorMode: colorMode } = (0, $01wZP.default)();
    const backgroundStyle = colorMode === 'dark' ? `linear-gradient(to bottom, ${backgroundColor} -800000%, transparent 200000%)` : `linear-gradient(to bottom, ${backgroundColor} -850000%, transparent 150000%)`;
    return `
    &.color-${index} {
      background: ${backgroundStyle};
      &::after {
        background-color: ${backgroundColor};
        color: ${textColor};
        border-color: ${backgroundColor};
      }
    }
  `;
};
const $baa7c1787ff83074$export$75f1e2b0ae2c8197 = 'telepointer-dim';
const $baa7c1787ff83074$export$44ee82a2b1106d13 = 'telepointer-pulse-animate';
const $baa7c1787ff83074$export$15875d5e8ce4fd42 = 'telepointer-pulse-during-tr';
const $baa7c1787ff83074$export$cea3f62f94f5fdf0 = 7500; // Keeping it longer so it'll be easier to spot during transactions
const $baa7c1787ff83074$export$74788e2dc4d9be50 = 'data-telepointer-sessionid';
const $baa7c1787ff83074$export$c94087d6ea5127ad = /*#__PURE__*/ (0, $1NIU8.css)("@keyframes pulseIn{0%,100%{transform:scaleX(0);opacity:0;}10%{transform:scaleX(1.4);opacity:1;}15%,85%{transform:scaleX(1);opacity:1;}}@keyframes pulseOut{0%,90%,100%{transform:scaleX(1);opacity:1;}10%,80%{transform:scaleX(0);opacity:0;}}@keyframes pulseInDuringTr{0%,95%{transform:scaleX(1);opacity:1;}100%{transform:scaleX(0);opacity:0;}}@keyframes pulseOutDuringTr{100%{transform:scaleX(1);opacity:1;}0%,90%{transform:scaleX(0);opacity:0;}}.ProseMirror .telepointer{position:relative;transition:opacity 200ms;", (0, $7yBx7.participantColors).map((participantColor, index)=>$baa7c1787ff83074$var$telepointerColorStyle(participantColor.backgroundColor, participantColor.textColor, index)), ";&.telepointer-selection:not(.inlineNodeView){line-height:1.2;pointer-events:none;user-select:none;}&.telepointer-selection-badge{.telepointer-initial,.telepointer-fullname{position:absolute;display:block;user-select:none;white-space:pre;top:-14px;left:0px;font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);padding-left:var(--ds-space-050, 4px);padding-right:var(--ds-space-050, 4px);border-radius:0 2px 2px 0;}.telepointer-initial{opacity:1;transition:opacity 0.15s ease-out;}.telepointer-fullname{opacity:0;transform:scaleX(0);transform-origin:top left;transition:transform 0.15s ease-out,opacity 0.15s ease-out;}}&.", $baa7c1787ff83074$export$44ee82a2b1106d13, "{.telepointer-initial{animation:pulseOut 2.5s ease-in-out;}.telepointer-fullname{animation:pulseIn 2.5s ease-in-out;}}&.", $baa7c1787ff83074$export$15875d5e8ce4fd42, "{.telepointer-initial{animation:pulseOutDuringTr ", $baa7c1787ff83074$export$cea3f62f94f5fdf0, "ms ease-in-out;}.telepointer-fullname{animation:pulseInDuringTr ", $baa7c1787ff83074$export$cea3f62f94f5fdf0, "ms ease-in-out;}}&:hover{.telepointer-initial{opacity:0;transition-delay:150ms;}.telepointer-fullname{transform:scaleX(1);opacity:1;z-index:1;}}&.", $baa7c1787ff83074$export$75f1e2b0ae2c8197, "{opacity:0.2;}}");
const $baa7c1787ff83074$var$tintKey = 'collab:isDirtyTransaction';
const $baa7c1787ff83074$export$c500b1bc696a0abc = (tr)=>{
    return Boolean(tr.getMeta($baa7c1787ff83074$var$tintKey));
};
const $baa7c1787ff83074$export$f25182515d14d793 = (tr)=>{
    tr.setMeta($baa7c1787ff83074$var$tintKey, true);
};

});

parcelRegister("7e31w", function(module, exports) {
$parcel$export(module.exports, "findChangedNodesFromTransaction", () => $14bf14a539fd661c$export$cdc577fd3f583194);
const $14bf14a539fd661c$export$cdc577fd3f583194 = (tr)=>{
    const nodes = [];
    const steps = tr.steps || [];
    steps.forEach((step)=>{
        step.getMap().forEach((_oldStart, _oldEnd, newStart, newEnd)=>{
            tr.doc.nodesBetween(newStart, Math.min(newEnd, tr.doc.content.size), (node)=>{
                if (!nodes.find((n)=>n === node)) nodes.push(node);
                return false;
            });
        });
    });
    return nodes;
};

});

parcelRegister("ep3X6", function(module, exports) {
$parcel$export(module.exports, "freezeUnsafeTransactionProperties", () => $35bd4827ea64a1ab$export$668aa008bdae439f);

var $bMFKb = parcelRequire("bMFKb");
const $35bd4827ea64a1ab$export$9f24e92219b6e945 = 'Setting an unsafe property on transaction after dispatch!';
// since selection uses curSelection under the hood, we guard setSelection instead
const $35bd4827ea64a1ab$var$isUnsafeMethod = (prop)=>[
        'setSelection'
    ].includes(prop.toString());
const $35bd4827ea64a1ab$var$isReadOnlyProperty = (prop)=>[
        'doc',
        'docs',
        'steps',
        'selection'
    ].includes(prop.toString());
const $35bd4827ea64a1ab$export$668aa008bdae439f = ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginKey: pluginKey })=>{
    const isUnsafe = ()=>{
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).TRANSACTION_MUTATED_AFTER_DISPATCH,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
            attributes: {
                pluginKey: pluginKey || 'unknown'
            }
        });
        throw new Error($35bd4827ea64a1ab$export$9f24e92219b6e945);
    };
    return {
        get: function(target, prop, receiver) {
            if ($35bd4827ea64a1ab$var$isUnsafeMethod(prop)) isUnsafe();
            return Reflect.get(target, prop, receiver);
        },
        set: function(target, prop, receiver) {
            if ($35bd4827ea64a1ab$var$isReadOnlyProperty(prop)) isUnsafe();
            return Reflect.set(target, prop, receiver);
        }
    };
};

});

parcelRegister("kNGyI", function(module, exports) {
$parcel$export(module.exports, "EVENT_NAME_ON_CHANGE", () => $dfbe61fc04a32540$export$bb82e7cfb8987f35);

var $8LHnV = parcelRequire("8LHnV");

var $hvjqZ = parcelRequire("hvjqZ");

var $hEZNp = parcelRequire("hEZNp");
const $dfbe61fc04a32540$export$5e38f3b295505ec8 = `\u{1F989} EditorView::state::apply`;
const $dfbe61fc04a32540$export$646ca0d076c98ad5 = `\u{1F989} EditorView::updateState`;
const $dfbe61fc04a32540$export$2f488cec9729a7d6 = `\u{1F989} EditorView::onEditorViewStateUpdated`;
const $dfbe61fc04a32540$export$bb82e7cfb8987f35 = `\u{1F989} ReactEditorView::onChange`;
const $dfbe61fc04a32540$export$373baa16b824d295 = `\u{1F989} ReactEditorView::dispatchTransaction`;
const $dfbe61fc04a32540$export$735da5ee20c885d5 = false;
const $dfbe61fc04a32540$var$DEFAULT_SAMPLING_RATE = 100;
const $dfbe61fc04a32540$var$noop = ()=>{};
class $dfbe61fc04a32540$export$7a054319813aafa {
    addMeasureListener(listener) {
        this.measureListeners.push(listener);
    }
    removeMeasureListener(listener) {
        const index = this.measureListeners.indexOf(listener);
        if (index > -1) this.measureListeners.splice(index, 1);
    }
    shouldTrackTransaction(options) {
        const { enabled: trackingEnabled, samplingRate: samplingRate = $dfbe61fc04a32540$var$DEFAULT_SAMPLING_RATE } = options;
        return trackingEnabled && this.dispatchCallCounter === samplingRate;
    }
    constructor(){
        // Counter so we can rate limit the transaction performance tracking
        this.dispatchCallCounter = 0;
        // A map containing the time which measurement starts
        this.measureMap = new Map();
        this.measureListeners = [];
        this.bumpDispatchCounter = (options)=>{
            const { enabled: trackingEnabled, samplingRate: samplingRate = $dfbe61fc04a32540$var$DEFAULT_SAMPLING_RATE } = options;
            if (trackingEnabled) {
                if (this.dispatchCallCounter >= samplingRate) this.dispatchCallCounter = 0;
                this.dispatchCallCounter++;
            }
            return this.dispatchCallCounter;
        };
        this.getMeasureHelpers = (options)=>{
            const { usePerformanceMarks: usePerformanceMarks = $dfbe61fc04a32540$export$735da5ee20c885d5 } = options;
            if (!this.shouldTrackTransaction(options)) return {
                startMeasure: $dfbe61fc04a32540$var$noop,
                stopMeasure: $dfbe61fc04a32540$var$noop
            };
            return {
                startMeasure: usePerformanceMarks ? (0, $hvjqZ.startMeasure) : this.startMeasureSimple,
                stopMeasure: usePerformanceMarks ? (0, $hvjqZ.stopMeasure) : this.stopMeasureSimple
            };
        };
        this.startMeasureSimple = (measureName)=>{
            if (!(0, $8LHnV.isPerformanceAPIAvailable)()) return;
            this.measureMap.set(measureName, performance.now());
        };
        this.stopMeasureSimple = (measureName, onMeasureComplete)=>{
            if (!(0, $8LHnV.isPerformanceAPIAvailable)()) return;
            const startTime = this.measureMap.get(measureName);
            if (startTime) {
                const duration = (0, $hEZNp.getTimeSince)(startTime);
                this.measureMap.delete(measureName);
                if (onMeasureComplete) onMeasureComplete(duration, startTime);
                // Call each subscribed listener
                this.measureListeners.forEach((listener)=>listener({
                        name: measureName,
                        duration: duration,
                        startTime: startTime
                    }));
            }
        };
    }
}

});
parcelRegister("hEZNp", function(module, exports) {
$parcel$export(module.exports, "getTimeSince", () => $53d5d7ad4b40db71$export$a26b90db2c8f1b97);
/**
 * Calculate the difference between performance.now() and the given startTime.
 * This allows for the timing to be overridable during tests.
 *
 * @param startTime DOMHighResTimeStamp
 * @returns DOMHighResTimeStamp
 */ const $53d5d7ad4b40db71$export$a26b90db2c8f1b97 = (startTime)=>performance.now() - startTime;

});


parcelRegister("1Jh1r", function(module, exports) {
$parcel$export(module.exports, "validNode", () => $04d4fe46b198d691$export$4c39e41e39b3c449);
$parcel$export(module.exports, "validateNodes", () => $04d4fe46b198d691$export$996213f7c272fc6f);
const $04d4fe46b198d691$export$4c39e41e39b3c449 = (node)=>{
    try {
        node.check();
    } catch (error) {
        return false;
    }
    return true;
};
const $04d4fe46b198d691$export$996213f7c272fc6f = (nodes)=>nodes.every($04d4fe46b198d691$export$4c39e41e39b3c449);

});


parcelRegister("2afhI", function(module, exports) {
$parcel$export(module.exports, "useFireFullWidthEvent", () => $11dfe5e8679f5a9d$export$4998b7b36606f9c3);

var $eJOHy = parcelRequire("eJOHy");

var $bMFKb = parcelRequire("bMFKb");

var $5ZVTg = parcelRequire("5ZVTg");

var $dHHo1 = parcelRequire("dHHo1");
const $11dfe5e8679f5a9d$export$4998b7b36606f9c3 = (appearance, dispatchAnalyticsEvent)=>{
    const previousAppearance = (0, $5ZVTg.default)(appearance);
    (0, $eJOHy.useEffect)(()=>{
        if (appearance !== previousAppearance) {
            if (appearance === 'full-width' || previousAppearance === 'full-width') dispatchAnalyticsEvent({
                action: (0, $bMFKb.ACTION).CHANGED_FULL_WIDTH_MODE,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                attributes: {
                    previousMode: (0, $dHHo1.formatFullWidthAppearance)(previousAppearance),
                    newMode: (0, $dHHo1.formatFullWidthAppearance)(appearance)
                }
            });
        }
    }, [
        appearance,
        previousAppearance,
        dispatchAnalyticsEvent
    ]);
};

});
parcelRegister("dHHo1", function(module, exports) {
$parcel$export(module.exports, "formatFullWidthAppearance", () => $1f21fdcc124e6848$export$47d5b79f3ddf0b92);

var $8MfCL = parcelRequire("8MfCL");
const $1f21fdcc124e6848$export$47d5b79f3ddf0b92 = (appearance)=>{
    if (appearance === 'full-width') return (0, $8MfCL.FULL_WIDTH_MODE).FULL_WIDTH;
    return (0, $8MfCL.FULL_WIDTH_MODE).FIXED_WIDTH;
};

});



parcelRegister("6HxkX", function(module, exports) {
$parcel$export(module.exports, "IntlProviderIfMissingWrapper", () => $b65d45e9e05c381b$export$742fe272b8921eea);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6YFG2 = parcelRequire("6YFG2");
var $4nehu = parcelRequire("4nehu");
const $b65d45e9e05c381b$var$useCheckIntlContext = ()=>(0, $eJOHy.useContext)((0, $6YFG2.Context)) === null;
function $b65d45e9e05c381b$export$742fe272b8921eea({ children: children }) {
    const missingIntlContext = $b65d45e9e05c381b$var$useCheckIntlContext();
    if (missingIntlContext) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        locale: "en",
        children: children
    });
    return children;
}

});

parcelRegister("gk7i7", function(module, exports) {
$parcel$export(module.exports, "BaseThemeWrapper", () => $da9fa5a563d178aa$export$3de34996b814f0f0);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $loabE = parcelRequire("loabE");

var $7yBx7 = parcelRequire("7yBx7");
// Default value from: `import { fontSize } from '@atlaskit/theme/constants';`
const $da9fa5a563d178aa$var$defaultFontSize = 14;
function $da9fa5a563d178aa$export$3de34996b814f0f0({ baseFontSize: baseFontSize, children: children }) {
    const memoizedTheme = (0, $eJOHy.useMemo)(()=>({
            baseFontSize: baseFontSize || $da9fa5a563d178aa$var$defaultFontSize,
            layoutMaxWidth: (0, $7yBx7.akEditorDefaultLayoutWidth)
        }), [
        baseFontSize
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $loabE.a), {
        theme: memoizedTheme,
        children: children
    });
}

});

parcelRegister("dLePd", function(module, exports) {
$parcel$export(module.exports, "getBaseFontSize", () => $94ef00ed687838d3$export$8e2864079bc476bd);

var $7yBx7 = parcelRequire("7yBx7");

var $cbSL1 = parcelRequire("cbSL1");
function $94ef00ed687838d3$export$8e2864079bc476bd(appearance, contentMode) {
    if ((0, $cbSL1.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test')) {
        if (contentMode === ((0, $cbSL1.expValEquals)('confluence_content_mode_replace_dense_with_compact', 'cohort', 'test') ? 'compact' : 'dense')) return 0, $7yBx7.akEditorFullPageDenseFontSize;
    }
    if (appearance === undefined) return 0, $7yBx7.akEditorFullPageDefaultFontSize;
    return ![
        'comment',
        'chromeless'
    ].includes(appearance) ? (0, $7yBx7.akEditorFullPageDefaultFontSize) : undefined;
}

});


parcelRegister("1PCVi", function(module, exports) {
$parcel$export(module.exports, "default", () => $b11c9a982109a0ee$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $bMFKb = parcelRequire("bMFKb");

var $hvjqZ = parcelRequire("hvjqZ");

var $1ZFgR = parcelRequire("1ZFgR");

var $fwDw9 = parcelRequire("fwDw9");

var $iPrw3 = parcelRequire("iPrw3");
function $b11c9a982109a0ee$export$2e2bcd8739ae039(props, createAnalyticsEvent) {
    (0, $iPrw3.default)();
    (0, $eJOHy.useEffect)(()=>{
        (0, $hvjqZ.stopMeasure)((0, $1ZFgR.default).EDITOR_MOUNTED, (0, $fwDw9.default)((0, $bMFKb.ACTION).EDITOR_MOUNTED, props, createAnalyticsEvent));
        return ()=>{
            (0, $hvjqZ.clearMeasure)((0, $1ZFgR.default).EDITOR_MOUNTED);
            (0, $hvjqZ.clearMeasure)((0, $1ZFgR.default).ON_EDITOR_READY_CALLBACK);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
// Disable Exhaustive Deps here since we only want to stop the measure on mount.
}

});
parcelRegister("fwDw9", function(module, exports) {
$parcel$export(module.exports, "default", () => $95a6074d616ca448$export$2e2bcd8739ae039);

var $bMFKb = parcelRequire("bMFKb");
var $cd124 = parcelRequire("cd124");
function $95a6074d616ca448$export$2e2bcd8739ae039(action, props, createAnalyticsEvent) {
    return async (duration, startTime)=>{
        const contextIdentifier = await props.contextIdentifierProvider;
        const objectId = contextIdentifier?.objectId;
        if (createAnalyticsEvent) (0, $cd124.fireAnalyticsEvent)(createAnalyticsEvent)({
            payload: {
                action: action,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
                attributes: {
                    duration: duration,
                    startTime: startTime,
                    objectId: objectId
                },
                eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
            }
        });
    };
}

});

parcelRegister("iPrw3", function(module, exports) {
$parcel$export(module.exports, "default", () => $500d5897eb76031a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $2Kn3g = parcelRequire("2Kn3g");

var $hvjqZ = parcelRequire("hvjqZ");

var $1ZFgR = parcelRequire("1ZFgR");
function $500d5897eb76031a$export$2e2bcd8739ae039() {
    (0, $2Kn3g.default)(()=>{
        (0, $hvjqZ.startMeasure)((0, $1ZFgR.default).EDITOR_MOUNTED);
    });
}

});


parcelRegister("1NJcR", function(module, exports) {
$parcel$export(module.exports, "default", () => $237036b9f5e87f96$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $237036b9f5e87f96$export$d9d7e48a5f16fb4d = (passedProps)=>{
    const memodProps = (0, $eJOHy.useMemo)(()=>{
        // That sounds awful but this is the only way to make sure we didn't missed any EditorProps
        const allProps = {
            preset: passedProps.preset,
            appearance: passedProps.appearance,
            contentMode: passedProps.contentMode,
            contentComponents: passedProps.contentComponents,
            primaryToolbarIconBefore: passedProps.primaryToolbarIconBefore,
            secondaryToolbarComponents: passedProps.secondaryToolbarComponents,
            persistScrollGutter: passedProps.persistScrollGutter,
            quickInsert: passedProps.quickInsert,
            shouldFocus: passedProps.shouldFocus,
            disabled: passedProps.disabled,
            contextPanel: passedProps.contextPanel,
            errorReporterHandler: passedProps.errorReporterHandler,
            contentTransformerProvider: passedProps.contentTransformerProvider,
            maxHeight: passedProps.maxHeight,
            minHeight: passedProps.minHeight,
            placeholder: passedProps.placeholder,
            placeholderBracketHint: passedProps.placeholderBracketHint,
            defaultValue: passedProps.defaultValue,
            assistiveLabel: passedProps.assistiveLabel,
            assistiveDescribedBy: passedProps.assistiveDescribedBy,
            popupsMountPoint: passedProps.popupsMountPoint,
            popupsBoundariesElement: passedProps.popupsBoundariesElement,
            popupsScrollableElement: passedProps.popupsScrollableElement,
            editorActions: passedProps.editorActions,
            onEditorReady: passedProps.onEditorReady,
            onDestroy: passedProps.onDestroy,
            onChange: passedProps.onChange,
            onCancel: passedProps.onCancel,
            extensionProviders: passedProps.extensionProviders,
            UNSAFE_useAnalyticsContext: passedProps.UNSAFE_useAnalyticsContext,
            useStickyToolbar: passedProps.useStickyToolbar,
            featureFlags: passedProps.featureFlags,
            onSave: passedProps.onSave,
            sanitizePrivateContent: passedProps.sanitizePrivateContent,
            media: passedProps.media,
            collabEdit: passedProps.collabEdit,
            primaryToolbarComponents: passedProps.primaryToolbarComponents,
            performanceTracking: passedProps.performanceTracking,
            inputSamplingLimit: passedProps.inputSamplingLimit,
            allowUndoRedoButtons: passedProps.allowUndoRedoButtons,
            linking: passedProps.linking,
            activityProvider: passedProps.activityProvider,
            searchProvider: passedProps.searchProvider,
            annotationProviders: passedProps.annotationProviders,
            collabEditProvider: passedProps.collabEditProvider,
            presenceProvider: passedProps.presenceProvider,
            emojiProvider: passedProps.emojiProvider,
            taskDecisionProvider: passedProps.taskDecisionProvider,
            legacyImageUploadProvider: passedProps.legacyImageUploadProvider,
            mentionProvider: passedProps.mentionProvider,
            autoformattingProvider: passedProps.autoformattingProvider,
            macroProvider: passedProps.macroProvider,
            contextIdentifierProvider: passedProps.contextIdentifierProvider,
            allowExpand: passedProps.allowExpand,
            allowNestedTasks: passedProps.allowNestedTasks,
            allowBlockType: passedProps.allowBlockType,
            allowTasksAndDecisions: passedProps.allowTasksAndDecisions,
            allowBreakout: passedProps.allowBreakout,
            allowRule: passedProps.allowRule,
            allowHelpDialog: passedProps.allowHelpDialog,
            allowPanel: passedProps.allowPanel,
            allowExtension: passedProps.allowExtension,
            allowConfluenceInlineComment: passedProps.allowConfluenceInlineComment,
            allowTemplatePlaceholders: passedProps.allowTemplatePlaceholders,
            allowDate: passedProps.allowDate,
            allowLayouts: passedProps.allowLayouts,
            allowStatus: passedProps.allowStatus,
            allowTextAlignment: passedProps.allowTextAlignment,
            allowIndentation: passedProps.allowIndentation,
            showIndentationButtons: passedProps.showIndentationButtons,
            allowFindReplace: passedProps.allowFindReplace,
            allowBorderMark: passedProps.allowBorderMark,
            allowFragmentMark: passedProps.allowFragmentMark,
            autoScrollIntoView: passedProps.autoScrollIntoView,
            elementBrowser: passedProps.elementBrowser,
            maxContentSize: passedProps.maxContentSize,
            saveOnEnter: passedProps.saveOnEnter,
            feedbackInfo: passedProps.feedbackInfo,
            mention: passedProps.mention,
            mentionInsertDisplayName: passedProps.mentionInsertDisplayName,
            uploadErrorHandler: passedProps.uploadErrorHandler,
            waitForMediaUpload: passedProps.waitForMediaUpload,
            extensionHandlers: passedProps.extensionHandlers,
            allowTextColor: passedProps.allowTextColor,
            allowTables: passedProps.allowTables,
            insertMenuItems: passedProps.insertMenuItems,
            UNSAFE_cards: passedProps.UNSAFE_cards,
            smartLinks: passedProps.smartLinks,
            allowAnalyticsGASV3: passedProps.allowAnalyticsGASV3,
            codeBlock: passedProps.codeBlock,
            textFormatting: passedProps.textFormatting,
            __livePage: passedProps.__livePage,
            AppearanceComponent: passedProps.AppearanceComponent,
            skipValidation: passedProps.skipValidation,
            syncBlock: passedProps.syncBlock,
            syncedBlockProvider: passedProps.syncedBlockProvider
        };
        const defaultProps = {
            appearance: 'comment',
            disabled: false,
            quickInsert: true
        };
        const nextProps = {
            ...defaultProps,
            ...allProps
        };
        return nextProps;
    }, [
        passedProps.preset,
        passedProps.appearance,
        passedProps.contentMode,
        passedProps.contentComponents,
        passedProps.primaryToolbarIconBefore,
        passedProps.secondaryToolbarComponents,
        passedProps.persistScrollGutter,
        passedProps.quickInsert,
        passedProps.shouldFocus,
        passedProps.disabled,
        passedProps.contextPanel,
        passedProps.errorReporterHandler,
        passedProps.contentTransformerProvider,
        passedProps.maxHeight,
        passedProps.minHeight,
        passedProps.placeholder,
        passedProps.placeholderBracketHint,
        passedProps.performanceTracking,
        passedProps.inputSamplingLimit,
        passedProps.defaultValue,
        passedProps.assistiveLabel,
        passedProps.assistiveDescribedBy,
        passedProps.popupsMountPoint,
        passedProps.popupsBoundariesElement,
        passedProps.popupsScrollableElement,
        passedProps.editorActions,
        passedProps.onEditorReady,
        passedProps.onDestroy,
        passedProps.onChange,
        passedProps.onCancel,
        passedProps.extensionProviders,
        passedProps.UNSAFE_useAnalyticsContext,
        passedProps.useStickyToolbar,
        passedProps.featureFlags,
        passedProps.onSave,
        passedProps.sanitizePrivateContent,
        passedProps.media,
        passedProps.collabEdit,
        passedProps.primaryToolbarComponents,
        passedProps.allowUndoRedoButtons,
        passedProps.linking,
        passedProps.activityProvider,
        passedProps.searchProvider,
        passedProps.annotationProviders,
        passedProps.collabEditProvider,
        passedProps.presenceProvider,
        passedProps.emojiProvider,
        passedProps.taskDecisionProvider,
        passedProps.legacyImageUploadProvider,
        passedProps.mentionProvider,
        passedProps.autoformattingProvider,
        passedProps.macroProvider,
        passedProps.contextIdentifierProvider,
        passedProps.allowExpand,
        passedProps.allowNestedTasks,
        passedProps.allowBlockType,
        passedProps.allowTasksAndDecisions,
        passedProps.allowBreakout,
        passedProps.allowRule,
        passedProps.allowHelpDialog,
        passedProps.allowPanel,
        passedProps.allowExtension,
        passedProps.allowConfluenceInlineComment,
        passedProps.allowTemplatePlaceholders,
        passedProps.allowDate,
        passedProps.allowLayouts,
        passedProps.allowStatus,
        passedProps.allowTextAlignment,
        passedProps.allowIndentation,
        passedProps.showIndentationButtons,
        passedProps.allowFindReplace,
        passedProps.allowBorderMark,
        passedProps.allowFragmentMark,
        passedProps.autoScrollIntoView,
        passedProps.elementBrowser,
        passedProps.maxContentSize,
        passedProps.saveOnEnter,
        passedProps.feedbackInfo,
        passedProps.mention,
        passedProps.mentionInsertDisplayName,
        passedProps.uploadErrorHandler,
        passedProps.waitForMediaUpload,
        passedProps.extensionHandlers,
        passedProps.allowTextColor,
        passedProps.allowTables,
        passedProps.insertMenuItems,
        passedProps.UNSAFE_cards,
        passedProps.smartLinks,
        passedProps.allowAnalyticsGASV3,
        passedProps.codeBlock,
        passedProps.textFormatting,
        passedProps.__livePage,
        passedProps.AppearanceComponent,
        passedProps.skipValidation,
        passedProps.syncBlock,
        passedProps.syncedBlockProvider
    ]);
    return memodProps;
};
var $237036b9f5e87f96$export$2e2bcd8739ae039 = $237036b9f5e87f96$export$d9d7e48a5f16fb4d;

});

parcelRegister("fy7ur", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8f673fa8ed7b638$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1RDZV = parcelRequire("1RDZV");

var $daFj4 = parcelRequire("daFj4");

var $anjtc = parcelRequire("anjtc");

var $cenXl = parcelRequire("cenXl");

var $aipJ3 = parcelRequire("aipJ3");
function $e8f673fa8ed7b638$var$useEditorRef(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
preset) {
    const apiRef = (0, $eJOHy.useRef)();
    (0, $eJOHy.useEffect)(()=>{
        return preset?.apiResolver.on((api)=>{
            apiRef.current = api;
        });
    }, [
        preset?.apiResolver
    ]);
    return apiRef;
}
function $e8f673fa8ed7b638$var$prepareProviders(editorActions, apiRef, quickInsert, extensionProviders, createAnalyticsEvent) {
    const extensionProvider = (0, $daFj4.default)(()=>editorActions)(extensionProviders);
    const quickInsertProvider = (0, $anjtc.default)(editorActions, apiRef, extensionProvider, quickInsert, createAnalyticsEvent);
    return {
        extensionProvider: extensionProvider,
        quickInsertProvider: quickInsertProvider
    };
}
function $e8f673fa8ed7b638$export$2e2bcd8739ae039(props, editorActions, createAnalyticsEvent) {
    const { autoformattingProvider: autoformattingProvider, emojiProvider: emojiProvider, mentionProvider: mentionProvider, legacyImageUploadProvider: legacyImageUploadProvider, taskDecisionProvider: taskDecisionProvider, contextIdentifierProvider: contextIdentifierProvider, searchProvider: searchProvider, macroProvider: macroProvider, activityProvider: activityProvider, collabEdit: collabEdit, collabEditProvider: collabEditProvider, presenceProvider: presenceProvider, quickInsert: quickInsert, extensionProviders: extensionProviders } = props;
    const providers = (0, $eJOHy.useMemo)(()=>(0, $cenXl.default)({
            autoformattingProvider: autoformattingProvider,
            emojiProvider: emojiProvider,
            mentionProvider: mentionProvider,
            legacyImageUploadProvider: legacyImageUploadProvider,
            taskDecisionProvider: taskDecisionProvider,
            contextIdentifierProvider: contextIdentifierProvider,
            searchProvider: searchProvider,
            macroProvider: macroProvider,
            activityProvider: activityProvider,
            collabEdit: collabEdit,
            collabEditProvider: collabEditProvider,
            presenceProvider: presenceProvider
        }), [
        autoformattingProvider,
        emojiProvider,
        mentionProvider,
        legacyImageUploadProvider,
        taskDecisionProvider,
        contextIdentifierProvider,
        searchProvider,
        macroProvider,
        activityProvider,
        collabEdit,
        collabEditProvider,
        presenceProvider
    ]);
    const providerFactory = (0, $eJOHy.useRef)(new (0, $1RDZV.default)());
    const editorRef = $e8f673fa8ed7b638$var$useEditorRef(props.preset);
    const preparedProviders = (0, $eJOHy.useMemo)(()=>// Though this will introduce some performance regression related to quick insert
        // loading but we can remove it soon when Forge will move to new API.
        // quickInsert={Promise.resolve(consumerQuickInsert)} is one of the main reason behind this performance issue.
        $e8f673fa8ed7b638$var$prepareProviders(editorActions, editorRef, quickInsert, extensionProviders, createAnalyticsEvent), [
        extensionProviders,
        quickInsert,
        editorActions,
        createAnalyticsEvent,
        editorRef
    ]);
    (0, $eJOHy.useEffect)(()=>{
        (0, $aipJ3.default)(providerFactory.current, providers, preparedProviders.extensionProvider, preparedProviders.quickInsertProvider);
    }, [
        providers,
        preparedProviders
    ]);
    // componentWillUnmount equivalent
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            // Disable this next line because it is not a React node
            // so we can safely call destroy on the ref.
            // eslint-disable-next-line react-hooks/exhaustive-deps
            providerFactory.current.destroy();
        };
    }, []);
    return providerFactory.current;
}

});
parcelRegister("daFj4", function(module, exports) {
$parcel$export(module.exports, "default", () => $2801c4168a8fcca6$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");

var $6m9OE = parcelRequire("6m9OE");
function $2801c4168a8fcca6$var$prepareExtensionProvidersInternal(editorActions, extensionProviders) {
    if (!extensionProviders) return;
    if (typeof extensionProviders === 'function') return (0, $6m9OE.default)(extensionProviders(editorActions));
    return (0, $6m9OE.default)(extensionProviders);
}
const $2801c4168a8fcca6$var$prepareExtensionProvider = (getEditorActions)=>(0, $LFmXM.default)((extensionProviders)=>$2801c4168a8fcca6$var$prepareExtensionProvidersInternal(getEditorActions(), extensionProviders));
var $2801c4168a8fcca6$export$2e2bcd8739ae039 = $2801c4168a8fcca6$var$prepareExtensionProvider;

});
parcelRegister("6m9OE", function(module, exports) {
$parcel$export(module.exports, "default", () => $d1566159a1e1f037$export$2e2bcd8739ae039);

var $alidL = parcelRequire("alidL");
var /**
 * Allow to run methods from the `ExtensionProvider` interface across all providers seamlessly.
 * This handles promise racing and discards rejected promises safely.
 */ $d1566159a1e1f037$export$2e2bcd8739ae039 = (extensionProviders)=>{
    let providersCache = [];
    const { invokeSingle: invokeSingle, invokeList: invokeList } = (0, $alidL.default)(extensionProviders);
    return {
        getExtensions () {
            return invokeList('getExtensions');
        },
        async preload () {
            if (providersCache.length === 0) providersCache = await Promise.all(extensionProviders.map((provider)=>Promise.resolve(provider)));
            await Promise.all(providersCache.map((provider)=>provider?.preload?.()));
        },
        getPreloadedExtension (type, key) {
            if (providersCache.length === 0) // preload() has not been called yet
            return;
            for (const provider of providersCache)try {
                const result = provider?.getPreloadedExtension?.(type, key);
                if (result) return result;
            } catch  {
            // Not every provider will implement this method.
            // In that case we would get error from other providers in the loop
            // and undefined from that particular provider.
            // We can safely ignore it and fallback to the async getExtension when nothing was found.
            }
        },
        getExtension (type, key) {
            return invokeSingle('getExtension', [
                type,
                key
            ]);
        },
        search (keyword) {
            return invokeList('search', [
                keyword
            ]);
        },
        getAutoConverter () {
            return invokeList('getAutoConverter');
        }
    };
};

});
parcelRegister("alidL", function(module, exports) {
$parcel$export(module.exports, "default", () => $27e5a5983c1dac74$export$2e2bcd8739ae039);

var $8eFx0 = parcelRequire("8eFx0");
const $27e5a5983c1dac74$var$flatten = (arr)=>[].concat(...arr);
var /**
 * Allow to run methods from the given provider interface across all providers seamlessly.
 * Handles promise racing and discards rejected promises safely.
 */ $27e5a5983c1dac74$export$2e2bcd8739ae039 = (providers)=>{
    if (providers.length === 0) throw new Error('At least one provider must be provided');
    const getFulfilledProviders = async ()=>{
        const results = await (0, $8eFx0.waitForAllPromises)(providers.map((result)=>Promise.resolve(result)));
        return (0, $8eFx0.getOnlyFulfilled)(results);
    };
    const runInAllProviders = async (mapFunction)=>{
        return (await getFulfilledProviders()).map((provider)=>mapFunction(provider));
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const createCallback = (methodName, args)=>(provider)=>{
            const method = provider[methodName];
            if (typeof method === 'function') return method.apply(provider, args);
            throw new Error(`"${String(methodName)}" isn't a function of the provider`);
        };
    /**
	 * Run a method from the provider which expects to return a single item
	 * @param methodName
	 * @param args
	 */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const invokeSingle = async (methodName, args)=>{
        const callback = createCallback(methodName, args);
        return (0, $8eFx0.waitForFirstFulfilledPromise)(await runInAllProviders(callback));
    };
    /**
	 * Run a method in the provider which expectes to return a list of items
	 * @param methodName
	 * @param args
	 */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const invokeList = async (methodName, args)=>{
        const callback = createCallback(methodName, args);
        const results = await (0, $8eFx0.waitForAllPromises)(await runInAllProviders(callback));
        const fulfilledResults = (0, $8eFx0.getOnlyFulfilled)(results);
        return $27e5a5983c1dac74$var$flatten(fulfilledResults).filter((result)=>result);
    };
    return {
        invokeSingle: invokeSingle,
        invokeList: invokeList
    };
};

});
parcelRegister("8eFx0", function(module, exports) {
$parcel$export(module.exports, "waitForAllPromises", () => $bdae55c7b39f1d12$export$b43fdcffd84b7b0f);
$parcel$export(module.exports, "waitForFirstFulfilledPromise", () => $bdae55c7b39f1d12$export$cb8861b0e3f3dd6f);
$parcel$export(module.exports, "getOnlyFulfilled", () => $bdae55c7b39f1d12$export$b7581cbf0e22e36b);
var $bdae55c7b39f1d12$export$7103a54af3e45080 = /*#__PURE__*/ function(ResultStatus) {
    ResultStatus["FULFILLED"] = "fulfilled";
    ResultStatus["FAILED"] = "failed";
    return ResultStatus;
}({});
const $bdae55c7b39f1d12$var$isFullfilled = (result)=>result.status === "fulfilled";
const $bdae55c7b39f1d12$var$markFullfilled = (value)=>({
        status: "fulfilled",
        value: value
    });
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdae55c7b39f1d12$var$markRejected = (error)=>({
        status: "failed",
        reason: error
    });
const $bdae55c7b39f1d12$export$b43fdcffd84b7b0f = (promises)=>{
    return Promise.all(promises.map((result)=>result.then($bdae55c7b39f1d12$var$markFullfilled).catch($bdae55c7b39f1d12$var$markRejected)));
};
const $bdae55c7b39f1d12$export$cb8861b0e3f3dd6f = (promises)=>{
    const rejectReasons = [];
    return new Promise((resolve, reject)=>{
        promises.forEach((promise)=>promise.then((value)=>{
                if (typeof value === 'undefined' || value === null) throw new Error(`Result was not found but the method didn't reject/throw. Please ensure that it doesn't return null or undefined.`);
                resolve(value);
            }).catch((reason)=>{
                rejectReasons.push(reason);
                if (rejectReasons.length === promises.length) reject(reason);
            }));
    });
};
const $bdae55c7b39f1d12$export$b7581cbf0e22e36b = (results)=>results.filter($bdae55c7b39f1d12$var$isFullfilled).map((result)=>result.value);

});




parcelRegister("anjtc", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ec3991611a90ddd$export$2e2bcd8739ae039);

var $cLzGC = parcelRequire("cLzGC");
function $4ec3991611a90ddd$export$2e2bcd8739ae039(editorActions, apiRef, extensionProvider, quickInsert, createAnalyticsEvent) {
    const quickInsertProvider = quickInsert && typeof quickInsert !== 'boolean' && quickInsert.provider;
    const extensionQuickInsertProvider = extensionProvider && (0, $cLzGC.extensionProviderToQuickInsertProvider)(extensionProvider, editorActions, apiRef, createAnalyticsEvent);
    return quickInsertProvider && extensionQuickInsertProvider ? (0, $cLzGC.combineQuickInsertProviders)([
        quickInsertProvider,
        extensionQuickInsertProvider
    ]) : quickInsertProvider || extensionQuickInsertProvider;
}

});
parcelRegister("cLzGC", function(module, exports) {
$parcel$export(module.exports, "extensionProviderToQuickInsertProvider", () => $3995d1230bc1e17d$export$6b0bb34c2583056f);
$parcel$export(module.exports, "combineQuickInsertProviders", () => $3995d1230bc1e17d$export$e3759a254d73dcb7);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $joSn0 = parcelRequire("joSn0");

var $bMFKb = parcelRequire("bMFKb");
var $cd124 = parcelRequire("cd124");

var $g3VjK = parcelRequire("g3VjK");
var $l3kPA = parcelRequire("l3kPA");

var $alidL = parcelRequire("alidL");

var $dyNYh = parcelRequire("dyNYh");

var $eGOwo = parcelRequire("eGOwo");
/**
 * Utils to send analytics event when a extension is inserted using quickInsert
 */ function $3995d1230bc1e17d$var$sendExtensionQuickInsertAnalytics(item, selection, createAnalyticsEvent, source) {
    if (createAnalyticsEvent) {
        const insertLocation = (0, $dyNYh.findInsertLocation)(selection);
        (0, $cd124.fireAnalyticsEvent)(createAnalyticsEvent)({
            payload: {
                action: (0, $bMFKb.ACTION).INSERTED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).EXTENSION,
                attributes: {
                    extensionType: item.extensionType,
                    extensionKey: item.extensionKey,
                    key: item.key,
                    inputMethod: source || (0, $bMFKb.INPUT_METHOD).QUICK_INSERT,
                    ...insertLocation ? {
                        insertLocation: insertLocation
                    } : {}
                },
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK
            }
        });
    }
}
const $3995d1230bc1e17d$var$showDummyAPIWarning = (location)=>{};
const $3995d1230bc1e17d$var$dummyExtensionAPI = {
    editInContextPanel: ()=>$3995d1230bc1e17d$var$showDummyAPIWarning('editInContextPanel'),
    _editInLegacyMacroBrowser: ()=>$3995d1230bc1e17d$var$showDummyAPIWarning('_editInLegacyMacroBrowser'),
    getNodeWithPosByLocalId: ()=>({
            node: null,
            pos: null
        }),
    doc: {
        insertAfter: ()=>$3995d1230bc1e17d$var$showDummyAPIWarning('doc:insertAfter'),
        scrollTo: ()=>$3995d1230bc1e17d$var$showDummyAPIWarning('doc:scrollTo'),
        update: ()=>$3995d1230bc1e17d$var$showDummyAPIWarning('doc:update')
    }
};
async function $3995d1230bc1e17d$export$6b0bb34c2583056f(extensionProvider, editorActions, apiRef, createAnalyticsEvent) {
    const extensions = await extensionProvider.getExtensions();
    return {
        getItems: ()=>{
            const quickInsertItems = (0, $g3VjK.getQuickInsertItemsFromModule)(extensions, (item)=>{
                const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
                    loader: item.icon,
                    loading: ()=>null
                });
                return {
                    // Add module key so typeahead/quick-insert can identify items
                    // **locale-agnostically**! nb: we _already_ send key in analytics
                    // events, this standardises and makes our items more predictable.
                    ...(0, $eGOwo.fg)('confluence-whiteboards-quick-insert-l10n-eligible') && {
                        key: item.key
                    },
                    title: item.title,
                    description: item.description,
                    icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                            label: ""
                        }),
                    keywords: item.keywords,
                    featured: item.featured,
                    ...(0, $eGOwo.fg)('cc_fd_wb_create_priority_in_slash_menu_enabled') && {
                        priority: item.priority
                    },
                    categories: item.categories,
                    isDisabledOffline: true,
                    action: (insert, state, source)=>{
                        if (typeof item.node === 'function') {
                            const extensionAPI = apiRef?.current?.extension?.actions?.api();
                            // While this should only run when the extension some setups of editor
                            // may not have the extension API
                            if (extensionAPI) (0, $l3kPA.resolveImport)(item.node(extensionAPI)).then((node)=>{
                                $3995d1230bc1e17d$var$sendExtensionQuickInsertAnalytics(item, state.selection, createAnalyticsEvent, source);
                                if (node) editorActions.replaceSelection(node);
                            });
                            else // Originally it was understood we could only use this if we were using the extension plugin
                            // However there are some edge cases where this is not true (ie. in jira)
                            // Since making it optional now would be a breaking change - instead we can just pass a dummy
                            // extension API to consumers that warns them of using the methods.
                            (0, $l3kPA.resolveImport)(item.node($3995d1230bc1e17d$var$dummyExtensionAPI)).then((node)=>{
                                $3995d1230bc1e17d$var$sendExtensionQuickInsertAnalytics(item, state.selection, createAnalyticsEvent, source);
                                if (node) editorActions.replaceSelection(node);
                            });
                            return insert('');
                        } else {
                            $3995d1230bc1e17d$var$sendExtensionQuickInsertAnalytics(item, state.selection, createAnalyticsEvent, source);
                            return insert(item.node);
                        }
                    }
                };
            });
            return Promise.all(quickInsertItems);
        }
    };
}
async function $3995d1230bc1e17d$export$e3759a254d73dcb7(quickInsertProviders) {
    const { invokeList: invokeList } = (0, $alidL.default)(quickInsertProviders);
    return {
        getItems () {
            return invokeList('getItems');
        }
    };
}

});
parcelRegister("g3VjK", function(module, exports) {
$parcel$export(module.exports, "getQuickInsertItemsFromModule", () => $229d3d4e66a244b5$export$a1d0004a197b97a3);
$parcel$export(module.exports, "getAutoConvertPatternsFromModule", () => $229d3d4e66a244b5$export$60407594ea5edd1c);
$parcel$export(module.exports, "getExtensionAutoConvertersFromProvider", () => $229d3d4e66a244b5$export$38a3a11e6509754a);
$parcel$export(module.exports, "getContextualToolbarItemsFromModule", () => $229d3d4e66a244b5$export$9d13b95c50a2a6c9);

var $eGOwo = parcelRequire("eGOwo");

var $l3kPA = parcelRequire("l3kPA");
const $229d3d4e66a244b5$export$3f063810d7bf01bd = (arr, attr, keyRenamer)=>// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    arr.reduce((acc, item)=>{
        acc[keyRenamer(item[attr])] = item;
        return acc;
    }, {});
function $229d3d4e66a244b5$export$30871400b97708b4(manifest, extensionModule) {
    const title = extensionModule.title || manifest.title;
    const key = `${manifest.key}:${extensionModule.key}`;
    const node = (0, $l3kPA.buildAction)(extensionModule.action, manifest);
    if (!node) throw new Error(`Couldn't find any action for ${title} (${key})`);
    return {
        key: key,
        title: title,
        extensionType: manifest.type,
        extensionKey: manifest.key,
        keywords: extensionModule.keywords || manifest.keywords || [],
        featured: extensionModule.featured || false,
        categories: extensionModule.categories || manifest.categories || [],
        description: extensionModule.description || manifest.description,
        summary: manifest.summary,
        documentationUrl: manifest.documentationUrl,
        ...(0, $eGOwo.fg)('cc_fd_wb_create_priority_in_slash_menu_enabled') && {
            priority: extensionModule.priority
        },
        icon: extensionModule.icon || manifest.icons['48'],
        node: node
    };
}
const $229d3d4e66a244b5$export$a1d0004a197b97a3 = (extensions, transformFunction)=>{
    const items = extensions.map((manifest)=>{
        const modules = manifest.modules.quickInsert || [];
        return modules.map((extensionModule)=>$229d3d4e66a244b5$export$30871400b97708b4(manifest, extensionModule));
    });
    const flatItems = [].concat(...items);
    return flatItems.map(transformFunction);
};
async function $229d3d4e66a244b5$export$60407594ea5edd1c(extensions) {
    const items = await Promise.all(// Ignored via go/ees005
    // eslint-disable-next-line require-await
    extensions.map(async (manifest)=>{
        if (manifest.modules.autoConvert && manifest.modules.autoConvert.url) return manifest.modules.autoConvert.url;
        return [];
    }));
    return [].concat(...items);
}
const $229d3d4e66a244b5$export$5ae7aa0814ef4090 = (autoConvertHandlers)=>(text)=>{
        for (const handler of autoConvertHandlers){
            const result = handler(text);
            if (result) return result;
        }
    };
async function $229d3d4e66a244b5$export$38a3a11e6509754a(extensionProviderPromise) {
    const extensionProvider = await extensionProviderPromise;
    const extensionAutoConverters = await extensionProvider.getAutoConverter();
    return $229d3d4e66a244b5$export$5ae7aa0814ef4090(extensionAutoConverters);
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $229d3d4e66a244b5$var$logError = (msg, ...args)=>{
    // eslint-disable-next-line no-console
    console.error(msg, ...args);
};
const $229d3d4e66a244b5$var$toolbarItemToButtonConfig = (toolbarButton, parentKey)=>{
    const { tooltip: tooltip, tooltipStyle: tooltipStyle, key: key, label: label, ariaLabel: ariaLabel, icon: icon, action: action, disabled: disabled } = toolbarButton;
    const itemKey = [
        parentKey,
        key
    ].join(':');
    if (typeof action !== 'function') $229d3d4e66a244b5$var$logError(`Provided action is not a function for extension toolbar button: ${label} (${itemKey})`);
    let labelAndIcon = {};
    switch(toolbarButton.display){
        case 'icon':
            if (!icon) $229d3d4e66a244b5$var$logError(`icon should be provided for extension toolbar button (${itemKey}), when display is set to 'icon'`);
            labelAndIcon = {
                icon: icon
            };
            break;
        case 'label':
            if (!label) $229d3d4e66a244b5$var$logError(`label should be provided for extension toolbar button (${itemKey}), when display is set to 'label'`);
            labelAndIcon = {
                label: label
            };
            break;
        default:
            if (!label || !icon) $229d3d4e66a244b5$var$logError(`label and icon should be provided for extension toolbar button (${itemKey}), when display is not set or set to 'icon-and-label'`);
            labelAndIcon = {
                icon: icon,
                label: label
            };
            break;
    }
    return {
        key: itemKey,
        ariaLabel: ariaLabel,
        tooltip: tooltip,
        tooltipStyle: tooltipStyle,
        action: action,
        disabled: disabled,
        ...labelAndIcon
    };
};
const $229d3d4e66a244b5$var$compareContext = (contextA, contextB)=>{
    if (contextA.type === contextB.type && contextA.nodeType === contextB.nodeType) {
        if (contextA.type === 'node') return true;
        if (contextA.type === 'extension' && contextB.type === 'extension') return contextA.extensionKey === contextB.extensionKey && contextA.extensionType === contextB.extensionType;
    }
    return false;
};
const $229d3d4e66a244b5$var$hasDuplicateContext = (contextualToolbars)=>{
    if (contextualToolbars.length > 1) {
        const contexts = contextualToolbars.map((contextualToolbar)=>contextualToolbar.context);
        return contexts.find((currentContext, currentIndex)=>currentIndex !== contexts.findIndex((context)=>$229d3d4e66a244b5$var$compareContext(currentContext, context)));
    }
};
const $229d3d4e66a244b5$export$9d13b95c50a2a6c9 = (extensions, node, api)=>{
    return extensions.map((extension)=>{
        if (extension.modules.contextualToolbars) {
            const duplicateContext = $229d3d4e66a244b5$var$hasDuplicateContext(extension.modules.contextualToolbars);
            if (duplicateContext) {
                $229d3d4e66a244b5$var$logError(`[contextualToolbars] Duplicate context detected - ${JSON.stringify(duplicateContext)}.`);
                return [];
            }
            return extension.modules.contextualToolbars.map((contextualToolbar)=>{
                if ($229d3d4e66a244b5$var$shouldAddExtensionItemForNode(contextualToolbar, node)) {
                    const { toolbarItems: toolbarItems } = contextualToolbar;
                    if (typeof toolbarItems === 'function') return toolbarItems(node, api);
                    return toolbarItems;
                }
                return [];
            }).flatMap((toolbarItems)=>toolbarItems.map((toolbarItem)=>{
                    if ($229d3d4e66a244b5$var$isToolbarButton(toolbarItem)) return $229d3d4e66a244b5$var$toolbarItemToButtonConfig(toolbarItem, extension.key);
                    return toolbarItem;
                }));
        }
        return [];
    }).flatMap((extensionToolbarButtons)=>extensionToolbarButtons);
};
const $229d3d4e66a244b5$var$isToolbarButton = (toolbarItem)=>{
    if ('type' in toolbarItem) return false;
    return true;
};
// defines whether to add toolbar item for the given node
function $229d3d4e66a244b5$var$shouldAddExtensionItemForNode(item, node) {
    // if item type is a standard node - should match the nodeType
    if (item.context.type === 'node' && item.context.nodeType === node.type) return true;
    // for other cases should be an extension and match the nodeType ("extension" | "inlineExtension" | "bodiedExtension" | "multiBodiedExtension")
    if (item.context.type !== 'extension' || node.type !== item.context.nodeType) return false;
    // in cases where we need custom exclusion depending on the node
    if (item.context.shouldExclude) {
        if (item.context.shouldExclude(node)) return false;
    }
    const { extensionType: extensionType, extensionKey: extensionKey } = item.context;
    // if extension type is given - should match extension type
    if (extensionType && extensionType !== node.attrs?.extensionType) return false;
    // if extension key is a string
    if (typeof extensionKey === 'string') return extensionKey === node.attrs?.extensionKey;
    // if extension key is an array
    if (Array.isArray(extensionKey) && extensionKey.length) return extensionKey.includes(node.attrs?.extensionKey);
    return false;
}

});



parcelRegister("cenXl", function(module, exports) {
$parcel$export(module.exports, "default", () => $dede0867f120b1e2$export$2e2bcd8739ae039);
function $dede0867f120b1e2$export$2e2bcd8739ae039({ autoformattingProvider: autoformattingProvider, emojiProvider: emojiProvider, mentionProvider: mentionProvider, legacyImageUploadProvider: legacyImageUploadProvider, taskDecisionProvider: taskDecisionProvider, contextIdentifierProvider: contextIdentifierProvider, searchProvider: searchProvider, macroProvider: macroProvider, activityProvider: activityProvider, collabEdit: collabEdit, collabEditProvider: collabEditProvider, presenceProvider: presenceProvider }) {
    return {
        emojiProvider: emojiProvider,
        mentionProvider: mentionProvider,
        autoformattingProvider: autoformattingProvider,
        activityProvider: activityProvider,
        imageUploadProvider: legacyImageUploadProvider,
        taskDecisionProvider: taskDecisionProvider,
        contextIdentifierProvider: contextIdentifierProvider,
        searchProvider: searchProvider,
        presenceProvider: presenceProvider,
        macroProvider: macroProvider,
        collabEditProvider: collabEdit?.provider ? collabEdit.provider : collabEditProvider
    };
}

});

parcelRegister("aipJ3", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0281c993a8017a7$export$2e2bcd8739ae039);
function $f0281c993a8017a7$export$2e2bcd8739ae039(providerFactory, { mentionProvider: mentionProvider, contextIdentifierProvider: contextIdentifierProvider, collabEditProvider: collabEditProvider, activityProvider: activityProvider, presenceProvider: presenceProvider, macroProvider: macroProvider, imageUploadProvider: imageUploadProvider, searchProvider: searchProvider }, extensionProvider, quickInsertProvider) {
    providerFactory.setProvider('mentionProvider', mentionProvider);
    providerFactory.setProvider('contextIdentifierProvider', contextIdentifierProvider);
    providerFactory.setProvider('imageUploadProvider', imageUploadProvider);
    providerFactory.setProvider('collabEditProvider', collabEditProvider);
    providerFactory.setProvider('activityProvider', activityProvider);
    providerFactory.setProvider('searchProvider', searchProvider);
    providerFactory.setProvider('presenceProvider', presenceProvider);
    providerFactory.setProvider('macroProvider', macroProvider);
    if (extensionProvider) providerFactory.setProvider('extensionProvider', Promise.resolve(extensionProvider));
    if (quickInsertProvider) providerFactory.setProvider('quickInsertProvider', quickInsertProvider);
}

});



parcelRegister("5bg1T", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef3f63f387936899$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $cxXTK = parcelRequire("cxXTK");

var $eGOwo = parcelRequire("eGOwo");

var $7XjxI = parcelRequire("7XjxI");

var $gyhYD = parcelRequire("gyhYD");

var $52GJU = parcelRequire("52GJU");
function $ef3f63f387936899$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ef3f63f387936899$var$scrollbarStylesNew = {
    name: "3owfxy",
    styles: "-ms-overflow-style:-ms-autohiding-scrollbar;&::-webkit-scrollbar-corner{display:none;}&::-webkit-scrollbar-thumb{background-color:var(--ds-background-neutral-subtle, #00000000);}&:hover::-webkit-scrollbar-thumb{background-color:var(--ds-background-neutral-bold, #44546F);border-radius:var(--ds-radius-large, 8px);}&::-webkit-scrollbar-thumb:hover{background-color:var(--ds-background-neutral-bold-hovered, #2C3E5D);}"
};
const $ef3f63f387936899$var$chromelessEditorStylesNew = {
    name: "1236vqr",
    styles: "line-height:20px;height:auto;overflow-x:hidden;overflow-y:auto;max-width:inherit;box-sizing:border-box;word-wrap:break-word;div > .ProseMirror{outline:none;white-space:pre-wrap;padding:0;margin:0;& > :last-child{padding-bottom:var(--ds-space-100, 0.5em);}}"
};
const $ef3f63f387936899$var$extraSpaceLastLineFix = {
    name: "1cghcav",
    styles: ".ProseMirror{& > p:last-of-type{margin-bottom:var(--ds-space-0, 0px);}}"
};
class $ef3f63f387936899$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.displayName = 'ChromelessEditorAppearance';
    }
    render() {
        return /*#__PURE__*/ (0, $1NIU8.jsx)($ef3f63f387936899$var$RenderWithPluginState, {
            editorAPI: this.props.editorAPI,
            renderChrome: this.renderChrome
        });
    }
    constructor(...args){
        super(...args), this.appearance = 'chromeless', this.containerElement = null, this.renderChrome = ({ maxContentSize: maxContentSize })=>{
            const { editorDOMElement: editorDOMElement, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, contentComponents: contentComponents, customContentComponents: customContentComponents, maxHeight: maxHeight, minHeight: minHeight = 30, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginHooks: pluginHooks, featureFlags: featureFlags } = this.props;
            const maxContentSizeReached = Boolean(maxContentSize?.maxContentSizeReached);
            const editorViewMode = (0, $cxXTK.useSharedPluginStateWithSelector)(this.props.editorAPI, [
                'editorViewMode'
            ], (states)=>states?.editorViewModeState?.mode);
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $52GJU.default), {
                animate: maxContentSizeReached
            }, /*#__PURE__*/ (0, $1NIU8.jsx)($ef3f63f387936899$export$5ffd32ebea3773c5, {
                maxHeight: maxHeight,
                minHeight: minHeight,
                containerRef: (ref)=>this.containerElement = ref
            }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $7XjxI.default), {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: "ak-editor-content-area",
                featureFlags: featureFlags,
                viewMode: editorViewMode,
                appearance: this.appearance
            }, customContentComponents && 'before' in customContentComponents ? customContentComponents.before : customContentComponents, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $gyhYD.default), {
                editorView: editorView,
                editorActions: editorActions,
                eventDispatcher: eventDispatcher,
                providerFactory: providerFactory,
                appearance: this.appearance,
                items: contentComponents,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                containerElement: this.containerElement,
                disabled: !!disabled,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                wrapperElement: this.containerElement,
                pluginHooks: pluginHooks
            }), editorDOMElement, customContentComponents && 'after' in customContentComponents ? customContentComponents.after : null)));
        };
    }
}
function $ef3f63f387936899$var$RenderWithPluginState({ renderChrome: renderChrome, editorAPI: editorAPI }) {
    const maxContentSizeReached = (0, $cxXTK.useSharedPluginStateWithSelector)(editorAPI, [
        'maxContentSize'
    ], (states)=>states?.maxContentSizeState?.maxContentSizeReached);
    const maxContentSize = maxContentSizeReached === undefined ? undefined : {
        maxContentSizeReached: maxContentSizeReached
    };
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, renderChrome({
        maxContentSize: maxContentSize
    }));
}
function $ef3f63f387936899$export$5ffd32ebea3773c5({ maxHeight: maxHeight, minHeight: minHeight, children: children, containerRef: containerRef }) {
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            $ef3f63f387936899$var$chromelessEditorStylesNew,
            $ef3f63f387936899$var$scrollbarStylesNew,
            (0, $eGOwo.fg)('platform_fix_extra_space_last_line_comment_editor') && $ef3f63f387936899$var$extraSpaceLastLineFix
        ],
        style: {
            maxHeight: maxHeight ? `${maxHeight}px` : undefined,
            minHeight: `${minHeight}px`
        },
        "data-testid": "chromeless-editor",
        id: "chromeless-editor",
        ref: containerRef
    }, children);
}

});
parcelRegister("cxXTK", function(module, exports) {
$parcel$export(module.exports, "useSharedPluginStateWithSelector", () => $a66d3b38505e578c$export$e5d623015ec283cc);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");
/**
 *
 * Directly map object values
 *
 * @private
 * @param object The object to transform
 * @param mapFunction The function to map an old value to new one
 * @returns Object with the same key but transformed values
 *
 */ function $a66d3b38505e578c$var$mapValues(object, mapFunction) {
    return Object.entries(object).reduce((acc, [key, value])=>({
            ...acc,
            [key]: mapFunction(value)
        }), {});
}
// When we use the `useSharedPluginStateWithSelector` example: `useSharedPluginStateWithSelector(api, ['width'], selector)`
// it will re-render every time the component re-renders as the array "['width']" is seen as an update.
// This hook is used to prevent re-renders due to this.
function $a66d3b38505e578c$var$useStaticPlugins(plugins) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $eJOHy.useMemo)(()=>plugins, []);
}
function $a66d3b38505e578c$export$e5d623015ec283cc(injectionApi, plugins, selector) {
    const pluginNames = $a66d3b38505e578c$var$useStaticPlugins(plugins);
    const selectorRef = (0, $eJOHy.useRef)(selector);
    // Create a memoized object containing the named plugins
    const namedExternalPlugins = (0, $eJOHy.useMemo)(()=>pluginNames.reduce((acc, pluginName)=>({
                ...acc,
                [`${String(pluginName)}State`]: injectionApi?.[pluginName]
            }), {}), [
        injectionApi,
        pluginNames
    ]);
    return $a66d3b38505e578c$var$useSharedPluginStateInternal(namedExternalPlugins, selectorRef);
}
function $a66d3b38505e578c$var$useSharedPluginStateInternal(externalPlugins, selector) {
    const refStates = (0, $eJOHy.useRef)($a66d3b38505e578c$var$mapValues(externalPlugins, (value)=>value?.sharedState.currentState()));
    const [pluginStates, setPluginState] = (0, $eJOHy.useState)(()=>selector.current(refStates.current));
    const mounted = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useLayoutEffect)(()=>{
        const debouncedPluginStateUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(()=>{
            setPluginState((currentPluginStates)=>{
                const nextStates = selector.current({
                    ...refStates.current
                });
                if ($a66d3b38505e578c$var$shallowEqual(nextStates, currentPluginStates)) return currentPluginStates;
                return nextStates;
            });
        });
        // If we re-render this hook due to a change in the external
        // plugins we need to push a state update to ensure we have
        // the most current state.
        if (mounted.current) {
            refStates.current = $a66d3b38505e578c$var$mapValues(externalPlugins, (value)=>value?.sharedState.currentState());
            debouncedPluginStateUpdate();
        }
        const unsubs = Object.entries(externalPlugins).map(([pluginKey, externalPlugin])=>{
            return externalPlugin?.sharedState.onChange(({ nextSharedState: nextSharedState, prevSharedState: prevSharedState })=>{
                if (prevSharedState === nextSharedState) return;
                refStates.current[pluginKey] = nextSharedState;
                debouncedPluginStateUpdate();
            });
        });
        mounted.current = true;
        return ()=>{
            refStates.current = {};
            unsubs.forEach((cb)=>cb?.());
        };
    }, [
        externalPlugins,
        selector
    ]);
    return pluginStates;
}
function $a66d3b38505e578c$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for (const key of keysA){
        if (objA[key] !== objB[key]) return false;
    }
    return true;
}

});

parcelRegister("7XjxI", function(module, exports) {
$parcel$export(module.exports, "default", () => $42977f0494318a12$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");
var $loabE = parcelRequire("loabE");

var $7EdFW = parcelRequire("7EdFW");

var $laqWo = parcelRequire("laqWo");

var $7yBx7 = parcelRequire("7yBx7");

var $eGOwo = parcelRequire("eGOwo");

var $cbSL1 = parcelRequire("cbSL1");

var $9Letn = parcelRequire("9Letn");

var $92xoS = parcelRequire("92xoS");

var $g6YpQ = parcelRequire("g6YpQ");

var $58yRG = parcelRequire("58yRG");

var $dLePd = parcelRequire("dLePd");

var $g3IWD = parcelRequire("g3IWD");

var $jEh2r = parcelRequire("jEh2r");

var $dUP13 = parcelRequire("dUP13");

var $9C47H = parcelRequire("9C47H");

var $ifZIx = parcelRequire("ifZIx");

var $cnIgR = parcelRequire("cnIgR");

var $iOgo7 = parcelRequire("iOgo7");

var $kdwal = parcelRequire("kdwal");

var $9A6ET = parcelRequire("9A6ET");

var $bOenW = parcelRequire("bOenW");

var $hbiJU = parcelRequire("hbiJU");

var $ipdG9 = parcelRequire("ipdG9");

var $fGeMV = parcelRequire("fGeMV");

var $l61tR = parcelRequire("l61tR");

var $aZU0R = parcelRequire("aZU0R");

var $l1WmN = parcelRequire("l1WmN");

var $ftlkF = parcelRequire("ftlkF");

var $hgRND = parcelRequire("hgRND");

var $eXk0C = parcelRequire("eXk0C");

var $cni8p = parcelRequire("cni8p");

var $bVQOn = parcelRequire("bVQOn");

var $ivuYE = parcelRequire("ivuYE");

var $8lEWs = parcelRequire("8lEWs");

var $6tApo = parcelRequire("6tApo");

var $iFTJL = parcelRequire("iFTJL");

var $a9Tj3 = parcelRequire("a9Tj3");

var $9dvIW = parcelRequire("9dvIW");

var $d2E5F = parcelRequire("d2E5F");

var $jw6co = parcelRequire("jw6co");

var $51Rgo = parcelRequire("51Rgo");

var $bRDpM = parcelRequire("bRDpM");

var $02AzZ = parcelRequire("02AzZ");

var $g7Nsb = parcelRequire("g7Nsb");

var $5mW2j = parcelRequire("5mW2j");

var $ftB1y = parcelRequire("ftB1y");

var $khwCN = parcelRequire("khwCN");

var $famkW = parcelRequire("famkW");

var $krgOs = parcelRequire("krgOs");

var $bEDkR = parcelRequire("bEDkR");

var $6uQ8z = parcelRequire("6uQ8z");

var $cZpyt = parcelRequire("cZpyt");

var $iZ3Ak = parcelRequire("iZ3Ak");

var $2287P = parcelRequire("2287P");

var $8A2V5 = parcelRequire("8A2V5");

var $bHGrA = parcelRequire("bHGrA");

var $lOMXK = parcelRequire("lOMXK");

var $fdSLH = parcelRequire("fdSLH");

var $iBvA9 = parcelRequire("iBvA9");

var $l0XHK = parcelRequire("l0XHK");
const $42977f0494318a12$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
const $42977f0494318a12$var$alignMultipleWrappedImageInLayoutStyles = {
    '.ProseMirror [data-layout-section] [data-layout-column] > div': {
        // apply marginTop to wrapped mediaSingle that has preceding wrapped mediaSingle (even when there's gap cursor in between them)
        // Given the first wrapped mediaSingle in layout has 0 marginTop, this is needed to make sure fellow wrapped mediaSingle align with it horizontally
        '.mediaSingleView-content-wrap[layout^=wrap] + .mediaSingleView-content-wrap[layout^=wrap], .mediaSingleView-content-wrap[layout^=wrap] + .ProseMirror-gapcursor + .mediaSingleView-content-wrap[layout^=wrap]': {
            '.rich-media-item': {
                marginTop: 0
            }
        },
        // Due to the above rule, wrapped mediaSingle (not the first node in layout) that are followed by wrapped mediaSingle should also have 0 marginTop
        // so it's aligned with the following wrapped mediaSingle
        '.mediaSingleView-content-wrap[layout^=wrap]:has( + .mediaSingleView-content-wrap[layout^=wrap])': {
            '.rich-media-item': {
                marginTop: 0
            }
        }
    }
};
const $42977f0494318a12$var$firstWrappedMediaStyles = {
    '.ProseMirror': {
        // Remove gap between first wrapped mediaSingle and its fellow wrapped mediaSingle
        "& [layout^='wrap-']:has(+ [layout^='wrap-']), & [layout^='wrap-']:has(+ .ProseMirror-gapcursor + [layout^='wrap-'])": {
            [`& .${0, $laqWo.richMediaClassName}`]: {
                marginLeft: 0,
                marginRight: 0
            }
        }
    }
};
/**
 * EditorContentStyles is a wrapper component that applies styles to its children
 * based on the provided feature flags, view mode, and other props.
 * It uses Emotion for styling and supports scrollable content.
 *
 * This will be used in near future to replace the current editor content styles from index.tsx
 */ const $42977f0494318a12$var$EditorContentContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>{
    const { className: className, children: children, viewMode: viewMode, isScrollable: isScrollable, appearance: appearance, contentMode: contentMode } = props;
    const theme = (0, $loabE.u)();
    const { colorMode: colorMode } = (0, $58yRG.default)();
    const isFullPage = appearance === 'full-page' || appearance === 'full-width';
    const isComment = appearance === 'comment';
    const baseFontSize = (0, $dLePd.getBaseFontSize)(appearance, contentMode);
    const style = (0, $92xoS.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        '--ak-editor-base-font-size': `${(0, $7yBx7.editorFontSize)({
            theme: theme
        })}px`
    } : {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        '--ak-editor-base-font-size': `${(0, $7yBx7.editorFontSize)({
            theme: theme
        })}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        '--ak-editor--large-gutter-padding': `${(0, $7yBx7.akEditorGutterPaddingDynamic)()}px`
    };
    const browser = (0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $7EdFW.getBrowserInfo)() : (0, $7EdFW.browser);
    const allClassNames = [
        className
    ];
    if ((0, $g6YpQ.expVal)('platform_editor_resizer_cls_fix', 'isEnabled', false)) allClassNames.push('resizer-hover-zone-cls-fix');
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: allClassNames.join(' '),
        ref: ref,
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9C47H.baseStyles),
            // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $eGOwo.fg)('platform_editor_controls_increase_full_page_gutter') && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9C47H.editorLargeGutterPuddingBaseStylesEditorControls) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9C47H.editorLargeGutterPuddingBaseStyles),
            (0, $92xoS.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                exposure: true
            }) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9C47H.editorLargeGutterPuddingReducedBaseStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $l0XHK.whitespaceStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $6tApo.indentationStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $bEDkR.shadowStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $iFTJL.InlineNodeViewSharedStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.hideSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.hideCursorWhenHideSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.selectedNodeStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $hbiJU.cursorStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $cni8p.firstFloatingToolbarButtonStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $g7Nsb.placeholderTextStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $g7Nsb.placeholderStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') && (0, $g7Nsb.placeholderOverflowStyles),
            (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') && (0, $eGOwo.fg)('platform_editor_quick_insert_placeholder') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $g7Nsb.placeholderWrapStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $kdwal.codeBlockStyles),
            (0, $cbSL1.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $eGOwo.fg)('platform_editor_content_mode_button_mvp') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $kdwal.codeBlockStylesWithEmUnits),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            !(0, $eGOwo.fg)('platform_editor_fix_code_block_bg_color_in_macro_2') && (0, $kdwal.codeBgColorStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            !(0, $eGOwo.fg)('platform_editor_typography_ugc') && (0, $fGeMV.editorUGCTokensDefault),
            (0, $eGOwo.fg)('platform_editor_typography_ugc') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $fGeMV.editorUGCTokensRefreshed),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $cnIgR.blocktypeStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $eGOwo.fg)('platform_editor_typography_ugc') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $cnIgR.blocktypeStyles_fg_platform_editor_typography_ugc) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $cnIgR.blocktypeStyles_without_fg_platform_editor_typography_ugc),
            (0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $cnIgR.blocktypeStyles_fg_platform_editor_nested_dnd_styles_changes),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9A6ET.codeMarkStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $lOMXK.textColorStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $dUP13.backgroundColorStyles),
            (0, $cbSL1.expValEquals)('platform_editor_text_highlight_padding', 'isEnabled', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $dUP13.textHighlightPaddingStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $d2E5F.listsStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $eGOwo.fg)('aifc_create_enabled') && (0, $d2E5F.diffListStyles),
            // Condense vertical spacing between list items when content mode dense is active
            (0, $cbSL1.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $eGOwo.fg)('platform_editor_content_mode_button_mvp') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $d2E5F.getDenseListStyles)(baseFontSize),
            (0, $cbSL1.expValEquals)('cc_editor_ttvc_release_bundle_one', 'listLayoutShiftFix', true) && isFullPage && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $d2E5F.listsStylesMarginLayoutShiftFix),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $ftB1y.ruleStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $eGOwo.fg)('aifc_create_enabled') && (0, $6uQ8z.smartCardDiffStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $eGOwo.fg)('platform_editor_ai_aifc_patch_beta_2') && (0, $6uQ8z.showDiffDeletedNodeStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $jw6co.mediaStyles),
            (0, $cbSL1.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $eGOwo.fg)('platform_editor_content_mode_button_mvp') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $jw6co.mediaCaptionStyles),
            // merge firstWrappedMediaStyles with mediaStyles when clean up platform_editor_fix_media_in_renderer
            (0, $eGOwo.fg)('platform_editor_fix_media_in_renderer') && $42977f0494318a12$var$firstWrappedMediaStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $bHGrA.telepointerStyle),
            /* This needs to be after telepointer styles as some overlapping rules have equal specificity, and so the order is significant */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $bHGrA.telepointerColorAndCommonStyle),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $ivuYE.gapCursorStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $bRDpM.panelStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $bRDpM.nestedPanelBorderStylesMixin),
            (0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $bRDpM.panelStylesMixin_fg_platform_editor_nested_dnd_styles_changes),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $bRDpM.panelStylesMixin),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $51Rgo.mentionsStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8A2V5.tasksAndDecisionsStyles),
            // condense vertical spacing between tasks/decisions items when content mode dense is active
            (0, $cbSL1.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $eGOwo.fg)('platform_editor_content_mode_button_mvp') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8A2V5.getDenseTasksAndDecisionsStyles)(baseFontSize),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8lEWs.gridStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $ifZIx.blockMarksStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $ipdG9.dateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $ftlkF.getExtensionStyles)(contentMode),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $l1WmN.expandStyles),
            (0, $cbSL1.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $eGOwo.fg)('platform_editor_content_mode_button_mvp') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $l1WmN.getDenseExpandTitleStyles)(baseFontSize),
            (0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $l1WmN.expandStylesMixin_fg_platform_editor_nested_dnd_styles_changes) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $l1WmN.expandStylesMixin_without_fg_platform_editor_nested_dnd_styles_changes),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $eGOwo.fg)('platform-visual-refresh-icons') && (0, $l1WmN.expandStylesMixin_fg_platform_visual_refresh_icons),
            (0, $cbSL1.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $hgRND.findReplaceStylesNew) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $hgRND.findReplaceStyles),
            (0, $cbSL1.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) && (0, $eGOwo.fg)('platform_editor_find_codeblock_color_contrast_fix') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $hgRND.findReplaceStylesNewWithCodeblockColorContrastFix),
            !(0, $cbSL1.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) && (0, $eGOwo.fg)('platform_editor_find_codeblock_color_contrast_fix') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $hgRND.findReplaceStylesWithCodeblockColorContrastFix),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $fdSLH.textHighlightStyle),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8A2V5.decisionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9Letn.expValEqualsNoExposure)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8A2V5.taskItemStylesWithBlockTaskItem) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8A2V5.taskItemStyles),
            (0, $eGOwo.fg)('platform-visual-refresh-icons') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8A2V5.decisionIconWithVisualRefresh),
            !(0, $eGOwo.fg)('platform-visual-refresh-icons') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8A2V5.decisionIconWithoutVisualRefresh),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $cZpyt.statusStyles),
            (0, $eGOwo.fg)('platform-component-visual-refresh') ? (0, $9Letn.expValEqualsNoExposure)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $cZpyt.statusStylesMixin_fg_platform_component_visual_refresh_with_search_match) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $cZpyt.statusStylesMixin_fg_platform_component_visual_refresh) : (0, $9Letn.expValEqualsNoExposure)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $cZpyt.statusStylesMixin_without_fg_platform_component_visual_refresh_with_search_match) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $cZpyt.statusStylesMixin_without_fg_platform_component_visual_refresh),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $jEh2r.annotationStyles),
            (0, $9Letn.expValEqualsNoExposure)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? (0, $9Letn.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $6uQ8z.smartCardStylesWithSearchMatchAndBlockMenuDangerStyles) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $6uQ8z.smartCardStylesWithSearchMatch) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $6uQ8z.smartCardStyles),
            (0, $92xoS.editorExperiment)('platform_editor_preview_panel_responsiveness', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $6uQ8z.smartCardStylesWithSearchMatchAndPreviewPanelResponsiveness),
            ((0, $9Letn.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1') || (0, $92xoS.editorExperiment)('platform_editor_preview_panel_linking_exp', true)) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $6uQ8z.editorControlsSmartCardStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $l61tR.embedCardStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $iBvA9.unsupportedStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $5mW2j.resizerStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $a9Tj3.layoutBaseStyles),
            // merge alignMultipleWrappedImageInLayoutStyles with layoutBaseStyles when clean up platform_editor_fix_media_in_renderer
            (0, $eGOwo.fg)('platform_editor_fix_media_in_renderer') && $42977f0494318a12$var$alignMultipleWrappedImageInLayoutStyles,
            (0, $9Letn.expValEqualsNoExposure)('platform_synced_block', 'isEnabled', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $iZ3Ak.syncBlockStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $92xoS.editorExperiment)('advanced_layouts', true) && (0, $a9Tj3.layoutBaseStylesAdvanced),
            (0, $92xoS.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $a9Tj3.layoutSectionStylesAdvanced) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $a9Tj3.layoutSectionStylesNotAdvanced),
            (0, $92xoS.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $a9Tj3.layoutColumnStylesAdvanced) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $a9Tj3.layoutColumnStylesNotAdvanced),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $92xoS.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $a9Tj3.layoutSelectedStylesAdvanced) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $a9Tj3.layoutSelectedStylesNotAdvanced),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $92xoS.editorExperiment)('advanced_layouts', true) && (0, $a9Tj3.layoutColumnResponsiveStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $92xoS.editorExperiment)('advanced_layouts', true) && (0, $a9Tj3.layoutResponsiveBaseStyles),
            (0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $a9Tj3.layoutBaseStylesFixesUnderNestedDnDFG),
            (0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $a9Tj3.layoutColumnMartinTopFixesNew) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $a9Tj3.layoutColumnMartinTopFixesOld),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $6uQ8z.smartLinksInLivePagesStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $6uQ8z.linkingVisualRefreshV1Styles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $ipdG9.dateVanillaStyles),
            (0, $eGOwo.fg)('platform_editor_typography_ugc') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $cbSL1.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $eGOwo.fg)('platform_editor_content_mode_button_mvp') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $02AzZ.paragraphStylesWithScaledMargin) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $02AzZ.paragraphStylesUGCRefreshed) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $cbSL1.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $eGOwo.fg)('platform_editor_content_mode_button_mvp') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $02AzZ.paragraphStylesOldWithScaledMargin) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $02AzZ.paragraphStylesOld),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9dvIW.linkStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            browser.safari && (0, $d2E5F.listsStylesSafariFix),
            (0, $9Letn.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true) ? (0, $eGOwo.fg)('platform_editor_breakout_resizing_width_changes') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $5mW2j.pragmaticResizerStylesNew) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $5mW2j.pragmaticResizerStyles) : undefined,
            (0, $92xoS.editorExperiment)('advanced_layouts', true) && (0, $9Letn.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $5mW2j.pragmaticStylesLayoutFirstNodeResizeHandleFix),
            (0, $9Letn.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $5mW2j.pragmaticResizerStylesForTooltip),
            (0, $92xoS.editorExperiment)('platform_editor_preview_panel_responsiveness', true) && ((0, $92xoS.editorExperiment)('advanced_layouts', true) || (0, $9Letn.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true)) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $5mW2j.pragmaticResizerStylesWithReducedEditorGutter),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $g3IWD.aiPanelBaseStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            $42977f0494318a12$var$isFirefox && (0, $g3IWD.aiPanelBaseFirefoxStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            colorMode === 'dark' && (0, $g3IWD.aiPanelDarkStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            colorMode === 'dark' && $42977f0494318a12$var$isFirefox && (0, $g3IWD.aiPanelDarkFirefoxStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            viewMode === 'view' && (0, $a9Tj3.layoutStylesForView),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            viewMode === 'view' && (0, $92xoS.editorExperiment)('advanced_layouts', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $a9Tj3.layoutSelectedStylesForViewAdvanced),
            viewMode === 'view' && (0, $92xoS.editorExperiment)('advanced_layouts', false) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $a9Tj3.layoutSelectedStylesForViewNotAdvanced),
            viewMode === 'view' && (0, $92xoS.editorExperiment)('advanced_layouts', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $a9Tj3.layoutResponsiveStylesForView),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            isComment && (0, $bOenW.commentEditorStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            isComment && (0, $2287P.tableCommentEditorStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            isFullPage && (0, $bVQOn.fullPageEditorStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            isFullPage && (0, $khwCN.scrollbarStyles),
            (0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $kdwal.firstCodeBlockWithNoMargin) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $kdwal.firstCodeBlockWithNoMarginOld),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $eXk0C.firstBlockNodeStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $51Rgo.mentionNodeStyles),
            (0, $9Letn.expValEqualsNoExposure)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $51Rgo.mentionsSelectionStylesWithSearchMatch) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $51Rgo.mentionsSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $aZU0R.emojiStyles),
            // Dense emoji scaling based on base font size
            (0, $cbSL1.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $eGOwo.fg)('platform_editor_content_mode_button_mvp') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $aZU0R.getDenseEmojiStyles)(baseFontSize),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $bRDpM.panelViewStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $jw6co.mediaGroupStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $jw6co.mediaAlignmentStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $2287P.tableLayoutFixes),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $2287P.tableContainerStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            !(0, $eGOwo.fg)('platform_editor_table_container_y_overflow_fix') && (0, $2287P.tableContainerOverflowY),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9dvIW.hyperLinkFloatingToolbarStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            !(0, $eGOwo.fg)('platform-visual-refresh-icons') && (0, $9dvIW.linkLegacyIconStylesFix),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $eGOwo.fg)('confluence_floating_toolbar_animation') && (0, $krgOs.selectionToolbarAnimationStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $eGOwo.fg)('platform_editor_vanilla_codebidi_warning') && (0, $iOgo7.codeBidiWarningStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $g6YpQ.expValNoExposure)('platform_editor_block_menu', 'isEnabled', true) && [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $ipdG9.dangerDateStyles),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $aZU0R.emojiDangerStyles),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $51Rgo.mentionDangerStyles),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $8A2V5.decisionDangerStyles),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $cZpyt.statusDangerStyles),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $ftB1y.dangerRuleStyles),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $jw6co.mediaDangerStyles),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $bRDpM.nestedPanelDangerStyles)
            ]
        ],
        "data-editor-scroll-container": isScrollable ? 'true' : undefined,
        "data-testid": "editor-content-container",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        tabIndex: isScrollable ? 0 : undefined,
        role: isScrollable ? 'region' : undefined
    }, children);
});
var $42977f0494318a12$export$2e2bcd8739ae039 = $42977f0494318a12$var$EditorContentContainer;

});
parcelRegister("g3IWD", function(module, exports) {
$parcel$export(module.exports, "aiPanelBaseStyles", () => $699539a74131df67$export$7d2a5652980d3808);
$parcel$export(module.exports, "aiPanelBaseFirefoxStyles", () => $699539a74131df67$export$541b06daf7fd8fce);
$parcel$export(module.exports, "aiPanelDarkStyles", () => $699539a74131df67$export$9a2d17c0df63f635);
$parcel$export(module.exports, "aiPanelDarkFirefoxStyles", () => $699539a74131df67$export$18b242302a502e32);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");
/**
 * aiPanelStyles
 * was imported from packages/editor/editor-core/src/ui/ContentStyles/ai-panels.ts
 */ const $699539a74131df67$var$rotationAnimation = (0, $1NIU8.keyframes)({
    '0%': {
        '--panel-gradient-angle': '0deg'
    },
    '100%': {
        '--panel-gradient-angle': '360deg'
    }
});
const $699539a74131df67$var$rotationAnimationFirefox = (0, $1NIU8.keyframes)({
    '0%': {
        '--panel-gradient-angle': '0deg',
        backgroundPosition: '100%'
    },
    '100%': {
        '--panel-gradient-angle': '360deg',
        backgroundPosition: '-100%'
    }
});
const $699539a74131df67$var$aiPrismColor = {
    ['prism.border.step.1']: {
        light: '#0065FF',
        dark: '#0065FF80'
    },
    ['prism.border.step.2']: {
        light: '#0469FF',
        dark: '#0469FF80'
    },
    ['prism.border.step.3']: {
        light: '#BF63F3',
        dark: '#BF63F380'
    },
    ['prism.border.step.4']: {
        light: '#FFA900',
        dark: '#FFA90080'
    }
};
const $699539a74131df67$var$aiPrismColorStep1Light = $699539a74131df67$var$aiPrismColor['prism.border.step.1']['light'];
const $699539a74131df67$var$aiPrismColorStep2Light = $699539a74131df67$var$aiPrismColor['prism.border.step.2']['light'];
const $699539a74131df67$var$aiPrismColorStep3Light = $699539a74131df67$var$aiPrismColor['prism.border.step.3']['light'];
const $699539a74131df67$var$aiPrismColorStep4Light = $699539a74131df67$var$aiPrismColor['prism.border.step.4']['light'];
const $699539a74131df67$var$aiPrismColorStep1Dark = $699539a74131df67$var$aiPrismColor['prism.border.step.1']['dark'];
const $699539a74131df67$var$aiPrismColorStep2Dark = $699539a74131df67$var$aiPrismColor['prism.border.step.2']['dark'];
const $699539a74131df67$var$aiPrismColorStep3Dark = $699539a74131df67$var$aiPrismColor['prism.border.step.3']['dark'];
const $699539a74131df67$var$aiPrismColorStep4Dark = $699539a74131df67$var$aiPrismColor['prism.border.step.4']['dark'];
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $699539a74131df67$var$prismBorderBaseBackgroundFirefox = `linear-gradient(90deg, ${$699539a74131df67$var$aiPrismColorStep1Light} 0%, ${$699539a74131df67$var$aiPrismColorStep2Light} 12%, ${$699539a74131df67$var$aiPrismColorStep3Light} 24%, ${$699539a74131df67$var$aiPrismColorStep4Light} 48%, ${$699539a74131df67$var$aiPrismColorStep3Light} 64%, ${$699539a74131df67$var$aiPrismColorStep2Light} 80%, ${$699539a74131df67$var$aiPrismColorStep1Light} 100%)`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $699539a74131df67$var$prismBorderBaseBackground = `conic-gradient(from var(--panel-gradient-angle, 270deg), ${$699539a74131df67$var$aiPrismColorStep1Light} 0%, ${$699539a74131df67$var$aiPrismColorStep2Light} 20%, ${$699539a74131df67$var$aiPrismColorStep3Light} 50%, ${$699539a74131df67$var$aiPrismColorStep4Light} 56%, ${$699539a74131df67$var$aiPrismColorStep1Light} 100%)`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $699539a74131df67$var$prismBorderDarkBackgroundFirefox = `linear-gradient(90deg, ${$699539a74131df67$var$aiPrismColorStep1Dark} 0%, ${$699539a74131df67$var$aiPrismColorStep2Dark} 12%, ${$699539a74131df67$var$aiPrismColorStep3Dark} 24%, ${$699539a74131df67$var$aiPrismColorStep4Dark} 48%, ${$699539a74131df67$var$aiPrismColorStep3Dark} 64%, ${$699539a74131df67$var$aiPrismColorStep2Dark} 80%, ${$699539a74131df67$var$aiPrismColorStep1Dark} 100%)`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $699539a74131df67$var$prismBorderDarkBackground = `conic-gradient(from var(--panel-gradient-angle, 270deg), ${$699539a74131df67$var$aiPrismColorStep1Dark} 0%, ${$699539a74131df67$var$aiPrismColorStep2Dark} 20%, ${$699539a74131df67$var$aiPrismColorStep3Dark} 50%, ${$699539a74131df67$var$aiPrismColorStep4Dark} 56%, ${$699539a74131df67$var$aiPrismColorStep1Dark} 100%)`;
const $699539a74131df67$export$7d2a5652980d3808 = /*#__PURE__*/ (0, $1NIU8.css)({
    '@property --panel-gradient-angle': {
        syntax: '<angle>',
        initialValue: '270deg',
        inherits: false
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensionType="com.atlassian.ai-blocks"]': {
        /* This hides the label for the extension */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-label': {
            display: 'none'
        },
        /* This styles the ai panel correctly when its just sitting on the page and there
    is no user interaction */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            position: 'relative',
            boxShadow: 'none',
            overflow: 'unset',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            backgroundColor: `${"var(--ds-surface, #FFFFFF)"} !important`,
            // prismBorderBaseStyles
            '&::before, &::after': {
                content: "''",
                position: 'absolute',
                zIndex: -1,
                width: `calc(100% + 2px)`,
                height: `calc(100% + 2px)`,
                top: `-1px`,
                left: `-1px`,
                borderRadius: `calc(${"var(--ds-radius-small, 3px)"} + 1px)`,
                transform: 'translate3d(0, 0, 0)',
                background: $699539a74131df67$var$prismBorderBaseBackground
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.with-hover-border': {
                '&::before, &::after': {
                    //prismBorderHoverStyles
                    background: "var(--ds-border-input, #8590A2)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& .with-margin-styles': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                backgroundColor: `${"var(--ds-surface, #FFFFFF)"} !important`,
                borderRadius: "var(--ds-radius-small, 3px)"
            }
        }
    },
    /* This styles the ai panel correctly when its streaming */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    'div[extensionType="com.atlassian.ai-blocks"]:has(.streaming)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            '&::before, &::after': {
                // prismBorderAnimationStyles
                animationName: $699539a74131df67$var$rotationAnimation,
                animationDuration: '2s',
                animationTimingFunction: 'linear',
                animationIterationCount: 'infinite',
                '@media (prefers-reduced-motion)': {
                    animation: 'none'
                }
            }
        }
    },
    /* This styles the ai panel correctly when a user is hovering over the delete button in the floating panel */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensionType="com.atlassian.ai-blocks"].danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
        }
    },
    /* This removes the margin from the action list when inside an ai panel */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensiontype="com.atlassian.ai-blocks"][extensionkey="ai-action-items-block:aiActionItemsBodiedExtension"]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'div[data-node-type="actionList"]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            margin: '0 !important'
        }
    }
});
const $699539a74131df67$export$541b06daf7fd8fce = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensionType="com.atlassian.ai-blocks"]': {
        '&::before, &::after': {
            background: $699539a74131df67$var$prismBorderBaseBackgroundFirefox,
            backgroundSize: '200%'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    'div[extensionType="com.atlassian.ai-blocks"]:has(.streaming)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            '&::before, &::after': {
                animationName: $699539a74131df67$var$rotationAnimationFirefox,
                animationDirection: 'normal',
                animationDuration: '1s'
            }
        }
    }
});
const $699539a74131df67$export$9a2d17c0df63f635 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensionType="com.atlassian.ai-blocks"]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            '&::before, &::after': {
                background: $699539a74131df67$var$prismBorderDarkBackground
            }
        }
    }
});
const $699539a74131df67$export$18b242302a502e32 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensionType="com.atlassian.ai-blocks"]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            '&::before, &::after': {
                background: $699539a74131df67$var$prismBorderDarkBackgroundFirefox,
                backgroundSize: '200%'
            }
        }
    }
});

});

parcelRegister("jEh2r", function(module, exports) {
$parcel$export(module.exports, "annotationStyles", () => $249babfc18f57823$export$65cde0a0b7e7c1c1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");

var $l8DE0 = parcelRequire("l8DE0");
const $249babfc18f57823$export$65cde0a0b7e7c1c1 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $l8DE0.AnnotationSharedClassNames).blur}, .${(0, $l8DE0.AnnotationSharedClassNames).focus}, .${(0, $l8DE0.AnnotationSharedClassNames).draft}, .${(0, $l8DE0.AnnotationSharedClassNames).hover}`]: {
            borderBottom: '2px solid transparent',
            cursor: 'pointer',
            padding: '1px 0 2px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has(.card), &:has([data-inline-card])': {
                padding: '5px 0 3px 0'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has(.date-lozenger-container)': {
                paddingTop: "var(--ds-space-025, 2px)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $l8DE0.AnnotationSharedClassNames).focus}`]: {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $l8DE0.AnnotationSharedClassNames).draft}`]: {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)",
            cursor: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $l8DE0.AnnotationSharedClassNames).blur}`]: {
            background: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $l8DE0.AnnotationSharedClassNames).hover}`]: {
            background: "var(--ds-background-accent-yellow-subtlest-hovered, #F8E6A0)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"
        }
    }
});

});
parcelRegister("l8DE0", function(module, exports) {
$parcel$export(module.exports, "AnnotationSharedClassNames", () => $699ed6094ac331bd$export$b0aeb22a160e5b4c);
$parcel$export(module.exports, "BlockAnnotationSharedClassNames", () => $699ed6094ac331bd$export$ac15f3ad21fefeac);
const $699ed6094ac331bd$export$6d0ce11e3a04da25 = 'ak-editor-annotation';
const $699ed6094ac331bd$export$b0aeb22a160e5b4c = {
    focus: `${$699ed6094ac331bd$export$6d0ce11e3a04da25}-focus`,
    blur: `${$699ed6094ac331bd$export$6d0ce11e3a04da25}-blur`,
    draft: `${$699ed6094ac331bd$export$6d0ce11e3a04da25}-draft`,
    hover: `${$699ed6094ac331bd$export$6d0ce11e3a04da25}-hover`
};
const $699ed6094ac331bd$export$3600479d19dfa7a9 = 'ak-editor-block-annotation';
const $699ed6094ac331bd$export$ac15f3ad21fefeac = {
    focus: `${$699ed6094ac331bd$export$3600479d19dfa7a9}-focus`,
    blur: `${$699ed6094ac331bd$export$3600479d19dfa7a9}-blur`,
    draft: `${$699ed6094ac331bd$export$3600479d19dfa7a9}-draft`
};

});


parcelRegister("dUP13", function(module, exports) {
$parcel$export(module.exports, "textHighlightPaddingStyles", () => $024bfa874c46c3b7$export$a365082c2a191514);
$parcel$export(module.exports, "backgroundColorStyles", () => $024bfa874c46c3b7$export$e4cca17cf56e99d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $024bfa874c46c3b7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $024bfa874c46c3b7$export$a365082c2a191514 = {
    name: "nf8qu5",
    styles: ".fabric-background-color-mark:has(.background-color-padding-left){padding-left:var(--ds-space-025, 2px);margin-left:var(--ds-space-negative-025, -2px);}.fabric-background-color-mark:has(.background-color-padding-right){padding-right:var(--ds-space-025, 2px);margin-right:var(--ds-space-negative-025, -2px);}"
};
const $024bfa874c46c3b7$export$e4cca17cf56e99d = {
    name: "yf96ao",
    styles: ".fabric-background-color-mark{background-color:var(--custom-palette-color, inherit);border-radius:var(--ds-radius-xsmall, 2px);padding-top:1px;padding-bottom:2px;box-decoration-break:clone;}a .fabric-background-color-mark{background-color:unset;}.fabric-background-color-mark .ak-editor-annotation{background-color:unset;}"
};

});

parcelRegister("9C47H", function(module, exports) {
$parcel$export(module.exports, "baseStyles", () => $4385740eaa5c2877$export$6a08aa478781aaec);
$parcel$export(module.exports, "editorLargeGutterPuddingBaseStyles", () => $4385740eaa5c2877$export$9e26088fca9327a2);
$parcel$export(module.exports, "editorLargeGutterPuddingBaseStylesEditorControls", () => $4385740eaa5c2877$export$cc6d483a79f2d275);
$parcel$export(module.exports, "editorLargeGutterPuddingReducedBaseStyles", () => $4385740eaa5c2877$export$23029c6a73ca6b8c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");
function $4385740eaa5c2877$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// = akEditorDefaultLayoutWidth * breakoutWideScaleRatio = 1010.8 ~ 1011 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is > 1329px.
const $4385740eaa5c2877$var$akEditorCalculatedWideLayoutWidth = 1011;
// from breakoutConsts.calcWideWidth, layoutMaxWidth * breakoutConsts.wideScaleRatio = 904.8 ~ 905 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is <= 1266px.
const $4385740eaa5c2877$var$akEditorCalculatedWideLayoutWidthSmallViewport = 905;
const $4385740eaa5c2877$var$akEditorGutterPadding = 32;
const $4385740eaa5c2877$var$akEditorDefaultLayoutWidth = 760;
const $4385740eaa5c2877$var$akEditorFullWidthLayoutWidth = 1800;
// The breakpoint for small devices is 1266px, copied from getBreakpoint in platform/packages/editor/editor-common/src/ui/WidthProvider/index.tsx
const $4385740eaa5c2877$var$akEditorBreakpointForSmallDevice = `1266px`;
const $4385740eaa5c2877$var$akEditorGutterPaddingReduced = 24;
const $4385740eaa5c2877$var$akEditorFullPageNarrowBreakout = 600;
const $4385740eaa5c2877$export$6a08aa478781aaec = /*#__PURE__*/ (0, $1NIU8.css)({
    '--ak-editor--default-gutter-padding': `${$4385740eaa5c2877$var$akEditorGutterPadding}px`,
    '--ak-editor--default-layout-width': `${$4385740eaa5c2877$var$akEditorDefaultLayoutWidth}px`,
    '--ak-editor--resizer-handle-spacing': `12px`,
    '--ak-editor--full-width-layout-width': `${$4385740eaa5c2877$var$akEditorFullWidthLayoutWidth}px`,
    /* calculate editor line length, 100cqw is the editor container width */ '--ak-editor--line-length': 'min(calc(100cqw - var(--ak-editor--large-gutter-padding) * 2), var(--ak-editor--default-layout-width))',
    '--ak-editor--breakout-wide-layout-width': `${$4385740eaa5c2877$var$akEditorCalculatedWideLayoutWidthSmallViewport}px`,
    '--ak-editor--breakout-full-page-guttering-padding': 'calc(var(--ak-editor--large-gutter-padding) * 2 + var(--ak-editor--default-gutter-padding))',
    '--ak-editor--breakout-fallback-width': 'calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))',
    '--ak-editor--breakout-min-width': '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.fabric-editor--full-width-mode': {
        '--ak-editor--line-length': 'min(calc(100cqw - var(--ak-editor--large-gutter-padding) * 2), var(--ak-editor--full-width-layout-width))',
        /* in full width appearances it's not possible to rely on cqw because it doesn't account for the page scrollbar, which depends on users system settings */ '--ak-editor--breakout-fallback-width': '100%',
        '--ak-editor--breakout-min-width': '0px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        '--ak-editor-max-container-width': 'calc(100cqw - var(--ak-editor--large-gutter-padding))',
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 'var(--ak-editor-base-font-size)'
    },
    /* We can't allow nodes that are inside other nodes to bleed from the parent container */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror > div[data-prosemirror-node-block] [data-prosemirror-node-block]': {
        '--ak-editor-max-container-width': '100%'
    },
    /* container editor-area is defined in platform/packages/editor/editor-core/src/ui/Appearance/FullPage/StyledComponents.ts */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-unsafe-values
    [`@container editor-area (width >= ${$4385740eaa5c2877$var$akEditorBreakpointForSmallDevice})`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ProseMirror': {
            '--ak-editor--breakout-wide-layout-width': `${$4385740eaa5c2877$var$akEditorCalculatedWideLayoutWidth}px`
        }
    }
});
const $4385740eaa5c2877$export$9e26088fca9327a2 = {
    name: "ituy02",
    styles: "--ak-editor--large-gutter-padding:52px"
};
const $4385740eaa5c2877$export$cc6d483a79f2d275 = {
    name: "n99on3",
    styles: "--ak-editor--large-gutter-padding:72px"
};
const $4385740eaa5c2877$export$23029c6a73ca6b8c = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-unsafe-values
    [`@container editor-area (max-width: ${$4385740eaa5c2877$var$akEditorFullPageNarrowBreakout}px)`]: {
        '--ak-editor--large-gutter-padding': `${$4385740eaa5c2877$var$akEditorGutterPaddingReduced}px`
    }
});

});

parcelRegister("ifZIx", function(module, exports) {
$parcel$export(module.exports, "blockMarksStyles", () => $5934f9ed13f35a2d$export$e561f1e4e17b129d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
function $5934f9ed13f35a2d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5934f9ed13f35a2d$export$e561f1e4e17b129d = {
    name: "13r502m",
    styles: "*:not(.fabric-editor-block-mark) >, *:not(.fabric-editor-block-mark) > div.fabric-editor-block-mark:first-of-type:not(.fabric-editor-indentation-mark):not(.fabric-editor-alignment), .fabric-editor-alignment:first-of-type:first-child, .ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child{p, h1, h2, h3, h4, h5, h6, .heading-wrapper{&:first-child:not(style), style:first-child + *{margin-top:0;}}}"
};

});

parcelRegister("cnIgR", function(module, exports) {
$parcel$export(module.exports, "blocktypeStyles", () => $2c13caad1b2bf46d$export$610a2509037eaf6);
$parcel$export(module.exports, "blocktypeStyles_fg_platform_editor_typography_ugc", () => $2c13caad1b2bf46d$export$36460e974c9904b9);
$parcel$export(module.exports, "blocktypeStyles_without_fg_platform_editor_typography_ugc", () => $2c13caad1b2bf46d$export$4a8301858e3f950);
$parcel$export(module.exports, "blocktypeStyles_fg_platform_editor_nested_dnd_styles_changes", () => $2c13caad1b2bf46d$export$13d8dd04b9497c9a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");
function $2c13caad1b2bf46d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2c13caad1b2bf46d$export$610a2509037eaf6 = {
    name: "5lf82v",
    styles: ".ProseMirror{& blockquote{box-sizing:border-box;color:inherit;width:100%;display:inline-block;padding-left:var(--ds-space-200, 16px);border-left-width:var(--ds-border-width-selected, 2px);border-left-style:solid;border-left-color:var(--ds-border, #091E4224);margin:0.75rem 0 0 0;margin-right:0;[dir=\"rtl\"] &{padding-left:0;padding-right:var(--ds-space-200, 16px);}&:first-child{margin-top:0;}&::before{content:'';}&::after{content:none;}& p{display:block;}& table, & table:last-child{display:inline-table;}> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child{display:block;}> .extensionView-content-wrap:last-child{display:block;}}.fabric-editor-block-mark.fabric-editor-alignment:not(:first-child){> h1:first-child{margin-top:1.667em;}> h2:first-child{margin-top:1.8em;}> h3:first-child{margin-top:2em;}> h4:first-child{margin-top:1.357em;}> h5:first-child{margin-top:1.667em;}> h6:first-child{margin-top:1.455em;}}.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment{> :is(h1, h2, h3, h4, h5, h6):first-child{margin-top:0;}}}"
};
const $2c13caad1b2bf46d$export$36460e974c9904b9 = {
    name: "jrdqfj",
    styles: ".ProseMirror{& h1{font:var(--editor-font-ugc-token-heading-h1);margin-bottom:0;margin-top:1.45833em;& strong{font-weight:var(--editor-font-ugc-token-weight-heading-bold);}}& h2{font:var(--editor-font-ugc-token-heading-h2);margin-bottom:0;margin-top:1.4em;& strong{font-weight:var(--editor-font-ugc-token-weight-heading-bold);}}& h3{font:var(--editor-font-ugc-token-heading-h3);margin-bottom:0;margin-top:1.31249em;& strong{font-weight:var(--editor-font-ugc-token-weight-heading-bold);}}& h4{font:var(--editor-font-ugc-token-heading-h4);margin-top:1.25em;& strong{font-weight:var(--editor-font-ugc-token-weight-heading-bold);}}& h5{font:var(--editor-font-ugc-token-heading-h5);margin-top:1.45833em;text-transform:none;& strong{font-weight:var(--editor-font-ugc-token-weight-heading-bold);}}& h6{font:var(--editor-font-ugc-token-heading-h6);margin-top:1.59091em;text-transform:none;& strong{font-weight:var(--editor-font-ugc-token-weight-heading-bold);}}}"
};
const $2c13caad1b2bf46d$export$4a8301858e3f950 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& h1': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 'calc(24em / 14)',
            fontStyle: 'inherit',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'calc(28 / 24)',
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-medium, 500)",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            letterSpacing: `-0.01em`,
            marginBottom: 0,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '1.667em'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& h2': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 'calc(20em / 14)',
            fontStyle: 'inherit',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'calc(24 / 20)',
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-medium, 500)",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            letterSpacing: `-0.008em`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '1.8em',
            marginBottom: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& h3': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 'calc(16em / 14)',
            fontStyle: 'inherit',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'calc(20 / 16)',
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            letterSpacing: `-0.006em`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '2em',
            marginBottom: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& h4': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 'calc(14em / 14)',
            fontStyle: 'inherit',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'calc(16 / 14)',
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            letterSpacing: `-0.003em`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '1.357em'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& h5': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 'calc(12em / 14)',
            fontStyle: 'inherit',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'calc(16 / 12)',
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '1.667em',
            textTransform: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& h6': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 'calc(11em / 14)',
            fontStyle: 'inherit',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'calc(16 / 11)',
            color: "var(--ds-text-subtlest, #626F86)",
            fontWeight: "var(--ds-font-weight-bold, 700)",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '1.455em',
            textTransform: 'none'
        }
    }
});
const $2c13caad1b2bf46d$export$13d8dd04b9497c9a = {
    name: "18w6jtp",
    styles: ".ak-editor-content-area.appearance-full-page .ProseMirror blockquote{padding-left:var(--ds-space-250, 20px);}.ak-editor-content-area .ak-editor-content-area .ProseMirror blockquote{padding-left:var(--ds-space-200, 16px);}"
};

});

parcelRegister("iOgo7", function(module, exports) {
$parcel$export(module.exports, "codeBidiWarningStyles", () => $f4f2062210aa6838$export$98853831203df33a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");
const $f4f2062210aa6838$export$98853831203df33a = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="code-bidi-warning"]': {
        display: 'inline-block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="code-bidi-warning"] [data-bidi-component="code-bidi-warning-decorator"]': {
        paddingInlineStart: "var(--ds-space-050, 4px)",
        paddingInlineEnd: "var(--ds-space-050, 4px)",
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        fontStyle: 'normal',
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        paddingTop: '0.05rem',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        paddingBottom: '0.05rem',
        color: "var(--ds-text-warning, #A54800)",
        backgroundColor: "var(--ds-background-warning, #FFF7D6)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="code-bidi-warning"] [data-bidi-component="code-bidi-warning-decorator"]:hover': {
        color: "var(--ds-text-warning, #A54800)",
        backgroundColor: "var(--ds-background-warning-hovered, #F8E6A0)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="code-bidi-warning"] [data-bidi-component="code-bidi-warning-tooltip"]': {
        visibility: 'hidden',
        boxSizing: 'border-box',
        width: '15pc',
        backgroundColor: "var(--ds-background-neutral-bold, #44546F)",
        color: "var(--ds-text-inverse, #FFFFFF)",
        overflowWrap: 'break-word',
        cursor: 'default',
        borderRadius: "var(--ds-radius-small, 4px)",
        margin: "var(--ds-space-0, 0px)",
        padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-075, 6px)"}`,
        position: 'fixed',
        // The character label will be ~80px and this is positioned from the end of that label
        // We also use this instead of top: 24px to make sure the tooltip maintains its initial position
        // instead of being positioned relative to the viewport.
        // We need to use position: fixed so that the tooltip bypasses the overflow settings of the code block
        // and is always visible.
        // We also offset a little extra here to account for the transition behavior (to replicate ADS fade-in-from-top)
        transform: 'translate(calc(-50% - 40px), calc(24px - 4px))',
        opacity: 0,
        whiteSpace: 'normal',
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        zIndex: 9999,
        // Exit animation timings
        // - Mark invisible after 0.475s
        // - After 0.3s, fade out and move up over 0.175s
        transition: 'visibility 0s linear 0.475s, opacity 0.175s cubic-bezier(0.15,1,0.3,1) 0.3s, transform 0.175s cubic-bezier(0.15,1,0.3,1) 0.3s'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="code-bidi-warning"]:hover [data-bidi-component="code-bidi-warning-tooltip"]': {
        visibility: 'visible',
        transform: 'translate(calc(-50% - 40px), calc(24px))',
        opacity: 1,
        // Enter animation timings
        // - Mark visible after 0.3s of hovering
        // - After 0.3s, fade in over 0.175s
        // - After 0.3s, move down over 0.35s
        transition: 'visibility 0s linear 0.3s, opacity 0.175s cubic-bezier(0.15,1,0.3,1) 0.3s, transform 0.35s cubic-bezier(0.15,1,0.3,1) 0.3s'
    }
});

});

parcelRegister("kdwal", function(module, exports) {
$parcel$export(module.exports, "CodeBlockSharedCssClassName", () => $d6a88bda7f42404d$export$42659c26f026f6ea);
$parcel$export(module.exports, "codeBlockStyles", () => $d6a88bda7f42404d$export$4baaed2b257b830);
$parcel$export(module.exports, "codeBlockStylesWithEmUnits", () => $d6a88bda7f42404d$export$921fec04d268c00a);
$parcel$export(module.exports, "codeBgColorStyles", () => $d6a88bda7f42404d$export$107831225ad52bb4);
$parcel$export(module.exports, "firstCodeBlockWithNoMargin", () => $d6a88bda7f42404d$export$ddc3dd3ba723d1af);
$parcel$export(module.exports, "firstCodeBlockWithNoMarginOld", () => $d6a88bda7f42404d$export$50458a606d5c37d0);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");

var $jhoGk = parcelRequire("jhoGk");

var $famkW = parcelRequire("famkW");
function $d6a88bda7f42404d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d6a88bda7f42404d$export$42659c26f026f6ea = {
    CODEBLOCK_CONTAINER: 'code-block',
    CODEBLOCK_START: 'code-block--start',
    CODEBLOCK_END: 'code-block--end',
    CODEBLOCK_CONTENT_WRAPPER: 'code-block-content-wrapper',
    CODEBLOCK_LINE_NUMBER_GUTTER: 'line-number-gutter',
    CODEBLOCK_CONTENT: 'code-content',
    DS_CODEBLOCK: '[data-ds--code--code-block]',
    CODEBLOCK_CONTENT_WRAPPED: 'code-content--wrapped',
    CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET: 'code-content__line-number--wrapped'
};
const $d6a88bda7f42404d$var$fontSize14px = `${0.875}rem`;
const $d6a88bda7f42404d$var$blockNodesVerticalMargin = '0.75rem';
const $d6a88bda7f42404d$var$gutterDangerOverlay = {
    name: "110x2n0",
    styles: "&::after{height:100%;content:'';position:absolute;left:0;top:0;width:24px;background-color:var(--ds-blanket-danger, #EF5C4814);}"
};
const $d6a88bda7f42404d$export$4baaed2b257b830 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPED} > .${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER} > .${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_CONTENT}`]: {
            marginRight: "var(--ds-space-100, 8px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            code: {
                display: 'block',
                wordBreak: 'break-word',
                whiteSpace: 'pre-wrap'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER} > .${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_CONTENT}`]: {
            display: 'flex',
            flex: 1,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            code: {
                flexGrow: 1,
                whiteSpace: 'pre'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_CONTAINER}`]: {
            position: 'relative',
            backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
            borderRadius: "var(--ds-radius-small, 3px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            margin: `${$d6a88bda7f42404d$var$blockNodesVerticalMargin} 0 0 0`,
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            minWidth: 48,
            cursor: 'pointer',
            clear: 'both',
            // This is necessary to allow for arrow key navigation in/out of code blocks in Firefox.
            whiteSpace: 'normal',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.code-block-gutter-pseudo-element::before': {
                content: 'attr(data-label)'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_START}`]: {
                position: 'absolute',
                visibility: 'hidden',
                height: '1.5rem',
                top: 0,
                left: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_END}`]: {
                position: 'absolute',
                visibility: 'hidden',
                height: '1.5rem',
                bottom: 0,
                right: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER}`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $jhoGk.overflowShadowStyles),
                {
                    position: 'relative',
                    backgroundColor: "var(--ds-background-neutral, #091E420F)",
                    display: 'flex',
                    borderRadius: "var(--ds-radius-small, 3px)",
                    width: '100%',
                    counterReset: 'line',
                    overflowX: 'auto',
                    backgroundRepeat: 'no-repeat',
                    backgroundAttachment: 'local, local, local, local, scroll, scroll, scroll, scroll',
                    backgroundSize: `${"var(--ds-space-300, 24px)"} 100%,
	                         ${"var(--ds-space-300, 24px)"} 100%,
	                         ${"var(--ds-space-100, 8px)"} 100%,
	                         ${"var(--ds-space-100, 8px)"} 100%,
	                         ${"var(--ds-space-100, 8px)"} 100%,
	                         1px 100%,
	                         ${"var(--ds-space-100, 8px)"} 100%,
	                         1px 100%`,
                    backgroundPosition: `0 0,
	                             0 0,
                               100% 0,
                               100% 0,
                               100% 0,
                               100% 0,
	                             0 0,
	                             0 0`,
                    // Be careful if refactoring this; it is needed to keep arrow key navigation in Firefox consistent with other browsers.
                    overflowY: 'hidden'
                }
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER}`]: {
                backgroundColor: "var(--ds-background-neutral, #091E420F)",
                position: 'relative',
                width: 'var(--lineNumberGutterWidth, 2rem)',
                padding: "var(--ds-space-100, 8px)",
                flexShrink: 0,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: $d6a88bda7f42404d$var$fontSize14px,
                boxSizing: 'content-box'
            },
            // This is a fix of marker of list item with code block.
            // The list item marker in Chrome is aligned by the baseline of the text,
            // that's why we need to add a text (content: "1") to the line number gutter to align
            // the list item marker with the text.
            // Without it, the list item marker will be aligned by the bottom of the code block. */
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER}::before`]: {
                content: "'1'",
                visibility: 'hidden',
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: $d6a88bda7f42404d$var$fontSize14px,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                lineHeight: '1.5rem'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_CONTENT}`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                code: {
                    tabSize: 4,
                    cursor: 'text',
                    color: "var(--ds-text, #172B4D)",
                    borderRadius: "var(--ds-radius-small, 3px)",
                    margin: "var(--ds-space-100, 8px)",
                    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                    fontSize: $d6a88bda7f42404d$var$fontSize14px,
                    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                    lineHeight: '1.5rem'
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET}`]: {
                pointerEvents: 'none',
                userSelect: 'none',
                width: 'var(--lineNumberGutterWidth, 2rem)',
                left: 0,
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: $d6a88bda7f42404d$var$fontSize14px,
                padding: `0px ${"var(--ds-space-100, 8px)"}`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                lineHeight: '1.5rem',
                textAlign: 'right',
                color: "var(--ds-text-subtlest, #505F79)",
                boxSizing: 'content-box'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        li: {
            // if same list item has multiple code blocks we need top margin for all but first
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .code-block': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
                margin: `${$d6a88bda7f42404d$var$blockNodesVerticalMargin} 0 0 0`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '> .code-block:first-child, > .ProseMirror-gapcursor:first-child + .code-block': {
                marginTop: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '> div:last-of-type.code-block, > pre:last-of-type.code-block': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
                marginBottom: $d6a88bda7f42404d$var$blockNodesVerticalMargin
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
        [`.code-block.ak-editor-selected-node:not(.danger)`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.boxShadowSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.blanketSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.hideNativeBrowserTextSelectionStyles)
        ],
        // Danger when top level node
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.danger.code-block': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER}`]: [
                {
                    backgroundColor: "var(--ds-background-danger, #FFECEB)",
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    color: "var(--ds-text-danger, #AE2E24)"
                },
                $d6a88bda7f42404d$var$gutterDangerOverlay
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_CONTENT}`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
            }
        },
        // Danger when nested node
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.danger .code-block': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER}`]: [
                {
                    backgroundColor: "var(--ds-background-danger, #FFECEB)",
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    color: "var(--ds-text-danger, #AE2E24)"
                },
                $d6a88bda7f42404d$var$gutterDangerOverlay
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_CONTENT}`]: {
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
            }
        }
    }
});
const $d6a88bda7f42404d$export$921fec04d268c00a = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_CONTAINER}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.code-block-gutter-pseudo-element::before': {
                display: 'flow',
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                lineHeight: '1.5em'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_CONTENT}`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                code: {
                    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                    fontSize: '0.875em',
                    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                    lineHeight: '1.5em'
                }
            }
        }
    }
});
const $d6a88bda7f42404d$export$107831225ad52bb4 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_CONTAINER}`]: {
        '--ds--code--bg-color': 'transparent'
    }
});
const $d6a88bda7f42404d$export$ddc3dd3ba723d1af = {
    name: "1pwqusk",
    styles: ".ProseMirror{.ak-editor-panel__content{> .code-block:first-child, > .ProseMirror-widget:first-child + .code-block, > .ProseMirror-widget:first-child + .ProseMirror-widget + .code-block{margin:0!important;}}}"
};
const $d6a88bda7f42404d$export$50458a606d5c37d0 = {
    name: "1jcwwg4",
    styles: ".ProseMirror{.ak-editor-panel__content{> .code-block:first-child{margin:0!important;}}}"
};

});
parcelRegister("jhoGk", function(module, exports) {
$parcel$export(module.exports, "overflowShadowStyles", () => $bd6de6a2b5bbbfc1$export$cd7bee32f3fef345);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");
const $bd6de6a2b5bbbfc1$export$cd7bee32f3fef345 = /*#__PURE__*/ (0, $1NIU8.css)({
    backgroundImage: `
		linear-gradient(
			to right,
			${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-300, 24px)"},
			transparent ${"var(--ds-space-300, 24px)"}
		),
		linear-gradient(
			to right,
			${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
			transparent ${"var(--ds-space-300, 24px)"}
		),
		linear-gradient(
			to left,
			${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-100, 8px)"},
			transparent ${"var(--ds-space-100, 8px)"}
		),
		linear-gradient(
			to left,
			${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
			transparent ${"var(--ds-space-100, 8px)"}
		),
		linear-gradient(
			to left,
			${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
		),
		linear-gradient(
			to left,
			${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
		),
		linear-gradient(
			to right,
			${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
		),
		linear-gradient(
			to right,
			${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
		)
	`
});

});

parcelRegister("famkW", function(module, exports) {
$parcel$export(module.exports, "hideNativeBrowserTextSelectionStyles", () => $9065106edc6fff3a$export$a716852a0c5e54d5);
$parcel$export(module.exports, "borderSelectionStyles", () => $9065106edc6fff3a$export$48dd9ca0c16e4625);
$parcel$export(module.exports, "boxShadowSelectionStyles", () => $9065106edc6fff3a$export$a8e8bf15b18b52a0);
$parcel$export(module.exports, "backgroundSelectionStyles", () => $9065106edc6fff3a$export$b2937e5c446645ec);
$parcel$export(module.exports, "blanketSelectionStyles", () => $9065106edc6fff3a$export$e7c1f2908e268236);
$parcel$export(module.exports, "hideSelectionStyles", () => $9065106edc6fff3a$export$b8cc3f8fc9e3d56a);
$parcel$export(module.exports, "hideCursorWhenHideSelectionStyles", () => $9065106edc6fff3a$export$cc1dcabcf4a29354);
$parcel$export(module.exports, "selectedNodeStyles", () => $9065106edc6fff3a$export$a3d8f4cb8a14da43);
$parcel$export(module.exports, "dangerBorderStyles", () => $9065106edc6fff3a$export$57f48b634c3a2512);
$parcel$export(module.exports, "dangerBackgroundStyles", () => $9065106edc6fff3a$export$fd4ac125b4ba4c28);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");
function $9065106edc6fff3a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9065106edc6fff3a$export$a716852a0c5e54d5 = {
    name: "1fqpa4w",
    styles: "&::selection,*::selection{background-color:transparent;}&::-moz-selection,*::-moz-selection{background-color:transparent;}"
};
const $9065106edc6fff3a$export$48dd9ca0c16e4625 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
    border: `1px solid ${"var(--ds-border-selected, #0C66E4)"}`,
    // Fixes ED-15246: Trello card is visible through a border of a table border
    '&::after': {
        height: '100%',
        content: "'\\00a0'",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        background: "var(--ds-border-selected, #0C66E4)",
        position: 'absolute',
        right: -1,
        top: 0,
        bottom: 0,
        width: 1,
        border: 'none',
        display: 'inline-block'
    }
});
const $9065106edc6fff3a$export$a8e8bf15b18b52a0 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
    boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}`,
    borderColor: 'transparent'
});
const $9065106edc6fff3a$export$b2937e5c446645ec = {
    name: "1l5b1jb",
    styles: "background-color:var(--ds-background-selected, #E9F2FF)"
};
const $9065106edc6fff3a$export$e7c1f2908e268236 = {
    name: "na0ofp",
    styles: "position:relative;-webkit-user-select:text;&::before{position:absolute;content:'';left:0;right:0;top:0;bottom:0;width:100%;pointer-events:none;z-index:12;background-color:var(--ds-blanket-selected, #388BFF14);}"
};
const $9065106edc6fff3a$export$b8cc3f8fc9e3d56a = {
    name: "105gl83",
    styles: ".ProseMirror-hideselection{*::selection{background:transparent;}*::-moz-selection{background:transparent;}}"
};
const $9065106edc6fff3a$export$cc1dcabcf4a29354 = {
    name: "p4ha7",
    styles: ".ProseMirror-hideselection{caret-color:transparent;}"
};
const $9065106edc6fff3a$export$a3d8f4cb8a14da43 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror-selectednode': {
        outline: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror-selectednode:empty': {
        outline: `2px solid ${"var(--ds-border-focused, #388BFF)"}`
    }
});
const $9065106edc6fff3a$export$57f48b634c3a2512 = /*#__PURE__*/ (0, $1NIU8.css)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
});
const $9065106edc6fff3a$export$fd4ac125b4ba4c28 = {
    name: "74cays",
    styles: "background-color:var(--ds-background-danger, #FFECEB)"
};

});


parcelRegister("9A6ET", function(module, exports) {
$parcel$export(module.exports, "codeMarkStyles", () => $d41324697c305c78$export$2029176b06e1b241);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");
const $d41324697c305c78$export$2029176b06e1b241 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.code': {
        '--ds--code--bg-color': "var(--ds-background-neutral, #091E420F)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        display: 'inline',
        padding: '2px 0.5ch',
        backgroundColor: `var(--ds--code--bg-color,${"var(--ds-background-neutral, #091E420F)"})`,
        borderRadius: "var(--ds-radius-small, 3px)",
        borderStyle: 'none',
        boxDecorationBreak: 'clone',
        color: "var(--ds-text, #172B4D)",
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        fontWeight: "var(--ds-font-weight-regular, 400)",
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    }
});

});

parcelRegister("bOenW", function(module, exports) {
$parcel$export(module.exports, "commentEditorStyles", () => $40cb95d2de1819a2$export$d6e7bceefcc20e27);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");
const $40cb95d2de1819a2$var$CommentEditorMargin = 14;
const $40cb95d2de1819a2$var$GRID_GUTTER = 12;
const $40cb95d2de1819a2$export$d6e7bceefcc20e27 = /*#__PURE__*/ (0, $1NIU8.css)({
    flexGrow: 1,
    overflowX: 'clip',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '24px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror': {
        margin: "var(--ds-space-150, 12px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridParent': {
        marginLeft: "var(--ds-space-025, 2px)",
        marginRight: "var(--ds-space-025, 2px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `calc(100% + ${$40cb95d2de1819a2$var$CommentEditorMargin - $40cb95d2de1819a2$var$GRID_GUTTER}px)`
    },
    padding: "var(--ds-space-250, 20px)"
});

});

parcelRegister("hbiJU", function(module, exports) {
$parcel$export(module.exports, "cursorStyles", () => $bbc9dc9b7e34646f$export$f21d9f928c6ae322);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
function $bbc9dc9b7e34646f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $bbc9dc9b7e34646f$export$f21d9f928c6ae322 = {
    name: "l350f4",
    styles: ".ProseMirror.ProseMirror-focused:has(.ProseMirror-mark-boundary-cursor){caret-color:transparent;}.ProseMirror:not(.ProseMirror-focused) .ProseMirror-mark-boundary-cursor{display:none;}.ProseMirror:has(.ProseMirror-hide-cursor){caret-color:transparent;}"
};

});

parcelRegister("ipdG9", function(module, exports) {
$parcel$export(module.exports, "dateVanillaStyles", () => $9d04087153a93635$export$b89fadc5134d50fa);
$parcel$export(module.exports, "dateStyles", () => $9d04087153a93635$export$37579fbc35dcc1a9);
$parcel$export(module.exports, "dangerDateStyles", () => $9d04087153a93635$export$f9f3f08b750aaa7d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");

var $famkW = parcelRequire("famkW");
const $9d04087153a93635$export$99cdf122d0bb9f95 = {
    DATE_WRAPPER: `date-lozenger-container`,
    DATE_CONTAINER: 'dateView-content-wrap'
};
const $9d04087153a93635$export$b89fadc5134d50fa = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`[data-prosemirror-node-name='date'] .${$9d04087153a93635$export$99cdf122d0bb9f95.DATE_WRAPPER} span`]: {
        backgroundColor: "var(--ds-background-neutral, #091E420F)",
        color: "var(--ds-text, #172B4D)",
        borderRadius: "var(--ds-radius-small, 4px)",
        padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
        margin: '0 1px',
        position: 'relative',
        transition: 'background 0.3s',
        whiteSpace: 'nowrap',
        cursor: 'unset'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`[data-prosemirror-node-name='date'] .${$9d04087153a93635$export$99cdf122d0bb9f95.DATE_WRAPPER} span:hover`]: {
        backgroundColor: "var(--ds-background-neutral-hovered, #091E4224)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`[data-prosemirror-node-name='date'] .${$9d04087153a93635$export$99cdf122d0bb9f95.DATE_WRAPPER} span.date-node-color-red`]: {
        backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
        color: "var(--ds-text-accent-red, #AE2E24)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`[data-prosemirror-node-name='date'] .${$9d04087153a93635$export$99cdf122d0bb9f95.DATE_WRAPPER} span.date-node-color-red:hover`]: {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)"
    }
});
const $9d04087153a93635$export$37579fbc35dcc1a9 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$9d04087153a93635$export$99cdf122d0bb9f95.DATE_WRAPPER} span`]: {
        whiteSpace: 'unset'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$9d04087153a93635$export$99cdf122d0bb9f95.DATE_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$9d04087153a93635$export$99cdf122d0bb9f95.DATE_WRAPPER}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'initial',
            cursor: 'pointer'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$9d04087153a93635$export$99cdf122d0bb9f95.DATE_WRAPPER} > span`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $famkW.boxShadowSelectionStyles),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $famkW.hideNativeBrowserTextSelectionStyles)
            ]
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$9d04087153a93635$export$99cdf122d0bb9f95.DATE_CONTAINER}.ak-editor-selected-node .${$9d04087153a93635$export$99cdf122d0bb9f95.DATE_WRAPPER} > span`]: {
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
        }
    }
});
const $9d04087153a93635$export$f9f3f08b750aaa7d = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$9d04087153a93635$export$99cdf122d0bb9f95.DATE_CONTAINER}.ak-editor-selected-node.danger .${$9d04087153a93635$export$99cdf122d0bb9f95.DATE_WRAPPER} > span`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [
        (0, $famkW.dangerBorderStyles)
    ]
});

});

parcelRegister("fGeMV", function(module, exports) {
$parcel$export(module.exports, "editorUGCTokensDefault", () => $c6f5988542c59082$export$87e0522332cd3719);
$parcel$export(module.exports, "editorUGCTokensRefreshed", () => $c6f5988542c59082$export$63adc0ebe3278d31);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
function $c6f5988542c59082$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c6f5988542c59082$export$87e0522332cd3719 = {
    name: "u5gvmr",
    styles: "--editor-font-ugc-token-heading-h1:normal 500 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h2:normal 500 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h3:normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h4:normal 600 1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h5:normal 600 0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h6:normal 700 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-body:normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-weight-heading-bold:700"
};
const $c6f5988542c59082$export$95588e746468319e = {
    name: "14r7dlz",
    styles: "--editor-font-ugc-token-heading-h1:normal 600 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h2:normal 600 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h3:normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h4:normal 600  1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h5:normal 600  0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h6:normal 600 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-body:normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-weight-heading-bold:700"
};
const $c6f5988542c59082$export$63adc0ebe3278d31 = {
    name: "1maftdw",
    styles: "--editor-font-ugc-token-heading-h1:normal 600 1.71429em/1.16667 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h2:normal 600 1.42857em/1.2 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h3:normal 600 1.14286em/1.25 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h4:normal 600 1em/1.14286 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h5:normal 600 0.857143em/1.33333 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h6:normal 600 0.785714em/1.45455 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-body:normal 400 1em/1.714 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-weight-heading-bold:700"
};

});

parcelRegister("l61tR", function(module, exports) {
$parcel$export(module.exports, "embedCardStyles", () => $356bedc457c60c0b$export$5a1f57c6600b90f1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
function $356bedc457c60c0b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $356bedc457c60c0b$export$5a1f57c6600b90f1 = {
    name: "1tw1dm8",
    styles: ".ProseMirror{.embedCardView-content-wrap[layout^='wrap-']{max-width:100%;position:relative;z-index:2;}.embedCardView-content-wrap[layout='wrap-left']{float:left;}.embedCardView-content-wrap[layout='wrap-right']{float:right;}.embedCardView-content-wrap[layout='wrap-right'] + .embedCardView-content-wrap[layout='wrap-left']{clear:both;}}"
};

});

parcelRegister("aZU0R", function(module, exports) {
$parcel$export(module.exports, "emojiStyles", () => $40f24ef1e1f02788$export$d73b97ac20f33f4);
$parcel$export(module.exports, "getDenseEmojiStyles", () => $40f24ef1e1f02788$export$2a2707475ad11d76);
$parcel$export(module.exports, "emojiDangerStyles", () => $40f24ef1e1f02788$export$df03c70a9b9671c1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");

var $8iUeU = parcelRequire("8iUeU");
var $dXRfX = parcelRequire("dXRfX");

var $7yBx7 = parcelRequire("7yBx7");

var $famkW = parcelRequire("famkW");
function $40f24ef1e1f02788$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $40f24ef1e1f02788$var$emojiSelectionStyles = {
    name: "1h3rhjl",
    styles: "border-radius:var(--ds-radius-xsmall, 2px)"
};
const $40f24ef1e1f02788$export$d73b97ac20f33f4 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror .${(0, $dXRfX.EmojiSharedCssClassName).EMOJI_CONTAINER}`]: {
        display: 'inline-block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror :is(.${(0, $dXRfX.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $dXRfX.EmojiSharedCssClassName).EMOJI_IMAGE})`]: {
        background: 'no-repeat transparent',
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        height: `${(0, $8iUeU.defaultEmojiHeight)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        maxHeight: `${(0, $8iUeU.defaultEmojiHeight)}px`,
        cursor: 'pointer',
        verticalAlign: 'middle',
        userSelect: 'all'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror .${0, $7yBx7.akEditorSelectedNodeClassName}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $dXRfX.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $dXRfX.EmojiSharedCssClassName).EMOJI_IMAGE}`]: [
            $40f24ef1e1f02788$var$emojiSelectionStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.blanketSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.boxShadowSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.hideNativeBrowserTextSelectionStyles)
        ]
    }
});
/**
 * Gets dynamic emoji styles that scale emoji size based on the base font size.
 * This allows emojis to scale proportionally when the base font size changes.
 * @param baseFontSize - The base font size in pixels (e.g., 16 for default, 13 for dense mode)
 * @returns SerializedStyles with emoji size overrides if baseFontSize is provided and different from default.
 */ var $40f24ef1e1f02788$var$_ref = {
    name: "0",
    styles: ""
};
const $40f24ef1e1f02788$export$2a2707475ad11d76 = (baseFontSize)=>{
    if (!baseFontSize || baseFontSize === (0, $7yBx7.akEditorFullPageDefaultFontSize)) return $40f24ef1e1f02788$var$_ref;
    // Calculate emoji size based on base font size
    // Default: 20px emoji at 16px base font
    // Scaled: 20px * (baseFontSize/16)
    // E.g., dense mode (13px base): 20px * (13/16) = 16.25px
    const emojiSize = (0, $8iUeU.defaultEmojiHeight) * baseFontSize / (0, $7yBx7.akEditorFullPageDefaultFontSize);
    return /*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.ProseMirror :is(.${(0, $dXRfX.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $dXRfX.EmojiSharedCssClassName).EMOJI_IMAGE})`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            width: emojiSize,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            height: emojiSize,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            maxHeight: emojiSize,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            img: {
                width: '100%',
                height: '100%',
                objectFit: 'contain'
            }
        },
        // Scale panel icon in dense mode
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ProseMirror .ak-editor-panel .ak-editor-panel__icon': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            height: "var(--ds-space-250, 20px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            width: "var(--ds-space-250, 20px)"
        }
    });
};
const $40f24ef1e1f02788$export$df03c70a9b9671c1 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror .${0, $7yBx7.akEditorSelectedNodeClassName}.danger`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $dXRfX.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $dXRfX.EmojiSharedCssClassName).EMOJI_IMAGE}`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            [
                (0, $famkW.dangerBorderStyles),
                (0, $famkW.dangerBackgroundStyles)
            ]
        ]
    }
});

});

parcelRegister("l1WmN", function(module, exports) {
$parcel$export(module.exports, "expandStyles", () => $04d1b98fb107f419$export$4bb28258452e3b9a);
$parcel$export(module.exports, "getDenseExpandTitleStyles", () => $04d1b98fb107f419$export$9f08fc5d3959d07e);
$parcel$export(module.exports, "expandStylesMixin_fg_platform_visual_refresh_icons", () => $04d1b98fb107f419$export$20843fd014d7530c);
$parcel$export(module.exports, "expandStylesMixin_fg_platform_editor_nested_dnd_styles_changes", () => $04d1b98fb107f419$export$26d7f96b2bb98b5b);
$parcel$export(module.exports, "expandStylesMixin_without_fg_platform_editor_nested_dnd_styles_changes", () => $04d1b98fb107f419$export$4dd1b2c2505a38a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");
function $04d1b98fb107f419$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $04d1b98fb107f419$export$4bb28258452e3b9a = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__icon > div': {
        display: 'flex'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand': {
        // sharedExpandStyles.containerStyles({ expanded: false, focused: false })(),
        borderWidth: "var(--ds-border-width, 1px)",
        borderStyle: 'solid',
        borderColor: 'transparent',
        borderRadius: "var(--ds-radius-small, 4px)",
        minHeight: '25px',
        background: "var(--ds-background-neutral-subtle, transparent)",
        margin: `${"var(--ds-space-050, 0.25rem)"} 0 0`,
        transition: 'background 0.3s cubic-bezier(0.15, 1, 0.3, 1), border-color 0.3s cubic-bezier(0.15, 1, 0.3, 1)',
        padding: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'td > :not(style):first-child, td > style:first-child + *': {
            marginTop: 0
        },
        cursor: 'pointer',
        boxSizing: 'border-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'td > &': {
            marginTop: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__icon-container svg': {
            color: "var(--ds-icon-subtle, #626F86)",
            transform: 'rotate(90deg)'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&.ak-editor-selected-node:not(.danger)': {
            // SelectionStyle.Blanket
            position: 'relative',
            // Fixes ED-9263, where emoji or inline card in panel makes selection go outside the panel
            // in Safari. Looks like it's caused by user-select: all in the emoji element
            WebkitUserSelect: 'text',
            '&::before': {
                position: 'absolute',
                content: "''",
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                width: '100%',
                pointerEvents: 'none',
                zIndex: 12,
                // akEditorStickyheaderZIndex (11) + 1
                backgroundColor: "var(--ds-blanket-selected, #388BFF14)"
            },
            // SelectionStyle.Border (common case)
            border: `1px solid ${"var(--ds-border-selected, #0C66E4)"}`,
            // If fg('platform_editor_nested_dnd_styles_changes') is true,
            // then we'll also need the rest of the selection styles for blanket
            // hideNativeBrowserTextSelectionStyles
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&::selection, *::selection': {
                backgroundColor: 'transparent'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&::-moz-selection, *::-moz-selection': {
                backgroundColor: 'transparent'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            background: "var(--ds-background-danger, #FFECEB)",
            borderColor: "var(--ds-border-danger, #E2483D)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror > .ak-editor-expand__type-expand, .fabric-editor-breakout-mark-dom > .ak-editor-expand__type-expand': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginLeft: '-12px',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginRight: '-12px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__content': {
        // sharedExpandStyles.contentStyles({ expanded: false, focused: false })(),
        paddingTop: "var(--ds-space-0, 0px)",
        paddingRight: "var(--ds-space-100, 8px)",
        paddingLeft: "var(--ds-space-300, 24px)",
        marginLeft: "var(--ds-space-050, 4px)",
        display: 'flow-root',
        /* The follow rules inside @supports block are added as a part of ED-8893
    	The fix is targeting mobile bridge on iOS 12 or below,
    	We should consider remove this fix when we no longer support iOS 12 */ '@supports not (display: flow-root)': {
            width: '100%',
            boxSizing: 'border-box'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.expand-content-wrapper, .nestedExpand-content-wrapper': {
            /* We visually hide the content here to preserve the content during copy+paste */ /* Do not add text nowrap here because inline comment navigation depends on the location of the text */ width: '100%',
            display: 'block',
            height: 0,
            overflow: 'hidden',
            clip: 'rect(1px, 1px, 1px, 1px)',
            userSelect: 'none'
        },
        cursor: 'text'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__title-input': {
        // sharedExpandStyles.titleInputStyles(),
        outline: 'none',
        border: 'none',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 'calc(14rem / 16)',
        // relativeFontSizeToBase16(14),
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.714,
        // If fg('platform-visual-refresh-icons') then this needs to be overridden
        fontWeight: "var(--ds-font-weight-regular, 400)",
        color: "var(--ds-text-subtlest, #626F86)",
        background: 'transparent',
        display: 'flex',
        flex: 1,
        padding: `0 0 0 ${"var(--ds-space-050, 4px)"}`,
        width: '100%',
        '&::placeholder': {
            opacity: 1,
            color: "var(--ds-text-subtlest, #626F86)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__title-container': {
        // sharedExpandStyles.titleContainerStyles(),
        padding: 0,
        display: 'flex',
        // Omitting alignItems: 'flex-start' as it would be overridden
        background: 'none',
        border: 'none',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 'calc(14rem / 16)',
        // relativeFontSizeToBase16(14),
        width: '100%',
        color: "var(--ds-text-subtle, #44546F)",
        // Omitting overflow: 'hidden' as it would be overridden
        cursor: 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&:focus': {
            outline: 0
        },
        alignItems: 'center',
        overflow: 'visible'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__expanded': {
        background: "var(--ds-background-neutral-subtle, #00000000)",
        borderColor: "var(--ds-border, #091E4224)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__content': {
            paddingTop: "var(--ds-space-100, 8px)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__input-container': {
        width: '100%'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.ak-editor-expand:not(.ak-editor-expand__expanded)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__content': {
            position: 'absolute',
            height: '1px',
            width: '1px',
            overflow: 'hidden',
            clip: 'rect(1px, 1px, 1px, 1px)',
            whiteSpace: 'nowrap'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__icon-container svg': {
            color: "var(--ds-icon-subtle, #626F86)",
            transform: 'rotate(0deg)'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:not(.ak-editor-selected-node):not(.danger)': {
            background: 'transparent',
            borderColor: 'transparent',
            '&:hover': {
                borderColor: "var(--ds-border, #091E4224)",
                background: "var(--ds-background-neutral-subtle, #00000000)"
            }
        }
    }
});
/**
 * This function gets the dynamic styles that scale the expand title font size based on the base font size.
 * If the base font size is not the default font size, we want the expand title font size to match the base font size.
 * @param baseFontSize - The base font size in pixels. (e.g., 16 for default, 13 for dense mode)
 * @returns SerializedStyles with expand title font size override if baseFontSize is provided and different from default.
 */ var $04d1b98fb107f419$var$_ref = {
    name: "0",
    styles: ""
};
const $04d1b98fb107f419$export$9f08fc5d3959d07e = (baseFontSize)=>{
    if (!baseFontSize || baseFontSize === (0, $7yBx7.akEditorFullPageDefaultFontSize)) return $04d1b98fb107f419$var$_ref;
    return /*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__title-input': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography, @atlaskit/ui-styling-standard/no-unsafe-values
            fontSize: `${baseFontSize}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__title-container': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography, @atlaskit/ui-styling-standard/no-unsafe-values
            fontSize: `${baseFontSize}px`
        }
    });
};
const $04d1b98fb107f419$export$20843fd014d7530c = {
    name: "1izbe44",
    styles: ".ak-editor-expand__title-input{line-height:1;}"
};
const $04d1b98fb107f419$export$26d7f96b2bb98b5b = {
    name: "b2r3jw",
    styles: ".ak-editor-content-area.appearance-full-page .ProseMirror > .ak-editor-expand__type-expand, .fabric-editor-breakout-mark-dom > .ak-editor-expand__type-expand{margin-left:-20px;margin-right:-20px;}.ak-editor-expand__expanded{.ak-editor-expand__content{> :nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}> div.ak-editor-expand[data-node-type=\"nestedExpand\"]{margin-top:var(--ds-space-050, 0.25rem);}}}"
};
const $04d1b98fb107f419$export$4dd1b2c2505a38a = {
    name: "1oa7j7",
    styles: ".ak-editor-expand{&.ak-editor-selected-node:not(.danger){&::after{height:100%;content:'\\00a0';background:var(--ds-border-selected, #0C66E4);position:absolute;right:-1px;top:0;bottom:0;width:1px;border:none;display:inline-block;}}}"
};

});

parcelRegister("ftlkF", function(module, exports) {
$parcel$export(module.exports, "getExtensionStyles", () => $94d47c11854fef9e$export$9abdb593a2600bc6);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");

var $eGOwo = parcelRequire("eGOwo");

var $cbSL1 = parcelRequire("cbSL1");

var $famkW = parcelRequire("famkW");
function $94d47c11854fef9e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Creates the extension styles with the ability to use feature flags and experiments.
 * @returns Complete SerializedStyles including base styles and any feature-gated styles
 */ var $94d47c11854fef9e$var$_ref = {
    name: "0",
    styles: ""
};
var $94d47c11854fef9e$var$_ref2 = {
    name: "pwxs72",
    styles: ".extension-container [data-macro-name=\"toc\"] * :not(.status-lozenge-span *){font-size:var(--ak-editor-base-font-size);}.extension-container .ak-excerpt-include :not([data-inline-card-lozenge] *, code, .status-lozenge-span *, .code-block *){font-size:var(--ak-editor-base-font-size);}"
};
const $94d47c11854fef9e$export$9abdb593a2600bc6 = (contentMode)=>{
    const baseExtensionStyles = /*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.multiBodiedExtensionView-content-wrap': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > .multiBodiedExtension--container': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                backgroundColor: "var(--ds-background-danger, #FFECEB)"
            },
            // ...extensionLabelStyles
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > div > .extension-label': {
                backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
                color: "var(--ds-text-danger, #AE2E24)",
                opacity: 1,
                boxShadow: 'none'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label': {
                backgroundColor: "var(--ds-background-selected, #E9F2FF)",
                color: "var(--ds-text-selected, #0C66E4)",
                opacity: 1,
                boxShadow: 'none'
            },
            /* Targets the icon for bodied macro styling in button label */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > div > .extension-label > span': {
                display: 'inline'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div .extension-label > span': {
                display: 'inline'
            },
            /* Start of bodied extension edit toggle styles */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > .extension-edit-toggle-container': {
                opacity: 1
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > .extension-edit-toggle-container': {
                opacity: 1
            },
            /* In view mode of the bodied macro, we never want to show the extension label */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > div > .extension-label.always-hide-label': {
                opacity: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label.always-hide-label': {
                opacity: 0
            },
            /* .with-bodied-macro-live-page-styles class will only be added to bodied macros with the renderer mode gate enabled */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label.with-bodied-macro-live-page-styles': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > div > .extension-label.with-bodied-macro-live-page-styles': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > .extension-edit-toggle-container > .extension-edit-toggle': {
                backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
                color: "var(--ds-text-danger, #AE2E24)",
                boxShadow: 'none'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&.danger > span > .with-danger-overlay': {
                backgroundColor: 'transparent',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.multiBodiedExtension--overlay': {
                    // ...dangerOverlayStyles
                    opacity: 0.3,
                    backgroundColor: "var(--ds-background-danger-hovered, #FFD5D2)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
                '& > span > .multiBodiedExtension--container': [
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $famkW.boxShadowSelectionStyles),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $famkW.blanketSelectionStyles),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $famkW.hideNativeBrowserTextSelectionStyles)
                ]
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.multiBodiedExtension--container': {
                width: '100%',
                maxWidth: '100%' // ensure width can't go over 100%
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.inlineExtensionView-content-wrap': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > .extension-container': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                backgroundColor: "var(--ds-background-danger, #FFECEB)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > .with-danger-overlay': {
                /* If the macro turned used to red before, not setting the background to be transparent will cause the
        danger state to have two layers of red which we don't want. */ backgroundColor: 'transparent',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.extension-overlay': {
                    // ...dangerOverlayStyles
                    opacity: 0.3,
                    backgroundColor: "var(--ds-background-danger-hovered, #FFD5D2)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
                '& > span > .extension-container': [
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $famkW.boxShadowSelectionStyles),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $famkW.hideNativeBrowserTextSelectionStyles)
                ]
            },
            // ...extensionLabelStyles
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > div > .extension-label': {
                backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
                color: "var(--ds-text-danger, #AE2E24)",
                opacity: 1,
                boxShadow: 'none'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label': {
                backgroundColor: "var(--ds-background-selected, #E9F2FF)",
                color: "var(--ds-text-selected, #0C66E4)",
                opacity: 1,
                boxShadow: 'none'
            },
            /* Targets the icon for bodied macro styling in button label */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > div > .extension-label > span': {
                display: 'inline'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div .extension-label > span': {
                display: 'inline'
            },
            /* Start of bodied extension edit toggle styles */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > .extension-edit-toggle-container': {
                opacity: 1
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > .extension-edit-toggle-container': {
                opacity: 1
            },
            /* In view mode of the bodied macro, we never want to show the extension label */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > div > .extension-label.always-hide-label': {
                opacity: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label.always-hide-label': {
                opacity: 0
            },
            /* .with-bodied-macro-live-page-styles class will only be added to bodied macros with the renderer mode gate enabled */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label.with-bodied-macro-live-page-styles': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > div > .extension-label.with-bodied-macro-live-page-styles': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > .extension-edit-toggle-container > .extension-edit-toggle': {
                backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
                color: "var(--ds-text-danger, #AE2E24)",
                boxShadow: 'none'
            }
        },
        /* This is referenced in the toDOM of a bodied extension and is used to put
    label content into the bodied extension.
    We do this so that we don't serialise the label (which causes the label to be
    copied to the clipboard causing copy-paste issues). */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.bodied-extension-to-dom-label::after': {
            content: 'attr(data-bodied-extension-label)'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extensionView-content-wrap, .multiBodiedExtensionView-content-wrap, .bodiedExtensionView-content-wrap': {
            margin: `0.75rem 0`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:first-of-type': {
                marginTop: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:last-of-type': {
                marginBottom: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
                '& > span > .extension-container': [
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $famkW.boxShadowSelectionStyles),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $famkW.hideNativeBrowserTextSelectionStyles)
                ]
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > .extension-container': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                backgroundColor: "var(--ds-background-danger, #FFECEB)"
            },
            // ...extensionLabelStyles
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > div > .extension-label': {
                backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
                color: "var(--ds-text-danger, #AE2E24)",
                opacity: 1,
                boxShadow: 'none'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label': {
                backgroundColor: "var(--ds-background-selected, #E9F2FF)",
                color: "var(--ds-text-selected, #0C66E4)",
                opacity: 1,
                boxShadow: 'none'
            },
            /* Targets the icon for bodied macro styling in button label */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > div > .extension-label > span': {
                display: 'inline'
            },
            /** Targets legacy content header in LCM extension */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > .legacy-content-header': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                backgroundColor: `${"var(--ds-background-danger, #FFECEB)"}`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '& .status-lozenge-span > span': {
                    backgroundColor: `${"var(--ds-background-accent-red-subtle-hovered, #FD9891)"}`
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div .extension-label > span': {
                display: 'inline'
            },
            /* Start of bodied extension edit toggle styles */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > .extension-edit-toggle-container': {
                opacity: 1
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > .extension-edit-toggle-container': {
                opacity: 1
            },
            /* In view mode of the bodied macro, we never want to show the extension label */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > div > .extension-label.always-hide-label': {
                opacity: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label.always-hide-label': {
                opacity: 0
            },
            /* .with-bodied-macro-live-page-styles class will only be added to bodied macros with the renderer mode gate enabled */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label.with-bodied-macro-live-page-styles': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > div > .extension-label.with-bodied-macro-live-page-styles': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > .extension-edit-toggle-container > .extension-edit-toggle': {
                backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
                color: "var(--ds-text-danger, #AE2E24)",
                boxShadow: 'none'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&.danger > span > .with-danger-overlay': {
                backgroundColor: 'transparent',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.extension-overlay': {
                    // ...dangerOverlayStyles
                    opacity: 0.3,
                    backgroundColor: "var(--ds-background-danger-hovered, #FFD5D2)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.inline': {
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extensionView-content-wrap .extension-container': {
            overflow: 'hidden',
            /* Don't hide overflow for editors inside extensions. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has(.extension-editable-area)': {
                overflow: 'visible'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.bodiedExtensionView-content-wrap .extensionView-content-wrap .extension-container': {
            width: '100%',
            maxWidth: '100%' // ensure width can't go over 100%
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "[data-mark-type='fragment']": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& > .extensionView-content-wrap, & > .bodiedExtensionView-content-wrap': {
                margin: '0.75rem 0'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "& > [data-mark-type='dataConsumer']": {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '& > .extensionView-content-wrap, & > .bodiedExtensionView-content-wrap': {
                    margin: '0.75rem 0'
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:first-child': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '& > .extensionView-content-wrap, & > .bodiedExtensionView-content-wrap': {
                    marginTop: 0
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                "& > [data-mark-type='dataConsumer']": {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '& > .extensionView-content-wrap, & > .bodiedExtensionView-content-wrap': {
                        marginTop: 0
                    }
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:nth-last-of-type(-n + 2):not(:first-of-type)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '& > .extensionView-content-wrap, & > .bodiedExtensionView-content-wrap': {
                    marginBottom: 0
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                "& > [data-mark-type='dataConsumer']": {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '& > .extensionView-content-wrap, & > .bodiedExtensionView-content-wrap': {
                        marginBottom: 0
                    }
                }
            }
        }
    });
    // Dense content mode extensions styling fix - addresses EDITOR-1992
    // When cleaning up the experiment, move this logic into the baseExtensionStyles above
    const fontSize = (0, $cbSL1.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') ? (0, $7yBx7.relativeFontSizeToBase16)((0, $7yBx7.akEditorFullPageDenseFontSize)) : undefined;
    const denseExtensionStyles = (contentMode === 'compact' || contentMode === 'dense') && (0, $cbSL1.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $eGOwo.fg)('platform_editor_content_mode_button_mvp') ? $94d47c11854fef9e$var$_ref2 : (contentMode === 'compact' || contentMode === 'dense') && (0, $cbSL1.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') ? /*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container a span': {
            fontSize: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            fontSize
        }
    }) : $94d47c11854fef9e$var$_ref;
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    return /*#__PURE__*/ (0, $1NIU8.css)(baseExtensionStyles, denseExtensionStyles);
};

});

parcelRegister("hgRND", function(module, exports) {
$parcel$export(module.exports, "findReplaceStyles", () => $27c55fcc747b2da2$export$c5ceb9c726010930);
$parcel$export(module.exports, "findReplaceStylesWithCodeblockColorContrastFix", () => $27c55fcc747b2da2$export$a5471dc947aff188);
$parcel$export(module.exports, "findReplaceStylesNewWithCodeblockColorContrastFix", () => $27c55fcc747b2da2$export$fae24dca059c5);
$parcel$export(module.exports, "findReplaceStylesNew", () => $27c55fcc747b2da2$export$f6e8277f5198ab7b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");

var $gBkUB = parcelRequire("gBkUB");
const $27c55fcc747b2da2$export$c5ceb9c726010930 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match': {
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
        borderRadius: "var(--ds-radius-small, 3px)",
        backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
        boxShadow: `${"var(--ds-shadow-raised, 0 1px 1px 0 rgba(9, 30, 66, 0.25), 0 0 1px 0 rgba(9, 30, 66, 0.31))"}, inset 0 0 0 1px ${"var(--ds-border-input, #8590A2)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.selected-search-match': {
        backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)"
    }
});
const $27c55fcc747b2da2$export$a5471dc947aff188 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER} .search-match.selected-search-match`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        span: {
            // we need to use !important here as we need to override inline selection styles
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            color: `${"var(--ds-text, #172B4D)"} !important`
        }
    }
});
const $27c55fcc747b2da2$export$fae24dca059c5 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER} .search-match-text.selected-search-match`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        span: {
            // we need to use !important here as we need to override inline selection styles
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            color: `${"var(--ds-text, #172B4D)"} !important`
        }
    }
});
const $27c55fcc747b2da2$export$f6e8277f5198ab7b = /*#__PURE__*/ (0, $1NIU8.css)({
    /** Text match styles */ /** Light mode */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-text': {
        borderRadius: "var(--ds-space-050, 4px)",
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}
		`,
        // we need to use !important here as we need to override inline selection styles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        backgroundColor: `${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"} !important`,
        color: "var(--ds-text, #172B4D)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-text.selected-search-match': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"}
		`,
        // we need to use !important here as we need to override inline selection styles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        backgroundColor: `${"var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"} !important`
    },
    /** Dark mode */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-text.search-match-dark': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-pressed, #50253F)"}
		`,
        // we need to use !important here as we need to override inline selection styles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        backgroundColor: `${"var(--ds-background-accent-magenta-bolder-pressed, #50253F)"} !important`,
        color: "var(--ds-text-inverse, #FFFFFF)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-text.selected-search-match.search-match-dark': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}
		`,
        // we need to use !important here as we need to override inline selection styles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        backgroundColor: `${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"} !important`
    },
    /** Block match styles */ /** Light mode */ /** Without node selection */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
			inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `0px 0px 0px 4px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"}`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-block-selected': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
			inset 0 0 0 4px ${"var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `0px 0px 0px 4px ${"var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"}`
        }
    },
    /** With node selection */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.ak-editor-selected-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
			inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"},
			0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}, 0px 0px 0px 4px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"}`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-block-selected.ak-editor-selected-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
			inset 0 0 0 4px ${"var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"},
			0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}, 0px 0px 0px 4px ${"var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"}`
        }
    },
    /** Dark mode */ /** Without node selection */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-dark': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
			inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-pressed, #50253F)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `0px 0px 0px 4px ${"var(--ds-background-accent-magenta-bolder-pressed, #50253F)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"}`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-block-selected.search-match-dark': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
			inset 0 0 0 4px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `0px 0px 0px 4px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"}`
        }
    },
    /** With node selection */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-dark.ak-editor-selected-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
			inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-pressed, #50253F)"},
			0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}, 0px 0px 0px 4px ${"var(--ds-background-accent-magenta-bolder-pressed, #50253F)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"}`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-block-selected.search-match-dark.ak-editor-selected-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
			inset 0 0 0 4px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"},
			0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}, 0px 0px 0px 4px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"}`
        }
    },
    /** Expand title match styles */ /** Light mode */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-expand-title > .ak-editor-expand__title-container > .ak-editor-expand__input-container': {
        borderRadius: "var(--ds-space-050, 4px)",
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__title-input': {
            color: "var(--ds-text, #172B4D)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-expand-title.selected-search-match > .ak-editor-expand__title-container > .ak-editor-expand__input-container': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"
    },
    /** Dark mode */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-expand-title.search-match-dark > .ak-editor-expand__title-container > .ak-editor-expand__input-container': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-pressed, #50253F)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__title-input': {
            color: "var(--ds-text-inverse, #FFFFFF)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-expand-title.selected-search-match.search-match-dark > .ak-editor-expand__title-container > .ak-editor-expand__input-container': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-bolder-hovered, #943D73)"
    }
});

});

parcelRegister("eXk0C", function(module, exports) {
$parcel$export(module.exports, "firstBlockNodeStyles", () => $247d7e71c20f1de6$export$2d6e8a1d666d4a60);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");

var $7kf0Z = parcelRequire("7kf0Z");

var $is7NW = parcelRequire("is7NW");
var $e2Ny4 = parcelRequire("e2Ny4");

var $kdwal = parcelRequire("kdwal");
const $247d7e71c20f1de6$export$2d6e8a1d666d4a60 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`> .${(0, $7kf0Z.PanelSharedCssClassName).prefix}, > .${(0, $kdwal.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}, > .${(0, $e2Ny4.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}, > div[data-task-list-local-id], > div[data-layout-section], > .${(0, $is7NW.expandClassNames).prefix}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:first-child': {
                marginTop: 0
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
        '> hr:first-child, > .ProseMirror-widget:first-child + hr': {
            marginTop: 0
        }
    }
});

});
parcelRegister("7kf0Z", function(module, exports) {
$parcel$export(module.exports, "darkPanelColors", () => $8f40ff547e3f0696$export$804476272fbaff5e);
$parcel$export(module.exports, "PanelSharedCssClassName", () => $8f40ff547e3f0696$export$6dd740b6c888e050);
$parcel$export(module.exports, "getPanelTypeBackgroundNoTokens", () => $8f40ff547e3f0696$export$8099afddf1b1be78);

var $ePdnq = parcelRequire("ePdnq");

var $kZPQ0 = parcelRequire("kZPQ0");
const $8f40ff547e3f0696$var$lightPanelColors = {
    info: '#DEEBFF',
    note: '#EAE6FF',
    tip: '#E3FCEF',
    success: '#E3FCEF',
    warning: '#FFFAE6',
    error: '#FFEBE6'
};
const $8f40ff547e3f0696$export$804476272fbaff5e = {
    // standard panels
    info: `#0C294F`,
    error: `#441C13`,
    warning: `#413001`,
    tip: `#052E21`,
    success: `#052E21`,
    note: `#282249`,
    // Reds
    R900: '#601D16',
    // Red Saturated
    R100S: `#FFEFEB`,
    R300S: `#FFB5A3`,
    R500S: `#FF6B47`,
    R800S: `#C4320E`,
    R1200S: `#441C13`,
    // Yellows
    Y900: '#533F04',
    // Yellow Saturated
    Y100S: `#FFF3D1`,
    Y300S: `#FFDC7A`,
    Y500S: `#FFC933`,
    Y800S: `#D8A003`,
    Y1200S: `#413001`,
    // Greens
    G900: '#164B35',
    // Green Saturated
    G100S: `#E3FCF0`,
    G300S: `#95EEC5`,
    G400S: `#60DCA8`,
    G900S: `#086848`,
    G1200S: `#052E21`,
    // Blues
    B900: '#09326C',
    // Saturated Blues
    B100S: '#E5F0FF',
    B300S: '#A3C9FF',
    B500S: '#4794FF',
    B800S: '#0055CC',
    B1200S: '#0C294F',
    // Purples
    P900: `#352C63`,
    // Purple Saturated
    P100S: `#EEEBFF`,
    P300S: `#CCC3FE`,
    P500S: `#A292F7`,
    P800S: `#5E49CA`,
    P1200S: `#282249`,
    // Teals
    T900: '#1D474C',
    // Teal Saturated
    T100S: `#DBFAFF`,
    T300S: `#78EBFC`,
    T400S: `#3AD6EE`,
    T900S: `#056270`,
    T1200S: `#0B3037`,
    // Dark Mode Alpha
    DarkGray: '#161A1D',
    Gray: '#2C333A',
    LightGray: '#5A6977',
    TextColor: '#D9DDE3'
};
function $8f40ff547e3f0696$export$9490e629452e7f9e(colorName, colorValue) {
    return `
  &[data-panel-color="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
    color: ${$8f40ff547e3f0696$export$804476272fbaff5e.TextColor};
  }
  `;
}
const $8f40ff547e3f0696$var$prefix = 'ak-editor-panel';
const $8f40ff547e3f0696$export$6dd740b6c888e050 = {
    prefix: $8f40ff547e3f0696$var$prefix,
    content: `${$8f40ff547e3f0696$var$prefix}__content`,
    icon: `${$8f40ff547e3f0696$var$prefix}__icon`,
    noIcon: `${$8f40ff547e3f0696$var$prefix}__no-icon`
};
const $8f40ff547e3f0696$export$b0ee08fae091706a = {
    infoPanel: `.${$8f40ff547e3f0696$var$prefix}[data-panel-type=${(0, $ePdnq.PanelType).INFO}]`,
    notePanel: `.${$8f40ff547e3f0696$var$prefix}[data-panel-type=${(0, $ePdnq.PanelType).NOTE}]`,
    warningPanel: `.${$8f40ff547e3f0696$var$prefix}[data-panel-type=${(0, $ePdnq.PanelType).WARNING}]`,
    errorPanel: `.${$8f40ff547e3f0696$var$prefix}[data-panel-type=${(0, $ePdnq.PanelType).ERROR}]`,
    successPanel: `.${$8f40ff547e3f0696$var$prefix}[data-panel-type=${(0, $ePdnq.PanelType).SUCCESS}]`,
    noteButton: `button[aria-label="Note"]`,
    warningButton: `button[aria-label="Warning"]`,
    removeButton: `button[aria-label="Remove"]`,
    colorPalette: `[aria-label="Background color"]`,
    selectedColor: `[aria-label="Light green"]`,
    removeEmojiIcon: `[aria-label="Remove emoji"]`,
    emojiIcon: `[aria-label="editor-add-emoji"]`,
    selectedEmoji: `[aria-label=":grinning:"]`,
    addYourOwnEmoji: `#add-custom-emoji`,
    emojiNameInCustomEmoji: `[aria-label="Enter a name for the new emoji"]`,
    title: `#editor-title`,
    emojiPopup: `[aria-label="Popup"]`,
    searchEmoji: `[aria-label="Emoji name"]`,
    orangeWarningIcon: `[aria-label=":warning:"]`,
    yellowWarningIcon: `[aria-label=":warning:"]  span:nth-child(1)`,
    copyButton: `button[aria-label="Copy"]`
};
const $8f40ff547e3f0696$export$8099afddf1b1be78 = (panelType)=>$8f40ff547e3f0696$var$lightPanelColors[panelType] || 'none';
const $8f40ff547e3f0696$export$dd3f0fd482ae7ccc = (panelType)=>(0, $kZPQ0.hexToEditorBackgroundPaletteColor)($8f40ff547e3f0696$var$lightPanelColors[panelType]) || 'none';

});

parcelRegister("is7NW", function(module, exports) {
$parcel$export(module.exports, "expandIconContainerStyle", () => $4022cd3059a6bfcb$export$2e9dabdcf16aeb54);
$parcel$export(module.exports, "expandClassNames", () => $4022cd3059a6bfcb$export$6ba39aa0ead007b7);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $4022cd3059a6bfcb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4022cd3059a6bfcb$export$e1f541b6d8e35681 = {
    name: "1igsh0u",
    styles: "margin-left:var(--ds-space-negative-100, -8px)"
};
const $4022cd3059a6bfcb$export$2e9dabdcf16aeb54 = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
const $4022cd3059a6bfcb$var$prefix = 'ak-editor-expand';
const $4022cd3059a6bfcb$export$6ba39aa0ead007b7 = {
    prefix: $4022cd3059a6bfcb$var$prefix,
    expanded: `${$4022cd3059a6bfcb$var$prefix}__expanded`,
    titleContainer: `${$4022cd3059a6bfcb$var$prefix}__title-container`,
    inputContainer: `${$4022cd3059a6bfcb$var$prefix}__input-container`,
    iconContainer: `${$4022cd3059a6bfcb$var$prefix}__icon-container`,
    icon: `${$4022cd3059a6bfcb$var$prefix}__icon`,
    titleInput: `${$4022cd3059a6bfcb$var$prefix}__title-input`,
    content: `${$4022cd3059a6bfcb$var$prefix}__content`,
    type: (type)=>`${$4022cd3059a6bfcb$var$prefix}__type-${type}`
};

});


parcelRegister("cni8p", function(module, exports) {
$parcel$export(module.exports, "firstFloatingToolbarButtonStyles", () => $6ad95db767abb176$export$f06cff4aa315bcf9);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");
const $6ad95db767abb176$export$f06cff4aa315bcf9 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'button.first-floating-toolbar-button:focus': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        outline: `2px solid ${"var(--ds-border-focused, #388BFF)"}`
    }
});

});

parcelRegister("bVQOn", function(module, exports) {
$parcel$export(module.exports, "fullPageEditorStyles", () => $f8db2b9032b8f267$export$eb88bb4706d67f65);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
function $f8db2b9032b8f267$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f8db2b9032b8f267$export$eb88bb4706d67f65 = {
    name: "1ro9jdo",
    styles: "flex-grow:1;height:100%;overflow-y:scroll;position:relative;display:flex;flex-direction:column;scroll-behavior:smooth"
};

});

parcelRegister("ivuYE", function(module, exports) {
$parcel$export(module.exports, "gapCursorStyles", () => $6aba582e724017a6$export$f6b9d90c2745834e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");
const $6aba582e724017a6$var$gapCursorBlink = (0, $1NIU8.keyframes)({
    'from, to': {
        opacity: 0
    },
    '50%': {
        opacity: 1
    }
});
const $6aba582e724017a6$export$8adc5edbc4a22166 = 'ProseMirror-hide-gapcursor';
const $6aba582e724017a6$var$gapCursorSelector = '.ProseMirror-gapcursor';
const $6aba582e724017a6$var$prosemirrorwidgetNotBlock = '.ProseMirror-widget:not([data-blocks-decoration-container="true"]):not([data-blocks-drag-handle-container="true"]):not([data-blocks-quick-insert-container="true"])';
const $6aba582e724017a6$var$wrapLeft = '[layout="wrap-left"]';
const $6aba582e724017a6$var$wrapRight = '[layout="wrap-right"]';
const $6aba582e724017a6$var$fixVerticalAlignmentSelector = `
	&:first-of-type + ul,
	&:first-of-type + span + ul,
	&:first-of-type + ol,
	&:first-of-type + span + ol,
	&:first-of-type + pre,
	&:first-of-type + span + pre,
	&:first-of-type + blockquote,
	&:first-of-type + span + blockquote
`;
const $6aba582e724017a6$var$twoImagesSideBySideFixSelector = `
  ${$6aba582e724017a6$var$gapCursorSelector}${$6aba582e724017a6$var$wrapLeft} + span + ${$6aba582e724017a6$var$wrapLeft},
  ${$6aba582e724017a6$var$gapCursorSelector}${$6aba582e724017a6$var$wrapRight} + span + ${$6aba582e724017a6$var$wrapRight},
  ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapLeft} + ${$6aba582e724017a6$var$wrapRight},
  ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapLeft} + span + ${$6aba582e724017a6$var$wrapRight},
  ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapRight} + ${$6aba582e724017a6$var$wrapLeft},
  ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapRight} + span + ${$6aba582e724017a6$var$wrapLeft},
  ${$6aba582e724017a6$var$wrapLeft} + ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapRight},
  ${$6aba582e724017a6$var$wrapLeft} + ${$6aba582e724017a6$var$gapCursorSelector} + span ${$6aba582e724017a6$var$wrapRight},
  ${$6aba582e724017a6$var$wrapRight} + ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapLeft},
  ${$6aba582e724017a6$var$wrapRight} + ${$6aba582e724017a6$var$gapCursorSelector} + span + ${$6aba582e724017a6$var$wrapLeft},
  ${$6aba582e724017a6$var$wrapLeft} + ${$6aba582e724017a6$var$gapCursorSelector}`;
const $6aba582e724017a6$var$marginFixSelector = `
  ${$6aba582e724017a6$var$wrapLeft} + ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapRight} > div,
  ${$6aba582e724017a6$var$wrapLeft} + ${$6aba582e724017a6$var$gapCursorSelector} + span + ${$6aba582e724017a6$var$wrapRight} > div,
  ${$6aba582e724017a6$var$wrapRight} + ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapLeft} > div,
  ${$6aba582e724017a6$var$wrapRight} + ${$6aba582e724017a6$var$gapCursorSelector} + span + ${$6aba582e724017a6$var$wrapLeft} > div,
  ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapRight} + ${$6aba582e724017a6$var$wrapLeft} > div,
  ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapRight} + span + ${$6aba582e724017a6$var$wrapLeft} > div,
  ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapLeft} + ${$6aba582e724017a6$var$wrapRight} > div,
  ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapLeft} + span + ${$6aba582e724017a6$var$wrapRight} > div`;
const $6aba582e724017a6$var$floatLeftFixSelector = `
  ${$6aba582e724017a6$var$wrapLeft} + ${$6aba582e724017a6$var$gapCursorSelector},
  ${$6aba582e724017a6$var$wrapRight} + ${$6aba582e724017a6$var$gapCursorSelector}`;
const $6aba582e724017a6$var$afterPresudoSelector = `
  ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapLeft} + span + ${$6aba582e724017a6$var$wrapRight}::after,
  ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapRight} + span + ${$6aba582e724017a6$var$wrapLeft}::after,
  ${$6aba582e724017a6$var$wrapLeft} + ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapRight}::after,
  ${$6aba582e724017a6$var$wrapLeft} + ${$6aba582e724017a6$var$gapCursorSelector} + span + ${$6aba582e724017a6$var$wrapRight}::after,
  ${$6aba582e724017a6$var$wrapRight} + ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapLeft}::after,
  ${$6aba582e724017a6$var$wrapRight} + ${$6aba582e724017a6$var$gapCursorSelector} + span + ${$6aba582e724017a6$var$wrapLeft}::after`;
const $6aba582e724017a6$var$marginDeepChildrenFixSelector = `
${$6aba582e724017a6$var$wrapLeft} + ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapRight} + *,
  ${$6aba582e724017a6$var$wrapLeft} + ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapRight} + span + *,
  ${$6aba582e724017a6$var$wrapRight} + ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapLeft} + *,
  ${$6aba582e724017a6$var$wrapRight} + ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapLeft} + span + *,
  ${$6aba582e724017a6$var$wrapLeft} + ${$6aba582e724017a6$var$gapCursorSelector} + span + ${$6aba582e724017a6$var$wrapRight} + *,
  ${$6aba582e724017a6$var$wrapRight} + ${$6aba582e724017a6$var$gapCursorSelector} + span + ${$6aba582e724017a6$var$wrapLeft} + *,
  ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapLeft} + span + ${$6aba582e724017a6$var$wrapRight} + *,
  ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapRight} + span + ${$6aba582e724017a6$var$wrapLeft} + *,
  ${$6aba582e724017a6$var$wrapLeft} + ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapRight} + * > *,
  ${$6aba582e724017a6$var$wrapLeft} + ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapRight} + span + * > *,
  ${$6aba582e724017a6$var$wrapRight} + ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapLeft} + * > *,
  ${$6aba582e724017a6$var$wrapRight} + ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapLeft} + span + * > *,
  ${$6aba582e724017a6$var$wrapLeft} + ${$6aba582e724017a6$var$gapCursorSelector} + span + ${$6aba582e724017a6$var$wrapRight} + * > *,
  ${$6aba582e724017a6$var$wrapRight} + ${$6aba582e724017a6$var$gapCursorSelector} + span + ${$6aba582e724017a6$var$wrapLeft} + * > *,
  ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapLeft} + span + ${$6aba582e724017a6$var$wrapRight} + * > *,
  ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapRight} + span + ${$6aba582e724017a6$var$wrapLeft} + * > *,
  ${$6aba582e724017a6$var$prosemirrorwidgetNotBlock} + ${$6aba582e724017a6$var$gapCursorSelector} + *,
  ${$6aba582e724017a6$var$prosemirrorwidgetNotBlock} + ${$6aba582e724017a6$var$gapCursorSelector} + span + *`;
const $6aba582e724017a6$export$f6b9d90c2745834e = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.${$6aba582e724017a6$export$8adc5edbc4a22166}`]: {
            caretColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$6aba582e724017a6$var$gapCursorSelector]: {
            display: 'none',
            pointerEvents: 'none',
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& span': {
                caretColor: 'transparent',
                position: 'absolute',
                height: '100%',
                width: '100%',
                display: 'block'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& span::after': {
                animation: `1s ${$6aba582e724017a6$var$gapCursorBlink} step-start infinite`,
                borderLeft: '1px solid',
                content: "''",
                display: 'block',
                position: 'absolute',
                top: 0,
                height: '100%'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.-left span::after': {
                left: "var(--ds-space-negative-050, -4px)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.-right span::after': {
                right: "var(--ds-space-negative-050, -4px)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& span[layout="full-width"], & span[layout="wide"], & span[layout="fixed-width"]': {
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                marginLeft: '50%',
                transform: 'translateX(-50%)'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`&${$6aba582e724017a6$var$wrapRight}`]: {
                float: 'right'
            },
            /* fix vertical alignment of gap cursor */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [$6aba582e724017a6$var$fixVerticalAlignmentSelector]: {
                marginTop: 0
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ProseMirror-focused ${$6aba582e724017a6$var$gapCursorSelector}`]: {
            display: 'block',
            borderColor: 'transparent'
        }
    },
    /* This hack below is for two images aligned side by side */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$6aba582e724017a6$var$twoImagesSideBySideFixSelector]: {
        clear: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$6aba582e724017a6$var$marginFixSelector]: {
        marginRight: 0,
        marginLeft: 0,
        marginBottom: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$6aba582e724017a6$var$floatLeftFixSelector]: {
        float: 'left'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$6aba582e724017a6$var$afterPresudoSelector]: {
        visibility: 'hidden',
        display: 'block',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        content: "' '",
        clear: 'both',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$6aba582e724017a6$var$marginDeepChildrenFixSelector]: {
        marginTop: 0
    }
});

});

parcelRegister("8lEWs", function(module, exports) {
$parcel$export(module.exports, "gridStyles", () => $c3078574795805c7$export$61d0da483c72dda3);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");
const $c3078574795805c7$export$61d0da483c72dda3 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridParent': {
        width: `calc(100% + 24px)`,
        marginLeft: "var(--ds-space-negative-150, -12px)",
        marginRight: "var(--ds-space-negative-150, -12px)",
        transform: 'scale(1)',
        zIndex: 2
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridContainer': {
        position: 'fixed',
        height: '100vh',
        width: '100%',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridLine': {
        borderLeft: `1px solid ${"var(--ds-border, #091E4224)"}`,
        display: 'inline-block',
        boxSizing: 'border-box',
        height: '100%',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginLeft: '-1px',
        transition: 'border-color 0.15s linear',
        zIndex: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.highlight': {
        borderLeft: `1px solid ${"var(--ds-border-focused, #388BFF)"}`
    }
});

});

parcelRegister("6tApo", function(module, exports) {
$parcel$export(module.exports, "indentationStyles", () => $6915d298031facd2$export$fc74cf03693076b4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
function $6915d298031facd2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6915d298031facd2$export$fc74cf03693076b4 = {
    name: "86ymtv",
    styles: ".ProseMirror{.fabric-editor-indentation-mark{&[data-level='1']{margin-left:30px;}&[data-level='2']{margin-left:60px;}&[data-level='3']{margin-left:90px;}&[data-level='4']{margin-left:120px;}&[data-level='5']{margin-left:150px;}&[data-level='6']{margin-left:180px;}}}"
};

});

parcelRegister("iFTJL", function(module, exports) {
$parcel$export(module.exports, "InlineNodeViewSharedStyles", () => $748764bed64b9090$export$3fc32cdc53f6edeb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
function $748764bed64b9090$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $748764bed64b9090$export$3fc32cdc53f6edeb = {
    name: "n6ftfq",
    styles: ".ProseMirror{.inlineNodeView{display:inline;user-select:all;white-space:nowrap;& > *:not(.zeroWidthSpaceContainer){white-space:pre-wrap;}& > .assistive{user-select:none;}}&.ua-safari{.inlineNodeView{&::selection, *::selection{background:transparent;}}}&.ua-chrome .inlineNodeView > span{user-select:none;}.inlineNodeViewAddZeroWidthSpace{&::after{content:'\u200B';}}}"
};

});

parcelRegister("a9Tj3", function(module, exports) {
$parcel$export(module.exports, "layoutColumnStylesAdvanced", () => $2612b88834a2d8d3$export$8dd21c7c24132a82);
$parcel$export(module.exports, "layoutColumnStylesNotAdvanced", () => $2612b88834a2d8d3$export$fe39d5414c0135d3);
$parcel$export(module.exports, "layoutColumnResponsiveStyles", () => $2612b88834a2d8d3$export$55890fd3e3be7f1b);
$parcel$export(module.exports, "layoutSectionStylesAdvanced", () => $2612b88834a2d8d3$export$d9912ef7f698aab8);
$parcel$export(module.exports, "layoutSectionStylesNotAdvanced", () => $2612b88834a2d8d3$export$17d7fe9c8be65e97);
$parcel$export(module.exports, "layoutSelectedStylesNotAdvanced", () => $2612b88834a2d8d3$export$cdcbf2d4bffabda6);
$parcel$export(module.exports, "layoutSelectedStylesAdvanced", () => $2612b88834a2d8d3$export$fe59793079ccb11a);
$parcel$export(module.exports, "layoutResponsiveBaseStyles", () => $2612b88834a2d8d3$export$c1454bb6dd8837f5);
$parcel$export(module.exports, "layoutResponsiveStylesForView", () => $2612b88834a2d8d3$export$203a03d09c37c555);
$parcel$export(module.exports, "layoutBaseStyles", () => $2612b88834a2d8d3$export$ce383b8d82e44bf5);
$parcel$export(module.exports, "layoutBaseStylesAdvanced", () => $2612b88834a2d8d3$export$74ce03ae8f7cbe1a);
$parcel$export(module.exports, "layoutBaseStylesFixesUnderNestedDnDFG", () => $2612b88834a2d8d3$export$4d009f8d3cbd5535);
$parcel$export(module.exports, "layoutSelectedStylesForViewAdvanced", () => $2612b88834a2d8d3$export$20e6a345585c5c3c);
$parcel$export(module.exports, "layoutSelectedStylesForViewNotAdvanced", () => $2612b88834a2d8d3$export$70038a77af1ac7b5);
$parcel$export(module.exports, "layoutStylesForView", () => $2612b88834a2d8d3$export$ec8bdd18ecbadae7);
$parcel$export(module.exports, "layoutColumnMartinTopFixesNew", () => $2612b88834a2d8d3$export$c60086c81c0ffabf);
$parcel$export(module.exports, "layoutColumnMartinTopFixesOld", () => $2612b88834a2d8d3$export$598dd68f26eb7eff);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");

var $famkW = parcelRequire("famkW");
function $2612b88834a2d8d3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2612b88834a2d8d3$var$gridMediumMaxWidth = 1024;
const $2612b88834a2d8d3$var$akEditorSelectedNodeClassName = 'ak-editor-selected-node';
const $2612b88834a2d8d3$var$selectorForNotResizedLayoutInFulllWidthEditor = '.fabric-editor--full-width-mode .ProseMirror > .layoutSectionView-content-wrap';
const $2612b88834a2d8d3$var$selectorForNotResizedLayoutInFixedWidthEditor = '.ak-editor-content-area:not(.fabric-editor--full-width-mode) .ProseMirror > .layoutSectionView-content-wrap';
const $2612b88834a2d8d3$var$selectorForResizedLayoutInFullOrFixedWidthEditor = '.ProseMirror .fabric-editor-breakout-mark .layoutSectionView-content-wrap';
const $2612b88834a2d8d3$var$layoutResponsiveSelectedSelector = `&.selected, &:hover, &.selected.danger, &.${$2612b88834a2d8d3$var$akEditorSelectedNodeClassName}:not(.danger)`;
const $2612b88834a2d8d3$var$layoutSelectedSelector = `&.selected, [data-empty-layout='true'], &:hover, &.selected.danger [data-layout-section], &.${$2612b88834a2d8d3$var$akEditorSelectedNodeClassName}:not(.danger) [data-layout-section]`;
const $2612b88834a2d8d3$export$8dd21c7c24132a82 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror [data-layout-section]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> [data-layout-column]': {
            margin: '0 4px'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
        '> [data-layout-column]:first-of-type': {
            marginLeft: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
        '> [data-layout-column]:last-of-type': {
            marginRight: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`@media screen and (max-width: ${$2612b88834a2d8d3$var$gridMediumMaxWidth}px)`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '[data-layout-column] + [data-layout-column]': {
                margin: 0
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`> [data-layout-column].${$2612b88834a2d8d3$var$akEditorSelectedNodeClassName}:not(.danger)`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.blanketSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.hideNativeBrowserTextSelectionStyles),
            {
                // layout column selection shorter after layout border has been removed
                '::before': {
                    width: 'calc(100% - 8px)',
                    left: 4,
                    borderRadius: "var(--ds-radius-small, 3px)"
                }
            }
        ]
    }
});
const $2612b88834a2d8d3$export$fe39d5414c0135d3 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror [data-layout-section]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-column] + [data-layout-column]': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: 8
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`@media screen and (max-width: ${$2612b88834a2d8d3$var$gridMediumMaxWidth}px)`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '[data-layout-column] + [data-layout-column]': {
                marginLeft: 0
            }
        }
    }
});
const $2612b88834a2d8d3$export$55890fd3e3be7f1b = {
    name: "4jflbi",
    styles: ".ProseMirror [data-layout-section]{display:flex;flex-direction:row;gap:var(--ds-space-100, 8px);& > *{flex:1;min-width:0;}& > .unsupportedBlockView-content-wrap{min-width:initial;}}.layout-section-container{container-type:inline-size;container-name:layout-area;}"
};
const $2612b88834a2d8d3$export$d9912ef7f698aab8 = {
    name: "xjr39a",
    styles: ".ProseMirror .layout-section-container [data-layout-section]{> .ProseMirror-widget{flex:none;display:contents !important;&[data-blocks-drag-handle-container] div{display:contents !important;}&[data-blocks-drop-target-container]{display:block !important;margin:var(--ds-space-negative-050, -4px);[data-drop-target-for-element]{position:absolute;}}& + [data-layout-column]{margin:0;}}> [data-layout-column]{margin:0;}}"
};
const $2612b88834a2d8d3$export$17d7fe9c8be65e97 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror [data-layout-section]': {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media screen and (max-width: ${$2612b88834a2d8d3$var$gridMediumMaxWidth}px)`]: {
            flexDirection: 'column'
        }
    }
});
const $2612b88834a2d8d3$export$cdcbf2d4bffabda6 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section], .layoutSectionView-content-wrap': {
            // Shows the border when cursor is inside a layout
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.selected [data-layout-column], &:hover [data-layout-column]': {
                border: `1px solid ${"var(--ds-border, #091E4224)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.selected.danger [data-layout-column]': {
                backgroundColor: "var(--ds-background-danger, #FFECEB)",
                borderColor: "var(--ds-border-danger, #E2483D)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`&.${$2612b88834a2d8d3$var$akEditorSelectedNodeClassName}:not(.danger)`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                '[data-layout-column]': [
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $famkW.borderSelectionStyles),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $famkW.blanketSelectionStyles),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $famkW.hideNativeBrowserTextSelectionStyles),
                    {
                        '::after': {
                            backgroundColor: 'transparent'
                        }
                    }
                ]
            }
        }
    }
});
// TODO: ED-28075 - inline rowSeparatorBaseStyles to unblock Compiled CSS migration
const $2612b88834a2d8d3$var$rowSeparatorBaseStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-layout-content]::before': {
        content: "''",
        borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`,
        position: 'absolute',
        width: 'calc(100% - 32px)',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: -13,
        // clear styles for column separator
        borderLeft: 'unset',
        marginLeft: 'unset',
        height: 'unset'
    }
});
const $2612b88834a2d8d3$export$fe59793079ccb11a = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section], .layoutSectionView-content-wrap': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [$2612b88834a2d8d3$var$layoutSelectedSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                '[data-layout-column]:not(:first-of-type) [data-layout-content]::before': {
                    content: "''",
                    borderLeft: `1px solid ${"var(--ds-border, #091E4224)"}`,
                    position: 'absolute',
                    height: 'calc(100% - 24px)',
                    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                    marginLeft: -25
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.selected.danger [data-layout-section]': {
                backgroundColor: "var(--ds-background-danger, #FFECEB)",
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                borderRadius: "var(--ds-radius-small, 4px)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`&.${$2612b88834a2d8d3$var$akEditorSelectedNodeClassName}:not(.danger) [data-layout-section]`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}`,
                borderRadius: "var(--ds-radius-small, 4px)",
                backgroundColor: "var(--ds-background-selected, #E9F2FF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                '[data-layout-column]': [
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $famkW.blanketSelectionStyles),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $famkW.hideNativeBrowserTextSelectionStyles),
                    {
                        border: 0,
                        '::before': {
                            backgroundColor: 'transparent'
                        }
                    }
                ]
            }
        }
    }
});
const $2612b88834a2d8d3$export$c1454bb6dd8837f5 = /*#__PURE__*/ (0, $1NIU8.css)({
    // chosen breakpoints in container queries are to make sure layout responsiveness in editor aligns with renderer
    // not resized layout in full-width editor
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$2612b88834a2d8d3$var$selectorForNotResizedLayoutInFulllWidthEditor]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
            '@container editor-area (max-width:724px)': {
                flexDirection: 'column'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$2612b88834a2d8d3$var$layoutResponsiveSelectedSelector]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '[data-layout-column]:not(:first-of-type)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries,@atlaskit/ui-styling-standard/no-unsafe-values
                [`@container editor-area (max-width:724px)`]: $2612b88834a2d8d3$var$rowSeparatorBaseStyles
            }
        }
    },
    // not resized layout in fixed-width editor
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$2612b88834a2d8d3$var$selectorForNotResizedLayoutInFixedWidthEditor]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
            '@container editor-area (max-width:788px)': {
                flexDirection: 'column'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$2612b88834a2d8d3$var$layoutResponsiveSelectedSelector]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '[data-layout-column]:not(:first-of-type)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries,@atlaskit/ui-styling-standard/no-unsafe-values
                [`@container editor-area (max-width:788px)`]: $2612b88834a2d8d3$var$rowSeparatorBaseStyles
            }
        }
    },
    // resized layout in full/fixed-width editor
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$2612b88834a2d8d3$var$selectorForResizedLayoutInFullOrFixedWidthEditor]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
            '@container editor-area (max-width:820px)': {
                flexDirection: 'column'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$2612b88834a2d8d3$var$layoutResponsiveSelectedSelector]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '[data-layout-column]:not(:first-of-type)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries,@atlaskit/ui-styling-standard/no-unsafe-values
                [`@container editor-area (max-width:820px)`]: $2612b88834a2d8d3$var$rowSeparatorBaseStyles
            }
        }
    }
});
const $2612b88834a2d8d3$export$203a03d09c37c555 = /*#__PURE__*/ (0, $1NIU8.css)({
    // chosen breakpoints in container queries are to make sure layout responsiveness in editor aligns with renderer
    // not resized layout in full-width editor
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$2612b88834a2d8d3$var$selectorForNotResizedLayoutInFulllWidthEditor]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$2612b88834a2d8d3$var$layoutResponsiveSelectedSelector]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '[data-layout-column]:not(:first-of-type)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries,@atlaskit/ui-styling-standard/no-unsafe-values
                [`@container editor-area (max-width:724px)`]: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '[data-layout-content]::before': {
                        borderTop: 0
                    }
                }
            }
        }
    },
    // not resized layout in fixed-width editor
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$2612b88834a2d8d3$var$selectorForNotResizedLayoutInFixedWidthEditor]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$2612b88834a2d8d3$var$layoutResponsiveSelectedSelector]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '[data-layout-column]:not(:first-of-type)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries,@atlaskit/ui-styling-standard/no-unsafe-values
                [`@container editor-area (max-width:788px)`]: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '[data-layout-content]::before': {
                        borderTop: 0
                    }
                }
            }
        }
    },
    // resized layout in full/fixed-width editor
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$2612b88834a2d8d3$var$selectorForResizedLayoutInFullOrFixedWidthEditor]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$2612b88834a2d8d3$var$layoutResponsiveSelectedSelector]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '[data-layout-column]:not(:first-of-type)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries,@atlaskit/ui-styling-standard/no-unsafe-values
                [`@container editor-area (max-width:820px)`]: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '[data-layout-content]::before': {
                        borderTop: 0
                    }
                }
            }
        }
    }
});
const $2612b88834a2d8d3$export$ce383b8d82e44bf5 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section]': {
            margin: `${"var(--ds-space-100, 8px)"} -12px 0`,
            transition: 'border-color 0.3s cubic-bezier(0.15, 1, 0.3, 1)',
            cursor: 'pointer',
            // Inner cursor located 26px from left
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '[data-layout-column]': {
                flex: 1,
                position: 'relative',
                minWidth: 0,
                /* disable 4 borders when in view mode and advanced layouts is on */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #091E4224)"}`,
                borderRadius: "var(--ds-radius-small, 4px)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                padding: "var(--ds-space-150, 12px)",
                boxSizing: 'border-box',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '> div': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .embedCardView-content-wrap:first-of-type .rich-media-item': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .mediaSingleView-content-wrap:first-of-type .rich-media-item': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor.-right:first-child + .mediaSingleView-content-wrap .rich-media-item, > style:first-child + .ProseMirror-gapcursor.-right + .mediaSingleView-content-wrap .rich-media-item, > .ProseMirror-gapcursor.-right:first-of-type + .embedCardView-content-wrap .rich-media-item': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor:first-child + span + .mediaSingleView-content-wrap .rich-media-item, > style:first-child + .ProseMirror-gapcursor + span + .mediaSingleView-content-wrap .rich-media-item': {
                        marginTop: 0
                    },
                    // Prevent first DecisionWrapper's margin-top: 8px from shifting decisions down and shrinking layout's node selectable area (leniency margin)
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    "> [data-node-type='decisionList']": {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                        'li:first-of-type [data-decision-wrapper]': {
                            marginTop: 0
                        }
                    }
                },
                // Make the 'content' fill the entire height of the layout column to allow click handler of layout section nodeview to target only data-layout-column
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '[data-layout-content]': {
                    height: '100%',
                    cursor: 'text',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '.mediaGroupView-content-wrap': {
                        clear: 'both'
                    }
                }
            }
        }
    },
    // hide separator when element is dragging on top of a layout column
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-blocks-drop-target-container] ~ [data-layout-column] > [data-layout-content]::before': {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.fabric-editor--full-width-mode .ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.pm-table-container': {
                margin: '0 2px'
            }
        }
    }
});
const $2612b88834a2d8d3$export$74ce03ae8f7cbe1a = {
    name: "14on7sz",
    styles: ".ProseMirror [data-layout-section] [data-layout-column]{border:0;}"
};
const $2612b88834a2d8d3$export$4d009f8d3cbd5535 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror [data-layout-section]': {
        margin: `${"var(--ds-space-100, 8px)"} -20px 0`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror [data-layout-section] [data-layout-column]': {
        padding: '12px 20px'
    }
});
const $2612b88834a2d8d3$export$20e6a345585c5c3c = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section], .layoutSectionView-content-wrap': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors
            [$2612b88834a2d8d3$var$layoutSelectedSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                '[data-layout-column]:not(:first-of-type) [data-layout-content]::before': {
                    borderLeft: 0
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.selected.danger [data-layout-section]': {
                boxShadow: `0 0 0 0 ${"var(--ds-border-danger, #E2483D)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
            [`&.${$2612b88834a2d8d3$var$akEditorSelectedNodeClassName}:not(.danger) [data-layout-section]`]: {
                boxShadow: `0 0 0 0 ${"var(--ds-border-selected, #0C66E4)"}`
            }
        }
    }
});
const $2612b88834a2d8d3$export$70038a77af1ac7b5 = {
    name: "1nqe1o0",
    styles: ".ProseMirror{[data-layout-section], .layoutSectionView-content-wrap{&.selected [data-layout-column], &:hover [data-layout-column]{border:0;}}}"
};
const $2612b88834a2d8d3$export$ec8bdd18ecbadae7 = {
    name: "1xloaqb",
    styles: ".ProseMirror{[data-layout-section]{cursor:default;[data-layout-column]{border:0;}}}"
};
const $2612b88834a2d8d3$export$c60086c81c0ffabf = {
    name: "1gk7267",
    styles: ".ProseMirror [data-layout-section] [data-layout-column] > div{> :nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}}"
};
const $2612b88834a2d8d3$export$598dd68f26eb7eff = {
    name: "uvfuhz",
    styles: ".ProseMirror [data-layout-section] [data-layout-column] > div{> :not(style):first-child, > style:first-child + *{margin-top:0;}> .ProseMirror-gapcursor:first-child + *, > style:first-child + .ProseMirror-gapcursor + *{margin-top:0;}> .ProseMirror-gapcursor:first-child + span + *{margin-top:0;}}"
};

});

parcelRegister("9dvIW", function(module, exports) {
$parcel$export(module.exports, "linkStyles", () => $e216d8155bc86c53$export$4ea5976125a01ffa);
$parcel$export(module.exports, "hyperLinkFloatingToolbarStyles", () => $e216d8155bc86c53$export$889b949305b162f9);
$parcel$export(module.exports, "linkLegacyIconStylesFix", () => $e216d8155bc86c53$export$e696625219a66da6);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
function $e216d8155bc86c53$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e216d8155bc86c53$export$4ea5976125a01ffa = {
    name: "aj1leh",
    styles: ".ProseMirror a.blockLink{display:block;}.ProseMirror a[data-prosemirror-mark-name=\"link\"]{text-decoration:underline;}.ProseMirror a[data-prosemirror-mark-name=\"link\"]:hover{text-decoration:none;}"
};
const $e216d8155bc86c53$export$889b949305b162f9 = {
    name: "1cwtun1",
    styles: ".hyperlink-floating-toolbar{padding:0;}"
};
const $e216d8155bc86c53$export$e696625219a66da6 = {
    name: "1li8ktf",
    styles: ".hyperlink-open-link{min-width:24px;svg{max-width:18px;}}"
};

});

parcelRegister("d2E5F", function(module, exports) {
$parcel$export(module.exports, "listsStyles", () => $2ab7e6e52b65acbd$export$5f95d55c83a3b7bc);
$parcel$export(module.exports, "diffListStyles", () => $2ab7e6e52b65acbd$export$b5b1b7a81c86d94e);
$parcel$export(module.exports, "listsStylesMarginLayoutShiftFix", () => $2ab7e6e52b65acbd$export$3861aadd8944b16f);
$parcel$export(module.exports, "listsStylesSafariFix", () => $2ab7e6e52b65acbd$export$dba87c9b43c1033d);
$parcel$export(module.exports, "EDITOR_LIST_DENSE_GAP", () => $2ab7e6e52b65acbd$export$b9f4317d28be80aa);
$parcel$export(module.exports, "getDenseListStyles", () => $2ab7e6e52b65acbd$export$dc36e8e603594c1d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");
function $2ab7e6e52b65acbd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// copied from packages/editor/editor-shared-styles/src/consts/consts.ts
const $2ab7e6e52b65acbd$var$akEditorLineHeight = 1.714;
// copied from packages/editor/editor-common/src/styles/shared/smart-card.ts
const $2ab7e6e52b65acbd$var$BLOCK_CARD_CONTAINER = 'blockCardView-content-wrap';
// copied from packages/editor/editor-shared-styles/src/consts/consts.ts
const $2ab7e6e52b65acbd$var$blockNodesVerticalMargin = '0.75rem';
const $2ab7e6e52b65acbd$export$5f95d55c83a3b7bc = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        /* =============== INDENTATION SPACING ========= */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ul, ol': {
            boxSizing: 'border-box',
            paddingLeft: `var(--ed--list--item-counter--padding, 24px)`
        },
        // Firefox does not handle empty block element inside li tag.
        // If there is not block element inside li tag,	then firefox sets inherited height to li
        // However, if there is any block element and if it's empty	(or has empty inline element) then
        // firefox sets li tag height to zero.
        //
        // More details at
        // https://product-fabric.atlassian.net/wiki/spaces/~455502413/pages/3149365890/ED-14110+Investigation
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ua-firefox': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            'ul, ol': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                'li p:empty, li p > span:empty': {
                    display: 'inline-block'
                }
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-ol, .ak-ul': {
            // Ensures list item content adheres to the list's margin instead
            // of filling the entire block row. This is important to allow
            // clicking interactive elements which are floated next to a list.
            //
            // For some history and context on this block, see PRs related to tickets.:
            // @see ED-6551 - original issue.
            // @see ED-7015 - follow up issue.
            // @see ED-7447 - flow-root change.
            //
            // @see https://css-tricks.com/display-flow-root/
            //
            // For older browsers the do not support flow-root. */
            // stylelint-disable declaration-block-no-duplicate-properties */
            display: 'flow-root'
        },
        /* =============== INDENTATION AESTHETICS ========= */ // We support nested lists up to six levels deep.
        /*  ======== LEGACY LISTS ======== */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ul, ul ul ul ul': {
            listStyleType: 'disc'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ul ul, ul ul ul ul ul': {
            listStyleType: 'circle'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ul ul ul, ul ul ul ul ul ul': {
            listStyleType: 'square'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ol, ol ol ol ol': {
            listStyleType: 'decimal'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ol ol, ol ol ol ol ol': {
            listStyleType: 'lower-alpha'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ol ol ol, ol ol ol ol ol ol': {
            listStyleType: 'lower-roman'
        },
        /* ======== PREDICTABLE LISTS ======== */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "ol[data-indent-level='1'], ol[data-indent-level='4']": {
            listStyleType: 'decimal'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "ol[data-indent-level='2'], ol[data-indent-level='5']": {
            listStyleType: 'lower-alpha'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "ol[data-indent-level='3'], ol[data-indent-level='6']": {
            listStyleType: 'lower-roman'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "ul[data-indent-level='1'], ul[data-indent-level='4']": {
            listStyleType: 'disc'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "ul[data-indent-level='2'], ul[data-indent-level='5']": {
            listStyleType: 'circle'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "ul[data-indent-level='3'], ul[data-indent-level='6']": {
            listStyleType: 'square'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        li: {
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '& > p:not(:first-child)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                margin: `${"var(--ds-space-050, 4px)"} 0 0 0`
            },
            /* In SSR the above rule will apply to all p tags because first-child would be a style tag.
      	The following rule resets the first p tag back to its original margin
      	defined in packages/editor/editor-common/src/styles/shared/paragraph.ts */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '& > style:first-child + p': {
                marginTop: $2ab7e6e52b65acbd$var$blockNodesVerticalMargin
            }
        }
    }
});
const $2ab7e6e52b65acbd$export$b5b1b7a81c86d94e = {
    name: "2ngyxg",
    styles: "li[data-testid=\"show-diff-changed-decoration-node\"]::marker{color:var(--diff-decoration-marker-color);}"
};
const $2ab7e6e52b65acbd$export$3861aadd8944b16f = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // Root lists: 12px top margin (design system value), except first content child. Uses :not(:nth-child(1 of ...)) to exclude first content lists.
        // A more complex selector is used here to ensure this style is not applied to block quotes and panels, as they do not have a margin-top property already, and this will incorrectly add a margin-top to them.
        // This is unlike tables and expands, which do have a margin-top property already, and this style would not change their top margin, even without the :not(:nth-child(1 of ...)) selector.
        // This targeted approach reduces the blast radius of the fix. Instead of modifying numerous existing styles, we add this single selector until the issue with bundle.css & aui-reset.less is fixed.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'ul:not(li > ul):not(:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span))), ol:not(li > ol):not(:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)))': {
            marginTop: `var(--ds-space-150, 12px)`
        },
        // Nested lists: 4px top margin (design system value)
        // Applies to both OL and UL nested inside list items
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'li > ol, li > ul': {
            marginTop: `var(--ds-space-050, 4px)`
        }
    }
});
const $2ab7e6e52b65acbd$export$dba87c9b43c1033d = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror:not(.${$2ab7e6e52b65acbd$var$BLOCK_CARD_CONTAINER}) > li::before`]: {
        content: '" "',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        lineHeight: $2ab7e6e52b65acbd$var$akEditorLineHeight
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror:not(.${$2ab7e6e52b65acbd$var$BLOCK_CARD_CONTAINER}) > li > p:first-child, .ProseMirror:not(.${$2ab7e6e52b65acbd$var$BLOCK_CARD_CONTAINER}) > li > .code-block:first-child, .ProseMirror:not(.${$2ab7e6e52b65acbd$var$BLOCK_CARD_CONTAINER}) > li > .ProseMirror-gapcursor:first-child + .code-block`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        marginTop: `-${$2ab7e6e52b65acbd$var$akEditorLineHeight}em !important`
    }
});
const $2ab7e6e52b65acbd$export$b9f4317d28be80aa = `max(0px, calc((var(--ak-editor-base-font-size, ${(0, $7yBx7.akEditorFullPageDefaultFontSize)}px) - ${(0, $7yBx7.akEditorFullPageDenseFontSize)}px) * (4 / 3)))`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
var $2ab7e6e52b65acbd$var$_ref = {
    name: "0",
    styles: ""
};
const $2ab7e6e52b65acbd$export$dc36e8e603594c1d = (baseFontSize)=>{
    if (!baseFontSize || baseFontSize === (0, $7yBx7.akEditorFullPageDefaultFontSize)) return $2ab7e6e52b65acbd$var$_ref;
    return /*#__PURE__*/ (0, $1NIU8.css)({
        /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ '.ProseMirror': {
            // Adjacent list items
            'li + li': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                marginTop: $2ab7e6e52b65acbd$export$b9f4317d28be80aa
            },
            // Nested lists directly under an li (unordered and ordered)
            'li > ul, li > ol, .ak-ul li > ul, .ak-ul li > ol, .ak-ol li > ul, .ak-ol li > ol': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                marginTop: $2ab7e6e52b65acbd$export$b9f4317d28be80aa
            }
        }
    });
};

});

parcelRegister("jw6co", function(module, exports) {
$parcel$export(module.exports, "mediaStyles", () => $2ceb85f8698e9c0d$export$abd2efc27ac7e809);
$parcel$export(module.exports, "mediaDangerStyles", () => $2ceb85f8698e9c0d$export$c47a18e5da2466ef);
$parcel$export(module.exports, "mediaGroupStyles", () => $2ceb85f8698e9c0d$export$cbc2f5b7ba4a5b45);
$parcel$export(module.exports, "mediaAlignmentStyles", () => $2ceb85f8698e9c0d$export$228abfa0106fa708);
$parcel$export(module.exports, "mediaCaptionStyles", () => $2ceb85f8698e9c0d$export$1cac2710e369d647);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");

var $dA9km = parcelRequire("dA9km");

var $1I3aa = parcelRequire("1I3aa");

var $cYzoj = parcelRequire("cYzoj");
var $laqWo = parcelRequire("laqWo");

var $7yBx7 = parcelRequire("7yBx7");

var $jbnQ0 = parcelRequire("jbnQ0");

var $famkW = parcelRequire("famkW");
function $2ceb85f8698e9c0d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2ceb85f8698e9c0d$var$wrappedMediaBreakoutPoint = 410;
/**
 * Reference Heights
 *
 * These heights enforce consistent sizes with media inline nodes due to
 * inconsistencies with center aligned inline nodes and text.
 *
 * There is conversation about refactoring media inline nodes to conform to
 * aligning correctly with the surrounding text.
 *
 * These constants originally came from `headingSizes` from the `theme` package
 * and have been copied here to remove this package.
 */ const $2ceb85f8698e9c0d$var$referenceHeights = {
    p: 22,
    h1: 36,
    h2: 31,
    h3: 25,
    h4: 23,
    h5: 20,
    h6: 18
};
const $2ceb85f8698e9c0d$var$inlineImageSelector = `> .mediaInlineView-content-wrap > .${(0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME)}, > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${(0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME)}, > .${(0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME)}, > :is(a, span[data-mark-type='border']) .${(0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME)}`;
const $2ceb85f8698e9c0d$export$abd2efc27ac7e809 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
        [`li .${0, $laqWo.richMediaClassName}`]: {
            margin: 0
        },
        // Hack for chrome to fix media single position inside a list when media is the first child
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
            content: "''",
            display: 'block',
            height: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ua-firefox': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.mediaSingleView-content-wrap': {
                userSelect: 'none'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.captionView-content-wrap': {
                userSelect: 'text'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mediaSingleView-content-wrap[layout^='wrap-']": {
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
            zIndex: (0, $7yBx7.akEditorWrappedNodeZIndex),
            maxWidth: '100%',
            /* overwrite default Prosemirror setting making it clear: both */ clear: 'inherit'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mediaSingleView-content-wrap[layout='center']": {
            clear: 'both'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
        [`table .${0, $laqWo.richMediaClassName}`]: {
            marginTop: "var(--ds-space-150, 12px)",
            marginBottom: "var(--ds-space-150, 12px)",
            clear: 'both',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
                clear: 'none',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                '&:first-child': {
                    marginTop: "var(--ds-space-150, 12px)"
                }
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
        [`.${0, $laqWo.richMediaClassName}.image-wrap-right + .${0, $laqWo.richMediaClassName}.image-wrap-left`]: {
            clear: 'both'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
        [`.${0, $laqWo.richMediaClassName}.image-wrap-left + .${0, $laqWo.richMediaClassName}.image-wrap-right, .${0, $laqWo.richMediaClassName}.image-wrap-right + .${0, $laqWo.richMediaClassName}.image-wrap-left, .${0, $laqWo.richMediaClassName}.image-wrap-left + .${0, $laqWo.richMediaClassName}.image-wrap-left, .${0, $laqWo.richMediaClassName}.image-wrap-right + .${0, $laqWo.richMediaClassName}.image-wrap-right`]: {
            marginRight: 0,
            marginLeft: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`@media all and (max-width: ${$2ceb85f8698e9c0d$var$wrappedMediaBreakoutPoint}px)`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
                float: 'none',
                overflow: 'auto',
                margin: `${"var(--ds-space-150, 12px)"} 0`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`& [layout='full-width'] .${0, $laqWo.richMediaClassName}, & [layout='wide'] .${0, $laqWo.richMediaClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: '50%',
            transform: 'translateX(-50%)'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".media-extended-resize-experience[layout^='wrap-']": {
            // override 'overflow: auto' when viewport <= 410 set by mediaSingleSharedStyle
            // to prevent scroll bar
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            overflow: 'visible !important'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "& [layout^='wrap-'] + [layout^='wrap-']": {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "& + p, & + div[class^='fabric-editor-align'], & + ul, & + ol, & + h1, & + h2, & + h3, & + h4, & + h5, & + h6": {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles,@atlaskit/ui-styling-standard/no-unsafe-values
                clear: 'both !important'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${0, $laqWo.richMediaClassName}`]: {
                marginLeft: 0,
                marginRight: 0
            }
        },
        // Shifting the mediaInline image component (renders image) to align nicely with
        // mediaInline (renders text) is a bit of a testing ground. This numbers represent
        // shift in top and bottom and size adjustments to make up for lack of 1to1 size
        //  mapping
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            height: $2ceb85f8698e9c0d$var$referenceHeights['p'],
            transform: 'translateY(-2px)'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h1: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$2ceb85f8698e9c0d$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $2ceb85f8698e9c0d$var$referenceHeights.h1,
                transform: `translateY(-3px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h2: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$2ceb85f8698e9c0d$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $2ceb85f8698e9c0d$var$referenceHeights.h2,
                transform: `translateY(-3px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h3: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$2ceb85f8698e9c0d$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $2ceb85f8698e9c0d$var$referenceHeights.h3,
                transform: `translateY(-2px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h4: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$2ceb85f8698e9c0d$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $2ceb85f8698e9c0d$var$referenceHeights.h4,
                transform: `translateY(-2px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h5: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$2ceb85f8698e9c0d$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $2ceb85f8698e9c0d$var$referenceHeights.h5,
                transform: `translateY(-2px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h6: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$2ceb85f8698e9c0d$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $2ceb85f8698e9c0d$var$referenceHeights.h6,
                transform: `translateY(-2px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mediaSingleView-content-wrap[layout='wrap-left']": {
            float: 'left'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mediaSingleView-content-wrap[layout='wrap-right']": {
            float: 'right'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mediaSingleView-content-wrap[layout='wrap-right'] + .mediaSingleView-content-wrap[layout='wrap-left']": {
            clear: 'both'
        },
        // Larger margins for resize handlers when at depth 0 of the document
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > .mediaSingleView-content-wrap': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.richMedia-resize-handle-right': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
                marginRight: `-${(0, $7yBx7.akEditorMediaResizeHandlerPaddingWide)}px`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.richMedia-resize-handle-left': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
                marginLeft: `-${(0, $7yBx7.akEditorMediaResizeHandlerPaddingWide)}px`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
    [`.${(0, $cYzoj.ClassNames).FLOATING_TOOLBAR_COMPONENT}`]: {
        padding: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.richMedia-resize-handle-right, .richMedia-resize-handle-left': {
        display: 'flex',
        flexDirection: 'column',
        /* vertical align */ justifyContent: 'center'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.richMedia-resize-handle-right': {
        alignItems: 'flex-end',
        paddingRight: "var(--ds-space-150, 12px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        marginRight: `-${(0, $7yBx7.akEditorMediaResizeHandlerPadding)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.richMedia-resize-handle-left': {
        alignItems: 'flex-start',
        paddingLeft: "var(--ds-space-150, 12px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        marginLeft: `-${(0, $7yBx7.akEditorMediaResizeHandlerPadding)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.richMedia-resize-handle-right::after, .richMedia-resize-handle-left::after': {
        content: "' '",
        display: 'flex',
        width: 3,
        height: 64,
        borderRadius: "var(--ds-radius-medium, 6px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${0, $laqWo.richMediaClassName}:hover .richMedia-resize-handle-left::after, .${0, $laqWo.richMediaClassName}:hover .richMedia-resize-handle-right::after`]: {
        background: "var(--ds-border, #091E4224)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${0, $7yBx7.akEditorSelectedNodeClassName} .richMedia-resize-handle-right::after, .${0, $7yBx7.akEditorSelectedNodeClassName} .richMedia-resize-handle-left::after, .${0, $laqWo.richMediaClassName} .richMedia-resize-handle-right:hover::after, .${0, $laqWo.richMediaClassName} .richMedia-resize-handle-left:hover::after, .${0, $laqWo.richMediaClassName}.is-resizing .richMedia-resize-handle-right::after, .${0, $laqWo.richMediaClassName}.is-resizing .richMedia-resize-handle-left::after`]: {
        background: "var(--ds-border-focused, #388BFF)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.__resizable_base__': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        left: 'unset !important',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        width: 'auto !important',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        height: 'auto !important'
    },
    // Danger when top level node for smart cards / inline links
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger > div > div > .media-card-frame, .danger > span > a': {
        backgroundColor: "var(--ds-background-danger, #FFECEB)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        boxShadow: `0px 0px 0px ${(0, $7yBx7.akEditorSelectedBorderBoldSize)}px, ${"var(--ds-border-danger, #E2483D)"}`,
        transition: 'background-color 0s, box-shadow 0s'
    },
    // Danger when nested node or common
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // Media single
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $laqWo.richMediaClassName} .${0, $87b212d64266f221$export$7a6526d4be3b7eb3}::after`]: {
            border: `1px solid ${"var(--ds-border-danger, #E2483D)"}`
        },
        // Media single video player
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $laqWo.richMediaClassName} .${0, $jbnQ0.inlinePlayerClassName}::after`]: {
            border: `1px solid ${"var(--ds-border-danger, #E2483D)"}`
        },
        // New file experience
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $laqWo.richMediaClassName} .${0, $c214caf0b65ba182$export$c5ba918dbb0b00f3}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`
        },
        // Media resize legacy handlers
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.richMedia-resize-handle-right::after, .richMedia-resize-handle-left::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            background: `${"var(--ds-icon-danger, #C9372C)"} !important`
        },
        // Media resize new handlers
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.resizer-handle-thumb': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            background: `${"var(--ds-icon-danger, #C9372C)"} !important`
        },
        // Smart cards
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'div div .media-card-frame, .inlineCardView-content-wrap > span > a': {
            backgroundColor: `${"var(--ds-blanket-danger, #EF5C4814)"}`,
            transition: `background-color 0s`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'div div .media-card-frame::after': {
            boxShadow: 'none'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.warning': {
        // Media single
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $laqWo.richMediaClassName} .${0, $87b212d64266f221$export$7a6526d4be3b7eb3}::after`]: {
            border: `1px solid ${"var(--ds-border-warning, #E56910)"}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $laqWo.richMediaClassName} .${0, $jbnQ0.inlinePlayerClassName}::after`]: {
            border: `1px solid ${"var(--ds-border-warning, #E56910)"}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $laqWo.richMediaClassName} .${0, $c214caf0b65ba182$export$c5ba918dbb0b00f3}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            boxShadow: `0 0 0 1px ${"var(--ds-border-warning, #E56910)"} !important`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.resizer-handle-thumb': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            background: `${"var(--ds-icon-warning, #E56910)"} !important`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.media-filmstrip-list-item': {
        cursor: 'pointer'
    },
    // When clicking drag handle, mediaGroup node will be selected. Hence we need to apply selected style to each media node
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.mediaGroupView-content-wrap.${0, $7yBx7.akEditorSelectedNodeClassName} #newFileExperienceWrapper`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        boxShadow: (0, $7yBx7.akEditorSelectedBoxShadow)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-no-interaction #newFileExperienceWrapper': {
        boxShadow: 'none'
    }
});
const $2ceb85f8698e9c0d$export$c47a18e5da2466ef = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-nested-selectors
        [`.mediaInlineView-content-wrap.${0, $7yBx7.akEditorSelectedNodeClassName}.danger`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [` .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: [
                (0, $famkW.dangerBorderStyles)
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            '>span> span[role="button"]': [
                (0, $famkW.dangerBorderStyles)
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.mediaGroupView-content-wrap.danger #newFileExperienceWrapper`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        [
            (0, $famkW.dangerBorderStyles)
        ]
    }
});
const $2ceb85f8698e9c0d$export$cbc2f5b7ba4a5b45 = {
    name: "efqvbk",
    styles: ".mediaGroupView-content-wrap ul{padding:0;}"
};
const $2ceb85f8698e9c0d$export$228abfa0106fa708 = {
    name: "1u86ffv",
    styles: ".fabric-editor-block-mark[class^=\"fabric-editor-align\"]{clear:none;}.fabric-editor-align-end{text-align:right;}.fabric-editor-align-start{text-align:left;}.fabric-editor-align-center{text-align:center;}.fabric-editor--full-width-mode{.pm-table-container{.code-block, .extension-container, .multiBodiedExtension--container{max-width:100%;}}}"
};
const $2ceb85f8698e9c0d$export$1cac2710e369d647 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.mediaSingleView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`span#${0, $1I3aa.CAPTION_PLACEHOLDER_ID}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 'var(--ak-editor-base-font-size)'
        }
    }
});

});
parcelRegister("1I3aa", function(module, exports) {
$parcel$export(module.exports, "MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH", () => $63e3275bb42d0987$export$5937600f4cc784f0);
$parcel$export(module.exports, "MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH", () => $63e3275bb42d0987$export$71d660e8ca5b8f73);
$parcel$export(module.exports, "MEDIA_SINGLE_SNAP_GAP", () => $63e3275bb42d0987$export$cd11d7d46412c89b);
$parcel$export(module.exports, "MEDIA_SINGLE_ADJACENT_HANDLE_MARGIN", () => $63e3275bb42d0987$export$8c5ac0b0c62a3d21);
$parcel$export(module.exports, "MEDIA_SINGLE_GUTTER_SIZE", () => $63e3275bb42d0987$export$68d0abe4f03863fb);
$parcel$export(module.exports, "DEFAULT_IMAGE_WIDTH", () => $63e3275bb42d0987$export$d722b7527b1834a8);
$parcel$export(module.exports, "DEFAULT_IMAGE_HEIGHT", () => $63e3275bb42d0987$export$da894f7669b4e67c);
$parcel$export(module.exports, "MEDIA_SINGLE_RESIZE_THROTTLE_TIME", () => $63e3275bb42d0987$export$e13825c38da2ce1);
$parcel$export(module.exports, "wrappedLayouts", () => $63e3275bb42d0987$export$405baca3d8bc263d);
$parcel$export(module.exports, "DEFAULT_ROUNDING_INTERVAL", () => $63e3275bb42d0987$export$4d41d008e9cd4f34);
$parcel$export(module.exports, "CAPTION_PLACEHOLDER_ID", () => $63e3275bb42d0987$export$b4b560efd3c61856);
const $63e3275bb42d0987$export$5937600f4cc784f0 = 24;
const $63e3275bb42d0987$export$71d660e8ca5b8f73 = 320;
const $63e3275bb42d0987$export$cd11d7d46412c89b = 3;
const $63e3275bb42d0987$export$71482734bb54ac3 = 10;
const $63e3275bb42d0987$export$fd2b09475ada41cc = 12;
const $63e3275bb42d0987$export$8c5ac0b0c62a3d21 = 8;
const $63e3275bb42d0987$export$68d0abe4f03863fb = $63e3275bb42d0987$export$fd2b09475ada41cc * 2;
const $63e3275bb42d0987$export$d722b7527b1834a8 = 250;
const $63e3275bb42d0987$export$da894f7669b4e67c = 200;
const $63e3275bb42d0987$export$e13825c38da2ce1 = 100;
var $63e3275bb42d0987$export$c84671f46d6a1ca = /*#__PURE__*/ function(Layout) {
    Layout["FULL_WIDTH"] = "full-width";
    Layout["WIDE"] = "wide";
    Layout["CENTER"] = "center";
    Layout["ALIGN_START"] = "align-start";
    Layout["ALIGN_END"] = "align-end";
    Layout["WRAP_RIGHT"] = "wrap-right";
    Layout["WRAP_LEFT"] = "wrap-left";
    return Layout;
}({});
const $63e3275bb42d0987$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
const $63e3275bb42d0987$export$4d41d008e9cd4f34 = 0.5;
const $63e3275bb42d0987$export$b4b560efd3c61856 = 'caption-placeholder';

});

parcelRegister("cYzoj", function(module, exports) {
$parcel$export(module.exports, "ClassNames", () => $ba39bea6c852bb89$export$9b9c0f9d9f3552b8);
const $ba39bea6c852bb89$var$prefix = 'pm-alt-text';
const $ba39bea6c852bb89$export$9b9c0f9d9f3552b8 = {
    FLOATING_TOOLBAR_COMPONENT: `${$ba39bea6c852bb89$var$prefix}-alt-text-floating-toolbar`,
    MEDIA_CONTAINER: 'mediaView-content-wrap'
};

});

parcelRegister("jbnQ0", function(module, exports) {
$parcel$export(module.exports, "inlinePlayerClassName", () => $3a69e8a96f043606$export$70bc5d30fe886af);
$parcel$export(module.exports, "inlinePlayerWrapperStyles", () => $3a69e8a96f043606$export$bffd1a8ecf8d5d06);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $28sr0 = parcelRequire("28sr0");

var $2N2k8 = parcelRequire("2N2k8");
var $egs2l = parcelRequire("egs2l");
/*
 * Used to display the blue border around a selected card without
 * shrinking the image OR growing the card size
 */ const $3a69e8a96f043606$var$getSelectedBorderStyle = ({ selected: selected })=>`
    ${selected ? (0, $2N2k8.hideNativeBrowserTextSelectionStyles) : ''}

    &::after {
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      box-sizing: border-box;
      pointer-events: none;
      border-radius: ${"var(--ds-radius-small, 3px)"};
      ${selected ? (0, $2N2k8.getSelectionStyles)([
        (0, $egs2l.SelectionStyle).Border
    ]) : ''}
    }
  `;
const $3a69e8a96f043606$export$70bc5d30fe886af = 'media-card-inline-player';
const $3a69e8a96f043606$export$bffd1a8ecf8d5d06 = ({ dimensions: dimensions, selected: selected })=>/*#__PURE__*/ (0, $1NIU8.css)("width:", (0, $28sr0.getDimensionsWithDefault)(dimensions).width || '100%', ";height:", (0, $28sr0.getDimensionsWithDefault)(dimensions).height || 'auto', ";overflow:hidden;border-radius:var(--ds-radius-small, 3px);position:relative;max-width:100%;max-height:100%;", $3a69e8a96f043606$var$getSelectedBorderStyle(selected), " video{width:100%;height:100%;}");
$3a69e8a96f043606$export$bffd1a8ecf8d5d06.displayName = 'InlinePlayerWrapper';

});
parcelRegister("28sr0", function(module, exports) {
$parcel$export(module.exports, "getDimensionsWithDefault", () => $61071ab5121234d6$export$36acad525b1fb57b);
const $61071ab5121234d6$export$36acad525b1fb57b = (dimensions = {
    width: '100%',
    height: '100%'
})=>{
    return {
        height: typeof dimensions.height === 'number' ? `${dimensions.height}px` : dimensions.height,
        width: typeof dimensions.width === 'number' ? `${dimensions.width}px` : dimensions.width
    };
};

});

parcelRegister("2N2k8", function(module, exports) {
$parcel$export(module.exports, "getSelectionStyles", () => $6b23a7199e707c88$export$fb186b651805ffe4);
$parcel$export(module.exports, "hideNativeBrowserTextSelectionStyles", () => $6b23a7199e707c88$export$a716852a0c5e54d5);

var $7yBx7 = parcelRequire("7yBx7");

var $egs2l = parcelRequire("egs2l");
const $6b23a7199e707c88$export$fb186b651805ffe4 = (selectionStyles)=>selectionStyles.map((selectionStyle)=>$6b23a7199e707c88$var$getSelectionStyle(selectionStyle)).concat($6b23a7199e707c88$export$a716852a0c5e54d5).join('\n');
const $6b23a7199e707c88$export$a716852a0c5e54d5 = `
  ::selection,*::selection {
    background-color: transparent;
  }
  ::-moz-selection,*::-moz-selection {
    background-color: transparent;
  }
`;
const $6b23a7199e707c88$var$getSelectionStyle = (style)=>{
    switch(style){
        case (0, $egs2l.SelectionStyle).Border:
            return `
        border: ${0, $7yBx7.akEditorSelectedBorder};

        // Fixes ED-15246: Trello card is visible through a border of a table border
        &::after {
          height: 100%;
          content: '\\00a0';
          background: ${0, $7yBx7.akEditorSelectedBorderColor};
          position: absolute;
          right: -1px;
          top: 0;
          bottom: 0;
          width: 1px;
          border: none;
          display: inline-block;
        }
      `;
        case (0, $egs2l.SelectionStyle).BoxShadow:
            return `
        box-shadow: ${0, $7yBx7.akEditorSelectedBoxShadow};
        border-color: transparent;
        `;
        case (0, $egs2l.SelectionStyle).Background:
            return `background-color: ${"var(--ds-background-selected, #E9F2FF)"};`;
        case (0, $egs2l.SelectionStyle).Blanket:
            return `
        position: relative;

        // Fixes ED-9263, where emoji or inline card in panel makes selection go outside the panel
        // in Safari. Looks like it's caused by user-select: all in the emoji element
        -webkit-user-select: text;

        ::before {
          position: absolute;
          content: '';
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          width: 100%;
          pointer-events: none;
          z-index: ${0, $7yBx7.akEditorSmallZIndex};
          background-color: ${"var(--ds-blanket-selected, #388BFF14)"}
        }`;
        default:
            return '';
    }
};

});
parcelRegister("egs2l", function(module, exports) {
$parcel$export(module.exports, "SelectionStyle", () => $947335242c3fddd4$export$80010201b36a8290);
/**
 * These are generic selection styles for all nodes
 * If you have custom behaviour needed for a node, add that in the plugin's styles
 * file in editor-core
 */ var $947335242c3fddd4$export$80010201b36a8290 = /*#__PURE__*/ function(SelectionStyle) {
    SelectionStyle[SelectionStyle["Border"] = 0] = "Border";
    SelectionStyle[SelectionStyle["BoxShadow"] = 1] = "BoxShadow";
    SelectionStyle[SelectionStyle["Background"] = 2] = "Background";
    SelectionStyle[SelectionStyle["Blanket"] = 3] = "Blanket";
    return SelectionStyle;
}({});

});



const $c214caf0b65ba182$export$c5ba918dbb0b00f3 = 'new-file-experience-wrapper';


parcelRegister("51Rgo", function(module, exports) {
$parcel$export(module.exports, "mentionsStyles", () => $b4303f6126700a98$export$1445f2e2b3a1d9c8);
$parcel$export(module.exports, "mentionNodeStyles", () => $b4303f6126700a98$export$5fb9b21e3678e9ac);
$parcel$export(module.exports, "mentionsSelectionStyles", () => $b4303f6126700a98$export$8697a9554aac2a5a);
$parcel$export(module.exports, "mentionsSelectionStylesWithSearchMatch", () => $b4303f6126700a98$export$13ab2f17ccaf48f6);
$parcel$export(module.exports, "mentionDangerStyles", () => $b4303f6126700a98$export$1091a37fb36d77e5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");

var $av5GH = parcelRequire("av5GH");

var $7yBx7 = parcelRequire("7yBx7");

var $famkW = parcelRequire("famkW");
function $b4303f6126700a98$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/* need to specify dark text colour because personal mentions
(in dark blue) have white text by default */ const $b4303f6126700a98$var$mentionsSelectedColor = {
    name: "4hmdsz",
    styles: "color:var(--ds-text-subtle, #44546F)"
};
const $b4303f6126700a98$export$1445f2e2b3a1d9c8 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${(0, $av5GH.MentionSharedCssClassName).MENTION_CONTAINER}`]: {
        // TODO: ED-28075 - refactor selection styles to unblock Compiled CSS migration
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`&.${0, $7yBx7.akEditorSelectedNodeClassName} [data-mention-id] > span`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.boxShadowSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.backgroundSelectionStyles),
            $b4303f6126700a98$var$mentionsSelectedColor
        ]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $av5GH.MentionSharedCssClassName).MENTION_CONTAINER}.${0, $7yBx7.akEditorSelectedNodeClassName}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> span > span > span': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
                boxShadow: `0 0 0 ${(0, $7yBx7.akEditorSelectedBorderSize)}px ${(0, $7yBx7.akEditorDeleteBorder)}`,
                backgroundColor: "var(--ds-background-danger, #FFECEB)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $av5GH.MentionSharedCssClassName).MENTION_CONTAINER} > span > span > span`]: {
            backgroundColor: "var(--ds-background-neutral, #091E420F)",
            color: "var(--ds-text-subtle, #44546F)"
        }
    }
});
const $b4303f6126700a98$export$5fb9b21e3678e9ac = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.editor-mention-primitive': {
        display: 'inline',
        borderRadius: "var(--ds-radius-full, 9999px)",
        cursor: 'pointer',
        padding: '1px 0.3em 1px 0.23em',
        // To match `packages/elements/mention/src/components/Mention/PrimitiveMention.tsx` implementation
        // we match the line height exactly
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '1.714',
        fontWeight: "var(--ds-font-weight-regular, 400)",
        wordBreak: 'break-word',
        background: "var(--ds-background-neutral, #091E420F)",
        border: '1px solid transparent',
        color: "var(--ds-text-subtle, #44546F)",
        '&:hover': {
            background: "var(--ds-background-neutral-hovered, #091E4224)"
        },
        '&:active': {
            background: "var(--ds-background-neutral-pressed, #091E424F)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.editor-mention-primitive.mention-restricted': {
        background: 'transparent',
        border: `1px solid ${"var(--ds-border-bold, #758195)"}`,
        color: "var(--ds-text, #172B4D)",
        '&:hover': {
            background: 'transparent'
        },
        '&:active': {
            background: 'transparent'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.editor-mention-primitive.mention-self': {
        background: "var(--ds-background-brand-bold, #0C66E4)",
        border: '1px solid transparent',
        color: "var(--ds-text-inverse, #FFFFFF)",
        '&:hover': {
            background: "var(--ds-background-brand-bold-hovered, #0055CC)"
        },
        '&:active': {
            background: "var(--ds-background-brand-bold-pressed, #09326C)"
        }
    }
});
const $b4303f6126700a98$export$8697a9554aac2a5a = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.editor-mention-primitive': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 ${(0, $7yBx7.akEditorSelectedBorderSize)}px ${(0, $7yBx7.akEditorDeleteBorder)}`,
            backgroundColor: "var(--ds-background-danger, #FFECEB)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${0, $7yBx7.akEditorSelectedNodeClassName}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> .editor-mention-primitive, > .editor-mention-primitive.mention-self, > .editor-mention-primitive.mention-restricted': // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.boxShadowSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.backgroundSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.hideNativeBrowserTextSelectionStyles),
            $b4303f6126700a98$var$mentionsSelectedColor
        ]
    }
});
const $b4303f6126700a98$export$13ab2f17ccaf48f6 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.editor-mention-primitive': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 ${(0, $7yBx7.akEditorSelectedBorderSize)}px ${(0, $7yBx7.akEditorDeleteBorder)}`,
            backgroundColor: "var(--ds-background-danger, #FFECEB)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${0, $7yBx7.akEditorSelectedNodeClassName}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> .editor-mention-primitive, > .editor-mention-primitive.mention-self, > .editor-mention-primitive.mention-restricted': // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.backgroundSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.hideNativeBrowserTextSelectionStyles),
            $b4303f6126700a98$var$mentionsSelectedColor
        ]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${0, $7yBx7.akEditorSelectedNodeClassName}:not(.search-match-block)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> .editor-mention-primitive, > .editor-mention-primitive.mention-self, > .editor-mention-primitive.mention-restricted': // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.boxShadowSelectionStyles)
        ]
    }
});
const $b4303f6126700a98$export$1091a37fb36d77e5 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${0, $7yBx7.akEditorSelectedNodeClassName}:not(.search-match-block).danger`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> .editor-mention-primitive, > .editor-mention-primitive.mention-self, > .editor-mention-primitive.mention-restricted': // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            (0, $famkW.dangerBorderStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.dangerBackgroundStyles)
        ]
    }
});

});
parcelRegister("av5GH", function(module, exports) {
$parcel$export(module.exports, "MentionSharedCssClassName", () => $f50611b263831150$export$e5f60e08987c4e73);
const $f50611b263831150$export$e5f60e08987c4e73 = {
    MENTION_CONTAINER: 'mentionView-content-wrap'
};

});


parcelRegister("bRDpM", function(module, exports) {
$parcel$export(module.exports, "panelStyles", () => $811bc2ff7ba56aae$export$8290cf129669d0cb);
$parcel$export(module.exports, "nestedPanelBorderStylesMixin", () => $811bc2ff7ba56aae$export$fb05379f8218158);
$parcel$export(module.exports, "panelStylesMixin_fg_platform_editor_nested_dnd_styles_changes", () => $811bc2ff7ba56aae$export$1bea98aa89006044);
$parcel$export(module.exports, "panelStylesMixin", () => $811bc2ff7ba56aae$export$59d3d90d4141195);
$parcel$export(module.exports, "panelViewStyles", () => $811bc2ff7ba56aae$export$21dc022a1db4e807);
$parcel$export(module.exports, "nestedPanelDangerStyles", () => $811bc2ff7ba56aae$export$9addcfe7a096a01d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");
function $811bc2ff7ba56aae$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $811bc2ff7ba56aae$export$8290cf129669d0cb = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-panel': {
            cursor: 'pointer',
            /* Danger when top level node */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                backgroundColor: `${"var(--ds-background-danger, #FFECEB)"} !important`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.ak-editor-panel__icon': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                    color: `${"var(--ds-icon-danger, #C9372C)"} !important`
                }
            },
            // panelSharedStyles()
            // panelSharedStylesWithoutPrefix()
            borderRadius: "var(--ds-radius-small, 3px)",
            margin: `0.75rem 0 0`,
            paddingTop: "var(--ds-space-100, 8px)",
            paddingRight: "var(--ds-space-200, 16px)",
            paddingBottom: "var(--ds-space-100, 8px)",
            paddingLeft: "var(--ds-space-100, 8px)",
            minWidth: '48px',
            display: 'flex',
            position: 'relative',
            alignItems: 'normal',
            wordBreak: 'break-word',
            // mainDynamicStyles(PanelType.INFO)
            // > getPanelTypeBackground(PanelType.INFO)
            backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
            color: 'inherit',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__icon': {
                flexShrink: 0,
                height: "var(--ds-space-300, 24px)",
                width: "var(--ds-space-300, 24px)",
                boxSizing: 'content-box',
                paddingRight: "var(--ds-space-100, 8px)",
                textAlign: 'center',
                userSelect: 'none',
                MozUserSelect: 'none',
                WebkitUserSelect: 'none',
                msUserSelect: 'none',
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                marginTop: '0.1em',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '> span': {
                    verticalAlign: 'middle',
                    display: 'inline-flex'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.emoji-common-emoji-sprite': {
                    verticalAlign: '-2px' // -(8*3-20)/2 [px]
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.emoji-common-emoji-image': {
                    verticalAlign: '-3px',
                    // panelEmojiSpriteVerticalAlignment - 1 [px]
                    /* Vertical align only works for inline-block elements in Firefox */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '@-moz-document url-prefix()': {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                        img: {
                            display: 'inline-block'
                        }
                    }
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__content': {
                margin: `${"var(--ds-space-025, 2px)"} 0 ${"var(--ds-space-025, 2px)"}`,
                flex: '1 0 0',
                /*
        	https://ishadeed.com/article/min-max-css/#setting-min-width-to-zero-with-flexbox
        	The default value for min-width is auto, which is computed to zero.
        	When an element is a flex item, the value of min-width doesn’t compute to zero.
        	The minimum size of a flex item is equal to the size of its contents.
        */ minWidth: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="note"]': {
                // mainDynamicStyles(PanelType.NOTE)
                backgroundColor: "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
                color: 'inherit'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="tip"]': {
                // mainDynamicStyles(PanelType.TIP)
                backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
                color: 'inherit'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="warning"]': {
                // mainDynamicStyles(PanelType.WARNING)
                backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
                color: 'inherit'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="error"]': {
                // mainDynamicStyles(PanelType.ERROR)
                backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
                color: 'inherit'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="success"]': {
                // mainDynamicStyles(PanelType.SUCCESS)
                backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
                color: 'inherit'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-panel__content': {
            cursor: 'text'
        },
        /* Danger when nested node */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.danger .ak-editor-panel': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type]': {
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.ak-editor-panel__icon': {
                    color: "var(--ds-icon-danger, #C9372C)"
                }
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.ak-editor-panel.ak-editor-selected-node:not(.danger)': {
        // getSelectionStyles([SelectionStyle.BoxShadow, SelectionStyle.Blanket]),
        // SelectionStyle.BoxShadow
        boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}`,
        borderColor: 'transparent',
        // SelectionStyle.Blanket
        position: 'relative',
        // Fixes ED-9263, where emoji or inline card in panel makes selection go outside the panel
        // in Safari. Looks like it's caused by user-select: all in the emoji element
        WebkitUserSelect: 'text',
        '&::before': {
            position: 'absolute',
            content: '""',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            width: '100%',
            pointerEvents: 'none',
            zIndex: 12,
            // akEditorSmallZIndex
            backgroundColor: "var(--ds-blanket-selected, #388BFF14)"
        },
        // hideNativeSelectionStyles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&::selection, *::selection': {
            backgroundColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&::-moz-selection, *::-moz-selection': {
            backgroundColor: 'transparent'
        }
    }
});
const $811bc2ff7ba56aae$export$fb05379f8218158 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-panel': {
            // Support nested panel
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__content .ak-editor-panel': {
                border: `1px solid ${"var(--ds-border, #091E4224)"}`
            }
        }
    }
});
const $811bc2ff7ba56aae$export$1bea98aa89006044 = {
    name: "icrrk4",
    styles: ".ProseMirror{.ak-editor-panel{&.ak-editor-panel__no-icon{padding-right:var(--ds-space-150, 12px);padding-left:var(--ds-space-150, 12px);}}}.ak-editor-content-area.appearance-full-page .ProseMirror{.ak-editor-panel .ak-editor-panel__icon{padding-right:var(--ds-space-150, 12px);}.ak-editor-panel.ak-editor-panel__no-icon{padding-left:var(--ds-space-250, 20px);padding-right:var(--ds-space-250, 20px);}}.ak-editor-content-area .ak-editor-content-area .ProseMirror{.ak-editor-panel .ak-editor-panel__icon{padding-right:var(--ds-space-100, 8px);}.ak-editor-panel.ak-editor-panel__no-icon{padding-right:var(--ds-space-150, 12px);padding-left:var(--ds-space-150, 12px);}}"
};
const $811bc2ff7ba56aae$export$59d3d90d4141195 = {
    name: "qz3hzr",
    styles: ".ProseMirror{.ak-editor-panel{&[data-panel-type=\"info\"]{.ak-editor-panel__icon[data-panel-type=\"info\"]{color:var(--ds-icon-information, #1D7AFC);}}&[data-panel-type=\"note\"]{.ak-editor-panel__icon[data-panel-type=\"note\"]{color:var(--ds-icon-discovery, #8270DB);}}&[data-panel-type=\"tip\"]{.ak-editor-panel__icon[data-panel-type=\"tip\"]{color:var(--ds-icon-success, #22A06B);}}&[data-panel-type=\"warning\"]{.ak-editor-panel__icon[data-panel-type=\"warning\"]{color:var(--ds-icon-warning, #E56910);}}&[data-panel-type=\"error\"]{.ak-editor-panel__icon[data-panel-type=\"error\"]{color:var(--ds-icon-danger, #C9372C);}}&[data-panel-type=\"success\"]{.ak-editor-panel__icon[data-panel-type=\"success\"]{color:var(--ds-icon-success, #22A06B);}}}}"
};
const $811bc2ff7ba56aae$export$21dc022a1db4e807 = {
    name: "5hfp5c",
    styles: ".panelView-content-wrap{box-sizing:border-box;}"
};
const $811bc2ff7ba56aae$export$9addcfe7a096a01d = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        /* Danger when nested node */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.danger .ak-editor-panel': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="info"]': {
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.ak-editor-panel__icon[data-panel-type="info"]': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                    color: `${"var(--ds-icon-danger, #C9372C)"}`
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="note"]': {
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.ak-editor-panel__icon[data-panel-type="note"]': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                    color: `${"var(--ds-icon-danger, #C9372C)"}`
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="success"]': {
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.ak-editor-panel__icon[data-panel-type="success"]': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                    color: `${"var(--ds-icon-danger, #C9372C)"}`
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="warning"]': {
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.ak-editor-panel__icon[data-panel-type="warning"]': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                    color: `${"var(--ds-icon-danger, #C9372C)"}`
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="error"]': {
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.ak-editor-panel__icon[data-panel-type="error"]': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                    color: `${"var(--ds-icon-danger, #C9372C)"}`
                }
            }
        }
    }
});

});

parcelRegister("02AzZ", function(module, exports) {
$parcel$export(module.exports, "paragraphStylesWithScaledMargin", () => $6c1f15f81e4dd34f$export$63635a8b56f58eca);
$parcel$export(module.exports, "paragraphStylesOldWithScaledMargin", () => $6c1f15f81e4dd34f$export$3de2f7ce686aadc2);
$parcel$export(module.exports, "paragraphStylesUGCRefreshed", () => $6c1f15f81e4dd34f$export$29f6e72d2a83d55a);
$parcel$export(module.exports, "paragraphStylesOld", () => $6c1f15f81e4dd34f$export$855ac5a16d662324);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");
const $6c1f15f81e4dd34f$var$blockNodesVerticalMargin = '0.75rem';
const $6c1f15f81e4dd34f$var$scaledBlockNodesVerticalMargin = '0.75em';
const $6c1f15f81e4dd34f$export$63635a8b56f58eca = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror p': {
        // The `editor.font.body` token is used for the UGC typography theme.
        // We don't use `editorUGCToken('editor.font.body')` here because we want to build this styles statically.
        // See platform/packages/editor/editor-common/src/ugc-tokens/get-editor-ugc-token.tsx
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: 'normal 400 1em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        marginTop: $6c1f15f81e4dd34f$var$scaledBlockNodesVerticalMargin,
        marginBottom: 0
    }
});
const $6c1f15f81e4dd34f$export$3de2f7ce686aadc2 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.714,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        marginTop: $6c1f15f81e4dd34f$var$scaledBlockNodesVerticalMargin,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: '-0.005em'
    }
});
const $6c1f15f81e4dd34f$export$29f6e72d2a83d55a = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror p': {
        // The `editor.font.body` token is used for the UGC typography theme.
        // We don't use `editorUGCToken('editor.font.body')` here because we want to build this styles statically.
        // See platform/packages/editor/editor-common/src/ugc-tokens/get-editor-ugc-token.tsx
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: 'normal 400 1em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        marginTop: $6c1f15f81e4dd34f$var$blockNodesVerticalMargin,
        marginBottom: 0
    }
});
const $6c1f15f81e4dd34f$export$a251c8dae8d8433a = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror p': {
        // The `editor.font.body` token is used for the UGC typography theme.
        // We don't use `editorUGCToken('editor.font.body')` here because we want to build this styles statically.
        // See platform/packages/editor/editor-common/src/ugc-tokens/get-editor-ugc-token.tsx
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        marginTop: $6c1f15f81e4dd34f$var$blockNodesVerticalMargin,
        marginBottom: 0
    }
});
const $6c1f15f81e4dd34f$export$855ac5a16d662324 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.714,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        marginTop: $6c1f15f81e4dd34f$var$blockNodesVerticalMargin,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: '-0.005em'
    }
});

});

parcelRegister("g7Nsb", function(module, exports) {
$parcel$export(module.exports, "placeholderTextStyles", () => $d1b33a989f10eb2f$export$56bce713f2cb8aa7);
$parcel$export(module.exports, "placeholderStyles", () => $d1b33a989f10eb2f$export$d3bdc0d52bb6c2c8);
$parcel$export(module.exports, "placeholderOverflowStyles", () => $d1b33a989f10eb2f$export$ec7b3b2c50356d2e);
$parcel$export(module.exports, "placeholderWrapStyles", () => $d1b33a989f10eb2f$export$959bd343ec1d44de);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");
function $d1b33a989f10eb2f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d1b33a989f10eb2f$export$56bce713f2cb8aa7 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror span[data-placeholder]': {
        color: "var(--ds-text-subtlest, #626F86)",
        display: 'inline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror span.pm-placeholder': {
        display: 'inline',
        color: "var(--ds-text-subtlest, #626F86)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror span.pm-placeholder__text': {
        display: 'inline',
        color: "var(--ds-text-subtlest, #626F86)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror span.pm-placeholder.ak-editor-selected-node': {
        // ...backgroundSelectionStyles
        backgroundColor: "var(--ds-background-selected, #E9F2FF)",
        // ...backgroundSelectionStyles -> hideNativeBrowserTextSelectionStyles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&::selection,*::selection': {
            backgroundColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
        '&::-moz-selection,*::-moz-selection': {
            backgroundColor: 'transparent'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror span.pm-placeholder__text[data-placeholder]::after': {
        color: "var(--ds-text-subtlest, #626F86)",
        cursor: 'text',
        content: 'attr(data-placeholder)',
        display: 'inline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ProseMirror-fake-text-cursor': {
            display: 'inline',
            pointerEvents: 'none',
            position: 'relative'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ProseMirror-fake-text-cursor::after': {
            content: '""',
            display: 'inline',
            top: 0,
            position: 'absolute',
            borderRight: `1px solid ${"var(--ds-border, #091E4224)"}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ProseMirror-fake-text-selection': {
            display: 'inline',
            pointerEvents: 'none',
            position: 'relative',
            // Follow the system highlight colour to match native text selection
            backgroundColor: 'Highlight',
            // We should also match the text colour to the system highlight text colour.
            // That way if the system highlight background is dark, the text will still be readable.
            color: 'HighlightText'
        }
    }
});
const $d1b33a989f10eb2f$export$d3bdc0d52bb6c2c8 = {
    name: "12q9gkf",
    styles: ".ProseMirror .placeholder-decoration{color:var(--ds-text-subtlest, #626F86);width:100%;pointer-events:none;user-select:none;.placeholder-android{pointer-events:none;outline:none;user-select:none;position:absolute;}}"
};
const $d1b33a989f10eb2f$export$ec7b3b2c50356d2e = {
    name: "9a360",
    styles: ".ProseMirror p:has(.placeholder-decoration-hide-overflow){overflow:hidden;white-space:nowrap;text-overflow:ellipsis;}"
};
const $d1b33a989f10eb2f$export$959bd343ec1d44de = {
    name: "25qy8u",
    styles: ".ProseMirror mark[data-type-ahead-query=\"true\"]:has(.placeholder-decoration-wrap){white-space:nowrap;}"
};

});

parcelRegister("5mW2j", function(module, exports) {
$parcel$export(module.exports, "resizerStyles", () => $4f9aebd5f6249d37$export$ce55ec61aa49b942);
$parcel$export(module.exports, "pragmaticResizerStylesForTooltip", () => $4f9aebd5f6249d37$export$21b363e15a3a4b0b);
$parcel$export(module.exports, "pragmaticStylesLayoutFirstNodeResizeHandleFix", () => $4f9aebd5f6249d37$export$241444dc11ae22d6);
$parcel$export(module.exports, "pragmaticResizerStyles", () => $4f9aebd5f6249d37$export$62cd5dfd9881f590);
$parcel$export(module.exports, "pragmaticResizerStylesNew", () => $4f9aebd5f6249d37$export$4f3e1cb10ec03a18);
$parcel$export(module.exports, "pragmaticResizerStylesWithReducedEditorGutter", () => $4f9aebd5f6249d37$export$2785010673d864e4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");
function $4f9aebd5f6249d37$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4f9aebd5f6249d37$export$a06160db3520e5a2 = 'resizer-item';
const $4f9aebd5f6249d37$export$c42cdcfd48254bda = 'resizer-hover-zone';
const $4f9aebd5f6249d37$export$10b67c6ff1748bd = 'resizer-is-extended';
const $4f9aebd5f6249d37$export$6afc20f0ff6d041 = 'resizer-handle';
const $4f9aebd5f6249d37$export$a5792d7e2a486d41 = `${$4f9aebd5f6249d37$export$6afc20f0ff6d041}-track`;
const $4f9aebd5f6249d37$export$2201bc1aaee73f36 = `${$4f9aebd5f6249d37$export$6afc20f0ff6d041}-thumb`;
const $4f9aebd5f6249d37$export$97a99610b6f0a178 = `${$4f9aebd5f6249d37$export$6afc20f0ff6d041}-danger`;
const $4f9aebd5f6249d37$export$b5fa87f62ced4967 = 3;
const $4f9aebd5f6249d37$export$b123b2c8a2536d05 = 'resizer-handle-wrapper';
const $4f9aebd5f6249d37$export$ce55ec61aa49b942 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$4f9aebd5f6249d37$export$a06160db3520e5a2}`]: {
        willChange: 'width',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&:hover, &.display-handle': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& > .${$4f9aebd5f6249d37$export$b123b2c8a2536d05} > .${$4f9aebd5f6249d37$export$6afc20f0ff6d041}`]: {
                visibility: 'visible',
                opacity: 1
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.is-resizing': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$4f9aebd5f6249d37$export$2201bc1aaee73f36}`]: {
                background: "var(--ds-border-focused, #388BFF)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`&.${$4f9aebd5f6249d37$export$97a99610b6f0a178}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$4f9aebd5f6249d37$export$2201bc1aaee73f36}`]: {
                transition: 'none',
                background: "var(--ds-icon-danger, #C9372C)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$4f9aebd5f6249d37$export$6afc20f0ff6d041}`]: {
        display: 'flex',
        visibility: 'hidden',
        opacity: 0,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: 7,
        transition: 'visibility 0.2s, opacity 0.2s',
        // NOTE: The below style is targeted at the div element added by the tooltip. We don't have any means of injecting styles
        // into the tooltip
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "& div[role='presentation']": {
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: "var(--ds-space-negative-200, -16px)",
            whiteSpace: 'normal'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.left': {
            alignItems: 'flex-start'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.right': {
            alignItems: 'flex-end'
        },
        // Handle Sizing
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.small': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$4f9aebd5f6249d37$export$2201bc1aaee73f36}`]: {
                height: 43
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.medium': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$4f9aebd5f6249d37$export$2201bc1aaee73f36}`]: {
                height: 64
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.large': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$4f9aebd5f6249d37$export$2201bc1aaee73f36}`]: {
                height: 96
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.clamped': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$4f9aebd5f6249d37$export$2201bc1aaee73f36}`]: {
                height: 'clamp(43px, calc(100% - 32px), 96px)'
            }
        },
        // Handle Alignment
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.sticky': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$4f9aebd5f6249d37$export$2201bc1aaee73f36}`]: {
                position: 'sticky',
                top: "var(--ds-space-150, 12px)",
                bottom: "var(--ds-space-150, 12px)"
            }
        },
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$4f9aebd5f6249d37$export$2201bc1aaee73f36}`]: {
                background: "var(--ds-border-focused, #388BFF)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$4f9aebd5f6249d37$export$a5792d7e2a486d41}`]: {
                visibility: 'visible',
                opacity: 0.5
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$4f9aebd5f6249d37$export$2201bc1aaee73f36}`]: {
        content: "' '",
        display: 'flex',
        width: 3,
        margin: `0 ${"var(--ds-space-025, 2px)"}`,
        height: 64,
        transition: 'background-color 0.2s',
        borderRadius: "var(--ds-radius-medium, 6px)",
        border: 0,
        padding: 0,
        zIndex: 2,
        outline: 'none',
        minHeight: 24,
        background: "var(--ds-border, #091E4224)",
        '&:hover': {
            cursor: 'col-resize'
        },
        '&:focus': {
            background: "var(--ds-border-selected, #0C66E4)",
            '&::after': {
                content: "''",
                position: 'absolute',
                top: "var(--ds-space-negative-050, -4px)",
                right: "var(--ds-space-negative-050, -4px)",
                bottom: "var(--ds-space-negative-050, -4px)",
                left: "var(--ds-space-negative-050, -4px)",
                border: `2px solid ${"var(--ds-border-focused, #388BFF)"}`,
                borderRadius: 'inherit',
                zIndex: -1
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$4f9aebd5f6249d37$export$a5792d7e2a486d41}`]: {
        visibility: 'hidden',
        position: 'absolute',
        width: 7,
        height: 'calc(100% - 40px)',
        borderRadius: "var(--ds-radius-small, 4px)",
        opacity: 0,
        transition: 'background-color 0.2s, visibility 0.2s, opacity 0.2s',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.none': {
            background: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.shadow': {
            background: "var(--ds-background-selected, #E9F2FF)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.full-height': {
            background: "var(--ds-background-selected, #E9F2FF)",
            height: '100%',
            minHeight: 36
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    '.ak-editor-selected-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`& .${$4f9aebd5f6249d37$export$2201bc1aaee73f36}`]: {
            background: "var(--ds-border-focused, #388BFF)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.ak-editor-no-interaction .ak-editor-selected-node .${$4f9aebd5f6249d37$export$6afc20f0ff6d041}:not(:hover) .${$4f9aebd5f6249d37$export$2201bc1aaee73f36}`]: {
        background: "var(--ds-border, #091E4224)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`&.resizer-hover-zone-cls-fix .${$4f9aebd5f6249d37$export$c42cdcfd48254bda}`]: {
        display: 'flow-root'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$4f9aebd5f6249d37$export$c42cdcfd48254bda}`]: {
        position: 'relative',
        display: 'inline-block',
        width: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`&.${$4f9aebd5f6249d37$export$10b67c6ff1748bd}`]: {
            padding: `0 ${"var(--ds-space-150, 12px)"}`,
            left: "var(--ds-space-negative-150, -12px)"
        }
    },
    // This below style is here to make sure the image width is correct when nested in a table
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`table .${$4f9aebd5f6249d37$export$c42cdcfd48254bda}, table .${$4f9aebd5f6249d37$export$c42cdcfd48254bda}.${$4f9aebd5f6249d37$export$10b67c6ff1748bd}`]: {
        padding: 'unset',
        left: 'unset'
    }
});
const $4f9aebd5f6249d37$export$21b363e15a3a4b0b = {
    name: "1rqtth7",
    styles: ".pm-breakout-resize-handle-rail-wrapper{display:flex;align-items:center;justify-content:center;height:100%;cursor:col-resize;border-radius:var(--ds-radius-small, 4px);z-index:2;[role=\"presentation\"]{height:100%;width:100%;}.pm-breakout-resize-handle-rail-inside-tooltip{height:100%;}}"
};
const $4f9aebd5f6249d37$export$241444dc11ae22d6 = {
    name: "zqeg2w",
    styles: ".fabric-editor-breakout-mark{&:has([data-prosemirror-node-name=\"layoutSection\"].first-node-in-document){> .pm-breakout-resize-handle-container{height:calc(100% - 8px);}}}"
};
const $4f9aebd5f6249d37$export$62cd5dfd9881f590 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.fabric-editor-breakout-mark': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has([data-prosemirror-node-name="codeBlock"])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container--left': {
                left: '-12px'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container--right': {
                right: '-12px'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container': {
                height: 'calc(100% - 12px)'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has([data-prosemirror-node-name="expand"]), &:has([data-prosemirror-node-name="layoutSection"])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container--left': {
                left: '-32px'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container--right': {
                right: '-32px'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has([data-prosemirror-node-name="expand"])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container': {
                height: 'calc(100% - 4px)'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has([data-prosemirror-node-name="layoutSection"])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container': {
                height: 'calc(100% - 8px)'
            }
        },
        // the first node in the document always has margin-top = 0
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.first-node-in-document)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container': {
                height: '100%'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container': {
        position: 'relative',
        alignSelf: 'end',
        gridRow: 1,
        gridColumn: 1,
        height: '100%',
        width: 7
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container--left': {
        justifySelf: 'start'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container--right': {
        justifySelf: 'end'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-rail': {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        cursor: 'col-resize',
        borderRadius: "var(--ds-radius-small, 4px)",
        transition: 'background-color 0.2s, visibility 0.2s, opacity 0.2s',
        zIndex: 2,
        opacity: 0,
        '&:hover': {
            background: "var(--ds-background-selected, #E9F2FF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.pm-breakout-resize-handle-thumb': {
                background: "var(--ds-border-focused, #388BFF)"
            }
        }
    },
    // same as 'hover' styles above
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container--active': {
        background: "var(--ds-background-selected, #E9F2FF)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.pm-breakout-resize-handle-thumb': {
            background: "var(--ds-border-focused, #388BFF)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-hit-box': {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: -20,
        right: -20,
        zIndex: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-thumb': {
        minWidth: $4f9aebd5f6249d37$export$b5fa87f62ced4967,
        // copied from resizeStyles.clamped
        height: 'clamp(27px, calc(100% - 32px), 96px)',
        background: "var(--ds-border, #091E4224)",
        borderRadius: "var(--ds-radius-medium, 6px)",
        // sticky styles
        position: 'sticky',
        top: "var(--ds-space-150, 12px)",
        bottom: "var(--ds-space-150, 12px)"
    }
});
const $4f9aebd5f6249d37$export$4f3e1cb10ec03a18 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.fabric-editor-breakout-mark': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has([data-prosemirror-node-name="codeBlock"])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container--left': {
                left: '-5px'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container--right': {
                right: '-5px'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container': {
                height: 'calc(100% - 12px)'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has([data-prosemirror-node-name="expand"]), &:has([data-prosemirror-node-name="layoutSection"])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container--left': {
                left: '-25px'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container--right': {
                right: '-25px'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has([data-prosemirror-node-name="expand"])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container': {
                height: 'calc(100% - 4px)'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has([data-prosemirror-node-name="layoutSection"])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container': {
                height: 'calc(100% - 8px)'
            }
        },
        // the first node in the document always has margin-top = 0
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.first-node-in-document)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container': {
                height: '100%'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container': {
        position: 'relative',
        alignSelf: 'end',
        gridRow: 1,
        gridColumn: 1,
        height: '100%',
        width: 7
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container--left': {
        justifySelf: 'start'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container--right': {
        justifySelf: 'end'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-rail': {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        cursor: 'col-resize',
        borderRadius: "var(--ds-radius-small, 4px)",
        transition: 'background-color 0.2s, visibility 0.2s, opacity 0.2s',
        zIndex: 2,
        opacity: 0,
        '&:hover': {
            background: "var(--ds-background-selected, #E9F2FF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.pm-breakout-resize-handle-thumb': {
                background: "var(--ds-border-focused, #388BFF)"
            }
        }
    },
    // same as 'hover' styles above
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container--active': {
        background: "var(--ds-background-selected, #E9F2FF)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.pm-breakout-resize-handle-thumb': {
            background: "var(--ds-border-focused, #388BFF)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-hit-box': {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: -20,
        right: -20,
        zIndex: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-thumb': {
        minWidth: $4f9aebd5f6249d37$export$b5fa87f62ced4967,
        // copied from resizeStyles.clamped
        height: 'clamp(27px, calc(100% - 32px), 96px)',
        background: "var(--ds-border, #091E4224)",
        borderRadius: "var(--ds-radius-medium, 6px)",
        // sticky styles
        position: 'sticky',
        top: "var(--ds-space-150, 12px)",
        bottom: "var(--ds-space-150, 12px)"
    }
});
const $4f9aebd5f6249d37$export$2785010673d864e4 = /*#__PURE__*/ (0, $1NIU8.css)({
    /* container editor-area is defined in platform/packages/editor/editor-core/src/ui/Appearance/FullPage/StyledComponents.ts */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`@container editor-area (max-width: ${0, $7yBx7.akEditorFullPageNarrowBreakout}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.fabric-editor-breakout-mark': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has([data-prosemirror-node-name="expand"]), &:has([data-prosemirror-node-name="layoutSection"])': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '> .pm-breakout-resize-handle-container': {
                    opacity: 0,
                    visibility: 'hidden'
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has([data-prosemirror-node-name="layoutSection"])': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
                [`.${$4f9aebd5f6249d37$export$a06160db3520e5a2}`]: {
                    willChange: 'width',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '&:hover, &.display-handle': {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
                        [`& > .${$4f9aebd5f6249d37$export$b123b2c8a2536d05} > .${$4f9aebd5f6249d37$export$6afc20f0ff6d041}`]: {
                            visibility: 'hidden',
                            opacity: 0
                        }
                    }
                }
            }
        }
    }
});

});

parcelRegister("ftB1y", function(module, exports) {
$parcel$export(module.exports, "ruleStyles", () => $5795383c614a8c7e$export$2413e968422424ec);
$parcel$export(module.exports, "dangerRuleStyles", () => $5795383c614a8c7e$export$e425548b5cacd57);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");
const $5795383c614a8c7e$export$2413e968422424ec = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror hr': {
        border: 'none',
        backgroundColor: "var(--ds-border, #091E4224)",
        height: '2px',
        borderRadius: '1px',
        // this should use token('radius.full') but cannot since the element has padding which increases its height beyond 2px
        cursor: 'pointer',
        padding: `${"var(--ds-space-050, 4px)"} 0`,
        margin: `${"var(--ds-space-300, 24px)"} 0`,
        backgroundClip: 'content-box'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror hr.${0, $7yBx7.akEditorSelectedNodeClassName}`]: {
        outline: 'none',
        backgroundColor: "var(--ds-border-selected, #0C66E4)"
    }
});
const $5795383c614a8c7e$export$e425548b5cacd57 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror hr.${0, $7yBx7.akEditorSelectedNodeClassName}.danger`]: {
        backgroundColor: "var(--ds-border-danger, #E2483D)"
    }
});

});

parcelRegister("khwCN", function(module, exports) {
$parcel$export(module.exports, "scrollbarStyles", () => $ce5959d77d71240d$export$b2380b18b089518f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
function $ce5959d77d71240d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ce5959d77d71240d$export$b2380b18b089518f = {
    name: "3owfxy",
    styles: "-ms-overflow-style:-ms-autohiding-scrollbar;&::-webkit-scrollbar-corner{display:none;}&::-webkit-scrollbar-thumb{background-color:var(--ds-background-neutral-subtle, #00000000);}&:hover::-webkit-scrollbar-thumb{background-color:var(--ds-background-neutral-bold, #44546F);border-radius:var(--ds-radius-large, 8px);}&::-webkit-scrollbar-thumb:hover{background-color:var(--ds-background-neutral-bold-hovered, #2C3E5D);}"
};

});

parcelRegister("krgOs", function(module, exports) {
$parcel$export(module.exports, "selectionToolbarAnimationStyles", () => $9d1f359457013a31$export$1629cb32bbba3a7e);

var $1NIU8 = parcelRequire("1NIU8");
const $9d1f359457013a31$var$fadeIn = (0, $1NIU8.keyframes)({
    from: {
        opacity: 0,
        transform: 'translateY(16px)'
    },
    to: {
        opacity: 1,
        transform: 'translateY(0)'
    }
});
const $9d1f359457013a31$export$1629cb32bbba3a7e = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "[aria-label='Selection toolbar']": {
        animationName: $9d1f359457013a31$var$fadeIn,
        animationDuration: `0.2s`,
        animationTimingFunction: `cubic-bezier(0.6, 0, 0, 1)`
    }
});

});

parcelRegister("bEDkR", function(module, exports) {
$parcel$export(module.exports, "shadowStyles", () => $0c992df02a25760d$export$9750a92ac0203c10);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");
const $0c992df02a25760d$export$4735dd2b0fa88aa5 = {
    RIGHT_SHADOW: 'right-shadow',
    LEFT_SHADOW: 'left-shadow'
};
const $0c992df02a25760d$export$1cbe0bb16052178d = {
    SENTINEL_LEFT: 'sentinel-left',
    SENTINEL_RIGHT: 'sentinel-right',
    SHADOW_CONTAINER: 'with-shadow-observer'
};
const $0c992df02a25760d$export$9750a92ac0203c10 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${$0c992df02a25760d$export$4735dd2b0fa88aa5.RIGHT_SHADOW}::before, .${$0c992df02a25760d$export$4735dd2b0fa88aa5.RIGHT_SHADOW}::after, .${$0c992df02a25760d$export$4735dd2b0fa88aa5.LEFT_SHADOW}::before, .${$0c992df02a25760d$export$4735dd2b0fa88aa5.LEFT_SHADOW}::after`]: {
            display: 'none',
            position: 'absolute',
            pointerEvents: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            zIndex: 2,
            width: 8,
            content: "''",
            height: 'calc(100%)'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${$0c992df02a25760d$export$4735dd2b0fa88aa5.RIGHT_SHADOW}, .${$0c992df02a25760d$export$4735dd2b0fa88aa5.LEFT_SHADOW}`]: {
            position: 'relative'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${$0c992df02a25760d$export$4735dd2b0fa88aa5.LEFT_SHADOW}::before`]: {
            background: `linear-gradient(to left, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to right, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px)`,
            top: 0,
            left: 0,
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${$0c992df02a25760d$export$4735dd2b0fa88aa5.RIGHT_SHADOW}::after`]: {
            background: `linear-gradient(to right, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to left, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px)`,
            right: 0,
            top: 0,
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${$0c992df02a25760d$export$1cbe0bb16052178d.SENTINEL_LEFT}`]: {
            height: '100%',
            width: 0,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${$0c992df02a25760d$export$1cbe0bb16052178d.SENTINEL_RIGHT}`]: {
            height: '100%',
            width: 0,
            minWidth: 0
        }
    }
});

});

parcelRegister("6uQ8z", function(module, exports) {
$parcel$export(module.exports, "editorControlsSmartCardStyles", () => $cb72127d5cad6aec$export$f64b12e3fb171ebc);
$parcel$export(module.exports, "smartCardDiffStyles", () => $cb72127d5cad6aec$export$1fef993256efc96e);
$parcel$export(module.exports, "showDiffDeletedNodeStyles", () => $cb72127d5cad6aec$export$4d8f0e547724198);
$parcel$export(module.exports, "smartCardStyles", () => $cb72127d5cad6aec$export$b346a5d6d598424c);
$parcel$export(module.exports, "smartCardStylesWithSearchMatch", () => $cb72127d5cad6aec$export$56d86af0724ad29e);
$parcel$export(module.exports, "smartCardStylesWithSearchMatchAndBlockMenuDangerStyles", () => $cb72127d5cad6aec$export$42b66ad40efe5bbe);
$parcel$export(module.exports, "smartCardStylesWithSearchMatchAndPreviewPanelResponsiveness", () => $cb72127d5cad6aec$export$fefb174a4d9f4c0);
$parcel$export(module.exports, "smartLinksInLivePagesStyles", () => $cb72127d5cad6aec$export$cb0683bb9c4e1322);
$parcel$export(module.exports, "linkingVisualRefreshV1Styles", () => $cb72127d5cad6aec$export$1a87a16059da4299);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");

var $famkW = parcelRequire("famkW");
const $cb72127d5cad6aec$export$32f80df830e375f6 = 'datasourceView-content-inner-wrap';
const $cb72127d5cad6aec$export$863ae87a9d233606 = 'card-floating-toolbar--link-picker';
const $cb72127d5cad6aec$export$4ccd31bf665a88f6 = {
    INLINE_CARD_CONTAINER: 'inlineCardView-content-wrap',
    BLOCK_CARD_CONTAINER: 'blockCardView-content-wrap',
    EMBED_CARD_CONTAINER: 'embedCardView-content-wrap',
    DATASOURCE_CONTAINER: 'datasourceView-content-wrap',
    LOADER_WRAPPER: 'loader-wrapper'
};
const $cb72127d5cad6aec$export$f64b12e3fb171ebc = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.INLINE_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-inlinecard-button-overlay="icon-wrapper-line-height"] span': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 0
        }
    }
});
const $cb72127d5cad6aec$export$1fef993256efc96e = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
    [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`&[data-testid="show-diff-changed-decoration-node"] .${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 1px var(--diff-decoration-marker-color)`,
            borderColor: 'transparent'
        }
    }
});
const $cb72127d5cad6aec$export$4d8f0e547724198 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
    [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
        [`&.show-diff-deleted-node .${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 1px ${"var(--ds-border-accent-gray, #758195)"}`,
            borderColor: 'transparent'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.mediaSingleView-content-wrap.show-diff-deleted-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > div': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 1px ${"var(--ds-border-accent-gray, #758195)"}`,
            borderRadius: "var(--ds-radius-small, 4px)"
        }
    }
});
const $cb72127d5cad6aec$export$b346a5d6d598424c = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.INLINE_CARD_CONTAINER}`]: {
        maxWidth: 'calc(100% - 20px)',
        verticalAlign: 'top',
        wordBreak: 'break-all',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.card-with-comment': {
            background: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
            borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.card': {
            paddingLeft: "var(--ds-space-025, 2px)",
            paddingRight: "var(--ds-space-025, 2px)",
            paddingTop: "var(--ds-space-100, 0.5em)",
            paddingBottom: "var(--ds-space-100, 0.5em)",
            marginBottom: "var(--ds-space-negative-100, -0.5em)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a:focus`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $famkW.boxShadowSelectionStyles),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $famkW.hideNativeBrowserTextSelectionStyles)
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.boxShadowSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.hideNativeBrowserTextSelectionStyles)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: {
            // EDM-1717: box-shadow Safari fix start
            zIndex: 1,
            position: 'relative'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                // EDM-1717: box-shadow Safari fix start
                zIndex: 2
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        display: 'block',
        margin: '0.75rem 0 0',
        maxWidth: `${760}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.boxShadowSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.hideNativeBrowserTextSelectionStyles),
            {
                borderRadius: "var(--ds-radius-large, 8px)"
            }
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.DATASOURCE_CONTAINER}.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        maxWidth: '100%',
        display: 'flex',
        justifyContent: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$cb72127d5cad6aec$export$32f80df830e375f6}`]: {
            cursor: 'pointer',
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
            borderRadius: "var(--ds-radius-large, 8px)",
            border: `1px solid ${"var(--ds-border, #091E4224)"}`,
            overflow: 'hidden'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$cb72127d5cad6aec$export$32f80df830e375f6}`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $famkW.boxShadowSelectionStyles),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $famkW.hideNativeBrowserTextSelectionStyles),
                {
                    'input::selection': {
                        backgroundColor: "var(--ds-background-selected-hovered, #CCE0FF)"
                    },
                    'input::-moz-selection': {
                        backgroundColor: "var(--ds-background-selected-hovered, #CCE0FF)"
                    }
                }
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$cb72127d5cad6aec$export$32f80df830e375f6}`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
            cursor: 'pointer',
            '&::after': {
                transition: 'box-shadow 0s'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.boxShadowSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.hideNativeBrowserTextSelectionStyles)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.media-card-frame::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                background: `${"var(--ds-background-danger, #FFECEB)"} !important`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.richMedia-resize-handle-right::after, .richMedia-resize-handle-left::after': {
                background: "var(--ds-border-danger, #E2483D)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$cb72127d5cad6aec$export$863ae87a9d233606}`]: {
        padding: 0
    }
});
const $cb72127d5cad6aec$export$56d86af0724ad29e = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.INLINE_CARD_CONTAINER}`]: {
        maxWidth: 'calc(100% - 20px)',
        verticalAlign: 'top',
        wordBreak: 'break-all',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.card-with-comment': {
            background: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
            borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.card': {
            paddingLeft: "var(--ds-space-025, 2px)",
            paddingRight: "var(--ds-space-025, 2px)",
            paddingTop: "var(--ds-space-100, 0.5em)",
            paddingBottom: "var(--ds-space-100, 0.5em)",
            marginBottom: "var(--ds-space-negative-100, -0.5em)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a:focus`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $famkW.boxShadowSelectionStyles),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $famkW.hideNativeBrowserTextSelectionStyles)
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.hideNativeBrowserTextSelectionStyles)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node:not(.search-match-block) .${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.boxShadowSelectionStyles)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: {
            // EDM-1717: box-shadow Safari fix start
            zIndex: 1,
            position: 'relative'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                // EDM-1717: box-shadow Safari fix start
                zIndex: 2
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        display: 'block',
        margin: '0.75rem 0 0',
        maxWidth: `${760}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.boxShadowSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.hideNativeBrowserTextSelectionStyles),
            {
                borderRadius: "var(--ds-radius-large, 8px)"
            }
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.DATASOURCE_CONTAINER}.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        maxWidth: '100%',
        display: 'flex',
        justifyContent: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$cb72127d5cad6aec$export$32f80df830e375f6}`]: {
            cursor: 'pointer',
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
            borderRadius: "var(--ds-radius-large, 8px)",
            border: `1px solid ${"var(--ds-border, #091E4224)"}`,
            overflow: 'hidden'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$cb72127d5cad6aec$export$32f80df830e375f6}`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $famkW.boxShadowSelectionStyles),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $famkW.hideNativeBrowserTextSelectionStyles),
                {
                    'input::selection': {
                        backgroundColor: "var(--ds-background-selected-hovered, #CCE0FF)"
                    },
                    'input::-moz-selection': {
                        backgroundColor: "var(--ds-background-selected-hovered, #CCE0FF)"
                    }
                }
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$cb72127d5cad6aec$export$32f80df830e375f6}`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
            cursor: 'pointer',
            '&::after': {
                transition: 'box-shadow 0s'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.hideNativeBrowserTextSelectionStyles)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node:not(.search-match-block) .${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.boxShadowSelectionStyles)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.media-card-frame::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                background: `${"var(--ds-background-danger, #FFECEB)"} !important`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.richMedia-resize-handle-right::after, .richMedia-resize-handle-left::after': {
                background: "var(--ds-border-danger, #E2483D)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$cb72127d5cad6aec$export$863ae87a9d233606}`]: {
        padding: 0
    }
});
const $cb72127d5cad6aec$export$42b66ad40efe5bbe = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.INLINE_CARD_CONTAINER}`]: {
        maxWidth: 'calc(100% - 20px)',
        verticalAlign: 'top',
        wordBreak: 'break-all',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.card-with-comment': {
            background: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
            borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.card': {
            paddingLeft: "var(--ds-space-025, 2px)",
            paddingRight: "var(--ds-space-025, 2px)",
            paddingTop: "var(--ds-space-100, 0.5em)",
            paddingBottom: "var(--ds-space-100, 0.5em)",
            marginBottom: "var(--ds-space-negative-100, -0.5em)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a:focus`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $famkW.boxShadowSelectionStyles),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $famkW.hideNativeBrowserTextSelectionStyles)
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.hideNativeBrowserTextSelectionStyles)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node:not(.search-match-block):not(.danger) .${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.boxShadowSelectionStyles)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: {
            // EDM-1717: box-shadow Safari fix start
            zIndex: 1,
            position: 'relative'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                // EDM-1717: box-shadow Safari fix start
                zIndex: 2
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        display: 'block',
        margin: '0.75rem 0 0',
        maxWidth: `${760}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.boxShadowSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.hideNativeBrowserTextSelectionStyles),
            {
                borderRadius: "var(--ds-radius-large, 8px)"
            }
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.DATASOURCE_CONTAINER}.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        maxWidth: '100%',
        display: 'flex',
        justifyContent: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$cb72127d5cad6aec$export$32f80df830e375f6}`]: {
            cursor: 'pointer',
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
            borderRadius: "var(--ds-radius-large, 8px)",
            border: `1px solid ${"var(--ds-border, #091E4224)"}`,
            overflow: 'hidden'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$cb72127d5cad6aec$export$32f80df830e375f6}`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $famkW.boxShadowSelectionStyles),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $famkW.hideNativeBrowserTextSelectionStyles),
                {
                    'input::selection': {
                        backgroundColor: "var(--ds-background-selected-hovered, #CCE0FF)"
                    },
                    'input::-moz-selection': {
                        backgroundColor: "var(--ds-background-selected-hovered, #CCE0FF)"
                    }
                }
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$cb72127d5cad6aec$export$32f80df830e375f6}`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
            cursor: 'pointer',
            '&::after': {
                transition: 'box-shadow 0s'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.hideNativeBrowserTextSelectionStyles)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node:not(.search-match-block) .${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.boxShadowSelectionStyles)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.media-card-frame::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                background: `${"var(--ds-background-danger, #FFECEB)"} !important`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.richMedia-resize-handle-right::after, .richMedia-resize-handle-left::after': {
                background: "var(--ds-border-danger, #E2483D)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$cb72127d5cad6aec$export$863ae87a9d233606}`]: {
        padding: 0
    }
});
const $cb72127d5cad6aec$export$fefb174a4d9f4c0 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`@container editor-area (max-width: ${0, $7yBx7.akEditorFullPageNarrowBreakout}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors
        [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
            marginTop: "var(--ds-space-150, 0.75rem)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}.ak-editor-selected-node .${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.boxShadowSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.hideNativeBrowserTextSelectionStyles),
            {
                borderRadius: "var(--ds-radius-large, 8px)"
            }
        ]
    }
});
const $cb72127d5cad6aec$export$cb0683bb9c4e1322 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
            cursor: 'pointer',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            a: {
                cursor: 'auto'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            a: {
                cursor: 'auto'
            }
        }
    }
});
const $cb72127d5cad6aec$export$1a87a16059da4299 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}:not(.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.DATASOURCE_CONTAINER})`]: {
        // EDM-11991: Fix list plugin adding padding to ADS AvatarGroup
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ul, ol': {
            paddingLeft: 'inherit'
        }
    }
});

});

parcelRegister("cZpyt", function(module, exports) {
$parcel$export(module.exports, "statusStyles", () => $f5157a89598b2125$export$79c8c9ad308bbe07);
$parcel$export(module.exports, "statusStylesMixin_fg_platform_component_visual_refresh", () => $f5157a89598b2125$export$7c209f30e9068068);
$parcel$export(module.exports, "statusStylesMixin_fg_platform_component_visual_refresh_with_search_match", () => $f5157a89598b2125$export$8b4cca12f7a094c7);
$parcel$export(module.exports, "statusDangerStyles", () => $f5157a89598b2125$export$bd58d1bcb934912c);
$parcel$export(module.exports, "statusStylesMixin_without_fg_platform_component_visual_refresh", () => $f5157a89598b2125$export$dc185896d75d4b4);
$parcel$export(module.exports, "statusStylesMixin_without_fg_platform_component_visual_refresh_with_search_match", () => $f5157a89598b2125$export$60b421c3da7a2a99);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");
const $f5157a89598b2125$export$79c8c9ad308bbe07 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-table-cell-content-wrap, .pm-table-header-content-wrap, [data-layout-section]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.statusView-content-wrap': {
            maxWidth: '100%',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& > span': {
                width: '100%'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.statusView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > span': {
            cursor: 'pointer',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 0 // Prevent responsive layouts increasing height of container.
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.status-lozenge-span > span': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            backgroundColor: 'rgba(255, 189, 173, 0.5)' // akEditorDeleteBackgroundWithOpacity
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.statusView-content-wrap.ak-editor-selected-node': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.status-lozenge-span > span': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-neutral, #091E420F)",
        maxWidth: '100%',
        paddingInline: "var(--ds-space-050, 4px)",
        display: 'inline-flex',
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
        borderRadius: "var(--ds-radius-small, 3px)",
        blockSize: 'min-content',
        position: 'static',
        overflow: 'hidden',
        boxSizing: 'border-box',
        appearance: 'none',
        border: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] .lozenge-text': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '11px',
        fontStyle: 'normal',
        fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-bold, 700)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '16px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        maxWidth: `calc(200px - ${"var(--ds-space-100, 8px)"})`
    }
});
const $f5157a89598b2125$export$7c209f30e9068068 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.statusView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node .status-lozenge-span > span': {
            boxShadow: `0 0 0 2px ${"var(--ds-border-selected, #0C66E4)"}`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] .lozenge-text': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        color: '#292A2E'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=neutral] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#DDDEE1'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=purple] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#D8A0F7'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=blue] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#8FB8F6'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=yellow] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#F9C84E'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=red] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#FD9891'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=green] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#B3DF72'
    }
});
const $f5157a89598b2125$export$8b4cca12f7a094c7 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.statusView-content-wrap:not(.search-match-block)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node .status-lozenge-span > span': {
            boxShadow: `0 0 0 2px ${"var(--ds-border-selected, #0C66E4)"}`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] .lozenge-text': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        color: '#292A2E'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=neutral] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#DDDEE1'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=purple] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#D8A0F7'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=blue] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#8FB8F6'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=yellow] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#F9C84E'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=red] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#FD9891'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=green] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#B3DF72'
    }
});
const $f5157a89598b2125$export$bd58d1bcb934912c = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.statusView-content-wrap:not(.search-match-block)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node.danger .status-lozenge-span > span': {
            boxShadow: `0 0 0 2px ${"var(--ds-border-danger, #E2483D)"}`
        }
    }
});
const $f5157a89598b2125$export$dc185896d75d4b4 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.statusView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node .status-lozenge-span > span': {
            // getSelectionStyles([SelectionStyle.BoxShadow]);
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}`,
            borderColor: 'transparent',
            // hideNativeBrowserTextSelectionStyles
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&::selection, & *::selection': {
                backgroundColor: 'transparent'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&::-moz-selection, & *::-moz-selection': {
                backgroundColor: 'transparent'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=neutral] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-neutral, #091E420F)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=neutral] .lozenge-text': {
        color: "var(--ds-text-subtle, #44546F)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=purple] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-discovery, #F3F0FF)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=purple] .lozenge-text': {
        color: "var(--ds-text-discovery, #5E4DB2)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=blue] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-information, #E9F2FF)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=blue] .lozenge-text': {
        color: "var(--ds-text-information, #0055CC)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=yellow] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-warning, #FFF7D6)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=yellow] .lozenge-text': {
        color: "var(--ds-text-warning, #A54800)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=red] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-danger, #FFECEB)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=red] .lozenge-text': {
        color: "var(--ds-text-danger, #AE2E24)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=green] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-success, #DCFFF1)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=green] .lozenge-text': {
        color: "var(--ds-text-success, #216E4E)"
    }
});
const $f5157a89598b2125$export$60b421c3da7a2a99 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.statusView-content-wrap:not(.search-match-block)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node .status-lozenge-span > span': {
            // getSelectionStyles([SelectionStyle.BoxShadow]);
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}`,
            borderColor: 'transparent',
            // hideNativeBrowserTextSelectionStyles
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&::selection, & *::selection': {
                backgroundColor: 'transparent'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&::-moz-selection, & *::-moz-selection': {
                backgroundColor: 'transparent'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=neutral] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-neutral, #091E420F)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=neutral] .lozenge-text': {
        color: "var(--ds-text-subtle, #44546F)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=purple] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-discovery, #F3F0FF)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=purple] .lozenge-text': {
        color: "var(--ds-text-discovery, #5E4DB2)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=blue] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-information, #E9F2FF)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=blue] .lozenge-text': {
        color: "var(--ds-text-information, #0055CC)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=yellow] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-warning, #FFF7D6)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=yellow] .lozenge-text': {
        color: "var(--ds-text-warning, #A54800)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=red] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-danger, #FFECEB)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=red] .lozenge-text': {
        color: "var(--ds-text-danger, #AE2E24)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=green] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-success, #DCFFF1)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=green] .lozenge-text': {
        color: "var(--ds-text-success, #216E4E)"
    }
});

});

parcelRegister("iZ3Ak", function(module, exports) {
$parcel$export(module.exports, "syncBlockStyles", () => $52990d0215e44f98$export$2ef961ae194ff4dc);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");

var $c5jKU = parcelRequire("c5jKU");

var $7yBx7 = parcelRequire("7yBx7");
const $52990d0215e44f98$export$2ef961ae194ff4dc = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $c5jKU.SyncBlockSharedCssClassName).prefix}, .${(0, $c5jKU.BodiedSyncBlockSharedCssClassName).prefix}`]: {
            position: 'relative',
            cursor: 'pointer',
            /* Danger when top level node */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                backgroundColor: `${"var(--ds-background-danger, #FFECEB)"} !important`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.ak-editor-panel__icon': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                    color: `${"var(--ds-icon-danger, #C9372C)"} !important`
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                [`.${(0, $c5jKU.SyncBlockLabelSharedCssClassName).labelClassName}`]: {
                    backgroundColor: "var(--ds-background-danger, #FFECEB)",
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: '-1px',
                        left: '-1px',
                        right: '-1px',
                        bottom: '-1px',
                        border: `1px solid ${"var(--ds-border-danger, #E2483D)"}`,
                        borderRadius: "var(--ds-radius-small, 3px)",
                        mask: 'linear-gradient(to bottom, black 55%, transparent 55%)',
                        WebkitMask: 'linear-gradient(to bottom, black 55%, transparent 55%)',
                        pointerEvents: 'none',
                        zIndex: -1
                    }
                }
            },
            borderRadius: "var(--ds-radius-small, 3px)",
            marginTop: "var(--ds-space-150, 12px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            marginRight: `-${(0, $7yBx7.akEditorGutterPadding)}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            marginLeft: `-${(0, $7yBx7.akEditorGutterPadding)}px`,
            marginBottom: 0,
            paddingTop: "var(--ds-space-050, 4px)",
            paddingBottom: "var(--ds-space-050, 4px)",
            color: 'inherit',
            '&:hover': {
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
                boxShadow: `0px 0px 0px 1px ${"var(--ds-border, #091E4224)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`.${(0, $c5jKU.BodiedSyncBlockSharedCssClassName).content}`]: {
                padding: '0 32px',
                cursor: 'text'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`.${(0, $c5jKU.SyncBlockSharedCssClassName).renderer}`]: {
                padding: '0 32px'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${(0, $c5jKU.SyncBlockSharedCssClassName).prefix}.ak-editor-selected-node:not(.danger), .${(0, $c5jKU.BodiedSyncBlockSharedCssClassName).prefix}.ak-editor-selected-node:not(.danger)`]: {
        boxShadow: `0 0 0 1px ${"var(--ds-border-focused, #388BFF)"}`,
        backgroundColor: "var(--ds-background-selected, #E9F2FF)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $c5jKU.SyncBlockLabelSharedCssClassName).labelClassName}`]: {
            backgroundColor: "var(--ds-background-selected, #E9F2FF)",
            '&::before': {
                content: '""',
                position: 'absolute',
                top: '-1px',
                left: '-1px',
                right: '-1px',
                bottom: '-1px',
                border: `1px solid ${"var(--ds-border-focused, #388BFF)"}`,
                borderRadius: "var(--ds-radius-small, 3px)",
                mask: 'linear-gradient(to bottom, black 55%, transparent 55%)',
                WebkitMask: 'linear-gradient(to bottom, black 55%, transparent 55%)',
                pointerEvents: 'none',
                zIndex: -1
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${(0, $c5jKU.SyncBlockSharedCssClassName).prefix}.ak-editor-selected-node, .${(0, $c5jKU.SyncBlockSharedCssClassName).prefix}:hover, .${(0, $c5jKU.BodiedSyncBlockSharedCssClassName).prefix}.ak-editor-selected-node, .${(0, $c5jKU.BodiedSyncBlockSharedCssClassName).prefix}:hover, .${(0, $c5jKU.BodiedSyncBlockSharedCssClassName).prefix}.danger, ${(0, $c5jKU.SyncBlockLabelSharedCssClassName).labelClassName}:hover`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $c5jKU.SyncBlockLabelSharedCssClassName).labelClassName}`]: {
            opacity: 1,
            visibility: 'visible'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${(0, $c5jKU.SyncBlockSharedCssClassName).prefix}:has(.${(0, $c5jKU.SyncBlockSharedCssClassName).error}), .${(0, $c5jKU.BodiedSyncBlockSharedCssClassName).prefix}:has(.${(0, $c5jKU.SyncBlockSharedCssClassName).error})`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:hover:not(.ak-editor-selected-node)': {
            boxShadow: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node, &:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`.${(0, $c5jKU.SyncBlockLabelSharedCssClassName).labelClassName}`]: {
                opacity: 0,
                visibility: 'hidden'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${(0, $c5jKU.SyncBlockLabelSharedCssClassName).labelClassName}`]: {
        color: "var(--ds-text-subtle, #44546F)",
        borderRadius: "var(--ds-radius-small, 3px)",
        position: 'absolute',
        gap: "var(--ds-space-050, 4px)",
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        opacity: 0,
        visibility: 'hidden',
        paddingLeft: "var(--ds-space-100, 8px)",
        paddingRight: "var(--ds-space-100, 8px)",
        paddingBottom: "var(--ds-space-050, 4px)",
        paddingTop: "var(--ds-space-050, 4px)",
        top: "var(--ds-space-negative-200, -16px)",
        right: "var(--ds-space-150, 12px)",
        backgroundColor: "var(--ds-surface, #FFFFFF)",
        maxWidth: '140px'
    }
});

});
parcelRegister("c5jKU", function(module, exports) {
$parcel$export(module.exports, "SyncBlockSharedCssClassName", () => $34aa318834c7ba9a$export$84840734cffb342f);
$parcel$export(module.exports, "BodiedSyncBlockSharedCssClassName", () => $34aa318834c7ba9a$export$628f41eb22ec9a2);
$parcel$export(module.exports, "SyncBlockLabelSharedCssClassName", () => $34aa318834c7ba9a$export$f75b6075afbd73af);
const $34aa318834c7ba9a$var$prefix = 'ak-editor-sync-block';
const $34aa318834c7ba9a$export$84840734cffb342f = {
    prefix: $34aa318834c7ba9a$var$prefix,
    renderer: `${$34aa318834c7ba9a$var$prefix}__renderer`,
    error: `${$34aa318834c7ba9a$var$prefix}__error_state`
};
const $34aa318834c7ba9a$var$bodiedPrefix = 'ak-editor-bodied-sync-block';
const $34aa318834c7ba9a$export$628f41eb22ec9a2 = {
    prefix: $34aa318834c7ba9a$var$bodiedPrefix,
    content: `${$34aa318834c7ba9a$var$bodiedPrefix}__content`
};
const $34aa318834c7ba9a$var$labelClassName = 'ak-editor-sync-block__label';
const $34aa318834c7ba9a$export$f75b6075afbd73af = {
    labelClassName: $34aa318834c7ba9a$var$labelClassName
};

});


parcelRegister("2287P", function(module, exports) {
$parcel$export(module.exports, "tableLayoutFixes", () => $742a6fc2ff79e14c$export$696afa9d8a2fe544);
$parcel$export(module.exports, "tableCommentEditorStyles", () => $742a6fc2ff79e14c$export$61a2da566f69d1df);
$parcel$export(module.exports, "tableContainerStyles", () => $742a6fc2ff79e14c$export$d4422e89f15370f2);
$parcel$export(module.exports, "tableContainerOverflowY", () => $742a6fc2ff79e14c$export$a12a9c400154a0fb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");

var $khwCN = parcelRequire("khwCN");
function $742a6fc2ff79e14c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $742a6fc2ff79e14c$export$696afa9d8a2fe544 = {
    name: "p382o5",
    styles: ".pm-table-header-content-wrap :not(.fabric-editor-alignment), .pm-table-header-content-wrap :not(p, .fabric-editor-block-mark) + div.fabric-editor-block-mark, .pm-table-cell-content-wrap :not(p, .fabric-editor-block-mark) + div.fabric-editor-block-mark{p:first-of-type{margin-top:0;}}.pm-table-cell-content-wrap .mediaGroupView-content-wrap{clear:both;}"
};
const $742a6fc2ff79e14c$export$5dc8ab529dc33316 = {
    name: "mlsake",
    styles: "margin-left:0;margin-right:0"
};
const $742a6fc2ff79e14c$export$61a2da566f69d1df = /*#__PURE__*/ (0, $1NIU8.css)({
    // TODO: ED-28075 - refactor array include to unblock Compiled CSS migration
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror .pm-table-wrapper > table`]: [
        $742a6fc2ff79e14c$export$5dc8ab529dc33316,
        (0, $khwCN.scrollbarStyles)
    ]
});
const $742a6fc2ff79e14c$export$d4422e89f15370f2 = {
    name: "7u8j0z",
    styles: ".ProseMirror .pm-table-wrapper{max-width:100%;overflow-x:auto;width:100%;box-sizing:border-box;}.ProseMirror .pm-table-wrapper table{max-width:100%;width:100%;table-layout:fixed;min-width:auto;}"
};
const $742a6fc2ff79e14c$export$a12a9c400154a0fb = {
    name: "vkez57",
    styles: ".ProseMirror .pm-table-wrapper{overflow-y:visible;}"
};

});

parcelRegister("8A2V5", function(module, exports) {
$parcel$export(module.exports, "tasksAndDecisionsStyles", () => $dab29d26076633be$export$df437277fbc8b4f5);
$parcel$export(module.exports, "getDenseTasksAndDecisionsStyles", () => $dab29d26076633be$export$715995201f735e2d);
$parcel$export(module.exports, "decisionStyles", () => $dab29d26076633be$export$c2f467e1dc47f4f1);
$parcel$export(module.exports, "decisionDangerStyles", () => $dab29d26076633be$export$27a4e7e55add38c4);
$parcel$export(module.exports, "decisionIconWithVisualRefresh", () => $dab29d26076633be$export$e237513ae3de60b5);
$parcel$export(module.exports, "decisionIconWithoutVisualRefresh", () => $dab29d26076633be$export$921eec0bd8c26b90);
$parcel$export(module.exports, "taskItemStyles", () => $dab29d26076633be$export$2a9fa9bb25fe40d2);
$parcel$export(module.exports, "taskItemStylesWithBlockTaskItem", () => $dab29d26076633be$export$a261a5b04a85ad9c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");

var $d2E5F = parcelRequire("d2E5F");

var $famkW = parcelRequire("famkW");
function $dab29d26076633be$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dab29d26076633be$var$akEditorLineHeight = 1.714;
const $dab29d26076633be$var$akEditorSelectedNodeClassName = 'ak-editor-selected-node';
const $dab29d26076633be$export$a7172b75d403a0e4 = {
    DECISION_CONTAINER: 'decisionItemView-content-wrap',
    TASK_CONTAINER: 'taskItemView-content-wrap',
    //NOTE: value is a selector (data attribute), not a class name
    TASK_LIST_CONTAINER: '[data-node-type="actionList"]',
    TASK_ITEM: 'task-item',
    TASK_CHECKBOX_CONTAINER: 'task-item-checkbox-wrap'
};
const $dab29d26076633be$export$df437277fbc8b4f5 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.taskItemView-content-wrap, .${$dab29d26076633be$export$a7172b75d403a0e4.DECISION_CONTAINER}`]: {
            position: 'relative',
            minWidth: 48
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$dab29d26076633be$export$a7172b75d403a0e4.DECISION_CONTAINER}`]: {
            marginTop: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$dab29d26076633be$export$a7172b75d403a0e4.TASK_CONTAINER}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "span[contenteditable='false']": {
                height: `${$dab29d26076633be$var$akEditorLineHeight}em`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$dab29d26076633be$export$a7172b75d403a0e4.TASK_ITEM}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: $dab29d26076633be$var$akEditorLineHeight
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[data-task-local-id]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "span[contenteditable='false']": {
            height: `${$dab29d26076633be$var$akEditorLineHeight}em`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "span[contenteditable='false'] + div": {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${$dab29d26076633be$var$akEditorLineHeight}em`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[data-task-list-local-id]': {
        margin: `${"var(--ds-space-150, 12px)"} 0 0 0`,
        // If task item is not first in the list then set margin top to 4px.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'div + div': {
            marginTop: "var(--ds-space-050, 4px)"
        }
    },
    // If task list is not first in the document then set margin top to 4px.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[data-task-list-local-id] div[data-task-list-local-id]': {
        marginTop: "var(--ds-space-050, 4px)",
        marginLeft: "var(--ds-space-300, 24px)"
    },
    // When action list is inside panel
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-panel__content': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div[data-task-list-local-id]:first-child': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            margin: '0 !important'
        }
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $dab29d26076633be$var$TASKLIST_CONTAINER_MARGIN_DENSE = `max(0px, calc(10px + (var(--ak-editor-base-font-size, ${(0, $7yBx7.akEditorFullPageDefaultFontSize)}px) - ${(0, $7yBx7.akEditorFullPageDenseFontSize)}px) * (2 / 3)))`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var $dab29d26076633be$var$_ref = {
    name: "0",
    styles: ""
};
const $dab29d26076633be$export$715995201f735e2d = (baseFontSize)=>{
    if (!baseFontSize || baseFontSize === (0, $7yBx7.akEditorFullPageDefaultFontSize)) return $dab29d26076633be$var$_ref;
    return /*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        '.ProseMirror': {
            // Task lists
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [$dab29d26076633be$export$a7172b75d403a0e4.TASK_LIST_CONTAINER]: {
                // Task lists: container top margin
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                marginTop: $dab29d26076633be$var$TASKLIST_CONTAINER_MARGIN_DENSE
            },
            // Task lists: sibling items and nested lists
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [`${$dab29d26076633be$export$a7172b75d403a0e4.TASK_LIST_CONTAINER} > * + *`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                marginTop: (0, $d2E5F.EDITOR_LIST_DENSE_GAP)
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [`${$dab29d26076633be$export$a7172b75d403a0e4.TASK_LIST_CONTAINER} ${$dab29d26076633be$export$a7172b75d403a0e4.TASK_LIST_CONTAINER}, .${$dab29d26076633be$export$a7172b75d403a0e4.TASK_CONTAINER} .${$dab29d26076633be$export$a7172b75d403a0e4.TASK_CONTAINER}`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                marginTop: (0, $d2E5F.EDITOR_LIST_DENSE_GAP)
            }
        }
    });
};
const $dab29d26076633be$export$c2f467e1dc47f4f1 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$dab29d26076633be$var$akEditorSelectedNodeClassName} > [data-decision-wrapper], ol[data-node-type='decisionList'].${$dab29d26076633be$var$akEditorSelectedNodeClassName}`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    [
        {
            borderRadius: "var(--ds-radius-small, 4px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $famkW.boxShadowSelectionStyles),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $famkW.blanketSelectionStyles),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $famkW.hideNativeBrowserTextSelectionStyles)
    ],
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$dab29d26076633be$export$a7172b75d403a0e4.DECISION_CONTAINER}.${$dab29d26076633be$var$akEditorSelectedNodeClassName} > div`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
            backgroundColor: "var(--ds-blanket-danger, #EF5C4814)",
            '&::after': {
                content: 'none' // reset the Blanket selection style
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"]': {
        listStyleType: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper]': {
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'row',
        margin: `${"var(--ds-space-100, 8px)"} 0 0 0`,
        padding: "var(--ds-space-100, 8px)",
        paddingLeft: "var(--ds-space-150, 12px)",
        borderRadius: "var(--ds-radius-small, 4px)",
        backgroundColor: "var(--ds-background-neutral, #091E420F)",
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"]': {
        flex: '0 0 16px',
        height: '16px',
        width: '16px',
        margin: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"} 0 0`,
        color: "var(--ds-icon-subtle, #626F86)",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"]:not(:has([data-empty]):not(:has([data-type-ahead]))) > [data-decision-wrapper] > [data-component="icon"]': {
        color: "var(--ds-icon-success, #22A06B)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span': {
        display: 'inline-block',
        flexShrink: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography -- Mirroring icon styles
        lineHeight: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span > svg': {
        overflow: 'hidden',
        pointerEvents: 'none',
        color: 'currentColor',
        verticalAlign: 'bottom'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="placeholder"]': {
        margin: `0 0 0 calc(${"var(--ds-space-100, 8px)"} * 3.5)`,
        position: 'absolute',
        color: "var(--ds-text-subtlest, #626F86)",
        pointerEvents: 'none',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: 'calc(100% - 50px)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"]:not(:has([data-empty]):not(:has([data-type-ahead]))) > [data-decision-wrapper] > [data-component="placeholder"]': {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="content"]': {
        margin: 0,
        wordWrap: 'break-word',
        minWidth: 0,
        flex: '1 1 auto'
    }
});
const $dab29d26076633be$export$27a4e7e55add38c4 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${$dab29d26076633be$var$akEditorSelectedNodeClassName}.danger > [data-decision-wrapper], ol[data-node-type='decisionList'].${$dab29d26076633be$var$akEditorSelectedNodeClassName}.danger`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [
        (0, $famkW.dangerBackgroundStyles),
        (0, $famkW.dangerBorderStyles)
    ]
});
const $dab29d26076633be$export$e237513ae3de60b5 = {
    name: "b3ew8y",
    styles: "[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span >  svg[data-icon-source=\"legacy\"]{display:none;}[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span{box-sizing:border-box;padding-inline-end:var(--ds--button--new-icon-padding-end, 0);padding-inline-start:var(--ds--button--new-icon-padding-start, 0);@media screen and (forced-colors: active){color:canvastext;filter:grayscale(1);}}[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span > svg{width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px);}"
};
const $dab29d26076633be$export$921eec0bd8c26b90 = {
    name: "s6v8rd",
    styles: "[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span >  svg[data-icon-source=\"refreshed\"]{display:none;}[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span{width:32px;height:32px;@media screen and (forced-colors: active){filter:grayscale(1);color:canvastext;fill:canvas;}}[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span > svg{max-width:100%;max-height:100%;fill:var(--ds-surface, #FFFFFF);width:32px;height:32px;}"
};
const $dab29d26076633be$export$2a9fa9bb25fe40d2 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"]': {
        listStyle: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="task-item-main"]': {
        display: 'flex',
        flexDirection: 'row',
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="placeholder"]': {
        position: 'absolute',
        color: "var(--ds-text-subtlest, #626F86)",
        margin: `0 0 0 calc(${"var(--ds-space-100, 8px)"} * 3)`,
        pointerEvents: 'none',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: 'calc(100% - 50px)',
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    "[data-prosemirror-node-name='taskItem']:has([data-empty]):not(:has([data-type-ahead])) [data-component='placeholder']": {
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="content"]': {
        margin: 0,
        wordWrap: 'break-word',
        minWidth: 0,
        flex: '1 1 auto'
    },
    // copied styles from packages/design-system/icon/src/components/icon-new.tsx
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="checkbox-icon-wrap"]': {
        display: 'inline-block',
        boxSizing: 'border-box',
        flexShrink: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1,
        paddingInlineEnd: 'var(--ds--button--new-icon-padding-end, 0)',
        paddingInlineStart: 'var(--ds--button--new-icon-padding-start, 0)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="checkbox-icon-wrap"] svg': {
        overflow: 'hidden',
        pointerEvents: 'none',
        color: 'currentColor',
        verticalAlign: 'bottom',
        width: "var(--ds-space-200, 16px)",
        height: "var(--ds-space-200, 16px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-node-name="taskItem"] input[type=checkbox]:not(:checked) + span [data-component=checkbox-checked-icon]': {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-node-name="taskItem"] input[type=checkbox]:not(:checked) + span [data-component=checkbox-unchecked-icon]': {
        display: 'inline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] input[type=checkbox]:checked + span [data-component=checkbox-checked-icon]': {
        display: 'inline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] input[type=checkbox]:checked + span [data-component=checkbox-unchecked-icon]': {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`[data-prosemirror-node-name="taskItem"] .${$dab29d26076633be$export$a7172b75d403a0e4.TASK_CHECKBOX_CONTAINER}`]: {
        flex: '0 0 24px',
        width: '24px',
        height: '24px',
        position: 'relative',
        alignSelf: 'start',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "& > input[type='checkbox']": {
            width: '16px',
            height: '16px',
            zIndex: 1,
            cursor: 'pointer',
            outline: 'none',
            margin: 0,
            opacity: 0,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&[disabled]': {
                cursor: 'default'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '+ span': {
                width: '24px',
                height: '24px',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '+ span > svg': {
                boxSizing: 'border-box',
                display: 'inline',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                maxWidth: 'unset',
                maxHeight: 'unset',
                position: 'absolute',
                overflow: 'hidden',
                color: "var(--ds-background-input, #FFFFFF)",
                transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'path:first-of-type': {
                    visibility: 'hidden'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border-input, #8590A2)",
                    strokeWidth: 1,
                    transition: 'stroke 0.2s ease-in-out'
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&:hover + span > svg': {
                color: "var(--ds-background-input-hovered, #F7F8F9)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border-input, #8590A2)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&:checked:hover + span > svg': {
                color: "var(--ds-background-selected-bold-hovered, #0055CC)",
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-background-selected-bold-hovered, #0055CC)"
                }
            },
            '&:checked': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
                '+ span > svg': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                    'path:first-of-type': {
                        visibility: 'visible'
                    },
                    color: "var(--ds-background-selected-bold, #0C66E4)",
                    fill: "var(--ds-icon-inverse, #FFFFFF)",
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                    'rect:first-of-type': {
                        stroke: "var(--ds-background-selected-bold, #0C66E4)"
                    }
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:active + span > svg': {
                color: "var(--ds-background-input-pressed, #FFFFFF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border, #091E4224)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:checked:active + span > svg': {
                color: "var(--ds-background-input-pressed, #FFFFFF)",
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border, #091E4224)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:disabled + span > svg, &:disabled:hover + span > svg, &:disabled:focus + span > svg, &:disabled:active + span > svg': {
                color: "var(--ds-background-disabled, #091E4208)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-background-disabled, #091E4208)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:disabled:checked + span > svg': {
                fill: "var(--ds-icon-disabled, #091E424F)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:focus + span::after': {
                position: 'absolute',
                width: "var(--ds-space-200, 16px)",
                height: "var(--ds-space-200, 16px)",
                border: `2px solid ${"var(--ds-border-focused, #388BFF)"}`,
                borderRadius: "var(--ds-space-050, 4px)",
                content: "''",
                display: 'block',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
            }
        }
    }
});
const $dab29d26076633be$export$a261a5b04a85ad9c = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"], [data-prosemirror-node-name="blockTaskItem"]': {
        listStyle: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="task-item-main"], [data-prosemirror-node-name="blockTaskItem"] [data-component="task-item-main"]': {
        display: 'flex',
        flexDirection: 'row',
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="placeholder"], [data-prosemirror-node-name="blockTaskItem"] [data-component="placeholder"]': {
        position: 'absolute',
        color: "var(--ds-text-subtlest, #626F86)",
        margin: `0 0 0 calc(${"var(--ds-space-100, 8px)"} * 3)`,
        pointerEvents: 'none',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: 'calc(100% - 50px)',
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    "[data-prosemirror-node-name='taskItem']:has([data-empty]):not(:has([data-type-ahead])) [data-component='placeholder'], [data-prosemirror-node-name='blockTaskItem']:has([data-empty]):not(:has([data-type-ahead])) [data-component='placeholder']": {
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="content"], [data-prosemirror-node-name="blockTaskItem"] [data-component="content"]': {
        margin: 0,
        wordWrap: 'break-word',
        minWidth: 0,
        flex: '1 1 auto'
    },
    // copied styles from packages/design-system/icon/src/components/icon-new.tsx
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="checkbox-icon-wrap"], [data-prosemirror-node-name="blockTaskItem"] [data-component="checkbox-icon-wrap"]': {
        display: 'inline-block',
        boxSizing: 'border-box',
        flexShrink: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1,
        paddingInlineEnd: 'var(--ds--button--new-icon-padding-end, 0)',
        paddingInlineStart: 'var(--ds--button--new-icon-padding-start, 0)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="checkbox-icon-wrap"] svg, [data-prosemirror-node-name="blockTaskItem"] [data-component="checkbox-icon-wrap"] svg': {
        overflow: 'hidden',
        pointerEvents: 'none',
        color: 'currentColor',
        verticalAlign: 'bottom',
        width: "var(--ds-space-200, 16px)",
        height: "var(--ds-space-200, 16px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-node-name="taskItem"] input[type=checkbox]:not(:checked) + span [data-component=checkbox-checked-icon], [data-prosemirror-node-name="blockTaskItem"] input[type=checkbox]:not(:checked) + span [data-component=checkbox-checked-icon]': {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-node-name="taskItem"] input[type=checkbox]:not(:checked) + span [data-component=checkbox-unchecked-icon], [data-prosemirror-node-name="blockTaskItem"] input[type=checkbox]:not(:checked) + span [data-component=checkbox-unchecked-icon]': {
        display: 'inline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] input[type=checkbox]:checked + span [data-component=checkbox-checked-icon], [data-prosemirror-node-name="blockTaskItem"] input[type=checkbox]:checked + span [data-component=checkbox-checked-icon]': {
        display: 'inline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] input[type=checkbox]:checked + span [data-component=checkbox-unchecked-icon], [data-prosemirror-node-name="blockTaskItem"] input[type=checkbox]:checked + span [data-component=checkbox-unchecked-icon]': {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`[data-prosemirror-node-name="taskItem"] .${$dab29d26076633be$export$a7172b75d403a0e4.TASK_CHECKBOX_CONTAINER}, [data-prosemirror-node-name="blockTaskItem"] .${$dab29d26076633be$export$a7172b75d403a0e4.TASK_CHECKBOX_CONTAINER}`]: {
        flex: '0 0 24px',
        width: '24px',
        height: '24px',
        position: 'relative',
        alignSelf: 'start',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "& > input[type='checkbox']": {
            width: '16px',
            height: '16px',
            zIndex: 1,
            cursor: 'pointer',
            outline: 'none',
            margin: 0,
            opacity: 0,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&[disabled]': {
                cursor: 'default'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '+ span': {
                width: '24px',
                height: '24px',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '+ span > svg': {
                boxSizing: 'border-box',
                display: 'inline',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                maxWidth: 'unset',
                maxHeight: 'unset',
                position: 'absolute',
                overflow: 'hidden',
                color: "var(--ds-background-input, #FFFFFF)",
                transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'path:first-of-type': {
                    visibility: 'hidden'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border-input, #8590A2)",
                    strokeWidth: 1,
                    transition: 'stroke 0.2s ease-in-out'
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&:hover + span > svg': {
                color: "var(--ds-background-input-hovered, #F7F8F9)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border-input, #8590A2)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&:checked:hover + span > svg': {
                color: "var(--ds-background-selected-bold-hovered, #0055CC)",
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-background-selected-bold-hovered, #0055CC)"
                }
            },
            '&:checked': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
                '+ span > svg': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                    'path:first-of-type': {
                        visibility: 'visible'
                    },
                    color: "var(--ds-background-selected-bold, #0C66E4)",
                    fill: "var(--ds-icon-inverse, #FFFFFF)",
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                    'rect:first-of-type': {
                        stroke: "var(--ds-background-selected-bold, #0C66E4)"
                    }
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:active + span > svg': {
                color: "var(--ds-background-input-pressed, #FFFFFF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border, #091E4224)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:checked:active + span > svg': {
                color: "var(--ds-background-input-pressed, #FFFFFF)",
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border, #091E4224)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:disabled + span > svg, &:disabled:hover + span > svg, &:disabled:focus + span > svg, &:disabled:active + span > svg': {
                color: "var(--ds-background-disabled, #091E4208)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-background-disabled, #091E4208)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:disabled:checked + span > svg': {
                fill: "var(--ds-icon-disabled, #091E424F)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:focus + span::after': {
                position: 'absolute',
                width: "var(--ds-space-200, 16px)",
                height: "var(--ds-space-200, 16px)",
                border: `2px solid ${"var(--ds-border-focused, #388BFF)"}`,
                borderRadius: "var(--ds-space-050, 4px)",
                content: "''",
                display: 'block',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
            }
        }
    }
});

});

parcelRegister("bHGrA", function(module, exports) {
$parcel$export(module.exports, "telepointerColorAndCommonStyle", () => $181b659280034467$export$3f28e75e37279280);
$parcel$export(module.exports, "telepointerStyle", () => $181b659280034467$export$c94087d6ea5127ad);
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 
var $1NIU8 = parcelRequire("1NIU8");
function $181b659280034467$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $181b659280034467$var$pulseIn = (0, $1NIU8.keyframes)({
    '0%, 100%': {
        transform: 'scaleX(0)',
        opacity: 0
    },
    '10%': {
        transform: 'scaleX(1.4)',
        opacity: 1
    },
    '15%, 85%': {
        transform: 'scaleX(1)',
        opacity: 1
    }
});
const $181b659280034467$var$pulseOut = (0, $1NIU8.keyframes)({
    '0%, 90%, 100%': {
        transform: 'scaleX(1)',
        opacity: 1
    },
    '10%, 80%': {
        transform: 'scaleX(0)',
        opacity: 0
    }
});
const $181b659280034467$var$pulseInDuringTr = (0, $1NIU8.keyframes)({
    '0%, 95%': {
        transform: 'scaleX(1)',
        opacity: 1
    },
    '100%': {
        transform: 'scaleX(0)',
        opacity: 0
    }
});
const $181b659280034467$var$pulseOutDuringTr = (0, $1NIU8.keyframes)({
    '100%': {
        transform: 'scaleX(1)',
        opacity: 1
    },
    '0%, 90%': {
        transform: 'scaleX(0)',
        opacity: 0
    }
});
const $181b659280034467$export$3f28e75e37279280 = {
    name: "13y51hg",
    styles: ".ProseMirror .telepointer{position:relative;transition:opacity 200ms;&.telepointer-selection:not(.inlineNodeView){line-height:1.2;pointer-events:none;user-select:none;}&.telepointer-dim{opacity:0.2;}&.color-0{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-red-bolder, #C9372C);}&.color-1{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-blue-bolder, #0C66E4);}&.color-2{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-green-bolder, #1F845A);}&.color-3{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-yellow-bolder, #946F00);}&.color-4{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-purple-bolder, #6E5DC6);}&.color-5{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-magenta-bolder, #AE4787);}&.color-6{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-teal-bolder, #227D9B);}&.color-7{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-orange-bolder, #C25100);}&.color-8{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-lime-bolder, #5B7F24);}&.color-9{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-gray-bolder, #626F86);}&.color-10{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #091E42);--telepointer-participant-bg-color:var(--ds-background-accent-blue-subtle, #579DFF);}&.color-11{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #091E42);--telepointer-participant-bg-color:var(--ds-background-accent-red-subtle, #F87168);}&.color-12{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #091E42);--telepointer-participant-bg-color:var(--ds-background-accent-orange-subtle, #FEA362);}&.color-13{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #091E42);--telepointer-participant-bg-color:var(--ds-background-accent-yellow-subtle, #F5CD47);}&.color-14{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #091E42);--telepointer-participant-bg-color:var(--ds-background-accent-green-subtle, #4BCE97);}&.color-15{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #091E42);--telepointer-participant-bg-color:var(--ds-background-accent-teal-subtle, #6CC3E0);}&.color-16{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #091E42);--telepointer-participant-bg-color:var(--ds-background-accent-purple-subtle, #9F8FEF);}&.color-17{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #091E42);--telepointer-participant-bg-color:var(--ds-background-accent-magenta-subtle, #E774BB);}html:not([data-color-mode=dark]) &{--telepointer-participant-background-first-stop:-850000%;--telepointer-participant-background-second-stop:150000%;}html[data-color-mode=dark] &{--telepointer-participant-background-first-stop:-800000%;--telepointer-participant-background-second-stop:200000%;}&[class*=\"color-\"]{background:linear-gradient(to bottom, var(--telepointer-participant-bg-color) var(--telepointer-participant-background-first-stop), transparent var(--telepointer-participant-background-second-stop));&::after{background-color:var(--telepointer-participant-bg-color);color:var(--telepointer-participant-text-color);border-color:var(--telepointer-participant-bg-color);}}}"
};
const $181b659280034467$export$c94087d6ea5127ad = /*#__PURE__*/ (0, $1NIU8.css)({
    '.ProseMirror .telepointer': {
        '&.telepointer-selection-badge': {
            '.telepointer-initial, .telepointer-fullname': {
                position: 'absolute',
                display: 'block',
                userSelect: 'none',
                whiteSpace: 'pre',
                top: -14,
                left: 0,
                font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                paddingLeft: "var(--ds-space-050, 4px)",
                paddingRight: "var(--ds-space-050, 4px)",
                borderRadius: `0 ${"var(--ds-radius-xsmall, 2px)"} ${"var(--ds-radius-xsmall, 2px)"} 0`
            },
            '.telepointer-initial': {
                opacity: 1,
                transition: 'opacity 0.15s ease-out'
            },
            '.telepointer-fullname': {
                opacity: 0,
                transform: 'scaleX(0)',
                transformOrigin: 'top left',
                transition: 'transform 0.15s ease-out, opacity 0.15s ease-out'
            }
        },
        '&.telepointer-pulse-animate': {
            '.telepointer-initial': {
                animation: `${$181b659280034467$var$pulseOut} 2.5s ease-in-out`
            },
            '.telepointer-fullname': {
                animation: `${$181b659280034467$var$pulseIn} 2.5s ease-in-out`
            }
        },
        '&.telepointer-pulse-during-tr': {
            '.telepointer-initial': {
                animation: `${$181b659280034467$var$pulseOutDuringTr} 7500ms ease-in-out`
            },
            '.telepointer-fullname': {
                animation: `${$181b659280034467$var$pulseInDuringTr} 7500ms ease-in-out`
            }
        },
        '&:hover': {
            '.telepointer-initial': {
                opacity: 0,
                transitionDelay: '150ms'
            },
            '.telepointer-fullname': {
                transform: 'scaleX(1)',
                opacity: 1,
                zIndex: 1
            }
        }
    }
});

});

parcelRegister("lOMXK", function(module, exports) {
$parcel$export(module.exports, "textColorStyles", () => $126b9fc34664e060$export$a518ea5d00002b38);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
function $126b9fc34664e060$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $126b9fc34664e060$export$a518ea5d00002b38 = {
    name: "1nlqh0j",
    styles: ".fabric-text-color-mark{color:var(--custom-palette-color, inherit);}a .fabric-text-color-mark{color:unset;}"
};

});

parcelRegister("fdSLH", function(module, exports) {
$parcel$export(module.exports, "textHighlightStyle", () => $dfd7ca8f25ce57ed$export$b286500adc7d91cd);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");
const $dfd7ca8f25ce57ed$export$b286500adc7d91cd = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.text-highlight': {
        backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
        borderBottom: `2px solid ${"var(--ds-background-accent-blue-subtler, #CCE0FF)"}`
    }
});

});

parcelRegister("iBvA9", function(module, exports) {
$parcel$export(module.exports, "unsupportedStyles", () => $8785b25087c6a3b1$export$637bcb89343f7ef4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");

var $famkW = parcelRequire("famkW");
const $8785b25087c6a3b1$export$629043421dcc56e5 = {
    BLOCK_CONTAINER: 'unsupportedBlockView-content-wrap',
    INLINE_CONTAINER: 'unsupportedInlineView-content-wrap'
};
const $8785b25087c6a3b1$export$637bcb89343f7ef4 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$8785b25087c6a3b1$export$629043421dcc56e5.BLOCK_CONTAINER} > div, .${$8785b25087c6a3b1$export$629043421dcc56e5.INLINE_CONTAINER} > span:nth-of-type(2)`]: {
        cursor: 'pointer'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-selected-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.${$8785b25087c6a3b1$export$629043421dcc56e5.BLOCK_CONTAINER} > div, &.${$8785b25087c6a3b1$export$629043421dcc56e5.INLINE_CONTAINER} > span:nth-of-type(2)`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.backgroundSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.borderSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.hideNativeBrowserTextSelectionStyles)
        ]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-selected-node': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`&.${$8785b25087c6a3b1$export$629043421dcc56e5.BLOCK_CONTAINER} > div, &.${$8785b25087c6a3b1$export$629043421dcc56e5.INLINE_CONTAINER} > span:nth-of-type(2)`]: {
                border: `1px solid ${"var(--ds-border-danger, #E2483D)"}`,
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
            }
        }
    }
});

});

parcelRegister("l0XHK", function(module, exports) {
$parcel$export(module.exports, "whitespaceStyles", () => $b673b6aaba39e431$export$2ee83b65ab9fac74);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
function $b673b6aaba39e431$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b673b6aaba39e431$export$2ee83b65ab9fac74 = {
    name: "1e3eb5t",
    styles: ".ProseMirror{word-wrap:break-word;white-space:pre-wrap;}"
};

});


parcelRegister("gyhYD", function(module, exports) {
$parcel$export(module.exports, "default", () => $be2098ae651ac5e5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $cSmYj = parcelRequire("cSmYj");

var $bMFKb = parcelRequire("bMFKb");

var $g6YpQ = parcelRequire("g6YpQ");

var $lTt3Y = parcelRequire("lTt3Y");

var $a8knB = parcelRequire("a8knB");
function $be2098ae651ac5e5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $be2098ae651ac5e5$var$pluginsComponentsWrapper = {
    name: "zjik7",
    styles: "display:flex"
};
const $be2098ae651ac5e5$var$PluginSlot = ({ items: items, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, appearance: appearance, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, containerElement: containerElement, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, wrapperElement: wrapperElement, pluginHooks: pluginHooks })=>{
    if (!items && !pluginHooks || !editorView && !(0, $g6YpQ.expVal)('platform_editor_hydratable_ui', 'isEnabled', false)) return null;
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $lTt3Y.ErrorBoundary), {
        component: (0, $bMFKb.ACTION_SUBJECT).PLUGIN_SLOT,
        fallbackComponent: null
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $a8knB.MountPluginHooks), {
        editorView: editorView,
        pluginHooks: pluginHooks,
        containerElement: containerElement
    }), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $be2098ae651ac5e5$var$pluginsComponentsWrapper,
        "data-testid": (0, $g6YpQ.expVal)('platform_editor_experience_tracking', 'isEnabled', true) ? 'plugins-components-wrapper' : undefined
    }, items?.map((component, key)=>{
        const props = {
            key: key
        };
        const element = component({
            editorView: editorView,
            editorActions: editorActions,
            eventDispatcher: eventDispatcher,
            providerFactory: providerFactory,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            appearance: appearance,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            containerElement: containerElement,
            disabled: disabled,
            wrapperElement: wrapperElement
        });
        return element && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(element, props);
    })));
};
const $be2098ae651ac5e5$var$PluginSlotComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo($be2098ae651ac5e5$var$PluginSlot, (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj))));
$be2098ae651ac5e5$var$PluginSlotComponent.displayName = 'PluginSlot';
var $be2098ae651ac5e5$export$2e2bcd8739ae039 = $be2098ae651ac5e5$var$PluginSlotComponent;

});
parcelRegister("lTt3Y", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $207e38d0440b647d$export$e926676385687eaf);

var $eJOHy = parcelRequire("eJOHy");

var $bMFKb = parcelRequire("bMFKb");

var $djRdf = parcelRequire("djRdf");
class $207e38d0440b647d$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.dispatchAnalyticsEvent) this.props.dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).EDITOR_CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: error,
                errorInfo: errorInfo,
                errorRethrown: !this.hasFallback()
            }
        });
        (0, $djRdf.logException)(error, {
            location: 'editor-core/ui'
        });
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        });
    }
    render() {
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            errorCaptured: false
        };
    }
}

});

parcelRegister("a8knB", function(module, exports) {
$parcel$export(module.exports, "MountPluginHooks", () => $6043c76403f3f940$export$a9224552b63e3fe8);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
function $6043c76403f3f940$var$MountPluginHook({ usePluginHook: usePluginHook, editorView: editorView, containerElement: containerElement }) {
    usePluginHook({
        editorView: editorView,
        containerElement: containerElement
    });
    return null;
}
function $6043c76403f3f940$export$a9224552b63e3fe8({ pluginHooks: pluginHooks, editorView: editorView, containerElement: containerElement }) {
    if (!editorView) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: pluginHooks?.map((usePluginHook, key)=>/*#__PURE__*/ (0, $gt9Am.jsx)($6043c76403f3f940$var$MountPluginHook, {
                usePluginHook: usePluginHook,
                editorView: editorView,
                containerElement: containerElement
            }, key))
    });
}

});


parcelRegister("52GJU", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd92e6ea4def32e6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");
const $bd92e6ea4def32e6$var$pulseBackground = (0, $1NIU8.keyframes)({
    '50%': {
        backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
    }
});
const $bd92e6ea4def32e6$var$pulseBackgroundReverse = (0, $1NIU8.keyframes)({
    '0%': {
        backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
    },
    '50%': {
        backgroundColor: 'auto'
    },
    '100%': {
        backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
    }
});
const $bd92e6ea4def32e6$var$flashWrapper = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.-flash > div': {
        animationName: $bd92e6ea4def32e6$var$pulseBackgroundReverse,
        animationDuration: '0.25s',
        animationTimingFunction: 'ease-in-out'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > div': {
        animation: "'none'"
    }
});
const $bd92e6ea4def32e6$var$flashWrapperAnimated = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`${$bd92e6ea4def32e6$var$flashWrapper} & > div`]: {
        animationName: $bd92e6ea4def32e6$var$pulseBackground,
        animationDuration: '0.25s',
        animationTimingFunction: 'ease-in-out'
    }
});
class $bd92e6ea4def32e6$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { animate: animate, children: children } = this.props;
        this.toggle = animate && !this.toggle;
        return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
        /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: animate ? $bd92e6ea4def32e6$var$flashWrapperAnimated : $bd92e6ea4def32e6$var$flashWrapper,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: this.toggle ? '-flash' : ''
        }, children));
    }
    constructor(...args){
        super(...args), this.toggle = false;
    }
}

});



parcelRegister("bXaOH", function(module, exports) {
$parcel$export(module.exports, "usePresetByFeatures", () => $fb81693e5169b90a$export$cdae2f05238f63a2);

var $hzPqg = parcelRequire("hzPqg");

var $eY1Jr = parcelRequire("eY1Jr");

var $MFHY3 = parcelRequire("MFHY3");
const $fb81693e5169b90a$export$cdae2f05238f63a2 = (appearance, features)=>{
    const memoisedFeatures = (0, $MFHY3.useMemoisedFeatures)(features);
    const preset = (0, $hzPqg.usePreset)((builder)=>(0, $eY1Jr.createPreset)(builder, appearance, memoisedFeatures), [
        memoisedFeatures
    ]);
    return preset;
};

});
parcelRegister("hzPqg", function(module, exports) {
$parcel$export(module.exports, "usePreset", () => $92ad4392f2dcd1e5$export$1d81a44583df97d2);

var $eJOHy = parcelRequire("eJOHy");

var $8PuhX = parcelRequire("8PuhX");
function $92ad4392f2dcd1e5$export$1d81a44583df97d2(createPreset, dependencies = []) {
    const [editorApi, setAPI] = (0, $eJOHy.useState)(undefined);
    const preset = (0, $eJOHy.useMemo)(()=>createPreset(new (0, $8PuhX.EditorPresetBuilder)()), // eslint-disable-next-line react-hooks/exhaustive-deps
    dependencies);
    (0, $eJOHy.useLayoutEffect)(()=>{
        return preset.apiResolver.on((api)=>{
            setAPI(api);
        });
    }, [
        preset.apiResolver
    ]);
    return {
        editorApi: editorApi,
        preset: preset
    };
}

});
parcelRegister("8PuhX", function(module, exports) {
$parcel$export(module.exports, "EditorPresetBuilder", () => $259832480ddd66b3$export$dab03ba05a79e5c7);

var $aoyv9 = parcelRequire("aoyv9");
class $259832480ddd66b3$export$dab03ba05a79e5c7 {
    constructor(...more){
        this.apiEmitter = ()=>{};
        this.safeEntry = (plugin)=>Array.isArray(plugin) ? plugin : [
                plugin,
                undefined
            ];
        // @ts-ignore - TS2872 TypeScript 5.9.2 upgrade
        this.data = [
            ...more
        ];
        this.apiPromise = new Promise((r)=>this.resolver = r);
        this.apiResolver = new $259832480ddd66b3$var$APIDispatcher((emitter)=>this.apiEmitter = emitter);
    }
    add(nextOrTuple) {
        return new $259832480ddd66b3$export$dab03ba05a79e5c7(/**
			 * re-cast this to NewPlugin as we've done all the type
			 * safety, dependency checking, narrowing, during
			 * `SafePresetCheck & VerifyPluginDependencies`
			 */ nextOrTuple, ...this.data);
    }
    maybeAdd(pluginToAdd, shouldAdd) {
        const pluginOrBuilder = typeof shouldAdd === 'function' ? shouldAdd(pluginToAdd, this) : shouldAdd;
        if (pluginOrBuilder instanceof $259832480ddd66b3$export$dab03ba05a79e5c7) return pluginOrBuilder;
        const nextPluginStack = [
            /**
			 * re-cast this to NewPlugin as we've done all the type
			 * safety, dependency checking, narrowing, during
			 * `SafePresetCheck & VerifyPluginDependencies`
			 */ pluginOrBuilder ? pluginToAdd : undefined,
            ...this.data
        ];
        const nextEditorPresetBuilder = new $259832480ddd66b3$export$dab03ba05a79e5c7(...nextPluginStack);
        return nextEditorPresetBuilder;
    }
    has(plugin) {
        return this.data.some((pluginPreset)=>{
            if (Array.isArray(pluginPreset)) return pluginPreset[0] === plugin;
            return pluginPreset === plugin;
        });
    }
    build({ pluginInjectionAPI: pluginInjectionAPI, excludePlugins: maybeExcludePlugins } = {}) {
        const excludePlugins = new Set(maybeExcludePlugins ? maybeExcludePlugins : []);
        const editorPlugins = this.processEditorPlugins({
            pluginInjectionAPI: pluginInjectionAPI,
            excludePlugins: excludePlugins
        });
        if (pluginInjectionAPI) {
            // The pluginInjectionAPI API doesn't have information enough to build a proper type for the API.
            // It is returning a generic type but on top of the Proxy system
            // So, we can safely recast it here
            this.apiEmitter(pluginInjectionAPI.api());
            // Deprecated approach
            this.resolver?.(pluginInjectionAPI.api());
        }
        return this.removeExcludedPlugins(editorPlugins, excludePlugins);
    }
    verifyDuplicatedPlugins() {
        const cache = new Set();
        this.data.filter(Boolean).forEach((pluginEntry)=>{
            const [pluginFn, _] = Array.isArray(pluginEntry) ? pluginEntry : [
                pluginEntry,
                undefined
            ];
            if (cache.has(pluginFn)) throw new Error(`${pluginFn} is already included!`);
            cache.add(pluginFn);
        });
        return true;
    }
    processEditorPlugins({ pluginInjectionAPI: pluginInjectionAPI, excludePlugins: excludePlugins }) {
        this.verifyDuplicatedPlugins();
        const seen = new Set();
        const pluginsDataCopy = this.data.slice();
        const plugins = pluginsDataCopy.reverse().filter(Boolean).map((entry)=>{
            const [fn, config] = this.safeEntry(entry);
            if (seen.has(fn)) return null;
            seen.add(fn);
            if (typeof fn !== 'function') return null;
            const plugin = pluginInjectionAPI ? fn({
                config: config,
                api: pluginInjectionAPI.api()
            }) : fn({
                config: config
            });
            if (plugin && excludePlugins?.has(plugin.name)) return null;
            if (!pluginInjectionAPI) return plugin;
            pluginInjectionAPI.onEditorPluginInitialized(plugin);
            return plugin;
        }).filter(Boolean);
        return plugins;
    }
    removeExcludedPlugins(plugins, excludes) {
        if (excludes) return plugins.filter((plugin)=>!plugin || !excludes.has(plugin.name));
        return plugins;
    }
}
/**
 * WARNING: Internal object
 *
 * Dedicated wrapper around EventDispatcher for public API around the editor API.
 * This only has the public method `on` which is used to listen to updates to the editor API.
 *
 * This shouldn't really be used externally - the `editorAPI` should be accessed via `usePreset`.
 */ class $259832480ddd66b3$var$APIDispatcher {
    constructor(emitter){
        this.emitter = emitter;
        this.eventDispatcher = new (0, $aoyv9.EventDispatcher)();
        this.key = 'api-resolved-event';
        this.initialEvent = undefined;
        this.emitter((v)=>{
            this.initialEvent = v;
            this.eventDispatcher.emit(this.key, v);
        });
    }
    /**
	 * Used to observe Editor API events
	 *
	 * @param cb Callback to listen to the editor API.
	 * This will also emit the last event if the stream has already started.
	 * @returns Cleanup function to cleanup the listener
	 */ on(cb) {
        if (this.initialEvent !== undefined) // Keeps timing consistent with old approach - certain products
        // ie. ai-mate relied on this.
        Promise.resolve().then(()=>cb(this.initialEvent));
        this.eventDispatcher.on(this.key, cb);
        return ()=>{
            this.eventDispatcher.off(this.key, cb);
        };
    }
    destroy() {
        this.eventDispatcher.destroy();
    }
}

});


parcelRegister("eY1Jr", function(module, exports) {
$parcel$export(module.exports, "createPreset", () => $321c0d351d046272$export$b956d067c5bcf6b);

var $7c4bW = parcelRequire("7c4bW");

var $ishVX = parcelRequire("ishVX");
parcelRequire("9HYhn");
var $aflUx = parcelRequire("aflUx");
parcelRequire("1MKcc");
var $9J26c = parcelRequire("9J26c");
parcelRequire("ad5Kp");
var $1sH6J = parcelRequire("1sH6J");
parcelRequire("kjNEe");
var $4r3i7 = parcelRequire("4r3i7");
parcelRequire("b8wHL");
var $lTMvj = parcelRequire("lTMvj");
parcelRequire("cZNzR");
var $4H0bV = parcelRequire("4H0bV");
parcelRequire("30v6T");
var $88434 = parcelRequire("88434");
parcelRequire("iQvAc");
var $d3sAY = parcelRequire("d3sAY");
parcelRequire("c9xno");
var $7gUM9 = parcelRequire("7gUM9");
parcelRequire("9zBWD");
var $bXi9c = parcelRequire("bXi9c");
parcelRequire("4here");
var $2AVuz = parcelRequire("2AVuz");
parcelRequire("85rQi");
var $8EyJv = parcelRequire("8EyJv");
parcelRequire("3hdhz");
var $33nQb = parcelRequire("33nQb");
parcelRequire("3IrrG");
var $hCscm = parcelRequire("hCscm");
parcelRequire("03aTp");
var $cxOnI = parcelRequire("cxOnI");
parcelRequire("db6dP");
var $5F9b7 = parcelRequire("5F9b7");
const $321c0d351d046272$var$shouldShow = (option)=>{
    // if option is not defined, return false
    if (option === undefined) return false;
    return option;
};
const $321c0d351d046272$export$b956d067c5bcf6b = (builder, appearance, features)=>{
    const defaultFeatures = {
        blockType: true,
        textFormatting: true,
        list: true,
        insertBlock: true,
        textColor: true,
        hyperLink: true,
        quickInsert: true,
        codeBlock: true
    };
    // if `features` is not defined, set all options to true
    // if `features` is provided, only options that are set to true by the developer will render. This is so any new plugin additions made by us will not be rendered by default as the developer has intentionally only set certain options to appear
    const enabledPlugins = features ?? defaultFeatures;
    return builder.add((0, $aflUx.default)).maybeAdd((0, $1sH6J.blockTypePlugin), $321c0d351d046272$var$shouldShow(enabledPlugins?.blockType)) // allows for different text tags(paragraphs, heading levels) and quote blocks to be added
    .add((0, $9J26c.betterTypeHistoryPlugin)) // required for paste plugin
    .add([
        (0, $8EyJv.pastePlugin),
        {}
    ]) // allows links to be converted to hyper link on paste
    .add((0, $5F9b7.typeAheadPlugin)).maybeAdd((0, $33nQb.quickInsertPlugin), $321c0d351d046272$var$shouldShow(enabledPlugins?.quickInsert)) // allows for `/` to insert nodes from a menu
    .maybeAdd((0, $cxOnI.textFormattingPlugin), $321c0d351d046272$var$shouldShow(enabledPlugins?.textFormatting)).maybeAdd((0, $hCscm.textColorPlugin), $321c0d351d046272$var$shouldShow(enabledPlugins?.textColor)).maybeAdd((0, $2AVuz.listPlugin), $321c0d351d046272$var$shouldShow(enabledPlugins?.list)) // required for `-` to insert lists
    .maybeAdd([
        (0, $ishVX.toolbarListsIndentationPlugin),
        {
            showIndentationButtons: false,
            allowHeadingAndParagraphIndentation: false
        }
    ], $321c0d351d046272$var$shouldShow(enabledPlugins?.list)).add((0, $4H0bV.copyButtonPlugin)) // required for floating toolbar plugins
    .add((0, $d3sAY.editorDisabledPlugin)) // required for floating toolbar and `disabled` prop
    .add((0, $88434.decorationsPlugin)) // required for floating toolbar
    .add((0, $7gUM9.floatingToolbarPlugin)) // required for toolbar to appear under links
    .maybeAdd([
        (0, $7c4bW.hyperlinkPlugin),
        {
            editorAppearance: appearance,
            lpLinkPicker: true
        }
    ], $321c0d351d046272$var$shouldShow(enabledPlugins?.hyperLink)).add((0, $lTMvj.compositionPlugin)) // required for codeblock
    .maybeAdd([
        (0, $4r3i7.default),
        {}
    ], $321c0d351d046272$var$shouldShow(enabledPlugins?.codeBlock)).maybeAdd([
        (0, $bXi9c.insertBlockPlugin),
        {
            appearance: appearance
        }
    ], $321c0d351d046272$var$shouldShow(enabledPlugins?.insertBlock));
};

});
parcelRegister("7c4bW", function(module, exports) {
$parcel$export(module.exports, "hyperlinkPlugin", () => $6c47c03ecfef6936$export$8143923e8601d272);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $h9kgv = parcelRequire("h9kgv");

var $bMFKb = parcelRequire("bMFKb");

var $6Exgk = parcelRequire("6Exgk");

var $4axGb = parcelRequire("4axGb");

var $46A2h = parcelRequire("46A2h");

var $8GLF3 = parcelRequire("8GLF3");

var $c1NDo = parcelRequire("c1NDo");

var $grDTV = parcelRequire("grDTV");

var $9ucqS = parcelRequire("9ucqS");

var $eGOwo = parcelRequire("eGOwo");

var $92xoS = parcelRequire("92xoS");

var $eBKSl = parcelRequire("eBKSl");

var $2mlVO = parcelRequire("2mlVO");

var $fqUwN = parcelRequire("fqUwN");

var $5uCg0 = parcelRequire("5uCg0");

var $jfXvp = parcelRequire("jfXvp");

var $68iXk = parcelRequire("68iXk");

var $cF6Iw = parcelRequire("cF6Iw");

var $4W4Vf = parcelRequire("4W4Vf");
const $6c47c03ecfef6936$var$getPosFromActiveLinkMark = (state)=>{
    if (state === undefined) return undefined;
    switch(state.type){
        case 'EDIT':
        case 'EDIT_INSERTED':
            return state.pos;
        case 'INSERT':
            return undefined;
    }
};
const $6c47c03ecfef6936$var$selectionToolbarLinkButtonTestId = 'ak-editor-selection-toolbar-link-button';
const $6c47c03ecfef6936$export$8143923e8601d272 = ({ config: options = {}, api: api })=>{
    let primaryToolbarComponent;
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $cF6Iw.getToolbarComponents)(api));
    return {
        name: 'hyperlink',
        marks () {
            return [
                {
                    name: 'link',
                    mark: (0, $h9kgv.link)
                }
            ];
        },
        commands: {
            showLinkToolbar: (inputMethod = (0, $bMFKb.INPUT_METHOD).TOOLBAR)=>(0, $eBKSl.showLinkToolbar)(inputMethod, api?.analytics?.actions),
            updateLink: (href, text)=>{
                const linkMark = api?.hyperlink?.sharedState.currentState()?.activeLinkMark;
                const pos = $6c47c03ecfef6936$var$getPosFromActiveLinkMark(linkMark);
                if (pos === undefined) return ()=>null;
                return (0, $eBKSl.updateLinkEditorCommand)(href, text, pos);
            },
            removeLink: ()=>{
                const linkMark = api?.hyperlink?.sharedState.currentState()?.activeLinkMark;
                const pos = $6c47c03ecfef6936$var$getPosFromActiveLinkMark(linkMark);
                if (pos === undefined) return ()=>null;
                return (0, $eBKSl.removeLinkEditorCommand)(pos, api?.analytics?.actions);
            }
        },
        actions: {
            hideLinkToolbar: (0, $eBKSl.hideLinkToolbarSetMeta),
            insertLink: (inputMethod, from, to, href, title, displayText, cardsAvailable = false, sourceEvent, appearance)=>(0, $eBKSl.insertLinkWithAnalytics)(inputMethod, from, to, href, api?.card?.actions, api?.analytics?.actions, title, displayText, cardsAvailable, sourceEvent, appearance),
            updateLink: (0, $eBKSl.updateLink)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $jfXvp.stateKey).getState(editorState);
        },
        pmPlugins () {
            return [
                {
                    name: 'hyperlink',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl })=>(0, $jfXvp.plugin)(dispatch, getIntl(), options?.editorAppearance, api, options?.onClickCallback, // @ts-ignore Temporary solution to check for Live Page editor.
                        options.__livePage)
                },
                {
                    name: 'fakeCursorToolbarPlugin',
                    plugin: ()=>(0, $2mlVO.default)
                },
                {
                    name: 'hyperlinkInputRule',
                    plugin: ({ schema: schema })=>(0, $fqUwN.createInputRulePlugin)(schema, api?.analytics?.actions, options.autoLinkOnBlur)
                },
                {
                    name: 'hyperlinkKeymap',
                    plugin: ()=>(0, $5uCg0.createKeymapPlugin)(api?.analytics?.actions)
                },
                {
                    name: 'hyperlinkToolbarButtons',
                    plugin: ()=>{
                        const hasCard = !!api?.card?.actions;
                        return (0, $68iXk.toolbarButtonsPlugin)(hasCard ? {
                            skipAnalytics: true
                        } : undefined);
                    }
                }
            ];
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'hyperlink',
                        title: formatMessage((0, $46A2h.toolbarInsertBlockMessages).link),
                        description: formatMessage((0, $46A2h.toolbarInsertBlockMessages).linkDescription),
                        keywords: [
                            'hyperlink',
                            'url'
                        ],
                        priority: 1200,
                        keyshortcut: (0, $6Exgk.tooltip)((0, $6Exgk.addLink)),
                        icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $c1NDo.IconLink), {}),
                        action (insert, state) {
                            const tr = insert(undefined);
                            tr.setMeta((0, $jfXvp.stateKey), {
                                type: (0, $4axGb.LinkAction).SHOW_INSERT_TOOLBAR,
                                inputMethod: (0, $bMFKb.INPUT_METHOD).QUICK_INSERT
                            });
                            const analyticsAttached = api?.analytics?.actions?.attachAnalyticsEvent?.({
                                action: (0, $bMFKb.ACTION).INVOKED,
                                actionSubject: (0, $bMFKb.ACTION_SUBJECT).TYPEAHEAD,
                                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).TYPEAHEAD_LINK,
                                attributes: {
                                    inputMethod: (0, $bMFKb.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $bMFKb.EVENT_TYPE).UI
                            })(tr);
                            return analyticsAttached !== false ? tr : false;
                        }
                    }
                ],
            floatingToolbar: (0, $4W4Vf.getToolbarConfig)(options, api),
            ...!isToolbarAIFCEnabled && {
                selectionToolbar: (state, { formatMessage: formatMessage })=>{
                    const toolbarDocking = (0, $eGOwo.fg)('platform_editor_use_preferences_plugin') ? api?.userPreferences?.sharedState.currentState()?.preferences.toolbarDockingPosition : api?.selectionToolbar?.sharedState?.currentState()?.toolbarDocking;
                    if (toolbarDocking === 'none' && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1', {
                        exposure: true
                    })) {
                        const toolbarButton = ()=>{
                            const { from: from, to: to } = state.selection;
                            const isEnabled = (0, $grDTV.canLinkBeCreatedInRange)(from, to)(state);
                            const title = formatMessage((0, $46A2h.toolbarInsertBlockMessages).link);
                            return {
                                type: 'button',
                                disabled: !isEnabled,
                                testId: `${$6c47c03ecfef6936$var$selectionToolbarLinkButtonTestId}`,
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9ucqS))),
                                title: title,
                                tooltipContent: (0, $6Exgk.tooltip)((0, $6Exgk.addLink), title),
                                showTitle: false,
                                onClick: (state, dispatch)=>{
                                    return (0, $8GLF3.editorCommandToPMCommand)((0, $eBKSl.showLinkToolbar)((0, $bMFKb.INPUT_METHOD).FLOATING_TB, api?.analytics?.actions))(state, dispatch);
                                }
                            };
                        };
                        return {
                            isToolbarAbove: true,
                            items: [
                                toolbarButton()
                            ],
                            rank: 2
                        };
                    } else return undefined;
                }
            },
            ...!isToolbarAIFCEnabled && {
                primaryToolbarComponent: !api?.primaryToolbar && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1', {
                    exposure: true
                }) ? primaryToolbarComponent : undefined
            }
        }
    };
};

});
parcelRegister("6Exgk", function(module, exports) {
$parcel$export(module.exports, "addAltText", () => $d130671d8acbd866$export$82527b23b485fa7f);
$parcel$export(module.exports, "makeKeyMapWithCommon", () => $d130671d8acbd866$export$7e6b588cc98b34f1);
$parcel$export(module.exports, "navToEditorToolbar", () => $d130671d8acbd866$export$9288bbefb6b7498b);
$parcel$export(module.exports, "navToFloatingToolbar", () => $d130671d8acbd866$export$7be006a99a30f86b);
$parcel$export(module.exports, "askAIQuickInsert", () => $d130671d8acbd866$export$ae37214e128d9cc3);
$parcel$export(module.exports, "toggleBold", () => $d130671d8acbd866$export$183fe6d20e9e58ba);
$parcel$export(module.exports, "toggleItalic", () => $d130671d8acbd866$export$b03177f345903916);
$parcel$export(module.exports, "toggleUnderline", () => $d130671d8acbd866$export$6bcc93697958b66d);
$parcel$export(module.exports, "toggleStrikethrough", () => $d130671d8acbd866$export$6d564ba4eaf138d9);
$parcel$export(module.exports, "toggleSubscript", () => $d130671d8acbd866$export$d26ab98fee0c804);
$parcel$export(module.exports, "toggleSuperscript", () => $d130671d8acbd866$export$4af6b58e12324fd);
$parcel$export(module.exports, "toggleCode", () => $d130671d8acbd866$export$70686c6e7e15ed46);
$parcel$export(module.exports, "pastePlainText", () => $d130671d8acbd866$export$ab06dc742bb20e03);
$parcel$export(module.exports, "clearFormatting", () => $d130671d8acbd866$export$195de5d8e201efd7);
$parcel$export(module.exports, "setNormalText", () => $d130671d8acbd866$export$63c4f0859cc75dc6);
$parcel$export(module.exports, "toggleHeading1", () => $d130671d8acbd866$export$953ab0e6a5d310a9);
$parcel$export(module.exports, "toggleHeading2", () => $d130671d8acbd866$export$192a351cfd6ca247);
$parcel$export(module.exports, "toggleHeading3", () => $d130671d8acbd866$export$fe382f3f4c871c62);
$parcel$export(module.exports, "toggleHeading4", () => $d130671d8acbd866$export$4073e08db19e0e31);
$parcel$export(module.exports, "toggleHeading5", () => $d130671d8acbd866$export$b84e85b2035ddb39);
$parcel$export(module.exports, "toggleHeading6", () => $d130671d8acbd866$export$86b1ac99fd15509b);
$parcel$export(module.exports, "toggleOrderedList", () => $d130671d8acbd866$export$dca848a1b50b6a31);
$parcel$export(module.exports, "toggleBulletList", () => $d130671d8acbd866$export$c0e115f47553645e);
$parcel$export(module.exports, "toggleBlockQuote", () => $d130671d8acbd866$export$34ed0cbd4f7ff88);
$parcel$export(module.exports, "insertNewLine", () => $d130671d8acbd866$export$c2d9390f63354627);
$parcel$export(module.exports, "insertRule", () => $d130671d8acbd866$export$5f13bbad564673d4);
$parcel$export(module.exports, "undo", () => $d130671d8acbd866$export$21f930c44940fd98);
$parcel$export(module.exports, "moveUp", () => $d130671d8acbd866$export$44935f8a884b57b9);
$parcel$export(module.exports, "moveDown", () => $d130671d8acbd866$export$8eba228b343b3599);
$parcel$export(module.exports, "moveLeft", () => $d130671d8acbd866$export$108f27160c89e515);
$parcel$export(module.exports, "moveRight", () => $d130671d8acbd866$export$e2c874fbfec7201);
$parcel$export(module.exports, "indentList", () => $d130671d8acbd866$export$8066a906978eedb2);
$parcel$export(module.exports, "outdentList", () => $d130671d8acbd866$export$959569198ddbbe17);
$parcel$export(module.exports, "redoAlt", () => $d130671d8acbd866$export$c0e41ad67d77f6bb);
$parcel$export(module.exports, "redo", () => $d130671d8acbd866$export$1688e416fee0a49e);
$parcel$export(module.exports, "openHelp", () => $d130671d8acbd866$export$1e2fd7795238a2d3);
$parcel$export(module.exports, "addLink", () => $d130671d8acbd866$export$56b88caa6d8a3bff);
$parcel$export(module.exports, "addInlineComment", () => $d130671d8acbd866$export$fd78ad47ea0892f4);
$parcel$export(module.exports, "submit", () => $d130671d8acbd866$export$853c27de4ce0f746);
$parcel$export(module.exports, "enter", () => $d130671d8acbd866$export$e668df1bcd81e4d2);
$parcel$export(module.exports, "tab", () => $d130671d8acbd866$export$62d58b1c91e8e902);
$parcel$export(module.exports, "indent", () => $d130671d8acbd866$export$79ebfa808dffa5c6);
$parcel$export(module.exports, "outdent", () => $d130671d8acbd866$export$25755c0352544598);
$parcel$export(module.exports, "backspace", () => $d130671d8acbd866$export$1ea584ca7009bcc1);
$parcel$export(module.exports, "deleteKey", () => $d130671d8acbd866$export$9603e93cdf38d7);
$parcel$export(module.exports, "forwardDelete", () => $d130671d8acbd866$export$9e41eded5cb7e706);
$parcel$export(module.exports, "space", () => $d130671d8acbd866$export$a941ed4b947d12f8);
$parcel$export(module.exports, "escape", () => $d130671d8acbd866$export$4e7f196112fea3c5);
$parcel$export(module.exports, "nextCell", () => $d130671d8acbd866$export$172699367bb25225);
$parcel$export(module.exports, "previousCell", () => $d130671d8acbd866$export$69838570e03d7193);
$parcel$export(module.exports, "shiftArrowUp", () => $d130671d8acbd866$export$776c0cd47234205a);
$parcel$export(module.exports, "shiftTab", () => $d130671d8acbd866$export$9ad63694f5781e16);
$parcel$export(module.exports, "toggleTable", () => $d130671d8acbd866$export$33b9473b3f67763f);
$parcel$export(module.exports, "focusTableResizer", () => $d130671d8acbd866$export$a57fbe0d9c764ae0);
$parcel$export(module.exports, "addRowBefore", () => $d130671d8acbd866$export$2e3087448cf87857);
$parcel$export(module.exports, "addRowAfter", () => $d130671d8acbd866$export$fbcf51cabbe4a007);
$parcel$export(module.exports, "addColumnAfter", () => $d130671d8acbd866$export$bf95f7b7d259c19f);
$parcel$export(module.exports, "addColumnBefore", () => $d130671d8acbd866$export$717d5ccb817cdecc);
$parcel$export(module.exports, "addRowBeforeVO", () => $d130671d8acbd866$export$5851c701392d3bfd);
$parcel$export(module.exports, "addRowAfterVO", () => $d130671d8acbd866$export$73fa63faf0fd6077);
$parcel$export(module.exports, "addColumnAfterVO", () => $d130671d8acbd866$export$875b853996fced8d);
$parcel$export(module.exports, "addColumnBeforeVO", () => $d130671d8acbd866$export$414418ca306c22bd);
$parcel$export(module.exports, "moveColumnLeft", () => $d130671d8acbd866$export$f092689a35ce978d);
$parcel$export(module.exports, "moveColumnRight", () => $d130671d8acbd866$export$863ee96d9e15383b);
$parcel$export(module.exports, "moveRowDown", () => $d130671d8acbd866$export$13c2dd2d968ada2a);
$parcel$export(module.exports, "moveRowUp", () => $d130671d8acbd866$export$e6749a6fc243b921);
$parcel$export(module.exports, "deleteColumn", () => $d130671d8acbd866$export$f4f2d7d33085c714);
$parcel$export(module.exports, "deleteRow", () => $d130671d8acbd866$export$2ef39e5ffdaff9ed);
$parcel$export(module.exports, "startColumnResizing", () => $d130671d8acbd866$export$8f58457f1327dd26);
$parcel$export(module.exports, "find", () => $d130671d8acbd866$export$71aa6c912b956294);
$parcel$export(module.exports, "alignLeft", () => $d130671d8acbd866$export$ca42dd9a1a0eb501);
$parcel$export(module.exports, "alignCenter", () => $d130671d8acbd866$export$f4a51ff076cc9a09);
$parcel$export(module.exports, "alignRight", () => $d130671d8acbd866$export$faf8793e4a37a5a2);
$parcel$export(module.exports, "toggleTaskItemCheckbox", () => $d130671d8acbd866$export$6f041e7a1d88fa51);
$parcel$export(module.exports, "toggleTaskList", () => $d130671d8acbd866$export$2e48e3ea1c210731);
$parcel$export(module.exports, "selectRow", () => $d130671d8acbd866$export$e247ed8cec4832f4);
$parcel$export(module.exports, "selectColumn", () => $d130671d8acbd866$export$c2e8772deb1607ea);
$parcel$export(module.exports, "selectTable", () => $d130671d8acbd866$export$625c5b9bf13f01a8);
$parcel$export(module.exports, "increaseMediaSize", () => $d130671d8acbd866$export$fdeca4160ac263c5);
$parcel$export(module.exports, "decreaseMediaSize", () => $d130671d8acbd866$export$5ec5f857fec297eb);
$parcel$export(module.exports, "activateVideoControls", () => $d130671d8acbd866$export$36141559a83247ee);
$parcel$export(module.exports, "toggleHighlightPalette", () => $d130671d8acbd866$export$ec123199f2fe4770);
$parcel$export(module.exports, "focusToContextMenuTrigger", () => $d130671d8acbd866$export$6b05735f625d1c82);
$parcel$export(module.exports, "toggleCodeBlock", () => $d130671d8acbd866$export$e9c6aab026be9523);
$parcel$export(module.exports, "insertEmoji", () => $d130671d8acbd866$export$8d5c072327044b6f);
$parcel$export(module.exports, "insertMention", () => $d130671d8acbd866$export$8c4314a90d4c5fc1);
$parcel$export(module.exports, "insertTaskList", () => $d130671d8acbd866$export$cf3c284f81e5d477);
$parcel$export(module.exports, "insertElements", () => $d130671d8acbd866$export$edd9d3cec5b0a9b6);
$parcel$export(module.exports, "continueInRovoChat", () => $d130671d8acbd866$export$54f122e0d55178a9);
$parcel$export(module.exports, "formatShortcut", () => $d130671d8acbd866$export$384a290f8c265cc5);
$parcel$export(module.exports, "tooltip", () => $d130671d8acbd866$export$4e6f96734dfe12f4);
$parcel$export(module.exports, "ToolTipContent", () => $d130671d8acbd866$export$4096cb8ab9668358);
$parcel$export(module.exports, "findKeymapByDescription", () => $d130671d8acbd866$export$c4e6735ce96cc7b3);
$parcel$export(module.exports, "findShortcutByKeymap", () => $d130671d8acbd866$export$d69faf3b7bc3451);
$parcel$export(module.exports, "getAriaKeyshortcuts", () => $d130671d8acbd866$export$6db28e5c399297b0);
$parcel$export(module.exports, "bindKeymapWithCommand", () => $d130671d8acbd866$export$4bced0ac29aaf950);
$parcel$export(module.exports, "bindKeymapArrayWithCommand", () => $d130671d8acbd866$export$e40cfdbcfa26f180);
$parcel$export(module.exports, "bindKeymapWithEditorCommand", () => $d130671d8acbd866$export$b87d3e1cb85f0ba1);
$parcel$export(module.exports, "findKeyMapForBrowser", () => $d130671d8acbd866$export$b2dbe47650bcfa54);
$parcel$export(module.exports, "isCapsLockOnAndModifyKeyboardEvent", () => $d130671d8acbd866$export$f2da701c7659a26c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $1rXzn = parcelRequire("1rXzn");

var $cbSL1 = parcelRequire("cbSL1");

var $8GLF3 = parcelRequire("8GLF3");

var $7EdFW = parcelRequire("7EdFW");


var $c9NXO = parcelRequire("c9NXO");
const $d130671d8acbd866$export$82527b23b485fa7f = $d130671d8acbd866$export$7e6b588cc98b34f1('Add Alt Text', 'Mod-Alt-y');
const $d130671d8acbd866$export$9288bbefb6b7498b = $d130671d8acbd866$export$7e6b588cc98b34f1('Navigate to editor toolbar', 'Alt-F9');
const $d130671d8acbd866$export$7be006a99a30f86b = $d130671d8acbd866$export$7e6b588cc98b34f1('Navigate to floating toolbar', 'Alt-F10');
const $d130671d8acbd866$export$ae37214e128d9cc3 = $d130671d8acbd866$export$7e6b588cc98b34f1('Ask AI', "Mod-'");
const $d130671d8acbd866$export$183fe6d20e9e58ba = $d130671d8acbd866$export$7e6b588cc98b34f1('Bold', 'Mod-b');
const $d130671d8acbd866$export$b03177f345903916 = $d130671d8acbd866$export$7e6b588cc98b34f1('Italic', 'Mod-i');
const $d130671d8acbd866$export$6bcc93697958b66d = $d130671d8acbd866$export$7e6b588cc98b34f1('Underline', 'Mod-u');
const $d130671d8acbd866$export$6d564ba4eaf138d9 = $d130671d8acbd866$export$7e6b588cc98b34f1('Strikethrough', 'Mod-Shift-s');
const $d130671d8acbd866$export$d26ab98fee0c804 = $d130671d8acbd866$export$7e6b588cc98b34f1('Subscript', 'Mod-Shift-,');
const $d130671d8acbd866$export$4af6b58e12324fd = $d130671d8acbd866$export$7e6b588cc98b34f1('Superscript', 'Mod-Shift-.');
const $d130671d8acbd866$export$70686c6e7e15ed46 = $d130671d8acbd866$export$7e6b588cc98b34f1('Code', 'Mod-Shift-m');
const $d130671d8acbd866$export$ab06dc742bb20e03 = $d130671d8acbd866$export$7e6b588cc98b34f1('Paste Plain Text', 'Mod-Shift-v');
const $d130671d8acbd866$export$195de5d8e201efd7 = $d130671d8acbd866$export$7e6b588cc98b34f1('Clear formatting', 'Mod-\\');
const $d130671d8acbd866$export$63c4f0859cc75dc6 = $d130671d8acbd866$export$7e6b588cc98b34f1('Normal text', 'Mod-Alt-0');
const $d130671d8acbd866$export$953ab0e6a5d310a9 = $d130671d8acbd866$export$7e6b588cc98b34f1('Heading 1', 'Mod-Alt-1');
const $d130671d8acbd866$export$192a351cfd6ca247 = $d130671d8acbd866$export$7e6b588cc98b34f1('Heading 2', 'Mod-Alt-2');
const $d130671d8acbd866$export$fe382f3f4c871c62 = $d130671d8acbd866$export$7e6b588cc98b34f1('Heading 3', 'Mod-Alt-3');
const $d130671d8acbd866$export$4073e08db19e0e31 = $d130671d8acbd866$export$7e6b588cc98b34f1('Heading 4', 'Mod-Alt-4');
const $d130671d8acbd866$export$b84e85b2035ddb39 = $d130671d8acbd866$export$7e6b588cc98b34f1('Heading 5', 'Mod-Alt-5');
const $d130671d8acbd866$export$86b1ac99fd15509b = $d130671d8acbd866$export$7e6b588cc98b34f1('Heading 6', 'Mod-Alt-6');
const $d130671d8acbd866$export$dca848a1b50b6a31 = $d130671d8acbd866$export$7e6b588cc98b34f1('Numbered list', 'Mod-Shift-7');
const $d130671d8acbd866$export$17f69a767ce93bb3 = $d130671d8acbd866$export$7e6b588cc98b34f1('Cmd + Backspace', 'Mod-Backspace');
const $d130671d8acbd866$export$c0e115f47553645e = $d130671d8acbd866$export$7e6b588cc98b34f1('Bullet list', 'Mod-Shift-8');
const $d130671d8acbd866$export$34ed0cbd4f7ff88 = $d130671d8acbd866$export$7e6b588cc98b34f1('Quote', 'Mod-Shift-9');
const $d130671d8acbd866$export$c2d9390f63354627 = $d130671d8acbd866$export$7e6b588cc98b34f1('Insert new line', 'Shift-Enter');
const $d130671d8acbd866$export$dfd73a1c108b1570 = $d130671d8acbd866$export$7e6b588cc98b34f1('Shift Backspace', 'Shift-Backspace');
const $d130671d8acbd866$export$9e5a9569a07601f2 = $d130671d8acbd866$export$7e6b588cc98b34f1('Split code block', 'Enter');
const $d130671d8acbd866$export$e920ee2eb756d384 = $d130671d8acbd866$export$7e6b588cc98b34f1('Split list item', 'Enter');
const $d130671d8acbd866$export$5f13bbad564673d4 = $d130671d8acbd866$export$7e6b588cc98b34f1('Insert horizontal rule', 'Mod-Shift--');
const $d130671d8acbd866$export$21f930c44940fd98 = $d130671d8acbd866$export$7e6b588cc98b34f1('Undo', 'Mod-z');
const $d130671d8acbd866$export$44935f8a884b57b9 = $d130671d8acbd866$export$7e6b588cc98b34f1('Move up', 'ArrowUp');
const $d130671d8acbd866$export$8eba228b343b3599 = $d130671d8acbd866$export$7e6b588cc98b34f1('Move down', 'ArrowDown');
const $d130671d8acbd866$export$108f27160c89e515 = $d130671d8acbd866$export$7e6b588cc98b34f1('Move left', 'ArrowLeft');
const $d130671d8acbd866$export$e2c874fbfec7201 = $d130671d8acbd866$export$7e6b588cc98b34f1('Move right', 'ArrowRight');
const $d130671d8acbd866$export$8066a906978eedb2 = $d130671d8acbd866$export$7e6b588cc98b34f1('Indent List', 'Tab');
const $d130671d8acbd866$export$959569198ddbbe17 = $d130671d8acbd866$export$7e6b588cc98b34f1('Outdent List', 'Shift-Tab');
const $d130671d8acbd866$export$c0e41ad67d77f6bb = $d130671d8acbd866$export$7e6b588cc98b34f1('Redo', 'Mod-y');
const $d130671d8acbd866$export$1688e416fee0a49e = $d130671d8acbd866$export$d8a7f422d8d42038('Redo', 'Ctrl-y', 'Mod-Shift-z');
const $d130671d8acbd866$export$1e2fd7795238a2d3 = $d130671d8acbd866$export$7e6b588cc98b34f1('Open Help', 'Mod-/');
const $d130671d8acbd866$export$56b88caa6d8a3bff = $d130671d8acbd866$export$7e6b588cc98b34f1('Link', 'Mod-k');
const $d130671d8acbd866$export$fd78ad47ea0892f4 = $d130671d8acbd866$export$7e6b588cc98b34f1('Annotate', 'Mod-Alt-c');
const $d130671d8acbd866$export$853c27de4ce0f746 = $d130671d8acbd866$export$7e6b588cc98b34f1('Submit Content', 'Mod-Enter');
const $d130671d8acbd866$export$e668df1bcd81e4d2 = $d130671d8acbd866$export$7e6b588cc98b34f1('Enter', 'Enter');
const $d130671d8acbd866$export$9f99fe2ed5bb7a29 = $d130671d8acbd866$export$7e6b588cc98b34f1('Shift Enter', 'Shift-Enter');
const $d130671d8acbd866$export$62d58b1c91e8e902 = $d130671d8acbd866$export$7e6b588cc98b34f1('Tab', 'Tab');
const $d130671d8acbd866$export$79ebfa808dffa5c6 = $d130671d8acbd866$export$7e6b588cc98b34f1('Indent', 'Tab');
const $d130671d8acbd866$export$25755c0352544598 = $d130671d8acbd866$export$7e6b588cc98b34f1('Outdent', 'Shift-Tab');
const $d130671d8acbd866$export$1ea584ca7009bcc1 = $d130671d8acbd866$export$7e6b588cc98b34f1('Backspace', 'Backspace');
const $d130671d8acbd866$export$9603e93cdf38d7 = $d130671d8acbd866$export$7e6b588cc98b34f1('Delete', 'Delete');
const $d130671d8acbd866$export$9e41eded5cb7e706 = $d130671d8acbd866$export$d8a7f422d8d42038('Forward Delete', '', 'Ctrl-d');
const $d130671d8acbd866$export$a941ed4b947d12f8 = $d130671d8acbd866$export$7e6b588cc98b34f1('Space', 'Space');
const $d130671d8acbd866$export$4e7f196112fea3c5 = $d130671d8acbd866$export$7e6b588cc98b34f1('Escape', 'Escape');
const $d130671d8acbd866$export$172699367bb25225 = $d130671d8acbd866$export$7e6b588cc98b34f1('Next cell', 'Tab');
const $d130671d8acbd866$export$69838570e03d7193 = $d130671d8acbd866$export$7e6b588cc98b34f1('Previous cell', 'Shift-Tab');
const $d130671d8acbd866$export$776c0cd47234205a = $d130671d8acbd866$export$7e6b588cc98b34f1('Shift ArrowUp', 'Shift-ArrowUp');
const $d130671d8acbd866$export$9ad63694f5781e16 = $d130671d8acbd866$export$7e6b588cc98b34f1('Shift Tab', 'Shift-Tab');
const $d130671d8acbd866$export$33b9473b3f67763f = $d130671d8acbd866$export$7e6b588cc98b34f1('Table', 'Shift-Alt-t');
const $d130671d8acbd866$export$a57fbe0d9c764ae0 = $d130671d8acbd866$export$7e6b588cc98b34f1('Focus Table Resizer', 'Mod-Alt-Shift-r');
const $d130671d8acbd866$export$2e3087448cf87857 = $d130671d8acbd866$export$7e6b588cc98b34f1('Add Row Above', 'Ctrl-Alt-ArrowUp');
const $d130671d8acbd866$export$fbcf51cabbe4a007 = $d130671d8acbd866$export$7e6b588cc98b34f1('Add Row Below', 'Ctrl-Alt-ArrowDown');
const $d130671d8acbd866$export$bf95f7b7d259c19f = $d130671d8acbd866$export$7e6b588cc98b34f1('Add Column After', 'Ctrl-Alt-ArrowRight');
const $d130671d8acbd866$export$717d5ccb817cdecc = $d130671d8acbd866$export$7e6b588cc98b34f1('Add Column Before', 'Ctrl-Alt-ArrowLeft');
const $d130671d8acbd866$export$5851c701392d3bfd = $d130671d8acbd866$export$7e6b588cc98b34f1('Add Row Above', 'Mod-Alt-[');
const $d130671d8acbd866$export$73fa63faf0fd6077 = $d130671d8acbd866$export$7e6b588cc98b34f1('Add Row Below', 'Mod-Alt-]');
const $d130671d8acbd866$export$875b853996fced8d = $d130671d8acbd866$export$7e6b588cc98b34f1('Add Column After', 'Mod-Alt-=');
const $d130671d8acbd866$export$414418ca306c22bd = $d130671d8acbd866$export$7e6b588cc98b34f1('Add Column Before', 'Mod-Alt--');
const $d130671d8acbd866$export$f092689a35ce978d = $d130671d8acbd866$export$7e6b588cc98b34f1('Move Column Left', 'Ctrl-Alt-Shift-ArrowLeft');
const $d130671d8acbd866$export$863ee96d9e15383b = $d130671d8acbd866$export$7e6b588cc98b34f1('Move Column Right', 'Ctrl-Alt-Shift-ArrowRight');
const $d130671d8acbd866$export$13c2dd2d968ada2a = $d130671d8acbd866$export$7e6b588cc98b34f1('Move Row Down', 'Ctrl-Alt-Shift-ArrowDown');
const $d130671d8acbd866$export$e6749a6fc243b921 = $d130671d8acbd866$export$7e6b588cc98b34f1('Move Row Up', 'Ctrl-Alt-Shift-ArrowUp');
const $d130671d8acbd866$export$f4f2d7d33085c714 = $d130671d8acbd866$export$7e6b588cc98b34f1('Delete Column', 'Ctrl-Backspace');
const $d130671d8acbd866$export$2ef39e5ffdaff9ed = $d130671d8acbd866$export$7e6b588cc98b34f1('Delete Row', 'Ctrl-Backspace');
const $d130671d8acbd866$export$8f58457f1327dd26 = $d130671d8acbd866$export$7e6b588cc98b34f1('Activate Column Resize', 'Mod-Alt-Shift-c');
const $d130671d8acbd866$export$af2a99f971a346e6 = $d130671d8acbd866$export$7e6b588cc98b34f1('Cut', 'Mod-x');
const $d130671d8acbd866$export$784d13d8ee351f07 = $d130671d8acbd866$export$7e6b588cc98b34f1('Copy', 'Mod-c');
const $d130671d8acbd866$export$9b6706c8686cfc8e = $d130671d8acbd866$export$7e6b588cc98b34f1('Paste', 'Mod-v');
const $d130671d8acbd866$export$3c1455b21d3e7aab = $d130671d8acbd866$export$7e6b588cc98b34f1('Paste', 'Mod-Shift-v');
const $d130671d8acbd866$export$71aa6c912b956294 = $d130671d8acbd866$export$7e6b588cc98b34f1('Find', 'Mod-f');
const $d130671d8acbd866$export$ca42dd9a1a0eb501 = $d130671d8acbd866$export$7e6b588cc98b34f1('Align Left', 'Mod-Shift-l');
const $d130671d8acbd866$export$f4a51ff076cc9a09 = $d130671d8acbd866$export$7e6b588cc98b34f1('Align Center', 'Mod-Alt-e');
const $d130671d8acbd866$export$faf8793e4a37a5a2 = $d130671d8acbd866$export$7e6b588cc98b34f1('Align Right', 'Mod-Alt-t');
const $d130671d8acbd866$export$6f041e7a1d88fa51 = $d130671d8acbd866$export$7e6b588cc98b34f1('Toggles task item', 'Mod-Alt-Enter');
const $d130671d8acbd866$export$2e48e3ea1c210731 = $d130671d8acbd866$export$7e6b588cc98b34f1('Toggle task list', 'Mod-Shift-6');
const $d130671d8acbd866$export$e247ed8cec4832f4 = $d130671d8acbd866$export$5882c1dfa05eb556('Select row', [
    'Mod-Alt-Shift-ArrowLeft',
    'Mod-Alt-Shift-ArrowRight'
]);
const $d130671d8acbd866$export$c2e8772deb1607ea = $d130671d8acbd866$export$5882c1dfa05eb556('Select column', [
    'Mod-Alt-Shift-ArrowDown',
    'Mod-Alt-Shift-ArrowUp'
]);
const $d130671d8acbd866$export$625c5b9bf13f01a8 = $d130671d8acbd866$export$7e6b588cc98b34f1('Select table', 'Mod-a');
const $d130671d8acbd866$export$fdeca4160ac263c5 = $d130671d8acbd866$export$7e6b588cc98b34f1('increase image size', 'Mod-Alt-]');
const $d130671d8acbd866$export$5ec5f857fec297eb = $d130671d8acbd866$export$7e6b588cc98b34f1('increase image size', 'Mod-Alt-[');
const $d130671d8acbd866$export$36141559a83247ee = $d130671d8acbd866$export$7e6b588cc98b34f1('Activate controls panel on video', 'Shift-F10');
const $d130671d8acbd866$export$ec123199f2fe4770 = $d130671d8acbd866$export$7e6b588cc98b34f1('Toggle Highlight Palette', 'Mod-Alt-b');
const $d130671d8acbd866$export$62f87f0ca411e518 = $d130671d8acbd866$export$7e6b588cc98b34f1('Apply Yellow Highlight', 'Mod-Alt-y');
const $d130671d8acbd866$export$6b05735f625d1c82 = $d130671d8acbd866$export$7e6b588cc98b34f1('Focus table context menu trigger', 'Shift-F10');
const $d130671d8acbd866$export$a1bdda43619f945f = $d130671d8acbd866$export$7e6b588cc98b34f1('Move node up in the document', 'Ctrl-Shift-ArrowUp');
const $d130671d8acbd866$export$9bf312985dc8137e = $d130671d8acbd866$export$7e6b588cc98b34f1('Move node down in the document', 'Ctrl-Shift-ArrowDown');
const $d130671d8acbd866$export$c4f661b85fc92fd1 = $d130671d8acbd866$export$7e6b588cc98b34f1('Move node to the left column in the document', 'Ctrl-Shift-Alt-ArrowLeft');
const $d130671d8acbd866$export$61c867f4a21787f6 = $d130671d8acbd866$export$7e6b588cc98b34f1('Move node to the right column in the document', 'Ctrl-Shift-Alt-ArrowRight');
const $d130671d8acbd866$export$ba34d2a4e6aa10e4 = $d130671d8acbd866$export$7e6b588cc98b34f1('Show drag handle for editor element', 'Ctrl-Shift-h');
const $d130671d8acbd866$export$e9c6aab026be9523 = $d130671d8acbd866$export$7e6b588cc98b34f1('Toggle Code Block', '```');
const $d130671d8acbd866$export$8d5c072327044b6f = $d130671d8acbd866$export$7e6b588cc98b34f1('Insert Emoji', ':');
const $d130671d8acbd866$export$8c4314a90d4c5fc1 = $d130671d8acbd866$export$7e6b588cc98b34f1('Insert Mention', '@');
const $d130671d8acbd866$export$cf3c284f81e5d477 = $d130671d8acbd866$export$7e6b588cc98b34f1('Insert Action Item', '[]');
const $d130671d8acbd866$export$edd9d3cec5b0a9b6 = $d130671d8acbd866$export$7e6b588cc98b34f1('Insert Elements', '/');
const $d130671d8acbd866$export$54f122e0d55178a9 = $d130671d8acbd866$export$7e6b588cc98b34f1('Continue in Rovo chat', 'Alt-Enter');
const $d130671d8acbd866$var$arrowKeysMap = {
    // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    ARROWLEFT: '\u2190',
    ARROWRIGHT: '\u2192',
    ARROWUP: '\u2191',
    ARROWDOWN: '\u2193'
};
const $d130671d8acbd866$var$tooltipShortcutStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    borderRadius: "var(--ds-radius-xsmall, 2px)",
    backgroundColor: "var(--ds-background-inverse-subtle, #00000029)",
    padding: `0 ${"var(--ds-space-025, 2px)"}`,
    // NOTE: This might not actually do anything: https://atlassian.slack.com/archives/CFG3PSQ9E/p1647395052443259?thread_ts=1647394572.556029&cid=CFG3PSQ9E
    label: 'tooltip-shortcut'
});
function $d130671d8acbd866$export$384a290f8c265cc5(keymap) {
    let shortcut;
    const browser = (0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $7EdFW.getBrowserInfo)() : (0, $7EdFW.browser);
    if (browser.mac) // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    shortcut = keymap.mac// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/Cmd/i, '\u2318')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/Shift/i, '\u21E7')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/Ctrl/i, '\u2303')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/Alt/i, '\u2325')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/Backspace/i, '\u232B')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/Enter/i, '\u23CE');
    else // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    shortcut = keymap.windows.replace(/Backspace/i, '\u232B');
    const keys = shortcut.split('-');
    let lastKey = keys[keys.length - 1];
    if (lastKey.length === 1) // capitalise single letters
    lastKey = lastKey.toUpperCase();
    keys[keys.length - 1] = $d130671d8acbd866$var$arrowKeysMap[lastKey.toUpperCase()] || lastKey;
    return keys.join(browser.mac ? '' : '+');
}
function $d130671d8acbd866$export$4e6f96734dfe12f4(keymap, description) {
    if (keymap) {
        const shortcut = $d130671d8acbd866$export$384a290f8c265cc5(keymap);
        return description ? `${description} ${shortcut}` : shortcut;
    }
    return;
}
const $d130671d8acbd866$export$4096cb8ab9668358 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ description: description, shortcutOverride: shortcutOverride, keymap: keymap })=>{
    const shortcut = shortcutOverride || keymap && $d130671d8acbd866$export$384a290f8c265cc5(keymap);
    return shortcut || description ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, description, shortcut && description && '\u00A0', shortcut && /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $d130671d8acbd866$var$tooltipShortcutStyle
    }, shortcut)) : null;
});
const $d130671d8acbd866$export$9f7e5fe6d45c5f7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ helpDescriptors: helpDescriptors })=>{
    const keymapCount = helpDescriptors.length;
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, helpDescriptors.map((descriptor, index)=>// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), {
            key: index
        }, /*#__PURE__*/ (0, $1NIU8.jsx)($d130671d8acbd866$export$4096cb8ab9668358, descriptor), ' ', index < keymapCount - 1 && /*#__PURE__*/ (0, $1NIU8.jsx)("br", null))));
});
function $d130671d8acbd866$export$c4e6735ce96cc7b3(description) {
    const matches = $d130671d8acbd866$var$ALL.filter((keymap)=>keymap.description.toUpperCase() === description.toUpperCase());
    return matches[0];
}
function $d130671d8acbd866$export$ca66063a345ce3ab(description) {
    const keymap = $d130671d8acbd866$export$c4e6735ce96cc7b3(description);
    if (keymap) return $d130671d8acbd866$export$d69faf3b7bc3451(keymap);
    return;
}
function $d130671d8acbd866$export$d69faf3b7bc3451(keymap) {
    const browser = (0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $7EdFW.getBrowserInfo)() : (0, $7EdFW.browser);
    if (browser.mac) return keymap.mac;
    return keymap.windows;
}
function $d130671d8acbd866$export$6db28e5c399297b0(keymap) {
    let keyShortcuts;
    const browser = (0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $7EdFW.getBrowserInfo)() : (0, $7EdFW.browser);
    if (typeof keymap === 'string') keyShortcuts = keymap;
    else if (typeof keymap === 'object') keyShortcuts = keymap[browser.mac ? 'mac' : 'windows'];
    if (keyShortcuts) return keyShortcuts.toLowerCase().split('-').map((modifier)=>{
        switch(modifier){
            case 'cmd':
                return 'Meta';
            case 'ctrl':
                return 'Control';
            case 'alt':
                return 'Alt';
            case 'shift':
                return 'Shift';
            case 'enter':
                return 'Enter';
            case 'esc':
                return 'Esc';
            case 'tab':
                return 'Tab';
            case 'space':
                return 'Space';
            case 'backspace':
                return 'Backspace';
            case 'arrowup':
                return 'Arrow Up';
            case 'arrowdown':
                return 'Arrow Down';
            default:
                return modifier.split('').join(' ');
        }
    }).join('+');
    else return undefined;
}
const $d130671d8acbd866$var$ALL = [
    $d130671d8acbd866$export$dca848a1b50b6a31,
    $d130671d8acbd866$export$c0e115f47553645e,
    $d130671d8acbd866$export$183fe6d20e9e58ba,
    $d130671d8acbd866$export$b03177f345903916,
    $d130671d8acbd866$export$6bcc93697958b66d,
    $d130671d8acbd866$export$6d564ba4eaf138d9,
    $d130671d8acbd866$export$d26ab98fee0c804,
    $d130671d8acbd866$export$4af6b58e12324fd,
    $d130671d8acbd866$export$70686c6e7e15ed46,
    $d130671d8acbd866$export$63c4f0859cc75dc6,
    $d130671d8acbd866$export$953ab0e6a5d310a9,
    $d130671d8acbd866$export$192a351cfd6ca247,
    $d130671d8acbd866$export$fe382f3f4c871c62,
    $d130671d8acbd866$export$4073e08db19e0e31,
    $d130671d8acbd866$export$b84e85b2035ddb39,
    $d130671d8acbd866$export$86b1ac99fd15509b,
    $d130671d8acbd866$export$34ed0cbd4f7ff88,
    $d130671d8acbd866$export$c2d9390f63354627,
    $d130671d8acbd866$export$5f13bbad564673d4,
    $d130671d8acbd866$export$9e5a9569a07601f2,
    $d130671d8acbd866$export$e920ee2eb756d384,
    $d130671d8acbd866$export$1688e416fee0a49e,
    $d130671d8acbd866$export$21f930c44940fd98,
    $d130671d8acbd866$export$71aa6c912b956294,
    $d130671d8acbd866$export$4e7f196112fea3c5,
    $d130671d8acbd866$export$e668df1bcd81e4d2,
    $d130671d8acbd866$export$9f99fe2ed5bb7a29
];
function $d130671d8acbd866$export$d8a7f422d8d42038(description, windows, mac, common) {
    return {
        description: description,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        windows: windows.replace(/Mod/i, 'Ctrl'),
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        mac: mac.replace(/Mod/i, 'Cmd'),
        common: common
    };
}
function $d130671d8acbd866$export$7e6b588cc98b34f1(description, common) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const windows = common.replace(/Mod/i, 'Ctrl');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const mac = common.replace(/Mod/i, 'Cmd');
    return $d130671d8acbd866$export$d8a7f422d8d42038(description, windows, mac, common);
}
function $d130671d8acbd866$export$5882c1dfa05eb556(description, shortcuts) {
    const keymapArray = [];
    shortcuts.forEach((shortcut)=>{
        keymapArray.push($d130671d8acbd866$export$7e6b588cc98b34f1(description, shortcut));
    });
    return keymapArray;
}
function $d130671d8acbd866$var$combineWithOldCommand(cmd, oldCmd) {
    return (state, dispatch, editorView)=>{
        return oldCmd(state, dispatch) || cmd(state, dispatch, editorView);
    };
}
function $d130671d8acbd866$export$4bced0ac29aaf950(shortcut, cmd, keymap) {
    const oldCmd = keymap[shortcut];
    keymap[shortcut] = oldCmd ? $d130671d8acbd866$var$combineWithOldCommand(cmd, oldCmd) : cmd;
}
function $d130671d8acbd866$export$e40cfdbcfa26f180(shortcutsArray, cmd, keymap) {
    shortcutsArray.forEach((shortcut)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return $d130671d8acbd866$export$4bced0ac29aaf950(shortcut.common, cmd, keymap);
    });
}
function $d130671d8acbd866$export$b87d3e1cb85f0ba1(shortcut, cmd, keymap) {
    $d130671d8acbd866$export$4bced0ac29aaf950(shortcut, (0, $8GLF3.editorCommandToPMCommand)(cmd), keymap);
}
function $d130671d8acbd866$export$b2dbe47650bcfa54(keyMap) {
    if (keyMap) {
        const browser = (0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $7EdFW.getBrowserInfo)() : (0, $7EdFW.browser);
        if (browser.mac) return keyMap.mac;
        return keyMap.windows;
    }
    return;
}
function $d130671d8acbd866$export$f2da701c7659a26c(event) {
    let keyboardEvent = event;
    const name = (0, $1rXzn.keyName)(event);
    if (event.ctrlKey && event.getModifierState('CapsLock') && !event.getModifierState('Shift') && name.length === 1 && // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /^[A-Z]/.test(name)) keyboardEvent = new KeyboardEvent('keydown', {
        key: (0, $1rXzn.base)[event.keyCode].toLowerCase(),
        code: event.code,
        ctrlKey: true
    });
    return keyboardEvent;
}

});
parcelRegister("1rXzn", function(module, exports) {
$parcel$export(module.exports, "base", () => $10e6855a98fb7649$export$e2253033e6e1df16);
$parcel$export(module.exports, "shift", () => $10e6855a98fb7649$export$fba63a578e423eb);
$parcel$export(module.exports, "keyName", () => $10e6855a98fb7649$export$fb33aafd75404f4c);
var $10e6855a98fb7649$export$e2253033e6e1df16 = {
    8: "Backspace",
    9: "Tab",
    10: "Enter",
    12: "NumLock",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    44: "PrintScreen",
    45: "Insert",
    46: "Delete",
    59: ";",
    61: "=",
    91: "Meta",
    92: "Meta",
    106: "*",
    107: "+",
    108: ",",
    109: "-",
    110: ".",
    111: "/",
    144: "NumLock",
    145: "ScrollLock",
    160: "Shift",
    161: "Shift",
    162: "Control",
    163: "Control",
    164: "Alt",
    165: "Alt",
    173: "-",
    186: ";",
    187: "=",
    188: ",",
    189: "-",
    190: ".",
    191: "/",
    192: "`",
    219: "[",
    220: "\\",
    221: "]",
    222: "'"
};
var $10e6855a98fb7649$export$fba63a578e423eb = {
    48: ")",
    49: "!",
    50: "@",
    51: "#",
    52: "$",
    53: "%",
    54: "^",
    55: "&",
    56: "*",
    57: "(",
    59: ":",
    61: "+",
    173: "_",
    186: ":",
    187: "+",
    188: "<",
    189: "_",
    190: ">",
    191: "?",
    192: "~",
    219: "{",
    220: "|",
    221: "}",
    222: "\""
};
var $10e6855a98fb7649$var$mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
var $10e6855a98fb7649$var$ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
// Fill in the digit keys
for(var $10e6855a98fb7649$var$i = 0; $10e6855a98fb7649$var$i < 10; $10e6855a98fb7649$var$i++)$10e6855a98fb7649$export$e2253033e6e1df16[48 + $10e6855a98fb7649$var$i] = $10e6855a98fb7649$export$e2253033e6e1df16[96 + $10e6855a98fb7649$var$i] = String($10e6855a98fb7649$var$i);
// The function keys
for(var $10e6855a98fb7649$var$i = 1; $10e6855a98fb7649$var$i <= 24; $10e6855a98fb7649$var$i++)$10e6855a98fb7649$export$e2253033e6e1df16[$10e6855a98fb7649$var$i + 111] = "F" + $10e6855a98fb7649$var$i;
// And the alphabetic keys
for(var $10e6855a98fb7649$var$i = 65; $10e6855a98fb7649$var$i <= 90; $10e6855a98fb7649$var$i++){
    $10e6855a98fb7649$export$e2253033e6e1df16[$10e6855a98fb7649$var$i] = String.fromCharCode($10e6855a98fb7649$var$i + 32);
    $10e6855a98fb7649$export$fba63a578e423eb[$10e6855a98fb7649$var$i] = String.fromCharCode($10e6855a98fb7649$var$i);
}
// For each code that doesn't have a shift-equivalent, copy the base name
for(var $10e6855a98fb7649$var$code in $10e6855a98fb7649$export$e2253033e6e1df16)if (!$10e6855a98fb7649$export$fba63a578e423eb.hasOwnProperty($10e6855a98fb7649$var$code)) $10e6855a98fb7649$export$fba63a578e423eb[$10e6855a98fb7649$var$code] = $10e6855a98fb7649$export$e2253033e6e1df16[$10e6855a98fb7649$var$code];
function $10e6855a98fb7649$export$fb33aafd75404f4c(event) {
    // On macOS, keys held with Shift and Cmd don't reflect the effect of Shift in `.key`.
    // On IE, shift effect is never included in `.key`.
    var ignoreKey = $10e6855a98fb7649$var$mac && event.metaKey && event.shiftKey && !event.ctrlKey && !event.altKey || $10e6855a98fb7649$var$ie && event.shiftKey && event.key && event.key.length == 1 || event.key == "Unidentified";
    var name = !ignoreKey && event.key || (event.shiftKey ? $10e6855a98fb7649$export$fba63a578e423eb : $10e6855a98fb7649$export$e2253033e6e1df16)[event.keyCode] || event.key || "Unidentified";
    // Edge sometimes produces wrong names (Issue #3)
    if (name == "Esc") name = "Escape";
    if (name == "Del") name = "Delete";
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
    if (name == "Left") name = "ArrowLeft";
    if (name == "Up") name = "ArrowUp";
    if (name == "Right") name = "ArrowRight";
    if (name == "Down") name = "ArrowDown";
    return name;
}

});

parcelRegister("c9NXO", function(module, exports) {
$parcel$export(module.exports, "keymap", () => $ce32827cb979a5c5$export$5043418e2ef368d5);

var $1rXzn = parcelRequire("1rXzn");

var $x7sgX = parcelRequire("x7sgX");

var $i8KtF = parcelRequire("i8KtF");
function $ce32827cb979a5c5$export$5043418e2ef368d5(bindings) {
    return new (0, $i8KtF.SafePlugin)({
        props: {
            handleKeyDown (view, event) {
                const name = (0, $1rXzn.keyName)(event);
                let keyboardEvent = event;
                // We will try to bypass the keycode only if any of mod keys are pressed,
                // to allow users to use non-latin and Dead characters.
                const isModKeyPressed = event.ctrlKey || event.metaKey;
                // Check the unicode of the character to assert that it's not an ASCII character.
                // These are characters outside latin's range.
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                const isNonLatinKey = name.length === 1 && /[^\u0000-\u007f]/.test(name);
                // The `Dead` key is a key that combines with a following key to produce a combined character.
                // It will have `even.key === 'Dead'` in some browsers but the `keyCode` will be the same as in a qwerty-keyboard.
                // See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key and https://en.wikipedia.org/wiki/Dead_key
                const isDeadKey = name === 'Dead';
                if (isModKeyPressed && (isNonLatinKey || isDeadKey)) keyboardEvent = new KeyboardEvent(event.type, {
                    // Ignored via go/ees007
                    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                    // FIXME: The event.keyCode is deprecated (see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode),
                    // and could be removed in any time, but the w3c-keyname library doesn't provide a way to get
                    // a key by event.code.
                    key: (0, $1rXzn.base)[event.keyCode],
                    code: event.code,
                    ctrlKey: event.ctrlKey,
                    altKey: event.altKey,
                    metaKey: event.metaKey,
                    shiftKey: event.shiftKey
                });
                return (0, $x7sgX.keydownHandler)(bindings)(view, keyboardEvent);
            }
        }
    });
}

});
parcelRegister("x7sgX", function(module, exports) {
$parcel$export(module.exports, "keymap", () => $0638dd97826018c9$export$5043418e2ef368d5);
$parcel$export(module.exports, "keydownHandler", () => $0638dd97826018c9$export$53f558754f8b9fd1);

var $1rXzn = parcelRequire("1rXzn");

var $3lIcL = parcelRequire("3lIcL");
const $0638dd97826018c9$var$mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : false;
function $0638dd97826018c9$var$normalizeKeyName(name) {
    let parts = name.split(/-(?!$)/), result = parts[parts.length - 1];
    if (result == "Space") result = " ";
    let alt, ctrl, shift, meta;
    for(let i = 0; i < parts.length - 1; i++){
        let mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod)) meta = true;
        else if (/^a(lt)?$/i.test(mod)) alt = true;
        else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
        else if (/^s(hift)?$/i.test(mod)) shift = true;
        else if (/^mod$/i.test(mod)) {
            if ($0638dd97826018c9$var$mac) meta = true;
            else ctrl = true;
        } else throw new Error("Unrecognized modifier name: " + mod);
    }
    if (alt) result = "Alt-" + result;
    if (ctrl) result = "Ctrl-" + result;
    if (meta) result = "Meta-" + result;
    if (shift) result = "Shift-" + result;
    return result;
}
function $0638dd97826018c9$var$normalize(map) {
    let copy = Object.create(null);
    for(let prop in map)copy[$0638dd97826018c9$var$normalizeKeyName(prop)] = map[prop];
    return copy;
}
function $0638dd97826018c9$var$modifiers(name, event, shift = true) {
    if (event.altKey) name = "Alt-" + name;
    if (event.ctrlKey) name = "Ctrl-" + name;
    if (event.metaKey) name = "Meta-" + name;
    if (shift && event.shiftKey) name = "Shift-" + name;
    return name;
}
/**
Create a keymap plugin for the given set of bindings.

Bindings should map key names to [command](https://prosemirror.net/docs/ref/#commands)-style
functions, which will be called with `(EditorState, dispatch,
EditorView)` arguments, and should return true when they've handled
the key. Note that the view argument isn't part of the command
protocol, but can be used as an escape hatch if a binding needs to
directly interact with the UI.

Key names may be strings like `"Shift-Ctrl-Enter"`—a key
identifier prefixed with zero or more modifiers. Key identifiers
are based on the strings that can appear in
[`KeyEvent.key`](https:developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key).
Use lowercase letters to refer to letter keys (or uppercase letters
if you want shift to be held). You may use `"Space"` as an alias
for the `" "` name.

Modifiers can be given in any order. `Shift-` (or `s-`), `Alt-` (or
`a-`), `Ctrl-` (or `c-` or `Control-`) and `Cmd-` (or `m-` or
`Meta-`) are recognized. For characters that are created by holding
shift, the `Shift-` prefix is implied, and should not be added
explicitly.

You can use `Mod-` as a shorthand for `Cmd-` on Mac and `Ctrl-` on
other platforms.

You can add multiple keymap plugins to an editor. The order in
which they appear determines their precedence (the ones early in
the array get to dispatch first).
*/ function $0638dd97826018c9$export$5043418e2ef368d5(bindings) {
    return new (0, $3lIcL.Plugin)({
        props: {
            handleKeyDown: $0638dd97826018c9$export$53f558754f8b9fd1(bindings)
        }
    });
}
/**
Given a set of bindings (using the same format as
[`keymap`](https://prosemirror.net/docs/ref/#keymap.keymap)), return a [keydown
handler](https://prosemirror.net/docs/ref/#view.EditorProps.handleKeyDown) that handles them.
*/ function $0638dd97826018c9$export$53f558754f8b9fd1(bindings) {
    let map = $0638dd97826018c9$var$normalize(bindings);
    return function(view, event) {
        let name = (0, $1rXzn.keyName)(event), baseName, direct = map[$0638dd97826018c9$var$modifiers(name, event)];
        if (direct && direct(view.state, view.dispatch, view)) return true;
        // A character key
        if (name.length == 1 && name != " ") {
            if (event.shiftKey) {
                // In case the name was already modified by shift, try looking
                // it up without its shift modifier
                let noShift = map[$0638dd97826018c9$var$modifiers(name, event, false)];
                if (noShift && noShift(view.state, view.dispatch, view)) return true;
            }
            if ((event.shiftKey || event.altKey || event.metaKey || name.charCodeAt(0) > 127) && (baseName = (0, $1rXzn.base)[event.keyCode]) && baseName != name) {
                // Try falling back to the keyCode when there's a modifier
                // active or the character produced isn't ASCII, and our table
                // produces a different name from the the keyCode. See #668,
                // #1060
                let fromCode = map[$0638dd97826018c9$var$modifiers(baseName, event)];
                if (fromCode && fromCode(view.state, view.dispatch, view)) return true;
            }
        }
        return false;
    };
}

});



parcelRegister("4axGb", function(module, exports) {
$parcel$export(module.exports, "LinkAction", () => $db469bd5a248a7ca$export$6dcc1033b74c9344);
$parcel$export(module.exports, "InsertStatus", () => $db469bd5a248a7ca$export$8dcc3cd59f9a0726);
var $db469bd5a248a7ca$export$6dcc1033b74c9344 = /*#__PURE__*/ function(LinkAction) {
    LinkAction["SHOW_INSERT_TOOLBAR"] = "SHOW_INSERT_TOOLBAR";
    LinkAction["HIDE_TOOLBAR"] = "HIDE_TOOLBAR";
    LinkAction["SELECTION_CHANGE"] = "SELECTION_CHANGE";
    LinkAction["INSERT_LINK_TOOLBAR"] = "INSERT";
    LinkAction["EDIT_INSERTED_TOOLBAR"] = "EDIT_INSERTED_TOOLBAR";
    LinkAction["SET_CONFIGURE_BUTTON_TARGET_POS"] = "SET_CONFIGURE_BUTTON_TARGET_POS";
    LinkAction["SET_CONFIGURE_DROPDOWN_OPEN"] = "SET_CONFIGURE_DROPDOWN_OPEN";
    return LinkAction;
}({});
var $db469bd5a248a7ca$export$8dcc3cd59f9a0726 = /*#__PURE__*/ function(InsertStatus) {
    InsertStatus["EDIT_LINK_TOOLBAR"] = "EDIT";
    InsertStatus["INSERT_LINK_TOOLBAR"] = "INSERT";
    InsertStatus["EDIT_INSERTED_TOOLBAR"] = "EDIT_INSERTED";
    return InsertStatus;
}({});

});

parcelRegister("c1NDo", function(module, exports) {
$parcel$export(module.exports, "IconAction", () => $99da9a417e294ba4$export$e40fe94b4cff8ec5);
$parcel$export(module.exports, "IconCode", () => $99da9a417e294ba4$export$e332a83b9159d69d);
$parcel$export(module.exports, "IconDate", () => $99da9a417e294ba4$export$39617668a6028b06);
$parcel$export(module.exports, "IconDecision", () => $99da9a417e294ba4$export$6eb71591d1461541);
$parcel$export(module.exports, "IconDivider", () => $99da9a417e294ba4$export$f2ab17920c9d243);
$parcel$export(module.exports, "IconEmoji", () => $99da9a417e294ba4$export$8bd591d4b34dcafa);
$parcel$export(module.exports, "IconImages", () => $99da9a417e294ba4$export$c17cf1164355efc2);
$parcel$export(module.exports, "IconLayout", () => $99da9a417e294ba4$export$fba0c846789a9d87);
$parcel$export(module.exports, "IconLink", () => $99da9a417e294ba4$export$23da1e9f164f7ea1);
$parcel$export(module.exports, "IconListNumber", () => $99da9a417e294ba4$export$32f6affcc5f19c17);
$parcel$export(module.exports, "IconList", () => $99da9a417e294ba4$export$527d32aa1785fdd4);
$parcel$export(module.exports, "IconMention", () => $99da9a417e294ba4$export$de1d1a07ff53cf53);
$parcel$export(module.exports, "IconPanelError", () => $99da9a417e294ba4$export$a1c6b14f5f0a0c20);
$parcel$export(module.exports, "IconPanelNote", () => $99da9a417e294ba4$export$4d90d09f9e3039e);
$parcel$export(module.exports, "IconPanelSuccess", () => $99da9a417e294ba4$export$cc5c1cc765c068a0);
$parcel$export(module.exports, "IconPanelWarning", () => $99da9a417e294ba4$export$e728578e48814100);
$parcel$export(module.exports, "IconPanel", () => $99da9a417e294ba4$export$18978208c8652af3);
$parcel$export(module.exports, "IconQuote", () => $99da9a417e294ba4$export$2478ed0e296e2752);
$parcel$export(module.exports, "IconStatus", () => $99da9a417e294ba4$export$4635bc8225f90ec6);
$parcel$export(module.exports, "IconOneColumnLayout", () => $99da9a417e294ba4$export$8f1e9e900568bfce);
$parcel$export(module.exports, "IconTwoColumnLayout", () => $99da9a417e294ba4$export$732a7fc4975ab5a4);
$parcel$export(module.exports, "IconThreeColumnLayout", () => $99da9a417e294ba4$export$fdfaf73f45072edb);
$parcel$export(module.exports, "IconFourColumnLayout", () => $99da9a417e294ba4$export$a1588f873a973762);
$parcel$export(module.exports, "IconFiveColumnLayout", () => $99da9a417e294ba4$export$ff1f32987b4c27d9);
$parcel$export(module.exports, "IconHeading", () => $99da9a417e294ba4$export$1a33a10ac24d7971);
$parcel$export(module.exports, "IconFeedback", () => $99da9a417e294ba4$export$e25449dcffb445e);
$parcel$export(module.exports, "IconExpand", () => $99da9a417e294ba4$export$209d03a445a7dc8e);
$parcel$export(module.exports, "IconDatasourceJiraIssue", () => $99da9a417e294ba4$export$c9b1dcefa7c9a7aa);
$parcel$export(module.exports, "IconDatasourceAssetsObjects", () => $99da9a417e294ba4$export$7d6f860161da0fa6);
$parcel$export(module.exports, "IconDatasourceConfluenceSearch", () => $99da9a417e294ba4$export$29a810fd0b8c3f03);
$parcel$export(module.exports, "IconSyncBlock", () => $99da9a417e294ba4$export$4dc65faf2ef9e446);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $joSn0 = parcelRequire("joSn0");

const $99da9a417e294ba4$export$e40fe94b4cff8ec5 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("dotBO")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$e332a83b9159d69d = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("5dzg4")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$39617668a6028b06 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("b6qxN")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$6eb71591d1461541 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("2krFq")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$f2ab17920c9d243 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("03v3x")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$8bd591d4b34dcafa = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("5yMxy")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$c17cf1164355efc2 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("1kquo")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$fba0c846789a9d87 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("47aLW")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$23da1e9f164f7ea1 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("9QkOO")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$32f6affcc5f19c17 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("awjjh")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$527d32aa1785fdd4 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("32n8Q")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$de1d1a07ff53cf53 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("8KVVR")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$a1c6b14f5f0a0c20 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("27XIs")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$4d90d09f9e3039e = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("l0z6M")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$cc5c1cc765c068a0 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("9MaOF")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$e728578e48814100 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("ghruS")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$18978208c8652af3 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("21Nvd")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$2478ed0e296e2752 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("gnOZk")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$4635bc8225f90ec6 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("kbLUO")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$8f1e9e900568bfce = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("iQbHc")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$732a7fc4975ab5a4 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("bURsa")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$fdfaf73f45072edb = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("931Fv")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$a1588f873a973762 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("9qGny")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$ff1f32987b4c27d9 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("gkBsj")).then((module)=>module.default),
    loading: ()=>null
});






function $99da9a417e294ba4$var$importHeading(level) {
    switch(level){
        case 1:
            return (parcelRequire("hqXPr"));
        case 2:
            return (parcelRequire("hiMaZ"));
        case 3:
            return (parcelRequire("khSb6"));
        case 4:
            return (parcelRequire("iudiN"));
        case 5:
            return (parcelRequire("731iR"));
        case 6:
        default:
            return (parcelRequire("frtTY"));
    }
}
const $99da9a417e294ba4$export$1a33a10ac24d7971 = ({ level: level, ...props })=>{
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
        loader: ()=>$99da9a417e294ba4$var$importHeading(level).then((module)=>module.default),
        loading: ()=>null
    });
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
        ...props
    });
};

const $99da9a417e294ba4$export$e25449dcffb445e = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("h1YiP")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$209d03a445a7dc8e = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("hxbJQ")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$c9b1dcefa7c9a7aa = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("9yMDO")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$7d6f860161da0fa6 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("RKBlN")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$29a810fd0b8c3f03 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("cb8QY")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$ccbb24eed51aea20 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("2Hg4h")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$4dc65faf2ef9e446 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("ditZE")).then((module)=>module.default),
    loading: ()=>null
});

});
parcelRegister("dotBO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eCyD4").then(()=>parcelRequire('5BR1H'));

});

parcelRegister("5dzg4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("a2fIC").then(()=>parcelRequire('dnYd0'));

});

parcelRegister("b6qxN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ggzT2").then(()=>parcelRequire('8cnF0'));

});

parcelRegister("2krFq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7tSfp").then(()=>parcelRequire('chn85'));

});

parcelRegister("03v3x", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2zQPP").then(()=>parcelRequire('2xmbt'));

});

parcelRegister("5yMxy", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2MgjY").then(()=>parcelRequire('fOddn'));

});

parcelRegister("1kquo", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5vF82").then(()=>parcelRequire('bKZy2'));

});

parcelRegister("47aLW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3lKbh").then(()=>parcelRequire('5OwXS'));

});

parcelRegister("9QkOO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1U88s").then(()=>parcelRequire('hKgJo'));

});

parcelRegister("awjjh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8S0iX").then(()=>parcelRequire('3RQQj'));

});

parcelRegister("32n8Q", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gcHxg").then(()=>parcelRequire('h2zFV'));

});

parcelRegister("8KVVR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1GvQW").then(()=>parcelRequire('e6YbY'));

});

parcelRegister("27XIs", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("30F0C").then(()=>parcelRequire('iOKaS'));

});

parcelRegister("l0z6M", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kuuFH").then(()=>parcelRequire('gwan4'));

});

parcelRegister("9MaOF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3yxk6").then(()=>parcelRequire('02KwK'));

});

parcelRegister("ghruS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("05fo1").then(()=>parcelRequire('194qU'));

});

parcelRegister("21Nvd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fjuAD").then(()=>parcelRequire('hKJ3E'));

});

parcelRegister("gnOZk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("coqKm").then(()=>parcelRequire('64g7t'));

});

parcelRegister("kbLUO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6l2Go").then(()=>parcelRequire('dEEk1'));

});

parcelRegister("iQbHc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("26UTw").then(()=>parcelRequire('13yNJ'));

});

parcelRegister("bURsa", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4TeWn").then(()=>parcelRequire('hHIWD'));

});

parcelRegister("931Fv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iwHwB").then(()=>parcelRequire('1fv9y'));

});

parcelRegister("9qGny", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gudhZ").then(()=>parcelRequire('5nSWq'));

});

parcelRegister("gkBsj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kMFx9").then(()=>parcelRequire('fXnqO'));

});

parcelRegister("hqXPr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("d7APn").then(()=>parcelRequire('1RvFs'));

});

parcelRegister("hiMaZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5Qr6L").then(()=>parcelRequire('3dKZY'));

});

parcelRegister("khSb6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gQkiB").then(()=>parcelRequire('k60EQ'));

});

parcelRegister("iudiN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("uIkuA").then(()=>parcelRequire('acVWB'));

});

parcelRegister("731iR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6gOq1").then(()=>parcelRequire('jXADX'));

});

parcelRegister("frtTY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9Hipf").then(()=>parcelRequire('it43C'));

});

parcelRegister("h1YiP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kyuDP").then(()=>parcelRequire('epf88'));

});

parcelRegister("hxbJQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aJkk9").then(()=>parcelRequire('2RZ4K'));

});

parcelRegister("9yMDO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eCZgn").then(()=>parcelRequire('dUI4N'));

});

parcelRegister("RKBlN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8TBzz").then(()=>parcelRequire('jAOOx'));

});

parcelRegister("cb8QY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gwtQ2").then(()=>parcelRequire('9nYy9'));

});

parcelRegister("2Hg4h", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("Bh1ku").then(()=>parcelRequire('hS26u'));

});

parcelRegister("ditZE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3L1Ns").then(()=>parcelRequire('fblEC'));

});


parcelRegister("grDTV", function(module, exports) {
$parcel$export(module.exports, "LinkMatcher", () => $c8bd54d882b6a9e0$export$4490385c12bf3d4);
$parcel$export(module.exports, "normalizeUrl", () => $c8bd54d882b6a9e0$export$6535eb414fa2c8b6);
$parcel$export(module.exports, "linkifyContent", () => $c8bd54d882b6a9e0$export$5a511fa58fab15e6);
$parcel$export(module.exports, "findFilepaths", () => $c8bd54d882b6a9e0$export$d37783fe63e2f0fe);
$parcel$export(module.exports, "isLinkInMatches", () => $c8bd54d882b6a9e0$export$5e652e74655163e5);
$parcel$export(module.exports, "getLinkDomain", () => $c8bd54d882b6a9e0$export$238a6141b3685c21);
$parcel$export(module.exports, "isFromCurrentDomain", () => $c8bd54d882b6a9e0$export$336c6a47b1dfa1bc);
$parcel$export(module.exports, "getLinkCreationAnalyticsEvent", () => $c8bd54d882b6a9e0$export$56039faad4eda709);
$parcel$export(module.exports, "canLinkBeCreatedInRange", () => $c8bd54d882b6a9e0$export$b7392a423e62dc8c);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/utils/hyperlink.ts
// If changes are made to this file, please make the same update in the linked file.

var $iKozC = parcelRequire("iKozC");

var $bMFKb = parcelRequire("bMFKb");

var $8YVeS = parcelRequire("8YVeS");

var $gbisc = parcelRequire("gbisc");
const $c8bd54d882b6a9e0$export$893fccbed37586dd = /([a-zA-Z]:|\\)([^\/:*?<>"|]+\\)?([^\/:*?<>"| ]+(?=\s?))?/gim;
const $c8bd54d882b6a9e0$export$dabcc234035f6703 = /^(\$|{)/;
class $c8bd54d882b6a9e0$export$4490385c12bf3d4 {
    static create() {
        class LinkMatcherRegex {
            exec(str) {
                const stringsBySpace = str.slice(0, str.length - 1).split(' ');
                const lastStringBeforeSpace = stringsBySpace[stringsBySpace.length - 1];
                const isLastStringValid = lastStringBeforeSpace.length > 0;
                if (!str.endsWith(' ') || !isLastStringValid) return null;
                if ($c8bd54d882b6a9e0$export$dabcc234035f6703.test(lastStringBeforeSpace)) return null;
                const links = (0, $iKozC.linkify).match(lastStringBeforeSpace);
                if (!links || links.length === 0) return null;
                const lastMatch = links[links.length - 1];
                const lastLink = links[links.length - 1];
                lastLink.input = str.substring(lastMatch.index);
                lastLink.length = lastLink.lastIndex - lastLink.index + 1;
                lastLink.index = str.lastIndexOf(lastStringBeforeSpace) + lastMatch.index;
                return lastLink;
            }
        }
        return new LinkMatcherRegex();
    }
}
function $c8bd54d882b6a9e0$export$6535eb414fa2c8b6(url) {
    if (!url) return '';
    if ((0, $iKozC.isSafeUrl)(url)) return url;
    return (0, $iKozC.normalizeUrl)(url);
}
function $c8bd54d882b6a9e0$export$5a511fa58fab15e6(schema) {
    return (slice)=>(0, $gbisc.mapSlice)(slice, (node, parent)=>{
            const isAllowedInParent = !parent || parent.type !== schema.nodes.codeBlock;
            const link = node.type.schema.marks.link;
            if (link === undefined) throw new Error('Link not in schema - unable to linkify content');
            if (isAllowedInParent && node.isText && !link.isInSet(node.marks)) {
                const linkified = [];
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const text = node.text;
                const matches = $c8bd54d882b6a9e0$var$findLinkMatches(text).filter((0, $8YVeS.shouldAutoLinkifyMatch));
                let pos = 0;
                const filepaths = $c8bd54d882b6a9e0$export$d37783fe63e2f0fe(text);
                matches.forEach((match)=>{
                    if ($c8bd54d882b6a9e0$export$5e652e74655163e5(match.index, filepaths)) return;
                    if (match.index > 0) linkified.push(node.cut(pos, match.index));
                    linkified.push(node.cut(match.index, match.lastIndex).mark(link.create({
                        href: $c8bd54d882b6a9e0$export$6535eb414fa2c8b6(match.url)
                    }).addToSet(node.marks)));
                    pos = match.lastIndex;
                });
                if (pos < text.length) linkified.push(node.cut(pos));
                return linkified;
            }
            return node;
        });
}
function $c8bd54d882b6a9e0$export$238a6141b3685c21(url) {
    // Remove protocol and www., if either exists
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const withoutProtocol = url.toLowerCase().replace(/^(.*):\/\//, '');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const withoutWWW = withoutProtocol.replace(/^(www\.)/, '');
    // Remove port, fragment, path, query string
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return withoutWWW.replace(/[:\/?#](.*)$/, '');
}
function $c8bd54d882b6a9e0$export$336c6a47b1dfa1bc(url) {
    if (!window || !window.location) return false;
    const currentDomain = window.location.hostname;
    const linkDomain = $c8bd54d882b6a9e0$export$238a6141b3685c21(url);
    return currentDomain === linkDomain;
}
/**
 * Fetch linkify matches from text
 * @param text Input text from a node
 * @returns Array of linkify matches. Returns empty array if text is empty or no matches found;
 */ function $c8bd54d882b6a9e0$var$findLinkMatches(text) {
    if (text === '') return [];
    return (0, $iKozC.linkify).match(text) || [];
}
const $c8bd54d882b6a9e0$export$d37783fe63e2f0fe = (text, offset = 0)=>{
    // Creation of a copy of the RegExp is necessary as lastIndex is stored on it when we run .exec()
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const localRegExp = new RegExp($c8bd54d882b6a9e0$export$893fccbed37586dd);
    let match;
    const matchesList = [];
    const maxFilepathSize = 260;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while((match = localRegExp.exec(text)) !== null){
        const start = match.index + offset;
        let end = localRegExp.lastIndex + offset;
        if (end - start > maxFilepathSize) end = start + maxFilepathSize;
         // We don't care about big strings of text that are pretending to be filepaths!!
        matchesList.push({
            startIndex: start,
            endIndex: end
        });
    }
    return matchesList;
};
const $c8bd54d882b6a9e0$export$5e652e74655163e5 = (linkStart, matchesList)=>{
    for(let i = 0; i < matchesList.length; i++){
        if (linkStart >= matchesList[i].startIndex && linkStart < matchesList[i].endIndex) return true;
    }
    return false;
};
function $c8bd54d882b6a9e0$export$56039faad4eda709(inputMethod, url) {
    return {
        action: (0, $bMFKb.ACTION).INSERTED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).LINK,
        attributes: {
            inputMethod: inputMethod,
            fromCurrentDomain: $c8bd54d882b6a9e0$export$336c6a47b1dfa1bc(url)
        },
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
        nonPrivacySafeAttributes: {
            linkDomain: $c8bd54d882b6a9e0$export$238a6141b3685c21(url)
        }
    };
}
const $c8bd54d882b6a9e0$export$b7392a423e62dc8c = (from, to)=>(state)=>{
        if (!state.doc.rangeHasMark(from, to, state.schema.marks.link)) {
            const $from = state.doc.resolve(from);
            const $to = state.doc.resolve(to);
            const link = state.schema.marks.link;
            if ($from.parent === $to.parent && $from.parent.isTextblock) {
                if ($from.parent.type.allowsMarkType(link)) {
                    let allowed = true;
                    state.doc.nodesBetween(from, to, (node)=>{
                        const hasInlineCard = node.type === state.schema.nodes.inlineCard;
                        allowed = allowed && !node.marks.some((m)=>m.type.excludes(link)) && !hasInlineCard;
                        return allowed;
                    });
                    return allowed;
                }
            }
        }
        return false;
    };

});
parcelRegister("8YVeS", function(module, exports) {
$parcel$export(module.exports, "shouldAutoLinkifyMatch", () => $d6bd16a08c4f7ae5$export$e19a09e301eaa6bb);
/** Created by scanning the Wikipedia page for all TLDs and selecting those that are common filenames, along
 * with customer complaints */ const $d6bd16a08c4f7ae5$var$tldsToNotAutoLinkify = [
    'name',
    'zip',
    'doc',
    'mov',
    // Ensure common 2 character file extensions aren't linkified without https prefix
    'md',
    // Postscript
    'ps',
    // C++
    'cc',
    // C#
    'cs',
    // f#
    'fs',
    // Go
    'go',
    // JavaScript
    'js',
    // Perl
    'pl',
    // Perl module
    'pm',
    // Python
    'py',
    // Ruby
    'rb',
    // Rust
    'rs',
    // Bash
    'sh',
    // Typescript
    'ts',
    // C#
    'cs',
    // Visual Basic
    'vb'
];
function $d6bd16a08c4f7ae5$export$977fe75b90bdd614(url) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const startsWithHttpHttps = /^https?:\/\//.test(url);
    if (startsWithHttpHttps) return true;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const startsWithWWW = /^www\./.test(url);
    if (startsWithWWW) return true;
    try {
        const hostname = new URL(`https://${url}`).hostname;
        const parts = hostname.split('.');
        const tld = parts.length > 1 ? parts[parts.length - 1] : null;
        if (parts[0] === '') // If the domain is an empty string (ie the link is `.com`), it's invalid, so
        // automatically return true
        return true;
        if (!tld) return true;
        return !$d6bd16a08c4f7ae5$var$tldsToNotAutoLinkify.includes(tld);
    } catch (e) {
        return true;
    }
}
function $d6bd16a08c4f7ae5$export$e19a09e301eaa6bb(match) {
    return $d6bd16a08c4f7ae5$export$977fe75b90bdd614(match.raw);
}

});

parcelRegister("gbisc", function(module, exports) {
$parcel$export(module.exports, "getFragmentBackingArray", () => $3eaab404b91bf559$export$7b8536c35e9eb7d2);
$parcel$export(module.exports, "mapFragment", () => $3eaab404b91bf559$export$81fe6b3b714fd0bf);
$parcel$export(module.exports, "mapSlice", () => $3eaab404b91bf559$export$d8264570c5933bbf);
$parcel$export(module.exports, "flatmap", () => $3eaab404b91bf559$export$c575791007f9dbd1);
$parcel$export(module.exports, "mapChildren", () => $3eaab404b91bf559$export$e0baa27f47733a4a);

var $3xw6l = parcelRequire("3xw6l");
function $3eaab404b91bf559$export$7b8536c35e9eb7d2(fragment) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return fragment.content;
}
function $3eaab404b91bf559$export$81fe6b3b714fd0bf(content, callback, parent = null) {
    const children = [];
    for(let i = 0, size = content.childCount; i < size; i++){
        const node = content.child(i);
        const transformed = node.isLeaf ? callback(node, parent, i) : callback(node.copy($3eaab404b91bf559$export$81fe6b3b714fd0bf(node.content, callback, node)), parent, i);
        if (transformed) {
            if (transformed instanceof (0, $3xw6l.Fragment)) children.push(...$3eaab404b91bf559$export$7b8536c35e9eb7d2(transformed));
            else if (Array.isArray(transformed)) children.push(...transformed);
            else children.push(transformed);
        }
    }
    return (0, $3xw6l.Fragment).fromArray(children);
}
function $3eaab404b91bf559$export$d8264570c5933bbf(slice, callback) {
    const fragment = $3eaab404b91bf559$export$81fe6b3b714fd0bf(slice.content, callback);
    return new (0, $3xw6l.Slice)(fragment, slice.openStart, slice.openEnd);
}
function $3eaab404b91bf559$export$c575791007f9dbd1(fragment, callback) {
    const fragmentContent = [];
    for(let i = 0; i < fragment.childCount; i++){
        const child = callback(fragment.child(i), i, fragment);
        if (Array.isArray(child)) fragmentContent.push(...child);
        else fragmentContent.push(child);
    }
    return (0, $3xw6l.Fragment).fromArray(fragmentContent);
}
function $3eaab404b91bf559$export$e0baa27f47733a4a(node, callback) {
    const array = [];
    for(let i = 0; i < node.childCount; i++)array.push(callback(node.child(i), i, node instanceof (0, $3xw6l.Fragment) ? node : node.content));
    return array;
}
const $3eaab404b91bf559$var$findNode = (predicate)=>(slice)=>{
        let foundNode = null;
        slice.content.nodesBetween(0, slice.content.size, (node)=>{
            if (predicate(node)) {
                foundNode = node;
                return false;
            }
            return true;
        });
        return foundNode;
    };
const $3eaab404b91bf559$export$b6ae752d7894ad08 = (predicate)=>(slice)=>{
        return !!$3eaab404b91bf559$var$findNode(predicate)(slice);
    };

});


parcelRegister("9ucqS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6f17721ea8582c4f15777a32fa3d6d29>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6e808f42332e9d94$var$_react = $6e808f42332e9d94$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $6e808f42332e9d94$var$_link = $6e808f42332e9d94$var$_interopRequireDefault((parcelRequire("cV8sz")));

var $6e808f42332e9d94$var$_link2 = $6e808f42332e9d94$var$_interopRequireDefault((parcelRequire("frcEo")));
function $6e808f42332e9d94$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "EditorLinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6e808f42332e9d94$var$LinkIcon = (props)=>/*#__PURE__*/ $6e808f42332e9d94$var$_react.default.createElement($6e808f42332e9d94$var$_link.default, Object.assign({
        name: "LinkIcon",
        LEGACY_fallbackIcon: $6e808f42332e9d94$var$_link2.default
    }, props));
$6e808f42332e9d94$var$LinkIcon.displayName = 'LinkIconMigration';
var $6e808f42332e9d94$var$_default = module.exports.default = $6e808f42332e9d94$var$LinkIcon;

});
parcelRegister("frcEo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b3d330c229d7652a$var$_react = $b3d330c229d7652a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $b3d330c229d7652a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b3d330c229d7652a$var$EditorLinkIcon = (props)=>/*#__PURE__*/ $b3d330c229d7652a$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12.654 8.764a.858.858 0 0 1-1.213-1.213l1.214-1.214a3.717 3.717 0 0 1 5.257 0 3.714 3.714 0 0 1 .001 5.258l-1.214 1.214-.804.804a3.72 3.72 0 0 1-5.263.005.858.858 0 0 1 1.214-1.214c.781.782 2.05.78 2.836-.005l.804-.803 1.214-1.214a2 2 0 0 0-.001-2.831 2 2 0 0 0-2.83 0zm-.808 6.472a.858.858 0 0 1 1.213 1.213l-1.214 1.214a3.717 3.717 0 0 1-5.257 0 3.714 3.714 0 0 1-.001-5.258l1.214-1.214.804-.804a3.72 3.72 0 0 1 5.263-.005.858.858 0 0 1-1.214 1.214 2.005 2.005 0 0 0-2.836.005l-.804.803L7.8 13.618a2 2 0 0 0 .001 2.831 2 2 0 0 0 2.83 0z"/></svg>`
    }, props));
$b3d330c229d7652a$var$EditorLinkIcon.displayName = 'EditorLinkIcon';
var $b3d330c229d7652a$var$_default = module.exports.default = $b3d330c229d7652a$var$EditorLinkIcon;

});


parcelRegister("eBKSl", function(module, exports) {
$parcel$export(module.exports, "updateLinkEditorCommand", () => $2caeb89afa51b896$export$1f68f6e2d4509ef7);
$parcel$export(module.exports, "updateLink", () => $2caeb89afa51b896$export$468bc07728835ac4);
$parcel$export(module.exports, "insertLinkWithAnalytics", () => $2caeb89afa51b896$export$61f4de3ecc2b935b);
$parcel$export(module.exports, "removeLink", () => $2caeb89afa51b896$export$91d8072017908bea);
$parcel$export(module.exports, "removeLinkEditorCommand", () => $2caeb89afa51b896$export$32e967ed59808fd);
$parcel$export(module.exports, "editInsertedLink", () => $2caeb89afa51b896$export$8eb8ea8f98f386b5);
$parcel$export(module.exports, "showLinkToolbar", () => $2caeb89afa51b896$export$83c364d103479f90);
$parcel$export(module.exports, "hideLinkToolbar", () => $2caeb89afa51b896$export$bd1cd60a9b31da5e);
$parcel$export(module.exports, "hideLinkToolbarSetMeta", () => $2caeb89afa51b896$export$534add8453a7a184);
$parcel$export(module.exports, "onEscapeCallback", () => $2caeb89afa51b896$export$34daa751a305794c);
$parcel$export(module.exports, "onClickAwayCallback", () => $2caeb89afa51b896$export$e72685a867c8a4f2);

var $bMFKb = parcelRequire("bMFKb");
var $97Qim = parcelRequire("97Qim");

var $6C2m6 = parcelRequire("6C2m6");

var $asjM0 = parcelRequire("asjM0");

var $a36Ig = parcelRequire("a36Ig");
var $4axGb = parcelRequire("4axGb");

var $8GLF3 = parcelRequire("8GLF3");

var $grDTV = parcelRequire("grDTV");

var $3lIcL = parcelRequire("3lIcL");

var $jfXvp = parcelRequire("jfXvp");
function $2caeb89afa51b896$var$setLinkHrefEditorCommand(href, pos, editorAnalyticsApi, to, isTabPressed) {
    return ({ tr: tr })=>{
        if (!(0, $a36Ig.isTextAtPos)(pos)({
            tr: tr
        })) return null;
        const $pos = tr.doc.resolve(pos);
        const node = tr.doc.nodeAt(pos);
        const linkMark = tr.doc.type.schema.marks.link;
        const mark = linkMark.isInSet(node.marks);
        const url = (0, $grDTV.normalizeUrl)(href);
        if (mark && mark.attrs.href === url) return null;
        const rightBound = to && pos !== to ? to : pos - $pos.textOffset + node.nodeSize;
        tr.removeMark(pos, rightBound, linkMark);
        if (href.trim()) tr.addMark(pos, rightBound, linkMark.create({
            ...mark && mark.attrs || {},
            href: url
        }));
        else editorAnalyticsApi?.attachAnalyticsEvent((0, $97Qim.unlinkPayload)((0, $bMFKb.ACTION_SUBJECT_ID).HYPERLINK))(tr);
        if (!isTabPressed) tr.setMeta((0, $jfXvp.stateKey), {
            type: (0, $4axGb.LinkAction).HIDE_TOOLBAR
        });
        return tr;
    };
}
function $2caeb89afa51b896$export$911a683cdd8a2ccf(href, pos, editorAnalyticsApi, to, isTabPressed) {
    return (0, $8GLF3.editorCommandToPMCommand)($2caeb89afa51b896$var$setLinkHrefEditorCommand(href, pos, editorAnalyticsApi, to, isTabPressed));
}
function $2caeb89afa51b896$export$1f68f6e2d4509ef7(href, text, pos, to) {
    return ({ tr: tr })=>{
        const $pos = tr.doc.resolve(pos);
        const node = tr.doc.nodeAt(pos);
        if (!node) return null;
        const url = (0, $grDTV.normalizeUrl)(href);
        const mark = tr.doc.type.schema.marks.link.isInSet(node.marks);
        const linkMark = tr.doc.type.schema.marks.link;
        const rightBound = to && pos !== to ? to : pos - $pos.textOffset + node.nodeSize;
        if (!url && text) {
            tr.removeMark(pos, rightBound, linkMark);
            tr.insertText(text, pos, rightBound);
        } else if (!url) return null;
        else {
            tr.insertText(text, pos, rightBound);
            // Casting to LinkAttributes to prevent wrong attributes been passed (Example ED-7951)
            const linkAttrs = {
                ...mark && mark.attrs || {},
                href: url
            };
            tr.addMark(pos, pos + text.length, linkMark.create(linkAttrs));
            tr.setMeta((0, $jfXvp.stateKey), {
                type: (0, $4axGb.LinkAction).HIDE_TOOLBAR
            });
        }
        return tr;
    };
}
function $2caeb89afa51b896$export$468bc07728835ac4(href, text, pos, to) {
    return (0, $8GLF3.editorCommandToPMCommand)($2caeb89afa51b896$export$1f68f6e2d4509ef7(href, text, pos, to));
}
function $2caeb89afa51b896$export$c13c4fbf8f656592(from, to, incomingHref, incomingTitle, displayText, source, sourceEvent, appearance = 'inline', cardApiActions) {
    return (state, dispatch)=>{
        const link = state.schema.marks.link;
        const { tr: tr } = state;
        if (incomingHref.trim()) {
            const normalizedUrl = (0, $grDTV.normalizeUrl)(incomingHref);
            // NB: in this context, `currentText` represents text which has been
            // highlighted in the Editor, upon which a link is is being added.
            const currentText = (0, $jfXvp.stateKey).getState(state)?.activeText;
            let markEnd = to;
            const text = displayText || incomingTitle || incomingHref;
            if (!displayText || displayText !== currentText) {
                tr.insertText(text, from, to);
                // new block created to wrap the link
                if (tr.mapping.map(from) === from + text.length + 2) // +1 is for the block's opening tag
                markEnd = from + text.length + 1;
                else markEnd = from + text.length;
            }
            tr.addMark(from, markEnd, link.create({
                href: normalizedUrl
            }));
            tr.setSelection((0, $3lIcL.Selection).near(tr.doc.resolve(markEnd)));
            if (!displayText || displayText === incomingHref) {
                const queueCardsFromChangedTr = cardApiActions?.queueCardsFromChangedTr;
                if (queueCardsFromChangedTr) queueCardsFromChangedTr?.(state, tr, // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                source, (0, $bMFKb.ACTION).INSERTED, false, sourceEvent, appearance);
                else (0, $6C2m6.addLinkMetadata)(state.selection, tr, {
                    action: (0, $bMFKb.ACTION).INSERTED,
                    inputMethod: source,
                    sourceEvent: sourceEvent
                });
            } else /**
				 * Add link metadata because queue cards would have otherwise handled this for us
				 */ (0, $6C2m6.addLinkMetadata)(state.selection, tr, {
                action: (0, $bMFKb.ACTION).INSERTED,
                inputMethod: source,
                sourceEvent: sourceEvent
            });
            tr.setMeta((0, $jfXvp.stateKey), {
                type: (0, $4axGb.LinkAction).HIDE_TOOLBAR
            });
            if (dispatch) dispatch(tr);
            return true;
        }
        tr.setMeta((0, $jfXvp.stateKey), {
            type: (0, $4axGb.LinkAction).HIDE_TOOLBAR
        });
        if (dispatch) dispatch(tr);
        return false;
    };
}
const $2caeb89afa51b896$export$61f4de3ecc2b935b = (inputMethod, from, to, href, cardActions, editorAnalyticsApi, title, displayText, cardsAvailable = false, sourceEvent, appearance)=>{
    // If smart cards are available, we send analytics for hyperlinks when a smart link is rejected.
    if (cardsAvailable && !title && !displayText) return $2caeb89afa51b896$export$c13c4fbf8f656592(from, to, href, title, displayText, inputMethod, sourceEvent, appearance, cardActions);
    return (0, $asjM0.withAnalytics)(editorAnalyticsApi, (0, $grDTV.getLinkCreationAnalyticsEvent)(inputMethod, href))($2caeb89afa51b896$export$c13c4fbf8f656592(from, to, href, title, displayText, inputMethod, sourceEvent, appearance, cardActions));
};
function $2caeb89afa51b896$export$91d8072017908bea(pos, editorAnalyticsApi) {
    return (0, $6C2m6.commandWithMetadata)($2caeb89afa51b896$export$911a683cdd8a2ccf('', pos, editorAnalyticsApi), {
        action: (0, $bMFKb.ACTION).UNLINK
    });
}
function $2caeb89afa51b896$export$32e967ed59808fd(pos, editorAnalyticsApi) {
    return ({ tr: tr })=>{
        $2caeb89afa51b896$var$setLinkHrefEditorCommand('', pos, editorAnalyticsApi)({
            tr: tr
        });
        (0, $6C2m6.addLinkMetadata)(tr.selection, tr, {
            action: (0, $bMFKb.ACTION).UNLINK
        });
        return tr;
    };
}
function $2caeb89afa51b896$export$8eb8ea8f98f386b5(editorAnalyticsApi) {
    return (state, dispatch)=>{
        if (dispatch) {
            const { tr: tr } = state;
            tr.setMeta((0, $jfXvp.stateKey), {
                type: (0, $4axGb.LinkAction).EDIT_INSERTED_TOOLBAR,
                inputMethod: (0, $bMFKb.INPUT_METHOD).FLOATING_TB
            });
            editorAnalyticsApi?.attachAnalyticsEvent((0, $97Qim.buildEditLinkPayload)((0, $bMFKb.ACTION_SUBJECT_ID).HYPERLINK))(tr);
            dispatch(tr);
        }
        return true;
    };
}
function $2caeb89afa51b896$export$83c364d103479f90(inputMethod, editorAnalyticsApi) {
    return ({ tr: tr })=>{
        const newTr = tr.setMeta((0, $jfXvp.stateKey), {
            type: (0, $4axGb.LinkAction).SHOW_INSERT_TOOLBAR,
            inputMethod: inputMethod
        });
        editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $bMFKb.ACTION).INVOKED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).TYPEAHEAD,
            actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).TYPEAHEAD_LINK,
            attributes: {
                inputMethod: inputMethod
            },
            eventType: (0, $bMFKb.EVENT_TYPE).UI
        })(newTr);
        return newTr;
    };
}
function $2caeb89afa51b896$export$bd1cd60a9b31da5e() {
    return function(state, dispatch) {
        if (dispatch) dispatch($2caeb89afa51b896$export$534add8453a7a184(state.tr));
        return true;
    };
}
const $2caeb89afa51b896$export$534add8453a7a184 = (tr)=>{
    return tr.setMeta((0, $jfXvp.stateKey), {
        type: (0, $4axGb.LinkAction).HIDE_TOOLBAR
    });
};
const $2caeb89afa51b896$export$34daa751a305794c = (cardActions)=>(state, dispatch)=>{
        const { tr: tr } = state;
        $2caeb89afa51b896$export$534add8453a7a184(tr);
        cardActions?.hideLinkToolbar?.(tr);
        if (dispatch) {
            dispatch(tr);
            return true;
        }
        return false;
    };
const $2caeb89afa51b896$export$e72685a867c8a4f2 = (state, dispatch)=>{
    if (dispatch) {
        $2caeb89afa51b896$export$bd1cd60a9b31da5e()(state, dispatch);
        return true;
    }
    return false;
};

});
parcelRegister("97Qim", function(module, exports) {
$parcel$export(module.exports, "buildEditLinkPayload", () => $7d7b4d8beeabc390$export$7f3c24765adf61f0);
$parcel$export(module.exports, "buildVisitedLinkPayload", () => $7d7b4d8beeabc390$export$e81ec2390acfc152);
$parcel$export(module.exports, "buildVisitedNonHyperLinkPayload", () => $7d7b4d8beeabc390$export$4c5e2a0406e7eae8);
$parcel$export(module.exports, "buildOpenedSettingsPayload", () => $7d7b4d8beeabc390$export$96aa8ae974c8591a);
$parcel$export(module.exports, "unlinkPayload", () => $7d7b4d8beeabc390$export$aab75a08bdd88be4);

var $bMFKb = parcelRequire("bMFKb");
const $7d7b4d8beeabc390$export$7f3c24765adf61f0 = (type)=>{
    return {
        action: (0, $bMFKb.ACTION).CLICKED,
        actionSubject: type === (0, $bMFKb.ACTION_SUBJECT_ID).HYPERLINK ? (0, $bMFKb.ACTION_SUBJECT).HYPERLINK : (0, $bMFKb.ACTION_SUBJECT).SMART_LINK,
        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).EDIT_LINK,
        attributes: type !== (0, $bMFKb.ACTION_SUBJECT_ID).HYPERLINK ? {
            // @ts-ignore
            display: type
        } : {},
        eventType: (0, $bMFKb.EVENT_TYPE).UI
    };
};
const $7d7b4d8beeabc390$var$mapLinkTypeToCardAppearance = (type)=>{
    switch(type){
        case (0, $bMFKb.ACTION_SUBJECT_ID).CARD_INLINE:
            return 'inline';
        case (0, $bMFKb.ACTION_SUBJECT_ID).CARD_BLOCK:
            return 'block';
        case (0, $bMFKb.ACTION_SUBJECT_ID).EMBEDS:
            return 'embed';
        default:
            return 'url';
    }
};
const $7d7b4d8beeabc390$export$e81ec2390acfc152 = (type)=>{
    return type === (0, $bMFKb.ACTION_SUBJECT_ID).HYPERLINK ? $7d7b4d8beeabc390$var$buildVisitedHyperLinkPayload() : $7d7b4d8beeabc390$export$4c5e2a0406e7eae8(type, (0, $bMFKb.INPUT_METHOD).TOOLBAR);
};
const $7d7b4d8beeabc390$var$buildVisitedHyperLinkPayload = ()=>{
    return {
        action: (0, $bMFKb.ACTION).VISITED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).HYPERLINK,
        actionSubjectId: undefined,
        attributes: {
            inputMethod: (0, $bMFKb.INPUT_METHOD).TOOLBAR
        },
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK
    };
};
const $7d7b4d8beeabc390$export$4c5e2a0406e7eae8 = (type, inputMethod)=>{
    return {
        action: (0, $bMFKb.ACTION).VISITED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).SMART_LINK,
        actionSubjectId: type,
        attributes: {
            inputMethod: inputMethod
        },
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK
    };
};
const $7d7b4d8beeabc390$export$96aa8ae974c8591a = (type)=>{
    return {
        action: (0, $bMFKb.ACTION).CLICKED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).BUTTON,
        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).GOTO_SMART_LINK_SETTINGS,
        attributes: {
            // @ts-ignore
            inputMethod: (0, $bMFKb.INPUT_METHOD).TOOLBAR,
            display: $7d7b4d8beeabc390$var$mapLinkTypeToCardAppearance(type)
        },
        eventType: (0, $bMFKb.EVENT_TYPE).UI
    };
};
const $7d7b4d8beeabc390$export$aab75a08bdd88be4 = (type)=>{
    return {
        action: (0, $bMFKb.ACTION).UNLINK,
        actionSubject: type === (0, $bMFKb.ACTION_SUBJECT_ID).HYPERLINK ? (0, $bMFKb.ACTION_SUBJECT).HYPERLINK : (0, $bMFKb.ACTION_SUBJECT).SMART_LINK,
        actionSubjectId: type === (0, $bMFKb.ACTION_SUBJECT_ID).HYPERLINK ? undefined : type,
        attributes: {
            inputMethod: (0, $bMFKb.INPUT_METHOD).TOOLBAR
        },
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK
    };
};

});

parcelRegister("6C2m6", function(module, exports) {
$parcel$export(module.exports, "addLinkMetadata", () => $11397821c0b6cc0a$export$e2d4855dca88ecc1);
$parcel$export(module.exports, "getLinkMetadataFromTransaction", () => $11397821c0b6cc0a$export$3aba02526a1e2e78);
$parcel$export(module.exports, "commandWithMetadata", () => $11397821c0b6cc0a$export$76125a95b70625ac);

var $5KmoW = parcelRequire("5KmoW");
function $11397821c0b6cc0a$export$e2d4855dca88ecc1(initialSelection, tr, metadata) {
    const { storedMarks: storedMarks } = tr;
    const pos = tr.mapping.map(initialSelection.$from.pos);
    tr.step(new (0, $5KmoW.LinkMetaStep)(pos, metadata));
    // When you add a new step all the storedMarks are removed it
    if (storedMarks) tr.setStoredMarks(storedMarks);
    return tr;
}
function $11397821c0b6cc0a$export$3aba02526a1e2e78(tr) {
    return tr.steps.reduce((metadata, step)=>{
        if (!(step instanceof (0, $5KmoW.LinkMetaStep))) return metadata;
        return {
            ...metadata,
            ...step.getMetadata()
        };
    }, {});
}
const $11397821c0b6cc0a$export$76125a95b70625ac = (command, metadata)=>{
    return (state, dispatch, view)=>{
        if (!dispatch) return command(state, dispatch, view);
        return command(state, (tr)=>{
            $11397821c0b6cc0a$export$e2d4855dca88ecc1(state.selection, tr, metadata);
            dispatch(tr);
        }, view);
    };
};

});
parcelRegister("5KmoW", function(module, exports) {
$parcel$export(module.exports, "LinkMetaStep", () => $42f2a0144630b4c7$export$40e33c9d27895078);

var $3xw6l = parcelRequire("3xw6l");

var $lzEKq = parcelRequire("lzEKq");
const $42f2a0144630b4c7$export$954e3f6aa93d9ba3 = 'editor-linking-meta';
const $42f2a0144630b4c7$export$2774298c489a128f = 'editor-linking-meta-invert';
class $42f2a0144630b4c7$export$40e33c9d27895078 extends (0, $lzEKq.Step) {
    constructor(pos, metadata, isInverted = false){
        super();
        this.pos = pos;
        this.metadata = metadata;
        this.isInverted = isInverted;
    }
    getMetadata() {
        return this.metadata;
    }
    /**
   * Generate new undo/redo analytics event when step is inverted
   */ invert() {
        /**
     * Omit sourceEvent in history
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { sourceEvent: sourceEvent, ...metadata } = this.metadata;
        return new $42f2a0144630b4c7$export$40e33c9d27895078(this.pos, metadata, true);
    }
    // Should make no modifications to the doc
    apply(doc) {
        return (0, $lzEKq.StepResult).ok(doc);
    }
    map(mapping) {
        let newPos = this.pos;
        if (typeof newPos === 'number') newPos = mapping.map(newPos);
        // Return the same events, this step will never be removed
        return new $42f2a0144630b4c7$export$40e33c9d27895078(newPos, this.metadata, this.isInverted);
    }
    getMap() {
        return new (0, $lzEKq.StepMap)([
            this.pos || 0,
            0,
            0
        ]);
    }
    // Return null to avoid merging events
    merge() {
        return null;
    }
    toJSON() {
        // When serialized we should create a noop Replace step
        return {
            stepType: 'replace',
            from: 0,
            to: 0
        };
    }
    static fromJSON() {
        // This is a "local custom step" once serialized
        // we need to transform it in a no-operation action
        return new (0, $lzEKq.ReplaceStep)(0, 0, (0, $3xw6l.Slice).empty);
    }
}
/** Register this step with Prosemirror */ (0, $lzEKq.Step).jsonID($42f2a0144630b4c7$export$954e3f6aa93d9ba3, $42f2a0144630b4c7$export$40e33c9d27895078);

});


parcelRegister("asjM0", function(module, exports) {
$parcel$export(module.exports, "withAnalytics", () => $40dab61f4313c98f$export$af9baadf0e4f6e13);
function $40dab61f4313c98f$export$af9baadf0e4f6e13(analyticsApi, payload, channel) {
    return (command)=>(state, dispatch, view)=>command(state, (tr)=>{
                if (dispatch) {
                    if (payload instanceof Function) {
                        const dynamicPayload = payload(state, {
                            currentDoc: tr.doc
                        });
                        if (dynamicPayload) {
                            analyticsApi?.attachAnalyticsEvent(dynamicPayload, channel)(tr);
                            dispatch(tr);
                        }
                    } else {
                        analyticsApi?.attachAnalyticsEvent(payload, channel)(tr);
                        dispatch(tr);
                    }
                }
            }, view);
}

});

parcelRegister("a36Ig", function(module, exports) {
$parcel$export(module.exports, "isTextAtPos", () => $925ba74d34988a68$export$8476280b1d47554d);
$parcel$export(module.exports, "getLinkPreferencesURLFromENV", () => $925ba74d34988a68$export$e5404273592f5dbd);
$parcel$export(module.exports, "getActiveLinkMark", () => $925ba74d34988a68$export$819e108a65d33088);

var $efWct = parcelRequire("efWct");

var $92xoS = parcelRequire("92xoS");

const $925ba74d34988a68$var$STAGING = 'staging';
const $925ba74d34988a68$var$PRODUCTION = 'prod';
const $925ba74d34988a68$var$DEV = 'dev';
function $925ba74d34988a68$export$8476280b1d47554d(pos) {
    return ({ tr: tr })=>{
        const node = tr.doc.nodeAt(pos);
        return !!node && node.isText;
    };
}
function $925ba74d34988a68$export$54fac2c1c66c48ae(pos) {
    return (state)=>{
        const node = state.doc.nodeAt(pos);
        return !!node && !!state.schema.marks.link.isInSet(node.marks);
    };
}
const $925ba74d34988a68$export$e5404273592f5dbd = ()=>{
    const envType = $925ba74d34988a68$var$PRODUCTION;
    return (0, $efWct.getUrlForDomainInContext)('id', envType) + (0, $36674f1acadf5cf4$export$f0972e90f14682b1);
};
const $925ba74d34988a68$var$isSelectionInsideLink = (state)=>!!state.doc.type.schema.marks.link.isInSet(state.selection.$from.marks());
const $925ba74d34988a68$var$isEmptySelectionBeforeLink = (state)=>{
    const { $from: $from, $to: $to } = state.selection;
    return $from === $to && !!state.doc.type.schema.marks.link.isInSet($from.nodeAfter?.marks || []);
};
const $925ba74d34988a68$var$isEmptySelectionAfterLink = (state)=>{
    const { $from: $from, $to: $to } = state.selection;
    return $from === $to && !!state.doc.type.schema.marks.link.isInSet($from.nodeBefore?.marks || []);
};
const $925ba74d34988a68$var$isSelectionAroundLink = (state)=>{
    const { $from: $from, $to: $to } = state.selection;
    const node = $from.nodeAfter;
    return !!node && $from.textOffset === 0 && $to.pos - $from.pos === node.nodeSize && !!state.doc.type.schema.marks.link.isInSet(node.marks);
};
const $925ba74d34988a68$export$819e108a65d33088 = (state)=>{
    const { selection: { $from: $from } } = state;
    if ($925ba74d34988a68$var$isSelectionInsideLink(state) || $925ba74d34988a68$var$isSelectionAroundLink(state)) {
        const pos = $from.pos - $from.textOffset;
        const node = state.doc.nodeAt(pos);
        return node && node.isText ? {
            node: node,
            pos: pos
        } : undefined;
    }
    if ($925ba74d34988a68$var$isEmptySelectionBeforeLink(state) && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) {
        // if user clicks right before the link, we want to show the toolbar for the link
        // but only if the link is a single character
        const node = state.doc.nodeAt($from.pos);
        return node && node.isText && node.nodeSize === 1 ? {
            node: node,
            pos: $from.pos
        } : undefined;
    }
    if ($925ba74d34988a68$var$isEmptySelectionAfterLink(state) && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) {
        // if user clicks right after the link, we want to show the toolbar for the link
        // but only if the link is a single character
        // and we return the position of the link
        const node = state.doc.nodeAt($from.pos - 1);
        return node && node.isText && node.nodeSize === 1 ? {
            node: node,
            pos: $from.pos - 1
        } : undefined;
    }
    return undefined;
};

});
const $36674f1acadf5cf4$export$f0972e90f14682b1 = '/manage-profile/link-preferences';


parcelRegister("jfXvp", function(module, exports) {
$parcel$export(module.exports, "stateKey", () => $a09ab5ad2f7d9456$export$77b371d6becc8882);
$parcel$export(module.exports, "plugin", () => $a09ab5ad2f7d9456$export$ca524d3785e2543);

var $aXKmr = parcelRequire("aXKmr");

var $a36Ig = parcelRequire("a36Ig");
var $4axGb = parcelRequire("4axGb");

var $i8KtF = parcelRequire("i8KtF");

var $grDTV = parcelRequire("grDTV");
var $3ADzg = parcelRequire("3ADzg");

var $3lIcL = parcelRequire("3lIcL");

var $b7EWj = parcelRequire("b7EWj");
const $a09ab5ad2f7d9456$var$mapTransactionToState = (state, tr)=>{
    if (!state) return undefined;
    else if (state.type === (0, $4axGb.InsertStatus).EDIT_LINK_TOOLBAR || state.type === (0, $4axGb.InsertStatus).EDIT_INSERTED_TOOLBAR) {
        const { pos: pos, deleted: deleted } = tr.mapping.mapResult(state.pos, 1);
        const node = tr.doc.nodeAt(pos);
        // If the position was not deleted & it is still a link
        if (!deleted && !!node.type.schema.marks.link.isInSet(node.marks)) {
            if (node === state.node && pos === state.pos) return state;
            return {
                ...state,
                pos: pos,
                node: node
            };
        }
        // If the position has been deleted, then require a navigation to show the toolbar again
        return;
    } else if (state.type === (0, $4axGb.InsertStatus).INSERT_LINK_TOOLBAR) return {
        ...state,
        from: tr.mapping.map(state.from),
        to: tr.mapping.map(state.to)
    };
    return;
};
const $a09ab5ad2f7d9456$var$toState = (state, action, editorState)=>{
    // Show insert or edit toolbar
    if (!state) switch(action){
        case (0, $4axGb.LinkAction).SHOW_INSERT_TOOLBAR:
            {
                const { from: from, to: to } = editorState.selection;
                if ((0, $grDTV.canLinkBeCreatedInRange)(from, to)(editorState)) return {
                    type: (0, $4axGb.InsertStatus).INSERT_LINK_TOOLBAR,
                    from: from,
                    to: to
                };
                return undefined;
            }
        case (0, $4axGb.LinkAction).SELECTION_CHANGE:
            // If the user has moved their cursor, see if they're in a link
            const link = (0, $a36Ig.getActiveLinkMark)(editorState);
            if (link) return {
                ...link,
                type: (0, $4axGb.InsertStatus).EDIT_LINK_TOOLBAR
            };
            return undefined;
        default:
            return undefined;
    }
    // Update toolbar state if selection changes, or if toolbar is hidden
    if (state.type === (0, $4axGb.InsertStatus).EDIT_LINK_TOOLBAR) switch(action){
        case (0, $4axGb.LinkAction).EDIT_INSERTED_TOOLBAR:
            {
                const link = (0, $a36Ig.getActiveLinkMark)(editorState);
                if (link) {
                    if (link.pos === state.pos && link.node === state.node) return {
                        ...state,
                        type: (0, $4axGb.InsertStatus).EDIT_INSERTED_TOOLBAR
                    };
                    return {
                        ...link,
                        type: (0, $4axGb.InsertStatus).EDIT_INSERTED_TOOLBAR
                    };
                }
                return undefined;
            }
        case (0, $4axGb.LinkAction).SELECTION_CHANGE:
            const link1 = (0, $a36Ig.getActiveLinkMark)(editorState);
            if (link1) {
                if (link1.pos === state.pos && link1.node === state.node) // Make sure we return the same object, if it's the same link
                return state;
                return {
                    ...link1,
                    type: (0, $4axGb.InsertStatus).EDIT_LINK_TOOLBAR
                };
            }
            return undefined;
        case (0, $4axGb.LinkAction).HIDE_TOOLBAR:
            return undefined;
        default:
            return state;
    }
    // Remove toolbar if user changes selection or toolbar is hidden
    if (state.type === (0, $4axGb.InsertStatus).INSERT_LINK_TOOLBAR) switch(action){
        case (0, $4axGb.LinkAction).SELECTION_CHANGE:
        case (0, $4axGb.LinkAction).HIDE_TOOLBAR:
            return undefined;
        default:
            return state;
    }
    return;
};
const $a09ab5ad2f7d9456$var$getActiveText = (selection)=>{
    const currentSlice = selection.content();
    if (currentSlice.size === 0) return;
    if (currentSlice.content.childCount === 1 && currentSlice.content.firstChild && selection instanceof (0, $3lIcL.TextSelection)) return currentSlice.content.firstChild.textContent;
    return;
};
const $a09ab5ad2f7d9456$export$77b371d6becc8882 = new (0, $3lIcL.PluginKey)('hyperlinkPlugin');
const $a09ab5ad2f7d9456$export$ca524d3785e2543 = (dispatch, intl, editorAppearance, pluginInjectionApi, onClickCallback, __livePage)=>new (0, $i8KtF.SafePlugin)({
        state: {
            init (_, state) {
                const canInsertLink = (0, $grDTV.canLinkBeCreatedInRange)(state.selection.from, state.selection.to)(state);
                return {
                    activeText: $a09ab5ad2f7d9456$var$getActiveText(state.selection),
                    canInsertLink: canInsertLink,
                    timesViewed: 0,
                    activeLinkMark: $a09ab5ad2f7d9456$var$toState(undefined, (0, $4axGb.LinkAction).SELECTION_CHANGE, state),
                    editorAppearance: editorAppearance
                };
            },
            apply (tr, pluginState, oldState, newState) {
                let state = pluginState;
                const action = tr.getMeta($a09ab5ad2f7d9456$export$77b371d6becc8882) && tr.getMeta($a09ab5ad2f7d9456$export$77b371d6becc8882).type;
                const inputMethod = tr.getMeta($a09ab5ad2f7d9456$export$77b371d6becc8882) && tr.getMeta($a09ab5ad2f7d9456$export$77b371d6becc8882).inputMethod;
                if (tr.docChanged) state = {
                    activeText: state.activeText,
                    canInsertLink: (0, $grDTV.canLinkBeCreatedInRange)(newState.selection.from, newState.selection.to)(newState),
                    timesViewed: state.timesViewed,
                    inputMethod: inputMethod,
                    activeLinkMark: $a09ab5ad2f7d9456$var$mapTransactionToState(state.activeLinkMark, tr),
                    editorAppearance: editorAppearance
                };
                if (action) {
                    const stateForAnalytics = [
                        (0, $4axGb.LinkAction).SHOW_INSERT_TOOLBAR,
                        (0, $4axGb.LinkAction).EDIT_INSERTED_TOOLBAR
                    ].includes(action) ? {
                        timesViewed: ++state.timesViewed,
                        searchSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))()
                    } : {
                        timesViewed: state.timesViewed,
                        searchSessionId: state.searchSessionId
                    };
                    state = {
                        activeText: state.activeText,
                        canInsertLink: state.canInsertLink,
                        inputMethod: inputMethod,
                        activeLinkMark: $a09ab5ad2f7d9456$var$toState(state.activeLinkMark, action, newState),
                        editorAppearance: editorAppearance,
                        ...stateForAnalytics
                    };
                }
                const hasPositionChanged = oldState.selection.from !== newState.selection.from || oldState.selection.to !== newState.selection.to;
                if (tr.selectionSet && hasPositionChanged) state = {
                    activeText: $a09ab5ad2f7d9456$var$getActiveText(newState.selection),
                    canInsertLink: (0, $grDTV.canLinkBeCreatedInRange)(newState.selection.from, newState.selection.to)(newState),
                    activeLinkMark: $a09ab5ad2f7d9456$var$toState(state.activeLinkMark, (0, $4axGb.LinkAction).SELECTION_CHANGE, newState),
                    timesViewed: state.timesViewed,
                    searchSessionId: state.searchSessionId,
                    inputMethod: inputMethod,
                    editorAppearance: editorAppearance
                };
                if (!(0, $3ADzg.shallowEqual)(state, pluginState)) dispatch($a09ab5ad2f7d9456$export$77b371d6becc8882, state);
                return state;
            }
        },
        key: $a09ab5ad2f7d9456$export$77b371d6becc8882,
        props: {
            decorations: ()=>{
                return (0, $b7EWj.DecorationSet).empty;
            },
            handleDOMEvents: {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                mouseup: (_, event)=>{
                    // this prevents redundant selection transaction when clicking on link
                    // link state will be update on slection change which happens on mousedown
                    if ($a09ab5ad2f7d9456$var$isLinkDirectTarget(event)) {
                        event.preventDefault();
                        return true;
                    }
                    return false;
                },
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                mousedown: (view, event)=>{
                    // since link clicks are disallowed by browsers inside contenteditable
                    // so we need to handle shift+click selection ourselves in this case
                    if (!event.shiftKey || !$a09ab5ad2f7d9456$var$isLinkDirectTarget(event)) return false;
                    const { state: state } = view;
                    const { selection: { $anchor: $anchor } } = state;
                    const newPosition = view.posAtCoords({
                        left: event.clientX,
                        top: event.clientY
                    });
                    if (newPosition?.pos != null && newPosition.pos !== $anchor.pos) {
                        const tr = state.tr.setSelection((0, $3lIcL.TextSelection).create(state.doc, $anchor.pos, newPosition.pos));
                        view.dispatch(tr);
                        return true;
                    }
                    return false;
                }
            }
        }
    });
function $a09ab5ad2f7d9456$var$isLinkDirectTarget(event) {
    return event?.target instanceof HTMLElement && event.target.tagName === 'A';
}

});
parcelRegister("3ADzg", function(module, exports) {
$parcel$export(module.exports, "pmHistoryPluginKey", () => $f2cf97e1a7db7bda$export$d4f2631252432abf);
$parcel$export(module.exports, "shallowEqual", () => $f2cf97e1a7db7bda$export$d36bdfa510afb180);
$parcel$export(module.exports, "isSelectionInsideLastNodeInDocument", () => $f2cf97e1a7db7bda$export$51bf7c6695e13879);
$parcel$export(module.exports, "isInListItem", () => $f2cf97e1a7db7bda$export$92d47fcf661e090e);
$parcel$export(module.exports, "findFarthestParentNode", () => $f2cf97e1a7db7bda$export$6b982788a5f0ccef);
$parcel$export(module.exports, "insideTableCell", () => $f2cf97e1a7db7bda$export$1350ff12653c84d4);
$parcel$export(module.exports, "checkNodeDown", () => $f2cf97e1a7db7bda$export$d0951c59cd3dac0f);
$parcel$export(module.exports, "isEmptyNode", () => $f2cf97e1a7db7bda$export$641fdf56f693bfbc);
$parcel$export(module.exports, "isNodeEmpty", () => $f2cf97e1a7db7bda$export$cd58ff1081f6abe9);
$parcel$export(module.exports, "isInEmptyLine", () => $f2cf97e1a7db7bda$export$3b68253250b41118);
$parcel$export(module.exports, "isEmptyParagraph", () => (parcelRequire("5Z3Rm")).isEmptyParagraph);
$parcel$export(module.exports, "hasDocAsParent", () => (parcelRequire("bnAxN")).hasDocAsParent);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $BmspC = parcelRequire("BmspC");

var $bnAxN = parcelRequire("bnAxN");

var $5Z3Rm = parcelRequire("5Z3Rm");

var $8YVeS = parcelRequire("8YVeS");

var $7TRmB = parcelRequire("7TRmB");

var $8yKjs = parcelRequire("8yKjs");

var $7EdFW = parcelRequire("7EdFW");

var $hvPOH = parcelRequire("hvPOH");

var $dZ5Iy = parcelRequire("dZ5Iy");

var $5s6bt = parcelRequire("5s6bt");

var $bnh3n = parcelRequire("bnh3n");

var $9Ssie = parcelRequire("9Ssie");

var $bazog = parcelRequire("bazog");

var $gbisc = parcelRequire("gbisc");

var $7SIsS = parcelRequire("7SIsS");


var $dyNYh = parcelRequire("dyNYh");

var $33XK0 = parcelRequire("33XK0");

var $3mTkR = parcelRequire("3mTkR");






var $3AGQm = parcelRequire("3AGQm");

var $bTpHi = parcelRequire("bTpHi");

var $gikGJ = parcelRequire("gikGJ");

var $d3BBj = parcelRequire("d3BBj");

var $gO24W = parcelRequire("gO24W");


var $LjYWw = parcelRequire("LjYWw");


var $lT8fo = parcelRequire("lT8fo");

var $b2Bji = parcelRequire("b2Bji");


var $3Ussg = parcelRequire("3Ussg");




var $64w3F = parcelRequire("64w3F");

var $74dMH = parcelRequire("74dMH");

var $fCXIH = parcelRequire("fCXIH");

var $grDTV = parcelRequire("grDTV");

var $A5UFg = parcelRequire("A5UFg");

var $51k6y = parcelRequire("51k6y");

var $19zEl = parcelRequire("19zEl");


var $7WlTe = parcelRequire("7WlTe");

var $HOLTj = parcelRequire("HOLTj");




var $leZY6 = parcelRequire("leZY6");

var $3vP7W = parcelRequire("3vP7W");

var $dqHDB = parcelRequire("dqHDB");

var $kMoqb = parcelRequire("kMoqb");

var $gmvZ4 = parcelRequire("gmvZ4");

var $hMYvD = parcelRequire("hMYvD");

var $aP4il = parcelRequire("aP4il");


const $f2cf97e1a7db7bda$export$d4f2631252432abf = 'history$';
function $f2cf97e1a7db7bda$export$d36bdfa510afb180(obj1 = {}, obj2 = {}) {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    return keys1.length === keys2.length && keys1.reduce((acc, key)=>acc && obj1[key] === obj2[key], true);
}
function $f2cf97e1a7db7bda$export$51bf7c6695e13879(selection) {
    const docNode = selection.$anchor.node(0);
    const rootNode = selection.$anchor.node(1);
    return docNode.lastChild === rootNode;
}
const $f2cf97e1a7db7bda$export$92d47fcf661e090e = (state)=>{
    return (0, $BmspC.hasParentNodeOfType)(state.schema.nodes.listItem)(state.selection);
};
const $f2cf97e1a7db7bda$export$6b982788a5f0ccef = (predicate)=>($pos)=>{
        let candidate = null;
        for(let i = $pos.depth; i > 0; i--){
            const node = $pos.node(i);
            if (predicate(node)) candidate = {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
        return candidate;
    };
const $f2cf97e1a7db7bda$export$1350ff12653c84d4 = (state)=>{
    const { tableCell: tableCell, tableHeader: tableHeader } = state.schema.nodes;
    return (0, $BmspC.hasParentNodeOfType)([
        tableCell,
        tableHeader
    ])(state.selection);
};
/**
 * Traverse the document until an "ancestor" is found. Any nestable block can be an ancestor.
 */ // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f2cf97e1a7db7bda$var$findAncestorPosition(doc, pos) {
    const nestableBlocks = [
        'blockquote',
        'bulletList',
        'orderedList'
    ];
    if (pos.depth === 1) return pos;
    let node = pos.node(pos.depth);
    let newPos = pos;
    while(pos.depth >= 1){
        pos = doc.resolve(pos.before(pos.depth));
        node = pos.node(pos.depth);
        if (node && nestableBlocks.indexOf(node.type.name) !== -1) newPos = pos;
    }
    return newPos;
}
function $f2cf97e1a7db7bda$export$d0951c59cd3dac0f(selection, doc, filter) {
    const ancestorDepth = $f2cf97e1a7db7bda$var$findAncestorPosition(doc, selection.$to).depth;
    // Top level node
    if (ancestorDepth === 0) return false;
    const res = doc.resolve(selection.$to.after(ancestorDepth));
    return res.nodeAfter ? filter(res.nodeAfter) : false;
}
const $f2cf97e1a7db7bda$export$641fdf56f693bfbc = (schema)=>{
    const { doc: doc, paragraph: paragraph, expand: expand, codeBlock: codeBlock, blockquote: blockquote, panel: panel, heading: heading, listItem: listItem, bulletList: bulletList, orderedList: orderedList, taskList: taskList, taskItem: taskItem, decisionList: decisionList, decisionItem: decisionItem, media: media, mediaGroup: mediaGroup, mediaSingle: mediaSingle } = schema.nodes;
    const innerIsEmptyNode = (node)=>{
        switch(node.type){
            case media:
            case mediaGroup:
            case mediaSingle:
                return false;
            case paragraph:
            case codeBlock:
            case heading:
            case taskItem:
            case decisionItem:
                return node.content.size === 0;
            case expand:
            case blockquote:
            case panel:
            case listItem:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return node.content.size === 2 && innerIsEmptyNode(node.content.firstChild);
            case bulletList:
            case orderedList:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return node.content.size === 4 && innerIsEmptyNode(node.content.firstChild);
            case taskList:
            case decisionList:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return node.content.size === 2 && innerIsEmptyNode(node.content.firstChild);
            case doc:
                let isEmpty = true;
                node.content.forEach((child)=>{
                    isEmpty = isEmpty && innerIsEmptyNode(child);
                });
                return isEmpty;
            default:
                return $f2cf97e1a7db7bda$export$cd58ff1081f6abe9(node);
        }
    };
    return innerIsEmptyNode;
};
function $f2cf97e1a7db7bda$export$cd58ff1081f6abe9(node) {
    if (node && node.textContent) return false;
    if (!node || !node.childCount || node.childCount === 1 && (0, $5Z3Rm.isEmptyParagraph)(node.firstChild)) return true;
    const block = [];
    const nonBlock = [];
    node.forEach((child)=>{
        child.isInline ? nonBlock.push(child) : block.push(child);
    });
    return !nonBlock.length && !block.filter((childNode)=>!!childNode.childCount && !(childNode.childCount === 1 && (0, $5Z3Rm.isEmptyParagraph)(childNode.firstChild)) || childNode.isAtom).length;
}
function $f2cf97e1a7db7bda$export$3b68253250b41118(state) {
    const { selection: selection } = state;
    const { $cursor: $cursor, $anchor: $anchor } = selection;
    if (!$cursor) return false;
    const node = $cursor.node();
    if (!node) return false;
    return (0, $5Z3Rm.isEmptyParagraph)(node) && (0, $bnAxN.hasDocAsParent)($anchor);
}

});
parcelRegister("8yKjs", function(module, exports) {
$parcel$export(module.exports, "getExtensionLozengeData", () => $36b18020509a37b1$export$4fd8ecadd193bea0);
const $36b18020509a37b1$export$4fd8ecadd193bea0 = ({ node: node, type: type })=>{
    if (!node.attrs.parameters) return;
    const { macroMetadata: macroMetadata } = node.attrs.parameters;
    if (macroMetadata && macroMetadata.placeholder) {
        let placeholderData;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        macroMetadata.placeholder.forEach((placeholder)=>{
            if (placeholder.type === type && placeholder.data && placeholder.data.url) placeholderData = placeholder.data;
        });
        return placeholderData;
    }
    return;
};

});

parcelRegister("dZ5Iy", function(module, exports) {
$parcel$export(module.exports, "timestampToUTCDate", () => $588f444e520afb69$export$56c3660a4ee2196a);
$parcel$export(module.exports, "todayTimestampInUTC", () => $588f444e520afb69$export$6297728405c48562);
$parcel$export(module.exports, "timestampToString", () => $588f444e520afb69$export$48755a044ef883a0);
$parcel$export(module.exports, "timestampToIsoFormat", () => $588f444e520afb69$export$70a1b7b6fffe4dd1);
$parcel$export(module.exports, "isPastDate", () => $588f444e520afb69$export$e6cc7bfc6e0e363e);
$parcel$export(module.exports, "timestampToTaskContext", () => $588f444e520afb69$export$fbc04a9e57b04a80);

var $btz6U = parcelRequire("btz6U");

var $bf0oy = parcelRequire("bf0oy");
var $588f444e520afb69$var$FORMATS = /*#__PURE__*/ function(FORMATS) {
    FORMATS["ISO_FORMAT"] = "YYYY-MM-DD";
    FORMATS["LOCALIZED_FORMAT"] = "LOCALIZED_FORMAT";
    return FORMATS;
}($588f444e520afb69$var$FORMATS || {});
const $588f444e520afb69$export$56c3660a4ee2196a = (timestamp)=>{
    const date = new Date(Number(timestamp));
    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1;
    const year = date.getUTCFullYear();
    return {
        day: day,
        month: month,
        year: year
    };
};
const $588f444e520afb69$export$6297728405c48562 = ()=>{
    const today = new Date(Date.now());
    const todayInUTC = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
    return todayInUTC.toString();
};
const $588f444e520afb69$var$addLeadingZero = (val)=>{
    if (val < 10) return `0${val}`;
    return val;
};
const $588f444e520afb69$var$capitalizeFirstLetter = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $588f444e520afb69$export$48755a044ef883a0 = (timestamp, intl, pattern)=>{
    if (!intl || pattern === "YYYY-MM-DD") return $588f444e520afb69$export$70a1b7b6fffe4dd1(timestamp);
    const date = new Date(Number(timestamp));
    return intl.formatDate(date, {
        timeZone: 'UTC',
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        formatMatcher: 'best fit'
    });
};
const $588f444e520afb69$export$70a1b7b6fffe4dd1 = (timestamp)=>{
    const date = new Date(Number(timestamp));
    return `${date.getUTCFullYear()}-${$588f444e520afb69$var$addLeadingZero(date.getUTCMonth() + 1)}-${$588f444e520afb69$var$addLeadingZero(date.getUTCDate())}`;
};
const $588f444e520afb69$export$e6cc7bfc6e0e363e = (timestamp)=>{
    return (0, $bf0oy.default)(new Date(Number(timestamp)), new Date(Number($588f444e520afb69$export$6297728405c48562())));
};
const $588f444e520afb69$export$fbc04a9e57b04a80 = (timestamp, intl)=>{
    const curDate = new Date(Number($588f444e520afb69$export$6297728405c48562()));
    const givenDate = new Date(Number(timestamp));
    const distance = (0, $btz6U.default)(givenDate, curDate);
    if (intl && [
        -1,
        0,
        1
    ].indexOf(distance) > -1) return $588f444e520afb69$var$capitalizeFirstLetter(intl.formatRelativeTime(distance, 'day', {
        numeric: 'auto'
    }));
    return $588f444e520afb69$export$48755a044ef883a0(timestamp, intl, "LOCALIZED_FORMAT");
};

});

parcelRegister("5s6bt", function(module, exports) {
$parcel$export(module.exports, "withImageLoader", () => $e51a33182b24142b$export$9b0f795b2e33f057);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $e51a33182b24142b$export$3a0bcc6ff2e20f36 = (Wrapped)=>class WithImageLoader extends (0, $eJOHy.Component) {
        /**
		 *
		 * @example
		 */ componentDidMount() {
            this.fetchImage(this.props);
        }
        /**
		 *
		 * @param nextProps
		 * @example
		 */ // Ignored via go/ees005
        // eslint-disable-next-line react/no-unsafe
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (nextProps.url !== this.props.url) {
                this.setState({
                    imageStatus: 'loading'
                });
                this.fetchImage(nextProps);
            }
        }
        /**
		 *
		 * @example
		 */ componentWillUnmount() {
            if (this.img) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('load', this.onLoad);
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('error', this.onError);
                this.img = null;
            }
        }
        /**
		 *
		 * @param root0
		 * @param root0.url
		 * @example
		 */ fetchImage({ url: url }) {
            if (url) {
                if (!this.img) {
                    this.img = new Image();
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('load', this.onLoad);
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('error', this.onError);
                }
                this.img.src = url;
            }
        }
        /**
		 *
		 * @example
		 */ render() {
            const { imageStatus: imageStatus } = this.state;
            // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, $gt9Am.jsx)(Wrapped, {
                ...this.props,
                imageStatus: imageStatus
            });
        }
        constructor(...args){
            super(...args), this.state = {
                imageStatus: 'loading'
            }, this.onLoad = ()=>{
                this.setState({
                    imageStatus: 'complete'
                });
                const { onExternalImageLoaded: onExternalImageLoaded } = this.props;
                if (onExternalImageLoaded && this.img) onExternalImageLoaded({
                    width: this.img.naturalWidth,
                    height: this.img.naturalHeight
                });
            }, this.onError = ()=>{
                this.setState({
                    imageStatus: 'error'
                });
            };
        }
    };
const $e51a33182b24142b$var$withImageLoaderNew = (Wrapped)=>class WithImageLoader extends (0, $eJOHy.Component) {
        componentDidMount() {
            this.fetchImage(this.props);
        }
        componentDidUpdate(newProps) {
            if (newProps.url !== this.props.url) {
                this.setState({
                    imageStatus: 'loading'
                });
                this.fetchImage(newProps);
            }
        }
        componentWillUnmount() {
            if (this.img) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('load', this.onLoad);
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('error', this.onError);
                this.img = null;
            }
        }
        fetchImage({ url: url }) {
            if (url) {
                if (!this.img) {
                    this.img = new Image();
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('load', this.onLoad);
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('error', this.onError);
                }
                this.img.src = url;
            }
        }
        render() {
            const { imageStatus: imageStatus } = this.state;
            // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, $gt9Am.jsx)(Wrapped, {
                ...this.props,
                imageStatus: imageStatus
            });
        }
        constructor(...args){
            super(...args), this.state = {
                imageStatus: 'loading'
            }, this.onLoad = ()=>{
                this.setState({
                    imageStatus: 'complete'
                });
                const { onExternalImageLoaded: onExternalImageLoaded } = this.props;
                if (onExternalImageLoaded && this.img) onExternalImageLoaded({
                    width: this.img.naturalWidth,
                    height: this.img.naturalHeight
                });
            }, this.onError = ()=>{
                this.setState({
                    imageStatus: 'error'
                });
            };
        }
    };
const $e51a33182b24142b$export$9b0f795b2e33f057 = (Wrapped)=>{
    return $e51a33182b24142b$var$withImageLoaderNew(Wrapped);
};

});

parcelRegister("9Ssie", function(module, exports) {
$parcel$export(module.exports, "isParagraph", () => $842b6525224fe87c$export$d7ae8c533ae18832);
$parcel$export(module.exports, "isText", () => $842b6525224fe87c$export$1879817ac5c922b7);
$parcel$export(module.exports, "isLinkMark", () => $842b6525224fe87c$export$5dfeda3a9e6fe056);
$parcel$export(module.exports, "SelectedState", () => $842b6525224fe87c$export$a6212ae0c82963af);
$parcel$export(module.exports, "isNodeSelectedOrInRange", () => $842b6525224fe87c$export$5125f50e751e84db);
$parcel$export(module.exports, "isSupportedInParent", () => $842b6525224fe87c$export$b6e38334b1fb4d1b);
$parcel$export(module.exports, "isMediaNode", () => $842b6525224fe87c$export$d6ca4605aefeca32);
$parcel$export(module.exports, "isNodeBeforeMediaNode", () => $842b6525224fe87c$export$cfaa7840b0c93780);
$parcel$export(module.exports, "toJSON", () => $842b6525224fe87c$export$54fd2c36b5cc6731);
$parcel$export(module.exports, "nodeToJSON", () => $842b6525224fe87c$export$3a858d3babd60825);

var $lovmf = parcelRequire("lovmf");

var $BmspC = parcelRequire("BmspC");
const $842b6525224fe87c$export$cdc577fd3f583194 = (tr)=>{
    const nodes = [];
    const steps = tr.steps || [];
    steps.forEach((step)=>{
        step.getMap().forEach((oldStart, oldEnd, newStart, newEnd)=>{
            tr.doc.nodesBetween(newStart, Math.min(newEnd, tr.doc.content.size), (node)=>{
                if (!nodes.find((n)=>n === node)) nodes.push(node);
                return false;
            });
        });
    });
    return nodes;
};
const $842b6525224fe87c$export$4c39e41e39b3c449 = (node)=>{
    try {
        node.check(); // this will throw an error if the node is invalid
    } catch (error) {
        return false;
    }
    return true;
};
const $842b6525224fe87c$export$996213f7c272fc6f = (nodes)=>nodes.every($842b6525224fe87c$export$4c39e41e39b3c449);
const $842b6525224fe87c$export$26b9f946b448f23e = (node, type)=>type && node && node.type === type;
const $842b6525224fe87c$export$d7ae8c533ae18832 = (node, schema)=>$842b6525224fe87c$export$26b9f946b448f23e(node, schema.nodes.paragraph);
const $842b6525224fe87c$export$1879817ac5c922b7 = (node, schema)=>$842b6525224fe87c$export$26b9f946b448f23e(node, schema.nodes.text);
const $842b6525224fe87c$export$5dfeda3a9e6fe056 = (node, schema)=>$842b6525224fe87c$export$26b9f946b448f23e(node, schema.marks.link);
var $842b6525224fe87c$export$a6212ae0c82963af = /*#__PURE__*/ function(SelectedState) {
    SelectedState[SelectedState["selectedInRange"] = 0] = "selectedInRange";
    SelectedState[SelectedState["selectedInside"] = 1] = "selectedInside";
    return SelectedState;
}({});
const $842b6525224fe87c$export$5125f50e751e84db = (anchorPosition, headPosition, nodePosition, nodeSize)=>{
    if (typeof nodePosition !== 'number') return null;
    const rangeStart = Math.min(anchorPosition, headPosition);
    const rangeEnd = Math.max(anchorPosition, headPosition);
    const nodeStart = nodePosition;
    const nodeEnd = nodePosition + nodeSize;
    if (anchorPosition === headPosition) return null;
    if (rangeStart <= nodeStart && nodeEnd < rangeEnd || rangeStart < nodeStart && nodeEnd <= rangeEnd) return 0;
    if (nodeStart <= anchorPosition && headPosition <= nodeEnd) return 1;
    return null;
};
const $842b6525224fe87c$export$b6e38334b1fb4d1b = (state, fragment, currentAppearance)=>{
    const depth = currentAppearance === 'embed' || currentAppearance === 'block' ? undefined : -1;
    const parent = state.selection.$from.node(depth);
    return parent && parent.type.validContent(fragment);
};
const $842b6525224fe87c$export$d6ca4605aefeca32 = (node)=>{
    return [
        'media',
        'mediaInline',
        'mediaGroup',
        'mediaSingle'
    ].includes(node.type.name);
};
const $842b6525224fe87c$export$cfaa7840b0c93780 = ($pos, state)=>{
    let nodeBefore = $pos.nodeBefore;
    if (!nodeBefore) {
        const depthOfParent = $pos.depth - 1 || 1;
        const parentNode = (0, $BmspC.findParentNodeOfType)([
            state.schema.nodes[`${$pos.node(depthOfParent).type.name}`]
        ])(state.selection);
        const resolvedPosOfParentNode = parentNode ? state.tr.doc.resolve(parentNode.pos) : undefined;
        const nodeBeforeParent = resolvedPosOfParentNode && resolvedPosOfParentNode.pos < state.doc.nodeSize ? resolvedPosOfParentNode.nodeBefore : undefined;
        if (nodeBeforeParent) nodeBefore = nodeBeforeParent;
    }
    if (nodeBefore) return [
        'media',
        'mediaInline',
        'mediaGroup',
        'mediaSingle'
    ].includes(nodeBefore.type.name);
    return false;
};
const $842b6525224fe87c$var$transformer = new (0, $lovmf.JSONTransformer)();
function $842b6525224fe87c$export$54fd2c36b5cc6731(node) {
    return $842b6525224fe87c$var$transformer.encode(node);
}
function $842b6525224fe87c$export$3a858d3babd60825(node) {
    return $842b6525224fe87c$var$transformer.encodeNode(node);
}

});

parcelRegister("bazog", function(module, exports) {
$parcel$export(module.exports, "pluginFactory", () => $01c852007ceaa07b$export$3dd00fb488ab385a);
/**
 * Creates a ProseMirror plugin's state and handles UI updates.
 *
 * Here's a few things to keep in mind:
 * - plugin's state is stored as a single object
 * - `Reducer` specifies how plugin's state changes in response to commands
 * - `Command` describes only what happen, but not how state changes
 * - `mapping` could be used to map ProseMirror positions stored in plugin's state
 *
 * Example:
 *  const { createPluginState, createCommand, getPluginState } = pluginFactory(
 *    reducer,
 *    pluginKey
 *  );
 *
 *  export const createPlugin = (dispatch: Dispatch, initialState) =>
 *    new SafePlugin({
 *      state: createPluginState(dispatch, initialState),
 *      key: pluginKey
 *    });
 *
 * Example of a reducer:
 *
 *  export const reducer = (
 *    state: TablePluginState,
 *    action: TableAction,
 *  ): TablePluginState => {
 *    switch (action.type) {
 *      case 'TOGGLE_CONTEXTUAL_MENU':
 *      return {
 *        ...state,
 *        isContextualMenuOpen: !state.isContextualMenuOpen,
 *      };
 *    default:
 *      return state;
 *    }
 *  };
 *
 *
 * Example of a command:
 *
 * export const toggleContextualMenu = createCommand({
 *   type: 'TOGGLE_CONTEXTUAL_MENU',
 * }, tr => tr.setMeta('addToHistory', false));
 *
 */ // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $01c852007ceaa07b$var$isFunction(x) {
    return typeof x === 'function';
}
function $01c852007ceaa07b$export$3dd00fb488ab385a(pluginKey, reducer, options = {}) {
    const { mapping: mapping, onDocChanged: onDocChanged, onSelectionChanged: onSelectionChanged } = options;
    return {
        createPluginState (dispatch, initialState) {
            return {
                init: (_, state)=>$01c852007ceaa07b$var$isFunction(initialState) ? initialState(state) : initialState,
                apply: (tr, _pluginState, _oldEditorState, newEditorState)=>{
                    const oldPluginState = mapping ? mapping(tr, _pluginState, newEditorState) : _pluginState;
                    let newPluginState = oldPluginState;
                    const meta = tr.getMeta(pluginKey);
                    if (meta) newPluginState = reducer(oldPluginState, meta);
                    if (onDocChanged && tr.docChanged) newPluginState = onDocChanged(tr, newPluginState, newEditorState);
                    else if (onSelectionChanged && tr.selectionSet) newPluginState = onSelectionChanged(tr, newPluginState, newEditorState);
                    if (newPluginState !== oldPluginState) dispatch(pluginKey, newPluginState);
                    return newPluginState;
                }
            };
        },
        createCommand (action, transform) {
            return (state, dispatch)=>{
                if (dispatch) {
                    const tr = transform ? transform(state.tr, state) : state.tr;
                    const resolvedAction = $01c852007ceaa07b$var$isFunction(action) ? action(state) : action;
                    if (tr && resolvedAction) dispatch(tr.setMeta(pluginKey, resolvedAction));
                    else return false;
                }
                return true;
            };
        },
        getPluginState (state) {
            return pluginKey.getState(state);
        }
    };
}

});

parcelRegister("gO24W", function(module, exports) {
$parcel$export(module.exports, "isTextInput", () => $a9c11403540600f0$export$3e6057b9bf6b0bbb);

var $lzEKq = parcelRequire("lzEKq");
const $a9c11403540600f0$export$3e6057b9bf6b0bbb = (tr)=>{
    const [step] = tr.steps;
    if (!step || !(step instanceof (0, $lzEKq.ReplaceStep))) return false;
    const { slice: { content: content }, from: from, to: to } = step;
    const char = content.firstChild;
    return from === to && content.childCount === 1 && !!char && !!char.text && char.text.length === 1;
};

});

parcelRegister("lT8fo", function(module, exports) {
$parcel$export(module.exports, "getPerformanceOptions", () => $4a9fd58283843c2b$export$9838b97af1c61be);
$parcel$export(module.exports, "startMeasureReactNodeViewRendered", () => $4a9fd58283843c2b$export$2630f5971dfad231);
$parcel$export(module.exports, "stopMeasureReactNodeViewRendered", () => $4a9fd58283843c2b$export$dc5a82f0bfc526c3);

var $bMFKb = parcelRequire("bMFKb");

var $hvjqZ = parcelRequire("hvjqZ");
// This was existing logic when converting from ReactNodeView
// our current sampling for this event is not bound by node.type
let $4a9fd58283843c2b$var$nodeViewRenderedEventsCounter = 0;
const $4a9fd58283843c2b$var$DEFAULT_SAMPLING_RATE = 100;
const $4a9fd58283843c2b$var$DEFAULT_SLOW_THRESHOLD = 7;
function $4a9fd58283843c2b$export$9838b97af1c61be(view) {
    // Please, do not copy or use this kind of code below
    // @ts-ignore
    const fakePluginKey = {
        key: 'analyticsPlugin$',
        getState: (state)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return state['analyticsPlugin$'];
        }
    };
    const pluginState = fakePluginKey.getState(view.state);
    const nodeViewTracking = pluginState && pluginState.performanceTracking ? pluginState.performanceTracking.nodeViewTracking || {} : {};
    const samplingRate = nodeViewTracking.samplingRate ?? $4a9fd58283843c2b$var$DEFAULT_SAMPLING_RATE;
    const slowThreshold = nodeViewTracking.slowThreshold ?? $4a9fd58283843c2b$var$DEFAULT_SLOW_THRESHOLD;
    return {
        trackingEnabled: !!nodeViewTracking.enabled,
        samplingRate: samplingRate,
        slowThreshold: slowThreshold
    };
}
function $4a9fd58283843c2b$export$2630f5971dfad231({ nodeTypeName: nodeTypeName }) {
    (0, $hvjqZ.startMeasure)(`\u{1F989}${nodeTypeName}::ReactNodeView`);
}
function $4a9fd58283843c2b$export$dc5a82f0bfc526c3({ nodeTypeName: nodeTypeName, dispatchAnalyticsEvent: dispatchAnalyticsEvent, samplingRate: samplingRate, slowThreshold: slowThreshold }) {
    (0, $hvjqZ.stopMeasure)(`\u{1F989}${nodeTypeName}::ReactNodeView`, (duration)=>{
        if (++$4a9fd58283843c2b$var$nodeViewRenderedEventsCounter % samplingRate === 0 && duration > slowThreshold) dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).REACT_NODEVIEW_RENDERED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
            attributes: {
                node: nodeTypeName,
                duration: duration
            }
        });
    });
}

});

parcelRegister("b2Bji", function(module, exports) {
$parcel$export(module.exports, "sniffUserBrowserExtensions", () => $61b3a92b49e227d6$export$4cd1ca2600761f65);
const $61b3a92b49e227d6$var$registerDetectors = (targetExtensions, supportedDetectors)=>{
    const detectors = supportedDetectors.filter((registration)=>targetExtensions.includes(registration.name));
    return detectors.map((detector)=>({
            name: detector.name,
            state: {
                detected: false
            },
            fns: {
                async: detector.fns.async,
                sync: detector.fns.sync
            }
        }));
};
const $61b3a92b49e227d6$var$RACE_COMPLETE = 'race_complete';
const $61b3a92b49e227d6$var$SELECTORS = {
    GRAMMARLY: 'grammarly-extension, grammarly-popups, [data-grammarly-shadow-root]'
};
/**
 * This is the official list of supported browser extension detectors. To add support
 * for detecting an additional browser extension, simply add a (DetectorRegistration)
 * object like below to the list:
 *
 * ```
 * {
 *  name: 'exampleExtension',
 *  fns: {
 *    // a synchronous check that should return true if the extension is detected
 *    sync: () => !!document.querySelector(".some-example-class"),
 *    // an asynchronous check that should invoke 'detected' if the extension is detected.
 *    // it can also invoke 'cleanup' with a callback to schedule cleanup tasks
 *    // (such as disconnecting observers).
 *    async: (detected, cleanup) => {
 *      if (document.querySelector(".some-example-class")) {
 *        detected();
 *      }
 *    }
 *  }
 * }
 * ```
 */ const $61b3a92b49e227d6$var$supportedDetectors = [
    {
        name: 'grammarly',
        fns: {
            sync: ()=>Boolean(document?.querySelector($61b3a92b49e227d6$var$SELECTORS.GRAMMARLY)),
            async: (detected, cleanup)=>{
                // First check to see if grammarly already exists on page
                const exists = Boolean(document?.querySelector($61b3a92b49e227d6$var$SELECTORS.GRAMMARLY));
                if (exists) detected();
                // Otherwise, setup a mutation observer to observe the page and its children
                // for newly added nodes. Collect observed mutations in a queue and in 1 second
                // intervals either process the queue or schedule the processing task for when
                // the user agent's main thread is idle (if possible).
                let queue = [];
                const processQueue = ()=>{
                    for (const mutations of queue){
                        for (const mutation of mutations)if (mutation?.type === 'childList' && mutation?.addedNodes?.length) {
                            const exists = Array.from(mutation.addedNodes).some((node)=>node.parentElement?.querySelector($61b3a92b49e227d6$var$SELECTORS.GRAMMARLY));
                            if (exists) detected();
                        }
                    }
                    queue = [];
                };
                const intervalId = setInterval(()=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    if (typeof window.requestIdleCallback === 'function') // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    window.requestIdleCallback(processQueue);
                    else window.requestAnimationFrame(processQueue);
                }, 1000);
                const observer = new MutationObserver((mutations)=>{
                    queue.push(mutations);
                });
                cleanup(()=>{
                    queue = [];
                    clearInterval(intervalId);
                    observer?.disconnect();
                });
                observer.observe(document.documentElement, {
                    childList: true,
                    subtree: true
                });
            }
        }
    }
];
function $61b3a92b49e227d6$export$4cd1ca2600761f65(options) {
    try {
        // First we filter out supported extensions that aren't requested through options. We also
        // prepare detector objects with some initial internal state (e.g. detector.state.detected = false)
        const detectors = $61b3a92b49e227d6$var$registerDetectors(options.extensions, $61b3a92b49e227d6$var$supportedDetectors);
        // If async mode is enabled, we convert the list of detector objects to a list of promises
        // that resolve when the detector invokes detected() during its asynchronous check.
        // We also track any scheduled cleanup() tasks.
        if (options.async === true) {
            const asyncCleanups = [];
            const asyncDetections = Promise.all(detectors.map((detector)=>{
                return new Promise((resolve)=>{
                    const detected = ()=>{
                        detector.state.detected = true;
                        resolve();
                    };
                    const cleanup = (cb)=>{
                        asyncCleanups.push(cb);
                    };
                    if (typeof detector.fns.async === 'function') detector.fns.async(detected, cleanup);
                    else {
                        detector.state.detected = false;
                        resolve();
                    }
                });
            }));
            // We race all asynchronous checkers against a user-defined timeout (asyncTimeoutMs).
            // When asynchronous checks are finalised first,or if the timeout elapses, we return
            // the list of extensions detected up until that point.
            const globalTimeout = new Promise((resolve)=>setTimeout(resolve, options.asyncTimeoutMs, $61b3a92b49e227d6$var$RACE_COMPLETE));
            return Promise.race([
                asyncDetections,
                globalTimeout
            ]).then(()=>{
                return detectors.filter((detector)=>detector.state.detected).map((detector)=>detector.name);
            })// If there are any errors, we fail safely and silently with zero detected extensions.
            .catch(()=>[]).finally(()=>asyncCleanups.map((cleanup)=>cleanup()));
        } else // If sync mode, we immediately execute synchronous checks
        // and return a list of extensions whose synchronous checks returned true.
        return detectors.filter((detector)=>detector.fns.sync?.()).map((detector)=>detector.name);
    } catch (err) {
        // If there are any unhandled errors, we fail safely and silently with zero detected extensions.
        return options.async ? Promise.resolve([]) : [];
    }
}

});

parcelRegister("64w3F", function(module, exports) {
$parcel$export(module.exports, "autoJoinTr", () => $c136a66e18d8e68e$export$c7c1e59168a7f554);

var $lzEKq = parcelRequire("lzEKq");
function $c136a66e18d8e68e$export$c7c1e59168a7f554(tr, isJoinable) {
    if (Array.isArray(isJoinable)) {
        const types = isJoinable;
        isJoinable = (node)=>types.indexOf(node.type.name) > -1;
    }
    const ranges = [];
    for(let i = 0; i < tr.mapping.maps.length; i++){
        const map = tr.mapping.maps[i];
        for(let j = 0; j < ranges.length; j++)ranges[j] = map.map(ranges[j]);
        map.forEach((_s, _e, from, to)=>ranges.push(from, to));
    }
    // Figure out which joinable points exist inside those ranges,
    // by checking all node boundaries in their parent nodes.
    const joinable = [];
    for(let i = 0; i < ranges.length; i += 2){
        const from = ranges[i];
        const to = ranges[i + 1];
        const $from = tr.doc.resolve(from);
        const depth = $from.sharedDepth(to);
        const parent = $from.node(depth);
        for(let index = $from.indexAfter(depth), pos = $from.after(depth + 1); pos <= to; ++index){
            const after = parent.maybeChild(index);
            if (!after) break;
            if (index && joinable.indexOf(pos) === -1) {
                const before = parent.child(index - 1);
                if (before.type === after.type && isJoinable(before, after)) joinable.push(pos);
            }
            pos += after.nodeSize;
        }
    }
    // Join the joinable points
    joinable.sort((a, b)=>a - b);
    for(let i = joinable.length - 1; i >= 0; i--)if ((0, $lzEKq.canJoin)(tr.doc, joinable[i])) tr.join(joinable[i]);
}

});

parcelRegister("74dMH", function(module, exports) {
$parcel$export(module.exports, "isReferencedSource", () => $2d248134b5fac0e8$export$d35a68bd2e0b55da);
$parcel$export(module.exports, "removeConnectedNodes", () => $2d248134b5fac0e8$export$657e59857351232d);
$parcel$export(module.exports, "getChildrenInfo", () => $2d248134b5fac0e8$export$c98d43680e607ac1);
$parcel$export(module.exports, "getNodeName", () => $2d248134b5fac0e8$export$651544f548703224);
const $2d248134b5fac0e8$export$d35a68bd2e0b55da = (state, node)=>{
    if (!node) return false;
    let found = false;
    // Handle nodes having 2 uuids. They could have a localId or a fragment. Regardless this needs
    // to check if either id is used by a data consumer.
    const localIds = new Set([
        node.attrs?.localId,
        node.marks?.find((mark)=>mark.type === state.schema.marks.fragment)?.attrs?.localId
    ].filter(Boolean));
    // If there are no uuids on the node then it's not possible for it to be referenced anywhere.
    if (!localIds.size) return false;
    state.doc.descendants((node)=>{
        if (found) return false;
        const dataConsumer = node.marks.find((mark)=>mark.type === state.schema.marks.dataConsumer);
        if (!dataConsumer) return true;
        found = dataConsumer.attrs.sources?.some((src)=>localIds.has(src)) ?? false;
        return !found;
    });
    return found;
};
const $2d248134b5fac0e8$export$82b9f8f75cc709b4 = (state)=>{
    const result = {};
    const { doc: doc, schema: schema } = state;
    // Keeps a map of all raw ids -> to their preferred normalised varient. A node with both fragmentMark & localId will
    // have both ids mapped here to the same normalized version.
    const normalizedIds = new Map();
    const dataConsumerSources = new Map();
    // Perform a prelim scan creating the initial id to connection link mappings.
    // This will also save a list of data sources consumed per node.
    doc.descendants((node, pos)=>{
        let dataConsumer;
        let fragmentMark;
        node.marks.some((mark)=>{
            if (mark.type === schema.marks.dataConsumer) dataConsumer = mark;
            else if (mark.type === schema.marks.fragment) fragmentMark = mark;
            // Stop searching marks if we've found both consumer and fragment.
            return !!dataConsumer && !!fragmentMark;
        });
        // If node cannot be referenced by any means then abort.
        if (!fragmentMark && !node.attrs?.localId) return true;
        const normalizedId = fragmentMark?.attrs?.localId ?? node.attrs?.localId;
        if (!normalizedId) return true;
        if (!!fragmentMark?.attrs?.localId) normalizedIds.set(fragmentMark.attrs.localId, normalizedId);
        if (!!node.attrs?.localId) normalizedIds.set(node.attrs.localId, normalizedId);
        if (!!result[normalizedId]) // Duplicate ID has been found, we'll care about the first one for now.
        return true;
        result[normalizedId] = {
            localId: normalizedId,
            name: fragmentMark?.attrs?.name,
            node: node,
            pos: pos,
            targets: []
        };
        if (!!dataConsumer && dataConsumer.attrs.sources.length) dataConsumerSources.set(normalizedId, dataConsumer.attrs.sources);
        // Do not descend into children of a node which has a dataConsumer attached. This assumes all children of the node cannot
        // be referenced by another node.
        return !dataConsumer;
    });
    // This 2nd-pass only looks at the consumer sources and updates all connections with the correct id refs.
    for (const [localId, sources] of dataConsumerSources)// This is a ref to the node (connection link) which contains the consumer.
    sources.forEach((src)=>{
        const normalizedId = normalizedIds.get(src) ?? src;
        const srcLink = result[normalizedId];
        if (srcLink && normalizedId !== localId) srcLink.targets.push(localId);
    });
    return result;
};
const $2d248134b5fac0e8$export$657e59857351232d = (state, node)=>{
    if (!node) return state.tr;
    const selectedLocalIds = $2d248134b5fac0e8$var$getSelectedLocalIds(state, node);
    const allNodes = $2d248134b5fac0e8$export$82b9f8f75cc709b4(state);
    const idsToBeDeleted = $2d248134b5fac0e8$var$getIdsToBeDeleted(selectedLocalIds, allNodes);
    if (!idsToBeDeleted?.length) return state.tr;
    const { tr: tr } = state;
    let newTr = tr;
    idsToBeDeleted.forEach((id)=>{
        if (!allNodes[id]) return;
        const { node: node, pos: pos } = allNodes[id];
        newTr = newTr.delete(newTr.mapping.map(pos), newTr.mapping.map(node.nodeSize + pos));
    });
    return newTr;
};
// find all ids need to be remove connected to selected extension
const $2d248134b5fac0e8$var$getIdsToBeDeleted = (selectedIds, allNodes)=>{
    if (!selectedIds.size) return [];
    let searchSet = [
        ...selectedIds
    ];
    const deletedIds = new Set();
    while(searchSet.length){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const id = searchSet.pop();
        if (allNodes[id]) {
            deletedIds.add(allNodes[id].localId);
            searchSet = searchSet.concat(allNodes[id]?.targets.filter((targetId)=>!deletedIds.has(allNodes[targetId]?.localId)) ?? []);
        }
    }
    return Array.from(deletedIds);
};
const $2d248134b5fac0e8$export$c98d43680e607ac1 = (state, node)=>{
    let allChildrenHadName = true;
    if (!node) return [];
    const childrenIdSet = new Set();
    const childrenInfoArray = [];
    const allNodes = $2d248134b5fac0e8$export$82b9f8f75cc709b4(state);
    const selectedNodeIds = $2d248134b5fac0e8$var$getSelectedLocalIds(state, node);
    selectedNodeIds.forEach((id)=>{
        if (allNodes[id]) allNodes[id].targets.forEach(childrenIdSet.add, childrenIdSet);
    });
    for (const id of childrenIdSet)if (!$2d248134b5fac0e8$var$getNodeNameById(id, allNodes)) {
        allChildrenHadName = false;
        break;
    } else childrenInfoArray.push({
        id: id,
        name: $2d248134b5fac0e8$var$getNodeNameById(id, allNodes),
        amount: $2d248134b5fac0e8$var$getChildrenNodeAmount(id, allNodes)
    });
    return allChildrenHadName ? childrenInfoArray : [];
};
const $2d248134b5fac0e8$var$getChildrenNodeAmount = (id, allNodes)=>{
    const searchTerms = new Set([
        id
    ]);
    const traverseHistory = new Map();
    const childrenIds = new Set();
    traverseHistory.set(id, false);
    while(searchTerms.size > 0){
        const [currTerm] = searchTerms;
        const targets = $2d248134b5fac0e8$var$getNodeTargetsById(currTerm, allNodes);
        targets.forEach((target)=>{
            const isTargetCounted = traverseHistory.get(target);
            if (!isTargetCounted) {
                searchTerms.add(target);
                childrenIds.add(target);
            }
            target !== id && childrenIds.add(target);
        });
        traverseHistory.set(currTerm, true);
        searchTerms.delete(currTerm);
    }
    return childrenIds.size;
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2d248134b5fac0e8$var$getNodeTargetsById = (id, allNodes)=>{
    if (!id || !allNodes[id]) return [];
    return allNodes[id].targets;
};
const $2d248134b5fac0e8$var$getNodeNameById = (id, allNodes)=>{
    if (typeof id === 'object') {
        let name;
        id.forEach((localId)=>{
            name = name ?? allNodes[localId]?.name;
        });
        return name || null;
    }
    if (!id || !allNodes[id]) return null;
    return allNodes[id].name;
};
const $2d248134b5fac0e8$var$getSelectedLocalIds = (state, node)=>{
    if (!node) return new Set([]);
    const localIds = new Set([
        node.attrs?.localId,
        node.marks?.find((mark)=>mark.type === state.schema.marks.fragment)?.attrs?.localId
    ].filter(Boolean));
    return localIds;
};
const $2d248134b5fac0e8$export$651544f548703224 = (state, node)=>{
    return node?.marks?.find((mark)=>mark.type === state.schema.marks.fragment)?.attrs?.name ?? '';
};

});

parcelRegister("A5UFg", function(module, exports) {
$parcel$export(module.exports, "gridTypeForLayout", () => $dfda3d7dfdd95a88$export$27813bf9aa3826dc);
const $dfda3d7dfdd95a88$export$27813bf9aa3826dc = (layout)=>layout === 'wrap-left' || layout === 'wrap-right' ? 'wrapped' : 'full';

});

parcelRegister("19zEl", function(module, exports) {
$parcel$export(module.exports, "shouldAddDefaultWrappedWidth", () => $b3204125fc08effb$export$7cd5aab2c4f1fb1e);
$parcel$export(module.exports, "nonWrappedLayouts", () => $b3204125fc08effb$export$607795ead6e50626);
$parcel$export(module.exports, "floatingLayouts", () => $b3204125fc08effb$export$7c0073a4d21b222d);
$parcel$export(module.exports, "isRichMediaInsideOfBlockNode", () => $b3204125fc08effb$export$55fb9d6810f2e04b);
$parcel$export(module.exports, "alignAttributes", () => $b3204125fc08effb$export$b2258912a400ba32);
$parcel$export(module.exports, "calculateSnapPoints", () => $b3204125fc08effb$export$de65085e667b4bf1);

var $BmspC = parcelRequire("BmspC");

var $7yBx7 = parcelRequire("7yBx7");

var $24wSW = parcelRequire("24wSW");
const $b3204125fc08effb$export$7cd5aab2c4f1fb1e = (layout, width, lineLength)=>{
    return (0, $24wSW.wrappedLayouts).indexOf(layout) > -1 && lineLength && width && width > 0.5 * lineLength;
};
const $b3204125fc08effb$export$607795ead6e50626 = [
    'center',
    'wide',
    'full-width'
];
const $b3204125fc08effb$export$7c0073a4d21b222d = [
    'wrap-left',
    'wrap-right'
];
const $b3204125fc08effb$export$55fb9d6810f2e04b = (view, pos)=>{
    if (typeof pos !== 'number' || isNaN(pos) || !view) return false;
    const $pos = view.state.doc.resolve(pos);
    const { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } = view.state.schema.nodes;
    return !!(0, $BmspC.findParentNodeOfTypeClosestToPos)($pos, [
        expand,
        nestedExpand,
        layoutColumn
    ]);
};
const $b3204125fc08effb$export$b2258912a400ba32 = (layout, oldAttrs, gridSize = 12, originalWidth, lineLength)=>{
    let width = oldAttrs.width;
    const oldLayout = oldAttrs.layout;
    const oldLayoutIsNonWrapped = $b3204125fc08effb$export$607795ead6e50626.indexOf(oldLayout) > -1;
    const newLayoutIsNonWrapped = $b3204125fc08effb$export$607795ead6e50626.indexOf(layout) > -1;
    const newLayoutIsWrapped = (0, $24wSW.wrappedLayouts).indexOf(layout) > -1;
    const oldLayoutIsWrapped = (0, $24wSW.wrappedLayouts).indexOf(oldLayout) > -1;
    if (oldLayoutIsNonWrapped && $b3204125fc08effb$export$7cd5aab2c4f1fb1e(layout, originalWidth, lineLength)) // 'full-width' or 'wide' or 'center' -> 'wrap-left' or 'wrap-right' or 'align-end' or 'align-start'
    {
        if (!width || width >= 100 || oldLayout !== 'center' // == 'full-width' or 'wide'
        ) width = 50;
    } else if (layout !== oldLayout && [
        'full-width',
        'wide'
    ].indexOf(oldLayout) > -1) // 'full-width' -> 'center' or 'wide'
    // 'wide' -> 'center' or 'full-width'
    // unset width
    width = undefined;
    else if (width) {
        const cols = Math.round(width / 100 * gridSize);
        let targetCols = cols;
        if (oldLayoutIsWrapped && newLayoutIsNonWrapped) {
            // wrap -> center needs to align to even grid
            targetCols = Math.floor(targetCols / 2) * 2;
            width = undefined;
        } else if (oldLayoutIsNonWrapped && newLayoutIsWrapped) {
            // Can be here only if
            // 'full-width' or 'wide' or 'center' -> 'wrap-left' or 'wrap-right' or 'align-end' or 'align-start'
            // AND
            // !originalWidth || !lineLength || small image
            // AND
            // width defined!
            // cannot resize to full column width, and cannot resize to 1 column
            if (cols <= 1) targetCols = 2;
            else if (cols >= gridSize) targetCols = 10;
        }
        if (targetCols !== cols) width = targetCols / gridSize * 100;
    }
    return {
        ...oldAttrs,
        layout: layout,
        width: width
    };
};
function $b3204125fc08effb$export$de65085e667b4bf1({ $pos: $pos, akEditorWideLayoutWidth: akEditorWideLayoutWidth, allowBreakoutSnapPoints: allowBreakoutSnapPoints, containerWidth: containerWidth, gridSize: gridSize, gridWidth: gridWidth, insideInlineLike: insideInlineLike, insideLayout: insideLayout, isVideoFile: isVideoFile, lineLength: lineLength, offsetLeft: offsetLeft, wrappedLayout: wrappedLayout }) {
    const snapTargets = [];
    for(let i = 0; i < gridWidth; i++){
        const pxFromColumns = (0, $24wSW.calcPxFromColumns)(i, lineLength, gridWidth);
        snapTargets.push(insideLayout ? pxFromColumns : pxFromColumns - offsetLeft);
    }
    // full width
    snapTargets.push(lineLength - offsetLeft);
    const columns = wrappedLayout || insideInlineLike ? 1 : 2;
    const minimumWidth = (0, $24wSW.calcPxFromColumns)(columns, lineLength, gridSize);
    let snapPoints = snapTargets.filter((width)=>width >= minimumWidth);
    if (!$pos) return snapPoints;
    snapPoints = isVideoFile ? snapPoints.filter((width)=>width > 320) : snapPoints;
    const isTopLevel = $pos.parent.type.name === 'doc';
    if (isTopLevel && allowBreakoutSnapPoints) {
        snapPoints.push(akEditorWideLayoutWidth);
        const fullWidthPoint = containerWidth - (0, $7yBx7.akEditorBreakoutPadding);
        if (fullWidthPoint > akEditorWideLayoutWidth) snapPoints.push(fullWidthPoint);
    }
    // EDM-1107: Ensure new snapPoints are sorted with existing points
    snapPoints = snapPoints.sort((a, b)=>a - b);
    return snapPoints;
}

});
parcelRegister("24wSW", function(module, exports) {
$parcel$export(module.exports, "calcPxFromColumns", () => $41c0bcab9a8da41b$export$1e3701608f0cee80);
$parcel$export(module.exports, "calcColumnsFromPx", () => $41c0bcab9a8da41b$export$10912f14d8d54640);
$parcel$export(module.exports, "calcPctFromPx", () => $41c0bcab9a8da41b$export$55ddb36b3404ec6d);
$parcel$export(module.exports, "wrappedLayouts", () => $41c0bcab9a8da41b$export$405baca3d8bc263d);
$parcel$export(module.exports, "calcMediaPxWidth", () => $41c0bcab9a8da41b$export$5e51fc02b9ada5af);

var $7yBx7 = parcelRequire("7yBx7");

var $1I3aa = parcelRequire("1I3aa");
const $41c0bcab9a8da41b$var$validWidthModes = [
    'center',
    'wrap-left',
    'wrap-right',
    'align-start',
    'align-end'
];
const $41c0bcab9a8da41b$export$adfc02948d64a4f2 = (layout)=>$41c0bcab9a8da41b$var$validWidthModes.indexOf(layout) > -1;
function $41c0bcab9a8da41b$export$1e3701608f0cee80(columns, lineLength, gridSize) {
    const maxWidth = lineLength + (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE);
    return maxWidth / gridSize * columns - (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE);
}
function $41c0bcab9a8da41b$export$10912f14d8d54640(width, lineLength, gridSize) {
    const maxWidth = lineLength + (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE)) * gridSize / maxWidth;
}
function $41c0bcab9a8da41b$export$e70e278a1f662f8d(pct, lineLength) {
    const maxWidth = lineLength + (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE);
    return maxWidth * pct - (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE);
}
function $41c0bcab9a8da41b$export$55ddb36b3404ec6d(width, lineLength) {
    const maxWidth = lineLength + (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE)) / maxWidth;
}
const $41c0bcab9a8da41b$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
const $41c0bcab9a8da41b$export$144a1e648ed4962e = (containerWidth, pctWidth, origWidth, origHeight)=>pctWidth && origWidth && origHeight && Math.ceil($41c0bcab9a8da41b$export$e70e278a1f662f8d(pctWidth / 100, containerWidth.lineLength || containerWidth.width));
const $41c0bcab9a8da41b$export$5e51fc02b9ada5af = (opts)=>{
    const { origWidth: origWidth, origHeight: origHeight, layout: layout, pctWidth: pctWidth, containerWidth: containerWidth, resizedPctWidth: resizedPctWidth } = opts;
    const { width: width, lineLength: lineLength } = containerWidth;
    const calculatedPctWidth = $41c0bcab9a8da41b$export$144a1e648ed4962e(containerWidth, pctWidth, origWidth, origHeight);
    const calculatedResizedPctWidth = $41c0bcab9a8da41b$export$144a1e648ed4962e(containerWidth, resizedPctWidth, origWidth, origHeight);
    if (layout === 'wide') {
        if (lineLength) {
            const wideWidth = Math.ceil(lineLength * (0, $7yBx7.breakoutWideScaleRatio));
            return wideWidth > width ? lineLength : wideWidth;
        }
    } else if (layout === 'full-width') return width - (0, $7yBx7.akEditorBreakoutPadding);
    else if (calculatedPctWidth) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if ($41c0bcab9a8da41b$export$405baca3d8bc263d.indexOf(layout) > -1) {
            if (calculatedResizedPctWidth) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                if (resizedPctWidth < 50) return calculatedResizedPctWidth;
                return calculatedPctWidth;
            }
            return Math.min(calculatedPctWidth, origWidth);
        }
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return calculatedPctWidth;
    } else if (layout === 'center') {
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return Math.min(origWidth, lineLength || width);
    } else if (layout && $41c0bcab9a8da41b$export$405baca3d8bc263d.indexOf(layout) !== -1) {
        const halfLineLength = Math.ceil((lineLength || width) / 2);
        return origWidth <= halfLineLength ? origWidth : halfLineLength;
    }
    return origWidth;
};
const $41c0bcab9a8da41b$export$195604d042fd3f87 = (gridWidth, width, height, lineLength, gridSize)=>{
    const pxWidth = $41c0bcab9a8da41b$export$e70e278a1f662f8d(gridWidth / 100, lineLength);
    const columnSpan = Math.round($41c0bcab9a8da41b$export$10912f14d8d54640(pxWidth, lineLength, gridSize));
    const alignedWidth = $41c0bcab9a8da41b$export$1e3701608f0cee80(columnSpan, lineLength, gridSize);
    return {
        height: height / width * alignedWidth,
        width: alignedWidth
    };
};

});


parcelRegister("7WlTe", function(module, exports) {
$parcel$export(module.exports, "getDatasourceType", () => $735e61d500130c4c$export$19af9860957ca153);
$parcel$export(module.exports, "canRenderDatasource", () => $735e61d500130c4c$export$1974047c293dd52e);

var $k9y0J = parcelRequire("k9y0J");
var $7BBxG = parcelRequire("7BBxG");
var $7KhEE = parcelRequire("7KhEE");

var $eGOwo = parcelRequire("eGOwo");
const $735e61d500130c4c$export$19af9860957ca153 = (datasourceId)=>{
    switch(datasourceId){
        case 0, $7KhEE.JIRA_LIST_OF_LINKS_DATASOURCE_ID:
            return 'jira';
        case 0, $k9y0J.ASSETS_LIST_OF_LINKS_DATASOURCE_ID:
            return 'assets';
        case 0, $7BBxG.CONFLUENCE_SEARCH_DATASOURCE_ID:
            return 'confluence-search';
        default:
            return undefined;
    }
};
const $735e61d500130c4c$export$1974047c293dd52e = (datasourceId, defaultValue = true)=>{
    const datasourceType = $735e61d500130c4c$export$19af9860957ca153(datasourceId);
    switch(datasourceType){
        case 'jira':
            return true;
        case 'assets':
            if ((0, $eGOwo.fg)('linking_platform_datasource_assets_objects')) return true;
            return false;
        default:
            return defaultValue;
    }
};

});
parcelRegister("k9y0J", function(module, exports) {
$parcel$export(module.exports, "ASSETS_LIST_OF_LINKS_DATASOURCE_ID", () => $16f3892d5aa02916$export$34a6fbdd67f09ff6);
$parcel$export(module.exports, "default", () => $16f3892d5aa02916$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $16f3892d5aa02916$export$34a6fbdd67f09ff6 = '361d618a-3c04-40ad-9b27-3c8ea6927020';

const $16f3892d5aa02916$var$LazyAssetsConfigModal = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("azbF7")).then((module)=>({
            default: module.AssetsConfigModal
        })));
const $16f3892d5aa02916$var$AssetsConfigModalWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-testid": 'assets-aql-datasource-table-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16f3892d5aa02916$var$LazyAssetsConfigModal, props));
};
var $16f3892d5aa02916$export$2e2bcd8739ae039 = $16f3892d5aa02916$var$AssetsConfigModalWithWrappers;

});
parcelRegister("azbF7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kNFvF"),
    $ewTvA("fliVL"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("gxPBZ")
]).then(()=>parcelRequire('i1bWW'));

});


parcelRegister("7BBxG", function(module, exports) {
$parcel$export(module.exports, "CONFLUENCE_SEARCH_DATASOURCE_ID", () => $aaf2311a623c98ee$export$d9788d6cf1867282);
$parcel$export(module.exports, "default", () => $aaf2311a623c98ee$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $aaf2311a623c98ee$export$d9788d6cf1867282 = '768fc736-3af4-4a8f-b27e-203602bff8ca';

const $aaf2311a623c98ee$var$LazyConfluenceSearchConfigModal = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dPmx0")).then((module)=>({
            default: module.ConfluenceSearchConfigModal
        })));
const $aaf2311a623c98ee$var$ConfluenceSearchConfigModalWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-testid": 'confluence-search-datasource-table-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aaf2311a623c98ee$var$LazyConfluenceSearchConfigModal, props));
};
var $aaf2311a623c98ee$export$2e2bcd8739ae039 = $aaf2311a623c98ee$var$ConfluenceSearchConfigModalWithWrappers;

});
parcelRegister("dPmx0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kNFvF"),
    $ewTvA("fliVL"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("lLdNy")
]).then(()=>parcelRequire('a1XeP'));

});


parcelRegister("7KhEE", function(module, exports) {
$parcel$export(module.exports, "JIRA_LIST_OF_LINKS_DATASOURCE_ID", () => $b6adaf62d6e1c249$export$8ce19958117ece5c);
$parcel$export(module.exports, "default", () => $b6adaf62d6e1c249$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $b6adaf62d6e1c249$export$8ce19958117ece5c = 'd8b75300-dfda-4519-b6cd-e49abbd50401';

const $b6adaf62d6e1c249$var$LazyJiraIssuesConfigModal = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cQoqQ")).then((module)=>({
            default: module.JiraIssuesConfigModal
        })));
const $b6adaf62d6e1c249$var$JiraIssuesConfigModalWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-testid": 'jira-datasource-table-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b6adaf62d6e1c249$var$LazyJiraIssuesConfigModal, props));
};
var $b6adaf62d6e1c249$export$2e2bcd8739ae039 = $b6adaf62d6e1c249$var$JiraIssuesConfigModalWithWrappers;

});
parcelRegister("cQoqQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kNFvF"),
    $ewTvA("fliVL"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("7FotB")
]).then(()=>parcelRequire('fjaM1'));

});



parcelRegister("HOLTj", function(module, exports) {
$parcel$export(module.exports, "walkNextNode", () => $fa3fe07496cb04ee$export$a5ae75c0b3dfe1c0);
$parcel$export(module.exports, "walkPrevNode", () => $fa3fe07496cb04ee$export$cab15df6ad89b5a0);
$parcel$export(module.exports, "insertNewLineWithAnalytics", () => $fa3fe07496cb04ee$export$67efd148fa31066c);
$parcel$export(module.exports, "createNewParagraphAbove", () => $fa3fe07496cb04ee$export$fd094c1e3c1540bf);
$parcel$export(module.exports, "createParagraphNear", () => $fa3fe07496cb04ee$export$d0f80ac1b4510888);
$parcel$export(module.exports, "createNewParagraphBelow", () => $fa3fe07496cb04ee$export$d4296e42f66d8dc6);
$parcel$export(module.exports, "deleteEmptyParagraphAndMoveBlockUp", () => $fa3fe07496cb04ee$export$a52ade1f964aef2c);
$parcel$export(module.exports, "insertContentDeleteRange", () => $fa3fe07496cb04ee$export$1a87582f65bdc5db);
$parcel$export(module.exports, "isEmptySelectionAtStart", () => $fa3fe07496cb04ee$export$55f1e30b4664ff16);
$parcel$export(module.exports, "isEmptySelectionAtEnd", () => $fa3fe07496cb04ee$export$aedf35c057f77b82);
$parcel$export(module.exports, "filterCommand", () => $fa3fe07496cb04ee$export$3dea766d36a8935f);

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $eGOwo = parcelRequire("eGOwo");

var $9Letn = parcelRequire("9Letn");

var $bMFKb = parcelRequire("bMFKb");

var $asjM0 = parcelRequire("asjM0");

var $6BNUN = parcelRequire("6BNUN");

var $5Z3Rm = parcelRequire("5Z3Rm");

var $9Ssie = parcelRequire("9Ssie");
const $fa3fe07496cb04ee$export$3dea766d36a8935f = (predicates, cmd)=>{
    return function(state, dispatch, view) {
        if (!Array.isArray(predicates)) predicates = [
            predicates
        ];
        if (predicates.some((pred)=>!pred(state, view))) return false;
        return cmd(state, dispatch, view) || false;
    };
};
const $fa3fe07496cb04ee$export$a5ae75c0b3dfe1c0 = ($startPos)=>{
    let $pos = $startPos;
    // invariant 1: don't walk past the end of the document
    // invariant 2: we are at the beginning or
    //              we haven't walked to the start of *any* node
    //              parentOffset includes textOffset.
    while($pos.pos < $pos.doc.nodeSize - 2 && ($pos.pos === $startPos.pos || $pos.parentOffset > 0))$pos = $pos.doc.resolve($pos.pos + 1);
    return {
        $pos: $pos,
        foundNode: $pos.pos < $pos.doc.nodeSize - 2
    };
};
const $fa3fe07496cb04ee$export$cab15df6ad89b5a0 = ($startPos)=>{
    let $pos = $startPos;
    while($pos.pos > 0 && ($pos.pos === $startPos.pos || $pos.parentOffset < $pos.parent.nodeSize - 2))$pos = $pos.doc.resolve($pos.pos - 1);
    return {
        $pos: $pos,
        foundNode: $pos.pos > 0
    };
};
function $fa3fe07496cb04ee$export$c2d9390f63354627() {
    return function(state, dispatch) {
        const { $from: $from } = state.selection;
        const parent = $from.parent;
        const { hardBreak: hardBreak } = state.schema.nodes;
        if (hardBreak) {
            const hardBreakNode = hardBreak.createChecked();
            if (parent && parent.type.validContent((0, $3xw6l.Fragment).from(hardBreakNode))) {
                if (dispatch) dispatch(state.tr.replaceSelectionWith(hardBreakNode, false));
                return true;
            }
        }
        if (state.selection instanceof (0, $3lIcL.TextSelection)) {
            if (dispatch) dispatch(state.tr.insertText('\n'));
            return true;
        }
        return false;
    };
}
const $fa3fe07496cb04ee$export$67efd148fa31066c = (editorAnalyticsAPI)=>(0, $asjM0.withAnalytics)(editorAnalyticsAPI, {
        action: (0, $bMFKb.ACTION).INSERTED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).LINE_BREAK,
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK
    })($fa3fe07496cb04ee$export$c2d9390f63354627());
const $fa3fe07496cb04ee$export$fd094c1e3c1540bf = (state, dispatch)=>{
    const append = false;
    if (!$fa3fe07496cb04ee$var$canMoveUp(state) && $fa3fe07496cb04ee$var$canCreateParagraphNear(state)) {
        $fa3fe07496cb04ee$export$d0f80ac1b4510888(append)(state, dispatch);
        return true;
    }
    return false;
};
const $fa3fe07496cb04ee$export$d4296e42f66d8dc6 = (state, dispatch)=>{
    const append = true;
    if (!$fa3fe07496cb04ee$var$canMoveDown(state) && $fa3fe07496cb04ee$var$canCreateParagraphNear(state)) {
        $fa3fe07496cb04ee$export$d0f80ac1b4510888(append)(state, dispatch);
        return true;
    }
    return false;
};
function $fa3fe07496cb04ee$var$canCreateParagraphNear(state) {
    const { selection: { $from: $from } } = state;
    const node = $from.node($from.depth);
    const insideCodeBlock = !!node && node.type === state.schema.nodes.codeBlock;
    const isNodeSelection = state.selection instanceof (0, $3lIcL.NodeSelection);
    return $from.depth > 1 || isNodeSelection || insideCodeBlock;
}
function $fa3fe07496cb04ee$export$d0f80ac1b4510888(append = true) {
    return function(state, dispatch) {
        const paragraph = state.schema.nodes.paragraph;
        if (!paragraph) return false;
        let insertPos;
        if (state.selection instanceof (0, $3lIcL.TextSelection)) {
            if ($fa3fe07496cb04ee$var$topLevelNodeIsEmptyTextBlock(state)) return false;
            insertPos = $fa3fe07496cb04ee$var$getInsertPosFromTextBlock(state, append);
        } else insertPos = $fa3fe07496cb04ee$var$getInsertPosFromNonTextBlock(state, append);
        const tr = state.tr.insert(insertPos, paragraph.createAndFill());
        tr.setSelection((0, $3lIcL.TextSelection).create(tr.doc, insertPos + 1));
        if (dispatch) dispatch(tr);
        return true;
    };
}
function $fa3fe07496cb04ee$var$getInsertPosFromTextBlock(state, append) {
    const { $from: $from, $to: $to } = state.selection;
    let pos;
    if (!append) pos = $from.start(0);
    else pos = $to.end(0);
    return pos;
}
function $fa3fe07496cb04ee$var$getInsertPosFromNonTextBlock(state, append) {
    const { $from: $from, $to: $to } = state.selection;
    const nodeAtSelection = state.selection instanceof (0, $3lIcL.NodeSelection) && state.doc.nodeAt(state.selection.$anchor.pos);
    const isMediaSelection = nodeAtSelection && nodeAtSelection.type.name === 'mediaGroup';
    let pos;
    if (!append) {
        // The start position is different with text block because it starts from 0
        pos = $from.start($from.depth);
        // The depth is different with text block because it starts from 0
        pos = $from.depth > 0 && !isMediaSelection ? pos - 1 : pos;
    } else {
        pos = $to.end($to.depth);
        pos = $to.depth > 0 && !isMediaSelection ? pos + 1 : pos;
    }
    return pos;
}
function $fa3fe07496cb04ee$var$topLevelNodeIsEmptyTextBlock(state) {
    const topLevelNode = state.selection.$from.node(1);
    return topLevelNode.isTextblock && topLevelNode.type !== state.schema.nodes.codeBlock && topLevelNode.nodeSize === 2;
}
function $fa3fe07496cb04ee$var$canMoveUp(state) {
    const { selection: selection } = state;
    /**
	 * If there's a media element on the selection it will use a gap cursor to move
	 */ if (selection instanceof (0, $3lIcL.NodeSelection) && (0, $9Ssie.isMediaNode)(selection.node)) return true;
    if (selection instanceof (0, $3lIcL.TextSelection) && !((0, $9Letn.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true) && (0, $9Letn.expValEqualsNoExposure)('platform_editor_block_menu_empty_line', 'isEnabled', true))) {
        if (!selection.empty) return true;
    }
    return !$fa3fe07496cb04ee$export$e9083e8cbe24bec0(state);
}
function $fa3fe07496cb04ee$var$canMoveDown(state) {
    const { selection: selection } = state;
    /**
	 * If there's a media element on the selection it will use a gap cursor to move
	 */ if (selection instanceof (0, $3lIcL.NodeSelection) && (0, $9Ssie.isMediaNode)(selection.node)) return true;
    if (selection instanceof (0, $3lIcL.TextSelection) && !((0, $9Letn.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true) && (0, $9Letn.expValEqualsNoExposure)('platform_editor_block_menu_empty_line', 'isEnabled', true))) {
        if (!selection.empty) return true;
    }
    return !$fa3fe07496cb04ee$export$4ca816540352da02(state);
}
function $fa3fe07496cb04ee$export$4ca816540352da02(state) {
    const { selection: selection, doc: doc } = state;
    return doc.nodeSize - selection.$to.pos - 2 === selection.$to.depth;
}
function $fa3fe07496cb04ee$export$e9083e8cbe24bec0(state) {
    const { selection: selection } = state;
    return selection.$from.pos === selection.$from.depth;
}
const $fa3fe07496cb04ee$export$a52ade1f964aef2c = (canNextNodeMoveUp)=>{
    return (state, dispatch, view)=>{
        const { selection: { $from: { pos: pos, parent: parent }, $head: $head, empty: empty }, tr: tr, doc: doc } = state;
        const { $pos: $pos } = $fa3fe07496cb04ee$export$a5ae75c0b3dfe1c0($head);
        const nextPMNode = doc.nodeAt($pos.pos - 1);
        if (empty && nextPMNode && canNextNodeMoveUp(nextPMNode) && (0, $5Z3Rm.isEmptyParagraph)(parent) && view?.endOfTextblock('right')) {
            tr.deleteRange(pos - 1, pos + 1);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
};
const $fa3fe07496cb04ee$export$1a87582f65bdc5db = (tr, getSelectionResolvedPos, insertions, deletions)=>{
    insertions.forEach((contentInsert)=>{
        const [content, pos] = contentInsert;
        tr.insert(tr.mapping.map(pos), content);
    });
    deletions.forEach((deleteRange)=>{
        const [firstPos, lastPos] = deleteRange;
        tr.delete(tr.mapping.map(firstPos), tr.mapping.map(lastPos));
    });
    tr.setSelection(new (0, $3lIcL.TextSelection)(getSelectionResolvedPos(tr)));
};
const $fa3fe07496cb04ee$export$55f1e30b4664ff16 = (state)=>{
    const { blockTaskItem: blockTaskItem } = state.schema.nodes;
    const { empty: empty, $from: $from } = state.selection;
    // If blockTaskItem is in the schema,
    // we need to check if the selection is inside a blockTaskItem
    if (blockTaskItem && empty && (0, $eGOwo.fg)('platform_editor_blocktaskitem_patch_2')) {
        // If the parent is in a textblock,
        // check if it's nested inside a blockTaskItem
        if ($from.parent.isTextblock) {
            const $posAtStartOfTextBlock = state.doc.resolve($from.start($from.depth - 1));
            const parentOfTextBlock = $posAtStartOfTextBlock.parent;
            // If the parent of the textblock is a blockTaskItem,
            // we need to if the textblock is the first node in the blockTaskItem
            if (parentOfTextBlock.type === blockTaskItem) {
                const firstChildOfBlockTaskItem = parentOfTextBlock.firstChild;
                if (firstChildOfBlockTaskItem === $from.parent) {
                    // If the textblock is the first node in the blockTaskItem,
                    // check if the selection is at the start of the textblock
                    const firstTextPosInTextBlock = $from.start($from.depth);
                    return $from.pos === firstTextPosInTextBlock;
                } else return false;
            }
        } else if ($from.parent.type === blockTaskItem) {
            // Check if the selection is at the start of the blockTaskItem
            let firstPosInBlockTaskItem = 0;
            if ((0, $eGOwo.fg)('platform_editor_blocktaskitem_patch_2')) {
                const blockTaskItemDepth = $from.depth;
                // When cleaning up platform_editor_blocktaskitem_patch_2, set firstPosInBlockTaskItem as const
                firstPosInBlockTaskItem = $from.start(blockTaskItemDepth);
            } else {
                const blockTaskItemDepth = $from.depth - 1;
                const DISTANCE_FROM_PARENT_FOR_GAP_CURSOR = 1;
                firstPosInBlockTaskItem = $from.start(blockTaskItemDepth) + DISTANCE_FROM_PARENT_FOR_GAP_CURSOR;
            }
            // Is the selection at the first possible position inside the blockTaskItem
            return $from.pos === firstPosInBlockTaskItem;
        }
    }
    return empty && ($from.parentOffset === 0 || state.selection instanceof (0, $6BNUN.GapCursorSelection));
};
const $fa3fe07496cb04ee$export$aedf35c057f77b82 = (state)=>{
    const { blockTaskItem: blockTaskItem } = state.schema.nodes;
    const { empty: empty, $from: $from } = state.selection;
    // If blockTaskItem is in the schema,
    // we need to check if the selection is inside a blockTaskItem
    if (blockTaskItem && empty && (0, $eGOwo.fg)('platform_editor_blocktaskitem_patch_3')) {
        // If the parent is in a textblock,
        // check if it's nested inside a blockTaskItem
        if ($from.parent.isTextblock) {
            const $posAtEndOfTextBlock = state.doc.resolve($from.end($from.depth - 1));
            const parentOfTextBlock = $posAtEndOfTextBlock.parent;
            // If the parent of the textblock is a blockTaskItem,
            // we need to know if the textblock is the last node in the blockTaskItem
            if (parentOfTextBlock.type === blockTaskItem) {
                const lastChildOfBlockTaskItem = parentOfTextBlock.lastChild;
                if (lastChildOfBlockTaskItem === $from.parent) {
                    // If the textblock is the last node in the blockTaskItem,
                    // check if the selection is at the end of the textblock
                    const lastTextPosInTextBlock = $from.end($from.depth);
                    return $from.pos === lastTextPosInTextBlock;
                } else return false;
            }
        } else if ($from.parent.type === blockTaskItem) {
            // Check if the selection is at the end of the blockTaskItem
            const lastPosInBlockTaskItem = $from.end();
            return $from.pos === lastPosInBlockTaskItem;
        }
    }
    return empty && ($from.end() === $from.pos || state.selection instanceof (0, $6BNUN.GapCursorSelection));
};

});
parcelRegister("6BNUN", function(module, exports) {
$parcel$export(module.exports, "Side", () => $99eae554af83c227$export$80a00690bda7f17e);
$parcel$export(module.exports, "JSON_ID", () => $99eae554af83c227$export$d9f9f34e18094ffd);
$parcel$export(module.exports, "GapCursorSelection", () => $99eae554af83c227$export$7d98c58ca1423246);

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $8TSsQ = parcelRequire("8TSsQ");
var $99eae554af83c227$export$80a00690bda7f17e = /*#__PURE__*/ function(Side) {
    Side["LEFT"] = "left";
    Side["RIGHT"] = "right";
    return Side;
}({});
const $99eae554af83c227$export$d9f9f34e18094ffd = 'gapcursor';
class $99eae554af83c227$export$7d98c58ca1423246 extends (0, $3lIcL.Selection) {
    /**
	 * Construct a GapCursorSelection
	 * @param {ResolvedPos} $pos resolved position
	 * @param {Side} side side where the gap cursor is drawn
	 */ constructor($pos, side = "left"){
        super($pos, $pos), this.side = side, this.visible = false;
    }
    static valid($pos) {
        const { parent: parent, nodeBefore: nodeBefore, nodeAfter: nodeAfter } = $pos;
        const targetNode = (0, $8TSsQ.isValidTargetNode)(nodeBefore) ? nodeBefore : (0, $8TSsQ.isValidTargetNode)(nodeAfter) ? nodeAfter : null;
        if (!targetNode || parent.isTextblock) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const deflt = parent.contentMatchAt($pos.index()).defaultType;
        return deflt && deflt.isTextblock;
    }
    static findFrom($pos, dir, mustMove = false) {
        const side = dir === 1 ? "right" : "left";
        if (!mustMove && $99eae554af83c227$export$7d98c58ca1423246.valid($pos)) return new $99eae554af83c227$export$7d98c58ca1423246($pos, side);
        let pos = $pos.pos;
        // TODO: ED-5048 - Fix any, potential issue.
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let next = null;
        // Scan up from this position
        for(let d = $pos.depth;; d--){
            const parent = $pos.node(d);
            if (side === "right" ? $pos.indexAfter(d) < parent.childCount : $pos.index(d) > 0) {
                next = parent.maybeChild(side === "right" ? $pos.indexAfter(d) : $pos.index(d) - 1);
                break;
            } else if (d === 0) return null;
            pos += dir;
            const $cur = $pos.doc.resolve(pos);
            if ($99eae554af83c227$export$7d98c58ca1423246.valid($cur)) return new $99eae554af83c227$export$7d98c58ca1423246($cur, side);
        }
        // And then down into the next node
        for(;;){
            next = side === "right" ? next.firstChild : next.lastChild;
            if (next === null) break;
            pos += dir;
            const $cur = $pos.doc.resolve(pos);
            if ($99eae554af83c227$export$7d98c58ca1423246.valid($cur)) return new $99eae554af83c227$export$7d98c58ca1423246($cur, side);
        }
        return null;
    }
    static fromJSON(doc, json) {
        return new $99eae554af83c227$export$7d98c58ca1423246(doc.resolve(json.pos), json.side);
    }
    map(doc, mapping) {
        const $pos = doc.resolve(mapping.map(this.head));
        return $99eae554af83c227$export$7d98c58ca1423246.valid($pos) ? new $99eae554af83c227$export$7d98c58ca1423246($pos, this.side) : (0, $3lIcL.Selection).near($pos);
    }
    eq(other) {
        return other instanceof $99eae554af83c227$export$7d98c58ca1423246 && other.head === this.head;
    }
    content() {
        return (0, $3xw6l.Slice).empty;
    }
    getBookmark() {
        return new $99eae554af83c227$export$afd2c0d75bc9ce6c(this.anchor);
    }
    toJSON() {
        return {
            pos: this.head,
            type: $99eae554af83c227$export$d9f9f34e18094ffd,
            side: this.side
        };
    }
}
(0, $3lIcL.Selection).jsonID($99eae554af83c227$export$d9f9f34e18094ffd, $99eae554af83c227$export$7d98c58ca1423246);
class $99eae554af83c227$export$afd2c0d75bc9ce6c {
    constructor(pos){
        this.pos = pos;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    map(mapping) {
        return new $99eae554af83c227$export$afd2c0d75bc9ce6c(mapping.map(this.pos));
    }
    resolve(doc) {
        const $pos = doc.resolve(this.pos);
        return $99eae554af83c227$export$7d98c58ca1423246.valid($pos) ? new $99eae554af83c227$export$7d98c58ca1423246($pos) : (0, $3lIcL.Selection).near($pos);
    }
}

});
parcelRegister("8TSsQ", function(module, exports) {
$parcel$export(module.exports, "isValidTargetNode", () => $54676098617ff86f$export$b485b49b5e1715ef);

var $cm19r = parcelRequire("cm19r");
const $54676098617ff86f$export$b485b49b5e1715ef = (node)=>{
    return !!node && !(0, $cm19r.isIgnored)(node);
};

});
parcelRegister("cm19r", function(module, exports) {
$parcel$export(module.exports, "isIgnored", () => $d6040c4eb752c505$export$ac3f691269cd6d9b);
// we don't show gap cursor for those nodes
const $d6040c4eb752c505$var$IGNORED_NODES = [
    'paragraph',
    'bulletList',
    'orderedList',
    'listItem',
    'taskItem',
    'decisionItem',
    'heading',
    'blockquote',
    'layoutColumn',
    'caption',
    'media',
    'extensionFrame'
];
const $d6040c4eb752c505$export$ac3f691269cd6d9b = (node)=>{
    return !!node && $d6040c4eb752c505$var$IGNORED_NODES.indexOf(node.type.name) !== -1;
};

});




parcelRegister("leZY6", function(module, exports) {
$parcel$export(module.exports, "inputRuleWithAnalytics", () => $466bcc9a564fee27$export$333ee6e3f01bb8f9);
$parcel$export(module.exports, "createWrappingJoinRule", () => $466bcc9a564fee27$export$6341edfa2d147bc);
$parcel$export(module.exports, "createRule", () => $466bcc9a564fee27$export$56e87122f905fac0);

var $lzEKq = parcelRequire("lzEKq");

var $apqw1 = parcelRequire("apqw1");

var $eZyx0 = parcelRequire("eZyx0");
const $466bcc9a564fee27$export$333ee6e3f01bb8f9 = (getPayload, analyticsApi)=>{
    return (originalRule)=>{
        const onHandlerApply = (state, tr, matchResult)=>{
            const payload = typeof getPayload === 'function' ? getPayload(state, matchResult) : getPayload;
            if (payload && payload.attributes) payload.attributes.formatSize = typeof matchResult[0] === 'string' ? matchResult[0].length : 0;
            analyticsApi?.attachAnalyticsEvent(payload)(tr);
            if (originalRule.onHandlerApply) originalRule.onHandlerApply(state, tr, matchResult);
        };
        return {
            ...originalRule,
            onHandlerApply: onHandlerApply
        };
    };
};
const $466bcc9a564fee27$export$6341edfa2d147bc = ({ match: match, nodeType: nodeType, getAttrs: getAttrs, joinPredicate: joinPredicate })=>{
    const handler = (state, match, start, end)=>{
        const attrs = (getAttrs instanceof Function ? getAttrs(match) : getAttrs) || {};
        const tr = state.tr;
        const fixedStart = Math.max(start, 1);
        tr.delete(fixedStart, end);
        const $start = tr.doc.resolve(fixedStart);
        const range = $start.blockRange();
        const wrapping = range && (0, $lzEKq.findWrapping)(range, nodeType, attrs);
        if (!wrapping || !range) return null;
        const parentNodePosMapped = tr.mapping.map(range.start);
        const parentNode = tr.doc.nodeAt(parentNodePosMapped);
        const lastWrap = wrapping[wrapping.length - 1];
        if (parentNode && lastWrap) {
            const allowedMarks = lastWrap.type.allowedMarks(parentNode.marks) || [];
            tr.setNodeMarkup(parentNodePosMapped, parentNode.type, parentNode.attrs, allowedMarks);
        }
        tr.wrap(range, wrapping);
        const before = tr.doc.resolve(fixedStart - 1).nodeBefore;
        if (before && before.type === nodeType && (0, $lzEKq.canJoin)(tr.doc, fixedStart - 1) && (!joinPredicate || joinPredicate(match, before, (0, $eZyx0.JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST).JOINED_TO_LIST_ABOVE))) tr.join(fixedStart - 1);
        return tr;
    };
    return $466bcc9a564fee27$export$56e87122f905fac0(match, handler);
};
const $466bcc9a564fee27$export$56e87122f905fac0 = (match, handler, allowsBackwardMatch = false)=>{
    return {
        match: match,
        handler: handler,
        onHandlerApply: (_state, tr)=>{
            (0, $apqw1.closeHistory)(tr);
        },
        allowsBackwardMatch: allowsBackwardMatch
    };
};

});
parcelRegister("apqw1", function(module, exports) {
$parcel$export(module.exports, "closeHistory", () => $6534b921447e7d51$export$181a649d919c589e);
$parcel$export(module.exports, "history", () => $6534b921447e7d51$export$55abd4691b317664);
$parcel$export(module.exports, "undo", () => $6534b921447e7d51$export$21f930c44940fd98);
$parcel$export(module.exports, "redo", () => $6534b921447e7d51$export$1688e416fee0a49e);

var $7VXOm = parcelRequire("7VXOm");

var $3lIcL = parcelRequire("3lIcL");

var $lzEKq = parcelRequire("lzEKq");

var $eGOwo = parcelRequire("eGOwo");

var $6rJ4n = parcelRequire("6rJ4n");
// ProseMirror's history isn't simply a way to roll back to a previous
// state, because ProseMirror supports applying changes without adding
// them to the history (for example during collaboration).
//
// To this end, each 'Branch' (one for the undo history and one for
// the redo history) keeps an array of 'Items', which can optionally
// hold a step (an actual undoable change), and always hold a position
// map (which is needed to move changes below them to apply to the
// current document).
//
// An item that has both a step and a selection bookmark is the start
// of an 'event' — a group of changes that will be undone or redone at
// once. (It stores only the bookmark, since that way we don't have to
// provide a document until the selection is actually applied, which
// is useful when compressing.)
// Used to schedule history compression
const $6534b921447e7d51$var$max_empty_items = 500;
class $6534b921447e7d51$var$Branch {
    constructor(items, eventCount){
        this.items = items;
        this.eventCount = eventCount;
    }
    // Pop the latest event off the branch's history and apply it
    // to a document transform.
    popEvent(state, preserveItems) {
        // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        if (this.eventCount == 0) return null;
        let end = this.items.length;
        for(;; end--){
            const next = this.items.get(end - 1);
            if (next.selection) {
                --end;
                break;
            }
        }
        let remap, mapFrom;
        if (preserveItems) {
            remap = this.remapping(end, this.items.length);
            mapFrom = remap.maps.length;
        }
        const transform = state.tr;
        let selection, remaining;
        const addAfter = [], addBefore = [];
        this.items.forEach((item, i)=>{
            if (!item.step) {
                if (!remap) {
                    remap = this.remapping(end, i + 1);
                    mapFrom = remap.maps.length;
                }
                // To match existing behaviour of prosemirror-history
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                mapFrom--;
                addBefore.push(item);
                return;
            }
            if (remap) {
                addBefore.push(new $6534b921447e7d51$var$Item(item.map));
                const step = item.step.map(remap.slice(mapFrom));
                let map;
                if (step && transform.maybeStep(step).doc) {
                    map = transform.mapping.maps[transform.mapping.maps.length - 1];
                    addAfter.push(new $6534b921447e7d51$var$Item(map, undefined, undefined, addAfter.length + addBefore.length));
                }
                // To match existing behaviour of prosemirror-history
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                mapFrom--;
                if (map) remap.appendMap(map, mapFrom);
            } else transform.maybeStep(item.step);
            if (item.selection) {
                selection = remap ? item.selection.map(remap.slice(mapFrom)) : item.selection;
                remaining = new $6534b921447e7d51$var$Branch(this.items.slice(0, end).append(addBefore.reverse().concat(addAfter)), this.eventCount - 1);
                return false;
            }
        }, this.items.length, 0);
        // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return {
            remaining: remaining,
            transform: transform,
            selection: selection
        };
    }
    // Create a new branch with the given transform added.
    addTransform(transform, selection, histOptions, preserveItems) {
        const newItems = [];
        let eventCount = this.eventCount;
        let oldItems = this.items, lastItem = !preserveItems && oldItems.length ? oldItems.get(oldItems.length - 1) : null;
        for(let i = 0; i < transform.steps.length; i++){
            const step = transform.steps[i].invert(transform.docs[i]);
            let item = new $6534b921447e7d51$var$Item(transform.mapping.maps[i], step, selection), merged;
            // To match existing behaviour of prosemirror-history
            // eslint-disable-next-line no-cond-assign
            if (merged = lastItem && lastItem.merge(item)) {
                item = merged;
                if (i) newItems.pop();
                else oldItems = oldItems.slice(0, oldItems.length - 1);
            }
            newItems.push(item);
            if (selection) {
                eventCount++;
                selection = undefined;
            }
            if (!preserveItems) lastItem = item;
        }
        const overflow = eventCount - histOptions.depth;
        if (overflow > $6534b921447e7d51$var$DEPTH_OVERFLOW) {
            oldItems = $6534b921447e7d51$var$cutOffEvents(oldItems, overflow);
            eventCount -= overflow;
        }
        return new $6534b921447e7d51$var$Branch(oldItems.append(newItems), eventCount);
    }
    remapping(from, to) {
        const maps = new (0, $lzEKq.Mapping)();
        this.items.forEach((item, i)=>{
            const mirrorPos = item.mirrorOffset != null && i - item.mirrorOffset >= from ? maps.maps.length - item.mirrorOffset : undefined;
            maps.appendMap(item.map, mirrorPos);
        }, from, to);
        return maps;
    }
    addMaps(array) {
        // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        if (this.eventCount == 0) return this;
        return new $6534b921447e7d51$var$Branch(this.items.append(array.map((map)=>new $6534b921447e7d51$var$Item(map))), this.eventCount);
    }
    // When the collab module receives remote changes, the history has
    // to know about those, so that it can adjust the steps that were
    // rebased on top of the remote changes, and include the position
    // maps for the remote changes in its array of items.
    rebased(rebasedTransform, rebasedCount) {
        if (!this.eventCount) return this;
        const rebasedItems = [], start = Math.max(0, this.items.length - rebasedCount);
        const mapping = rebasedTransform.mapping;
        let newUntil = rebasedTransform.steps.length;
        let eventCount = this.eventCount;
        this.items.forEach((item)=>{
            if (item.selection) eventCount--;
        }, start);
        let iRebased = rebasedCount;
        this.items.forEach((item)=>{
            const pos = mapping.getMirror(--iRebased);
            // To match existing behaviour of prosemirror-history
            // eslint-disable-next-line eqeqeq
            if (pos == null) return;
            newUntil = Math.min(newUntil, pos);
            const map = mapping.maps[pos];
            if (item.step) {
                const step = rebasedTransform.steps[pos].invert(rebasedTransform.docs[pos]);
                const selection = item.selection && item.selection.map(mapping.slice(iRebased + 1, pos));
                if (selection) eventCount++;
                rebasedItems.push(new $6534b921447e7d51$var$Item(map, step, selection));
            } else rebasedItems.push(new $6534b921447e7d51$var$Item(map));
        }, start);
        const newMaps = [];
        for(let i = rebasedCount; i < newUntil; i++)newMaps.push(new $6534b921447e7d51$var$Item(mapping.maps[i]));
        const items = this.items.slice(0, start).append(newMaps).append(rebasedItems);
        let branch = new $6534b921447e7d51$var$Branch(items, eventCount);
        if (branch.emptyItemCount() > $6534b921447e7d51$var$max_empty_items) branch = branch.compress(this.items.length - rebasedItems.length);
        return branch;
    }
    emptyItemCount() {
        let count = 0;
        this.items.forEach((item)=>{
            if (!item.step) count++;
        });
        return count;
    }
    // Compressing a branch means rewriting it to push the air (map-only
    // items) out. During collaboration, these naturally accumulate
    // because each remote change adds one. The `upto` argument is used
    // to ensure that only the items below a given level are compressed,
    // because `rebased` relies on a clean, untouched set of items in
    // order to associate old items with rebased steps.
    compress(upto = this.items.length) {
        const remap = this.remapping(0, upto);
        let mapFrom = remap.maps.length;
        const items = [];
        let events = 0;
        this.items.forEach((item, i)=>{
            if (i >= upto) {
                items.push(item);
                if (item.selection) events++;
            } else if (item.step) {
                const step = item.step.map(remap.slice(mapFrom)), map = step && step.getMap();
                mapFrom--;
                if (map) remap.appendMap(map, mapFrom);
                if (step) {
                    const selection = item.selection && item.selection.map(remap.slice(mapFrom));
                    if (selection) events++;
                    // To match existing behaviour of prosemirror-history
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const newItem = new $6534b921447e7d51$var$Item(map.invert(), step, selection);
                    let merged;
                    const last = items.length - 1;
                    // To match existing behaviour of prosemirror-history
                    // eslint-disable-next-line no-cond-assign
                    if (merged = items.length && items[last].merge(newItem)) items[last] = merged;
                    else items.push(newItem);
                }
            } else if (item.map) mapFrom--;
        }, this.items.length, 0);
        return new $6534b921447e7d51$var$Branch((0, $7VXOm.default).from(items.reverse()), events);
    }
    static{
        this.empty = new $6534b921447e7d51$var$Branch((0, $7VXOm.default).empty, 0);
    }
}
function $6534b921447e7d51$var$cutOffEvents(items, n) {
    let cutPoint;
    items.forEach((item, i)=>{
        // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        if (item.selection && n-- == 0) {
            cutPoint = i;
            return false;
        }
    });
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return items.slice(cutPoint);
}
class $6534b921447e7d51$var$Item {
    constructor(// The (forward) step map for this item.
    map, // The inverted step
    step, // If this is non-null, this item is the start of a group, and
    // this selection is the starting selection for the group (the one
    // that was active before the first step was applied)
    selection, // If this item is the inverse of a previous mapping on the stack,
    // this points at the inverse's offset
    mirrorOffset){
        this.map = map;
        this.step = step;
        this.selection = selection;
        this.mirrorOffset = mirrorOffset;
    }
    merge(other) {
        if (this.step && other.step && !other.selection) {
            const step = other.step.merge(this.step);
            if (step) return new $6534b921447e7d51$var$Item(step.getMap().invert(), step, this.selection);
        }
    }
}
// The value of the state field that tracks undo/redo history for that
// state. Will be stored in the plugin state when the history plugin
// is active.
class $6534b921447e7d51$var$HistoryState {
    constructor(done, undone, prevRanges, prevTime, prevComposition, /**
		 * ===
		 * FORK ADDITION START
		 * Allow for "history slicing" which groups together changes regardless of time / position adjacency
		 */ historySliceActive, trackedSteps, selectionBookmark){
        this.done = done;
        this.undone = undone;
        this.prevRanges = prevRanges;
        this.prevTime = prevTime;
        this.prevComposition = prevComposition;
        this.historySliceActive = historySliceActive;
        this.trackedSteps = trackedSteps;
        this.selectionBookmark = selectionBookmark;
    }
}
const $6534b921447e7d51$var$DEPTH_OVERFLOW = 20;
// Record a transformation in undo history.
function $6534b921447e7d51$var$applyTransaction(history, state, tr, options) {
    const historyTr = tr.getMeta($6534b921447e7d51$var$historyKey);
    let rebased;
    if (historyTr) return historyTr.historyState;
    /**
	 * ===
	 * FORK ADDITION START
	 * If history slicing is active, we want to continue the current slice
	 */ if ((0, $eGOwo.fg)('platform_editor_ai_aifc_undo_redo')) {
        if ((tr.getMeta('startHistorySlice') === true || history?.historySliceActive) && tr.getMeta('endHistorySlice') !== true) {
            if (tr.getMeta('addToHistory') === false) {
                // For addToHistory=false transactions during a slice, we need to:
                // 1. Update the mapping for done/undone branches
                // 2. Map the existing steps
                // 3. Update the document to rebaseline
                const mappedRanges = history.prevRanges ? $6534b921447e7d51$var$mapRanges(history.prevRanges, tr.mapping) : null;
                return new $6534b921447e7d51$var$HistoryState(history.done.addMaps(tr.mapping.maps), history.undone.addMaps(tr.mapping.maps), mappedRanges, history.prevTime, history.prevComposition, true, (0, $6rJ4n.mapInvertableSteps)(history.trackedSteps, tr), history.selectionBookmark);
            }
            const startHistorySlice = tr.getMeta('startHistorySlice') === true;
            const newTrackedSteps = [
                ...history.trackedSteps || [],
                ...tr.steps.map((s, idx)=>new (0, $6rJ4n.InvertableStep)(s, s.invert(tr.docs[idx])))
            ];
            const mappedRanges = history.prevRanges ? $6534b921447e7d51$var$mapRanges(history.prevRanges, tr.mapping) : null;
            return new $6534b921447e7d51$var$HistoryState(history.done, startHistorySlice ? $6534b921447e7d51$var$Branch.empty : history.undone, mappedRanges, history.prevTime, history.prevComposition, true, newTrackedSteps, startHistorySlice ? state.selection.getBookmark() : history.selectionBookmark);
        } else if (tr.getMeta('endHistorySlice') === true && history.historySliceActive) {
            const trackedSteps = history.historySliceActive ? history.trackedSteps || [] : [];
            // Create transform that represents the changes made during the slice
            // Use the original slice document as the base
            const transform = (0, $6rJ4n.createTransformFromSteps)(trackedSteps, tr.doc);
            const mappedRanges = history.prevRanges ? $6534b921447e7d51$var$mapRanges(history.prevRanges, tr.mapping) : null;
            return new $6534b921447e7d51$var$HistoryState(history.done.addMaps(tr.mapping.maps).addTransform(transform, history.selectionBookmark, options, $6534b921447e7d51$var$mustPreserveItems(state)), history.undone.addMaps(tr.mapping.maps), mappedRanges, history.prevTime, history.prevComposition);
        }
    }
    /**
	 * FORK ADDITION END
	 * ===
	 */ if (tr.getMeta($6534b921447e7d51$var$closeHistoryKey)) history = new $6534b921447e7d51$var$HistoryState(history.done, history.undone, null, 0, -1);
    const appended = tr.getMeta('appendedTransaction');
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line eqeqeq
    if (tr.steps.length == 0) return history;
    else if (appended && appended.getMeta($6534b921447e7d51$var$historyKey)) {
        if (appended.getMeta($6534b921447e7d51$var$historyKey).redo) return new $6534b921447e7d51$var$HistoryState(history.done.addTransform(tr, undefined, options, $6534b921447e7d51$var$mustPreserveItems(state)), history.undone, $6534b921447e7d51$var$rangesFor(tr.mapping.maps), history.prevTime, history.prevComposition);
        else return new $6534b921447e7d51$var$HistoryState(history.done, history.undone.addTransform(tr, undefined, options, $6534b921447e7d51$var$mustPreserveItems(state)), null, history.prevTime, history.prevComposition);
    } else if (tr.getMeta('addToHistory') !== false && !(appended && appended.getMeta('addToHistory') === false)) {
        // Group transforms that occur in quick succession into one event.
        const composition = tr.getMeta('composition');
        const newGroup = // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        history.prevTime == 0 || !appended && // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        history.prevComposition != composition && (history.prevTime < (tr.time || 0) - options.newGroupDelay || // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        !$6534b921447e7d51$var$isAdjacentTo(tr, history.prevRanges));
        const prevRanges = appended ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $6534b921447e7d51$var$mapRanges(history.prevRanges, tr.mapping) : $6534b921447e7d51$var$rangesFor(tr.mapping.maps);
        return new $6534b921447e7d51$var$HistoryState(history.done.addTransform(tr, newGroup ? state.selection.getBookmark() : undefined, options, $6534b921447e7d51$var$mustPreserveItems(state)), $6534b921447e7d51$var$Branch.empty, prevRanges, tr.time, // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        composition == null ? history.prevComposition : composition);
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line no-cond-assign
    } else if (rebased = tr.getMeta('rebased')) // Used by the collab module to tell the history that some of its
    // content has been rebased.
    return new $6534b921447e7d51$var$HistoryState(history.done.rebased(tr, rebased), history.undone.rebased(tr, rebased), // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    $6534b921447e7d51$var$mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
    else return new $6534b921447e7d51$var$HistoryState(history.done.addMaps(tr.mapping.maps), history.undone.addMaps(tr.mapping.maps), // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    $6534b921447e7d51$var$mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
}
function $6534b921447e7d51$var$isAdjacentTo(transform, prevRanges) {
    if (!prevRanges) return false;
    if (!transform.docChanged) return true;
    let adjacent = false;
    transform.mapping.maps[0].forEach((start, end)=>{
        for(let i = 0; i < prevRanges.length; i += 2)if (start <= prevRanges[i + 1] && end >= prevRanges[i]) adjacent = true;
    });
    return adjacent;
}
function $6534b921447e7d51$var$rangesFor(maps) {
    const result = [];
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line eqeqeq
    for(let i = maps.length - 1; i >= 0 && result.length == 0; i--)maps[i].forEach((_from, _to, from, to)=>result.push(from, to));
    return result;
}
function $6534b921447e7d51$var$mapRanges(ranges, mapping) {
    if (!ranges) return null;
    const result = [];
    for(let i = 0; i < ranges.length; i += 2){
        const from = mapping.map(ranges[i], 1), to = mapping.map(ranges[i + 1], -1);
        if (from <= to) result.push(from, to);
    }
    return result;
}
// Apply the latest event from one branch to the document and shift the event
// onto the other branch.
function $6534b921447e7d51$var$histTransaction(history, state, redo) {
    const preserveItems = $6534b921447e7d51$var$mustPreserveItems(state);
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-explicit-any
    const histOptions = $6534b921447e7d51$var$historyKey.get(state).spec.config;
    const pop = (redo ? history.undone : history.done).popEvent(state, preserveItems);
    if (!pop) return null;
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const selection = pop.selection.resolve(pop.transform.doc);
    const added = (redo ? history.done : history.undone).addTransform(pop.transform, state.selection.getBookmark(), histOptions, preserveItems);
    /**
	 * ===
	 * FORK ADDITION START
	 * If history slicing is active when we undo/redo, when we perform an undo/redo we want to
	 * map and keep the relevant steps in the new history state
	 */ const newHist = history.historySliceActive && (0, $eGOwo.fg)('platform_editor_ai_aifc_undo_redo') ? new $6534b921447e7d51$var$HistoryState(redo ? added : pop.remaining, redo ? pop.remaining : added, null, 0, -1, history.historySliceActive, (0, $6rJ4n.mapInvertableSteps)(history.trackedSteps, pop.transform), history.selectionBookmark?.map(pop.transform.mapping)) : new $6534b921447e7d51$var$HistoryState(redo ? added : pop.remaining, redo ? pop.remaining : added, null, 0, -1);
    /**
	 * FORK ADDITION END
	 * ===
	 */ return pop.transform.setSelection(selection).setMeta($6534b921447e7d51$var$historyKey, {
        redo: redo,
        historyState: newHist
    });
}
let $6534b921447e7d51$var$cachedPreserveItems = false, $6534b921447e7d51$var$cachedPreserveItemsPlugins = null;
// Check whether any plugin in the given state has a
// `historyPreserveItems` property in its spec, in which case we must
// preserve steps exactly as they came in, so that they can be
// rebased.
function $6534b921447e7d51$var$mustPreserveItems(state) {
    const plugins = state.plugins;
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line eqeqeq
    if ($6534b921447e7d51$var$cachedPreserveItemsPlugins != plugins) {
        $6534b921447e7d51$var$cachedPreserveItems = false;
        $6534b921447e7d51$var$cachedPreserveItemsPlugins = plugins;
        for(let i = 0; i < plugins.length; i++)// To match existing behaviour of prosemirror-history
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (plugins[i].spec.historyPreserveItems) {
            $6534b921447e7d51$var$cachedPreserveItems = true;
            break;
        }
    }
    return $6534b921447e7d51$var$cachedPreserveItems;
}
function $6534b921447e7d51$export$181a649d919c589e(tr) {
    return tr.setMeta($6534b921447e7d51$var$closeHistoryKey, true);
}
const $6534b921447e7d51$var$historyKey = new (0, $3lIcL.PluginKey)('history');
const $6534b921447e7d51$var$closeHistoryKey = new (0, $3lIcL.PluginKey)('closeHistory');
function $6534b921447e7d51$export$55abd4691b317664(config = {}) {
    config = {
        depth: config.depth || 100,
        newGroupDelay: config.newGroupDelay || 500
    };
    return new (0, $3lIcL.Plugin)({
        key: $6534b921447e7d51$var$historyKey,
        state: {
            init () {
                return new $6534b921447e7d51$var$HistoryState($6534b921447e7d51$var$Branch.empty, $6534b921447e7d51$var$Branch.empty, null, 0, -1);
            },
            apply (tr, hist, state) {
                return $6534b921447e7d51$var$applyTransaction(hist, state, tr, config);
            }
        },
        config: config,
        props: {
            handleDOMEvents: {
                beforeinput (view, e) {
                    const inputType = e.inputType;
                    const command = // To match existing behaviour of prosemirror-history
                    // eslint-disable-next-line eqeqeq
                    inputType == 'historyUndo' ? $6534b921447e7d51$export$21f930c44940fd98 : inputType == 'historyRedo' ? $6534b921447e7d51$export$1688e416fee0a49e : null;
                    if (!command || !view.editable) return false;
                    e.preventDefault();
                    return command(view.state, view.dispatch);
                }
            }
        }
    });
}
function $6534b921447e7d51$var$buildCommand(redo, scroll) {
    return (state, dispatch)=>{
        const hist = $6534b921447e7d51$var$historyKey.getState(state);
        // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        if (!hist || (redo ? hist.undone : hist.done).eventCount == 0) return false;
        if (dispatch) {
            const tr = $6534b921447e7d51$var$histTransaction(hist, state, redo);
            if (tr) dispatch(scroll ? tr.scrollIntoView() : tr);
        }
        return true;
    };
}
const $6534b921447e7d51$export$21f930c44940fd98 = $6534b921447e7d51$var$buildCommand(false, true);
const $6534b921447e7d51$export$1688e416fee0a49e = $6534b921447e7d51$var$buildCommand(true, true);
const $6534b921447e7d51$export$24b5d280435f3a3f = $6534b921447e7d51$var$buildCommand(false, false);
const $6534b921447e7d51$export$3774e54bae7be19b = $6534b921447e7d51$var$buildCommand(true, false);
function $6534b921447e7d51$export$f8a176c2b9a10bdb(state) {
    const hist = $6534b921447e7d51$var$historyKey.getState(state);
    return hist ? hist.done.eventCount : 0;
}
function $6534b921447e7d51$export$3ffe6b288e7d941b(state) {
    const hist = $6534b921447e7d51$var$historyKey.getState(state);
    return hist ? hist.undone.eventCount : 0;
}

});
parcelRegister("7VXOm", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c6c408b4e1a2afa$export$2e2bcd8739ae039);
var $5c6c408b4e1a2afa$var$GOOD_LEAF_SIZE = 200;
// :: class<T> A rope sequence is a persistent sequence data structure
// that supports appending, prepending, and slicing without doing a
// full copy. It is represented as a mostly-balanced tree.
var $5c6c408b4e1a2afa$var$RopeSequence = function RopeSequence() {};
$5c6c408b4e1a2afa$var$RopeSequence.prototype.append = function append(other) {
    if (!other.length) return this;
    other = $5c6c408b4e1a2afa$var$RopeSequence.from(other);
    return !this.length && other || other.length < $5c6c408b4e1a2afa$var$GOOD_LEAF_SIZE && this.leafAppend(other) || this.length < $5c6c408b4e1a2afa$var$GOOD_LEAF_SIZE && other.leafPrepend(this) || this.appendInner(other);
};
// :: (union<[T], RopeSequence<T>>) → RopeSequence<T>
// Prepend an array or other rope to this one, returning a new rope.
$5c6c408b4e1a2afa$var$RopeSequence.prototype.prepend = function prepend(other) {
    if (!other.length) return this;
    return $5c6c408b4e1a2afa$var$RopeSequence.from(other).append(this);
};
$5c6c408b4e1a2afa$var$RopeSequence.prototype.appendInner = function appendInner(other) {
    return new $5c6c408b4e1a2afa$var$Append(this, other);
};
// :: (?number, ?number) → RopeSequence<T>
// Create a rope repesenting a sub-sequence of this rope.
$5c6c408b4e1a2afa$var$RopeSequence.prototype.slice = function slice(from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    if (from >= to) return $5c6c408b4e1a2afa$var$RopeSequence.empty;
    return this.sliceInner(Math.max(0, from), Math.min(this.length, to));
};
// :: (number) → T
// Retrieve the element at the given position from this rope.
$5c6c408b4e1a2afa$var$RopeSequence.prototype.get = function get(i) {
    if (i < 0 || i >= this.length) return undefined;
    return this.getInner(i);
};
// :: ((element: T, index: number) → ?bool, ?number, ?number)
// Call the given function for each element between the given
// indices. This tends to be more efficient than looping over the
// indices and calling `get`, because it doesn't have to descend the
// tree for every element.
$5c6c408b4e1a2afa$var$RopeSequence.prototype.forEach = function forEach(f, from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    if (from <= to) this.forEachInner(f, from, to, 0);
    else this.forEachInvertedInner(f, from, to, 0);
};
// :: ((element: T, index: number) → U, ?number, ?number) → [U]
// Map the given functions over the elements of the rope, producing
// a flat array.
$5c6c408b4e1a2afa$var$RopeSequence.prototype.map = function map(f, from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    var result = [];
    this.forEach(function(elt, i) {
        return result.push(f(elt, i));
    }, from, to);
    return result;
};
// :: (?union<[T], RopeSequence<T>>) → RopeSequence<T>
// Create a rope representing the given array, or return the rope
// itself if a rope was given.
$5c6c408b4e1a2afa$var$RopeSequence.from = function from(values) {
    if (values instanceof $5c6c408b4e1a2afa$var$RopeSequence) return values;
    return values && values.length ? new $5c6c408b4e1a2afa$var$Leaf(values) : $5c6c408b4e1a2afa$var$RopeSequence.empty;
};
var $5c6c408b4e1a2afa$var$Leaf = /*@__PURE__*/ function(RopeSequence) {
    function Leaf(values) {
        RopeSequence.call(this);
        this.values = values;
    }
    if (RopeSequence) Leaf.__proto__ = RopeSequence;
    Leaf.prototype = Object.create(RopeSequence && RopeSequence.prototype);
    Leaf.prototype.constructor = Leaf;
    var prototypeAccessors = {
        length: {
            configurable: true
        },
        depth: {
            configurable: true
        }
    };
    Leaf.prototype.flatten = function flatten() {
        return this.values;
    };
    Leaf.prototype.sliceInner = function sliceInner(from, to) {
        if (from == 0 && to == this.length) return this;
        return new Leaf(this.values.slice(from, to));
    };
    Leaf.prototype.getInner = function getInner(i) {
        return this.values[i];
    };
    Leaf.prototype.forEachInner = function forEachInner(f, from, to, start) {
        for(var i = from; i < to; i++){
            if (f(this.values[i], start + i) === false) return false;
        }
    };
    Leaf.prototype.forEachInvertedInner = function forEachInvertedInner(f, from, to, start) {
        for(var i = from - 1; i >= to; i--){
            if (f(this.values[i], start + i) === false) return false;
        }
    };
    Leaf.prototype.leafAppend = function leafAppend(other) {
        if (this.length + other.length <= $5c6c408b4e1a2afa$var$GOOD_LEAF_SIZE) return new Leaf(this.values.concat(other.flatten()));
    };
    Leaf.prototype.leafPrepend = function leafPrepend(other) {
        if (this.length + other.length <= $5c6c408b4e1a2afa$var$GOOD_LEAF_SIZE) return new Leaf(other.flatten().concat(this.values));
    };
    prototypeAccessors.length.get = function() {
        return this.values.length;
    };
    prototypeAccessors.depth.get = function() {
        return 0;
    };
    Object.defineProperties(Leaf.prototype, prototypeAccessors);
    return Leaf;
}($5c6c408b4e1a2afa$var$RopeSequence);
// :: RopeSequence
// The empty rope sequence.
$5c6c408b4e1a2afa$var$RopeSequence.empty = new $5c6c408b4e1a2afa$var$Leaf([]);
var $5c6c408b4e1a2afa$var$Append = /*@__PURE__*/ function(RopeSequence) {
    function Append(left, right) {
        RopeSequence.call(this);
        this.left = left;
        this.right = right;
        this.length = left.length + right.length;
        this.depth = Math.max(left.depth, right.depth) + 1;
    }
    if (RopeSequence) Append.__proto__ = RopeSequence;
    Append.prototype = Object.create(RopeSequence && RopeSequence.prototype);
    Append.prototype.constructor = Append;
    Append.prototype.flatten = function flatten() {
        return this.left.flatten().concat(this.right.flatten());
    };
    Append.prototype.getInner = function getInner(i) {
        return i < this.left.length ? this.left.get(i) : this.right.get(i - this.left.length);
    };
    Append.prototype.forEachInner = function forEachInner(f, from, to, start) {
        var leftLen = this.left.length;
        if (from < leftLen && this.left.forEachInner(f, from, Math.min(to, leftLen), start) === false) return false;
        if (to > leftLen && this.right.forEachInner(f, Math.max(from - leftLen, 0), Math.min(this.length, to) - leftLen, start + leftLen) === false) return false;
    };
    Append.prototype.forEachInvertedInner = function forEachInvertedInner(f, from, to, start) {
        var leftLen = this.left.length;
        if (from > leftLen && this.right.forEachInvertedInner(f, from - leftLen, Math.max(to, leftLen) - leftLen, start + leftLen) === false) return false;
        if (to < leftLen && this.left.forEachInvertedInner(f, Math.min(from, leftLen), to, start) === false) return false;
    };
    Append.prototype.sliceInner = function sliceInner(from, to) {
        if (from == 0 && to == this.length) return this;
        var leftLen = this.left.length;
        if (to <= leftLen) return this.left.slice(from, to);
        if (from >= leftLen) return this.right.slice(from - leftLen, to - leftLen);
        return this.left.slice(from, leftLen).append(this.right.slice(0, to - leftLen));
    };
    Append.prototype.leafAppend = function leafAppend(other) {
        var inner = this.right.leafAppend(other);
        if (inner) return new Append(this.left, inner);
    };
    Append.prototype.leafPrepend = function leafPrepend(other) {
        var inner = this.left.leafPrepend(other);
        if (inner) return new Append(inner, this.right);
    };
    Append.prototype.appendInner = function appendInner(other) {
        if (this.left.depth >= Math.max(this.right.depth, other.depth) + 1) return new Append(this.left, new Append(this.right, other));
        return new Append(this, other);
    };
    return Append;
}($5c6c408b4e1a2afa$var$RopeSequence);
var $5c6c408b4e1a2afa$export$2e2bcd8739ae039 = $5c6c408b4e1a2afa$var$RopeSequence;

});

parcelRegister("6rJ4n", function(module, exports) {
$parcel$export(module.exports, "InvertableStep", () => $38ee939df848c8d1$export$ebdc1f934f4dd665);
$parcel$export(module.exports, "createTransformFromSteps", () => $38ee939df848c8d1$export$6137dcc98f08e76);
$parcel$export(module.exports, "mapInvertableSteps", () => $38ee939df848c8d1$export$3cddda3829daa1af);

var $lzEKq = parcelRequire("lzEKq");
class $38ee939df848c8d1$export$ebdc1f934f4dd665 {
    constructor(step, inverted){
        this.step = step;
        this.inverted = inverted;
    }
}
function $38ee939df848c8d1$export$6137dcc98f08e76(steps, finalDoc) {
    for (const step of steps.slice().reverse())try {
        const result = step.inverted.apply(finalDoc);
        if (result.failed === null && result.doc) finalDoc = result.doc;
    } catch (e) {
    //TODO: EDITOR-2471 - Log the error
    }
    let tr = new (0, $lzEKq.Transform)(finalDoc);
    for (const step of steps)try {
        tr = tr.step(step.step);
    } catch (e) {
    //TODO: EDITOR-2471 - Log the error
    }
    return tr;
}
function $38ee939df848c8d1$export$3cddda3829daa1af(steps, tr) {
    if (steps === undefined) return undefined;
    return steps.map((step)=>{
        const newStep = step.step.map(tr.mapping);
        const newInvertedStep = step.inverted.map(tr.mapping);
        if (newStep && newInvertedStep) return new $38ee939df848c8d1$export$ebdc1f934f4dd665(newStep, newInvertedStep);
        return undefined;
    }).filter((s)=>!!s);
}

});


parcelRegister("eZyx0", function(module, exports) {
$parcel$export(module.exports, "DELETE_DIRECTION", () => $e60a8d1b964492b5$export$a9b79b94eb5ffad);
$parcel$export(module.exports, "LIST_TEXT_SCENARIOS", () => $e60a8d1b964492b5$export$c3c848735ee9408a);
$parcel$export(module.exports, "JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST", () => $e60a8d1b964492b5$export$43e6a678b13eb45f);
$parcel$export(module.exports, "OUTDENT_SCENARIOS", () => $e60a8d1b964492b5$export$ed4ba8ac11f6cbc8);
var $e60a8d1b964492b5$export$a9b79b94eb5ffad = /*#__PURE__*/ function(DELETE_DIRECTION) {
    DELETE_DIRECTION["BACKWARD"] = "backward";
    DELETE_DIRECTION["FORWARD"] = "forward";
    return DELETE_DIRECTION;
}({});
var $e60a8d1b964492b5$export$c3c848735ee9408a = /*#__PURE__*/ function(LIST_TEXT_SCENARIOS) {
    LIST_TEXT_SCENARIOS["JOIN_SIBLINGS"] = "joinSiblings";
    LIST_TEXT_SCENARIOS["JOIN_DESCENDANT_TO_PARENT"] = "joinDescendantToParent";
    LIST_TEXT_SCENARIOS["JOIN_TO_SIBLING_DESCENDANT"] = "joinToSiblingDescendant";
    LIST_TEXT_SCENARIOS["JOIN_PARAGRAPH_WITH_LIST"] = "joinParagraphWithList";
    LIST_TEXT_SCENARIOS["JOIN_PARENT_SIBLING_TO_PARENT_CHILD"] = "joinParentSiblingToParentChild";
    LIST_TEXT_SCENARIOS["JOIN_LIST_ITEM_WITH_PARAGRAPH"] = "joinListItemWithParagraph";
    return LIST_TEXT_SCENARIOS;
}({});
var $e60a8d1b964492b5$export$43e6a678b13eb45f = /*#__PURE__*/ function(JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST) {
    JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST["NO_JOIN"] = "noJoin";
    JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST["JOINED_TO_LIST_ABOVE"] = "joinedToListAbove";
    JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST["JOINED_TO_LIST_BELOW"] = "joinedToListBelow";
    return JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST;
}({});
var $e60a8d1b964492b5$export$ed4ba8ac11f6cbc8 = /*#__PURE__*/ function(OUTDENT_SCENARIOS) {
    OUTDENT_SCENARIOS["SPLIT_LIST"] = "splitList";
    return OUTDENT_SCENARIOS;
}({});

});


parcelRegister("3vP7W", function(module, exports) {
$parcel$export(module.exports, "dedupe", () => $2f17aa2200094e4c$export$f3a259b74a77132f);
function $2f17aa2200094e4c$export$f3a259b74a77132f(list = [], iteratee = (p)=>p) {
    /**
              .,
    .      _,'f----.._
    |\ ,-'"/  |     ,'
    |,_  ,--.      /
    /,-. ,'`.     (_
    f  o|  o|__     "`-.
    ,-._.,--'_ `.   _.,-`
    `"' ___.,'` j,-'
      `-.__.,--'
    Gotta go fast!
 */ const seen = new Set();
    list.forEach((l)=>seen.add(iteratee(l)));
    return list.filter((l)=>{
        const it = iteratee(l);
        if (seen.has(it)) {
            seen.delete(it);
            return true;
        }
        return false;
    });
}

});

parcelRegister("dqHDB", function(module, exports) {
$parcel$export(module.exports, "createWrapSelectionTransaction", () => $58cb4f2c5bda693a$export$d5c308539c2b2123);

var $3lIcL = parcelRequire("3lIcL");

var $lzEKq = parcelRequire("lzEKq");

var $BmspC = parcelRequire("BmspC");

var $5Z3Rm = parcelRequire("5Z3Rm");
function $58cb4f2c5bda693a$export$d5c308539c2b2123({ state: state, type: type, nodeAttributes: nodeAttributes }) {
    let { tr: tr } = state;
    const { alignment: alignment, indentation: indentation } = state.schema.marks;
    /** Alignment or Indentation is not valid inside block types */ const removeAlignTr = (0, $5Z3Rm.removeBlockMarks)(state, [
        alignment,
        indentation
    ]);
    tr = removeAlignTr || tr;
    /**Get range and wrapping needed for the selection*/ const { range: range, wrapping: wrapping } = $58cb4f2c5bda693a$export$656aa714448bfa8a(state, type, nodeAttributes);
    if (wrapping) tr.wrap(range, wrapping).scrollIntoView();
    else /** We always want to append a block type */ (0, $BmspC.safeInsert)(type.createAndFill(nodeAttributes))(tr).scrollIntoView();
    return tr;
}
function $58cb4f2c5bda693a$export$656aa714448bfa8a(state, type, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
nodeAttributes) {
    const { $from: $from, $to: $to, from: from } = state.selection;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let range = $from.blockRange($to);
    const isMediaSelection = state.selection instanceof (0, $3lIcL.NodeSelection) && state.selection.node.type === state.schema.nodes.media;
    /**
	 * To wrap a media group we need to start the range from one position
	 * before a media selection's from position.
	 */ if (isMediaSelection) {
        const prev = from - 1;
        range = state.doc.resolve(from > 0 ? prev : from).blockRange($to);
    }
    let isAllowedChild = true;
    /**
	 * Added a check to avoid wrapping codeblock
	 */ if (state.selection.empty) state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
        if (!isAllowedChild) return false;
        return isAllowedChild = node.type !== state.schema.nodes.codeBlock;
    });
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const wrapping = isAllowedChild && range && (0, $lzEKq.findWrapping)(range, type, nodeAttributes);
    return {
        range: range,
        wrapping: wrapping
    };
}

});

parcelRegister("kMoqb", function(module, exports) {
$parcel$export(module.exports, "transformNodeIntoListItem", () => $00404095a85c8de8$export$f4c81471ccea5042);

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");

var $fCXIH = parcelRequire("fCXIH");
// Taken from `editor-plugin-content-insertion`
function $00404095a85c8de8$var$setSelectionToValidTextNode(tr, node, from) {
    const sliceInserted = (0, $3xw6l.Slice).maxOpen((0, $3xw6l.Fragment).from(node));
    const openPosition = Math.min(from + (node.isAtom ? node.nodeSize : sliceInserted.openStart), tr.doc.content.size);
    const FORWARD_DIRECTION = 1;
    const nextSelection = (0, $3lIcL.TextSelection).findFrom(tr.doc.resolve(openPosition), FORWARD_DIRECTION, true);
    if (nextSelection) return tr.setSelection(nextSelection);
}
function $00404095a85c8de8$export$f4c81471ccea5042(tr, node) {
    const { $to: $to, $from: $from, to: to, from: from } = tr.selection;
    const { orderedList: orderedList, bulletList: bulletList, listItem: listItem } = tr.doc.type.schema.nodes;
    const startLinePosition = $from.start();
    const parentStartPosition = $from.depth === 0 ? 0 : $from.before();
    // Setting the start position
    const startMapped = startLinePosition === from ? parentStartPosition : from;
    // Selected nodes
    const selectionParentListItemNode = (0, $BmspC.findParentNodeOfType)(listItem)(tr.selection);
    const selectionParentListNodeWithPos = (0, $BmspC.findParentNodeOfType)([
        bulletList,
        orderedList
    ])(tr.selection);
    const selectionParentListNode = selectionParentListNodeWithPos?.node;
    if (!selectionParentListNodeWithPos) return tr;
    // Offsets
    const listWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth + 1; // difference in depth between to position and list node
    const listItemWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth; // difference in depth between to position and list item node
    // Anything to do with nested lists should safeInsert and not be handled here
    const grandParentListNode = (0, $BmspC.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(selectionParentListNodeWithPos.pos), [
        bulletList,
        orderedList
    ]);
    const selectionIsInNestedList = !!grandParentListNode;
    let selectedListItemHasNestedList = false;
    selectionParentListItemNode?.node.content.forEach((child)=>{
        if ((0, $fCXIH.isListNode)(child)) selectedListItemHasNestedList = true;
    });
    if (selectedListItemHasNestedList || selectionIsInNestedList) return (0, $BmspC.safeInsert)(node)(tr).scrollIntoView();
    // Check if node after the insert position is listItem
    const isNodeAfterInsertPositionIsListItem = tr.doc.nodeAt(to + listItemWrappingOffset)?.type === listItem;
    let replaceTo;
    if (isNodeAfterInsertPositionIsListItem) replaceTo = to + listItemWrappingOffset;
    else if (!isNodeAfterInsertPositionIsListItem) replaceTo = to;
    else replaceTo = to + listWrappingOffset;
    // handle the insertion of the slice
    tr.replaceWith(startMapped, replaceTo, node).scrollIntoView();
    // Get the next list items position (used later to find the split out ordered list)
    const indexOfNextListItem = $to.indexAfter($to.depth - listItemWrappingOffset);
    const positionOfNextListItem = tr.doc.resolve(selectionParentListNodeWithPos.pos + 1).posAtIndex(indexOfNextListItem);
    // Place the selection at the replaced location
    $00404095a85c8de8$var$setSelectionToValidTextNode(tr, node, from);
    // Find the ordered list node after the pasted content so we can set it's order
    const mappedPositionOfNextListItem = tr.mapping.map(positionOfNextListItem);
    if (mappedPositionOfNextListItem > tr.doc.nodeSize) return tr;
    const nodeAfterPastedContentResolvedPos = (0, $BmspC.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(mappedPositionOfNextListItem), [
        orderedList
    ]);
    // Work out the new split out lists 'order' (the number it starts from)
    const originalParentOrderedListNodeOrder = selectionParentListNode?.attrs.order;
    const nodeOfOriginalList = (0, $BmspC.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(from - 1), [
        orderedList
    ]);
    const numOfListItemsInOriginalList = nodeOfOriginalList?.node.childCount;
    // Set the new split out lists order attribute
    if (typeof originalParentOrderedListNodeOrder === 'number' && numOfListItemsInOriginalList && nodeAfterPastedContentResolvedPos && // We only want to apply the node markup if we're referring to the split
    // list rather than the original
    nodeOfOriginalList?.node !== nodeAfterPastedContentResolvedPos?.node) tr.setNodeMarkup(nodeAfterPastedContentResolvedPos.pos, orderedList, {
        ...nodeAfterPastedContentResolvedPos.node.attrs,
        order: originalParentOrderedListNodeOrder + numOfListItemsInOriginalList
    });
    return tr;
}

});

parcelRegister("gmvZ4", function(module, exports) {
$parcel$export(module.exports, "wrapSelectionIn", () => $90b1f29b359fa517$export$f63f505240212912);

var $dqHDB = parcelRequire("dqHDB");
function $90b1f29b359fa517$export$f63f505240212912(type) {
    return function(state, dispatch) {
        const tr = (0, $dqHDB.createWrapSelectionTransaction)({
            state: state,
            type: type
        });
        if (dispatch) dispatch(tr);
        return true;
    };
}

});

parcelRegister("hMYvD", function(module, exports) {
$parcel$export(module.exports, "calculateToolbarPositionAboveSelection", () => $dcba559a41e7cc63$export$5966a251e0deb6ac);
$parcel$export(module.exports, "calculateToolbarPositionTrackHead", () => $dcba559a41e7cc63$export$4fdfbe77de19eec);
$parcel$export(module.exports, "calculateToolbarPositionOnCellSelection", () => $dcba559a41e7cc63$export$2d9cc331fb808a87);

var $BmspC = parcelRequire("BmspC");

var $cwzAY = parcelRequire("cwzAY");

var $eGOwo = parcelRequire("eGOwo");
const $dcba559a41e7cc63$var$MAXIMUM_BROWSER_SCROLLBAR_WIDTH = 20;
const $dcba559a41e7cc63$export$5966a251e0deb6ac = (toolbarTitle)=>(editorView, nextPos)=>{
        const toolbar = document.querySelector(`div[aria-label="${toolbarTitle}"]`);
        if (!toolbar) return nextPos;
        // scroll wrapper for full page, fall back to document body
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO: look into using getScrollGutterOptions()
        const scrollWrapper = editorView.dom.closest('.fabric-editor-popup-scroll-parent') || document.body;
        const wrapperBounds = scrollWrapper.getBoundingClientRect();
        const selection = window && window.getSelection();
        const range = selection && !selection.isCollapsed && selection.getRangeAt(0);
        if (!range) return nextPos;
        const toolbarRect = toolbar.getBoundingClientRect();
        const { head: head, anchor: anchor } = editorView.state.selection;
        const topCoords = editorView.coordsAtPos(Math.min(head, anchor));
        const bottomCoords = editorView.coordsAtPos(Math.max(head, anchor) - Math.min(range.endOffset, 1));
        let top = (topCoords.top || 0) - toolbarRect.height * 1.5;
        let left = 0;
        // If not on the same line
        if (topCoords.top !== bottomCoords.top) {
            // selecting downwards
            if (head > anchor) left = Math.max(topCoords.right, bottomCoords.right);
            else left = Math.min(topCoords.left, bottomCoords.left);
            /*
        short selection above a long paragraph
        eg. short {<}heading
        The purpose of this text is to show the selection range{>}.
        The horizontal positioning should center around "heading",
        not where it ends at "range".
        Note: if it was "head<b>ing</b>" then it would only center
        around "head". Undesireable but matches the current renderer.
      */ const cliffPosition = range.getClientRects()[0];
            if (cliffPosition.right < left) left = cliffPosition.left + cliffPosition.width / 2;
        } else // Otherwise center on the single line selection
        left = topCoords.left + (bottomCoords.right - topCoords.left) / 2;
        left -= toolbarRect.width / 2;
        // Place toolbar below selection if not sufficient space above
        if (top < wrapperBounds.top) ({ top: top, left: left } = $dcba559a41e7cc63$var$getCoordsBelowSelection(bottomCoords, toolbarRect));
        // remap positions from browser document to wrapperBounds
        return {
            top: top - wrapperBounds.top + scrollWrapper.scrollTop,
            left: Math.max(0, left - wrapperBounds.left)
        };
    };
const $dcba559a41e7cc63$export$4fdfbe77de19eec = (toolbarTitle)=>(editorView, nextPos)=>{
        const toolbar = document.querySelector(`div[aria-label="${toolbarTitle}"]`);
        if (!toolbar) return nextPos;
        // scroll wrapper for full page, fall back to document body
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO: look into using getScrollGutterOptions()
        const scrollWrapper = editorView.dom.closest('.fabric-editor-popup-scroll-parent') || document.body;
        const wrapperBounds = scrollWrapper.getBoundingClientRect();
        const selection = window && window.getSelection();
        const moreRovoOptionsButton = document.querySelector('button[aria-label="More Rovo options"], [aria-label="More Rovo options"]');
        const isMoreRovoOptionsButtonVisible = !!moreRovoOptionsButton && moreRovoOptionsButton instanceof HTMLElement && !!moreRovoOptionsButton.offsetParent;
        let range = null;
        if (isMoreRovoOptionsButtonVisible && (0, $eGOwo.fg)('aifc_create_enabled')) {
            if (selection && selection.getRangeAt && selection.rangeCount > 0) {
                const maybeRange = selection.getRangeAt(0);
                if (maybeRange instanceof Range) range = maybeRange;
            }
        } else if (selection && !selection.isCollapsed && selection.getRangeAt && selection.rangeCount > 0) {
            const maybeRange = selection.getRangeAt(0);
            if (maybeRange instanceof Range) range = maybeRange;
        }
        if (!range) return nextPos;
        const toolbarRect = toolbar.getBoundingClientRect();
        const { head: head, anchor: anchor } = editorView.state.selection;
        const topCoords = editorView.coordsAtPos(Math.min(head, anchor));
        const bottomCoords = editorView.coordsAtPos(Math.max(head, anchor) - Math.min(range.endOffset, 1));
        let top;
        // If not the same line, display toolbar below.
        if (head > anchor && topCoords.top !== bottomCoords.top) // We are taking the previous pos to the maxium, so avoid end of line positions
        // returning the next line's rect.
        top = (bottomCoords.top || 0) + toolbarRect.height / 1.15;
        else top = (topCoords.top || 0) - toolbarRect.height * 1.5;
        let left = (head > anchor ? bottomCoords.right : topCoords.left) - toolbarRect.width / 2;
        // Place toolbar below selection if not sufficient space above
        if (top < wrapperBounds.top) ({ top: top, left: left } = $dcba559a41e7cc63$var$getCoordsBelowSelection(bottomCoords, toolbarRect));
        let leftCoord = Math.max(0, left - wrapperBounds.left);
        if (leftCoord + toolbarRect.width > wrapperBounds.width) {
            const scrollbarWidth = $dcba559a41e7cc63$var$MAXIMUM_BROWSER_SCROLLBAR_WIDTH;
            leftCoord = Math.max(0, wrapperBounds.width - (toolbarRect.width + scrollbarWidth));
        }
        // remap positions from browser document to wrapperBounds
        return {
            top: top - wrapperBounds.top + scrollWrapper.scrollTop,
            left: leftCoord
        };
    };
/**
 * Returns the coordintes at the bottom the selection.
 */ const $dcba559a41e7cc63$var$getCoordsBelowSelection = (bottomCoords, toolbarRect)=>{
    return {
        top: (bottomCoords.top || 0) + toolbarRect.height / 1.15,
        left: bottomCoords.right - toolbarRect.width / 2
    };
};
const $dcba559a41e7cc63$var$cellSelectionToolbarOffsetTop = 10;
const $dcba559a41e7cc63$var$scrollbarWidth = 20;
const $dcba559a41e7cc63$var$offsetTopOnColumnSelection = 4;
const $dcba559a41e7cc63$export$2d9cc331fb808a87 = (toolbarTitle)=>(editorView, nextPos)=>{
        const toolbar = document.querySelector(`div[aria-label="${toolbarTitle}"]`);
        if (!toolbar) return nextPos;
        const { selection: selection } = editorView.state;
        if (!(selection instanceof (0, $cwzAY.CellSelection))) return nextPos;
        const { $anchorCell: $anchorCell, $headCell: $headCell } = selection;
        const domAtPos = editorView.domAtPos.bind(editorView);
        const anchorCellDOM = (0, $BmspC.findDomRefAtPos)($anchorCell.pos, domAtPos);
        const headCellDOM = (0, $BmspC.findDomRefAtPos)($headCell.pos, domAtPos);
        if (!(anchorCellDOM instanceof HTMLElement) || !(headCellDOM instanceof HTMLElement)) return nextPos;
        const anchorCellRect = anchorCellDOM.getBoundingClientRect();
        const headCellRect = headCellDOM.getBoundingClientRect();
        const toolbarRect = toolbar.getBoundingClientRect();
        let top;
        if (headCellRect.top <= anchorCellRect.top) // Display Selection toolbar at the top of the selection
        top = headCellRect.top - toolbarRect.height - $dcba559a41e7cc63$var$cellSelectionToolbarOffsetTop;
        else // Display Selection toolbar at the bottom of the selection
        top = headCellRect.bottom + $dcba559a41e7cc63$var$cellSelectionToolbarOffsetTop;
        // scroll wrapper for full page, fall back to document body
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO: look into using getScrollGutterOptions()
        const scrollWrapper = editorView.dom.closest('.fabric-editor-popup-scroll-parent') || document.body;
        const wrapperBounds = scrollWrapper.getBoundingClientRect();
        // Place toolbar below selection if not sufficient space above
        if (top < wrapperBounds.top && headCellRect.top <= anchorCellRect.top) top = anchorCellRect.bottom + $dcba559a41e7cc63$var$cellSelectionToolbarOffsetTop;
        let left;
        if (headCellRect.left < anchorCellRect.left) left = headCellRect.left;
        else if (headCellRect.left === anchorCellRect.left) left = headCellRect.left + headCellRect.width / 2;
        else left = headCellRect.right;
        // If a user selected multiple columns via clicking on a drag handle
        // (clicking first on the left column and then shift clicking on the right column),
        // the $headcell stays in place and $anchorcell changes position. If they clicked on the right column
        // and then shift clicked on the left, the $headCell will change while $anchor stays in place.
        // Where is no way to know if user was dragging to select the cells or clicking on the drag handle.
        // So if all cells in columns are selected, we will align the Text Formatting toolbar
        // relative to center of the selected area.
        if (selection.isColSelection()) {
            if (headCellRect.left < anchorCellRect.left) left = headCellRect.left + (anchorCellRect.right - headCellRect.left) / 2;
            else if (headCellRect.left === anchorCellRect.left) left;
            else left = anchorCellRect.left + (headCellRect.right - anchorCellRect.left) / 2;
            // When column is selected, adjust top position to ensure that the toolbar does not
            // touch column drag handle
            top = top - $dcba559a41e7cc63$var$offsetTopOnColumnSelection;
        }
        let adjustedLeft = Math.max(0, left - toolbarRect.width / 2 - wrapperBounds.left);
        if (adjustedLeft + toolbarRect.width > wrapperBounds.width) adjustedLeft = Math.max(0, wrapperBounds.width - (toolbarRect.width + $dcba559a41e7cc63$var$scrollbarWidth));
        // If the toolbar is to be placed at the bottom of the selection (it happens when
        // there is no sufficient space above) and the bottom of the selection is not in the view,
        // place the toolbar at the bottom of the visible part of selection
        if (selection.isColSelection() && top + toolbarRect.height > wrapperBounds.bottom) top = top - (top - wrapperBounds.bottom) - (toolbarRect.height + 2 * $dcba559a41e7cc63$var$cellSelectionToolbarOffsetTop);
        return {
            top: top - wrapperBounds.top + scrollWrapper.scrollTop,
            left: adjustedLeft
        };
    };

});

parcelRegister("aP4il", function(module, exports) {
$parcel$export(module.exports, "findNodePosByLocalIds", () => $0fd236b6b958ecf0$export$947fc26275418e36);
const $0fd236b6b958ecf0$export$947fc26275418e36 = (state, ids, option = {})=>{
    if (ids.length === 0) return [];
    const nodes = [];
    const localIdSet = new Set(ids);
    if (option.includeDocNode && localIdSet.has(state.doc.attrs?.localId)) nodes.push({
        node: state.doc,
        pos: 0
    });
    state.doc.descendants((node, pos)=>{
        if (localIdSet.has(node.attrs?.localId)) nodes.push({
            node: node,
            pos: pos
        });
        // stop traversing once we found all the nodes
        return localIdSet.size !== nodes.length;
    });
    return nodes;
};

});




parcelRegister("2mlVO", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6690882379d5cd9$export$2e2bcd8739ae039);

var $4axGb = parcelRequire("4axGb");

var $i8KtF = parcelRequire("i8KtF");

var $b7EWj = parcelRequire("b7EWj");

var $SUgiK = parcelRequire("SUgiK");

var $jfXvp = parcelRequire("jfXvp");
const $c6690882379d5cd9$var$createTextCursor = (pos)=>{
    const node = document.createElement('div');
    node.className = 'ProseMirror-fake-text-cursor';
    return (0, $b7EWj.Decoration).widget(pos, node, {
        key: 'hyperlink-text-cursor'
    });
};
const $c6690882379d5cd9$var$createTextSelection = (from, to)=>(0, $b7EWj.Decoration).inline(from, to, {
        class: 'ProseMirror-fake-text-selection'
    });
const $c6690882379d5cd9$var$getInsertLinkToolbarState = (editorState)=>{
    const state = (0, $jfXvp.stateKey).getState(editorState);
    if (state && state.activeLinkMark) {
        if (state.activeLinkMark.type === (0, $4axGb.InsertStatus).INSERT_LINK_TOOLBAR) return state.activeLinkMark;
    }
    return undefined;
};
const $c6690882379d5cd9$var$fakeCursorToolbarPlugin = new (0, $i8KtF.SafePlugin)({
    key: (0, $SUgiK.fakeCursorForToolbarPluginKey),
    state: {
        init () {
            return (0, $b7EWj.DecorationSet).empty;
        },
        apply (tr, pluginState, oldState, newState) {
            const oldInsertToolbarState = $c6690882379d5cd9$var$getInsertLinkToolbarState(oldState);
            const insertToolbarState = $c6690882379d5cd9$var$getInsertLinkToolbarState(newState);
            // Map DecorationSet if it still refers to the same position in the document
            if (oldInsertToolbarState && insertToolbarState) {
                const { from: from, to: to } = insertToolbarState;
                const oldFrom = tr.mapping.map(oldInsertToolbarState.from);
                const oldTo = tr.mapping.map(oldInsertToolbarState.to);
                if (oldFrom === from && oldTo === to) return pluginState.map(tr.mapping, tr.doc);
            }
            // Update DecorationSet if new insert toolbar, or if we have moved to a different position in the doc
            if (insertToolbarState) {
                const { from: from, to: to } = insertToolbarState;
                return (0, $b7EWj.DecorationSet).create(tr.doc, [
                    from === to ? $c6690882379d5cd9$var$createTextCursor(from) : $c6690882379d5cd9$var$createTextSelection(from, to)
                ]);
            }
            return (0, $b7EWj.DecorationSet).empty;
        }
    },
    props: {
        decorations (state) {
            return (0, $SUgiK.fakeCursorForToolbarPluginKey).getState(state);
        }
    }
});
var $c6690882379d5cd9$export$2e2bcd8739ae039 = $c6690882379d5cd9$var$fakeCursorToolbarPlugin;

});
parcelRegister("SUgiK", function(module, exports) {
$parcel$export(module.exports, "fakeCursorForToolbarPluginKey", () => $cc1318b17cd4d0a7$export$38c00ed3b117ab26);

var $3lIcL = parcelRequire("3lIcL");
const $cc1318b17cd4d0a7$export$38c00ed3b117ab26 = new (0, $3lIcL.PluginKey)('fakeCursorToolbarPlugin');

});


parcelRegister("fqUwN", function(module, exports) {
$parcel$export(module.exports, "createInputRulePlugin", () => $3eb08c293b79df06$export$dc83f374e2af640d);

var $bMFKb = parcelRequire("bMFKb");

var $6C2m6 = parcelRequire("6C2m6");

var $i8KtF = parcelRequire("i8KtF");

var $leZY6 = parcelRequire("leZY6");
var $grDTV = parcelRequire("grDTV");
var $8YVeS = parcelRequire("8YVeS");

var $jCfsG = parcelRequire("jCfsG");

var $68iXk = parcelRequire("68iXk");
function $3eb08c293b79df06$export$8d0400fab1d2ed11(regexp, editorAnalyticsApi) {
    // Plain typed text (eg, typing 'www.google.com') should convert to a hyperlink
    return (0, $leZY6.createRule)(regexp, (state, match, start, end)=>{
        const { schema: schema } = state;
        if (state.doc.rangeHasMark(start, end, schema.marks.link)) return null;
        const link = match;
        // Property 'url' does not exist on type 'RegExpExecArray', the type of `match`.
        // This check is in case the match is not a Linkify match, which has a url property.
        if (link.url === undefined) return null;
        if (!(0, $8YVeS.shouldAutoLinkifyMatch)(link)) return null;
        const url = (0, $grDTV.normalizeUrl)(link.url);
        // Not previously handled; don't create a link if the URL is empty.
        // This will only happen if the `regexp` matches more links than the normalizeUrl validation;
        // if they both use the same linkify instance this shouldn't happen.
        if (url === '') return null;
        const markType = schema.mark('link', {
            href: url
        });
        // Need access to complete text to check if last URL is part of a filepath before linkifying
        const nodeBefore = state.selection.$from.nodeBefore;
        if (!nodeBefore || !nodeBefore.isText || !nodeBefore.text) return null;
        const filepaths = (0, $grDTV.findFilepaths)(nodeBefore.text, // The position referenced by 'start' is relative to the start of the document, findFilepaths deals with index in a node only.
        start - (nodeBefore.text.length - link.text.length));
        if ((0, $grDTV.isLinkInMatches)(start, filepaths)) {
            const tr = state.tr;
            return tr;
        }
        const from = start;
        const to = Math.min(start + link.text.length, state.doc.content.size);
        const tr = state.tr.addMark(from, to, markType);
        // Keep old behavior that will delete the space after the link
        if (to === end) tr.insertText(' ');
        (0, $6C2m6.addLinkMetadata)(state.selection, tr, {
            inputMethod: (0, $bMFKb.INPUT_METHOD).AUTO_DETECT
        });
        const skipAnalytics = (0, $68iXk.toolbarKey).getState(state)?.skipAnalytics ?? false;
        if (skipAnalytics) return tr;
        editorAnalyticsApi?.attachAnalyticsEvent((0, $grDTV.getLinkCreationAnalyticsEvent)((0, $bMFKb.INPUT_METHOD).AUTO_DETECT, url))(tr);
        return tr;
    });
}
function $3eb08c293b79df06$export$dc83f374e2af640d(schema, editorAnalyticsApi, autoLinkOnBlur = false) {
    if (!schema.marks.link) return;
    const urlWithASpaceRule = $3eb08c293b79df06$export$8d0400fab1d2ed11((0, $grDTV.LinkMatcher).create(), editorAnalyticsApi);
    // [something](link) should convert to a hyperlink
    // eslint-disable-next-line require-unicode-regexp
    const markdownLinkRule = (0, $leZY6.createRule)(/(^|[^!])\[(.*?)\]\((\S+)\)$/, (state, match, start, end)=>{
        const { schema: schema } = state;
        const [, prefix, linkText, linkUrl] = match;
        // We don't filter this match here by shouldAutoLinkifyMatch
        // because the intent of creating a link is clear
        const url = (0, $grDTV.normalizeUrl)(linkUrl).trim();
        const markType = schema.mark('link', {
            href: url
        });
        const tr = state.tr.replaceWith(start + prefix.length, end, schema.text((linkText || '').trim(), [
            markType
        ]));
        (0, $6C2m6.addLinkMetadata)(state.selection, tr, {
            inputMethod: (0, $bMFKb.INPUT_METHOD).FORMATTING
        });
        const skipAnalytics = (0, $68iXk.toolbarKey).getState(state)?.skipAnalytics ?? false;
        if (skipAnalytics) return tr;
        editorAnalyticsApi?.attachAnalyticsEvent((0, $grDTV.getLinkCreationAnalyticsEvent)((0, $bMFKb.INPUT_METHOD).FORMATTING, url))(tr);
        return tr;
    });
    return new (0, $i8KtF.SafePlugin)((0, $jCfsG.createPlugin)('hyperlink', [
        urlWithASpaceRule,
        markdownLinkRule
    ], autoLinkOnBlur ? {
        checkOnBlur: true,
        appendTextOnBlur: ' '
    } : undefined));
}
var $3eb08c293b79df06$export$2e2bcd8739ae039 = $3eb08c293b79df06$export$dc83f374e2af640d;

});
parcelRegister("jCfsG", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $c1eaadfe01c39748$export$ae829ec7b2625219);

var $3lIcL = parcelRequire("3lIcL");

var $apqw1 = parcelRequire("apqw1");

var $dxbYf = parcelRequire("dxbYf");

var $1umm2 = parcelRequire("1umm2");
const $c1eaadfe01c39748$var$hasUnsupportedMarks = (state, start, end, marksNameUnsupported)=>{
    const isUnsupportedMark = (node)=>(marksNameUnsupported || []).includes(node.type.name);
    const $from = state.doc.resolve(start);
    const $to = state.doc.resolve(end);
    const marksInSelection = start === end ? $from.marks() : $from.marksAcross($to);
    return (marksInSelection || []).some(isUnsupportedMark);
};
const $c1eaadfe01c39748$var$isCursorInsideUnsupportedMarks = (state, marksNameUnsupported)=>{
    const { selection: selection } = state;
    if (!(selection instanceof (0, $3lIcL.TextSelection))) return false;
    const { $cursor: $cursor } = selection;
    const isUnsupportedMark = (node)=>marksNameUnsupported.includes(node.type.name);
    return Boolean($cursor?.nodeBefore?.marks?.some(isUnsupportedMark));
};
const $c1eaadfe01c39748$export$ae829ec7b2625219 = (pluginName, rules, options = {})=>{
    const { isBlockNodeRule: isBlockNodeRule = false, allowInsertTextOnDocument: allowInsertTextOnDocument = true, checkOnBlur: checkOnBlur, appendTextOnBlur: appendTextOnBlur } = options;
    const onInputEvent = ({ state: state, from: from, to: to })=>{
        const unsupportedMarks = isBlockNodeRule ? [
            'code',
            'link',
            'typeAheadQuery'
        ] : [
            'code'
        ];
        const $from = state.selection.$from;
        const isInline = state.selection instanceof (0, $3lIcL.NodeSelection) && state.selection.node.type.isInline;
        if ($from.parent.type.spec.code || !(state.selection instanceof (0, $3lIcL.TextSelection)) && !(0, $dxbYf.isGapCursorSelection)(state.selection) && !isInline || $c1eaadfe01c39748$var$hasUnsupportedMarks(state, from, to, unsupportedMarks) || isBlockNodeRule && $c1eaadfe01c39748$var$isCursorInsideUnsupportedMarks(state, unsupportedMarks)) return false;
        return true;
    };
    return (0, $1umm2.createInputRulePlugin)(pluginName, rules, {
        allowInsertTextOnDocument: allowInsertTextOnDocument,
        onInputEvent: onInputEvent,
        onBeforeRegexMatch: (tr)=>{
            (0, $apqw1.closeHistory)(tr);
        },
        checkOnBlur: checkOnBlur,
        appendTextOnBlur: appendTextOnBlur
    });
};

});
parcelRegister("dxbYf", function(module, exports) {
$parcel$export(module.exports, "isGapCursorSelection", () => $5654d327962dad94$export$b0e17cd4423f50ca);
/**
 * This file is to duplicate types that exist in editor-common
 * so that input-rules does not depend on it.
 *
 * This simplifies our dependencies and makes adoption much easier.
 */ const $5654d327962dad94$export$b0e17cd4423f50ca = (selection)=>{
    // @ts-expect-error
    return Boolean(selection.jsonID === 'gapcursor');
};

});

parcelRegister("1umm2", function(module, exports) {
$parcel$export(module.exports, "createInputRulePlugin", () => $afad2bebb97d7d25$export$dc83f374e2af640d);

var $3lIcL = parcelRequire("3lIcL");

var $cbSL1 = parcelRequire("cbSL1");

var $82vn7 = parcelRequire("82vn7");

var $9tLbC = parcelRequire("9tLbC");
function $afad2bebb97d7d25$export$dc83f374e2af640d(pluginName, rules, options = {}) {
    const onInputEvent = options?.onInputEvent;
    const onBeforeRegexMatch = options?.onBeforeRegexMatch;
    const allowInsertTextOnDocument = Boolean(options?.allowInsertTextOnDocument);
    const pluginKey = new (0, $3lIcL.PluginKey)(`inputRulePlugin__${pluginName}`);
    const inputEvent = (0, $9tLbC.createInputEventHandler)({
        allowInsertTextOnDocument: allowInsertTextOnDocument,
        pluginKey: pluginKey,
        rules: rules,
        onInputEvent: onInputEvent,
        onBeforeRegexMatch: onBeforeRegexMatch
    });
    return {
        key: pluginKey,
        state: {
            init () {
                return null;
            },
            apply (tr, prev) {
                const stored = tr.getMeta(pluginKey);
                if (stored) return stored;
                return tr.selectionSet || tr.docChanged ? null : prev;
            }
        },
        appendTransaction: (transactions, oldState, newState)=>{
            const transactionWithInputRuleMeta = transactions.find((tr)=>tr.getMeta(pluginKey));
            const pluginState = transactionWithInputRuleMeta?.getMeta(pluginKey);
            if (!pluginState || !transactionWithInputRuleMeta) return null;
            const { matchedRule: matchedRule, from: from, to: to, isBackwardMatch: isBackwardMatch } = pluginState;
            const { result: result } = matchedRule;
            const mappedTo = transactionWithInputRuleMeta.mapping.map(to);
            const tr = matchedRule.handler(newState, result, from, mappedTo);
            if (!tr) return null;
            tr.setMeta((0, $82vn7.TEXT_INPUT_RULE_TRANSACTION_KEY), true);
            if (matchedRule.onHandlerApply) matchedRule.onHandlerApply(newState, tr, matchedRule.result);
            // after inserting inline code, we need to reset the selection back
            // else, we set the selection at the end of the inline code which doesn't make sense if we are closing the inline code from R to L
            if (isBackwardMatch && (0, $cbSL1.expValEquals)('platform_editor_lovability_inline_code', 'isEnabled', true)) {
                const prevSelection = oldState.selection.map(tr.doc, tr.mapping);
                tr.setSelection(prevSelection);
            }
            return tr;
        },
        props: {
            handleTextInput (view, from, to, text) {
                return inputEvent({
                    view: view,
                    from: from,
                    to: to,
                    text: text
                });
            },
            handleDOMEvents: {
                blur: (view)=>{
                    if (!options?.checkOnBlur) return false;
                    const selection = view.state.selection;
                    if (!(selection instanceof (0, $3lIcL.TextSelection))) return;
                    const { $cursor: $cursor } = selection;
                    if ($cursor) inputEvent({
                        view: view,
                        from: $cursor.pos,
                        to: $cursor.pos,
                        text: options.appendTextOnBlur ?? ''
                    });
                    return false;
                },
                compositionend: (view)=>{
                    setTimeout(()=>{
                        const selection = view.state.selection;
                        if (!(selection instanceof (0, $3lIcL.TextSelection))) return;
                        const { $cursor: $cursor } = selection;
                        if ($cursor) inputEvent({
                            view: view,
                            from: $cursor.pos,
                            to: $cursor.pos,
                            text: ''
                        });
                    });
                    return false;
                }
            }
        },
        // @ts-ignore This is used by prosemirror-view to apply input rules on text input event.
        // However, there is no typing ffor this, yet.
        isInputRules: true
    };
}

});
parcelRegister("82vn7", function(module, exports) {
$parcel$export(module.exports, "leafNodeReplacementCharacter", () => $feddda005efaf7df$export$a96b909f1510512b);
$parcel$export(module.exports, "TEXT_INPUT_RULE_TRANSACTION_KEY", () => $feddda005efaf7df$export$e56dc8305776db1f);
$parcel$export(module.exports, "MAX_REGEX_MATCH", () => $feddda005efaf7df$export$af78bb669dec9658);
$parcel$export(module.exports, "TYPEAHEAD_TRIGGERS", () => $feddda005efaf7df$export$3082ca29ad268435);
// ProseMirror uses the Unicode Character 'OBJECT REPLACEMENT CHARACTER' (U+FFFC) as text representation for
// leaf nodes, i.e. nodes that don't have any content or text property (e.g. hardBreak, emoji, mention, rule)
// It was introduced because of https://github.com/ProseMirror/prosemirror/issues/262
// This can be used in an input rule regex to be able to include or exclude such nodes.
const $feddda005efaf7df$export$a96b909f1510512b = '\ufffc';
const $feddda005efaf7df$export$e56dc8305776db1f = 'input_rule_plugin_transaction';
const $feddda005efaf7df$export$af78bb669dec9658 = 500;
const $feddda005efaf7df$export$3082ca29ad268435 = [
    ':',
    '/',
    '@'
];

});

parcelRegister("9tLbC", function(module, exports) {
$parcel$export(module.exports, "createInputEventHandler", () => $924a0317ab067bd8$export$9bcba4b183c6bb83);

var $cbSL1 = parcelRequire("cbSL1");

var $82vn7 = parcelRequire("82vn7");

var $dxbYf = parcelRequire("dxbYf");
const $924a0317ab067bd8$export$9bcba4b183c6bb83 = ({ rules: rules, pluginKey: pluginKey, allowInsertTextOnDocument: allowInsertTextOnDocument, onInputEvent: onInputEvent, onBeforeRegexMatch: onBeforeRegexMatch })=>({ view: view, from: from, to: to, text: text })=>{
        if (view.composing) return false;
        const state = view.state;
        const $from = state.doc.resolve(from);
        if ($from.parent.type.spec.code) return false;
        if (onInputEvent && !onInputEvent({
            state: state,
            from: from,
            to: to
        })) return false;
        const textBefore = $from.parent.textBetween(Math.max(0, $from.parentOffset - (0, $82vn7.MAX_REGEX_MATCH)), $from.parentOffset, undefined, (0, $82vn7.leafNodeReplacementCharacter)) + text;
        let result = $924a0317ab067bd8$var$findMatchOnRules({
            rules: rules,
            textToMatch: textBefore,
            from: from,
            to: to,
            state: state
        });
        let isBackwardMatch;
        if (!result && (0, $cbSL1.expValEquals)('platform_editor_lovability_inline_code', 'isEnabled', true)) {
            if ((0, $82vn7.TYPEAHEAD_TRIGGERS).includes(text)) return false;
            const textAfter = text + $from.parent.textBetween($from.parentOffset, Math.min($from.parent.content.size, $from.parentOffset + (0, $82vn7.MAX_REGEX_MATCH)), undefined, (0, $82vn7.leafNodeReplacementCharacter));
            isBackwardMatch = true;
            result = $924a0317ab067bd8$var$findMatchOnRules({
                rules: rules,
                textToMatch: textAfter,
                from: from,
                to: to,
                state: state,
                isBackwardMatch: isBackwardMatch
            });
            if (!result) return false;
        }
        if (!result) return false;
        const tr = allowInsertTextOnDocument ? state.tr.insertText(text, from, to) : state.tr;
        tr.setMeta((0, $82vn7.TEXT_INPUT_RULE_TRANSACTION_KEY), true);
        tr.setMeta(pluginKey, {
            textInserted: text,
            from: result.from,
            to: result.to,
            matchedRule: result.matchedRule,
            isBackwardMatch: isBackwardMatch
        });
        if (onBeforeRegexMatch) onBeforeRegexMatch(tr);
        view.dispatch(tr);
        return true;
    };
function $924a0317ab067bd8$var$findMatchOnRules({ rules: rules, textToMatch: textToMatch, from: from, to: to, state: state, isBackwardMatch: isBackwardMatch }) {
    for(let i = 0; i < rules.length; i++){
        const rule = rules[i];
        // Some plugins like Typeahead require a whitespace before a trigger character.
        // We want them to fire inside a gap cursor. Yet, a gap cursor is not considered a whitespace,
        // and `textToMatch` contains the text in the previous block before the gap cursor.
        // Here is a workaround: if we inside a gap cursor, match the input rule only against the last typed character
        // (which may be a typeahead trigger) and ignore the rest.
        const matchString = (0, $dxbYf.isGapCursorSelection)(state.selection) ? textToMatch.at(-1) ?? '' : textToMatch;
        // EDITOR-2460
        // if the user is formatting text to inline code from R to L i.e. backwards
        if (rule.allowsBackwardMatch && isBackwardMatch && (0, $cbSL1.expValEquals)('platform_editor_lovability_inline_code', 'isEnabled', true)) {
            const match = rule.match.exec(matchString);
            if (!match) continue;
            const matchEndPos = from + match[0].length - 1;
            const transform = rule.handler(state, match, from, matchEndPos);
            if (transform) return {
                from: from,
                to: matchEndPos,
                matchedRule: {
                    ...rule,
                    result: match
                }
            };
            return null;
        }
        const match = rule.match.exec(matchString);
        if (!match) continue;
        const parentNodeStartAt = state.selection.$from.start();
        const offset = Math.max(0, state.selection.$from.parentOffset - (0, $82vn7.MAX_REGEX_MATCH));
        const fromFixed = Math.max(parentNodeStartAt + match.index + offset, 1);
        const transform = rule.handler(state, match, fromFixed, to);
        if (transform) return {
            from: fromFixed,
            to: to,
            matchedRule: {
                ...rule,
                result: match
            }
        };
    }
    return null;
}

});



parcelRegister("68iXk", function(module, exports) {
$parcel$export(module.exports, "toolbarKey", () => $13c7c9663eae5dc5$export$6cbac557ea601778);
$parcel$export(module.exports, "toolbarButtonsPlugin", () => $13c7c9663eae5dc5$export$faf11097578346af);

var $i8KtF = parcelRequire("i8KtF");

var $3lIcL = parcelRequire("3lIcL");
const $13c7c9663eae5dc5$export$6cbac557ea601778 = new (0, $3lIcL.PluginKey)('hyperlinkToolbarItems');
const $13c7c9663eae5dc5$export$faf11097578346af = (initialState)=>{
    return new (0, $i8KtF.SafePlugin)({
        key: $13c7c9663eae5dc5$export$6cbac557ea601778,
        state: {
            init: (_, __)=>{
                return initialState;
            },
            apply: (tr, pluginState)=>{
                const metaState = tr.getMeta($13c7c9663eae5dc5$export$6cbac557ea601778);
                if (metaState) return metaState;
                return pluginState;
            }
        }
    });
};

});


parcelRegister("5uCg0", function(module, exports) {
$parcel$export(module.exports, "createKeymapPlugin", () => $4d42e10b25d4a341$export$1d7b13ce0747fbd);

var $iKozC = parcelRequire("iKozC");

var $bMFKb = parcelRequire("bMFKb");

var $6C2m6 = parcelRequire("6C2m6");

var $6Exgk = parcelRequire("6Exgk");

var $grDTV = parcelRequire("grDTV");
var $8YVeS = parcelRequire("8YVeS");

var $x7sgX = parcelRequire("x7sgX");

var $eBKSl = parcelRequire("eBKSl");

var $jfXvp = parcelRequire("jfXvp");

var $68iXk = parcelRequire("68iXk");
function $4d42e10b25d4a341$export$1d7b13ce0747fbd(editorAnalyticsApi) {
    const list = {};
    (0, $6Exgk.bindKeymapWithEditorCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.addLink).common, (0, $eBKSl.showLinkToolbar)((0, $bMFKb.INPUT_METHOD).SHORTCUT, editorAnalyticsApi), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.bindKeymapWithCommand)((0, $6Exgk.enter).common, $4d42e10b25d4a341$var$mayConvertLastWordToHyperlink(editorAnalyticsApi), list);
    (0, $6Exgk.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.insertNewLine).common, $4d42e10b25d4a341$var$mayConvertLastWordToHyperlink(editorAnalyticsApi), list);
    (0, $6Exgk.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.escape).common, (state, dispatch, view)=>{
        const hyperlinkPlugin = (0, $jfXvp.stateKey).getState(state);
        if (hyperlinkPlugin.activeLinkMark) {
            (0, $eBKSl.hideLinkToolbar)()(state, dispatch);
            if (view) view.focus();
            return false;
        }
        return false;
    }, list);
    return (0, $x7sgX.keymap)(list);
}
/**
 * Convert the last word before the selection to a hyperlink if it's a valid URL with a tld we want to linkify
 */ const $4d42e10b25d4a341$var$mayConvertLastWordToHyperlink = (editorAnalyticsApi)=>{
    return function(state, dispatch) {
        const skipAnalytics = (0, $68iXk.toolbarKey).getState(state)?.skipAnalytics ?? false;
        const nodeBefore = state.selection.$from.nodeBefore;
        if (!nodeBefore || !nodeBefore.isText || !nodeBefore.text) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const words = nodeBefore.text.split(' ');
        const lastWord = words[words.length - 1];
        const match = (0, $iKozC.getLinkMatch)(lastWord);
        if (match) {
            if (!(0, $8YVeS.shouldAutoLinkifyMatch)(match)) return false;
            const hyperlinkedText = match.raw;
            const start = state.selection.$from.pos - hyperlinkedText.length;
            const end = state.selection.$from.pos;
            if (state.doc.rangeHasMark(start, end, state.schema.marks.link)) return false;
            const url = match.url;
            const markType = state.schema.mark('link', {
                href: url
            });
            const filepaths = (0, $grDTV.findFilepaths)(nodeBefore.text, start - (nodeBefore.text.length - hyperlinkedText.length));
            if ((0, $grDTV.isLinkInMatches)(start, filepaths)) return false;
            const tr = state.tr.addMark(start, end, markType);
            if (dispatch) {
                (0, $6C2m6.addLinkMetadata)(state.selection, tr, {
                    inputMethod: (0, $bMFKb.INPUT_METHOD).AUTO_DETECT
                });
                if (skipAnalytics) dispatch(tr);
                else {
                    editorAnalyticsApi?.attachAnalyticsEvent((0, $grDTV.getLinkCreationAnalyticsEvent)((0, $bMFKb.INPUT_METHOD).AUTO_DETECT, url))(tr);
                    dispatch(tr);
                }
            }
        }
        return false;
    };
};
var $4d42e10b25d4a341$export$2e2bcd8739ae039 = $4d42e10b25d4a341$export$1d7b13ce0747fbd;

});

parcelRegister("cF6Iw", function(module, exports) {
$parcel$export(module.exports, "getToolbarComponents", () => $ffb7eca1e40199f9$export$a758406ca53b86a5);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $3KjUM = parcelRequire("3KjUM");
var $6996L = parcelRequire("6996L");

var $jEUaN = parcelRequire("jEUaN");
const $ffb7eca1e40199f9$export$a758406ca53b86a5 = (api)=>{
    const toolbarComponents = [
        {
            type: (0, $3KjUM.LINKING_GROUP).type,
            key: (0, $3KjUM.LINKING_GROUP).key,
            parents: [
                {
                    type: (0, $3KjUM.LINKING_SECTION).type,
                    key: (0, $3KjUM.LINKING_SECTION).key,
                    rank: (0, $6996L.LINKING_SECTION_RANK)[(0, $3KjUM.LINKING_GROUP).key]
                }
            ]
        },
        {
            type: (0, $3KjUM.LINKING_BUTTON).type,
            key: (0, $3KjUM.LINKING_BUTTON).key,
            parents: [
                {
                    type: (0, $3KjUM.LINKING_GROUP).type,
                    key: (0, $3KjUM.LINKING_GROUP).key,
                    rank: (0, $6996L.LINKING_GROUP_RANK)[(0, $3KjUM.LINKING_BUTTON).key]
                }
            ],
            component: ()=>{
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jEUaN.LinkButton), {
                    api: api
                });
            }
        }
    ];
    return toolbarComponents;
};

});
parcelRegister("3KjUM", function(module, exports) {
$parcel$export(module.exports, "TOOLBARS", () => $b53d88dc93e8b19e$export$cc1c18c6e6b6ecaf);
$parcel$export(module.exports, "AI_SECTION", () => $b53d88dc93e8b19e$export$78ec0124ca63fa02);
$parcel$export(module.exports, "AI_VIEW_SECTION", () => $b53d88dc93e8b19e$export$124d2ee606ccdfdc);
$parcel$export(module.exports, "AI_SECTION_PRIMARY_TOOLBAR", () => $b53d88dc93e8b19e$export$6d5407fbb0bc912e);
$parcel$export(module.exports, "AI_SECTION_FULL_PAGE_PRIMARY_TOOLBAR", () => $b53d88dc93e8b19e$export$ea53d97c37cdede3);
$parcel$export(module.exports, "AI_SECTION_COMMENT_PRIMARY_TOOLBAR", () => $b53d88dc93e8b19e$export$dcbeb7730f347566);
$parcel$export(module.exports, "ROVO_GROUP", () => $b53d88dc93e8b19e$export$ab61657fb37116be);
$parcel$export(module.exports, "ROVO_GROUP_VIEW", () => $b53d88dc93e8b19e$export$b0e50b17917e2523);
$parcel$export(module.exports, "ROVO_GROUP_PRIMARY_TOOLBAR", () => $b53d88dc93e8b19e$export$67ae7e5d398cd98);
$parcel$export(module.exports, "ROVO_GROUP_DISPLAY_SMALL", () => $b53d88dc93e8b19e$export$393a27a1587c4748);
$parcel$export(module.exports, "IMPROVE_WRITING_GROUP", () => $b53d88dc93e8b19e$export$164a0130b2b649c6);
$parcel$export(module.exports, "IMPROVE_WRITING_BUTTON", () => $b53d88dc93e8b19e$export$e7c291289ee98d9);
$parcel$export(module.exports, "HERO_PROMPT_BUTTON_GROUP", () => $b53d88dc93e8b19e$export$50fb6fd780a8da5a);
$parcel$export(module.exports, "HERO_PROMPT_BUTTON", () => $b53d88dc93e8b19e$export$6ea8ae73b826b63e);
$parcel$export(module.exports, "ROVO_HERO_BUTTON", () => $b53d88dc93e8b19e$export$3d823cd1493e8383);
$parcel$export(module.exports, "ROVO_WRITE_BUTTON_PRIMARY_TOOLBAR", () => $b53d88dc93e8b19e$export$bc3c6b8bbdf543d6);
$parcel$export(module.exports, "ROVO_MENU", () => $b53d88dc93e8b19e$export$4532eefb6fdb660c);
$parcel$export(module.exports, "ROVO_MENU_DISPLAY_SMALL", () => $b53d88dc93e8b19e$export$245b51779748026d);
$parcel$export(module.exports, "ROVO_PROMPT_MENU_SECTION", () => $b53d88dc93e8b19e$export$f157764a2d8d74e6);
$parcel$export(module.exports, "ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL", () => $b53d88dc93e8b19e$export$8be015e65f184637);
$parcel$export(module.exports, "IMPROVE_WRITING_MENU_ITEM", () => $b53d88dc93e8b19e$export$c9c5b3ece9aa9724);
$parcel$export(module.exports, "HERO_PROMPT_MENU_ITEM", () => $b53d88dc93e8b19e$export$1ede5932cecaa59);
$parcel$export(module.exports, "MAKE_SHORTER_MENU_ITEM", () => $b53d88dc93e8b19e$export$4799f439258ea378);
$parcel$export(module.exports, "MAKE_LONGER_MENU_ITEM", () => $b53d88dc93e8b19e$export$b82c17edba0c6a9e);
$parcel$export(module.exports, "CHANGE_TONE_NESTED_MENU", () => $b53d88dc93e8b19e$export$1356bd5d76f7fc4);
$parcel$export(module.exports, "SPELLING_AND_GRAMMAR_MENU_ITEM", () => $b53d88dc93e8b19e$export$ba297ac76e077190);
$parcel$export(module.exports, "CHANGE_TONE_MENU_SECTION", () => $b53d88dc93e8b19e$export$86a7882cf39bf1df);
$parcel$export(module.exports, "MORE_PROFESSIONAL_MENU_ITEM", () => $b53d88dc93e8b19e$export$d868febccc6870c7);
$parcel$export(module.exports, "MORE_CASUAL_MENU_ITEM", () => $b53d88dc93e8b19e$export$4a7c57dd33fc4a14);
$parcel$export(module.exports, "MORE_EMPATHETIC_MENU_ITEM", () => $b53d88dc93e8b19e$export$3758b89123aa4456);
$parcel$export(module.exports, "TRANSLATE_NESTED_MENU", () => $b53d88dc93e8b19e$export$76118e0d25ac1fef);
$parcel$export(module.exports, "TRANSLATE_MENU_SECTION", () => $b53d88dc93e8b19e$export$a526b8293dafd11c);
$parcel$export(module.exports, "DEFINE_MENU_ITEM", () => $b53d88dc93e8b19e$export$5836877aa3028c9d);
$parcel$export(module.exports, "DEFINE_GROUP", () => $b53d88dc93e8b19e$export$92f779590a87713f);
$parcel$export(module.exports, "DEFINE_BUTTON", () => $b53d88dc93e8b19e$export$8bfe594eeaed8635);
$parcel$export(module.exports, "TEXT_SECTION", () => $b53d88dc93e8b19e$export$46f6ca06869869c);
$parcel$export(module.exports, "TEXT_SECTION_PRIMARY_TOOLBAR", () => $b53d88dc93e8b19e$export$9821adc8accbec40);
$parcel$export(module.exports, "TEXT_SECTION_COLLAPSED", () => $b53d88dc93e8b19e$export$65db33ca2d38a784);
$parcel$export(module.exports, "TEXT_COLLAPSED_GROUP", () => $b53d88dc93e8b19e$export$dbb8e55d66b9ce7c);
$parcel$export(module.exports, "TEXT_COLLAPSED_MENU", () => $b53d88dc93e8b19e$export$50e256f5fa0723b1);
$parcel$export(module.exports, "TEXT_STYLES_GROUP", () => $b53d88dc93e8b19e$export$17de14a70389be62);
$parcel$export(module.exports, "TEXT_STYLES_MENU", () => $b53d88dc93e8b19e$export$e3c7868e9e7f30f);
$parcel$export(module.exports, "TEXT_STYLES_MENU_SECTION", () => $b53d88dc93e8b19e$export$61c471f0e406c6cd);
$parcel$export(module.exports, "NORMAL_TEXT_MENU_ITEM", () => $b53d88dc93e8b19e$export$a0d395bab4f77bed);
$parcel$export(module.exports, "HEADING_1_MENU_ITEM", () => $b53d88dc93e8b19e$export$2469e8506da598d3);
$parcel$export(module.exports, "HEADING_2_MENU_ITEM", () => $b53d88dc93e8b19e$export$a065aede28a4fa60);
$parcel$export(module.exports, "HEADING_3_MENU_ITEM", () => $b53d88dc93e8b19e$export$85070b7c6d42e3bb);
$parcel$export(module.exports, "HEADING_4_MENU_ITEM", () => $b53d88dc93e8b19e$export$e78c2531f67b545f);
$parcel$export(module.exports, "HEADING_5_MENU_ITEM", () => $b53d88dc93e8b19e$export$a92294de346392be);
$parcel$export(module.exports, "HEADING_6_MENU_ITEM", () => $b53d88dc93e8b19e$export$9c3cdc8e6d51ce82);
$parcel$export(module.exports, "BLOCK_QUOTE_MENU_ITEM", () => $b53d88dc93e8b19e$export$f4b89f87980eb537);
$parcel$export(module.exports, "TEXT_FORMATTING_GROUP", () => $b53d88dc93e8b19e$export$acdcd8bfebadff8e);
$parcel$export(module.exports, "TEXT_FORMATTING_GROUP_COLLAPSED", () => $b53d88dc93e8b19e$export$3efe78988280adb3);
$parcel$export(module.exports, "TEXT_FORMATTING_GROUP_INLINE", () => $b53d88dc93e8b19e$export$d709b777a6a93241);
$parcel$export(module.exports, "BOLD_BUTTON_GROUP", () => $b53d88dc93e8b19e$export$e54b89ebe974229a);
$parcel$export(module.exports, "UNDERLINE_BUTTON_GROUP", () => $b53d88dc93e8b19e$export$eb8680bccd13ec29);
$parcel$export(module.exports, "TEXT_FORMATTING_HERO_BUTTON", () => $b53d88dc93e8b19e$export$b1308631b6ed4b3);
$parcel$export(module.exports, "TEXT_FORMATTING_HERO_BUTTON_COLLAPSED", () => $b53d88dc93e8b19e$export$1f2df85e05c78a28);
$parcel$export(module.exports, "BOLD_BUTTON", () => $b53d88dc93e8b19e$export$512cce888b603a21);
$parcel$export(module.exports, "UNDERLINE_BUTTON", () => $b53d88dc93e8b19e$export$8ba429f81350a9a5);
$parcel$export(module.exports, "TEXT_FORMATTING_MENU", () => $b53d88dc93e8b19e$export$6ed8e5719ec9c8ca);
$parcel$export(module.exports, "BOLD_MENU_ITEM", () => $b53d88dc93e8b19e$export$8bc14fdbfc88e3d);
$parcel$export(module.exports, "ITALIC_MENU_ITEM", () => $b53d88dc93e8b19e$export$55cababf49d70434);
$parcel$export(module.exports, "UNDERLINE_MENU_ITEM", () => $b53d88dc93e8b19e$export$74aa4c917d0fb179);
$parcel$export(module.exports, "STRIKE_MENU_ITEM", () => $b53d88dc93e8b19e$export$9caef6162846aa5f);
$parcel$export(module.exports, "CODE_MENU_ITEM", () => $b53d88dc93e8b19e$export$33821ea6eceb9d13);
$parcel$export(module.exports, "SUBSCRIPT_MENU_ITEM", () => $b53d88dc93e8b19e$export$ee8cb7d7ef764bfe);
$parcel$export(module.exports, "SUPERSCRIPT_MENU_ITEM", () => $b53d88dc93e8b19e$export$85ead1ec02f87839);
$parcel$export(module.exports, "TEXT_FORMATTING_MENU_SECTION", () => $b53d88dc93e8b19e$export$6f16936b77c05f44);
$parcel$export(module.exports, "CLEAR_FORMARTTING_MENU_SECTION", () => $b53d88dc93e8b19e$export$2d7a9246359565f);
$parcel$export(module.exports, "CLEAR_FORMATTING_MENU_ITEM", () => $b53d88dc93e8b19e$export$2577e452f5468087);
$parcel$export(module.exports, "TEXT_COLOR_HIGHLIGHT_GROUP", () => $b53d88dc93e8b19e$export$eb99509879c4d1a6);
$parcel$export(module.exports, "TEXT_COLOR_HIGHLIGHT_MENU", () => $b53d88dc93e8b19e$export$126ef012ef4d8c5f);
$parcel$export(module.exports, "TEXT_COLOR_HIGHLIGHT_MENU_SECTION", () => $b53d88dc93e8b19e$export$70638f1e77085913);
$parcel$export(module.exports, "TEXT_COLOR_MENU_ITEM", () => $b53d88dc93e8b19e$export$ebd1271b08f151b0);
$parcel$export(module.exports, "HIGHLIGHT_MENU_ITEM", () => $b53d88dc93e8b19e$export$bae2fe42c2b86102);
$parcel$export(module.exports, "CLEAR_COLOR_MENU_ITEM", () => $b53d88dc93e8b19e$export$267f9526bd36c2c);
$parcel$export(module.exports, "ALIGNMENT_GROUP", () => $b53d88dc93e8b19e$export$36cf1d476157a47d);
$parcel$export(module.exports, "ALIGNMENT_MENU", () => $b53d88dc93e8b19e$export$b9d75d8ec913c411);
$parcel$export(module.exports, "ALIGNMENT_MENU_SECTION", () => $b53d88dc93e8b19e$export$a7d30f7c1c00dd6e);
$parcel$export(module.exports, "ALIGN_LEFT_MENU_ITEM", () => $b53d88dc93e8b19e$export$fb5e83c02abc1116);
$parcel$export(module.exports, "ALIGN_CENTER_MENU_ITEM", () => $b53d88dc93e8b19e$export$920b9c1f02074883);
$parcel$export(module.exports, "ALIGN_RIGHT_MENU_ITEM", () => $b53d88dc93e8b19e$export$77c582b2c8fa437c);
$parcel$export(module.exports, "LISTS_INDENTATION_GROUP", () => $b53d88dc93e8b19e$export$cfa2bcff371b7719);
$parcel$export(module.exports, "LISTS_INDENTATION_GROUP_COLLAPSED", () => $b53d88dc93e8b19e$export$e24e846ad969dbb4);
$parcel$export(module.exports, "LISTS_INDENTATION_GROUP_INLINE", () => $b53d88dc93e8b19e$export$18e3c58ea662f7ad);
$parcel$export(module.exports, "BULLETED_LIST_BUTTON_GROUP", () => $b53d88dc93e8b19e$export$93963c53c29fc835);
$parcel$export(module.exports, "BULLETED_LIST_BUTTON", () => $b53d88dc93e8b19e$export$6c8387a14e0128fe);
$parcel$export(module.exports, "LISTS_INDENTATION_HERO_BUTTON_COLLAPSED", () => $b53d88dc93e8b19e$export$f625e29dbd38e447);
$parcel$export(module.exports, "LISTS_INDENTATION_HERO_BUTTON", () => $b53d88dc93e8b19e$export$8709d937e93456c5);
$parcel$export(module.exports, "LISTS_INDENTATION_MENU", () => $b53d88dc93e8b19e$export$77b7fc28d250a53f);
$parcel$export(module.exports, "LISTS_INDENTATION_MENU_SECTION", () => $b53d88dc93e8b19e$export$21a99ac537934e71);
$parcel$export(module.exports, "BULLETED_LIST_MENU_ITEM", () => $b53d88dc93e8b19e$export$fc39a5dc74747fed);
$parcel$export(module.exports, "NUMBERED_LIST_MENU_ITEM", () => $b53d88dc93e8b19e$export$9d64032e4ea1097c);
$parcel$export(module.exports, "TASK_LIST_MENU_ITEM", () => $b53d88dc93e8b19e$export$d6bac99c24b8cdfd);
$parcel$export(module.exports, "INDENT_MENU_ITEM", () => $b53d88dc93e8b19e$export$87678574248a0249);
$parcel$export(module.exports, "OUTDENT_MENU_ITEM", () => $b53d88dc93e8b19e$export$8fc4080aa2f8adc2);
$parcel$export(module.exports, "INSERT_BLOCK_SECTION", () => $b53d88dc93e8b19e$export$8be58f85d6f2b208);
$parcel$export(module.exports, "CODE_BLOCK_GROUP", () => $b53d88dc93e8b19e$export$a55d93db15cde50c);
$parcel$export(module.exports, "CODE_BLOCK_BUTTON", () => $b53d88dc93e8b19e$export$22d0f50f2ec2f1a8);
$parcel$export(module.exports, "TASK_LIST_GROUP", () => $b53d88dc93e8b19e$export$6265c903e79c43eb);
$parcel$export(module.exports, "TASK_LIST_BUTTON", () => $b53d88dc93e8b19e$export$9634f504f88ede38);
$parcel$export(module.exports, "MEDIA_GROUP", () => $b53d88dc93e8b19e$export$ce4671f9066f5c48);
$parcel$export(module.exports, "MEDIA_BUTTON", () => $b53d88dc93e8b19e$export$37025ad4bfe1d2aa);
$parcel$export(module.exports, "MENTION_GROUP", () => $b53d88dc93e8b19e$export$f4c921ea7ce3d48a);
$parcel$export(module.exports, "MENTION_BUTTON", () => $b53d88dc93e8b19e$export$450b9a588cdf3949);
$parcel$export(module.exports, "EMOJI_GROUP", () => $b53d88dc93e8b19e$export$6ca7976638436c6);
$parcel$export(module.exports, "EMOJI_BUTTON", () => $b53d88dc93e8b19e$export$a4310034b096a4ad);
$parcel$export(module.exports, "LAYOUT_GROUP", () => $b53d88dc93e8b19e$export$f746b10bd135ebe5);
$parcel$export(module.exports, "LAYOUT_BUTTON", () => $b53d88dc93e8b19e$export$bc099bce567fd020);
$parcel$export(module.exports, "TABLE_GROUP", () => $b53d88dc93e8b19e$export$19b0175d8da45496);
$parcel$export(module.exports, "TABLE_BUTTON", () => $b53d88dc93e8b19e$export$c37ae5d099679682);
$parcel$export(module.exports, "TABLE_SIZE_PICKER", () => $b53d88dc93e8b19e$export$c796ec87818935d5);
$parcel$export(module.exports, "INSERT_GROUP", () => $b53d88dc93e8b19e$export$2db6abe323bf312e);
$parcel$export(module.exports, "INSERT_BUTTON", () => $b53d88dc93e8b19e$export$2b79c1387bf4ea1b);
$parcel$export(module.exports, "LINKING_SECTION", () => $b53d88dc93e8b19e$export$1fc1401e9e5d8a);
$parcel$export(module.exports, "LINKING_GROUP", () => $b53d88dc93e8b19e$export$87f2f2ff3eb62f79);
$parcel$export(module.exports, "LINKING_BUTTON", () => $b53d88dc93e8b19e$export$3d214445dcf942f2);
$parcel$export(module.exports, "COLLAB_SECTION", () => $b53d88dc93e8b19e$export$457818231baddd40);
$parcel$export(module.exports, "COMMENT_GROUP", () => $b53d88dc93e8b19e$export$8978fe8e689744cc);
$parcel$export(module.exports, "COMMENT_HERO_BUTTON", () => $b53d88dc93e8b19e$export$f97beb46382b3388);
$parcel$export(module.exports, "APPS_SECTION", () => $b53d88dc93e8b19e$export$d757fc54a1831d82);
$parcel$export(module.exports, "TRACK_CHANGES_SECTION", () => $b53d88dc93e8b19e$export$c3f44bc1025dceb2);
$parcel$export(module.exports, "UNDO_CHANGES_GROUP", () => $b53d88dc93e8b19e$export$b3d4f2cdc057cba1);
$parcel$export(module.exports, "UNDO_BUTTON", () => $b53d88dc93e8b19e$export$f13c32a4c68c0806);
$parcel$export(module.exports, "REDO_CHANGES_GROUP", () => $b53d88dc93e8b19e$export$e149a5154bb9b44);
$parcel$export(module.exports, "REDO_BUTTON", () => $b53d88dc93e8b19e$export$1fb249ec6ca34dd0);
$parcel$export(module.exports, "TRACK_CHANGES_GROUP", () => $b53d88dc93e8b19e$export$8e3cd3ec14c6efc);
$parcel$export(module.exports, "TRACK_CHANGES_BUTTON", () => $b53d88dc93e8b19e$export$9cfd2622f07061e0);
$parcel$export(module.exports, "OVERFLOW_SECTION", () => $b53d88dc93e8b19e$export$cb18e5ae740a3f22);
$parcel$export(module.exports, "OVERFLOW_GROUP", () => $b53d88dc93e8b19e$export$932f82408ad2af53);
$parcel$export(module.exports, "OVERFLOW_MENU", () => $b53d88dc93e8b19e$export$6583eb3a2765795b);
$parcel$export(module.exports, "PIN_MENU_SECTION", () => $b53d88dc93e8b19e$export$cefae60670d357d0);
$parcel$export(module.exports, "PIN_MENU_ITEM", () => $b53d88dc93e8b19e$export$76d22fa71bc28346);
$parcel$export(module.exports, "OVERFLOW_SECTION_PRIMARY_TOOLBAR", () => $b53d88dc93e8b19e$export$1b5ea0d5074f7d18);
$parcel$export(module.exports, "OVERFLOW_GROUP_PRIMARY_TOOLBAR", () => $b53d88dc93e8b19e$export$a481b12c04259be8);
$parcel$export(module.exports, "OVERFLOW_MENU_PRIMARY_TOOLBAR", () => $b53d88dc93e8b19e$export$b0bb124d5687709e);
$parcel$export(module.exports, "PIN_SECTION", () => $b53d88dc93e8b19e$export$6d497f3df1049a22);
$parcel$export(module.exports, "PIN_GROUP", () => $b53d88dc93e8b19e$export$762436e7516a2365);
$parcel$export(module.exports, "PIN_BUTTON", () => $b53d88dc93e8b19e$export$cfefbb6355b14379);
$parcel$export(module.exports, "LOOM_MENU_SECTION", () => $b53d88dc93e8b19e$export$dd76f40d6548a654);
$parcel$export(module.exports, "LOOM_MENU_ITEM", () => $b53d88dc93e8b19e$export$4ac3fd1884a40118);
$parcel$export(module.exports, "SELECTION_EXTENSION_MENU_SECTION", () => $b53d88dc93e8b19e$export$debff7788300c3ff);
const $b53d88dc93e8b19e$export$cc1c18c6e6b6ecaf = {
    INLINE_TEXT_TOOLBAR: 'inline-text-toolbar',
    PRIMARY_TOOLBAR: 'primary-toolbar'
};
const $b53d88dc93e8b19e$export$78ec0124ca63fa02 = {
    key: 'ai-section',
    type: 'section'
};
const $b53d88dc93e8b19e$export$124d2ee606ccdfdc = {
    key: 'ai-view-section',
    type: 'section'
};
const $b53d88dc93e8b19e$export$6d5407fbb0bc912e = {
    key: 'ai-section-primary-toolbar',
    type: 'section'
};
const $b53d88dc93e8b19e$export$ea53d97c37cdede3 = {
    key: 'ai-section-full-page-primary-toolbar',
    type: 'section'
};
const $b53d88dc93e8b19e$export$dcbeb7730f347566 = {
    key: 'ai-section-comment-primary-toolbar',
    type: 'section'
};
const $b53d88dc93e8b19e$export$ab61657fb37116be = {
    key: 'rovo-group',
    type: 'group'
};
const $b53d88dc93e8b19e$export$b0e50b17917e2523 = {
    key: 'rovo-group-view',
    type: 'group'
};
const $b53d88dc93e8b19e$export$67ae7e5d398cd98 = {
    key: 'rovo-group-primary-toolbar',
    type: 'group'
};
const $b53d88dc93e8b19e$export$393a27a1587c4748 = {
    key: 'rovo-group-display-small',
    type: 'group'
};
const $b53d88dc93e8b19e$export$164a0130b2b649c6 = {
    key: 'improve-writing-group',
    type: 'group'
};
const $b53d88dc93e8b19e$export$e7c291289ee98d9 = {
    key: 'improve-writing-button',
    type: 'button'
};
const $b53d88dc93e8b19e$export$50fb6fd780a8da5a = {
    key: 'hero-prompt-button-group',
    type: 'group'
};
const $b53d88dc93e8b19e$export$6ea8ae73b826b63e = {
    key: 'hero-prompt-button',
    type: 'button'
};
const $b53d88dc93e8b19e$export$3d823cd1493e8383 = {
    key: 'rovo-hero-button',
    type: 'button'
};
const $b53d88dc93e8b19e$export$bc3c6b8bbdf543d6 = {
    key: 'rovo-write-button-primary-toolbar',
    type: 'button'
};
const $b53d88dc93e8b19e$export$4532eefb6fdb660c = {
    key: 'rovo-menu',
    type: 'menu'
};
const $b53d88dc93e8b19e$export$245b51779748026d = {
    key: 'rovo-menu-display-small',
    type: 'menu'
};
const $b53d88dc93e8b19e$export$f157764a2d8d74e6 = {
    key: 'rovo-prompt-menu-section',
    type: 'menu-section'
};
const $b53d88dc93e8b19e$export$8be015e65f184637 = {
    key: 'rovo-prompt-menu-section-display-small',
    type: 'menu-section'
};
const $b53d88dc93e8b19e$export$c9c5b3ece9aa9724 = {
    key: 'improve-writing-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$1ede5932cecaa59 = {
    key: 'hero-prompt-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$4799f439258ea378 = {
    key: 'make-shorter-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$b82c17edba0c6a9e = {
    key: 'make-longer-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$1356bd5d76f7fc4 = {
    key: 'change-tone-nested-menu',
    type: 'nested-menu'
};
const $b53d88dc93e8b19e$export$ba297ac76e077190 = {
    key: 'spelling-and-grammar-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$86a7882cf39bf1df = {
    key: 'change-tone-default-menu-section',
    type: 'menu-section'
};
const $b53d88dc93e8b19e$export$d868febccc6870c7 = {
    key: 'more-professional-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$4a7c57dd33fc4a14 = {
    key: 'more-casual-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$3758b89123aa4456 = {
    key: 'more-empathetic-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$76118e0d25ac1fef = {
    key: 'translate-nested-menu',
    type: 'nested-menu'
};
const $b53d88dc93e8b19e$export$a526b8293dafd11c = {
    key: 'translate-menu-section',
    type: 'menu-section'
};
const $b53d88dc93e8b19e$export$5836877aa3028c9d = {
    key: 'define-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$92f779590a87713f = {
    key: 'define-group',
    type: 'group'
};
const $b53d88dc93e8b19e$export$8bfe594eeaed8635 = {
    key: 'define-button',
    type: 'button'
};
const $b53d88dc93e8b19e$export$46f6ca06869869c = {
    key: 'text-section',
    type: 'section'
};
const $b53d88dc93e8b19e$export$9821adc8accbec40 = {
    key: 'text-section-primary-toolbar',
    type: 'section'
};
const $b53d88dc93e8b19e$export$65db33ca2d38a784 = {
    key: 'text-section-collapsed',
    type: 'section'
};
const $b53d88dc93e8b19e$export$dbb8e55d66b9ce7c = {
    key: 'text-collapsed-group',
    type: 'group'
};
const $b53d88dc93e8b19e$export$50e256f5fa0723b1 = {
    key: 'text-collapsed-menu',
    type: 'menu'
};
const $b53d88dc93e8b19e$export$17de14a70389be62 = {
    key: 'text-styles-group',
    type: 'group'
};
const $b53d88dc93e8b19e$export$e3c7868e9e7f30f = {
    key: 'text-styles-menu',
    type: 'menu'
};
const $b53d88dc93e8b19e$export$61c471f0e406c6cd = {
    key: 'text-styles-menu-section',
    type: 'menu-section'
};
const $b53d88dc93e8b19e$export$a0d395bab4f77bed = {
    key: 'normal-text-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$2469e8506da598d3 = {
    key: 'heading-1-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$a065aede28a4fa60 = {
    key: 'heading-2-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$85070b7c6d42e3bb = {
    key: 'heading-3-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$e78c2531f67b545f = {
    key: 'heading-4-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$a92294de346392be = {
    key: 'heading-5-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$9c3cdc8e6d51ce82 = {
    key: 'heading-6-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$f4b89f87980eb537 = {
    key: 'block-quote-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$acdcd8bfebadff8e = {
    key: 'text-formatting-group',
    type: 'group'
};
const $b53d88dc93e8b19e$export$3efe78988280adb3 = {
    key: 'text-formatting-group-collapsed',
    type: 'group'
};
const $b53d88dc93e8b19e$export$d709b777a6a93241 = {
    key: 'text-formatting-group-inline',
    type: 'group'
};
const $b53d88dc93e8b19e$export$e54b89ebe974229a = {
    key: 'bold-button-group',
    type: 'group'
};
const $b53d88dc93e8b19e$export$eb8680bccd13ec29 = {
    key: 'underline-button-group',
    type: 'group'
};
const $b53d88dc93e8b19e$export$b1308631b6ed4b3 = {
    key: 'text-formatting-hero-button',
    type: 'button'
};
const $b53d88dc93e8b19e$export$1f2df85e05c78a28 = {
    key: 'text-formatting-hero-button-collapsed',
    type: 'button'
};
const $b53d88dc93e8b19e$export$512cce888b603a21 = {
    key: 'bold-button',
    type: 'button'
};
const $b53d88dc93e8b19e$export$8ba429f81350a9a5 = {
    key: 'underline-button',
    type: 'button'
};
const $b53d88dc93e8b19e$export$6ed8e5719ec9c8ca = {
    key: 'text-formatting-menu',
    type: 'menu'
};
const $b53d88dc93e8b19e$export$8bc14fdbfc88e3d = {
    key: 'bold-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$55cababf49d70434 = {
    key: 'italic-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$74aa4c917d0fb179 = {
    key: 'underline-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$9caef6162846aa5f = {
    key: 'strike-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$33821ea6eceb9d13 = {
    key: 'code-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$ee8cb7d7ef764bfe = {
    key: 'subscript-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$85ead1ec02f87839 = {
    key: 'superscript-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$6f16936b77c05f44 = {
    key: 'text-formatting-menu-section',
    type: 'menu-section'
};
const $b53d88dc93e8b19e$export$2d7a9246359565f = {
    key: 'clear-formatting-menu-section',
    type: 'menu-section'
};
const $b53d88dc93e8b19e$export$2577e452f5468087 = {
    key: 'clear-formatting-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$eb99509879c4d1a6 = {
    key: 'text-color-highlight-group',
    type: 'group'
};
const $b53d88dc93e8b19e$export$126ef012ef4d8c5f = {
    key: 'text-color-highlight-menu',
    type: 'menu'
};
const $b53d88dc93e8b19e$export$70638f1e77085913 = {
    key: 'text-color-highlight-menu-section',
    type: 'menu-section'
};
const $b53d88dc93e8b19e$export$ebd1271b08f151b0 = {
    key: 'text-color-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$bae2fe42c2b86102 = {
    key: 'highlight-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$267f9526bd36c2c = {
    key: 'clear-color-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$36cf1d476157a47d = {
    key: 'alignment-group',
    type: 'group'
};
const $b53d88dc93e8b19e$export$b9d75d8ec913c411 = {
    key: 'alignment-menu',
    type: 'menu'
};
const $b53d88dc93e8b19e$export$a7d30f7c1c00dd6e = {
    key: 'alignment-menu-section',
    type: 'menu-section'
};
const $b53d88dc93e8b19e$export$fb5e83c02abc1116 = {
    key: 'align-left-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$920b9c1f02074883 = {
    key: 'align-center-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$77c582b2c8fa437c = {
    key: 'align-right-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$cfa2bcff371b7719 = {
    key: 'lists-indentation-group',
    type: 'group'
};
const $b53d88dc93e8b19e$export$e24e846ad969dbb4 = {
    key: 'lists-indentation-group-collapsed',
    type: 'group'
};
const $b53d88dc93e8b19e$export$18e3c58ea662f7ad = {
    key: 'lists-indentation-group-inline',
    type: 'group'
};
const $b53d88dc93e8b19e$export$93963c53c29fc835 = {
    key: 'bullet-list-button-group',
    type: 'group'
};
const $b53d88dc93e8b19e$export$6c8387a14e0128fe = {
    key: 'bullet-list-button',
    type: 'button'
};
const $b53d88dc93e8b19e$export$f625e29dbd38e447 = {
    key: 'lists-indentation-hero-button-collapsed',
    type: 'button'
};
const $b53d88dc93e8b19e$export$8709d937e93456c5 = {
    key: 'lists-indentation-hero-button',
    type: 'button'
};
const $b53d88dc93e8b19e$export$77b7fc28d250a53f = {
    key: 'lists-indentation-menu',
    type: 'menu'
};
const $b53d88dc93e8b19e$export$21a99ac537934e71 = {
    key: 'lists-indendation-menu-section',
    type: 'menu-section'
};
const $b53d88dc93e8b19e$export$fc39a5dc74747fed = {
    key: 'bullet-list-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$9d64032e4ea1097c = {
    key: 'numbered-list-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$d6bac99c24b8cdfd = {
    key: 'task-list-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$87678574248a0249 = {
    key: 'indent-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$8fc4080aa2f8adc2 = {
    key: 'outdent-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$8be58f85d6f2b208 = {
    key: 'insert-block-section',
    type: 'section'
};
const $b53d88dc93e8b19e$export$a55d93db15cde50c = {
    key: 'code-block-group',
    type: 'group'
};
const $b53d88dc93e8b19e$export$22d0f50f2ec2f1a8 = {
    key: 'code-block-button',
    type: 'button'
};
const $b53d88dc93e8b19e$export$6265c903e79c43eb = {
    key: 'task-list-group',
    type: 'group'
};
const $b53d88dc93e8b19e$export$9634f504f88ede38 = {
    key: 'task-list-button',
    type: 'button'
};
const $b53d88dc93e8b19e$export$ce4671f9066f5c48 = {
    key: 'media-group',
    type: 'group'
};
const $b53d88dc93e8b19e$export$37025ad4bfe1d2aa = {
    key: 'media-button',
    type: 'button'
};
const $b53d88dc93e8b19e$export$f4c921ea7ce3d48a = {
    key: 'mention-group',
    type: 'group'
};
const $b53d88dc93e8b19e$export$450b9a588cdf3949 = {
    key: 'mention-button',
    type: 'button'
};
const $b53d88dc93e8b19e$export$6ca7976638436c6 = {
    key: 'emoji-group',
    type: 'group'
};
const $b53d88dc93e8b19e$export$a4310034b096a4ad = {
    key: 'emoji-button',
    type: 'button'
};
const $b53d88dc93e8b19e$export$f746b10bd135ebe5 = {
    key: 'layout-group',
    type: 'group'
};
const $b53d88dc93e8b19e$export$bc099bce567fd020 = {
    key: 'layout-button',
    type: 'button'
};
const $b53d88dc93e8b19e$export$19b0175d8da45496 = {
    key: 'table-group',
    type: 'group'
};
const $b53d88dc93e8b19e$export$c37ae5d099679682 = {
    key: 'table-button',
    type: 'button'
};
const $b53d88dc93e8b19e$export$c796ec87818935d5 = {
    key: 'table-size-picker',
    type: 'button'
};
const $b53d88dc93e8b19e$export$2db6abe323bf312e = {
    key: 'insert-group',
    type: 'group'
};
const $b53d88dc93e8b19e$export$2b79c1387bf4ea1b = {
    key: 'insert-button',
    type: 'button'
};
const $b53d88dc93e8b19e$export$1fc1401e9e5d8a = {
    key: 'linking-section',
    type: 'section'
};
const $b53d88dc93e8b19e$export$87f2f2ff3eb62f79 = {
    key: 'linking-group',
    type: 'group'
};
const $b53d88dc93e8b19e$export$3d214445dcf942f2 = {
    key: 'linking-button',
    type: 'button'
};
const $b53d88dc93e8b19e$export$457818231baddd40 = {
    key: 'collab-section',
    type: 'section'
};
const $b53d88dc93e8b19e$export$8978fe8e689744cc = {
    key: 'comment-group',
    type: 'group'
};
const $b53d88dc93e8b19e$export$f97beb46382b3388 = {
    key: 'comment-hero-button',
    type: 'button'
};
const $b53d88dc93e8b19e$export$d757fc54a1831d82 = {
    key: 'apps-section',
    type: 'section'
};
const $b53d88dc93e8b19e$export$c3f44bc1025dceb2 = {
    key: 'track-changes-section',
    type: 'section'
};
const $b53d88dc93e8b19e$export$b3d4f2cdc057cba1 = {
    key: 'undo-changes-group',
    type: 'group'
};
const $b53d88dc93e8b19e$export$f13c32a4c68c0806 = {
    key: 'undo-button',
    type: 'button'
};
const $b53d88dc93e8b19e$export$e149a5154bb9b44 = {
    key: 'redo-changes-group',
    type: 'group'
};
const $b53d88dc93e8b19e$export$1fb249ec6ca34dd0 = {
    key: 'redo-button',
    type: 'button'
};
const $b53d88dc93e8b19e$export$8e3cd3ec14c6efc = {
    key: 'track-changes-group',
    type: 'group'
};
const $b53d88dc93e8b19e$export$9cfd2622f07061e0 = {
    key: 'track-changes-button',
    type: 'button'
};
const $b53d88dc93e8b19e$export$cb18e5ae740a3f22 = {
    key: 'overflow-section',
    type: 'section'
};
const $b53d88dc93e8b19e$export$932f82408ad2af53 = {
    key: 'overflow-group',
    type: 'group'
};
const $b53d88dc93e8b19e$export$6583eb3a2765795b = {
    key: 'overflow-menu',
    type: 'menu'
};
const $b53d88dc93e8b19e$export$cefae60670d357d0 = {
    key: 'pin-menu-section',
    type: 'menu-section'
};
const $b53d88dc93e8b19e$export$76d22fa71bc28346 = {
    key: 'pin-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$1b5ea0d5074f7d18 = {
    key: 'overflow-section-primary-toolbar',
    type: 'section'
};
const $b53d88dc93e8b19e$export$a481b12c04259be8 = {
    key: 'overflow-group-primary-toolbar',
    type: 'group'
};
const $b53d88dc93e8b19e$export$b0bb124d5687709e = {
    key: 'overflow-menu-primary-toolbar',
    type: 'menu'
};
const $b53d88dc93e8b19e$export$6d497f3df1049a22 = {
    key: 'pin-section',
    type: 'section'
};
const $b53d88dc93e8b19e$export$762436e7516a2365 = {
    key: 'pin-group',
    type: 'group'
};
const $b53d88dc93e8b19e$export$cfefbb6355b14379 = {
    key: 'pin-button',
    type: 'button'
};
const $b53d88dc93e8b19e$export$dd76f40d6548a654 = {
    key: 'loom-menu-section',
    type: 'menu-section'
};
const $b53d88dc93e8b19e$export$4ac3fd1884a40118 = {
    key: 'loom-menu-item',
    type: 'menu-item'
};
const $b53d88dc93e8b19e$export$debff7788300c3ff = {
    key: 'selection-extension-menu-section',
    type: 'menu-section'
};

});

parcelRegister("6996L", function(module, exports) {
$parcel$export(module.exports, "TOOLBAR_RANK", () => $dc137f44fa0001cb$export$bc7b81cc80d86c30);
$parcel$export(module.exports, "AI_SECTION_RANK", () => $dc137f44fa0001cb$export$466bb91cec477703);
$parcel$export(module.exports, "ROVO_GROUP_RANK", () => $dc137f44fa0001cb$export$ff4863cfaec82192);
$parcel$export(module.exports, "ROVO_GROUP_DISPLAY_SMALL_RANK", () => $dc137f44fa0001cb$export$bc7ded9825806f2);
$parcel$export(module.exports, "DEFINE_GROUP_RANK", () => $dc137f44fa0001cb$export$322be3308b7fba35);
$parcel$export(module.exports, "IMPROVE_WRITING_GROUP_RANK", () => $dc137f44fa0001cb$export$6f336126efb2136d);
$parcel$export(module.exports, "HERO_PROMPT_BUTTON_GROUP_RANK", () => $dc137f44fa0001cb$export$5eed3dfe1bf849e5);
$parcel$export(module.exports, "ROVO_MENU_RANK", () => $dc137f44fa0001cb$export$dd95f65f4139e5c7);
$parcel$export(module.exports, "ROVO_PROMPT_MENU_SECTION_RANK", () => $dc137f44fa0001cb$export$bfac571871e409b2);
$parcel$export(module.exports, "CHANGE_TONE_MENU_RANK", () => $dc137f44fa0001cb$export$e63f50c00e536f07);
$parcel$export(module.exports, "CHANGE_TONE_MENU_SECTION_RANK", () => $dc137f44fa0001cb$export$b55028e61899c679);
$parcel$export(module.exports, "TRANSLATE_MENU_RANK", () => $dc137f44fa0001cb$export$6f11aef2061f527c);
$parcel$export(module.exports, "TEXT_SECTION_RANK", () => $dc137f44fa0001cb$export$6784d5340d4a1b21);
$parcel$export(module.exports, "TEXT_SECTION_PRIMARY_TOOLBAR_RANK", () => $dc137f44fa0001cb$export$a3445a42840bc6d9);
$parcel$export(module.exports, "TEXT_COLLAPSED_MENU_RANK", () => $dc137f44fa0001cb$export$d5a685ed621e9024);
$parcel$export(module.exports, "TEXT_STYLES_GROUP_RANK", () => $dc137f44fa0001cb$export$26a9865aa120e992);
$parcel$export(module.exports, "TEXT_STYLES_MENU_RANK", () => $dc137f44fa0001cb$export$51921362eebd85ab);
$parcel$export(module.exports, "TEXT_STYLES_MENU_SECTION_RANK", () => $dc137f44fa0001cb$export$6449a65588a19d38);
$parcel$export(module.exports, "TEXT_FORMAT_GROUP_RANK", () => $dc137f44fa0001cb$export$9cdaceac32c6b4d8);
$parcel$export(module.exports, "TEXT_FORMAT_GROUP_COLLAPSED_RANK", () => $dc137f44fa0001cb$export$6d00774ee584bc52);
$parcel$export(module.exports, "TEXT_FORMAT_MENU_RANK", () => $dc137f44fa0001cb$export$669a394c241c9256);
$parcel$export(module.exports, "TEXT_FORMATTING_MENU_SECTION_RANK", () => $dc137f44fa0001cb$export$20900530b02fcff9);
$parcel$export(module.exports, "CLEAR_FORMARTTING_MENU_SECTION_RANK", () => $dc137f44fa0001cb$export$b62a699881de3ad5);
$parcel$export(module.exports, "LISTS_INDENTATION_GROUP_RANK", () => $dc137f44fa0001cb$export$bbc17a51edaecf5e);
$parcel$export(module.exports, "LISTS_INDENTATION_GROUP_COLLAPSED_RANK", () => $dc137f44fa0001cb$export$c57e1bc67b28ed16);
$parcel$export(module.exports, "LISTS_INDENTATION_MENU_RANK", () => $dc137f44fa0001cb$export$29d19572f6bf97d3);
$parcel$export(module.exports, "LISTS_INDENTATION_MENU_SECTION_RANK", () => $dc137f44fa0001cb$export$70af84b45a4dbc54);
$parcel$export(module.exports, "ALIGNMENT_GROUP_RANK", () => $dc137f44fa0001cb$export$f2b3800989381ab8);
$parcel$export(module.exports, "ALIGNMENT_MENU_RANK", () => $dc137f44fa0001cb$export$50e3ab1607836660);
$parcel$export(module.exports, "ALIGNMENT_MENU_SECTION_RANK", () => $dc137f44fa0001cb$export$fe18fd9800ea0b78);
$parcel$export(module.exports, "TEXT_COLOR_HIGHLIGHT_GROUP_RANK", () => $dc137f44fa0001cb$export$ae4377fbd160eba4);
$parcel$export(module.exports, "TEXT_COLOR_HIGHLIGHT_MENU_RANK", () => $dc137f44fa0001cb$export$7aebf1f83f92aec4);
$parcel$export(module.exports, "TEXT_COLOR_HIGHLIGHT_MENU_SECTION_RANK", () => $dc137f44fa0001cb$export$6d61bddc04226fae);
$parcel$export(module.exports, "INSERT_BLOCK_SECTION_RANK", () => $dc137f44fa0001cb$export$d501e2da4fccd3d9);
$parcel$export(module.exports, "TASK_LIST_GROUP_RANK", () => $dc137f44fa0001cb$export$ca5c9182c556b0ba);
$parcel$export(module.exports, "MEDIA_GROUP_RANK", () => $dc137f44fa0001cb$export$41b6a2bde3ffc16c);
$parcel$export(module.exports, "CODE_BLOCK_GROUP_RANK", () => $dc137f44fa0001cb$export$2e369b4fbf595d64);
$parcel$export(module.exports, "MENTION_GROUP_RANK", () => $dc137f44fa0001cb$export$9834991fe1fe77a);
$parcel$export(module.exports, "EMOJI_GROUP_RANK", () => $dc137f44fa0001cb$export$5e431f0b402bc573);
$parcel$export(module.exports, "LAYOUT_GROUP_RANK", () => $dc137f44fa0001cb$export$18725f40b7ed45c9);
$parcel$export(module.exports, "TABLE_GROUP_RANK", () => $dc137f44fa0001cb$export$3b68d352d79ba4dc);
$parcel$export(module.exports, "INSERT_GROUP_RANK", () => $dc137f44fa0001cb$export$6b93bebdb0c4f64b);
$parcel$export(module.exports, "LINKING_SECTION_RANK", () => $dc137f44fa0001cb$export$c7c28a2a4f553552);
$parcel$export(module.exports, "LINKING_GROUP_RANK", () => $dc137f44fa0001cb$export$400d2c257bc9421e);
$parcel$export(module.exports, "COLLAB_SECTION_RANK", () => $dc137f44fa0001cb$export$efde8251fb2b89d5);
$parcel$export(module.exports, "TRACK_CHANGES_SECTION_RANK", () => $dc137f44fa0001cb$export$6795fbb63d664162);
$parcel$export(module.exports, "UNDO_CHANGES_GROUP_RANK", () => $dc137f44fa0001cb$export$8b9f9ebddc5f6d72);
$parcel$export(module.exports, "REDO_CHANGES_GROUP_RANK", () => $dc137f44fa0001cb$export$faf3ae5c01b97598);
$parcel$export(module.exports, "TRACK_CHANGES_GROUP_RANK", () => $dc137f44fa0001cb$export$e9551bb6af82297a);
$parcel$export(module.exports, "OVERFLOW_SECTION_RANK", () => $dc137f44fa0001cb$export$d63a7078a6c0dc57);
$parcel$export(module.exports, "OVERFLOW_GROUP_RANK", () => $dc137f44fa0001cb$export$7aecad5ed6bcab55);
$parcel$export(module.exports, "OVERFLOW_MENU_RANK", () => $dc137f44fa0001cb$export$ea9c3eff8619984);
$parcel$export(module.exports, "PIN_MENU_SECTION_RANK", () => $dc137f44fa0001cb$export$510811eb0f5e0b21);
$parcel$export(module.exports, "OVERFLOW_SECTION_PRIMARY_TOOLBAR_RANK", () => $dc137f44fa0001cb$export$3bdd20aa1e9eee2);
$parcel$export(module.exports, "OVERFLOW_GROUP_PRIMARY_TOOLBAR_RANK", () => $dc137f44fa0001cb$export$dc811b512e84a8a4);
$parcel$export(module.exports, "OVERFLOW_MENU_PRIMARY_TOOLBAR_RANK", () => $dc137f44fa0001cb$export$9cc8eee968218e62);
$parcel$export(module.exports, "PIN_SECTION_RANK", () => $dc137f44fa0001cb$export$58a4b339bb5abbc1);
$parcel$export(module.exports, "PIN_GROUP_RANK", () => $dc137f44fa0001cb$export$cb4d99d2936acb14);
$parcel$export(module.exports, "LOOM_MENU_SECTION_RANK", () => $dc137f44fa0001cb$export$d27db3643df90b4d);

var $3KjUM = parcelRequire("3KjUM");
const $dc137f44fa0001cb$export$bc7b81cc80d86c30 = {
    [(0, $3KjUM.AI_SECTION).key]: 100,
    [(0, $3KjUM.AI_VIEW_SECTION).key]: 100,
    [(0, $3KjUM.TEXT_SECTION).key]: 200,
    /* Same rank as TEXT_SECTION as only one is ever shown at a time */ [(0, $3KjUM.TEXT_SECTION_COLLAPSED).key]: 200,
    [(0, $3KjUM.INSERT_BLOCK_SECTION).key]: 300,
    [(0, $3KjUM.LINKING_SECTION).key]: 400,
    [(0, $3KjUM.COLLAB_SECTION).key]: 500,
    [(0, $3KjUM.APPS_SECTION).key]: 600,
    [(0, $3KjUM.TRACK_CHANGES_SECTION).key]: 700,
    [(0, $3KjUM.OVERFLOW_SECTION).key]: 800,
    [(0, $3KjUM.PIN_SECTION).key]: 900,
    [(0, $3KjUM.OVERFLOW_SECTION_PRIMARY_TOOLBAR).key]: 1000
};
const $dc137f44fa0001cb$export$466bb91cec477703 = {
    [(0, $3KjUM.ROVO_GROUP).key]: 100,
    [(0, $3KjUM.ROVO_GROUP_DISPLAY_SMALL).key]: 100,
    [(0, $3KjUM.ROVO_GROUP_PRIMARY_TOOLBAR).key]: 100,
    [(0, $3KjUM.DEFINE_GROUP).key]: 200,
    [(0, $3KjUM.IMPROVE_WRITING_GROUP).key]: 300,
    [(0, $3KjUM.HERO_PROMPT_BUTTON_GROUP).key]: 300
};
const $dc137f44fa0001cb$export$ff4863cfaec82192 = {
    [(0, $3KjUM.ROVO_HERO_BUTTON).key]: 100,
    [(0, $3KjUM.ROVO_WRITE_BUTTON_PRIMARY_TOOLBAR).key]: 100,
    [(0, $3KjUM.ROVO_MENU).key]: 200
};
const $dc137f44fa0001cb$export$bc7ded9825806f2 = {
    [(0, $3KjUM.ROVO_HERO_BUTTON).key]: 100,
    [(0, $3KjUM.ROVO_MENU_DISPLAY_SMALL).key]: 200
};
const $dc137f44fa0001cb$export$322be3308b7fba35 = {
    [(0, $3KjUM.DEFINE_BUTTON).key]: 100
};
const $dc137f44fa0001cb$export$6f336126efb2136d = {
    [(0, $3KjUM.IMPROVE_WRITING_BUTTON).key]: 100
};
const $dc137f44fa0001cb$export$5eed3dfe1bf849e5 = {
    [(0, $3KjUM.HERO_PROMPT_BUTTON).key]: 100
};
const $dc137f44fa0001cb$export$dd95f65f4139e5c7 = {
    [(0, $3KjUM.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).key]: 100,
    [(0, $3KjUM.ROVO_PROMPT_MENU_SECTION).key]: 100
};
const $dc137f44fa0001cb$export$bfac571871e409b2 = {
    [(0, $3KjUM.IMPROVE_WRITING_MENU_ITEM).key]: 100,
    [(0, $3KjUM.HERO_PROMPT_MENU_ITEM).key]: 100,
    [(0, $3KjUM.SPELLING_AND_GRAMMAR_MENU_ITEM).key]: 100,
    [(0, $3KjUM.CHANGE_TONE_NESTED_MENU).key]: 200,
    [(0, $3KjUM.MAKE_SHORTER_MENU_ITEM).key]: 300,
    [(0, $3KjUM.MAKE_LONGER_MENU_ITEM).key]: 400,
    [(0, $3KjUM.TRANSLATE_NESTED_MENU).key]: 500,
    [(0, $3KjUM.DEFINE_MENU_ITEM).key]: 600
};
const $dc137f44fa0001cb$export$e63f50c00e536f07 = {
    [(0, $3KjUM.CHANGE_TONE_MENU_SECTION).key]: 100
};
const $dc137f44fa0001cb$export$b55028e61899c679 = {
    [(0, $3KjUM.MORE_PROFESSIONAL_MENU_ITEM).key]: 100,
    [(0, $3KjUM.MORE_CASUAL_MENU_ITEM).key]: 200,
    [(0, $3KjUM.MORE_EMPATHETIC_MENU_ITEM).key]: 300
};
const $dc137f44fa0001cb$export$6f11aef2061f527c = {
    [(0, $3KjUM.TRANSLATE_MENU_SECTION).key]: 100
};
const $dc137f44fa0001cb$export$6784d5340d4a1b21 = {
    [(0, $3KjUM.TEXT_STYLES_GROUP).key]: 100,
    [(0, $3KjUM.TEXT_FORMATTING_GROUP).key]: 200,
    [(0, $3KjUM.LISTS_INDENTATION_GROUP).key]: 300,
    [(0, $3KjUM.ALIGNMENT_GROUP).key]: 400,
    [(0, $3KjUM.TEXT_COLOR_HIGHLIGHT_GROUP).key]: 500
};
const $dc137f44fa0001cb$export$a3445a42840bc6d9 = {
    [(0, $3KjUM.TEXT_STYLES_GROUP).key]: 100,
    [(0, $3KjUM.BOLD_BUTTON_GROUP).key]: 200,
    [(0, $3KjUM.UNDERLINE_BUTTON_GROUP).key]: 300,
    [(0, $3KjUM.TEXT_FORMATTING_GROUP).key]: 400,
    [(0, $3KjUM.BULLETED_LIST_BUTTON_GROUP).key]: 500,
    [(0, $3KjUM.LISTS_INDENTATION_GROUP).key]: 600,
    [(0, $3KjUM.ALIGNMENT_GROUP).key]: 700,
    [(0, $3KjUM.TEXT_COLOR_HIGHLIGHT_GROUP).key]: 800
};
const $dc137f44fa0001cb$export$b3332537c956e2f5 = {
    [(0, $3KjUM.TEXT_COLLAPSED_GROUP).key]: 100
};
const $dc137f44fa0001cb$export$d0c8ffa085b6d177 = {
    [(0, $3KjUM.TEXT_COLLAPSED_MENU).key]: 100
};
const $dc137f44fa0001cb$export$d5a685ed621e9024 = {
    [(0, $3KjUM.TEXT_STYLES_MENU_SECTION).key]: 100,
    [(0, $3KjUM.TEXT_FORMATTING_MENU_SECTION).key]: 200,
    [(0, $3KjUM.CLEAR_FORMARTTING_MENU_SECTION).key]: 300,
    [(0, $3KjUM.LISTS_INDENTATION_MENU_SECTION).key]: 400,
    [(0, $3KjUM.ALIGNMENT_MENU_SECTION).key]: 500,
    [(0, $3KjUM.TEXT_COLOR_HIGHLIGHT_MENU_SECTION).key]: 600
};
const $dc137f44fa0001cb$export$26a9865aa120e992 = {
    [(0, $3KjUM.TEXT_STYLES_MENU).key]: 100
};
const $dc137f44fa0001cb$export$51921362eebd85ab = {
    [(0, $3KjUM.TEXT_STYLES_MENU_SECTION).key]: 100
};
const $dc137f44fa0001cb$export$6449a65588a19d38 = {
    [(0, $3KjUM.NORMAL_TEXT_MENU_ITEM).key]: 100,
    [(0, $3KjUM.HEADING_1_MENU_ITEM).key]: 200,
    [(0, $3KjUM.HEADING_2_MENU_ITEM).key]: 300,
    [(0, $3KjUM.HEADING_3_MENU_ITEM).key]: 400,
    [(0, $3KjUM.HEADING_4_MENU_ITEM).key]: 500,
    [(0, $3KjUM.HEADING_5_MENU_ITEM).key]: 600,
    [(0, $3KjUM.HEADING_6_MENU_ITEM).key]: 700,
    [(0, $3KjUM.BLOCK_QUOTE_MENU_ITEM).key]: 800
};
const $dc137f44fa0001cb$export$9cdaceac32c6b4d8 = {
    [(0, $3KjUM.TEXT_FORMATTING_HERO_BUTTON).key]: 100,
    [(0, $3KjUM.TEXT_FORMATTING_MENU).key]: 200
};
const $dc137f44fa0001cb$export$6d00774ee584bc52 = {
    [(0, $3KjUM.TEXT_FORMATTING_HERO_BUTTON_COLLAPSED).key]: 100,
    [(0, $3KjUM.TEXT_FORMATTING_MENU).key]: 200
};
const $dc137f44fa0001cb$export$669a394c241c9256 = {
    [(0, $3KjUM.TEXT_FORMATTING_MENU_SECTION).key]: 100,
    [(0, $3KjUM.CLEAR_FORMARTTING_MENU_SECTION).key]: 200
};
const $dc137f44fa0001cb$export$20900530b02fcff9 = {
    [(0, $3KjUM.BOLD_MENU_ITEM).key]: 100,
    [(0, $3KjUM.ITALIC_MENU_ITEM).key]: 200,
    [(0, $3KjUM.UNDERLINE_MENU_ITEM).key]: 300,
    [(0, $3KjUM.STRIKE_MENU_ITEM).key]: 400,
    [(0, $3KjUM.CODE_MENU_ITEM).key]: 500,
    [(0, $3KjUM.SUBSCRIPT_MENU_ITEM).key]: 600,
    [(0, $3KjUM.SUPERSCRIPT_MENU_ITEM).key]: 700
};
const $dc137f44fa0001cb$export$b62a699881de3ad5 = {
    [(0, $3KjUM.CLEAR_FORMATTING_MENU_ITEM).key]: 100
};
const $dc137f44fa0001cb$export$bbc17a51edaecf5e = {
    [(0, $3KjUM.BULLETED_LIST_BUTTON).key]: 100,
    [(0, $3KjUM.LISTS_INDENTATION_HERO_BUTTON).key]: 200,
    [(0, $3KjUM.LISTS_INDENTATION_MENU).key]: 300
};
const $dc137f44fa0001cb$export$c57e1bc67b28ed16 = {
    [(0, $3KjUM.LISTS_INDENTATION_HERO_BUTTON_COLLAPSED).key]: 100,
    [(0, $3KjUM.LISTS_INDENTATION_MENU).key]: 200
};
const $dc137f44fa0001cb$export$29d19572f6bf97d3 = {
    [(0, $3KjUM.LISTS_INDENTATION_MENU_SECTION).key]: 100
};
const $dc137f44fa0001cb$export$70af84b45a4dbc54 = {
    [(0, $3KjUM.BULLETED_LIST_MENU_ITEM).key]: 100,
    [(0, $3KjUM.NUMBERED_LIST_MENU_ITEM).key]: 200,
    [(0, $3KjUM.TASK_LIST_MENU_ITEM).key]: 300,
    [(0, $3KjUM.OUTDENT_MENU_ITEM).key]: 400,
    [(0, $3KjUM.INDENT_MENU_ITEM).key]: 500
};
const $dc137f44fa0001cb$export$f2b3800989381ab8 = {
    [(0, $3KjUM.ALIGNMENT_MENU).key]: 100
};
const $dc137f44fa0001cb$export$50e3ab1607836660 = {
    [(0, $3KjUM.ALIGNMENT_MENU_SECTION).key]: 100
};
const $dc137f44fa0001cb$export$fe18fd9800ea0b78 = {
    [(0, $3KjUM.ALIGN_LEFT_MENU_ITEM).key]: 100,
    [(0, $3KjUM.ALIGN_CENTER_MENU_ITEM).key]: 200,
    [(0, $3KjUM.ALIGN_RIGHT_MENU_ITEM).key]: 300
};
const $dc137f44fa0001cb$export$ae4377fbd160eba4 = {
    [(0, $3KjUM.TEXT_COLOR_HIGHLIGHT_MENU).key]: 100
};
const $dc137f44fa0001cb$export$7aebf1f83f92aec4 = {
    [(0, $3KjUM.TEXT_COLOR_HIGHLIGHT_MENU_SECTION).key]: 100
};
const $dc137f44fa0001cb$export$6d61bddc04226fae = {
    [(0, $3KjUM.TEXT_COLOR_MENU_ITEM).key]: 100,
    [(0, $3KjUM.HIGHLIGHT_MENU_ITEM).key]: 200,
    [(0, $3KjUM.CLEAR_COLOR_MENU_ITEM).key]: 300
};
const $dc137f44fa0001cb$export$d501e2da4fccd3d9 = {
    [(0, $3KjUM.TASK_LIST_GROUP).key]: 100,
    [(0, $3KjUM.MEDIA_GROUP).key]: 200,
    [(0, $3KjUM.CODE_BLOCK_GROUP).key]: 300,
    [(0, $3KjUM.MENTION_GROUP).key]: 400,
    [(0, $3KjUM.EMOJI_GROUP).key]: 500,
    [(0, $3KjUM.LAYOUT_GROUP).key]: 600,
    [(0, $3KjUM.TABLE_GROUP).key]: 700,
    [(0, $3KjUM.INSERT_GROUP).key]: 800
};
const $dc137f44fa0001cb$export$ca5c9182c556b0ba = {
    [(0, $3KjUM.TASK_LIST_BUTTON).key]: 100
};
const $dc137f44fa0001cb$export$41b6a2bde3ffc16c = {
    [(0, $3KjUM.MEDIA_BUTTON).key]: 100
};
const $dc137f44fa0001cb$export$2e369b4fbf595d64 = {
    [(0, $3KjUM.CODE_BLOCK_BUTTON).key]: 100
};
const $dc137f44fa0001cb$export$9834991fe1fe77a = {
    [(0, $3KjUM.MENTION_BUTTON).key]: 100
};
const $dc137f44fa0001cb$export$5e431f0b402bc573 = {
    [(0, $3KjUM.EMOJI_BUTTON).key]: 100
};
const $dc137f44fa0001cb$export$18725f40b7ed45c9 = {
    [(0, $3KjUM.LAYOUT_BUTTON).key]: 100
};
const $dc137f44fa0001cb$export$3b68d352d79ba4dc = {
    [(0, $3KjUM.TABLE_BUTTON).key]: 100,
    [(0, $3KjUM.TABLE_SIZE_PICKER).key]: 200
};
const $dc137f44fa0001cb$export$6b93bebdb0c4f64b = {
    [(0, $3KjUM.INSERT_BUTTON).key]: 100
};
const $dc137f44fa0001cb$export$c7c28a2a4f553552 = {
    [(0, $3KjUM.LINKING_GROUP).key]: 100
};
const $dc137f44fa0001cb$export$400d2c257bc9421e = {
    [(0, $3KjUM.LINKING_BUTTON).key]: 100
};
const $dc137f44fa0001cb$export$efde8251fb2b89d5 = {
    [(0, $3KjUM.COMMENT_GROUP).key]: 100
};
const $dc137f44fa0001cb$export$4f59ebca6ea8293b = {
    [(0, $3KjUM.COMMENT_HERO_BUTTON).key]: 100
};
const $dc137f44fa0001cb$export$6795fbb63d664162 = {
    [(0, $3KjUM.UNDO_CHANGES_GROUP).key]: 100,
    [(0, $3KjUM.REDO_CHANGES_GROUP).key]: 200,
    [(0, $3KjUM.TRACK_CHANGES_GROUP).key]: 300
};
const $dc137f44fa0001cb$export$8b9f9ebddc5f6d72 = {
    [(0, $3KjUM.UNDO_BUTTON).key]: 100
};
const $dc137f44fa0001cb$export$faf3ae5c01b97598 = {
    [(0, $3KjUM.REDO_BUTTON).key]: 100
};
const $dc137f44fa0001cb$export$e9551bb6af82297a = {
    [(0, $3KjUM.TRACK_CHANGES_BUTTON).key]: 100
};
const $dc137f44fa0001cb$export$d63a7078a6c0dc57 = {
    [(0, $3KjUM.OVERFLOW_GROUP).key]: 100
};
const $dc137f44fa0001cb$export$7aecad5ed6bcab55 = {
    [(0, $3KjUM.OVERFLOW_MENU).key]: 100
};
const $dc137f44fa0001cb$export$ea9c3eff8619984 = {
    [(0, $3KjUM.PIN_MENU_SECTION).key]: 100,
    [(0, $3KjUM.LOOM_MENU_SECTION).key]: 200,
    [(0, $3KjUM.SELECTION_EXTENSION_MENU_SECTION).key]: 300
};
const $dc137f44fa0001cb$export$510811eb0f5e0b21 = {
    [(0, $3KjUM.PIN_MENU_ITEM).key]: 100
};
const $dc137f44fa0001cb$export$3bdd20aa1e9eee2 = {
    [(0, $3KjUM.OVERFLOW_GROUP_PRIMARY_TOOLBAR).key]: 100
};
const $dc137f44fa0001cb$export$dc811b512e84a8a4 = {
    [(0, $3KjUM.OVERFLOW_MENU_PRIMARY_TOOLBAR).key]: 100
};
const $dc137f44fa0001cb$export$9cc8eee968218e62 = {
    [(0, $3KjUM.LOOM_MENU_SECTION).key]: 100
};
const $dc137f44fa0001cb$export$58a4b339bb5abbc1 = {
    [(0, $3KjUM.PIN_GROUP).key]: 100
};
const $dc137f44fa0001cb$export$cb4d99d2936acb14 = {
    [(0, $3KjUM.PIN_BUTTON).key]: 100
};
const $dc137f44fa0001cb$export$d27db3643df90b4d = {
    [(0, $3KjUM.LOOM_MENU_ITEM).key]: 100
};

});

parcelRegister("jEUaN", function(module, exports) {
$parcel$export(module.exports, "LinkButton", () => $b7f53592c21b664d$export$29d11c0fe2fc51d8);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bMFKb = parcelRequire("bMFKb");

var $cxXTK = parcelRequire("cxXTK");

var $6Exgk = parcelRequire("6Exgk");

var $46A2h = parcelRequire("46A2h");

var $cV8sz = parcelRequire("cV8sz");
var $aDNj8 = parcelRequire("aDNj8");
var $64R2q = parcelRequire("64R2q");
const $b7f53592c21b664d$export$29d11c0fe2fc51d8 = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const canInsertLink = (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'hyperlink'
    ], (state)=>state?.hyperlinkState?.canInsertLink ?? true);
    const onClick = ()=>{
        api?.core.actions.execute(api?.hyperlink.commands.showLinkToolbar((0, $bMFKb.INPUT_METHOD).FLOATING_TB));
    };
    const isEnabled = canInsertLink;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $64R2q.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6Exgk.ToolTipContent), {
            description: formatMessage((0, $46A2h.toolbarInsertBlockMessages).link),
            keymap: (0, $6Exgk.addLink)
        }),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aDNj8.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cV8sz))), {
                label: formatMessage((0, $46A2h.toolbarInsertBlockMessages).link),
                size: "small"
            }),
            onClick: onClick,
            testId: 'editor-toolbar__link-button',
            isDisabled: !isEnabled
        })
    });
};

});
parcelRegister("aDNj8", function(module, exports) {
$parcel$export(module.exports, "ToolbarButton", () => $396293bae1aa05a8$export$e5c1a33878e86e9e);
/* ToolbarButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $46R8N = parcelRequire("46R8N");

var $7K3rS = parcelRequire("7K3rS");
const $396293bae1aa05a8$var$styles = {
    button: "_zulp12x7 _2rko12b0 _11c82smr _1e0c1txw _bfhk1w7a _o5721q9c _4cvr1h6o _1bah1h6o _1tke1f4h _syaz1gjq _19bvu2gc _u5f3u2gc _1ah3idpf _g0pbkb7n _oh03h2mm",
    enabled: "_irr3166n _1di61dty",
    disabled: "_syaz1lh4 _80om13gf",
    selected: "_bfhkfg4m _syazaqb7 _irr3i1yw _1di619ru"
};
const $396293bae1aa05a8$export$e5c1a33878e86e9e = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ iconBefore: iconBefore, children: children, onClick: onClick, isSelected: isSelected, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, 'aria-controls': ariaControls, 'data-ds--level': dataDsLevel, onBlur: onBlur, onFocus: onFocus, testId: testId, id: id, isDisabled: isDisabled, ariaKeyshortcuts: ariaKeyshortcuts, label: label, interactionName: interactionName }, ref)=>{
    const { preventDefaultOnMouseDown: preventDefaultOnMouseDown, isDisabled: ctxDisabled } = (0, $7K3rS.useToolbarUI)();
    const disabled = Boolean(ctxDisabled || isDisabled);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $46R8N.default), {
        ref: ref,
        xcss: (0, $6qaBj.cx)($396293bae1aa05a8$var$styles.button, disabled ? $396293bae1aa05a8$var$styles.disabled : isSelected ? $396293bae1aa05a8$var$styles.selected : $396293bae1aa05a8$var$styles.enabled),
        "aria-pressed": isSelected,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        "aria-controls": ariaControls,
        "aria-keyshortcuts": ariaKeyshortcuts,
        "aria-label": label,
        "data-ds--level": dataDsLevel,
        onClick: onClick,
        onBlur: onBlur,
        onFocus: onFocus,
        testId: testId,
        id: id,
        isDisabled: disabled,
        onMouseDown: (event)=>{
            if (preventDefaultOnMouseDown) event.preventDefault();
        },
        "data-toolbar-component": "button",
        interactionName: interactionName,
        children: [
            iconBefore,
            children
        ]
    });
});

});
parcelRegister("7K3rS", function(module, exports) {
$parcel$export(module.exports, "useToolbarUI", () => $7f5e317a8d7f86c2$export$e7063f2520f6adf8);
$parcel$export(module.exports, "ToolbarUIProvider", () => $7f5e317a8d7f86c2$export$ae8c3f290017c42a);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $7f5e317a8d7f86c2$var$ToolbarUIContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    onDropdownOpenChanged: ()=>{},
    preventDefaultOnMouseDown: false,
    isDisabled: false,
    popupsMountPoint: undefined,
    fireAnalyticsEvent: undefined,
    keyboardNavigation: undefined
});
const $7f5e317a8d7f86c2$export$e7063f2520f6adf8 = ()=>{
    const context = (0, $eJOHy.useContext)($7f5e317a8d7f86c2$var$ToolbarUIContext);
    if (!context) throw new Error('useToolbarUI must be used within ToolbarUIContext');
    return context;
};
const $7f5e317a8d7f86c2$export$ae8c3f290017c42a = ({ children: children, onDropdownOpenChanged: onDropdownOpenChanged, preventDefaultOnMouseDown: preventDefaultOnMouseDown, isDisabled: isDisabled, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, fireAnalyticsEvent: fireAnalyticsEvent, keyboardNavigation: keyboardNavigation })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($7f5e317a8d7f86c2$var$ToolbarUIContext.Provider, {
        value: {
            onDropdownOpenChanged: onDropdownOpenChanged,
            preventDefaultOnMouseDown: preventDefaultOnMouseDown,
            isDisabled: isDisabled,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            fireAnalyticsEvent: fireAnalyticsEvent,
            keyboardNavigation: keyboardNavigation
        },
        children: children
    });
};

});


parcelRegister("64R2q", function(module, exports) {
$parcel$export(module.exports, "ToolbarTooltip", () => $9dc82eb2278a40ea$export$7293ce116b97b92a);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");
const $9dc82eb2278a40ea$export$7293ce116b97b92a = ({ content: content, children: children, position: position = 'top', delay: delay })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: content,
        position: position,
        delay: delay,
        children: children
    });
};

});



parcelRegister("4W4Vf", function(module, exports) {
$parcel$export(module.exports, "getToolbarConfig", () => $a780a0ad71bf734c$export$86ce8f8241c20a3);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $iKozC = parcelRequire("iKozC");

var $bMFKb = parcelRequire("bMFKb");
var $97Qim = parcelRequire("97Qim");

var $6C2m6 = parcelRequire("6C2m6");

var $cxXTK = parcelRequire("cxXTK");

var $bvdaU = parcelRequire("bvdaU");

var $53A9i = parcelRequire("53A9i");
var $4AqYB = parcelRequire("4AqYB");

var $jx6gl = parcelRequire("jx6gl");


var $b5R53 = parcelRequire("b5R53");

var $grDTV = parcelRequire("grDTV");

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");

var $gTr6H = parcelRequire("gTr6H");

var $dQl2w = parcelRequire("dQl2w");

var $8rAKL = parcelRequire("8rAKL");

var $eGOwo = parcelRequire("eGOwo");

var $92xoS = parcelRequire("92xoS");

var $eBKSl = parcelRequire("eBKSl");

var $jfXvp = parcelRequire("jfXvp");

var $68iXk = parcelRequire("68iXk");
/* type guard for edit links */ function $a780a0ad71bf734c$var$isEditLink(linkMark) {
    return linkMark.pos !== undefined;
}
const $a780a0ad71bf734c$var$dispatchAnalytics = (dispatch, state, analyticsBuilder, editorAnalyticsApi)=>{
    if (dispatch) {
        const { tr: tr } = state;
        editorAnalyticsApi?.attachAnalyticsEvent(analyticsBuilder((0, $bMFKb.ACTION_SUBJECT_ID).HYPERLINK))(tr);
        dispatch(tr);
    }
};
const $a780a0ad71bf734c$var$visitHyperlink = (editorAnalyticsApi)=>(state, dispatch)=>{
        $a780a0ad71bf734c$var$dispatchAnalytics(dispatch, state, (0, $97Qim.buildVisitedLinkPayload), editorAnalyticsApi);
        return true;
    };
function $a780a0ad71bf734c$var$getLinkText(activeLinkMark, state) {
    if (!activeLinkMark.node) return undefined;
    const textToUrl = (0, $grDTV.normalizeUrl)(activeLinkMark.node.text);
    const linkMark = activeLinkMark.node.marks.find((mark)=>mark.type === state.schema.marks.link);
    const linkHref = linkMark && linkMark.attrs.href;
    if (textToUrl === linkHref) return undefined;
    return activeLinkMark.node.text;
}
const $a780a0ad71bf734c$var$selector = (states)=>{
    return {
        timesViewed: states.hyperlinkState?.timesViewed,
        inputMethod: states.hyperlinkState?.inputMethod,
        searchSessionId: states.hyperlinkState?.searchSessionId
    };
};
function $a780a0ad71bf734c$export$a46cebff622c3cae({ linkPickerOptions: linkPickerOptions = {}, onSubmit: onSubmit, displayText: displayText, displayUrl: displayUrl, providerFactory: providerFactory, view: view, onCancel: onCancel, invokeMethod: invokeMethod, lpLinkPicker: lpLinkPicker, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback, pluginInjectionApi: pluginInjectionApi }) {
    const { timesViewed: timesViewed, inputMethod: inputMethod, searchSessionId: searchSessionId } = (0, $cxXTK.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'hyperlink'
    ], $a780a0ad71bf734c$var$selector);
    // This is constant rather than dynamic - because if someone's already got a hyperlink toolbar open,
    // we don't want to dynamically change it on them as this would cause data loss if they've already
    // started typing in the fields.
    const isOffline = (0, $eJOHy.useRef)(pluginInjectionApi?.connectivity?.sharedState.currentState()?.mode === 'offline');
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bvdaU.HyperlinkAddToolbar), {
        linkPickerOptions: linkPickerOptions,
        onSubmit: onSubmit,
        displayText: displayText,
        displayUrl: displayUrl,
        providerFactory: providerFactory,
        view: view,
        onCancel: onCancel,
        invokeMethod: invokeMethod,
        lpLinkPicker: lpLinkPicker,
        onClose: onClose,
        onEscapeCallback: onEscapeCallback,
        onClickAwayCallback: onClickAwayCallback,
        timesViewed: timesViewed,
        inputMethod: inputMethod,
        searchSessionId: searchSessionId,
        isOffline: isOffline.current
    });
}
const $a780a0ad71bf734c$export$86ce8f8241c20a3 = (options, pluginInjectionApi)=>(state, intl, providerFactory)=>{
        if (options.disableFloatingToolbar) return;
        const isToolbarAIFCEnabled = Boolean(pluginInjectionApi?.toolbar);
        const linkState = (0, $jfXvp.stateKey).getState(state);
        const activeLinkMark = linkState?.activeLinkMark;
        // If range selection, we don't show hyperlink floating toolbar.
        // Text Formattting toolbar is shown instaed.
        if (state.selection instanceof (0, $3lIcL.TextSelection) && state.selection.to !== state.selection.from && activeLinkMark?.type === 'EDIT' && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) return;
        const { formatMessage: formatMessage } = intl;
        const editorCardActions = pluginInjectionApi?.card?.actions;
        const editorAnalyticsApi = pluginInjectionApi?.analytics?.actions;
        const lpLinkPicker = options.lpLinkPicker ?? true;
        if (activeLinkMark) {
            const hyperLinkToolbar = {
                title: 'Hyperlink floating controls',
                nodeType: [
                    state.schema.nodes.text,
                    state.schema.nodes.paragraph,
                    state.schema.nodes.heading,
                    state.schema.nodes.taskItem,
                    state.schema.nodes.decisionItem,
                    state.schema.nodes.caption
                ].filter((nodeType)=>!!nodeType),
                align: 'left',
                className: activeLinkMark.type.match('INSERT|EDIT_INSERTED') ? 'hyperlink-floating-toolbar' : '',
                // getDomRef by default uses view.state.selection.from to position the toolbar.
                // However, when the user clicks in right after the link the view.state.selection.from references to the dom after the selection.
                // So instead we want to use the activeLinkMark.pos which has been calculated as the position before the click so that would be the link node
                getDomRef: activeLinkMark && (activeLinkMark.type === 'EDIT_INSERTED' || activeLinkMark.type === 'EDIT') && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? (view)=>{
                    const domRef = (0, $BmspC.findDomRefAtPos)(activeLinkMark.pos, view.domAtPos.bind(view));
                    return domRef instanceof HTMLElement ? domRef : undefined;
                } : undefined
            };
            switch(activeLinkMark.type){
                case 'EDIT':
                    {
                        const { pos: pos, node: node } = activeLinkMark;
                        const linkMark = node.marks.filter((mark)=>mark.type === state.schema.marks.link);
                        const link = linkMark[0] && linkMark[0].attrs.href;
                        const isValidUrl = (0, $iKozC.isSafeUrl)(link);
                        const labelOpenLink = formatMessage(isValidUrl ? (0, $53A9i.linkMessages).openLink : (0, $4AqYB.linkToolbarMessages).unableToOpenLink);
                        // TODO: ED-14403 - investigate why these are not translating?
                        const labelUnlink = formatMessage((0, $4AqYB.linkToolbarMessages).unlink);
                        const editLink = formatMessage((0, $4AqYB.linkToolbarMessages).editLink);
                        const metadata = {
                            url: link,
                            title: ''
                        };
                        if (activeLinkMark.node.text) metadata.title = activeLinkMark.node.text;
                        const areAnyNewToolbarFlagsEnabled = (0, $jx6gl.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar));
                        const cardActions = pluginInjectionApi?.card?.actions;
                        const startingToolbarItems = cardActions?.getStartingToolbarItems(intl, link, (0, $eBKSl.editInsertedLink)(editorAnalyticsApi), metadata, areAnyNewToolbarFlagsEnabled ? state : undefined) ?? [
                            {
                                id: 'editor.link.edit',
                                testId: 'editor.link.edit',
                                type: 'button',
                                onClick: (0, $eBKSl.editInsertedLink)(editorAnalyticsApi),
                                title: editLink,
                                showTitle: areAnyNewToolbarFlagsEnabled ? false : true,
                                metadata: metadata,
                                icon: areAnyNewToolbarFlagsEnabled ? (0, (/*@__PURE__*/$parcel$interopDefault($gTr6H))) : undefined
                            },
                            {
                                type: 'separator'
                            }
                        ];
                        const openLinkButton = {
                            id: 'editor.link.openLink',
                            testId: 'editor.link.openLink',
                            type: 'button',
                            disabled: !isValidUrl,
                            target: '_blank',
                            href: isValidUrl ? link : undefined,
                            onClick: $a780a0ad71bf734c$var$visitHyperlink(editorAnalyticsApi),
                            title: labelOpenLink,
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8rAKL))),
                            className: 'hyperlink-open-link',
                            metadata: metadata,
                            tabIndex: null
                        };
                        const unlinkButton = {
                            id: 'editor.link.unlink',
                            testId: 'editor.link.unlink',
                            type: 'button',
                            onClick: (0, $6C2m6.commandWithMetadata)((0, $eBKSl.removeLink)(pos, editorAnalyticsApi), {
                                inputMethod: (0, $bMFKb.INPUT_METHOD).FLOATING_TB
                            }),
                            title: labelUnlink,
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dQl2w))),
                            tabIndex: null
                        };
                        const items = [
                            ...startingToolbarItems,
                            ...areAnyNewToolbarFlagsEnabled ? [
                                unlinkButton,
                                {
                                    type: 'separator',
                                    fullHeight: true
                                },
                                openLinkButton,
                                {
                                    type: 'separator',
                                    fullHeight: true
                                }
                            ] : [
                                openLinkButton,
                                {
                                    type: 'separator'
                                },
                                unlinkButton,
                                {
                                    type: 'separator'
                                }
                            ],
                            {
                                type: 'copy-button',
                                items: [
                                    {
                                        state: state,
                                        formatMessage: formatMessage,
                                        markType: state.schema.marks.link
                                    }
                                ]
                            },
                            ...cardActions?.getEndingToolbarItems(intl, link) ?? []
                        ];
                        return {
                            ...hyperLinkToolbar,
                            height: 32,
                            width: 250,
                            items: items,
                            scrollable: true
                        };
                    }
                case 'EDIT_INSERTED':
                case 'INSERT':
                    {
                        let link;
                        if ($a780a0ad71bf734c$var$isEditLink(activeLinkMark) && activeLinkMark.node) {
                            const linkMark = activeLinkMark.node.marks.filter((mark)=>mark.type === state.schema.marks.link);
                            link = linkMark[0] && linkMark[0].attrs.href;
                        }
                        const displayText = $a780a0ad71bf734c$var$isEditLink(activeLinkMark) ? $a780a0ad71bf734c$var$getLinkText(activeLinkMark, state) : linkState.activeText;
                        const popupHeight = lpLinkPicker ? (0, $4d66e472a8adb592$export$c635b83728f81640) : (0, $4d66e472a8adb592$export$c04a5ad015d45447);
                        // Removing popupWidth to ensure that we the popup always positions setting positon left instead of flipping to position right
                        // inside of a narrow space like Preview panel
                        const popupWidth = !lpLinkPicker && (0, $eGOwo.fg)('platform_editor_link_picker_width_fix') ? undefined : (0, $4d66e472a8adb592$export$a62aa932daf22ffe);
                        return {
                            ...hyperLinkToolbar,
                            preventPopupOverflow: true,
                            height: popupHeight,
                            width: popupWidth,
                            items: [
                                {
                                    type: 'custom',
                                    fallback: [],
                                    disableArrowNavigation: true,
                                    render: (view, idx)=>{
                                        if (!view) return null;
                                        const Toolbar = /*#__PURE__*/ (0, $gt9Am.jsx)($a780a0ad71bf734c$export$a46cebff622c3cae, {
                                            pluginInjectionApi: pluginInjectionApi,
                                            view: view,
                                            linkPickerOptions: options?.linkPicker,
                                            lpLinkPicker: lpLinkPicker,
                                            displayUrl: link,
                                            displayText: displayText || '',
                                            providerFactory: providerFactory,
                                            onCancel: ()=>view.focus(),
                                            onEscapeCallback: (0, $eBKSl.onEscapeCallback)(editorCardActions),
                                            onClickAwayCallback: (0, $eBKSl.onClickAwayCallback),
                                            onSubmit: (href, title = '', displayText, inputMethod, analytic)=>{
                                                const isEdit = $a780a0ad71bf734c$var$isEditLink(activeLinkMark);
                                                const action = isEdit ? (0, $bMFKb.ACTION).UPDATED : (0, $bMFKb.ACTION).INSERTED;
                                                const skipAnalytics = (0, $68iXk.toolbarKey).getState(state)?.skipAnalytics ?? false;
                                                const command = isEdit ? (0, $6C2m6.commandWithMetadata)((0, $eBKSl.updateLink)(href, displayText || title, activeLinkMark.pos), {
                                                    action: action,
                                                    inputMethod: inputMethod,
                                                    sourceEvent: analytic
                                                }) : (0, $eBKSl.insertLinkWithAnalytics)(inputMethod, activeLinkMark.from, activeLinkMark.to, href, editorCardActions, editorAnalyticsApi, title, displayText, skipAnalytics, analytic);
                                                command(view.state, view.dispatch, view);
                                                view.focus();
                                            }
                                        }, idx);
                                        return isToolbarAIFCEnabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b5R53.UserIntentPopupWrapper), {
                                            api: pluginInjectionApi,
                                            children: Toolbar
                                        }) : Toolbar;
                                    }
                                }
                            ]
                        };
                    }
            }
        }
        return;
    };

});
parcelRegister("bvdaU", function(module, exports) {
$parcel$export(module.exports, "HyperlinkAddToolbar", () => $540fb4737fcb7e70$export$8be6a38cd66ace65);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $bMFKb = parcelRequire("bMFKb");

var $4sxxB = parcelRequire("4sxxB");

var $ge12G = parcelRequire("ge12G");

var $4DYEn = parcelRequire("4DYEn");
/**
 * Wraps around the editor's onSubmit handler so that the plugin can interface with the link picker
 */ const $540fb4737fcb7e70$var$onSubmitInterface = (onSubmit)=>({ url: url, title: title, displayText: displayText, rawUrl: rawUrl, meta: meta }, analytic)=>{
        onSubmit(url, title ?? rawUrl, displayText || undefined, meta.inputMethod === 'manual' ? (0, $bMFKb.INPUT_METHOD).MANUAL : (0, $bMFKb.INPUT_METHOD).TYPEAHEAD, analytic);
    };
function $540fb4737fcb7e70$export$8be6a38cd66ace65({ linkPickerOptions: linkPickerOptions = {}, onSubmit: onSubmit, displayText: displayText, displayUrl: displayUrl, providerFactory: providerFactory, view: view, onCancel: onCancel, invokeMethod: invokeMethod, lpLinkPicker: lpLinkPicker, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback, editorAppearance: editorAppearance, inputMethod: inputMethod, searchSessionId: searchSessionId, timesViewed: timesViewed, isOffline: isOffline }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4sxxB.WithProviders), {
        providers: [
            'activityProvider',
            'searchProvider'
        ],
        providerFactory: providerFactory,
        renderNode: ({ activityProvider: activityProvider, searchProvider: searchProvider })=>{
            // If we're offline fallback to HyperlinkAddToolbarComp as we may not have loaded
            // EditorLinkPicker into the bundle
            if (lpLinkPicker && !Boolean(isOffline)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ge12G.EditorLinkPicker), {
                view: view,
                invokeMethod: // Provide `invokeMethod` prop as preferred value (card plugin passes as prop) otherwise assume this
                // is being used from inside the hyperlink plugin and use inputMethod from plugin state
                invokeMethod ?? inputMethod,
                editorAppearance: editorAppearance,
                ...linkPickerOptions,
                url: displayUrl,
                displayText: displayText,
                onSubmit: $540fb4737fcb7e70$var$onSubmitInterface(onSubmit),
                onCancel: onCancel,
                onClose: onClose,
                onEscapeCallback: onEscapeCallback,
                onClickAwayCallback: onClickAwayCallback
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4DYEn.default), {
                activityProvider: activityProvider,
                searchProvider: searchProvider,
                onSubmit: onSubmit,
                displayText: displayText,
                displayUrl: displayUrl,
                view: view,
                onEscapeCallback: onEscapeCallback,
                onClickAwayCallback: onClickAwayCallback,
                inputMethod: inputMethod,
                searchSessionId: searchSessionId,
                timesViewed: timesViewed
            });
        }
    });
}

});
parcelRegister("ge12G", function(module, exports) {
$parcel$export(module.exports, "EditorLinkPicker", () => $87b6bbc09a31053d$export$da2f76555f5c8d0a);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $e2B2h = parcelRequire("e2B2h");

var $ie7Le = parcelRequire("ie7Le");

var $dyNYh = parcelRequire("dyNYh");

var $5x7vO = parcelRequire("5x7vO");
const $87b6bbc09a31053d$export$da2f76555f5c8d0a = ({ view: view, onCancel: onCancel, invokeMethod: invokeMethod = '_unknown', editorAppearance: editorAppearance, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback, ...restProps })=>{
    /**
	 * Track onClose handler in a
	 * ref so that we void needing it in the dependency array
	 * below
	 */ const onCloseRef = (0, $eJOHy.useRef)(onClose);
    (0, $eJOHy.useEffect)(()=>{
        onCloseRef.current = onClose;
    });
    /**
	 * Call onClose on mount, usefull to provide
	 * a handler for performing an action after the component has been
	 * unmounted (e.g. return focus to the editors)
	 */ (0, $eJOHy.useEffect)(()=>()=>onCloseRef.current?.(), []);
    const onEscape = (0, $eJOHy.useCallback)(()=>{
        const { state: state, dispatch: dispatch } = view;
        onEscapeCallback?.(state, dispatch);
        onCancel?.();
    }, [
        view,
        onCancel,
        onEscapeCallback
    ]);
    const onClickAway = (0, $eJOHy.useCallback)(()=>{
        const { state: state, dispatch: dispatch } = view;
        onClickAwayCallback?.(state, dispatch);
        onCancel?.();
    }, [
        view,
        onCancel,
        onClickAwayCallback
    ]);
    const ref = (0, $5x7vO.useEscapeClickaway)(onEscape, onClickAway);
    const analyticsEditorAppearance = (0, $dyNYh.getAnalyticsEditorAppearance)(editorAppearance);
    const analyticsData = (0, $eJOHy.useMemo)(()=>({
            attributes: {
                invokeMethod: invokeMethod,
                location: analyticsEditorAppearance
            },
            // Below is added for the future implementation of Linking Platform namespaced analytic context
            location: analyticsEditorAppearance
        }), [
        invokeMethod,
        analyticsEditorAppearance
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
            data: analyticsData,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ie7Le.default), {
                ...restProps,
                onCancel: onEscape
            })
        })
    });
};

});
parcelRegister("ie7Le", function(module, exports) {
$parcel$export(module.exports, "default", () => $ddd7d0de1cad6667$export$2e2bcd8739ae039);
parcelRequire("bn7wb");
var $aAuez = parcelRequire("aAuez");

var $8KszW = parcelRequire("8KszW");

const $ddd7d0de1cad6667$var$LazyLinkPickerComponent = (0, $aAuez.lazyForPaint)(()=>(parcelRequire("5Fntp")).then(({ LinkPicker: LinkPicker })=>({
            default: LinkPicker
        })));
var // Must be a default export to be able to support prop docs
// eslint-disable-next-line import/no-default-export
$ddd7d0de1cad6667$export$2e2bcd8739ae039 = (0, $8KszW.composeLinkPicker)($ddd7d0de1cad6667$var$LazyLinkPickerComponent);

});
parcelRegister("bn7wb", function(module, exports) {
$parcel$export(module.exports, "lazyForPaint", () => (parcelRequire("aAuez")).lazyForPaint);
$parcel$export(module.exports, "lazyAfterPaint", () => (parcelRequire("aAuez")).lazyAfterPaint);
$parcel$export(module.exports, "lazy", () => (parcelRequire("aAuez")).lazy);
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("7qz8r")).LazySuspense);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("l7ep7")).useLazyPhase);
parcelRequire("7veda");
var $8V4xR = parcelRequire("8V4xR");

var $MkKnc = parcelRequire("MkKnc");

var $aAuez = parcelRequire("aAuez");
parcelRequire("4XKbm");
var $7eb8v = parcelRequire("7eb8v");
var $esFTx = parcelRequire("esFTx");
parcelRequire("jv91R");
var $7qz8r = parcelRequire("7qz8r");
parcelRequire("1llka");
var $l7ep7 = parcelRequire("l7ep7");

var $hrq5I = parcelRequire("hrq5I");

});
parcelRegister("7veda", function(module, exports) {
$parcel$export(module.exports, "getConfig", () => $576673b9f1b70022$export$44487a86467333c3);
$parcel$export(module.exports, "setConfig", () => $576673b9f1b70022$export$940a7873bb071df8);
$parcel$export(module.exports, "MODE", () => (parcelRequire("8V4xR")).MODE);

var $8V4xR = parcelRequire("8V4xR");
const $576673b9f1b70022$var$DEFAULT_CROSS_ORIGIN = undefined;
const $576673b9f1b70022$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $576673b9f1b70022$var$DEFAULT_MODE = (0, $8V4xR.MODE).HYDRATE;
const $576673b9f1b70022$var$DEFAULT_RETRY = 2;
const $576673b9f1b70022$var$config = {
    crossOrigin: $576673b9f1b70022$var$DEFAULT_CROSS_ORIGIN,
    manifest: $576673b9f1b70022$var$DEFAULT_MANIFEST,
    mode: $576673b9f1b70022$var$DEFAULT_MODE,
    retry: $576673b9f1b70022$var$DEFAULT_RETRY
};
const $576673b9f1b70022$export$44487a86467333c3 = ()=>$576673b9f1b70022$var$config;
const $576673b9f1b70022$export$940a7873bb071df8 = (nextConfig)=>{
    var _nextConfig$crossOrig, _nextConfig$manifest, _nextConfig$mode, _nextConfig$retry;
    $576673b9f1b70022$var$config.crossOrigin = (_nextConfig$crossOrig = nextConfig.crossOrigin) != null ? _nextConfig$crossOrig : $576673b9f1b70022$var$DEFAULT_CROSS_ORIGIN;
    $576673b9f1b70022$var$config.manifest = (_nextConfig$manifest = nextConfig.manifest) != null ? _nextConfig$manifest : $576673b9f1b70022$var$DEFAULT_MANIFEST;
    $576673b9f1b70022$var$config.mode = (_nextConfig$mode = nextConfig.mode) != null ? _nextConfig$mode : $576673b9f1b70022$var$DEFAULT_MODE;
    $576673b9f1b70022$var$config.retry = (_nextConfig$retry = nextConfig.retry) != null ? _nextConfig$retry : $576673b9f1b70022$var$DEFAULT_RETRY;
};

});
parcelRegister("8V4xR", function(module, exports) {
$parcel$export(module.exports, "MODE", () => $67e72c25add85f29$export$e48589d9e4824227);
const $67e72c25add85f29$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};

});


parcelRegister("MkKnc", function(module, exports) {

var $8h7zW = parcelRequire("8h7zW");

var $7veda = parcelRequire("7veda");
parcelRequire("1llka");
var $eGDOl = parcelRequire("eGDOl");
var $l7ep7 = parcelRequire("l7ep7");

var $a1Dox = parcelRequire("a1Dox");
const $091493b8f27d5831$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $7veda.setConfig)(config);
        (0, $eGDOl.LISTENERS).length = 0;
        (0, $l7ep7.setCurrent)(0);
        if (!(0, $a1Dox.isNodeEnvironment)()) (0, $8h7zW.collect)();
    }
};

});
parcelRegister("8h7zW", function(module, exports) {
$parcel$export(module.exports, "collect", () => $6065ca3c1e226813$export$bb44f104e3c54dae);

var $7veda = parcelRequire("7veda");
var $8V4xR = parcelRequire("8V4xR");

var $bzDJE = parcelRequire("bzDJE");

var $9WyUY = parcelRequire("9WyUY");

var $1NKbK = parcelRequire("1NKbK");
const $6065ca3c1e226813$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll('input[data-lazy-begin]');
    const { mode: mode } = (0, $7veda.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $8V4xR.MODE).RENDER ? (0, $9WyUY.cloneElements)(markers[i], lazyBegin) : (0, $1NKbK.refElements)(markers[i], lazyBegin);
        if ((0, $bzDJE.COLLECTED).has(lazyBegin)) (0, $bzDJE.COLLECTED).get(lazyBegin).push(value);
        else (0, $bzDJE.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};

});
parcelRegister("bzDJE", function(module, exports) {
$parcel$export(module.exports, "PHASE", () => $86d1c92cf7d83ac0$export$2cc7a2eaaea7809f);
$parcel$export(module.exports, "COLLECTED", () => $86d1c92cf7d83ac0$export$4831ef3968ea94ef);
const $86d1c92cf7d83ac0$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $86d1c92cf7d83ac0$export$4831ef3968ea94ef = new Map();

});

parcelRegister("9WyUY", function(module, exports) {
$parcel$export(module.exports, "cloneElements", () => $73d49dd0c38c2a1c$export$c42217d53a7ebafb);
const $73d49dd0c38c2a1c$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement('div');
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break; // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};

});

parcelRegister("1NKbK", function(module, exports) {
$parcel$export(module.exports, "refElements", () => $14fe3218cc4e45c4$export$c69443129766a7fc);
const $14fe3218cc4e45c4$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};

});


parcelRegister("1llka", function(module, exports) {
$parcel$export(module.exports, "LazyPhaseContext", () => (parcelRequire("l7ep7")).LazyPhaseContext);
$parcel$export(module.exports, "setCurrent", () => (parcelRequire("l7ep7")).setCurrent);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("l7ep7")).useLazyPhase);
$parcel$export(module.exports, "LISTENERS", () => (parcelRequire("eGDOl")).LISTENERS);

var $l7ep7 = parcelRequire("l7ep7");

var $eGDOl = parcelRequire("eGDOl");

var $7Peej = parcelRequire("7Peej");

});
parcelRegister("l7ep7", function(module, exports) {
$parcel$export(module.exports, "setCurrent", () => $f5f56cc3db1024b3$export$5f80f094fd31fffd);
$parcel$export(module.exports, "LazyPhaseContext", () => $f5f56cc3db1024b3$export$5a25eca35e5debcb);
$parcel$export(module.exports, "useLazyPhase", () => $f5f56cc3db1024b3$export$1dc361b277327f88);

var $eJOHy = parcelRequire("eJOHy");

var $bzDJE = parcelRequire("bzDJE");

var $eGDOl = parcelRequire("eGDOl");

var $7Peej = parcelRequire("7Peej");
let $f5f56cc3db1024b3$var$CURRENT_PHASE = (0, $bzDJE.PHASE).PAINT;
const $f5f56cc3db1024b3$export$5f80f094fd31fffd = (phase)=>{
    $f5f56cc3db1024b3$var$CURRENT_PHASE = phase;
    (0, $eGDOl.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $f5f56cc3db1024b3$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $eJOHy.createContext)({
    subscribe: (0, $7Peej.createSubscribe)((0, $eGDOl.LISTENERS)),
    currentValue: ()=>$f5f56cc3db1024b3$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $f5f56cc3db1024b3$export$5f80f094fd31fffd((0, $bzDJE.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$f5f56cc3db1024b3$export$5f80f094fd31fffd((0, $bzDJE.PHASE).PAINT)
    }
});
const $f5f56cc3db1024b3$export$1dc361b277327f88 = ()=>{
    const v = (0, $eJOHy.useContext)($f5f56cc3db1024b3$export$5a25eca35e5debcb);
    return v.api;
};

});
parcelRegister("eGDOl", function(module, exports) {
$parcel$export(module.exports, "LISTENERS", () => $ab13de8c68717d57$export$81b9c458a026d68f);
const $ab13de8c68717d57$export$81b9c458a026d68f = [];

});

parcelRegister("7Peej", function(module, exports) {
$parcel$export(module.exports, "createSubscribe", () => $5b2855963721e7ea$export$364097d812234b3f);
const $5b2855963721e7ea$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };

});



parcelRegister("a1Dox", function(module, exports) {
$parcel$export(module.exports, "getExport", () => $74c88e574846d6bd$export$d4c07b1daf44a7f);
$parcel$export(module.exports, "displayNameFromId", () => $74c88e574846d6bd$export$4429f98ef60d2d87);
$parcel$export(module.exports, "isNodeEnvironment", () => $74c88e574846d6bd$export$283635c04a02cc36);
$parcel$export(module.exports, "attrToProp", () => $74c88e574846d6bd$export$62bf630d0de3d781);
$parcel$export(module.exports, "hash", () => (parcelRequire("ed3y6")).default);

var $ed3y6 = parcelRequire("ed3y6");
const $74c88e574846d6bd$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $74c88e574846d6bd$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $74c88e574846d6bd$export$283635c04a02cc36 = ()=>{
    if (typeof window === 'undefined') return true;
    if (window.name === 'nodejs') return true;
    return false;
};
function $74c88e574846d6bd$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}

});
parcelRegister("ed3y6", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5850857827bd3c9$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $a5850857827bd3c9$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});



parcelRegister("aAuez", function(module, exports) {
$parcel$export(module.exports, "lazyForPaint", () => $7b54b80385d7fc57$export$c952e5f94576010e);
$parcel$export(module.exports, "lazyAfterPaint", () => $7b54b80385d7fc57$export$291dd592399bdafa);
$parcel$export(module.exports, "lazy", () => $7b54b80385d7fc57$export$488013bae63b21da);

var $j5vcn = parcelRequire("j5vcn");

var $7veda = parcelRequire("7veda");

var $bzDJE = parcelRequire("bzDJE");

var $a1Dox = parcelRequire("a1Dox");
var $ed3y6 = parcelRequire("ed3y6");

var $b8XF0 = parcelRequire("b8XF0");

var $jA7rF = parcelRequire("jA7rF");

var $c7s3I = parcelRequire("c7s3I");

var $iFrYh = parcelRequire("iFrYh");

var $dcrQD = parcelRequire("dcrQD");

var $dcUz2 = parcelRequire("dcUz2");

var $2f83m = parcelRequire("2f83m");
function $7b54b80385d7fc57$var$_extends() {
    $7b54b80385d7fc57$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7b54b80385d7fc57$var$_extends.apply(this, arguments);
}
function $7b54b80385d7fc57$var$lazyProxy(_loader, { defer: defer = (0, $bzDJE.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $a1Dox.isNodeEnvironment)();
    const dataLazyId = (0, $ed3y6.default)(moduleId);
    const LazyInternal = isServer ? (0, $c7s3I.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: _loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $jA7rF.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $iFrYh.createDeferred)({
            loader: ()=>{
                const { retry: maxAttempts } = (0, $7veda.getConfig)();
                return (0, $dcUz2.retry)(_loader, {
                    delay: (0, $b8XF0.RETRY_DELAY),
                    factor: (0, $b8XF0.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: _loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $a1Dox.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $7veda.getConfig)();
        return (0, $j5vcn.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority != null ? priority : defer === (0, $bzDJE.PHASE).PAINT ? (0, $b8XF0.PRIORITY).HIGH : (0, $b8XF0.PRIORITY).LOW;
        return (0, $dcrQD.preloadAsset)({
            loader: _loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        preload: preload
    });
}
const $7b54b80385d7fc57$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $bzDJE.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $bzDJE.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $bzDJE.PHASE).LAZY
    }
};
function $7b54b80385d7fc57$export$c952e5f94576010e(loader, opts) {
    return $7b54b80385d7fc57$var$lazyProxy(loader, $7b54b80385d7fc57$var$_extends({}, $7b54b80385d7fc57$export$93ca5d3f8675ae4c.lazyForPaint, opts || {}));
}
function $7b54b80385d7fc57$export$291dd592399bdafa(loader, opts) {
    return $7b54b80385d7fc57$var$lazyProxy(loader, $7b54b80385d7fc57$var$_extends({}, $7b54b80385d7fc57$export$93ca5d3f8675ae4c.lazyAfterPaint, opts || {}));
}
function $7b54b80385d7fc57$export$488013bae63b21da(loader, opts) {
    return $7b54b80385d7fc57$var$lazyProxy(loader, $7b54b80385d7fc57$var$_extends({}, $7b54b80385d7fc57$export$93ca5d3f8675ae4c.lazy, opts || {}));
}

});
parcelRegister("j5vcn", function(module, exports) {
$parcel$export(module.exports, "getAssetUrlsFromId", () => $de56af5358c8f987$export$303f43e55cf1ef2f);
const $de56af5358c8f987$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets || !manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};

});

parcelRegister("b8XF0", function(module, exports) {
$parcel$export(module.exports, "PRIORITY", () => $81ceb864b052c80d$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "RETRY_DELAY", () => $81ceb864b052c80d$export$a339266ad71b2447);
$parcel$export(module.exports, "RETRY_FACTOR", () => $81ceb864b052c80d$export$ba64c908e55507fe);
const $81ceb864b052c80d$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $81ceb864b052c80d$export$a339266ad71b2447 = 300;
const $81ceb864b052c80d$export$ba64c908e55507fe = 1;

});

parcelRegister("jA7rF", function(module, exports) {
$parcel$export(module.exports, "createComponentClient", () => $e417279bde8da3e7$export$6898b5504b58699a);

var $eJOHy = parcelRequire("eJOHy");

var $7veda = parcelRequire("7veda");
var $8V4xR = parcelRequire("8V4xR");

var $bzDJE = parcelRequire("bzDJE");
parcelRequire("4XKbm");
var $esFTx = parcelRequire("esFTx");
parcelRequire("1llka");
var $l7ep7 = parcelRequire("l7ep7");
parcelRequire("jv91R");
var $4XL9N = parcelRequire("4XL9N");

var $2f83m = parcelRequire("2f83m");

var $bVeRl = parcelRequire("bVeRl");

var $7fZLe = parcelRequire("7fZLe");

var $hrq5I = parcelRequire("hrq5I");

var $9qVNk = parcelRequire("9qVNk");
function $e417279bde8da3e7$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const ResolvedLazy = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $eJOHy.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $bzDJE.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $bzDJE.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const profiler = (0, $eJOHy.useContext)((0, $hrq5I.ProfilerContext)).current;
        const load = ()=>{
            if (status.started || !status.phase || !status.noWait) return;
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $2f83m.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        }; // Subscribe to LazyWait context, triggering load when until is true
        (0, $9qVNk.useSubscription)({
            context: (0, $esFTx.WaitContext),
            load: load,
            onValue: (v)=>status.noWait = v === 1
        });
        if (defer === (0, $bzDJE.PHASE).AFTER_PAINT) // Subscribe to LazyPhase context, triggering load when own phase starts
        (0, $9qVNk.useSubscription)({
            context: (0, $l7ep7.LazyPhaseContext),
            load: load,
            onValue: (v)=>status.phase = v >= defer
        });
        const { setFallback: setFallback } = (0, $eJOHy.useContext)((0, $4XL9N.LazySuspenseContext));
        (0, $eJOHy.useMemo)(()=>{
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $bzDJE.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return; // override Suspense fallback with magic input wrappers
            const component = (0, $7veda.getConfig)().mode === (0, $8V4xR.MODE).RENDER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bVeRl.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fZLe.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ResolvedLazy, props);
    };
}

});
parcelRegister("4XKbm", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => (parcelRequire("esFTx")).WaitContext);

var $esFTx = parcelRequire("esFTx");

var $7eb8v = parcelRequire("7eb8v");

});
parcelRegister("esFTx", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => $a8742da03f685732$export$9ba3fe09d15de47b);

var $eJOHy = parcelRequire("eJOHy");

var $ddxDA = parcelRequire("ddxDA");
const $a8742da03f685732$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $eJOHy.createContext)({
    subscribe: ()=>(0, $ddxDA.noopCleanup),
    currentValue: ()=>1
});

});
parcelRegister("ddxDA", function(module, exports) {
$parcel$export(module.exports, "noopCleanup", () => $99f694f5596397af$export$276c7dbda7675aec);
const $99f694f5596397af$export$276c7dbda7675aec = ()=>{};

});


parcelRegister("7eb8v", function(module, exports) {

var $eJOHy = parcelRequire("eJOHy");

var $esFTx = parcelRequire("esFTx");
const $54327a9f9e29fe04$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
    const closestWait = (0, $eJOHy.useContext)((0, $esFTx.WaitContext));
    const value = (0, $eJOHy.useRef)(until && closestWait.currentValue() ? 1 : 0);
    const subscribers = (0, $eJOHy.useRef)(new Set());
    const api = (0, $eJOHy.useRef)({
        subscribe: (subscriber)=>{
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current.delete(subscriber);
            };
        },
        currentValue: ()=>value.current
    });
    (0, $eJOHy.useEffect)(()=>{
        // Notify subscribers when until prop or closest until value changes
        const notify = ()=>{
            value.current = closestWait.currentValue() && until ? 1 : 0;
            subscribers.current.forEach((subscriber)=>subscriber());
        };
        notify();
        return closestWait.subscribe(notify);
    }, [
        closestWait,
        until
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $esFTx.WaitContext).Provider, {
        value: api.current
    }, children);
};

});


parcelRegister("jv91R", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("7qz8r")).LazySuspense);
$parcel$export(module.exports, "LazySuspenseContext", () => (parcelRequire("4XL9N")).LazySuspenseContext);

var $7qz8r = parcelRequire("7qz8r");

var $4XL9N = parcelRequire("4XL9N");

});
parcelRegister("7qz8r", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => $56863736a86894e9$export$256c542058532d6f);

var $eJOHy = parcelRequire("eJOHy");

var $a1Dox = parcelRequire("a1Dox");

var $4XL9N = parcelRequire("4XL9N");
class $56863736a86894e9$export$256c542058532d6f extends (0, $eJOHy.Component) {
    constructor(props){
        super(props);
        this.state = {
            // Used on server to render fallback down the tree
            fallback: this.props.fallback,
            // Used on client to replace fallback with magic input
            setFallback: (fallback)=>{
                if (this.hydrationFallback === fallback) return;
                this.hydrationFallback = fallback; // Schedule an update so we force switch from the sibling tree
                // back to the suspense boundary
                if (this.mounted) this.forceUpdate();
            },
            name: this.props.name
        };
        this.hydrationFallback = null;
        this.mounted = false;
        this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $eJOHy.useLayoutEffect)(()=>{
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    if (!outsideSuspense) this.state.setFallback(null);
                };
            }, [
                outsideSuspense
            ]);
            return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
        };
        this.DynamicFallback.displayName = 'DynamicFallback';
    }
    componentDidMount() {
        this.mounted = true;
    }
    renderFallback(outsideSuspense) {
        const { DynamicFallback: DynamicFallback } = this; // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (fallback)=>fallback);
    }
    renderServer() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4XL9N.LazySuspenseContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    renderClient() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4XL9N.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Suspense), {
            fallback: this.renderFallback(false)
        }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
    }
    render() {
        return (0, $a1Dox.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
    }
}

});
parcelRegister("4XL9N", function(module, exports) {
$parcel$export(module.exports, "LazySuspenseContext", () => $39d1408803878497$export$c33990e84065970c);

var $eJOHy = parcelRequire("eJOHy");
const $39d1408803878497$export$c33990e84065970c = /*#__PURE__*/ (0, $eJOHy.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Fragment), null),
    setFallback: ()=>{
        console.warn('Missing <LooselySuspense /> boundary');
    }
});

});



parcelRegister("2f83m", function(module, exports) {
$parcel$export(module.exports, "createLoaderError", () => $1a233ab151dd1ee2$export$c73a6a6f0bf7d425);
const $1a233ab151dd1ee2$export$6aa69c1258005366 = Symbol.for('react-loosely-lazy/loader-error');
const $1a233ab151dd1ee2$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') return Object.assign(error, {
        [$1a233ab151dd1ee2$export$6aa69c1258005366]: true
    });
    return error;
};
const $1a233ab151dd1ee2$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($1a233ab151dd1ee2$export$6aa69c1258005366);

});

parcelRegister("bVeRl", function(module, exports) {
$parcel$export(module.exports, "PlaceholderFallbackRender", () => $8ae08b5f412b712d$export$d55db778a3e1446b);

var $eJOHy = parcelRequire("eJOHy");

var $hrq5I = parcelRequire("hrq5I");
parcelRequire("4XKbm");
var $esFTx = parcelRequire("esFTx");
parcelRequire("jv91R");
var $4XL9N = parcelRequire("4XL9N");
function $8ae08b5f412b712d$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $8ae08b5f412b712d$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $eJOHy.useRef)(null);
    const { current: ssrDomNodes } = (0, $eJOHy.useRef)(content || []);
    const profilerContext = (0, $eJOHy.useContext)((0, $hrq5I.ProfilerContext)).current;
    const waitContext = (0, $eJOHy.useContext)((0, $esFTx.WaitContext));
    const suspenseContext = (0, $eJOHy.useContext)((0, $4XL9N.LazySuspenseContext));
    (0, $eJOHy.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        profilerContext === null || profilerContext.placeholderFallBackMounted(resolveId, suspenseContext.name, !waitContext.currentValue());
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($8ae08b5f412b712d$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            profilerContext === null || profilerContext.placeholderFallBackUnmounted(resolveId, suspenseContext.name, !waitContext.currentValue());
            ssrDomNodes.forEach((node)=>{
                var _node$parentNode;
                return (_node$parentNode = node.parentNode) == null ? void 0 : _node$parentNode.removeChild(node);
            });
        }; // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $8ae08b5f412b712d$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $8ae08b5f412b712d$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};

});
parcelRegister("hrq5I", function(module, exports) {
$parcel$export(module.exports, "GlobalReactLooselyLazyProfiler", () => $cb29326da0127013$export$e2d53c0cbedd2710);
$parcel$export(module.exports, "ProfilerContext", () => $cb29326da0127013$export$8146ab57a3f7a7cb);

var $eJOHy = parcelRequire("eJOHy");
const $cb29326da0127013$export$e2d53c0cbedd2710 = {
    current: null
};
const $cb29326da0127013$export$8146ab57a3f7a7cb = /*#__PURE__*/ (0, $eJOHy.createContext)($cb29326da0127013$export$e2d53c0cbedd2710);

});


parcelRegister("7fZLe", function(module, exports) {
$parcel$export(module.exports, "PlaceholderFallbackHydrate", () => $5489d785fce022f5$export$ca5b8fbc835d95e4);

var $eJOHy = parcelRequire("eJOHy");

var $a1Dox = parcelRequire("a1Dox");
function $5489d785fce022f5$var$_extends() {
    $5489d785fce022f5$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5489d785fce022f5$var$_extends.apply(this, arguments);
}
const $5489d785fce022f5$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id
    }), content.map((el, i)=>{
        const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
        const props = Array.from(attributes).reduce((0, $a1Dox.attrToProp), {
            key: String(i)
        }); // text node
        if (!tagName) return /*#__PURE__*/ (0, $eJOHy.createElement)((0, $eJOHy.Fragment), props, el.textContent); // childless tag
        if (!childNodes.length) return /*#__PURE__*/ (0, $eJOHy.createElement)(tagName.toLowerCase(), props); // tag with content
        return /*#__PURE__*/ (0, $eJOHy.createElement)(tagName.toLowerCase(), $5489d785fce022f5$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: ''
            },
            suppressHydrationWarning: true
        }));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
        type: "hidden",
        "data-lazy-end": id
    }));
};

});

parcelRegister("9qVNk", function(module, exports) {
$parcel$export(module.exports, "useSubscription", () => $6de35f980c3d94e0$export$368b4214baeb914c);

var $eJOHy = parcelRequire("eJOHy");
function $6de35f980c3d94e0$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $eJOHy.useContext)(context);
    (0, $eJOHy.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});


parcelRegister("c7s3I", function(module, exports) {
$parcel$export(module.exports, "createComponentServer", () => $8d2be766ecc6ab62$export$eb2e4b04351cdd9e);

var $j5vcn = parcelRequire("j5vcn");

var $eJOHy = parcelRequire("eJOHy");

var $7veda = parcelRequire("7veda");

var $bzDJE = parcelRequire("bzDJE");
parcelRequire("jv91R");
var $4XL9N = parcelRequire("4XL9N");

var $a1Dox = parcelRequire("a1Dox");

var $2f83m = parcelRequire("2f83m");
function $8d2be766ecc6ab62$var$load(moduleId, loader) {
    try {
        return (0, $a1Dox.getExport)(loader());
    } catch (err) {
        throw (0, $2f83m.createLoaderError)(err);
    }
}
function $8d2be766ecc6ab62$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        var _getAssetUrlsFromId;
        const Resolved = ssr ? $8d2be766ecc6ab62$var$load(moduleId, loader) : null;
        const { fallback: fallback } = (0, $eJOHy.useContext)((0, $4XL9N.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest } = (0, $7veda.getConfig)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": dataLazyId
        }), defer !== (0, $bzDJE.PHASE).LAZY && ((_getAssetUrlsFromId = (0, $j5vcn.getAssetUrlsFromId)(manifest, moduleId)) == null ? void 0 : _getAssetUrlsFromId.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("link", {
                key: url,
                rel: defer === (0, $bzDJE.PHASE).PAINT ? 'preload' : 'prefetch',
                href: url,
                crossOrigin: crossOrigin,
                as: "script"
            }))), Resolved ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Resolved, props) : fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
            type: "hidden",
            "data-lazy-end": dataLazyId
        }));
    };
}

});

parcelRegister("iFrYh", function(module, exports) {
$parcel$export(module.exports, "createDeferred", () => $0381d5b0cf615548$export$e673efccd97e4223);
const $0381d5b0cf615548$export$e673efccd97e4223 = ({ loader: loader, preload: preload })=>{
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: function(_preload) {
            function preload() {
                return _preload.apply(this, arguments);
            }
            preload.toString = function() {
                return _preload.toString();
            };
            return preload;
        }(()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{});
        }),
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            } // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    return deferred;
};

});

parcelRegister("dcrQD", function(module, exports) {
$parcel$export(module.exports, "preloadAsset", () => $99c1ff5e48fc9639$export$25bad4aa00c45355);

var $j5vcn = parcelRequire("j5vcn");

var $ddxDA = parcelRequire("ddxDA");

var $7veda = parcelRequire("7veda");

var $a1Dox = parcelRequire("a1Dox");

var $b8XF0 = parcelRequire("b8XF0");

var $dfXT0 = parcelRequire("dfXT0");

var $hrq5I = parcelRequire("hrq5I");
function $99c1ff5e48fc9639$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $7veda.getConfig)();
    const assets = (0, $j5vcn.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $dfXT0.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $99c1ff5e48fc9639$var$fakePromise = {
    then: ()=>$99c1ff5e48fc9639$var$fakePromise,
    catch: ()=>$99c1ff5e48fc9639$var$fakePromise,
    finally: ()=>$99c1ff5e48fc9639$var$fakePromise
};
function $99c1ff5e48fc9639$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy'); // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $dfXT0.insertLinkTag)(href, rel));
        return $99c1ff5e48fc9639$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {} // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $99c1ff5e48fc9639$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $ddxDA.noopCleanup;
}
function $99c1ff5e48fc9639$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    var _GlobalReactLooselyLa;
    if ((0, $a1Dox.isNodeEnvironment)()) return 0, $ddxDA.noopCleanup;
    (_GlobalReactLooselyLa = (0, $hrq5I.GlobalReactLooselyLazyProfiler).current) == null || _GlobalReactLooselyLa.onPreload(moduleId, priority);
    const rel = priority === (0, $b8XF0.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $99c1ff5e48fc9639$export$3af04dbcb01bad4d,
        $99c1ff5e48fc9639$export$1046fd6a49d5e7a,
        $99c1ff5e48fc9639$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {}
    return 0, $ddxDA.noopCleanup;
}

});
parcelRegister("dfXT0", function(module, exports) {
$parcel$export(module.exports, "insertLinkTag", () => $9a6b213a2be2821b$export$6610512821c8a4ce);

var $hrq5I = parcelRequire("hrq5I");

var $ddxDA = parcelRequire("ddxDA");

var $7veda = parcelRequire("7veda");
function $9a6b213a2be2821b$export$6610512821c8a4ce(href, rel) {
    var _document$head;
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $ddxDA.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $7veda.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $hrq5I.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    (_document$head = document.head) == null || _document$head.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) {
            var _document$head2;
            (_document$head2 = document.head) == null || _document$head2.removeChild(link);
        }
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}

});


parcelRegister("dcUz2", function(module, exports) {
$parcel$export(module.exports, "retry", () => $99d845ced60c5b28$export$9369b12211e1fce4);
const $99d845ced60c5b28$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1; // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
     // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $99d845ced60c5b28$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $99d845ced60c5b28$var$getPolicy = (configuration)=>{
    var _configuration$delay, _configuration$factor, _configuration$maxAtt;
    return {
        delay: Math.max(0, (_configuration$delay = configuration.delay) != null ? _configuration$delay : 0),
        factor: Math.max(0, (_configuration$factor = configuration.factor) != null ? _configuration$factor : 0),
        maxAttempts: Math.max(0, (_configuration$maxAtt = configuration.maxAttempts) != null ? _configuration$maxAtt : 0)
    };
};
function $99d845ced60c5b28$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $99d845ced60c5b28$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $99d845ced60c5b28$var$calculateDelay(context, policy);
        if (delay) await $99d845ced60c5b28$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}

});



parcelRegister("8KszW", function(module, exports) {
$parcel$export(module.exports, "composeLinkPicker", () => $eb8046ac18ca72c4$export$922eb685ceb4a294);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
parcelRequire("bn7wb");
var $7qz8r = parcelRequire("7qz8r");

var $e2B2h = parcelRequire("e2B2h");


var $kunAt = parcelRequire("kunAt");

var $iTs0r = parcelRequire("iTs0r");

var $2HYqy = parcelRequire("2HYqy");

var $Y30qr = parcelRequire("Y30qr");
const $eb8046ac18ca72c4$export$800daf5fbbe96aff = {
    linkPickerRoot: 'link-picker-root'
};
const $eb8046ac18ca72c4$export$a2495bb1f182689d = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: (0, $fb78791935341089$export$fc44104665f4d1e5),
    source: (0, $fb78791935341089$export$fc44104665f4d1e5)
};
const $eb8046ac18ca72c4$var$DefaultRootComponent = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": $eb8046ac18ca72c4$export$800daf5fbbe96aff.linkPickerRoot,
        children: children
    });
};
const $eb8046ac18ca72c4$var$fixedWidthContainerStyles = null;
const $eb8046ac18ca72c4$var$FixedWidthContainer = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        role: "dialog",
        "aria-modal": "false",
        "aria-label": "link-picker",
        ...props,
        className: (0, $hcewu.default)([
            "_1bsb1ubl"
        ])
    });
};
const $eb8046ac18ca72c4$export$922eb685ceb4a294 = (Component)=>{
    return /*#__PURE__*/ (0, $eJOHy.memo)((props)=>{
        const { component: component } = props;
        const RootComponent = component ?? $eb8046ac18ca72c4$var$DefaultRootComponent;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
            data: $eb8046ac18ca72c4$export$a2495bb1f182689d,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kunAt.LinkPickerSessionProvider), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Y30qr.MessagesProvider), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        style: {
                            ['--link-picker-width']: props.disableWidth ? '100%' : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                            `${0, $fb78791935341089$export$bf31a09f182d5584}px`,
                            ['--link-picker-padding-left']: props.paddingLeft ?? "var(--ds-space-200, 16px)",
                            ['--link-picker-padding-right']: props.paddingRight ?? "var(--ds-space-200, 16px)",
                            ['--link-picker-padding-top']: props.paddingTop ?? "var(--ds-space-200, 16px)",
                            ['--link-picker-padding-bottom']: props.paddingBottom ?? "var(--ds-space-200, 16px)"
                        },
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)($eb8046ac18ca72c4$var$FixedWidthContainer, {
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iTs0r.ErrorBoundary), {
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7qz8r.LazySuspense), {
                                    fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2HYqy.LoaderFallback), {
                                        url: props.url,
                                        hideDisplayText: props.hideDisplayText,
                                        isLoadingPlugins: props.isLoadingPlugins,
                                        plugins: props.plugins
                                    }),
                                    children: /*#__PURE__*/ (0, $gt9Am.jsx)(RootComponent, {
                                        ...props,
                                        "data-testid": $eb8046ac18ca72c4$export$800daf5fbbe96aff.linkPickerRoot,
                                        children: /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                                            ...props
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        });
    });
};

});
const $fb78791935341089$export$85183a312807388d = 'media';
const $fb78791935341089$export$fc44104665f4d1e5 = 'linkPicker';
const $fb78791935341089$export$452f1062ecf44be7 = 5;
const $fb78791935341089$export$bf31a09f182d5584 = 342;
const $fb78791935341089$export$542fb16962bf430c = '290px';

parcelRegister("kunAt", function(module, exports) {
$parcel$export(module.exports, "LinkPickerSessionProvider", () => $a9b0b6ac0f090565$export$2f19832fd2d620ca);
$parcel$export(module.exports, "useLinkPickerSessionId", () => $a9b0b6ac0f090565$export$36ecc935abdc3636);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $0DWCX = parcelRequire("0DWCX");
const $a9b0b6ac0f090565$export$c07727f5eddb98f = 'SESSION_UNINITIALIZED';
const $a9b0b6ac0f090565$export$3285420c698bc605 = /*#__PURE__*/ (0, $eJOHy.createContext)($a9b0b6ac0f090565$export$c07727f5eddb98f);
const $a9b0b6ac0f090565$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $eJOHy.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $a9b0b6ac0f090565$export$2f19832fd2d620ca = ({ children: children })=>{
    const { current: sessionId } = (0, $eJOHy.useRef)((0, $aXKmr.v4)());
    (0, $eJOHy.useEffect)(()=>{
        return ()=>(0, $0DWCX.abortUfoExperience)((0, $0DWCX.ufoExperience).mounted, sessionId);
    }, [
        sessionId
    ]);
    $a9b0b6ac0f090565$var$useConstructor(()=>(0, $0DWCX.startUfoExperience)((0, $0DWCX.ufoExperience).mounted, sessionId));
    return /*#__PURE__*/ (0, $gt9Am.jsx)($a9b0b6ac0f090565$export$3285420c698bc605.Provider, {
        value: sessionId,
        children: children
    });
};
const $a9b0b6ac0f090565$export$36ecc935abdc3636 = ()=>(0, $eJOHy.useContext)($a9b0b6ac0f090565$export$3285420c698bc605);

});
parcelRegister("0DWCX", function(module, exports) {
$parcel$export(module.exports, "ufoExperience", () => $e323e12dc8ed89b1$export$f9c7780c574346a2);
$parcel$export(module.exports, "startUfoExperience", () => $e323e12dc8ed89b1$export$5e9287b6a10f8075);
$parcel$export(module.exports, "succeedUfoExperience", () => $e323e12dc8ed89b1$export$c5a5cf072c836c0e);
$parcel$export(module.exports, "failUfoExperience", () => $e323e12dc8ed89b1$export$8dda83bafca11b77);
$parcel$export(module.exports, "abortUfoExperience", () => $e323e12dc8ed89b1$export$b1021040eb94cdca);

var $9iIu4 = parcelRequire("9iIu4");
var $aRnO1 = parcelRequire("aRnO1");
const $e323e12dc8ed89b1$export$f9c7780c574346a2 = {
    mounted: 'component-mounted'
};
const $e323e12dc8ed89b1$var$ufoExperiences = {
    [$e323e12dc8ed89b1$export$f9c7780c574346a2.mounted]: new (0, $9iIu4.ConcurrentExperience)($e323e12dc8ed89b1$export$f9c7780c574346a2.mounted, {
        type: (0, $aRnO1.ExperienceTypes).Load,
        performanceType: (0, $aRnO1.ExperiencePerformanceTypes).PageSegmentLoad,
        platform: {
            component: 'link-picker'
        }
    })
};
const $e323e12dc8ed89b1$export$5e9287b6a10f8075 = (experienceName, id, metadata)=>{
    const experience = $e323e12dc8ed89b1$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (metadata) experience.addMetadata(metadata);
};
const $e323e12dc8ed89b1$export$c5a5cf072c836c0e = (experienceName, id, metadata)=>{
    const experience = $e323e12dc8ed89b1$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: metadata
    });
};
const $e323e12dc8ed89b1$export$8dda83bafca11b77 = (experienceName, id, metadata)=>{
    const experience = $e323e12dc8ed89b1$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: metadata
    });
};
const $e323e12dc8ed89b1$export$b1021040eb94cdca = (experienceName, id, metadata)=>{
    const experience = $e323e12dc8ed89b1$var$ufoExperiences[experienceName].getInstance(id);
    experience.abort({
        metadata: metadata
    });
};

});


parcelRegister("iTs0r", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $7fe0a641749a590b$export$e926676385687eaf);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $0DWCX = parcelRequire("0DWCX");


var $bTQgK = parcelRequire("bTQgK");

var $kunAt = parcelRequire("kunAt");

var $gR1HW = parcelRequire("gR1HW");

var $66Atn = parcelRequire("66Atn");
function $7fe0a641749a590b$export$e926676385687eaf({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const linkPickerSessionId = (0, $kunAt.useLinkPickerSessionId)();
    const handleError = (0, $eJOHy.useCallback)((error, info)=>{
        // Fire Analytics event
        createAnalyticsEvent((0, $bTQgK.default)('ui.linkPicker.unhandledErrorCaught', {
            browserInfo: window?.navigator?.userAgent || 'unknown',
            error: error.toString(),
            componentStack: info?.componentStack ?? ''
        })).fire((0, $fb78791935341089$export$85183a312807388d));
        // Fire UFO failed experience
        (0, $0DWCX.failUfoExperience)((0, $0DWCX.ufoExperience).mounted, linkPickerSessionId);
    }, [
        createAnalyticsEvent,
        linkPickerSessionId
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gR1HW.BaseErrorBoundary), {
        onError: handleError,
        ErrorComponent: (0, $66Atn.ErrorBoundaryFallback),
        children: children
    });
}

});
parcelRegister("bTQgK", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf0e8c7ea1346a5c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::cd5b926575a5c379425d0d72e5339f12>>
 * @codegenCommand yarn workspace @atlaskit/link-picker run codegen-analytics
 */ function $cf0e8c7ea1346a5c$var$createEventPayload(eventKey, attributes) {
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes
    };
}
var $cf0e8c7ea1346a5c$export$2e2bcd8739ae039 = $cf0e8c7ea1346a5c$var$createEventPayload;

});

parcelRegister("gR1HW", function(module, exports) {
$parcel$export(module.exports, "BaseErrorBoundary", () => $54f25fcbe7560c46$export$688779ac61ee945f);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
class $54f25fcbe7560c46$export$688779ac61ee945f extends (0, $eJOHy.Component) {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { children: children, ErrorComponent: ErrorComponent } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError && ErrorComponent) return /*#__PURE__*/ (0, $gt9Am.jsx)(ErrorComponent, {});
        return children;
    }
}

});

parcelRegister("66Atn", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundaryFallback", () => $57609f69915f526c$export$8a28b7e38e4685dd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");


var $g4Asp = parcelRequire("g4Asp");

var $1KMXo = parcelRequire("1KMXo");

var $2vTuF = parcelRequire("2vTuF");
const $57609f69915f526c$var$errorBoundaryFallbackStyles = null;
const $57609f69915f526c$var$messages = (0, $7qGN1.defineMessages)({
    heading: {
        defaultMessage: 'Something went wrong!',
        description: 'Heading displayed when an unhandled error occurs.',
        id: 'fabric.linkPicker.unhandledError.heading'
    },
    description: {
        defaultMessage: 'Try reloading the page.',
        description: 'Body message shown underneath the heading when an unhandled error occurs.',
        id: 'fabric.linkPicker.unhandledError.description'
    }
});
const $57609f69915f526c$export$8a28b7e38e4685dd = ()=>{
    const intl = (0, $lRq8t.default)();
    const header = intl.formatMessage($57609f69915f526c$var$messages.heading);
    const description = intl.formatMessage($57609f69915f526c$var$messages.description);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2vTuF.MinHeightContainer), {
        minHeight: (0, $fb78791935341089$export$542fb16962bf430c),
        "data-testid": "link-picker-root-error-boundary-ui",
        className: (0, $hcewu.default)([
            "_11c81vhk"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1KMXo.EmptyState), {
            header: header,
            renderImage: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $g4Asp.GenericErrorSVG), {}),
            description: description
        })
    });
};

});
parcelRegister("g4Asp", function(module, exports) {
$parcel$export(module.exports, "GenericErrorSVG", () => $db1bd415078f212e$export$e54420a1a27457a4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $db1bd415078f212e$var$SIZE = 96;
const $db1bd415078f212e$var$genericErrorStyles = null;
const $db1bd415078f212e$export$e54420a1a27457a4 = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        viewBox: "0 0 96 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        className: (0, $hcewu.default)([
            "_1bsb16xz _4t3i16xz _1e0c1ule"
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                fill: "#fff",
                d: "M64.861 32.06a27.753 27.753 0 0 0-2.667-4.133 28.187 28.187 0 0 0-3.376-3.669c-6.985-6.311-15.57-6.89-23.609-2.53a30.226 30.226 0 0 0-4.056 2.656 30.624 30.624 0 0 0-3.735 3.4c-6.225 6.717-7.82 15.154-3.505 23.462a28.108 28.108 0 0 0 2.698 4.193 27.67 27.67 0 0 0 3.33 3.62c6.94 6.266 15.518 6.85 23.596 2.507a30.492 30.492 0 0 0 4.23-2.758 30.07 30.07 0 0 0 3.593-3.257c6.252-6.692 7.847-15.161 3.494-23.49h.007Z"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                fill: "#DDDEE1",
                d: "M43.092 66.774c-5.306 0-10.382-1.997-14.75-5.938a30.405 30.405 0 0 1-3.62-3.93 30.243 30.243 0 0 1-2.928-4.553c-4.657-8.961-3.247-18.509 3.871-26.192a33.271 33.271 0 0 1 4.025-3.67 32.834 32.834 0 0 1 4.378-2.869c9.209-4.995 18.816-3.951 26.353 2.86a30.945 30.945 0 0 1 3.665 3.98 30.303 30.303 0 0 1 2.898 4.488c4.705 9.003 3.295 18.565-3.868 26.231a32.148 32.148 0 0 1-3.879 3.515 33.415 33.415 0 0 1-4.562 2.975c-3.858 2.073-7.782 3.1-11.583 3.1v.003Zm2.53-45.486c-3.019 0-6.147.84-9.275 2.54a28.433 28.433 0 0 0-3.735 2.448 28.059 28.059 0 0 0-3.442 3.135c-5.746 6.203-6.86 13.566-3.135 20.736a25.395 25.395 0 0 0 2.472 3.83 25.304 25.304 0 0 0 3.044 3.309c5.99 5.41 13.398 6.182 20.862 2.175a28.02 28.02 0 0 0 3.899-2.545 28.03 28.03 0 0 0 3.31-2.999c5.777-6.182 6.883-13.552 3.124-20.75a25.553 25.553 0 0 0-2.44-3.777 25.848 25.848 0 0 0-3.087-3.358c-3.49-3.153-7.442-4.744-11.59-4.744h-.006Z"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                fill: "#DDDEE1",
                d: "M62.822 59.694c-1.235-1.72-2.562-1.71-3.857-.708-1.215.939-1.54 2.21-.244 3.882l1.48 1.913 4.102-3.174-1.48-1.913Z"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                fill: "#DDDEE1",
                d: "m65.334 60.811-6.159 4.762L70.748 80.54l6.16-4.761L65.333 60.81Z"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                fill: "#B7B9BE",
                d: "m64.344 61.577-4.178 3.23 3.925 5.076 4.178-3.23-3.925-5.076Z"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                fill: "#DDDEE1",
                fillRule: "evenodd",
                d: "M55.057 33.452 36.213 52.296l-2.468-2.469 18.844-18.844 2.468 2.469Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                fill: "#DDDEE1",
                fillRule: "evenodd",
                d: "M52.589 52.296 33.745 33.452l2.468-2.469 18.844 18.844-2.468 2.469Z",
                clipRule: "evenodd"
            })
        ]
    });
};

});

parcelRegister("1KMXo", function(module, exports) {
$parcel$export(module.exports, "EmptyState", () => $dc4e666f89d05f99$export$fddf379e22a74b00);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $806LH = parcelRequire("806LH");

var $2sLVw = parcelRequire("2sLVw");
var $3cMgR = parcelRequire("3cMgR");
const $dc4e666f89d05f99$var$styles = {
    containerV2: "_ca0q1ejb _u5f3oahv _19bvoahv _n3td1jfw _y3gn1h6o"
};
const $dc4e666f89d05f99$export$fddf379e22a74b00 = ({ testId: testId, header: header, description: description, action: action, renderImage: renderImage })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $2sLVw.default), {
        xcss: $dc4e666f89d05f99$var$styles.containerV2,
        testId: testId,
        direction: "column",
        alignItems: "center",
        gap: "space.200",
        children: [
            renderImage?.(),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                size: "small",
                as: "h2",
                children: header
            }),
            description && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                as: "p",
                color: "color.text",
                children: description
            }),
            action && action
        ]
    });
};

});

parcelRegister("2vTuF", function(module, exports) {
$parcel$export(module.exports, "MinHeightContainer", () => $536fd4b57d015f9b$export$42134e2a251518b3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
const $536fd4b57d015f9b$var$minHeightComponentStyles = null;
const $536fd4b57d015f9b$export$42134e2a251518b3 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ className: className, minHeight: minHeight, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1fhb _1bah1h6o _1tke16li",
            className
        ]),
        ...props,
        style: {
            ['--link-picker-min-height']: minHeight
        }
    });
});

});



parcelRegister("2HYqy", function(module, exports) {
$parcel$export(module.exports, "LoaderFallback", () => $1add3bb7eb9fa4e2$export$d96e921133238c41);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7ep4S = parcelRequire("7ep4S");

var $2vTuF = parcelRequire("2vTuF");
const $1add3bb7eb9fa4e2$var$styles = null;
const $1add3bb7eb9fa4e2$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT = '495px';
const $1add3bb7eb9fa4e2$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT = '590px';
const $1add3bb7eb9fa4e2$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT = '545px';
const $1add3bb7eb9fa4e2$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT = '450px';
const $1add3bb7eb9fa4e2$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT = '252px';
const $1add3bb7eb9fa4e2$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT = '155px';
const $1add3bb7eb9fa4e2$var$getEstimatedMinHeight = ({ hideDisplayText: hideDisplayText, isLoadingPlugins: isLoadingPlugins, plugins: plugins, url: url })=>{
    /**
   * "Insert mode" (search results shown initially)
   */ if (!url) {
        /**
     * With tabs
     */ if (plugins && plugins.length > 1 || isLoadingPlugins) return hideDisplayText ? $1add3bb7eb9fa4e2$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT : $1add3bb7eb9fa4e2$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT;
        /**
     * Without tabs
     */ if (plugins?.length === 1) return hideDisplayText ? $1add3bb7eb9fa4e2$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT : $1add3bb7eb9fa4e2$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT;
    }
    return hideDisplayText ? $1add3bb7eb9fa4e2$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT : $1add3bb7eb9fa4e2$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT;
};
const $1add3bb7eb9fa4e2$export$d96e921133238c41 = (props)=>{
    const minHeight = $1add3bb7eb9fa4e2$var$getEstimatedMinHeight(props);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2vTuF.MinHeightContainer), {
        minHeight: minHeight,
        "data-testid": "link-picker-root-loader-boundary-ui",
        className: (0, $hcewu.default)([
            "_4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
            testId: "link-picker.component-loading-indicator",
            interactionName: props.name || 'link-picker-loading',
            size: "medium"
        })
    });
};

});

parcelRegister("Y30qr", function(module, exports) {
$parcel$export(module.exports, "MessagesProvider", () => $aa70be8195ee421d$export$54320b51a950d54a);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $34dxJ = parcelRequire("34dxJ");
const $aa70be8195ee421d$export$54320b51a950d54a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $34dxJ.LazyMessagesProvider), {
        children: children
    });
};

});
parcelRegister("34dxJ", function(module, exports) {
$parcel$export(module.exports, "LazyMessagesProvider", () => $0ac74dc6ffe13f36$export$d013d33430f9fb4b);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $3JwXA = parcelRequire("3JwXA");

var $5fDnW = parcelRequire("5fDnW");

var $cyJCq = parcelRequire("cyJCq");
const $0ac74dc6ffe13f36$export$d013d33430f9fb4b = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3JwXA.default), {
        defaultMessages: (0, $5fDnW.default),
        loaderFn: (0, $cyJCq.fetchMessagesForLocale),
        children: children
    });
};

});
parcelRegister("5fDnW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $5d97aea06f1eadff$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $hFeg8 = parcelRequire("hFeg8");
var $5d97aea06f1eadff$export$2e2bcd8739ae039 = (0, $hFeg8.default);

});
parcelRegister("hFeg8", function(module, exports) {
$parcel$export(module.exports, "default", () => $1858bd7463fc44e1$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $1858bd7463fc44e1$export$2e2bcd8739ae039 = {
    'fabric.linkPicker.button.cancel': 'Cancel',
    'fabric.linkPicker.button.insert': 'Insert',
    'fabric.linkPicker.button.save': 'Save',
    'fabric.linkPicker.clearLink': 'Clear',
    'fabric.linkPicker.clearLinkText': 'Clear text',
    'fabric.linkPicker.hyperlink.searchLinkResults': '{count, plural, =0 {no results} one {# result} other {# results}} found',
    'fabric.linkPicker.linkAriaLabel': 'Type or paste a link into the field',
    'fabric.linkPicker.linkHelperTextAriaLabel': 'Link display helper text',
    'fabric.linkPicker.linkHelperTextLabel': 'Give this link a title or description',
    'fabric.linkPicker.linkInvalid': 'Enter a valid URL.',
    'fabric.linkPicker.linkLabel': 'Link',
    'fabric.linkPicker.linkPlaceholder': 'Paste a link',
    'fabric.linkPicker.linkTextAriaLabel': 'Link display text',
    'fabric.linkPicker.linkTextLabel': 'Display text (optional)',
    'fabric.linkPicker.linkTextPlaceholder': 'Text to display',
    'fabric.linkPicker.listTitle.recentlyViewed': 'Recently Viewed',
    'fabric.linkPicker.listTitle.results': 'Results',
    'fabric.linkPicker.noEmbed': "Embed view isn't supported for this link. <a>More about why some Smart Links don't display content.</a>",
    'fabric.linkPicker.search.error.description': 'Refresh the page, or contact <a>Atlassian Support</a> if this keeps happening.',
    'fabric.linkPicker.search.error.heading': "We\u2019re having trouble loading data.",
    'fabric.linkPicker.search.error.retry': 'Refresh',
    'fabric.linkPicker.search.linkAriaLabel': 'Suggestions will appear below as you type into the field',
    'fabric.linkPicker.search.linkLabel': 'Search or paste a link',
    'fabric.linkPicker.search.linkPlaceholder': 'Find recent links or paste a new link',
    'fabric.linkPicker.search.noResults.description': 'Try again with a different term.',
    'fabric.linkPicker.search.noResults.heading': "We couldn\u2019t find anything matching your search.",
    'fabric.linkPicker.status.submitting': 'Submitting',
    'fabric.linkPicker.time.message.updated': 'Updated {time}',
    'fabric.linkPicker.time.message.viewed': 'Viewed {time}',
    'fabric.linkPicker.unhandledError.description': 'Try reloading the page.',
    'fabric.linkPicker.unhandledError.heading': 'Something went wrong!',
    foo: 'Default string'
};

});


parcelRegister("cyJCq", function(module, exports) {
$parcel$export(module.exports, "fetchMessagesForLocale", () => $7da9184eca175e75$export$2b153a2030b0feb2);

var $4NLTA = parcelRequire("4NLTA");
const $7da9184eca175e75$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const localeKey = locale.replace('-', '_');
        if (localeKey in (0, $4NLTA.locales)) {
            const messages = await (0, $4NLTA.locales)[localeKey]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $4NLTA.locales)) {
            const messages = await (0, $4NLTA.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
};

});
parcelRegister("4NLTA", function(module, exports) {
$parcel$export(module.exports, "locales", () => $25f2380afca4a4c7$export$df1c34db1371eeed);

























const $25f2380afca4a4c7$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("lHgyq")),
    da: ()=>(parcelRequire("4YXfr")),
    de: ()=>(parcelRequire("jKSgI")),
    en_GB: ()=>(parcelRequire("258Qe")),
    en_ZZ: ()=>(parcelRequire("h1LVc")),
    en: ()=>Promise.resolve((parcelRequire("5fDnW"))),
    es: ()=>(parcelRequire("9m56n")),
    fi: ()=>(parcelRequire("kmSjm")),
    fr: ()=>(parcelRequire("9fNsE")),
    hu: ()=>(parcelRequire("1Tphb")),
    it: ()=>(parcelRequire("7hzjZ")),
    ja: ()=>(parcelRequire("7P3BH")),
    ko: ()=>(parcelRequire("2ywL5")),
    nb: ()=>(parcelRequire("en3yi")),
    nl: ()=>(parcelRequire("kdJKa")),
    pl: ()=>(parcelRequire("ffRW8")),
    pt_BR: ()=>(parcelRequire("gSj1T")),
    ru: ()=>(parcelRequire("8HH7M")),
    sv: ()=>(parcelRequire("20gJT")),
    th: ()=>(parcelRequire("fii6U")),
    tr: ()=>(parcelRequire("3hnD9")),
    uk: ()=>(parcelRequire("6zo9y")),
    vi: ()=>(parcelRequire("aOo77")),
    zh_TW: ()=>(parcelRequire("cvgA9")),
    zh: ()=>(parcelRequire("7kdlf"))
};

});
parcelRegister("lHgyq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4Lzx5").then(()=>parcelRequire('fFjBZ'));

});

parcelRegister("4YXfr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("knDxd").then(()=>parcelRequire('91VcN'));

});

parcelRegister("jKSgI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hU95F").then(()=>parcelRequire('5lo1V'));

});

parcelRegister("258Qe", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1crI1").then(()=>parcelRequire('ARD7U'));

});

parcelRegister("h1LVc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ahwzx").then(()=>parcelRequire('4FORW'));

});

parcelRegister("9m56n", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jMWm4").then(()=>parcelRequire('953q9'));

});

parcelRegister("kmSjm", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1WWCk").then(()=>parcelRequire('lQ21i'));

});

parcelRegister("9fNsE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gEXZZ").then(()=>parcelRequire('1TJcy'));

});

parcelRegister("1Tphb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jzNYH").then(()=>parcelRequire('4PDkD'));

});

parcelRegister("7hzjZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gJH9A").then(()=>parcelRequire('7bAD1'));

});

parcelRegister("7P3BH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3nrLK").then(()=>parcelRequire('2wbVn'));

});

parcelRegister("2ywL5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5bANX").then(()=>parcelRequire('dF97w'));

});

parcelRegister("en3yi", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hFl5P").then(()=>parcelRequire('gusPx'));

});

parcelRegister("kdJKa", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("diwMv").then(()=>parcelRequire('fSNMI'));

});

parcelRegister("ffRW8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("agyBn").then(()=>parcelRequire('jMzOa'));

});

parcelRegister("gSj1T", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("du1Vi").then(()=>parcelRequire('jeFMu'));

});

parcelRegister("8HH7M", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("Lui6s").then(()=>parcelRequire('bfFnE'));

});

parcelRegister("20gJT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gS7xS").then(()=>parcelRequire('i4tNv'));

});

parcelRegister("fii6U", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5tsMc").then(()=>parcelRequire('3yZiu'));

});

parcelRegister("3hnD9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2qq9U").then(()=>parcelRequire('iLucK'));

});

parcelRegister("6zo9y", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3QtHi").then(()=>parcelRequire('8owvt'));

});

parcelRegister("aOo77", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aUfCR").then(()=>parcelRequire('4wLiD'));

});

parcelRegister("cvgA9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2ssec").then(()=>parcelRequire('hfCab'));

});

parcelRegister("7kdlf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bLXUG").then(()=>parcelRequire('7xB1Z'));

});






parcelRegister("5Fntp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("9g10b")
]).then(()=>parcelRequire('8lrXP'));

});


parcelRegister("5x7vO", function(module, exports) {
$parcel$export(module.exports, "useEscapeClickaway", () => $12fe35c4feeff506$export$886f2fdec3f419af);

var $eJOHy = parcelRequire("eJOHy");
const $12fe35c4feeff506$export$886f2fdec3f419af = (/** Callback to fire when the user presses the escape key */ onEscape, /** Callback to fire when the user clicks an element not contained by the ref */ onClickAway)=>{
    const ref = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        const handleClickAway = (event)=>{
            const el = ref.current;
            if (event.target instanceof Element && el && !el.contains(event.target)) onClickAway();
        };
        const handleKeydown = (event)=>{
            if (event.key === 'Escape') {
                event.preventDefault();
                onEscape();
            }
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('mousedown', handleClickAway);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('keydown', handleKeydown);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('mousedown', handleClickAway);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('keydown', handleKeydown);
        };
    }, [
        onClickAway,
        onEscape
    ]);
    return ref;
};

});


parcelRegister("4DYEn", function(module, exports) {
$parcel$export(module.exports, "default", () => $95022feab3ab1638$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $3s8bj = parcelRequire("3s8bj");

var $aQK2r = parcelRequire("aQK2r");

var $7qGN1 = parcelRequire("7qGN1");
var $6YFG2 = parcelRequire("6YFG2");

var $iKozC = parcelRequire("iKozC");

var $4J0ad = parcelRequire("4J0ad");

var $fk1hB = parcelRequire("fk1hB");

var $kXEdL = parcelRequire("kXEdL");

var $eGOwo = parcelRequire("eGOwo");

var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $cbSL1 = parcelRequire("cbSL1");

var $k71qx = parcelRequire("k71qx");

var $bMFKb = parcelRequire("bMFKb");
var $cd124 = parcelRequire("cd124");

var $bQBk1 = parcelRequire("bQBk1");
var $8VBqs = parcelRequire("8VBqs");

var $grDTV = parcelRequire("grDTV");

var $7EdFW = parcelRequire("7EdFW");

var $9sG1M = parcelRequire("9sG1M");

var $b2d9j = parcelRequire("b2d9j");

var $gKQQp = parcelRequire("gKQQp");

var $84M54 = parcelRequire("84M54");
function $95022feab3ab1638$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $95022feab3ab1638$export$8dd524ceb40e3d16 = {
    name: "19nbz8q",
    styles: "clip:rect(1px, 1px, 1px, 1px);clip-path:inset(50%);height:1px;width:1px;margin:var(--ds-space-negative-025, -2px);overflow:hidden;padding:0;position:absolute"
};
const $95022feab3ab1638$export$452f1062ecf44be7 = 5;
const $95022feab3ab1638$var$clearTextButtonStyles = (0, $1DXK0.xcss)({
    padding: 'space.0',
    marginRight: 'space.100',
    backgroundColor: 'color.background.neutral.subtle',
    border: 'none'
});
const $95022feab3ab1638$var$clearTextWrapper = {
    name: "154v9b4",
    styles: "position:absolute;right:0"
};
const $95022feab3ab1638$var$containerPadding = /*#__PURE__*/ (0, $1NIU8.css)({
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-100, 8px)"}`
});
const $95022feab3ab1638$var$textLabelMargin = {
    name: "1s21os8",
    styles: "margin-top:var(--ds-space-150, 12px)"
};
const $95022feab3ab1638$var$inputLabel = {
    name: "1ta6p52",
    styles: "color:var(--ds-text-subtlest, #626F86);padding-bottom:var(--ds-space-050, 4px);font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-medium, 500)"
};
const $95022feab3ab1638$var$inputWrapperPosition = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $95022feab3ab1638$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    displayText: {
        id: 'fabric.editor.displayText',
        defaultMessage: 'Text to display',
        description: 'Text to display'
    },
    clearText: {
        id: 'fabric.editor.clearLinkText',
        defaultMessage: 'Clear text',
        description: 'Clears text on the link toolbar'
    },
    clearLink: {
        id: 'fabric.editor.clearLink',
        defaultMessage: 'Clear link',
        description: 'Clears link in the link toolbar'
    },
    searchLinkAriaDescription: {
        id: 'fabric.editor.hyperlink.searchLinkAriaDescription',
        defaultMessage: 'Suggestions will appear below as you type into the field',
        description: 'Describes what the search field does for screen reader users.'
    },
    searchLinkResults: {
        id: 'fabric.editor.hyperlink.searchLinkResults',
        defaultMessage: '{count, plural, =0 {no results} one {# result} other {# results}} found',
        description: 'Announce search results for screen-reader users.'
    },
    linkVisibleLabel: {
        id: 'fabric.editor.hyperlink.linkVisibleLabel',
        defaultMessage: 'Paste or search for link',
        description: 'Visible label for link input in hyperlink floating control'
    },
    textVisibleLabel: {
        id: 'fabric.editor.hyperlink.textVisibleLabel',
        defaultMessage: 'Display text (optional)',
        description: 'Visible label for text input in hyperlink floating control'
    }
});
const $95022feab3ab1638$var$defaultIcon = /*#__PURE__*/ (0, $1NIU8.jsx)((0, $fk1hB.default), {
    label: 'page'
});
const $95022feab3ab1638$var$mapActivityProviderResultToLinkSearchItemData = ({ name: name, container: container, iconUrl: iconUrl, objectId: objectId, url: url, viewedTimestamp: viewedTimestamp })=>({
        objectId: objectId,
        name: name,
        container: container,
        iconUrl: iconUrl,
        url: url,
        lastViewedDate: viewedTimestamp ? new Date(viewedTimestamp) : undefined,
        prefetch: true
    });
const $95022feab3ab1638$var$mapSearchProviderResultToLinkSearchItemData = ({ objectId: objectId, container: container, title: title, contentType: contentType, url: url, updatedTimestamp: updatedTimestamp })=>({
        objectId: objectId,
        container: container,
        name: title,
        url: url,
        lastUpdatedDate: updatedTimestamp ? new Date(updatedTimestamp) : undefined,
        icon: contentType && (0, $84M54.mapContentTypeToIcon)[contentType] || $95022feab3ab1638$var$defaultIcon,
        prefetch: false
    });
class $95022feab3ab1638$export$7acbf008e0847b89 extends (0, $eJOHy.PureComponent) {
    constructor(props){
        super(props), /* To prevent double submit */ this.submitted = false, this.urlInputContainer = null, this.displayTextInputContainer = null, this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.listItemRefs = {
            current: {}
        }, this.quickSearchQueryVersion = 0, this.analyticSource = 'createLinkInlineDialog', this.quickSearch = async (input, items, quickSearchLimit)=>{
            const { searchProvider: searchProvider, displayUrl: displayUrl } = this.state;
            const { searchSessionId: searchSessionId } = this.props;
            if (!searchProvider) return;
            const queryVersion = ++this.quickSearchQueryVersion;
            this.fireAnalytics({
                action: (0, $bMFKb.ACTION).ENTERED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).LINK_SEARCH_INPUT,
                attributes: {
                    queryLength: input.length,
                    queryVersion: queryVersion,
                    queryHash: (0, $84M54.sha1)(input),
                    searchSessionId: searchSessionId ?? '',
                    wordCount: (0, $84M54.wordCount)(input),
                    source: this.analyticSource
                },
                nonPrivacySafeAttributes: {
                    query: input
                },
                eventType: (0, $bMFKb.EVENT_TYPE).UI
            });
            const perfStart = performance.now();
            try {
                const searchProviderResultItems = await searchProvider.quickSearch(input, quickSearchLimit);
                const searchItems = $95022feab3ab1638$var$limit((0, $84M54.filterUniqueItems)([
                    ...items,
                    ...searchProviderResultItems.map($95022feab3ab1638$var$mapSearchProviderResultToLinkSearchItemData)
                ], (firstItem, secondItem)=>firstItem.objectId === secondItem.objectId));
                if (displayUrl === input && queryVersion === this.quickSearchQueryVersion) this.setState({
                    items: searchItems,
                    isLoading: false
                });
                const perfStop = performance.now();
                const duration = perfStop - perfStart;
                this.fireAnalytics({
                    action: (0, $bMFKb.ACTION).INVOKED,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).SEARCH_RESULT,
                    actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).QUICK_SEARCH,
                    attributes: {
                        duration: duration,
                        count: searchProviderResultItems.length
                    },
                    eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
                });
                this.fireAnalytics({
                    action: (0, $bMFKb.ACTION).SHOWN,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).SEARCH_RESULT,
                    actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).POST_QUERY_SEARCH_RESULTS,
                    attributes: {
                        source: this.analyticSource,
                        postQueryRequestDurationMs: duration,
                        searchSessionId: searchSessionId ?? '',
                        resultCount: searchProviderResultItems.length,
                        results: searchProviderResultItems.map((item)=>({
                                resultContentId: item.objectId,
                                resultType: item.contentType
                            }))
                    },
                    eventType: (0, $bMFKb.EVENT_TYPE).UI
                });
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                const perfStop = performance.now();
                const duration = perfStop - perfStart;
                this.fireAnalytics({
                    action: (0, $bMFKb.ACTION).INVOKED,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).SEARCH_RESULT,
                    actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).QUICK_SEARCH,
                    attributes: {
                        duration: duration,
                        count: -1,
                        errorCode: err.status
                    },
                    eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
                });
            }
        }, this.updateInput = async (input)=>{
            const { activityProvider: activityProvider, searchProvider: searchProvider } = this.state;
            this.setState({
                displayUrl: input
            });
            if (activityProvider) {
                if (input.length === 0) this.setState({
                    items: await this.getRecentItems(activityProvider),
                    selectedIndex: -1
                });
                else if ((0, $iKozC.isSafeUrl)(input)) this.setState({
                    items: [],
                    selectedIndex: -1,
                    isLoading: false
                });
                else {
                    const items = await this.getRecentItems(activityProvider, input);
                    const shouldQuerySearchProvider = items.length < $95022feab3ab1638$export$452f1062ecf44be7 && !!searchProvider;
                    this.setState({
                        items: items,
                        isLoading: shouldQuerySearchProvider
                    });
                    if (shouldQuerySearchProvider) this.debouncedQuickSearch(input, items, $95022feab3ab1638$export$452f1062ecf44be7);
                }
            }
        }, this.createClearHandler = (field)=>{
            return async ()=>{
                const { activityProvider: activityProvider } = this.state;
                switch(field){
                    case 'displayUrl':
                        this.setState({
                            [field]: '',
                            items: !!activityProvider ? $95022feab3ab1638$var$limit(await activityProvider.getRecentItems()) : []
                        });
                        if (this.urlInputContainer) this.urlInputContainer.focus();
                        break;
                    case 'displayText':
                        this.setState({
                            [field]: ''
                        });
                        if (this.displayTextInputContainer) this.displayTextInputContainer.focus();
                }
            };
        }, this.handleClickOutside = (event)=>{
            if (event.target instanceof Element && this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
                const { view: { state: state, dispatch: dispatch }, onClickAwayCallback: onClickAwayCallback } = this.props;
                onClickAwayCallback?.(state, dispatch);
            }
        }, this.getScreenReaderText = ()=>{
            const { intl: intl } = this.props;
            const { items: items, selectedIndex: selectedIndex } = this.state;
            if (items.length && selectedIndex > -1) {
                const { name: name, container: container, lastUpdatedDate: lastUpdatedDate, lastViewedDate: lastViewedDate } = items[selectedIndex];
                const date = (0, $gKQQp.transformTimeStamp)(intl, lastViewedDate, lastUpdatedDate);
                return `${name}, ${container}, ${date?.pageAction} ${date?.dateString} ${date?.timeSince || ''}`;
            }
        }, this.listItemRefCallback = (el, id)=>{
            if (!this.listItemRefs.current) return;
            if (el === null) delete this.listItemRefs.current[id];
            else this.listItemRefs.current[id] = el;
        }, this.isUrlPopulatedWithSelectedItem = ()=>{
            /**
     * When we use ArrowKey to navigate through result items,
     * the URL field will be populated with the content of
     * selected item.
     * This function will check if the URL field is populated
     * with selected item.
     * It can be useful to detect whether we want to insert a
     * smartlink or a hyperlink with customized title
     */ const { items: items, selectedIndex: selectedIndex, displayUrl: displayUrl } = this.state;
            const selectedItem = items[selectedIndex];
            if (selectedItem && selectedItem.url === displayUrl) return true;
            return false;
        }, this.handleSelected = (href, text)=>{
            this.handleInsert(href, text, (0, $bMFKb.INPUT_METHOD).TYPEAHEAD, 'click');
        }, this.handleInsert = (href, title, inputType, interaction)=>{
            const { searchSessionId: searchSessionId, onSubmit: onSubmit } = this.props;
            const { items: items, selectedIndex: selectedIndex, displayText: displayText } = this.state;
            if (onSubmit) {
                this.submitted = true;
                onSubmit(href, title, displayText, inputType);
            }
            if (interaction === 'click' || this.isUrlPopulatedWithSelectedItem()) {
                /**
       * When it's a mouse click even or the selectedItem.url matches displayUrl, we think
       * it's selected from the result list and fire the
       * analytic
       */ const selectedItem = items[selectedIndex];
                this.fireAnalytics({
                    action: (0, $bMFKb.ACTION).SELECTED,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).SEARCH_RESULT,
                    attributes: {
                        source: this.analyticSource,
                        searchSessionId: searchSessionId ?? '',
                        trigger: interaction,
                        resultCount: items.length,
                        selectedResultId: selectedItem.objectId,
                        selectedRelativePosition: selectedIndex,
                        prefetch: selectedItem.prefetch ?? false
                    },
                    eventType: (0, $bMFKb.EVENT_TYPE).UI
                });
            }
        }, this.handleMouseEnterResultItem = (objectId)=>{
            const { items: items } = this.state;
            const index = $95022feab3ab1638$var$findIndex(items, (item)=>item.objectId === objectId);
            this.setState({
                selectedIndex: index
            });
        }, this.handleMouseLeaveResultItem = (objectId)=>{
            const { items: items, selectedIndex: selectedIndex } = this.state;
            const index = $95022feab3ab1638$var$findIndex(items, (item)=>item.objectId === objectId);
            // This is to avoid updating index that was set by other mouseenter event
            if (selectedIndex === index) this.setState({
                selectedIndex: -1
            });
        }, this.handleSubmit = ()=>{
            const { displayUrl: displayUrl, selectedIndex: selectedIndex, items: items } = this.state;
            const selectedItem = items[selectedIndex];
            if (this.isUrlPopulatedWithSelectedItem()) this.handleInsert((0, $grDTV.normalizeUrl)(selectedItem.url), selectedItem.name, (0, $bMFKb.INPUT_METHOD).TYPEAHEAD, 'keyboard');
            else if (displayUrl && displayUrl.length > 0) {
                const url = (0, $grDTV.normalizeUrl)(displayUrl);
                if (url) this.handleInsert(url, displayUrl, (0, $bMFKb.INPUT_METHOD).MANUAL, 'notselected');
            }
        }, this.handleClearTextKeyDown = (event)=>{
            const KEY_CODE_TAB = 9;
            const { keyCode: keyCode } = event;
            if (keyCode === KEY_CODE_TAB) {
                /** If there are items in the list, allow normal tabbing so focus moves to the next interactive element (in this case, a search result item).
       */ if (this.state.items.length > 0) return;
                if (!this.submitted) {
                    const { displayUrl: displayUrl, displayText: displayText } = this.state;
                    const url = (0, $grDTV.normalizeUrl)(displayUrl);
                    this.handleInsert(url, displayText || displayUrl, (0, $bMFKb.INPUT_METHOD).MANUAL, 'notselected');
                }
                event.preventDefault();
                return;
            }
        }, this.handleListItemFocus = (index)=>{
            this.setState({
                selectedIndex: index
            });
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleKeyDown = (event)=>{
            const { items: items, selectedIndex: selectedIndex } = this.state;
            const { view: view, onEscapeCallback: onEscapeCallback, searchSessionId: searchSessionId } = this.props;
            const { keyCode: keyCode } = event;
            const KEY_CODE_ESCAPE = 27;
            const KEY_CODE_ARROW_DOWN = 40;
            const KEY_CODE_ARROW_UP = 38;
            if (keyCode === KEY_CODE_ESCAPE) {
                // escape
                event.preventDefault();
                const { state: state, dispatch: dispatch } = view;
                onEscapeCallback?.(state, dispatch);
                return;
            }
            if (!items || !items.length) return;
            let updatedIndex = selectedIndex;
            if (keyCode === KEY_CODE_ARROW_DOWN) {
                // down
                event.preventDefault();
                updatedIndex = (selectedIndex + 1) % items.length;
            } else if (keyCode === KEY_CODE_ARROW_UP) {
                // up
                event.preventDefault();
                updatedIndex = selectedIndex > 0 ? selectedIndex - 1 : items.length - 1;
            }
            if ([
                KEY_CODE_ARROW_DOWN,
                KEY_CODE_ARROW_UP
            ].includes(keyCode) && items[updatedIndex]) {
                if (this.listItemRefs.current) this.listItemRefs.current[items[updatedIndex].objectId]?.focus();
                this.setState({
                    selectedIndex: updatedIndex,
                    displayUrl: items[updatedIndex].url
                });
                this.fireAnalytics({
                    action: (0, $bMFKb.ACTION).HIGHLIGHTED,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).SEARCH_RESULT,
                    attributes: {
                        source: this.analyticSource,
                        searchSessionId: searchSessionId ?? '',
                        selectedResultId: items[updatedIndex].objectId,
                        selectedRelativePosition: updatedIndex
                    },
                    eventType: (0, $bMFKb.EVENT_TYPE).UI
                });
            }
        }, this.updateTextInput = (displayText)=>{
            this.setState({
                displayText: displayText
            });
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleCancel = (e)=>{
            const { view: { state: state, dispatch: dispatch }, onClickAwayCallback: onClickAwayCallback } = this.props;
            e.preventDefault();
            onClickAwayCallback?.(state, dispatch);
        };
        this.state = {
            selectedIndex: -1,
            isLoading: false,
            displayUrl: (0, $grDTV.normalizeUrl)(props.displayUrl),
            displayText: props.displayText,
            items: []
        };
        /* Cache functions */ this.handleClearText = this.createClearHandler('displayUrl');
        this.handleClearDisplayText = this.createClearHandler('displayText');
        this.debouncedQuickSearch = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(this.quickSearch, 400);
        this.fireCustomAnalytics = (0, $cd124.fireAnalyticsEvent)(props.createAnalyticsEvent);
    }
    async componentDidMount() {
        const { timesViewed: timesViewed, inputMethod: inputMethod, searchSessionId: searchSessionId } = this.props;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('mousedown', this.handleClickOutside);
        this.fireAnalytics({
            action: (0, $bMFKb.ACTION).VIEWED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).CREATE_LINK_INLINE_DIALOG,
            attributes: {
                timesViewed: timesViewed ?? 0,
                searchSessionId: searchSessionId ?? '',
                trigger: inputMethod ?? ''
            },
            eventType: (0, $bMFKb.EVENT_TYPE).SCREEN
        });
        const [activityProvider, searchProvider] = await Promise.all([
            this.props.activityProvider,
            this.props.searchProvider
        ]);
        // loadInitialLinkSearchResult and updateInput rely on activityProvider being set in state
        (0, $aQK2r.flushSync)(()=>this.setState({
                activityProvider: activityProvider,
                searchProvider: searchProvider
            }));
        await this.loadInitialLinkSearchResult();
    }
    componentWillUnmount() {
        const { searchSessionId: searchSessionId } = this.props;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('mousedown', this.handleClickOutside);
        if (!this.submitted) this.fireAnalytics({
            action: (0, $bMFKb.ACTION).DISMISSED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).CREATE_LINK_INLINE_DIALOG,
            attributes: {
                source: this.analyticSource,
                searchSessionId: searchSessionId ?? '',
                trigger: 'blur'
            },
            eventType: (0, $bMFKb.EVENT_TYPE).UI
        });
    }
    async getRecentItems(activityProvider, query) {
        const { searchSessionId: searchSessionId } = this.props;
        const perfStart = performance.now();
        try {
            const activityRecentItems = $95022feab3ab1638$var$limit(query ? await activityProvider.searchRecent(query) : await activityProvider.getRecentItems());
            const items = activityRecentItems.map($95022feab3ab1638$var$mapActivityProviderResultToLinkSearchItemData);
            const perfStop = performance.now();
            const duration = perfStop - perfStart;
            this.fireAnalytics({
                action: (0, $bMFKb.ACTION).INVOKED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).SEARCH_RESULT,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).RECENT_ACTIVITIES,
                attributes: {
                    duration: duration,
                    count: items.length
                },
                eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
            });
            this.fireAnalytics({
                action: (0, $bMFKb.ACTION).SHOWN,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).SEARCH_RESULT,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).PRE_QUERY_SEARCH_RESULTS,
                attributes: {
                    source: this.analyticSource,
                    preQueryRequestDurationMs: duration,
                    searchSessionId: searchSessionId ?? '',
                    resultCount: items.length,
                    results: activityRecentItems.map((item)=>({
                            resultContentId: item.objectId,
                            resultType: item.type ?? ''
                        }))
                },
                eventType: (0, $bMFKb.EVENT_TYPE).UI
            });
            return items;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            const perfStop = performance.now();
            const duration = perfStop - perfStart;
            this.fireAnalytics({
                action: (0, $bMFKb.ACTION).INVOKED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).SEARCH_RESULT,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).RECENT_ACTIVITIES,
                attributes: {
                    duration: duration,
                    count: -1,
                    errorCode: err.status
                },
                eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
            });
            return [];
        }
    }
    fireAnalytics(payload) {
        if (this.props.createAnalyticsEvent && this.fireCustomAnalytics) this.fireCustomAnalytics({
            payload: payload
        });
    }
    async loadInitialLinkSearchResult() {
        const { displayUrl: displayUrl, activityProvider: activityProvider } = this.state;
        try {
            if (!displayUrl && activityProvider) {
                this.setState({
                    isLoading: true
                });
                const items = await this.getRecentItems(activityProvider);
                this.setState({
                    items: items
                });
            }
        } finally{
            this.setState({
                isLoading: false
            });
        }
    }
    render() {
        const { items: items, isLoading: isLoading, selectedIndex: selectedIndex, displayUrl: displayUrl, displayText: displayText } = this.state;
        const { intl: { formatMessage: formatMessage }, activityProvider: activityProvider } = this.props;
        const formatClearLinkText = formatMessage($95022feab3ab1638$export$defe85febe8b728c.clearLink);
        const screenReaderDescriptionId = 'search-recent-links-field-description';
        const linkSearchListId = 'hyperlink-search-list';
        const ariaActiveDescendant = selectedIndex > -1 ? `link-search-list-item-${selectedIndex}` : '';
        const linkSearchInputId = 'search-recent-links-field-id';
        const displayTextInputId = 'display-text-filed-id';
        const browser = (0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $7EdFW.getBrowserInfo)() : (0, $7EdFW.browser);
        // Added workaround with a screen reader Announcer specifically for VoiceOver + Safari
        // as the Aria design pattern for combobox does not work in this case
        // for details: https://a11y-internal.atlassian.net/browse/AK-740
        const screenReaderText = browser.safari && this.getScreenReaderText();
        const containerWidth = (0, $eGOwo.fg)('platform_editor_link_picker_width_fix') ? (0, $b2d9j.narrowContainerWidth) : !!activityProvider && (0, $b2d9j.containerWithProvider);
        return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            "aria-label": "Hyperlink Edit",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "recent-list",
            "data-testid": "hyperlink-add-toolbar"
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: [
                (0, $b2d9j.container),
                containerWidth,
                $95022feab3ab1638$var$containerPadding
            ],
            ref: this.wrapperRef
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("label", {
            htmlFor: linkSearchInputId,
            css: $95022feab3ab1638$var$inputLabel
        }, formatMessage($95022feab3ab1638$export$defe85febe8b728c.linkVisibleLabel)), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: [
                (0, $b2d9j.inputWrapper),
                $95022feab3ab1638$var$inputWrapperPosition
            ]
        }, screenReaderText && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $bQBk1.default), {
            ariaLive: "assertive",
            text: screenReaderText,
            ariaRelevant: "additions",
            delay: 250
        }), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $95022feab3ab1638$export$8dd524ceb40e3d16,
            "aria-hidden": "true",
            id: screenReaderDescriptionId
        }, formatMessage($95022feab3ab1638$export$defe85febe8b728c.searchLinkAriaDescription)), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8VBqs.default), {
            role: "combobox",
            ariaExpanded: (0, $cbSL1.expValEquals)('editor_enghealth_hyperlink_toolbar_aria_values', 'isEnabled', true, false) ? items && items.length > 0 && !isLoading : true,
            ariaActiveDescendant: ariaActiveDescendant,
            ariaControls: linkSearchListId,
            ariaAutoComplete: true,
            describedById: screenReaderDescriptionId,
            ref: (ele)=>this.urlInputContainer = ele,
            testId: 'link-url',
            onSubmit: this.handleSubmit,
            onChange: this.updateInput,
            autoFocus: {
                preventScroll: true
            },
            onCancel: this.handleCancel,
            defaultValue: displayUrl,
            onKeyDown: this.handleKeyDown,
            inputId: linkSearchInputId
        }), displayUrl && /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $95022feab3ab1638$var$clearTextWrapper
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k71qx.default), {
            content: formatClearLinkText
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $bQP4O.default), {
            xcss: $95022feab3ab1638$var$clearTextButtonStyles,
            onClick: this.handleClearText
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kXEdL))), {
            label: formatClearLinkText,
            color: "var(--ds-icon-subtle, #626F86)"
        }))))), /*#__PURE__*/ (0, $1NIU8.jsx)("label", {
            htmlFor: displayTextInputId,
            css: [
                $95022feab3ab1638$var$inputLabel,
                $95022feab3ab1638$var$textLabelMargin
            ]
        }, formatMessage($95022feab3ab1638$export$defe85febe8b728c.textVisibleLabel)), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: [
                (0, $b2d9j.inputWrapper),
                $95022feab3ab1638$var$inputWrapperPosition
            ]
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8VBqs.default), {
            ref: (ele)=>this.displayTextInputContainer = ele,
            testId: 'link-text',
            onChange: this.updateTextInput,
            onCancel: this.handleCancel,
            defaultValue: displayText,
            onSubmit: this.handleSubmit,
            onKeyDown: this.handleKeyDown,
            inputId: displayTextInputId
        }), displayText && /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $95022feab3ab1638$var$clearTextWrapper
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k71qx.default), {
            content: formatMessage($95022feab3ab1638$export$defe85febe8b728c.clearText)
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $bQP4O.default), {
            xcss: $95022feab3ab1638$var$clearTextButtonStyles,
            onClick: this.handleClearDisplayText,
            onKeyDown: this.handleClearTextKeyDown
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kXEdL))), {
            label: formatMessage($95022feab3ab1638$export$defe85febe8b728c.clearText),
            color: "var(--ds-icon-subtle, #626F86)"
        }))))), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $95022feab3ab1638$export$8dd524ceb40e3d16,
            "aria-live": "polite",
            "aria-atomic": "true",
            id: "fabric.editor.hyperlink.suggested.results"
        }, displayUrl && formatMessage($95022feab3ab1638$export$defe85febe8b728c.searchLinkResults, {
            count: items.length
        })), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $9sG1M.default), {
            ariaControls: "fabric.editor.hyperlink.suggested.results",
            id: linkSearchListId,
            role: "listbox",
            items: items,
            isLoading: isLoading,
            selectedIndex: selectedIndex,
            listItemRefCallback: this.listItemRefCallback,
            onFocus: this.handleListItemFocus,
            onKeyDown: this.handleKeyDown,
            onSelect: this.handleSelected,
            onMouseEnter: this.handleMouseEnterResultItem,
            onMouseLeave: this.handleMouseLeaveResultItem
        })));
    }
}
function $95022feab3ab1638$var$findIndex(array, predicate) {
    let index = -1;
    array.some((item, i)=>{
        if (predicate(item)) {
            index = i;
            return true;
        }
        return false;
    });
    return index;
}
function $95022feab3ab1638$var$limit(items) {
    return items.slice(0, $95022feab3ab1638$export$452f1062ecf44be7);
}
const $95022feab3ab1638$export$527bb787d3e8324e = (0, $6YFG2.default)($95022feab3ab1638$export$7acbf008e0847b89);
var $95022feab3ab1638$export$2e2bcd8739ae039 = (0, $4J0ad.default)()($95022feab3ab1638$export$527bb787d3e8324e);

});
parcelRegister("fk1hB", function(module, exports) {
$parcel$export(module.exports, "default", () => $a2dc89233b1e272e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::89370760dd7aca35aeecca1b17abbf42>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $DtmfJ = parcelRequire("DtmfJ");

var $hsQbR = parcelRequire("hsQbR");

var $eGOwo = parcelRequire("eGOwo");

var $5NsmF = parcelRequire("5NsmF");
/**
 * __16px `page` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $a2dc89233b1e272e$var$Page16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hsQbR.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($DtmfJ))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5NsmF.default), {
            label: label,
            testId: testId
        })
    });
};
$a2dc89233b1e272e$var$Page16Icon.displayName = 'Page16Icon';
var $a2dc89233b1e272e$export$2e2bcd8739ae039 = $a2dc89233b1e272e$var$Page16Icon;

});
parcelRegister("6IK2z", function(module, exports) {
$parcel$export(module.exports, "default", () => $df1c2fc9df73f09d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $41qqA = parcelRequire("41qqA");

var $l77v2 = parcelRequire("l77v2");
// Color mapping for size 16 standalone icons that will no longer be tiles
const $df1c2fc9df73f09d$var$appearanceToIconColorMap = {
    blue: "var(--ds-icon-accent-blue, #1D7AFC)",
    blueBold: "var(--ds-icon-accent-blue, #1D7AFC)",
    gray: "var(--ds-icon-accent-gray, #758195)",
    grayBold: "var(--ds-icon-accent-gray, #758195)",
    green: "var(--ds-icon-accent-green, #22A06B)",
    greenBold: "var(--ds-icon-accent-green, #22A06B)",
    lime: "var(--ds-icon-accent-lime, #6A9A23)",
    limeBold: "var(--ds-icon-accent-lime, #6A9A23)",
    magenta: "var(--ds-icon-accent-magenta, #CD519D)",
    magentaBold: "var(--ds-icon-accent-magenta, #CD519D)",
    orange: "var(--ds-icon-accent-orange, #E56910)",
    orangeBold: "var(--ds-icon-accent-orange, #E56910)",
    purple: "var(--ds-icon-accent-purple, #8270DB)",
    purpleBold: "var(--ds-icon-accent-purple, #8270DB)",
    red: "var(--ds-icon-accent-red, #C9372C)",
    redBold: "var(--ds-icon-accent-red, #C9372C)",
    teal: "var(--ds-icon-accent-teal, #2898BD)",
    tealBold: "var(--ds-icon-accent-teal, #2898BD)",
    yellow: "var(--ds-icon-accent-yellow, #B38600)",
    yellowBold: "var(--ds-icon-accent-yellow, #B38600)"
};
function $df1c2fc9df73f09d$export$2e2bcd8739ae039({ appearance: appearance, icon: Icon, label: label, size: size, testId: testId, shape: shape, LEGACY_fallbackComponent: LEGACY_fallbackComponent, UNSAFE_circleReplacementComponent: UNSAFE_circleReplacementComponent }) {
    if (LEGACY_fallbackComponent && !(0, $eGOwo.fg)('platform-visual-refresh-icons')) return LEGACY_fallbackComponent;
    if (UNSAFE_circleReplacementComponent && shape === 'circle' && (0, $eGOwo.fg)('platform_dst_icon_tile_circle_replacement')) return UNSAFE_circleReplacementComponent;
    if (shape !== 'circle' && (0, $eGOwo.fg)('platform_dst_new_icon_tile')) {
        // Handle size 16 - render icon directly without Tile
        if (size === '16') return /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
            color: $df1c2fc9df73f09d$var$appearanceToIconColorMap[appearance],
            label: label,
            testId: testId
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $41qqA.default), {
            appearance: appearance,
            icon: Icon,
            label: label,
            shape: shape,
            size: size,
            testId: testId
        });
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l77v2.default), {
        appearance: appearance,
        icon: Icon,
        label: label,
        shape: shape,
        size: size,
        testId: testId
    });
}

});
parcelRegister("41qqA", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef39d2750ac3c535$export$2e2bcd8739ae039);
/* icon-tile-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $ieO20 = parcelRequire("ieO20");
const $ef39d2750ac3c535$var$sizeCrossCompatibleMap = {
    // Size mapping from old pixel sizes to new t-shirt sizes
    '16': 'xsmall',
    // Not used
    '24': 'small',
    '32': 'medium',
    '40': 'large',
    '48': 'xlarge',
    xsmall: 'xsmall',
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
// Icon color mapping for Tile-based icons
const $ef39d2750ac3c535$var$iconColorMap = {
    blue: "_syaz1ov1",
    blueBold: "_syazwdcn",
    gray: "_syaz1oju",
    grayBold: "_syaz5w2r",
    green: "_syaz17hp",
    greenBold: "_syazwdcn",
    lime: "_syaz8645",
    limeBold: "_syazwdcn",
    magenta: "_syazv8hk",
    magentaBold: "_syazwdcn",
    orange: "_syaz7r97",
    orangeBold: "_syazwdcn",
    purple: "_syaz5yjc",
    purpleBold: "_syazwdcn",
    red: "_syaznbxb",
    redBold: "_syazwdcn",
    teal: "_syaz8uof",
    tealBold: "_syazwdcn",
    yellow: "_syaz1oqg",
    yellowBold: "_syazwdcn"
};
// Background color mapping for Tile component
const $ef39d2750ac3c535$var$backgroundColorMap = {
    blue: undefined,
    blueBold: 'color.background.accent.blue.subtle',
    gray: undefined,
    grayBold: 'color.background.neutral.bold',
    green: undefined,
    greenBold: 'color.background.accent.green.subtle',
    lime: undefined,
    limeBold: 'color.background.accent.lime.subtle',
    magenta: undefined,
    magentaBold: 'color.background.accent.magenta.subtle',
    orange: undefined,
    orangeBold: 'color.background.accent.orange.subtle',
    purple: undefined,
    purpleBold: 'color.background.accent.purple.subtle',
    red: undefined,
    redBold: 'color.background.accent.red.subtle',
    teal: undefined,
    tealBold: 'color.background.accent.teal.subtle',
    yellow: undefined,
    yellowBold: 'color.background.accent.yellow.subtle'
};
function $ef39d2750ac3c535$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = 'small', testId: testId } = props;
    const ExpandedIcon = Icon;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ieO20.default), {
        size: $ef39d2750ac3c535$var$sizeCrossCompatibleMap[size],
        backgroundColor: $ef39d2750ac3c535$var$backgroundColorMap[appearance],
        label: label,
        testId: testId,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            className: (0, $hcewu.default)([
                $ef39d2750ac3c535$var$iconColorMap[appearance]
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(ExpandedIcon, {
                color: "currentColor",
                label: label,
                shouldScale: true
            })
        })
    });
}

});
parcelRegister("ieO20", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a27c3c406dff3d5$export$2e2bcd8739ae039);
/* tile.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $9a27c3c406dff3d5$var$styles = {
    root: "_2rkol0p1 _1reo15vq _18m915vq _kqswh2mm _1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1o9zidpf _16jlidpf _1ul9idpf _1tkeidpf",
    border: "_189ee4h9 _1dqonqa1 _1h6dmuej",
    inset: "_1iia1wug _bna71wug _1xjx1wug _17521wug",
    nonInset: "_1qwg1osq _mezj1osq _e2oo1osq _w8l51osq _1iia1osq _bna71osq _1xjx1osq _17521osq"
};
const $9a27c3c406dff3d5$var$sizeMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz _1wyb19bv",
    xsmall: "_1bsbgktf _4t3igktf _1wyb1crf",
    small: "_1bsb1tcg _4t3i1tcg _1wybdlk8",
    medium: "_1bsbzwfg _4t3izwfg _1wyb7vkz",
    large: "_1bsb1ylp _4t3i1ylp _1wybgktf",
    xlarge: "_1bsbckbl _4t3ickbl _1wyb1tcg"
};
const $9a27c3c406dff3d5$var$insetSizeMap = {
    xxsmall: "_1qwg19bv _mezj19bv _e2oo19bv _w8l519bv _5ile19el _1hdc19el _1pc719el _pkax19el",
    xsmall: "_1qwg1crf _mezj1crf _e2oo1crf _w8l51crf _5ilemccc _1hdcmccc _1pc7mccc _pkaxmccc",
    small: "_1qwgdlk8 _mezjdlk8 _e2oodlk8 _w8l5dlk8 _5ilewk7l _1hdcwk7l _1pc7wk7l _pkaxwk7l",
    medium: "_1qwg7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _5ile1gpt _1hdc1gpt _1pc71gpt _pkax1gpt",
    large: "_1qwggktf _mezjgktf _e2oogktf _w8l5gktf _5ile1txs _1hdc1txs _1pc71txs _pkax1txs",
    xlarge: "_1qwg1tcg _mezj1tcg _e2oo1tcg _w8l51tcg _5ilea982 _1hdca982 _1pc7a982 _pkaxa982"
};
const $9a27c3c406dff3d5$var$backgroundColorMap = {
    white: "_bfhku67f",
    black: "_bfhkr3uz",
    transparent: "_bfhk18uv",
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.orange.subtlest': "_bfhk1g3m",
    'color.background.accent.orange.subtler': "_bfhkf2vu",
    'color.background.accent.orange.subtle': "_bfhk1g6e",
    'color.background.accent.orange.bolder': "_bfhkjgng",
    'color.background.accent.yellow.subtlest': "_bfhk1ozg",
    'color.background.accent.yellow.subtler': "_bfhk3fv2",
    'color.background.accent.yellow.subtle': "_bfhkry5t",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.blue.subtlest': "_bfhkavxe",
    'color.background.accent.blue.subtler': "_bfhk4v9p",
    'color.background.accent.blue.subtle': "_bfhk1j89",
    'color.background.accent.blue.bolder': "_bfhkc8cv",
    'color.background.accent.purple.subtlest': "_bfhkp7j4",
    'color.background.accent.purple.subtler': "_bfhk1jkz",
    'color.background.accent.purple.subtle': "_bfhkdh45",
    'color.background.accent.purple.bolder': "_bfhkygwo",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.gray.subtlest': "_bfhk11bn",
    'color.background.accent.gray.subtler': "_bfhk1v33",
    'color.background.accent.gray.subtle': "_bfhk1t05",
    'color.background.accent.gray.bolder': "_bfhk1t1b",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.neutral': "_bfhkm7j4",
    'color.background.neutral.bold': "_bfhkcdhy",
    'color.background.brand.subtlest': "_bfhk3wxy",
    'color.background.brand.bold': "_bfhkb29m",
    'color.background.brand.boldest': "_bfhk15mt",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.warning': "_bfhk1tzq",
    'color.background.warning.bold': "_bfhk190i",
    'color.background.success': "_bfhkmv6i",
    'color.background.success.bold': "_bfhk8emd",
    'color.background.discovery': "_bfhk1nvp",
    'color.background.discovery.bold': "_bfhk1lri",
    'color.background.information': "_bfhk33gi",
    'color.background.information.bold': "_bfhk14wj"
};
function $9a27c3c406dff3d5$export$2e2bcd8739ae039(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId,
        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $hcewu.default)([
            $9a27c3c406dff3d5$var$styles.root,
            $9a27c3c406dff3d5$var$sizeMap[size],
            isInset ? $9a27c3c406dff3d5$var$styles.inset : $9a27c3c406dff3d5$var$styles.nonInset,
            isInset && $9a27c3c406dff3d5$var$insetSizeMap[size],
            $9a27c3c406dff3d5$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $9a27c3c406dff3d5$var$styles.border
        ]),
        children: children
    });
}

});


parcelRegister("l77v2", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd87b3d482b8dffc$export$2e2bcd8739ae039);
/* icon-tile-old.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $bd87b3d482b8dffc$var$sizeCrossCompatibleMap = {
    // Size mapping from new t-shirt sizes to old pixel sizes
    xsmall: '20',
    small: '24',
    medium: '32',
    large: '40',
    xlarge: '48',
    '16': '16',
    '24': '24',
    '32': '32',
    '40': '40',
    '48': '48'
};
const $bd87b3d482b8dffc$var$sizeMap = {
    '16': "_1bsb7vkz _4t3i7vkz",
    '20': "_1bsbgktf _4t3igktf",
    '24': "_1bsb1tcg _4t3i1tcg",
    '32': "_1bsbzwfg _4t3izwfg",
    '40': "_1bsb1ylp _4t3i1ylp",
    '48': "_1bsbckbl _4t3ickbl"
};
const $bd87b3d482b8dffc$var$appearanceMap = {
    grayBold: "_bfhk1t1b _syaz5w2r",
    limeBold: "_bfhktde4 _syaz5w2r",
    greenBold: "_bfhk1e5c _syaz5w2r",
    blueBold: "_bfhkc8cv _syaz5w2r",
    redBold: "_bfhkuibq _syaz5w2r",
    purpleBold: "_bfhkygwo _syaz5w2r",
    magentaBold: "_bfhkc3uk _syaz5w2r",
    tealBold: "_bfhk2c8p _syaz5w2r",
    orangeBold: "_bfhkjgng _syaz5w2r",
    yellowBold: "_bfhk1vop _syaz5w2r",
    gray: "_bfhk1v33 _syaz16ni",
    lime: "_bfhkz2ec _syaz8645",
    orange: "_bfhkf2vu _syaz7r97",
    magenta: "_bfhkv9ra _syazv8hk",
    green: "_bfhk1wnw _syaz17hp",
    blue: "_bfhk4v9p _syaz1ov1",
    red: "_bfhk1rtt _syaznbxb",
    purple: "_bfhk1jkz _syaz5yjc",
    teal: "_bfhk1a17 _syaz8uof",
    yellow: "_bfhk3fv2 _syaz1oqg"
};
const $bd87b3d482b8dffc$var$shapeMap = {
    square: "_2rko12b0",
    circle: "_2rko1rr0"
};
const $bd87b3d482b8dffc$var$iconTileStyles = null;
function $bd87b3d482b8dffc$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = '24', shape: shape = 'square', testId: testId } = props;
    const ExpandedIcon = Icon;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1wybidpf",
            $bd87b3d482b8dffc$var$appearanceMap[appearance],
            $bd87b3d482b8dffc$var$sizeMap[$bd87b3d482b8dffc$var$sizeCrossCompatibleMap[size]],
            $bd87b3d482b8dffc$var$shapeMap[shape]
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(ExpandedIcon, {
            color: "currentColor",
            label: label,
            spacing: "spacious",
            shouldScale: true
        })
    });
}

});


parcelRegister("DtmfJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a80f298c9d6e0d96eff1b09e3e1e4079>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $076a6a80fa08401a$var$_react = $076a6a80fa08401a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $076a6a80fa08401a$var$_baseNew = $076a6a80fa08401a$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $076a6a80fa08401a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $076a6a80fa08401a$var$PageIcon = (props)=>/*#__PURE__*/ $076a6a80fa08401a$var$_react.default.createElement($076a6a80fa08401a$var$_baseNew.default, Object.assign({
        name: "PageIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM12 6H4V4.5h8zm-2 3.5H4V8h6z" clip-rule="evenodd"/>`
    }, props));
$076a6a80fa08401a$var$PageIcon.displayName = 'PageIcon';
var $076a6a80fa08401a$var$_default = module.exports.default = $076a6a80fa08401a$var$PageIcon;

});

parcelRegister("hsQbR", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4435affc1467282$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c46a68f431db1746de65e15ef846dc14>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $DtmfJ = parcelRequire("DtmfJ");

var $gPsTF = parcelRequire("gPsTF");
function $a4435affc1467282$export$2e2bcd8739ae039({ label: label = 'Page', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($DtmfJ))),
        color: "var(--ds-icon-accent-blue, #1D7AFC)"
    });
}

});
parcelRegister("gPsTF", function(module, exports) {
$parcel$export(module.exports, "default", () => $9228c397c6e87f34$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
function $9228c397c6e87f34$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, icon: Icon }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
        label: label,
        size: size === 'medium' ? 'medium' : 'small',
        color: color,
        testId: testId
    });
}

});


parcelRegister("5NsmF", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f9962a8e371d8db$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cd912d046d645339f61cb4aacd78042a>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $8f9962a8e371d8db$var$Page16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`,
        ...props,
        size: "small"
    });
$8f9962a8e371d8db$var$Page16Icon.displayName = 'Page16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8f9962a8e371d8db$export$2e2bcd8739ae039 = $8f9962a8e371d8db$var$Page16Icon;

});


parcelRegister("bQBk1", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa18ffb3bef34c1e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
// Note: Flag 'contentRendered' resolves bug with duplicates messages (NVDA + Firefox)
// https://github.com/nvaccess/nvda/labels/bug%2Fdouble-speaking
let $fa18ffb3bef34c1e$var$timer;
const $fa18ffb3bef34c1e$var$Announcer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ ariaAtomic: ariaAtomic = 'true', ariaLive: ariaLive = 'polite', ariaRelevant: ariaRelevant = 'all', role: role = 'status', text: text = '', delay: delay = 0 }, ref)=>{
    const [contentRendered, setContentRendered] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        clearTimeout($fa18ffb3bef34c1e$var$timer);
        setContentRendered(false);
        $fa18ffb3bef34c1e$var$timer = setTimeout(()=>{
            setContentRendered(true);
        }, delay);
        return ()=>clearTimeout($fa18ffb3bef34c1e$var$timer);
    }, [
        text,
        delay
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "assistive",
        ref: ref,
        role: role,
        "aria-atomic": ariaAtomic,
        "aria-relevant": ariaRelevant,
        "aria-live": ariaLive,
        children: contentRendered && /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            children: text
        })
    });
});
var $fa18ffb3bef34c1e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($fa18ffb3bef34c1e$var$Announcer);

});

parcelRegister("8VBqs", function(module, exports) {
$parcel$export(module.exports, "default", () => $d912f19a48e0ba81$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $cbSL1 = parcelRequire("cbSL1");

var $7EdFW = parcelRequire("7EdFW");

var $ierDl = parcelRequire("ierDl");
const $d912f19a48e0ba81$var$KeyZCode = 90;
const $d912f19a48e0ba81$var$KeyYCode = 89;
class $d912f19a48e0ba81$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    constructor(props){
        super(props), this.onMouseDown = ()=>{
            const { onMouseDown: onMouseDown } = this.props;
            if (onMouseDown) onMouseDown();
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onBlur = (e)=>{
            const { onBlur: onBlur } = this.props;
            if (onBlur) onBlur(e);
        }, this.handleChange = ()=>{
            const { onChange: onChange } = this.props;
            if (this.input) this.setState({
                value: this.input.value
            });
            if (onChange && this.input) onChange(this.input.value);
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleKeydown = (e)=>{
            const { onUndo: onUndo, onRedo: onRedo, onSubmit: onSubmit, onCancel: onCancel } = this.props;
            if (e.keyCode === 13 && onSubmit) {
                e.preventDefault(); // Prevent from submitting if an editor is inside a form.
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                onSubmit(this.input.value);
            } else if (e.keyCode === 27 && onCancel) onCancel(e);
            else if (typeof onUndo === 'function' && this.isUndoEvent(e)) {
                e.preventDefault();
                onUndo();
            } else if (typeof onRedo === 'function' && this.isRedoEvent(e)) {
                e.preventDefault();
                onRedo();
            }
            if (this.props.onKeyDown) this.props.onKeyDown(e);
        }, this.handleRef = (input)=>{
            if (input instanceof HTMLInputElement) {
                this.input = input;
                if (this.props.autoFocus) // Need this to prevent jumping when we render TextInput inside Portal @see ED-2992
                this.focusTimeoutId = window.setTimeout(()=>this.focus());
            } else this.input = undefined;
        };
        this.state = {
            value: props.defaultValue || ''
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.defaultValue !== this.props.defaultValue) this.setState({
            value: this.props.defaultValue
        });
    }
    componentWillUnmount() {
        window.clearTimeout(this.focusTimeoutId);
    }
    render() {
        const { placeholder: placeholder, width: width, maxLength: maxLength, testId: testId, ariaLabel: ariaLabel, describedById: describedById, ariaActiveDescendant: ariaActiveDescendant, ariaControls: ariaControls, ariaExpanded: ariaExpanded, ariaAutoComplete: ariaAutoComplete, role: role, inputId: inputId } = this.props;
        const { value: value } = this.state;
        return /*#__PURE__*/ (0, $1NIU8.jsx)("input", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: [
                (0, $ierDl.panelTextInput),
                width !== undefined && (0, $ierDl.panelTextInputWithCustomWidth)(width)
            ],
            role: role,
            "aria-autocomplete": ariaAutoComplete ? 'list' : undefined,
            "aria-expanded": ariaExpanded,
            "aria-controls": ariaControls,
            "aria-activedescendant": ariaActiveDescendant,
            "aria-describedby": describedById,
            "data-testid": testId || '',
            type: "text",
            placeholder: placeholder,
            value: value,
            onChange: this.handleChange,
            onKeyDown: this.handleKeydown,
            onMouseDown: this.onMouseDown,
            onBlur: this.onBlur,
            ref: this.handleRef,
            maxLength: maxLength,
            "aria-label": ariaLabel,
            "aria-required": this.props?.ariaRequired,
            "aria-invalid": this.props?.ariaInvalid,
            id: inputId
        });
    }
    focus() {
        const { input: input } = this;
        if (input) {
            const focusOpts = typeof this.props.autoFocus === 'object' ? this.props.autoFocus : {};
            input.focus(focusOpts);
        }
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    isUndoEvent(event) {
        const browser = (0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $7EdFW.getBrowserInfo)() : (0, $7EdFW.browser);
        return event.keyCode === $d912f19a48e0ba81$var$KeyZCode && // cmd + z for mac
        (browser.mac && event.metaKey && !event.shiftKey || // ctrl + z for non-mac
        !browser.mac && event.ctrlKey);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    isRedoEvent(event) {
        const browser = (0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $7EdFW.getBrowserInfo)() : (0, $7EdFW.browser);
        return(// ctrl + y for non-mac
        !browser.mac && event.ctrlKey && event.keyCode === $d912f19a48e0ba81$var$KeyYCode || browser.mac && event.metaKey && event.shiftKey && event.keyCode === $d912f19a48e0ba81$var$KeyZCode || event.ctrlKey && event.shiftKey && event.keyCode === $d912f19a48e0ba81$var$KeyZCode);
    }
}

});
parcelRegister("ierDl", function(module, exports) {
$parcel$export(module.exports, "panelTextInput", () => $9b77db833ab3fb33$export$b81ddbf3e2eaad80);
$parcel$export(module.exports, "panelTextInputWithCustomWidth", () => $9b77db833ab3fb33$export$c9f899b6422903f6);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");
const $9b77db833ab3fb33$export$b81ddbf3e2eaad80 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'input&': {
        background: 'transparent',
        border: `1px solid ${"var(--ds-border-input, #8590A2)"}`,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
        borderRadius: "var(--ds-radius-small, 3px)",
        boxSizing: 'content-box',
        color: "var(--ds-text, #172B4D)",
        flexGrow: 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontSize: (0, $7yBx7.relativeFontSizeToBase16)(13),
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '20px',
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-400, 32px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`,
        minWidth: '145px',
        /* Hides IE10+ built-in [x] clear input button */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&::-ms-clear': {
            display: 'none'
        },
        '&:focus': {
            outline: 'none',
            backgroundColor: "var(--ds-background-input-pressed, #FFFFFF)",
            borderColor: "var(--ds-border-focused, #388BFF)",
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${"var(--ds-border-focused, #388BFF)"}`
        },
        '&::placeholder': {
            color: "var(--ds-text-subtlest, #626F86)"
        }
    }
});
const $9b77db833ab3fb33$export$c9f899b6422903f6 = (width)=>/*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'input&': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${width}px`
        }
    });

});


parcelRegister("9sG1M", function(module, exports) {
$parcel$export(module.exports, "default", () => $68bfecaf9f913500$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1NIU8 = parcelRequire("1NIU8");

var $7ep4S = parcelRequire("7ep4S");

var $7PcQo = parcelRequire("7PcQo");
function $68bfecaf9f913500$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $68bfecaf9f913500$var$listContainer = /*#__PURE__*/ (0, $1NIU8.css)({
    paddingTop: 0,
    marginTop: "var(--ds-space-150, 12px)",
    borderTop: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #091E4224)"}`
});
const $68bfecaf9f913500$var$spinnerContainer = {
    name: "q64ud4",
    styles: "text-align:center;min-height:80px;margin-top:var(--ds-space-400, 32px)"
};
const $68bfecaf9f913500$export$ca0620a9deb4a3fe = {
    name: "n1lsvi",
    styles: "padding:0;list-style:none"
};
const $68bfecaf9f913500$var$LinkSearchList = ({ listItemRefCallback: listItemRefCallback, onFocus: onFocus, onKeyDown: onKeyDown, onSelect: onSelect, onMouseMove: onMouseMove, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, items: items, selectedIndex: selectedIndex, isLoading: isLoading, ariaControls: ariaControls, role: role, id: id })=>{
    let itemsContent;
    let loadingContent;
    if (items && items.length > 0) itemsContent = /*#__PURE__*/ (0, $1NIU8.jsx)("ul", {
        css: $68bfecaf9f913500$export$ca0620a9deb4a3fe,
        id: id,
        role: role,
        "aria-controls": ariaControls,
        "data-testid": `${id}--items`
    }, items.map((item, index)=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, $7PcQo.default), {
            id: `link-search-list-item-${index}`,
            item: item,
            selected: selectedIndex === index,
            onFocus: ()=>onFocus?.(index),
            onKeyDown: onKeyDown,
            onMouseMove: onMouseMove,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onSelect: onSelect,
            key: item.objectId,
            ref: (el)=>listItemRefCallback?.(el, item.objectId)
        })));
    if (isLoading) loadingContent = /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        id: id,
        "data-testid": `${id}--loading`,
        css: $68bfecaf9f913500$var$spinnerContainer
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $7ep4S.default), {
        size: "medium",
        interactionName: "link-search-spinner"
    }));
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $68bfecaf9f913500$var$listContainer
    }, itemsContent, loadingContent);
};
var $68bfecaf9f913500$export$2e2bcd8739ae039 = $68bfecaf9f913500$var$LinkSearchList;

});
parcelRegister("7PcQo", function(module, exports) {
$parcel$export(module.exports, "default", () => $7deb9772ab8a12ab$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");

var $7yBx7 = parcelRequire("7yBx7");

var $kxAEw = parcelRequire("kxAEw");

var $gKQQp = parcelRequire("gKQQp");
function $7deb9772ab8a12ab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7deb9772ab8a12ab$export$34e0f9847d4c02dd = /*#__PURE__*/ (0, $1NIU8.css)({
    backgroundColor: 'transparent',
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`,
    cursor: 'pointer',
    display: 'flex',
    marginTop: 0
});
const $7deb9772ab8a12ab$export$624ac72e8eeb8e3d = {
    name: "jjwciq",
    styles: "background-color:var(--ds-background-neutral-subtle-hovered, #091E420F)"
};
const $7deb9772ab8a12ab$var$nameWrapper = {
    name: "d3v9zr",
    styles: "overflow:hidden"
};
const $7deb9772ab8a12ab$export$d6a1b4d10134b7d7 = {
    name: "ufq1bc",
    styles: "color:var(--ds-text, #172B4D);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;line-height:20px"
};
const $7deb9772ab8a12ab$export$ff1446d682f75fb9 = /*#__PURE__*/ (0, $1NIU8.css)({
    color: "var(--ds-text-subtlest, #626F86)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $7yBx7.relativeFontSizeToBase16)(11)
});
const $7deb9772ab8a12ab$var$iconStyle = {
    name: "r2c2s1",
    styles: "min-width:16px;margin-top:var(--ds-space-050, 4px);margin-right:var(--ds-space-150, 12px);img{max-width:16px;}"
};
const $7deb9772ab8a12ab$var$LinkSearchListItem = (props, ref)=>{
    const { id: id, item: item, onFocus: onFocus, onKeyDown: onKeyDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseMove: onMouseMove, onSelect: onSelect, selected: selected, intl: intl } = props;
    const handleSelect = (0, $eJOHy.useCallback)((e)=>{
        e.preventDefault(); // don't let editor lose focus
        onSelect(item.url, item.name);
    }, [
        onSelect,
        item.url,
        item.name
    ]);
    const handleKeyDown = (0, $eJOHy.useCallback)((event)=>{
        if (event.key === 'Enter') onSelect(item.url, item.name);
        onKeyDown?.(event);
    }, [
        onSelect,
        onKeyDown,
        item.url,
        item.name
    ]);
    const handleMouseMove = (0, $eJOHy.useCallback)(()=>{
        onMouseMove?.(item.objectId);
    }, [
        onMouseMove,
        item.objectId
    ]);
    const handleMouseEnter = (0, $eJOHy.useCallback)(()=>{
        onMouseEnter?.(item.objectId);
    }, [
        onMouseEnter,
        item.objectId
    ]);
    const handleMouseLeave = (0, $eJOHy.useCallback)(()=>{
        onMouseLeave?.(item.objectId);
    }, [
        onMouseLeave,
        item.objectId
    ]);
    const renderIcon = ()=>{
        if (item.icon) return /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            css: $7deb9772ab8a12ab$var$iconStyle
        }, item.icon);
        if (item.iconUrl) return /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            css: $7deb9772ab8a12ab$var$iconStyle
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("img", {
            src: item.iconUrl,
            alt: (0, $kxAEw.getCorrectAltByIconUrl)(item.iconUrl, intl)
        }));
        return null;
    };
    const renderTimeStamp = ()=>{
        const date = (0, $gKQQp.transformTimeStamp)(intl, item.lastViewedDate, item.lastUpdatedDate);
        return date && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, "\xa0 \u2022", /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "link-search-timestamp",
            "data-testid": "link-search-timestamp"
        }, "\xa0 ", date.pageAction, " ", date.dateString, " ", date.timeSince || ''));
    };
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        ref: ref,
        css: [
            $7deb9772ab8a12ab$export$34e0f9847d4c02dd,
            selected && $7deb9772ab8a12ab$export$624ac72e8eeb8e3d
        ],
        role: 'option',
        tabIndex: 0,
        id: id,
        "aria-selected": selected,
        "data-testid": "link-search-list-item",
        onFocus: onFocus,
        onKeyDown: handleKeyDown,
        onMouseMove: handleMouseMove,
        onMouseEnter: handleMouseEnter,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: handleMouseLeave,
        onClick: handleSelect
    }, renderIcon(), /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $7deb9772ab8a12ab$var$nameWrapper
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $7deb9772ab8a12ab$export$d6a1b4d10134b7d7
    }, item.name), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        "data-testid": "link-search-list-item-container",
        css: $7deb9772ab8a12ab$export$ff1446d682f75fb9
    }, item.container, renderTimeStamp())));
};
const $7deb9772ab8a12ab$var$ForwardedLinkSearchListItem = /*#__PURE__*/ (0, $eJOHy.forwardRef)($7deb9772ab8a12ab$var$LinkSearchListItem);
const $7deb9772ab8a12ab$export$1896ba66c9a2c53b = (0, $6YFG2.default)($7deb9772ab8a12ab$var$ForwardedLinkSearchListItem, {
    forwardRef: true
});
var $7deb9772ab8a12ab$export$2e2bcd8739ae039 = $7deb9772ab8a12ab$export$1896ba66c9a2c53b;

});
parcelRegister("kxAEw", function(module, exports) {
$parcel$export(module.exports, "getCorrectAltByIconUrl", () => $8bd2e99392d17d43$export$ac1fda7301622804);

var $7qGN1 = parcelRequire("7qGN1");
const $8bd2e99392d17d43$var$messages = (0, $7qGN1.defineMessages)({
    story: {
        id: 'fabric.editor.story',
        defaultMessage: 'Story',
        description: 'Alt text for Story'
    },
    epic: {
        id: 'fabric.editor.epic',
        defaultMessage: 'Epic',
        description: 'Alt text for Epic'
    },
    task: {
        id: 'fabric.editor.task',
        defaultMessage: 'Task',
        description: 'Alt text for Task'
    },
    bug: {
        id: 'fabric.editor.bug',
        defaultMessage: 'Bug',
        description: 'Alt text for Bug'
    },
    subTask: {
        id: 'fabric.editor.subTask',
        defaultMessage: 'Sub-task',
        description: 'Alt text for Sub-task'
    },
    improvement: {
        id: 'fabric.editor.improvement',
        defaultMessage: 'Improvement',
        description: 'Alt text for Improvement'
    },
    defaultAltText: {
        id: 'fabric.editor.defaultAltText',
        defaultMessage: 'Document',
        description: 'Default alt text for ListItem image'
    }
});
const $8bd2e99392d17d43$export$ac1fda7301622804 = (iconUrl, intl)=>{
    let alt = intl.formatMessage($8bd2e99392d17d43$var$messages.defaultAltText);
    if (iconUrl.includes('story.svg')) alt = intl.formatMessage($8bd2e99392d17d43$var$messages.story);
    if (iconUrl.includes('epic.svg')) alt = intl.formatMessage($8bd2e99392d17d43$var$messages.epic);
    if (iconUrl.includes('avatarId=10318')) alt = intl.formatMessage($8bd2e99392d17d43$var$messages.task);
    if (iconUrl.includes('avatarId=10303')) alt = intl.formatMessage($8bd2e99392d17d43$var$messages.bug);
    if (iconUrl.includes('avatarId=10518')) alt = intl.formatMessage($8bd2e99392d17d43$var$messages.subTask);
    if (iconUrl.includes('avatarId=10310')) alt = intl.formatMessage($8bd2e99392d17d43$var$messages.improvement);
    return alt;
};

});

parcelRegister("gKQQp", function(module, exports) {
$parcel$export(module.exports, "transformTimeStamp", () => $94d8dacd02b9fa1d$export$439b9bb86eb9f500);

var $btz6U = parcelRequire("btz6U");

var $57raR = parcelRequire("57raR");

var $2QHI9 = parcelRequire("2QHI9");

var $h2yqz = parcelRequire("h2yqz");
const $94d8dacd02b9fa1d$var$renderAbsoluteOrRelativeDate = (timeStamp, pageAction, intl)=>{
    let pageActionText = '';
    switch(pageAction){
        case 'updated':
            pageActionText = intl.formatMessage((0, $h2yqz.default).timeUpdated);
            break;
        case 'viewed':
            pageActionText = intl.formatMessage((0, $h2yqz.default).timeViewed);
            break;
    }
    if ((0, $btz6U.default)(timeStamp, Date.now()) < -7) return {
        pageAction: pageActionText,
        dateString: (0, $57raR.default)(timeStamp, 'MMMM dd, yyyy')
    };
    return {
        pageAction: pageActionText,
        dateString: (0, $2QHI9.default)(timeStamp, Date.now()),
        timeSince: intl.formatMessage((0, $h2yqz.default).timeAgo)
    };
};
const $94d8dacd02b9fa1d$export$439b9bb86eb9f500 = (intl, lastViewedDate, lastUpdatedDate)=>{
    if (lastViewedDate) return $94d8dacd02b9fa1d$var$renderAbsoluteOrRelativeDate(lastViewedDate, 'viewed', intl);
    if (lastUpdatedDate) return $94d8dacd02b9fa1d$var$renderAbsoluteOrRelativeDate(lastUpdatedDate, 'updated', intl);
};

});



parcelRegister("b2d9j", function(module, exports) {
$parcel$export(module.exports, "inputWrapper", () => $17c3be13bb7cbc07$export$248a47518f3a0001);
$parcel$export(module.exports, "container", () => $17c3be13bb7cbc07$export$34e0f9847d4c02dd);
$parcel$export(module.exports, "containerWithProvider", () => $17c3be13bb7cbc07$export$8fb2d297355596b4);
$parcel$export(module.exports, "narrowContainerWidth", () => $17c3be13bb7cbc07$export$b45558f4e00a3f09);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

function $17c3be13bb7cbc07$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $17c3be13bb7cbc07$export$248a47518f3a0001 = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0,
    padding: `${"var(--ds-space-075, 6px)"} 0`,
    alignItems: 'center'
});
const $17c3be13bb7cbc07$export$34e0f9847d4c02dd = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    padding: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $4d66e472a8adb592$export$92a2501826f554f6)}px`,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 'initial'
});
const $17c3be13bb7cbc07$export$8fb2d297355596b4 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $4d66e472a8adb592$export$a62aa932daf22ffe)}px`
});
const $17c3be13bb7cbc07$export$b45558f4e00a3f09 = {
    name: "1raezz8",
    styles: "width:292px"
};

});
const $4d66e472a8adb592$export$a62aa932daf22ffe = 420;
const $4d66e472a8adb592$export$92a2501826f554f6 = 360;
const $4d66e472a8adb592$export$c04a5ad015d45447 = 360;
const $4d66e472a8adb592$export$c635b83728f81640 = 570;


parcelRegister("84M54", function(module, exports) {
$parcel$export(module.exports, "filterUniqueItems", () => $346ac22856e3fa3b$export$8437fc55448c6e05);
$parcel$export(module.exports, "mapContentTypeToIcon", () => $346ac22856e3fa3b$export$80e948449ec854a9);
$parcel$export(module.exports, "sha1", () => $346ac22856e3fa3b$export$5091bdda49ba90f5);
$parcel$export(module.exports, "wordCount", () => $346ac22856e3fa3b$export$24d5ff955141c347);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6YFG2 = parcelRequire("6YFG2");

var $jhs3c = parcelRequire("jhs3c");

var $ihwup = parcelRequire("ihwup");

var $i3nvV = parcelRequire("i3nvV");

var $8WXuv = parcelRequire("8WXuv");

var $fk1hB = parcelRequire("fk1hB");

var $iaeCZ = parcelRequire("iaeCZ");

var $cOjgE = parcelRequire("cOjgE");

var $eGOwo = parcelRequire("eGOwo");

var $j7F6W = parcelRequire("j7F6W");
function $346ac22856e3fa3b$export$8437fc55448c6e05(arr, comparator) {
    return arr.filter((firstItem, index, self)=>{
        return self.findIndex((secondItem)=>comparator ? comparator(firstItem, secondItem) : firstItem === secondItem) === index;
    });
}
const $346ac22856e3fa3b$var$Issue16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8WXuv.default), {
        label: intl.formatMessage((0, $eGOwo.fg)('confluence-issue-terminology-refresh') ? (0, $j7F6W.utilMessages).hyperlinkIconIssueLabelIssueTermRefresh : (0, $j7F6W.utilMessages).hyperlinkIconIssueLabel)
    });
};
const $346ac22856e3fa3b$var$Bug16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i3nvV.default), {
        label: intl.formatMessage((0, $j7F6W.utilMessages).hyperlinkIconBugLabel)
    });
};
const $346ac22856e3fa3b$var$Story16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iaeCZ.default), {
        label: intl.formatMessage((0, $j7F6W.utilMessages).hyperlinkIconStoryLabel)
    });
};
const $346ac22856e3fa3b$var$Task16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cOjgE.default), {
        label: intl.formatMessage((0, $j7F6W.utilMessages).hyperlinkIconTaskLabel)
    });
};
const $346ac22856e3fa3b$var$Page16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fk1hB.default), {
        label: intl.formatMessage((0, $j7F6W.utilMessages).hyperlinkIconPageLabel)
    });
};
const $346ac22856e3fa3b$var$Blog16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ihwup.default), {
        label: intl.formatMessage((0, $j7F6W.utilMessages).hyperlinkIconBlogLabel)
    });
};
const $346ac22856e3fa3b$var$IntlIssue16Icon = (0, $6YFG2.default)($346ac22856e3fa3b$var$Issue16);
const $346ac22856e3fa3b$var$IntlBug16Icon = (0, $6YFG2.default)($346ac22856e3fa3b$var$Bug16);
const $346ac22856e3fa3b$var$IntlStory16Icon = (0, $6YFG2.default)($346ac22856e3fa3b$var$Story16);
const $346ac22856e3fa3b$var$IntlTask16Icon = (0, $6YFG2.default)($346ac22856e3fa3b$var$Task16);
const $346ac22856e3fa3b$var$IntlPage16Icon = (0, $6YFG2.default)($346ac22856e3fa3b$var$Page16);
const $346ac22856e3fa3b$var$IntlBlog16Icon = (0, $6YFG2.default)($346ac22856e3fa3b$var$Blog16);
const $346ac22856e3fa3b$export$80e948449ec854a9 = {
    'jira.issue': /*#__PURE__*/ (0, $gt9Am.jsx)($346ac22856e3fa3b$var$IntlIssue16Icon, {}),
    'jira.issue.bug': /*#__PURE__*/ (0, $gt9Am.jsx)($346ac22856e3fa3b$var$IntlBug16Icon, {}),
    'jira.issue.story': /*#__PURE__*/ (0, $gt9Am.jsx)($346ac22856e3fa3b$var$IntlStory16Icon, {}),
    'jira.issue.task': /*#__PURE__*/ (0, $gt9Am.jsx)($346ac22856e3fa3b$var$IntlTask16Icon, {}),
    'confluence.page': /*#__PURE__*/ (0, $gt9Am.jsx)($346ac22856e3fa3b$var$IntlPage16Icon, {}),
    'confluence.blogpost': /*#__PURE__*/ (0, $gt9Am.jsx)($346ac22856e3fa3b$var$IntlBlog16Icon, {})
};
const $346ac22856e3fa3b$export$5091bdda49ba90f5 = (input)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($jhs3c))).createHash().update(input).digest('hex');
};
const $346ac22856e3fa3b$export$24d5ff955141c347 = (input)=>{
    return input.split(' ').length;
};

});
parcelRegister("ihwup", function(module, exports) {
$parcel$export(module.exports, "default", () => $6042983cb1b7627c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25f59ea2b6bc25c62576440e4e014d55>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $amerd = parcelRequire("amerd");

var $ixkyU = parcelRequire("ixkyU");

var $eGOwo = parcelRequire("eGOwo");

var $37A7r = parcelRequire("37A7r");
/**
 * __16px `blog` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $6042983cb1b7627c$var$Blog16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ixkyU.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($amerd))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $37A7r.default), {
            label: label,
            testId: testId
        })
    });
};
$6042983cb1b7627c$var$Blog16Icon.displayName = 'Blog16Icon';
var $6042983cb1b7627c$export$2e2bcd8739ae039 = $6042983cb1b7627c$var$Blog16Icon;

});
parcelRegister("ixkyU", function(module, exports) {
$parcel$export(module.exports, "default", () => $efb8455781b7b8dd$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97191d14e335e1cb9997865bd9c31c4d>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $amerd = parcelRequire("amerd");

var $gPsTF = parcelRequire("gPsTF");
function $efb8455781b7b8dd$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($amerd))),
        color: "var(--ds-icon-accent-blue, #1D7AFC)"
    });
}

});

parcelRegister("37A7r", function(module, exports) {
$parcel$export(module.exports, "default", () => $def8fa9bf18a8fbf$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7cef41f07f9ec4679337b66fb782a07>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $def8fa9bf18a8fbf$var$Blog16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M6.972 6.128a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325m7 0a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$def8fa9bf18a8fbf$var$Blog16Icon.displayName = 'Blog16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$def8fa9bf18a8fbf$export$2e2bcd8739ae039 = $def8fa9bf18a8fbf$var$Blog16Icon;

});


parcelRegister("i3nvV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $7757e0f556678002$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::167fa533efc4ba93e24036848d1072d4>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $9UdpB = parcelRequire("9UdpB");

var $lcl8I = parcelRequire("lcl8I");

var $eGOwo = parcelRequire("eGOwo");

var $ePICl = parcelRequire("ePICl");
/**
 * __16px `bug` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $7757e0f556678002$var$Bug16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lcl8I.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9UdpB))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ePICl.default), {
            label: label,
            testId: testId
        })
    });
};
$7757e0f556678002$var$Bug16Icon.displayName = 'Bug16Icon';
var $7757e0f556678002$export$2e2bcd8739ae039 = $7757e0f556678002$var$Bug16Icon;

});
parcelRegister("lcl8I", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f9279295c562e43$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3405feb70bdc0482b21b411108f82ba5>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $9UdpB = parcelRequire("9UdpB");

var $gPsTF = parcelRequire("gPsTF");
function $9f9279295c562e43$export$2e2bcd8739ae039({ label: label = 'Bug', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9UdpB))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
}

});

parcelRegister("ePICl", function(module, exports) {
$parcel$export(module.exports, "default", () => $c67568ee10eb7c6c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5651d34540e7f43d2ed8c5db6223a91c>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $c67568ee10eb7c6c$var$Bug16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`,
        ...props,
        size: "small"
    });
$c67568ee10eb7c6c$var$Bug16Icon.displayName = 'Bug16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c67568ee10eb7c6c$export$2e2bcd8739ae039 = $c67568ee10eb7c6c$var$Bug16Icon;

});


parcelRegister("8WXuv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $67922ee1ec2953f7$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bca06c5d0b322c69c2d7dabe129b3860>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $c59mr = parcelRequire("c59mr");

var $hMLdG = parcelRequire("hMLdG");

var $eGOwo = parcelRequire("eGOwo");

var $28xc1 = parcelRequire("28xc1");
/**
 * __16px `issue` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $67922ee1ec2953f7$var$Issue16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hMLdG.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c59mr))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $28xc1.default), {
            label: label,
            testId: testId
        })
    });
};
$67922ee1ec2953f7$var$Issue16Icon.displayName = 'Issue16Icon';
var $67922ee1ec2953f7$export$2e2bcd8739ae039 = $67922ee1ec2953f7$var$Issue16Icon;

});
parcelRegister("hMLdG", function(module, exports) {
$parcel$export(module.exports, "default", () => $b0fecfbb7e320ff1$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9d7811e9ce600b90f94930755b99d471>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $c59mr = parcelRequire("c59mr");

var $gPsTF = parcelRequire("gPsTF");
function $b0fecfbb7e320ff1$export$2e2bcd8739ae039({ label: label = 'Work Item', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c59mr))),
        color: "var(--ds-icon-accent-blue, #1D7AFC)"
    });
}

});

parcelRegister("28xc1", function(module, exports) {
$parcel$export(module.exports, "default", () => $26d0d6c17f6a21a0$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::92eaddadffe090000f45e8586efb1edd>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $26d0d6c17f6a21a0$var$Issue16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm1 2v4h8V6z"/></svg>`,
        ...props,
        size: "small"
    });
$26d0d6c17f6a21a0$var$Issue16Icon.displayName = 'Issue16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$26d0d6c17f6a21a0$export$2e2bcd8739ae039 = $26d0d6c17f6a21a0$var$Issue16Icon;

});


parcelRegister("iaeCZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $5d125ca7430036a6$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::58018d99cc8a0f6abeddbd3fccbd6413>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $hVZow = parcelRequire("hVZow");

var $1ln11 = parcelRequire("1ln11");

var $eGOwo = parcelRequire("eGOwo");

var $ayExB = parcelRequire("ayExB");
/**
 * __16px `story` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $5d125ca7430036a6$var$Story16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1ln11.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hVZow))),
        appearance: "greenBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ayExB.default), {
            label: label,
            testId: testId
        })
    });
};
$5d125ca7430036a6$var$Story16Icon.displayName = 'Story16Icon';
var $5d125ca7430036a6$export$2e2bcd8739ae039 = $5d125ca7430036a6$var$Story16Icon;

});
parcelRegister("1ln11", function(module, exports) {
$parcel$export(module.exports, "default", () => $02d2d79053f6e150$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc6be74be899a91647cea1371235d747>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hVZow = parcelRequire("hVZow");

var $gPsTF = parcelRequire("gPsTF");
function $02d2d79053f6e150$export$2e2bcd8739ae039({ label: label = 'Story', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hVZow))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
}

});

parcelRegister("ayExB", function(module, exports) {
$parcel$export(module.exports, "default", () => $a03bb463cddb9827$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1896fd3bafdfc1bc71c0fcf57c8b2685>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $a03bb463cddb9827$var$Story16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 11-2.863 1.822c-.42.38-1.137.111-1.137-.427v-8.19C4 3.54 4.596 3 5.333 3h5.334C11.403 3 12 3.539 12 4.206v8.19c0 .537-.719.806-1.139.426zm0-2.371 2 1.274V5H6v4.902z"/></svg>`,
        ...props,
        size: "small"
    });
$a03bb463cddb9827$var$Story16Icon.displayName = 'Story16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a03bb463cddb9827$export$2e2bcd8739ae039 = $a03bb463cddb9827$var$Story16Icon;

});


parcelRegister("cOjgE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $442ecc1a7897d80c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ba42c74cbfda9afab131839d0b6c6e6f>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $bwM92 = parcelRequire("bwM92");

var $iXN9z = parcelRequire("iXN9z");

var $eGOwo = parcelRequire("eGOwo");

var $dSbyY = parcelRequire("dSbyY");
/**
 * __16px `task` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $442ecc1a7897d80c$var$Task16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iXN9z.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bwM92))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dSbyY.default), {
            label: label,
            testId: testId
        })
    });
};
$442ecc1a7897d80c$var$Task16Icon.displayName = 'Task16Icon';
var $442ecc1a7897d80c$export$2e2bcd8739ae039 = $442ecc1a7897d80c$var$Task16Icon;

});
parcelRegister("bwM92", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::511501585faa18257c05d7a2687e12c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8648076de2cded56$var$_react = $8648076de2cded56$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $8648076de2cded56$var$_baseNew = $8648076de2cded56$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $8648076de2cded56$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Task".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8648076de2cded56$var$TaskIcon = (props)=>/*#__PURE__*/ $8648076de2cded56$var$_react.default.createElement($8648076de2cded56$var$_baseNew.default, Object.assign({
        name: "TaskIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm9.326 2.98-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308z" clip-rule="evenodd"/>`
    }, props));
$8648076de2cded56$var$TaskIcon.displayName = 'TaskIcon';
var $8648076de2cded56$var$_default = module.exports.default = $8648076de2cded56$var$TaskIcon;

});

parcelRegister("iXN9z", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4b71fd2f274d4b0$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::00a580c76a83b898772f38add89d77e3>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $bwM92 = parcelRequire("bwM92");

var $gPsTF = parcelRequire("gPsTF");
function $b4b71fd2f274d4b0$export$2e2bcd8739ae039({ label: label = 'Task', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bwM92))),
        color: "var(--ds-icon-accent-blue, #1D7AFC)"
    });
}

});

parcelRegister("dSbyY", function(module, exports) {
$parcel$export(module.exports, "default", () => $7143582d1b645e3c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3096846462441e20a58007578ded0cbf>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $7143582d1b645e3c$var$Task16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zM4.667 3C3.747 3 3 3.746 3 4.667v6.666C3 12.253 3.746 13 4.667 13h6.666c.92 0 1.667-.746 1.667-1.667V4.667C13 3.747 12.254 3 11.333 3zM5 5v6h6V5z"/></svg>`,
        ...props,
        size: "small"
    });
$7143582d1b645e3c$var$Task16Icon.displayName = 'Task16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7143582d1b645e3c$export$2e2bcd8739ae039 = $7143582d1b645e3c$var$Task16Icon;

});


parcelRegister("j7F6W", function(module, exports) {
$parcel$export(module.exports, "utilMessages", () => $4386b122c8afdcff$export$ecd9e62648c1046a);

var $7qGN1 = parcelRequire("7qGN1");
const $4386b122c8afdcff$export$ecd9e62648c1046a = (0, $7qGN1.defineMessages)({
    hyperlinkIconIssueLabel: {
        id: 'fabric.editor.headingLink.hyperlinkIconIssueLabel',
        defaultMessage: 'Issue',
        description: 'icon label for a jira issue'
    },
    hyperlinkIconBugLabel: {
        id: 'fabric.editor.headingLink.hyperlinkIconBugLabel',
        defaultMessage: 'Bug',
        description: 'icon label for a jira bug'
    },
    hyperlinkIconStoryLabel: {
        id: 'fabric.editor.headingLink.hyperlinkIconStoryLabel',
        defaultMessage: 'Story',
        description: 'icon label for a jira story'
    },
    hyperlinkIconTaskLabel: {
        id: 'fabric.editor.headingLink.hyperlinkIconTaskLabel',
        defaultMessage: 'Task',
        description: 'icon label for a jira task'
    },
    hyperlinkIconPageLabel: {
        id: 'fabric.editor.headingLink.hyperlinkIconPageLabel',
        defaultMessage: 'Page',
        description: 'icon label for a confluence page'
    },
    hyperlinkIconBlogLabel: {
        id: 'fabric.editor.headingLink.hyperlinkIconBlogLabel',
        defaultMessage: 'Blog',
        description: 'icon label for a confluence blog'
    },
    hyperlinkIconIssueLabelIssueTermRefresh: {
        id: 'fabric.editor.headingLink.hyperlinkIconIssueLabel.issue-term-refresh',
        defaultMessage: 'Work Item',
        description: 'icon label for a jira issue'
    }
});

});




parcelRegister("jx6gl", function(module, exports) {
$parcel$export(module.exports, "areToolbarFlagsEnabled", () => $4e590ec6c94d1164$export$c6d9af905adcabd8);

var $9Letn = parcelRequire("9Letn");
const $4e590ec6c94d1164$export$c6d9af905adcabd8 = (isNewToolbarEnabled)=>Boolean((0, $9Letn.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1') || isNewToolbarEnabled);

});

parcelRegister("b5R53", function(module, exports) {
$parcel$export(module.exports, "UserIntentPopupWrapper", () => $d6e3eb225df2349f$export$99ff0262540b54dc);

var $eJOHy = parcelRequire("eJOHy");

var $9Letn = parcelRequire("9Letn");
const $d6e3eb225df2349f$export$99ff0262540b54dc = ({ userIntent: userIntent = 'popupOpen', children: children, api: api })=>{
    (0, $eJOHy.useEffect)(()=>{
        api?.core.actions.execute(api?.userIntent?.commands.setCurrentUserIntent((0, $9Letn.expValEqualsNoExposure)('platform_editor_lovability_user_intent', 'isEnabled', true) ? userIntent : 'popupOpen'));
        return ()=>{
            api?.core.actions.execute(api?.userIntent?.commands.setCurrentUserIntent('default'));
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return children;
};

});

parcelRegister("dQl2w", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::389823b40aad588b43ecd72e237cdac0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a14073b85762ade2$var$_react = $a14073b85762ade2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a14073b85762ade2$var$_linkBroken = $a14073b85762ade2$var$_interopRequireDefault((parcelRequire("25YjY")));

var $a14073b85762ade2$var$_unlink = $a14073b85762ade2$var$_interopRequireDefault((parcelRequire("bnsEu")));
function $a14073b85762ade2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkBrokenIcon.
 * This component is LinkBrokenIcon, with `UNSAFE_fallbackIcon` set to "EditorUnlinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing a link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a14073b85762ade2$var$LinkBrokenIcon = (props)=>/*#__PURE__*/ $a14073b85762ade2$var$_react.default.createElement($a14073b85762ade2$var$_linkBroken.default, Object.assign({
        name: "LinkBrokenIcon",
        LEGACY_fallbackIcon: $a14073b85762ade2$var$_unlink.default
    }, props));
$a14073b85762ade2$var$LinkBrokenIcon.displayName = 'LinkBrokenIconMigration';
var $a14073b85762ade2$var$_default = module.exports.default = $a14073b85762ade2$var$LinkBrokenIcon;

});
parcelRegister("25YjY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ae3bff1d1955acd002e5417a314968c1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $186ad6f022280ede$var$_react = $186ad6f022280ede$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $186ad6f022280ede$var$_baseNew = $186ad6f022280ede$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $186ad6f022280ede$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkBroken".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing a link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $186ad6f022280ede$var$LinkBrokenIcon = (props)=>/*#__PURE__*/ $186ad6f022280ede$var$_react.default.createElement($186ad6f022280ede$var$_baseNew.default, Object.assign({
        name: "LinkBrokenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 1v3H4.5V1zm2.22 1.22a3.932 3.932 0 1 1 5.56 5.56l-.75.75-1.06-1.06.75-.75a2.432 2.432 0 0 0-3.44-3.44l-.75.75-1.06-1.06zM1 4.5h3V6H1zm1.22 3.72.75-.75 1.06 1.06-.75.75a2.432 2.432 0 0 0 3.44 3.44l.75-.75 1.06 1.06-.75.75a3.932 3.932 0 1 1-5.56-5.56M15 11.5h-3V10h3zM10 15v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$186ad6f022280ede$var$LinkBrokenIcon.displayName = 'LinkBrokenIcon';
var $186ad6f022280ede$var$_default = module.exports.default = $186ad6f022280ede$var$LinkBrokenIcon;

});

parcelRegister("bnsEu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $848811633a172475$var$_react = $848811633a172475$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $848811633a172475$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $848811633a172475$var$EditorUnlinkIcon = (props)=>/*#__PURE__*/ $848811633a172475$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M5 10V9h2v1zm4-5h1v2H9zm7.646 12.354.708-.708 2 2-.708.708zM17 15v-1h2v1zm-3 2h1v2h-1zM7.354 6.646l-.708.708-2-2 .708-.708zm3.567 9.037 1.061-1.062a.75.75 0 1 1 1.06 1.061l-1.06 1.061a3.25 3.25 0 0 1-4.596 0 3.247 3.247 0 0 1 0-4.596l1.06-1.061.703-.703c.793-.63 1.773.35 1.06 1.06l-.702.703-1.06 1.062a1.747 1.747 0 0 0 0 2.474 1.75 1.75 0 0 0 2.474 0m2.658-7.608-1.061 1.061a.75.75 0 0 1-1.06-1.06l1.06-1.062a3.25 3.25 0 0 1 4.596 0 3.247 3.247 0 0 1 0 4.596l-1.06 1.062-.703.702c-.565.565-1.581-.45-1.06-1.06l.702-.703 1.06-1.061a1.747 1.747 0 0 0 0-2.475 1.75 1.75 0 0 0-2.474 0"/></svg>`
    }, props));
$848811633a172475$var$EditorUnlinkIcon.displayName = 'EditorUnlinkIcon';
var $848811633a172475$var$_default = module.exports.default = $848811633a172475$var$EditorUnlinkIcon;

});


parcelRegister("8rAKL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::166c54eac565624de39efb8836e98193>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $625d5ac66d163c05$var$_react = $625d5ac66d163c05$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $625d5ac66d163c05$var$_linkExternal = $625d5ac66d163c05$var$_interopRequireDefault((parcelRequire("9itkV")));

var $625d5ac66d163c05$var$_shortcut = $625d5ac66d163c05$var$_interopRequireDefault((parcelRequire("lhaOC")));
function $625d5ac66d163c05$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkExternalIcon.
 * This component is LinkExternalIcon, with `UNSAFE_fallbackIcon` set to "ShortcutIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $625d5ac66d163c05$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $625d5ac66d163c05$var$_react.default.createElement($625d5ac66d163c05$var$_linkExternal.default, Object.assign({
        name: "LinkExternalIcon",
        LEGACY_fallbackIcon: $625d5ac66d163c05$var$_shortcut.default
    }, props));
$625d5ac66d163c05$var$LinkExternalIcon.displayName = 'LinkExternalIconMigration';
var $625d5ac66d163c05$var$_default = module.exports.default = $625d5ac66d163c05$var$LinkExternalIcon;

});
parcelRegister("lhaOC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7d3934037e9da62$var$_react = $f7d3934037e9da62$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $f7d3934037e9da62$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f7d3934037e9da62$var$ShortcutIcon = (props)=>/*#__PURE__*/ $f7d3934037e9da62$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M5 19.01V19zM5 4.99V5zM19 19v-6h2v6a2 2 0 0 1-1.99 2H5a2 2 0 0 1-2-1.99V4.99C3 3.89 3.9 3 5 3h6v2H5v14zM5 4.99V5zM11 5H5v14h14v-6h2v6a2 2 0 0 1-1.99 2H5a2 2 0 0 1-2-1.99V4.99C3 3.89 3.9 3 5 3h6zm8 0v3a1 1 0 0 0 2 0V4a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2z"/><path d="m12.707 12.707 8-8a1 1 0 1 0-1.414-1.414l-8 8a1 1 0 0 0 1.414 1.414"/></g></svg>`
    }, props));
$f7d3934037e9da62$var$ShortcutIcon.displayName = 'ShortcutIcon';
var $f7d3934037e9da62$var$_default = module.exports.default = $f7d3934037e9da62$var$ShortcutIcon;

});




parcelRegister("ishVX", function(module, exports) {
$parcel$export(module.exports, "toolbarListsIndentationPlugin", () => $e92d281b87137bd6$export$fdc8ab6a3979a865);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $cxXTK = parcelRequire("cxXTK");

var $aBsWC = parcelRequire("aBsWC");

var $eJQEz = parcelRequire("eJQEz");

var $eGOwo = parcelRequire("eGOwo");

var $92xoS = parcelRequire("92xoS");

var $e36TU = parcelRequire("e36TU");

var $eRKkP = parcelRequire("eRKkP");

var $3Tv4M = parcelRequire("3Tv4M");

var $iqesS = parcelRequire("iqesS");

var $eSzDT = parcelRequire("eSzDT");
const $e92d281b87137bd6$export$fdc8ab6a3979a865 = ({ config: config, api: api })=>{
    const { showIndentationButtons: showIndentationButtons = false, allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation = false } = config ?? {};
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const primaryToolbarComponent = ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)($e92d281b87137bd6$export$94516d5cccf573e3, {
            featureFlags: featureFlags,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            isSmall: toolbarSize < (0, $aBsWC.ToolbarSize).L,
            isToolbarReducedSpacing: isToolbarReducedSpacing,
            disabled: disabled,
            editorView: editorView,
            showIndentationButtons: showIndentationButtons,
            pluginInjectionApi: api,
            allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation
        });
    };
    if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $eSzDT.getToolbarComponents)({
        api: api,
        showIndentationButtons: showIndentationButtons,
        allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation
    }));
    else api?.primaryToolbar?.actions.registerComponent({
        name: 'toolbarListsIndentation',
        component: primaryToolbarComponent
    });
    return {
        name: 'toolbarListsIndentation',
        pluginsOptions: {
            ...!isToolbarAIFCEnabled && {
                selectionToolbar () {
                    const toolbarDocking = (0, $eGOwo.fg)('platform_editor_use_preferences_plugin') ? api?.userPreferences?.sharedState.currentState()?.preferences.toolbarDockingPosition : api?.selectionToolbar?.sharedState?.currentState()?.toolbarDocking;
                    if (toolbarDocking === 'none' && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1', {
                        exposure: true
                    })) {
                        const toolbarCustom = {
                            type: 'custom',
                            render: (view)=>{
                                if (!view) return;
                                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iqesS.FloatingToolbarComponent), {
                                    editorView: view,
                                    featureFlags: featureFlags,
                                    pluginInjectionApi: api,
                                    showIndentationButtons: showIndentationButtons,
                                    allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation
                                });
                            },
                            fallback: []
                        };
                        return {
                            rank: 3,
                            isToolbarAbove: true,
                            items: [
                                toolbarCustom
                            ],
                            pluginName: 'toolbarListsIndentation'
                        };
                    } else return undefined;
                }
            }
        },
        primaryToolbarComponent: !isToolbarAIFCEnabled && !api?.primaryToolbar ? primaryToolbarComponent : undefined
    };
};
function $e92d281b87137bd6$export$94516d5cccf573e3({ featureFlags: featureFlags, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isSmall: isSmall, isToolbarReducedSpacing: isToolbarReducedSpacing, disabled: disabled, editorView: editorView, showIndentationButtons: showIndentationButtons, pluginInjectionApi: pluginInjectionApi, allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation }) {
    const { bulletListActive: bulletListActive, bulletListDisabled: bulletListDisabled, orderedListActive: orderedListActive, orderedListDisabled: orderedListDisabled, isIndentationAllowed: isIndentationAllowed, indentDisabled: indentDisabled, outdentDisabled: outdentDisabled } = (0, $cxXTK.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'list',
        'indentation'
    ], (states)=>({
            bulletListActive: states.listState?.bulletListActive,
            bulletListDisabled: states.listState?.bulletListDisabled,
            orderedListActive: states.listState?.orderedListActive,
            orderedListDisabled: states.listState?.orderedListDisabled,
            isIndentationAllowed: states.indentationState?.isIndentationAllowed,
            indentDisabled: states.indentationState?.indentDisabled,
            outdentDisabled: states.indentationState?.outdentDisabled,
            // decorationSet is required to re-render PrimaryToolbarComponent component, so that the toolbar states updates regularly
            decorationSet: states.listState?.decorationSet
        }));
    const [taskDecisionState, setTaskDecisionState] = (0, $eJOHy.useState)();
    (0, $eJQEz.usePluginStateEffect)(pluginInjectionApi, [
        'taskDecision'
    ], ({ taskDecisionState: newTaskDecisionState })=>{
        if (newTaskDecisionState?.outdentDisabled !== taskDecisionState?.outdentDisabled || newTaskDecisionState?.indentDisabled !== taskDecisionState?.indentDisabled || newTaskDecisionState?.isInsideTask !== taskDecisionState?.isInsideTask) setTaskDecisionState({
            isInsideTask: Boolean(newTaskDecisionState?.isInsideTask),
            indentDisabled: Boolean(newTaskDecisionState?.indentDisabled),
            outdentDisabled: Boolean(newTaskDecisionState?.outdentDisabled)
        });
    });
    const toolbarListsIndentationState = (0, $e36TU.getIndentationButtonsState)(editorView.state, allowHeadingAndParagraphIndentation, taskDecisionState, {
        isIndentationAllowed: isIndentationAllowed,
        indentDisabled: indentDisabled,
        outdentDisabled: outdentDisabled
    }, pluginInjectionApi?.list?.actions.isInsideListItem);
    if (bulletListActive === undefined || bulletListDisabled === undefined || orderedListActive === undefined || orderedListDisabled === undefined) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3Tv4M.default), {
        featureFlags: featureFlags,
        isSmall: isSmall,
        isReducedSpacing: isToolbarReducedSpacing,
        disabled: disabled,
        editorView: editorView,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        bulletListActive: bulletListActive,
        bulletListDisabled: bulletListDisabled,
        orderedListActive: orderedListActive,
        orderedListDisabled: orderedListDisabled,
        showIndentationButtons: !!showIndentationButtons,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        indentDisabled: toolbarListsIndentationState.indentDisabled,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        outdentDisabled: toolbarListsIndentationState.outdentDisabled,
        indentationStateNode: toolbarListsIndentationState?.node,
        pluginInjectionApi: pluginInjectionApi,
        toolbarType: (0, $eRKkP.ToolbarType).PRIMARY
    });
}

});
parcelRegister("eJQEz", function(module, exports) {
$parcel$export(module.exports, "usePluginStateEffect", () => $f7a31f1b90f34787$export$85f3fdc261c569b3);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");
/**
 *
 * Directly map object values
 *
 * @param object The object to transform
 * @param mapFunction The function to map an old value to new one
 * @returns Object with the same key but transformed values
 *
 */ function $f7a31f1b90f34787$var$mapValues(object, mapFunction) {
    return Object.entries(object).reduce((acc, [key, value])=>({
            ...acc,
            [key]: mapFunction(value)
        }), {});
}
// When we use the `useSharedPluginState` example: `useSharedPluginState(api, ['width'])`
// it will re-render every time the component re-renders as the array "['width']" is seen as an update.
// This hook is used to prevent re-renders due to this.
function $f7a31f1b90f34787$var$useStaticPlugins(plugins) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $eJOHy.useMemo)(()=>plugins, []);
}
function $f7a31f1b90f34787$export$85f3fdc261c569b3(injectionApi, plugins, effect, options = {}) {
    const pluginNames = $f7a31f1b90f34787$var$useStaticPlugins(plugins);
    // Create a memoized object containing the named plugins
    const namedExternalPlugins = (0, $eJOHy.useMemo)(()=>pluginNames.reduce((acc, pluginName)=>({
                ...acc,
                [`${String(pluginName)}State`]: injectionApi?.[pluginName]
            }), {}), [
        injectionApi,
        pluginNames
    ]);
    $f7a31f1b90f34787$var$usePluginStateEffectInternal(namedExternalPlugins, effect, options);
}
function $f7a31f1b90f34787$var$usePluginStateEffectInternal(externalPlugins, effect, options = {}) {
    const refStates = (0, $eJOHy.useRef)();
    const cleanup = (0, $eJOHy.useRef)();
    const latestEffect = (0, $eJOHy.useRef)(effect);
    // We should store the latest effect in a reference so it is more intuitive to the user
    // and we are not causing a memory leak by having references to old state.
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (options.disabled) return;
        latestEffect.current = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(effect);
        return ()=>{
            latestEffect.current = undefined;
        };
    }, [
        effect,
        options.disabled
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (options.disabled) return;
        // Update the reference for this plugin and activate the effect
        refStates.current = $f7a31f1b90f34787$var$mapValues(externalPlugins, (value)=>value?.sharedState.currentState());
        cleanup.current = latestEffect.current?.(refStates.current);
        const unsubs = Object.entries(externalPlugins).map(([pluginKey, externalPlugin])=>externalPlugin?.sharedState.onChange(({ nextSharedState: nextSharedState, prevSharedState: prevSharedState })=>{
                if (prevSharedState !== nextSharedState && refStates.current) {
                    // Update the reference for this plugin and activate the effect
                    refStates.current[pluginKey] = nextSharedState;
                    cleanup.current = latestEffect.current?.(refStates.current);
                }
            }));
        return ()=>{
            refStates.current = undefined;
            unsubs.forEach((cb)=>cb?.());
            cleanup.current?.();
        };
    // Do not re-run if the `effect` changes - this is not expected with `useEffect` or similar hooks
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        externalPlugins,
        options.disabled
    ]);
}

});

parcelRegister("e36TU", function(module, exports) {
$parcel$export(module.exports, "getIndentationButtonsState", () => $e0cda9b2016a89cd$export$3d562ab2ad3402f3);


var $81iCy = parcelRequire("81iCy");

var $BmspC = parcelRequire("BmspC");
function $e0cda9b2016a89cd$export$3d562ab2ad3402f3(editorState, allowHeadingAndParagraphIndentation, taskDecisionState, indentationState, isInsideListItem) {
    const state = {
        indentDisabled: true,
        outdentDisabled: true,
        node: null
    };
    const { selection: selection } = editorState;
    // Handle bullet and numbered lists seperately as they do
    // not use the indentation mark.
    // Check for lists before paragraphs and headings in case
    // the selection is in a list nested in a layout column.
    if (isInsideListItem?.(editorState.tr)) {
        const { indentLevel: indentLevel, itemIndex: itemIndex } = (0, $81iCy.getListItemAttributes)(selection.$head);
        return {
            // List indent levels are zero indexed so we need to subtract 1
            indentDisabled: itemIndex === 0 || indentLevel >= (0, $f93ddaaf75c99dad$export$d5851c05c73d1974) - 1,
            outdentDisabled: false,
            node: 'list'
        };
    }
    // Handle tasks seperately as they do not use the indentation mark
    // and have different behaviour for outdent compared to lists
    if (taskDecisionState?.isInsideTask) return {
        indentDisabled: taskDecisionState.indentDisabled,
        outdentDisabled: taskDecisionState.outdentDisabled,
        node: 'taskList'
    };
    const isTopLevelParagraphOrHeading = selection.$from.depth === 1;
    const isInLayoutNode = (0, $BmspC.hasParentNodeOfType)(editorState.schema.nodes.layoutColumn)(selection) && // depth of non-nested paragraphs and headings in layouts will always be 3
    selection.$from.depth === 3;
    if (allowHeadingAndParagraphIndentation && (indentationState?.isIndentationAllowed ?? false) && (isTopLevelParagraphOrHeading || isInLayoutNode) && indentationState?.indentDisabled !== undefined && indentationState?.outdentDisabled !== undefined) return {
        indentDisabled: indentationState.indentDisabled,
        outdentDisabled: indentationState.outdentDisabled,
        node: 'paragraph_heading'
    };
    return state;
}

});
const $f93ddaaf75c99dad$export$d5851c05c73d1974 = 6;

parcelRegister("81iCy", function(module, exports) {
$parcel$export(module.exports, "numberNestedLists", () => $7fb843dec99618ea$export$5fe3c994010aac53);
$parcel$export(module.exports, "getListItemAttributes", () => $7fb843dec99618ea$export$3f981ad265759e92);
$parcel$export(module.exports, "normalizeListItemsSelection", () => $7fb843dec99618ea$export$6c425b5a921132e);

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");

var $fCXIH = parcelRequire("fCXIH");
const $7fb843dec99618ea$export$5fe3c994010aac53 = (resolvedPos)=>{
    let count = 0;
    for(let i = resolvedPos.depth - 1; i > 0; i--){
        const node = resolvedPos.node(i);
        if ((0, $fCXIH.isListNode)(node)) count += 1;
    }
    return count;
};
const $7fb843dec99618ea$export$3f981ad265759e92 = ($pos)=>{
    // Get level for the correct indent of nesting
    const indentLevel = $7fb843dec99618ea$export$5fe3c994010aac53($pos) - 1;
    const itemAtPos = (0, $BmspC.findParentNodeClosestToPos)($pos, (0, $fCXIH.isListItemNode));
    // Get the index of the current item relative to parent (parent is at item depth - 1)
    const itemIndex = $pos.index(itemAtPos ? itemAtPos.depth - 1 : undefined);
    return {
        indentLevel: indentLevel,
        itemIndex: itemIndex
    };
};
const $7fb843dec99618ea$export$6c425b5a921132e = ({ selection: selection, doc: doc })=>{
    if (selection.empty) return selection;
    const { $from: $from, $to: $to } = selection;
    if (selection instanceof (0, $3lIcL.NodeSelection)) {
        const head = $7fb843dec99618ea$var$resolvePositionToStartOfListItem($from);
        return new (0, $3lIcL.TextSelection)(head, head);
    }
    const head = $7fb843dec99618ea$var$resolvePositionToStartOfListItem($from);
    const anchor = $7fb843dec99618ea$var$resolvePositionToEndOfListItem($to);
    return new (0, $3lIcL.TextSelection)(anchor, head);
};
const $7fb843dec99618ea$var$resolvePositionToStartOfListItem = ($pos)=>{
    const fromRange = $pos.blockRange($pos, (0, $fCXIH.isListItemNode));
    const fromPosition = fromRange && $pos.textOffset === 0 && fromRange.end - 1 === $pos.pos ? (0, $3lIcL.Selection).near($pos.doc.resolve(fromRange.end + 1), 1).$from : $pos;
    return fromPosition;
};
const $7fb843dec99618ea$var$resolvePositionToEndOfListItem = ($pos)=>{
    const toRange = $pos.blockRange($pos, (0, $fCXIH.isListItemNode));
    const toPosition = toRange && $pos.textOffset === 0 && toRange.start + 1 === $pos.pos ? (0, $3lIcL.Selection).near($pos.doc.resolve(toRange.start - 1), -1).$to : $pos;
    return toPosition;
};

});


parcelRegister("eRKkP", function(module, exports) {
$parcel$export(module.exports, "ToolbarType", () => $ce3e93b286cbef6e$export$a5d11b3163e4b1a5);
var $ce3e93b286cbef6e$export$a5d11b3163e4b1a5 = /*#__PURE__*/ function(ToolbarType) {
    ToolbarType["PRIMARY"] = "primaryToolbar";
    ToolbarType["FLOATING"] = "floatingToolbar";
    return ToolbarType;
}({});

});

parcelRegister("3Tv4M", function(module, exports) {
$parcel$export(module.exports, "default", () => $edff9e1bce2ced5e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $bMFKb = parcelRequire("bMFKb");

var $92xoS = parcelRequire("92xoS");

var $eRKkP = parcelRequire("eRKkP");

var $eXOb6 = parcelRequire("eXOb6");

var $iNy03 = parcelRequire("iNy03");

var $45g6R = parcelRequire("45g6R");

var $ea7w3 = parcelRequire("ea7w3");
function $edff9e1bce2ced5e$export$2e2bcd8739ae039(props) {
    const { disabled: disabled, isSmall: isSmall, isReducedSpacing: isReducedSpacing, bulletListActive: bulletListActive, bulletListDisabled: bulletListDisabled, orderedListActive: orderedListActive, orderedListDisabled: orderedListDisabled, showIndentationButtons: showIndentationButtons, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, indentDisabled: indentDisabled, outdentDisabled: outdentDisabled, indentationStateNode: indentationStateNode, featureFlags: featureFlags, pluginInjectionApi: pluginInjectionApi, toolbarType: toolbarType } = props;
    const inputMethod = toolbarType ? (0, $ea7w3.getInputMethod)(toolbarType) : (0, $bMFKb.INPUT_METHOD).TOOLBAR;
    if (isSmall || toolbarType === (0, $eRKkP.ToolbarType).FLOATING || (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) {
        const areAllOptionsDisabled = [
            bulletListDisabled,
            orderedListDisabled,
            indentDisabled,
            outdentDisabled
        ].every((item)=>Boolean(item) === true);
        const isDisabled = disabled || areAllOptionsDisabled;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $45g6R.ToolbarDropdown), {
            editorView: props.editorView,
            isReducedSpacing: isReducedSpacing,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            bulletListActive: bulletListActive,
            bulletListDisabled: bulletListDisabled,
            showIndentationButtons: showIndentationButtons,
            orderedListActive: orderedListActive,
            orderedListDisabled: orderedListDisabled,
            indentDisabled: indentDisabled,
            outdentDisabled: outdentDisabled,
            disabled: isDisabled,
            onItemActivated: (0, $eXOb6.onItemActivated)(pluginInjectionApi, indentationStateNode, inputMethod),
            featureFlags: featureFlags,
            pluginInjectionApi: pluginInjectionApi,
            toolbarType: toolbarType
        });
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iNy03.Toolbar), {
        editorView: props.editorView,
        isReducedSpacing: isReducedSpacing,
        bulletListActive: bulletListActive,
        bulletListDisabled: bulletListDisabled,
        showIndentationButtons: showIndentationButtons,
        orderedListActive: orderedListActive,
        orderedListDisabled: orderedListDisabled,
        indentDisabled: indentDisabled,
        outdentDisabled: outdentDisabled,
        disabled: disabled,
        onItemActivated: (0, $eXOb6.onItemActivated)(pluginInjectionApi, indentationStateNode, inputMethod),
        featureFlags: featureFlags,
        pluginInjectionApi: pluginInjectionApi
    });
}

});
parcelRegister("eXOb6", function(module, exports) {
$parcel$export(module.exports, "onItemActivated", () => $fa963a398e67a524$export$602524aee99c280f);
const $fa963a398e67a524$export$602524aee99c280f = (pluginInjectionApi, indentationStateNode, inputMethod)=>({ buttonName: buttonName, editorView: editorView })=>{
        switch(buttonName){
            case 'bullet_list':
                pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.list?.commands.toggleBulletList(inputMethod));
                break;
            case 'ordered_list':
                pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.list?.commands.toggleOrderedList(inputMethod));
                break;
            case 'indent':
                {
                    const node = indentationStateNode;
                    if (node === 'paragraph_heading') pluginInjectionApi?.indentation?.actions.indentParagraphOrHeading(inputMethod)(editorView.state, editorView.dispatch);
                    if (node === 'list') pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.list?.commands.indentList(inputMethod));
                    if (node === 'taskList') pluginInjectionApi?.taskDecision?.actions.indentTaskList(inputMethod)(editorView.state, editorView.dispatch);
                    break;
                }
            case 'outdent':
                {
                    const node = indentationStateNode;
                    if (node === 'paragraph_heading') pluginInjectionApi?.indentation?.actions.outdentParagraphOrHeading(inputMethod)(editorView.state, editorView.dispatch);
                    if (node === 'list') pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.list?.commands.outdentList(inputMethod));
                    if (node === 'taskList') pluginInjectionApi?.taskDecision?.actions.outdentTaskList(inputMethod)(editorView.state, editorView.dispatch);
                    break;
                }
        }
    };

});

parcelRegister("iNy03", function(module, exports) {
$parcel$export(module.exports, "Toolbar", () => $6ed76762085bfa03$export$4c260019440d418f);
/* Toolbar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $6Exgk = parcelRequire("6Exgk");

var $7g31l = parcelRequire("7g31l");
var $eCOhn = parcelRequire("eCOhn");

var $42J8o = parcelRequire("42J8o");
var $5tWs8 = parcelRequire("5tWs8");

var $2pk5j = parcelRequire("2pk5j");
var $9Sic1 = parcelRequire("9Sic1");

var $la331 = parcelRequire("la331");

var $5Xn4A = parcelRequire("5Xn4A");

var $hfYNh = parcelRequire("hfYNh");

var $kwwiE = parcelRequire("kwwiE");
function $6ed76762085bfa03$export$4c260019440d418f(props) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const indentButtonRef = (0, $eJOHy.useRef)(null);
    const outdentButtonRef = (0, $eJOHy.useRef)(null);
    const { disabled: disabled, isReducedSpacing: isReducedSpacing, bulletListActive: bulletListActive, bulletListDisabled: bulletListDisabled, orderedListActive: orderedListActive, orderedListDisabled: orderedListDisabled, showIndentationButtons: showIndentationButtons, indentDisabled: indentDisabled, outdentDisabled: outdentDisabled, onItemActivated: onItemActivated, pluginInjectionApi: pluginInjectionApi } = props;
    const labelUnorderedList = formatMessage((0, $eCOhn.messages).unorderedList);
    const labelOrderedList = formatMessage((0, $eCOhn.messages).orderedList);
    const labelListsFormat = formatMessage((0, $eCOhn.messages).listsFormat);
    const indentMessage = formatMessage((0, $7g31l.messages).indent);
    const outdentMessage = formatMessage((0, $7g31l.messages).outdent);
    const isIndentButtonFocused = document.activeElement === indentButtonRef.current;
    const isOutdentButtonFocused = document.activeElement === outdentButtonRef.current;
    const handleOnItemActivated = (buttonName)=>(event)=>onItemActivated({
                editorView: props.editorView,
                buttonName: buttonName
            });
    (0, $eJOHy.useEffect)(()=>{
        if (isIndentButtonFocused && indentDisabled && outdentButtonRef.current) outdentButtonRef.current.focus();
    }, [
        indentButtonRef,
        indentDisabled,
        isIndentButtonFocused
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isOutdentButtonFocused && outdentDisabled && indentButtonRef.current) indentButtonRef.current.focus();
    }, [
        outdentButtonRef,
        outdentDisabled,
        isOutdentButtonFocused
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $42J8o.ToolbarButtonGroup), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                role: "group",
                "aria-label": labelListsFormat,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9Sic1.default), {
                        buttonId: (0, $2pk5j.TOOLBAR_ACTION_SUBJECT_ID).BULLET_LIST,
                        testId: labelUnorderedList,
                        spacing: isReducedSpacing ? 'none' : 'default',
                        onClick: handleOnItemActivated('bullet_list'),
                        selected: bulletListActive,
                        "aria-pressed": bulletListActive,
                        "aria-label": (0, $6Exgk.tooltip)((0, $6Exgk.toggleBulletList), labelUnorderedList),
                        "aria-keyshortcuts": (0, $6Exgk.getAriaKeyshortcuts)((0, $6Exgk.toggleBulletList)),
                        disabled: bulletListDisabled || disabled,
                        title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6Exgk.ToolTipContent), {
                            description: labelUnorderedList,
                            keymap: (0, $6Exgk.toggleBulletList)
                        }),
                        iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($la331))), {
                            label: "",
                            color: "currentColor",
                            spacing: "spacious"
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9Sic1.default), {
                        buttonId: (0, $2pk5j.TOOLBAR_ACTION_SUBJECT_ID).ORDERED_LIST,
                        testId: labelOrderedList,
                        spacing: isReducedSpacing ? 'none' : 'default',
                        onClick: handleOnItemActivated('ordered_list'),
                        selected: orderedListActive,
                        "aria-pressed": orderedListActive,
                        "aria-label": (0, $6Exgk.tooltip)((0, $6Exgk.toggleOrderedList), labelOrderedList),
                        "aria-keyshortcuts": (0, $6Exgk.getAriaKeyshortcuts)((0, $6Exgk.toggleOrderedList)),
                        disabled: orderedListDisabled || disabled,
                        title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6Exgk.ToolTipContent), {
                            description: labelOrderedList,
                            keymap: (0, $6Exgk.toggleOrderedList)
                        }),
                        iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5Xn4A))), {
                            color: "currentColor",
                            spacing: "spacious",
                            label: ""
                        })
                    }),
                    showIndentationButtons && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9Sic1.default), {
                        buttonId: (0, $2pk5j.TOOLBAR_ACTION_SUBJECT_ID).OUTDENT,
                        testId: (0, $2pk5j.TOOLBAR_ACTION_SUBJECT_ID).OUTDENT,
                        ref: outdentButtonRef,
                        spacing: isReducedSpacing ? 'none' : 'default',
                        onClick: handleOnItemActivated('outdent'),
                        iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hfYNh))), {
                            color: "currentColor",
                            spacing: "spacious",
                            label: ""
                        }),
                        disabled: outdentDisabled || disabled,
                        "aria-label": (0, $6Exgk.tooltip)((0, $6Exgk.outdent), outdentMessage),
                        "aria-keyshortcuts": (0, $6Exgk.getAriaKeyshortcuts)((0, $6Exgk.outdent)),
                        title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6Exgk.ToolTipContent), {
                            description: outdentMessage,
                            keymap: (0, $6Exgk.outdent)
                        })
                    }),
                    showIndentationButtons && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9Sic1.default), {
                        buttonId: (0, $2pk5j.TOOLBAR_ACTION_SUBJECT_ID).INDENT,
                        testId: (0, $2pk5j.TOOLBAR_ACTION_SUBJECT_ID).INDENT,
                        ref: indentButtonRef,
                        spacing: isReducedSpacing ? 'none' : 'default',
                        onClick: handleOnItemActivated('indent'),
                        iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kwwiE))), {
                            color: "currentColor",
                            spacing: "spacious",
                            label: ""
                        }),
                        disabled: indentDisabled || disabled,
                        "aria-label": (0, $6Exgk.tooltip)((0, $6Exgk.indent), indentMessage),
                        "aria-keyshortcuts": (0, $6Exgk.getAriaKeyshortcuts)((0, $6Exgk.indent)),
                        title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6Exgk.ToolTipContent), {
                            description: indentMessage,
                            keymap: (0, $6Exgk.indent)
                        })
                    })
                ]
            }),
            !pluginInjectionApi?.primaryToolbar && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5tWs8.ToolbarSeparator), {})
        ]
    });
}

});
parcelRegister("42J8o", function(module, exports) {
$parcel$export(module.exports, "ToolbarButtonGroup", () => $da6847a4b350a30c$export$89cfa2b8585c6d03);
/* ButtonGroup.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");
const $da6847a4b350a30c$var$buttonGroupStyle = null;
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- This rule thinks this isn't a `css()` call due to the name mapping
const $da6847a4b350a30c$var$buttonGroupStyleUnbounded = null;
const $da6847a4b350a30c$var$buttonGroupStyleBeforeVisualRefresh = null;
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- This rule thinks this isn't a `css()` call due to the name mapping
const $da6847a4b350a30c$var$buttonGroupStyleBeforeVisualRefreshUnbounded = null;
function $da6847a4b350a30c$export$89cfa2b8585c6d03({ children: children }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            (0, $eGOwo.fg)('platform-visual-refresh-icons') ? "_zulp1b66 _1e0c116y _4cvr1h6o" : "_1e0c116y _4cvr1h6o",
            (0, $eGOwo.fg)('platform-visual-refresh-icons') ? "_11ko1txw _1p8dglyw _89rs1b66" : "_11ko1txw _1p8dglyw"
        ]),
        children: children
    });
}

});

parcelRegister("5tWs8", function(module, exports) {
$parcel$export(module.exports, "ToolbarSeparator", () => $70a58bbcefc43341$export$291e1a31e8ec7868);
/* Separator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $70a58bbcefc43341$var$separatorStyles = null;
function $70a58bbcefc43341$export$291e1a31e8ec7868() {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": "editor-toolbar-seperator",
        className: (0, $hcewu.default)([
            "_1e0c1o8l _1bsbt94y _4t3i1tcg _19pkze3t _otyrze3t _18u0u2gc _2hwxu2gc _uiztglyw _bfhk15ej"
        ])
    });
}

});

parcelRegister("2pk5j", function(module, exports) {
$parcel$export(module.exports, "TOOLBAR_ACTION_SUBJECT_ID", () => $690552fbaaa0f530$export$f90c25d407b3694a);
var $690552fbaaa0f530$export$f90c25d407b3694a = /*#__PURE__*/ function(TOOLBAR_ACTION_SUBJECT_ID) {
    TOOLBAR_ACTION_SUBJECT_ID["FIND_REPLACE"] = "findReplace";
    TOOLBAR_ACTION_SUBJECT_ID["EMOJI"] = "emoji";
    TOOLBAR_ACTION_SUBJECT_ID["ORDERED_LIST"] = "orderedList";
    TOOLBAR_ACTION_SUBJECT_ID["BULLET_LIST"] = "bulletList";
    TOOLBAR_ACTION_SUBJECT_ID["MEDIA"] = "media";
    TOOLBAR_ACTION_SUBJECT_ID["MENTION"] = "mention";
    TOOLBAR_ACTION_SUBJECT_ID["DECISION_LIST"] = "decisionList";
    TOOLBAR_ACTION_SUBJECT_ID["TASK_LIST"] = "taskList";
    TOOLBAR_ACTION_SUBJECT_ID["TEXT_COLOR"] = "color";
    TOOLBAR_ACTION_SUBJECT_ID["BACKGROUND_COLOR"] = "backgroundColor";
    TOOLBAR_ACTION_SUBJECT_ID["TEXT_FORMATTING_STRONG"] = "strong";
    TOOLBAR_ACTION_SUBJECT_ID["TEXT_FORMATTING_ITALIC"] = "italic";
    TOOLBAR_ACTION_SUBJECT_ID["TEXT_FORMATTING_UNDERLINE"] = "underline";
    TOOLBAR_ACTION_SUBJECT_ID["UNDO"] = "undo";
    TOOLBAR_ACTION_SUBJECT_ID["REDO"] = "redo";
    TOOLBAR_ACTION_SUBJECT_ID["INDENT"] = "indent";
    TOOLBAR_ACTION_SUBJECT_ID["OUTDENT"] = "outdent";
    TOOLBAR_ACTION_SUBJECT_ID["RECORD_VIDEO"] = "recordVideo";
    TOOLBAR_ACTION_SUBJECT_ID["AI"] = "atlassian-intelligence";
    return TOOLBAR_ACTION_SUBJECT_ID;
}({});

});

parcelRegister("9Sic1", function(module, exports) {
$parcel$export(module.exports, "default", () => $a056acddf837a0c9$export$2e2bcd8739ae039);
// If you make any change here, copy it to above file as well
// and notify about the change in #team-fc-editor-ai-dev channel.
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $bgewf = parcelRequire("bgewf");

var $k71qx = parcelRequire("k71qx");

var $bMFKb = parcelRequire("bMFKb");

var $6Exgk = parcelRequire("6Exgk");

var $e8vrw = parcelRequire("e8vrw");
function $a056acddf837a0c9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a056acddf837a0c9$var$buttonWrapper = {
    name: "15currb",
    styles: "display:flex;height:100%"
};
const $a056acddf837a0c9$var$ToolbarButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>{
    const { buttonId: buttonId, testId: testId, className: className = '', href: href, iconAfter: iconAfter, iconBefore: iconBefore, disabled: disabled, selected: selected, spacing: spacing, target: target, children: children, hideTooltip: hideTooltip, title: title, keymap: keymap, titlePosition: titlePosition = 'top', item: item, rel: rel, 'aria-label': ariaLabel, 'aria-haspopup': ariaHasPopup, 'aria-expanded': ariaExpanded, 'aria-pressed': ariaPressed, 'aria-keyshortcuts': ariaKeyShortcuts, 'aria-controls': ariaControls, 'data-ds--level': dataDsLevel, onClick: onClick, onKeyDown: onKeyDown, onItemClick: onItemClick, onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave } = props;
    const handleClick = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        if (disabled) return;
        if (buttonId) analyticsEvent.update((payload)=>({
                ...payload,
                action: (0, $bMFKb.ACTION).CLICKED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).TOOLBAR_BUTTON,
                actionSubjectId: buttonId,
                eventType: (0, $bMFKb.EVENT_TYPE).UI
            })).fire((0, $bgewf.FabricChannel).editor);
        if (onClick) onClick(event);
        if (item && onItemClick) onItemClick(item);
    }, [
        disabled,
        onClick,
        onItemClick,
        item,
        buttonId
    ]);
    const button = /*#__PURE__*/ (0, $1NIU8.jsx)((0, $e8vrw.default), {
        ref: ref,
        appearance: "subtle",
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        href: href,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isDisabled: disabled,
        isSelected: selected,
        onClick: handleClick,
        spacing: spacing || 'default',
        target: target,
        shouldFitContainer: true,
        "aria-expanded": ariaExpanded,
        "aria-controls": ariaControls,
        "aria-haspopup": ariaHasPopup,
        "aria-label": ariaLabel,
        "aria-pressed": ariaPressed,
        "aria-keyshortcuts": ariaKeyShortcuts,
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        "data-ds--level": dataDsLevel,
        rel: rel
    }, children);
    if (!title) return button;
    const tooltipContent = hideTooltip ? null : /*#__PURE__*/ (0, $1NIU8.jsx)((0, $6Exgk.ToolTipContent), {
        description: title,
        keymap: keymap
    });
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k71qx.default), {
        content: tooltipContent,
        hideTooltipOnClick: true,
        position: titlePosition
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $a056acddf837a0c9$var$buttonWrapper
    }, button));
});
var $a056acddf837a0c9$export$2e2bcd8739ae039 = $a056acddf837a0c9$var$ToolbarButton;

});
parcelRegister("e8vrw", function(module, exports) {
$parcel$export(module.exports, "default", () => $a504faf53112d556$export$2e2bcd8739ae039);
// If you make any change here, copy it to above file as well
//  and notify about the change in #team-fc-editor-ai-dev channel.

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");
var $a504faf53112d556$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
        ref: ref,
        ...props,
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO: (from codemod) Buttons with "component", "css" or "style" prop can't be automatically migrated with codemods. Please migrate it manually.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            alignItems: 'center'
        }
    });
});

});


parcelRegister("la331", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5db26519e9813775db7effa65e775e41>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f67ce562841fadae$var$_react = $f67ce562841fadae$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f67ce562841fadae$var$_listBulleted = $f67ce562841fadae$var$_interopRequireDefault((parcelRequire("hJIkn")));

var $f67ce562841fadae$var$_bulletList = $f67ce562841fadae$var$_interopRequireDefault((parcelRequire("hhyv8")));
function $f67ce562841fadae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ListBulletedIcon.
 * This component is ListBulletedIcon, with `UNSAFE_fallbackIcon` set to "EditorBulletListIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f67ce562841fadae$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $f67ce562841fadae$var$_react.default.createElement($f67ce562841fadae$var$_listBulleted.default, Object.assign({
        name: "ListBulletedIcon",
        LEGACY_fallbackIcon: $f67ce562841fadae$var$_bulletList.default
    }, props));
$f67ce562841fadae$var$ListBulletedIcon.displayName = 'ListBulletedIconMigration';
var $f67ce562841fadae$var$_default = module.exports.default = $f67ce562841fadae$var$ListBulletedIcon;

});
parcelRegister("hhyv8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c94ec967c0d41565$var$_react = $c94ec967c0d41565$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $c94ec967c0d41565$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c94ec967c0d41565$var$EditorBulletListIcon = (props)=>/*#__PURE__*/ $c94ec967c0d41565$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 8c0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1m5-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2m-5 5c0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1m5-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2m-5 5c0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1m5-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2"/></svg>`
    }, props));
$c94ec967c0d41565$var$EditorBulletListIcon.displayName = 'EditorBulletListIcon';
var $c94ec967c0d41565$var$_default = module.exports.default = $c94ec967c0d41565$var$EditorBulletListIcon;

});


parcelRegister("5Xn4A", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6037f83b84c7668cea5207d550175115>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $45645c3a368d7be4$var$_react = $45645c3a368d7be4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $45645c3a368d7be4$var$_listNumbered = $45645c3a368d7be4$var$_interopRequireDefault((parcelRequire("bVHJR")));

var $45645c3a368d7be4$var$_numberList = $45645c3a368d7be4$var$_interopRequireDefault((parcelRequire("hM9Fu")));
function $45645c3a368d7be4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ListNumberedIcon.
 * This component is ListNumberedIcon, with `UNSAFE_fallbackIcon` set to "EditorNumberListIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Numbered list in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $45645c3a368d7be4$var$ListNumberedIcon = (props)=>/*#__PURE__*/ $45645c3a368d7be4$var$_react.default.createElement($45645c3a368d7be4$var$_listNumbered.default, Object.assign({
        name: "ListNumberedIcon",
        LEGACY_fallbackIcon: $45645c3a368d7be4$var$_numberList.default
    }, props));
$45645c3a368d7be4$var$ListNumberedIcon.displayName = 'ListNumberedIconMigration';
var $45645c3a368d7be4$var$_default = module.exports.default = $45645c3a368d7be4$var$ListNumberedIcon;

});
parcelRegister("bVHJR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1f7654718483868ec656fda28b5f1426>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8af6f227bfca1069$var$_react = $8af6f227bfca1069$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $8af6f227bfca1069$var$_baseNew = $8af6f227bfca1069$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $8af6f227bfca1069$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListNumbered".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Numbered list in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8af6f227bfca1069$var$ListNumberedIcon = (props)=>/*#__PURE__*/ $8af6f227bfca1069$var$_react.default.createElement($8af6f227bfca1069$var$_baseNew.default, Object.assign({
        name: "ListNumberedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 5H6V3.5h10zm0 7.5H6V11h10zM.5 1h1.75a.75.75 0 0 1 .75.75V7H1.5V2.5h-1zM0 8.5h2.63C3.39 8.5 4 9.12 4 9.88v1.25c0 .76-.62 1.38-1.37 1.38H1.5v1H4V15H.75a.75.75 0 0 1-.75-.75v-1.87C0 11.62.62 11 1.38 11H2.5v-1H0z" clip-rule="evenodd"/>`
    }, props));
$8af6f227bfca1069$var$ListNumberedIcon.displayName = 'ListNumberedIcon';
var $8af6f227bfca1069$var$_default = module.exports.default = $8af6f227bfca1069$var$ListNumberedIcon;

});

parcelRegister("hM9Fu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cf0e6b4732826275$var$_react = $cf0e6b4732826275$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $cf0e6b4732826275$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cf0e6b4732826275$var$EditorNumberListIcon = (props)=>/*#__PURE__*/ $cf0e6b4732826275$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11 7h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2m0 4h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2m0 4h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2m-5 0h3v1H6zm0 2h3v1H6zm1-9H6V7h2v3H7zm-1 3h3v1.333h-.6V13H7.2v-.667H6zm0 2h3v1H6zm2 3h2v1H8z"/></svg>`
    }, props));
$cf0e6b4732826275$var$EditorNumberListIcon.displayName = 'EditorNumberListIcon';
var $cf0e6b4732826275$var$_default = module.exports.default = $cf0e6b4732826275$var$EditorNumberListIcon;

});


parcelRegister("hfYNh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f4ab52fe73f2788cd5bc16868806adf4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c902fecc1f2b7020$var$_react = $c902fecc1f2b7020$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c902fecc1f2b7020$var$_textIndentLeft = $c902fecc1f2b7020$var$_interopRequireDefault((parcelRequire("5xSIi")));

var $c902fecc1f2b7020$var$_outdent = $c902fecc1f2b7020$var$_interopRequireDefault((parcelRequire("8hxcF")));
function $c902fecc1f2b7020$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for TextIndentLeftIcon.
 * This component is TextIndentLeftIcon, with `UNSAFE_fallbackIcon` set to "EditorOutdentIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shifting the indent of text content left.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c902fecc1f2b7020$var$TextIndentLeftIcon = (props)=>/*#__PURE__*/ $c902fecc1f2b7020$var$_react.default.createElement($c902fecc1f2b7020$var$_textIndentLeft.default, Object.assign({
        name: "TextIndentLeftIcon",
        LEGACY_fallbackIcon: $c902fecc1f2b7020$var$_outdent.default
    }, props));
$c902fecc1f2b7020$var$TextIndentLeftIcon.displayName = 'TextIndentLeftIconMigration';
var $c902fecc1f2b7020$var$_default = module.exports.default = $c902fecc1f2b7020$var$TextIndentLeftIcon;

});
parcelRegister("5xSIi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ea2f9ccde642b201921aa68be6179ead>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $409a79c8986c3c78$var$_react = $409a79c8986c3c78$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $409a79c8986c3c78$var$_baseNew = $409a79c8986c3c78$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $409a79c8986c3c78$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextIndentLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shifting the indent of text content left.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $409a79c8986c3c78$var$TextIndentLeftIcon = (props)=>/*#__PURE__*/ $409a79c8986c3c78$var$_react.default.createElement($409a79c8986c3c78$var$_baseNew.default, Object.assign({
        name: "TextIndentLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zM2.81 8l2.22-2.22-1.06-1.06-2.75 2.75a.75.75 0 0 0 0 1.06l2.75 2.75 1.06-1.06zM15 6.667H8v-1.5h7zm0 4.166H8v-1.5h7zM15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$409a79c8986c3c78$var$TextIndentLeftIcon.displayName = 'TextIndentLeftIcon';
var $409a79c8986c3c78$var$_default = module.exports.default = $409a79c8986c3c78$var$TextIndentLeftIcon;

});

parcelRegister("8hxcF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6079aabe82c13609$var$_react = $6079aabe82c13609$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $6079aabe82c13609$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6079aabe82c13609$var$EditorOutdentIcon = (props)=>/*#__PURE__*/ $6079aabe82c13609$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M9 9V7l-3 3 3 3v-2h2.51a.49.49 0 0 0 .49-.505v-.99A.495.495 0 0 0 11.51 9zm4-1.495c0-.279.228-.505.491-.505h5.018a.49.49 0 0 1 .491.505v.99a.503.503 0 0 1-.491.505h-5.018A.49.49 0 0 1 13 8.495zm0 4c0-.279.228-.505.491-.505h5.018a.49.49 0 0 1 .491.505v.99a.503.503 0 0 1-.491.505h-5.018a.49.49 0 0 1-.491-.505zm-6 4c0-.279.229-.505.5-.505h11c.276 0 .5.214.5.505v.99a.506.506 0 0 1-.5.505h-11a.495.495 0 0 1-.5-.505z"/></svg>`
    }, props));
$6079aabe82c13609$var$EditorOutdentIcon.displayName = 'EditorOutdentIcon';
var $6079aabe82c13609$var$_default = module.exports.default = $6079aabe82c13609$var$EditorOutdentIcon;

});


parcelRegister("kwwiE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5b781ae7916da76ce23508b640931263>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef0fd9dfebea2b29$var$_react = $ef0fd9dfebea2b29$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $ef0fd9dfebea2b29$var$_textIndentRight = $ef0fd9dfebea2b29$var$_interopRequireDefault((parcelRequire("6hGSl")));

var $ef0fd9dfebea2b29$var$_indent = $ef0fd9dfebea2b29$var$_interopRequireDefault((parcelRequire("eiUei")));
function $ef0fd9dfebea2b29$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for TextIndentRightIcon.
 * This component is TextIndentRightIcon, with `UNSAFE_fallbackIcon` set to "EditorIndentIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shifting the indent of text content right.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ef0fd9dfebea2b29$var$TextIndentRightIcon = (props)=>/*#__PURE__*/ $ef0fd9dfebea2b29$var$_react.default.createElement($ef0fd9dfebea2b29$var$_textIndentRight.default, Object.assign({
        name: "TextIndentRightIcon",
        LEGACY_fallbackIcon: $ef0fd9dfebea2b29$var$_indent.default
    }, props));
$ef0fd9dfebea2b29$var$TextIndentRightIcon.displayName = 'TextIndentRightIconMigration';
var $ef0fd9dfebea2b29$var$_default = module.exports.default = $ef0fd9dfebea2b29$var$TextIndentRightIcon;

});
parcelRegister("6hGSl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ec56d53f6935139bc9b8387adf31e631>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $493596cfaf46fe7f$var$_react = $493596cfaf46fe7f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $493596cfaf46fe7f$var$_baseNew = $493596cfaf46fe7f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $493596cfaf46fe7f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextIndentRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shifting the indent of text content right.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $493596cfaf46fe7f$var$TextIndentRightIcon = (props)=>/*#__PURE__*/ $493596cfaf46fe7f$var$_react.default.createElement($493596cfaf46fe7f$var$_baseNew.default, Object.assign({
        name: "TextIndentRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zM2.03 4.72l2.75 2.75a.75.75 0 0 1 0 1.06l-2.75 2.75-1.06-1.06L3.19 8 .97 5.78zM15 6.667H8v-1.5h7zm0 4.166H8v-1.5h7zm0 2.667V15H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$493596cfaf46fe7f$var$TextIndentRightIcon.displayName = 'TextIndentRightIcon';
var $493596cfaf46fe7f$var$_default = module.exports.default = $493596cfaf46fe7f$var$TextIndentRightIcon;

});

parcelRegister("eiUei", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a69e5d224237277f$var$_react = $a69e5d224237277f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $a69e5d224237277f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a69e5d224237277f$var$EditorIndentIcon = (props)=>/*#__PURE__*/ $a69e5d224237277f$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M9 9H6.49a.495.495 0 0 0-.49.505v.99c0 .291.22.505.49.505H9v2l3-3-3-3zm4-1.495c0-.279.228-.505.491-.505h5.018a.49.49 0 0 1 .491.505v.99a.503.503 0 0 1-.491.505h-5.018A.49.49 0 0 1 13 8.495zm0 4c0-.279.228-.505.491-.505h5.018a.49.49 0 0 1 .491.505v.99a.503.503 0 0 1-.491.505h-5.018a.49.49 0 0 1-.491-.505zm-6 4c0-.279.229-.505.5-.505h11c.276 0 .5.214.5.505v.99a.506.506 0 0 1-.5.505h-11a.495.495 0 0 1-.5-.505z"/></svg>`
    }, props));
$a69e5d224237277f$var$EditorIndentIcon.displayName = 'EditorIndentIcon';
var $a69e5d224237277f$var$_default = module.exports.default = $a69e5d224237277f$var$EditorIndentIcon;

});



parcelRegister("45g6R", function(module, exports) {
$parcel$export(module.exports, "ToolbarDropdown", () => $03abfe5ef0cebea3$export$6dea40f2cdd197ea);
/* ToolbarDropdown.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $6Exgk = parcelRequire("6Exgk");

var $7g31l = parcelRequire("7g31l");
var $eCOhn = parcelRequire("eCOhn");

var $1l7GR = parcelRequire("1l7GR");
var $gqNL1 = parcelRequire("gqNL1");
var $5avVa = parcelRequire("5avVa");
var $j6zxR = parcelRequire("j6zxR");
var $5tWs8 = parcelRequire("5tWs8");

var $aPcNU = parcelRequire("aPcNU");
var $9Sic1 = parcelRequire("9Sic1");

var $hJIkn = parcelRequire("hJIkn");

var $bVHJR = parcelRequire("bVHJR");

var $la331 = parcelRequire("la331");

var $5xSIi = parcelRequire("5xSIi");

var $6hGSl = parcelRequire("6hGSl");

var $92xoS = parcelRequire("92xoS");

var $eRKkP = parcelRequire("eRKkP");
function $03abfe5ef0cebea3$export$6dea40f2cdd197ea(props) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { disabled: disabled, isReducedSpacing: isReducedSpacing, bulletListActive: bulletListActive, orderedListActive: orderedListActive, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, onItemActivated: onItemActivated, pluginInjectionApi: pluginInjectionApi } = props;
    const [isDropdownOpen, setIsDropdownOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(false);
    const [isOpenedByKeyboard, setOpenedByKeyboard] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(false);
    const labelLists = formatMessage((0, $eCOhn.messages).lists);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onOpenChange = (attrs)=>{
        setIsDropdownOpen(attrs.isDropdownOpen);
    };
    const handleTriggerClick = ()=>{
        onOpenChange({
            isDropdownOpen: !isDropdownOpen
        });
    };
    const handleOnKeyDown = (event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setIsDropdownOpen(!isDropdownOpen);
            setOpenedByKeyboard(true);
        }
    };
    const items = $03abfe5ef0cebea3$var$useItems(props);
    const handleOnItemActivated = ({ item: item, shouldCloseMenu: shouldCloseMenu = true })=>{
        setIsDropdownOpen(!shouldCloseMenu);
        return onItemActivated({
            editorView: props.editorView,
            buttonName: item.value.name
        });
    };
    const reducedSpacing = props.toolbarType === (0, $eRKkP.ToolbarType).FLOATING ? 'compact' : 'none';
    let activeListIcon = null;
    let isSelected = isDropdownOpen;
    if ((0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) activeListIcon = orderedListActive ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bVHJR))), {
        spacing: "spacious",
        label: ""
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hJIkn))), {
        spacing: "spacious",
        label: ""
    });
    else {
        activeListIcon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($la331))), {
            color: "currentColor",
            spacing: "spacious",
            label: labelLists
        });
        isSelected = bulletListActive || orderedListActive || isDropdownOpen;
    }
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $5avVa.ToolbarDropdownWrapper), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aPcNU.DropdownMenuWithKeyboardNavigation), {
                items: items,
                onItemActivated: handleOnItemActivated,
                mountTo: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement,
                isOpen: isDropdownOpen,
                onOpenChange: onOpenChange,
                fitHeight: 188,
                fitWidth: 175,
                shouldUseDefaultRole: true,
                shouldFocusFirstItem: ()=>{
                    if (isOpenedByKeyboard) setOpenedByKeyboard(false);
                    return isOpenedByKeyboard;
                },
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9Sic1.default), {
                    spacing: isReducedSpacing ? reducedSpacing : 'default',
                    selected: isSelected,
                    "aria-expanded": isDropdownOpen,
                    "aria-haspopup": true,
                    "aria-label": labelLists,
                    disabled: disabled,
                    onClick: handleTriggerClick,
                    onKeyDown: handleOnKeyDown,
                    title: labelLists,
                    iconBefore: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gqNL1.ToolbarDropdownTriggerWrapper), {
                        children: [
                            activeListIcon,
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j6zxR.ToolbarExpandIcon), {})
                        ]
                    })
                })
            }),
            !pluginInjectionApi?.primaryToolbar && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5tWs8.ToolbarSeparator), {})
        ]
    });
}
function $03abfe5ef0cebea3$var$useItems(props) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const labelUnorderedList = formatMessage((0, $eCOhn.messages).unorderedList);
    const labelOrderedList = formatMessage((0, $eCOhn.messages).orderedList);
    const items = [
        {
            key: 'unorderedList',
            content: labelUnorderedList,
            value: {
                name: 'bullet_list'
            },
            isDisabled: props.bulletListDisabled,
            isActive: Boolean(props.bulletListActive),
            elemAfter: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1l7GR.Shortcut), {
                children: (0, $6Exgk.tooltip)((0, $6Exgk.toggleBulletList))
            }),
            elemBefore: (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hJIkn))), {
                label: ""
            }) : undefined
        },
        {
            key: 'orderedList',
            content: labelOrderedList,
            value: {
                name: 'ordered_list'
            },
            isDisabled: props.orderedListDisabled,
            isActive: Boolean(props.orderedListActive),
            elemAfter: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1l7GR.Shortcut), {
                children: (0, $6Exgk.tooltip)((0, $6Exgk.toggleOrderedList))
            }),
            elemBefore: (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bVHJR))), {
                label: ""
            }) : undefined
        }
    ];
    if (props.showIndentationButtons) {
        const labelIndent = formatMessage((0, $7g31l.messages).indent);
        const labelOutdent = formatMessage((0, $7g31l.messages).outdent);
        items.push({
            key: 'outdent',
            content: labelOutdent,
            value: {
                name: 'outdent'
            },
            isDisabled: props.outdentDisabled,
            isActive: false,
            elemAfter: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1l7GR.Shortcut), {
                children: (0, $6Exgk.tooltip)((0, $6Exgk.outdent))
            }),
            elemBefore: (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5xSIi))), {
                label: ""
            }) : undefined
        }, {
            key: 'indent',
            content: labelIndent,
            value: {
                name: 'indent'
            },
            isDisabled: props.indentDisabled,
            isActive: false,
            elemAfter: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1l7GR.Shortcut), {
                children: (0, $6Exgk.tooltip)((0, $6Exgk.indent))
            }),
            elemBefore: (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6hGSl))), {
                label: ""
            }) : undefined
        });
    }
    return [
        {
            items: items
        }
    ];
}

});
parcelRegister("1l7GR", function(module, exports) {
$parcel$export(module.exports, "Shortcut", () => $e148b39e5e964f4f$export$59451aa6b6270879);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
parcelRequire("eJOHy");
const $e148b39e5e964f4f$var$shortcutStyle = null;
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- This rule thinks this isn't a `css()` call due to the name mapping
const $e148b39e5e964f4f$var$shortcutStyleUnbounded = null;
function $e148b39e5e964f4f$export$59451aa6b6270879({ children: children }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_2rkofajl _1wpzesu3 _ca0q1b66 _n3td1b66 _19bv1b66 _u5f31b66 _syaz1gjq _bfhkm7j4 _1ggkglyw",
            "_1wyb1qpa"
        ]),
        children: children
    });
}

});

parcelRegister("gqNL1", function(module, exports) {
$parcel$export(module.exports, "ToolbarDropdownTriggerWrapper", () => $cb4a65cb49af2dc6$export$bddd4c3563999c);
/* DropdownTriggerWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");
const $cb4a65cb49af2dc6$var$triggerWrapperStylesWithPadding = null;
const $cb4a65cb49af2dc6$var$triggerWrapperStyles = null;
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- This rule thinks this isn't a `css()` call due to the name mapping
const $cb4a65cb49af2dc6$var$triggerWrapperStylesUnbounded = null;
function $cb4a65cb49af2dc6$export$bddd4c3563999c({ children: children }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            (0, $eGOwo.fg)('platform-visual-refresh-icons') ? "_1e0c1txw _u5f3v77o" : "_1e0c1txw",
            "_1fvdglyw"
        ]),
        children: children
    });
}

});

parcelRegister("5avVa", function(module, exports) {
$parcel$export(module.exports, "ToolbarDropdownWrapper", () => $5ed78759879ef722$export$b4f55ae464964425);
/* DropdownWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
parcelRequire("eJOHy");
const $5ed78759879ef722$var$wrapperStyle = null;
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- This rule thinks this isn't a `css()` call due to the name mapping
const $5ed78759879ef722$var$wrapperStylesUnbounded = null;
function $5ed78759879ef722$export$b4f55ae464964425({ children: children }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _18u0idpf _1ul91wug",
            "_p7r11txw _1xdi1txw _1ylx1txw _1fvdglyw"
        ]),
        children: children
    });
}

});

parcelRegister("j6zxR", function(module, exports) {
$parcel$export(module.exports, "ToolbarExpandIcon", () => $1155eb6b34799894$export$12d8719856664799);
/* ExpandIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5lAAn = parcelRequire("5lAAn");
const $1155eb6b34799894$var$expandIconContainerStyle = null;
function $1155eb6b34799894$export$12d8719856664799() {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
            label: "",
            color: "currentColor",
            LEGACY_margin: "0 0 0 -8px",
            size: "small"
        })
    });
}

});

parcelRegister("aPcNU", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c31c18ac311bc9c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "DropdownMenuItem", () => $9c31c18ac311bc9c$export$ed97964d1871885d);
$parcel$export(module.exports, "DropdownMenuWithKeyboardNavigation", () => $9c31c18ac311bc9c$export$9e0cd5a62a7d99cf);
/* eslint-disable @repo/internal/react/no-class-components */ /**
                                                               * @jsxRuntime classic
                                                               * @jsx jsx
                                                               */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");

var $1PYwQ = parcelRequire("1PYwQ");
var $jUgeq = parcelRequire("jUgeq");
var $6YEko = parcelRequire("6YEko");

var $cbSL1 = parcelRequire("cbSL1");

var $92xoS = parcelRequire("92xoS");

var $k71qx = parcelRequire("k71qx");

var $4utXL = parcelRequire("4utXL");

var $baHgw = parcelRequire("baHgw");

var $dcudV = parcelRequire("dcudV");

var $jRVxI = parcelRequire("jRVxI");

var $avm98 = parcelRequire("avm98");

var $aYKcT = parcelRequire("aYKcT");

var $UpZp1 = parcelRequire("UpZp1");
function $9c31c18ac311bc9c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9c31c18ac311bc9c$var$wrapper = {
    name: "ul2689",
    styles: "& > div > div{display:flex;}"
};
const $9c31c18ac311bc9c$var$focusedMenuItemStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    boxShadow: `inset 0px 0px 0px 2px ${"var(--ds-border-focused, #388BFF)"}`,
    outline: 'none'
});
const $9c31c18ac311bc9c$var$buttonStyles = (isActive, submenuActive)=>{
    if (isActive) {
        if ((0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) /**
       * Hack for item to imitate old dropdown-menu selected styles
       */ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
        return /*#__PURE__*/ (0, $1NIU8.css)("position:relative;&::before{display:block;height:100%;width:2px;position:absolute;left:0;top:0;background:var(--ds-border-selected, transparent);content:'';}>span,>span:hover,>span:active{background:var(--ds-background-selected, #6c798f);color:var(--ds-text-selected, #0C66E4);}:focus>span[aria-disabled='false']{", $9c31c18ac311bc9c$var$focusedMenuItemStyle, ";}:focus-visible,:focus-visible>span[aria-disabled='false']{outline:none;}");
        /**
     * Hack for item to imitate old dropdown-menu selected styles
     */ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
        return /*#__PURE__*/ (0, $1NIU8.css)(">span,>span:hover,>span:active{background:var(--ds-background-selected, #6c798f);color:var(--ds-text-selected, #0C66E4);}:focus>span[aria-disabled='false']{", $9c31c18ac311bc9c$var$focusedMenuItemStyle, ";}:focus-visible,:focus-visible>span[aria-disabled='false']{outline:none;}");
    } else // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $1NIU8.css)(">span:hover[aria-disabled='false']{color:var(--ds-text, #172B4D);background-color:var(--ds-background-neutral-subtle-hovered, rgb(244, 245, 247));}", !submenuActive && `
					> span:active[aria-disabled='false'] {
						background-color: ${"var(--ds-background-neutral-subtle-pressed, rgb(179, 212, 255))"};
					}`, ">span[aria-disabled='true']{color:var(--ds-text-disabled, #091E424F);}:focus>span[aria-disabled='false']{", $9c31c18ac311bc9c$var$focusedMenuItemStyle, ";}:focus-visible,:focus-visible>span[aria-disabled='false']{outline:none;}"); // The default focus-visible style is removed to ensure consistency across browsers
};
const $9c31c18ac311bc9c$var$DropListWithOutsideClickTargetRef = (props)=>{
    const setOutsideClickTargetRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $dcudV.OutsideClickTargetRefContext));
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jRVxI.default), {
        onDroplistRef: setOutsideClickTargetRef,
        ...props
    });
};
const $9c31c18ac311bc9c$var$DropListWithOutsideListeners = (0, $dcudV.default)($9c31c18ac311bc9c$var$DropListWithOutsideClickTargetRef);
class $9c31c18ac311bc9c$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    renderDropdownMenu() {
        const { target: target, popupPlacement: popupPlacement } = this.state;
        const { items: items, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement, offset: offset, fitHeight: fitHeight, fitWidth: fitWidth, isOpen: isOpen, zIndex: zIndex, shouldUseDefaultRole: shouldUseDefaultRole, onItemActivated: onItemActivated, arrowKeyNavigationProviderOptions: arrowKeyNavigationProviderOptions, section: section, allowEnterDefaultBehavior: allowEnterDefaultBehavior, handleEscapeKeydown: handleEscapeKeydown } = this.props;
        // Note that this onSelection function can't be refactored to useMemo for
        // performance gains as it is being used as a dependency in a useEffect in
        // MenuArrowKeyNavigationProvider in order to check for re-renders to adjust
        // focus for accessibility. If this needs to be refactored in future refer
        // back to ED-16740 for context.
        const navigationProviderProps = arrowKeyNavigationProviderOptions.type === (0, $UpZp1.ArrowKeyNavigationType).COLOR ? arrowKeyNavigationProviderOptions : {
            ...arrowKeyNavigationProviderOptions,
            onSelection: (index)=>{
                let result = [];
                if (typeof onItemActivated === 'function') {
                    result = items.reduce((result, group)=>{
                        return result.concat(group.items);
                    }, result);
                    onItemActivated({
                        item: result[index],
                        shouldCloseMenu: false
                    });
                }
            }
        };
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $avm98.default), {
            target: isOpen ? target : undefined,
            mountTo: mountTo,
            boundariesElement: boundariesElement,
            scrollableElement: scrollableElement,
            onPlacementChanged: this.updatePopupPlacement,
            fitHeight: fitHeight,
            fitWidth: fitWidth,
            zIndex: zIndex || (0, $7yBx7.akEditorFloatingPanelZIndex),
            offset: offset
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $aYKcT.ArrowKeyNavigationProvider), {
            ...navigationProviderProps,
            handleClose: this.handleCloseAndFocus,
            closeOnTab: true
        }, /*#__PURE__*/ (0, $1NIU8.jsx)($9c31c18ac311bc9c$var$DropListWithOutsideListeners, {
            isOpen: true,
            position: popupPlacement.join(' '),
            shouldFitContainer: true,
            handleClickOutside: this.handleClose,
            handleEscapeKeydown: handleEscapeKeydown || this.handleCloseAndFocus,
            handleEnterKeydown: (e)=>{
                if (!allowEnterDefaultBehavior) e.preventDefault();
                e.stopPropagation();
            },
            targetRef: this.state.target
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            style: {
                height: 0,
                minWidth: fitWidth || 0
            }
        }), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            ref: this.popupRef
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jUgeq.default), {
            role: shouldUseDefaultRole ? 'group' : 'menu'
        }, items.map((group, index)=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, $6YEko.default), {
                hasSeparator: section?.hasSeparator && index > 0,
                title: section?.title,
                // Ignored via go/ees005
                // eslint-disable-next-line react/no-array-index-key
                key: index
            }, group.items.map((item)=>/*#__PURE__*/ (0, $1NIU8.jsx)($9c31c18ac311bc9c$export$ed97964d1871885d, {
                    key: item.key ?? String(item.content),
                    item: item,
                    onItemActivated: this.props.onItemActivated,
                    shouldUseDefaultRole: this.props.shouldUseDefaultRole,
                    onMouseEnter: this.props.onMouseEnter,
                    onMouseLeave: this.props.onMouseLeave
                })))))))));
    }
    render() {
        const { children: children, isOpen: isOpen } = this.props;
        return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $9c31c18ac311bc9c$var$wrapper
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            ref: this.handleRef
        }, children), isOpen ? this.renderDropdownMenu() : null);
    }
    componentDidUpdate(previousProps) {
        const { mountTo: mountTo, isOpen: isOpen } = this.props;
        const isOpenToggled = isOpen !== previousProps.isOpen;
        if (isOpen && isOpenToggled) {
            if (typeof this.props.shouldFocusFirstItem === 'function' && this.props.shouldFocusFirstItem()) {
                const keyboardEvent = new KeyboardEvent('keydown', {
                    key: 'ArrowDown',
                    bubbles: true
                });
                if (mountTo) {
                    mountTo.dispatchEvent(keyboardEvent);
                    return;
                }
                this.state.target?.dispatchEvent(keyboardEvent);
            }
        }
    }
    constructor(...args){
        super(...args), this.state = {
            popupPlacement: [
                'bottom',
                'left'
            ],
            selectionIndex: -1
        }, this.popupRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.handleRef = (target)=>{
            this.setState({
                target: target || undefined
            });
        }, this.updatePopupPlacement = (placement)=>{
            const { popupPlacement: previousPlacement } = this.state;
            if (placement[0] !== previousPlacement[0] || placement[1] !== previousPlacement[1]) this.setState({
                popupPlacement: placement
            });
        }, this.handleCloseAndFocus = (event)=>{
            this.state.target?.querySelector('button')?.focus();
            this.handleClose(event);
        }, this.handleClose = (event)=>{
            const { onOpenChange: onOpenChange } = this.props;
            if (onOpenChange) onOpenChange({
                isOpen: false,
                event: event
            });
        };
    }
}
const $9c31c18ac311bc9c$var$DropdownMenuItemCustomComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        ref: ref,
        ...rest,
        style: {
            // This forces the item container back to be `position: static`, the default value.
            // This ensures the custom nested menu for table color picker still works as now
            // menu items from @atlaskit/menu all have `position: relative` set for the selected borders.
            // The current implementation unfortunately is very brittle. Design System Team will
            // be prioritizing official support for accessible nested menus that we want you to move
            // to in the future.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'static'
        }
    }, children);
});
function $9c31c18ac311bc9c$export$ed97964d1871885d({ item: item, onItemActivated: onItemActivated, shouldUseDefaultRole: shouldUseDefaultRole, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }) {
    const [submenuActive, setSubmenuActive] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(false);
    // onClick and value.name are the action indicators in the handlers
    // If neither are present, don't wrap in an Item.
    if (!item.onClick && !(item.value && item.value.name)) return /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        key: String(item.content)
    }, item.content);
    const _handleSubmenuActive = (event)=>{
        setSubmenuActive(Boolean(event.target instanceof HTMLElement && event.target.closest(`.${(0, $4utXL.DropdownMenuSharedCssClassName).SUBMENU}`)));
    };
    const ariaLabel = item['aria-label'] === '' ? undefined : item['aria-label'] || String(item.content);
    const testId = item['data-testid'] || `dropdown-item__${item.content}`;
    // From time to time we don't want to have any tabIndex on item wrapper
    // especially when we pass any interactive element as a item.content
    const tabIndex = item.wrapperTabIndex === null ? undefined : item.wrapperTabIndex || -1;
    const dropListItem = /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: ()=>$9c31c18ac311bc9c$var$buttonStyles(item.isActive, submenuActive),
        role: (0, $cbSL1.expValEquals)('platform_editor_august_a11y', 'isEnabled', true) ? shouldUseDefaultRole ? undefined : 'menuitem' : undefined,
        tabIndex: tabIndex,
        "aria-disabled": item.isDisabled ? 'true' : 'false',
        "aria-expanded": (0, $cbSL1.expValEquals)('platform_editor_august_a11y', 'isEnabled', true) ? item['aria-expanded'] : undefined,
        onMouseDown: _handleSubmenuActive
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $1PYwQ.default), {
        item: item,
        key: item.key ?? String(item.content),
        testId: testId,
        role: shouldUseDefaultRole ? 'button' : (0, $cbSL1.expValEquals)('platform_editor_august_a11y', 'isEnabled', true) ? undefined : 'menuitem',
        iconBefore: item.elemBefore,
        iconAfter: item.elemAfter,
        isDisabled: item.isDisabled,
        onClick: ()=>onItemActivated && onItemActivated({
                item: item
            }),
        "aria-label": ariaLabel,
        "aria-pressed": shouldUseDefaultRole ? item.isActive : undefined,
        "aria-keyshortcuts": item['aria-keyshortcuts'],
        onMouseDown: (e)=>{
            e.preventDefault();
        },
        component: $9c31c18ac311bc9c$var$DropdownMenuItemCustomComponent,
        onMouseEnter: ()=>onMouseEnter && onMouseEnter({
                item: item
            }),
        onMouseLeave: ()=>onMouseLeave && onMouseLeave({
                item: item
            }),
        "aria-expanded": (0, $cbSL1.expValEquals)('platform_editor_august_a11y', 'isEnabled', true) ? undefined : item['aria-expanded']
    }, item.content));
    if (item.tooltipDescription) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k71qx.default), {
        key: item.key ?? String(item.content),
        content: item.tooltipDescription,
        position: item.tooltipPosition
    }, dropListItem);
    return dropListItem;
}
const $9c31c18ac311bc9c$export$9e0cd5a62a7d99cf = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
({ ...props })=>{
    const keyDownHandlerContext = (0, $eJOHy.useContext)((0, $baHgw.KeyDownHandlerContext));
    // This context is to handle the tab, Arrow Right/Left key events for dropdown.
    // Default context has the void callbacks for above key events
    return /*#__PURE__*/ (0, $1NIU8.jsx)($9c31c18ac311bc9c$export$2e2bcd8739ae039, {
        arrowKeyNavigationProviderOptions: {
            ...props.arrowKeyNavigationProviderOptions,
            keyDownHandlerContext: keyDownHandlerContext
        },
        ...props
    });
});

});
parcelRegister("4utXL", function(module, exports) {
$parcel$export(module.exports, "DropdownMenuSharedCssClassName", () => $ed9f3a9be6d32c7b$export$94c0f60c32e7bd13);
const $ed9f3a9be6d32c7b$export$15eb942addb87cf6 = 'pm-dropdown';
const $ed9f3a9be6d32c7b$export$94c0f60c32e7bd13 = {
    SUBMENU: `${$ed9f3a9be6d32c7b$export$15eb942addb87cf6}-submenu`
};

});

parcelRegister("baHgw", function(module, exports) {
$parcel$export(module.exports, "KeyDownHandlerContext", () => $3af9f0f89cac008b$export$5455406531e3792c);
$parcel$export(module.exports, "ToolbarArrowKeyNavigationProvider", () => $3af9f0f89cac008b$export$9837e395eba6f527);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $eGOwo = parcelRequire("eGOwo");

var $jiQ0H = parcelRequire("jiQ0H");

var $1LIK6 = parcelRequire("1LIK6");

var $jlbSP = parcelRequire("jlbSP");

function $3af9f0f89cac008b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3af9f0f89cac008b$export$5455406531e3792c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext({
    handleArrowLeft: ()=>{},
    handleArrowRight: ()=>{},
    handleTab: ()=>{}
});
const $3af9f0f89cac008b$var$centeredToolbarContainer = {
    name: "1iikq5b",
    styles: "display:flex;width:100%;align-items:center"
};
const $3af9f0f89cac008b$export$9837e395eba6f527 = ({ children: children, editorView: editorView, childComponentSelector: childComponentSelector, handleEscape: handleEscape, disableArrowKeyNavigation: disableArrowKeyNavigation, isShortcutToFocusToolbar: isShortcutToFocusToolbar, editorAppearance: editorAppearance, useStickyToolbar: useStickyToolbar, intl: intl })=>{
    const wrapperRef = (0, $eJOHy.useRef)(null);
    const selectedItemIndex = (0, $eJOHy.useRef)(0);
    const incrementIndex = (0, $eJOHy.useCallback)((list)=>{
        let index = 0;
        if (document.activeElement) {
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            index = list.indexOf(document.activeElement);
            index = (index + 1) % list.length;
        }
        selectedItemIndex.current = index;
    }, []);
    const decrementIndex = (0, $eJOHy.useCallback)((list)=>{
        let index = 0;
        if (document.activeElement) {
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            index = list.indexOf(document.activeElement);
            index = (list.length + index - 1) % list.length;
        }
        selectedItemIndex.current = index;
    }, []);
    const handleArrowRightMemoized = (0, $eJOHy.useCallback)(()=>{
        const filteredFocusableElements = $3af9f0f89cac008b$var$getFilteredFocusableElements(wrapperRef?.current);
        incrementIndex(filteredFocusableElements);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    }, [
        incrementIndex
    ]);
    const handleArrowLeftMemoized = (0, $eJOHy.useCallback)(()=>{
        const filteredFocusableElements = $3af9f0f89cac008b$var$getFilteredFocusableElements(wrapperRef?.current);
        decrementIndex(filteredFocusableElements);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    }, [
        decrementIndex
    ]);
    const handleTabMemoized = (0, $eJOHy.useCallback)(()=>{
        const filteredFocusableElements = $3af9f0f89cac008b$var$getFilteredFocusableElements(wrapperRef?.current);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    }, []);
    const handleTabLocal = ()=>{
        const filteredFocusableElements = $3af9f0f89cac008b$var$getFilteredFocusableElements(wrapperRef?.current);
        filteredFocusableElements.forEach((element)=>{
            element.setAttribute('tabindex', '-1');
        });
        filteredFocusableElements[selectedItemIndex.current].setAttribute('tabindex', '0');
    };
    const focusAndScrollToElement = (element, scrollToElement = true)=>{
        if (scrollToElement) element?.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest'
        });
        element.focus();
    };
    const submenuKeydownHandleContext = (0, $eJOHy.useMemo)(()=>({
            handleArrowLeft: handleArrowLeftMemoized,
            handleArrowRight: handleArrowRightMemoized,
            handleTab: handleTabMemoized
        }), [
        handleArrowLeftMemoized,
        handleArrowRightMemoized,
        handleTabMemoized
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!wrapperRef.current || disableArrowKeyNavigation) return;
        const { current: element } = wrapperRef;
        /**
     * To handle the key events on the list
     * @param event
     */ const handleKeyDown = (event)=>{
            // To trap the focus inside the horizontal toolbar for left and right arrow keys
            const targetElement = event.target;
            if (targetElement instanceof HTMLElement && !targetElement.closest(`${childComponentSelector}`)) return;
            if (targetElement instanceof HTMLElement && document.querySelector('[data-role="droplistContent"], [data-test-id="color-picker-menu"], [data-emoji-picker-container="true"]')?.contains(targetElement) || targetElement instanceof HTMLElement && document.querySelector('[data-test-id="color-picker-menu"]')?.contains(targetElement) || event.key === 'ArrowUp' || event.key === 'ArrowDown' || disableArrowKeyNavigation) return;
            const menuWrapper = document.querySelector('.menu-key-handler-wrapper');
            if (menuWrapper) // if menu wrapper exists, then a menu is open and arrow keys will be handled by MenuArrowKeyNavigationProvider
            return;
            const elementBrowser = wrapperRef?.current?.querySelector(`#${(0, $jiQ0H.ELEMENT_BROWSER_ID)}`);
            if (elementBrowser) // if element browser is open, then arrow keys will be handled by MenuArrowKeyNavigationProvider
            return;
            const filteredFocusableElements = $3af9f0f89cac008b$var$getFilteredFocusableElements(wrapperRef?.current);
            if (!filteredFocusableElements || filteredFocusableElements?.length === 0) return;
            // If the target element is the media picker then navigation is handled by the media picker
            if (targetElement instanceof HTMLElement && targetElement.closest(`[aria-label="${intl.formatMessage((0, $jlbSP.mediaInsertMessages).mediaPickerPopupAriaLabel)}"]`)) return;
            if (targetElement instanceof HTMLElement && !wrapperRef.current?.contains(targetElement)) selectedItemIndex.current = -1;
            else selectedItemIndex.current = targetElement instanceof HTMLElement && filteredFocusableElements.indexOf(targetElement) > -1 ? filteredFocusableElements.indexOf(targetElement) : selectedItemIndex.current;
            // do not scroll to focused element for sticky toolbar when navigating with arrows to avoid unnesessary scroll jump
            const allowScrollToElement = !(editorAppearance === 'comment' && !!useStickyToolbar);
            switch(event.key){
                case 'ArrowRight':
                    incrementIndex(filteredFocusableElements);
                    focusAndScrollToElement(filteredFocusableElements[selectedItemIndex.current], allowScrollToElement);
                    event.preventDefault();
                    break;
                case 'ArrowLeft':
                    decrementIndex(filteredFocusableElements);
                    focusAndScrollToElement(filteredFocusableElements[selectedItemIndex.current], allowScrollToElement);
                    event.preventDefault();
                    break;
                case 'Tab':
                    handleTabLocal();
                    break;
                case 'Escape':
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleEscape(event);
                    break;
                default:
            }
        };
        const globalKeyDownHandler = (event)=>{
            // To focus the first element in the toolbar
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            if (isShortcutToFocusToolbar(event)) {
                const filteredFocusableElements = $3af9f0f89cac008b$var$getFilteredFocusableElements(wrapperRef?.current);
                filteredFocusableElements[0]?.focus();
                // Button component from DS removes focus ring when :focus:not(:focus-visible) is true
                // Since here we programmatically focus the first button in the toolbar (as suppose to keyboard navigation), browser does not always force focus-visible to true
                // which is why the first button in the toolbar is not shown with focus ring
                // The workaround is add a new classname so we add back focus ring when the button is focused
                if (filteredFocusableElements[0]?.tagName === 'BUTTON') filteredFocusableElements[0].classList.add('first-floating-toolbar-button');
                filteredFocusableElements[0]?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
            }
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', handleKeyDown);
        const editorViewDom = editorView?.dom;
        if (isShortcutToFocusToolbar) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        editorViewDom?.addEventListener('keydown', globalKeyDownHandler);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', handleKeyDown);
            if (isShortcutToFocusToolbar) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            editorViewDom?.removeEventListener('keydown', globalKeyDownHandler);
        };
    }, [
        selectedItemIndex,
        wrapperRef,
        editorView,
        disableArrowKeyNavigation,
        handleEscape,
        childComponentSelector,
        incrementIndex,
        decrementIndex,
        isShortcutToFocusToolbar,
        editorAppearance,
        useStickyToolbar,
        intl
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: editorAppearance === 'comment' && $3af9f0f89cac008b$var$centeredToolbarContainer,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "custom-key-handler-wrapper",
        ref: wrapperRef,
        role: "toolbar",
        "aria-label": intl.formatMessage((0, $1LIK6.messages).toolbarLabel),
        "aria-controls": (0, $0f281244a829b337$export$b16ce0826b76e795)
    }, /*#__PURE__*/ (0, $1NIU8.jsx)($3af9f0f89cac008b$export$5455406531e3792c.Provider, {
        value: submenuKeydownHandleContext
    }, children));
};
function $3af9f0f89cac008b$var$getFocusableElements(rootNode) {
    if (!rootNode) return [];
    const focusableModalElements = rootNode.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, div[tabindex="-1"], div[tabindex="0"]') || [];
    return Array.from(focusableModalElements);
}
function $3af9f0f89cac008b$var$isElementOrAncestorHiddenOrDisabled(element, rootNode) {
    let currentElement = element;
    while(currentElement && currentElement !== rootNode && currentElement !== document.body){
        const style = window.getComputedStyle(currentElement);
        // Check if current element is hidden
        if (style.visibility === 'hidden' || style.display === 'none') return true;
        // Check if current element is disabled
        if (currentElement.hasAttribute('disabled') || currentElement.getAttribute('aria-disabled') === 'true' || currentElement.disabled === true) return true;
        // Move to parent element
        currentElement = currentElement.parentElement;
    }
    return false;
}
function $3af9f0f89cac008b$var$getFilteredFocusableElements(rootNode) {
    // The focusable elements from child components such as dropdown menus / popups are ignored
    return $3af9f0f89cac008b$var$getFocusableElements(rootNode).filter((elm)=>{
        const style = window.getComputedStyle(elm);
        // ignore invisible element to avoid losing focus
        const isVisible = style.visibility !== 'hidden' && style.display !== 'none';
        // Check if element or any ancestor is hidden or disabled
        const isHiddenOrDisabled = $3af9f0f89cac008b$var$isElementOrAncestorHiddenOrDisabled(elm, rootNode);
        if ((0, $eGOwo.fg)('platform_editor_toolbar_aifc_patch_7')) return !elm.closest('[data-role="droplistContent"]') && !elm.closest('[data-emoji-picker-container="true"]') && !elm.closest('[data-test-id="color-picker-menu"]') && !elm.closest('.scroll-buttons') && !isHiddenOrDisabled;
        return !elm.closest('[data-role="droplistContent"]') && !elm.closest('[data-emoji-picker-container="true"]') && !elm.closest('[data-test-id="color-picker-menu"]') && !elm.closest('.scroll-buttons') && isVisible;
    });
}

});
parcelRegister("jiQ0H", function(module, exports) {
$parcel$export(module.exports, "GRID_SIZE", () => $238f781d7af120a7$export$bc90872e265d166e);
$parcel$export(module.exports, "DEVICE_BREAKPOINT_NUMBERS", () => $238f781d7af120a7$export$1f1798e92fa75806);
$parcel$export(module.exports, "FLEX_ITEMS_CONTAINER_BREAKPOINT_NUMBERS", () => $238f781d7af120a7$export$69bde1b03e8b5224);
$parcel$export(module.exports, "SIDEBAR_WIDTH", () => $238f781d7af120a7$export$780035d9fe48eb32);
$parcel$export(module.exports, "SIDEBAR_HEADING_WRAPPER_HEIGHT", () => $238f781d7af120a7$export$95b62a1773aa5ebe);
$parcel$export(module.exports, "INLINE_SIDEBAR_HEIGHT", () => $238f781d7af120a7$export$51a2d6b2c009fbfd);
$parcel$export(module.exports, "SEARCH_ITEM_HEIGHT_WIDTH", () => $238f781d7af120a7$export$df8bcac60101d466);
$parcel$export(module.exports, "SCROLLBAR_WIDTH", () => $238f781d7af120a7$export$9a6bb2acef5e644a);
$parcel$export(module.exports, "ELEMENT_LIST_PADDING", () => $238f781d7af120a7$export$3b8e93b2c0f295b0);
$parcel$export(module.exports, "ELEMENT_ITEM_HEIGHT", () => $238f781d7af120a7$export$6d221f35db1b75aa);
$parcel$export(module.exports, "ELEMENT_ITEM_PADDING", () => $238f781d7af120a7$export$ab53450bc5fd5b7d);
$parcel$export(module.exports, "ELEMENT_BROWSER_ID", () => $238f781d7af120a7$export$6ee360fa4b93ee8e);
$parcel$export(module.exports, "ELEMENT_BROWSER_LIST_ID", () => $238f781d7af120a7$export$f5c254b5428bf7c6);
const $238f781d7af120a7$export$bc90872e265d166e = 8;
const $238f781d7af120a7$export$1f1798e92fa75806 = {
    small: $238f781d7af120a7$export$bc90872e265d166e * 40,
    medium: $238f781d7af120a7$export$bc90872e265d166e * 75,
    large: $238f781d7af120a7$export$bc90872e265d166e * 128
};
const $238f781d7af120a7$export$69bde1b03e8b5224 = {
    small: $238f781d7af120a7$export$bc90872e265d166e * 50,
    medium: $238f781d7af120a7$export$1f1798e92fa75806.medium,
    large: $238f781d7af120a7$export$1f1798e92fa75806.large
};
const $238f781d7af120a7$export$780035d9fe48eb32 = `${$238f781d7af120a7$export$bc90872e265d166e * 25}px`;
const $238f781d7af120a7$export$95b62a1773aa5ebe = `${$238f781d7af120a7$export$bc90872e265d166e * 6}px`;
const $238f781d7af120a7$export$387950d54d372827 = '12px';
const $238f781d7af120a7$export$51a2d6b2c009fbfd = '54px';
const $238f781d7af120a7$export$df8bcac60101d466 = '20px';
const $238f781d7af120a7$export$9a6bb2acef5e644a = 15;
const $238f781d7af120a7$export$3b8e93b2c0f295b0 = 2;
const $238f781d7af120a7$export$6d221f35db1b75aa = 60;
const $238f781d7af120a7$export$ab53450bc5fd5b7d = 10;
const $238f781d7af120a7$export$6ee360fa4b93ee8e = 'editor-element-browser';
const $238f781d7af120a7$export$f5c254b5428bf7c6 = 'editor-element-browser-list';

});

const $0f281244a829b337$export$b16ce0826b76e795 = 'ak-editor-textarea';


parcelRegister("dcudV", function(module, exports) {
$parcel$export(module.exports, "OutsideClickTargetRefContext", () => $c3af1bbc3f53da0d$export$798d66d2e25c3c95);
$parcel$export(module.exports, "default", () => $c3af1bbc3f53da0d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $92xoS = parcelRequire("92xoS");

var $g9imq = parcelRequire("g9imq");
const $c3af1bbc3f53da0d$export$798d66d2e25c3c95 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(()=>Object);
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $c3af1bbc3f53da0d$var$WithOutsideClick extends (0, $eJOHy.PureComponent) {
    componentDidMount() {
        if (this.props.handleClickOutside) {
            const options = this.props.captureClick && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? {
                capture: true
            } : false;
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('click', this.handleClick, options);
        }
        if (this.props.handleEscapeKeydown) // Attached event to the menu so that 'ESC' events from the opened menu also will be handled.
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        (this.props.popupsMountPoint ? this.props.popupsMountPoint : this.props.editorRef?.current || this.props.targetRef || document)// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .addEventListener('keydown', this.handleKeydown, false);
    }
    componentWillUnmount() {
        if (this.props.handleClickOutside) {
            const options = this.props.captureClick && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? {
                capture: true
            } : false;
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('click', this.handleClick, options);
        }
        if (this.props.handleEscapeKeydown) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        (this.props.popupsMountPoint ? this.props.popupsMountPoint : this.props.editorRef?.current || this.props.targetRef || document)// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .removeEventListener('keydown', this.handleKeydown, false);
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.handleClick = (evt)=>{
            if (!this.props.isActiveComponent || !this.props.handleClickOutside) return;
            const domNode = this.props.outsideClickTargetRef.current?.deref();
            if (!domNode || evt.target instanceof Node && !domNode.contains(evt.target)) {
                this.props.handleClickOutside(evt);
                // When the menus are closed by clicking outside the focus is set on editor.
                if (!this.props.editorView?.hasFocus()) this.props.editorView?.focus();
            }
        }, this.handleKeydown = (evt)=>{
            if (!this.props.isActiveComponent) return;
            if (evt.code === 'Escape' && this.props.handleEscapeKeydown) {
                evt.preventDefault();
                evt.stopPropagation();
                this.props.handleEscapeKeydown(evt);
                // on 'Esc', Focus is handled in 'handleEscapeKeydown'.
                return false;
            } else if (evt.code === 'Enter' && this.props.handleEnterKeydown) this.props.handleEnterKeydown(evt);
            else if (evt.code === 'Tab' && this.props.handleEscapeKeydown && this.props.closeOnTab) // The menus should be closed when the tab is pressed as it takes the focus out of the menu
            this.props.handleEscapeKeydown(evt);
        };
    }
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $c3af1bbc3f53da0d$var$hasIsOpen(props) {
    return 'isOpen' in props;
}
function $c3af1bbc3f53da0d$export$2e2bcd8739ae039(Component) {
    return ({ handleClickOutside: handleClickOutside, handleEnterKeydown: handleEnterKeydown, handleEscapeKeydown: handleEscapeKeydown, closeOnTab: closeOnTab, captureClick: captureClick, ...props })=>{
        const isActiveProp = $c3af1bbc3f53da0d$var$hasIsOpen(props) ? props.isOpen : true;
        const [isActiveComponent, setActiveComponent] = (0, $eJOHy.useState)(false);
        const outsideClickTargetRef = (0, $eJOHy.useRef)(null);
        const setOutsideClickTargetRef = (0, $eJOHy.useCallback)((el)=>{
            outsideClickTargetRef.current = el && new WeakRef(el);
        }, [
            outsideClickTargetRef
        ]);
        (0, $eJOHy.useEffect)(()=>{
            requestAnimationFrame(()=>{
                setActiveComponent(isActiveProp);
            });
        }, [
            isActiveProp
        ]);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $g9imq.default).Consumer, {
            children: ({ editorView: editorView, popupsMountPoint: popupsMountPoint, editorRef: editorRef })=>/*#__PURE__*/ (0, $gt9Am.jsx)($c3af1bbc3f53da0d$export$798d66d2e25c3c95.Provider, {
                    value: setOutsideClickTargetRef,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)($c3af1bbc3f53da0d$var$WithOutsideClick, {
                        editorView: editorView,
                        editorRef: editorRef,
                        targetRef: props.targetRef,
                        outsideClickTargetRef: outsideClickTargetRef,
                        popupsMountPoint: popupsMountPoint,
                        isActiveComponent: isActiveComponent,
                        handleClickOutside: handleClickOutside,
                        handleEnterKeydown: handleEnterKeydown,
                        handleEscapeKeydown: handleEscapeKeydown,
                        closeOnTab: closeOnTab,
                        captureClick: captureClick,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                            ...props
                        })
                    })
                })
        });
    };
}

});

parcelRegister("jRVxI", function(module, exports) {
$parcel$export(module.exports, "default", () => $07f9a8a894fda9b5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $5fWw9 = parcelRequire("5fWw9");

var $dUaMU = parcelRequire("dUaMU");

var $4J0ad = parcelRequire("4J0ad");

var $eGOwo = parcelRequire("eGOwo");

var $bPL67 = parcelRequire("bPL67");
const $07f9a8a894fda9b5$var$packageName = "platform-pkg";
const $07f9a8a894fda9b5$var$packageVersion = "0.0.0-use.local";
const $07f9a8a894fda9b5$var$halfFocusRing = 1;
const $07f9a8a894fda9b5$var$dropOffset = '0, 8';
const $07f9a8a894fda9b5$var$fadeIn = (0, $1NIU8.keyframes)({
    '0%': {
        opacity: 0
    },
    '100%': {
        opacity: 1
    }
});
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $07f9a8a894fda9b5$var$DropList extends (0, $eJOHy.Component) {
    render() {
        const { children: children, isOpen: isOpen, position: position, trigger: trigger, onPositioned: onPositioned, testId: testId, id: id } = this.props;
        const layerContent = isOpen ? /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: this.menuWrapper,
            "data-role": "droplistContent",
            "data-testid": testId && `${testId}--content`,
            ref: this.handleContentRef,
            id: id,
            role: "presentation"
        }, children) : null;
        return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: [
                this.wrapperStyles,
                (0, $eGOwo.fg)('p2m-drop-down-motion') && this.motionStyles
            ],
            ref: this.handleDroplistRef
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $bPL67.default), {
            content: layerContent,
            offset: $07f9a8a894fda9b5$var$dropOffset,
            position: position,
            onPositioned: onPositioned
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: [
                this.triggerStyles,
                (0, $eGOwo.fg)('p2m-drop-down-motion') && this.motionStyles
            ],
            ref: this.handleTriggerRef
        }, trigger)));
    }
    constructor(...args){
        super(...args), this.wrapperStyles = /*#__PURE__*/ (0, $1NIU8.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: this.props.shouldFitContainer ? 'block' : 'inline-flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            flex: this.props.shouldFitContainer ? '1 1 auto' : undefined,
            transitionDuration: '0.2s',
            transition: 'box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)'
        }), this.triggerStyles = /*#__PURE__*/ (0, $1NIU8.css)({
            transitionDuration: '0.2s',
            transition: 'box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: this.props.shouldFitContainer ? 'block' : 'inline-flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxSizing: this.props.shouldFitContainer ? 'border-box' : undefined
        }), this.motionStyles = /*#__PURE__*/ (0, $1NIU8.css)({
            animationName: `${$07f9a8a894fda9b5$var$fadeIn}`,
            animationDuration: '360ms',
            animationTimingFunction: 'cubic-bezier(0.8, 0, 0, 1)'
        }), /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ this.menuWrapper = ()=>{
            return /*#__PURE__*/ (0, $1NIU8.css)({
                color: "var(--ds-text-subtle, #44546F)",
                backgroundColor: "var(--ds-surface-overlay, #FFFFFF)",
                borderRadius: "var(--ds-radius-small, 3px)",
                boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)",
                boxSizing: 'border-box',
                overflow: 'auto',
                padding: `${"var(--ds-space-050, 4px)"} 0`,
                maxHeight: '90vh'
            });
        }, /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ this.componentDidMount = ()=>{
            this.setContentWidth();
            // We use a captured event here to avoid a radio or checkbox dropdown item firing its
            // click event first, which would cause a re-render of the element and prevent DropList
            // from detecting the actual source of this original click event.
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('click', this.handleClickOutside, true);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('keydown', this.handleEsc);
        }, this.componentDidUpdate = ()=>{
            if (this.props.isOpen) this.setContentWidth();
        }, this.componentWillUnmount = ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('click', this.handleClickOutside, true);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('keydown', this.handleEsc);
        }, this.setContentWidth = ()=>{
            const { dropContentRef: dropContentRef, triggerRef: triggerRef } = this;
            const { shouldFitContainer: shouldFitContainer } = this.props;
            // We need to manually set the content width to match the trigger width
            if (shouldFitContainer && dropContentRef && triggerRef) dropContentRef.style.width = `${triggerRef.offsetWidth - $07f9a8a894fda9b5$var$halfFocusRing * 2}px`;
        }, this.handleEsc = (event)=>{
            if ((event.key === 'Escape' || event.key === 'Esc') && this.props.isOpen) this.close(event);
        }, this.handleClickOutside = (event)=>{
            if (this.props.isOpen) {
                if (event.target instanceof Node) {
                    // Rather than check for the target within the entire DropList, we specify the trigger/content.
                    // This aids with future effort in scroll-locking DropList when isMenuFixed is enabled; the scroll
                    // blanket which stretches to the viewport should not stop 'close' from being triggered.
                    const withinTrigger = this.triggerRef && this.triggerRef.contains(event.target);
                    const withinContent = this.dropContentRef && this.dropContentRef.contains(event.target);
                    if (!withinTrigger && !withinContent) this.close(event);
                }
            }
        }, this.close = (event)=>{
            if (this.props.onOpenChange) this.props.onOpenChange({
                isOpen: false,
                event: event
            });
        }, this.handleContentRef = (ref)=>{
            this.dropContentRef = ref;
            // If the dropdown has just been opened, we focus on the containing element so the
            // user can tab to the first dropdown item. We will only receive this ref if isOpen
            // is true or null, so no need to check for truthiness here.
            if (ref) ref.focus();
        }, this.handleDroplistRef = (ref)=>{
            this.props.onDroplistRef?.(ref);
        }, this.handleTriggerRef = (ref)=>{
            this.triggerRef = ref;
        };
    }
}
const $07f9a8a894fda9b5$var$createAndFireEventOnAtlaskit = (0, $5fWw9.default)('atlaskit');
var $07f9a8a894fda9b5$export$2e2bcd8739ae039 = (0, $dUaMU.default)({
    componentName: 'droplist',
    packageName: $07f9a8a894fda9b5$var$packageName,
    packageVersion: $07f9a8a894fda9b5$var$packageVersion
})((0, $4J0ad.default)({
    onOpenChange: $07f9a8a894fda9b5$var$createAndFireEventOnAtlaskit({
        action: 'toggled',
        actionSubject: 'droplist',
        attributes: {
            componentName: 'droplist',
            packageName: $07f9a8a894fda9b5$var$packageName,
            packageVersion: $07f9a8a894fda9b5$var$packageVersion
        }
    })
})($07f9a8a894fda9b5$var$DropList));

});
parcelRegister("bPL67", function(module, exports) {
$parcel$export(module.exports, "default", () => $28d4ef08a9ff10dc$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hUhgh = parcelRequire("hUhgh");

var $bRPNB = parcelRequire("bRPNB");

var $jIGfZ = parcelRequire("jIGfZ");
const $28d4ef08a9ff10dc$var$defaultState = {
    hasExtractedStyles: false,
    // We set these default offsets to prevent a flash of popper content in the wrong position
    // which can cause incorrect height calculations. Popper will calculate these values
    offsets: {
        popper: {
            left: -9999,
            top: -9999,
            position: null
        }
    },
    cssPosition: 'absolute',
    originalHeight: null,
    maxHeight: null
};
class $28d4ef08a9ff10dc$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        // working with extract-react-types
        this.defaultProps = {
            boundariesElement: 'viewport',
            children: null,
            content: null,
            offset: '0, 0',
            position: 'right middle',
            zIndex: 400,
            lockScroll: false,
            isAlwaysFixed: false,
            onPositioned: ()=>{}
        };
    }
    constructor(props){
        super(props), this.targetRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.contentRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.extractStyles = (state)=>{
            if (state) {
                const popperHeight = state.offsets.popper.height;
                const left = Math.round(state.offsets.popper.left);
                const top = Math.round(state.offsets.popper.top);
                const cssPosition = 'absolute';
                const originalHeight = this.state.originalHeight || popperHeight;
                const maxHeight = this.calculateMaxHeight(originalHeight, popperHeight, top, cssPosition);
                this.setState({
                    cssPosition: // position: fixed or absolute
                    cssPosition,
                    hasExtractedStyles: true,
                    transform: `translate3d(${left}px, ${top}px, 0px)`,
                    originalHeight: originalHeight,
                    maxHeight: maxHeight
                });
            }
        };
        this.state = $28d4ef08a9ff10dc$var$defaultState;
        this.extractStyles = (0, $bRPNB.default)(this.extractStyles.bind(this));
    }
    componentDidMount() {
        this.applyPopper(this.props);
    }
    componentDidUpdate(prevProps, prevState) {
        const { onPositioned: onPositioned } = this.props;
        const { hasExtractedStyles: hasExtractedStyles } = this.state;
        if (this.props !== prevProps) this.applyPopper(this.props);
        // This flag is set the first time the position is calculated from Popper and applied to the content
        if (!prevState.hasExtractedStyles && hasExtractedStyles && onPositioned) onPositioned();
    }
    componentWillUnmount() {
        // this.extractStyles.cancel();
        if (this.popper) this.popper.destroy();
    }
    /* Calculate the max height of the popper if it's height is greater than the viewport to prevent
	 * the bottom of the popper not being viewable.
	 * Only works if the popper uses viewport as the boundary and has a fixed position ancestor.
	 */ calculateMaxHeight(originalHeight, currentHeight, positionTop, cssPosition) {
        let DocumentElementClientHeight = 0;
        if (document.documentElement) DocumentElementClientHeight = document.documentElement.clientHeight;
        if (cssPosition !== 'fixed') return null;
        const viewportHeight = Math.max(DocumentElementClientHeight, window.innerHeight || 0);
        return viewportHeight < originalHeight && currentHeight + positionTop >= viewportHeight - 50 ? viewportHeight - 12 : null;
    }
    applyPopper(props) {
        if (!this.targetRef.current || !this.contentRef.current) return;
        if (this.popper) this.popper.destroy();
        // "new Popper(...)" operation is very expensive when called on virtual DOM.
        // This condition reduces the number of calls so we can run our tests faster
        // (time was reduced from 100s to 13s).
        if (!props.content) return;
        // we wrap our target in a div so that we can safely get a reference to it, but we pass the
        // actual target to popper
        const isAlwaysFixed = false;
        const actualTarget = this.targetRef.current.children[0];
        const popperOpts = {
            placement: (0, $jIGfZ.positionPropToPopperPosition)(props.position),
            onCreate: this.extractStyles,
            onUpdate: this.extractStyles,
            modifiers: {
                applyStyle: {
                    enabled: false
                },
                hide: {
                    enabled: false
                },
                offset: {
                    enabled: true,
                    offset: this.props.offset
                },
                flip: {
                    enabled: false,
                    flipVariations: true,
                    boundariesElement: 'viewport',
                    padding: 0
                },
                preventOverflow: {
                    enabled: false,
                    escapeWithReference: true
                }
            },
            positionFixed: isAlwaysFixed
        };
        if (actualTarget) this.popper = new (0, $hUhgh.default)(actualTarget, this.contentRef.current, popperOpts);
    }
    render() {
        const { transform: transform, hasExtractedStyles: hasExtractedStyles, maxHeight: maxHeight } = this.state;
        const opacity = hasExtractedStyles ? {} : {
            opacity: 0
        };
        return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    ref: this.targetRef,
                    children: this.props.children
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    ref: this.contentRef,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        top: 0,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        left: 0,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        position: 'absolute',
                        transform: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        transform,
                        maxHeight: maxHeight ? maxHeight : 'auto',
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        ...opacity
                    },
                    children: this.props.content
                })
            ]
        });
    }
}

});
parcelRegister("hUhgh", function(module, exports) {
$parcel$export(module.exports, "default", () => $d0950e6c3380f4ed$export$2e2bcd8739ae039);
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.15.0
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $d0950e6c3380f4ed$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var $d0950e6c3380f4ed$var$longerTimeoutBrowsers = [
    'Edge',
    'Trident',
    'Firefox'
];
var $d0950e6c3380f4ed$var$timeoutDuration = 0;
for(var $d0950e6c3380f4ed$var$i = 0; $d0950e6c3380f4ed$var$i < $d0950e6c3380f4ed$var$longerTimeoutBrowsers.length; $d0950e6c3380f4ed$var$i += 1)if ($d0950e6c3380f4ed$var$isBrowser && navigator.userAgent.indexOf($d0950e6c3380f4ed$var$longerTimeoutBrowsers[$d0950e6c3380f4ed$var$i]) >= 0) {
    $d0950e6c3380f4ed$var$timeoutDuration = 1;
    break;
}
function $d0950e6c3380f4ed$var$microtaskDebounce(fn) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        window.Promise.resolve().then(function() {
            called = false;
            fn();
        });
    };
}
function $d0950e6c3380f4ed$var$taskDebounce(fn) {
    var scheduled = false;
    return function() {
        if (!scheduled) {
            scheduled = true;
            setTimeout(function() {
                scheduled = false;
                fn();
            }, $d0950e6c3380f4ed$var$timeoutDuration);
        }
    };
}
var $d0950e6c3380f4ed$var$supportsMicroTasks = $d0950e6c3380f4ed$var$isBrowser && window.Promise;
/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/ var $d0950e6c3380f4ed$var$debounce = $d0950e6c3380f4ed$var$supportsMicroTasks ? $d0950e6c3380f4ed$var$microtaskDebounce : $d0950e6c3380f4ed$var$taskDebounce;
/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */ function $d0950e6c3380f4ed$var$isFunction(functionToCheck) {
    var getType = {};
    return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}
/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */ function $d0950e6c3380f4ed$var$getStyleComputedProperty(element, property) {
    if (element.nodeType !== 1) return [];
    // NOTE: 1 DOM access here
    var window1 = element.ownerDocument.defaultView;
    var css = window1.getComputedStyle(element, null);
    return property ? css[property] : css;
}
/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */ function $d0950e6c3380f4ed$var$getParentNode(element) {
    if (element.nodeName === 'HTML') return element;
    return element.parentNode || element.host;
}
/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */ function $d0950e6c3380f4ed$var$getScrollParent(element) {
    // Return body, `getScroll` will take care to get the correct `scrollTop` from it
    if (!element) return document.body;
    switch(element.nodeName){
        case 'HTML':
        case 'BODY':
            return element.ownerDocument.body;
        case '#document':
            return element.body;
    }
    // Firefox want us to check `-x` and `-y` variations as well
    var _getStyleComputedProp = $d0950e6c3380f4ed$var$getStyleComputedProperty(element), overflow = _getStyleComputedProp.overflow, overflowX = _getStyleComputedProp.overflowX, overflowY = _getStyleComputedProp.overflowY;
    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) return element;
    return $d0950e6c3380f4ed$var$getScrollParent($d0950e6c3380f4ed$var$getParentNode(element));
}
var $d0950e6c3380f4ed$var$isIE11 = $d0950e6c3380f4ed$var$isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var $d0950e6c3380f4ed$var$isIE10 = $d0950e6c3380f4ed$var$isBrowser && /MSIE 10/.test(navigator.userAgent);
/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */ function $d0950e6c3380f4ed$var$isIE(version) {
    if (version === 11) return $d0950e6c3380f4ed$var$isIE11;
    if (version === 10) return $d0950e6c3380f4ed$var$isIE10;
    return $d0950e6c3380f4ed$var$isIE11 || $d0950e6c3380f4ed$var$isIE10;
}
/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */ function $d0950e6c3380f4ed$var$getOffsetParent(element) {
    if (!element) return document.documentElement;
    var noOffsetParent = $d0950e6c3380f4ed$var$isIE(10) ? document.body : null;
    // NOTE: 1 DOM access here
    var offsetParent = element.offsetParent || null;
    // Skip hidden elements which don't have an offsetParent
    while(offsetParent === noOffsetParent && element.nextElementSibling)offsetParent = (element = element.nextElementSibling).offsetParent;
    var nodeName = offsetParent && offsetParent.nodeName;
    if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') return element ? element.ownerDocument.documentElement : document.documentElement;
    // .offsetParent will return the closest TH, TD or TABLE in case
    // no offsetParent is present, I hate this job...
    if ([
        'TH',
        'TD',
        'TABLE'
    ].indexOf(offsetParent.nodeName) !== -1 && $d0950e6c3380f4ed$var$getStyleComputedProperty(offsetParent, 'position') === 'static') return $d0950e6c3380f4ed$var$getOffsetParent(offsetParent);
    return offsetParent;
}
function $d0950e6c3380f4ed$var$isOffsetContainer(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY') return false;
    return nodeName === 'HTML' || $d0950e6c3380f4ed$var$getOffsetParent(element.firstElementChild) === element;
}
/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */ function $d0950e6c3380f4ed$var$getRoot(node) {
    if (node.parentNode !== null) return $d0950e6c3380f4ed$var$getRoot(node.parentNode);
    return node;
}
/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */ function $d0950e6c3380f4ed$var$findCommonOffsetParent(element1, element2) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) return document.documentElement;
    // Here we make sure to give as "start" the element that comes first in the DOM
    var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
    var start = order ? element1 : element2;
    var end = order ? element2 : element1;
    // Get common ancestor container
    var range = document.createRange();
    range.setStart(start, 0);
    range.setEnd(end, 0);
    var commonAncestorContainer = range.commonAncestorContainer;
    // Both nodes are inside #document
    if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
        if ($d0950e6c3380f4ed$var$isOffsetContainer(commonAncestorContainer)) return commonAncestorContainer;
        return $d0950e6c3380f4ed$var$getOffsetParent(commonAncestorContainer);
    }
    // one of the nodes is inside shadowDOM, find which one
    var element1root = $d0950e6c3380f4ed$var$getRoot(element1);
    if (element1root.host) return $d0950e6c3380f4ed$var$findCommonOffsetParent(element1root.host, element2);
    else return $d0950e6c3380f4ed$var$findCommonOffsetParent(element1, $d0950e6c3380f4ed$var$getRoot(element2).host);
}
/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */ function $d0950e6c3380f4ed$var$getScroll(element) {
    var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
    var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') {
        var html = element.ownerDocument.documentElement;
        var scrollingElement = element.ownerDocument.scrollingElement || html;
        return scrollingElement[upperSide];
    }
    return element[upperSide];
}
/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */ function $d0950e6c3380f4ed$var$includeScroll(rect, element) {
    var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var scrollTop = $d0950e6c3380f4ed$var$getScroll(element, 'top');
    var scrollLeft = $d0950e6c3380f4ed$var$getScroll(element, 'left');
    var modifier = subtract ? -1 : 1;
    rect.top += scrollTop * modifier;
    rect.bottom += scrollTop * modifier;
    rect.left += scrollLeft * modifier;
    rect.right += scrollLeft * modifier;
    return rect;
}
/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */ function $d0950e6c3380f4ed$var$getBordersSize(styles, axis) {
    var sideA = axis === 'x' ? 'Left' : 'Top';
    var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
    return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}
function $d0950e6c3380f4ed$var$getSize(axis, body, html, computedStyle) {
    return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], $d0950e6c3380f4ed$var$isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}
function $d0950e6c3380f4ed$var$getWindowSizes(document1) {
    var body = document1.body;
    var html = document1.documentElement;
    var computedStyle = $d0950e6c3380f4ed$var$isIE(10) && getComputedStyle(html);
    return {
        height: $d0950e6c3380f4ed$var$getSize('Height', body, html, computedStyle),
        width: $d0950e6c3380f4ed$var$getSize('Width', body, html, computedStyle)
    };
}
var $d0950e6c3380f4ed$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $d0950e6c3380f4ed$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $d0950e6c3380f4ed$var$defineProperty = function(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
};
var $d0950e6c3380f4ed$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */ function $d0950e6c3380f4ed$var$getClientRect(offsets) {
    return $d0950e6c3380f4ed$var$_extends({}, offsets, {
        right: offsets.left + offsets.width,
        bottom: offsets.top + offsets.height
    });
}
/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */ function $d0950e6c3380f4ed$var$getBoundingClientRect(element) {
    var rect = {};
    // IE10 10 FIX: Please, don't ask, the element isn't
    // considered in DOM in some circumstances...
    // This isn't reproducible in IE10 compatibility mode of IE11
    try {
        if ($d0950e6c3380f4ed$var$isIE(10)) {
            rect = element.getBoundingClientRect();
            var scrollTop = $d0950e6c3380f4ed$var$getScroll(element, 'top');
            var scrollLeft = $d0950e6c3380f4ed$var$getScroll(element, 'left');
            rect.top += scrollTop;
            rect.left += scrollLeft;
            rect.bottom += scrollTop;
            rect.right += scrollLeft;
        } else rect = element.getBoundingClientRect();
    } catch (e) {}
    var result = {
        left: rect.left,
        top: rect.top,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
    };
    // subtract scrollbar size from sizes
    var sizes = element.nodeName === 'HTML' ? $d0950e6c3380f4ed$var$getWindowSizes(element.ownerDocument) : {};
    var width = sizes.width || element.clientWidth || result.right - result.left;
    var height = sizes.height || element.clientHeight || result.bottom - result.top;
    var horizScrollbar = element.offsetWidth - width;
    var vertScrollbar = element.offsetHeight - height;
    // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
    // we make this check conditional for performance reasons
    if (horizScrollbar || vertScrollbar) {
        var styles = $d0950e6c3380f4ed$var$getStyleComputedProperty(element);
        horizScrollbar -= $d0950e6c3380f4ed$var$getBordersSize(styles, 'x');
        vertScrollbar -= $d0950e6c3380f4ed$var$getBordersSize(styles, 'y');
        result.width -= horizScrollbar;
        result.height -= vertScrollbar;
    }
    return $d0950e6c3380f4ed$var$getClientRect(result);
}
function $d0950e6c3380f4ed$var$getOffsetRectRelativeToArbitraryNode(children, parent) {
    var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isIE10 = $d0950e6c3380f4ed$var$isIE(10);
    var isHTML = parent.nodeName === 'HTML';
    var childrenRect = $d0950e6c3380f4ed$var$getBoundingClientRect(children);
    var parentRect = $d0950e6c3380f4ed$var$getBoundingClientRect(parent);
    var scrollParent = $d0950e6c3380f4ed$var$getScrollParent(children);
    var styles = $d0950e6c3380f4ed$var$getStyleComputedProperty(parent);
    var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
    var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);
    // In cases where the parent is fixed, we must ignore negative scroll in offset calc
    if (fixedPosition && isHTML) {
        parentRect.top = Math.max(parentRect.top, 0);
        parentRect.left = Math.max(parentRect.left, 0);
    }
    var offsets = $d0950e6c3380f4ed$var$getClientRect({
        top: childrenRect.top - parentRect.top - borderTopWidth,
        left: childrenRect.left - parentRect.left - borderLeftWidth,
        width: childrenRect.width,
        height: childrenRect.height
    });
    offsets.marginTop = 0;
    offsets.marginLeft = 0;
    // Subtract margins of documentElement in case it's being used as parent
    // we do this only on HTML because it's the only element that behaves
    // differently when margins are applied to it. The margins are included in
    // the box of the documentElement, in the other cases not.
    if (!isIE10 && isHTML) {
        var marginTop = parseFloat(styles.marginTop, 10);
        var marginLeft = parseFloat(styles.marginLeft, 10);
        offsets.top -= borderTopWidth - marginTop;
        offsets.bottom -= borderTopWidth - marginTop;
        offsets.left -= borderLeftWidth - marginLeft;
        offsets.right -= borderLeftWidth - marginLeft;
        // Attach marginTop and marginLeft because in some circumstances we may need them
        offsets.marginTop = marginTop;
        offsets.marginLeft = marginLeft;
    }
    if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') offsets = $d0950e6c3380f4ed$var$includeScroll(offsets, parent);
    return offsets;
}
function $d0950e6c3380f4ed$var$getViewportOffsetRectRelativeToArtbitraryNode(element) {
    var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var html = element.ownerDocument.documentElement;
    var relativeOffset = $d0950e6c3380f4ed$var$getOffsetRectRelativeToArbitraryNode(element, html);
    var width = Math.max(html.clientWidth, window.innerWidth || 0);
    var height = Math.max(html.clientHeight, window.innerHeight || 0);
    var scrollTop = !excludeScroll ? $d0950e6c3380f4ed$var$getScroll(html) : 0;
    var scrollLeft = !excludeScroll ? $d0950e6c3380f4ed$var$getScroll(html, 'left') : 0;
    var offset = {
        top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
        left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
        width: width,
        height: height
    };
    return $d0950e6c3380f4ed$var$getClientRect(offset);
}
/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */ function $d0950e6c3380f4ed$var$isFixed(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') return false;
    if ($d0950e6c3380f4ed$var$getStyleComputedProperty(element, 'position') === 'fixed') return true;
    var parentNode = $d0950e6c3380f4ed$var$getParentNode(element);
    if (!parentNode) return false;
    return $d0950e6c3380f4ed$var$isFixed(parentNode);
}
/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */ function $d0950e6c3380f4ed$var$getFixedPositionOffsetParent(element) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element || !element.parentElement || $d0950e6c3380f4ed$var$isIE()) return document.documentElement;
    var el = element.parentElement;
    while(el && $d0950e6c3380f4ed$var$getStyleComputedProperty(el, 'transform') === 'none')el = el.parentElement;
    return el || document.documentElement;
}
/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */ function $d0950e6c3380f4ed$var$getBoundaries(popper, reference, padding, boundariesElement) {
    var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    // NOTE: 1 DOM access here
    var boundaries = {
        top: 0,
        left: 0
    };
    var offsetParent = fixedPosition ? $d0950e6c3380f4ed$var$getFixedPositionOffsetParent(popper) : $d0950e6c3380f4ed$var$findCommonOffsetParent(popper, reference);
    // Handle viewport case
    if (boundariesElement === 'viewport') boundaries = $d0950e6c3380f4ed$var$getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
    else {
        // Handle other cases based on DOM element used as boundaries
        var boundariesNode = void 0;
        if (boundariesElement === 'scrollParent') {
            boundariesNode = $d0950e6c3380f4ed$var$getScrollParent($d0950e6c3380f4ed$var$getParentNode(reference));
            if (boundariesNode.nodeName === 'BODY') boundariesNode = popper.ownerDocument.documentElement;
        } else if (boundariesElement === 'window') boundariesNode = popper.ownerDocument.documentElement;
        else boundariesNode = boundariesElement;
        var offsets = $d0950e6c3380f4ed$var$getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
        // In case of HTML, we need a different computation
        if (boundariesNode.nodeName === 'HTML' && !$d0950e6c3380f4ed$var$isFixed(offsetParent)) {
            var _getWindowSizes = $d0950e6c3380f4ed$var$getWindowSizes(popper.ownerDocument), height = _getWindowSizes.height, width = _getWindowSizes.width;
            boundaries.top += offsets.top - offsets.marginTop;
            boundaries.bottom = height + offsets.top;
            boundaries.left += offsets.left - offsets.marginLeft;
            boundaries.right = width + offsets.left;
        } else // for all the other DOM elements, this one is good
        boundaries = offsets;
    }
    // Add paddings
    padding = padding || 0;
    var isPaddingNumber = typeof padding === 'number';
    boundaries.left += isPaddingNumber ? padding : padding.left || 0;
    boundaries.top += isPaddingNumber ? padding : padding.top || 0;
    boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
    boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
    return boundaries;
}
function $d0950e6c3380f4ed$var$getArea(_ref) {
    var width = _ref.width, height = _ref.height;
    return width * height;
}
/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $d0950e6c3380f4ed$var$computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
    var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    if (placement.indexOf('auto') === -1) return placement;
    var boundaries = $d0950e6c3380f4ed$var$getBoundaries(popper, reference, padding, boundariesElement);
    var rects = {
        top: {
            width: boundaries.width,
            height: refRect.top - boundaries.top
        },
        right: {
            width: boundaries.right - refRect.right,
            height: boundaries.height
        },
        bottom: {
            width: boundaries.width,
            height: boundaries.bottom - refRect.bottom
        },
        left: {
            width: refRect.left - boundaries.left,
            height: boundaries.height
        }
    };
    var sortedAreas = Object.keys(rects).map(function(key) {
        return $d0950e6c3380f4ed$var$_extends({
            key: key
        }, rects[key], {
            area: $d0950e6c3380f4ed$var$getArea(rects[key])
        });
    }).sort(function(a, b) {
        return b.area - a.area;
    });
    var filteredAreas = sortedAreas.filter(function(_ref2) {
        var width = _ref2.width, height = _ref2.height;
        return width >= popper.clientWidth && height >= popper.clientHeight;
    });
    var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
    var variation = placement.split('-')[1];
    return computedPlacement + (variation ? '-' + variation : '');
}
/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */ function $d0950e6c3380f4ed$var$getReferenceOffsets(state, popper, reference) {
    var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var commonOffsetParent = fixedPosition ? $d0950e6c3380f4ed$var$getFixedPositionOffsetParent(popper) : $d0950e6c3380f4ed$var$findCommonOffsetParent(popper, reference);
    return $d0950e6c3380f4ed$var$getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}
/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */ function $d0950e6c3380f4ed$var$getOuterSizes(element) {
    var window1 = element.ownerDocument.defaultView;
    var styles = window1.getComputedStyle(element);
    var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
    var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
    var result = {
        width: element.offsetWidth + y,
        height: element.offsetHeight + x
    };
    return result;
}
/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */ function $d0950e6c3380f4ed$var$getOppositePlacement(placement) {
    var hash = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}
/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */ function $d0950e6c3380f4ed$var$getPopperOffsets(popper, referenceOffsets, placement) {
    placement = placement.split('-')[0];
    // Get popper node sizes
    var popperRect = $d0950e6c3380f4ed$var$getOuterSizes(popper);
    // Add position, width and height to our offsets object
    var popperOffsets = {
        width: popperRect.width,
        height: popperRect.height
    };
    // depending by the popper placement we have to compute its offsets slightly differently
    var isHoriz = [
        'right',
        'left'
    ].indexOf(placement) !== -1;
    var mainSide = isHoriz ? 'top' : 'left';
    var secondarySide = isHoriz ? 'left' : 'top';
    var measurement = isHoriz ? 'height' : 'width';
    var secondaryMeasurement = !isHoriz ? 'height' : 'width';
    popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
    if (placement === secondarySide) popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
    else popperOffsets[secondarySide] = referenceOffsets[$d0950e6c3380f4ed$var$getOppositePlacement(secondarySide)];
    return popperOffsets;
}
/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $d0950e6c3380f4ed$var$find(arr, check) {
    // use native find if supported
    if (Array.prototype.find) return arr.find(check);
    // use `filter` to obtain the same behavior of `find`
    return arr.filter(check)[0];
}
/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $d0950e6c3380f4ed$var$findIndex(arr, prop, value) {
    // use native findIndex if supported
    if (Array.prototype.findIndex) return arr.findIndex(function(cur) {
        return cur[prop] === value;
    });
    // use `find` + `indexOf` if `findIndex` isn't supported
    var match = $d0950e6c3380f4ed$var$find(arr, function(obj) {
        return obj[prop] === value;
    });
    return arr.indexOf(match);
}
/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */ function $d0950e6c3380f4ed$var$runModifiers(modifiers, data, ends) {
    var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, $d0950e6c3380f4ed$var$findIndex(modifiers, 'name', ends));
    modifiersToRun.forEach(function(modifier) {
        if (modifier['function']) // eslint-disable-line dot-notation
        console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
        var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
        if (modifier.enabled && $d0950e6c3380f4ed$var$isFunction(fn)) {
            // Add properties to offsets to make them a complete clientRect object
            // we do this before each modifier to make sure the previous one doesn't
            // mess with these values
            data.offsets.popper = $d0950e6c3380f4ed$var$getClientRect(data.offsets.popper);
            data.offsets.reference = $d0950e6c3380f4ed$var$getClientRect(data.offsets.reference);
            data = fn(data, modifier);
        }
    });
    return data;
}
/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */ function $d0950e6c3380f4ed$var$update() {
    // if popper is destroyed, don't perform any further update
    if (this.state.isDestroyed) return;
    var data = {
        instance: this,
        styles: {},
        arrowStyles: {},
        attributes: {},
        flipped: false,
        offsets: {}
    };
    // compute reference element offsets
    data.offsets.reference = $d0950e6c3380f4ed$var$getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    data.placement = $d0950e6c3380f4ed$var$computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
    // store the computed placement inside `originalPlacement`
    data.originalPlacement = data.placement;
    data.positionFixed = this.options.positionFixed;
    // compute the popper offsets
    data.offsets.popper = $d0950e6c3380f4ed$var$getPopperOffsets(this.popper, data.offsets.reference, data.placement);
    data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
    // run the modifiers
    data = $d0950e6c3380f4ed$var$runModifiers(this.modifiers, data);
    // the first `update` will call `onCreate` callback
    // the other ones will call `onUpdate` callback
    if (!this.state.isCreated) {
        this.state.isCreated = true;
        this.options.onCreate(data);
    } else this.options.onUpdate(data);
}
/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */ function $d0950e6c3380f4ed$var$isModifierEnabled(modifiers, modifierName) {
    return modifiers.some(function(_ref) {
        var name = _ref.name, enabled = _ref.enabled;
        return enabled && name === modifierName;
    });
}
/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */ function $d0950e6c3380f4ed$var$getSupportedPropertyName(property) {
    var prefixes = [
        false,
        'ms',
        'Webkit',
        'Moz',
        'O'
    ];
    var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
    for(var i = 0; i < prefixes.length; i++){
        var prefix = prefixes[i];
        var toCheck = prefix ? '' + prefix + upperProp : property;
        if (typeof document.body.style[toCheck] !== 'undefined') return toCheck;
    }
    return null;
}
/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */ function $d0950e6c3380f4ed$var$destroy() {
    this.state.isDestroyed = true;
    // touch DOM only if `applyStyle` modifier is enabled
    if ($d0950e6c3380f4ed$var$isModifierEnabled(this.modifiers, 'applyStyle')) {
        this.popper.removeAttribute('x-placement');
        this.popper.style.position = '';
        this.popper.style.top = '';
        this.popper.style.left = '';
        this.popper.style.right = '';
        this.popper.style.bottom = '';
        this.popper.style.willChange = '';
        this.popper.style[$d0950e6c3380f4ed$var$getSupportedPropertyName('transform')] = '';
    }
    this.disableEventListeners();
    // remove the popper if user explicity asked for the deletion on destroy
    // do not use `remove` because IE11 doesn't support it
    if (this.options.removeOnDestroy) this.popper.parentNode.removeChild(this.popper);
    return this;
}
/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */ function $d0950e6c3380f4ed$var$getWindow(element) {
    var ownerDocument = element.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView : window;
}
function $d0950e6c3380f4ed$var$attachToScrollParents(scrollParent, event, callback, scrollParents) {
    var isBody = scrollParent.nodeName === 'BODY';
    var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
    target.addEventListener(event, callback, {
        passive: true
    });
    if (!isBody) $d0950e6c3380f4ed$var$attachToScrollParents($d0950e6c3380f4ed$var$getScrollParent(target.parentNode), event, callback, scrollParents);
    scrollParents.push(target);
}
/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $d0950e6c3380f4ed$var$setupEventListeners(reference, options, state, updateBound) {
    // Resize event listener on window
    state.updateBound = updateBound;
    $d0950e6c3380f4ed$var$getWindow(reference).addEventListener('resize', state.updateBound, {
        passive: true
    });
    // Scroll event listener on scroll parents
    var scrollElement = $d0950e6c3380f4ed$var$getScrollParent(reference);
    $d0950e6c3380f4ed$var$attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
    state.scrollElement = scrollElement;
    state.eventsEnabled = true;
    return state;
}
/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */ function $d0950e6c3380f4ed$var$enableEventListeners() {
    if (!this.state.eventsEnabled) this.state = $d0950e6c3380f4ed$var$setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
}
/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $d0950e6c3380f4ed$var$removeEventListeners(reference, state) {
    // Remove resize event listener on window
    $d0950e6c3380f4ed$var$getWindow(reference).removeEventListener('resize', state.updateBound);
    // Remove scroll event listener on scroll parents
    state.scrollParents.forEach(function(target) {
        target.removeEventListener('scroll', state.updateBound);
    });
    // Reset state
    state.updateBound = null;
    state.scrollParents = [];
    state.scrollElement = null;
    state.eventsEnabled = false;
    return state;
}
/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */ function $d0950e6c3380f4ed$var$disableEventListeners() {
    if (this.state.eventsEnabled) {
        cancelAnimationFrame(this.scheduleUpdate);
        this.state = $d0950e6c3380f4ed$var$removeEventListeners(this.reference, this.state);
    }
}
/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */ function $d0950e6c3380f4ed$var$isNumeric(n) {
    return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}
/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $d0950e6c3380f4ed$var$setStyles(element, styles) {
    Object.keys(styles).forEach(function(prop) {
        var unit = '';
        // add unit if the value is numeric and is one of the following
        if ([
            'width',
            'height',
            'top',
            'right',
            'bottom',
            'left'
        ].indexOf(prop) !== -1 && $d0950e6c3380f4ed$var$isNumeric(styles[prop])) unit = 'px';
        element.style[prop] = styles[prop] + unit;
    });
}
/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $d0950e6c3380f4ed$var$setAttributes(element, attributes) {
    Object.keys(attributes).forEach(function(prop) {
        var value = attributes[prop];
        if (value !== false) element.setAttribute(prop, attributes[prop]);
        else element.removeAttribute(prop);
    });
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */ function $d0950e6c3380f4ed$var$applyStyle(data) {
    // any property present in `data.styles` will be applied to the popper,
    // in this way we can make the 3rd party modifiers add custom styles to it
    // Be aware, modifiers could override the properties defined in the previous
    // lines of this modifier!
    $d0950e6c3380f4ed$var$setStyles(data.instance.popper, data.styles);
    // any property present in `data.attributes` will be applied to the popper,
    // they will be set as HTML attributes of the element
    $d0950e6c3380f4ed$var$setAttributes(data.instance.popper, data.attributes);
    // if arrowElement is defined and arrowStyles has some properties
    if (data.arrowElement && Object.keys(data.arrowStyles).length) $d0950e6c3380f4ed$var$setStyles(data.arrowElement, data.arrowStyles);
    return data;
}
/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */ function $d0950e6c3380f4ed$var$applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
    // compute reference element offsets
    var referenceOffsets = $d0950e6c3380f4ed$var$getReferenceOffsets(state, popper, reference, options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    var placement = $d0950e6c3380f4ed$var$computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
    popper.setAttribute('x-placement', placement);
    // Apply `position` to popper before anything else because
    // without the position applied we can't guarantee correct computations
    $d0950e6c3380f4ed$var$setStyles(popper, {
        position: options.positionFixed ? 'fixed' : 'absolute'
    });
    return options;
}
/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */ function $d0950e6c3380f4ed$var$getRoundedOffsets(data, shouldRound) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var round = Math.round, floor = Math.floor;
    var noRound = function noRound(v) {
        return v;
    };
    var referenceWidth = round(reference.width);
    var popperWidth = round(popper.width);
    var isVertical = [
        'left',
        'right'
    ].indexOf(data.placement) !== -1;
    var isVariation = data.placement.indexOf('-') !== -1;
    var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
    var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
    var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
    var verticalToInteger = !shouldRound ? noRound : round;
    return {
        left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
        top: verticalToInteger(popper.top),
        bottom: verticalToInteger(popper.bottom),
        right: horizontalToInteger(popper.right)
    };
}
var $d0950e6c3380f4ed$var$isFirefox = $d0950e6c3380f4ed$var$isBrowser && /Firefox/i.test(navigator.userAgent);
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $d0950e6c3380f4ed$var$computeStyle(data, options) {
    var x = options.x, y = options.y;
    var popper = data.offsets.popper;
    // Remove this legacy support in Popper.js v2
    var legacyGpuAccelerationOption = $d0950e6c3380f4ed$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'applyStyle';
    }).gpuAcceleration;
    if (legacyGpuAccelerationOption !== undefined) console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
    var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
    var offsetParent = $d0950e6c3380f4ed$var$getOffsetParent(data.instance.popper);
    var offsetParentRect = $d0950e6c3380f4ed$var$getBoundingClientRect(offsetParent);
    // Styles
    var styles = {
        position: popper.position
    };
    var offsets = $d0950e6c3380f4ed$var$getRoundedOffsets(data, window.devicePixelRatio < 2 || !$d0950e6c3380f4ed$var$isFirefox);
    var sideA = x === 'bottom' ? 'top' : 'bottom';
    var sideB = y === 'right' ? 'left' : 'right';
    // if gpuAcceleration is set to `true` and transform is supported,
    //  we use `translate3d` to apply the position to the popper we
    // automatically use the supported prefixed version if needed
    var prefixedProperty = $d0950e6c3380f4ed$var$getSupportedPropertyName('transform');
    // now, let's make a step back and look at this code closely (wtf?)
    // If the content of the popper grows once it's been positioned, it
    // may happen that the popper gets misplaced because of the new content
    // overflowing its reference element
    // To avoid this problem, we provide two options (x and y), which allow
    // the consumer to define the offset origin.
    // If we position a popper on top of a reference element, we can set
    // `x` to `top` to make the popper grow towards its top instead of
    // its bottom.
    var left = void 0, top = void 0;
    if (sideA === 'bottom') {
        // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
        // and not the bottom of the html element
        if (offsetParent.nodeName === 'HTML') top = -offsetParent.clientHeight + offsets.bottom;
        else top = -offsetParentRect.height + offsets.bottom;
    } else top = offsets.top;
    if (sideB === 'right') {
        if (offsetParent.nodeName === 'HTML') left = -offsetParent.clientWidth + offsets.right;
        else left = -offsetParentRect.width + offsets.right;
    } else left = offsets.left;
    if (gpuAcceleration && prefixedProperty) {
        styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
        styles[sideA] = 0;
        styles[sideB] = 0;
        styles.willChange = 'transform';
    } else {
        // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
        var invertTop = sideA === 'bottom' ? -1 : 1;
        var invertLeft = sideB === 'right' ? -1 : 1;
        styles[sideA] = top * invertTop;
        styles[sideB] = left * invertLeft;
        styles.willChange = sideA + ', ' + sideB;
    }
    // Attributes
    var attributes = {
        'x-placement': data.placement
    };
    // Update `data` attributes, styles and arrowStyles
    data.attributes = $d0950e6c3380f4ed$var$_extends({}, attributes, data.attributes);
    data.styles = $d0950e6c3380f4ed$var$_extends({}, styles, data.styles);
    data.arrowStyles = $d0950e6c3380f4ed$var$_extends({}, data.offsets.arrow, data.arrowStyles);
    return data;
}
/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */ function $d0950e6c3380f4ed$var$isModifierRequired(modifiers, requestingName, requestedName) {
    var requesting = $d0950e6c3380f4ed$var$find(modifiers, function(_ref) {
        var name = _ref.name;
        return name === requestingName;
    });
    var isRequired = !!requesting && modifiers.some(function(modifier) {
        return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
    });
    if (!isRequired) {
        var _requesting = '`' + requestingName + '`';
        var requested = '`' + requestedName + '`';
        console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
    }
    return isRequired;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $d0950e6c3380f4ed$var$arrow(data, options) {
    var _data$offsets$arrow;
    // arrow depends on keepTogether in order to work
    if (!$d0950e6c3380f4ed$var$isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) return data;
    var arrowElement = options.element;
    // if arrowElement is a string, suppose it's a CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = data.instance.popper.querySelector(arrowElement);
        // if arrowElement is not found, don't run the modifier
        if (!arrowElement) return data;
    } else // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
        console.warn('WARNING: `arrow.element` must be child of its popper element!');
        return data;
    }
    var placement = data.placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isVertical = [
        'left',
        'right'
    ].indexOf(placement) !== -1;
    var len = isVertical ? 'height' : 'width';
    var sideCapitalized = isVertical ? 'Top' : 'Left';
    var side = sideCapitalized.toLowerCase();
    var altSide = isVertical ? 'left' : 'top';
    var opSide = isVertical ? 'bottom' : 'right';
    var arrowElementSize = $d0950e6c3380f4ed$var$getOuterSizes(arrowElement)[len];
    //
    // extends keepTogether behavior making sure the popper and its
    // reference have enough pixels in conjunction
    //
    // top/left side
    if (reference[opSide] - arrowElementSize < popper[side]) data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
    // bottom/right side
    if (reference[side] + arrowElementSize > popper[opSide]) data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
    data.offsets.popper = $d0950e6c3380f4ed$var$getClientRect(data.offsets.popper);
    // compute center of the popper
    var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
    // Compute the sideValue using the updated popper offsets
    // take popper margin in account because we don't have this info available
    var css = $d0950e6c3380f4ed$var$getStyleComputedProperty(data.instance.popper);
    var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
    var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
    var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
    // prevent arrowElement from being placed not contiguously to its popper
    sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
    data.arrowElement = arrowElement;
    data.offsets.arrow = (_data$offsets$arrow = {}, $d0950e6c3380f4ed$var$defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), $d0950e6c3380f4ed$var$defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
    return data;
}
/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */ function $d0950e6c3380f4ed$var$getOppositeVariation(variation) {
    if (variation === 'end') return 'start';
    else if (variation === 'start') return 'end';
    return variation;
}
/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */ var $d0950e6c3380f4ed$var$placements = [
    'auto-start',
    'auto',
    'auto-end',
    'top-start',
    'top',
    'top-end',
    'right-start',
    'right',
    'right-end',
    'bottom-end',
    'bottom',
    'bottom-start',
    'left-end',
    'left',
    'left-start'
];
// Get rid of `auto` `auto-start` and `auto-end`
var $d0950e6c3380f4ed$var$validPlacements = $d0950e6c3380f4ed$var$placements.slice(3);
/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */ function $d0950e6c3380f4ed$var$clockwise(placement) {
    var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var index = $d0950e6c3380f4ed$var$validPlacements.indexOf(placement);
    var arr = $d0950e6c3380f4ed$var$validPlacements.slice(index + 1).concat($d0950e6c3380f4ed$var$validPlacements.slice(0, index));
    return counter ? arr.reverse() : arr;
}
var $d0950e6c3380f4ed$var$BEHAVIORS = {
    FLIP: 'flip',
    CLOCKWISE: 'clockwise',
    COUNTERCLOCKWISE: 'counterclockwise'
};
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $d0950e6c3380f4ed$var$flip(data, options) {
    // if `inner` modifier is enabled, we can't use the `flip` modifier
    if ($d0950e6c3380f4ed$var$isModifierEnabled(data.instance.modifiers, 'inner')) return data;
    if (data.flipped && data.placement === data.originalPlacement) // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
    var boundaries = $d0950e6c3380f4ed$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
    var placement = data.placement.split('-')[0];
    var placementOpposite = $d0950e6c3380f4ed$var$getOppositePlacement(placement);
    var variation = data.placement.split('-')[1] || '';
    var flipOrder = [];
    switch(options.behavior){
        case $d0950e6c3380f4ed$var$BEHAVIORS.FLIP:
            flipOrder = [
                placement,
                placementOpposite
            ];
            break;
        case $d0950e6c3380f4ed$var$BEHAVIORS.CLOCKWISE:
            flipOrder = $d0950e6c3380f4ed$var$clockwise(placement);
            break;
        case $d0950e6c3380f4ed$var$BEHAVIORS.COUNTERCLOCKWISE:
            flipOrder = $d0950e6c3380f4ed$var$clockwise(placement, true);
            break;
        default:
            flipOrder = options.behavior;
    }
    flipOrder.forEach(function(step, index) {
        if (placement !== step || flipOrder.length === index + 1) return data;
        placement = data.placement.split('-')[0];
        placementOpposite = $d0950e6c3380f4ed$var$getOppositePlacement(placement);
        var popperOffsets = data.offsets.popper;
        var refOffsets = data.offsets.reference;
        // using floor because the reference offsets may contain decimals we are not going to consider here
        var floor = Math.floor;
        var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
        var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
        var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
        var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
        var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
        var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
        // flip the variation if required
        var isVertical = [
            'top',
            'bottom'
        ].indexOf(placement) !== -1;
        // flips variation if reference element overflows boundaries
        var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
        // flips variation if popper content overflows boundaries
        var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
        var flippedVariation = flippedVariationByRef || flippedVariationByContent;
        if (overlapsRef || overflowsBoundaries || flippedVariation) {
            // this boolean to detect any flip loop
            data.flipped = true;
            if (overlapsRef || overflowsBoundaries) placement = flipOrder[index + 1];
            if (flippedVariation) variation = $d0950e6c3380f4ed$var$getOppositeVariation(variation);
            data.placement = placement + (variation ? '-' + variation : '');
            // this object contains `position`, we want to preserve it along with
            // any additional property we may add in the future
            data.offsets.popper = $d0950e6c3380f4ed$var$_extends({}, data.offsets.popper, $d0950e6c3380f4ed$var$getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
            data = $d0950e6c3380f4ed$var$runModifiers(data.instance.modifiers, data, 'flip');
        }
    });
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $d0950e6c3380f4ed$var$keepTogether(data) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var placement = data.placement.split('-')[0];
    var floor = Math.floor;
    var isVertical = [
        'top',
        'bottom'
    ].indexOf(placement) !== -1;
    var side = isVertical ? 'right' : 'bottom';
    var opSide = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';
    if (popper[side] < floor(reference[opSide])) data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
    if (popper[opSide] > floor(reference[side])) data.offsets.popper[opSide] = floor(reference[side]);
    return data;
}
/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */ function $d0950e6c3380f4ed$var$toValue(str, measurement, popperOffsets, referenceOffsets) {
    // separate value from unit
    var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
    var value = +split[1];
    var unit = split[2];
    // If it's not a number it's an operator, I guess
    if (!value) return str;
    if (unit.indexOf('%') === 0) {
        var element = void 0;
        switch(unit){
            case '%p':
                element = popperOffsets;
                break;
            case '%':
            case '%r':
            default:
                element = referenceOffsets;
        }
        var rect = $d0950e6c3380f4ed$var$getClientRect(element);
        return rect[measurement] / 100 * value;
    } else if (unit === 'vh' || unit === 'vw') {
        // if is a vh or vw, we calculate the size based on the viewport
        var size = void 0;
        if (unit === 'vh') size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        else size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        return size / 100 * value;
    } else // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
}
/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */ function $d0950e6c3380f4ed$var$parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
    var offsets = [
        0,
        0
    ];
    // Use height if placement is left or right and index is 0 otherwise use width
    // in this way the first offset will use an axis and the second one
    // will use the other one
    var useHeight = [
        'right',
        'left'
    ].indexOf(basePlacement) !== -1;
    // Split the offset string to obtain a list of values and operands
    // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
    var fragments = offset.split(/(\+|\-)/).map(function(frag) {
        return frag.trim();
    });
    // Detect if the offset string contains a pair of values or a single one
    // they could be separated by comma or space
    var divider = fragments.indexOf($d0950e6c3380f4ed$var$find(fragments, function(frag) {
        return frag.search(/,|\s/) !== -1;
    }));
    if (fragments[divider] && fragments[divider].indexOf(',') === -1) console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
    // If divider is found, we divide the list of values and operands to divide
    // them by ofset X and Y.
    var splitRegex = /\s*,\s*|\s+/;
    var ops = divider !== -1 ? [
        fragments.slice(0, divider).concat([
            fragments[divider].split(splitRegex)[0]
        ]),
        [
            fragments[divider].split(splitRegex)[1]
        ].concat(fragments.slice(divider + 1))
    ] : [
        fragments
    ];
    // Convert the values with units to absolute pixels to allow our computations
    ops = ops.map(function(op, index) {
        // Most of the units rely on the orientation of the popper
        var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
        var mergeWithPrevious = false;
        return op// This aggregates any `+` or `-` sign that aren't considered operators
        // e.g.: 10 + +5 => [10, +, +5]
        .reduce(function(a, b) {
            if (a[a.length - 1] === '' && [
                '+',
                '-'
            ].indexOf(b) !== -1) {
                a[a.length - 1] = b;
                mergeWithPrevious = true;
                return a;
            } else if (mergeWithPrevious) {
                a[a.length - 1] += b;
                mergeWithPrevious = false;
                return a;
            } else return a.concat(b);
        }, [])// Here we convert the string values into number values (in px)
        .map(function(str) {
            return $d0950e6c3380f4ed$var$toValue(str, measurement, popperOffsets, referenceOffsets);
        });
    });
    // Loop trough the offsets arrays and execute the operations
    ops.forEach(function(op, index) {
        op.forEach(function(frag, index2) {
            if ($d0950e6c3380f4ed$var$isNumeric(frag)) offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
        });
    });
    return offsets;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */ function $d0950e6c3380f4ed$var$offset(data, _ref) {
    var offset = _ref.offset;
    var placement = data.placement, _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var basePlacement = placement.split('-')[0];
    var offsets = void 0;
    if ($d0950e6c3380f4ed$var$isNumeric(+offset)) offsets = [
        +offset,
        0
    ];
    else offsets = $d0950e6c3380f4ed$var$parseOffset(offset, popper, reference, basePlacement);
    if (basePlacement === 'left') {
        popper.top += offsets[0];
        popper.left -= offsets[1];
    } else if (basePlacement === 'right') {
        popper.top += offsets[0];
        popper.left += offsets[1];
    } else if (basePlacement === 'top') {
        popper.left += offsets[0];
        popper.top -= offsets[1];
    } else if (basePlacement === 'bottom') {
        popper.left += offsets[0];
        popper.top += offsets[1];
    }
    data.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $d0950e6c3380f4ed$var$preventOverflow(data, options) {
    var boundariesElement = options.boundariesElement || $d0950e6c3380f4ed$var$getOffsetParent(data.instance.popper);
    // If offsetParent is the reference element, we really want to
    // go one step up and use the next offsetParent as reference to
    // avoid to make this modifier completely useless and look like broken
    if (data.instance.reference === boundariesElement) boundariesElement = $d0950e6c3380f4ed$var$getOffsetParent(boundariesElement);
    // NOTE: DOM access here
    // resets the popper's position so that the document size can be calculated excluding
    // the size of the popper element itself
    var transformProp = $d0950e6c3380f4ed$var$getSupportedPropertyName('transform');
    var popperStyles = data.instance.popper.style; // assignment to help minification
    var top = popperStyles.top, left = popperStyles.left, transform = popperStyles[transformProp];
    popperStyles.top = '';
    popperStyles.left = '';
    popperStyles[transformProp] = '';
    var boundaries = $d0950e6c3380f4ed$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
    // NOTE: DOM access here
    // restores the original style properties after the offsets have been computed
    popperStyles.top = top;
    popperStyles.left = left;
    popperStyles[transformProp] = transform;
    options.boundaries = boundaries;
    var order = options.priority;
    var popper = data.offsets.popper;
    var check = {
        primary: function primary(placement) {
            var value = popper[placement];
            if (popper[placement] < boundaries[placement] && !options.escapeWithReference) value = Math.max(popper[placement], boundaries[placement]);
            return $d0950e6c3380f4ed$var$defineProperty({}, placement, value);
        },
        secondary: function secondary(placement) {
            var mainSide = placement === 'right' ? 'left' : 'top';
            var value = popper[mainSide];
            if (popper[placement] > boundaries[placement] && !options.escapeWithReference) value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
            return $d0950e6c3380f4ed$var$defineProperty({}, mainSide, value);
        }
    };
    order.forEach(function(placement) {
        var side = [
            'left',
            'top'
        ].indexOf(placement) !== -1 ? 'primary' : 'secondary';
        popper = $d0950e6c3380f4ed$var$_extends({}, popper, check[side](placement));
    });
    data.offsets.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $d0950e6c3380f4ed$var$shift(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var shiftvariation = placement.split('-')[1];
    // if shift shiftvariation is specified, run the modifier
    if (shiftvariation) {
        var _data$offsets = data.offsets, reference = _data$offsets.reference, popper = _data$offsets.popper;
        var isVertical = [
            'bottom',
            'top'
        ].indexOf(basePlacement) !== -1;
        var side = isVertical ? 'left' : 'top';
        var measurement = isVertical ? 'width' : 'height';
        var shiftOffsets = {
            start: $d0950e6c3380f4ed$var$defineProperty({}, side, reference[side]),
            end: $d0950e6c3380f4ed$var$defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
        };
        data.offsets.popper = $d0950e6c3380f4ed$var$_extends({}, popper, shiftOffsets[shiftvariation]);
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $d0950e6c3380f4ed$var$hide(data) {
    if (!$d0950e6c3380f4ed$var$isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) return data;
    var refRect = data.offsets.reference;
    var bound = $d0950e6c3380f4ed$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'preventOverflow';
    }).boundaries;
    if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === true) return data;
        data.hide = true;
        data.attributes['x-out-of-boundaries'] = '';
    } else {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === false) return data;
        data.hide = false;
        data.attributes['x-out-of-boundaries'] = false;
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $d0950e6c3380f4ed$var$inner(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isHoriz = [
        'left',
        'right'
    ].indexOf(basePlacement) !== -1;
    var subtractLength = [
        'top',
        'left'
    ].indexOf(basePlacement) === -1;
    popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
    data.placement = $d0950e6c3380f4ed$var$getOppositePlacement(placement);
    data.offsets.popper = $d0950e6c3380f4ed$var$getClientRect(popper);
    return data;
}
/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */ /**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */ var $d0950e6c3380f4ed$var$modifiers = {
    /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */ shift: {
        /** @prop {number} order=100 - Index used to define the order of execution */ order: 100,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $d0950e6c3380f4ed$var$shift
    },
    /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */ offset: {
        /** @prop {number} order=200 - Index used to define the order of execution */ order: 200,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $d0950e6c3380f4ed$var$offset,
        /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */ offset: 0
    },
    /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */ preventOverflow: {
        /** @prop {number} order=300 - Index used to define the order of execution */ order: 300,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $d0950e6c3380f4ed$var$preventOverflow,
        /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */ priority: [
            'left',
            'right',
            'top',
            'bottom'
        ],
        /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */ boundariesElement: 'scrollParent'
    },
    /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */ keepTogether: {
        /** @prop {number} order=400 - Index used to define the order of execution */ order: 400,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $d0950e6c3380f4ed$var$keepTogether
    },
    /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */ arrow: {
        /** @prop {number} order=500 - Index used to define the order of execution */ order: 500,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $d0950e6c3380f4ed$var$arrow,
        /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */ element: '[x-arrow]'
    },
    /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */ flip: {
        /** @prop {number} order=600 - Index used to define the order of execution */ order: 600,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $d0950e6c3380f4ed$var$flip,
        /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */ behavior: 'flip',
        /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */ boundariesElement: 'viewport',
        /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariations: false,
        /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariationsByContent: false
    },
    /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */ inner: {
        /** @prop {number} order=700 - Index used to define the order of execution */ order: 700,
        /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */ enabled: false,
        /** @prop {ModifierFn} */ fn: $d0950e6c3380f4ed$var$inner
    },
    /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */ hide: {
        /** @prop {number} order=800 - Index used to define the order of execution */ order: 800,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $d0950e6c3380f4ed$var$hide
    },
    /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */ computeStyle: {
        /** @prop {number} order=850 - Index used to define the order of execution */ order: 850,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $d0950e6c3380f4ed$var$computeStyle,
        /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: true,
        /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */ x: 'bottom',
        /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */ y: 'right'
    },
    /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */ applyStyle: {
        /** @prop {number} order=900 - Index used to define the order of execution */ order: 900,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $d0950e6c3380f4ed$var$applyStyle,
        /** @prop {Function} */ onLoad: $d0950e6c3380f4ed$var$applyStyleOnLoad,
        /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: undefined
    }
};
/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */ /**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */ var $d0950e6c3380f4ed$var$Defaults = {
    /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */ placement: 'bottom',
    /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */ positionFixed: false,
    /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */ eventsEnabled: true,
    /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */ removeOnDestroy: false,
    /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */ onCreate: function onCreate() {},
    /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */ onUpdate: function onUpdate() {},
    /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */ modifiers: $d0950e6c3380f4ed$var$modifiers
};
/**
 * @callback onCreate
 * @param {dataObject} data
 */ /**
 * @callback onUpdate
 * @param {dataObject} data
 */ // Utils
// Methods
var $d0950e6c3380f4ed$var$Popper = function() {
    /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */ function Popper(reference, popper) {
        var _this = this;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $d0950e6c3380f4ed$var$classCallCheck(this, Popper);
        this.scheduleUpdate = function() {
            return requestAnimationFrame(_this.update);
        };
        // make update() debounced, so that it only runs at most once-per-tick
        this.update = $d0950e6c3380f4ed$var$debounce(this.update.bind(this));
        // with {} we create a new object with the options inside it
        this.options = $d0950e6c3380f4ed$var$_extends({}, Popper.Defaults, options);
        // init state
        this.state = {
            isDestroyed: false,
            isCreated: false,
            scrollParents: []
        };
        // get reference and popper elements (allow jQuery wrappers)
        this.reference = reference && reference.jquery ? reference[0] : reference;
        this.popper = popper && popper.jquery ? popper[0] : popper;
        // Deep merge modifiers options
        this.options.modifiers = {};
        Object.keys($d0950e6c3380f4ed$var$_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function(name) {
            _this.options.modifiers[name] = $d0950e6c3380f4ed$var$_extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
        });
        // Refactoring modifiers' list (Object => Array)
        this.modifiers = Object.keys(this.options.modifiers).map(function(name) {
            return $d0950e6c3380f4ed$var$_extends({
                name: name
            }, _this.options.modifiers[name]);
        })// sort the modifiers by order
        .sort(function(a, b) {
            return a.order - b.order;
        });
        // modifiers have the ability to execute arbitrary code when Popper.js get inited
        // such code is executed in the same order of its modifier
        // they could add new properties to their options configuration
        // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
        this.modifiers.forEach(function(modifierOptions) {
            if (modifierOptions.enabled && $d0950e6c3380f4ed$var$isFunction(modifierOptions.onLoad)) modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
        });
        // fire the first update to position the popper in the right place
        this.update();
        var eventsEnabled = this.options.eventsEnabled;
        if (eventsEnabled) // setup event listeners, they will take care of update the position in specific situations
        this.enableEventListeners();
        this.state.eventsEnabled = eventsEnabled;
    }
    // We can't use class properties because they don't get listed in the
    // class prototype and break stuff like Sinon stubs
    $d0950e6c3380f4ed$var$createClass(Popper, [
        {
            key: 'update',
            value: function update$$1() {
                return $d0950e6c3380f4ed$var$update.call(this);
            }
        },
        {
            key: 'destroy',
            value: function destroy$$1() {
                return $d0950e6c3380f4ed$var$destroy.call(this);
            }
        },
        {
            key: 'enableEventListeners',
            value: function enableEventListeners$$1() {
                return $d0950e6c3380f4ed$var$enableEventListeners.call(this);
            }
        },
        {
            key: 'disableEventListeners',
            value: function disableEventListeners$$1() {
                return $d0950e6c3380f4ed$var$disableEventListeners.call(this);
            }
        }
    ]);
    return Popper;
}();
/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */ $d0950e6c3380f4ed$var$Popper.Utils = (typeof window !== 'undefined' ? window : $parcel$global).PopperUtils;
$d0950e6c3380f4ed$var$Popper.placements = $d0950e6c3380f4ed$var$placements;
$d0950e6c3380f4ed$var$Popper.Defaults = $d0950e6c3380f4ed$var$Defaults;
var $d0950e6c3380f4ed$export$2e2bcd8739ae039 = $d0950e6c3380f4ed$var$Popper;

});

parcelRegister("jIGfZ", function(module, exports) {
$parcel$export(module.exports, "positionPropToPopperPosition", () => $74b597cb03f3a6fd$export$9e6a7c92c66a7cdd);
const $74b597cb03f3a6fd$var$positionMap = {
    'top left': {
        position: 'top-start',
        animation: 'top'
    },
    'top center': {
        position: 'top',
        animation: 'top'
    },
    'top right': {
        position: 'top-end',
        animation: 'top'
    },
    'right top': {
        position: 'right-start',
        animation: 'right'
    },
    'right middle': {
        position: 'right',
        animation: 'right'
    },
    'right bottom': {
        position: 'right-end',
        animation: 'right'
    },
    'bottom left': {
        position: 'bottom-start',
        animation: 'bottom'
    },
    'bottom center': {
        position: 'bottom',
        animation: 'bottom'
    },
    'bottom right': {
        position: 'bottom-end',
        animation: 'bottom'
    },
    'left top': {
        position: 'left-start',
        animation: 'left'
    },
    'left middle': {
        position: 'left',
        animation: 'left'
    },
    'left bottom': {
        position: 'left-end',
        animation: 'left'
    }
};
const $74b597cb03f3a6fd$export$f6c90e9517ee2ce0 = {
    values: [
        'top left',
        'top center',
        'top right',
        'right top',
        'right middle',
        'right bottom',
        'bottom left',
        'bottom center',
        'bottom right',
        'left top',
        'left middle',
        'left bottom'
    ],
    default: 'right middle'
};
function $74b597cb03f3a6fd$var$positionToPopper(position) {
    return position && $74b597cb03f3a6fd$var$positionMap[position] ? $74b597cb03f3a6fd$var$positionMap[position].position : null;
}
function $74b597cb03f3a6fd$export$9e6a7c92c66a7cdd(position) {
    return $74b597cb03f3a6fd$var$positionToPopper(position) || $74b597cb03f3a6fd$var$positionMap[$74b597cb03f3a6fd$export$f6c90e9517ee2ce0.default].position;
}

});



parcelRegister("avm98", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f5ad13b8318551c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5gCP6 = parcelRequire("5gCP6");

var $bRPNB = parcelRequire("bRPNB");

var $aQK2r = parcelRequire("aQK2r");

var $7yBx7 = parcelRequire("7yBx7");

var $eGOwo = parcelRequire("eGOwo");

var $9Letn = parcelRequire("9Letn");

var $dwnni = parcelRequire("dwnni");
class $1f5ad13b8318551c$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            offset: [
                0,
                0
            ],
            allowOutOfBound: false
        };
    }
    /**
	 * Calculates new popup position
	 */ calculatePosition(props, popup) {
        const { target: target, fitHeight: fitHeight, fitWidth: fitWidth, boundariesElement: boundariesElement, offset: offset, onPositionCalculated: onPositionCalculated, onPlacementChanged: onPlacementChanged, alignX: alignX, alignY: alignY, stick: stick, forcePlacement: forcePlacement, allowOutOfBounds: allowOutOfBounds, rect: rect, preventOverflow: preventOverflow, absoluteOffset: absoluteOffset } = props;
        if (!target || !popup) return {};
        const placement = (0, $dwnni.calculatePlacement)(target, boundariesElement || document.body, fitWidth, fitHeight, alignX, alignY, forcePlacement, preventOverflow);
        if (onPlacementChanged && this.placement.join('') !== placement.join('')) {
            onPlacementChanged(placement);
            this.placement = placement;
        }
        let position = (0, $dwnni.calculatePosition)({
            placement: placement,
            popup: popup,
            target: target,
            stick: stick,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            offset: offset,
            allowOutOfBounds: allowOutOfBounds,
            rect: rect,
            boundariesElement: (0, $eGOwo.fg)('platform_editor_link_popup_position_fix_aifc') ? boundariesElement || document.body : undefined
        });
        position = onPositionCalculated ? onPositionCalculated(position) : position;
        if (typeof position.top !== 'undefined' && absoluteOffset?.top) position.top = position.top + absoluteOffset.top;
        if (typeof position.bottom !== 'undefined' && absoluteOffset?.bottom) position.bottom = position.bottom + absoluteOffset.bottom;
        if (typeof position.right !== 'undefined' && absoluteOffset?.right) position.right = position.right + absoluteOffset.right;
        if (typeof position.left !== 'undefined' && absoluteOffset?.left) position.left = position.left + absoluteOffset.left;
        return {
            position: position,
            validPosition: (0, $dwnni.validatePosition)(target)
        };
    }
    updatePosition(props = this.props, state = this.state) {
        const { popup: popup } = state;
        const { position: position, validPosition: validPosition } = this.calculatePosition(props, popup);
        if (position && validPosition) (0, $aQK2r.flushSync)(()=>{
            this.setState({
                position: position,
                validPosition: validPosition
            });
        });
    }
    cannotSetPopup(popup, target, overflowScrollParent) {
        /**
		 * Check whether:
		 * 1. Popup's offset targets which means whether or not its possible to correctly position popup along with given target.
		 * 2. Popup is inside "overflow: scroll" container, but its offset parent isn't.
		 *
		 * Currently Popup isn't capable of position itself correctly in case 2,
		 * Add "position: relative" to "overflow: scroll" container or to some other FloatingPanel wrapper inside it.
		 */ return !target || document.body.contains(target) && popup.offsetParent && // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        !popup.offsetParent.contains(target) || overflowScrollParent && !overflowScrollParent.contains(popup.offsetParent);
    }
    /**
	 * Popup initialization.
	 * Checks whether it's possible to position popup along given target, and if it's not throws an error.
	 */ initPopup(popup) {
        if (this.popupRef.current && (0, $eGOwo.fg)('platform_editor_link_popup_position_fix_aifc')) this.resizeObserver?.unobserve(this.popupRef.current);
        this.popupRef.current = popup;
        const { target: target } = this.props;
        const overflowScrollParent = (0, $dwnni.findOverflowScrollParent)(popup);
        if (this.cannotSetPopup(popup, target, overflowScrollParent)) return;
        this.setState({
            popup: popup
        });
        /**
		 * Some plugins (like image) have async rendering of component in floating toolbar(which is popup).
		 * Now, floating toolbar position depends on it's size.
		 * Size of floating toolbar changes, when async component renders.
		 * There is currently, no way to re position floating toolbar or
		 *  better to not show floating toolbar till all the async component are ready to render.
		 * Also, it is not even Popup's responsibility to take care of it as popup's children are passed
		 *  as a prop.
		 * So, calling scheduledUpdatePosition to position popup on next request animation frame,
		 * which is currently working for most of the floating toolbar and other popups.
		 */ this.scheduledUpdatePosition(this.props);
        if (this.props.focusTrap) this.initFocusTrap();
        if (this.popupRef.current && (0, $eGOwo.fg)('platform_editor_link_popup_position_fix_aifc')) this.resizeObserver?.observe(this.popupRef.current);
    }
    /**
	 * Cancels the initialisation of the focus trap if it has not yet occured
	 * Deactivates the focus trap if it exists
	 */ destroyFocusTrap() {
        this.initFocusTrap.cancel();
        this.focusTrap?.deactivate();
    }
    /**
	 * Handle pausing, unpausing, and initialising (if not yet initialised) of the focus trap
	 */ handleChangedFocusTrapProp(prevProps) {
        if (prevProps.focusTrap !== this.props.focusTrap) {
            // If currently set to disable, then pause the trap if it exists
            if (!this.props.focusTrap) return this.focusTrap?.pause();
            // If set to enabled and trap already exists, unpause
            if (this.focusTrap) this.focusTrap.unpause();
            // Else initialise the focus trap
            return this.initFocusTrap();
        }
    }
    componentDidUpdate(prevProps) {
        this.handleChangedFocusTrapProp(prevProps);
        if (this.props !== prevProps) this.scheduledUpdatePosition(prevProps);
    }
    componentDidMount() {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('resize', this.onResize);
        const { stick: stick } = this.props;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.scrollParentElement = (0, $dwnni.findOverflowScrollParent)(this.props.target);
        if (this.scrollParentElement && this.resizeObserver) this.resizeObserver.observe(this.scrollParentElement);
        if (stick) this.scrollElement = this.scrollParentElement;
        else this.scrollElement = this.props.scrollableElement;
        if (this.scrollElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.scrollElement.addEventListener('scroll', this.onResize);
    }
    componentWillUnmount() {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('resize', this.onResize);
        if (this.scrollElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.scrollElement.removeEventListener('scroll', this.onResize);
        if ((0, $eGOwo.fg)('platform_editor_link_popup_position_fix_aifc')) this.resizeObserver?.disconnect();
        else if (this.scrollParentElement && this.resizeObserver) this.resizeObserver.unobserve(this.scrollParentElement);
        this.scheduledUpdatePosition.cancel();
        this.destroyFocusTrap();
        const { onUnmount: onUnmount } = this.props;
        if (onUnmount) onUnmount();
    }
    renderPopup() {
        const { position: position } = this.state;
        const { shouldRenderPopup: shouldRenderPopup } = this.props;
        if (shouldRenderPopup && !shouldRenderPopup(position || {})) return null;
        /**
		 * https://a11y.atlassian.net/browse/A11Y-9995
		 * We set aria-label to undefined if it's null, no more 'Popup' fallback.
		 * It is meaningless for screen readers and causes confusion.
		 */ const ariaLabel = (0, $eGOwo.fg)('editor_a11y_aria_label_removal_popup') ? this.props.ariaLabel ?? undefined : this.props.ariaLabel === null ? undefined : this.props.ariaLabel || 'Popup';
        const getRole = ()=>{
            // Provide a valid role only when aria-label is present to satisfy a11y rules, as when aria-label is present, role is required
            // use role = dialog as default role, as dialog role itself is not a parent role that requires specific children to function as some other ARIA roles(menu) do
            // if set default role to menu, tons of integration tests will fail as many of our popup usages do not have children that satisfy menu role requirements
            if (ariaLabel && (0, $eGOwo.fg)('platform_editor_a11y_add_role_to_popup')) return this.props.role || 'dialog';
            return undefined;
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            ref: this.handleRef,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                zIndex: this.props.zIndex || (0, $7yBx7.akEditorFloatingPanelZIndex),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...position,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...this.props.style
            },
            role: getRole(),
            "aria-label": ariaLabel,
            "data-testid": "popup-wrapper",
            // Indicates component is an editor pop. Required for focus handling in Message.tsx
            "data-editor-popup": true,
            children: this.props.children
        });
    }
    render() {
        const { target: target, mountTo: mountTo } = this.props;
        const { validPosition: validPosition } = this.state;
        if (!target || !validPosition) return null;
        if (mountTo) return /*#__PURE__*/ (0, $aQK2r.createPortal)(this.renderPopup(), mountTo);
        // Without mountTo property renders popup as is,
        // which means it will be cropped by "overflow: hidden" container.
        return this.renderPopup();
    }
    constructor(...args){
        super(...args), this.rafIds = new Set(), this.state = {
            validPosition: true
        }, this.popupRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.placement = [
            '',
            ''
        ], this.handleRef = (popup)=>{
            if (!popup) return;
            this.initPopup(popup);
        }, this.scheduledUpdatePosition = (0, $bRPNB.default)((props)=>{
            this.updatePosition(this.props);
        }), this.onResize = ()=>this.scheduledUpdatePosition(this.props), this.resizeObserver = window?.ResizeObserver ? new ResizeObserver(()=>{
            this.scheduledUpdatePosition(this.props);
        }) : undefined, /**
	 * Raf scheduled so that it also occurs after the initial update position
	 */ this.initFocusTrap = (0, $bRPNB.default)(()=>{
            const popup = this.popupRef.current;
            if (!popup) return;
            const defaultTrapConfig = {
                clickOutsideDeactivates: true,
                escapeDeactivates: true,
                initialFocus: popup,
                fallbackFocus: popup,
                returnFocusOnDeactivate: false
            };
            const trapConfig = typeof this.props.focusTrap === 'boolean' ? defaultTrapConfig : {
                ...defaultTrapConfig,
                ...this.props.focusTrap
            };
            this.focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($5gCP6)))(popup, (0, $9Letn.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true) && (0, $9Letn.expValEqualsNoExposure)('platform_editor_block_menu_keyboard_navigation', 'isEnabled', true) ? trapConfig : defaultTrapConfig);
            this.focusTrap.activate();
        });
    }
}

});
parcelRegister("dwnni", function(module, exports) {
$parcel$export(module.exports, "calculatePlacement", () => $5c938d1514d83d54$export$b81415a09b611cb);
$parcel$export(module.exports, "findOverflowScrollParent", () => $5c938d1514d83d54$export$69742dd9a26edd3e);
$parcel$export(module.exports, "calculatePosition", () => $5c938d1514d83d54$export$b3ceb0cbf1056d98);
$parcel$export(module.exports, "validatePosition", () => $5c938d1514d83d54$export$ab306cb155a0ca1b);
function $5c938d1514d83d54$export$540dbd453ede1ce3(elem) {
    return elem === document.body;
}
function $5c938d1514d83d54$export$ccbedd67ef6e9417(elem) {
    return elem && elem.nodeType === 3;
}
function $5c938d1514d83d54$export$ba5b1093dd832251(target, boundariesElement, fitHeight, alignY, forcePlacement, preventOverflow) {
    if (forcePlacement && alignY) return alignY;
    if (!fitHeight) return 'bottom';
    if ($5c938d1514d83d54$export$ccbedd67ef6e9417(target)) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    target = target.parentElement;
    const boundariesClientRect = boundariesElement.getBoundingClientRect();
    const { height: boundariesHeight } = boundariesClientRect;
    const boundariesTop = $5c938d1514d83d54$export$540dbd453ede1ce3(boundariesElement) ? 0 : boundariesClientRect.top;
    const { top: targetTop, height: targetHeight } = target.getBoundingClientRect();
    const spaceAbove = targetTop - (boundariesTop - boundariesElement.scrollTop);
    const spaceBelow = boundariesTop + boundariesHeight - (targetTop + targetHeight);
    // Force vertical placement to bottom if the space above doesn't accomodate the fitHeight
    if (preventOverflow) {
        if (spaceAbove <= fitHeight) return 'bottom';
    }
    if (spaceBelow >= fitHeight || spaceBelow >= spaceAbove) return 'bottom';
    return 'top';
}
function $5c938d1514d83d54$export$af26c34d66be95d6(target, boundariesElement, fitWidth, alignX, forcePlacement, preventOverflow) {
    // force placement unless preventOverflow is enabled
    if (forcePlacement && alignX && !preventOverflow) return alignX;
    if (!fitWidth) return alignX || 'left';
    if ($5c938d1514d83d54$export$ccbedd67ef6e9417(target)) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    target = target.parentElement;
    const { left: targetLeft, width: targetWidth } = target.getBoundingClientRect();
    const { left: boundariesLeft, width: boundariesWidth } = boundariesElement.getBoundingClientRect();
    const spaceLeft = targetLeft - boundariesLeft + targetWidth;
    const spaceRight = boundariesLeft + boundariesWidth - targetLeft;
    if (alignX && spaceLeft > fitWidth && spaceRight > fitWidth) return alignX;
    else if (spaceRight >= fitWidth || spaceRight >= spaceLeft && !alignX) return 'left';
    return 'right';
}
function $5c938d1514d83d54$export$b81415a09b611cb(target, boundariesElement, fitWidth, fitHeight, alignX, alignY, forcePlacement, preventOverflow) {
    return [
        $5c938d1514d83d54$export$ba5b1093dd832251(target, boundariesElement, fitHeight, alignY, forcePlacement, preventOverflow),
        $5c938d1514d83d54$export$af26c34d66be95d6(target, boundariesElement, fitWidth, alignX, forcePlacement, preventOverflow)
    ];
}
const $5c938d1514d83d54$var$calculateHorizontalPlacement = ({ placement: placement, targetLeft: targetLeft, targetRight: targetRight, targetWidth: targetWidth, isPopupParentBody: isPopupParentBody, popupOffsetParentLeft: popupOffsetParentLeft, popupOffsetParentRight: popupOffsetParentRight, popupOffsetParentScrollLeft: popupOffsetParentScrollLeft, popupOffsetParentClientWidth: popupOffsetParentClientWidth, popupClientWidth: popupClientWidth, offset: offset, allowOutOfBounds: allowOutOfBounds = false })=>{
    const position = {};
    if (placement === 'left') position.left = Math.ceil(targetLeft - popupOffsetParentLeft + (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0]);
    else if (placement === 'center') position.left = Math.ceil(targetLeft - popupOffsetParentLeft + (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0] + targetWidth / 2 - popupClientWidth / 2);
    else if (placement === 'end') {
        const left = Math.ceil(targetRight - popupOffsetParentLeft + (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0]);
        position.left = left;
    } else position.right = Math.ceil(popupOffsetParentRight - targetRight - (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0]);
    if (!allowOutOfBounds) {
        if (position.left !== undefined) position.left = $5c938d1514d83d54$var$getPopupXInsideParent(position.left, popupClientWidth, popupOffsetParentClientWidth);
        if (position.right !== undefined) position.right = $5c938d1514d83d54$var$getPopupXInsideParent(position.right, popupClientWidth, popupOffsetParentClientWidth);
    }
    return position;
};
const $5c938d1514d83d54$var$getPopupXInsideParent = (x, popupClientWidth, popupOffsetParentClientWidth)=>{
    // minimum distance the popup can be from the edge of its parent
    const minPopupMargin = 1;
    // prevent going too far right
    if (popupOffsetParentClientWidth < x + popupClientWidth) x = popupOffsetParentClientWidth - popupClientWidth - minPopupMargin;
    // prevent going too far left
    return Math.max(minPopupMargin, x);
};
const $5c938d1514d83d54$var$calculateVerticalStickBottom = ({ target: target, targetTop: targetTop, targetHeight: targetHeight, popup: popup, offset: offset, position: position, boundariesElement: boundariesElement })=>{
    const scrollParent = $5c938d1514d83d54$export$69742dd9a26edd3e(target) || boundariesElement;
    const newPos = {
        ...position
    };
    if (scrollParent) {
        const topOffsetTop = targetTop - scrollParent.getBoundingClientRect().top;
        const targetEnd = targetHeight + topOffsetTop;
        if (scrollParent.clientHeight - targetEnd <= popup.clientHeight + offset[1] * 2 && topOffsetTop < scrollParent.clientHeight) {
            const scroll = targetEnd - scrollParent.clientHeight + offset[1] * 2;
            let top = newPos.top || 0;
            top = top - (scroll + popup.clientHeight);
            newPos.top = top;
        }
    }
    return newPos;
};
const $5c938d1514d83d54$var$calculateVerticalStickTop = ({ target: target, targetTop: targetTop, targetHeight: targetHeight, popupOffsetParentHeight: popupOffsetParentHeight, popupOffsetParent: popupOffsetParent, offset: offset, position: position, placement: placement, boundariesElement: boundariesElement })=>{
    const scrollParent = $5c938d1514d83d54$export$69742dd9a26edd3e(target) || boundariesElement;
    const newPos = {
        ...position
    };
    if (scrollParent) {
        const { top: scrollParentTop } = scrollParent.getBoundingClientRect();
        const topBoundary = targetTop - scrollParentTop;
        const scrollParentScrollTop = scrollParent.scrollTop;
        if (topBoundary < 0) {
            const isBelowNodeBoundary = targetTop + (scrollParentScrollTop - scrollParentTop) + targetHeight + offset[1] < scrollParentScrollTop;
            if (placement === 'top') {
                if (isBelowNodeBoundary) newPos.bottom = popupOffsetParentHeight - (topBoundary + popupOffsetParent.scrollTop + targetHeight);
                else newPos.bottom = topBoundary + (newPos.bottom || 0);
            }
            if (placement === 'start') {
                if (isBelowNodeBoundary) newPos.top = topBoundary + popupOffsetParent.scrollTop + targetHeight;
                else newPos.top = Math.abs(topBoundary) + (newPos.top || 0) + offset[1];
            }
        }
    }
    return newPos;
};
const $5c938d1514d83d54$var$calculateVerticalPlacement = ({ placement: placement, targetTop: targetTop, targetHeight: targetHeight, isPopupParentBody: isPopupParentBody, popupOffsetParentHeight: popupOffsetParentHeight, popupOffsetParentTop: popupOffsetParentTop, popupOffsetParentScrollTop: popupOffsetParentScrollTop, borderBottomWidth: borderBottomWidth, offset: offset })=>{
    const position = {};
    if (placement === 'top') position.bottom = Math.ceil(popupOffsetParentHeight - (targetTop - popupOffsetParentTop) - (isPopupParentBody ? 0 : popupOffsetParentScrollTop) - borderBottomWidth + offset[1]);
    else if (placement === 'start') position.top = Math.ceil(targetTop - popupOffsetParentTop - offset[1] + (isPopupParentBody ? 0 : popupOffsetParentScrollTop));
    else {
        const top = Math.ceil(targetTop - popupOffsetParentTop + targetHeight + (isPopupParentBody ? 0 : popupOffsetParentScrollTop) - borderBottomWidth + offset[1]);
        position.top = top;
    }
    return position;
};
function $5c938d1514d83d54$export$b3ceb0cbf1056d98({ placement: placement, target: target, popup: popup, offset: offset, stick: stick, allowOutOfBounds: allowOutOfBounds = false, rect: rect, boundariesElement: boundariesElement }) {
    let position = {};
    if (!target || !popup || !popup.offsetParent) return position;
    if ($5c938d1514d83d54$export$ccbedd67ef6e9417(target)) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    target = target.parentElement;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const popupOffsetParent = popup.offsetParent;
    const offsetParentStyle = popupOffsetParent.style;
    let borderBottomWidth = 0;
    if (offsetParentStyle && offsetParentStyle.borderBottomWidth) borderBottomWidth = parseInt(offsetParentStyle.borderBottomWidth, 10);
    const [verticalPlacement, horizontalPlacement] = placement;
    const { top: popupOffsetParentTop, left: popupOffsetParentLeft, right: popupOffsetParentRight, height: popupOffsetParentHeight } = rect ? rect : popupOffsetParent.getBoundingClientRect();
    const { top: targetTop, left: targetLeft, right: targetRight, height: targetHeight, width: targetWidth } = target.getBoundingClientRect();
    const isPopupParentBody = $5c938d1514d83d54$export$540dbd453ede1ce3(popupOffsetParent);
    const verticalPosition = $5c938d1514d83d54$var$calculateVerticalPlacement({
        placement: verticalPlacement,
        targetTop: targetTop,
        isPopupParentBody: isPopupParentBody,
        popupOffsetParentHeight: popupOffsetParentHeight,
        popupOffsetParentTop: popupOffsetParentTop,
        popupOffsetParentScrollTop: popupOffsetParent.scrollTop || 0,
        targetHeight: targetHeight,
        borderBottomWidth: borderBottomWidth,
        offset: offset
    });
    position = {
        ...position,
        ...verticalPosition
    };
    if ((verticalPlacement === 'top' || verticalPlacement === 'start') && stick) position = $5c938d1514d83d54$var$calculateVerticalStickTop({
        target: target,
        targetTop: targetTop,
        targetHeight: targetHeight,
        popupOffsetParentHeight: popupOffsetParentHeight,
        popupOffsetParent: popupOffsetParent,
        popup: popup,
        offset: offset,
        position: position,
        placement: verticalPlacement,
        boundariesElement: boundariesElement
    });
    if (verticalPlacement !== 'top' && verticalPlacement !== 'start' && stick) position = $5c938d1514d83d54$var$calculateVerticalStickBottom({
        target: target,
        targetTop: targetTop,
        targetHeight: targetHeight,
        popup: popup,
        offset: offset,
        position: position,
        boundariesElement: boundariesElement
    });
    const horizontalPosition = $5c938d1514d83d54$var$calculateHorizontalPlacement({
        placement: horizontalPlacement,
        targetLeft: targetLeft,
        targetRight: targetRight,
        targetWidth: targetWidth,
        isPopupParentBody: isPopupParentBody,
        popupOffsetParentLeft: popupOffsetParentLeft,
        popupOffsetParentRight: popupOffsetParentRight,
        popupOffsetParentScrollLeft: popupOffsetParent.scrollLeft || 0,
        popupOffsetParentClientWidth: popup.offsetParent.clientWidth,
        popupClientWidth: popup.clientWidth || 0,
        offset: offset,
        allowOutOfBounds: allowOutOfBounds
    });
    position = {
        ...position,
        ...horizontalPosition
    };
    return position;
}
function $5c938d1514d83d54$export$ab306cb155a0ca1b(popup) {
    // popup.offsetParent does not exist if the popup element is not mounted
    if (!popup || !popup.offsetParent) return false;
    return true;
}
function $5c938d1514d83d54$export$69742dd9a26edd3e(popup) {
    let parent = popup;
    if (!parent) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while(parent = parent.parentElement){
        // IE11 on Window 8 doesn't show styles from CSS when accessing through element.style property.
        const style = window.getComputedStyle(parent);
        if (style.overflow === 'scroll' || style.overflowX === 'scroll' || style.overflowY === 'scroll' || parent.classList.contains('fabric-editor-popup-scroll-parent')) return parent;
    }
    return false;
}

});


parcelRegister("aYKcT", function(module, exports) {
$parcel$export(module.exports, "ArrowKeyNavigationProvider", () => $ba9790d4043e9bef$export$ee87cc4950b6d6fe);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $g9imq = parcelRequire("g9imq");

var $dNMlg = parcelRequire("dNMlg");

var $4UveB = parcelRequire("4UveB");

var $UpZp1 = parcelRequire("UpZp1");
const $ba9790d4043e9bef$export$ee87cc4950b6d6fe = (props)=>{
    const { children: children, type: type, ...restProps } = props;
    if (type === (0, $UpZp1.ArrowKeyNavigationType).COLOR) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $g9imq.default).Consumer, {
        children: ({ popupsMountPoint: popupsMountPoint, editorView: editorView, editorRef: editorRef })=>editorRef && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dNMlg.ColorPaletteArrowKeyNavigationProvider), {
                selectedRowIndex: props.selectedRowIndex,
                selectedColumnIndex: props.selectedColumnIndex,
                isOpenedByKeyboard: props.isOpenedByKeyboard,
                isPopupPositioned: props.isPopupPositioned,
                editorRef: editorRef,
                popupsMountPoint: popupsMountPoint,
                ...restProps,
                children: children
            })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $g9imq.default).Consumer, {
        children: ({ popupsMountPoint: popupsMountPoint, editorView: editorView, editorRef: editorRef })=>editorRef && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4UveB.MenuArrowKeyNavigationProvider), {
                editorRef: editorRef,
                popupsMountPoint: popupsMountPoint,
                ...restProps,
                children: children
            })
    });
};

});
parcelRegister("dNMlg", function(module, exports) {
$parcel$export(module.exports, "ColorPaletteArrowKeyNavigationProvider", () => $8f58427aa1024ad4$export$e17115e9cf808589);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $8f58427aa1024ad4$export$e17115e9cf808589 = ({ children: children, selectedRowIndex: selectedRowIndex, selectedColumnIndex: selectedColumnIndex, isOpenedByKeyboard: isOpenedByKeyboard, isPopupPositioned: isPopupPositioned, handleClose: handleClose, closeOnTab: closeOnTab, editorRef: editorRef, ignoreEscapeKey: ignoreEscapeKey, popupsMountPoint: popupsMountPoint })=>{
    const wrapperRef = (0, $eJOHy.useRef)(null);
    const currentSelectedColumnIndex = (0, $eJOHy.useRef)(selectedColumnIndex === -1 ? 0 : selectedColumnIndex);
    const currentSelectedRowIndex = (0, $eJOHy.useRef)(selectedRowIndex === -1 ? 0 : selectedRowIndex);
    const element = popupsMountPoint ? popupsMountPoint : editorRef.current;
    const [listenerTargetElement] = (0, $eJOHy.useState)(element);
    const incrementRowIndex = (rowElements, columnElements)=>{
        if (currentSelectedRowIndex.current === rowElements.length - 1) currentSelectedRowIndex.current = 0;
        else currentSelectedRowIndex.current = currentSelectedRowIndex.current + 1;
    };
    const decrementRowIndex = (rowElements, columnElements)=>{
        if (currentSelectedRowIndex.current === 0) currentSelectedRowIndex.current = rowElements.length - 1;
        else currentSelectedRowIndex.current = currentSelectedRowIndex.current - 1;
    };
    (0, $eJOHy.useLayoutEffect)(()=>{
        const incrementColumnIndex = (rowElements, columnElements)=>{
            if (currentSelectedColumnIndex.current === columnElements.length - 1) {
                incrementRowIndex(rowElements, columnElements);
                currentSelectedColumnIndex.current = 0;
            } else currentSelectedColumnIndex.current = currentSelectedColumnIndex.current + 1;
        };
        const decrementColumnIndex = (rowElements, columnElements)=>{
            if (currentSelectedColumnIndex.current === 0) {
                decrementRowIndex(rowElements, columnElements);
                currentSelectedColumnIndex.current = columnElements.length - 1;
            } else currentSelectedColumnIndex.current = currentSelectedColumnIndex.current - 1;
        };
        const focusColorSwatch = ()=>{
            const colorSwatchesRowElements = $8f58427aa1024ad4$var$getColorSwatchesRows(wrapperRef?.current);
            const currentSelectedColorSwatchRowElement = colorSwatchesRowElements[currentSelectedRowIndex.current];
            const focusableElements = $8f58427aa1024ad4$var$getFocusableElements(currentSelectedColorSwatchRowElement);
            if (!focusableElements || focusableElements?.length === 0) return;
            focusableElements[currentSelectedColumnIndex.current]?.focus();
        };
        /**
		 * To handle the key events on the list
		 * @param event
		 */ const handleKeyDown = (event)=>{
            if (event.key === 'Tab' && closeOnTab) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                handleClose(event);
                return;
            }
            const colorSwatchesRowElements = $8f58427aa1024ad4$var$getColorSwatchesRows(wrapperRef?.current);
            const currentSelectedColorSwatchRowElement = colorSwatchesRowElements[currentSelectedRowIndex.current];
            const focusableElements = $8f58427aa1024ad4$var$getFocusableElements(currentSelectedColorSwatchRowElement);
            switch(event.key){
                case 'ArrowDown':
                    incrementRowIndex(colorSwatchesRowElements, focusableElements);
                    focusColorSwatch();
                    event.preventDefault();
                    break;
                case 'ArrowUp':
                    decrementRowIndex(colorSwatchesRowElements, focusableElements);
                    focusColorSwatch();
                    event.preventDefault();
                    break;
                case 'ArrowLeft':
                    decrementColumnIndex(colorSwatchesRowElements, focusableElements);
                    focusColorSwatch();
                    event.preventDefault();
                    break;
                case 'ArrowRight':
                    incrementColumnIndex(colorSwatchesRowElements, focusableElements);
                    focusColorSwatch();
                    event.preventDefault();
                    break;
                case 'Escape':
                    if (!ignoreEscapeKey) // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleClose(event);
                    break;
                default:
                    return;
            }
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        listenerTargetElement && listenerTargetElement.addEventListener('keydown', handleKeyDown);
        // set focus to current selected color swatch if only opened by keyboard
        if (isOpenedByKeyboard && isPopupPositioned) // Using timeout because, we need to wait till color palette is rendered
        //  and visible on screen, then only focus color swatch, otherwise focus will be
        //  moved to body
        setTimeout(()=>{
            focusColorSwatch();
        });
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            listenerTargetElement && listenerTargetElement.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        currentSelectedColumnIndex,
        isOpenedByKeyboard,
        isPopupPositioned,
        wrapperRef,
        handleClose,
        closeOnTab,
        ignoreEscapeKey,
        listenerTargetElement
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: "custom-key-handler-wrapper",
        ref: wrapperRef,
        children: children
    }));
};
function $8f58427aa1024ad4$var$getColorSwatchesRows(rootNode) {
    if (!rootNode) return [];
    const colorSwatchesRowElements = rootNode.querySelectorAll('div[role=radiogroup]') || [];
    return Array.from(colorSwatchesRowElements);
}
function $8f58427aa1024ad4$var$getFocusableElements(rootNode) {
    if (!rootNode) return [];
    const focusableModalElements = rootNode.querySelectorAll('button[role=radio]:not([disabled])') || [];
    return Array.from(focusableModalElements);
}

});

parcelRegister("4UveB", function(module, exports) {
$parcel$export(module.exports, "MenuArrowKeyNavigationProvider", () => $a5d38829450c5340$export$e12b037790bf03e3);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $a5d38829450c5340$var$hasEnabledItems = (list)=>list.some((item)=>item.getAttribute('aria-disabled') !== 'true');
const $a5d38829450c5340$export$e12b037790bf03e3 = ({ children: children, handleClose: handleClose, disableArrowKeyNavigation: disableArrowKeyNavigation, keyDownHandlerContext: keyDownHandlerContext, closeOnTab: closeOnTab, onSelection: onSelection, editorRef: editorRef, popupsMountPoint: popupsMountPoint, disableCloseOnArrowClick: disableCloseOnArrowClick })=>{
    const wrapperRef = (0, $eJOHy.useRef)(null);
    const [currentSelectedItemIndex, setCurrentSelectedItemIndex] = (0, $eJOHy.useState)(-1);
    const element = popupsMountPoint ? [
        popupsMountPoint,
        editorRef.current
    ] : [
        editorRef.current
    ];
    const [listenerTargetElement] = (0, $eJOHy.useState)(element);
    const incrementIndex = (0, $eJOHy.useCallback)((list)=>{
        const currentIndex = currentSelectedItemIndex;
        let nextIndex = (currentIndex + 1) % list.length;
        // Skips disabled items. Previously this function relied on a list of enabled elements which caused a
        // difference between currentIndex and the item index in the menu.
        while(nextIndex !== currentIndex && list[nextIndex].getAttribute('aria-disabled') === 'true')nextIndex = (nextIndex + 1) % list.length;
        setCurrentSelectedItemIndex(nextIndex);
        return nextIndex;
    }, [
        currentSelectedItemIndex
    ]);
    const decrementIndex = (0, $eJOHy.useCallback)((list)=>{
        const currentIndex = currentSelectedItemIndex;
        let nextIndex = (list.length + currentIndex - 1) % list.length;
        while(nextIndex !== currentIndex && list[nextIndex].getAttribute('aria-disabled') === 'true')nextIndex = (list.length + nextIndex - 1) % list.length;
        setCurrentSelectedItemIndex(nextIndex);
        return nextIndex;
    }, [
        currentSelectedItemIndex
    ]);
    // this useEffect uses onSelection in it's dependency list which gets
    // changed as a result of the dropdown menu getting re-rendered in it's
    // parent component. Note that if onSelection gets updated to useMemo
    // this will no longer work.
    (0, $eJOHy.useEffect)(()=>{
        const currentIndex = currentSelectedItemIndex;
        const list = $a5d38829450c5340$var$getFocusableElements(wrapperRef?.current);
        const currentElement = list[currentIndex];
        if (currentElement && currentElement.getAttribute('aria-disabled') === 'true') {
            const focusIndex = incrementIndex(list);
            list[focusIndex]?.focus();
        }
    }, [
        currentSelectedItemIndex,
        onSelection,
        incrementIndex,
        decrementIndex
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (disableArrowKeyNavigation) return;
        /**
		 * To handle the key events on the list
		 * @param event
		 */ const handleKeyDown = (event)=>{
            const targetElement = event.target;
            // Tab key on menu items can be handled in the parent components of dropdown menus with KeydownHandlerContext
            if (event.key === 'Tab' && closeOnTab) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                handleClose(event);
                keyDownHandlerContext?.handleTab();
                return;
            }
            // To trap the focus inside the toolbar using left and right arrow keys
            const focusableElements = $a5d38829450c5340$var$getFocusableElements(wrapperRef?.current);
            if (!focusableElements || focusableElements?.length === 0) return;
            if (targetElement instanceof HTMLElement && !wrapperRef.current?.contains(targetElement)) setCurrentSelectedItemIndex(-1);
            switch(event.key){
                case 'ArrowDown':
                    if ($a5d38829450c5340$var$hasEnabledItems(focusableElements)) {
                        const focusIndex = incrementIndex(focusableElements);
                        focusableElements[focusIndex]?.focus();
                        event.preventDefault();
                    }
                    break;
                case 'ArrowUp':
                    if ($a5d38829450c5340$var$hasEnabledItems(focusableElements)) {
                        const focusIndex = decrementIndex(focusableElements);
                        focusableElements[focusIndex]?.focus();
                        event.preventDefault();
                    }
                    break;
                // ArrowLeft/Right on the menu should close the menus
                // then logic to retain the focus can be handled in the parent components with KeydownHandlerContext
                case 'ArrowLeft':
                    if (targetElement instanceof HTMLElement && !targetElement.closest('.custom-key-handler-wrapper')) return;
                    if (!disableCloseOnArrowClick) // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleClose(event);
                    if (targetElement instanceof HTMLElement && !targetElement.closest('[data-testid="editor-floating-toolbar"]')) keyDownHandlerContext?.handleArrowLeft();
                    break;
                case 'ArrowRight':
                    if (targetElement instanceof HTMLElement && !targetElement.closest('.custom-key-handler-wrapper')) return;
                    if (!disableCloseOnArrowClick) // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleClose(event);
                    if (targetElement instanceof HTMLElement && !targetElement.closest('[data-testid="editor-floating-toolbar"]')) keyDownHandlerContext?.handleArrowRight();
                    break;
                case 'Escape':
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleClose(event);
                    break;
                case 'Enter':
                    if (typeof onSelection === 'function') onSelection(currentSelectedItemIndex);
                    break;
                default:
                    return;
            }
        };
        listenerTargetElement && listenerTargetElement.forEach(function(elem) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            elem && elem.addEventListener('keydown', handleKeyDown);
        });
        return ()=>{
            listenerTargetElement && listenerTargetElement.forEach(function(elem) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                elem && elem.removeEventListener('keydown', handleKeyDown);
            });
        };
    }, [
        currentSelectedItemIndex,
        wrapperRef,
        handleClose,
        disableArrowKeyNavigation,
        keyDownHandlerContext,
        closeOnTab,
        onSelection,
        incrementIndex,
        decrementIndex,
        listenerTargetElement,
        disableCloseOnArrowClick
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "menu-key-handler-wrapper custom-key-handler-wrapper",
        ref: wrapperRef,
        children: children
    });
};
function $a5d38829450c5340$var$getFocusableElements(rootNode) {
    if (!rootNode) return [];
    const focusableModalElements = rootNode.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, div[tabindex="-1"]') || [];
    return Array.from(focusableModalElements);
}

});

parcelRegister("UpZp1", function(module, exports) {
$parcel$export(module.exports, "ArrowKeyNavigationType", () => $f801a7f63248a4b1$export$26c2c5e2f61f437a);
var $f801a7f63248a4b1$export$26c2c5e2f61f437a = /*#__PURE__*/ function(ArrowKeyNavigationType) {
    ArrowKeyNavigationType["COLOR"] = "color";
    ArrowKeyNavigationType["MENU"] = "menu";
    return ArrowKeyNavigationType;
}({});

});




parcelRegister("ea7w3", function(module, exports) {
$parcel$export(module.exports, "getInputMethod", () => $07480d76b26364de$export$8213a6fbfa466e73);

var $bMFKb = parcelRequire("bMFKb");

var $eRKkP = parcelRequire("eRKkP");
const $07480d76b26364de$var$toolbarTypeToInputMethod = {
    [(0, $eRKkP.ToolbarType).PRIMARY]: (0, $bMFKb.INPUT_METHOD).TOOLBAR,
    [(0, $eRKkP.ToolbarType).FLOATING]: (0, $bMFKb.INPUT_METHOD).FLOATING_TB
};
const $07480d76b26364de$export$8213a6fbfa466e73 = (toolbarType)=>$07480d76b26364de$var$toolbarTypeToInputMethod[toolbarType];

});


parcelRegister("iqesS", function(module, exports) {
$parcel$export(module.exports, "FloatingToolbarComponent", () => $cb805d55df99e777$export$b15abb95157a91c7);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $cxXTK = parcelRequire("cxXTK");

var $eJQEz = parcelRequire("eJQEz");

var $92xoS = parcelRequire("92xoS");

var $e36TU = parcelRequire("e36TU");

var $eRKkP = parcelRequire("eRKkP");

var $3Tv4M = parcelRequire("3Tv4M");
const $cb805d55df99e777$var$FloatingToolbarSettings = {
    disabled: false,
    isToolbarReducedSpacing: true,
    isSmall: true
};
function $cb805d55df99e777$export$b15abb95157a91c7({ featureFlags: featureFlags, editorView: editorView, showIndentationButtons: showIndentationButtons, pluginInjectionApi: pluginInjectionApi, allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation }) {
    const { bulletListActive: bulletListActive, bulletListDisabled: bulletListDisabled, orderedListActive: orderedListActive, orderedListDisabled: orderedListDisabled, isIndentationAllowed: isIndentationAllowed, indentDisabled: indentDisabled, outdentDisabled: outdentDisabled } = (0, $cxXTK.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'list',
        'indentation'
    ], (states)=>({
            bulletListActive: states.listState?.bulletListActive,
            bulletListDisabled: states.listState?.bulletListDisabled,
            orderedListActive: states.listState?.orderedListActive,
            orderedListDisabled: states.listState?.orderedListDisabled,
            isIndentationAllowed: states.indentationState?.isIndentationAllowed,
            indentDisabled: states.indentationState?.indentDisabled,
            outdentDisabled: states.indentationState?.outdentDisabled,
            // decorationSet is required to re-render PrimaryToolbarComponent component, so that the toolbar states updates regularly
            decorationSet: states.listState?.decorationSet
        }));
    const [taskDecisionState, setTaskDecisionState] = (0, $eJOHy.useState)();
    (0, $eJQEz.usePluginStateEffect)(pluginInjectionApi, [
        'taskDecision'
    ], ({ taskDecisionState: newTaskDecisionState })=>{
        if (newTaskDecisionState?.outdentDisabled !== taskDecisionState?.outdentDisabled || newTaskDecisionState?.indentDisabled !== taskDecisionState?.indentDisabled || newTaskDecisionState?.isInsideTask !== taskDecisionState?.isInsideTask) setTaskDecisionState({
            isInsideTask: Boolean(newTaskDecisionState?.isInsideTask),
            indentDisabled: Boolean(newTaskDecisionState?.indentDisabled),
            outdentDisabled: Boolean(newTaskDecisionState?.outdentDisabled)
        });
    });
    const toolbarListsIndentationState = (0, $e36TU.getIndentationButtonsState)(editorView.state, allowHeadingAndParagraphIndentation, taskDecisionState, {
        isIndentationAllowed: isIndentationAllowed,
        indentDisabled: indentDisabled,
        outdentDisabled: outdentDisabled
    }, pluginInjectionApi?.list?.actions.isInsideListItem);
    if (bulletListActive === undefined || bulletListDisabled === undefined || orderedListActive === undefined || orderedListDisabled === undefined) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3Tv4M.default), {
        featureFlags: featureFlags,
        isSmall: $cb805d55df99e777$var$FloatingToolbarSettings.isSmall,
        isReducedSpacing: (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? false : $cb805d55df99e777$var$FloatingToolbarSettings.isToolbarReducedSpacing,
        disabled: $cb805d55df99e777$var$FloatingToolbarSettings.disabled,
        editorView: editorView,
        bulletListActive: bulletListActive,
        bulletListDisabled: bulletListDisabled,
        orderedListActive: orderedListActive,
        orderedListDisabled: orderedListDisabled,
        showIndentationButtons: !!showIndentationButtons,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        indentDisabled: toolbarListsIndentationState.indentDisabled,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        outdentDisabled: toolbarListsIndentationState.outdentDisabled,
        indentationStateNode: toolbarListsIndentationState?.node,
        pluginInjectionApi: pluginInjectionApi,
        toolbarType: (0, $eRKkP.ToolbarType).FLOATING
    });
}

});

parcelRegister("eSzDT", function(module, exports) {
$parcel$export(module.exports, "getToolbarComponents", () => $fe3698aa388b1fe1$export$a758406ca53b86a5);

var $iyciS = parcelRequire("iyciS");

var $ixptR = parcelRequire("ixptR");

var $aHE13 = parcelRequire("aHE13");

var $ePDxN = parcelRequire("ePDxN");

var $c3Z1c = parcelRequire("c3Z1c");
const $fe3698aa388b1fe1$export$a758406ca53b86a5 = ({ api: api, showIndentationButtons: showIndentationButtons, allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation })=>{
    return [
        ...(0, $aHE13.getListsIndentationGroupForPrimaryToolbar)(),
        ...(0, $ixptR.getListsIndentationGroupForInlineToolbar)(),
        ...(0, $ePDxN.getListsIndentationHeroButton)(api),
        ...(0, $iyciS.getBulletedListButtonGroup)(api),
        ...(0, $c3Z1c.getListsIndentationMenu)(allowHeadingAndParagraphIndentation, showIndentationButtons, api)
    ];
};

});
parcelRegister("iyciS", function(module, exports) {
$parcel$export(module.exports, "getBulletedListButtonGroup", () => $1bb62e281b1637a7$export$eeaae60d77808105);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $3KjUM = parcelRequire("3KjUM");
var $6996L = parcelRequire("6996L");
var $c0YTT = parcelRequire("c0YTT");

var $f893H = parcelRequire("f893H");
var $1ZfmT = parcelRequire("1ZfmT");

var $2dqqH = parcelRequire("2dqqH");
const $1bb62e281b1637a7$var$BulletedListButtonGroup = ({ children: children })=>{
    const { editorAppearance: editorAppearance } = (0, $c0YTT.useEditorToolbar)();
    if (editorAppearance === 'full-page') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f893H.Show), {
        above: "xl",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1ZfmT.ToolbarButtonGroup), {
            children: children
        })
    });
};
const $1bb62e281b1637a7$export$eeaae60d77808105 = (api)=>{
    return [
        {
            type: (0, $3KjUM.BULLETED_LIST_BUTTON_GROUP).type,
            key: (0, $3KjUM.BULLETED_LIST_BUTTON_GROUP).key,
            parents: [
                {
                    type: (0, $3KjUM.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $3KjUM.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $6996L.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $3KjUM.BULLETED_LIST_BUTTON_GROUP).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $gt9Am.jsx)($1bb62e281b1637a7$var$BulletedListButtonGroup, {
                    children: children
                });
            }
        },
        {
            type: (0, $3KjUM.BULLETED_LIST_BUTTON).type,
            key: (0, $3KjUM.BULLETED_LIST_BUTTON).key,
            parents: [
                {
                    type: (0, $3KjUM.BULLETED_LIST_BUTTON_GROUP).type,
                    key: (0, $3KjUM.BULLETED_LIST_BUTTON_GROUP).key,
                    rank: 100
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $2dqqH.BulletedListButton), {
                    api: api,
                    parents: parents
                })
        }
    ];
};

});
parcelRegister("c0YTT", function(module, exports) {
$parcel$export(module.exports, "useEditorToolbar", () => $4872904f58e6716f$export$d463571cb9040a24);
$parcel$export(module.exports, "EditorToolbarProvider", () => $4872904f58e6716f$export$847624ff5ecdfe6d);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $4872904f58e6716f$var$EditorToolbarContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    editorView: null,
    editorAppearance: undefined,
    editorViewMode: undefined,
    editorToolbarDockingPreference: undefined
});
const $4872904f58e6716f$export$d463571cb9040a24 = ()=>{
    const context = (0, $eJOHy.useContext)($4872904f58e6716f$var$EditorToolbarContext);
    if (!context) throw new Error('useEditorToolbar must be used within EditorToolbarContext');
    return context;
};
const $4872904f58e6716f$export$847624ff5ecdfe6d = ({ children: children, editorView: editorView, editorAppearance: editorAppearance, editorViewMode: editorViewMode, editorToolbarDockingPreference: editorToolbarDockingPreference, isOffline: isOffline })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($4872904f58e6716f$var$EditorToolbarContext.Provider, {
        value: {
            editorView: editorView,
            editorAppearance: editorAppearance,
            editorViewMode: editorViewMode,
            editorToolbarDockingPreference: editorToolbarDockingPreference,
            isOffline: isOffline
        },
        children: children
    });
};

});

parcelRegister("f893H", function(module, exports) {
$parcel$export(module.exports, "Show", () => $7637c2be95a1dfb8$export$f6a3d19be20f5819);
/* eslint-disable @atlaskit/ui-styling-standard/no-classname-prop */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
/**
 * Generate a className based on the breakpoints provided.
 *
 * **Warning** - must much classnames defined in ResponsiveContainer.tsx
 * @param above - The breakpoint to show the element above.
 * @param below - The breakpoint to show the element below.
 * @returns The className to apply to the element.
 */ const $7637c2be95a1dfb8$var$generateClassName = (above, below)=>{
    if (above) return `show-above-${above}`;
    if (below) return `show-below-${below}`;
    return;
};
const $7637c2be95a1dfb8$export$f6a3d19be20f5819 = ({ children: children, above: above, below: below })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: $7637c2be95a1dfb8$var$generateClassName(above, below),
        children: children
    });
};

});

parcelRegister("1ZfmT", function(module, exports) {
$parcel$export(module.exports, "ToolbarButtonGroup", () => $a96d0ef427755500$export$89cfa2b8585c6d03);
/* ToolbarButtonGroup.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8IeH1 = parcelRequire("8IeH1");
const $a96d0ef427755500$var$styles = {
    container: "_1e0c1txw",
    firstChild: "_fb2512x7 _t1diidpf _u6eridpf",
    lastChild: "_fb2512x7 _xk07idpf _1jiyidpf",
    firstChildNew: "_19pe12x7 _1qq0idpf _3nesidpf",
    lastChildNew: "_19pe12x7 _15rdidpf _i84vidpf"
};
const $a96d0ef427755500$export$89cfa2b8585c6d03 = ({ children: children })=>{
    const items = (0, $eJOHy.Children).toArray(children);
    const FirstChild = items.at(0);
    const LastChild = items.at(-1);
    const middleChildren = items.slice(1, -1);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: $a96d0ef427755500$var$styles.container,
        "data-toolbar-component": "button-group",
        children: items.length <= 1 ? children : /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $a96d0ef427755500$var$styles.firstChildNew
                    ]),
                    children: FirstChild
                }),
                middleChildren,
                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $a96d0ef427755500$var$styles.lastChildNew
                    ]),
                    children: LastChild
                })
            ]
        })
    });
};

});

parcelRegister("2dqqH", function(module, exports) {
$parcel$export(module.exports, "BulletedListButton", () => $c54c9cdc56c92c6a$export$40c1053c0d024043);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6Exgk = parcelRequire("6Exgk");

var $hJIkn = parcelRequire("hJIkn");
var $aDNj8 = parcelRequire("aDNj8");
var $64R2q = parcelRequire("64R2q");

var $aS7Zt = parcelRequire("aS7Zt");
const $c54c9cdc56c92c6a$export$40c1053c0d024043 = ({ api: api, parents: parents })=>{
    const { bulletMessage: bulletMessage, onClick: onClick, isDisabled: isDisabled, isSelected: isSelected } = (0, $aS7Zt.useBulletedListInfo)({
        api: api,
        parents: parents
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $64R2q.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6Exgk.ToolTipContent), {
            description: bulletMessage,
            keymap: (0, $6Exgk.toggleBulletList)
        }),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aDNj8.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hJIkn))), {
                size: "small",
                label: ""
            }),
            onClick: onClick,
            isSelected: isSelected,
            isDisabled: isDisabled,
            ariaKeyshortcuts: (0, $6Exgk.getAriaKeyshortcuts)((0, $6Exgk.toggleBulletList))
        })
    });
};

});
parcelRegister("aS7Zt", function(module, exports) {
$parcel$export(module.exports, "useBulletedListInfo", () => $98138c9c84c33846$export$7d7b92fab7b2082a);
$parcel$export(module.exports, "BulletedListMenuItem", () => $98138c9c84c33846$export$13c3f4610578d225);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $cxXTK = parcelRequire("cxXTK");

var $6Exgk = parcelRequire("6Exgk");

var $eCOhn = parcelRequire("eCOhn");

var $e7Koy = parcelRequire("e7Koy");

var $hJIkn = parcelRequire("hJIkn");
var $dFLJN = parcelRequire("dFLJN");
var $ayYTB = parcelRequire("ayYTB");
const $98138c9c84c33846$export$7d7b92fab7b2082a = ({ api: api, parents: parents })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const bulletMessage = formatMessage((0, $eCOhn.messages).bulletedList);
    const { bulletListActive: bulletListActive, bulletListDisabled: bulletListDisabled, taskListActive: taskListActive } = (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'list',
        'taskDecision'
    ], (states)=>({
            bulletListActive: states.listState?.bulletListActive,
            bulletListDisabled: states.listState?.bulletListDisabled,
            taskListActive: states.taskDecisionState?.isInsideTask
        }));
    const onClick = ()=>{
        api?.core.actions.execute(taskListActive ? api?.taskDecision?.commands.toggleTaskList('bulletList') : api?.list.commands.toggleBulletList((0, $e7Koy.getInputMethodFromParentKeys)(parents)));
    };
    const isDisabled = bulletListDisabled && !taskListActive;
    const shortcut = (0, $6Exgk.formatShortcut)((0, $6Exgk.toggleBulletList));
    return {
        bulletMessage: bulletMessage,
        onClick: onClick,
        isDisabled: isDisabled,
        isSelected: bulletListActive,
        shortcut: shortcut
    };
};
const $98138c9c84c33846$export$13c3f4610578d225 = ({ api: api, parents: parents })=>{
    const { bulletMessage: bulletMessage, onClick: onClick, isDisabled: isDisabled, isSelected: isSelected, shortcut: shortcut } = $98138c9c84c33846$export$7d7b92fab7b2082a({
        api: api,
        parents: parents
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dFLJN.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hJIkn))), {
            size: "small",
            label: ""
        }),
        elemAfter: shortcut ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ayYTB.ToolbarKeyboardShortcutHint), {
            shortcut: shortcut
        }) : undefined,
        isSelected: isSelected,
        isDisabled: isDisabled,
        onClick: onClick,
        ariaKeyshortcuts: shortcut,
        children: bulletMessage
    });
};

});
parcelRegister("e7Koy", function(module, exports) {
$parcel$export(module.exports, "getInputMethodFromParentKeys", () => $ce82bd4e931ce09a$export$19f6cf3733198aff);

var $bMFKb = parcelRequire("bMFKb");

var $3KjUM = parcelRequire("3KjUM");
const $ce82bd4e931ce09a$export$19f6cf3733198aff = (parents)=>parents.at(0)?.key === (0, $3KjUM.TOOLBARS).INLINE_TEXT_TOOLBAR ? (0, $bMFKb.INPUT_METHOD).FLOATING_TB : (0, $bMFKb.INPUT_METHOD).TOOLBAR;

});

parcelRegister("dFLJN", function(module, exports) {
$parcel$export(module.exports, "ToolbarDropdownItem", () => $9c1d8888f1748025$export$abcb00136d206988);
/* ToolbarDropdownItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $jYYbf = parcelRequire("jYYbf");

var $46R8N = parcelRequire("46R8N");

var $cbSL1 = parcelRequire("cbSL1");

var $L6zCC = parcelRequire("L6zCC");
const $9c1d8888f1748025$var$styles = {
    toolbarDropdownItem: "_11c82smr _18zrutpp _1rjc1b66 _1e0c1txw _kqswh2mm _bfhk1w7a _1bsb1osq _1tkezwfg _1ul9eoa3 _syaz1gjq _1bas12b0 _1ah31i6y",
    enabled: "_irr3166n _1di61dty",
    disabled: "_syaz1lh4 _80om13gf",
    selected: "_bfhkfg4m _syazaqb7 _irr3i1yw _1di619ru"
};
const $9c1d8888f1748025$var$CustomDropdownMenuItemButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, 'data-testid': testId, 'aria-haspopup': ariaHasPopup, 'aria-disabled': ariaDisabled, 'aria-pressed': ariaPressed, 'aria-keyshortcuts': ariaKeyshortcuts, onClick: onClick, tabIndex: tabIndex }, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        testId: testId,
        xcss: (0, $6qaBj.cx)($9c1d8888f1748025$var$styles.toolbarDropdownItem, ariaDisabled ? $9c1d8888f1748025$var$styles.disabled : ariaPressed ? $9c1d8888f1748025$var$styles.selected : $9c1d8888f1748025$var$styles.enabled),
        onClick: onClick,
        tabIndex: tabIndex,
        "aria-haspopup": ariaHasPopup,
        "aria-expanded": ariaHasPopup ? ariaPressed ? true : false : undefined,
        "aria-pressed": ariaPressed,
        "aria-disabled": ariaDisabled,
        "aria-keyshortcuts": ariaKeyshortcuts,
        "data-toolbar-component": (0, $cbSL1.expValEquals)('platform_synced_block', 'isEnabled', true) ? 'menu-item' : undefined,
        ref: ref,
        children: children
    }));
const $9c1d8888f1748025$export$abcb00136d206988 = ({ onClick: onClick, elemBefore: elemBefore, elemAfter: elemAfter, isSelected: isSelected, children: children, isDisabled: isDisabled, hasNestedDropdownMenu: hasNestedDropdownMenu, triggerRef: triggerRef, shouldTitleWrap: shouldTitleWrap = true, testId: testId, ariaKeyshortcuts: ariaKeyshortcuts, href: href, target: target, rel: rel })=>{
    const parentContext = (0, $L6zCC.useToolbarDropdownMenu)();
    const injectedElemAfter = (()=>{
        if (!/*#__PURE__*/ (0, $eJOHy.isValidElement)(elemAfter)) return elemAfter;
        const elementProps = elemAfter.props;
        if ('isDisabled' in elementProps) return elemAfter;
        return /*#__PURE__*/ (0, $eJOHy.cloneElement)(elemAfter, {
            ...elementProps,
            isDisabled: isDisabled
        });
    })();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
        onClick: (e)=>{
            if (!hasNestedDropdownMenu) parentContext?.closeMenu();
            onClick?.(e);
        },
        elemBefore: elemBefore,
        elemAfter: (0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_patch_5', 'isEnabled', true) ? injectedElemAfter : elemAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        "aria-haspopup": hasNestedDropdownMenu,
        "aria-pressed": isSelected,
        "aria-keyshortcuts": ariaKeyshortcuts,
        ref: triggerRef,
        href: href,
        target: target,
        rel: rel,
        // @ts-ignore -- This `CustomDropdownMenuItemButton` has type conflicts with the `DropdownItem` component in a way that cannot be reconciled (ignored as it fails types in Jira and should in Platform)
        component: href && (0, $cbSL1.expValEquals)('platform_editor_toolbar_migrate_loom', 'isEnabled', true) ? undefined : $9c1d8888f1748025$var$CustomDropdownMenuItemButton,
        testId: testId,
        "data-toolbar-component": "menu-item",
        shouldTitleWrap: shouldTitleWrap,
        children: children
    });
};

});
parcelRegister("L6zCC", function(module, exports) {
$parcel$export(module.exports, "useToolbarDropdownMenu", () => $457f20b2be18e6a2$export$4a532e97cc88ad2f);
$parcel$export(module.exports, "ToolbarDropdownMenuProvider", () => $457f20b2be18e6a2$export$7baf0d20f25b94dd);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $457f20b2be18e6a2$var$ToolbarDropdownMenuContext = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $457f20b2be18e6a2$export$4a532e97cc88ad2f = ()=>{
    return (0, $eJOHy.useContext)($457f20b2be18e6a2$var$ToolbarDropdownMenuContext);
};
const $457f20b2be18e6a2$export$7baf0d20f25b94dd = ({ children: children, isOpen: isOpen, setIsOpen: setIsOpen })=>{
    const [isOpenInternal, setIsOpenInternal] = (0, $eJOHy.useState)(false);
    const openMenu = ()=>{
        if (setIsOpen !== undefined) setIsOpen(true);
        else setIsOpenInternal(true);
    };
    const closeMenu = ()=>{
        if (setIsOpen !== undefined) setIsOpen(false);
        else setIsOpenInternal(false);
    };
    const contextValue = {
        openMenu: openMenu,
        closeMenu: closeMenu,
        isOpen: isOpen !== undefined ? isOpen : isOpenInternal
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)($457f20b2be18e6a2$var$ToolbarDropdownMenuContext.Provider, {
        value: contextValue,
        children: children
    });
};

});


parcelRegister("ayYTB", function(module, exports) {
$parcel$export(module.exports, "ToolbarKeyboardShortcutHint", () => $bb0ff64ea177e3f2$export$f433dac65060f723);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $7q9BG = parcelRequire("7q9BG");

var $3cMgR = parcelRequire("3cMgR");

var $cbSL1 = parcelRequire("cbSL1");
const $bb0ff64ea177e3f2$export$f433dac65060f723 = ({ shortcut: shortcut, isDisabled: isDisabled })=>{
    if (isDisabled && (0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_patch_5', 'isEnabled', true)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7q9BG.default), {
        appearance: "primaryInverted",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
            color: "color.text.disabled",
            children: shortcut
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7q9BG.default), {
        children: shortcut
    });
};

});




parcelRegister("ixptR", function(module, exports) {
$parcel$export(module.exports, "getListsIndentationGroupForInlineToolbar", () => $740b3edfb1fe03d3$export$ba625abe9e2ccf66);

var $3KjUM = parcelRequire("3KjUM");
var $6996L = parcelRequire("6996L");
const $740b3edfb1fe03d3$export$ba625abe9e2ccf66 = ()=>{
    return [
        {
            type: (0, $3KjUM.LISTS_INDENTATION_GROUP_INLINE).type,
            key: (0, $3KjUM.LISTS_INDENTATION_GROUP_INLINE).key,
            parents: [
                {
                    type: (0, $3KjUM.TEXT_SECTION).type,
                    key: (0, $3KjUM.TEXT_SECTION).key,
                    rank: (0, $6996L.TEXT_SECTION_RANK)[(0, $3KjUM.LISTS_INDENTATION_GROUP).key]
                }
            ]
        }
    ];
};

});

parcelRegister("aHE13", function(module, exports) {
$parcel$export(module.exports, "getListsIndentationGroupForPrimaryToolbar", () => $6d0c45665b02e4ea$export$559bcfe9bd160d2a);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $3KjUM = parcelRequire("3KjUM");
var $6996L = parcelRequire("6996L");
var $c0YTT = parcelRequire("c0YTT");

var $f893H = parcelRequire("f893H");
var $1ZfmT = parcelRequire("1ZfmT");
const $6d0c45665b02e4ea$var$ListsIndentationGroup = ({ children: children })=>{
    const { editorAppearance: editorAppearance } = (0, $c0YTT.useEditorToolbar)();
    if (editorAppearance === 'full-page') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f893H.Show), {
        above: "xl",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1ZfmT.ToolbarButtonGroup), {
            children: children
        })
    });
};
const $6d0c45665b02e4ea$var$ListsIndentationGroupCollapsed = ({ children: children })=>{
    const { editorAppearance: editorAppearance } = (0, $c0YTT.useEditorToolbar)();
    if (editorAppearance === 'full-page') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f893H.Show), {
        below: "xl",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1ZfmT.ToolbarButtonGroup), {
            children: children
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1ZfmT.ToolbarButtonGroup), {
        children: children
    });
};
const $6d0c45665b02e4ea$export$559bcfe9bd160d2a = ()=>{
    return [
        {
            type: (0, $3KjUM.LISTS_INDENTATION_GROUP).type,
            key: (0, $3KjUM.LISTS_INDENTATION_GROUP).key,
            parents: [
                {
                    type: (0, $3KjUM.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $3KjUM.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $6996L.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $3KjUM.LISTS_INDENTATION_GROUP).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $gt9Am.jsx)($6d0c45665b02e4ea$var$ListsIndentationGroup, {
                    children: children
                });
            }
        },
        {
            type: (0, $3KjUM.LISTS_INDENTATION_GROUP_COLLAPSED).type,
            key: (0, $3KjUM.LISTS_INDENTATION_GROUP_COLLAPSED).key,
            parents: [
                {
                    type: (0, $3KjUM.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $3KjUM.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $6996L.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $3KjUM.LISTS_INDENTATION_GROUP).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $gt9Am.jsx)($6d0c45665b02e4ea$var$ListsIndentationGroupCollapsed, {
                    children: children
                });
            }
        }
    ];
};

});

parcelRegister("ePDxN", function(module, exports) {
$parcel$export(module.exports, "getListsIndentationHeroButton", () => $ace518784a980c2e$export$b917037285a1e87b);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $3KjUM = parcelRequire("3KjUM");
var $6996L = parcelRequire("6996L");

var $67OnT = parcelRequire("67OnT");
const $ace518784a980c2e$export$b917037285a1e87b = (api)=>{
    return [
        {
            type: (0, $3KjUM.LISTS_INDENTATION_HERO_BUTTON).type,
            key: (0, $3KjUM.LISTS_INDENTATION_HERO_BUTTON).key,
            parents: [
                {
                    type: (0, $3KjUM.LISTS_INDENTATION_GROUP).type,
                    key: (0, $3KjUM.LISTS_INDENTATION_GROUP).key,
                    rank: (0, $6996L.LISTS_INDENTATION_GROUP_RANK)[(0, $3KjUM.LISTS_INDENTATION_HERO_BUTTON).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $67OnT.ListsIndentationHeroButtonNew), {
                    api: api,
                    parents: parents
                })
        },
        {
            type: (0, $3KjUM.LISTS_INDENTATION_HERO_BUTTON_COLLAPSED).type,
            key: (0, $3KjUM.LISTS_INDENTATION_HERO_BUTTON_COLLAPSED).key,
            parents: [
                {
                    type: (0, $3KjUM.LISTS_INDENTATION_GROUP_COLLAPSED).type,
                    key: (0, $3KjUM.LISTS_INDENTATION_GROUP_COLLAPSED).key,
                    rank: (0, $6996L.LISTS_INDENTATION_GROUP_COLLAPSED_RANK)[(0, $3KjUM.LISTS_INDENTATION_HERO_BUTTON_COLLAPSED).key]
                },
                {
                    type: (0, $3KjUM.LISTS_INDENTATION_GROUP_INLINE).type,
                    key: (0, $3KjUM.LISTS_INDENTATION_GROUP_INLINE).key,
                    rank: (0, $6996L.LISTS_INDENTATION_GROUP_COLLAPSED_RANK)[(0, $3KjUM.LISTS_INDENTATION_HERO_BUTTON_COLLAPSED).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $67OnT.ListsIndentationHeroButtonCollapsed), {
                    api: api,
                    parents: parents
                })
        }
    ];
};

});
parcelRegister("67OnT", function(module, exports) {
$parcel$export(module.exports, "ListsIndentationHeroButtonCollapsed", () => $10aa912f767038d6$export$64aac13cbedfda18);
$parcel$export(module.exports, "ListsIndentationHeroButtonNew", () => $10aa912f767038d6$export$ac280cc0a77a657a);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $cxXTK = parcelRequire("cxXTK");

var $6Exgk = parcelRequire("6Exgk");

var $eCOhn = parcelRequire("eCOhn");
var $fbDBV = parcelRequire("fbDBV");

var $e7Koy = parcelRequire("e7Koy");

var $hJIkn = parcelRequire("hJIkn");
var $bVHJR = parcelRequire("bVHJR");
var $aDNj8 = parcelRequire("aDNj8");
var $64R2q = parcelRequire("64R2q");

var $bwM92 = parcelRequire("bwM92");

var $cbSL1 = parcelRequire("cbSL1");
function $10aa912f767038d6$var$useListsIndentationHeroButtonInfo({ api: api, parents: parents, defaultListType: defaultListType }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { bulletListActive: bulletListActive, bulletListDisabled: bulletListDisabled, orderedListActive: orderedListActive, taskListActive: taskListActive } = (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'list',
        'taskDecision'
    ], (states)=>({
            bulletListActive: states.listState?.bulletListActive,
            bulletListDisabled: states.listState?.bulletListDisabled,
            orderedListActive: states.listState?.orderedListActive,
            taskListActive: states.taskDecisionState?.isInsideTask
        }));
    const getListType = taskListActive ? 'taskList' : orderedListActive ? 'orderedList' : defaultListType;
    const taskListKeymap = (0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) ? (0, $6Exgk.toggleTaskList) : (0, $6Exgk.toggleTaskItemCheckbox);
    const getKeymap = getListType === 'taskList' ? taskListKeymap : getListType === 'orderedList' ? (0, $6Exgk.toggleOrderedList) : (0, $6Exgk.toggleBulletList);
    const shortcut = (0, $6Exgk.formatShortcut)(getKeymap);
    const keymap = getKeymap;
    const message = getListType === 'taskList' ? formatMessage((0, $fbDBV.tasksAndDecisionsMessages).taskList) : getListType === 'orderedList' ? formatMessage((0, $eCOhn.messages).orderedList) : formatMessage((0, $eCOhn.messages).bulletedList);
    const onClick = ()=>{
        const inputMethod = (0, $e7Koy.getInputMethodFromParentKeys)(parents);
        if (getListType === 'taskList') api?.core.actions.execute(api?.taskDecision?.commands.toggleTaskList());
        else if (getListType === 'orderedList') api?.core.actions.execute(api?.list.commands.toggleOrderedList(inputMethod));
        else api?.core.actions.execute(api?.list.commands.toggleBulletList(inputMethod));
    };
    const iconBefore = getListType === 'taskList' ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bwM92))), {
        label: formatMessage((0, $fbDBV.tasksAndDecisionsMessages).taskList),
        size: "small"
    }) : getListType === 'orderedList' ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bVHJR))), {
        label: formatMessage((0, $eCOhn.messages).orderedList),
        size: "small"
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hJIkn))), {
        label: formatMessage((0, $eCOhn.messages).bulletedList),
        size: "small"
    });
    const isSelected = getListType === 'bulletList' ? bulletListActive : getListType === 'orderedList' ? orderedListActive : taskListActive;
    const isDisabled = !orderedListActive && !taskListActive && bulletListDisabled;
    return {
        shortcut: shortcut,
        keymap: keymap,
        message: message,
        onClick: onClick,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled
    };
}
const $10aa912f767038d6$export$64aac13cbedfda18 = ({ api: api, parents: parents })=>{
    const { shortcut: shortcut, keymap: keymap, message: message, onClick: onClick, iconBefore: iconBefore, isSelected: isSelected, isDisabled: isDisabled } = $10aa912f767038d6$var$useListsIndentationHeroButtonInfo({
        api: api,
        parents: parents,
        defaultListType: 'bulletList'
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $64R2q.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6Exgk.ToolTipContent), {
            description: message,
            keymap: keymap
        }),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aDNj8.ToolbarButton), {
            iconBefore: iconBefore,
            isSelected: isSelected,
            isDisabled: isDisabled,
            ariaKeyshortcuts: shortcut,
            onClick: onClick
        })
    });
};
const $10aa912f767038d6$export$ac280cc0a77a657a = ({ api: api, parents: parents })=>{
    const { shortcut: shortcut, keymap: keymap, message: message, onClick: onClick, iconBefore: iconBefore, isSelected: isSelected, isDisabled: isDisabled } = $10aa912f767038d6$var$useListsIndentationHeroButtonInfo({
        api: api,
        parents: parents,
        defaultListType: 'orderedList'
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $64R2q.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6Exgk.ToolTipContent), {
            description: message,
            keymap: keymap
        }),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aDNj8.ToolbarButton), {
            iconBefore: iconBefore,
            isSelected: isSelected,
            isDisabled: isDisabled,
            ariaKeyshortcuts: shortcut,
            onClick: onClick
        })
    });
};
const $10aa912f767038d6$export$a7640af50de0f233 = ({ api: api, parents: parents })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { bulletListActive: bulletListActive, bulletListDisabled: bulletListDisabled, orderedListActive: orderedListActive, taskListActive: taskListActive } = (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'list',
        'taskDecision'
    ], (states)=>({
            bulletListActive: states.listState?.bulletListActive,
            bulletListDisabled: states.listState?.bulletListDisabled,
            orderedListActive: states.listState?.orderedListActive,
            taskListActive: states.taskDecisionState?.isInsideTask
        }));
    const taskListKeymap = (0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) ? (0, $6Exgk.toggleTaskList) : (0, $6Exgk.toggleTaskItemCheckbox);
    const shortcut = taskListActive ? (0, $6Exgk.formatShortcut)(taskListKeymap) : orderedListActive ? (0, $6Exgk.formatShortcut)((0, $6Exgk.toggleOrderedList)) : (0, $6Exgk.formatShortcut)((0, $6Exgk.toggleBulletList));
    const onClick = ()=>{
        const inputMethod = (0, $e7Koy.getInputMethodFromParentKeys)(parents);
        if (taskListActive) api?.core.actions.execute(api?.taskDecision?.commands.toggleTaskList());
        else if (orderedListActive) api?.core.actions.execute(api?.list.commands.toggleOrderedList(inputMethod));
        else api?.core.actions.execute(api?.list.commands.toggleBulletList(inputMethod));
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $64R2q.ToolbarTooltip), {
        content: taskListActive ? formatMessage((0, $fbDBV.tasksAndDecisionsMessages).taskList) : orderedListActive ? formatMessage((0, $eCOhn.messages).orderedList) : formatMessage((0, $eCOhn.messages).bulletedList),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aDNj8.ToolbarButton), {
            iconBefore: taskListActive ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bwM92))), {
                label: formatMessage((0, $fbDBV.tasksAndDecisionsMessages).taskList),
                size: "small"
            }) : orderedListActive ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bVHJR))), {
                label: formatMessage((0, $eCOhn.messages).orderedList),
                size: "small"
            }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hJIkn))), {
                label: formatMessage((0, $eCOhn.messages).bulletedList),
                size: "small"
            }),
            isSelected: bulletListActive || orderedListActive || taskListActive,
            isDisabled: !orderedListActive && !taskListActive && bulletListDisabled,
            ariaKeyshortcuts: shortcut,
            onClick: onClick
        })
    });
};

});


parcelRegister("c3Z1c", function(module, exports) {
$parcel$export(module.exports, "getListsIndentationMenu", () => $ac7914328cb43386$export$9c70fcf7cde6c956);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $3KjUM = parcelRequire("3KjUM");
var $6996L = parcelRequire("6996L");

var $cbSL1 = parcelRequire("cbSL1");

var $aS7Zt = parcelRequire("aS7Zt");

var $kgSjQ = parcelRequire("kgSjQ");

var $dRXXC = parcelRequire("dRXXC");

var $7axTx = parcelRequire("7axTx");

var $fMPWs = parcelRequire("fMPWs");

var $dCUJ0 = parcelRequire("dCUJ0");

var $1tAkW = parcelRequire("1tAkW");
const $ac7914328cb43386$export$9c70fcf7cde6c956 = (allowHeadingAndParagraphIndentation, showIndentationButtons, api)=>{
    return [
        {
            type: (0, $3KjUM.LISTS_INDENTATION_MENU).type,
            key: (0, $3KjUM.LISTS_INDENTATION_MENU).key,
            parents: [
                {
                    type: (0, $3KjUM.LISTS_INDENTATION_GROUP).type,
                    key: (0, $3KjUM.LISTS_INDENTATION_GROUP).key,
                    rank: (0, $6996L.LISTS_INDENTATION_GROUP_RANK)[(0, $3KjUM.LISTS_INDENTATION_MENU).key]
                },
                {
                    type: (0, $3KjUM.LISTS_INDENTATION_GROUP_COLLAPSED).type,
                    key: (0, $3KjUM.LISTS_INDENTATION_GROUP_COLLAPSED).key,
                    rank: (0, $6996L.LISTS_INDENTATION_GROUP_COLLAPSED_RANK)[(0, $3KjUM.LISTS_INDENTATION_MENU).key]
                },
                {
                    type: (0, $3KjUM.LISTS_INDENTATION_GROUP_INLINE).type,
                    key: (0, $3KjUM.LISTS_INDENTATION_GROUP_INLINE).key,
                    rank: (0, $6996L.LISTS_INDENTATION_GROUP_COLLAPSED_RANK)[(0, $3KjUM.LISTS_INDENTATION_MENU).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $dRXXC.ListsIndentationMenu), {
                    api: api,
                    allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation,
                    children: children
                })
        },
        {
            type: (0, $3KjUM.LISTS_INDENTATION_MENU_SECTION).type,
            key: (0, $3KjUM.LISTS_INDENTATION_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $3KjUM.LISTS_INDENTATION_MENU).type,
                    key: (0, $3KjUM.LISTS_INDENTATION_MENU).key,
                    rank: (0, $6996L.LISTS_INDENTATION_MENU_RANK)[(0, $3KjUM.LISTS_INDENTATION_MENU_SECTION).key]
                },
                ...(0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_responsive', 'isEnabled', true) ? [
                    {
                        type: (0, $3KjUM.TEXT_COLLAPSED_MENU).type,
                        key: (0, $3KjUM.TEXT_COLLAPSED_MENU).key,
                        rank: (0, $6996L.TEXT_COLLAPSED_MENU_RANK)[(0, $3KjUM.LISTS_INDENTATION_MENU_SECTION).key]
                    }
                ] : []
            ],
            component: (0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_responsive', 'isEnabled', true) ? (0, $7axTx.MenuSection) : undefined
        },
        {
            type: (0, $3KjUM.BULLETED_LIST_MENU_ITEM).type,
            key: (0, $3KjUM.BULLETED_LIST_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $3KjUM.LISTS_INDENTATION_MENU_SECTION).type,
                    key: (0, $3KjUM.LISTS_INDENTATION_MENU_SECTION).key,
                    rank: (0, $6996L.LISTS_INDENTATION_MENU_SECTION_RANK)[(0, $3KjUM.BULLETED_LIST_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $aS7Zt.BulletedListMenuItem), {
                    api: api,
                    parents: parents
                })
        },
        {
            type: (0, $3KjUM.NUMBERED_LIST_MENU_ITEM).type,
            key: (0, $3KjUM.NUMBERED_LIST_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $3KjUM.LISTS_INDENTATION_MENU_SECTION).type,
                    key: (0, $3KjUM.LISTS_INDENTATION_MENU_SECTION).key,
                    rank: (0, $6996L.LISTS_INDENTATION_MENU_SECTION_RANK)[(0, $3KjUM.NUMBERED_LIST_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fMPWs.NumberedListMenuItem), {
                    api: api,
                    parents: parents
                })
        },
        ...!(0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) ? [
            {
                type: (0, $3KjUM.TASK_LIST_MENU_ITEM).type,
                key: (0, $3KjUM.TASK_LIST_MENU_ITEM).key,
                parents: [
                    {
                        type: (0, $3KjUM.LISTS_INDENTATION_MENU_SECTION).type,
                        key: (0, $3KjUM.LISTS_INDENTATION_MENU_SECTION).key,
                        rank: (0, $6996L.LISTS_INDENTATION_MENU_SECTION_RANK)[(0, $3KjUM.TASK_LIST_MENU_ITEM).key]
                    }
                ],
                component: ({ parents: parents })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $1tAkW.TaskListMenuItem), {
                        api: api,
                        parents: parents
                    })
            }
        ] : [],
        {
            type: (0, $3KjUM.OUTDENT_MENU_ITEM).type,
            key: (0, $3KjUM.OUTDENT_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $3KjUM.LISTS_INDENTATION_MENU_SECTION).type,
                    key: (0, $3KjUM.LISTS_INDENTATION_MENU_SECTION).key,
                    rank: (0, $6996L.LISTS_INDENTATION_MENU_SECTION_RANK)[(0, $3KjUM.OUTDENT_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $dCUJ0.OutdentMenuItem), {
                    api: api,
                    allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation,
                    showIndentationButtons: showIndentationButtons,
                    parents: parents
                })
        },
        {
            type: (0, $3KjUM.INDENT_MENU_ITEM).type,
            key: (0, $3KjUM.INDENT_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $3KjUM.LISTS_INDENTATION_MENU_SECTION).type,
                    key: (0, $3KjUM.LISTS_INDENTATION_MENU_SECTION).key,
                    rank: (0, $6996L.LISTS_INDENTATION_MENU_SECTION_RANK)[(0, $3KjUM.INDENT_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kgSjQ.IndentMenuItem), {
                    api: api,
                    allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation,
                    showIndentationButtons: showIndentationButtons,
                    parents: parents
                })
        }
    ];
};

});
parcelRegister("kgSjQ", function(module, exports) {
$parcel$export(module.exports, "IndentMenuItem", () => $d16a5a98ab92aae1$export$fdc3a713c0f7f7e);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $6Exgk = parcelRequire("6Exgk");

var $7g31l = parcelRequire("7g31l");

var $e7Koy = parcelRequire("e7Koy");
var $c0YTT = parcelRequire("c0YTT");

var $6hGSl = parcelRequire("6hGSl");
var $dFLJN = parcelRequire("dFLJN");
var $ayYTB = parcelRequire("ayYTB");

var $cfbCh = parcelRequire("cfbCh");
const $d16a5a98ab92aae1$export$fdc3a713c0f7f7e = ({ api: api, showIndentationButtons: showIndentationButtons, allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation, parents: parents })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { editorView: editorView } = (0, $c0YTT.useEditorToolbar)();
    const indentationState = (0, $cfbCh.useIndentationState)({
        api: api,
        allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation,
        state: editorView?.state
    });
    if (!showIndentationButtons) return null;
    const onClick = ()=>{
        const inputMethod = (0, $e7Koy.getInputMethodFromParentKeys)(parents);
        const node = indentationState?.node;
        if (node === 'paragraph_heading') {
            if (editorView?.state) api?.indentation?.actions.indentParagraphOrHeading(inputMethod)(editorView?.state, editorView?.dispatch);
        }
        if (node === 'list') api?.core?.actions.execute(api?.list?.commands.indentList(inputMethod));
        if (node === 'taskList') {
            if (editorView?.state) api?.taskDecision?.actions.indentTaskList(inputMethod)(editorView?.state, editorView?.dispatch);
        }
    };
    const shortcut = (0, $6Exgk.formatShortcut)((0, $6Exgk.indent));
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dFLJN.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6hGSl))), {
            size: "small",
            label: ""
        }),
        elemAfter: shortcut ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ayYTB.ToolbarKeyboardShortcutHint), {
            shortcut: shortcut
        }) : undefined,
        isDisabled: indentationState?.indentDisabled,
        ariaKeyshortcuts: shortcut,
        onClick: onClick,
        children: formatMessage((0, $7g31l.messages).indent)
    });
};

});
parcelRegister("cfbCh", function(module, exports) {
$parcel$export(module.exports, "useIndentationState", () => $13f6fc9a6a06d30b$export$738f7a376e7e29b3);

var $cxXTK = parcelRequire("cxXTK");

var $e36TU = parcelRequire("e36TU");
const $13f6fc9a6a06d30b$export$738f7a376e7e29b3 = ({ api: api, allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation, state: state })=>{
    const { isIndentationAllowed: isIndentationAllowed, indentDisabled: indentDisabled, outdentDisabled: outdentDisabled } = (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'indentation'
    ], (states)=>({
            isIndentationAllowed: states.indentationState?.isIndentationAllowed,
            outdentDisabled: states.indentationState?.outdentDisabled,
            indentDisabled: states.indentationState?.indentDisabled
        }));
    const { isInsideTask: isInsideTask, indentDisabled: taskIndentDisabled, outdentDisabled: taskOutdentDisabled } = (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'taskDecision'
    ], (states)=>({
            isInsideTask: states.taskDecisionState?.isInsideTask,
            outdentDisabled: states.taskDecisionState?.outdentDisabled,
            indentDisabled: states.taskDecisionState?.indentDisabled
        }));
    if (!state) return undefined;
    return (0, $e36TU.getIndentationButtonsState)(state, allowHeadingAndParagraphIndentation, {
        isInsideTask: isInsideTask ?? false,
        indentDisabled: taskIndentDisabled ?? false,
        outdentDisabled: taskOutdentDisabled ?? false
    }, {
        isIndentationAllowed: isIndentationAllowed,
        indentDisabled: indentDisabled,
        outdentDisabled: outdentDisabled
    }, api?.list.actions.isInsideListItem);
};

});


parcelRegister("dRXXC", function(module, exports) {
$parcel$export(module.exports, "ListsIndentationMenu", () => $6a76707ed57df832$export$4f71a14292bb825f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $cxXTK = parcelRequire("cxXTK");

var $d3Kyb = parcelRequire("d3Kyb");

var $c0YTT = parcelRequire("c0YTT");

var $1ivsK = parcelRequire("1ivsK");
var $lNljc = parcelRequire("lNljc");
var $64R2q = parcelRequire("64R2q");

var $cbSL1 = parcelRequire("cbSL1");

var $cfbCh = parcelRequire("cfbCh");
const $6a76707ed57df832$export$4f71a14292bb825f = ({ children: children, api: api, allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { editorView: editorView } = (0, $c0YTT.useEditorToolbar)();
    const indentationState = (0, $cfbCh.useIndentationState)({
        api: api,
        allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation,
        state: editorView?.state
    });
    const { bulletListDisabled: bulletListDisabled, orderedListDisabled: orderedListDisabled, taskListActive: taskListActive } = (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'list',
        'taskDecision'
    ], (states)=>({
            bulletListDisabled: states.listState?.bulletListDisabled,
            orderedListDisabled: states.listState?.orderedListDisabled,
            taskListActive: states.taskDecisionState?.isInsideTask
        }));
    const allItemsDisabled = bulletListDisabled && orderedListDisabled && indentationState?.indentDisabled && indentationState?.outdentDisabled && !taskListActive;
    return (0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $64R2q.ToolbarTooltip), {
        content: formatMessage((0, $d3Kyb.messages).lists),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lNljc.ToolbarDropdownMenu), {
            iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1ivsK.MoreItemsIcon), {
                label: formatMessage((0, $d3Kyb.messages).lists)
            }),
            isDisabled: allItemsDisabled,
            testId: "editor-toolbar__lists-and-indentation-menu",
            label: formatMessage((0, $d3Kyb.messages).lists),
            children: children
        })
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lNljc.ToolbarDropdownMenu), {
        iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1ivsK.MoreItemsIcon), {
            label: formatMessage((0, $d3Kyb.messages).lists)
        }),
        isDisabled: allItemsDisabled,
        testId: "editor-toolbar__lists-and-indentation-menu",
        label: formatMessage((0, $d3Kyb.messages).lists),
        children: children
    });
};

});
parcelRegister("d3Kyb", function(module, exports) {
$parcel$export(module.exports, "messages", () => $150485595db2e4ef$export$defe85febe8b728c);
// Common Translations will live here

var $7qGN1 = parcelRequire("7qGN1");
const $150485595db2e4ef$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    unorderedList: {
        id: 'fabric.editor.unorderedList',
        defaultMessage: 'Bullet list',
        description: "A list with bullets. Also known as an \u201Cunordered\u201D list"
    },
    unorderedListDescription: {
        id: 'fabric.editor.unorderedList.description',
        defaultMessage: 'Create an unordered list',
        description: ''
    },
    orderedList: {
        id: 'fabric.editor.orderedList',
        defaultMessage: 'Numbered list',
        description: "A list with ordered items 1\u2026 2\u2026 3\u2026"
    },
    orderedListDescription: {
        id: 'fabric.editor.orderedList.description',
        defaultMessage: 'Create an ordered list',
        description: ''
    },
    lists: {
        id: 'fabric.editor.lists',
        defaultMessage: 'Lists',
        description: 'Menu shows ordered/bullet list and unordered/numbered lists'
    }
});

});

parcelRegister("1ivsK", function(module, exports) {
$parcel$export(module.exports, "MoreItemsIcon", () => $2c2624ad0b60daf8$export$fab3805c25b17109);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1OQKp = parcelRequire("1OQKp");
const $2c2624ad0b60daf8$export$fab3805c25b17109 = ({ label: label, testId: testId, color: color, shouldRecommendSmallIcon: shouldRecommendSmallIcon, spacing: spacing })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
        label: label,
        testId: testId,
        color: color,
        shouldRecommendSmallIcon: shouldRecommendSmallIcon,
        spacing: spacing,
        size: "small"
    });

});

parcelRegister("lNljc", function(module, exports) {
$parcel$export(module.exports, "ToolbarDropdownMenu", () => $9dd938a903413b20$export$fffc3e0cfea7888f);
/* ToolbarDropdownMenu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $k0ahr = parcelRequire("k0ahr");

var $7rjYb = parcelRequire("7rjYb");

var $8IeH1 = parcelRequire("8IeH1");

var $cbSL1 = parcelRequire("cbSL1");

var $7K3rS = parcelRequire("7K3rS");

var $aDNj8 = parcelRequire("aDNj8");

var $L6zCC = parcelRequire("L6zCC");
const $9dd938a903413b20$var$styles = {
    sectionMargin: "_1mouv77o",
    firstSectionSeparator: "_18l8n7od",
    scrollContainer: "_c71lnklw _18m91wug"
};
const $9dd938a903413b20$var$ToolbarDropdownMenuContent = ({ iconBefore: iconBefore, children: children, isDisabled: isDisabled, testId: testId, label: label, onClick: onClick })=>{
    const { onDropdownOpenChanged: onDropdownOpenChanged } = (0, $7K3rS.useToolbarUI)();
    const menuContext = (0, $L6zCC.useToolbarDropdownMenu)();
    const handleOpenChange = (0, $eJOHy.useCallback)((args)=>{
        onDropdownOpenChanged(args);
        if (!args.isOpen) menuContext?.closeMenu();
    }, [
        menuContext,
        onDropdownOpenChanged
    ]);
    const handleClick = (0, $eJOHy.useCallback)(()=>{
        if (!menuContext?.isOpen) menuContext?.openMenu();
        else menuContext?.closeMenu();
    }, [
        menuContext
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7rjYb.default), {
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $aDNj8.ToolbarButton), {
                ref: triggerProps.triggerRef,
                isSelected: triggerProps.isSelected,
                "aria-expanded": triggerProps['aria-expanded'],
                "aria-haspopup": triggerProps['aria-haspopup'],
                "aria-controls": triggerProps['aria-controls'],
                onBlur: triggerProps.onBlur,
                onClick: (e)=>{
                    onClick && onClick(e, !menuContext?.isOpen);
                    handleClick();
                    triggerProps.onClick && triggerProps.onClick(e);
                },
                onFocus: triggerProps.onFocus,
                testId: testId,
                iconBefore: iconBefore,
                isDisabled: isDisabled,
                label: label
            }),
        onOpenChange: handleOpenChange,
        isOpen: menuContext?.isOpen,
        children: children
    });
};
const $9dd938a903413b20$export$fffc3e0cfea7888f = ({ iconBefore: iconBefore, children: children, isDisabled: isDisabled, testId: testId, label: label, hasSectionMargin: hasSectionMargin = true, enableMaxHeight: enableMaxHeight = false, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($9dd938a903413b20$var$ToolbarDropdownMenuContent, {
        iconBefore: iconBefore,
        isDisabled: isDisabled,
        testId: testId,
        label: label,
        onClick: onClick,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            xcss: (0, $k0ahr.cx)(hasSectionMargin && $9dd938a903413b20$var$styles.sectionMargin, enableMaxHeight && $9dd938a903413b20$var$styles.scrollContainer, (0, $cbSL1.expValEquals)('platform_editor_toolbar_migrate_loom', 'isEnabled', true) && $9dd938a903413b20$var$styles.firstSectionSeparator),
            "data-toolbar-component": "menu",
            children: children
        })
    });
};

});


parcelRegister("7axTx", function(module, exports) {
$parcel$export(module.exports, "MenuSection", () => $9c443981f027d4c8$export$4b1545b4f2016d26);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $3KjUM = parcelRequire("3KjUM");

var $9tvdK = parcelRequire("9tvdK");
const $9c443981f027d4c8$export$4b1545b4f2016d26 = ({ children: children, title: title, parents: parents })=>{
    const hasSeparator = parents.some((parent)=>parent.key === (0, $3KjUM.TEXT_COLLAPSED_MENU).key);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9tvdK.ToolbarDropdownItemSection), {
        hasSeparator: hasSeparator,
        title: title,
        children: children
    });
};

});
parcelRegister("9tvdK", function(module, exports) {
$parcel$export(module.exports, "ToolbarDropdownItemSection", () => $93728b4d62be1ff7$export$3e60ddf10b9269e3);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $aLJ1L = parcelRequire("aLJ1L");
const $93728b4d62be1ff7$export$3e60ddf10b9269e3 = ({ children: children, hasSeparator: hasSeparator, title: title, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aLJ1L.default), {
        hasSeparator: hasSeparator,
        title: title,
        "data-toolbar-component": "menu-section",
        testId: testId,
        children: children
    });
};

});


parcelRegister("fMPWs", function(module, exports) {
$parcel$export(module.exports, "NumberedListMenuItem", () => $423080da0aa4e79f$export$248224347373862f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $cxXTK = parcelRequire("cxXTK");

var $6Exgk = parcelRequire("6Exgk");

var $eCOhn = parcelRequire("eCOhn");

var $e7Koy = parcelRequire("e7Koy");

var $bVHJR = parcelRequire("bVHJR");
var $dFLJN = parcelRequire("dFLJN");
var $ayYTB = parcelRequire("ayYTB");
const $423080da0aa4e79f$export$248224347373862f = ({ api: api, parents: parents })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { orderedListActive: orderedListActive, orderedListDisabled: orderedListDisabled, taskListActive: taskListActive } = (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'list',
        'taskDecision'
    ], (states)=>({
            orderedListActive: states.listState?.orderedListActive,
            orderedListDisabled: states.listState?.orderedListDisabled,
            taskListActive: states.taskDecisionState?.isInsideTask
        }));
    const onClick = ()=>{
        api?.core.actions.execute(taskListActive ? api?.taskDecision?.commands.toggleTaskList('orderedList') : api?.list.commands.toggleOrderedList((0, $e7Koy.getInputMethodFromParentKeys)(parents)));
    };
    const shortcut = (0, $6Exgk.formatShortcut)((0, $6Exgk.toggleOrderedList));
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dFLJN.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bVHJR))), {
            size: "small",
            label: ""
        }),
        elemAfter: shortcut ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ayYTB.ToolbarKeyboardShortcutHint), {
            shortcut: shortcut
        }) : undefined,
        isSelected: orderedListActive,
        isDisabled: orderedListDisabled && !taskListActive,
        onClick: onClick,
        ariaKeyshortcuts: shortcut,
        children: formatMessage((0, $eCOhn.messages).orderedList)
    });
};

});

parcelRegister("dCUJ0", function(module, exports) {
$parcel$export(module.exports, "OutdentMenuItem", () => $d0b7d4e69e23efb0$export$549a24252ad8d94);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $6Exgk = parcelRequire("6Exgk");

var $7g31l = parcelRequire("7g31l");

var $e7Koy = parcelRequire("e7Koy");
var $c0YTT = parcelRequire("c0YTT");

var $5xSIi = parcelRequire("5xSIi");
var $dFLJN = parcelRequire("dFLJN");
var $ayYTB = parcelRequire("ayYTB");

var $cfbCh = parcelRequire("cfbCh");
const $d0b7d4e69e23efb0$export$549a24252ad8d94 = ({ api: api, allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation, showIndentationButtons: showIndentationButtons, parents: parents })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { editorView: editorView } = (0, $c0YTT.useEditorToolbar)();
    const indentationState = (0, $cfbCh.useIndentationState)({
        api: api,
        allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation,
        state: editorView?.state
    });
    if (!showIndentationButtons) return null;
    const onClick = ()=>{
        const inputMethod = (0, $e7Koy.getInputMethodFromParentKeys)(parents);
        const node = indentationState?.node;
        if (node === 'paragraph_heading') {
            if (editorView?.state) api?.indentation?.actions.outdentParagraphOrHeading(inputMethod)(editorView?.state, editorView?.dispatch);
        }
        if (node === 'list') api?.core.actions.execute(api?.list.commands.outdentList(inputMethod));
        if (node === 'taskList') {
            if (editorView?.state) api?.taskDecision?.actions.outdentTaskList(inputMethod)(editorView?.state, editorView?.dispatch);
        }
    };
    const shortcut = (0, $6Exgk.formatShortcut)((0, $6Exgk.outdent));
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dFLJN.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5xSIi))), {
            size: "small",
            label: ""
        }),
        elemAfter: shortcut ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ayYTB.ToolbarKeyboardShortcutHint), {
            shortcut: shortcut
        }) : undefined,
        isDisabled: indentationState?.outdentDisabled,
        ariaKeyshortcuts: shortcut,
        onClick: onClick,
        children: formatMessage((0, $7g31l.messages).outdent)
    });
};

});

parcelRegister("1tAkW", function(module, exports) {
$parcel$export(module.exports, "TaskListMenuItem", () => $4642d03cd15304a1$export$a78d1842153dea18);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $fbDBV = parcelRequire("fbDBV");

var $c0YTT = parcelRequire("c0YTT");

var $frlUM = parcelRequire("frlUM");

var $dFLJN = parcelRequire("dFLJN");
var $ayYTB = parcelRequire("ayYTB");

var $bwM92 = parcelRequire("bwM92");
const $4642d03cd15304a1$export$a78d1842153dea18 = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { editorView: editorView } = (0, $c0YTT.useEditorToolbar)();
    const taskListActive = (0, $frlUM.useSharedPluginStateSelector)(api, 'taskDecision.isInsideTask');
    if (!editorView?.state.schema.nodes.taskItem) return null;
    const handleClick = ()=>{
        api?.core.actions.execute(api?.taskDecision?.commands.toggleTaskList());
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dFLJN.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bwM92))), {
            size: "small",
            label: ""
        }),
        elemAfter: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ayYTB.ToolbarKeyboardShortcutHint), {
            shortcut: "[]"
        }),
        isSelected: taskListActive,
        isDisabled: false,
        onClick: handleClick,
        children: formatMessage((0, $fbDBV.tasksAndDecisionsMessages).taskList)
    });
};

});
parcelRegister("frlUM", function(module, exports) {
$parcel$export(module.exports, "useSharedPluginStateSelector", () => $d936bc043638308c$export$feb16861fe41d066);

var $eJOHy = parcelRequire("eJOHy");

var $9Dhvc = parcelRequire("9Dhvc");

var $cSmYj = parcelRequire("cSmYj");

var $eJQEz = parcelRequire("eJQEz");
function $d936bc043638308c$export$feb16861fe41d066(api, plugin, options = {}) {
    const transformer = (0, $eJOHy.useCallback)((pluginState)=>{
        const [pluginName, ...properties] = plugin.split('.');
        if (!pluginState || properties?.length === 0) return undefined;
        return (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(pluginState?.[`${pluginName}State`], properties);
    }, [
        plugin
    ]);
    const pluginNameArray = (0, $eJOHy.useMemo)(()=>{
        const [pluginName] = plugin.split('.');
        return [
            pluginName
        ];
    }, [
        plugin
    ]);
    const initialState = (0, $eJOHy.useMemo)(()=>{
        if (options.disabled) return;
        const [pluginName] = plugin.split('.');
        return transformer({
            [`${pluginName}State`]: api?.[pluginName]?.sharedState.currentState()
        });
    }, [
        plugin,
        api,
        options.disabled,
        transformer
    ]);
    return $d936bc043638308c$var$useSharedPluginStateSelectorInternal(api, pluginNameArray, transformer, initialState, options);
}
function $d936bc043638308c$var$useSharedPluginStateSelectorInternal(api, plugins, transformer, initialState, options = {}) {
    const [selectedPluginState, setSelectedPluginState] = (0, $eJOHy.useState)(()=>initialState);
    (0, $eJQEz.usePluginStateEffect)(api, plugins, (pluginStates)=>{
        // `pluginStates`: This is the same type through inference - but typescript doesn't recognise them as they are computed slightly differently
        const transformedValue = transformer(pluginStates);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(transformedValue, selectedPluginState)) setSelectedPluginState(()=>transformedValue);
    }, options);
    return selectedPluginState;
}

});





parcelRegister("9HYhn", function(module, exports) {
$parcel$export(module.exports, "basePlugin", () => (parcelRequire("aflUx")).default);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $aflUx = parcelRequire("aflUx");

});
parcelRegister("aflUx", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb08d8614905fb69$export$2e2bcd8739ae039);

var $gjQyF = parcelRequire("gjQyF");
var $bK3tx = parcelRequire("bK3tx");
var $53i5t = parcelRequire("53i5t");

var $c9NXO = parcelRequire("c9NXO");

var $dEkUJ = parcelRequire("dEkUJ");

var $apqw1 = parcelRequire("apqw1");

var $cbSL1 = parcelRequire("cbSL1");

var $92xoS = parcelRequire("92xoS");

var $kFUgU = parcelRequire("kFUgU");

var $kccJu = parcelRequire("kccJu");

var $Fp2cl = parcelRequire("Fp2cl");

var $9udmP = parcelRequire("9udmP");

var $hVrgn = parcelRequire("hVrgn");

var $iUuxx = parcelRequire("iUuxx");

var $8hwRf = parcelRequire("8hwRf");

var $2frjn = parcelRequire("2frjn");

var $02sTQ = parcelRequire("02sTQ");

var $htlTO = parcelRequire("htlTO");
function $bb08d8614905fb69$export$edcd20463038b9e1(from, to, tr, callbacks) {
    const { doc: doc } = tr;
    doc.nodesBetween(from, to, (node, pos)=>{
        callbacks.forEach((cb)=>cb({
                tr: tr,
                node: node,
                pos: pos,
                from: from,
                to: to
            }));
    });
}
const $bb08d8614905fb69$var$SMART_TO_ASCII = {
    "\u2026": '...',
    "\u2192": '->',
    "\u2190": '<-',
    "\u2013": '--',
    "\u201C": '"',
    "\u201D": '"',
    "\u2018": "'",
    "\u2019": "'"
};
// eslint-disable-next-line require-unicode-regexp
const $bb08d8614905fb69$var$FIND_SMART_CHAR = new RegExp(`[${Object.keys($bb08d8614905fb69$var$SMART_TO_ASCII).join('')}]`, 'g');
const $bb08d8614905fb69$var$basePlugin = ({ config: options, api: api })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    const callbacks = [];
    api?.base?.actions.registerMarks(({ tr: tr, node: node, pos: pos, from: from, to: to })=>{
        const { doc: doc } = tr;
        const { schema: schema } = doc.type;
        const { text: textNodeType } = schema.nodes;
        if (node.type === textNodeType && node.text) {
            // Find a valid start and end position because the text may be partially selected.
            const startPositionInSelection = Math.max(pos, from);
            const endPositionInSelection = Math.min(pos + node.nodeSize, to);
            const textForReplacing = doc.textBetween(startPositionInSelection, endPositionInSelection);
            const newText = textForReplacing.replace($bb08d8614905fb69$var$FIND_SMART_CHAR, (match)=>$bb08d8614905fb69$var$SMART_TO_ASCII[match] ?? match);
            const currentStartPos = tr.mapping.map(startPositionInSelection);
            const currentEndPos = tr.mapping.map(endPositionInSelection);
            tr.replaceWith(currentStartPos, currentEndPos, schema.text(newText, node.marks));
        }
    });
    return {
        name: 'base',
        getSharedState (editorState) {
            return {
                keyboardHeight: (0, $02sTQ.getKeyboardHeight)(editorState)
            };
        },
        actions: {
            setKeyboardHeight: $kFUgU.setKeyboardHeight,
            resolveMarks: (from, to, tr)=>$bb08d8614905fb69$export$edcd20463038b9e1(from, to, tr, callbacks),
            registerMarks: (callback)=>{
                callbacks.push(callback);
            }
        },
        pmPlugins () {
            const plugins = [
                {
                    name: 'filterStepsPlugin',
                    plugin: ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>(0, $Fp2cl.default)(dispatchAnalyticsEvent)
                }
            ];
            if ((0, $92xoS.editorExperiment)('platform_editor_exp_lazy_node_views', true, {
                exposure: true
            }) || (0, $cbSL1.expValEquals)('platform_editor_jira_advanced_code_blocks', 'isEnabled', true)) plugins.push({
                name: 'lazyNodeViewDecorationsPlugin',
                plugin: ()=>(0, $iUuxx.createLazyNodeViewDecorationPlugin)()
            });
            // In Chrome, when the selection is placed between adjacent nodes which are not contenteditatble
            // the cursor appears at the right most point of the parent container.
            //
            // In Firefox, when the selection is placed between adjacent nodes which are not contenteditatble
            // no cursor is presented to users.
            //
            // In Safari, when the selection is placed between adjacent nodes which are not contenteditatble
            // it is not possible to navigate with arrow keys.
            //
            // This plugin works around the issues by inserting decorations between
            // inline nodes which are set as contenteditable, and have a zero width space.
            plugins.push({
                name: 'inlineCursorTargetPlugin',
                plugin: ()=>options && options.allowInlineCursorTarget ? (0, $hVrgn.default)() : undefined
            });
            plugins.push({
                name: 'newlinePreserveMarksPlugin',
                plugin: (0, $8hwRf.default)
            }, {
                name: 'frozenEditor',
                plugin: ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
                    return (0, $9udmP.default)(api?.contextIdentifier)(dispatchAnalyticsEvent, (0, $htlTO.inputTracking), undefined);
                }
            }, {
                name: 'history',
                plugin: ()=>(0, $apqw1.history)()
            }, // should be last :(
            {
                name: 'codeBlockIndent',
                plugin: ()=>(0, $c9NXO.keymap)({
                        ...(0, $dEkUJ.baseKeymap),
                        'Mod-[': ()=>true,
                        'Mod-]': ()=>true
                    })
            });
            if (options && options.allowScrollGutter) plugins.push({
                name: 'scrollGutterPlugin',
                plugin: ()=>(0, $2frjn.default)(options.allowScrollGutter)
            });
            plugins.push({
                name: 'disableSpellcheckingPlugin',
                plugin: ()=>(0, $kccJu.default)(featureFlags)
            });
            return plugins;
        },
        nodes () {
            return [
                {
                    name: 'doc',
                    node: (0, $gjQyF.doc)
                },
                {
                    name: 'paragraph',
                    node: (0, $bK3tx.paragraph)
                },
                {
                    name: 'text',
                    node: (0, $53i5t.text)
                }
            ];
        }
    };
};
var $bb08d8614905fb69$export$2e2bcd8739ae039 = $bb08d8614905fb69$var$basePlugin;

});
parcelRegister("dEkUJ", function(module, exports) {
$parcel$export(module.exports, "deleteSelection", () => $9eff3bdfd297a823$export$e9a518a637d1e641);
$parcel$export(module.exports, "selectNodeBackward", () => $9eff3bdfd297a823$export$52b8a4af68d19794);
$parcel$export(module.exports, "exitCode", () => $9eff3bdfd297a823$export$634b78845598ff5b);
$parcel$export(module.exports, "createParagraphNear", () => $9eff3bdfd297a823$export$d0f80ac1b4510888);
$parcel$export(module.exports, "splitBlock", () => $9eff3bdfd297a823$export$e99155638ff4dff0);
$parcel$export(module.exports, "selectAll", () => $9eff3bdfd297a823$export$90aca4adda6ff0f5);
$parcel$export(module.exports, "toggleMark", () => $9eff3bdfd297a823$export$797ad2667b8015a8);
$parcel$export(module.exports, "autoJoin", () => $9eff3bdfd297a823$export$29903073afddcd8b);
$parcel$export(module.exports, "chainCommands", () => $9eff3bdfd297a823$export$146a774cdef7663a);
$parcel$export(module.exports, "baseKeymap", () => $9eff3bdfd297a823$export$4a0c2b85b1f0a889);

var $lzEKq = parcelRequire("lzEKq");

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");
/**
Delete the selection, if there is one.
*/ const $9eff3bdfd297a823$export$e9a518a637d1e641 = (state, dispatch)=>{
    if (state.selection.empty) return false;
    if (dispatch) dispatch(state.tr.deleteSelection().scrollIntoView());
    return true;
};
function $9eff3bdfd297a823$var$atBlockStart(state, view) {
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("backward", state) : $cursor.parentOffset > 0)) return null;
    return $cursor;
}
/**
If the selection is empty and at the start of a textblock, try to
reduce the distance between that block and the one before it—if
there's a block directly before it that can be joined, join them.
If not, try to move the selected block closer to the next one in
the document structure by lifting it out of its parent or moving it
into a parent of the previous block. Will use the view for accurate
(bidi-aware) start-of-textblock detection if given.
*/ const $9eff3bdfd297a823$export$979097b097459299 = (state, dispatch, view)=>{
    let $cursor = $9eff3bdfd297a823$var$atBlockStart(state, view);
    if (!$cursor) return false;
    let $cut = $9eff3bdfd297a823$var$findCutBefore($cursor);
    // If there is no node before this, try to lift
    if (!$cut) {
        let range = $cursor.blockRange(), target = range && (0, $lzEKq.liftTarget)(range);
        if (target == null) return false;
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    let before = $cut.nodeBefore;
    // Apply the joining algorithm
    if ($9eff3bdfd297a823$var$deleteBarrier(state, $cut, dispatch, -1)) return true;
    // If the node below has no content and the node above is
    // selectable, delete the node below and select the one above.
    if ($cursor.parent.content.size == 0 && ($9eff3bdfd297a823$var$textblockAt(before, "end") || (0, $3lIcL.NodeSelection).isSelectable(before))) for(let depth = $cursor.depth;; depth--){
        let delStep = (0, $lzEKq.replaceStep)(state.doc, $cursor.before(depth), $cursor.after(depth), (0, $3xw6l.Slice).empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection($9eff3bdfd297a823$var$textblockAt(before, "end") ? (0, $3lIcL.Selection).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos, -1)), -1) : (0, $3lIcL.NodeSelection).create(tr.doc, $cut.pos - before.nodeSize));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
        if (depth == 1 || $cursor.node(depth - 1).childCount > 1) break;
    }
    // If the node before is an atom, delete it
    if (before.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch) dispatch(state.tr.delete($cut.pos - before.nodeSize, $cut.pos).scrollIntoView());
        return true;
    }
    return false;
};
/**
A more limited form of [`joinBackward`]($commands.joinBackward)
that only tries to join the current textblock to the one before
it, if the cursor is at the start of a textblock.
*/ const $9eff3bdfd297a823$export$1dce4f5c74f5f90f = (state, dispatch, view)=>{
    let $cursor = $9eff3bdfd297a823$var$atBlockStart(state, view);
    if (!$cursor) return false;
    let $cut = $9eff3bdfd297a823$var$findCutBefore($cursor);
    return $cut ? $9eff3bdfd297a823$var$joinTextblocksAround(state, $cut, dispatch) : false;
};
/**
A more limited form of [`joinForward`]($commands.joinForward)
that only tries to join the current textblock to the one after
it, if the cursor is at the end of a textblock.
*/ const $9eff3bdfd297a823$export$e796bb96d22be2cd = (state, dispatch, view)=>{
    let $cursor = $9eff3bdfd297a823$var$atBlockEnd(state, view);
    if (!$cursor) return false;
    let $cut = $9eff3bdfd297a823$var$findCutAfter($cursor);
    return $cut ? $9eff3bdfd297a823$var$joinTextblocksAround(state, $cut, dispatch) : false;
};
function $9eff3bdfd297a823$var$joinTextblocksAround(state, $cut, dispatch) {
    let before = $cut.nodeBefore, beforeText = before, beforePos = $cut.pos - 1;
    for(; !beforeText.isTextblock; beforePos--){
        if (beforeText.type.spec.isolating) return false;
        let child = beforeText.lastChild;
        if (!child) return false;
        beforeText = child;
    }
    let after = $cut.nodeAfter, afterText = after, afterPos = $cut.pos + 1;
    for(; !afterText.isTextblock; afterPos++){
        if (afterText.type.spec.isolating) return false;
        let child = afterText.firstChild;
        if (!child) return false;
        afterText = child;
    }
    let step = (0, $lzEKq.replaceStep)(state.doc, beforePos, afterPos, (0, $3xw6l.Slice).empty);
    if (!step || step.from != beforePos || step instanceof (0, $lzEKq.ReplaceStep) && step.slice.size >= afterPos - beforePos) return false;
    if (dispatch) {
        let tr = state.tr.step(step);
        tr.setSelection((0, $3lIcL.TextSelection).create(tr.doc, beforePos));
        dispatch(tr.scrollIntoView());
    }
    return true;
}
function $9eff3bdfd297a823$var$textblockAt(node, side, only = false) {
    for(let scan = node; scan; scan = side == "start" ? scan.firstChild : scan.lastChild){
        if (scan.isTextblock) return true;
        if (only && scan.childCount != 1) return false;
    }
    return false;
}
/**
When the selection is empty and at the start of a textblock, select
the node before that textblock, if possible. This is intended to be
bound to keys like backspace, after
[`joinBackward`](https://prosemirror.net/docs/ref/#commands.joinBackward) or other deleting
commands, as a fall-back behavior when the schema doesn't allow
deletion at the selected point.
*/ const $9eff3bdfd297a823$export$52b8a4af68d19794 = (state, dispatch, view)=>{
    let { $head: $head, empty: empty } = state.selection, $cut = $head;
    if (!empty) return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("backward", state) : $head.parentOffset > 0) return false;
        $cut = $9eff3bdfd297a823$var$findCutBefore($head);
    }
    let node = $cut && $cut.nodeBefore;
    if (!node || !(0, $3lIcL.NodeSelection).isSelectable(node)) return false;
    if (dispatch) dispatch(state.tr.setSelection((0, $3lIcL.NodeSelection).create(state.doc, $cut.pos - node.nodeSize)).scrollIntoView());
    return true;
};
function $9eff3bdfd297a823$var$findCutBefore($pos) {
    if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
        if ($pos.index(i) > 0) return $pos.doc.resolve($pos.before(i + 1));
        if ($pos.node(i).type.spec.isolating) break;
    }
    return null;
}
function $9eff3bdfd297a823$var$atBlockEnd(state, view) {
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("forward", state) : $cursor.parentOffset < $cursor.parent.content.size)) return null;
    return $cursor;
}
/**
If the selection is empty and the cursor is at the end of a
textblock, try to reduce or remove the boundary between that block
and the one after it, either by joining them or by moving the other
block closer to this one in the tree structure. Will use the view
for accurate start-of-textblock detection if given.
*/ const $9eff3bdfd297a823$export$bf432e340007f9ef = (state, dispatch, view)=>{
    let $cursor = $9eff3bdfd297a823$var$atBlockEnd(state, view);
    if (!$cursor) return false;
    let $cut = $9eff3bdfd297a823$var$findCutAfter($cursor);
    // If there is no node after this, there's nothing to do
    if (!$cut) return false;
    let after = $cut.nodeAfter;
    // Try the joining algorithm
    if ($9eff3bdfd297a823$var$deleteBarrier(state, $cut, dispatch, 1)) return true;
    // If the node above has no content and the node below is
    // selectable, delete the node above and select the one below.
    if ($cursor.parent.content.size == 0 && ($9eff3bdfd297a823$var$textblockAt(after, "start") || (0, $3lIcL.NodeSelection).isSelectable(after))) {
        let delStep = (0, $lzEKq.replaceStep)(state.doc, $cursor.before(), $cursor.after(), (0, $3xw6l.Slice).empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection($9eff3bdfd297a823$var$textblockAt(after, "start") ? (0, $3lIcL.Selection).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos)), 1) : (0, $3lIcL.NodeSelection).create(tr.doc, tr.mapping.map($cut.pos)));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    // If the next node is an atom, delete it
    if (after.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch) dispatch(state.tr.delete($cut.pos, $cut.pos + after.nodeSize).scrollIntoView());
        return true;
    }
    return false;
};
/**
When the selection is empty and at the end of a textblock, select
the node coming after that textblock, if possible. This is intended
to be bound to keys like delete, after
[`joinForward`](https://prosemirror.net/docs/ref/#commands.joinForward) and similar deleting
commands, to provide a fall-back behavior when the schema doesn't
allow deletion at the selected point.
*/ const $9eff3bdfd297a823$export$5835b52680b80cfd = (state, dispatch, view)=>{
    let { $head: $head, empty: empty } = state.selection, $cut = $head;
    if (!empty) return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("forward", state) : $head.parentOffset < $head.parent.content.size) return false;
        $cut = $9eff3bdfd297a823$var$findCutAfter($head);
    }
    let node = $cut && $cut.nodeAfter;
    if (!node || !(0, $3lIcL.NodeSelection).isSelectable(node)) return false;
    if (dispatch) dispatch(state.tr.setSelection((0, $3lIcL.NodeSelection).create(state.doc, $cut.pos)).scrollIntoView());
    return true;
};
function $9eff3bdfd297a823$var$findCutAfter($pos) {
    if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
        let parent = $pos.node(i);
        if ($pos.index(i) + 1 < parent.childCount) return $pos.doc.resolve($pos.after(i + 1));
        if (parent.type.spec.isolating) break;
    }
    return null;
}
/**
Join the selected block or, if there is a text selection, the
closest ancestor block of the selection that can be joined, with
the sibling above it.
*/ const $9eff3bdfd297a823$export$4bb15e6d4372b393 = (state, dispatch)=>{
    let sel = state.selection, nodeSel = sel instanceof (0, $3lIcL.NodeSelection), point;
    if (nodeSel) {
        if (sel.node.isTextblock || !(0, $lzEKq.canJoin)(state.doc, sel.from)) return false;
        point = sel.from;
    } else {
        point = (0, $lzEKq.joinPoint)(state.doc, sel.from, -1);
        if (point == null) return false;
    }
    if (dispatch) {
        let tr = state.tr.join(point);
        if (nodeSel) tr.setSelection((0, $3lIcL.NodeSelection).create(tr.doc, point - state.doc.resolve(point).nodeBefore.nodeSize));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
Join the selected block, or the closest ancestor of the selection
that can be joined, with the sibling after it.
*/ const $9eff3bdfd297a823$export$8dd967a262b064bb = (state, dispatch)=>{
    let sel = state.selection, point;
    if (sel instanceof (0, $3lIcL.NodeSelection)) {
        if (sel.node.isTextblock || !(0, $lzEKq.canJoin)(state.doc, sel.to)) return false;
        point = sel.to;
    } else {
        point = (0, $lzEKq.joinPoint)(state.doc, sel.to, 1);
        if (point == null) return false;
    }
    if (dispatch) dispatch(state.tr.join(point).scrollIntoView());
    return true;
};
/**
Lift the selected block, or the closest ancestor block of the
selection that can be lifted, out of its parent node.
*/ const $9eff3bdfd297a823$export$590e8b2c435046d9 = (state, dispatch)=>{
    let { $from: $from, $to: $to } = state.selection;
    let range = $from.blockRange($to), target = range && (0, $lzEKq.liftTarget)(range);
    if (target == null) return false;
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
If the selection is in a node whose type has a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, replace the
selection with a newline character.
*/ const $9eff3bdfd297a823$export$a5d02b4b65e94f91 = (state, dispatch)=>{
    let { $head: $head, $anchor: $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
    if (dispatch) dispatch(state.tr.insertText("\n").scrollIntoView());
    return true;
};
function $9eff3bdfd297a823$var$defaultBlockAt(match) {
    for(let i = 0; i < match.edgeCount; i++){
        let { type: type } = match.edge(i);
        if (type.isTextblock && !type.hasRequiredAttrs()) return type;
    }
    return null;
}
/**
When the selection is in a node with a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, create a
default block after the code block, and move the cursor there.
*/ const $9eff3bdfd297a823$export$634b78845598ff5b = (state, dispatch)=>{
    let { $head: $head, $anchor: $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
    let above = $head.node(-1), after = $head.indexAfter(-1), type = $9eff3bdfd297a823$var$defaultBlockAt(above.contentMatchAt(after));
    if (!type || !above.canReplaceWith(after, after, type)) return false;
    if (dispatch) {
        let pos = $head.after(), tr = state.tr.replaceWith(pos, pos, type.createAndFill());
        tr.setSelection((0, $3lIcL.Selection).near(tr.doc.resolve(pos), 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If a block node is selected, create an empty paragraph before (if
it is its parent's first child) or after it.
*/ const $9eff3bdfd297a823$export$d0f80ac1b4510888 = (state, dispatch)=>{
    let sel = state.selection, { $from: $from, $to: $to } = sel;
    if (sel instanceof (0, $3lIcL.AllSelection) || $from.parent.inlineContent || $to.parent.inlineContent) return false;
    let type = $9eff3bdfd297a823$var$defaultBlockAt($to.parent.contentMatchAt($to.indexAfter()));
    if (!type || !type.isTextblock) return false;
    if (dispatch) {
        let side = (!$from.parentOffset && $to.index() < $to.parent.childCount ? $from : $to).pos;
        let tr = state.tr.insert(side, type.createAndFill());
        tr.setSelection((0, $3lIcL.TextSelection).create(tr.doc, side + 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If the cursor is in an empty textblock that can be lifted, lift the
block.
*/ const $9eff3bdfd297a823$export$a3574cc681852c08 = (state, dispatch)=>{
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || $cursor.parent.content.size) return false;
    if ($cursor.depth > 1 && $cursor.after() != $cursor.end(-1)) {
        let before = $cursor.before();
        if ((0, $lzEKq.canSplit)(state.doc, before)) {
            if (dispatch) dispatch(state.tr.split(before).scrollIntoView());
            return true;
        }
    }
    let range = $cursor.blockRange(), target = range && (0, $lzEKq.liftTarget)(range);
    if (target == null) return false;
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
Create a variant of [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock) that uses
a custom function to determine the type of the newly split off block.
*/ function $9eff3bdfd297a823$export$8bf8350f33b1e5ab(splitNode) {
    return (state, dispatch)=>{
        let { $from: $from, $to: $to } = state.selection;
        if (state.selection instanceof (0, $3lIcL.NodeSelection) && state.selection.node.isBlock) {
            if (!$from.parentOffset || !(0, $lzEKq.canSplit)(state.doc, $from.pos)) return false;
            if (dispatch) dispatch(state.tr.split($from.pos).scrollIntoView());
            return true;
        }
        if (!$from.depth) return false;
        let types = [];
        let splitDepth, deflt, atEnd = false, atStart = false;
        for(let d = $from.depth;; d--){
            let node = $from.node(d);
            if (node.isBlock) {
                atEnd = $from.end(d) == $from.pos + ($from.depth - d);
                atStart = $from.start(d) == $from.pos - ($from.depth - d);
                deflt = $9eff3bdfd297a823$var$defaultBlockAt($from.node(d - 1).contentMatchAt($from.indexAfter(d - 1)));
                let splitType = splitNode && splitNode($to.parent, atEnd, $from);
                types.unshift(splitType || (atEnd && deflt ? {
                    type: deflt
                } : null));
                splitDepth = d;
                break;
            } else {
                if (d == 1) return false;
                types.unshift(null);
            }
        }
        let tr = state.tr;
        if (state.selection instanceof (0, $3lIcL.TextSelection) || state.selection instanceof (0, $3lIcL.AllSelection)) tr.deleteSelection();
        let splitPos = tr.mapping.map($from.pos);
        let can = (0, $lzEKq.canSplit)(tr.doc, splitPos, types.length, types);
        if (!can) {
            types[0] = deflt ? {
                type: deflt
            } : null;
            can = (0, $lzEKq.canSplit)(tr.doc, splitPos, types.length, types);
        }
        tr.split(splitPos, types.length, types);
        if (!atEnd && atStart && $from.node(splitDepth).type != deflt) {
            let first = tr.mapping.map($from.before(splitDepth)), $first = tr.doc.resolve(first);
            if (deflt && $from.node(splitDepth - 1).canReplaceWith($first.index(), $first.index() + 1, deflt)) tr.setNodeMarkup(tr.mapping.map($from.before(splitDepth)), deflt);
        }
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
}
/**
Split the parent block of the selection. If the selection is a text
selection, also delete its content.
*/ const $9eff3bdfd297a823$export$e99155638ff4dff0 = $9eff3bdfd297a823$export$8bf8350f33b1e5ab();
/**
Acts like [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock), but without
resetting the set of active marks at the cursor.
*/ const $9eff3bdfd297a823$export$eeb429476568b72b = (state, dispatch)=>{
    return $9eff3bdfd297a823$export$e99155638ff4dff0(state, dispatch && ((tr)=>{
        let marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
        if (marks) tr.ensureMarks(marks);
        dispatch(tr);
    }));
};
/**
Move the selection to the node wrapping the current selection, if
any. (Will not select the document node.)
*/ const $9eff3bdfd297a823$export$a37f6aaa9169911d = (state, dispatch)=>{
    let { $from: $from, to: to } = state.selection, pos;
    let same = $from.sharedDepth(to);
    if (same == 0) return false;
    pos = $from.before(same);
    if (dispatch) dispatch(state.tr.setSelection((0, $3lIcL.NodeSelection).create(state.doc, pos)));
    return true;
};
/**
Select the whole document.
*/ const $9eff3bdfd297a823$export$90aca4adda6ff0f5 = (state, dispatch)=>{
    if (dispatch) dispatch(state.tr.setSelection(new (0, $3lIcL.AllSelection)(state.doc)));
    return true;
};
function $9eff3bdfd297a823$var$joinMaybeClear(state, $pos, dispatch) {
    let before = $pos.nodeBefore, after = $pos.nodeAfter, index = $pos.index();
    if (!before || !after || !before.type.compatibleContent(after.type)) return false;
    if (!before.content.size && $pos.parent.canReplace(index - 1, index)) {
        if (dispatch) dispatch(state.tr.delete($pos.pos - before.nodeSize, $pos.pos).scrollIntoView());
        return true;
    }
    if (!$pos.parent.canReplace(index, index + 1) || !(after.isTextblock || (0, $lzEKq.canJoin)(state.doc, $pos.pos))) return false;
    if (dispatch) dispatch(state.tr.join($pos.pos).scrollIntoView());
    return true;
}
function $9eff3bdfd297a823$var$deleteBarrier(state, $cut, dispatch, dir) {
    let before = $cut.nodeBefore, after = $cut.nodeAfter, conn, match;
    let isolated = before.type.spec.isolating || after.type.spec.isolating;
    if (!isolated && $9eff3bdfd297a823$var$joinMaybeClear(state, $cut, dispatch)) return true;
    let canDelAfter = !isolated && $cut.parent.canReplace($cut.index(), $cut.index() + 1);
    if (canDelAfter && (conn = (match = before.contentMatchAt(before.childCount)).findWrapping(after.type)) && match.matchType(conn[0] || after.type).validEnd) {
        if (dispatch) {
            let end = $cut.pos + after.nodeSize, wrap = (0, $3xw6l.Fragment).empty;
            for(let i = conn.length - 1; i >= 0; i--)wrap = (0, $3xw6l.Fragment).from(conn[i].create(null, wrap));
            wrap = (0, $3xw6l.Fragment).from(before.copy(wrap));
            let tr = state.tr.step(new (0, $lzEKq.ReplaceAroundStep)($cut.pos - 1, end, $cut.pos, end, new (0, $3xw6l.Slice)(wrap, 1, 0), conn.length, true));
            let $joinAt = tr.doc.resolve(end + 2 * conn.length);
            if ($joinAt.nodeAfter && $joinAt.nodeAfter.type == before.type && (0, $lzEKq.canJoin)(tr.doc, $joinAt.pos)) tr.join($joinAt.pos);
            dispatch(tr.scrollIntoView());
        }
        return true;
    }
    let selAfter = after.type.spec.isolating || dir > 0 && isolated ? null : (0, $3lIcL.Selection).findFrom($cut, 1);
    let range = selAfter && selAfter.$from.blockRange(selAfter.$to), target = range && (0, $lzEKq.liftTarget)(range);
    if (target != null && target >= $cut.depth) {
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    if (canDelAfter && $9eff3bdfd297a823$var$textblockAt(after, "start", true) && $9eff3bdfd297a823$var$textblockAt(before, "end")) {
        let at = before, wrap = [];
        for(;;){
            wrap.push(at);
            if (at.isTextblock) break;
            at = at.lastChild;
        }
        let afterText = after, afterDepth = 1;
        for(; !afterText.isTextblock; afterText = afterText.firstChild)afterDepth++;
        if (at.canReplace(at.childCount, at.childCount, afterText.content)) {
            if (dispatch) {
                let end = (0, $3xw6l.Fragment).empty;
                for(let i = wrap.length - 1; i >= 0; i--)end = (0, $3xw6l.Fragment).from(wrap[i].copy(end));
                let tr = state.tr.step(new (0, $lzEKq.ReplaceAroundStep)($cut.pos - wrap.length, $cut.pos + after.nodeSize, $cut.pos + afterDepth, $cut.pos + after.nodeSize - afterDepth, new (0, $3xw6l.Slice)(end, wrap.length, 0), 0, true));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    return false;
}
function $9eff3bdfd297a823$var$selectTextblockSide(side) {
    return function(state, dispatch) {
        let sel = state.selection, $pos = side < 0 ? sel.$from : sel.$to;
        let depth = $pos.depth;
        while($pos.node(depth).isInline){
            if (!depth) return false;
            depth--;
        }
        if (!$pos.node(depth).isTextblock) return false;
        if (dispatch) dispatch(state.tr.setSelection((0, $3lIcL.TextSelection).create(state.doc, side < 0 ? $pos.start(depth) : $pos.end(depth))));
        return true;
    };
}
/**
Moves the cursor to the start of current text block.
*/ const $9eff3bdfd297a823$export$c3a64f3c9604a1b1 = $9eff3bdfd297a823$var$selectTextblockSide(-1);
/**
Moves the cursor to the end of current text block.
*/ const $9eff3bdfd297a823$export$a66c1876556415e5 = $9eff3bdfd297a823$var$selectTextblockSide(1);
// Parameterized commands
/**
Wrap the selection in a node of the given type with the given
attributes.
*/ function $9eff3bdfd297a823$export$6e5e3c49755affd0(nodeType, attrs = null) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to } = state.selection;
        let range = $from.blockRange($to), wrapping = range && (0, $lzEKq.findWrapping)(range, nodeType, attrs);
        if (!wrapping) return false;
        if (dispatch) dispatch(state.tr.wrap(range, wrapping).scrollIntoView());
        return true;
    };
}
/**
Returns a command that tries to set the selected textblocks to the
given node type with the given attributes.
*/ function $9eff3bdfd297a823$export$36987f561c736aad(nodeType, attrs = null) {
    return function(state, dispatch) {
        let applicable = false;
        for(let i = 0; i < state.selection.ranges.length && !applicable; i++){
            let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
            state.doc.nodesBetween(from, to, (node, pos)=>{
                if (applicable) return false;
                if (!node.isTextblock || node.hasMarkup(nodeType, attrs)) return;
                if (node.type == nodeType) applicable = true;
                else {
                    let $pos = state.doc.resolve(pos), index = $pos.index();
                    applicable = $pos.parent.canReplaceWith(index, index + 1, nodeType);
                }
            });
        }
        if (!applicable) return false;
        if (dispatch) {
            let tr = state.tr;
            for(let i = 0; i < state.selection.ranges.length; i++){
                let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
                tr.setBlockType(from, to, nodeType, attrs);
            }
            dispatch(tr.scrollIntoView());
        }
        return true;
    };
}
function $9eff3bdfd297a823$var$markApplies(doc, ranges, type, enterAtoms) {
    for(let i = 0; i < ranges.length; i++){
        let { $from: $from, $to: $to } = ranges[i];
        let can = $from.depth == 0 ? doc.inlineContent && doc.type.allowsMarkType(type) : false;
        doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            if (can || !enterAtoms && node.isAtom && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) return false;
            can = node.inlineContent && node.type.allowsMarkType(type);
        });
        if (can) return true;
    }
    return false;
}
function $9eff3bdfd297a823$var$removeInlineAtoms(ranges) {
    let result = [];
    for(let i = 0; i < ranges.length; i++){
        let { $from: $from, $to: $to } = ranges[i];
        $from.doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            if (node.isAtom && node.content.size && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) {
                if (pos + 1 > $from.pos) result.push(new (0, $3lIcL.SelectionRange)($from, $from.doc.resolve(pos + 1)));
                $from = $from.doc.resolve(pos + 1 + node.content.size);
                return false;
            }
        });
        if ($from.pos < $to.pos) result.push(new (0, $3lIcL.SelectionRange)($from, $to));
    }
    return result;
}
/**
Create a command function that toggles the given mark with the
given attributes. Will return `false` when the current selection
doesn't support that mark. This will remove the mark if any marks
of that type exist in the selection, or add it otherwise. If the
selection is empty, this applies to the [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks) instead of a range of the
document.
*/ function $9eff3bdfd297a823$export$797ad2667b8015a8(markType, attrs = null, options) {
    let removeWhenPresent = (options && options.removeWhenPresent) !== false;
    let enterAtoms = (options && options.enterInlineAtoms) !== false;
    return function(state, dispatch) {
        let { empty: empty, $cursor: $cursor, ranges: ranges } = state.selection;
        if (empty && !$cursor || !$9eff3bdfd297a823$var$markApplies(state.doc, ranges, markType, enterAtoms)) return false;
        if (dispatch) {
            if ($cursor) {
                if (markType.isInSet(state.storedMarks || $cursor.marks())) dispatch(state.tr.removeStoredMark(markType));
                else dispatch(state.tr.addStoredMark(markType.create(attrs)));
            } else {
                let add, tr = state.tr;
                if (!enterAtoms) ranges = $9eff3bdfd297a823$var$removeInlineAtoms(ranges);
                if (removeWhenPresent) add = !ranges.some((r)=>state.doc.rangeHasMark(r.$from.pos, r.$to.pos, markType));
                else add = !ranges.every((r)=>{
                    let missing = false;
                    tr.doc.nodesBetween(r.$from.pos, r.$to.pos, (node, pos, parent)=>{
                        if (missing) return false;
                        missing = !markType.isInSet(node.marks) && !!parent && parent.type.allowsMarkType(markType) && !(node.isText && /^\s*$/.test(node.textBetween(Math.max(0, r.$from.pos - pos), Math.min(node.nodeSize, r.$to.pos - pos))));
                    });
                    return !missing;
                });
                for(let i = 0; i < ranges.length; i++){
                    let { $from: $from, $to: $to } = ranges[i];
                    if (!add) tr.removeMark($from.pos, $to.pos, markType);
                    else {
                        let from = $from.pos, to = $to.pos, start = $from.nodeAfter, end = $to.nodeBefore;
                        let spaceStart = start && start.isText ? /^\s*/.exec(start.text)[0].length : 0;
                        let spaceEnd = end && end.isText ? /\s*$/.exec(end.text)[0].length : 0;
                        if (from + spaceStart < to) {
                            from += spaceStart;
                            to -= spaceEnd;
                        }
                        tr.addMark(from, to, markType.create(attrs));
                    }
                }
                dispatch(tr.scrollIntoView());
            }
        }
        return true;
    };
}
function $9eff3bdfd297a823$var$wrapDispatchForJoin(dispatch, isJoinable) {
    return (tr)=>{
        if (!tr.isGeneric) return dispatch(tr);
        let ranges = [];
        for(let i = 0; i < tr.mapping.maps.length; i++){
            let map = tr.mapping.maps[i];
            for(let j = 0; j < ranges.length; j++)ranges[j] = map.map(ranges[j]);
            map.forEach((_s, _e, from, to)=>ranges.push(from, to));
        }
        // Figure out which joinable points exist inside those ranges,
        // by checking all node boundaries in their parent nodes.
        let joinable = [];
        for(let i = 0; i < ranges.length; i += 2){
            let from = ranges[i], to = ranges[i + 1];
            let $from = tr.doc.resolve(from), depth = $from.sharedDepth(to), parent = $from.node(depth);
            for(let index = $from.indexAfter(depth), pos = $from.after(depth + 1); pos <= to; ++index){
                let after = parent.maybeChild(index);
                if (!after) break;
                if (index && joinable.indexOf(pos) == -1) {
                    let before = parent.child(index - 1);
                    if (before.type == after.type && isJoinable(before, after)) joinable.push(pos);
                }
                pos += after.nodeSize;
            }
        }
        // Join the joinable points
        joinable.sort((a, b)=>a - b);
        for(let i = joinable.length - 1; i >= 0; i--)if ((0, $lzEKq.canJoin)(tr.doc, joinable[i])) tr.join(joinable[i]);
        dispatch(tr);
    };
}
/**
Wrap a command so that, when it produces a transform that causes
two joinable nodes to end up next to each other, those are joined.
Nodes are considered joinable when they are of the same type and
when the `isJoinable` predicate returns true for them or, if an
array of strings was passed, if their node type name is in that
array.
*/ function $9eff3bdfd297a823$export$29903073afddcd8b(command, isJoinable) {
    let canJoin = Array.isArray(isJoinable) ? (node)=>isJoinable.indexOf(node.type.name) > -1 : isJoinable;
    return (state, dispatch, view)=>command(state, dispatch && $9eff3bdfd297a823$var$wrapDispatchForJoin(dispatch, canJoin), view);
}
/**
Combine a number of command functions into a single function (which
calls them one by one until one returns true).
*/ function $9eff3bdfd297a823$export$146a774cdef7663a(...commands) {
    return function(state, dispatch, view) {
        for(let i = 0; i < commands.length; i++)if (commands[i](state, dispatch, view)) return true;
        return false;
    };
}
let $9eff3bdfd297a823$var$backspace = $9eff3bdfd297a823$export$146a774cdef7663a($9eff3bdfd297a823$export$e9a518a637d1e641, $9eff3bdfd297a823$export$979097b097459299, $9eff3bdfd297a823$export$52b8a4af68d19794);
let $9eff3bdfd297a823$var$del = $9eff3bdfd297a823$export$146a774cdef7663a($9eff3bdfd297a823$export$e9a518a637d1e641, $9eff3bdfd297a823$export$bf432e340007f9ef, $9eff3bdfd297a823$export$5835b52680b80cfd);
/**
A basic keymap containing bindings not specific to any schema.
Binds the following keys (when multiple commands are listed, they
are chained with [`chainCommands`](https://prosemirror.net/docs/ref/#commands.chainCommands)):

* **Enter** to `newlineInCode`, `createParagraphNear`, `liftEmptyBlock`, `splitBlock`
* **Mod-Enter** to `exitCode`
* **Backspace** and **Mod-Backspace** to `deleteSelection`, `joinBackward`, `selectNodeBackward`
* **Delete** and **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-a** to `selectAll`
*/ const $9eff3bdfd297a823$export$eb36e8971b04df36 = {
    "Enter": $9eff3bdfd297a823$export$146a774cdef7663a($9eff3bdfd297a823$export$a5d02b4b65e94f91, $9eff3bdfd297a823$export$d0f80ac1b4510888, $9eff3bdfd297a823$export$a3574cc681852c08, $9eff3bdfd297a823$export$e99155638ff4dff0),
    "Mod-Enter": $9eff3bdfd297a823$export$634b78845598ff5b,
    "Backspace": $9eff3bdfd297a823$var$backspace,
    "Mod-Backspace": $9eff3bdfd297a823$var$backspace,
    "Shift-Backspace": $9eff3bdfd297a823$var$backspace,
    "Delete": $9eff3bdfd297a823$var$del,
    "Mod-Delete": $9eff3bdfd297a823$var$del,
    "Mod-a": $9eff3bdfd297a823$export$90aca4adda6ff0f5
};
/**
A copy of `pcBaseKeymap` that also binds **Ctrl-h** like Backspace,
**Ctrl-d** like Delete, **Alt-Backspace** like Ctrl-Backspace, and
**Ctrl-Alt-Backspace**, **Alt-Delete**, and **Alt-d** like
Ctrl-Delete.
*/ const $9eff3bdfd297a823$export$f292ad8dbd5063c8 = {
    "Ctrl-h": $9eff3bdfd297a823$export$eb36e8971b04df36["Backspace"],
    "Alt-Backspace": $9eff3bdfd297a823$export$eb36e8971b04df36["Mod-Backspace"],
    "Ctrl-d": $9eff3bdfd297a823$export$eb36e8971b04df36["Delete"],
    "Ctrl-Alt-Backspace": $9eff3bdfd297a823$export$eb36e8971b04df36["Mod-Delete"],
    "Alt-Delete": $9eff3bdfd297a823$export$eb36e8971b04df36["Mod-Delete"],
    "Alt-d": $9eff3bdfd297a823$export$eb36e8971b04df36["Mod-Delete"],
    "Ctrl-a": $9eff3bdfd297a823$export$c3a64f3c9604a1b1,
    "Ctrl-e": $9eff3bdfd297a823$export$a66c1876556415e5
};
for(let key in $9eff3bdfd297a823$export$eb36e8971b04df36)$9eff3bdfd297a823$export$f292ad8dbd5063c8[key] = $9eff3bdfd297a823$export$eb36e8971b04df36[key];
const $9eff3bdfd297a823$var$mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os != "undefined" && os.platform ? os.platform() == "darwin" : false;
/**
Depending on the detected platform, this will hold
[`pcBasekeymap`](https://prosemirror.net/docs/ref/#commands.pcBaseKeymap) or
[`macBaseKeymap`](https://prosemirror.net/docs/ref/#commands.macBaseKeymap).
*/ const $9eff3bdfd297a823$export$4a0c2b85b1f0a889 = $9eff3bdfd297a823$var$mac ? $9eff3bdfd297a823$export$f292ad8dbd5063c8 : $9eff3bdfd297a823$export$eb36e8971b04df36;

});

parcelRegister("kFUgU", function(module, exports) {
$parcel$export(module.exports, "setKeyboardHeight", () => $da49190bee742ba4$export$b8c3ea160300668d);

var $9P93m = parcelRequire("9P93m");
const $da49190bee742ba4$export$b8c3ea160300668d = (keyboardHeight)=>(state, dispatch)=>{
        const { tr: tr } = state;
        tr.setMeta((0, $9P93m.scrollGutterPluginKey), {
            keyboardHeight: keyboardHeight
        });
        if (dispatch) dispatch(tr);
        return true;
    };

});
parcelRegister("9P93m", function(module, exports) {
$parcel$export(module.exports, "scrollGutterPluginKey", () => $440e0c8ae1a4b410$export$54fdd3c2782161ea);
$parcel$export(module.exports, "getScrollGutterPluginState", () => $440e0c8ae1a4b410$export$a237783470abe542);

var $3lIcL = parcelRequire("3lIcL");
const $440e0c8ae1a4b410$export$54fdd3c2782161ea = new (0, $3lIcL.PluginKey)('scrollGutter');
const $440e0c8ae1a4b410$export$a237783470abe542 = (state)=>{
    if (state) return $440e0c8ae1a4b410$export$54fdd3c2782161ea.getState(state);
};

});


parcelRegister("kccJu", function(module, exports) {
$parcel$export(module.exports, "default", () => $99f225c75744e2a6$export$2e2bcd8739ae039);

var $7EdFW = parcelRequire("7EdFW");

var $i8KtF = parcelRequire("i8KtF");

var $3lIcL = parcelRequire("3lIcL");

var $cbSL1 = parcelRequire("cbSL1");
function $99f225c75744e2a6$var$getCurrentBrowserAndVersion(browserEnv) {
    switch(true){
        case browserEnv.chrome === true:
            return {
                browser: 'chrome',
                version: browserEnv.chrome_version
            };
        case browserEnv.ie === true:
            return {
                browser: 'ie',
                version: browserEnv.ie_version
            };
        case browserEnv.gecko === true:
            return {
                browser: 'gecko',
                version: browserEnv.gecko_version
            };
        case browserEnv.safari === true:
            return {
                browser: 'safari',
                version: browserEnv.safari_version
            };
    }
    return undefined;
}
var $99f225c75744e2a6$export$2e2bcd8739ae039 = (featureFlags)=>new (0, $i8KtF.SafePlugin)({
        key: new (0, $3lIcL.PluginKey)('disableSpellchecking'),
        props: {
            attributes: (editorState)=>{
                if (!featureFlags) return {};
                const browserConfigFeatureFlag = featureFlags.disableSpellcheckByBrowser;
                const browserEnv = (0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $7EdFW.getBrowserInfo)() : (0, $7EdFW.browser);
                const userCurrentBrowserAndVersion = $99f225c75744e2a6$var$getCurrentBrowserAndVersion(browserEnv);
                if (!userCurrentBrowserAndVersion || !browserConfigFeatureFlag) return {};
                const browserVersionDisableRange = // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                browserConfigFeatureFlag[userCurrentBrowserAndVersion.browser];
                if (!browserVersionDisableRange || !browserEnv[userCurrentBrowserAndVersion.browser]) return {};
                const shouldDisableSpellcheck = !!browserVersionDisableRange.maximum ? userCurrentBrowserAndVersion.version >= browserVersionDisableRange.minimum && userCurrentBrowserAndVersion.version <= browserVersionDisableRange.maximum : browserEnv[userCurrentBrowserAndVersion.browser] && userCurrentBrowserAndVersion.version >= browserVersionDisableRange.minimum;
                if (shouldDisableSpellcheck) return {
                    spellcheck: 'false'
                };
                return {};
            }
        }
    });

});

parcelRegister("Fp2cl", function(module, exports) {
$parcel$export(module.exports, "default", () => $08450b8db49816ac$export$2e2bcd8739ae039);

var $bMFKb = parcelRequire("bMFKb");
var $jXreb = parcelRequire("jXreb");

var $i8KtF = parcelRequire("i8KtF");
const $08450b8db49816ac$var$hasInvalidSteps = (tr)=>(tr.steps || []).some((step)=>step.from > step.to);
var $08450b8db49816ac$export$2e2bcd8739ae039 = (dispatchAnalyticsEvent)=>{
    return new (0, $i8KtF.SafePlugin)({
        filterTransaction (transaction) {
            if ($08450b8db49816ac$var$hasInvalidSteps(transaction)) {
                // eslint-disable-next-line no-console
                console.warn('The transaction was blocked because it contains invalid steps', transaction.steps);
                dispatchAnalyticsEvent({
                    action: (0, $bMFKb.ACTION).DISCARDED_INVALID_STEPS_FROM_TRANSACTION,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
                    attributes: {
                        analyticsEventPayloads: (0, $jXreb.getAnalyticsEventsFromTransaction)(transaction)
                    },
                    eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
                });
                return false;
            }
            return true;
        }
    });
};

});

parcelRegister("9udmP", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ee19c3da06fb608$export$2e2bcd8739ae039);

var $bMFKb = parcelRequire("bMFKb");
var $8MfCL = parcelRequire("8MfCL");

var $9I6lS = parcelRequire("9I6lS");

var $8LHnV = parcelRequire("8LHnV");

var $i8KtF = parcelRequire("i8KtF");

var $dyNYh = parcelRequire("dyNYh");

var $3lIcL = parcelRequire("3lIcL");

var $btBeM = parcelRequire("btBeM");

var $lu3Zd = parcelRequire("lu3Zd");
const $8ee19c3da06fb608$export$70246689264eff75 = new (0, $3lIcL.PluginKey)('frozenEditor');
const $8ee19c3da06fb608$var$DEFAULT_KEYSTROKE_SAMPLING_LIMIT = 100;
const $8ee19c3da06fb608$var$DEFAULT_SLOW_THRESHOLD = 300;
const $8ee19c3da06fb608$export$c8d5b833abcf8e80 = 600;
const $8ee19c3da06fb608$export$47b2879ca9bbf67a = 2000;
const $8ee19c3da06fb608$export$1b622068be977101 = 3000;
const $8ee19c3da06fb608$var$DEFAULT_TRACK_SEVERITY_ENABLED = false;
const $8ee19c3da06fb608$export$5705ac5f923a65e7 = 100;
const $8ee19c3da06fb608$export$1c6feb3429832c55 = 500;
const $8ee19c3da06fb608$var$dispatchLongTaskEvent = (contextIdentifierPlugin)=>(dispatchAnalyticsEvent, view, time, getNodeCount, interactionType, severity)=>{
        const { state: state } = view;
        const nodesCount = getNodeCount(state);
        return dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).BROWSER_FREEZE,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
            attributes: {
                objectId: contextIdentifierPlugin?.sharedState.currentState()?.contextIdentifierProvider?.objectId,
                freezeTime: time,
                nodeSize: state.doc.nodeSize,
                ...nodesCount,
                interactionType: interactionType,
                severity: severity
            },
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
        });
    };
var $8ee19c3da06fb608$export$2e2bcd8739ae039 = (contextIdentifierPlugin)=>(dispatchAnalyticsEvent, inputTracking, browserFreezeTracking)=>{
        let interactionType;
        let inputLatencyTracker = null;
        if (browserFreezeTracking?.trackInteractionType) interactionType = (0, $btBeM.setInteractionType)((0, $8MfCL.BROWSER_FREEZE_INTERACTION_TYPE).LOADING);
        const samplingRate = inputTracking && typeof inputTracking.samplingRate === 'number' ? inputTracking.samplingRate : $8ee19c3da06fb608$var$DEFAULT_KEYSTROKE_SAMPLING_LIMIT;
        // TODO: ED-26959 - get right values here based on appearance
        const slowThreshold = $8ee19c3da06fb608$var$DEFAULT_SLOW_THRESHOLD;
        // TODO: ED-26959 - get right values here based on appearance
        const freezeThreshold = $8ee19c3da06fb608$export$c8d5b833abcf8e80;
        const allowCountNodes = inputTracking && inputTracking.countNodes;
        let prevNodeCountState = null;
        let prevNodeCount = {};
        // Cache the result as we were calling this multiple times
        // and has potential to be expensive
        const getNodeCount = (state)=>{
            if (state === prevNodeCountState) return prevNodeCount;
            prevNodeCount = allowCountNodes ? (0, $9I6lS.countNodes)(state) : {};
            prevNodeCountState = state;
            return prevNodeCount;
        };
        const shouldTrackSeverity = inputTracking?.trackSeverity || $8ee19c3da06fb608$var$DEFAULT_TRACK_SEVERITY_ENABLED;
        const severityThresholdNormal = inputTracking?.severityNormalThreshold || $8ee19c3da06fb608$export$5705ac5f923a65e7;
        const severityThresholdDegraded = inputTracking?.severityDegradedThreshold || $8ee19c3da06fb608$export$1c6feb3429832c55;
        const createDispatchSample = (action, view)=>(time, severity)=>{
                const { state: state } = view;
                const nodesCount = getNodeCount(state);
                const samplePayload = {
                    action: action,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
                    attributes: {
                        time: time,
                        nodeSize: state.doc.nodeSize,
                        ...nodesCount,
                        objectId: contextIdentifierPlugin?.sharedState.currentState()?.contextIdentifierProvider?.objectId,
                        severity: shouldTrackSeverity ? severity : undefined
                    },
                    eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
                };
                dispatchAnalyticsEvent(samplePayload);
            };
        const createDispatchAverage = (action, view)=>({ mean: mean, median: median, sampleSize: sampleSize }, severity)=>{
                const { state: state } = view;
                const nodeCount = getNodeCount(state);
                const averagePayload = {
                    action: action,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
                    attributes: {
                        mean: mean,
                        median: median,
                        sampleSize: sampleSize,
                        ...nodeCount,
                        nodeSize: state.doc.nodeSize,
                        severity: shouldTrackSeverity ? severity : undefined,
                        objectId: contextIdentifierPlugin?.sharedState.currentState()?.contextIdentifierProvider?.objectId
                    },
                    eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
                };
                dispatchAnalyticsEvent(averagePayload);
            };
        return new (0, $i8KtF.SafePlugin)({
            key: $8ee19c3da06fb608$export$70246689264eff75,
            props: (0, $8LHnV.isPerformanceAPIAvailable)() ? {
                handleTextInput (view) {
                    if (browserFreezeTracking?.trackInteractionType) interactionType = (0, $8MfCL.BROWSER_FREEZE_INTERACTION_TYPE).TYPING;
                    if (inputLatencyTracker) {
                        const end = inputLatencyTracker.start();
                        // This is called after all handleTextInput events are executed which means first handleTextInput time incorporates following handleTextInput processing time
                        // Also this is called before browser rendering so it doesn't count it.
                        requestAnimationFrame(end);
                    }
                    return false;
                },
                handleDOMEvents: browserFreezeTracking?.trackInteractionType ? {
                    click: ()=>{
                        interactionType = (0, $btBeM.setInteractionType)((0, $8MfCL.BROWSER_FREEZE_INTERACTION_TYPE).CLICKING);
                        return false;
                    },
                    paste: ()=>{
                        interactionType = (0, $btBeM.setInteractionType)((0, $8MfCL.BROWSER_FREEZE_INTERACTION_TYPE).PASTING);
                        return false;
                    }
                } : undefined
            } : undefined,
            view (view) {
                if (!(0, $8LHnV.isPerformanceObserverAvailable)()) return {};
                inputLatencyTracker = new (0, $lu3Zd.default)({
                    samplingRate: samplingRate,
                    slowThreshold: slowThreshold,
                    normalThreshold: severityThresholdNormal,
                    degradedThreshold: severityThresholdDegraded,
                    dispatchSample: createDispatchSample((0, $bMFKb.ACTION).INPUT_PERF_SAMPLING, view),
                    dispatchAverage: createDispatchAverage((0, $bMFKb.ACTION).INPUT_PERF_SAMPLING_AVG, view),
                    onSlowInput: (time)=>{
                        const { state: state } = view;
                        const nodesCount = getNodeCount(state);
                        dispatchAnalyticsEvent({
                            action: (0, $bMFKb.ACTION).SLOW_INPUT,
                            actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
                            attributes: {
                                time: time,
                                nodeSize: state.doc.nodeSize,
                                ...nodesCount,
                                objectId: contextIdentifierPlugin?.sharedState.currentState()?.contextIdentifierProvider?.objectId
                            },
                            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
                        });
                    }
                });
                let observer;
                try {
                    observer = new PerformanceObserver((list)=>{
                        const perfEntries = list.getEntries();
                        for(let i = 0; i < perfEntries.length; i++){
                            const { duration: duration } = perfEntries[i];
                            if (duration > freezeThreshold) $8ee19c3da06fb608$var$dispatchLongTaskEvent(contextIdentifierPlugin)(dispatchAnalyticsEvent, view, duration, getNodeCount, browserFreezeTracking?.trackInteractionType ? interactionType : undefined, (0, $dyNYh.getAnalyticsEventSeverity)(duration, // Ignored via go/ees007
                            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                            //TODO: get right values here
                            severityThresholdNormal, severityThresholdDegraded));
                        }
                    });
                    // register observer for long task notifications
                    observer.observe({
                        entryTypes: [
                            'longtask'
                        ]
                    });
                } catch (e) {}
                return {
                    destroy: ()=>{
                        inputLatencyTracker?.flush();
                        observer?.disconnect();
                    }
                };
            }
        });
    };

});
parcelRegister("9I6lS", function(module, exports) {
$parcel$export(module.exports, "countNodes", () => $518a979ea155355e$export$1daf15cbaf649dad);
function $518a979ea155355e$export$1daf15cbaf649dad(state) {
    const nodeCount = {};
    const extensionNodeCount = {};
    const nodeTypes = state.schema.nodes;
    const extensionNodeTypes = [
        nodeTypes.extension?.name,
        nodeTypes.inlineExtension?.name,
        nodeTypes.bodiedExtension?.name,
        nodeTypes.multiBodiedExtension?.name
    ];
    state.doc.descendants((node)=>{
        const nodeName = node.type.name;
        if (nodeName in nodeCount) nodeCount[nodeName]++;
        else nodeCount[nodeName] = 1;
        let extensionNodeName = nodeName;
        if (extensionNodeTypes.includes(extensionNodeName) && node.attrs?.extensionType) {
            extensionNodeName = `${node.attrs.extensionType} - ${node.attrs?.extensionKey}`;
            if (extensionNodeName in extensionNodeCount) extensionNodeCount[extensionNodeName]++;
            else extensionNodeCount[extensionNodeName] = 1;
        }
        return true;
    });
    return {
        nodeCount: nodeCount,
        extensionNodeCount: extensionNodeCount
    };
}

});

parcelRegister("btBeM", function(module, exports) {
$parcel$export(module.exports, "setInteractionType", () => $c78204369f8d32c0$export$324d9bc8f4935d84);
/** Allows the possibility of overriding interaction type values in unit tests via jest.mock or spyOn. */ const $c78204369f8d32c0$export$324d9bc8f4935d84 = (value)=>value;

});

parcelRegister("lu3Zd", function(module, exports) {
$parcel$export(module.exports, "default", () => $858fb2d2ea90605a$export$2e2bcd8739ae039);

var $dyNYh = parcelRequire("dyNYh");

var $cDfDI = parcelRequire("cDfDI");
class $858fb2d2ea90605a$export$2e2bcd8739ae039 {
    constructor({ samplingRate: samplingRate, slowThreshold: slowThreshold, normalThreshold: normalThreshold, degradedThreshold: degradedThreshold, dispatchAverage: dispatchAverage, dispatchSample: dispatchSample, onSampleStart: onSampleStart, onSampleEnd: onSampleEnd, onSlowInput: onSlowInput }){
        this.samples = [];
        this.total = 0;
        this.samplingRate = samplingRate;
        this.slowThreshold = slowThreshold;
        this.normalThreshold = normalThreshold;
        this.degradedThreshold = degradedThreshold;
        this.dispatchAverage = dispatchAverage;
        this.dispatchSample = dispatchSample;
        this.onSampleStart = onSampleStart;
        this.onSampleEnd = onSampleEnd;
        this.onSlowInput = onSlowInput;
    }
    start() {
        const currentStart = performance.now();
        if (this.samples.length + 1 === this.samplingRate) this.onSampleStart?.();
        const end = ()=>{
            if (currentStart === null) return;
            let isSlow = false;
            const time = (0, $cDfDI.getTimeSince)(currentStart);
            this.push(time);
            if (time > this.slowThreshold) {
                this.onSlowInput?.(time);
                isSlow = true;
            }
            if (this.samples.length === this.samplingRate) {
                this.flush();
                this.onSampleEnd?.(time, {
                    isSlow: isSlow,
                    severity: this.severity(time)
                });
            }
        };
        return end;
    }
    flush() {
        if (this.samples.length === 0) return;
        this.dispatch();
        this.samples = [];
        this.total = 0;
    }
    dispatch() {
        this.dispatchSample?.(this.getLast(), this.severity(this.getLast()));
        // cache
        const median = this.getMedian();
        this.dispatchAverage?.({
            mean: this.getMean(),
            median: median,
            sampleSize: this.samples.length
        }, this.severity(median));
    }
    push(latency) {
        this.samples.push(latency);
        this.total += latency;
    }
    severity(time) {
        return (0, $dyNYh.getAnalyticsEventSeverity)(time, this.normalThreshold, this.degradedThreshold);
    }
    getLast() {
        return this.samples[this.samples.length - 1];
    }
    getMean() {
        return this.total / this.samples.length;
    }
    getMedian() {
        if (this.samples.length === 1) return this.samples[0];
        this.samples.sort((a, b)=>a - b);
        const middle = (this.samples.length + 1) / 2;
        const floorMiddle = Math.floor(middle);
        const remainder = middle % floorMiddle;
        if (remainder === 0) return this.samples[middle - 1];
        const left = this.samples[floorMiddle - 1];
        const right = this.samples[floorMiddle];
        return (left + right) / 2;
    }
}

});
parcelRegister("cDfDI", function(module, exports) {
$parcel$export(module.exports, "getTimeSince", () => $4733a554f07dbbc9$export$a26b90db2c8f1b97);
/**
 * Calculate the difference between performance.now() and the given startTime.
 * This allows for the timing to be overridable during tests.
 *
 * @param startTime DOMHighResTimeStamp
 * @returns DOMHighResTimeStamp
 */ const $4733a554f07dbbc9$export$a26b90db2c8f1b97 = (startTime)=>performance.now() - startTime;

});



parcelRegister("hVrgn", function(module, exports) {
$parcel$export(module.exports, "default", () => $024d1731ff49b548$export$2e2bcd8739ae039);

var $7EdFW = parcelRequire("7EdFW");

var $i8KtF = parcelRequire("i8KtF");

var $5Z3Rm = parcelRequire("5Z3Rm");


var $3lIcL = parcelRequire("3lIcL");

var $b7EWj = parcelRequire("b7EWj");

var $cbSL1 = parcelRequire("cbSL1");
const $024d1731ff49b548$export$8836bfc6be4cb708 = new (0, $3lIcL.PluginKey)('inlineCursorTargetPlugin');
const $024d1731ff49b548$var$isInlineNodeView = (node)=>{
    /**
	 * If inlineNodeView is a hardbreak we don't want to add decorations
	 * as it breaks soft line breaks for Japanese/Chinese keyboards.
	 */ const isHardBreak = node?.type === node?.type.schema.nodes.hardBreak;
    return node && node.type.isInline && !node.type.isText && !isHardBreak;
};
var $024d1731ff49b548$export$2e2bcd8739ae039 = ()=>{
    return new (0, $i8KtF.SafePlugin)({
        key: $024d1731ff49b548$export$8836bfc6be4cb708,
        state: {
            init: ()=>({
                    cursorTarget: undefined
                }),
            apply (tr) {
                const { selection: selection, doc: doc } = tr;
                const { $from: $from, $to: $to } = selection;
                // In Safari, if the cursor target is to the right of the cursor it will block selections
                // made with shift + arrowRight and vice versa for shift + arrowLeft. This is due to a
                // contenteditable bug in safari, where editable elements block the selection but we need
                // the cursor target to be editable for the following:
                // - Ability to navigate with down/up arrows when between inline nodes
                // - Ability to navigate with down/up arrows when between the start of a paragraph & an inline node
                // - Ability to click and drag to select an inline node if it is the first node
                // To prevent blocking the selection, we check handleDOMEvents and add meta to
                // the transaction to prevent the plugin from making cursor target decorations.
                const safariShiftSelection = tr.getMeta($024d1731ff49b548$export$8836bfc6be4cb708);
                if (selection && (0, $5Z3Rm.isTextSelection)(selection) && !safariShiftSelection) {
                    const hasInlineNodeViewAfter = $024d1731ff49b548$var$isInlineNodeView($from.nodeAfter);
                    const hasInlineNodeViewBefore = $024d1731ff49b548$var$isInlineNodeView($from.nodeBefore);
                    const isAtStartAndInlineNodeViewAfter = $from.parentOffset === 0 && $024d1731ff49b548$var$isInlineNodeView($from.nodeAfter);
                    const isAtEndAndInlineNodeViewBefore = doc.resolve($from.pos).node().lastChild === $from.nodeBefore && $024d1731ff49b548$var$isInlineNodeView($from.nodeBefore);
                    const createWidget = (side)=>{
                        const node = document.createElement('span');
                        node.contentEditable = 'true';
                        node.setAttribute('aria-hidden', 'true');
                        node.appendChild(document.createTextNode((0, $f9e41f230eb38f84$export$15a09f5ef055bcfa)));
                        node.className = 'cursor-target';
                        const { $from: $from } = selection;
                        const rightPosition = $from.pos;
                        const leftPosition = $from.posAtIndex(Math.max($from.index() - 1, 0));
                        const widgetPos = side === 'left' ? leftPosition : rightPosition;
                        return (0, $b7EWj.Decoration).widget(widgetPos, node, {
                            raw: true,
                            key: 'inlineCursor'
                        });
                    };
                    // Create editable decoration widgets around the current inline node to allow proper cursor navigation.
                    if ((hasInlineNodeViewAfter || isAtEndAndInlineNodeViewBefore) && (hasInlineNodeViewBefore || isAtStartAndInlineNodeViewAfter)) return {
                        cursorTarget: {
                            decorations: [
                                createWidget('left'),
                                createWidget('right')
                            ],
                            positions: {
                                from: $from.pos,
                                to: $to.pos
                            }
                        }
                    };
                }
                return {
                    cursorTarget: undefined
                };
            }
        },
        props: {
            decorations (state) {
                const { doc: doc } = state;
                const { cursorTarget: cursorTarget } = $024d1731ff49b548$export$8836bfc6be4cb708.getState(state);
                if ($024d1731ff49b548$var$cursorTargetHasValidDecorations(cursorTarget)) return (0, $b7EWj.DecorationSet).create(doc, cursorTarget.decorations);
                return null;
            },
            handleDOMEvents: {
                // Workaround to prevent the decorations created by the plugin from
                // blocking shift + arrow left/right selections in safari. When
                // a shift + arrow left/right event is detected, send meta data to the
                // plugin to prevent it from creating decorations.
                // TODO: ED-26959 - We may be able to remove this when playing the following ticket:
                // https://product-fabric.atlassian.net/browse/ED-14938
                keydown: (view, event)=>{
                    const browser = (0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $7EdFW.getBrowserInfo)() : (0, $7EdFW.browser);
                    if (browser.safari && event instanceof KeyboardEvent && event.shiftKey && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) view.dispatch(view.state.tr.setMeta($024d1731ff49b548$export$8836bfc6be4cb708, {
                        cursorTarget: undefined
                    }));
                    return false;
                },
                // Check the DOM to see if there are inline cursor targets
                // after a composition event ends. If so, manually insert the
                // event data in order to prevent contents ending up inside
                // of the cursor target decorations.
                compositionend: (view, incorrectlyTypedEvent)=>{
                    // This is typed by the prosemirror definitions as Event,
                    // this type is incorrect, and it is actually an InputEvent
                    const event = incorrectlyTypedEvent;
                    const { state: state } = view;
                    const { cursorTarget: cursorTarget } = $024d1731ff49b548$export$8836bfc6be4cb708.getState(state);
                    if (cursorTarget !== undefined) {
                        $024d1731ff49b548$var$handleTextInputInsideCursorTargetDecoration({
                            event: event,
                            cursorTarget: cursorTarget,
                            view: view
                        });
                        return true;
                    }
                    return false;
                },
                // Check the DOM to see if there are inline cursor targets
                // before any input event. If so, manually insert the
                // event data in order to prevent contents ending up inside
                // of the cursor target decorations.
                beforeinput: (view, incorrectlyTypedEvent)=>{
                    // This is typed by the prosemirror definitions as Event,
                    // this type is incorrect, and it is actually an InputEvent
                    const event = incorrectlyTypedEvent;
                    const { state: state } = view;
                    const { cursorTarget: cursorTarget } = $024d1731ff49b548$export$8836bfc6be4cb708.getState(state);
                    if (!event.isComposing && cursorTarget !== undefined) {
                        $024d1731ff49b548$var$handleTextInputInsideCursorTargetDecoration({
                            event: event,
                            cursorTarget: cursorTarget,
                            view: view
                        });
                        return true;
                    }
                    return false;
                }
            }
        }
    });
};
function $024d1731ff49b548$var$cursorTargetHasValidDecorations(cursorTarget) {
    if (!cursorTarget || // Decorations can end up as null when the decorations prop is
    // called after the decorations have been removed from the dom.
    // https://github.com/ProseMirror/prosemirror-view/blob/8f0d313a6389b86a335274fba36534ba1cb21f12/src/decoration.js#L30
    cursorTarget.decorations.includes(null)) return false;
    return true;
}
function $024d1731ff49b548$var$handleTextInputInsideCursorTargetDecoration({ event: event, view: view, cursorTarget: cursorTarget }) {
    event.stopPropagation();
    event.preventDefault();
    const content = event.data || '';
    const tr = view.state.tr;
    // ensure any custom handleTextInput handlers are called for the input event
    // ie. type ahead, emoji shortcuts.
    const potentiallyHandleByHandleTextInput = view.someProp('handleTextInput', (f)=>f(view, cursorTarget.positions.from, cursorTarget.positions.to, content));
    if (potentiallyHandleByHandleTextInput) // if a handleTextInput handler has handled the event, we don't want to
    // manually update the document.
    return;
    tr.insertText(content);
    view.dispatch(tr);
}

});
const $f9e41f230eb38f84$export$15a09f5ef055bcfa = '\u200b';
const $f9e41f230eb38f84$export$2b4d00c13dcd3c1f = '\u200d';


parcelRegister("iUuxx", function(module, exports) {
$parcel$export(module.exports, "createLazyNodeViewDecorationPlugin", () => $d62dcf470f78e135$export$650082547b31be68);

var $hkA3A = parcelRequire("hkA3A");

var $i8KtF = parcelRequire("i8KtF");

var $b7EWj = parcelRequire("b7EWj");
const $d62dcf470f78e135$var$LAZY_NODE_VIEW_DECORATION_CLASS = '__lazy-node-view-decoration__';
function $d62dcf470f78e135$export$650082547b31be68() {
    return new (0, $i8KtF.SafePlugin)({
        key: (0, $hkA3A.lazyNodeViewDecorationPluginKey),
        state: {
            init: ()=>{
                return {
                    decorations: (0, $b7EWj.DecorationSet).empty,
                    nodeTypes: []
                };
            },
            apply (tr, _oldState, newState) {
                const actionPayload = tr.getMeta((0, $hkA3A.lazyNodeViewDecorationPluginKey));
                const pluginState = (0, $hkA3A.lazyNodeViewDecorationPluginKey).getState(newState);
                if (actionPayload?.type === 'add' && actionPayload.nodeTypes.size) {
                    const decorations = [];
                    tr.doc.nodesBetween(0, tr.doc.nodeSize - 2, (node, pos)=>{
                        if (actionPayload.nodeTypes.has(node.type.name)) decorations.push((0, $b7EWj.Decoration).node(pos, pos + node.nodeSize, {
                            class: $d62dcf470f78e135$var$LAZY_NODE_VIEW_DECORATION_CLASS
                        }));
                    });
                    return {
                        decorations: (0, $b7EWj.DecorationSet).create(tr.doc, decorations)
                    };
                }
                if (actionPayload?.type === 'clear') return {
                    decorations: (0, $b7EWj.DecorationSet).empty
                };
                if (tr.docChanged) return {
                    decorations: pluginState?.decorations.map(tr.mapping, tr.doc)
                };
                return pluginState;
            }
        },
        props: {
            decorations: (state)=>{
                return (0, $hkA3A.lazyNodeViewDecorationPluginKey).getState(state)?.decorations;
            }
        },
        view (editorView) {
            return {
                update () {
                    /**
					 * After view update can clean up decorations...
					 */ const pluginState = (0, $hkA3A.lazyNodeViewDecorationPluginKey).getState(editorView.state);
                    if (pluginState.decorations !== (0, $b7EWj.DecorationSet).empty) {
                        const tr = editorView.state.tr;
                        tr.setMeta((0, $hkA3A.lazyNodeViewDecorationPluginKey), {
                            type: 'clear'
                        });
                        editorView.dispatch(tr);
                    }
                }
            };
        }
    });
}

});
parcelRegister("hkA3A", function(module, exports) {
$parcel$export(module.exports, "lazyNodeViewDecorationPluginKey", () => $e3e8f14f61febe2b$export$325659f41b2239a7);
$parcel$export(module.exports, "withLazyLoading", () => $e3e8f14f61febe2b$export$6b97b121e15a69b7);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $3lIcL = parcelRequire("3lIcL");

var $lk39V = parcelRequire("lk39V");

var $b08BT = parcelRequire("b08BT");

var $6D3CR = parcelRequire("6D3CR");
const $e3e8f14f61febe2b$export$325659f41b2239a7 = new (0, $3lIcL.PluginKey)('lazyNodeViewDecoration');
/**
 * 🧱 Internal: Editor FE Platform
 *
 * Controls which node was scheduled to load the original node view code
 */ const $e3e8f14f61febe2b$var$requestedNodesPerEditorView = new WeakMap();
/**
 * 🧱 Internal: Editor FE Platform
 *
 * Caches loaded node view factory functions for each editor view
 */ const $e3e8f14f61febe2b$var$resolvedNodesPerEditorView = new WeakMap();
/**
 * 🧱 Internal: Editor FE Platform
 *
 * Stores editorView -> raf to debounce NodeView updates.
 */ const $e3e8f14f61febe2b$var$debounceToEditorViewMap = new WeakMap();
const $e3e8f14f61febe2b$var$testOnlyIgnoreLazyNodeViewSet = new WeakSet();
function $e3e8f14f61febe2b$export$6c7e823c919edf69(view) {
    $e3e8f14f61febe2b$var$testOnlyIgnoreLazyNodeViewSet.add(view);
}
const $e3e8f14f61febe2b$export$6b97b121e15a69b7 = ({ nodeName: nodeName, loader: loader, getNodeViewOptions: getNodeViewOptions })=>{
    return (node, view, getPos, decorations, innerDecorations)=>{
        let requestedNodes = $e3e8f14f61febe2b$var$requestedNodesPerEditorView.get(view);
        if (!requestedNodes) {
            requestedNodes = new Map();
            $e3e8f14f61febe2b$var$requestedNodesPerEditorView.set(view, requestedNodes);
        }
        const resolvedNodeViews = $e3e8f14f61febe2b$var$resolvedNodesPerEditorView.get(view);
        if (!resolvedNodeViews) $e3e8f14f61febe2b$var$resolvedNodesPerEditorView.set(view, new Map());
        const wasAlreadyRequested = requestedNodes.has(nodeName);
        if (wasAlreadyRequested) {
            const resolvedNodeView = resolvedNodeViews?.get(nodeName);
            if (resolvedNodeView && !$e3e8f14f61febe2b$var$testOnlyIgnoreLazyNodeViewSet.has(view)) return resolvedNodeView(node, view, getPos, decorations, innerDecorations);
            return new (0, $b08BT.LazyNodeView)(node, view, getPos, decorations);
        }
        const loaderPromise = loader().then((nodeViewFuncModule)=>{
            const nodeViewFunc = (node, view, getPos, decorations, innerDecorations)=>{
                const nodeView = nodeViewFuncModule(node, view, getPos, decorations, getNodeViewOptions, innerDecorations);
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = nodeView.dom;
                dom.setAttribute('data-vc', `editor-lnv-loaded--${node.type.name}`);
                const pos = getPos();
                if (pos !== undefined) dom.setAttribute('data-editor-lnv-placeholder-replace', (0, $b08BT.makeNodePlaceholderId)(node.type.name, pos));
                return nodeView;
            };
            $e3e8f14f61febe2b$var$resolvedNodesPerEditorView.get(view)?.set(nodeName, nodeViewFunc);
            /**
			 * Triggering lazyNodeViewDecoration plugin to apply decorations
			 * to nodes with newly loaded NodeViews.
			 */ const [callbackId, nodeTypes] = $e3e8f14f61febe2b$var$debounceToEditorViewMap.get(view) || [
                null,
                new Set()
            ];
            if (callbackId) (0, $lk39V.cancelCallback)(callbackId);
            nodeTypes.add(node.type.name);
            const nextCallbackId = (0, $lk39V.scheduleCallback)(()=>{
                $e3e8f14f61febe2b$var$debounceToEditorViewMap.set(view, [
                    null,
                    new Set()
                ]);
                const tr = view.state.tr;
                tr.setMeta($e3e8f14f61febe2b$export$325659f41b2239a7, {
                    type: 'add',
                    nodeTypes: nodeTypes
                });
                view.dispatch(tr);
            });
            $e3e8f14f61febe2b$var$debounceToEditorViewMap.set(view, [
                nextCallbackId,
                nodeTypes
            ]);
            /**
			 * END triggering LazyNodeViewDecoration plugin
			 */ return nodeViewFunc;
        });
        requestedNodes.set(nodeName, loaderPromise);
        typeof node.type?.spec?.toDOM;
        return new (0, $b08BT.LazyNodeView)(node, view, getPos, decorations);
    };
};

});
parcelRegister("lk39V", function(module, exports) {
$parcel$export(module.exports, "scheduleCallback", () => $8c4668674839fdc0$export$4db3c991f22dbc2d);
$parcel$export(module.exports, "cancelCallback", () => $8c4668674839fdc0$export$b888d8f981c07a46);
const $8c4668674839fdc0$var$hasIdleCallback = 'requestIdleCallback' in window;
const $8c4668674839fdc0$export$4db3c991f22dbc2d = (cb, options)=>{
    return $8c4668674839fdc0$var$hasIdleCallback ? requestIdleCallback(cb, {
        timeout: 5000,
        ...options
    }) : requestAnimationFrame(cb);
};
const $8c4668674839fdc0$export$b888d8f981c07a46 = (id)=>{
    return $8c4668674839fdc0$var$hasIdleCallback ? cancelIdleCallback(id) : cancelAnimationFrame(id);
};

});

parcelRegister("b08BT", function(module, exports) {
$parcel$export(module.exports, "makeNodePlaceholderId", () => $b549a2854d6f21a9$export$f306d9dd555af398);
$parcel$export(module.exports, "LazyNodeView", () => $b549a2854d6f21a9$export$dccb00b9da782c66);

var $5PQOA = parcelRequire("5PQOA");

var $3xw6l = parcelRequire("3xw6l");
const $b549a2854d6f21a9$var$getEditorLineWidth = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))((view)=>{
    return view.dom?.clientWidth;
});
// Copied from ProseMirror NodeView
// https://github.com/ProseMirror/prosemirror-view/blob/cfa73eb969777f63bcb39972594fd4a9110f5a93/src/viewdesc.ts#L1095-L1099
function $b549a2854d6f21a9$var$sameOuterDeco(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        // @ts-expect-error type actually exist on decoration at runtime
        if (!a[i].type) return false;
        // @ts-expect-error type actually exist on decoration at runtime
        if (!a[i].type.eq(b[i].type)) return false;
    }
    return true;
}
function $b549a2854d6f21a9$export$f306d9dd555af398(nodeType, pos) {
    return `${nodeType}:${pos}`;
}
class $b549a2854d6f21a9$export$dccb00b9da782c66 {
    constructor(node, view, _getPos, outerDeco){
        this.update = (node, outerDeco)=>{
            const prevNode = this.node;
            this.node = node;
            if (!$b549a2854d6f21a9$var$sameOuterDeco(outerDeco, this.outerDeco)) return false;
            // Copying some of the default NodeView update behaviour
            // https://github.com/ProseMirror/prosemirror-view/blob/cfa73eb969777f63bcb39972594fd4a9110f5a93/src/viewdesc.ts#L803
            return !this.node.sameMarkup(prevNode);
        };
        this.node = node;
        this.outerDeco = outerDeco;
        if (typeof node.type?.spec?.toDOM !== 'function') {
            this.dom = document.createElement('div');
            return;
        }
        const toDOMConfiguration = {
            editorLineWidth: $b549a2854d6f21a9$var$getEditorLineWidth(view)
        };
        const fallback = (0, $3xw6l.DOMSerializer).renderSpec(document, node.type.spec.toDOM(node, // We are injecting a second parameter to be used by the toDOM lazy node view implementations
        // @ts-expect-error
        toDOMConfiguration));
        this.dom = fallback.dom;
        this.contentDOM = fallback.contentDOM;
        if (this.dom instanceof HTMLElement) {
            // This attribute is mostly used for debugging purposed
            // It will help us to found out when the node was replaced
            this.dom.setAttribute('data-lazy-node-view', node.type.name);
            // This is used on Libra tests
            // We are using this to make sure all lazy noded were replaced
            // before the test started
            this.dom.setAttribute('data-lazy-node-view-fallback', 'true');
            // This is used by the UFO to identify the node
            this.dom.setAttribute('data-vc', `editor-lnv-fallback--${node.type.name}`);
            const pos = _getPos();
            if (pos !== undefined) // Used for UFO to identify this as a placeholder
            this.dom.setAttribute('data-editor-lnv-placeholder', $b549a2854d6f21a9$export$f306d9dd555af398(node.type.name, pos));
        }
    }
    ignoreMutation() {
        if (this.node.type.isTextblock) return false;
        return true;
    }
}

});

parcelRegister("6D3CR", function(module, exports) {
$parcel$export(module.exports, "convertToInlineCss", () => $7b699afabc4d5eec$export$7da93c9174ab9340);
/**
 * Converts a camelCased CSS property name to a hyphenated CSS property name.
 *
 * @param property - CamelCased CSS property name.
 * @returns Hyphenated CSS property name.
 */ function $7b699afabc4d5eec$var$hyphenate(property) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return property.replace(/[A-Z]/g, (match)=>`-${match.toLowerCase()}`).replace(/^ms/, '-ms');
}
function $7b699afabc4d5eec$export$7da93c9174ab9340(properties) {
    const cssString = Object.entries(properties).sort(([a], [b])=>a.localeCompare(b)).map(([property, value])=>`${property.startsWith('--') ? property : $7b699afabc4d5eec$var$hyphenate(property)}: ${value};`).join(' ');
    return cssString;
}

});



parcelRegister("8hwRf", function(module, exports) {
$parcel$export(module.exports, "default", () => $66790e82e4c518d3$export$2e2bcd8739ae039);

var $i8KtF = parcelRequire("i8KtF");

var $HOLTj = parcelRequire("HOLTj");
var $bnAxN = parcelRequire("bnAxN");

var $x7sgX = parcelRequire("x7sgX");

var $3lIcL = parcelRequire("3lIcL");
const $66790e82e4c518d3$export$2f489388b18569dd = new (0, $3lIcL.PluginKey)('newlinePreserveMarksPlugin');
const $66790e82e4c518d3$var$isSelectionAligned = (state)=>!!state.selection.$to.parent.marks.find((m)=>m.type === state.schema.marks.alignment);
const $66790e82e4c518d3$var$splitBlockPreservingMarks = (state, dispatch)=>{
    if (dispatch) dispatch(state.tr.split(state.tr.mapping.map(state.selection.$from.pos), 1));
    return true;
};
var $66790e82e4c518d3$export$2e2bcd8739ae039 = ()=>new (0, $i8KtF.SafePlugin)({
        key: $66790e82e4c518d3$export$2f489388b18569dd,
        props: {
            handleKeyDown: (0, $x7sgX.keydownHandler)({
                Enter: (0, $HOLTj.filterCommand)([
                    (0, $bnAxN.isSelectionEndOfParagraph),
                    $66790e82e4c518d3$var$isSelectionAligned
                ], $66790e82e4c518d3$var$splitBlockPreservingMarks)
            })
        }
    });

});

parcelRegister("2frjn", function(module, exports) {
$parcel$export(module.exports, "default", () => $a8dc9c9763c1aa4b$export$2e2bcd8739ae039);

var $i8KtF = parcelRequire("i8KtF");

var $g6YpQ = parcelRequire("g6YpQ");

var $9P93m = parcelRequire("9P93m");
const $a8dc9c9763c1aa4b$var$GUTTER_SIZE_IN_PX = 120;
const $a8dc9c9763c1aa4b$var$GUTTER_SELECTOR_NAME = 'editor-scroll-gutter';
/**
 * Create a gutter element that can be added or removed from the DOM.
 */ function $a8dc9c9763c1aa4b$var$createGutter(gutterSize, parent) {
    if ((0, $g6YpQ.expVal)('platform_editor_hydratable_ui', 'isEnabled', false)) {
        const gutterRef = document.getElementById($a8dc9c9763c1aa4b$var$GUTTER_SELECTOR_NAME);
        if (gutterRef) {
            gutterRef.style.paddingBottom = `${gutterSize}px`;
            gutterRef.style.display = 'block';
            return ()=>parent?.removeChild(gutterRef);
        }
    }
    const gutter = document.createElement('div');
    gutter.style.paddingBottom = `${gutterSize}px`;
    gutter.setAttribute('data-vc', 'scroll-gutter');
    gutter.id = $a8dc9c9763c1aa4b$var$GUTTER_SELECTOR_NAME;
    if (parent) parent.appendChild(gutter);
    return ()=>parent?.removeChild(gutter);
}
var $a8dc9c9763c1aa4b$export$2e2bcd8739ae039 = (pluginOptions = {})=>{
    const { getScrollElement: getScrollElement, gutterSize: gutterSize = $a8dc9c9763c1aa4b$var$GUTTER_SIZE_IN_PX } = pluginOptions;
    if (!getScrollElement) return undefined;
    return new (0, $i8KtF.SafePlugin)({
        key: (0, $9P93m.scrollGutterPluginKey),
        state: {
            init: ()=>({}),
            apply: (tr, pluginState)=>{
                if (tr.getMeta((0, $9P93m.scrollGutterPluginKey))) return tr.getMeta((0, $9P93m.scrollGutterPluginKey));
                return pluginState;
            }
        },
        props: {
            // Determines the distance (in pixels) between the cursor and the end of the visible viewport at which point,
            // when scrolling the cursor into view, scrolling takes place.
            // Defaults to 0: https://prosemirror.net/docs/ref/#view.EditorProps.scrollThreshold
            scrollThreshold: gutterSize,
            // Determines the extra space (in pixels) that is left above or below the cursor when it is scrolled into view.
            // Defaults to 5: https://prosemirror.net/docs/ref/#view.EditorProps.scrollMargin
            scrollMargin: gutterSize
        },
        view (view) {
            // Store references to avoid lookups on successive checks.
            const scrollElement = getScrollElement(view);
            let editorElement = view.dom instanceof HTMLElement ? view.dom : null;
            let editorParentElement = editorElement?.parentElement;
            let cleanup = ()=>{};
            if (editorParentElement && scrollElement) cleanup = $a8dc9c9763c1aa4b$var$createGutter(gutterSize, editorParentElement);
            return {
                destroy () {
                    cleanup();
                    editorParentElement = editorElement = null;
                }
            };
        }
    });
};

});

parcelRegister("02sTQ", function(module, exports) {
$parcel$export(module.exports, "getKeyboardHeight", () => $8a5f047a5d73bb75$export$af5702f0c69bf4d7);

var $9P93m = parcelRequire("9P93m");
const $8a5f047a5d73bb75$export$af5702f0c69bf4d7 = (state)=>{
    if (state) {
        const scrollGutterPluginState = (0, $9P93m.getScrollGutterPluginState)(state);
        return scrollGutterPluginState ? scrollGutterPluginState.keyboardHeight : undefined;
    }
};

});

parcelRegister("htlTO", function(module, exports) {
$parcel$export(module.exports, "inputTracking", () => $70fbb96fe8b566ba$export$30b652f8daa79df4);
const $70fbb96fe8b566ba$export$30b652f8daa79df4 = {
    enabled: true,
    samplingRate: 100,
    countNodes: true,
    trackSeverity: true,
    trackRenderingTime: false,
    trackSingleKeypress: false,
    // TODO: ED-26959 - change this based on appearance due to SLOs - need to make ticket for both
    severityDegradedThreshold: 273,
    severityNormalThreshold: 143
};

});



parcelRegister("1MKcc", function(module, exports) {
$parcel$export(module.exports, "betterTypeHistoryPlugin", () => (parcelRequire("9J26c")).betterTypeHistoryPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $9J26c = parcelRequire("9J26c");

});
parcelRegister("9J26c", function(module, exports) {
$parcel$export(module.exports, "betterTypeHistoryPlugin", () => $3741766cd8ae5dd8$export$5587393ddd97118a);

var $8b80W = parcelRequire("8b80W");

var $9KHhg = parcelRequire("9KHhg");
/**
 * This plugin is aiming to improve undo behaviour for some of our more custom applications, very specific text
 * paste events, splitting blocks of text, new lines.
 */ const $3741766cd8ae5dd8$export$5587393ddd97118a = ()=>{
    return {
        name: 'betterTypeHistory',
        actions: {
            flagPasteEvent (tr) {
                tr.setMeta((0, $9KHhg.pluginKey), true);
                return tr;
            }
        },
        pmPlugins () {
            return [
                {
                    name: 'betterTypeHistory',
                    plugin: ()=>(0, $8b80W.default)()
                }
            ];
        }
    };
};

});
parcelRegister("8b80W", function(module, exports) {
$parcel$export(module.exports, "default", () => $a52700030bf22dfd$export$2e2bcd8739ae039);

var $i8KtF = parcelRequire("i8KtF");

var $5Z3Rm = parcelRequire("5Z3Rm");

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $lzEKq = parcelRequire("lzEKq");

var $apqw1 = parcelRequire("apqw1");

var $9KHhg = parcelRequire("9KHhg");
const $a52700030bf22dfd$var$getEnterKeyboardActionStep = (trs)=>{
    const firstTr = trs.length === 1 && trs[0];
    if (!firstTr || !firstTr.docChanged || !firstTr.isGeneric || !(firstTr.selection instanceof (0, $3lIcL.TextSelection))) return null;
    const { selection: selection, steps: steps } = firstTr;
    const replaceSteps = steps.filter((step)=>step instanceof (0, $lzEKq.ReplaceStep) || step instanceof (0, $lzEKq.ReplaceAroundStep));
    if (!selection.$cursor || replaceSteps.length !== 1) return null;
    return replaceSteps[0];
};
const $a52700030bf22dfd$var$isSliceSplittingBlockNode = (slice)=>{
    const hasOnlyTwoChildren = slice.size > 1 && slice.content.childCount === 2;
    if (!hasOnlyTwoChildren) return false;
    const firstNode = slice.content.child(0);
    const secondNode = slice.content.child(1);
    return firstNode && secondNode && firstNode.type === secondNode.type;
};
const $a52700030bf22dfd$var$isSliceAddingNewlineChar = (slice, schema)=>{
    const newLine = (0, $3xw6l.Fragment).from(schema.text('\n'));
    return slice.content.eq(newLine);
};
var $a52700030bf22dfd$export$2e2bcd8739ae039 = ()=>{
    return new (0, $i8KtF.SafePlugin)({
        key: (0, $9KHhg.pluginKey),
        appendTransaction: (transactions, oldState, newState)=>{
            const hasHandlePasteMeta = transactions.find((tran)=>tran.getMeta((0, $9KHhg.pluginKey)));
            if (hasHandlePasteMeta) return (0, $apqw1.closeHistory)(newState.tr);
            const enterStep = $a52700030bf22dfd$var$getEnterKeyboardActionStep(transactions);
            if (!enterStep) return;
            const slice = (0, $5Z3Rm.extractSliceFromStep)(enterStep);
            const { schema: schema } = newState;
            if (slice && ($a52700030bf22dfd$var$isSliceSplittingBlockNode(slice) || $a52700030bf22dfd$var$isSliceAddingNewlineChar(slice, schema))) return (0, $apqw1.closeHistory)(newState.tr);
        }
    });
};

});
parcelRegister("9KHhg", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $a682887866156705$export$18d4026d1ea86bb1);

var $3lIcL = parcelRequire("3lIcL");
const $a682887866156705$export$18d4026d1ea86bb1 = new (0, $3lIcL.PluginKey)('betterTypeHistoryPlugin');

});




parcelRegister("ad5Kp", function(module, exports) {
$parcel$export(module.exports, "blockTypePlugin", () => (parcelRequire("1sH6J")).blockTypePlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $1sH6J = parcelRequire("1sH6J");

});
parcelRegister("1sH6J", function(module, exports) {
$parcel$export(module.exports, "blockTypePlugin", () => $c6d92e3bfd5c2d84$export$896c3d927d705025);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $iBSvH = parcelRequire("iBSvH");
var $ewUmv = parcelRequire("ewUmv");
var $8FGKL = parcelRequire("8FGKL");

var $bMFKb = parcelRequire("bMFKb");

var $c9NXO = parcelRequire("c9NXO");
var $6Exgk = parcelRequire("6Exgk");

var $TgnAJ = parcelRequire("TgnAJ");

var $c1NDo = parcelRequire("c1NDo");

var $aBsWC = parcelRequire("aBsWC");

var $eGOwo = parcelRequire("eGOwo");

var $9Letn = parcelRequire("9Letn");

var $92xoS = parcelRequire("92xoS");

var $aGH6G = parcelRequire("aGH6G");

var $lnss2 = parcelRequire("lnss2");

var $5P4L6 = parcelRequire("5P4L6");

var $8wIsi = parcelRequire("8wIsi");

var $beO9L = parcelRequire("beO9L");

var $jfXjJ = parcelRequire("jfXjJ");

var $g83Eb = parcelRequire("g83Eb");

var $f1SCK = parcelRequire("f1SCK");
const $c6d92e3bfd5c2d84$var$headingPluginOptions = ({ formatMessage: formatMessage }, isAllowed, editorAnalyticsApi)=>{
    if (!isAllowed) return [];
    return Array.from({
        length: 6
    }, (_v, idx)=>{
        const level = idx + 1;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const descriptionDescriptor = (0, $TgnAJ.messages)[`heading${level}Description`];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const keyshortcut = (0, $6Exgk.tooltip)((0, $c9NXO.keymap)[`toggleHeading${level}`]);
        const id = `heading${level}`;
        return {
            id: id,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            title: formatMessage((0, $TgnAJ.messages)[id]),
            description: formatMessage(descriptionDescriptor),
            priority: 1300,
            keywords: [
                `h${level}`
            ],
            keyshortcut: keyshortcut,
            icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $c1NDo.IconHeading), {
                    level: level
                }),
            action (insert, state) {
                const tr = insert(state.schema.nodes.heading.createChecked({
                    level: level
                }));
                editorAnalyticsApi?.attachAnalyticsEvent({
                    action: (0, $bMFKb.ACTION).FORMATTED,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
                    eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                    actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_HEADING,
                    attributes: {
                        inputMethod: (0, $bMFKb.INPUT_METHOD).QUICK_INSERT,
                        newHeadingLevel: level
                    }
                })(tr);
                return tr;
            }
        };
    });
};
const $c6d92e3bfd5c2d84$var$blockquotePluginOptions = ({ formatMessage: formatMessage }, isAllowed, editorAnalyticsApi)=>{
    if (!isAllowed) return [];
    return [
        {
            id: 'blockquote',
            title: formatMessage((0, $TgnAJ.messages).blockquote),
            description: formatMessage((0, $TgnAJ.messages).blockquoteDescription),
            priority: 1300,
            keyshortcut: '>',
            icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $c1NDo.IconQuote), {}),
            action (insert, state) {
                const tr = insert(state.schema.nodes.blockquote.createChecked({}, state.schema.nodes.paragraph.createChecked()));
                editorAnalyticsApi?.attachAnalyticsEvent({
                    action: (0, $bMFKb.ACTION).FORMATTED,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
                    eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                    actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
                    attributes: {
                        inputMethod: (0, $bMFKb.INPUT_METHOD).QUICK_INSERT
                    }
                })(tr);
                return tr;
            }
        }
    ];
};
const $c6d92e3bfd5c2d84$export$896c3d927d705025 = ({ config: options, api: api })=>{
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const primaryToolbarComponent = ({ popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing })=>{
        let isSmall = options && options.isUndoRedoButtonsEnabled ? toolbarSize < (0, $aBsWC.ToolbarSize).XXL : toolbarSize < (0, $aBsWC.ToolbarSize).XL;
        if ((0, $eGOwo.fg)('platform_editor_toolbar_responsive_fixes')) isSmall = toolbarSize < (0, $aBsWC.ToolbarSize).XXL;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jfXjJ.PrimaryToolbarComponent), {
            isSmall: isSmall,
            disabled: disabled,
            isToolbarReducedSpacing: isToolbarReducedSpacing,
            api: api,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            shouldUseDefaultRole: false
        });
    };
    if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $g83Eb.getToolbarComponents)(api));
    else api?.primaryToolbar?.actions.registerComponent({
        name: 'blockType',
        component: primaryToolbarComponent
    });
    if ((0, $9Letn.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true)) api?.blockMenu?.actions.registerBlockMenuComponents((0, $f1SCK.getBlockTypeComponents)(api));
    return {
        name: 'blockType',
        nodes () {
            const nodes = [
                {
                    name: 'heading',
                    node: (0, $8FGKL.heading)
                },
                {
                    name: 'blockquote',
                    node: (0, $eGOwo.fg)('platform_editor_adf_with_localid') ? (0, $iBSvH.extendedBlockquoteWithLocalId) : (0, $iBSvH.extendedBlockquote)
                },
                {
                    name: 'hardBreak',
                    node: (0, $ewUmv.hardBreak)
                }
            ];
            if (options && options.allowBlockType) {
                const exclude = options.allowBlockType.exclude ? options.allowBlockType.exclude : [];
                return nodes.filter((node)=>exclude.indexOf(node.name) === -1);
            }
            return nodes;
        },
        pmPlugins () {
            return [
                {
                    name: 'blockType',
                    plugin: ({ dispatch: dispatch })=>(0, $8wIsi.createPlugin)(api, dispatch, options && options.lastNodeMustBeParagraph, options?.includeBlockQuoteAsTextstyleOption)
                },
                {
                    name: 'blockTypeInputRule',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, $lnss2.default)(api?.analytics?.actions, schema, featureFlags)
                },
                // Needs to be lower priority than editor-tables.tableEditing
                // plugin as it is currently swallowing right/down arrow events inside tables
                {
                    name: 'blockTypeKeyMap',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, $5P4L6.default)(api?.analytics?.actions, schema, featureFlags)
                }
            ];
        },
        actions: {
            insertBlockQuote (inputMethod) {
                return (0, $aGH6G.insertBlockQuoteWithAnalytics)(inputMethod, api?.analytics?.actions);
            }
        },
        commands: {
            setTextLevel (level, inputMethod, fromBlockQuote = false) {
                return (0, $aGH6G.setBlockTypeWithAnalytics)(level, inputMethod, api?.analytics?.actions, fromBlockQuote);
            },
            insertBlockQuote (inputMethod) {
                return (0, $aGH6G.insertBlockQuoteWithAnalyticsCommand)(inputMethod, api?.analytics?.actions);
            },
            clearFormatting (inputMethod) {
                return (0, $aGH6G.clearFormatting)(inputMethod, api?.analytics?.actions);
            }
        },
        getSharedState (editorState) {
            if (!editorState) return;
            return (0, $8wIsi.pluginKey).getState(editorState);
        },
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined,
        pluginsOptions: {
            ...!isToolbarAIFCEnabled && {
                selectionToolbar: ()=>{
                    const toolbarDocking = (0, $eGOwo.fg)('platform_editor_use_preferences_plugin') ? api?.userPreferences?.sharedState.currentState()?.preferences?.toolbarDockingPosition : api?.selectionToolbar?.sharedState?.currentState()?.toolbarDocking;
                    if (toolbarDocking === 'none' && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1', {
                        exposure: true
                    })) {
                        const toolbarCustom = {
                            type: 'custom',
                            render: (view, _idx, _dispatchAnalyticsEvent)=>{
                                if (!view) return;
                                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $beO9L.FloatingToolbarComponent), {
                                    api: api
                                });
                            },
                            fallback: []
                        };
                        return {
                            isToolbarAbove: true,
                            items: [
                                toolbarCustom
                            ],
                            rank: 8
                        };
                    } else return undefined;
                }
            },
            ...(0, $92xoS.editorExperiment)('platform_editor_insertion', 'control') && {
                quickInsert: (intl)=>{
                    const exclude = options && options.allowBlockType && options.allowBlockType.exclude ? options.allowBlockType.exclude : [];
                    return [
                        ...$c6d92e3bfd5c2d84$var$blockquotePluginOptions(intl, exclude.indexOf('blockquote') === -1, api?.analytics?.actions),
                        ...$c6d92e3bfd5c2d84$var$headingPluginOptions(intl, exclude.indexOf('heading') === -1, api?.analytics?.actions)
                    ];
                }
            }
        }
    };
};

});
parcelRegister("aGH6G", function(module, exports) {
$parcel$export(module.exports, "setBlockTypeWithAnalytics", () => $be8553735b2be0a0$export$3f9af78ebb95cc20);
$parcel$export(module.exports, "setNormalTextWithAnalytics", () => $be8553735b2be0a0$export$283e32d0388e302a);
$parcel$export(module.exports, "setHeadingWithAnalytics", () => $be8553735b2be0a0$export$52d74b15bd103d7f);
$parcel$export(module.exports, "clearFormatting", () => $be8553735b2be0a0$export$195de5d8e201efd7);
$parcel$export(module.exports, "insertBlockQuoteWithAnalytics", () => $be8553735b2be0a0$export$50b4331f407b3ab6);
$parcel$export(module.exports, "insertBlockQuoteWithAnalyticsCommand", () => $be8553735b2be0a0$export$f5e16b3b6b62d83);
$parcel$export(module.exports, "cleanUpAtTheStartOfDocument", () => $be8553735b2be0a0$export$9c6026f8ac831f44);

var $bMFKb = parcelRequire("bMFKb");

var $asjM0 = parcelRequire("asjM0");

var $5Z3Rm = parcelRequire("5Z3Rm");
var $gmvZ4 = parcelRequire("gmvZ4");

var $lzEKq = parcelRequire("lzEKq");

var $cwzAY = parcelRequire("cwzAY");

var $h16z0 = parcelRequire("h16z0");

var $78v0m = parcelRequire("78v0m");

var $l8Eo2 = parcelRequire("l8Eo2");
function $be8553735b2be0a0$export$36987f561c736aad(name) {
    return ({ tr: tr })=>{
        const { nodes: nodes } = tr.doc.type.schema;
        if (name === (0, $h16z0.NORMAL_TEXT).name && nodes.paragraph) return $be8553735b2be0a0$export$63c4f0859cc75dc6()({
            tr: tr
        });
        const headingBlockType = (0, $h16z0.HEADINGS_BY_NAME)[name];
        if (headingBlockType && nodes.heading && headingBlockType.level) return $be8553735b2be0a0$export$c6a04dca1ed03a3c(headingBlockType.level)({
            tr: tr
        });
        return null;
    };
}
function $be8553735b2be0a0$export$c6a04dca1ed03a3c(level, fromBlockQuote) {
    return function({ tr: tr }) {
        const { selection: selection, doc: { type: { schema: schema } } } = tr;
        const ranges = selection instanceof (0, $cwzAY.CellSelection) ? selection.ranges : [
            selection
        ];
        ranges.forEach(({ $from: $from, $to: $to })=>{
            if (fromBlockQuote) {
                const range = $from.blockRange($to);
                if (!range) return;
                // First, lift the content out of the blockquote
                const targetLiftDepth = (0, $lzEKq.liftTarget)(range);
                if (targetLiftDepth || targetLiftDepth === 0) tr.lift(range, targetLiftDepth);
                // Then apply the heading block type to the lifted content
                // We need to recalculate positions after the lift operation
                const newFrom = tr.mapping.map($from.pos);
                const newTo = tr.mapping.map($to.pos);
                tr.setBlockType(newFrom, newTo, schema.nodes.heading, {
                    level: level
                });
            } else tr.setBlockType($from.pos, $to.pos, schema.nodes.heading, {
                level: level
            });
        });
        return tr;
    };
}
function $be8553735b2be0a0$export$3f9af78ebb95cc20(name, inputMethod, editorAnalyticsApi, fromBlockQuote) {
    return ({ tr: tr })=>{
        const { nodes: nodes } = tr.doc.type.schema;
        if (name === 'normal' && nodes.paragraph) return $be8553735b2be0a0$export$283e32d0388e302a(inputMethod, editorAnalyticsApi, fromBlockQuote)({
            tr: tr
        });
        const headingBlockType = (0, $h16z0.HEADINGS_BY_NAME)[name];
        if (headingBlockType && nodes.heading && headingBlockType.level) return $be8553735b2be0a0$export$52d74b15bd103d7f(headingBlockType.level, inputMethod, editorAnalyticsApi, fromBlockQuote)({
            tr: tr
        });
        return null;
    };
}
function $be8553735b2be0a0$export$63c4f0859cc75dc6(fromBlockQuote) {
    return function({ tr: tr }) {
        const { selection: selection, doc: { type: { schema: schema } } } = tr;
        const ranges = selection instanceof (0, $cwzAY.CellSelection) ? selection.ranges : [
            selection
        ];
        ranges.forEach(({ $from: $from, $to: $to })=>{
            if (fromBlockQuote) {
                const range = $from.blockRange($to);
                if (!range) return;
                // First, lift the content out of the blockquote
                const targetLiftDepth = (0, $lzEKq.liftTarget)(range);
                if (targetLiftDepth || targetLiftDepth === 0) tr.lift(range, targetLiftDepth);
                const newFrom = tr.mapping.map($from.pos);
                const newTo = tr.mapping.map($to.pos);
                tr.setBlockType(newFrom, newTo, schema.nodes.paragraph, {});
            } else tr.setBlockType($from.pos, $to.pos, schema.nodes.paragraph);
        });
        return tr;
    };
}
function $be8553735b2be0a0$export$195de5d8e201efd7(inputMethod, editorAnalyticsApi) {
    return function({ tr: tr }) {
        const formattingCleared = [];
        const schema = tr.doc.type.schema;
        (0, $78v0m.FORMATTING_MARK_TYPES).forEach((mark)=>{
            const { from: from, to: to } = tr.selection;
            const markType = schema.marks[mark];
            if (!markType) return;
            if (tr.selection instanceof (0, $cwzAY.CellSelection)) (0, $78v0m.cellSelectionNodesBetween)(tr.selection, tr.doc, (node, pos)=>{
                const isTableCell = node.type === schema.nodes.tableCell || node.type === schema.nodes.tableHeader;
                if (!isTableCell) return true;
                if (tr.doc.rangeHasMark(pos, pos + node.nodeSize, markType)) {
                    formattingCleared.push((0, $78v0m.formatTypes)[mark]);
                    tr.removeMark(pos, pos + node.nodeSize, markType);
                }
                return false;
            });
            else if (tr.doc.rangeHasMark(from, to, markType)) {
                formattingCleared.push((0, $78v0m.formatTypes)[mark]);
                tr.removeMark(from, to, markType);
            }
        });
        (0, $78v0m.FORMATTING_NODE_TYPES).forEach((nodeName)=>{
            const formattedNodeType = schema.nodes[nodeName];
            const { $from: $from, $to: $to } = tr.selection;
            if (tr.selection instanceof (0, $cwzAY.CellSelection)) (0, $78v0m.cellSelectionNodesBetween)(tr.selection, tr.doc, (0, $78v0m.clearNodeFormattingOnSelection)(schema, tr, formattedNodeType, nodeName, formattingCleared));
            else tr.doc.nodesBetween($from.pos, $to.pos, (0, $78v0m.clearNodeFormattingOnSelection)(schema, tr, formattedNodeType, nodeName, formattingCleared));
        });
        tr.setStoredMarks([]);
        if (formattingCleared.length) editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $bMFKb.ACTION).FORMATTED,
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
            actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_CLEAR,
            attributes: {
                inputMethod: inputMethod,
                formattingCleared: formattingCleared,
                dropdownMenu: 'textStyle'
            }
        })(tr);
        return tr;
    };
}
function $be8553735b2be0a0$var$withCurrentHeadingLevel(fn) {
    return ({ tr: tr })=>{
        // Find all headings and paragraphs of text
        const { heading: heading, paragraph: paragraph } = tr.doc.type.schema.nodes;
        const nodes = (0, $5Z3Rm.filterChildrenBetween)(tr.doc, tr.selection.from, tr.selection.to, (node)=>{
            return node.type === heading || node.type === paragraph;
        });
        // Check each paragraph and/or heading and check for consistent level
        let level;
        for (const node of nodes){
            const nodeLevel = node.node.type === heading ? node.node.attrs.level : 0;
            if (!level) level = nodeLevel;
            else if (nodeLevel !== level) {
                // Conflict in level, therefore inconsistent and undefined
                level = undefined;
                break;
            }
        }
        return fn(level)({
            tr: tr
        });
    };
}
function $be8553735b2be0a0$export$283e32d0388e302a(inputMethod, editorAnalyticsApi, fromBlockQuote) {
    return $be8553735b2be0a0$var$withCurrentHeadingLevel((previousHeadingLevel)=>({ tr: tr })=>{
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $bMFKb.ACTION).FORMATTED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_HEADING,
                attributes: {
                    inputMethod: inputMethod,
                    newHeadingLevel: 0,
                    previousHeadingLevel: previousHeadingLevel
                }
            })(tr);
            return $be8553735b2be0a0$export$63c4f0859cc75dc6(fromBlockQuote)({
                tr: tr
            });
        });
}
const $be8553735b2be0a0$export$52d74b15bd103d7f = (newHeadingLevel, inputMethod, editorAnalyticsApi, fromBlockQuote)=>{
    return $be8553735b2be0a0$var$withCurrentHeadingLevel((previousHeadingLevel)=>({ tr: tr })=>{
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $bMFKb.ACTION).FORMATTED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_HEADING,
                attributes: {
                    inputMethod: inputMethod,
                    newHeadingLevel: newHeadingLevel,
                    previousHeadingLevel: previousHeadingLevel
                }
            })(tr);
            return $be8553735b2be0a0$export$c6a04dca1ed03a3c(newHeadingLevel, fromBlockQuote)({
                tr: tr
            });
        });
};
function $be8553735b2be0a0$var$insertBlockQuote() {
    return function(state, dispatch) {
        const { nodes: nodes } = state.schema;
        if (nodes.paragraph && nodes.blockquote) return (0, $gmvZ4.wrapSelectionIn)(nodes.blockquote)(state, dispatch);
        return false;
    };
}
const $be8553735b2be0a0$export$50b4331f407b3ab6 = (inputMethod, editorAnalyticsApi)=>{
    return (0, $asjM0.withAnalytics)(editorAnalyticsApi, {
        action: (0, $bMFKb.ACTION).FORMATTED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
        attributes: {
            inputMethod: inputMethod
        }
    })($be8553735b2be0a0$var$insertBlockQuote());
};
function $be8553735b2be0a0$export$f5e16b3b6b62d83(inputMethod, editorAnalyticsApi) {
    return $be8553735b2be0a0$var$withCurrentHeadingLevel((previousHeadingLevel)=>({ tr: tr })=>{
            const { nodes: nodes } = tr.doc.type.schema;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $bMFKb.ACTION).FORMATTED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
                attributes: {
                    inputMethod: inputMethod
                }
            })(tr);
            return (0, $l8Eo2.wrapSelectionInBlockType)(nodes.blockquote)({
                tr: tr
            });
        });
}
const $be8553735b2be0a0$export$9c6026f8ac831f44 = (state, dispatch)=>{
    const { $cursor: $cursor } = state.selection;
    if ($cursor && !$cursor.nodeBefore && !$cursor.nodeAfter && $cursor.pos === 1) {
        const { tr: tr, schema: schema } = state;
        const { paragraph: paragraph } = schema.nodes;
        const { parent: parent } = $cursor;
        /**
		 * Use cases:
		 * 1. Change `heading` to `paragraph`
		 * 2. Remove block marks
		 *
		 * NOTE: We already know it's an empty doc so it's safe to use 0
		 */ tr.setNodeMarkup(0, paragraph, parent.attrs, []);
        if (dispatch) dispatch(tr);
        return true;
    }
    return false;
};

});
parcelRegister("h16z0", function(module, exports) {
$parcel$export(module.exports, "NORMAL_TEXT", () => $c75cdf0ae0ea8421$export$58d6de174a4025df);
$parcel$export(module.exports, "HEADING_1", () => $c75cdf0ae0ea8421$export$aca53469ff012f69);
$parcel$export(module.exports, "HEADING_2", () => $c75cdf0ae0ea8421$export$8af5e2d4f952c9f0);
$parcel$export(module.exports, "HEADING_3", () => $c75cdf0ae0ea8421$export$4b4c4ef3a93a84d8);
$parcel$export(module.exports, "HEADING_4", () => $c75cdf0ae0ea8421$export$67379271b4d26982);
$parcel$export(module.exports, "HEADING_5", () => $c75cdf0ae0ea8421$export$230d7efa1736763e);
$parcel$export(module.exports, "HEADING_6", () => $c75cdf0ae0ea8421$export$329adfa5d98f30d5);
$parcel$export(module.exports, "BLOCK_QUOTE", () => $c75cdf0ae0ea8421$export$175cdd8bc7e4b125);
$parcel$export(module.exports, "CODE_BLOCK", () => $c75cdf0ae0ea8421$export$cf55d1bff75690da);
$parcel$export(module.exports, "PANEL", () => $c75cdf0ae0ea8421$export$867b449446b85962);
$parcel$export(module.exports, "OTHER", () => $c75cdf0ae0ea8421$export$d46a05f8561f868a);
$parcel$export(module.exports, "TEXT_BLOCK_TYPES", () => $c75cdf0ae0ea8421$export$2ec1d6c4f06d927);
$parcel$export(module.exports, "toolbarBlockTypesWithRank", () => $c75cdf0ae0ea8421$export$eb0a3dded5e1d29b);
$parcel$export(module.exports, "FORMATTING_NODE_TYPES", () => $c75cdf0ae0ea8421$export$a5cb0c20bd02ce0c);
$parcel$export(module.exports, "FORMATTING_MARK_TYPES", () => $c75cdf0ae0ea8421$export$73b50f8f13648c71);
$parcel$export(module.exports, "WRAPPER_BLOCK_TYPES", () => $c75cdf0ae0ea8421$export$c6516682f7569488);
$parcel$export(module.exports, "getBlockTypesInDropdown", () => $c75cdf0ae0ea8421$export$a1bb601016dd2309);
$parcel$export(module.exports, "HEADINGS_BY_LEVEL", () => $c75cdf0ae0ea8421$export$110c9c3e05131569);
$parcel$export(module.exports, "HEADINGS_BY_NAME", () => $c75cdf0ae0ea8421$export$33dfdcd30c23ea87);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $TgnAJ = parcelRequire("TgnAJ");

var $3KjUM = parcelRequire("3KjUM");
var $6996L = parcelRequire("6996L");

var $2DLW5 = parcelRequire("2DLW5");
var $8tfsN = parcelRequire("8tfsN");
var $iaTwJ = parcelRequire("iaTwJ");
var $kMjFB = parcelRequire("kMjFB");
var $g6Zs4 = parcelRequire("g6Zs4");
var $a4Ktd = parcelRequire("a4Ktd");
var $amerd = parcelRequire("amerd");
var $8hNRj = parcelRequire("8hNRj");

var $2DLW5 = parcelRequire("2DLW5");

var $8tfsN = parcelRequire("8tfsN");

var $iaTwJ = parcelRequire("iaTwJ");

var $kMjFB = parcelRequire("kMjFB");

var $g6Zs4 = parcelRequire("g6Zs4");

var $a4Ktd = parcelRequire("a4Ktd");

var $8hNRj = parcelRequire("8hNRj");

var $92xoS = parcelRequire("92xoS");

var $352qR = parcelRequire("352qR");
const $c75cdf0ae0ea8421$export$58d6de174a4025df = {
    name: 'normal',
    title: (0, $TgnAJ.messages).normal,
    nodeName: 'paragraph',
    tagName: 'p',
    icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8hNRj))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $352qR.Text), {})
};
const $c75cdf0ae0ea8421$export$aca53469ff012f69 = {
    name: 'heading1',
    title: (0, $TgnAJ.messages).heading1,
    nodeName: 'heading',
    tagName: 'h1',
    level: 1,
    icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iaTwJ))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $352qR.H1), {})
};
const $c75cdf0ae0ea8421$export$8af5e2d4f952c9f0 = {
    name: 'heading2',
    title: (0, $TgnAJ.messages).heading2,
    nodeName: 'heading',
    tagName: 'h2',
    level: 2,
    icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a4Ktd))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $352qR.H2), {})
};
const $c75cdf0ae0ea8421$export$4b4c4ef3a93a84d8 = {
    name: 'heading3',
    title: (0, $TgnAJ.messages).heading3,
    nodeName: 'heading',
    tagName: 'h3',
    level: 3,
    icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6Zs4))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $352qR.H3), {})
};
const $c75cdf0ae0ea8421$export$67379271b4d26982 = {
    name: 'heading4',
    title: (0, $TgnAJ.messages).heading4,
    nodeName: 'heading',
    tagName: 'h4',
    level: 4,
    icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tfsN))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $352qR.H4), {})
};
const $c75cdf0ae0ea8421$export$230d7efa1736763e = {
    name: 'heading5',
    title: (0, $TgnAJ.messages).heading5,
    nodeName: 'heading',
    tagName: 'h5',
    level: 5,
    icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2DLW5))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $352qR.H5), {})
};
const $c75cdf0ae0ea8421$export$329adfa5d98f30d5 = {
    name: 'heading6',
    title: (0, $TgnAJ.messages).heading6,
    nodeName: 'heading',
    tagName: 'h6',
    level: 6,
    icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kMjFB))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $352qR.H6), {})
};
const $c75cdf0ae0ea8421$export$175cdd8bc7e4b125 = {
    name: 'blockquote',
    title: (0, $TgnAJ.messages).blockquote,
    nodeName: 'blockquote',
    tagName: 'blockquote'
};
const $c75cdf0ae0ea8421$export$cf55d1bff75690da = {
    name: 'codeblock',
    title: (0, $TgnAJ.messages).codeblock,
    nodeName: 'codeBlock'
};
const $c75cdf0ae0ea8421$export$867b449446b85962 = {
    name: 'panel',
    title: (0, $TgnAJ.messages).infoPanel,
    nodeName: 'panel'
};
const $c75cdf0ae0ea8421$export$d46a05f8561f868a = {
    name: 'other',
    title: (0, $TgnAJ.messages).other,
    nodeName: ''
};
const $c75cdf0ae0ea8421$export$2ec1d6c4f06d927 = [
    $c75cdf0ae0ea8421$export$58d6de174a4025df,
    $c75cdf0ae0ea8421$export$aca53469ff012f69,
    $c75cdf0ae0ea8421$export$8af5e2d4f952c9f0,
    $c75cdf0ae0ea8421$export$4b4c4ef3a93a84d8,
    $c75cdf0ae0ea8421$export$67379271b4d26982,
    $c75cdf0ae0ea8421$export$230d7efa1736763e,
    $c75cdf0ae0ea8421$export$329adfa5d98f30d5
];
var $c75cdf0ae0ea8421$var$ToolbarBlockTypes = /*#__PURE__*/ function(ToolbarBlockTypes) {
    ToolbarBlockTypes["normal"] = "normal";
    ToolbarBlockTypes["heading1"] = "heading1";
    ToolbarBlockTypes["heading2"] = "heading2";
    ToolbarBlockTypes["heading3"] = "heading3";
    ToolbarBlockTypes["heading4"] = "heading4";
    ToolbarBlockTypes["heading5"] = "heading5";
    ToolbarBlockTypes["heading6"] = "heading6";
    ToolbarBlockTypes["blockquote"] = "blockquote";
    return ToolbarBlockTypes;
}($c75cdf0ae0ea8421$var$ToolbarBlockTypes || {});
const $c75cdf0ae0ea8421$export$eb0a3dded5e1d29b = ()=>({
        normal: {
            ...$c75cdf0ae0ea8421$export$58d6de174a4025df,
            icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8hNRj))), {
                size: "small",
                label: ""
            }),
            toolbarRank: (0, $6996L.TEXT_STYLES_MENU_SECTION_RANK)[(0, $3KjUM.NORMAL_TEXT_MENU_ITEM).key],
            toolbarKey: (0, $3KjUM.NORMAL_TEXT_MENU_ITEM).key
        },
        heading1: {
            ...$c75cdf0ae0ea8421$export$aca53469ff012f69,
            icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iaTwJ))), {
                size: "small",
                label: ""
            }),
            toolbarRank: (0, $6996L.TEXT_STYLES_MENU_SECTION_RANK)[(0, $3KjUM.HEADING_1_MENU_ITEM).key],
            toolbarKey: (0, $3KjUM.HEADING_1_MENU_ITEM).key
        },
        heading2: {
            ...$c75cdf0ae0ea8421$export$8af5e2d4f952c9f0,
            icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a4Ktd))), {
                size: "small",
                label: ""
            }),
            toolbarRank: (0, $6996L.TEXT_STYLES_MENU_SECTION_RANK)[(0, $3KjUM.HEADING_2_MENU_ITEM).key],
            toolbarKey: (0, $3KjUM.HEADING_2_MENU_ITEM).key
        },
        heading3: {
            ...$c75cdf0ae0ea8421$export$4b4c4ef3a93a84d8,
            icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6Zs4))), {
                size: "small",
                label: ""
            }),
            toolbarRank: (0, $6996L.TEXT_STYLES_MENU_SECTION_RANK)[(0, $3KjUM.HEADING_3_MENU_ITEM).key],
            toolbarKey: (0, $3KjUM.HEADING_3_MENU_ITEM).key
        },
        heading4: {
            ...$c75cdf0ae0ea8421$export$67379271b4d26982,
            icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tfsN))), {
                size: "small",
                label: ""
            }),
            toolbarRank: (0, $6996L.TEXT_STYLES_MENU_SECTION_RANK)[(0, $3KjUM.HEADING_4_MENU_ITEM).key],
            toolbarKey: (0, $3KjUM.HEADING_4_MENU_ITEM).key
        },
        heading5: {
            ...$c75cdf0ae0ea8421$export$230d7efa1736763e,
            icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2DLW5))), {
                size: "small",
                label: ""
            }),
            toolbarRank: (0, $6996L.TEXT_STYLES_MENU_SECTION_RANK)[(0, $3KjUM.HEADING_5_MENU_ITEM).key],
            toolbarKey: (0, $3KjUM.HEADING_5_MENU_ITEM).key
        },
        heading6: {
            ...$c75cdf0ae0ea8421$export$329adfa5d98f30d5,
            icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kMjFB))), {
                size: "small",
                label: ""
            }),
            toolbarRank: (0, $6996L.TEXT_STYLES_MENU_SECTION_RANK)[(0, $3KjUM.HEADING_6_MENU_ITEM).key],
            toolbarKey: (0, $3KjUM.HEADING_6_MENU_ITEM).key
        },
        blockquote: {
            ...$c75cdf0ae0ea8421$export$175cdd8bc7e4b125,
            icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($amerd))), {
                size: "small",
                label: ""
            }),
            toolbarRank: (0, $6996L.TEXT_STYLES_MENU_SECTION_RANK)[(0, $3KjUM.BLOCK_QUOTE_MENU_ITEM).key],
            toolbarKey: (0, $3KjUM.BLOCK_QUOTE_MENU_ITEM).key
        }
    });
const $c75cdf0ae0ea8421$export$a5cb0c20bd02ce0c = [
    'heading',
    'blockquote'
];
const $c75cdf0ae0ea8421$export$73b50f8f13648c71 = [
    'em',
    'code',
    'strike',
    'strong',
    'underline',
    'textColor',
    'subsup',
    'backgroundColor'
];
const $c75cdf0ae0ea8421$export$c6516682f7569488 = [
    $c75cdf0ae0ea8421$export$175cdd8bc7e4b125,
    $c75cdf0ae0ea8421$export$cf55d1bff75690da,
    $c75cdf0ae0ea8421$export$867b449446b85962
];
const $c75cdf0ae0ea8421$export$237f26fa8dbc0d9a = $c75cdf0ae0ea8421$export$2ec1d6c4f06d927.concat($c75cdf0ae0ea8421$export$c6516682f7569488);
const $c75cdf0ae0ea8421$export$a1bb601016dd2309 = (includeBlockQuoteAsTextstyleOption)=>{
    return (0, $92xoS.editorExperiment)('platform_editor_blockquote_in_text_formatting_menu', true, {
        exposure: true
    }) && includeBlockQuoteAsTextstyleOption ? [
        ...$c75cdf0ae0ea8421$export$2ec1d6c4f06d927,
        $c75cdf0ae0ea8421$export$175cdd8bc7e4b125
    ] : $c75cdf0ae0ea8421$export$2ec1d6c4f06d927;
};
const $c75cdf0ae0ea8421$export$110c9c3e05131569 = $c75cdf0ae0ea8421$export$2ec1d6c4f06d927.reduce((acc, blockType)=>{
    if (blockType.level && blockType.nodeName === 'heading') acc[blockType.level] = blockType;
    return acc;
}, {});
const $c75cdf0ae0ea8421$export$33dfdcd30c23ea87 = $c75cdf0ae0ea8421$export$2ec1d6c4f06d927.reduce((acc, blockType)=>{
    if (blockType.level && blockType.nodeName === 'heading') acc[blockType.name] = blockType;
    return acc;
}, {});

});
parcelRegister("2DLW5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e990a01e1f886ae319272b03d75a687b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1ec46857d90761b6$var$_react = $1ec46857d90761b6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $1ec46857d90761b6$var$_baseNew = $1ec46857d90761b6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $1ec46857d90761b6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingFive".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H5 / Heading 5 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1ec46857d90761b6$var$TextHeadingFiveIcon = (props)=>/*#__PURE__*/ $1ec46857d90761b6$var$_react.default.createElement($1ec46857d90761b6$var$_baseNew.default, Object.assign({
        name: "TextHeadingFiveIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 8.5h-3.75a.75.75 0 0 0-.75.75v3c0 .41.34.75.75.75h2.25v1.5h-3V16h3.13c.76 0 1.38-.62 1.38-1.37v-1.75c0-.76-.62-1.37-1.37-1.37H13V10h3zM2.5 6.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$1ec46857d90761b6$var$TextHeadingFiveIcon.displayName = 'TextHeadingFiveIcon';
var $1ec46857d90761b6$var$_default = module.exports.default = $1ec46857d90761b6$var$TextHeadingFiveIcon;

});

parcelRegister("8tfsN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a0ec299c9d9d8293148b95b4eb4ef8e6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $62ad06df3ef188bd$var$_react = $62ad06df3ef188bd$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $62ad06df3ef188bd$var$_baseNew = $62ad06df3ef188bd$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $62ad06df3ef188bd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingFour".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H4 / Heading 4 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $62ad06df3ef188bd$var$TextHeadingFourIcon = (props)=>/*#__PURE__*/ $62ad06df3ef188bd$var$_react.default.createElement($62ad06df3ef188bd$var$_baseNew.default, Object.assign({
        name: "TextHeadingFourIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.5 12V8.5H11v3.63c0 .76.62 1.38 1.38 1.38h2.12V16H16V8.5h-1.5V12zm-10-5.75V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$62ad06df3ef188bd$var$TextHeadingFourIcon.displayName = 'TextHeadingFourIcon';
var $62ad06df3ef188bd$var$_default = module.exports.default = $62ad06df3ef188bd$var$TextHeadingFourIcon;

});

parcelRegister("iaTwJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6e4d3b8c2282199229e89fad097e5cbf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d3b43bae4b75d424$var$_react = $d3b43bae4b75d424$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d3b43bae4b75d424$var$_baseNew = $d3b43bae4b75d424$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $d3b43bae4b75d424$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingOne".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H1 / Heading 1 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d3b43bae4b75d424$var$TextHeadingOneIcon = (props)=>/*#__PURE__*/ $d3b43bae4b75d424$var$_react.default.createElement($d3b43bae4b75d424$var$_baseNew.default, Object.assign({
        name: "TextHeadingOneIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 6.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25zM12 8.5h1.75a.75.75 0 0 1 .75.75V16H13v-6h-1z" clip-rule="evenodd"/>`
    }, props));
$d3b43bae4b75d424$var$TextHeadingOneIcon.displayName = 'TextHeadingOneIcon';
var $d3b43bae4b75d424$var$_default = module.exports.default = $d3b43bae4b75d424$var$TextHeadingOneIcon;

});

parcelRegister("kMjFB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7ea50078a5999a2c3fbe51c1b3e78d4a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f2078c62da50ef9b$var$_react = $f2078c62da50ef9b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f2078c62da50ef9b$var$_baseNew = $f2078c62da50ef9b$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $f2078c62da50ef9b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingSix".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H6 / Heading 6 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f2078c62da50ef9b$var$TextHeadingSixIcon = (props)=>/*#__PURE__*/ $f2078c62da50ef9b$var$_react.default.createElement($f2078c62da50ef9b$var$_baseNew.default, Object.assign({
        name: "TextHeadingSixIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15.5 8.5h-2.62c-.76 0-1.37.62-1.37 1.38v4.75c0 .76.62 1.38 1.38 1.38h1.75c.76 0 1.38-.62 1.38-1.37v-1.75c0-.76-.62-1.37-1.37-1.37H13V10h2.5zM13 13h1.5v1.5H13zM2.5 6.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$f2078c62da50ef9b$var$TextHeadingSixIcon.displayName = 'TextHeadingSixIcon';
var $f2078c62da50ef9b$var$_default = module.exports.default = $f2078c62da50ef9b$var$TextHeadingSixIcon;

});

parcelRegister("g6Zs4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eb8ba74bc7f968e3347d9c83c15417ee>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bbacdfed018e1198$var$_react = $bbacdfed018e1198$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $bbacdfed018e1198$var$_baseNew = $bbacdfed018e1198$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $bbacdfed018e1198$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingThree".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H3 / Heading 3 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bbacdfed018e1198$var$TextHeadingThreeIcon = (props)=>/*#__PURE__*/ $bbacdfed018e1198$var$_react.default.createElement($bbacdfed018e1198$var$_baseNew.default, Object.assign({
        name: "TextHeadingThreeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.5 8.5h3.13c.76 0 1.38.62 1.38 1.38v4.75c0 .76-.62 1.38-1.37 1.38H11.5v-1.5h3V13h-3v-1.5h3V10h-3zm-9-2.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$bbacdfed018e1198$var$TextHeadingThreeIcon.displayName = 'TextHeadingThreeIcon';
var $bbacdfed018e1198$var$_default = module.exports.default = $bbacdfed018e1198$var$TextHeadingThreeIcon;

});

parcelRegister("a4Ktd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4280f54cb1f2416c8d1b430fc38ff118>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $755e5320e3b8adde$var$_react = $755e5320e3b8adde$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $755e5320e3b8adde$var$_baseNew = $755e5320e3b8adde$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $755e5320e3b8adde$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingTwo".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H2 / Heading 2 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $755e5320e3b8adde$var$TextHeadingTwoIcon = (props)=>/*#__PURE__*/ $755e5320e3b8adde$var$_react.default.createElement($755e5320e3b8adde$var$_baseNew.default, Object.assign({
        name: "TextHeadingTwoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.5 8.5h3.13c.76 0 1.38.62 1.38 1.38v1.75c0 .76-.62 1.38-1.37 1.38H13v1.5h3V16h-3.75a.75.75 0 0 1-.75-.75v-2.37c0-.76.62-1.37 1.38-1.37h1.62V10h-3zm-9-2.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$755e5320e3b8adde$var$TextHeadingTwoIcon.displayName = 'TextHeadingTwoIcon';
var $755e5320e3b8adde$var$_default = module.exports.default = $755e5320e3b8adde$var$TextHeadingTwoIcon;

});

parcelRegister("352qR", function(module, exports) {
$parcel$export(module.exports, "Text", () => $62c59381d0caa582$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "H1", () => $62c59381d0caa582$export$5523b16adee8048);
$parcel$export(module.exports, "H2", () => $62c59381d0caa582$export$cb94397127ac9363);
$parcel$export(module.exports, "H3", () => $62c59381d0caa582$export$746be9e3a3dfff1f);
$parcel$export(module.exports, "H4", () => $62c59381d0caa582$export$cc5e069d64fda823);
$parcel$export(module.exports, "H5", () => $62c59381d0caa582$export$88ef9fdaf11f7a1f);
$parcel$export(module.exports, "H6", () => $62c59381d0caa582$export$a559fb8039b06400);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $62c59381d0caa582$var$SVGContainer = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        style: {
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)",
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center'
        },
        children: children
    });
const $62c59381d0caa582$export$5f1af8db9871e1d6 = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)($62c59381d0caa582$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M2 1H14V5H12.5V2.5H8.8125V13.5H10.5V15H5.5V13.5H7.3125V2.5H3.5V5H2V1Z",
                fill: "currentColor"
            })
        })
    });
const $62c59381d0caa582$export$5523b16adee8048 = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)($62c59381d0caa582$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M0 0H1.5V6.25H6V0H7.5V6.25V7.75V14H6V7.75H1.5V14H0V7.75V6.25V0ZM9.85801 12.6959V14H13.9999V12.6959H12.8161V7.83108H11.3138L9.8418 8.86406V10.4342L11.3499 9.31528V12.6959H9.85801Z",
                fill: "currentColor"
            })
        })
    });
const $62c59381d0caa582$export$cb94397127ac9363 = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)($62c59381d0caa582$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                "clip-rule": "evenodd",
                d: "M1.5 0H0V6.25V7.75V14H1.5V7.75H6V14H7.5V7.75V6.25V0H6V6.25H1.5V0ZM9.2395 12.8296V14H14V12.6553H11.5637V12.573L12.4146 11.875C12.7826 11.5734 13.0772 11.2981 13.2986 11.0491C13.5199 10.8 13.679 10.5635 13.7759 10.3394C13.8755 10.1152 13.9253 9.89111 13.9253 9.66699V9.64624C13.9253 9.28101 13.8285 8.96419 13.6348 8.6958C13.4411 8.42464 13.1685 8.21574 12.8171 8.06909C12.4685 7.91968 12.0562 7.84497 11.5803 7.84497C11.0906 7.84497 10.6617 7.93075 10.2937 8.10229C9.92847 8.27108 9.64347 8.50903 9.43872 8.81616C9.23674 9.12052 9.13574 9.47884 9.13574 9.89111V9.92432H10.7378V9.88696C10.7378 9.74308 10.771 9.6158 10.8374 9.50513C10.9038 9.39445 10.9951 9.30729 11.1113 9.24365C11.2303 9.18001 11.3659 9.14819 11.5181 9.14819C11.6647 9.14819 11.7906 9.1731 11.8958 9.2229C12.0037 9.27271 12.0853 9.34465 12.1406 9.43872C12.1987 9.5328 12.2278 9.64486 12.2278 9.7749V9.79565C12.2278 9.9008 12.1946 10.0115 12.1282 10.1277C12.0645 10.2439 11.9497 10.3878 11.7837 10.5593C11.6177 10.7281 11.3811 10.9467 11.074 11.2151L9.2395 12.8296Z",
                fill: "currentColor"
            })
        })
    });
const $62c59381d0caa582$export$746be9e3a3dfff1f = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)($62c59381d0caa582$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M1.5 0H0V6.25V7.75V14H1.5V7.75H6V14H7.5V7.75V6.25V0H6V6.25H1.5V0ZM10.219 13.7649C10.5811 13.9216 11.0012 14 11.4794 14C12.0009 14 12.4494 13.9257 12.825 13.7771C13.2005 13.6258 13.4896 13.411 13.6922 13.1327C13.8976 12.8544 14.0002 12.5248 14.0002 12.1438V12.1357C14.0002 11.7575 13.8706 11.4535 13.6112 11.2239C13.3518 10.9942 13.0006 10.8564 12.5575 10.8105V10.7781C12.7709 10.7348 12.9681 10.6565 13.1492 10.543C13.3329 10.4295 13.4801 10.2823 13.5909 10.1013C13.7017 9.91755 13.7571 9.70275 13.7571 9.45688V9.44878C13.7571 9.12186 13.6639 8.83817 13.4774 8.5977C13.291 8.35454 13.0262 8.16541 12.6831 8.03032C12.34 7.89523 11.9347 7.82769 11.4673 7.82769C11.0134 7.82769 10.6162 7.90469 10.2758 8.05869C9.93805 8.20999 9.67057 8.42479 9.47334 8.70308C9.27611 8.98136 9.16533 9.31099 9.14102 9.69194L9.13696 9.75273H10.6851L10.6892 9.71626C10.7027 9.58927 10.7418 9.4785 10.8067 9.38394C10.8715 9.28667 10.9593 9.21237 11.0701 9.16104C11.1836 9.107 11.316 9.07998 11.4673 9.07998C11.6132 9.07998 11.7388 9.10565 11.8442 9.15698C11.9523 9.20562 12.0347 9.27586 12.0914 9.36772C12.1481 9.45959 12.1765 9.56631 12.1765 9.68789V9.696C12.1765 9.81488 12.1427 9.9189 12.0752 10.0081C12.0104 10.0945 11.9158 10.1607 11.7915 10.2066C11.6672 10.2526 11.5159 10.2755 11.3376 10.2755H10.7337V11.4062H11.3376C11.6348 11.4062 11.8618 11.4589 12.0185 11.5643C12.1752 11.667 12.2535 11.8183 12.2535 12.0182V12.0263C12.2535 12.1506 12.2224 12.2614 12.1603 12.3586C12.0982 12.4532 12.009 12.5289 11.8928 12.5856C11.7766 12.6396 11.6375 12.6667 11.4754 12.6667C11.3133 12.6667 11.1728 12.641 11.0539 12.5896C10.935 12.5383 10.8405 12.4681 10.7702 12.3789C10.7 12.2897 10.6567 12.1911 10.6405 12.0831L10.6324 12.0344H8.99512L8.99917 12.0871C9.02889 12.4762 9.14912 12.8139 9.35986 13.1003C9.57061 13.3867 9.857 13.6082 10.219 13.7649Z",
                fill: "currentColor"
            })
        })
    });
const $62c59381d0caa582$export$cc5e069d64fda823 = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)($62c59381d0caa582$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M1.5 0H0V6.25V7.75V14H1.5V7.75H6V14H7.5V7.75V6.25V0H6V6.25H1.5V0ZM11.542 13.0117V14H13.2607V13.0117H13.9998V11.6195H13.2607V7.79961H10.7428C10.5852 8.05169 10.4291 8.30378 10.2744 8.55586C10.1226 8.80508 9.97077 9.05573 9.81894 9.30781C9.66999 9.5599 9.52103 9.81628 9.37207 10.077C9.22311 10.3348 9.07559 10.5969 8.92949 10.8633C8.7834 11.1268 8.6373 11.3975 8.49121 11.6754V13.0117H11.542ZM11.5936 11.6883H10.0338V11.6023C10.1226 11.4276 10.2143 11.2543 10.3088 11.0824C10.4033 10.9077 10.4993 10.7344 10.5967 10.5625C10.6969 10.3906 10.7972 10.2202 10.8975 10.0512C10.9977 9.8793 11.098 9.71029 11.1982 9.54414C11.3014 9.37799 11.4045 9.21328 11.5076 9.05H11.5936V11.6883Z",
                fill: "currentColor"
            })
        })
    });
const $62c59381d0caa582$export$88ef9fdaf11f7a1f = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)($62c59381d0caa582$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M1.5 0H0V6.25V7.75V14H1.5V7.75H6V14H7.5V7.75V6.25V0H6V6.25H1.5V0ZM10.2808 13.7551C10.6349 13.9184 11.0527 14 11.5342 14C12.0239 14 12.4542 13.9101 12.825 13.7302C13.1957 13.5476 13.4835 13.2917 13.6882 12.9624C13.8958 12.6331 13.9995 12.2499 13.9995 11.8127V11.8044C13.9995 11.4281 13.9165 11.0961 13.7505 10.8083C13.5872 10.5178 13.3617 10.2896 13.074 10.1235C12.7862 9.95752 12.457 9.87451 12.0862 9.87451C11.887 9.87451 11.703 9.90356 11.5342 9.96167C11.3682 10.0198 11.2243 10.1 11.1025 10.2024C10.9808 10.3048 10.884 10.4237 10.812 10.5593H10.729L10.8203 9.1731H13.6177V7.84497H9.45898L9.22241 11.4973H10.7207C10.7511 11.4392 10.7913 11.3839 10.8411 11.3313C10.8909 11.276 10.9462 11.2275 11.0071 11.186C11.079 11.139 11.1579 11.103 11.2437 11.0781C11.3322 11.0505 11.4277 11.0366 11.53 11.0366C11.6933 11.0366 11.8385 11.0712 11.9658 11.1404C12.0931 11.2068 12.1927 11.2995 12.2646 11.4185C12.3366 11.5374 12.3726 11.6772 12.3726 11.8376V11.8459C12.3726 12.0037 12.3366 12.1448 12.2646 12.2693C12.1927 12.391 12.0931 12.4865 11.9658 12.5557C11.8413 12.6248 11.6974 12.6594 11.5342 12.6594C11.3903 12.6594 11.2616 12.6345 11.1482 12.5847C11.0347 12.5349 10.9393 12.4685 10.8618 12.3855C10.7871 12.2997 10.7318 12.2056 10.6958 12.1033L10.6875 12.0784H9.12695L9.1311 12.1531C9.15047 12.4989 9.25838 12.8116 9.45483 13.0911C9.65405 13.3705 9.92936 13.5919 10.2808 13.7551Z",
                fill: "currentColor"
            })
        })
    });
const $62c59381d0caa582$export$a559fb8039b06400 = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)($62c59381d0caa582$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M1.5 0H0V6.25V7.75V14H1.5V7.75H6V14H7.5V7.75V6.25V0H6V6.25H1.5V0ZM10.4615 13.7893C10.7857 13.9298 11.1531 14 11.5638 14C12.0501 14 12.4757 13.9068 12.8404 13.7204C13.2052 13.5339 13.4889 13.28 13.6915 12.9584C13.8968 12.6342 13.9995 12.2681 13.9995 11.8602V11.8521C13.9995 11.4873 13.9225 11.1644 13.7685 10.8834C13.6172 10.5998 13.3997 10.3782 13.116 10.2188C12.835 10.0567 12.4973 9.97563 12.1028 9.97563C11.8272 9.97563 11.5935 10.0135 11.4017 10.0891C11.2099 10.1648 11.0532 10.2634 10.9316 10.385C10.81 10.5065 10.7141 10.6389 10.6438 10.7821H10.5547C10.5548 10.7402 10.5561 10.6984 10.5587 10.6565C10.575 10.3539 10.6195 10.0878 10.6925 9.8581C10.7681 9.62845 10.8762 9.44878 11.0167 9.31909C11.1572 9.1894 11.3328 9.12456 11.5436 9.12456C11.6624 9.12456 11.7678 9.14347 11.8597 9.1813C11.9542 9.21912 12.0353 9.27046 12.1028 9.3353C12.1704 9.40015 12.2204 9.47309 12.2528 9.55415L12.2649 9.58252H13.9266L13.9225 9.5582C13.8685 9.23398 13.7334 8.94219 13.5172 8.68281C13.3011 8.42074 13.0215 8.21269 12.6783 8.05869C12.3379 7.90469 11.9542 7.82768 11.5273 7.82768C11.0032 7.82768 10.5466 7.95062 10.1575 8.19648C9.76846 8.44235 9.4672 8.79629 9.25376 9.2583C9.04032 9.71761 8.93359 10.2674 8.93359 10.9078V10.9159C8.93359 11.3941 8.99303 11.8237 9.11191 12.2046C9.23079 12.5856 9.40371 12.9098 9.63066 13.1773C9.86032 13.4421 10.1373 13.6461 10.4615 13.7893ZM10.7492 11.9047C10.7492 12.056 10.7843 12.1925 10.8546 12.3141C10.9275 12.4356 11.0248 12.5316 11.1464 12.6018C11.2707 12.6694 11.4071 12.7031 11.5557 12.7031C11.707 12.7031 11.8435 12.6694 11.965 12.6018C12.0866 12.5316 12.1839 12.4383 12.2568 12.3222C12.3298 12.206 12.3663 12.075 12.3663 11.9291V11.9209C12.3663 11.7696 12.3311 11.6359 12.2609 11.5197C12.1906 11.4035 12.0947 11.3117 11.9731 11.2441C11.8543 11.1766 11.7165 11.1428 11.5598 11.1428C11.4112 11.1428 11.2747 11.1752 11.1504 11.2401C11.0289 11.3022 10.9316 11.39 10.8586 11.5035C10.7857 11.617 10.7492 11.748 10.7492 11.8966V11.9047Z",
                fill: "currentColor"
            })
        })
    });

});


parcelRegister("78v0m", function(module, exports) {
$parcel$export(module.exports, "FORMATTING_NODE_TYPES", () => $16d8796ef7db609e$export$a5cb0c20bd02ce0c);
$parcel$export(module.exports, "FORMATTING_MARK_TYPES", () => $16d8796ef7db609e$export$73b50f8f13648c71);
$parcel$export(module.exports, "formatTypes", () => $16d8796ef7db609e$export$ce157a3b6664c924);
$parcel$export(module.exports, "cellSelectionNodesBetween", () => $16d8796ef7db609e$export$bd443c1dba3019b8);
$parcel$export(module.exports, "clearNodeFormattingOnSelection", () => $16d8796ef7db609e$export$10ed2145ce1a03b1);

var $bMFKb = parcelRequire("bMFKb");

var $lzEKq = parcelRequire("lzEKq");
const $16d8796ef7db609e$export$a5cb0c20bd02ce0c = [
    'heading',
    'blockquote'
];
const $16d8796ef7db609e$export$73b50f8f13648c71 = [
    'em',
    'code',
    'strike',
    'strong',
    'underline',
    'textColor',
    'subsup',
    'backgroundColor'
];
const $16d8796ef7db609e$export$ce157a3b6664c924 = {
    em: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_ITALIC,
    code: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_CODE,
    strike: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_STRIKE,
    strong: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_STRONG,
    underline: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_UNDERLINE,
    textColor: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_COLOR,
    subsup: 'subsup',
    backgroundColor: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_BACKGROUND_COLOR
};
const $16d8796ef7db609e$export$bd443c1dba3019b8 = (selection, doc, f, startPos)=>{
    selection.forEachCell((cell, cellPos)=>{
        doc.nodesBetween(cellPos, cellPos + cell.nodeSize, f, startPos);
    });
};
function $16d8796ef7db609e$export$10ed2145ce1a03b1(schema, tr, formattedNodeType, nodeName, formattingCleared) {
    return function(node, pos) {
        if (node.type === formattedNodeType) {
            if (formattedNodeType.isTextblock) {
                tr.setNodeMarkup(pos, schema.nodes.paragraph);
                formattingCleared.push(nodeName);
                return false;
            } else {
                // In case of panel or blockquote
                const fromPos = tr.doc.resolve(pos + 1);
                const toPos = tr.doc.resolve(pos + node.nodeSize - 1);
                const nodeRange = fromPos.blockRange(toPos);
                if (nodeRange) {
                    const targetLiftDepth = (0, $lzEKq.liftTarget)(nodeRange);
                    if (targetLiftDepth || targetLiftDepth === 0) {
                        formattingCleared.push(nodeName);
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        tr.lift(nodeRange, targetLiftDepth);
                    }
                }
            }
        }
        return true;
    };
}

});

parcelRegister("l8Eo2", function(module, exports) {
$parcel$export(module.exports, "wrapSelectionInBlockType", () => $af68f559d9bca524$export$bb05c9a6c853122f);

var $3xw6l = parcelRequire("3xw6l");

var $lzEKq = parcelRequire("lzEKq");
function $af68f559d9bca524$export$bb05c9a6c853122f(nodeType) {
    return ({ tr: tr })=>{
        const { nodes: nodes } = tr.doc.type.schema;
        const { alignment: alignment, indentation: indentation } = tr.doc.type.schema.marks;
        if (nodes.paragraph && nodes.blockquote) {
            /**Remove alignment and indentation marks from the selection */ const marksToRemove = [
                alignment,
                indentation
            ];
            const hasMark = (mark)=>marksToRemove.indexOf(mark.type) > -1;
            const not = (fn)=>(arg)=>!fn(arg);
            /**
			 * When you need to toggle the selection
			 * when another type which does not allow alignment is applied
			 */ tr.doc.nodesBetween(tr.selection.from, tr.selection.to, (node, pos)=>{
                if (node.type === nodes.paragraph && node.marks.some(hasMark)) {
                    const resolvedPos = tr.doc.resolve(pos);
                    const withoutBlockMarks = node.marks.filter(not(hasMark));
                    tr = tr.setNodeMarkup(resolvedPos.pos, undefined, node.attrs, withoutBlockMarks);
                }
            });
            /** Get range and wrapping needed for the selection */ const { $from: $from, $to: $to } = tr.selection;
            const range = $from.blockRange($to);
            const wrapping = range && (0, $lzEKq.findWrapping)(range, nodes.blockquote);
            if (wrapping) /** Wrap the selection */ tr.wrap(range, wrapping).scrollIntoView();
            else {
                /** If wrapping is not possible, replace with a blockquote */ const start = $from.start();
                const end = $to.end();
                const content = $from.node().content;
                const blockquote = nodes.blockquote.create({}, nodes.paragraph.create({}, content));
                const slice = new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(blockquote), 0, 0);
                tr.replaceRange(start, end, slice).scrollIntoView();
            }
        }
        return tr;
    };
}

});


parcelRegister("lnss2", function(module, exports) {
$parcel$export(module.exports, "default", () => $e78ff6e25e870e0f$export$2e2bcd8739ae039);

var $bMFKb = parcelRequire("bMFKb");

var $piMVJ = parcelRequire("piMVJ");

var $i8KtF = parcelRequire("i8KtF");

var $leZY6 = parcelRequire("leZY6");

var $jCfsG = parcelRequire("jCfsG");
var $82vn7 = parcelRequire("82vn7");

var $lRu98 = parcelRequire("lRu98");
const $e78ff6e25e870e0f$var$MAX_HEADING_LEVEL = 6;
function $e78ff6e25e870e0f$var$getHeadingLevel(match) {
    return {
        level: match[1].length
    };
}
function $e78ff6e25e870e0f$var$headingRule(nodeType, maxLevel) {
    return (0, $lRu98.createWrappingTextBlockRule)({
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        match: new RegExp('^(#{1,' + maxLevel + '})\\s$'),
        nodeType: nodeType,
        getAttrs: $e78ff6e25e870e0f$var$getHeadingLevel
    });
}
function $e78ff6e25e870e0f$var$blockQuoteRule(nodeType) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return (0, $lRu98.createJoinNodesRule)(/^\s*>\s$/, nodeType);
}
/**
 * Get heading rules
 *
 * @param {Schema} schema
 * @returns {InputRuleWithHandler[]}
 */ function $e78ff6e25e870e0f$var$getHeadingRules(editorAnalyticsAPI, schema) {
    // '# ' for h1, '## ' for h2 and etc
    const hashRule = $e78ff6e25e870e0f$var$headingRule(schema.nodes.heading, $e78ff6e25e870e0f$var$MAX_HEADING_LEVEL);
    const leftNodeReplacementHashRule = (0, $leZY6.createRule)(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    new RegExp(`${(0, $82vn7.leafNodeReplacementCharacter)}(#{1,6})\\s$`), (state, match, start, end)=>{
        const level = match[1].length;
        return (0, $piMVJ.insertBlock)(state, schema.nodes.heading, start, end, {
            level: level
        });
    });
    // New analytics handler
    const ruleWithHeadingAnalytics = (0, $leZY6.inputRuleWithAnalytics)((_state, matchResult)=>({
            action: (0, $bMFKb.ACTION).FORMATTED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
            actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_HEADING,
            attributes: {
                inputMethod: (0, $bMFKb.INPUT_METHOD).FORMATTING,
                newHeadingLevel: $e78ff6e25e870e0f$var$getHeadingLevel(matchResult).level
            }
        }), editorAnalyticsAPI);
    return [
        ruleWithHeadingAnalytics(hashRule),
        ruleWithHeadingAnalytics(leftNodeReplacementHashRule)
    ];
}
/**
 * Get all block quote input rules
 *
 * @param {Schema} schema
 * @returns {InputRuleWithHandler[]}
 */ function $e78ff6e25e870e0f$var$getBlockQuoteRules(editorAnalyticsAPI, schema) {
    // '> ' for blockquote
    const greatherThanRule = $e78ff6e25e870e0f$var$blockQuoteRule(schema.nodes.blockquote);
    const leftNodeReplacementGreatherRule = (0, $leZY6.createRule)(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    new RegExp(`${(0, $82vn7.leafNodeReplacementCharacter)}\\s*>\\s$`), (state, _match, start, end)=>{
        return (0, $piMVJ.insertBlock)(state, schema.nodes.blockquote, start, end);
    });
    // Analytics V3 handler
    const ruleWithBlockQuoteAnalytics = (0, $leZY6.inputRuleWithAnalytics)({
        action: (0, $bMFKb.ACTION).FORMATTED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
        attributes: {
            inputMethod: (0, $bMFKb.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    return [
        ruleWithBlockQuoteAnalytics(greatherThanRule),
        ruleWithBlockQuoteAnalytics(leftNodeReplacementGreatherRule)
    ];
}
function $e78ff6e25e870e0f$var$inputRulePlugin(editorAnalyticsAPI, schema, featureFlags) {
    const rules = [];
    if (schema.nodes.heading) rules.push(...$e78ff6e25e870e0f$var$getHeadingRules(editorAnalyticsAPI, schema));
    if (schema.nodes.blockquote) rules.push(...$e78ff6e25e870e0f$var$getBlockQuoteRules(editorAnalyticsAPI, schema));
    if (rules.length !== 0) return new (0, $i8KtF.SafePlugin)((0, $jCfsG.createPlugin)('block-type', rules, {
        isBlockNodeRule: true
    }));
    return;
}
var $e78ff6e25e870e0f$export$2e2bcd8739ae039 = $e78ff6e25e870e0f$var$inputRulePlugin;

});
parcelRegister("piMVJ", function(module, exports) {
$parcel$export(module.exports, "insertBlock", () => $30b8ddabf0c2d0be$export$f51280337625031);

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");
const $30b8ddabf0c2d0be$export$f51280337625031 = (state, nodeType, start, end, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
attrs)=>{
    // To ensure that match is done after HardBreak.
    const { hardBreak: hardBreak, codeBlock: codeBlock, listItem: listItem } = state.schema.nodes;
    const $pos = state.doc.resolve(start);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if ($pos.nodeAfter.type !== hardBreak) return null;
    // To ensure no nesting is done. (unless we're inserting a codeBlock inside lists)
    if ($pos.depth > 1 && !(nodeType === codeBlock && (0, $BmspC.hasParentNodeOfType)(listItem)(state.selection))) return null;
    // Split at the start of autoformatting and delete formatting characters.
    let tr = state.tr.delete(start, end).split(start);
    let currentNode = tr.doc.nodeAt(start + 1);
    // If node has more content split at the end of autoformatting.
    let nodeHasMoreContent = false;
    tr.doc.nodesBetween(start, start + currentNode.nodeSize, (node, pos)=>{
        if (!nodeHasMoreContent && node.type === hardBreak) {
            nodeHasMoreContent = true;
            tr = tr.split(pos + 1).delete(pos, pos + 1);
        }
    });
    if (nodeHasMoreContent) currentNode = tr.doc.nodeAt(start + 1);
    // Create new node and fill with content of current node.
    const { blockquote: blockquote, paragraph: paragraph } = state.schema.nodes;
    let content;
    let depth;
    if (nodeType === blockquote) {
        depth = 3;
        content = [
            paragraph.create({}, currentNode.content)
        ];
    } else {
        depth = 2;
        content = currentNode.content;
    }
    const newNode = nodeType.create(attrs, content);
    // Add new node.
    tr = tr.setSelection(new (0, $3lIcL.NodeSelection)(tr.doc.resolve(start + 1)))// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    .replaceSelectionWith(newNode).setSelection(new (0, $3lIcL.TextSelection)(tr.doc.resolve(start + depth)));
    return tr;
};

});

parcelRegister("lRu98", function(module, exports) {
$parcel$export(module.exports, "isNodeAWrappingBlockNode", () => $a8f166db1835b456$export$3a2c03e35bc6c7a8);
$parcel$export(module.exports, "createJoinNodesRule", () => $a8f166db1835b456$export$1fe8b64ae159a0fa);
$parcel$export(module.exports, "createWrappingTextBlockRule", () => $a8f166db1835b456$export$644b98fd2fd87b8b);
$parcel$export(module.exports, "areBlockTypesDisabled", () => $a8f166db1835b456$export$52adb8d9a3386cb8);
$parcel$export(module.exports, "checkFormattingIsPresent", () => $a8f166db1835b456$export$4b48a1fc423972ea);
$parcel$export(module.exports, "hasBlockQuoteInOptions", () => $a8f166db1835b456$export$bce51f4ee2032263);

var $02q9c = parcelRequire("02q9c");

var $leZY6 = parcelRequire("leZY6");

var $92xoS = parcelRequire("92xoS");

var $h16z0 = parcelRequire("h16z0");
const $a8f166db1835b456$export$3a2c03e35bc6c7a8 = (node)=>{
    if (!node) return false;
    return (0, $h16z0.WRAPPER_BLOCK_TYPES).some((blockNode)=>blockNode.name === node.type.name);
};
const $a8f166db1835b456$export$1fe8b64ae159a0fa = (match, nodeType)=>{
    return (0, $leZY6.createWrappingJoinRule)({
        nodeType: nodeType,
        match: match,
        getAttrs: {},
        joinPredicate: (_, node)=>node.type === nodeType
    });
};
const $a8f166db1835b456$export$644b98fd2fd87b8b = ({ match: match, nodeType: nodeType, getAttrs: getAttrs })=>{
    const handler = (state, match, start, end)=>{
        const fixedStart = Math.max(start, 1);
        const $start = state.doc.resolve(fixedStart);
        const attrs = getAttrs instanceof Function ? getAttrs(match) : getAttrs;
        const nodeBefore = $start.node(-1);
        if (nodeBefore && !nodeBefore.canReplaceWith($start.index(-1), $start.indexAfter(-1), nodeType)) return null;
        return state.tr.delete(fixedStart, end).setBlockType(fixedStart, fixedStart, nodeType, attrs);
    };
    return (0, $leZY6.createRule)(match, handler);
};
/**
 * Function will create a list of wrapper blocks present in a selection.
 */ function $a8f166db1835b456$var$getSelectedWrapperNodes(state) {
    const nodes = [];
    if (state.selection) {
        const { $from: $from, $to: $to } = state.selection;
        const { blockquote: blockquote, panel: panel, orderedList: orderedList, bulletList: bulletList, listItem: listItem, caption: caption, codeBlock: codeBlock, decisionItem: decisionItem, decisionList: decisionList, taskItem: taskItem, taskList: taskList } = state.schema.nodes;
        const wrapperNodes = [
            blockquote,
            panel,
            orderedList,
            bulletList,
            listItem,
            codeBlock,
            decisionItem,
            decisionList,
            taskItem,
            taskList
        ];
        wrapperNodes.push(caption);
        state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
            if (node.isBlock && wrapperNodes.indexOf(node.type) >= 0) nodes.push(node.type);
        });
    }
    return nodes;
}
function $a8f166db1835b456$export$52adb8d9a3386cb8(state) {
    const nodesTypes = $a8f166db1835b456$var$getSelectedWrapperNodes(state);
    const { panel: panel, blockquote: blockquote, bulletList: bulletList, orderedList: orderedList } = state.schema.nodes;
    if ((0, $92xoS.editorExperiment)('platform_editor_blockquote_in_text_formatting_menu', true)) {
        let hasQuote = false;
        let hasNestedListInQuote = false;
        const { $from: $from, $to: $to } = state.selection;
        state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
            if (node.type === blockquote) {
                hasQuote = true;
                node.descendants((child)=>{
                    if (child.type === bulletList || child.type === orderedList) {
                        hasNestedListInQuote = true;
                        return false;
                    }
                    return true;
                });
            }
            return !hasNestedListInQuote;
        });
        return nodesTypes.filter((type)=>type !== panel).length > 0 && (!hasQuote || hasNestedListInQuote);
    }
    return nodesTypes.filter((type)=>type !== panel).length > 0;
}
const $a8f166db1835b456$var$blockStylingIsPresent = (state)=>{
    const { from: from, to: to } = state.selection;
    let isBlockStyling = false;
    state.doc.nodesBetween(from, to, (node)=>{
        if ((0, $h16z0.FORMATTING_NODE_TYPES).indexOf(node.type.name) !== -1) {
            isBlockStyling = true;
            return false;
        }
        return true;
    });
    return isBlockStyling;
};
const $a8f166db1835b456$var$marksArePresent = (state)=>{
    const activeMarkTypes = (0, $h16z0.FORMATTING_MARK_TYPES).filter((mark)=>{
        if (!!state.schema.marks[mark]) {
            const { $from: $from, empty: empty } = state.selection;
            const { marks: marks } = state.schema;
            if (empty) return !!marks[mark].isInSet(state.storedMarks || $from.marks());
            return (0, $02q9c.anyMarkActive)(state, marks[mark]);
        }
        return false;
    });
    return activeMarkTypes.length > 0;
};
const $a8f166db1835b456$export$4b48a1fc423972ea = (state)=>{
    return $a8f166db1835b456$var$marksArePresent(state) || $a8f166db1835b456$var$blockStylingIsPresent(state);
};
const $a8f166db1835b456$export$bce51f4ee2032263 = (dropdownOptions)=>{
    return !!dropdownOptions.find((blockType)=>blockType.name === 'blockquote');
};

});
parcelRegister("02q9c", function(module, exports) {
$parcel$export(module.exports, "anyMarkActive", () => $df38474d8872f1f5$export$3d7a3b3f27c57f56);
$parcel$export(module.exports, "wholeSelectionHasMarks", () => $df38474d8872f1f5$export$a4048c78ac7b54c8);
$parcel$export(module.exports, "isMarkAllowedInRange", () => $df38474d8872f1f5$export$22a8bb98a26ef60);
$parcel$export(module.exports, "isMarkExcluded", () => $df38474d8872f1f5$export$87b559fec4a10a1a);

var $3xw6l = parcelRequire("3xw6l");

var $cwzAY = parcelRequire("cwzAY");

var $cbSL1 = parcelRequire("cbSL1");
const $df38474d8872f1f5$export$3d7a3b3f27c57f56 = (state, markType)=>{
    const { $from: $from, from: from, to: to, empty: empty } = state.selection;
    if (empty) return !!markType.isInSet(state.storedMarks || $from.marks());
    let rangeHasMark = false;
    if (state.selection instanceof (0, $cwzAY.CellSelection)) state.selection.forEachCell((cell, cellPos)=>{
        const from = cellPos;
        const to = cellPos + cell.nodeSize;
        if (!rangeHasMark) rangeHasMark = state.doc.rangeHasMark(from, to, markType);
    });
    else rangeHasMark = state.doc.rangeHasMark(from, to, markType);
    return rangeHasMark;
};
const $df38474d8872f1f5$var$allMarksAreRuledOut = (marks)=>Array.from(marks.values()).every((mark)=>!mark);
const $df38474d8872f1f5$export$a4048c78ac7b54c8 = (state, markTypes)=>{
    const { $from: $from, from: from, to: to, empty: empty } = state.selection;
    if (empty) return new Map(markTypes.map((markType)=>[
            markType,
            !!markType.isInSet(state.storedMarks || $from.marks())
        ]));
    if (state.selection instanceof (0, $cwzAY.CellSelection)) return $df38474d8872f1f5$var$cellSelectionHasMarks(state.doc, state.selection, markTypes);
    return $df38474d8872f1f5$var$wholeRangeHasMarks(from, to, state.doc, markTypes);
};
const $df38474d8872f1f5$var$cellSelectionHasMarks = (doc, selection, markTypes)=>{
    // Warning: This is micro-optimized and is a total pain to actually read.
    // Will attempt to explain in comments.
    // Start with map of booleans for each mark
    let cellsHaveMarks = new Map(markTypes.map((markType)=>[
            markType,
            true
        ]));
    selection.forEachCell((cell, cellPos)=>{
        // Early exit if all marks are already ruled out
        if ($df38474d8872f1f5$var$allMarksAreRuledOut(cellsHaveMarks)) return;
        const from = cellPos;
        const to = cellPos + cell.nodeSize;
        // On first cell just do a regular check
        if (!cellsHaveMarks) cellsHaveMarks = $df38474d8872f1f5$var$wholeRangeHasMarks(from, to, doc, markTypes);
        else {
            // Find the marks that are still true ie the ones that haven't been ruled out in
            // previous cells. The idea here is to whittle down the list of marks so that we check
            // less and less as we go, giving `wholeRangeHasMarks` more opportunities to exit early
            const marksToCheck = [];
            for (const [markType, hasMark] of cellsHaveMarks)if (hasMark) marksToCheck.push(markType);
            // Look specifically for the marks that are not yet ruled out.
            const cellHasMarks = $df38474d8872f1f5$var$wholeRangeHasMarks(from, to, doc, marksToCheck);
            // Map these results back into the original array of results and repeat!
            for (const [markType, hasMark] of cellHasMarks)cellsHaveMarks.set(markType, hasMark);
        }
    });
    return cellsHaveMarks;
};
const $df38474d8872f1f5$var$wholeRangeHasMarks = (from, to, doc, markTypes)=>{
    const hasMarks = new Map(markTypes.map((markType)=>[
            markType,
            true
        ]));
    const hasNoMarks = new Map(markTypes.map((markType)=>[
            markType,
            false
        ]));
    let isTextContent = false;
    doc.nodesBetween(from, to, (node)=>{
        if ($df38474d8872f1f5$var$allMarksAreRuledOut(hasMarks)) // This won't be a true early exit, but will prevent diving into nodes and
        // any checks further down the function.
        return false;
        if (!node.type.isText) return true; // continue traversing
        isTextContent = true;
        for (const [markType, hasMark] of hasMarks){
            if (!hasMark) continue; // already ruled out the mark, skip further checks
            const value = markType instanceof (0, $3xw6l.Mark) ? markType.isInSet(node.marks) : node.marks.some((mark)=>mark.type === markType);
            hasMarks.set(markType, value);
        }
    });
    if ((0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_patch_3', 'isEnabled', true)) return isTextContent ? hasMarks : hasNoMarks;
    return hasMarks;
};
const $df38474d8872f1f5$export$22a8bb98a26ef60 = (doc, ranges, type)=>{
    for(let i = 0; i < ranges.length; i++){
        const { $from: $from, $to: $to } = ranges[i];
        let can = $from.depth === 0 ? doc.type.allowsMarkType(type) : false;
        doc.nodesBetween($from.pos, $to.pos, (node)=>{
            if (can) return false;
            can = node.inlineContent && node.type.allowsMarkType(type);
            return;
        });
        if (can) return can;
    }
    return false;
};
const $df38474d8872f1f5$export$87b559fec4a10a1a = (type, marks)=>{
    if (marks) return marks.some((mark)=>mark.type !== type && mark.type.excludes(type));
    return false;
};

});



parcelRegister("5P4L6", function(module, exports) {
$parcel$export(module.exports, "default", () => $2115116b1a0d7d22$export$2e2bcd8739ae039);

var $bMFKb = parcelRequire("bMFKb");

var $6Exgk = parcelRequire("6Exgk");
var $c9NXO = parcelRequire("c9NXO");

var $HOLTj = parcelRequire("HOLTj");

var $dEkUJ = parcelRequire("dEkUJ");

var $apqw1 = parcelRequire("apqw1");

var $h16z0 = parcelRequire("h16z0");

var $aGH6G = parcelRequire("aGH6G");

var $5WRdy = parcelRequire("5WRdy");

var $8Pvq1 = parcelRequire("8Pvq1");

var $lRu98 = parcelRequire("lRu98");
const $2115116b1a0d7d22$var$backspaceCommand = (0, $dEkUJ.chainCommands)((0, $aGH6G.cleanUpAtTheStartOfDocument), (0, $8Pvq1.deleteBlockContent)((0, $lRu98.isNodeAWrappingBlockNode)), (0, $5WRdy.deleteAndMoveCursor));
const $2115116b1a0d7d22$var$del = (0, $dEkUJ.chainCommands)((0, $HOLTj.deleteEmptyParagraphAndMoveBlockUp)((0, $lRu98.isNodeAWrappingBlockNode)), (0, $8Pvq1.deleteBlockContent)((0, $lRu98.isNodeAWrappingBlockNode)), (0, $5WRdy.deleteAndMoveCursor));
function $2115116b1a0d7d22$export$2e2bcd8739ae039(editorAnalyticsApi, schema, _featureFlags) {
    const list = {};
    (0, $6Exgk.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.insertNewLine).common, (0, $HOLTj.insertNewLineWithAnalytics)(editorAnalyticsApi), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.bindKeymapWithCommand)((0, $6Exgk.moveUp).common, (0, $HOLTj.createNewParagraphAbove), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.bindKeymapWithCommand)((0, $6Exgk.moveDown).common, (0, $HOLTj.createNewParagraphBelow), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.bindKeymapWithCommand)((0, $6Exgk.findKeyMapForBrowser)((0, $6Exgk.redo)), (0, $apqw1.redo), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.bindKeymapWithCommand)((0, $6Exgk.undo).common, (0, $apqw1.undo), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.bindKeymapWithCommand)((0, $6Exgk.backspace).common, $2115116b1a0d7d22$var$backspaceCommand, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.bindKeymapWithCommand)((0, $6Exgk.deleteKey).common, $2115116b1a0d7d22$var$del, list);
    (0, $6Exgk.bindKeymapWithCommand)((0, $6Exgk.forwardDelete).mac, $2115116b1a0d7d22$var$del, list);
    if (schema.nodes[$h16z0.BLOCK_QUOTE.nodeName]) (0, $6Exgk.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.findShortcutByKeymap)((0, $6Exgk.toggleBlockQuote)), (0, $aGH6G.insertBlockQuoteWithAnalytics)((0, $bMFKb.INPUT_METHOD).KEYBOARD, editorAnalyticsApi), list);
    return (0, $c9NXO.keymap)(list);
}

});
parcelRegister("5WRdy", function(module, exports) {
$parcel$export(module.exports, "deleteAndMoveCursor", () => $b01b354482d51f58$export$6c408f720f6b44a7);

var $3lIcL = parcelRequire("3lIcL");
// We should override default behaviour when selection spans node depths or
// ends at a node junction
const $b01b354482d51f58$var$shouldMoveCursorAfterDelete = (state)=>{
    const { selection: { $from: $from, $to: $to } } = state;
    const nodeRange = $from.blockRange($to);
    if (!nodeRange) return false;
    const hasSameAncestor = $from.depth === $to.depth && $from.depth - 1 === nodeRange.depth;
    const toPositionHasNodeAfter = !!$to.nodeAfter;
    if (hasSameAncestor || toPositionHasNodeAfter) return false;
    return true;
};
const $b01b354482d51f58$export$6c408f720f6b44a7 = (state, dispatch)=>{
    if (state.selection.empty || !(state.selection instanceof (0, $3lIcL.TextSelection))) return false;
    if (!$b01b354482d51f58$var$shouldMoveCursorAfterDelete(state)) return false;
    const { tr: tr } = state;
    tr.deleteSelection();
    // Make sure the next position is not out of boundaries
    const previousPosition = Math.min(Math.max(state.selection.$from.pos, 0), tr.doc.content.size);
    // Override default delete behaviour that moves the cursor to first suitable position after selection (postive bias).
    // See. selectionToInsertionEnd. We will override behavior with negative bias (search for suitable cursor position backwards).
    tr.setSelection((0, $3lIcL.Selection).near(tr.doc.resolve(previousPosition), -1));
    if (dispatch) dispatch(tr.scrollIntoView());
    return true;
};

});

parcelRegister("8Pvq1", function(module, exports) {
$parcel$export(module.exports, "deleteBlockContent", () => $aaf6218b92354302$export$9c1a524875bfb8ec);

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");
// function to check whether the selected node is the sole decision item in the decision list
const $aaf6218b92354302$var$isSelectedNodeSoleDecisionItem = (state)=>{
    const isDecisionItemNodeSelected = state.selection instanceof (0, $3lIcL.NodeSelection) && state.selection.node.type.name === 'decisionItem';
    if (!isDecisionItemNodeSelected) return false;
    const decisionList = (0, $BmspC.findParentNodeOfType)([
        state.schema.nodes.decisionList
    ])(state.selection)?.node;
    return decisionList?.childCount === 1;
};
const $aaf6218b92354302$var$isSelectedNodeMediaGroup = (state)=>{
    return Boolean(state.selection instanceof (0, $3lIcL.NodeSelection) && state.selection.node.type.name === 'media' && state.selection.$head.parent.type.name === 'mediaGroup');
};
function $aaf6218b92354302$export$9c1a524875bfb8ec(isNodeAWrappingBlockNode) {
    return (state, dispatch)=>{
        const { tr: tr, selection: { $from: $from, $to: $to }, doc: doc } = state;
        if ($from.pos === $to.pos) return false;
        let selectionCrossesWrappingBlockNode = false;
        doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            // Optimisation. If selection crosses wrapping block node
            // short circuit the loop by returning false
            if (isNodeAWrappingBlockNode(node)) {
                selectionCrossesWrappingBlockNode = true;
                return false;
            }
        });
        if (!selectionCrossesWrappingBlockNode) return false;
        const isParentNodeOfTypePanel = (0, $BmspC.hasParentNodeOfType)([
            state.schema.nodes.panel
        ])(state.selection);
        const isParentNodeOfTypeBlockQuote = (0, $BmspC.hasParentNodeOfType)([
            state.schema.nodes.blockquote
        ])(state.selection);
        if ((isParentNodeOfTypePanel || isParentNodeOfTypeBlockQuote) && $aaf6218b92354302$var$isSelectedNodeMediaGroup(state) || isParentNodeOfTypePanel && $aaf6218b92354302$var$isSelectedNodeSoleDecisionItem(state)) {
            tr.setSelection(new (0, $3lIcL.TextSelection)(tr.doc.resolve($from.before())));
            tr.delete($from.before(), $from.after());
        } else tr.delete($from.pos, $to.pos);
        if (dispatch) dispatch(tr);
        return true;
    };
}

});


parcelRegister("8wIsi", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $83ea502db08eb91b$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "createPlugin", () => $83ea502db08eb91b$export$ae829ec7b2625219);

var $bMFKb = parcelRequire("bMFKb");

var $7EdFW = parcelRequire("7EdFW");

var $i8KtF = parcelRequire("i8KtF");

var $3lIcL = parcelRequire("3lIcL");

var $eGOwo = parcelRequire("eGOwo");

var $cbSL1 = parcelRequire("cbSL1");

var $h16z0 = parcelRequire("h16z0");

var $aGH6G = parcelRequire("aGH6G");

var $jCRHz = parcelRequire("jCRHz");

var $lRu98 = parcelRequire("lRu98");
const $83ea502db08eb91b$var$blockTypeForNode = (node, schema)=>{
    if (node.type === schema.nodes.heading) {
        const maybeNode = (0, $h16z0.HEADINGS_BY_LEVEL)[node.attrs['level']];
        if (maybeNode) return maybeNode;
    } else if (node.type === schema.nodes.paragraph) return 0, $h16z0.NORMAL_TEXT;
    else if (node.type === schema.nodes.blockquote) return 0, $h16z0.BLOCK_QUOTE;
    return 0, $h16z0.OTHER;
};
const $83ea502db08eb91b$var$isBlockTypeSchemaSupported = (blockType, state)=>{
    switch(blockType){
        case 0, $h16z0.NORMAL_TEXT:
            return !!state.schema.nodes.paragraph;
        case 0, $h16z0.HEADING_1:
        case 0, $h16z0.HEADING_2:
        case 0, $h16z0.HEADING_3:
        case 0, $h16z0.HEADING_4:
        case 0, $h16z0.HEADING_5:
        case 0, $h16z0.HEADING_6:
            return !!state.schema.nodes.heading;
        case 0, $h16z0.BLOCK_QUOTE:
            return !!state.schema.nodes.blockquote;
        case 0, $h16z0.CODE_BLOCK:
            return !!state.schema.nodes.codeBlock;
        case 0, $h16z0.PANEL:
            return !!state.schema.nodes.panel;
    }
    return;
};
const $83ea502db08eb91b$var$detectBlockType = (availableBlockTypes, state)=>{
    // Before a document is loaded, there is no selection.
    if (!state.selection) return 0, $h16z0.NORMAL_TEXT;
    let blockType;
    const { $from: $from, $to: $to } = state.selection;
    state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
        const nodeBlockType = availableBlockTypes.filter((blockType)=>blockType === $83ea502db08eb91b$var$blockTypeForNode(node, state.schema));
        if (nodeBlockType.length > 0) {
            if (!blockType) blockType = nodeBlockType[0];
            else if (blockType !== (0, $h16z0.OTHER) && blockType !== nodeBlockType[0]) blockType = (0, $h16z0.OTHER);
            return false;
        }
    });
    return blockType || (0, $h16z0.OTHER);
};
const $83ea502db08eb91b$var$autoformatHeading = (headingLevel, editorAnalyticsApi)=>{
    if (headingLevel === 0) return (0, $aGH6G.setNormalTextWithAnalytics)((0, $bMFKb.INPUT_METHOD).FORMATTING, editorAnalyticsApi);
    return (0, $aGH6G.setHeadingWithAnalytics)(headingLevel, (0, $bMFKb.INPUT_METHOD).FORMATTING, editorAnalyticsApi);
};
const $83ea502db08eb91b$export$18d4026d1ea86bb1 = new (0, $3lIcL.PluginKey)('blockTypePlugin');
const $83ea502db08eb91b$export$ae829ec7b2625219 = (editorAPI, // eslint-disable-next-line @typescript-eslint/no-explicit-any
dispatch, lastNodeMustBeParagraph, includeBlockQuoteAsTextstyleOption)=>{
    const editorAnalyticsApi = editorAPI?.analytics?.actions;
    let altKeyLocation = 0;
    return new (0, $i8KtF.SafePlugin)({
        appendTransaction (_transactions, _oldState, newState) {
            if (lastNodeMustBeParagraph) {
                const pos = newState.doc.resolve(newState.doc.content.size - 1);
                const lastNode = pos.node(1);
                const { paragraph: paragraph } = newState.schema.nodes;
                if (lastNode && lastNode.isBlock && lastNode.type !== paragraph) return newState.tr.insert(newState.doc.content.size, newState.schema.nodes.paragraph.create()).setMeta('addToHistory', false);
            }
        },
        state: {
            init (_config, state) {
                const availableBlockTypes = (0, $h16z0.TEXT_BLOCK_TYPES).filter((blockType)=>$83ea502db08eb91b$var$isBlockTypeSchemaSupported(blockType, state));
                const availableWrapperBlockTypes = (0, $h16z0.WRAPPER_BLOCK_TYPES).filter((blockType)=>$83ea502db08eb91b$var$isBlockTypeSchemaSupported(blockType, state));
                const BLOCK_TYPES_IN_DROPDOWN = (0, $h16z0.getBlockTypesInDropdown)(includeBlockQuoteAsTextstyleOption);
                const availableBlockTypesInDropdown = BLOCK_TYPES_IN_DROPDOWN.filter((blockType)=>$83ea502db08eb91b$var$isBlockTypeSchemaSupported(blockType, state));
                const formattingIsPresent = (0, $lRu98.hasBlockQuoteInOptions)(availableBlockTypesInDropdown) ? (0, $lRu98.checkFormattingIsPresent)(state) : undefined;
                return {
                    currentBlockType: $83ea502db08eb91b$var$detectBlockType(availableBlockTypesInDropdown, state),
                    blockTypesDisabled: (0, $lRu98.areBlockTypesDisabled)(state),
                    availableBlockTypes: availableBlockTypes,
                    availableWrapperBlockTypes: availableWrapperBlockTypes,
                    availableBlockTypesInDropdown: availableBlockTypesInDropdown,
                    formattingIsPresent: formattingIsPresent
                };
            },
            apply (_tr, oldPluginState, _oldState, newState) {
                const newPluginState = {
                    ...oldPluginState,
                    currentBlockType: $83ea502db08eb91b$var$detectBlockType(oldPluginState.availableBlockTypesInDropdown, newState),
                    blockTypesDisabled: (0, $lRu98.areBlockTypesDisabled)(newState),
                    formattingIsPresent: (0, $lRu98.hasBlockQuoteInOptions)(oldPluginState.availableBlockTypesInDropdown) ? (0, $lRu98.checkFormattingIsPresent)(newState) : undefined
                };
                if (newPluginState.currentBlockType !== oldPluginState.currentBlockType || newPluginState.blockTypesDisabled !== oldPluginState.blockTypesDisabled || newPluginState.formattingIsPresent !== oldPluginState.formattingIsPresent) dispatch($83ea502db08eb91b$export$18d4026d1ea86bb1, newPluginState);
                return newPluginState;
            }
        },
        key: $83ea502db08eb91b$export$18d4026d1ea86bb1,
        props: {
            /**
			 * As we only want the left alt key to work for headings shortcuts on Windows
			 * we can't use prosemirror-keymap and need to handle these shortcuts specially
			 * Shortcut on Mac: Cmd-Opt-{heading level}
			 * Shortcut on Windows: Ctrl-LeftAlt-{heading level}
			 */ handleKeyDown: (view, event)=>{
                let headingLevel = (0, $jCRHz.HEADING_KEYS).indexOf(event.keyCode);
                if (headingLevel === -1 && (0, $eGOwo.fg)('platform_editor_heading_from_numpad')) // Check for numpad keys if not found in digits row
                headingLevel = (0, $jCRHz.HEADING_NUMPAD_KEYS).indexOf(event.keyCode);
                const browser = (0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $7EdFW.getBrowserInfo)() : (0, $7EdFW.browser);
                if (headingLevel > -1 && event.altKey) {
                    if (browser.mac && event.metaKey) return editorAPI?.core?.actions.execute($83ea502db08eb91b$var$autoformatHeading(headingLevel, editorAnalyticsApi)) ?? false;
                    else if (!browser.mac && event.ctrlKey && altKeyLocation !== event.DOM_KEY_LOCATION_RIGHT) return editorAPI?.core?.actions.execute($83ea502db08eb91b$var$autoformatHeading(headingLevel, editorAnalyticsApi)) ?? false;
                } else if (event.key === 'Alt') // event.location is for the current key only; when a user hits Ctrl-Alt-1 the
                // location refers to the location of the '1' key
                // We store the location of the Alt key when it is hit to check against later
                altKeyLocation = event.location;
                else if (!event.altKey) altKeyLocation = 0;
                return false;
            }
        }
    });
};

});
parcelRegister("jCRHz", function(module, exports) {
$parcel$export(module.exports, "HEADING_KEYS", () => $eef3fa157c3caefb$export$442e847723cf0569);
$parcel$export(module.exports, "HEADING_NUMPAD_KEYS", () => $eef3fa157c3caefb$export$fcc4b4cb2de35e6);
const $eef3fa157c3caefb$var$KEY_0 = 48;
const $eef3fa157c3caefb$var$KEY_1 = 49;
const $eef3fa157c3caefb$var$KEY_2 = 50;
const $eef3fa157c3caefb$var$KEY_3 = 51;
const $eef3fa157c3caefb$var$KEY_4 = 52;
const $eef3fa157c3caefb$var$KEY_5 = 53;
const $eef3fa157c3caefb$var$KEY_6 = 54;
const $eef3fa157c3caefb$export$442e847723cf0569 = [
    $eef3fa157c3caefb$var$KEY_0,
    $eef3fa157c3caefb$var$KEY_1,
    $eef3fa157c3caefb$var$KEY_2,
    $eef3fa157c3caefb$var$KEY_3,
    $eef3fa157c3caefb$var$KEY_4,
    $eef3fa157c3caefb$var$KEY_5,
    $eef3fa157c3caefb$var$KEY_6
];
const $eef3fa157c3caefb$var$NUMPAD_KEY_0 = 96;
const $eef3fa157c3caefb$var$NUMPAD_KEY_1 = 97;
const $eef3fa157c3caefb$var$NUMPAD_KEY_2 = 98;
const $eef3fa157c3caefb$var$NUMPAD_KEY_3 = 99;
const $eef3fa157c3caefb$var$NUMPAD_KEY_4 = 100;
const $eef3fa157c3caefb$var$NUMPAD_KEY_5 = 101;
const $eef3fa157c3caefb$var$NUMPAD_KEY_6 = 102;
const $eef3fa157c3caefb$export$fcc4b4cb2de35e6 = [
    $eef3fa157c3caefb$var$NUMPAD_KEY_0,
    $eef3fa157c3caefb$var$NUMPAD_KEY_1,
    $eef3fa157c3caefb$var$NUMPAD_KEY_2,
    $eef3fa157c3caefb$var$NUMPAD_KEY_3,
    $eef3fa157c3caefb$var$NUMPAD_KEY_4,
    $eef3fa157c3caefb$var$NUMPAD_KEY_5,
    $eef3fa157c3caefb$var$NUMPAD_KEY_6
];

});


parcelRegister("beO9L", function(module, exports) {
$parcel$export(module.exports, "FloatingToolbarComponent", () => $79cbb34da80cd52a$export$b15abb95157a91c7);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $bMFKb = parcelRequire("bMFKb");

var $cxXTK = parcelRequire("cxXTK");

var $92xoS = parcelRequire("92xoS");

var $dcew5 = parcelRequire("dcew5");
const $79cbb34da80cd52a$var$FloatingToolbarSettings = {
    isSmall: true,
    disabled: false,
    isToolbarReducedSpacing: true,
    shouldUseDefaultRole: false
};
function $79cbb34da80cd52a$export$b15abb95157a91c7({ api: api }) {
    const { currentBlockType: currentBlockType, blockTypesDisabled: blockTypesDisabled, availableBlockTypes: availableBlockTypes, availableBlockTypesInDropdown: availableBlockTypesInDropdown, formattingIsPresent: formattingIsPresent } = (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'blockType'
    ], (states)=>({
            currentBlockType: states.blockTypeState?.currentBlockType,
            blockTypesDisabled: states.blockTypeState?.blockTypesDisabled,
            availableBlockTypes: states.blockTypeState?.availableBlockTypes,
            availableBlockTypesInDropdown: states.blockTypeState?.availableBlockTypesInDropdown,
            formattingIsPresent: states.blockTypeState?.formattingIsPresent
        }));
    const boundSetBlockType = (0, $eJOHy.useCallback)((name, fromBlockQuote)=>api?.core?.actions.execute(api?.blockType?.commands?.setTextLevel(name, (0, $bMFKb.INPUT_METHOD).FLOATING_TB, fromBlockQuote)), [
        api
    ]);
    const wrapBlockQuote = (0, $eJOHy.useCallback)(()=>api?.core?.actions.execute(api?.blockType?.commands?.insertBlockQuote((0, $bMFKb.INPUT_METHOD).FLOATING_TB)), [
        api
    ]);
    const clearFormatting = (0, $eJOHy.useCallback)(()=>api?.core?.actions.execute(api?.blockType?.commands?.clearFormatting((0, $bMFKb.INPUT_METHOD).FLOATING_TB)), [
        api
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dcew5.default), {
        isSmall: $79cbb34da80cd52a$var$FloatingToolbarSettings.isSmall,
        isDisabled: $79cbb34da80cd52a$var$FloatingToolbarSettings.disabled,
        isReducedSpacing: (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? false : $79cbb34da80cd52a$var$FloatingToolbarSettings.isToolbarReducedSpacing,
        setTextLevel: boundSetBlockType,
        currentBlockType: currentBlockType,
        blockTypesDisabled: blockTypesDisabled,
        availableBlockTypes: availableBlockTypes,
        availableBlockTypesInDropdown: availableBlockTypesInDropdown,
        formattingIsPresent: formattingIsPresent,
        wrapBlockQuote: wrapBlockQuote,
        clearFormatting: clearFormatting,
        shouldUseDefaultRole: $79cbb34da80cd52a$var$FloatingToolbarSettings.shouldUseDefaultRole,
        api: api
    });
}

});
parcelRegister("dcew5", function(module, exports) {
$parcel$export(module.exports, "default", () => $c726f23a9024491f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");

var $6Exgk = parcelRequire("6Exgk");

var $1D5wE = parcelRequire("1D5wE");

var $fcJnk = parcelRequire("fcJnk");

var $aPcNU = parcelRequire("aPcNU");

var $7yBx7 = parcelRequire("7yBx7");

var $8hNRj = parcelRequire("8hNRj");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $92xoS = parcelRequire("92xoS");

var $7I1UL = parcelRequire("7I1UL");

var $h16z0 = parcelRequire("h16z0");

var $h5iWO = parcelRequire("h5iWO");

var $fAjN9 = parcelRequire("fAjN9");
const $c726f23a9024491f$var$buttonWrapperStyles = (0, $1DXK0.xcss)({
    flexShrink: 0
});
// eslint-disable-next-line @repo/internal/react/no-class-components
class $c726f23a9024491f$var$ToolbarBlockType extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    componentDidMount() {
        const observer = new (0, $7I1UL.default)(({ typography: typography })=>{
            if (typography !== this.state.typographyTheme) this.setState({
                typographyTheme: typography
            });
        });
        this.setState({
            observer: observer
        });
        observer.observe();
    }
    componentWillUnmount() {
        this.state.observer?.disconnect();
    }
    render() {
        const { active: active, isOpenedByKeyboard: isOpenedByKeyboard } = this.state;
        const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isSmall: isSmall, isReducedSpacing: isReducedSpacing, currentBlockType: currentBlockType, blockTypesDisabled: blockTypesDisabled, availableBlockTypes: availableBlockTypes = [], availableBlockTypesInDropdown: availableBlockTypesInDropdown = [], shouldUseDefaultRole: shouldUseDefaultRole, intl: { formatMessage: formatMessage }, api: api } = this.props;
        const isHeadingDisabled = !availableBlockTypes.some((blockType)=>blockType.nodeName === 'heading');
        if (isHeadingDisabled) return null;
        const blockTypeTitles = availableBlockTypesInDropdown.filter((blockType)=>blockType.name === currentBlockType?.name).map((blockType)=>blockType.title);
        const defaultIcon = /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8hNRj))), {
            label: ""
        });
        const currentIcon = currentBlockType?.icon;
        if (!this.props.isDisabled && !blockTypesDisabled) {
            const items = this.createItems();
            const button = /*#__PURE__*/ (0, $1NIU8.jsx)((0, $h5iWO.BlockTypeButton), {
                isSmall: isSmall,
                isReducedSpacing: isReducedSpacing,
                selected: active,
                disabled: false,
                title: blockTypeTitles[0],
                onClick: this.handleTriggerClick,
                onKeyDown: this.handleTriggerByKeyboard,
                formatMessage: formatMessage,
                "aria-expanded": active,
                blockTypeName: currentBlockType?.name,
                blockTypeIcon: currentIcon || defaultIcon
            });
            return /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
                css: (0, $92xoS.editorExperiment)('platform_editor_blockquote_in_text_formatting_menu', true) ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                [
                    (0, $fcJnk.wrapperStyle),
                    (0, $fAjN9.floatingToolbarWrapperStyle)
                ] : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $fcJnk.wrapperStyle)
            }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $aPcNU.DropdownMenuWithKeyboardNavigation), {
                items: items,
                onOpenChange: this.onOpenChange,
                onItemActivated: this.handleSelectBlockType,
                isOpen: active,
                mountTo: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement,
                zIndex: (0, $7yBx7.akEditorMenuZIndex),
                fitHeight: 360,
                fitWidth: 106,
                section: {
                    hasSeparator: true
                },
                shouldUseDefaultRole: shouldUseDefaultRole,
                // hasSeparator={true}
                shouldFocusFirstItem: ()=>{
                    if (isOpenedByKeyboard) // eslint-disable-next-line @repo/internal/react/no-set-state-inside-render
                    this.setState({
                        ...this.state,
                        isOpenedByKeyboard: false
                    });
                    return isOpenedByKeyboard;
                }
            }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8nu6j.default), {
                xcss: $c726f23a9024491f$var$buttonWrapperStyles
            }, button)), !api?.primaryToolbar && /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $fcJnk.separatorStyles)
            }));
        }
        return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            css: (0, $fcJnk.wrapperStyle)
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $h5iWO.BlockTypeButton), {
            isSmall: isSmall,
            isReducedSpacing: isReducedSpacing,
            selected: active,
            disabled: true,
            title: blockTypeTitles[0],
            onClick: this.handleTriggerClick,
            onKeyDown: this.handleTriggerByKeyboard,
            formatMessage: formatMessage,
            "aria-expanded": active,
            blockTypeName: currentBlockType?.name,
            blockTypeIcon: currentIcon || defaultIcon
        }), !api?.primaryToolbar && /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: (0, $fcJnk.separatorStyles)
        })));
    }
    constructor(...args){
        super(...args), this.state = {
            active: false,
            isOpenedByKeyboard: false,
            typographyTheme: undefined,
            observer: null
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onOpenChange = (attrs)=>{
            this.setState({
                ...this.state,
                active: attrs.isOpen,
                isOpenedByKeyboard: attrs.isOpenedByKeyboard
            });
        }, this.handleTriggerClick = ()=>{
            this.onOpenChange({
                isOpen: !this.state.active,
                isOpenedByKeyboard: false
            });
        }, this.handleTriggerByKeyboard = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.onOpenChange({
                    isOpen: !this.state.active,
                    isOpenedByKeyboard: true
                });
            }
        }, this.createItems = ()=>{
            const { intl: { formatMessage: formatMessage }, currentBlockType: currentBlockType, availableBlockTypesInDropdown: availableBlockTypesInDropdown, formattingIsPresent: formattingIsPresent } = this.props;
            const items = (availableBlockTypesInDropdown ?? []).map((blockType, index)=>{
                const isActive = currentBlockType === blockType;
                const tagName = blockType.tagName || 'p';
                const Tag = tagName;
                const defaultMessage = Array.isArray(blockType.title.defaultMessage) ? blockType.title.defaultMessage.find((message)=>'value' in message) : blockType.title.defaultMessage;
                const description = typeof defaultMessage === 'string' ? defaultMessage : defaultMessage && 'value' in defaultMessage ? defaultMessage.value : '';
                const keyMap = (0, $6Exgk.findKeymapByDescription)(description);
                const icon = blockType?.icon;
                const item = {
                    content: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
                        css: (0, $fAjN9.blockTypeMenuItemStyle)(tagName, isActive, this.state.typographyTheme)
                    }, /*#__PURE__*/ (0, $1NIU8.jsx)(Tag, null, formatMessage(blockType.title))),
                    value: blockType,
                    'aria-label': (0, $6Exgk.tooltip)(keyMap, formatMessage(blockType.title)),
                    key: `${blockType.name}-${index}`,
                    elemBefore: (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? icon : undefined,
                    elemAfter: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
                        css: [
                            (0, $fAjN9.keyboardShortcut),
                            isActive && (0, $fAjN9.keyboardShortcutSelect)
                        ]
                    }, (0, $6Exgk.tooltip)(keyMap)),
                    isActive: isActive
                };
                return item;
            });
            if ((availableBlockTypesInDropdown ?? []).map((blockType)=>blockType.name).includes('blockquote') && (0, $92xoS.editorExperiment)('platform_editor_controls', 'control')) {
                const clearFormattingItem = {
                    content: /*#__PURE__*/ (0, $1NIU8.jsx)("div", null, /*#__PURE__*/ (0, $1NIU8.jsx)("p", null, (0, $1D5wE.toolbarMessages).clearFormatting.defaultMessage)),
                    value: {
                        name: 'clearFormatting'
                    },
                    'aria-label': (0, $6Exgk.tooltip)((0, $6Exgk.clearFormatting), (0, $1D5wE.toolbarMessages).clearFormatting.defaultMessage),
                    key: 'clear-formatting',
                    elemAfter: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
                        css: [
                            (0, $fAjN9.keyboardShortcut)
                        ]
                    }, (0, $6Exgk.tooltip)((0, $6Exgk.clearFormatting))),
                    isActive: false,
                    isDisabled: currentBlockType === (0, $h16z0.NORMAL_TEXT) && !formattingIsPresent
                };
                return [
                    {
                        items: items
                    },
                    {
                        items: [
                            clearFormattingItem
                        ]
                    }
                ];
            }
            return [
                {
                    items: items
                }
            ];
        }, this.handleSelectBlockType = ({ item: item, shouldCloseMenu: shouldCloseMenu = true })=>{
            const blockType = item.value;
            if (blockType.name === 'blockquote') this.props.wrapBlockQuote(blockType.name);
            else if (blockType.name === 'clearFormatting') this.props.clearFormatting();
            else {
                const fromBlockQuote = this.props.currentBlockType?.name === 'blockquote';
                this.props.setTextLevel(blockType.name, fromBlockQuote);
            }
            if (shouldCloseMenu) this.setState({
                ...this.state,
                active: false
            });
        };
    }
}
var $c726f23a9024491f$export$2e2bcd8739ae039 = (0, $6YFG2.default)($c726f23a9024491f$var$ToolbarBlockType);

});
parcelRegister("fcJnk", function(module, exports) {
$parcel$export(module.exports, "buttonGroupStyleBeforeVisualRefresh", () => $0e5673ef90675e29$export$7638a34f4ed2b514);
$parcel$export(module.exports, "buttonGroupStyle", () => $0e5673ef90675e29$export$5897f954e99cc6c0);
$parcel$export(module.exports, "separatorStyles", () => $0e5673ef90675e29$export$39b9f83b35c7456d);
$parcel$export(module.exports, "wrapperStyle", () => $0e5673ef90675e29$export$c4d4f06a25de97f);
$parcel$export(module.exports, "triggerWrapperStyles", () => $0e5673ef90675e29$export$147e2cce6f264c9b);
$parcel$export(module.exports, "triggerWrapperStylesWithPadding", () => $0e5673ef90675e29$export$f2c6a721c78d3c4a);
$parcel$export(module.exports, "disableBlueBorderStyles", () => $0e5673ef90675e29$export$cd86615b96818354);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");
function $0e5673ef90675e29$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0e5673ef90675e29$export$7638a34f4ed2b514 = {
    name: "ewpfso",
    styles: "display:inline-flex;align-items:center;& > div{display:flex;}button:not(#local-media-upload-button){&:not([disabled])::after{border:none;}}"
};
const $0e5673ef90675e29$export$5897f954e99cc6c0 = {
    name: "ioewc",
    styles: "display:inline-flex;align-items:center;& > div{display:flex;}button:not(#local-media-upload-button){&:not([disabled])::after{border:none;}}gap:var(--ds-space-050, 4px);div[role=group]{gap:var(--ds-space-050, 4px);}"
};
const $0e5673ef90675e29$export$39b9f83b35c7456d = /*#__PURE__*/ (0, $1NIU8.css)({
    background: "var(--ds-border, #091E4224)",
    width: '1px',
    height: '24px',
    display: 'inline-block',
    margin: `0 ${"var(--ds-space-100, 8px)"}`,
    userSelect: 'none'
});
const $0e5673ef90675e29$export$c4d4f06a25de97f = {
    name: "1ty89h5",
    styles: "display:flex;align-items:center;> div, > span{display:flex;}> div > div{display:flex;}margin-left:0;min-width:auto;button{&:not([disabled])::after{border:none;}}"
};
const $0e5673ef90675e29$export$147e2cce6f264c9b = {
    name: "wb8qky",
    styles: "display:flex;button{&:not([disabled])::after{border:none;}}"
};
const $0e5673ef90675e29$export$f2c6a721c78d3c4a = {
    name: "4sd07o",
    styles: "display:flex;padding-right:var(--ds-space-025, 2px);button{&:not([disabled])::after{border:none;}}"
};
const $0e5673ef90675e29$export$cd86615b96818354 = {
    name: "ox0lz7",
    styles: "&:not([disabled])::after{border:none;}"
};

});

parcelRegister("h5iWO", function(module, exports) {
$parcel$export(module.exports, "BlockTypeButton", () => $fba0099e23b010e5$export$60665cf15e769742);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $kDaaB = parcelRequire("kDaaB");

var $1D5wE = parcelRequire("1D5wE");

var $is7NW = parcelRequire("is7NW");
var $fcJnk = parcelRequire("fcJnk");

var $9Sic1 = parcelRequire("9Sic1");

var $5lAAn = parcelRequire("5lAAn");

var $8hNRj = parcelRequire("8hNRj");

var $exniU = parcelRequire("exniU");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $9Letn = parcelRequire("9Letn");

var $h16z0 = parcelRequire("h16z0");

var $fAjN9 = parcelRequire("fAjN9");
const $fba0099e23b010e5$var$buttonContentStyle = (0, $1DXK0.xcss)({
    minWidth: `calc(80px + 2*${"var(--ds-space-075, 6px)"})`,
    overflow: 'hidden',
    padding: 'space.075'
});
const $fba0099e23b010e5$var$buttonContentReducedSpacingStyle = (0, $1DXK0.xcss)({
    padding: 'space.100',
    minWidth: `calc(80px + 2*${"var(--ds-space-100, 8px)"})`
});
const $fba0099e23b010e5$export$60665cf15e769742 = (props)=>{
    const blockTypeName = props.blockTypeName || '';
    const labelTextStyles = props.formatMessage((0, $1D5wE.toolbarMessages).textStyles, {
        blockTypeName: blockTypeName
    });
    const toolipTextStyles = props.formatMessage((0, $1D5wE.toolbarMessages).textStylesTooltip);
    const icon = (0, $9Letn.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1') && props.blockTypeIcon ? props.blockTypeIcon : /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8hNRj))), {
        label: labelTextStyles,
        spacing: "spacious",
        color: "currentColor",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($exniU)))
    });
    const chevronIconSpacing = (0, $9Letn.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1') ? 'spacious' : 'none';
    const shouldUseIconAsButton = props.isSmall || (0, $9Letn.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1');
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $9Sic1.default), {
        spacing: props.isReducedSpacing ? 'none' : 'default',
        selected: props.selected,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "block-type-btn",
        disabled: props.disabled,
        onClick: props.onClick,
        onKeyDown: props.onKeyDown,
        title: toolipTextStyles,
        "aria-label": labelTextStyles,
        "aria-haspopup": true,
        "aria-expanded": props['aria-expanded'],
        iconAfter: /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: [
                (0, $fcJnk.wrapperStyle),
                props.isSmall && (0, $fAjN9.wrapperSmallStyle)
            ],
            "data-testid": "toolbar-block-type-text-styles-icon"
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, shouldUseIconAsButton && icon, /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: (0, $is7NW.expandIconContainerStyle)
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
            spacing: chevronIconSpacing,
            label: "",
            color: "currentColor",
            LEGACY_margin: "0 0 0 -8px",
            size: "small"
        }))))
    }, !shouldUseIconAsButton && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8nu6j.default), {
        xcss: [
            $fba0099e23b010e5$var$buttonContentStyle,
            props.isReducedSpacing && $fba0099e23b010e5$var$buttonContentReducedSpacingStyle
        ]
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $kDaaB.default), props.title || (0, $h16z0.NORMAL_TEXT).title)));
};

});
parcelRegister("exniU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9563970426cdd61$var$_react = $a9563970426cdd61$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $a9563970426cdd61$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a9563970426cdd61$var$EditorTextStyleIcon = (props)=>/*#__PURE__*/ $a9563970426cdd61$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m6.26 6.678-3.237 9.534a.5.5 0 0 0 .473.66h1.032a.75.75 0 0 0 .717-.53l.648-2.107H9.63l.647 2.107a.75.75 0 0 0 .717.53h1.113a.5.5 0 0 0 .473-.66L9.337 6.677A1 1 0 0 0 8.39 6H7.207a1 1 0 0 0-.947.678M7.736 8.08h.051l1.364 4.453H6.372zm11.113 2.043v-.327a1 1 0 0 1 1-1H20a1 1 0 0 1 1 1v6.078a1 1 0 0 1-1 1h-.151a1 1 0 0 1-1-1v-.312h-.088c-.392.874-1.232 1.439-2.418 1.439-1.975 0-3.221-1.613-3.221-4.182 0-2.546 1.254-4.15 3.221-4.15 1.172 0 2.026.595 2.418 1.454zm-.045 2.712c0-1.47-.685-2.404-1.754-2.404s-1.725.92-1.725 2.404c0 1.491.657 2.395 1.725 2.395 1.076 0 1.754-.911 1.754-2.395"/></svg>`
    }, props));
$a9563970426cdd61$var$EditorTextStyleIcon.displayName = 'EditorTextStyleIcon';
var $a9563970426cdd61$var$_default = module.exports.default = $a9563970426cdd61$var$EditorTextStyleIcon;

});

parcelRegister("fAjN9", function(module, exports) {
$parcel$export(module.exports, "blockTypeMenuItemStyle", () => $238f8284e8f7479b$export$2e548ca9c55ac73f);
$parcel$export(module.exports, "keyboardShortcut", () => $238f8284e8f7479b$export$54ea58af6cf8bf3a);
$parcel$export(module.exports, "keyboardShortcutSelect", () => $238f8284e8f7479b$export$b09cf4fbc27c2bae);
$parcel$export(module.exports, "wrapperSmallStyle", () => $238f8284e8f7479b$export$4f9ef2b7bddb4c3a);
$parcel$export(module.exports, "floatingToolbarWrapperStyle", () => $238f8284e8f7479b$export$a61e5f64ad28e14a);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $lu6Kl = parcelRequire("lu6Kl");
var $ifrjt = parcelRequire("ifrjt");

var $2dMzB = parcelRequire("2dMzB");

function $238f8284e8f7479b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $238f8284e8f7479b$export$2e548ca9c55ac73f = (tagName, selected, typographyTheme)=>{
    // TEMP FIX: See https://product-fabric.atlassian.net/browse/ED-13878
    const selectedStyle = selected ? `${tagName} { color: ${"var(--ds-text, white)"} !important; }` : '';
    return ()=>/*#__PURE__*/ (0, $1NIU8.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        tagName === 'blockquote' ? (0, $lu6Kl.blockquoteSharedStyles) : (0, $ifrjt.headingsSharedStyles)(typographyTheme), ">{h1, h2, h3, h4, h5, h6{margin-top:0;}blockquote{padding-top:0;padding-bottom:0;margin-top:0;}}", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        selectedStyle);
};
const $238f8284e8f7479b$export$54ea58af6cf8bf3a = /*#__PURE__*/ (0, $1NIU8.css)((0, $2dMzB.shortcutStyle), {
    marginLeft: "var(--ds-space-200, 16px)",
    color: `var(--ds-icon, ${(0, $7bb4c1736002a04a$export$eece5f492e429f08)})`
});
const $238f8284e8f7479b$export$b09cf4fbc27c2bae = /*#__PURE__*/ (0, $1NIU8.css)({
    color: `var(--ds-icon, ${(0, $7bb4c1736002a04a$export$eece5f492e429f08)})`
});
const $238f8284e8f7479b$export$4f9ef2b7bddb4c3a = {
    name: "1eh91m4",
    styles: "margin-left:var(--ds-space-050, 4px);min-width:40px"
};
const $238f8284e8f7479b$export$e1f541b6d8e35681 = {
    name: "1igsh0u",
    styles: "margin-left:var(--ds-space-negative-100, -8px)"
};
const $238f8284e8f7479b$export$a61e5f64ad28e14a = {
    name: "1t1gmw4",
    styles: "[data-role='droplistContent']{max-height:90vh;}"
};

});
parcelRegister("lu6Kl", function(module, exports) {
$parcel$export(module.exports, "blockquoteSharedStyles", () => $f7ed224e95af54b3$export$1b5f3b43e6c4a8ee);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");
const $f7ed224e95af54b3$export$1b5f3b43e6c4a8ee = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& blockquote': {
        boxSizing: 'border-box',
        color: 'inherit',
        width: '100%',
        display: 'inline-block',
        paddingLeft: "var(--ds-space-200, 16px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderLeft: `2px solid ${`var(--ds-border, ${(0, $7yBx7.akEditorBlockquoteBorderColor)})`}`,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $7yBx7.blockNodesVerticalMargin)} 0 0 0`,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[dir='rtl'] &": {
            paddingLeft: 0,
            paddingRight: "var(--ds-space-200, 16px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: 0
        },
        '&::before': {
            content: "''"
        },
        '&::after': {
            content: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& table, & table:last-child': {
            display: 'inline-table'
        },
        // Workaround for overriding the inline-block display on last child of a blockquote set in CSS reset.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> .extensionView-content-wrap:last-child': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: 'block'
        }
    }
});

});

parcelRegister("ifrjt", function(module, exports) {
$parcel$export(module.exports, "headingsSharedStyles", () => $072b136e11b961b1$export$9272613b68afed4b);
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/use-tokens-space */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eGOwo = parcelRequire("eGOwo");

var $Vv4zU = parcelRequire("Vv4zU");
const $072b136e11b961b1$var$headingWithAlignmentStyles = ()=>// Override marginTop: 0 with default margin found in headingsSharedStyles for first heading in alignment block that is not the first child
    ({
        '.fabric-editor-block-mark.fabric-editor-alignment:not(:first-child)': {
            '> h1:first-child': {
                marginTop: '1.667em'
            },
            ' > h2:first-child': {
                marginTop: '1.8em'
            },
            '> h3:first-child': {
                marginTop: '2em'
            },
            '> h4:first-child': {
                marginTop: '1.357em'
            },
            '> h5:first-child': {
                marginTop: '1.667em'
            },
            '> h6:first-child': {
                marginTop: '1.455em'
            }
        },
        // Set marginTop: 0 if alignment block is next to a gap cursor or widget that is first child
        '.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment': {
            '> :is(h1, h2, h3, h4, h5, h6):first-child': {
                marginTop: '0'
            }
        }
    });
const $072b136e11b961b1$export$9272613b68afed4b = (typographyTheme)=>{
    if ((0, $eGOwo.fg)('platform_editor_typography_ugc')) return /*#__PURE__*/ (0, $1NIU8.css)({
        '& h1': {
            font: (0, $Vv4zU.default)('editor.font.heading.h1'),
            marginBottom: 0,
            marginTop: '1.45833em',
            '& strong': {
                fontWeight: (0, $Vv4zU.default)('editor.font.weight.heading.h1.bold')
            },
            '&::before': {}
        },
        '& h2': {
            font: (0, $Vv4zU.default)('editor.font.heading.h2'),
            marginTop: '1.4em',
            marginBottom: 0,
            '& strong': {
                fontWeight: (0, $Vv4zU.default)('editor.font.weight.heading.h1.bold')
            }
        },
        '& h3': {
            font: (0, $Vv4zU.default)('editor.font.heading.h3'),
            marginTop: '1.31249em',
            marginBottom: 0,
            '& strong': {
                fontWeight: (0, $Vv4zU.default)('editor.font.weight.heading.h1.bold')
            }
        },
        '& h4': {
            font: (0, $Vv4zU.default)('editor.font.heading.h4'),
            marginTop: '1.25em',
            '& strong': {
                fontWeight: (0, $Vv4zU.default)('editor.font.weight.heading.h1.bold')
            }
        },
        '& h5': {
            font: (0, $Vv4zU.default)('editor.font.heading.h5'),
            marginTop: '1.45833em',
            textTransform: 'none',
            '& strong': {
                fontWeight: (0, $Vv4zU.default)('editor.font.weight.heading.h1.bold')
            }
        },
        '& h6': {
            font: (0, $Vv4zU.default)('editor.font.heading.h6'),
            marginTop: '1.59091em',
            textTransform: 'none',
            '& strong': {
                fontWeight: (0, $Vv4zU.default)('editor.font.weight.heading.h1.bold')
            }
        },
        ...$072b136e11b961b1$var$headingWithAlignmentStyles()
    });
    else return /*#__PURE__*/ (0, $1NIU8.css)({
        '& h1': {
            fontSize: `${24 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 28 / 24,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-medium, 500)",
            letterSpacing: `-0.01em`,
            marginBottom: 0,
            marginTop: '1.667em'
        },
        '& h2': {
            fontSize: `${20 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 1.2,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-medium, 500)",
            letterSpacing: `-0.008em`,
            marginTop: '1.8em',
            marginBottom: 0
        },
        '& h3': {
            fontSize: `${16 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 1.25,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            letterSpacing: `-0.006em`,
            marginTop: '2em',
            marginBottom: 0
        },
        '& h4': {
            fontSize: `${1}em`,
            fontStyle: 'inherit',
            lineHeight: 16 / 14,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            letterSpacing: `-0.003em`,
            marginTop: '1.357em'
        },
        '& h5': {
            fontSize: `${12 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 16 / 12,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            marginTop: '1.667em',
            textTransform: 'none'
        },
        '& h6': {
            fontSize: `${11 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 16 / 11,
            color: "var(--ds-text-subtlest, #626F86)",
            fontWeight: "var(--ds-font-weight-bold, 700)",
            marginTop: '1.455em',
            textTransform: 'none'
        },
        ...$072b136e11b961b1$var$headingWithAlignmentStyles()
    });
};

});

parcelRegister("2dMzB", function(module, exports) {
$parcel$export(module.exports, "shortcutStyle", () => $c53387095d02f5bd$export$297e5814a2c821bb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");
const $c53387095d02f5bd$export$297e5814a2c821bb = /*#__PURE__*/ (0, $1NIU8.css)("background-color:var(--ds-background-neutral, #091E420F);color:var(--ds-text-subtle, #44546F);border-radius:var(--ds-radius-small, 3px);padding:var(--ds-space-050, 4px);line-height:12px;font-size:", (0, $7yBx7.relativeFontSizeToBase16)(11.67), ";align-self:flex-end;@media (max-width: ", (0, $7yBx7.akEditorMobileMaxWidth), "px){display:none;}");

});





parcelRegister("jfXjJ", function(module, exports) {
$parcel$export(module.exports, "PrimaryToolbarComponent", () => $9a0f29d20eebff80$export$94516d5cccf573e3);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $bMFKb = parcelRequire("bMFKb");

var $cxXTK = parcelRequire("cxXTK");

var $dcew5 = parcelRequire("dcew5");
function $9a0f29d20eebff80$export$94516d5cccf573e3({ api: api, isSmall: isSmall, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, shouldUseDefaultRole: shouldUseDefaultRole }) {
    const { currentBlockType: currentBlockType, blockTypesDisabled: blockTypesDisabled, availableBlockTypes: availableBlockTypes, availableBlockTypesInDropdown: availableBlockTypesInDropdown, formattingIsPresent: formattingIsPresent } = (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'blockType'
    ], (states)=>({
            currentBlockType: states.blockTypeState?.currentBlockType,
            blockTypesDisabled: states.blockTypeState?.blockTypesDisabled,
            availableBlockTypes: states.blockTypeState?.availableBlockTypes,
            availableBlockTypesInDropdown: states.blockTypeState?.availableBlockTypesInDropdown,
            formattingIsPresent: states.blockTypeState?.formattingIsPresent
        }));
    const boundSetBlockType = (name, fromBlockQuote)=>api?.core?.actions.execute(api?.blockType?.commands?.setTextLevel(name, (0, $bMFKb.INPUT_METHOD).TOOLBAR, fromBlockQuote));
    const wrapBlockQuote = ()=>api?.core?.actions.execute(api?.blockType?.commands?.insertBlockQuote((0, $bMFKb.INPUT_METHOD).TOOLBAR));
    const clearFormatting = ()=>api?.core?.actions.execute(api?.blockType?.commands?.clearFormatting((0, $bMFKb.INPUT_METHOD).TOOLBAR));
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dcew5.default), {
        isSmall: isSmall,
        isDisabled: disabled,
        isReducedSpacing: isToolbarReducedSpacing,
        setTextLevel: boundSetBlockType,
        wrapBlockQuote: wrapBlockQuote,
        clearFormatting: clearFormatting,
        currentBlockType: currentBlockType,
        blockTypesDisabled: blockTypesDisabled,
        availableBlockTypes: availableBlockTypes,
        availableBlockTypesInDropdown: availableBlockTypesInDropdown,
        formattingIsPresent: formattingIsPresent,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        shouldUseDefaultRole: shouldUseDefaultRole,
        api: api
    });
}

});

parcelRegister("g83Eb", function(module, exports) {
$parcel$export(module.exports, "getToolbarComponents", () => $5c05a44acecd65ab$export$a758406ca53b86a5);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $3KjUM = parcelRequire("3KjUM");
var $6996L = parcelRequire("6996L");

var $cbSL1 = parcelRequire("cbSL1");

var $h16z0 = parcelRequire("h16z0");

var $1e8xR = parcelRequire("1e8xR");

var $70QwX = parcelRequire("70QwX");

var $kLTRx = parcelRequire("kLTRx");
const $5c05a44acecd65ab$export$a758406ca53b86a5 = (api)=>{
    const toolbarComponents = [
        {
            type: (0, $3KjUM.TEXT_STYLES_GROUP).type,
            key: (0, $3KjUM.TEXT_STYLES_GROUP).key,
            parents: [
                {
                    type: (0, $3KjUM.TEXT_SECTION).type,
                    key: (0, $3KjUM.TEXT_SECTION).key,
                    rank: (0, $6996L.TEXT_SECTION_RANK)[(0, $3KjUM.TEXT_STYLES_GROUP).key]
                },
                {
                    type: (0, $3KjUM.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $3KjUM.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $6996L.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $3KjUM.TEXT_STYLES_GROUP).key]
                }
            ]
        },
        {
            type: (0, $3KjUM.TEXT_STYLES_MENU).type,
            key: (0, $3KjUM.TEXT_STYLES_MENU).key,
            parents: [
                {
                    type: (0, $3KjUM.TEXT_STYLES_GROUP).type,
                    key: (0, $3KjUM.TEXT_STYLES_GROUP).key,
                    rank: (0, $6996L.TEXT_STYLES_GROUP_RANK)[(0, $3KjUM.TEXT_STYLES_MENU).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kLTRx.TextStylesMenuButton), {
                    api: api,
                    children: children
                })
        },
        {
            type: (0, $3KjUM.TEXT_STYLES_MENU_SECTION).type,
            key: (0, $3KjUM.TEXT_STYLES_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $3KjUM.TEXT_STYLES_MENU).type,
                    key: (0, $3KjUM.TEXT_STYLES_MENU).key,
                    rank: (0, $6996L.TEXT_STYLES_MENU_RANK)[(0, $3KjUM.TEXT_STYLES_MENU_SECTION).key]
                },
                ...(0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_responsive', 'isEnabled', true) ? [
                    {
                        type: (0, $3KjUM.TEXT_COLLAPSED_MENU).type,
                        key: (0, $3KjUM.TEXT_COLLAPSED_MENU).key,
                        rank: (0, $6996L.TEXT_COLLAPSED_MENU_RANK)[(0, $3KjUM.TEXT_STYLES_MENU_SECTION).key]
                    }
                ] : []
            ]
        }
    ];
    Object.values((0, $h16z0.toolbarBlockTypesWithRank)()).forEach((blockType)=>{
        if (blockType.toolbarKey) {
            const menuItem = {
                type: 'menu-item',
                key: blockType.toolbarKey,
                parents: [
                    {
                        type: (0, $3KjUM.TEXT_STYLES_MENU_SECTION).type,
                        key: (0, $3KjUM.TEXT_STYLES_MENU_SECTION).key,
                        rank: blockType.toolbarRank
                    }
                ],
                component: blockType.name === 'blockquote' ? ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $70QwX.QuoteButton), {
                        blockType: blockType,
                        api: api
                    }) : ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $1e8xR.HeadingButton), {
                        blockType: blockType,
                        api: api
                    })
            };
            toolbarComponents.push(menuItem);
        }
    });
    return toolbarComponents;
};

});
parcelRegister("1e8xR", function(module, exports) {
$parcel$export(module.exports, "HeadingButton", () => $5ea3f9645eec1de7$export$a24781eb35f914a5);
/* HeadingButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bMFKb = parcelRequire("bMFKb");

var $6Exgk = parcelRequire("6Exgk");

var $frlUM = parcelRequire("frlUM");

var $dFLJN = parcelRequire("dFLJN");
var $ayYTB = parcelRequire("ayYTB");

var $8IeH1 = parcelRequire("8IeH1");

var $cbSL1 = parcelRequire("cbSL1");
const $5ea3f9645eec1de7$var$headingSizeStylesMap = {
    normal: "_11c82smr",
    heading1: "_11c81c04",
    heading2: "_11c8nf1z",
    heading3: "_11c8lodh",
    heading4: "_11c8nbxd",
    heading5: "_11c8140y",
    heading6: "_11c81vhk"
};
const $5ea3f9645eec1de7$var$shortcuts = {
    normal: (0, $6Exgk.setNormalText),
    heading1: (0, $6Exgk.toggleHeading1),
    heading2: (0, $6Exgk.toggleHeading2),
    heading3: (0, $6Exgk.toggleHeading3),
    heading4: (0, $6Exgk.toggleHeading4),
    heading5: (0, $6Exgk.toggleHeading5),
    heading6: (0, $6Exgk.toggleHeading6)
};
const $5ea3f9645eec1de7$export$a24781eb35f914a5 = ({ blockType: blockType, api: api })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const currentBlockType = (0, $frlUM.useSharedPluginStateSelector)(api, 'blockType.currentBlockType');
    const availableBlockTypesInDropdown = (0, $frlUM.useSharedPluginStateSelector)(api, 'blockType.availableBlockTypesInDropdown');
    if (!availableBlockTypesInDropdown?.some((availableBlockType)=>availableBlockType.name === blockType.name)) return null;
    const fromBlockQuote = currentBlockType?.name === 'blockquote';
    const onClick = ()=>{
        api?.core?.actions.execute(api?.blockType?.commands?.setTextLevel(blockType.name, (0, $bMFKb.INPUT_METHOD).TOOLBAR, fromBlockQuote));
    };
    const shortcut = (0, $6Exgk.formatShortcut)($5ea3f9645eec1de7$var$shortcuts[blockType.name]);
    (0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_patch_3', 'isEnabled', true);
    const isSelected = (0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_patch_3', 'isEnabled', true) ? currentBlockType?.name === blockType.name : currentBlockType === blockType;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dFLJN.ToolbarDropdownItem), {
        elemBefore: blockType.icon,
        elemAfter: shortcut ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ayYTB.ToolbarKeyboardShortcutHint), {
            shortcut: shortcut
        }) : undefined,
        onClick: onClick,
        isSelected: isSelected,
        ariaKeyshortcuts: shortcut,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            xcss: $5ea3f9645eec1de7$var$headingSizeStylesMap[blockType.name],
            children: formatMessage(blockType.title)
        })
    });
};

});

parcelRegister("70QwX", function(module, exports) {
$parcel$export(module.exports, "QuoteButton", () => $c5ac920f5284ad2d$export$94ec63f36c20dec6);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bMFKb = parcelRequire("bMFKb");

var $6Exgk = parcelRequire("6Exgk");

var $frlUM = parcelRequire("frlUM");

var $dFLJN = parcelRequire("dFLJN");
var $ayYTB = parcelRequire("ayYTB");
const $c5ac920f5284ad2d$export$94ec63f36c20dec6 = ({ blockType: blockType, api: api })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const availableBlockTypesInDropdown = (0, $frlUM.useSharedPluginStateSelector)(api, 'blockType.availableBlockTypesInDropdown');
    const currentBlockType = (0, $frlUM.useSharedPluginStateSelector)(api, 'blockType.currentBlockType');
    if (!availableBlockTypesInDropdown?.some((availableBlockType)=>availableBlockType.name === blockType.name)) return null;
    const onClick = ()=>{
        api?.core?.actions.execute(api?.blockType?.commands?.insertBlockQuote((0, $bMFKb.INPUT_METHOD).TOOLBAR));
    };
    const shortcut = (0, $6Exgk.formatShortcut)((0, $6Exgk.toggleBlockQuote));
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dFLJN.ToolbarDropdownItem), {
        elemBefore: blockType.icon,
        elemAfter: shortcut ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ayYTB.ToolbarKeyboardShortcutHint), {
            shortcut: shortcut
        }) : undefined,
        onClick: onClick,
        isSelected: currentBlockType === blockType,
        ariaKeyshortcuts: shortcut,
        children: formatMessage(blockType.title)
    });
};

});

parcelRegister("kLTRx", function(module, exports) {
$parcel$export(module.exports, "TextStylesMenuButton", () => $5dd3806cf1f3c7c3$export$e34ebed463fa4947);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $cxXTK = parcelRequire("cxXTK");

var $1D5wE = parcelRequire("1D5wE");

var $c0YTT = parcelRequire("c0YTT");

var $frlUM = parcelRequire("frlUM");

var $8hNRj = parcelRequire("8hNRj");
var $lNljc = parcelRequire("lNljc");
var $64R2q = parcelRequire("64R2q");

var $1DmqU = parcelRequire("1DmqU");

var $cbSL1 = parcelRequire("cbSL1");

var $h16z0 = parcelRequire("h16z0");
const $5dd3806cf1f3c7c3$var$usePluginState = (0, $1DmqU.conditionalHooksFactory)(()=>(0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_patch_3', 'isEnabled', true), (api)=>{
    return (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'blockType'
    ], (state)=>({
            blockTypesDisabled: state.blockTypeState?.blockTypesDisabled,
            currentBlockType: state.blockTypeState?.currentBlockType
        }));
}, (api)=>{
    const blockTypesDisabled = (0, $frlUM.useSharedPluginStateSelector)(api, 'blockType.blockTypesDisabled');
    const currentBlockType = (0, $frlUM.useSharedPluginStateSelector)(api, 'blockType.currentBlockType');
    return {
        blockTypesDisabled: blockTypesDisabled,
        currentBlockType: currentBlockType
    };
});
const $5dd3806cf1f3c7c3$export$e34ebed463fa4947 = ({ api: api, children: children })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { blockTypesDisabled: blockTypesDisabled, currentBlockType: currentBlockType } = $5dd3806cf1f3c7c3$var$usePluginState(api);
    const blockTypes = (0, $h16z0.toolbarBlockTypesWithRank)();
    const { editorAppearance: editorAppearance } = (0, $c0YTT.useEditorToolbar)();
    const CurrentIcon = Object.values(blockTypes).find((blockType)=>blockType.name === currentBlockType?.name)?.icon?.type;
    const normalText = blockTypes.normal;
    const TriggerIcon = (0, $eJOHy.useMemo)(()=>{
        if (editorAppearance === 'full-page') {
            const hasCurrentBlockType = currentBlockType && CurrentIcon;
            const Icon = hasCurrentBlockType ? CurrentIcon : (0, (/*@__PURE__*/$parcel$interopDefault($8hNRj)));
            return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                        label: "",
                        size: "small"
                    }),
                    hasCurrentBlockType ? formatMessage(currentBlockType.title) : formatMessage(normalText.title)
                ]
            });
        }
        return CurrentIcon ? /*#__PURE__*/ (0, $gt9Am.jsx)(CurrentIcon, {
            label: `${currentBlockType?.name} ${formatMessage((0, $1D5wE.toolbarMessages).textStylesTooltip)}`,
            size: "small"
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8hNRj))), {
            label: formatMessage((0, $1D5wE.toolbarMessages).textStylesTooltip),
            size: "small"
        });
    }, [
        editorAppearance,
        currentBlockType,
        CurrentIcon,
        normalText,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $64R2q.ToolbarTooltip), {
        content: formatMessage((0, $1D5wE.toolbarMessages).textStylesTooltip),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lNljc.ToolbarDropdownMenu), {
            isDisabled: blockTypesDisabled,
            iconBefore: TriggerIcon,
            children: children
        })
    });
};

});
parcelRegister("1DmqU", function(module, exports) {
$parcel$export(module.exports, "conditionalHooksFactory", () => $c7ee05ec9845cd50$export$691e93bad45e6f07);
// Shorthand alias for the global cache map key because it's (intentionally) a long name
const $c7ee05ec9845cd50$var$CACHE_MAP_KEY = '__conditionalHooksFactory_conditionCacheMap_dont_modify_this_manually_unless_you_want_react_to_blow_up';
// Initialize the global cache map once
globalThis[$c7ee05ec9845cd50$var$CACHE_MAP_KEY] = globalThis[$c7ee05ec9845cd50$var$CACHE_MAP_KEY] || new WeakMap();
function $c7ee05ec9845cd50$export$e328888e5cffce88() {
    globalThis[$c7ee05ec9845cd50$var$CACHE_MAP_KEY] = new WeakMap();
}
function $c7ee05ec9845cd50$export$691e93bad45e6f07(condition, newHook, oldHook) {
    const hookFn = (...args)=>{
        // call each time so we can track exposures
        const conditionResult = condition();
        const cache = globalThis[$c7ee05ec9845cd50$var$CACHE_MAP_KEY];
        if (!cache.has(hookFn)) cache.set(hookFn, conditionResult);
        if (cache.get(hookFn)) return newHook(...args);
        else return oldHook(...args);
    };
    return hookFn;
}

});



parcelRegister("f1SCK", function(module, exports) {
$parcel$export(module.exports, "getBlockTypeComponents", () => $0bd48d87583136a5$export$325b6b890260a604);

var $6iVIn = parcelRequire("6iVIn");
var $dzaj1 = parcelRequire("dzaj1");

var $eGOwo = parcelRequire("eGOwo");

var $1FUs4 = parcelRequire("1FUs4");

var $dXebO = parcelRequire("dXebO");

var $5H1IN = parcelRequire("5H1IN");
const $0bd48d87583136a5$export$325b6b890260a604 = (api)=>{
    return [
        {
            type: 'block-menu-item',
            key: (0, $6iVIn.FORMAT_HEADING_1_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: 'nested-menu-format-section-primary',
                rank: (0, $eGOwo.fg)('platform_editor_block_menu_format_rank_revised') ? (0, $dzaj1.FORMAT_NESTED_MENU_RANK_REVISED)[(0, $6iVIn.FORMAT_HEADING_1_MENU_ITEM).key] : (0, $dzaj1.FORMAT_NESTED_MENU_RANK)[(0, $6iVIn.FORMAT_HEADING_1_MENU_ITEM).key]
            },
            component: (0, $1FUs4.createHeadingBlockMenuItem)({
                level: 1,
                api: api
            })
        },
        {
            type: 'block-menu-item',
            key: (0, $6iVIn.FORMAT_HEADING_2_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: 'nested-menu-format-section-primary',
                rank: (0, $eGOwo.fg)('platform_editor_block_menu_format_rank_revised') ? (0, $dzaj1.FORMAT_NESTED_MENU_RANK_REVISED)[(0, $6iVIn.FORMAT_HEADING_2_MENU_ITEM).key] : (0, $dzaj1.FORMAT_NESTED_MENU_RANK)[(0, $6iVIn.FORMAT_HEADING_2_MENU_ITEM).key]
            },
            component: (0, $1FUs4.createHeadingBlockMenuItem)({
                level: 2,
                api: api
            })
        },
        {
            type: 'block-menu-item',
            key: (0, $6iVIn.FORMAT_HEADING_3_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: 'nested-menu-format-section-primary',
                rank: (0, $eGOwo.fg)('platform_editor_block_menu_format_rank_revised') ? (0, $dzaj1.FORMAT_NESTED_MENU_RANK_REVISED)[(0, $6iVIn.FORMAT_HEADING_3_MENU_ITEM).key] : (0, $dzaj1.FORMAT_NESTED_MENU_RANK)[(0, $6iVIn.FORMAT_HEADING_3_MENU_ITEM).key]
            },
            component: (0, $1FUs4.createHeadingBlockMenuItem)({
                level: 3,
                api: api
            })
        },
        {
            type: 'block-menu-item',
            key: (0, $6iVIn.FORMAT_HEADING_4_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: 'nested-menu-format-section-primary',
                rank: (0, $eGOwo.fg)('platform_editor_block_menu_format_rank_revised') ? (0, $dzaj1.FORMAT_NESTED_MENU_RANK_REVISED)[(0, $6iVIn.FORMAT_HEADING_4_MENU_ITEM).key] : (0, $dzaj1.FORMAT_NESTED_MENU_RANK)[(0, $6iVIn.FORMAT_HEADING_4_MENU_ITEM).key]
            },
            component: (0, $1FUs4.createHeadingBlockMenuItem)({
                level: 4,
                api: api
            })
        },
        {
            type: 'block-menu-item',
            key: (0, $6iVIn.FORMAT_HEADING_5_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: 'nested-menu-format-section-primary',
                rank: (0, $eGOwo.fg)('platform_editor_block_menu_format_rank_revised') ? (0, $dzaj1.FORMAT_NESTED_MENU_RANK_REVISED)[(0, $6iVIn.FORMAT_HEADING_5_MENU_ITEM).key] : (0, $dzaj1.FORMAT_NESTED_MENU_RANK)[(0, $6iVIn.FORMAT_HEADING_5_MENU_ITEM).key]
            },
            component: (0, $1FUs4.createHeadingBlockMenuItem)({
                level: 5,
                api: api
            })
        },
        {
            type: 'block-menu-item',
            key: (0, $6iVIn.FORMAT_HEADING_6_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: 'nested-menu-format-section-primary',
                rank: (0, $eGOwo.fg)('platform_editor_block_menu_format_rank_revised') ? (0, $dzaj1.FORMAT_NESTED_MENU_RANK_REVISED)[(0, $6iVIn.FORMAT_HEADING_6_MENU_ITEM).key] : (0, $dzaj1.FORMAT_NESTED_MENU_RANK)[(0, $6iVIn.FORMAT_HEADING_6_MENU_ITEM).key]
            },
            component: (0, $1FUs4.createHeadingBlockMenuItem)({
                level: 6,
                api: api
            })
        },
        {
            type: 'block-menu-item',
            key: (0, $6iVIn.FORMAT_PARAGRAPH_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: 'nested-menu-format-section-primary',
                rank: (0, $eGOwo.fg)('platform_editor_block_menu_format_rank_revised') ? (0, $dzaj1.FORMAT_NESTED_MENU_RANK_REVISED)[(0, $6iVIn.FORMAT_PARAGRAPH_MENU_ITEM).key] : (0, $dzaj1.FORMAT_NESTED_MENU_RANK)[(0, $6iVIn.FORMAT_PARAGRAPH_MENU_ITEM).key]
            },
            component: (0, $dXebO.createParagraphBlockMenuItem)({
                api: api
            })
        },
        {
            type: 'block-menu-item',
            key: (0, $6iVIn.FORMAT_QUOTE_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: 'nested-menu-format-section-primary',
                rank: (0, $eGOwo.fg)('platform_editor_block_menu_format_rank_revised') ? (0, $dzaj1.FORMAT_NESTED_MENU_RANK_REVISED)[(0, $6iVIn.FORMAT_QUOTE_MENU_ITEM).key] : (0, $dzaj1.FORMAT_NESTED_MENU_RANK)[(0, $6iVIn.FORMAT_QUOTE_MENU_ITEM).key]
            },
            component: (0, $5H1IN.createQuoteBlockMenuItem)({
                api: api
            })
        }
    ];
};

});
parcelRegister("6iVIn", function(module, exports) {
$parcel$export(module.exports, "FORMAT_HEADING_1_MENU_ITEM", () => $c3c7637ec0cd69ef$export$db27ff69b30eb136);
$parcel$export(module.exports, "FORMAT_HEADING_2_MENU_ITEM", () => $c3c7637ec0cd69ef$export$868b9a2162e13fb7);
$parcel$export(module.exports, "FORMAT_HEADING_3_MENU_ITEM", () => $c3c7637ec0cd69ef$export$f950d196caee2740);
$parcel$export(module.exports, "FORMAT_HEADING_4_MENU_ITEM", () => $c3c7637ec0cd69ef$export$b956be9ecbebaa85);
$parcel$export(module.exports, "FORMAT_HEADING_5_MENU_ITEM", () => $c3c7637ec0cd69ef$export$80e1d27a5528d323);
$parcel$export(module.exports, "FORMAT_HEADING_6_MENU_ITEM", () => $c3c7637ec0cd69ef$export$e4811800ad98db16);
$parcel$export(module.exports, "FORMAT_PARAGRAPH_MENU_ITEM", () => $c3c7637ec0cd69ef$export$f93e2689f792d14f);
$parcel$export(module.exports, "FORMAT_QUOTE_MENU_ITEM", () => $c3c7637ec0cd69ef$export$f97abe57c108b636);
$parcel$export(module.exports, "FORMAT_EXPAND_MENU_ITEM", () => $c3c7637ec0cd69ef$export$3e4f392c9af6002d);
$parcel$export(module.exports, "FORMAT_LAYOUT_MENU_ITEM", () => $c3c7637ec0cd69ef$export$fbb342cfedee40b4);
$parcel$export(module.exports, "FORMAT_PANEL_MENU_ITEM", () => $c3c7637ec0cd69ef$export$513776f48af1049d);
$parcel$export(module.exports, "FORMAT_CODE_BLOCK_MENU_ITEM", () => $c3c7637ec0cd69ef$export$74a1116b03601d8c);
$parcel$export(module.exports, "FORMAT_BULLETED_LIST_MENU_ITEM", () => $c3c7637ec0cd69ef$export$73d2360cca0003);
$parcel$export(module.exports, "FORMAT_NUMBERED_LIST_MENU_ITEM", () => $c3c7637ec0cd69ef$export$e2e6e0265f47eb70);
$parcel$export(module.exports, "FORMAT_TASK_LIST_MENU_ITEM", () => $c3c7637ec0cd69ef$export$46f66e3bf78ae755);
$parcel$export(module.exports, "PRIMARY_MENU_SECTION", () => $c3c7637ec0cd69ef$export$854c8c543ed22259);
$parcel$export(module.exports, "NESTED_FORMAT_MENU_SECTION", () => $c3c7637ec0cd69ef$export$f2ba8ab734ee1173);
$parcel$export(module.exports, "ADD_BLOCKS_MENU_SECTION", () => $c3c7637ec0cd69ef$export$c505e8451d142847);
$parcel$export(module.exports, "COPY_MENU_SECTION", () => $c3c7637ec0cd69ef$export$8f241e6f8ca6eca0);
$parcel$export(module.exports, "DELETE_MENU_SECTION", () => $c3c7637ec0cd69ef$export$ca2108a38e6280a5);
$parcel$export(module.exports, "MOVE_UP_DOWN_MENU_SECTION", () => $c3c7637ec0cd69ef$export$7e90e92c82cd8c2b);
$parcel$export(module.exports, "FORMAT_MENU_ITEM", () => $c3c7637ec0cd69ef$export$979b1b5b10ad2adf);
$parcel$export(module.exports, "CREATE_SYNCED_BLOCK_MENU_ITEM", () => $c3c7637ec0cd69ef$export$8c07fa1503a2294a);
$parcel$export(module.exports, "COPY_BLOCK_MENU_ITEM", () => $c3c7637ec0cd69ef$export$e1f2cf92fcf252b0);
$parcel$export(module.exports, "COPY_LINK_MENU_ITEM", () => $c3c7637ec0cd69ef$export$8af7206163bb2604);
$parcel$export(module.exports, "MOVE_UP_MENU_ITEM", () => $c3c7637ec0cd69ef$export$889ac69c7c6ac647);
$parcel$export(module.exports, "MOVE_DOWN_MENU_ITEM", () => $c3c7637ec0cd69ef$export$d511fe13da4161eb);
$parcel$export(module.exports, "DELETE_MENU_ITEM", () => $c3c7637ec0cd69ef$export$1bb697e1417f5dce);
const $c3c7637ec0cd69ef$export$db27ff69b30eb136 = {
    key: 'block-menu-format-heading-1'
};
const $c3c7637ec0cd69ef$export$868b9a2162e13fb7 = {
    key: 'block-menu-format-heading-2'
};
const $c3c7637ec0cd69ef$export$f950d196caee2740 = {
    key: 'block-menu-format-heading-3'
};
const $c3c7637ec0cd69ef$export$b956be9ecbebaa85 = {
    key: 'block-menu-format-heading-4'
};
const $c3c7637ec0cd69ef$export$80e1d27a5528d323 = {
    key: 'block-menu-format-heading-5'
};
const $c3c7637ec0cd69ef$export$e4811800ad98db16 = {
    key: 'block-menu-format-heading-6'
};
const $c3c7637ec0cd69ef$export$f93e2689f792d14f = {
    key: 'block-menu-format-paragraph'
};
const $c3c7637ec0cd69ef$export$f97abe57c108b636 = {
    key: 'block-menu-format-quote'
};
const $c3c7637ec0cd69ef$export$3e4f392c9af6002d = {
    key: 'block-menu-format-expand'
};
const $c3c7637ec0cd69ef$export$fbb342cfedee40b4 = {
    key: 'block-menu-format-layout'
};
const $c3c7637ec0cd69ef$export$513776f48af1049d = {
    key: 'block-menu-format-panel'
};
const $c3c7637ec0cd69ef$export$74a1116b03601d8c = {
    key: 'block-menu-format-code-block'
};
const $c3c7637ec0cd69ef$export$73d2360cca0003 = {
    key: 'block-menu-format-bulleted-list'
};
const $c3c7637ec0cd69ef$export$e2e6e0265f47eb70 = {
    key: 'block-menu-format-numbered-list'
};
const $c3c7637ec0cd69ef$export$46f66e3bf78ae755 = {
    key: 'block-menu-format-task-list'
};
const $c3c7637ec0cd69ef$export$7ca91c9772dac78e = {
    key: 'nested-menu-format'
};
const $c3c7637ec0cd69ef$export$854c8c543ed22259 = {
    key: 'block-menu-section-primary'
};
const $c3c7637ec0cd69ef$export$f2ba8ab734ee1173 = {
    key: 'nested-menu-format-section-primary'
};
const $c3c7637ec0cd69ef$export$c505e8451d142847 = {
    key: 'block-menu-section-synced-block'
};
const $c3c7637ec0cd69ef$export$8f241e6f8ca6eca0 = {
    key: 'block-menu-section-copy'
};
const $c3c7637ec0cd69ef$export$ca2108a38e6280a5 = {
    key: 'block-menu-section-delete'
};
const $c3c7637ec0cd69ef$export$7e90e92c82cd8c2b = {
    key: 'block-menu-section-move-up-down'
};
const $c3c7637ec0cd69ef$export$979b1b5b10ad2adf = {
    key: 'nested-menu-format-section-primary'
};
const $c3c7637ec0cd69ef$export$8c07fa1503a2294a = {
    key: 'block-menu-create-synced-block'
};
const $c3c7637ec0cd69ef$export$e1f2cf92fcf252b0 = {
    key: 'block-menu-copy-block'
};
const $c3c7637ec0cd69ef$export$8af7206163bb2604 = {
    key: 'block-menu-item-copy-link'
};
const $c3c7637ec0cd69ef$export$889ac69c7c6ac647 = {
    key: 'block-menu-item-move-up'
};
const $c3c7637ec0cd69ef$export$d511fe13da4161eb = {
    key: 'block-menu-item-move-down'
};
const $c3c7637ec0cd69ef$export$1bb697e1417f5dce = {
    key: 'block-menu-item-delete'
};

});

parcelRegister("dzaj1", function(module, exports) {
$parcel$export(module.exports, "FORMAT_NESTED_MENU_RANK", () => $d9e674565155f2a5$export$74d4b0caeb774cb3);
$parcel$export(module.exports, "FORMAT_NESTED_MENU_RANK_REVISED", () => $d9e674565155f2a5$export$e840f9051821f71e);
$parcel$export(module.exports, "ADD_BLOCKS_MENU_SECTION_RANK", () => $d9e674565155f2a5$export$e99645b7dd6a9c51);

var $6iVIn = parcelRequire("6iVIn");
const $d9e674565155f2a5$export$74d4b0caeb774cb3 = {
    [(0, $6iVIn.FORMAT_HEADING_1_MENU_ITEM).key]: 50,
    [(0, $6iVIn.FORMAT_HEADING_2_MENU_ITEM).key]: 100,
    [(0, $6iVIn.FORMAT_HEADING_3_MENU_ITEM).key]: 150,
    [(0, $6iVIn.FORMAT_PARAGRAPH_MENU_ITEM).key]: 200,
    [(0, $6iVIn.FORMAT_QUOTE_MENU_ITEM).key]: 250,
    [(0, $6iVIn.FORMAT_EXPAND_MENU_ITEM).key]: 300,
    [(0, $6iVIn.FORMAT_LAYOUT_MENU_ITEM).key]: 350,
    [(0, $6iVIn.FORMAT_PANEL_MENU_ITEM).key]: 400,
    [(0, $6iVIn.FORMAT_CODE_BLOCK_MENU_ITEM).key]: 450,
    [(0, $6iVIn.FORMAT_BULLETED_LIST_MENU_ITEM).key]: 500,
    [(0, $6iVIn.FORMAT_NUMBERED_LIST_MENU_ITEM).key]: 550,
    [(0, $6iVIn.FORMAT_TASK_LIST_MENU_ITEM).key]: 600,
    [(0, $6iVIn.FORMAT_HEADING_4_MENU_ITEM).key]: 650,
    [(0, $6iVIn.FORMAT_HEADING_5_MENU_ITEM).key]: 700,
    [(0, $6iVIn.FORMAT_HEADING_6_MENU_ITEM).key]: 750
};
const $d9e674565155f2a5$export$e840f9051821f71e = {
    [(0, $6iVIn.FORMAT_PARAGRAPH_MENU_ITEM).key]: 50,
    [(0, $6iVIn.FORMAT_QUOTE_MENU_ITEM).key]: 100,
    [(0, $6iVIn.FORMAT_EXPAND_MENU_ITEM).key]: 150,
    [(0, $6iVIn.FORMAT_LAYOUT_MENU_ITEM).key]: 200,
    [(0, $6iVIn.FORMAT_PANEL_MENU_ITEM).key]: 250,
    [(0, $6iVIn.FORMAT_CODE_BLOCK_MENU_ITEM).key]: 300,
    [(0, $6iVIn.FORMAT_BULLETED_LIST_MENU_ITEM).key]: 350,
    [(0, $6iVIn.FORMAT_NUMBERED_LIST_MENU_ITEM).key]: 400,
    [(0, $6iVIn.FORMAT_TASK_LIST_MENU_ITEM).key]: 450,
    [(0, $6iVIn.FORMAT_HEADING_1_MENU_ITEM).key]: 500,
    [(0, $6iVIn.FORMAT_HEADING_2_MENU_ITEM).key]: 550,
    [(0, $6iVIn.FORMAT_HEADING_3_MENU_ITEM).key]: 600,
    [(0, $6iVIn.FORMAT_HEADING_4_MENU_ITEM).key]: 650,
    [(0, $6iVIn.FORMAT_HEADING_5_MENU_ITEM).key]: 700,
    [(0, $6iVIn.FORMAT_HEADING_6_MENU_ITEM).key]: 750
};
const $d9e674565155f2a5$export$615735e74b5868db = {
    [(0, $6iVIn.PRIMARY_MENU_SECTION).key]: 100,
    [(0, $6iVIn.ADD_BLOCKS_MENU_SECTION).key]: 200,
    [(0, $6iVIn.COPY_MENU_SECTION).key]: 300,
    [(0, $6iVIn.MOVE_UP_DOWN_MENU_SECTION).key]: 400,
    [(0, $6iVIn.DELETE_MENU_SECTION).key]: 500
};
const $d9e674565155f2a5$export$ab4d1d24bd840233 = {
    [(0, $6iVIn.FORMAT_MENU_ITEM).key]: 50
};
const $d9e674565155f2a5$export$e99645b7dd6a9c51 = {
    [(0, $6iVIn.CREATE_SYNCED_BLOCK_MENU_ITEM).key]: 50
};
const $d9e674565155f2a5$export$c47104fe34e7bfc4 = {
    [(0, $6iVIn.COPY_LINK_MENU_ITEM).key]: 50,
    [(0, $6iVIn.COPY_BLOCK_MENU_ITEM).key]: 100
};
const $d9e674565155f2a5$export$75015c8e892fe378 = {
    [(0, $6iVIn.MOVE_UP_MENU_ITEM).key]: 50,
    [(0, $6iVIn.MOVE_DOWN_MENU_ITEM).key]: 100
};
const $d9e674565155f2a5$export$b2d6e9ca316f6637 = {
    [(0, $6iVIn.DELETE_MENU_ITEM).key]: 50
};

});

parcelRegister("1FUs4", function(module, exports) {
$parcel$export(module.exports, "createHeadingBlockMenuItem", () => $226556c7e87a33c2$export$93c991c81dd77070);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bMFKb = parcelRequire("bMFKb");

var $TgnAJ = parcelRequire("TgnAJ");

var $frlUM = parcelRequire("frlUM");

var $3lIcL = parcelRequire("3lIcL");

var $dFLJN = parcelRequire("dFLJN");

var $2DLW5 = parcelRequire("2DLW5");

var $8tfsN = parcelRequire("8tfsN");

var $iaTwJ = parcelRequire("iaTwJ");

var $kMjFB = parcelRequire("kMjFB");

var $g6Zs4 = parcelRequire("g6Zs4");

var $a4Ktd = parcelRequire("a4Ktd");

var $h16z0 = parcelRequire("h16z0");
const $226556c7e87a33c2$var$headingIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($iaTwJ))),
    (0, (/*@__PURE__*/$parcel$interopDefault($a4Ktd))),
    (0, (/*@__PURE__*/$parcel$interopDefault($g6Zs4))),
    (0, (/*@__PURE__*/$parcel$interopDefault($8tfsN))),
    (0, (/*@__PURE__*/$parcel$interopDefault($2DLW5))),
    (0, (/*@__PURE__*/$parcel$interopDefault($kMjFB)))
];
const $226556c7e87a33c2$var$headingMessages = [
    (0, $TgnAJ.messages).heading1,
    (0, $TgnAJ.messages).heading2,
    (0, $TgnAJ.messages).heading3,
    (0, $TgnAJ.messages).heading4,
    (0, $TgnAJ.messages).heading5,
    (0, $TgnAJ.messages).heading6
];
const $226556c7e87a33c2$var$HeadingBlockTypes = [
    (0, $h16z0.HEADING_1),
    (0, $h16z0.HEADING_2),
    (0, $h16z0.HEADING_3),
    (0, $h16z0.HEADING_4),
    (0, $h16z0.HEADING_5),
    (0, $h16z0.HEADING_6)
];
const $226556c7e87a33c2$var$HeadingBlockMenuItem = ({ level: level, api: api })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const Icon = $226556c7e87a33c2$var$headingIcons[level - 1];
    const message = $226556c7e87a33c2$var$headingMessages[level - 1];
    const currentBlockType = (0, $frlUM.useSharedPluginStateSelector)(api, 'blockType.currentBlockType');
    const selection = (0, $frlUM.useSharedPluginStateSelector)(api, 'selection.selection');
    const isTextSelection = selection instanceof (0, $3lIcL.TextSelection);
    const isHeading = isTextSelection && currentBlockType && $226556c7e87a33c2$var$HeadingBlockTypes.includes(currentBlockType);
    const currentHeadingLevel = isHeading ? currentBlockType.level : undefined;
    const isSelected = isHeading && currentHeadingLevel === level;
    const handleClick = (event)=>{
        if (!selection) return;
        if (!isSelected) {
            const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $bMFKb.INPUT_METHOD).KEYBOARD : (0, $bMFKb.INPUT_METHOD).MOUSE;
            const inputMethod = (0, $bMFKb.INPUT_METHOD).BLOCK_MENU;
            api?.core.actions.execute(api?.blockMenu?.commands.formatNode(`heading${level}`, {
                inputMethod: inputMethod,
                triggeredFrom: triggeredFrom
            }));
        }
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dFLJN.ToolbarDropdownItem), {
        onClick: handleClick,
        isSelected: isSelected,
        elemBefore: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
            label: ""
        }),
        children: formatMessage(message)
    });
};
const $226556c7e87a33c2$export$93c991c81dd77070 = ({ level: level, api: api })=>{
    return ()=>/*#__PURE__*/ (0, $gt9Am.jsx)($226556c7e87a33c2$var$HeadingBlockMenuItem, {
            level: level,
            api: api
        });
};

});

parcelRegister("dXebO", function(module, exports) {
$parcel$export(module.exports, "createParagraphBlockMenuItem", () => $f09fc928346ad353$export$469651dcc0916a77);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bMFKb = parcelRequire("bMFKb");

var $garJk = parcelRequire("garJk");

var $frlUM = parcelRequire("frlUM");

var $3lIcL = parcelRequire("3lIcL");

var $dFLJN = parcelRequire("dFLJN");

var $hRIZ8 = parcelRequire("hRIZ8");

var $h16z0 = parcelRequire("h16z0");
const $f09fc928346ad353$var$ParagraphBlockMenuItem = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const currentBlockType = (0, $frlUM.useSharedPluginStateSelector)(api, 'blockType.currentBlockType');
    const bulletListActive = (0, $frlUM.useSharedPluginStateSelector)(api, 'list.bulletListActive');
    const orderedListActive = (0, $frlUM.useSharedPluginStateSelector)(api, 'list.orderedListActive');
    const selection = (0, $frlUM.useSharedPluginStateSelector)(api, 'selection.selection');
    const isTextSelection = selection instanceof (0, $3lIcL.TextSelection);
    const isParagraph = isTextSelection && currentBlockType && currentBlockType === (0, $h16z0.NORMAL_TEXT) && !bulletListActive && !orderedListActive;
    const handleClick = (event)=>{
        if (!selection) return;
        if (!isParagraph) {
            const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $bMFKb.INPUT_METHOD).KEYBOARD : (0, $bMFKb.INPUT_METHOD).MOUSE;
            const inputMethod = (0, $bMFKb.INPUT_METHOD).BLOCK_MENU;
            api?.core.actions.execute(api?.blockMenu?.commands.formatNode(`paragraph`, {
                inputMethod: inputMethod,
                triggeredFrom: triggeredFrom
            }));
        }
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dFLJN.ToolbarDropdownItem), {
        onClick: handleClick,
        isSelected: isParagraph,
        elemBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hRIZ8))), {
            label: ""
        }),
        children: formatMessage((0, $garJk.messages).paragraph)
    });
};
const $f09fc928346ad353$export$469651dcc0916a77 = ({ api: api })=>{
    return ()=>/*#__PURE__*/ (0, $gt9Am.jsx)($f09fc928346ad353$var$ParagraphBlockMenuItem, {
            api: api
        });
};

});
parcelRegister("hRIZ8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::74ca1dacf8943b30998c1339b14fef77>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d01a48051c9b10ce$var$_react = $d01a48051c9b10ce$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d01a48051c9b10ce$var$_baseNew = $d01a48051c9b10ce$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $d01a48051c9b10ce$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextParagraph".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Confluence Editor AI action for reformatting paragraphs into multiple shorter paragraphs
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d01a48051c9b10ce$var$TextParagraphIcon = (props)=>/*#__PURE__*/ $d01a48051c9b10ce$var$_react.default.createElement($d01a48051c9b10ce$var$_baseNew.default, Object.assign({
        name: "TextParagraphIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.25 2.5a2.75 2.75 0 0 0 0 5.5H8V2.5zm3.25 0V15H8V9.5H6.25a4.25 4.25 0 0 1 0-8.5h5.5a.75.75 0 0 1 .75.75V15H11V2.5z" clip-rule="evenodd"/>`
    }, props));
$d01a48051c9b10ce$var$TextParagraphIcon.displayName = 'TextParagraphIcon';
var $d01a48051c9b10ce$var$_default = module.exports.default = $d01a48051c9b10ce$var$TextParagraphIcon;

});


parcelRegister("5H1IN", function(module, exports) {
$parcel$export(module.exports, "createQuoteBlockMenuItem", () => $35f0fc66649dedbb$export$e07c899cb2d719c9);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bMFKb = parcelRequire("bMFKb");

var $TgnAJ = parcelRequire("TgnAJ");

var $frlUM = parcelRequire("frlUM");

var $dFLJN = parcelRequire("dFLJN");

var $amerd = parcelRequire("amerd");

var $h16z0 = parcelRequire("h16z0");
const $35f0fc66649dedbb$var$QuoteBlockMenuItem = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const currentBlockType = (0, $frlUM.useSharedPluginStateSelector)(api, 'blockType.currentBlockType');
    const isBlockQuote = currentBlockType && currentBlockType === (0, $h16z0.BLOCK_QUOTE);
    const handleClick = (event)=>{
        if (!isBlockQuote) {
            const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $bMFKb.INPUT_METHOD).KEYBOARD : (0, $bMFKb.INPUT_METHOD).MOUSE;
            const inputMethod = (0, $bMFKb.INPUT_METHOD).BLOCK_MENU;
            api?.core.actions.execute(api?.blockMenu?.commands.formatNode(`blockquote`, {
                inputMethod: inputMethod,
                triggeredFrom: triggeredFrom
            }));
        }
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dFLJN.ToolbarDropdownItem), {
        onClick: handleClick,
        isSelected: isBlockQuote,
        elemBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($amerd))), {
            label: ""
        }),
        children: formatMessage((0, $TgnAJ.messages).blockquote)
    });
};
const $35f0fc66649dedbb$export$e07c899cb2d719c9 = ({ api: api })=>{
    return ()=>/*#__PURE__*/ (0, $gt9Am.jsx)($35f0fc66649dedbb$var$QuoteBlockMenuItem, {
            api: api
        });
};

});




parcelRegister("kjNEe", function(module, exports) {
$parcel$export(module.exports, "codeBlockPlugin", () => (parcelRequire("4r3i7")).default);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $4r3i7 = parcelRequire("4r3i7");

});
parcelRegister("4r3i7", function(module, exports) {
$parcel$export(module.exports, "default", () => $fbe4b0b2ff091762$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $02BNy = parcelRequire("02BNy");

var $bMFKb = parcelRequire("bMFKb");

var $6iVIn = parcelRequire("6iVIn");
var $dzaj1 = parcelRequire("dzaj1");

var $TgnAJ = parcelRequire("TgnAJ");

var $c1NDo = parcelRequire("c1NDo");

var $eGOwo = parcelRequire("eGOwo");

var $9Letn = parcelRequire("9Letn");

var $eUWhc = parcelRequire("eUWhc");

var $4J8hb = parcelRequire("4J8hb");

var $bXs63 = parcelRequire("bXs63");

var $4A4SW = parcelRequire("4A4SW");

var $9qZT4 = parcelRequire("9qZT4");

var $eZ8Jb = parcelRequire("eZ8Jb");

var $fRZQq = parcelRequire("fRZQq");

var $har6y = parcelRequire("har6y");

var $izqih = parcelRequire("izqih");

var $6dsfp = parcelRequire("6dsfp");
const $fbe4b0b2ff091762$var$codeBlockPlugin = ({ config: options, api: api })=>{
    if ((0, $9Letn.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true)) api?.blockMenu?.actions.registerBlockMenuComponents([
        {
            type: 'block-menu-item',
            key: (0, $6iVIn.FORMAT_CODE_BLOCK_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $6iVIn.FORMAT_MENU_ITEM).key,
                rank: (0, $eGOwo.fg)('platform_editor_block_menu_format_rank_revised') ? (0, $dzaj1.FORMAT_NESTED_MENU_RANK_REVISED)[(0, $6iVIn.FORMAT_CODE_BLOCK_MENU_ITEM).key] : (0, $dzaj1.FORMAT_NESTED_MENU_RANK)[(0, $6iVIn.FORMAT_CODE_BLOCK_MENU_ITEM).key]
            },
            component: (0, $6dsfp.createCodeBlockMenuItem)(api)
        }
    ]);
    return {
        name: 'codeBlock',
        nodes () {
            return [
                {
                    name: 'codeBlock',
                    node: (0, $eGOwo.fg)('platform_editor_adf_with_localid') ? (0, $02BNy.codeBlockWithLocalId) : (0, $02BNy.codeBlock)
                }
            ];
        },
        getSharedState (state) {
            if (!state) return undefined;
            return {
                copyButtonHoverNode: (0, $bXs63.copySelectionPluginKey).getState(state).codeBlockNode
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'codeBlock',
                    plugin: ({ getIntl: getIntl })=>(0, $fRZQq.createPlugin)({
                            ...options,
                            getIntl: getIntl,
                            api: api
                        })
                },
                {
                    name: 'codeBlockInputRule',
                    plugin: ({ schema: schema })=>{
                        return (0, $9qZT4.createCodeBlockInputRule)(schema, api?.analytics?.actions);
                    }
                },
                {
                    name: 'codeBlockIDEKeyBindings',
                    plugin: ()=>(0, $4A4SW.default)(api)
                },
                {
                    name: 'codeBlockKeyMap',
                    plugin: ({ schema: schema })=>(0, $eZ8Jb.default)(schema)
                },
                {
                    name: 'codeBlockCopySelection',
                    plugin: ()=>(0, $bXs63.codeBlockCopySelectionPlugin)()
                },
                {
                    name: 'codeBlockAutoFullStopTransform',
                    plugin: ()=>(0, $4J8hb.codeBlockAutoFullStopTransformPlugin)()
                }
            ];
        },
        // Workaround for a firefox issue where dom selection is off sync
        // https://product-fabric.atlassian.net/browse/ED-12442
        onEditorViewStateUpdated (props) {
            (0, $har6y.default)(props.originalTransaction, props.newEditorState);
        },
        actions: {
            /*
			 * Function will insert code block at current selection if block is empty or below current selection and set focus on it.
			 */ insertCodeBlock: (inputMethod)=>(0, $eUWhc.insertCodeBlockWithAnalytics)(inputMethod, api?.analytics?.actions)
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'codeblock',
                        title: formatMessage((0, $TgnAJ.messages).codeblock),
                        description: formatMessage((0, $TgnAJ.messages).codeblockDescription),
                        keywords: [
                            'code block'
                        ],
                        priority: 700,
                        keyshortcut: '```',
                        icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $c1NDo.IconCode), {}),
                        action (_insert, state, source) {
                            const tr = (0, $eUWhc.createInsertCodeBlockTransaction)({
                                state: state
                            });
                            api?.analytics?.actions.attachAnalyticsEvent({
                                action: (0, $bMFKb.ACTION).INSERTED,
                                actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
                                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).CODE_BLOCK,
                                attributes: {
                                    inputMethod: (0, $9Letn.expValEqualsNoExposure)('platform_editor_plain_text_support', 'isEnabled', true) ? source || (0, $bMFKb.INPUT_METHOD).QUICK_INSERT : (0, $bMFKb.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $bMFKb.EVENT_TYPE).TRACK
                            })(tr);
                            return tr;
                        }
                    }
                ],
            floatingToolbar: (0, $izqih.getToolbarConfig)(options?.allowCopyToClipboard, api, options?.overrideLanguageName)
        }
    };
};
var $fbe4b0b2ff091762$export$2e2bcd8739ae039 = $fbe4b0b2ff091762$var$codeBlockPlugin;

});
parcelRegister("eUWhc", function(module, exports) {
$parcel$export(module.exports, "removeCodeBlockWithAnalytics", () => $8c9e5c0f44d7e20e$export$44b4779780b25933);
$parcel$export(module.exports, "changeLanguage", () => $8c9e5c0f44d7e20e$export$61465194746e7fd2);
$parcel$export(module.exports, "copyContentToClipboardWithAnalytics", () => $8c9e5c0f44d7e20e$export$50ffc017f5e54c0);
$parcel$export(module.exports, "resetCopiedState", () => $8c9e5c0f44d7e20e$export$3e0b07341e7576a);
$parcel$export(module.exports, "ignoreFollowingMutations", () => $8c9e5c0f44d7e20e$export$e6e93d61d1873d0c);
$parcel$export(module.exports, "resetShouldIgnoreFollowingMutations", () => $8c9e5c0f44d7e20e$export$60364cd5f5fed191);
$parcel$export(module.exports, "createInsertCodeBlockTransaction", () => $8c9e5c0f44d7e20e$export$c875ffe428b4a5f);
$parcel$export(module.exports, "insertCodeBlockWithAnalytics", () => $8c9e5c0f44d7e20e$export$a8d9c0f039b6fb43);
$parcel$export(module.exports, "toggleWordWrapStateForCodeBlockNode", () => $8c9e5c0f44d7e20e$export$160d674382436f98);

var $bMFKb = parcelRequire("bMFKb");
var $8MfCL = parcelRequire("8MfCL");

var $58hN2 = parcelRequire("58hN2");

var $hbQpB = parcelRequire("hbQpB");

var $asjM0 = parcelRequire("asjM0");

var $j6ZdO = parcelRequire("j6ZdO");

var $k2X9Z = parcelRequire("k2X9Z");

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");

var $qwti8 = parcelRequire("qwti8");

var $bXs63 = parcelRequire("bXs63");

var $cPDlc = parcelRequire("cPDlc");

var $b1dKB = parcelRequire("b1dKB");
const $8c9e5c0f44d7e20e$export$44b4779780b25933 = (editorAnalyticsAPI)=>{
    return (0, $asjM0.withAnalytics)(editorAnalyticsAPI, {
        action: (0, $bMFKb.ACTION).DELETED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).CODE_BLOCK,
        attributes: {
            inputMethod: (0, $bMFKb.INPUT_METHOD).FLOATING_TB
        },
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK
    })($8c9e5c0f44d7e20e$export$e635d7f974817375);
};
const $8c9e5c0f44d7e20e$export$e635d7f974817375 = (state, dispatch)=>{
    const { schema: { nodes: nodes }, tr: tr } = state;
    if (dispatch) {
        let removeTr = tr;
        if ((0, $BmspC.findSelectedNodeOfType)(nodes.codeBlock)(tr.selection)) removeTr = (0, $BmspC.removeSelectedNode)(tr);
        else removeTr = (0, $BmspC.removeParentNodeOfType)(nodes.codeBlock)(tr);
        dispatch(removeTr);
    }
    return true;
};
const $8c9e5c0f44d7e20e$export$61465194746e7fd2 = (editorAnalyticsAPI)=>(language)=>(state, dispatch)=>{
            const { codeBlock: codeBlock } = state.schema.nodes;
            const pos = (0, $cPDlc.pluginKey).getState(state)?.pos;
            if (typeof pos !== 'number') return false;
            const tr = state.tr.setNodeMarkup(pos, codeBlock, {
                language: language
            }).setMeta('scrollIntoView', false);
            const selection = (0, $BmspC.isNodeSelection)(state.selection) ? (0, $3lIcL.NodeSelection).create(tr.doc, pos) : tr.selection;
            const result = tr.setSelection(selection);
            if (dispatch) {
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $bMFKb.ACTION).LANGUAGE_SELECTED,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).CODE_BLOCK,
                    attributes: {
                        language: language
                    },
                    eventType: (0, $bMFKb.EVENT_TYPE).TRACK
                })(result);
                dispatch(result);
            }
            return true;
        };
const $8c9e5c0f44d7e20e$export$50ffc017f5e54c0 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { schema: { nodes: nodes }, tr: tr } = state;
        const codeBlock = (0, $BmspC.findParentNodeOfType)(nodes.codeBlock)(tr.selection);
        const textContent = codeBlock && codeBlock.node.textContent;
        if (textContent) {
            (0, $58hN2.copyToClipboard)(textContent);
            const copyToClipboardTr = tr;
            copyToClipboardTr.setMeta((0, $cPDlc.pluginKey), {
                type: (0, $qwti8.ACTIONS).SET_COPIED_TO_CLIPBOARD,
                data: true
            });
            copyToClipboardTr.setMeta((0, $bXs63.copySelectionPluginKey), 'remove-selection');
            if (editorAnalyticsAPI) {
                const analyticsPayload = (0, $58hN2.getAnalyticsPayload)(state, (0, $bMFKb.ACTION).COPIED);
                if (analyticsPayload) {
                    analyticsPayload.attributes.inputMethod = (0, $bMFKb.INPUT_METHOD).FLOATING_TB;
                    analyticsPayload.attributes.nodeType = codeBlock?.node.type.name;
                    editorAnalyticsAPI.attachAnalyticsEvent(analyticsPayload)(copyToClipboardTr);
                }
            }
            if (dispatch) dispatch(copyToClipboardTr);
        }
        return true;
    };
const $8c9e5c0f44d7e20e$export$859674cc23da4522 = (state, dispatch)=>{
    const { schema: { nodes: nodes }, tr: tr } = state;
    const codeBlock = (0, $BmspC.findParentNodeOfType)(nodes.codeBlock)(tr.selection);
    const textContent = codeBlock && codeBlock.node.textContent;
    if (textContent) {
        (0, $58hN2.copyToClipboard)(textContent);
        const copyToClipboardTr = tr;
        copyToClipboardTr.setMeta((0, $cPDlc.pluginKey), {
            type: (0, $qwti8.ACTIONS).SET_COPIED_TO_CLIPBOARD,
            data: true
        });
        copyToClipboardTr.setMeta((0, $bXs63.copySelectionPluginKey), 'remove-selection');
        if (dispatch) dispatch(copyToClipboardTr);
    }
    return true;
};
const $8c9e5c0f44d7e20e$export$3e0b07341e7576a = (state, dispatch)=>{
    const { tr: tr } = state;
    const codeBlockState = (0, $cPDlc.pluginKey).getState(state);
    const resetCopiedStateTr = tr;
    if (codeBlockState && codeBlockState.contentCopied) {
        resetCopiedStateTr.setMeta((0, $cPDlc.pluginKey), {
            type: (0, $qwti8.ACTIONS).SET_COPIED_TO_CLIPBOARD,
            data: false
        });
        resetCopiedStateTr.setMeta((0, $bXs63.copySelectionPluginKey), 'remove-selection');
        if (dispatch) dispatch(resetCopiedStateTr);
    } else {
        const clearSelectionStateTransaction = state.tr;
        clearSelectionStateTransaction.setMeta((0, $bXs63.copySelectionPluginKey), 'remove-selection');
        // note: dispatch should always be defined when called from the
        // floating toolbar. Howver the Command type which floating toolbar uses
        // (and resetCopiedState) uses suggests it's optional.
        if (dispatch) dispatch(clearSelectionStateTransaction);
    }
    return true;
};
const $8c9e5c0f44d7e20e$export$e6e93d61d1873d0c = (state, dispatch)=>{
    const { tr: tr } = state;
    const ignoreFollowingMutationsTr = tr;
    ignoreFollowingMutationsTr.setMeta((0, $cPDlc.pluginKey), {
        type: (0, $qwti8.ACTIONS).SET_SHOULD_IGNORE_FOLLOWING_MUTATIONS,
        data: true
    });
    if (dispatch) dispatch(ignoreFollowingMutationsTr);
    return true;
};
const $8c9e5c0f44d7e20e$export$60364cd5f5fed191 = (state, dispatch)=>{
    const { tr: tr } = state;
    const ignoreFollowingMutationsTr = tr;
    ignoreFollowingMutationsTr.setMeta((0, $cPDlc.pluginKey), {
        type: (0, $qwti8.ACTIONS).SET_SHOULD_IGNORE_FOLLOWING_MUTATIONS,
        data: false
    });
    if (dispatch) dispatch(ignoreFollowingMutationsTr);
    return true;
};
function $8c9e5c0f44d7e20e$export$c875ffe428b4a5f({ state: state }) {
    let { tr: tr } = state;
    const { from: from } = state.selection;
    const { codeBlock: codeBlock } = state.schema.nodes;
    const grandParentNode = state.selection.$from.node(-1);
    const grandParentNodeType = grandParentNode?.type;
    const parentNodeType = state.selection.$from.parent.type;
    /** We always want to append a codeBlock unless we're inserting into a paragraph
	 * AND it's a valid child of the grandparent node.
	 * Insert the current selection as codeBlock content unless it contains nodes other
	 * than paragraphs and inline.
	 */ const canInsertCodeBlock = (0, $j6ZdO.shouldSplitSelectedNodeOnNodeInsertion)({
        parentNodeType: parentNodeType,
        grandParentNodeType: grandParentNodeType,
        content: codeBlock.createAndFill()
    }) && (0, $j6ZdO.contentAllowedInCodeBlock)(state);
    if (canInsertCodeBlock) tr = (0, $b1dKB.transformToCodeBlockAction)(state, from, undefined);
    else (0, $BmspC.safeInsert)(codeBlock.createAndFill())(tr).scrollIntoView();
    return tr;
}
function $8c9e5c0f44d7e20e$export$a8d9c0f039b6fb43(inputMethod, analyticsAPI) {
    return (0, $asjM0.withAnalytics)(analyticsAPI, {
        action: (0, $bMFKb.ACTION).INSERTED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).CODE_BLOCK,
        attributes: {
            inputMethod: inputMethod
        },
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK
    })(function(state, dispatch) {
        const tr = $8c9e5c0f44d7e20e$export$c875ffe428b4a5f({
            state: state
        });
        if (dispatch) dispatch(tr);
        return true;
    });
}
const $8c9e5c0f44d7e20e$export$160d674382436f98 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const codeBlockNode = (0, $k2X9Z.findCodeBlock)(state)?.node;
        const { tr: tr } = state;
        if (!(0, $hbQpB.codeBlockWrappedStates) || !codeBlockNode) return false;
        const updatedToggleState = !(0, $hbQpB.isCodeBlockWordWrapEnabled)(codeBlockNode);
        (0, $hbQpB.codeBlockWrappedStates).set(codeBlockNode, updatedToggleState);
        tr.setMeta((0, $cPDlc.pluginKey), {
            type: (0, $qwti8.ACTIONS).SET_IS_WRAPPED,
            data: updatedToggleState
        });
        if (dispatch) {
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $bMFKb.ACTION).TOGGLE_CODE_BLOCK_WRAP,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).CODE_BLOCK,
                attributes: {
                    platform: (0, $8MfCL.PLATFORMS).WEB,
                    mode: (0, $8MfCL.MODE).EDITOR,
                    wordWrapEnabled: updatedToggleState,
                    codeBlockNodeSize: codeBlockNode.nodeSize
                },
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK
            })(tr);
            dispatch(tr);
        }
        return true;
    };

});
parcelRegister("58hN2", function(module, exports) {
$parcel$export(module.exports, "copyToClipboard", () => $4462298816d64b27$export$2cdf1b96a9f86d16);
$parcel$export(module.exports, "copyHTMLToClipboard", () => $4462298816d64b27$export$8b344d2a6a3e9af3);
$parcel$export(module.exports, "copyHTMLToClipboardPolyfill", () => $4462298816d64b27$export$97e18ff8b98c7078);
$parcel$export(module.exports, "getAnalyticsPayload", () => $4462298816d64b27$export$4feda93c1c6b2d80);
$parcel$export(module.exports, "getNodeCopiedAnalyticsPayload", () => $4462298816d64b27$export$f8811fa45a00fd64);
// Ignored via go/ees005
// eslint-disable-next-line import/no-namespace

var $4OJ8P = parcelRequire("4OJ8P");

var $3lIcL = parcelRequire("3lIcL");

var $bMFKb = parcelRequire("bMFKb");

var $7xtnm = parcelRequire("7xtnm");
const $4462298816d64b27$var$isClipboardApiSupported = ()=>!!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
const $4462298816d64b27$var$isIEClipboardApiSupported = ()=>// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.clipboardData && typeof window.clipboardData.setData === 'function';
const $4462298816d64b27$var$isExtensionNode = (node)=>{
    if (node === 'extension' || node === 'bodiedExtension' || node === 'inlineExtension' || node === 'multiBodiedExtension') return true;
    return false;
};
const $4462298816d64b27$export$2cdf1b96a9f86d16 = async (textToCopy)=>{
    if ($4462298816d64b27$var$isClipboardApiSupported()) try {
        await navigator.clipboard.writeText(textToCopy);
    } catch (error) {
        throw new Error('Clipboard api is not supported');
    }
    else if ($4462298816d64b27$var$isIEClipboardApiSupported()) try {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        await window.clipboardData.setData('text', textToCopy);
    } catch (error) {
        throw new Error('IE clipboard api is not supported');
    }
    else throw new Error('Clipboard api is not supported');
};
const $4462298816d64b27$export$8b344d2a6a3e9af3 = async (elementToCopy, plainTextToCopy)=>{
    // @ts-ignore
    if ($4462298816d64b27$var$isClipboardApiSupported() && typeof ClipboardItem !== 'undefined') try {
        const data = new ClipboardItem({
            'text/plain': new Blob([
                plainTextToCopy || elementToCopy.innerText
            ], {
                type: 'text/plain'
            }),
            'text/html': new Blob([
                elementToCopy.innerHTML
            ], {
                type: 'text/html'
            })
        });
        // @ts-ignore
        await navigator.clipboard.write([
            data
        ]);
    } catch (error) {
        throw new Error('Clipboard api is not supported');
    }
    else if (!!document && typeof document === 'object') try {
        // ED-17083 extension copy seems have issue with ClipboardItem API
        // Hence of use of this polyfill
        $4462298816d64b27$export$97e18ff8b98c7078(elementToCopy, plainTextToCopy);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
    }
};
const $4462298816d64b27$export$97e18ff8b98c7078 = async (elementToCopy, plainTextToCopy)=>{
    const dt = new $4OJ8P.ClipboardItem({
        'text/html': new Blob([
            elementToCopy.innerHTML
        ], {
            type: 'text/html'
        }),
        'text/plain': new Blob([
            plainTextToCopy || elementToCopy.innerText
        ], {
            type: 'text/plain'
        })
    });
    await $4OJ8P.write([
        dt
    ]);
};
const $4462298816d64b27$export$4feda93c1c6b2d80 = (state, action)=>{
    const { selection: selection, doc: doc } = state;
    const selectionAnalyticsPayload = (0, $7xtnm.getNodeSelectionAnalyticsPayload)(selection) || (0, $7xtnm.getRangeSelectionAnalyticsPayload)(selection, doc) || (0, $7xtnm.getAllSelectionAnalyticsPayload)(selection) || (0, $7xtnm.getCellSelectionAnalyticsPayload)(state);
    if (selectionAnalyticsPayload) {
        const { actionSubjectId: selectionActionSubjectId } = selectionAnalyticsPayload;
        const node = selectionAnalyticsPayload.attributes?.node;
        const content = [];
        let extensionType;
        let extensionKey;
        switch(selectionActionSubjectId){
            case (0, $bMFKb.ACTION_SUBJECT_ID).NODE:
                if (node) {
                    content.push(node);
                    if ($4462298816d64b27$var$isExtensionNode(node)) {
                        extensionType = selection.node.attrs.extensionType;
                        extensionKey = selection.node.attrs.extensionKey;
                    }
                }
                break;
            case (0, $bMFKb.ACTION_SUBJECT_ID).RANGE:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                content.push(...selectionAnalyticsPayload.attributes.nodes);
                break;
            case (0, $bMFKb.ACTION_SUBJECT_ID).ALL:
                content.push('all');
                break;
            case (0, $bMFKb.ACTION_SUBJECT_ID).CELL:
                {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const { selectedCells: selectedCells } = selectionAnalyticsPayload.attributes;
                    content.push(...Array(selectedCells).fill('tableCell'));
                    break;
                }
        }
        if ($4462298816d64b27$var$isExtensionNode(node)) return {
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
            action: action,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
            attributes: {
                content: content,
                extensionKey: extensionKey,
                extensionType: extensionType
            }
        };
        return {
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
            action: action,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
            attributes: {
                content: content
            }
        };
    }
    if (selection instanceof (0, $3lIcL.TextSelection) && selection.$cursor) return {
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
        action: action,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
        attributes: {
            content: [
                'caret'
            ]
        }
    };
};
const $4462298816d64b27$export$f8811fa45a00fd64 = (node, inputMethod)=>{
    const nodeType = node.type.name;
    let extensionType;
    let extensionKey;
    if ($4462298816d64b27$var$isExtensionNode(nodeType)) {
        extensionType = node.attrs.extensionType;
        extensionKey = node.attrs.extensionKey;
    }
    const payload = {
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
        action: (0, $bMFKb.ACTION).COPIED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
        attributes: {
            content: [
                nodeType
            ],
            inputMethod: inputMethod,
            nodeType: nodeType,
            ...extensionType ? {
                extensionType: extensionType
            } : {},
            ...extensionKey ? {
                extensionKey: extensionKey
            } : {}
        }
    };
    return payload;
};

});
parcelRegister("4OJ8P", function(module, exports) {
$parcel$export(module.exports, "ClipboardItem", () => $381ed90e93d28ded$export$3b1380c0957dc8fe);
$parcel$export(module.exports, "write", () => $381ed90e93d28ded$export$68d8715fc104d294);
// src/clipboard-polyfill/ClipboardItem/data-types.ts
var $381ed90e93d28ded$var$TEXT_PLAIN = "text/plain";
var $381ed90e93d28ded$var$TEXT_HTML = "text/html";
// src/clipboard-polyfill/debug.ts
var $381ed90e93d28ded$var$debugLogImpl = (s)=>{};
function $381ed90e93d28ded$var$debugLog(s) {
    $381ed90e93d28ded$var$debugLogImpl(s);
}
function $381ed90e93d28ded$export$e014146e87162c32(logFn) {
    $381ed90e93d28ded$var$debugLogImpl = logFn;
}
var $381ed90e93d28ded$var$showWarnings = true;
function $381ed90e93d28ded$export$ba5c9528becaaf25() {
    $381ed90e93d28ded$var$showWarnings = false;
}
function $381ed90e93d28ded$var$shouldShowWarnings() {
    return $381ed90e93d28ded$var$showWarnings;
}
function $381ed90e93d28ded$var$warnOrLog() {
    (console.warn || console.log).apply(console, arguments);
}
var $381ed90e93d28ded$var$warn = $381ed90e93d28ded$var$warnOrLog.bind("[clipboard-polyfill]");
// src/clipboard-polyfill/builtins/window-globalThis.ts
var $381ed90e93d28ded$var$originalWindow = typeof window === "undefined" ? void 0 : window;
var $381ed90e93d28ded$var$originalGlobalThis = typeof globalThis === "undefined" ? void 0 : globalThis;
// src/clipboard-polyfill/builtins/promise-constructor.ts
var $381ed90e93d28ded$var$_a, $381ed90e93d28ded$var$_b, $381ed90e93d28ded$var$_c;
var $381ed90e93d28ded$var$promiseConstructorImpl = ($381ed90e93d28ded$var$_c = ($381ed90e93d28ded$var$_a = $381ed90e93d28ded$var$originalWindow) == null ? void 0 : $381ed90e93d28ded$var$_a.Promise) != null ? $381ed90e93d28ded$var$_c : ($381ed90e93d28ded$var$_b = $381ed90e93d28ded$var$originalGlobalThis) == null ? void 0 : $381ed90e93d28ded$var$_b.Promise;
function $381ed90e93d28ded$var$getPromiseConstructor() {
    if (!$381ed90e93d28ded$var$promiseConstructorImpl) throw new Error("No `Promise` implementation available for `clipboard-polyfill`. Consider using: https://github.com/lgarron/clipboard-polyfill#flat-file-version-with-promise-included");
    return $381ed90e93d28ded$var$promiseConstructorImpl;
}
// src/clipboard-polyfill/builtins/builtin-globals.ts
var $381ed90e93d28ded$var$originalNavigator = typeof navigator === "undefined" ? void 0 : navigator;
var $381ed90e93d28ded$var$originalNavigatorClipboard = $381ed90e93d28ded$var$originalNavigator == null ? void 0 : $381ed90e93d28ded$var$originalNavigator.clipboard;
var $381ed90e93d28ded$var$_a2;
var $381ed90e93d28ded$var$originalNavigatorClipboardRead = ($381ed90e93d28ded$var$_a2 = $381ed90e93d28ded$var$originalNavigatorClipboard == null ? void 0 : $381ed90e93d28ded$var$originalNavigatorClipboard.read) == null ? void 0 : $381ed90e93d28ded$var$_a2.bind($381ed90e93d28ded$var$originalNavigatorClipboard);
var $381ed90e93d28ded$var$_a3;
var $381ed90e93d28ded$var$originalNavigatorClipboardReadText = ($381ed90e93d28ded$var$_a3 = $381ed90e93d28ded$var$originalNavigatorClipboard == null ? void 0 : $381ed90e93d28ded$var$originalNavigatorClipboard.readText) == null ? void 0 : $381ed90e93d28ded$var$_a3.bind($381ed90e93d28ded$var$originalNavigatorClipboard);
var $381ed90e93d28ded$var$_a4;
var $381ed90e93d28ded$var$originalNavigatorClipboardWrite = ($381ed90e93d28ded$var$_a4 = $381ed90e93d28ded$var$originalNavigatorClipboard == null ? void 0 : $381ed90e93d28ded$var$originalNavigatorClipboard.write) == null ? void 0 : $381ed90e93d28ded$var$_a4.bind($381ed90e93d28ded$var$originalNavigatorClipboard);
var $381ed90e93d28ded$var$_a5;
var $381ed90e93d28ded$var$originalNavigatorClipboardWriteText = ($381ed90e93d28ded$var$_a5 = $381ed90e93d28ded$var$originalNavigatorClipboard == null ? void 0 : $381ed90e93d28ded$var$originalNavigatorClipboard.writeText) == null ? void 0 : $381ed90e93d28ded$var$_a5.bind($381ed90e93d28ded$var$originalNavigatorClipboard);
var $381ed90e93d28ded$var$_a6;
var $381ed90e93d28ded$var$originalWindowClipboardItem = ($381ed90e93d28ded$var$_a6 = $381ed90e93d28ded$var$originalWindow) == null ? void 0 : $381ed90e93d28ded$var$_a6.ClipboardItem;
var $381ed90e93d28ded$var$promiseConstructor = $381ed90e93d28ded$var$getPromiseConstructor();
// src/clipboard-polyfill/strategies/internet-explorer.ts
var $381ed90e93d28ded$var$ieWindow = $381ed90e93d28ded$var$originalWindow;
function $381ed90e93d28ded$var$seemToBeInIE() {
    return typeof ClipboardEvent === "undefined" && typeof ($381ed90e93d28ded$var$ieWindow == null ? void 0 : $381ed90e93d28ded$var$ieWindow.clipboardData) !== "undefined" && typeof ($381ed90e93d28ded$var$ieWindow == null ? void 0 : $381ed90e93d28ded$var$ieWindow.clipboardData.setData) !== "undefined";
}
function $381ed90e93d28ded$var$writeTextIE(text) {
    if (!$381ed90e93d28ded$var$ieWindow.clipboardData) return false;
    var success = $381ed90e93d28ded$var$ieWindow.clipboardData.setData("Text", text);
    if (success) $381ed90e93d28ded$var$debugLog("writeTextIE worked");
    return success;
}
function $381ed90e93d28ded$var$readTextIE() {
    if (!$381ed90e93d28ded$var$ieWindow.clipboardData) throw new Error("Cannot read IE clipboard Data ");
    var text = $381ed90e93d28ded$var$ieWindow.clipboardData.getData("Text");
    if (text === "") throw new Error("Empty clipboard or could not read plain text from clipboard");
    return text;
}
// src/clipboard-polyfill/strategies/dom.ts
function $381ed90e93d28ded$var$copyListener(tracker, data, e) {
    $381ed90e93d28ded$var$debugLog("listener called");
    tracker.success = true;
    for(var type in data){
        var value = data[type];
        var clipboardData = e.clipboardData;
        clipboardData.setData(type, value);
        if (type === $381ed90e93d28ded$var$TEXT_PLAIN && clipboardData.getData(type) !== value) {
            $381ed90e93d28ded$var$debugLog("setting text/plain failed");
            tracker.success = false;
        }
    }
    e.preventDefault();
}
function $381ed90e93d28ded$var$execCopy(data) {
    var tracker = {
        success: false
    };
    var listener = $381ed90e93d28ded$var$copyListener.bind(this, tracker, data);
    document.addEventListener("copy", listener);
    try {
        document.execCommand("copy");
    } finally{
        document.removeEventListener("copy", listener);
    }
    return tracker.success;
}
function $381ed90e93d28ded$var$copyUsingTempSelection(e, data) {
    $381ed90e93d28ded$var$selectionSet(e);
    var success = $381ed90e93d28ded$var$execCopy(data);
    $381ed90e93d28ded$var$selectionClear();
    return success;
}
function $381ed90e93d28ded$var$copyUsingTempElem(data) {
    var tempElem = document.createElement("div");
    tempElem.setAttribute("style", "-webkit-user-select: text !important");
    tempElem.textContent = "temporary element";
    document.body.appendChild(tempElem);
    var success = $381ed90e93d28ded$var$copyUsingTempSelection(tempElem, data);
    document.body.removeChild(tempElem);
    return success;
}
function $381ed90e93d28ded$var$copyTextUsingDOM(str) {
    $381ed90e93d28ded$var$debugLog("copyTextUsingDOM");
    var tempElem = document.createElement("div");
    tempElem.setAttribute("style", "-webkit-user-select: text !important");
    var spanParent = tempElem;
    if (tempElem.attachShadow) {
        $381ed90e93d28ded$var$debugLog("Using shadow DOM.");
        spanParent = tempElem.attachShadow({
            mode: "open"
        });
    }
    var span = document.createElement("span");
    span.innerText = str;
    spanParent.appendChild(span);
    document.body.appendChild(tempElem);
    $381ed90e93d28ded$var$selectionSet(span);
    var result = document.execCommand("copy");
    $381ed90e93d28ded$var$selectionClear();
    document.body.removeChild(tempElem);
    return result;
}
function $381ed90e93d28ded$var$selectionSet(elem) {
    var sel = document.getSelection();
    if (sel) {
        var range = document.createRange();
        range.selectNodeContents(elem);
        sel.removeAllRanges();
        sel.addRange(range);
    }
}
function $381ed90e93d28ded$var$selectionClear() {
    var sel = document.getSelection();
    if (sel) sel.removeAllRanges();
}
// src/clipboard-polyfill/implementations/write-fallback.ts
function $381ed90e93d28ded$var$writeFallback(stringItem) {
    var hasTextPlain = $381ed90e93d28ded$var$TEXT_PLAIN in stringItem;
    if ($381ed90e93d28ded$var$seemToBeInIE()) {
        if (!hasTextPlain) throw new Error("No `text/plain` value was specified.");
        if ($381ed90e93d28ded$var$writeTextIE(stringItem[$381ed90e93d28ded$var$TEXT_PLAIN])) return true;
        else throw new Error("Copying failed, possibly because the user rejected it.");
    }
    if ($381ed90e93d28ded$var$execCopy(stringItem)) {
        $381ed90e93d28ded$var$debugLog("regular execCopy worked");
        return true;
    }
    if (navigator.userAgent.indexOf("Edge") > -1) {
        $381ed90e93d28ded$var$debugLog('UA "Edge" => assuming success');
        return true;
    }
    if ($381ed90e93d28ded$var$copyUsingTempSelection(document.body, stringItem)) {
        $381ed90e93d28ded$var$debugLog("copyUsingTempSelection worked");
        return true;
    }
    if ($381ed90e93d28ded$var$copyUsingTempElem(stringItem)) {
        $381ed90e93d28ded$var$debugLog("copyUsingTempElem worked");
        return true;
    }
    if ($381ed90e93d28ded$var$copyTextUsingDOM(stringItem[$381ed90e93d28ded$var$TEXT_PLAIN])) {
        $381ed90e93d28ded$var$debugLog("copyTextUsingDOM worked");
        return true;
    }
    return false;
}
// src/clipboard-polyfill/promise/promise-compat.ts
function $381ed90e93d28ded$var$promiseRecordMap(keys, f) {
    var promiseList = [];
    for(var i in keys){
        var key = keys[i];
        promiseList.push(f(key));
    }
    return $381ed90e93d28ded$var$promiseConstructor.all(promiseList).then((vList)=>{
        var dataOut = {};
        for(var i2 = 0; i2 < keys.length; i2++)dataOut[keys[i2]] = vList[i2];
        return dataOut;
    });
}
var $381ed90e93d28ded$var$voidPromise = $381ed90e93d28ded$var$promiseConstructor.resolve();
var $381ed90e93d28ded$var$truePromiseFn = ()=>$381ed90e93d28ded$var$promiseConstructor.resolve(true);
var $381ed90e93d28ded$var$falsePromise = $381ed90e93d28ded$var$promiseConstructor.resolve(false);
function $381ed90e93d28ded$var$rejectThrownErrors(executor) {
    return new $381ed90e93d28ded$var$promiseConstructor((resolve, reject)=>{
        try {
            resolve(executor());
        } catch (e) {
            reject(e);
        }
    });
}
// src/clipboard-polyfill/implementations/text.ts
function $381ed90e93d28ded$var$stringToStringItem(s) {
    var stringItem = {};
    stringItem[$381ed90e93d28ded$var$TEXT_PLAIN] = s;
    return stringItem;
}
function $381ed90e93d28ded$export$bec150f75a9b8f11(s) {
    return $381ed90e93d28ded$var$rejectThrownErrors(()=>{
        if ($381ed90e93d28ded$var$originalNavigatorClipboardWriteText) {
            $381ed90e93d28ded$var$debugLog("Using `navigator.clipboard.writeText()`.");
            return $381ed90e93d28ded$var$originalNavigatorClipboardWriteText(s).catch($381ed90e93d28ded$var$writeTextStringFallback);
        }
        return $381ed90e93d28ded$var$promiseConstructor.resolve($381ed90e93d28ded$var$writeTextStringFallback(s));
    });
}
function $381ed90e93d28ded$var$writeTextStringFallback(s) {
    if (!$381ed90e93d28ded$var$writeFallback($381ed90e93d28ded$var$stringToStringItem(s))) throw new Error("writeText() failed");
}
function $381ed90e93d28ded$export$bee0113684d8879b() {
    return $381ed90e93d28ded$var$rejectThrownErrors(()=>{
        if ($381ed90e93d28ded$var$originalNavigatorClipboardReadText) {
            $381ed90e93d28ded$var$debugLog("Using `navigator.clipboard.readText()`.");
            return $381ed90e93d28ded$var$originalNavigatorClipboardReadText();
        }
        if ($381ed90e93d28ded$var$seemToBeInIE()) {
            var result = $381ed90e93d28ded$var$readTextIE();
            return $381ed90e93d28ded$var$promiseConstructor.resolve(result);
        }
        throw new Error("Read is not supported in your browser.");
    });
}
// src/clipboard-polyfill/ClipboardItem/check.ts
function $381ed90e93d28ded$var$hasItemWithType(clipboardItems, typeName) {
    for(var i in clipboardItems){
        var item = clipboardItems[i];
        if (item.types.indexOf(typeName) !== -1) return true;
    }
    return false;
}
// src/clipboard-polyfill/ClipboardItem/ClipboardItemPolyfill.ts
function $381ed90e93d28ded$var$ClipboardItemPolyfillImpl(items, options) {
    var _a7;
    var types = Object.keys(items);
    var _items = {};
    for(var type in items){
        var item = items[type];
        if (typeof item === "string") _items[type] = $381ed90e93d28ded$var$stringToBlob(type, item);
        else _items[type] = item;
    }
    var presentationStyle = (_a7 = options == null ? void 0 : options.presentationStyle) != null ? _a7 : "unspecified";
    function getType(type2) {
        return $381ed90e93d28ded$var$promiseConstructor.resolve(_items[type2]);
    }
    return {
        types: types,
        presentationStyle: presentationStyle,
        getType: getType
    };
}
var $381ed90e93d28ded$export$3b1380c0957dc8fe = $381ed90e93d28ded$var$ClipboardItemPolyfillImpl;
// src/clipboard-polyfill/ClipboardItem/convert.ts
function $381ed90e93d28ded$var$stringToBlob(type, str) {
    return new Blob([
        str
    ], {
        type: type
    });
}
function $381ed90e93d28ded$var$blobToString(blob) {
    return new $381ed90e93d28ded$var$promiseConstructor((resolve, reject)=>{
        var fileReader = new FileReader();
        fileReader.addEventListener("load", ()=>{
            var result = fileReader.result;
            if (typeof result === "string") resolve(result);
            else reject("could not convert blob to string");
        });
        fileReader.readAsText(blob);
    });
}
function $381ed90e93d28ded$var$clipboardItemToGlobalClipboardItem(clipboardItem) {
    return $381ed90e93d28ded$var$promiseRecordMap(clipboardItem.types, function(type) {
        return clipboardItem.getType(type);
    }).then((items)=>{
        return new Promise((resolve, reject)=>{
            var options = {};
            if (clipboardItem.presentationStyle) options.presentationStyle = clipboardItem.presentationStyle;
            if ($381ed90e93d28ded$var$originalWindowClipboardItem) resolve(new $381ed90e93d28ded$var$originalWindowClipboardItem(items, options));
            else reject("window.ClipboardItem is not defined");
        });
    });
}
function $381ed90e93d28ded$var$textToClipboardItem(text) {
    var items = {};
    items[$381ed90e93d28ded$var$TEXT_PLAIN] = $381ed90e93d28ded$var$stringToBlob(text, $381ed90e93d28ded$var$TEXT_PLAIN);
    return new $381ed90e93d28ded$export$3b1380c0957dc8fe(items);
}
function $381ed90e93d28ded$var$getTypeAsString(clipboardItem, type) {
    return clipboardItem.getType(type).then((text)=>{
        return $381ed90e93d28ded$var$blobToString(text);
    });
}
function $381ed90e93d28ded$var$toStringItem(data) {
    return $381ed90e93d28ded$var$promiseRecordMap(data.types, function(type) {
        return $381ed90e93d28ded$var$getTypeAsString(data, type);
    });
}
// src/clipboard-polyfill/implementations/blob.ts
function $381ed90e93d28ded$export$68d8715fc104d294(data) {
    return $381ed90e93d28ded$var$rejectThrownErrors(()=>{
        if ($381ed90e93d28ded$var$originalNavigatorClipboardWrite && $381ed90e93d28ded$var$originalWindowClipboardItem) {
            var originalNavigatorClipboardWriteCached = $381ed90e93d28ded$var$originalNavigatorClipboardWrite;
            $381ed90e93d28ded$var$debugLog("Using `navigator.clipboard.write()`.");
            return $381ed90e93d28ded$var$promiseConstructor.all(data.map($381ed90e93d28ded$var$clipboardItemToGlobalClipboardItem)).then((globalClipboardItems)=>{
                return originalNavigatorClipboardWriteCached(globalClipboardItems).then($381ed90e93d28ded$var$truePromiseFn).catch((e)=>{
                    if (!$381ed90e93d28ded$var$hasItemWithType(data, $381ed90e93d28ded$var$TEXT_PLAIN) && !$381ed90e93d28ded$var$hasItemWithType(data, $381ed90e93d28ded$var$TEXT_HTML)) throw e;
                    return $381ed90e93d28ded$var$falsePromise;
                });
            });
        }
        return $381ed90e93d28ded$var$falsePromise;
    }).then((success)=>{
        if (success) return $381ed90e93d28ded$var$voidPromise;
        var hasTextPlain = $381ed90e93d28ded$var$hasItemWithType(data, $381ed90e93d28ded$var$TEXT_PLAIN);
        if ($381ed90e93d28ded$var$shouldShowWarnings() && !hasTextPlain) $381ed90e93d28ded$var$debugLog("clipboard.write() was called without a `text/plain` data type. On some platforms, this may result in an empty clipboard. Call suppressWarnings() to suppress this warning.");
        return $381ed90e93d28ded$var$toStringItem(data[0]).then((stringItem)=>{
            if (!$381ed90e93d28ded$var$writeFallback(stringItem)) throw new Error("write() failed");
        });
    });
}
function $381ed90e93d28ded$export$aafa59e2e03f2942() {
    return $381ed90e93d28ded$var$rejectThrownErrors(()=>{
        if ($381ed90e93d28ded$var$originalNavigatorClipboardRead) {
            $381ed90e93d28ded$var$debugLog("Using `navigator.clipboard.read()`.");
            return $381ed90e93d28ded$var$originalNavigatorClipboardRead();
        }
        return $381ed90e93d28ded$export$bee0113684d8879b().then((text)=>{
            return [
                $381ed90e93d28ded$var$textToClipboardItem(text)
            ];
        });
    });
}

});

parcelRegister("7xtnm", function(module, exports) {
$parcel$export(module.exports, "getNodeSelectionAnalyticsPayload", () => $09c262605d5c0f03$export$3162c38157c33ee6);
$parcel$export(module.exports, "getAllSelectionAnalyticsPayload", () => $09c262605d5c0f03$export$9f3a063378bdcaa1);
$parcel$export(module.exports, "getCellSelectionAnalyticsPayload", () => $09c262605d5c0f03$export$dcdd07dcad6adb98);
$parcel$export(module.exports, "getRangeSelectionAnalyticsPayload", () => $09c262605d5c0f03$export$bf6883b886d952b0);
$parcel$export(module.exports, "createSelectionClickHandler", () => $09c262605d5c0f03$export$563f7987ca7936f1);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $3lIcL = parcelRequire("3lIcL");

var $cwzAY = parcelRequire("cwzAY");

var $4fn0w = parcelRequire("4fn0w");

var $bMFKb = parcelRequire("bMFKb");

var $5n5Zn = parcelRequire("5n5Zn");

var $6BNUN = parcelRequire("6BNUN");

var $gEqKI = parcelRequire("gEqKI");

var $cm19r = parcelRequire("cm19r");

var $8TSsQ = parcelRequire("8TSsQ");

var $6zZWQ = parcelRequire("6zZWQ");

var $3N6pN = parcelRequire("3N6pN");

var $iqjsw = parcelRequire("iqjsw");
function $09c262605d5c0f03$export$3162c38157c33ee6(selection) {
    if (selection instanceof (0, $3lIcL.NodeSelection)) return {
        action: (0, $bMFKb.ACTION).SELECTED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).NODE,
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
        attributes: {
            node: selection.node.type.name
        }
    };
}
function $09c262605d5c0f03$export$9f3a063378bdcaa1(selection) {
    if (selection instanceof (0, $3lIcL.AllSelection)) return {
        action: (0, $bMFKb.ACTION).SELECTED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).ALL,
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK
    };
}
function $09c262605d5c0f03$export$dcdd07dcad6adb98(state) {
    if (state.selection instanceof (0, $cwzAY.CellSelection)) {
        const rect = (0, $4fn0w.selectedRect)(state);
        const selectedCells = rect.map.cellsInRect(rect).length;
        const totalCells = rect.map.map.length;
        return {
            action: (0, $bMFKb.ACTION).SELECTED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).CELL,
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
            attributes: {
                selectedCells: selectedCells,
                totalCells: totalCells
            }
        };
    }
}
function $09c262605d5c0f03$export$bf6883b886d952b0(selection, doc) {
    if (selection instanceof (0, $3lIcL.TextSelection) && selection.from !== selection.to) {
        const { from: from, to: to, anchor: anchor, head: head } = selection;
        const nodes = [];
        doc.nodesBetween(from, to, (node, pos)=>{
            // We want to send top-level nodes only, ie.the nodes that would have the selection styling
            // We allow text nodes that are not fully covered as they are a special case
            if (node.isText || pos >= from && pos + node.nodeSize <= to) {
                nodes.push(node.type.name);
                return false;
            }
        });
        return {
            action: (0, $bMFKb.ACTION).SELECTED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).RANGE,
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
            attributes: {
                from: anchor,
                to: head,
                nodes: nodes
            }
        };
    }
}
const $09c262605d5c0f03$export$cbcb4f775d907a9e = (pos)=>(state, dispatch)=>{
        if (dispatch) dispatch(state.tr.setSelection(new (0, $3lIcL.NodeSelection)(state.doc.resolve(pos))));
        return true;
    };
function $09c262605d5c0f03$export$563f7987ca7936f1(nodes, isValidTarget, options) {
    return function handleClickOn(view, pos, node, nodePos, event, direct) {
        if (options.useLongPressSelection) return false;
        if (direct && nodes.indexOf(node.type.name) !== -1) {
            const target = event.target;
            if (target instanceof HTMLElement && isValidTarget(target)) {
                const selectionPos = options.getNodeSelectionPos ? options.getNodeSelectionPos(view.state, nodePos) : nodePos;
                $09c262605d5c0f03$export$cbcb4f775d907a9e(selectionPos)(view.state, view.dispatch);
                return true;
            }
        }
        return false;
    };
}

});
parcelRegister("4fn0w", function(module, exports) {
$parcel$export(module.exports, "selectedRect", () => $351d80593845a142$export$39ce22e69aa9ed17);

var $cwzAY = parcelRequire("cwzAY");

var $2vA54 = parcelRequire("2vA54");

var $a57M0 = parcelRequire("a57M0");
function $351d80593845a142$export$39ce22e69aa9ed17(state) {
    const sel = state.selection;
    const $pos = (0, $a57M0.selectionCell)(sel);
    if (!$pos) throw new Error(`selectedRect: invalid $pos for selection`);
    const table = $pos.node(-1);
    const tableStart = $pos.start(-1);
    const map = (0, $2vA54.TableMap).get(table);
    let rect;
    if (sel instanceof (0, $cwzAY.CellSelection)) rect = map.rectBetween(sel.$anchorCell.pos - tableStart, sel.$headCell.pos - tableStart);
    else rect = map.findCell($pos.pos - tableStart);
    rect.tableStart = tableStart;
    rect.map = map;
    rect.table = table;
    return rect;
}

});
parcelRegister("a57M0", function(module, exports) {
$parcel$export(module.exports, "selectionCell", () => $519e662fb5a9bfe0$export$aad75348c8f2d244);

var $cSPHa = parcelRequire("cSPHa");

var $6dtFv = parcelRequire("6dtFv");
function $519e662fb5a9bfe0$export$aad75348c8f2d244(selection) {
    if ((0, $6dtFv.isSelectionType)(selection, 'cell')) return selection.$anchorCell.pos > selection.$headCell.pos ? selection.$anchorCell : selection.$headCell;
    if ((0, $6dtFv.isSelectionType)(selection, 'node') && selection.node.type.spec.tableRole === 'cell') return selection.$anchor;
    return (0, $cSPHa.cellAround)(selection.$head) || (0, $cSPHa.cellNear)(selection.$head);
}

});
parcelRegister("6dtFv", function(module, exports) {
$parcel$export(module.exports, "isSelectionType", () => $05939f259ca4311e$export$626dcc173023aed7);
function $05939f259ca4311e$export$626dcc173023aed7(selection, type) {
    if (!selection) return false;
    const serialized = selection.toJSON();
    return serialized.type === type;
}

});



parcelRegister("5n5Zn", function(module, exports) {
$parcel$export(module.exports, "RelativeSelectionPos", () => $2fdbd9918acdbc6c$export$cb9005d223ae8de7);
var $2fdbd9918acdbc6c$export$cb9005d223ae8de7 = /*#__PURE__*/ function(RelativeSelectionPos) {
    RelativeSelectionPos["Before"] = "Before";
    RelativeSelectionPos["Start"] = "Start";
    RelativeSelectionPos["Inside"] = "Inside";
    RelativeSelectionPos["End"] = "End";
    return RelativeSelectionPos;
}({});

});

parcelRegister("gEqKI", function(module, exports) {
$parcel$export(module.exports, "setSelectionTopLevelBlocks", () => $a7c226ba21b437a8$export$1b305efb24649ca5);
$parcel$export(module.exports, "setGapCursorAtPos", () => $a7c226ba21b437a8$export$44fdd7840a0a11f2);

var $3lIcL = parcelRequire("3lIcL");

var $6BNUN = parcelRequire("6BNUN");

var $8TSsQ = parcelRequire("8TSsQ");
// This function captures clicks outside of the ProseMirror contentEditable area
// see also description of "handleClick" in gap-cursor pm-plugin
const $a7c226ba21b437a8$var$captureCursorCoords = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
event, editorRef, posAtCoords, tr)=>{
    const rect = editorRef.getBoundingClientRect();
    // capture clicks before the first block element
    if (event.clientY < rect.top) return {
        position: 0,
        side: (0, $6BNUN.Side).LEFT
    };
    if (rect.left > 0) {
        // calculate start position of a node that is vertically at the same level
        const coords = posAtCoords({
            left: rect.left,
            top: event.clientY
        });
        if (coords && coords.inside > -1) {
            const $from = tr.doc.resolve(coords.inside);
            const start = $from.before(1);
            const side = event.clientX < rect.left ? (0, $6BNUN.Side).LEFT : (0, $6BNUN.Side).RIGHT;
            let position;
            if (side === (0, $6BNUN.Side).LEFT) position = start;
            else {
                const node = tr.doc.nodeAt(start);
                if (node) position = start + node.nodeSize;
            }
            return {
                position: position,
                side: side
            };
        }
    }
    return null;
};
const $a7c226ba21b437a8$export$1b305efb24649ca5 = (tr, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
event, editorRef, posAtCoords, editorFocused)=>{
    const cursorCoords = $a7c226ba21b437a8$var$captureCursorCoords(event, editorRef, posAtCoords, tr);
    if (!cursorCoords) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const $pos = cursorCoords.position !== undefined ? tr.doc.resolve(cursorCoords.position) : null;
    if ($pos === null) return;
    const isGapCursorAllowed = cursorCoords.side === (0, $6BNUN.Side).LEFT ? (0, $8TSsQ.isValidTargetNode)($pos.nodeAfter) : (0, $8TSsQ.isValidTargetNode)($pos.nodeBefore);
    if (isGapCursorAllowed && (0, $6BNUN.GapCursorSelection).valid($pos)) {
        // this forces PM to re-render the decoration node if we change the side of the gap cursor, it doesn't do it by default
        if (tr.selection instanceof (0, $6BNUN.GapCursorSelection)) tr.setSelection((0, $3lIcL.Selection).near($pos));
        else tr.setSelection(new (0, $6BNUN.GapCursorSelection)($pos, cursorCoords.side));
    } else if (editorFocused === false) {
        const selectionTemp = (0, $3lIcL.Selection).findFrom($pos, cursorCoords.side === (0, $6BNUN.Side).LEFT ? 1 : -1, true);
        if (selectionTemp) tr.setSelection(selectionTemp);
    }
};
const $a7c226ba21b437a8$export$44fdd7840a0a11f2 = (position, side = (0, $6BNUN.Side).LEFT)=>(state, dispatch)=>{
        // @see ED-6231
        if (position > state.doc.content.size) return false;
        const $pos = state.doc.resolve(position);
        if ((0, $6BNUN.GapCursorSelection).valid($pos)) {
            if (dispatch) dispatch(state.tr.setSelection(new (0, $6BNUN.GapCursorSelection)($pos, side)));
            return true;
        }
        return false;
    };

});

parcelRegister("6zZWQ", function(module, exports) {
$parcel$export(module.exports, "setGapCursorSelection", () => $46b7320c96bd71cd$export$a8946811e8b82dd);

var $6BNUN = parcelRequire("6BNUN");
function $46b7320c96bd71cd$export$a8946811e8b82dd(view, pos, side) {
    const { state: state } = view;
    view.dispatch(state.tr.setSelection(new (0, $6BNUN.GapCursorSelection)(state.doc.resolve(pos), side)));
}

});

parcelRegister("3N6pN", function(module, exports) {
$parcel$export(module.exports, "hideCaretModifier", () => $c949221da68db29f$export$8adc5edbc4a22166);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");
const $c949221da68db29f$var$gapCursorBlink = (0, $1NIU8.keyframes)({
    'from, to': {
        opacity: 0
    },
    '50%': {
        opacity: 1
    }
});
const $c949221da68db29f$export$8adc5edbc4a22166 = 'ProseMirror-hide-gapcursor';
const $c949221da68db29f$var$gapCursor = '.ProseMirror-gapcursor';
const $c949221da68db29f$var$prosemirrorwidgetNotBlock = '.ProseMirror-widget:not([data-blocks-decoration-container="true"]):not([data-blocks-drag-handle-container="true"]):not([data-blocks-quick-insert-container="true"])';
const $c949221da68db29f$var$wrapLeft = '[layout="wrap-left"]';
const $c949221da68db29f$var$wrapRight = '[layout="wrap-right"]';
const $c949221da68db29f$export$f6b9d90c2745834e = /*#__PURE__*/ (0, $1NIU8.css)(".ProseMirror{&.", $c949221da68db29f$export$8adc5edbc4a22166, "{caret-color:transparent;}", $c949221da68db29f$var$gapCursor, "{display:none;pointer-events:none;position:relative;& span{caret-color:transparent;position:absolute;height:100%;width:100%;display:block;}& span::after{animation:1s ", $c949221da68db29f$var$gapCursorBlink, " step-start infinite;border-left:1px solid;content:'';display:block;position:absolute;top:0;height:100%;}&.-left span::after{left:var(--ds-space-negative-050, -4px);}&.-right span::after{right:var(--ds-space-negative-050, -4px);}& span[layout='full-width'],& span[layout='wide'],& span[layout='fixed-width']{margin-left:50%;transform:translateX(-50%);}&", $c949221da68db29f$var$wrapRight, "{float:right;}&:first-of-type+ul,&:first-of-type+span+ul,&:first-of-type+ol,&:first-of-type+span+ol,&:first-of-type+pre,&:first-of-type+span+pre,&:first-of-type+blockquote,&:first-of-type+span+blockquote{margin-top:0;}}&.ProseMirror-focused ", $c949221da68db29f$var$gapCursor, "{display:block;border-color:transparent;}}", $c949221da68db29f$var$gapCursor, $c949221da68db29f$var$wrapLeft, "+span+", $c949221da68db29f$var$wrapLeft, ",", $c949221da68db29f$var$gapCursor, $c949221da68db29f$var$wrapRight, "+span+", $c949221da68db29f$var$wrapRight, ",", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapLeft, "+", $c949221da68db29f$var$wrapRight, ",", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapLeft, "+span+", $c949221da68db29f$var$wrapRight, ",", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapRight, "+", $c949221da68db29f$var$wrapLeft, ",", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapRight, "+span+", $c949221da68db29f$var$wrapLeft, ",", $c949221da68db29f$var$wrapLeft, "+", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapRight, ",", $c949221da68db29f$var$wrapLeft, "+", $c949221da68db29f$var$gapCursor, "+span ", $c949221da68db29f$var$wrapRight, ",", $c949221da68db29f$var$wrapRight, "+", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapLeft, ",", $c949221da68db29f$var$wrapRight, "+", $c949221da68db29f$var$gapCursor, "+span+", $c949221da68db29f$var$wrapLeft, ",", $c949221da68db29f$var$wrapLeft, "+", $c949221da68db29f$var$gapCursor, "{clear:none;}", $c949221da68db29f$var$wrapLeft, "+", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapRight, ">div,", $c949221da68db29f$var$wrapLeft, "+", $c949221da68db29f$var$gapCursor, "+span+", $c949221da68db29f$var$wrapRight, ">div,", $c949221da68db29f$var$wrapRight, "+", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapLeft, ">div,", $c949221da68db29f$var$wrapRight, "+", $c949221da68db29f$var$gapCursor, "+span+", $c949221da68db29f$var$wrapLeft, ">div,", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapRight, "+", $c949221da68db29f$var$wrapLeft, ">div,", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapRight, "+span+", $c949221da68db29f$var$wrapLeft, ">div,", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapLeft, "+", $c949221da68db29f$var$wrapRight, ">div,", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapLeft, "+span+", $c949221da68db29f$var$wrapRight, ">div{margin-right:0;margin-left:0;margin-bottom:0;}", $c949221da68db29f$var$wrapLeft, "+", $c949221da68db29f$var$gapCursor, ",", $c949221da68db29f$var$wrapRight, "+", $c949221da68db29f$var$gapCursor, "{float:left;}", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapLeft, "+span+", $c949221da68db29f$var$wrapRight, "::after,", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapRight, "+span+", $c949221da68db29f$var$wrapLeft, "::after,", $c949221da68db29f$var$wrapLeft, "+", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapRight, "::after,", $c949221da68db29f$var$wrapLeft, "+", $c949221da68db29f$var$gapCursor, "+span+", $c949221da68db29f$var$wrapRight, "::after,", $c949221da68db29f$var$wrapRight, "+", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapLeft, "::after,", $c949221da68db29f$var$wrapRight, "+", $c949221da68db29f$var$gapCursor, "+span+", $c949221da68db29f$var$wrapLeft, "::after{visibility:hidden;display:block;font-size:0;content:' ';clear:both;height:0;}", $c949221da68db29f$var$wrapLeft, "+", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapRight, "+*,", $c949221da68db29f$var$wrapLeft, "+", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapRight, "+span+*,", $c949221da68db29f$var$wrapRight, "+", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapLeft, "+*,", $c949221da68db29f$var$wrapRight, "+", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapLeft, "+span+*,", $c949221da68db29f$var$wrapLeft, "+", $c949221da68db29f$var$gapCursor, "+span+", $c949221da68db29f$var$wrapRight, "+*,", $c949221da68db29f$var$wrapRight, "+", $c949221da68db29f$var$gapCursor, "+span+", $c949221da68db29f$var$wrapLeft, "+*,", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapLeft, "+span+", $c949221da68db29f$var$wrapRight, "+*,", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapRight, "+span+", $c949221da68db29f$var$wrapLeft, "+*,", $c949221da68db29f$var$wrapLeft, "+", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapRight, "+*>*,", $c949221da68db29f$var$wrapLeft, "+", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapRight, "+span+*>*,", $c949221da68db29f$var$wrapRight, "+", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapLeft, "+*>*,", $c949221da68db29f$var$wrapRight, "+", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapLeft, "+span+*>*,", $c949221da68db29f$var$wrapLeft, "+", $c949221da68db29f$var$gapCursor, "+span+", $c949221da68db29f$var$wrapRight, "+*>*,", $c949221da68db29f$var$wrapRight, "+", $c949221da68db29f$var$gapCursor, "+span+", $c949221da68db29f$var$wrapLeft, "+*>*,", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapLeft, "+span+", $c949221da68db29f$var$wrapRight, "+*>*,", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapRight, "+span+", $c949221da68db29f$var$wrapLeft, "+*>*,", $c949221da68db29f$var$prosemirrorwidgetNotBlock, "+", $c949221da68db29f$var$gapCursor, "+*,", $c949221da68db29f$var$prosemirrorwidgetNotBlock, "+", $c949221da68db29f$var$gapCursor, "+span+*{margin-top:0;}");

});

parcelRegister("iqjsw", function(module, exports) {
$parcel$export(module.exports, "isSelectionAtStartOfNode", () => $40db8b6c9f98bf36$export$2543715425b0bf0b);
$parcel$export(module.exports, "isSelectionAtEndOfNode", () => $40db8b6c9f98bf36$export$5762916b8b83bc6d);
$parcel$export(module.exports, "atTheEndOfDoc", () => $40db8b6c9f98bf36$export$4ca816540352da02);
$parcel$export(module.exports, "atTheBeginningOfDoc", () => $40db8b6c9f98bf36$export$e9083e8cbe24bec0);
$parcel$export(module.exports, "atTheEndOfBlock", () => $40db8b6c9f98bf36$export$6f303ca7dac350ae);
$parcel$export(module.exports, "endPositionOfParent", () => $40db8b6c9f98bf36$export$8e09b50c60354750);
$parcel$export(module.exports, "atTheBeginningOfBlock", () => $40db8b6c9f98bf36$export$8351d833af62ae68);
$parcel$export(module.exports, "startPositionOfParent", () => $40db8b6c9f98bf36$export$ced77c72038c89cb);

var $3lIcL = parcelRequire("3lIcL");

var $6BNUN = parcelRequire("6BNUN");
const $40db8b6c9f98bf36$export$2543715425b0bf0b = ($pos, parentNode)=>{
    if (!parentNode) return false;
    for(let i = $pos.depth + 1; i > 0; i--){
        const node = $pos.node(i);
        if (node && node.eq(parentNode)) break;
        if (i > 1 && $pos.before(i) !== $pos.before(i - 1) + 1) return false;
    }
    return true;
};
const $40db8b6c9f98bf36$export$5762916b8b83bc6d = ($pos, parentNode)=>{
    if (!parentNode) return false;
    for(let i = $pos.depth + 1; i > 0; i--){
        const node = $pos.node(i);
        if (node && node.eq(parentNode)) break;
        if (i > 1 && $pos.after(i) !== $pos.after(i - 1) - 1) return false;
    }
    return true;
};
function $40db8b6c9f98bf36$export$4ca816540352da02(state) {
    const { selection: selection, doc: doc } = state;
    return doc.nodeSize - selection.$to.pos - 2 === selection.$to.depth;
}
function $40db8b6c9f98bf36$export$e9083e8cbe24bec0(state) {
    const { selection: selection } = state;
    return selection.$from.pos === selection.$from.depth;
}
function $40db8b6c9f98bf36$export$6f303ca7dac350ae(state) {
    const { selection: selection } = state;
    const { $to: $to } = selection;
    if (selection instanceof (0, $6BNUN.GapCursorSelection)) return false;
    if (selection instanceof (0, $3lIcL.NodeSelection) && selection.node.isBlock) return true;
    return $40db8b6c9f98bf36$export$8e09b50c60354750($to) === $to.pos + 1;
}
function $40db8b6c9f98bf36$export$8351d833af62ae68(state) {
    const { selection: selection } = state;
    const { $from: $from } = selection;
    if (selection instanceof (0, $6BNUN.GapCursorSelection)) return false;
    if (selection instanceof (0, $3lIcL.NodeSelection) && selection.node.isBlock) return true;
    return $40db8b6c9f98bf36$export$ced77c72038c89cb($from) === $from.pos;
}
function $40db8b6c9f98bf36$export$ced77c72038c89cb(resolvedPos) {
    return resolvedPos.start(resolvedPos.depth);
}
function $40db8b6c9f98bf36$export$8e09b50c60354750(resolvedPos) {
    return resolvedPos.end(resolvedPos.depth) + 1;
}
const $40db8b6c9f98bf36$export$748c2428d313e6d0 = ($anchor, $head)=>{
    const sharedDepth = $anchor.sharedDepth($head.pos) + 1;
    const $from = $anchor.min($head);
    const $to = $anchor.max($head);
    const fromDepth = $from.depth;
    const toDepth = $to.depth;
    let selectionStart;
    let selectionEnd;
    const selectionHasGrandparent = toDepth > 1 && fromDepth > 1;
    const selectionIsAcrossDiffParents = selectionHasGrandparent && !$to.parent.isTextblock && !$to.sameParent($from);
    const selectionIsAcrossTextBlocksWithDiffParents = selectionHasGrandparent && $to.parent.isTextblock && $to.before(toDepth - 1) !== $from.before(fromDepth - 1);
    if (toDepth > fromDepth) {
        selectionStart = $from.before(sharedDepth);
        selectionEnd = $to.after(sharedDepth);
    } else if (toDepth < fromDepth) {
        selectionStart = $from.before(sharedDepth);
        selectionEnd = $to.after(sharedDepth);
    } else if (selectionIsAcrossDiffParents || selectionIsAcrossTextBlocksWithDiffParents) {
        // when selection from/to share same depth with different parents, hoist up the selection to the parent of the highest depth in the selection
        selectionStart = $from.before(sharedDepth);
        selectionEnd = $to.after(sharedDepth);
    } else if (!$from.node().inlineContent) // when selection might be a Node selection, return what was passed in
    return {
        $anchor: $anchor,
        $head: $head
    };
    else {
        selectionStart = fromDepth ? $from.before() : $from.pos;
        selectionEnd = toDepth ? $to.after() : $to.pos;
    }
    const $expandedFrom = $anchor.doc.resolve(selectionStart);
    const $expandedTo = $anchor.doc.resolve(selectionEnd);
    return {
        $anchor: $anchor === $from ? $expandedFrom : $expandedTo,
        $head: $head === $to ? $expandedTo : $expandedFrom
    };
};

});



parcelRegister("hbQpB", function(module, exports) {
$parcel$export(module.exports, "defaultWordWrapState", () => $7ab4b3274405a015$export$dea78458f6234074);
$parcel$export(module.exports, "codeBlockWrappedStates", () => $7ab4b3274405a015$export$15e74cb2b99d4f44);
$parcel$export(module.exports, "isCodeBlockWordWrapEnabled", () => $7ab4b3274405a015$export$ca74aa614fc297de);
$parcel$export(module.exports, "getCodeBlockFoldState", () => $7ab4b3274405a015$export$dd8d371c28bc93ab);
$parcel$export(module.exports, "setCodeBlockFoldState", () => $7ab4b3274405a015$export$84bbe896418e05aa);
$parcel$export(module.exports, "transferCodeBlockWrappedValue", () => $7ab4b3274405a015$export$8de8069131d61656);
$parcel$export(module.exports, "updateCodeBlockWrappedStateNodeKeys", () => $7ab4b3274405a015$export$de41d58f29620282);

var $cbSL1 = parcelRequire("cbSL1");
const $7ab4b3274405a015$export$dea78458f6234074 = false;
const $7ab4b3274405a015$export$15e74cb2b99d4f44 = new WeakMap();
const $7ab4b3274405a015$var$codeBlockFoldStates = new WeakMap();
const $7ab4b3274405a015$export$ca74aa614fc297de = (codeBlockNode)=>{
    const currentNodeWordWrapState = $7ab4b3274405a015$export$15e74cb2b99d4f44.get(codeBlockNode);
    return currentNodeWordWrapState !== undefined ? currentNodeWordWrapState : $7ab4b3274405a015$export$dea78458f6234074;
};
const $7ab4b3274405a015$export$dd8d371c28bc93ab = (codeBlockNode)=>{
    const currentNodeFoldState = $7ab4b3274405a015$var$codeBlockFoldStates.get(codeBlockNode);
    return currentNodeFoldState || [];
};
const $7ab4b3274405a015$export$84bbe896418e05aa = (codeBlockNode, foldRanges)=>{
    $7ab4b3274405a015$var$codeBlockFoldStates.set(codeBlockNode, foldRanges);
};
const $7ab4b3274405a015$export$8de8069131d61656 = (oldCodeBlockNode, newCodeBlockNode)=>{
    if ((0, $cbSL1.expValEquals)('platform_editor_code_block_fold_gutter', 'isEnabled', true)) $7ab4b3274405a015$var$transferCodeBlockFoldValue(oldCodeBlockNode, newCodeBlockNode);
    // Don't overwrite the value for the new node if it already exists.
    // This can happen when a drag&drop is swapping nodes.
    if ($7ab4b3274405a015$export$15e74cb2b99d4f44.has(newCodeBlockNode)) return;
    const previousValue = $7ab4b3274405a015$export$ca74aa614fc297de(oldCodeBlockNode);
    $7ab4b3274405a015$export$15e74cb2b99d4f44.set(newCodeBlockNode, previousValue);
    $7ab4b3274405a015$export$15e74cb2b99d4f44.delete(oldCodeBlockNode);
};
/**
 * Swap the old node key with the new node key in the fold states WeakMap.
 */ const $7ab4b3274405a015$var$transferCodeBlockFoldValue = (oldCodeBlockNode, newCodeBlockNode)=>{
    // Don't overwrite the value for the new node if it already exists.
    // This can happen when a drag&drop is swapping nodes.
    if ($7ab4b3274405a015$var$codeBlockFoldStates.has(newCodeBlockNode)) return;
    const previousValue = $7ab4b3274405a015$export$dd8d371c28bc93ab(oldCodeBlockNode);
    $7ab4b3274405a015$var$codeBlockFoldStates.set(newCodeBlockNode, previousValue);
    $7ab4b3274405a015$var$codeBlockFoldStates.delete(oldCodeBlockNode);
};
const $7ab4b3274405a015$export$de41d58f29620282 = (newCodeBlockNodes, oldState)=>{
    newCodeBlockNodes.forEach((newCodeBlockNode)=>{
        if ((0, $cbSL1.expValEquals)('platform_editor_code_block_fold_gutter', 'isEnabled', true)) $7ab4b3274405a015$var$updateCodeBlockFoldStateNodeKeys(newCodeBlockNode, oldState);
        // Don't overwrite the value for the new node if it already exists.
        // This can happen when a drag&drop is swapping nodes.
        if ($7ab4b3274405a015$export$15e74cb2b99d4f44.has(newCodeBlockNode.node)) return;
        // Do not go out of range on the oldState doc. Happens on initial load.
        if (oldState.doc.content.size <= newCodeBlockNode.pos) return;
        const oldCodeBlockNode = oldState.doc.nodeAt(newCodeBlockNode.pos);
        if (!oldCodeBlockNode || oldCodeBlockNode.type !== oldState.schema.nodes.codeBlock) return;
        const previousValue = $7ab4b3274405a015$export$ca74aa614fc297de(oldCodeBlockNode);
        $7ab4b3274405a015$export$15e74cb2b99d4f44.set(newCodeBlockNode.node, previousValue);
    });
};
/**
 * As the code block node is used as the fold state key, there is instances where the node will be destroyed & recreated and is no longer a valid key.
 * In these instances, we must get the value from that old node and set it to the value of the new node.
 * This function takes all the given nodes, finds their old nodes from the old state and updates these old node keys.
 */ const $7ab4b3274405a015$var$updateCodeBlockFoldStateNodeKeys = (newCodeBlockNode, oldState)=>{
    // Don't overwrite the value for the new node if it already exists.
    // This can happen when a drag&drop is swapping nodes.
    if ($7ab4b3274405a015$var$codeBlockFoldStates.has(newCodeBlockNode.node)) return;
    // Do not go out of range on the oldState doc. Happens on initial load.
    if (oldState.doc.content.size <= newCodeBlockNode.pos) return;
    const oldCodeBlockNode = oldState.doc.nodeAt(newCodeBlockNode.pos);
    if (!oldCodeBlockNode || oldCodeBlockNode.type !== oldState.schema.nodes.codeBlock) return;
    const previousValue = $7ab4b3274405a015$export$dd8d371c28bc93ab(oldCodeBlockNode);
    $7ab4b3274405a015$var$codeBlockFoldStates.set(newCodeBlockNode.node, previousValue);
};

});

parcelRegister("j6ZdO", function(module, exports) {
$parcel$export(module.exports, "normaliseNestedLayout", () => $384898e2fc47703e$export$9a3d0d2a50538e52);
$parcel$export(module.exports, "safeInsert", () => $384898e2fc47703e$export$5fe92db78385e37c);
$parcel$export(module.exports, "shouldSplitSelectedNodeOnNodeInsertion", () => $384898e2fc47703e$export$b80431b156693a98);
$parcel$export(module.exports, "insertSelectedItem", () => $384898e2fc47703e$export$e3c00faab58641c5);
$parcel$export(module.exports, "contentAllowedInCodeBlock", () => $384898e2fc47703e$export$b6980e4b8ea578a5);
$parcel$export(module.exports, "fragmentContainsNodeType", () => $384898e2fc47703e$export$2b1594c8921b5b2e);

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $lzEKq = parcelRequire("lzEKq");

var $BmspC = parcelRequire("BmspC");

var $6BNUN = parcelRequire("6BNUN");
parcelRequire("3ADzg");
var $5Z3Rm = parcelRequire("5Z3Rm");
var $fCXIH = parcelRequire("fCXIH");
var $384898e2fc47703e$export$cbdce50c60b34c89 = /*#__PURE__*/ function(LookDirection) {
    LookDirection["Before"] = "before";
    LookDirection["After"] = "after";
    return LookDirection;
}({});
const $384898e2fc47703e$export$9a3d0d2a50538e52 = ({ selection: selection, doc: doc }, node)=>{
    if (selection.$from.depth > 1) {
        if (node.attrs.layout && node.attrs.layout !== 'default') return node.type.createChecked({
            ...node.attrs,
            layout: 'default'
        }, node.content, node.marks);
        // If its a breakout layout, we can remove the mark
        // Since default isn't a valid breakout mode.
        const breakoutMark = doc.type.schema.marks.breakout;
        if (breakoutMark && breakoutMark.isInSet(node.marks)) {
            const newMarks = breakoutMark.removeFromSet(node.marks);
            return node.type.createChecked(node.attrs, node.content, newMarks);
        }
    }
    return node;
};
const $384898e2fc47703e$var$isLastChild = ($pos, doc)=>doc.resolve($pos.after()).node().lastChild === $pos.node();
const $384898e2fc47703e$var$isFirstChild = ($pos, doc)=>doc.resolve($pos.before()).node().firstChild === $pos.node();
const $384898e2fc47703e$var$nodeIsInsideAList = (tr)=>{
    const { nodes: nodes } = tr.doc.type.schema;
    return (0, $BmspC.hasParentNodeOfType)([
        nodes.orderedList,
        nodes.bulletList
    ])(tr.selection);
};
const $384898e2fc47703e$var$selectionIsInsideAPanel = (tr)=>{
    const { nodes: nodes } = tr.doc.type.schema;
    return (0, $BmspC.hasParentNodeOfType)(nodes.panel)(tr.selection);
};
const $384898e2fc47703e$var$selectionIsInNestedList = (tr)=>{
    const { nodes: nodes } = tr.doc.type.schema;
    const parentListNode = (0, $BmspC.findParentNodeOfType)([
        nodes.orderedList,
        nodes.bulletList
    ])(tr.selection);
    if (!parentListNode) return false;
    return (0, $fCXIH.isListItemNode)(tr.doc.resolve(parentListNode.pos).parent);
};
const $384898e2fc47703e$var$insertBeforeOrAfter = (tr, lookDirection, $parentPos, $proposedPosition, content)=>{
    /**
	 * This block caters for the first item in a parent with the cursor being at the very start
	 * or the last item with the cursor being at the very end
	 *
	 * e.g.
	 * ul
	 *  li {<>}Scenario one
	 *  li
	 *  li Scenario two{<>}
	 */ if ($384898e2fc47703e$var$isFirstChild($proposedPosition, tr.doc) && lookDirection === "before" || $384898e2fc47703e$var$isLastChild($proposedPosition, tr.doc) && lookDirection === "after") return tr.insert($parentPos[lookDirection](), content);
    return tr.insert($proposedPosition[lookDirection](), content);
};
// Ignored via go/ees007
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// FIXME: A more sustainable and configurable way to choose when to split
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $384898e2fc47703e$var$shouldSplit = (nodeType, schemaNodes)=>{
    return [
        schemaNodes.bulletList,
        schemaNodes.orderedList,
        schemaNodes.panel
    ].includes(nodeType);
};
const $384898e2fc47703e$export$5fe92db78385e37c = (content, position)=>(tr)=>{
        const { nodes: nodes } = tr.doc.type.schema;
        const whitelist = [
            nodes.rule,
            nodes.mediaSingle
        ];
        if (content instanceof (0, $3xw6l.Fragment) || !whitelist.includes(content.type)) return null;
        // Check for selection
        if (!tr.selection.empty || (0, $BmspC.isNodeSelection)(tr.selection)) // NOT IMPLEMENTED
        return null;
        const { $from: $from } = tr.selection;
        const $insertPos = position ? tr.doc.resolve(position) : (0, $BmspC.isNodeSelection)(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
        let lookDirection;
        const insertPosEnd = $insertPos.end();
        const insertPosStart = $insertPos.start();
        // When parent node is an empty paragraph,
        // check the empty paragraph is the first or last node of its parent.
        if ((0, $5Z3Rm.isEmptyParagraph)($insertPos.parent)) {
            if ($384898e2fc47703e$var$isLastChild($insertPos, tr.doc)) lookDirection = "after";
            else if ($384898e2fc47703e$var$isFirstChild($insertPos, tr.doc)) lookDirection = "before";
        } else {
            if ($insertPos.pos === insertPosEnd) lookDirection = "after";
            else if ($insertPos.pos === insertPosStart) lookDirection = "before";
        }
        const grandParentNodeType = tr.selection.$from.node(-1)?.type;
        const parentNodeType = tr.selection.$from.parent.type;
        // if there is no direction, and cannot split for this particular node
        const noDirectionAndShouldNotSplit = !lookDirection && !$384898e2fc47703e$export$b80431b156693a98({
            parentNodeType: parentNodeType,
            grandParentNodeType: grandParentNodeType,
            content: content
        });
        const ruleNodeInANestedListNode = content.type === nodes.rule && $384898e2fc47703e$var$selectionIsInNestedList(tr);
        const nonRuleNodeInListNode = !(content.type === nodes.rule) && $384898e2fc47703e$var$nodeIsInsideAList(tr);
        if (ruleNodeInANestedListNode || noDirectionAndShouldNotSplit && nonRuleNodeInListNode || noDirectionAndShouldNotSplit && !$384898e2fc47703e$var$nodeIsInsideAList(tr)) // node to be inserted is an invalid child of selection so insert below selected node
        return (0, $BmspC.safeInsert)(content, tr.selection.from)(tr);
        // if node is a rule and that is a flat list splitting and not at the end of a list
        const { from: from, to: to } = tr.selection;
        const ruleTypeInAList = content.type === nodes.rule && $384898e2fc47703e$var$nodeIsInsideAList(tr);
        if (ruleTypeInAList && !($insertPos.pos === insertPosEnd)) return tr.replaceRange(from, to, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(nodes.rule.createChecked()), 0, 0));
        if (!lookDirection) // fallback to consumer for now
        return null;
        // Replace empty paragraph
        if ((0, $5Z3Rm.isEmptyParagraph)($insertPos.parent) && (0, $BmspC.canInsert)(tr.doc.resolve($insertPos[lookDirection]()), content)) return $384898e2fc47703e$var$finaliseInsert(tr.replaceWith($insertPos.before(), $insertPos.after(), content), -1);
        let $proposedPosition = $insertPos;
        while($proposedPosition.depth > 0){
            const $parentPos = tr.doc.resolve($proposedPosition[lookDirection]());
            const parentNode = $parentPos.node();
            // Insert at position (before or after target pos)
            if ((0, $BmspC.canInsert)($proposedPosition, content)) return $384898e2fc47703e$var$finaliseInsert(tr.insert($proposedPosition.pos, content), content.nodeSize);
            // If we can't insert, and we think we should split, we fallback to consumer for now
            if ($384898e2fc47703e$var$shouldSplit(parentNode.type, tr.doc.type.schema.nodes)) {
                const nextTr = $384898e2fc47703e$var$finaliseInsert($384898e2fc47703e$var$insertBeforeOrAfter(tr, lookDirection, $parentPos, $proposedPosition, content), content.nodeSize);
                // Move selection to the closest text node, otherwise it defaults to the whatever the lookDirection is set to above
                if ([
                    nodes.orderedList,
                    nodes.bulletList
                ].includes(parentNode.type) && nextTr) return nextTr.setSelection((0, $3lIcL.TextSelection).between(nextTr.selection.$from, nextTr.selection.$from));
                else return nextTr;
            }
            // Can not insert into current parent, step up one parent
            $proposedPosition = $parentPos;
        }
        return $384898e2fc47703e$var$finaliseInsert(tr.insert($proposedPosition.pos, content), content.nodeSize);
    };
const $384898e2fc47703e$var$finaliseInsert = (tr, nodeLength)=>{
    const lastStep = tr.steps[tr.steps.length - 1];
    if (!(lastStep instanceof (0, $lzEKq.ReplaceStep) || lastStep instanceof (0, $lzEKq.ReplaceAroundStep))) return null;
    // Place gap cursor after the newly inserted node
    const gapCursorPos = lastStep.to + lastStep.slice.openStart + nodeLength;
    return tr.setSelection(new (0, $6BNUN.GapCursorSelection)(tr.doc.resolve(gapCursorPos), (0, $6BNUN.Side).RIGHT)).scrollIntoView();
};
const $384898e2fc47703e$export$e3c00faab58641c5 = (maybeNode, opts = {})=>(state, tr, start)=>{
        if (!maybeNode) return tr;
        const isInputFragment = maybeNode instanceof (0, $3xw6l.Fragment);
        let node;
        try {
            node = maybeNode instanceof (0, $3xw6l.Node) || isInputFragment ? maybeNode : typeof maybeNode === 'string' ? state.schema.text(maybeNode) : (0, $3xw6l.Node).fromJSON(state.schema, maybeNode);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
            return tr;
        }
        if (node instanceof (0, $3xw6l.Node) && node.isText) tr = tr.replaceWith(start, start, node);
        else if (node instanceof (0, $3xw6l.Node) && node.isBlock) {
            /**
			 *
			 * Rule has unique insertion behaviour
			 * so using this safeInsert function in order to handle specific cases in flat list vs nested list
			 * instead of a generic pmSafeInsert (i.e appending at the end)
			 *
			 */ const selectionInsideAPanel = $384898e2fc47703e$var$selectionIsInsideAPanel(tr);
            if (node.type.name === 'rule' && !selectionInsideAPanel && // ED-17438 If the selection is not an empty paragraph we want to use pmSafeInsert
            // This fixes a bug where if a rule was inserted using safeInsert and the selection
            // was an empty paragraph it would not be inserted
            !(0, $5Z3Rm.isEmptyParagraph)(tr.selection.$from.parent)) tr = $384898e2fc47703e$export$5fe92db78385e37c(node, tr.selection.from)(tr) ?? tr;
            else tr = (0, $BmspC.safeInsert)($384898e2fc47703e$export$9a3d0d2a50538e52(state, node), undefined, true)(tr);
        /**
			 *
			 * Replacing a type ahead query mark with an inline node.
			 *
			 */ } else if (node instanceof (0, $3xw6l.Node) && node.isInline || isInputFragment) {
            const fragment = isInputFragment ? node : (0, $3xw6l.Fragment).fromArray([
                node,
                state.schema.text(' ')
            ]);
            tr = tr.replaceWith(start, start, fragment);
            if (opts.selectInlineNode) // Select inserted node
            tr = tr.setSelection((0, $3lIcL.NodeSelection).create(tr.doc, start));
            else // Placing cursor after node + space.
            tr = tr.setSelection((0, $3lIcL.Selection).near(tr.doc.resolve(start + fragment.size)));
        }
        return tr;
    };
const $384898e2fc47703e$export$b80431b156693a98 = ({ parentNodeType: parentNodeType, grandParentNodeType: grandParentNodeType, content: content })=>{
    if (parentNodeType.name === 'doc' || parentNodeType.name === 'paragraph' && grandParentNodeType.validContent((0, $3xw6l.Fragment).from(content))) return true;
    return false;
};
function $384898e2fc47703e$export$b6980e4b8ea578a5(state) {
    const { $from: $from, $to: $to } = state.selection;
    let isAllowedChild = true;
    state.doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
        const withinSelection = $from.pos <= pos && pos + node.nodeSize <= $to.pos;
        if (!withinSelection) return;
        if (!isAllowedChild) return false;
        return isAllowedChild = node.type === state.schema.nodes.listItem || node.type === state.schema.nodes.bulletList || node.type === state.schema.nodes.orderedList || node.type === state.schema.nodes.paragraph || node.isInline || node.type === state.schema.nodes.panel || node.isText;
    });
    return isAllowedChild;
}
function $384898e2fc47703e$export$2b1594c8921b5b2e(fragment, nodeType) {
    let doesContainNodeType = false;
    fragment.descendants((node)=>{
        if (node.type === nodeType) {
            doesContainNodeType = true;
            // Stop looking
            return false;
        }
        return true;
    });
    return doesContainNodeType;
}

});

parcelRegister("k2X9Z", function(module, exports) {
$parcel$export(module.exports, "transformSliceToJoinAdjacentCodeBlocks", () => $f1a235c7a15c8b24$export$5a682e48ed34e262);
$parcel$export(module.exports, "transformSingleLineCodeBlockToCodeMark", () => $f1a235c7a15c8b24$export$d1dc8019f50dded8);
$parcel$export(module.exports, "findCodeBlock", () => $f1a235c7a15c8b24$export$8435d1ef36841a34);

var $3xw6l = parcelRequire("3xw6l");

var $BmspC = parcelRequire("BmspC");

var $gbisc = parcelRequire("gbisc");
function $f1a235c7a15c8b24$var$joinCodeBlocks(left, right) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const textContext = `${left.textContent}\n${right.textContent}`;
    return left.type.create(left.attrs, left.type.schema.text(textContext));
}
function $f1a235c7a15c8b24$var$mergeAdjacentCodeBlocks(fragment) {
    const children = [];
    fragment.forEach((maybeCodeBlock)=>{
        if (maybeCodeBlock.type === maybeCodeBlock.type.schema.nodes.codeBlock) {
            const peekAtPrevious = children[children.length - 1];
            if (peekAtPrevious && peekAtPrevious.type === maybeCodeBlock.type) // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return children.push($f1a235c7a15c8b24$var$joinCodeBlocks(children.pop(), maybeCodeBlock));
        }
        return children.push(maybeCodeBlock);
    });
    return (0, $3xw6l.Fragment).from(children);
}
function $f1a235c7a15c8b24$export$5a682e48ed34e262(slice) {
    slice = (0, $gbisc.mapSlice)(slice, (node)=>{
        return node.isBlock && !node.isTextblock ? node.copy($f1a235c7a15c8b24$var$mergeAdjacentCodeBlocks(node.content)) : node;
    });
    // mapSlice won't be able to merge adjacent top-level code-blocks
    return new (0, $3xw6l.Slice)($f1a235c7a15c8b24$var$mergeAdjacentCodeBlocks(slice.content), slice.openStart, slice.openEnd);
}
const $f1a235c7a15c8b24$export$d1dc8019f50dded8 = (slice, schema)=>{
    if (slice.content.childCount === 1 && (slice.openStart || slice.openEnd)) {
        const maybeCodeBlock = slice.content.firstChild;
        if (maybeCodeBlock && maybeCodeBlock.type === schema.nodes.codeBlock) {
            if (maybeCodeBlock.textContent && maybeCodeBlock.textContent.indexOf('\n') === -1) return new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(schema.text(maybeCodeBlock.textContent, [
                schema.marks.code.create()
            ])), 0, 0);
        }
    }
    return slice;
};
const $f1a235c7a15c8b24$export$8435d1ef36841a34 = (state, selection)=>{
    const { codeBlock: codeBlock } = state.schema.nodes;
    return (0, $BmspC.findSelectedNodeOfType)(codeBlock)(selection || state.selection) || (0, $BmspC.findParentNodeOfType)(codeBlock)(selection || state.selection);
};

});

parcelRegister("qwti8", function(module, exports) {
$parcel$export(module.exports, "ACTIONS", () => $44d77072e21c4f43$export$92a1a3b7554e9387);
const $44d77072e21c4f43$export$92a1a3b7554e9387 = {
    SET_COPIED_TO_CLIPBOARD: 'SET_COPIED_TO_CLIPBOARD',
    SET_SHOULD_IGNORE_FOLLOWING_MUTATIONS: 'SET_SHOULD_IGNORE_FOLLOWING_MUTATIONS',
    SET_IS_WRAPPED: 'SET_IS_WRAPPED'
};

});

parcelRegister("bXs63", function(module, exports) {
$parcel$export(module.exports, "copySelectionPluginKey", () => $2d8de4750354639c$export$97324d26e7dfa2c5);
$parcel$export(module.exports, "codeBlockCopySelectionPlugin", () => $2d8de4750354639c$export$bf11b3ffc9027f6b);
$parcel$export(module.exports, "provideVisualFeedbackForCopyButton", () => $2d8de4750354639c$export$73dae478fefb96e);
$parcel$export(module.exports, "removeVisualFeedbackForCopyButton", () => $2d8de4750354639c$export$1ec425a919cc0ea);

var $e5Nsc = parcelRequire("e5Nsc");

var $i8KtF = parcelRequire("i8KtF");

var $3lIcL = parcelRequire("3lIcL");

var $b7EWj = parcelRequire("b7EWj");
const $2d8de4750354639c$export$97324d26e7dfa2c5 = new (0, $3lIcL.PluginKey)('codeBlockCopySelectionPlugin');
function $2d8de4750354639c$var$getSelectionDecorationStartAndEnd({ state: state, transaction: transaction }) {
    const codeBlockNode = (0, $e5Nsc.getSelectedNodeOrNodeParentByNodeType)({
        nodeType: state.schema.nodes.codeBlock,
        selection: transaction.selection
    });
    if (!codeBlockNode) return {
        decorationStartAndEnd: undefined,
        codeBlockNode: undefined
    };
    const decorationStartAndEnd = [
        codeBlockNode.start,
        codeBlockNode.start + codeBlockNode.node.nodeSize
    ];
    return {
        decorationStartAndEnd: decorationStartAndEnd,
        codeBlockNode: codeBlockNode.node
    };
}
function $2d8de4750354639c$export$bf11b3ffc9027f6b() {
    return new (0, $i8KtF.SafePlugin)({
        key: $2d8de4750354639c$export$97324d26e7dfa2c5,
        state: {
            init () {
                return {
                    decorationStartAndEnd: undefined
                };
            },
            apply (transaction, currentCodeBlockCopySelectionPluginState, _oldState, newState) {
                switch(transaction.getMeta($2d8de4750354639c$export$97324d26e7dfa2c5)){
                    case 'show-selection':
                        return $2d8de4750354639c$var$getSelectionDecorationStartAndEnd({
                            state: newState,
                            transaction: transaction
                        });
                    case 'remove-selection':
                        return {
                            decorationStartAndEnd: undefined
                        };
                    default:
                        // The contents of the code block can change while the selection is being shown
                        // (either from collab edits -- or from the user continuing to type while hovering
                        // the mouse over the copy button).
                        // This ensures the selection is updated in these cases.
                        if (currentCodeBlockCopySelectionPluginState.decorationStartAndEnd !== undefined) return $2d8de4750354639c$var$getSelectionDecorationStartAndEnd({
                            state: newState,
                            transaction: transaction
                        });
                        return currentCodeBlockCopySelectionPluginState;
                }
            }
        },
        props: {
            decorations (state) {
                if ($2d8de4750354639c$export$97324d26e7dfa2c5.getState(state).decorationStartAndEnd) {
                    const [start, end] = $2d8de4750354639c$export$97324d26e7dfa2c5.getState(state).decorationStartAndEnd;
                    return (0, $b7EWj.DecorationSet).create(state.doc, [
                        (0, $b7EWj.Decoration).inline(start, end, {
                            class: 'ProseMirror-fake-text-selection'
                        })
                    ]);
                }
                return (0, $b7EWj.DecorationSet).empty;
            }
        }
    });
}
function $2d8de4750354639c$export$73dae478fefb96e(state, dispatch) {
    const tr = state.tr;
    tr.setMeta($2d8de4750354639c$export$97324d26e7dfa2c5, 'show-selection');
    // note: dispatch should always be defined when called from the
    // floating toolbar. Howver the Command type which the floating toolbar
    // uses suggests it's optional.
    // Using the type here to protect against future refactors of the
    // floating toolbar
    if (dispatch) dispatch(tr);
    return true;
}
function $2d8de4750354639c$export$1ec425a919cc0ea(state, dispatch) {
    const tr = state.tr;
    tr.setMeta($2d8de4750354639c$export$97324d26e7dfa2c5, 'remove-selection');
    // note: dispatch should always be defined when called from the
    // floating toolbar. Howver the Command type which the floating toolbar
    // uses suggests it's optional.
    // Using the type here to protect against future refactors of the
    // floating toolbar
    if (dispatch) dispatch(tr);
    return true;
}

});
parcelRegister("e5Nsc", function(module, exports) {
$parcel$export(module.exports, "getSelectedNodeOrNodeParentByNodeType", () => $4be08fc0f886407d$export$64477bc469482fd0);
$parcel$export(module.exports, "toDOM", () => $4be08fc0f886407d$export$289411c5a7970646);
$parcel$export(module.exports, "copyDomNode", () => $4be08fc0f886407d$export$ccb445b3e5426309);

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");

var $cbSL1 = parcelRequire("cbSL1");

var $58hN2 = parcelRequire("58hN2");

var $7EdFW = parcelRequire("7EdFW");
function $4be08fc0f886407d$export$64477bc469482fd0({ nodeType: nodeType, selection: selection }) {
    let node = (0, $BmspC.findSelectedNodeOfType)(nodeType)(selection);
    if (!node) node = (0, $BmspC.findParentNodeOfType)(nodeType)(selection);
    return node;
}
const $4be08fc0f886407d$export$289411c5a7970646 = (node, schema)=>{
    return (0, $3xw6l.DOMSerializer).fromSchema(schema).serializeNode(node);
};
const $4be08fc0f886407d$export$ccb445b3e5426309 = (domNode, nodeType, selection)=>{
    if (domNode) {
        const div = document.createElement('div');
        div.appendChild(domNode);
        const schema = selection.$from.doc.type.schema;
        const browser = (0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $7EdFW.getBrowserInfo)() : (0, $7EdFW.browser);
        // if copying inline content
        if (nodeType.inlineContent) // The "1 1" refers to the start and end depth of the slice
        // since we're copying the text inside a paragraph, it will always be 1 1
        // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        div.firstChild.setAttribute('data-pm-slice', '1 1 []');
        else // The "0 0" refers to the start and end depth of the slice
        // since we're copying the block node only, it will always be 0 0
        // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        div.firstChild.setAttribute('data-pm-slice', '0 0 []');
        // ED-17083 safari seems have bugs for extension copy because exntension do not have a child text(innerText) and it will not recognized as html in clipboard, this could be merge into one if this extension fixed children issue or safari fix the copy bug
        // MEX-2528 safari has a bug related to the mediaSingle node with border or link. The image tag within the clipboard is not recognized as HTML when using the ClipboardItem API. To address this, we have to switch to ClipboardPolyfill
        if (browser.safari && selection instanceof (0, $3lIcL.NodeSelection) && (selection.node.type === schema.nodes.extension || selection.node.type === schema.nodes.mediaSingle)) (0, $58hN2.copyHTMLToClipboardPolyfill)(div);
        else (0, $58hN2.copyHTMLToClipboard)(div);
    }
};

});


parcelRegister("cPDlc", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $d555078d7f6f2bff$export$18d4026d1ea86bb1);

var $3lIcL = parcelRequire("3lIcL");
const $d555078d7f6f2bff$export$18d4026d1ea86bb1 = new (0, $3lIcL.PluginKey)('codeBlockPlugin');

});

parcelRegister("b1dKB", function(module, exports) {
$parcel$export(module.exports, "transformToCodeBlockAction", () => $274fc6b184a5183c$export$92adcb8baa0906a6);
$parcel$export(module.exports, "isConvertableToCodeBlock", () => $274fc6b184a5183c$export$4b5d5858845bfcf6);

var $6BNUN = parcelRequire("6BNUN");

var $gbisc = parcelRequire("gbisc");
var $dZ5Iy = parcelRequire("dZ5Iy");

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");
function $274fc6b184a5183c$export$92adcb8baa0906a6(state, start, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
attrs) {
    const startOfCodeBlockText = state.selection.$from;
    const endPosition = state.selection.empty && !(state.selection instanceof (0, $6BNUN.GapCursorSelection)) ? startOfCodeBlockText.end() : state.selection.$to.pos;
    const startLinePosition = startOfCodeBlockText.start();
    //when cmd+A is used to select the content. start position should be 0.
    const parentStartPosition = startOfCodeBlockText.depth === 0 ? 0 : startOfCodeBlockText.before();
    const contentSlice = state.doc.slice(startOfCodeBlockText.pos, endPosition);
    const codeBlockSlice = (0, $gbisc.mapSlice)(contentSlice, (node, parent, index)=>{
        if (node.type === state.schema.nodes.hardBreak) return state.schema.text('\n');
        if (node.isText) return node.mark([]);
        if (node.isInline) {
            // Convert dates
            if (node.attrs.timestamp) return state.schema.text((0, $dZ5Iy.timestampToString)(node.attrs.timestamp, null));
            // Convert links
            if (node.attrs.url) return state.schema.text(node.attrs.url);
            return node.attrs.text ? state.schema.text(node.attrs.text) : null;
        }
        // if the current node is the last child of the Slice exit early to prevent
        // adding additional line breaks
        if (contentSlice.content.childCount - 1 === index) return node.content;
        //useful to decide whether to append line breaks when the content has list items.
        const isParentLastChild = parent && contentSlice.content.childCount - 1 === index;
        // add line breaks at the end of each paragraph to mimic layout of selected content
        // do not add line breaks when the 'paragraph' parent is last child.
        if (node.content.childCount && node.type === state.schema.nodes.paragraph && !isParentLastChild) return node.content.append((0, $3xw6l.Fragment).from(state.schema.text('\n\n')));
        return node.content.childCount ? node.content : null;
    });
    const tr = state.tr;
    // Replace current block node
    const startMapped = startLinePosition === start ? parentStartPosition : start;
    const codeBlock = state.schema.nodes.codeBlock;
    const codeBlockNode = codeBlock.createChecked(attrs, codeBlockSlice.content);
    tr.replaceWith(startMapped, Math.min(endPosition, tr.doc.content.size), codeBlockNode);
    // Reposition cursor when inserting into layouts or table headers
    const mapped = tr.doc.resolve(tr.mapping.map(startMapped) + 1);
    const selection = (0, $3lIcL.TextSelection).findFrom(mapped, state.selection instanceof (0, $6BNUN.GapCursorSelection) ? -1 : 1, true);
    if (selection) return tr.setSelection(selection);
    return tr.setSelection((0, $3lIcL.TextSelection).create(tr.doc, Math.min(start + startOfCodeBlockText.node().nodeSize - 1, tr.doc.content.size)));
}
function $274fc6b184a5183c$export$4b5d5858845bfcf6(state) {
    // Before a document is loaded, there is no selection.
    if (!state.selection) return false;
    const { $from: $from } = state.selection;
    const node = $from.parent;
    if (!node.isTextblock || node.type === state.schema.nodes.codeBlock) return false;
    const parentDepth = $from.depth - 1;
    const parentNode = $from.node(parentDepth);
    const index = $from.index(parentDepth);
    return parentNode.canReplaceWith(index, index + 1, state.schema.nodes.codeBlock);
}

});


parcelRegister("4J8hb", function(module, exports) {
$parcel$export(module.exports, "codeBlockAutoFullStopTransformPlugin", () => $7fb25f2908998efc$export$67e82b3aa944d041);

var $7EdFW = parcelRequire("7EdFW");

var $i8KtF = parcelRequire("i8KtF");

var $k2X9Z = parcelRequire("k2X9Z");

var $3lIcL = parcelRequire("3lIcL");

var $eGOwo = parcelRequire("eGOwo");

var $cbSL1 = parcelRequire("cbSL1");
const $7fb25f2908998efc$export$6114c8149cd0d98e = new (0, $3lIcL.PluginKey)('codeBlockAutoFullStopTransformPluginKey');
function $7fb25f2908998efc$export$67e82b3aa944d041() {
    return new (0, $i8KtF.SafePlugin)({
        key: $7fb25f2908998efc$export$6114c8149cd0d98e,
        appendTransaction (_transactions, oldState, newState) {
            if (!(0, $eGOwo.fg)('code_block_auto_insertion_bug_fix')) return undefined;
            // We need to compare the old and new state to isloate auto insertion of fullstop on mac
            const { tr: trNew } = newState;
            const { tr: trOld } = oldState;
            const { from: fromOld } = trOld.selection;
            const { from: fromNew, to: toNew } = trNew.selection;
            const isCodeBlock = !!(0, $k2X9Z.findCodeBlock)(oldState, trOld.selection) && !!(0, $k2X9Z.findCodeBlock)(newState, trNew.selection);
            const browser = (0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $7EdFW.getBrowserInfo)() : (0, $7EdFW.browser);
            /**
			 * Mac will auto insert a fullstop when the user double taps the space key after some content.
			 * Line number decorators are assumed content so on new lines the fullstop is inserted.
			 *
			 * - When a fulltop is auto inserted the new states selection is the same, the old state selection is one position less
			 * - The text returned for the old state returns as a space with the selection from - 1
			 * - The text returned for the new state returns as a fullstop with the selection from - 2 to from -1
			 *
			 * This is enough conditional logic to isoloate the auto insertion of the fullstop on mac
			 *
			 * There are some solutions to this problem in codemirror which can be read further here
			 * https://discuss.codemirror.net/t/dot-being-added-when-pressing-space-repeatedly/3899
			 */ // both selections must be of code block early exit
            if (browser.mac && fromNew === toNew && fromNew === fromOld + 1 && isCodeBlock) // detect when '.' is inserted when the previous state was a space ' '
            try {
                const textBetweenBefore = trOld.doc.textBetween(fromOld - 1, fromOld); // ' '
                const textBetweenAfter = trNew.doc.textBetween(fromNew - 2, fromNew - 1); // '.'
                if (textBetweenBefore === ' ' && textBetweenAfter === '.') {
                    trNew.delete(fromNew - 2, fromNew); // remove the fullstop
                    trNew.insertText('  ', fromNew - 2); // insert double space
                    return trNew;
                }
            } catch (error) {
                // if for some reason textBetween fails, just return the new transaction as is by defaut.
                return undefined;
            }
            return undefined;
        }
    });
}

});

parcelRegister("4A4SW", function(module, exports) {
$parcel$export(module.exports, "default", () => $889a4076a568c002$export$2e2bcd8739ae039);

var $i8KtF = parcelRequire("i8KtF");

var $HOLTj = parcelRequire("HOLTj");

var $x7sgX = parcelRequire("x7sgX");

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");

var $dlvAu = parcelRequire("dlvAu");

var $ib34m = parcelRequire("ib34m");

var $cf9uI = parcelRequire("cf9uI");

var $8BGsb = parcelRequire("8BGsb");

var $eBW2c = parcelRequire("eBW2c");

var $eD0rA = parcelRequire("eD0rA");
const $889a4076a568c002$var$ideUX = (pluginInjectionApi)=>{
    const editorAnalyticsAPI = pluginInjectionApi?.analytics?.actions;
    return new (0, $i8KtF.SafePlugin)({
        props: {
            handleTextInput (view, from, to, text) {
                const { state: state, dispatch: dispatch } = view;
                const compositionPluginState = pluginInjectionApi?.composition?.sharedState.currentState();
                if ((0, $cf9uI.isCursorInsideCodeBlock)(state) && !compositionPluginState?.isComposing) {
                    const beforeText = (0, $cf9uI.getStartOfCurrentLine)(state).text;
                    const afterText = (0, $cf9uI.getEndOfCurrentLine)(state).text;
                    // If text is a closing bracket/quote and we've already inserted it, move the selection after
                    if ((0, $8BGsb.isCursorBeforeClosingCharacter)(afterText) && (0, $8BGsb.isClosingCharacter)(text) && afterText.startsWith(text)) {
                        dispatch((0, $BmspC.setTextSelection)(to + text.length)(state.tr));
                        return true;
                    }
                    // Automatically add right-hand side bracket when user types the left bracket
                    if ((0, $dlvAu.shouldAutoCloseBracket)(beforeText, afterText)) {
                        const { left: left, right: right } = (0, $dlvAu.getAutoClosingBracketInfo)(beforeText + text, afterText);
                        if (left && right) {
                            const bracketPair = state.schema.text(text + right);
                            const tr = state.tr.replaceWith(from, to, bracketPair);
                            dispatch((0, $BmspC.setTextSelection)(from + text.length)(tr));
                            return true;
                        }
                    }
                    // Automatically add closing quote when user types a starting quote
                    if ((0, $eBW2c.shouldAutoCloseQuote)(beforeText, afterText)) {
                        const { left: leftQuote, right: rightQuote } = (0, $eBW2c.getAutoClosingQuoteInfo)(beforeText + text, afterText);
                        if (leftQuote && rightQuote) {
                            const quotePair = state.schema.text(text + rightQuote);
                            const tr = state.tr.replaceWith(from, to, quotePair);
                            dispatch((0, $BmspC.setTextSelection)(from + text.length)(tr));
                            return true;
                        }
                    }
                }
                return false;
            },
            handleKeyDown: (0, $x7sgX.keydownHandler)({
                Backspace: (state, dispatch)=>{
                    if ((0, $cf9uI.isCursorInsideCodeBlock)(state)) {
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const $cursor = (0, $eD0rA.getCursor)(state.selection);
                        const beforeText = (0, $cf9uI.getStartOfCurrentLine)(state).text;
                        const afterText = (0, $cf9uI.getEndOfCurrentLine)(state).text;
                        const { left: leftBracket, right: rightBracket, hasTrailingMatchingBracket: hasTrailingMatchingBracket } = (0, $dlvAu.getAutoClosingBracketInfo)(beforeText, afterText);
                        if (leftBracket && rightBracket && hasTrailingMatchingBracket && dispatch) {
                            dispatch(state.tr.delete($cursor.pos - leftBracket.length, $cursor.pos + rightBracket.length));
                            return true;
                        }
                        const { left: leftQuote, right: rightQuote, hasTrailingMatchingQuote: hasTrailingMatchingQuote } = (0, $eBW2c.getAutoClosingQuoteInfo)(beforeText, afterText);
                        if (leftQuote && rightQuote && hasTrailingMatchingQuote && dispatch) {
                            dispatch(state.tr.delete($cursor.pos - leftQuote.length, $cursor.pos + rightQuote.length));
                            return true;
                        }
                        const { indentToken: { size: size, token: token }, indentText: indentText } = (0, $cf9uI.getLineInfo)(beforeText);
                        if (beforeText === indentText) {
                            if (indentText.endsWith(token.repeat(size)) && dispatch) {
                                dispatch(state.tr.delete($cursor.pos - (size - indentText.length % size || size), $cursor.pos));
                                return true;
                            }
                        }
                    }
                    return false;
                },
                Enter: (0, $HOLTj.filterCommand)((0, $cf9uI.isSelectionEntirelyInsideCodeBlock), (0, $ib34m.insertNewlineWithIndent)),
                'Mod-]': (0, $HOLTj.filterCommand)((0, $cf9uI.isSelectionEntirelyInsideCodeBlock), (0, $ib34m.indent)(editorAnalyticsAPI)),
                'Mod-[': (0, $HOLTj.filterCommand)((0, $cf9uI.isSelectionEntirelyInsideCodeBlock), (0, $ib34m.outdent)(editorAnalyticsAPI)),
                Tab: (0, $HOLTj.filterCommand)((0, $cf9uI.isSelectionEntirelyInsideCodeBlock), (state, dispatch)=>{
                    if (!dispatch) return false;
                    if ((0, $cf9uI.isCursorInsideCodeBlock)(state)) return (0, $ib34m.insertIndent)(state, dispatch);
                    return (0, $ib34m.indent)(editorAnalyticsAPI)(state, dispatch);
                }),
                'Shift-Tab': (0, $HOLTj.filterCommand)((0, $cf9uI.isSelectionEntirelyInsideCodeBlock), (0, $ib34m.outdent)(editorAnalyticsAPI)),
                'Mod-a': (state, dispatch)=>{
                    if ((0, $cf9uI.isSelectionEntirelyInsideCodeBlock)(state)) {
                        const { $from: $from, $to: $to } = state.selection;
                        const isFullCodeBlockSelection = $from.parentOffset === 0 && $to.parentOffset === $to.parent.nodeSize - 2;
                        if (!isFullCodeBlockSelection && dispatch) {
                            dispatch(state.tr.setSelection((0, $3lIcL.TextSelection).create(state.doc, $from.start(), $to.end())));
                            return true;
                        }
                    }
                    return false;
                }
            })
        }
    });
};
var $889a4076a568c002$export$2e2bcd8739ae039 = $889a4076a568c002$var$ideUX;

});
parcelRegister("dlvAu", function(module, exports) {
$parcel$export(module.exports, "BRACKET_MAP", () => $6194dbe90ca65266$export$94d363c96bda1dd9);
$parcel$export(module.exports, "shouldAutoCloseBracket", () => $6194dbe90ca65266$export$29c04e6b1b08e223);
$parcel$export(module.exports, "getAutoClosingBracketInfo", () => $6194dbe90ca65266$export$a40becce5a71614c);
const $6194dbe90ca65266$export$94d363c96bda1dd9 = {
    '{': '}',
    '[': ']',
    '(': ')'
};
const $6194dbe90ca65266$export$29c04e6b1b08e223 = (before, after)=>{
    // when directly before a closing bracket
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    if (/^[}\])]/.test(after)) return true;
    // exclusion: when directly before a non-whitespace character
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    if (/^[^\s]/.test(after)) return false;
    return true;
};
const $6194dbe90ca65266$export$a40becce5a71614c = (before, after)=>{
    const left = Object.keys($6194dbe90ca65266$export$94d363c96bda1dd9).find((item)=>before.endsWith(item));
    const right = left ? $6194dbe90ca65266$export$94d363c96bda1dd9[left] : undefined;
    const hasTrailingMatchingBracket = right ? after.startsWith(right) : false;
    return {
        left: left,
        right: right,
        hasTrailingMatchingBracket: hasTrailingMatchingBracket
    };
};

});

parcelRegister("ib34m", function(module, exports) {
$parcel$export(module.exports, "indent", () => $9780e45216d8810a$export$79ebfa808dffa5c6);
$parcel$export(module.exports, "outdent", () => $9780e45216d8810a$export$25755c0352544598);
$parcel$export(module.exports, "insertIndent", () => $9780e45216d8810a$export$ba3935b326bda6a5);
$parcel$export(module.exports, "insertNewlineWithIndent", () => $9780e45216d8810a$export$1b9cc0cafa2b529c);

var $bMFKb = parcelRequire("bMFKb");
var $1o1iK = parcelRequire("1o1iK");

var $3lIcL = parcelRequire("3lIcL");

var $cf9uI = parcelRequire("cf9uI");
/**
 * Return the current indentation level
 * @param indentText - Text in the code block that represent an indentation
 * @param indentSize - Size of the indentation token in a string
 */ function $9780e45216d8810a$var$getIndentLevel(indentText, indentSize) {
    if (indentSize === 0 || indentText.length === 0) return 0;
    return indentText.length / indentSize;
}
const $9780e45216d8810a$export$79ebfa808dffa5c6 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { text: text, start: start } = (0, $cf9uI.getLinesFromSelection)(state);
        const { tr: tr, selection: selection } = state;
        (0, $cf9uI.forEachLine)(text, (line, offset)=>{
            const { indentText: indentText, indentToken: indentToken } = (0, $cf9uI.getLineInfo)(line);
            const indentLevel = $9780e45216d8810a$var$getIndentLevel(indentText, indentToken.size);
            const indentToAdd = indentToken.token.repeat(indentToken.size - indentText.length % indentToken.size || indentToken.size);
            tr.insertText(indentToAdd, tr.mapping.map(start + offset, -1));
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $bMFKb.ACTION).FORMATTED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_INDENT,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                attributes: {
                    inputMethod: (0, $bMFKb.INPUT_METHOD).KEYBOARD,
                    previousIndentationLevel: indentLevel,
                    newIndentLevel: indentLevel + 1,
                    direction: (0, $1o1iK.INDENT_DIRECTION).INDENT,
                    indentType: (0, $1o1iK.INDENT_TYPE).CODE_BLOCK
                }
            })(tr);
            if (!selection.empty) tr.setSelection((0, $3lIcL.TextSelection).create(tr.doc, tr.mapping.map(selection.from, -1), tr.selection.to));
        });
        if (dispatch) dispatch(tr);
        return true;
    };
const $9780e45216d8810a$export$25755c0352544598 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { text: text, start: start } = (0, $cf9uI.getLinesFromSelection)(state);
        const { tr: tr } = state;
        (0, $cf9uI.forEachLine)(text, (line, offset)=>{
            const { indentText: indentText, indentToken: indentToken } = (0, $cf9uI.getLineInfo)(line);
            if (indentText) {
                const indentLevel = $9780e45216d8810a$var$getIndentLevel(indentText, indentToken.size);
                const unindentLength = indentText.length % indentToken.size || indentToken.size;
                tr.delete(tr.mapping.map(start + offset), tr.mapping.map(start + offset + unindentLength));
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $bMFKb.ACTION).FORMATTED,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
                    actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_INDENT,
                    eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                    attributes: {
                        inputMethod: (0, $bMFKb.INPUT_METHOD).KEYBOARD,
                        previousIndentationLevel: indentLevel,
                        newIndentLevel: indentLevel - 1,
                        direction: (0, $1o1iK.INDENT_DIRECTION).OUTDENT,
                        indentType: (0, $1o1iK.INDENT_TYPE).CODE_BLOCK
                    }
                })(tr);
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
function $9780e45216d8810a$export$ba3935b326bda6a5(state, dispatch) {
    const { text: textAtStartOfLine } = (0, $cf9uI.getStartOfCurrentLine)(state);
    const { indentToken: indentToken } = (0, $cf9uI.getLineInfo)(textAtStartOfLine);
    const indentToAdd = indentToken.token.repeat(indentToken.size - textAtStartOfLine.length % indentToken.size || indentToken.size);
    dispatch(state.tr.insertText(indentToAdd));
    return true;
}
function $9780e45216d8810a$export$1b9cc0cafa2b529c(state, dispatch) {
    const { text: textAtStartOfLine } = (0, $cf9uI.getStartOfCurrentLine)(state);
    const { indentText: indentText } = (0, $cf9uI.getLineInfo)(textAtStartOfLine);
    if (indentText && dispatch) {
        dispatch(state.tr.insertText('\n' + indentText));
        return true;
    }
    return false;
}

});
parcelRegister("1o1iK", function(module, exports) {
$parcel$export(module.exports, "INDENT_DIRECTION", () => $90b9aeb1e46a3e06$export$c8090e81b8640d69);
$parcel$export(module.exports, "INDENT_TYPE", () => $90b9aeb1e46a3e06$export$303836d45647271d);
var $90b9aeb1e46a3e06$export$c8090e81b8640d69 = /*#__PURE__*/ function(INDENT_DIRECTION) {
    INDENT_DIRECTION["INDENT"] = "indent";
    INDENT_DIRECTION["OUTDENT"] = "outdent";
    return INDENT_DIRECTION;
}({});
var $90b9aeb1e46a3e06$export$303836d45647271d = /*#__PURE__*/ function(INDENT_TYPE) {
    INDENT_TYPE["PARAGRAPH"] = "paragraph";
    INDENT_TYPE["LIST"] = "list";
    INDENT_TYPE["HEADING"] = "heading";
    INDENT_TYPE["CODE_BLOCK"] = "codeBlock";
    INDENT_TYPE["TASK_LIST"] = "taskList";
    return INDENT_TYPE;
}({});

});

parcelRegister("cf9uI", function(module, exports) {
$parcel$export(module.exports, "isSelectionEntirelyInsideCodeBlock", () => $f0f7505c9ad7bf22$export$b54b55a89e362241);
$parcel$export(module.exports, "isCursorInsideCodeBlock", () => $f0f7505c9ad7bf22$export$cecd33f3def3e129);
$parcel$export(module.exports, "getStartOfCurrentLine", () => $f0f7505c9ad7bf22$export$13a3ef35664ba7de);
$parcel$export(module.exports, "getEndOfCurrentLine", () => $f0f7505c9ad7bf22$export$8291149050336443);
$parcel$export(module.exports, "getLinesFromSelection", () => $f0f7505c9ad7bf22$export$64ccdebd7526708f);
$parcel$export(module.exports, "forEachLine", () => $f0f7505c9ad7bf22$export$7f5b487b51da88d0);
$parcel$export(module.exports, "getLineInfo", () => $f0f7505c9ad7bf22$export$7af82191547c5ff7);

var $eD0rA = parcelRequire("eD0rA");
const $f0f7505c9ad7bf22$export$b54b55a89e362241 = (state)=>state.selection.$from.sameParent(state.selection.$to) && state.selection.$from.parent.type === state.schema.nodes.codeBlock;
const $f0f7505c9ad7bf22$export$cecd33f3def3e129 = (state)=>!!(0, $eD0rA.getCursor)(state.selection) && $f0f7505c9ad7bf22$export$b54b55a89e362241(state);
const $f0f7505c9ad7bf22$export$13a3ef35664ba7de = (state)=>{
    const { $from: $from } = state.selection;
    if ($from.nodeBefore && $from.nodeBefore.isText) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const prevNewLineIndex = $from.nodeBefore.text.lastIndexOf('\n');
        return {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            text: $from.nodeBefore.text.substring(prevNewLineIndex + 1),
            pos: $from.start() + prevNewLineIndex + 1
        };
    }
    return {
        text: '',
        pos: $from.pos
    };
};
const $f0f7505c9ad7bf22$export$8291149050336443 = (state)=>{
    const { $to: $to } = state.selection;
    if ($to.nodeAfter && $to.nodeAfter.isText) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const nextNewLineIndex = $to.nodeAfter.text.indexOf('\n');
        return {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            text: $to.nodeAfter.text.substring(0, nextNewLineIndex >= 0 ? nextNewLineIndex : undefined),
            pos: nextNewLineIndex >= 0 ? $to.pos + nextNewLineIndex : $to.end()
        };
    }
    return {
        text: '',
        pos: $to.pos
    };
};
function $f0f7505c9ad7bf22$export$64ccdebd7526708f(state) {
    const { pos: start } = $f0f7505c9ad7bf22$export$13a3ef35664ba7de(state);
    const { pos: end } = $f0f7505c9ad7bf22$export$8291149050336443(state);
    const text = state.doc.textBetween(start, end);
    return {
        text: text,
        start: start,
        end: end
    };
}
const $f0f7505c9ad7bf22$export$7f5b487b51da88d0 = (text, callback)=>{
    let offset = 0;
    text.split('\n').forEach((line)=>{
        callback(line, offset);
        offset += line.length + 1;
    });
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f0f7505c9ad7bf22$var$SPACE = {
    token: ' ',
    size: 2,
    regex: /[^ ]/
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f0f7505c9ad7bf22$var$TAB = {
    token: '\t',
    size: 1,
    regex: /[^\t]/
};
const $f0f7505c9ad7bf22$export$7af82191547c5ff7 = (line)=>{
    const indentToken = line.startsWith('\t') ? $f0f7505c9ad7bf22$var$TAB : $f0f7505c9ad7bf22$var$SPACE;
    const indentLength = line.search(indentToken.regex);
    const indentText = line.substring(0, indentLength >= 0 ? indentLength : line.length);
    return {
        indentToken: indentToken,
        indentText: indentText
    };
};

});
parcelRegister("eD0rA", function(module, exports) {
$parcel$export(module.exports, "getCursor", () => $1223b511b78ca76a$export$da3f040fb23d21f);
$parcel$export(module.exports, "getAllCodeBlockNodesInDoc", () => $1223b511b78ca76a$export$f43d710a87ced169);
$parcel$export(module.exports, "getAllChangedCodeBlocksInTransaction", () => $1223b511b78ca76a$export$3fa3c149b89781e7);
function $1223b511b78ca76a$export$da3f040fb23d21f(selection) {
    return selection.$cursor || undefined;
}
function $1223b511b78ca76a$export$f43d710a87ced169(state) {
    const codeBlockNodes = [];
    state.doc.descendants((node, pos)=>{
        if (node.type === state.schema.nodes.codeBlock) {
            codeBlockNodes.push({
                node: node,
                pos: pos
            });
            return false;
        }
        return true;
    });
    return codeBlockNodes;
}
function $1223b511b78ca76a$export$3fa3c149b89781e7(tr) {
    const changedCodeBlocks = [];
    const nodePositions = new Set();
    tr.steps.forEach((step)=>{
        const mapResult = step.getMap();
        mapResult.forEach((oldStart, oldEnd, newStart, newEnd)=>{
            tr.doc.nodesBetween(newStart, Math.min(newEnd, tr.doc.content.size), (node, pos)=>{
                if (node.type.name === 'codeBlock') {
                    if (!nodePositions.has(pos)) {
                        nodePositions.add(pos);
                        changedCodeBlocks.push({
                            node: node,
                            pos: pos
                        });
                    }
                }
            });
        });
    });
    if (changedCodeBlocks.length < 1) return null;
    return changedCodeBlocks;
}

});



parcelRegister("8BGsb", function(module, exports) {
$parcel$export(module.exports, "isCursorBeforeClosingCharacter", () => $4c515515cc67f536$export$1d6d73d16dcadbdd);
$parcel$export(module.exports, "isClosingCharacter", () => $4c515515cc67f536$export$ea0560eb552fb0a7);

var $dlvAu = parcelRequire("dlvAu");

var $eBW2c = parcelRequire("eBW2c");
const $4c515515cc67f536$var$PAIRED_CHARACTER_MAP = {
    ...(0, $dlvAu.BRACKET_MAP),
    ...(0, $eBW2c.QUOTE_MAP)
};
const $4c515515cc67f536$export$1d6d73d16dcadbdd = (after)=>{
    return Object.keys($4c515515cc67f536$var$PAIRED_CHARACTER_MAP).some((leftCharacter)=>after.startsWith($4c515515cc67f536$var$PAIRED_CHARACTER_MAP[leftCharacter]));
};
const $4c515515cc67f536$export$ea0560eb552fb0a7 = (text)=>{
    return Object.keys($4c515515cc67f536$var$PAIRED_CHARACTER_MAP).some((leftCharacter)=>text === $4c515515cc67f536$var$PAIRED_CHARACTER_MAP[leftCharacter]);
};

});
parcelRegister("eBW2c", function(module, exports) {
$parcel$export(module.exports, "QUOTE_MAP", () => $b3b5581cde717d52$export$bb64b01afeb72d0a);
$parcel$export(module.exports, "shouldAutoCloseQuote", () => $b3b5581cde717d52$export$42f0a0996a9a464d);
$parcel$export(module.exports, "getAutoClosingQuoteInfo", () => $b3b5581cde717d52$export$6af564d7e42f37e8);
const $b3b5581cde717d52$export$bb64b01afeb72d0a = {
    "'": "'",
    '"': '"',
    '`': '`'
};
const $b3b5581cde717d52$export$42f0a0996a9a464d = (before, after)=>{
    // when directly before a closing bracket
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    if (/^[}\])]/.test(after)) return true;
    // exclusion: when directly before a non-whitespace character
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    if (/^[^\s]/.test(after)) return false;
    // exclusion: when directly after a letter or quote
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    if (/[A-Za-z0-9]$/.test(before) || /[\'\"\`]$/.test(before)) return false;
    return true;
};
const $b3b5581cde717d52$export$6af564d7e42f37e8 = (before, after)=>{
    const left = Object.keys($b3b5581cde717d52$export$bb64b01afeb72d0a).find((item)=>before.endsWith(item));
    const right = left ? $b3b5581cde717d52$export$bb64b01afeb72d0a[left] : undefined;
    const hasTrailingMatchingQuote = right ? after.startsWith(right) : false;
    return {
        left: left,
        right: right,
        hasTrailingMatchingQuote: hasTrailingMatchingQuote
    };
};

});



parcelRegister("9qZT4", function(module, exports) {
$parcel$export(module.exports, "createCodeBlockInputRule", () => $e648317e6b3c8ac4$export$bdcd7d8080bcac7f);

var $bMFKb = parcelRequire("bMFKb");

var $piMVJ = parcelRequire("piMVJ");

var $i8KtF = parcelRequire("i8KtF");

var $leZY6 = parcelRequire("leZY6");

var $BmspC = parcelRequire("BmspC");

var $jCfsG = parcelRequire("jCfsG");
var $82vn7 = parcelRequire("82vn7");

var $b1dKB = parcelRequire("b1dKB");
function $e648317e6b3c8ac4$export$bdcd7d8080bcac7f(schema, editorAnalyticsAPI) {
    const rules = $e648317e6b3c8ac4$var$getCodeBlockRules(editorAnalyticsAPI, schema);
    return new (0, $i8KtF.SafePlugin)((0, $jCfsG.createPlugin)('code-block-input-rule', rules, {
        isBlockNodeRule: true
    }));
}
/**
 * Get all code block input rules
 *
 * @param {Schema} schema
 * @returns {InputRuleWithHandler[]}
 */ function $e648317e6b3c8ac4$var$getCodeBlockRules(editorAnalyticsAPI, schema) {
    const ruleAnalytics = (0, $leZY6.inputRuleWithAnalytics)({
        action: (0, $bMFKb.ACTION).INSERTED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).CODE_BLOCK,
        attributes: {
            inputMethod: (0, $bMFKb.INPUT_METHOD).FORMATTING
        },
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK
    }, editorAnalyticsAPI);
    const validMatchLength = (match)=>match.length > 0 && match[0].length === 3;
    // eslint-disable-next-line require-unicode-regexp
    const threeTildeRule = (0, $leZY6.createRule)(/(?!\s)(`{3,})$/, (state, match, start, end)=>{
        if (!validMatchLength(match)) return null;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const attributes = {};
        if (match[4]) attributes.language = match[4];
        if ((0, $b1dKB.isConvertableToCodeBlock)(state)) return (0, $b1dKB.transformToCodeBlockAction)(state, start, attributes);
        const tr = state.tr;
        tr.delete(start, end);
        const codeBlock = tr.doc.type.schema.nodes.codeBlock.createChecked();
        (0, $BmspC.safeInsert)(codeBlock)(tr);
        return tr;
    });
    const leftNodeReplacementThreeTildeRule = (0, $leZY6.createRule)(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    new RegExp(`((${(0, $82vn7.leafNodeReplacementCharacter)}\`{3,})|^\\s(\`{3,}))(\\S*)$`), (state, match, start, end)=>{
        if (!validMatchLength(match)) return null;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const attributes = {};
        if (match[4]) attributes.language = match[4];
        const inlineStart = Math.max(match.index + state.selection.$from.start(), 1);
        return (0, $piMVJ.insertBlock)(state, schema.nodes.codeBlock, inlineStart, end, attributes);
    });
    return [
        ruleAnalytics(threeTildeRule),
        ruleAnalytics(leftNodeReplacementThreeTildeRule)
    ];
}

});

parcelRegister("eZ8Jb", function(module, exports) {
$parcel$export(module.exports, "default", () => $1aff668b4346f473$export$2e2bcd8739ae039);

var $3ADzg = parcelRequire("3ADzg");

var $x7sgX = parcelRequire("x7sgX");

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");

var $eD0rA = parcelRequire("eD0rA");
const $1aff668b4346f473$var$deleteCurrentItem = ($from)=>(tr)=>{
        return tr.delete($from.before($from.depth), $from.after($from.depth));
    };
const $1aff668b4346f473$var$setTextSelection = (pos)=>(tr)=>{
        const newSelection = (0, $3lIcL.Selection).findFrom(tr.doc.resolve(pos), -1, true);
        if (newSelection) tr.setSelection(newSelection);
        return tr;
    };
function $1aff668b4346f473$export$e832373cff8dec22(schema) {
    return (0, $x7sgX.keymap)({
        Backspace: (state, dispatch)=>{
            const $cursor = (0, $eD0rA.getCursor)(state.selection);
            const { codeBlock: codeBlock, listItem: listItem, table: table, layoutColumn: layoutColumn, paragraph: paragraph } = state.schema.nodes;
            if (!$cursor || $cursor.parent.type !== codeBlock || !dispatch) return false;
            if ($cursor.pos === 1 || (0, $BmspC.hasParentNodeOfType)(listItem)(state.selection) && $cursor.parentOffset === 0) {
                const node = (0, $BmspC.findParentNodeOfTypeClosestToPos)($cursor, codeBlock);
                if (!node) return false;
                dispatch(state.tr.setNodeMarkup(node.pos, node.node.type, node.node.attrs, []).setBlockType($cursor.pos, $cursor.pos, paragraph));
                return true;
            }
            if ($cursor.node && (0, $3ADzg.isEmptyNode)(schema)($cursor.node()) && ((0, $BmspC.hasParentNodeOfType)(layoutColumn)(state.selection) || (0, $BmspC.hasParentNodeOfType)(table)(state.selection))) {
                const { tr: tr } = state;
                const insertPos = $cursor.pos;
                $1aff668b4346f473$var$deleteCurrentItem($cursor)(tr);
                $1aff668b4346f473$var$setTextSelection(insertPos)(tr);
                dispatch(tr.scrollIntoView());
                return true;
            }
            // Handle not nested empty code block
            if ((0, $3ADzg.isEmptyNode)(schema)($cursor.node())) {
                dispatch($1aff668b4346f473$var$deleteCurrentItem($cursor)(state?.tr));
                return true;
            }
            return false;
        }
    });
}
var $1aff668b4346f473$export$2e2bcd8739ae039 = $1aff668b4346f473$export$e832373cff8dec22;

});

parcelRegister("fRZQq", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $a8a06aa8757ef417$export$ae829ec7b2625219);

var $7EdFW = parcelRequire("7EdFW");

var $hbQpB = parcelRequire("hbQpB");

var $TgnAJ = parcelRequire("TgnAJ");

var $i8KtF = parcelRequire("i8KtF");

var $7xtnm = parcelRequire("7xtnm");

var $k2X9Z = parcelRequire("k2X9Z");

var $3lIcL = parcelRequire("3lIcL");

var $b7EWj = parcelRequire("b7EWj");

var $cbSL1 = parcelRequire("cbSL1");

var $eUWhc = parcelRequire("eUWhc");

var $kS1ht = parcelRequire("kS1ht");

var $9Q7mz = parcelRequire("9Q7mz");

var $qwti8 = parcelRequire("qwti8");

var $i9cyy = parcelRequire("i9cyy");

var $cPDlc = parcelRequire("cPDlc");

var $eD0rA = parcelRequire("eD0rA");
const $a8a06aa8757ef417$export$ae829ec7b2625219 = ({ useLongPressSelection: useLongPressSelection = false, getIntl: getIntl, allowCompositionInputOverride: allowCompositionInputOverride = false, api: api })=>{
    const handleDOMEvents = {
        click: ()=>{
            // Set hasHadInteraction to true on any click of code blocks, as clicks
            // on code blocks to not propagate to editor-level click handlers
            api?.core?.actions.execute(api?.interaction?.commands.handleInteraction);
        }
    };
    // ME-1599: Composition on mobile was causing the DOM observer to mutate the code block
    // incorrecly and lose content when pressing enter in the middle of a code block line.
    if (allowCompositionInputOverride) handleDOMEvents.beforeinput = (view, event)=>{
        const keyEvent = event;
        const eventInputType = keyEvent.inputType;
        const eventText = keyEvent.data;
        const browser = (0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $7EdFW.getBrowserInfo)() : (0, $7EdFW.browser);
        if (browser.ios && event.composed && // insertParagraph will be the input type when the enter key is pressed.
        eventInputType === 'insertParagraph' && (0, $k2X9Z.findCodeBlock)(view.state, view.state.selection)) {
            event.preventDefault();
            return true;
        } else if (browser.android && event.composed && eventInputType === 'insertCompositionText' && eventText[eventText?.length - 1] === '\n' && (0, $k2X9Z.findCodeBlock)(view.state, view.state.selection)) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const resultingText = event.target.outerText + '\n';
            if (resultingText.endsWith(eventText)) // End of paragraph
            setTimeout(()=>{
                view.someProp('handleKeyDown', (f)=>f(view, new KeyboardEvent('keydown', {
                        bubbles: true,
                        cancelable: true,
                        key: 'Enter',
                        code: 'Enter'
                    })));
            }, 0);
            else // Middle of paragraph, end of line
            (0, $eUWhc.ignoreFollowingMutations)(view.state, view.dispatch);
            return true;
        }
        if (browser.android) (0, $eUWhc.resetShouldIgnoreFollowingMutations)(view.state, view.dispatch);
        return false;
    };
    return new (0, $i8KtF.SafePlugin)({
        state: {
            init (_, state) {
                const node = (0, $k2X9Z.findCodeBlock)(state, state.selection);
                const initialDecorations = // Disabled when using advanced code block advanced since it interfers with styling
                // Long term we will deprecate the code block plugin and move all the related logic to
                // the advanced plugin
                // @ts-expect-error Code block advanced cannot depend on code block
                api?.codeBlockAdvanced !== undefined && (0, $cbSL1.expValEquals)('platform_editor_code_block_fold_gutter', 'isEnabled', true) ? [] : (0, $i9cyy.generateInitialDecorations)(state);
                return {
                    pos: node ? node.pos : null,
                    contentCopied: false,
                    isNodeSelected: false,
                    shouldIgnoreFollowingMutations: false,
                    decorations: (0, $b7EWj.DecorationSet).create(state.doc, initialDecorations)
                };
            },
            apply (tr, pluginState, _oldState, newState) {
                const meta = tr.getMeta((0, $cPDlc.pluginKey));
                if (meta?.type === (0, $qwti8.ACTIONS).SET_IS_WRAPPED) {
                    const node = (0, $k2X9Z.findCodeBlock)(newState, tr.selection);
                    return {
                        ...pluginState,
                        decorations: (0, $i9cyy.updateDecorationSetWithWordWrappedDecorator)(pluginState.decorations, tr, node)
                    };
                }
                if (tr.docChanged) {
                    const node = (0, $k2X9Z.findCodeBlock)(newState, tr.selection);
                    // Updates mapping position of all existing decorations to new positions
                    // specifically used for updating word wrap node decorators (does not cover drag & drop, validateWordWrappedDecorators does).
                    let updatedDecorationSet = pluginState.decorations.map(tr.mapping, tr.doc);
                    const codeBlockNodes = (0, $eD0rA.getAllChangedCodeBlocksInTransaction)(tr);
                    if (codeBlockNodes) {
                        (0, $hbQpB.updateCodeBlockWrappedStateNodeKeys)(codeBlockNodes, _oldState);
                        // Disabled when using advanced code block for performance reasons
                        // @ts-expect-error Code block advanced cannot depend on code block
                        if (api?.codeBlockAdvanced === undefined) updatedDecorationSet = (0, $i9cyy.updateCodeBlockDecorations)(tr, codeBlockNodes, updatedDecorationSet);
                    }
                    const newPluginState = {
                        ...pluginState,
                        pos: node ? node.pos : null,
                        isNodeSelected: tr.selection instanceof (0, $3lIcL.NodeSelection),
                        decorations: updatedDecorationSet
                    };
                    return newPluginState;
                }
                if (tr.selectionSet) {
                    const node = (0, $k2X9Z.findCodeBlock)(newState, tr.selection);
                    const newPluginState = {
                        ...pluginState,
                        pos: node ? node.pos : null,
                        isNodeSelected: tr.selection instanceof (0, $3lIcL.NodeSelection)
                    };
                    return newPluginState;
                }
                if (meta?.type === (0, $qwti8.ACTIONS).SET_COPIED_TO_CLIPBOARD) return {
                    ...pluginState,
                    contentCopied: meta.data
                };
                else if (meta?.type === (0, $qwti8.ACTIONS).SET_SHOULD_IGNORE_FOLLOWING_MUTATIONS) return {
                    ...pluginState,
                    shouldIgnoreFollowingMutations: meta.data
                };
                return pluginState;
            }
        },
        key: (0, $cPDlc.pluginKey),
        props: {
            decorations (state) {
                return (0, $cPDlc.pluginKey).getState(state).decorations || (0, $b7EWj.DecorationSet).empty;
            },
            nodeViews: {
                codeBlock: (node, view, getPos)=>{
                    const { formatMessage: formatMessage } = getIntl();
                    const formattedAriaLabel = formatMessage((0, $TgnAJ.messages).codeblock);
                    return (0, $kS1ht.codeBlockNodeView)(node, view, getPos, formattedAriaLabel, api);
                }
            },
            handleClickOn: (0, $7xtnm.createSelectionClickHandler)([
                'codeBlock'
            ], (target)=>!!(target.classList.contains((0, $9Q7mz.codeBlockClassNames).lineNumberWidget) || target.classList.contains((0, $9Q7mz.codeBlockClassNames).gutter)), {
                useLongPressSelection: useLongPressSelection
            }),
            handleDOMEvents: handleDOMEvents
        }
    });
};

});
parcelRegister("kS1ht", function(module, exports) {
$parcel$export(module.exports, "codeBlockNodeView", () => $8ed1dad9c96cdac6$export$9ea0022afafc61b7);

var $7EdFW = parcelRequire("7EdFW");

var $hbQpB = parcelRequire("hbQpB");

var $3xw6l = parcelRequire("3xw6l");

var $eGOwo = parcelRequire("eGOwo");

var $cbSL1 = parcelRequire("cbSL1");

var $eUWhc = parcelRequire("eUWhc");

var $c5kme = parcelRequire("c5kme");

var $9Q7mz = parcelRequire("9Q7mz");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8ed1dad9c96cdac6$var$MATCH_NEWLINES = new RegExp('\n', 'g');
const $8ed1dad9c96cdac6$var$toDOM = (node, contentEditable, formattedAriaLabel)=>[
        'div',
        {
            class: (0, $9Q7mz.codeBlockClassNames).container
        },
        [
            'div',
            {
                class: (0, $9Q7mz.codeBlockClassNames).start,
                contenteditable: 'false'
            }
        ],
        [
            'div',
            {
                class: (0, $9Q7mz.codeBlockClassNames).contentWrapper
            },
            [
                'div',
                {
                    class: (0, $9Q7mz.codeBlockClassNames).gutter,
                    contenteditable: 'false'
                }
            ],
            [
                'div',
                {
                    class: (0, $9Q7mz.codeBlockClassNames).content
                },
                [
                    'code',
                    {
                        'data-language': node.attrs.language || '',
                        spellcheck: 'false',
                        contenteditable: contentEditable ? 'true' : 'false',
                        'data-testid': 'code-block--code',
                        'aria-label': formattedAriaLabel,
                        ...(0, $eGOwo.fg)('platform_editor_adf_with_localid') && {
                            'data-local-id': node.attrs.localId
                        }
                    },
                    0
                ]
            ]
        ],
        [
            'div',
            {
                class: (0, $9Q7mz.codeBlockClassNames).end,
                contenteditable: 'false'
            }
        ]
    ];
class $8ed1dad9c96cdac6$export$84ecc4258da6ad44 {
    constructor(node, view, getPos, formattedAriaLabel, api, cleanupEditorDisabledListener){
        this.cleanupEditorDisabledListener = cleanupEditorDisabledListener;
        this.formattedAriaLabel = '';
        this.maintainDynamicGutterSize = ()=>{
            let totalLineCount = 1;
            this.node.forEach((node)=>{
                const text = node.text;
                if (text) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                totalLineCount += (node.text.match($8ed1dad9c96cdac6$var$MATCH_NEWLINES) || []).length;
            });
            const maxDigits = totalLineCount.toString().length;
            this.dom.style.setProperty('--lineNumberGutterWidth', `${maxDigits}ch`);
        };
        const { dom: dom, contentDOM: contentDOM } = (0, $3xw6l.DOMSerializer).renderSpec(document, $8ed1dad9c96cdac6$var$toDOM(node, !api?.editorDisabled?.sharedState.currentState()?.editorDisabled, formattedAriaLabel));
        this.getPos = getPos;
        this.view = view;
        this.node = node;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.dom = dom;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.contentDOM = contentDOM;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.lineNumberGutter = this.dom.querySelector(`.${(0, $9Q7mz.codeBlockClassNames).gutter}`);
        this.api = api;
        this.maintainDynamicGutterSize();
        // Ensure the code block node has a wrapped state.
        // Wrapped state may already exist from breakout's recreating the node.
        if (!(0, $hbQpB.codeBlockWrappedStates).has(node)) (0, $hbQpB.codeBlockWrappedStates).set(node, (0, $hbQpB.defaultWordWrapState));
        this.handleEditorDisabledChanged();
    }
    handleEditorDisabledChanged() {
        if (this.api?.editorDisabled) this.cleanupEditorDisabledListener = this.api.editorDisabled.sharedState.onChange((sharedState)=>{
            if (this.contentDOM) this.contentDOM.setAttribute('contenteditable', sharedState.nextSharedState.editorDisabled ? 'false' : 'true');
        });
    }
    updateDOMAndSelection(savedInnerHTML, newCursorPosition) {
        if (this.dom?.childNodes && this.dom.childNodes.length > 1) {
            const contentWrapper = this.dom.childNodes[1];
            const contentView = contentWrapper?.childNodes[1];
            if (contentView?.childNodes?.length > 0) {
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const codeElement = contentView.firstChild;
                codeElement.innerHTML = savedInnerHTML;
                // We need to set cursor for the DOM update
                const textElement = Array.from(codeElement.childNodes).find((child)=>child.nodeName === '#text');
                const sel = window.getSelection();
                const range = document.createRange();
                range.setStart(textElement, newCursorPosition);
                range.collapse(true);
                sel?.removeAllRanges();
                sel?.addRange(range);
            }
        }
    }
    coalesceDOMElements() {
        if (this.dom?.childNodes && this.dom.childNodes.length > 1) {
            const contentWrapper = this.dom.childNodes[1];
            const contentView = contentWrapper?.childNodes[1];
            if (contentView?.childNodes && contentView.childNodes.length > 1) {
                let savedInnerHTML = '';
                while(contentView.childNodes.length > 1){
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const lastChild = contentView.lastChild;
                    savedInnerHTML = lastChild.innerHTML + savedInnerHTML;
                    contentView.removeChild(lastChild);
                }
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const firstChild = contentView.firstChild;
                savedInnerHTML = firstChild.innerHTML + '\n' + savedInnerHTML;
                const newCursorPosition = firstChild.innerHTML.length + 1;
                setTimeout(this.updateDOMAndSelection.bind(this, savedInnerHTML, newCursorPosition), 20);
            }
        }
    }
    update(node) {
        if (node.type !== this.node.type) return false;
        if (node !== this.node) {
            if (node.attrs.language !== this.node.attrs.language) this.contentDOM.setAttribute('data-language', node.attrs.language || '');
            this.node = node;
            this.maintainDynamicGutterSize();
            const browser = (0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $7EdFW.getBrowserInfo)() : (0, $7EdFW.browser);
            if (browser.android) {
                this.coalesceDOMElements();
                (0, $eUWhc.resetShouldIgnoreFollowingMutations)(this.view.state, this.view.dispatch);
            }
        }
        return true;
    }
    ignoreMutation(record) {
        const pluginState = (0, $c5kme.getPluginState)(this.view.state);
        if (pluginState?.shouldIgnoreFollowingMutations) return true;
        // Ensure updating the line-number gutter doesn't trigger reparsing the codeblock
        return record.target === this.lineNumberGutter || record.target.parentNode === this.lineNumberGutter;
    }
    destroy() {
        if (this.cleanupEditorDisabledListener) this.cleanupEditorDisabledListener();
        this.cleanupEditorDisabledListener = undefined;
    }
}
const $8ed1dad9c96cdac6$export$9ea0022afafc61b7 = (node, view, getPos, formattedAriaLabel, api)=>new $8ed1dad9c96cdac6$export$84ecc4258da6ad44(node, view, getPos, formattedAriaLabel, api);

});
parcelRegister("c5kme", function(module, exports) {
$parcel$export(module.exports, "getPluginState", () => $c8fe5d125409441c$export$f05434c51e3762e);

var $cPDlc = parcelRequire("cPDlc");
const $c8fe5d125409441c$export$f05434c51e3762e = (state)=>(0, $cPDlc.pluginKey).getState(state);

});

parcelRegister("9Q7mz", function(module, exports) {
$parcel$export(module.exports, "codeBlockClassNames", () => $ec6faa476854ac1f$export$4ffea7f3ae91d083);

var $gBkUB = parcelRequire("gBkUB");
const $ec6faa476854ac1f$export$4ffea7f3ae91d083 = {
    container: (0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER,
    start: (0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_START,
    end: (0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_END,
    contentWrapper: (0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER,
    contentWrapped: (0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPED,
    gutter: (0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER,
    content: (0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT,
    lineNumberWidget: (0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET
};

});


parcelRegister("i9cyy", function(module, exports) {
$parcel$export(module.exports, "generateInitialDecorations", () => $e747df2a6695b282$export$e39f4b987bac6a89);
$parcel$export(module.exports, "updateCodeBlockDecorations", () => $e747df2a6695b282$export$af0ed0ae85f93cba);
$parcel$export(module.exports, "updateDecorationSetWithWordWrappedDecorator", () => $e747df2a6695b282$export$655c2c2993b251d2);

var $hbQpB = parcelRequire("hbQpB");

var $b7EWj = parcelRequire("b7EWj");

var $9Q7mz = parcelRequire("9Q7mz");

var $eD0rA = parcelRequire("eD0rA");
const $e747df2a6695b282$export$feb1744c3f7a1a44 = 'decorationWidgetType';
const $e747df2a6695b282$export$7d62a9abd4358350 = 'decorationNodeType';
const $e747df2a6695b282$export$e39f4b987bac6a89 = (state)=>{
    const codeBlockNodes = (0, $eD0rA.getAllCodeBlockNodesInDoc)(state);
    return codeBlockNodes.flatMap((node)=>$e747df2a6695b282$export$9955827033f49bf6($e747df2a6695b282$export$e2f66570e25f0fa7(node)));
};
const $e747df2a6695b282$export$af0ed0ae85f93cba = (tr, codeBlockNodes, decorationSet)=>{
    let updatedDecorationSet = decorationSet;
    // Update line number decorators for changed code block nodes if new line added or line removed.
    updatedDecorationSet = $e747df2a6695b282$export$b7832269a6c1c9aa(tr, codeBlockNodes, updatedDecorationSet);
    // Check to make sure the word wrap decorators are still valid.
    updatedDecorationSet = $e747df2a6695b282$export$7384f52a5ea552e1(tr, codeBlockNodes, updatedDecorationSet);
    return updatedDecorationSet;
};
const $e747df2a6695b282$export$b7832269a6c1c9aa = (tr, codeBlockNodes, decorationSet)=>{
    let updatedDecorationSet = decorationSet;
    const lineNumberDecorators = [];
    codeBlockNodes.forEach((node)=>{
        const existingWidgetsOnNode = updatedDecorationSet.find(node.pos, node.pos + node.node.nodeSize, (spec)=>spec.type === $e747df2a6695b282$export$feb1744c3f7a1a44);
        const newLineAttributes = $e747df2a6695b282$export$e2f66570e25f0fa7(node);
        // There will be no widgets on initialisation. If the number of existing widgets does not equal the amount of lines, regenerate the widgets.
        // There may be a case where the number of existing widgets and the number of lines are the same, that's why we track totalLineCount. This allows
        // us to know how many lines there were when the widget was created. It avoids a break in line numbers, e.g. "1, 2, 3, 5, 6". Happens on line removal.
        if (existingWidgetsOnNode.length === 0 || existingWidgetsOnNode.length !== newLineAttributes.length || existingWidgetsOnNode[0].spec.totalLineCount !== newLineAttributes.length) {
            updatedDecorationSet = updatedDecorationSet.remove(existingWidgetsOnNode);
            lineNumberDecorators.push(...$e747df2a6695b282$export$9955827033f49bf6(newLineAttributes));
        }
    });
    return updatedDecorationSet.add(tr.doc, [
        ...lineNumberDecorators
    ]);
};
const $e747df2a6695b282$export$e2f66570e25f0fa7 = (node)=>{
    const { node: innerNode, pos: pos } = node;
    // Get content node
    const contentNode = innerNode.content;
    // Get node text content
    let lineAttributes = [];
    // Early exit if content size is 0
    if (contentNode.size === 0) return [
        {
            lineStart: pos + 1,
            lineNumber: 1
        }
    ];
    contentNode.forEach((child)=>{
        const nodeTextContent = child.textContent;
        const nodeStartPos = pos;
        let lineStartIndex = nodeStartPos;
        const newLineAttributes = nodeTextContent.split('\n').map((line, index)=>{
            const lineLength = line.length;
            const lineStart = lineStartIndex + 1;
            const lineNumber = index + 1;
            // Include the newline character and increment to keep tabs on line position
            lineStartIndex += lineLength + 1;
            return {
                lineStart: lineStart,
                lineNumber: lineNumber
            };
        });
        lineAttributes = [
            ...lineAttributes,
            ...newLineAttributes
        ];
    });
    return lineAttributes;
};
const $e747df2a6695b282$export$9955827033f49bf6 = (lineAttributes)=>{
    const widgetDecorations = lineAttributes.map((lineAttribute)=>{
        const { lineStart: lineStart, lineNumber: lineNumber } = lineAttribute;
        // Passing a function to create the widget rather than directly passing a widget, as per ProseMirror docs.
        const createLineNumberWidget = ()=>{
            const widget = document.createElement('span');
            widget.textContent = `${lineNumber}`;
            widget.classList.add((0, $9Q7mz.codeBlockClassNames).lineNumberWidget);
            return widget;
        };
        // side -1 is used so the line numbers are the first thing to the left of the lines of code.
        // totalLineCount is used to know whether or not to update the line numbers when a new line is added or removed.
        return (0, $b7EWj.Decoration).widget(lineStart, createLineNumberWidget, {
            type: $e747df2a6695b282$export$feb1744c3f7a1a44,
            side: -1,
            totalLineCount: lineAttributes.length
        });
    });
    return widgetDecorations;
};
const $e747df2a6695b282$export$7384f52a5ea552e1 = (tr, codeBlockNodes, decorationSet)=>{
    let updatedDecorationSet = decorationSet;
    codeBlockNodes.forEach((node)=>{
        const isCodeBlockWrappedInState = (0, $hbQpB.isCodeBlockWordWrapEnabled)(node.node);
        const isCodeBlockWrappedByDecorator = $e747df2a6695b282$export$343dbf55d0e24df2(node.pos, decorationSet).length !== 0;
        if (isCodeBlockWrappedInState !== isCodeBlockWrappedByDecorator) updatedDecorationSet = $e747df2a6695b282$export$655c2c2993b251d2(decorationSet, tr, node);
    });
    return updatedDecorationSet;
};
const $e747df2a6695b282$export$655c2c2993b251d2 = (decorationSet, tr, node)=>{
    if (!node || node.pos === undefined) return decorationSet;
    let updatedDecorationSet = decorationSet;
    const { pos: pos, node: innerNode } = node;
    const isNodeWrapped = (0, $hbQpB.isCodeBlockWordWrapEnabled)(innerNode);
    if (!isNodeWrapped) {
        const currentWrappedBlockDecorationSet = $e747df2a6695b282$export$343dbf55d0e24df2(pos, updatedDecorationSet);
        updatedDecorationSet = updatedDecorationSet.remove(currentWrappedBlockDecorationSet);
        // In code block advanced we don't use the node decoration - however a change in decorations
        // is how we detect updates to the word wrap. If we have no decorations attached we've
        // likely changed the breakout width with the toggle ON - we add an empty decoration to force
        // prosemirror to recognise the change so we can update in our node view. This gets filtered
        // out on the next toggle.
        if (currentWrappedBlockDecorationSet.length === 0 && pos + innerNode.nodeSize <= tr.doc.content.size) {
            const wrappedBlock = (0, $b7EWj.Decoration).node(pos, pos + innerNode.nodeSize, {}, {
                type: $e747df2a6695b282$export$7d62a9abd4358350
            });
            updatedDecorationSet = updatedDecorationSet.add(tr.doc, [
                wrappedBlock
            ]);
        }
    } else {
        const wrappedBlock = (0, $b7EWj.Decoration).node(pos, pos + innerNode.nodeSize, {
            class: (0, $9Q7mz.codeBlockClassNames).contentWrapped
        }, {
            type: $e747df2a6695b282$export$7d62a9abd4358350
        });
        updatedDecorationSet = updatedDecorationSet.add(tr.doc, [
            wrappedBlock
        ]);
    }
    return updatedDecorationSet;
};
const $e747df2a6695b282$export$343dbf55d0e24df2 = (pos, decorationSet)=>{
    const codeBlockNodePosition = pos + 1; // We need to add 1 to the position to get the start of the node.
    const currentWrappedBlockDecorationSet = decorationSet.find(codeBlockNodePosition, codeBlockNodePosition, (spec)=>spec.type === $e747df2a6695b282$export$7d62a9abd4358350);
    return currentWrappedBlockDecorationSet;
};

});


parcelRegister("har6y", function(module, exports) {
$parcel$export(module.exports, "default", () => $365cd01d6bda5720$export$2e2bcd8739ae039);

var $7EdFW = parcelRequire("7EdFW");

var $cbSL1 = parcelRequire("cbSL1");

var $cPDlc = parcelRequire("cPDlc");
// Workaround for a firefox issue where dom selection is off sync
// https://product-fabric.atlassian.net/browse/ED-12442
const $365cd01d6bda5720$export$b3bd6df96c05d596 = ()=>{
    const domSelection = window.getSelection();
    if (domSelection) {
        const domRange = domSelection && domSelection.rangeCount === 1 && domSelection.getRangeAt(0).cloneRange();
        if (domRange) {
            domSelection.removeAllRanges();
            domSelection.addRange(domRange);
        }
    }
};
const $365cd01d6bda5720$var$refreshBrowserSelectionOnChange = (transaction, editorState)=>{
    const browser = (0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $7EdFW.getBrowserInfo)() : (0, $7EdFW.browser);
    if (browser.gecko && transaction.docChanged && // codeblockState.pos should be set if current selection is in a codeblock.
    typeof (0, $cPDlc.pluginKey).getState(editorState)?.pos === 'number') $365cd01d6bda5720$export$b3bd6df96c05d596();
};
var $365cd01d6bda5720$export$2e2bcd8739ae039 = $365cd01d6bda5720$var$refreshBrowserSelectionOnChange;

});

parcelRegister("izqih", function(module, exports) {
$parcel$export(module.exports, "getToolbarConfig", () => $ebe400eaf7994d0a$export$86ce8f8241c20a3);

var $hbQpB = parcelRequire("hbQpB");

var $ehejR = parcelRequire("ehejR");
var $h2yqz = parcelRequire("h2yqz");

var $jx6gl = parcelRequire("jx6gl");

var $BmspC = parcelRequire("BmspC");

var $4MicW = parcelRequire("4MicW");

var $4TA31 = parcelRequire("4TA31");

var $2IYY2 = parcelRequire("2IYY2");

var $gVpwy = parcelRequire("gVpwy");

var $eGOwo = parcelRequire("eGOwo");

var $eUWhc = parcelRequire("eUWhc");

var $b4hab = parcelRequire("b4hab");

var $bXs63 = parcelRequire("bXs63");

var $3qt8L = parcelRequire("3qt8L");

var $cPDlc = parcelRequire("cPDlc");
const $ebe400eaf7994d0a$export$86ce8f8241c20a3 = (allowCopyToClipboard = false, api, overrideLanguageName)=>(state, { formatMessage: formatMessage })=>{
        const isViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
        const { hoverDecoration: hoverDecoration } = api?.decorations?.actions ?? {};
        const editorAnalyticsAPI = api?.analytics?.actions;
        const codeBlockState = (0, $cPDlc.pluginKey).getState(state);
        const pos = codeBlockState?.pos ?? null;
        if (!codeBlockState || pos === null) return;
        const node = state.doc.nodeAt(pos);
        const nodeType = state.schema.nodes.codeBlock;
        if (node?.type !== nodeType) return;
        const isWrapped = (0, $hbQpB.isCodeBlockWordWrapEnabled)(node);
        const language = node?.attrs?.language;
        const languageList = (0, $3qt8L.createLanguageList)(overrideLanguageName ? (0, $3qt8L.DEFAULT_LANGUAGES).map((language)=>({
                ...language,
                name: overrideLanguageName(language.name)
            })) : (0, $3qt8L.DEFAULT_LANGUAGES));
        const options = languageList.map((lang)=>({
                label: lang.name,
                value: (0, $3qt8L.getLanguageIdentifier)(lang),
                alias: lang.alias
            }));
        // If language is not undefined search for it in the value and then search in the aliases
        const defaultValue = language ? options.find((option)=>option.value === language) || options.find((option)=>option.alias.includes(language)) : null;
        const languageSelect = {
            id: 'editor.codeBlock.languageOptions',
            type: 'select',
            selectType: 'list',
            onChange: (option)=>(0, $eUWhc.changeLanguage)(editorAnalyticsAPI)(option.value),
            defaultValue: defaultValue,
            placeholder: formatMessage((0, $ehejR.codeBlockButtonMessages).selectLanguage),
            options: options,
            filterOption: $ebe400eaf7994d0a$export$fffed505cd33273c
        };
        const separator = {
            type: 'separator'
        };
        const areAnyNewToolbarFlagsEnabled = (0, $jx6gl.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
        const copyToClipboardItems = !allowCopyToClipboard ? [] : [
            {
                id: 'editor.codeBlock.copy',
                type: 'button',
                supportsViewMode: true,
                appearance: 'subtle',
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($4TA31))),
                // note: copyContentToClipboardWithAnalytics contains logic that also removes the
                // visual feedback for the copy button
                onClick: (0, $eUWhc.copyContentToClipboardWithAnalytics)(editorAnalyticsAPI),
                title: formatMessage(codeBlockState.contentCopied ? (0, $ehejR.codeBlockButtonMessages).copiedCodeToClipboard : (0, $ehejR.codeBlockButtonMessages).copyCodeToClipboard),
                onMouseEnter: (0, $bXs63.provideVisualFeedbackForCopyButton),
                // note: resetCopiedState contains logic that also removes the
                // visual feedback for the copy button
                onMouseLeave: (0, $eUWhc.resetCopiedState),
                onFocus: (0, $bXs63.provideVisualFeedbackForCopyButton),
                onBlur: (0, $bXs63.removeVisualFeedbackForCopyButton),
                hideTooltipOnClick: false,
                disabled: codeBlockState.isNodeSelected,
                tabIndex: null
            },
            separator
        ];
        let copyAndDeleteButtonMenuItems = [];
        if (areAnyNewToolbarFlagsEnabled) {
            const overflowMenuOptions = [
                {
                    title: formatMessage((0, $h2yqz.default).delete),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($4MicW)))({
                        label: ''
                    }),
                    onMouseEnter: hoverDecoration?.(nodeType, true),
                    onMouseLeave: hoverDecoration?.(nodeType, false),
                    onFocus: hoverDecoration?.(nodeType, true),
                    onBlur: hoverDecoration?.(nodeType, false),
                    onClick: (0, $eUWhc.removeCodeBlockWithAnalytics)(editorAnalyticsAPI)
                }
            ];
            if (allowCopyToClipboard) overflowMenuOptions.unshift({
                title: formatMessage((0, $h2yqz.default).copyToClipboard),
                onClick: (0, $eUWhc.copyContentToClipboardWithAnalytics)(editorAnalyticsAPI),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($4TA31)))({
                    label: ''
                }),
                onMouseEnter: (0, $bXs63.provideVisualFeedbackForCopyButton),
                onMouseLeave: (0, $eUWhc.resetCopiedState),
                onFocus: (0, $bXs63.provideVisualFeedbackForCopyButton),
                onBlur: (0, $bXs63.removeVisualFeedbackForCopyButton),
                disabled: codeBlockState.isNodeSelected
            });
            copyAndDeleteButtonMenuItems = isViewMode ? [
                ...copyToClipboardItems
            ] : [
                {
                    type: 'separator',
                    fullHeight: true
                },
                {
                    type: 'overflow-dropdown',
                    testId: 'code-block-overflow-dropdown-trigger',
                    options: overflowMenuOptions
                }
            ];
        } else {
            const deleteButton = {
                id: 'editor.codeBlock.delete',
                type: 'button',
                appearance: 'danger',
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($4MicW))),
                iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($2IYY2))),
                onMouseEnter: hoverDecoration?.(nodeType, true),
                onMouseLeave: hoverDecoration?.(nodeType, false),
                onFocus: hoverDecoration?.(nodeType, true),
                onBlur: hoverDecoration?.(nodeType, false),
                onClick: (0, $eUWhc.removeCodeBlockWithAnalytics)(editorAnalyticsAPI),
                title: formatMessage((0, $h2yqz.default).remove),
                tabIndex: null
            };
            copyAndDeleteButtonMenuItems = [
                separator,
                ...copyToClipboardItems,
                deleteButton
            ];
        }
        const codeBlockWrapButton = {
            id: 'editor.codeBlock.wrap',
            type: 'button',
            supportsViewMode: true,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gVpwy))),
            iconFallback: (0, $b4hab.WrapIcon),
            onClick: (0, $eUWhc.toggleWordWrapStateForCodeBlockNode)(editorAnalyticsAPI),
            title: (0, $eGOwo.fg)('editor_a11y_remove_unwrap_button') ? formatMessage((0, $ehejR.codeBlockButtonMessages).wrapCode) : isWrapped ? formatMessage((0, $ehejR.codeBlockButtonMessages).unwrapCode) : formatMessage((0, $ehejR.codeBlockButtonMessages).wrapCode),
            tabIndex: null,
            selected: isWrapped
        };
        return {
            title: 'CodeBlock floating controls',
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getDomRef: (view)=>(0, $BmspC.findDomRefAtPos)(pos, view.domAtPos.bind(view)),
            nodeType: nodeType,
            items: [
                languageSelect,
                ...areAnyNewToolbarFlagsEnabled ? [] : [
                    separator
                ],
                codeBlockWrapButton,
                ...copyAndDeleteButtonMenuItems
            ],
            scrollable: true
        };
    };
const $ebe400eaf7994d0a$export$fffed505cd33273c = (option, rawInput)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { data: data } = option;
    const searchString = rawInput.toLowerCase();
    return data.label.toLowerCase().includes(searchString) || data.alias.some((alias)=>alias.toLowerCase() === searchString);
};

});
parcelRegister("2IYY2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::60832bf0895f3f62571fae1dfe0965a2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1fbefbb1d7554da3$var$_react = $1fbefbb1d7554da3$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $1fbefbb1d7554da3$var$_delete = $1fbefbb1d7554da3$var$_interopRequireDefault((parcelRequire("4MicW")));

var $1fbefbb1d7554da3$var$_remove = $1fbefbb1d7554da3$var$_interopRequireDefault((parcelRequire("f7oSr")));
function $1fbefbb1d7554da3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DeleteIcon.
 * This component is DeleteIcon, with `UNSAFE_fallbackIcon` set to "EditorRemoveIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing or deleting an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1fbefbb1d7554da3$var$DeleteIcon = (props)=>/*#__PURE__*/ $1fbefbb1d7554da3$var$_react.default.createElement($1fbefbb1d7554da3$var$_delete.default, Object.assign({
        name: "DeleteIcon",
        LEGACY_fallbackIcon: $1fbefbb1d7554da3$var$_remove.default
    }, props));
$1fbefbb1d7554da3$var$DeleteIcon.displayName = 'DeleteIconMigration';
var $1fbefbb1d7554da3$var$_default = module.exports.default = $1fbefbb1d7554da3$var$DeleteIcon;

});

parcelRegister("gVpwy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d2eb42ffff47552bf7695cd1247757bc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c525c4c05f1309a4$var$_react = $c525c4c05f1309a4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c525c4c05f1309a4$var$_baseNew = $c525c4c05f1309a4$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c525c4c05f1309a4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextWrap".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for wrapping text so it spans multiple lines.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c525c4c05f1309a4$var$TextWrapIcon = (props)=>/*#__PURE__*/ $c525c4c05f1309a4$var$_react.default.createElement($c525c4c05f1309a4$var$_baseNew.default, Object.assign({
        name: "TextWrapIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.375 5H0V3.5h13.375A2.625 2.625 0 0 1 16 6.125v2.75a2.625 2.625 0 0 1-2.625 2.625H9.561l1.72 1.72-1.061 1.06-3-3a.75.75 0 0 1 0-1.06l3-3 1.06 1.06L9.56 10h3.815c.621 0 1.125-.504 1.125-1.125v-2.75C14.5 5.504 13.996 5 13.375 5M5 11.5H0V10h5z" clip-rule="evenodd"/>`
    }, props));
$c525c4c05f1309a4$var$TextWrapIcon.displayName = 'TextWrapIcon';
var $c525c4c05f1309a4$var$_default = module.exports.default = $c525c4c05f1309a4$var$TextWrapIcon;

});

parcelRegister("b4hab", function(module, exports) {
$parcel$export(module.exports, "WrapIcon", () => $1ee61fee6843a2dc$export$93a804c703d50d67);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $1ee61fee6843a2dc$var$CustomGlyph = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
            fill: "currentColor",
            clipPath: "url(#clip0_654_431)",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M20 4h-1v16h1V4ZM3 8a1 1 0 0 1 1-1h9.5a4.5 4.5 0 1 1 0 9h-2.086l.293.293a1 1 0 0 1-1.414 1.414l-2-2a1 1 0 0 1 0-1.414l2-2a1 1 0 0 1 1.414 1.414l-.293.293H13.5a2.5 2.5 0 0 0 0-5H4a1 1 0 0 1-1-1Z",
                clipRule: "evenodd",
                fillRule: "evenodd"
            })
        })
    });
const $1ee61fee6843a2dc$export$93a804c703d50d67 = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.default), {
        glyph: $1ee61fee6843a2dc$var$CustomGlyph,
        label: "wrapIcon"
    });
};

});

parcelRegister("3qt8L", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_LANGUAGES", () => $45d6a69d3352219e$export$5a175c817b3d7154);
$parcel$export(module.exports, "getLanguageIdentifier", () => $45d6a69d3352219e$export$8ef04e71795bc8a6);
$parcel$export(module.exports, "createLanguageList", () => $45d6a69d3352219e$export$e2dc9c8f242e4ee2);

var $236Qa = parcelRequire("236Qa");
const $45d6a69d3352219e$export$5a175c817b3d7154 = [
    {
        name: '(None)',
        alias: [
            'none'
        ],
        value: 'none'
    },
    ...(0, $236Qa.SUPPORTED_LANGUAGES)
];
function $45d6a69d3352219e$export$c11db3aa0f1c6401(supportedLanguages, language) {
    if (!language) return undefined;
    const matches = supportedLanguages.filter((supportedLanguage)=>{
        return supportedLanguage.alias.indexOf(language.toLowerCase()) !== -1;
    });
    if (matches.length > 0) return matches[0];
    return undefined;
}
function $45d6a69d3352219e$export$b76ace6a02d76481(supportedLanguages) {
    if (!supportedLanguages || !supportedLanguages.length) return $45d6a69d3352219e$export$5a175c817b3d7154;
    return $45d6a69d3352219e$export$5a175c817b3d7154.filter((language)=>{
        let i = language.alias.length;
        while(i--){
            if (supportedLanguages.indexOf(language.alias[i]) > -1) return true;
        }
        return false;
    });
}
function $45d6a69d3352219e$export$8ef04e71795bc8a6(language) {
    return language.alias[0];
}
function $45d6a69d3352219e$export$e2dc9c8f242e4ee2(supportedLanguages) {
    return supportedLanguages.sort((left, right)=>{
        if (left.alias[0] === 'none') return -1;
        if (left.name.toLowerCase() > right.name.toLowerCase()) return 1;
        if (left.name.toLowerCase() < right.name.toLowerCase()) return -1;
        return 0;
    });
}

});


parcelRegister("6dsfp", function(module, exports) {
$parcel$export(module.exports, "createCodeBlockMenuItem", () => $da307396cbb22877$export$76cec325b897d60);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bMFKb = parcelRequire("bMFKb");

var $garJk = parcelRequire("garJk");

var $frlUM = parcelRequire("frlUM");

var $3lIcL = parcelRequire("3lIcL");

var $dFLJN = parcelRequire("dFLJN");

var $8lO5P = parcelRequire("8lO5P");
const $da307396cbb22877$var$nodeName = 'codeBlock';
const $da307396cbb22877$var$CodeBlockMenuItem = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const selection = (0, $frlUM.useSharedPluginStateSelector)(api, 'selection.selection');
    const isCodeBlockSelected = (0, $eJOHy.useMemo)(()=>{
        if (!selection) return false;
        if (selection instanceof (0, $3lIcL.NodeSelection)) // Note: we are checking for any type of panel, not just of type infopanel
        return selection.node.type.name === $da307396cbb22877$var$nodeName;
        return false;
    }, [
        selection
    ]);
    const handleClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $bMFKb.INPUT_METHOD).KEYBOARD : (0, $bMFKb.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $bMFKb.INPUT_METHOD).BLOCK_MENU;
        api?.core.actions.execute(api?.blockMenu?.commands.formatNode($da307396cbb22877$var$nodeName, {
            inputMethod: inputMethod,
            triggeredFrom: triggeredFrom
        }));
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dFLJN.ToolbarDropdownItem), {
        onClick: handleClick,
        isSelected: isCodeBlockSelected,
        elemBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8lO5P))), {
            label: ""
        }),
        children: formatMessage((0, $garJk.messages).codeBlock)
    });
};
const $da307396cbb22877$export$76cec325b897d60 = (api)=>{
    return ()=>/*#__PURE__*/ (0, $gt9Am.jsx)($da307396cbb22877$var$CodeBlockMenuItem, {
            api: api
        });
};

});
parcelRegister("8lO5P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1091d7b3916e42e9c126eb0a1ee5598a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6147244ca1278d21$var$_react = $6147244ca1278d21$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $6147244ca1278d21$var$_baseNew = $6147244ca1278d21$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $6147244ca1278d21$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AngleBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6147244ca1278d21$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $6147244ca1278d21$var$_react.default.createElement($6147244ca1278d21$var$_baseNew.default, Object.assign({
        name: "AngleBracketsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.315 14.445 6-13.5 1.37.61-6 13.5zM13.982 10l-2.925 2.145.886 1.21 3.75-2.75a.75.75 0 0 0 0-1.21l-3.75-2.75-.886 1.21zM2.018 6l2.926 2.145-.888 1.21-3.75-2.75a.75.75 0 0 1 0-1.21l3.75-2.75.888 1.21z" clip-rule="evenodd"/>`
    }, props));
$6147244ca1278d21$var$AngleBracketsIcon.displayName = 'AngleBracketsIcon';
var $6147244ca1278d21$var$_default = module.exports.default = $6147244ca1278d21$var$AngleBracketsIcon;

});




parcelRegister("b8wHL", function(module, exports) {
$parcel$export(module.exports, "compositionPlugin", () => (parcelRequire("lTMvj")).compositionPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $lTMvj = parcelRequire("lTMvj");

});
parcelRegister("lTMvj", function(module, exports) {
$parcel$export(module.exports, "compositionPlugin", () => $9084af76a60c3c01$export$afd1652ef5208b);

var $2lXaz = parcelRequire("2lXaz");

var $3fHwZ = parcelRequire("3fHwZ");
const $9084af76a60c3c01$export$afd1652ef5208b = ()=>{
    return {
        name: 'composition',
        getSharedState (editorState) {
            if (!editorState) return {
                isComposing: false
            };
            return {
                isComposing: !!(0, $3fHwZ.pluginKey).getState(editorState)?.isComposing
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'composition',
                    plugin: ()=>(0, $2lXaz.default)()
                }
            ];
        }
    };
};

});
parcelRegister("2lXaz", function(module, exports) {
$parcel$export(module.exports, "default", () => $44b1a75a37d715e3$export$2e2bcd8739ae039);

var $i8KtF = parcelRequire("i8KtF");


var $3fHwZ = parcelRequire("3fHwZ");
const $44b1a75a37d715e3$var$isLinux = ()=>navigator.userAgent.indexOf('Linux') >= 0;
var $44b1a75a37d715e3$export$2e2bcd8739ae039 = ()=>new (0, $i8KtF.SafePlugin)({
        key: (0, $3fHwZ.pluginKey),
        state: {
            init: ()=>({
                    isComposing: false,
                    zeroWidthSpacePos: undefined
                }),
            apply: (tr, value)=>{
                const isComposing = tr.getMeta((0, $3fHwZ.pluginKey));
                const zeroWidthSpacePos = tr.getMeta('zeroWidthSpacePos');
                if (typeof isComposing === 'undefined') return value;
                return {
                    isComposing: isComposing,
                    zeroWidthSpacePos: zeroWidthSpacePos
                };
            }
        },
        props: {
            handleDOMEvents: {
                compositionstart: (view, event)=>{
                    const { tr: tr } = view.state;
                    tr.setMeta((0, $3fHwZ.pluginKey), true);
                    // only apply for linux and cursor is at start of line
                    if ($44b1a75a37d715e3$var$isLinux() && view.state.selection.$from.parentOffset === 0) {
                        tr.insertText((0, $f9e41f230eb38f84$export$15a09f5ef055bcfa));
                        // remember the position of inserted zero width space
                        tr.setMeta('zeroWidthSpacePos', view.state.selection.$from.pos);
                    }
                    view.dispatch(tr);
                    return false;
                },
                compositionend: (view, event)=>{
                    const { tr: tr } = view.state;
                    tr.setMeta((0, $3fHwZ.pluginKey), false);
                    if ($44b1a75a37d715e3$var$isLinux()) {
                        const zeroWidthSpacePos = (0, $3fHwZ.pluginKey).getState(view.state)?.zeroWidthSpacePos;
                        if (typeof zeroWidthSpacePos !== 'undefined') tr.deleteRange(zeroWidthSpacePos, zeroWidthSpacePos + 1);
                        tr.setMeta('zeroWidthSpacePos', undefined);
                    }
                    view.dispatch(tr);
                    return false;
                }
            }
        }
    });

});
parcelRegister("3fHwZ", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $56ec35762a00da13$export$18d4026d1ea86bb1);

var $3lIcL = parcelRequire("3lIcL");
const $56ec35762a00da13$export$18d4026d1ea86bb1 = new (0, $3lIcL.PluginKey)('compositionPlugin');

});




parcelRegister("cZNzR", function(module, exports) {
$parcel$export(module.exports, "copyButtonPlugin", () => (parcelRequire("4H0bV")).copyButtonPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $4H0bV = parcelRequire("4H0bV");

});
parcelRegister("4H0bV", function(module, exports) {
$parcel$export(module.exports, "copyButtonPlugin", () => $564122ed4bc3c3af$export$ea22bdb37423f02c);

var $hTRyK = parcelRequire("hTRyK");

var $8p4Ku = parcelRequire("8p4Ku");
const $564122ed4bc3c3af$export$ea22bdb37423f02c = ({ api: api })=>({
        name: 'copyButton',
        pmPlugins () {
            return [
                {
                    name: 'copyButton',
                    plugin: ()=>(0, $hTRyK.default)()
                }
            ];
        },
        actions: {
            processCopyButtonItems: (0, $8p4Ku.processCopyButtonItems)(api?.analytics?.actions, api)
        }
    });

});
parcelRegister("hTRyK", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9c58c3677587314$export$2e2bcd8739ae039);

var $i8KtF = parcelRequire("i8KtF");

var $b7EWj = parcelRequire("b7EWj");

var $6XtUa = parcelRequire("6XtUa");
function $e9c58c3677587314$export$6867b9cd7a8c8a75({ $pos: $pos, markType: markType }) {
    const hasMark = $pos.doc.rangeHasMark($pos.pos, Math.min($pos.pos + 1, $pos.doc.nodeSize), markType);
    if (!hasMark) return false;
    if ($pos.parent.childCount === 1) {
        const nodePosition = $pos.pos;
        const maybeNode = $pos.doc.nodeAt(nodePosition);
        if (!maybeNode || !maybeNode.isText) return false;
        const start = $pos.pos - $pos.parentOffset;
        const end = start + maybeNode.nodeSize;
        return {
            start: start,
            end: end
        };
    }
    if ($pos.parent.childCount > 1) {
        const start = $pos.pos - $pos.textOffset;
        const maybeTextNode = $pos.doc.nodeAt(start);
        if (!maybeTextNode || !maybeTextNode.isText) return false;
        const end = start + maybeTextNode.nodeSize;
        return {
            start: start,
            end: end
        };
    }
    return false;
}
function $e9c58c3677587314$var$getMarkSelectionDecorationStartAndEnd({ markType: markType, transaction: transaction }) {
    const anchorPositions = $e9c58c3677587314$export$6867b9cd7a8c8a75({
        $pos: transaction.selection.$anchor,
        markType: markType
    });
    if (anchorPositions) return {
        ...anchorPositions,
        markType: markType
    };
    const headPositions = $e9c58c3677587314$export$6867b9cd7a8c8a75({
        $pos: transaction.selection.$head,
        markType: markType
    });
    if (headPositions) return {
        ...headPositions,
        markType: markType
    };
    return undefined;
}
function $e9c58c3677587314$export$ea22bdb37423f02c() {
    return new (0, $i8KtF.SafePlugin)({
        key: (0, $6XtUa.copyButtonPluginKey),
        state: {
            init () {
                return {
                    copied: false,
                    markSelection: undefined
                };
            },
            apply (tr, currentPluginState) {
                const meta = tr.getMeta((0, $6XtUa.copyButtonPluginKey));
                if (meta?.copied !== undefined) return {
                    copied: meta.copied,
                    markSelection: undefined
                };
                if (meta?.showSelection) return {
                    copied: currentPluginState.copied,
                    markSelection: $e9c58c3677587314$var$getMarkSelectionDecorationStartAndEnd({
                        markType: meta.markType,
                        transaction: tr
                    })
                };
                if (meta?.removeSelection) return {
                    copied: currentPluginState.copied,
                    markSelection: undefined
                };
                if (currentPluginState.markSelection) return {
                    copied: currentPluginState.copied,
                    markSelection: $e9c58c3677587314$var$getMarkSelectionDecorationStartAndEnd({
                        markType: currentPluginState.markSelection.markType,
                        transaction: tr
                    })
                };
                return currentPluginState;
            }
        },
        props: {
            decorations (_state) {
                // Showing visual hints for the hyperlink copy button has been disabled
                // due to an issue where invalid hyperlink marks cause the floating toolbar
                // to jump around when the copy button is hovered.
                // See the following bug for details -- once that is resolved -- the visual
                // hints can be re enabled.
                // https://product-fabric.atlassian.net/browse/DTR-722
                // const copyButtonPluginState = copyButtonPluginKey.getState(
                //   state,
                // ) as CopyButtonPluginState;
                // if (copyButtonPluginState.markSelection) {
                //   const { start, end } = copyButtonPluginState.markSelection;
                //   return DecorationSet.create(state.doc, [
                //     Decoration.inline(start, end, {
                //       class: 'ProseMirror-fake-text-selection',
                //     }),
                //   ]);
                // }
                return (0, $b7EWj.DecorationSet).empty;
            }
        }
    });
}
var $e9c58c3677587314$export$2e2bcd8739ae039 = $e9c58c3677587314$export$ea22bdb37423f02c;

});
parcelRegister("6XtUa", function(module, exports) {
$parcel$export(module.exports, "copyButtonPluginKey", () => $bfc4a395a71e5ec3$export$e41a18c2cdafffa9);

var $3lIcL = parcelRequire("3lIcL");
const $bfc4a395a71e5ec3$export$e41a18c2cdafffa9 = new (0, $3lIcL.PluginKey)('copyButtonPlugin');

});


parcelRegister("8p4Ku", function(module, exports) {
$parcel$export(module.exports, "processCopyButtonItems", () => $ef5cce76d7c36fc7$export$f61ed03c42ac876f);

var $h2yqz = parcelRequire("h2yqz");

var $4TA31 = parcelRequire("4TA31");

var $jBChJ = parcelRequire("jBChJ");

var $6XtUa = parcelRequire("6XtUa");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ef5cce76d7c36fc7$var$isSeparator(item) {
    return item?.type === 'separator';
}
function $ef5cce76d7c36fc7$var$isNodeOptions(options) {
    return 'nodeType' in options && options.nodeType !== undefined;
}
function $ef5cce76d7c36fc7$export$518afae27d2d4b23(options, hoverDecoration, editorAnalyticsApi, api) {
    const { state: state, formatMessage: formatMessage, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, onBlur: onBlur } = options;
    const copyButtonState = (0, $6XtUa.copyButtonPluginKey).getState(state);
    let buttonActionHandlers;
    if ($ef5cce76d7c36fc7$var$isNodeOptions(options)) buttonActionHandlers = {
        onClick: (0, $jBChJ.createToolbarCopyCommandForNode)(options.nodeType, editorAnalyticsApi, api, formatMessage((0, $h2yqz.default).copiedToClipboard)),
        // Note for future changes: these two handlers should perform
        // the same action.
        onMouseEnter: onMouseEnter || hoverDecoration?.(options.nodeType, true, 'ak-editor-selected-node'),
        onFocus: onFocus || hoverDecoration?.(options.nodeType, true, 'ak-editor-selected-node'),
        // Note for future changes: these two handlers should perform
        // the same action.
        onMouseLeave: (0, $jBChJ.resetCopiedState)(options.nodeType, hoverDecoration, onMouseLeave),
        onBlur: (0, $jBChJ.resetCopiedState)(options.nodeType, hoverDecoration, onBlur)
    };
    else buttonActionHandlers = {
        onClick: (0, $jBChJ.createToolbarCopyCommandForMark)(options.markType, editorAnalyticsApi),
        onMouseEnter: (0, $jBChJ.getProvideMarkVisualFeedbackForCopyButtonCommand)(options.markType),
        onFocus: (0, $jBChJ.getProvideMarkVisualFeedbackForCopyButtonCommand)(options.markType),
        onMouseLeave: (0, $jBChJ.removeMarkVisualFeedbackForCopyButtonCommand),
        onBlur: (0, $jBChJ.removeMarkVisualFeedbackForCopyButtonCommand)
    };
    return {
        id: 'editor.floatingToolbar.copy',
        type: 'button',
        appearance: 'subtle',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4TA31))),
        title: formatMessage(copyButtonState?.copied ? (0, $h2yqz.default).copiedToClipboard : (0, $h2yqz.default).copyToClipboard),
        ...buttonActionHandlers,
        hideTooltipOnClick: false,
        tabIndex: null
    };
}
const $ef5cce76d7c36fc7$export$f61ed03c42ac876f = (editorAnalyticsApi, api)=>(state)=>{
        return (items, hoverDecoration)=>items.flatMap((item)=>{
                switch(item.type){
                    case 'copy-button':
                        if (item?.hidden) return [];
                        return item?.items.map((copyButtonItem)=>$ef5cce76d7c36fc7$var$isSeparator(copyButtonItem) ? copyButtonItem : $ef5cce76d7c36fc7$export$518afae27d2d4b23(copyButtonItem, hoverDecoration, editorAnalyticsApi, api));
                    default:
                        return [
                            item
                        ];
                }
            });
    };

});
parcelRegister("jBChJ", function(module, exports) {
$parcel$export(module.exports, "createToolbarCopyCommandForMark", () => $44f34e302f022356$export$61f33363e77ed28);
$parcel$export(module.exports, "getProvideMarkVisualFeedbackForCopyButtonCommand", () => $44f34e302f022356$export$5887c7b152626490);
$parcel$export(module.exports, "removeMarkVisualFeedbackForCopyButtonCommand", () => $44f34e302f022356$export$e52b1d5c60d367b8);
$parcel$export(module.exports, "createToolbarCopyCommandForNode", () => $44f34e302f022356$export$be806b3b778a7682);
$parcel$export(module.exports, "resetCopiedState", () => $44f34e302f022356$export$3e0b07341e7576a);

var $bMFKb = parcelRequire("bMFKb");

var $7EdFW = parcelRequire("7EdFW");

var $58hN2 = parcelRequire("58hN2");

var $e5Nsc = parcelRequire("e5Nsc");

var $3lIcL = parcelRequire("3lIcL");

var $cbSL1 = parcelRequire("cbSL1");

var $9Letn = parcelRequire("9Letn");

var $6XtUa = parcelRequire("6XtUa");
function $44f34e302f022356$export$61f33363e77ed28(markType, editorAnalyticsApi) {
    function command(state, dispatch) {
        const textNode = state.tr.selection.$head.parent.maybeChild(state.tr.selection.$head.index());
        if (!textNode) return false;
        if (dispatch) {
            // As calling copyHTMLToClipboard causes side effects -- we only run this when
            // dispatch is provided -- as otherwise the consumer is only testing to see if
            // the action is availble.
            const domNode = (0, $e5Nsc.toDOM)(textNode, state.schema);
            if (domNode) {
                const div = document.createElement('div');
                const p = document.createElement('p');
                div.appendChild(p);
                p.appendChild(domNode);
                // The "1 1" refers to the start and end depth of the slice
                // since we're copying the text inside a paragraph, it will always be 1 1
                // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                div.firstChild.setAttribute('data-pm-slice', '1 1 []');
                // If we're copying a hyperlink, we'd copy the url as the fallback plain text
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const linkUrl = domNode.getAttribute('href');
                (0, $58hN2.copyHTMLToClipboard)(div, markType.name === 'link' && linkUrl ? linkUrl : undefined);
            }
            const copyToClipboardTr = state.tr;
            copyToClipboardTr.setMeta((0, $6XtUa.copyButtonPluginKey), {
                copied: true
            });
            const analyticsPayload = (0, $58hN2.getAnalyticsPayload)(state, (0, $bMFKb.ACTION).COPIED);
            if (analyticsPayload && editorAnalyticsApi) {
                analyticsPayload.attributes.inputMethod = (0, $bMFKb.INPUT_METHOD).FLOATING_TB;
                analyticsPayload.attributes.markType = markType.name;
                editorAnalyticsApi?.attachAnalyticsEvent?.(analyticsPayload)(copyToClipboardTr);
            }
            dispatch(copyToClipboardTr);
        }
        return true;
    }
    return command;
}
function $44f34e302f022356$export$5887c7b152626490(markType) {
    function provideMarkVisualFeedbackForCopyButtonCommand(state, dispatch) {
        const tr = state.tr;
        tr.setMeta((0, $6XtUa.copyButtonPluginKey), {
            showSelection: true,
            markType: markType
        });
        if (dispatch) dispatch(tr);
        return true;
    }
    return provideMarkVisualFeedbackForCopyButtonCommand;
}
function $44f34e302f022356$export$e52b1d5c60d367b8(state, dispatch) {
    const tr = state.tr;
    tr.setMeta((0, $6XtUa.copyButtonPluginKey), {
        removeSelection: true
    });
    const copyButtonState = (0, $6XtUa.copyButtonPluginKey).getState(state);
    if (copyButtonState?.copied) tr.setMeta((0, $6XtUa.copyButtonPluginKey), {
        copied: false
    });
    if (dispatch) dispatch(tr);
    return true;
}
const $44f34e302f022356$export$be806b3b778a7682 = (nodeType, editorAnalyticsApi, api, onClickMessage)=>(state, dispatch)=>{
        const { tr: tr, schema: schema } = state;
        // This command should only be triggered by the Copy button in the floating toolbar
        // which is only visible when selection is inside the target node
        const contentNodeWithPos = (0, $e5Nsc.getSelectedNodeOrNodeParentByNodeType)({
            nodeType: nodeType,
            selection: tr.selection
        });
        if (!contentNodeWithPos) return false;
        const copyToClipboardTr = tr;
        copyToClipboardTr.setMeta((0, $6XtUa.copyButtonPluginKey), {
            copied: true
        });
        const analyticsPayload = (0, $58hN2.getAnalyticsPayload)(state, (0, $bMFKb.ACTION).COPIED);
        if (analyticsPayload && editorAnalyticsApi) {
            analyticsPayload.attributes.inputMethod = (0, $bMFKb.INPUT_METHOD).FLOATING_TB;
            analyticsPayload.attributes.nodeType = contentNodeWithPos.node.type.name;
            editorAnalyticsApi?.attachAnalyticsEvent?.(analyticsPayload)(copyToClipboardTr);
        }
        if (dispatch) {
            // As calling copyHTMLToClipboard causes side effects -- we only run this when
            // dispatch is provided -- as otherwise the consumer is only testing to see if
            // the action is availble.
            const domNode = (0, $e5Nsc.toDOM)(contentNodeWithPos.node, schema);
            if ((0, $9Letn.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true)) (0, $e5Nsc.copyDomNode)(domNode, contentNodeWithPos.node.type, tr.selection);
            else if (domNode) {
                const div = document.createElement('div');
                const browser = (0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $7EdFW.getBrowserInfo)() : (0, $7EdFW.browser);
                div.appendChild(domNode);
                // if copying inline content
                if (contentNodeWithPos.node.type.inlineContent) // The "1 1" refers to the start and end depth of the slice
                // since we're copying the text inside a paragraph, it will always be 1 1
                // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                div.firstChild.setAttribute('data-pm-slice', '1 1 []');
                else // The "0 0" refers to the start and end depth of the slice
                // since we're copying the block node only, it will always be 0 0
                // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                div.firstChild.setAttribute('data-pm-slice', '0 0 []');
                // ED-17083 safari seems have bugs for extension copy because exntension do not have a child text(innerText) and it will not recognized as html in clipboard, this could be merge into one if this extension fixed children issue or safari fix the copy bug
                // MEX-2528 safari has a bug related to the mediaSingle node with border or link. The image tag within the clipboard is not recognized as HTML when using the ClipboardItem API. To address this, we have to switch to ClipboardPolyfill
                if (browser.safari && state.selection instanceof (0, $3lIcL.NodeSelection) && (state.selection.node.type === state.schema.nodes.extension || state.selection.node.type === state.schema.nodes.mediaSingle)) (0, $58hN2.copyHTMLToClipboardPolyfill)(div);
                else (0, $58hN2.copyHTMLToClipboard)(div);
            }
            copyToClipboardTr.setMeta('scrollIntoView', false);
            dispatch(copyToClipboardTr);
        }
        /**
		 * A11y-10275 This prop api drilled from the plugin all the way down to the usage
		 * because it's the safest way to ensure accessibilityUtils is available and not
		 * undefined.
		 *
		 * see thread https://atlassian.slack.com/archives/C02CDUS3SUS/p1744256326459569
		 */ if (onClickMessage) api?.accessibilityUtils?.actions.ariaNotify(onClickMessage, {
            priority: 'important'
        });
        return true;
    };
const $44f34e302f022356$export$3e0b07341e7576a = (nodeType, hoverDecoration, onMouseLeave)=>(state, dispatch)=>{
        let customTr = state.tr;
        // Avoid multipe dispatch
        // https://product-fabric.atlassian.net/wiki/spaces/E/pages/2241659456/All+about+dispatch+and+why+there+shouldn+t+be+multiple#How-do-I-avoid-them%3F
        const customDispatch = (tr)=>{
            customTr = tr;
        };
        onMouseLeave ? onMouseLeave(state, customDispatch) : hoverDecoration?.(nodeType, false)(state, customDispatch);
        const copyButtonState = (0, $6XtUa.copyButtonPluginKey).getState(state);
        if (copyButtonState?.copied) customTr.setMeta((0, $6XtUa.copyButtonPluginKey), {
            copied: false
        });
        if (dispatch) dispatch(customTr);
        return true;
    };

});




parcelRegister("30v6T", function(module, exports) {
$parcel$export(module.exports, "decorationsPlugin", () => (parcelRequire("88434")).decorationsPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $88434 = parcelRequire("88434");

});
parcelRegister("88434", function(module, exports) {
$parcel$export(module.exports, "decorationsPlugin", () => $dd7c9b5c239a1620$export$1c07ef1814918eb5);

var $9Letn = parcelRequire("9Letn");

var $hY0KA = parcelRequire("hY0KA");

var $lFhVg = parcelRequire("lFhVg");
const $dd7c9b5c239a1620$export$1c07ef1814918eb5 = ()=>({
        name: 'decorations',
        pmPlugins () {
            return [
                {
                    name: 'decorationPlugin',
                    plugin: ()=>(0, $lFhVg.default)()
                }
            ];
        },
        actions: {
            hoverDecoration: $lFhVg.hoverDecoration,
            removeDecoration: $lFhVg.removeDecoration
        },
        getSharedState (editorState) {
            if (!editorState) return {
                decoration: undefined
            };
            return (0, $lFhVg.decorationStateKey).getState(editorState);
        },
        commands: {
            hoverDecoration: (0, $9Letn.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true) ? ({ nodeType: nodeType, add: add, className: className })=>(0, $hY0KA.hoverDecorationCommand)({
                    nodeType: nodeType,
                    add: add,
                    className: className
                }) : undefined,
            removeDecoration: (0, $9Letn.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true) ? ()=>(0, $hY0KA.removeDecorationCommand)() : undefined
        }
    });

});
parcelRegister("hY0KA", function(module, exports) {
$parcel$export(module.exports, "hoverDecorationCommand", () => $d4d0580bf7da60f9$export$84d8b6d3cf5f2fb4);
$parcel$export(module.exports, "removeDecorationCommand", () => $d4d0580bf7da60f9$export$14b7848c5cb6944c);

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");

var $b7EWj = parcelRequire("b7EWj");

var $cwzAY = parcelRequire("cwzAY");
var $kuDbA = parcelRequire("kuDbA");
var $2vA54 = parcelRequire("2vA54");

var $hs2hB = parcelRequire("hs2hB");

var $9Letn = parcelRequire("9Letn");

var $lFhVg = parcelRequire("lFhVg");
const $d4d0580bf7da60f9$export$84d8b6d3cf5f2fb4 = ({ nodeType: nodeType, add: add, className: className = 'danger' })=>({ tr: tr })=>{
        let from;
        let parentNode;
        let decoration;
        if (tr.selection instanceof (0, $3lIcL.NodeSelection)) {
            const selectedNode = tr.selection.node;
            const nodeTypes = Array.isArray(nodeType) ? nodeType : [
                nodeType
            ];
            const isNodeTypeMatching = nodeTypes.indexOf(selectedNode.type) > -1;
            // This adds danger styling if the selected node is the one that requires
            // the decoration to be added, e.g. if a layout is selected and the user
            // hovers over the layout's delete button.
            if (isNodeTypeMatching) {
                from = tr.selection.from;
                parentNode = selectedNode;
            }
        }
        // This adds danger styling if the selection is not a node selection, OR if
        // the selected node is a child of the one that requires the decoration to
        // be added, e.g. if a decision item is selected inside a layout and the
        // user hovers over the layout's delete button.
        const foundParentNode = (0, $BmspC.findParentNodeOfType)(nodeType)(tr.selection);
        // Override from and parentNode values if foundParentNode is a mediaGroup
        if (foundParentNode && (from === undefined || foundParentNode.node.type.name === 'mediaGroup')) {
            from = foundParentNode.pos;
            parentNode = foundParentNode.node;
        }
        // Note: can't use !from as from could be 0, which is falsy but valid
        if (from === undefined || parentNode === undefined) return tr;
        decoration = (0, $b7EWj.Decoration).node(from, from + parentNode.nodeSize, {
            class: className
        }, {
            key: 'decorationNode'
        });
        if (tr.selection instanceof (0, $3lIcL.TextSelection)) decoration = (0, $b7EWj.Decoration).inline(from, tr.selection.to, {
            class: className,
            style: `background-color: ${"var(--ds-background-danger, #FFECEB)"};`
        }, {
            key: 'decorationNode'
        });
        if (tr.selection instanceof (0, $cwzAY.CellSelection)) {
            const table = (0, $kuDbA.findTable)(tr.selection);
            if (!table) return tr;
            const map = (0, $2vA54.TableMap).get(table.node);
            const rect = (0, $hs2hB.getSelectionRect)(tr.selection);
            if (!map || !rect) return tr;
            const tableNodeDec = (0, $b7EWj.Decoration).node(table.pos, table.pos + table.node.nodeSize, {
                class: className
            }, {
                key: 'decorationNode'
            });
            const updatedCells = map.cellsInRect(rect).map((x)=>x + table.start);
            const tableCellDecorations = updatedCells.map((pos)=>{
                const cell = tr.doc.nodeAt(pos);
                if (!cell) return;
                return (0, $b7EWj.Decoration).node(pos, pos + cell.nodeSize, {
                    class: className
                }, {
                    key: 'decorationNode'
                });
            }).filter((decoration)=>!!decoration);
            decoration = (0, $b7EWj.DecorationSet).create(tr.doc, [
                tableNodeDec,
                ...tableCellDecorations
            ]);
        }
        tr.setMeta((0, $lFhVg.decorationStateKey), {
            action: add ? (0, $lFhVg.ACTIONS).DECORATION_ADD : (0, $lFhVg.ACTIONS).DECORATION_REMOVE,
            data: decoration,
            hasDangerDecorations: (0, $9Letn.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true) && (0, $9Letn.expValEqualsNoExposure)('platform_editor_block_menu_keyboard_navigation', 'isEnabled', true) ? className === 'danger' : undefined
        }).setMeta('addToHistory', false);
        return tr;
    };
const $d4d0580bf7da60f9$export$14b7848c5cb6944c = ()=>({ tr: tr })=>{
        return tr.setMeta((0, $lFhVg.decorationStateKey), {
            action: (0, $lFhVg.ACTIONS).DECORATION_REMOVE
        });
    };

});
parcelRegister("kuDbA", function(module, exports) {
$parcel$export(module.exports, "findTable", () => $b569d06a5ec21d0c$export$1ae6a0a4f7784fc4);
$parcel$export(module.exports, "findTableClosestToPos", () => $b569d06a5ec21d0c$export$9323c80f9a3e899f);
$parcel$export(module.exports, "findCellClosestToPos", () => $b569d06a5ec21d0c$export$3ac56532a0bf4018);
$parcel$export(module.exports, "findCellRectClosestToPos", () => $b569d06a5ec21d0c$export$68680ae223aebfa7);

var $BmspC = parcelRequire("BmspC");

var $2vA54 = parcelRequire("2vA54");
const $b569d06a5ec21d0c$export$1ae6a0a4f7784fc4 = (selection)=>(0, $BmspC.findParentNode)((node)=>node.type.spec.tableRole && node.type.spec.tableRole === 'table')(selection);
const $b569d06a5ec21d0c$export$9323c80f9a3e899f = ($pos)=>{
    const predicate = (node)=>node.type.spec.tableRole && node.type.spec.tableRole === 'table';
    return (0, $BmspC.findParentNodeClosestToPos)($pos, predicate);
};
const $b569d06a5ec21d0c$export$3ac56532a0bf4018 = ($pos)=>{
    const predicate = (node)=>// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        node.type.spec.tableRole && /cell/i.test(node.type.spec.tableRole);
    return (0, $BmspC.findParentNodeClosestToPos)($pos, predicate);
};
const $b569d06a5ec21d0c$export$68680ae223aebfa7 = ($pos)=>{
    const cell = $b569d06a5ec21d0c$export$3ac56532a0bf4018($pos);
    if (cell) {
        const table = $b569d06a5ec21d0c$export$9323c80f9a3e899f($pos);
        if (table) {
            const map = (0, $2vA54.TableMap).get(table.node);
            const cellPos = cell.pos - table.start;
            return map.rectBetween(cellPos, cellPos);
        }
    }
};

});

parcelRegister("hs2hB", function(module, exports) {
$parcel$export(module.exports, "getSelectionRect", () => $66110a9b78781fc4$export$aa946c0ed562e2ed);

var $2vA54 = parcelRequire("2vA54");

var $6dtFv = parcelRequire("6dtFv");
const $66110a9b78781fc4$export$aa946c0ed562e2ed = (selection)=>{
    if (!(0, $6dtFv.isSelectionType)(selection, 'cell')) return;
    const start = selection.$anchorCell.start(-1);
    const map = (0, $2vA54.TableMap).get(selection.$anchorCell.node(-1));
    return map.rectBetween(selection.$anchorCell.pos - start, selection.$headCell.pos - start);
};

});

parcelRegister("lFhVg", function(module, exports) {
$parcel$export(module.exports, "decorationStateKey", () => $1dc8fc1d38aeb2a7$export$385f768f10dabdd5);
$parcel$export(module.exports, "ACTIONS", () => $1dc8fc1d38aeb2a7$export$92a1a3b7554e9387);
$parcel$export(module.exports, "removeDecoration", () => $1dc8fc1d38aeb2a7$export$ea377ae2b4b58797);
$parcel$export(module.exports, "hoverDecoration", () => $1dc8fc1d38aeb2a7$export$fbf24964a8aac61c);
$parcel$export(module.exports, "default", () => $1dc8fc1d38aeb2a7$export$2e2bcd8739ae039);

var $i8KtF = parcelRequire("i8KtF");

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");

var $b7EWj = parcelRequire("b7EWj");

var $9Letn = parcelRequire("9Letn");
const $1dc8fc1d38aeb2a7$export$385f768f10dabdd5 = new (0, $3lIcL.PluginKey)('decorationPlugin');
var $1dc8fc1d38aeb2a7$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS[ACTIONS["DECORATION_ADD"] = 0] = "DECORATION_ADD";
    ACTIONS[ACTIONS["DECORATION_REMOVE"] = 1] = "DECORATION_REMOVE";
    return ACTIONS;
}({});
const $1dc8fc1d38aeb2a7$export$ea377ae2b4b58797 = (state, dispatch)=>{
    const { tr: tr } = state;
    const { decoration: decoration } = $1dc8fc1d38aeb2a7$export$385f768f10dabdd5.getState(state);
    if (decoration && dispatch) {
        dispatch(tr.setMeta($1dc8fc1d38aeb2a7$export$385f768f10dabdd5, {
            action: 1
        }));
        return true;
    }
    return false;
};
const $1dc8fc1d38aeb2a7$export$fbf24964a8aac61c = (nodeType, add, className = 'danger')=>(state, dispatch)=>{
        let from;
        let parentNode;
        if (state.selection instanceof (0, $3lIcL.NodeSelection)) {
            const selectedNode = state.selection.node;
            const nodeTypes = Array.isArray(nodeType) ? nodeType : [
                nodeType
            ];
            const isNodeTypeMatching = nodeTypes.indexOf(selectedNode.type) > -1;
            // This adds danger styling if the selected node is the one that requires
            // the decoration to be added, e.g. if a layout is selected and the user
            // hovers over the layout's delete button.
            if (isNodeTypeMatching) {
                from = state.selection.from;
                parentNode = selectedNode;
            }
        }
        // This adds danger styling if the selection is not a node selection, OR if
        // the selected node is a child of the one that requires the decoration to
        // be added, e.g. if a decision item is selected inside a layout and the
        // user hovers over the layout's delete button.
        const foundParentNode = (0, $BmspC.findParentNodeOfType)(nodeType)(state.selection);
        if (from === undefined && foundParentNode) {
            from = foundParentNode.pos;
            parentNode = foundParentNode.node;
        }
        // Note: can't use !from as from could be 0, which is falsy but valid
        if (from === undefined || parentNode === undefined) return false;
        if (dispatch) dispatch(state.tr.setMeta($1dc8fc1d38aeb2a7$export$385f768f10dabdd5, {
            action: add ? 0 : 1,
            data: (0, $b7EWj.Decoration).node(from, from + parentNode.nodeSize, {
                class: className
            }, {
                key: 'decorationNode'
            })
        }).setMeta('addToHistory', false));
        return true;
    };
var $1dc8fc1d38aeb2a7$export$2e2bcd8739ae039 = ()=>{
    return new (0, $i8KtF.SafePlugin)({
        key: $1dc8fc1d38aeb2a7$export$385f768f10dabdd5,
        state: {
            init: ()=>({
                    decoration: undefined
                }),
            apply (tr, pluginState) {
                if (pluginState.decoration && pluginState.decoration instanceof (0, $b7EWj.Decoration)) {
                    const mapResult = tr.mapping.mapResult(pluginState.decoration.from);
                    if (mapResult.deleted) pluginState = {
                        decoration: undefined
                    };
                }
                if (pluginState.decoration && pluginState.decoration instanceof (0, $b7EWj.DecorationSet) && (0, $9Letn.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true)) pluginState.decoration = pluginState.decoration.map(tr.mapping, tr.doc);
                const meta = tr.getMeta($1dc8fc1d38aeb2a7$export$385f768f10dabdd5);
                if (!meta) return pluginState;
                switch(meta.action){
                    case 0:
                        return {
                            decoration: meta.data,
                            hasDangerDecorations: (0, $9Letn.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true) && (0, $9Letn.expValEqualsNoExposure)('platform_editor_block_menu_keyboard_navigation', 'isEnabled', true) ? meta.hasDangerDecorations : undefined
                        };
                    case 1:
                        return {
                            decoration: undefined,
                            hasDangerDecorations: undefined
                        };
                    default:
                        return pluginState;
                }
            }
        },
        props: {
            decorations (state) {
                const { doc: doc } = state;
                const { decoration: decoration } = $1dc8fc1d38aeb2a7$export$385f768f10dabdd5.getState(state);
                if (decoration instanceof (0, $b7EWj.Decoration)) return (0, $b7EWj.DecorationSet).create(doc, [
                    decoration
                ]);
                if (decoration instanceof (0, $b7EWj.DecorationSet) && (0, $9Letn.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true)) return decoration;
                return null;
            }
        }
    });
};

});




parcelRegister("iQvAc", function(module, exports) {
$parcel$export(module.exports, "editorDisabledPlugin", () => (parcelRequire("d3sAY")).editorDisabledPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $d3sAY = parcelRequire("d3sAY");

});
parcelRegister("d3sAY", function(module, exports) {
$parcel$export(module.exports, "editorDisabledPlugin", () => $7b74f9ec744b951a$export$db5fb3a4c4390f03);

var $bRPNB = parcelRequire("bRPNB");

var $i8KtF = parcelRequire("i8KtF");

var $bazog = parcelRequire("bazog");

var $3lIcL = parcelRequire("3lIcL");

var $eGOwo = parcelRequire("eGOwo");

var $gWHTY = parcelRequire("gWHTY");
const $7b74f9ec744b951a$export$18d4026d1ea86bb1 = new (0, $3lIcL.PluginKey)('editorDisabledPlugin');
const { getPluginState: $7b74f9ec744b951a$var$getPluginState } = (0, $bazog.pluginFactory)($7b74f9ec744b951a$export$18d4026d1ea86bb1, (0, $gWHTY.reducer));
/*
Stores the state of the editor enabled/disabled for panel and floating
toolbar to subscribe to through useSharedPluginState. Otherwise the NodeViews
won't re-render when it changes.
*/ function $7b74f9ec744b951a$var$createPlugin(dispatch, options) {
    const scheduleEditorDisabledUpdate = (0, $bRPNB.default)((view)=>{
        if ($7b74f9ec744b951a$var$getPluginState(view.state).editorDisabled !== !view.editable) {
            const disabledMeta = {
                editorDisabled: !view.editable,
                disabledByPlugin: $7b74f9ec744b951a$var$getPluginState(view.state).disabledByPlugin
            };
            const tr = view.state.tr.setMeta($7b74f9ec744b951a$export$18d4026d1ea86bb1, disabledMeta).setMeta('editorDisabledPlugin', disabledMeta);
            tr.setMeta('isLocal', true);
            view.dispatch(tr);
        }
    });
    return new (0, $i8KtF.SafePlugin)({
        key: $7b74f9ec744b951a$export$18d4026d1ea86bb1,
        state: {
            init: ()=>{
                return {
                    editorDisabled: options?.initialDisabledState ?? false,
                    disabledByPlugin: false
                };
            },
            apply: (tr, pluginState)=>{
                const meta = tr.getMeta($7b74f9ec744b951a$export$18d4026d1ea86bb1);
                if (meta) {
                    if ((0, $eGOwo.fg)('platform_editor_ai_aifc_patch_beta')) {
                        if ('action' in meta) return (0, $gWHTY.reducer)(pluginState, meta);
                    }
                    return pluginState.editorDisabled !== meta.editorDisabled ? {
                        ...pluginState,
                        ...meta
                    } : pluginState;
                }
                return pluginState;
            }
        },
        props: {
            // If we set to undefined it respects the previous value.
            // Prosemirror doesn't have this typed correctly for this type of behaviour
            // @ts-expect-error
            editable: (0, $eGOwo.fg)('platform_editor_ai_aifc_patch_beta') ? (state)=>{
                const { disabledByPlugin: disabledByPlugin } = $7b74f9ec744b951a$export$18d4026d1ea86bb1.getState(state) ?? {
                    disabledByPlugin: false
                };
                return disabledByPlugin ? false : undefined;
            } : undefined
        },
        view: (view)=>{
            // schedule on mount
            scheduleEditorDisabledUpdate(view);
            return {
                update (view) {
                    scheduleEditorDisabledUpdate(view);
                },
                destroy () {
                    scheduleEditorDisabledUpdate.cancel();
                }
            };
        }
    });
}
const $7b74f9ec744b951a$export$db5fb3a4c4390f03 = ({ config: options = {}, api: api })=>({
        name: 'editorDisabled',
        getSharedState (editorState) {
            if (!editorState) return {
                editorDisabled: false
            };
            const pluginState = $7b74f9ec744b951a$export$18d4026d1ea86bb1.getState(editorState);
            if (!pluginState) return {
                editorDisabled: false
            };
            if ((0, $eGOwo.fg)('platform_editor_ai_aifc_patch_beta')) return {
                editorDisabled: pluginState.disabledByPlugin || pluginState.editorDisabled
            };
            return pluginState;
        },
        pmPlugins: ()=>[
                {
                    name: 'editorDisabled',
                    plugin: ({ dispatch: dispatch })=>$7b74f9ec744b951a$var$createPlugin(dispatch, options)
                }
            ],
        commands: {
            toggleDisabled: (disabled)=>({ tr: tr })=>{
                    return (0, $eGOwo.fg)('platform_editor_ai_aifc_patch_beta') ? tr.setMeta($7b74f9ec744b951a$export$18d4026d1ea86bb1, {
                        action: (0, $gWHTY.ACTION).TOGGLE_DISABLED,
                        disabled: disabled
                    }) : null;
                }
        }
    });

});
parcelRegister("gWHTY", function(module, exports) {
$parcel$export(module.exports, "ACTION", () => $a1357e04fa9033e8$export$9523889e0a5da4ba);
$parcel$export(module.exports, "reducer", () => $a1357e04fa9033e8$export$1650419e431d3ba3);
var $a1357e04fa9033e8$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["TOGGLE_DISABLED"] = "TOGGLE_DISABLED";
    return ACTION;
}({});
function $a1357e04fa9033e8$export$1650419e431d3ba3(pluginState, meta) {
    if (meta && 'action' in meta) switch(meta.action){
        case "TOGGLE_DISABLED":
            if (meta.disabled === pluginState.disabledByPlugin) return pluginState;
            return {
                ...pluginState,
                disabledByPlugin: Boolean(meta.disabled)
            };
        default:
            return pluginState;
    }
    return pluginState;
}

});



parcelRegister("c9xno", function(module, exports) {
$parcel$export(module.exports, "floatingToolbarPlugin", () => (parcelRequire("7gUM9")).floatingToolbarPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $7gUM9 = parcelRequire("7gUM9");

});
parcelRegister("7gUM9", function(module, exports) {
$parcel$export(module.exports, "floatingToolbarPlugin", () => $b1b0f95ea4c121e3$export$baed971c987bc0e);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $7mF43 = parcelRequire("7mF43");

var $bMFKb = parcelRequire("bMFKb");

var $fNh22 = parcelRequire("fNh22");

var $28ffc = parcelRequire("28ffc");

var $bSToC = parcelRequire("bSToC");

var $4sxxB = parcelRequire("4sxxB");

var $i8KtF = parcelRequire("i8KtF");

var $jx6gl = parcelRequire("jx6gl");

var $avm98 = parcelRequire("avm98");

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");

var $eGOwo = parcelRequire("eGOwo");

var $cbSL1 = parcelRequire("cbSL1");

var $9Letn = parcelRequire("9Letn");

var $92xoS = parcelRequire("92xoS");

var $h9coN = parcelRequire("h9coN");

var $cIMBE = parcelRequire("cIMBE");

var $bYdnm = parcelRequire("bYdnm");

var $2M0rW = parcelRequire("2M0rW");

var $3v3t0 = parcelRequire("3v3t0");

var $ho7Ph = parcelRequire("ho7Ph");

var $hNNR4 = parcelRequire("hNNR4");

var $28qTE = parcelRequire("28qTE");

var $jFFUB = parcelRequire("jFFUB");
const $b1b0f95ea4c121e3$var$SUPPRESS_TOOLBAR_USER_INTENTS = [
    'dragging',
    'tablePopupOpen',
    'commenting',
    'resizing',
    'blockMenuOpen',
    'statusPickerOpen'
];
const $b1b0f95ea4c121e3$export$c5f0b4d19f5b8d4b = (selection, configs)=>{
    // node selections always take precedence, see if
    let configPair;
    configs.find((config)=>{
        const node = (0, $BmspC.findSelectedNodeOfType)(config.nodeType)(selection);
        if (node) configPair = {
            node: node.node,
            pos: node.pos,
            config: config
        };
        return !!node;
    });
    if (configPair) return configPair;
    // create mapping of node type name to configs
    const configByNodeType = {};
    configs.forEach((config)=>{
        if (Array.isArray(config.nodeType)) config.nodeType.forEach((nodeType)=>{
            configByNodeType[nodeType.name] = config;
        });
        else configByNodeType[config.nodeType.name] = config;
    });
    // search up the tree from selection
    const { $from: $from } = selection;
    for(let i = $from.depth; i > 0; i--){
        const node = $from.node(i);
        const matchedConfig = configByNodeType[node.type.name];
        if (matchedConfig) return {
            config: matchedConfig,
            node: node,
            pos: $from.pos
        };
    }
    // if it is AllSelection (can be result of Cmd+A) - use first node
    if (selection instanceof (0, $3lIcL.AllSelection)) {
        const docNode = $from.node(0);
        let matchedConfig = null;
        const firstChild = (0, $ho7Ph.findNode)(docNode, (node)=>{
            matchedConfig = configByNodeType[node.type.name];
            return !!matchedConfig;
        });
        if (firstChild && matchedConfig) return {
            config: matchedConfig,
            node: firstChild,
            pos: $from.pos
        };
    }
    return;
};
const $b1b0f95ea4c121e3$var$getDomRefFromSelection = (view, dispatchAnalyticsEvent)=>{
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        return (0, $BmspC.findDomRefAtPos)(view.state.selection.from, view.domAtPos.bind(view));
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(error);
        if (dispatchAnalyticsEvent) {
            const payload = {
                action: (0, $bMFKb.ACTION).ERRORED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).CONTENT_COMPONENT,
                eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    component: (0, $bMFKb.CONTENT_COMPONENT).FLOATING_TOOLBAR,
                    selection: view.state.selection.toJSON(),
                    position: view.state.selection.from,
                    docSize: view.state.doc.nodeSize,
                    error: error.toString(),
                    // @ts-expect-error - Object literal may only specify known properties, 'errorStack' does not exist in type
                    // This error was introduced after upgrading to TypeScript 5
                    errorStack: error.stack || undefined
                }
            };
            dispatchAnalyticsEvent(payload);
        }
    }
};
function $b1b0f95ea4c121e3$var$filterUndefined(x) {
    return !!x;
}
const $b1b0f95ea4c121e3$export$baed971c987bc0e = ({ api: api })=>{
    return {
        name: 'floatingToolbar',
        pmPlugins (floatingToolbarHandlers = []) {
            const plugins = [
                {
                    // Should be after all toolbar plugins
                    name: 'floatingToolbar',
                    plugin: ({ providerFactory: providerFactory, getIntl: getIntl })=>$b1b0f95ea4c121e3$export$5c1ec0ef773ca0cc({
                            api: api,
                            floatingToolbarHandlers: floatingToolbarHandlers,
                            providerFactory: providerFactory,
                            getIntl: getIntl
                        })
                },
                {
                    name: 'floatingToolbarData',
                    plugin: ({ dispatch: dispatch })=>(0, $2M0rW.createPlugin)(dispatch)
                },
                {
                    name: 'forceFocus',
                    plugin: ()=>(0, $cIMBE.default)()
                }
            ];
            return plugins;
        },
        actions: {
            forceFocusSelector: $cIMBE.forceFocusSelector
        },
        commands: {
            copyNode: (nodeType, inputMethod)=>(0, $h9coN.copyNode)(nodeType, api?.analytics?.actions, inputMethod)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const interactionState = api?.interaction?.sharedState.currentState()?.interactionState;
            const configWithNodeInfo = interactionState !== 'hasNotHadInteraction' ? $b1b0f95ea4c121e3$export$18d4026d1ea86bb1.getState(editorState)?.getConfigWithNodeInfo?.(editorState) ?? undefined : undefined;
            return {
                configWithNodeInfo: configWithNodeInfo,
                floatingToolbarData: (0, $3v3t0.pluginKey).getState(editorState)
            };
        },
        contentComponent ({ popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView, providerFactory: providerFactory, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $gt9Am.jsx)($b1b0f95ea4c121e3$export$2dda1e4a1d1f6a81, {
                editorView: editorView,
                pluginInjectionApi: api,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                providerFactory: providerFactory,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent
            });
        }
    };
};
function $b1b0f95ea4c121e3$export$2dda1e4a1d1f6a81({ pluginInjectionApi: pluginInjectionApi, editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, providerFactory: providerFactory, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
    const { floatingToolbarState: floatingToolbarState, editorDisabledState: editorDisabledState, editorViewModeState: editorViewModeState, userIntentState: userIntentState, blockControlsState: // @ts-expect-error - excluded from FloatingToolbarPlugin dependencies to avoid circular dependency
    blockControlsState } = (0, $bSToC.useSharedPluginState)(pluginInjectionApi, [
        'floatingToolbar',
        'editorDisabled',
        'editorViewMode',
        'userIntent',
        // @ts-expect-error - excluded from FloatingToolbarPlugin dependencies to avoid circular dependency
        'blockControls'
    ]);
    const { configWithNodeInfo: configWithNodeInfo, floatingToolbarData: floatingToolbarData } = floatingToolbarState ?? {};
    if ((0, $fNh22.isSSR)()) return null;
    if (!configWithNodeInfo || !configWithNodeInfo.config || typeof configWithNodeInfo.config?.visible !== 'undefined' && !configWithNodeInfo.config?.visible) return null;
    const userIntentEnabled = Boolean(pluginInjectionApi?.userIntent && (0, $9Letn.expValEqualsNoExposure)('platform_editor_lovability_user_intent', 'isEnabled', true));
    if ((userIntentState?.currentUserIntent === 'dragging' || userIntentState?.currentUserIntent === 'blockMenuOpen' && (0, $cbSL1.expValEquals)('platform_editor_block_menu', 'isEnabled', true) && (0, $eGOwo.fg)('platform_editor_block_menu_hide_floating_toolbar')) && !userIntentEnabled) return null;
    if (userIntentState?.currentUserIntent && $b1b0f95ea4c121e3$var$SUPPRESS_TOOLBAR_USER_INTENTS.includes(userIntentState?.currentUserIntent) && userIntentEnabled) return null;
    const { config: config, node: node } = configWithNodeInfo;
    // When the new inline editor-toolbar is enabled, suppress floating toolbar for text selections.
    if (Boolean(pluginInjectionApi?.toolbar)) {
        const selection = editorView.state.selection;
        const isCellSelection = '$anchorCell' in selection && !selection.empty;
        const isTextSelected = selection instanceof (0, $3lIcL.TextSelection) && !selection.empty;
        // don't dismiss table toolbar when a cell selection is caused by clicking the drag handle (which has it's own userIntent)
        if ((0, $eGOwo.fg)('platform_editor_toolbar_aifc_user_intent_fix')) {
            if (isTextSelected && config.className !== 'hyperlink-floating-toolbar' || isCellSelection && userIntentState?.currentUserIntent === 'default') return null;
        } else {
            if (isTextSelected && config.className !== 'hyperlink-floating-toolbar' || isCellSelection) return null;
        }
    }
    let { items: items } = config;
    const { groupLabel: groupLabel } = config;
    const { title: title, getDomRef: getDomRef = $b1b0f95ea4c121e3$var$getDomRefFromSelection, align: align = 'center', className: className = '', height: height, width: width, zIndex: zIndex, offset: offset = [
        0,
        12
    ], forcePlacement: forcePlacement, preventPopupOverflow: preventPopupOverflow, onPositionCalculated: onPositionCalculated, absoluteOffset: absoluteOffset = {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
    }, focusTrap: focusTrap, mediaAssistiveMessage: mediaAssistiveMessage = '', stick: stick = true } = config;
    const targetRef = getDomRef(editorView, dispatchAnalyticsEvent);
    const isEditorDisabled = editorDisabledState && editorDisabledState.editorDisabled;
    const isInViewMode = editorViewModeState?.mode === 'view';
    if (!targetRef || isEditorDisabled && !isInViewMode) return null;
    // TODO: MODES-3950 - Update this view mode specific logic once we refactor view mode.
    //       We should inverse the responsibility here: A blacklist for toolbar items in view mode, rather than this white list.
    //       Also consider moving this logic to the more specific toolbar plugins (media and selection).
    const iterableItems = Array.isArray(items) ? items : items?.(node);
    if (isInViewMode) {
        // Typescript note: Not all toolbar item types have the `supportsViewMode` prop.
        const toolbarItemViewModeProp = 'supportsViewMode';
        items = iterableItems.filter((item)=>toolbarItemViewModeProp in item && !!item[toolbarItemViewModeProp]);
    }
    if ((0, $jx6gl.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar))) {
        // Consolidate floating toolbar items
        const toolbarItemsArray = Array.isArray(items) ? items : items?.(node);
        const overflowDropdownItems = toolbarItemsArray.filter((item)=>item.type === 'overflow-dropdown');
        if (overflowDropdownItems.length > 1) {
            const consolidatedOverflowDropdown = (0, $jFFUB.consolidateOverflowDropdownItems)(overflowDropdownItems);
            const otherItems = toolbarItemsArray.filter((item)=>item.type !== 'overflow-dropdown');
            if (otherItems.length > 0) // remove the last separators
            while(otherItems.at(-1)?.type === 'separator')otherItems.pop();
            items = [
                ...otherItems,
                {
                    type: 'separator',
                    fullHeight: true,
                    supportsViewMode: true
                },
                consolidatedOverflowDropdown
            ];
        }
        // Apply analytics to dropdown
        if (overflowDropdownItems.length > 0 && dispatchAnalyticsEvent) {
            const currentItems = Array.isArray(items) ? items : items?.(node);
            const updatedItems = currentItems.map((item)=>{
                if (item.type !== 'overflow-dropdown') return item;
                const originalOnClick = item.onClick;
                return {
                    ...item,
                    onClick: ()=>{
                        const editorContentMode = pluginInjectionApi?.editorViewMode?.sharedState.currentState()?.mode;
                        dispatchAnalyticsEvent({
                            action: (0, $bMFKb.ACTION).CLICKED,
                            actionSubject: (0, $bMFKb.ACTION_SUBJECT).BUTTON,
                            actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FLOATING_TOOLBAR_OVERFLOW,
                            eventType: (0, $bMFKb.EVENT_TYPE).UI,
                            attributes: {
                                editorContentMode: editorContentMode
                            }
                        });
                        // Call original onClick if it exists
                        originalOnClick?.();
                    }
                };
            });
            items = updatedItems;
        }
    }
    let customPositionCalculation;
    const toolbarItems = pluginInjectionApi?.copyButton?.actions.processCopyButtonItems(editorView.state)(Array.isArray(items) ? items : items(node), pluginInjectionApi?.decorations?.actions.hoverDecoration);
    if (onPositionCalculated) customPositionCalculation = (nextPos)=>{
        return onPositionCalculated(editorView, nextPos);
    };
    const dispatchCommand = (fn)=>fn && fn(editorView.state, editorView.dispatch, editorView);
    // Confirm dialog
    let confirmButtonItem;
    if ((0, $eGOwo.fg)('platform_editor_fix_confirm_table_removal')) {
        const { confirmDialogForItem: confirmDialogForItem, confirmDialogForItemOption: confirmDialogForItemOption } = floatingToolbarData || {};
        const matchingItem = confirmDialogForItem ? toolbarItems?.[confirmDialogForItem] : undefined;
        if (matchingItem?.type === 'button') confirmButtonItem = matchingItem;
        if (matchingItem?.type === 'overflow-dropdown' && confirmDialogForItemOption !== undefined) {
            const matchingItemOption = matchingItem.options[confirmDialogForItemOption];
            // OverflowDropdownOption is the only member of the union that does not have a 'type' property
            if (!('type' in matchingItemOption)) confirmButtonItem = matchingItemOption;
        }
    } else {
        const { confirmDialogForItem: confirmDialogForItem } = floatingToolbarData || {};
        confirmButtonItem = confirmDialogForItem ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        toolbarItems[confirmDialogForItem] : undefined;
    }
    const scrollable = config.scrollable;
    const confirmDialogOptions = typeof confirmButtonItem?.confirmDialog === 'function' ? confirmButtonItem?.confirmDialog() : confirmButtonItem?.confirmDialog;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $28ffc.ErrorBoundary), {
        component: (0, $bMFKb.ACTION_SUBJECT).FLOATING_TOOLBAR_PLUGIN,
        componentId: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))(title),
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        fallbackComponent: null,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $avm98.default), {
                ariaLabel: title,
                role: (0, $eGOwo.fg)('platform_editor_a11y_add_role_to_popup') ? 'toolbar' : undefined,
                offset: offset,
                target: targetRef,
                alignY: "bottom",
                forcePlacement: forcePlacement,
                fitHeight: height,
                fitWidth: width,
                absoluteOffset: absoluteOffset,
                alignX: align,
                stick: stick,
                zIndex: zIndex,
                mountTo: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement,
                onPositionCalculated: customPositionCalculation,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: scrollable ? {
                    maxWidth: '100%'
                } : {},
                focusTrap: focusTrap,
                preventOverflow: preventPopupOverflow,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4sxxB.WithProviders), {
                    providerFactory: providerFactory,
                    providers: [
                        'extensionProvider'
                    ],
                    renderNode: (providers)=>{
                        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $28qTE.default), {
                            target: targetRef,
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            items: toolbarItems,
                            groupLabel: groupLabel,
                            node: node,
                            dispatchCommand: dispatchCommand,
                            editorView: editorView,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                            className: className,
                            focusEditor: ()=>editorView.focus(),
                            providerFactory: providerFactory,
                            popupsMountPoint: popupsMountPoint,
                            popupsBoundariesElement: popupsBoundariesElement,
                            popupsScrollableElement: popupsScrollableElement,
                            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                            extensionsProvider: providers.extensionProvider,
                            scrollable: scrollable,
                            api: pluginInjectionApi,
                            mediaAssistiveMessage: mediaAssistiveMessage
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hNNR4.ConfirmationModal), {
                testId: "ak-floating-toolbar-confirmation-modal",
                options: confirmDialogOptions,
                onConfirm: (isChecked = false)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    if (!!confirmDialogOptions.onConfirm) // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dispatchCommand(confirmDialogOptions.onConfirm(isChecked));
                    else // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dispatchCommand(confirmButtonItem.onClick);
                },
                onClose: ()=>{
                    dispatchCommand((0, $bYdnm.hideConfirmDialog)());
                    // Need to set focus to Editor here,
                    // As when the Confirmation dialog pop up, and user interacts with the dialog, Editor loses focus.
                    // So when Confirmation dialog is closed, Editor does not have the focus, then cursor goes to the position 1 of the doc,
                    // instead of the cursor position before the dialog pop up.
                    if (!editorView.hasFocus()) editorView.focus();
                }
            })
        ]
    });
}
const $b1b0f95ea4c121e3$export$18d4026d1ea86bb1 = new (0, $3lIcL.PluginKey)('floatingToolbarPluginKey');
/**
 * Clean up floating toolbar configs from undesired properties.
 */ function $b1b0f95ea4c121e3$var$sanitizeFloatingToolbarConfig(config) {
    // Cleanup from non existing node types
    if (Array.isArray(config.nodeType)) return {
        ...config,
        nodeType: config.nodeType.filter($b1b0f95ea4c121e3$var$filterUndefined)
    };
    return config;
}
function $b1b0f95ea4c121e3$export$5c1ec0ef773ca0cc(options) {
    const { floatingToolbarHandlers: floatingToolbarHandlers, providerFactory: providerFactory, getIntl: getIntl, api: api } = options;
    const intl = getIntl();
    const getConfigWithNodeInfo = (editorState)=>{
        let activeConfigs = [];
        for(let index = 0; index < floatingToolbarHandlers.length; index++){
            const handler = floatingToolbarHandlers[index];
            const config = handler(editorState, intl, providerFactory, activeConfigs);
            if (config) {
                const userIntentEnabled = Boolean(api?.userIntent && (0, $9Letn.expValEqualsNoExposure)('platform_editor_lovability_user_intent', 'isEnabled', true));
                if (config.__suppressAllToolbars && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') && !userIntentEnabled) {
                    activeConfigs = undefined;
                    break;
                }
                if (userIntentEnabled && $b1b0f95ea4c121e3$var$SUPPRESS_TOOLBAR_USER_INTENTS.includes(api?.userIntent?.sharedState.currentState()?.currentUserIntent || '')) {
                    activeConfigs = undefined;
                    break;
                }
                activeConfigs.push($b1b0f95ea4c121e3$var$sanitizeFloatingToolbarConfig(config));
            }
        }
        const relevantConfig = activeConfigs && $b1b0f95ea4c121e3$export$c5f0b4d19f5b8d4b(editorState.selection, activeConfigs);
        return relevantConfig;
    };
    const getIsToolbarSuppressed = (editorState)=>{
        const userIntentEnabled = Boolean(api?.userIntent && (0, $9Letn.expValEqualsNoExposure)('platform_editor_lovability_user_intent', 'isEnabled', true));
        if (userIntentEnabled) return false;
        for(let index = 0; index < floatingToolbarHandlers.length; index++){
            const handler = floatingToolbarHandlers[index];
            const config = handler(editorState, intl, providerFactory);
            if (config?.__suppressAllToolbars) return true;
        }
        return false;
    };
    const apply = ()=>{
        const newPluginState = {
            getConfigWithNodeInfo: getConfigWithNodeInfo
        };
        return newPluginState;
    };
    return new (0, $i8KtF.SafePlugin)({
        key: $b1b0f95ea4c121e3$export$18d4026d1ea86bb1,
        state: {
            init: ()=>{
                return {
                    getConfigWithNodeInfo: getConfigWithNodeInfo
                };
            },
            apply: (0, $cbSL1.expValEquals)('platform_editor_lovability_suppress_toolbar_event', 'isEnabled', true) ? (_tr, _pluginState, __oldEditorState, newEditorState)=>{
                const suppressedToolbar = getIsToolbarSuppressed(newEditorState);
                const newPluginState = {
                    getConfigWithNodeInfo: getConfigWithNodeInfo,
                    suppressedToolbar: suppressedToolbar
                };
                return newPluginState;
            } : apply
        },
        view: (0, $cbSL1.expValEquals)('platform_editor_lovability_suppress_toolbar_event', 'isEnabled', true) ? ()=>{
            return {
                update: (view, prevState)=>{
                    const pluginState = $b1b0f95ea4c121e3$export$18d4026d1ea86bb1.getState(view.state);
                    const prevPluginState = $b1b0f95ea4c121e3$export$18d4026d1ea86bb1.getState(prevState);
                    if (pluginState?.suppressedToolbar && !prevPluginState?.suppressedToolbar) api?.analytics?.actions?.fireAnalyticsEvent({
                        action: (0, $bMFKb.ACTION).SUPPRESSED,
                        actionSubject: (0, $bMFKb.ACTION_SUBJECT).FLOATING_TOOLBAR_PLUGIN,
                        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FLOATING_TOOLBAR,
                        eventType: (0, $bMFKb.EVENT_TYPE).TRACK
                    });
                }
            };
        } : undefined
    });
}

});
parcelRegister("28ffc", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $5cc3db7d4b1c17d6$export$e926676385687eaf);

var $eJOHy = parcelRequire("eJOHy");

var $bMFKb = parcelRequire("bMFKb");

var $djRdf = parcelRequire("djRdf");
class $5cc3db7d4b1c17d6$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.dispatchAnalyticsEvent) this.props.dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).EDITOR_CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: error,
                errorInfo: errorInfo,
                errorRethrown: !this.hasFallback()
            }
        });
        (0, $djRdf.logException)(error, {
            location: 'editor-common'
        });
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        });
    }
    render() {
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            errorCaptured: false
        };
    }
}

});

parcelRegister("bSToC", function(module, exports) {
$parcel$export(module.exports, "useSharedPluginState", () => $b02d4f6815d6953c$export$a4c4fd90e2b72baa);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");
/**
 *
 * Directly map object values
 *
 * @param object The object to transform
 * @param mapFunction The function to map an old value to new one
 * @returns Object with the same key but transformed values
 *
 */ function $b02d4f6815d6953c$var$mapValues(object, mapFunction) {
    return Object.entries(object).reduce((acc, [key, value])=>({
            ...acc,
            [key]: mapFunction(value)
        }), {});
}
// When we use the `useSharedPluginState` example: `useSharedPluginState(api, ['width'])`
// it will re-render every time the component re-renders as the array "['width']" is seen as an update.
// This hook is used to prevent re-renders due to this.
function $b02d4f6815d6953c$var$useStaticPlugins(plugins) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $eJOHy.useMemo)(()=>plugins, []);
}
function $b02d4f6815d6953c$export$a4c4fd90e2b72baa(injectionApi, plugins, options) {
    const pluginNames = $b02d4f6815d6953c$var$useStaticPlugins(plugins);
    // Create a memoized object containing the named plugins
    const namedExternalPlugins = (0, $eJOHy.useMemo)(()=>pluginNames.reduce((acc, pluginName)=>({
                ...acc,
                [`${String(pluginName)}State`]: injectionApi?.[pluginName]
            }), {}), [
        injectionApi,
        pluginNames
    ]);
    return $b02d4f6815d6953c$var$useSharedPluginStateInternal(namedExternalPlugins, options);
}
function $b02d4f6815d6953c$var$useSharedPluginStateInternal(externalPlugins, options = {}) {
    const [pluginStates, setPluginState] = (0, $eJOHy.useState)($b02d4f6815d6953c$var$mapValues(externalPlugins, (value)=>options.disabled ? undefined : value?.sharedState.currentState()));
    const refStates = (0, $eJOHy.useRef)({});
    const mounted = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (options.disabled) return;
        const debouncedPluginStateUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(()=>{
            setPluginState((currentPluginStates)=>({
                    ...currentPluginStates,
                    ...refStates.current
                }));
        });
        // If we re-render this hook due to a change in the external
        // plugins we need to push a state update to ensure we have
        // the most current state.
        if (mounted.current) {
            refStates.current = $b02d4f6815d6953c$var$mapValues(externalPlugins, (value)=>value?.sharedState.currentState());
            debouncedPluginStateUpdate();
        }
        const unsubs = Object.entries(externalPlugins).map(([pluginKey, externalPlugin])=>{
            return externalPlugin?.sharedState.onChange(({ nextSharedState: nextSharedState, prevSharedState: prevSharedState })=>{
                if (prevSharedState === nextSharedState) return;
                refStates.current[pluginKey] = nextSharedState;
                debouncedPluginStateUpdate();
            });
        });
        mounted.current = true;
        return ()=>{
            refStates.current = {};
            unsubs.forEach((cb)=>cb?.());
        };
    // Do not re-render due to state changes, we only need to check this when
    // setting up the initial subscription.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        externalPlugins,
        options.disabled
    ]);
    return pluginStates;
}

});

parcelRegister("h9coN", function(module, exports) {
$parcel$export(module.exports, "copyNode", () => $70d8ebd0ac083768$export$978ef9948557240e);

var $7EdFW = parcelRequire("7EdFW");

var $58hN2 = parcelRequire("58hN2");

var $e5Nsc = parcelRequire("e5Nsc");

var $3lIcL = parcelRequire("3lIcL");

var $cbSL1 = parcelRequire("cbSL1");

var $9Letn = parcelRequire("9Letn");
const $70d8ebd0ac083768$export$978ef9948557240e = (nodeType, editorAnalyticsApi, inputMethod)=>({ tr: tr })=>{
        // const { tr, schema } = state;
        // This command should only be triggered by the Copy button in the floating toolbar
        // which is only visible when selection is inside the target node
        const contentNodeWithPos = (0, $e5Nsc.getSelectedNodeOrNodeParentByNodeType)({
            nodeType: nodeType,
            selection: tr.selection
        });
        if (!contentNodeWithPos) return tr;
        const schema = tr.doc.type.schema;
        const copyToClipboardTr = tr;
        const domNode = (0, $e5Nsc.toDOM)(contentNodeWithPos.node, schema);
        if ((0, $9Letn.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true)) (0, $e5Nsc.copyDomNode)(domNode, contentNodeWithPos.node.type, tr.selection);
        else if (domNode) {
            const div = document.createElement('div');
            const browser = (0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $7EdFW.getBrowserInfo)() : (0, $7EdFW.browser);
            div.appendChild(domNode);
            // if copying inline content
            if (contentNodeWithPos.node.type.inlineContent) // The "1 1" refers to the start and end depth of the slice
            // since we're copying the text inside a paragraph, it will always be 1 1
            // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            div.firstChild.setAttribute('data-pm-slice', '1 1 []');
            else // The "0 0" refers to the start and end depth of the slice
            // since we're copying the block node only, it will always be 0 0
            // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            div.firstChild.setAttribute('data-pm-slice', '0 0 []');
            // ED-17083 safari seems have bugs for extension copy because exntension do not have a child text(innerText) and it will not recognized as html in clipboard, this could be merge into one if this extension fixed children issue or safari fix the copy bug
            // MEX-2528 safari has a bug related to the mediaSingle node with border or link. The image tag within the clipboard is not recognized as HTML when using the ClipboardItem API. To address this, we have to switch to ClipboardPolyfill
            if (browser.safari && tr.selection instanceof (0, $3lIcL.NodeSelection) && (tr.selection.node.type === schema.nodes.extension || tr.selection.node.type === schema.nodes.mediaSingle)) (0, $58hN2.copyHTMLToClipboardPolyfill)(div);
            else (0, $58hN2.copyHTMLToClipboard)(div);
        }
        if (editorAnalyticsApi) {
            const analyticsPayload = (0, $58hN2.getNodeCopiedAnalyticsPayload)(contentNodeWithPos.node, inputMethod);
            editorAnalyticsApi.attachAnalyticsEvent(analyticsPayload)(copyToClipboardTr);
        }
        copyToClipboardTr.setMeta('scrollIntoView', false);
        return copyToClipboardTr;
    };

});

parcelRegister("cIMBE", function(module, exports) {
$parcel$export(module.exports, "default", () => $6186217194205868$export$2e2bcd8739ae039);
$parcel$export(module.exports, "forceFocusSelector", () => $6186217194205868$export$1470545de94762f5);
$parcel$export(module.exports, "checkShouldForceFocusAndApply", () => $6186217194205868$export$a2ced8424a9be595);

var $i8KtF = parcelRequire("i8KtF");

var $3lIcL = parcelRequire("3lIcL");
const $6186217194205868$export$ded15a80767f6af7 = new (0, $3lIcL.PluginKey)('forceFocusStatePlugin');
var /**
 * Used in cases where a floating toolbar button opens a submenu which destroys
 * the button, but the user has pressed ESC to close the submenu and focus needs
 * to move back to the button. */ $6186217194205868$export$2e2bcd8739ae039 = ()=>new (0, $i8KtF.SafePlugin)({
        key: $6186217194205868$export$ded15a80767f6af7,
        state: {
            init: ()=>({
                    selector: null
                }),
            apply: (tr, prevState)=>{
                const meta = tr.getMeta($6186217194205868$export$ded15a80767f6af7);
                if (meta && 'selector' in meta) return {
                    selector: meta.selector
                };
                return prevState;
            }
        }
    });
const $6186217194205868$export$1470545de94762f5 = (selector)=>(tr)=>{
        return tr.setMeta($6186217194205868$export$ded15a80767f6af7, {
            selector: selector
        });
    };
function $6186217194205868$export$a2ced8424a9be595(view) {
    const state = view?.state;
    if (state) {
        const { selector: selector } = $6186217194205868$export$ded15a80767f6af7.getState(state);
        if (selector) {
            const focusableElement = document.querySelector(selector);
            if (focusableElement) {
                focusableElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                focusableElement.focus();
                const { state: { tr: tr }, dispatch: dispatch } = view;
                dispatch($6186217194205868$export$1470545de94762f5(null)(tr));
            }
        }
    }
}

});

parcelRegister("bYdnm", function(module, exports) {
$parcel$export(module.exports, "showConfirmDialog", () => $2ab9456e5c0e5923$export$c0076bd4afc29e7a);
$parcel$export(module.exports, "hideConfirmDialog", () => $2ab9456e5c0e5923$export$5a3c1357cfd1045c);

var $dZNtB = parcelRequire("dZNtB");
const $2ab9456e5c0e5923$export$c0076bd4afc29e7a = (buttonIndex, optionIndex)=>(0, $dZNtB.createCommand)({
        type: 'SHOW_CONFIRM_DIALOG',
        data: {
            buttonIndex: buttonIndex,
            optionIndex: optionIndex
        }
    }, (tr)=>tr.setMeta('addToHistory', false));
const $2ab9456e5c0e5923$export$5a3c1357cfd1045c = ()=>(0, $dZNtB.createCommand)({
        type: 'HIDE_CONFIRM_DIALOG'
    }, (tr)=>tr.setMeta('addToHistory', false));

});
parcelRegister("dZNtB", function(module, exports) {
$parcel$export(module.exports, "createPluginState", () => $d5d414125912cd48$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $d5d414125912cd48$export$8d4021544bdece00);

var $bazog = parcelRequire("bazog");

var $3v3t0 = parcelRequire("3v3t0");

var $5fIEN = parcelRequire("5fIEN");
const { createPluginState: $d5d414125912cd48$export$656c7661095efe2e, createCommand: $d5d414125912cd48$export$8d4021544bdece00, getPluginState: $d5d414125912cd48$export$f05434c51e3762e } = (0, $bazog.pluginFactory)((0, $3v3t0.pluginKey), (0, $5fIEN.reducer));

});
parcelRegister("3v3t0", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $5705c173e2bd1077$export$18d4026d1ea86bb1);

var $3lIcL = parcelRequire("3lIcL");
const $5705c173e2bd1077$export$18d4026d1ea86bb1 = new (0, $3lIcL.PluginKey)('floatingToolbarData');

});

parcelRegister("5fIEN", function(module, exports) {
$parcel$export(module.exports, "reducer", () => $54989e4408e8c6c4$export$1650419e431d3ba3);
const $54989e4408e8c6c4$export$1650419e431d3ba3 = (pluginState, action)=>{
    switch(action.type){
        case 'SHOW_CONFIRM_DIALOG':
            return {
                ...pluginState,
                confirmDialogForItem: action.data.buttonIndex,
                confirmDialogForItemOption: action.data.optionIndex
            };
        case 'HIDE_CONFIRM_DIALOG':
            return {
                ...pluginState,
                confirmDialogForItem: undefined
            };
        default:
            return pluginState;
    }
};

});



parcelRegister("2M0rW", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $5fa7b329811e3008$export$ae829ec7b2625219);

var $i8KtF = parcelRequire("i8KtF");

var $dZNtB = parcelRequire("dZNtB");

var $3v3t0 = parcelRequire("3v3t0");
const $5fa7b329811e3008$export$ae829ec7b2625219 = (dispatch)=>{
    return new (0, $i8KtF.SafePlugin)({
        state: (0, $dZNtB.createPluginState)(dispatch, {}),
        key: (0, $3v3t0.pluginKey)
    });
};

});

parcelRegister("ho7Ph", function(module, exports) {
$parcel$export(module.exports, "findNode", () => $97cced9edf09bb43$export$5b92d7a8b5d33ee2);
function $97cced9edf09bb43$export$5b92d7a8b5d33ee2(parent, predicate) {
    let matchedNode;
    parent.descendants((node)=>{
        // dont run predicate if node already found
        if (matchedNode) return false;
        if (predicate(node)) {
            matchedNode = node;
            return false;
        }
        return true;
    });
    return matchedNode;
}

});

parcelRegister("hNNR4", function(module, exports) {
$parcel$export(module.exports, "ConfirmationModal", () => $490644b4f8b9075d$export$1f33f980da756c46);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6YFG2 = parcelRequire("6YFG2");

var $956it = parcelRequire("956it");

var $ils3V = parcelRequire("ils3V");

var $hhZ9w = parcelRequire("hhZ9w");
const $490644b4f8b9075d$var$ConfirmationModalImpl = (props)=>{
    const { options: options } = props;
    const renderModel = (isReferentialityDialog = false)=>// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        isReferentialityDialog ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ils3V.CheckboxModal), {
            ...props
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hhZ9w.SimpleModal), {
            ...props
        });
    return options ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $956it.default), {
        children: renderModel(options?.isReferentialityDialog)
    }) : null;
};
const $490644b4f8b9075d$export$1f33f980da756c46 = (0, $6YFG2.default)($490644b4f8b9075d$var$ConfirmationModalImpl);

});
parcelRegister("ils3V", function(module, exports) {
$parcel$export(module.exports, "CheckboxModal", () => $9bebfd3a35e9a96e$export$9c828de50258a892);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");

var $86tBw = parcelRequire("86tBw");

var $jn2od = parcelRequire("jn2od");

var $gHHv2 = parcelRequire("gHHv2");
var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $eGOwo = parcelRequire("eGOwo");

var $3cMgR = parcelRequire("3cMgR");
const $9bebfd3a35e9a96e$export$9c828de50258a892 = (props)=>{
    const [isChecked, setCheckbox] = (0, $eJOHy.useState)(false);
    const { onConfirm: onConfirm, onClose: onClose, options: options, intl: { formatMessage: formatMessage }, testId: testId } = props;
    const heading = options?.title || formatMessage((0, $jn2od.default).confirmModalDefaultHeading);
    const okButtonLabel = options?.okButtonLabel || formatMessage((0, $jn2od.default).confirmModalOK);
    const cancelButtonLabel = options?.cancelButtonLabel || formatMessage((0, $jn2od.default).confirmModalCancel);
    const checkboxlabel = options?.checkboxLabel;
    const childrenInfo = options?.getChildrenInfo?.();
    const ListComponent = ({ nodes: nodes })=>{
        if (nodes.length === 0) return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)("ul", {
            children: nodes.map((node)=>// Ignored via go/ees005
                // eslint-disable-next-line react/jsx-props-no-spreading
                /*#__PURE__*/ (0, $eJOHy.createElement)(ListItem, {
                    ...node,
                    key: node.id
                }))
        });
    };
    const ListItem = (props)=>{
        const { id: id, name: name, amount: amount } = props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)("li", {
            id: id,
            children: formatMessage((0, $jn2od.default).confirmModalListUnit, {
                name: name,
                amount: amount
            })
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gHHv2.default), {
        onClose: onClose,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2qG7I.default), {
                hasCloseButton: (0, $eGOwo.fg)('platform_editor_update_modal_close_button'),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5a9Ro.default), {
                    appearance: "warning",
                    children: heading
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $ik0CA.default), {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                        as: "p",
                        children: options?.message
                    }),
                    !!childrenInfo?.length && /*#__PURE__*/ (0, $gt9Am.jsx)(ListComponent, {
                        nodes: childrenInfo
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                        as: "p",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $86tBw.default), {
                            isChecked: isChecked,
                            onChange: ()=>setCheckbox(!isChecked),
                            label: checkboxlabel,
                            testId: testId ? `${testId}-checkbox` : undefined
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $kseeK.default), {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                        appearance: "default",
                        onClick: onClose,
                        testId: testId ? `${testId}-cancel-button` : undefined,
                        children: cancelButtonLabel
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                        appearance: "warning",
                        onClick: ()=>{
                            onConfirm(isChecked);
                            onClose();
                        },
                        testId: testId ? `${testId}-confirm-button` : undefined,
                        children: okButtonLabel
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("jn2od", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a3c8b280992071c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $2a3c8b280992071c$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    confirmModalDefaultHeading: {
        id: 'fabric.editor.floatingToolbar.confirmModalHeading',
        defaultMessage: 'Are you sure?',
        description: 'Default heading of floating toolbar confirmation modal.'
    },
    confirmModalOK: {
        id: 'fabric.editor.floatingToolbar.confirmModalOK',
        defaultMessage: 'OK',
        description: 'OK button for floating toolbar confirmation modal.'
    },
    confirmModalCancel: {
        id: 'fabric.editor.floatingToolbar.confirmModalCancel',
        defaultMessage: 'Cancel',
        description: 'Cancel button for floating toolbar confirmation modal.'
    },
    confirmModalListUnit: {
        id: 'fabric.editor.floatingToolbar.confirmModalConnectedUnit',
        defaultMessage: '{name}{amount, plural, =0 {} one { (+1 connected element)} other { (+# connected elements)}}',
        description: 'Text displayed in confirmation modal which highlights the nodes and the amount of connected nodes that will be deleted'
    },
    confirmDeleteLinkedModalMessage: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalMessage',
        defaultMessage: 'Deleting {nodeName} will break anything connected to it.',
        description: 'Message for confirm modal when deleting a extension linked to an data consumer.'
    },
    floatingToolbarAriaLabel: {
        id: 'fabric.editor.floatingToolbar.floatingToolbarAriaLabel',
        defaultMessage: 'Floating Toolbar',
        description: "a floating toolbar's aria label"
    },
    floatingToolbarAnnouncer: {
        id: 'fabric.editor.floatingToolbar.floatingToolbarAnnouncer',
        defaultMessage: 'Floating toolbar controls have been opened',
        description: 'message that will be announced to screenreaders that the floating toolbar is opened'
    },
    floatingToolbarScrollLeft: {
        id: 'fabric.editor.floatingToolbar.scrollLeft',
        defaultMessage: 'Scroll left',
        description: 'Button to scroll left when the toolbar is in the overflow state'
    },
    floatingToolbarScrollRight: {
        id: 'fabric.editor.floatingToolbar.scrollRight',
        defaultMessage: 'Scroll right',
        description: 'Button to scroll right when the toolbar is in the overflow state'
    }
});

});


parcelRegister("hhZ9w", function(module, exports) {
$parcel$export(module.exports, "SimpleModal", () => $4ae2a3c0a4fe208b$export$f96c193e316d2274);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");

var $jn2od = parcelRequire("jn2od");

var $gHHv2 = parcelRequire("gHHv2");
var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $eGOwo = parcelRequire("eGOwo");

var $3cMgR = parcelRequire("3cMgR");
const $4ae2a3c0a4fe208b$export$f96c193e316d2274 = (props)=>{
    const { onConfirm: onConfirm, onClose: onClose, options: options, intl: { formatMessage: formatMessage }, testId: testId } = props;
    const heading = options?.title || formatMessage((0, $jn2od.default).confirmModalDefaultHeading);
    const okButtonLabel = options?.okButtonLabel || formatMessage((0, $jn2od.default).confirmModalOK);
    const cancelButtonLabel = options?.cancelButtonLabel || formatMessage((0, $jn2od.default).confirmModalCancel);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gHHv2.default), {
        onClose: onClose,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2qG7I.default), {
                hasCloseButton: (0, $eGOwo.fg)('platform_editor_update_modal_close_button'),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5a9Ro.default), {
                    appearance: "warning",
                    children: heading
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ik0CA.default), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                    as: "p",
                    children: options?.message
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $kseeK.default), {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                        appearance: "default",
                        onClick: onClose,
                        testId: testId ? `${testId}-cancel-button` : undefined,
                        children: cancelButtonLabel
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                        appearance: "warning",
                        onClick: ()=>{
                            onConfirm();
                            onClose();
                        },
                        testId: testId ? `${testId}-confirm-button` : undefined,
                        children: okButtonLabel
                    })
                ]
            })
        ]
    });
};

});


parcelRegister("28qTE", function(module, exports) {
$parcel$export(module.exports, "default", () => $71cc83e474c44c13$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation */ /**
                                                                                                            * @jsxRuntime classic
                                                                                                            * @jsx jsx
                                                                                                            */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");

var $48q59 = parcelRequire("48q59");

var $1RDZu = parcelRequire("1RDZu");
var $jn2od = parcelRequire("jn2od");

var $h2yqz = parcelRequire("h2yqz");

var $jx6gl = parcelRequire("jx6gl");

var $bQBk1 = parcelRequire("bQBk1");
var $knwdo = parcelRequire("knwdo");
var $84CN8 = parcelRequire("84CN8");

var $a44PI = parcelRequire("a44PI");

var $9yYkI = parcelRequire("9yYkI");
var $baHgw = parcelRequire("baHgw");

var $kZPQ0 = parcelRequire("kZPQ0");

var $NByNW = parcelRequire("NByNW");

var $eGOwo = parcelRequire("eGOwo");

var $cbSL1 = parcelRequire("cbSL1");

var $cIMBE = parcelRequire("cIMBE");

var $bYdnm = parcelRequire("bYdnm");

var $9rPmE = parcelRequire("9rPmE");

var $ggPk9 = parcelRequire("ggPk9");

var $edTSk = parcelRequire("edTSk");

var $atGh8 = parcelRequire("atGh8");

var $f989C = parcelRequire("f989C");

var $jR93w = parcelRequire("jR93w");

var $Svvcf = parcelRequire("Svvcf");
function $71cc83e474c44c13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $71cc83e474c44c13$export$7abc8284d66f79b1(items, areAnyNewToolbarFlagsEnabled) {
    const groupItems = items.reduce((accumulator, item, i)=>{
        const { finalOutput: finalOutput, buttonGroup: buttonGroup } = accumulator;
        if (item.type === 'button') {
            const notLastItem = i < items.length - 1;
            const nextItemIsButton = items[i + 1] && items[i + 1].type === 'button';
            const wasPreviousButton = items[i - 1] && items[i - 1].type === 'button';
            const shouldBeRadioButton = notLastItem && nextItemIsButton || wasPreviousButton;
            // Only group as radio button if not explicitly set to false
            const isRadioButton = !(0, $cbSL1.expValEquals)('platform_editor_august_a11y', 'isEnabled', true) ? shouldBeRadioButton : shouldBeRadioButton && item.isRadioButton !== false;
            if (isRadioButton) {
                item.isRadioButton = true;
                buttonGroup.push(item);
                if (!nextItemIsButton && wasPreviousButton) {
                    finalOutput.push(buttonGroup);
                    accumulator.buttonGroup = [];
                }
            } else finalOutput.push(item);
        } else if (item.type === 'separator' && areAnyNewToolbarFlagsEnabled) {
            const isLeadingSeparator = i === 0;
            const isTrailingSeparator = i === items.length - 1;
            const isDuplicateSeparator = items[i - 1]?.type === 'separator';
            !isLeadingSeparator && !isTrailingSeparator && !isDuplicateSeparator && finalOutput.push(item);
        } else finalOutput.push(item);
        return accumulator;
    }, {
        buttonGroup: [],
        finalOutput: []
    });
    return groupItems.finalOutput;
}
const $71cc83e474c44c13$var$ToolbarItems = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ items: items, groupLabel: groupLabel, dispatchCommand: dispatchCommand, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, popupsScrollableElement: popupsScrollableElement, scrollable: scrollable, providerFactory: providerFactory, extensionsProvider: extensionsProvider, node: node, setDisableScroll: setDisableScroll, mountRef: mountRef, api: api, intl: intl })=>{
    const emojiAndColourPickerMountPoint = scrollable ? popupsMountPoint || editorView?.dom.closest('.fabric-editor-popup-scroll-parent') || editorView?.dom.closest('.ak-editor-content-area') || undefined : popupsMountPoint;
    const areAnyNewToolbarFlagsEnabled = (0, $jx6gl.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
    const renderItem = (item, idx)=>{
        switch(item.type){
            case 'button':
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const ButtonIcon = item.icon;
                const onClickHandler = ()=>{
                    if (item.confirmDialog) dispatchCommand((0, $bYdnm.showConfirmDialog)(idx));
                    else {
                        dispatchCommand(item.onClick);
                        if (item.focusEditoronEnter && !editorView?.hasFocus()) editorView?.focus();
                    }
                };
                const getIconColor = (disabled, selected)=>{
                    if (disabled) return "var(--ds-icon-disabled, #091E424F)";
                    if (selected) return "var(--ds-icon-selected, #0C66E4)";
                    return 'currentColor';
                };
                return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $knwdo.default), {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
                    className: item.className,
                    key: idx,
                    title: item.title,
                    href: item.href,
                    icon: item.icon ? item.iconFallback ? /*#__PURE__*/ (0, $1NIU8.jsx)(ButtonIcon, {
                        color: getIconColor(item.disabled, item.selected),
                        spacing: "spacious",
                        label: undefined,
                        LEGACY_fallbackIcon: item.iconFallback,
                        LEGACY_primaryColor: "currentColor",
                        Legacy_secondaryColor: "var(--ds-surface, #FFFFFF)",
                        "aria-hidden": true
                    }) : /*#__PURE__*/ (0, $1NIU8.jsx)(ButtonIcon, {
                        spacing: "spacious",
                        label: undefined,
                        "aria-hidden": true
                    }) : undefined,
                    iconAfter: item.iconAfter ? /*#__PURE__*/ (0, $1NIU8.jsx)(item.iconAfter, {
                        label: ""
                    }) : undefined,
                    appearance: item.appearance,
                    target: item.target,
                    onClick: onClickHandler,
                    onMouseEnter: ()=>dispatchCommand(item.onMouseEnter),
                    onMouseLeave: ()=>dispatchCommand(item.onMouseLeave),
                    onFocus: ()=>dispatchCommand(item.onFocus),
                    onBlur: ()=>dispatchCommand(item.onBlur),
                    onMount: item.onMount,
                    onUnmount: item.onUnmount,
                    selected: item.selected,
                    disabled: item.disabled,
                    tooltipContent: item.tooltipContent,
                    testId: item.testId,
                    hideTooltipOnClick: item.hideTooltipOnClick,
                    ariaHasPopup: item.ariaHasPopup,
                    tabIndex: item.tabIndex,
                    isRadioButton: item.isRadioButton,
                    ariaLabel: (0, $cbSL1.expValEquals)('platform_editor_floating_toolbar_button_aria_label', 'isEnabled', true) ? item?.ariaLabel : undefined,
                    pulse: item.pulse,
                    spotlightConfig: item.spotlightConfig,
                    interactionName: item.interactionName,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                }, item.showTitle && item.title);
            case 'input':
                return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $atGh8.Input), {
                    key: idx,
                    mountPoint: popupsMountPoint,
                    boundariesElement: popupsBoundariesElement,
                    defaultValue: item.defaultValue,
                    placeholder: item.placeholder,
                    onSubmit: (value)=>dispatchCommand(item.onSubmit(value)),
                    onBlur: (value)=>dispatchCommand(item.onBlur(value))
                });
            case 'custom':
                return item.render(editorView, idx, dispatchAnalyticsEvent);
            case 'overflow-dropdown':
                let options;
                if ((0, $eGOwo.fg)('platform_editor_fix_confirm_table_removal')) // if an option has a confirmDialog, we need to replace its onClick handler
                // to set the state to show the confirm dialog
                // crudely done here to avoid greater coupling with DropdownMenuItem from `floating-toolbar`
                // which would need knowledge of indexes, showConfirmDialog etc.
                options = item.options.map((option, optionIndex)=>{
                    if (!('type' in option) && option.confirmDialog) {
                        const onClick = option.confirmDialog ? (0, $bYdnm.showConfirmDialog)(idx, optionIndex) : option.onClick;
                        return {
                            ...option,
                            onClick: onClick
                        };
                    }
                    return option;
                });
                else options = item.options;
                return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $9rPmE.default), {
                    alignX: areAnyNewToolbarFlagsEnabled ? 'right' : undefined,
                    key: idx,
                    title: intl.formatMessage((0, $h2yqz.default).viewMore),
                    icon: /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($NByNW))), {
                        label: "",
                        spacing: "spacious"
                    }),
                    dispatchCommand: dispatchCommand,
                    options: options,
                    disabled: item.disabled,
                    tooltip: item.tooltip,
                    hideExpandIcon: true,
                    mountPoint: popupsMountPoint,
                    boundariesElement: popupsBoundariesElement,
                    scrollableElement: popupsScrollableElement,
                    dropdownWidth: item.dropdownWidth,
                    showSelected: item.showSelected,
                    buttonTestId: item.testId,
                    editorView: editorView,
                    setDisableParentScroll: scrollable ? setDisableScroll : undefined,
                    dropdownListId: item?.id && `${item.id}-dropdownList`,
                    alignDropdownWithToolbar: items.length === 1,
                    onClick: item.onClick,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                });
            case 'dropdown':
                const DropdownIcon = item.icon;
                const BeforeIcon = item.iconBefore;
                return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $9rPmE.default), {
                    key: idx,
                    title: item.title,
                    icon: DropdownIcon && /*#__PURE__*/ (0, $1NIU8.jsx)(DropdownIcon, {
                        label: item.title
                    }),
                    iconBefore: BeforeIcon && /*#__PURE__*/ (0, $1NIU8.jsx)(BeforeIcon, {
                        label: ""
                    }),
                    dispatchCommand: dispatchCommand,
                    options: item.options,
                    disabled: item.disabled,
                    tooltip: item.tooltip,
                    hideExpandIcon: item.hideExpandIcon,
                    mountPoint: popupsMountPoint,
                    boundariesElement: popupsBoundariesElement,
                    scrollableElement: popupsScrollableElement,
                    dropdownWidth: item.dropdownWidth,
                    showSelected: item.showSelected,
                    buttonTestId: item.testId,
                    editorView: editorView,
                    setDisableParentScroll: scrollable ? setDisableScroll : undefined,
                    dropdownListId: item?.id && `${item.id}-dropdownList`,
                    alignDropdownWithToolbar: items.length === 1,
                    onToggle: item.onToggle,
                    footer: item.footer,
                    onMount: item.onMount,
                    onClick: item.onClick,
                    pulse: item.pulse,
                    shouldFitContainer: item.shouldFitContainer,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                });
            case 'select':
                if (item.selectType === 'list') {
                    const ariaLabel = item.title || item.placeholder;
                    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $Svvcf.default), {
                        key: idx,
                        dispatchCommand: dispatchCommand,
                        options: item.options,
                        hideExpandIcon: item.hideExpandIcon,
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        mountPoint: scrollable ? mountRef.current : undefined,
                        boundariesElement: popupsBoundariesElement,
                        scrollableElement: popupsScrollableElement,
                        defaultValue: item.defaultValue,
                        placeholder: item.placeholder,
                        onChange: (selected)=>dispatchCommand(item.onChange(selected)),
                        ariaLabel: ariaLabel,
                        filterOption: item.filterOption,
                        setDisableParentScroll: scrollable ? setDisableScroll : undefined,
                        classNamePrefix: 'floating-toolbar-select'
                    });
                }
                if (item.selectType === 'color') return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $9yYkI.default), {
                    skipFocusButtonAfterPick: true,
                    key: idx,
                    isAriaExpanded: item.isAriaExpanded,
                    title: item.title,
                    onChange: (selected)=>{
                        dispatchCommand(item.onChange(selected));
                    },
                    colorPalette: item.options,
                    currentColor: item.defaultValue ? item.defaultValue.value : undefined,
                    placement: "Panels",
                    mountPoint: emojiAndColourPickerMountPoint,
                    setDisableParentScroll: scrollable ? setDisableScroll : undefined,
                    // Currently in floating toolbar, color picker is only
                    //  used in panel and table cell background color.
                    // Both uses same color palette.
                    // That's why hard-coding hexToEditorBackgroundPaletteColor
                    //  and paletteColorTooltipMessages.
                    // When we need to support different color palette
                    //  in floating toolbar, we need to set hexToPaletteColor
                    //  and paletteColorTooltipMessages in item options.
                    hexToPaletteColor: (0, $kZPQ0.hexToEditorBackgroundPaletteColor),
                    paletteColorTooltipMessages: (0, $a44PI.backgroundPaletteTooltipMessages),
                    returnEscToButton: item.returnEscToButton
                });
                if (item.selectType === 'emoji') return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $ggPk9.EmojiPickerButton), {
                    key: idx,
                    editorView: editorView,
                    title: item.title,
                    providerFactory: providerFactory,
                    isSelected: item.selected,
                    onChange: (selected)=>dispatchCommand(item.onChange(selected)),
                    mountPoint: emojiAndColourPickerMountPoint,
                    popupsBoundariesElement: popupsBoundariesElement,
                    setDisableParentScroll: scrollable ? setDisableScroll : undefined,
                    pluginInjectionApi: api
                });
                return null;
            case 'extensions-placeholder':
                if (!editorView || !extensionsProvider) return null;
                return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $edTSk.ExtensionsPlaceholder), {
                    key: idx,
                    node: node,
                    editorView: editorView,
                    extensionProvider: extensionsProvider,
                    separator: item.separator,
                    applyChangeToContextPanel: api?.contextPanel?.actions.applyChange,
                    extensionApi: api?.extension?.actions.api(),
                    dispatchCommand: dispatchCommand,
                    popupsMountPoint: popupsMountPoint,
                    popupsBoundariesElement: popupsBoundariesElement,
                    popupsScrollableElement: popupsScrollableElement,
                    alignDropdownWithToolbar: items.length === 1,
                    scrollable: scrollable,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                });
            case 'separator':
                if (areAnyNewToolbarFlagsEnabled) return item.fullHeight ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $84CN8.default), {
                    key: idx,
                    fullHeight: true,
                    areAnyNewToolbarFlagsEnabled: true
                }) : null;
                return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $84CN8.default), {
                    key: idx,
                    fullHeight: item.fullHeight,
                    areAnyNewToolbarFlagsEnabled: false
                });
        }
    };
    const groupedItems = $71cc83e474c44c13$export$7abc8284d66f79b1(items.filter((item)=>!item.hidden), areAnyNewToolbarFlagsEnabled);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $48q59.default), {
        testId: "editor-floating-toolbar-items"
    }, groupedItems.map((element, index)=>{
        const isGroup = Array.isArray(element);
        if (isGroup) return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            // Ignored via go/ees005
            // eslint-disable-next-line react/no-array-index-key
            key: index,
            css: areAnyNewToolbarFlagsEnabled ? $71cc83e474c44c13$var$buttonGroupStylesNew : $71cc83e474c44c13$var$buttonGroupStyles,
            role: "radiogroup",
            "aria-label": groupLabel ?? undefined,
            "data-testid": "editor-floating-toolbar-grouped-buttons"
        }, element.map((element)=>{
            const indexInAllItems = items.findIndex((item)=>item === element);
            return renderItem(element, indexInAllItems);
        }));
        else {
            const indexInAllItems = items.findIndex((item)=>item === element);
            return renderItem(element, indexInAllItems);
        }
    }));
}, (prevProps, nextProps)=>{
    if (!nextProps.node) return false;
    // only rerender toolbar items if the node is different
    // otherwise it causes an issue where multiple popups stays open
    return !(prevProps.node.type !== nextProps.node.type || prevProps.node.attrs.localId !== nextProps.node.attrs.localId || !(0, $1RDZu.areSameItems)(prevProps.items, nextProps.items) || !prevProps.mounted !== !nextProps.mounted);
});
const $71cc83e474c44c13$var$buttonGroupStyles = {
    name: "h1up05",
    styles: "display:flex;gap:var(--ds-space-050, 4px)"
};
const $71cc83e474c44c13$var$buttonGroupStylesNew = {
    name: "gcdzb",
    styles: "display:flex;gap:var(--ds-space-075, 6px)"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $71cc83e474c44c13$var$_ref6 = {
    name: "q568uz",
    styles: "min-height:var(--ds-space-500, 40px)"
};
var $71cc83e474c44c13$var$_ref7 = {
    name: "oxur4o",
    styles: "padding-left:var(--ds-space-050, 4px)"
};
var $71cc83e474c44c13$var$_ref8 = {
    name: "oxur4o",
    styles: "padding-left:var(--ds-space-050, 4px)"
};
var $71cc83e474c44c13$var$_ref9 = {
    name: "s0vnfv",
    styles: "height:32px"
};
var $71cc83e474c44c13$var$_ref0 = {
    name: "1k18kha",
    styles: "height:40px"
};
const $71cc83e474c44c13$var$toolbarContainer = (areAnyNewToolbarFlagsEnabled, scrollable, hasSelect, firstElementIsSelect)=>/*#__PURE__*/ (0, $1NIU8.css)({
        backgroundColor: "var(--ds-surface-overlay, white)",
        borderRadius: "var(--ds-radius-small, 3px)",
        boxShadow: `var(--ds-shadow-overlay, ${`0 0 1px rgba(9, 30, 66, 0.31), 0 4px 8px -2px rgba(9, 30, 66, 0.25)`})`,
        display: 'flex',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1,
        boxSizing: 'border-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > div > div': {
            alignItems: 'center'
        }
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    scrollable ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $1NIU8.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    hasSelect ? $71cc83e474c44c13$var$_ref0 : $71cc83e474c44c13$var$_ref9, "overflow:hidden;") : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    areAnyNewToolbarFlagsEnabled ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `${"var(--ds-space-0, 0)"} 4px ${"var(--ds-space-0, 0)"} 4px`
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    firstElementIsSelect && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    $71cc83e474c44c13$var$_ref8) : /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $1NIU8.css)({
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    firstElementIsSelect && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    $71cc83e474c44c13$var$_ref7), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    areAnyNewToolbarFlagsEnabled ? $71cc83e474c44c13$var$_ref6 : undefined);
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $71cc83e474c44c13$var$_ref = {
    name: "zjik7",
    styles: "display:flex"
};
var $71cc83e474c44c13$var$_ref2 = {
    name: "9kivhj",
    styles: "margin-left:var(--ds-space-100, 8px)"
};
var $71cc83e474c44c13$var$_ref3 = {
    name: "8gsxsd",
    styles: "margin-left:var(--ds-space-050, 4px)"
};
var $71cc83e474c44c13$var$_ref4 = {
    name: "upho8i",
    styles: "overflow-x:auto;overflow-y:hidden;scrollbar-width:none"
};
var $71cc83e474c44c13$var$_ref5 = {
    name: "d3v9zr",
    styles: "overflow:hidden"
};
const $71cc83e474c44c13$var$toolbarOverflow = ({ scrollable: scrollable, scrollDisabled: scrollDisabled, firstElementIsSelect: firstElementIsSelect, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>/*#__PURE__*/ (0, $1NIU8.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    scrollable ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $1NIU8.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    scrollDisabled ? $71cc83e474c44c13$var$_ref5 : $71cc83e474c44c13$var$_ref4, {
        WebkitOverflowScrolling: 'touch',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `${"var(--ds-space-050, 4px)"} 0 ${"var(--ds-space-050, 4px)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '> div:first-child': firstElementIsSelect ? $71cc83e474c44c13$var$_ref3 : $71cc83e474c44c13$var$_ref2,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '> div:last-child': {
                marginRight: "var(--ds-space-100, 8px)"
            }
        }
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    areAnyNewToolbarFlagsEnabled ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `${"var(--ds-space-0, 0)"} 4px ${"var(--ds-space-600, 48px)"} 4px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> div': {
            minHeight: "var(--ds-space-500, 40px)",
            gap: "var(--ds-space-075, 6px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '> div:first-child': {
                marginLeft: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '> div:last-child': {
                marginRight: 0
            }
        }
    }) : undefined) : $71cc83e474c44c13$var$_ref);
// eslint-disable-next-line @repo/internal/react/no-class-components
class $71cc83e474c44c13$var$Toolbar extends (0, $eJOHy.Component) {
    constructor(props){
        super(props), this.shouldHandleArrowKeys = ()=>{
            //To prevent the keydown handling of arrow keys for custom toolbar items with 'disableArrowNavigation' prop enabled,
            //Usually the button which has menus or popups
            return !this.props.items?.find((item)=>item.type === 'custom' && item.disableArrowNavigation);
        }, this.handleEscape = (event)=>{
            // If any menu is open inside the floating toolbar 'Esc' key should not
            // focus the editorview.
            // Event can't be stopped as they are not childnodes of floating toolbar
            const isDropdownOpen = !!document.querySelector('[data-role="droplistContent"]');
            const isSelectMenuOpen = !!document.querySelector('.floating-toolbar-select__menu');
            if (isDropdownOpen || isSelectMenuOpen) return;
            this.props.editorView?.focus();
            event.preventDefault();
            event.stopPropagation();
        }, this.captureMouseEvent = (event)=>{
            // Don't capture mouse event for custom toolbars e.g. insert hyperlink
            if (this.props.items?.length === 1 && this.props.items[0].type === 'custom') return;
            // Prevents toolbar from closing when clicking on the toolbar itself and not on the buttons
            event.stopPropagation();
            event.preventDefault();
        }, this.isShortcutToFocusToolbar = (event)=>{
            //Alt + F10 to reach first element in this floating toolbar
            return event.altKey && (event.key === 'F10' || event.keyCode === 121);
        };
        this.scrollContainerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef();
        this.mountRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef();
        this.toolbarContainerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef();
        this.state = {
            scrollDisabled: false,
            mounted: false
        };
    }
    // remove any decorations added by toolbar buttons i.e danger and selected styling
    // this prevents https://product-fabric.atlassian.net/browse/ED-10207
    resetStyling() {
        if (this.props.editorView) {
            const { state: state, dispatch: dispatch } = this.props.editorView;
            this.props.api?.decorations?.actions.removeDecoration(state, dispatch);
        }
    }
    setDisableScroll(disabled) {
        // wait before setting disabled state incase users jumping from one popup to another
        if (disabled) requestAnimationFrame(()=>{
            this.setState({
                scrollDisabled: disabled
            });
        });
        else this.setState({
            scrollDisabled: disabled
        });
    }
    componentDidMount() {
        this.setState({
            mounted: true
        });
    }
    componentDidUpdate(prevProps) {
        (0, $cIMBE.checkShouldForceFocusAndApply)(this.props?.editorView);
        if (this.props.node !== prevProps.node) this.resetStyling();
    }
    componentWillUnmount() {
        const { editorView: editorView } = this.props;
        if (editorView) {
            const { state: { tr: tr }, dispatch: dispatch } = editorView;
            dispatch((0, $cIMBE.forceFocusSelector)(null)(tr));
        }
        this.resetStyling();
    }
    render() {
        const { items: items, className: className, node: node, intl: intl, scrollable: scrollable, mediaAssistiveMessage: mediaAssistiveMessage } = this.props;
        const areAnyNewToolbarFlagsEnabled = (0, $jx6gl.areToolbarFlagsEnabled)(Boolean(this.props.api?.toolbar));
        if (!items || !items.length) return null;
        // Select has left padding of 4px to the border, everything else 8px
        const firstElementIsSelect = items[0].type === 'select';
        const hasSelect = items.find((item)=>item.type === 'select' && item.selectType === 'list');
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $baHgw.ToolbarArrowKeyNavigationProvider), {
            editorView: this.props.editorView,
            handleEscape: this.handleEscape,
            disableArrowKeyNavigation: !this.shouldHandleArrowKeys(),
            childComponentSelector: "[data-testid='editor-floating-toolbar']",
            isShortcutToFocusToolbar: this.isShortcutToFocusToolbar,
            intl: intl
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            ref: this.toolbarContainerRef,
            css: ()=>[
                    $71cc83e474c44c13$var$toolbarContainer(areAnyNewToolbarFlagsEnabled, scrollable, hasSelect !== undefined, firstElementIsSelect)
                ],
            "aria-label": intl.formatMessage((0, $jn2od.default).floatingToolbarAriaLabel),
            role: "toolbar",
            "data-testid": "editor-floating-toolbar",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            onMouseDown: areAnyNewToolbarFlagsEnabled ? this.captureMouseEvent : undefined
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $bQBk1.default), {
            text: mediaAssistiveMessage ? `${mediaAssistiveMessage}, ${intl.formatMessage((0, $jn2od.default).floatingToolbarAnnouncer)}` : intl.formatMessage((0, $jn2od.default).floatingToolbarAnnouncer),
            delay: 250
        }), scrollable && areAnyNewToolbarFlagsEnabled && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $f989C.ScrollButton), {
            intl: intl,
            scrollContainerRef: this.scrollContainerRef,
            node: node,
            disabled: this.state.scrollDisabled,
            side: "left"
        }), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            "data-testid": "floating-toolbar-items",
            ref: this.scrollContainerRef,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            css: $71cc83e474c44c13$var$toolbarOverflow({
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled,
                scrollable: scrollable,
                scrollDisabled: this.state.scrollDisabled,
                firstElementIsSelect: firstElementIsSelect
            })
        }, /*#__PURE__*/ (0, $1NIU8.jsx)($71cc83e474c44c13$var$ToolbarItems, {
            ...this.props,
            setDisableScroll: this.setDisableScroll.bind(this),
            mountRef: this.mountRef,
            mounted: this.state.mounted
        })), scrollable && (areAnyNewToolbarFlagsEnabled ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $f989C.ScrollButton), {
            intl: intl,
            scrollContainerRef: this.scrollContainerRef,
            node: node,
            disabled: this.state.scrollDisabled,
            side: "right"
        }) : /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jR93w.ScrollButtons), {
            intl: intl,
            scrollContainerRef: this.scrollContainerRef,
            node: node,
            disabled: this.state.scrollDisabled,
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }))), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            ref: this.mountRef
        })));
    }
}
var $71cc83e474c44c13$export$2e2bcd8739ae039 = (0, $6YFG2.default)($71cc83e474c44c13$var$Toolbar);

});
parcelRegister("1RDZu", function(module, exports) {
$parcel$export(module.exports, "areSameItems", () => $24719367e011a5b8$export$1d04baad505b720e);

var $1uOR2 = parcelRequire("1uOR2");

var $1MQUb = parcelRequire("1MQUb");

var $jn2od = parcelRequire("jn2od");

var $8hkbz = parcelRequire("8hkbz");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $24719367e011a5b8$var$makeSameType(_a, _b) {
    return true;
}
const $24719367e011a5b8$export$d36bdfa510afb180 = (objA, objB)=>{
    if (objA === objB) return true;
    if (objA == null || objB == null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    const bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    for(let idx = 0; idx < keysA.length; idx++){
        const key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (objA[key] !== objB[key]) return false;
    }
    return true;
};
const $24719367e011a5b8$export$fc16749c794bf6ff = (left, right, compareFn = $24719367e011a5b8$export$d36bdfa510afb180)=>{
    if (left.length !== right.length) return false;
    for(let idx = 0; idx < left.length; idx++){
        if (!compareFn(left[idx], right[idx])) return false;
    }
    return true;
};
const $24719367e011a5b8$var$compareItemWithKeys = (leftItem, rightItem, excludedKeys = [])=>Object.keys(leftItem).filter((key)=>excludedKeys.indexOf(key) === -1).every((key)=>leftItem[key] instanceof Object ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $24719367e011a5b8$export$d36bdfa510afb180(leftItem[key], rightItem[key]) : leftItem[key] === rightItem[key]);
const $24719367e011a5b8$export$b6007c51cfc2eaf0 = (leftItem, rightItem)=>{
    if (leftItem.type !== rightItem.type) return false;
    switch(leftItem.type){
        case 'button':
            // Need to typecast `rightItem as typeof leftItem` otherwise we will
            // have to put the `type !==` inside each case.
            return $24719367e011a5b8$var$compareItemWithKeys(leftItem, rightItem, [
                'type',
                'onClick',
                'onMouseEnter',
                'onMouseLeave'
            ]);
        case 'copy-button':
            return $24719367e011a5b8$var$compareItemWithKeys(leftItem, rightItem, [
                'type',
                'items'
            ]);
        case 'input':
            return $24719367e011a5b8$var$compareItemWithKeys(leftItem, rightItem, [
                'type',
                'onSubmit',
                'onBlur'
            ]);
        case 'select':
            if ($24719367e011a5b8$var$makeSameType(leftItem, rightItem) && Array.isArray(leftItem.options) && Array.isArray(rightItem.options) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            !$24719367e011a5b8$export$fc16749c794bf6ff(leftItem.options, rightItem.options, (left, right)=>$24719367e011a5b8$var$compareItemWithKeys(left, right))) return false;
            return $24719367e011a5b8$var$compareItemWithKeys(leftItem, rightItem, [
                'type',
                'onChange',
                'options'
            ]);
        case 'overflow-dropdown':
        case 'dropdown':
            if ($24719367e011a5b8$var$makeSameType(leftItem, rightItem) && Array.isArray(leftItem.options) && Array.isArray(rightItem.options) && // @ts-expect-error TS2345: Argument of type 'DropdownOptionT<Function>[]' is not assignable to parameter of type 'any[][]'
            !$24719367e011a5b8$export$fc16749c794bf6ff(leftItem.options, rightItem.options, (left, right)=>// @ts-expect-error  TS2322: Type '"onClick"' is not assignable to type 'keyof any[]'
                $24719367e011a5b8$var$compareItemWithKeys(left, right, [
                    'onClick'
                ]))) return false;
            return $24719367e011a5b8$var$compareItemWithKeys(leftItem, rightItem, [
                'type',
                'options'
            ]);
        case 'custom':
            return false;
        case 'separator':
            return $24719367e011a5b8$var$compareItemWithKeys(leftItem, rightItem);
        case 'extensions-placeholder':
            return $24719367e011a5b8$var$compareItemWithKeys(leftItem, rightItem);
    }
};
const $24719367e011a5b8$export$1d04baad505b720e = (leftArr, rightArr)=>{
    if (leftArr === undefined && rightArr === undefined) return true;
    if (leftArr === undefined || rightArr === undefined) return false;
    if (leftArr.length !== rightArr.length) return false;
    return leftArr.every((item, index)=>$24719367e011a5b8$export$b6007c51cfc2eaf0(rightArr[index], item));
};

});
parcelRegister("1uOR2", function(module, exports) {
$parcel$export(module.exports, "DropdownMenuExtensionItems", () => $a3cf7a1e1792f5ca$export$24b801b186044441);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $joSn0 = parcelRequire("joSn0");

var $g3VjK = parcelRequire("g3VjK");

var $9Ssie = parcelRequire("9Ssie");

var $1MQUb = parcelRequire("1MQUb");

var $8hkbz = parcelRequire("8hkbz");
const $a3cf7a1e1792f5ca$var$noop = ()=>null;
const $a3cf7a1e1792f5ca$var$isDefaultExport = (mod)=>{
    return mod.hasOwnProperty('default');
};
const $a3cf7a1e1792f5ca$var$resolveExtensionIcon = async (getIcon)=>{
    if (!getIcon) return $a3cf7a1e1792f5ca$var$noop;
    const maybeIcon = await getIcon();
    return $a3cf7a1e1792f5ca$var$isDefaultExport(maybeIcon) ? maybeIcon.default : maybeIcon;
};
const $a3cf7a1e1792f5ca$var$convertExtensionToDropdownMenuItem = ({ item: item, disabled: disabled, node: node, extension: extension })=>{
    const ButtonIcon = item.icon ? (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
        // Ignored via go/ees005
        // eslint-disable-next-line require-await
        loader: async ()=>$a3cf7a1e1792f5ca$var$resolveExtensionIcon(item.icon),
        loading: $a3cf7a1e1792f5ca$var$noop
    }) : undefined;
    let title = '';
    if (item.label) title = item.label;
    else if (typeof item.tooltip === 'string') title = item.tooltip;
    else if (item.ariaLabel) title = item.ariaLabel;
    item.disabled = disabled?.(item.key) || false;
    return {
        title: title,
        icon: ButtonIcon ? /*#__PURE__*/ (0, $gt9Am.jsx)(ButtonIcon, {
            label: item.label || ''
        }) : undefined,
        disabled: item.disabled,
        onClick: ()=>{
            if (typeof item.action !== 'function') throw new Error(`'action' of context toolbar item '${item.key}' is not a function`);
            const targetNodeAdf = (0, $9Ssie.nodeToJSON)(node);
            extension.extensionApi && item.action(targetNodeAdf, extension.extensionApi);
            return true;
        }
    };
};
const $a3cf7a1e1792f5ca$var$DropdownMenuExtensionItem = ({ item: item, editorView: editorView, disabled: disabled, node: node, extension: extension, dropdownOptions: dropdownOptions })=>{
    const dropdownItem = $a3cf7a1e1792f5ca$var$convertExtensionToDropdownMenuItem({
        item: item,
        disabled: disabled,
        node: node,
        extension: extension
    });
    if (!dropdownItem) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1MQUb.DropdownMenuItem), {
        item: dropdownItem,
        editorView: editorView,
        hide: dropdownOptions.hide,
        dispatchCommand: dropdownOptions.dispatchCommand,
        showSelected: dropdownOptions.showSelected,
        intl: dropdownOptions.intl
    }, item.key);
};
const $a3cf7a1e1792f5ca$export$24b801b186044441 = (props)=>{
    const { node: node, editorView: editorView, extension: extension, disabled: disabled, dropdownOptions: dropdownOptions, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [extensions, setExtensions] = (0, $eJOHy.useState)([]);
    (0, $eJOHy.useEffect)(()=>{
        getExtensions();
        async function getExtensions() {
            const provider = await extension.extensionProvider;
            if (provider) setExtensions(await provider.getExtensions());
        }
    }, [
        extension.extensionProvider
    ]);
    const nodeAdf = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>(0, $9Ssie.nodeToJSON)(node), [
        node
    ]);
    const extensionItems = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>{
        if (!extension.extensionApi) return [];
        return (0, $g3VjK.getContextualToolbarItemsFromModule)(extensions, nodeAdf, extension.extensionApi);
    }, [
        extensions,
        nodeAdf,
        extension.extensionApi
    ]);
    if (!extensionItems.length || !dropdownOptions) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            extensionItems.map((item, idx)=>{
                if (!('key' in item)) return null;
                return /*#__PURE__*/ (0, $gt9Am.jsx)($a3cf7a1e1792f5ca$var$DropdownMenuExtensionItem, {
                    item: item,
                    editorView: editorView,
                    disabled: disabled,
                    node: node,
                    extension: extension,
                    dropdownOptions: dropdownOptions
                }, item.key);
            }),
            areAnyNewToolbarFlagsEnabled && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8hkbz.DropdownSeparator), {})
        ]
    });
};

});
parcelRegister("1MQUb", function(module, exports) {
$parcel$export(module.exports, "DropdownMenuItem", () => $d847d4aaf27ad623$export$ed97964d1871885d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6XkOW = parcelRequire("6XkOW");

var $7saMl = parcelRequire("7saMl");

var $cbSL1 = parcelRequire("cbSL1");

var $92xoS = parcelRequire("92xoS");

var $k71qx = parcelRequire("k71qx");

var $jn2od = parcelRequire("jn2od");
function $d847d4aaf27ad623$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d847d4aaf27ad623$export$1a7f12094b137d20 = {
    width: 175,
    height: 32
};
const $d847d4aaf27ad623$var$labelStyles = {
    name: "18nns55",
    styles: "display:inline-block;width:100%"
};
const $d847d4aaf27ad623$var$spacerStyles = {
    name: "nce1h9",
    styles: "display:flex;flex:1;padding:var(--ds-space-100, 8px)"
};
const $d847d4aaf27ad623$var$DropdownButtonItem = (0, $7saMl.default);
const $d847d4aaf27ad623$var$SelectedIconBefore = ({ itemSelected: itemSelected, intl: intl, showSelected: showSelected })=>{
    if (showSelected && itemSelected) return /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6XkOW))), {
        LEGACY_primaryColor: "var(--ds-icon-selected, #0C66E4)",
        LEGACY_size: "small",
        label: intl.formatMessage((0, $jn2od.default).confirmModalOK),
        spacing: "none"
    }));
    return /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $d847d4aaf27ad623$var$spacerStyles
    });
};
const $d847d4aaf27ad623$export$ed97964d1871885d = (props)=>{
    const { item: item, hide: hide, dispatchCommand: dispatchCommand, editorView: editorView, showSelected: showSelected, intl: intl } = props;
    const itemSelected = item.selected;
    const iconBefore = (0, $eJOHy.useMemo)(()=>{
        if (item.icon) return item.icon;
        else return /*#__PURE__*/ (0, $1NIU8.jsx)($d847d4aaf27ad623$var$SelectedIconBefore, {
            itemSelected: itemSelected,
            showSelected: showSelected,
            intl: intl
        });
    }, [
        itemSelected,
        showSelected,
        intl,
        item.icon
    ]);
    const [tooltipContent, setTooltipContent] = (0, $eJOHy.useState)(item.tooltip || '');
    const handleItemMouseOut = (0, $eJOHy.useCallback)(()=>{
        setTooltipContent('');
        if (item.onMouseOut) dispatchCommand(item.onMouseOut);
    }, [
        item.onMouseOut,
        dispatchCommand
    ]);
    const handleItemMouseDown = (0, $eJOHy.useCallback)((e)=>{
        e.preventDefault(); // ED-16204 - This is needed for safari to get handleItemClick() to work
        if (item.onMouseDown) dispatchCommand(item.onMouseDown);
    }, [
        item.onMouseDown,
        dispatchCommand
    ]);
    const handleItemMouseOver = (0, $eJOHy.useCallback)(()=>{
        setTooltipContent(item.tooltip || '');
        if (item.onMouseOver) dispatchCommand(item.onMouseOver);
    }, [
        item.tooltip,
        item.onMouseOver,
        dispatchCommand
    ]);
    const handleItemMouseEnter = (0, $eJOHy.useCallback)((e)=>{
        if (item.onMouseEnter) {
            e.preventDefault();
            dispatchCommand(item.onMouseEnter);
        }
    }, [
        item.onMouseEnter,
        dispatchCommand
    ]);
    const handleItemMouseLeave = (0, $eJOHy.useCallback)((e)=>{
        if (item.onMouseLeave) {
            e.preventDefault();
            dispatchCommand(item.onMouseLeave);
        }
    }, [
        item.onMouseLeave,
        dispatchCommand
    ]);
    const handleItemOnFocus = (0, $eJOHy.useCallback)((e)=>{
        if (item.onFocus) {
            e.preventDefault();
            dispatchCommand(item.onFocus);
        }
    }, [
        item.onFocus,
        dispatchCommand
    ]);
    const handleItemOnBlur = (0, $eJOHy.useCallback)((e)=>{
        if (item.onBlur) {
            e.preventDefault();
            dispatchCommand(item.onBlur);
        }
    }, [
        item.onBlur,
        dispatchCommand
    ]);
    const handleItemClick = (0, $eJOHy.useCallback)(()=>{
        /**
     * The order of dispatching the event and hide() is important, because
     * the ClickAreaBlock will be relying on the element to calculate the
     * click coordinate.
     * For more details, please visit the comment in this PR https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/5328/edm-1321-set-selection-near-smart-link?link_source=email#chg-packages/editor/editor-core/src/plugins/floating-toolbar/ui/DropdownMenu.tsx
     */ dispatchCommand(item.onClick);
        hide();
        if (!editorView?.hasFocus()) editorView?.focus();
    }, [
        dispatchCommand,
        item.onClick,
        hide,
        editorView
    ]);
    /* ED-16704 - Native mouse event handler to overcome firefox issue on disabled <button> - https://github.com/whatwg/html/issues/5886 */ const labelRef = (0, $eJOHy.useRef)(null);
    const handleTitleWrapperMouseEvent = (0, $eJOHy.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e)=>{
        if (item.disabled) {
            e.stopPropagation();
            e.preventDefault();
        }
    }, [
        item.disabled
    ]);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isAriaChecked = (item)=>{
        const { selected: selected, domItemOptions: domItemOptions } = item;
        return domItemOptions?.type === 'item-checkbox' ? selected : undefined;
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const hasRole = (item)=>{
        if ((0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') || (0, $cbSL1.expValEquals)('platform_editor_august_a11y', 'isEnabled', true)) return item.domItemOptions?.type === 'item-checkbox' ? 'menuitemcheckbox' : 'menuitem';
        return item.domItemOptions?.type === 'item-checkbox' ? 'menuitemcheckbox' : undefined;
    };
    (0, $eJOHy.useEffect)(()=>{
        const labelRefCurrent = labelRef.current;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        labelRefCurrent?.addEventListener('click', handleTitleWrapperMouseEvent);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        labelRefCurrent?.addEventListener('mousedown', handleTitleWrapperMouseEvent);
        return ()=>{
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            labelRefCurrent?.removeEventListener('click', handleTitleWrapperMouseEvent);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            labelRefCurrent?.removeEventListener('mousedown', handleTitleWrapperMouseEvent);
        };
    });
    const itemContent = /*#__PURE__*/ (0, $1NIU8.jsx)($d847d4aaf27ad623$var$DropdownButtonItem, {
        isSelected: itemSelected,
        iconBefore: iconBefore,
        iconAfter: item.elemAfter,
        onClick: handleItemClick,
        "data-testid": item.testId,
        isDisabled: item.disabled,
        onMouseDown: handleItemMouseDown,
        onMouseOver: handleItemMouseOver,
        onMouseEnter: handleItemMouseEnter,
        onMouseLeave: handleItemMouseLeave,
        onMouseOut: handleItemMouseOut,
        onFocus: handleItemOnFocus,
        onBlur: handleItemOnBlur,
        role: hasRole(item),
        "aria-checked": isAriaChecked(item)
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        ref: labelRef,
        css: $d847d4aaf27ad623$var$labelStyles
    }, item.title));
    if (tooltipContent) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k71qx.default), {
        content: tooltipContent
    }, itemContent);
    return itemContent;
};

});

parcelRegister("8hkbz", function(module, exports) {
$parcel$export(module.exports, "DropdownSeparator", () => $b92b52499b3d8729$export$c0340fdc1581055e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");
function $b92b52499b3d8729$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b92b52499b3d8729$var$separatorStyles = {
    name: "1ccyrm",
    styles: "background:var(--ds-border, #091E4224);height:1px"
};
const $b92b52499b3d8729$export$c0340fdc1581055e = ()=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $b92b52499b3d8729$var$separatorStyles
    });
};

});



parcelRegister("knwdo", function(module, exports) {
$parcel$export(module.exports, "default", () => $a66705cdfb3b2eca$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $abjs4 = parcelRequire("abjs4");

var $k71qx = parcelRequire("k71qx");

var $7drWe = parcelRequire("7drWe");

var $cOk3B = parcelRequire("cOk3B");

var $lNCvi = parcelRequire("lNCvi");
const $a66705cdfb3b2eca$var$customSizeAndPadding = {
    minWidth: "var(--ds-space-400, 32px)",
    padding: `0px ${"var(--ds-space-050, 4px)"}`
};
var $a66705cdfb3b2eca$export$2e2bcd8739ae039 = ({ title: title, icon: icon, iconAfter: iconAfter, onClick: onClick, onKeyDown: onKeyDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, onBlur: onBlur, onMount: onMount, onUnmount: onUnmount, selected: selected, disabled: disabled, href: href, target: target, appearance: appearance = 'subtle', children: children, className: className, tooltipContent: tooltipContent, tooltipStyle: tooltipStyle, testId: testId, interactionName: interactionName, hideTooltipOnClick: hideTooltipOnClick = true, ariaHasPopup: ariaHasPopup, tabIndex: tabIndex, areaControls: areaControls, ariaLabel: ariaLabel, isRadioButton: isRadioButton, pulse: pulse, spotlightConfig: spotlightConfig, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    // Check if there's only an icon and add additional styles
    const iconOnly = (icon || iconAfter) && !children;
    const customSpacing = iconOnly ? (0, $lNCvi.iconOnlySpacing) : {};
    const isButtonPressed = ariaHasPopup ? undefined : selected;
    const ariaChecked = isRadioButton ? isButtonPressed : undefined;
    const ariaPressed = isRadioButton ? undefined : isButtonPressed;
    const [spotlightReferenceElement, setSpotlightReferenceElement] = (0, $eJOHy.useState)(null);
    (0, $eJOHy.useEffect)(()=>{
        onMount?.();
        return ()=>onUnmount?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onSpotlightTargetClick = spotlightConfig?.isSpotlightOpen ? spotlightConfig?.onTargetClick : undefined;
    const handleOnClick = (0, $eJOHy.useCallback)((event)=>{
        // fire the spotlight onTargetClick callback if a spotlight is rendered and callback is provided
        onSpotlightTargetClick?.();
        onClick?.(event);
    }, [
        onClick,
        onSpotlightTargetClick
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                // Only fallback to title for tooltip if title is not shown
                content: tooltipContent || (iconOnly ? title : undefined),
                component: tooltipStyle,
                hideTooltipOnClick: hideTooltipOnClick,
                position: "top",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: onMouseLeave,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7drWe.Pulse), {
                        pulse: pulse || spotlightConfig?.pulse,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $abjs4.default), {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
                            className: className,
                            ref: (buttonElement)=>setSpotlightReferenceElement(buttonElement),
                            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
                            theme: (adgTheme, themeProps)=>{
                                const { buttonStyles: buttonStyles, ...rest } = adgTheme(themeProps);
                                return {
                                    buttonStyles: {
                                        ...buttonStyles,
                                        ...customSpacing,
                                        ...appearance === 'danger' && (0, $lNCvi.getButtonStyles)({
                                            appearance: appearance,
                                            state: themeProps.state,
                                            mode: themeProps.mode
                                        }),
                                        ...areAnyNewToolbarFlagsEnabled ? $a66705cdfb3b2eca$var$customSizeAndPadding : {}
                                    },
                                    ...rest
                                };
                            },
                            "aria-label": ariaLabel || title,
                            "aria-pressed": ariaPressed,
                            "aria-checked": ariaChecked,
                            role: isRadioButton ? 'radio' : undefined,
                            "aria-expanded": ariaHasPopup ? selected : undefined,
                            "aria-controls": ariaHasPopup ? areaControls : undefined,
                            spacing: areAnyNewToolbarFlagsEnabled ? 'default' : 'compact',
                            href: href,
                            target: target,
                            appearance: appearance,
                            "aria-haspopup": ariaHasPopup,
                            iconBefore: icon || undefined,
                            iconAfter: iconAfter,
                            onClick: handleOnClick,
                            onKeyDown: onKeyDown,
                            isSelected: selected,
                            isDisabled: disabled,
                            testId: testId,
                            interactionName: interactionName,
                            onFocus: onFocus,
                            onBlur: onBlur,
                            // @ts-ignore
                            // tabIndex set as 0 by default in the design system  ButtonBase component
                            // this is not expected for all buttons, we have to use tabIndex={null} for some cases
                            // should be fixed here https://a11y-internal.atlassian.net/browse/DST-287
                            tabIndex: tabIndex,
                            children: children
                        })
                    })
                })
            }),
            spotlightConfig?.isSpotlightOpen && spotlightReferenceElement && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cOk3B.ButtonSpotlightCard), {
                referenceElement: spotlightReferenceElement,
                ...spotlightConfig.spotlightCardOptions
            })
        ]
    });
};

});
parcelRegister("7drWe", function(module, exports) {
$parcel$export(module.exports, "Pulse", () => $35ce09c36823f610$export$927d63e2511364c0);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fBe2p = parcelRequire("fBe2p");
function $35ce09c36823f610$export$927d63e2511364c0({ pulse: pulse, radius: radius = 3, children: children }) {
    if (pulse) return(// SpotlightPulse shows pulse effect if `pulse` is `undefined`.
    // That's why we need to cast `pulse` to `false` if it's `undefined`.
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fBe2p.Pulse), {
        radius: radius,
        pulse: pulse ?? false,
        children: children
    }));
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
}

});

parcelRegister("cOk3B", function(module, exports) {
$parcel$export(module.exports, "ButtonSpotlightCard", () => $10a34352fe55e5a0$export$beb7ede7fcdf145c);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $3l2IB = parcelRequire("3l2IB");

var $8qmYl = parcelRequire("8qmYl");
const $10a34352fe55e5a0$export$beb7ede7fcdf145c = (props)=>{
    const { referenceElement: referenceElement, placement: placement = 'top-start', ...spotlightCardProps } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8qmYl.Popper), {
        referenceElement: referenceElement,
        placement: placement,
        strategy: "absolute",
        children: ({ ref: ref, style: style })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                ref: ref,
                style: style,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3l2IB.default), {
                    ...spotlightCardProps
                })
            })
    });
};

});

parcelRegister("lNCvi", function(module, exports) {
$parcel$export(module.exports, "iconOnlySpacing", () => $57820a58c354b0f0$export$7d8cec9727d4e603);
$parcel$export(module.exports, "getButtonStyles", () => $57820a58c354b0f0$export$f98ea88a275be66c);

var $eGOwo = parcelRequire("eGOwo");
const $57820a58c354b0f0$export$7d8cec9727d4e603 = {
    '&&': {
        padding: '0px'
    },
    '& > span': {
        margin: '0px'
    }
};
const $57820a58c354b0f0$var$getStyles = (property, { appearance: appearance = 'default', state: state = 'default', mode: mode = 'light' })=>{
    if (!property[appearance] || !property[appearance][state]) return 'initial';
    return property[appearance][state][mode];
};
const $57820a58c354b0f0$var$background = {
    danger: {
        default: {
            light: 'inherit',
            dark: 'inherit'
        },
        hover: {
            light: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
            dark: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
        },
        active: {
            light: "var(--ds-background-neutral-pressed, #091E424F)",
            dark: "var(--ds-background-neutral-pressed, #091E424F)"
        }
    }
};
const $57820a58c354b0f0$var$backgroundVisualRefresh = {
    danger: {
        default: {
            light: 'inherit',
            dark: 'inherit'
        },
        hover: {
            light: "var(--ds-background-danger-hovered, #FFD5D2)",
            dark: "var(--ds-background-danger-hovered, #FFD5D2)"
        },
        active: {
            light: "var(--ds-background-danger-pressed, #FD9891)",
            dark: "var(--ds-background-danger-pressed, #FD9891)"
        }
    }
};
const $57820a58c354b0f0$var$color = {
    danger: {
        default: {
            light: "var(--ds-icon, #44546F)",
            dark: "var(--ds-icon, #44546F)"
        },
        hover: {
            light: "var(--ds-icon-danger, #C9372C)",
            dark: "var(--ds-icon-danger, #C9372C)"
        },
        active: {
            light: "var(--ds-icon-danger, #C9372C)",
            dark: "var(--ds-icon-danger, #C9372C)"
        }
    }
};
const $57820a58c354b0f0$var$colorVisualRefresh = {
    danger: {
        default: {
            light: "var(--ds-icon-subtle, #626F86)",
            dark: "var(--ds-icon-subtle, #626F86)"
        },
        hover: {
            light: "var(--ds-icon-danger, #C9372C)",
            dark: "var(--ds-icon-danger, #C9372C)"
        },
        active: {
            light: "var(--ds-icon-danger, #C9372C)",
            dark: "var(--ds-icon-danger, #C9372C)"
        }
    }
};
const $57820a58c354b0f0$export$f98ea88a275be66c = (props)=>({
        background: $57820a58c354b0f0$var$getStyles((0, $eGOwo.fg)('platform-visual-refresh-icons') ? $57820a58c354b0f0$var$backgroundVisualRefresh : $57820a58c354b0f0$var$background, props),
        color: $57820a58c354b0f0$var$getStyles((0, $eGOwo.fg)('platform-visual-refresh-icons') ? $57820a58c354b0f0$var$colorVisualRefresh : $57820a58c354b0f0$var$color, props)
    });

});


parcelRegister("84CN8", function(module, exports) {
$parcel$export(module.exports, "default", () => $62a9c1374f8f3d97$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");
function $62a9c1374f8f3d97$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $62a9c1374f8f3d97$var$separator = /*#__PURE__*/ (0, $1NIU8.css)({
    background: "var(--ds-border, #091E4224)",
    width: '1px',
    height: '20px',
    margin: `0 ${"var(--ds-space-050, 4px)"}`,
    alignSelf: 'center'
});
const $62a9c1374f8f3d97$var$separatorNew = {
    name: "876g5t",
    styles: "background:var(--ds-border, #091E4224);width:1px;height:20px;align-self:center"
};
const $62a9c1374f8f3d97$var$separatorFullHeight = {
    name: "1k18kha",
    styles: "height:40px"
};
var $62a9c1374f8f3d97$export$2e2bcd8739ae039 = ({ fullHeight: fullHeight, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            areAnyNewToolbarFlagsEnabled ? $62a9c1374f8f3d97$var$separatorNew : $62a9c1374f8f3d97$var$separator,
            fullHeight && $62a9c1374f8f3d97$var$separatorFullHeight
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "separator"
    });

});

parcelRegister("a44PI", function(module, exports) {
$parcel$export(module.exports, "textPaletteTooltipMessages", () => $77c84882c339b613$export$d8fe76863446580e);
$parcel$export(module.exports, "backgroundPaletteTooltipMessages", () => $77c84882c339b613$export$c671ecebb9c48677);
$parcel$export(module.exports, "chartsColorPaletteTooltipMessages", () => $77c84882c339b613$export$f8b88c9f6c817aff);
$parcel$export(module.exports, "borderPaletteTooltipMessages", () => $77c84882c339b613$export$515e8edd15e08de7);

var $7qGN1 = parcelRequire("7qGN1");
const $77c84882c339b613$export$788a656fb7fb7897 = (0, $7qGN1.defineMessages)({
    '#FFFFFF': {
        id: 'fabric.theme.white',
        defaultMessage: 'White',
        description: 'Name of a color'
    },
    '#B3D4FF': {
        id: 'fabric.theme.subtle-blue',
        defaultMessage: 'Subtle blue',
        description: 'Name of a color'
    },
    '#B3F5FF': {
        id: 'fabric.theme.subtle-teal',
        defaultMessage: 'Subtle teal',
        description: 'Name of a color'
    },
    '#ABF5D1': {
        id: 'fabric.theme.subtle-green',
        defaultMessage: 'Subtle green',
        description: 'Name of a color'
    },
    '#FFF0B3': {
        id: 'fabric.theme.subtle-yellow',
        defaultMessage: 'Subtle yellow',
        description: 'Name of a color'
    },
    '#FFBDAD': {
        id: 'fabric.theme.subtle-red',
        defaultMessage: 'Subtle red',
        description: 'Name of a color'
    },
    '#EAE6FF': {
        id: 'fabric.theme.subtle-purple',
        defaultMessage: 'Subtle purple',
        description: 'Name of a color'
    },
    '#97A0AF': {
        id: 'fabric.theme.gray',
        defaultMessage: 'Gray',
        description: 'Name of a color'
    },
    '#4C9AFF': {
        id: 'fabric.theme.blue',
        defaultMessage: 'Blue',
        description: 'Name of a color'
    },
    '#00B8D9': {
        id: 'fabric.theme.teal',
        defaultMessage: 'Teal',
        description: 'Name of a color'
    },
    '#36B37E': {
        id: 'fabric.theme.green',
        defaultMessage: 'Green',
        description: 'Name of a color'
    },
    '#FFC400': {
        id: 'fabric.theme.yellow',
        defaultMessage: 'Yellow',
        description: 'Name of a color'
    },
    '#FF5630': {
        id: 'fabric.theme.red',
        defaultMessage: 'Red',
        description: 'Name of a color.'
    },
    '#FF991F': {
        id: 'fabric.theme.bold-orange',
        defaultMessage: 'Bold orange',
        description: 'Name of a color.'
    },
    '#6554C0': {
        id: 'fabric.theme.purple',
        defaultMessage: 'Purple',
        description: 'Name of a color'
    },
    '#0747A6': {
        id: 'fabric.theme.bold-blue',
        defaultMessage: 'Bold blue',
        description: 'Name of a color'
    },
    '#008DA6': {
        id: 'fabric.theme.bold-teal',
        defaultMessage: 'Bold teal',
        description: 'Name of a color'
    },
    '#006644': {
        id: 'fabric.theme.bold-green',
        defaultMessage: 'Bold green',
        description: 'Name of a color'
    },
    '#BF2600': {
        id: 'fabric.theme.bold-red',
        defaultMessage: 'Bold red',
        description: 'Name of a color'
    },
    '#403294': {
        id: 'fabric.theme.bold-purple',
        defaultMessage: 'Bold purple',
        description: 'Name of a color'
    },
    '#172B4D': {
        id: 'fabric.theme.default',
        defaultMessage: 'Default',
        description: 'Name of a color'
    }
});
const $77c84882c339b613$var$darkModeTextPaletteOverrides = (0, $7qGN1.defineMessages)({
    '#FFFFFF': {
        id: 'fabric.theme.dark-gray',
        defaultMessage: 'Dark gray',
        description: 'Name of a color'
    }
});
const $77c84882c339b613$export$cca9f3b863b77c82 = {
    ...$77c84882c339b613$export$788a656fb7fb7897,
    ...$77c84882c339b613$var$darkModeTextPaletteOverrides
};
const $77c84882c339b613$export$d8fe76863446580e = {
    light: $77c84882c339b613$export$788a656fb7fb7897,
    dark: $77c84882c339b613$export$cca9f3b863b77c82
};
const $77c84882c339b613$export$12d66ae3e5b38d26 = (0, $7qGN1.defineMessages)({
    '#DEEBFF': {
        id: 'fabric.theme.subtle-blue',
        defaultMessage: 'Subtle blue',
        description: 'Name of a color'
    },
    '#B3D4FF': {
        id: 'fabric.theme.blue',
        defaultMessage: 'Blue',
        description: 'Name of a color'
    },
    '#4C9AFF': {
        id: 'fabric.theme.bold-blue',
        defaultMessage: 'Bold blue',
        description: 'Name of a color'
    },
    '#E6FCFF': {
        id: 'fabric.theme.subtle-teal',
        defaultMessage: 'Subtle teal',
        description: 'Name of a color'
    },
    '#B3F5FF': {
        id: 'fabric.theme.teal',
        defaultMessage: 'Teal',
        description: 'Name of a color'
    },
    '#79E2F2': {
        id: 'fabric.theme.bold-teal',
        defaultMessage: 'Bold teal',
        description: 'Name of a color'
    },
    '#E3FCEF': {
        id: 'fabric.theme.subtle-green',
        defaultMessage: 'Subtle green',
        description: 'Name of a color'
    },
    '#ABF5D1': {
        id: 'fabric.theme.green',
        defaultMessage: 'Green',
        description: 'Name of a color'
    },
    '#57D9A3': {
        id: 'fabric.theme.bold-green',
        defaultMessage: 'Bold green',
        description: 'Name of a color'
    },
    '#FFFAE6': {
        id: 'fabric.theme.subtle-yellow',
        defaultMessage: 'Subtle yellow',
        description: 'Name of a color'
    },
    '#FFF0B3': {
        id: 'fabric.theme.yellow',
        defaultMessage: 'Yellow',
        description: 'Name of a color'
    },
    '#FFC400': {
        id: 'fabric.theme.bold-yellow',
        defaultMessage: 'Bold yellow',
        description: 'Name of a color'
    },
    '#FFEBE6': {
        id: 'fabric.theme.subtle-red',
        defaultMessage: 'Subtle red',
        description: 'Name of a color'
    },
    '#FFBDAD': {
        id: 'fabric.theme.red',
        defaultMessage: 'Red',
        description: 'Name of a color.'
    },
    '#FF8F73': {
        id: 'fabric.theme.bold-red',
        defaultMessage: 'Bold red',
        description: 'Name of a color'
    },
    '#EAE6FF': {
        id: 'fabric.theme.subtle-purple',
        defaultMessage: 'Subtle purple',
        description: 'Name of a color'
    },
    '#C0B6F2': {
        id: 'fabric.theme.purple',
        defaultMessage: 'Purple',
        description: 'Name of a color'
    },
    '#998DD9': {
        id: 'fabric.theme.bold-purple',
        defaultMessage: 'Bold purple',
        description: 'Name of a color'
    },
    '#FFFFFF': {
        id: 'fabric.theme.white',
        defaultMessage: 'White',
        description: 'Name of a color'
    },
    '#F4F5F7': {
        id: 'fabric.theme.gray',
        defaultMessage: 'Gray',
        description: 'Name of a color'
    },
    '#B3BAC5': {
        id: 'fabric.theme.bold-gray',
        defaultMessage: 'Bold gray',
        description: 'Name of a color'
    }
});
const $77c84882c339b613$var$darkModeBackgroundPaletteOverrides = (0, $7qGN1.defineMessages)({
    '#FFFFFF': {
        id: 'fabric.theme.subtle-gray',
        defaultMessage: 'Subtle gray',
        description: 'Name of a color'
    },
    '#B3BAC5': {
        id: 'fabric.theme.bold-gray',
        defaultMessage: 'Bold gray',
        description: 'Name of a color'
    }
});
const $77c84882c339b613$export$d1327856929fda16 = {
    ...$77c84882c339b613$export$12d66ae3e5b38d26,
    ...$77c84882c339b613$var$darkModeBackgroundPaletteOverrides
};
const $77c84882c339b613$export$c671ecebb9c48677 = {
    light: $77c84882c339b613$export$12d66ae3e5b38d26,
    dark: $77c84882c339b613$export$d1327856929fda16
};
const $77c84882c339b613$export$3db7ab7dd64ad21a = (0, $7qGN1.defineMessages)({
    // Blue color
    '#7AB2FF': {
        id: 'fabric.theme.subtle-blue',
        defaultMessage: 'Subtle blue',
        description: 'Name of a color'
    },
    '#247FFF': {
        id: 'fabric.theme.blue',
        defaultMessage: 'Blue',
        description: 'Name of a color'
    },
    '#0055CC': {
        id: 'fabric.theme.bold-blue',
        defaultMessage: 'Bold blue',
        description: 'Name of a color'
    },
    '#003884': {
        id: 'fabric.theme.bolder-blue',
        defaultMessage: 'Bolder blue',
        description: 'Name of a color'
    },
    // Teal color
    '#60C6D2': {
        id: 'fabric.theme.subtle-teal',
        defaultMessage: 'Subtle teal',
        description: 'Name of a color'
    },
    '#1D9AAA': {
        id: 'fabric.theme.teal',
        defaultMessage: 'Teal',
        description: 'Name of a color'
    },
    '#1D7F8C': {
        id: 'fabric.theme.bold-teal',
        defaultMessage: 'Bold teal',
        description: 'Name of a color'
    },
    '#206B74': {
        id: 'fabric.theme.bolder-teal',
        defaultMessage: 'Bolder teal',
        description: 'Name of a color'
    },
    // Green color
    '#6BE1B0': {
        id: 'fabric.theme.subtle-green',
        defaultMessage: 'Subtle green',
        description: 'Name of a color'
    },
    '#23A971': {
        id: 'fabric.theme.green',
        defaultMessage: 'Green',
        description: 'Name of a color'
    },
    '#177D52': {
        id: 'fabric.theme.bold-green',
        defaultMessage: 'Bold green',
        description: 'Name of a color'
    },
    '#055C3F': {
        id: 'fabric.theme.bolder-green',
        defaultMessage: 'Bolder green',
        description: 'Name of a color'
    },
    // Yellow color
    '#FFDB57': {
        id: 'fabric.theme.subtle-yellow',
        defaultMessage: 'Subtle yellow',
        description: 'Name of a color'
    },
    '#FFBE33': {
        id: 'fabric.theme.yellow',
        defaultMessage: 'Yellow',
        description: 'Name of a color'
    },
    '#FF9D00': {
        id: 'fabric.theme.bold-yellow',
        defaultMessage: 'Bold yellow',
        description: 'Name of a color'
    },
    '#946104': {
        id: 'fabric.theme.bolder-yellow',
        defaultMessage: 'Bolder yellow',
        description: 'Name of a color'
    },
    // Red color
    '#FF8F73': {
        id: 'fabric.theme.subtle-red',
        defaultMessage: 'Subtle red',
        description: 'Name of a color'
    },
    '#FC552C': {
        id: 'fabric.theme.red',
        defaultMessage: 'Red',
        description: 'Name of a color.'
    },
    '#D32D03': {
        id: 'fabric.theme.bold-red',
        defaultMessage: 'Bold red',
        description: 'Name of a color'
    },
    '#A32000': {
        id: 'fabric.theme.bolder-red',
        defaultMessage: 'Bolder red',
        description: 'Name of a color'
    },
    // Orange color
    '#FAA53D': {
        id: 'fabric.theme.subtle-orange',
        defaultMessage: 'Subtle orange',
        description: 'Name of a color'
    },
    '#D97008': {
        id: 'fabric.theme.orange',
        defaultMessage: 'Orange',
        description: 'Name of a color.'
    },
    '#B65C02': {
        id: 'fabric.theme.bold-orange',
        defaultMessage: 'Bold orange',
        description: 'Name of a color.'
    },
    '#974F0C': {
        id: 'fabric.theme.bolder-orange',
        defaultMessage: 'Bolder orange',
        description: 'Name of a color'
    },
    // Magenta color
    '#E774BB': {
        id: 'fabric.theme.subtle-magenta',
        defaultMessage: 'Subtle magenta',
        description: 'Name of a color'
    },
    '#DA62AC': {
        id: 'fabric.theme.magenta',
        defaultMessage: 'Magenta',
        description: 'Name of a color'
    },
    '#CD519D': {
        id: 'fabric.theme.bold-magenta',
        defaultMessage: 'Bold magenta',
        description: 'Name of a color'
    },
    '#943D73': {
        id: 'fabric.theme.bolder-magenta',
        defaultMessage: 'Bolder magenta',
        description: 'Name of a color'
    },
    // Purple color
    '#B5A7FB': {
        id: 'fabric.theme.subtle-purple',
        defaultMessage: 'Subtle purple',
        description: 'Name of a color'
    },
    '#8B77EE': {
        id: 'fabric.theme.purple',
        defaultMessage: 'Purple',
        description: 'Name of a color'
    },
    '#5A43D0': {
        id: 'fabric.theme.bold-purple',
        defaultMessage: 'Bold purple',
        description: 'Name of a color'
    },
    '#44368B': {
        id: 'fabric.theme.bolder-purple',
        defaultMessage: 'Bolder purple',
        description: 'Name of a color'
    },
    // Gray color
    '#8993A5': {
        id: 'fabric.theme.subtle-gray',
        defaultMessage: 'Subtle gray',
        description: 'Name of a color'
    },
    '#8590A2': {
        id: 'fabric.theme.gray',
        defaultMessage: 'Gray',
        description: 'Name of a color'
    },
    '#758195': {
        id: 'fabric.theme.bold-gray',
        defaultMessage: 'Bold gray',
        description: 'Name of a color'
    },
    '#44546F': {
        id: 'fabric.theme.bolder-gray',
        defaultMessage: 'Bolder gray',
        description: 'Name of a color'
    }
});
const $77c84882c339b613$var$darkChartsColorPaletteTooltipMessages = {
    ...$77c84882c339b613$export$3db7ab7dd64ad21a
};
const $77c84882c339b613$export$f8b88c9f6c817aff = {
    light: $77c84882c339b613$export$3db7ab7dd64ad21a,
    dark: $77c84882c339b613$var$darkChartsColorPaletteTooltipMessages
};
const $77c84882c339b613$var$lightBorderPaletteTooltipMessages = (0, $7qGN1.defineMessages)({
    '#091E4224': {
        id: 'fabric.theme.subtle-gray',
        defaultMessage: 'Subtle gray',
        description: 'Name of a color'
    },
    '#758195': {
        id: 'fabric.theme.gray',
        defaultMessage: 'Gray',
        description: 'Name of a color'
    },
    '#172B4D': {
        id: 'fabric.theme.bold-gray',
        defaultMessage: 'Bold gray',
        description: 'Name of a color'
    }
});
const $77c84882c339b613$var$darkBorderPaletteTooltipMessages = {
    ...$77c84882c339b613$var$lightBorderPaletteTooltipMessages
};
const $77c84882c339b613$export$515e8edd15e08de7 = {
    light: $77c84882c339b613$var$lightBorderPaletteTooltipMessages,
    dark: $77c84882c339b613$var$darkBorderPaletteTooltipMessages
};

});

parcelRegister("9yYkI", function(module, exports) {
$parcel$export(module.exports, "default", () => $cbb0a0fcde007d3a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $lRq8t = parcelRequire("lRq8t");

var $dUaMU = parcelRequire("dUaMU");

var $4J0ad = parcelRequire("4J0ad");

var $5CSKW = parcelRequire("5CSKW");

var $goZPP = parcelRequire("goZPP");

var $1OQKp = parcelRequire("1OQKp");

var $1UIWS = parcelRequire("1UIWS");

var $eGOwo = parcelRequire("eGOwo");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $92xoS = parcelRequire("92xoS");

var $k71qx = parcelRequire("k71qx");

var $bMFKb = parcelRequire("bMFKb");
var $cd124 = parcelRequire("cd124");

var $fIrg1 = parcelRequire("fIrg1");

var $9LhzF = parcelRequire("9LhzF");
var $cCaJX = parcelRequire("cCaJX");
var $4nqSo = parcelRequire("4nqSo");

var $dcudV = parcelRequire("dcudV");

var $avm98 = parcelRequire("avm98");

var $aYKcT = parcelRequire("aYKcT");

var $UpZp1 = parcelRequire("UpZp1");
function $cbb0a0fcde007d3a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// helps adjusts position of popup
const $cbb0a0fcde007d3a$var$colorPickerButtonWrapper = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $cbb0a0fcde007d3a$var$colorPickerExpandContainer = (0, $1DXK0.xcss)({
    marginTop: 'space.0',
    marginBottom: 'space.0',
    marginLeft: 'space.negative.050',
    marginRight: 'space.negative.050'
});
const $cbb0a0fcde007d3a$var$colorPickerExpandContainerVisualRefresh = (0, $1DXK0.xcss)({
    marginTop: 'space.negative.025',
    marginRight: 'space.negative.050'
});
const $cbb0a0fcde007d3a$var$colorPickerButtonStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    button: {
        '&::after': {
            border: 'none'
        },
        '&:hover': {
            backgroundColor: `${"var(--ds-background-selected, #E9F2FF)"}`
        }
    }
});
// Control the size of color picker buttons and preview
// TODO: DSP-4134 - Color picking UI
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $cbb0a0fcde007d3a$var$colorPickerWrapper = ()=>/*#__PURE__*/ (0, $1NIU8.css)({
        borderRadius: "var(--ds-radius-small, 3px)",
        backgroundColor: "var(--ds-surface-overlay, #FFFFFF)",
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)",
        padding: `${"var(--ds-space-100, 8px)"} 0px`
    });
const $cbb0a0fcde007d3a$var$ColorPaletteWithReactViewListeners = (0, $dcudV.default)((0, $9LhzF.default));
const $cbb0a0fcde007d3a$var$ColorPickerButton = (props)=>{
    const buttonRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const [isPopupOpen, setIsPopupOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(false);
    const [isPopupPositioned, setIsPopupPositioned] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(false);
    const [isOpenedByKeyboard, setIsOpenedByKeyboard] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(false);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const togglePopup = ()=>{
        setIsPopupOpen(!isPopupOpen);
        if (!isPopupOpen) {
            setIsOpenedByKeyboard(false);
            setIsPopupPositioned(false);
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        if (props.setDisableParentScroll) props.setDisableParentScroll(isPopupOpen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isPopupOpen
    ]);
    const focusButton = ()=>{
        buttonRef.current?.focus();
    };
    const handleEsc = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        setIsOpenedByKeyboard(false);
        setIsPopupPositioned(false);
        setIsPopupOpen(false);
        focusButton();
    }, []);
    const onPositionCalculated = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((position)=>{
        setIsPopupPositioned(true);
        return position;
    }, []);
    const { onChange: onChange, createAnalyticsEvent: createAnalyticsEvent, colorPalette: colorPalette, placement: placement, skipFocusButtonAfterPick: skipFocusButtonAfterPick } = props;
    const onColorSelected = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((color, label)=>{
        setIsOpenedByKeyboard(false);
        setIsPopupOpen(false);
        setIsPopupPositioned(false);
        if (onChange) {
            if (createAnalyticsEvent) {
                // fire analytics
                const payload = {
                    action: (0, $bMFKb.ACTION).UPDATED,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).PICKER,
                    actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).PICKER_COLOR,
                    attributes: {
                        color: color,
                        label: label,
                        placement: placement
                    },
                    eventType: (0, $bMFKb.EVENT_TYPE).TRACK
                };
                createAnalyticsEvent(payload).fire((0, $cd124.editorAnalyticsChannel));
            }
            const newPalette = colorPalette.find((colorPalette)=>colorPalette.value === color);
            newPalette && onChange(newPalette);
        }
        if (!skipFocusButtonAfterPick) focusButton();
    }, [
        colorPalette,
        onChange,
        createAnalyticsEvent,
        placement,
        skipFocusButtonAfterPick
    ]);
    const renderPopup = ()=>{
        if (!isPopupOpen || !buttonRef.current) return;
        const selectedColor = props.currentColor || null;
        const { selectedRowIndex: selectedRowIndex, selectedColumnIndex: selectedColumnIndex } = (0, $4nqSo.getSelectedRowAndColumnFromPalette)(props.colorPalette, selectedColor, props.cols);
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $avm98.default), {
            target: buttonRef.current,
            fitHeight: 350,
            fitWidth: 350,
            offset: [
                0,
                10
            ],
            alignX: props.alignX,
            mountTo: props.setDisableParentScroll ? props.mountPoint : undefined,
            absoluteOffset: props.absoluteOffset,
            // Confluence inline comment editor has z-index: 500
            // if the toolbar is scrollable, this will be mounted in the root editor
            // we need an index of > 500 to display over it
            zIndex: props.setDisableParentScroll ? 600 : undefined,
            ariaLabel: (0, $eGOwo.fg)('editor_a11y_aria_label_removal_popup') ? formatMessage((0, $fIrg1.colorPickerButtonMessages).colorPickerMenuLabel) : 'Color picker popup',
            onPositionCalculated: onPositionCalculated
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $cbb0a0fcde007d3a$var$colorPickerWrapper,
            "data-test-id": "color-picker-menu"
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $aYKcT.ArrowKeyNavigationProvider), {
            type: (0, $UpZp1.ArrowKeyNavigationType).COLOR,
            selectedRowIndex: selectedRowIndex,
            selectedColumnIndex: selectedColumnIndex,
            closeOnTab: true,
            handleClose: ()=>setIsPopupOpen(false),
            isOpenedByKeyboard: isOpenedByKeyboard,
            isPopupPositioned: isPopupPositioned,
            ignoreEscapeKey: props.returnEscToButton
        }, /*#__PURE__*/ (0, $1NIU8.jsx)($cbb0a0fcde007d3a$var$ColorPaletteWithReactViewListeners, {
            cols: props.cols,
            selectedColor: selectedColor,
            onClick: onColorSelected,
            handleClickOutside: togglePopup,
            handleEscapeKeydown: handleEsc,
            paletteOptions: {
                palette: props.colorPalette,
                hexToPaletteColor: props.hexToPaletteColor,
                paletteColorTooltipMessages: props.paletteColorTooltipMessages
            }
        }))));
    };
    const title = props.title || '';
    const currentColor = props.currentColor && props.hexToPaletteColor ? props.hexToPaletteColor(props.currentColor) : props.currentColor;
    const buttonStyle = ()=>/*#__PURE__*/ (0, $1NIU8.css)({
            padding: `${"var(--ds-space-075, 6px)"} 10px`,
            backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${!!props.size?.height ? 'inherit' : ''}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:before': {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                alignSelf: 'center',
                content: "''",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                border: `${"var(--ds-border-width, 1px)"} solid ${(0, $cCaJX.DEFAULT_BORDER_COLOR)}`,
                borderRadius: "var(--ds-radius-small, 3px)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: currentColor || 'transparent',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: props.size?.width || '14px',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: props.size?.height || '14px',
                padding: 0,
                margin: `0px ${"var(--ds-space-025, 2px)"}`
            },
            '&:hover': {
                background: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
            }
        });
    const buttonStyleVisualRefresh = ()=>/*#__PURE__*/ (0, $1NIU8.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${!!props.size?.height ? 'inherit' : ''}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:before': {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                alignSelf: 'center',
                content: "''",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                border: `${"var(--ds-border-width, 1px)"} solid ${(0, $cCaJX.DEFAULT_BORDER_COLOR)}`,
                borderRadius: "var(--ds-radius-small, 3px)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: currentColor || 'transparent',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: props.size?.width || '14px',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: props.size?.height || '14px',
                marginTop: `${"var(--ds-space-025, 2px)"}`
            }
        });
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $cbb0a0fcde007d3a$var$colorPickerButtonWrapper
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k71qx.default), {
        content: title,
        position: "top"
    }, (0, $eGOwo.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $cbb0a0fcde007d3a$var$colorPickerButtonStyle
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $5CSKW.default), {
        appearance: 'subtle',
        ref: buttonRef,
        "aria-label": title,
        "aria-expanded": props.isAriaExpanded ? isPopupOpen : undefined,
        spacing: (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? 'default' : 'compact',
        onClick: togglePopup,
        onKeyDown: (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                togglePopup();
                setIsOpenedByKeyboard(true);
            }
        },
        "data-selected-color": props.currentColor,
        isSelected: isPopupOpen
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $3Wh6p.default), {
        alignBlock: "start"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: buttonStyleVisualRefresh
    }), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8nu6j.default), {
        xcss: $cbb0a0fcde007d3a$var$colorPickerExpandContainerVisualRefresh
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
        color: "currentColor",
        spacing: "spacious",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($1UIWS))),
        label: "color-picker-chevron-down",
        size: "small"
    }))))) : /*#__PURE__*/ (0, $1NIU8.jsx)((0, $goZPP.default), {
        appearance: 'subtle',
        ref: buttonRef,
        "aria-label": title,
        "aria-expanded": props.isAriaExpanded ? isPopupOpen : undefined,
        spacing: "compact",
        onClick: togglePopup,
        onKeyDown: (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                togglePopup();
                setIsOpenedByKeyboard(true);
            }
        },
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        css: buttonStyle,
        iconAfter: /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8nu6j.default), {
            xcss: $cbb0a0fcde007d3a$var$colorPickerExpandContainer
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
            color: "currentColor",
            spacing: "spacious",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($1UIWS))),
            label: "color-picker-chevron-down",
            size: "small"
        })),
        "data-selected-color": props.currentColor
    })), renderPopup());
};
var $cbb0a0fcde007d3a$export$2e2bcd8739ae039 = (0, $dUaMU.default)({
    source: 'ConfigPanel'
})((0, $4J0ad.default)()($cbb0a0fcde007d3a$var$ColorPickerButton));

});
parcelRegister("fIrg1", function(module, exports) {
$parcel$export(module.exports, "colorPickerButtonMessages", () => $afc8b012020513ab$export$46fbf624c87d759a);

var $7qGN1 = parcelRequire("7qGN1");
const $afc8b012020513ab$export$46fbf624c87d759a = (0, $7qGN1.defineMessages)({
    colorPickerMenuLabel: {
        id: 'fabric.editor.colorPicker.menuLabel',
        defaultMessage: 'Color picker menu',
        description: 'The label for the color picker menu popup window'
    }
});

});

parcelRegister("9LhzF", function(module, exports) {
$parcel$export(module.exports, "default", () => $32e4808298e8647e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $ku9IZ = parcelRequire("ku9IZ");

var $6YFG2 = parcelRequire("6YFG2");

var $58yRG = parcelRequire("58yRG");

var $cvtBW = parcelRequire("cvtBW");

var $ebo8n = parcelRequire("ebo8n");

var $681M3 = parcelRequire("681M3");

var $4nqSo = parcelRequire("4nqSo");
/**
 * For a given color pick the color from a list of colors with
 * the highest contrast
 *
 * @param color color string, supports HEX, RGB, RGBA etc.
 * @param useIconToken boolean, describes if a token should be used for the icon color
 * @return Highest contrast color in pool
 */ function $32e4808298e8647e$var$getCheckMarkColor(color, useIconToken) {
    const tokenVal = (0, $4nqSo.getTokenCSSVariableValue)(color);
    const colorValue = !!tokenVal ? tokenVal : color;
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    const contrastColor = [
        '#FFFFFF',
        '#42526E'
    ].sort((a, b)=>(0, $ku9IZ.default).difference(b, colorValue) - (0, $ku9IZ.default).difference(a, colorValue))[0];
    if (!useIconToken) return contrastColor;
    // Use of these token comes from guidance from designers in the Design System team
    // they are only intended for use with text colors (and there are different tokens
    // planned to be used when this extended to be used with other palettes).
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    return contrastColor === '#FFFFFF' ? "var(--ds-icon-inverse, #FFFFFF)" : "var(--ds-icon, #44546F)";
}
const $32e4808298e8647e$var$ColorPalette = (props)=>{
    const { cols: cols = (0, $4nqSo.DEFAULT_COLOR_PICKER_COLUMNS), onClick: onClick, onKeyDown: onKeyDown, selectedColor: selectedColor, className: className, intl: { formatMessage: formatMessage }, paletteOptions: paletteOptions } = props;
    const { palette: palette, hexToPaletteColor: hexToPaletteColor, paletteColorTooltipMessages: paletteColorTooltipMessages } = paletteOptions;
    const { colorMode: tokenTheme } = (0, $58yRG.default)();
    const useIconToken = !!hexToPaletteColor;
    const colorsPerRow = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>{
        return (0, $4nqSo.getColorsPerRowFromPalette)(palette, cols);
    }, [
        palette,
        cols
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, colorsPerRow.map((row)=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: (0, $681M3.colorPaletteWrapper),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            key: `row-first-color-${row[0].value}`,
            role: "radiogroup"
        }, row.map(({ value: value, label: label, border: border, message: message, decorator: decorator })=>{
            if (paletteColorTooltipMessages) {
                if (tokenTheme === 'dark') message = (0, $ebo8n.default)(paletteColorTooltipMessages.dark, value.toUpperCase());
                if (tokenTheme === 'light') message = (0, $ebo8n.default)(paletteColorTooltipMessages.light, value.toUpperCase());
            }
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $cvtBW.default), {
                key: value,
                value: value,
                borderColor: border,
                label: message ? formatMessage(message) : label,
                onClick: onClick,
                onKeyDown: onKeyDown,
                isSelected: value === selectedColor,
                checkMarkColor: $32e4808298e8647e$var$getCheckMarkColor(value, useIconToken),
                hexToPaletteColor: hexToPaletteColor,
                decorator: decorator
            });
        }))));
};
var $32e4808298e8647e$export$2e2bcd8739ae039 = (0, $6YFG2.default)($32e4808298e8647e$var$ColorPalette);

});
parcelRegister("cvtBW", function(module, exports) {
$parcel$export(module.exports, "default", () => $097f2dead47b1ccd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6XkOW = parcelRequire("6XkOW");

var $k71qx = parcelRequire("k71qx");

var $1vZkV = parcelRequire("1vZkV");
const $097f2dead47b1ccd$var$Color = (props)=>{
    const { autoFocus: autoFocus, tabIndex: tabIndex, value: value, label: label, isSelected: isSelected, borderColor: borderColor, checkMarkColor: checkMarkColor = '#FFFFFF', hexToPaletteColor: /**
     * When hexToPaletteColor prop is set,
     * it will be used to get background color style based on
     * value (which will be hexcode) prop
     */ hexToPaletteColor, decorator: decorator } = props;
    const colorStyle = hexToPaletteColor ? hexToPaletteColor(value) : value;
    const onMouseDown = (e)=>{
        e.preventDefault();
    };
    const onClick = (e)=>{
        const { onClick: onClick, value: value, label: label } = props;
        e.preventDefault();
        onClick(value, label);
    };
    const onKeyDown = (e)=>{
        const { onKeyDown: onKeyDown, value: value, label: label } = props;
        if (!onKeyDown) return undefined;
        e.preventDefault();
        onKeyDown(value, label, e);
    };
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k71qx.default), {
        content: label
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: (0, $1vZkV.buttonWrapperStyle)
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("button", {
        type: "button",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $1vZkV.buttonStyle),
        "aria-label": label,
        role: "radio",
        "aria-checked": isSelected,
        onClick: onClick,
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        tabIndex: tabIndex,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${isSelected ? 'selected' : ''}`,
        style: {
            backgroundColor: colorStyle || "var(--ds-background-input, #FFFFFF)",
            border: `${"var(--ds-border-width, 1px)"} solid ${borderColor}`
        },
        autoFocus: autoFocus
    }, !decorator && isSelected && /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6XkOW))), {
        LEGACY_primaryColor: checkMarkColor,
        label: ""
    }), decorator)));
};
var $097f2dead47b1ccd$export$2e2bcd8739ae039 = $097f2dead47b1ccd$var$Color;

});
parcelRegister("1vZkV", function(module, exports) {
$parcel$export(module.exports, "buttonStyle", () => $d6ef09183541af4d$export$fd4d27a26b4854f3);
$parcel$export(module.exports, "buttonWrapperStyle", () => $d6ef09183541af4d$export$7afe8f4b3442c19d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");
const $d6ef09183541af4d$export$fd4d27a26b4854f3 = /*#__PURE__*/ (0, $1NIU8.css)({
    height: '26px',
    width: '26px',
    background: "var(--ds-background-neutral, #091E420F)",
    padding: 0,
    borderRadius: "var(--ds-radius-small, 4px)",
    border: `1px solid ${"var(--ds-border-inverse, #FFFFFF)"}`,
    cursor: 'pointer',
    display: 'block'
});
const $d6ef09183541af4d$export$7afe8f4b3442c19d = /*#__PURE__*/ (0, $1NIU8.css)({
    border: '1px solid transparent',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 0,
    display: 'flex',
    alignItems: 'center',
    padding: "var(--ds-space-025, 2px)",
    borderRadius: "var(--ds-radius-medium, 6px)",
    '&:focus-within, &:focus, &:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        borderColor: `${"var(--ds-border, #091E4224)"} !important`
    }
}); /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ 

});


parcelRegister("ebo8n", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae7458f81f0a9e75$export$2e2bcd8739ae039);
function $ae7458f81f0a9e75$export$2e2bcd8739ae039(messages, color) {
    const message = messages[color];
    if (!message) // eslint-disable-next-line no-console
    console.warn(`Text color palette does not have an internationalization message for color ${color.toUpperCase()}.
You must add a message description to properly translate this color.
Using current label as default message.
This could have happen when someone changed the 'colorPalette' from 'adf-schema' without updating this file.
`);
    return message;
}

});

parcelRegister("681M3", function(module, exports) {
$parcel$export(module.exports, "colorPaletteWrapper", () => $b00a39b590f88570$export$506342f5c0767858);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");
const $b00a39b590f88570$export$506342f5c0767858 = /*#__PURE__*/ (0, $1NIU8.css)({
    padding: `0 ${"var(--ds-space-100, 8px)"}`,
    /* Firefox bug fix: https://product-fabric.atlassian.net/browse/ED-1789 */ display: 'flex'
});

});

parcelRegister("4nqSo", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_COLOR_PICKER_COLUMNS", () => $4fef7fadf2d9b7ec$export$dc37d14f75a32acb);
$parcel$export(module.exports, "getColorsPerRowFromPalette", () => $4fef7fadf2d9b7ec$export$d97d52770ca27b6f);
$parcel$export(module.exports, "getSelectedRowAndColumnFromPalette", () => $4fef7fadf2d9b7ec$export$c16ae5b27ec0c8f6);
$parcel$export(module.exports, "getTokenCSSVariableValue", () => $4fef7fadf2d9b7ec$export$426cbff16166281c);
const $4fef7fadf2d9b7ec$export$dc37d14f75a32acb = 7;
function $4fef7fadf2d9b7ec$export$d97d52770ca27b6f(palette, cols = $4fef7fadf2d9b7ec$export$dc37d14f75a32acb) {
    return palette.reduce((resultArray, item, index)=>{
        const chunkIndex = Math.floor(index / cols);
        resultArray[chunkIndex] = resultArray[chunkIndex] || []; // start a new chunk
        resultArray[chunkIndex].push(item);
        return resultArray;
    }, []);
}
function $4fef7fadf2d9b7ec$export$17092ffd56d3b3b2(colorsPerRow, selectedColor) {
    let selectedRowIndex = -1;
    let selectedColumnIndex = -1;
    colorsPerRow.forEach((row, rowIndex)=>{
        row.forEach(({ value: value }, columnIndex)=>{
            if (value === selectedColor) {
                selectedRowIndex = rowIndex;
                selectedColumnIndex = columnIndex;
            }
        });
    });
    return {
        selectedRowIndex: selectedRowIndex,
        selectedColumnIndex: selectedColumnIndex
    };
}
function $4fef7fadf2d9b7ec$export$c16ae5b27ec0c8f6(palette, selectedColor, cols = $4fef7fadf2d9b7ec$export$dc37d14f75a32acb) {
    const colorsPerRow = $4fef7fadf2d9b7ec$export$d97d52770ca27b6f(palette, cols);
    return $4fef7fadf2d9b7ec$export$17092ffd56d3b3b2(colorsPerRow, selectedColor);
}
const $4fef7fadf2d9b7ec$export$426cbff16166281c = (variableExpression)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const matcher = variableExpression.match(/var\(([^,\)]+)(,.*)?\)/);
    if (matcher) {
        const variable = matcher[1].trim();
        const fallback = matcher[2] ? matcher[2].replace(',', '').trim() : '';
        if (typeof document === 'undefined') return fallback;
        const value = window.getComputedStyle(document.documentElement).getPropertyValue(variable).trim();
        return value || fallback;
    }
    return '';
};

});


parcelRegister("cCaJX", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_BORDER_COLOR", () => $59916a1f984da1b9$export$f54f5cacf382b9f2);

var $ku9IZ = parcelRequire("ku9IZ");
/**
 * For a given color set the alpha channel to alpha
 *
 * @param color color string, suppports HEX, RGB, RGBA etc.
 * @param alpha Alpha channel value as fraction of 1
 * @return CSS RGBA string with applied alpha channel
 */ function $59916a1f984da1b9$var$setAlpha(color, alpha) {
    const { r: r, g: g, b: b } = (0, $ku9IZ.default).convert(color).rgb;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
const $59916a1f984da1b9$export$f54f5cacf382b9f2 = $59916a1f984da1b9$var$setAlpha('#172B4D', 0.12); /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ 

});


parcelRegister("9rPmE", function(module, exports) {
$parcel$export(module.exports, "default", () => $27bf2e5efb032df3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $knwdo = parcelRequire("knwdo");

var $UpZp1 = parcelRequire("UpZp1");
var $cigQc = parcelRequire("cigQc");

var $1OQKp = parcelRequire("1OQKp");

var $1UIWS = parcelRequire("1UIWS");

var $d1JoN = parcelRequire("d1JoN");

var $4GAH8 = parcelRequire("4GAH8");
function $27bf2e5efb032df3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $27bf2e5efb032df3$var$dropdownExpandContainer = /*#__PURE__*/ (0, $1NIU8.css)({
    margin: `0px ${"var(--ds-space-negative-050, -4px)"}`
});
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $27bf2e5efb032df3$var$iconGroup = {
    name: "zjik7",
    styles: "display:flex"
};
const $27bf2e5efb032df3$var$CompositeIcon = ({ icon: icon })=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $27bf2e5efb032df3$var$iconGroup
    }, icon, /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $27bf2e5efb032df3$var$dropdownExpandContainer
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
        color: "currentColor",
        spacing: "spacious",
        label: "Expand dropdown menu",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($1UIWS))),
        size: "small"
    })));
class $27bf2e5efb032df3$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    render() {
        const { isOpen: isOpen } = this.state;
        const { title: title, icon: icon, iconBefore: iconBefore, options: options, dispatchCommand: dispatchCommand, mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement, hideExpandIcon: hideExpandIcon, disabled: disabled, tooltip: tooltip, buttonTestId: buttonTestId, dropdownWidth: dropdownWidth, dropdownListId: dropdownListId, alignDropdownWithToolbar: alignDropdownWithToolbar, footer: footer, onMount: onMount, pulse: pulse, spotlightConfig: spotlightConfig, shouldFitContainer: shouldFitContainer, alignX: alignX, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = this.props;
        let trigger;
        if (icon) {
            const TriggerIcon = hideExpandIcon ? icon : /*#__PURE__*/ (0, $1NIU8.jsx)($27bf2e5efb032df3$var$CompositeIcon, {
                icon: icon
            });
            trigger = /*#__PURE__*/ (0, $1NIU8.jsx)((0, $knwdo.default), {
                testId: buttonTestId,
                title: title,
                icon: TriggerIcon,
                onClick: this.toggleOpen,
                onKeyDown: this.toggleOpenByKeyboard,
                selected: isOpen,
                disabled: disabled,
                tooltipContent: tooltip,
                ariaHasPopup: areAnyNewToolbarFlagsEnabled ? true : undefined,
                onMount: onMount,
                pulse: pulse,
                spotlightConfig: spotlightConfig,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            });
        } else trigger = /*#__PURE__*/ (0, $1NIU8.jsx)((0, $knwdo.default), {
            testId: buttonTestId,
            iconAfter: /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
                css: $27bf2e5efb032df3$var$dropdownExpandContainer
            }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
                color: "currentColor",
                spacing: "spacious",
                label: "Expand dropdown menu",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($1UIWS))),
                size: "small"
            })),
            icon: iconBefore,
            onClick: this.toggleOpen,
            onKeyDown: this.toggleOpenByKeyboard,
            selected: isOpen,
            disabled: disabled,
            tooltipContent: tooltip,
            ariaHasPopup: true,
            areaControls: dropdownListId,
            onMount: onMount,
            pulse: pulse,
            spotlightConfig: spotlightConfig,
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }, title);
        /**
     * We want to change direction of our dropdowns a bit early,
     * not exactly when it hits the boundary.
     */ const fitTolerance = 10;
        const fitWidth = Array.isArray(options) || typeof options === 'function' ? dropdownWidth || (0, $4GAH8.menuItemDimensions).width : options.width;
        const fitHeight = Array.isArray(options) ? options.length * (0, $4GAH8.menuItemDimensions).height + (0, $4GAH8.itemSpacing) * 2 : typeof options === 'function' ? this.makeArrayOptionsFromCallback(options).length : options.height;
        return(/**
       * At the moment footer diver is rendered along with footer, if it's provided
       * This is to provide some level of consistency
       * Refer to the PR for more details:
       * https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/137394/overview?commentId=8130003
       */ /*#__PURE__*/ (0, $1NIU8.jsx)((0, $cigQc.DropdownContainer), {
            alignX: alignX,
            mountTo: mountPoint,
            boundariesElement: boundariesElement,
            scrollableElement: scrollableElement,
            isOpen: isOpen,
            handleClickOutside: this.hide,
            handleEscapeKeydown: this.hideOnEsc,
            onOpenChange: this.onOpenChanged,
            fitWidth: fitWidth + fitTolerance,
            fitHeight: fitHeight + fitTolerance,
            trigger: trigger,
            dropdownListId: dropdownListId,
            alignDropdownWithParentElement: alignDropdownWithToolbar,
            arrowKeyNavigationProviderOptions: {
                type: (0, $UpZp1.ArrowKeyNavigationType).MENU
            },
            shouldFitContainer: shouldFitContainer
        }, Array.isArray(options) ? this.renderArrayOptions(options) : typeof options === 'function' ? this.renderArrayOptions(this.makeArrayOptionsFromCallback(options)) : options.render({
            hide: this.hide,
            dispatchCommand: dispatchCommand
        }), footer && /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $d1JoN.Divider), null), footer)));
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.isOpen !== this.state.isOpen) {
            if (this.props.setDisableParentScroll) this.props.setDisableParentScroll(this.state.isOpen);
            // ECA11Y-235: no sense in sending keyboard event since the menu popup mounted to the custom element,
            // we will ensure first element focused asap as 'MenuArrowKeyNavigationProvider' is mounted
            if (this.props.mountPoint) return;
            if (this.state.isOpen && this.state.isOpenedByKeyboard) {
                const dropList = document.querySelector('[data-role="droplistContent"]');
                if (dropList) // Add setTimeout so that if a dropdown item has tooltip,
                // the tooltip won't be rendered until next render cycle
                // when the droplist is correctly positioned.
                // This makes tooltip appears at the correct position for the first dropdown item.
                setTimeout(()=>{
                    const keyboardEvent = new KeyboardEvent('keydown', {
                        bubbles: true,
                        key: 'ArrowDown'
                    });
                    dropList.dispatchEvent(keyboardEvent);
                }, 0);
            }
        }
    }
    constructor(...args){
        super(...args), this.state = {
            isOpen: false,
            isOpenedByKeyboard: false
        }, this.triggerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.makeArrayOptionsFromCallback = (makeOptions)=>{
            const options = makeOptions();
            return options;
        }, this.renderArrayOptions = (options)=>{
            const { showSelected: showSelected, dispatchCommand: dispatchCommand, editorView: editorView, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = this.props;
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $4GAH8.default), {
                hide: this.hide,
                dispatchCommand: dispatchCommand,
                items: options,
                showSelected: showSelected,
                editorView: editorView,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            });
        }, this.toggleOpen = ()=>{
            const onClick = this.props.onClick;
            if (onClick) onClick();
            this.setState({
                isOpen: !this.state.isOpen,
                isOpenedByKeyboard: false
            });
            const onToggle = this.props.onToggle;
            if (!onToggle) return;
            requestAnimationFrame(()=>{
                this.props.dispatchCommand(onToggle);
            });
        }, this.toggleOpenByKeyboard = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.setState({
                    isOpen: !this.state.isOpen,
                    isOpenedByKeyboard: true
                });
            }
        }, this.hide = ()=>{
            this.setState({
                ...this.state,
                isOpen: false
            });
        }, this.hideOnEsc = ()=>{
            // Focus the trigger button only on Escape
            // Focus is done before hiding to ensure onBlur is called
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            document.querySelector(`[data-testid=${this.props.buttonTestId}]`)?.focus();
            this.hide();
        }, this.onOpenChanged = (openChangedEvent)=>{
            if (!openChangedEvent.isOpen && openChangedEvent.event instanceof KeyboardEvent) openChangedEvent.event?.key === 'Escape' ? this.hideOnEsc() : this.hide();
        };
    }
}

});
parcelRegister("cigQc", function(module, exports) {
$parcel$export(module.exports, "DropdownContainer", () => $c0a99f03c3224fee$export$49166591ec160d97);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $UpZp1 = parcelRequire("UpZp1");

var $aSEqE = parcelRequire("aSEqE");

var $baHgw = parcelRequire("baHgw");
const $c0a99f03c3224fee$export$49166591ec160d97 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(function DropdownContainer(props) {
    const keyDownHandlerContext = (0, $eJOHy.useContext)((0, $baHgw.KeyDownHandlerContext));
    let newArrowKeyNavigationProviderOptions = props.arrowKeyNavigationProviderOptions;
    // if the dropdown is of type menu, use this keyDownHandlerContext
    if (props.arrowKeyNavigationProviderOptions.type === (0, $UpZp1.ArrowKeyNavigationType).MENU) newArrowKeyNavigationProviderOptions = {
        ...props.arrowKeyNavigationProviderOptions,
        keyDownHandlerContext: keyDownHandlerContext
    };
    return(//This context is to handle the tab, Arrow Right/Left key events for dropdown.
    //Default context has the void callbacks for above key events
    /*#__PURE__*/ (0, $1NIU8.jsx)((0, $aSEqE.default), {
        ...props,
        arrowKeyNavigationProviderOptions: newArrowKeyNavigationProviderOptions
    }));
});

});
parcelRegister("aSEqE", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a3c72f3adb26b0b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $dcudV = parcelRequire("dcudV");

var $jRVxI = parcelRequire("jRVxI");

var $avm98 = parcelRequire("avm98");

var $dwnni = parcelRequire("dwnni");

var $aYKcT = parcelRequire("aYKcT");
class $2a3c72f3adb26b0b$export$931cbfb6bfb85fc extends (0, $eJOHy.PureComponent) {
    constructor(props){
        super(props), this.handleRef = (setOutsideClickTargetRef)=>(target)=>{
                setOutsideClickTargetRef(target);
                this.setState({
                    target: target || undefined
                });
            }, this.updatePopupPlacement = (placement)=>{
            this.setState({
                popupPlacement: placement
            });
        }, this.handleCloseAndFocus = (event)=>{
            this.state.target?.querySelector('button')?.focus();
            this.handleClose(event);
        }, this.handleClose = (event)=>{
            if (this.props.onOpenChange) this.props.onOpenChange({
                isOpen: false,
                event: event
            });
        };
        this.state = {
            popupPlacement: [
                'bottom',
                'left'
            ]
        };
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.isOpen && this.props.isOpen && this.state.target) {
            // Dropdown flickers when opens as placement is calculated in Popup component and updated after the first render.
            // popupPlacement is set to ['bottom', 'left'] by default, but it may not be the correct placement and is required in DropdownList.
            // To avoid flicker we calculate placement here and set it to state when the dropdown opens.
            const initialPlacement = (0, $dwnni.calculatePlacement)(this.state.target, this.props.boundariesElement || document.body, this.props.fitWidth, this.props.fitHeight, this.props.alignX, this.props.alignY, this.props.forcePlacement);
            this.setState({
                popupPlacement: initialPlacement
            });
        }
    }
    renderDropdown() {
        const { target: target, popupPlacement: popupPlacement } = this.state;
        const { children: children, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement, onOpenChange: onOpenChange, fitHeight: fitHeight, fitWidth: fitWidth, zIndex: zIndex, arrowKeyNavigationProviderOptions: arrowKeyNavigationProviderOptions, dropdownListId: dropdownListId, alignDropdownWithParentElement: alignDropdownWithParentElement, target: targetProp, forcePlacement: forcePlacement, alignX: alignX, alignY: alignY, offset: offset, shouldFitContainer: shouldFitContainer = true } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $avm98.default), {
            target: targetProp ?? (alignDropdownWithParentElement ? // eslint-disable-next-line @atlaskit/editor/no-as-casting
            target?.closest("[data-testid='editor-floating-toolbar']") : target),
            mountTo: mountTo,
            boundariesElement: boundariesElement,
            scrollableElement: scrollableElement,
            onPlacementChanged: forcePlacement ? undefined : this.updatePopupPlacement,
            fitHeight: fitHeight,
            fitWidth: fitWidth,
            zIndex: zIndex,
            allowOutOfBounds: alignDropdownWithParentElement,
            alignX: alignX,
            alignY: alignY,
            forcePlacement: forcePlacement,
            offset: offset,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aYKcT.ArrowKeyNavigationProvider), {
                ...arrowKeyNavigationProviderOptions,
                closeOnTab: true,
                handleClose: this.handleCloseAndFocus,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    style: {
                        height: 0,
                        minWidth: fitWidth || 0
                    },
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jRVxI.default), {
                        isOpen: true,
                        onOpenChange: onOpenChange,
                        position: popupPlacement.join(' '),
                        shouldFitContainer: shouldFitContainer,
                        id: dropdownListId,
                        children: children
                    })
                })
            })
        });
    }
    render() {
        const { trigger: trigger, isOpen: isOpen } = this.props;
        return trigger ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dcudV.OutsideClickTargetRefContext).Consumer, {
            children: (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            ref: this.handleRef(setOutsideClickTargetRef),
                            children: trigger
                        }),
                        isOpen ? this.renderDropdown() : null
                    ]
                })
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: isOpen ? this.renderDropdown() : null
        });
    }
}
const $2a3c72f3adb26b0b$var$DropdownWithOuterListeners = (0, $dcudV.default)($2a3c72f3adb26b0b$export$931cbfb6bfb85fc);
var $2a3c72f3adb26b0b$export$2e2bcd8739ae039 = $2a3c72f3adb26b0b$var$DropdownWithOuterListeners;

});


parcelRegister("d1JoN", function(module, exports) {
$parcel$export(module.exports, "Divider", () => $94c9de9b67245fd7$export$2e0a83ec2e27ecbb);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $94c9de9b67245fd7$var$styles = (0, $1DXK0.xcss)({
    width: '100%',
    borderBlockEnd: 'none',
    borderBlockStart: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #091E4224)"}`,
    borderInline: 'none'
});
const $94c9de9b67245fd7$export$2e0a83ec2e27ecbb = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        as: "hr",
        xcss: $94c9de9b67245fd7$var$styles,
        role: "presentation"
    });

});

parcelRegister("4GAH8", function(module, exports) {
$parcel$export(module.exports, "menuItemDimensions", () => $07d5427865cc095d$export$1a7f12094b137d20);
$parcel$export(module.exports, "itemSpacing", () => $07d5427865cc095d$export$e14354b446b68c1f);
$parcel$export(module.exports, "default", () => $07d5427865cc095d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");

var $1MQUb = parcelRequire("1MQUb");
var $8hkbz = parcelRequire("8hkbz");

var $eJOdq = parcelRequire("eJOdq");
const $07d5427865cc095d$export$1a7f12094b137d20 = {
    width: 175,
    height: 32
};
const $07d5427865cc095d$var$headingStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    padding: `${"var(--ds-space-200, 16px)"} 0 ${"var(--ds-space-100, 8px)"}`
});
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
const $07d5427865cc095d$var$menuContainerStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `${$07d5427865cc095d$export$1a7f12094b137d20.width}px`,
    // temporary solution to retain spacing defined by @atlaskit/Item
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& button': {
        minHeight: "var(--ds-space-400, 32px)",
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} 7px`,
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > [data-item-elem-before]': {
            marginRight: "var(--ds-space-050, 4px)"
        }
    }
});
const $07d5427865cc095d$export$e14354b446b68c1f = 4;
const $07d5427865cc095d$var$Dropdown = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>{
    const { hide: hide, dispatchCommand: dispatchCommand, items: items, intl: intl, editorView: editorView, showSelected: showSelected = true, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    if (areAnyNewToolbarFlagsEnabled) return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $07d5427865cc095d$var$menuContainerStyles,
        role: "menu"
    }, items// @ts-ignore
    .filter((item)=>item && (!('hidden' in item) || !item.hidden)).map((item, idx)=>{
        if (!('type' in item)) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $1MQUb.DropdownMenuItem), {
            // Ignored via go/ees005
            // eslint-disable-next-line react/no-array-index-key
            key: idx,
            item: item,
            hide: hide,
            dispatchCommand: dispatchCommand,
            editorView: editorView,
            showSelected: showSelected,
            intl: intl
        });
        if (item.type === 'separator') // eslint-disable-next-line react/no-array-index-key
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8hkbz.DropdownSeparator), {
            key: idx
        });
        if (item.type === 'overflow-dropdown-heading') return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            key: item.title,
            css: $07d5427865cc095d$var$headingStyles
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOdq.default), null, item.title));
        if (item.type === 'custom') {
            const dropdownMenuOptions = {
                hide: hide,
                dispatchCommand: dispatchCommand,
                editorView: editorView,
                showSelected: showSelected,
                intl: intl
            };
            return item.render(editorView, dropdownMenuOptions);
        }
    }));
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $07d5427865cc095d$var$menuContainerStyles,
        role: "menu"
    }, items.filter((item)=>!item.hidden).map((item, idx)=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, $1MQUb.DropdownMenuItem), {
            // Ignored via go/ees005
            // eslint-disable-next-line react/no-array-index-key
            key: idx,
            item: item,
            hide: hide,
            dispatchCommand: dispatchCommand,
            editorView: editorView,
            showSelected: showSelected,
            intl: intl
        })));
});
var $07d5427865cc095d$export$2e2bcd8739ae039 = (0, $6YFG2.default)($07d5427865cc095d$var$Dropdown);

});


parcelRegister("ggPk9", function(module, exports) {
$parcel$export(module.exports, "EmojiPickerButton", () => $e01169f7c66dd85c$export$428fcc6fc228bd52);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $Ay1uj = parcelRequire("Ay1uj");

var $cxXTK = parcelRequire("cxXTK");

var $avm98 = parcelRequire("avm98");

var $dcudV = parcelRequire("dcudV");
parcelRequire("lWZLb");
var $l1j5w = parcelRequire("l1j5w");

var $gxQLu = parcelRequire("gxQLu");

var $eGOwo = parcelRequire("eGOwo");

var $k71qx = parcelRequire("k71qx");

var $kv4Vh = parcelRequire("kv4Vh");
function $e01169f7c66dd85c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $e01169f7c66dd85c$var$emojiPickerButtonWrapper = {
    name: "1o944d1",
    styles: "position:relative;button{top:-1px;&:not([disabled])::after{border:none;}}svg{path{transform-origin:50% 50%;transform:scale(1.14);}}"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $e01169f7c66dd85c$var$emojiPickerButtonWrapperVisualRefresh = {
    name: "1spoyok",
    styles: "position:relative;button{&:not([disabled])::after{border:none;}}"
};
const $e01169f7c66dd85c$var$selector = (states)=>{
    return states.emojiState?.emojiProvider;
};
const $e01169f7c66dd85c$var$EmojiPickerWithProvider = (props)=>{
    const emojiProvider = (0, $cxXTK.useSharedPluginStateWithSelector)(props.pluginInjectionApi, [
        'emoji'
    ], $e01169f7c66dd85c$var$selector);
    const setOutsideClickTargetRef = (0, $eJOHy.useContext)((0, $dcudV.OutsideClickTargetRefContext));
    if (!emojiProvider) return null;
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $l1j5w.default), {
        emojiProvider: Promise.resolve(emojiProvider),
        onSelection: props.updateEmoji,
        onPickerRef: setOutsideClickTargetRef
    });
};
// Note: These are based on the height and width of the emoji picker at the time
// of writing (2025-05-05). It is 100% prone to change but at least it's vaguely
// written down.
const $e01169f7c66dd85c$var$EMOJI_PICKER_MAX_HEIGHT = 431;
const $e01169f7c66dd85c$var$EMOJI_PICKER_MAX_WIDTH = 352;
const $e01169f7c66dd85c$var$EmojiPickerWithListener = (0, $dcudV.default)($e01169f7c66dd85c$var$EmojiPickerWithProvider);
const $e01169f7c66dd85c$export$428fcc6fc228bd52 = (props)=>{
    const buttonRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const [isPopupOpen, setIsPopupOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        if (props.setDisableParentScroll) props.setDisableParentScroll(isPopupOpen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isPopupOpen
    ]);
    const togglePopup = (0, $eJOHy.useCallback)(()=>{
        setIsPopupOpen(!isPopupOpen);
    }, [
        setIsPopupOpen,
        isPopupOpen
    ]);
    const updateEmoji = (emoji)=>{
        setIsPopupOpen(false);
        props.onChange && props.onChange(emoji);
        requestAnimationFrame(()=>{
            props.editorView?.focus();
        });
    };
    const isDetachedElement = (0, $eJOHy.useCallback)((el)=>!document.body.contains(el), []);
    const handleEmojiClickOutside = (0, $eJOHy.useCallback)((e)=>{
        // Ignore click events for detached elements.
        // Workaround for CETI-240 - where two onClicks fire - one when the upload button is
        // still in the document, and one once it's detached. Does not always occur, and
        // may be a side effect of a react render optimisation
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        if (e && e.target && !isDetachedElement(e.target)) togglePopup();
    }, [
        isDetachedElement,
        togglePopup
    ]);
    const handleEmojiPressEscape = (0, $eJOHy.useCallback)(()=>{
        setIsPopupOpen(false);
        buttonRef.current?.focus();
    }, [
        setIsPopupOpen,
        buttonRef
    ]);
    const renderPopup = ()=>{
        if (!buttonRef.current || !isPopupOpen) return;
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $avm98.default), {
            target: buttonRef.current,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            mountTo: props.setDisableParentScroll ? props.mountPoint : buttonRef.current.parentElement,
            fitHeight: $e01169f7c66dd85c$var$EMOJI_PICKER_MAX_HEIGHT,
            fitWidth: $e01169f7c66dd85c$var$EMOJI_PICKER_MAX_WIDTH,
            offset: [
                0,
                10
            ],
            // Confluence inline comment editor has z-index: 500
            // if the toolbar is scrollable, this will be mounted in the root editor
            // we need an index of > 500 to display over it
            zIndex: props.setDisableParentScroll ? 600 : undefined,
            focusTrap: true,
            preventOverflow: true,
            boundariesElement: props.popupsBoundariesElement
        }, /*#__PURE__*/ (0, $1NIU8.jsx)($e01169f7c66dd85c$var$EmojiPickerWithListener, {
            handleEscapeKeydown: handleEmojiPressEscape,
            handleClickOutside: handleEmojiClickOutside,
            pluginInjectionApi: props.pluginInjectionApi,
            updateEmoji: updateEmoji
        }));
    };
    const title = props.title || '';
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: (0, $eGOwo.fg)('platform-visual-refresh-icons') ? $e01169f7c66dd85c$var$emojiPickerButtonWrapperVisualRefresh : $e01169f7c66dd85c$var$emojiPickerButtonWrapper
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k71qx.default), {
        content: title,
        position: "top"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $Ay1uj.default), {
        appearance: "subtle",
        key: props.idx,
        onClick: togglePopup,
        ref: buttonRef,
        isSelected: props.isSelected,
        label: title,
        spacing: "compact",
        icon: ()=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gxQLu))), {
                color: "currentColor",
                LEGACY_fallbackIcon: (0, $kv4Vh.default),
                label: "emoji-picker-button",
                spacing: "spacious"
            })
    })), renderPopup());
};

});
parcelRegister("lWZLb", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba2e156c3bc0aa00$export$2e2bcd8739ae039);
$parcel$export(module.exports, "EmojiPicker", () => (parcelRequire("l1j5w")).default);
parcelRequire("kp3br");
var $7Eo2D = parcelRequire("7Eo2D");

var $i4Ljn = parcelRequire("i4Ljn");


var $4IKFn = parcelRequire("4IKFn");

var $l1j5w = parcelRequire("l1j5w");



var $aIqUF = parcelRequire("aIqUF");


var $53MhD = parcelRequire("53MhD");





var $db4JS = parcelRequire("db4JS");
var $jZzVI = parcelRequire("jZzVI");

var $8iUeU = parcelRequire("8iUeU");





var $4FlMD = parcelRequire("4FlMD");

var $adGgK = parcelRequire("adGgK");
var $ba2e156c3bc0aa00$export$2e2bcd8739ae039 = (0, $l1j5w.default);

});
parcelRegister("i4Ljn", function(module, exports) {
$parcel$export(module.exports, "EmojiNodeWrapper", () => $ce7d8292c0049cae$export$ce5eef59d8e46687);
$parcel$export(module.exports, "default", () => $ce7d8292c0049cae$export$2e2bcd8739ae039);
/* Emoji.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $cBxa0 = parcelRequire("cBxa0");

var $8iUeU = parcelRequire("8iUeU");

var $fqzOa = parcelRequire("fqzOa");

var $adGgK = parcelRequire("adGgK");

var $huLzh = parcelRequire("huLzh");

var $01aoY = parcelRequire("01aoY");


var $8B8Wm = parcelRequire("8B8Wm");
var $iVp1F = parcelRequire("iVp1F");

var $3PZQJ = parcelRequire("3PZQJ");

var $lXMGu = parcelRequire("lXMGu");

var $8B8Wm = parcelRequire("8B8Wm");

var $4g9mX = parcelRequire("4g9mX");

var $chAs1 = parcelRequire("chAs1");

var $cbSL1 = parcelRequire("cbSL1");

var $eGOwo = parcelRequire("eGOwo");
const $ce7d8292c0049cae$var$emojiSpriteContainer = null;
const $ce7d8292c0049cae$var$emojiImageContainer = null;
const $ce7d8292c0049cae$var$handleMouseDown = (props, event)=>{
    // Clicked emoji delete button
    if (event.target instanceof Element && event.target.getAttribute('aria-label') === (0, $8iUeU.deleteEmojiLabel)) return;
    const { emoji: emoji, onSelected: onSelected } = props;
    if (onSelected && (0, $huLzh.leftClick)(event)) onSelected((0, $fqzOa.toEmojiId)(emoji), emoji, event);
};
const $ce7d8292c0049cae$var$handleKeyDown = (props, event)=>{
    if (!(0, $8iUeU.EMOJI_KEYBOARD_KEYS_SUPPORTED).includes(event.key)) return;
    event.preventDefault();
    event.stopPropagation();
    const { emoji: emoji, onSelected: onSelected, showDelete: showDelete } = props;
    if (onSelected && (event.key === (0, $8iUeU.KeyboardKeys).Enter || event.key === (0, $8iUeU.KeyboardKeys).Space)) onSelected((0, $fqzOa.toEmojiId)(emoji), emoji, event);
    if (showDelete && event.key === (0, $8iUeU.KeyboardKeys).Backspace) $ce7d8292c0049cae$var$handleDelete(props, event);
};
const $ce7d8292c0049cae$var$handleMouseMove = (props, event)=>{
    const { emoji: emoji, onMouseMove: onMouseMove } = props;
    if (onMouseMove) onMouseMove((0, $fqzOa.toEmojiId)(emoji), emoji, event);
};
const $ce7d8292c0049cae$var$handleFocus = (props, event)=>{
    const { emoji: emoji, onFocus: onFocus } = props;
    if (onFocus) onFocus((0, $fqzOa.toEmojiId)(emoji), emoji, event);
};
const $ce7d8292c0049cae$var$handleDelete = (props, event)=>{
    const { emoji: emoji, onDelete: onDelete } = props;
    if (onDelete) onDelete((0, $fqzOa.toEmojiId)(emoji), emoji, event);
};
const $ce7d8292c0049cae$var$handleImageError = (props, event)=>{
    const { emoji: emoji, onLoadError: onLoadError } = props;
    // Hide error state (but keep space for it)
    if (event.target) {
        const target = event.target;
        target.style.visibility = 'hidden';
    }
    if (onLoadError) onLoadError((0, $fqzOa.toEmojiId)(emoji), emoji, event);
};
const $ce7d8292c0049cae$export$ef49ddbb198ce334 = (props)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className } = props;
    const representation = emoji.representation;
    const sprite = representation.sprite;
    const classes = `${(0, $eb4c5e773f9bbee2$export$b06c4aab1d012063)} ${selected ? (0, $eb4c5e773f9bbee2$export$8633a0edef8e95dd) : ''} ${selectOnHover ? (0, $eb4c5e773f9bbee2$export$860109dfd198259b) : ''} ${className ? className : ''}`;
    let sizing = {};
    if (fitToHeight) sizing = {
        width: `${fitToHeight}px`,
        height: `${fitToHeight}px`,
        minHeight: `${fitToHeight}px`,
        minWidth: `${fitToHeight}px`
    };
    const xPositionInPercent = 100 / (sprite.column - 1) * (representation.xIndex - 0);
    const yPositionInPercent = 100 / (sprite.row - 1) * (representation.yIndex - 0);
    const style = {
        backgroundImage: `url(${sprite.url})`,
        backgroundPosition: `${xPositionInPercent}% ${yPositionInPercent}%`,
        backgroundSize: `${sprite.column * 100}% ${sprite.row * 100}%`,
        ...sizing
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $gt9Am.jsx)($ce7d8292c0049cae$export$ce5eef59d8e46687, {
        ...props,
        type: "sprite",
        className: classes,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            className: (0, $eb4c5e773f9bbee2$export$1c10634420a08d8a),
            style: style
        })
    }));
};
const $ce7d8292c0049cae$export$99dfeb9d71c11788 = (props)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className, showDelete: showDelete, onLoadSuccess: onLoadSuccess, disableLazyLoad: disableLazyLoad, autoWidth: autoWidth } = props;
    const [ref, inView] = (0, $lXMGu.useInView)({
        triggerOnce: true
    });
    const ufoExp = (0, $eJOHy.useMemo)(()=>(0, $8B8Wm.sampledUfoRenderedEmoji)(emoji), [
        emoji
    ]);
    const classes = `${(0, $eb4c5e773f9bbee2$export$11462c0756c24ab6)} ${(0, $eb4c5e773f9bbee2$export$b06c4aab1d012063)} ${selected ? (0, $eb4c5e773f9bbee2$export$8633a0edef8e95dd) : ''} ${selectOnHover ? (0, $eb4c5e773f9bbee2$export$860109dfd198259b) : ''} ${(0, $eb4c5e773f9bbee2$export$da61cef1c8919f7c)} ${className ? className : ''} ${showDelete ? (0, $eb4c5e773f9bbee2$export$22b19c311e9caa4) : ''}`;
    let width;
    let height;
    let src;
    const representation = (0, $cBxa0.shouldUseAltRepresentation)(emoji, fitToHeight) ? emoji.altRepresentation : emoji.representation;
    if ((0, $fqzOa.isImageRepresentation)(representation)) {
        src = representation.imagePath;
        width = representation.width;
        height = representation.height;
    } else if ((0, $fqzOa.isMediaRepresentation)(representation)) {
        src = representation.mediaPath;
        width = representation.width;
        height = representation.height;
    }
    let sizing = {};
    if (fitToHeight && width && height) {
        const sizingWidth = autoWidth && (!(0, $chAs1.isSSR)() || (0, $eGOwo.fg)('platform_emoji_ssr_width_auto_allowed')) ? 'auto' : fitToHeight / height * width;
        // Presize image, to prevent reflow due to size changes after loading
        sizing = {
            width: sizingWidth,
            height: fitToHeight
        };
    }
    const onErrorV1 = (0, $eJOHy.useCallback)((event)=>{
        $ce7d8292c0049cae$var$handleImageError(props, event);
    }, [
        props
    ]);
    const onErrorV2 = (0, $eJOHy.useCallback)((event)=>{
        $ce7d8292c0049cae$var$handleImageError({
            emoji: props.emoji,
            onLoadError: props.onLoadError
        }, event);
    }, [
        props.emoji,
        props.onLoadError
    ]);
    const onError = (0, $cbSL1.expValEquals)('cc_complexit_fe_emoji_stability', 'isEnabled', true) ? onErrorV2 : onErrorV1;
    const onLoad = (0, $eJOHy.useCallback)(()=>{
        const mountedMark = ufoExp.metrics.marks.find((mark)=>mark.name === (0, $adGgK.UfoEmojiTimings).MOUNTED_END);
        // onload could trigger before onBeforeLoad when emojis in viewport at start, so we need to mark onload start manually.
        if (!(0, $8B8Wm.hasUfoMarked)(ufoExp, (0, $adGgK.UfoEmojiTimings).ONLOAD_START)) ufoExp.mark((0, $adGgK.UfoEmojiTimings).ONLOAD_START, mountedMark?.time);
        const loadedStartMark = ufoExp.metrics.marks.find((mark)=>mark.name === (0, $adGgK.UfoEmojiTimings).ONLOAD_START);
        if (mountedMark && loadedStartMark) ufoExp.addMetadata({
            lazyLoad: loadedStartMark.time > mountedMark.time
        });
        // onload_start
        if (!(0, $8B8Wm.hasUfoMarked)(ufoExp, (0, $adGgK.UfoEmojiTimings).ONLOAD_END)) ufoExp.mark((0, $adGgK.UfoEmojiTimings).ONLOAD_END);
        ufoExp.success({
            metadata: {
                IBSupported: (0, $3PZQJ.default).supportsIntersectionObserver
            }
        });
        if (onLoadSuccess) onLoadSuccess(emoji);
    }, [
        emoji,
        onLoadSuccess,
        ufoExp
    ]);
    const onBeforeLoad = (0, $eJOHy.useCallback)(()=>{
        if (!(0, $8B8Wm.hasUfoMarked)(ufoExp, (0, $adGgK.UfoEmojiTimings).ONLOAD_START)) ufoExp.mark((0, $adGgK.UfoEmojiTimings).ONLOAD_START);
    }, [
        ufoExp
    ]);
    const onMouseOver = (0, $eJOHy.useCallback)((e)=>{
        // only disable tooltip when not on focus
        if (!document.activeElement?.contains(e.target)) e.stopPropagation();
    }, []);
    // because of the lack of browser support of on before load natively, used IntersectionObserver helper hook to mimic the before load time mark for UFO.
    (0, $eJOHy.useEffect)(()=>{
        if (inView) onBeforeLoad();
    }, [
        inView,
        onBeforeLoad
    ]);
    const emojiNode = /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
        //@ts-ignore
        loading: disableLazyLoad ? 'eager' : 'lazy',
        src: src,
        alt: emoji.name || emoji.shortName,
        "data-emoji-short-name": emoji.shortName,
        "data-emoji-id": emoji.id,
        "data-emoji-text": emoji.fallback || emoji.shortName,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "emoji",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            visibility: 'visible'
        },
        onError: onError,
        onLoad: onLoad,
        ...sizing,
        "data-vc": "emoji"
    }, src);
    // show a tooltip for deletable emoji only on focus
    if (showDelete) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4g9mX.DeletableEmojiTooltipContent), {}),
        position: "right-start",
        tag: "span",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)($ce7d8292c0049cae$export$ce5eef59d8e46687, {
            ...props,
            "aria-labelledby": `screenreader-emoji-${emoji.id}`,
            type: "image",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: classes,
            ref: ref,
            showTooltip: false,
            onMouseOver: onMouseOver,
            children: [
                emojiNode,
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $01aoY.default), {
                    onClick: (event)=>$ce7d8292c0049cae$var$handleDelete(props, event)
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4g9mX.DeletableEmojiTooltipContentForScreenReader), {
                    emoji: emoji
                })
            ]
        })
    });
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $gt9Am.jsx)($ce7d8292c0049cae$export$ce5eef59d8e46687, {
        ...props,
        type: "image",
        className: classes,
        ref: ref,
        children: emojiNode
    }));
};
const $ce7d8292c0049cae$export$ce5eef59d8e46687 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className, showTooltip: showTooltip, showDelete: showDelete, shouldBeInteractive: shouldBeInteractive = false, tabIndex: tabIndex, onSelected: onSelected, onMouseMove: onMouseMove, onFocus: onFocus, onDelete: onDelete, onLoadError: onLoadError, onLoadSuccess: onLoadSuccess, disableLazyLoad: disableLazyLoad, autoWidth: autoWidth, children: children, type: type, editorEmoji: editorEmoji, ...other } = props;
    let accessibilityProps;
    if (editorEmoji) accessibilityProps = {
        role: undefined
    };
    else if (shouldBeInteractive) accessibilityProps = {
        role: 'button',
        'aria-label': emoji.shortName
    };
    else accessibilityProps = {
        role: 'img',
        'aria-label': emoji.shortName
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...accessibilityProps,
        ref: ref,
        "data-testid": `${type}-emoji-${emoji.shortName}`,
        "data-emoji-type": type,
        tabIndex: shouldBeInteractive ? tabIndex || 0 : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            type === 'sprite' ? "_19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _1e0c1o8l _jr50scvx _ylp71o8l _pkaxgktf _1hdcgktf _109tnkob _tn8j14ae _3naf14ae _nt751r31 _49pcglyw _1hvw1o36 _7ehi1n2i _491113zc" : "_2rkofajl _19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _bfhk18uv _1e0c1o8l _s7n4nkob _v4pn1ule _tn8j14ae _3naf14ae _160jewfl _1theewfl _1kogh2mm _qyp0ewfl _nt751r31 _49pcglyw _1hvw1o36 _7ehi1n2i _491113zc",
            className
        ]),
        onKeyDown: (event)=>$ce7d8292c0049cae$var$handleKeyDown(props, event),
        onMouseDown: (event)=>{
            $ce7d8292c0049cae$var$handleMouseDown(props, event);
        },
        onMouseEnter: (event)=>{
            $ce7d8292c0049cae$var$handleMouseMove(props, event);
        },
        onFocus: (event)=>{
            $ce7d8292c0049cae$var$handleFocus(props, event);
        },
        title: showTooltip ? emoji.shortName : undefined,
        ...other,
        children: children
    });
});
const $ce7d8292c0049cae$export$56cc48506ff790a = (props)=>{
    const { emoji: emoji } = props;
    // start emoji rendered experience, it may have already started earlier in ResourcedEmoji or CachingEmoji
    (0, $iVp1F.useSampledUFOComponentExperience)((0, $8B8Wm.ufoExperiences)['emoji-rendered'].getInstance(emoji.id || emoji.shortName), (0, $8iUeU.SAMPLING_RATE_EMOJI_RENDERED_EXP), {
        source: 'Emoji',
        emojiId: emoji.id
    });
    (0, $eJOHy.useEffect)(()=>{
        const ufoExp = (0, $8B8Wm.sampledUfoRenderedEmoji)(emoji);
        if (!(0, $8B8Wm.hasUfoMarked)(ufoExp, 'fmp')) ufoExp.markFMP();
        if (!(0, $8B8Wm.hasUfoMarked)(ufoExp, (0, $adGgK.UfoEmojiTimings).MOUNTED_END)) ufoExp.mark((0, $adGgK.UfoEmojiTimings).MOUNTED_END);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // TODO: We always prefer render as image as having accessibility issues with sprite representation
    if ((0, $fqzOa.isSpriteRepresentation)(emoji.representation)) return /*#__PURE__*/ (0, $gt9Am.jsx)($ce7d8292c0049cae$export$ef49ddbb198ce334, {
        ...props
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)($ce7d8292c0049cae$export$99dfeb9d71c11788, {
        ...props
    });
};
var $ce7d8292c0049cae$export$2e2bcd8739ae039 = $ce7d8292c0049cae$export$56cc48506ff790a;

});
parcelRegister("cBxa0", function(module, exports) {
$parcel$export(module.exports, "emojiRequest", () => $37cc264674c90168$export$ea1accde4cc117f4);
$parcel$export(module.exports, "getAltRepresentation", () => $37cc264674c90168$export$4a0301d636367e1d);
$parcel$export(module.exports, "denormaliseEmojiServiceResponse", () => $37cc264674c90168$export$afaea97e40b5ca70);
$parcel$export(module.exports, "shouldUseAltRepresentation", () => $37cc264674c90168$export$b7e9058f156d8d19);

var $kp3br = parcelRequire("kp3br");

var $fqzOa = parcelRequire("fqzOa");

var $32Nbx = parcelRequire("32Nbx");
const $37cc264674c90168$export$ea1accde4cc117f4 = (provider, options)=>{
    const { getRatio: getRatio = $37cc264674c90168$export$d39ce20a37bba061, ...serviceConfig } = provider;
    const scaleQueryParams = $37cc264674c90168$var$calculateScale(getRatio);
    const { queryParams: queryParams = {}, ...otherOptions } = options || {};
    const requestOptions = {
        ...otherOptions,
        queryParams: {
            ...scaleQueryParams,
            ...queryParams,
            preferredRepresentation: 'IMAGE'
        }
    };
    return (0, $kp3br.utils).requestService(serviceConfig, requestOptions);
};
const $37cc264674c90168$var$calculateScale = (getRatio)=>{
    // Retina display
    if (getRatio() > 1) return {
        scale: 'XHDPI',
        altScale: 'XXXHDPI'
    };
    // Default set used for desktop
    return {
        altScale: 'XHDPI'
    };
};
const $37cc264674c90168$export$d39ce20a37bba061 = ()=>{
    if (typeof window === 'undefined') return 0;
    return window.devicePixelRatio;
};
const $37cc264674c90168$export$4a0301d636367e1d = (reps)=>{
    // Invalid reps handled outside function - logic may change depending what the service returns
    return reps[$37cc264674c90168$var$calculateScale($37cc264674c90168$export$d39ce20a37bba061).altScale];
};
const $37cc264674c90168$export$db05e6ae1fd416af = (url, meta)=>!!(meta && meta.mediaApiToken && url.indexOf(meta.mediaApiToken.url) === 0);
const $37cc264674c90168$export$55077db3efc820aa = (representation, meta)=>{
    if ((0, $fqzOa.isSpriteServiceRepresentation)(representation) && meta && meta.spriteSheets) {
        const { height: height, width: width, x: x, y: y, xIndex: xIndex, yIndex: yIndex, spriteRef: spriteRef } = representation;
        const spriteSheet = meta.spriteSheets[spriteRef];
        if (spriteSheet) return {
            sprite: spriteSheet,
            height: height,
            width: width,
            x: x,
            y: y,
            xIndex: xIndex,
            yIndex: yIndex
        };
    } else if ((0, $fqzOa.isImageRepresentation)(representation)) {
        const { height: height, width: width, imagePath: imagePath } = representation;
        if ($37cc264674c90168$export$db05e6ae1fd416af(imagePath, meta)) return (0, $fqzOa.convertImageToMediaRepresentation)(representation);
        return {
            height: height,
            width: width,
            imagePath: imagePath
        };
    }
    (0, $32Nbx.default)('failed conversion for representation', representation, meta);
    return undefined;
};
const $37cc264674c90168$export$aa9faa01267cb2e7 = (altReps, meta)=>{
    return !altReps || Object.keys(altReps).length === 0 ? undefined : $37cc264674c90168$export$55077db3efc820aa($37cc264674c90168$export$4a0301d636367e1d(altReps), meta);
};
const $37cc264674c90168$export$e3da49c88c2e54d5 = (emoji, meta)=>{
    if (!emoji.skinVariations) return [];
    const skinEmoji = emoji.skinVariations;
    const baseId = emoji.id;
    return skinEmoji.map((skin)=>{
        const { representation: representation, altRepresentations: altRepresentations, ...other } = skin;
        return {
            baseId: baseId,
            representation: $37cc264674c90168$export$55077db3efc820aa(representation, meta),
            altRepresentation: $37cc264674c90168$export$aa9faa01267cb2e7(altRepresentations, meta),
            ...other
        };
    });
};
const $37cc264674c90168$export$afaea97e40b5ca70 = (emojiData)=>{
    const emojis = emojiData.emojis.map((emoji)=>{
        const newRepresentation = $37cc264674c90168$export$55077db3efc820aa(emoji.representation, emojiData.meta);
        const altRepresentation = $37cc264674c90168$export$aa9faa01267cb2e7(emoji.altRepresentations, emojiData.meta);
        const newSkinVariations = $37cc264674c90168$export$e3da49c88c2e54d5(emoji, emojiData.meta);
        // create trimmedServiceDesc which is emoji with no representations or skinVariations
        const { representation: representation, skinVariations: skinVariations, altRepresentations: altRepresentations, ...trimmedServiceDesc } = emoji;
        const response = {
            ...trimmedServiceDesc,
            representation: newRepresentation,
            skinVariations: newSkinVariations
        };
        return (0, $fqzOa.buildEmojiDescriptionWithAltRepresentation)(response, altRepresentation);
    });
    const mediaApiToken = emojiData.meta && emojiData.meta.mediaApiToken;
    return {
        emojis: emojis,
        mediaApiToken: mediaApiToken
    };
};
const $37cc264674c90168$var$getHeight = (fitToHeight)=>$37cc264674c90168$export$d39ce20a37bba061() > 1 ? fitToHeight * 2 : fitToHeight;
const $37cc264674c90168$export$b7e9058f156d8d19 = (emoji, fitToHeight)=>!!(fitToHeight && emoji.altRepresentation && $37cc264674c90168$var$getHeight(fitToHeight) > emoji.representation.height);

});
parcelRegister("fqzOa", function(module, exports) {
$parcel$export(module.exports, "isSpriteServiceRepresentation", () => $23c7073f5fdbdf31$export$1c52f72b88b558e8);
$parcel$export(module.exports, "isSpriteRepresentation", () => $23c7073f5fdbdf31$export$a194199d673d75de);
$parcel$export(module.exports, "isImageRepresentation", () => $23c7073f5fdbdf31$export$90b099a26fbd8b41);
$parcel$export(module.exports, "isMediaRepresentation", () => $23c7073f5fdbdf31$export$979133dc1df141c6);
$parcel$export(module.exports, "isPromise", () => $23c7073f5fdbdf31$export$4369c812aac99591);
$parcel$export(module.exports, "isEmojiDescription", () => $23c7073f5fdbdf31$export$378ed2c87d03531c);
$parcel$export(module.exports, "isMediaEmoji", () => $23c7073f5fdbdf31$export$a7e82c67204c73a1);
$parcel$export(module.exports, "isLoadedMediaEmoji", () => $23c7073f5fdbdf31$export$d25a80b2c86d7fdf);
$parcel$export(module.exports, "isEmojiDescriptionWithVariations", () => $23c7073f5fdbdf31$export$b0ed6d8df471f3cc);
$parcel$export(module.exports, "isEmojiVariationDescription", () => $23c7073f5fdbdf31$export$82a0350e1f6b5c0a);
$parcel$export(module.exports, "isMessagesKey", () => $23c7073f5fdbdf31$export$dddfba07c16c94d2);
$parcel$export(module.exports, "toEmojiId", () => $23c7073f5fdbdf31$export$8d7d3de6b5b305d1);
$parcel$export(module.exports, "containsEmojiId", () => $23c7073f5fdbdf31$export$39ed0ad389e58ef7);
$parcel$export(module.exports, "convertImageToMediaRepresentation", () => $23c7073f5fdbdf31$export$20a1bd1d33069ce7);
$parcel$export(module.exports, "convertMediaToImageEmoji", () => $23c7073f5fdbdf31$export$f1a89a11f425faaa);
$parcel$export(module.exports, "buildEmojiDescriptionWithAltRepresentation", () => $23c7073f5fdbdf31$export$a48c58c688a3131);
$parcel$export(module.exports, "getCategoryId", () => $23c7073f5fdbdf31$export$4bcbf61cb6832a8e);

var $2lSsS = parcelRequire("2lSsS");

var $8iUeU = parcelRequire("8iUeU");
const $23c7073f5fdbdf31$export$1c52f72b88b558e8 = (rep)=>!!(rep && rep.spriteRef);
const $23c7073f5fdbdf31$export$a194199d673d75de = (rep)=>!!(rep && rep.sprite);
const $23c7073f5fdbdf31$export$90b099a26fbd8b41 = (rep)=>!!(rep && rep.imagePath);
const $23c7073f5fdbdf31$export$979133dc1df141c6 = (rep)=>!!(rep && rep.mediaPath);
const $23c7073f5fdbdf31$export$4369c812aac99591 = (p)=>!!(p && p.then);
const $23c7073f5fdbdf31$export$378ed2c87d03531c = (possibleEmojiDescription)=>possibleEmojiDescription && possibleEmojiDescription.shortName && possibleEmojiDescription.type;
const $23c7073f5fdbdf31$export$a7e82c67204c73a1 = (emoji)=>$23c7073f5fdbdf31$export$979133dc1df141c6(emoji.representation);
const $23c7073f5fdbdf31$export$7720a4954d6f75f8 = (rep)=>$23c7073f5fdbdf31$export$90b099a26fbd8b41(rep) && rep.imagePath.indexOf((0, $8iUeU.dataURLPrefix)) === 0;
const $23c7073f5fdbdf31$export$d25a80b2c86d7fdf = (emoji)=>emoji.category === (0, $8iUeU.customCategory) && $23c7073f5fdbdf31$export$7720a4954d6f75f8(emoji.representation);
const $23c7073f5fdbdf31$export$b0ed6d8df471f3cc = (emoji)=>!!(emoji && emoji.skinVariations);
const $23c7073f5fdbdf31$export$82a0350e1f6b5c0a = (object)=>{
    return 'baseId' in object;
};
const $23c7073f5fdbdf31$export$dddfba07c16c94d2 = (key)=>key in (0, $2lSsS.messages);
const $23c7073f5fdbdf31$export$8d7d3de6b5b305d1 = (emoji)=>({
        shortName: emoji.shortName,
        id: emoji.id,
        fallback: emoji.fallback
    });
const $23c7073f5fdbdf31$export$2dbfa5a5d35af350 = (emoji)=>{
    if (!emoji) return undefined;
    return $23c7073f5fdbdf31$export$8d7d3de6b5b305d1(emoji);
};
const $23c7073f5fdbdf31$export$92ad509d7c96b723 = (l, r)=>l === r || l && r && l.id === r.id && l.shortName === r.shortName;
const $23c7073f5fdbdf31$export$39ed0ad389e58ef7 = (emojis, emojiId)=>{
    if (!emojiId) return false;
    for(let i = 0; i < emojis.length; i++){
        if ($23c7073f5fdbdf31$export$92ad509d7c96b723(emojis[i], emojiId)) return true;
    }
    return false;
};
const $23c7073f5fdbdf31$export$20a1bd1d33069ce7 = (rep)=>({
        mediaPath: rep.imagePath,
        height: rep.height,
        width: rep.width
    });
const $23c7073f5fdbdf31$export$3197405d49d2e298 = (rep, newImagePath)=>({
        imagePath: newImagePath || rep.mediaPath,
        height: rep.height,
        width: rep.width
    });
const $23c7073f5fdbdf31$export$f1a89a11f425faaa = (emoji, newImagePath, useAlt)=>{
    const mediaRepresentation = emoji.representation;
    const mediaAltRepresentation = emoji.altRepresentation;
    const imgPath = !useAlt ? newImagePath : undefined;
    const altImgPath = useAlt ? newImagePath : undefined;
    if (!$23c7073f5fdbdf31$export$979133dc1df141c6(mediaRepresentation) && !$23c7073f5fdbdf31$export$979133dc1df141c6(mediaAltRepresentation)) return emoji;
    const representation = $23c7073f5fdbdf31$export$979133dc1df141c6(mediaRepresentation) ? $23c7073f5fdbdf31$export$3197405d49d2e298(mediaRepresentation, imgPath) : mediaRepresentation;
    const altRepresentation = $23c7073f5fdbdf31$export$979133dc1df141c6(mediaAltRepresentation) ? $23c7073f5fdbdf31$export$3197405d49d2e298(mediaAltRepresentation, altImgPath) : mediaAltRepresentation;
    const baseEmoji = {
        ...emoji,
        representation: representation
    };
    return $23c7073f5fdbdf31$export$a48c58c688a3131(baseEmoji, altRepresentation);
};
const $23c7073f5fdbdf31$export$a48c58c688a3131 = (emoji, altRepresentation)=>{
    if (!altRepresentation) return emoji;
    return {
        ...emoji,
        altRepresentation: altRepresentation
    };
};
const $23c7073f5fdbdf31$export$4bcbf61cb6832a8e = (emoji)=>emoji.category;

});
parcelRegister("2lSsS", function(module, exports) {
$parcel$export(module.exports, "messages", () => $8dae1054855c684a$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $8dae1054855c684a$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    deleteEmojiTooltip: {
        id: 'fabric.emoji.delete.tooltip',
        defaultMessage: 'Delete',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTooltipForScreenreader: {
        id: 'fabric.emoji.delete.screenreader.tooltip',
        defaultMessage: 'To delete {shortName} emoji, press Backspace',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTitle: {
        id: 'fabric.emoji.delete.title',
        defaultMessage: 'Remove emoji',
        description: 'Title for emoji removal dialog'
    },
    deleteEmojiDescription: {
        id: 'fabric.emoji.delete.description',
        defaultMessage: 'All existing instances of this emoji will be replaced with {emojiShortName}',
        description: 'Description for emoji removal dialog'
    },
    deleteEmojiLabel: {
        id: 'fabric.emoji.delete.label',
        defaultMessage: 'Remove',
        description: 'Button label to remove emoji'
    },
    addCustomEmojiLabel: {
        id: 'fabric.emoji.add.custom.emoji.label',
        defaultMessage: 'Add your own emoji',
        description: 'Button label to add custom emoji'
    },
    emojiPlaceholder: {
        id: 'fabric.emoji.placeholder',
        defaultMessage: 'e.g. hello',
        description: 'Placeholder for emoji that provides an example for emoji name'
    },
    emojiNameAriaLabel: {
        id: 'fabric.emoji.name.ariaLabel',
        defaultMessage: 'Enter a name for the new emoji',
        description: 'Explains to enter a name for a new emoji'
    },
    emojiChooseFileTitle: {
        id: 'fabric.emoji.choose.file.title',
        defaultMessage: 'Choose file',
        description: 'Choose custom emoji file'
    },
    emojiChooseFileScreenReaderDescription: {
        id: 'fabric.emoji.choose.file.screenReaderDescription',
        defaultMessage: 'Choose a file for the emoji. JPG, PNG or GIF. Max size 1 MB',
        description: 'Message indicating the purpose of choosing the file and requirements for the file'
    },
    emojiSelectSkinToneButtonAriaLabelText: {
        id: 'fabric.emoji.select.skin.tone.ariaLabel',
        defaultMessage: 'Choose your skin tone, {selectedTone} selected',
        description: 'Message indicating the purpose of the skin tone selection button and the selected tone'
    },
    emojiSelectSkinToneListAriaLabelText: {
        id: 'fabric.emoji.select.skin.list.ariaLabel',
        defaultMessage: 'Skin tone selector',
        description: 'Message indicating the purpose of the skin tone list and make user to choose one tone'
    },
    emojiImageRequirements: {
        id: 'fabric.emoji.image.requirements',
        defaultMessage: 'JPG, PNG or GIF. Max size 1 MB.',
        description: 'Message for emoji image requirements and maximum file size'
    },
    emojiPreviewTitle: {
        id: 'fabric.emoji.preview.title',
        defaultMessage: 'Preview',
        description: 'Emoji preview title'
    },
    emojiPreview: {
        id: 'fabric.emoji.preview',
        defaultMessage: 'Your new emoji {emoji} looks great',
        description: 'Emoji preview'
    },
    addEmojiLabel: {
        id: 'fabric.emoji.add.label',
        defaultMessage: 'Add emoji',
        description: 'verb - Button label to add emoji'
    },
    retryLabel: {
        id: 'fabric.emoji.retry.label',
        defaultMessage: 'Retry',
        description: 'verb - Button label to retry upload'
    },
    cancelLabel: {
        id: 'fabric.emoji.cancel.label',
        defaultMessage: 'Cancel',
        description: 'verb - button label to cancel operation'
    },
    searchPlaceholder: {
        id: 'fabric.emoji.search.placeholder',
        defaultMessage: 'Search',
        description: 'Placeholder for search emoji field'
    },
    searchLabel: {
        id: 'fabric.emoji.search.label',
        defaultMessage: 'Emoji name',
        description: 'verb - button label to search'
    },
    searchResultsStatus: {
        id: 'fabric.emoji.search.status.count',
        defaultMessage: 'Found {count} emojis',
        description: 'search results status for screenreader to read out'
    },
    searchResultsStatusSeeAll: {
        id: 'fabric.emoji.search.status',
        defaultMessage: 'Seeing all emojis',
        description: 'search results status when no search query for screenreader to read out'
    },
    categoriesSelectorLabel: {
        id: 'fabric.emoji.categories.label',
        defaultMessage: 'Choose an emoji category',
        description: 'Aria label for Emoji categories selector at the top of emoji picker'
    },
    categoriesSearchResults: {
        id: 'fabric.emoji.categories.search.results',
        defaultMessage: 'Search results',
        description: 'Emoji categories search results'
    },
    frequentCategory: {
        id: 'fabric.emoji.category.frequent',
        defaultMessage: 'Frequent',
        description: 'Emoji frequent category'
    },
    peopleCategory: {
        id: 'fabric.emoji.category.people',
        defaultMessage: 'People',
        description: 'Emoji frequent category'
    },
    natureCategory: {
        id: 'fabric.emoji.category.nature',
        defaultMessage: 'Nature',
        description: 'Emoji nature category'
    },
    foodsCategory: {
        id: 'fabric.emoji.category.foods',
        defaultMessage: 'Food & Drink',
        description: 'Emoji Foods category'
    },
    activityCategory: {
        id: 'fabric.emoji.category.activity',
        defaultMessage: 'Activity',
        description: 'Emoji activity category'
    },
    placesCategory: {
        id: 'fabric.emoji.category.places',
        defaultMessage: 'Travel & Places',
        description: 'Emoji Places category'
    },
    objectsCategory: {
        id: 'fabric.emoji.category.objects',
        defaultMessage: 'Objects',
        description: 'Emoji objects category'
    },
    symbolsCategory: {
        id: 'fabric.emoji.category.symbols',
        defaultMessage: 'Symbols',
        description: 'Emoji symbols category'
    },
    flagsCategory: {
        id: 'fabric.emoji.category.flags',
        defaultMessage: 'Flags',
        description: 'Emoji flags category'
    },
    productivityCategory: {
        id: 'fabric.emoji.category.productivity',
        defaultMessage: 'Atlassian & productivity',
        description: 'Emoji Atlassian & productivity category'
    },
    userUploadsCustomCategory: {
        id: 'fabric.emoji.category.user.uploads',
        defaultMessage: 'Your uploads',
        description: 'User uploads in the custom category'
    },
    allUploadsCustomCategory: {
        id: 'fabric.emoji.category.all.uploads',
        defaultMessage: 'All uploads',
        description: 'All uploads in the custom category'
    },
    deleteEmojiFailed: {
        id: 'fabric.emoji.error.delete.failed',
        defaultMessage: 'Remove failed',
        description: 'Error message when custom emoji failed to be removed'
    },
    emojiInvalidImage: {
        id: 'fabric.emoji.error.invalid.image',
        defaultMessage: 'Selected image is invalid',
        description: 'Error message for invalid selected image'
    },
    emojiUploadFailed: {
        id: 'fabric.emoji.error.upload.failed',
        defaultMessage: 'Upload failed',
        description: 'Failed to upload emoji image'
    },
    emojiUploadTimeout: {
        id: 'fabric.emoji.error.upload.timeout',
        defaultMessage: 'Upload timed out',
        description: 'Failed to upload emoji image'
    },
    emojiImageTooBig: {
        id: 'fabric.emoji.error.image.too.big',
        defaultMessage: 'Selected image is more than 1 MB',
        description: 'Error message for image too big, beyond the size limit'
    },
    emojiPickerTitle: {
        id: 'fabric.emoji.picker',
        defaultMessage: 'Emoji picker',
        description: 'Aria label for emoji picker'
    },
    emojiPickerListPanel: {
        id: 'fabric.emoji.pickerlist.tabpanel',
        defaultMessage: 'Emojis actions and list panel',
        description: 'Aria lable for tabpanel of emoji picker, which shows emojis actions and list'
    },
    emojiPickerGrid: {
        id: 'fabric.emoji.pickerlist.grid',
        defaultMessage: '{showSearchResults, select, true{Search results} other{Emojis}}',
        description: `Aria label for emoji picker grid, showSearchResults is a boolean variable, message will be "Entering Emojis table", or "Leaving Emojis"`
    },
    emojiButtonRoleDescription: {
        id: 'fabric.emoji.emojipicker.emoi.roledescription',
        defaultMessage: 'emoji button',
        description: `Aria roledescription for emoji button, used in emoji picker.`
    },
    error: {
        id: 'fabric.emoji.emojipicker.error',
        defaultMessage: 'Error!',
        description: `Aria label for error icon, apperaed in emoji uploader screens and delete emoji screens of emoji picker`
    }
});

});


parcelRegister("32Nbx", function(module, exports) {
$parcel$export(module.exports, "default", () => $9aab8f9e1de525a0$export$2e2bcd8739ae039);
let $9aab8f9e1de525a0$var$debugEnabled = false;
let $9aab8f9e1de525a0$var$stacktracesEnabled = false;
function $9aab8f9e1de525a0$export$748ada60eaf985cc(enable) {
    $9aab8f9e1de525a0$var$debugEnabled = enable;
}
function $9aab8f9e1de525a0$export$4f7017086af31c25(enable) {
    $9aab8f9e1de525a0$var$stacktracesEnabled = enable;
}
function $9aab8f9e1de525a0$export$2a858f450a2f66d() {
    if ($9aab8f9e1de525a0$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $9aab8f9e1de525a0$export$2e2bcd8739ae039(msg, ...args) {
    if ($9aab8f9e1de525a0$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});


parcelRegister("adGgK", function(module, exports) {
$parcel$export(module.exports, "SearchSort", () => $a40ac3523e94d0b5$export$a15e9a4340d08b2e);
$parcel$export(module.exports, "SearchSourceTypes", () => $a40ac3523e94d0b5$export$db41220f541db607);
$parcel$export(module.exports, "ProviderTypes", () => $a40ac3523e94d0b5$export$bf337c9223e5c8b);
$parcel$export(module.exports, "UfoExperienceName", () => $a40ac3523e94d0b5$export$d0d1c9cd31a11a64);
$parcel$export(module.exports, "UfoComponentName", () => $a40ac3523e94d0b5$export$122ce5c8fda96269);
$parcel$export(module.exports, "UfoEmojiTimingsKeys", () => $a40ac3523e94d0b5$export$265ee18146a6885e);
$parcel$export(module.exports, "UfoEmojiTimings", () => $a40ac3523e94d0b5$export$482549d945a3723);
var $a40ac3523e94d0b5$export$a15e9a4340d08b2e = /*#__PURE__*/ function(SearchSort) {
    // no sort - just the default ordering of emoji
    SearchSort[SearchSort["None"] = 0] = "None";
    // a sort taking into account a number of factors including, usage, closeness of match to the query, etc
    SearchSort[SearchSort["Default"] = 1] = "Default";
    // sort such that the most frequently used emoji come first, and then standard, service defined ordering is preserved.
    SearchSort[SearchSort["UsageFrequency"] = 2] = "UsageFrequency";
    return SearchSort;
}({});
var $a40ac3523e94d0b5$export$db41220f541db607 = /*#__PURE__*/ function(SearchSourceTypes) {
    SearchSourceTypes["PICKER"] = "picker";
    SearchSourceTypes["TYPEAHEAD"] = "typeahead";
    return SearchSourceTypes;
}({});
var $a40ac3523e94d0b5$export$bf337c9223e5c8b = /*#__PURE__*/ function(ProviderTypes) {
    ProviderTypes["SITE"] = "SITE";
    ProviderTypes["STANDARD"] = "STANDARD";
    ProviderTypes["ATLASSIAN"] = "ATLASSIAN";
    ProviderTypes["UNKNOWN"] = "UNKNOWN";
    ProviderTypes["SINGLE"] = "SINGLE";
    return ProviderTypes;
}({});
var $a40ac3523e94d0b5$export$d0d1c9cd31a11a64 = /*#__PURE__*/ function(UfoExperienceName) {
    UfoExperienceName["EMOJI_RENDERED"] = "emoji-rendered";
    UfoExperienceName["EMOJI_RESOURCE_FETCHED"] = "emoji-resource-fetched";
    UfoExperienceName["EMOJI_PICKER_OPENED"] = "emoji-picker-opened";
    UfoExperienceName["EMOJI_SELECTION_RECORDED"] = "emoji-selection-recorded";
    UfoExperienceName["EMOJI_UPLOADED"] = "emoji-uploaded";
    UfoExperienceName["EMOJI_SEARCHED"] = "emoji-searched";
    return UfoExperienceName;
}({});
var $a40ac3523e94d0b5$export$122ce5c8fda96269 = /*#__PURE__*/ function(UfoComponentName) {
    UfoComponentName["EMOJI"] = "emoji";
    UfoComponentName["EMOJI_PICKER"] = "emoji-picker";
    UfoComponentName["EMOJI_PROVIDER"] = "emoji-provider";
    return UfoComponentName;
}({});
var $a40ac3523e94d0b5$export$265ee18146a6885e = /*#__PURE__*/ function(UfoEmojiTimingsKeys) {
    UfoEmojiTimingsKeys["FMP"] = "fmp";
    UfoEmojiTimingsKeys["MOUNTED"] = "emoji-mount";
    UfoEmojiTimingsKeys["METADATA"] = "emoji-metadata";
    UfoEmojiTimingsKeys["MEDIADATA"] = "emoji-media";
    UfoEmojiTimingsKeys["ONLOAD"] = "emoji-onload";
    return UfoEmojiTimingsKeys;
}({});
var $a40ac3523e94d0b5$export$482549d945a3723 = /*#__PURE__*/ function(UfoEmojiTimings) {
    UfoEmojiTimings["FMP_END"] = "fmp";
    UfoEmojiTimings["MOUNTED_END"] = "emoji-mount_end";
    UfoEmojiTimings["METADATA_START"] = "emoji-metadata_start";
    UfoEmojiTimings["METADATA_END"] = "emoji-metadata_end";
    UfoEmojiTimings["MEDIA_START"] = "emoji-media_start";
    UfoEmojiTimings["MEDIA_END"] = "emoji-media_end";
    UfoEmojiTimings["ONLOAD_START"] = "emoji-onload_start";
    UfoEmojiTimings["ONLOAD_END"] = "emoji-onload_end";
    return UfoEmojiTimings;
}({});

});

parcelRegister("huLzh", function(module, exports) {
$parcel$export(module.exports, "leftClick", () => $730123a1a1d68375$export$34ebdaf2c517ae75);
function $730123a1a1d68375$export$fd3cd03f8ac42187(event) {
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $730123a1a1d68375$export$de744e30016241b0(oldPosition, newPosition) {
    if (!oldPosition || oldPosition.x !== newPosition.x || oldPosition.y !== newPosition.y) return true;
    return false;
}
function $730123a1a1d68375$export$34ebdaf2c517ae75(reactEvent) {
    return reactEvent.button === 0 && !reactEvent.altKey && !reactEvent.ctrlKey && !reactEvent.metaKey && !reactEvent.shiftKey;
}

});

parcelRegister("01aoY", function(module, exports) {
$parcel$export(module.exports, "default", () => $485888db4a729b65$export$2e2bcd8739ae039);
/* DeleteButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $kXEdL = parcelRequire("kXEdL");


var $8iUeU = parcelRequire("8iUeU");


var $8IeH1 = parcelRequire("8IeH1");
const $485888db4a729b65$var$styles = {
    boxWrapperStyle: "_1bsbf6fq _4t3if6fq"
};
const $485888db4a729b65$var$deleteButton = null;
const $485888db4a729b65$export$28fc7374cf1206d4 = 'render-emoji-delete-button';
const $485888db4a729b65$var$DeleteButton = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_3um015vq _1e0c1txw _kqswstnw _154ix0bf _1xi2x0bf _1pbykb7n _13t3idpf",
            (0, $eb4c5e773f9bbee2$export$b11fa39b56a371f6)
        ]),
        "data-testid": $485888db4a729b65$export$28fc7374cf1206d4,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
            iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $485888db4a729b65$var$styles.boxWrapperStyle,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kXEdL))), {
                    label: (0, $8iUeU.deleteEmojiLabel),
                    color: `var(--ds-text-subtle, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`,
                    LEGACY_size: "small",
                    size: "small"
                })
            }),
            onClick: props.onClick,
            // TODO: (from codemod) "link" and "subtle-link" appearances are only available in LinkButton, please either provide a href prop then migrate to LinkButton, or remove the appearance from the default button.
            appearance: "subtle-link",
            spacing: "none",
            testId: "emoji-delete-button",
            tabIndex: -1
        })
    });
var $485888db4a729b65$export$2e2bcd8739ae039 = $485888db4a729b65$var$DeleteButton;

});

parcelRegister("8B8Wm", function(module, exports) {
$parcel$export(module.exports, "ufoExperiences", () => $883d6eb80cdaaaf8$export$615f888019c45765);
$parcel$export(module.exports, "sampledUfoRenderedEmoji", () => $883d6eb80cdaaaf8$export$71c8cba6f1251ea9);
$parcel$export(module.exports, "hasUfoMarked", () => $883d6eb80cdaaaf8$export$a9be054d2a5cedc0);
$parcel$export(module.exports, "sampledUfoEmojiResourceFetched", () => $883d6eb80cdaaaf8$export$1466212a1606133);

var $adGgK = parcelRequire("adGgK");

var $9iIu4 = parcelRequire("9iIu4");
var $aRnO1 = parcelRequire("aRnO1");
var $2pMzV = parcelRequire("2pMzV");

var $jZzVI = parcelRequire("jZzVI");
const $883d6eb80cdaaaf8$var$createRenderExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $aRnO1.ExperienceTypes).Load,
        performanceType: (0, $aRnO1.ExperiencePerformanceTypes).PageSegmentLoad
    };
};
const $883d6eb80cdaaaf8$var$createInlineExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $aRnO1.ExperienceTypes).Experience,
        performanceType: (0, $aRnO1.ExperiencePerformanceTypes).InlineResult
    };
};
const $883d6eb80cdaaaf8$var$customEmojiTimings = [
    {
        key: (0, $adGgK.UfoEmojiTimingsKeys).FMP,
        endMark: (0, $adGgK.UfoEmojiTimings).FMP_END
    },
    {
        key: (0, $adGgK.UfoEmojiTimingsKeys).METADATA,
        component: 'resourced-emoji',
        startMark: (0, $adGgK.UfoEmojiTimings).METADATA_START,
        endMark: (0, $adGgK.UfoEmojiTimings).METADATA_END
    },
    {
        key: (0, $adGgK.UfoEmojiTimingsKeys).MEDIADATA,
        component: 'caching-emoji',
        startMark: (0, $adGgK.UfoEmojiTimings).MEDIA_START,
        endMark: (0, $adGgK.UfoEmojiTimings).MEDIA_END
    },
    {
        key: (0, $adGgK.UfoEmojiTimingsKeys).MOUNTED,
        component: 'emoji',
        endMark: (0, $adGgK.UfoEmojiTimings).MOUNTED_END
    },
    {
        key: (0, $adGgK.UfoEmojiTimingsKeys).ONLOAD,
        startMark: (0, $adGgK.UfoEmojiTimings).ONLOAD_START,
        endMark: (0, $adGgK.UfoEmojiTimings).ONLOAD_END
    }
];
const $883d6eb80cdaaaf8$export$615f888019c45765 = {
    'emoji-rendered': new (0, $9iIu4.ConcurrentExperience)((0, $adGgK.UfoExperienceName).EMOJI_RENDERED, {
        platform: {
            component: (0, $adGgK.UfoComponentName).EMOJI
        },
        type: (0, $aRnO1.ExperienceTypes).Operation,
        performanceType: (0, $aRnO1.ExperiencePerformanceTypes).Custom,
        timings: $883d6eb80cdaaaf8$var$customEmojiTimings
    }),
    'emoji-resource-fetched': new (0, $9iIu4.ConcurrentExperience)((0, $adGgK.UfoExperienceName).EMOJI_RESOURCE_FETCHED, $883d6eb80cdaaaf8$var$createRenderExperience((0, $adGgK.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-picker-opened': new (0, $2pMzV.UFOExperience)((0, $adGgK.UfoExperienceName).EMOJI_PICKER_OPENED, $883d6eb80cdaaaf8$var$createRenderExperience((0, $adGgK.UfoComponentName).EMOJI_PICKER)),
    'emoji-selection-recorded': new (0, $2pMzV.UFOExperience)((0, $adGgK.UfoExperienceName).EMOJI_SELECTION_RECORDED, $883d6eb80cdaaaf8$var$createInlineExperience((0, $adGgK.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-uploaded': new (0, $2pMzV.UFOExperience)((0, $adGgK.UfoExperienceName).EMOJI_UPLOADED, $883d6eb80cdaaaf8$var$createInlineExperience((0, $adGgK.UfoComponentName).EMOJI_PICKER)),
    'emoji-searched': new (0, $2pMzV.UFOExperience)((0, $adGgK.UfoExperienceName).EMOJI_SEARCHED, $883d6eb80cdaaaf8$var$createInlineExperience((0, $adGgK.UfoComponentName).EMOJI_PICKER))
};
const $883d6eb80cdaaaf8$export$71c8cba6f1251ea9 = (emojiId)=>{
    return (0, $jZzVI.withSampling)($883d6eb80cdaaaf8$export$615f888019c45765['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName));
};
const $883d6eb80cdaaaf8$export$a9be054d2a5cedc0 = (ufoExperience, name)=>{
    return ufoExperience.metrics.marks.some((mask)=>mask.name === name);
};
const $883d6eb80cdaaaf8$export$1466212a1606133 = (providerType)=>{
    return (0, $jZzVI.withSampling)($883d6eb80cdaaaf8$export$615f888019c45765['emoji-resource-fetched'].getInstance(providerType));
};

});
parcelRegister("jZzVI", function(module, exports) {
$parcel$export(module.exports, "withSampling", () => $79a9e98a54aa22fe$export$dc2f0946255b3f89);
const $79a9e98a54aa22fe$export$c7c4959fece2f3ec = {};
const $79a9e98a54aa22fe$export$cdff9a865136ae27 = ()=>{
    for (const prop of Object.getOwnPropertyNames($79a9e98a54aa22fe$export$c7c4959fece2f3ec))delete $79a9e98a54aa22fe$export$c7c4959fece2f3ec[prop];
};
const $79a9e98a54aa22fe$export$1c967630b3ea2d58 = (rate)=>{
    if (rate === 1) return true;
    if (rate === 0) return false;
    return Math.random() * rate <= 1;
};
const $79a9e98a54aa22fe$var$hasSampledFromStart = (experience)=>{
    if (!$79a9e98a54aa22fe$export$c7c4959fece2f3ec[experience.id]) return false;
    if (experience.instanceId) // if the instance of concurrent exp has been sampled from start, allow it.
    return $79a9e98a54aa22fe$export$c7c4959fece2f3ec[experience.id].sampledInstance[experience.instanceId];
    return $79a9e98a54aa22fe$export$c7c4959fece2f3ec[experience.id].sampled;
};
const $79a9e98a54aa22fe$export$dc2f0946255b3f89 = (ufoExperience)=>{
    const init = ()=>{
        if (!$79a9e98a54aa22fe$export$c7c4959fece2f3ec[ufoExperience.id]) $79a9e98a54aa22fe$export$c7c4959fece2f3ec[ufoExperience.id] = {
            sampled: false,
            sampledInstance: {}
        };
    };
    const start = async (options)=>{
        // check if the experience has already sampled before
        if ($79a9e98a54aa22fe$var$hasSampledFromStart(ufoExperience)) return;
        const isSampled = options.samplingFunc || $79a9e98a54aa22fe$export$1c967630b3ea2d58;
        if (!isSampled(options.samplingRate)) {
            if (ufoExperience.instanceId) $79a9e98a54aa22fe$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = false;
            $79a9e98a54aa22fe$export$c7c4959fece2f3ec[ufoExperience.id].sampled = false;
            return;
        }
        // update sampled records
        if (ufoExperience.instanceId) {
            $79a9e98a54aa22fe$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = true;
            $79a9e98a54aa22fe$export$c7c4959fece2f3ec[ufoExperience.id].sampled = true;
        }
        return ufoExperience.start(options.startTime);
    };
    const success = async (config)=>{
        if (!$79a9e98a54aa22fe$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.success(config);
    };
    const failure = async (config)=>{
        if (!$79a9e98a54aa22fe$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.failure(config);
    };
    const abort = async (config)=>{
        if (!$79a9e98a54aa22fe$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.abort(config);
    };
    const addMetadata = (data)=>{
        if (!$79a9e98a54aa22fe$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.addMetadata(data);
    };
    const mark = (name, timestamp)=>{
        if (!$79a9e98a54aa22fe$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.mark(name, timestamp);
    };
    const markFMP = (timestamp)=>{
        if (!$79a9e98a54aa22fe$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markFMP(timestamp);
    };
    const markInlineResponse = (timestamp)=>{
        if (!$79a9e98a54aa22fe$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markInlineResponse(timestamp);
    };
    init();
    return {
        ...ufoExperience,
        start: start,
        addMetadata: addMetadata,
        success: success,
        failure: failure,
        abort: abort,
        mark: mark,
        markFMP: markFMP,
        markInlineResponse: markInlineResponse
    };
};

});


parcelRegister("iVp1F", function(module, exports) {
$parcel$export(module.exports, "useSampledUFOComponentExperience", () => $6912adc371031cc9$export$f959821a7419dee1);

var $eJOHy = parcelRequire("eJOHy");

var $jZzVI = parcelRequire("jZzVI");
const $6912adc371031cc9$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $eJOHy.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $6912adc371031cc9$export$f959821a7419dee1 = (experience, samplingRate, metadata)=>{
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            (0, $jZzVI.withSampling)(experience).abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $6912adc371031cc9$var$useConstructor(()=>{
        (0, $jZzVI.withSampling)(experience).start({
            samplingRate: samplingRate
        });
        const isMetadataEmpty = Object.keys(experience.metadata).length === 0;
        if (metadata && isMetadataEmpty) experience.addMetadata(metadata);
    });
    return null;
};

});

parcelRegister("3PZQJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $99400fbc97a519f7$export$2e2bcd8739ae039);
const $99400fbc97a519f7$var$result = {
    mac: false,
    supportsIntersectionObserver: false
};
if (typeof navigator !== 'undefined') {
    $99400fbc97a519f7$var$result.mac = /Mac/.test(navigator.platform);
    $99400fbc97a519f7$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
}
var $99400fbc97a519f7$export$2e2bcd8739ae039 = $99400fbc97a519f7$var$result;

});

parcelRegister("lXMGu", function(module, exports) {
$parcel$export(module.exports, "useInView", () => $3e5fc6b003616943$export$2f62ee6831462844);

var $1fvOh = parcelRequire("1fvOh");

var $3PZQJ = parcelRequire("3PZQJ");
const $3e5fc6b003616943$export$2f62ee6831462844 = (options)=>{
    const hookResult = (0, $1fvOh.useInView)(options);
    if (!(0, $3PZQJ.default).supportsIntersectionObserver) // Unsupported, return no `ref` and default `inView` true value
    return [
        undefined,
        true
    ];
    return hookResult;
};

});
parcelRegister("1fvOh", function(module, exports) {
$parcel$export(module.exports, "useInView", () => $0e8fddefcb6714fc$export$2f62ee6831462844);
$parcel$export(module.exports, "default", () => $0e8fddefcb6714fc$export$a62107ca74432f44);

var $eJOHy = parcelRequire("eJOHy");
function $0e8fddefcb6714fc$var$_extends() {
    $0e8fddefcb6714fc$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0e8fddefcb6714fc$var$_extends.apply(this, arguments);
}
function $0e8fddefcb6714fc$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $0e8fddefcb6714fc$var$_setPrototypeOf(subClass, superClass);
}
function $0e8fddefcb6714fc$var$_setPrototypeOf(o, p) {
    $0e8fddefcb6714fc$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0e8fddefcb6714fc$var$_setPrototypeOf(o, p);
}
function $0e8fddefcb6714fc$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $0e8fddefcb6714fc$var$observerMap = new Map();
var $0e8fddefcb6714fc$var$RootIds = new WeakMap();
var $0e8fddefcb6714fc$var$rootId = 0;
var $0e8fddefcb6714fc$var$unsupportedValue = undefined;
/**
 * What should be the default behavior if the IntersectionObserver is unsupported?
 * Ideally the polyfill has been loaded, you can have the following happen:
 * - `undefined`: Throw an error
 * - `true` or `false`: Set the `inView` value to this regardless of intersection state
 * **/ function $0e8fddefcb6714fc$export$2ef3a60ee1f37bec(inView) {
    $0e8fddefcb6714fc$var$unsupportedValue = inView;
}
/**
 * Generate a unique ID for the root element
 * @param root
 */ function $0e8fddefcb6714fc$var$getRootId(root) {
    if (!root) return '0';
    if ($0e8fddefcb6714fc$var$RootIds.has(root)) return $0e8fddefcb6714fc$var$RootIds.get(root);
    $0e8fddefcb6714fc$var$rootId += 1;
    $0e8fddefcb6714fc$var$RootIds.set(root, $0e8fddefcb6714fc$var$rootId.toString());
    return $0e8fddefcb6714fc$var$RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */ function $0e8fddefcb6714fc$var$optionsToId(options) {
    return Object.keys(options).sort().filter(function(key) {
        return options[key] !== undefined;
    }).map(function(key) {
        return key + "_" + (key === 'root' ? $0e8fddefcb6714fc$var$getRootId(options.root) : options[key]);
    }).toString();
}
function $0e8fddefcb6714fc$var$createObserver(options) {
    // Create a unique ID for this observer instance, based on the root, root margin and threshold.
    var id = $0e8fddefcb6714fc$var$optionsToId(options);
    var instance = $0e8fddefcb6714fc$var$observerMap.get(id);
    if (!instance) {
        // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
        var elements = new Map();
        var thresholds;
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                var _elements$get;
                // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
                // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
                var inView = entry.isIntersecting && thresholds.some(function(threshold) {
                    return entry.intersectionRatio >= threshold;
                }); // @ts-ignore support IntersectionObserver v2
                if (options.trackVisibility && typeof entry.isVisible === 'undefined') // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
                // @ts-ignore
                entry.isVisible = inView;
                (_elements$get = elements.get(entry.target)) == null || _elements$get.forEach(function(callback) {
                    callback(inView, entry);
                });
            });
        }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options
        thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [
            options.threshold || 0
        ]);
        instance = {
            id: id,
            observer: observer,
            elements: elements
        };
        $0e8fddefcb6714fc$var$observerMap.set(id, instance);
    }
    return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */ function $0e8fddefcb6714fc$export$d1203567a167490e(element, callback, options, fallbackInView) {
    if (options === void 0) options = {};
    if (fallbackInView === void 0) fallbackInView = $0e8fddefcb6714fc$var$unsupportedValue;
    if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
        var bounds = element.getBoundingClientRect();
        callback(fallbackInView, {
            isIntersecting: fallbackInView,
            target: element,
            intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
            time: 0,
            boundingClientRect: bounds,
            intersectionRect: bounds,
            rootBounds: bounds
        });
        return function() {};
    } // An observer with the same options can be reused, so lets use this fact
    var _createObserver = $0e8fddefcb6714fc$var$createObserver(options), id = _createObserver.id, observer = _createObserver.observer, elements = _createObserver.elements; // Register the callback listener for this element
    var callbacks = elements.get(element) || [];
    if (!elements.has(element)) elements.set(element, callbacks);
    callbacks.push(callback);
    observer.observe(element);
    return function unobserve() {
        // Remove the callback from the callback list
        callbacks.splice(callbacks.indexOf(callback), 1);
        if (callbacks.length === 0) {
            // No more callback exists for element, so destroy it
            elements["delete"](element);
            observer.unobserve(element);
        }
        if (elements.size === 0) {
            // No more elements are being observer by this instance, so destroy it
            observer.disconnect();
            $0e8fddefcb6714fc$var$observerMap["delete"](id);
        }
    };
}
var $0e8fddefcb6714fc$var$_excluded = [
    "children",
    "as",
    "triggerOnce",
    "threshold",
    "root",
    "rootMargin",
    "onChange",
    "skip",
    "trackVisibility",
    "delay",
    "initialInView",
    "fallbackInView"
];
function $0e8fddefcb6714fc$var$isPlainChildren(props) {
    return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */ var $0e8fddefcb6714fc$export$a62107ca74432f44 = /*#__PURE__*/ function(_React$Component) {
    $0e8fddefcb6714fc$var$_inheritsLoose(InView, _React$Component);
    function InView(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.node = null;
        _this._unobserveCb = null;
        _this.handleNode = function(node) {
            if (_this.node) {
                // Clear the old observer, before we start observing a new element
                _this.unobserve();
                if (!node && !_this.props.triggerOnce && !_this.props.skip) // Reset the state if we get a new node, and we aren't ignoring updates
                _this.setState({
                    inView: !!_this.props.initialInView,
                    entry: undefined
                });
            }
            _this.node = node ? node : null;
            _this.observeNode();
        };
        _this.handleChange = function(inView, entry) {
            if (inView && _this.props.triggerOnce) // If `triggerOnce` is true, we should stop observing the element.
            _this.unobserve();
            if (!$0e8fddefcb6714fc$var$isPlainChildren(_this.props)) // Store the current State, so we can pass it to the children in the next render update
            // There's no reason to update the state for plain children, since it's not used in the rendering.
            _this.setState({
                inView: inView,
                entry: entry
            });
            if (_this.props.onChange) // If the user is actively listening for onChange, always trigger it
            _this.props.onChange(inView, entry);
        };
        _this.state = {
            inView: !!props.initialInView,
            entry: undefined
        };
        return _this;
    }
    var _proto = InView.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        // If a IntersectionObserver option changed, reinit the observer
        if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
            this.unobserve();
            this.observeNode();
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.unobserve();
        this.node = null;
    };
    _proto.observeNode = function observeNode() {
        if (!this.node || this.props.skip) return;
        var _this$props = this.props, threshold = _this$props.threshold, root = _this$props.root, rootMargin = _this$props.rootMargin, trackVisibility = _this$props.trackVisibility, delay = _this$props.delay, fallbackInView = _this$props.fallbackInView;
        this._unobserveCb = $0e8fddefcb6714fc$export$d1203567a167490e(this.node, this.handleChange, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin,
            // @ts-ignore
            trackVisibility: trackVisibility,
            // @ts-ignore
            delay: delay
        }, fallbackInView);
    };
    _proto.unobserve = function unobserve() {
        if (this._unobserveCb) {
            this._unobserveCb();
            this._unobserveCb = null;
        }
    };
    _proto.render = function render() {
        if (!$0e8fddefcb6714fc$var$isPlainChildren(this.props)) {
            var _this$state = this.state, inView = _this$state.inView, entry = _this$state.entry;
            return this.props.children({
                inView: inView,
                entry: entry,
                ref: this.handleNode
            });
        }
        var _this$props2 = this.props, children = _this$props2.children, as = _this$props2.as, props = $0e8fddefcb6714fc$var$_objectWithoutPropertiesLoose(_this$props2, $0e8fddefcb6714fc$var$_excluded);
        return /*#__PURE__*/ $eJOHy.createElement(as || 'div', $0e8fddefcb6714fc$var$_extends({
            ref: this.handleNode
        }, props), children);
    };
    return InView;
}($eJOHy.Component);
$0e8fddefcb6714fc$export$a62107ca74432f44.displayName = 'InView';
$0e8fddefcb6714fc$export$a62107ca74432f44.defaultProps = {
    threshold: 0,
    triggerOnce: false,
    initialInView: false
};
/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */ function $0e8fddefcb6714fc$export$2f62ee6831462844(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, threshold = _ref.threshold, delay = _ref.delay, trackVisibility = _ref.trackVisibility, rootMargin = _ref.rootMargin, root = _ref.root, triggerOnce = _ref.triggerOnce, skip = _ref.skip, initialInView = _ref.initialInView, fallbackInView = _ref.fallbackInView;
    var unobserve = $eJOHy.useRef();
    var _React$useState = $eJOHy.useState({
        inView: !!initialInView
    }), state = _React$useState[0], setState = _React$useState[1];
    var setRef = $eJOHy.useCallback(function(node) {
        if (unobserve.current !== undefined) {
            unobserve.current();
            unobserve.current = undefined;
        } // Skip creating the observer
        if (skip) return;
        if (node) unobserve.current = $0e8fddefcb6714fc$export$d1203567a167490e(node, function(inView, entry) {
            setState({
                inView: inView,
                entry: entry
            });
            if (entry.isIntersecting && triggerOnce && unobserve.current) {
                // If it should only trigger once, unobserve the element after it's inView
                unobserve.current();
                unobserve.current = undefined;
            }
        }, {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold,
            // @ts-ignore
            trackVisibility: trackVisibility,
            // @ts-ignore
            delay: delay
        }, fallbackInView);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // eslint-disable-next-line react-hooks/exhaustive-deps
        Array.isArray(threshold) ? threshold.toString() : threshold,
        root,
        rootMargin,
        triggerOnce,
        skip,
        trackVisibility,
        fallbackInView,
        delay
    ]);
    /* eslint-disable-next-line */ (0, $eJOHy.useEffect)(function() {
        if (!unobserve.current && state.entry && !triggerOnce && !skip) // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
        // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
        setState({
            inView: !!initialInView
        });
    });
    var result = [
        setRef,
        state.inView,
        state.entry
    ]; // Support object destructuring, by adding the specific values.
    result.ref = result[0];
    result.inView = result[1];
    result.entry = result[2];
    return result;
}

});


parcelRegister("4g9mX", function(module, exports) {
$parcel$export(module.exports, "DeletableEmojiTooltipContent", () => $0d652cd35182c73f$export$4727956877b6f612);
$parcel$export(module.exports, "DeletableEmojiTooltipContentForScreenReader", () => $0d652cd35182c73f$export$d151e4941072147c);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $2lSsS = parcelRequire("2lSsS");

var $jA3IN = parcelRequire("jA3IN");

var $cfLrC = parcelRequire("cfLrC");

var $6fs4r = parcelRequire("6fs4r");
const $0d652cd35182c73f$export$4727956877b6f612 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jA3IN.ToolTipContentWithKeymap), {
        description: formatMessage((0, $2lSsS.messages).deleteEmojiTooltip),
        keymap: (0, $cfLrC.backspace)
    });
};
const $0d652cd35182c73f$export$d151e4941072147c = ({ emoji: emoji })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6fs4r.default), {
        id: `screenreader-emoji-${emoji.id}`,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $2lSsS.messages).deleteEmojiTooltipForScreenreader,
            values: {
                shortName: emoji.shortName
            }
        })
    });
};

});
parcelRegister("jA3IN", function(module, exports) {
$parcel$export(module.exports, "ToolTipContentWithKeymap", () => $e82b8fc1f7abac1c$export$c7308f5f9ed494ac);
/* ToolTipContentWithKeymap.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $cfLrC = parcelRequire("cfLrC");
const $e82b8fc1f7abac1c$var$tooltipShortcutStyle = null;
const $e82b8fc1f7abac1c$export$c7308f5f9ed494ac = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ description: description, shortcutOverride: shortcutOverride, keymap: keymap })=>{
    const shortcut = shortcutOverride || keymap && (0, $cfLrC.formatShortcut)(keymap);
    return shortcut || description ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
        children: [
            description,
            shortcut && description && '\u00A0',
            shortcut && /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                className: (0, $hcewu.default)([
                    "_2rkofajl _bfhk17rn _ca0qidpf _n3tdidpf _19bvv77o _u5f3v77o _jqf61teg"
                ]),
                children: shortcut
            })
        ]
    }) : null;
});

});
parcelRegister("cfLrC", function(module, exports) {
$parcel$export(module.exports, "backspace", () => $2d3a83954aa08a62$export$1ea584ca7009bcc1);
$parcel$export(module.exports, "formatShortcut", () => $2d3a83954aa08a62$export$384a290f8c265cc5);
/**
 * Copied from editor-common: https://bitbucket.org/atlassian/atlassian-frontend/src/d01430a20500d720791d0667fd7cfe25d254f2e3/packages/editor/editor-common/src/keymaps/index.tsx
 */ 
var $3PZQJ = parcelRequire("3PZQJ");
const $2d3a83954aa08a62$export$1ea584ca7009bcc1 = $2d3a83954aa08a62$export$7e6b588cc98b34f1('Backspace', 'Backspace');
function $2d3a83954aa08a62$export$d8a7f422d8d42038(description, windows, mac, common) {
    return {
        description: description,
        windows: windows.replace(/Mod/i, 'Ctrl'),
        mac: mac.replace(/Mod/i, 'Cmd'),
        common: common
    };
}
function $2d3a83954aa08a62$export$7e6b588cc98b34f1(description, common) {
    const windows = common.replace(/Mod/i, 'Ctrl');
    const mac = common.replace(/Mod/i, 'Cmd');
    return $2d3a83954aa08a62$export$d8a7f422d8d42038(description, windows, mac, common);
}
const $2d3a83954aa08a62$export$8d734690d3a46118 = {
    // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    ARROWLEFT: '\u2190',
    ARROWRIGHT: '\u2192',
    ARROWUP: '\u2191',
    ARROWDOWN: '\u2193'
};
function $2d3a83954aa08a62$export$384a290f8c265cc5(keymap) {
    let shortcut;
    if ((0, $3PZQJ.default).mac) // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    shortcut = keymap.mac.replace(/Cmd/i, '\u2318').replace(/Shift/i, '\u21E7').replace(/Ctrl/i, '\u2303').replace(/Alt/i, '\u2325').replace(/Backspace/i, '\u232B').replace(/Enter/i, '\u23CE');
    else shortcut = keymap.windows.replace(/Backspace/i, '\u232B');
    const keys = shortcut.split('-');
    let lastKey = keys[keys.length - 1];
    if (lastKey.length === 1) // capitalise single letters
    lastKey = lastKey.toUpperCase();
    keys[keys.length - 1] = $2d3a83954aa08a62$export$8d734690d3a46118[lastKey.toUpperCase()] || lastKey;
    return keys.join((0, $3PZQJ.default).mac ? '' : '+');
}

});



parcelRegister("chAs1", function(module, exports) {
$parcel$export(module.exports, "isSSR", () => $a4876ac4e3ec9e73$export$48d7c418edadb60c);

var $igDjg = parcelRequire("igDjg");
function $a4876ac4e3ec9e73$export$48d7c418edadb60c() {
    try {
        return Boolean(// In most places there is no document when running on server-side
        typeof document === 'undefined' || // When SSRing editor with full cycle mode we define the document
        // Check Confluence specific environment variable
        typeof $igDjg !== 'undefined' && $igDjg?.env?.REACT_SSR);
    } catch (e) {
        // Catch possible error that might occur and just return false
        return false;
    }
}

});


parcelRegister("4IKFn", function(module, exports) {
$parcel$export(module.exports, "default", () => $60846143e9fc24cc$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $htczl = parcelRequire("htczl");

var $b9cFG = parcelRequire("b9cFG");

var $8B8Wm = parcelRequire("8B8Wm");

var $8iUeU = parcelRequire("8iUeU");
const $60846143e9fc24cc$var$ResourcedEmoji = (props)=>{
    const { emojiId: emojiId, optimisticImageURL: optimisticImageURL } = props;
    (0, $eJOHy.useEffect)(()=>{
        if (!emojiId) return;
        (0, $8B8Wm.sampledUfoRenderedEmoji)(emojiId).start({
            samplingRate: (0, $8iUeU.SAMPLING_RATE_EMOJI_RENDERED_EXP)
        });
        (0, $8B8Wm.ufoExperiences)['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName).addMetadata({
            source: 'ResourcedEmoji',
            emojiId: emojiId.id,
            isOptimisticImageURL: !!optimisticImageURL
        });
        return ()=>{
            (0, $8B8Wm.sampledUfoRenderedEmoji)(emojiId).abort({
                metadata: {
                    source: 'ResourcedEmoji',
                    reason: 'unmount'
                }
            });
        };
    }, [
        emojiId,
        optimisticImageURL
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b9cFG.UfoErrorBoundary), {
        experiences: [
            (0, $8B8Wm.ufoExperiences)['emoji-rendered'].getInstance(props.emojiId.id || props.emojiId.shortName)
        ],
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $htczl.ResourcedEmojiComponent), {
            ...props
        })
    });
};
var $60846143e9fc24cc$export$2e2bcd8739ae039 = $60846143e9fc24cc$var$ResourcedEmoji;

});
parcelRegister("htczl", function(module, exports) {
$parcel$export(module.exports, "ResourcedEmojiComponent", () => $b3a1b7c1097f467f$export$7bfde52eceb3e2f6);
/* ResourcedEmojiComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8iUeU = parcelRequire("8iUeU");

var $fqzOa = parcelRequire("fqzOa");

var $adGgK = parcelRequire("adGgK");

var $i4Ljn = parcelRequire("i4Ljn");

var $k8ZdJ = parcelRequire("k8ZdJ");

var $8B8Wm = parcelRequire("8B8Wm");

var $4FlMD = parcelRequire("4FlMD");

var $8B8Wm = parcelRequire("8B8Wm");

var $eGOwo = parcelRequire("eGOwo");
var $b3a1b7c1097f467f$var$ResourcedEmojiComponentRenderStatesEnum = /*#__PURE__*/ function(ResourcedEmojiComponentRenderStatesEnum) {
    ResourcedEmojiComponentRenderStatesEnum["INITIAL"] = "INITIAL";
    ResourcedEmojiComponentRenderStatesEnum["FALLBACK"] = "FALLBACK";
    ResourcedEmojiComponentRenderStatesEnum["EMOJI"] = "EMOJI";
    return ResourcedEmojiComponentRenderStatesEnum;
}($b3a1b7c1097f467f$var$ResourcedEmojiComponentRenderStatesEnum || {});
const $b3a1b7c1097f467f$export$7bfde52eceb3e2f6 = ({ emojiProvider: emojiProvider, emojiId: emojiId, showTooltip: showTooltip = false, customFallback: customFallback, fitToHeight: fitToHeight = (0, $8iUeU.defaultEmojiHeight), optimistic: optimistic = false, optimisticImageURL: optimisticImageURL, editorEmoji: editorEmoji, placeholderXcss: placeholderXcss, onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail })=>{
    const { shortName: shortName, id: id, fallback: fallback } = emojiId;
    const [emoji, setEmoji] = (0, $eJOHy.useState)();
    const [loaded, setLoaded] = (0, $eJOHy.useState)(false);
    const [imageLoadError, setImageLoadError] = (0, $eJOHy.useState)(false);
    const [resolvedEmojiProvider, setResolvedEmojiProvider] = (0, $eJOHy.useState)();
    const fetchOrGetEmoji = (0, $eJOHy.useCallback)(async (_emojiProvider, emojiId, optimisticFetch = false)=>{
        if (!_emojiProvider.fetchByEmojiId) {
            setEmoji(undefined);
            const reason = 'missing fetchByEmojiId interface';
            onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
            (0, $8B8Wm.sampledUfoRenderedEmoji)(emojiId).failure({
                metadata: {
                    reason: reason,
                    source: 'ResourcedEmojiComponent'
                }
            });
        }
        const foundEmoji = _emojiProvider.fetchByEmojiId(emojiId, optimisticFetch);
        (0, $8B8Wm.sampledUfoRenderedEmoji)(emojiId).mark((0, $adGgK.UfoEmojiTimings).METADATA_START);
        if ((0, $fqzOa.isPromise)(foundEmoji)) {
            setLoaded(false);
            foundEmoji.then((emoji)=>{
                setEmoji(emoji);
                if (!emoji) {
                    const reason = 'failed to find';
                    onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
                    // emoji is undefined
                    (0, $8B8Wm.sampledUfoRenderedEmoji)(emojiId).failure({
                        metadata: {
                            reason: reason,
                            source: 'ResourcedEmojiComponent',
                            data: {
                                emoji: {
                                    id: emojiId.id,
                                    shortName: emojiId.shortName
                                }
                            }
                        }
                    });
                }
            }).catch(()=>{
                setEmoji(undefined);
                const reason = 'failed to load';
                onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
                (0, $8B8Wm.sampledUfoRenderedEmoji)(emojiId).failure({
                    metadata: {
                        reason: reason,
                        source: 'ResourcedEmojiComponent',
                        data: {
                            emoji: {
                                id: emojiId.id,
                                shortName: emojiId.shortName
                            }
                        }
                    }
                });
            }).finally(()=>{
                setLoaded(true);
                (0, $8B8Wm.sampledUfoRenderedEmoji)(emojiId).mark((0, $adGgK.UfoEmojiTimings).METADATA_END);
            });
        } else {
            setEmoji(foundEmoji);
            setLoaded(true);
            (0, $8B8Wm.sampledUfoRenderedEmoji)(emojiId).mark((0, $adGgK.UfoEmojiTimings).METADATA_END);
        }
    }, [
        onEmojiLoadFail
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!emojiId) return;
        if (!(0, $8B8Wm.hasUfoMarked)((0, $8B8Wm.sampledUfoRenderedEmoji)(emojiId), (0, $adGgK.UfoEmojiTimings).FMP_END)) (0, $8B8Wm.sampledUfoRenderedEmoji)(emojiId).markFMP();
    }, [
        emojiId
    ]);
    (0, $eJOHy.useMemo)(()=>{
        if (!resolvedEmojiProvider || !emojiId) return;
        fetchOrGetEmoji(resolvedEmojiProvider, emojiId, optimistic);
    }, [
        resolvedEmojiProvider,
        emojiId,
        optimistic,
        fetchOrGetEmoji
    ]);
    /**
   * Setting resolved emoji provider for optimistic rendering
   */ (0, $eJOHy.useEffect)(()=>{
        Promise.resolve(emojiProvider).then((emojiProvider)=>{
            setResolvedEmojiProvider(emojiProvider);
        });
    }, [
        emojiProvider
    ]);
    const emojiRenderState = (0, $eJOHy.useMemo)(()=>{
        if (!emoji && !loaded && !optimisticImageURL) return "INITIAL";
        else if (!emoji && loaded || imageLoadError) return "FALLBACK";
        return "EMOJI";
    }, [
        emoji,
        loaded,
        optimisticImageURL,
        imageLoadError
    ]);
    const optimisticEmojiDescription = (0, $eJOHy.useMemo)(()=>{
        if (optimisticImageURL) {
            if (emoji && ((0, $fqzOa.isImageRepresentation)(emoji.representation) || (0, $fqzOa.isMediaRepresentation)(emoji?.representation))) {
                const { width: width, height: height } = emoji.representation;
                return {
                    ...emoji,
                    representation: {
                        width: width,
                        height: height,
                        imagePath: optimisticImageURL
                    }
                };
            } else return {
                id: id,
                shortName: shortName,
                fallback: fallback,
                type: '',
                category: '',
                representation: {
                    height: fitToHeight || (0, $8iUeU.defaultEmojiHeight),
                    width: fitToHeight || (0, $8iUeU.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true
            };
        }
        return emoji;
    }, [
        emoji,
        optimisticImageURL,
        fallback,
        fitToHeight,
        id,
        shortName
    ]);
    const handleOnLoadError = (0, $eJOHy.useCallback)((emojiId)=>{
        setImageLoadError(true);
        const reason = 'load error';
        onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
        (0, $8B8Wm.sampledUfoRenderedEmoji)(emojiId).failure({
            metadata: {
                reason: reason,
                source: 'ResourcedEmojiComponent',
                emojiId: emojiId.id
            }
        });
    }, [
        onEmojiLoadFail
    ]);
    const handleOnLoadSuccess = (0, $eJOHy.useCallback)((emojiId)=>{
        onEmojiLoadSuccess && onEmojiLoadSuccess(emojiId.id);
    }, [
        onEmojiLoadSuccess
    ]);
    // use width: auto as long as fitToHeight is defined
    const autoWidth = (0, $eGOwo.fg)('platform_emoji_width_auto_fittoheight') ? !!fitToHeight : !!emoji ? false : true;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4FlMD.EmojiCommonProvider), {
        emojiProvider: resolvedEmojiProvider,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("span", {
            "data-emoji-id": id,
            "data-emoji-short-name": shortName,
            "data-emoji-text": fallback || shortName,
            "data-ssr-placeholder": `emoji-${id ?? shortName}`,
            "data-ssr-placeholder-replace": `emoji-${id ?? shortName}`,
            children: [
                emojiRenderState === "INITIAL" && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8ZdJ.default), {
                    shortName: shortName,
                    showTooltip: showTooltip,
                    size: fitToHeight || (0, $8iUeU.defaultEmojiHeight),
                    loading: true,
                    xcss: placeholderXcss
                }),
                emojiRenderState === "FALLBACK" && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
                    children: customFallback || fallback || shortName
                }),
                emojiRenderState === "EMOJI" && optimisticEmojiDescription && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i4Ljn.default), {
                    emoji: optimisticEmojiDescription,
                    onLoadError: handleOnLoadError,
                    onLoadSuccess: handleOnLoadSuccess,
                    showTooltip: showTooltip,
                    fitToHeight: fitToHeight,
                    autoWidth: autoWidth,
                    editorEmoji: editorEmoji
                })
            ]
        })
    });
};
var $b3a1b7c1097f467f$export$2e2bcd8739ae039 = $b3a1b7c1097f467f$export$7bfde52eceb3e2f6;

});
parcelRegister("k8ZdJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $5122c9670f038eb1$export$2e2bcd8739ae039);
/* EmojiPlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $8iUeU = parcelRequire("8iUeU");

const $5122c9670f038eb1$var$placeholderContainer = null;
const $5122c9670f038eb1$export$73987987fac5266b = (shortName)=>`emoji-placeholder-${shortName}`;
const $5122c9670f038eb1$var$EmojiPlaceholder = (props)=>{
    const { shortName: shortName, size: size = (0, $8iUeU.defaultEmojiHeight), showTooltip: showTooltip, representation: representation, loading: loading = false, xcss: xcss } = props;
    let scaledWidth;
    let scaledHeight;
    if (representation && size) {
        const width = representation.width;
        const height = representation.height;
        if (width && height) {
            scaledWidth = size / height * width;
            scaledHeight = size;
        }
    }
    const width = scaledWidth || size;
    const height = scaledHeight || size;
    const style = {
        fill: 'f7f7f7',
        minWidth: `${width}px`,
        width: `${width}px`,
        height: `${height}px`
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": $5122c9670f038eb1$export$73987987fac5266b(shortName),
        "aria-busy": loading,
        role: "status",
        "aria-label": shortName,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _2rkofajl _1reo15vq _18m915vq _kqswh2mm _1e0c1o8l _bfhkttw1 _s7n4nkob _o5721q9c _y3gn1h6o",
            [
                (0, $eb4c5e773f9bbee2$export$c7187bbd1a7a9244),
                (0, $eGOwo.fg)('platform_reactions_placeholder_custom_background') ? xcss : ''
            ].join(' ')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        title: showTooltip ? shortName : ''
    });
};
var $5122c9670f038eb1$export$2e2bcd8739ae039 = $5122c9670f038eb1$var$EmojiPlaceholder;

});

parcelRegister("4FlMD", function(module, exports) {
$parcel$export(module.exports, "EmojiCommonProvider", () => $3ad4b3a3694a9c33$export$1120e666998e21b5);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7qseJ = parcelRequire("7qseJ");

var $cbSL1 = parcelRequire("cbSL1");
const $3ad4b3a3694a9c33$export$1120e666998e21b5 = (props)=>{
    const emojiContextValue = (0, $eJOHy.useMemo)(()=>props.emojiProvider ? {
            emoji: {
                emojiProvider: props.emojiProvider
            }
        } : undefined, [
        props.emojiProvider
    ]);
    if (!!emojiContextValue && (0, $cbSL1.expValEquals)('cc_complexit_fe_emoji_stability', 'isEnabled', true)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7qseJ.EmojiContextProvider), {
        emojiContextValue: emojiContextValue,
        children: props.children
    });
    else if (props.emojiProvider) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7qseJ.EmojiContextProvider), {
        emojiContextValue: {
            emoji: {
                emojiProvider: props.emojiProvider
            }
        },
        children: props.children
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: props.children
    });
};

});
parcelRegister("7qseJ", function(module, exports) {
$parcel$export(module.exports, "EmojiContextProvider", () => $e6e58c0a6a6190fa$export$f4a09143833145ed);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $64Cd4 = parcelRequire("64Cd4");

var $32Nbx = parcelRequire("32Nbx");
const $e6e58c0a6a6190fa$export$f4a09143833145ed = ({ children: children, emojiContextValue: emojiContextValue })=>{
    const memoizedEmojiContextValue = (0, $eJOHy.useMemo)(()=>emojiContextValue, [
        emojiContextValue
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // trigger emoji fetching
        async function fetchEmojiProvider() {
            try {
                await memoizedEmojiContextValue?.emoji.emojiProvider.fetchEmojiProvider();
            } catch (error) {
                (0, $32Nbx.default)('fetchEmojiProvider error catched from outside', error);
            }
        }
        if (memoizedEmojiContextValue?.emoji.emojiProvider.onlyFetchOnDemand) {
            const isFetchingOnDemand = memoizedEmojiContextValue?.emoji.emojiProvider.onlyFetchOnDemand();
            if (!isFetchingOnDemand) fetchEmojiProvider();
        } else fetchEmojiProvider();
    }, [
        memoizedEmojiContextValue
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $64Cd4.EmojiContext).Provider, {
        value: memoizedEmojiContextValue,
        children: children
    });
};

});
parcelRegister("64Cd4", function(module, exports) {
$parcel$export(module.exports, "EmojiContext", () => $5eb1e8c0c6fbfd3d$export$9fab6c37a453c65e);

var $eJOHy = parcelRequire("eJOHy");
const $5eb1e8c0c6fbfd3d$export$9fab6c37a453c65e = (0, $eJOHy.createContext)(null);

});




parcelRegister("b9cFG", function(module, exports) {
$parcel$export(module.exports, "UfoErrorBoundary", () => $54cade362a3b2ab3$export$5ef1c2550074a375);

var $eJOHy = parcelRequire("eJOHy");
class $54cade362a3b2ab3$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidCatch(error, errorInfo) {
        for (const exp of this.props.experiences){
            const { name: name, message: message } = error;
            const infoStack = errorInfo.componentStack && typeof errorInfo.componentStack !== 'undefined' ? errorInfo.componentStack : undefined;
            exp.failure({
                metadata: {
                    source: 'UfoErrorBoundary',
                    reason: 'error',
                    error: {
                        name: name,
                        message: message,
                        infoStack: infoStack
                    }
                }
            });
        }
    }
    render() {
        return this.props.children;
    }
}

});


parcelRegister("l1j5w", function(module, exports) {
$parcel$export(module.exports, "preloadEmojiPicker", () => $916ef81dcb3e99e8$export$6b47bb4986b03271);
$parcel$export(module.exports, "default", () => $916ef81dcb3e99e8$export$2e2bcd8739ae039);
/* EmojiPicker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
parcelRequire("eJOHy");

var $4J0ad = parcelRequire("4J0ad");

var $8B8Wm = parcelRequire("8B8Wm");

var $j4r1g = parcelRequire("j4r1g");

var $hSOTv = parcelRequire("hSOTv");

var $b9cFG = parcelRequire("b9cFG");

var $8iUeU = parcelRequire("8iUeU");

var $4FlMD = parcelRequire("4FlMD");
const $916ef81dcb3e99e8$var$emojiPicker = null;

const $916ef81dcb3e99e8$var$emojiPickerModuleLoader = ()=>(parcelRequire("6KprU"));
const $916ef81dcb3e99e8$var$emojiPickerLoader = ()=>$916ef81dcb3e99e8$var$emojiPickerModuleLoader().then((module)=>module.default);
const $916ef81dcb3e99e8$export$6b47bb4986b03271 = ()=>{
    $916ef81dcb3e99e8$var$emojiPickerLoader().then((component)=>{
        $916ef81dcb3e99e8$export$bcf219a275f21b24.AsyncLoadedComponent = component;
    });
};
class $916ef81dcb3e99e8$export$bcf219a275f21b24 extends (0, $j4r1g.default) {
    static{
        this.defaultProps = {
            size: (0, $8iUeU.defaultEmojiPickerSize)
        };
    }
    constructor(props){
        super(props, {}), this.state = {
            asyncLoadedComponent: $916ef81dcb3e99e8$export$bcf219a275f21b24.AsyncLoadedComponent
        };
        (0, $8B8Wm.ufoExperiences)['emoji-picker-opened'].start();
    }
    asyncLoadComponent() {
        $916ef81dcb3e99e8$var$emojiPickerLoader().then((component)=>{
            $916ef81dcb3e99e8$export$bcf219a275f21b24.AsyncLoadedComponent = component;
            this.setAsyncState(component);
        });
    }
    renderLoading() {
        const item = new (0, $hSOTv.LoadingItem)();
        const handlePickerRef = (ref)=>{
            if (this.props.onPickerRef) this.props.onPickerRef(ref);
        };
        (0, $8B8Wm.ufoExperiences)['emoji-picker-opened'].markFMP();
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            ref: handlePickerRef,
            className: (0, $hcewu.default)([
                "_19it11e4 _2rkofajl _1e0c1txw _2lx21bp4 _1bah1yb4 _bfhk1bhr _16qs1gxp _4t3iixjv _1bsb1edt _1ul91edt _1tke5x59 _c71l1y6z"
            ]),
            children: item.renderItem()
        });
    }
    renderLoaded(loadedEmojiProvider, EmojiPickerComponent) {
        const { emojiProvider: emojiProvider, ...otherProps } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b9cFG.UfoErrorBoundary), {
            experiences: [
                (0, $8B8Wm.ufoExperiences)['emoji-picker-opened']
            ],
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4FlMD.EmojiCommonProvider), {
                emojiProvider: loadedEmojiProvider,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(EmojiPickerComponent, {
                    ...otherProps
                })
            })
        });
    }
}
const $916ef81dcb3e99e8$var$EmojiPicker = (0, $4J0ad.default)()($916ef81dcb3e99e8$export$bcf219a275f21b24);
var $916ef81dcb3e99e8$export$2e2bcd8739ae039 = $916ef81dcb3e99e8$var$EmojiPicker;

});
parcelRegister("j4r1g", function(module, exports) {
$parcel$export(module.exports, "default", () => $23a7418e0aa98bcb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
class $23a7418e0aa98bcb$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    constructor(props, state){
        super(props), this.isUnmounted = false, this.loaded = (state)=>!!state.asyncLoadedComponent && !!state.loadedEmojiProvider;
        this.state = state;
        // initializing here instead of componentDidMount to avoid needless
        // rerendering if emojiProvider resolves immediately.
        this.loadEmojiProvider(this.props.emojiProvider);
    }
    componentDidMount() {
        // check for the module has not yet been loaded
        // state.asyncLoadedComponent should be initialised
        // with static field to prevent unnecessary rerender
        if (!this.state.asyncLoadedComponent) this.asyncLoadComponent();
    }
    componentDidUpdate(prevProps) {
        if (this.props !== prevProps) this.loadEmojiProvider(this.props.emojiProvider);
    }
    componentWillUnmount() {
        this.isUnmounted = true;
    }
    loadEmojiProvider(futureEmojiProvider) {
        futureEmojiProvider.then((loadedEmojiProvider)=>{
            if (!this.isUnmounted) this.setState({
                loadedEmojiProvider: loadedEmojiProvider
            });
        }).catch(()=>{
            if (!this.isUnmounted) this.setState({
                loadedEmojiProvider: undefined
            });
        });
    }
    setAsyncState(asyncLoadedComponent) {
        if (!this.isUnmounted) this.setState({
            asyncLoadedComponent: asyncLoadedComponent
        });
    }
    renderLoading() {
        return null;
    }
    render() {
        if (this.loaded(this.state)) {
            const { loadedEmojiProvider: loadedEmojiProvider, asyncLoadedComponent: asyncLoadedComponent } = this.state;
            return this.renderLoaded(loadedEmojiProvider, asyncLoadedComponent);
        }
        return this.renderLoading();
    }
}

});

parcelRegister("hSOTv", function(module, exports) {
$parcel$export(module.exports, "EmojisRowItem", () => $a768900ba64c68da$export$99598b6ddae6b40f);
$parcel$export(module.exports, "LoadingItem", () => $a768900ba64c68da$export$a16bfd7fb92e211d);
$parcel$export(module.exports, "CategoryHeadingItem", () => $a768900ba64c68da$export$7fb68de373aba588);
$parcel$export(module.exports, "virtualItemRenderer", () => $a768900ba64c68da$export$1786779f88a71e20);
/* EmojiPickerVirtualItems.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7ep4S = parcelRequire("7ep4S");

var $lsq3w = parcelRequire("lsq3w");

var $zYTQn = parcelRequire("zYTQn");

var $d2aiW = parcelRequire("d2aiW");
const $a768900ba64c68da$var$emojiPickerSpinner = null;
class $a768900ba64c68da$export$8faa7b3aa4960e00 {
    constructor(props, height){
        this.props = props;
        this.height = height;
    }
}
class $a768900ba64c68da$export$99598b6ddae6b40f extends $a768900ba64c68da$export$8faa7b3aa4960e00 {
    constructor(props){
        super(props, (0, $d2aiW.sizes).emojiRowHeight), this.renderItem = (context)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $zYTQn.default), {
                ...this.props,
                virtualItemContext: context
            });
    }
}
class $a768900ba64c68da$export$a16bfd7fb92e211d extends $a768900ba64c68da$export$8faa7b3aa4960e00 {
    constructor(){
        super({}, (0, $d2aiW.sizes).loadingRowHeight), this.renderItem = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    "_1e0c1txw _1bsb1osq _4t3i1w81 _1bah1h6o _4cvr1h6o _nphsidpf _t1edidpf _1t3b1wug"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                        size: "medium"
                    })
                })
            });
    }
}
class $a768900ba64c68da$export$7fb68de373aba588 extends $a768900ba64c68da$export$8faa7b3aa4960e00 {
    constructor(props){
        super(props, (0, $d2aiW.sizes).categoryHeadingHeight), this.renderItem = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $lsq3w.default), {
                ...this.props
            });
    }
}
const $a768900ba64c68da$export$1786779f88a71e20 = (rows, context)=>{
    const { index: index, key: key } = context;
    const row = rows[index];
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        children: row && row.renderItem(context)
    }, key);
};

});
parcelRegister("lsq3w", function(module, exports) {
$parcel$export(module.exports, "default", () => $07be3c7ce6c6059f$export$2e2bcd8739ae039);
/* EmojiPickerCategoryHeading.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kDaaB = parcelRequire("kDaaB");

var $fqzOa = parcelRequire("fqzOa");

var $2lSsS = parcelRequire("2lSsS");
const $07be3c7ce6c6059f$var$emojiCategoryTitle = null;
const $07be3c7ce6c6059f$export$354d69a9ad71a0a0 = 'render-emoji-picker-categorty-heading';
const $07be3c7ce6c6059f$var$EmojiPickerCategoryHeading = ({ id: id, title: title, className: className })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        id: id,
        "data-category-id": id,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-testid": $07be3c7ce6c6059f$export$354d69a9ad71a0a0,
        role: "rowheader",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            className: (0, $hcewu.default)([
                "_11c82smr _vchhusvi _syazj3m3 _ca0q12x7 _n3td12x7 _19bvu2gc _u5f3u2gc _1p1d1qyh _299mangw"
            ]),
            children: (0, $fqzOa.isMessagesKey)(title) ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $2lSsS.messages)[title]
            }) : title
        })
    });
var $07be3c7ce6c6059f$export$2e2bcd8739ae039 = $07be3c7ce6c6059f$var$EmojiPickerCategoryHeading;

});

parcelRegister("zYTQn", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1317d59989091d2$export$2e2bcd8739ae039);
/* EmojiPickerEmojiRow.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $ltta5 = parcelRequire("ltta5");

var $kkQ7l = parcelRequire("kkQ7l");

var $2lSsS = parcelRequire("2lSsS");
const $c1317d59989091d2$var$emojiItem = null;
const $c1317d59989091d2$var$emojiPickerRow = null;
const $c1317d59989091d2$var$EmojiPickerEmojiRow = ({ emojis: emojis, onSelected: onSelected, onMouseMove: onMouseMove, onFocus: onFocus, title: title, showDelete: showDelete, onDelete: onDelete, virtualItemContext: virtualItemContext })=>{
    const { currentEmojisFocus: currentEmojisFocus, setEmojisFocus: setEmojisFocus } = (0, $kkQ7l.useEmojiPickerListContext)();
    const rowIndex = virtualItemContext?.index || 0;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleFocus = (index)=>(emojiId, emoji, event)=>{
            setEmojisFocus({
                rowIndex: rowIndex,
                columnIndex: index
            });
            onFocus && onFocus(emojiId, emoji, event);
        };
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        role: "presentation",
        className: (0, $hcewu.default)([
            "_18u0u2gc"
        ]),
        children: emojis.map((emoji, index)=>{
            const { shortName: shortName, id: id } = emoji;
            const key = id ? `${id}-${title}` : `${shortName}-${title}`;
            const focus = currentEmojisFocus.rowIndex === rowIndex && currentEmojisFocus.columnIndex === index;
            return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                role: "gridcell",
                "aria-colindex": index + 1,
                className: (0, $hcewu.default)([
                    "_1e0c1o8l _y3gn1h6o _1bsb1ylp _1wcg1qi0 _1678tlke _7b50u2gc _1rf4u2gc _b4kiu2gc _bm9mu2gc _1lvc1tcg _1cf71tcg _8vlfze3t _1909ze3t _1tcfze3t _n7xcze3t _4ubfu2gc _18x3u2gc _fw9su2gc _29jju2gc _qpkw1tcg _elsp1tcg _vtzrze3t _w2q0ze3t _o5kcze3t _1mc3ze3t _115ch2mm _yrst1ssb _85ft1ssb _5mfndbra _1k8z1tcg _17dz1tcg _zdyf1ule _1mn81tcg _u5ah1tcg"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ltta5.default), {
                    emoji: emoji,
                    selectOnHover: true,
                    onSelected: onSelected,
                    onMouseMove: onMouseMove,
                    onFocus: handleFocus(index),
                    showDelete: showDelete,
                    onDelete: onDelete,
                    placeholderSize: 24,
                    "data-focus-index": `${rowIndex}-${index}`,
                    tabIndex: focus ? 0 : -1,
                    "aria-roledescription": formatMessage((0, $2lSsS.messages).emojiButtonRoleDescription),
                    shouldBeInteractive: true
                })
            }, key);
        })
    });
};
var $c1317d59989091d2$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($c1317d59989091d2$var$EmojiPickerEmojiRow);

});
parcelRegister("ltta5", function(module, exports) {
$parcel$export(module.exports, "default", () => $17896e8d306ebdbe$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $fqzOa = parcelRequire("fqzOa");

var $adGgK = parcelRequire("adGgK");

var $32Nbx = parcelRequire("32Nbx");

var $i4Ljn = parcelRequire("i4Ljn");

var $k8ZdJ = parcelRequire("k8ZdJ");

var $dekK8 = parcelRequire("dekK8");

var $b9cFG = parcelRequire("b9cFG");

var $8B8Wm = parcelRequire("8B8Wm");
var $iVp1F = parcelRequire("iVp1F");

var $8iUeU = parcelRequire("8iUeU");

var $8B8Wm = parcelRequire("8B8Wm");

var $dqI8g = parcelRequire("dqI8g");

var $db4JS = parcelRequire("db4JS");
const $17896e8d306ebdbe$export$e81207f376d36133 = (props)=>{
    // Optimisation to only render CachingMediaEmoji if necessary
    // slight performance hit, which accumulates for a large number of emoji.
    const { emoji: emoji, placeholderSize: placeholderSize, ...restProps } = props;
    // start emoji rendered experience, it may have already started earlier in `ResourcedEmoji`.
    (0, $iVp1F.useSampledUFOComponentExperience)((0, $8B8Wm.ufoExperiences)['emoji-rendered'].getInstance(emoji.id || emoji.shortName), (0, $8iUeU.SAMPLING_RATE_EMOJI_RENDERED_EXP), {
        source: 'CachingEmoji',
        emojiId: emoji.id
    });
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, $8B8Wm.hasUfoMarked)((0, $8B8Wm.sampledUfoRenderedEmoji)(emoji), 'fmp')) (0, $8B8Wm.sampledUfoRenderedEmoji)(emoji).markFMP();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const emojiNode = ()=>{
        if ((0, $fqzOa.isMediaEmoji)(emoji)) return /*#__PURE__*/ (0, $gt9Am.jsx)($17896e8d306ebdbe$export$aa961da7639f7a98, {
            emoji: emoji,
            placeholderSize: placeholderSize,
            ...restProps
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)($17896e8d306ebdbe$var$StandardEmoji, {
            emoji: emoji,
            ...restProps
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b9cFG.UfoErrorBoundary), {
        experiences: [
            (0, $8B8Wm.ufoExperiences)['emoji-rendered'].getInstance(props.emoji.id || props.emoji.shortName)
        ],
        children: emojiNode()
    });
};
const $17896e8d306ebdbe$var$StandardEmoji = (props)=>{
    const { emoji: emoji, ...restProps } = props;
    const [imageLoadError, setImageLoadError] = (0, $eJOHy.useState)(false);
    const handleLoadError = (_emojiId)=>{
        setImageLoadError(true);
    };
    if (imageLoadError) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dekK8.default), {
        emoji: emoji,
        ...restProps
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i4Ljn.default), {
        emoji: emoji,
        onLoadError: handleLoadError,
        ...restProps
    });
};
const $17896e8d306ebdbe$export$aa961da7639f7a98 = (props)=>{
    const { emoji: emoji, placeholderSize: placeholderSize, showTooltip: showTooltip, fitToHeight: fitToHeight, children: children, ...restProps } = props;
    const { shortName: shortName, representation: representation } = emoji;
    const [cachedEmoji, setCachedEmoji] = (0, $eJOHy.useState)();
    const [inValidImage, setInvalidImage] = (0, $eJOHy.useState)(false);
    const { emojiProvider: emojiProvider } = (0, $dqI8g.useEmoji)();
    const loadEmoji = (0, $eJOHy.useCallback)((emojiProvider)=>{
        (0, $32Nbx.default)('Loading image via media cache', emoji.shortName);
        (0, $8B8Wm.sampledUfoRenderedEmoji)(emoji).mark((0, $adGgK.UfoEmojiTimings).MEDIA_START);
        emojiProvider.getMediaEmojiDescriptionURLWithInlineToken(emoji).then((cachedEmoji)=>{
            setCachedEmoji(cachedEmoji);
            setInvalidImage(false);
            (0, $8B8Wm.sampledUfoRenderedEmoji)(emoji).mark((0, $adGgK.UfoEmojiTimings).MEDIA_END);
        }).catch((error)=>{
            setCachedEmoji(undefined);
            setInvalidImage(true);
            (0, $8B8Wm.sampledUfoRenderedEmoji)(emoji).failure({
                metadata: {
                    error: (0, $db4JS.extractErrorInfo)(error),
                    reason: 'failed to load media emoji',
                    source: 'CachingMediaEmoji',
                    emojiId: emoji.id
                }
            });
        });
    }, [
        emoji
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (emojiProvider) loadEmoji(emojiProvider);
    }, [
        emojiProvider,
        loadEmoji
    ]);
    const handleLoadError = (_emojiId)=>{
        (0, $8B8Wm.sampledUfoRenderedEmoji)(_emojiId).failure({
            metadata: {
                reason: 'load error',
                source: 'CachingMediaEmoji',
                emojiId: _emojiId.id
            }
        });
        setInvalidImage(true);
    };
    if (cachedEmoji && !inValidImage) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i4Ljn.default), {
        ...restProps,
        showTooltip: showTooltip,
        fitToHeight: fitToHeight,
        emoji: cachedEmoji,
        onLoadError: handleLoadError
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8ZdJ.default), {
        size: fitToHeight || placeholderSize,
        shortName: shortName,
        showTooltip: showTooltip,
        representation: representation
    });
};
var $17896e8d306ebdbe$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($17896e8d306ebdbe$export$e81207f376d36133);

});
parcelRegister("dekK8", function(module, exports) {
$parcel$export(module.exports, "default", () => $faab7894433509c5$export$2e2bcd8739ae039);
/* EmojiFallback.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
parcelRequire("eJOHy");

var $i4Ljn = parcelRequire("i4Ljn");

const $faab7894433509c5$var$emojiFallbackStyles = null;
const $faab7894433509c5$export$e3a226c1c0d61870 = (props)=>{
    const { emoji: emoji, selected: selected, selectOnHover: selectOnHover, className: className } = props;
    const { fallback: fallback, shortName: shortName } = emoji;
    const classes = `${(0, $eb4c5e773f9bbee2$export$b06c4aab1d012063)} ${selected ? (0, $eb4c5e773f9bbee2$export$8633a0edef8e95dd) : ''} ${selectOnHover ? (0, $eb4c5e773f9bbee2$export$860109dfd198259b) : ''} ${className ? className : ''}`;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i4Ljn.EmojiNodeWrapper), {
        type: "image",
        ...props,
        className: classes,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            className: (0, $hcewu.default)([
                "_1reo15vq _18m915vq _1e0c1txw _1bsb1osq _4t3i1osq _1bah1h6o _4cvr1h6o"
            ]),
            children: fallback || shortName
        })
    }));
};
var $faab7894433509c5$export$2e2bcd8739ae039 = $faab7894433509c5$export$e3a226c1c0d61870;

});

parcelRegister("dqI8g", function(module, exports) {
$parcel$export(module.exports, "useEmoji", () => $8ea412cb74f38f8e$export$482903c4ce3f5633);

var $eJOHy = parcelRequire("eJOHy");

var $64Cd4 = parcelRequire("64Cd4");
const $8ea412cb74f38f8e$var$supportsUploadFeature = (emojiProvider)=>{
    const emojiUploadProvider = emojiProvider;
    return !!emojiUploadProvider.isUploadSupported && !!emojiUploadProvider.uploadCustomEmoji && !!emojiUploadProvider.prepareForUpload;
};
const $8ea412cb74f38f8e$export$482903c4ce3f5633 = ()=>{
    const context = (0, $eJOHy.useContext)((0, $64Cd4.EmojiContext));
    // Hooks API
    const [isUploadSupported, setIsUploadSupported] = (0, $eJOHy.useState)(false);
    if (!context) throw new Error('useEmoji must be used within EmojiContext');
    const { emojiProvider: emojiProvider } = context.emoji;
    (0, $eJOHy.useEffect)(()=>{
        if ($8ea412cb74f38f8e$var$supportsUploadFeature(emojiProvider)) {
            const checkIfUploadIsSupported = async ()=>{
                try {
                    const supported = await emojiProvider.isUploadSupported();
                    setIsUploadSupported(supported);
                } catch (error) {
                    return false;
                }
            };
            checkIfUploadIsSupported();
        }
    }, [
        emojiProvider
    ]);
    return {
        emojiProvider: emojiProvider,
        isUploadSupported: isUploadSupported
    };
};

});

parcelRegister("db4JS", function(module, exports) {
$parcel$export(module.exports, "createAndFireEventInElementsChannel", () => $86131ba6e700aea8$export$53eef0dcd9611650);
$parcel$export(module.exports, "recordSucceededEmoji", () => $86131ba6e700aea8$export$3125c3f60f61a0a9);
$parcel$export(module.exports, "recordFailedEmoji", () => $86131ba6e700aea8$export$ccd0c8bcbda28b7a);
$parcel$export(module.exports, "openedPickerEvent", () => $86131ba6e700aea8$export$956acef77052d363);
$parcel$export(module.exports, "closedPickerEvent", () => $86131ba6e700aea8$export$151c59c3f6a1ff5f);
$parcel$export(module.exports, "pickerClickedEvent", () => $86131ba6e700aea8$export$d69b5cd43769bb6b);
$parcel$export(module.exports, "categoryClickedEvent", () => $86131ba6e700aea8$export$8e021f755a07e0d2);
$parcel$export(module.exports, "pickerSearchedEvent", () => $86131ba6e700aea8$export$d800a6d814034c48);
$parcel$export(module.exports, "toneSelectedEvent", () => $86131ba6e700aea8$export$e559e98af3da9d17);
$parcel$export(module.exports, "toneSelectorOpenedEvent", () => $86131ba6e700aea8$export$7274b855c80879c4);
$parcel$export(module.exports, "toneSelectorClosedEvent", () => $86131ba6e700aea8$export$301f0d0181307f7);
$parcel$export(module.exports, "uploadBeginButton", () => $86131ba6e700aea8$export$be48de448ed1f64f);
$parcel$export(module.exports, "uploadConfirmButton", () => $86131ba6e700aea8$export$b82a2393560e5893);
$parcel$export(module.exports, "uploadCancelButton", () => $86131ba6e700aea8$export$47ef032c3ec0a60a);
$parcel$export(module.exports, "uploadSucceededEvent", () => $86131ba6e700aea8$export$6aed2b90719a7d39);
$parcel$export(module.exports, "uploadFailedEvent", () => $86131ba6e700aea8$export$18cfbd0c8c6d2297);
$parcel$export(module.exports, "deleteBeginEvent", () => $86131ba6e700aea8$export$d74d89c79fff5a67);
$parcel$export(module.exports, "deleteConfirmEvent", () => $86131ba6e700aea8$export$87a8007f9e978b47);
$parcel$export(module.exports, "deleteCancelEvent", () => $86131ba6e700aea8$export$9877255e5a8f0cde);
$parcel$export(module.exports, "selectedFileEvent", () => $86131ba6e700aea8$export$fc14407a1d009938);
$parcel$export(module.exports, "recordSelectionSucceededSli", () => $86131ba6e700aea8$export$524400435f62e003);
$parcel$export(module.exports, "recordSelectionFailedSli", () => $86131ba6e700aea8$export$d1176b797f0912b8);
$parcel$export(module.exports, "extractErrorInfo", () => $86131ba6e700aea8$export$74aaf4784c2edb2c);

var $5fWw9 = parcelRequire("5fWw9");

var $adGgK = parcelRequire("adGgK");
const $86131ba6e700aea8$export$53eef0dcd9611650 = (0, $5fWw9.default)('fabric-elements');
const $86131ba6e700aea8$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes
        }
    });
const $86131ba6e700aea8$export$3125c3f60f61a0a9 = (emoji)=>(source)=>{
        return $86131ba6e700aea8$var$createEvent('operational', 'succeeded', 'recordEmojiSelection', undefined, {
            source: source,
            emojiId: emoji?.id,
            emojiType: emoji?.type,
            emojiCategory: emoji?.category
        });
    };
const $86131ba6e700aea8$export$4e713a2b020a4dca = (source)=>{
    return $86131ba6e700aea8$var$createEvent('operational', 'succeeded', 'recordEmojiSelection', undefined, {
        source: source
    });
};
const $86131ba6e700aea8$export$ccd0c8bcbda28b7a = (emoji)=>(source)=>{
        return $86131ba6e700aea8$var$createEvent('operational', 'failed', 'recordEmojiSelection', undefined, {
            source: source,
            emojiId: emoji?.id,
            emojiType: emoji?.type,
            emojiCategory: emoji?.category
        });
    };
const $86131ba6e700aea8$export$5bd025a43378005c = (source)=>{
    return $86131ba6e700aea8$var$createEvent('operational', 'failed', 'recordEmojiSelection', undefined, {
        source: source
    });
};
const $86131ba6e700aea8$var$emojiPickerEvent = (action, attributes = {}, actionSubjectId)=>$86131ba6e700aea8$var$createEvent('ui', action, 'emojiPicker', actionSubjectId, attributes);
const $86131ba6e700aea8$export$956acef77052d363 = ()=>$86131ba6e700aea8$var$emojiPickerEvent('opened');
const $86131ba6e700aea8$export$151c59c3f6a1ff5f = (attributes)=>$86131ba6e700aea8$var$emojiPickerEvent('closed', attributes);
const $86131ba6e700aea8$var$skinTones = [
    {
        id: '-1f3fb',
        skinToneModifier: 'light'
    },
    {
        id: '-1f3fc',
        skinToneModifier: 'mediumLight'
    },
    {
        id: '-1f3fd',
        skinToneModifier: 'medium'
    },
    {
        id: '-1f3fe',
        skinToneModifier: 'mediumDark'
    },
    {
        id: '-1f3ff',
        skinToneModifier: 'dark'
    }
];
const $86131ba6e700aea8$var$getSkinTone = (emojiId)=>{
    if (!emojiId) return {};
    for (const { id: id, skinToneModifier: skinToneModifier } of $86131ba6e700aea8$var$skinTones){
        if (emojiId.indexOf(id) !== -1) return {
            skinToneModifier: skinToneModifier,
            baseEmojiId: emojiId.replace(id, '')
        };
    }
    return {};
};
const $86131ba6e700aea8$export$d69b5cd43769bb6b = (attributes)=>$86131ba6e700aea8$var$emojiPickerEvent('clicked', {
        ...$86131ba6e700aea8$var$getSkinTone(attributes.emojiId),
        ...attributes
    }, 'emoji');
const $86131ba6e700aea8$export$8e021f755a07e0d2 = (attributes)=>$86131ba6e700aea8$var$emojiPickerEvent('clicked', attributes, 'category');
const $86131ba6e700aea8$export$d800a6d814034c48 = (attributes)=>$86131ba6e700aea8$var$emojiPickerEvent('searched', attributes, 'query');
const $86131ba6e700aea8$var$skintoneSelectorEvent = (action, attributes = {})=>$86131ba6e700aea8$var$createEvent('ui', action, 'emojiSkintoneSelector', undefined, attributes);
const $86131ba6e700aea8$export$e559e98af3da9d17 = (attributes)=>$86131ba6e700aea8$var$skintoneSelectorEvent('clicked', attributes);
const $86131ba6e700aea8$export$7274b855c80879c4 = (attributes)=>$86131ba6e700aea8$var$skintoneSelectorEvent('opened', attributes);
const $86131ba6e700aea8$export$301f0d0181307f7 = ()=>$86131ba6e700aea8$var$skintoneSelectorEvent('cancelled');
const $86131ba6e700aea8$var$emojiUploaderEvent = (action, actionSubjectId, attributes)=>$86131ba6e700aea8$var$createEvent('ui', action, 'emojiUploader', actionSubjectId, attributes);
const $86131ba6e700aea8$export$be48de448ed1f64f = ()=>$86131ba6e700aea8$var$emojiUploaderEvent('clicked', 'addButton');
const $86131ba6e700aea8$export$b82a2393560e5893 = (attributes)=>$86131ba6e700aea8$var$emojiUploaderEvent('clicked', 'confirmButton', attributes);
const $86131ba6e700aea8$export$47ef032c3ec0a60a = ()=>$86131ba6e700aea8$var$emojiUploaderEvent('clicked', 'cancelButton');
const $86131ba6e700aea8$export$6aed2b90719a7d39 = (attributes)=>$86131ba6e700aea8$var$createEvent('operational', 'finished', 'emojiUploader', undefined, attributes);
const $86131ba6e700aea8$export$18cfbd0c8c6d2297 = (attributes)=>$86131ba6e700aea8$var$createEvent('operational', 'failed', 'emojiUploader', undefined, attributes);
const $86131ba6e700aea8$export$d74d89c79fff5a67 = (attributes)=>$86131ba6e700aea8$var$createEvent('ui', 'clicked', 'emojiPicker', 'deleteEmojiTrigger', attributes);
const $86131ba6e700aea8$export$87a8007f9e978b47 = (attributes)=>$86131ba6e700aea8$var$createEvent('ui', 'clicked', 'emojiPicker', 'deleteEmojiConfirm', attributes);
const $86131ba6e700aea8$export$9877255e5a8f0cde = (attributes)=>$86131ba6e700aea8$var$createEvent('ui', 'clicked', 'emojiPicker', 'deleteEmojiCancel', attributes);
const $86131ba6e700aea8$export$fc14407a1d009938 = ()=>$86131ba6e700aea8$var$createEvent('ui', 'clicked', 'emojiUploader', 'selectFile');
const $86131ba6e700aea8$var$extractCommonAttributes = (query, emojiList)=>{
    return {
        queryLength: query ? query.length : 0,
        spaceInQuery: query ? query.indexOf(' ') !== -1 : false,
        emojiIds: emojiList ? emojiList.map((emoji)=>emoji.id).filter(Boolean).slice(0, 20) : []
    };
};
const $86131ba6e700aea8$export$89566522a5321393 = (duration, query, emojiList)=>$86131ba6e700aea8$var$createEvent('ui', 'cancelled', 'emojiTypeahead', undefined, {
        duration: duration,
        ...$86131ba6e700aea8$var$extractCommonAttributes(query, emojiList)
    });
const $86131ba6e700aea8$var$getPosition = (emojiList, selectedEmoji)=>{
    if (emojiList) {
        const index = emojiList.findIndex((emoji)=>emoji.id === selectedEmoji.id);
        return index === -1 ? undefined : index;
    }
    return;
};
const $86131ba6e700aea8$export$475603c082d8a174 = (pressed, duration, emoji, emojiList, query, exactMatch)=>$86131ba6e700aea8$var$createEvent('ui', pressed ? 'pressed' : 'clicked', 'emojiTypeahead', undefined, {
        duration: duration,
        position: $86131ba6e700aea8$var$getPosition(emojiList, emoji),
        ...$86131ba6e700aea8$var$extractCommonAttributes(query, emojiList),
        ...$86131ba6e700aea8$var$getSkinTone(emoji.id),
        emojiType: emoji.type,
        exactMatch: exactMatch || false
    });
const $86131ba6e700aea8$export$bbbb081930a4e19d = (duration, query, emojiList)=>$86131ba6e700aea8$var$createEvent('operational', 'rendered', 'emojiTypeahead', undefined, {
        duration: duration,
        ...$86131ba6e700aea8$var$extractCommonAttributes(query, emojiList)
    });
const $86131ba6e700aea8$export$524400435f62e003 = (emoji, options)=>()=>{
        if (options && options.createAnalyticsEvent) (0, $5fWw9.default)('editor')($86131ba6e700aea8$export$3125c3f60f61a0a9(emoji)((0, $adGgK.SearchSourceTypes).TYPEAHEAD))(options.createAnalyticsEvent);
    };
const $86131ba6e700aea8$export$d1176b797f0912b8 = (emoji, options)=>(err)=>{
        if (options && options.createAnalyticsEvent) (0, $5fWw9.default)('editor')($86131ba6e700aea8$export$ccd0c8bcbda28b7a(emoji)((0, $adGgK.SearchSourceTypes).TYPEAHEAD))(options.createAnalyticsEvent);
        return Promise.reject(err);
    };
const $86131ba6e700aea8$export$74aaf4784c2edb2c = (error)=>{
    if (error instanceof Error) return {
        name: error.name,
        message: error.message
    };
    return error;
};

});


parcelRegister("kkQ7l", function(module, exports) {
$parcel$export(module.exports, "useEmojiPickerListContext", () => $21f87df7919e0d92$export$1d569b16c0178739);

var $eJOHy = parcelRequire("eJOHy");

var $5XzHA = parcelRequire("5XzHA");
const $21f87df7919e0d92$export$1d569b16c0178739 = ()=>(0, $eJOHy.useContext)((0, $5XzHA.EmojiPickerListContext));

});
parcelRegister("5XzHA", function(module, exports) {
$parcel$export(module.exports, "EmojiPickerListContext", () => $abfdae19395bd978$export$968c8d71e683bcd1);
$parcel$export(module.exports, "EmojiPickerListContextProvider", () => $abfdae19395bd978$export$6f4d9357992f0254);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $abfdae19395bd978$export$968c8d71e683bcd1 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    currentEmojisFocus: {
        rowIndex: 0,
        columnIndex: 0
    },
    setEmojisFocus: ()=>{}
});
const $abfdae19395bd978$export$6f4d9357992f0254 = (props)=>{
    const [currentEmojisFocus, setEmojisFocus] = (0, $eJOHy.useState)(props.initialEmojisFocus);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($abfdae19395bd978$export$968c8d71e683bcd1.Provider, {
        value: {
            currentEmojisFocus: currentEmojisFocus,
            setEmojisFocus: setEmojisFocus
        },
        children: props.children
    });
};

});



parcelRegister("d2aiW", function(module, exports) {
$parcel$export(module.exports, "sizes", () => $7e822d7b540cf30b$export$c647cb0ee6e282fe);

var $8iUeU = parcelRequire("8iUeU");
const $7e822d7b540cf30b$export$c647cb0ee6e282fe = {
    listHeight: (0, $8iUeU.emojiPickerListHeight),
    listWidth: (0, $8iUeU.emojiPickerWidth),
    searchHeight: 52,
    categoryHeadingHeight: 30,
    emojiRowHeight: 40,
    addEmojiHeight: 32,
    loadingRowHeight: 150,
    uploadActionHeight: 40,
    emojiPerRow: 8
};

});


parcelRegister("6KprU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("ccRp1")
]).then(()=>parcelRequire('7GAVa'));

});


parcelRegister("aIqUF", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f2930e4e1a27d2c$export$2e2bcd8739ae039);
/* EmojiTypeAheadItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $4FlMD = parcelRequire("4FlMD");

var $huLzh = parcelRequire("huLzh");

var $fqzOa = parcelRequire("fqzOa");

var $i0kkc = parcelRequire("i0kkc");

const $8f2930e4e1a27d2c$var$typeAheadWidth = 350;
const $8f2930e4e1a27d2c$var$typeAheadItem = null;
const $8f2930e4e1a27d2c$var$selectedStyles = null;
const $8f2930e4e1a27d2c$var$typeAheadItemRow = null;
function $8f2930e4e1a27d2c$export$616ca81e9448d046(props) {
    const { emoji: emoji, onSelection: onSelection, onMouseMove: onMouseMove, selected: selected, emojiProvider: emojiProvider, forwardedRef: forwardedRef } = props;
    const onEmojiSelected = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        if ((0, $huLzh.leftClick)(event) && onSelection) {
            event.preventDefault();
            onSelection((0, $fqzOa.toEmojiId)(emoji), emoji, event);
        }
    }, [
        emoji,
        onSelection
    ]);
    const onEmojiMenuItemMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        if (onMouseMove) onMouseMove((0, $fqzOa.toEmojiId)(emoji), emoji, event);
    }, [
        emoji,
        onMouseMove
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4FlMD.EmojiCommonProvider), {
        emojiProvider: emojiProvider,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $hcewu.default)([
                "_1reo15vq _18m915vq _80omtlke _1e0c1ule _2mzuglyw _1bsb1edt",
                selected && "_bfhk1yrq",
                `ak-emoji-typeahead-item ${selected ? (0, $2829b0b539ff9660$export$214089244105a739) : ''}`
            ]),
            onMouseDown: onEmojiSelected,
            onMouseMove: onEmojiMenuItemMouseMove,
            "data-emoji-id": emoji.shortName,
            ref: forwardedRef,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    "_1e0c1txw _2lx2vrvc _1n261g80 _s7n4nkob"
                ]),
                children: emoji && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i0kkc.EmojiPreviewComponent), {
                    emoji: emoji
                })
            })
        })
    });
}
const $8f2930e4e1a27d2c$var$EmojiTypeAheadItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)($8f2930e4e1a27d2c$export$616ca81e9448d046, {
        ...props,
        forwardedRef: ref
    }));
var $8f2930e4e1a27d2c$export$2e2bcd8739ae039 = $8f2930e4e1a27d2c$var$EmojiTypeAheadItem;

});
parcelRegister("i0kkc", function(module, exports) {
$parcel$export(module.exports, "EmojiPreviewComponent", () => $7b84e20d32eb1d27$export$222c91bd2db2d158);
/* EmojiPreviewComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $ltta5 = parcelRequire("ltta5");
const $7b84e20d32eb1d27$var$emojiName = null;
const $7b84e20d32eb1d27$var$emojiShortName = null;
const $7b84e20d32eb1d27$var$preview = null;
const $7b84e20d32eb1d27$var$previewImg = null;
const $7b84e20d32eb1d27$var$previewText = null;
const $7b84e20d32eb1d27$export$222c91bd2db2d158 = ({ emoji: emoji })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        className: (0, $hcewu.default)([
            "_ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1e0c1txw _2lx2vrvc _1n261q9c _4t3izwfg _4cvr1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                className: (0, $hcewu.default)([
                    "_1e0c1o8l _1bsbzwfg _12s6idpf _1e4didpf _1dvqidpf _vwlxidpf _1gdiidpf _1f45idpf _pdfdidpf _mwo3idpf _5ilezwfg _boltzwfg _1pc7zwfg _u5wqzwfg _w7981kw7 _1vqe1kw7 _1l4xidpf _1l79idpf _118didpf _1pa4idpf _1pglh2mm _1vjf1ssb _1h6o1ssb _8fp6dbra _1os4zwfg _1e7azwfg _7mh21ule"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ltta5.default), {
                    emoji: emoji
                }, emoji.id || emoji.shortName)
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                className: (0, $hcewu.default)([
                    "_1e0c1txw _2lx21bp4 _1wpz1h6o _19pk1i6y _18u019bv _p12f3sup _1bsb3sup _16jlkb7n _1o9zkb7n"
                ]),
                children: [
                    emoji.name && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            "_1reo15vq _18m915vq _1e0c1ule _syazj3m3 _1bto1l2s _o5721q9c _299mangw"
                        ]),
                        children: emoji.name
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            "_11c8dcr7 _1reo15vq _18m915vq _1e0c1ule _syaz1a45 _vwz4kb7n _otyr1i6y _n3tdv77o _1bto1l2s _o5721q9c _10hw2smr _pnmbj3m3"
                        ]),
                        children: emoji.shortName
                    })
                ]
            })
        ]
    });
};

});

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
const $2829b0b539ff9660$export$dca0df2a2f0ab6cf = 'emoji-typeahead-element';
const $2829b0b539ff9660$export$9b2d029b494a863e = 'emoji-typeahead-list-container';
const $2829b0b539ff9660$export$214089244105a739 = 'emoji-typeahead-selected';


parcelRegister("53MhD", function(module, exports) {
$parcel$export(module.exports, "supportsUploadFeature", () => $a7fb98cbcf1e0eb5$export$7b697b720032fd6f);
$parcel$export(module.exports, "default", () => $a7fb98cbcf1e0eb5$export$2e2bcd8739ae039);
parcelRequire("kp3br");
var $7Eo2D = parcelRequire("7Eo2D");
var $kp3br = parcelRequire("kp3br");

var $8iUeU = parcelRequire("8iUeU");

var $32Nbx = parcelRequire("32Nbx");

var $fqzOa = parcelRequire("fqzOa");

var $G2hpM = parcelRequire("G2hpM");

var $adGgK = parcelRequire("adGgK");

var $kMGBZ = parcelRequire("kMGBZ");

var $5QefI = parcelRequire("5QefI");

var $g84Mp = parcelRequire("g84Mp");

var $8B8Wm = parcelRequire("8B8Wm");

var $1AKB0 = parcelRequire("1AKB0");
const $a7fb98cbcf1e0eb5$export$7b697b720032fd6f = (emojiProvider)=>{
    const emojiUploadProvider = emojiProvider;
    return !!emojiUploadProvider.isUploadSupported && !!emojiUploadProvider.uploadCustomEmoji && !!emojiUploadProvider.prepareForUpload;
};
class $a7fb98cbcf1e0eb5$export$b5efafc6dd611ec5 extends (0, $7Eo2D.AbstractResource) {
    constructor(config){
        super(), this.activeLoaders = 0, this.initialLoaders = 0, this.retries = new Map(), this.isInitialised = false, this.fetchOnDemand = false, this.getOptimisticImageURL = (emojiId)=>{
            if (this.emojiProviderConfig.optimisticImageApi) return this.emojiProviderConfig.optimisticImageApi.getUrl(emojiId);
            return;
        }, this.isRepositoryAvailable = (repository)=>{
            return !!repository;
        }, this.isLoaded = ()=>this.initialLoaders !== 0 && this.activeLoaders === 0;
        this.emojiProviderConfig = config;
        this.recordConfig = config.recordConfig;
        this.currentUser = config.currentUser;
        if ((0, $G2hpM.default)('localStorage')) this.selectedTone = this.loadStoredTone();
        if (config.providers.length === 0) throw new Error('No providers specified');
        this.fetchOnDemand = !!config.options && !!config.options.onlyFetchOnDemand;
        this.initialLoaders = this.emojiProviderConfig.providers.length;
        this.activeLoaders = this.emojiProviderConfig.providers.length;
        this.emojiResponses = [];
    }
    /**
	 * Get the emoji provider from Emoji Resource
	 * @returns Promise<EmojiProvider>
	 */ async getEmojiProvider(options = {
        fetchAtStart: !this.fetchOnDemand
    }) {
        if (options.fetchAtStart) try {
            await this.fetchEmojiProvider();
        } catch (error) {
            (0, $32Nbx.default)(error);
            return Promise.resolve(this);
        }
        return Promise.resolve(this);
    }
    async fetchIndividualProvider(provider, index) {
        const providerType = this.getProviderType(provider);
        try {
            (0, $8B8Wm.sampledUfoEmojiResourceFetched)(providerType).start({
                samplingRate: (0, $8iUeU.SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP)
            });
            (0, $8B8Wm.sampledUfoEmojiResourceFetched)(providerType).addMetadata({
                type: providerType
            });
            const loader = new (0, $kMGBZ.default)(provider);
            // fetch emoji from provider url and denormalise
            const emojiResponse = await loader.loadEmoji();
            (0, $8B8Wm.sampledUfoEmojiResourceFetched)(providerType).success();
            // setup emoji repository
            this.emojiResponses[index] = emojiResponse;
            this.initEmojiRepository(this.emojiResponses);
            await this.initSiteEmojiResource(emojiResponse, provider);
            this.activeLoaders--;
            this.performRetries();
            this.refreshLastFilter();
        } catch (error) {
            this.activeLoaders--;
            this.notifyError(error);
            (0, $8B8Wm.sampledUfoEmojiResourceFetched)(providerType).failure({
                metadata: {
                    reason: error,
                    source: 'EmojiProvider',
                    providerUrl: provider.url
                }
            });
            (0, $32Nbx.default)(`failed to fetch emoji provider for ${provider.url}`, error);
            throw new Error(`failed to fetch emoji from ${provider.url}`);
        }
    }
    async fetchEmojiProvider(force = false) {
        // unless (re-)fetch is being forced, fetching will only
        // happen if no emojiRepository exists
        // in case this method is called and emojiRepository has already been populated
        // the method will just return the existing emojiRepository
        if (force || !this.isRepositoryAvailable(this.emojiRepository) && !this.isInitialised) {
            this.isInitialised = true;
            this.emojiResponses = [];
            // fetch emoji providers
            await Promise.all(this.emojiProviderConfig.providers.map((provider, index)=>this.fetchIndividualProvider(provider, index)));
        }
        return Promise.resolve(this.emojiRepository);
    }
    onlyFetchOnDemand() {
        return this.fetchOnDemand;
    }
    async fetchByEmojiId(emojiId, optimistic) {
        // Check if repository exists and emoji is defined.
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) {
            const emoji = await this.findByEmojiId(emojiId);
            if (emoji) return await this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
        }
        // If optimistic is fetched
        if (this.emojiProviderConfig.singleEmojiApi && optimistic) {
            // if config has singleEmojiApi then fetch single emoji
            const provider = {
                url: this.emojiProviderConfig.singleEmojiApi.getUrl(emojiId),
                securityProvider: this.emojiProviderConfig.singleEmojiApi.securityProvider
            };
            const loader = new (0, $kMGBZ.default)(provider);
            try {
                const loadEmoji = await loader.loadEmoji();
                if (!loadEmoji.emojis[0]) return;
                if (!this.isRepositoryAvailable(this.siteEmojiResource)) await this.initSiteEmojiResource(loadEmoji, provider);
                return this.getMediaEmojiDescriptionURLWithInlineToken(loadEmoji.emojis[0]);
            } catch  {
                const emoji = await this.findByEmojiId(emojiId);
                if (!emoji) return;
                return this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
            }
        }
        const emoji = await this.findByEmojiId(emojiId);
        if (!emoji) return;
        return this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
    }
    getProviderType(provider) {
        if (provider.url.includes('/site')) return (0, $adGgK.ProviderTypes).SITE;
        else if (provider.url.includes('/standard')) return (0, $adGgK.ProviderTypes).STANDARD;
        else if (provider.url.includes('/atlassian')) return (0, $adGgK.ProviderTypes).ATLASSIAN;
        return (0, $adGgK.ProviderTypes).UNKNOWN;
    }
    initEmojiRepository(emojiResponses) {
        let emojis = [];
        emojiResponses.forEach((emojiResponse)=>{
            emojis = emojis.concat(emojiResponse.emojis);
        });
        this.emojiRepository = new (0, $5QefI.default)(emojis);
    }
    initSiteEmojiResource(emojiResponse, provider) {
        if (!this.isRepositoryAvailable(this.siteEmojiResource) && emojiResponse.mediaApiToken) {
            this.siteEmojiResource = new (0, $g84Mp.default)(provider, emojiResponse.mediaApiToken);
            // Prime cache type + optimistic rendering by checking first Emoji.
            // If this is fails, it won't be primed until a good emoji is loaded later.
            const { emojis: emojis } = emojiResponse;
            if (emojis.length) {
                const done = this.siteEmojiResource.optimisticRendering(emojis[0]);
                if ((0, $fqzOa.isPromise)(done)) return done.then(()=>{
                    (0, $32Nbx.default)('Primed siteEmojiResource');
                }).catch(()=>{
                    (0, $32Nbx.default)('Failed to prime siteEmojiResource');
                });
                else (0, $32Nbx.default)('Already primed siteEmojiResource');
            } else (0, $32Nbx.default)('No emoji to prime siteEmojiResource with');
        }
        return Promise.resolve();
    }
    performRetries() {
        const currentRetries = this.retries;
        this.retries = new Map();
        currentRetries.forEach((resolveReject, retry)=>{
            const result = retry();
            if ((0, $fqzOa.isPromise)(result)) result.then((response)=>{
                resolveReject.resolve(response);
            }).catch((reason)=>{
                resolveReject.reject(reason);
            });
            else resolveReject.resolve(result);
        });
    }
    loadStoredTone() {
        if (typeof window === 'undefined') return undefined;
        const storedToneString = window.localStorage.getItem((0, $8iUeU.selectedToneStorageKey));
        if (storedToneString) {
            const storedTone = parseInt(storedToneString, 10);
            return !isNaN(storedTone) ? storedTone : undefined;
        }
        return undefined;
    }
    refreshLastFilter() {
        if (typeof this.lastQuery !== 'undefined') {
            const { query: query, options: options } = this.lastQuery;
            this.filter(query, options);
        }
    }
    retryIfLoading(retry, defaultResponse) {
        if (!this.isLoaded()) return new Promise((resolve, reject)=>{
            this.retries.set(retry, {
                resolve: resolve,
                reject: reject
            });
        });
        return Promise.resolve(defaultResponse);
    }
    notifyResult(result) {
        if (this.lastQuery && result.query === this.lastQuery.query) super.notifyResult(result);
    }
    /**
	 *  Returns the EmojiDescription with a valid media path that includes query token and client attributes to access the emoji media inline.
	 */ async getMediaEmojiDescriptionURLWithInlineToken(emoji) {
        if (this.isRepositoryAvailable(this.siteEmojiResource)) {
            const { representation: representation, altRepresentation: altRepresentation } = await this.siteEmojiResource.generateTokenisedMediaURLS(emoji.representation, emoji.altRepresentation);
            return {
                ...emoji,
                representation: representation,
                altRepresentation: altRepresentation
            };
        }
        return emoji;
    }
    loadMediaEmoji(emoji, useAlt) {
        if (!this.isRepositoryAvailable(this.siteEmojiResource) || !(0, $fqzOa.isMediaEmoji)(emoji)) return emoji;
        return this.siteEmojiResource.loadMediaEmoji(emoji, useAlt);
    }
    optimisticMediaRendering(emoji, useAlt) {
        if (!(0, $fqzOa.isMediaEmoji)(emoji)) return true;
        if (!this.isRepositoryAvailable(this.siteEmojiResource)) // Shouldn't have a media emoji without a siteEmojiResouce, but anyway ;)
        return false;
        const optimistic = this.siteEmojiResource.optimisticRendering(emoji, useAlt);
        if ((0, $fqzOa.isPromise)(optimistic)) // Not sure yet, so lets say no for now (this should normally be primed in most/all cases)
        return false;
        return optimistic;
    }
    filter(query, options) {
        (0, $8B8Wm.ufoExperiences)['emoji-searched'].start();
        (0, $8B8Wm.ufoExperiences)['emoji-searched'].addMetadata({
            queryLength: query?.length || 0
        });
        this.lastQuery = {
            query: query,
            options: options
        };
        if (this.isRepositoryAvailable(this.emojiRepository)) {
            const searchResults = this.emojiRepository.search(query, options);
            this.notifyResult(searchResults);
            (0, $8B8Wm.ufoExperiences)['emoji-searched'].success({
                metadata: {
                    emojisLength: searchResults.emojis.length,
                    source: options?.source || 'typeahead'
                }
            });
        } else // not ready
        this.notifyNotReady();
    }
    findByShortName(shortName) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) // Wait for all emoji to load before looking by shortName (to ensure correct priority)
        return this.emojiRepository.findByShortName(shortName);
        return this.retryIfLoading(()=>this.findByShortName(shortName), undefined);
    }
    findByEmojiId(emojiId) {
        const { id: id, shortName: shortName } = emojiId;
        if (this.isRepositoryAvailable(this.emojiRepository)) {
            if (id) {
                const emoji = this.emojiRepository.findById(id);
                if (emoji) return emoji;
                if (this.isLoaded()) {
                    // all loaded but not found by id, try server to see if
                    // this is a newly uploaded emoji
                    if (this.isRepositoryAvailable(this.siteEmojiResource)) return this.siteEmojiResource.findEmoji(emojiId).then((emoji)=>{
                        if (!emoji) // if not, fallback to searching by shortName to
                        // at least render an alternative
                        return this.findByShortName(shortName);
                        this.addUnknownEmoji(emoji);
                        return emoji;
                    });
                    // if not, fallback to searching by shortName to
                    // at least render an alternative
                    return this.findByShortName(shortName);
                }
            } else // no id fallback to shortName
            return this.findByShortName(shortName);
        }
        return this.retryIfLoading(()=>this.findByEmojiId(emojiId), undefined);
    }
    findById(id) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return this.emojiRepository.findById(id);
        return this.retryIfLoading(()=>this.findById(id), undefined);
    }
    findInCategory(categoryId) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.findInCategory(categoryId));
        return this.retryIfLoading(()=>this.findInCategory(categoryId), []);
    }
    getAsciiMap() {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getAsciiMap());
        return this.retryIfLoading(()=>this.getAsciiMap(), new Map());
    }
    getFrequentlyUsed(options) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getFrequentlyUsed(options));
        return this.retryIfLoading(()=>this.getFrequentlyUsed(options), []);
    }
    /**
	 * Record the selection of an emoji to a remote service if 'recordConfig' has been supplied.
	 * Regardless of the recordConfig, emoji selections will always be recorded on the EmojiRepository
	 * for the purposes of tracking the frequency of use.
	 *
	 * @param emoji The full description of the emoji to record usage for.
	 */ recordSelection(emoji) {
        const { recordConfig: recordConfig } = this;
        if (this.isRepositoryAvailable(this.emojiRepository)) this.emojiRepository.used(emoji);
        if (recordConfig) {
            const queryParams = {
                emojiId: (0, $fqzOa.toEmojiId)(emoji)
            };
            const requestInit = {
                method: 'POST'
            };
            return (0, $kp3br.utils).requestService(recordConfig, {
                queryParams: queryParams,
                requestInit: requestInit
            });
        }
        return Promise.resolve();
    }
    deleteSiteEmoji(emoji) {
        if (this.isRepositoryAvailable(this.siteEmojiResource) && emoji.id) return this.siteEmojiResource.deleteEmoji(emoji).then((success)=>{
            if (success && this.isRepositoryAvailable(this.emojiRepository)) {
                this.emojiRepository.delete(emoji);
                return true;
            }
            return false;
        }).catch((err)=>{
            // eslint-disable-next-line no-console
            console.error('failed to delete site emoji', err);
            return false;
        });
        return this.retryIfLoading(()=>this.deleteSiteEmoji(emoji), false);
    }
    getSelectedTone() {
        return this.selectedTone;
    }
    setSelectedTone(tone) {
        this.selectedTone = tone;
        if (typeof window === 'undefined') return;
        if ((0, $G2hpM.default)('localStorage')) try {
            window.localStorage.setItem((0, $8iUeU.selectedToneStorageKey), tone ? tone.toString() : '');
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('failed to store selected emoji skin tone', e);
        }
    }
    calculateDynamicCategories() {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getDynamicCategoryList());
        return this.retryIfLoading(()=>this.calculateDynamicCategories(), []);
    }
    getCurrentUser() {
        return this.currentUser;
    }
    addUnknownEmoji(emoji) {
        if (this.isRepositoryAvailable(this.emojiRepository)) this.emojiRepository.addUnknownEmoji(emoji);
    }
}
class $a7fb98cbcf1e0eb5$export$2e2bcd8739ae039 extends $a7fb98cbcf1e0eb5$export$b5efafc6dd611ec5 {
    constructor(config){
        super(config);
        this.allowUpload = !!config.allowUpload;
    }
    isUploadSupported() {
        if (!this.allowUpload) return Promise.resolve(false);
        if (this.isRepositoryAvailable(this.siteEmojiResource)) return this.siteEmojiResource.hasUploadToken();
        return this.retryIfLoading(()=>this.isUploadSupported(), false);
    }
    uploadCustomEmoji(upload, retry = false, timeout = 12000) {
        return this.isUploadSupported().then((supported)=>{
            if (!supported || !this.isRepositoryAvailable(this.siteEmojiResource)) return Promise.reject('No media api support is configured');
            const uploadPromise = this.siteEmojiResource.uploadEmoji(upload, retry).then((emoji)=>{
                // Use file preview blob URL to temporarily fix the graybox issue after uploading,
                // Because the media service takes time to process the image.
                // Ideally should improve CachingMediaImage by using mediaClient or mediaImage,
                // But that requires more efforts in FE & BE.
                // TODO: revist this when pick up COLLAB-2294
                emoji.representation.imagePath = upload.dataURL;
                this.addUnknownEmoji(emoji);
                this.refreshLastFilter();
                return emoji;
            });
            return (0, $1AKB0.promiseWithTimeout)(uploadPromise, timeout, 'uploadCustomEmoji timed out');
        });
    }
    prepareForUpload() {
        if (this.isRepositoryAvailable(this.siteEmojiResource)) this.siteEmojiResource.prepareForUpload();
        return this.retryIfLoading(()=>this.prepareForUpload(), undefined);
    }
}

});
parcelRegister("G2hpM", function(module, exports) {
$parcel$export(module.exports, "default", () => $94b47349612cc74c$export$2e2bcd8739ae039);
function $94b47349612cc74c$export$2e2bcd8739ae039(type) {
    if (typeof window === 'undefined') return false;
    var storage;
    try {
        storage = window[type];
        var x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return e instanceof DOMException && // everything except Firefox
        (e.code === 22 || // Firefox
        e.code === 1014 || // test name field too, because code might not be present
        // everything except Firefox
        e.name === 'QuotaExceededError' || // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
        storage && storage.length !== 0;
    }
}

});

parcelRegister("kMGBZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $17c248999a68f2aa$export$2e2bcd8739ae039);

var $cBxa0 = parcelRequire("cBxa0");
class $17c248999a68f2aa$export$2e2bcd8739ae039 {
    constructor(config){
        this.config = config;
    }
    /**
	 * Returns a promise with an array of Emoji from all providers.
	 */ loadEmoji() {
        const emojisPromise = (0, $cBxa0.emojiRequest)(this.config);
        return emojisPromise.then((emojiServiceResponse)=>(0, $cBxa0.denormaliseEmojiServiceResponse)(emojiServiceResponse));
    }
}

});

parcelRegister("5QefI", function(module, exports) {
$parcel$export(module.exports, "getEmojiVariation", () => $9b87de636599ba93$export$e55e46e1520c899d);
$parcel$export(module.exports, "default", () => $9b87de636599ba93$export$2e2bcd8739ae039);

var $1qij2 = parcelRequire("1qij2");

var $8iUeU = parcelRequire("8iUeU");

var $fqzOa = parcelRequire("fqzOa");

var $adGgK = parcelRequire("adGgK");

var $6xd1B = parcelRequire("6xd1B");

var $g6gOB = parcelRequire("g6gOB");

var $kLr62 = parcelRequire("kLr62");

var $eGOwo = parcelRequire("eGOwo");
// FS-1097 - duplicated in mentions - extract at some point into a shared library
class $9b87de636599ba93$var$Tokenizer {
    tokenize(text) {
        return this.tokenizeAsTokens(text).map((token)=>token.token);
    }
    tokenizeAsTokens(text) {
        let match;
        let tokens = [];
        (0, $6xd1B.tokenizerRegex).lastIndex = 0;
        while((match = (0, $6xd1B.tokenizerRegex).exec(text)) !== null)if (match[0]) tokens.push({
            token: match[0],
            start: match.index
        });
        return tokens;
    }
}
const $9b87de636599ba93$var$addAllVariants = (emoji, fnKey, map)=>{
    const key = fnKey(emoji);
    if (!map.has(key)) map.set(key, []);
    const emojisForKey = map.get(key);
    // Unnecessary, but typescript thinks it is. :/
    if (emojisForKey) emojisForKey.push(emoji);
    if ((0, $fqzOa.isEmojiDescriptionWithVariations)(emoji)) {
        // map variations too
        const variations = emoji.skinVariations;
        if (variations) variations.forEach((variation)=>$9b87de636599ba93$var$addAllVariants(variation, fnKey, map));
    }
};
const $9b87de636599ba93$var$findByKey = (map, key)=>{
    const emojis = map.get(key);
    if (emojis && emojis.length) // Priority is always to source from the last emoji set (last overrides first)
    return emojis[emojis.length - 1];
    return undefined;
};
const $9b87de636599ba93$var$splitQuery = (query = '')=>{
    const isColonQuery = query.indexOf(':') === 0;
    if (isColonQuery) return {
        nameQuery: query.slice(1),
        asciiQuery: query
    };
    return {
        nameQuery: query,
        asciiQuery: ''
    };
};
const $9b87de636599ba93$export$e55e46e1520c899d = (emoji, options)=>{
    if ((0, $fqzOa.isEmojiDescriptionWithVariations)(emoji) && options) {
        const skinTone = options.skinTone;
        if (skinTone && emoji.skinVariations && emoji.skinVariations.length) {
            const skinToneEmoji = emoji.skinVariations[skinTone - 1]; // skinTone start at 1
            if (skinToneEmoji) return skinToneEmoji;
        }
    }
    return emoji;
};
const $9b87de636599ba93$var$findEmojiIndex = (emojis, toFind)=>{
    const findId = toFind.id;
    let match = -1;
    emojis.forEach((emoji, index)=>{
        // Match if ID is defined and are equal
        // Or both have no id and shortnames match
        if (emoji.id && emoji.id === findId || !emoji.id && !findId && emoji.shortName === toFind.shortName) {
            match = index;
            return;
        }
    });
    return match;
};
class $9b87de636599ba93$export$2e2bcd8739ae039 {
    static{
        this.defaultEmojiWeight = 1000000;
    }
    constructor(emojis, usageTracker){
        this.fullSearchReady = false;
        this.emojis = emojis;
        this.initMembers(usageTracker);
    }
    /**
	 * Returns all available (and searchable) emoji in some default order.
	 */ all() {
        const options = {
            sort: (0, $adGgK.SearchSort).None
        };
        return this.search('', options);
    }
    /**
	 * Text search of emoji shortName and name field for suitable matches.
	 *
	 * Returns an array of all (searchable) emoji if query is empty or null, otherwise returns matching emoji.
	 *
	 * You can change how the results are sorted by specifying a custom EmojiComparator in the SearchOptions. If
	 * you don't want any sorting you can also disable via the SearchOptions (this might be a useful optimisation).
	 * If no sort is specified in SearchOptions then a default sorting it applied based on the query.
	 */ search(query, options) {
        let filteredEmoji = [];
        const { nameQuery: nameQuery, asciiQuery: asciiQuery } = $9b87de636599ba93$var$splitQuery(query);
        if (nameQuery) {
            filteredEmoji = this.getSearchIndex().search(nameQuery);
            if (asciiQuery) filteredEmoji = this.withAsciiMatch(asciiQuery, filteredEmoji);
        } else filteredEmoji = this.getAllSearchableEmojis();
        filteredEmoji = this.applySearchOptions(filteredEmoji, query, options);
        return {
            emojis: filteredEmoji,
            query: query
        };
    }
    /**
	 * Returns all emoji with matching shortName
	 */ findAllMatchingShortName(shortName) {
        return this.shortNameMap.get(shortName) || [];
    }
    /**
	 * Returns the first matching emoji matching the shortName, or null if none found.
	 */ findByShortName(shortName) {
        return $9b87de636599ba93$var$findByKey(this.shortNameMap, shortName);
    }
    /**
	 * Returns the first matching emoji matching the id, or null if none found.
	 */ findById(id) {
        return $9b87de636599ba93$var$findByKey(this.idMap, id);
    }
    findByAsciiRepresentation(asciiEmoji) {
        return this.asciiMap.get(asciiEmoji);
    }
    findInCategory(categoryId) {
        if (categoryId === (0, $8iUeU.frequentCategory)) return this.getFrequentlyUsed();
        else return this.all().emojis.filter((emoji)=>emoji.category === categoryId);
    }
    addUnknownEmoji(emoji) {
        this.emojis = [
            ...this.emojis,
            emoji
        ];
        this.getSearchIndex().addDocuments([
            emoji
        ]);
        this.addToMaps(emoji);
        this.addToDynamicCategories(emoji);
    }
    getAsciiMap() {
        return this.asciiMap;
    }
    /**
	 * Return the most frequently used emoji, ordered from most frequent to least frequent. Return an empty array if
	 * there are none.
	 *
	 * @param options optional settings to be applied to the set of frequently used emoji
	 */ getFrequentlyUsed(options) {
        const emojiIds = this.usageTracker.getOrder();
        let emojiResult = emojiIds.map((id)=>this.findById(id)).filter((e)=>e !== undefined);
        if (options) emojiResult = this.applySearchOptions(emojiResult, '', options);
        return emojiResult;
    }
    getDynamicCategoryList() {
        return this.dynamicCategoryList.slice();
    }
    /**
	 * Call this on emoji usage to allow the EmojiRepository to track the usage of emoji (which could be useful
	 * in sorting, etc).
	 *
	 * @param emoji the emoji that was just used
	 */ used(emoji) {
        this.usageTracker.recordUsage(emoji);
        // If this is the first usage ensure that we update the dynamic categories.
        // This is done in a 'timeout' since the usageTracker call previously also happens in a timeout. This ensures that
        // the frequent category will not appear until the usage has been tracked (avoiding the possibility of an empty
        // frequent category being shown in the picker).
        if (this.dynamicCategoryList.indexOf((0, $8iUeU.frequentCategory)) === -1) {
            if (typeof window === 'undefined') return;
            window.setTimeout(()=>{
                this.dynamicCategoryList.push((0, $8iUeU.frequentCategory));
            });
        }
    }
    delete(emoji) {
        const deletedIndex = $9b87de636599ba93$var$findEmojiIndex(this.emojis, emoji);
        if (deletedIndex !== -1) {
            // Remove the deleted emojis from the internal list
            this.emojis.splice(deletedIndex, 1);
            // Reconstruct repository member variables
            this.initMembers(this.usageTracker);
        }
    }
    withAsciiMatch(ascii, emojis) {
        let result = emojis;
        const asciiEmoji = this.findByAsciiRepresentation(ascii);
        if (asciiEmoji) {
            // Ensures that the same emoji isn't already in the list
            // If it is, we give precedence to the ascii match
            result = emojis.filter((e)=>e.id !== asciiEmoji.id);
            result = [
                asciiEmoji,
                ...result
            ];
        }
        return result;
    }
    applySearchOptions(emojis, query, options) {
        if (!options) options = {};
        if (options.sort === undefined) options.sort = (0, $adGgK.SearchSort).Default;
        let comparator;
        if (options.sort === (0, $adGgK.SearchSort).Default) comparator = (0, $g6gOB.createSearchEmojiComparator)(query, this.usageTracker.getOrder());
        else if (options.sort === (0, $adGgK.SearchSort).UsageFrequency) comparator = (0, $g6gOB.createUsageOnlyEmojiComparator)(this.usageTracker.getOrder());
        if (comparator) {
            comparator.compare = comparator.compare.bind(comparator); // TODO bind at a better place
            emojis = emojis.sort(comparator.compare);
        }
        if (options.limit && options.limit > 0) emojis = emojis.slice(0, options.limit);
        if (options.skinTone) return emojis.map((emoji)=>{
            return $9b87de636599ba93$export$e55e46e1520c899d(emoji, options);
        });
        return emojis;
    }
    initMembers(usageTracker) {
        this.usageTracker = usageTracker || new (0, $kLr62.UsageFrequencyTracker)();
        this.initRepositoryMetadata();
        if (!(0, $eGOwo.fg)('platform_index_emoji_just_in_time')) this.initSearchIndex();
    }
    /**
	 * Optimisation to initialise all map member variables in single loop over emojis
	 */ initRepositoryMetadata() {
        this.shortNameMap = new Map();
        this.idMap = new Map();
        this.asciiMap = new Map();
        const categorySet = new Set();
        this.emojis.forEach((emoji)=>{
            categorySet.add(emoji.category);
            this.addToMaps(emoji);
        });
        if (this.usageTracker.getOrder().length) categorySet.add((0, $8iUeU.frequentCategory));
        this.dynamicCategoryList = Array.from(categorySet).filter((category)=>(0, $8iUeU.defaultCategories).indexOf(category) === -1);
    }
    initSearchIndex() {
        this.fullSearch = new (0, $1qij2.Search)('id');
        this.fullSearch.tokenizer = new $9b87de636599ba93$var$Tokenizer();
        this.fullSearch.searchIndex = new (0, $1qij2.UnorderedSearchIndex)();
        this.fullSearch.addIndex('name');
        this.fullSearch.addIndex('shortName');
        this.fullSearch.addDocuments(this.getAllSearchableEmojis());
        this.fullSearchReady = true;
    }
    getSearchIndex() {
        if (!this.fullSearchReady) this.initSearchIndex();
        return this.fullSearch;
    }
    getAllSearchableEmojis() {
        return this.emojis.filter((emojiDescription)=>emojiDescription.searchable);
    }
    addToMaps(emoji) {
        // Give default value and assign higher weight to Atlassian emojis for logical order when sorting
        if (typeof emoji.order === 'undefined' || emoji.order === -1) emoji.order = $9b87de636599ba93$export$2e2bcd8739ae039.defaultEmojiWeight;
        if (typeof emoji.id === 'undefined') emoji.id = $9b87de636599ba93$export$2e2bcd8739ae039.defaultEmojiWeight.toString();
        $9b87de636599ba93$var$addAllVariants(emoji, (e)=>e.shortName, this.shortNameMap);
        $9b87de636599ba93$var$addAllVariants(emoji, (e)=>e.id, this.idMap);
        if (emoji.ascii) emoji.ascii.forEach((a)=>this.asciiMap.set(a, emoji));
    }
    addToDynamicCategories(emoji) {
        const category = (0, $fqzOa.getCategoryId)(emoji);
        if ((0, $8iUeU.defaultCategories).indexOf(category) === -1 && this.dynamicCategoryList.indexOf(category) === -1) this.dynamicCategoryList.push(category);
    }
}

});
parcelRegister("1qij2", function(module, exports) {
$parcel$export(module.exports, "UnorderedSearchIndex", () => $10966b55d7fb8e7d$export$5e70dbef3f0d47db);
$parcel$export(module.exports, "Search", () => $10966b55d7fb8e7d$export$4b85d3515bd863a5);
/**
 * Indexes for all substring searches (e.g. the term "cat" is indexed as "c", "ca", "cat", "a", "at", and "t").
 */ var $10966b55d7fb8e7d$export$58ac23006833dfe0 = /*#__PURE__*/ function() {
    function AllSubstringsIndexStrategy() {}
    var _proto = AllSubstringsIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        var expandedTokens = [];
        var string;
        for(var i = 0, length = token.length; i < length; ++i){
            string = '';
            for(var j = i; j < length; ++j){
                string += token.charAt(j);
                expandedTokens.push(string);
            }
        }
        return expandedTokens;
    };
    return AllSubstringsIndexStrategy;
}();
/**
 * Indexes for exact word matches.
 */ var $10966b55d7fb8e7d$export$1dcc2d6a64836c8f = /*#__PURE__*/ function() {
    function ExactWordIndexStrategy() {}
    var _proto = ExactWordIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        return token ? [
            token
        ] : [];
    };
    return ExactWordIndexStrategy;
}();
/**
 * Indexes for prefix searches (e.g. the term "cat" is indexed as "c", "ca", and "cat" allowing prefix search lookups).
 */ var $10966b55d7fb8e7d$export$eb7fc80cfe9abfe6 = /*#__PURE__*/ function() {
    function PrefixIndexStrategy() {}
    var _proto = PrefixIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        var expandedTokens = [];
        var string = '';
        for(var i = 0, length = token.length; i < length; ++i){
            string += token.charAt(i);
            expandedTokens.push(string);
        }
        return expandedTokens;
    };
    return PrefixIndexStrategy;
}();
/**
 * Enforces case-sensitive text matches.
 */ var $10966b55d7fb8e7d$export$b88ffe9b5486f99a = /*#__PURE__*/ function() {
    function CaseSensitiveSanitizer() {}
    var _proto = CaseSensitiveSanitizer.prototype;
    /**
   * @inheritDocs
   */ _proto.sanitize = function sanitize(text) {
        return text ? text.trim() : '';
    };
    return CaseSensitiveSanitizer;
}();
/**
 * Sanitizes text by converting to a locale-friendly lower-case version and triming leading and trailing whitespace.
 */ var $10966b55d7fb8e7d$export$147e8ac43c84713a = /*#__PURE__*/ function() {
    function LowerCaseSanitizer() {}
    var _proto = LowerCaseSanitizer.prototype;
    /**
   * @inheritDocs
   */ _proto.sanitize = function sanitize(text) {
        return text ? text.toLocaleLowerCase().trim() : '';
    };
    return LowerCaseSanitizer;
}();
/**
 * Find and return a nested object value.
 *
 * @param object to crawl
 * @param path Property path
 * @returns {any}
 */ function $10966b55d7fb8e7d$var$getNestedFieldValue(object, path) {
    path = path || [];
    object = object || {};
    var value = object; // walk down the property path
    for(var i = 0; i < path.length; i++){
        value = value[path[i]];
        if (value == null) return null;
    }
    return value;
}
/**
 * Search index capable of returning results matching a set of tokens and ranked according to TF-IDF.
 */ var $10966b55d7fb8e7d$export$a1138c79781169cc = /*#__PURE__*/ function() {
    function TfIdfSearchIndex(uidFieldName) {
        this._uidFieldName = uidFieldName;
        this._tokenToIdfCache = {};
        this._tokenMap = {};
    }
    /**
   * @inheritDocs
   */ var _proto = TfIdfSearchIndex.prototype;
    _proto.indexDocument = function indexDocument(token, uid, doc) {
        this._tokenToIdfCache = {}; // New index invalidates previous IDF caches
        var tokenMap = this._tokenMap;
        var tokenDatum;
        if (typeof tokenMap[token] !== 'object') tokenMap[token] = tokenDatum = {
            $numDocumentOccurrences: 0,
            $totalNumOccurrences: 1,
            $uidMap: {}
        };
        else {
            tokenDatum = tokenMap[token];
            tokenDatum.$totalNumOccurrences++;
        }
        var uidMap = tokenDatum.$uidMap;
        if (typeof uidMap[uid] !== 'object') {
            tokenDatum.$numDocumentOccurrences++;
            uidMap[uid] = {
                $document: doc,
                $numTokenOccurrences: 1
            };
        } else uidMap[uid].$numTokenOccurrences++;
    } /**
   * @inheritDocs
   */ ;
    _proto.search = function search(tokens, corpus) {
        var uidToDocumentMap = {};
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = tokens[i];
            var tokenMetadata = this._tokenMap[token]; // Short circuit if no matches were found for any given token.
            if (!tokenMetadata) return [];
            if (i === 0) {
                var keys = Object.keys(tokenMetadata.$uidMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    uidToDocumentMap[uid] = tokenMetadata.$uidMap[uid].$document;
                }
            } else {
                var keys = Object.keys(uidToDocumentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    if (typeof tokenMetadata.$uidMap[uid] !== 'object') delete uidToDocumentMap[uid];
                }
            }
        }
        var documents = [];
        for(var uid in uidToDocumentMap)documents.push(uidToDocumentMap[uid]);
        var calculateTfIdf = this._createCalculateTfIdf(); // Return documents sorted by TF-IDF
        return documents.sort(function(documentA, documentB) {
            return calculateTfIdf(tokens, documentB, corpus) - calculateTfIdf(tokens, documentA, corpus);
        });
    };
    _proto._createCalculateIdf = function _createCalculateIdf() {
        var tokenMap = this._tokenMap;
        var tokenToIdfCache = this._tokenToIdfCache;
        return function calculateIdf(token, documents) {
            if (!tokenToIdfCache[token]) {
                var numDocumentsWithToken = typeof tokenMap[token] !== 'undefined' ? tokenMap[token].$numDocumentOccurrences : 0;
                tokenToIdfCache[token] = 1 + Math.log(documents.length / (1 + numDocumentsWithToken));
            }
            return tokenToIdfCache[token];
        };
    };
    _proto._createCalculateTfIdf = function _createCalculateTfIdf() {
        var tokenMap = this._tokenMap;
        var uidFieldName = this._uidFieldName;
        var calculateIdf = this._createCalculateIdf();
        return function calculateTfIdf(tokens, document, documents) {
            var score = 0;
            for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
                var token = tokens[i];
                var inverseDocumentFrequency = calculateIdf(token, documents);
                if (inverseDocumentFrequency === Infinity) inverseDocumentFrequency = 0;
                var uid;
                if (uidFieldName instanceof Array) uid = document && $10966b55d7fb8e7d$var$getNestedFieldValue(document, uidFieldName);
                else uid = document && document[uidFieldName];
                var termFrequency = typeof tokenMap[token] !== 'undefined' && typeof tokenMap[token].$uidMap[uid] !== 'undefined' ? tokenMap[token].$uidMap[uid].$numTokenOccurrences : 0;
                score += termFrequency * inverseDocumentFrequency;
            }
            return score;
        };
    };
    return TfIdfSearchIndex;
}();
/**
 * Search index capable of returning results matching a set of tokens but without any meaningful rank or order.
 */ var $10966b55d7fb8e7d$export$5e70dbef3f0d47db = /*#__PURE__*/ function() {
    function UnorderedSearchIndex() {
        this._tokenToUidToDocumentMap = {};
    }
    /**
   * @inheritDocs
   */ var _proto = UnorderedSearchIndex.prototype;
    _proto.indexDocument = function indexDocument(token, uid, doc) {
        if (typeof this._tokenToUidToDocumentMap[token] !== 'object') this._tokenToUidToDocumentMap[token] = {};
        this._tokenToUidToDocumentMap[token][uid] = doc;
    } /**
   * @inheritDocs
   */ ;
    _proto.search = function search(tokens, corpus) {
        var intersectingDocumentMap = {};
        var tokenToUidToDocumentMap = this._tokenToUidToDocumentMap;
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = tokens[i];
            var documentMap = tokenToUidToDocumentMap[token]; // Short circuit if no matches were found for any given token.
            if (!documentMap) return [];
            if (i === 0) {
                var keys = Object.keys(documentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    intersectingDocumentMap[uid] = documentMap[uid];
                }
            } else {
                var keys = Object.keys(intersectingDocumentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    if (typeof documentMap[uid] !== 'object') delete intersectingDocumentMap[uid];
                }
            }
        }
        var keys = Object.keys(intersectingDocumentMap);
        var documents = [];
        for(var i = 0, numKeys = keys.length; i < numKeys; i++){
            var uid = keys[i];
            documents.push(intersectingDocumentMap[uid]);
        }
        return documents;
    };
    return UnorderedSearchIndex;
}();
var $10966b55d7fb8e7d$var$REGEX = /[^a-zа-яё0-9\-']+/i;
/**
 * Simple tokenizer that splits strings on whitespace characters and returns an array of all non-empty substrings.
 */ var $10966b55d7fb8e7d$export$f5ac5ec3cb556ad6 = /*#__PURE__*/ function() {
    function SimpleTokenizer() {}
    var _proto = SimpleTokenizer.prototype;
    /**
   * @inheritDocs
   */ _proto.tokenize = function tokenize(text) {
        return text.split($10966b55d7fb8e7d$var$REGEX).filter(function(text) {
            return text;
        } // Filter empty tokens
        );
    };
    return SimpleTokenizer;
}();
/**
 * Stemming is the process of reducing search tokens to their root (or stem) so that searches for different forms of a
 * word will match. For example "search", "searching" and "searched" are all reduced to the stem "search".
 *
 * <p>This stemming tokenizer converts tokens (words) to their stem forms before returning them. It requires an
 * external stemming function to be provided; for this purpose I recommend the NPM 'porter-stemmer' library.
 *
 * <p>For more information see http : //tartarus.org/~martin/PorterStemmer/
 */ var $10966b55d7fb8e7d$export$d2c689c98d4dcb27 = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param stemmingFunction Function capable of accepting a word and returning its stem.
   * @param decoratedIndexStrategy Index strategy to be run after all stop words have been removed.
   */ function StemmingTokenizer(stemmingFunction, decoratedTokenizer) {
        this._stemmingFunction = stemmingFunction;
        this._tokenizer = decoratedTokenizer;
    }
    /**
   * @inheritDocs
   */ var _proto = StemmingTokenizer.prototype;
    _proto.tokenize = function tokenize(text) {
        return this._tokenizer.tokenize(text).map(this._stemmingFunction);
    };
    return StemmingTokenizer;
}();
/**
 * Stop words list copied from Lunr JS.
 */ var $10966b55d7fb8e7d$export$eeaf491a400e882a = {
    a: true,
    able: true,
    about: true,
    across: true,
    after: true,
    all: true,
    almost: true,
    also: true,
    am: true,
    among: true,
    an: true,
    and: true,
    any: true,
    are: true,
    as: true,
    at: true,
    be: true,
    because: true,
    been: true,
    but: true,
    by: true,
    can: true,
    cannot: true,
    could: true,
    dear: true,
    did: true,
    'do': true,
    does: true,
    either: true,
    'else': true,
    ever: true,
    every: true,
    'for': true,
    from: true,
    'get': true,
    got: true,
    had: true,
    has: true,
    have: true,
    he: true,
    her: true,
    hers: true,
    him: true,
    his: true,
    how: true,
    however: true,
    i: true,
    'if': true,
    'in': true,
    into: true,
    is: true,
    it: true,
    its: true,
    just: true,
    least: true,
    "let": true,
    like: true,
    likely: true,
    may: true,
    me: true,
    might: true,
    most: true,
    must: true,
    my: true,
    neither: true,
    no: true,
    nor: true,
    not: true,
    of: true,
    off: true,
    often: true,
    on: true,
    only: true,
    or: true,
    other: true,
    our: true,
    own: true,
    rather: true,
    said: true,
    say: true,
    says: true,
    she: true,
    should: true,
    since: true,
    so: true,
    some: true,
    than: true,
    that: true,
    the: true,
    their: true,
    them: true,
    then: true,
    there: true,
    these: true,
    they: true,
    'this': true,
    tis: true,
    to: true,
    too: true,
    twas: true,
    us: true,
    wants: true,
    was: true,
    we: true,
    were: true,
    what: true,
    when: true,
    where: true,
    which: true,
    'while': true,
    who: true,
    whom: true,
    why: true,
    will: true,
    'with': true,
    would: true,
    yet: true,
    you: true,
    your: true
}; // Prevent false positives for inherited properties
$10966b55d7fb8e7d$export$eeaf491a400e882a.constructor = false;
$10966b55d7fb8e7d$export$eeaf491a400e882a.hasOwnProperty = false;
$10966b55d7fb8e7d$export$eeaf491a400e882a.isPrototypeOf = false;
$10966b55d7fb8e7d$export$eeaf491a400e882a.propertyIsEnumerable = false;
$10966b55d7fb8e7d$export$eeaf491a400e882a.toLocaleString = false;
$10966b55d7fb8e7d$export$eeaf491a400e882a.toString = false;
$10966b55d7fb8e7d$export$eeaf491a400e882a.valueOf = false;
/**
 * Stop words are very common (e.g. "a", "and", "the") and are often not semantically meaningful in the context of a
 * search. This tokenizer removes stop words from a set of tokens before passing the remaining tokens along for
 * indexing or searching purposes.
 */ var $10966b55d7fb8e7d$export$59d4dfff8ed0ca89 = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param decoratedIndexStrategy Index strategy to be run after all stop words have been removed.
   */ function StopWordsTokenizer(decoratedTokenizer) {
        this._tokenizer = decoratedTokenizer;
    }
    /**
   * @inheritDocs
   */ var _proto = StopWordsTokenizer.prototype;
    _proto.tokenize = function tokenize(text) {
        return this._tokenizer.tokenize(text).filter(function(token) {
            return !$10966b55d7fb8e7d$export$eeaf491a400e882a[token];
        });
    };
    return StopWordsTokenizer;
}();
function $10966b55d7fb8e7d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $10966b55d7fb8e7d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $10966b55d7fb8e7d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $10966b55d7fb8e7d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/**
 * Simple client-side searching within a set of documents.
 *
 * <p>Documents can be searched by any number of fields. Indexing and search strategies are highly customizable.
 */ var $10966b55d7fb8e7d$export$4b85d3515bd863a5 = /*#__PURE__*/ function() {
    /**
   * Array containing either a property name or a path (list of property names) to a nested value
   */ /**
   * Constructor.
   * @param uidFieldName Field containing values that uniquely identify search documents; this field's values are used
   *                     to ensure that a search result set does not contain duplicate objects.
   */ function Search(uidFieldName) {
        if (!uidFieldName) throw Error('js-search requires a uid field name constructor parameter');
        this._uidFieldName = uidFieldName; // Set default/recommended strategies
        this._indexStrategy = new $10966b55d7fb8e7d$export$eb7fc80cfe9abfe6();
        this._searchIndex = new $10966b55d7fb8e7d$export$a1138c79781169cc(uidFieldName);
        this._sanitizer = new $10966b55d7fb8e7d$export$147e8ac43c84713a();
        this._tokenizer = new $10966b55d7fb8e7d$export$f5ac5ec3cb556ad6();
        this._documents = [];
        this._searchableFields = [];
    }
    /**
   * Override the default index strategy.
   * @param value Custom index strategy
   * @throws Error if documents have already been indexed by this search instance
   */ var _proto = Search.prototype;
    /**
   * Add a searchable document to the index. Document will automatically be indexed for search.
   * @param document
   */ _proto.addDocument = function addDocument(document) {
        this.addDocuments([
            document
        ]);
    } /**
   * Adds searchable documents to the index. Documents will automatically be indexed for search.
   * @param document
   */ ;
    _proto.addDocuments = function addDocuments(documents) {
        this._documents = this._documents.concat(documents);
        this.indexDocuments_(documents, this._searchableFields);
    } /**
   * Add a new searchable field to the index. Existing documents will automatically be indexed using this new field.
   *
   * @param field Searchable field or field path. Pass a string to index a top-level field and an array of strings for nested fields.
   */ ;
    _proto.addIndex = function addIndex(field) {
        this._searchableFields.push(field);
        this.indexDocuments_(this._documents, [
            field
        ]);
    } /**
   * Search all documents for ones matching the specified query text.
   * @param query
   * @returns {Array<Object>}
   */ ;
    _proto.search = function search(query) {
        var tokens = this._tokenizer.tokenize(this._sanitizer.sanitize(query));
        return this._searchIndex.search(tokens, this._documents);
    } /**
   * @param documents
   * @param _searchableFields Array containing property names and paths (lists of property names) to nested values
   * @private
   */ ;
    _proto.indexDocuments_ = function indexDocuments_(documents, _searchableFields) {
        this._initialized = true;
        var indexStrategy = this._indexStrategy;
        var sanitizer = this._sanitizer;
        var searchIndex = this._searchIndex;
        var tokenizer = this._tokenizer;
        var uidFieldName = this._uidFieldName;
        for(var di = 0, numDocuments = documents.length; di < numDocuments; di++){
            var doc = documents[di];
            var uid;
            if (uidFieldName instanceof Array) uid = $10966b55d7fb8e7d$var$getNestedFieldValue(doc, uidFieldName);
            else uid = doc[uidFieldName];
            for(var sfi = 0, numSearchableFields = _searchableFields.length; sfi < numSearchableFields; sfi++){
                var fieldValue;
                var searchableField = _searchableFields[sfi];
                if (searchableField instanceof Array) fieldValue = $10966b55d7fb8e7d$var$getNestedFieldValue(doc, searchableField);
                else fieldValue = doc[searchableField];
                if (fieldValue != null && typeof fieldValue !== 'string' && fieldValue.toString) fieldValue = fieldValue.toString();
                if (typeof fieldValue === 'string') {
                    var fieldTokens = tokenizer.tokenize(sanitizer.sanitize(fieldValue));
                    for(var fti = 0, numFieldValues = fieldTokens.length; fti < numFieldValues; fti++){
                        var fieldToken = fieldTokens[fti];
                        var expandedTokens = indexStrategy.expandToken(fieldToken);
                        for(var eti = 0, nummExpandedTokens = expandedTokens.length; eti < nummExpandedTokens; eti++){
                            var expandedToken = expandedTokens[eti];
                            searchIndex.indexDocument(expandedToken, uid, doc);
                        }
                    }
                }
            }
        }
    };
    $10966b55d7fb8e7d$var$_createClass(Search, [
        {
            key: "indexStrategy",
            set: function set(value) {
                if (this._initialized) throw Error('IIndexStrategy cannot be set after initialization');
                this._indexStrategy = value;
            },
            get: function get() {
                return this._indexStrategy;
            }
        },
        {
            key: "sanitizer",
            set: function set(value) {
                if (this._initialized) throw Error('ISanitizer cannot be set after initialization');
                this._sanitizer = value;
            },
            get: function get() {
                return this._sanitizer;
            }
        },
        {
            key: "searchIndex",
            set: function set(value) {
                if (this._initialized) throw Error('ISearchIndex cannot be set after initialization');
                this._searchIndex = value;
            },
            get: function get() {
                return this._searchIndex;
            }
        },
        {
            key: "tokenizer",
            set: function set(value) {
                if (this._initialized) throw Error('ITokenizer cannot be set after initialization');
                this._tokenizer = value;
            },
            get: function get() {
                return this._tokenizer;
            }
        }
    ]);
    return Search;
}();
/**
 * This utility highlights the occurrences of tokens within a string of text. It can be used to give visual indicators
 * of match criteria within searchable fields.
 *
 * <p>For performance purposes this highlighter only works with full-word or prefix token indexes.
 */ var $10966b55d7fb8e7d$export$11e693a7f8ce1bcc = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param opt_indexStrategy Index strategy used by Search
   * @param opt_sanitizer Sanitizer used by Search
   * @param opt_wrapperTagName Optional wrapper tag name; defaults to 'mark' (e.g. <mark>)
   */ function TokenHighlighter(opt_indexStrategy, opt_sanitizer, opt_wrapperTagName) {
        this._indexStrategy = opt_indexStrategy || new $10966b55d7fb8e7d$export$eb7fc80cfe9abfe6();
        this._sanitizer = opt_sanitizer || new $10966b55d7fb8e7d$export$147e8ac43c84713a();
        this._wrapperTagName = opt_wrapperTagName || 'mark';
    }
    /**
   * Highlights token occurrences within a string by wrapping them with a DOM element.
   *
   * @param text e.g. "john wayne"
   * @param tokens e.g. ["wa"]
   * @returns {string} e.g. "john <mark>wa</mark>yne"
   */ var _proto = TokenHighlighter.prototype;
    _proto.highlight = function highlight(text, tokens) {
        var tagsLength = this._wrapText('').length;
        var tokenDictionary = Object.create(null); // Create a token map for easier lookup below.
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = this._sanitizer.sanitize(tokens[i]);
            var expandedTokens = this._indexStrategy.expandToken(token);
            for(var j = 0, numExpandedTokens = expandedTokens.length; j < numExpandedTokens; j++){
                var expandedToken = expandedTokens[j];
                if (!tokenDictionary[expandedToken]) tokenDictionary[expandedToken] = [
                    token
                ];
                else tokenDictionary[expandedToken].push(token);
            }
        } // Track actualCurrentWord and sanitizedCurrentWord separately in case we encounter nested tags.
        var actualCurrentWord = '';
        var sanitizedCurrentWord = '';
        var currentWordStartIndex = 0; // Note this assumes either prefix or full word matching.
        for(var i = 0, textLength = text.length; i < textLength; i++){
            var character = text.charAt(i);
            if (character === ' ') {
                actualCurrentWord = '';
                sanitizedCurrentWord = '';
                currentWordStartIndex = i + 1;
            } else {
                actualCurrentWord += character;
                sanitizedCurrentWord += this._sanitizer.sanitize(character);
            }
            if (tokenDictionary[sanitizedCurrentWord] && tokenDictionary[sanitizedCurrentWord].indexOf(sanitizedCurrentWord) >= 0) {
                actualCurrentWord = this._wrapText(actualCurrentWord);
                text = text.substring(0, currentWordStartIndex) + actualCurrentWord + text.substring(i + 1);
                i += tagsLength;
                textLength += tagsLength;
            }
        }
        return text;
    } /**
   * @param text to wrap
   * @returns Text wrapped by wrapper tag (e.g. "foo" becomes "<mark>foo</mark>")
   * @private
   */ ;
    _proto._wrapText = function _wrapText(text) {
        var tagName = this._wrapperTagName;
        return "<" + tagName + ">" + text + "</" + tagName + ">";
    };
    return TokenHighlighter;
}();

});

parcelRegister("6xd1B", function(module, exports) {
$parcel$export(module.exports, "tokenizerRegex", () => $f70cf16a202d1ef4$export$6558e5d0f0e834f8);
// \p{Han} => each chinese character is a separate token
// \p{L}+[\p{Mn}|']*\p{L} => consecutive letters, including non spacing mark and apostrophe are a single token
// const tokenizerRegex = new XRegExp("\\p{Han}|[\\p{L}|\\p{N}]+[\\p{Mn}|']*\\p{L}*", 'gi');
// Note: Regex compiled to unicode charsets using xregexp-transformer, refer to it if you need to compile it again.
//       @atlaskit/xregexp-transformer (https://bitbucket.org/atlassian/xregexp-transformer)
// eslint-disable-next-line no-misleading-character-class
const $f70cf16a202d1ef4$export$6558e5d0f0e834f8 = new RegExp("[\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u3005\u3007\u3021-\u3029\u3038-\u303B\u3400-\u4DB5\u4E00-\u9FEF\uF900-\uFA6D\uFA70-\uFAD9]|[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC|0-9\u00B2\u00B3\u00B9\u00BC-\u00BE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D58-\u0D5E\u0D66-\u0D78\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]+[\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F|']*[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]*", 'gi');

});

parcelRegister("g6gOB", function(module, exports) {
$parcel$export(module.exports, "createSearchEmojiComparator", () => $a54cd167449f5744$export$e6097b005751df7);
$parcel$export(module.exports, "createUsageOnlyEmojiComparator", () => $a54cd167449f5744$export$1bd055808eeccb4e);

var $8iUeU = parcelRequire("8iUeU");

var $fqzOa = parcelRequire("fqzOa");
function $a54cd167449f5744$export$e6097b005751df7(query, orderedIds) {
    const textQuery = query ? query.replace(/:/g, '').toLowerCase().trim() : undefined;
    const comparators = [];
    if (query) comparators.push(new $a54cd167449f5744$export$ff92575cd1bbad0e(query));
    // Add the comparators to the 'chain'. The order of adding each comparator is important to the sort that is applied by the
    // ChainedEmojiComparator. (Which is why you may see the same 'if' a few times.)
    if (textQuery) comparators.push(new $a54cd167449f5744$export$3026b08b79541139(textQuery));
    if (orderedIds && orderedIds.length) comparators.push(new $a54cd167449f5744$export$55e24837a4bf653(orderedIds));
    if (textQuery) comparators.push(new $a54cd167449f5744$export$587c775915dc4869(textQuery, 'shortName'), new $a54cd167449f5744$export$587c775915dc4869(textQuery, 'name'));
    comparators.push($a54cd167449f5744$export$165e96ceead77edd.Instance, $a54cd167449f5744$export$30ce221e1adf48c1.Instance);
    const comparator = new $a54cd167449f5744$export$a8052d0852821684(...comparators);
    comparator.compare = comparator.compare.bind(comparator);
    return comparator;
}
function $a54cd167449f5744$export$1bd055808eeccb4e(orderedIds) {
    const comparator = new $a54cd167449f5744$export$a8052d0852821684(new $a54cd167449f5744$export$55e24837a4bf653(orderedIds), new $a54cd167449f5744$export$a7f7a0b04013a8a8(), $a54cd167449f5744$export$165e96ceead77edd.Instance);
    comparator.compare = comparator.compare.bind(comparator);
    return comparator;
}
class $a54cd167449f5744$export$a8052d0852821684 {
    constructor(...comparators){
        this.chain = comparators;
    }
    compare(e1, e2) {
        for(let i = 0; i < this.chain.length; i++){
            const result = this.chain[i].compare(e1, e2);
            if (result !== 0) return result;
        }
        return 0;
    }
}
class $a54cd167449f5744$export$ff92575cd1bbad0e {
    constructor(query){
        this.query = query;
    }
    compare(e1, e2) {
        const e1HasAscii = e1.ascii && e1.ascii.indexOf(this.query) !== -1;
        const e2HasAscii = e2.ascii && e2.ascii.indexOf(this.query) !== -1;
        if (e1HasAscii && !e2HasAscii) return -1;
        else if (!e1HasAscii && e2HasAscii) return 1;
        return 0;
    }
}
class $a54cd167449f5744$export$3026b08b79541139 {
    constructor(query){
        this.colonQuery = `:${query}:`;
        this.typeComparator = new $a54cd167449f5744$export$a7f7a0b04013a8a8(true);
    }
    compare(e1, e2) {
        if (e1.shortName === this.colonQuery && e2.shortName === this.colonQuery) return this.typeComparator.compare(e1, e2);
        else if (e1.shortName === this.colonQuery) return -1;
        else if (e2.shortName === this.colonQuery) return 1;
        return 0;
    }
}
class $a54cd167449f5744$export$a7f7a0b04013a8a8 {
    constructor(reverse){
        if (reverse) this.typeToNumber = new Map([
            [
                'SITE',
                0
            ],
            [
                'ATLASSIAN',
                1
            ],
            [
                'STANDARD',
                2
            ]
        ]);
        else this.typeToNumber = new Map([
            [
                'STANDARD',
                0
            ],
            [
                'ATLASSIAN',
                1
            ],
            [
                'SITE',
                2
            ]
        ]);
    }
    compare(e1, e2) {
        return this.emojiTypeToOrdinal(e1) - this.emojiTypeToOrdinal(e2);
    }
    emojiTypeToOrdinal(emoji) {
        let ordinal = this.typeToNumber.get(emoji.type);
        if (ordinal === undefined) ordinal = 10;
        return ordinal;
    }
}
class $a54cd167449f5744$export$55e24837a4bf653 {
    constructor(orderedIds){
        this.positionLookup = new Map();
        // Make ordering start from 1 to avoid having zero in the map (which is falsey)
        orderedIds.map((id, index)=>this.positionLookup.set(id, index + 1));
    }
    compare(e1, e2) {
        if (!e1.id || !e2.id) return 0; // this shouldn't occur. Leave position unchanged if there is any missing id.
        let i1 = this.getPositionInOrder(e1);
        let i2 = this.getPositionInOrder(e2);
        return i1 - i2;
    }
    /**
	 * Get the ordinal representing the position of this emoji.
	 *
	 * @param id the id of the emoji
	 */ getPositionInOrder(emoji) {
        let id = emoji.id ? emoji.id : '0';
        if ((0, $fqzOa.isEmojiVariationDescription)(emoji)) id = emoji.baseId;
        const position = this.positionLookup.get(id);
        if (position) return position;
        else return 0, $8iUeU.MAX_ORDINAL;
    }
}
class $a54cd167449f5744$export$587c775915dc4869 {
    /**
	 * @param query the query to match
	 * @param propertyToCompare the property of EmojiDescription to check for query within
	 */ constructor(query, propertyToCompare){
        this.query = query;
        if (!propertyToCompare) throw new Error('propertyToCompare is required');
        this.propertyName = propertyToCompare;
    }
    getScore(emoji) {
        // It is fine to do override the null check here because we are checking
        // it on the constructor.
        const propertyValue = emoji[this.propertyName];
        const score = propertyValue ? propertyValue.indexOf(this.query) : (0, $8iUeU.MAX_ORDINAL);
        return score === -1 ? (0, $8iUeU.MAX_ORDINAL) : score;
    }
    compare(e1, e2) {
        return this.getScore(e1) - this.getScore(e2);
    }
}
class $a54cd167449f5744$export$165e96ceead77edd {
    constructor(){}
    static get Instance() {
        return this.INSTANCE || (this.INSTANCE = new this());
    }
    compare(e1, e2) {
        let o1 = e1.order ? e1.order : (0, $8iUeU.MAX_ORDINAL);
        let o2 = e2.order ? e2.order : (0, $8iUeU.MAX_ORDINAL);
        return o1 - o2;
    }
}
class $a54cd167449f5744$export$30ce221e1adf48c1 {
    constructor(){}
    static get Instance() {
        return this.INSTANCE || (this.INSTANCE = new this());
    }
    compare(e1, e2) {
        return e1.shortName.localeCompare(e2.shortName);
    }
}

});

parcelRegister("kLr62", function(module, exports) {
$parcel$export(module.exports, "UsageFrequencyTracker", () => $85a3435740842397$export$3f86810331c44209);

var $fqzOa = parcelRequire("fqzOa");

var $8iUeU = parcelRequire("8iUeU");

var $3tG1E = parcelRequire("3tG1E");

var $hHpDh = parcelRequire("hHpDh");

var $G2hpM = parcelRequire("G2hpM");
class $85a3435740842397$export$3f86810331c44209 {
    static{
        this.queueOptions = {
            storage: (0, $G2hpM.default)('localStorage') ? window.localStorage : undefined,
            storagePrefix: (0, $8iUeU.localStoragePrefix),
            maxDuplicates: 25,
            minUniqueItems: 5
        };
    }
    constructor(useStorageIfPossible = true){
        const options = $85a3435740842397$export$3f86810331c44209.queueOptions;
        if (useStorageIfPossible && options.storage) {
            const queueOptions = {
                ...options,
                storage: options.storage
            };
            this.queue = new (0, $hHpDh.default)(queueOptions);
        } else this.queue = new (0, $3tG1E.default)(options);
        this.gateway = new $85a3435740842397$export$a0e1fa6601cae894(10);
    }
    /**
	 * Record the fact that the supplied emoji was used. You should note that usage is updated asynchronously so you can not
	 * count on getOrder() reflecting this usage immediately.
	 *
	 * @param emoji the emoji who's usage is to be recorded. If the emoji has no id then no usage will be recorded
	 */ recordUsage(emoji) {
        let emojiId = emoji.id;
        if (emojiId) {
            if ((0, $fqzOa.isEmojiVariationDescription)(emoji)) emojiId = emoji.baseId;
            this.gateway.submit(()=>{
                if (emojiId) this.queue.enqueue(emojiId);
            });
        }
    }
    /**
	 * Returns an array of emoji id (without skin tone variations) sorted by most used to least used. If there
	 * are no usages then an empty array will be returned.
	 */ getOrder() {
        return this.queue.getItemsOrderedByDuplicateCount();
    }
    /**
	 * Exposed for testing only. Clear any recorded usage.
	 */ clear() {
        this.queue.clear();
    }
}
class $85a3435740842397$export$a0e1fa6601cae894 {
    constructor(maximumPermitted){
        if (maximumPermitted < 1) throw new RangeError('The maximumPermitted parameter must be 1 or more.');
        this.maximumPermitted = maximumPermitted;
        this.count = 0;
    }
    /**
	 * Run the supplied function if the count of already submitted work allows it. Drop the work
	 * if it's not allowed to run.
	 *
	 * Will return true if the function has been submitted or false if it was not submitted.
	 */ submit(f) {
        if (this.count >= this.maximumPermitted) return false;
        this.count++;
        const wrappedFunc = ()=>{
            try {
                f();
            } finally{
                this.completed();
            }
        };
        if (typeof window !== 'undefined') window.setTimeout(wrappedFunc);
        return true;
    }
    completed() {
        this.count--;
    }
}

});
parcelRegister("3tG1E", function(module, exports) {
$parcel$export(module.exports, "default", () => $41426f5ff409d188$export$2e2bcd8739ae039);
/**
 * The options used to configure a newly constructed queue.
 */ class $41426f5ff409d188$export$2e2bcd8739ae039 {
    /**
	 * Construct a new DuplicateLimitedQueue.
	 *
	 * @param options the options for this queue.
	 */ constructor(options){
        if (options.maxDuplicates < 1) throw new RangeError('The maxDuplicates option must be at least 1');
        if (options.minUniqueItems < 1) throw new RangeError('The minUniqueItems option must be at least 1');
        this.maximumSize = options.maxDuplicates * options.minUniqueItems;
        this.perItemSize = options.maxDuplicates;
        this.createEmptyState();
    }
    /**
	 * @param item the item to add to the queue.
	 */ enqueue(item) {
        this.enqueueWithoutOrdering(item);
        // enqueues are less time sensitive (and may happen less frequently) than queries against the queue
        // so do the ordering work on each enqueue.
        this.itemsOrderedByFrequency = this.orderItemsByFrequency();
    }
    /**
	 * Return the items in the queue, ordered by how often they are duplicated. The items with the
	 * most duplicates come first in the returned Array.
	 *
	 * If there are no items in the queue then an empty Array will be returned.
	 */ getItemsOrderedByDuplicateCount() {
        return this.itemsOrderedByFrequency;
    }
    /**
	 * Exposed for storybook/testing purposes only. Clear the contents of the queue.
	 */ clear() {
        this.createEmptyState();
    }
    /**
	 * A more efficient mechanism for adding multiple items. Ordering is only performed once all
	 * the items have been added.
	 *
	 * @param items the items to be enqueued, which happens in their presented order.
	 */ bulkEnqueue(items) {
        items.map((item)=>this.enqueueWithoutOrdering(item));
        this.itemsOrderedByFrequency = this.orderItemsByFrequency();
    }
    /**
	 * Return the items currently stored in the queue.
	 */ getItems() {
        return this.items;
    }
    createEmptyState() {
        this.items = new Array();
        this.itemCountMap = new Map();
        this.itemsOrderedByFrequency = new Array();
    }
    /**
	 * Enqueue the supplied item, keeping consistency with the limits configured. However no ordering is
	 * performed by this enqueuing. You must trigger that manually if required.
	 *
	 * @param item the item to be queued
	 */ enqueueWithoutOrdering(item) {
        const count = this.itemCountMap.get(item);
        if (count && count >= this.perItemSize) // find the first item with that key in the array and remove it
        this.removeFirstOccurrence(item);
        else if (this.items.length >= this.maximumSize) this.remove();
        this.add(item);
    }
    /**
	 * Get an array of items from the queue ordered by how often they are duplicated in the queue.
	 */ orderItemsByFrequency() {
        const orderedEntries = Array.from(this.itemCountMap.entries()).sort((a, b)=>{
            return b[1] - a[1];
        });
        return orderedEntries.map((value)=>value[0]);
    }
    decrementCount(item) {
        let count = this.itemCountMap.get(item);
        if (count) {
            count--;
            if (count > 0) this.itemCountMap.set(item, count);
            else this.itemCountMap.delete(item);
        }
    }
    /**
	 * Walk the list of items and remove the first occurrence of the matching item.
	 *
	 * @param item the item to be removed.
	 */ removeFirstOccurrence(item) {
        const index = this.items.indexOf(item);
        if (index !== -1) {
            this.items.splice(index, 1);
            this.decrementCount(item);
        }
    }
    /**
	 * Remove the first item from the queue and update the itemCountMap accordingly.
	 * @return the item add the front of the queue or undefined if the queue is empty
	 */ remove() {
        const removed = this.items.shift();
        if (removed !== undefined) this.decrementCount(removed);
        return removed;
    }
    /**
	 * Add the supplied item to the end of the queue and update the itemCountMap accordingly.
	 * @param item the item to be added to the queue
	 */ add(item) {
        this.items.push(item);
        const count = this.itemCountMap.get(item);
        if (count) this.itemCountMap.set(item, count + 1);
        else this.itemCountMap.set(item, 1);
    }
}

});

parcelRegister("hHpDh", function(module, exports) {
$parcel$export(module.exports, "default", () => $3aba84b62a5f15c2$export$2e2bcd8739ae039);

var $3tG1E = parcelRequire("3tG1E");

var $32Nbx = parcelRequire("32Nbx");
class $3aba84b62a5f15c2$export$2e2bcd8739ae039 extends (0, $3tG1E.default) {
    static{
        this.storageKey = 'lastUsed';
    }
    constructor(options){
        super(options);
        this.storage = options.storage;
        this.prefixedStorageKey = `${options.storagePrefix}.${$3aba84b62a5f15c2$export$2e2bcd8739ae039.storageKey}`;
        this.load();
    }
    /**
	 * Enqueue the supplied item and also persist the new contents of the queue to storage.
	 *
	 * @param item the item to be enqueued
	 */ enqueue(item) {
        super.enqueue(item);
        this.save();
    }
    /**
	 * Exposed for storybook/testing purposes only. Clear the contents of the queue, and localStorage.
	 */ clear() {
        super.clear();
        this.storage.removeItem(this.prefixedStorageKey);
    }
    /**
	 * Initialise the queue contents from the configured Storage. If there is no data found in
	 * storage then the queue will have no items added. Likewise, a failure to read or parse stored
	 * data will be swallowed and no items are added to the queue.
	 */ load() {
        const itemsJson = this.storage.getItem(this.prefixedStorageKey);
        if (itemsJson) try {
            const items = JSON.parse(itemsJson);
            this.bulkEnqueue(items);
        } catch (e) {
            (0, $32Nbx.default)(`Error parsing the queue stored as ${this.prefixedStorageKey} key from storage`, e);
        }
    }
    /**
	 * Save the current items in the queue, overwriting any previously stored queue.
	 * Any failure in saving will be silently ignored with the likely outcome that any previous
	 * saved items will remain unchanged in storage.
	 */ save() {
        const itemsJson = JSON.stringify(this.getItems());
        try {
            this.storage.setItem(this.prefixedStorageKey, itemsJson);
        } catch (e) {
            (0, $32Nbx.default)(`Error saving the queued items as ${this.prefixedStorageKey}`, e);
        }
    }
}

});



parcelRegister("g84Mp", function(module, exports) {
$parcel$export(module.exports, "default", () => $dcbb7b86e406216b$export$2e2bcd8739ae039);

var $kp3br = parcelRequire("kp3br");

var $aRuva = parcelRequire("aRuva");

var $fqzOa = parcelRequire("fqzOa");

var $bPZCQ = parcelRequire("bPZCQ");

var $cBxa0 = parcelRequire("cBxa0");

var $k1Z1t = parcelRequire("k1Z1t");

var $32Nbx = parcelRequire("32Nbx");
const $dcbb7b86e406216b$export$6f3a08dea02a7b2b = 0.95;
class $dcbb7b86e406216b$export$2e2bcd8739ae039 {
    constructor(siteServiceConfig, mediaApiToken){
        this.postToEmojiService = (upload, fileId)=>{
            const { shortName: shortName, name: name } = upload;
            const { width: width, height: height } = upload;
            const requestInit = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    shortName: shortName,
                    name: name,
                    width: width,
                    height: height,
                    fileId: fileId
                })
            };
            return (0, $kp3br.utils).requestService(this.siteServiceConfig, {
                requestInit: requestInit
            }).then((response)=>{
                const { emojis: emojis } = response;
                if (emojis.length) {
                    const { altRepresentations: altRepresentations, ...emoji } = emojis[0];
                    const response = {
                        ...emoji,
                        representation: (0, $fqzOa.convertImageToMediaRepresentation)(emoji.representation)
                    };
                    const altRepresentation = (0, $cBxa0.getAltRepresentation)(altRepresentations || {});
                    const imgAltRepresentation = altRepresentation ? (0, $fqzOa.convertImageToMediaRepresentation)(altRepresentation) : undefined;
                    return (0, $fqzOa.buildEmojiDescriptionWithAltRepresentation)(response, imgAltRepresentation);
                }
                throw new Error('No emoji returns from upload. Upload failed.');
            });
        };
        this.siteServiceConfig = siteServiceConfig;
        this.mediaApiToken = mediaApiToken;
        this.tokenManager = new (0, $k1Z1t.default)(siteServiceConfig);
        this.tokenManager.addToken('read', mediaApiToken);
        this.mediaEmojiCache = new (0, $bPZCQ.default)(this.tokenManager);
    }
    /**
	 * Will generate an emoji media path that is inclusive of client and token within the query parameter for media representation and altRepresentation
	 */ async generateTokenisedMediaURLS(representation, altRepresentation) {
        if (!(0, $fqzOa.isMediaRepresentation)(representation)) return {
            representation: representation,
            altRepresentation: altRepresentation
        };
        try {
            const readToken = await this.tokenManager.getToken('read');
            return Object.entries({
                representation: representation,
                altRepresentation: altRepresentation
            }).reduce((acc, [key, value])=>{
                if (value && (0, $fqzOa.isMediaRepresentation)(value)) {
                    const path = new URL(value.mediaPath);
                    const params = path.searchParams;
                    if (params.get('token') !== readToken.jwt) params.set('token', readToken.jwt);
                    if (params.get('client') !== readToken.clientId) params.set('client', readToken.clientId);
                    acc[key] = {
                        ...value,
                        mediaPath: path.toString()
                    };
                }
                return acc;
            }, {
                representation: representation,
                altRepresentation: altRepresentation
            });
        } catch (error) {
            return {
                representation: representation,
                altRepresentation: altRepresentation
            };
        }
    }
    /**
	 * Will load media emoji, returning a new EmojiDescription if, for example,
	 * the URL has changed.
	 */ loadMediaEmoji(emoji, useAlt) {
        if (!(0, $fqzOa.isMediaEmoji)(emoji)) throw new Error('Only supported for media emoji');
        return this.mediaEmojiCache.loadEmoji(emoji, useAlt);
    }
    optimisticRendering(emoji, useAlt) {
        const representation = useAlt ? emoji.altRepresentation : emoji.representation;
        if (!(0, $fqzOa.isMediaRepresentation)(representation)) throw new Error('Only supported for media emoji');
        const { mediaPath: mediaPath } = representation;
        return this.mediaEmojiCache.optimisticRendering(mediaPath);
    }
    uploadEmoji(upload, retry = false, progressCallback) {
        const startTime = Date.now();
        return this.tokenManager.getToken('upload', retry).then((uploadToken)=>{
            const tokenLoadTime = Date.now() - startTime;
            (0, $32Nbx.default)('upload token load time', tokenLoadTime);
            return new Promise((resolve, reject)=>{
                const { url: url, clientId: clientId, collectionName: collectionName } = uploadToken;
                const mediaClient = (0, $aRuva.getMediaClient)({
                    authProvider: ()=>Promise.resolve({
                            clientId: clientId,
                            token: uploadToken.jwt,
                            baseUrl: url
                        }),
                    useSha256ForUploads: true
                });
                const subscription = mediaClient.file.upload({
                    content: upload.dataURL,
                    name: upload.filename,
                    collection: collectionName
                }).subscribe({
                    next: (state)=>{
                        if (state.status === 'uploading' && progressCallback) progressCallback({
                            percent: state.progress * $dcbb7b86e406216b$export$6f3a08dea02a7b2b
                        });
                        else if (state.status === 'processing' || state.status === 'processed') {
                            subscription.unsubscribe();
                            const totalUploadTime = Date.now() - startTime;
                            const mediaUploadTime = totalUploadTime - tokenLoadTime;
                            (0, $32Nbx.default)('total upload / media upload times', totalUploadTime, mediaUploadTime);
                            this.postToEmojiService(upload, state.id).then((emoji)=>{
                                resolve(emoji);
                            }).catch((httpError)=>{
                                reject(httpError.reason || httpError);
                            });
                        }
                    },
                    error (error) {
                        reject(error);
                    }
                });
            });
        });
    }
    /**
	 * Check if the MediaEmojiResource has been able to initialise an uploadToken. Retrieving an upload token
	 * is asynchronous so the Promise will need to resolve before the state is known. If the token retrieval
	 * completes with failure then the Promise will resolve to false.
	 */ hasUploadToken() {
        const tokenPromise = this.tokenManager.getToken('upload');
        return tokenPromise.then((token)=>{
            return token !== undefined;
        }, ()=>{
            return false;
        });
    }
    prepareForUpload() {
        // make sure a token is loaded from the emoji service if we don't have one
        // as future request to uploadEmoji will use this, this to preload it, as it
        // usually takes 1-2 seconds to generate
        this.tokenManager.getToken('upload');
    }
    findEmoji(emojiId) {
        if (!emojiId.id) return Promise.reject(false);
        const path = `../${encodeURIComponent(emojiId.id)}`;
        return (0, $cBxa0.emojiRequest)(this.siteServiceConfig, {
            path: path
        }).then((serviceResponse)=>{
            const response = (0, $cBxa0.denormaliseEmojiServiceResponse)(serviceResponse);
            return response.emojis[0];
        }).catch((error)=>{
            (0, $32Nbx.default)('failed to load emoji', emojiId, error);
            return undefined;
        });
    }
    /**
	 * Calls to site-scoped EmojiResource to delete emoji
	 * @param emoji media emoji to delete
	 * @returns Promise.resolve() if success and Promise.reject() for failure
	 */ deleteEmoji(emoji) {
        if (!(0, $fqzOa.isMediaEmoji)(emoji) && !(0, $fqzOa.isLoadedMediaEmoji)(emoji)) return Promise.reject(false);
        if (!emoji.id) return Promise.reject(false);
        const path = `${encodeURIComponent(emoji.id)}`;
        const requestInit = {
            method: 'DELETE'
        };
        return (0, $kp3br.utils).requestService(this.siteServiceConfig, {
            path: path,
            requestInit: requestInit
        })// Successful delete on Promise.resolve
        .then(()=>true)// Unsuccessful delete on Promise.reject
        .catch(()=>false);
    }
}

});
parcelRegister("bPZCQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4e4069442f1729a0$export$2e2bcd8739ae039);

var $fqzOa = parcelRequire("fqzOa");

var $9rgFW = parcelRequire("9rgFW");

var $32Nbx = parcelRequire("32Nbx");

var $7xkt0 = parcelRequire("7xkt0");
const $4e4069442f1729a0$var$getRequiredRepresentation = (emoji, useAlt)=>useAlt ? emoji.altRepresentation : emoji.representation;
const $4e4069442f1729a0$var$isUnsupportedBrowser = ()=>{
    const isIE = !!document.documentMode; // Internet Explorer 6-11
    const isEdge = !isIE && !!window.StyleMedia; // Edge 20+
    return isIE || isEdge;
};
class $4e4069442f1729a0$export$3850f566ce8d817a {
    constructor(mediaImageLoader){
        this.cachedImageUrls = new Set();
        (0, $32Nbx.default)('BrowserCacheStrategy');
        this.mediaImageLoader = mediaImageLoader;
    }
    loadEmoji(emoji, useAlt) {
        const representation = $4e4069442f1729a0$var$getRequiredRepresentation(emoji, useAlt);
        if (!(0, $fqzOa.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        if (this.cachedImageUrls.has(mediaPath)) // Already cached
        return emoji;
        return this.mediaImageLoader.loadMediaImage(mediaPath).then(()=>{
            // Media is loaded, can use original URL now, so just return original emoji
            this.cachedImageUrls.add(mediaPath);
            return emoji;
        }).catch(()=>{
            return undefined;
        });
    }
    optimisticRendering() {
        return true;
    }
    static supported(mediaPath, mediaImageLoader) {
        // IE/Edge uses memory cache strategy else images can fail to load
        // from a clean cache/if they are downloaded from the service
        // TODO: fix as a part of FS-1592
        if ($4e4069442f1729a0$var$isUnsupportedBrowser()) return Promise.resolve(false);
        return mediaImageLoader.loadMediaImage(mediaPath).then(()=>// Image should be cached in browser, if supported it should be accessible from the cache by an <img/>
            // Try to load without via image to confirm this support (this fails in Firefox)
            new Promise((resolve)=>{
                const img = new Image();
                img.addEventListener('load', ()=>{
                    resolve(true);
                });
                img.addEventListener('error', ()=>{
                    resolve(false);
                });
                img.src = mediaPath;
            })).catch(()=>false);
    }
}
const $4e4069442f1729a0$var$maxImageCached = 1000;
// Don't cache images large than this - dataUrl size in characters
const $4e4069442f1729a0$var$maxImageSize = 10000;
class $4e4069442f1729a0$export$b522858a3709f4c {
    constructor(mediaImageLoader){
        (0, $32Nbx.default)('MemoryCacheStrategy');
        this.mediaImageLoader = mediaImageLoader;
        this.dataURLCache = new (0, $7xkt0.LRUMap)($4e4069442f1729a0$var$maxImageCached);
    }
    loadEmoji(emoji, useAlt) {
        const representation = $4e4069442f1729a0$var$getRequiredRepresentation(emoji, useAlt);
        if (!(0, $fqzOa.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        const dataURL = this.dataURLCache.get(mediaPath);
        if (dataURL) // Already cached
        return (0, $fqzOa.convertMediaToImageEmoji)(emoji, dataURL, useAlt);
        // Not cached, load
        return this.mediaImageLoader.loadMediaImage(mediaPath).then((dataURL)=>{
            const loadedEmoji = (0, $fqzOa.convertMediaToImageEmoji)(emoji, dataURL, useAlt);
            if (dataURL.length <= $4e4069442f1729a0$var$maxImageSize) // Only cache if not large than max size
            this.dataURLCache.set(mediaPath, dataURL);
            else (0, $32Nbx.default)('No caching as image is too large', dataURL.length, dataURL.slice(0, 15), emoji.shortName);
            return loadedEmoji;
        }).catch(()=>{
            return undefined;
        });
    }
    optimisticRendering() {
        return false;
    }
}
class $4e4069442f1729a0$export$2e2bcd8739ae039 {
    constructor(tokenManager){
        this.waitingInitUrls = [];
        (0, $32Nbx.default)('MediaEmojiCache');
        this.mediaImageLoader = new (0, $9rgFW.default)(tokenManager);
    }
    loadEmoji(emoji, useAlt) {
        const representation = $4e4069442f1729a0$var$getRequiredRepresentation(emoji, useAlt);
        if (!(0, $fqzOa.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        const emojiCache = this.getCache(mediaPath);
        if ((0, $fqzOa.isPromise)(emojiCache)) // Promise based
        return emojiCache.then((cache)=>cache.loadEmoji(emoji, useAlt)).catch(()=>undefined);
        return emojiCache.loadEmoji(emoji, useAlt);
    }
    optimisticRendering(url) {
        const emojiCache = this.getCache(url);
        if ((0, $fqzOa.isPromise)(emojiCache)) // Promise based
        return emojiCache.then((cache)=>cache.optimisticRendering()).catch(()=>false);
        return emojiCache.optimisticRendering();
    }
    getCache(url) {
        if (this.cache) return this.cache;
        this.waitingInitUrls.push(url);
        if (!this.cacheLoading) this.cacheLoading = this.initCache().then((cache)=>{
            this.cache = cache;
            this.cacheLoading = undefined;
            return cache;
        }).catch((err)=>{
            this.cacheLoading = undefined;
            throw err;
        });
        return this.cacheLoading;
    }
    initCache() {
        const url = this.waitingInitUrls.pop();
        if (!url) return Promise.reject('Unable to initialise cache based on provided url(s)');
        return $4e4069442f1729a0$export$3850f566ce8d817a.supported(url, this.mediaImageLoader).then((supported)=>{
            this.waitingInitUrls = []; // clear
            this.cacheLoading = undefined;
            if (supported) return new $4e4069442f1729a0$export$3850f566ce8d817a(this.mediaImageLoader);
            return new $4e4069442f1729a0$export$b522858a3709f4c(this.mediaImageLoader);
        }).catch(()=>{
            return this.initCache();
        });
    }
}

});
parcelRegister("9rgFW", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d91f6546b6deb57$export$2e2bcd8739ae039);

var $4T9Po = parcelRequire("4T9Po");
const $8d91f6546b6deb57$var$defaultConcurrentDownloadLimit = 16;
const $8d91f6546b6deb57$var$backoffMaxDelayInMillis = 600;
const $8d91f6546b6deb57$var$defaultMaxRetriesOnNotFound = 2;
class $8d91f6546b6deb57$export$2e2bcd8739ae039 {
    constructor(tokenManager, options){
        this.mediaImageQueue = [];
        this.activeProcessing = 0;
        this.pendingRequests = new Map();
        this.concurrentDownloadLimit = options && options.concurrentDownloadLimit || $8d91f6546b6deb57$var$defaultConcurrentDownloadLimit;
        this.tokenManager = tokenManager;
    }
    loadMediaImage(url) {
        const maybePending = this.pendingRequests.get(url);
        if (maybePending !== undefined) return maybePending;
        const pending = new Promise((resolve, reject)=>{
            this.mediaImageQueue.push({
                url: url,
                resolve: resolve,
                reject: reject
            });
            this.processFromQueue();
        }).then((result)=>{
            this.pendingRequests.delete(url);
            return result;
        }).catch((error)=>{
            this.pendingRequests.delete(url);
            throw error;
        });
        this.pendingRequests.set(url, pending);
        return pending;
    }
    getQueueSize() {
        return this.mediaImageQueue.length;
    }
    getActiveDownloads() {
        return this.activeProcessing;
    }
    processFromQueue() {
        while(this.activeProcessing < this.concurrentDownloadLimit && this.mediaImageQueue.length > 0){
            this.activeProcessing++;
            const item = this.mediaImageQueue.shift();
            const { url: url, resolve: resolve, reject: reject } = item;
            this.tokenManager.getToken('read', false).then((token)=>{
                this.requestMediaEmoji(url, token, true).then((dataURL)=>{
                    resolve(dataURL);
                    this.completedItem();
                }).catch((error)=>{
                    reject(error);
                    this.completedItem();
                });
            }).catch((error)=>{
                // Failed to load, just resolve to original emoji
                reject(error);
                this.completedItem();
            });
        }
    }
    completedItem() {
        this.activeProcessing--;
        this.processFromQueue();
    }
    delay(durationInMillis) {
        return new Promise((resolve)=>setTimeout(resolve, durationInMillis));
    }
    requestMediaEmoji(url, token, retryOnAuthError, retriesOnNotFound = $8d91f6546b6deb57$var$defaultMaxRetriesOnNotFound) {
        return (0, $4T9Po.imageAcceptHeader)().then((acceptHeader)=>{
            // Media REST API: https://media-api-internal.atlassian.io/api.html#file__fileId__image_get
            const options = {
                headers: {
                    Authorization: `Bearer ${token.jwt}`,
                    'X-Client-Id': token.clientId,
                    Accept: acceptHeader
                }
            };
            return fetch(url, options).then((response)=>{
                // retry if 404
                if (response.status === 404 && retriesOnNotFound > 0) return this.delay($8d91f6546b6deb57$var$backoffMaxDelayInMillis / retriesOnNotFound) // backoff strategy
                .then(()=>this.requestMediaEmoji(url, token, false, retriesOnNotFound - 1));
                else if (response.status === 403 && retryOnAuthError) // retry once if 403
                return this.tokenManager.getToken('read', true).then((newToken)=>this.requestMediaEmoji(url, newToken, false));
                else if (response.ok) return response.blob().then((blob)=>this.readBlob(blob));
                throw new Error(`Unable to load media image. Status=${response.status} ${response.statusText}`);
            });
        });
    }
    readBlob(blob) {
        return new Promise((resolve, reject)=>{
            const reader = new FileReader();
            // TODO: [ts30] Add proper handling for null and ArrayBuffer
            reader.addEventListener('load', ()=>resolve(reader.result));
            reader.addEventListener('error', ()=>reject(reader.error));
            reader.readAsDataURL(blob);
        });
    }
}

});
parcelRegister("4T9Po", function(module, exports) {
$parcel$export(module.exports, "getNaturalImageSize", () => $1db1ed6195d2b828$export$90153ab95f408dfa);
$parcel$export(module.exports, "parseImage", () => $1db1ed6195d2b828$export$37bbb051492a18a7);
$parcel$export(module.exports, "hasFileExceededSize", () => $1db1ed6195d2b828$export$a115ddd5941792f1);
$parcel$export(module.exports, "imageAcceptHeader", () => $1db1ed6195d2b828$export$f8e7886bc155c2e6);
const $1db1ed6195d2b828$var$maxEmojiSizeInBytes = 1048576;
const $1db1ed6195d2b828$export$90153ab95f408dfa = (dataURL)=>{
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.addEventListener('load', ()=>{
            resolve({
                width: img.naturalWidth,
                height: img.naturalHeight
            });
        });
        img.addEventListener('error', reject);
        img.src = dataURL;
    });
};
const $1db1ed6195d2b828$export$37bbb051492a18a7 = (dataURL)=>{
    return new Promise((resolve, reject)=>{
        let img = new Image();
        img.onload = ()=>resolve({
                src: img.src
            });
        img.onerror = ()=>reject();
        img.src = dataURL;
    });
};
const $1db1ed6195d2b828$export$a115ddd5941792f1 = (file)=>{
    return file && file.size > $1db1ed6195d2b828$var$maxEmojiSizeInBytes;
};
// Duplicates https://bitbucket.org/atlassian/atlaskit/src/0e843df6df8bcd33fa7fc16cc63f11a0f6094957/packages/media-core/src/utils/checkWebpSupport.ts?at=master&fileviewer=file-view-default
// Didn't want to depend on the whole of media-core just for this util
/**
 * Checks if Webp support is enabled in the browser.
 * We know that creating a new image in memory and checking its height,
 * later on we cache this value forever.
 */ let $1db1ed6195d2b828$var$isWebpSupported;
const $1db1ed6195d2b828$export$c5a964eb84c7fca8 = ()=>{
    if ($1db1ed6195d2b828$var$isWebpSupported !== undefined) return Promise.resolve($1db1ed6195d2b828$var$isWebpSupported);
    return new Promise((resolve)=>{
        const img = new Image();
        const checkSupport = ()=>{
            $1db1ed6195d2b828$var$isWebpSupported = img.height === 2;
            resolve($1db1ed6195d2b828$var$isWebpSupported);
        };
        img.addEventListener('load', checkSupport);
        img.addEventListener('error', checkSupport);
        img.src = 'data:image/webp;base64,UklGRi4AAABXRUJQVlA4TCEAAAAvAUAAEB8wAiMwAgSSNtse/cXjxyCCmrYNWPwmHRH9jwMA';
    });
};
const $1db1ed6195d2b828$export$f8e7886bc155c2e6 = ()=>$1db1ed6195d2b828$export$c5a964eb84c7fca8().then((isWebpSupported)=>{
        // q=0.8 stands for 'quality factor' => http://stackoverflow.com/a/10496722
        const noWebpAcceptHeader = 'image/*,*/*;q=0.8';
        const webpAcceptHeader = 'image/webp,image/*,*/*;q=0.8';
        return isWebpSupported ? webpAcceptHeader : noWebpAcceptHeader;
    });

});



parcelRegister("k1Z1t", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c3d1420d2de3afa$export$2e2bcd8739ae039);

var $kp3br = parcelRequire("kp3br");
const $2c3d1420d2de3afa$export$866c20c059277b6 = 30;
class $2c3d1420d2de3afa$export$2e2bcd8739ae039 {
    constructor(siteServiceConfig){
        this.siteServiceConfig = siteServiceConfig;
        this.tokens = new Map();
    }
    isValidToken(mediaApiToken) {
        const nowInSeconds = Date.now() / 1000;
        const expiresAt = mediaApiToken.expiresAt - $2c3d1420d2de3afa$export$866c20c059277b6;
        if (nowInSeconds < expiresAt) return true;
        return false;
    }
    fetchNewToken(type) {
        return (0, $kp3br.utils).requestService(this.siteServiceConfig, {
            path: `token/${type}`
        });
    }
    addToken(type, mediaApiToken) {
        this.tokens.set(type, {
            mediaApiToken: mediaApiToken
        });
    }
    getToken(type, forceRefresh) {
        let tokenDetail = this.tokens.get(type);
        if (!tokenDetail) {
            tokenDetail = {};
            this.tokens.set(type, tokenDetail);
        }
        const { mediaApiToken: mediaApiToken, activeTokenRefresh: activeTokenRefresh } = tokenDetail;
        if (mediaApiToken) {
            if (this.isValidToken(mediaApiToken) && !forceRefresh) // still valid
            return Promise.resolve(mediaApiToken);
        }
        if (activeTokenRefresh) // refresh token promise already active, return that
        return activeTokenRefresh;
        // request a new token and track the promise for future requests until completed
        tokenDetail.activeTokenRefresh = this.fetchNewToken(type).then((token)=>{
            tokenDetail.mediaApiToken = token;
            tokenDetail.activeTokenRefresh = undefined;
            return token;
        });
        return tokenDetail.activeTokenRefresh;
    }
}

});


parcelRegister("1AKB0", function(module, exports) {
$parcel$export(module.exports, "promiseWithTimeout", () => $7d4e7f9f7c6d2510$export$a9cd205a244d9f54);
function $7d4e7f9f7c6d2510$export$a9cd205a244d9f54(promise, timeout, errorMessage = 'Timed out') {
    // Create a promise that rejects after the specified timeout
    const timeoutPromise = new Promise((_, reject)=>setTimeout(()=>reject(new Error(errorMessage)), timeout));
    // Use Promise.race to race the provided promise against the timeout promise
    return Promise.race([
        promise,
        timeoutPromise
    ]);
}

});



parcelRegister("gxQLu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cf6065af0d56e84610020204bbc954cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c0b8a8745bb75027$var$_react = $c0b8a8745bb75027$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c0b8a8745bb75027$var$_baseNew = $c0b8a8745bb75027$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c0b8a8745bb75027$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EmojiAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding an emoji reaction.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c0b8a8745bb75027$var$EmojiAddIcon = (props)=>/*#__PURE__*/ $c0b8a8745bb75027$var$_react.default.createElement($c0b8a8745bb75027$var$_baseNew.default, Object.assign({
        name: "EmojiAddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 8a6.5 6.5 0 1 0 13 0H16a8 8 0 1 1-8-8v1.5A6.5 6.5 0 0 0 1.5 8m4.585 2.033c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .721-.714l.005-.007-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513M5.75 7.5a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m4.5 0a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m2.25-4h-2V2h2V0H14v2h2v1.5h-2v2h-1.5z" clip-rule="evenodd"/>`
    }, props));
$c0b8a8745bb75027$var$EmojiAddIcon.displayName = 'EmojiAddIcon';
var $c0b8a8745bb75027$var$_default = module.exports.default = $c0b8a8745bb75027$var$EmojiAddIcon;

});

parcelRegister("kv4Vh", function(module, exports) {
$parcel$export(module.exports, "default", () => $716080d8ed91a1dd$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
function $716080d8ed91a1dd$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-label": "editor-add-emoji",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                width: 24,
                height: 24,
                fill: "var(--ds-background-neutral-subtle, white)",
                fillOpacity: "0.01"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.5715 6.20367C13.7531 5.88041 12.8807 5.71423 12 5.71423C10.1435 5.71423 8.36301 6.45173 7.05025 7.76449C5.7375 9.07724 5 10.8577 5 12.7142C5 14.5708 5.7375 16.3512 7.05025 17.664C8.36301 18.9767 10.1435 19.7142 12 19.7142C12.9193 19.7142 13.8295 19.5332 14.6788 19.1814C15.5281 18.8296 16.2997 18.314 16.9497 17.664C17.5998 17.014 18.1154 16.2423 18.4672 15.393C18.8189 14.5437 19 13.6335 19 12.7142C19 12.1349 18.9281 11.5591 18.7868 10.9999H17.2266C17.404 11.5396 17.5 12.1159 17.5 12.7142C17.5 15.7472 15.033 18.2142 12 18.2142C8.967 18.2142 6.5 15.7472 6.5 12.7142C6.50159 11.256 7.08156 9.85801 8.11267 8.8269C9.14377 7.79579 10.5418 7.21582 12 7.21423C12.9284 7.21423 13.8037 7.44537 14.5715 7.85312V6.20367ZM9.79289 11.9213C9.98043 12.1089 10.2348 12.2142 10.5 12.2142C10.7652 12.2142 11.0196 12.1089 11.2071 11.9213C11.3946 11.7338 11.5 11.4795 11.5 11.2142C11.5 10.949 11.3946 10.6947 11.2071 10.5071C11.0196 10.3196 10.7652 10.2142 10.5 10.2142C10.2348 10.2142 9.98043 10.3196 9.79289 10.5071C9.60536 10.6947 9.5 10.949 9.5 11.2142C9.5 11.4795 9.60536 11.7338 9.79289 11.9213ZM12.7929 11.9213C12.9804 12.1089 13.2348 12.2142 13.5 12.2142C13.7652 12.2142 14.0196 12.1089 14.2071 11.9213C14.3946 11.7338 14.5 11.4795 14.5 11.2142C14.5 10.949 14.3946 10.6947 14.2071 10.5071C14.0196 10.3196 13.7652 10.2142 13.5 10.2142C13.2348 10.2142 12.9804 10.3196 12.7929 10.5071C12.6054 10.6947 12.5 10.949 12.5 11.2142C12.5 11.4795 12.6054 11.7338 12.7929 11.9213ZM14.1965 13.61C14.0355 13.6153 13.8828 13.6823 13.77 13.7972C12.871 14.8032 11.133 14.8032 10.232 13.8002C10.1205 13.6799 9.96614 13.6082 9.80223 13.6006C9.63832 13.5931 9.47801 13.6503 9.35592 13.7599C9.23383 13.8695 9.15974 14.0227 9.14965 14.1865C9.13956 14.3503 9.19428 14.5115 9.302 14.6352C9.64217 15.0139 10.0582 15.3167 10.523 15.5241C10.9878 15.7316 11.491 15.8389 12 15.8392C12.51 15.839 13.0142 15.7313 13.4797 15.5231C13.9453 15.315 14.3617 15.0111 14.702 14.6312C14.8037 14.5064 14.8535 14.3472 14.8409 14.1866C14.8282 14.0261 14.7542 13.8766 14.6342 13.7692C14.5142 13.6618 14.3574 13.6048 14.1965 13.61Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.2856 8.31714H17.0228V9.05429C17.0228 9.28161 17.1131 9.49963 17.2738 9.66038C17.4345 9.82112 17.6526 9.91143 17.8799 9.91143C18.1072 9.91143 18.3252 9.82112 18.486 9.66038C18.6467 9.49963 18.737 9.28161 18.737 9.05429V8.31714H19.4828C19.7101 8.31714 19.9281 8.22684 20.0888 8.06609C20.2496 7.90535 20.3399 7.68733 20.3399 7.46C20.3399 7.23267 20.2496 7.01465 20.0888 6.85391C19.9281 6.69316 19.7101 6.60286 19.4828 6.60286H18.737V5.85714C18.737 5.62981 18.6467 5.4118 18.486 5.25105C18.3252 5.09031 18.1072 5 17.8799 5C17.6526 5 17.4345 5.09031 17.2738 5.25105C17.1131 5.4118 17.0228 5.62981 17.0228 5.85714V6.60286H16.2856C16.0583 6.60286 15.8403 6.69316 15.6795 6.85391C15.5188 7.01465 15.4285 7.23267 15.4285 7.46C15.4285 7.68733 15.5188 7.90535 15.6795 8.06609C15.8403 8.22684 16.0583 8.31714 16.2856 8.31714Z",
                fill: "currentColor"
            })
        ]
    });
}

});


parcelRegister("edTSk", function(module, exports) {
$parcel$export(module.exports, "ExtensionsPlaceholder", () => $f349c866cfe057a1$export$8bacfc8aacebb3c1);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $joSn0 = parcelRequire("joSn0");

var $48q59 = parcelRequire("48q59");

var $g3VjK = parcelRequire("g3VjK");

var $lQJJa = parcelRequire("lQJJa");

var $knwdo = parcelRequire("knwdo");
var $84CN8 = parcelRequire("84CN8");

var $9Ssie = parcelRequire("9Ssie");

var $eGOwo = parcelRequire("eGOwo");

var $9rPmE = parcelRequire("9rPmE");
const $f349c866cfe057a1$var$noop = ()=>null;
const $f349c866cfe057a1$var$isDefaultExport = (mod)=>{
    return mod.hasOwnProperty('default');
};
const $f349c866cfe057a1$var$resolveExtensionIcon = async (getIcon)=>{
    if (!getIcon) return $f349c866cfe057a1$var$noop;
    const maybeIcon = await getIcon();
    return $f349c866cfe057a1$var$isDefaultExport(maybeIcon) ? maybeIcon.default : maybeIcon;
};
const $f349c866cfe057a1$var$ExtensionButton = (props)=>{
    const { item: item, node: node, extensionApi: extensionApi, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    const ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>item.icon ? (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
            // Ignored via go/ees005
            // eslint-disable-next-line require-await
            loader: async ()=>$f349c866cfe057a1$var$resolveExtensionIcon(item.icon),
            loading: $f349c866cfe057a1$var$noop
        }) : undefined, [
        item.icon
    ]);
    const onClick = ()=>{
        if (typeof item.action !== 'function') throw new Error(`'action' of context toolbar item '${item.key}' is not a function`);
        const targetNodeAdf = (0, $9Ssie.nodeToJSON)(node);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        item.action(targetNodeAdf, extensionApi);
    };
    const getAriaLabel = ()=>{
        if (item.ariaLabel) return item.ariaLabel;
        if (typeof item.tooltip === 'string') return item.tooltip;
        if (item.label) return item.label;
        return '';
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $knwdo.default), {
        title: item.label,
        ariaLabel: getAriaLabel(),
        icon: ButtonIcon ? /*#__PURE__*/ (0, $gt9Am.jsx)(ButtonIcon, {
            label: item.label || ''
        }) : undefined,
        onClick: onClick,
        tooltipContent: item.tooltip,
        tooltipStyle: item.tooltipStyle,
        disabled: item.disabled,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled,
        children: item.label
    });
};
const $f349c866cfe057a1$export$8bacfc8aacebb3c1 = (props)=>{
    const { node: node, editorView: editorView, extensionProvider: extensionProvider, separator: separator, applyChangeToContextPanel: applyChangeToContextPanel, extensionApi: extensionApi, scrollable: scrollable, setDisableScroll: setDisableScroll, dispatchCommand: dispatchCommand, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, alignDropdownWithToolbar: alignDropdownWithToolbar, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [extensions, setExtensions] = (0, $eJOHy.useState)([]);
    (0, $eJOHy.useEffect)(()=>{
        getExtensions();
        async function getExtensions() {
            const provider = await extensionProvider;
            if (provider) setExtensions(await provider.getExtensions());
        }
    // leaving dependencies array empty so that this effect runs just once on component mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const nodeAdf = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>(0, $9Ssie.nodeToJSON)(node), [
        node
    ]);
    const extensionItems = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return (0, $g3VjK.getContextualToolbarItemsFromModule)(extensions, nodeAdf, extensionApi);
    }, [
        extensions,
        nodeAdf,
        extensionApi
    ]);
    if (!extensionItems.length) return null;
    // ButtonGroup wraps each child with another layer
    // but count fragment as 1 child, so here we create the children manually.
    const children = [];
    if (separator && [
        'start',
        'both'
    ].includes(separator)) children.push(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $84CN8.default), {
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    }));
    const isNestedTable = (0, $eGOwo.fg)('platform_editor_use_nested_table_pm_nodes') && (0, $lQJJa.isSelectionTableNestedInTable)(editorView.state);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    extensionItems.forEach((item, index)=>{
        // disable the referentiality and charts extensions for nested tables
        if (isNestedTable && [
            'referentiality:connections',
            'chart:insert-chart'
        ].includes(item.key)) item.disabled = true;
        if ('type' in item && item.type === 'dropdown') children.push(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $9rPmE.default), {
            title: item.title,
            icon: item.icon,
            dispatchCommand: dispatchCommand || (()=>{}),
            options: item.options,
            disabled: item.disabled,
            tooltip: item.tooltip,
            hideExpandIcon: item.hideExpandIcon,
            mountPoint: popupsMountPoint,
            boundariesElement: popupsBoundariesElement,
            scrollableElement: popupsScrollableElement,
            dropdownWidth: item.dropdownWidth,
            showSelected: item.showSelected,
            buttonTestId: item.testId,
            editorView: editorView,
            setDisableParentScroll: scrollable ? setDisableScroll : undefined,
            dropdownListId: item?.id && `${item.id}-dropdownList`,
            alignDropdownWithToolbar: alignDropdownWithToolbar,
            onToggle: item.onToggle,
            footer: item.footer,
            onMount: item.onMount,
            onClick: item.onClick,
            pulse: item.pulse,
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }, item.id));
        else children.push(/*#__PURE__*/ (0, $gt9Am.jsx)($f349c866cfe057a1$var$ExtensionButton, {
            node: node,
            item: item,
            editorView: editorView,
            applyChangeToContextPanel: applyChangeToContextPanel,
            extensionApi: extensionApi,
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }));
        if (index < extensionItems.length - 1) children.push(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $84CN8.default), {
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }));
    });
    if (separator && [
        'end',
        'both'
    ].includes(separator)) children.push(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $84CN8.default), {
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    }));
    // eslint-disable-next-line react/no-children-prop
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $48q59.default), {
        children: children
    });
};

});
parcelRegister("lQJJa", function(module, exports) {
$parcel$export(module.exports, "getParentOfTypeCount", () => $2852433c0b4a990b$export$d5cbd8b17958f08b);
$parcel$export(module.exports, "getPositionAfterTopParentNodeOfType", () => $2852433c0b4a990b$export$ae584b8f0be37f04);
$parcel$export(module.exports, "isSelectionTableNestedInTable", () => $2852433c0b4a990b$export$3dd46fa6c35aa514);

var $kuDbA = parcelRequire("kuDbA");
const $2852433c0b4a990b$export$d5cbd8b17958f08b = (nodeType)=>($pos)=>{
        let count = 0;
        // Loop through parent nodes from bottom to top
        for(let depth = $pos.depth; depth > 0; depth--){
            const node = $pos.node(depth);
            // Count the table nodes
            if (node.type === nodeType) count++;
        }
        return count;
    };
const $2852433c0b4a990b$export$ae584b8f0be37f04 = (nodeType)=>($pos)=>{
        // Loop through parent nodes from top to bottom
        for(let depth = 1; depth <= $pos.depth; depth++){
            const node = $pos.node(depth);
            // Count the table nodes
            if (node.type === nodeType) return $pos.after(depth);
        }
    };
const $2852433c0b4a990b$export$3dd46fa6c35aa514 = (state)=>{
    const table = (0, $kuDbA.findTable)(state.selection);
    if (!table) return false;
    const parent = state.doc.resolve(table.pos).parent;
    const nodeTypes = state.schema.nodes;
    return [
        nodeTypes.tableHeader,
        nodeTypes.tableCell
    ].includes(parent.type);
};

});


parcelRegister("atGh8", function(module, exports) {
$parcel$export(module.exports, "Input", () => $9be98fd394942511$export$f5b8910cec6cf069);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $ierDl = parcelRequire("ierDl");
const $9be98fd394942511$export$f5b8910cec6cf069 = (props)=>{
    const { defaultValue: defaultValue, onBlur: onBlur, onSubmit: onSubmit, placeholder: placeholder } = props;
    const [text, setText] = (0, $eJOHy.useState)(defaultValue || '');
    const handleChange = (e)=>{
        setText(e.target.value);
    };
    const handleSubmit = (e)=>{
        e.preventDefault();
        onSubmit && onSubmit(text);
    };
    const handleBlur = (e)=>{
        e.preventDefault();
        onBlur && onBlur(text);
    };
    return /*#__PURE__*/ (0, $1NIU8.jsx)("form", {
        onSubmit: handleSubmit
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("input", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $ierDl.panelTextInput),
        value: text,
        onChange: handleChange,
        placeholder: placeholder,
        onBlur: handleBlur
    }));
};

});

parcelRegister("f989C", function(module, exports) {
$parcel$export(module.exports, "ScrollButton", () => $8eb4adbf5372b66a$export$93d01adc5582c83e);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");

var $bRPNB = parcelRequire("bRPNB");

var $Ay1uj = parcelRequire("Ay1uj");

var $jn2od = parcelRequire("jn2od");

var $a2JSB = parcelRequire("a2JSB");

var $1kTzc = parcelRequire("1kTzc");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $8eb4adbf5372b66a$var$rightSideStyles = (0, $1DXK0.xcss)({
    borderLeft: `solid ${"var(--ds-border, #091E4224)"} 1px`,
    right: 'space.0',
    borderTopRightRadius: 'radius.small',
    borderBottomRightRadius: 'radius.small'
});
const $8eb4adbf5372b66a$var$leftSideStyles = (0, $1DXK0.xcss)({
    borderRight: `solid ${"var(--ds-border, #091E4224)"} 1px`,
    left: 'space.0',
    borderTopLeftRadius: 'radius.small',
    borderBottomLeftRadius: 'radius.small'
});
const $8eb4adbf5372b66a$var$buttonCommonStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    zIndex: '1',
    position: 'absolute'
});
const $8eb4adbf5372b66a$export$93d01adc5582c83e = ({ intl: intl, scrollContainerRef: scrollContainerRef, node: node, disabled: disabled, side: side })=>{
    const [needScroll, setNeedScroll] = (0, $eJOHy.useState)(false);
    const [canScrollToSide, setCanScrollToSide] = (0, $eJOHy.useState)(true);
    const setCanScrollDebounced = (0, $bRPNB.default)(()=>{
        // Refs are null before mounting and after unmount
        if (!scrollContainerRef.current) return;
        const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, offsetWidth: offsetWidth } = scrollContainerRef.current;
        setCanScrollToSide(// -1 to account for pixel rounding error
        side === 'left' ? scrollLeft > 0 : scrollLeft < scrollWidth - offsetWidth - 1);
    });
    const onScroll = ()=>{
        setCanScrollDebounced();
    };
    const onClick = ()=>{
        const { width: scrollContainerWidth = 0 } = scrollContainerRef.current?.getBoundingClientRect() || {};
        const scrollLeft = scrollContainerRef.current?.scrollLeft || 0;
        const scrollTo = side === 'left' ? scrollLeft - scrollContainerWidth : scrollLeft + scrollContainerWidth;
        scrollContainerRef.current?.scrollTo({
            top: 0,
            left: scrollTo,
            behavior: 'smooth'
        });
    };
    const resizeObserver = new ResizeObserver((t)=>{
        const widthNeededToShowAllItems = scrollContainerRef.current?.scrollWidth || 0;
        const parentNode = scrollContainerRef.current?.parentNode;
        let availableSpace = -1;
        if (parentNode instanceof HTMLElement) availableSpace = parentNode.offsetWidth;
        if (availableSpace === -1) return;
        if (availableSpace >= widthNeededToShowAllItems) setNeedScroll(false);
        else {
            setNeedScroll(true);
            onScroll();
        }
    });
    (0, $eJOHy.useEffect)(()=>{
        onScroll();
        const scrollContainerRefCurrent = scrollContainerRef.current;
        let unbind;
        if (scrollContainerRefCurrent) {
            // Adding/removing scroll button depending on scroll position
            unbind = (0, $4eDgu.bind)(scrollContainerRefCurrent, {
                type: 'scroll',
                listener: onScroll
            });
            // watch for toolbar resize and show/hide scroll buttons if needed
            resizeObserver.observe(scrollContainerRefCurrent);
        }
        return ()=>{
            if (scrollContainerRefCurrent) {
                unbind?.();
                resizeObserver.unobserve(scrollContainerRefCurrent);
            }
            setCanScrollDebounced.cancel();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        const scrollContainerRefCurrent = scrollContainerRef.current;
        if (scrollContainerRefCurrent) // reset scroll position when switching from one node with toolbar to another
        // scroll to made optional as it may not be rendered in testing env
        scrollContainerRefCurrent.scrollTo?.({
            left: 0
        });
    }, [
        node.type,
        scrollContainerRef
    ]);
    const Icon = side === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($a2JSB))) : (0, (/*@__PURE__*/$parcel$interopDefault($1kTzc)));
    return needScroll && (side === 'left' && canScrollToSide || side === 'right' && canScrollToSide) && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        padding: "space.050",
        xcss: [
            side === 'left' ? $8eb4adbf5372b66a$var$leftSideStyles : $8eb4adbf5372b66a$var$rightSideStyles,
            $8eb4adbf5372b66a$var$buttonCommonStyles
        ],
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
            appearance: "subtle",
            label: intl.formatMessage(side === 'left' ? (0, $jn2od.default).floatingToolbarScrollLeft : (0, $jn2od.default).floatingToolbarScrollRight),
            onClick: onClick,
            isDisabled: disabled,
            icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                    label: iconProps.label,
                    size: "small"
                }),
            isTooltipDisabled: false,
            tooltip: {
                position: 'top'
            }
        })
    });
};

});

parcelRegister("jR93w", function(module, exports) {
$parcel$export(module.exports, "ScrollButtons", () => $b126502ed442fff1$export$154bc6e95efc5a0d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $bRPNB = parcelRequire("bRPNB");

var $jn2od = parcelRequire("jn2od");

var $knwdo = parcelRequire("knwdo");

var $a2JSB = parcelRequire("a2JSB");

var $1kTzc = parcelRequire("1kTzc");

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $b126502ed442fff1$var$toolbarScrollButtons = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: "var(--ds-space-050, 4px)",
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
    borderLeft: `solid ${`var(--ds-border, ${(0, $7bb4c1736002a04a$export$3e51e8f1440314ba)})`} 1px`,
    flexShrink: 0,
    alignItems: 'center'
});
const $b126502ed442fff1$var$LeftIcon = (0, (/*@__PURE__*/$parcel$interopDefault($a2JSB)));
const $b126502ed442fff1$var$RightIcon = (0, (/*@__PURE__*/$parcel$interopDefault($1kTzc)));
const $b126502ed442fff1$export$154bc6e95efc5a0d = ({ intl: intl, scrollContainerRef: scrollContainerRef, node: node, disabled: disabled, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    const buttonsContainerRef = (0, $eJOHy.useRef)(null);
    const [needScroll, setNeedScroll] = (0, $eJOHy.useState)(false);
    const [canScrollLeft, setCanScrollLeft] = (0, $eJOHy.useState)(true);
    const [canScrollRight, setCanScrollRight] = (0, $eJOHy.useState)(true);
    const setCanScrollDebounced = (0, $bRPNB.default)(()=>{
        // Refs are null before mounting and after unmount
        if (!scrollContainerRef.current) return;
        const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, offsetWidth: offsetWidth } = scrollContainerRef.current;
        setCanScrollLeft(scrollLeft > 0);
        setCanScrollRight(scrollLeft + offsetWidth < scrollWidth - 1); // -1 to account for half pixel
    });
    const onScroll = ()=>setCanScrollDebounced();
    const scrollLeft = ()=>{
        const { width: scrollContainerWidth = 0 } = scrollContainerRef.current?.getBoundingClientRect() || {};
        const scrollLeft = scrollContainerRef.current?.scrollLeft || 0;
        // scroll to current position - scroll container width
        const scrollTo = scrollLeft - scrollContainerWidth;
        scrollContainerRef.current?.scrollTo({
            top: 0,
            left: scrollTo,
            behavior: 'smooth'
        });
    };
    const scrollRight = ()=>{
        const { width: scrollContainerWidth = 0 } = scrollContainerRef.current?.getBoundingClientRect() || {};
        const scrollLeft = scrollContainerRef.current?.scrollLeft || 0;
        // scroll to current position + scroll container width
        const scrollTo = scrollLeft + scrollContainerWidth;
        scrollContainerRef.current?.scrollTo({
            top: 0,
            left: scrollTo,
            behavior: 'smooth'
        });
    };
    const resizeObserver = new ResizeObserver((t)=>{
        const widthNeededToShowAllItems = scrollContainerRef.current?.scrollWidth || 0;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const availableSpace = scrollContainerRef.current?.parentNode?.offsetWidth;
        if (availableSpace >= widthNeededToShowAllItems) setNeedScroll(false);
        else {
            setNeedScroll(true);
            onScroll();
        }
    });
    (0, $eJOHy.useEffect)(()=>{
        onScroll();
        const scrollContainerRefCurrent = scrollContainerRef.current;
        if (scrollContainerRefCurrent) {
            // enable/disable scroll buttons depending on scroll position
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            scrollContainerRefCurrent.addEventListener('scroll', onScroll);
            // watch for toolbar resize and show/hide scroll buttons if needed
            resizeObserver.observe(scrollContainerRefCurrent);
        }
        return ()=>{
            if (scrollContainerRefCurrent) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                scrollContainerRefCurrent.removeEventListener('scroll', onScroll);
                resizeObserver.unobserve(scrollContainerRefCurrent);
            }
            setCanScrollDebounced.cancel();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        const scrollContainerRefCurrent = scrollContainerRef.current;
        if (scrollContainerRefCurrent) // reset scroll position when switching from one node with toolbar to another
        // scroll to made optional as it may not be rendered in testing env
        scrollContainerRefCurrent.scrollTo?.({
            left: 0
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        node.type
    ]);
    return needScroll ? /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        ref: buttonsContainerRef,
        css: $b126502ed442fff1$var$toolbarScrollButtons,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "scroll-buttons"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $knwdo.default), {
        title: intl.formatMessage((0, $jn2od.default).floatingToolbarScrollLeft),
        icon: /*#__PURE__*/ (0, $1NIU8.jsx)($b126502ed442fff1$var$LeftIcon, {
            label: intl.formatMessage((0, $jn2od.default).floatingToolbarScrollLeft),
            size: "small"
        }),
        onClick: scrollLeft,
        disabled: !canScrollLeft || disabled,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    }), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $knwdo.default), {
        title: intl.formatMessage((0, $jn2od.default).floatingToolbarScrollRight),
        icon: /*#__PURE__*/ (0, $1NIU8.jsx)($b126502ed442fff1$var$RightIcon, {
            label: intl.formatMessage((0, $jn2od.default).floatingToolbarScrollRight),
            size: "small"
        }),
        onClick: scrollRight,
        disabled: !canScrollRight || disabled,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    })) : null;
};

});

parcelRegister("Svvcf", function(module, exports) {
$parcel$export(module.exports, "default", () => $3fd94a760bd1fdc5$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $c4OV1 = parcelRequire("c4OV1");
function $3fd94a760bd1fdc5$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const selectRef = (0, $eJOHy.useRef)(null);
    const { width: width = 200 } = props;
    const style = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>({
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            container: (base)=>({
                    ...base,
                    width: width
                }),
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            menuPortal: (base)=>{
                // ED:16095: We add two possible getter paths for safely reaching into the underlying
                // react-select element. We first try a getter that conforms with react-select v5 APIs,
                // Failing that, we try a getter consistent with react-select v4 APIs. (We
                // handle both as consumers may control the time of the actual dependency version
                // cutover).
                const controlWrapper = selectRef?.current?.select?.controlRef?.parentNode || selectRef?.current?.select?.select?.controlRef?.parentNode;
                const menuPortalStyles = controlWrapper && props.setDisableParentScroll ? {
                    // since the portal is now outside, we need to position it as before
                    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                    top: controlWrapper.offsetTop,
                    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                    left: controlWrapper.offsetLeft,
                    height: controlWrapper.offsetHeight,
                    width: width
                } : {};
                return {
                    ...base,
                    ...menuPortalStyles
                };
            }
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        width
    ]);
    const onMenuOpen = ()=>{
        if (props.setDisableParentScroll) props.setDisableParentScroll(true);
    };
    const onMenuClose = ()=>{
        if (props.setDisableParentScroll) props.setDisableParentScroll(false);
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c4OV1.default), {
        ref: selectRef,
        options: props.options,
        value: props.defaultValue,
        onChange: props.onChange,
        placeholder: props.placeholder,
        spacing: "compact",
        menuPlacement: "auto",
        filterOption: props.filterOption,
        styles: style,
        menuPortalTarget: props.mountPoint,
        onMenuOpen: onMenuOpen,
        onMenuClose: onMenuClose,
        label: props.ariaLabel,
        classNamePrefix: props.classNamePrefix
    });
}

});


parcelRegister("jFFUB", function(module, exports) {
$parcel$export(module.exports, "consolidateOverflowDropdownItems", () => $5a480ea441738f5f$export$2f5751d7b477f660);
const $5a480ea441738f5f$export$2f5751d7b477f660 = (overflowDropdowns)=>{
    if (overflowDropdowns.length <= 1) return overflowDropdowns[0];
    const combinedItems = overflowDropdowns.reduce((acc, item)=>{
        if (item.options) acc.push(...item.options);
        return acc;
    }, []);
    // To filter out items that have a rank property, sort them by rank in descending order (highest rank first)
    const rankedItems = combinedItems.filter((item)=>'rank' in item && typeof item.rank === 'number').sort((a, b)=>(b.rank || 0) - (a.rank || 0));
    const unrankedItems = combinedItems.filter((item)=>!('rank' in item && typeof item.rank === 'number'));
    const sortedItems = [
        ...rankedItems,
        ...unrankedItems
    ];
    const largestDropdownWidth = overflowDropdowns.reduce((acc, item)=>{
        if (item.dropdownWidth && item.dropdownWidth > acc) return item.dropdownWidth;
        return acc;
    }, 0);
    return {
        type: 'overflow-dropdown',
        dropdownWidth: largestDropdownWidth,
        options: sortedItems
    };
};

});



parcelRegister("9zBWD", function(module, exports) {
$parcel$export(module.exports, "insertBlockPlugin", () => (parcelRequire("bXi9c")).insertBlockPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $bXi9c = parcelRequire("bXi9c");

});
parcelRegister("bXi9c", function(module, exports) {
$parcel$export(module.exports, "insertBlockPlugin", () => $0805191a7c4ae040$export$b7df1817ade19df9);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $bMFKb = parcelRequire("bMFKb");

var $7vo9Y = parcelRequire("7vo9Y");

var $cxXTK = parcelRequire("cxXTK");

var $4sxxB = parcelRequire("4sxxB");

var $aBsWC = parcelRequire("aBsWC");

var $frlUM = parcelRequire("frlUM");

var $h16z0 = parcelRequire("h16z0");

var $eGOwo = parcelRequire("eGOwo");

var $92xoS = parcelRequire("92xoS");

var $2uBjc = parcelRequire("2uBjc");

var $5vkel = parcelRequire("5vkel");

var $2vb08 = parcelRequire("2vb08");
const $0805191a7c4ae040$export$7e87882fdef9bc6 = (toolbarSize, appearance)=>{
    // Different button numbers for full-page to better match full page toolbar breakpoints
    if (appearance === 'full-page' && (0, $eGOwo.fg)('platform_editor_toolbar_responsive_fixes')) switch(toolbarSize){
        case (0, $aBsWC.ToolbarSize).XXL:
        case (0, $aBsWC.ToolbarSize).XL:
        case (0, $aBsWC.ToolbarSize).L:
            return 7;
        case (0, $aBsWC.ToolbarSize).M:
            return 3;
        default:
            return 0;
    }
    if ((0, $eGOwo.fg)('platform_editor_toolbar_responsive_fixes')) switch(toolbarSize){
        case (0, $aBsWC.ToolbarSize).XXL:
        case (0, $aBsWC.ToolbarSize).XL:
            return 7;
        case (0, $aBsWC.ToolbarSize).L:
            return 5;
        case (0, $aBsWC.ToolbarSize).M:
        case (0, $aBsWC.ToolbarSize).S:
            return 2;
        default:
            return 0;
    }
    else switch(toolbarSize){
        case (0, $aBsWC.ToolbarSize).XXL:
        case (0, $aBsWC.ToolbarSize).XL:
        case (0, $aBsWC.ToolbarSize).L:
        case (0, $aBsWC.ToolbarSize).M:
            return 7;
        case (0, $aBsWC.ToolbarSize).S:
            return 2;
        default:
            return 0;
    }
};
/**
 * Wrapper over insertBlockTypeWithAnalytics to autobind toolbar input method
 * @param name Block name
 */ function $0805191a7c4ae040$var$handleInsertBlockType(insertCodeBlock, insertPanel, insertBlockQuote) {
    return (name)=>{
        if (name === (0, $h16z0.CODE_BLOCK).name && insertCodeBlock) return insertCodeBlock((0, $bMFKb.INPUT_METHOD).TOOLBAR);
        if (name === (0, $h16z0.PANEL).name && insertPanel) return insertPanel((0, $bMFKb.INPUT_METHOD).TOOLBAR);
        if (name === (0, $h16z0.BLOCK_QUOTE).name && insertBlockQuote) return insertBlockQuote((0, $bMFKb.INPUT_METHOD).INSERT_MENU);
        return ()=>false;
    };
}
function $0805191a7c4ae040$var$delayUntilIdle(cb) {
    if (typeof window === 'undefined') return;
    // eslint-disable-next-line compat/compat
    if (window.requestIdleCallback !== undefined) // eslint-disable-next-line compat/compat
    return window.requestIdleCallback(()=>cb(), {
        timeout: 500
    });
    return window.requestAnimationFrame(()=>cb());
}
const $0805191a7c4ae040$export$b7df1817ade19df9 = ({ config: options = {}, api: api })=>{
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const primaryToolbarComponent = ({ editorView: editorView, editorActions: editorActions, dispatchAnalyticsEvent: dispatchAnalyticsEvent, providerFactory: providerFactory, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, isLastItem: isLastItem })=>{
        const renderNode = (providers)=>{
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $gt9Am.jsx)($0805191a7c4ae040$var$ToolbarInsertBlockWithInjectionApi, {
                pluginInjectionApi: api,
                editorView: editorView,
                editorActions: editorActions,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                providerFactory: providerFactory,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                toolbarSize: toolbarSize,
                disabled: disabled,
                isToolbarReducedSpacing: isToolbarReducedSpacing,
                isLastItem: isLastItem,
                providers: providers,
                options: options,
                appearance: options.appearance
            });
        };
        if ((0, $92xoS.editorExperiment)('platform_editor_prevent_toolbar_layout_shifts', true)) {
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $gt9Am.jsx)($0805191a7c4ae040$var$ToolbarInsertBlockWithInjectionApi, {
                pluginInjectionApi: api,
                editorView: editorView,
                editorActions: editorActions,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                providerFactory: providerFactory,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                toolbarSize: toolbarSize,
                disabled: disabled,
                isToolbarReducedSpacing: isToolbarReducedSpacing,
                isLastItem: isLastItem,
                options: options,
                appearance: options.appearance
            });
        }
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4sxxB.WithProviders), {
            providerFactory: providerFactory,
            providers: [
                'emojiProvider'
            ],
            renderNode: renderNode
        });
    };
    if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $5vkel.getToolbarComponents)({
        api: api,
        onInsertBlockType: $0805191a7c4ae040$var$handleInsertBlockType(api?.codeBlock?.actions.insertCodeBlock, api?.panel?.actions.insertPanel, api?.blockType?.actions.insertBlockQuote),
        options: options
    }));
    else api?.primaryToolbar?.actions.registerComponent({
        name: 'insertBlock',
        component: primaryToolbarComponent
    });
    const plugin = {
        name: 'insertBlock',
        actions: {
            toggleAdditionalMenu: ()=>{
                api?.core?.actions.execute(({ tr: tr })=>{
                    return tr.setMeta((0, $2uBjc.toggleInsertBlockPmKey), true);
                });
            }
        },
        getSharedState: (editorState)=>{
            if (!editorState || ![
                'full-page',
                'full-width'
            ].includes(options.appearance ?? '')) return;
            const toggleInsertBlockPluginState = (0, $2uBjc.toggleInsertBlockPmKey).getState(editorState);
            return {
                showElementBrowser: toggleInsertBlockPluginState?.showElementBrowser || false
            };
        },
        usePluginHook () {
            (0, $eJOHy.useEffect)(()=>{
                // This is to optimise the UI so that when the user first clicks on the insert
                // menu it opens instantly. As we're delaying the loading this won't affect the
                // initial editor rendering metrics.
                $0805191a7c4ae040$var$delayUntilIdle(()=>{
                    (0, $7vo9Y.default).preload();
                });
            }, []);
        },
        pmPlugins: ()=>{
            [
                'full-page',
                'full-width'
            ].includes(options.appearance ?? '');
            const plugins = [];
            plugins.push({
                name: 'toggleInsertBlockPmPlugin',
                plugin: ()=>(0, $2uBjc.toggleInsertBlockPmPlugin)()
            });
            return plugins;
        },
        pluginsOptions: {},
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined
    };
    return plugin;
};
const $0805191a7c4ae040$var$selector = (states)=>{
    return {
        emojiProviderSelector: states.emojiState?.emojiProvider,
        showMediaPicker: states.mediaState?.showMediaPicker,
        mediaAllowsUploads: states.mediaState?.allowsUploads,
        showElementBrowser: states.insertBlockState?.showElementBrowser,
        isTypeAheadAllowed: states.typeAheadState?.isAllowed,
        mentionProvider: states.mentionState?.mentionProvider,
        canInsertMention: states.mentionState?.canInsertMention,
        dateEnabled: states.dateState?.isInitialised,
        placeholderTextAllowInserting: states.placeholderTextState?.allowInserting,
        connectivityMode: states.connectivityState?.mode,
        imageUploadEnabled: states.imageUploadState?.enabled,
        availableWrapperBlockTypes: states.blockTypeState?.availableWrapperBlockTypes,
        canInsertLink: states.hyperlinkState?.canInsertLink,
        activeLinkMark: states.hyperlinkState?.activeLinkMark
    };
};
function $0805191a7c4ae040$var$ToolbarInsertBlockWithInjectionApi({ editorView: editorView, editorActions: editorActions, dispatchAnalyticsEvent: dispatchAnalyticsEvent, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, isLastItem: isLastItem, pluginInjectionApi: pluginInjectionApi, options: options, appearance: appearance }) {
    const buttons = $0805191a7c4ae040$export$7e87882fdef9bc6(toolbarSize, appearance);
    const { emojiProviderSelector: emojiProviderSelector, showMediaPicker: showMediaPicker, mediaAllowsUploads: mediaAllowsUploads, showElementBrowser: showElementBrowser, isTypeAheadAllowed: isTypeAheadAllowed, mentionProvider: mentionProvider, canInsertMention: canInsertMention, dateEnabled: dateEnabled, placeholderTextAllowInserting: placeholderTextAllowInserting, connectivityMode: connectivityMode, imageUploadEnabled: imageUploadEnabled, availableWrapperBlockTypes: availableWrapperBlockTypes, canInsertLink: canInsertLink, activeLinkMark: activeLinkMark } = (0, $cxXTK.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'hyperlink',
        'date',
        'imageUpload',
        'mention',
        'emoji',
        'blockType',
        'media',
        'typeAhead',
        'placeholderText',
        'insertBlock',
        'connectivity'
    ], $0805191a7c4ae040$var$selector);
    const emojiProviderPromise = (0, $frlUM.useSharedPluginStateSelector)(pluginInjectionApi, 'emoji.emojiProviderPromise', {
        disabled: !(0, $92xoS.editorExperiment)('platform_editor_prevent_toolbar_layout_shifts', true)
    });
    const getEmojiProvider = ()=>{
        if (emojiProviderSelector) return Promise.resolve(emojiProviderSelector);
    };
    const emojiProvider = (0, $92xoS.editorExperiment)('platform_editor_prevent_toolbar_layout_shifts', true, {
        exposure: true
    }) ? emojiProviderPromise : getEmojiProvider();
    const onShowMediaPicker = (mountInfo)=>{
        if (!showMediaPicker) return;
        pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.mediaInsert?.commands.showMediaInsertPopup(mountInfo));
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2vb08.default), {
        showElementBrowser: showElementBrowser || false,
        pluginInjectionApi: pluginInjectionApi,
        buttons: buttons,
        isReducedSpacing: isToolbarReducedSpacing,
        isDisabled: disabled,
        isTypeAheadAllowed: Boolean(isTypeAheadAllowed),
        editorView: editorView,
        tableSupported: !!editorView.state.schema.nodes.table,
        tableSelectorSupported: options.tableSelectorSupported && !!editorView.state.schema.nodes.table,
        actionSupported: !!editorView.state.schema.nodes.taskItem,
        mentionsSupported: !!mentionProvider,
        mentionsDisabled: !canInsertMention,
        decisionSupported: !!editorView.state.schema.nodes.decisionItem,
        dateEnabled: !!dateEnabled,
        placeholderTextEnabled: !!placeholderTextAllowInserting,
        layoutSectionEnabled: Boolean(pluginInjectionApi?.layout),
        expandEnabled: !!options.allowExpand,
        mediaUploadsEnabled: mediaAllowsUploads ?? undefined,
        onShowMediaPicker: onShowMediaPicker,
        mediaSupported: mediaAllowsUploads !== undefined,
        isEditorOffline: connectivityMode === 'offline',
        imageUploadSupported: !!pluginInjectionApi?.imageUpload,
        imageUploadEnabled: imageUploadEnabled,
        handleImageUpload: pluginInjectionApi?.imageUpload?.actions.startUpload,
        availableWrapperBlockTypes: availableWrapperBlockTypes,
        linkSupported: canInsertLink !== undefined,
        linkDisabled: !canInsertLink || !!activeLinkMark,
        emojiDisabled: !emojiProvider,
        emojiProvider: emojiProvider,
        nativeStatusSupported: options.nativeStatusSupported,
        horizontalRuleEnabled: options.horizontalRuleEnabled,
        onInsertBlockType: $0805191a7c4ae040$var$handleInsertBlockType(pluginInjectionApi?.codeBlock?.actions.insertCodeBlock, pluginInjectionApi?.panel?.actions.insertPanel, pluginInjectionApi?.blockType?.actions.insertBlockQuote),
        onInsertMacroFromMacroBrowser: pluginInjectionApi?.extension?.actions.insertMacroFromMacroBrowser,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        insertMenuItems: options.insertMenuItems,
        editorActions: editorActions,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        showElementBrowserLink: options.showElementBrowserLink,
        showSeparator: !isLastItem && toolbarSize <= (0, $aBsWC.ToolbarSize).S,
        editorAppearance: options.appearance
    });
}

});
parcelRegister("7vo9Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $a15e3d18a09f5714$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $joSn0 = parcelRequire("joSn0");

var $7ep4S = parcelRequire("7ep4S");
function $a15e3d18a09f5714$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a15e3d18a09f5714$var$spinnerContainer = {
    name: "c1gsw5",
    styles: "display:flex;align-items:center;justify-content:center;height:100%;width:100%"
};

const $a15e3d18a09f5714$var$ElementBrowserLoader = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("1hpra")).then((module)=>module.default),
    loading: ()=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $a15e3d18a09f5714$var$spinnerContainer
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $7ep4S.default), {
            size: "medium",
            interactionName: "element-browser-spinner"
        }))
});
var $a15e3d18a09f5714$export$2e2bcd8739ae039 = $a15e3d18a09f5714$var$ElementBrowserLoader;

});
parcelRegister("1hpra", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("gGRLk")
]).then(()=>parcelRequire('f7iIq'));

});


parcelRegister("2uBjc", function(module, exports) {
$parcel$export(module.exports, "toggleInsertBlockPmKey", () => $44c60165ef0568d0$export$fef912314604ae84);
$parcel$export(module.exports, "toggleInsertBlockPmPlugin", () => $44c60165ef0568d0$export$6f80226cf0aae60e);

var $i8KtF = parcelRequire("i8KtF");

var $3lIcL = parcelRequire("3lIcL");
const $44c60165ef0568d0$export$fef912314604ae84 = new (0, $3lIcL.PluginKey)('toggleInsertBlockPmKey');
const $44c60165ef0568d0$export$6f80226cf0aae60e = ()=>new (0, $i8KtF.SafePlugin)({
        key: $44c60165ef0568d0$export$fef912314604ae84,
        state: {
            init () {
                return {
                    showElementBrowser: false
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($44c60165ef0568d0$export$fef912314604ae84);
                if (!meta) return pluginState;
                return {
                    showElementBrowser: !pluginState.showElementBrowser
                };
            }
        }
    });

});

parcelRegister("5vkel", function(module, exports) {
$parcel$export(module.exports, "getToolbarComponents", () => $e0aeeae6f6aad9c1$export$a758406ca53b86a5);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $3KjUM = parcelRequire("3KjUM");
var $6996L = parcelRequire("6996L");

var $f893H = parcelRequire("f893H");
var $1ZfmT = parcelRequire("1ZfmT");

var $cbSL1 = parcelRequire("cbSL1");

var $31M9c = parcelRequire("31M9c");

var $jw1o8 = parcelRequire("jw1o8");

var $7UX6h = parcelRequire("7UX6h");

var $9JNZ7 = parcelRequire("9JNZ7");

var $lO1OX = parcelRequire("lO1OX");

var $gvHa0 = parcelRequire("gvHa0");

var $cpz21 = parcelRequire("cpz21");

var $1reWu = parcelRequire("1reWu");

var $iECnl = parcelRequire("iECnl");

var $cwtLJ = parcelRequire("cwtLJ");

var $5jQsy = parcelRequire("5jQsy");
const $e0aeeae6f6aad9c1$export$a758406ca53b86a5 = ({ api: api, options: options, onInsertBlockType: onInsertBlockType })=>{
    const config = (0, $jw1o8.resolveToolbarConfig)(options);
    const components = [];
    // Helper function to create responsive wrapper component
    const createResponsiveComponent = ()=>{
        return (0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_responsive', 'isEnabled', true) ? ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $f893H.Show), {
                above: "lg",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1ZfmT.ToolbarButtonGroup), {
                    children: children
                })
            }) : undefined;
    };
    // TaskList Group
    if (config.taskList?.enabled) {
        components.push({
            type: (0, $3KjUM.TASK_LIST_GROUP).type,
            key: (0, $3KjUM.TASK_LIST_GROUP).key,
            parents: [
                {
                    type: (0, $3KjUM.INSERT_BLOCK_SECTION).type,
                    key: (0, $3KjUM.INSERT_BLOCK_SECTION).key,
                    rank: (0, $6996L.INSERT_BLOCK_SECTION_RANK)[(0, $3KjUM.TASK_LIST_GROUP).key]
                }
            ],
            component: createResponsiveComponent()
        });
        components.push({
            type: (0, $3KjUM.TASK_LIST_BUTTON).type,
            key: (0, $3KjUM.TASK_LIST_BUTTON).key,
            parents: [
                {
                    type: (0, $3KjUM.TASK_LIST_GROUP).type,
                    key: (0, $3KjUM.TASK_LIST_GROUP).key,
                    rank: (0, $6996L.TASK_LIST_GROUP_RANK)[(0, $3KjUM.TASK_LIST_BUTTON).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $5jQsy.TaskListButton), {
                    api: api
                })
        });
    }
    // Media Group
    if (config.media?.enabled) {
        components.push({
            type: (0, $3KjUM.MEDIA_GROUP).type,
            key: (0, $3KjUM.MEDIA_GROUP).key,
            parents: [
                {
                    type: (0, $3KjUM.INSERT_BLOCK_SECTION).type,
                    key: (0, $3KjUM.INSERT_BLOCK_SECTION).key,
                    rank: (0, $6996L.INSERT_BLOCK_SECTION_RANK)[(0, $3KjUM.MEDIA_GROUP).key]
                }
            ],
            component: createResponsiveComponent()
        });
        components.push({
            type: (0, $3KjUM.MEDIA_BUTTON).type,
            key: (0, $3KjUM.MEDIA_BUTTON).key,
            parents: [
                {
                    type: (0, $3KjUM.MEDIA_GROUP).type,
                    key: (0, $3KjUM.MEDIA_GROUP).key,
                    rank: (0, $6996L.MEDIA_GROUP_RANK)[(0, $3KjUM.MEDIA_BUTTON).key]
                }
            ],
            component: ()=>!!api?.imageUpload ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9JNZ7.ImageButton), {
                    api: api
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cpz21.MediaButton), {
                    api: api
                })
        });
    }
    // CodeBlock Group
    if (config.codeBlock?.enabled) {
        components.push({
            type: (0, $3KjUM.CODE_BLOCK_GROUP).type,
            key: (0, $3KjUM.CODE_BLOCK_GROUP).key,
            parents: [
                {
                    type: (0, $3KjUM.INSERT_BLOCK_SECTION).type,
                    key: (0, $3KjUM.INSERT_BLOCK_SECTION).key,
                    rank: (0, $6996L.INSERT_BLOCK_SECTION_RANK)[(0, $3KjUM.CODE_BLOCK_GROUP).key]
                }
            ],
            component: createResponsiveComponent()
        });
        components.push({
            type: (0, $3KjUM.CODE_BLOCK_BUTTON).type,
            key: (0, $3KjUM.CODE_BLOCK_BUTTON).key,
            parents: [
                {
                    type: (0, $3KjUM.CODE_BLOCK_GROUP).type,
                    key: (0, $3KjUM.CODE_BLOCK_GROUP).key,
                    rank: (0, $6996L.CODE_BLOCK_GROUP_RANK)[(0, $3KjUM.CODE_BLOCK_BUTTON).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $31M9c.CodeBlockButton), {
                    api: api
                })
        });
    }
    // Mention Group
    if (config.mention?.enabled) {
        components.push({
            type: (0, $3KjUM.MENTION_GROUP).type,
            key: (0, $3KjUM.MENTION_GROUP).key,
            parents: [
                {
                    type: (0, $3KjUM.INSERT_BLOCK_SECTION).type,
                    key: (0, $3KjUM.INSERT_BLOCK_SECTION).key,
                    rank: (0, $6996L.INSERT_BLOCK_SECTION_RANK)[(0, $3KjUM.MENTION_GROUP).key]
                }
            ],
            component: createResponsiveComponent()
        });
        components.push({
            type: (0, $3KjUM.MENTION_BUTTON).type,
            key: (0, $3KjUM.MENTION_BUTTON).key,
            parents: [
                {
                    type: (0, $3KjUM.MENTION_GROUP).type,
                    key: (0, $3KjUM.MENTION_GROUP).key,
                    rank: (0, $6996L.MENTION_GROUP_RANK)[(0, $3KjUM.MENTION_BUTTON).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $1reWu.MentionButton), {
                    api: api
                })
        });
    }
    // Emoji Group
    if (config.emoji?.enabled) {
        components.push({
            type: (0, $3KjUM.EMOJI_GROUP).type,
            key: (0, $3KjUM.EMOJI_GROUP).key,
            parents: [
                {
                    type: (0, $3KjUM.INSERT_BLOCK_SECTION).type,
                    key: (0, $3KjUM.INSERT_BLOCK_SECTION).key,
                    rank: (0, $6996L.INSERT_BLOCK_SECTION_RANK)[(0, $3KjUM.EMOJI_GROUP).key]
                }
            ],
            component: createResponsiveComponent()
        });
        components.push({
            type: (0, $3KjUM.EMOJI_BUTTON).type,
            key: (0, $3KjUM.EMOJI_BUTTON).key,
            parents: [
                {
                    type: (0, $3KjUM.EMOJI_GROUP).type,
                    key: (0, $3KjUM.EMOJI_GROUP).key,
                    rank: (0, $6996L.EMOJI_GROUP_RANK)[(0, $3KjUM.EMOJI_BUTTON).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $7UX6h.EmojiButton), {
                    api: api
                })
        });
    }
    // Layout Group
    if (config.layout?.enabled) {
        components.push({
            type: (0, $3KjUM.LAYOUT_GROUP).type,
            key: (0, $3KjUM.LAYOUT_GROUP).key,
            parents: [
                {
                    type: (0, $3KjUM.INSERT_BLOCK_SECTION).type,
                    key: (0, $3KjUM.INSERT_BLOCK_SECTION).key,
                    rank: (0, $6996L.INSERT_BLOCK_SECTION_RANK)[(0, $3KjUM.LAYOUT_GROUP).key]
                }
            ],
            component: createResponsiveComponent()
        });
        components.push({
            type: (0, $3KjUM.LAYOUT_BUTTON).type,
            key: (0, $3KjUM.LAYOUT_BUTTON).key,
            parents: [
                {
                    type: (0, $3KjUM.LAYOUT_GROUP).type,
                    key: (0, $3KjUM.LAYOUT_GROUP).key,
                    rank: (0, $6996L.LAYOUT_GROUP_RANK)[(0, $3KjUM.LAYOUT_BUTTON).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $gvHa0.LayoutButton), {
                    api: api
                })
        });
    }
    // Table Group
    if (config.table?.enabled) {
        components.push({
            type: (0, $3KjUM.TABLE_GROUP).type,
            key: (0, $3KjUM.TABLE_GROUP).key,
            parents: [
                {
                    type: (0, $3KjUM.INSERT_BLOCK_SECTION).type,
                    key: (0, $3KjUM.INSERT_BLOCK_SECTION).key,
                    rank: (0, $6996L.INSERT_BLOCK_SECTION_RANK)[(0, $3KjUM.TABLE_GROUP).key]
                }
            ],
            component: createResponsiveComponent()
        });
        components.push({
            type: (0, $3KjUM.TABLE_BUTTON).type,
            key: (0, $3KjUM.TABLE_BUTTON).key,
            parents: [
                {
                    type: (0, $3KjUM.TABLE_GROUP).type,
                    key: (0, $3KjUM.TABLE_GROUP).key,
                    rank: (0, $6996L.TABLE_GROUP_RANK)[(0, $3KjUM.TABLE_BUTTON).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $iECnl.TableButton), {
                    api: api
                })
        });
        if (options.tableSelectorSupported) components.push({
            type: (0, $3KjUM.TABLE_SIZE_PICKER).type,
            key: (0, $3KjUM.TABLE_SIZE_PICKER).key,
            parents: [
                {
                    type: (0, $3KjUM.TABLE_GROUP).type,
                    key: (0, $3KjUM.TABLE_GROUP).key,
                    rank: (0, $6996L.TABLE_GROUP_RANK)[(0, $3KjUM.TABLE_SIZE_PICKER).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $cwtLJ.TableSizePicker), {
                    api: api,
                    tableSelectorSupported: options.tableSelectorSupported
                })
        });
    }
    // Insert Group
    if (config.insert?.enabled) {
        components.push({
            type: (0, $3KjUM.INSERT_GROUP).type,
            key: (0, $3KjUM.INSERT_GROUP).key,
            parents: [
                {
                    type: (0, $3KjUM.INSERT_BLOCK_SECTION).type,
                    key: (0, $3KjUM.INSERT_BLOCK_SECTION).key,
                    rank: (0, $6996L.INSERT_BLOCK_SECTION_RANK)[(0, $3KjUM.INSERT_GROUP).key]
                }
            ]
        });
        components.push({
            type: (0, $3KjUM.INSERT_BUTTON).type,
            key: (0, $3KjUM.INSERT_BUTTON).key,
            parents: [
                {
                    type: (0, $3KjUM.INSERT_GROUP).type,
                    key: (0, $3KjUM.INSERT_GROUP).key,
                    rank: (0, $6996L.INSERT_GROUP_RANK)[(0, $3KjUM.INSERT_BUTTON).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $lO1OX.InsertButton), {
                    api: api,
                    showElementBrowserLink: options.showElementBrowserLink,
                    tableSelectorSupported: options.tableSelectorSupported,
                    onInsertBlockType: onInsertBlockType,
                    nativeStatusSupported: options.nativeStatusSupported,
                    horizontalRuleEnabled: options.horizontalRuleEnabled,
                    expandEnabled: options.allowExpand,
                    insertMenuItems: options.insertMenuItems,
                    numberOfButtons: 7
                })
        });
    }
    return components;
};

});
parcelRegister("31M9c", function(module, exports) {
$parcel$export(module.exports, "CodeBlockButton", () => $d50686cc47dbd675$export$f18e402f09bee3a1);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bMFKb = parcelRequire("bMFKb");

var $6Exgk = parcelRequire("6Exgk");

var $TgnAJ = parcelRequire("TgnAJ");

var $c0YTT = parcelRequire("c0YTT");

var $8lO5P = parcelRequire("8lO5P");
var $aDNj8 = parcelRequire("aDNj8");
var $64R2q = parcelRequire("64R2q");
const $d50686cc47dbd675$export$f18e402f09bee3a1 = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { editorView: editorView } = (0, $c0YTT.useEditorToolbar)();
    if (!api?.codeBlock) return null;
    const onClick = ()=>{
        if (editorView) api?.codeBlock?.actions.insertCodeBlock((0, $bMFKb.INPUT_METHOD).TOOLBAR)(editorView.state, editorView.dispatch);
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $64R2q.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6Exgk.ToolTipContent), {
            description: formatMessage((0, $TgnAJ.messages).codeblock),
            keymap: (0, $6Exgk.toggleCodeBlock)
        }),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aDNj8.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8lO5P))), {
                label: formatMessage((0, $TgnAJ.messages).codeblock),
                size: "small"
            }),
            onClick: onClick,
            ariaKeyshortcuts: (0, $6Exgk.getAriaKeyshortcuts)((0, $6Exgk.toggleCodeBlock))
        })
    });
};

});

parcelRegister("jw1o8", function(module, exports) {
$parcel$export(module.exports, "resolveToolbarConfig", () => $f009d7beea5b9581$export$ab4e2221b4885da5);
const $f009d7beea5b9581$export$ab4e2221b4885da5 = (options)=>{
    // Handle backward compatibility: toolbarShowPlusInsertOnly
    if (options.toolbarShowPlusInsertOnly) return {
        codeBlock: {
            enabled: false
        },
        emoji: {
            enabled: false
        },
        insert: {
            enabled: true
        },
        layout: {
            enabled: false
        },
        media: {
            enabled: false
        },
        mention: {
            enabled: false
        },
        table: {
            enabled: false
        },
        taskList: {
            enabled: false
        }
    };
    if (!options.toolbarButtons) // disable code block by default if there's no toolbarButtons options provided, e.g on full page editor
    return {
        codeBlock: {
            enabled: false
        },
        emoji: {
            enabled: true
        },
        insert: {
            enabled: true
        },
        layout: {
            enabled: true
        },
        media: {
            enabled: true
        },
        mention: {
            enabled: true
        },
        table: {
            enabled: true
        },
        taskList: {
            enabled: true
        }
    };
    const defaults = {
        enabled: false
    };
    const resolveGroupConfig = (groupConfig)=>{
        return {
            enabled: groupConfig?.enabled ?? defaults.enabled
        };
    };
    return {
        codeBlock: resolveGroupConfig(options.toolbarButtons?.codeBlock),
        emoji: resolveGroupConfig(options.toolbarButtons?.emoji),
        insert: resolveGroupConfig(options.toolbarButtons?.insert),
        layout: resolveGroupConfig(options.toolbarButtons?.layout),
        media: resolveGroupConfig(options.toolbarButtons?.media),
        mention: resolveGroupConfig(options.toolbarButtons?.mention),
        table: resolveGroupConfig(options.toolbarButtons?.table),
        taskList: resolveGroupConfig(options.toolbarButtons?.taskList)
    };
};

});

parcelRegister("7UX6h", function(module, exports) {
$parcel$export(module.exports, "EmojiButton", () => $63bb7f1938b2b397$export$e6ce3311a4d41b7f);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $cxXTK = parcelRequire("cxXTK");

var $6Exgk = parcelRequire("6Exgk");

var $46A2h = parcelRequire("46A2h");

var $euu4D = parcelRequire("euu4D");
var $aDNj8 = parcelRequire("aDNj8");
var $64R2q = parcelRequire("64R2q");
var $7K3rS = parcelRequire("7K3rS");

var $cbSL1 = parcelRequire("cbSL1");

var $5MbKe = parcelRequire("5MbKe");

var $9mNrI = parcelRequire("9mNrI");
const $63bb7f1938b2b397$export$e6ce3311a4d41b7f = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const emojiButtonRef = (0, $eJOHy.useRef)(null);
    const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement } = (0, $7K3rS.useToolbarUI)();
    const { emojiProviderSelector: emojiProviderSelector, emojiProviderPromise: emojiProviderPromise, isTypeAheadAllowed: isTypeAheadAllowed } = (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'emoji',
        'typeAhead'
    ], (states)=>({
            emojiProviderSelector: states.emojiState?.emojiProvider,
            emojiProviderPromise: states.emojiState?.emojiProviderPromise,
            isTypeAheadAllowed: states.typeAheadState?.isAllowed
        }));
    const emojiPickerPopup = (0, $5MbKe.useEmojiPickerPopup)({
        api: api,
        buttonRef: emojiButtonRef
    });
    if (!api?.emoji) return null;
    const getEmojiProvider = ()=>{
        if (emojiProviderSelector) return Promise.resolve(emojiProviderSelector);
    };
    const emojiProvider = (0, $cbSL1.expValEquals)('platform_editor_prevent_toolbar_layout_shifts', 'isEnabled', true) ? emojiProviderPromise : getEmojiProvider();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9mNrI.EmojiPickerPopup), {
                isOpen: emojiPickerPopup.isOpen,
                targetRef: emojiButtonRef,
                emojiProvider: emojiProvider,
                onSelection: emojiPickerPopup.handleSelectedEmoji,
                onClickOutside: emojiPickerPopup.handleClickOutside,
                onEscapeKeydown: emojiPickerPopup.handleEscapeKeydown,
                onUnmount: emojiPickerPopup.onPopupUnmount,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $64R2q.ToolbarTooltip), {
                content: (0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6Exgk.ToolTipContent), {
                    description: formatMessage((0, $46A2h.toolbarInsertBlockMessages).emoji),
                    keymap: (0, $6Exgk.insertEmoji)
                }) : formatMessage((0, $46A2h.toolbarInsertBlockMessages).emoji),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aDNj8.ToolbarButton), {
                    iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($euu4D))), {
                        label: formatMessage((0, $46A2h.toolbarInsertBlockMessages).emoji),
                        size: "small"
                    }),
                    ariaKeyshortcuts: "Shift+;",
                    ref: emojiButtonRef,
                    onClick: ()=>emojiPickerPopup.toggle(),
                    isSelected: emojiPickerPopup.isOpen,
                    isDisabled: !isTypeAheadAllowed || !emojiProvider
                })
            })
        ]
    });
};

});
parcelRegister("euu4D", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1c30d577c7234bb5109e7b6cea91ee6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a8cb3213f8552b4b$var$_react = $a8cb3213f8552b4b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a8cb3213f8552b4b$var$_baseNew = $a8cb3213f8552b4b$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $a8cb3213f8552b4b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Emoji".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Editor as a category for Emoji's.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a8cb3213f8552b4b$var$EmojiIcon = (props)=>/*#__PURE__*/ $a8cb3213f8552b4b$var$_react.default.createElement($a8cb3213f8552b4b$var$_baseNew.default, Object.assign({
        name: "EmojiIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m4.5-1.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m4.5 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m-2.915 3.783c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .721-.714l.005-.007-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513" clip-rule="evenodd"/>`
    }, props));
$a8cb3213f8552b4b$var$EmojiIcon.displayName = 'EmojiIcon';
var $a8cb3213f8552b4b$var$_default = module.exports.default = $a8cb3213f8552b4b$var$EmojiIcon;

});

parcelRegister("5MbKe", function(module, exports) {
$parcel$export(module.exports, "useEmojiPickerPopup", () => $c4a7c4d2fa5ac919$export$906c13b7666cd621);

var $eJOHy = parcelRequire("eJOHy");

var $bMFKb = parcelRequire("bMFKb");

var $cjeKO = parcelRequire("cjeKO");
const $c4a7c4d2fa5ac919$export$906c13b7666cd621 = ({ api: api, buttonRef: buttonRef })=>{
    const popupManager = (0, $cjeKO.usePopupManager)({
        focusTarget: buttonRef,
        analytics: {
            onToggle: (isOpen)=>{
                if (isOpen) api?.analytics?.actions.fireAnalyticsEvent({
                    action: (0, $bMFKb.ACTION).OPENED,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).PICKER,
                    actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).PICKER_EMOJI,
                    attributes: {
                        inputMethod: (0, $bMFKb.INPUT_METHOD).TOOLBAR
                    },
                    eventType: (0, $bMFKb.EVENT_TYPE).UI
                });
            }
        }
    });
    const handleSelectedEmoji = (0, $eJOHy.useCallback)((emojiId)=>{
        api?.core.actions.focus();
        api?.core.actions.execute(api?.emoji?.commands.insertEmoji(emojiId, (0, $bMFKb.INPUT_METHOD).PICKER));
        popupManager.close();
        return true;
    }, [
        api,
        popupManager
    ]);
    const onPopupUnmount = (0, $eJOHy.useCallback)(()=>{
        requestAnimationFrame(()=>api?.core.actions.focus());
    }, [
        api
    ]);
    return {
        ...popupManager,
        handleSelectedEmoji: handleSelectedEmoji,
        onPopupUnmount: onPopupUnmount
    };
};

});
parcelRegister("cjeKO", function(module, exports) {
$parcel$export(module.exports, "usePopupManager", () => $694997e5f1896d72$export$7db65f41c8758d11);

var $eJOHy = parcelRequire("eJOHy");

var $9cXof = parcelRequire("9cXof");
const $694997e5f1896d72$export$7db65f41c8758d11 = (config = {})=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const [isOpenedByKeyboard, setIsOpenedByKeyboard] = (0, $eJOHy.useState)(false);
    const toggle = (0, $eJOHy.useCallback)((inputMethod)=>{
        const newState = !isOpen;
        setIsOpen(newState);
        if (newState) config.onOpen?.(inputMethod);
        else config.onClose?.();
        config.analytics?.onToggle?.(newState, inputMethod);
    }, [
        isOpen,
        config
    ]);
    const close = (0, $eJOHy.useCallback)(()=>{
        setIsOpen(false);
        config.onClose?.();
        config.analytics?.onToggle?.(false);
    }, [
        config
    ]);
    const handleEscapeKeydown = (0, $eJOHy.useCallback)(()=>{
        close();
        config.focusTarget?.current?.focus();
    }, [
        close,
        config.focusTarget
    ]);
    const handleClickOutside = (0, $eJOHy.useCallback)((e)=>{
        if (e.target instanceof HTMLElement && !(0, $9cXof.isDetachedElement)(e.target)) close();
    }, [
        close
    ]);
    const handleKeyboardOpen = (0, $eJOHy.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            setIsOpenedByKeyboard(true);
            event.preventDefault();
        }
    }, []);
    return {
        isOpen: isOpen,
        isOpenedByKeyboard: isOpenedByKeyboard,
        toggle: toggle,
        close: close,
        handleEscapeKeydown: handleEscapeKeydown,
        handleClickOutside: handleClickOutside,
        handleKeyboardOpen: handleKeyboardOpen
    };
};

});
parcelRegister("9cXof", function(module, exports) {
$parcel$export(module.exports, "isDetachedElement", () => $e5b64ec22d453389$export$2670f72994f3eb72);
/**
 * Checks if an element is detached (i.e. not in the current document)
 */ const $e5b64ec22d453389$export$2670f72994f3eb72 = (el)=>!document.body.contains(el);

});



parcelRegister("9mNrI", function(module, exports) {
$parcel$export(module.exports, "EmojiPickerPopup", () => $05a7827eff7e2262$export$84d7903b9ff4f263);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $avm98 = parcelRequire("avm98");

var $dcudV = parcelRequire("dcudV");

var $7yBx7 = parcelRequire("7yBx7");

var $l1j5w = parcelRequire("l1j5w");
const $05a7827eff7e2262$var$EmojiPicker = (props)=>{
    const setOutsideClickTargetRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $dcudV.OutsideClickTargetRefContext));
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l1j5w.default), {
        onPickerRef: setOutsideClickTargetRef,
        emojiProvider: props.emojiProvider,
        onSelection: props.onSelection
    });
};
const $05a7827eff7e2262$var$EmojiPickerWithListeners = (0, $dcudV.default)($05a7827eff7e2262$var$EmojiPicker);
const $05a7827eff7e2262$export$84d7903b9ff4f263 = ({ isOpen: isOpen, targetRef: targetRef, emojiProvider: emojiProvider, onSelection: onSelection, onClickOutside: onClickOutside, onEscapeKeydown: onEscapeKeydown, onUnmount: onUnmount, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement })=>{
    if (!isOpen || !targetRef.current || !emojiProvider) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $avm98.default), {
        target: targetRef.current,
        fitHeight: 350,
        fitWidth: 350,
        offset: [
            0,
            3
        ],
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        onUnmount: onUnmount,
        focusTrap: true,
        zIndex: (0, $7yBx7.akEditorMenuZIndex),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($05a7827eff7e2262$var$EmojiPickerWithListeners, {
            emojiProvider: emojiProvider,
            onSelection: onSelection,
            handleClickOutside: onClickOutside,
            handleEscapeKeydown: onEscapeKeydown
        })
    });
};

});


parcelRegister("9JNZ7", function(module, exports) {
$parcel$export(module.exports, "ImageButton", () => $e0af33561b4ddb46$export$7554951b29a2b076);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $cxXTK = parcelRequire("cxXTK");

var $46A2h = parcelRequire("46A2h");

var $c0YTT = parcelRequire("c0YTT");

var $fJNLD = parcelRequire("fJNLD");
var $aDNj8 = parcelRequire("aDNj8");
var $64R2q = parcelRequire("64R2q");
const $e0af33561b4ddb46$export$7554951b29a2b076 = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { connectivityMode: connectivityMode, imageUploadEnabled: imageUploadEnabled } = (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'connectivity',
        'imageUpload'
    ], (states)=>({
            connectivityMode: states.connectivityState?.mode,
            imageUploadEnabled: states.imageUploadState?.enabled
        }));
    const { editorView: editorView } = (0, $c0YTT.useEditorToolbar)();
    const isOffline = connectivityMode === 'offline';
    const onClick = ()=>{
        if (editorView) {
            const { state: state, dispatch: dispatch } = editorView;
            api?.imageUpload?.actions.startUpload()(state, dispatch);
        }
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $64R2q.ToolbarTooltip), {
        content: formatMessage((0, $46A2h.toolbarInsertBlockMessages).image),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aDNj8.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fJNLD))), {
                label: formatMessage((0, $46A2h.toolbarInsertBlockMessages).image),
                size: "small"
            }),
            onClick: onClick,
            isDisabled: !imageUploadEnabled || isOffline
        })
    });
};

});

parcelRegister("lO1OX", function(module, exports) {
$parcel$export(module.exports, "InsertButton", () => $81700850cc36694f$export$a84121b2ebfb3ce9);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bMFKb = parcelRequire("bMFKb");

var $6Exgk = parcelRequire("6Exgk");

var $46A2h = parcelRequire("46A2h");

var $c0YTT = parcelRequire("c0YTT");

var $avm98 = parcelRequire("avm98");

var $frlUM = parcelRequire("frlUM");

var $7yBx7 = parcelRequire("7yBx7");

var $dcLzM = parcelRequire("dcLzM");
var $aDNj8 = parcelRequire("aDNj8");
var $64R2q = parcelRequire("64R2q");
var $7K3rS = parcelRequire("7K3rS");

var $eGOwo = parcelRequire("eGOwo");

var $cbSL1 = parcelRequire("cbSL1");

var $6ZPK6 = parcelRequire("6ZPK6");

var $5MbKe = parcelRequire("5MbKe");

var $l3EtO = parcelRequire("l3EtO");

var $8miOa = parcelRequire("8miOa");

var $9mNrI = parcelRequire("9mNrI");
// This determines how the popup should fit. We prefer the insert menu
// opening on the bottom as we have a search bar and should only open on
// top if there is more than sufficient room.
const $81700850cc36694f$var$FIT_HEIGHT_BUFFER = 100;
const $81700850cc36694f$export$a84121b2ebfb3ce9 = ({ api: api, showElementBrowserLink: showElementBrowserLink = false, isFullPageAppearance: isFullPageAppearance = false, tableSelectorSupported: tableSelectorSupported, nativeStatusSupported: nativeStatusSupported, horizontalRuleEnabled: horizontalRuleEnabled, expandEnabled: expandEnabled, insertMenuItems: insertMenuItems, numberOfButtons: numberOfButtons, onInsertBlockType: onInsertBlockType })=>{
    const { editorView: editorView } = (0, $c0YTT.useEditorToolbar)();
    const { isDisabled: isDisabled, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement } = (0, $7K3rS.useToolbarUI)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [insertMenuOpen, setInsertMenuOpen] = (0, $eJOHy.useState)(false);
    const insertButtonRef = (0, $eJOHy.useRef)(null);
    const emojiPickerPopup = (0, $5MbKe.useEmojiPickerPopup)({
        api: api,
        buttonRef: insertButtonRef
    });
    const tableSelectorPopup = (0, $8miOa.useTableSelectorPopup)({
        api: api,
        buttonRef: insertButtonRef
    });
    const showMediaPicker = (0, $frlUM.useSharedPluginStateSelector)(api, 'media.showMediaPicker');
    const { dropdownItems: dropdownItems, emojiProvider: emojiProvider, isTypeAheadAllowed: isTypeAheadAllowed } = (0, $l3EtO.useInsertButtonState)({
        api: api,
        editorView: editorView || undefined,
        horizontalRuleEnabled: horizontalRuleEnabled,
        insertMenuItems: insertMenuItems,
        nativeStatusSupported: nativeStatusSupported,
        numberOfButtons: numberOfButtons,
        tableSelectorSupported: tableSelectorSupported,
        expandEnabled: expandEnabled,
        showElementBrowserLink: showElementBrowserLink
    });
    if (!api?.insertBlock) return null;
    const toggleInsertMenuOpen = (newState)=>{
        setInsertMenuOpen(newState);
    };
    const onPopupUnmount = ()=>{
        requestAnimationFrame(()=>api?.core.actions.focus());
    };
    const onClick = ()=>{
        toggleInsertMenuOpen(!insertMenuOpen);
    };
    const onItemActivated = ({ item: item, inputMethod: inputMethod })=>{
        if (!editorView) return;
        const { state: state, dispatch: dispatch } = editorView;
        // need to do this before inserting nodes so scrollIntoView works properly
        if (!editorView.hasFocus()) editorView.focus();
        switch(item.value.name){
            case 'link':
                api?.core?.actions.execute(api?.hyperlink?.commands.showLinkToolbar(inputMethod));
                break;
            case 'table':
                // workaround to solve race condition where cursor is not placed correctly inside table
                queueMicrotask(()=>{
                    api?.table?.actions.insertTable?.({
                        action: (0, $bMFKb.ACTION).INSERTED,
                        actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
                        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).TABLE,
                        attributes: {
                            inputMethod: inputMethod
                        },
                        eventType: (0, $bMFKb.EVENT_TYPE).TRACK
                    })(state, dispatch);
                });
                break;
            case 'table selector':
                tableSelectorPopup.toggle(inputMethod);
                break;
            case 'image upload':
                if (api?.imageUpload?.actions.startUpload) api.imageUpload.actions.startUpload()(state, dispatch);
                break;
            case 'media':
                if (showMediaPicker) api?.core?.actions.execute(api?.mediaInsert?.commands.showMediaInsertPopup());
                break;
            case 'mention':
                api?.mention?.actions?.openTypeAhead(inputMethod);
                break;
            case 'emoji':
                emojiPickerPopup.toggle(inputMethod);
                break;
            case 'codeblock':
            case 'blockquote':
            case 'panel':
                onInsertBlockType?.(item.value.name)(state, dispatch);
                break;
            case 'action':
            case 'decision':
                const listType = item.value.name === 'action' ? 'taskList' : 'decisionList';
                api?.taskDecision?.actions.insertTaskDecision(listType, inputMethod)(state, dispatch);
                break;
            case 'horizontalrule':
                api?.rule?.actions.insertHorizontalRule(inputMethod)(state, dispatch);
                break;
            case 'macro':
                if (!(0, $eGOwo.fg)('platform_editor_refactor_view_more')) api?.core?.actions.execute(api?.quickInsert?.commands.openElementBrowserModal);
                break;
            case 'date':
                api?.core?.actions.execute(api?.date?.commands?.insertDate({
                    inputMethod: inputMethod
                }));
                break;
            case 'placeholder text':
                api?.placeholderText?.actions.showPlaceholderFloatingToolbar(state, dispatch);
                break;
            case 'layout':
                api?.layout?.actions.insertLayoutColumns(inputMethod)(state, dispatch);
                break;
            case 'status':
                api?.core?.actions.execute(api?.status?.commands?.insertStatus(inputMethod));
                break;
            case 'expand':
                api?.expand?.actions.insertExpand(state, dispatch);
                break;
            default:
                if (item && item.onClick) item.onClick();
                break;
        }
        toggleInsertMenuOpen(false);
    };
    const onInsert = ({ item: item })=>{
        onItemActivated({
            item: item,
            inputMethod: (0, $bMFKb.INPUT_METHOD).INSERT_MENU
        });
    };
    const toggleVisibility = ()=>{
        toggleInsertMenuOpen(!insertMenuOpen);
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            insertMenuOpen && insertButtonRef.current && editorView && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $avm98.default), {
                target: insertButtonRef.current,
                fitHeight: (0, $6ZPK6.DEFAULT_HEIGHT) + $81700850cc36694f$var$FIT_HEIGHT_BUFFER,
                fitWidth: 350,
                offset: [
                    0,
                    3
                ],
                mountTo: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement,
                onUnmount: onPopupUnmount,
                focusTrap: true,
                zIndex: (0, $7yBx7.akEditorMenuZIndex),
                preventOverflow: true,
                alignX: "right",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6ZPK6.default), {
                    editorView: editorView,
                    dropdownItems: dropdownItems,
                    onInsert: onInsert,
                    toggleVisiblity: toggleVisibility,
                    showElementBrowserLink: showElementBrowserLink,
                    pluginInjectionApi: api,
                    isFullPageAppearance: isFullPageAppearance
                })
            }),
            emojiProvider && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9mNrI.EmojiPickerPopup), {
                isOpen: emojiPickerPopup.isOpen,
                targetRef: insertButtonRef,
                emojiProvider: Promise.resolve(emojiProvider),
                onSelection: emojiPickerPopup.handleSelectedEmoji,
                onClickOutside: emojiPickerPopup.handleClickOutside,
                onEscapeKeydown: emojiPickerPopup.handleEscapeKeydown,
                onUnmount: emojiPickerPopup.onPopupUnmount,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $64R2q.ToolbarTooltip), {
                content: (0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6Exgk.ToolTipContent), {
                    description: formatMessage((0, $46A2h.toolbarInsertBlockMessages).insertMenu),
                    keymap: (0, $6Exgk.insertElements)
                }) : formatMessage((0, $46A2h.toolbarInsertBlockMessages).insertMenu),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aDNj8.ToolbarButton), {
                    iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
                        size: "small",
                        label: formatMessage((0, $46A2h.toolbarInsertBlockMessages).insertMenu)
                    }),
                    ariaKeyshortcuts: (0, $6Exgk.getAriaKeyshortcuts)((0, $6Exgk.insertElements)),
                    ref: insertButtonRef,
                    onClick: onClick,
                    isSelected: insertMenuOpen,
                    isDisabled: !isTypeAheadAllowed || isDisabled
                })
            })
        ]
    });
};

});
parcelRegister("6ZPK6", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_HEIGHT", () => $9c14f3da498fdb8d$export$611c894df53833b0);
$parcel$export(module.exports, "default", () => $9c14f3da498fdb8d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $lRq8t = parcelRequire("lRq8t");

var $kFk36 = parcelRequire("kFk36");

var $bMFKb = parcelRequire("bMFKb");

var $jiQ0H = parcelRequire("jiQ0H");
var $7vo9Y = parcelRequire("7vo9Y");

var $cxXTK = parcelRequire("cxXTK");

var $c1NDo = parcelRequire("c1NDo");
var $kpo54 = parcelRequire("kpo54");

var $dcudV = parcelRequire("dcudV");

var $eGOwo = parcelRequire("eGOwo");


var $cbSL1 = parcelRequire("cbSL1");

var $g6YpQ = parcelRequire("g6YpQ");
function $9c14f3da498fdb8d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9c14f3da498fdb8d$export$611c894df53833b0 = 560;
const $9c14f3da498fdb8d$export$60c7b179df9c4d78 = (featuredItems, formatMessage)=>{
    // Legacy path fallback -- prior comments as follows:
    /**
   * // Part of ATLAS-95399 to pin whiteboards to the top of the InsertMenu
  	// Need to check if whiteboard options are available, and filter for the cohort
  	// Takes the original featuredItems list and returns one with the right whiteboard option at the top
   */ if ((0, $eGOwo.fg)('confluence-whiteboards-quick-insert-eligible')) {
        const [DIAGRAM_TITLE, BLANK_TITLE] = [
            'Create diagram',
            'Create whiteboard'
        ];
        const featuredWhiteboardsPresent = featuredItems.filter((item)=>[
                DIAGRAM_TITLE,
                BLANK_TITLE
            ].includes(item.title)).length === 2;
        if (featuredWhiteboardsPresent) {
            const pinWhiteboardActionToTop = (items, title)=>{
                // find the requested item by title, give it the appropriate description, and bring it to the top of the list
                const index = items.findIndex((item)=>item.title === title);
                const filteredList = items.filter((item)=>![
                        DIAGRAM_TITLE,
                        BLANK_TITLE
                    ].includes(item.title));
                if (index === -1) return filteredList;
                const featuredItem = {
                    ...items[index]
                };
                featuredItem.description = formatMessage((0, $kpo54.messages).featuredWhiteboardDescription);
                return [
                    featuredItem,
                    ...filteredList
                ];
            };
            if ((0, $cbSL1.expValEquals)('confluence_whiteboards_quick_insert', 'cohort', 'test_blank')) return pinWhiteboardActionToTop(featuredItems, BLANK_TITLE);
            if ((0, $cbSL1.expValEquals)('confluence_whiteboards_quick_insert', 'cohort', 'test_diagram')) return pinWhiteboardActionToTop(featuredItems, DIAGRAM_TITLE);
            // NOTE this is not desirable/the OG behaviour, but given we've shipped the test_diagram variant,
            return featuredItems.filter((item)=>![
                    DIAGRAM_TITLE,
                    BLANK_TITLE
                ].includes(item.title));
        } else if ((0, $eGOwo.fg)('confluence-whiteboards-quick-insert-l10n-eligible')) {
            // Fire exposure for confluence_whiteboards_quick_insert_localised_aa
            // https://switcheroo.atlassian.com/ui/gates/ccd80d32-28a1-4dcf-b3f9-dbdc02a046ff/key/confluence_whiteboards_quick_insert_localised_aa
            (0, $g6YpQ.expVal)('confluence_whiteboards_quick_insert_localised_aa', 'cohort', 'test_diagram');
            /** BEGIN locale agnostic path */ /**
         * EXTREMELY IMPORTANT: we must not drop diagram for those who already receive
         * the 'insert diagram to the top' treatment.
         *
         * Our heuristic to check that this is only targeting users where they haven't
         * gotten the experience, is if we _cannot_ find the blank board experience in
         * the list, matching purely on title.
         *
         * e.g. `featuredWhiteboardsPresent` = false, given it matches on title.
         *
         * The side-effect of this, is that there's a small chance/edge case of users
         * who toggle between locales, and receive different experiences.
         *
         * Hopefully we can make a call early on this experiment, and eliminate this
         * code path.
         */ const WHITEBOARD_KEY = 'whiteboard-extension:create-whiteboard';
            const DIAGRAM_KEY = 'whiteboard-extension:create-diagram';
            const isBlank = (item)=>item.key === WHITEBOARD_KEY;
            const isDiagram = (item)=>item.key === DIAGRAM_KEY;
            const hasBoth = featuredItems.some(isBlank) && featuredItems.some(isDiagram);
            if (hasBoth) {
                const pin = (key)=>{
                    const idx = featuredItems.findIndex((item)=>item.key === key);
                    const filtered = featuredItems.filter((item)=>!isBlank(item) && !isDiagram(item));
                    if (idx === -1) return filtered;
                    const picked = {
                        ...featuredItems[idx],
                        description: formatMessage((0, $kpo54.messages).featuredWhiteboardDescription)
                    };
                    return [
                        picked,
                        ...filtered
                    ];
                };
                if ((0, $cbSL1.expValEquals)('confluence_whiteboards_quick_insert_localised', 'cohort', 'test_blank')) return pin(WHITEBOARD_KEY);
                if ((0, $cbSL1.expValEquals)('confluence_whiteboards_quick_insert_localised', 'cohort', 'test_diagram')) return pin(DIAGRAM_KEY);
                if ((0, $cbSL1.expValEquals)('confluence_whiteboards_quick_insert_localised', 'cohort', 'control')) return featuredItems;
            }
        }
    }
    return featuredItems;
};
const $9c14f3da498fdb8d$var$selector = (states)=>{
    return {
        connectivityMode: states.connectivityState?.mode
    };
};
const $9c14f3da498fdb8d$var$InsertMenu = ({ editorView: editorView, dropdownItems: dropdownItems, showElementBrowserLink: showElementBrowserLink, onInsert: onInsert, toggleVisiblity: toggleVisiblity, pluginInjectionApi: pluginInjectionApi, isFullPageAppearance: isFullPageAppearance })=>{
    const [itemCount, setItemCount] = (0, $eJOHy.useState)(0);
    const [height, setHeight] = (0, $eJOHy.useState)($9c14f3da498fdb8d$export$611c894df53833b0);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const cache = (0, $eJOHy.useMemo)(()=>{
        return new (0, $kFk36.CellMeasurerCache)({
            fixedWidth: true,
            defaultHeight: (0, $jiQ0H.ELEMENT_ITEM_HEIGHT),
            minHeight: (0, $jiQ0H.ELEMENT_ITEM_HEIGHT)
        });
    }, []);
    (0, $eJOHy.useLayoutEffect)(()=>{
        // Figure based on visuals to exclude the searchbar, padding/margin, and the ViewMore item.
        const EXTRA_SPACE_EXCLUDING_ELEMENTLIST = 128;
        const totalItemHeight = [
            ...Array(itemCount)
        ].reduce((sum, _, index)=>sum + cache.rowHeight({
                index: index
            }), 0) + EXTRA_SPACE_EXCLUDING_ELEMENTLIST;
        if (itemCount > 0 && totalItemHeight < $9c14f3da498fdb8d$export$611c894df53833b0) setHeight(totalItemHeight);
        else setHeight($9c14f3da498fdb8d$export$611c894df53833b0);
    }, [
        cache,
        itemCount
    ]);
    const transform = (0, $eJOHy.useCallback)((item)=>({
            title: item.content,
            description: item.tooltipDescription,
            keyshortcut: item.shortcut,
            icon: ()=>$9c14f3da498fdb8d$var$getSvgIconForItem({
                    name: item.value.name
                }) || item.elemBefore,
            /**
     * @note This transformed items action is only used when a quick insert item has been
     * called from the quick insert menu and a search has not been performed.
     */ action: ()=>onInsert({
                    item: item
                }),
            // "insertInsertMenuItem" expects these 2 properties.
            onClick: item.onClick,
            value: item.value
        }), [
        onInsert
    ]);
    const quickInsertDropdownItems = dropdownItems.map(transform);
    // Please clean up viewMoreItem when cleaning up platform_editor_refactor_view_more
    const viewMoreItem = !(0, $eGOwo.fg)('platform_editor_refactor_view_more') && showElementBrowserLink ? quickInsertDropdownItems.pop() : undefined;
    const onInsertItem = (0, $eJOHy.useCallback)((item)=>{
        toggleVisiblity();
        if (!editorView.hasFocus()) editorView.focus();
        pluginInjectionApi?.quickInsert?.actions.insertItem(item, (0, $bMFKb.INPUT_METHOD).TOOLBAR)(editorView.state, editorView.dispatch);
    }, [
        editorView,
        toggleVisiblity,
        pluginInjectionApi
    ]);
    const { connectivityMode: connectivityMode } = (0, $cxXTK.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'connectivity'
    ], $9c14f3da498fdb8d$var$selector);
    const getItems = (0, $eJOHy.useCallback)((query, category)=>{
        let result;
        /**
     * @warning The results if there is a query are not the same as the results if there is no query.
     * For example: If you have a typed panel and then select the panel item then it will call a different action
     * than is specified on the editor plugins quick insert
     * @see above transform function for more details.
     */ if (query) result = pluginInjectionApi?.quickInsert?.actions.getSuggestions({
            query: query,
            category: category
        })?.map((item)=>connectivityMode === 'offline' && item.isDisabledOffline ? {
                ...item,
                isDisabled: true
            } : item) ?? [];
        else {
            const featuredQuickInsertSuggestions = pluginInjectionApi?.quickInsert?.actions.getSuggestions({
                category: category,
                featuredItems: true
            })?.map((item)=>connectivityMode === 'offline' && item.isDisabledOffline ? {
                    ...item,
                    isDisabled: true
                } : item) ?? [];
            const unfilteredResult = quickInsertDropdownItems.concat(featuredQuickInsertSuggestions);
            // need to filter on the concatenated list so whiteboards are at the top
            result = $9c14f3da498fdb8d$export$60c7b179df9c4d78(unfilteredResult, formatMessage);
        }
        setItemCount(result.length);
        return result;
    }, [
        pluginInjectionApi?.quickInsert?.actions,
        quickInsertDropdownItems,
        connectivityMode,
        formatMessage
    ]);
    const emptyStateHandler = pluginInjectionApi?.quickInsert?.sharedState.currentState()?.emptyStateHandler;
    const onViewMore = (0, $eJOHy.useCallback)(()=>{
        toggleVisiblity();
        pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.quickInsert?.commands.openElementBrowserModal);
    }, [
        pluginInjectionApi,
        toggleVisiblity
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $9c14f3da498fdb8d$var$insertMenuWrapper(height, isFullPageAppearance)
    }, /*#__PURE__*/ (0, $1NIU8.jsx)($9c14f3da498fdb8d$var$ElementBrowserWrapper, {
        handleClickOutside: toggleVisiblity,
        handleEscapeKeydown: toggleVisiblity,
        closeOnTab: false
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $7vo9Y.default), {
        mode: "inline",
        getItems: getItems,
        emptyStateHandler: emptyStateHandler,
        onInsertItem: onInsertItem,
        showSearch: true,
        showCategories: false,
        // On page resize we want the InlineElementBrowser to show updated tools/overflow items
        key: quickInsertDropdownItems.length,
        viewMoreItem: viewMoreItem,
        onViewMore: showElementBrowserLink ? onViewMore : undefined,
        cache: cache
    }))));
};
const $9c14f3da498fdb8d$var$getSvgIconForItem = ({ name: name })=>{
    const Icon = {
        codeblock: (0, $c1NDo.IconCode),
        panel: (0, $c1NDo.IconPanel),
        blockquote: (0, $c1NDo.IconQuote),
        decision: (0, $c1NDo.IconDecision),
        horizontalrule: (0, $c1NDo.IconDivider),
        expand: (0, $c1NDo.IconExpand),
        date: (0, $c1NDo.IconDate),
        status: (0, $c1NDo.IconStatus)
    }[name];
    return Icon ? /*#__PURE__*/ (0, $1NIU8.jsx)(Icon, {
        label: ""
    }) : undefined;
};
const $9c14f3da498fdb8d$var$insertMenuWrapper = (height, isFullPageAppearance)=>{
    return /*#__PURE__*/ (0, $1NIU8.css)({
        display: 'flex',
        flexDirection: 'column',
        width: '320px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        height: `${height}px`,
        backgroundColor: `${`var(--ds-surface-overlay, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`}`,
        borderRadius: "var(--ds-radius-small, 3px)",
        boxShadow: `${`var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $7bb4c1736002a04a$export$920c0d5c49070351)},
    0 2px 1px ${(0, $7bb4c1736002a04a$export$920c0d5c49070351)},
    0 0 20px -6px ${(0, $7bb4c1736002a04a$export$d2d3bedfb276cac0)}`})`}`
    });
};
const $9c14f3da498fdb8d$var$flexWrapperStyles = {
    name: "1wlc510",
    styles: "display:flex;flex:1;box-sizing:border-box;overflow:hidden"
};
const $9c14f3da498fdb8d$var$FlexWrapper = (props)=>{
    const setOutsideClickTargetRef = (0, $eJOHy.useContext)((0, $dcudV.OutsideClickTargetRefContext));
    const { children: children, ...divProps } = props;
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        ref: setOutsideClickTargetRef,
        css: $9c14f3da498fdb8d$var$flexWrapperStyles,
        ...divProps
    }, children));
};
const $9c14f3da498fdb8d$var$ElementBrowserWrapper = (0, $dcudV.default)($9c14f3da498fdb8d$var$FlexWrapper);
var $9c14f3da498fdb8d$export$2e2bcd8739ae039 = $9c14f3da498fdb8d$var$InsertMenu;

});
parcelRegister("kFk36", function(module, exports) {
"use strict";

var $7Wmh0 = parcelRequire("7Wmh0");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "CellMeasurer", {
    enumerable: true,
    get: function get() {
        return $f0b7304b32e2f74d$var$_CellMeasurer["default"];
    }
});
Object.defineProperty(module.exports, "CellMeasurerCache", {
    enumerable: true,
    get: function get() {
        return $f0b7304b32e2f74d$var$_CellMeasurerCache["default"];
    }
});
module.exports["default"] = void 0;

var $f0b7304b32e2f74d$var$_CellMeasurer = $7Wmh0((parcelRequire("Z9qfj")));

var $f0b7304b32e2f74d$var$_CellMeasurerCache = $7Wmh0((parcelRequire("kEXeZ")));
var $f0b7304b32e2f74d$var$_default = module.exports["default"] = $f0b7304b32e2f74d$var$_CellMeasurer["default"];

});
parcelRegister("Z9qfj", function(module, exports) {
"use strict";

var $7Wmh0 = parcelRequire("7Wmh0");

var $2V8W5 = parcelRequire("2V8W5");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $0b7d01b26ccf34bf$var$_classCallCheck2 = $7Wmh0((parcelRequire("4r8Q9")));

var $0b7d01b26ccf34bf$var$_createClass2 = $7Wmh0((parcelRequire("3Ei40")));

var $0b7d01b26ccf34bf$var$_possibleConstructorReturn2 = $7Wmh0((parcelRequire("1gtk9")));

var $0b7d01b26ccf34bf$var$_getPrototypeOf2 = $7Wmh0((parcelRequire("hj4kH")));

var $0b7d01b26ccf34bf$var$_inherits2 = $7Wmh0((parcelRequire("33JSU")));

var $0b7d01b26ccf34bf$var$_defineProperty2 = $7Wmh0((parcelRequire("ky4V8")));

var $0b7d01b26ccf34bf$var$_react = $0b7d01b26ccf34bf$var$_interopRequireWildcard((parcelRequire("eJOHy")));
var $0b7d01b26ccf34bf$var$React = $0b7d01b26ccf34bf$var$_react;
function $0b7d01b26ccf34bf$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0b7d01b26ccf34bf$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $0b7d01b26ccf34bf$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $2V8W5(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $0b7d01b26ccf34bf$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $0b7d01b26ccf34bf$var$_callSuper(t, o, e) {
    return o = (0, $0b7d01b26ccf34bf$var$_getPrototypeOf2["default"])(o), (0, $0b7d01b26ccf34bf$var$_possibleConstructorReturn2["default"])(t, $0b7d01b26ccf34bf$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $0b7d01b26ccf34bf$var$_getPrototypeOf2["default"])(t).constructor) : o.apply(t, e));
}
function $0b7d01b26ccf34bf$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0b7d01b26ccf34bf$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
} /*:: import type {CellMeasureCache} from './types';*/ 
/*:: type Children = (params: {measure: () => void}) => React.Element<*>;*/ /*:: type Cell = {
  columnIndex: number,
  rowIndex: number,
};*/ /*:: type Props = {
  cache: CellMeasureCache,
  children: Children | React.Element<*>,
  columnIndex?: number,
  index?: number,
  parent: {
    invalidateCellSizeAfterRender?: (cell: Cell) => void,
    recomputeGridSize?: (cell: Cell) => void,
  },
  rowIndex?: number,
};*/ /**
 * Wraps a cell and measures its rendered content.
 * Measurements are stored in a per-cell cache.
 * Cached-content is not be re-measured.
 */ var $0b7d01b26ccf34bf$var$CellMeasurer = module.exports["default"] = /*#__PURE__*/ function(_React$PureComponent) {
    function CellMeasurer() {
        var _this;
        (0, $0b7d01b26ccf34bf$var$_classCallCheck2["default"])(this, CellMeasurer);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $0b7d01b26ccf34bf$var$_callSuper(this, CellMeasurer, [].concat(args));
        (0, $0b7d01b26ccf34bf$var$_defineProperty2["default"])(_this, "_child", /*#__PURE__*/ $0b7d01b26ccf34bf$var$React.createRef());
        (0, $0b7d01b26ccf34bf$var$_defineProperty2["default"])(_this, "_measure", function() {
            var _this$props = _this.props, cache = _this$props.cache, _this$props$columnInd = _this$props.columnIndex, columnIndex = _this$props$columnInd === void 0 ? 0 : _this$props$columnInd, parent = _this$props.parent, _this$props$rowIndex = _this$props.rowIndex, rowIndex = _this$props$rowIndex === void 0 ? _this.props.index || 0 : _this$props$rowIndex;
            var _this$_getCellMeasure = _this._getCellMeasurements(), height = _this$_getCellMeasure.height, width = _this$_getCellMeasure.width;
            if (height !== cache.getHeight(rowIndex, columnIndex) || width !== cache.getWidth(rowIndex, columnIndex)) {
                cache.set(rowIndex, columnIndex, width, height);
                if (parent && typeof parent.recomputeGridSize === 'function') parent.recomputeGridSize({
                    columnIndex: columnIndex,
                    rowIndex: rowIndex
                });
            }
        });
        (0, $0b7d01b26ccf34bf$var$_defineProperty2["default"])(_this, "_registerChild", function(element) {
            if (element && !(element instanceof Element)) console.warn('CellMeasurer registerChild expects to be passed Element or null');
            _this._child.current = element;
            if (element) _this._maybeMeasureCell();
        });
        return _this;
    }
    (0, $0b7d01b26ccf34bf$var$_inherits2["default"])(CellMeasurer, _React$PureComponent);
    return (0, $0b7d01b26ccf34bf$var$_createClass2["default"])(CellMeasurer, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._maybeMeasureCell();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this._maybeMeasureCell();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var children = this.props.children;
                var resolvedChildren = typeof children === 'function' ? children({
                    measure: this._measure,
                    registerChild: this._registerChild
                }) : children;
                if (resolvedChildren === null) return resolvedChildren;
                return /*#__PURE__*/ (0, $0b7d01b26ccf34bf$var$_react.cloneElement)(resolvedChildren, {
                    ref: function ref(node) {
                        if (typeof resolvedChildren.ref === 'function') resolvedChildren.ref(node);
                        else if (resolvedChildren.ref) resolvedChildren.ref.current = node;
                        _this2._child.current = node;
                    }
                });
            }
        },
        {
            key: "_getCellMeasurements",
            value: function _getCellMeasurements() {
                var cache = this.props.cache;
                var node = this._child.current;
                // TODO Check for a bad combination of fixedWidth and missing numeric width or vice versa with height
                if (node && node.ownerDocument && node.ownerDocument.defaultView && node instanceof node.ownerDocument.defaultView.HTMLElement) {
                    var styleWidth = node.style.width;
                    var styleHeight = node.style.height;
                    // If we are re-measuring a cell that has already been measured,
                    // It will have a hard-coded width/height from the previous measurement.
                    // The fact that we are measuring indicates this measurement is probably stale,
                    // So explicitly clear it out (eg set to "auto") so we can recalculate.
                    // See issue #593 for more info.
                    // Even if we are measuring initially- if we're inside of a MultiGrid component,
                    // Explicitly clear width/height before measuring to avoid being tainted by another Grid.
                    // eg top/left Grid renders before bottom/right Grid
                    // Since the CellMeasurerCache is shared between them this taints derived cell size values.
                    if (!cache.hasFixedWidth()) node.style.width = 'auto';
                    if (!cache.hasFixedHeight()) node.style.height = 'auto';
                    var height = Math.ceil(node.offsetHeight);
                    var width = Math.ceil(node.offsetWidth);
                    // Reset after measuring to avoid breaking styles; see #660
                    if (styleWidth) node.style.width = styleWidth;
                    if (styleHeight) node.style.height = styleHeight;
                    return {
                        height: height,
                        width: width
                    };
                } else return {
                    height: 0,
                    width: 0
                };
            }
        },
        {
            key: "_maybeMeasureCell",
            value: function _maybeMeasureCell() {
                var _this$props2 = this.props, cache = _this$props2.cache, _this$props2$columnIn = _this$props2.columnIndex, columnIndex = _this$props2$columnIn === void 0 ? 0 : _this$props2$columnIn, parent = _this$props2.parent, _this$props2$rowIndex = _this$props2.rowIndex, rowIndex = _this$props2$rowIndex === void 0 ? this.props.index || 0 : _this$props2$rowIndex;
                if (!cache.has(rowIndex, columnIndex)) {
                    var _this$_getCellMeasure2 = this._getCellMeasurements(), height = _this$_getCellMeasure2.height, width = _this$_getCellMeasure2.width;
                    cache.set(rowIndex, columnIndex, width, height);
                    // If size has changed, let Grid know to re-render.
                    if (parent && typeof parent.invalidateCellSizeAfterRender === 'function') parent.invalidateCellSizeAfterRender({
                        columnIndex: columnIndex,
                        rowIndex: rowIndex
                    });
                }
            }
        }
    ]);
}($0b7d01b26ccf34bf$var$React.PureComponent); // Used for DEV mode warning check
(0, $0b7d01b26ccf34bf$var$_defineProperty2["default"])($0b7d01b26ccf34bf$var$CellMeasurer, "__internalCellMeasurerFlag", false);

});
parcelRegister("4r8Q9", function(module, exports) {
function $33b08a8756b6c5bc$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $33b08a8756b6c5bc$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3Ei40", function(module, exports) {

var $3Wdje = parcelRequire("3Wdje");
function $2a831e9a867a847f$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $3Wdje(o.key), o);
    }
}
function $2a831e9a867a847f$var$_createClass(e, r, t) {
    return r && $2a831e9a867a847f$var$_defineProperties(e.prototype, r), t && $2a831e9a867a847f$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $2a831e9a867a847f$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("1gtk9", function(module, exports) {

var $2V8W5 = parcelRequire("2V8W5");
var $0ebe08312ea05486$var$_typeof = $2V8W5.default;

var $7GwkG = parcelRequire("7GwkG");
function $0ebe08312ea05486$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $0ebe08312ea05486$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $7GwkG(t);
}
module.exports = $0ebe08312ea05486$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("33JSU", function(module, exports) {

var $a3tvS = parcelRequire("a3tvS");
function $23a53ea68b5a21a4$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $a3tvS(t, e);
}
module.exports = $23a53ea68b5a21a4$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("kEXeZ", function(module, exports) {
"use strict";

var $7Wmh0 = parcelRequire("7Wmh0");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.DEFAULT_WIDTH = module.exports.DEFAULT_HEIGHT = void 0;

var $f0a57f0a1ffa7616$var$_classCallCheck2 = $7Wmh0((parcelRequire("4r8Q9")));

var $f0a57f0a1ffa7616$var$_createClass2 = $7Wmh0((parcelRequire("3Ei40")));

var $f0a57f0a1ffa7616$var$_defineProperty2 = $7Wmh0((parcelRequire("ky4V8")));
/*:: import type {CellMeasureCache} from './types';*/ var $f0a57f0a1ffa7616$var$DEFAULT_HEIGHT = module.exports.DEFAULT_HEIGHT = 30;
var $f0a57f0a1ffa7616$var$DEFAULT_WIDTH = module.exports.DEFAULT_WIDTH = 100;
// Enables more intelligent mapping of a given column and row index to an item ID.
// This prevents a cell cache from being invalidated when its parent collection is modified.
/*:: type KeyMapper = (rowIndex: number, columnIndex: number) => any;*/ /*:: type CellMeasurerCacheParams = {
  defaultHeight?: number,
  defaultWidth?: number,
  fixedHeight?: boolean,
  fixedWidth?: boolean,
  minHeight?: number,
  minWidth?: number,
  keyMapper?: KeyMapper,
};*/ /*:: type Cache = {
  [key: any]: number,
};*/ /*:: type IndexParam = {
  index: number,
};*/ /**
 * Caches measurements for a given cell.
 */ var $f0a57f0a1ffa7616$var$CellMeasurerCache = module.exports["default"] = /*#__PURE__*/ function() {
    function CellMeasurerCache() {
        var _this = this;
        var params /*: CellMeasurerCacheParams*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $f0a57f0a1ffa7616$var$_classCallCheck2["default"])(this, CellMeasurerCache);
        (0, $f0a57f0a1ffa7616$var$_defineProperty2["default"])(this, "_cellHeightCache", {});
        (0, $f0a57f0a1ffa7616$var$_defineProperty2["default"])(this, "_cellWidthCache", {});
        (0, $f0a57f0a1ffa7616$var$_defineProperty2["default"])(this, "_columnWidthCache", {});
        (0, $f0a57f0a1ffa7616$var$_defineProperty2["default"])(this, "_rowHeightCache", {});
        (0, $f0a57f0a1ffa7616$var$_defineProperty2["default"])(this, "_defaultHeight", void 0);
        (0, $f0a57f0a1ffa7616$var$_defineProperty2["default"])(this, "_defaultWidth", void 0);
        (0, $f0a57f0a1ffa7616$var$_defineProperty2["default"])(this, "_minHeight", void 0);
        (0, $f0a57f0a1ffa7616$var$_defineProperty2["default"])(this, "_minWidth", void 0);
        (0, $f0a57f0a1ffa7616$var$_defineProperty2["default"])(this, "_keyMapper", void 0);
        (0, $f0a57f0a1ffa7616$var$_defineProperty2["default"])(this, "_hasFixedHeight", void 0);
        (0, $f0a57f0a1ffa7616$var$_defineProperty2["default"])(this, "_hasFixedWidth", void 0);
        (0, $f0a57f0a1ffa7616$var$_defineProperty2["default"])(this, "_columnCount", 0);
        (0, $f0a57f0a1ffa7616$var$_defineProperty2["default"])(this, "_rowCount", 0);
        (0, $f0a57f0a1ffa7616$var$_defineProperty2["default"])(this, "columnWidth", function(_ref /*:: */ ) {
            var index = _ref /*:: */ .index;
            var key = _this._keyMapper(0, index);
            return _this._columnWidthCache[key] !== undefined ? _this._columnWidthCache[key] : _this._defaultWidth;
        });
        (0, $f0a57f0a1ffa7616$var$_defineProperty2["default"])(this, "rowHeight", function(_ref2 /*:: */ ) {
            var index = _ref2 /*:: */ .index;
            var key = _this._keyMapper(index, 0);
            return _this._rowHeightCache[key] !== undefined ? _this._rowHeightCache[key] : _this._defaultHeight;
        });
        var defaultHeight = params.defaultHeight, defaultWidth = params.defaultWidth, fixedHeight = params.fixedHeight, fixedWidth = params.fixedWidth, keyMapper = params.keyMapper, minHeight = params.minHeight, minWidth = params.minWidth;
        this._hasFixedHeight = fixedHeight === true;
        this._hasFixedWidth = fixedWidth === true;
        this._minHeight = minHeight || 0;
        this._minWidth = minWidth || 0;
        this._keyMapper = keyMapper || $f0a57f0a1ffa7616$var$defaultKeyMapper;
        this._defaultHeight = Math.max(this._minHeight, typeof defaultHeight === 'number' ? defaultHeight : $f0a57f0a1ffa7616$var$DEFAULT_HEIGHT);
        this._defaultWidth = Math.max(this._minWidth, typeof defaultWidth === 'number' ? defaultWidth : $f0a57f0a1ffa7616$var$DEFAULT_WIDTH);
    }
    return (0, $f0a57f0a1ffa7616$var$_createClass2["default"])(CellMeasurerCache, [
        {
            key: "clear",
            value: function clear(rowIndex /*: number*/ ) {
                var columnIndex /*: number*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var key = this._keyMapper(rowIndex, columnIndex);
                delete this._cellHeightCache[key];
                delete this._cellWidthCache[key];
                this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
            }
        },
        {
            key: "clearAll",
            value: function clearAll() {
                this._cellHeightCache = {};
                this._cellWidthCache = {};
                this._columnWidthCache = {};
                this._rowHeightCache = {};
                this._rowCount = 0;
                this._columnCount = 0;
            }
        },
        {
            key: "defaultHeight",
            get: function get() /*: number*/ {
                return this._defaultHeight;
            }
        },
        {
            key: "defaultWidth",
            get: function get() /*: number*/ {
                return this._defaultWidth;
            }
        },
        {
            key: "hasFixedHeight",
            value: function hasFixedHeight() /*: boolean*/ {
                return this._hasFixedHeight;
            }
        },
        {
            key: "hasFixedWidth",
            value: function hasFixedWidth() /*: boolean*/ {
                return this._hasFixedWidth;
            }
        },
        {
            key: "getHeight",
            value: function getHeight(rowIndex /*: number*/ ) /*: number*/ {
                var columnIndex /*: number*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                if (this._hasFixedHeight) return this._defaultHeight;
                else {
                    var _key = this._keyMapper(rowIndex, columnIndex);
                    return this._cellHeightCache[_key] !== undefined ? Math.max(this._minHeight, this._cellHeightCache[_key]) : this._defaultHeight;
                }
            }
        },
        {
            key: "getWidth",
            value: function getWidth(rowIndex /*: number*/ ) /*: number*/ {
                var columnIndex /*: number*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                if (this._hasFixedWidth) return this._defaultWidth;
                else {
                    var _key2 = this._keyMapper(rowIndex, columnIndex);
                    return this._cellWidthCache[_key2] !== undefined ? Math.max(this._minWidth, this._cellWidthCache[_key2]) : this._defaultWidth;
                }
            }
        },
        {
            key: "has",
            value: function has(rowIndex /*: number*/ ) /*: boolean*/ {
                var columnIndex /*: number*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var key = this._keyMapper(rowIndex, columnIndex);
                return this._cellHeightCache[key] !== undefined;
            }
        },
        {
            key: "set",
            value: function set(rowIndex /*: number*/ , columnIndex /*: number*/ , width /*: number*/ , height /*: number*/ ) /*: void*/ {
                var key = this._keyMapper(rowIndex, columnIndex);
                if (columnIndex >= this._columnCount) this._columnCount = columnIndex + 1;
                if (rowIndex >= this._rowCount) this._rowCount = rowIndex + 1;
                // Size is cached per cell so we don't have to re-measure if cells are re-ordered.
                this._cellHeightCache[key] = height;
                this._cellWidthCache[key] = width;
                this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
            }
        },
        {
            key: "_updateCachedColumnAndRowSizes",
            value: function _updateCachedColumnAndRowSizes(rowIndex /*: number*/ , columnIndex /*: number*/ ) {
                // :columnWidth and :rowHeight are derived based on all cells in a column/row.
                // Pre-cache these derived values for faster lookup later.
                // Reads are expected to occur more frequently than writes in this case.
                // Only update non-fixed dimensions though to avoid doing unnecessary work.
                if (!this._hasFixedWidth) {
                    var columnWidth = 0;
                    for(var i = 0; i < this._rowCount; i++)columnWidth = Math.max(columnWidth, this.getWidth(i, columnIndex));
                    var columnKey = this._keyMapper(0, columnIndex);
                    this._columnWidthCache[columnKey] = columnWidth;
                }
                if (!this._hasFixedHeight) {
                    var rowHeight = 0;
                    for(var _i = 0; _i < this._columnCount; _i++)rowHeight = Math.max(rowHeight, this.getHeight(rowIndex, _i));
                    var rowKey = this._keyMapper(rowIndex, 0);
                    this._rowHeightCache[rowKey] = rowHeight;
                }
            }
        }
    ]);
}();
function $f0a57f0a1ffa7616$var$defaultKeyMapper(rowIndex /*: number*/ , columnIndex /*: number*/ ) {
    return "".concat(rowIndex, "-").concat(columnIndex);
}

});


parcelRegister("kpo54", function(module, exports) {
$parcel$export(module.exports, "messages", () => $7cd97434ff870fe4$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $7cd97434ff870fe4$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    help: {
        id: 'fabric.editor.elementBrowser.help',
        defaultMessage: 'Help',
        description: 'Element browser help button label'
    },
    all: {
        id: 'fabric.editor.elementbrowser.categorylist.category-all',
        defaultMessage: 'All',
        description: 'all'
    },
    formatting: {
        id: 'fabric.editor.elementbrowser.categorylist.category-formatting',
        defaultMessage: 'Formatting',
        description: 'formatting'
    },
    'confluence-content': {
        id: 'fabric.editor.elementbrowser.categorylist.category-confluence-content',
        defaultMessage: 'Confluence content',
        description: 'confluence-content'
    },
    media: {
        id: 'fabric.editor.elementbrowser.categorylist.category-media',
        defaultMessage: 'Media',
        description: 'media'
    },
    visuals: {
        id: 'fabric.editor.elementbrowser.categorylist.category-visuals',
        defaultMessage: 'Visuals & images',
        description: 'visuals'
    },
    navigation: {
        id: 'fabric.editor.elementbrowser.categorylist.category-navigation',
        defaultMessage: 'Navigation',
        description: 'navigation'
    },
    'external-content': {
        id: 'fabric.editor.elementbrowser.categorylist.category-external-content',
        defaultMessage: 'External content',
        description: 'external-content'
    },
    communication: {
        id: 'fabric.editor.elementbrowser.categorylist.category-communication',
        defaultMessage: 'Communication',
        description: 'communication'
    },
    reporting: {
        id: 'fabric.editor.elementbrowser.categorylist.category-reporting',
        defaultMessage: 'Reporting',
        description: 'reporting'
    },
    admin: {
        id: 'fabric.editor.elementbrowser.categorylist.category-admin',
        defaultMessage: 'Administration',
        description: 'admin'
    },
    development: {
        id: 'fabric.editor.elementbrowser.categorylist.category-development',
        defaultMessage: 'Development',
        description: 'development'
    },
    AI: {
        id: 'fabric.editor.elementbrowser.categorylist.category-ai',
        defaultMessage: 'Rovo',
        description: 'AI'
    },
    featuredWhiteboardDescription: {
        id: 'fabric.editor.elementbrowser.featured.whiteboard.description',
        defaultMessage: 'Use a whiteboard to add visuals to your page',
        description: 'Displayed as the description for a featured whiteboard insert action'
    },
    browse: {
        id: 'fabric.editor.elementbrowser.sidebar.heading',
        defaultMessage: 'Browse',
        description: 'Sidebar heading'
    }
});

});


parcelRegister("l3EtO", function(module, exports) {
$parcel$export(module.exports, "useInsertButtonState", () => $d93210850afd8bbe$export$94599bdafcdd887b);

var $lRq8t = parcelRequire("lRq8t");

var $frlUM = parcelRequire("frlUM");

var $hJx37 = parcelRequire("hJx37");
const $d93210850afd8bbe$export$94599bdafcdd887b = ({ api: api, editorView: editorView, horizontalRuleEnabled: horizontalRuleEnabled, insertMenuItems: insertMenuItems, nativeStatusSupported: nativeStatusSupported, numberOfButtons: numberOfButtons, tableSelectorSupported: tableSelectorSupported, expandEnabled: expandEnabled, showElementBrowserLink: showElementBrowserLink })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isTypeAheadAllowed = (0, $frlUM.useSharedPluginStateSelector)(api, 'typeAhead.isAllowed');
    const imageUploadEnabled = (0, $frlUM.useSharedPluginStateSelector)(api, 'imageUpload.enabled');
    const mentionsSupported = !!(0, $frlUM.useSharedPluginStateSelector)(api, 'mention.mentionProvider');
    const canInsertMention = (0, $frlUM.useSharedPluginStateSelector)(api, 'mention.canInsertMention');
    const dateEnabled = (0, $frlUM.useSharedPluginStateSelector)(api, 'date.isInitialised');
    const placeholderTextEnabled = (0, $frlUM.useSharedPluginStateSelector)(api, 'placeholderText.allowInserting');
    const mediaAllowsUploads = (0, $frlUM.useSharedPluginStateSelector)(api, 'media.allowsUploads');
    const canInsertLink = (0, $frlUM.useSharedPluginStateSelector)(api, 'hyperlink.canInsertLink');
    const activeLinkMark = (0, $frlUM.useSharedPluginStateSelector)(api, 'hyperlink.activeLinkMark');
    const connectivityMode = (0, $frlUM.useSharedPluginStateSelector)(api, 'connectivity.mode');
    const emojiProvider = (0, $frlUM.useSharedPluginStateSelector)(api, 'emoji.emojiProvider');
    const availableWrapperBlockTypes = (0, $frlUM.useSharedPluginStateSelector)(api, 'blockType.availableWrapperBlockTypes');
    // Computed values
    const mediaUploadsEnabled = mediaAllowsUploads;
    const mediaSupported = mediaAllowsUploads !== undefined;
    const isEditorOffline = connectivityMode === 'offline';
    const imageUploadSupported = !!api?.imageUpload;
    const mentionsDisabled = !canInsertMention;
    const linkSupported = canInsertLink !== undefined;
    const linkDisabled = !canInsertLink || !!activeLinkMark;
    const emojiDisabled = !emojiProvider;
    const actionSupported = !!editorView?.state.schema.nodes.taskItem;
    const decisionSupported = !!editorView?.state.schema.nodes.decisionItem;
    const layoutSectionEnabled = !!api?.layout;
    const [, dropdownItems] = editorView?.state.schema ? (0, $hJx37.createItems)({
        isTypeAheadAllowed: isTypeAheadAllowed,
        tableSupported: !!editorView?.state.schema.nodes.table,
        tableSelectorSupported: tableSelectorSupported,
        mediaUploadsEnabled: mediaUploadsEnabled,
        mediaSupported: mediaSupported,
        isEditorOffline: isEditorOffline,
        imageUploadSupported: imageUploadSupported,
        imageUploadEnabled: imageUploadEnabled,
        mentionsSupported: mentionsSupported,
        mentionsDisabled: mentionsDisabled,
        actionSupported: actionSupported,
        decisionSupported: decisionSupported,
        linkSupported: linkSupported,
        linkDisabled: linkDisabled,
        emojiDisabled: emojiDisabled,
        hasEmojiPlugin: !!api?.emoji,
        hasMentionsPlugin: !!api?.mention,
        hasMediaPlugin: !!api?.media,
        nativeStatusSupported: nativeStatusSupported,
        dateEnabled: dateEnabled,
        placeholderTextEnabled: placeholderTextEnabled,
        horizontalRuleEnabled: horizontalRuleEnabled,
        layoutSectionEnabled: layoutSectionEnabled,
        expandEnabled: expandEnabled,
        showElementBrowserLink: showElementBrowserLink,
        emojiProvider: emojiProvider,
        availableWrapperBlockTypes: availableWrapperBlockTypes,
        insertMenuItems: insertMenuItems,
        schema: editorView?.state.schema,
        numberOfButtons: numberOfButtons || 0,
        formatMessage: formatMessage
    }) : [
        ,
        []
    ];
    return {
        dropdownItems: dropdownItems,
        emojiProvider: emojiProvider,
        isTypeAheadAllowed: isTypeAheadAllowed
    };
};

});
parcelRegister("hJx37", function(module, exports) {
$parcel$export(module.exports, "createItems", () => $78c41afe212ee3e4$export$af56db357559c888);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5PQOA = parcelRequire("5PQOA");

var $LFmXM = parcelRequire("LFmXM");

var $6Exgk = parcelRequire("6Exgk");

var $TgnAJ = parcelRequire("TgnAJ");
var $46A2h = parcelRequire("46A2h");

var $eGOwo = parcelRequire("eGOwo");

var $92xoS = parcelRequire("92xoS");

var $36pe9 = parcelRequire("36pe9");

var $fN6Kr = parcelRequire("fN6Kr");
const $78c41afe212ee3e4$var$buttonToItem = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))((button)=>({
        ...button,
        title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6Exgk.ToolTipContent), {
            description: button.content,
            shortcutOverride: button.shortcut
        })
    }));
const $78c41afe212ee3e4$var$buttonToDropdownItem = (0, $LFmXM.default)((title)=>(0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))((button)=>({
            ...button,
            title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6Exgk.ToolTipContent), {
                description: title,
                shortcutOverride: "/"
            })
        })));
const $78c41afe212ee3e4$var$createInsertBlockItems = (config)=>{
    const { isTypeAheadAllowed: isTypeAheadAllowed, tableSupported: tableSupported, tableSelectorSupported: tableSelectorSupported, mediaUploadsEnabled: mediaUploadsEnabled, mediaSupported: mediaSupported, imageUploadSupported: imageUploadSupported, imageUploadEnabled: imageUploadEnabled, mentionsSupported: mentionsSupported, mentionsDisabled: mentionsDisabled, availableWrapperBlockTypes: availableWrapperBlockTypes, actionSupported: actionSupported, decisionSupported: decisionSupported, showElementBrowserLink: showElementBrowserLink, linkSupported: linkSupported, linkDisabled: linkDisabled, emojiDisabled: emojiDisabled, emojiProvider: emojiProvider, hasEmojiPlugin: hasEmojiPlugin, hasMentionsPlugin: hasMentionsPlugin, hasMediaPlugin: hasMediaPlugin, nativeStatusSupported: nativeStatusSupported, insertMenuItems: insertMenuItems, dateEnabled: dateEnabled, placeholderTextEnabled: placeholderTextEnabled, horizontalRuleEnabled: horizontalRuleEnabled, layoutSectionEnabled: layoutSectionEnabled, expandEnabled: expandEnabled, numberOfButtons: numberOfButtons, schema: schema, formatMessage: formatMessage, isEditorOffline: isEditorOffline } = config;
    const items = [];
    const isOffline = isEditorOffline === true;
    if (actionSupported) items.push((0, $36pe9.action)({
        content: formatMessage((0, $46A2h.toolbarInsertBlockMessages).action),
        tooltipDescription: formatMessage((0, $46A2h.toolbarInsertBlockMessages).actionDescription),
        disabled: false
    }));
    if (linkSupported) items.push((0, $36pe9.link)({
        content: formatMessage((0, $46A2h.toolbarInsertBlockMessages).link),
        tooltipDescription: formatMessage((0, $46A2h.toolbarInsertBlockMessages).linkDescription),
        disabled: !!linkDisabled,
        'aria-haspopup': 'dialog'
    }));
    if ((0, $92xoS.editorExperiment)('platform_editor_prevent_toolbar_layout_shifts', true)) {
        if (imageUploadSupported) items.push((0, $36pe9.imageUpload)({
            content: formatMessage((0, $46A2h.toolbarInsertBlockMessages).image),
            disabled: !imageUploadEnabled || isOffline
        }));
        else if (hasMediaPlugin) items.push((0, $36pe9.media)({
            content: formatMessage((0, $46A2h.toolbarInsertBlockMessages).addMediaFiles),
            tooltipDescription: formatMessage((0, $46A2h.toolbarInsertBlockMessages).mediaFilesDescription),
            disabled: isOffline || !mediaSupported || !mediaUploadsEnabled
        }));
        if (hasMentionsPlugin) items.push((0, $36pe9.mention)({
            content: formatMessage((0, $46A2h.toolbarInsertBlockMessages).mention),
            tooltipDescription: formatMessage((0, $46A2h.toolbarInsertBlockMessages).mentionDescription),
            disabled: !isTypeAheadAllowed || !!mentionsDisabled || !mentionsSupported,
            'aria-haspopup': 'listbox'
        }));
        if (hasEmojiPlugin) items.push((0, $36pe9.emoji)({
            content: formatMessage((0, $46A2h.toolbarInsertBlockMessages).emoji),
            tooltipDescription: formatMessage((0, $46A2h.toolbarInsertBlockMessages).emojiDescription),
            disabled: emojiDisabled || !isTypeAheadAllowed || !emojiProvider,
            'aria-haspopup': 'dialog'
        }));
    } else {
        if (mediaSupported && mediaUploadsEnabled) items.push((0, $36pe9.media)({
            content: formatMessage((0, $46A2h.toolbarInsertBlockMessages).addMediaFiles),
            tooltipDescription: formatMessage((0, $46A2h.toolbarInsertBlockMessages).mediaFilesDescription),
            disabled: isOffline
        }));
        if (imageUploadSupported) items.push((0, $36pe9.imageUpload)({
            content: formatMessage((0, $46A2h.toolbarInsertBlockMessages).image),
            disabled: !imageUploadEnabled || isOffline
        }));
        if (mentionsSupported) items.push((0, $36pe9.mention)({
            content: formatMessage((0, $46A2h.toolbarInsertBlockMessages).mention),
            tooltipDescription: formatMessage((0, $46A2h.toolbarInsertBlockMessages).mentionDescription),
            disabled: !isTypeAheadAllowed || !!mentionsDisabled,
            'aria-haspopup': 'listbox'
        }));
        if (emojiProvider) items.push((0, $36pe9.emoji)({
            content: formatMessage((0, $46A2h.toolbarInsertBlockMessages).emoji),
            tooltipDescription: formatMessage((0, $46A2h.toolbarInsertBlockMessages).emojiDescription),
            disabled: emojiDisabled || !isTypeAheadAllowed,
            'aria-haspopup': 'dialog'
        }));
    }
    if (tableSupported) items.push((0, $36pe9.table)({
        content: formatMessage((0, $46A2h.toolbarInsertBlockMessages).table),
        tooltipDescription: formatMessage((0, $46A2h.toolbarInsertBlockMessages).tableDescription),
        disabled: false
    }));
    if (tableSupported && tableSelectorSupported) items.push((0, $36pe9.tableSelector)({
        content: formatMessage((0, $46A2h.toolbarInsertBlockMessages).tableSelector),
        tooltipDescription: formatMessage((0, $46A2h.toolbarInsertBlockMessages).tableSelectorDescription),
        disabled: false
    }));
    if (layoutSectionEnabled) {
        const labelColumns = formatMessage((0, $46A2h.toolbarInsertBlockMessages).columns);
        items.push((0, $36pe9.layout)({
            content: labelColumns,
            tooltipDescription: formatMessage((0, $46A2h.toolbarInsertBlockMessages).columnsDescription),
            disabled: false
        }));
    }
    const blockTypes = availableWrapperBlockTypes || [];
    const codeblockData = blockTypes.find((type)=>type.name === 'codeblock');
    const panelData = blockTypes.find((type)=>type.name === 'panel');
    const blockquoteData = blockTypes.find((type)=>type.name === 'blockquote');
    if (codeblockData) items.push((0, $36pe9.codeblock)({
        content: formatMessage(codeblockData.title),
        tooltipDescription: formatMessage((0, $TgnAJ.messages).codeblockDescription),
        disabled: false,
        shortcut: '```'
    }));
    if (panelData) items.push((0, $36pe9.panel)({
        content: formatMessage(panelData.title),
        tooltipDescription: formatMessage((0, $TgnAJ.messages).infoPanelDescription),
        disabled: false
    }));
    if (blockquoteData) items.push((0, $36pe9.blockquote)({
        content: formatMessage(blockquoteData.title),
        tooltipDescription: formatMessage((0, $TgnAJ.messages).blockquoteDescription),
        disabled: false,
        shortcut: '>'
    }));
    if (decisionSupported) items.push((0, $36pe9.decision)({
        content: formatMessage((0, $46A2h.toolbarInsertBlockMessages).decision),
        tooltipDescription: formatMessage((0, $46A2h.toolbarInsertBlockMessages).decisionDescription),
        disabled: false
    }));
    if (horizontalRuleEnabled && schema.nodes.rule) items.push((0, $36pe9.horizontalrule)({
        content: formatMessage((0, $46A2h.toolbarInsertBlockMessages).horizontalRule),
        tooltipDescription: formatMessage((0, $46A2h.toolbarInsertBlockMessages).horizontalRuleDescription),
        disabled: false
    }));
    if (expandEnabled && schema.nodes.expand) items.push((0, $36pe9.expand)({
        content: formatMessage((0, $46A2h.toolbarInsertBlockMessages).expand),
        tooltipDescription: formatMessage((0, $46A2h.toolbarInsertBlockMessages).expandDescription),
        disabled: false
    }));
    if (dateEnabled) {
        const labelDate = formatMessage((0, $46A2h.toolbarInsertBlockMessages).date);
        items.push((0, $36pe9.date)({
            content: labelDate,
            tooltipDescription: formatMessage((0, $46A2h.toolbarInsertBlockMessages).dateDescription),
            disabled: false
        }));
    }
    if (placeholderTextEnabled) items.push((0, $36pe9.placeholder)({
        content: formatMessage((0, $46A2h.toolbarInsertBlockMessages).placeholderText),
        disabled: false
    }));
    if (nativeStatusSupported) {
        const labelStatus = formatMessage((0, $46A2h.toolbarInsertBlockMessages).status);
        items.push((0, $36pe9.status)({
            content: labelStatus,
            tooltipDescription: formatMessage((0, $46A2h.toolbarInsertBlockMessages).statusDescription),
            disabled: false
        }));
    }
    if (insertMenuItems) items.push(...insertMenuItems);
    if (showElementBrowserLink && !(0, $eGOwo.fg)('platform_editor_refactor_view_more')) items.push((0, $36pe9.more)({
        content: formatMessage((0, $46A2h.toolbarInsertBlockMessages).viewMore),
        disabled: false
    }));
    let numButtonsAdjusted = numberOfButtons;
    if ((0, $eGOwo.fg)('platform_editor_toolbar_responsive_fixes')) {
        if (items.slice(0, numButtonsAdjusted).some((item)=>item.value.name === 'table selector')) numButtonsAdjusted++;
    } else numButtonsAdjusted = tableSupported && tableSelectorSupported ? numberOfButtons + 1 : numberOfButtons;
    const buttonItems = items.slice(0, numButtonsAdjusted).map($78c41afe212ee3e4$var$buttonToItem);
    const remainingItems = items.slice(numButtonsAdjusted).filter(({ value: { name: name } })=>name !== 'table selector');
    const dropdownItems = remainingItems.map($78c41afe212ee3e4$var$buttonToDropdownItem(formatMessage((0, $46A2h.toolbarInsertBlockMessages).insertMenu)));
    return [
        buttonItems,
        dropdownItems
    ];
};
const $78c41afe212ee3e4$export$af56db357559c888 = (0, $LFmXM.default)($78c41afe212ee3e4$var$createInsertBlockItems, (0, $fN6Kr.shallowEquals));

});
parcelRegister("36pe9", function(module, exports) {
$parcel$export(module.exports, "action", () => $d46d5a7e8159e67d$export$31eb53bd5b582a97);
$parcel$export(module.exports, "link", () => $d46d5a7e8159e67d$export$9c30223ca0a664fb);
$parcel$export(module.exports, "media", () => $d46d5a7e8159e67d$export$987d49ffe1b0900f);
$parcel$export(module.exports, "imageUpload", () => $d46d5a7e8159e67d$export$d5dd7159835f64ad);
$parcel$export(module.exports, "mention", () => $d46d5a7e8159e67d$export$db83999c14438df4);
$parcel$export(module.exports, "emoji", () => $d46d5a7e8159e67d$export$a19185d1233fc4b2);
$parcel$export(module.exports, "table", () => $d46d5a7e8159e67d$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableSelector", () => $d46d5a7e8159e67d$export$614b510decb5e0d8);
$parcel$export(module.exports, "layout", () => $d46d5a7e8159e67d$export$b3219800bda33a1f);
$parcel$export(module.exports, "codeblock", () => $d46d5a7e8159e67d$export$c0626db977961abf);
$parcel$export(module.exports, "panel", () => $d46d5a7e8159e67d$export$21f42ab9b6679f44);
$parcel$export(module.exports, "blockquote", () => $d46d5a7e8159e67d$export$67dc04e652a298ca);
$parcel$export(module.exports, "decision", () => $d46d5a7e8159e67d$export$29bcf506ab92b297);
$parcel$export(module.exports, "horizontalrule", () => $d46d5a7e8159e67d$export$f7cc6d560fcfab9b);
$parcel$export(module.exports, "expand", () => $d46d5a7e8159e67d$export$9f77e0932fb78f72);
$parcel$export(module.exports, "date", () => $d46d5a7e8159e67d$export$324d90190a8b822a);
$parcel$export(module.exports, "placeholder", () => $d46d5a7e8159e67d$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "status", () => $d46d5a7e8159e67d$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "more", () => $d46d5a7e8159e67d$export$a627d162e8aad100);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $LFmXM = parcelRequire("LFmXM");

var $6Exgk = parcelRequire("6Exgk");

var $2dMzB = parcelRequire("2dMzB");

var $1ILIS = parcelRequire("1ILIS");

var $iHaKK = parcelRequire("iHaKK");

var $cnLJM = parcelRequire("cnLJM");

var $73PB0 = parcelRequire("73PB0");

var $5lAAn = parcelRequire("5lAAn");

var $cu3lN = parcelRequire("cu3lN");

var $luDPF = parcelRequire("luDPF");

var $lhPrb = parcelRequire("lhPrb");

var $dbsNQ = parcelRequire("dbsNQ");

var $92GYt = parcelRequire("92GYt");

var $9or4V = parcelRequire("9or4V");

var $9ucqS = parcelRequire("9ucqS");

var $hyxYz = parcelRequire("hyxYz");

var $aBcWs = parcelRequire("aBcWs");

var $dTYnh = parcelRequire("dTYnh");

var $i2fvj = parcelRequire("i2fvj");

var $8pzQh = parcelRequire("8pzQh");

var $bwM92 = parcelRequire("bwM92");

var $a9Y5z = parcelRequire("a9Y5z");

var $52PFA = parcelRequire("52PFA");

var $eta4I = parcelRequire("eta4I");

var $fN6Kr = parcelRequire("fN6Kr");
const $d46d5a7e8159e67d$var$from = (init)=>({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        value: {
            name: init.name
        },
        elemBefore: /*#__PURE__*/ (0, $1NIU8.jsx)(init.Icon, {
            label: "",
            color: "currentColor",
            spacing: "spacious"
        }),
        elemAfter: init.shortcut ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: (0, $2dMzB.shortcutStyle)
        }, init.shortcut) : undefined,
        'aria-label': init.shortcut ? init.content + ' ' + init.shortcut : init.content,
        'aria-haspopup': init['aria-haspopup'],
        'aria-keyshortcuts': init['aria-keyshortcuts'],
        shortcut: init.shortcut,
        isDisabled: init.disabled
    });
const $d46d5a7e8159e67d$var$mem = (fn)=>(0, $LFmXM.default)(fn, (0, $fN6Kr.shallowEquals));
const $d46d5a7e8159e67d$export$31eb53bd5b582a97 = $d46d5a7e8159e67d$var$mem((init)=>{
    return $d46d5a7e8159e67d$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'action',
        shortcut: '[]',
        Icon: ()=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bwM92))), {
                label: "",
                color: "currentColor",
                spacing: "spacious",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($a9Y5z)))
            }),
        'aria-keyshortcuts': '[ ] Space'
    });
});
const $d46d5a7e8159e67d$export$9c30223ca0a664fb = $d46d5a7e8159e67d$var$mem((init)=>$d46d5a7e8159e67d$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'link',
        shortcut: (0, $6Exgk.tooltip)((0, $6Exgk.addLink)),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($9ucqS))),
        'aria-haspopup': init['aria-haspopup'],
        'aria-keyshortcuts': (0, $6Exgk.getAriaKeyshortcuts)((0, $6Exgk.addLink))
    }));
const $d46d5a7e8159e67d$export$987d49ffe1b0900f = $d46d5a7e8159e67d$var$mem((init)=>$d46d5a7e8159e67d$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'media',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($92GYt)))
    }));
const $d46d5a7e8159e67d$export$d5dd7159835f64ad = $d46d5a7e8159e67d$var$mem((init)=>$d46d5a7e8159e67d$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'image upload',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($92GYt)))
    }));
const $d46d5a7e8159e67d$export$db83999c14438df4 = $d46d5a7e8159e67d$var$mem((init)=>$d46d5a7e8159e67d$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'mention',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($hyxYz))),
        shortcut: '@',
        'aria-haspopup': init['aria-haspopup'],
        'aria-keyshortcuts': 'Shift+2 Space'
    }));
const $d46d5a7e8159e67d$export$a19185d1233fc4b2 = $d46d5a7e8159e67d$var$mem((init)=>$d46d5a7e8159e67d$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'emoji',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($lhPrb))),
        shortcut: ':',
        'aria-haspopup': init['aria-haspopup'],
        'aria-keyshortcuts': 'Shift+;'
    }));
const $d46d5a7e8159e67d$export$9852986a3ec5f6a0 = $d46d5a7e8159e67d$var$mem((init)=>$d46d5a7e8159e67d$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'table',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dbsNQ))),
        shortcut: (0, $6Exgk.tooltip)((0, $6Exgk.toggleTable)),
        'aria-keyshortcuts': (0, $6Exgk.getAriaKeyshortcuts)((0, $6Exgk.toggleTable))
    }));
const $d46d5a7e8159e67d$export$614b510decb5e0d8 = $d46d5a7e8159e67d$var$mem((init)=>$d46d5a7e8159e67d$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'table selector',
        Icon: ()=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
                label: "",
                color: "currentColor",
                size: "small"
            })
    }));
const $d46d5a7e8159e67d$export$b3219800bda33a1f = $d46d5a7e8159e67d$var$mem((init)=>$d46d5a7e8159e67d$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'layout',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($9or4V)))
    }));
const $d46d5a7e8159e67d$export$c0626db977961abf = $d46d5a7e8159e67d$var$mem((init)=>$d46d5a7e8159e67d$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'codeblock',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($cnLJM))),
        shortcut: init.shortcut,
        'aria-keyshortcuts': (0, $6Exgk.getAriaKeyshortcuts)(init.shortcut)
    }));
const $d46d5a7e8159e67d$export$21f42ab9b6679f44 = $d46d5a7e8159e67d$var$mem((init)=>$d46d5a7e8159e67d$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'panel',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($8pzQh))),
        shortcut: init.shortcut,
        'aria-keyshortcuts': (0, $6Exgk.getAriaKeyshortcuts)(init.shortcut)
    }));
const $d46d5a7e8159e67d$export$67dc04e652a298ca = $d46d5a7e8159e67d$var$mem((init)=>$d46d5a7e8159e67d$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'blockquote',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dTYnh))),
        shortcut: init.shortcut,
        'aria-keyshortcuts': 'Shift+. Space'
    }));
const $d46d5a7e8159e67d$export$29bcf506ab92b297 = $d46d5a7e8159e67d$var$mem((init)=>$d46d5a7e8159e67d$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'decision',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($luDPF))),
        shortcut: '<>',
        'aria-keyshortcuts': 'Shift+, Shift+. Space'
    }));
const $d46d5a7e8159e67d$export$f7cc6d560fcfab9b = $d46d5a7e8159e67d$var$mem((init)=>$d46d5a7e8159e67d$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'horizontalrule',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($aBcWs))),
        shortcut: '---',
        'aria-keyshortcuts': '- - -'
    }));
const $d46d5a7e8159e67d$export$9f77e0932fb78f72 = $d46d5a7e8159e67d$var$mem((init)=>$d46d5a7e8159e67d$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'expand',
        Icon: (iconProps)=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cu3lN))), {
                label: iconProps.label,
                size: "small"
            })
    }));
const $d46d5a7e8159e67d$export$324d90190a8b822a = $d46d5a7e8159e67d$var$mem((init)=>$d46d5a7e8159e67d$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'date',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($73PB0))),
        shortcut: '//',
        'aria-keyshortcuts': '/ / Enter'
    }));
const $d46d5a7e8159e67d$export$c7187bbd1a7a9244 = $d46d5a7e8159e67d$var$mem((init)=>$d46d5a7e8159e67d$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'placeholder text',
        Icon: ()=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1ILIS))), {
                label: "",
                spacing: "spacious",
                color: "currentColor",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($52PFA)))
            })
    }));
const $d46d5a7e8159e67d$export$471f7ae5c4103ae1 = $d46d5a7e8159e67d$var$mem((init)=>$d46d5a7e8159e67d$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'status',
        Icon: ()=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iHaKK))), {
                label: "",
                color: "currentColor",
                spacing: "spacious",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($eta4I)))
            })
    }));
const $d46d5a7e8159e67d$export$a627d162e8aad100 = $d46d5a7e8159e67d$var$mem((init)=>$d46d5a7e8159e67d$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'macro',
        Icon: ()=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i2fvj))), {
                label: "",
                color: "currentColor"
            })
    }));

});
parcelRegister("1ILIS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b0cd8dd83f623ffc8a93c918c96c1a11>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $140eeb4366ba52e5$var$_react = $140eeb4366ba52e5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $140eeb4366ba52e5$var$_baseNew = $140eeb4366ba52e5$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $140eeb4366ba52e5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FieldText".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $140eeb4366ba52e5$var$FieldTextIcon = (props)=>/*#__PURE__*/ $140eeb4366ba52e5$var$_react.default.createElement($140eeb4366ba52e5$var$_baseNew.default, Object.assign({
        name: "FieldTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.75 2.5H8V1h5v1.5h-1.75v2H14a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-2.75v2H13V15H8v-1.5h1.75zm1.5 7.5H14a.5.5 0 0 0 .5-.5v-3A.5.5 0 0 0 14 6h-2.75zM2 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h6v1.5H2a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h6V6z" clip-rule="evenodd"/>`
    }, props));
$140eeb4366ba52e5$var$FieldTextIcon.displayName = 'FieldTextIcon';
var $140eeb4366ba52e5$var$_default = module.exports.default = $140eeb4366ba52e5$var$FieldTextIcon;

});

parcelRegister("iHaKK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0c82000dc806c2316f0968120fc4d10f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d9c49578a1a4196a$var$_react = $d9c49578a1a4196a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d9c49578a1a4196a$var$_baseNew = $d9c49578a1a4196a$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $d9c49578a1a4196a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Lozenge".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for inserting status lozenges in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d9c49578a1a4196a$var$LozengeIcon = (props)=>/*#__PURE__*/ $d9c49578a1a4196a$var$_react.default.createElement($d9c49578a1a4196a$var$_baseNew.default, Object.assign({
        name: "LozengeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V6a.5.5 0 0 0-.5-.5zm11 3.25H3v-1.5h10z" clip-rule="evenodd"/>`
    }, props));
$d9c49578a1a4196a$var$LozengeIcon.displayName = 'LozengeIcon';
var $d9c49578a1a4196a$var$_default = module.exports.default = $d9c49578a1a4196a$var$LozengeIcon;

});

parcelRegister("cnLJM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::666490f25e634884d5c2169b0cfbe1fa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $903ca9af37aa0f5e$var$_react = $903ca9af37aa0f5e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $903ca9af37aa0f5e$var$_angleBrackets = $903ca9af37aa0f5e$var$_interopRequireDefault((parcelRequire("8lO5P")));

var $903ca9af37aa0f5e$var$_code = $903ca9af37aa0f5e$var$_interopRequireDefault((parcelRequire("Uzddr")));
function $903ca9af37aa0f5e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AngleBracketsIcon.
 * This component is AngleBracketsIcon, with `UNSAFE_fallbackIcon` set to "EditorCodeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $903ca9af37aa0f5e$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $903ca9af37aa0f5e$var$_react.default.createElement($903ca9af37aa0f5e$var$_angleBrackets.default, Object.assign({
        name: "AngleBracketsIcon",
        LEGACY_fallbackIcon: $903ca9af37aa0f5e$var$_code.default
    }, props));
$903ca9af37aa0f5e$var$AngleBracketsIcon.displayName = 'AngleBracketsIconMigration';
var $903ca9af37aa0f5e$var$_default = module.exports.default = $903ca9af37aa0f5e$var$AngleBracketsIcon;

});
parcelRegister("Uzddr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0aa08b7a66d33e6a$var$_react = $0aa08b7a66d33e6a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $0aa08b7a66d33e6a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0aa08b7a66d33e6a$var$EditorCodeIcon = (props)=>/*#__PURE__*/ $0aa08b7a66d33e6a$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M10.208 7.308a1.09 1.09 0 0 1 0 1.483l-3.515 3.71 3.515 3.708a1.09 1.09 0 0 1 0 1.483.957.957 0 0 1-1.405 0l-3.866-4.08a1.635 1.635 0 0 1 0-2.225l3.866-4.08a.957.957 0 0 1 1.405 0m3.584 0a.957.957 0 0 1 1.405 0l3.866 4.08c.583.614.583 1.61 0 2.225l-3.866 4.08a.957.957 0 0 1-1.405 0 1.09 1.09 0 0 1 0-1.484l3.515-3.708-3.515-3.71a1.09 1.09 0 0 1 0-1.483"/></svg>`
    }, props));
$0aa08b7a66d33e6a$var$EditorCodeIcon.displayName = 'EditorCodeIcon';
var $0aa08b7a66d33e6a$var$_default = module.exports.default = $0aa08b7a66d33e6a$var$EditorCodeIcon;

});


parcelRegister("73PB0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ebcd1de31972e031048867b7cb16b5d6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5240d6186bebd6ee$var$_react = $5240d6186bebd6ee$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5240d6186bebd6ee$var$_calendar = $5240d6186bebd6ee$var$_interopRequireDefault((parcelRequire("btkTq")));

var $5240d6186bebd6ee$var$_date = $5240d6186bebd6ee$var$_interopRequireDefault((parcelRequire("cyebN")));
function $5240d6186bebd6ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CalendarIcon.
 * This component is CalendarIcon, with `UNSAFE_fallbackIcon` set to "EditorDateIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5240d6186bebd6ee$var$CalendarIcon = (props)=>/*#__PURE__*/ $5240d6186bebd6ee$var$_react.default.createElement($5240d6186bebd6ee$var$_calendar.default, Object.assign({
        name: "CalendarIcon",
        LEGACY_fallbackIcon: $5240d6186bebd6ee$var$_date.default
    }, props));
$5240d6186bebd6ee$var$CalendarIcon.displayName = 'CalendarIconMigration';
var $5240d6186bebd6ee$var$_default = module.exports.default = $5240d6186bebd6ee$var$CalendarIcon;

});
parcelRegister("cyebN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9233aab1d35cbddc$var$_react = $9233aab1d35cbddc$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $9233aab1d35cbddc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9233aab1d35cbddc$var$EditorDateIcon = (props)=>/*#__PURE__*/ $9233aab1d35cbddc$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 8.51c0-.282.229-.51.5-.51h11c.276 0 .5.228.5.51v8.98c0 .282-.229.51-.5.51h-11a.505.505 0 0 1-.5-.51zm2 2.995v.99c0 .291.226.505.505.505h.99a.497.497 0 0 0 .505-.505v-.99A.497.497 0 0 0 9.495 11h-.99a.497.497 0 0 0-.505.505m3 0v.99c0 .291.226.505.505.505h.99a.497.497 0 0 0 .505-.505v-.99a.497.497 0 0 0-.505-.505h-.99a.497.497 0 0 0-.505.505m-3 3v.99c0 .291.226.505.505.505h.99a.497.497 0 0 0 .505-.505v-.99A.497.497 0 0 0 9.495 14h-.99a.497.497 0 0 0-.505.505M7.5 8v1h3V8zm6 0v1h3V8zm.5-1.495c0-.279.214-.505.505-.505h.99c.279 0 .505.214.505.505V8h-2zm-6 0C8 6.226 8.214 6 8.505 6h.99c.279 0 .505.214.505.505V8H8z"/></svg>`
    }, props));
$9233aab1d35cbddc$var$EditorDateIcon.displayName = 'EditorDateIcon';
var $9233aab1d35cbddc$var$_default = module.exports.default = $9233aab1d35cbddc$var$EditorDateIcon;

});


parcelRegister("cu3lN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4aaa99e30c6c75833f1e95013ae6432f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $916ae2bca38bb870$var$_react = $916ae2bca38bb870$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $916ae2bca38bb870$var$_chevronRight = $916ae2bca38bb870$var$_interopRequireDefault((parcelRequire("cQxBL")));

var $916ae2bca38bb870$var$_chevronRightCircle = $916ae2bca38bb870$var$_interopRequireDefault((parcelRequire("kYD0I")));
function $916ae2bca38bb870$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Next page of pagination results, collapsed tree item, expand tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $916ae2bca38bb870$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $916ae2bca38bb870$var$_react.default.createElement($916ae2bca38bb870$var$_chevronRight.default, Object.assign({
        name: "ChevronRightIcon",
        LEGACY_fallbackIcon: $916ae2bca38bb870$var$_chevronRightCircle.default
    }, props));
$916ae2bca38bb870$var$ChevronRightIcon.displayName = 'ChevronRightIconMigration';
var $916ae2bca38bb870$var$_default = module.exports.default = $916ae2bca38bb870$var$ChevronRightIcon;

});
parcelRegister("kYD0I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $03f0e5dec31656bc$var$_react = $03f0e5dec31656bc$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $03f0e5dec31656bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $03f0e5dec31656bc$var$ChevronRightCircleIcon = (props)=>/*#__PURE__*/ $03f0e5dec31656bc$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M10.294 9.698a.99.99 0 0 1 0-1.407 1.01 1.01 0 0 1 1.419 0l2.965 2.94a1.09 1.09 0 0 1 0 1.548l-2.955 2.93a1.01 1.01 0 0 1-1.42 0 .99.99 0 0 1 0-1.407l2.318-2.297z"/></g></svg>`
    }, props));
$03f0e5dec31656bc$var$ChevronRightCircleIcon.displayName = 'ChevronRightCircleIcon';
var $03f0e5dec31656bc$var$_default = module.exports.default = $03f0e5dec31656bc$var$ChevronRightCircleIcon;

});


parcelRegister("luDPF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::09b32cb7d4442686961e5cde83b86b0a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fa5b4c2ffbdf39ba$var$_react = $fa5b4c2ffbdf39ba$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fa5b4c2ffbdf39ba$var$_decision = $fa5b4c2ffbdf39ba$var$_interopRequireDefault((parcelRequire("kXFxs")));

var $fa5b4c2ffbdf39ba$var$_decision2 = $fa5b4c2ffbdf39ba$var$_interopRequireDefault((parcelRequire("fvh9f")));
function $fa5b4c2ffbdf39ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DecisionIcon.
 * This component is DecisionIcon, with `UNSAFE_fallbackIcon` set to "EditorDecisionIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fa5b4c2ffbdf39ba$var$DecisionIcon = (props)=>/*#__PURE__*/ $fa5b4c2ffbdf39ba$var$_react.default.createElement($fa5b4c2ffbdf39ba$var$_decision.default, Object.assign({
        name: "DecisionIcon",
        LEGACY_fallbackIcon: $fa5b4c2ffbdf39ba$var$_decision2.default
    }, props));
$fa5b4c2ffbdf39ba$var$DecisionIcon.displayName = 'DecisionIconMigration';
var $fa5b4c2ffbdf39ba$var$_default = module.exports.default = $fa5b4c2ffbdf39ba$var$DecisionIcon;

});
parcelRegister("kXFxs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4cf6befe44e2552b8aec07f847b9be00>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f4298a06d23defad$var$_react = $f4298a06d23defad$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f4298a06d23defad$var$_baseNew = $f4298a06d23defad$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $f4298a06d23defad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Decision".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f4298a06d23defad$var$DecisionIcon = (props)=>/*#__PURE__*/ $f4298a06d23defad$var$_react.default.createElement($f4298a06d23defad$var$_baseNew.default, Object.assign({
        name: "DecisionIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m13.97.97-4.5 4.5 1.06 1.06 4.5-4.5zM3.56 2.5H8V1H1.75a.75.75 0 0 0-.75.75V8h1.5V3.56l4.604 4.604a.5.5 0 0 1 .146.354V15h1.5V8.518a2 2 0 0 0-.586-1.414z" clip-rule="evenodd"/>`
    }, props));
$f4298a06d23defad$var$DecisionIcon.displayName = 'DecisionIcon';
var $f4298a06d23defad$var$_default = module.exports.default = $f4298a06d23defad$var$DecisionIcon;

});

parcelRegister("fvh9f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4970d82e75d8a32$var$_react = $b4970d82e75d8a32$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $b4970d82e75d8a32$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b4970d82e75d8a32$var$EditorDecisionIcon = (props)=>/*#__PURE__*/ $b4970d82e75d8a32$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.414 8 3.293 3.293c.187.187.293.442.293.707v5a1 1 0 0 1-2 0v-4.586l-3-3V10.5a1 1 0 0 1-2 0V7a1 1 0 0 1 1-1h3.5a1 1 0 0 1 0 2zm8.293-1.707a1 1 0 0 1 0 1.414l-2.5 2.5a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l2.5-2.5a1 1 0 0 1 1.414 0"/></svg>`
    }, props));
$b4970d82e75d8a32$var$EditorDecisionIcon.displayName = 'EditorDecisionIcon';
var $b4970d82e75d8a32$var$_default = module.exports.default = $b4970d82e75d8a32$var$EditorDecisionIcon;

});


parcelRegister("lhPrb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::76c3d1c8c171022a94e8d1953855fefa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7f315edef134345$var$_react = $f7f315edef134345$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f7f315edef134345$var$_emoji = $f7f315edef134345$var$_interopRequireDefault((parcelRequire("euu4D")));

var $f7f315edef134345$var$_emoji2 = $f7f315edef134345$var$_interopRequireDefault((parcelRequire("gF0HQ")));
function $f7f315edef134345$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EmojiIcon.
 * This component is EmojiIcon, with `UNSAFE_fallbackIcon` set to "EditorEmojiIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Editor as a category for Emoji's.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f7f315edef134345$var$EmojiIcon = (props)=>/*#__PURE__*/ $f7f315edef134345$var$_react.default.createElement($f7f315edef134345$var$_emoji.default, Object.assign({
        name: "EmojiIcon",
        LEGACY_fallbackIcon: $f7f315edef134345$var$_emoji2.default
    }, props));
$f7f315edef134345$var$EmojiIcon.displayName = 'EmojiIconMigration';
var $f7f315edef134345$var$_default = module.exports.default = $f7f315edef134345$var$EmojiIcon;

});
parcelRegister("gF0HQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c21105e2bf1e9d5b$var$_react = $c21105e2bf1e9d5b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $c21105e2bf1e9d5b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c21105e2bf1e9d5b$var$EditorEmojiIcon = (props)=>/*#__PURE__*/ $c21105e2bf1e9d5b$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 5a7 7 0 1 1 0 14 7 7 0 0 1 0-14m0 12.5c3.033 0 5.5-2.467 5.5-5.5S15.033 6.5 12 6.5A5.506 5.506 0 0 0 6.5 12c0 3.033 2.467 5.5 5.5 5.5m-1.5-6a1 1 0 1 1 0-2 1 1 0 0 1 0 2m3 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2m.27 1.583a.626.626 0 0 1 .932.834A3.63 3.63 0 0 1 12 15.125a3.63 3.63 0 0 1-2.698-1.204.625.625 0 0 1 .93-.835c.901 1.003 2.639 1.003 3.538-.003"/></svg>`
    }, props));
$c21105e2bf1e9d5b$var$EditorEmojiIcon.displayName = 'EditorEmojiIcon';
var $c21105e2bf1e9d5b$var$_default = module.exports.default = $c21105e2bf1e9d5b$var$EditorEmojiIcon;

});


parcelRegister("dbsNQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ca341356ec7e14a1634869a278921cc5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9992a518a827fbb5$var$_react = $9992a518a827fbb5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9992a518a827fbb5$var$_grid = $9992a518a827fbb5$var$_interopRequireDefault((parcelRequire("1U4zO")));

var $9992a518a827fbb5$var$_table = $9992a518a827fbb5$var$_interopRequireDefault((parcelRequire("XRjx0")));
function $9992a518a827fbb5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for GridIcon.
 * This component is GridIcon, with `UNSAFE_fallbackIcon` set to "EditorTableIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: spaces in Confluence, and grid view, all content in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9992a518a827fbb5$var$GridIcon = (props)=>/*#__PURE__*/ $9992a518a827fbb5$var$_react.default.createElement($9992a518a827fbb5$var$_grid.default, Object.assign({
        name: "GridIcon",
        LEGACY_fallbackIcon: $9992a518a827fbb5$var$_table.default
    }, props));
$9992a518a827fbb5$var$GridIcon.displayName = 'GridIconMigration';
var $9992a518a827fbb5$var$_default = module.exports.default = $9992a518a827fbb5$var$GridIcon;

});
parcelRegister("XRjx0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0b3edddb5f77a4f6$var$_react = $0b3edddb5f77a4f6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $0b3edddb5f77a4f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0b3edddb5f77a4f6$var$EditorTableIcon = (props)=>/*#__PURE__*/ $0b3edddb5f77a4f6$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 6h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2m0 2v3h3V8zm5 0v3h3V8zm-5 5v3h3v-3zm5 0v3h3v-3z"/></svg>`
    }, props));
$0b3edddb5f77a4f6$var$EditorTableIcon.displayName = 'EditorTableIcon';
var $0b3edddb5f77a4f6$var$_default = module.exports.default = $0b3edddb5f77a4f6$var$EditorTableIcon;

});


parcelRegister("92GYt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b83cd234d5712d22c639f33aef110659>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6955a2c45da87ccc$var$_react = $6955a2c45da87ccc$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $6955a2c45da87ccc$var$_image = $6955a2c45da87ccc$var$_interopRequireDefault((parcelRequire("fJNLD")));

var $6955a2c45da87ccc$var$_image2 = $6955a2c45da87ccc$var$_interopRequireDefault((parcelRequire("3h9bV")));
function $6955a2c45da87ccc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ImageIcon.
 * This component is ImageIcon, with `UNSAFE_fallbackIcon` set to "EditorImageIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: images, image upload.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6955a2c45da87ccc$var$ImageIcon = (props)=>/*#__PURE__*/ $6955a2c45da87ccc$var$_react.default.createElement($6955a2c45da87ccc$var$_image.default, Object.assign({
        name: "ImageIcon",
        LEGACY_fallbackIcon: $6955a2c45da87ccc$var$_image2.default
    }, props));
$6955a2c45da87ccc$var$ImageIcon.displayName = 'ImageIconMigration';
var $6955a2c45da87ccc$var$_default = module.exports.default = $6955a2c45da87ccc$var$ImageIcon;

});
parcelRegister("3h9bV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $262a16d7e6a6b30c$var$_react = $262a16d7e6a6b30c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $262a16d7e6a6b30c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $262a16d7e6a6b30c$var$EditorImageIcon = (props)=>/*#__PURE__*/ $262a16d7e6a6b30c$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11 15-1-1-2 2h8v-1.8L14 12zM6 6.5c0-.276.229-.5.5-.5h11c.276 0 .5.229.5.5v11c0 .276-.229.5-.5.5h-11a.504.504 0 0 1-.5-.5zM9.5 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"/></svg>`
    }, props));
$262a16d7e6a6b30c$var$EditorImageIcon.displayName = 'EditorImageIcon';
var $262a16d7e6a6b30c$var$_default = module.exports.default = $262a16d7e6a6b30c$var$EditorImageIcon;

});


parcelRegister("9or4V", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4571b7e70ca52e55dc3b5128ce36d6f8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6d6b5c28bc08a4be$var$_react = $6d6b5c28bc08a4be$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $6d6b5c28bc08a4be$var$_layoutTwoColumns = $6d6b5c28bc08a4be$var$_interopRequireDefault((parcelRequire("fkTM0")));

var $6d6b5c28bc08a4be$var$_layoutTwoEqual = $6d6b5c28bc08a4be$var$_interopRequireDefault((parcelRequire("kHKYy")));
function $6d6b5c28bc08a4be$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LayoutTwoColumnsIcon.
 * This component is LayoutTwoColumnsIcon, with `UNSAFE_fallbackIcon` set to "EditorLayoutTwoEqualIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 2 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6d6b5c28bc08a4be$var$LayoutTwoColumnsIcon = (props)=>/*#__PURE__*/ $6d6b5c28bc08a4be$var$_react.default.createElement($6d6b5c28bc08a4be$var$_layoutTwoColumns.default, Object.assign({
        name: "LayoutTwoColumnsIcon",
        LEGACY_fallbackIcon: $6d6b5c28bc08a4be$var$_layoutTwoEqual.default
    }, props));
$6d6b5c28bc08a4be$var$LayoutTwoColumnsIcon.displayName = 'LayoutTwoColumnsIconMigration';
var $6d6b5c28bc08a4be$var$_default = module.exports.default = $6d6b5c28bc08a4be$var$LayoutTwoColumnsIcon;

});
parcelRegister("kHKYy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f12c433003818350$var$_react = $f12c433003818350$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $f12c433003818350$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f12c433003818350$var$EditorLayoutTwoEqualIcon = (props)=>/*#__PURE__*/ $f12c433003818350$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 5h5a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m9 0h5a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"/></svg>`
    }, props));
$f12c433003818350$var$EditorLayoutTwoEqualIcon.displayName = 'EditorLayoutTwoEqualIcon';
var $f12c433003818350$var$_default = module.exports.default = $f12c433003818350$var$EditorLayoutTwoEqualIcon;

});


parcelRegister("hyxYz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c3fc51bb51ce6dba844d651a03b45347>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc7ff793be7dd205$var$_react = $cc7ff793be7dd205$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $cc7ff793be7dd205$var$_mention = $cc7ff793be7dd205$var$_interopRequireDefault((parcelRequire("4HB8x")));

var $cc7ff793be7dd205$var$_mention2 = $cc7ff793be7dd205$var$_interopRequireDefault((parcelRequire("6cJsV")));
function $cc7ff793be7dd205$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for MentionIcon.
 * This component is MentionIcon, with `UNSAFE_fallbackIcon` set to "EditorMentionIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user mentions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cc7ff793be7dd205$var$MentionIcon = (props)=>/*#__PURE__*/ $cc7ff793be7dd205$var$_react.default.createElement($cc7ff793be7dd205$var$_mention.default, Object.assign({
        name: "MentionIcon",
        LEGACY_fallbackIcon: $cc7ff793be7dd205$var$_mention2.default
    }, props));
$cc7ff793be7dd205$var$MentionIcon.displayName = 'MentionIconMigration';
var $cc7ff793be7dd205$var$_default = module.exports.default = $cc7ff793be7dd205$var$MentionIcon;

});
parcelRegister("4HB8x", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::091705eae2c62b0ec5df7f32c6cbaf31>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36c7fc296df7b371$var$_react = $36c7fc296df7b371$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $36c7fc296df7b371$var$_baseNew = $36c7fc296df7b371$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $36c7fc296df7b371$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Mention".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user mentions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $36c7fc296df7b371$var$MentionIcon = (props)=>/*#__PURE__*/ $36c7fc296df7b371$var$_react.default.createElement($36c7fc296df7b371$var$_baseNew.default, Object.assign({
        name: "MentionIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 3.25 12.13l.75 1.3A8 8 0 1 1 16 8c0 .842-.28 1.775-.817 2.513-.547.751-1.401 1.344-2.522 1.344-.577 0-1.07-.177-1.462-.507a2.5 2.5 0 0 1-.66-.908C9.387 11.776 7.529 12.346 6 11.464 4.229 10.441 3.926 8.057 4.969 6.25S8.229 3.513 10 4.536c1.12.647 1.66 1.87 1.633 3.105l-.005.13c0 .687.038 1.397.226 1.923.091.255.201.415.313.51.098.083.242.153.494.153.536 0 .976-.27 1.31-.727.342-.47.529-1.091.529-1.63A6.5 6.5 0 0 0 8 1.5m2.133 6.102c.015-.798-.328-1.447-.883-1.767C8.39 5.339 7.02 5.698 6.268 7s-.377 2.67.482 3.165c.86.496 2.23.137 2.982-1.165.244-.422.37-.866.397-1.287z" clip-rule="evenodd"/>`
    }, props));
$36c7fc296df7b371$var$MentionIcon.displayName = 'MentionIcon';
var $36c7fc296df7b371$var$_default = module.exports.default = $36c7fc296df7b371$var$MentionIcon;

});

parcelRegister("6cJsV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4847218fcbdc0a18$var$_react = $4847218fcbdc0a18$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $4847218fcbdc0a18$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4847218fcbdc0a18$var$EditorMentionIcon = (props)=>/*#__PURE__*/ $4847218fcbdc0a18$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.062 13.93c-.904 0-1.451-.734-1.451-1.945 0-1.226.538-1.952 1.467-1.952.928 0 1.422.764 1.422 1.967 0 1.195-.502 1.93-1.438 1.93M12 5c-3.925 0-7 3.075-7 7 0 4.596 3.521 7 7 7 .874 0 1.613-.09 2.258-.279a.751.751 0 0 0-.42-1.44c-.506.147-1.108.22-1.838.22-2.649 0-5.5-1.722-5.5-5.5 0-3.085 2.415-5.5 5.5-5.5 3.239 0 5.5 1.952 5.5 4.75 0 2.045-1.044 3-1.75 3-.007 0-.75-.11-.75-.75v-4a.75.75 0 1 0-1.5 0v.187c-.347-.585-1.017-.952-1.796-.952C10.103 8.736 9 10.04 9 11.938c0 1.984 1.103 3.312 2.753 3.312.865 0 1.51-.387 1.865-1.076.334 1.016 1.37 1.576 2.132 1.576 1.598 0 3.25-1.683 3.25-4.5C19 7.628 16.058 5 12 5"/></svg>`
    }, props));
$4847218fcbdc0a18$var$EditorMentionIcon.displayName = 'EditorMentionIcon';
var $4847218fcbdc0a18$var$_default = module.exports.default = $4847218fcbdc0a18$var$EditorMentionIcon;

});


parcelRegister("aBcWs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::afc2a06d02cd5de17b8369ab9ec2ebf8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7b77661458a8237b$var$_react = $7b77661458a8237b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7b77661458a8237b$var$_minus = $7b77661458a8237b$var$_interopRequireDefault((parcelRequire("FvAEI")));

var $7b77661458a8237b$var$_horizontalRule = $7b77661458a8237b$var$_interopRequireDefault((parcelRequire("k5n7B")));
function $7b77661458a8237b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for MinusIcon.
 * This component is MinusIcon, with `UNSAFE_fallbackIcon` set to "EditorHorizontalRuleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: horizontal rule in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7b77661458a8237b$var$MinusIcon = (props)=>/*#__PURE__*/ $7b77661458a8237b$var$_react.default.createElement($7b77661458a8237b$var$_minus.default, Object.assign({
        name: "MinusIcon",
        LEGACY_fallbackIcon: $7b77661458a8237b$var$_horizontalRule.default
    }, props));
$7b77661458a8237b$var$MinusIcon.displayName = 'MinusIconMigration';
var $7b77661458a8237b$var$_default = module.exports.default = $7b77661458a8237b$var$MinusIcon;

});
parcelRegister("FvAEI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::efc4ad949a44efb0684f52ead162d030>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $07cc559c093f5ea2$var$_react = $07cc559c093f5ea2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $07cc559c093f5ea2$var$_baseNew = $07cc559c093f5ea2$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $07cc559c093f5ea2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Minus".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: horizontal rule in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $07cc559c093f5ea2$var$MinusIcon = (props)=>/*#__PURE__*/ $07cc559c093f5ea2$var$_react.default.createElement($07cc559c093f5ea2$var$_baseNew.default, Object.assign({
        name: "MinusIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 8.75H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$07cc559c093f5ea2$var$MinusIcon.displayName = 'MinusIcon';
var $07cc559c093f5ea2$var$_default = module.exports.default = $07cc559c093f5ea2$var$MinusIcon;

});

parcelRegister("k5n7B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e9f635bb59d590bd$var$_react = $e9f635bb59d590bd$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $e9f635bb59d590bd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e9f635bb59d590bd$var$EditorHorizontalRuleIcon = (props)=>/*#__PURE__*/ $e9f635bb59d590bd$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><rect width="14" height="2" x="5" y="11" fill="currentcolor" fill-rule="evenodd" rx="1"/></svg>`
    }, props));
$e9f635bb59d590bd$var$EditorHorizontalRuleIcon.displayName = 'EditorHorizontalRuleIcon';
var $e9f635bb59d590bd$var$_default = module.exports.default = $e9f635bb59d590bd$var$EditorHorizontalRuleIcon;

});


parcelRegister("dTYnh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b4086e75332955510ed2f144ae74452d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1ef3e8971d3de67$var$_react = $a1ef3e8971d3de67$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a1ef3e8971d3de67$var$_quotationMark = $a1ef3e8971d3de67$var$_interopRequireDefault((parcelRequire("amerd")));

var $a1ef3e8971d3de67$var$_quote = $a1ef3e8971d3de67$var$_interopRequireDefault((parcelRequire("8KCrB")));
function $a1ef3e8971d3de67$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for QuotationMarkIcon.
 * This component is QuotationMarkIcon, with `UNSAFE_fallbackIcon` set to "QuoteIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: blockquote, comment, testimonial, blogs in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a1ef3e8971d3de67$var$QuotationMarkIcon = (props)=>/*#__PURE__*/ $a1ef3e8971d3de67$var$_react.default.createElement($a1ef3e8971d3de67$var$_quotationMark.default, Object.assign({
        name: "QuotationMarkIcon",
        LEGACY_fallbackIcon: $a1ef3e8971d3de67$var$_quote.default
    }, props));
$a1ef3e8971d3de67$var$QuotationMarkIcon.displayName = 'QuotationMarkIconMigration';
var $a1ef3e8971d3de67$var$_default = module.exports.default = $a1ef3e8971d3de67$var$QuotationMarkIcon;

});
parcelRegister("8KCrB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $65f070d23fa99443$var$_react = $65f070d23fa99443$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $65f070d23fa99443$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $65f070d23fa99443$var$QuoteIcon = (props)=>/*#__PURE__*/ $65f070d23fa99443$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.051 6c-1.571 0-2.847 1.312-2.847 2.93 0 1.617 1.276 2.93 2.847 2.93 2.699 0 1.135 5.088-2.269 5.618a.68.68 0 0 0-.578.671c0 .416.372.745.784.682 6.187-.938 8.387-12.83 2.063-12.83M7.848 6C6.275 6 5 7.311 5 8.93c0 1.616 1.275 2.928 2.848 2.928 2.698 0 1.134 5.09-2.27 5.62a.68.68 0 0 0-.578.67c0 .416.372.745.783.682C11.972 17.892 14.172 6 7.848 6"/></svg>`
    }, props));
$65f070d23fa99443$var$QuoteIcon.displayName = 'QuoteIcon';
var $65f070d23fa99443$var$_default = module.exports.default = $65f070d23fa99443$var$QuoteIcon;

});


parcelRegister("i2fvj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::991b79665438b5f4c7ce06548b7c55db>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $03636d2c0d71bb7e$var$_react = $03636d2c0d71bb7e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $03636d2c0d71bb7e$var$_showMoreHorizontal = $03636d2c0d71bb7e$var$_interopRequireDefault((parcelRequire("NByNW")));

var $03636d2c0d71bb7e$var$_more = $03636d2c0d71bb7e$var$_interopRequireDefault((parcelRequire("fES0B")));
function $03636d2c0d71bb7e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShowMoreHorizontalIcon.
 * This component is ShowMoreHorizontalIcon, with `UNSAFE_fallbackIcon` set to "EditorMoreIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $03636d2c0d71bb7e$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $03636d2c0d71bb7e$var$_react.default.createElement($03636d2c0d71bb7e$var$_showMoreHorizontal.default, Object.assign({
        name: "ShowMoreHorizontalIcon",
        LEGACY_fallbackIcon: $03636d2c0d71bb7e$var$_more.default
    }, props));
$03636d2c0d71bb7e$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIconMigration';
var $03636d2c0d71bb7e$var$_default = module.exports.default = $03636d2c0d71bb7e$var$ShowMoreHorizontalIcon;

});
parcelRegister("fES0B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b6647c75389e5379$var$_react = $b6647c75389e5379$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $b6647c75389e5379$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b6647c75389e5379$var$EditorMoreIcon = (props)=>/*#__PURE__*/ $b6647c75389e5379$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 14a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m-4.5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m9 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"/></svg>`
    }, props));
$b6647c75389e5379$var$EditorMoreIcon.displayName = 'EditorMoreIcon';
var $b6647c75389e5379$var$_default = module.exports.default = $b6647c75389e5379$var$EditorMoreIcon;

});


parcelRegister("8pzQh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f63bc5877ceef7abf243a0cb010fc1b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $61fc760bcfd4ec40$var$_react = $61fc760bcfd4ec40$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $61fc760bcfd4ec40$var$_statusInformation = $61fc760bcfd4ec40$var$_interopRequireDefault((parcelRequire("2R0ne")));

var $61fc760bcfd4ec40$var$_info = $61fc760bcfd4ec40$var$_interopRequireDefault((parcelRequire("eAsyt")));
function $61fc760bcfd4ec40$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusInformationIcon.
 * This component is StatusInformationIcon, with `UNSAFE_fallbackIcon` set to "EditorInfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $61fc760bcfd4ec40$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $61fc760bcfd4ec40$var$_react.default.createElement($61fc760bcfd4ec40$var$_statusInformation.default, Object.assign({
        name: "StatusInformationIcon",
        LEGACY_fallbackIcon: $61fc760bcfd4ec40$var$_info.default
    }, props));
$61fc760bcfd4ec40$var$StatusInformationIcon.displayName = 'StatusInformationIconMigration';
var $61fc760bcfd4ec40$var$_default = module.exports.default = $61fc760bcfd4ec40$var$StatusInformationIcon;

});
parcelRegister("eAsyt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9ea93e742aa0026$var$_react = $a9ea93e742aa0026$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $a9ea93e742aa0026$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a9ea93e742aa0026$var$EditorInfoIcon = (props)=>/*#__PURE__*/ $a9ea93e742aa0026$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m0-8.5a1 1 0 0 0-1 1V15a1 1 0 0 0 2 0v-2.5a1 1 0 0 0-1-1m0-1.125a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75"/></svg>`
    }, props));
$a9ea93e742aa0026$var$EditorInfoIcon.displayName = 'EditorInfoIcon';
var $a9ea93e742aa0026$var$_default = module.exports.default = $a9ea93e742aa0026$var$EditorInfoIcon;

});


parcelRegister("a9Y5z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76595b0ea0deb3c5$var$_react = $76595b0ea0deb3c5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $76595b0ea0deb3c5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $76595b0ea0deb3c5$var$EditorTaskIcon = (props)=>/*#__PURE__*/ $76595b0ea0deb3c5$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7.5 6h9A1.5 1.5 0 0 1 18 7.5v9a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 16.5v-9A1.5 1.5 0 0 1 7.5 6m3.072 8.838.143.154a.5.5 0 0 0 .769-.042l.13-.175 3.733-5.045a.8.8 0 0 0-.11-1.064.665.665 0 0 0-.984.118l-3.243 4.387-1.315-1.422a.663.663 0 0 0-.99 0 .8.8 0 0 0 0 1.07z"/></svg>`
    }, props));
$76595b0ea0deb3c5$var$EditorTaskIcon.displayName = 'EditorTaskIcon';
var $76595b0ea0deb3c5$var$_default = module.exports.default = $76595b0ea0deb3c5$var$EditorTaskIcon;

});

parcelRegister("52PFA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3ac5382da0e1f86d$var$_react = $3ac5382da0e1f86d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $3ac5382da0e1f86d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3ac5382da0e1f86d$var$MediaServicesTextIcon = (props)=>/*#__PURE__*/ $3ac5382da0e1f86d$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11 7h2v11h-2zM6 5h12v2H6z"/><path d="M5 5h2v3H5zm5 13h4v2h-4zm7-13h2v3h-2z"/></g></svg>`
    }, props));
$3ac5382da0e1f86d$var$MediaServicesTextIcon.displayName = 'MediaServicesTextIcon';
var $3ac5382da0e1f86d$var$_default = module.exports.default = $3ac5382da0e1f86d$var$MediaServicesTextIcon;

});

parcelRegister("eta4I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a88b96d16780be34$var$_react = $a88b96d16780be34$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $a88b96d16780be34$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a88b96d16780be34$var$StatusIcon = (props)=>/*#__PURE__*/ $a88b96d16780be34$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M4 5h16c1.105 0 2 1.045 2 2.333v9.334C22 17.955 21.105 19 20 19H4c-1.105 0-2-1.045-2-2.333V7.333C2 6.045 2.895 5 4 5m3.465 9.887h1.278L6.786 9.251H5.399l-1.957 5.636h1.183l.434-1.343h1.98zM6.02 10.423h.07l.7 2.21H5.313zm6.215 4.464c1.203 0 1.95-.625 1.95-1.613 0-.726-.544-1.289-1.29-1.344v-.07a1.22 1.22 0 0 0 1.02-1.203c0-.871-.653-1.406-1.747-1.406H9.704v5.636zm-1.352-4.734h.985c.562 0 .886.27.886.719 0 .453-.347.715-.984.715h-.887zm0 3.832v-1.601h1.024c.695 0 1.074.273 1.074.789 0 .527-.367.812-1.047.812zm6.762 1.047c1.36 0 2.352-.84 2.45-2.059h-1.15c-.112.621-.62 1.02-1.296 1.02-.89 0-1.441-.738-1.441-1.926s.55-1.922 1.437-1.922c.672 0 1.184.426 1.297 1.074h1.148c-.086-1.226-1.109-2.113-2.445-2.113-1.637 0-2.645 1.13-2.645 2.961 0 1.836 1.012 2.965 2.645 2.965"/></svg>`
    }, props));
$a88b96d16780be34$var$StatusIcon.displayName = 'StatusIcon';
var $a88b96d16780be34$var$_default = module.exports.default = $a88b96d16780be34$var$StatusIcon;

});

parcelRegister("fN6Kr", function(module, exports) {
$parcel$export(module.exports, "shallowEquals", () => $c5161cb2c1d33cac$export$fa1c2bbf4100b8bc);
const $c5161cb2c1d33cac$export$fa1c2bbf4100b8bc = ([aRaw], [bRaw])=>{
    const a = aRaw;
    const b = bRaw;
    return !Object.keys(a).some((key)=>{
        const k = key;
        return a[k] !== b[k];
    });
};

});




parcelRegister("8miOa", function(module, exports) {
$parcel$export(module.exports, "useTableSelectorPopup", () => $3803b65981c0e628$export$db7bd02db6cb687e);

var $eJOHy = parcelRequire("eJOHy");

var $bMFKb = parcelRequire("bMFKb");

var $cjeKO = parcelRequire("cjeKO");
const $3803b65981c0e628$export$db7bd02db6cb687e = ({ api: api, buttonRef: buttonRef })=>{
    const popupManager = (0, $cjeKO.usePopupManager)({
        focusTarget: buttonRef
    });
    const handleSelectedTableSize = (0, $eJOHy.useCallback)((rowsCount, colsCount)=>{
        // workaround to solve race condition where cursor is not placed correctly inside table
        queueMicrotask(()=>{
            api?.core?.actions.execute(api?.table?.commands.insertTableWithSize(rowsCount, colsCount, (0, $bMFKb.INPUT_METHOD).PICKER));
        });
        popupManager.close();
    }, [
        api,
        popupManager
    ]);
    const onPopupUnmount = (0, $eJOHy.useCallback)(()=>{
        api?.core.actions.focus();
    }, [
        api
    ]);
    return {
        ...popupManager,
        handleSelectedTableSize: handleSelectedTableSize,
        onPopupUnmount: onPopupUnmount
    };
};

});


parcelRegister("gvHa0", function(module, exports) {
$parcel$export(module.exports, "LayoutButton", () => $d89ac6cdb19889ba$export$b5a1df4e06cdc467);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bMFKb = parcelRequire("bMFKb");

var $46A2h = parcelRequire("46A2h");

var $c0YTT = parcelRequire("c0YTT");

var $fkTM0 = parcelRequire("fkTM0");
var $aDNj8 = parcelRequire("aDNj8");
var $64R2q = parcelRequire("64R2q");
const $d89ac6cdb19889ba$export$b5a1df4e06cdc467 = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { editorView: editorView } = (0, $c0YTT.useEditorToolbar)();
    if (!api?.layout) return null;
    const onClick = ()=>{
        if (editorView) {
            const { state: state, dispatch: dispatch } = editorView;
            api?.layout?.actions.insertLayoutColumns((0, $bMFKb.INPUT_METHOD).TOOLBAR)(state, dispatch);
        }
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $64R2q.ToolbarTooltip), {
        content: formatMessage((0, $46A2h.toolbarInsertBlockMessages).columns),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aDNj8.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fkTM0))), {
                label: formatMessage((0, $46A2h.toolbarInsertBlockMessages).columns),
                size: "small"
            }),
            onClick: onClick
        })
    });
};

});

parcelRegister("cpz21", function(module, exports) {
$parcel$export(module.exports, "MediaButton", () => $37892411d7931102$export$38a6b9ce8791e252);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bMFKb = parcelRequire("bMFKb");

var $cxXTK = parcelRequire("cxXTK");

var $46A2h = parcelRequire("46A2h");

var $fJNLD = parcelRequire("fJNLD");
var $aDNj8 = parcelRequire("aDNj8");
var $64R2q = parcelRequire("64R2q");
const $37892411d7931102$export$38a6b9ce8791e252 = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { showMediaPicker: showMediaPicker, connectivityMode: connectivityMode, allowsUploads: allowsUploads } = (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'media',
        'connectivity'
    ], (states)=>({
            showMediaPicker: states.mediaState?.showMediaPicker,
            allowsUploads: states.mediaState?.allowsUploads,
            connectivityMode: states.connectivityState?.mode
        }));
    const mediaButtonRef = (0, $eJOHy.useRef)(null);
    if (!api?.media) return null;
    const onClick = ()=>{
        if (!showMediaPicker) return;
        if (api?.mediaInsert?.commands?.showMediaInsertPopup) {
            const mountInfo = mediaButtonRef.current ? {
                ref: mediaButtonRef.current,
                mountPoint: mediaButtonRef.current
            } : undefined;
            api?.core?.actions.execute(api?.mediaInsert?.commands.showMediaInsertPopup(mountInfo));
        } else showMediaPicker();
        api?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $bMFKb.ACTION).OPENED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).PICKER,
            actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).PICKER_MEDIA,
            attributes: {
                inputMethod: (0, $bMFKb.INPUT_METHOD).TOOLBAR
            },
            eventType: (0, $bMFKb.EVENT_TYPE).UI
        });
    };
    const isOffline = connectivityMode === 'offline';
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $64R2q.ToolbarTooltip), {
        content: formatMessage((0, $46A2h.toolbarInsertBlockMessages).addMediaFiles),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aDNj8.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fJNLD))), {
                label: formatMessage((0, $46A2h.toolbarInsertBlockMessages).addMediaFiles),
                size: "small"
            }),
            onClick: onClick,
            ref: mediaButtonRef,
            isDisabled: isOffline || !allowsUploads
        })
    });
};

});

parcelRegister("1reWu", function(module, exports) {
$parcel$export(module.exports, "MentionButton", () => $cf342a1492f26633$export$d16f16312388c7e);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bMFKb = parcelRequire("bMFKb");

var $cxXTK = parcelRequire("cxXTK");

var $6Exgk = parcelRequire("6Exgk");

var $46A2h = parcelRequire("46A2h");

var $4HB8x = parcelRequire("4HB8x");
var $aDNj8 = parcelRequire("aDNj8");
var $64R2q = parcelRequire("64R2q");

var $cbSL1 = parcelRequire("cbSL1");
const $cf342a1492f26633$export$d16f16312388c7e = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { canInsertMention: canInsertMention, mentionProvider: mentionProvider, isTypeAheadAllowed: isTypeAheadAllowed } = (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'mention',
        'typeAhead'
    ], (states)=>({
            canInsertMention: states.mentionState?.canInsertMention,
            mentionProvider: states.mentionState?.mentionProvider,
            isTypeAheadAllowed: states.typeAheadState?.isAllowed
        }));
    if (!api?.mention) return null;
    const onClick = ()=>{
        api?.mention?.actions?.openTypeAhead((0, $bMFKb.INPUT_METHOD).TOOLBAR);
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $64R2q.ToolbarTooltip), {
        content: (0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6Exgk.ToolTipContent), {
            description: formatMessage((0, $46A2h.toolbarInsertBlockMessages).mention),
            keymap: (0, $6Exgk.insertMention)
        }) : formatMessage((0, $46A2h.toolbarInsertBlockMessages).mention),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aDNj8.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4HB8x))), {
                label: formatMessage((0, $46A2h.toolbarInsertBlockMessages).mention),
                size: "small"
            }),
            onClick: onClick,
            ariaKeyshortcuts: "Shift+2 Space",
            isDisabled: !canInsertMention || !mentionProvider || !isTypeAheadAllowed
        })
    });
};

});

parcelRegister("iECnl", function(module, exports) {
$parcel$export(module.exports, "TableButton", () => $3173536519b7c30f$export$a5d4a9df719d6bc1);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bMFKb = parcelRequire("bMFKb");

var $6Exgk = parcelRequire("6Exgk");

var $46A2h = parcelRequire("46A2h");

var $c0YTT = parcelRequire("c0YTT");

var $1U4zO = parcelRequire("1U4zO");
var $aDNj8 = parcelRequire("aDNj8");
var $64R2q = parcelRequire("64R2q");

var $cbSL1 = parcelRequire("cbSL1");
const $3173536519b7c30f$export$a5d4a9df719d6bc1 = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { editorView: editorView } = (0, $c0YTT.useEditorToolbar)();
    if (!api?.table) return null;
    const onClick = ()=>{
        if (editorView) {
            const { state: state, dispatch: dispatch } = editorView;
            // workaround to solve race condition where cursor is not placed correctly inside table
            queueMicrotask(()=>{
                api?.table?.actions.insertTable?.({
                    action: (0, $bMFKb.ACTION).INSERTED,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).TABLE,
                    attributes: {
                        inputMethod: (0, $bMFKb.INPUT_METHOD).TOOLBAR
                    },
                    eventType: (0, $bMFKb.EVENT_TYPE).TRACK
                })(state, dispatch);
            });
        }
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $64R2q.ToolbarTooltip), {
        content: (0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6Exgk.ToolTipContent), {
            description: formatMessage((0, $46A2h.toolbarInsertBlockMessages).table),
            keymap: (0, $6Exgk.toggleTable)
        }) : formatMessage((0, $46A2h.toolbarInsertBlockMessages).table),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aDNj8.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1U4zO))), {
                label: formatMessage((0, $46A2h.toolbarInsertBlockMessages).table),
                size: "small"
            }),
            onClick: onClick,
            ariaKeyshortcuts: (0, $6Exgk.getAriaKeyshortcuts)((0, $6Exgk.toggleTable)),
            testId: "Table"
        })
    });
};

});

parcelRegister("cwtLJ", function(module, exports) {
$parcel$export(module.exports, "TableSizePicker", () => $9dd2d28990203c53$export$5468cf78b7a314d6);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $46A2h = parcelRequire("46A2h");

var $1ivsK = parcelRequire("1ivsK");
var $aDNj8 = parcelRequire("aDNj8");
var $64R2q = parcelRequire("64R2q");
var $7K3rS = parcelRequire("7K3rS");

var $8miOa = parcelRequire("8miOa");

var $7h3e7 = parcelRequire("7h3e7");
const $9dd2d28990203c53$export$5468cf78b7a314d6 = ({ api: api, tableSelectorSupported: tableSelectorSupported })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const tableSizePickerRef = (0, $eJOHy.useRef)(null);
    const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement } = (0, $7K3rS.useToolbarUI)();
    const tableSelectorPopup = (0, $8miOa.useTableSelectorPopup)({
        api: api,
        buttonRef: tableSizePickerRef
    });
    if (!api?.table || !tableSelectorSupported) return null;
    const onClick = (event)=>{
        if (event.detail === 0) tableSelectorPopup.handleKeyboardOpen(event);
        tableSelectorPopup.toggle();
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7h3e7.TableSelectorPopupWrapper), {
                isOpen: tableSelectorPopup.isOpen,
                targetRef: tableSizePickerRef,
                isOpenedByKeyboard: tableSelectorPopup.isOpenedByKeyboard,
                onSelection: tableSelectorPopup.handleSelectedTableSize,
                onClickOutside: tableSelectorPopup.handleClickOutside,
                onEscapeKeydown: tableSelectorPopup.handleEscapeKeydown,
                onUnmount: tableSelectorPopup.onPopupUnmount,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $64R2q.ToolbarTooltip), {
                content: formatMessage((0, $46A2h.toolbarInsertBlockMessages).tableSelector),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aDNj8.ToolbarButton), {
                    iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1ivsK.MoreItemsIcon), {
                        label: formatMessage((0, $46A2h.toolbarInsertBlockMessages).tableSelector)
                    }),
                    onClick: onClick,
                    isSelected: tableSelectorPopup.isOpen,
                    ref: tableSizePickerRef
                })
            })
        ]
    });
};

});
parcelRegister("7h3e7", function(module, exports) {
$parcel$export(module.exports, "TableSelectorPopupWrapper", () => $3b7671481e82a95d$export$e82abb3e18a71b34);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $jfqPo = parcelRequire("jfqPo");
const $3b7671481e82a95d$export$e82abb3e18a71b34 = ({ isOpen: isOpen, targetRef: targetRef, isOpenedByKeyboard: isOpenedByKeyboard, onSelection: onSelection, onClickOutside: onClickOutside, onEscapeKeydown: onEscapeKeydown, onUnmount: onUnmount, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement })=>{
    if (!isOpen || !targetRef.current) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jfqPo.default), {
        allowOutsideSelection: true,
        target: targetRef.current,
        onUnmount: onUnmount,
        onSelection: onSelection,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        handleClickOutside: onClickOutside,
        handleEscapeKeydown: onEscapeKeydown,
        isOpenedByKeyboard: isOpenedByKeyboard
    });
};

});
parcelRegister("jfqPo", function(module, exports) {
$parcel$export(module.exports, "default", () => $61449d04db74784b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $4eDgu = parcelRequire("4eDgu");

var $7yBx7 = parcelRequire("7yBx7");


var $92xoS = parcelRequire("92xoS");

var $dcudV = parcelRequire("dcudV");

var $avm98 = parcelRequire("avm98");

var $338Ys = parcelRequire("338Ys");
const $61449d04db74784b$var$TABLE_SELECTOR_PADDING_TOP = 8;
const $61449d04db74784b$var$TABLE_SELECTOR_PADDING_SIDE = 10;
const $61449d04db74784b$var$DEFAULT_TABLE_SELECTOR_ROWS = 5;
const $61449d04db74784b$var$DEFAULT_TABLE_SELECTOR_COLS = 10;
const $61449d04db74784b$var$DEFAULT_TABLE_SELECTOR_SELECTION_SIZE = 1;
const $61449d04db74784b$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS = 10;
const $61449d04db74784b$var$TableSelectorWithListeners = (0, $dcudV.default)((0, $338Ys.default));
const $61449d04db74784b$var$initialSizeState = {
    col: $61449d04db74784b$var$DEFAULT_TABLE_SELECTOR_SELECTION_SIZE,
    row: $61449d04db74784b$var$DEFAULT_TABLE_SELECTOR_SELECTION_SIZE,
    maxCol: $61449d04db74784b$var$DEFAULT_TABLE_SELECTOR_COLS,
    maxRow: $61449d04db74784b$var$DEFAULT_TABLE_SELECTOR_ROWS
};
const $61449d04db74784b$var$tableSelectorPopupWrapperStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    borderRadius: "var(--ds-radius-small, 3px)",
    backgroundColor: `var(--ds-surface-overlay, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $7bb4c1736002a04a$export$920c0d5c49070351)}, 0 2px 1px ${(0, $7bb4c1736002a04a$export$920c0d5c49070351)}, 0 0 20px -6px ${(0, $7bb4c1736002a04a$export$d2d3bedfb276cac0)}`})`,
    padding: `${`var(--ds-space-100, ${`${$61449d04db74784b$var$TABLE_SELECTOR_PADDING_TOP}px`})`} ${$61449d04db74784b$var$TABLE_SELECTOR_PADDING_SIDE}px`
});
const $61449d04db74784b$export$4b4bd4d01ec9c7c9 = (props)=>{
    const [size, setSize] = (0, $eJOHy.useState)({
        ...$61449d04db74784b$var$initialSizeState,
        ...props.defaultSize
    });
    const tablePopupRef = (0, $eJOHy.useRef)(null);
    // If popup opened by keyboard enable keyboard mode
    const isKeyboardMode = (0, $eJOHy.useRef)(props.isOpenedByKeyboard);
    const enableKeyboardMode = (0, $eJOHy.useCallback)(()=>{
        if (!isKeyboardMode.current) isKeyboardMode.current = true;
    }, [
        isKeyboardMode
    ]);
    const disableKeyboardMode = (0, $eJOHy.useCallback)(()=>{
        if (isKeyboardMode.current) isKeyboardMode.current = false;
    }, [
        isKeyboardMode
    ]);
    // Mouse move is used to allow selection changes outside of the popup and is more reactive to changes.
    const handleMouseMove = (0, $eJOHy.useCallback)((e)=>{
        if (!tablePopupRef.current) return;
        disableKeyboardMode();
        const tablePopup = tablePopupRef.current;
        const { left: left, top: top } = tablePopup.getBoundingClientRect();
        // Mouse position on popup
        const selectedWidth = e.clientX - left;
        const selectedHeight = e.clientY - top;
        // Calculate number grid cells selected
        let selectedGridCols = Math.ceil((selectedWidth - $61449d04db74784b$var$TABLE_SELECTOR_PADDING_SIDE + (0, $338Ys.TABLE_SELECTOR_BUTTON_GAP)) / ((0, $338Ys.TABLE_SELECTOR_BUTTON_GAP) + (0, $338Ys.TABLE_SELECTOR_BUTTON_SIZE)));
        let selectedGridRows = Math.ceil((selectedHeight - $61449d04db74784b$var$TABLE_SELECTOR_PADDING_TOP + (0, $338Ys.TABLE_SELECTOR_BUTTON_GAP)) / ((0, $338Ys.TABLE_SELECTOR_BUTTON_GAP) + (0, $338Ys.TABLE_SELECTOR_BUTTON_SIZE)));
        // Keep the selected rows and columns within the defined bounds
        let gridRows = $61449d04db74784b$var$DEFAULT_TABLE_SELECTOR_ROWS;
        if (selectedGridCols < 1) selectedGridCols = 1;
        if (selectedGridCols > size.maxCol) selectedGridCols = size.maxCol;
        if (selectedGridRows < 1) selectedGridRows = 1;
        // Expand grid when row selection is greater than the default grid size
        if (selectedGridRows >= $61449d04db74784b$var$DEFAULT_TABLE_SELECTOR_ROWS && selectedGridRows < $61449d04db74784b$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS) gridRows = selectedGridRows + 1;
        if (selectedGridRows >= $61449d04db74784b$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS) {
            selectedGridRows = $61449d04db74784b$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS;
            gridRows = $61449d04db74784b$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS;
        }
        if (selectedGridCols !== size.col || selectedGridRows !== size.row) setSize({
            col: selectedGridCols,
            row: selectedGridRows,
            maxCol: $61449d04db74784b$var$DEFAULT_TABLE_SELECTOR_COLS,
            maxRow: gridRows
        });
    }, [
        disableKeyboardMode,
        size,
        setSize
    ]);
    const decreasingSequence = (maxNumber, prevNumber)=>{
        let nextNumber = prevNumber - 1;
        if (prevNumber === 1) nextNumber = maxNumber;
        return nextNumber;
    };
    const getMaxRow = (prevSize, eventKey)=>{
        switch(eventKey){
            case 'ArrowDown':
                // Expand the grid size when last row selected
                if (prevSize.maxRow < $61449d04db74784b$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS && prevSize.row >= $61449d04db74784b$var$DEFAULT_TABLE_SELECTOR_ROWS - 1) return prevSize.maxRow + 1;
                if (prevSize.row === $61449d04db74784b$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS) return $61449d04db74784b$var$DEFAULT_TABLE_SELECTOR_ROWS;
                return prevSize.maxRow;
            case 'ArrowLeft':
                const moveToPrevRow = prevSize.col === 1 && prevSize.row > 1;
                const moveToLastRow = prevSize.row === 1 && prevSize.col === 1;
                // Expand the popup to max size when selected row wraps around to last row
                if (moveToLastRow) return $61449d04db74784b$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS;
                // Decrease the popup when decreased row selection
                if (prevSize.maxRow > $61449d04db74784b$var$DEFAULT_TABLE_SELECTOR_ROWS && moveToPrevRow) return prevSize.row;
                return prevSize.maxRow;
            case 'ArrowUp':
                if (prevSize.row === 1) return $61449d04db74784b$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS;
                else if (prevSize.maxRow > $61449d04db74784b$var$DEFAULT_TABLE_SELECTOR_ROWS) return prevSize.row;
                return prevSize.maxRow;
            case 'ArrowRight':
                const moveToNextRow = prevSize.col === $61449d04db74784b$var$DEFAULT_TABLE_SELECTOR_COLS;
                const increaseMaxRow = prevSize.maxRow < $61449d04db74784b$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS && moveToNextRow && prevSize.row + 1 === prevSize.maxRow;
                // Decrease popup size for wrap around to selection 1 x 1
                if (prevSize.row === $61449d04db74784b$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS && prevSize.col === $61449d04db74784b$var$DEFAULT_TABLE_SELECTOR_COLS) return $61449d04db74784b$var$DEFAULT_TABLE_SELECTOR_ROWS;
                else if (increaseMaxRow) return prevSize.maxRow + 1;
                return prevSize.maxRow;
            default:
                return prevSize.maxRow;
        }
    };
    const handleInitialButtonFocus = (0, $eJOHy.useCallback)(()=>{
        if (isKeyboardMode.current !== true) {
            enableKeyboardMode();
            setSize($61449d04db74784b$var$initialSizeState);
        }
    }, [
        enableKeyboardMode,
        setSize
    ]);
    const handleKeyDown = (0, $eJOHy.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event)=>{
        if (event.key === 'ArrowDown') {
            enableKeyboardMode();
            setSize((prevSize)=>{
                return {
                    ...prevSize,
                    row: prevSize.row % prevSize.maxRow + 1,
                    maxRow: getMaxRow(prevSize, event.key)
                };
            });
            if ((0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) event.preventDefault();
        }
        if (event.key === 'ArrowRight') {
            enableKeyboardMode();
            setSize((prevSize)=>{
                const moveToNextRow = prevSize.col === $61449d04db74784b$var$DEFAULT_TABLE_SELECTOR_COLS;
                return {
                    ...prevSize,
                    col: prevSize.col % $61449d04db74784b$var$DEFAULT_TABLE_SELECTOR_COLS + 1,
                    row: moveToNextRow ? prevSize.row % prevSize.maxRow + 1 : prevSize.row,
                    maxRow: getMaxRow(prevSize, event.key)
                };
            });
        }
        if (event.key === 'ArrowLeft') {
            enableKeyboardMode();
            setSize((prevSize)=>{
                const getRow = (prevRow, prevCol)=>{
                    const row = prevRow;
                    // Move to previous row for wrap around
                    if (prevSize.col === 1 && prevSize.row > 1) return prevRow - 1;
                    else if (prevRow === 1 && prevCol === 1) return $61449d04db74784b$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS;
                    return row;
                };
                return {
                    ...prevSize,
                    col: decreasingSequence(prevSize.maxCol, prevSize.col),
                    row: getRow(prevSize.row, prevSize.col),
                    maxRow: getMaxRow(prevSize, event.key)
                };
            });
        }
        if (event.key === 'ArrowUp') {
            enableKeyboardMode();
            setSize((prevSize)=>{
                const moveToLastRow = prevSize.row === 1;
                return {
                    ...prevSize,
                    row: moveToLastRow ? $61449d04db74784b$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS : decreasingSequence(prevSize.maxRow, prevSize.row),
                    maxRow: getMaxRow(prevSize, event.key)
                };
            });
            if ((0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) event.preventDefault();
        }
    }, [
        enableKeyboardMode,
        setSize
    ]);
    (0, $eJOHy.useEffect)(()=>{
        let unbind;
        const target = props.allowOutsideSelection ? window : tablePopupRef.current;
        if (target) unbind = (0, $4eDgu.bind)(target, {
            type: 'mousemove',
            listener: handleMouseMove
        });
        return unbind;
    }, [
        handleMouseMove,
        props.allowOutsideSelection,
        tablePopupRef
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $avm98.default), {
        target: props.target,
        offset: [
            0,
            3
        ],
        mountTo: props.popupsMountPoint,
        boundariesElement: props.popupsBoundariesElement,
        scrollableElement: props.popupsScrollableElement,
        focusTrap: true,
        onUnmount: props.onUnmount,
        zIndex: (0, $7yBx7.akEditorMenuZIndex)
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $61449d04db74784b$var$tableSelectorPopupWrapperStyles,
        ref: tablePopupRef
    }, /*#__PURE__*/ (0, $1NIU8.jsx)($61449d04db74784b$var$TableSelectorWithListeners, {
        handleClickOutside: props.handleClickOutside,
        handleEscapeKeydown: props.handleEscapeKeydown,
        maxCols: size.maxCol,
        maxRows: size.maxRow,
        onSelection: props.onSelection,
        selectedCol: size.col,
        selectedRow: size.row,
        onKeyDown: handleKeyDown,
        isFocused: isKeyboardMode.current,
        handleInitialButtonFocus: handleInitialButtonFocus
    })));
};
var $61449d04db74784b$export$2e2bcd8739ae039 = $61449d04db74784b$export$4b4bd4d01ec9c7c9;

});
parcelRegister("338Ys", function(module, exports) {
$parcel$export(module.exports, "TABLE_SELECTOR_BUTTON_GAP", () => $f3934af5941898d3$export$fe015b05aaf05d59);
$parcel$export(module.exports, "TABLE_SELECTOR_BUTTON_SIZE", () => $f3934af5941898d3$export$80d6f86639b2335);
$parcel$export(module.exports, "default", () => $f3934af5941898d3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");

var $78OnL = parcelRequire("78OnL");


var $92xoS = parcelRequire("92xoS");

var $46A2h = parcelRequire("46A2h");

var $dcudV = parcelRequire("dcudV");
function $f3934af5941898d3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f3934af5941898d3$export$fe015b05aaf05d59 = 2;
const $f3934af5941898d3$export$80d6f86639b2335 = 17;
const $f3934af5941898d3$var$selectedButtonStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    backgroundColor: "var(--ds-background-accent-blue-subtlest, #579DFF)",
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-background-accent-blue-subtle, #579DFF)"}`
});
const $f3934af5941898d3$var$buttonStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    height: `${$f3934af5941898d3$export$80d6f86639b2335}px`,
    width: `${$f3934af5941898d3$export$80d6f86639b2335}px`,
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #091e4224)"}`,
    backgroundColor: "var(--ds-background-input, #ffffff)",
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
    borderRadius: "var(--ds-radius-small, 3px)",
    cursor: 'pointer',
    display: 'block',
    '&:focus': {
        outline: 'none',
        border: `${"var(--ds-border-width, 1px)"} solid ${`var(--ds-border-focused, ${(0, $7bb4c1736002a04a$export$ecfc1dff386a3e7a)})`}`,
        boxShadow: `0 0 0 0.5px ${`var(--ds-border-focused, ${(0, $7bb4c1736002a04a$export$ecfc1dff386a3e7a)})`}`
    }
});
const $f3934af5941898d3$var$selectionSizeTextStyles = {
    name: "bn43i4",
    styles: "line-height:14px;display:flex;justify-content:center;margin-top:var(--ds-space-075, 5px);padding:var(--ds-space-075, 10px)"
};
const $f3934af5941898d3$var$TableSelectorButton = ({ row: row, col: col, isActive: isActive, onClick: onClick, label: label, onKeyDown: onKeyDown, isFocused: isFocused, handleInitialButtonFocus: handleInitialButtonFocus })=>{
    const btnRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (btnRef.current) {
            if (isFocused) btnRef.current.focus({
                preventScroll: (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? true : undefined
            });
            else btnRef.current.blur();
        }
    }, [
        isFocused,
        btnRef
    ]);
    const handleFocus = col === 1 && row === 1 ? ()=>handleInitialButtonFocus() : undefined;
    return /*#__PURE__*/ (0, $1NIU8.jsx)("button", {
        type: "button",
        css: [
            $f3934af5941898d3$var$buttonStyles,
            isActive ? $f3934af5941898d3$var$selectedButtonStyles : undefined
        ],
        onClick: ()=>onClick(row, col),
        "aria-label": label,
        onKeyDown: onKeyDown,
        ref: btnRef,
        onFocus: handleFocus
    });
};
const $f3934af5941898d3$var$createArray = (maxCols, maxRows)=>{
    const arr = [];
    for(let i = 1; i < maxRows + 1; i++)for(let j = 1; j < maxCols + 1; j++)arr.push({
        col: j,
        row: i
    });
    return arr;
};
const $f3934af5941898d3$var$gridWrapperStyles = ({ maxCols: maxCols, maxRows: maxRows })=>/*#__PURE__*/ (0, $1NIU8.css)({
        display: 'grid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gridTemplateColumns: `repeat(${maxCols}, 1fr)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gridTemplateRows: `repeat(${maxRows}, 1fr)`,
        gap: `${`var(--ds-space-025, ${`${$f3934af5941898d3$export$fe015b05aaf05d59}px`})`}`
    });
const $f3934af5941898d3$var$TableSelectorPopup = ({ maxCols: maxCols, maxRows: maxRows, onSelection: onSelection, selectedCol: selectedCol, selectedRow: selectedRow, onKeyDown: onKeyDown, isFocused: isFocused, handleInitialButtonFocus: handleInitialButtonFocus, intl: { formatMessage: formatMessage } })=>{
    const buttons = (0, $eJOHy.useMemo)(()=>{
        return $f3934af5941898d3$var$createArray(maxCols, maxRows);
    }, [
        maxCols,
        maxRows
    ]);
    const setOutsideClickTargetRef = (0, $eJOHy.useContext)((0, $dcudV.OutsideClickTargetRefContext));
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $78OnL.default), {
        ref: setOutsideClickTargetRef
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        "aria-label": `${formatMessage((0, $46A2h.toolbarInsertBlockMessages).tableSizeSelectorPopup)}`,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        $f3934af5941898d3$var$gridWrapperStyles({
            maxCols: maxCols,
            maxRows: maxRows
        })
    }, buttons.map(({ col: col, row: row }, index)=>{
        const isCurrentFocused = isFocused && selectedCol === col && selectedRow === row;
        const isActive = selectedCol >= col && selectedRow >= row ? true : false;
        return /*#__PURE__*/ (0, $1NIU8.jsx)($f3934af5941898d3$var$TableSelectorButton, {
            // Ignored via go/ees005
            // eslint-disable-next-line react/no-array-index-key
            key: index,
            isActive: isActive,
            col: col,
            row: row,
            onClick: onSelection,
            label: `${formatMessage((0, $46A2h.toolbarInsertBlockMessages).tableSizeSelectorButton, {
                numberOfColumns: col,
                numberOfRows: row
            })}`,
            onKeyDown: onKeyDown,
            isFocused: isCurrentFocused,
            handleInitialButtonFocus: handleInitialButtonFocus
        });
    })), /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $f3934af5941898d3$var$selectionSizeTextStyles,
        "aria-hidden": true
    }, `${selectedCol} x ${selectedRow}`));
};
var $f3934af5941898d3$export$2e2bcd8739ae039 = (0, $6YFG2.default)($f3934af5941898d3$var$TableSelectorPopup);

});




parcelRegister("5jQsy", function(module, exports) {
$parcel$export(module.exports, "TaskListButton", () => $1904d372181431f7$export$be2acb2f228dcb8b);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bMFKb = parcelRequire("bMFKb");

var $6Exgk = parcelRequire("6Exgk");

var $46A2h = parcelRequire("46A2h");

var $c0YTT = parcelRequire("c0YTT");

var $bwM92 = parcelRequire("bwM92");
var $aDNj8 = parcelRequire("aDNj8");
var $64R2q = parcelRequire("64R2q");

var $cbSL1 = parcelRequire("cbSL1");
const $1904d372181431f7$export$be2acb2f228dcb8b = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { editorView: editorView } = (0, $c0YTT.useEditorToolbar)();
    if (!api?.taskDecision) return null;
    const onClick = ()=>{
        if (editorView) {
            const { state: state, dispatch: dispatch } = editorView;
            api?.taskDecision?.actions.insertTaskDecision('taskList', (0, $bMFKb.INPUT_METHOD).TOOLBAR)(state, dispatch);
        }
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $64R2q.ToolbarTooltip), {
        content: (0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6Exgk.ToolTipContent), {
            description: formatMessage((0, $46A2h.toolbarInsertBlockMessages).action),
            keymap: (0, $6Exgk.insertTaskList)
        }) : formatMessage((0, $46A2h.toolbarInsertBlockMessages).action),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aDNj8.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bwM92))), {
                label: formatMessage((0, $46A2h.toolbarInsertBlockMessages).action),
                size: "small"
            }),
            onClick: onClick,
            ariaKeyshortcuts: "[ ] Space"
        })
    });
};

});


parcelRegister("2vb08", function(module, exports) {
$parcel$export(module.exports, "default", () => $4be7573df5320310$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");

var $bMFKb = parcelRequire("bMFKb");

var $46A2h = parcelRequire("46A2h");

var $fcJnk = parcelRequire("fcJnk");

var $avm98 = parcelRequire("avm98");
var $jfqPo = parcelRequire("jfqPo");

var $9Sic1 = parcelRequire("9Sic1");

var $dcudV = parcelRequire("dcudV");

var $7yBx7 = parcelRequire("7yBx7");

var $l1j5w = parcelRequire("l1j5w");

var $eGOwo = parcelRequire("eGOwo");


var $92xoS = parcelRequire("92xoS");

var $hyKr5 = parcelRequire("hyKr5");

var $hJx37 = parcelRequire("hJx37");
/**
 * Checks if an element is detached (i.e. not in the current document)
 */ const $4be7573df5320310$var$isDetachedElement = (el)=>!document.body.contains(el);
const $4be7573df5320310$var$TABLE_SELECTOR_STRING = 'table selector';
// TODO: ED-26959 - Jenga team will create a component for a split button using this css
const $4be7573df5320310$var$getHoverStyles = (selector)=>`&:hover ${selector} {
    background: ${`var(--ds-background-neutral-subtle-hovered, ${0, $7bb4c1736002a04a$export$8d43898f60b96a82})`};

    &:hover {
      background: ${`var(--ds-background-neutral-hovered, ${0, $7bb4c1736002a04a$export$920c0d5c49070351})`};
    }
  }`;
const $4be7573df5320310$var$EmojiPicker = (props)=>{
    const setOutsideClickTargetRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $dcudV.OutsideClickTargetRefContext));
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $l1j5w.default), {
        onPickerRef: setOutsideClickTargetRef,
        ...props
    });
};
const $4be7573df5320310$var$EmojiPickerWithListeners = (0, $dcudV.default)($4be7573df5320310$var$EmojiPicker);
const $4be7573df5320310$export$6555404d88cb913b = ({ isTableSelectorOpen: isTableSelectorOpen, isButtonDisabled: isButtonDisabled })=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation due to mixins
    (0, $1NIU8.css)("display:flex;", !isTableSelectorOpen && !isButtonDisabled && $4be7573df5320310$var$getHoverStyles('.table-selector-toolbar-btn'), " ", !isTableSelectorOpen && !isButtonDisabled && $4be7573df5320310$var$getHoverStyles('.table-toolbar-btn'), " .table-toolbar-btn{border-top-right-radius:var(--ds-radius-large, 0px);border-bottom-right-radius:var(--ds-radius-large, 0px);margin-right:var(--ds-space-025, 1px);padding:var(--ds-space-0, 0px);&>span{min-width:16px;margin:var(--ds-space-0, 0px);}}.table-selector-toolbar-btn{padding:var(--ds-space-0, 0px);border-top-left-radius:var(--ds-radius-large, 0px)!important;border-bottom-left-radius:var(--ds-radius-large, 0px)!important;&>span{margin:var(--ds-space-0, 0px);width:16px!important;display:flex;justify-content:center;}}");
class $4be7573df5320310$export$630ae7da9d01a215 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    static getDerivedStateFromProps(props, state) {
        const [buttons, dropdownItems] = (0, $hJx37.createItems)({
            isTypeAheadAllowed: props.isTypeAheadAllowed,
            tableSupported: props.tableSupported,
            tableSelectorSupported: props.tableSelectorSupported,
            mediaUploadsEnabled: props.mediaUploadsEnabled,
            mediaSupported: props.mediaSupported,
            isEditorOffline: props.isEditorOffline,
            imageUploadSupported: props.imageUploadSupported,
            imageUploadEnabled: props.imageUploadEnabled,
            mentionsSupported: props.mentionsSupported,
            mentionsDisabled: props.mentionsDisabled,
            actionSupported: props.actionSupported,
            decisionSupported: props.decisionSupported,
            linkSupported: props.linkSupported,
            linkDisabled: props.linkDisabled,
            emojiDisabled: props.emojiDisabled,
            hasEmojiPlugin: !!props.pluginInjectionApi?.emoji,
            hasMentionsPlugin: !!props.pluginInjectionApi?.mention,
            hasMediaPlugin: !!props.pluginInjectionApi?.media,
            nativeStatusSupported: props.nativeStatusSupported,
            dateEnabled: props.dateEnabled,
            placeholderTextEnabled: props.placeholderTextEnabled,
            horizontalRuleEnabled: props.horizontalRuleEnabled,
            layoutSectionEnabled: props.layoutSectionEnabled,
            expandEnabled: props.expandEnabled,
            showElementBrowserLink: props.showElementBrowserLink,
            emojiProvider: props.emojiProvider,
            availableWrapperBlockTypes: props.availableWrapperBlockTypes,
            insertMenuItems: props.insertMenuItems,
            schema: props.editorView.state.schema,
            numberOfButtons: props.buttons,
            formatMessage: props.intl.formatMessage
        });
        return {
            ...state,
            buttons: buttons,
            dropdownItems: dropdownItems
        };
    }
    componentDidUpdate(prevProps) {
        // If number of visible buttons changed, close emoji picker and table selector
        if (prevProps.buttons !== this.props.buttons) this.setState({
            emojiPickerOpen: false,
            isTableSelectorOpen: false
        });
        if (this.state.isOpenedByKeyboard) {
            const downArrowEvent = new KeyboardEvent('keydown', {
                bubbles: true,
                key: 'ArrowDown'
            });
            this.dropdownButtonRef?.deref()?.dispatchEvent(downArrowEvent);
            this.setState({
                ...this.state,
                isOpenedByKeyboard: false
            });
        }
        if (this.state.isTableSelectorOpen) this.setState({
            isTableSelectorOpenedByKeyboard: false
        });
        if (this.props.showElementBrowser !== prevProps.showElementBrowser) {
            this.handleClick();
            this.setState({
                ...this.state,
                isPlusMenuOpen: this.props.showElementBrowser
            });
        }
    }
    renderPopup() {
        const { emojiPickerOpen: emojiPickerOpen } = this.state;
        const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, emojiProvider: emojiProvider } = this.props;
        const dropdownEmoji = this.state.dropdownItems.some(({ value: { name: name } })=>name === 'emoji');
        const dropDownButtonRef = this.plusButtonRef;
        const ref = dropdownEmoji ? dropDownButtonRef : this.emojiButtonRef;
        if (!emojiPickerOpen || !ref || !emojiProvider) return null;
        const onUnmount = ()=>{
            requestAnimationFrame(()=>this.props.pluginInjectionApi?.core?.actions?.focus());
        };
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $avm98.default), {
            target: ref.deref(),
            fitHeight: 350,
            fitWidth: 350,
            offset: [
                0,
                3
            ],
            mountTo: popupsMountPoint,
            boundariesElement: popupsBoundariesElement,
            scrollableElement: popupsScrollableElement,
            onUnmount: onUnmount,
            focusTrap: true,
            zIndex: (0, $7yBx7.akEditorMenuZIndex)
        }, /*#__PURE__*/ (0, $1NIU8.jsx)($4be7573df5320310$var$EmojiPickerWithListeners, {
            emojiProvider: emojiProvider,
            onSelection: this.handleSelectedEmoji,
            handleClickOutside: this.handleEmojiClickOutside,
            handleEscapeKeydown: this.handleEmojiPressEscape
        }));
    }
    renderTableSelectorPopup() {
        const { isTableSelectorOpen: isTableSelectorOpen, isTableSelectorOpenedByKeyboard: isTableSelectorOpenedByKeyboard } = this.state;
        const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, pluginInjectionApi: pluginInjectionApi } = this.props;
        const ref = this.tableButtonRef.current ?? undefined;
        if (!isTableSelectorOpen) return null;
        // We use focusTrap in the Popup. When we insert a table via popup,
        // the popup closes, focusTrap gets destroyed and the popup detaches.
        // The focus gets set to the body element. onUnmount method sets focus on the editor right before the
        // Popup will be unmounted to ensure that the new table has a selection with a blinking cursor.
        // So we can start typing right away.
        const onUnmount = ()=>pluginInjectionApi?.core?.actions?.focus();
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jfqPo.default), {
            allowOutsideSelection: true,
            target: ref,
            onUnmount: onUnmount,
            onSelection: this.handleSelectedTableSize,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            handleClickOutside: this.handleTableSelectorClickOutside,
            handleEscapeKeydown: this.handleTableSelectorPressEscape,
            isOpenedByKeyboard: isTableSelectorOpenedByKeyboard
        });
    }
    render() {
        const { buttons: buttons, dropdownItems: dropdownItems, emojiPickerOpen: emojiPickerOpen, isTableSelectorOpen: isTableSelectorOpen } = this.state;
        const { isDisabled: isDisabled, isReducedSpacing: isReducedSpacing, editorAppearance: editorAppearance } = this.props;
        const isFullPageAppearance = [
            'full-page',
            'full-width'
        ].includes(editorAppearance ?? '');
        const isTableButtonVisible = buttons.some(({ value: value })=>value.name === 'table');
        const isTableSizeVisible = buttons.some(({ value: value })=>value.name === 'table selector');
        if (buttons.length === 0 && dropdownItems.length === 0) return null;
        const toolbarButtons = [];
        let tableSelectorButton;
        let tableButton;
        // Seperate table buttons from toolbar buttons
        for (const btn of buttons){
            if (btn.value.name === $4be7573df5320310$var$TABLE_SELECTOR_STRING) tableSelectorButton = btn;
            else if (btn.value.name === 'table' && this.props.tableSelectorSupported) tableButton = btn;
            else toolbarButtons.push(btn);
        }
        return /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            css: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
            (0, $eGOwo.fg)('platform-visual-refresh-icons') ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $fcJnk.buttonGroupStyle) : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            (0, $fcJnk.buttonGroupStyleBeforeVisualRefresh)
        }, toolbarButtons.map((btn)=>{
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $9Sic1.default), {
                item: btn,
                testId: this.getToolbarButtonTestId(btn),
                ref: this.handleToolbarRef(btn.value.name),
                key: btn.value.name,
                spacing: isReducedSpacing ? 'none' : 'default',
                disabled: isDisabled || btn.isDisabled,
                iconBefore: btn.elemBefore,
                selected: btn.value.name === 'emoji' && emojiPickerOpen || btn.isActive,
                title: btn.title,
                "aria-label": btn['aria-label'],
                "aria-haspopup": btn['aria-haspopup'],
                "aria-keyshortcuts": btn['aria-keyshortcuts'],
                onItemClick: this.insertToolbarMenuItem
            });
        }), this.props.tableSelectorSupported && (isTableButtonVisible || isTableSizeVisible) && /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            css: $4be7573df5320310$export$6555404d88cb913b({
                isTableSelectorOpen: isTableSelectorOpen,
                isButtonDisabled: tableButton?.isDisabled
            })
        }, isTableButtonVisible && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $9Sic1.default), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
            className: "table-toolbar-btn",
            item: tableButton,
            ref: this.tableButtonRef,
            testId: String(tableButton?.content),
            key: tableButton?.value.name,
            spacing: isReducedSpacing ? 'none' : 'default',
            disabled: isDisabled || tableButton?.isDisabled,
            iconBefore: tableButton?.elemBefore,
            selected: tableButton?.isActive || isTableSelectorOpen,
            title: tableButton?.title,
            "aria-label": tableButton ? tableButton['aria-label'] : undefined,
            "aria-haspopup": tableButton ? tableButton['aria-haspopup'] : undefined,
            "aria-keyshortcuts": tableButton ? tableButton['aria-keyshortcuts'] : undefined,
            onItemClick: this.insertToolbarMenuItem
        }), isTableButtonVisible && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $9Sic1.default), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
            className: "table-selector-toolbar-btn",
            item: tableSelectorButton,
            testId: String(tableSelectorButton?.content),
            key: tableSelectorButton?.value.name,
            ref: this.tableSelectorButtonRef,
            spacing: isReducedSpacing ? 'none' : 'default',
            disabled: isDisabled || tableSelectorButton?.isDisabled,
            iconBefore: tableSelectorButton?.elemBefore,
            selected: tableSelectorButton?.isActive || isTableSelectorOpen,
            title: tableSelectorButton?.title,
            "aria-label": tableSelectorButton ? tableSelectorButton['aria-label'] : undefined,
            "aria-haspopup": tableSelectorButton ? tableSelectorButton['aria-haspopup'] : undefined,
            "aria-keyshortcuts": tableSelectorButton ? tableSelectorButton['aria-keyshortcuts'] : undefined,
            onItemClick: this.insertToolbarMenuItem,
            onKeyDown: this.handleTableSelectorOpenByKeyboard
        })), /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            css: (0, $fcJnk.wrapperStyle)
        }, this.renderPopup(), this.renderTableSelectorPopup(), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $hyKr5.BlockInsertMenu), {
            popupsMountPoint: this.props.popupsMountPoint,
            popupsBoundariesElement: this.props.popupsBoundariesElement,
            popupsScrollableElement: this.props.popupsScrollableElement,
            disabled: this.props.isDisabled ?? false,
            editorView: this.props.editorView,
            spacing: this.props.isReducedSpacing ? 'none' : 'default',
            label: this.props.intl.formatMessage((0, $46A2h.toolbarInsertBlockMessages).insertMenu),
            open: this.state.isPlusMenuOpen,
            plusButtonRef: this.plusButtonRef?.deref(),
            items: this.state.dropdownItems,
            onRef: this.handleDropDownButtonRef,
            onPlusButtonRef: this.handlePlusButtonRef,
            onClick: this.handleClick,
            onKeyDown: this.handleOpenByKeyboard,
            onItemActivated: (0, $eGOwo.fg)('platform_editor_remove_unused_block_insert_props') ? undefined : this.insertInsertMenuItem,
            onOpenChange: (0, $eGOwo.fg)('platform_editor_remove_unused_block_insert_props') ? undefined : this.onOpenChange,
            onInsert: this.insertInsertMenuItem,
            togglePlusMenuVisibility: this.togglePlusMenuVisibility,
            showElementBrowserLink: this.props.showElementBrowserLink || false,
            pluginInjectionApi: this.props.pluginInjectionApi,
            isFullPageAppearance: isFullPageAppearance
        })), (!this.props.pluginInjectionApi?.primaryToolbar && this.props.showSeparator || isFullPageAppearance && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) && /* eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            css: (0, $fcJnk.separatorStyles)
        }));
    }
    constructor(...args){
        super(...args), this.tableButtonRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.tableSelectorButtonRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.state = {
            isPlusMenuOpen: false,
            emojiPickerOpen: false,
            isOpenedByKeyboard: false,
            buttons: [],
            dropdownItems: [],
            isTableSelectorOpen: false,
            isTableSelectorOpenedByKeyboard: false
        }, this.onOpenChange = (attrs)=>{
            const state = {
                isPlusMenuOpen: attrs.isPlusMenuOpen,
                emojiPickerOpen: this.state.emojiPickerOpen
            };
            if (this.state.emojiPickerOpen && !attrs.open) state.emojiPickerOpen = false;
            this.setState(state, ()=>{
                const { dispatchAnalyticsEvent: dispatchAnalyticsEvent } = this.props;
                if (!dispatchAnalyticsEvent) return;
                const { isPlusMenuOpen: isPlusMenuOpen } = this.state;
                if (isPlusMenuOpen) return dispatchAnalyticsEvent({
                    action: (0, $bMFKb.ACTION).OPENED,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).PLUS_MENU,
                    eventType: (0, $bMFKb.EVENT_TYPE).UI
                });
                return dispatchAnalyticsEvent({
                    action: (0, $bMFKb.ACTION).CLOSED,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).PLUS_MENU,
                    eventType: (0, $bMFKb.EVENT_TYPE).UI
                });
            });
        }, this.togglePlusMenuVisibility = (event)=>{
            const { isPlusMenuOpen: isPlusMenuOpen } = this.state;
            const { pluginInjectionApi: pluginInjectionApi } = this.props;
            if (pluginInjectionApi && (0, $eGOwo.fg)('platform_editor_ease_of_use_metrics')) pluginInjectionApi.core.actions.execute(({ tr: tr })=>{
                if (isPlusMenuOpen) pluginInjectionApi.metrics?.commands.startActiveSessionTimer()({
                    tr: tr
                });
                else pluginInjectionApi.metrics?.commands.handleIntentToStartEdit({
                    shouldStartTimer: false,
                    shouldPersistActiveSession: true
                })({
                    tr: tr
                });
                return tr;
            });
            this.onOpenChange({
                isPlusMenuOpen: !isPlusMenuOpen
            });
            if (event?.key === 'Escape') (this.plusButtonRef || this.dropdownButtonRef)?.deref()?.focus();
        }, this.toggleEmojiPicker = (inputMethod = (0, $bMFKb.INPUT_METHOD).TOOLBAR)=>{
            this.setState((prevState)=>({
                    emojiPickerOpen: !prevState.emojiPickerOpen
                }), ()=>{
                if (this.state.emojiPickerOpen) {
                    const { dispatchAnalyticsEvent: dispatchAnalyticsEvent } = this.props;
                    if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                        action: (0, $bMFKb.ACTION).OPENED,
                        actionSubject: (0, $bMFKb.ACTION_SUBJECT).PICKER,
                        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).PICKER_EMOJI,
                        attributes: {
                            inputMethod: inputMethod
                        },
                        eventType: (0, $bMFKb.EVENT_TYPE).UI
                    });
                }
            });
        }, this.handleEmojiPressEscape = ()=>{
            this.toggleEmojiPicker((0, $bMFKb.INPUT_METHOD).KEYBOARD);
            this.emojiButtonRef?.deref()?.focus();
        }, this.handleEmojiClickOutside = (e)=>{
            // Ignore click events for detached elements.
            // Workaround for FS-1322 - where two onClicks fire - one when the upload button is
            // still in the document, and one once it's detached. Does not always occur, and
            // may be a side effect of a react render optimisation
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            if (e.target && !$4be7573df5320310$var$isDetachedElement(e.target)) this.toggleEmojiPicker((0, $bMFKb.INPUT_METHOD).TOOLBAR);
        }, this.getToolbarButtonTestId = (btn)=>{
            const buttonTestIds = {
                media: 'media-attachment-toolbar-button'
            };
            return buttonTestIds[btn.value.name] || String(btn.content);
        }, this.handleToolbarRef = (buttonName)=>(ref)=>{
                if (!ref) return;
                switch(buttonName){
                    case 'emoji':
                        this.emojiButtonRef = new WeakRef(ref);
                        break;
                    case 'media':
                        this.mediaButtonRef = new WeakRef(ref);
                        break;
                }
            }, this.handlePlusButtonRef = (ref)=>{
            if (ref) this.plusButtonRef = new WeakRef(ref);
        }, this.handleDropDownButtonRef = (ref)=>{
            if (ref) this.dropdownButtonRef = new WeakRef(ref);
        }, this.toggleTableSelector = (inputMethod = (0, $bMFKb.INPUT_METHOD).TOOLBAR)=>{
            this.setState((prevState)=>({
                    isTableSelectorOpen: !prevState.isTableSelectorOpen
                }));
        }, this.handleSelectedTableSize = (rowsCount, colsCount)=>{
            this.insertTableWithSize((0, $bMFKb.INPUT_METHOD).TOOLBAR, rowsCount, colsCount)();
            this.toggleTableSelector();
        }, this.handleTableSelectorPressEscape = ()=>{
            this.toggleTableSelector((0, $bMFKb.INPUT_METHOD).KEYBOARD);
            this.tableSelectorButtonRef.current?.focus();
        }, this.handleTableSelectorClickOutside = (e)=>{
            // Ignore click events for detached elements.
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            if (e.target && !$4be7573df5320310$var$isDetachedElement(e.target)) this.toggleTableSelector((0, $bMFKb.INPUT_METHOD).TOOLBAR);
        }, this.handleClick = ()=>{
            this.togglePlusMenuVisibility();
        }, this.handleOpenByKeyboard = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                this.setState({
                    ...this.state,
                    isOpenedByKeyboard: true
                });
                event.preventDefault();
                this.togglePlusMenuVisibility();
            }
        }, this.handleTableSelectorOpenByKeyboard = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') this.setState({
                isTableSelectorOpenedByKeyboard: true
            });
        }, this.toggleLinkPanel = (inputMethod)=>{
            const { pluginInjectionApi: pluginInjectionApi } = this.props;
            return pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.hyperlink?.commands.showLinkToolbar(inputMethod)) ?? false;
        }, this.insertMention = (inputMethod)=>{
            const { editorView: editorView, pluginInjectionApi: pluginInjectionApi } = this.props;
            if (!editorView) return true;
            const pluginState = pluginInjectionApi?.mention?.sharedState.currentState();
            if (pluginState && pluginState.canInsertMention === false) return false;
            return Boolean(pluginInjectionApi?.mention?.actions?.openTypeAhead(inputMethod));
        }, this.insertTable = (inputMethod)=>{
            const { pluginInjectionApi: pluginInjectionApi, editorView: editorView } = this.props;
            const { state: state, dispatch: dispatch } = editorView;
            // workaround to solve race condition where cursor is not placed correctly inside table
            queueMicrotask(()=>{
                pluginInjectionApi?.table?.actions.insertTable?.({
                    action: (0, $bMFKb.ACTION).INSERTED,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).TABLE,
                    attributes: {
                        inputMethod: inputMethod
                    },
                    eventType: (0, $bMFKb.EVENT_TYPE).TRACK
                })(state, dispatch);
            });
        }, this.insertTableWithSize = (inputMethod, rowsCount, colsCount)=>()=>{
                const { pluginInjectionApi: pluginInjectionApi } = this.props;
                // workaround to solve race condition where cursor is not placed correctly inside table
                queueMicrotask(()=>{
                    pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.table?.commands.insertTableWithSize(rowsCount, colsCount, (0, $bMFKb.INPUT_METHOD).PICKER));
                });
            }, this.createDate = (inputMethod)=>{
            const { pluginInjectionApi: pluginInjectionApi } = this.props;
            pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.date?.commands?.insertDate({
                inputMethod: inputMethod
            }));
            return true;
        }, this.createPlaceholderText = ()=>{
            const { editorView: editorView, pluginInjectionApi: pluginInjectionApi } = this.props;
            pluginInjectionApi?.placeholderText?.actions.showPlaceholderFloatingToolbar(editorView.state, editorView.dispatch);
            return true;
        }, this.insertLayoutColumns = (inputMethod)=>{
            const { editorView: editorView, pluginInjectionApi: pluginInjectionApi } = this.props;
            pluginInjectionApi?.layout?.actions.insertLayoutColumns(inputMethod)(editorView.state, editorView.dispatch);
            return true;
        }, this.createStatus = (inputMethod)=>{
            const { pluginInjectionApi: pluginInjectionApi } = this.props;
            return Boolean(pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.status?.commands?.insertStatus(inputMethod)));
        }, this.openMediaPicker = (inputMethod)=>{
            const { onShowMediaPicker: onShowMediaPicker, dispatchAnalyticsEvent: dispatchAnalyticsEvent } = this.props;
            if (onShowMediaPicker) {
                const ref = this.mediaButtonRef?.deref();
                const args = ref ? {
                    ref: ref,
                    mountPoint: this.props.popupsMountPoint ?? ref
                } : undefined;
                onShowMediaPicker(args);
                if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                    action: (0, $bMFKb.ACTION).OPENED,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).PICKER,
                    actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).PICKER_MEDIA,
                    attributes: {
                        inputMethod: inputMethod
                    },
                    eventType: (0, $bMFKb.EVENT_TYPE).UI
                });
            }
            return true;
        }, this.insertTaskDecision = (name, inputMethod)=>()=>{
                const { editorView: { state: state, dispatch: dispatch }, pluginInjectionApi: pluginInjectionApi } = this.props;
                const listType = name === 'action' ? 'taskList' : 'decisionList';
                return pluginInjectionApi?.taskDecision?.actions.insertTaskDecision(listType, inputMethod)(state, dispatch) ?? false;
            }, this.insertHorizontalRule = (inputMethod)=>{
            const { editorView: { state: state, dispatch: dispatch }, pluginInjectionApi: pluginInjectionApi } = this.props;
            return pluginInjectionApi?.rule?.actions.insertHorizontalRule(inputMethod)(state, dispatch) ?? false;
        }, this.insertExpand = ()=>{
            const { editorView: { state: state, dispatch: dispatch }, pluginInjectionApi: pluginInjectionApi } = this.props;
            return pluginInjectionApi?.expand?.actions.insertExpand(state, dispatch) ?? false;
        }, this.insertBlockType = (itemName)=>()=>{
                const { editorView: editorView, onInsertBlockType: onInsertBlockType } = this.props;
                const { state: state, dispatch: dispatch } = editorView;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                onInsertBlockType(itemName)(state, dispatch);
                return true;
            }, this.handleSelectedEmoji = (emojiId)=>{
            const { pluginInjectionApi: pluginInjectionApi } = this.props;
            this.props.editorView.focus();
            pluginInjectionApi?.core?.actions.execute(pluginInjectionApi.emoji?.commands.insertEmoji(emojiId, (0, $bMFKb.INPUT_METHOD).PICKER));
            this.toggleEmojiPicker();
            return true;
        }, this.openElementBrowser = ()=>{
            const { pluginInjectionApi: pluginInjectionApi } = this.props;
            pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.quickInsert?.commands.openElementBrowserModal);
        }, this.onItemActivated = ({ item: item, inputMethod: inputMethod })=>{
            const { editorView: editorView, handleImageUpload: handleImageUpload, expandEnabled: expandEnabled } = this.props;
            // need to do this before inserting nodes so scrollIntoView works properly
            if (!editorView.hasFocus()) editorView.focus();
            switch(item.value.name){
                case 'link':
                    this.toggleLinkPanel(inputMethod);
                    break;
                case 'table':
                    this.insertTable(inputMethod);
                    break;
                case 'table selector':
                    this.toggleTableSelector(inputMethod);
                    break;
                case 'image upload':
                    if (handleImageUpload) {
                        const { state: state, dispatch: dispatch } = editorView;
                        handleImageUpload()(state, dispatch);
                    }
                    break;
                case 'media':
                    this.openMediaPicker(inputMethod);
                    break;
                case 'mention':
                    this.insertMention(inputMethod);
                    break;
                case 'emoji':
                    this.toggleEmojiPicker(inputMethod);
                    break;
                case 'codeblock':
                case 'blockquote':
                case 'panel':
                    this.insertBlockType(item.value.name)();
                    break;
                case 'action':
                case 'decision':
                    this.insertTaskDecision(item.value.name, inputMethod)();
                    break;
                case 'horizontalrule':
                    this.insertHorizontalRule(inputMethod);
                    break;
                case 'macro':
                    /**
         * Remove 'macro' case when cleaning up platform_editor_refactor_view_more
         * along with the 'more' function from platform/packages/editor/editor-plugin-insert-block/src/ui/ToolbarInsertBlock/item.tsx
         * as it will no longer be needed for the View More button.
         * This will also reduce confusion from the 'macro' naming.
         */ if (!(0, $eGOwo.fg)('platform_editor_refactor_view_more')) this.openElementBrowser();
                    break;
                case 'date':
                    this.createDate(inputMethod);
                    break;
                case 'placeholder text':
                    this.createPlaceholderText();
                    break;
                case 'layout':
                    this.insertLayoutColumns(inputMethod);
                    break;
                case 'status':
                    this.createStatus(inputMethod);
                    break;
                // https://product-fabric.atlassian.net/browse/ED-8053
                // @ts-ignore: OK to fallthrough to default
                case 'expand':
                    if (expandEnabled) {
                        this.insertExpand();
                        break;
                    }
                // eslint-disable-next-line no-fallthrough
                default:
                    if (item && item.onClick) {
                        item.onClick();
                        break;
                    }
            }
            this.setState({
                isPlusMenuOpen: false
            });
        }, this.insertToolbarMenuItem = (btn)=>this.onItemActivated({
                item: btn,
                inputMethod: (0, $bMFKb.INPUT_METHOD).TOOLBAR
            }), this.insertInsertMenuItem = ({ item: item })=>this.onItemActivated({
                item: item,
                inputMethod: (0, $bMFKb.INPUT_METHOD).INSERT_MENU
            });
    }
}
var $4be7573df5320310$export$2e2bcd8739ae039 = (0, $6YFG2.default)($4be7573df5320310$export$630ae7da9d01a215);

});
parcelRegister("hyKr5", function(module, exports) {
$parcel$export(module.exports, "BlockInsertMenu", () => $0c0f1e60d653d2d9$export$4476666e12e8d26e);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $4Enee = parcelRequire("4Enee");

var $ji4qM = parcelRequire("ji4qM");
const $0c0f1e60d653d2d9$export$4476666e12e8d26e = (props)=>{
    if ((0, $eGOwo.fg)('platform_editor_refactor_view_more')) {
        if (props.items.length === 0 && !props.showElementBrowserLink) return null;
    } else {
        if (props.items.length === 0) return null;
    }
    if (props.disabled) return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ji4qM.DropDownButton), {
            "aria-expanded": props.open,
            "aria-haspopup": true,
            handleRef: props.onRef,
            selected: props.open,
            disabled: props.disabled,
            onClick: props.onClick,
            onKeyDown: props.onKeyDown,
            spacing: props.spacing,
            label: props.label,
            "aria-keyshortcuts": "/"
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Enee.BlockInsertElementBrowser), {
        disabled: props.disabled,
        editorView: props.editorView,
        items: props.items,
        label: props.label,
        onClick: props.onClick,
        onKeyDown: props.onKeyDown,
        onInsert: props.onInsert,
        onRef: props.onPlusButtonRef,
        open: props.open,
        plusButtonRef: props.plusButtonRef,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsMountPoint: props.popupsMountPoint,
        popupsScrollableElement: props.popupsScrollableElement,
        spacing: props.spacing,
        togglePlusMenuVisibility: props.togglePlusMenuVisibility,
        showElementBrowserLink: props.showElementBrowserLink,
        pluginInjectionApi: props.pluginInjectionApi,
        isFullPageAppearance: props.isFullPageAppearance
    });
};

});
parcelRegister("4Enee", function(module, exports) {
$parcel$export(module.exports, "BlockInsertElementBrowser", () => $b1a631a56c0cf0fa$export$fa06a3a473615c12);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $avm98 = parcelRequire("avm98");

var $6ZPK6 = parcelRequire("6ZPK6");

var $ji4qM = parcelRequire("ji4qM");
// This determines how the popup should fit. We prefer the insert menu
// opening on the bottom as we have a search bar and should only open on
// top if there is more than sufficient room.
const $b1a631a56c0cf0fa$var$FIT_HEIGHT_BUFFER = 100;
const $b1a631a56c0cf0fa$export$fa06a3a473615c12 = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            props.open && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $avm98.default), {
                target: props.plusButtonRef,
                fitHeight: (0, $6ZPK6.DEFAULT_HEIGHT) + $b1a631a56c0cf0fa$var$FIT_HEIGHT_BUFFER,
                fitWidth: 350,
                offset: [
                    0,
                    3
                ],
                mountTo: props.popupsMountPoint,
                boundariesElement: props.popupsBoundariesElement,
                scrollableElement: props.popupsScrollableElement,
                preventOverflow: true,
                alignX: "right",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6ZPK6.default), {
                    editorView: props.editorView,
                    dropdownItems: props.items,
                    onInsert: props.onInsert,
                    toggleVisiblity: props.togglePlusMenuVisibility,
                    showElementBrowserLink: props.showElementBrowserLink,
                    pluginInjectionApi: props.pluginInjectionApi,
                    isFullPageAppearance: props.isFullPageAppearance
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ji4qM.DropDownButton), {
                "aria-expanded": props.open,
                "aria-haspopup": true,
                handleRef: props.onRef,
                selected: props.open,
                disabled: props.disabled,
                onClick: props.onClick,
                onKeyDown: props.onKeyDown,
                spacing: props.spacing,
                label: props.label,
                "aria-keyshortcuts": "/"
            })
        ]
    });
};

});
parcelRegister("ji4qM", function(module, exports) {
$parcel$export(module.exports, "DropDownButton", () => $0a783ef0b70e6660$export$e200d4ca2624495d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6Exgk = parcelRequire("6Exgk");

var $9Sic1 = parcelRequire("9Sic1");

var $kMmrb = parcelRequire("kMmrb");

var $5lAAn = parcelRequire("5lAAn");

var $ifrzO = parcelRequire("ifrzO");
const $0a783ef0b70e6660$var$DropDownButtonIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo((props)=>// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: (0, $ifrzO.triggerWrapper)
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kMmrb))), {
        label: props.label,
        color: "currentColor",
        spacing: "spacious"
    }), /*#__PURE__*/ (0, $1NIU8.jsx)("span", null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
        label: "",
        color: "currentColor",
        LEGACY_margin: "0 0 0 -8px",
        size: "small"
    }))));
const $0a783ef0b70e6660$export$e200d4ca2624495d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo((props)=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, $9Sic1.default), {
        ref: props.handleRef,
        selected: props.selected,
        disabled: props.disabled,
        onClick: props.onClick,
        onKeyDown: props.onKeyDown,
        spacing: props.spacing,
        "aria-expanded": props['aria-expanded'],
        "aria-haspopup": props['aria-haspopup'],
        "aria-keyshortcuts": props['aria-keyshortcuts'],
        "aria-label": `${props.label}`,
        iconBefore: /*#__PURE__*/ (0, $1NIU8.jsx)($0a783ef0b70e6660$var$DropDownButtonIcon, {
            label: ""
        }),
        title: /*#__PURE__*/ (0, $1NIU8.jsx)((0, $6Exgk.ToolTipContent), {
            description: props.label,
            shortcutOverride: "/"
        })
    }));

});
parcelRegister("ifrzO", function(module, exports) {
$parcel$export(module.exports, "triggerWrapper", () => $20651d553950a648$export$61533625d778d03b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $20651d553950a648$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $20651d553950a648$export$61533625d778d03b = {
    name: "y71vja",
    styles: "width:42px;display:flex;align-items:center;> div, > span{display:flex;}> div > div{display:flex;}"
};
const $20651d553950a648$export$16be3daa8c26e74d = {
    name: "8gsxsd",
    styles: "margin-left:var(--ds-space-050, 4px)"
};

});







parcelRegister("4here", function(module, exports) {
$parcel$export(module.exports, "listPlugin", () => (parcelRequire("2AVuz")).listPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $2AVuz = parcelRequire("2AVuz");

});
parcelRegister("2AVuz", function(module, exports) {
$parcel$export(module.exports, "listPlugin", () => $7c71a4576d390b83$export$aab29c128be6b8b2);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $7T1su = parcelRequire("7T1su");
var $gkLMH = parcelRequire("gkLMH");
var $a4ifE = parcelRequire("a4ifE");

var $bMFKb = parcelRequire("bMFKb");

var $6Exgk = parcelRequire("6Exgk");

var $eCOhn = parcelRequire("eCOhn");

var $c1NDo = parcelRequire("c1NDo");

var $eGOwo = parcelRequire("eGOwo");

var $9Letn = parcelRequire("9Letn");

var $92xoS = parcelRequire("92xoS");

var $4XEa7 = parcelRequire("4XEa7");

var $j79rf = parcelRequire("j79rf");

var $gT7GF = parcelRequire("gT7GF");

var $5zzop = parcelRequire("5zzop");

var $cGMTC = parcelRequire("cGMTC");

var $kDOXU = parcelRequire("kDOXU");

var $jVesZ = parcelRequire("jVesZ");

var $510Zv = parcelRequire("510Zv");

var $ftYo6 = parcelRequire("ftYo6");
const $7c71a4576d390b83$export$aab29c128be6b8b2 = ({ config: options, api: api })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    const editorAnalyticsAPI = api?.analytics?.actions;
    if ((0, $9Letn.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true)) api?.blockMenu?.actions.registerBlockMenuComponents((0, $ftYo6.getListComponents)(api));
    return {
        name: 'list',
        actions: {
            isInsideListItem: $510Zv.isInsideListItem,
            findRootParentListNode: $jVesZ.findRootParentListNode
        },
        commands: {
            indentList: (0, $j79rf.indentList)(editorAnalyticsAPI),
            outdentList: (inputMethod)=>(0, $gT7GF.outdentList)(editorAnalyticsAPI)(inputMethod),
            toggleOrderedList: (0, $4XEa7.toggleOrderedList)(editorAnalyticsAPI),
            toggleBulletList: (0, $4XEa7.toggleBulletList)(editorAnalyticsAPI)
        },
        getSharedState: (editorState)=>{
            if (!editorState) return undefined;
            return (0, $kDOXU.pluginKey).getState(editorState);
        },
        nodes () {
            return [
                {
                    name: 'bulletList',
                    node: (0, $eGOwo.fg)('platform_editor_adf_with_localid') ? (0, $7T1su.bulletListWithLocalId) : (0, $7T1su.bulletList)
                },
                {
                    name: 'orderedList',
                    node: (0, $eGOwo.fg)('platform_editor_adf_with_localid') ? (0, $a4ifE.orderedListWithOrderAndLocalId) : (0, $a4ifE.orderedListWithOrder)
                },
                {
                    name: 'listItem',
                    node: (0, $eGOwo.fg)('platform_editor_adf_with_localid') ? (0, $gkLMH.listItemWithLocalId) : (0, $gkLMH.listItem)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'list',
                    plugin: ({ dispatch: dispatch })=>(0, $kDOXU.createPlugin)(dispatch, featureFlags, api)
                },
                {
                    name: 'listInputRule',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, $5zzop.default)(schema, api?.analytics?.actions)
                },
                {
                    name: 'listKeymap',
                    plugin: ()=>(0, $cGMTC.default)(featureFlags, api?.analytics?.actions)
                }
            ];
        },
        pluginsOptions: {
            ...(0, $92xoS.editorExperiment)('platform_editor_insertion', 'control') && {
                quickInsert: ({ formatMessage: formatMessage })=>{
                    return [
                        {
                            id: 'unorderedList',
                            title: formatMessage((0, $eCOhn.messages).unorderedList),
                            description: formatMessage((0, $eCOhn.messages).unorderedListDescription),
                            keywords: [
                                'ul',
                                'unordered'
                            ],
                            priority: 1100,
                            keyshortcut: (0, $6Exgk.tooltip)((0, $6Exgk.toggleBulletList)),
                            icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $c1NDo.IconList), {}),
                            action (insert, state) {
                                const tr = insert(state.schema.nodes.bulletList.createChecked({}, state.schema.nodes.listItem.createChecked({}, state.schema.nodes.paragraph.createChecked())));
                                editorAnalyticsAPI?.attachAnalyticsEvent({
                                    action: (0, $bMFKb.ACTION).INSERTED,
                                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).LIST,
                                    actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET,
                                    eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                                    attributes: {
                                        inputMethod: (0, $bMFKb.INPUT_METHOD).QUICK_INSERT
                                    }
                                })(tr);
                                return tr;
                            }
                        },
                        {
                            id: 'orderedList',
                            title: formatMessage((0, $eCOhn.messages).orderedList),
                            description: formatMessage((0, $eCOhn.messages).orderedListDescription),
                            keywords: [
                                'ol',
                                'ordered'
                            ],
                            priority: 1200,
                            keyshortcut: (0, $6Exgk.tooltip)((0, $6Exgk.toggleOrderedList)),
                            icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $c1NDo.IconListNumber), {}),
                            action (insert, state) {
                                const tr = insert(state.schema.nodes.orderedList.createChecked({}, state.schema.nodes.listItem.createChecked({}, state.schema.nodes.paragraph.createChecked())));
                                editorAnalyticsAPI?.attachAnalyticsEvent({
                                    action: (0, $bMFKb.ACTION).INSERTED,
                                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).LIST,
                                    actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER,
                                    eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                                    attributes: {
                                        inputMethod: (0, $bMFKb.INPUT_METHOD).QUICK_INSERT
                                    }
                                })(tr);
                                return tr;
                            }
                        }
                    ];
                }
            }
        }
    };
};

});
parcelRegister("4XEa7", function(module, exports) {
$parcel$export(module.exports, "enterKeyCommand", () => $0238e4d474468e0a$export$476a01d760cd8a14);
$parcel$export(module.exports, "backspaceKeyCommand", () => $0238e4d474468e0a$export$c1d6e1a8db28fd58);
$parcel$export(module.exports, "deleteKeyCommand", () => $0238e4d474468e0a$export$ca522099b17e5b55);
$parcel$export(module.exports, "toggleList", () => $0238e4d474468e0a$export$78da663726cb9398);
$parcel$export(module.exports, "toggleBulletList", () => $0238e4d474468e0a$export$c0e115f47553645e);
$parcel$export(module.exports, "toggleOrderedList", () => $0238e4d474468e0a$export$dca848a1b50b6a31);

var $bMFKb = parcelRequire("bMFKb");

var $2Ttys = parcelRequire("2Ttys");

var $9R6MF = parcelRequire("9R6MF");
var $4gTd9 = parcelRequire("4gTd9");

var $8GLF3 = parcelRequire("8GLF3");

var $6BNUN = parcelRequire("6BNUN");

var $HOLTj = parcelRequire("HOLTj");
var $bnAxN = parcelRequire("bnAxN");

var $dEkUJ = parcelRequire("dEkUJ");

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");

var $eGOwo = parcelRequire("eGOwo");

var $9KYIN = parcelRequire("9KYIN");

var $llTxy = parcelRequire("llTxy");

var $5z2mt = parcelRequire("5z2mt");

var $amcSn = parcelRequire("amcSn");

var $510Zv = parcelRequire("510Zv");

var $7BSUw = parcelRequire("7BSUw");

var $75YHg = parcelRequire("75YHg");

var $g2Qv0 = parcelRequire("g2Qv0");

var $gT7GF = parcelRequire("gT7GF");
const $0238e4d474468e0a$export$476a01d760cd8a14 = (editorAnalyticsAPI)=>()=>(state, dispatch)=>{
            const { selection: selection } = state;
            if (selection.empty) {
                const { $from: $from } = selection;
                const { listItem: listItem, codeBlock: codeBlock } = state.schema.nodes;
                // the list item is the parent of the gap cursor
                // while for text, list item is the grant parent of the text node
                const isGapCursorSelection = selection instanceof (0, $6BNUN.GapCursorSelection);
                const wrapper = isGapCursorSelection && (0, $eGOwo.fg)('platform_editor_split_list_item_for_gap_cursor') ? $from.parent : $from.node($from.depth - 1);
                if (wrapper && wrapper.type === listItem) {
                    /** Check if the wrapper has any visible content */ const wrapperHasContent = (0, $bnAxN.hasVisibleContent)(wrapper);
                    if (!wrapperHasContent) return (0, $8GLF3.editorCommandToPMCommand)((0, $gT7GF.outdentList)(editorAnalyticsAPI)((0, $bMFKb.INPUT_METHOD).KEYBOARD))(state, dispatch);
                    else if (!(0, $BmspC.hasParentNodeOfType)(codeBlock)(selection)) return $0238e4d474468e0a$var$splitListItem(listItem)(state, dispatch);
                }
            }
            return false;
        };
const $0238e4d474468e0a$export$c1d6e1a8db28fd58 = (editorAnalyticsAPI)=>()=>(state, dispatch)=>{
            return (0, $dEkUJ.chainCommands)((0, $g2Qv0.listBackspace)(editorAnalyticsAPI), // if we're at the start of a list item, we need to either backspace
            // directly to an empty list item above, or outdent this node
            (0, $HOLTj.filterCommand)([
                (0, $HOLTj.isEmptySelectionAtStart),
                // list items might have multiple paragraphs; only do this at the first one
                (0, $7BSUw.isFirstChildOfParent),
                (state)=>(0, $510Zv.isInsideListItem)(state.tr)
            ], (0, $dEkUJ.chainCommands)($0238e4d474468e0a$var$deletePreviousEmptyListItem, (0, $8GLF3.editorCommandToPMCommand)((0, $gT7GF.outdentList)(editorAnalyticsAPI)((0, $bMFKb.INPUT_METHOD).KEYBOARD)))), // if we're just inside a paragraph node (or gapcursor is shown) and backspace, then try to join
            // the text to the previous list item, if one exists
            (0, $HOLTj.filterCommand)([
                (0, $HOLTj.isEmptySelectionAtStart),
                (state)=>(0, $510Zv.canJoinToPreviousListItem)(state.tr)
            ], $0238e4d474468e0a$var$joinToPreviousListItem))(state, dispatch);
        };
const $0238e4d474468e0a$export$ca522099b17e5b55 = (editorAnalyticsAPI)=>(0, $75YHg.joinListItemForward)(editorAnalyticsAPI);
const $0238e4d474468e0a$export$3ee0594e8fdf55d5 = (pos, nodes)=>{
    const { bulletList: bulletList, orderedList: orderedList, listItem: listItem } = nodes;
    let depth;
    for(let i = pos.depth - 1; i > 0; i--){
        const node = pos.node(i);
        if (node.type === bulletList || node.type === orderedList) depth = i;
        if (node.type !== bulletList && node.type !== orderedList && node.type !== listItem) break;
    }
    return depth;
};
function $0238e4d474468e0a$var$untoggleSelectedList(tr) {
    const { selection: selection } = tr;
    const depth = $0238e4d474468e0a$export$3ee0594e8fdf55d5(selection.$to, tr.doc.type.schema.nodes);
    tr = (0, $5z2mt.liftFollowingList)(selection.$to.pos, selection.$to.end(depth), depth || 0, tr);
    if (selection instanceof (0, $3lIcL.NodeSelection) || selection instanceof (0, $6BNUN.GapCursorSelection)) return (0, $5z2mt.liftNodeSelectionList)(selection, tr);
    return (0, $5z2mt.liftTextSelectionList)(selection, tr);
}
const $0238e4d474468e0a$export$78da663726cb9398 = (editorAnalyticsAPI)=>(inputMethod, listType)=>{
        return function({ tr: tr }) {
            const { taskList: taskList } = tr.doc.type.schema.nodes;
            if ((0, $BmspC.hasParentNodeOfType)(taskList)(tr.selection)) return tr;
            const listInsideSelection = (0, $510Zv.selectionContainsList)(tr);
            const listNodeType = tr.doc.type.schema.nodes[listType];
            const actionSubjectId = listType === 'bulletList' ? (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET : (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
            if (listInsideSelection) {
                const { selection: selection } = tr;
                // for gap cursor or node selection - list is expected 1 level up (listItem -> list)
                // for text selection - list is expected 2 levels up (paragraph -> listItem -> list)
                const positionDiff = selection instanceof (0, $6BNUN.GapCursorSelection) || selection instanceof (0, $3lIcL.NodeSelection) ? 1 : 2;
                const fromNode = selection.$from.node(selection.$from.depth - positionDiff);
                const toNode = selection.$to.node(selection.$to.depth - positionDiff);
                const transformedFrom = listInsideSelection.type.name === 'bulletList' ? (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET : (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
                if (fromNode?.type.name === listType && toNode?.type.name === listType) {
                    const commonAttributes = (0, $9R6MF.getCommonListAnalyticsAttributes)(tr);
                    $0238e4d474468e0a$var$untoggleSelectedList(tr);
                    editorAnalyticsAPI?.attachAnalyticsEvent({
                        action: (0, $bMFKb.ACTION).CONVERTED,
                        actionSubject: (0, $bMFKb.ACTION_SUBJECT).LIST,
                        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).TEXT,
                        eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                        attributes: {
                            ...commonAttributes,
                            transformedFrom: transformedFrom,
                            inputMethod: inputMethod
                        }
                    })(tr);
                    return tr;
                }
                (0, $9KYIN.convertListType)({
                    tr: tr,
                    nextListNodeType: listNodeType
                });
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $bMFKb.ACTION).CONVERTED,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).LIST,
                    actionSubjectId: actionSubjectId,
                    eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                    attributes: {
                        ...(0, $9R6MF.getCommonListAnalyticsAttributes)(tr),
                        transformedFrom: transformedFrom,
                        inputMethod: inputMethod
                    }
                })(tr);
            } else {
                // Need to have this before wrapInList so the wrapping is done with valid content
                // For example, if trying to convert centre or right aligned paragraphs to lists
                (0, $amcSn.sanitiseMarksInSelection)(tr, listNodeType);
                (0, $llTxy.wrapInListAndJoin)(listNodeType, tr);
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $bMFKb.ACTION).INSERTED,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).LIST,
                    actionSubjectId: actionSubjectId,
                    eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                    attributes: {
                        inputMethod: inputMethod
                    }
                })(tr);
            }
            // If document wasn't changed, return false from the command to indicate that the
            // editing action failed
            if (!tr.docChanged) return null;
            return tr;
        };
    };
const $0238e4d474468e0a$export$c0e115f47553645e = (editorAnalyticsAPI)=>(inputMethod = (0, $bMFKb.INPUT_METHOD).TOOLBAR)=>{
        return $0238e4d474468e0a$export$78da663726cb9398(editorAnalyticsAPI)(inputMethod, 'bulletList');
    };
const $0238e4d474468e0a$export$dca848a1b50b6a31 = (editorAnalyticsAPI)=>(inputMethod = (0, $bMFKb.INPUT_METHOD).TOOLBAR)=>{
        return $0238e4d474468e0a$export$78da663726cb9398(editorAnalyticsAPI)(inputMethod, 'orderedList');
    };
/**
 * Implementation taken and modified for our needs from PM
 * @param itemType Node
 * Splits the list items, specific implementation take from PM
 */ function $0238e4d474468e0a$var$splitListItem(itemType) {
    return function(state, dispatch) {
        const ref = state.selection;
        const $from = ref.$from;
        const $to = ref.$to;
        const node = ref.node;
        if (node && node.isBlock || $from.depth < 2 || !$from.sameParent($to)) return false;
        // list item is the parent of the gap cursor instead of grant parent;
        // rename grantParent to WrapperlistItem once we clean up platform_editor_split_list_item_for_gap_cursor
        const isGapCursorSelection = ref instanceof (0, $6BNUN.GapCursorSelection);
        const grandParent = isGapCursorSelection && (0, $eGOwo.fg)('platform_editor_split_list_item_for_gap_cursor') ? $from.parent : $from.node(-1);
        if (grandParent.type !== itemType) return false;
        /** --> The following line changed from the original PM implementation to allow list additions with multiple paragraphs */ if (// eslint-disable-next-line @typescript-eslint/no-explicit-any
        grandParent.content.content.length <= 1 && $from.parent.content.size === 0 && !(grandParent.content.size === 0)) {
            // In an empty block. If this is a nested list, the wrapping
            // list item should be split. Otherwise, bail out and let next
            // command handle lifting.
            if ($from.depth === 2 || $from.node(-3).type !== itemType || $from.index(-2) !== $from.node(-2).childCount - 1) return false;
            if (dispatch) {
                let wrap = (0, $3xw6l.Fragment).empty;
                const keepItem = $from.index(-1) > 0;
                // Build a fragment containing empty versions of the structure
                // from the outer list item to the parent node of the cursor
                for(let d = $from.depth - (keepItem ? 1 : 2); d >= $from.depth - 3; d--)wrap = (0, $3xw6l.Fragment).from($from.node(d).copy(wrap));
                // Add a second list item with an empty default start node
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                wrap = wrap.append((0, $3xw6l.Fragment).from(itemType.createAndFill()));
                const tr$1 = state.tr.replace($from.before(keepItem ? undefined : -1), $from.after(-3), new (0, $3xw6l.Slice)(wrap, keepItem ? 3 : 2, 2));
                tr$1.setSelection(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                state.selection.constructor.near(tr$1.doc.resolve($from.pos + (keepItem ? 3 : 2))));
                dispatch(tr$1.scrollIntoView());
            }
            return true;
        }
        const nextType = $to.pos === $from.end() ? grandParent.contentMatchAt(0).defaultType : null;
        const tr = state.tr.delete($from.pos, $to.pos);
        const types = nextType && [
            null,
            {
                type: nextType
            }
        ];
        if ((0, $eGOwo.fg)('platform_editor_split_list_item_for_gap_cursor')) {
            if (dispatch) {
                if (ref instanceof (0, $3lIcL.TextSelection)) {
                    dispatch(tr.split($from.pos, 2, types ?? undefined).scrollIntoView());
                    return true;
                }
                // create new list item with empty paragraph when user click enter on gap cursor
                if (isGapCursorSelection && $from.nodeBefore?.isBlock) {
                    // For gap cursor selection , we can not split the list item directly
                    // We need to insert a new list item after the current list item to simulate the split behaviour
                    const { listItem: listItem, paragraph: paragraph } = state.schema.nodes;
                    const newListItem = listItem.createChecked({}, paragraph.createChecked());
                    dispatch(tr.insert($from.pos, newListItem).setSelection((0, $3lIcL.Selection).near(tr.doc.resolve($to.pos + 1))).scrollIntoView());
                    return true;
                }
            }
            return false;
        } else {
            if (dispatch) dispatch(tr.split($from.pos, 2, types ?? undefined).scrollIntoView());
            return true;
        }
    };
}
const $0238e4d474468e0a$var$deletePreviousEmptyListItem = (state, dispatch)=>{
    const { $from: $from } = state.selection;
    const { listItem: listItem } = state.schema.nodes;
    const $cut = (0, $2Ttys.findCutBefore)($from);
    if (!$cut || !$cut.nodeBefore || !($cut.nodeBefore.type === listItem)) return false;
    const nodeBeforeIsExtension = $cut.nodeBefore.firstChild && $cut.nodeBefore.firstChild.type.name === 'extension';
    const previousListItemEmpty = // Ignored via go/ees005
    $cut.nodeBefore.childCount === 1 && $cut.nodeBefore.firstChild && $cut.nodeBefore.firstChild.nodeSize <= 2 && !nodeBeforeIsExtension;
    if (previousListItemEmpty) {
        const { tr: tr } = state;
        if (dispatch) dispatch(tr.delete($cut.pos - $cut.nodeBefore.nodeSize, $from.pos).scrollIntoView());
        return true;
    }
    return false;
};
const $0238e4d474468e0a$var$joinToPreviousListItem = (state, dispatch)=>{
    const { $from: $from } = state.selection;
    const { paragraph: paragraph, listItem: listItem, codeBlock: codeBlock, bulletList: bulletList, orderedList: orderedList } = state.schema.nodes;
    const isGapCursorShown = state.selection instanceof (0, $6BNUN.GapCursorSelection);
    const $cutPos = isGapCursorShown ? state.doc.resolve($from.pos + 1) : $from;
    const $cut = (0, $2Ttys.findCutBefore)($cutPos);
    if (!$cut) return false;
    // see if the containing node is a list
    if ($cut.nodeBefore && [
        bulletList,
        orderedList
    ].indexOf($cut.nodeBefore.type) > -1) // and the node after this is a paragraph or a codeBlock
    {
        if ($cut.nodeAfter && ($cut.nodeAfter.type === paragraph || $cut.nodeAfter.type === codeBlock)) {
            // find the nearest paragraph that precedes this node
            let $lastNode = $cut.doc.resolve($cut.pos - 1);
            while($lastNode.parent.type !== paragraph && $lastNode.pos > 1)$lastNode = state.doc.resolve($lastNode.pos - 1);
            let { tr: tr } = state;
            if (isGapCursorShown) {
                const nodeBeforePos = (0, $BmspC.findPositionOfNodeBefore)(tr.selection);
                if (typeof nodeBeforePos !== 'number') return false;
                // append the codeblock to the list node
                const list = $cut.nodeBefore.copy($cut.nodeBefore.content.append((0, $3xw6l.Fragment).from(listItem.createChecked({}, $cut.nodeAfter))));
                tr.replaceWith(nodeBeforePos, $from.pos + $cut.nodeAfter.nodeSize, list);
            } else {
                const step = (0, $4gTd9.moveTargetIntoList)({
                    insertPosition: $lastNode.pos,
                    $target: $cut
                });
                // ED-13966: check if the step will cause an ProseMirror error
                // if there's an error don't apply the step as it will might lead into a data loss.
                // It doesn't play well with media being a leaf node.
                const stepResult = state.tr.maybeStep(step);
                if (stepResult.failed) return false;
                else tr = state.tr.step(step);
            }
            // find out if there's now another list following and join them
            // as in, [list, p, list] => [list with p, list], and we want [joined list]
            const $postCut = tr.doc.resolve(tr.mapping.map($cut.pos + $cut.nodeAfter.nodeSize));
            if ($postCut.nodeBefore && $postCut.nodeAfter && $postCut.nodeBefore.type === $postCut.nodeAfter.type && [
                bulletList,
                orderedList
            ].indexOf($postCut.nodeBefore.type) > -1) tr = tr.join($postCut.pos);
            if (dispatch) {
                if (!tr.doc.resolve($lastNode.pos).nodeBefore?.isBlock || tr.doc.resolve($lastNode.pos).nodeBefore === null) tr = tr.setSelection((0, $3lIcL.TextSelection).near(tr.doc.resolve(tr.mapping.map($cut.pos)), -1));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    return false;
};

});
parcelRegister("2Ttys", function(module, exports) {
$parcel$export(module.exports, "addParagraphAtEnd", () => $401855f8a07ae14f$export$fc18809329b5ff08);
$parcel$export(module.exports, "changeImageAlignment", () => $401855f8a07ae14f$export$774cc08dd90b6a6a);
$parcel$export(module.exports, "changeImageAlignmentNext", () => $401855f8a07ae14f$export$b637dda807357427);
$parcel$export(module.exports, "createToggleBlockMarkOnRange", () => $401855f8a07ae14f$export$1115c4cf51ae1924);
$parcel$export(module.exports, "createToggleInlineMarkOnRange", () => $401855f8a07ae14f$export$a10bb5a1a10022f6);
$parcel$export(module.exports, "toggleBlockMark", () => $401855f8a07ae14f$export$72d6145976985e8c);
$parcel$export(module.exports, "toggleBlockMarkNext", () => $401855f8a07ae14f$export$23f118e134ed2228);
$parcel$export(module.exports, "findCutBefore", () => $401855f8a07ae14f$export$ad1078cb3917e860);

var $3lIcL = parcelRequire("3lIcL");

var $cwzAY = parcelRequire("cwzAY");

var $piMVJ = parcelRequire("piMVJ");
function $401855f8a07ae14f$export$fc18809329b5ff08(tr) {
    const { doc: { type: { schema: { nodes: { paragraph: paragraph } } } }, doc: doc } = tr;
    if (doc.lastChild && !(doc.lastChild.type === paragraph && doc.lastChild.content.size === 0)) {
        if (paragraph) tr.insert(doc.content.size, paragraph.createAndFill());
    }
    tr.setSelection((0, $3lIcL.TextSelection).create(tr.doc, tr.doc.content.size - 1));
    tr.scrollIntoView();
}
function $401855f8a07ae14f$export$2864da03fd603a92() {
    return function(state, dispatch) {
        const { tr: tr } = state;
        $401855f8a07ae14f$export$fc18809329b5ff08(tr);
        if (dispatch) dispatch(tr);
        return true;
    };
}
const $401855f8a07ae14f$export$774cc08dd90b6a6a = (align)=>(state, dispatch)=>{
        const { from: from, to: to } = state.selection;
        const tr = state.tr;
        state.doc.nodesBetween(from, to, (node, pos)=>{
            if (node.type === state.schema.nodes.mediaSingle) tr.setNodeMarkup(pos, undefined, {
                ...node.attrs,
                layout: align === 'center' ? 'center' : `align-${align}`
            });
        });
        if (tr.docChanged && dispatch) {
            dispatch(tr.scrollIntoView());
            return true;
        }
        return false;
    };
const $401855f8a07ae14f$export$b637dda807357427 = (align)=>(tr)=>{
        const { from: from, to: to } = tr.selection;
        const initialDoc = tr.doc;
        tr.doc.nodesBetween(from, to, (node, pos)=>{
            if (node.type === tr.doc.type.schema.nodes.mediaSingle) tr.setNodeMarkup(pos, undefined, {
                ...node.attrs,
                layout: align === 'center' ? 'center' : `align-${align}`
            });
        });
        // compare tr.doc with initialDoc instead of tr.docChanged
        // because tr passed in might have been modified prior this function
        // e.g. see changeAlignmentTr platform/packages/editor/editor-plugin-alignment/src/editor-commands/index.ts:L197
        if (!tr.doc.eq(initialDoc)) {
            tr.scrollIntoView();
            return true;
        }
        return false;
    };
const $401855f8a07ae14f$export$1115c4cf51ae1924 = (markType, getAttrs, allowedBlocks)=>(from, to, tr, state)=>{
        let markApplied = false;
        state.doc.nodesBetween(from, to, (node, pos, parent)=>{
            if (!node.type.isBlock) return false;
            const parentAllowsMark = state?.schema?.nodes?.blockTaskItem && parent?.type === state?.schema?.nodes?.blockTaskItem && markType === state?.schema?.marks?.indentation ? false : parent?.type.allowsMarkType(markType);
            if ((!allowedBlocks || (Array.isArray(allowedBlocks) ? allowedBlocks.indexOf(node.type) > -1 : allowedBlocks(state.schema, node, parent))) && parentAllowsMark) {
                const oldMarks = node.marks.filter((mark)=>mark.type === markType);
                const prevAttrs = oldMarks.length ? oldMarks[0].attrs : undefined;
                const newAttrs = getAttrs(prevAttrs, node);
                if (newAttrs !== undefined) {
                    tr.setNodeMarkup(pos, node.type, node.attrs, node.marks.filter((mark)=>!markType.excludes(mark.type)).concat(newAttrs === false ? [] : markType.create(newAttrs)));
                    markApplied = true;
                }
            }
            return;
        });
        return markApplied;
    };
const $401855f8a07ae14f$export$8614a16deba8906f = (markType, getAttrs, allowedBlocks)=>(from, to, tr)=>{
        let markApplied = false;
        tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
            if (!node.type.isBlock) return false;
            const schema = tr.doc.type.schema;
            const parentAllowsMark = schema?.nodes?.blockTaskItem && parent?.type === schema?.nodes?.blockTaskItem && markType === schema?.marks?.indentation ? false : parent?.type.allowsMarkType(markType);
            if ((!allowedBlocks || (Array.isArray(allowedBlocks) ? allowedBlocks.indexOf(node.type) > -1 : allowedBlocks(tr.doc.type.schema, node, parent))) && parentAllowsMark) {
                const oldMarks = node.marks.filter((mark)=>mark.type === markType);
                const prevAttrs = oldMarks.length ? oldMarks[0].attrs : undefined;
                const newAttrs = getAttrs(prevAttrs, node);
                if (newAttrs !== undefined) {
                    tr.setNodeMarkup(pos, node.type, node.attrs, node.marks.filter((mark)=>!markType.excludes(mark.type)).concat(newAttrs === false ? [] : markType.create(newAttrs)));
                    markApplied = true;
                }
            }
            return;
        });
        return markApplied;
    };
const $401855f8a07ae14f$export$a10bb5a1a10022f6 = (markType, getAttrs)=>(from, to, tr, state)=>{
        let markApplied = false;
        state.doc.nodesBetween(from, to, (node, pos, parent)=>{
            if (parent?.type.allowsMarkType(markType)) {
                const oldMarks = node.marks.filter((mark)=>mark.type === markType);
                const prevAttrs = oldMarks.length ? oldMarks[0].attrs : undefined;
                const newAttrs = getAttrs(prevAttrs, node);
                if (newAttrs !== undefined) {
                    tr.setNodeMarkup(pos, node.type, node.attrs, node.marks.filter((mark)=>!markType.excludes(mark.type)).concat(newAttrs === false ? [] : markType.create(newAttrs)));
                    tr.setSelection((0, $3lIcL.NodeSelection).create(tr.doc, state.selection.from));
                    markApplied = true;
                }
            }
            return;
        });
        return markApplied;
    };
const $401855f8a07ae14f$export$72d6145976985e8c = (markType, getAttrs, allowedBlocks)=>(state, dispatch)=>{
        let markApplied = false;
        const tr = state.tr;
        const toggleBlockMarkOnRange = $401855f8a07ae14f$export$1115c4cf51ae1924(markType, getAttrs, allowedBlocks);
        if (state.selection instanceof (0, $cwzAY.CellSelection)) state.selection.forEachCell((cell, pos)=>{
            markApplied = toggleBlockMarkOnRange(pos, pos + cell.nodeSize, tr, state);
        });
        else {
            const { from: from, to: to } = state.selection;
            markApplied = toggleBlockMarkOnRange(from, to, tr, state);
        }
        if (markApplied && tr.docChanged) {
            if (dispatch) dispatch(tr.scrollIntoView());
            return true;
        }
        return false;
    };
const $401855f8a07ae14f$export$23f118e134ed2228 = (markType, getAttrs, allowedBlocks)=>(tr)=>{
        let markApplied = false;
        const toggleBlockMarkOnRange = $401855f8a07ae14f$export$8614a16deba8906f(markType, getAttrs, allowedBlocks);
        const initialDoc = tr.doc;
        const { selection: selection } = tr;
        if (selection instanceof (0, $cwzAY.CellSelection)) selection.forEachCell((cell, pos)=>{
            markApplied = toggleBlockMarkOnRange(pos, pos + cell.nodeSize, tr);
        });
        else {
            const { from: from, to: to } = selection;
            markApplied = toggleBlockMarkOnRange(from, to, tr);
        }
        // compare tr.doc with initialDoc instead of tr.docChanged
        // because tr passed in might have been modified prior this function
        // e.g. see changeAlignmentTr platform/packages/editor/editor-plugin-alignment/src/editor-commands/index.ts:L197
        if (markApplied && !initialDoc.eq(tr.doc)) {
            tr.scrollIntoView();
            return true;
        }
        return false;
    };
const $401855f8a07ae14f$export$59c0bf8874edecc7 = (state, dispatch)=>{
    const tr = state.tr;
    tr.replace(0, state.doc.nodeSize - 2);
    tr.setSelection((0, $3lIcL.Selection).atStart(tr.doc));
    if (dispatch) {
        dispatch(tr);
        return true;
    }
    return false;
};
function $401855f8a07ae14f$export$ad1078cb3917e860($pos) {
    // parent is non-isolating, so we can look across this boundary
    if (!$pos.parent.type.spec.isolating) // search up the tree from the pos's *parent*
    for(let i = $pos.depth - 1; i >= 0; i--){
        // starting from the inner most node's parent, find out
        // if we're not its first child
        if ($pos.index(i) > 0) return $pos.doc.resolve($pos.before(i + 1));
        if ($pos.node(i).type.spec.isolating) break;
    }
    return null;
}
function $401855f8a07ae14f$export$c6a04dca1ed03a3c(level) {
    return function(state, dispatch) {
        const { selection: selection, schema: schema, tr: tr } = state;
        const ranges = selection instanceof (0, $cwzAY.CellSelection) ? selection.ranges : [
            selection
        ];
        ranges.forEach(({ $from: $from, $to: $to })=>{
            tr.setBlockType($from.pos, $to.pos, schema.nodes.heading, {
                level: level
            });
        });
        if (dispatch) dispatch(tr);
        return true;
    };
}

});

parcelRegister("9R6MF", function(module, exports) {
$parcel$export(module.exports, "getCommonListAnalyticsAttributes", () => $db893f1ab5fe5614$export$b4f9b2b8a958b87c);

var $fCXIH = parcelRequire("fCXIH");

var $81iCy = parcelRequire("81iCy");
const $db893f1ab5fe5614$export$b4f9b2b8a958b87c = (tr)=>{
    const { selection: { $from: $from, $to: $to } } = tr;
    const fromAttrs = (0, $81iCy.getListItemAttributes)($from);
    const toAttrs = (0, $81iCy.getListItemAttributes)($to);
    return {
        itemIndexAtSelectionStart: fromAttrs.itemIndex,
        itemIndexAtSelectionEnd: toAttrs.itemIndex,
        indentLevelAtSelectionStart: fromAttrs.indentLevel,
        indentLevelAtSelectionEnd: toAttrs.indentLevel,
        itemsInSelection: $db893f1ab5fe5614$export$c910df91212e45f2(tr)
    };
};
const $db893f1ab5fe5614$export$c910df91212e45f2 = (tr)=>{
    const { from: from, to: to } = tr.selection;
    if (from === to) return 1;
    let count = 0;
    const listSlice = tr.doc.cut(from, to);
    listSlice.content.nodesBetween(0, listSlice.content.size, (node, pos, parent, index)=>{
        if (parent && (0, $fCXIH.isListItemNode)(parent) && !(0, $fCXIH.isListNode)(node) && index === 0) count++;
    });
    return count;
};

});

parcelRegister("4gTd9", function(module, exports) {
$parcel$export(module.exports, "moveTargetIntoList", () => $68ed78c955482647$export$cbf2f67c120cb8dd);
$parcel$export(module.exports, "wrapTaskListIntoListAbove", () => $68ed78c955482647$export$d113ea522b2117ee);

var $3xw6l = parcelRequire("3xw6l");

var $lzEKq = parcelRequire("lzEKq");
const $68ed78c955482647$export$cbf2f67c120cb8dd = ({ insertPosition: insertPosition, $target: $target })=>{
    // take the text content of the paragraph and insert after the paragraph up until before the the cut
    const from = insertPosition;
    const to = $target.pos + ($target.nodeAfter?.nodeSize || 0); //$cut.pos + $cut.nodeAfter.nodeSize;
    const gapFrom = $target.posAtIndex(0, $target.depth + 1); // start pos of the child
    const gapTo = $target.doc.resolve(gapFrom).end(); // end pos of the paragraph
    if (gapTo - gapFrom === 0) return new (0, $lzEKq.ReplaceStep)(from, to, $target.doc.slice(insertPosition, $target.pos));
    const step = new (0, $lzEKq.ReplaceAroundStep)(from, to, gapFrom, gapTo, $target.doc.slice(insertPosition, $target.pos), 0, true);
    return step;
};
const $68ed78c955482647$export$d113ea522b2117ee = (tr, taskListStart, previousListStart)=>{
    const $taskListStart = tr.doc.resolve(taskListStart);
    /* Safecheck: if not passed a taskList node, return */ if ($taskListStart.node().type.name !== 'taskList') return;
    const $previousListStart = tr.doc.resolve(previousListStart);
    const taskList = tr.doc.slice($taskListStart.pos, $taskListStart.after());
    const frag = (0, $3xw6l.Fragment).from(taskList.content);
    /*
    Delete the existing taskList at the same level and insert inside above list provided
    1. To delete the tasklist, we need wrapping positions before and after it to completely delete it.
      $taskListStart.after() would give us closing position enclosed by node itself using it would remove only the contents of taskList
      so we add 1 to it to get the position after the taskList node and completly remove it.
    2. Inserting the taskList at the end() position safe inserts the taskList to next available position which would lead to deleting and inserting taskList at same place.
      Reason: $previousListStart.end() gives us end position of listItem but we can add content only inside listItem not at same level
      so we subtract 1 to get the position inside the list item and insert the TaskList same level as paragraph/content inside listItem.
  */ tr.delete($taskListStart.before(), $taskListStart.after() + 1);
    tr.insert($previousListStart.end() - 1, frag);
};

});

parcelRegister("9KYIN", function(module, exports) {
$parcel$export(module.exports, "convertListType", () => $44daaa53c9e21854$export$193e29566e093d19);

var $49G1L = parcelRequire("49G1L");

var $6BNUN = parcelRequire("6BNUN");
parcelRequire("3ADzg");
var $5Z3Rm = parcelRequire("5Z3Rm");
var $fCXIH = parcelRequire("fCXIH");

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $lzEKq = parcelRequire("lzEKq");

var $BmspC = parcelRequire("BmspC");

var $jVesZ = parcelRequire("jVesZ");
function $44daaa53c9e21854$export$193e29566e093d19({ tr: tr, nextListNodeType: nextListNodeType }) {
    const { doc: doc, selection: { $from: $from, $to: $to } } = tr;
    let listRange;
    if (tr.selection instanceof (0, $6BNUN.GapCursorSelection)) {
        const nodeSize = $from.nodeAfter?.nodeSize || 1;
        listRange = $from.blockRange($from.doc.resolve($from.pos + nodeSize));
    } else listRange = $from.blockRange($to, (0, $fCXIH.isListNode));
    if (listRange) return $44daaa53c9e21854$var$convertSelectedList({
        tr: tr,
        nextListNodeType: nextListNodeType
    });
    const nodeRangeAroundList = $from.blockRange($to);
    if (!nodeRangeAroundList) return;
    const parentNode = nodeRangeAroundList.parent;
    const { startIndex: startIndex, endIndex: endIndex, depth: depth } = nodeRangeAroundList;
    // Checking for invalid nodes to prevent conversion
    // eg. a panel cannot be wrapped in a list so return
    // It will skip this check if the selection begins within a list
    // This is to match the behaviour of the toolbar buttons being disabled
    if (!(0, $jVesZ.findFirstParentListNode)($from)) for(let i = startIndex; i < endIndex; i++){
        const position = nodeRangeAroundList.$from.posAtIndex(i, depth);
        const resolvedPosition = doc.resolve(position);
        const currentChild = parentNode.child(i);
        const currentNodeRange = resolvedPosition.blockRange(tr.doc.resolve(position + currentChild.nodeSize));
        if (currentNodeRange && !(0, $fCXIH.isListNode)(currentChild) && !(0, $lzEKq.findWrapping)(currentNodeRange, nextListNodeType)) return;
    }
    // Checking for any non list nodes and wrapping them in a list
    // so they can be converted
    tr.doc.nodesBetween(nodeRangeAroundList.start, nodeRangeAroundList.end, (node, pos)=>{
        // Skip over any nodes that are part of a list
        if ((0, $jVesZ.findFirstParentListNode)(tr.doc.resolve(tr.mapping.map(pos)))) return false;
        // The following applies to suitable nodes that are not within a list
        const currentNodeNotWrappedInList = node;
        const isNotAnEmptyParagraphAndIsParagraphOrLeafNode = !(0, $5Z3Rm.isEmptyParagraph)(currentNodeNotWrappedInList) && (!node.type.isBlock || node.type.name === 'paragraph');
        if (isNotAnEmptyParagraphAndIsParagraphOrLeafNode && nodeRangeAroundList) {
            const remainingNodeRange = new (0, $3xw6l.NodeRange)(tr.doc.resolve(tr.mapping.map(pos)), tr.doc.resolve(tr.mapping.map(pos) + currentNodeNotWrappedInList.nodeSize), nodeRangeAroundList.depth);
            $44daaa53c9e21854$var$convertAroundList({
                tr: tr,
                nextListNodeType: nextListNodeType,
                nodeRange: remainingNodeRange
            });
            return false;
        }
    });
    $44daaa53c9e21854$var$convertSelectedList({
        tr: tr,
        nextListNodeType: nextListNodeType
    });
    if (tr.docChanged) (0, $49G1L.joinSiblingLists)({
        tr: tr,
        forceListType: nextListNodeType
    });
}
const $44daaa53c9e21854$var$convertSelectedList = ({ tr: tr, nextListNodeType: nextListNodeType })=>{
    const { selection: selection, selection: { from: from, to: to } } = tr;
    const { codeBlock: codeBlock } = tr.doc.type.schema.nodes;
    // get the positions of all the leaf nodes within the selection
    const nodePositions = [];
    if (selection instanceof (0, $3lIcL.TextSelection) && selection.$cursor || selection instanceof (0, $6BNUN.GapCursorSelection)) nodePositions.push(from);
    else // nodesBetween doesn't return leaf nodes that are outside of from and to
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        // isLeaf is false for empty codeBlock so adding additional check for childCount
        if (!node.isLeaf && !(node.type === codeBlock && node.childCount === 0)) return true;
        nodePositions.push(pos);
    });
    // use those positions to get the closest parent list nodes
    nodePositions.reduce((acc, pos)=>{
        const closestParentListNode = (0, $BmspC.findParentNodeClosestToPos)(tr.doc.resolve(pos), (0, $fCXIH.isListNode));
        if (!closestParentListNode) return acc;
        // don't add duplicates if the parent has already been added into the array
        const existingParent = acc.find((node)=>{
            return node.pos === closestParentListNode.pos && node.start === closestParentListNode.start && node.depth === closestParentListNode.depth;
        });
        if (!existingParent) acc.push(closestParentListNode);
        return acc;
    }, []).forEach((item)=>{
        tr.setNodeMarkup(item.pos, nextListNodeType);
    });
};
const $44daaa53c9e21854$var$convertAroundList = ({ tr: tr, nextListNodeType: nextListNodeType, nodeRange: nodeRange })=>{
    for(let i = nodeRange.endIndex - 1; i >= nodeRange.startIndex; i--){
        // @ts-ignore posAtIndex is a public API but has no type yet
        const position = nodeRange.$from.posAtIndex(i, nodeRange.depth);
        const resolvedPos = tr.doc.resolve(position + 1);
        const range = resolvedPos.blockRange(resolvedPos);
        if (!range) return;
        const wrappings = (0, $lzEKq.findWrapping)(range, nextListNodeType);
        if (!range || !wrappings) return;
        tr.wrap(range, wrappings);
    }
};

});
parcelRegister("49G1L", function(module, exports) {
$parcel$export(module.exports, "JoinDirection", () => $eb0f57dbfb811008$export$5e0de40a18047fef);
$parcel$export(module.exports, "joinSiblingLists", () => $eb0f57dbfb811008$export$e400d0e3efb40bf0);

var $3xw6l = parcelRequire("3xw6l");

var $fCXIH = parcelRequire("fCXIH");

var $4gTd9 = parcelRequire("4gTd9");
function $eb0f57dbfb811008$export$b1e4478495976768(node) {
    const { bulletList: bulletList } = node.type.schema.nodes;
    if (!bulletList) return false;
    const listFragment = (0, $3xw6l.Fragment).from(bulletList.createAndFill());
    return !(0, $fCXIH.isListItemNode)(node) && node.type.validContent(listFragment);
}
var $eb0f57dbfb811008$export$5e0de40a18047fef = /*#__PURE__*/ function(JoinDirection) {
    JoinDirection[JoinDirection["LEFT"] = 1] = "LEFT";
    JoinDirection[JoinDirection["RIGHT"] = -1] = "RIGHT";
    return JoinDirection;
}({});
const $eb0f57dbfb811008$export$e400d0e3efb40bf0 = ({ tr: tr, direction: direction, forceListType: forceListType })=>{
    const result = {
        orderedList: 0,
        bulletList: 0
    };
    const { doc: doc, selection: { $from: $from, $to: $to }, selection: selection } = tr;
    const range = $from.blockRange($to, $eb0f57dbfb811008$export$b1e4478495976768);
    if (!range) return result;
    const rootListNode = doc.nodeAt(range.start);
    const from = (0, $fCXIH.isListNode)(rootListNode) ? range.start : 0;
    const to = (0, $fCXIH.isListNode)(rootListNode) ? range.end : tr.doc.content.size;
    const joins = [];
    doc.nodesBetween(from, to, (node, pos, parent)=>{
        const resolvedPos = doc.resolve(pos);
        const { nodeBefore: nodeBefore, nodeAfter: nodeAfter } = resolvedPos;
        if (!nodeBefore || !nodeAfter || !(0, $fCXIH.isListNode)(nodeBefore) || !(0, $fCXIH.isListNode)(nodeAfter)) return;
        const isNestedList = (0, $fCXIH.isListItemNode)(parent);
        if (!isNestedList && nodeBefore.type !== nodeAfter.type && !forceListType) return;
        const index = resolvedPos.index();
        const positionPreviousNode = resolvedPos.posAtIndex(index - 1);
        const positionCurrentNode = resolvedPos.posAtIndex(index);
        // If the previous node is part of the selection, OR
        // If the previous node is not part of the selection and the previous node has the same list type that we’re converting to
        const joinBefore = positionPreviousNode >= from || nodeBefore.type === forceListType;
        if (forceListType) {
            if (joinBefore) tr.setNodeMarkup(positionPreviousNode, forceListType);
            tr.setNodeMarkup(positionCurrentNode, forceListType);
        }
        if (isNestedList && nodeBefore.type !== nodeAfter.type) {
            const nodeType = direction === -1 ? nodeAfter.type : nodeBefore.type;
            tr.setNodeMarkup(positionPreviousNode, nodeType);
        }
        if (joinBefore) joins.push(pos);
    });
    if (selection.empty && rootListNode && (0, $fCXIH.isListNode)(rootListNode)) {
        const resolvedPos = doc.resolve(range.start + rootListNode.nodeSize);
        const { nodeBefore: nodeBefore, nodeAfter: nodeAfter } = resolvedPos;
        if (nodeBefore && nodeAfter && (0, $fCXIH.isListNode)(nodeBefore) && (0, $fCXIH.isListNode)(nodeAfter) && nodeAfter.type === nodeBefore.type) joins.push(resolvedPos.pos);
    }
    for(let i = joins.length - 1; i >= 0; i--){
        const listNode = tr.doc.nodeAt(joins[i]);
        const listName = listNode?.type.name;
        if (listName && (listName === 'orderedList' || listName === 'bulletList')) {
            const amount = result[listName] || 0;
            result[listName] = amount + 1;
        }
        tr.join(joins[i]);
    }
    return result;
};
/**
 * Returns the prosemirror position for the child at give index inside the parent node.
 * Example: Considering doc structure as below using the function
 *          passing parent resolved position for li and index 2
 *          would return starting position of taskList
 * DOC STRUCTURE:
 * ol()
 *  ( li(
 *      p('text'),
 *      ul(content),
 *      taskList(),
 *    )
 *  )
 * @param $from Starting resolved position for the parent node of the child we are looking for.
 * @param index Index of the child node we want the position for.
 * @returns
 */ const $eb0f57dbfb811008$var$findStartPositionOfChildWithIndex = ($from, index)=>{
    const parent = $from.node();
    let currentPos = $from.pos + 1;
    for(let i = 0; i < index; i++)currentPos += parent.child(i).nodeSize;
    return currentPos;
};
const $eb0f57dbfb811008$var$findGrandParentResolvedPos = (tr, $from)=>{
    return $from.depth > 2 ? tr.doc.resolve($from.start($from.depth - 2)) : null;
};
const $eb0f57dbfb811008$var$findNestedTaskListsIndexAtSameLevel = (tr, $from)=>{
    /*
    Currently our cursor would be inside a pargraph of a list of type numbered/bullet list,
    we need to find the grandparent of the cursor which is the list at same level of taskList.
    We can get the root list item(inside which various lists are being resolved before outdenting) by going one depth above that list.
  */ const nestedListResolvedPos = $eb0f57dbfb811008$var$findGrandParentResolvedPos(tr, $from);
    const rootListItem = nestedListResolvedPos?.node(nestedListResolvedPos.depth - 1);
    const nestedTaskListsIndexes = [];
    const rootListItemChildCount = rootListItem?.childCount || 0;
    // first child of list item is always paragraph (i = 0) so we start from 1
    for(let i = 1; i < rootListItemChildCount; i++)if (rootListItem?.child(i).type.name === 'taskList') nestedTaskListsIndexes.push(i);
    return nestedTaskListsIndexes;
};
const $eb0f57dbfb811008$export$d676b534bbdcdb6d = (tr)=>{
    const { $from: $from } = tr.selection;
    const nestedTaskListIndexes = $eb0f57dbfb811008$var$findNestedTaskListsIndexAtSameLevel(tr, $from);
    if (nestedTaskListIndexes.length === 0) return;
    const nestedListResolvedPos = $eb0f57dbfb811008$var$findGrandParentResolvedPos(tr, $from);
    const rootListItemStart = nestedListResolvedPos?.start(nestedListResolvedPos.depth - 1);
    /* We need not wrap the taskList present above other lists since it doesn't affect the flow. */ const nestedTaskListIndexesToWrap = nestedTaskListIndexes.filter((index)=>index > 1);
    /*
    Wraps the taskLists present at each index mentioned in the nestedTaskListIndexesToWrap to the list above it.
    After each wrap the indexes changes since two lists are being merged into one,
    so we keep track of it and use it to access actual calculated taskList indexes.
  */ if (rootListItemStart) {
        let taskListsFixedNested = 0;
        nestedTaskListIndexesToWrap.forEach((index)=>{
            (0, $4gTd9.wrapTaskListIntoListAbove)(tr, $eb0f57dbfb811008$var$findStartPositionOfChildWithIndex(tr.doc.resolve(rootListItemStart), index - taskListsFixedNested), $eb0f57dbfb811008$var$findStartPositionOfChildWithIndex(tr.doc.resolve(rootListItemStart), index - 1 - taskListsFixedNested));
            taskListsFixedNested++;
        });
    }
    return;
};

});

parcelRegister("jVesZ", function(module, exports) {
$parcel$export(module.exports, "findFirstParentListNode", () => $e094df98cd5f350c$export$cd0bf0d386a8d5a7);
$parcel$export(module.exports, "findFirstParentListItemNode", () => $e094df98cd5f350c$export$112d93610a31ac47);
$parcel$export(module.exports, "findRootParentListNode", () => $e094df98cd5f350c$export$cd55a6653375f672);

var $fCXIH = parcelRequire("fCXIH");

var $BmspC = parcelRequire("BmspC");
function $e094df98cd5f350c$export$cd0bf0d386a8d5a7($pos) {
    const currentNode = $pos.doc.nodeAt($pos.pos);
    let listNodePosition = null;
    if ((0, $fCXIH.isListNode)(currentNode)) listNodePosition = $pos.pos;
    else {
        const result = (0, $BmspC.findParentNodeClosestToPos)($pos, (0, $fCXIH.isListNode));
        listNodePosition = result && result.pos;
    }
    if (listNodePosition == null) return null;
    const node = $pos.doc.nodeAt(listNodePosition);
    if (!node) return null;
    return {
        node: node,
        pos: listNodePosition
    };
}
function $e094df98cd5f350c$export$112d93610a31ac47($pos) {
    const currentNode = $pos.doc.nodeAt($pos.pos);
    const listItemNodePosition = (0, $fCXIH.isListItemNode)(currentNode) ? $pos : (0, $BmspC.findParentNodeClosestToPos)($pos, (0, $fCXIH.isListItemNode));
    if (!listItemNodePosition || listItemNodePosition.pos === null) return null;
    const node = $pos.doc.nodeAt(listItemNodePosition.pos);
    if (!node) return null;
    return {
        node: node,
        pos: listItemNodePosition.pos
    };
}
const $e094df98cd5f350c$export$cd55a6653375f672 = ($pos)=>{
    const { doc: doc } = $pos;
    if ($pos.pos + 1 > doc.content.size) return null;
    if ($pos.depth === 0) return doc.resolve($pos.pos + 1);
    const currentNode = doc.nodeAt($pos.pos);
    const beforePosition = $pos.before();
    const nodeBefore = doc.nodeAt(beforePosition);
    if ((0, $fCXIH.isListNode)(currentNode) && !(0, $fCXIH.isListItemNode)(nodeBefore)) return doc.resolve($pos.pos + 1);
    const parentList = (0, $BmspC.findParentNodeClosestToPos)($pos, (0, $fCXIH.isListNode));
    if (!parentList) return null;
    const listNodePosition = doc.resolve(parentList.pos);
    return $e094df98cd5f350c$export$cd55a6653375f672(listNodePosition);
};

});


parcelRegister("llTxy", function(module, exports) {
$parcel$export(module.exports, "wrapInListAndJoin", () => $17aafe0e07b2d033$export$dc4f1f9730c3e037);

var $6BNUN = parcelRequire("6BNUN");

var $64w3F = parcelRequire("64w3F");

var $3xw6l = parcelRequire("3xw6l");

var $lzEKq = parcelRequire("lzEKq");

var $510Zv = parcelRequire("510Zv");
function $17aafe0e07b2d033$export$dc4f1f9730c3e037(nodeType, tr) {
    $17aafe0e07b2d033$export$a8aef45c6262afee(nodeType)(tr);
    (0, $64w3F.autoJoinTr)(tr, (before, after)=>before.type === after.type && before.type === nodeType);
}
function $17aafe0e07b2d033$export$a8aef45c6262afee(listType, attrs) {
    return function(tr) {
        const { $from: $from, $to: $to } = tr.selection;
        let range;
        if (tr.selection instanceof (0, $6BNUN.GapCursorSelection) && $from.nodeAfter && (0, $510Zv.isWrappingPossible)(listType, tr.selection)) {
            const nodeSize = $from.nodeAfter.nodeSize || 1;
            range = $from.blockRange($from.doc.resolve($from.pos + nodeSize));
        } else range = $from.blockRange($to);
        let doJoin = false;
        let outerRange = range;
        if (!range) return false;
        // This is at the top of an existing list item
        if (range.depth >= 2 && // @ts-ignore - missing type for compatibleContent
        $from.node(range.depth - 1).type.compatibleContent(listType) && range.startIndex === 0) {
            // Don't do anything if this is the top of the list
            if ($from.index(range.depth - 1) === 0) return false;
            const $insert = tr.doc.resolve(range.start - 2);
            outerRange = new (0, $3xw6l.NodeRange)($insert, $insert, range.depth);
            if (range.endIndex < range.parent.childCount) range = new (0, $3xw6l.NodeRange)($from, tr.doc.resolve($to.end(range.depth)), range.depth);
            doJoin = true;
        }
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const wrap = (0, $lzEKq.findWrapping)(outerRange, listType, attrs, range);
        if (!wrap) return false;
        tr = $17aafe0e07b2d033$var$doWrapInList(tr, range, wrap, doJoin, listType);
        return true;
    };
}
/**
 * Internal function used by wrapInList
 *
 * Adapted from https://github.com/ProseMirror/prosemirror-schema-list/blob/master/src/schema-list.js#L91-L112
 */ function $17aafe0e07b2d033$var$doWrapInList(tr, range, wrappers, joinBefore, listType) {
    let content = (0, $3xw6l.Fragment).empty;
    for(let i = wrappers.length - 1; i >= 0; i--)content = (0, $3xw6l.Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
    tr.step(new (0, $lzEKq.ReplaceAroundStep)(range.start - (joinBefore ? 2 : 0), range.end, range.start, range.end, new (0, $3xw6l.Slice)(content, 0, 0), wrappers.length, true));
    let found = 0;
    for(let i = 0; i < wrappers.length; i++)if (wrappers[i].type === listType) found = i + 1;
    const splitDepth = wrappers.length - found;
    let splitPos = range.start + wrappers.length - (joinBefore ? 2 : 0);
    const parent = range.parent;
    for(let i = range.startIndex, e = range.endIndex, first = true; i < e; i++, first = false){
        if (!first && (0, $lzEKq.canSplit)(tr.doc, splitPos, splitDepth)) {
            tr.split(splitPos, splitDepth);
            splitPos += 2 * splitDepth;
        }
        splitPos += parent.child(i).nodeSize;
    }
    return tr;
}

});
parcelRegister("510Zv", function(module, exports) {
$parcel$export(module.exports, "isPosInsideParagraph", () => $ce386257bc67f406$export$27bb641e25fad24d);
$parcel$export(module.exports, "isPosInsideList", () => $ce386257bc67f406$export$4639440f68939b8a);
$parcel$export(module.exports, "isWrappingPossible", () => $ce386257bc67f406$export$af251811cd857645);
$parcel$export(module.exports, "isInsideListItem", () => $ce386257bc67f406$export$fd64e4ef922c42f3);
$parcel$export(module.exports, "isInsideTableCell", () => $ce386257bc67f406$export$cb2b92f281f91c40);
$parcel$export(module.exports, "canJoinToPreviousListItem", () => $ce386257bc67f406$export$6ec51e240036c4ab);
$parcel$export(module.exports, "selectionContainsList", () => $ce386257bc67f406$export$f0dda2b070101c76);
$parcel$export(module.exports, "createListNodeRange", () => $ce386257bc67f406$export$44fa515643dd6860);

var $6BNUN = parcelRequire("6BNUN");

var $fCXIH = parcelRequire("fCXIH");

var $lzEKq = parcelRequire("lzEKq");

var $BmspC = parcelRequire("BmspC");
const $ce386257bc67f406$export$27bb641e25fad24d = ($pos)=>{
    return $pos.parent.type.name === 'paragraph';
};
const $ce386257bc67f406$export$4639440f68939b8a = ($pos)=>{
    const posGrandParent = $pos.node(-1);
    return (0, $fCXIH.isListItemNode)($pos.parent) || (0, $fCXIH.isListNode)($pos.parent) || (0, $fCXIH.isListItemNode)(posGrandParent);
};
const $ce386257bc67f406$export$af251811cd857645 = (nodeType, selection)=>{
    const { $from: $from, $to: $to } = selection;
    let range;
    if (selection instanceof (0, $6BNUN.GapCursorSelection) && $from.nodeAfter) {
        const nodeSize = $from.nodeAfter.nodeSize || 1;
        range = $from.blockRange($from.doc.resolve($from.pos + nodeSize));
    } else range = $from.blockRange($to);
    if (!range) return false;
    const wrap = (0, $lzEKq.findWrapping)(range, nodeType);
    if (!wrap) return false;
    return true;
};
const $ce386257bc67f406$export$fd64e4ef922c42f3 = (tr)=>{
    const { parent: parent } = tr.selection.$from;
    const { listItem: listItem } = tr.doc.type.schema.nodes;
    if (tr.selection instanceof (0, $6BNUN.GapCursorSelection)) return (0, $fCXIH.isListItemNode)(parent);
    return (0, $BmspC.hasParentNodeOfType)(listItem)(tr.selection) && (0, $fCXIH.isParagraphNode)(parent);
};
const $ce386257bc67f406$export$cb2b92f281f91c40 = (tr)=>{
    const { tableCell: tableCell, tableHeader: tableHeader } = tr.doc.type.schema.nodes;
    return !!(0, $BmspC.findParentNodeOfType)([
        tableCell,
        tableHeader
    ])(tr.selection);
};
const $ce386257bc67f406$export$6ec51e240036c4ab = (tr)=>{
    const { $from: $from } = tr.selection;
    const $before = tr.doc.resolve($from.pos - 1);
    let nodeBefore = $before ? $before.nodeBefore : null;
    if (tr.selection instanceof (0, $6BNUN.GapCursorSelection)) nodeBefore = $from.nodeBefore;
    return (0, $fCXIH.isListNode)(nodeBefore);
};
const $ce386257bc67f406$export$f0dda2b070101c76 = (tr)=>{
    const { selection: { from: from, to: to } } = tr;
    let foundListNode = null;
    tr.doc.nodesBetween(from, to, (node)=>{
        if ((0, $fCXIH.isListNode)(node)) foundListNode = node;
        if (foundListNode) return false;
        return true;
    });
    return foundListNode;
};
const $ce386257bc67f406$export$44fa515643dd6860 = ({ selection: selection })=>{
    const { $from: $from, $to: $to } = selection;
    const range = $from.blockRange($to, (0, $fCXIH.isListNode));
    if (!range) return null;
    return range;
};

});


parcelRegister("5z2mt", function(module, exports) {
$parcel$export(module.exports, "liftFollowingList", () => $c4080ce58f2bb214$export$4ed538bc5a7d756f);
$parcel$export(module.exports, "liftNodeSelectionList", () => $c4080ce58f2bb214$export$2b630c4fa336fee7);
$parcel$export(module.exports, "liftTextSelectionList", () => $c4080ce58f2bb214$export$a88bd9b6e3aac8d6);

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $lzEKq = parcelRequire("lzEKq");

var $bXXSX = parcelRequire("bXXSX");
function $c4080ce58f2bb214$var$liftListItem(selection, tr) {
    const { $from: $from, $to: $to } = selection;
    const nodeType = tr.doc.type.schema.nodes.listItem;
    let range = $from.blockRange($to, (node)=>!!node.childCount && !!node.firstChild && node.firstChild.type === nodeType);
    if (!range || range.depth < 2 || $from.node(range.depth - 1).type !== nodeType) return tr;
    const end = range.end;
    const endOfList = $to.end(range.depth);
    if (end < endOfList) {
        tr.step(new (0, $lzEKq.ReplaceAroundStep)(end - 1, endOfList, end, endOfList, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(nodeType.create(undefined, range.parent.copy())), 1, 0), 1, true));
        range = new (0, $3xw6l.NodeRange)(tr.doc.resolve($from.pos), tr.doc.resolve(endOfList), range.depth);
    }
    return tr.lift(range, (0, $lzEKq.liftTarget)(range)).scrollIntoView();
}
function $c4080ce58f2bb214$export$4ed538bc5a7d756f(from, to, rootListDepth, tr) {
    const { listItem: listItem } = tr.doc.type.schema.nodes;
    let lifted = false;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (!lifted && node.type === listItem && pos > from) {
            lifted = true;
            let listDepth = rootListDepth + 3;
            while(listDepth > rootListDepth + 2){
                const start = tr.doc.resolve(tr.mapping.map(pos));
                listDepth = start.depth;
                const end = tr.doc.resolve(tr.mapping.map(pos + node.textContent.length));
                const sel = new (0, $3lIcL.TextSelection)(start, end);
                tr = $c4080ce58f2bb214$var$liftListItem(sel, tr);
            }
        }
    });
    return tr;
}
function $c4080ce58f2bb214$export$2b630c4fa336fee7(selection, tr) {
    const { from: from } = selection;
    const { listItem: listItem } = tr.doc.type.schema.nodes;
    const mappedPosition = tr.mapping.map(from);
    const nodeAtPos = tr.doc.nodeAt(mappedPosition);
    const start = tr.doc.resolve(mappedPosition);
    if (start?.parent.type !== listItem) return tr;
    const end = tr.doc.resolve(mappedPosition + (nodeAtPos?.nodeSize || 1));
    const range = start.blockRange(end);
    if (range) {
        const liftTarget = (0, $bXXSX.getListLiftTarget)(start);
        tr.lift(range, liftTarget);
    }
    return tr;
}
function $c4080ce58f2bb214$export$a88bd9b6e3aac8d6(selection, tr) {
    const { from: from, to: to } = selection;
    const { paragraph: paragraph } = tr.doc.type.schema.nodes;
    const listCol = [];
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (node.type === paragraph) listCol.push({
            node: node,
            pos: pos
        });
    });
    for(let i = listCol.length - 1; i >= 0; i--){
        const paragraph = listCol[i];
        const start = tr.doc.resolve(tr.mapping.map(paragraph.pos));
        if (start.depth > 0) {
            let end;
            if (paragraph.node.textContent && paragraph.node.textContent.length > 0) end = tr.doc.resolve(tr.mapping.map(paragraph.pos + paragraph.node.textContent.length));
            else end = tr.doc.resolve(tr.mapping.map(paragraph.pos + 1));
            const range = start.blockRange(end);
            if (range) tr.lift(range, (0, $bXXSX.getListLiftTarget)(start));
        }
    }
    return tr;
}

});
parcelRegister("bXXSX", function(module, exports) {
$parcel$export(module.exports, "getListLiftTarget", () => $ea0b4d5a00bbcb2a$export$624f45cf4fef090e);

var $fCXIH = parcelRequire("fCXIH");
const $ea0b4d5a00bbcb2a$export$624f45cf4fef090e = (resPos)=>{
    let target = resPos.depth;
    for(let i = resPos.depth; i > 0; i--){
        const node = resPos.node(i);
        if ((0, $fCXIH.isListNode)(node)) target = i;
        if (!(0, $fCXIH.isListItemNode)(node) && !(0, $fCXIH.isListNode)(node)) break;
    }
    return target - 1;
};

});


parcelRegister("amcSn", function(module, exports) {
$parcel$export(module.exports, "sanitiseMarksInSelection", () => $8f22db7788a8ebe9$export$bec007f49d03125c);
const $8f22db7788a8ebe9$export$bec007f49d03125c = (tr, newParentType)=>{
    const { from: from, to: to } = tr.selection;
    const nodesSanitized = [];
    tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (node.isText) return false;
        // Skip expands and layouts if they are outside selection
        // but continue to iterate over their children.
        if ([
            'expand',
            'layoutSection'
        ].includes(node.type.name) && (pos < from || pos > to)) return true;
        node.marks.forEach((mark)=>{
            if (!parent?.type.allowsMarkType(mark.type) || newParentType && !newParentType.allowsMarkType(mark.type)) {
                const filteredMarks = node.marks.filter((m)=>m.type !== mark.type);
                const position = pos > 0 ? pos : 0;
                const marksRemoved = node.marks.filter((m)=>m.type === mark.type);
                nodesSanitized.push({
                    node: node,
                    marksRemoved: marksRemoved
                });
                tr.setNodeMarkup(position, undefined, node.attrs, filteredMarks);
            }
        });
    });
    return nodesSanitized;
};

});

parcelRegister("7BSUw", function(module, exports) {
$parcel$export(module.exports, "isFirstChildOfParent", () => $1d25dbc9e9d84354$export$1d357fa6aecde5b8);

var $6BNUN = parcelRequire("6BNUN");
const $1d25dbc9e9d84354$export$1d357fa6aecde5b8 = (state)=>{
    const { $from: $from } = state.selection;
    return $from.depth > 1 ? state.selection instanceof (0, $6BNUN.GapCursorSelection) && $from.parentOffset === 0 || $from.index($from.depth - 1) === 0 : true;
};

});

parcelRegister("75YHg", function(module, exports) {
$parcel$export(module.exports, "joinListItemForward", () => $08eb5bc126bb275d$export$6851baf5987dd2cb);

var $bMFKb = parcelRequire("bMFKb");
var $eZyx0 = parcelRequire("eZyx0");

var $HOLTj = parcelRequire("HOLTj");

var $BmspC = parcelRequire("BmspC");

var $hfUzq = parcelRequire("hfUzq");
const $08eb5bc126bb275d$export$6851baf5987dd2cb = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { tr: tr, selection: { $head: $head } } = state;
        const walkNode = (0, $HOLTj.walkNextNode)($head);
        if (!(0, $HOLTj.isEmptySelectionAtEnd)(state)) return false;
        const scenarios = (0, $hfUzq.calcJoinListScenario)(walkNode, $head);
        if (!scenarios) return false;
        const [scenario, action] = scenarios;
        const result = action({
            tr: tr,
            $next: walkNode.$pos,
            $head: $head
        });
        if (!result) return false;
        const { bulletList: bulletList, orderedList: orderedList } = state.schema.nodes;
        const listParent = (0, $BmspC.findParentNodeOfType)([
            bulletList,
            orderedList
        ])(tr.selection);
        let actionSubjectId = (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET;
        if (listParent && listParent.node.type === orderedList) actionSubjectId = (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $bMFKb.ACTION).LIST_ITEM_JOINED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).LIST,
            actionSubjectId: actionSubjectId,
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
            attributes: {
                inputMethod: (0, $bMFKb.INPUT_METHOD).KEYBOARD,
                direction: (0, $eZyx0.DELETE_DIRECTION).FORWARD,
                scenario: scenario
            }
        })(tr);
        if (dispatch) dispatch(tr);
        return true;
    };

});
parcelRegister("hfUzq", function(module, exports) {
$parcel$export(module.exports, "calcJoinListScenario", () => $bde76a8889bc91c8$export$c60ae92c9826748a);

var $eZyx0 = parcelRequire("eZyx0");

var $fCXIH = parcelRequire("fCXIH");

var $510Zv = parcelRequire("510Zv");

var $gfgCR = parcelRequire("gfgCR");

var $lcdT6 = parcelRequire("lcdT6");

var $hpmd7 = parcelRequire("hpmd7");

var $1kUmU = parcelRequire("1kUmU");

var $g3h0e = parcelRequire("g3h0e");
const $bde76a8889bc91c8$export$c60ae92c9826748a = (walkNode, $head)=>{
    const { $pos: $next, foundNode: nextFoundNode } = walkNode;
    const headParent = $head.parent;
    const headGrandParent = $head.node(-1);
    const headInList = (0, $510Zv.isPosInsideList)($head);
    const headInParagraph = (0, $510Zv.isPosInsideParagraph)($head);
    const headInLastNonListChild = headGrandParent && headGrandParent.lastChild && (headGrandParent.lastChild === headParent || headGrandParent.childCount > 1 && headGrandParent.child(headGrandParent.childCount - 2) === headParent && //find the second last child if a list item may be the last child
    (0, $fCXIH.isListNode)(headGrandParent.lastChild));
    const nextInList = (0, $510Zv.isPosInsideList)($next);
    const nextInParagraph = (0, $510Zv.isPosInsideParagraph)($next);
    if (!headInList && headInParagraph && nextInList) return [
        (0, $eZyx0.LIST_TEXT_SCENARIOS).JOIN_LIST_ITEM_WITH_PARAGRAPH,
        (0, $gfgCR.joinListItemWithParagraph)
    ];
    if (!nextFoundNode || !headInList || !headInParagraph || !headInLastNonListChild) return false;
    if (!nextInList && nextInParagraph) return [
        (0, $eZyx0.LIST_TEXT_SCENARIOS).JOIN_PARAGRAPH_WITH_LIST,
        (0, $1kUmU.joinParagrapWithList)
    ];
    if (!nextInList) return false;
    const nextNodeAfter = $next.nodeAfter;
    const nextGrandParent = $next.node(-1);
    const headGreatGrandParent = $head.node(-2);
    const nextInListItem = (0, $fCXIH.isListItemNode)($next.parent);
    const nextNodeAfterListItem = (0, $fCXIH.isListItemNode)(nextNodeAfter);
    const nextListItemHasFirstChildParagraph = nextNodeAfter && //Redundant check but the linter complains otherwise
    nextNodeAfterListItem && (0, $fCXIH.isParagraphNode)(nextNodeAfter.firstChild);
    if (!nextInListItem && nextListItemHasFirstChildParagraph) return [
        (0, $eZyx0.LIST_TEXT_SCENARIOS).JOIN_DESCENDANT_TO_PARENT,
        (0, $hpmd7.joinNestedListWithParentListItem)
    ];
    if (!nextInListItem) return false;
    const nextParentSiblingOfHeadParent = nextGrandParent && nextGrandParent === headGreatGrandParent;
    const nextNodeAfterIsParagraph = (0, $fCXIH.isParagraphNode)(nextNodeAfter);
    if (!nextNodeAfterIsParagraph) return false;
    if (nextParentSiblingOfHeadParent) return [
        (0, $eZyx0.LIST_TEXT_SCENARIOS).JOIN_SIBLINGS,
        (0, $g3h0e.joinSiblingListItems)
    ];
    return [
        (0, $eZyx0.LIST_TEXT_SCENARIOS).JOIN_PARENT_SIBLING_TO_PARENT_CHILD,
        (0, $lcdT6.joinListItemWithParentNestedList)
    ];
};

});
parcelRegister("gfgCR", function(module, exports) {
$parcel$export(module.exports, "joinListItemWithParagraph", () => $85acec414952a5c0$export$fc9859705a1e8274);

var $HOLTj = parcelRequire("HOLTj");
var $fCXIH = parcelRequire("fCXIH");

var $3xw6l = parcelRequire("3xw6l");
const $85acec414952a5c0$export$fc9859705a1e8274 = ({ tr: tr, $next: $next, $head: $head })=>{
    // For empty paragraphs before a list
    if ($head.parent.content.size < 1) {
        (0, $HOLTj.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve($head.pos), [], [
            [
                $head.pos - 1,
                $head.pos
            ]
        ]);
        return true;
    }
    const paragraphPosition = $head.pos;
    const list = tr.doc.nodeAt($next.pos - 1);
    const firstListItem = tr.doc.nodeAt($next.pos);
    if (!list || !firstListItem) return false;
    const firstChildNodeOfFirstListItem = firstListItem.firstChild;
    if (!firstChildNodeOfFirstListItem) return false;
    const lastChildOfFirstListItem = firstListItem.lastChild;
    const firstGrandchildOfFirstListItem = firstChildNodeOfFirstListItem.firstChild;
    const firstListItemHasOneChildWithNoNestedLists = $85acec414952a5c0$var$hasSingleChild(firstListItem) && firstChildNodeOfFirstListItem.childCount < 2 && $next.nodeAfter;
    const firstListItemContainsParagraphAndNestedList = !$85acec414952a5c0$var$hasSingleChild(firstListItem) && lastChildOfFirstListItem && (0, $fCXIH.isListNode)(lastChildOfFirstListItem);
    const insertions = [];
    const deletions = [];
    // For lists that only have one list item with no children - need to remove remaining list
    if ($85acec414952a5c0$var$hasSingleChild(list) && $85acec414952a5c0$var$hasSingleChild(firstListItem) && $next.nodeAfter) deletions.push([
        tr.mapping.map($next.pos - 1),
        tr.mapping.map($next.pos + $next.nodeAfter.nodeSize + 1)
    ]);
    // For first list items that have a paragraph and a list
    if (firstListItemContainsParagraphAndNestedList) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const firstListItemNestedList = (0, $3xw6l.Fragment).from(lastChildOfFirstListItem.content);
        insertions.push([
            firstListItemNestedList,
            tr.mapping.map($next.pos)
        ]);
    }
    // For first list item has one child & no nested lists OR first list items that have a paragraph and a list
    if (firstListItemHasOneChildWithNoNestedLists || firstListItemContainsParagraphAndNestedList) {
        deletions.push([
            tr.mapping.map($next.pos),
            tr.mapping.map($next.pos + firstListItem.nodeSize - 1)
        ]);
        const firstListItemText = (0, $3xw6l.Fragment).from(firstChildNodeOfFirstListItem.content);
        insertions.push([
            firstListItemText,
            paragraphPosition
        ]);
        (0, $HOLTj.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve($head.pos), insertions, deletions);
        return true;
    }
    // For any first list items that have multiple children (eg. multiple paragraphs)
    if (firstListItem.childCount > 1) {
        insertions.push([
            (0, $3xw6l.Fragment).from(firstChildNodeOfFirstListItem.content),
            paragraphPosition
        ]);
        deletions.push([
            tr.mapping.map($next.pos + 1),
            tr.mapping.map($next.pos + firstChildNodeOfFirstListItem.nodeSize + 1)
        ]);
        (0, $HOLTj.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve($head.pos), insertions, deletions);
        return true;
    }
    // For any remaining first list items that have a single child (eg. single paragraph, multiple lines of text)
    if (firstGrandchildOfFirstListItem && firstGrandchildOfFirstListItem.type.name === 'hardBreak') {
        const nodeSizeOfGrandchild = firstGrandchildOfFirstListItem ? firstGrandchildOfFirstListItem.nodeSize : 0;
        deletions.push([
            tr.mapping.map($next.pos + 2),
            tr.mapping.map($next.pos + 2 + nodeSizeOfGrandchild)
        ]);
    } else {
        insertions.push([
            (0, $3xw6l.Fragment).from(firstChildNodeOfFirstListItem.content),
            paragraphPosition
        ]);
        const nodeSizeOfFirstChild = firstChildNodeOfFirstListItem.nodeSize;
        deletions.push([
            tr.mapping.map($next.pos),
            tr.mapping.map($next.pos + 2 + nodeSizeOfFirstChild)
        ]);
    }
    (0, $HOLTj.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve($head.pos), insertions, deletions);
    return true;
};
const $85acec414952a5c0$var$hasSingleChild = (node)=>{
    return node.childCount === 1;
};

});

parcelRegister("lcdT6", function(module, exports) {
$parcel$export(module.exports, "joinListItemWithParentNestedList", () => $5a2668eec5a47599$export$2d042119f7337416);

var $HOLTj = parcelRequire("HOLTj");
var $fCXIH = parcelRequire("fCXIH");
const $5a2668eec5a47599$export$2d042119f7337416 = ({ tr: tr, $next: $next, $head: $head })=>{
    /* CASE 4
	 * Initial Structure:
	 *
	 * List A {
	 *   ListItem B {
	 *     Paragraph C { text1 }
	 *     ...Children D
	 *     List E {
	 *       ...
	 *         List F {       //May be multiple levels of lists
	 *           ...Children G
	 *           ListItem H {        //Last node of the block
	 *             ...Children I
	 *             Paragraph J { text2 |$head||textInsertPos| } |childrenMInsertPos|        //Cant have children since this ListItem is the last of the block
	 *           }
	 *         }
	 *       ...
	 *     |childrenOInsertPos| }
	 *   }
	 *   ListItem K { |$next|
	 *      Paragraph L { text3 }
	 *      ...Children M
	 *      List? N {
	 *       ...Children O
	 *      }
	 *   }
	 * }
	 *
	 * Converts to:
	 *
	 * List A {
	 *   ListItem B {
	 *     Paragraph C { text1 }
	 *     ...Children D
	 *     List E {
	 *       ...
	 *         List F {
	 *           ...Children G
	 *           ListItem H {
	 *             ...Children I
	 *             Paragraph J { text2text3 }
	 *             ...Children M
	 *           }
	 *         }
	 *       ...
	 *       ...Children O
	 *     }
	 *   }
	 * }
	 *
	 */ const listItemK = $next.parent; //List must have at least one child
    if (!listItemK.firstChild || !listItemK.lastChild) return false;
    const beforeListItemK = $next.before();
    const afterListItemB = $next.before();
    const afterListItemK = $next.after();
    const containsChildrenO = (0, $fCXIH.isListNode)(listItemK.lastChild);
    const textInsertPos = $head.pos;
    const childrenMInsertPos = $head.pos + 1;
    const childrenOInsertPos = afterListItemB - 2;
    const textContent = listItemK.firstChild.content;
    const childrenMContent = containsChildrenO ? listItemK.content.cut(listItemK.firstChild.nodeSize, listItemK.nodeSize - listItemK.lastChild.nodeSize - 2) : listItemK.content.cut(listItemK.firstChild.nodeSize);
    const childrenOContent = listItemK.lastChild.content;
    (0, $HOLTj.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve(textInsertPos), containsChildrenO ? [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenMContent,
            childrenMInsertPos
        ],
        [
            childrenOContent,
            childrenOInsertPos
        ]
    ] : [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenMContent,
            childrenMInsertPos
        ]
    ], [
        [
            beforeListItemK,
            afterListItemK
        ]
    ]);
    return true;
};

});

parcelRegister("hpmd7", function(module, exports) {
$parcel$export(module.exports, "joinNestedListWithParentListItem", () => $6410bf9d2330445d$export$a4a1ba570b242c2c);

var $HOLTj = parcelRequire("HOLTj");
var $fCXIH = parcelRequire("fCXIH");
const $6410bf9d2330445d$export$a4a1ba570b242c2c = ({ tr: tr, $next: $next, $head: $head })=>{
    /* CASE 3
	 * Initial Structure:
	 *
	 * List A {
	 *   ListItem B {
	 *     ...Children C
	 *     Paragraph D { text1 |$head||textInsertPos| } |childrenHInsertPos|
	 *     List E { |$next||childrenJInsertPos|
	 *       ListItem F {
	 *         Paragraph G { text2 }
	 *         ...Children H
	 *         List? I {
	 *           ...Children J
	 *         }
	 *       }
	 *       ...Children K
	 *     }
	 *   }
	 * }
	 *
	 * Converts to:
	 *
	 * List A {
	 *   ListItem B {
	 *     ...Children C
	 *     Paragraph D { text1text2 }
	 *     ...Children H
	 *     List E {
	 *       ...Children J
	 *       ...Children K
	 *     }
	 *   }
	 * }
	 *
	 */ const listE = $next.parent;
    const listItemF = $next.nodeAfter; //We know next is before a ListItem. ListItem must have at least one child
    if (!listItemF || !listItemF.lastChild) return false;
    const paragraphG = listItemF.firstChild; //ListItem must have at least one child
    if (!paragraphG) return false;
    const beforeListE = $next.before();
    const beforeListItemF = $next.pos;
    const afterParagraphD = $head.after();
    const afterListE = $next.after();
    const afterListItemF = tr.doc.resolve($next.pos + 1).after(); //List must always have at least one listItem
    const containsChildrenJ = (0, $fCXIH.isListNode)(listItemF.lastChild);
    const shouldRemoveListE = listE.childCount === 1 && !containsChildrenJ; //Assures no Children J and K
    const textInsertPos = $head.pos;
    const childrenHInsertPos = afterParagraphD;
    const childrenJInsertPos = $next.pos;
    const textContent = paragraphG.content;
    const childrenHContent = containsChildrenJ ? listItemF.content.cut(paragraphG.nodeSize, listItemF.nodeSize - listItemF.lastChild.nodeSize - 2) : listItemF.content.cut(paragraphG.nodeSize); //If Children J doesn't exist then Children H will include the last node
    const childrenJContent = listItemF.lastChild.content; //Will be invalid if there are no Children J but it will be unused
    (0, $HOLTj.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve(textInsertPos), containsChildrenJ ? [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenHContent,
            childrenHInsertPos
        ],
        [
            childrenJContent,
            childrenJInsertPos
        ]
    ] : [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenHContent,
            childrenHInsertPos
        ]
    ], [
        shouldRemoveListE ? [
            beforeListE,
            afterListE
        ] : [
            beforeListItemF,
            afterListItemF
        ]
    ]);
    return true;
};

});

parcelRegister("1kUmU", function(module, exports) {
$parcel$export(module.exports, "joinParagrapWithList", () => $8a151c34fc72cce3$export$676f199e6d2601c5);

var $HOLTj = parcelRequire("HOLTj");
const $8a151c34fc72cce3$export$676f199e6d2601c5 = ({ tr: tr, $next: $next, $head: $head })=>{
    /* CASE 1
	 * Initial Structure:
	 *
	 * List A {
	 *   ListItem B {
	 *     ...Children C
	 *     Paragraph D { text1 |$head||textInsertPos| }
	 *   }
	 * }
	 * Paragraph E { |$next| text 2 }
	 *
	 * Converts to:
	 *
	 * List A {
	 *   ListItem B {
	 *     ...Children C
	 *     Paragraph D { text1text2 }
	 *   }
	 * }
	 *
	 */ const paragraphE = $next.parent;
    const beforeParagraphE = $next.before();
    const afterParagraphE = $next.after();
    const textInsertPos = $head.pos;
    const textContent = paragraphE.content;
    (0, $HOLTj.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve(textInsertPos), [
        [
            textContent,
            textInsertPos
        ]
    ], [
        [
            beforeParagraphE,
            afterParagraphE
        ]
    ]);
    return true;
};

});

parcelRegister("g3h0e", function(module, exports) {
$parcel$export(module.exports, "joinSiblingListItems", () => $3bc5c6c52ef94be9$export$1a90e697acce0e2d);

var $HOLTj = parcelRequire("HOLTj");
const $3bc5c6c52ef94be9$export$1a90e697acce0e2d = ({ tr: tr, $next: $next, $head: $head })=>{
    /* CASE 2
	 * Initial Structure:
	 *
	 * List A {
	 *   ListItem B {
	 *     ...Children C
	 *     Paragraph D { text1 |$head||textInsertPos| }       //Cant have children since that would be Case 4
	 *   |childrenGInsertPos| }
	 *   ListItem E { |$next|
	 *     Paragraph F { text2 }
	 *     ...Children G
	 *   }
	 * }
	 *
	 * Converts to:
	 *
	 * List A {
	 *   ListItem B {
	 *     ...Children C
	 *     Paragraph C { text1text2 }
	 *     ...Children G
	 *   }
	 * }
	 *
	 */ const listItemE = $next.parent;
    const paragraphF = $next.nodeAfter; //ListItem must have at least one child
    if (!paragraphF) return false;
    const beforeListItemE = $next.before();
    const afterListItemE = $next.after();
    const endListItemB = $head.end(-1);
    const textInsertPos = $head.pos;
    const childrenGInsertPos = endListItemB;
    const textContent = paragraphF.content;
    const childrenGContent = listItemE.content.cut(paragraphF.nodeSize);
    (0, $HOLTj.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve(textInsertPos), [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenGContent,
            childrenGInsertPos
        ]
    ], [
        [
            beforeListItemE,
            afterListItemE
        ]
    ]);
    return true;
};

});



parcelRegister("g2Qv0", function(module, exports) {
$parcel$export(module.exports, "listBackspace", () => $a20c008ca505db1d$export$7d25b69a3ad4526e);

var $bMFKb = parcelRequire("bMFKb");
var $eZyx0 = parcelRequire("eZyx0");

var $HOLTj = parcelRequire("HOLTj");
var $fCXIH = parcelRequire("fCXIH");

var $BmspC = parcelRequire("BmspC");

var $510Zv = parcelRequire("510Zv");
//Cases below refer to the cases found in this document: https://product-fabric.atlassian.net/wiki/spaces/E/pages/1146954996/List+Backspace+and+Delete+Behaviour
//Case for two adjacent list items of the same indentation
const $a20c008ca505db1d$var$listBackspaceCase2 = (tr, dispatch, $prev, $head)=>{
    /* CASE 2
	 * Initial Structure:
	 *
	 * List A {
	 *   ListItem B {
	 *     ...Children C
	 *     Paragraph D { text1 |textInsertPos| }       //Cant have children since that would be Case 4
	 *   |$prev||childrenGInsertPos| }
	 *   ListItem E {
	 *     Paragraph F { |$head| text2 }
	 *     ...Children G
	 *   }
	 * }
	 *
	 * Converts to:
	 *
	 * List A {
	 *   ListItem B {
	 *     ...Children C
	 *     Paragraph C { text1text2 }
	 *     ...Children G
	 *   }
	 * }
	 *
	 */ const listItemE = $head.node(-1); //Head is inside listItem E so it must have a first and last child
    if (!listItemE.firstChild) return false;
    const beforeListItemE = $head.before(-1);
    const afterListItemE = $head.after(-1);
    const textInsertPos = $prev.pos - 1; //Paragraph D must be directly behind $prev otherwise it would be case 4
    const childrenGInsertPos = $prev.pos;
    const textContent = $head.parent.content;
    const childrenGContent = listItemE.content.cut(listItemE.firstChild.nodeSize);
    (0, $HOLTj.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve(textInsertPos), [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenGContent,
            childrenGInsertPos
        ]
    ], [
        [
            beforeListItemE,
            afterListItemE
        ]
    ]);
    if (dispatch) dispatch(tr);
    return true;
};
//Case for two adjacent list items with the first being of lower indentation
const $a20c008ca505db1d$var$listBackspaceCase3 = (tr, dispatch, $prev, $head)=>{
    /* CASE 3
	 * Initial Structure:
	 *
	 * List A {
	 *   ListItem B {
	 *     ...Children C
	 *     Paragraph D { text1 |$prev||textInsertPos| } |childrenHInsertPos|
	 *     List E { |childrenJInsertPos|
	 *       ListItem F {
	 *         Paragraph G { |$head| text2 }
	 *         ...Children H
	 *         List? I {
	 *           ...Children J
	 *         }
	 *       }
	 *       ...Children K
	 *     }
	 *   }
	 * }
	 *
	 * Converts to:
	 *
	 * List A {
	 *   ListItem B {
	 *     ...Children C
	 *     Paragraph D { text1text2 }
	 *     ...Children H
	 *     List E {
	 *       ...Children J
	 *       ...Children K
	 *     }
	 *   }
	 * }
	 *
	 */ const listE = $head.node(-2);
    const listItemF = $head.node(-1); //Head is inside listItem F so it must have a first and last child
    if (!listItemF.firstChild || !listItemF.lastChild) return false;
    const beforeListE = $head.before(-2);
    const beforeListItemF = $head.before(-1);
    const afterParagraphD = $prev.after();
    const afterListE = $head.after(-2);
    const afterListItemF = $head.after(-1);
    const startListE = $head.start(-2);
    const containsChildrenJ = (0, $fCXIH.isListNode)(listItemF.lastChild);
    const shouldRemoveListE = listE.childCount === 1 && !containsChildrenJ; //Assures no Children J and K
    const textInsertPos = $prev.pos;
    const childrenHInsertPos = afterParagraphD;
    const childrenJInsertPos = startListE;
    const textContent = $head.parent.content;
    const childrenHContent = containsChildrenJ ? listItemF.content.cut(listItemF.firstChild.nodeSize, listItemF.nodeSize - listItemF.lastChild.nodeSize - 2) : listItemF.content.cut(listItemF.firstChild.nodeSize); //If Children J doesn't exist then Children H will include the last node
    const childrenJContent = listItemF.lastChild.content; //Will be invalid if there are no Children J but it will be unused
    (0, $HOLTj.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve(textInsertPos), containsChildrenJ ? [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenHContent,
            childrenHInsertPos
        ],
        [
            childrenJContent,
            childrenJInsertPos
        ]
    ] : [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenHContent,
            childrenHInsertPos
        ]
    ], [
        shouldRemoveListE ? [
            beforeListE,
            afterListE
        ] : [
            beforeListItemF,
            afterListItemF
        ]
    ]);
    if (dispatch) dispatch(tr);
    return true;
};
//Case for two adjacent list items with the first being of greater indentation
const $a20c008ca505db1d$var$listBackspaceCase4 = (tr, dispatch, $prev, $head, $last)=>{
    /* CASE 4
	 * Initial Structure:
	 *
	 * List A {
	 *   ListItem B {
	 *     Paragraph C { text1 }
	 *     ...Children D
	 *     List E {
	 *       ...
	 *         List F {       //May be multiple levels of lists
	 *           ...Children G
	 *           ListItem H {        //Last node of the block
	 *             ...Children I
	 *             Paragraph J { text2 |$last||textInsertPos| } |childrenMInsertPos|        //Cant have children since this ListItem is the last of the block
	 *           }
	 *         }
	 *       ...
	 *     |childrenOInsertPosition| }
	 *   |$prev| }
	 *   ListItem K {
	 *      Paragraph L { |$head| text3 }
	 *      ...Children M
	 *      List? N {
	 *       ...Children O
	 *      }
	 *   }
	 * }
	 *
	 * Converts to:
	 *
	 * List A {
	 *   ListItem B {
	 *     Paragraph C { text1 }
	 *     ...Children D
	 *     List E {
	 *       ...
	 *         List F {
	 *           ...Children G
	 *           ListItem H {
	 *             ...Children I
	 *             Paragraph J { text2text3 }
	 *             ...Children M
	 *           }
	 *         }
	 *       ...
	 *       ...Children O
	 *     }
	 *   }
	 * }
	 *
	 */ if (!$last) //Exit if an invalid last was given as a parameter
    return false;
    const listItemK = $head.node(-1); //Head is inside listItem K so it must have a first and last child
    if (!listItemK.firstChild || !listItemK.lastChild) return false;
    const paragraphL = $head.parent;
    const beforeListItemK = $head.before(-1);
    const afterParagraphJ = $last.after();
    const afterListItemK = $head.after(-1);
    const containsChildrenO = (0, $fCXIH.isListNode)(listItemK.lastChild);
    const textInsertPos = $last.pos;
    const childrenMInsertPos = afterParagraphJ;
    const childrenOInsertPos = $prev.pos - 1; //Last item of listItem B must be a list therefore we can simply decrement $prev to get there
    const textContent = paragraphL.content;
    const childrenMContent = containsChildrenO ? listItemK.content.cut(listItemK.firstChild.nodeSize, listItemK.nodeSize - listItemK.lastChild.nodeSize - 2) : listItemK.content.cut(listItemK.firstChild.nodeSize);
    const childrenOContent = listItemK.lastChild.content;
    (0, $HOLTj.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve(textInsertPos), containsChildrenO ? [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenMContent,
            childrenMInsertPos
        ],
        [
            childrenOContent,
            childrenOInsertPos
        ]
    ] : [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenMContent,
            childrenMInsertPos
        ]
    ], [
        [
            beforeListItemK,
            afterListItemK
        ]
    ]);
    if (dispatch) dispatch(tr);
    return true;
};
const $a20c008ca505db1d$var$BACKSPACE_COMMANDS = {
    [(0, $eZyx0.LIST_TEXT_SCENARIOS).JOIN_SIBLINGS]: $a20c008ca505db1d$var$listBackspaceCase2,
    [(0, $eZyx0.LIST_TEXT_SCENARIOS).JOIN_DESCENDANT_TO_PARENT]: $a20c008ca505db1d$var$listBackspaceCase3,
    [(0, $eZyx0.LIST_TEXT_SCENARIOS).JOIN_TO_SIBLING_DESCENDANT]: $a20c008ca505db1d$var$listBackspaceCase4
};
const $a20c008ca505db1d$export$c60ae92c9826748a = (walkNode, $head, tr)=>{
    const { $pos: $prev, foundNode: prevFoundNode } = walkNode;
    const prevInList = (0, $510Zv.isPosInsideList)($prev);
    const headInParagraph = (0, $510Zv.isPosInsideParagraph)($head);
    const headInFirstChild = $head.index(-1) === 0;
    const headInList = (0, $510Zv.isPosInsideList)($head);
    //Must be at the start of the selection of the first child in the listItem
    if (!prevFoundNode || !prevInList || !headInParagraph || !headInFirstChild || !headInList) return false;
    const prevInParagraph = (0, $510Zv.isPosInsideParagraph)($prev);
    if (prevInParagraph) return [
        (0, $eZyx0.LIST_TEXT_SCENARIOS).JOIN_DESCENDANT_TO_PARENT,
        null
    ];
    const prevParentLastChildIsList = $prev.parent.lastChild && (0, $fCXIH.isListNode)($prev.parent.lastChild);
    const prevParentLastChildIsParagraph = (0, $fCXIH.isParagraphNode)($prev.parent.lastChild);
    // Will search for the possible last node for case 4 (where the list could be indented multiple times)
    // $last is required to determine whether we are in case 2 or 4
    let $last = tr.doc.resolve($prev.pos);
    let lastFoundNode;
    do {
        const walkNode = (0, $HOLTj.walkPrevNode)($last);
        $last = walkNode.$pos;
        lastFoundNode = walkNode.foundNode;
    }while (lastFoundNode && !$last.parent.isTextblock);
    const lastInParagraph = (0, $510Zv.isPosInsideParagraph)($last);
    if (lastFoundNode && prevParentLastChildIsList && lastInParagraph) return [
        (0, $eZyx0.LIST_TEXT_SCENARIOS).JOIN_TO_SIBLING_DESCENDANT,
        $last
    ];
    else if (prevParentLastChildIsParagraph) return [
        (0, $eZyx0.LIST_TEXT_SCENARIOS).JOIN_SIBLINGS,
        null
    ];
    return false;
};
const $a20c008ca505db1d$export$7d25b69a3ad4526e = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { tr: tr, selection: { $head: $head } } = state;
        const walkNode = (0, $HOLTj.walkPrevNode)($head);
        if (!(0, $HOLTj.isEmptySelectionAtStart)(state)) return false;
        const scenario = $a20c008ca505db1d$export$c60ae92c9826748a(walkNode, $head, tr);
        if (!scenario) return false;
        const { bulletList: bulletList, orderedList: orderedList } = state.schema.nodes;
        const listParent = (0, $BmspC.findParentNodeOfType)([
            bulletList,
            orderedList
        ])(tr.selection);
        let actionSubjectId = (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET;
        if (listParent && listParent.node.type === orderedList) actionSubjectId = (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $bMFKb.ACTION).LIST_ITEM_JOINED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).LIST,
            actionSubjectId: actionSubjectId,
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
            attributes: {
                inputMethod: (0, $bMFKb.INPUT_METHOD).KEYBOARD,
                direction: (0, $eZyx0.DELETE_DIRECTION).BACKWARD,
                scenario: scenario[0]
            }
        })(tr);
        return $a20c008ca505db1d$var$BACKSPACE_COMMANDS[scenario[0]](tr, dispatch, walkNode.$pos, $head, scenario[1]);
    };

});

parcelRegister("gT7GF", function(module, exports) {
$parcel$export(module.exports, "outdentList", () => $700500b4e7ae259e$export$959569198ddbbe17);

var $bMFKb = parcelRequire("bMFKb");
var $eZyx0 = parcelRequire("eZyx0");

var $9R6MF = parcelRequire("9R6MF");

var $8GLF3 = parcelRequire("8GLF3");

var $fCXIH = parcelRequire("fCXIH");

var $apqw1 = parcelRequire("apqw1");

var $jZi4T = parcelRequire("jZi4T");

var $az0Ou = parcelRequire("az0Ou");

var $jVesZ = parcelRequire("jVesZ");

var $510Zv = parcelRequire("510Zv");
const $700500b4e7ae259e$export$959569198ddbbe17 = (editorAnalyticsAPI)=>(inputMethod = (0, $bMFKb.INPUT_METHOD).KEYBOARD)=>{
        return function({ tr: tr }) {
            if (!(0, $510Zv.isInsideListItem)(tr)) return null;
            const { $from: $from } = tr.selection;
            const parentListNode = (0, $jVesZ.findFirstParentListNode)($from);
            if (!parentListNode) // Even though this is a non-operation, we don't want to send this event to the browser. Because if we return false, the browser will move the focus to another place
            return new (0, $8GLF3.PassiveTransaction)();
            // Save the history, so it could undo/revert to the same state before the outdent, see https://product-fabric.atlassian.net/browse/ED-14753
            (0, $apqw1.closeHistory)(tr);
            const actionSubjectId = (0, $fCXIH.isBulletList)(parentListNode.node) ? (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET : (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
            const customTr = tr;
            (0, $jZi4T.outdentListItemsSelected)(customTr);
            if (!customTr || !customTr.docChanged) // Even though this is a non-operation, we don't want to send this event to the browser. Because if we return false, the browser will move the focus to another place
            // If inside table cell and can't outdent list, then let it handle by table keymap
            return !(0, $510Zv.isInsideTableCell)(customTr) ? new (0, $8GLF3.PassiveTransaction)() : null;
            const restartListsAttributes = {};
            const { outdentScenario: outdentScenario, splitListStartNumber: splitListStartNumber } = (0, $az0Ou.getRestartListsAttributes)(customTr);
            if (outdentScenario === (0, $eZyx0.OUTDENT_SCENARIOS).SPLIT_LIST) {
                restartListsAttributes.outdentScenario = outdentScenario;
                restartListsAttributes.splitListStartNumber = splitListStartNumber;
            }
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $bMFKb.ACTION).OUTDENTED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).LIST,
                actionSubjectId: actionSubjectId,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                attributes: {
                    ...(0, $9R6MF.getCommonListAnalyticsAttributes)(customTr),
                    ...restartListsAttributes,
                    inputMethod: inputMethod
                }
            })(customTr);
            return customTr;
        };
    };

});
parcelRegister("jZi4T", function(module, exports) {
$parcel$export(module.exports, "outdentListItemsSelected", () => $57843eaa9aac76c3$export$af0010ffaabe3f83);

var $eZyx0 = parcelRequire("eZyx0");

var $49G1L = parcelRequire("49G1L");
var $81iCy = parcelRequire("81iCy");

var $6BNUN = parcelRequire("6BNUN");

var $fCXIH = parcelRequire("fCXIH");

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $lzEKq = parcelRequire("lzEKq");

var $az0Ou = parcelRequire("az0Ou");

var $jVesZ = parcelRequire("jVesZ");

var $510Zv = parcelRequire("510Zv");
const $57843eaa9aac76c3$export$af0010ffaabe3f83 = (tr)=>{
    const originalSelection = tr.selection;
    const normalizedSelection = (0, $81iCy.normalizeListItemsSelection)({
        selection: tr.selection,
        doc: tr.doc
    });
    const rootList = (0, $jVesZ.findRootParentListNode)(normalizedSelection.$from);
    if (!rootList) return;
    const commonList = normalizedSelection.$from.blockRange(rootList, (0, $fCXIH.isListNode));
    if (!commonList) return;
    let hasNormalizedToPositionLiftedOut = false;
    let hasNormalizedFromPositionLiftedOut = false;
    const { from: oldFrom, to: oldTo } = normalizedSelection;
    const nodeRanges = $57843eaa9aac76c3$var$splitRangeSelection(normalizedSelection);
    nodeRanges.forEach((range)=>{
        const $from = tr.doc.resolve(tr.mapping.map(range.from));
        const $to = tr.doc.resolve(tr.mapping.map(range.to));
        const mappedRange = $from.blockRange($to, (0, $fCXIH.isListNode));
        if (!mappedRange) return;
        if ((0, $fCXIH.isListItemNode)($from.node(mappedRange.depth - 1))) $57843eaa9aac76c3$var$outdentRangeToParentList({
            tr: tr,
            range: mappedRange
        });
        else {
            $57843eaa9aac76c3$var$extractListItemsRangeFromList({
                tr: tr,
                range: mappedRange
            });
            hasNormalizedToPositionLiftedOut = hasNormalizedToPositionLiftedOut || oldTo >= range.from && oldTo < range.to;
            hasNormalizedFromPositionLiftedOut = hasNormalizedFromPositionLiftedOut || oldFrom >= range.from && oldFrom < range.to;
        }
    });
    const hasCommonListMoved = commonList.start !== tr.mapping.map(commonList.start);
    const nextSelection = $57843eaa9aac76c3$var$calculateNewSelection({
        originalSelection: originalSelection,
        normalizedSelection: normalizedSelection,
        tr: tr,
        hasCommonListMoved: hasCommonListMoved,
        hasNormalizedToPositionLiftedOut: hasNormalizedToPositionLiftedOut,
        hasNormalizedFromPositionLiftedOut: hasNormalizedFromPositionLiftedOut
    });
    tr.setSelection(nextSelection);
    // processNestedTaskListsInSameLevel(tr);
    (0, $49G1L.joinSiblingLists)({
        tr: tr,
        direction: (0, $49G1L.JoinDirection).RIGHT
    });
};
const $57843eaa9aac76c3$var$calculateNewSelection = ({ tr: tr, originalSelection: originalSelection, normalizedSelection: normalizedSelection, hasCommonListMoved: hasCommonListMoved, hasNormalizedToPositionLiftedOut: hasNormalizedToPositionLiftedOut, hasNormalizedFromPositionLiftedOut: hasNormalizedFromPositionLiftedOut })=>{
    const { $from: $from, $to: $to } = normalizedSelection;
    const isCursorSelection = normalizedSelection.empty;
    let from = tr.mapping.map($from.pos);
    let to = tr.mapping.map($to.pos);
    const LIST_STRUCTURE_CHANGED_OFFSET = 2;
    const isToFromSameListItem = $from.sameParent($to);
    if (hasNormalizedFromPositionLiftedOut) {
        const fromMapped = isToFromSameListItem ? $from.pos : from;
        from = hasNormalizedFromPositionLiftedOut ? $from.pos : fromMapped;
        from = hasCommonListMoved ? from - LIST_STRUCTURE_CHANGED_OFFSET : from;
        from = Math.max(from, 0);
    }
    if (hasNormalizedToPositionLiftedOut) {
        const toMapped = isToFromSameListItem ? $to.pos : to;
        to = hasNormalizedToPositionLiftedOut ? $to.pos : toMapped;
        to = hasCommonListMoved ? to - LIST_STRUCTURE_CHANGED_OFFSET : to;
        to = Math.min(to, tr.doc.nodeSize - 2);
    }
    if (normalizedSelection instanceof (0, $6BNUN.GapCursorSelection)) {
        const nextSelectionFrom = tr.doc.resolve(from);
        return new (0, $6BNUN.GapCursorSelection)(nextSelectionFrom, normalizedSelection.side);
    }
    if (originalSelection instanceof (0, $3lIcL.NodeSelection)) return (0, $3lIcL.NodeSelection).create(tr.doc, from);
    if (isCursorSelection) return (0, $3lIcL.TextSelection).between(tr.doc.resolve(to), tr.doc.resolve(to), -1);
    return (0, $3lIcL.TextSelection).between(tr.doc.resolve(from), tr.doc.resolve(to), -1);
};
const $57843eaa9aac76c3$var$splitRangeSelection = (selection)=>{
    const commonListRange = (0, $510Zv.createListNodeRange)({
        selection: selection
    });
    if (!commonListRange) return [];
    const { $from: $from, $to: $to } = selection;
    if ($from.pos === $to.pos && $from.sameParent($to)) return [
        {
            from: commonListRange.start,
            to: commonListRange.end,
            depth: commonListRange.depth
        }
    ];
    const lastListItem = $57843eaa9aac76c3$var$findPreviousListItemSibling($from);
    if (!lastListItem) return [];
    const nodeRanges = [];
    const { doc: doc } = $from;
    let previousListItem = $57843eaa9aac76c3$var$findPreviousListItemSibling($to);
    while(previousListItem && previousListItem.pos >= lastListItem.pos && previousListItem.pos >= commonListRange.start){
        const node = doc.nodeAt(previousListItem.pos);
        if (!node || !(0, $fCXIH.isListItemNode)(node)) return [];
        let offset = 0;
        if (node && node.lastChild && (0, $fCXIH.isListNode)(node.lastChild)) offset = node.lastChild.nodeSize;
        const start = previousListItem.pos + 1;
        nodeRanges.push({
            from: start,
            to: doc.resolve(start).end() - offset,
            depth: previousListItem.depth
        });
        previousListItem = $57843eaa9aac76c3$var$findPreviousListItemSibling(previousListItem);
    }
    return nodeRanges;
};
const $57843eaa9aac76c3$var$outdentRangeToParentList = ({ tr: tr, range: range })=>{
    const end = range.end;
    const endOfList = range.$to.end(range.depth);
    const { listItem: listItem } = tr.doc.type.schema.nodes;
    if (end < endOfList) {
        const slice = new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(listItem.create(null, range.parent.copy())), 1, 0);
        const step = new (0, $lzEKq.ReplaceAroundStep)(end - 1, endOfList, end, endOfList, slice, 1, true);
        tr.step(step);
        range = new (0, $3xw6l.NodeRange)(tr.doc.resolve(range.$from.pos), tr.doc.resolve(endOfList), range.depth);
    }
    const target = (0, $lzEKq.liftTarget)(range);
    if (target) tr.lift(range, target);
};
const $57843eaa9aac76c3$var$extractListItemsRangeFromList = ({ tr: tr, range: range })=>{
    const list = range.parent;
    const $start = tr.doc.resolve(range.start);
    const listStart = $start.start(range.depth);
    const listEnd = $start.end(range.depth);
    const isAtTop = listStart === range.start;
    const isAtBottom = listEnd === range.end;
    const isTheEntireList = isAtTop && isAtBottom;
    let listItemContent = isAtTop ? (0, $3xw6l.Fragment).empty : (0, $3xw6l.Fragment).from(list.copy((0, $3xw6l.Fragment).empty));
    for(let i = range.startIndex; i < range.endIndex; i++)listItemContent = listItemContent.append(list.child(i).content);
    if (isAtTop) for(let i = 0; i < listItemContent.childCount; i++){
        const child = listItemContent.child(i);
        if (child && (0, $fCXIH.isListNode)(child) && child.type !== list.type) {
            const newNestedList = list.type.create(null, child.content);
            listItemContent = listItemContent.replaceChild(i, newNestedList);
        }
    }
    const nextList = list.copy((0, $3xw6l.Fragment).empty);
    let nextListStartNumber;
    // if splitting a numbered list, keep the splitted item
    // counter as the start of the next (second half) list (instead
    // of reverting back to 1 as a starting number)
    const order = (0, $fCXIH.getOrderFromOrderedListNode)(list);
    if (list.type.name === 'orderedList') {
        nextListStartNumber = range.endIndex - 1 + order;
        // @ts-ignore - [unblock prosemirror bump] assigning to readonly attrs
        nextList.attrs = {
            ...nextList.attrs,
            order: nextListStartNumber
        };
        const { splitListStartNumber: splitListStartNumber } = (0, $az0Ou.getRestartListsAttributes)(tr);
        if (typeof splitListStartNumber !== 'number') (0, $az0Ou.storeRestartListsAttributes)(tr, {
            splitListStartNumber: nextListStartNumber
        });
    }
    const nextListFragment = listItemContent.append((0, $3xw6l.Fragment).from(nextList));
    // if the split list with nextListStartNumber is below another list
    // with order (e.g due to multi-level indent items being lifted), track the
    // list above's order instead, as it will be the split list's order after sibling joins
    nextListFragment.forEach((node, _offset, index)=>{
        if (node.type.name === 'orderedList' && node.attrs?.order === nextListStartNumber) {
            const prev = nextListFragment.child(index - 1);
            if (prev?.attrs?.order >= 0) (0, $az0Ou.storeRestartListsAttributes)(tr, {
                splitListStartNumber: prev?.attrs?.order
            });
        }
    });
    if (isTheEntireList) {
        const slice = new (0, $3xw6l.Slice)(listItemContent, 0, 0);
        const step = new (0, $lzEKq.ReplaceStep)($start.pos - 1, range.end + 1, slice, false);
        (0, $az0Ou.storeRestartListsAttributes)(tr, {
            outdentScenario: undefined
        });
        tr.step(step);
    } else if (isAtTop) {
        const slice = new (0, $3xw6l.Slice)(nextListFragment, 0, 1);
        const step = new (0, $lzEKq.ReplaceStep)($start.pos - 1, range.end, slice, false);
        tr.step(step);
    } else if (isAtBottom) {
        const slice = new (0, $3xw6l.Slice)(listItemContent, 1, 0);
        const step = new (0, $lzEKq.ReplaceStep)($start.pos, listEnd + 1, slice, false);
        tr.step(step);
    } else {
        (0, $az0Ou.storeRestartListsAttributes)(tr, {
            outdentScenario: (0, $eZyx0.OUTDENT_SCENARIOS).SPLIT_LIST
        });
        const slice = new (0, $3xw6l.Slice)(nextListFragment, 1, 1);
        const step = new (0, $lzEKq.ReplaceAroundStep)($start.pos, listEnd, range.end, listEnd, slice, slice.size, false);
        tr.step(step);
    }
};
const $57843eaa9aac76c3$var$findPreviousListItemSibling = ($pos)=>{
    const doc = $pos.doc;
    const isPositionListItem = (0, $fCXIH.isListNode)($pos.node());
    const listItemPosition = $pos;
    if (!isPositionListItem) {
        const listItem = (0, $jVesZ.findFirstParentListItemNode)($pos);
        if (!listItem) return null;
        return doc.resolve(listItem.pos);
    }
    const resolved = doc.resolve(listItemPosition.pos);
    const foundPosition = (0, $3lIcL.Selection).findFrom(resolved, -1);
    if (!foundPosition) return null;
    const parentListItemNode = (0, $jVesZ.findFirstParentListItemNode)(foundPosition.$from);
    if (!parentListItemNode) return null;
    return doc.resolve(parentListItemNode.pos);
};

});
parcelRegister("az0Ou", function(module, exports) {
$parcel$export(module.exports, "getRestartListsAttributes", () => $d68fa001f73e23ac$export$a5d23221f6e92f0d);
$parcel$export(module.exports, "storeRestartListsAttributes", () => $d68fa001f73e23ac$export$2279077d1a24e505);
const $d68fa001f73e23ac$export$8a03eb72bd3998d1 = 'restartListsAnalytics';
const $d68fa001f73e23ac$export$a5d23221f6e92f0d = (tr)=>tr.getMeta($d68fa001f73e23ac$export$8a03eb72bd3998d1) ?? {};
const $d68fa001f73e23ac$export$2279077d1a24e505 = (tr, attributes)=>{
    const meta = $d68fa001f73e23ac$export$a5d23221f6e92f0d(tr);
    tr.setMeta($d68fa001f73e23ac$export$8a03eb72bd3998d1, {
        ...meta,
        ...attributes
    });
};

});




parcelRegister("j79rf", function(module, exports) {
$parcel$export(module.exports, "indentList", () => $f0adbe766ce39987$export$8066a906978eedb2);

var $bMFKb = parcelRequire("bMFKb");

var $9R6MF = parcelRequire("9R6MF");
var $81iCy = parcelRequire("81iCy");
var $bnuR5 = parcelRequire("bnuR5");

var $8GLF3 = parcelRequire("8GLF3");

var $fCXIH = parcelRequire("fCXIH");

var $apqw1 = parcelRequire("apqw1");


var $htZdj = parcelRequire("htZdj");

var $jVesZ = parcelRequire("jVesZ");

var $510Zv = parcelRequire("510Zv");
const $f0adbe766ce39987$export$8066a906978eedb2 = (editorAnalyticsAPI)=>(inputMethod = (0, $bMFKb.INPUT_METHOD).KEYBOARD)=>{
        return function({ tr: tr }) {
            const { selection: { $from: $from } } = tr;
            // don't indent if selection is not inside a list
            if (!(0, $510Zv.isInsideListItem)(tr)) return null;
            // Save the history, so it could undo/revert to the same state before the indent, see https://product-fabric.atlassian.net/browse/ED-14753
            (0, $apqw1.closeHistory)(tr);
            const firstListItemSelectedAttributes = (0, $81iCy.getListItemAttributes)($from);
            const parentListNode = (0, $jVesZ.findFirstParentListNode)($from);
            if (!parentListNode || firstListItemSelectedAttributes && firstListItemSelectedAttributes.indentLevel === 0 && firstListItemSelectedAttributes.itemIndex === 0) {
                if ((0, $510Zv.isInsideTableCell)(tr)) // dont consume tab, as table-keymap should move cursor to next cell
                return null;
                else // Even though this is a non-operation, we don't want to send this event to the browser. Because if we return false, the browser will move the focus to another place
                return new (0, $8GLF3.PassiveTransaction)();
            }
            const currentListNode = parentListNode.node;
            const actionSubjectId = (0, $fCXIH.isBulletList)(currentListNode) ? (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET : (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
            (0, $htZdj.indentListItemsSelected)(tr);
            const maximimunNestedLevelReached = !(0, $bnuR5.hasValidListIndentationLevel)({
                tr: tr,
                maxIndentation: (0, $8aff72ccff72cdee$export$eb55a67f55930af1)
            });
            if (maximimunNestedLevelReached || !tr.docChanged) // Even though this is a non-operation, we don't want to send this event to the browser. Because if we return false, the browser will move the focus to another place
            return new (0, $8GLF3.PassiveTransaction)();
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $bMFKb.ACTION).INDENTED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).LIST,
                actionSubjectId: actionSubjectId,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                attributes: {
                    ...(0, $9R6MF.getCommonListAnalyticsAttributes)(tr),
                    inputMethod: inputMethod
                }
            })(tr);
            return tr;
        };
    };

});
parcelRegister("bnuR5", function(module, exports) {
$parcel$export(module.exports, "hasValidListIndentationLevel", () => $f7135072d17cb4da$export$925f3cc2bf62e47a);

var $81iCy = parcelRequire("81iCy");
const $f7135072d17cb4da$export$925f3cc2bf62e47a = ({ tr: tr, maxIndentation: maxIndentation })=>{
    const initialIndentationLevel = (0, $81iCy.numberNestedLists)(tr.selection.$from);
    let currentIndentationLevel;
    let currentPos = tr.selection.$to.pos;
    do {
        const resolvedPos = tr.doc.resolve(currentPos);
        currentIndentationLevel = (0, $81iCy.numberNestedLists)(resolvedPos);
        if (currentIndentationLevel > maxIndentation) return false;
        currentPos++;
    }while (currentIndentationLevel >= initialIndentationLevel);
    return true;
};

});

const $8aff72ccff72cdee$export$eb55a67f55930af1 = 6;

parcelRegister("htZdj", function(module, exports) {
$parcel$export(module.exports, "indentListItemsSelected", () => $3ed854cce6d4dce9$export$cbf684996d8a31a2);

var $81iCy = parcelRequire("81iCy");

var $6BNUN = parcelRequire("6BNUN");

var $fCXIH = parcelRequire("fCXIH");

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $jVesZ = parcelRequire("jVesZ");
const $3ed854cce6d4dce9$export$cbf684996d8a31a2 = (tr)=>{
    const originalSelection = tr.selection;
    const normalizedSelection = (0, $81iCy.normalizeListItemsSelection)({
        selection: originalSelection,
        doc: tr.doc
    });
    const { $from: $from, $to: $to } = normalizedSelection;
    const range = $3ed854cce6d4dce9$var$calculateRange({
        selection: normalizedSelection
    });
    if (!range) return false;
    const listItemsSelected = {
        from: (0, $jVesZ.findFirstParentListItemNode)($from),
        to: (0, $jVesZ.findFirstParentListItemNode)($to)
    };
    if (listItemsSelected.from === null || listItemsSelected.to === null) return null;
    const resolvedPos = tr.doc.resolve(listItemsSelected.from.pos);
    const listItemIndex = resolvedPos.index();
    // @ts-ignore
    const positionListItemPosition = resolvedPos.posAtIndex(listItemIndex - 1);
    const currentListItemPosition = resolvedPos.posAtIndex(listItemIndex);
    const previousListItem = tr.doc.nodeAt(positionListItemPosition);
    const currentListItem = tr.doc.nodeAt(currentListItemPosition);
    const currentListItemContent = currentListItem?.content?.content;
    const hasLastItemExtension = currentListItemContent !== undefined && currentListItemContent?.length > 0 ? currentListItemContent[currentListItemContent.length - 1].type.name === 'extension' : false;
    if (!previousListItem || !(0, $fCXIH.isListItemNode)(previousListItem)) return null;
    if ((0, $fCXIH.isListItemNode)(previousListItem) && listItemIndex === 0) return null;
    const listItemSelectedCommonParent = range.parent;
    const previousNestedList = (0, $fCXIH.isListNode)(previousListItem.lastChild) ? previousListItem.lastChild : null;
    const listNodeType = previousNestedList ? previousNestedList.type : listItemSelectedCommonParent.type;
    const nestedList = listItemsSelected.to.node.lastChild;
    const nestedItemsOffset = nestedList && (0, $fCXIH.isListNode)(nestedList) ? nestedList.nodeSize : 0;
    const from = listItemsSelected.from.pos;
    const to = listItemsSelected.to.pos + listItemsSelected.to.node.nodeSize - nestedItemsOffset;
    const [sliceSelected, nestedListItemsLeftover] = $3ed854cce6d4dce9$var$createIndentedListItemsSlice({
        tr: tr,
        listNodeType: listNodeType,
        range: range,
        from: from,
        to: to,
        hasLastItemExtension: hasLastItemExtension
    });
    const hasPreviousNestedList = Boolean(previousNestedList);
    const start = from - 1;
    tr.replaceRange(hasPreviousNestedList ? start - 1 : start, range.end, sliceSelected);
    const leftoverContentPosition = tr.mapping.map(to) - 2;
    if (nestedListItemsLeftover.openStart === 0) tr.insert(leftoverContentPosition, nestedListItemsLeftover.content);
    else tr.replace(leftoverContentPosition - nestedListItemsLeftover.openStart, leftoverContentPosition - nestedListItemsLeftover.openStart, nestedListItemsLeftover);
    const nextSelection = $3ed854cce6d4dce9$var$calculateNewSelection({
        originalSelection: originalSelection,
        normalizedSelection: normalizedSelection,
        tr: tr,
        hasPreviousNestedList: hasPreviousNestedList
    });
    tr.setSelection(nextSelection);
};
const $3ed854cce6d4dce9$var$calculateRange = ({ selection: selection })=>{
    const { $from: $from, $to: $to } = selection;
    const range = $from.blockRange($to, (0, $fCXIH.isListNode));
    if (!range) return null;
    return range;
};
const $3ed854cce6d4dce9$var$calculateNewSelection = ({ tr: tr, normalizedSelection: normalizedSelection, originalSelection: originalSelection, hasPreviousNestedList: hasPreviousNestedList })=>{
    const offset = hasPreviousNestedList ? 2 : 0;
    const { $from: $from, $to: $to } = normalizedSelection;
    if (normalizedSelection instanceof (0, $6BNUN.GapCursorSelection)) {
        const nextSelectionFrom = tr.doc.resolve($from.pos - offset);
        return new (0, $6BNUN.GapCursorSelection)(nextSelectionFrom, normalizedSelection.side);
    }
    if (originalSelection instanceof (0, $3lIcL.NodeSelection)) return (0, $3lIcL.NodeSelection).create(tr.doc, $from.pos - offset);
    const { $from: nextSelectionFrom } = (0, $3lIcL.Selection).near(tr.doc.resolve($from.pos - offset));
    const { $to: nextSelectionTo } = (0, $3lIcL.Selection).near(tr.doc.resolve($to.pos - offset), -1);
    return new (0, $3lIcL.TextSelection)(nextSelectionFrom, nextSelectionTo);
};
const $3ed854cce6d4dce9$var$createIndentedListItemsSlice = ({ tr: tr, from: from, to: to, listNodeType: listNodeType, range: range, hasLastItemExtension: hasLastItemExtension })=>{
    const listItemsSlice = tr.doc.slice(from, hasLastItemExtension ? to : to - 2);
    const listFragment = (0, $3xw6l.Fragment).from(listNodeType.create(null, listItemsSlice.content));
    const nonSelectedListItemsSlice = tr.doc.slice(to, range.end - 2);
    const openStart = tr.doc.slice(from - 1, range.end).openStart;
    const slice = new (0, $3xw6l.Slice)(listFragment, openStart, 0);
    return [
        slice,
        nonSelectedListItemsSlice
    ];
};

});


parcelRegister("5zzop", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7955ff877a4d75c$export$2e2bcd8739ae039);

var $i8KtF = parcelRequire("i8KtF");

var $jCfsG = parcelRequire("jCfsG");

var $8NOSU = parcelRequire("8NOSU");
function $b7955ff877a4d75c$export$2e2bcd8739ae039(schema, editorAnalyticsApi) {
    const { nodes: { bulletList: bulletList, orderedList: orderedList } } = schema;
    const rules = [];
    if (bulletList) rules.push((0, $8NOSU.createRuleForListType)({
        // Using UTF instead of • character
        // because of issue where product converted the
        // character into an escaped version.
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        expression: /^\s*([\*\-\u2022]) $/,
        listType: bulletList,
        editorAnalyticsApi: editorAnalyticsApi
    }));
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const expression = /((^[1-9]{1}[0-9]{0,2})|^(0))[\.\)] $/;
    if (orderedList) rules.push((0, $8NOSU.createRuleForListType)({
        expression: expression,
        listType: orderedList,
        editorAnalyticsApi: editorAnalyticsApi
    }));
    if (rules.length !== 0) return new (0, $i8KtF.SafePlugin)((0, $jCfsG.createPlugin)('lists', rules));
    return;
}

});
parcelRegister("8NOSU", function(module, exports) {
$parcel$export(module.exports, "createRuleForListType", () => $62bef06198ac5925$export$7c19b3e2f55f7141);

var $bMFKb = parcelRequire("bMFKb");
var $eZyx0 = parcelRequire("eZyx0");

var $leZY6 = parcelRequire("leZY6");

var $1NOzi = parcelRequire("1NOzi");
const $62bef06198ac5925$var$getOrder = (matchResult)=>Number(matchResult[1]);
function $62bef06198ac5925$export$7c19b3e2f55f7141({ listType: listType, expression: expression, editorAnalyticsApi: editorAnalyticsApi }) {
    let joinScenario = (0, $eZyx0.JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST).NO_JOIN;
    const isBulletList = listType.name === 'bulletList';
    const actionSubjectId = isBulletList ? (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET : (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
    const getAnalyticsPayload = (state, matchResult)=>{
        const analyticsPayload = {
            action: (0, $bMFKb.ACTION).INSERTED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).LIST,
            actionSubjectId: actionSubjectId,
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
            attributes: {
                inputMethod: (0, $bMFKb.INPUT_METHOD).FORMATTING
            }
        };
        if (listType === state.schema.nodes.orderedList && analyticsPayload.attributes) {
            analyticsPayload.attributes.listStartNumber = $62bef06198ac5925$var$getOrder(matchResult);
            analyticsPayload.attributes.joinScenario = joinScenario;
            // we reset the tracked joinScenario after storing it in the event payload
            joinScenario = (0, $eZyx0.JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST).NO_JOIN;
        }
        return analyticsPayload;
    };
    const joinToNeighbourIfSameListType = (_, node, scenario)=>{
        const shouldJoin = node.type === listType;
        if (shouldJoin) joinScenario = scenario;
        return shouldJoin;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getAttrs = (matchResult)=>{
        return {
            order: $62bef06198ac5925$var$getOrder(matchResult)
        };
    };
    const inputRule = (0, $1NOzi.createWrappingJoinRule)({
        match: expression,
        nodeType: listType,
        getAttrs: getAttrs,
        joinPredicate: joinToNeighbourIfSameListType
    });
    return (0, $leZY6.inputRuleWithAnalytics)(getAnalyticsPayload, editorAnalyticsApi)(inputRule);
}

});
parcelRegister("1NOzi", function(module, exports) {
$parcel$export(module.exports, "createWrappingJoinRule", () => $51e193465a6e3f21$export$6341edfa2d147bc);

var $eZyx0 = parcelRequire("eZyx0");

var $leZY6 = parcelRequire("leZY6");

var $lzEKq = parcelRequire("lzEKq");

var $BmspC = parcelRequire("BmspC");
const $51e193465a6e3f21$export$6341edfa2d147bc = ({ match: match, nodeType: nodeType, getAttrs: getAttrs, joinPredicate: joinPredicate })=>{
    const handler = (state, match, start, end)=>{
        const attrs = (getAttrs instanceof Function ? getAttrs(match) : getAttrs) || {};
        const tr = state.tr;
        const fixedStart = Math.max(start, 1);
        tr.delete(fixedStart, end);
        const $start = tr.doc.resolve(fixedStart);
        const range = $start.blockRange();
        const wrapping = range && (0, $lzEKq.findWrapping)(range, nodeType, attrs);
        if (!wrapping || !range) return null;
        const parentNodePosMapped = tr.mapping.map(range.start);
        const parentNode = tr.doc.nodeAt(parentNodePosMapped);
        const lastWrap = wrapping[wrapping.length - 1];
        if (parentNode && lastWrap) {
            const allowedMarks = lastWrap.type.allowedMarks(parentNode.marks) || [];
            tr.setNodeMarkup(parentNodePosMapped, parentNode.type, parentNode.attrs, allowedMarks);
        }
        tr.wrap(range, wrapping);
        // if an orderedList node would be inserted by the input rule match, and
        // that orderedList node is being added directly after another orderedList
        const $end = tr.doc.resolve(tr.mapping.map(end));
        const nodeWithPos = (0, $BmspC.findParentNodeOfTypeClosestToPos)($end, nodeType);
        if (nodeType === state.schema.nodes.orderedList) // otherwise join the lists
        {
            if (nodeWithPos) {
                const nodeEnd = nodeWithPos.pos + nodeWithPos.node.nodeSize;
                const after = tr.doc.resolve(nodeEnd).nodeAfter;
                if (after && after.type === nodeType && (0, $lzEKq.canJoin)(tr.doc, nodeEnd) && (!joinPredicate || joinPredicate(match, after, (0, $eZyx0.JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST).JOINED_TO_LIST_BELOW))) tr.join(nodeEnd);
            }
        }
        const before = tr.doc.resolve(fixedStart - 1).nodeBefore;
        if (before && before.type === nodeType && (0, $lzEKq.canJoin)(tr.doc, fixedStart - 1) && (!joinPredicate || joinPredicate(match, before, (0, $eZyx0.JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST).JOINED_TO_LIST_ABOVE))) tr.join(fixedStart - 1);
        return tr;
    };
    return (0, $leZY6.createRule)(match, handler);
};

});



parcelRegister("cGMTC", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b0a3046093d2b4d$export$2e2bcd8739ae039);

var $bMFKb = parcelRequire("bMFKb");

var $6Exgk = parcelRequire("6Exgk");

var $x7sgX = parcelRequire("x7sgX");

var $4XEa7 = parcelRequire("4XEa7");

var $j79rf = parcelRequire("j79rf");

var $gT7GF = parcelRequire("gT7GF");
function $3b0a3046093d2b4d$export$e832373cff8dec22(featureFlags, editorAnalyticsAPI) {
    const list = {};
    (0, $6Exgk.bindKeymapWithEditorCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.findShortcutByKeymap)((0, $6Exgk.toggleOrderedList)), (0, $4XEa7.toggleList)(editorAnalyticsAPI)((0, $bMFKb.INPUT_METHOD).KEYBOARD, 'orderedList'), list);
    (0, $6Exgk.bindKeymapWithEditorCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.findShortcutByKeymap)((0, $6Exgk.toggleBulletList)), (0, $4XEa7.toggleList)(editorAnalyticsAPI)((0, $bMFKb.INPUT_METHOD).KEYBOARD, 'bulletList'), list);
    (0, $6Exgk.bindKeymapWithEditorCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.indentList).common, (0, $j79rf.indentList)(editorAnalyticsAPI)((0, $bMFKb.INPUT_METHOD).KEYBOARD), list);
    (0, $6Exgk.bindKeymapWithEditorCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.outdentList).common, (0, $gT7GF.outdentList)(editorAnalyticsAPI)((0, $bMFKb.INPUT_METHOD).KEYBOARD), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.bindKeymapWithCommand)((0, $6Exgk.enter).common, (0, $4XEa7.enterKeyCommand)(editorAnalyticsAPI)(), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.bindKeymapWithCommand)((0, $6Exgk.backspace).common, (0, $4XEa7.backspaceKeyCommand)(editorAnalyticsAPI)(), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.bindKeymapWithCommand)((0, $6Exgk.deleteKey).common, (0, $4XEa7.deleteKeyCommand)(editorAnalyticsAPI), list);
    // This shortcut is Mac only
    (0, $6Exgk.bindKeymapWithCommand)((0, $6Exgk.findKeyMapForBrowser)((0, $6Exgk.forwardDelete)), (0, $4XEa7.deleteKeyCommand)(editorAnalyticsAPI), list);
    return (0, $x7sgX.keymap)(list);
}
var $3b0a3046093d2b4d$export$2e2bcd8739ae039 = $3b0a3046093d2b4d$export$e832373cff8dec22;

});

parcelRegister("kDOXU", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $b256c440ca92af07$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "createPlugin", () => $b256c440ca92af07$export$ae829ec7b2625219);

var $i8KtF = parcelRequire("i8KtF");

var $6zZWQ = parcelRequire("6zZWQ");
var $6BNUN = parcelRequire("6BNUN");

var $gBkUB = parcelRequire("gBkUB");
var $kvnqO = parcelRequire("kvnqO");

var $fCXIH = parcelRequire("fCXIH");
var $bazog = parcelRequire("bazog");

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");

var $b7EWj = parcelRequire("b7EWj");

var $enDkL = parcelRequire("enDkL");

var $cbSL1 = parcelRequire("cbSL1");

var $510Zv = parcelRequire("510Zv");
const $b256c440ca92af07$var$listPluginKey = new (0, $3lIcL.PluginKey)('listPlugin');
const $b256c440ca92af07$export$18d4026d1ea86bb1 = $b256c440ca92af07$var$listPluginKey;
const $b256c440ca92af07$var$initialState = {
    bulletListActive: false,
    bulletListDisabled: false,
    orderedListActive: false,
    orderedListDisabled: false,
    decorationSet: (0, $b7EWj.DecorationSet).empty
};
const $b256c440ca92af07$export$97e020a829527f8b = (doc, from = 0, to = doc.content.size)=>{
    const decorations = [];
    // this stack keeps track of each (nested) list to calculate the indentation level
    const processedListsStack = [];
    doc.nodesBetween(from, to, (node, currentNodeStartPos)=>{
        if (processedListsStack.length > 0) {
            let isOutsideLastList = true;
            while(isOutsideLastList && processedListsStack.length > 0){
                const lastList = processedListsStack[processedListsStack.length - 1];
                const lastListEndPos = lastList.startPos + lastList.node.nodeSize;
                isOutsideLastList = currentNodeStartPos >= lastListEndPos;
                // once we finish iterating over each innermost list, pop the stack to
                // decrease the indent level attribute accordingly
                if (isOutsideLastList) processedListsStack.pop();
            }
        }
        if ((0, $fCXIH.isListNode)(node)) {
            processedListsStack.push({
                node: node,
                startPos: currentNodeStartPos
            });
            const from = currentNodeStartPos;
            const to = currentNodeStartPos + node.nodeSize;
            const depth = processedListsStack.length;
            decorations.push((0, $b7EWj.Decoration).node(from, to, {
                'data-indent-level': `${depth}`
            }));
            if (node.type.name === 'orderedList') {
                // If a numbered list has item counters numbering >= 100, we'll need to add special
                // spacing to account for the extra digit chars
                const digitsSize = (0, $fCXIH.getItemCounterDigitsSize)({
                    itemsCount: node?.childCount,
                    order: node?.attrs?.order
                });
                if (digitsSize && digitsSize > 1) decorations.push((0, $b7EWj.Decoration).node(from, to, {
                    style: (0, $kvnqO.getOrderedListInlineStyles)(digitsSize, 'string')
                }));
            }
        }
    });
    return decorations;
};
const $b256c440ca92af07$export$7401dd42ebfee9d = (decorationSet, tr)=>{
    let nextDecorationSet = decorationSet.map(tr.mapping, tr.doc);
    tr.mapping.maps.forEach((stepMap, index)=>{
        stepMap.forEach((oldStart, oldEnd)=>{
            const start = tr.mapping.slice(index).map(oldStart, -1);
            const end = tr.mapping.slice(index).map(oldEnd);
            // Remove decorations in this range
            const decorationsToRemove = nextDecorationSet.find(start, end);
            nextDecorationSet = nextDecorationSet.remove(decorationsToRemove);
            // Recompute decorations for this range
            // Expand the range by 1 on each side to catch adjacent list nodes
            const from = Math.max(0, start - 1);
            const to = Math.min(tr.doc.content.size, end + 1);
            const decorationsToAdd = $b256c440ca92af07$export$97e020a829527f8b(tr.doc, from, to);
            nextDecorationSet = nextDecorationSet.add(tr.doc, decorationsToAdd);
        });
    });
    return nextDecorationSet;
};
const $b256c440ca92af07$export$968abecb43309c32 = (doc, state, featureFlags)=>{
    const decorations = [];
    // this stack keeps track of each (nested) list to calculate the indentation level
    const processedListsStack = [];
    doc.nodesBetween(0, doc.content.size, (node, currentNodeStartPos)=>{
        if (processedListsStack.length > 0) {
            let isOutsideLastList = true;
            while(isOutsideLastList && processedListsStack.length > 0){
                const lastList = processedListsStack[processedListsStack.length - 1];
                const lastListEndPos = lastList.startPos + lastList.node.nodeSize;
                isOutsideLastList = currentNodeStartPos >= lastListEndPos;
                // once we finish iterating over each innermost list, pop the stack to
                // decrease the indent level attribute accordingly
                if (isOutsideLastList) processedListsStack.pop();
            }
        }
        if ((0, $fCXIH.isListNode)(node)) {
            processedListsStack.push({
                node: node,
                startPos: currentNodeStartPos
            });
            const from = currentNodeStartPos;
            const to = currentNodeStartPos + node.nodeSize;
            const depth = processedListsStack.length;
            decorations.push((0, $b7EWj.Decoration).node(from, to, {
                'data-indent-level': `${depth}`
            }));
            if (node.type.name === 'orderedList') {
                // If a numbered list has item counters numbering >= 100, we'll need to add special
                // spacing to account for the extra digit chars
                const digitsSize = (0, $fCXIH.getItemCounterDigitsSize)({
                    itemsCount: node?.childCount,
                    order: node?.attrs?.order
                });
                if (digitsSize && digitsSize > 1) decorations.push((0, $b7EWj.Decoration).node(from, to, {
                    style: (0, $kvnqO.getOrderedListInlineStyles)(digitsSize, 'string')
                }));
            }
        }
    });
    return (0, $b7EWj.DecorationSet).empty.add(doc, decorations);
};
const $b256c440ca92af07$var$getListState = (doc, selection)=>{
    const { bulletList: bulletList, orderedList: orderedList, taskList: taskList } = doc.type.schema.nodes;
    const listParent = (0, $BmspC.findParentNodeOfType)([
        bulletList,
        orderedList,
        taskList
    ])(selection);
    const bulletListActive = !!listParent && listParent.node.type === bulletList;
    const orderedListActive = !!listParent && listParent.node.type === orderedList;
    const bulletListDisabled = !(bulletListActive || orderedListActive || (0, $510Zv.isWrappingPossible)(bulletList, selection));
    const orderedListDisabled = !(bulletListActive || orderedListActive || (0, $510Zv.isWrappingPossible)(orderedList, selection));
    return {
        bulletListActive: bulletListActive,
        bulletListDisabled: bulletListDisabled,
        orderedListActive: orderedListActive,
        orderedListDisabled: orderedListDisabled
    };
};
const $b256c440ca92af07$var$handleDocChanged = (featureFlags)=>(tr, pluginState, editorState)=>{
        const nextPluginState = $b256c440ca92af07$var$handleSelectionChanged(tr, pluginState);
        const decorationSet = $b256c440ca92af07$export$968abecb43309c32(tr.doc, editorState, featureFlags);
        return {
            ...nextPluginState,
            decorationSet: decorationSet
        };
    };
const $b256c440ca92af07$var$handleSelectionChanged = (tr, pluginState)=>{
    const { bulletListActive: bulletListActive, orderedListActive: orderedListActive, bulletListDisabled: bulletListDisabled, orderedListDisabled: orderedListDisabled } = $b256c440ca92af07$var$getListState(tr.doc, tr.selection);
    if (bulletListActive !== pluginState.bulletListActive || orderedListActive !== pluginState.orderedListActive || bulletListDisabled !== pluginState.bulletListDisabled || orderedListDisabled !== pluginState.orderedListDisabled) {
        const nextPluginState = {
            ...pluginState,
            bulletListActive: bulletListActive,
            orderedListActive: orderedListActive,
            bulletListDisabled: bulletListDisabled,
            orderedListDisabled: orderedListDisabled
        };
        return nextPluginState;
    }
    return pluginState;
};
const $b256c440ca92af07$var$reducer = ()=>(state)=>{
        return state;
    };
const $b256c440ca92af07$var$createInitialState = (featureFlags, api)=>(state)=>{
        const isToolbarAIFCEnabled = Boolean(api?.toolbar);
        const getInitialDecorations = ()=>{
            (0, $enDkL.insm).session?.startFeature('listDecorationsInit');
            const decorations = $b256c440ca92af07$export$97e020a829527f8b(state.doc);
            (0, $enDkL.insm).session?.endFeature('listDecorationsInit');
            return decorations;
        };
        return {
            // When plugin is initialised, editor state is defined with selection
            // hence returning the list state based on the selection to avoid list button in primary toolbar flickering during initial load
            ...isToolbarAIFCEnabled && (0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_patch_3', 'isEnabled', true) ? $b256c440ca92af07$var$getListState(state.doc, state.selection) : $b256c440ca92af07$var$initialState,
            decorationSet: (0, $cbSL1.expValEquals)('platform_editor_new_list_decorations_logic', 'isEnabled', true) ? (0, $b7EWj.DecorationSet).empty.add(state.doc, getInitialDecorations()) : $b256c440ca92af07$export$968abecb43309c32(state.doc, state, featureFlags)
        };
    };
const $b256c440ca92af07$export$ae829ec7b2625219 = (eventDispatch, featureFlags, api)=>{
    const { getPluginState: getPluginState, createPluginState: createPluginState } = (0, $bazog.pluginFactory)($b256c440ca92af07$var$listPluginKey, $b256c440ca92af07$var$reducer(), {
        onDocChanged: $b256c440ca92af07$var$handleDocChanged(featureFlags),
        onSelectionChanged: $b256c440ca92af07$var$handleSelectionChanged
    });
    const pluginState = createPluginState(eventDispatch, $b256c440ca92af07$var$createInitialState(featureFlags, api));
    const pluginStateInit = (_, state)=>{
        return $b256c440ca92af07$var$createInitialState(featureFlags)(state);
    };
    const pluginStateApply = (tr, oldPluginState, _oldEditorState, _newEditorState)=>{
        let nextPluginState = oldPluginState;
        if (tr.docChanged) {
            nextPluginState = $b256c440ca92af07$var$handleSelectionChanged(tr, nextPluginState);
            (0, $enDkL.insm).session?.startFeature('listDecorationUpdate');
            const nextDecorationSet = $b256c440ca92af07$export$7401dd42ebfee9d(nextPluginState.decorationSet, tr);
            (0, $enDkL.insm).session?.endFeature('listDecorationUpdate');
            nextPluginState = {
                ...nextPluginState,
                decorationSet: nextDecorationSet
            };
        } else if (tr.selectionSet) nextPluginState = $b256c440ca92af07$var$handleSelectionChanged(tr, nextPluginState);
        if (nextPluginState !== oldPluginState) eventDispatch($b256c440ca92af07$var$listPluginKey, nextPluginState);
        return nextPluginState;
    };
    return new (0, $i8KtF.SafePlugin)({
        state: {
            init: (0, $cbSL1.expValEquals)('platform_editor_new_list_decorations_logic', 'isEnabled', true) ? pluginStateInit : pluginState.init,
            apply: (0, $cbSL1.expValEquals)('platform_editor_new_list_decorations_logic', 'isEnabled', true) ? pluginStateApply : pluginState.apply
        },
        key: $b256c440ca92af07$var$listPluginKey,
        props: {
            decorations (state) {
                const { decorationSet: decorationSet } = (0, $cbSL1.expValEquals)('platform_editor_new_list_decorations_logic', 'isEnabled', true) ? $b256c440ca92af07$var$listPluginKey.getState(state) : getPluginState(state);
                return decorationSet;
            },
            handleClick: (view, pos, event)=>{
                const { state: state } = view;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                if ([
                    'LI',
                    'UL'
                ].includes((event?.target).tagName)) {
                    const nodeAtPos = state.tr.doc.nodeAt(pos);
                    const { listItem: listItem, codeBlock: codeBlock } = view.state.schema.nodes;
                    if (nodeAtPos?.type === listItem && nodeAtPos?.firstChild?.type === codeBlock) {
                        const bufferPx = 50;
                        const isCodeBlockNextToListMarker = Boolean(document?.elementFromPoint(event.clientX + ((0, $kvnqO.listItemCounterPadding) + bufferPx), event.clientY)?.closest(`.${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`));
                        if (isCodeBlockNextToListMarker) {
                            // +1 needed to put cursor inside li
                            // otherwise gap cursor markup will be injected as immediate child of ul resulting in invalid html
                            (0, $6zZWQ.setGapCursorSelection)(view, pos + 1, (0, $6BNUN.Side).LEFT);
                            return true;
                        }
                    }
                }
                return false;
            }
        }
    });
};

});
parcelRegister("enDkL", function(module, exports) {
$parcel$export(module.exports, "insm", () => $a4e6093359dda159$export$2945ea0ab201da79);

var $6RN0v = parcelRequire("6RN0v");
let $a4e6093359dda159$var$initialisedInsm;
function $a4e6093359dda159$export$2cd8252107eb640b(options) {
    $a4e6093359dda159$var$initialisedInsm = new (0, $6RN0v.INSM)(options);
}
function $a4e6093359dda159$var$insmInitialised() {
    if (!$a4e6093359dda159$var$initialisedInsm) return false;
    return true;
}
const $a4e6093359dda159$export$2945ea0ab201da79 = {
    startHeavyTask (heavyTaskName) {
        if ($a4e6093359dda159$var$insmInitialised()) $a4e6093359dda159$var$initialisedInsm.startHeavyTask(heavyTaskName);
    },
    endHeavyTask (heavyTaskName) {
        if ($a4e6093359dda159$var$insmInitialised()) $a4e6093359dda159$var$initialisedInsm.endHeavyTask(heavyTaskName);
    },
    start (experienceKey, experienceProperties) {
        if ($a4e6093359dda159$var$insmInitialised()) $a4e6093359dda159$var$initialisedInsm.start(experienceKey, experienceProperties);
    },
    overrideExperienceKey (experienceKey) {
        if ($a4e6093359dda159$var$insmInitialised()) $a4e6093359dda159$var$initialisedInsm.overrideExperienceKey(experienceKey);
    },
    stopEarly (reasonKey, description) {
        if ($a4e6093359dda159$var$insmInitialised()) $a4e6093359dda159$var$initialisedInsm.stopEarly(reasonKey, description);
    },
    // We only expose details and feature start/stop to consumers
    // as the other properties are internals for the insm and InsmPeriod
    // to interact with the running session.
    get session () {
        if ($a4e6093359dda159$var$insmInitialised()) return $a4e6093359dda159$var$initialisedInsm.runningSession;
    },
    // @ts-expect-error Private method for testing purposes
    __setAnalyticsWebClient (analyticsWebClient) {
        if ($a4e6093359dda159$var$initialisedInsm) $a4e6093359dda159$var$initialisedInsm.analyticsWebClient = analyticsWebClient;
    }
};

});
parcelRegister("6RN0v", function(module, exports) {
$parcel$export(module.exports, "INSM", () => $3ffcf231175fb5c3$export$4b79d93e0c782a13);

var $brZK0 = parcelRequire("brZK0");

var $4mgwb = parcelRequire("4mgwb");

var $eGFqP = parcelRequire("eGFqP");

var $cbSL1 = parcelRequire("cbSL1");
class $3ffcf231175fb5c3$export$4b79d93e0c782a13 {
    constructor(options){
        /**
	 * Heavy tasks are tracked at the insm layer as heavy tasks
	 * are expected at times to be unrelated to the current
	 * page session.
	 */ this.runningHeavyTasks = new Set();
        this.periodMeasurers = [
            new (0, $4mgwb.AnimationFPSIM)(),
            new (0, $eGFqP.INPTracker)()
        ];
        this.options = options;
        // If this does throw -- we do want an unhandledRejection rejection to be passed to the window
        // this is to ease debugging.
        options.getAnalyticsWebClient.then((analyticsWebClient)=>this.analyticsWebClient = analyticsWebClient);
        // No cleanup needs to be performed -- as this tooling is intended to run until the tab is closed
        // The use of beforeunload here is because using pagehide does not reliably result in the analytics
        // being fired by the analytics web client.
        // The use of this means we will miss events from mobile safari which does not reliably call this api
        // however mobile browsers do not call when a browser closes - so we expect limited mobile data from
        // this tooling in its current form.
        // window will not be defined in server envs - in these envs -- there can never be a session end
        if (typeof window !== 'undefined') // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('beforeunload', ()=>{
            this.runningSession?.end({
                stoppedBy: 'beforeunload'
            });
        });
    }
    /**
	 * Starts a heavy task in the currently running session.
	 *
	 * This also pauses measurement.
	 *
	 * For PageLoads using the key 'PageLoad' will mean the heavy task duration
	 * is added to the insm session event as pageLoadTime.
	 */ startHeavyTask(heavyTaskName) {
        this.runningHeavyTasks.add(heavyTaskName);
        this.runningSession?.periodTracking?.startHeavyTask(heavyTaskName);
        this.runningSession?.periodTracking.pause(heavyTaskName);
        this.runningSession?.longAnimationFrameMeasurer.pause();
    }
    /**
	 * Ends a heavy task in the currently running session
	 */ endHeavyTask(heavyTaskName) {
        this.runningHeavyTasks.delete(heavyTaskName);
        this.runningSession?.periodTracking.resume(heavyTaskName);
        if (this.runningHeavyTasks.size === 0) this.runningSession?.longAnimationFrameMeasurer.resume();
        if ((0, $cbSL1.expValEquals)('cc_editor_insm_outlier_events', 'cohort', 'test')) {
            if (heavyTaskName === 'PageLoad') this.runningSession?.completePageLoad();
        }
    }
    /**
	 * Call this when starting a new experience.  This is expected to be wired to the product
	 * routing solution.
	 *
	 * It's expected this call will be paired with a `insm.session.startHeavyTask('PageLoad')` and
	 * subsequent `insm.session.endHeavyTask('PageLoad')` so that performance degradations linked
	 * to the page initialisation are excluded from the active interactivity monitoring.
	 *
	 * Using the key 'PageLoad' is special and will result in the heavy task duration being added to the
	 * insm session event as pageLoadTime.
	 *
	 *
	 * ```ts
	 * insm.start('edit-page', { initial: true, contentId: '9001' })
	 * insm.session.startHeavyTask('PageLoad')
	 * // ... heavy initialisation work
	 * insm.session.endHeavyTask('PageLoad')
	 * ```
	 */ start(experienceKey, experienceProperties) {
        if (this.runningSession !== undefined) this.runningSession.end({
            stoppedBy: 'new-experience',
            experienceKey: experienceKey,
            contentId: experienceProperties.contentId
        });
        this.lastStartedExperienceProperties = experienceProperties;
        if (this.options.experiences[experienceKey]?.enabled) this.runningSession = new (0, $brZK0.INSMSession)(experienceKey, experienceProperties, this);
    }
    /**
	 * Call this to update the name of the running session after it's started
	 * In the case it's been started with an unregistered name, and there is not running
	 * session. This will also trigger the session being started.
	 */ overrideExperienceKey(experienceKey) {
        if (this.runningSession !== undefined) // If there is a running session - we update its name
        this.runningSession.updateExperienceKey(experienceKey);
        else // otherwise - we assume the last session was not registered, and start it with the new name
        if (this.options.experiences[experienceKey]?.enabled && this.lastStartedExperienceProperties) this.runningSession = new (0, $brZK0.INSMSession)(experienceKey, this.lastStartedExperienceProperties, this);
    }
    /**
	 * This prematurely halts any running experience measurement. It's expected to be used in
	 * scenarios such as when error boundaries are hit.
	 */ stopEarly(reasonKey, description) {
        this.runningSession?.earlyStop(reasonKey, description);
    }
    /**
	 * Gets the current running session details
	 */ get session() {
        return this.runningSession;
    }
}

});
parcelRegister("brZK0", function(module, exports) {
$parcel$export(module.exports, "INSMSession", () => $e35755ea9bcaf065$export$15db790bb6e6f6d1);

var $3nEAz = parcelRequire("3nEAz");

var $cbSL1 = parcelRequire("cbSL1");

var $7Ydlg = parcelRequire("7Ydlg");

var $hJD9Z = parcelRequire("hJD9Z");
class $e35755ea9bcaf065$export$15db790bb6e6f6d1 {
    constructor(experienceKey, experienceProperties, insm){
        this.startedAt = performance.now();
        this.pageLoadTime = null;
        this.running = true;
        this.addedProperties = [];
        this.runningFeatures = new Set();
        this.experienceKey = experienceKey;
        this.experienceProperties = experienceProperties;
        this.insm = insm;
        this.periodTracking = new (0, $7Ydlg.PeriodTracking)(this);
        this.longAnimationFrameMeasurer = new (0, $hJD9Z.LongAnimationFrameMeasurer)({
            initial: this.experienceProperties.initial,
            limit: 3,
            insmSession: this,
            reportingThreshold: 500
        });
    }
    /**
	 * Completes the page load timing. This is called automatically when ending a heavy task
	 * with the key 'PageLoad'.
	 */ completePageLoad() {
        this.pageLoadTime = performance.now() - this.startedAt;
    }
    updateExperienceKey(experienceKey) {
        this.experienceKey = experienceKey;
    }
    /**
	 * Adds a feature to the currently running session
	 */ startFeature(featureName) {
        this.runningFeatures.add(featureName);
        this.periodTracking?.startFeature(featureName);
    }
    /**
	 * Ends a features usage in the currently running session
	 */ endFeature(featureName) {
        this.runningFeatures.delete(featureName);
    }
    /**
	 * Returns details on the current session.
	 */ get details() {
        return {
            experienceKey: this.experienceKey,
            experienceProperties: this.experienceProperties,
            paused: this.periodTracking.pauses.size > 0,
            periodState: this.periodTracking.state,
            /**
			 * The only scenario where this value should return false is when
			 * the experience has been stopped early.
			 */ running: this.running
        };
    }
    /**
	 * This api takes either a static single-level key-value object, or callbacks which return the same and
	 * will be evaluated on session end.
	 *
	 * When ending a session, all properties received via this api are merged, in order, into the resulting
	 * insm event’s properties; last write wins.
	 *
	 * Callback values are evaluated at session end.
	 *
	 * For example, for the following
	 *
	 * ```ts
	 * insm.experience.addProperties({ one: 1, two: 2 });
	 * insm.experience.addProperties(() => ({ one: 'one' }));
	 * insm.experience.addProperties({ three: 3 });
	 * ```
	 *
	 * The resulting added properties will be
	 *
	 * ```ts
	 * { one: 'one', two: 2, three: 3 }
	 * ```
	 */ addProperties(propertiesToAdd) {
        this.addedProperties.push(propertiesToAdd);
    }
    /**
	 * In some scenarios (ie. when a page error boundary is hit), you will want to exit early.
	 * This is api supports these scenarios
	 *
	 * ```ts
	 * insm.stopEarly(reasonKey: string, description: string);
	 * ```
	 *
	 * Sessions closed early are identifiable by their end details
	 * `"endDetails": { stoppedBy: "early-stop", reasonKey, description }`.
	 *
	 * **Note**: The session is ended as soon as this is called, and any `addProperties` handlers will
	 * called immediately.
	 */ earlyStop(reason, description) {
        this.end({
            stoppedBy: 'early-stop',
            reason: reason,
            description: description
        });
    }
    end(endDetails) {
        if (this.running === false) // If an experience has already been ended -- don't repeat the ending
        return;
        this.running = false;
        const endedAt = performance.now();
        const duration = endedAt - this.startedAt;
        const evaluatedAddedProperties = {};
        for (const addedProperty of this.addedProperties)if (typeof addedProperty === 'function') Object.assign(evaluatedAddedProperties, addedProperty());
        else Object.assign(evaluatedAddedProperties, addedProperty);
        const periodResults = this.periodTracking.endResults;
        /**
		 * This event ends up as "insm measured"
		 */ const operationalEvent = {
            actionSubject: 'insm',
            action: 'measured',
            attributes: {
                // Added first to ensure these don't overwrite any insm properties
                ...evaluatedAddedProperties,
                experienceKey: this.experienceKey,
                initial: this.experienceProperties.initial,
                contentId: this.experienceProperties.contentId,
                timing: {
                    startedAt: this.startedAt,
                    duration: // Note: this will not match up with the periods sum of durations, as it includes
                    // time paused when heavy tasks were running, and/or the page is in the background.
                    duration
                },
                periods: periodResults,
                endDetails: endDetails,
                ...(0, $cbSL1.expValEquals)('cc_editor_insm_outlier_events', 'cohort', 'test') ? {
                    longScripts: this.longAnimationFrameMeasurer.current,
                    pageLoadTime: this.pageLoadTime,
                    deviceDetails: $e35755ea9bcaf065$var$getDeviceDetails()
                } : {},
                // these health attributes drive our SLOs
                healthAFPS: periodResults.active.measurements.afps?.average ? periodResults.active.measurements.afps?.average >= 50 : undefined,
                healthINP: periodResults.active.measurements.inp?.average ? periodResults.active.measurements.inp?.average >= 200 : undefined
            },
            highPriority: true,
            tags: [
                'editor'
            ],
            source: 'unknown'
        };
        this.insm.analyticsWebClient?.sendOperationalEvent(operationalEvent);
        this.longAnimationFrameMeasurer.cleanup();
    }
}
// Functionality vendored from UFO
function $e35755ea9bcaf065$var$getDeviceDetails() {
    const telemetry = {};
    // /platform/packages/data/ufo-internal/src/core/publisher/plugins/browser.ts
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3nEAz))).getParser) {
        const browser = (0, (/*@__PURE__*/$parcel$interopDefault($3nEAz))).getParser((typeof window !== 'undefined' && !!window ? window : undefined)?.navigator?.userAgent || '');
        Object.assign(telemetry, {
            'event:browser:name': browser.getBrowserName(),
            'event:browser:version': browser.getBrowserVersion()
        });
    }
    // /platform/packages/data/ufo-internal/src/core/publisher/plugins/cpus.ts
    Object.assign(telemetry, {
        'event:cpus': navigator.hardwareConcurrency
    });
    // /platform/packages/data/ufo-internal/src/core/publisher/plugins/memory.ts
    // @ts-ignore: deviceMemory is exposed in some browsers
    Object.assign(telemetry, {
        'event:memory': navigator.deviceMemory
    });
    // /platform/packages/data/ufo-internal/src/core/publisher/plugins/network.ts
    Object.assign(telemetry, {
        // Network
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:effectiveType': navigator.connection?.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:rtt': navigator.connection?.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:downlink': navigator.connection?.downlink
    });
    return telemetry;
}

});
parcelRegister("7Ydlg", function(module, exports) {
$parcel$export(module.exports, "PeriodTracking", () => $c29fdba45df1dbd3$export$715a4ea2578407b6);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $eGOwo = parcelRequire("eGOwo");
class $c29fdba45df1dbd3$export$715a4ea2578407b6 {
    constructor(session){
        this.periodMeasurements = {
            active: {
                features: new Set(),
                heavyTasks: new Set(),
                measurements: {},
                duration: 0,
                count: 0
            },
            inactive: {
                features: new Set(),
                heavyTasks: new Set(),
                measurements: {},
                duration: 0,
                count: 0
            }
        };
        this.state = 'inactive';
        this.pauses = new Set();
        /**
	 * Warning: this can be reset mid period when pausing/resuming.
	 * It's intended use is to build the `periodMeasurements` duration.
	 */ this.currentPeriodStart = performance.now();
        this.activeStartListeners = [];
        this.activeEndListeners = [];
        /**
	 * This works by;
	 * On setup
	 * - starts activity listeners
	 *   - on activity received
	 *     - possible end active count down started.
	 *       3 animation frames or 3 seconds of inactivity - whichever comes first
	 *     - any existing end count down ended
	 */ this.activeEndCountDownAbortController = new AbortController();
        this.session = session;
        this.latestPeriodFeatures = new Set(session.runningFeatures);
        this.latestHeavyTasks = new Set(session.insm.runningHeavyTasks);
        this.pauses = new Set(session.insm.runningHeavyTasks);
        const startInteractivityMeasuresPaused = this.latestHeavyTasks.size !== 0;
        for (const periodMeasurer of session.insm.periodMeasurers){
            periodMeasurer.start(startInteractivityMeasuresPaused);
            this.periodMeasurements.active.measurements[periodMeasurer.name] = {
                numerator: 0,
                denominator: 0,
                max: 0,
                min: 0,
                average: 0
            };
            this.periodMeasurements.inactive.measurements[periodMeasurer.name] = {
                numerator: 0,
                denominator: 0,
                max: 0,
                min: 0,
                average: 0
            };
        }
        this.setupActiveStartInteractionListeners();
    }
    startFeature(featureName) {
        this.latestPeriodFeatures.add(featureName);
        this.periodMeasurements[this.state].features.add(featureName);
    }
    startHeavyTask(heavyTaskName) {
        this.latestHeavyTasks.add(heavyTaskName);
        this.periodMeasurements[this.state].heavyTasks.add(heavyTaskName);
        this.pause(heavyTaskName);
    }
    endHeavyTask(heavyTaskName) {
        this.resume(heavyTaskName);
    }
    /**
	 * Sets a pause based on a key.  If this is the first pause, then it will also halt
	 * running interactivity measures, and update the current measurements duration.
	 */ pause(pauseName) {
        if (this.pauses.size === 0) {
            this.periodMeasurements[this.state].duration = this.periodMeasurements[this.state].duration + (performance.now() - this.currentPeriodStart);
            for (const periodMeasurer of this.session.insm.periodMeasurers)periodMeasurer.pause();
        }
        this.pauses.add(pauseName);
    }
    /**
	 * Releases a pause for a key.
	 *
	 * **NOTE**: The session will only resume if this was the only
	 * currently tracked pause key.
	 */ resume(pauseName) {
        this.pauses.delete(pauseName);
        if (this.pauses.size === 0) {
            this.currentPeriodStart = performance.now();
            for (const periodMeasurer of this.session.insm.periodMeasurers)periodMeasurer.resume();
        }
    }
    get endResults() {
        this.changePeriodAndTrackLast(this.state);
        if ((0, $eGOwo.fg)('cc_editor_insm_fix_attributes')) return {
            active: {
                features: Array.from(this.periodMeasurements.active.features),
                heavyTasks: Array.from(this.periodMeasurements.active.heavyTasks),
                measurements: this.periodMeasurements.active.measurements,
                duration: this.periodMeasurements.active.duration,
                count: this.periodMeasurements.active.count
            },
            inactive: {
                features: Array.from(this.periodMeasurements.inactive.features),
                heavyTasks: Array.from(this.periodMeasurements.inactive.heavyTasks),
                measurements: this.periodMeasurements.inactive.measurements,
                duration: this.periodMeasurements.inactive.duration,
                count: this.periodMeasurements.inactive.count
            }
        };
        return this.periodMeasurements;
    }
    setupActiveStartInteractionListeners() {
        const events = [
            'mousemove',
            'pointerdown',
            'pointerup',
            'click',
            'keydown',
            'keyup',
            'scroll'
        ];
        for (const event of events){
            const eventListener = ()=>{
                // start event
                this.changePeriodAndTrackLast('inactive', 'active');
            };
            window.addEventListener(event, eventListener, {
                once: true
            });
            this.activeStartListeners.push([
                event,
                eventListener
            ]);
        }
    }
    setupEndActiveInteractionListeners() {
        this.activeEndCountDownVisibilityListener = ()=>{
            if (document.visibilityState === 'hidden') endSession();
        };
        window.addEventListener('visibilitychange', this.activeEndCountDownVisibilityListener);
        const events = [
            'mousemove',
            'pointerdown',
            'pointerup',
            'click',
            'keydown',
            'keyup',
            'scroll'
        ];
        for (const event of events){
            const eventListener = ()=>{
                this.activeEndCountDownAbortController.abort();
                this.activeEndCountDownAbortController = new AbortController();
                $c29fdba45df1dbd3$var$startPeriodEndCountDown(this.activeEndCountDownAbortController.signal, ()=>{
                    endSession();
                });
            };
            window.addEventListener(event, eventListener);
            this.activeEndListeners.push([
                event,
                eventListener
            ]);
        }
        const endSession = ()=>{
            this.activeEndCountDownAbortController.abort();
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            window.removeEventListener('visibilitychange', this.activeEndCountDownVisibilityListener);
            for (const activeEndListener of this.activeEndListeners)window.removeEventListener(activeEndListener[0], activeEndListener[1]);
            this.changePeriodAndTrackLast('active', 'inactive');
        };
        // When first setting up -- there has just been an interaction -- so we start a countdown
        this.activeEndCountDownAbortController.abort();
        this.activeEndCountDownAbortController = new AbortController();
        $c29fdba45df1dbd3$var$startPeriodEndCountDown(this.activeEndCountDownAbortController.signal, ()=>{
            endSession();
        });
    }
    changePeriodAndTrackLast(lastPeriod, newPeriod) {
        this.periodMeasurements[lastPeriod].duration = this.periodMeasurements[lastPeriod].duration + (performance.now() - this.currentPeriodStart);
        this.periodMeasurements[lastPeriod].count++;
        const interactivityMeasuresPaused = this.latestHeavyTasks.size !== 0;
        for (const interactivityMeasure of this.session.insm.periodMeasurers){
            const finalResult = newPeriod ? interactivityMeasure.start(interactivityMeasuresPaused) : interactivityMeasure.end();
            const tracked = this.periodMeasurements[lastPeriod].measurements[interactivityMeasure.name];
            if (finalResult.average === 0) ;
            else if (tracked.average === 0) // In this case -- we haven't had any entries come through yet - so we replace any existing entries
            this.periodMeasurements[lastPeriod].measurements[interactivityMeasure.name] = finalResult;
            else {
                // In this case there is a new measurement which we merge with the previous measurement
                const merged = {
                    numerator: finalResult.numerator + tracked.numerator,
                    denominator: finalResult.denominator + tracked.denominator,
                    average: (finalResult.numerator + tracked.numerator) / (finalResult.denominator + tracked.denominator),
                    max: tracked.max === 0 || finalResult.max > tracked.max ? finalResult.max : tracked.max,
                    min: tracked.min === 0 || finalResult.min < tracked.min ? finalResult.min : tracked.min
                };
                this.periodMeasurements[lastPeriod].measurements[interactivityMeasure.name] = merged;
            }
        }
        for (const listener of this.activeStartListeners)window.removeEventListener(listener[0], listener[1]);
        for (const listener of this.activeEndListeners)window.removeEventListener(listener[0], listener[1]);
        this.activeEndCountDownAbortController?.abort();
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        window.removeEventListener('visibilitychange', this.activeEndCountDownVisibilityListener);
        if (newPeriod) {
            this.latestPeriodFeatures = new Set(this.session.runningFeatures);
            this.session.runningFeatures.forEach((featureName)=>{
                this.periodMeasurements[newPeriod].features.add(featureName);
            });
            this.latestHeavyTasks = new Set(this.session.insm.runningHeavyTasks);
            this.currentPeriodStart = performance.now();
            switch(newPeriod){
                case 'active':
                    this.setupEndActiveInteractionListeners();
                    this.state = 'active';
                    break;
                case 'inactive':
                    this.setupActiveStartInteractionListeners();
                    this.state = 'inactive';
                    break;
            }
        }
    }
}
function $c29fdba45df1dbd3$var$startPeriodEndCountDown(signal, handleEnd) {
    let animationFramesSinceLastInteraction = 0;
    let inactiveTimeReached = false;
    let timer;
    let animationFrameHandler;
    const monitorAnimationFrames = ()=>{
        animationFrameHandler = requestAnimationFrame(()=>{
            animationFramesSinceLastInteraction++;
            if (animationFramesSinceLastInteraction < 3) monitorAnimationFrames();
            else if (inactiveTimeReached) handleEnd();
        });
    };
    const monitorTime = ()=>{
        timer = setTimeout(()=>{
            inactiveTimeReached = true;
            if (animationFramesSinceLastInteraction === 3) handleEnd();
        }, 3000);
    };
    monitorTime();
    monitorAnimationFrames();
    signal.addEventListener('abort', ()=>{
        clearTimeout(timer);
        cancelAnimationFrame(animationFrameHandler);
    });
}

});

parcelRegister("hJD9Z", function(module, exports) {
$parcel$export(module.exports, "LongAnimationFrameMeasurer", () => $d6c2cb4e299c8bec$export$c53843efd6e2e499);
class $d6c2cb4e299c8bec$export$c53843efd6e2e499 {
    constructor(options){
        this.longestScriptTimings = [];
        this.minimumIndex = -1;
        this.minimumDuration = Infinity;
        this.options = options;
        this.paused = options.insmSession.insm.runningHeavyTasks.size !== 0;
        if (PerformanceObserver.supportedEntryTypes.includes('long-animation-frame')) {
            this.observer = new PerformanceObserver((list)=>{
                if (!this.paused) // only handle batches when tracking is not paused
                this.handleBatch(list.getEntries());
            });
            this.observer.observe({
                type: 'long-animation-frame',
                buffered: options.initial
            });
        }
    }
    handleBatch(batch) {
        for(let batchIndex = 0; batchIndex < batch.length; batchIndex++){
            const animationFrame = batch[batchIndex];
            // Only process frames that exceed the reporting threshold
            if (animationFrame.duration < this.options.reportingThreshold) continue;
            // Process all scripts in this long animation frame
            if (animationFrame.scripts && animationFrame.scripts.length > 0) for (const script of animationFrame.scripts)this.processScript(script, animationFrame);
        }
    }
    createScriptTiming(script, animationFrame) {
        return {
            duration: script.duration,
            forcedStyleAndLayoutDuration: script.forcedStyleAndLayoutDuration,
            invoker: script.invoker,
            invokerType: script.invokerType,
            sourceCharPosition: script.sourceCharPosition,
            sourceFunctionName: script.sourceFunctionName,
            sourceURL: script.sourceURL,
            features: Array.from(this.options.insmSession.runningFeatures),
            afDuration: animationFrame.duration
        };
    }
    processScript(script, animationFrame) {
        const scriptDuration = script.duration;
        const len = this.longestScriptTimings.length;
        // Not yet at capacity: append and update min tracking incrementally
        if (len < this.options.limit) {
            const scriptTiming = this.createScriptTiming(script, animationFrame);
            this.longestScriptTimings[len] = scriptTiming;
            if (len === 0 || scriptDuration < this.minimumDuration) {
                this.minimumDuration = scriptDuration;
                this.minimumIndex = len;
            }
            return;
        }
        // At capacity: only do work if we beat the current min
        if (scriptDuration <= this.minimumDuration) return;
        const scriptTiming = this.createScriptTiming(script, animationFrame);
        // Replace the current min
        this.longestScriptTimings[this.minimumIndex] = scriptTiming;
        // Find new minimum
        let newMinimumIndex = 0;
        let newMinimumDuration = this.longestScriptTimings[0].duration;
        for(let i = 1; i < this.options.limit; i++)if (this.longestScriptTimings[i].duration < newMinimumDuration) {
            newMinimumIndex = i;
            newMinimumDuration = this.longestScriptTimings[i].duration;
        }
        // Update the min tracking
        this.minimumIndex = newMinimumIndex;
        this.minimumDuration = newMinimumDuration;
    }
    /**
	 * Pauses tracking
	 */ pause() {
        this.paused = true;
    }
    /**
	 * Resumes tracking
	 */ resume() {
        this.paused = false;
    }
    /**
	 * Returns the current tracked longest script timings sorted by duration
	 */ get current() {
        const copy = this.longestScriptTimings.slice();
        copy.sort((a, b)=>b.duration - a.duration);
        return copy;
    }
    /**
	 * Cleans up the performance tracking (tracking cannot be resumed following this).
	 */ cleanup() {
        this.observer?.disconnect();
    }
}

});


parcelRegister("4mgwb", function(module, exports) {
$parcel$export(module.exports, "AnimationFPSIM", () => $542ac3fa2d4d373e$export$dcf27b52d88d889b);
class $542ac3fa2d4d373e$export$dcf27b52d88d889b {
    start(paused) {
        const result = this.monitor.startNewWindow(paused);
        return result;
    }
    end() {
        const result = this.monitor.end();
        return result;
    }
    pause() {
        this.monitor.pause();
    }
    resume() {
        this.monitor.resume();
    }
    constructor(){
        /**
	 * AFPS stands for Animation Frames Per Second
	 */ this.name = 'afps';
        this.monitor = new $542ac3fa2d4d373e$var$AnimationFPSMonitor();
    }
}
class $542ac3fa2d4d373e$var$AnimationFPSMonitor {
    measureWindowFPS() {
        // Calculate FPS for this window
        // Note: windowFrameCount and windowTotalTime is reset after each window measurement
        const windowSeconds = this.windowTotalTime / 1000;
        // frames / seconds
        const windowFPS = this.windowFrameCount / windowSeconds;
        // Update overall tracking
        this.currentState.numerator += this.windowFrameCount;
        // The denominator is seconds not ms
        this.currentState.denominator += windowSeconds;
        // Calculate overall average FPS: (total frames / total time measured in seconds
        this.currentState.average = this.currentState.numerator / this.currentState.denominator;
        if (this.currentState.max === 0 || windowFPS > this.currentState.max) this.currentState.max = windowFPS;
        if (this.currentState.min === 0 || windowFPS < this.currentState.min) this.currentState.min = windowFPS;
    }
    /**
	 * If there is running tracking - it will be reset
	 */ startWindowTracking() {
        // Clear any previous tracking state
        this.resetOverallTracking();
        const measureFrame = ()=>{
            this.currentFrameStart = $parcel$global.performance.now();
            this.animationFrame = requestAnimationFrame(()=>{
                // While measurement is paused -- we don't count the animation frame towards the monitored
                // period.
                if (!this.paused) {
                    const frameDuration = performance.now() - this.currentFrameStart;
                    // Add frame to current window
                    this.windowFrameCount++;
                    this.windowTotalTime += frameDuration;
                    // Check if window is >= 1 second (1000ms)
                    // When the page is running smoothly it's expected this will not be hit frequently
                    if (this.windowTotalTime >= 1000) {
                        this.measureWindowFPS();
                        // Reset window for next measurement
                        this.resetWindow();
                    }
                }
                measureFrame();
            });
        };
        measureFrame();
    }
    startNewWindow(paused) {
        const lastWindowResult = {
            numerator: this.currentState.numerator,
            denominator: this.currentState.denominator,
            max: this.currentState.max,
            min: this.currentState.min,
            average: this.currentState.average
        };
        this.paused = paused;
        this.startWindowTracking();
        return lastWindowResult;
    }
    resetWindow() {
        this.windowFrameCount = 0;
        this.windowTotalTime = 0;
    // Note this.currentFrameStart is over ridden
    // as part of tracking - so does not need to be
    // reset.
    }
    endWindowTracking() {
        if (this.animationFrame) cancelAnimationFrame(this.animationFrame);
    }
    resetOverallTracking() {
        this.resetWindow();
        this.endWindowTracking();
        this.currentState = {
            numerator: 0,
            denominator: 0,
            max: 0,
            min: 0,
            average: 0
        };
    }
    end() {
        try {
            this.measureWindowFPS();
            return this.currentState;
        } finally{
            this.resetOverallTracking();
        }
    }
    pause() {
        // Note - we leave the tracking animationFrame monitoring running, and on resume
        // simply set the currentFrameStart and paused to true
        // This works because the tracking builds windows of tracked time rather than
        // basing itself off a window start time and time elapsed time since then.
        this.paused = true;
    }
    resume() {
        // Note - We don't need to handle the gap in measurement - as the raf logic builds/increments a window time
        // based on the currentFrameStart (and any previous measurements which can only happen while the tracking
        // is not paused).
        this.currentFrameStart = performance.now();
        this.paused = false;
        if (!this.animationFrame) this.startWindowTracking();
    }
    constructor(){
        this.paused = false;
        this.currentState = {
            numerator: 0,
            denominator: 0,
            max: 0,
            average: 0,
            min: 0
        };
        // Current measurement window
        this.windowFrameCount = 0;
        this.windowTotalTime = 0;
        this.currentFrameStart = 0;
    }
}

});

parcelRegister("eGFqP", function(module, exports) {
$parcel$export(module.exports, "INPTracker", () => $78ffdfd8930274f7$export$4551d640419205b3);
class $78ffdfd8930274f7$export$4551d640419205b3 {
    constructor(options){
        /**
	 * INP stands for Interaction to Next Paint
	 */ this.name = 'inp';
        this.includedInteractions = options?.includedInteractions || [
            'pointerdown',
            'pointerup',
            'click',
            'keydown',
            'keyup'
        ];
        this.monitor = new $78ffdfd8930274f7$var$InteractionTracker(this.includedInteractions);
    }
    start(paused) {
        const result = this.monitor.start(paused);
        return result;
    }
    end() {
        const result = this.monitor.end();
        return result;
    }
    pause() {
        this.monitor.pause();
    }
    resume() {
        this.monitor.resume();
    }
}
class $78ffdfd8930274f7$var$InteractionResult {
    constructor(){
        this.min = Infinity;
        this.max = 0;
        this.average = 0;
        this.numerator = 0;
        this.count = 0;
    }
    update(duration) {
        if (duration > this.max) this.max = duration;
        if (duration < this.min) this.min = duration;
        this.numerator += duration;
        this.count += 1;
        this.average = this.numerator / this.count;
    }
    toMeasure() {
        return {
            min: this.count === 0 ? 0 : this.min,
            max: this.max,
            average: this.average,
            numerator: this.numerator,
            denominator: this.count
        };
    }
}
class $78ffdfd8930274f7$var$InteractionTracker {
    constructor(includedInteractions){
        this.paused = false;
        this.performanceObserver = null;
        this.interactionResult = new $78ffdfd8930274f7$var$InteractionResult();
        this.includedInteractions = includedInteractions;
    }
    stopTracking() {
        this.performanceObserver?.disconnect();
        this.performanceObserver = null;
    }
    startTracking() {
        this.performanceObserver = new PerformanceObserver((list)=>{
            // Note: find link to actual safari issue .. good to get rid of this if Safari has fixed this
            // Delay by a microtask to workaround a bug in Safari where the
            // callback is invoked immediately, rather than in a separate task.
            // See: https://github.com/GoogleChrome/web-vitals/issues/277
            Promise.resolve().then(()=>{
                const entries = list.getEntries();
                entries.forEach((entry)=>{
                    // Skip further processing for entries that cannot be INP candidates.
                    //
                    // When a user interacts with a web page, a user interaction (for example a click) usually triggers a sequence of events.
                    // To measure the latency of this series of events, the events share the same interactionId.
                    // An interactionId is only computed for the following event types belonging to a user interaction. It is 0 otherwise.
                    // * click / tap / drag events: 'pointerdown', 'pointerup', 'click'
                    // * keypress events: 'keydown', 'keyup'
                    //
                    if (!entry.interactionId) return;
                    if (this.includedInteractions.includes(entry.name)) this.interactionResult.update(entry.duration);
                });
            });
        });
        // Event Timing entries have their durations rounded to the nearest 8ms,
        // so a duration of 40ms would be any event that spans 2.5 or more frames
        // at 60Hz. This threshold is chosen to strike a balance between usefulness
        // and performance. Running this callback for any interaction that spans
        // just one or two frames is likely not worth the insight that could be
        // gained.
        if (PerformanceObserver.supportedEntryTypes.includes('event')) this.performanceObserver.observe({
            type: 'event',
            buffered: true,
            durationThreshold: 40
        });
    }
    reset() {
        this.stopTracking();
        this.interactionResult = new $78ffdfd8930274f7$var$InteractionResult();
    }
    start(paused) {
        const lastResult = this.interactionResult.toMeasure();
        this.reset();
        this.paused = paused;
        if (!paused) this.startTracking();
        return lastResult;
    }
    end() {
        try {
            return this.interactionResult.toMeasure();
        } finally{
            this.reset();
        }
    }
    pause() {
        if (this.paused) return;
        this.paused = true;
        this.stopTracking();
    }
    resume() {
        if (!this.paused) return;
        this.paused = false;
        this.startTracking();
    }
}

});




parcelRegister("ftYo6", function(module, exports) {
$parcel$export(module.exports, "getListComponents", () => $379522b1fc535262$export$eb84e5278d4ad5e0);

var $6iVIn = parcelRequire("6iVIn");
var $dzaj1 = parcelRequire("dzaj1");

var $eGOwo = parcelRequire("eGOwo");

var $hW4d0 = parcelRequire("hW4d0");

var $dtOLp = parcelRequire("dtOLp");
const $379522b1fc535262$export$eb84e5278d4ad5e0 = (api)=>{
    return [
        {
            type: 'block-menu-item',
            key: (0, $6iVIn.FORMAT_BULLETED_LIST_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: 'nested-menu-format-section-primary',
                rank: (0, $eGOwo.fg)('platform_editor_block_menu_format_rank_revised') ? (0, $dzaj1.FORMAT_NESTED_MENU_RANK_REVISED)[(0, $6iVIn.FORMAT_BULLETED_LIST_MENU_ITEM).key] : (0, $dzaj1.FORMAT_NESTED_MENU_RANK)[(0, $6iVIn.FORMAT_BULLETED_LIST_MENU_ITEM).key]
            },
            component: (0, $hW4d0.createBulletedListBlockMenuItem)({
                api: api
            })
        },
        {
            type: 'block-menu-item',
            key: (0, $6iVIn.FORMAT_NUMBERED_LIST_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: 'nested-menu-format-section-primary',
                rank: (0, $eGOwo.fg)('platform_editor_block_menu_format_rank_revised') ? (0, $dzaj1.FORMAT_NESTED_MENU_RANK_REVISED)[(0, $6iVIn.FORMAT_NUMBERED_LIST_MENU_ITEM).key] : (0, $dzaj1.FORMAT_NESTED_MENU_RANK)[(0, $6iVIn.FORMAT_NUMBERED_LIST_MENU_ITEM).key]
            },
            component: (0, $dtOLp.createNumberedListBlockMenuItem)({
                api: api
            })
        }
    ];
};

});
parcelRegister("hW4d0", function(module, exports) {
$parcel$export(module.exports, "createBulletedListBlockMenuItem", () => $0331278f28c2c0e6$export$a10d73d60d04133e);
// BulletedListBlockMenuItem.tsx

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bMFKb = parcelRequire("bMFKb");

var $eCOhn = parcelRequire("eCOhn");

var $frlUM = parcelRequire("frlUM");

var $dFLJN = parcelRequire("dFLJN");

var $hJIkn = parcelRequire("hJIkn");
const $0331278f28c2c0e6$var$BulletedListBlockMenuItem = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const bulletListActive = (0, $frlUM.useSharedPluginStateSelector)(api, 'list.bulletListActive');
    const currentSelectedNodeName = (0, $frlUM.useSharedPluginStateSelector)(api, 'blockMenu.currentSelectedNodeName');
    // Check if a blockquote is currently selected
    const isBlockquoteSelected = currentSelectedNodeName?.includes('blockquote');
    // Only show as selected if bullet list is active AND we're not selecting a blockquote
    const isSelected = bulletListActive && !isBlockquoteSelected;
    const handleClick = (event)=>{
        if (!bulletListActive) {
            const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $bMFKb.INPUT_METHOD).KEYBOARD : (0, $bMFKb.INPUT_METHOD).MOUSE;
            const inputMethod = (0, $bMFKb.INPUT_METHOD).BLOCK_MENU;
            api?.core.actions.execute(api?.blockMenu?.commands.formatNode(`bulletList`, {
                inputMethod: inputMethod,
                triggeredFrom: triggeredFrom
            }));
        }
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dFLJN.ToolbarDropdownItem), {
        onClick: handleClick,
        isSelected: isSelected,
        elemBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hJIkn))), {
            label: ""
        }),
        children: formatMessage((0, $eCOhn.messages).bulletedList)
    });
};
const $0331278f28c2c0e6$export$a10d73d60d04133e = ({ api: api })=>{
    return ()=>/*#__PURE__*/ (0, $gt9Am.jsx)($0331278f28c2c0e6$var$BulletedListBlockMenuItem, {
            api: api
        });
};

});

parcelRegister("dtOLp", function(module, exports) {
$parcel$export(module.exports, "createNumberedListBlockMenuItem", () => $53f66ee4c266aa46$export$43d7befaff491a1f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bMFKb = parcelRequire("bMFKb");

var $eCOhn = parcelRequire("eCOhn");

var $frlUM = parcelRequire("frlUM");

var $dFLJN = parcelRequire("dFLJN");

var $bVHJR = parcelRequire("bVHJR");
const $53f66ee4c266aa46$var$NumberedListBlockMenuItem = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const orderedListActive = (0, $frlUM.useSharedPluginStateSelector)(api, 'list.orderedListActive');
    const currentSelectedNodeName = (0, $frlUM.useSharedPluginStateSelector)(api, 'blockMenu.currentSelectedNodeName');
    // Check if a blockquote is currently selected
    const isBlockquoteSelected = currentSelectedNodeName?.includes('blockquote');
    // Only show as selected if ordered list is active AND we're not selecting a blockquote
    const isSelected = orderedListActive && !isBlockquoteSelected;
    const handleClick = (event)=>{
        if (!orderedListActive) {
            const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $bMFKb.INPUT_METHOD).KEYBOARD : (0, $bMFKb.INPUT_METHOD).MOUSE;
            const inputMethod = (0, $bMFKb.INPUT_METHOD).BLOCK_MENU;
            api?.core.actions.execute(api?.blockMenu?.commands.formatNode(`orderedList`, {
                inputMethod: inputMethod,
                triggeredFrom: triggeredFrom
            }));
        }
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dFLJN.ToolbarDropdownItem), {
        onClick: handleClick,
        isSelected: isSelected,
        elemBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bVHJR))), {
            label: ""
        }),
        children: formatMessage((0, $eCOhn.messages).orderedList)
    });
};
const $53f66ee4c266aa46$export$43d7befaff491a1f = ({ api: api })=>{
    return ()=>/*#__PURE__*/ (0, $gt9Am.jsx)($53f66ee4c266aa46$var$NumberedListBlockMenuItem, {
            api: api
        });
};

});




parcelRegister("85rQi", function(module, exports) {
$parcel$export(module.exports, "pastePlugin", () => (parcelRequire("8EyJv")).pastePlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $8EyJv = parcelRequire("8EyJv");

});
parcelRegister("8EyJv", function(module, exports) {
$parcel$export(module.exports, "pastePlugin", () => $778928956fab3494$export$2d7f4bd9c1268cd7);

var $0YStE = parcelRequire("0YStE");

var $bZVQL = parcelRequire("bZVQL");

var $3Elhj = parcelRequire("3Elhj");
const $778928956fab3494$export$2d7f4bd9c1268cd7 = ({ config: config, api: api })=>{
    const { cardOptions: cardOptions, sanitizePrivateContent: sanitizePrivateContent, isFullPage: isFullPage } = config ?? {};
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    const editorAnalyticsAPI = api?.analytics?.actions;
    return {
        name: 'paste',
        pmPlugins () {
            return [
                {
                    name: 'paste',
                    plugin: ({ schema: schema, providerFactory: providerFactory, dispatchAnalyticsEvent: dispatchAnalyticsEvent, dispatch: dispatch, getIntl: getIntl })=>(0, $0YStE.createPlugin)(schema, dispatchAnalyticsEvent, dispatch, featureFlags, api, getIntl, cardOptions, sanitizePrivateContent, providerFactory)
                },
                {
                    name: 'moveAnalyticsPlugin',
                    plugin: ({ dispatch: dispatch })=>{
                        return isFullPage ? (0, $bZVQL.createPlugin)(dispatch, editorAnalyticsAPI) : undefined;
                    }
                }
            ];
        },
        getSharedState: (editorState)=>{
            if (!editorState) return {
                lastContentPasted: null
            };
            const pluginState = (0, $3Elhj.pluginKey).getState(editorState);
            return {
                lastContentPasted: pluginState.lastContentPasted
            };
        }
    };
};

});
parcelRegister("0YStE", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $a6f16289cbc0bfec$export$ae829ec7b2625219);

var $aXKmr = parcelRequire("aXKmr");

var $bMFKb = parcelRequire("bMFKb");
var $j0X5g = parcelRequire("j0X5g");

var $6C2m6 = parcelRequire("6C2m6");

var $eQTBG = parcelRequire("eQTBG");

var $g3VjK = parcelRequire("g3VjK");

var $ayT4n = parcelRequire("ayT4n");
var $8WSr8 = parcelRequire("8WSr8");

var $65rqJ = parcelRequire("65rqJ");

var $i8KtF = parcelRequire("i8KtF");

var $iZ2Kf = parcelRequire("iZ2Kf");
var $k2X9Z = parcelRequire("k2X9Z");
var $1Snbj = parcelRequire("1Snbj");
var $4Gpco = parcelRequire("4Gpco");
var $j6af7 = parcelRequire("j6af7");
var $3qYlO = parcelRequire("3qYlO");

var $7TRmB = parcelRequire("7TRmB");
var $5Z3Rm = parcelRequire("5Z3Rm");
var $grDTV = parcelRequire("grDTV");
var $gbisc = parcelRequire("gbisc");

var $4jPLX = parcelRequire("4jPLX");

var $3xw6l = parcelRequire("3xw6l");

var $BmspC = parcelRequire("BmspC");

var $5yEGu = parcelRequire("5yEGu");

var $enDkL = parcelRequire("enDkL");

var $eGOwo = parcelRequire("eGOwo");

var $cbSL1 = parcelRequire("cbSL1");

var $92xoS = parcelRequire("92xoS");

var $6UQpI = parcelRequire("6UQpI");

var $1CqHB = parcelRequire("1CqHB");

var $5pNJd = parcelRequire("5pNJd");

var $3kq4u = parcelRequire("3kq4u");

var $18m7e = parcelRequire("18m7e");

var $3Elhj = parcelRequire("3Elhj");

var $bFyUX = parcelRequire("bFyUX");

var $di4lu = parcelRequire("di4lu");

var $1nSqW = parcelRequire("1nSqW");

var $2kOjB = parcelRequire("2kOjB");
const $a6f16289cbc0bfec$export$eedfdbc6a6bc1442 = (state)=>{
    const { blockquote: blockquote } = state.schema.nodes;
    return (0, $BmspC.hasParentNodeOfType)(blockquote)(state.selection);
};
const $a6f16289cbc0bfec$var$PASTE = 'Editor Paste Plugin Paste Duration';
function $a6f16289cbc0bfec$export$c503e2315ac846a7(url) {
    if (!url) return false;
    try {
        const urlObj = new URL(url);
        const hostname = urlObj.hostname.toLowerCase();
        const protocol = urlObj.protocol.toLowerCase();
        // Only accept HTTPS URLs for security
        if (protocol !== 'https:') return false;
        // Check if hostname ends with the trusted domains (not just contains them)
        return hostname.endsWith('sharepoint.com') || hostname.endsWith('onedrive.com') || hostname.endsWith('onedrive.live.com');
    } catch  {
        // If URL parsing fails, return false for safety
        return false;
    }
}
function $a6f16289cbc0bfec$export$ae829ec7b2625219(schema, dispatchAnalyticsEvent, dispatch, featureFlags, pluginInjectionApi, getIntl, cardOptions, sanitizePrivateContent, providerFactory) {
    const editorAnalyticsAPI = pluginInjectionApi?.analytics?.actions;
    const atlassianMarkDownParser = new (0, $4jPLX.MarkdownTransformer)(schema, (0, $8WSr8.md));
    function getMarkdownSlice(text, openStart, openEnd) {
        const escapedTextInput = (0, $bFyUX.escapeBackslashAndLinksExceptCodeBlock)(text);
        const doc = atlassianMarkDownParser.parse(escapedTextInput);
        if (doc && doc.content) return new (0, $3xw6l.Slice)(doc.content, openStart, openEnd);
        return;
    }
    let extensionAutoConverter;
    async function setExtensionAutoConverter(name, extensionProviderPromise) {
        if (name !== 'extensionProvider' || !extensionProviderPromise) return;
        try {
            extensionAutoConverter = await (0, $g3VjK.getExtensionAutoConvertersFromProvider)(extensionProviderPromise);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    }
    if (providerFactory) providerFactory.subscribe('extensionProvider', setExtensionAutoConverter);
    let mostRecentPasteEvent;
    let pastedFromBitBucket = false;
    return new (0, $i8KtF.SafePlugin)({
        key: (0, $3Elhj.pluginKey),
        state: (0, $3Elhj.createPluginState)(dispatch, {
            pastedMacroPositions: {},
            lastContentPasted: null
        }),
        props: {
            // For serialising to plain text
            clipboardTextSerializer: (0, $eGOwo.fg)('platform_editor_date_to_text') ? (0, $18m7e.createClipboardTextSerializer)(getIntl()) : (0, $18m7e.clipboardTextSerializer),
            handleDOMEvents: {
                // note
                paste: (view, event)=>{
                    mostRecentPasteEvent = event;
                    if ((0, $cbSL1.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true) && event.clipboardData) (0, $enDkL.insm).startHeavyTask('paste');
                    return false;
                }
            },
            // note
            handlePaste (view, rawEvent, slice) {
                const event = rawEvent;
                if (!event.clipboardData) return false;
                let text = event.clipboardData.getData('text/plain');
                const html = event.clipboardData.getData('text/html');
                const uriList = event.clipboardData.getData('text/uri-list');
                // Links copied from iOS Safari share button only have the text/uri-list data type
                // ProseMirror don't do anything with this type so we want to make our own open slice
                // with url as text content so link is pasted inline
                if (uriList && !text && !html) {
                    text = uriList;
                    slice = new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(schema.text(text)), 1, 1);
                }
                if (text?.includes('\r')) // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                text = text.replace(/\r/g, '');
                // Strip Legacy Content Macro (LCM) extensions on paste
                if (!(0, $eGOwo.fg)('platform_editor_legacy_content_macro_insert')) slice = (0, $j6af7.transformSliceToRemoveLegacyContentMacro)(slice, schema);
                const isPastedFile = (0, $ayT4n.isPastedFile)(event);
                const isPlainText = text && !html;
                const isRichText = !!html;
                // Bail if copied content has files
                if (isPastedFile) {
                    if (!html) {
                        if ((0, $cbSL1.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $enDkL.insm).endHeavyTask('paste');
                        /**
						 * Microsoft Office, Number, Pages, etc. adds an image to clipboard
						 * with other mime-types so we don't let the event reach media.
						 * The detection ration here is that if the payload has both `html` and
						 * `files`, then it could be one of above or an image copied from web.
						 * Here, we don't have html, so we return true to allow default event behaviour
						 */ return true;
                    }
                    /**
					 * We want to return false for external copied image to allow
					 * it to be uploaded by the client.
					 *
					 * Scenario where we are pasting an external image inside a block quote
					 * is skipped and handled in handleRichText
					 */ if ((0, $bFyUX.htmlContainsSingleFile)(html) && !$a6f16289cbc0bfec$export$eedfdbc6a6bc1442(view.state)) {
                        if ((0, $cbSL1.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $enDkL.insm).endHeavyTask('paste');
                        return true;
                    }
                    /**
					 * https://product-fabric.atlassian.net/browse/ED-21993
					 * stopImmediatePropagation will run the first event attached to the same element
					 * Which chould have race condition issue
					 */ event.stopPropagation();
                }
                const { state: state } = view;
                const content = (0, $3kq4u.getContentNodeTypes)(slice.content);
                const pasteId = (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))();
                const measureName = `${$a6f16289cbc0bfec$var$PASTE}_${pasteId}`;
                (0, $65rqJ.measureRender)(measureName, ({ duration: duration, distortedDuration: distortedDuration })=>{
                    const payload = (0, $3kq4u.createPasteMeasurePayload)({
                        view: view,
                        duration: duration,
                        content: content,
                        distortedDuration: distortedDuration
                    });
                    if (payload) dispatchAnalyticsEvent(payload);
                    if ((0, $cbSL1.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $enDkL.insm).endHeavyTask('paste');
                });
                const getLastPastedSlice = (tr)=>{
                    let slice;
                    for (const step of tr.steps){
                        const stepSlice = (0, $5Z3Rm.extractSliceFromStep)(step);
                        if (stepSlice) slice = stepSlice;
                    }
                    return slice;
                };
                // creating a custom dispatch because we want to add a meta whenever we do a paste.
                const dispatch = (tr)=>{
                    // https://product-fabric.atlassian.net/browse/ED-12633
                    // don't add closeHistory call if we're pasting a text inside placeholder text as we want the whole action
                    // to be atomic
                    const { placeholder: placeholder } = state.schema.nodes;
                    const isPastingTextInsidePlaceholderText = state.doc.resolve(state.selection.$anchor.pos).nodeAfter?.type === placeholder;
                    // Don't add closeHistory if we're pasting over layout columns, as we will appendTransaction
                    // to cleanup the layout's structure and we want to keep the paste and re-structuring as
                    // one event.
                    const isPastingOverLayoutColumns = (0, $BmspC.hasParentNodeOfType)(state.schema.nodes.layoutColumn)(state.selection);
                    // don't add closeHistory call if we're pasting a table, as some tables may involve additional
                    // appendedTransactions to repair them (if they're partial or incomplete) and we don't want
                    // to split those repairing transactions in prosemirror-history when they're being added to the
                    // "done" stack
                    const isPastingTable = tr.steps.some((step)=>{
                        const slice = (0, $5Z3Rm.extractSliceFromStep)(step);
                        let tableExists = false;
                        slice?.content?.forEach((node)=>{
                            if (node.type === state.schema.nodes.table) tableExists = true;
                        });
                        return tableExists;
                    });
                    if (!isPastingTextInsidePlaceholderText && !isPastingTable && !isPastingOverLayoutColumns && pluginInjectionApi?.betterTypeHistory) tr = pluginInjectionApi?.betterTypeHistory?.actions.flagPasteEvent(tr);
                    const isDocChanged = tr.docChanged;
                    (0, $6C2m6.addLinkMetadata)(view.state.selection, tr, {
                        action: isPlainText ? (0, $bMFKb.ACTION).PASTED_AS_PLAIN : (0, $bMFKb.ACTION).PASTED,
                        inputMethod: (0, $bMFKb.INPUT_METHOD).CLIPBOARD
                    });
                    // handleMacroAutoConvert dispatches twice
                    // we make sure to call paste options toolbar
                    // only for a valid paste action
                    if (isDocChanged) {
                        if ((0, $cbSL1.expValEquals)('platform_editor_pasting_nested_table_fix', 'isEnabled', true)) {
                            const pastedSlice = getLastPastedSlice(tr);
                            if (pastedSlice) {
                                const pasteStartPos = state.selection.from;
                                const pasteEndPos = tr.selection.to;
                                const contentPasted = {
                                    pasteStartPos: pasteStartPos,
                                    pasteEndPos: pasteEndPos,
                                    text: text,
                                    isShiftPressed: Boolean(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                                    view.shiftKey || view.input?.shiftKey),
                                    isPlainText: Boolean(isPlainText),
                                    pastedSlice: pastedSlice,
                                    pastedAt: Date.now(),
                                    pasteSource: (0, $bFyUX.getPasteSource)(event)
                                };
                                tr.setMeta((0, $3Elhj.pluginKey), {
                                    type: (0, $6UQpI.PastePluginActionTypes).ON_PASTE,
                                    contentPasted: contentPasted
                                });
                            }
                        } else {
                            const pasteStartPos = Math.min(state.selection.anchor, state.selection.head);
                            const pasteEndPos = tr.selection.to;
                            const contentPasted = {
                                pasteStartPos: pasteStartPos,
                                pasteEndPos: pasteEndPos,
                                text: text,
                                isShiftPressed: Boolean(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                                view.shiftKey || view.input?.shiftKey),
                                isPlainText: Boolean(isPlainText),
                                pastedSlice: tr.doc.slice(pasteStartPos, pasteEndPos),
                                pastedAt: Date.now(),
                                pasteSource: (0, $bFyUX.getPasteSource)(event)
                            };
                            tr.setMeta((0, $3Elhj.pluginKey), {
                                type: (0, $6UQpI.PastePluginActionTypes).ON_PASTE,
                                contentPasted: contentPasted
                            });
                        }
                    }
                    // the handlePaste definition overrides the generic prosemirror behaviour which would previously
                    // include a uiEvent meta of paste. To align with the docs (https://prosemirror.net/docs/ref/#state.Transaction)
                    // This will re-add the uiEvent meta.
                    view.dispatch(tr.setMeta('uiEvent', 'paste'));
                };
                slice = (0, $1nSqW.handleParagraphBlockMarks)(state, slice);
                slice = (0, $di4lu.handleVSCodeBlock)({
                    state: state,
                    slice: slice,
                    event: event,
                    text: text
                });
                const plainTextPasteSlice = (0, $grDTV.linkifyContent)(state.schema)(slice);
                if ((0, $3kq4u.handlePasteAsPlainTextWithAnalytics)(editorAnalyticsAPI)(view, event, plainTextPasteSlice)(state, dispatch, view)) return true;
                if ((0, $eGOwo.fg)('platform_editor_fix_captions_on_copy')) {
                    if ((0, $3kq4u.handlePasteIntoCaptionWithAnalytics)(editorAnalyticsAPI)(view, event, slice, (0, $j0X5g.PasteTypes).richText)(state, dispatch)) // Create a custom handler to avoid handling with handleRichText method
                    // As SafeInsert is used inside handleRichText which caused some bad UX like this:
                    // https://product-fabric.atlassian.net/browse/MEX-1520
                    // Converting caption to plain text needs to be handled before transformSliceForMedia
                    // as createChecked will fail when trying to create a mediaSingle node with a caption
                    // that is not plain text.
                    return true;
                }
                // transform slices based on destination
                slice = (0, $5pNJd.transformSliceForMedia)(slice, schema, pluginInjectionApi)(state.selection);
                let markdownSlice;
                if (isPlainText) {
                    markdownSlice = getMarkdownSlice(text, slice.openStart, slice.openEnd);
                    // https://product-fabric.atlassian.net/browse/ED-15134
                    // Lists are not allowed within Blockquotes at this time. Attempting to
                    // paste a markdown list ie. ">- foo" will yeild a markdownSlice of size 0.
                    // Rather then blocking the paste action with no UI feedback, this will instead
                    // force a "paste as plain text" action by clearing the markdownSlice.
                    markdownSlice = !markdownSlice?.size ? undefined : markdownSlice;
                    if (markdownSlice) {
                        // linkify text prior to converting to macro
                        if ((0, $3kq4u.handlePasteLinkOnSelectedTextWithAnalytics)(editorAnalyticsAPI)(view, event, markdownSlice, (0, $j0X5g.PasteTypes).markdown)(state, dispatch)) return true;
                        // run macro autoconvert prior to other conversions
                        if ((0, $1nSqW.handleMacroAutoConvert)(text, markdownSlice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr, pluginInjectionApi?.extension?.actions?.runMacroAutoConvert, cardOptions, extensionAutoConverter)(state, dispatch, view)) {
                            // TODO: ED-26959 - handleMacroAutoConvert dispatch twice, so we can't use the helper
                            (0, $3kq4u.sendPasteAnalyticsEvent)(editorAnalyticsAPI)(view, event, markdownSlice, {
                                type: (0, $j0X5g.PasteTypes).markdown
                            });
                            return true;
                        }
                    }
                }
                slice = (0, $bFyUX.transformUnsupportedBlockCardToInline)(slice, state, cardOptions);
                // Handles edge case so that when copying text from the top level of the document
                // it can be pasted into nodes like panels/actions/decisions without removing them.
                // Overriding openStart to be 1 when only pasting a paragraph makes the preferred
                // depth favour the text, rather than the paragraph node.
                // https://github.com/ProseMirror/prosemirror-transform/blob/master/src/replace.js#:~:text=Transform.prototype.-,replaceRange,-%3D%20function(from%2C%20to
                const selectionDepth = state.selection.$head.depth;
                const selectionParentNode = state.selection.$head.node(selectionDepth - 1);
                const selectionParentType = selectionParentNode?.type;
                const edgeCaseNodeTypes = [
                    schema.nodes?.panel,
                    schema.nodes?.taskList,
                    schema.nodes?.decisionList
                ];
                if (slice.openStart === 0 && slice.openEnd !== 1 && selectionParentNode && edgeCaseNodeTypes.includes(selectionParentType)) // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
                slice.openStart = 1;
                // If we're in a code block, append the text contents of clipboard inside it
                if ((0, $3kq4u.handleCodeBlockWithAnalytics)(editorAnalyticsAPI)(view, event, slice, text)(state, dispatch)) return true;
                if ((0, $3kq4u.handleMediaSingleWithAnalytics)(editorAnalyticsAPI)(view, event, slice, isPastedFile ? (0, $j0X5g.PasteTypes).binary : (0, $j0X5g.PasteTypes).richText, pluginInjectionApi?.media?.actions.insertMediaAsMediaSingle)(state, dispatch, view)) return true;
                if ((0, $3kq4u.handleSelectedTableWithAnalytics)(editorAnalyticsAPI)(view, event, slice)(state, dispatch)) return true;
                let isNestedMarkdownTable = false;
                // if paste a markdown table inside a table cell, we should treat it as a table slice
                const isParentNodeTdOrTh = selectionParentType === schema.nodes.tableCell || selectionParentType === schema.nodes.tableHeader;
                isNestedMarkdownTable = !!(markdownSlice && isPlainText && isParentNodeTdOrTh && (0, $3kq4u.getContentNodeTypes)(markdownSlice.content).includes(schema.nodes.table?.name));
                slice = isNestedMarkdownTable ? markdownSlice : slice;
                // get editor-tables to handle pasting tables if it can
                // otherwise, just the replace the selection with the content
                if ((0, $5yEGu.handlePaste)(view, event, slice, {
                    pasteSource: (0, $bFyUX.getPasteSource)(event)
                })) {
                    (0, $3kq4u.sendPasteAnalyticsEvent)(editorAnalyticsAPI)(view, event, slice, {
                        type: (0, $j0X5g.PasteTypes).richText
                    });
                    return true;
                }
                // handle paste of nested tables to ensure nesting limits are respected
                if ((0, $3kq4u.handleNestedTablePasteWithAnalytics)(editorAnalyticsAPI, (0, $eGOwo.fg)('platform_editor_use_nested_table_pm_nodes'))(view, event, slice)(state, dispatch)) return true;
                if ((0, $3kq4u.handlePasteIntoTaskAndDecisionWithAnalytics)(view, event, slice, isPlainText ? (0, $j0X5g.PasteTypes).plain : (0, $j0X5g.PasteTypes).richText, pluginInjectionApi)(state, dispatch)) return true;
                // If the clipboard only contains plain text, attempt to parse it as Markdown
                if (isPlainText && markdownSlice && !isNestedMarkdownTable) {
                    if ((0, $3kq4u.handlePastePreservingMarksWithAnalytics)(view, event, markdownSlice, (0, $j0X5g.PasteTypes).markdown, pluginInjectionApi)(state, dispatch)) return true;
                    return (0, $3kq4u.handleMarkdownWithAnalytics)(view, event, markdownSlice, pluginInjectionApi)(state, dispatch);
                }
                if (isRichText && $a6f16289cbc0bfec$export$eedfdbc6a6bc1442(state)) {
                    //If pasting inside blockquote
                    //Skip the blockquote node and keep remaining nodes as they are
                    //prevent doing this if there is list inside blockquote as the list is pasted incorrectly inside blockquote due to wrong openStart and openEnd
                    const { blockquote: blockquote } = schema.nodes;
                    const children = [];
                    (0, $gbisc.mapChildren)(slice.content, (node)=>{
                        if (node.type === blockquote && !(0, $BmspC.contains)(node, state.schema.nodes.listItem)) for(let i = 0; i < node.childCount; i++)children.push(node.child(i));
                        else children.push(node);
                    });
                    slice = new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).fromArray(children), slice.openStart, slice.openEnd);
                }
                // finally, handle rich-text copy-paste
                if (isRichText || isNestedMarkdownTable) {
                    // linkify the text where possible
                    slice = (0, $grDTV.linkifyContent)(state.schema)(slice);
                    if ((0, $3kq4u.handlePasteLinkOnSelectedTextWithAnalytics)(editorAnalyticsAPI)(view, event, slice, (0, $j0X5g.PasteTypes).richText)(state, dispatch)) return true;
                    // run macro autoconvert prior to other conversions
                    if ((0, $1nSqW.handleMacroAutoConvert)(text, slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr, pluginInjectionApi?.extension?.actions?.runMacroAutoConvert, cardOptions, extensionAutoConverter)(state, dispatch, view)) {
                        // TODO: ED-26959 - handleMacroAutoConvert dispatch twice, so we can't use the helper
                        (0, $3kq4u.sendPasteAnalyticsEvent)(editorAnalyticsAPI)(view, event, slice, {
                            type: (0, $j0X5g.PasteTypes).richText
                        });
                        return true;
                    }
                    // Special handling for SharePoint URLs generated from Share button
                    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
                    if ($a6f16289cbc0bfec$export$c503e2315ac846a7(text) && ((0, $eGOwo.fg)('platform_editor_sharepoint_url_smart_card_fallback') || (0, $eGOwo.fg)('platform_editor_sharepoint_url_smart_card_jira'))) {
                        // Create an inline card directly for SharePoint URLs to show the "Connect" button
                        const inlineCardNode = schema.nodes.inlineCard.create({
                            url: text
                        });
                        const cardSlice = new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(inlineCardNode), 0, 0);
                        if (dispatch) dispatch(state.tr.replaceSelection(cardSlice));
                        return true;
                    }
                    // handle the case when copy content from a table cell inside bodied extension
                    if ((0, $1nSqW.handleTableContentPasteInBodiedExtension)(slice)(state, dispatch)) return true;
                    // remove annotation marks from the pasted data if they are not present in the document
                    // for the cases when they are pasted from external pages
                    if (slice.content.size && (0, $7TRmB.containsAnyAnnotations)(slice, state)) pluginInjectionApi?.annotation?.actions.stripNonExistingAnnotations(slice, state);
                    if ((0, $3kq4u.handlePastePreservingMarksWithAnalytics)(view, event, slice, (0, $j0X5g.PasteTypes).richText, pluginInjectionApi)(state, dispatch)) return true;
                    // Check that we are pasting in a location that does not accept
                    // breakout marks, if so we strip the mark and paste. Note that
                    // breakout marks are only valid in the root document.
                    if (selectionParentType !== state.schema.nodes.doc) {
                        const sliceCopy = (0, $3xw6l.Slice).fromJSON(state.schema, slice.toJSON() || {});
                        sliceCopy.content.descendants((node)=>{
                            // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
                            node.marks = node.marks.filter((mark)=>mark.type.name !== 'breakout');
                            // as breakout marks should only be on top level nodes,
                            // we don't traverse the entire document
                            return false;
                        });
                        slice = sliceCopy;
                    }
                    if ((0, $3kq4u.handleExpandWithAnalytics)(editorAnalyticsAPI)(view, event, slice)(state, dispatch)) return true;
                    if (!(0, $eQTBG.insideTable)(state)) slice = (0, $1Snbj.transformSliceNestedExpandToExpand)(slice, state.schema);
                    if (!(0, $eGOwo.fg)('platform_editor_fix_captions_on_copy')) {
                        if ((0, $3kq4u.handlePasteIntoCaptionWithAnalytics)(editorAnalyticsAPI)(view, event, slice, (0, $j0X5g.PasteTypes).richText)(state, dispatch)) // Create a custom handler to avoid handling with handleRichText method
                        // As SafeInsert is used inside handleRichText which caused some bad UX like this:
                        // https://product-fabric.atlassian.net/browse/MEX-1520
                        return true;
                    }
                    if ((0, $3kq4u.handlePastePanelOrDecisionIntoListWithAnalytics)(editorAnalyticsAPI)(view, event, slice, pluginInjectionApi?.list?.actions.findRootParentListNode)(state, dispatch)) return true;
                    if ((0, $3kq4u.handlePasteNonNestableBlockNodesIntoListWithAnalytics)(editorAnalyticsAPI)(view, event, slice)(state, dispatch)) return true;
                    return (0, $3kq4u.handleRichTextWithAnalytics)(view, event, slice, pluginInjectionApi)(state, dispatch);
                }
                return false;
            },
            transformPasted (slice) {
                if (sanitizePrivateContent) slice = (0, $1nSqW.handleMention)(slice, schema);
                /* Bitbucket copies diffs as multiple adjacent code blocks
				 * so we merge ALL adjacent code blocks to support paste here */ if (pastedFromBitBucket) slice = (0, $k2X9Z.transformSliceToJoinAdjacentCodeBlocks)(slice);
                slice = (0, $k2X9Z.transformSingleLineCodeBlockToCodeMark)(slice, schema);
                slice = (0, $5pNJd.transformSliceToCorrectMediaWrapper)(slice, schema);
                slice = (0, $5pNJd.transformSliceToMediaSingleWithNewExperience)(slice, schema, pluginInjectionApi);
                slice = (0, $4Gpco.transformSliceToDecisionList)(slice, schema);
                // splitting linebreaks into paragraphs must happen before upgrading text to lists
                slice = (0, $1CqHB.splitParagraphs)(slice, schema);
                slice = (0, $1CqHB.upgradeTextToLists)(slice, schema);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                if (slice.content.childCount && slice.content.lastChild.type === schema.nodes.codeBlock) slice = new (0, $3xw6l.Slice)(slice.content, 0, 0);
                if (!(0, $92xoS.editorExperiment)('single_column_layouts', true)) slice = (0, $iZ2Kf.transformSingleColumnLayout)(slice, schema);
                slice = (0, $j6af7.transformSliceToRemoveMacroId)(slice, schema);
                if ((0, $cbSL1.expValEquals)('platform_synced_block', 'isEnabled', true)) slice = (0, $3qYlO.transformToNewReferenceSyncBlock)(slice, schema);
                return slice;
            },
            transformPastedHTML (html) {
                // Fix for issue ED-4438
                // text from google docs should not be pasted as inline code
                if (html.indexOf('id="docs-internal-guid-') >= 0) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    html = html.replace(/white-space:pre/g, '');
                    // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    html = html.replace(/white-space:pre-wrap/g, '');
                }
                // Partial fix for ED-7331: During a copy/paste from the legacy tinyMCE
                // confluence editor, if we encounter an incomplete table (e.g. table elements
                // not wrapped in <table>), we try to rebuild a complete, valid table if possible.
                if (mostRecentPasteEvent && (0, $2kOjB.isPastedFromTinyMCEConfluence)(mostRecentPasteEvent, html) && (0, $2kOjB.htmlHasIncompleteTable)(html)) {
                    const completeTableHtml = (0, $2kOjB.tryRebuildCompleteTableHtml)(html);
                    if (completeTableHtml) html = completeTableHtml;
                }
                if (!(0, $bFyUX.isPastedFromWord)(html) && !(0, $bFyUX.isPastedFromExcel)(html) && html.indexOf('<img ') >= 0) html = (0, $5pNJd.unwrapNestedMediaElements)(html);
                // https://product-fabric.atlassian.net/browse/ED-11714
                // Checking for edge case when copying a list item containing links from Notion
                // The html from this case is invalid with duplicate nested links
                if ((0, $bFyUX.htmlHasInvalidLinkTags)(html)) html = (0, $bFyUX.removeDuplicateInvalidLinks)(html);
                // Fix for ED-13568: Code blocks being copied/pasted when next to each other get merged
                pastedFromBitBucket = html.indexOf('data-qa="code-line"') >= 0;
                mostRecentPasteEvent = null;
                return html;
            }
        }
    });
}

});
parcelRegister("j0X5g", function(module, exports) {
$parcel$export(module.exports, "PasteTypes", () => $bfeab86471e5953a$export$2ba12a8680458b1e);
$parcel$export(module.exports, "PasteContents", () => $bfeab86471e5953a$export$a82556f999b47168);
const $bfeab86471e5953a$export$2ba12a8680458b1e = {
    richText: 'richText',
    plain: 'plain',
    markdown: 'markdown',
    binary: 'binary'
};
const $bfeab86471e5953a$export$602c33ed77663fbf = {
    fabricEditor: 'fabric-editor',
    applePages: 'apple-pages',
    googleSpreadsheets: 'google-spreadsheets',
    googleDocs: 'google-docs',
    microsoftExcel: 'microsoft-excel',
    microsoftWord: 'microsoft-word',
    dropboxPaper: 'dropbox-paper',
    uncategorized: 'uncategorized'
};
const $bfeab86471e5953a$export$a82556f999b47168 = {
    text: 'text',
    url: 'url',
    code: 'code',
    mediaSingle: 'mediaSingle',
    mediaCard: 'mediaCard',
    mediaGroup: 'mediaGroup',
    tableCells: 'tableCells',
    table: 'table',
    expand: 'expand',
    nestedExpand: 'nestedExpand',
    mixed: 'mixed',
    blockquote: 'blockquote',
    blockCard: 'blockCard',
    bodiedExtension: 'bodiedExtension',
    multiBodiedExtension: 'multiBodiedExtension',
    bulletList: 'bulletList',
    codeBlock: 'codeBlock',
    decisionList: 'decisionList',
    decisionItem: 'decisionItem',
    extension: 'extension',
    heading: 'heading',
    layoutSection: 'layoutSection',
    orderedList: 'orderedList',
    panel: 'panel',
    rule: 'rule',
    tableHeader: 'tableHeader',
    tableRow: 'tableRow',
    taskItem: 'taskItem',
    uncategorized: 'uncategorized'
};

});

parcelRegister("eQTBG", function(module, exports) {
$parcel$export(module.exports, "insideTable", () => $45b36e31a8b529d8$export$244bf4b32387ef62);

var $BmspC = parcelRequire("BmspC");
const $45b36e31a8b529d8$export$244bf4b32387ef62 = (state)=>{
    const { table: table, tableCell: tableCell } = state.schema.nodes;
    return (0, $BmspC.hasParentNodeOfType)([
        table,
        tableCell
    ])(state.selection);
};

});

parcelRegister("ayT4n", function(module, exports) {
$parcel$export(module.exports, "isPastedFile", () => $dea5e46e68396a3b$export$30c8e5e50a78a591);
function $dea5e46e68396a3b$export$e20225b4cda674a8(type, item) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isDOMStringList = (t)=>!t.indexOf && !!t.contains;
    return isDOMStringList(type) ? type.contains(item) : type.indexOf(item) > -1;
}
function $dea5e46e68396a3b$export$30c8e5e50a78a591(rawEvent) {
    const { clipboardData: clipboardData } = rawEvent;
    if (!clipboardData) return false;
    return $dea5e46e68396a3b$export$e20225b4cda674a8(clipboardData.types, 'Files');
}

});

parcelRegister("8WSr8", function(module, exports) {
$parcel$export(module.exports, "md", () => $4c8310abfd36e68a$export$f4de1c043ce6927);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/md/index.ts
// If changes are made to this file, please make the same update in the linked file.

var $cciZy = parcelRequire("cciZy");

var $ixJuK = parcelRequire("ixJuK");

var $hvgYN = parcelRequire("hvgYN");

var $5vTT1 = parcelRequire("5vTT1");

var $25i5a = parcelRequire("25i5a");
const $4c8310abfd36e68a$export$f4de1c043ce6927 = (0, (/*@__PURE__*/$parcel$interopDefault($cciZy)))('zero', {
    html: false
});
$4c8310abfd36e68a$export$f4de1c043ce6927.enable([
    // Process html entity - &#123;, &#xAF;, &quot;, ...
    'entity',
    // Process escaped chars and hardbreaks
    'escape',
    'newline'
]);
$4c8310abfd36e68a$export$f4de1c043ce6927.use((0, $25i5a.default));
// enable modified version of linkify plugin
// @see https://product-fabric.atlassian.net/browse/ED-3097
$4c8310abfd36e68a$export$f4de1c043ce6927.use((0, $hvgYN.default));
$4c8310abfd36e68a$export$f4de1c043ce6927.use((0, $5vTT1.default));
$4c8310abfd36e68a$export$f4de1c043ce6927.use((0, $ixJuK.default));

});
parcelRegister("cciZy", function(module, exports) {
'use strict';

module.exports = (parcelRequire("cBFd2"));

});
parcelRegister("cBFd2", function(module, exports) {
// Main parser class
'use strict';

var $l6IUK = parcelRequire("l6IUK");

var $gqPyc = parcelRequire("gqPyc");

var $gOmEB = parcelRequire("gOmEB");

var $5V1yU = parcelRequire("5V1yU");

var $9Xg9R = parcelRequire("9Xg9R");

var $hkcNh = parcelRequire("hkcNh");

var $98vHM = parcelRequire("98vHM");

var $90JXC = parcelRequire("90JXC");

var $4Iqgk = parcelRequire("4Iqgk");



var $92d8e80e58d3750f$var$config = {
    default: (parcelRequire("jbZa8")),
    zero: (parcelRequire("4Ggn6")),
    commonmark: (parcelRequire("5Yj6L"))
};
////////////////////////////////////////////////////////////////////////////////
//
// This validator can prohibit more than really needed to prevent XSS. It's a
// tradeoff to keep code simple and to be secure by default.
//
// If you need different setup - override validator method as you wish. Or
// replace it with dummy function and use external sanitizer.
//
var $92d8e80e58d3750f$var$BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
var $92d8e80e58d3750f$var$GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;
function $92d8e80e58d3750f$var$validateLink(url) {
    // url should be normalized at this point, and existing entities are decoded
    var str = url.trim().toLowerCase();
    return $92d8e80e58d3750f$var$BAD_PROTO_RE.test(str) ? $92d8e80e58d3750f$var$GOOD_DATA_RE.test(str) ? true : false : true;
}
////////////////////////////////////////////////////////////////////////////////
var $92d8e80e58d3750f$var$RECODE_HOSTNAME_FOR = [
    'http:',
    'https:',
    'mailto:'
];
function $92d8e80e58d3750f$var$normalizeLink(url) {
    var parsed = $90JXC.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $92d8e80e58d3750f$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = $4Iqgk.toASCII(parsed.hostname);
        } catch (er) {}
    }
    return $90JXC.encode($90JXC.format(parsed));
}
function $92d8e80e58d3750f$var$normalizeLinkText(url) {
    var parsed = $90JXC.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $92d8e80e58d3750f$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = $4Iqgk.toUnicode(parsed.hostname);
        } catch (er) {}
    }
    // add '%' to exclude list because of https://github.com/markdown-it/markdown-it/issues/720
    return $90JXC.decode($90JXC.format(parsed), $90JXC.decode.defaultChars + '%');
}
/**
 * class MarkdownIt
 *
 * Main parser/renderer class.
 *
 * ##### Usage
 *
 * ```javascript
 * // node.js, "classic" way:
 * var MarkdownIt = require('markdown-it'),
 *     md = new MarkdownIt();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // node.js, the same, but with sugar:
 * var md = require('markdown-it')();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // browser without AMD, added to "window" on script load
 * // Note, there are no dash.
 * var md = window.markdownit();
 * var result = md.render('# markdown-it rulezz!');
 * ```
 *
 * Single line rendering, without paragraph wrap:
 *
 * ```javascript
 * var md = require('markdown-it')();
 * var result = md.renderInline('__markdown-it__ rulezz!');
 * ```
 **/ /**
 * new MarkdownIt([presetName, options])
 * - presetName (String): optional, `commonmark` / `zero`
 * - options (Object)
 *
 * Creates parser instanse with given config. Can be called without `new`.
 *
 * ##### presetName
 *
 * MarkdownIt provides named presets as a convenience to quickly
 * enable/disable active syntax rules and options for common use cases.
 *
 * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.js) -
 *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
 * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.js) -
 *   similar to GFM, used when no preset name given. Enables all available rules,
 *   but still without html, typographer & autolinker.
 * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.js) -
 *   all rules disabled. Useful to quickly setup your config via `.enable()`.
 *   For example, when you need only `bold` and `italic` markup and nothing else.
 *
 * ##### options:
 *
 * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
 *   That's not safe! You may need external sanitizer to protect output from XSS.
 *   It's better to extend features via plugins, instead of enabling HTML.
 * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
 *   (`<br />`). This is needed only for full CommonMark compatibility. In real
 *   world you will need HTML output.
 * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
 * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
 *   Can be useful for external highlighters.
 * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
 * - __typographer__  - `false`. Set `true` to enable [some language-neutral
 *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.js) +
 *   quotes beautification (smartquotes).
 * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
 *   pairs, when typographer enabled and smartquotes on. For example, you can
 *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
 *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
 * - __highlight__ - `null`. Highlighter function for fenced code blocks.
 *   Highlighter `function (str, lang)` should return escaped HTML. It can also
 *   return empty string if the source was not changed and should be escaped
 *   externaly. If result starts with <pre... internal wrapper is skipped.
 *
 * ##### Example
 *
 * ```javascript
 * // commonmark mode
 * var md = require('markdown-it')('commonmark');
 *
 * // default mode
 * var md = require('markdown-it')();
 *
 * // enable everything
 * var md = require('markdown-it')({
 *   html: true,
 *   linkify: true,
 *   typographer: true
 * });
 * ```
 *
 * ##### Syntax highlighting
 *
 * ```js
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
 *       } catch (__) {}
 *     }
 *
 *     return ''; // use external default escaping
 *   }
 * });
 * ```
 *
 * Or with full wrapper override (if you need assign class to `<pre>`):
 *
 * ```javascript
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * // Actual default values
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return '<pre class="hljs"><code>' +
 *                hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
 *                '</code></pre>';
 *       } catch (__) {}
 *     }
 *
 *     return '<pre class="hljs"><code>' + md.utils.escapeHtml(str) + '</code></pre>';
 *   }
 * });
 * ```
 *
 **/ function $92d8e80e58d3750f$var$MarkdownIt(presetName, options) {
    if (!(this instanceof $92d8e80e58d3750f$var$MarkdownIt)) return new $92d8e80e58d3750f$var$MarkdownIt(presetName, options);
    if (!options) {
        if (!$l6IUK.isString(presetName)) {
            options = presetName || {};
            presetName = 'default';
        }
    }
    /**
   * MarkdownIt#inline -> ParserInline
   *
   * Instance of [[ParserInline]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.inline = new $hkcNh();
    /**
   * MarkdownIt#block -> ParserBlock
   *
   * Instance of [[ParserBlock]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.block = new $9Xg9R();
    /**
   * MarkdownIt#core -> Core
   *
   * Instance of [[Core]] chain executor. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.core = new $5V1yU();
    /**
   * MarkdownIt#renderer -> Renderer
   *
   * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
   * rules for new token types, generated by plugins.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * function myToken(tokens, idx, options, env, self) {
   *   //...
   *   return result;
   * };
   *
   * md.renderer.rules['my_token'] = myToken
   * ```
   *
   * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js).
   **/ this.renderer = new $gOmEB();
    /**
   * MarkdownIt#linkify -> LinkifyIt
   *
   * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
   * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js)
   * rule.
   **/ this.linkify = new $98vHM();
    /**
   * MarkdownIt#validateLink(url) -> Boolean
   *
   * Link validation function. CommonMark allows too much in links. By default
   * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
   * except some embedded image types.
   *
   * You can change this behaviour:
   *
   * ```javascript
   * var md = require('markdown-it')();
   * // enable everything
   * md.validateLink = function () { return true; }
   * ```
   **/ this.validateLink = $92d8e80e58d3750f$var$validateLink;
    /**
   * MarkdownIt#normalizeLink(url) -> String
   *
   * Function used to encode link url to a machine-readable format,
   * which includes url-encoding, punycode, etc.
   **/ this.normalizeLink = $92d8e80e58d3750f$var$normalizeLink;
    /**
   * MarkdownIt#normalizeLinkText(url) -> String
   *
   * Function used to decode link url to a human-readable format`
   **/ this.normalizeLinkText = $92d8e80e58d3750f$var$normalizeLinkText;
    // Expose utils & helpers for easy acces from plugins
    /**
   * MarkdownIt#utils -> utils
   *
   * Assorted utility functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.js).
   **/ this.utils = $l6IUK;
    /**
   * MarkdownIt#helpers -> helpers
   *
   * Link components parser functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
   **/ this.helpers = $l6IUK.assign({}, $gqPyc);
    this.options = {};
    this.configure(presetName);
    if (options) this.set(options);
}
/** chainable
 * MarkdownIt.set(options)
 *
 * Set parser options (in the same format as in constructor). Probably, you
 * will never need it, but you can change options after constructor call.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .set({ html: true, breaks: true })
 *             .set({ typographer, true });
 * ```
 *
 * __Note:__ To achieve the best possible performance, don't modify a
 * `markdown-it` instance options on the fly. If you need multiple configurations
 * it's best to create multiple instances and initialize each with separate
 * config.
 **/ $92d8e80e58d3750f$var$MarkdownIt.prototype.set = function(options) {
    $l6IUK.assign(this.options, options);
    return this;
};
/** chainable, internal
 * MarkdownIt.configure(presets)
 *
 * Batch load of all options and compenent settings. This is internal method,
 * and you probably will not need it. But if you will - see available presets
 * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
 *
 * We strongly recommend to use presets instead of direct config loads. That
 * will give better compatibility with next versions.
 **/ $92d8e80e58d3750f$var$MarkdownIt.prototype.configure = function(presets) {
    var self = this, presetName;
    if ($l6IUK.isString(presets)) {
        presetName = presets;
        presets = $92d8e80e58d3750f$var$config[presetName];
        if (!presets) throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name');
    }
    if (!presets) throw new Error('Wrong `markdown-it` preset, can\'t be empty');
    if (presets.options) self.set(presets.options);
    if (presets.components) Object.keys(presets.components).forEach(function(name) {
        if (presets.components[name].rules) self[name].ruler.enableOnly(presets.components[name].rules);
        if (presets.components[name].rules2) self[name].ruler2.enableOnly(presets.components[name].rules2);
    });
    return this;
};
/** chainable
 * MarkdownIt.enable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to enable
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable list or rules. It will automatically find appropriate components,
 * containing rules with given names. If rule not found, and `ignoreInvalid`
 * not set - throws exception.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .enable(['sub', 'sup'])
 *             .disable('smartquotes');
 * ```
 **/ $92d8e80e58d3750f$var$MarkdownIt.prototype.enable = function(list, ignoreInvalid) {
    var result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.enable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.enable(list, true));
    var missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to enable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.disable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * The same as [[MarkdownIt.enable]], but turn specified rules off.
 **/ $92d8e80e58d3750f$var$MarkdownIt.prototype.disable = function(list, ignoreInvalid) {
    var result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.disable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.disable(list, true));
    var missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to disable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.use(plugin, params)
 *
 * Load specified plugin with given params into current parser instance.
 * It's just a sugar to call `plugin(md, params)` with curring.
 *
 * ##### Example
 *
 * ```javascript
 * var iterator = require('markdown-it-for-inline');
 * var md = require('markdown-it')()
 *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
 *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
 *             });
 * ```
 **/ $92d8e80e58d3750f$var$MarkdownIt.prototype.use = function(plugin /*, params, ... */ ) {
    var args = [
        this
    ].concat(Array.prototype.slice.call(arguments, 1));
    plugin.apply(plugin, args);
    return this;
};
/** internal
 * MarkdownIt.parse(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Parse input string and return list of block tokens (special token type
 * "inline" will contain list of inline tokens). You should not call this
 * method directly, until you write custom renderer (for example, to produce
 * AST).
 *
 * `env` is used to pass data between "distributed" rules and return additional
 * metadata like reference info, needed for the renderer. It also can be used to
 * inject data in specific cases. Usually, you will be ok to pass `{}`,
 * and then pass updated object to renderer.
 **/ $92d8e80e58d3750f$var$MarkdownIt.prototype.parse = function(src, env) {
    if (typeof src !== 'string') throw new Error('Input data should be a String');
    var state = new this.core.State(src, this, env);
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.render(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Render markdown string into html. It does all magic for you :).
 *
 * `env` can be used to inject additional metadata (`{}` by default).
 * But you will not need it with high probability. See also comment
 * in [[MarkdownIt.parse]].
 **/ $92d8e80e58d3750f$var$MarkdownIt.prototype.render = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parse(src, env), this.options, env);
};
/** internal
 * MarkdownIt.parseInline(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
 * block tokens list with the single `inline` element, containing parsed inline
 * tokens in `children` property. Also updates `env` object.
 **/ $92d8e80e58d3750f$var$MarkdownIt.prototype.parseInline = function(src, env) {
    var state = new this.core.State(src, this, env);
    state.inlineMode = true;
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.renderInline(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
 * will NOT be wrapped into `<p>` tags.
 **/ $92d8e80e58d3750f$var$MarkdownIt.prototype.renderInline = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parseInline(src, env), this.options, env);
};
module.exports = $92d8e80e58d3750f$var$MarkdownIt;

});
parcelRegister("l6IUK", function(module, exports) {
$parcel$export(module.exports, "lib", () => $f5dcff8dfcedf068$export$16c08b91f883959a, (v) => $f5dcff8dfcedf068$export$16c08b91f883959a = v);
$parcel$export(module.exports, "assign", () => $f5dcff8dfcedf068$export$e6e34fd1f2686227, (v) => $f5dcff8dfcedf068$export$e6e34fd1f2686227 = v);
$parcel$export(module.exports, "isString", () => $f5dcff8dfcedf068$export$844ec244b1367d54, (v) => $f5dcff8dfcedf068$export$844ec244b1367d54 = v);
$parcel$export(module.exports, "has", () => $f5dcff8dfcedf068$export$a4f4bb6b1453fff5, (v) => $f5dcff8dfcedf068$export$a4f4bb6b1453fff5 = v);
$parcel$export(module.exports, "unescapeMd", () => $f5dcff8dfcedf068$export$5ccde1ea0c14bb03, (v) => $f5dcff8dfcedf068$export$5ccde1ea0c14bb03 = v);
$parcel$export(module.exports, "unescapeAll", () => $f5dcff8dfcedf068$export$db8a17c6655f7e2c, (v) => $f5dcff8dfcedf068$export$db8a17c6655f7e2c = v);
$parcel$export(module.exports, "isValidEntityCode", () => $f5dcff8dfcedf068$export$644a8f5b13b2a36d, (v) => $f5dcff8dfcedf068$export$644a8f5b13b2a36d = v);
$parcel$export(module.exports, "fromCodePoint", () => $f5dcff8dfcedf068$export$73bfc63873071f74, (v) => $f5dcff8dfcedf068$export$73bfc63873071f74 = v);
$parcel$export(module.exports, "escapeHtml", () => $f5dcff8dfcedf068$export$4cf11838cdc2a8a8, (v) => $f5dcff8dfcedf068$export$4cf11838cdc2a8a8 = v);
$parcel$export(module.exports, "arrayReplaceAt", () => $f5dcff8dfcedf068$export$f78478f71955b6bc, (v) => $f5dcff8dfcedf068$export$f78478f71955b6bc = v);
$parcel$export(module.exports, "isSpace", () => $f5dcff8dfcedf068$export$1d5ccafae59b4926, (v) => $f5dcff8dfcedf068$export$1d5ccafae59b4926 = v);
$parcel$export(module.exports, "isWhiteSpace", () => $f5dcff8dfcedf068$export$3c52dd84024ae72c, (v) => $f5dcff8dfcedf068$export$3c52dd84024ae72c = v);
$parcel$export(module.exports, "isMdAsciiPunct", () => $f5dcff8dfcedf068$export$829a0d33ae4e744, (v) => $f5dcff8dfcedf068$export$829a0d33ae4e744 = v);
$parcel$export(module.exports, "isPunctChar", () => $f5dcff8dfcedf068$export$4888a643af800fc1, (v) => $f5dcff8dfcedf068$export$4888a643af800fc1 = v);
$parcel$export(module.exports, "escapeRE", () => $f5dcff8dfcedf068$export$bc616c8f7dc20d5d, (v) => $f5dcff8dfcedf068$export$bc616c8f7dc20d5d = v);
$parcel$export(module.exports, "normalizeReference", () => $f5dcff8dfcedf068$export$20ef46802c8744b, (v) => $f5dcff8dfcedf068$export$20ef46802c8744b = v);
// Utilities
//
////////////////////////////////////////////////////////////////////////////////
// Re-export libraries commonly used in both markdown-it and its plugins,
// so plugins won't have to depend on them explicitly, which reduces their
// bundled size (e.g. a browser build).
//
var $f5dcff8dfcedf068$export$16c08b91f883959a;
var $f5dcff8dfcedf068$export$e6e34fd1f2686227;
var $f5dcff8dfcedf068$export$844ec244b1367d54;
var $f5dcff8dfcedf068$export$a4f4bb6b1453fff5;
var $f5dcff8dfcedf068$export$5ccde1ea0c14bb03;
var $f5dcff8dfcedf068$export$db8a17c6655f7e2c;
var $f5dcff8dfcedf068$export$644a8f5b13b2a36d;
var $f5dcff8dfcedf068$export$73bfc63873071f74;
// exports.replaceEntities     = replaceEntities;
var $f5dcff8dfcedf068$export$4cf11838cdc2a8a8;
var $f5dcff8dfcedf068$export$f78478f71955b6bc;
var $f5dcff8dfcedf068$export$1d5ccafae59b4926;
var $f5dcff8dfcedf068$export$3c52dd84024ae72c;
var $f5dcff8dfcedf068$export$829a0d33ae4e744;
var $f5dcff8dfcedf068$export$4888a643af800fc1;
var $f5dcff8dfcedf068$export$bc616c8f7dc20d5d;
var $f5dcff8dfcedf068$export$20ef46802c8744b;
'use strict';
function $f5dcff8dfcedf068$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $f5dcff8dfcedf068$var$isString(obj) {
    return $f5dcff8dfcedf068$var$_class(obj) === '[object String]';
}
var $f5dcff8dfcedf068$var$_hasOwnProperty = Object.prototype.hasOwnProperty;
function $f5dcff8dfcedf068$var$has(object, key) {
    return $f5dcff8dfcedf068$var$_hasOwnProperty.call(object, key);
}
// Merge objects
//
function $f5dcff8dfcedf068$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        if (typeof source !== 'object') throw new TypeError(source + 'must be object');
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
// Remove element from array and put another array at those position.
// Useful for some operations with tokens
function $f5dcff8dfcedf068$var$arrayReplaceAt(src, pos, newElements) {
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
}
////////////////////////////////////////////////////////////////////////////////
function $f5dcff8dfcedf068$var$isValidEntityCode(c) {
    /*eslint no-bitwise:0*/ // broken sequence
    if (c >= 0xD800 && c <= 0xDFFF) return false;
    // never used
    if (c >= 0xFDD0 && c <= 0xFDEF) return false;
    if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) return false;
    // control codes
    if (c >= 0x00 && c <= 0x08) return false;
    if (c === 0x0B) return false;
    if (c >= 0x0E && c <= 0x1F) return false;
    if (c >= 0x7F && c <= 0x9F) return false;
    // out of range
    if (c > 0x10FFFF) return false;
    return true;
}
function $f5dcff8dfcedf068$var$fromCodePoint(c) {
    /*eslint no-bitwise:0*/ if (c > 0xffff) {
        c -= 0x10000;
        var surrogate1 = 0xd800 + (c >> 10), surrogate2 = 0xdc00 + (c & 0x3ff);
        return String.fromCharCode(surrogate1, surrogate2);
    }
    return String.fromCharCode(c);
}
var $f5dcff8dfcedf068$var$UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])/g;
var $f5dcff8dfcedf068$var$ENTITY_RE = /&([a-z#][a-z0-9]{1,31});/gi;
var $f5dcff8dfcedf068$var$UNESCAPE_ALL_RE = new RegExp($f5dcff8dfcedf068$var$UNESCAPE_MD_RE.source + '|' + $f5dcff8dfcedf068$var$ENTITY_RE.source, 'gi');
var $f5dcff8dfcedf068$var$DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;

var $3q5w3 = parcelRequire("3q5w3");
function $f5dcff8dfcedf068$var$replaceEntityPattern(match, name) {
    var code;
    if ($f5dcff8dfcedf068$var$has($3q5w3, name)) return $3q5w3[name];
    if (name.charCodeAt(0) === 0x23 /* # */  && $f5dcff8dfcedf068$var$DIGITAL_ENTITY_TEST_RE.test(name)) {
        code = name[1].toLowerCase() === 'x' ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
        if ($f5dcff8dfcedf068$var$isValidEntityCode(code)) return $f5dcff8dfcedf068$var$fromCodePoint(code);
    }
    return match;
}
/*function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(ENTITY_RE, replaceEntityPattern);
}*/ function $f5dcff8dfcedf068$var$unescapeMd(str) {
    if (str.indexOf('\\') < 0) return str;
    return str.replace($f5dcff8dfcedf068$var$UNESCAPE_MD_RE, '$1');
}
function $f5dcff8dfcedf068$var$unescapeAll(str) {
    if (str.indexOf('\\') < 0 && str.indexOf('&') < 0) return str;
    return str.replace($f5dcff8dfcedf068$var$UNESCAPE_ALL_RE, function(match, escaped, entity) {
        if (escaped) return escaped;
        return $f5dcff8dfcedf068$var$replaceEntityPattern(match, entity);
    });
}
////////////////////////////////////////////////////////////////////////////////
var $f5dcff8dfcedf068$var$HTML_ESCAPE_TEST_RE = /[&<>"]/;
var $f5dcff8dfcedf068$var$HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
var $f5dcff8dfcedf068$var$HTML_REPLACEMENTS = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;'
};
function $f5dcff8dfcedf068$var$replaceUnsafeChar(ch) {
    return $f5dcff8dfcedf068$var$HTML_REPLACEMENTS[ch];
}
function $f5dcff8dfcedf068$var$escapeHtml(str) {
    if ($f5dcff8dfcedf068$var$HTML_ESCAPE_TEST_RE.test(str)) return str.replace($f5dcff8dfcedf068$var$HTML_ESCAPE_REPLACE_RE, $f5dcff8dfcedf068$var$replaceUnsafeChar);
    return str;
}
////////////////////////////////////////////////////////////////////////////////
var $f5dcff8dfcedf068$var$REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;
function $f5dcff8dfcedf068$var$escapeRE(str) {
    return str.replace($f5dcff8dfcedf068$var$REGEXP_ESCAPE_RE, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
function $f5dcff8dfcedf068$var$isSpace(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
// Zs (unicode class) || [\t\f\v\r\n]
function $f5dcff8dfcedf068$var$isWhiteSpace(code) {
    if (code >= 0x2000 && code <= 0x200A) return true;
    switch(code){
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0C:
        case 0x0D:
        case 0x20:
        case 0xA0:
        case 0x1680:
        case 0x202F:
        case 0x205F:
        case 0x3000:
            return true;
    }
    return false;
}

var $dDBFM = parcelRequire("dDBFM");
// Currently without astral characters support.
function $f5dcff8dfcedf068$var$isPunctChar(ch) {
    return $dDBFM.test(ch);
}
// Markdown ASCII punctuation characters.
//
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
//
// Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
//
function $f5dcff8dfcedf068$var$isMdAsciiPunct(ch) {
    switch(ch){
        case 0x21 /* ! */ :
        case 0x22 /* " */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x27 /* ' */ :
        case 0x28 /* ( */ :
        case 0x29 /* ) */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2C /* , */ :
        case 0x2D /* - */ :
        case 0x2E /* . */ :
        case 0x2F /* / */ :
        case 0x3A /* : */ :
        case 0x3B /* ; */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x3F /* ? */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7C /* | */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
// Hepler to unify [reference labels].
//
function $f5dcff8dfcedf068$var$normalizeReference(str) {
    // Trim and collapse whitespace
    //
    str = str.trim().replace(/\s+/g, ' ');
    // In node v10 'ẞ'.toLowerCase() === 'Ṿ', which is presumed to be a bug
    // fixed in v12 (couldn't find any details).
    //
    // So treat this one as a special case
    // (remove this when node v10 is no longer supported).
    //
    if ("\u1E9E".toLowerCase() === "\u1E7E") str = str.replace(/ẞ/g, "\xdf");
    // .toLowerCase().toUpperCase() should get rid of all differences
    // between letter variants.
    //
    // Simple .toLowerCase() doesn't normalize 125 code points correctly,
    // and .toUpperCase doesn't normalize 6 of them (list of exceptions:
    // İ, ϴ, ẞ, Ω, K, Å - those are already uppercased, but have differently
    // uppercased versions).
    //
    // Here's an example showing how it happens. Lets take greek letter omega:
    // uppercase U+0398 (Θ), U+03f4 (ϴ) and lowercase U+03b8 (θ), U+03d1 (ϑ)
    //
    // Unicode entries:
    // 0398;GREEK CAPITAL LETTER THETA;Lu;0;L;;;;;N;;;;03B8;
    // 03B8;GREEK SMALL LETTER THETA;Ll;0;L;;;;;N;;;0398;;0398
    // 03D1;GREEK THETA SYMBOL;Ll;0;L;<compat> 03B8;;;;N;GREEK SMALL LETTER SCRIPT THETA;;0398;;0398
    // 03F4;GREEK CAPITAL THETA SYMBOL;Lu;0;L;<compat> 0398;;;;N;;;;03B8;
    //
    // Case-insensitive comparison should treat all of them as equivalent.
    //
    // But .toLowerCase() doesn't change ϑ (it's already lowercase),
    // and .toUpperCase() doesn't change ϴ (already uppercase).
    //
    // Applying first lower then upper case normalizes any character:
    // '\u0398\u03f4\u03b8\u03d1'.toLowerCase().toUpperCase() === '\u0398\u0398\u0398\u0398'
    //
    // Note: this is equivalent to unicode case folding; unicode normalization
    // is a different step that is not required here.
    //
    // Final result should be uppercased, because it's later stored in an object
    // (this avoid a conflict with Object.prototype members,
    // most notably, `__proto__`)
    //
    return str.toLowerCase().toUpperCase();
}
$f5dcff8dfcedf068$export$16c08b91f883959a = {};

$f5dcff8dfcedf068$export$16c08b91f883959a.mdurl = (parcelRequire("90JXC"));

$f5dcff8dfcedf068$export$16c08b91f883959a.ucmicro = (parcelRequire("1I1Rw"));
$f5dcff8dfcedf068$export$e6e34fd1f2686227 = $f5dcff8dfcedf068$var$assign;
$f5dcff8dfcedf068$export$844ec244b1367d54 = $f5dcff8dfcedf068$var$isString;
$f5dcff8dfcedf068$export$a4f4bb6b1453fff5 = $f5dcff8dfcedf068$var$has;
$f5dcff8dfcedf068$export$5ccde1ea0c14bb03 = $f5dcff8dfcedf068$var$unescapeMd;
$f5dcff8dfcedf068$export$db8a17c6655f7e2c = $f5dcff8dfcedf068$var$unescapeAll;
$f5dcff8dfcedf068$export$644a8f5b13b2a36d = $f5dcff8dfcedf068$var$isValidEntityCode;
$f5dcff8dfcedf068$export$73bfc63873071f74 = $f5dcff8dfcedf068$var$fromCodePoint;
$f5dcff8dfcedf068$export$4cf11838cdc2a8a8 = $f5dcff8dfcedf068$var$escapeHtml;
$f5dcff8dfcedf068$export$f78478f71955b6bc = $f5dcff8dfcedf068$var$arrayReplaceAt;
$f5dcff8dfcedf068$export$1d5ccafae59b4926 = $f5dcff8dfcedf068$var$isSpace;
$f5dcff8dfcedf068$export$3c52dd84024ae72c = $f5dcff8dfcedf068$var$isWhiteSpace;
$f5dcff8dfcedf068$export$829a0d33ae4e744 = $f5dcff8dfcedf068$var$isMdAsciiPunct;
$f5dcff8dfcedf068$export$4888a643af800fc1 = $f5dcff8dfcedf068$var$isPunctChar;
$f5dcff8dfcedf068$export$bc616c8f7dc20d5d = $f5dcff8dfcedf068$var$escapeRE;
$f5dcff8dfcedf068$export$20ef46802c8744b = $f5dcff8dfcedf068$var$normalizeReference;

});
parcelRegister("3q5w3", function(module, exports) {
// HTML5 entities map: { name -> utf16string }
//
'use strict';

/*eslint quotes:0*/ module.exports = (parcelRequire("hHHTu"));

});
parcelRegister("hHHTu", function(module, exports) {
module.exports = JSON.parse('{"Aacute":"\xc1","aacute":"\xe1","Abreve":"\u0102","abreve":"\u0103","ac":"\u223E","acd":"\u223F","acE":"\u223E\u0333","Acirc":"\xc2","acirc":"\xe2","acute":"\xb4","Acy":"\u0410","acy":"\u0430","AElig":"\xc6","aelig":"\xe6","af":"\u2061","Afr":"\uD835\uDD04","afr":"\uD835\uDD1E","Agrave":"\xc0","agrave":"\xe0","alefsym":"\u2135","aleph":"\u2135","Alpha":"\u0391","alpha":"\u03B1","Amacr":"\u0100","amacr":"\u0101","amalg":"\u2A3F","amp":"&","AMP":"&","andand":"\u2A55","And":"\u2A53","and":"\u2227","andd":"\u2A5C","andslope":"\u2A58","andv":"\u2A5A","ang":"\u2220","ange":"\u29A4","angle":"\u2220","angmsdaa":"\u29A8","angmsdab":"\u29A9","angmsdac":"\u29AA","angmsdad":"\u29AB","angmsdae":"\u29AC","angmsdaf":"\u29AD","angmsdag":"\u29AE","angmsdah":"\u29AF","angmsd":"\u2221","angrt":"\u221F","angrtvb":"\u22BE","angrtvbd":"\u299D","angsph":"\u2222","angst":"\xc5","angzarr":"\u237C","Aogon":"\u0104","aogon":"\u0105","Aopf":"\uD835\uDD38","aopf":"\uD835\uDD52","apacir":"\u2A6F","ap":"\u2248","apE":"\u2A70","ape":"\u224A","apid":"\u224B","apos":"\'","ApplyFunction":"\u2061","approx":"\u2248","approxeq":"\u224A","Aring":"\xc5","aring":"\xe5","Ascr":"\uD835\uDC9C","ascr":"\uD835\uDCB6","Assign":"\u2254","ast":"*","asymp":"\u2248","asympeq":"\u224D","Atilde":"\xc3","atilde":"\xe3","Auml":"\xc4","auml":"\xe4","awconint":"\u2233","awint":"\u2A11","backcong":"\u224C","backepsilon":"\u03F6","backprime":"\u2035","backsim":"\u223D","backsimeq":"\u22CD","Backslash":"\u2216","Barv":"\u2AE7","barvee":"\u22BD","barwed":"\u2305","Barwed":"\u2306","barwedge":"\u2305","bbrk":"\u23B5","bbrktbrk":"\u23B6","bcong":"\u224C","Bcy":"\u0411","bcy":"\u0431","bdquo":"\u201E","becaus":"\u2235","because":"\u2235","Because":"\u2235","bemptyv":"\u29B0","bepsi":"\u03F6","bernou":"\u212C","Bernoullis":"\u212C","Beta":"\u0392","beta":"\u03B2","beth":"\u2136","between":"\u226C","Bfr":"\uD835\uDD05","bfr":"\uD835\uDD1F","bigcap":"\u22C2","bigcirc":"\u25EF","bigcup":"\u22C3","bigodot":"\u2A00","bigoplus":"\u2A01","bigotimes":"\u2A02","bigsqcup":"\u2A06","bigstar":"\u2605","bigtriangledown":"\u25BD","bigtriangleup":"\u25B3","biguplus":"\u2A04","bigvee":"\u22C1","bigwedge":"\u22C0","bkarow":"\u290D","blacklozenge":"\u29EB","blacksquare":"\u25AA","blacktriangle":"\u25B4","blacktriangledown":"\u25BE","blacktriangleleft":"\u25C2","blacktriangleright":"\u25B8","blank":"\u2423","blk12":"\u2592","blk14":"\u2591","blk34":"\u2593","block":"\u2588","bne":"=\u20E5","bnequiv":"\u2261\u20E5","bNot":"\u2AED","bnot":"\u2310","Bopf":"\uD835\uDD39","bopf":"\uD835\uDD53","bot":"\u22A5","bottom":"\u22A5","bowtie":"\u22C8","boxbox":"\u29C9","boxdl":"\u2510","boxdL":"\u2555","boxDl":"\u2556","boxDL":"\u2557","boxdr":"\u250C","boxdR":"\u2552","boxDr":"\u2553","boxDR":"\u2554","boxh":"\u2500","boxH":"\u2550","boxhd":"\u252C","boxHd":"\u2564","boxhD":"\u2565","boxHD":"\u2566","boxhu":"\u2534","boxHu":"\u2567","boxhU":"\u2568","boxHU":"\u2569","boxminus":"\u229F","boxplus":"\u229E","boxtimes":"\u22A0","boxul":"\u2518","boxuL":"\u255B","boxUl":"\u255C","boxUL":"\u255D","boxur":"\u2514","boxuR":"\u2558","boxUr":"\u2559","boxUR":"\u255A","boxv":"\u2502","boxV":"\u2551","boxvh":"\u253C","boxvH":"\u256A","boxVh":"\u256B","boxVH":"\u256C","boxvl":"\u2524","boxvL":"\u2561","boxVl":"\u2562","boxVL":"\u2563","boxvr":"\u251C","boxvR":"\u255E","boxVr":"\u255F","boxVR":"\u2560","bprime":"\u2035","breve":"\u02D8","Breve":"\u02D8","brvbar":"\xa6","bscr":"\uD835\uDCB7","Bscr":"\u212C","bsemi":"\u204F","bsim":"\u223D","bsime":"\u22CD","bsolb":"\u29C5","bsol":"\\\\","bsolhsub":"\u27C8","bull":"\u2022","bullet":"\u2022","bump":"\u224E","bumpE":"\u2AAE","bumpe":"\u224F","Bumpeq":"\u224E","bumpeq":"\u224F","Cacute":"\u0106","cacute":"\u0107","capand":"\u2A44","capbrcup":"\u2A49","capcap":"\u2A4B","cap":"\u2229","Cap":"\u22D2","capcup":"\u2A47","capdot":"\u2A40","CapitalDifferentialD":"\u2145","caps":"\u2229\uFE00","caret":"\u2041","caron":"\u02C7","Cayleys":"\u212D","ccaps":"\u2A4D","Ccaron":"\u010C","ccaron":"\u010D","Ccedil":"\xc7","ccedil":"\xe7","Ccirc":"\u0108","ccirc":"\u0109","Cconint":"\u2230","ccups":"\u2A4C","ccupssm":"\u2A50","Cdot":"\u010A","cdot":"\u010B","cedil":"\xb8","Cedilla":"\xb8","cemptyv":"\u29B2","cent":"\xa2","centerdot":"\xb7","CenterDot":"\xb7","cfr":"\uD835\uDD20","Cfr":"\u212D","CHcy":"\u0427","chcy":"\u0447","check":"\u2713","checkmark":"\u2713","Chi":"\u03A7","chi":"\u03C7","circ":"\u02C6","circeq":"\u2257","circlearrowleft":"\u21BA","circlearrowright":"\u21BB","circledast":"\u229B","circledcirc":"\u229A","circleddash":"\u229D","CircleDot":"\u2299","circledR":"\xae","circledS":"\u24C8","CircleMinus":"\u2296","CirclePlus":"\u2295","CircleTimes":"\u2297","cir":"\u25CB","cirE":"\u29C3","cire":"\u2257","cirfnint":"\u2A10","cirmid":"\u2AEF","cirscir":"\u29C2","ClockwiseContourIntegral":"\u2232","CloseCurlyDoubleQuote":"\u201D","CloseCurlyQuote":"\u2019","clubs":"\u2663","clubsuit":"\u2663","colon":":","Colon":"\u2237","Colone":"\u2A74","colone":"\u2254","coloneq":"\u2254","comma":",","commat":"@","comp":"\u2201","compfn":"\u2218","complement":"\u2201","complexes":"\u2102","cong":"\u2245","congdot":"\u2A6D","Congruent":"\u2261","conint":"\u222E","Conint":"\u222F","ContourIntegral":"\u222E","copf":"\uD835\uDD54","Copf":"\u2102","coprod":"\u2210","Coproduct":"\u2210","copy":"\xa9","COPY":"\xa9","copysr":"\u2117","CounterClockwiseContourIntegral":"\u2233","crarr":"\u21B5","cross":"\u2717","Cross":"\u2A2F","Cscr":"\uD835\uDC9E","cscr":"\uD835\uDCB8","csub":"\u2ACF","csube":"\u2AD1","csup":"\u2AD0","csupe":"\u2AD2","ctdot":"\u22EF","cudarrl":"\u2938","cudarrr":"\u2935","cuepr":"\u22DE","cuesc":"\u22DF","cularr":"\u21B6","cularrp":"\u293D","cupbrcap":"\u2A48","cupcap":"\u2A46","CupCap":"\u224D","cup":"\u222A","Cup":"\u22D3","cupcup":"\u2A4A","cupdot":"\u228D","cupor":"\u2A45","cups":"\u222A\uFE00","curarr":"\u21B7","curarrm":"\u293C","curlyeqprec":"\u22DE","curlyeqsucc":"\u22DF","curlyvee":"\u22CE","curlywedge":"\u22CF","curren":"\xa4","curvearrowleft":"\u21B6","curvearrowright":"\u21B7","cuvee":"\u22CE","cuwed":"\u22CF","cwconint":"\u2232","cwint":"\u2231","cylcty":"\u232D","dagger":"\u2020","Dagger":"\u2021","daleth":"\u2138","darr":"\u2193","Darr":"\u21A1","dArr":"\u21D3","dash":"\u2010","Dashv":"\u2AE4","dashv":"\u22A3","dbkarow":"\u290F","dblac":"\u02DD","Dcaron":"\u010E","dcaron":"\u010F","Dcy":"\u0414","dcy":"\u0434","ddagger":"\u2021","ddarr":"\u21CA","DD":"\u2145","dd":"\u2146","DDotrahd":"\u2911","ddotseq":"\u2A77","deg":"\xb0","Del":"\u2207","Delta":"\u0394","delta":"\u03B4","demptyv":"\u29B1","dfisht":"\u297F","Dfr":"\uD835\uDD07","dfr":"\uD835\uDD21","dHar":"\u2965","dharl":"\u21C3","dharr":"\u21C2","DiacriticalAcute":"\xb4","DiacriticalDot":"\u02D9","DiacriticalDoubleAcute":"\u02DD","DiacriticalGrave":"`","DiacriticalTilde":"\u02DC","diam":"\u22C4","diamond":"\u22C4","Diamond":"\u22C4","diamondsuit":"\u2666","diams":"\u2666","die":"\xa8","DifferentialD":"\u2146","digamma":"\u03DD","disin":"\u22F2","div":"\xf7","divide":"\xf7","divideontimes":"\u22C7","divonx":"\u22C7","DJcy":"\u0402","djcy":"\u0452","dlcorn":"\u231E","dlcrop":"\u230D","dollar":"$","Dopf":"\uD835\uDD3B","dopf":"\uD835\uDD55","Dot":"\xa8","dot":"\u02D9","DotDot":"\u20DC","doteq":"\u2250","doteqdot":"\u2251","DotEqual":"\u2250","dotminus":"\u2238","dotplus":"\u2214","dotsquare":"\u22A1","doublebarwedge":"\u2306","DoubleContourIntegral":"\u222F","DoubleDot":"\xa8","DoubleDownArrow":"\u21D3","DoubleLeftArrow":"\u21D0","DoubleLeftRightArrow":"\u21D4","DoubleLeftTee":"\u2AE4","DoubleLongLeftArrow":"\u27F8","DoubleLongLeftRightArrow":"\u27FA","DoubleLongRightArrow":"\u27F9","DoubleRightArrow":"\u21D2","DoubleRightTee":"\u22A8","DoubleUpArrow":"\u21D1","DoubleUpDownArrow":"\u21D5","DoubleVerticalBar":"\u2225","DownArrowBar":"\u2913","downarrow":"\u2193","DownArrow":"\u2193","Downarrow":"\u21D3","DownArrowUpArrow":"\u21F5","DownBreve":"\u0311","downdownarrows":"\u21CA","downharpoonleft":"\u21C3","downharpoonright":"\u21C2","DownLeftRightVector":"\u2950","DownLeftTeeVector":"\u295E","DownLeftVectorBar":"\u2956","DownLeftVector":"\u21BD","DownRightTeeVector":"\u295F","DownRightVectorBar":"\u2957","DownRightVector":"\u21C1","DownTeeArrow":"\u21A7","DownTee":"\u22A4","drbkarow":"\u2910","drcorn":"\u231F","drcrop":"\u230C","Dscr":"\uD835\uDC9F","dscr":"\uD835\uDCB9","DScy":"\u0405","dscy":"\u0455","dsol":"\u29F6","Dstrok":"\u0110","dstrok":"\u0111","dtdot":"\u22F1","dtri":"\u25BF","dtrif":"\u25BE","duarr":"\u21F5","duhar":"\u296F","dwangle":"\u29A6","DZcy":"\u040F","dzcy":"\u045F","dzigrarr":"\u27FF","Eacute":"\xc9","eacute":"\xe9","easter":"\u2A6E","Ecaron":"\u011A","ecaron":"\u011B","Ecirc":"\xca","ecirc":"\xea","ecir":"\u2256","ecolon":"\u2255","Ecy":"\u042D","ecy":"\u044D","eDDot":"\u2A77","Edot":"\u0116","edot":"\u0117","eDot":"\u2251","ee":"\u2147","efDot":"\u2252","Efr":"\uD835\uDD08","efr":"\uD835\uDD22","eg":"\u2A9A","Egrave":"\xc8","egrave":"\xe8","egs":"\u2A96","egsdot":"\u2A98","el":"\u2A99","Element":"\u2208","elinters":"\u23E7","ell":"\u2113","els":"\u2A95","elsdot":"\u2A97","Emacr":"\u0112","emacr":"\u0113","empty":"\u2205","emptyset":"\u2205","EmptySmallSquare":"\u25FB","emptyv":"\u2205","EmptyVerySmallSquare":"\u25AB","emsp13":"\u2004","emsp14":"\u2005","emsp":"\u2003","ENG":"\u014A","eng":"\u014B","ensp":"\u2002","Eogon":"\u0118","eogon":"\u0119","Eopf":"\uD835\uDD3C","eopf":"\uD835\uDD56","epar":"\u22D5","eparsl":"\u29E3","eplus":"\u2A71","epsi":"\u03B5","Epsilon":"\u0395","epsilon":"\u03B5","epsiv":"\u03F5","eqcirc":"\u2256","eqcolon":"\u2255","eqsim":"\u2242","eqslantgtr":"\u2A96","eqslantless":"\u2A95","Equal":"\u2A75","equals":"=","EqualTilde":"\u2242","equest":"\u225F","Equilibrium":"\u21CC","equiv":"\u2261","equivDD":"\u2A78","eqvparsl":"\u29E5","erarr":"\u2971","erDot":"\u2253","escr":"\u212F","Escr":"\u2130","esdot":"\u2250","Esim":"\u2A73","esim":"\u2242","Eta":"\u0397","eta":"\u03B7","ETH":"\xd0","eth":"\xf0","Euml":"\xcb","euml":"\xeb","euro":"\u20AC","excl":"!","exist":"\u2203","Exists":"\u2203","expectation":"\u2130","exponentiale":"\u2147","ExponentialE":"\u2147","fallingdotseq":"\u2252","Fcy":"\u0424","fcy":"\u0444","female":"\u2640","ffilig":"\uFB03","fflig":"\uFB00","ffllig":"\uFB04","Ffr":"\uD835\uDD09","ffr":"\uD835\uDD23","filig":"\uFB01","FilledSmallSquare":"\u25FC","FilledVerySmallSquare":"\u25AA","fjlig":"fj","flat":"\u266D","fllig":"\uFB02","fltns":"\u25B1","fnof":"\u0192","Fopf":"\uD835\uDD3D","fopf":"\uD835\uDD57","forall":"\u2200","ForAll":"\u2200","fork":"\u22D4","forkv":"\u2AD9","Fouriertrf":"\u2131","fpartint":"\u2A0D","frac12":"\xbd","frac13":"\u2153","frac14":"\xbc","frac15":"\u2155","frac16":"\u2159","frac18":"\u215B","frac23":"\u2154","frac25":"\u2156","frac34":"\xbe","frac35":"\u2157","frac38":"\u215C","frac45":"\u2158","frac56":"\u215A","frac58":"\u215D","frac78":"\u215E","frasl":"\u2044","frown":"\u2322","fscr":"\uD835\uDCBB","Fscr":"\u2131","gacute":"\u01F5","Gamma":"\u0393","gamma":"\u03B3","Gammad":"\u03DC","gammad":"\u03DD","gap":"\u2A86","Gbreve":"\u011E","gbreve":"\u011F","Gcedil":"\u0122","Gcirc":"\u011C","gcirc":"\u011D","Gcy":"\u0413","gcy":"\u0433","Gdot":"\u0120","gdot":"\u0121","ge":"\u2265","gE":"\u2267","gEl":"\u2A8C","gel":"\u22DB","geq":"\u2265","geqq":"\u2267","geqslant":"\u2A7E","gescc":"\u2AA9","ges":"\u2A7E","gesdot":"\u2A80","gesdoto":"\u2A82","gesdotol":"\u2A84","gesl":"\u22DB\uFE00","gesles":"\u2A94","Gfr":"\uD835\uDD0A","gfr":"\uD835\uDD24","gg":"\u226B","Gg":"\u22D9","ggg":"\u22D9","gimel":"\u2137","GJcy":"\u0403","gjcy":"\u0453","gla":"\u2AA5","gl":"\u2277","glE":"\u2A92","glj":"\u2AA4","gnap":"\u2A8A","gnapprox":"\u2A8A","gne":"\u2A88","gnE":"\u2269","gneq":"\u2A88","gneqq":"\u2269","gnsim":"\u22E7","Gopf":"\uD835\uDD3E","gopf":"\uD835\uDD58","grave":"`","GreaterEqual":"\u2265","GreaterEqualLess":"\u22DB","GreaterFullEqual":"\u2267","GreaterGreater":"\u2AA2","GreaterLess":"\u2277","GreaterSlantEqual":"\u2A7E","GreaterTilde":"\u2273","Gscr":"\uD835\uDCA2","gscr":"\u210A","gsim":"\u2273","gsime":"\u2A8E","gsiml":"\u2A90","gtcc":"\u2AA7","gtcir":"\u2A7A","gt":">","GT":">","Gt":"\u226B","gtdot":"\u22D7","gtlPar":"\u2995","gtquest":"\u2A7C","gtrapprox":"\u2A86","gtrarr":"\u2978","gtrdot":"\u22D7","gtreqless":"\u22DB","gtreqqless":"\u2A8C","gtrless":"\u2277","gtrsim":"\u2273","gvertneqq":"\u2269\uFE00","gvnE":"\u2269\uFE00","Hacek":"\u02C7","hairsp":"\u200A","half":"\xbd","hamilt":"\u210B","HARDcy":"\u042A","hardcy":"\u044A","harrcir":"\u2948","harr":"\u2194","hArr":"\u21D4","harrw":"\u21AD","Hat":"^","hbar":"\u210F","Hcirc":"\u0124","hcirc":"\u0125","hearts":"\u2665","heartsuit":"\u2665","hellip":"\u2026","hercon":"\u22B9","hfr":"\uD835\uDD25","Hfr":"\u210C","HilbertSpace":"\u210B","hksearow":"\u2925","hkswarow":"\u2926","hoarr":"\u21FF","homtht":"\u223B","hookleftarrow":"\u21A9","hookrightarrow":"\u21AA","hopf":"\uD835\uDD59","Hopf":"\u210D","horbar":"\u2015","HorizontalLine":"\u2500","hscr":"\uD835\uDCBD","Hscr":"\u210B","hslash":"\u210F","Hstrok":"\u0126","hstrok":"\u0127","HumpDownHump":"\u224E","HumpEqual":"\u224F","hybull":"\u2043","hyphen":"\u2010","Iacute":"\xcd","iacute":"\xed","ic":"\u2063","Icirc":"\xce","icirc":"\xee","Icy":"\u0418","icy":"\u0438","Idot":"\u0130","IEcy":"\u0415","iecy":"\u0435","iexcl":"\xa1","iff":"\u21D4","ifr":"\uD835\uDD26","Ifr":"\u2111","Igrave":"\xcc","igrave":"\xec","ii":"\u2148","iiiint":"\u2A0C","iiint":"\u222D","iinfin":"\u29DC","iiota":"\u2129","IJlig":"\u0132","ijlig":"\u0133","Imacr":"\u012A","imacr":"\u012B","image":"\u2111","ImaginaryI":"\u2148","imagline":"\u2110","imagpart":"\u2111","imath":"\u0131","Im":"\u2111","imof":"\u22B7","imped":"\u01B5","Implies":"\u21D2","incare":"\u2105","in":"\u2208","infin":"\u221E","infintie":"\u29DD","inodot":"\u0131","intcal":"\u22BA","int":"\u222B","Int":"\u222C","integers":"\u2124","Integral":"\u222B","intercal":"\u22BA","Intersection":"\u22C2","intlarhk":"\u2A17","intprod":"\u2A3C","InvisibleComma":"\u2063","InvisibleTimes":"\u2062","IOcy":"\u0401","iocy":"\u0451","Iogon":"\u012E","iogon":"\u012F","Iopf":"\uD835\uDD40","iopf":"\uD835\uDD5A","Iota":"\u0399","iota":"\u03B9","iprod":"\u2A3C","iquest":"\xbf","iscr":"\uD835\uDCBE","Iscr":"\u2110","isin":"\u2208","isindot":"\u22F5","isinE":"\u22F9","isins":"\u22F4","isinsv":"\u22F3","isinv":"\u2208","it":"\u2062","Itilde":"\u0128","itilde":"\u0129","Iukcy":"\u0406","iukcy":"\u0456","Iuml":"\xcf","iuml":"\xef","Jcirc":"\u0134","jcirc":"\u0135","Jcy":"\u0419","jcy":"\u0439","Jfr":"\uD835\uDD0D","jfr":"\uD835\uDD27","jmath":"\u0237","Jopf":"\uD835\uDD41","jopf":"\uD835\uDD5B","Jscr":"\uD835\uDCA5","jscr":"\uD835\uDCBF","Jsercy":"\u0408","jsercy":"\u0458","Jukcy":"\u0404","jukcy":"\u0454","Kappa":"\u039A","kappa":"\u03BA","kappav":"\u03F0","Kcedil":"\u0136","kcedil":"\u0137","Kcy":"\u041A","kcy":"\u043A","Kfr":"\uD835\uDD0E","kfr":"\uD835\uDD28","kgreen":"\u0138","KHcy":"\u0425","khcy":"\u0445","KJcy":"\u040C","kjcy":"\u045C","Kopf":"\uD835\uDD42","kopf":"\uD835\uDD5C","Kscr":"\uD835\uDCA6","kscr":"\uD835\uDCC0","lAarr":"\u21DA","Lacute":"\u0139","lacute":"\u013A","laemptyv":"\u29B4","lagran":"\u2112","Lambda":"\u039B","lambda":"\u03BB","lang":"\u27E8","Lang":"\u27EA","langd":"\u2991","langle":"\u27E8","lap":"\u2A85","Laplacetrf":"\u2112","laquo":"\xab","larrb":"\u21E4","larrbfs":"\u291F","larr":"\u2190","Larr":"\u219E","lArr":"\u21D0","larrfs":"\u291D","larrhk":"\u21A9","larrlp":"\u21AB","larrpl":"\u2939","larrsim":"\u2973","larrtl":"\u21A2","latail":"\u2919","lAtail":"\u291B","lat":"\u2AAB","late":"\u2AAD","lates":"\u2AAD\uFE00","lbarr":"\u290C","lBarr":"\u290E","lbbrk":"\u2772","lbrace":"{","lbrack":"[","lbrke":"\u298B","lbrksld":"\u298F","lbrkslu":"\u298D","Lcaron":"\u013D","lcaron":"\u013E","Lcedil":"\u013B","lcedil":"\u013C","lceil":"\u2308","lcub":"{","Lcy":"\u041B","lcy":"\u043B","ldca":"\u2936","ldquo":"\u201C","ldquor":"\u201E","ldrdhar":"\u2967","ldrushar":"\u294B","ldsh":"\u21B2","le":"\u2264","lE":"\u2266","LeftAngleBracket":"\u27E8","LeftArrowBar":"\u21E4","leftarrow":"\u2190","LeftArrow":"\u2190","Leftarrow":"\u21D0","LeftArrowRightArrow":"\u21C6","leftarrowtail":"\u21A2","LeftCeiling":"\u2308","LeftDoubleBracket":"\u27E6","LeftDownTeeVector":"\u2961","LeftDownVectorBar":"\u2959","LeftDownVector":"\u21C3","LeftFloor":"\u230A","leftharpoondown":"\u21BD","leftharpoonup":"\u21BC","leftleftarrows":"\u21C7","leftrightarrow":"\u2194","LeftRightArrow":"\u2194","Leftrightarrow":"\u21D4","leftrightarrows":"\u21C6","leftrightharpoons":"\u21CB","leftrightsquigarrow":"\u21AD","LeftRightVector":"\u294E","LeftTeeArrow":"\u21A4","LeftTee":"\u22A3","LeftTeeVector":"\u295A","leftthreetimes":"\u22CB","LeftTriangleBar":"\u29CF","LeftTriangle":"\u22B2","LeftTriangleEqual":"\u22B4","LeftUpDownVector":"\u2951","LeftUpTeeVector":"\u2960","LeftUpVectorBar":"\u2958","LeftUpVector":"\u21BF","LeftVectorBar":"\u2952","LeftVector":"\u21BC","lEg":"\u2A8B","leg":"\u22DA","leq":"\u2264","leqq":"\u2266","leqslant":"\u2A7D","lescc":"\u2AA8","les":"\u2A7D","lesdot":"\u2A7F","lesdoto":"\u2A81","lesdotor":"\u2A83","lesg":"\u22DA\uFE00","lesges":"\u2A93","lessapprox":"\u2A85","lessdot":"\u22D6","lesseqgtr":"\u22DA","lesseqqgtr":"\u2A8B","LessEqualGreater":"\u22DA","LessFullEqual":"\u2266","LessGreater":"\u2276","lessgtr":"\u2276","LessLess":"\u2AA1","lesssim":"\u2272","LessSlantEqual":"\u2A7D","LessTilde":"\u2272","lfisht":"\u297C","lfloor":"\u230A","Lfr":"\uD835\uDD0F","lfr":"\uD835\uDD29","lg":"\u2276","lgE":"\u2A91","lHar":"\u2962","lhard":"\u21BD","lharu":"\u21BC","lharul":"\u296A","lhblk":"\u2584","LJcy":"\u0409","ljcy":"\u0459","llarr":"\u21C7","ll":"\u226A","Ll":"\u22D8","llcorner":"\u231E","Lleftarrow":"\u21DA","llhard":"\u296B","lltri":"\u25FA","Lmidot":"\u013F","lmidot":"\u0140","lmoustache":"\u23B0","lmoust":"\u23B0","lnap":"\u2A89","lnapprox":"\u2A89","lne":"\u2A87","lnE":"\u2268","lneq":"\u2A87","lneqq":"\u2268","lnsim":"\u22E6","loang":"\u27EC","loarr":"\u21FD","lobrk":"\u27E6","longleftarrow":"\u27F5","LongLeftArrow":"\u27F5","Longleftarrow":"\u27F8","longleftrightarrow":"\u27F7","LongLeftRightArrow":"\u27F7","Longleftrightarrow":"\u27FA","longmapsto":"\u27FC","longrightarrow":"\u27F6","LongRightArrow":"\u27F6","Longrightarrow":"\u27F9","looparrowleft":"\u21AB","looparrowright":"\u21AC","lopar":"\u2985","Lopf":"\uD835\uDD43","lopf":"\uD835\uDD5D","loplus":"\u2A2D","lotimes":"\u2A34","lowast":"\u2217","lowbar":"_","LowerLeftArrow":"\u2199","LowerRightArrow":"\u2198","loz":"\u25CA","lozenge":"\u25CA","lozf":"\u29EB","lpar":"(","lparlt":"\u2993","lrarr":"\u21C6","lrcorner":"\u231F","lrhar":"\u21CB","lrhard":"\u296D","lrm":"\u200E","lrtri":"\u22BF","lsaquo":"\u2039","lscr":"\uD835\uDCC1","Lscr":"\u2112","lsh":"\u21B0","Lsh":"\u21B0","lsim":"\u2272","lsime":"\u2A8D","lsimg":"\u2A8F","lsqb":"[","lsquo":"\u2018","lsquor":"\u201A","Lstrok":"\u0141","lstrok":"\u0142","ltcc":"\u2AA6","ltcir":"\u2A79","lt":"<","LT":"<","Lt":"\u226A","ltdot":"\u22D6","lthree":"\u22CB","ltimes":"\u22C9","ltlarr":"\u2976","ltquest":"\u2A7B","ltri":"\u25C3","ltrie":"\u22B4","ltrif":"\u25C2","ltrPar":"\u2996","lurdshar":"\u294A","luruhar":"\u2966","lvertneqq":"\u2268\uFE00","lvnE":"\u2268\uFE00","macr":"\xaf","male":"\u2642","malt":"\u2720","maltese":"\u2720","Map":"\u2905","map":"\u21A6","mapsto":"\u21A6","mapstodown":"\u21A7","mapstoleft":"\u21A4","mapstoup":"\u21A5","marker":"\u25AE","mcomma":"\u2A29","Mcy":"\u041C","mcy":"\u043C","mdash":"\u2014","mDDot":"\u223A","measuredangle":"\u2221","MediumSpace":"\u205F","Mellintrf":"\u2133","Mfr":"\uD835\uDD10","mfr":"\uD835\uDD2A","mho":"\u2127","micro":"\xb5","midast":"*","midcir":"\u2AF0","mid":"\u2223","middot":"\xb7","minusb":"\u229F","minus":"\u2212","minusd":"\u2238","minusdu":"\u2A2A","MinusPlus":"\u2213","mlcp":"\u2ADB","mldr":"\u2026","mnplus":"\u2213","models":"\u22A7","Mopf":"\uD835\uDD44","mopf":"\uD835\uDD5E","mp":"\u2213","mscr":"\uD835\uDCC2","Mscr":"\u2133","mstpos":"\u223E","Mu":"\u039C","mu":"\u03BC","multimap":"\u22B8","mumap":"\u22B8","nabla":"\u2207","Nacute":"\u0143","nacute":"\u0144","nang":"\u2220\u20D2","nap":"\u2249","napE":"\u2A70\u0338","napid":"\u224B\u0338","napos":"\u0149","napprox":"\u2249","natural":"\u266E","naturals":"\u2115","natur":"\u266E","nbsp":"\xa0","nbump":"\u224E\u0338","nbumpe":"\u224F\u0338","ncap":"\u2A43","Ncaron":"\u0147","ncaron":"\u0148","Ncedil":"\u0145","ncedil":"\u0146","ncong":"\u2247","ncongdot":"\u2A6D\u0338","ncup":"\u2A42","Ncy":"\u041D","ncy":"\u043D","ndash":"\u2013","nearhk":"\u2924","nearr":"\u2197","neArr":"\u21D7","nearrow":"\u2197","ne":"\u2260","nedot":"\u2250\u0338","NegativeMediumSpace":"\u200B","NegativeThickSpace":"\u200B","NegativeThinSpace":"\u200B","NegativeVeryThinSpace":"\u200B","nequiv":"\u2262","nesear":"\u2928","nesim":"\u2242\u0338","NestedGreaterGreater":"\u226B","NestedLessLess":"\u226A","NewLine":"\\n","nexist":"\u2204","nexists":"\u2204","Nfr":"\uD835\uDD11","nfr":"\uD835\uDD2B","ngE":"\u2267\u0338","nge":"\u2271","ngeq":"\u2271","ngeqq":"\u2267\u0338","ngeqslant":"\u2A7E\u0338","nges":"\u2A7E\u0338","nGg":"\u22D9\u0338","ngsim":"\u2275","nGt":"\u226B\u20D2","ngt":"\u226F","ngtr":"\u226F","nGtv":"\u226B\u0338","nharr":"\u21AE","nhArr":"\u21CE","nhpar":"\u2AF2","ni":"\u220B","nis":"\u22FC","nisd":"\u22FA","niv":"\u220B","NJcy":"\u040A","njcy":"\u045A","nlarr":"\u219A","nlArr":"\u21CD","nldr":"\u2025","nlE":"\u2266\u0338","nle":"\u2270","nleftarrow":"\u219A","nLeftarrow":"\u21CD","nleftrightarrow":"\u21AE","nLeftrightarrow":"\u21CE","nleq":"\u2270","nleqq":"\u2266\u0338","nleqslant":"\u2A7D\u0338","nles":"\u2A7D\u0338","nless":"\u226E","nLl":"\u22D8\u0338","nlsim":"\u2274","nLt":"\u226A\u20D2","nlt":"\u226E","nltri":"\u22EA","nltrie":"\u22EC","nLtv":"\u226A\u0338","nmid":"\u2224","NoBreak":"\u2060","NonBreakingSpace":"\xa0","nopf":"\uD835\uDD5F","Nopf":"\u2115","Not":"\u2AEC","not":"\xac","NotCongruent":"\u2262","NotCupCap":"\u226D","NotDoubleVerticalBar":"\u2226","NotElement":"\u2209","NotEqual":"\u2260","NotEqualTilde":"\u2242\u0338","NotExists":"\u2204","NotGreater":"\u226F","NotGreaterEqual":"\u2271","NotGreaterFullEqual":"\u2267\u0338","NotGreaterGreater":"\u226B\u0338","NotGreaterLess":"\u2279","NotGreaterSlantEqual":"\u2A7E\u0338","NotGreaterTilde":"\u2275","NotHumpDownHump":"\u224E\u0338","NotHumpEqual":"\u224F\u0338","notin":"\u2209","notindot":"\u22F5\u0338","notinE":"\u22F9\u0338","notinva":"\u2209","notinvb":"\u22F7","notinvc":"\u22F6","NotLeftTriangleBar":"\u29CF\u0338","NotLeftTriangle":"\u22EA","NotLeftTriangleEqual":"\u22EC","NotLess":"\u226E","NotLessEqual":"\u2270","NotLessGreater":"\u2278","NotLessLess":"\u226A\u0338","NotLessSlantEqual":"\u2A7D\u0338","NotLessTilde":"\u2274","NotNestedGreaterGreater":"\u2AA2\u0338","NotNestedLessLess":"\u2AA1\u0338","notni":"\u220C","notniva":"\u220C","notnivb":"\u22FE","notnivc":"\u22FD","NotPrecedes":"\u2280","NotPrecedesEqual":"\u2AAF\u0338","NotPrecedesSlantEqual":"\u22E0","NotReverseElement":"\u220C","NotRightTriangleBar":"\u29D0\u0338","NotRightTriangle":"\u22EB","NotRightTriangleEqual":"\u22ED","NotSquareSubset":"\u228F\u0338","NotSquareSubsetEqual":"\u22E2","NotSquareSuperset":"\u2290\u0338","NotSquareSupersetEqual":"\u22E3","NotSubset":"\u2282\u20D2","NotSubsetEqual":"\u2288","NotSucceeds":"\u2281","NotSucceedsEqual":"\u2AB0\u0338","NotSucceedsSlantEqual":"\u22E1","NotSucceedsTilde":"\u227F\u0338","NotSuperset":"\u2283\u20D2","NotSupersetEqual":"\u2289","NotTilde":"\u2241","NotTildeEqual":"\u2244","NotTildeFullEqual":"\u2247","NotTildeTilde":"\u2249","NotVerticalBar":"\u2224","nparallel":"\u2226","npar":"\u2226","nparsl":"\u2AFD\u20E5","npart":"\u2202\u0338","npolint":"\u2A14","npr":"\u2280","nprcue":"\u22E0","nprec":"\u2280","npreceq":"\u2AAF\u0338","npre":"\u2AAF\u0338","nrarrc":"\u2933\u0338","nrarr":"\u219B","nrArr":"\u21CF","nrarrw":"\u219D\u0338","nrightarrow":"\u219B","nRightarrow":"\u21CF","nrtri":"\u22EB","nrtrie":"\u22ED","nsc":"\u2281","nsccue":"\u22E1","nsce":"\u2AB0\u0338","Nscr":"\uD835\uDCA9","nscr":"\uD835\uDCC3","nshortmid":"\u2224","nshortparallel":"\u2226","nsim":"\u2241","nsime":"\u2244","nsimeq":"\u2244","nsmid":"\u2224","nspar":"\u2226","nsqsube":"\u22E2","nsqsupe":"\u22E3","nsub":"\u2284","nsubE":"\u2AC5\u0338","nsube":"\u2288","nsubset":"\u2282\u20D2","nsubseteq":"\u2288","nsubseteqq":"\u2AC5\u0338","nsucc":"\u2281","nsucceq":"\u2AB0\u0338","nsup":"\u2285","nsupE":"\u2AC6\u0338","nsupe":"\u2289","nsupset":"\u2283\u20D2","nsupseteq":"\u2289","nsupseteqq":"\u2AC6\u0338","ntgl":"\u2279","Ntilde":"\xd1","ntilde":"\xf1","ntlg":"\u2278","ntriangleleft":"\u22EA","ntrianglelefteq":"\u22EC","ntriangleright":"\u22EB","ntrianglerighteq":"\u22ED","Nu":"\u039D","nu":"\u03BD","num":"#","numero":"\u2116","numsp":"\u2007","nvap":"\u224D\u20D2","nvdash":"\u22AC","nvDash":"\u22AD","nVdash":"\u22AE","nVDash":"\u22AF","nvge":"\u2265\u20D2","nvgt":">\u20D2","nvHarr":"\u2904","nvinfin":"\u29DE","nvlArr":"\u2902","nvle":"\u2264\u20D2","nvlt":"<\u20D2","nvltrie":"\u22B4\u20D2","nvrArr":"\u2903","nvrtrie":"\u22B5\u20D2","nvsim":"\u223C\u20D2","nwarhk":"\u2923","nwarr":"\u2196","nwArr":"\u21D6","nwarrow":"\u2196","nwnear":"\u2927","Oacute":"\xd3","oacute":"\xf3","oast":"\u229B","Ocirc":"\xd4","ocirc":"\xf4","ocir":"\u229A","Ocy":"\u041E","ocy":"\u043E","odash":"\u229D","Odblac":"\u0150","odblac":"\u0151","odiv":"\u2A38","odot":"\u2299","odsold":"\u29BC","OElig":"\u0152","oelig":"\u0153","ofcir":"\u29BF","Ofr":"\uD835\uDD12","ofr":"\uD835\uDD2C","ogon":"\u02DB","Ograve":"\xd2","ograve":"\xf2","ogt":"\u29C1","ohbar":"\u29B5","ohm":"\u03A9","oint":"\u222E","olarr":"\u21BA","olcir":"\u29BE","olcross":"\u29BB","oline":"\u203E","olt":"\u29C0","Omacr":"\u014C","omacr":"\u014D","Omega":"\u03A9","omega":"\u03C9","Omicron":"\u039F","omicron":"\u03BF","omid":"\u29B6","ominus":"\u2296","Oopf":"\uD835\uDD46","oopf":"\uD835\uDD60","opar":"\u29B7","OpenCurlyDoubleQuote":"\u201C","OpenCurlyQuote":"\u2018","operp":"\u29B9","oplus":"\u2295","orarr":"\u21BB","Or":"\u2A54","or":"\u2228","ord":"\u2A5D","order":"\u2134","orderof":"\u2134","ordf":"\xaa","ordm":"\xba","origof":"\u22B6","oror":"\u2A56","orslope":"\u2A57","orv":"\u2A5B","oS":"\u24C8","Oscr":"\uD835\uDCAA","oscr":"\u2134","Oslash":"\xd8","oslash":"\xf8","osol":"\u2298","Otilde":"\xd5","otilde":"\xf5","otimesas":"\u2A36","Otimes":"\u2A37","otimes":"\u2297","Ouml":"\xd6","ouml":"\xf6","ovbar":"\u233D","OverBar":"\u203E","OverBrace":"\u23DE","OverBracket":"\u23B4","OverParenthesis":"\u23DC","para":"\xb6","parallel":"\u2225","par":"\u2225","parsim":"\u2AF3","parsl":"\u2AFD","part":"\u2202","PartialD":"\u2202","Pcy":"\u041F","pcy":"\u043F","percnt":"%","period":".","permil":"\u2030","perp":"\u22A5","pertenk":"\u2031","Pfr":"\uD835\uDD13","pfr":"\uD835\uDD2D","Phi":"\u03A6","phi":"\u03C6","phiv":"\u03D5","phmmat":"\u2133","phone":"\u260E","Pi":"\u03A0","pi":"\u03C0","pitchfork":"\u22D4","piv":"\u03D6","planck":"\u210F","planckh":"\u210E","plankv":"\u210F","plusacir":"\u2A23","plusb":"\u229E","pluscir":"\u2A22","plus":"+","plusdo":"\u2214","plusdu":"\u2A25","pluse":"\u2A72","PlusMinus":"\xb1","plusmn":"\xb1","plussim":"\u2A26","plustwo":"\u2A27","pm":"\xb1","Poincareplane":"\u210C","pointint":"\u2A15","popf":"\uD835\uDD61","Popf":"\u2119","pound":"\xa3","prap":"\u2AB7","Pr":"\u2ABB","pr":"\u227A","prcue":"\u227C","precapprox":"\u2AB7","prec":"\u227A","preccurlyeq":"\u227C","Precedes":"\u227A","PrecedesEqual":"\u2AAF","PrecedesSlantEqual":"\u227C","PrecedesTilde":"\u227E","preceq":"\u2AAF","precnapprox":"\u2AB9","precneqq":"\u2AB5","precnsim":"\u22E8","pre":"\u2AAF","prE":"\u2AB3","precsim":"\u227E","prime":"\u2032","Prime":"\u2033","primes":"\u2119","prnap":"\u2AB9","prnE":"\u2AB5","prnsim":"\u22E8","prod":"\u220F","Product":"\u220F","profalar":"\u232E","profline":"\u2312","profsurf":"\u2313","prop":"\u221D","Proportional":"\u221D","Proportion":"\u2237","propto":"\u221D","prsim":"\u227E","prurel":"\u22B0","Pscr":"\uD835\uDCAB","pscr":"\uD835\uDCC5","Psi":"\u03A8","psi":"\u03C8","puncsp":"\u2008","Qfr":"\uD835\uDD14","qfr":"\uD835\uDD2E","qint":"\u2A0C","qopf":"\uD835\uDD62","Qopf":"\u211A","qprime":"\u2057","Qscr":"\uD835\uDCAC","qscr":"\uD835\uDCC6","quaternions":"\u210D","quatint":"\u2A16","quest":"?","questeq":"\u225F","quot":"\\"","QUOT":"\\"","rAarr":"\u21DB","race":"\u223D\u0331","Racute":"\u0154","racute":"\u0155","radic":"\u221A","raemptyv":"\u29B3","rang":"\u27E9","Rang":"\u27EB","rangd":"\u2992","range":"\u29A5","rangle":"\u27E9","raquo":"\xbb","rarrap":"\u2975","rarrb":"\u21E5","rarrbfs":"\u2920","rarrc":"\u2933","rarr":"\u2192","Rarr":"\u21A0","rArr":"\u21D2","rarrfs":"\u291E","rarrhk":"\u21AA","rarrlp":"\u21AC","rarrpl":"\u2945","rarrsim":"\u2974","Rarrtl":"\u2916","rarrtl":"\u21A3","rarrw":"\u219D","ratail":"\u291A","rAtail":"\u291C","ratio":"\u2236","rationals":"\u211A","rbarr":"\u290D","rBarr":"\u290F","RBarr":"\u2910","rbbrk":"\u2773","rbrace":"}","rbrack":"]","rbrke":"\u298C","rbrksld":"\u298E","rbrkslu":"\u2990","Rcaron":"\u0158","rcaron":"\u0159","Rcedil":"\u0156","rcedil":"\u0157","rceil":"\u2309","rcub":"}","Rcy":"\u0420","rcy":"\u0440","rdca":"\u2937","rdldhar":"\u2969","rdquo":"\u201D","rdquor":"\u201D","rdsh":"\u21B3","real":"\u211C","realine":"\u211B","realpart":"\u211C","reals":"\u211D","Re":"\u211C","rect":"\u25AD","reg":"\xae","REG":"\xae","ReverseElement":"\u220B","ReverseEquilibrium":"\u21CB","ReverseUpEquilibrium":"\u296F","rfisht":"\u297D","rfloor":"\u230B","rfr":"\uD835\uDD2F","Rfr":"\u211C","rHar":"\u2964","rhard":"\u21C1","rharu":"\u21C0","rharul":"\u296C","Rho":"\u03A1","rho":"\u03C1","rhov":"\u03F1","RightAngleBracket":"\u27E9","RightArrowBar":"\u21E5","rightarrow":"\u2192","RightArrow":"\u2192","Rightarrow":"\u21D2","RightArrowLeftArrow":"\u21C4","rightarrowtail":"\u21A3","RightCeiling":"\u2309","RightDoubleBracket":"\u27E7","RightDownTeeVector":"\u295D","RightDownVectorBar":"\u2955","RightDownVector":"\u21C2","RightFloor":"\u230B","rightharpoondown":"\u21C1","rightharpoonup":"\u21C0","rightleftarrows":"\u21C4","rightleftharpoons":"\u21CC","rightrightarrows":"\u21C9","rightsquigarrow":"\u219D","RightTeeArrow":"\u21A6","RightTee":"\u22A2","RightTeeVector":"\u295B","rightthreetimes":"\u22CC","RightTriangleBar":"\u29D0","RightTriangle":"\u22B3","RightTriangleEqual":"\u22B5","RightUpDownVector":"\u294F","RightUpTeeVector":"\u295C","RightUpVectorBar":"\u2954","RightUpVector":"\u21BE","RightVectorBar":"\u2953","RightVector":"\u21C0","ring":"\u02DA","risingdotseq":"\u2253","rlarr":"\u21C4","rlhar":"\u21CC","rlm":"\u200F","rmoustache":"\u23B1","rmoust":"\u23B1","rnmid":"\u2AEE","roang":"\u27ED","roarr":"\u21FE","robrk":"\u27E7","ropar":"\u2986","ropf":"\uD835\uDD63","Ropf":"\u211D","roplus":"\u2A2E","rotimes":"\u2A35","RoundImplies":"\u2970","rpar":")","rpargt":"\u2994","rppolint":"\u2A12","rrarr":"\u21C9","Rrightarrow":"\u21DB","rsaquo":"\u203A","rscr":"\uD835\uDCC7","Rscr":"\u211B","rsh":"\u21B1","Rsh":"\u21B1","rsqb":"]","rsquo":"\u2019","rsquor":"\u2019","rthree":"\u22CC","rtimes":"\u22CA","rtri":"\u25B9","rtrie":"\u22B5","rtrif":"\u25B8","rtriltri":"\u29CE","RuleDelayed":"\u29F4","ruluhar":"\u2968","rx":"\u211E","Sacute":"\u015A","sacute":"\u015B","sbquo":"\u201A","scap":"\u2AB8","Scaron":"\u0160","scaron":"\u0161","Sc":"\u2ABC","sc":"\u227B","sccue":"\u227D","sce":"\u2AB0","scE":"\u2AB4","Scedil":"\u015E","scedil":"\u015F","Scirc":"\u015C","scirc":"\u015D","scnap":"\u2ABA","scnE":"\u2AB6","scnsim":"\u22E9","scpolint":"\u2A13","scsim":"\u227F","Scy":"\u0421","scy":"\u0441","sdotb":"\u22A1","sdot":"\u22C5","sdote":"\u2A66","searhk":"\u2925","searr":"\u2198","seArr":"\u21D8","searrow":"\u2198","sect":"\xa7","semi":";","seswar":"\u2929","setminus":"\u2216","setmn":"\u2216","sext":"\u2736","Sfr":"\uD835\uDD16","sfr":"\uD835\uDD30","sfrown":"\u2322","sharp":"\u266F","SHCHcy":"\u0429","shchcy":"\u0449","SHcy":"\u0428","shcy":"\u0448","ShortDownArrow":"\u2193","ShortLeftArrow":"\u2190","shortmid":"\u2223","shortparallel":"\u2225","ShortRightArrow":"\u2192","ShortUpArrow":"\u2191","shy":"\xad","Sigma":"\u03A3","sigma":"\u03C3","sigmaf":"\u03C2","sigmav":"\u03C2","sim":"\u223C","simdot":"\u2A6A","sime":"\u2243","simeq":"\u2243","simg":"\u2A9E","simgE":"\u2AA0","siml":"\u2A9D","simlE":"\u2A9F","simne":"\u2246","simplus":"\u2A24","simrarr":"\u2972","slarr":"\u2190","SmallCircle":"\u2218","smallsetminus":"\u2216","smashp":"\u2A33","smeparsl":"\u29E4","smid":"\u2223","smile":"\u2323","smt":"\u2AAA","smte":"\u2AAC","smtes":"\u2AAC\uFE00","SOFTcy":"\u042C","softcy":"\u044C","solbar":"\u233F","solb":"\u29C4","sol":"\\/","Sopf":"\uD835\uDD4A","sopf":"\uD835\uDD64","spades":"\u2660","spadesuit":"\u2660","spar":"\u2225","sqcap":"\u2293","sqcaps":"\u2293\uFE00","sqcup":"\u2294","sqcups":"\u2294\uFE00","Sqrt":"\u221A","sqsub":"\u228F","sqsube":"\u2291","sqsubset":"\u228F","sqsubseteq":"\u2291","sqsup":"\u2290","sqsupe":"\u2292","sqsupset":"\u2290","sqsupseteq":"\u2292","square":"\u25A1","Square":"\u25A1","SquareIntersection":"\u2293","SquareSubset":"\u228F","SquareSubsetEqual":"\u2291","SquareSuperset":"\u2290","SquareSupersetEqual":"\u2292","SquareUnion":"\u2294","squarf":"\u25AA","squ":"\u25A1","squf":"\u25AA","srarr":"\u2192","Sscr":"\uD835\uDCAE","sscr":"\uD835\uDCC8","ssetmn":"\u2216","ssmile":"\u2323","sstarf":"\u22C6","Star":"\u22C6","star":"\u2606","starf":"\u2605","straightepsilon":"\u03F5","straightphi":"\u03D5","strns":"\xaf","sub":"\u2282","Sub":"\u22D0","subdot":"\u2ABD","subE":"\u2AC5","sube":"\u2286","subedot":"\u2AC3","submult":"\u2AC1","subnE":"\u2ACB","subne":"\u228A","subplus":"\u2ABF","subrarr":"\u2979","subset":"\u2282","Subset":"\u22D0","subseteq":"\u2286","subseteqq":"\u2AC5","SubsetEqual":"\u2286","subsetneq":"\u228A","subsetneqq":"\u2ACB","subsim":"\u2AC7","subsub":"\u2AD5","subsup":"\u2AD3","succapprox":"\u2AB8","succ":"\u227B","succcurlyeq":"\u227D","Succeeds":"\u227B","SucceedsEqual":"\u2AB0","SucceedsSlantEqual":"\u227D","SucceedsTilde":"\u227F","succeq":"\u2AB0","succnapprox":"\u2ABA","succneqq":"\u2AB6","succnsim":"\u22E9","succsim":"\u227F","SuchThat":"\u220B","sum":"\u2211","Sum":"\u2211","sung":"\u266A","sup1":"\xb9","sup2":"\xb2","sup3":"\xb3","sup":"\u2283","Sup":"\u22D1","supdot":"\u2ABE","supdsub":"\u2AD8","supE":"\u2AC6","supe":"\u2287","supedot":"\u2AC4","Superset":"\u2283","SupersetEqual":"\u2287","suphsol":"\u27C9","suphsub":"\u2AD7","suplarr":"\u297B","supmult":"\u2AC2","supnE":"\u2ACC","supne":"\u228B","supplus":"\u2AC0","supset":"\u2283","Supset":"\u22D1","supseteq":"\u2287","supseteqq":"\u2AC6","supsetneq":"\u228B","supsetneqq":"\u2ACC","supsim":"\u2AC8","supsub":"\u2AD4","supsup":"\u2AD6","swarhk":"\u2926","swarr":"\u2199","swArr":"\u21D9","swarrow":"\u2199","swnwar":"\u292A","szlig":"\xdf","Tab":"\\t","target":"\u2316","Tau":"\u03A4","tau":"\u03C4","tbrk":"\u23B4","Tcaron":"\u0164","tcaron":"\u0165","Tcedil":"\u0162","tcedil":"\u0163","Tcy":"\u0422","tcy":"\u0442","tdot":"\u20DB","telrec":"\u2315","Tfr":"\uD835\uDD17","tfr":"\uD835\uDD31","there4":"\u2234","therefore":"\u2234","Therefore":"\u2234","Theta":"\u0398","theta":"\u03B8","thetasym":"\u03D1","thetav":"\u03D1","thickapprox":"\u2248","thicksim":"\u223C","ThickSpace":"\u205F\u200A","ThinSpace":"\u2009","thinsp":"\u2009","thkap":"\u2248","thksim":"\u223C","THORN":"\xde","thorn":"\xfe","tilde":"\u02DC","Tilde":"\u223C","TildeEqual":"\u2243","TildeFullEqual":"\u2245","TildeTilde":"\u2248","timesbar":"\u2A31","timesb":"\u22A0","times":"\xd7","timesd":"\u2A30","tint":"\u222D","toea":"\u2928","topbot":"\u2336","topcir":"\u2AF1","top":"\u22A4","Topf":"\uD835\uDD4B","topf":"\uD835\uDD65","topfork":"\u2ADA","tosa":"\u2929","tprime":"\u2034","trade":"\u2122","TRADE":"\u2122","triangle":"\u25B5","triangledown":"\u25BF","triangleleft":"\u25C3","trianglelefteq":"\u22B4","triangleq":"\u225C","triangleright":"\u25B9","trianglerighteq":"\u22B5","tridot":"\u25EC","trie":"\u225C","triminus":"\u2A3A","TripleDot":"\u20DB","triplus":"\u2A39","trisb":"\u29CD","tritime":"\u2A3B","trpezium":"\u23E2","Tscr":"\uD835\uDCAF","tscr":"\uD835\uDCC9","TScy":"\u0426","tscy":"\u0446","TSHcy":"\u040B","tshcy":"\u045B","Tstrok":"\u0166","tstrok":"\u0167","twixt":"\u226C","twoheadleftarrow":"\u219E","twoheadrightarrow":"\u21A0","Uacute":"\xda","uacute":"\xfa","uarr":"\u2191","Uarr":"\u219F","uArr":"\u21D1","Uarrocir":"\u2949","Ubrcy":"\u040E","ubrcy":"\u045E","Ubreve":"\u016C","ubreve":"\u016D","Ucirc":"\xdb","ucirc":"\xfb","Ucy":"\u0423","ucy":"\u0443","udarr":"\u21C5","Udblac":"\u0170","udblac":"\u0171","udhar":"\u296E","ufisht":"\u297E","Ufr":"\uD835\uDD18","ufr":"\uD835\uDD32","Ugrave":"\xd9","ugrave":"\xf9","uHar":"\u2963","uharl":"\u21BF","uharr":"\u21BE","uhblk":"\u2580","ulcorn":"\u231C","ulcorner":"\u231C","ulcrop":"\u230F","ultri":"\u25F8","Umacr":"\u016A","umacr":"\u016B","uml":"\xa8","UnderBar":"_","UnderBrace":"\u23DF","UnderBracket":"\u23B5","UnderParenthesis":"\u23DD","Union":"\u22C3","UnionPlus":"\u228E","Uogon":"\u0172","uogon":"\u0173","Uopf":"\uD835\uDD4C","uopf":"\uD835\uDD66","UpArrowBar":"\u2912","uparrow":"\u2191","UpArrow":"\u2191","Uparrow":"\u21D1","UpArrowDownArrow":"\u21C5","updownarrow":"\u2195","UpDownArrow":"\u2195","Updownarrow":"\u21D5","UpEquilibrium":"\u296E","upharpoonleft":"\u21BF","upharpoonright":"\u21BE","uplus":"\u228E","UpperLeftArrow":"\u2196","UpperRightArrow":"\u2197","upsi":"\u03C5","Upsi":"\u03D2","upsih":"\u03D2","Upsilon":"\u03A5","upsilon":"\u03C5","UpTeeArrow":"\u21A5","UpTee":"\u22A5","upuparrows":"\u21C8","urcorn":"\u231D","urcorner":"\u231D","urcrop":"\u230E","Uring":"\u016E","uring":"\u016F","urtri":"\u25F9","Uscr":"\uD835\uDCB0","uscr":"\uD835\uDCCA","utdot":"\u22F0","Utilde":"\u0168","utilde":"\u0169","utri":"\u25B5","utrif":"\u25B4","uuarr":"\u21C8","Uuml":"\xdc","uuml":"\xfc","uwangle":"\u29A7","vangrt":"\u299C","varepsilon":"\u03F5","varkappa":"\u03F0","varnothing":"\u2205","varphi":"\u03D5","varpi":"\u03D6","varpropto":"\u221D","varr":"\u2195","vArr":"\u21D5","varrho":"\u03F1","varsigma":"\u03C2","varsubsetneq":"\u228A\uFE00","varsubsetneqq":"\u2ACB\uFE00","varsupsetneq":"\u228B\uFE00","varsupsetneqq":"\u2ACC\uFE00","vartheta":"\u03D1","vartriangleleft":"\u22B2","vartriangleright":"\u22B3","vBar":"\u2AE8","Vbar":"\u2AEB","vBarv":"\u2AE9","Vcy":"\u0412","vcy":"\u0432","vdash":"\u22A2","vDash":"\u22A8","Vdash":"\u22A9","VDash":"\u22AB","Vdashl":"\u2AE6","veebar":"\u22BB","vee":"\u2228","Vee":"\u22C1","veeeq":"\u225A","vellip":"\u22EE","verbar":"|","Verbar":"\u2016","vert":"|","Vert":"\u2016","VerticalBar":"\u2223","VerticalLine":"|","VerticalSeparator":"\u2758","VerticalTilde":"\u2240","VeryThinSpace":"\u200A","Vfr":"\uD835\uDD19","vfr":"\uD835\uDD33","vltri":"\u22B2","vnsub":"\u2282\u20D2","vnsup":"\u2283\u20D2","Vopf":"\uD835\uDD4D","vopf":"\uD835\uDD67","vprop":"\u221D","vrtri":"\u22B3","Vscr":"\uD835\uDCB1","vscr":"\uD835\uDCCB","vsubnE":"\u2ACB\uFE00","vsubne":"\u228A\uFE00","vsupnE":"\u2ACC\uFE00","vsupne":"\u228B\uFE00","Vvdash":"\u22AA","vzigzag":"\u299A","Wcirc":"\u0174","wcirc":"\u0175","wedbar":"\u2A5F","wedge":"\u2227","Wedge":"\u22C0","wedgeq":"\u2259","weierp":"\u2118","Wfr":"\uD835\uDD1A","wfr":"\uD835\uDD34","Wopf":"\uD835\uDD4E","wopf":"\uD835\uDD68","wp":"\u2118","wr":"\u2240","wreath":"\u2240","Wscr":"\uD835\uDCB2","wscr":"\uD835\uDCCC","xcap":"\u22C2","xcirc":"\u25EF","xcup":"\u22C3","xdtri":"\u25BD","Xfr":"\uD835\uDD1B","xfr":"\uD835\uDD35","xharr":"\u27F7","xhArr":"\u27FA","Xi":"\u039E","xi":"\u03BE","xlarr":"\u27F5","xlArr":"\u27F8","xmap":"\u27FC","xnis":"\u22FB","xodot":"\u2A00","Xopf":"\uD835\uDD4F","xopf":"\uD835\uDD69","xoplus":"\u2A01","xotime":"\u2A02","xrarr":"\u27F6","xrArr":"\u27F9","Xscr":"\uD835\uDCB3","xscr":"\uD835\uDCCD","xsqcup":"\u2A06","xuplus":"\u2A04","xutri":"\u25B3","xvee":"\u22C1","xwedge":"\u22C0","Yacute":"\xdd","yacute":"\xfd","YAcy":"\u042F","yacy":"\u044F","Ycirc":"\u0176","ycirc":"\u0177","Ycy":"\u042B","ycy":"\u044B","yen":"\xa5","Yfr":"\uD835\uDD1C","yfr":"\uD835\uDD36","YIcy":"\u0407","yicy":"\u0457","Yopf":"\uD835\uDD50","yopf":"\uD835\uDD6A","Yscr":"\uD835\uDCB4","yscr":"\uD835\uDCCE","YUcy":"\u042E","yucy":"\u044E","yuml":"\xff","Yuml":"\u0178","Zacute":"\u0179","zacute":"\u017A","Zcaron":"\u017D","zcaron":"\u017E","Zcy":"\u0417","zcy":"\u0437","Zdot":"\u017B","zdot":"\u017C","zeetrf":"\u2128","ZeroWidthSpace":"\u200B","Zeta":"\u0396","zeta":"\u03B6","zfr":"\uD835\uDD37","Zfr":"\u2128","ZHcy":"\u0416","zhcy":"\u0436","zigrarr":"\u21DD","zopf":"\uD835\uDD6B","Zopf":"\u2124","Zscr":"\uD835\uDCB5","zscr":"\uD835\uDCCF","zwj":"\u200D","zwnj":"\u200C"}');

});


parcelRegister("90JXC", function(module, exports) {
$parcel$export(module.exports, "encode", () => $68f7c3f7224c7eb2$export$c564cdbbe6da493, (v) => $68f7c3f7224c7eb2$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "decode", () => $68f7c3f7224c7eb2$export$2f872c0f2117be69, (v) => $68f7c3f7224c7eb2$export$2f872c0f2117be69 = v);
$parcel$export(module.exports, "format", () => $68f7c3f7224c7eb2$export$d9468344d3651243, (v) => $68f7c3f7224c7eb2$export$d9468344d3651243 = v);
$parcel$export(module.exports, "parse", () => $68f7c3f7224c7eb2$export$98e6a39c04603d36, (v) => $68f7c3f7224c7eb2$export$98e6a39c04603d36 = v);
var $68f7c3f7224c7eb2$export$c564cdbbe6da493;
var $68f7c3f7224c7eb2$export$2f872c0f2117be69;
var $68f7c3f7224c7eb2$export$d9468344d3651243;
var $68f7c3f7224c7eb2$export$98e6a39c04603d36;
'use strict';

$68f7c3f7224c7eb2$export$c564cdbbe6da493 = (parcelRequire("5NeVE"));

$68f7c3f7224c7eb2$export$2f872c0f2117be69 = (parcelRequire("SIvnT"));

$68f7c3f7224c7eb2$export$d9468344d3651243 = (parcelRequire("5llWn"));

$68f7c3f7224c7eb2$export$98e6a39c04603d36 = (parcelRequire("lEeS3"));

});
parcelRegister("5NeVE", function(module, exports) {
'use strict';
var $437d1be9ae335f6e$var$encodeCache = {};
// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function $437d1be9ae335f6e$var$getEncodeCache(exclude) {
    var i, ch, cache = $437d1be9ae335f6e$var$encodeCache[exclude];
    if (cache) return cache;
    cache = $437d1be9ae335f6e$var$encodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
        cache.push(ch);
        else cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
    }
    for(i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
    return cache;
}
// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function $437d1be9ae335f6e$var$encode(string, exclude, keepEscaped) {
    var i, l, code, nextCode, cache, result = '';
    if (typeof exclude !== 'string') {
        // encode(string, keepEscaped)
        keepEscaped = exclude;
        exclude = $437d1be9ae335f6e$var$encode.defaultChars;
    }
    if (typeof keepEscaped === 'undefined') keepEscaped = true;
    cache = $437d1be9ae335f6e$var$getEncodeCache(exclude);
    for(i = 0, l = string.length; i < l; i++){
        code = string.charCodeAt(i);
        if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
            if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                result += string.slice(i, i + 3);
                i += 2;
                continue;
            }
        }
        if (code < 128) {
            result += cache[code];
            continue;
        }
        if (code >= 0xD800 && code <= 0xDFFF) {
            if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                nextCode = string.charCodeAt(i + 1);
                if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                    result += encodeURIComponent(string[i] + string[i + 1]);
                    i++;
                    continue;
                }
            }
            result += '%EF%BF%BD';
            continue;
        }
        result += encodeURIComponent(string[i]);
    }
    return result;
}
$437d1be9ae335f6e$var$encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
$437d1be9ae335f6e$var$encode.componentChars = "-_.!~*'()";
module.exports = $437d1be9ae335f6e$var$encode;

});

parcelRegister("SIvnT", function(module, exports) {
'use strict';
/* eslint-disable no-bitwise */ var $0a479110ee2ce764$var$decodeCache = {};
function $0a479110ee2ce764$var$getDecodeCache(exclude) {
    var i, ch, cache = $0a479110ee2ce764$var$decodeCache[exclude];
    if (cache) return cache;
    cache = $0a479110ee2ce764$var$decodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        cache.push(ch);
    }
    for(i = 0; i < exclude.length; i++){
        ch = exclude.charCodeAt(i);
        cache[ch] = '%' + ('0' + ch.toString(16).toUpperCase()).slice(-2);
    }
    return cache;
}
// Decode percent-encoded string.
//
function $0a479110ee2ce764$var$decode(string, exclude) {
    var cache;
    if (typeof exclude !== 'string') exclude = $0a479110ee2ce764$var$decode.defaultChars;
    cache = $0a479110ee2ce764$var$getDecodeCache(exclude);
    return string.replace(/(%[a-f0-9]{2})+/gi, function(seq) {
        var i, l, b1, b2, b3, b4, chr, result = '';
        for(i = 0, l = seq.length; i < l; i += 3){
            b1 = parseInt(seq.slice(i + 1, i + 3), 16);
            if (b1 < 0x80) {
                result += cache[b1];
                continue;
            }
            if ((b1 & 0xE0) === 0xC0 && i + 3 < l) {
                // 110xxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                if ((b2 & 0xC0) === 0x80) {
                    chr = b1 << 6 & 0x7C0 | b2 & 0x3F;
                    if (chr < 0x80) result += '\ufffd\ufffd';
                    else result += String.fromCharCode(chr);
                    i += 3;
                    continue;
                }
            }
            if ((b1 & 0xF0) === 0xE0 && i + 6 < l) {
                // 1110xxxx 10xxxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
                    chr = b1 << 12 & 0xF000 | b2 << 6 & 0xFC0 | b3 & 0x3F;
                    if (chr < 0x800 || chr >= 0xD800 && chr <= 0xDFFF) result += '\ufffd\ufffd\ufffd';
                    else result += String.fromCharCode(chr);
                    i += 6;
                    continue;
                }
            }
            if ((b1 & 0xF8) === 0xF0 && i + 9 < l) {
                // 111110xx 10xxxxxx 10xxxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                b4 = parseInt(seq.slice(i + 10, i + 12), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80 && (b4 & 0xC0) === 0x80) {
                    chr = b1 << 18 & 0x1C0000 | b2 << 12 & 0x3F000 | b3 << 6 & 0xFC0 | b4 & 0x3F;
                    if (chr < 0x10000 || chr > 0x10FFFF) result += '\ufffd\ufffd\ufffd\ufffd';
                    else {
                        chr -= 0x10000;
                        result += String.fromCharCode(0xD800 + (chr >> 10), 0xDC00 + (chr & 0x3FF));
                    }
                    i += 9;
                    continue;
                }
            }
            result += '\ufffd';
        }
        return result;
    });
}
$0a479110ee2ce764$var$decode.defaultChars = ';/?:@&=+$,#';
$0a479110ee2ce764$var$decode.componentChars = '';
module.exports = $0a479110ee2ce764$var$decode;

});

parcelRegister("5llWn", function(module, exports) {
'use strict';
module.exports = function format(url) {
    var result = '';
    result += url.protocol || '';
    result += url.slashes ? '//' : '';
    result += url.auth ? url.auth + '@' : '';
    if (url.hostname && url.hostname.indexOf(':') !== -1) // ipv6 address
    result += '[' + url.hostname + ']';
    else result += url.hostname || '';
    result += url.port ? ':' + url.port : '';
    result += url.pathname || '';
    result += url.search || '';
    result += url.hash || '';
    return result;
};

});

parcelRegister("lEeS3", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
//
// Changes from joyent/node:
//
// 1. No leading slash in paths,
//    e.g. in `url.parse('http://foo?bar')` pathname is ``, not `/`
//
// 2. Backslashes are not replaced with slashes,
//    so `http:\\example.org\` is treated like a relative path
//
// 3. Trailing colon is treated like a part of the path,
//    i.e. in `http://example.org:foo` pathname is `:foo`
//
// 4. Nothing is URL-encoded in the resulting object,
//    (in joyent/node some chars in auth and paths are encoded)
//
// 5. `url.parse()` does not have `parseQueryString` argument
//
// 6. Removed extraneous result properties: `host`, `path`, `query`, etc.,
//    which can be constructed using other parts of the url.
//
function $fc28de6a6437981a$var$Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.pathname = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
var $fc28de6a6437981a$var$protocolPattern = /^([a-z0-9.+-]+:)/i, $fc28de6a6437981a$var$portPattern = /:[0-9]*$/, // Special case for a simple path URL
$fc28de6a6437981a$var$simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
$fc28de6a6437981a$var$delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
$fc28de6a6437981a$var$unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat($fc28de6a6437981a$var$delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
$fc28de6a6437981a$var$autoEscape = [
    '\''
].concat($fc28de6a6437981a$var$unwise), // Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
$fc28de6a6437981a$var$nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat($fc28de6a6437981a$var$autoEscape), $fc28de6a6437981a$var$hostEndingChars = [
    '/',
    '?',
    '#'
], $fc28de6a6437981a$var$hostnameMaxLen = 255, $fc28de6a6437981a$var$hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, $fc28de6a6437981a$var$hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
/* eslint-disable no-script-url */ // protocols that never have a hostname.
$fc28de6a6437981a$var$hostlessProtocol = {
    'javascript': true,
    'javascript:': true
}, // protocols that always contain a // bit.
$fc28de6a6437981a$var$slashedProtocol = {
    'http': true,
    'https': true,
    'ftp': true,
    'gopher': true,
    'file': true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};
/* eslint-enable no-script-url */ function $fc28de6a6437981a$var$urlParse(url, slashesDenoteHost) {
    if (url && url instanceof $fc28de6a6437981a$var$Url) return url;
    var u = new $fc28de6a6437981a$var$Url();
    u.parse(url, slashesDenoteHost);
    return u;
}
$fc28de6a6437981a$var$Url.prototype.parse = function(url, slashesDenoteHost) {
    var i, l, lowerProto, hec, slashes, rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = $fc28de6a6437981a$var$simplePathPattern.exec(rest);
        if (simplePath) {
            this.pathname = simplePath[1];
            if (simplePath[2]) this.search = simplePath[2];
            return this;
        }
    }
    var proto = $fc28de6a6437981a$var$protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        lowerProto = proto.toLowerCase();
        this.protocol = proto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && $fc28de6a6437981a$var$hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!$fc28de6a6437981a$var$hostlessProtocol[proto] && (slashes || proto && !$fc28de6a6437981a$var$slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(i = 0; i < $fc28de6a6437981a$var$hostEndingChars.length; i++){
            hec = rest.indexOf($fc28de6a6437981a$var$hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf('@', hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = auth;
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(i = 0; i < $fc28de6a6437981a$var$nonHostChars.length; i++){
            hec = rest.indexOf($fc28de6a6437981a$var$nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        if (rest[hostEnd - 1] === ':') hostEnd--;
        var host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost(host);
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || '';
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match($fc28de6a6437981a$var$hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match($fc28de6a6437981a$var$hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match($fc28de6a6437981a$var$hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > $fc28de6a6437981a$var$hostnameMaxLen) this.hostname = '';
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) this.hostname = this.hostname.substr(1, this.hostname.length - 2);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        rest = rest.slice(0, qm);
    }
    if (rest) this.pathname = rest;
    if ($fc28de6a6437981a$var$slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '';
    return this;
};
$fc28de6a6437981a$var$Url.prototype.parseHost = function(host) {
    var port = $fc28de6a6437981a$var$portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
module.exports = $fc28de6a6437981a$var$urlParse;

});


parcelRegister("1I1Rw", function(module, exports) {
$parcel$export(module.exports, "Any", () => $13eb5855fdfbbee7$export$b24b633b1364b94b, (v) => $13eb5855fdfbbee7$export$b24b633b1364b94b = v);
$parcel$export(module.exports, "Cc", () => $13eb5855fdfbbee7$export$15dafbac7aec8a57, (v) => $13eb5855fdfbbee7$export$15dafbac7aec8a57 = v);
$parcel$export(module.exports, "Cf", () => $13eb5855fdfbbee7$export$239cff0cce87eb56, (v) => $13eb5855fdfbbee7$export$239cff0cce87eb56 = v);
$parcel$export(module.exports, "P", () => $13eb5855fdfbbee7$export$56c0d5a1e737357d, (v) => $13eb5855fdfbbee7$export$56c0d5a1e737357d = v);
$parcel$export(module.exports, "Z", () => $13eb5855fdfbbee7$export$dc98b0b04f4c7758, (v) => $13eb5855fdfbbee7$export$dc98b0b04f4c7758 = v);
var $13eb5855fdfbbee7$export$b24b633b1364b94b;
var $13eb5855fdfbbee7$export$15dafbac7aec8a57;
var $13eb5855fdfbbee7$export$239cff0cce87eb56;
var $13eb5855fdfbbee7$export$56c0d5a1e737357d;
var $13eb5855fdfbbee7$export$dc98b0b04f4c7758;
'use strict';

$13eb5855fdfbbee7$export$b24b633b1364b94b = (parcelRequire("hZcCd"));

$13eb5855fdfbbee7$export$15dafbac7aec8a57 = (parcelRequire("iNnZB"));

$13eb5855fdfbbee7$export$239cff0cce87eb56 = (parcelRequire("7wXhr"));

$13eb5855fdfbbee7$export$56c0d5a1e737357d = (parcelRequire("dDBFM"));

$13eb5855fdfbbee7$export$dc98b0b04f4c7758 = (parcelRequire("23KJ1"));

});
parcelRegister("7wXhr", function(module, exports) {
module.exports = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804\uDCBD|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;

});



parcelRegister("gqPyc", function(module, exports) {
$parcel$export(module.exports, "parseLinkLabel", () => $bf670ff0bedcc008$export$2a2c8612930e58d0, (v) => $bf670ff0bedcc008$export$2a2c8612930e58d0 = v);
$parcel$export(module.exports, "parseLinkDestination", () => $bf670ff0bedcc008$export$22bd24080f95f2b3, (v) => $bf670ff0bedcc008$export$22bd24080f95f2b3 = v);
$parcel$export(module.exports, "parseLinkTitle", () => $bf670ff0bedcc008$export$89650c5477a69db9, (v) => $bf670ff0bedcc008$export$89650c5477a69db9 = v);
// Just a shortcut for bulk export
var $bf670ff0bedcc008$export$2a2c8612930e58d0;
var $bf670ff0bedcc008$export$22bd24080f95f2b3;
var $bf670ff0bedcc008$export$89650c5477a69db9;
'use strict';

$bf670ff0bedcc008$export$2a2c8612930e58d0 = (parcelRequire("75pPh"));

$bf670ff0bedcc008$export$22bd24080f95f2b3 = (parcelRequire("iL3v7"));

$bf670ff0bedcc008$export$89650c5477a69db9 = (parcelRequire("8Gz76"));

});
parcelRegister("75pPh", function(module, exports) {
// Parse link label
//
// this function assumes that first character ("[") already matches;
// returns the end of the label
//
'use strict';
module.exports = function parseLinkLabel(state, start, disableNested) {
    var level, found, marker, prevPos, labelEnd = -1, max = state.posMax, oldPos = state.pos;
    state.pos = start + 1;
    level = 1;
    while(state.pos < max){
        marker = state.src.charCodeAt(state.pos);
        if (marker === 0x5D /* ] */ ) {
            level--;
            if (level === 0) {
                found = true;
                break;
            }
        }
        prevPos = state.pos;
        state.md.inline.skipToken(state);
        if (marker === 0x5B /* [ */ ) {
            if (prevPos === state.pos - 1) // increase level if we find text `[`, which is not a part of any token
            level++;
            else if (disableNested) {
                state.pos = oldPos;
                return -1;
            }
        }
    }
    if (found) labelEnd = state.pos;
    // restore old state
    state.pos = oldPos;
    return labelEnd;
};

});

parcelRegister("iL3v7", function(module, exports) {
// Parse link destination
//
'use strict';

var $l6IUK = parcelRequire("l6IUK");
var $da7f54fa213e8274$require$unescapeAll = $l6IUK.unescapeAll;
module.exports = function parseLinkDestination(str, start, max) {
    var code, level, pos = start, result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ''
    };
    if (str.charCodeAt(pos) === 0x3C /* < */ ) {
        pos++;
        while(pos < max){
            code = str.charCodeAt(pos);
            if (code === 0x0A /* \n */ ) return result;
            if (code === 0x3C /* < */ ) return result;
            if (code === 0x3E /* > */ ) {
                result.pos = pos + 1;
                result.str = $da7f54fa213e8274$require$unescapeAll(str.slice(start + 1, pos));
                result.ok = true;
                return result;
            }
            if (code === 0x5C /* \ */  && pos + 1 < max) {
                pos += 2;
                continue;
            }
            pos++;
        }
        // no closing '>'
        return result;
    }
    // this should be ... } else { ... branch
    level = 0;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === 0x20) break;
        // ascii control characters
        if (code < 0x20 || code === 0x7F) break;
        if (code === 0x5C /* \ */  && pos + 1 < max) {
            if (str.charCodeAt(pos + 1) === 0x20) break;
            pos += 2;
            continue;
        }
        if (code === 0x28 /* ( */ ) {
            level++;
            if (level > 32) return result;
        }
        if (code === 0x29 /* ) */ ) {
            if (level === 0) break;
            level--;
        }
        pos++;
    }
    if (start === pos) return result;
    if (level !== 0) return result;
    result.str = $da7f54fa213e8274$require$unescapeAll(str.slice(start, pos));
    result.pos = pos;
    result.ok = true;
    return result;
};

});

parcelRegister("8Gz76", function(module, exports) {
// Parse link title
//
'use strict';

var $l6IUK = parcelRequire("l6IUK");
var $652d7bc9dc05402f$require$unescapeAll = $l6IUK.unescapeAll;
module.exports = function parseLinkTitle(str, start, max) {
    var code, marker, lines = 0, pos = start, result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ''
    };
    if (pos >= max) return result;
    marker = str.charCodeAt(pos);
    if (marker !== 0x22 /* " */  && marker !== 0x27 /* ' */  && marker !== 0x28 /* ( */ ) return result;
    pos++;
    // if opening marker is "(", switch it to closing marker ")"
    if (marker === 0x28) marker = 0x29;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === marker) {
            result.pos = pos + 1;
            result.lines = lines;
            result.str = $652d7bc9dc05402f$require$unescapeAll(str.slice(start + 1, pos));
            result.ok = true;
            return result;
        } else if (code === 0x28 /* ( */  && marker === 0x29 /* ) */ ) return result;
        else if (code === 0x0A) lines++;
        else if (code === 0x5C /* \ */  && pos + 1 < max) {
            pos++;
            if (str.charCodeAt(pos) === 0x0A) lines++;
        }
        pos++;
    }
    return result;
};

});


parcelRegister("gOmEB", function(module, exports) {
/**
 * class Renderer
 *
 * Generates HTML from parsed token stream. Each instance has independent
 * copy of rules. Those can be rewritten with ease. Also, you can add new
 * rules if you create plugin and adds new token types.
 **/ 'use strict';

var $l6IUK = parcelRequire("l6IUK");
var $c3d2e3746a985ca0$require$assign = $l6IUK.assign;

var $l6IUK = parcelRequire("l6IUK");
var $c3d2e3746a985ca0$require$unescapeAll = $l6IUK.unescapeAll;

var $l6IUK = parcelRequire("l6IUK");
var $c3d2e3746a985ca0$require$escapeHtml = $l6IUK.escapeHtml;
////////////////////////////////////////////////////////////////////////////////
var $c3d2e3746a985ca0$var$default_rules = {};
$c3d2e3746a985ca0$var$default_rules.code_inline = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    return '<code' + slf.renderAttrs(token) + '>' + $c3d2e3746a985ca0$require$escapeHtml(token.content) + '</code>';
};
$c3d2e3746a985ca0$var$default_rules.code_block = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    return '<pre' + slf.renderAttrs(token) + '><code>' + $c3d2e3746a985ca0$require$escapeHtml(tokens[idx].content) + '</code></pre>\n';
};
$c3d2e3746a985ca0$var$default_rules.fence = function(tokens, idx, options, env, slf) {
    var token = tokens[idx], info = token.info ? $c3d2e3746a985ca0$require$unescapeAll(token.info).trim() : '', langName = '', langAttrs = '', highlighted, i, arr, tmpAttrs, tmpToken;
    if (info) {
        arr = info.split(/(\s+)/g);
        langName = arr[0];
        langAttrs = arr.slice(2).join('');
    }
    if (options.highlight) highlighted = options.highlight(token.content, langName, langAttrs) || $c3d2e3746a985ca0$require$escapeHtml(token.content);
    else highlighted = $c3d2e3746a985ca0$require$escapeHtml(token.content);
    if (highlighted.indexOf('<pre') === 0) return highlighted + '\n';
    // If language exists, inject class gently, without modifying original token.
    // May be, one day we will add .deepClone() for token and simplify this part, but
    // now we prefer to keep things local.
    if (info) {
        i = token.attrIndex('class');
        tmpAttrs = token.attrs ? token.attrs.slice() : [];
        if (i < 0) tmpAttrs.push([
            'class',
            options.langPrefix + langName
        ]);
        else {
            tmpAttrs[i] = tmpAttrs[i].slice();
            tmpAttrs[i][1] += ' ' + options.langPrefix + langName;
        }
        // Fake token just to render attributes
        tmpToken = {
            attrs: tmpAttrs
        };
        return '<pre><code' + slf.renderAttrs(tmpToken) + '>' + highlighted + '</code></pre>\n';
    }
    return '<pre><code' + slf.renderAttrs(token) + '>' + highlighted + '</code></pre>\n';
};
$c3d2e3746a985ca0$var$default_rules.image = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    // "alt" attr MUST be set, even if empty. Because it's mandatory and
    // should be placed on proper position for tests.
    //
    // Replace content with actual value
    token.attrs[token.attrIndex('alt')][1] = slf.renderInlineAsText(token.children, options, env);
    return slf.renderToken(tokens, idx, options);
};
$c3d2e3746a985ca0$var$default_rules.hardbreak = function(tokens, idx, options /*, env */ ) {
    return options.xhtmlOut ? '<br />\n' : '<br>\n';
};
$c3d2e3746a985ca0$var$default_rules.softbreak = function(tokens, idx, options /*, env */ ) {
    return options.breaks ? options.xhtmlOut ? '<br />\n' : '<br>\n' : '\n';
};
$c3d2e3746a985ca0$var$default_rules.text = function(tokens, idx /*, options, env */ ) {
    return $c3d2e3746a985ca0$require$escapeHtml(tokens[idx].content);
};
$c3d2e3746a985ca0$var$default_rules.html_block = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
$c3d2e3746a985ca0$var$default_rules.html_inline = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
/**
 * new Renderer()
 *
 * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
 **/ function $c3d2e3746a985ca0$var$Renderer() {
    /**
   * Renderer#rules -> Object
   *
   * Contains render rules for tokens. Can be updated and extended.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * md.renderer.rules.strong_open  = function () { return '<b>'; };
   * md.renderer.rules.strong_close = function () { return '</b>'; };
   *
   * var result = md.renderInline(...);
   * ```
   *
   * Each rule is called as independent static function with fixed signature:
   *
   * ```javascript
   * function my_token_render(tokens, idx, options, env, renderer) {
   *   // ...
   *   return renderedHTML;
   * }
   * ```
   *
   * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js)
   * for more details and examples.
   **/ this.rules = $c3d2e3746a985ca0$require$assign({}, $c3d2e3746a985ca0$var$default_rules);
}
/**
 * Renderer.renderAttrs(token) -> String
 *
 * Render token attributes to string.
 **/ $c3d2e3746a985ca0$var$Renderer.prototype.renderAttrs = function renderAttrs(token) {
    var i, l, result;
    if (!token.attrs) return '';
    result = '';
    for(i = 0, l = token.attrs.length; i < l; i++)result += ' ' + $c3d2e3746a985ca0$require$escapeHtml(token.attrs[i][0]) + '="' + $c3d2e3746a985ca0$require$escapeHtml(token.attrs[i][1]) + '"';
    return result;
};
/**
 * Renderer.renderToken(tokens, idx, options) -> String
 * - tokens (Array): list of tokens
 * - idx (Numbed): token index to render
 * - options (Object): params of parser instance
 *
 * Default token renderer. Can be overriden by custom function
 * in [[Renderer#rules]].
 **/ $c3d2e3746a985ca0$var$Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
    var nextToken, result = '', needLf = false, token = tokens[idx];
    // Tight list paragraphs
    if (token.hidden) return '';
    // Insert a newline between hidden paragraph and subsequent opening
    // block-level tag.
    //
    // For example, here we should insert a newline before blockquote:
    //  - a
    //    >
    //
    if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) result += '\n';
    // Add token name, e.g. `<img`
    result += (token.nesting === -1 ? '</' : '<') + token.tag;
    // Encode attributes, e.g. `<img src="foo"`
    result += this.renderAttrs(token);
    // Add a slash for self-closing tags, e.g. `<img src="foo" /`
    if (token.nesting === 0 && options.xhtmlOut) result += ' /';
    // Check if we need to add a newline after this tag
    if (token.block) {
        needLf = true;
        if (token.nesting === 1) {
            if (idx + 1 < tokens.length) {
                nextToken = tokens[idx + 1];
                if (nextToken.type === 'inline' || nextToken.hidden) // Block-level tag containing an inline tag.
                //
                needLf = false;
                else if (nextToken.nesting === -1 && nextToken.tag === token.tag) // Opening tag + closing tag of the same type. E.g. `<li></li>`.
                //
                needLf = false;
            }
        }
    }
    result += needLf ? '>\n' : '>';
    return result;
};
/**
 * Renderer.renderInline(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * The same as [[Renderer.render]], but for single token of `inline` type.
 **/ $c3d2e3746a985ca0$var$Renderer.prototype.renderInline = function(tokens, options, env) {
    var type, result = '', rules = this.rules;
    for(var i = 0, len = tokens.length; i < len; i++){
        type = tokens[i].type;
        if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options);
    }
    return result;
};
/** internal
 * Renderer.renderInlineAsText(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Special kludge for image `alt` attributes to conform CommonMark spec.
 * Don't try to use it! Spec requires to show `alt` content with stripped markup,
 * instead of simple escaping.
 **/ $c3d2e3746a985ca0$var$Renderer.prototype.renderInlineAsText = function(tokens, options, env) {
    var result = '';
    for(var i = 0, len = tokens.length; i < len; i++){
        if (tokens[i].type === 'text') result += tokens[i].content;
        else if (tokens[i].type === 'image') result += this.renderInlineAsText(tokens[i].children, options, env);
        else if (tokens[i].type === 'softbreak') result += '\n';
    }
    return result;
};
/**
 * Renderer.render(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Takes token stream and generates HTML. Probably, you will never need to call
 * this method directly.
 **/ $c3d2e3746a985ca0$var$Renderer.prototype.render = function(tokens, options, env) {
    var i, len, type, result = '', rules = this.rules;
    for(i = 0, len = tokens.length; i < len; i++){
        type = tokens[i].type;
        if (type === 'inline') result += this.renderInline(tokens[i].children, options, env);
        else if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options, env);
    }
    return result;
};
module.exports = $c3d2e3746a985ca0$var$Renderer;

});

parcelRegister("5V1yU", function(module, exports) {
/** internal
 * class Core
 *
 * Top-level rules executor. Glues block/inline parsers and does intermediate
 * transformations.
 **/ 'use strict';

var $c3dcz = parcelRequire("c3dcz");







var $44f37ccc2afb11d4$var$_rules = [
    [
        'normalize',
        (parcelRequire("2F6P7"))
    ],
    [
        'block',
        (parcelRequire("4RLUe"))
    ],
    [
        'inline',
        (parcelRequire("dLNp5"))
    ],
    [
        'linkify',
        (parcelRequire("6QJhn"))
    ],
    [
        'replacements',
        (parcelRequire("9fXv1"))
    ],
    [
        'smartquotes',
        (parcelRequire("dTPyw"))
    ],
    // `text_join` finds `text_special` tokens (for escape sequences)
    // and joins them with the rest of the text
    [
        'text_join',
        (parcelRequire("iAzc8"))
    ]
];
/**
 * new Core()
 **/ function $44f37ccc2afb11d4$var$Core() {
    /**
   * Core#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of core rules.
   **/ this.ruler = new $c3dcz();
    for(var i = 0; i < $44f37ccc2afb11d4$var$_rules.length; i++)this.ruler.push($44f37ccc2afb11d4$var$_rules[i][0], $44f37ccc2afb11d4$var$_rules[i][1]);
}
/**
 * Core.process(state)
 *
 * Executes core chain rules.
 **/ $44f37ccc2afb11d4$var$Core.prototype.process = function(state) {
    var i, l, rules;
    rules = this.ruler.getRules('');
    for(i = 0, l = rules.length; i < l; i++)rules[i](state);
};

$44f37ccc2afb11d4$var$Core.prototype.State = (parcelRequire("c6wci"));
module.exports = $44f37ccc2afb11d4$var$Core;

});
parcelRegister("c3dcz", function(module, exports) {
/**
 * class Ruler
 *
 * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
 * [[MarkdownIt#inline]] to manage sequences of functions (rules):
 *
 * - keep rules in defined order
 * - assign the name to each rule
 * - enable/disable rules
 * - add/replace rules
 * - allow assign rules to additional named chains (in the same)
 * - cacheing lists of active rules
 *
 * You will not need use this class directly until write plugins. For simple
 * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
 * [[MarkdownIt.use]].
 **/ 'use strict';
/**
 * new Ruler()
 **/ function $8c600173b50ded2a$var$Ruler() {
    // List of added rules. Each element is:
    //
    // {
    //   name: XXX,
    //   enabled: Boolean,
    //   fn: Function(),
    //   alt: [ name2, name3 ]
    // }
    //
    this.__rules__ = [];
    // Cached rule chains.
    //
    // First level - chain name, '' for default.
    // Second level - diginal anchor for fast filtering by charcodes.
    //
    this.__cache__ = null;
}
////////////////////////////////////////////////////////////////////////////////
// Helper methods, should not be used directly
// Find rule index by name
//
$8c600173b50ded2a$var$Ruler.prototype.__find__ = function(name) {
    for(var i = 0; i < this.__rules__.length; i++){
        if (this.__rules__[i].name === name) return i;
    }
    return -1;
};
// Build rules lookup cache
//
$8c600173b50ded2a$var$Ruler.prototype.__compile__ = function() {
    var self = this;
    var chains = [
        ''
    ];
    // collect unique names
    self.__rules__.forEach(function(rule) {
        if (!rule.enabled) return;
        rule.alt.forEach(function(altName) {
            if (chains.indexOf(altName) < 0) chains.push(altName);
        });
    });
    self.__cache__ = {};
    chains.forEach(function(chain) {
        self.__cache__[chain] = [];
        self.__rules__.forEach(function(rule) {
            if (!rule.enabled) return;
            if (chain && rule.alt.indexOf(chain) < 0) return;
            self.__cache__[chain].push(rule.fn);
        });
    });
};
/**
 * Ruler.at(name, fn [, options])
 * - name (String): rule name to replace.
 * - fn (Function): new rule function.
 * - options (Object): new rule options (not mandatory).
 *
 * Replace rule by name with new function & options. Throws error if name not
 * found.
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * Replace existing typographer replacement rule with new one:
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.at('replacements', function replace(state) {
 *   //...
 * });
 * ```
 **/ $8c600173b50ded2a$var$Ruler.prototype.at = function(name, fn, options) {
    var index = this.__find__(name);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + name);
    this.__rules__[index].fn = fn;
    this.__rules__[index].alt = opt.alt || [];
    this.__cache__ = null;
};
/**
 * Ruler.before(beforeName, ruleName, fn [, options])
 * - beforeName (String): new rule will be added before this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain before one with given name. See also
 * [[Ruler.after]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $8c600173b50ded2a$var$Ruler.prototype.before = function(beforeName, ruleName, fn, options) {
    var index = this.__find__(beforeName);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + beforeName);
    this.__rules__.splice(index, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.after(afterName, ruleName, fn [, options])
 * - afterName (String): new rule will be added after this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain after one with given name. See also
 * [[Ruler.before]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.inline.ruler.after('text', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $8c600173b50ded2a$var$Ruler.prototype.after = function(afterName, ruleName, fn, options) {
    var index = this.__find__(afterName);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + afterName);
    this.__rules__.splice(index + 1, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.push(ruleName, fn [, options])
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Push new rule to the end of chain. See also
 * [[Ruler.before]], [[Ruler.after]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.push('my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $8c600173b50ded2a$var$Ruler.prototype.push = function(ruleName, fn, options) {
    var opt = options || {};
    this.__rules__.push({
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.enable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to enable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.disable]], [[Ruler.enableOnly]].
 **/ $8c600173b50ded2a$var$Ruler.prototype.enable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    var result = [];
    // Search by name and enable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = true;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.enableOnly(list [, ignoreInvalid])
 * - list (String|Array): list of rule names to enable (whitelist).
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names, and disable everything else. If any rule name
 * not found - throw Error. Errors can be disabled by second param.
 *
 * See also [[Ruler.disable]], [[Ruler.enable]].
 **/ $8c600173b50ded2a$var$Ruler.prototype.enableOnly = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    this.__rules__.forEach(function(rule) {
        rule.enabled = false;
    });
    this.enable(list, ignoreInvalid);
};
/**
 * Ruler.disable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Disable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.enable]], [[Ruler.enableOnly]].
 **/ $8c600173b50ded2a$var$Ruler.prototype.disable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    var result = [];
    // Search by name and disable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = false;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.getRules(chainName) -> Array
 *
 * Return array of active functions (rules) for given chain name. It analyzes
 * rules configuration, compiles caches if not exists and returns result.
 *
 * Default chain name is `''` (empty string). It can't be skipped. That's
 * done intentionally, to keep signature monomorphic for high speed.
 **/ $8c600173b50ded2a$var$Ruler.prototype.getRules = function(chainName) {
    if (this.__cache__ === null) this.__compile__();
    // Chain can be empty, if rules disabled. But we still have to return Array.
    return this.__cache__[chainName] || [];
};
module.exports = $8c600173b50ded2a$var$Ruler;

});

parcelRegister("2F6P7", function(module, exports) {
// Normalize input string
'use strict';
// https://spec.commonmark.org/0.29/#line-ending
var $1f04b41d04c68366$var$NEWLINES_RE = /\r\n?|\n/g;
var $1f04b41d04c68366$var$NULL_RE = /\0/g;
module.exports = function normalize(state) {
    var str;
    // Normalize newlines
    str = state.src.replace($1f04b41d04c68366$var$NEWLINES_RE, '\n');
    // Replace NULL characters
    str = str.replace($1f04b41d04c68366$var$NULL_RE, '\uFFFD');
    state.src = str;
};

});

parcelRegister("4RLUe", function(module, exports) {
'use strict';
module.exports = function block(state) {
    var token;
    if (state.inlineMode) {
        token = new state.Token('inline', '', 0);
        token.content = state.src;
        token.map = [
            0,
            1
        ];
        token.children = [];
        state.tokens.push(token);
    } else state.md.block.parse(state.src, state.md, state.env, state.tokens);
};

});

parcelRegister("dLNp5", function(module, exports) {
'use strict';
module.exports = function inline(state) {
    var tokens = state.tokens, tok, i, l;
    // Parse inlines
    for(i = 0, l = tokens.length; i < l; i++){
        tok = tokens[i];
        if (tok.type === 'inline') state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
};

});

parcelRegister("6QJhn", function(module, exports) {
// Replace link-like texts with link nodes.
//
// Currently restricted by `md.validateLink()` to http/https/ftp
//
'use strict';

var $l6IUK = parcelRequire("l6IUK");
var $4fcab8ef9c16d34c$require$arrayReplaceAt = $l6IUK.arrayReplaceAt;
function $4fcab8ef9c16d34c$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $4fcab8ef9c16d34c$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
module.exports = function linkify(state) {
    var i, j, l, tokens, token, currentToken, nodes, ln, text, pos, lastPos, level, htmlLinkLevel, url, fullUrl, urlText, blockTokens = state.tokens, links;
    if (!state.md.options.linkify) return;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !state.md.linkify.pretest(blockTokens[j].content)) continue;
        tokens = blockTokens[j].children;
        htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(i = tokens.length - 1; i >= 0; i--){
            currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($4fcab8ef9c16d34c$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($4fcab8ef9c16d34c$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && state.md.linkify.test(currentToken.content)) {
                text = currentToken.content;
                links = state.md.linkify.match(text);
                // Now split string to nodes
                nodes = [];
                level = currentToken.level;
                lastPos = 0;
                // forbid escape sequence at the start of the string,
                // this avoids http\://example.com/ from being linkified as
                // http:<a href="//example.com/">//example.com/</a>
                if (links.length > 0 && links[0].index === 0 && i > 0 && tokens[i - 1].type === 'text_special') links = links.slice(1);
                for(ln = 0; ln < links.length; ln++){
                    url = links[ln].url;
                    fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                    else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    pos = links[ln].index;
                    if (pos > lastPos) {
                        token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    token = new state.Token('link_open', 'a', 1);
                    token.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token.level = level++;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    token = new state.Token('text', '', 0);
                    token.content = urlText;
                    token.level = level;
                    nodes.push(token);
                    token = new state.Token('link_close', 'a', -1);
                    token.level = --level;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = $4fcab8ef9c16d34c$require$arrayReplaceAt(tokens, i, nodes);
            }
        }
    }
};

});

parcelRegister("9fXv1", function(module, exports) {
// Simple typographic replacements
//
// (c) (C) → ©
// (tm) (TM) → ™
// (r) (R) → ®
// +- → ±
// ... → … (also ?.... → ?.., !.... → !..)
// ???????? → ???, !!!!! → !!!, `,,` → `,`
// -- → &ndash;, --- → &mdash;
//
'use strict';
// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - multiplications 2 x 4 -> 2 × 4
var $6bd3ab1d593dcde6$var$RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;
// Workaround for phantomjs - need regex without /g flag,
// or root check will fail every second time
var $6bd3ab1d593dcde6$var$SCOPED_ABBR_TEST_RE = /\((c|tm|r)\)/i;
var $6bd3ab1d593dcde6$var$SCOPED_ABBR_RE = /\((c|tm|r)\)/ig;
var $6bd3ab1d593dcde6$var$SCOPED_ABBR = {
    c: "\xa9",
    r: "\xae",
    tm: "\u2122"
};
function $6bd3ab1d593dcde6$var$replaceFn(match, name) {
    return $6bd3ab1d593dcde6$var$SCOPED_ABBR[name.toLowerCase()];
}
function $6bd3ab1d593dcde6$var$replace_scoped(inlineTokens) {
    var i, token, inside_autolink = 0;
    for(i = inlineTokens.length - 1; i >= 0; i--){
        token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) token.content = token.content.replace($6bd3ab1d593dcde6$var$SCOPED_ABBR_RE, $6bd3ab1d593dcde6$var$replaceFn);
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
function $6bd3ab1d593dcde6$var$replace_rare(inlineTokens) {
    var i, token, inside_autolink = 0;
    for(i = inlineTokens.length - 1; i >= 0; i--){
        token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) {
            if ($6bd3ab1d593dcde6$var$RARE_RE.test(token.content)) token.content = token.content.replace(/\+-/g, "\xb1")// .., ..., ....... -> …
            // but ?..... & !..... -> ?.. & !..
            .replace(/\.{2,}/g, "\u2026").replace(/([?!])…/g, '$1..').replace(/([?!]){4,}/g, '$1$1$1').replace(/,{2,}/g, ',')// em-dash
            .replace(/(^|[^-])---(?=[^-]|$)/mg, '$1\u2014')// en-dash
            .replace(/(^|\s)--(?=\s|$)/mg, '$1\u2013').replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, '$1\u2013');
        }
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
module.exports = function replace(state) {
    var blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline') continue;
        if ($6bd3ab1d593dcde6$var$SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) $6bd3ab1d593dcde6$var$replace_scoped(state.tokens[blkIdx].children);
        if ($6bd3ab1d593dcde6$var$RARE_RE.test(state.tokens[blkIdx].content)) $6bd3ab1d593dcde6$var$replace_rare(state.tokens[blkIdx].children);
    }
};

});

parcelRegister("dTPyw", function(module, exports) {
// Convert straight quotation marks to typographic ones
//
'use strict';

var $l6IUK = parcelRequire("l6IUK");
var $a1e867523fcddfe1$require$isWhiteSpace = $l6IUK.isWhiteSpace;

var $l6IUK = parcelRequire("l6IUK");
var $a1e867523fcddfe1$require$isPunctChar = $l6IUK.isPunctChar;

var $l6IUK = parcelRequire("l6IUK");
var $a1e867523fcddfe1$require$isMdAsciiPunct = $l6IUK.isMdAsciiPunct;
var $a1e867523fcddfe1$var$QUOTE_TEST_RE = /['"]/;
var $a1e867523fcddfe1$var$QUOTE_RE = /['"]/g;
var $a1e867523fcddfe1$var$APOSTROPHE = '\u2019'; /* ’ */ 
function $a1e867523fcddfe1$var$replaceAt(str, index, ch) {
    return str.slice(0, index) + ch + str.slice(index + 1);
}
function $a1e867523fcddfe1$var$process_inlines(tokens, state) {
    var i, token, text, t, pos, max, thisLevel, item, lastChar, nextChar, isLastPunctChar, isNextPunctChar, isLastWhiteSpace, isNextWhiteSpace, canOpen, canClose, j, isSingle, stack, openQuote, closeQuote;
    stack = [];
    for(i = 0; i < tokens.length; i++){
        token = tokens[i];
        thisLevel = tokens[i].level;
        for(j = stack.length - 1; j >= 0; j--){
            if (stack[j].level <= thisLevel) break;
        }
        stack.length = j + 1;
        if (token.type !== 'text') continue;
        text = token.content;
        pos = 0;
        max = text.length;
        /*eslint no-labels:0,block-scoped-var:0*/ OUTER: while(pos < max){
            $a1e867523fcddfe1$var$QUOTE_RE.lastIndex = pos;
            t = $a1e867523fcddfe1$var$QUOTE_RE.exec(text);
            if (!t) break;
            canOpen = canClose = true;
            pos = t.index + 1;
            isSingle = t[0] === "'";
            // Find previous character,
            // default to space if it's the beginning of the line
            //
            lastChar = 0x20;
            if (t.index - 1 >= 0) lastChar = text.charCodeAt(t.index - 1);
            else for(j = i - 1; j >= 0; j--){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // lastChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
                break;
            }
            // Find next character,
            // default to space if it's the end of the line
            //
            nextChar = 0x20;
            if (pos < max) nextChar = text.charCodeAt(pos);
            else for(j = i + 1; j < tokens.length; j++){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // nextChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                nextChar = tokens[j].content.charCodeAt(0);
                break;
            }
            isLastPunctChar = $a1e867523fcddfe1$require$isMdAsciiPunct(lastChar) || $a1e867523fcddfe1$require$isPunctChar(String.fromCharCode(lastChar));
            isNextPunctChar = $a1e867523fcddfe1$require$isMdAsciiPunct(nextChar) || $a1e867523fcddfe1$require$isPunctChar(String.fromCharCode(nextChar));
            isLastWhiteSpace = $a1e867523fcddfe1$require$isWhiteSpace(lastChar);
            isNextWhiteSpace = $a1e867523fcddfe1$require$isWhiteSpace(nextChar);
            if (isNextWhiteSpace) canOpen = false;
            else if (isNextPunctChar) {
                if (!(isLastWhiteSpace || isLastPunctChar)) canOpen = false;
            }
            if (isLastWhiteSpace) canClose = false;
            else if (isLastPunctChar) {
                if (!(isNextWhiteSpace || isNextPunctChar)) canClose = false;
            }
            if (nextChar === 0x22 /* " */  && t[0] === '"') {
                if (lastChar >= 0x30 /* 0 */  && lastChar <= 0x39 /* 9 */ ) // special case: 1"" - count first quote as an inch
                canClose = canOpen = false;
            }
            if (canOpen && canClose) {
                // Replace quotes in the middle of punctuation sequence, but not
                // in the middle of the words, i.e.:
                //
                // 1. foo " bar " baz - not replaced
                // 2. foo-"-bar-"-baz - replaced
                // 3. foo"bar"baz     - not replaced
                //
                canOpen = isLastPunctChar;
                canClose = isNextPunctChar;
            }
            if (!canOpen && !canClose) {
                // middle of word
                if (isSingle) token.content = $a1e867523fcddfe1$var$replaceAt(token.content, t.index, $a1e867523fcddfe1$var$APOSTROPHE);
                continue;
            }
            if (canClose) // this could be a closing quote, rewind the stack to get a match
            for(j = stack.length - 1; j >= 0; j--){
                item = stack[j];
                if (stack[j].level < thisLevel) break;
                if (item.single === isSingle && stack[j].level === thisLevel) {
                    item = stack[j];
                    if (isSingle) {
                        openQuote = state.md.options.quotes[2];
                        closeQuote = state.md.options.quotes[3];
                    } else {
                        openQuote = state.md.options.quotes[0];
                        closeQuote = state.md.options.quotes[1];
                    }
                    // replace token.content *before* tokens[item.token].content,
                    // because, if they are pointing at the same token, replaceAt
                    // could mess up indices when quote length != 1
                    token.content = $a1e867523fcddfe1$var$replaceAt(token.content, t.index, closeQuote);
                    tokens[item.token].content = $a1e867523fcddfe1$var$replaceAt(tokens[item.token].content, item.pos, openQuote);
                    pos += closeQuote.length - 1;
                    if (item.token === i) pos += openQuote.length - 1;
                    text = token.content;
                    max = text.length;
                    stack.length = j;
                    continue OUTER;
                }
            }
            if (canOpen) stack.push({
                token: i,
                pos: t.index,
                single: isSingle,
                level: thisLevel
            });
            else if (canClose && isSingle) token.content = $a1e867523fcddfe1$var$replaceAt(token.content, t.index, $a1e867523fcddfe1$var$APOSTROPHE);
        }
    }
}
module.exports = function smartquotes(state) {
    /*eslint max-depth:0*/ var blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline' || !$a1e867523fcddfe1$var$QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) continue;
        $a1e867523fcddfe1$var$process_inlines(state.tokens[blkIdx].children, state);
    }
};

});

parcelRegister("iAzc8", function(module, exports) {
// Join raw text tokens with the rest of the text
//
// This is set as a separate rule to provide an opportunity for plugins
// to run text replacements after text join, but before escape join.
//
// For example, `\:)` shouldn't be replaced with an emoji.
//
'use strict';
module.exports = function text_join(state) {
    var j, l, tokens, curr, max, last, blockTokens = state.tokens;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline') continue;
        tokens = blockTokens[j].children;
        max = tokens.length;
        for(curr = 0; curr < max; curr++)if (tokens[curr].type === 'text_special') tokens[curr].type = 'text';
        for(curr = last = 0; curr < max; curr++)if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
        if (curr !== last) tokens.length = last;
    }
};

});

parcelRegister("c6wci", function(module, exports) {
// Core state object
//
'use strict';

var $8AILn = parcelRequire("8AILn");
function $8cff0547fd21895a$var$StateCore(src, md, env) {
    this.src = src;
    this.env = env;
    this.tokens = [];
    this.inlineMode = false;
    this.md = md; // link to parser instance
}
// re-export Token class to use in core rules
$8cff0547fd21895a$var$StateCore.prototype.Token = $8AILn;
module.exports = $8cff0547fd21895a$var$StateCore;

});
parcelRegister("8AILn", function(module, exports) {
// Token class
'use strict';
/**
 * class Token
 **/ /**
 * new Token(type, tag, nesting)
 *
 * Create new token and fill passed properties.
 **/ function $6414688916872829$var$Token(type, tag, nesting) {
    /**
   * Token#type -> String
   *
   * Type of the token (string, e.g. "paragraph_open")
   **/ this.type = type;
    /**
   * Token#tag -> String
   *
   * html tag name, e.g. "p"
   **/ this.tag = tag;
    /**
   * Token#attrs -> Array
   *
   * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
   **/ this.attrs = null;
    /**
   * Token#map -> Array
   *
   * Source map info. Format: `[ line_begin, line_end ]`
   **/ this.map = null;
    /**
   * Token#nesting -> Number
   *
   * Level change (number in {-1, 0, 1} set), where:
   *
   * -  `1` means the tag is opening
   * -  `0` means the tag is self-closing
   * - `-1` means the tag is closing
   **/ this.nesting = nesting;
    /**
   * Token#level -> Number
   *
   * nesting level, the same as `state.level`
   **/ this.level = 0;
    /**
   * Token#children -> Array
   *
   * An array of child nodes (inline and img tokens)
   **/ this.children = null;
    /**
   * Token#content -> String
   *
   * In a case of self-closing tag (code, html, fence, etc.),
   * it has contents of this tag.
   **/ this.content = '';
    /**
   * Token#markup -> String
   *
   * '*' or '_' for emphasis, fence string for fence, etc.
   **/ this.markup = '';
    /**
   * Token#info -> String
   *
   * Additional information:
   *
   * - Info string for "fence" tokens
   * - The value "auto" for autolink "link_open" and "link_close" tokens
   * - The string value of the item marker for ordered-list "list_item_open" tokens
   **/ this.info = '';
    /**
   * Token#meta -> Object
   *
   * A place for plugins to store an arbitrary data
   **/ this.meta = null;
    /**
   * Token#block -> Boolean
   *
   * True for block-level tokens, false for inline tokens.
   * Used in renderer to calculate line breaks
   **/ this.block = false;
    /**
   * Token#hidden -> Boolean
   *
   * If it's true, ignore this element when rendering. Used for tight lists
   * to hide paragraphs.
   **/ this.hidden = false;
}
/**
 * Token.attrIndex(name) -> Number
 *
 * Search attribute index by name.
 **/ $6414688916872829$var$Token.prototype.attrIndex = function attrIndex(name) {
    var attrs, i, len;
    if (!this.attrs) return -1;
    attrs = this.attrs;
    for(i = 0, len = attrs.length; i < len; i++){
        if (attrs[i][0] === name) return i;
    }
    return -1;
};
/**
 * Token.attrPush(attrData)
 *
 * Add `[ name, value ]` attribute to list. Init attrs if necessary
 **/ $6414688916872829$var$Token.prototype.attrPush = function attrPush(attrData) {
    if (this.attrs) this.attrs.push(attrData);
    else this.attrs = [
        attrData
    ];
};
/**
 * Token.attrSet(name, value)
 *
 * Set `name` attribute to `value`. Override old value if exists.
 **/ $6414688916872829$var$Token.prototype.attrSet = function attrSet(name, value) {
    var idx = this.attrIndex(name), attrData = [
        name,
        value
    ];
    if (idx < 0) this.attrPush(attrData);
    else this.attrs[idx] = attrData;
};
/**
 * Token.attrGet(name)
 *
 * Get the value of attribute `name`, or null if it does not exist.
 **/ $6414688916872829$var$Token.prototype.attrGet = function attrGet(name) {
    var idx = this.attrIndex(name), value = null;
    if (idx >= 0) value = this.attrs[idx][1];
    return value;
};
/**
 * Token.attrJoin(name, value)
 *
 * Join value to existing attribute via space. Or create new attribute if not
 * exists. Useful to operate with token classes.
 **/ $6414688916872829$var$Token.prototype.attrJoin = function attrJoin(name, value) {
    var idx = this.attrIndex(name);
    if (idx < 0) this.attrPush([
        name,
        value
    ]);
    else this.attrs[idx][1] = this.attrs[idx][1] + ' ' + value;
};
module.exports = $6414688916872829$var$Token;

});



parcelRegister("9Xg9R", function(module, exports) {
/** internal
 * class ParserBlock
 *
 * Block-level tokenizer.
 **/ 'use strict';

var $c3dcz = parcelRequire("c3dcz");











var $73f628630344da6a$var$_rules = [
    // First 2 params - rule name & source. Secondary array - list of rules,
    // which can be terminated by this one.
    [
        'table',
        (parcelRequire("6AMir")),
        [
            'paragraph',
            'reference'
        ]
    ],
    [
        'code',
        (parcelRequire("emojL"))
    ],
    [
        'fence',
        (parcelRequire("fv8TY")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'blockquote',
        (parcelRequire("aWlef")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'hr',
        (parcelRequire("7dy3H")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'list',
        (parcelRequire("6LEge")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'reference',
        (parcelRequire("14Fj0"))
    ],
    [
        'html_block',
        (parcelRequire("agiT5")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'heading',
        (parcelRequire("9FRBG")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'lheading',
        (parcelRequire("aKAqI"))
    ],
    [
        'paragraph',
        (parcelRequire("7QU8N"))
    ]
];
/**
 * new ParserBlock()
 **/ function $73f628630344da6a$var$ParserBlock() {
    /**
   * ParserBlock#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of block rules.
   **/ this.ruler = new $c3dcz();
    for(var i = 0; i < $73f628630344da6a$var$_rules.length; i++)this.ruler.push($73f628630344da6a$var$_rules[i][0], $73f628630344da6a$var$_rules[i][1], {
        alt: ($73f628630344da6a$var$_rules[i][2] || []).slice()
    });
}
// Generate tokens for input range
//
$73f628630344da6a$var$ParserBlock.prototype.tokenize = function(state, startLine, endLine) {
    var ok, i, prevLine, rules = this.ruler.getRules(''), len = rules.length, line = startLine, hasEmptyLines = false, maxNesting = state.md.options.maxNesting;
    while(line < endLine){
        state.line = line = state.skipEmptyLines(line);
        if (line >= endLine) break;
        // Termination condition for nested calls.
        // Nested calls currently used for blockquotes & lists
        if (state.sCount[line] < state.blkIndent) break;
        // If nesting level exceeded - skip tail to the end. That's not ordinary
        // situation and we should not care about content.
        if (state.level >= maxNesting) {
            state.line = endLine;
            break;
        }
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.line`
        // - update `state.tokens`
        // - return true
        prevLine = state.line;
        for(i = 0; i < len; i++){
            ok = rules[i](state, line, endLine, false);
            if (ok) {
                if (prevLine >= state.line) throw new Error("block rule didn't increment state.line");
                break;
            }
        }
        // this can only happen if user disables paragraph rule
        if (!ok) throw new Error('none of the block rules matched');
        // set state.tight if we had an empty line before current tag
        // i.e. latest empty line should not count
        state.tight = !hasEmptyLines;
        // paragraph might "eat" one newline after it in nested lists
        if (state.isEmpty(state.line - 1)) hasEmptyLines = true;
        line = state.line;
        if (line < endLine && state.isEmpty(line)) {
            hasEmptyLines = true;
            line++;
            state.line = line;
        }
    }
};
/**
 * ParserBlock.parse(str, md, env, outTokens)
 *
 * Process input string and push block tokens into `outTokens`
 **/ $73f628630344da6a$var$ParserBlock.prototype.parse = function(src, md, env, outTokens) {
    var state;
    if (!src) return;
    state = new this.State(src, md, env, outTokens);
    this.tokenize(state, state.line, state.lineMax);
};

$73f628630344da6a$var$ParserBlock.prototype.State = (parcelRequire("4ASdB"));
module.exports = $73f628630344da6a$var$ParserBlock;

});
parcelRegister("6AMir", function(module, exports) {
// GFM table, https://github.github.com/gfm/#tables-extension-
'use strict';

var $l6IUK = parcelRequire("l6IUK");
var $4ccb918515910368$require$isSpace = $l6IUK.isSpace;
function $4ccb918515910368$var$getLine(state, line) {
    var pos = state.bMarks[line] + state.tShift[line], max = state.eMarks[line];
    return state.src.slice(pos, max);
}
function $4ccb918515910368$var$escapedSplit(str) {
    var result = [], pos = 0, max = str.length, ch, isEscaped = false, lastPos = 0, current = '';
    ch = str.charCodeAt(pos);
    while(pos < max){
        if (ch === 0x7c /* | */ ) {
            if (!isEscaped) {
                // pipe separating cells, '|'
                result.push(current + str.substring(lastPos, pos));
                current = '';
                lastPos = pos + 1;
            } else {
                // escaped pipe, '\|'
                current += str.substring(lastPos, pos - 1);
                lastPos = pos;
            }
        }
        isEscaped = ch === 0x5c /* \ */ ;
        pos++;
        ch = str.charCodeAt(pos);
    }
    result.push(current + str.substring(lastPos));
    return result;
}
module.exports = function table(state, startLine, endLine, silent) {
    var ch, lineText, pos, i, l, nextLine, columns, columnCount, token, aligns, t, tableLines, tbodyLines, oldParentType, terminate, terminatorRules, firstCh, secondCh;
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    firstCh = state.src.charCodeAt(pos++);
    if (firstCh !== 0x7C /* | */  && firstCh !== 0x2D /* - */  && firstCh !== 0x3A /* : */ ) return false;
    if (pos >= state.eMarks[nextLine]) return false;
    secondCh = state.src.charCodeAt(pos++);
    if (secondCh !== 0x7C /* | */  && secondCh !== 0x2D /* - */  && secondCh !== 0x3A /* : */  && !$4ccb918515910368$require$isSpace(secondCh)) return false;
    // if first character is '-', then second character must not be a space
    // (due to parsing ambiguity with list)
    if (firstCh === 0x2D /* - */  && $4ccb918515910368$require$isSpace(secondCh)) return false;
    while(pos < state.eMarks[nextLine]){
        ch = state.src.charCodeAt(pos);
        if (ch !== 0x7C /* | */  && ch !== 0x2D /* - */  && ch !== 0x3A /* : */  && !$4ccb918515910368$require$isSpace(ch)) return false;
        pos++;
    }
    lineText = $4ccb918515910368$var$getLine(state, startLine + 1);
    columns = lineText.split('|');
    aligns = [];
    for(i = 0; i < columns.length; i++){
        t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3A /* : */ ) aligns.push(t.charCodeAt(0) === 0x3A /* : */  ? 'center' : 'right');
        else if (t.charCodeAt(0) === 0x3A /* : */ ) aligns.push('left');
        else aligns.push('');
    }
    lineText = $4ccb918515910368$var$getLine(state, startLine).trim();
    if (lineText.indexOf('|') === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $4ccb918515910368$var$escapedSplit(lineText);
    if (columns.length && columns[0] === '') columns.shift();
    if (columns.length && columns[columns.length - 1] === '') columns.pop();
    // header row will define an amount of columns in the entire table,
    // and align row should be exactly the same (the rest of the rows can differ)
    columnCount = columns.length;
    if (columnCount === 0 || columnCount !== aligns.length) return false;
    if (silent) return true;
    oldParentType = state.parentType;
    state.parentType = 'table';
    // use 'blockquote' lists for termination because it's
    // the most similar to tables
    terminatorRules = state.md.block.ruler.getRules('blockquote');
    token = state.push('table_open', 'table', 1);
    token.map = tableLines = [
        startLine,
        0
    ];
    token = state.push('thead_open', 'thead', 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    token = state.push('tr_open', 'tr', 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    for(i = 0; i < columns.length; i++){
        token = state.push('th_open', 'th', 1);
        if (aligns[i]) token.attrs = [
            [
                'style',
                'text-align:' + aligns[i]
            ]
        ];
        token = state.push('inline', '', 0);
        token.content = columns[i].trim();
        token.children = [];
        token = state.push('th_close', 'th', -1);
    }
    token = state.push('tr_close', 'tr', -1);
    token = state.push('thead_close', 'thead', -1);
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        lineText = $4ccb918515910368$var$getLine(state, nextLine).trim();
        if (!lineText) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $4ccb918515910368$var$escapedSplit(lineText);
        if (columns.length && columns[0] === '') columns.shift();
        if (columns.length && columns[columns.length - 1] === '') columns.pop();
        if (nextLine === startLine + 2) {
            token = state.push('tbody_open', 'tbody', 1);
            token.map = tbodyLines = [
                startLine + 2,
                0
            ];
        }
        token = state.push('tr_open', 'tr', 1);
        token.map = [
            nextLine,
            nextLine + 1
        ];
        for(i = 0; i < columnCount; i++){
            token = state.push('td_open', 'td', 1);
            if (aligns[i]) token.attrs = [
                [
                    'style',
                    'text-align:' + aligns[i]
                ]
            ];
            token = state.push('inline', '', 0);
            token.content = columns[i] ? columns[i].trim() : '';
            token.children = [];
            token = state.push('td_close', 'td', -1);
        }
        token = state.push('tr_close', 'tr', -1);
    }
    if (tbodyLines) {
        token = state.push('tbody_close', 'tbody', -1);
        tbodyLines[1] = nextLine;
    }
    token = state.push('table_close', 'table', -1);
    tableLines[1] = nextLine;
    state.parentType = oldParentType;
    state.line = nextLine;
    return true;
};

});

parcelRegister("emojL", function(module, exports) {
// Code block (4 spaces padded)
'use strict';
module.exports = function code(state, startLine, endLine /*, silent*/ ) {
    var nextLine, last, token;
    if (state.sCount[startLine] - state.blkIndent < 4) return false;
    last = nextLine = startLine + 1;
    while(nextLine < endLine){
        if (state.isEmpty(nextLine)) {
            nextLine++;
            continue;
        }
        if (state.sCount[nextLine] - state.blkIndent >= 4) {
            nextLine++;
            last = nextLine;
            continue;
        }
        break;
    }
    state.line = last;
    token = state.push('code_block', 'code', 0);
    token.content = state.getLines(startLine, last, 4 + state.blkIndent, false) + '\n';
    token.map = [
        startLine,
        state.line
    ];
    return true;
};

});

parcelRegister("fv8TY", function(module, exports) {
// fences (``` lang, ~~~ lang)
'use strict';
module.exports = function fence(state, startLine, endLine, silent) {
    var marker, len, params, nextLine, mem, token, markup, haveEndMarker = false, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (pos + 3 > max) return false;
    marker = state.src.charCodeAt(pos);
    if (marker !== 0x7E /* ~ */  && marker !== 0x60 /* ` */ ) return false;
    // scan marker length
    mem = pos;
    pos = state.skipChars(pos, marker);
    len = pos - mem;
    if (len < 3) return false;
    markup = state.src.slice(mem, pos);
    params = state.src.slice(pos, max);
    if (marker === 0x60 /* ` */ ) {
        if (params.indexOf(String.fromCharCode(marker)) >= 0) return false;
    }
    // Since start is found, we can report success here in validation mode
    if (silent) return true;
    // search end of block
    nextLine = startLine;
    for(;;){
        nextLine++;
        if (nextLine >= endLine) break;
        pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos < max && state.sCount[nextLine] < state.blkIndent) break;
        if (state.src.charCodeAt(pos) !== marker) continue;
        if (state.sCount[nextLine] - state.blkIndent >= 4) continue;
        pos = state.skipChars(pos, marker);
        // closing code fence must be at least as long as the opening one
        if (pos - mem < len) continue;
        // make sure tail has spaces only
        pos = state.skipSpaces(pos);
        if (pos < max) continue;
        haveEndMarker = true;
        break;
    }
    // If a fence has heading spaces, they should be removed from its inner block
    len = state.sCount[startLine];
    state.line = nextLine + (haveEndMarker ? 1 : 0);
    token = state.push('fence', 'code', 0);
    token.info = params;
    token.content = state.getLines(startLine + 1, nextLine, len, true);
    token.markup = markup;
    token.map = [
        startLine,
        state.line
    ];
    return true;
};

});

parcelRegister("aWlef", function(module, exports) {
// Block quotes
'use strict';

var $l6IUK = parcelRequire("l6IUK");
var $7f6fc9bcbb1c78c0$require$isSpace = $l6IUK.isSpace;
module.exports = function blockquote(state, startLine, endLine, silent) {
    var adjustTab, ch, i, initial, l, lastLineEmpty, lines, nextLine, offset, oldBMarks, oldBSCount, oldIndent, oldParentType, oldSCount, oldTShift, spaceAfterMarker, terminate, terminatorRules, token, isOutdented, oldLineMax = state.lineMax, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    // check the block quote marker
    if (state.src.charCodeAt(pos) !== 0x3E /* > */ ) return false;
    // we know that it's going to be a valid blockquote,
    // so no point trying to find the end of it in silent mode
    if (silent) return true;
    oldBMarks = [];
    oldBSCount = [];
    oldSCount = [];
    oldTShift = [];
    terminatorRules = state.md.block.ruler.getRules('blockquote');
    oldParentType = state.parentType;
    state.parentType = 'blockquote';
    // Search the end of the block
    //
    // Block ends with either:
    //  1. an empty line outside:
    //     ```
    //     > test
    //
    //     ```
    //  2. an empty line inside:
    //     ```
    //     >
    //     test
    //     ```
    //  3. another tag:
    //     ```
    //     > test
    //      - - -
    //     ```
    for(nextLine = startLine; nextLine < endLine; nextLine++){
        // check if it's outdented, i.e. it's inside list item and indented
        // less than said list item:
        //
        // ```
        // 1. anything
        //    > current blockquote
        // 2. checking this line
        // ```
        isOutdented = state.sCount[nextLine] < state.blkIndent;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos >= max) break;
        if (state.src.charCodeAt(pos++) === 0x3E /* > */  && !isOutdented) {
            // This line is inside the blockquote.
            // set offset past spaces and ">"
            initial = state.sCount[nextLine] + 1;
            // skip one optional space after '>'
            if (state.src.charCodeAt(pos) === 0x20 /* space */ ) {
                // ' >   test '
                //     ^ -- position start of line here:
                pos++;
                initial++;
                adjustTab = false;
                spaceAfterMarker = true;
            } else if (state.src.charCodeAt(pos) === 0x09 /* tab */ ) {
                spaceAfterMarker = true;
                if ((state.bsCount[nextLine] + initial) % 4 === 3) {
                    // '  >\t  test '
                    //       ^ -- position start of line here (tab has width===1)
                    pos++;
                    initial++;
                    adjustTab = false;
                } else // ' >\t  test '
                //    ^ -- position start of line here + shift bsCount slightly
                //         to make extra space appear
                adjustTab = true;
            } else spaceAfterMarker = false;
            offset = initial;
            oldBMarks.push(state.bMarks[nextLine]);
            state.bMarks[nextLine] = pos;
            while(pos < max){
                ch = state.src.charCodeAt(pos);
                if ($7f6fc9bcbb1c78c0$require$isSpace(ch)) {
                    if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
                    else offset++;
                } else break;
                pos++;
            }
            lastLineEmpty = pos >= max;
            oldBSCount.push(state.bsCount[nextLine]);
            state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);
            oldSCount.push(state.sCount[nextLine]);
            state.sCount[nextLine] = offset - initial;
            oldTShift.push(state.tShift[nextLine]);
            state.tShift[nextLine] = pos - state.bMarks[nextLine];
            continue;
        }
        // Case 2: line is not inside the blockquote, and the last line was empty.
        if (lastLineEmpty) break;
        // Case 3: another tag found.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) {
            // Quirk to enforce "hard termination mode" for paragraphs;
            // normally if you call `tokenize(state, startLine, nextLine)`,
            // paragraphs will look below nextLine for paragraph continuation,
            // but if blockquote is terminated by another tag, they shouldn't
            state.lineMax = nextLine;
            if (state.blkIndent !== 0) {
                // state.blkIndent was non-zero, we now set it to zero,
                // so we need to re-calculate all offsets to appear as
                // if indent wasn't changed
                oldBMarks.push(state.bMarks[nextLine]);
                oldBSCount.push(state.bsCount[nextLine]);
                oldTShift.push(state.tShift[nextLine]);
                oldSCount.push(state.sCount[nextLine]);
                state.sCount[nextLine] -= state.blkIndent;
            }
            break;
        }
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);
        // A negative indentation means that this is a paragraph continuation
        //
        state.sCount[nextLine] = -1;
    }
    oldIndent = state.blkIndent;
    state.blkIndent = 0;
    token = state.push('blockquote_open', 'blockquote', 1);
    token.markup = '>';
    token.map = lines = [
        startLine,
        0
    ];
    state.md.block.tokenize(state, startLine, nextLine);
    token = state.push('blockquote_close', 'blockquote', -1);
    token.markup = '>';
    state.lineMax = oldLineMax;
    state.parentType = oldParentType;
    lines[1] = state.line;
    // Restore original tShift; this might not be necessary since the parser
    // has already been here, but just to make sure we can do that.
    for(i = 0; i < oldTShift.length; i++){
        state.bMarks[i + startLine] = oldBMarks[i];
        state.tShift[i + startLine] = oldTShift[i];
        state.sCount[i + startLine] = oldSCount[i];
        state.bsCount[i + startLine] = oldBSCount[i];
    }
    state.blkIndent = oldIndent;
    return true;
};

});

parcelRegister("7dy3H", function(module, exports) {
// Horizontal rule
'use strict';

var $l6IUK = parcelRequire("l6IUK");
var $54142a9f38955a51$require$isSpace = $l6IUK.isSpace;
module.exports = function hr(state, startLine, endLine, silent) {
    var marker, cnt, ch, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    marker = state.src.charCodeAt(pos++);
    // Check hr marker
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x5F /* _ */ ) return false;
    // markers can be mixed with spaces, but there should be at least 3 of them
    cnt = 1;
    while(pos < max){
        ch = state.src.charCodeAt(pos++);
        if (ch !== marker && !$54142a9f38955a51$require$isSpace(ch)) return false;
        if (ch === marker) cnt++;
    }
    if (cnt < 3) return false;
    if (silent) return true;
    state.line = startLine + 1;
    token = state.push('hr', 'hr', 0);
    token.map = [
        startLine,
        state.line
    ];
    token.markup = Array(cnt + 1).join(String.fromCharCode(marker));
    return true;
};

});

parcelRegister("6LEge", function(module, exports) {
// Lists
'use strict';

var $l6IUK = parcelRequire("l6IUK");
var $4ed65cd7115d0dcb$require$isSpace = $l6IUK.isSpace;
// Search `[-+*][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $4ed65cd7115d0dcb$var$skipBulletListMarker(state, startLine) {
    var marker, pos, max, ch;
    pos = state.bMarks[startLine] + state.tShift[startLine];
    max = state.eMarks[startLine];
    marker = state.src.charCodeAt(pos++);
    // Check bullet
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x2B /* + */ ) return -1;
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!$4ed65cd7115d0dcb$require$isSpace(ch)) // " -test " - is not a list item
        return -1;
    }
    return pos;
}
// Search `\d+[.)][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $4ed65cd7115d0dcb$var$skipOrderedListMarker(state, startLine) {
    var ch, start = state.bMarks[startLine] + state.tShift[startLine], pos = start, max = state.eMarks[startLine];
    // List marker should have at least 2 chars (digit + dot)
    if (pos + 1 >= max) return -1;
    ch = state.src.charCodeAt(pos++);
    if (ch < 0x30 /* 0 */  || ch > 0x39 /* 9 */ ) return -1;
    for(;;){
        // EOL -> fail
        if (pos >= max) return -1;
        ch = state.src.charCodeAt(pos++);
        if (ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ ) {
            // List marker should have no more than 9 digits
            // (prevents integer overflow in browsers)
            if (pos - start >= 10) return -1;
            continue;
        }
        // found valid marker
        if (ch === 0x29 /* ) */  || ch === 0x2e /* . */ ) break;
        return -1;
    }
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!$4ed65cd7115d0dcb$require$isSpace(ch)) // " 1.test " - is not a list item
        return -1;
    }
    return pos;
}
function $4ed65cd7115d0dcb$var$markTightParagraphs(state, idx) {
    var i, l, level = state.level + 2;
    for(i = idx + 2, l = state.tokens.length - 2; i < l; i++)if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
        state.tokens[i + 2].hidden = true;
        state.tokens[i].hidden = true;
        i += 2;
    }
}
module.exports = function list(state, startLine, endLine, silent) {
    var ch, contentStart, i, indent, indentAfterMarker, initial, isOrdered, itemLines, l, listLines, listTokIdx, markerCharCode, markerValue, max, offset, oldListIndent, oldParentType, oldSCount, oldTShift, oldTight, pos, posAfterMarker, prevEmptyEnd, start, terminate, terminatorRules, token, nextLine = startLine, isTerminatingParagraph = false, tight = true;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // Special case:
    //  - item 1
    //   - item 2
    //    - item 3
    //     - item 4
    //      - this one is a paragraph continuation
    if (state.listIndent >= 0 && state.sCount[nextLine] - state.listIndent >= 4 && state.sCount[nextLine] < state.blkIndent) return false;
    // limit conditions when list can interrupt
    // a paragraph (validation mode only)
    if (silent && state.parentType === 'paragraph') // Next list item should still terminate previous list item;
    //
    // This code can fail if plugins use blkIndent as well as lists,
    // but I hope the spec gets fixed long before that happens.
    //
    {
        if (state.sCount[nextLine] >= state.blkIndent) isTerminatingParagraph = true;
    }
    // Detect list type and position after marker
    if ((posAfterMarker = $4ed65cd7115d0dcb$var$skipOrderedListMarker(state, nextLine)) >= 0) {
        isOrdered = true;
        start = state.bMarks[nextLine] + state.tShift[nextLine];
        markerValue = Number(state.src.slice(start, posAfterMarker - 1));
        // If we're starting a new ordered list right after
        // a paragraph, it should start with 1.
        if (isTerminatingParagraph && markerValue !== 1) return false;
    } else if ((posAfterMarker = $4ed65cd7115d0dcb$var$skipBulletListMarker(state, nextLine)) >= 0) isOrdered = false;
    else return false;
    // If we're starting a new unordered list right after
    // a paragraph, first line should not be empty.
    if (isTerminatingParagraph) {
        if (state.skipSpaces(posAfterMarker) >= state.eMarks[nextLine]) return false;
    }
    // For validation mode we can terminate immediately
    if (silent) return true;
    // We should terminate list on style change. Remember first one to compare.
    markerCharCode = state.src.charCodeAt(posAfterMarker - 1);
    // Start list
    listTokIdx = state.tokens.length;
    if (isOrdered) {
        token = state.push('ordered_list_open', 'ol', 1);
        if (markerValue !== 1) token.attrs = [
            [
                'start',
                markerValue
            ]
        ];
    } else token = state.push('bullet_list_open', 'ul', 1);
    token.map = listLines = [
        nextLine,
        0
    ];
    token.markup = String.fromCharCode(markerCharCode);
    //
    // Iterate list items
    //
    prevEmptyEnd = false;
    terminatorRules = state.md.block.ruler.getRules('list');
    oldParentType = state.parentType;
    state.parentType = 'list';
    while(nextLine < endLine){
        pos = posAfterMarker;
        max = state.eMarks[nextLine];
        initial = offset = state.sCount[nextLine] + posAfterMarker - (state.bMarks[nextLine] + state.tShift[nextLine]);
        while(pos < max){
            ch = state.src.charCodeAt(pos);
            if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine]) % 4;
            else if (ch === 0x20) offset++;
            else break;
            pos++;
        }
        contentStart = pos;
        if (contentStart >= max) // trimming space in "-    \n  3" case, indent is 1 here
        indentAfterMarker = 1;
        else indentAfterMarker = offset - initial;
        // If we have more than 4 spaces, the indent is 1
        // (the rest is just indented code block)
        if (indentAfterMarker > 4) indentAfterMarker = 1;
        // "  -  test"
        //  ^^^^^ - calculating total length of this thing
        indent = initial + indentAfterMarker;
        // Run subparser & write tokens
        token = state.push('list_item_open', 'li', 1);
        token.markup = String.fromCharCode(markerCharCode);
        token.map = itemLines = [
            nextLine,
            0
        ];
        if (isOrdered) token.info = state.src.slice(start, posAfterMarker - 1);
        // change current state, then restore it after parser subcall
        oldTight = state.tight;
        oldTShift = state.tShift[nextLine];
        oldSCount = state.sCount[nextLine];
        //  - example list
        // ^ listIndent position will be here
        //   ^ blkIndent position will be here
        //
        oldListIndent = state.listIndent;
        state.listIndent = state.blkIndent;
        state.blkIndent = indent;
        state.tight = true;
        state.tShift[nextLine] = contentStart - state.bMarks[nextLine];
        state.sCount[nextLine] = offset;
        if (contentStart >= max && state.isEmpty(nextLine + 1)) // workaround for this case
        // (list item is empty, list terminates before "foo"):
        // ~~~~~~~~
        //   -
        //
        //     foo
        // ~~~~~~~~
        state.line = Math.min(state.line + 2, endLine);
        else state.md.block.tokenize(state, nextLine, endLine, true);
        // If any of list item is tight, mark list as tight
        if (!state.tight || prevEmptyEnd) tight = false;
        // Item become loose if finish with empty line,
        // but we should filter last element, because it means list finish
        prevEmptyEnd = state.line - nextLine > 1 && state.isEmpty(state.line - 1);
        state.blkIndent = state.listIndent;
        state.listIndent = oldListIndent;
        state.tShift[nextLine] = oldTShift;
        state.sCount[nextLine] = oldSCount;
        state.tight = oldTight;
        token = state.push('list_item_close', 'li', -1);
        token.markup = String.fromCharCode(markerCharCode);
        nextLine = state.line;
        itemLines[1] = nextLine;
        if (nextLine >= endLine) break;
        //
        // Try to check if list is terminated or continued.
        //
        if (state.sCount[nextLine] < state.blkIndent) break;
        // if it's indented more than 3 spaces, it should be a code block
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        // fail if terminating block found
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        // fail if list has another type
        if (isOrdered) {
            posAfterMarker = $4ed65cd7115d0dcb$var$skipOrderedListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
            start = state.bMarks[nextLine] + state.tShift[nextLine];
        } else {
            posAfterMarker = $4ed65cd7115d0dcb$var$skipBulletListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
        }
        if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) break;
    }
    // Finalize list
    if (isOrdered) token = state.push('ordered_list_close', 'ol', -1);
    else token = state.push('bullet_list_close', 'ul', -1);
    token.markup = String.fromCharCode(markerCharCode);
    listLines[1] = nextLine;
    state.line = nextLine;
    state.parentType = oldParentType;
    // mark paragraphs tight if needed
    if (tight) $4ed65cd7115d0dcb$var$markTightParagraphs(state, listTokIdx);
    return true;
};

});

parcelRegister("14Fj0", function(module, exports) {
'use strict';

var $l6IUK = parcelRequire("l6IUK");
var $0c86349554c3af5f$require$normalizeReference = $l6IUK.normalizeReference;

var $l6IUK = parcelRequire("l6IUK");
var $0c86349554c3af5f$require$isSpace = $l6IUK.isSpace;
module.exports = function reference(state, startLine, _endLine, silent) {
    var ch, destEndPos, destEndLineNo, endLine, href, i, l, label, labelEnd, oldParentType, res, start, str, terminate, terminatorRules, title, lines = 0, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine], nextLine = startLine + 1;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (state.src.charCodeAt(pos) !== 0x5B /* [ */ ) return false;
    // Simple check to quickly interrupt scan on [link](url) at the start of line.
    // Can be useful on practice: https://github.com/markdown-it/markdown-it/issues/54
    while(++pos < max)if (state.src.charCodeAt(pos) === 0x5D /* ] */  && state.src.charCodeAt(pos - 1) !== 0x5C /* \ */ ) {
        if (pos + 1 === max) return false;
        if (state.src.charCodeAt(pos + 1) !== 0x3A /* : */ ) return false;
        break;
    }
    endLine = state.lineMax;
    // jump line-by-line until empty one or EOF
    terminatorRules = state.md.block.ruler.getRules('reference');
    oldParentType = state.parentType;
    state.parentType = 'reference';
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    str = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    max = str.length;
    for(pos = 1; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x5B /* [ */ ) return false;
        else if (ch === 0x5D /* ] */ ) {
            labelEnd = pos;
            break;
        } else if (ch === 0x0A /* \n */ ) lines++;
        else if (ch === 0x5C /* \ */ ) {
            pos++;
            if (pos < max && str.charCodeAt(pos) === 0x0A) lines++;
        }
    }
    if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */ ) return false;
    // [label]:   destination   'title'
    //         ^^^ skip optional whitespace here
    for(pos = labelEnd + 2; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ($0c86349554c3af5f$require$isSpace(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //            ^^^^^^^^^^^ parse this
    res = state.md.helpers.parseLinkDestination(str, pos, max);
    if (!res.ok) return false;
    href = state.md.normalizeLink(res.str);
    if (!state.md.validateLink(href)) return false;
    pos = res.pos;
    lines += res.lines;
    // save cursor state, we could require to rollback later
    destEndPos = pos;
    destEndLineNo = lines;
    // [label]:   destination   'title'
    //                       ^^^ skipping those spaces
    start = pos;
    for(; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ($0c86349554c3af5f$require$isSpace(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //                          ^^^^^^^ parse this
    res = state.md.helpers.parseLinkTitle(str, pos, max);
    if (pos < max && start !== pos && res.ok) {
        title = res.str;
        pos = res.pos;
        lines += res.lines;
    } else {
        title = '';
        pos = destEndPos;
        lines = destEndLineNo;
    }
    // skip trailing spaces until the rest of the line
    while(pos < max){
        ch = str.charCodeAt(pos);
        if (!$0c86349554c3af5f$require$isSpace(ch)) break;
        pos++;
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) {
        if (title) {
            // garbage at the end of the line after title,
            // but it could still be a valid reference if we roll back
            title = '';
            pos = destEndPos;
            lines = destEndLineNo;
            while(pos < max){
                ch = str.charCodeAt(pos);
                if (!$0c86349554c3af5f$require$isSpace(ch)) break;
                pos++;
            }
        }
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) // garbage at the end of the line
    return false;
    label = $0c86349554c3af5f$require$normalizeReference(str.slice(1, labelEnd));
    if (!label) // CommonMark 0.20 disallows empty labels
    return false;
    // Reference can not terminate anything. This check is for safety only.
    /*istanbul ignore if*/ if (silent) return true;
    if (typeof state.env.references === 'undefined') state.env.references = {};
    if (typeof state.env.references[label] === 'undefined') state.env.references[label] = {
        title: title,
        href: href
    };
    state.parentType = oldParentType;
    state.line = startLine + lines + 1;
    return true;
};

});

parcelRegister("agiT5", function(module, exports) {
// HTML block
'use strict';

var $5Ihfj = parcelRequire("5Ihfj");

var $0dDBY = parcelRequire("0dDBY");
var $778a0ca53406637a$require$HTML_OPEN_CLOSE_TAG_RE = $0dDBY.HTML_OPEN_CLOSE_TAG_RE;
// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
var $778a0ca53406637a$var$HTML_SEQUENCES = [
    [
        /^<(script|pre|style|textarea)(?=(\s|>|$))/i,
        /<\/(script|pre|style|textarea)>/i,
        true
    ],
    [
        /^<!--/,
        /-->/,
        true
    ],
    [
        /^<\?/,
        /\?>/,
        true
    ],
    [
        /^<![A-Z]/,
        />/,
        true
    ],
    [
        /^<!\[CDATA\[/,
        /\]\]>/,
        true
    ],
    [
        new RegExp('^</?(' + $5Ihfj.join('|') + ')(?=(\\s|/?>|$))', 'i'),
        /^$/,
        true
    ],
    [
        new RegExp($778a0ca53406637a$require$HTML_OPEN_CLOSE_TAG_RE.source + '\\s*$'),
        /^$/,
        false
    ]
];
module.exports = function html_block(state, startLine, endLine, silent) {
    var i, nextLine, token, lineText, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (!state.md.options.html) return false;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    lineText = state.src.slice(pos, max);
    for(i = 0; i < $778a0ca53406637a$var$HTML_SEQUENCES.length; i++){
        if ($778a0ca53406637a$var$HTML_SEQUENCES[i][0].test(lineText)) break;
    }
    if (i === $778a0ca53406637a$var$HTML_SEQUENCES.length) return false;
    if (silent) // true if this sequence can be a terminator, false otherwise
    return $778a0ca53406637a$var$HTML_SEQUENCES[i][2];
    nextLine = startLine + 1;
    // If we are here - we detected HTML block.
    // Let's roll down till block end.
    if (!$778a0ca53406637a$var$HTML_SEQUENCES[i][1].test(lineText)) for(; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        lineText = state.src.slice(pos, max);
        if ($778a0ca53406637a$var$HTML_SEQUENCES[i][1].test(lineText)) {
            if (lineText.length !== 0) nextLine++;
            break;
        }
    }
    state.line = nextLine;
    token = state.push('html_block', '', 0);
    token.map = [
        startLine,
        nextLine
    ];
    token.content = state.getLines(startLine, nextLine, state.blkIndent, true);
    return true;
};

});
parcelRegister("5Ihfj", function(module, exports) {
// List of valid html blocks names, accorting to commonmark spec
// http://jgm.github.io/CommonMark/spec.html#html-blocks
'use strict';
module.exports = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'section',
    'source',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];

});

parcelRegister("0dDBY", function(module, exports) {
$parcel$export(module.exports, "HTML_TAG_RE", () => $000a94675f760217$export$6db61d2c3a16e419, (v) => $000a94675f760217$export$6db61d2c3a16e419 = v);
$parcel$export(module.exports, "HTML_OPEN_CLOSE_TAG_RE", () => $000a94675f760217$export$cd48660d06f74639, (v) => $000a94675f760217$export$cd48660d06f74639 = v);
// Regexps to match html elements
var $000a94675f760217$export$6db61d2c3a16e419;
var $000a94675f760217$export$cd48660d06f74639;
'use strict';
var $000a94675f760217$var$attr_name = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
var $000a94675f760217$var$unquoted = '[^"\'=<>`\\x00-\\x20]+';
var $000a94675f760217$var$single_quoted = "'[^']*'";
var $000a94675f760217$var$double_quoted = '"[^"]*"';
var $000a94675f760217$var$attr_value = '(?:' + $000a94675f760217$var$unquoted + '|' + $000a94675f760217$var$single_quoted + '|' + $000a94675f760217$var$double_quoted + ')';
var $000a94675f760217$var$attribute = '(?:\\s+' + $000a94675f760217$var$attr_name + '(?:\\s*=\\s*' + $000a94675f760217$var$attr_value + ')?)';
var $000a94675f760217$var$open_tag = '<[A-Za-z][A-Za-z0-9\\-]*' + $000a94675f760217$var$attribute + '*\\s*\\/?>';
var $000a94675f760217$var$close_tag = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
var $000a94675f760217$var$comment = '<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->';
var $000a94675f760217$var$processing = '<[?][\\s\\S]*?[?]>';
var $000a94675f760217$var$declaration = '<![A-Z]+\\s+[^>]*>';
var $000a94675f760217$var$cdata = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';
var $000a94675f760217$var$HTML_TAG_RE = new RegExp('^(?:' + $000a94675f760217$var$open_tag + '|' + $000a94675f760217$var$close_tag + '|' + $000a94675f760217$var$comment + '|' + $000a94675f760217$var$processing + '|' + $000a94675f760217$var$declaration + '|' + $000a94675f760217$var$cdata + ')');
var $000a94675f760217$var$HTML_OPEN_CLOSE_TAG_RE = new RegExp('^(?:' + $000a94675f760217$var$open_tag + '|' + $000a94675f760217$var$close_tag + ')');
$000a94675f760217$export$6db61d2c3a16e419 = $000a94675f760217$var$HTML_TAG_RE;
$000a94675f760217$export$cd48660d06f74639 = $000a94675f760217$var$HTML_OPEN_CLOSE_TAG_RE;

});


parcelRegister("9FRBG", function(module, exports) {
// heading (#, ##, ...)
'use strict';

var $l6IUK = parcelRequire("l6IUK");
var $70b18692c05fad89$require$isSpace = $l6IUK.isSpace;
module.exports = function heading(state, startLine, endLine, silent) {
    var ch, level, tmp, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    ch = state.src.charCodeAt(pos);
    if (ch !== 0x23 /* # */  || pos >= max) return false;
    // count heading level
    level = 1;
    ch = state.src.charCodeAt(++pos);
    while(ch === 0x23 /* # */  && pos < max && level <= 6){
        level++;
        ch = state.src.charCodeAt(++pos);
    }
    if (level > 6 || pos < max && !$70b18692c05fad89$require$isSpace(ch)) return false;
    if (silent) return true;
    // Let's cut tails like '    ###  ' from the end of string
    max = state.skipSpacesBack(max, pos);
    tmp = state.skipCharsBack(max, 0x23, pos); // #
    if (tmp > pos && $70b18692c05fad89$require$isSpace(state.src.charCodeAt(tmp - 1))) max = tmp;
    state.line = startLine + 1;
    token = state.push('heading_open', 'h' + String(level), 1);
    token.markup = '########'.slice(0, level);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = state.src.slice(pos, max).trim();
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('heading_close', 'h' + String(level), -1);
    token.markup = '########'.slice(0, level);
    return true;
};

});

parcelRegister("aKAqI", function(module, exports) {
// lheading (---, ===)
'use strict';
module.exports = function lheading(state, startLine, endLine /*, silent*/ ) {
    var content, terminate, i, l, token, pos, max, level, marker, nextLine = startLine + 1, oldParentType, terminatorRules = state.md.block.ruler.getRules('paragraph');
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    oldParentType = state.parentType;
    state.parentType = 'paragraph'; // use paragraph to match terminatorRules
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        //
        // Check for underline in setext header
        //
        if (state.sCount[nextLine] >= state.blkIndent) {
            pos = state.bMarks[nextLine] + state.tShift[nextLine];
            max = state.eMarks[nextLine];
            if (pos < max) {
                marker = state.src.charCodeAt(pos);
                if (marker === 0x2D /* - */  || marker === 0x3D /* = */ ) {
                    pos = state.skipChars(pos, marker);
                    pos = state.skipSpaces(pos);
                    if (pos >= max) {
                        level = marker === 0x3D /* = */  ? 1 : 2;
                        break;
                    }
                }
            }
        }
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    if (!level) // Didn't find valid underline
    return false;
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine + 1;
    token = state.push('heading_open', 'h' + String(level), 1);
    token.markup = String.fromCharCode(marker);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line - 1
    ];
    token.children = [];
    token = state.push('heading_close', 'h' + String(level), -1);
    token.markup = String.fromCharCode(marker);
    state.parentType = oldParentType;
    return true;
};

});

parcelRegister("7QU8N", function(module, exports) {
// Paragraph
'use strict';
module.exports = function paragraph(state, startLine, endLine) {
    var content, terminate, i, l, token, oldParentType, nextLine = startLine + 1, terminatorRules = state.md.block.ruler.getRules('paragraph');
    oldParentType = state.parentType;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    token = state.push('paragraph_open', 'p', 1);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
};

});

parcelRegister("4ASdB", function(module, exports) {
// Parser state class
'use strict';

var $8AILn = parcelRequire("8AILn");

var $l6IUK = parcelRequire("l6IUK");
var $358494e0e5c813f5$require$isSpace = $l6IUK.isSpace;
function $358494e0e5c813f5$var$StateBlock(src, md, env, tokens) {
    var ch, s, start, pos, len, indent, offset, indent_found;
    this.src = src;
    // link to parser instance
    this.md = md;
    this.env = env;
    //
    // Internal state vartiables
    //
    this.tokens = tokens;
    this.bMarks = []; // line begin offsets for fast jumps
    this.eMarks = []; // line end offsets for fast jumps
    this.tShift = []; // offsets of the first non-space characters (tabs not expanded)
    this.sCount = []; // indents for each line (tabs expanded)
    // An amount of virtual spaces (tabs expanded) between beginning
    // of each line (bMarks) and real beginning of that line.
    //
    // It exists only as a hack because blockquotes override bMarks
    // losing information in the process.
    //
    // It's used only when expanding tabs, you can think about it as
    // an initial tab length, e.g. bsCount=21 applied to string `\t123`
    // means first tab should be expanded to 4-21%4 === 3 spaces.
    //
    this.bsCount = [];
    // block parser variables
    this.blkIndent = 0; // required block content indent (for example, if we are
    // inside a list, it would be positioned after list marker)
    this.line = 0; // line index in src
    this.lineMax = 0; // lines count
    this.tight = false; // loose/tight mode for lists
    this.ddIndent = -1; // indent of the current dd block (-1 if there isn't any)
    this.listIndent = -1; // indent of the current list block (-1 if there isn't any)
    // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
    // used in lists to determine if they interrupt a paragraph
    this.parentType = 'root';
    this.level = 0;
    // renderer
    this.result = '';
    // Create caches
    // Generate markers.
    s = this.src;
    indent_found = false;
    for(start = pos = indent = offset = 0, len = s.length; pos < len; pos++){
        ch = s.charCodeAt(pos);
        if (!indent_found) {
            if ($358494e0e5c813f5$require$isSpace(ch)) {
                indent++;
                if (ch === 0x09) offset += 4 - offset % 4;
                else offset++;
                continue;
            } else indent_found = true;
        }
        if (ch === 0x0A || pos === len - 1) {
            if (ch !== 0x0A) pos++;
            this.bMarks.push(start);
            this.eMarks.push(pos);
            this.tShift.push(indent);
            this.sCount.push(offset);
            this.bsCount.push(0);
            indent_found = false;
            indent = 0;
            offset = 0;
            start = pos + 1;
        }
    }
    // Push fake entry to simplify cache bounds checks
    this.bMarks.push(s.length);
    this.eMarks.push(s.length);
    this.tShift.push(0);
    this.sCount.push(0);
    this.bsCount.push(0);
    this.lineMax = this.bMarks.length - 1; // don't count last fake line
}
// Push new token to "stream".
//
$358494e0e5c813f5$var$StateBlock.prototype.push = function(type, tag, nesting) {
    var token = new $8AILn(type, tag, nesting);
    token.block = true;
    if (nesting < 0) this.level--; // closing tag
    token.level = this.level;
    if (nesting > 0) this.level++; // opening tag
    this.tokens.push(token);
    return token;
};
$358494e0e5c813f5$var$StateBlock.prototype.isEmpty = function isEmpty(line) {
    return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};
$358494e0e5c813f5$var$StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
    for(var max = this.lineMax; from < max; from++){
        if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) break;
    }
    return from;
};
// Skip spaces from given position.
$358494e0e5c813f5$var$StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
    var ch;
    for(var max = this.src.length; pos < max; pos++){
        ch = this.src.charCodeAt(pos);
        if (!$358494e0e5c813f5$require$isSpace(ch)) break;
    }
    return pos;
};
// Skip spaces from given position in reverse.
$358494e0e5c813f5$var$StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (!$358494e0e5c813f5$require$isSpace(this.src.charCodeAt(--pos))) return pos + 1;
    }
    return pos;
};
// Skip char codes from given position
$358494e0e5c813f5$var$StateBlock.prototype.skipChars = function skipChars(pos, code) {
    for(var max = this.src.length; pos < max; pos++){
        if (this.src.charCodeAt(pos) !== code) break;
    }
    return pos;
};
// Skip char codes reverse from given position - 1
$358494e0e5c813f5$var$StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (code !== this.src.charCodeAt(--pos)) return pos + 1;
    }
    return pos;
};
// cut lines range from source.
$358494e0e5c813f5$var$StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
    var i, lineIndent, ch, first, last, queue, lineStart, line = begin;
    if (begin >= end) return '';
    queue = new Array(end - begin);
    for(i = 0; line < end; line++, i++){
        lineIndent = 0;
        lineStart = first = this.bMarks[line];
        if (line + 1 < end || keepLastLF) // No need for bounds check because we have fake entry on tail.
        last = this.eMarks[line] + 1;
        else last = this.eMarks[line];
        while(first < last && lineIndent < indent){
            ch = this.src.charCodeAt(first);
            if ($358494e0e5c813f5$require$isSpace(ch)) {
                if (ch === 0x09) lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
                else lineIndent++;
            } else if (first - lineStart < this.tShift[line]) // patched tShift masked characters to look like spaces (blockquotes, list markers)
            lineIndent++;
            else break;
            first++;
        }
        if (lineIndent > indent) // partially expanding tabs in code blocks, e.g '\t\tfoobar'
        // with indent=2 becomes '  \tfoobar'
        queue[i] = new Array(lineIndent - indent + 1).join(' ') + this.src.slice(first, last);
        else queue[i] = this.src.slice(first, last);
    }
    return queue.join('');
};
// re-export Token class to use in block rules
$358494e0e5c813f5$var$StateBlock.prototype.Token = $8AILn;
module.exports = $358494e0e5c813f5$var$StateBlock;

});


parcelRegister("hkcNh", function(module, exports) {
/** internal
 * class ParserInline
 *
 * Tokenizes paragraph content.
 **/ 'use strict';

var $c3dcz = parcelRequire("c3dcz");












////////////////////////////////////////////////////////////////////////////////
// Parser rules
var $c9ce3a88b0f025ea$var$_rules = [
    [
        'text',
        (parcelRequire("9CTc4"))
    ],
    [
        'linkify',
        (parcelRequire("2BswS"))
    ],
    [
        'newline',
        (parcelRequire("jE0nb"))
    ],
    [
        'escape',
        (parcelRequire("k9EFJ"))
    ],
    [
        'backticks',
        (parcelRequire("fC6en"))
    ],
    [
        'strikethrough',
        (parcelRequire("dT517")).tokenize
    ],
    [
        'emphasis',
        (parcelRequire("ji5vg")).tokenize
    ],
    [
        'link',
        (parcelRequire("7ZRUa"))
    ],
    [
        'image',
        (parcelRequire("3t7o6"))
    ],
    [
        'autolink',
        (parcelRequire("fyaCn"))
    ],
    [
        'html_inline',
        (parcelRequire("9M7vq"))
    ],
    [
        'entity',
        (parcelRequire("i1a7Z"))
    ]
];




// `rule2` ruleset was created specifically for emphasis/strikethrough
// post-processing and may be changed in the future.
//
// Don't use this for anything except pairs (plugins working with `balance_pairs`).
//
var $c9ce3a88b0f025ea$var$_rules2 = [
    [
        'balance_pairs',
        (parcelRequire("6FHxS"))
    ],
    [
        'strikethrough',
        (parcelRequire("dT517")).postProcess
    ],
    [
        'emphasis',
        (parcelRequire("ji5vg")).postProcess
    ],
    // rules for pairs separate '**' into its own text tokens, which may be left unused,
    // rule below merges unused segments back with the rest of the text
    [
        'fragments_join',
        (parcelRequire("9Rdip"))
    ]
];
/**
 * new ParserInline()
 **/ function $c9ce3a88b0f025ea$var$ParserInline() {
    var i;
    /**
   * ParserInline#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of inline rules.
   **/ this.ruler = new $c3dcz();
    for(i = 0; i < $c9ce3a88b0f025ea$var$_rules.length; i++)this.ruler.push($c9ce3a88b0f025ea$var$_rules[i][0], $c9ce3a88b0f025ea$var$_rules[i][1]);
    /**
   * ParserInline#ruler2 -> Ruler
   *
   * [[Ruler]] instance. Second ruler used for post-processing
   * (e.g. in emphasis-like rules).
   **/ this.ruler2 = new $c3dcz();
    for(i = 0; i < $c9ce3a88b0f025ea$var$_rules2.length; i++)this.ruler2.push($c9ce3a88b0f025ea$var$_rules2[i][0], $c9ce3a88b0f025ea$var$_rules2[i][1]);
}
// Skip single token by running all rules in validation mode;
// returns `true` if any rule reported success
//
$c9ce3a88b0f025ea$var$ParserInline.prototype.skipToken = function(state) {
    var ok, i, pos = state.pos, rules = this.ruler.getRules(''), len = rules.length, maxNesting = state.md.options.maxNesting, cache = state.cache;
    if (typeof cache[pos] !== 'undefined') {
        state.pos = cache[pos];
        return;
    }
    if (state.level < maxNesting) for(i = 0; i < len; i++){
        // Increment state.level and decrement it later to limit recursion.
        // It's harmless to do here, because no tokens are created. But ideally,
        // we'd need a separate private state variable for this purpose.
        //
        state.level++;
        ok = rules[i](state, true);
        state.level--;
        if (ok) {
            if (pos >= state.pos) throw new Error("inline rule didn't increment state.pos");
            break;
        }
    }
    else // Too much nesting, just skip until the end of the paragraph.
    //
    // NOTE: this will cause links to behave incorrectly in the following case,
    //       when an amount of `[` is exactly equal to `maxNesting + 1`:
    //
    //       [[[[[[[[[[[[[[[[[[[[[foo]()
    //
    // TODO: remove this workaround when CM standard will allow nested links
    //       (we can replace it by preventing links from being parsed in
    //       validation mode)
    //
    state.pos = state.posMax;
    if (!ok) state.pos++;
    cache[pos] = state.pos;
};
// Generate tokens for input range
//
$c9ce3a88b0f025ea$var$ParserInline.prototype.tokenize = function(state) {
    var ok, i, prevPos, rules = this.ruler.getRules(''), len = rules.length, end = state.posMax, maxNesting = state.md.options.maxNesting;
    while(state.pos < end){
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.pos`
        // - update `state.tokens`
        // - return true
        prevPos = state.pos;
        if (state.level < maxNesting) for(i = 0; i < len; i++){
            ok = rules[i](state, false);
            if (ok) {
                if (prevPos >= state.pos) throw new Error("inline rule didn't increment state.pos");
                break;
            }
        }
        if (ok) {
            if (state.pos >= end) break;
            continue;
        }
        state.pending += state.src[state.pos++];
    }
    if (state.pending) state.pushPending();
};
/**
 * ParserInline.parse(str, md, env, outTokens)
 *
 * Process input string and push inline tokens into `outTokens`
 **/ $c9ce3a88b0f025ea$var$ParserInline.prototype.parse = function(str, md, env, outTokens) {
    var i, rules, len;
    var state = new this.State(str, md, env, outTokens);
    this.tokenize(state);
    rules = this.ruler2.getRules('');
    len = rules.length;
    for(i = 0; i < len; i++)rules[i](state);
};

$c9ce3a88b0f025ea$var$ParserInline.prototype.State = (parcelRequire("88Wcs"));
module.exports = $c9ce3a88b0f025ea$var$ParserInline;

});
parcelRegister("9CTc4", function(module, exports) {
// Skip text characters for text token, place those to pending buffer
// and increment current pos
'use strict';
// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// !!!! Don't confuse with "Markdown ASCII Punctuation" chars
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
function $702279f88976b162$var$isTerminatorChar(ch) {
    switch(ch){
        case 0x0A /* \n */ :
        case 0x21 /* ! */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2D /* - */ :
        case 0x3A /* : */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
module.exports = function text(state, silent) {
    var pos = state.pos;
    while(pos < state.posMax && !$702279f88976b162$var$isTerminatorChar(state.src.charCodeAt(pos)))pos++;
    if (pos === state.pos) return false;
    if (!silent) state.pending += state.src.slice(state.pos, pos);
    state.pos = pos;
    return true;
}; // Alternative implementation, for memory.
 //
 // It costs 10% of performance, but allows extend terminators list, if place it
 // to `ParcerInline` property. Probably, will switch to it sometime, such
 // flexibility required.
 /*
var TERMINATOR_RE = /[\n!#$%&*+\-:<=>@[\\\]^_`{}~]/;

module.exports = function text(state, silent) {
  var pos = state.pos,
      idx = state.src.slice(pos).search(TERMINATOR_RE);

  // first char is terminator -> empty text
  if (idx === 0) { return false; }

  // no terminator -> text till end of string
  if (idx < 0) {
    if (!silent) { state.pending += state.src.slice(pos); }
    state.pos = state.src.length;
    return true;
  }

  if (!silent) { state.pending += state.src.slice(pos, pos + idx); }

  state.pos += idx;

  return true;
};*/ 

});

parcelRegister("2BswS", function(module, exports) {
// Process links like https://example.org/
'use strict';
// RFC3986: scheme = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
var $1e552aca02548a0c$var$SCHEME_RE = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
module.exports = function linkify(state, silent) {
    var pos, max, match, proto, link, url, fullUrl, token;
    if (!state.md.options.linkify) return false;
    if (state.linkLevel > 0) return false;
    pos = state.pos;
    max = state.posMax;
    if (pos + 3 > max) return false;
    if (state.src.charCodeAt(pos) !== 0x3A /* : */ ) return false;
    if (state.src.charCodeAt(pos + 1) !== 0x2F /* / */ ) return false;
    if (state.src.charCodeAt(pos + 2) !== 0x2F /* / */ ) return false;
    match = state.pending.match($1e552aca02548a0c$var$SCHEME_RE);
    if (!match) return false;
    proto = match[1];
    link = state.md.linkify.matchAtStart(state.src.slice(pos - proto.length));
    if (!link) return false;
    url = link.url;
    // invalid link, but still detected by linkify somehow;
    // need to check to prevent infinite loop below
    if (url.length <= proto.length) return false;
    // disallow '*' at the end of the link (conflicts with emphasis)
    url = url.replace(/\*+$/, '');
    fullUrl = state.md.normalizeLink(url);
    if (!state.md.validateLink(fullUrl)) return false;
    if (!silent) {
        state.pending = state.pending.slice(0, -proto.length);
        token = state.push('link_open', 'a', 1);
        token.attrs = [
            [
                'href',
                fullUrl
            ]
        ];
        token.markup = 'linkify';
        token.info = 'auto';
        token = state.push('text', '', 0);
        token.content = state.md.normalizeLinkText(url);
        token = state.push('link_close', 'a', -1);
        token.markup = 'linkify';
        token.info = 'auto';
    }
    state.pos += url.length - proto.length;
    return true;
};

});

parcelRegister("jE0nb", function(module, exports) {
// Proceess '\n'
'use strict';

var $l6IUK = parcelRequire("l6IUK");
var $e4d20ad3daa16369$require$isSpace = $l6IUK.isSpace;
module.exports = function newline(state, silent) {
    var pmax, max, ws, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x0A /* \n */ ) return false;
    pmax = state.pending.length - 1;
    max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
                // Find whitespaces tail of pending chars.
                ws = pmax - 1;
                while(ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20)ws--;
                state.pending = state.pending.slice(0, ws);
                state.push('hardbreak', 'br', 0);
            } else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // skip heading spaces for next line
    while(pos < max && $e4d20ad3daa16369$require$isSpace(state.src.charCodeAt(pos)))pos++;
    state.pos = pos;
    return true;
};

});

parcelRegister("k9EFJ", function(module, exports) {
// Process escaped chars and hardbreaks
'use strict';

var $l6IUK = parcelRequire("l6IUK");
var $eac4328664b70245$require$isSpace = $l6IUK.isSpace;
var $eac4328664b70245$var$ESCAPED = [];
for(var $eac4328664b70245$var$i = 0; $eac4328664b70245$var$i < 256; $eac4328664b70245$var$i++)$eac4328664b70245$var$ESCAPED.push(0);
'\\!"#$%&\'()*+,./:;<=>?@[]^_`{|}~-'.split('').forEach(function(ch) {
    $eac4328664b70245$var$ESCAPED[ch.charCodeAt(0)] = 1;
});
module.exports = function escape(state, silent) {
    var ch1, ch2, origStr, escapedStr, token, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x5C /* \ */ ) return false;
    pos++;
    // '\' at the end of the inline block
    if (pos >= max) return false;
    ch1 = state.src.charCodeAt(pos);
    if (ch1 === 0x0A) {
        if (!silent) state.push('hardbreak', 'br', 0);
        pos++;
        // skip leading whitespaces from next line
        while(pos < max){
            ch1 = state.src.charCodeAt(pos);
            if (!$eac4328664b70245$require$isSpace(ch1)) break;
            pos++;
        }
        state.pos = pos;
        return true;
    }
    escapedStr = state.src[pos];
    if (ch1 >= 0xD800 && ch1 <= 0xDBFF && pos + 1 < max) {
        ch2 = state.src.charCodeAt(pos + 1);
        if (ch2 >= 0xDC00 && ch2 <= 0xDFFF) {
            escapedStr += state.src[pos + 1];
            pos++;
        }
    }
    origStr = '\\' + escapedStr;
    if (!silent) {
        token = state.push('text_special', '', 0);
        if (ch1 < 256 && $eac4328664b70245$var$ESCAPED[ch1] !== 0) token.content = escapedStr;
        else token.content = origStr;
        token.markup = origStr;
        token.info = 'escape';
    }
    state.pos = pos + 1;
    return true;
};

});

parcelRegister("fC6en", function(module, exports) {
// Parse backticks
'use strict';
module.exports = function backtick(state, silent) {
    var start, max, marker, token, matchStart, matchEnd, openerLength, closerLength, pos = state.pos, ch = state.src.charCodeAt(pos);
    if (ch !== 0x60 /* ` */ ) return false;
    start = pos;
    pos++;
    max = state.posMax;
    // scan marker length
    while(pos < max && state.src.charCodeAt(pos) === 0x60 /* ` */ )pos++;
    marker = state.src.slice(start, pos);
    openerLength = marker.length;
    if (state.backticksScanned && (state.backticks[openerLength] || 0) <= start) {
        if (!silent) state.pending += marker;
        state.pos += openerLength;
        return true;
    }
    matchEnd = pos;
    // Nothing found in the cache, scan until the end of the line (or until marker is found)
    while((matchStart = state.src.indexOf('`', matchEnd)) !== -1){
        matchEnd = matchStart + 1;
        // scan marker length
        while(matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60 /* ` */ )matchEnd++;
        closerLength = matchEnd - matchStart;
        if (closerLength === openerLength) {
            // Found matching closer length.
            if (!silent) {
                token = state.push('code_inline', 'code', 0);
                token.markup = marker;
                token.content = state.src.slice(pos, matchStart).replace(/\n/g, ' ').replace(/^ (.+) $/, '$1');
            }
            state.pos = matchEnd;
            return true;
        }
        // Some different length found, put it in cache as upper limit of where closer can be found
        state.backticks[closerLength] = matchStart;
    }
    // Scanned through the end, didn't find anything
    state.backticksScanned = true;
    if (!silent) state.pending += marker;
    state.pos += openerLength;
    return true;
};

});

parcelRegister("dT517", function(module, exports) {
$parcel$export(module.exports, "tokenize", () => $a1c44db354892de3$export$660b2ee2d4fb4eff, (v) => $a1c44db354892de3$export$660b2ee2d4fb4eff = v);
$parcel$export(module.exports, "postProcess", () => $a1c44db354892de3$export$7b804a0e0ce836d9, (v) => $a1c44db354892de3$export$7b804a0e0ce836d9 = v);
// ~~strike through~~
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var $a1c44db354892de3$export$660b2ee2d4fb4eff;
// Walk through delimiter list and replace text tokens with tags
//
var $a1c44db354892de3$export$7b804a0e0ce836d9;
'use strict';
$a1c44db354892de3$export$660b2ee2d4fb4eff = function strikethrough(state, silent) {
    var i, scanned, token, len, ch, start = state.pos, marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x7E /* ~ */ ) return false;
    scanned = state.scanDelims(state.pos, true);
    len = scanned.length;
    ch = String.fromCharCode(marker);
    if (len < 2) return false;
    if (len % 2) {
        token = state.push('text', '', 0);
        token.content = ch;
        len--;
    }
    for(i = 0; i < len; i += 2){
        token = state.push('text', '', 0);
        token.content = ch + ch;
        state.delimiters.push({
            marker: marker,
            length: 0,
            token: state.tokens.length - 1,
            end: -1,
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
};
function $a1c44db354892de3$var$postProcess(state, delimiters) {
    var i, j, startDelim, endDelim, token, loneMarkers = [], max = delimiters.length;
    for(i = 0; i < max; i++){
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x7E /* ~ */ ) continue;
        if (startDelim.end === -1) continue;
        endDelim = delimiters[startDelim.end];
        token = state.tokens[startDelim.token];
        token.type = 's_open';
        token.tag = 's';
        token.nesting = 1;
        token.markup = '~~';
        token.content = '';
        token = state.tokens[endDelim.token];
        token.type = 's_close';
        token.tag = 's';
        token.nesting = -1;
        token.markup = '~~';
        token.content = '';
        if (state.tokens[endDelim.token - 1].type === 'text' && state.tokens[endDelim.token - 1].content === '~') loneMarkers.push(endDelim.token - 1);
    }
    // If a marker sequence has an odd number of characters, it's splitted
    // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
    // start of the sequence.
    //
    // So, we have to move all those markers after subsequent s_close tags.
    //
    while(loneMarkers.length){
        i = loneMarkers.pop();
        j = i + 1;
        while(j < state.tokens.length && state.tokens[j].type === 's_close')j++;
        j--;
        if (i !== j) {
            token = state.tokens[j];
            state.tokens[j] = state.tokens[i];
            state.tokens[i] = token;
        }
    }
}
$a1c44db354892de3$export$7b804a0e0ce836d9 = function strikethrough(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $a1c44db354892de3$var$postProcess(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $a1c44db354892de3$var$postProcess(state, tokens_meta[curr].delimiters);
};

});

parcelRegister("ji5vg", function(module, exports) {
$parcel$export(module.exports, "tokenize", () => $e0b3f79dfd6fab43$export$660b2ee2d4fb4eff, (v) => $e0b3f79dfd6fab43$export$660b2ee2d4fb4eff = v);
$parcel$export(module.exports, "postProcess", () => $e0b3f79dfd6fab43$export$7b804a0e0ce836d9, (v) => $e0b3f79dfd6fab43$export$7b804a0e0ce836d9 = v);
// Process *this* and _that_
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var $e0b3f79dfd6fab43$export$660b2ee2d4fb4eff;
// Walk through delimiter list and replace text tokens with tags
//
var $e0b3f79dfd6fab43$export$7b804a0e0ce836d9;
'use strict';
$e0b3f79dfd6fab43$export$660b2ee2d4fb4eff = function emphasis(state, silent) {
    var i, scanned, token, start = state.pos, marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x5F /* _ */  && marker !== 0x2A /* * */ ) return false;
    scanned = state.scanDelims(state.pos, marker === 0x2A);
    for(i = 0; i < scanned.length; i++){
        token = state.push('text', '', 0);
        token.content = String.fromCharCode(marker);
        state.delimiters.push({
            // Char code of the starting marker (number).
            //
            marker: marker,
            // Total length of these series of delimiters.
            //
            length: scanned.length,
            // A position of the token this delimiter corresponds to.
            //
            token: state.tokens.length - 1,
            // If this delimiter is matched as a valid opener, `end` will be
            // equal to its position, otherwise it's `-1`.
            //
            end: -1,
            // Boolean flags that determine if this delimiter could open or close
            // an emphasis.
            //
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
};
function $e0b3f79dfd6fab43$var$postProcess(state, delimiters) {
    var i, startDelim, endDelim, token, ch, isStrong, max = delimiters.length;
    for(i = max - 1; i >= 0; i--){
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x5F /* _ */  && startDelim.marker !== 0x2A /* * */ ) continue;
        // Process only opening markers
        if (startDelim.end === -1) continue;
        endDelim = delimiters[startDelim.end];
        // If the previous delimiter has the same marker and is adjacent to this one,
        // merge those into one strong delimiter.
        //
        // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
        //
        isStrong = i > 0 && delimiters[i - 1].end === startDelim.end + 1 && // check that first two markers match and adjacent
        delimiters[i - 1].marker === startDelim.marker && delimiters[i - 1].token === startDelim.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
        delimiters[startDelim.end + 1].token === endDelim.token + 1;
        ch = String.fromCharCode(startDelim.marker);
        token = state.tokens[startDelim.token];
        token.type = isStrong ? 'strong_open' : 'em_open';
        token.tag = isStrong ? 'strong' : 'em';
        token.nesting = 1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = '';
        token = state.tokens[endDelim.token];
        token.type = isStrong ? 'strong_close' : 'em_close';
        token.tag = isStrong ? 'strong' : 'em';
        token.nesting = -1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = '';
        if (isStrong) {
            state.tokens[delimiters[i - 1].token].content = '';
            state.tokens[delimiters[startDelim.end + 1].token].content = '';
            i--;
        }
    }
}
$e0b3f79dfd6fab43$export$7b804a0e0ce836d9 = function emphasis(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $e0b3f79dfd6fab43$var$postProcess(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $e0b3f79dfd6fab43$var$postProcess(state, tokens_meta[curr].delimiters);
};

});

parcelRegister("7ZRUa", function(module, exports) {
// Process [link](<to> "stuff")
'use strict';

var $l6IUK = parcelRequire("l6IUK");
var $5d280b49f64c4b8a$require$normalizeReference = $l6IUK.normalizeReference;

var $l6IUK = parcelRequire("l6IUK");
var $5d280b49f64c4b8a$require$isSpace = $l6IUK.isSpace;
module.exports = function link(state, silent) {
    var attrs, code, label, labelEnd, labelStart, pos, res, ref, token, href = '', title = '', oldPos = state.pos, max = state.posMax, start = state.pos, parseReference = true;
    if (state.src.charCodeAt(state.pos) !== 0x5B /* [ */ ) return false;
    labelStart = state.pos + 1;
    labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // might have found a valid shortcut link, disable reference parsing
        parseReference = false;
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$5d280b49f64c4b8a$require$isSpace(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
            // [link](  <href>  "title"  )
            //                ^^ skipping these spaces
            start = pos;
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$5d280b49f64c4b8a$require$isSpace(code) && code !== 0x0A) break;
            }
            // [link](  <href>  "title"  )
            //                  ^^^^^^^ parsing link title
            res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
            if (pos < max && start !== pos && res.ok) {
                title = res.str;
                pos = res.pos;
                // [link](  <href>  "title"  )
                //                         ^^ skipping these spaces
                for(; pos < max; pos++){
                    code = state.src.charCodeAt(pos);
                    if (!$5d280b49f64c4b8a$require$isSpace(code) && code !== 0x0A) break;
                }
            }
        }
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) // parsing a valid shortcut link failed, fallback to reference
        parseReference = true;
        pos++;
    }
    if (parseReference) {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[$5d280b49f64c4b8a$require$normalizeReference(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        state.pos = labelStart;
        state.posMax = labelEnd;
        token = state.push('link_open', 'a', 1);
        token.attrs = attrs = [
            [
                'href',
                href
            ]
        ];
        if (title) attrs.push([
            'title',
            title
        ]);
        state.linkLevel++;
        state.md.inline.tokenize(state);
        state.linkLevel--;
        token = state.push('link_close', 'a', -1);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRegister("3t7o6", function(module, exports) {
// Process ![image](<src> "title")
'use strict';

var $l6IUK = parcelRequire("l6IUK");
var $2869cf98507d2846$require$normalizeReference = $l6IUK.normalizeReference;

var $l6IUK = parcelRequire("l6IUK");
var $2869cf98507d2846$require$isSpace = $l6IUK.isSpace;
module.exports = function image(state, silent) {
    var attrs, code, content, label, labelEnd, labelStart, pos, ref, res, title, token, tokens, start, href = '', oldPos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(state.pos) !== 0x21 /* ! */ ) return false;
    if (state.src.charCodeAt(state.pos + 1) !== 0x5B /* [ */ ) return false;
    labelStart = state.pos + 2;
    labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$2869cf98507d2846$require$isSpace(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
        }
        // [link](  <href>  "title"  )
        //                ^^ skipping these spaces
        start = pos;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$2869cf98507d2846$require$isSpace(code) && code !== 0x0A) break;
        }
        // [link](  <href>  "title"  )
        //                  ^^^^^^^ parsing link title
        res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
        if (pos < max && start !== pos && res.ok) {
            title = res.str;
            pos = res.pos;
            // [link](  <href>  "title"  )
            //                         ^^ skipping these spaces
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$2869cf98507d2846$require$isSpace(code) && code !== 0x0A) break;
            }
        } else title = '';
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) {
            state.pos = oldPos;
            return false;
        }
        pos++;
    } else {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[$2869cf98507d2846$require$normalizeReference(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        content = state.src.slice(labelStart, labelEnd);
        state.md.inline.parse(content, state.md, state.env, tokens = []);
        token = state.push('image', 'img', 0);
        token.attrs = attrs = [
            [
                'src',
                href
            ],
            [
                'alt',
                ''
            ]
        ];
        token.children = tokens;
        token.content = content;
        if (title) attrs.push([
            'title',
            title
        ]);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRegister("fyaCn", function(module, exports) {
// Process autolinks '<protocol:...>'
'use strict';
/*eslint max-len:0*/ var $b52244839cfe6245$var$EMAIL_RE = /^([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/;
var $b52244839cfe6245$var$AUTOLINK_RE = /^([a-zA-Z][a-zA-Z0-9+.\-]{1,31}):([^<>\x00-\x20]*)$/;
module.exports = function autolink(state, silent) {
    var url, fullUrl, token, ch, start, max, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    start = state.pos;
    max = state.posMax;
    for(;;){
        if (++pos >= max) return false;
        ch = state.src.charCodeAt(pos);
        if (ch === 0x3C /* < */ ) return false;
        if (ch === 0x3E /* > */ ) break;
    }
    url = state.src.slice(start + 1, pos);
    if ($b52244839cfe6245$var$AUTOLINK_RE.test(url)) {
        fullUrl = state.md.normalizeLink(url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            token = state.push('link_open', 'a', 1);
            token.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token.markup = 'autolink';
            token.info = 'auto';
            token = state.push('text', '', 0);
            token.content = state.md.normalizeLinkText(url);
            token = state.push('link_close', 'a', -1);
            token.markup = 'autolink';
            token.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    if ($b52244839cfe6245$var$EMAIL_RE.test(url)) {
        fullUrl = state.md.normalizeLink('mailto:' + url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            token = state.push('link_open', 'a', 1);
            token.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token.markup = 'autolink';
            token.info = 'auto';
            token = state.push('text', '', 0);
            token.content = state.md.normalizeLinkText(url);
            token = state.push('link_close', 'a', -1);
            token.markup = 'autolink';
            token.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    return false;
};

});

parcelRegister("9M7vq", function(module, exports) {
// Process html tags
'use strict';

var $0dDBY = parcelRequire("0dDBY");
var $71de6b3e3fe98feb$require$HTML_TAG_RE = $0dDBY.HTML_TAG_RE;
function $71de6b3e3fe98feb$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $71de6b3e3fe98feb$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $71de6b3e3fe98feb$var$isLetter(ch) {
    /*eslint no-bitwise:0*/ var lc = ch | 0x20; // to lower case
    return lc >= 0x61 /* a */  && lc <= 0x7a /* z */ ;
}
module.exports = function html_inline(state, silent) {
    var ch, match, max, token, pos = state.pos;
    if (!state.md.options.html) return false;
    // Check start
    max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */  || pos + 2 >= max) return false;
    // Quick fail on second char
    ch = state.src.charCodeAt(pos + 1);
    if (ch !== 0x21 /* ! */  && ch !== 0x3F /* ? */  && ch !== 0x2F /* / */  && !$71de6b3e3fe98feb$var$isLetter(ch)) return false;
    match = state.src.slice(pos).match($71de6b3e3fe98feb$require$HTML_TAG_RE);
    if (!match) return false;
    if (!silent) {
        token = state.push('html_inline', '', 0);
        token.content = match[0];
        if ($71de6b3e3fe98feb$var$isLinkOpen(token.content)) state.linkLevel++;
        if ($71de6b3e3fe98feb$var$isLinkClose(token.content)) state.linkLevel--;
    }
    state.pos += match[0].length;
    return true;
};

});

parcelRegister("i1a7Z", function(module, exports) {
// Process html entity - &#123;, &#xAF;, &quot;, ...
'use strict';

var $3q5w3 = parcelRequire("3q5w3");

var $l6IUK = parcelRequire("l6IUK");
var $d1e02d2d980e258d$require$has = $l6IUK.has;

var $l6IUK = parcelRequire("l6IUK");
var $d1e02d2d980e258d$require$isValidEntityCode = $l6IUK.isValidEntityCode;

var $l6IUK = parcelRequire("l6IUK");
var $d1e02d2d980e258d$require$fromCodePoint = $l6IUK.fromCodePoint;
var $d1e02d2d980e258d$var$DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i;
var $d1e02d2d980e258d$var$NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
module.exports = function entity(state, silent) {
    var ch, code, match, token, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x26 /* & */ ) return false;
    if (pos + 1 >= max) return false;
    ch = state.src.charCodeAt(pos + 1);
    if (ch === 0x23 /* # */ ) {
        match = state.src.slice(pos).match($d1e02d2d980e258d$var$DIGITAL_RE);
        if (match) {
            if (!silent) {
                code = match[1][0].toLowerCase() === 'x' ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
                token = state.push('text_special', '', 0);
                token.content = $d1e02d2d980e258d$require$isValidEntityCode(code) ? $d1e02d2d980e258d$require$fromCodePoint(code) : $d1e02d2d980e258d$require$fromCodePoint(0xFFFD);
                token.markup = match[0];
                token.info = 'entity';
            }
            state.pos += match[0].length;
            return true;
        }
    } else {
        match = state.src.slice(pos).match($d1e02d2d980e258d$var$NAMED_RE);
        if (match) {
            if ($d1e02d2d980e258d$require$has($3q5w3, match[1])) {
                if (!silent) {
                    token = state.push('text_special', '', 0);
                    token.content = $3q5w3[match[1]];
                    token.markup = match[0];
                    token.info = 'entity';
                }
                state.pos += match[0].length;
                return true;
            }
        }
    }
    return false;
};

});

parcelRegister("6FHxS", function(module, exports) {
// For each opening emphasis-like marker find a matching closing one
//
'use strict';
function $4db85999f2263c0e$var$processDelimiters(delimiters) {
    var closerIdx, openerIdx, closer, opener, minOpenerIdx, newMinOpenerIdx, isOddMatch, lastJump, openersBottom = {}, max = delimiters.length;
    if (!max) return;
    // headerIdx is the first delimiter of the current (where closer is) delimiter run
    var headerIdx = 0;
    var lastTokenIdx = -2; // needs any value lower than -1
    var jumps = [];
    for(closerIdx = 0; closerIdx < max; closerIdx++){
        closer = delimiters[closerIdx];
        jumps.push(0);
        // markers belong to same delimiter run if:
        //  - they have adjacent tokens
        //  - AND markers are the same
        //
        if (delimiters[headerIdx].marker !== closer.marker || lastTokenIdx !== closer.token - 1) headerIdx = closerIdx;
        lastTokenIdx = closer.token;
        // Length is only used for emphasis-specific "rule of 3",
        // if it's not defined (in strikethrough or 3rd party plugins),
        // we can default it to 0 to disable those checks.
        //
        closer.length = closer.length || 0;
        if (!closer.close) continue;
        // Previously calculated lower bounds (previous fails)
        // for each marker, each delimiter length modulo 3,
        // and for whether this closer can be an opener;
        // https://github.com/commonmark/cmark/commit/34250e12ccebdc6372b8b49c44fab57c72443460
        if (!openersBottom.hasOwnProperty(closer.marker)) openersBottom[closer.marker] = [
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ];
        minOpenerIdx = openersBottom[closer.marker][(closer.open ? 3 : 0) + closer.length % 3];
        openerIdx = headerIdx - jumps[headerIdx] - 1;
        newMinOpenerIdx = openerIdx;
        for(; openerIdx > minOpenerIdx; openerIdx -= jumps[openerIdx] + 1){
            opener = delimiters[openerIdx];
            if (opener.marker !== closer.marker) continue;
            if (opener.open && opener.end < 0) {
                isOddMatch = false;
                // from spec:
                //
                // If one of the delimiters can both open and close emphasis, then the
                // sum of the lengths of the delimiter runs containing the opening and
                // closing delimiters must not be a multiple of 3 unless both lengths
                // are multiples of 3.
                //
                if (opener.close || closer.open) {
                    if ((opener.length + closer.length) % 3 === 0) {
                        if (opener.length % 3 !== 0 || closer.length % 3 !== 0) isOddMatch = true;
                    }
                }
                if (!isOddMatch) {
                    // If previous delimiter cannot be an opener, we can safely skip
                    // the entire sequence in future checks. This is required to make
                    // sure algorithm has linear complexity (see *_*_*_*_*_... case).
                    //
                    lastJump = openerIdx > 0 && !delimiters[openerIdx - 1].open ? jumps[openerIdx - 1] + 1 : 0;
                    jumps[closerIdx] = closerIdx - openerIdx + lastJump;
                    jumps[openerIdx] = lastJump;
                    closer.open = false;
                    opener.end = closerIdx;
                    opener.close = false;
                    newMinOpenerIdx = -1;
                    // treat next token as start of run,
                    // it optimizes skips in **<...>**a**<...>** pathological case
                    lastTokenIdx = -2;
                    break;
                }
            }
        }
        if (newMinOpenerIdx !== -1) // If match for this delimiter run failed, we want to set lower bound for
        // future lookups. This is required to make sure algorithm has linear
        // complexity.
        //
        // See details here:
        // https://github.com/commonmark/cmark/issues/178#issuecomment-270417442
        //
        openersBottom[closer.marker][(closer.open ? 3 : 0) + (closer.length || 0) % 3] = newMinOpenerIdx;
    }
}
module.exports = function link_pairs(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $4db85999f2263c0e$var$processDelimiters(state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $4db85999f2263c0e$var$processDelimiters(tokens_meta[curr].delimiters);
};

});

parcelRegister("9Rdip", function(module, exports) {
// Clean up tokens after emphasis and strikethrough postprocessing:
// merge adjacent text nodes into one and re-calculate all token levels
//
// This is necessary because initially emphasis delimiter markers (*, _, ~)
// are treated as their own separate text tokens. Then emphasis rule either
// leaves them as text (needed to merge with adjacent text) or turns them
// into opening/closing tags (which messes up levels inside).
//
'use strict';
module.exports = function fragments_join(state) {
    var curr, last, level = 0, tokens = state.tokens, max = state.tokens.length;
    for(curr = last = 0; curr < max; curr++){
        // re-calculate levels after emphasis/strikethrough turns some text nodes
        // into opening/closing tags
        if (tokens[curr].nesting < 0) level--; // closing tag
        tokens[curr].level = level;
        if (tokens[curr].nesting > 0) level++; // opening tag
        if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
    }
    if (curr !== last) tokens.length = last;
};

});

parcelRegister("88Wcs", function(module, exports) {
// Inline parser state
'use strict';

var $8AILn = parcelRequire("8AILn");

var $l6IUK = parcelRequire("l6IUK");
var $5edc3765df6c6534$require$isWhiteSpace = $l6IUK.isWhiteSpace;

var $l6IUK = parcelRequire("l6IUK");
var $5edc3765df6c6534$require$isPunctChar = $l6IUK.isPunctChar;

var $l6IUK = parcelRequire("l6IUK");
var $5edc3765df6c6534$require$isMdAsciiPunct = $l6IUK.isMdAsciiPunct;
function $5edc3765df6c6534$var$StateInline(src, md, env, outTokens) {
    this.src = src;
    this.env = env;
    this.md = md;
    this.tokens = outTokens;
    this.tokens_meta = Array(outTokens.length);
    this.pos = 0;
    this.posMax = this.src.length;
    this.level = 0;
    this.pending = '';
    this.pendingLevel = 0;
    // Stores { start: end } pairs. Useful for backtrack
    // optimization of pairs parse (emphasis, strikes).
    this.cache = {};
    // List of emphasis-like delimiters for current tag
    this.delimiters = [];
    // Stack of delimiter lists for upper level tags
    this._prev_delimiters = [];
    // backtick length => last seen position
    this.backticks = {};
    this.backticksScanned = false;
    // Counter used to disable inline linkify-it execution
    // inside <a> and markdown links
    this.linkLevel = 0;
}
// Flush pending text
//
$5edc3765df6c6534$var$StateInline.prototype.pushPending = function() {
    var token = new $8AILn('text', '', 0);
    token.content = this.pending;
    token.level = this.pendingLevel;
    this.tokens.push(token);
    this.pending = '';
    return token;
};
// Push new token to "stream".
// If pending text exists - flush it as text token
//
$5edc3765df6c6534$var$StateInline.prototype.push = function(type, tag, nesting) {
    if (this.pending) this.pushPending();
    var token = new $8AILn(type, tag, nesting);
    var token_meta = null;
    if (nesting < 0) {
        // closing tag
        this.level--;
        this.delimiters = this._prev_delimiters.pop();
    }
    token.level = this.level;
    if (nesting > 0) {
        // opening tag
        this.level++;
        this._prev_delimiters.push(this.delimiters);
        this.delimiters = [];
        token_meta = {
            delimiters: this.delimiters
        };
    }
    this.pendingLevel = this.level;
    this.tokens.push(token);
    this.tokens_meta.push(token_meta);
    return token;
};
// Scan a sequence of emphasis-like markers, and determine whether
// it can start an emphasis sequence or end an emphasis sequence.
//
//  - start - position to scan from (it should point at a valid marker);
//  - canSplitWord - determine if these markers can be found inside a word
//
$5edc3765df6c6534$var$StateInline.prototype.scanDelims = function(start, canSplitWord) {
    var pos = start, lastChar, nextChar, count, can_open, can_close, isLastWhiteSpace, isLastPunctChar, isNextWhiteSpace, isNextPunctChar, left_flanking = true, right_flanking = true, max = this.posMax, marker = this.src.charCodeAt(start);
    // treat beginning of the line as a whitespace
    lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;
    while(pos < max && this.src.charCodeAt(pos) === marker)pos++;
    count = pos - start;
    // treat end of the line as a whitespace
    nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;
    isLastPunctChar = $5edc3765df6c6534$require$isMdAsciiPunct(lastChar) || $5edc3765df6c6534$require$isPunctChar(String.fromCharCode(lastChar));
    isNextPunctChar = $5edc3765df6c6534$require$isMdAsciiPunct(nextChar) || $5edc3765df6c6534$require$isPunctChar(String.fromCharCode(nextChar));
    isLastWhiteSpace = $5edc3765df6c6534$require$isWhiteSpace(lastChar);
    isNextWhiteSpace = $5edc3765df6c6534$require$isWhiteSpace(nextChar);
    if (isNextWhiteSpace) left_flanking = false;
    else if (isNextPunctChar) {
        if (!(isLastWhiteSpace || isLastPunctChar)) left_flanking = false;
    }
    if (isLastWhiteSpace) right_flanking = false;
    else if (isLastPunctChar) {
        if (!(isNextWhiteSpace || isNextPunctChar)) right_flanking = false;
    }
    if (!canSplitWord) {
        can_open = left_flanking && (!right_flanking || isLastPunctChar);
        can_close = right_flanking && (!left_flanking || isNextPunctChar);
    } else {
        can_open = left_flanking;
        can_close = right_flanking;
    }
    return {
        can_open: can_open,
        can_close: can_close,
        length: count
    };
};
// re-export Token class to use in block rules
$5edc3765df6c6534$var$StateInline.prototype.Token = $8AILn;
module.exports = $5edc3765df6c6534$var$StateInline;

});


parcelRegister("98vHM", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $6a6d745e641e5984$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $6a6d745e641e5984$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $6a6d745e641e5984$var$isString(obj) {
    return $6a6d745e641e5984$var$_class(obj) === '[object String]';
}
function $6a6d745e641e5984$var$isObject(obj) {
    return $6a6d745e641e5984$var$_class(obj) === '[object Object]';
}
function $6a6d745e641e5984$var$isRegExp(obj) {
    return $6a6d745e641e5984$var$_class(obj) === '[object RegExp]';
}
function $6a6d745e641e5984$var$isFunction(obj) {
    return $6a6d745e641e5984$var$_class(obj) === '[object Function]';
}
function $6a6d745e641e5984$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $6a6d745e641e5984$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $6a6d745e641e5984$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $6a6d745e641e5984$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $6a6d745e641e5984$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $6a6d745e641e5984$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $6a6d745e641e5984$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $6a6d745e641e5984$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $6a6d745e641e5984$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $6a6d745e641e5984$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $6a6d745e641e5984$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("fmrcY"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($6a6d745e641e5984$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($6a6d745e641e5984$var$isObject(val)) {
            if ($6a6d745e641e5984$var$isRegExp(val.validate)) compiled.validate = $6a6d745e641e5984$var$createValidator(val.validate);
            else if ($6a6d745e641e5984$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($6a6d745e641e5984$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $6a6d745e641e5984$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($6a6d745e641e5984$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $6a6d745e641e5984$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($6a6d745e641e5984$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.schema_at_start = RegExp('^' + self.re.schema_search.source, 'i');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $6a6d745e641e5984$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $6a6d745e641e5984$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $6a6d745e641e5984$var$createMatch(self, shift) {
    var match = new $6a6d745e641e5984$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $6a6d745e641e5984$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $6a6d745e641e5984$var$LinkifyIt)) return new $6a6d745e641e5984$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($6a6d745e641e5984$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $6a6d745e641e5984$var$assign({}, $6a6d745e641e5984$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $6a6d745e641e5984$var$assign({}, $6a6d745e641e5984$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $6a6d745e641e5984$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $6a6d745e641e5984$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $6a6d745e641e5984$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $6a6d745e641e5984$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $6a6d745e641e5984$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $6a6d745e641e5984$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $6a6d745e641e5984$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $6a6d745e641e5984$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $6a6d745e641e5984$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $6a6d745e641e5984$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($6a6d745e641e5984$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($6a6d745e641e5984$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/**
 * LinkifyIt#matchAtStart(text) -> Match|null
 *
 * Returns fully-formed (not fuzzy) link if it starts at the beginning
 * of the string, and null otherwise.
 **/ $6a6d745e641e5984$var$LinkifyIt.prototype.matchAtStart = function matchAtStart(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return null;
    var m = this.re.schema_at_start.exec(text);
    if (!m) return null;
    var len = this.testSchemaAt(text, m[2], m[0].length);
    if (!len) return null;
    this.__schema__ = m[2];
    this.__index__ = m.index + m[1].length;
    this.__last_index__ = m.index + m[0].length + len;
    return $6a6d745e641e5984$var$createMatch(this, 0);
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $6a6d745e641e5984$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $6a6d745e641e5984$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $6a6d745e641e5984$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $6a6d745e641e5984$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $6a6d745e641e5984$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $6a6d745e641e5984$var$LinkifyIt;

});
parcelRegister("fmrcY", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    opts = opts || {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("hZcCd")).source;
    re.src_Cc = (parcelRequire("iNnZB")).source;
    re.src_Z = (parcelRequire("23KJ1")).source;
    re.src_P = (parcelRequire("dDBFM")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')' + '(?!' + (opts['---'] ? '-(?!--)|' : '-|') + '_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-])|' + // allow `I'm_king` if no pair found
    '\\.{2,}[a-zA-Z0-9%/&]|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]|$)|' + (opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + ',(?!' + re.src_ZCc + '|$)|' + // allow `,,,` in paths
    ';(?!' + re.src_ZCc + '|$)|' + // allow `;` if not followed by space-like char
    '\\!+(?!' + re.src_ZCc + '|[!]|$)|' + // allow `!!!` in paths, but not at the end
    '\\?(?!' + re.src_ZCc + '|[?]|$)' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});


parcelRegister("4Iqgk", function(module, exports) {
'use strict';
/** Highest positive signed 32-bit float value */ const $36efa4a9e6f7bc26$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
/** Bootstring parameters */ const $36efa4a9e6f7bc26$var$base = 36;
const $36efa4a9e6f7bc26$var$tMin = 1;
const $36efa4a9e6f7bc26$var$tMax = 26;
const $36efa4a9e6f7bc26$var$skew = 38;
const $36efa4a9e6f7bc26$var$damp = 700;
const $36efa4a9e6f7bc26$var$initialBias = 72;
const $36efa4a9e6f7bc26$var$initialN = 128; // 0x80
const $36efa4a9e6f7bc26$var$delimiter = '-'; // '\x2D'
/** Regular expressions */ const $36efa4a9e6f7bc26$var$regexPunycode = /^xn--/;
const $36efa4a9e6f7bc26$var$regexNonASCII = /[^\0-\x7F]/; // Note: U+007F DEL is excluded too.
const $36efa4a9e6f7bc26$var$regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
/** Error messages */ const $36efa4a9e6f7bc26$var$errors = {
    'overflow': 'Overflow: input needs wider integers to process',
    'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
    'invalid-input': 'Invalid input'
};
/** Convenience shortcuts */ const $36efa4a9e6f7bc26$var$baseMinusTMin = $36efa4a9e6f7bc26$var$base - $36efa4a9e6f7bc26$var$tMin;
const $36efa4a9e6f7bc26$var$floor = Math.floor;
const $36efa4a9e6f7bc26$var$stringFromCharCode = String.fromCharCode;
/*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function $36efa4a9e6f7bc26$var$error(type) {
    throw new RangeError($36efa4a9e6f7bc26$var$errors[type]);
}
/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function $36efa4a9e6f7bc26$var$map(array, callback) {
    const result = [];
    let length = array.length;
    while(length--)result[length] = callback(array[length]);
    return result;
}
/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {String} A new string of characters returned by the callback
 * function.
 */ function $36efa4a9e6f7bc26$var$mapDomain(domain, callback) {
    const parts = domain.split('@');
    let result = '';
    if (parts.length > 1) {
        // In email addresses, only the domain name should be punycoded. Leave
        // the local part (i.e. everything up to `@`) intact.
        result = parts[0] + '@';
        domain = parts[1];
    }
    // Avoid `split(regex)` for IE8 compatibility. See #17.
    domain = domain.replace($36efa4a9e6f7bc26$var$regexSeparators, '\x2E');
    const labels = domain.split('.');
    const encoded = $36efa4a9e6f7bc26$var$map(labels, callback).join('.');
    return result + encoded;
}
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function $36efa4a9e6f7bc26$var$ucs2decode(string) {
    const output = [];
    let counter = 0;
    const length = string.length;
    while(counter < length){
        const value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            const extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ const $36efa4a9e6f7bc26$var$ucs2encode = (codePoints)=>String.fromCodePoint(...codePoints);
/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ const $36efa4a9e6f7bc26$var$basicToDigit = function(codePoint) {
    if (codePoint >= 0x30 && codePoint < 0x3A) return 26 + (codePoint - 0x30);
    if (codePoint >= 0x41 && codePoint < 0x5B) return codePoint - 0x41;
    if (codePoint >= 0x61 && codePoint < 0x7B) return codePoint - 0x61;
    return $36efa4a9e6f7bc26$var$base;
};
/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ const $36efa4a9e6f7bc26$var$digitToBasic = function(digit, flag) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ const $36efa4a9e6f7bc26$var$adapt = function(delta, numPoints, firstTime) {
    let k = 0;
    delta = firstTime ? $36efa4a9e6f7bc26$var$floor(delta / $36efa4a9e6f7bc26$var$damp) : delta >> 1;
    delta += $36efa4a9e6f7bc26$var$floor(delta / numPoints);
    for(; delta > $36efa4a9e6f7bc26$var$baseMinusTMin * $36efa4a9e6f7bc26$var$tMax >> 1; k += $36efa4a9e6f7bc26$var$base)delta = $36efa4a9e6f7bc26$var$floor(delta / $36efa4a9e6f7bc26$var$baseMinusTMin);
    return $36efa4a9e6f7bc26$var$floor(k + ($36efa4a9e6f7bc26$var$baseMinusTMin + 1) * delta / (delta + $36efa4a9e6f7bc26$var$skew));
};
/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ const $36efa4a9e6f7bc26$var$decode = function(input) {
    // Don't use UCS-2.
    const output = [];
    const inputLength = input.length;
    let i = 0;
    let n = $36efa4a9e6f7bc26$var$initialN;
    let bias = $36efa4a9e6f7bc26$var$initialBias;
    // Handle the basic code points: let `basic` be the number of input code
    // points before the last delimiter, or `0` if there is none, then copy
    // the first basic code points to the output.
    let basic = input.lastIndexOf($36efa4a9e6f7bc26$var$delimiter);
    if (basic < 0) basic = 0;
    for(let j = 0; j < basic; ++j){
        // if it's not a basic code point
        if (input.charCodeAt(j) >= 0x80) $36efa4a9e6f7bc26$var$error('not-basic');
        output.push(input.charCodeAt(j));
    }
    // Main decoding loop: start just after the last delimiter if any basic code
    // points were copied; start at the beginning otherwise.
    for(let index = basic > 0 ? basic + 1 : 0; index < inputLength;){
        // `index` is the index of the next character to be consumed.
        // Decode a generalized variable-length integer into `delta`,
        // which gets added to `i`. The overflow checking is easier
        // if we increase `i` as we go, then subtract off its starting
        // value at the end to obtain `delta`.
        const oldi = i;
        for(let w = 1, k = $36efa4a9e6f7bc26$var$base;; k += $36efa4a9e6f7bc26$var$base){
            if (index >= inputLength) $36efa4a9e6f7bc26$var$error('invalid-input');
            const digit = $36efa4a9e6f7bc26$var$basicToDigit(input.charCodeAt(index++));
            if (digit >= $36efa4a9e6f7bc26$var$base) $36efa4a9e6f7bc26$var$error('invalid-input');
            if (digit > $36efa4a9e6f7bc26$var$floor(($36efa4a9e6f7bc26$var$maxInt - i) / w)) $36efa4a9e6f7bc26$var$error('overflow');
            i += digit * w;
            const t = k <= bias ? $36efa4a9e6f7bc26$var$tMin : k >= bias + $36efa4a9e6f7bc26$var$tMax ? $36efa4a9e6f7bc26$var$tMax : k - bias;
            if (digit < t) break;
            const baseMinusT = $36efa4a9e6f7bc26$var$base - t;
            if (w > $36efa4a9e6f7bc26$var$floor($36efa4a9e6f7bc26$var$maxInt / baseMinusT)) $36efa4a9e6f7bc26$var$error('overflow');
            w *= baseMinusT;
        }
        const out = output.length + 1;
        bias = $36efa4a9e6f7bc26$var$adapt(i - oldi, out, oldi == 0);
        // `i` was supposed to wrap around from `out` to `0`,
        // incrementing `n` each time, so we'll fix that now:
        if ($36efa4a9e6f7bc26$var$floor(i / out) > $36efa4a9e6f7bc26$var$maxInt - n) $36efa4a9e6f7bc26$var$error('overflow');
        n += $36efa4a9e6f7bc26$var$floor(i / out);
        i %= out;
        // Insert `n` at position `i` of the output.
        output.splice(i++, 0, n);
    }
    return String.fromCodePoint(...output);
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ const $36efa4a9e6f7bc26$var$encode = function(input) {
    const output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = $36efa4a9e6f7bc26$var$ucs2decode(input);
    // Cache the length.
    const inputLength = input.length;
    // Initialize the state.
    let n = $36efa4a9e6f7bc26$var$initialN;
    let delta = 0;
    let bias = $36efa4a9e6f7bc26$var$initialBias;
    // Handle the basic code points.
    for (const currentValue of input)if (currentValue < 0x80) output.push($36efa4a9e6f7bc26$var$stringFromCharCode(currentValue));
    const basicLength = output.length;
    let handledCPCount = basicLength;
    // `handledCPCount` is the number of code points that have been handled;
    // `basicLength` is the number of basic code points.
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) output.push($36efa4a9e6f7bc26$var$delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next
        // larger one:
        let m = $36efa4a9e6f7bc26$var$maxInt;
        for (const currentValue of input)if (currentValue >= n && currentValue < m) m = currentValue;
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
        // but guard against overflow.
        const handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > $36efa4a9e6f7bc26$var$floor(($36efa4a9e6f7bc26$var$maxInt - delta) / handledCPCountPlusOne)) $36efa4a9e6f7bc26$var$error('overflow');
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for (const currentValue of input){
            if (currentValue < n && ++delta > $36efa4a9e6f7bc26$var$maxInt) $36efa4a9e6f7bc26$var$error('overflow');
            if (currentValue === n) {
                // Represent delta as a generalized variable-length integer.
                let q = delta;
                for(let k = $36efa4a9e6f7bc26$var$base;; k += $36efa4a9e6f7bc26$var$base){
                    const t = k <= bias ? $36efa4a9e6f7bc26$var$tMin : k >= bias + $36efa4a9e6f7bc26$var$tMax ? $36efa4a9e6f7bc26$var$tMax : k - bias;
                    if (q < t) break;
                    const qMinusT = q - t;
                    const baseMinusT = $36efa4a9e6f7bc26$var$base - t;
                    output.push($36efa4a9e6f7bc26$var$stringFromCharCode($36efa4a9e6f7bc26$var$digitToBasic(t + qMinusT % baseMinusT, 0)));
                    q = $36efa4a9e6f7bc26$var$floor(qMinusT / baseMinusT);
                }
                output.push($36efa4a9e6f7bc26$var$stringFromCharCode($36efa4a9e6f7bc26$var$digitToBasic(q, 0)));
                bias = $36efa4a9e6f7bc26$var$adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
                delta = 0;
                ++handledCPCount;
            }
        }
        ++delta;
        ++n;
    }
    return output.join('');
};
/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ const $36efa4a9e6f7bc26$var$toUnicode = function(input) {
    return $36efa4a9e6f7bc26$var$mapDomain(input, function(string) {
        return $36efa4a9e6f7bc26$var$regexPunycode.test(string) ? $36efa4a9e6f7bc26$var$decode(string.slice(4).toLowerCase()) : string;
    });
};
/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ const $36efa4a9e6f7bc26$var$toASCII = function(input) {
    return $36efa4a9e6f7bc26$var$mapDomain(input, function(string) {
        return $36efa4a9e6f7bc26$var$regexNonASCII.test(string) ? 'xn--' + $36efa4a9e6f7bc26$var$encode(string) : string;
    });
};
/*--------------------------------------------------------------------------*/ /** Define the public API */ const $36efa4a9e6f7bc26$var$punycode = {
    /**
	 * A string representing the current Punycode.js version number.
	 * @memberOf punycode
	 * @type String
	 */ 'version': '2.3.1',
    /**
	 * An object of methods to convert from JavaScript's internal character
	 * representation (UCS-2) to Unicode code points, and back.
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode
	 * @type Object
	 */ 'ucs2': {
        'decode': $36efa4a9e6f7bc26$var$ucs2decode,
        'encode': $36efa4a9e6f7bc26$var$ucs2encode
    },
    'decode': $36efa4a9e6f7bc26$var$decode,
    'encode': $36efa4a9e6f7bc26$var$encode,
    'toASCII': $36efa4a9e6f7bc26$var$toASCII,
    'toUnicode': $36efa4a9e6f7bc26$var$toUnicode
};
module.exports = $36efa4a9e6f7bc26$var$punycode;

});

parcelRegister("jbZa8", function(module, exports) {
// markdown-it default options
'use strict';
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 100 // Internal protection, recursion limit
    },
    components: {
        core: {},
        block: {},
        inline: {}
    }
};

});

parcelRegister("4Ggn6", function(module, exports) {
// "Zero" preset, with nothing enabled. Useful for manual configuring of simple
// modes. For example, to parse bold/italic only.
'use strict';
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'text'
            ],
            rules2: [
                'balance_pairs',
                'fragments_join'
            ]
        }
    }
};

});

parcelRegister("5Yj6L", function(module, exports) {
// Commonmark default options
'use strict';
module.exports = {
    options: {
        html: true,
        xhtmlOut: true,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'blockquote',
                'code',
                'fence',
                'heading',
                'hr',
                'html_block',
                'lheading',
                'list',
                'reference',
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'autolink',
                'backticks',
                'emphasis',
                'entity',
                'escape',
                'html_inline',
                'image',
                'link',
                'newline',
                'text'
            ],
            rules2: [
                'balance_pairs',
                'emphasis',
                'fragments_join'
            ]
        }
    }
};

});



parcelRegister("ixJuK", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ee9ca0aeb7749da$export$2e2bcd8739ae039);
/*
 * ED-15646
 * Headings in list items are not supported in our schema.
 * As the markdown transformer is used by the paste plugin,
 * certain pastes will strip invalid lines as
 * prosemirror-markdown cannot conform to the schema
 */ function $1ee9ca0aeb7749da$var$handleHeadingOpen(state, token, acc, index) {
    const isInListItem = state.tokens[index - 1]?.type === 'list_item_open';
    if (isInListItem) acc.push(new state.Token('paragraph_open', 'p', 1));
    else acc.push(token);
}
function $1ee9ca0aeb7749da$var$handleHeadingClose(state, token, acc, index) {
    const isInListItem = state.tokens[index + 1]?.type === 'list_item_close';
    if (isInListItem) acc.push(new state.Token('paragraph_close', 'p', -1));
    else acc.push(token);
}
function $1ee9ca0aeb7749da$export$2e2bcd8739ae039(md) {
    md.core.ruler.after('inline', 'ignore-list-heading-md-plugin', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            if (type === 'heading_open') $1ee9ca0aeb7749da$var$handleHeadingOpen(state, token, acc, index);
            else if (type === 'heading_close') $1ee9ca0aeb7749da$var$handleHeadingClose(state, token, acc, index);
            else acc.push(token);
            return acc;
        }, []);
    });
}

});

parcelRegister("hvgYN", function(module, exports) {
$parcel$export(module.exports, "default", () => $ecd6c54f35ffc584$export$2e2bcd8739ae039);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/md/linkify-md-plugin.ts
// If changes are made to this file, please make the same update in the linked file.
// See https://product-fabric.atlassian.net/browse/ED-3097 for why this file exists.

var $ap5nJ = parcelRequire("ap5nJ");

var $iKozC = parcelRequire("iKozC");

var $grDTV = parcelRequire("grDTV");
var $8YVeS = parcelRequire("8YVeS");
// modified version of the original markdown-it Linkify plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ecd6c54f35ffc584$var$arrayReplaceAt = (src, pos, newElements)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
};
const $ecd6c54f35ffc584$var$isLinkOpen = (str)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /^<a[>\s]/i.test(str);
};
const $ecd6c54f35ffc584$var$isLinkClose = (str)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /^<\/a\s*>/i.test(str);
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ecd6c54f35ffc584$var$linkify = (state)=>{
    const blockTokens = state.tokens;
    const linkify = new (0, (/*@__PURE__*/$parcel$interopDefault($ap5nJ)))();
    for(let j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !linkify.pretest(blockTokens[j].content)) continue;
        let tokens = blockTokens[j].children;
        let htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(let i = tokens.length - 1; i >= 0; i--){
            const currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($ecd6c54f35ffc584$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($ecd6c54f35ffc584$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && linkify.test(currentToken.content)) {
                const text = currentToken.content;
                let links = (0, $iKozC.linkifyMatch)(text);
                if (!links.length) links = linkify.match(text) || [];
                links = links.filter((link)=>(0, $8YVeS.shouldAutoLinkifyMatch)(link));
                // Now split string to nodes
                const nodes = [];
                let level = currentToken.level;
                let lastPos = 0;
                const filepaths = (0, $grDTV.findFilepaths)(text);
                for(let ln = 0; ln < links.length; ln++){
                    if ((0, $grDTV.isLinkInMatches)(links[ln].index, filepaths)) continue;
                    const { url: url } = links[ln];
                    const fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    let urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                    else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    const pos = links[ln].index;
                    if (pos > lastPos) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    let token = new state.Token('link_open', 'a', 1);
                    token.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token.level = level++;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    token = new state.Token('text', '', 0);
                    token.content = urlText;
                    token.level = level;
                    nodes.push(token);
                    token = new state.Token('link_close', 'a', -1);
                    token.level = --level;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    const token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = $ecd6c54f35ffc584$var$arrayReplaceAt(tokens, i, nodes);
            }
        }
    }
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$ecd6c54f35ffc584$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('custom-linkify', $ecd6c54f35ffc584$var$linkify);

});

parcelRegister("5vTT1", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c46f60ab21316a6$export$2e2bcd8739ae039);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/md/newline-md-plugin.ts
// If changes are made to this file, please make the same update in the linked file.
// ED-15363: modified version of the original newline plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_inline/newline.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5c46f60ab21316a6$var$newline = (state, silent)=>{
    let pos = state.pos;
    // ED-15363: unread variables
    // max,
    // ws,
    if (state.src.charCodeAt(pos) !== 0x0a /* \n */ ) return false;
    const pmax = state.pending.length - 1;
    // ED-15363: unread variable
    // max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) // ED-15363: We commented out this logic to preserve trailing whitespaces
            // for each line of text when pasting plain text
            // // Find whitespaces tail of pending chars.
            // ws = pmax - 1;
            // while (ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20) {
            //   ws--;
            // }
            // state.pending = state.pending.slice(0, ws);
            state.push('hardbreak', 'br', 0);
            else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // ED-15363: We commented out this logic from the original library to
    // preserve leading whitespaces for each line of text when pasting plain
    // text (to preserve whitespace-based indentation).
    // // skip heading spaces for next line
    // while (pos < max && isSpace(state.src.charCodeAt(pos))) {
    //   pos++;
    // }
    state.pos = pos;
    return true;
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$5c46f60ab21316a6$export$2e2bcd8739ae039 = (md)=>md.inline.ruler.at('newline', $5c46f60ab21316a6$var$newline);

});

parcelRegister("25i5a", function(module, exports) {
$parcel$export(module.exports, "default", () => $48f47d3b3722c3f1$export$2e2bcd8739ae039);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/md/paragraph-md-plugin.ts
// If changes are made to this file, please make the same update in the linked file.
// ED-15363: modified version of the original paragraph plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_block/paragraph.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $48f47d3b3722c3f1$var$paragraph = (state, startLine /*, endLine*/ )=>{
    let terminate, i, l, token, nextLine = startLine + 1;
    const terminatorRules = state.md.block.ruler.getRules('paragraph');
    const endLine = state.lineMax;
    const oldParentType = state.parentType;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    // ED-15363: We removed .trim() from this logic from the original library to
    // preserve leading whitespaces at the beginning and end of paragraph blocks
    // when pasting plain text (to preserve whitespace-based indentation, at the
    // beginning and end of paragraphs).
    // content = state.getLines(startLine, nextLine, state.blkIndent, false) .trim()
    const content = state.getLines(startLine, nextLine, state.blkIndent, false);
    state.line = nextLine;
    token = state.push('paragraph_open', 'p', 1);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$48f47d3b3722c3f1$export$2e2bcd8739ae039 = (md)=>md.block.ruler.at('paragraph', $48f47d3b3722c3f1$var$paragraph);

});


parcelRegister("iZ2Kf", function(module, exports) {
$parcel$export(module.exports, "transformSingleColumnLayout", () => $6c7dd00049a48457$export$ca45027befc3fad2);
$parcel$export(module.exports, "transformSliceToRemoveOpenLayoutNodes", () => $6c7dd00049a48457$export$82cc8566682e5cf4);

var $3xw6l = parcelRequire("3xw6l");

var $gbisc = parcelRequire("gbisc");
const $6c7dd00049a48457$var$isLayoutNode = (node)=>node.type === node.type.schema.nodes.layoutSection || node.type === node.type.schema.nodes.layoutColumn;
function $6c7dd00049a48457$export$5fc4db161d3fef1f(maybeLayoutSection) {
    const fragment = (0, $gbisc.mapFragment)((0, $3xw6l.Fragment).from(maybeLayoutSection), (node)=>{
        return $6c7dd00049a48457$var$isLayoutNode(node) ? node.content : node;
    });
    const nodes = [];
    fragment.forEach((i)=>nodes.push(i));
    return nodes;
}
function $6c7dd00049a48457$export$238984649a055433(node, i) {
    return i === 0 ? $6c7dd00049a48457$export$5fc4db161d3fef1f(node) : node;
}
function $6c7dd00049a48457$export$38d10d1907db60ca(node, i, fragment) {
    return i === fragment.childCount - 1 ? $6c7dd00049a48457$export$5fc4db161d3fef1f(node) : node;
}
const $6c7dd00049a48457$export$ca45027befc3fad2 = (slice, schema)=>{
    if (slice.content.childCount === 1 && slice.openStart === 0 && slice.openEnd === 0) {
        if (slice.content.firstChild?.type === schema.nodes.layoutColumn) {
            const newSlice = new (0, $3xw6l.Slice)(slice.content.firstChild.content, 0, 0);
            return newSlice;
        } else if (slice.content.firstChild?.type === schema.nodes.layoutSection && slice.content.firstChild.childCount === 1 && slice.content.firstChild.firstChild?.type === schema.nodes.layoutColumn) {
            const newSlice = new (0, $3xw6l.Slice)(slice.content.firstChild.firstChild.content, 0, 0);
            return newSlice;
        }
    }
    return slice;
};
function $6c7dd00049a48457$export$82cc8566682e5cf4(slice, schema) {
    // Case 1: A slice entirely within a single layoutSection
    if (slice.openStart && slice.openEnd && slice.content.childCount === 1) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const maybeLayoutSection = slice.content.firstChild;
        if (maybeLayoutSection.type === schema.nodes.layoutSection) return new (0, $3xw6l.Slice)((0, $gbisc.flatmap)(slice.content, $6c7dd00049a48457$export$238984649a055433), // '-2' here because we've removed the layoutSection/layoutColumn; reducing the open depth.
        slice.openStart - 2, slice.openEnd - 2);
    }
    // Case 2: A slice starting inside a layoutSection and finishing outside
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if (slice.openStart && slice.content.firstChild.type === schema.nodes.layoutSection) slice = new (0, $3xw6l.Slice)((0, $gbisc.flatmap)(slice.content, $6c7dd00049a48457$export$238984649a055433), slice.openStart - 2, slice.openEnd);
    // Case 3: A slice starting outside a layoutSection and finishing inside
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if (slice.openEnd && slice.content.lastChild.type === schema.nodes.layoutSection) slice = new (0, $3xw6l.Slice)((0, $gbisc.flatmap)(slice.content, $6c7dd00049a48457$export$38d10d1907db60ca), slice.openStart, slice.openEnd - 2);
    // Case 2 & 3 also handles a slice starting in one layoutSection & finishing in a different layoutSection
    return slice;
}

});

parcelRegister("1Snbj", function(module, exports) {
$parcel$export(module.exports, "findExpand", () => $a1268ea093b48e7a$export$fd7bf9c73fdd6f30);
$parcel$export(module.exports, "transformSliceToRemoveOpenExpand", () => $a1268ea093b48e7a$export$6d57e15bdf5e650f);
$parcel$export(module.exports, "transformSliceToRemoveOpenNestedExpand", () => $a1268ea093b48e7a$export$74dbe7cb6b933cde);
$parcel$export(module.exports, "transformSliceNestedExpandToExpand", () => $a1268ea093b48e7a$export$fd33fafbf6b5abc7);
$parcel$export(module.exports, "transformSliceExpandToNestedExpand", () => $a1268ea093b48e7a$export$447e90e618548243);

var $3xw6l = parcelRequire("3xw6l");

var $BmspC = parcelRequire("BmspC");

var $gbisc = parcelRequire("gbisc");
const $a1268ea093b48e7a$export$fd7bf9c73fdd6f30 = (state, selection)=>{
    const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
    return (0, $BmspC.findSelectedNodeOfType)([
        expand,
        nestedExpand
    ])(selection || state.selection) || (0, $BmspC.findParentNodeOfType)([
        expand,
        nestedExpand
    ])(selection || state.selection);
};
const $a1268ea093b48e7a$export$6d57e15bdf5e650f = (slice, schema)=>{
    if (slice.openStart > 1 && slice.openEnd > 1 && slice.content.childCount === 1 && slice.content.firstChild && slice.content.firstChild.type === schema.nodes.expand) return new (0, $3xw6l.Slice)(slice.content.firstChild.content, slice.openStart - 1, slice.openEnd - 1);
    return slice;
};
const $a1268ea093b48e7a$export$74dbe7cb6b933cde = (slice, schema)=>{
    if (slice.openStart > 1 && slice.openEnd > 1 && slice.content.childCount === 1 && slice.content.firstChild && slice.content.firstChild.type === schema.nodes.nestedExpand) return new (0, $3xw6l.Slice)(slice.content.firstChild.content, slice.openStart - 1, slice.openEnd - 1);
    return slice;
};
const $a1268ea093b48e7a$export$fd33fafbf6b5abc7 = (slice, schema)=>{
    const { expand: expand, nestedExpand: nestedExpand } = schema.nodes;
    const children = [];
    (0, $gbisc.mapChildren)(slice.content, (node)=>{
        if (node.type === nestedExpand) children.push(expand.createChecked(node.attrs, node.content, node.marks));
        else children.push(node);
    });
    return new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).fromArray(children), slice.openStart, slice.openEnd);
};
const $a1268ea093b48e7a$export$447e90e618548243 = (slice)=>{
    const children = [];
    try {
        (0, $gbisc.mapChildren)(slice.content, (currentNode)=>{
            const { expand: expand, nestedExpand: nestedExpand } = currentNode.type.schema.nodes;
            if (currentNode.type === expand) {
                const nestedExpandNode = nestedExpand.createChecked(currentNode.attrs, currentNode.content, currentNode.marks);
                if (nestedExpandNode) children.push(nestedExpandNode);
            } else children.push(currentNode);
        });
    } catch (e) {
        // Will throw error if unable to convert expand to nested expand.
        // Example: expand containing a table being converted to nested expand containing table.
        return null;
    }
    return new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).fromArray(children), slice.openStart, slice.openEnd);
};

});

parcelRegister("4Gpco", function(module, exports) {
$parcel$export(module.exports, "transformSliceToDecisionList", () => $d84bfd6becaef3e6$export$65d21b4bef5d424b);

var $3xw6l = parcelRequire("3xw6l");
const $d84bfd6becaef3e6$export$65d21b4bef5d424b = (slice, schema)=>{
    const node = slice.content.firstChild;
    if (slice.content.childCount === 1 && node && node.type.name === 'decisionItem') {
        const decisionListWrapperNode = schema.nodes.decisionList.create({}, node);
        return new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(decisionListWrapperNode), slice.openStart, slice.openEnd);
    }
    return slice;
};

});

parcelRegister("j6af7", function(module, exports) {
$parcel$export(module.exports, "transformSliceToRemoveOpenBodiedExtension", () => $d43eea8e1a58258d$export$c50f82e6f2cff97d);
$parcel$export(module.exports, "transformSliceToRemoveOpenMultiBodiedExtension", () => $d43eea8e1a58258d$export$d2a1206296dcfa47);
$parcel$export(module.exports, "transformSliceToRemoveLegacyContentMacro", () => $d43eea8e1a58258d$export$23ce34395aea8526);
$parcel$export(module.exports, "transformSliceToRemoveMacroId", () => $d43eea8e1a58258d$export$c20bd22f1bffad40);

var $2OrIX = parcelRequire("2OrIX");

var $3xw6l = parcelRequire("3xw6l");

var $gbisc = parcelRequire("gbisc");
const $d43eea8e1a58258d$export$c50f82e6f2cff97d = (slice, schema)=>{
    const { bodiedExtension: bodiedExtension } = schema.nodes;
    const fragment = (0, $gbisc.mapFragment)(slice.content, (node, parent, index)=>{
        if (node.type === bodiedExtension && !parent) {
            const currentNodeIsAtStartAndIsOpen = slice.openStart && index === 0;
            const currentNodeIsAtEndAndIsOpen = slice.openEnd && index + 1 === slice.content.childCount;
            if (currentNodeIsAtStartAndIsOpen || currentNodeIsAtEndAndIsOpen) return node.content;
        }
        return node;
    });
    // If the first/last child has changed - then we know we've removed a bodied extension & to decrement the open depth
    return new (0, $3xw6l.Slice)(fragment, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    fragment.firstChild && fragment.firstChild.type !== slice.content.firstChild.type ? slice.openStart - 1 : slice.openStart, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    fragment.lastChild && fragment.lastChild.type !== slice.content.lastChild.type ? slice.openEnd - 1 : slice.openEnd);
};
const $d43eea8e1a58258d$export$d2a1206296dcfa47 = (slice, schema)=>{
    const { multiBodiedExtension: multiBodiedExtension, extensionFrame: extensionFrame } = schema.nodes;
    let depthToReduce = 2; // Removing MBE and extensionFrame
    // Edge case where the slice does not contain extensionFrames under MBE, happens when multiple block nodes get copied from a frame
    if (slice.content.firstChild?.type === multiBodiedExtension && slice.content.firstChild?.firstChild?.type !== extensionFrame) depthToReduce = 1;
    const fragment = (0, $gbisc.mapFragment)(slice.content, (node, parent, index)=>{
        if (node.type === multiBodiedExtension && !parent || node.type === extensionFrame) {
            const currentNodeIsAtStartAndIsOpen = slice.openStart >= depthToReduce && index === 0;
            const currentNodeIsAtEndAndIsOpen = slice.openEnd >= depthToReduce && index + 1 === slice.content.childCount;
            if (currentNodeIsAtStartAndIsOpen || currentNodeIsAtEndAndIsOpen) return node.content;
        }
        if (node.type === multiBodiedExtension) /* While pasting on the same page, macroId does not change until the page is published and causes collision with the existing macroId
			 *  where switching tabs of one node changes the tabs for the other node, so we put a random macroId at paste to avoid collision
			 */ {
            if (node.attrs.parameters?.macroMetadata?.macroId?.value) node.attrs.parameters.macroMetadata.macroId.value = (0, $2OrIX.uuid).generate();
        }
        return node;
    });
    // If the first/last child has changed - then we know we've removed MBE and extensionFrame and need to decrement the open depth
    return new (0, $3xw6l.Slice)(fragment, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    fragment.firstChild && fragment.firstChild.type !== slice.content.firstChild.type ? slice.openStart - depthToReduce : slice.openStart, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    fragment.lastChild && fragment.lastChild.type !== slice.content.lastChild.type ? slice.openEnd - depthToReduce : slice.openEnd);
};
const $d43eea8e1a58258d$var$LEGACY_CONTENT_MACRO_EXTENSION_TYPE = 'com.atlassian.confluence.migration', $d43eea8e1a58258d$var$LEGACY_CONTENT_MACRO_EXTENSION_KEY = 'legacy-content';
const $d43eea8e1a58258d$var$isLegacyContentMacroExtension = (extensionNode)=>extensionNode.attrs?.extensionType === $d43eea8e1a58258d$var$LEGACY_CONTENT_MACRO_EXTENSION_TYPE && extensionNode.attrs?.extensionKey === $d43eea8e1a58258d$var$LEGACY_CONTENT_MACRO_EXTENSION_KEY;
const $d43eea8e1a58258d$export$23ce34395aea8526 = (slice, schema)=>{
    const { extension: extension } = schema.nodes;
    return (0, $gbisc.mapSlice)(slice, (node)=>{
        if (node.type === extension && $d43eea8e1a58258d$var$isLegacyContentMacroExtension(node)) // Strip the node
        return null;
        return node;
    });
};
const $d43eea8e1a58258d$export$c20bd22f1bffad40 = (slice, schema)=>{
    const { extension: extension, inlineExtension: inlineExtension } = schema.nodes;
    return (0, $gbisc.mapSlice)(slice, (node)=>{
        if ([
            extension,
            inlineExtension
        ].includes(node.type) && typeof node.attrs.parameters?.macroMetadata?.macroId?.value !== 'undefined') // Strip the macroId. While pasting on the same page, macroId does not change until the page
        // is published and causes collision with the existing macroId where switching tabs of one
        // node changes the tabs for the other node
        delete node.attrs.parameters.macroMetadata.macroId;
        return node;
    });
};

});

parcelRegister("3qYlO", function(module, exports) {
$parcel$export(module.exports, "transformToNewReferenceSyncBlock", () => $507dacc42e307790$export$8bb869fc3bfe0913);

var $2OrIX = parcelRequire("2OrIX");

var $gbisc = parcelRequire("gbisc");
const $507dacc42e307790$export$8bb869fc3bfe0913 = (slice, schema)=>{
    slice = (0, $gbisc.mapSlice)(slice, (node)=>{
        // sync blocks need a unique localId to function correctly
        if (node.type === schema.nodes.syncBlock) {
            const newAttrs = {
                ...node.attrs,
                localId: (0, $2OrIX.uuid).generate()
            };
            return schema.nodes.syncBlock.create(newAttrs, null, [
                ...node.marks
            ]);
        } else if (node.type === schema.nodes.bodiedSyncBlock) {
            // bodied sync blocks need a unique localId and convert to a reference sync block
            // when converting we want to be specific about attributes and marks we carry over
            const newAttrs = {
                resourceId: node.attrs.resourceId,
                localId: (0, $2OrIX.uuid).generate()
            };
            const newMarks = schema.nodes.syncBlock.markSet ? node.marks.filter((mark)=>schema.nodes.syncBlock.markSet?.includes(mark.type)) : node.marks; // schema.nodes.syncBlock.markSet is null meaning all marks are allowed
            return schema.nodes.syncBlock.create(newAttrs, null, newMarks);
        }
        return node;
    });
    return slice;
};

});

parcelRegister("4jPLX", function(module, exports) {
$parcel$export(module.exports, "MarkdownTransformer", () => $294df2a1bcb8e230$export$267fd7ead7cc4561);

var $8DB98 = parcelRequire("8DB98");

var $cciZy = parcelRequire("cciZy");

var $5bsyn = parcelRequire("5bsyn");

var $8AXx4 = parcelRequire("8AXx4");

var $eyCU5 = parcelRequire("eyCU5");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $294df2a1bcb8e230$var$filterMdToPmSchemaMapping(schema, map) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys(map).reduce((newMap, key)=>{
        const value = map[key];
        const block = value.block || value.node;
        const mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
}
const $294df2a1bcb8e230$var$pmSchemaToMdMapping = {
    nodes: {
        blockquote: 'blockquote',
        paragraph: 'paragraph',
        rule: 'hr',
        // lheading (---, ===)
        heading: [
            'heading',
            'lheading'
        ],
        codeBlock: [
            'code',
            'fence'
        ],
        listItem: 'list',
        image: 'image'
    },
    marks: {
        em: 'emphasis',
        strong: 'text',
        link: [
            'link',
            'autolink',
            'reference',
            'linkify'
        ],
        strike: 'strikethrough',
        code: 'backticks'
    }
};
const $294df2a1bcb8e230$var$mdToPmMapping = {
    blockquote: {
        block: 'blockquote'
    },
    paragraph: {
        block: 'paragraph'
    },
    em: {
        mark: 'em'
    },
    strong: {
        mark: 'strong'
    },
    link: {
        mark: 'link',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                href: tok.attrGet('href'),
                title: tok.attrGet('title') || null
            })
    },
    hr: {
        node: 'rule'
    },
    heading: {
        block: 'heading',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    softbreak: {
        node: 'hardBreak'
    },
    hardbreak: {
        node: 'hardBreak'
    },
    code_block: {
        block: 'codeBlock'
    },
    list_item: {
        block: 'listItem'
    },
    bullet_list: {
        block: 'bulletList'
    },
    ordered_list: {
        block: 'orderedList',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                order: typeof tok.attrGet('start') === 'number' ? tok.attrGet('start') : 1
            })
    },
    code_inline: {
        mark: 'code'
    },
    fence: {
        block: 'codeBlock',
        // we trim any whitespaces around language definition
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                language: tok.info && tok.info.trim() || null
            })
    },
    media_single: {
        block: 'mediaSingle',
        attrs: ()=>({})
    },
    media: {
        node: 'media',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url'),
                alt: tok.attrGet('alt'),
                type: 'external'
            };
        }
    },
    emoji: {
        node: 'emoji',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                shortName: `:${tok.markup}:`,
                text: tok.content
            })
    },
    table: {
        block: 'table'
    },
    tr: {
        block: 'tableRow'
    },
    th: {
        block: 'tableHeader'
    },
    td: {
        block: 'tableCell'
    },
    s: {
        mark: 'strike'
    },
    task_list: {
        block: 'taskList'
    },
    task_item: {
        block: 'taskItem',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                state: tok.meta
            })
    }
};
const $294df2a1bcb8e230$var$md = (0, (/*@__PURE__*/$parcel$interopDefault($cciZy)))('zero', {
    html: false
});
$294df2a1bcb8e230$var$md.enable([
    // Process html entity - &#123;, &#xAF;, &quot;, ...
    'entity',
    // Process escaped chars and hardbreaks
    'escape'
]);
class $294df2a1bcb8e230$export$267fd7ead7cc4561 {
    constructor(schema = (0, $8DB98.defaultSchema), tokenizer = $294df2a1bcb8e230$var$md){
        // Enable markdown plugins based on schema
        [
            'nodes',
            'marks'
        ].forEach((key)=>{
            for(const idx in $294df2a1bcb8e230$var$pmSchemaToMdMapping[key])if (schema[key][idx]) tokenizer.enable($294df2a1bcb8e230$var$pmSchemaToMdMapping[key][idx]);
        });
        if (schema.nodes.table) tokenizer.use((0, $5bsyn.markdownItTable));
        if (schema.nodes.media && schema.nodes.mediaSingle) tokenizer.use((0, $eyCU5.markdownItMedia));
        this.markdownParser = new (0, $8AXx4.MarkdownParser)(schema, tokenizer, $294df2a1bcb8e230$var$filterMdToPmSchemaMapping(schema, $294df2a1bcb8e230$var$mdToPmMapping));
    }
    encode(_node) {
        throw new Error('This is not implemented yet');
    }
    parse(content) {
        return this.markdownParser.parse(content);
    }
}

});
parcelRegister("5bsyn", function(module, exports) {
$parcel$export(module.exports, "markdownItTable", () => $3c6420f8bc70654d$export$26a6b72a65821214);

var $dMwKU = parcelRequire("dMwKU");
var $3c6420f8bc70654d$export$26a6b72a65821214 = function markdownItTable(md, options) {
    md.block.ruler.before('paragraph', 'table', (0, (/*@__PURE__*/$parcel$interopDefault($dMwKU))), {
        alt: [
            'paragraph',
            'reference'
        ]
    });
};

});
parcelRegister("dMwKU", function(module, exports) {
// Copied from https://github.com/markdown-it/markdown-it/blob/master/lib/rules_block/table.js
function $a0892a9f119b1133$var$isSpace(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
function $a0892a9f119b1133$var$getLine(state, line) {
    var pos = state.bMarks[line] + state.blkIndent, max = state.eMarks[line];
    return state.src.substr(pos, max - pos);
}
function $a0892a9f119b1133$var$escapedSplit(str) {
    var result = [], pos = 0, max = str.length, ch, escapes = 0, lastPos = 0, backTicked = false, lastBackTick = 0;
    ch = str.charCodeAt(pos);
    while(pos < max){
        if (ch === 0x60 /* ` */ ) {
            if (backTicked) {
                // make \` close code sequence, but not open it;
                // the reason is: `\` is correct code block
                backTicked = false;
                lastBackTick = pos;
            } else if (escapes % 2 === 0) {
                backTicked = true;
                lastBackTick = pos;
            }
        } else if (ch === 0x7c /* | */  && escapes % 2 === 0 && !backTicked) {
            result.push(str.substring(lastPos, pos));
            lastPos = pos + 1;
        }
        if (ch === 0x5c /* \ */ ) escapes++;
        else escapes = 0;
        pos++;
        // If there was an un-closed backtick, go back to just after
        // the last backtick, but as if it was a normal character
        if (pos === max && backTicked) {
            backTicked = false;
            pos = lastBackTick + 1;
        }
        ch = str.charCodeAt(pos);
    }
    result.push(str.substring(lastPos));
    return result;
}
module.exports = function table(state, startLine, endLine, silent) {
    var ch, lineText, pos, i, nextLine, columns, columnCount, token, aligns, t, tableLines, tbodyLines;
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    ch = state.src.charCodeAt(pos++);
    if (ch !== 0x7c /* | */  && ch !== 0x2d /* - */  && ch !== 0x3a /* : */ ) return false;
    while(pos < state.eMarks[nextLine]){
        ch = state.src.charCodeAt(pos);
        if (ch !== 0x7c /* | */  && ch !== 0x2d /* - */  && ch !== 0x3a /* : */  && !$a0892a9f119b1133$var$isSpace(ch)) return false;
        pos++;
    }
    lineText = $a0892a9f119b1133$var$getLine(state, startLine + 1);
    columns = lineText.split('|');
    aligns = [];
    for(i = 0; i < columns.length; i++){
        t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3a /* : */ ) aligns.push(t.charCodeAt(0) === 0x3a /* : */  ? 'center' : 'right');
        else if (t.charCodeAt(0) === 0x3a /* : */ ) aligns.push('left');
        else aligns.push('');
    }
    lineText = $a0892a9f119b1133$var$getLine(state, startLine).trim();
    if (lineText.indexOf('|') === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $a0892a9f119b1133$var$escapedSplit(lineText.replace(/^\||\|$/g, ''));
    // header row will define an amount of columns in the entire table,
    // and align row shouldn't be smaller than that (the rest of the rows can)
    columnCount = columns.length;
    if (columnCount > aligns.length) return false;
    if (silent) return true;
    token = state.push('table_open', 'table', 1);
    token.map = tableLines = [
        startLine,
        0
    ];
    // token     = state.push('thead_open', 'thead', 1);
    // token.map = [ startLine, startLine + 1 ];
    token = state.push('tr_open', 'tr', 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    for(i = 0; i < columns.length; i++){
        token = state.push('th_open', 'th', 1);
        token.map = [
            startLine,
            startLine + 1
        ];
        if (aligns[i]) token.attrs = [
            [
                'style',
                'text-align:' + aligns[i]
            ]
        ];
        token = state.push('paragraph_open', 'p', 1);
        token = state.push('inline', '', 0);
        token.content = columns[i].trim();
        token.map = [
            startLine,
            startLine + 1
        ];
        token.children = [];
        token = state.push('paragraph_close', 'p', -1);
        token = state.push('th_close', 'th', -1);
    }
    token = state.push('tr_close', 'tr', -1);
    // token     = state.push('thead_close', 'thead', -1);
    // token     = state.push('tbody_open', 'tbody', 1);
    token.map = tbodyLines = [
        startLine + 2,
        0
    ];
    var oldLineMax = state.lineMax;
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        lineText = $a0892a9f119b1133$var$getLine(state, nextLine).trim();
        if (lineText.indexOf('|') === -1) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $a0892a9f119b1133$var$escapedSplit(lineText.replace(/^\||\|$/g, ''));
        token = state.push('tr_open', 'tr', 1);
        for(var _i = 0, offset = 1; _i < columns.length; _i++){
            token = state.push('td_open', 'td', 1);
            if (aligns[_i]) token.attrs = [
                [
                    'style',
                    'text-align:' + aligns[_i]
                ]
            ];
            // https://github.com/markdown-it/markdown-it/blob/e6f19eab4204122e85e4a342e0c1c8486ff40c2d/lib/rules_block/state_block.js#L25
            // bMarks => line begin offsets for fast jumps
            // eMarks => line end offsets for fast jumps
            // tShift => offsets of the first non-space characters (tabs not expanded)
            // sCount => indents for each line (tabs expanded)
            // Move bMarks when first char is ' ' for > to work
            var shift = columns[_i][0] === ' ' || /^(\d+\.|\*|-)$/.test(columns[_i].trim()) ? 1 : 0;
            state.bMarks[nextLine] += offset + shift;
            offset = (columns[_i] || '').length + (shift ? 0 : 1);
            state.eMarks[nextLine] = state.bMarks[nextLine] + offset - 1;
            state.lineMax = 1;
            state.md.block.tokenize(state, nextLine, nextLine + 1);
            token = state.push('td_close', 'td', -1);
        }
        token = state.push('tr_close', 'tr', -1);
    }
    // token = state.push('tbody_close', 'tbody', -1);
    state.lineMax = oldLineMax;
    token = state.push('table_close', 'table', -1);
    tableLines[1] = tbodyLines[1] = nextLine;
    state.line = nextLine;
    return true;
};

});


parcelRegister("8AXx4", function(module, exports) {
$parcel$export(module.exports, "MarkdownParser", () => $641fdd6fa7cf2027$export$a64f782182dea128);
$parcel$export(module.exports, "MarkdownSerializer", () => $641fdd6fa7cf2027$export$ae9f6f04acb6c60c);
$parcel$export(module.exports, "MarkdownSerializerState", () => $641fdd6fa7cf2027$export$61055fa707e69319);

var $3xw6l = parcelRequire("3xw6l");

var $cciZy = parcelRequire("cciZy");
/**
Document schema for the data model used by CommonMark.
*/ const $641fdd6fa7cf2027$export$4902baddc787debb = new (0, $3xw6l.Schema)({
    nodes: {
        doc: {
            content: "block+"
        },
        paragraph: {
            content: "inline*",
            group: "block",
            parseDOM: [
                {
                    tag: "p"
                }
            ],
            toDOM () {
                return [
                    "p",
                    0
                ];
            }
        },
        blockquote: {
            content: "block+",
            group: "block",
            parseDOM: [
                {
                    tag: "blockquote"
                }
            ],
            toDOM () {
                return [
                    "blockquote",
                    0
                ];
            }
        },
        horizontal_rule: {
            group: "block",
            parseDOM: [
                {
                    tag: "hr"
                }
            ],
            toDOM () {
                return [
                    "div",
                    [
                        "hr"
                    ]
                ];
            }
        },
        heading: {
            attrs: {
                level: {
                    default: 1
                }
            },
            content: "(text | image)*",
            group: "block",
            defining: true,
            parseDOM: [
                {
                    tag: "h1",
                    attrs: {
                        level: 1
                    }
                },
                {
                    tag: "h2",
                    attrs: {
                        level: 2
                    }
                },
                {
                    tag: "h3",
                    attrs: {
                        level: 3
                    }
                },
                {
                    tag: "h4",
                    attrs: {
                        level: 4
                    }
                },
                {
                    tag: "h5",
                    attrs: {
                        level: 5
                    }
                },
                {
                    tag: "h6",
                    attrs: {
                        level: 6
                    }
                }
            ],
            toDOM (node) {
                return [
                    "h" + node.attrs.level,
                    0
                ];
            }
        },
        code_block: {
            content: "text*",
            group: "block",
            code: true,
            defining: true,
            marks: "",
            attrs: {
                params: {
                    default: ""
                }
            },
            parseDOM: [
                {
                    tag: "pre",
                    preserveWhitespace: "full",
                    getAttrs: (node)=>({
                            params: node.getAttribute("data-params") || ""
                        })
                }
            ],
            toDOM (node) {
                return [
                    "pre",
                    node.attrs.params ? {
                        "data-params": node.attrs.params
                    } : {},
                    [
                        "code",
                        0
                    ]
                ];
            }
        },
        ordered_list: {
            content: "list_item+",
            group: "block",
            attrs: {
                order: {
                    default: 1
                },
                tight: {
                    default: false
                }
            },
            parseDOM: [
                {
                    tag: "ol",
                    getAttrs (dom) {
                        return {
                            order: dom.hasAttribute("start") ? +dom.getAttribute("start") : 1,
                            tight: dom.hasAttribute("data-tight")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "ol",
                    {
                        start: node.attrs.order == 1 ? null : node.attrs.order,
                        "data-tight": node.attrs.tight ? "true" : null
                    },
                    0
                ];
            }
        },
        bullet_list: {
            content: "list_item+",
            group: "block",
            attrs: {
                tight: {
                    default: false
                }
            },
            parseDOM: [
                {
                    tag: "ul",
                    getAttrs: (dom)=>({
                            tight: dom.hasAttribute("data-tight")
                        })
                }
            ],
            toDOM (node) {
                return [
                    "ul",
                    {
                        "data-tight": node.attrs.tight ? "true" : null
                    },
                    0
                ];
            }
        },
        list_item: {
            content: "block+",
            defining: true,
            parseDOM: [
                {
                    tag: "li"
                }
            ],
            toDOM () {
                return [
                    "li",
                    0
                ];
            }
        },
        text: {
            group: "inline"
        },
        image: {
            inline: true,
            attrs: {
                src: {},
                alt: {
                    default: null
                },
                title: {
                    default: null
                }
            },
            group: "inline",
            draggable: true,
            parseDOM: [
                {
                    tag: "img[src]",
                    getAttrs (dom) {
                        return {
                            src: dom.getAttribute("src"),
                            title: dom.getAttribute("title"),
                            alt: dom.getAttribute("alt")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "img",
                    node.attrs
                ];
            }
        },
        hard_break: {
            inline: true,
            group: "inline",
            selectable: false,
            parseDOM: [
                {
                    tag: "br"
                }
            ],
            toDOM () {
                return [
                    "br"
                ];
            }
        }
    },
    marks: {
        em: {
            parseDOM: [
                {
                    tag: "i"
                },
                {
                    tag: "em"
                },
                {
                    style: "font-style=italic"
                },
                {
                    style: "font-style=normal",
                    clearMark: (m)=>m.type.name == "em"
                }
            ],
            toDOM () {
                return [
                    "em"
                ];
            }
        },
        strong: {
            parseDOM: [
                {
                    tag: "strong"
                },
                {
                    tag: "b",
                    getAttrs: (node)=>node.style.fontWeight != "normal" && null
                },
                {
                    style: "font-weight=400",
                    clearMark: (m)=>m.type.name == "strong"
                },
                {
                    style: "font-weight",
                    getAttrs: (value)=>/^(bold(er)?|[5-9]\d{2,})$/.test(value) && null
                }
            ],
            toDOM () {
                return [
                    "strong"
                ];
            }
        },
        link: {
            attrs: {
                href: {},
                title: {
                    default: null
                }
            },
            inclusive: false,
            parseDOM: [
                {
                    tag: "a[href]",
                    getAttrs (dom) {
                        return {
                            href: dom.getAttribute("href"),
                            title: dom.getAttribute("title")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "a",
                    node.attrs
                ];
            }
        },
        code: {
            parseDOM: [
                {
                    tag: "code"
                }
            ],
            toDOM () {
                return [
                    "code"
                ];
            }
        }
    }
});
// @ts-ignore
function $641fdd6fa7cf2027$var$maybeMerge(a, b) {
    if (a.isText && b.isText && (0, $3xw6l.Mark).sameSet(a.marks, b.marks)) return a.withText(a.text + b.text);
}
// Object used to track the context of a running parse.
class $641fdd6fa7cf2027$var$MarkdownParseState {
    constructor(schema, tokenHandlers){
        this.schema = schema;
        this.tokenHandlers = tokenHandlers;
        this.stack = [
            {
                type: schema.topNodeType,
                attrs: null,
                content: [],
                marks: (0, $3xw6l.Mark).none
            }
        ];
    }
    top() {
        return this.stack[this.stack.length - 1];
    }
    push(elt) {
        if (this.stack.length) this.top().content.push(elt);
    }
    // Adds the given text to the current position in the document,
    // using the current marks as styling.
    addText(text) {
        if (!text) return;
        let top = this.top(), nodes = top.content, last = nodes[nodes.length - 1];
        let node = this.schema.text(text, top.marks), merged;
        if (last && (merged = $641fdd6fa7cf2027$var$maybeMerge(last, node))) nodes[nodes.length - 1] = merged;
        else nodes.push(node);
    }
    // Adds the given mark to the set of active marks.
    openMark(mark) {
        let top = this.top();
        top.marks = mark.addToSet(top.marks);
    }
    // Removes the given mark from the set of active marks.
    closeMark(mark) {
        let top = this.top();
        top.marks = mark.removeFromSet(top.marks);
    }
    parseTokens(toks) {
        for(let i = 0; i < toks.length; i++){
            let tok = toks[i];
            let handler = this.tokenHandlers[tok.type];
            if (!handler) throw new Error("Token type `" + tok.type + "` not supported by Markdown parser");
            handler(this, tok, toks, i);
        }
    }
    // Add a node at the current position.
    addNode(type, attrs, content) {
        let top = this.top();
        let node = type.createAndFill(attrs, content, top ? top.marks : []);
        if (!node) return null;
        this.push(node);
        return node;
    }
    // Wrap subsequent content in a node of the given type.
    openNode(type, attrs) {
        this.stack.push({
            type: type,
            attrs: attrs,
            content: [],
            marks: (0, $3xw6l.Mark).none
        });
    }
    // Close and return the node that is currently on top of the stack.
    closeNode() {
        let info = this.stack.pop();
        return this.addNode(info.type, info.attrs, info.content);
    }
}
function $641fdd6fa7cf2027$var$attrs(spec, token, tokens, i) {
    if (spec.getAttrs) return spec.getAttrs(token, tokens, i);
    else if (spec.attrs instanceof Function) return spec.attrs(token);
    else return spec.attrs;
}
// Code content is represented as a single token with a `content`
// property in Markdown-it.
function $641fdd6fa7cf2027$var$noCloseToken(spec, type) {
    return spec.noCloseToken || type == "code_inline" || type == "code_block" || type == "fence";
}
function $641fdd6fa7cf2027$var$withoutTrailingNewline(str) {
    return str[str.length - 1] == "\n" ? str.slice(0, str.length - 1) : str;
}
function $641fdd6fa7cf2027$var$noOp() {}
function $641fdd6fa7cf2027$var$tokenHandlers(schema, tokens) {
    let handlers = Object.create(null);
    for(let type in tokens){
        let spec = tokens[type];
        if (spec.block) {
            let nodeType = schema.nodeType(spec.block);
            if ($641fdd6fa7cf2027$var$noCloseToken(spec, type)) handlers[type] = (state, tok, tokens, i)=>{
                state.openNode(nodeType, $641fdd6fa7cf2027$var$attrs(spec, tok, tokens, i));
                state.addText($641fdd6fa7cf2027$var$withoutTrailingNewline(tok.content));
                state.closeNode();
            };
            else {
                handlers[type + "_open"] = (state, tok, tokens, i)=>state.openNode(nodeType, $641fdd6fa7cf2027$var$attrs(spec, tok, tokens, i));
                handlers[type + "_close"] = (state)=>state.closeNode();
            }
        } else if (spec.node) {
            let nodeType = schema.nodeType(spec.node);
            handlers[type] = (state, tok, tokens, i)=>state.addNode(nodeType, $641fdd6fa7cf2027$var$attrs(spec, tok, tokens, i));
        } else if (spec.mark) {
            let markType = schema.marks[spec.mark];
            if ($641fdd6fa7cf2027$var$noCloseToken(spec, type)) handlers[type] = (state, tok, tokens, i)=>{
                state.openMark(markType.create($641fdd6fa7cf2027$var$attrs(spec, tok, tokens, i)));
                state.addText($641fdd6fa7cf2027$var$withoutTrailingNewline(tok.content));
                state.closeMark(markType);
            };
            else {
                handlers[type + "_open"] = (state, tok, tokens, i)=>state.openMark(markType.create($641fdd6fa7cf2027$var$attrs(spec, tok, tokens, i)));
                handlers[type + "_close"] = (state)=>state.closeMark(markType);
            }
        } else if (spec.ignore) {
            if ($641fdd6fa7cf2027$var$noCloseToken(spec, type)) handlers[type] = $641fdd6fa7cf2027$var$noOp;
            else {
                handlers[type + "_open"] = $641fdd6fa7cf2027$var$noOp;
                handlers[type + "_close"] = $641fdd6fa7cf2027$var$noOp;
            }
        } else throw new RangeError("Unrecognized parsing spec " + JSON.stringify(spec));
    }
    handlers.text = (state, tok)=>state.addText(tok.content);
    handlers.inline = (state, tok)=>state.parseTokens(tok.children);
    handlers.softbreak = handlers.softbreak || ((state)=>state.addText(" "));
    return handlers;
}
/**
A configuration of a Markdown parser. Such a parser uses
[markdown-it](https://github.com/markdown-it/markdown-it) to
tokenize a file, and then runs the custom rules it is given over
the tokens to create a ProseMirror document tree.
*/ class $641fdd6fa7cf2027$export$a64f782182dea128 {
    /**
    Create a parser with the given configuration. You can configure
    the markdown-it parser to parse the dialect you want, and provide
    a description of the ProseMirror entities those tokens map to in
    the `tokens` object, which maps token names to descriptions of
    what to do with them. Such a description is an object, and may
    have the following properties:
    */ constructor(/**
    The parser's document schema.
    */ schema, /**
    This parser's markdown-it tokenizer.
    */ tokenizer, /**
    The value of the `tokens` object used to construct this
    parser. Can be useful to copy and modify to base other parsers
    on.
    */ tokens){
        this.schema = schema;
        this.tokenizer = tokenizer;
        this.tokens = tokens;
        this.tokenHandlers = $641fdd6fa7cf2027$var$tokenHandlers(schema, tokens);
    }
    /**
    Parse a string as [CommonMark](http://commonmark.org/) markup,
    and create a ProseMirror document as prescribed by this parser's
    rules.
    
    The second argument, when given, is passed through to the
    [Markdown
    parser](https://markdown-it.github.io/markdown-it/#MarkdownIt.parse).
    */ parse(text, markdownEnv = {}) {
        let state = new $641fdd6fa7cf2027$var$MarkdownParseState(this.schema, this.tokenHandlers), doc;
        state.parseTokens(this.tokenizer.parse(text, markdownEnv));
        do doc = state.closeNode();
        while (state.stack.length);
        return doc || this.schema.topNodeType.createAndFill();
    }
}
function $641fdd6fa7cf2027$var$listIsTight(tokens, i) {
    while(++i < tokens.length)if (tokens[i].type != "list_item_open") return tokens[i].hidden;
    return false;
}
/**
A parser parsing unextended [CommonMark](http://commonmark.org/),
without inline HTML, and producing a document in the basic schema.
*/ const $641fdd6fa7cf2027$export$7517583227ad0cb8 = new $641fdd6fa7cf2027$export$a64f782182dea128($641fdd6fa7cf2027$export$4902baddc787debb, (0, (/*@__PURE__*/$parcel$interopDefault($cciZy)))("commonmark", {
    html: false
}), {
    blockquote: {
        block: "blockquote"
    },
    paragraph: {
        block: "paragraph"
    },
    list_item: {
        block: "list_item"
    },
    bullet_list: {
        block: "bullet_list",
        getAttrs: (_, tokens, i)=>({
                tight: $641fdd6fa7cf2027$var$listIsTight(tokens, i)
            })
    },
    ordered_list: {
        block: "ordered_list",
        getAttrs: (tok, tokens, i)=>({
                order: +tok.attrGet("start") || 1,
                tight: $641fdd6fa7cf2027$var$listIsTight(tokens, i)
            })
    },
    heading: {
        block: "heading",
        getAttrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    code_block: {
        block: "code_block",
        noCloseToken: true
    },
    fence: {
        block: "code_block",
        getAttrs: (tok)=>({
                params: tok.info || ""
            }),
        noCloseToken: true
    },
    hr: {
        node: "horizontal_rule"
    },
    image: {
        node: "image",
        getAttrs: (tok)=>({
                src: tok.attrGet("src"),
                title: tok.attrGet("title") || null,
                alt: tok.children[0] && tok.children[0].content || null
            })
    },
    hardbreak: {
        node: "hard_break"
    },
    em: {
        mark: "em"
    },
    strong: {
        mark: "strong"
    },
    link: {
        mark: "link",
        getAttrs: (tok)=>({
                href: tok.attrGet("href"),
                title: tok.attrGet("title") || null
            })
    },
    code_inline: {
        mark: "code",
        noCloseToken: true
    }
});
const $641fdd6fa7cf2027$var$blankMark = {
    open: "",
    close: "",
    mixable: true
};
/**
A specification for serializing a ProseMirror document as
Markdown/CommonMark text.
*/ class $641fdd6fa7cf2027$export$ae9f6f04acb6c60c {
    /**
    Construct a serializer with the given configuration. The `nodes`
    object should map node names in a given schema to function that
    take a serializer state and such a node, and serialize the node.
    */ constructor(/**
    The node serializer functions for this serializer.
    */ nodes, /**
    The mark serializer info.
    */ marks, options = {}){
        this.nodes = nodes;
        this.marks = marks;
        this.options = options;
    }
    /**
    Serialize the content of the given node to
    [CommonMark](http://commonmark.org/).
    */ serialize(content, options = {}) {
        options = Object.assign({}, this.options, options);
        let state = new $641fdd6fa7cf2027$export$61055fa707e69319(this.nodes, this.marks, options);
        state.renderContent(content);
        return state.out;
    }
}
/**
A serializer for the [basic schema](https://prosemirror.net/docs/ref/#schema).
*/ const $641fdd6fa7cf2027$export$f996452ca6e9a0ae = new $641fdd6fa7cf2027$export$ae9f6f04acb6c60c({
    blockquote (state, node) {
        state.wrapBlock("> ", null, node, ()=>state.renderContent(node));
    },
    code_block (state, node) {
        // Make sure the front matter fences are longer than any dash sequence within it
        const backticks = node.textContent.match(/`{3,}/gm);
        const fence = backticks ? backticks.sort().slice(-1)[0] + "`" : "```";
        state.write(fence + (node.attrs.params || "") + "\n");
        state.text(node.textContent, false);
        // Add a newline to the current content before adding closing marker
        state.write("\n");
        state.write(fence);
        state.closeBlock(node);
    },
    heading (state, node) {
        state.write(state.repeat("#", node.attrs.level) + " ");
        state.renderInline(node, false);
        state.closeBlock(node);
    },
    horizontal_rule (state, node) {
        state.write(node.attrs.markup || "---");
        state.closeBlock(node);
    },
    bullet_list (state, node) {
        state.renderList(node, "  ", ()=>(node.attrs.bullet || "*") + " ");
    },
    ordered_list (state, node) {
        let start = node.attrs.order || 1;
        let maxW = String(start + node.childCount - 1).length;
        let space = state.repeat(" ", maxW + 2);
        state.renderList(node, space, (i)=>{
            let nStr = String(start + i);
            return state.repeat(" ", maxW - nStr.length) + nStr + ". ";
        });
    },
    list_item (state, node) {
        state.renderContent(node);
    },
    paragraph (state, node) {
        state.renderInline(node);
        state.closeBlock(node);
    },
    image (state, node) {
        state.write("![" + state.esc(node.attrs.alt || "") + "](" + node.attrs.src.replace(/[\(\)]/g, "\\$&") + (node.attrs.title ? ' "' + node.attrs.title.replace(/"/g, '\\"') + '"' : "") + ")");
    },
    hard_break (state, node, parent, index) {
        for(let i = index + 1; i < parent.childCount; i++)if (parent.child(i).type != node.type) {
            state.write("\\\n");
            return;
        }
    },
    text (state, node) {
        state.text(node.text, !state.inAutolink);
    }
}, {
    em: {
        open: "*",
        close: "*",
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strong: {
        open: "**",
        close: "**",
        mixable: true,
        expelEnclosingWhitespace: true
    },
    link: {
        open (state, mark, parent, index) {
            state.inAutolink = $641fdd6fa7cf2027$var$isPlainURL(mark, parent, index);
            return state.inAutolink ? "<" : "[";
        },
        close (state, mark, parent, index) {
            let { inAutolink: inAutolink } = state;
            state.inAutolink = undefined;
            return inAutolink ? ">" : "](" + mark.attrs.href.replace(/[\(\)"]/g, "\\$&") + (mark.attrs.title ? ` "${mark.attrs.title.replace(/"/g, '\\"')}"` : "") + ")";
        },
        mixable: true
    },
    code: {
        open (_state, _mark, parent, index) {
            return $641fdd6fa7cf2027$var$backticksFor(parent.child(index), -1);
        },
        close (_state, _mark, parent, index) {
            return $641fdd6fa7cf2027$var$backticksFor(parent.child(index - 1), 1);
        },
        escape: false
    }
});
function $641fdd6fa7cf2027$var$backticksFor(node, side) {
    let ticks = /`+/g, m, len = 0;
    if (node.isText) while(m = ticks.exec(node.text))len = Math.max(len, m[0].length);
    let result = len > 0 && side > 0 ? " `" : "`";
    for(let i = 0; i < len; i++)result += "`";
    if (len > 0 && side < 0) result += " ";
    return result;
}
function $641fdd6fa7cf2027$var$isPlainURL(link, parent, index) {
    if (link.attrs.title || !/^\w+:/.test(link.attrs.href)) return false;
    let content = parent.child(index);
    if (!content.isText || content.text != link.attrs.href || content.marks[content.marks.length - 1] != link) return false;
    return index == parent.childCount - 1 || !link.isInSet(parent.child(index + 1).marks);
}
/**
This is an object used to track state and expose
methods related to markdown serialization. Instances are passed to
node and mark serialization methods (see `toMarkdown`).
*/ class $641fdd6fa7cf2027$export$61055fa707e69319 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ nodes, /**
    @internal
    */ marks, /**
    The options passed to the serializer.
    */ options){
        this.nodes = nodes;
        this.marks = marks;
        this.options = options;
        /**
        @internal
        */ this.delim = "";
        /**
        @internal
        */ this.out = "";
        /**
        @internal
        */ this.closed = null;
        /**
        @internal
        */ this.inAutolink = undefined;
        /**
        @internal
        */ this.atBlockStart = false;
        /**
        @internal
        */ this.inTightList = false;
        if (typeof this.options.tightLists == "undefined") this.options.tightLists = false;
        if (typeof this.options.hardBreakNodeName == "undefined") this.options.hardBreakNodeName = "hard_break";
    }
    /**
    @internal
    */ flushClose(size = 2) {
        if (this.closed) {
            if (!this.atBlank()) this.out += "\n";
            if (size > 1) {
                let delimMin = this.delim;
                let trim = /\s+$/.exec(delimMin);
                if (trim) delimMin = delimMin.slice(0, delimMin.length - trim[0].length);
                for(let i = 1; i < size; i++)this.out += delimMin + "\n";
            }
            this.closed = null;
        }
    }
    /**
    @internal
    */ getMark(name) {
        let info = this.marks[name];
        if (!info) {
            if (this.options.strict !== false) throw new Error(`Mark type \`${name}\` not supported by Markdown renderer`);
            info = $641fdd6fa7cf2027$var$blankMark;
        }
        return info;
    }
    /**
    Render a block, prefixing each line with `delim`, and the first
    line in `firstDelim`. `node` should be the node that is closed at
    the end of the block, and `f` is a function that renders the
    content of the block.
    */ wrapBlock(delim, firstDelim, node, f) {
        let old = this.delim;
        this.write(firstDelim != null ? firstDelim : delim);
        this.delim += delim;
        f();
        this.delim = old;
        this.closeBlock(node);
    }
    /**
    @internal
    */ atBlank() {
        return /(^|\n)$/.test(this.out);
    }
    /**
    Ensure the current content ends with a newline.
    */ ensureNewLine() {
        if (!this.atBlank()) this.out += "\n";
    }
    /**
    Prepare the state for writing output (closing closed paragraphs,
    adding delimiters, and so on), and then optionally add content
    (unescaped) to the output.
    */ write(content) {
        this.flushClose();
        if (this.delim && this.atBlank()) this.out += this.delim;
        if (content) this.out += content;
    }
    /**
    Close the block for the given node.
    */ closeBlock(node) {
        this.closed = node;
    }
    /**
    Add the given text to the document. When escape is not `false`,
    it will be escaped.
    */ text(text, escape = true) {
        let lines = text.split("\n");
        for(let i = 0; i < lines.length; i++){
            this.write();
            // Escape exclamation marks in front of links
            if (!escape && lines[i][0] == "[" && /(^|[^\\])\!$/.test(this.out)) this.out = this.out.slice(0, this.out.length - 1) + "\\!";
            this.out += escape ? this.esc(lines[i], this.atBlockStart) : lines[i];
            if (i != lines.length - 1) this.out += "\n";
        }
    }
    /**
    Render the given node as a block.
    */ render(node, parent, index) {
        if (this.nodes[node.type.name]) this.nodes[node.type.name](this, node, parent, index);
        else {
            if (this.options.strict !== false) throw new Error("Token type `" + node.type.name + "` not supported by Markdown renderer");
            else if (!node.type.isLeaf) {
                if (node.type.inlineContent) this.renderInline(node);
                else this.renderContent(node);
                if (node.isBlock) this.closeBlock(node);
            }
        }
    }
    /**
    Render the contents of `parent` as block nodes.
    */ renderContent(parent) {
        parent.forEach((node, _, i)=>this.render(node, parent, i));
    }
    /**
    Render the contents of `parent` as inline content.
    */ renderInline(parent, fromBlockStart = true) {
        this.atBlockStart = fromBlockStart;
        let active = [], trailing = "";
        let progress = (node, offset, index)=>{
            let marks = node ? node.marks : [];
            // Remove marks from `hard_break` that are the last node inside
            // that mark to prevent parser edge cases with new lines just
            // before closing marks.
            if (node && node.type.name === this.options.hardBreakNodeName) marks = marks.filter((m)=>{
                if (index + 1 == parent.childCount) return false;
                let next = parent.child(index + 1);
                return m.isInSet(next.marks) && (!next.isText || /\S/.test(next.text));
            });
            let leading = trailing;
            trailing = "";
            // If whitespace has to be expelled from the node, adjust
            // leading and trailing accordingly.
            if (node && node.isText && marks.some((mark)=>{
                let info = this.getMark(mark.type.name);
                return info && info.expelEnclosingWhitespace && !mark.isInSet(active);
            })) {
                let [_, lead, rest] = /^(\s*)(.*)$/m.exec(node.text);
                if (lead) {
                    leading += lead;
                    node = rest ? node.withText(rest) : null;
                    if (!node) marks = active;
                }
            }
            if (node && node.isText && marks.some((mark)=>{
                let info = this.getMark(mark.type.name);
                return info && info.expelEnclosingWhitespace && (index == parent.childCount - 1 || !mark.isInSet(parent.child(index + 1).marks));
            })) {
                let [_, rest, trail] = /^(.*?)(\s*)$/m.exec(node.text);
                if (trail) {
                    trailing = trail;
                    node = rest ? node.withText(rest) : null;
                    if (!node) marks = active;
                }
            }
            let inner = marks.length ? marks[marks.length - 1] : null;
            let noEsc = inner && this.getMark(inner.type.name).escape === false;
            let len = marks.length - (noEsc ? 1 : 0);
            // Try to reorder 'mixable' marks, such as em and strong, which
            // in Markdown may be opened and closed in different order, so
            // that order of the marks for the token matches the order in
            // active.
            outer: for(let i = 0; i < len; i++){
                let mark = marks[i];
                if (!this.getMark(mark.type.name).mixable) break;
                for(let j = 0; j < active.length; j++){
                    let other = active[j];
                    if (!this.getMark(other.type.name).mixable) break;
                    if (mark.eq(other)) {
                        if (i > j) marks = marks.slice(0, j).concat(mark).concat(marks.slice(j, i)).concat(marks.slice(i + 1, len));
                        else if (j > i) marks = marks.slice(0, i).concat(marks.slice(i + 1, j)).concat(mark).concat(marks.slice(j, len));
                        continue outer;
                    }
                }
            }
            // Find the prefix of the mark set that didn't change
            let keep = 0;
            while(keep < Math.min(active.length, len) && marks[keep].eq(active[keep]))++keep;
            // Close the marks that need to be closed
            while(keep < active.length)this.text(this.markString(active.pop(), false, parent, index), false);
            // Output any previously expelled trailing whitespace outside the marks
            if (leading) this.text(leading);
            // Open the marks that need to be opened
            if (node) {
                while(active.length < len){
                    let add = marks[active.length];
                    active.push(add);
                    this.text(this.markString(add, true, parent, index), false);
                    this.atBlockStart = false;
                }
                // Render the node. Special case code marks, since their content
                // may not be escaped.
                if (noEsc && node.isText) this.text(this.markString(inner, true, parent, index) + node.text + this.markString(inner, false, parent, index + 1), false);
                else this.render(node, parent, index);
                this.atBlockStart = false;
            }
            // After the first non-empty text node is rendered, the end of output
            // is no longer at block start.
            //
            // FIXME: If a non-text node writes something to the output for this
            // block, the end of output is also no longer at block start. But how
            // can we detect that?
            if ((node === null || node === void 0 ? void 0 : node.isText) && node.nodeSize > 0) this.atBlockStart = false;
        };
        parent.forEach(progress);
        progress(null, 0, parent.childCount);
        this.atBlockStart = false;
    }
    /**
    Render a node's content as a list. `delim` should be the extra
    indentation added to all lines except the first in an item,
    `firstDelim` is a function going from an item index to a
    delimiter for the first line of the item.
    */ renderList(node, delim, firstDelim) {
        if (this.closed && this.closed.type == node.type) this.flushClose(3);
        else if (this.inTightList) this.flushClose(1);
        let isTight = typeof node.attrs.tight != "undefined" ? node.attrs.tight : this.options.tightLists;
        let prevTight = this.inTightList;
        this.inTightList = isTight;
        node.forEach((child, _, i)=>{
            if (i && isTight) this.flushClose(1);
            this.wrapBlock(delim, firstDelim(i), node, ()=>this.render(child, node, i));
        });
        this.inTightList = prevTight;
    }
    /**
    Escape the given string so that it can safely appear in Markdown
    content. If `startOfLine` is true, also escape characters that
    have special meaning only at the start of the line.
    */ esc(str, startOfLine = false) {
        str = str.replace(/[`*\\~\[\]_]/g, (m, i)=>m == "_" && i > 0 && i + 1 < str.length && str[i - 1].match(/\w/) && str[i + 1].match(/\w/) ? m : "\\" + m);
        if (startOfLine) str = str.replace(/^(\+[ ]|[\-*>])/, "\\$&").replace(/^(\s*)(#{1,6})(\s|$)/, '$1\\$2$3').replace(/^(\s*\d+)\.\s/, "$1\\. ");
        if (this.options.escapeExtraCharacters) str = str.replace(this.options.escapeExtraCharacters, "\\$&");
        return str;
    }
    /**
    @internal
    */ quote(str) {
        let wrap = str.indexOf('"') == -1 ? '""' : str.indexOf("'") == -1 ? "''" : "()";
        return wrap[0] + str + wrap[1];
    }
    /**
    Repeat the given string `n` times.
    */ repeat(str, n) {
        let out = "";
        for(let i = 0; i < n; i++)out += str;
        return out;
    }
    /**
    Get the markdown string for a given opening or closing mark.
    */ markString(mark, open, parent, index) {
        let info = this.getMark(mark.type.name);
        let value = open ? info.open : info.close;
        return typeof value == "string" ? value : value(this, mark, parent, index);
    }
    /**
    Get leading and trailing whitespace from a string. Values of
    leading or trailing property of the return object will be undefined
    if there is no match.
    */ getEnclosingWhitespace(text) {
        return {
            leading: (text.match(/^(\s+)/) || [
                undefined
            ])[0],
            trailing: (text.match(/(\s+)$/) || [
                undefined
            ])[0]
        };
    }
}

});

parcelRegister("eyCU5", function(module, exports) {
$parcel$export(module.exports, "markdownItMedia", () => $8cff57ddc400605b$export$c8dcbd316b71f8cf);
function $8cff57ddc400605b$var$createRule() {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const regx = /!\[([^\]]*)\]\(([^)]*?)\s*(?:"([^")]*)"\s*)?\)/g;
    const validParentTokens = [
        'th_open',
        'td_open',
        'list_item_open',
        'blockquote_open'
    ];
    /**
	 * This function looks for strings that matches ![description](url) inside Inline-tokens.
	 * It will then split the Inline-token with content before and after the image, example:
	 *
	 * Input (tokens):
	 *   paragraph_open
	 *   inline - content: Hello ![](image.jpg) World!
	 *   paragraph_close
	 * Output (tokens):
	 *   paragraph_open
	 *   inline - content: Hello
	 *   paragraph_close
	 *   media_single_open
	 *   media
	 *   media_single_close
	 *   paragraph_open
	 *   inline - content: World!
	 *   paragraph_close
	 *
	 * This is applied before the inline content is parsed, to ensure that the formatting of
	 * remaining inline content (bold, links, etc.) is kept intact!
	 */ return function media(State) {
        const getUrl = (str)=>{
            const res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
            if (res.ok) {
                const href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return '';
        };
        const createMediaTokens = (url, alt = '')=>{
            const mediaSingleOpen = new State.Token('media_single_open', '', 1);
            const media = new State.Token('media', '', 0);
            media.attrs = [
                [
                    'url',
                    getUrl(url)
                ],
                [
                    'type',
                    'external'
                ],
                [
                    'alt',
                    alt
                ]
            ];
            const mediaSingleClose = new State.Token('media_single_close', '', -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        const createInlineTokens = (str, openingTokens, closingTokens)=>{
            if (!str || str.length === 0) return [];
            const inlineBefore = new State.Token('inline', '', 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [
                ...openingTokens,
                inlineBefore,
                ...closingTokens
            ];
        };
        let processedTokens = [];
        const newTokens = State.tokens.reduce((tokens, token, i, arr)=>{
            const matchAll = Array.from(token.content.matchAll(regx));
            if (token.type === 'inline' && matchAll.length) {
                const openingTokens = [];
                let cursor = i - 1;
                let previousToken = arr[cursor];
                let subTree = [];
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                const closingTokens = openingTokens.map((token)=>new State.Token(token.type.replace('_open', '_close'), token.tag, -1)).reverse();
                let inlineContentStack = token.content;
                matchAll.forEach((match)=>{
                    const [matchString, alt, url] = match;
                    const start = inlineContentStack.indexOf(matchString);
                    const contentBefore = inlineContentStack.substr(0, start);
                    inlineContentStack = inlineContentStack.substr(start + matchString.length);
                    subTree = [
                        ...subTree,
                        ...createInlineTokens(contentBefore, openingTokens, closingTokens),
                        ...createMediaTokens(url, alt)
                    ];
                });
                if (inlineContentStack.length) subTree = [
                    ...subTree,
                    ...createInlineTokens(inlineContentStack, openingTokens, closingTokens)
                ];
                processedTokens = [
                    ...processedTokens,
                    ...closingTokens.map((c)=>c.type)
                ];
                tokens = [
                    ...tokens.slice(0, cursor),
                    ...subTree
                ];
            } else if (processedTokens.indexOf(token.type) !== -1) // Ignore token if it's already processed
            processedTokens.splice(processedTokens.indexOf(token.type), 1);
            else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
const $8cff57ddc400605b$export$c8dcbd316b71f8cf = (md)=>{
    md.core.ruler.before('inline', 'media', $8cff57ddc400605b$var$createRule());
};

});


parcelRegister("5yEGu", function(module, exports) {
$parcel$export(module.exports, "handlePaste", () => $dd6e18e2f6e110dd$export$5dbcc300324fed87);

var $3xw6l = parcelRequire("3xw6l");

var $BmspC = parcelRequire("BmspC");

var $eGOwo = parcelRequire("eGOwo");

var $92xoS = parcelRequire("92xoS");

var $cwzAY = parcelRequire("cwzAY");

var $2vA54 = parcelRequire("2vA54");

var $a57M0 = parcelRequire("a57M0");

var $3n5hT = parcelRequire("3n5hT");

var $7lSnz = parcelRequire("7lSnz");

var $kR2ZR = parcelRequire("kR2ZR");
const $dd6e18e2f6e110dd$var$SKIP_NESTED_TABLE_PASTE_SOURCES = [
    'microsoft-excel',
    'google-spreadsheets'
];
function $dd6e18e2f6e110dd$export$5dbcc300324fed87(view, event, slice, options) {
    if (!(0, $7lSnz.isInTable)(view.state)) return false;
    const { schema: schema } = view.state;
    const isNestingAllowed = (0, $92xoS.editorExperiment)('nested-tables-in-tables', true);
    const isPasteFullTableInsideEmptyCellEnabled = (0, $eGOwo.fg)('platform_editor_paste_full_table_inside_empty_cell');
    const isPartialTablePaste = slice.content.childCount === 1 && slice.content.firstChild?.type === schema.nodes.table && slice.openStart !== 0 && slice.openEnd !== 0;
    const sel = view.state.selection;
    const isCellSelection = sel instanceof (0, $cwzAY.CellSelection);
    if (isPasteFullTableInsideEmptyCellEnabled && isNestingAllowed && !isPartialTablePaste && // If the selection is not a cell selection, and the selection is empty then we can insert a nested table
    !isCellSelection && sel.empty && !(options && $dd6e18e2f6e110dd$var$SKIP_NESTED_TABLE_PASTE_SOURCES.includes(options.pasteSource))) {
        const cellRes = (0, $BmspC.findParentNode)((node)=>node.type === schema.nodes.tableCell || node.type === schema.nodes.tableHeader)(sel);
        if (cellRes) {
            const canInsertNestedTable = cellRes.node.contentMatchAt(0).matchType(schema.nodes.table)?.validEnd;
            if (canInsertNestedTable) return false;
        }
    }
    let cells = (0, $kR2ZR.pastedCells)(slice);
    if (isCellSelection) {
        if (!cells) cells = {
            width: 1,
            height: 1,
            rows: [
                (0, $3xw6l.Fragment).from((0, $kR2ZR.fitSlice)((0, $3n5hT.tableNodeTypes)(view.state.schema).cell, slice))
            ]
        };
        const table = sel.$anchorCell.node(-1);
        const start = sel.$anchorCell.start(-1);
        const tableMap = (0, $2vA54.TableMap).get(table);
        const rect = tableMap.rectBetween(sel.$anchorCell.pos - start, sel.$headCell.pos - start);
        cells = (0, $kR2ZR.clipCells)(cells, rect.right - rect.left, rect.bottom - rect.top);
        (0, $kR2ZR.insertCells)(view.state, view.dispatch, start, rect, $dd6e18e2f6e110dd$var$clearColumnWidthOfCells(cells, rect, tableMap));
        return true;
    }
    if (cells) {
        const $cell = (0, $a57M0.selectionCell)(sel);
        if (!$cell) throw new Error(`handlePaste: no cell found`);
        const start = $cell.start(-1);
        const rect = (0, $2vA54.TableMap).get($cell.node(-1)).findCell($cell.pos - start);
        const tableMap = (0, $2vA54.TableMap).get($cell.node(-1));
        (0, $kR2ZR.insertCells)(view.state, view.dispatch, start, rect, $dd6e18e2f6e110dd$var$clearColumnWidthOfCells(cells, rect, tableMap));
        return true;
    }
    return false;
}
// Clear the pasted cells column widths so that it maintains
// the column widths of the destination table only if the pasted
// cells overlap with existing cells in the destination table.
// If the table grows on paste, keep the column widhts of the
// original table.
const $dd6e18e2f6e110dd$var$clearColumnWidthOfCells = (cells, rect, table)=>{
    const overlappingCells = [];
    for (const row of cells.rows){
        let colNum = rect.left;
        for(let index = 0; index < row.childCount; index++){
            const cell = row.child(index);
            if (colNum + cell.attrs.colspan <= table.width) {
                overlappingCells.push(cell);
                colNum += cell.attrs.colspan;
            } else break;
        }
    }
    for (const cell of overlappingCells)// TODO: ED-13910 - unblock Prosemirror bump
    // @ts-ignore
    cell.attrs.colwidth = null;
    return cells;
};

});
parcelRegister("3n5hT", function(module, exports) {
$parcel$export(module.exports, "tableNodeTypes", () => $eab552a4fa2f4da5$export$c7782132717464bc);
function $eab552a4fa2f4da5$export$c7782132717464bc(schema) {
    let result = schema.cached.tableNodeTypes;
    if (!result) {
        result = {};
        // eslint-disable-next-line no-param-reassign
        schema.cached.tableNodeTypes = result;
        // eslint-disable-next-line guard-for-in
        for(const name in schema.nodes){
            const type = schema.nodes[name];
            const role = type.spec.tableRole;
            if (role) result[role] = type;
        }
    }
    return result;
}

});

parcelRegister("kR2ZR", function(module, exports) {
$parcel$export(module.exports, "pastedCells", () => $61689dc703b4f6c3$export$f6d8f52489457fc4);
$parcel$export(module.exports, "fitSlice", () => $61689dc703b4f6c3$export$f09c6b3b06d884fb);
$parcel$export(module.exports, "clipCells", () => $61689dc703b4f6c3$export$cdcebd68073bc3f);
$parcel$export(module.exports, "insertCells", () => $61689dc703b4f6c3$export$e0b94385c1fdc132);
// Utilities used for copy/paste handling.
//
// This module handles pasting cell content into tables, or pasting
// anything into a cell selection, as replacing a block of cells with
// the content of the selection. When pasting cells into a cell, that
// involves placing the block of pasted content so that its top left
// aligns with the selection cell, optionally extending the table to
// the right or bottom to make sure it is large enough. Pasting into a
// cell selection is different, here the cells in the selection are
// clipped to the selection's rectangle, optionally repeating the
// pasted cells when they are smaller than the selection.

var $3xw6l = parcelRequire("3xw6l");

var $lzEKq = parcelRequire("lzEKq");

var $cwzAY = parcelRequire("cwzAY");

var $2vA54 = parcelRequire("2vA54");

var $9K0SW = parcelRequire("9K0SW");

var $4fn0w = parcelRequire("4fn0w");

var $3n5hT = parcelRequire("3n5hT");

var $RshmT = parcelRequire("RshmT");
// Utilities to help with copying and pasting table cells
/**
 * Replace any header cells with table cells.
 *
 * @param schema
 * @param cells
 * @returns Fragment with header cells converted to table cells
 */ function $61689dc703b4f6c3$var$stripHeaderType(schema, cells) {
    const newCells = [];
    cells.forEach((cell)=>{
        // Convert to cell type if not already
        const cellNodeType = (0, $3n5hT.tableNodeTypes)(schema).cell;
        const tableCell = cell.type === cellNodeType ? cell : cellNodeType.createAndFill(cell.attrs, cell.content, cell.marks) ?? cell;
        newCells.push(tableCell);
    });
    return (0, $3xw6l.Fragment).from(newCells);
}
function $61689dc703b4f6c3$export$f6d8f52489457fc4(slice) {
    if (!slice.size) return null;
    let { content: content, openStart: openStart, openEnd: openEnd } = slice;
    if (!content.firstChild) throw new Error('pastedCells: no firstChild defined for content');
    while(content.childCount === 1 && (openStart > 0 && openEnd > 0 || content.firstChild.type.spec.tableRole === 'table')){
        openStart--;
        openEnd--;
        content = content.firstChild.content;
        if (!content.firstChild) throw new Error('pastedCells: no firstChild defined for content');
    }
    const first = content.firstChild;
    const role = first.type.spec.tableRole;
    const { schema: schema } = first.type;
    const rows = [];
    if (role === 'row') for(let i = 0; i < content.childCount; i++){
        let cells = content.child(i).content;
        const left = i ? 0 : Math.max(0, openStart - 1);
        const right = i < content.childCount - 1 ? 0 : Math.max(0, openEnd - 1);
        if (left || right) cells = $61689dc703b4f6c3$export$f09c6b3b06d884fb((0, $3n5hT.tableNodeTypes)(schema).row, new (0, $3xw6l.Slice)(cells, left, right)).content;
        rows.push(cells);
    }
    else if (role === 'cell' || role === 'header_cell') rows.push(openStart || openEnd ? $61689dc703b4f6c3$export$f09c6b3b06d884fb((0, $3n5hT.tableNodeTypes)(schema).row, new (0, $3xw6l.Slice)(content, openStart, openEnd)).content : content);
    else return null;
    const rowsWithoutHeaders = rows.map((row)=>$61689dc703b4f6c3$var$stripHeaderType(schema, row));
    return $61689dc703b4f6c3$var$ensureRectangular(schema, rowsWithoutHeaders);
}
// : (Schema, [Fragment]) → {width: number, height: number, rows: [Fragment]}
// Compute the width and height of a set of cells, and make sure each
// row has the same number of cells.
function $61689dc703b4f6c3$var$ensureRectangular(schema, rowsFragment) {
    const rows = rowsFragment;
    const widths = [];
    for(let i = 0; i < rows.length; i++){
        const row = rows[i];
        for(let j = row.childCount - 1; j >= 0; j--){
            const { rowspan: rowspan, colspan: colspan } = row.child(j).attrs;
            for(let r = i; r < i + rowspan; r++)widths[r] = (widths[r] || 0) + colspan;
        }
    }
    let width = 0;
    for(let r = 0; r < widths.length; r++)width = Math.max(width, widths[r]);
    for(let r = 0; r < widths.length; r++){
        if (r >= rows.length) rows.push((0, $3xw6l.Fragment).empty);
        if (widths[r] < width) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const empty = (0, $3n5hT.tableNodeTypes)(schema).cell.createAndFill();
            const cells = [];
            for(let i = widths[r]; i < width; i++)cells.push(empty);
            rows[r] = rows[r].append((0, $3xw6l.Fragment).from(cells));
        }
    }
    return {
        height: rows.length,
        width: width,
        rows: rows
    };
}
function $61689dc703b4f6c3$export$f09c6b3b06d884fb(nodeType, slice) {
    const node = nodeType.createAndFill();
    if (!node) throw new Error(`fitSlice: unable to create node`);
    const tr = new (0, $lzEKq.Transform)(node).replace(0, node.content.size, slice);
    return tr.doc;
}
function $61689dc703b4f6c3$export$cdcebd68073bc3f({ width: currentWidth, height: currentHeight, rows: currentRows }, newWidth, newHeight) {
    let rows = currentRows;
    let width = currentWidth;
    let height = currentHeight;
    if (width !== newWidth) {
        const added = [];
        const newRows = [];
        for(let row = 0; row < rows.length; row++){
            const frag = rows[row];
            const cells = [];
            for(let col = added[row] || 0, i = 0; col < newWidth; i++){
                let cell = frag.child(i % frag.childCount);
                if (col + cell.attrs.colspan > newWidth) cell = cell.type.create((0, $9K0SW.removeColSpan)(cell.attrs, cell.attrs.colspan, col + cell.attrs.colspan - newWidth), cell.content);
                cells.push(cell);
                col += cell.attrs.colspan;
                for(let j = 1; j < cell.attrs.rowspan; j++)added[row + j] = (added[row + j] || 0) + cell.attrs.colspan;
            }
            newRows.push((0, $3xw6l.Fragment).from(cells));
        }
        rows = newRows;
        width = newWidth;
    }
    if (height !== newHeight) {
        const newRows = [];
        for(let row = 0, i = 0; row < newHeight; row++, i++){
            const cells = [];
            const source = rows[i % height];
            for(let j = 0; j < source.childCount; j++){
                let cell = source.child(j);
                if (row + cell.attrs.rowspan > newHeight) cell = cell.type.create({
                    ...cell.attrs,
                    rowspan: Math.max(1, newHeight - cell.attrs.rowspan)
                }, cell.content);
                cells.push(cell);
            }
            newRows.push((0, $3xw6l.Fragment).from(cells));
        }
        rows = newRows;
        height = newHeight;
    }
    return {
        width: width,
        height: height,
        rows: rows
    };
}
// Make sure a table has at least the given width and height. Return
// true if something was changed.
function $61689dc703b4f6c3$var$growTable(tr, map, table, start, width, height, mapFrom) {
    const { schema: schema } = tr.doc.type;
    const types = (0, $3n5hT.tableNodeTypes)(schema);
    let empty;
    let emptyHead;
    if (width > map.width) for(let row = 0, rowEnd = 0; row < map.height; row++){
        const rowNode = table.child(row);
        rowEnd += rowNode.nodeSize;
        const cells = [];
        let add;
        if (rowNode.lastChild == null || rowNode.lastChild.type === types.cell) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        add = empty || (empty = types.cell.createAndFill());
        else // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        add = emptyHead || (emptyHead = types.header_cell.createAndFill());
        for(let i = map.width; i < width; i++)cells.push(add);
        tr.insert(tr.mapping.slice(mapFrom).map(rowEnd - 1 + start), cells);
    }
    if (height > map.height) {
        const cells = [];
        for(let i = 0, k = (map.height - 1) * map.width; i < Math.max(map.width, width); i++){
            let header;
            if (i >= map.width) header = false;
            else {
                const mappedPos = map.map[k + i];
                const node = table.nodeAt(mappedPos);
                if (!node) throw new Error(`growTable: no node found at pos ${mappedPos}`);
                header = node.type === types.header_cell;
            }
            cells.push(header ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            emptyHead || (emptyHead = types.header_cell.createAndFill()) : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            empty || (empty = types.cell.createAndFill()));
        }
        const emptyRow = types.row.create(null, (0, $3xw6l.Fragment).from(cells));
        const rows = [];
        for(let i = map.height; i < height; i++)rows.push(emptyRow);
        tr.insert(tr.mapping.slice(mapFrom).map(start + table.nodeSize - 2), rows);
    }
    return !!(empty || emptyHead);
}
// Make sure the given line (left, top) to (right, top) doesn't cross
// any rowspan cells by splitting cells that cross it. Return true if
// something changed.
function $61689dc703b4f6c3$var$isolateHorizontal(tr, map, table, start, left, right, top, mapFrom) {
    if (top === 0 || top === map.height) return false;
    let found = false;
    for(let col = left; col < right; col++){
        const index = top * map.width + col;
        const pos = map.map[index];
        if (map.map[index - map.width] === pos) {
            found = true;
            const cell = table.nodeAt(pos);
            if (!cell) throw new Error(`isolateHorizontal: no cell found at pos ${pos}`);
            const { top: cellTop, left: cellLeft } = map.findCell(pos);
            tr.setNodeMarkup(tr.mapping.slice(mapFrom).map(pos + start), undefined, {
                ...cell.attrs,
                rowspan: top - cellTop
            });
            const newCell = cell.type.createAndFill({
                ...cell.attrs,
                rowspan: cellTop + cell.attrs.rowspan - top
            });
            if (!newCell) throw new Error('isolateHorizontal: failed to create cell');
            tr.insert(tr.mapping.slice(mapFrom).map(map.positionAt(top, cellLeft, table)), newCell);
            col += cell.attrs.colspan - 1;
        }
    }
    return found;
}
// Make sure the given line (left, top) to (left, bottom) doesn't
// cross any colspan cells by splitting cells that cross it. Return
// true if something changed.
function $61689dc703b4f6c3$var$isolateVertical(tr, map, table, start, top, bottom, left, mapFrom) {
    if (left === 0 || left === map.width) return false;
    let found = false;
    for(let row = top; row < bottom; row++){
        const index = row * map.width + left;
        const pos = map.map[index];
        if (map.map[index - 1] === pos) {
            found = true;
            const cell = table.nodeAt(pos);
            if (!cell) throw new Error(`isolateVertical: could not find cell at pos ${pos}`);
            const cellLeft = map.colCount(pos);
            const updatePos = tr.mapping.slice(mapFrom).map(pos + start);
            tr.setNodeMarkup(updatePos, undefined, (0, $9K0SW.removeColSpan)(cell.attrs, left - cellLeft, cell.attrs.colspan - (left - cellLeft)));
            const newCell = cell.type.createAndFill((0, $9K0SW.removeColSpan)(cell.attrs, 0, left - cellLeft));
            if (!newCell) throw new Error('isolateVertical: failed to create cell');
            tr.insert(updatePos + cell.nodeSize, newCell);
            row += cell.attrs.rowspan - 1;
        }
    }
    return found;
}
function $61689dc703b4f6c3$var$applyHeaderCells(tr, tableMap, state, tableStart, table, headerRowEnabled, headerColumnEnabled) {
    const { schema: schema } = state;
    const setMarkup = (tr, row, col, headerEnabled)=>{
        const cellPos = tableStart + tableMap.positionAt(row, col, table);
        const cell = tr.doc.nodeAt(cellPos);
        const newType = headerEnabled ? schema.nodes.tableHeader : schema.nodes.tableCell;
        const isCellTypeChanged = newType !== cell?.type;
        const isCellTypeValid = !!cell && [
            schema.nodes.tableCell,
            schema.nodes.tableHeader
        ].includes(cell.type);
        if (isCellTypeChanged && isCellTypeValid) tr.setNodeMarkup(cellPos, newType, cell?.attrs, cell?.marks);
    };
    // For row === 0 && col === 0 it is enabled if either are enabled
    setMarkup(tr, 0, 0, headerColumnEnabled || headerRowEnabled);
    // Header Column
    for(let col = 1; col < tableMap.width; col++)setMarkup(tr, 0, col, headerRowEnabled);
    // Header Row
    for(let row = 1; row < tableMap.height; row++)setMarkup(tr, row, 0, headerColumnEnabled);
}
function $61689dc703b4f6c3$export$e0b94385c1fdc132(state, dispatch, tableStart, rect, cells) {
    let table = state.doc;
    const newRect = (0, $4fn0w.selectedRect)(state);
    const types = (0, $3n5hT.tableNodeTypes)(state.schema);
    // Get if the header row and column are enabled on the original table
    const headerRowEnabled = (0, $RshmT.isHeaderEnabledByType)('row', newRect, types);
    const headerColumnEnabled = (0, $RshmT.isHeaderEnabledByType)('column', newRect, types);
    if (tableStart) {
        table = state.doc.nodeAt(tableStart - 1);
        if (!table) throw new Error(`insertCells: could not find table at pos ${tableStart - 1}`);
    }
    let map = (0, $2vA54.TableMap).get(table);
    const { top: top, left: left } = rect;
    const right = left + cells.width;
    const bottom = top + cells.height;
    const { tr: tr } = state;
    let mapFrom = 0;
    function recomp() {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        table = tableStart ? tr.doc.nodeAt(tableStart - 1) : tr.doc;
        map = (0, $2vA54.TableMap).get(table);
        mapFrom = tr.mapping.maps.length;
    }
    // Prepare the table to be large enough and not have any cells
    // crossing the boundaries of the rectangle that we want to
    // insert into. If anything about it changes, recompute the table
    // map so that subsequent operations can see the current shape.
    if ($61689dc703b4f6c3$var$growTable(tr, map, table, tableStart, right, bottom, mapFrom)) recomp();
    if ($61689dc703b4f6c3$var$isolateHorizontal(tr, map, table, tableStart, left, right, top, mapFrom)) recomp();
    if ($61689dc703b4f6c3$var$isolateHorizontal(tr, map, table, tableStart, left, right, bottom, mapFrom)) recomp();
    if ($61689dc703b4f6c3$var$isolateVertical(tr, map, table, tableStart, top, bottom, left, mapFrom)) recomp();
    if ($61689dc703b4f6c3$var$isolateVertical(tr, map, table, tableStart, top, bottom, right, mapFrom)) recomp();
    for(let row = top; row < bottom; row++){
        const from = map.positionAt(row, left, table);
        const to = map.positionAt(row, right, table);
        tr.replace(tr.mapping.slice(mapFrom).map(from + tableStart), tr.mapping.slice(mapFrom).map(to + tableStart), new (0, $3xw6l.Slice)(cells.rows[row - top], 0, 0));
    }
    recomp();
    $61689dc703b4f6c3$var$applyHeaderCells(tr, map, state, tableStart, table, headerRowEnabled, headerColumnEnabled);
    tr.setSelection(new (0, $cwzAY.CellSelection)(tr.doc.resolve(tableStart + map.map[top * map.width + left]), tr.doc.resolve(tableStart + map.map[(bottom - 1) * map.width + right - 1])));
    dispatch(tr);
}

});
parcelRegister("RshmT", function(module, exports) {
$parcel$export(module.exports, "isHeaderEnabledByType", () => $7fc921fd6f4a57e0$export$96946e3333d0ccc6);
$parcel$export(module.exports, "toggleHeader", () => $7fc921fd6f4a57e0$export$dee0ccd8d8f5a56e);

var $2vA54 = parcelRequire("2vA54");

var $4fn0w = parcelRequire("4fn0w");

var $3n5hT = parcelRequire("3n5hT");

var $7lSnz = parcelRequire("7lSnz");
function $7fc921fd6f4a57e0$export$96946e3333d0ccc6(type, rect, types) {
    // Get cell positions for first row or first column
    const cellPositions = rect.map.cellsInRect({
        left: 0,
        top: 0,
        right: type === 'row' ? rect.map.width : 1,
        bottom: type === 'column' ? rect.map.height : 1
    });
    for(let i = 0; i < cellPositions.length; i++){
        const cell = rect.table.nodeAt(cellPositions[i]);
        if (cell && cell.type !== types.header_cell) return false;
    }
    return true;
}
function $7fc921fd6f4a57e0$export$dee0ccd8d8f5a56e(type) {
    return function(state, dispatch) {
        if (!(0, $7lSnz.isInTable)(state)) return false;
        if (dispatch) {
            const types = (0, $3n5hT.tableNodeTypes)(state.schema);
            const rect = (0, $4fn0w.selectedRect)(state), tr = state.tr;
            const isHeaderRowEnabled = $7fc921fd6f4a57e0$export$96946e3333d0ccc6('row', rect, types);
            const isHeaderColumnEnabled = $7fc921fd6f4a57e0$export$96946e3333d0ccc6('column', rect, types);
            const isHeaderEnabled = type === 'column' ? isHeaderRowEnabled : type === 'row' ? isHeaderColumnEnabled : false;
            const selectionStartsAt = isHeaderEnabled ? 1 : 0;
            const cellsRect = type === 'column' ? new (0, $2vA54.Rect)(0, selectionStartsAt, 1, rect.map.height) : type === 'row' ? new (0, $2vA54.Rect)(selectionStartsAt, 0, rect.map.width, 1) : rect;
            let newType;
            if (type === 'column') newType = isHeaderColumnEnabled ? types.cell : types.header_cell;
            else if (type === 'row') newType = isHeaderRowEnabled ? types.cell : types.header_cell;
            else newType = types.cell;
            rect.map.cellsInRect(cellsRect).forEach((relativeCellPos)=>{
                const cellPos = relativeCellPos + rect.tableStart;
                const cell = tr.doc.nodeAt(cellPos);
                if (cell) tr.setNodeMarkup(cellPos, newType, cell.attrs);
            });
            dispatch(tr);
        }
        return true;
    };
}

});



parcelRegister("6UQpI", function(module, exports) {
$parcel$export(module.exports, "PastePluginActionTypes", () => $dd0a13d89c3f070e$export$ad3c0356f902fd97);
var $dd0a13d89c3f070e$export$ad3c0356f902fd97 = /*#__PURE__*/ function(PastePluginActionTypes) {
    PastePluginActionTypes["START_TRACKING_PASTED_MACRO_POSITIONS"] = "START_TRACKING_PASTED_MACRO_POSITIONS";
    PastePluginActionTypes["STOP_TRACKING_PASTED_MACRO_POSITIONS"] = "STOP_TRACKING_PASTED_MACRO_POSITIONS";
    PastePluginActionTypes["ON_PASTE"] = "ON_PASTE";
    return PastePluginActionTypes;
}({});

});

parcelRegister("1CqHB", function(module, exports) {
$parcel$export(module.exports, "startTrackingPastedMacroPositions", () => $ac53801a06635672$export$4a47d257a3fdbe1c);
$parcel$export(module.exports, "stopTrackingPastedMacroPositions", () => $ac53801a06635672$export$68f98dcea8e59d59);
$parcel$export(module.exports, "upgradeTextToLists", () => $ac53801a06635672$export$df231bdf1595dd19);
$parcel$export(module.exports, "splitParagraphs", () => $ac53801a06635672$export$f2dc3112f5c2bd10);

var $fCXIH = parcelRequire("fCXIH");
var $gbisc = parcelRequire("gbisc");

var $dEkUJ = parcelRequire("dEkUJ");

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $6UQpI = parcelRequire("6UQpI");

var $3Elhj = parcelRequire("3Elhj");
const $ac53801a06635672$export$4a47d257a3fdbe1c = (pastedMacroPositions)=>(0, $3Elhj.createCommand)(()=>{
        return {
            type: (0, $6UQpI.PastePluginActionTypes).START_TRACKING_PASTED_MACRO_POSITIONS,
            pastedMacroPositions: pastedMacroPositions
        };
    });
const $ac53801a06635672$export$68f98dcea8e59d59 = (pastedMacroPositionKeys)=>(0, $3Elhj.createCommand)(()=>{
        return {
            type: (0, $6UQpI.PastePluginActionTypes).STOP_TRACKING_PASTED_MACRO_POSITIONS,
            pastedMacroPositionKeys: pastedMacroPositionKeys
        };
    });
// matchers for text lists
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ac53801a06635672$var$bullets = /^\s*[\*\-\u2022](\s+|\s+$)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ac53801a06635672$var$numbers = /^\s*\d[\.\)](\s+|$)/;
const $ac53801a06635672$var$isListItem = (node, schema)=>{
    return Boolean(node && node.type === schema.nodes.listItem);
};
const $ac53801a06635672$var$getListType = (node, schema)=>{
    if (!node || !node.text) return null;
    const { bulletList: bulletList, orderedList: orderedList } = schema.nodes;
    return [
        {
            node: bulletList,
            matcher: $ac53801a06635672$var$bullets
        },
        {
            node: orderedList,
            matcher: $ac53801a06635672$var$numbers
        }
    ].reduce((lastMatch, listType)=>{
        if (lastMatch) return lastMatch;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const match = node.text.match(listType.matcher);
        return match ? [
            listType.node,
            match[0].length
        ] : lastMatch;
    }, null);
};
const $ac53801a06635672$export$252a79c29aea3669 = (content, schema)=>{
    const wrapperContent = [];
    let nextContent = [];
    content.forEach((node)=>{
        if (node.type === schema.nodes.hardBreak) {
            if (nextContent.length !== 0) wrapperContent.push(nextContent);
            nextContent = [
                node
            ];
        } else nextContent.push(node);
    });
    wrapperContent.push(nextContent);
    return wrapperContent;
};
const $ac53801a06635672$export$5bfe14e0df30e39c = (node, parent, schema)=>{
    const content = (0, $gbisc.mapChildren)(node.content, (node)=>node);
    const linesSplitByHardbreaks = $ac53801a06635672$export$252a79c29aea3669(content, schema);
    const { paragraph: paragraph, hardBreak: hardBreak, listItem: listItem, orderedList: orderedList } = schema.nodes;
    const splitListsAndParagraphs = [];
    let paragraphParts = [];
    // Ignored via go/ees005
    // eslint-disable-next-line no-var
    for(var index = 0; index < linesSplitByHardbreaks.length; index = index + 1){
        const line = linesSplitByHardbreaks[index];
        let listMatch;
        if (index === 0) {
            if (line[0]?.type === hardBreak) {
                paragraphParts.push(line);
                continue;
            } else // the first line the potential list item is at postion 0
            listMatch = $ac53801a06635672$var$getListType(line[0], schema);
        } else {
            // lines after the first the potential list item is at postion 1
            if (line.length === 1) {
                // if the line only has a line break return as is
                paragraphParts.push(line);
                continue;
            }
            listMatch = $ac53801a06635672$var$getListType(line[1], schema);
        }
        if (!listMatch || // CONFCLOUD-79708: If we are inside a list - let's not try to upgrade list as it resolves
        // to invalid content
        $ac53801a06635672$var$isListItem(parent, schema)) {
            // if there is not list match return as is
            paragraphParts.push(line);
            continue;
        }
        const [nodeType, length] = listMatch;
        const firstNonHardBreakNode = line.find((node)=>node.type !== hardBreak);
        const chunksWithoutLeadingHardBreaks = line.slice(line.findIndex((node)=>node.type !== hardBreak));
        // retain text after bullet or number-dot e.g. 1. Hello
        const startingText = firstNonHardBreakNode?.text?.substr(length);
        const restOfChunk = startingText ? [
            schema.text(startingText, firstNonHardBreakNode?.marks),
            ...chunksWithoutLeadingHardBreaks.slice(1)
        ] : chunksWithoutLeadingHardBreaks.slice(1);
        // convert to list
        const listItemNode = listItem?.createAndFill(undefined, paragraph.createChecked(undefined, restOfChunk));
        if (!listItemNode) {
            paragraphParts.push(line);
            continue;
        }
        const attrs = nodeType === orderedList ? {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            order: parseInt(firstNonHardBreakNode.text.split('.')[0])
        } : undefined;
        const newList = nodeType.createChecked(attrs, [
            listItemNode
        ]);
        if (paragraphParts.length !== 0 && paragraph.validContent((0, $3xw6l.Fragment).from(paragraphParts.flat()))) {
            splitListsAndParagraphs.push(paragraph.createAndFill(node.attrs, paragraphParts.flat(), node.marks));
            paragraphParts = [];
        }
        splitListsAndParagraphs.push(newList);
    }
    if (paragraphParts.length !== 0 && paragraph.validContent((0, $3xw6l.Fragment).from(paragraphParts.flat()))) splitListsAndParagraphs.push(schema.nodes.paragraph.createAndFill(node.attrs, paragraphParts.flat(), node.marks));
    const result = splitListsAndParagraphs.flat();
    // try to join
    const mockState = (0, $3lIcL.EditorState).create({
        schema: schema
    });
    let joinedListsTr;
    const mockDispatch = (tr)=>{
        joinedListsTr = tr;
    };
    // Return false to prevent replaceWith from wrapping the text node in a paragraph
    // paragraph since that will be done later. If it's done here, it will fail
    // the paragraph.validContent check.
    // Dont return false if there are lists, as they arent validContent for paragraphs
    // and will result in hanging textNodes
    (0, $dEkUJ.autoJoin)((state, dispatch)=>{
        if (!dispatch) return false;
        const containsList = result.some((node)=>node.type === schema.nodes.bulletList || node.type === schema.nodes.orderedList);
        if (result.some((node)=>node.isText) && !containsList) return false;
        dispatch(state.tr.replaceWith(0, 2, result));
        return true;
    }, (before, after)=>(0, $fCXIH.isListNode)(before) && (0, $fCXIH.isListNode)(after))(mockState, mockDispatch);
    const fragment = joinedListsTr ? joinedListsTr.doc.content : (0, $3xw6l.Fragment).from(result);
    return fragment;
};
const $ac53801a06635672$export$df231bdf1595dd19 = (slice, schema)=>{
    return (0, $gbisc.mapSlice)(slice, (node, parent)=>{
        if (node.type === schema.nodes.paragraph) return $ac53801a06635672$export$5bfe14e0df30e39c(node, parent, schema);
        return node;
    });
};
const $ac53801a06635672$export$f2dc3112f5c2bd10 = (slice, schema)=>{
    // exclude Text nodes with a code mark, since we transform those later
    // into a codeblock
    let hasCodeMark = false;
    slice.content.forEach((child)=>{
        hasCodeMark = hasCodeMark || child.marks.some((mark)=>mark.type === schema.marks.code);
    });
    // slice might just be a raw text string
    if (schema.nodes.paragraph.validContent(slice.content) && !hasCodeMark) {
        const replSlice = $ac53801a06635672$export$b2e3d6bb71a327f1({
            fragment: slice.content,
            schema: schema
        });
        return new (0, $3xw6l.Slice)(replSlice, slice.openStart + 1, slice.openEnd + 1);
    }
    return (0, $gbisc.mapSlice)(slice, (node)=>{
        if (node.type === schema.nodes.paragraph) return $ac53801a06635672$export$b2e3d6bb71a327f1({
            fragment: node.content,
            blockMarks: node.marks,
            schema: schema
        });
        return node;
    });
};
const $ac53801a06635672$export$b2e3d6bb71a327f1 = ({ fragment: fragment, blockMarks: blockMarks = [], schema: schema })=>{
    const paragraphs = [];
    let curChildren = [];
    let lastNode = null;
    const { hardBreak: hardBreak, paragraph: paragraph } = schema.nodes;
    fragment.forEach((node, i)=>{
        const isNodeValidContentForParagraph = schema.nodes.paragraph.validContent((0, $3xw6l.Fragment).from(node));
        if (!isNodeValidContentForParagraph) {
            paragraphs.push(node);
            return;
        }
        // ED-14725 Fixed the issue that it make duplicated line
        // when pasting <br /> from google docs.
        if (i === 0 && node.type === hardBreak) {
            paragraphs.push(paragraph.createChecked(undefined, curChildren, [
                ...blockMarks
            ]));
            lastNode = node;
            return;
        } else if (lastNode && lastNode.type === hardBreak && node.type === hardBreak) {
            // double hardbreak
            // backtrack a little; remove the trailing hardbreak we added last loop
            curChildren.pop();
            // create a new paragraph
            paragraphs.push(paragraph.createChecked(undefined, curChildren, [
                ...blockMarks
            ]));
            curChildren = [];
            return;
        }
        // add to this paragraph
        curChildren.push(node);
        lastNode = node;
    });
    if (curChildren.length) paragraphs.push(paragraph.createChecked(undefined, curChildren, [
        ...blockMarks
    ]));
    return (0, $3xw6l.Fragment).from(paragraphs.length ? paragraphs : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    [
        paragraph.createAndFill(undefined, undefined, [
            ...blockMarks
        ])
    ]);
};

});
parcelRegister("3Elhj", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $d82332805bdbc0be$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "createPluginState", () => $d82332805bdbc0be$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $d82332805bdbc0be$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $d82332805bdbc0be$export$f05434c51e3762e);

var $bazog = parcelRequire("bazog");

var $3lIcL = parcelRequire("3lIcL");

var $9SwZE = parcelRequire("9SwZE");
const $d82332805bdbc0be$export$18d4026d1ea86bb1 = new (0, $3lIcL.PluginKey)('pastePlugin');
const { createPluginState: $d82332805bdbc0be$export$656c7661095efe2e, createCommand: $d82332805bdbc0be$export$8d4021544bdece00, getPluginState: $d82332805bdbc0be$export$f05434c51e3762e } = (0, $bazog.pluginFactory)($d82332805bdbc0be$export$18d4026d1ea86bb1, (0, $9SwZE.reducer), {
    mapping: (tr, pluginState)=>{
        if (tr.docChanged) {
            let atLeastOnePositionChanged = false;
            const positionsMappedThroughChanges = Object.entries(pluginState.pastedMacroPositions).reduce((acc, [key, position])=>{
                const mappedPosition = tr.mapping.map(position);
                if (position !== mappedPosition) atLeastOnePositionChanged = true;
                acc[key] = tr.mapping.map(position);
                return acc;
            }, {});
            if (atLeastOnePositionChanged) return {
                ...pluginState,
                pastedMacroPositions: positionsMappedThroughChanges
            };
        }
        return pluginState;
    }
});

});
parcelRegister("9SwZE", function(module, exports) {
$parcel$export(module.exports, "reducer", () => $55714805b49ba3de$export$1650419e431d3ba3);

var $6UQpI = parcelRequire("6UQpI");
const $55714805b49ba3de$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case (0, $6UQpI.PastePluginActionTypes).START_TRACKING_PASTED_MACRO_POSITIONS:
            return {
                ...state,
                pastedMacroPositions: {
                    ...state.pastedMacroPositions,
                    ...action.pastedMacroPositions
                }
            };
        case (0, $6UQpI.PastePluginActionTypes).STOP_TRACKING_PASTED_MACRO_POSITIONS:
            {
                const filteredMacroPositions = Object.fromEntries(Object.entries(state.pastedMacroPositions).filter(([key])=>!action.pastedMacroPositionKeys.includes(key)));
                return {
                    ...state,
                    pastedMacroPositions: filteredMacroPositions
                };
            }
        case (0, $6UQpI.PastePluginActionTypes).ON_PASTE:
            return {
                ...state,
                lastContentPasted: action.contentPasted
            };
        default:
            return state;
    }
};

});



parcelRegister("5pNJd", function(module, exports) {
$parcel$export(module.exports, "transformSliceForMedia", () => $f04cfeb9928ddc35$export$5ed9534d355a0a0f);
$parcel$export(module.exports, "transformSliceToCorrectMediaWrapper", () => $f04cfeb9928ddc35$export$bd95a8dd607682c8);
$parcel$export(module.exports, "transformSliceToMediaSingleWithNewExperience", () => $f04cfeb9928ddc35$export$77944619eaa3fcd3);
$parcel$export(module.exports, "unwrapNestedMediaElements", () => $f04cfeb9928ddc35$export$3b69af3aaae9ee54);

var $1I3aa = parcelRequire("1I3aa");

var $gbisc = parcelRequire("gbisc");
var $7SIsS = parcelRequire("7SIsS");

var $BmspC = parcelRequire("BmspC");

var $3xaEP = parcelRequire("3xaEP");
function $f04cfeb9928ddc35$export$5ed9534d355a0a0f(slice, schema, api) {
    const { mediaSingle: mediaSingle, layoutSection: layoutSection, table: table, bulletList: bulletList, orderedList: orderedList, expand: expand, nestedExpand: nestedExpand } = schema.nodes;
    return (selection)=>{
        let newSlice = slice;
        if ((0, $BmspC.hasParentNodeOfType)([
            layoutSection,
            table,
            bulletList,
            orderedList,
            expand,
            nestedExpand
        ])(selection)) newSlice = (0, $gbisc.mapSlice)(newSlice, (node)=>{
            const mediaState = api?.media?.sharedState.currentState();
            const extendedOrLegacyAttrs = mediaState?.mediaOptions?.allowPixelResizing ? {
                layout: node.attrs.layout,
                widthType: node.attrs.widthType,
                width: node.attrs.width
            } : {
                layout: node.attrs.layout
            };
            let attrs = {};
            if ((0, $BmspC.hasParentNodeOfType)([
                layoutSection,
                table
            ])(selection)) // Supports layouts
            attrs = {
                ...extendedOrLegacyAttrs
            };
            else if ((0, $BmspC.hasParentNodeOfType)([
                bulletList,
                orderedList,
                expand,
                nestedExpand
            ])(selection)) // does not support other layouts
            attrs = {
                ...extendedOrLegacyAttrs,
                layout: 'center'
            };
            return node.type.name === 'mediaSingle' ? mediaSingle.createChecked(attrs, node.content, node.marks) : node;
        });
        return newSlice;
    };
}
const $f04cfeb9928ddc35$export$fb85bc5d6d9ef19b = (fileType)=>{
    return !!fileType && (fileType.indexOf('image/') > -1 || fileType.indexOf('video/') > -1);
};
const $f04cfeb9928ddc35$export$bd95a8dd607682c8 = (slice, schema)=>{
    const { mediaGroup: mediaGroup, mediaSingle: mediaSingle, media: media } = schema.nodes;
    return (0, $gbisc.mapSlice)(slice, (node, parent)=>{
        if (!parent && node.type === media) {
            if (mediaSingle && ($f04cfeb9928ddc35$export$fb85bc5d6d9ef19b(node.attrs.__fileMimeType) || node.attrs.type === 'external')) return mediaSingle.createChecked({}, node);
            else return mediaGroup.createChecked({}, [
                node
            ]);
        }
        return node;
    });
};
const $f04cfeb9928ddc35$export$77944619eaa3fcd3 = (slice, schema, api)=>{
    const { mediaInline: mediaInline, mediaSingle: mediaSingle, media: media } = schema.nodes;
    const newSlice = (0, $gbisc.mapSlice)(slice, (node)=>{
        // This logic is duplicated in editor-plugin-ai where external images can be inserted
        // from external sources through the use of AI.  The editor-plugin-ai package is avoiding
        // sharing dependencies with editor-core to support products using it with various versions
        // of editor packages.
        // The duplication is in the following file:
        // packages/editor/editor-plugin-ai/src/prebuilt/content-transformers/markdown-to-pm/markdown-transformer.ts
        if (node.type === mediaSingle) {
            const mediaState = api?.media?.sharedState.currentState();
            return mediaState?.mediaOptions?.allowPixelResizing ? mediaSingle.createChecked({
                width: node.attrs.width || (0, $1I3aa.DEFAULT_IMAGE_WIDTH),
                widthType: node.attrs.widthType || 'pixel',
                layout: node.attrs.layout
            }, node.content, node.marks) : node;
        }
        return node;
    });
    return (0, $gbisc.mapSlice)(newSlice, (node)=>{
        const __mediaTraceId = (0, $3xaEP.getRandomHex)(8);
        if (node.type === media) {
            api?.core.actions.execute(api?.media?.commands.trackMediaPaste(node.attrs));
            return media.createChecked({
                ...node.attrs,
                __external: node.attrs.type === 'external',
                __mediaTraceId: node.attrs.type === 'external' ? null : __mediaTraceId
            }, node.content, node.marks);
        }
        if (node.type.name === 'mediaInline') {
            api?.core.actions.execute(api?.media?.commands.trackMediaPaste(node.attrs));
            return mediaInline.createChecked({
                ...node.attrs,
                __mediaTraceId: __mediaTraceId
            }, node.content, node.marks);
        }
        return node;
    });
};
/**
 * Check base styles to see if an element will be invisible when rendered in a document.
 * @param element
 */ const $f04cfeb9928ddc35$var$isElementInvisible = (element)=>{
    return element.style.opacity === '0' || element.style.display === 'none' || element.style.visibility === 'hidden';
};
const $f04cfeb9928ddc35$var$VALID_TAGS_CONTAINER = [
    'DIV',
    'TD',
    'BLOCKQUOTE'
];
function $f04cfeb9928ddc35$var$canContainImage(element) {
    if (!element) return false;
    return $f04cfeb9928ddc35$var$VALID_TAGS_CONTAINER.indexOf(element.tagName) !== -1;
}
const $f04cfeb9928ddc35$export$3b69af3aaae9ee54 = (html)=>{
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const wrapper = doc.body;
    // Remove Google Doc's wrapper <b> el
    const docsWrapper = wrapper.querySelector('b[id^="docs-internal-guid-"]');
    if (docsWrapper) (0, $7SIsS.unwrap)(wrapper, docsWrapper);
    const imageTags = wrapper.querySelectorAll('img');
    if (!imageTags.length) return html;
    imageTags.forEach((imageTag)=>{
        // Capture the immediate parent, we may remove the media from here later.
        const mediaParent = imageTag.parentElement;
        if (!mediaParent) return;
        // If either the parent or the image itself contains styles that would make
        // them invisible on copy, dont paste them.
        if ($f04cfeb9928ddc35$var$isElementInvisible(mediaParent) || $f04cfeb9928ddc35$var$isElementInvisible(imageTag)) {
            mediaParent.removeChild(imageTag);
            return;
        }
        // If its wrapped by a valid container we assume its safe to bypass.
        // ProseMirror should handle these cases properly.
        if ($f04cfeb9928ddc35$var$canContainImage(mediaParent) || mediaParent instanceof HTMLSpanElement && mediaParent.closest('[class*="emoji-common"]')) return;
        // Find the top most element that the parent has a valid container for the image.
        // Stop just before found the wrapper
        const insertBeforeElement = (0, $7SIsS.walkUpTreeUntil)(mediaParent, (element)=>{
            // If is at the top just use this element as reference
            if (element.parentElement === wrapper) return true;
            return $f04cfeb9928ddc35$var$canContainImage(element.parentElement);
        });
        // Here we try to insert the media right after its top most valid parent element
        // Unless its the last element in our structure then we will insert above it.
        if (insertBeforeElement && insertBeforeElement.parentElement) {
            // Insert as close as possible to the most closest valid element index in the tree.
            insertBeforeElement.parentElement.insertBefore(imageTag, insertBeforeElement.nextElementSibling || insertBeforeElement);
            // Attempt to clean up lines left behind by the image
            mediaParent.innerText = mediaParent.innerText.trim();
            // Walk up and delete empty elements left over after removing the image tag
            (0, $7SIsS.removeNestedEmptyEls)(mediaParent);
        }
    });
    // If last child is a hardbreak we don't want it
    if (wrapper.lastElementChild && wrapper.lastElementChild.tagName === 'BR') wrapper.removeChild(wrapper.lastElementChild);
    return wrapper.innerHTML;
};

});

parcelRegister("3kq4u", function(module, exports) {
$parcel$export(module.exports, "sendPasteAnalyticsEvent", () => $4cfeb607ceb33f88$export$5ee87eef0a304a1b);
$parcel$export(module.exports, "handlePasteAsPlainTextWithAnalytics", () => $4cfeb607ceb33f88$export$69d6e3902009956e);
$parcel$export(module.exports, "handlePasteIntoTaskAndDecisionWithAnalytics", () => $4cfeb607ceb33f88$export$e3873690443e0966);
$parcel$export(module.exports, "handlePasteIntoCaptionWithAnalytics", () => $4cfeb607ceb33f88$export$e1d2fb186881c383);
$parcel$export(module.exports, "handleCodeBlockWithAnalytics", () => $4cfeb607ceb33f88$export$9fea421173ba6d7d);
$parcel$export(module.exports, "handleMediaSingleWithAnalytics", () => $4cfeb607ceb33f88$export$b49fd82cf59cd44e);
$parcel$export(module.exports, "handlePastePreservingMarksWithAnalytics", () => $4cfeb607ceb33f88$export$ef36b80b79d1d973);
$parcel$export(module.exports, "handleMarkdownWithAnalytics", () => $4cfeb607ceb33f88$export$d7489d309972091e);
$parcel$export(module.exports, "handleRichTextWithAnalytics", () => $4cfeb607ceb33f88$export$3ef868f9e7157717);
$parcel$export(module.exports, "handlePastePanelOrDecisionIntoListWithAnalytics", () => $4cfeb607ceb33f88$export$2d195c5439ce2ebc);
$parcel$export(module.exports, "handlePasteNonNestableBlockNodesIntoListWithAnalytics", () => $4cfeb607ceb33f88$export$bbc9709b7b4a2f6);
$parcel$export(module.exports, "handleExpandWithAnalytics", () => $4cfeb607ceb33f88$export$6681e5bfb9c8b704);
$parcel$export(module.exports, "handleNestedTablePasteWithAnalytics", () => $4cfeb607ceb33f88$export$7dc8d4c52517a2f7);
$parcel$export(module.exports, "handleSelectedTableWithAnalytics", () => $4cfeb607ceb33f88$export$6dbadac5ea22dd7a);
$parcel$export(module.exports, "handlePasteLinkOnSelectedTextWithAnalytics", () => $4cfeb607ceb33f88$export$b36a7c9ea20b7bbf);
$parcel$export(module.exports, "createPasteMeasurePayload", () => $4cfeb607ceb33f88$export$5dd5834ba1e07721);
$parcel$export(module.exports, "getContentNodeTypes", () => $4cfeb607ceb33f88$export$629ff5588e070c83);

var $bMFKb = parcelRequire("bMFKb");
var $j0X5g = parcelRequire("j0X5g");

var $grDTV = parcelRequire("grDTV");
var $gbisc = parcelRequire("gbisc");

var $BmspC = parcelRequire("BmspC");

var $bFyUX = parcelRequire("bFyUX");

var $1nSqW = parcelRequire("1nSqW");
const $4cfeb607ceb33f88$var$contentToPasteContent = {
    url: (0, $j0X5g.PasteContents).url,
    paragraph: (0, $j0X5g.PasteContents).text,
    bulletList: (0, $j0X5g.PasteContents).bulletList,
    orderedList: (0, $j0X5g.PasteContents).orderedList,
    heading: (0, $j0X5g.PasteContents).heading,
    blockquote: (0, $j0X5g.PasteContents).blockquote,
    codeBlock: (0, $j0X5g.PasteContents).codeBlock,
    panel: (0, $j0X5g.PasteContents).panel,
    rule: (0, $j0X5g.PasteContents).rule,
    mediaSingle: (0, $j0X5g.PasteContents).mediaSingle,
    mediaCard: (0, $j0X5g.PasteContents).mediaCard,
    mediaGroup: (0, $j0X5g.PasteContents).mediaGroup,
    table: (0, $j0X5g.PasteContents).table,
    tableCells: (0, $j0X5g.PasteContents).tableCells,
    tableHeader: (0, $j0X5g.PasteContents).tableHeader,
    tableRow: (0, $j0X5g.PasteContents).tableRow,
    decisionList: (0, $j0X5g.PasteContents).decisionList,
    decisionItem: (0, $j0X5g.PasteContents).decisionItem,
    taskList: (0, $j0X5g.PasteContents).taskItem,
    extension: (0, $j0X5g.PasteContents).extension,
    bodiedExtension: (0, $j0X5g.PasteContents).bodiedExtension,
    blockCard: (0, $j0X5g.PasteContents).blockCard,
    layoutSection: (0, $j0X5g.PasteContents).layoutSection
};
const $4cfeb607ceb33f88$var$nodeToActionSubjectId = {
    blockquote: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_BLOCKQUOTE,
    blockCard: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_BLOCK_CARD,
    bodiedExtension: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_BODIED_EXTENSION,
    bulletList: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_BULLET_LIST,
    codeBlock: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_CODE_BLOCK,
    decisionList: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_DECISION_LIST,
    extension: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_EXTENSION,
    heading: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_HEADING,
    mediaGroup: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_MEDIA_GROUP,
    mediaSingle: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_MEDIA_SINGLE,
    orderedList: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_ORDERED_LIST,
    panel: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_PANEL,
    rule: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_RULE,
    table: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_TABLE,
    tableCell: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_TABLE_CELL,
    tableHeader: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_TABLE_HEADER,
    tableRow: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_TABLE_ROW,
    taskList: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_TASK_LIST
};
function $4cfeb607ceb33f88$export$234c310f1a4fffd6({ schema: schema, slice: slice }) {
    const { nodes: { paragraph: paragraph }, marks: { link: link } } = schema;
    const nodeOrMarkName = new Set();
    slice.content.forEach((node)=>{
        if (node.type === paragraph && node.content.size === 0) // Skip empty paragraph
        return;
        if (node.type.name === 'text' && link.isInSet(node.marks)) {
            nodeOrMarkName.add('url');
            return;
        }
        // Check node contain link
        if (node.type === paragraph && node.rangeHasMark(0, node.nodeSize - 2, link)) {
            nodeOrMarkName.add('url');
            return;
        }
        nodeOrMarkName.add(node.type.name);
    });
    if (nodeOrMarkName.size > 1) return (0, $j0X5g.PasteContents).mixed;
    if (nodeOrMarkName.size === 0) return (0, $j0X5g.PasteContents).uncategorized;
    const type = nodeOrMarkName.values().next().value;
    // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
    const pasteContent = $4cfeb607ceb33f88$var$contentToPasteContent[type];
    return pasteContent ? pasteContent : (0, $j0X5g.PasteContents).uncategorized;
}
function $4cfeb607ceb33f88$export$d26f991ad03d8827(slice) {
    let traceId;
    (0, $gbisc.mapSlice)(slice, (node)=>{
        if (node.type.name === 'media' || node.type.name === 'mediaInline') traceId = node.attrs.__mediaTraceId;
        return node;
    });
    return traceId;
}
function $4cfeb607ceb33f88$var$getActionSubjectId({ selection: selection, schema: schema }) {
    const { nodes: { paragraph: paragraph, listItem: listItem, taskItem: taskItem, decisionItem: decisionItem } } = schema;
    const parent = (0, $BmspC.findParentNode)((node)=>{
        if (node.type !== paragraph && node.type !== listItem && node.type !== taskItem && node.type !== decisionItem) return true;
        return false;
    })(selection);
    if (!parent) return (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_PARAGRAPH;
    const parentType = parent.node.type;
    const actionSubjectId = $4cfeb607ceb33f88$var$nodeToActionSubjectId[parentType.name];
    return actionSubjectId ? actionSubjectId : (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_PARAGRAPH;
}
function $4cfeb607ceb33f88$var$createPasteAsPlainPayload(actionSubjectId, text, linksInPasteCount) {
    return {
        action: (0, $bMFKb.ACTION).PASTED_AS_PLAIN,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $bMFKb.INPUT_METHOD).KEYBOARD,
            pasteSize: text.length,
            linksInPasteCount: linksInPasteCount
        }
    };
}
function $4cfeb607ceb33f88$var$createPastePayload(actionSubjectId, attributes, linkDomain) {
    return {
        action: (0, $bMFKb.ACTION).PASTED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $bMFKb.INPUT_METHOD).KEYBOARD,
            ...attributes
        },
        ...linkDomain && linkDomain.length > 0 ? {
            nonPrivacySafeAttributes: {
                linkDomain: linkDomain
            }
        } : {}
    };
}
function $4cfeb607ceb33f88$var$createPasteAnalyticsPayloadBySelection(event, slice, pasteContext, pluginInjectionApi) {
    return (selection)=>{
        const text = event.clipboardData ? event.clipboardData.getData('text/plain') || event.clipboardData.getData('text/uri-list') : '';
        const actionSubjectId = $4cfeb607ceb33f88$var$getActionSubjectId({
            selection: selection,
            schema: selection.$from.doc.type.schema
        });
        const pasteSize = slice.size;
        const content = $4cfeb607ceb33f88$export$234c310f1a4fffd6({
            schema: selection.$from.doc.type.schema,
            slice: slice
        });
        const linkUrls = [];
        const mediaTraceId = $4cfeb607ceb33f88$export$d26f991ad03d8827(slice);
        // If we have a link among the pasted content, grab the
        // domain and send it up with the analytics event
        if (content === (0, $j0X5g.PasteContents).url || content === (0, $j0X5g.PasteContents).mixed) (0, $gbisc.mapSlice)(slice, (node)=>{
            const linkMark = node.marks.find((mark)=>mark.type.name === 'link');
            if (linkMark) linkUrls.push(linkMark.attrs.href);
            return node;
        });
        if (pasteContext.asPlain) return $4cfeb607ceb33f88$var$createPasteAsPlainPayload(actionSubjectId, text, linkUrls.length);
        const source = (0, $bFyUX.getPasteSource)(event);
        const mentionIds = [];
        const mentionLocalIds = [];
        slice.content.descendants((node)=>{
            if (node.type.name === 'mention') {
                mentionIds.push(node.attrs.id);
                mentionLocalIds.push(node.attrs.localId);
            }
        });
        if (pluginInjectionApi?.mention?.actions?.announceMentionsInsertion) {
            const mentionsInserted = [];
            slice.content.descendants((node)=>{
                if (node.type.name === 'mention') mentionsInserted.push({
                    type: 'added',
                    id: node.attrs.id,
                    localId: node.attrs.localId,
                    method: 'pasted'
                });
                if (node.type.name === 'taskItem') {
                    node.content.forEach((nodeContent)=>{
                        if (nodeContent.type.name === 'mention') mentionsInserted.push({
                            type: 'added',
                            localId: nodeContent.attrs.localId,
                            id: nodeContent.attrs.id,
                            taskLocalId: node.attrs.localId,
                            method: 'pasted'
                        });
                    });
                    return false;
                }
            });
            pluginInjectionApi?.mention?.actions?.announceMentionsInsertion(mentionsInserted);
        }
        if (pasteContext.type === (0, $j0X5g.PasteTypes).plain) return $4cfeb607ceb33f88$var$createPastePayload(actionSubjectId, {
            pasteSize: text.length,
            type: pasteContext.type,
            content: (0, $j0X5g.PasteContents).text,
            source: source,
            hyperlinkPasteOnText: false,
            linksInPasteCount: linkUrls.length,
            mentionIds: mentionIds,
            mentionLocalIds: mentionLocalIds,
            pasteSplitList: pasteContext.pasteSplitList
        });
        const linkDomains = linkUrls.map((0, $grDTV.getLinkDomain));
        return $4cfeb607ceb33f88$var$createPastePayload(actionSubjectId, {
            type: pasteContext.type,
            pasteSize: pasteSize,
            content: content,
            source: source,
            hyperlinkPasteOnText: !!pasteContext.hyperlinkPasteOnText,
            linksInPasteCount: linkUrls.length,
            mediaTraceId: mediaTraceId,
            mentionIds: mentionIds,
            mentionLocalIds: mentionLocalIds,
            pasteSplitList: pasteContext.pasteSplitList
        }, linkDomains);
    };
}
function $4cfeb607ceb33f88$export$a30e064bd28e927f(view, event, slice, pasteContext) {
    return $4cfeb607ceb33f88$var$createPasteAnalyticsPayloadBySelection(event, slice, pasteContext)(view.state.selection);
}
const $4cfeb607ceb33f88$export$5ee87eef0a304a1b = (editorAnalyticsAPI)=>(view, event, slice, pasteContext)=>{
        const tr = view.state.tr;
        const payload = $4cfeb607ceb33f88$export$a30e064bd28e927f(view, event, slice, pasteContext);
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
        view.dispatch(tr);
    };
const $4cfeb607ceb33f88$export$69d6e3902009956e = (editorAnalyticsAPI)=>(view, event, slice)=>$4cfeb607ceb33f88$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($4cfeb607ceb33f88$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $j0X5g.PasteTypes).plain,
            asPlain: true
        }))((0, $1nSqW.handlePasteAsPlainText)(slice, event, editorAnalyticsAPI));
const $4cfeb607ceb33f88$export$e3873690443e0966 = (view, event, slice, type, pluginInjectionApi)=>$4cfeb607ceb33f88$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi?.analytics?.actions)($4cfeb607ceb33f88$var$createPasteAnalyticsPayloadBySelection(event, slice, {
        type: type
    }))((0, $1nSqW.handlePasteIntoTaskOrDecisionOrPanel)(slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr));
const $4cfeb607ceb33f88$export$e1d2fb186881c383 = (editorAnalyticsAPI)=>(view, event, slice, type)=>$4cfeb607ceb33f88$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($4cfeb607ceb33f88$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: type
        }))((0, $1nSqW.handlePasteIntoCaption)(slice));
const $4cfeb607ceb33f88$export$9fea421173ba6d7d = (editorAnalyticsAPI)=>(view, event, slice, text)=>$4cfeb607ceb33f88$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($4cfeb607ceb33f88$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $j0X5g.PasteTypes).plain
        }))((0, $1nSqW.handleCodeBlock)(text));
const $4cfeb607ceb33f88$export$b49fd82cf59cd44e = (editorAnalyticsAPI)=>(view, event, slice, type, insertMediaAsMediaSingle)=>$4cfeb607ceb33f88$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($4cfeb607ceb33f88$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: type
        }))((0, $1nSqW.handleMediaSingle)((0, $bMFKb.INPUT_METHOD).CLIPBOARD, insertMediaAsMediaSingle)(slice));
const $4cfeb607ceb33f88$export$ef36b80b79d1d973 = (view, event, slice, type, pluginInjectionApi)=>$4cfeb607ceb33f88$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi?.analytics?.actions)($4cfeb607ceb33f88$var$createPasteAnalyticsPayloadBySelection(event, slice, {
        type: type
    }))((0, $1nSqW.handlePastePreservingMarks)(slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr));
const $4cfeb607ceb33f88$export$d7489d309972091e = (view, event, slice, pluginInjectionApi)=>$4cfeb607ceb33f88$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi?.analytics?.actions)($4cfeb607ceb33f88$var$createPasteAnalyticsPayloadBySelection(event, slice, {
        type: (0, $j0X5g.PasteTypes).markdown
    }))((0, $1nSqW.handleMarkdown)(slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr));
const $4cfeb607ceb33f88$export$3ef868f9e7157717 = (view, event, slice, pluginInjectionApi)=>$4cfeb607ceb33f88$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi?.analytics?.actions)($4cfeb607ceb33f88$var$createPasteAnalyticsPayloadBySelection(event, slice, {
        type: (0, $j0X5g.PasteTypes).richText
    }, pluginInjectionApi))((0, $1nSqW.handleRichText)(slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr));
const $4cfeb607ceb33f88$var$injectAnalyticsPayloadBeforeCommand = (editorAnalyticsAPI)=>(createPayloadByTransaction)=>{
        return (mainCommand)=>{
            return (state, dispatch, view)=>{
                let originalTransaction = state.tr;
                const fakeDispatch = (tr)=>{
                    originalTransaction = tr;
                };
                const result = mainCommand(state, fakeDispatch, view);
                if (!result) return false;
                if (dispatch && originalTransaction.docChanged) {
                    // it needs to know the selection before the changes
                    const payload = createPayloadByTransaction(state.selection);
                    editorAnalyticsAPI?.attachAnalyticsEvent(payload)(originalTransaction);
                    dispatch(originalTransaction);
                }
                return true;
            };
        };
    };
const $4cfeb607ceb33f88$export$2d195c5439ce2ebc = (editorAnalyticsAPI)=>(view, event, slice, findRootParentListNode)=>$4cfeb607ceb33f88$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($4cfeb607ceb33f88$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $j0X5g.PasteTypes).richText
        }))((0, $1nSqW.handlePastePanelOrDecisionContentIntoList)(slice, findRootParentListNode));
const $4cfeb607ceb33f88$export$bbc9709b7b4a2f6 = (editorAnalyticsAPI)=>(view, event, slice)=>$4cfeb607ceb33f88$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($4cfeb607ceb33f88$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $j0X5g.PasteTypes).richText,
            pasteSplitList: true
        }))((0, $1nSqW.handlePasteNonNestableBlockNodesIntoList)(slice));
const $4cfeb607ceb33f88$export$6681e5bfb9c8b704 = (editorAnalyticsAPI)=>(view, event, slice)=>$4cfeb607ceb33f88$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($4cfeb607ceb33f88$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $j0X5g.PasteTypes).richText,
            pasteSplitList: true
        }))((0, $1nSqW.handleExpandPaste)(slice));
const $4cfeb607ceb33f88$export$7dc8d4c52517a2f7 = (editorAnalyticsAPI, isNestingTablesSupported)=>(view, event, slice)=>$4cfeb607ceb33f88$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($4cfeb607ceb33f88$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $j0X5g.PasteTypes).richText,
            pasteSplitList: true
        }))((0, $1nSqW.handleNestedTablePaste)(slice, isNestingTablesSupported));
const $4cfeb607ceb33f88$export$6dbadac5ea22dd7a = (editorAnalyticsAPI)=>(view, event, slice)=>$4cfeb607ceb33f88$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($4cfeb607ceb33f88$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $j0X5g.PasteTypes).richText
        }))((0, $1nSqW.handleSelectedTable)(editorAnalyticsAPI)(slice));
const $4cfeb607ceb33f88$export$b36a7c9ea20b7bbf = (editorAnalyticsAPI)=>(view, event, slice, type)=>$4cfeb607ceb33f88$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($4cfeb607ceb33f88$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: type,
            hyperlinkPasteOnText: true
        }))((0, $1nSqW.handlePasteLinkOnSelectedText)(slice));
const $4cfeb607ceb33f88$export$5dd5834ba1e07721 = ({ view: view, duration: duration, content: content, distortedDuration: distortedDuration })=>{
    const pasteIntoNode = $4cfeb607ceb33f88$var$getActionSubjectId({
        selection: view.state.selection,
        schema: view.state.schema
    });
    return {
        action: (0, $bMFKb.ACTION).PASTED_TIMED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
        eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
        attributes: {
            pasteIntoNode: pasteIntoNode,
            content: content,
            time: duration,
            distortedDuration: distortedDuration
        }
    };
};
const $4cfeb607ceb33f88$export$629ff5588e070c83 = (content)=>{
    let nodeTypes = new Set();
    if (content.size) content.forEach((node)=>{
        if (node.content && node.content.size) nodeTypes = new Set([
            ...nodeTypes,
            ...$4cfeb607ceb33f88$export$629ff5588e070c83(node.content)
        ]);
        nodeTypes.add(node.type.name);
    });
    return Array.from(nodeTypes);
};

});
parcelRegister("bFyUX", function(module, exports) {
$parcel$export(module.exports, "isPastedFromWord", () => $a06a9e339294e95a$export$6ba9f527e53e4ac1);
$parcel$export(module.exports, "isPastedFromExcel", () => $a06a9e339294e95a$export$8d0b7622c89b176c);
$parcel$export(module.exports, "htmlContainsSingleFile", () => $a06a9e339294e95a$export$41d193509f55b76e);
$parcel$export(module.exports, "getPasteSource", () => $a06a9e339294e95a$export$e45b5b7458bacd81);
$parcel$export(module.exports, "escapeBackslashAndLinksExceptCodeBlock", () => $a06a9e339294e95a$export$3e81f5aaf68cd698);
$parcel$export(module.exports, "hasOnlyNodesOfType", () => $a06a9e339294e95a$export$a4568554bf9b43cd);
$parcel$export(module.exports, "applyTextMarksToSlice", () => $a06a9e339294e95a$export$3bf611fd421c1669);
$parcel$export(module.exports, "isEmptyNode", () => $a06a9e339294e95a$export$641fdf56f693bfbc);
$parcel$export(module.exports, "isCursorSelectionAtTextStartOrEnd", () => $a06a9e339294e95a$export$ee1d3ec5b3695690);
$parcel$export(module.exports, "isSelectionInsidePanel", () => $a06a9e339294e95a$export$3befc640b7d49184);
$parcel$export(module.exports, "htmlHasInvalidLinkTags", () => $a06a9e339294e95a$export$3c3a613abe5bb97d);
$parcel$export(module.exports, "removeDuplicateInvalidLinks", () => $a06a9e339294e95a$export$35ca1bb0581efaf3);
$parcel$export(module.exports, "addReplaceSelectedTableAnalytics", () => $a06a9e339294e95a$export$4f704994f6a89bd1);
$parcel$export(module.exports, "transformUnsupportedBlockCardToInline", () => $a06a9e339294e95a$export$9ffea5586131a948);

var $bMFKb = parcelRequire("bMFKb");
var $ey7La = parcelRequire("ey7La");

var $87fb1 = parcelRequire("87fb1");

var $9Ssie = parcelRequire("9Ssie");
var $gbisc = parcelRequire("gbisc");

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");

var $exwOR = parcelRequire("exwOR");
var $bctVO = parcelRequire("bctVO");

var $bajro = parcelRequire("bajro");

var $eGOwo = parcelRequire("eGOwo");
function $a06a9e339294e95a$export$6ba9f527e53e4ac1(html) {
    return !!html && html.indexOf('urn:schemas-microsoft-com:office:word') >= 0;
}
function $a06a9e339294e95a$export$8d0b7622c89b176c(html) {
    return !!html && html.indexOf('urn:schemas-microsoft-com:office:excel') >= 0;
}
function $a06a9e339294e95a$var$isPastedFromDropboxPaper(html) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return !!html && !!html.match(/class=\"\s?author-d-.+"/gim);
}
function $a06a9e339294e95a$var$isPastedFromGoogleDocs(html) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return !!html && !!html.match(/id=\"docs-internal-guid-.+"/gim);
}
function $a06a9e339294e95a$var$isPastedFromGoogleSpreadSheets(html) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return !!html && !!html.match(/data-sheets-.+=/gim);
}
function $a06a9e339294e95a$var$isPastedFromPages(html) {
    return !!html && html.indexOf('content="Cocoa HTML Writer"') >= 0;
}
function $a06a9e339294e95a$var$isPastedFromFabricEditor(html) {
    return !!html && html.indexOf('data-pm-slice="') >= 0;
}
const $a06a9e339294e95a$export$6186a6a0af6a6a9d = (text)=>{
    return !!text && text.trim().split('\n').length === 1;
};
function $a06a9e339294e95a$export$41d193509f55b76e(html) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return !!html.match(/<img .*>/) && !(0, $bajro.isMediaBlobUrl)(html);
}
function $a06a9e339294e95a$export$e45b5b7458bacd81(event) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const html = event.clipboardData.getData('text/html');
    if ($a06a9e339294e95a$var$isPastedFromDropboxPaper(html)) return 'dropbox-paper';
    else if ($a06a9e339294e95a$export$6ba9f527e53e4ac1(html)) return 'microsoft-word';
    else if ($a06a9e339294e95a$export$8d0b7622c89b176c(html)) return 'microsoft-excel';
    else if ($a06a9e339294e95a$var$isPastedFromGoogleDocs(html)) return 'google-docs';
    else if ($a06a9e339294e95a$var$isPastedFromGoogleSpreadSheets(html)) return 'google-spreadsheets';
    else if ($a06a9e339294e95a$var$isPastedFromPages(html)) return 'apple-pages';
    else if ($a06a9e339294e95a$var$isPastedFromFabricEditor(html)) return 'fabric-editor';
    return 'uncategorized';
}
function $a06a9e339294e95a$export$8acd10161c5f8b07(text) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return text.replace(/(\[([^\]]+)\]\()?((https?|ftp|jamfselfservice):\/\/[^\s>"]+)/g, (str)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return str.match(/^(https?|ftp|jamfselfservice):\/\/[^\s>"]+$/) ? `<${str}>` : str;
    });
}
function $a06a9e339294e95a$export$3e81f5aaf68cd698(textInput) {
    if ((0, $eGOwo.fg)('platform_editor_paste_code_fence_spaces')) {
        // ref: https://spec.commonmark.org/0.31.2/#fenced-code-blocks
        // Allows up to 3 leading spaces before ``` and optional trailing characters
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const openingCodeFenceRegex = /^( {0,3})```.*$/;
        // Allows up to 3 leading spaces before ``` and optional trailing spaces or tabs
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const closingCodeFenceRegex = /^( {0,3})```[ \t]*$/;
        let isInsideCodeBlock = false;
        const lines = textInput.split('\n');
        // In the splitted array, we traverse through every line and check if it will be parsed as a codeblock.
        return lines.map((line)=>{
            if (!isInsideCodeBlock && openingCodeFenceRegex.test(line)) {
                isInsideCodeBlock = true;
                return line;
            }
            if (isInsideCodeBlock && closingCodeFenceRegex.test(line)) {
                isInsideCodeBlock = false;
                return line;
            }
            // not code fence, don't escape anything inside code block
            if (isInsideCodeBlock) return line;
            else {
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                let escaped = line.replace(/\\/g, '\\\\');
                escaped = $a06a9e339294e95a$export$8acd10161c5f8b07(escaped);
                return escaped;
            }
        }).join('\n');
    } else {
        const codeToken = '```';
        let isInsideCodeBlock = false;
        const lines = textInput.split('\n');
        // In the splitted array, we traverse through every line and check if it will be parsed as a codeblock.
        return lines.map((line)=>{
            if (line === codeToken) {
                // Toggle code block state
                isInsideCodeBlock = !isInsideCodeBlock;
                return line;
            } else if (line.startsWith(codeToken) && !isInsideCodeBlock) {
                // if there is some text after the ``` mark , it gets counted as language attribute only at the start of codeblock
                isInsideCodeBlock = true;
                return line;
            }
            if (!isInsideCodeBlock) {
                // Only escape outside code blocks
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                let escaped = line.replace(/\\/g, '\\\\');
                escaped = $a06a9e339294e95a$export$8acd10161c5f8b07(escaped);
                return escaped;
            }
            return line;
        }).join('\n');
    }
}
function $a06a9e339294e95a$export$a4568554bf9b43cd(...nodeTypes) {
    return (slice)=>{
        let hasOnlyNodesOfType = true;
        slice.content.descendants((node)=>{
            hasOnlyNodesOfType = hasOnlyNodesOfType && nodeTypes.indexOf(node.type) > -1;
            return hasOnlyNodesOfType;
        });
        return hasOnlyNodesOfType;
    };
}
function $a06a9e339294e95a$export$3bf611fd421c1669(schema, marks) {
    return (slice)=>{
        const { marks: { code: codeMark, link: linkMark, annotation: annotationMark } } = schema;
        if (!Array.isArray(marks) || marks.length === 0) return slice;
        const sliceCopy = (0, $3xw6l.Slice).fromJSON(schema, slice.toJSON() || {});
        // allow links and annotations to be pasted
        const allowedMarksToPaste = [
            linkMark,
            annotationMark
        ];
        sliceCopy.content.descendants((node, _pos, parent)=>{
            if (node.isText && parent && parent.isBlock) {
                // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
                node.marks = [
                    // remove all marks from pasted slice when applying code mark
                    // and exclude all marks that are not allowed to be pasted
                    ...node.marks && !codeMark.isInSet(marks) && node.marks.filter((mark)=>allowedMarksToPaste.includes(mark.type)) || [],
                    // add marks to a slice if they're allowed in parent node
                    // and exclude link marks
                    ...parent.type.allowedMarks(marks).filter((mark)=>mark.type !== linkMark)
                ].sort((0, $87fb1.sortByOrderWithTypeName)('marks'));
                return false;
            }
            if ((0, $eGOwo.fg)('editor_inline_comments_paste_insert_nodes')) {
                if (node.isInline && [
                    'inlineCard',
                    'emoji',
                    'status',
                    'date',
                    'mention'
                ].includes(node.type.name) && parent && parent.isBlock) // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
                node.marks = [
                    ...node.marks,
                    ...parent.type.allowedMarks(marks).filter((mark)=>mark.type === schema.marks.annotation)
                ];
            }
            return true;
        });
        return sliceCopy;
    };
}
function $a06a9e339294e95a$export$641fdf56f693bfbc(node) {
    if (!node) return false;
    const { type: nodeType } = node;
    const emptyNode = nodeType.createAndFill();
    return emptyNode && emptyNode.nodeSize === node.nodeSize && emptyNode.content.eq(node.content) && (0, $3xw6l.Mark).sameSet(emptyNode.marks, node.marks);
}
function $a06a9e339294e95a$export$ee1d3ec5b3695690(selection) {
    return selection instanceof (0, $3lIcL.TextSelection) && selection.empty && selection.$cursor && (!selection.$cursor.nodeBefore || !selection.$cursor.nodeAfter);
}
function $a06a9e339294e95a$export$c7c9ca5cba02ff5a(node) {
    return Boolean(node && node.type.name === 'panel');
}
function $a06a9e339294e95a$export$3befc640b7d49184(selection) {
    if (selection instanceof (0, $3lIcL.NodeSelection) && $a06a9e339294e95a$export$c7c9ca5cba02ff5a(selection.node)) return selection.node;
    const { doc: { type: { schema: { nodes: { panel: panel } } } } } = selection.$from;
    const panelPosition = (0, $BmspC.findParentNodeOfType)(panel)(selection);
    if (panelPosition) return panelPosition.node;
    return null;
}
const $a06a9e339294e95a$export$3c3a613abe5bb97d = (html)=>{
    return !!html && (html.includes('</a></a>') || html.includes('"></a><a'));
};
const $a06a9e339294e95a$export$35ca1bb0581efaf3 = (html)=>{
    if ($a06a9e339294e95a$export$3c3a613abe5bb97d(html)) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const htmlArray = html.split(/(?=<a)/);
        const htmlArrayWithoutInvalidLinks = htmlArray.filter((item)=>{
            return !(item.includes('<a') && item.includes('"></a>')) && !(item.includes('<a') && !item.includes('</a>'));
        });
        const fixedHtml = htmlArrayWithoutInvalidLinks.join('')// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/<\/a><\/a>/gi, '</a>')// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/<a>/gi, '<a');
        return fixedHtml;
    }
    return html;
};
const $a06a9e339294e95a$export$4f704994f6a89bd1 = (state, tr, editorAnalyticsAPI)=>{
    if ((0, $bctVO.isTableSelected)(state.selection)) {
        const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $exwOR.getSelectedTableInfo)(state.selection);
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $ey7La.TABLE_ACTION).REPLACED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).TABLE,
            attributes: {
                totalColumnCount: totalColumnCount,
                totalRowCount: totalRowCount,
                inputMethod: (0, $bMFKb.INPUT_METHOD).CLIPBOARD
            },
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    }
    return state.tr;
};
const $a06a9e339294e95a$export$9ffea5586131a948 = (slice, state, cardOptions)=>{
    const { blockCard: blockCard, inlineCard: inlineCard } = state.schema.nodes;
    const children = [];
    (0, $gbisc.mapChildren)(slice.content, (node, i, frag)=>{
        if (node.type === blockCard && !$a06a9e339294e95a$var$isBlockCardSupported(state, frag, cardOptions?.allowBlockCards ?? false)) children.push(inlineCard.createChecked(node.attrs, node.content, node.marks));
        else children.push(node);
    });
    return new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).fromArray(children), slice.openStart, slice.openEnd);
};
/**
 * Function to determine if a block card is supported by the editor
 * @param state
 * @param frag
 * @param allowBlockCards
 * @returns
 */ const $a06a9e339294e95a$var$isBlockCardSupported = (state, frag, allowBlockCards)=>{
    return allowBlockCards && (0, $9Ssie.isSupportedInParent)(state, frag);
};

});
parcelRegister("exwOR", function(module, exports) {
$parcel$export(module.exports, "getSelectedTableInfo", () => $76d59b70b17f9a56$export$d2cf64960b17e12e);
$parcel$export(module.exports, "getSelectedCellInfo", () => $76d59b70b17f9a56$export$277d5394a2608229);

var $2vA54 = parcelRequire("2vA54");

var $kuDbA = parcelRequire("kuDbA");

var $hs2hB = parcelRequire("hs2hB");
function $76d59b70b17f9a56$export$d2cf64960b17e12e(selection) {
    let map;
    let totalRowCount = 0;
    let totalColumnCount = 0;
    const table = (0, $kuDbA.findTable)(selection);
    if (table) {
        map = (0, $2vA54.TableMap).get(table.node);
        totalRowCount = map.height;
        totalColumnCount = map.width;
    }
    return {
        table: table,
        map: map,
        totalRowCount: totalRowCount,
        totalColumnCount: totalColumnCount
    };
}
function $76d59b70b17f9a56$export$277d5394a2608229(selection) {
    let horizontalCells = 1;
    let verticalCells = 1;
    let totalCells = 1;
    const { table: table, map: map, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = $76d59b70b17f9a56$export$d2cf64960b17e12e(selection);
    if (table && map) {
        const rect = (0, $hs2hB.getSelectionRect)(selection);
        if (rect) {
            totalCells = map.cellsInRect(rect).length;
            horizontalCells = rect.right - rect.left;
            verticalCells = rect.bottom - rect.top;
        }
    }
    return {
        totalRowCount: totalRowCount,
        totalColumnCount: totalColumnCount,
        horizontalCells: horizontalCells,
        verticalCells: verticalCells,
        totalCells: totalCells
    };
}

});

parcelRegister("bctVO", function(module, exports) {
$parcel$export(module.exports, "isColumnSelected", () => $d039a68c7fe73dcc$export$8db1cdcc0c397a6d);
$parcel$export(module.exports, "isRowSelected", () => $d039a68c7fe73dcc$export$710e11cf672b86c);
$parcel$export(module.exports, "isTableSelected", () => $d039a68c7fe73dcc$export$5d08de4a0eeb0408);

var $2vA54 = parcelRequire("2vA54");

var $6dtFv = parcelRequire("6dtFv");
const $d039a68c7fe73dcc$export$d06743a3adc2076d = (rect)=>(selection)=>{
        if (!(0, $6dtFv.isSelectionType)(selection, 'cell')) return false;
        const map = (0, $2vA54.TableMap).get(selection.$anchorCell.node(-1));
        const start = selection.$anchorCell.start(-1);
        const cells = map.cellsInRect(rect);
        const selectedCells = map.cellsInRect(map.rectBetween(selection.$anchorCell.pos - start, selection.$headCell.pos - start));
        for(let i = 0, count = cells.length; i < count; i++){
            if (selectedCells.indexOf(cells[i]) === -1) return false;
        }
        return true;
    };
const $d039a68c7fe73dcc$export$8db1cdcc0c397a6d = (columnIndex)=>(selection)=>{
        if ((0, $6dtFv.isSelectionType)(selection, 'cell')) {
            const map = (0, $2vA54.TableMap).get(selection.$anchorCell.node(-1));
            return $d039a68c7fe73dcc$export$d06743a3adc2076d({
                left: columnIndex,
                right: columnIndex + 1,
                top: 0,
                bottom: map.height
            })(selection);
        }
        return false;
    };
const $d039a68c7fe73dcc$export$710e11cf672b86c = (rowIndex)=>(selection)=>{
        if ((0, $6dtFv.isSelectionType)(selection, 'cell')) {
            const map = (0, $2vA54.TableMap).get(selection.$anchorCell.node(-1));
            return $d039a68c7fe73dcc$export$d06743a3adc2076d({
                left: 0,
                right: map.width,
                top: rowIndex,
                bottom: rowIndex + 1
            })(selection);
        }
        return false;
    };
const $d039a68c7fe73dcc$export$5d08de4a0eeb0408 = (selection)=>{
    if ((0, $6dtFv.isSelectionType)(selection, 'cell')) {
        const map = (0, $2vA54.TableMap).get(selection.$anchorCell.node(-1));
        return $d039a68c7fe73dcc$export$d06743a3adc2076d({
            left: 0,
            right: map.width,
            top: 0,
            bottom: map.height
        })(selection);
    }
    return false;
};

});

parcelRegister("bajro", function(module, exports) {
$parcel$export(module.exports, "isMediaBlobUrl", () => $dd0a5c69b434a5a7$export$e1e8ad57ada2d90);
$parcel$export(module.exports, "getAttrsFromUrl", () => $dd0a5c69b434a5a7$export$b91a9e94ff0cbb29);
$parcel$export(module.exports, "addFileAttrsToUrl", () => $dd0a5c69b434a5a7$export$e51a8146182600b8);
const $dd0a5c69b434a5a7$var$mediaBlobUrlIdentifier = 'media-blob-url';
const $dd0a5c69b434a5a7$export$e1e8ad57ada2d90 = (url)=>{
    return url.indexOf(`${$dd0a5c69b434a5a7$var$mediaBlobUrlIdentifier}=true`) > -1;
};
const $dd0a5c69b434a5a7$var$getNumberFromParams = (params, name)=>{
    const value = params.get(name);
    return typeof value === 'string' && !isNaN(parseInt(value)) ? parseInt(value) : undefined;
};
const $dd0a5c69b434a5a7$var$getStringFromParams = (params, name)=>{
    const value = params.get(name);
    if (!value) return;
    return decodeURIComponent(value);
};
const $dd0a5c69b434a5a7$export$b91a9e94ff0cbb29 = (blobUrl)=>{
    const url = new URL(blobUrl);
    const hash = url.hash.replace('#', '');
    const params = new URLSearchParams(hash);
    const id = params.get('id');
    const contextId = params.get('contextId');
    // check if we have the required params
    if (!id || !contextId) return;
    return {
        id: id,
        contextId: contextId,
        collection: $dd0a5c69b434a5a7$var$getStringFromParams(params, 'collection'),
        alt: $dd0a5c69b434a5a7$var$getStringFromParams(params, 'alt'),
        height: $dd0a5c69b434a5a7$var$getNumberFromParams(params, 'height'),
        width: $dd0a5c69b434a5a7$var$getNumberFromParams(params, 'width'),
        size: $dd0a5c69b434a5a7$var$getNumberFromParams(params, 'size'),
        name: $dd0a5c69b434a5a7$var$getStringFromParams(params, 'name'),
        mimeType: $dd0a5c69b434a5a7$var$getStringFromParams(params, 'mimeType')
    };
};
const $dd0a5c69b434a5a7$export$89a7e74069fbb7af = (json)=>{
    return Object.keys(json).filter((attrName)=>typeof json[attrName] !== 'undefined' && json[attrName] !== null).map((key)=>{
        const value = json[key];
        if (typeof value === 'undefined' || value === null) return;
        return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
    }).join('&');
};
const $dd0a5c69b434a5a7$export$e51a8146182600b8 = (url, fileAttrs)=>{
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) return url;
    const mediaIdentifierAttr = {
        [$dd0a5c69b434a5a7$var$mediaBlobUrlIdentifier]: 'true'
    };
    const mergedAttrs = {
        ...mediaIdentifierAttr,
        ...fileAttrs
    };
    const queryAttrs = $dd0a5c69b434a5a7$export$89a7e74069fbb7af(mergedAttrs);
    // we can't use '?' separator for blob url params
    return `${url}#${queryAttrs}`;
};

});


parcelRegister("1nSqW", function(module, exports) {
$parcel$export(module.exports, "handleMention", () => $a3cc84ee80caab1f$export$7097a0398467de9c);
$parcel$export(module.exports, "handlePasteIntoTaskOrDecisionOrPanel", () => $a3cc84ee80caab1f$export$af959912bf89ae42);
$parcel$export(module.exports, "handlePasteNonNestableBlockNodesIntoList", () => $a3cc84ee80caab1f$export$b8a52be876d0b84f);
$parcel$export(module.exports, "handlePastePanelOrDecisionContentIntoList", () => $a3cc84ee80caab1f$export$3fd7f6d89a9d2cac);
$parcel$export(module.exports, "handlePasteLinkOnSelectedText", () => $a3cc84ee80caab1f$export$5e27b285bdcc71bf);
$parcel$export(module.exports, "handlePasteAsPlainText", () => $a3cc84ee80caab1f$export$efe55f809fabb910);
$parcel$export(module.exports, "handlePastePreservingMarks", () => $a3cc84ee80caab1f$export$de618421675f910e);
$parcel$export(module.exports, "handleMacroAutoConvert", () => $a3cc84ee80caab1f$export$d23738992a74c3a9);
$parcel$export(module.exports, "handleMarkdown", () => $a3cc84ee80caab1f$export$4b83e18c607f848f);
$parcel$export(module.exports, "handleCodeBlock", () => $a3cc84ee80caab1f$export$98135102f7ccdef2);
$parcel$export(module.exports, "handleMediaSingle", () => $a3cc84ee80caab1f$export$5fb647c5a57bac64);
$parcel$export(module.exports, "handleTableContentPasteInBodiedExtension", () => $a3cc84ee80caab1f$export$36e0fe2cadced224);
$parcel$export(module.exports, "handleNestedTablePaste", () => $a3cc84ee80caab1f$export$113227139658cc8d);
$parcel$export(module.exports, "handleExpandPaste", () => $a3cc84ee80caab1f$export$a497757c6eac4530);
$parcel$export(module.exports, "handleParagraphBlockMarks", () => $a3cc84ee80caab1f$export$feb0d61bf65d9267);
$parcel$export(module.exports, "handleRichText", () => $a3cc84ee80caab1f$export$f9c7e15c780a77d0);
$parcel$export(module.exports, "handlePasteIntoCaption", () => $a3cc84ee80caab1f$export$d399a86cc775ad7e);
$parcel$export(module.exports, "handleSelectedTable", () => $a3cc84ee80caab1f$export$4ce587bb5876886d);

var $8KLBw = parcelRequire("8KLBw");

var $bMFKb = parcelRequire("bMFKb");

var $eQTBG = parcelRequire("eQTBG");

var $02q9c = parcelRequire("02q9c");

var $lQJJa = parcelRequire("lQJJa");

var $6BNUN = parcelRequire("6BNUN");

var $grDTV = parcelRequire("grDTV");
var $3ADzg = parcelRequire("3ADzg");
var $9Ssie = parcelRequire("9Ssie");
var $fCXIH = parcelRequire("fCXIH");
var $gbisc = parcelRequire("gbisc");

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");

var $8hKAd = parcelRequire("8hKAd");

var $eGOwo = parcelRequire("eGOwo");

var $apqw1 = parcelRequire("apqw1");

var $92xoS = parcelRequire("92xoS");

var $1CqHB = parcelRequire("1CqHB");

var $3Elhj = parcelRequire("3Elhj");

var $3CAWf = parcelRequire("3CAWf");

var $es8xl = parcelRequire("es8xl");

var $bFyUX = parcelRequire("bFyUX");
const $a3cc84ee80caab1f$var$insideExpand = (state)=>{
    const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
    return (0, $BmspC.hasParentNodeOfType)([
        expand,
        nestedExpand
    ])(state.selection);
};
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Compose 1 to n functions.
 * @param func first function
 * @param funcs additional functions
 */ function $a3cc84ee80caab1f$var$compose(func, ...funcs) {
    const allFuncs = [
        func,
        ...funcs
    ];
    return function composed(raw) {
        return allFuncs.reduceRight((memo, func)=>func(memo), raw);
    };
}
function $a3cc84ee80caab1f$export$7097a0398467de9c(slice, schema) {
    return (0, $gbisc.mapSlice)(slice, (node)=>{
        // We should move this to the mention plugin when we refactor how paste works in the future
        // For now we can just null check mention exists in the schema to ensure we don't crash if it doesn't
        // exist.
        if (node.type.name === schema.nodes.mention?.name) {
            const mention = node.attrs;
            const newMention = {
                ...mention,
                text: ''
            };
            return schema.nodes.mention.create(newMention, node.content, node.marks);
        }
        return node;
    });
}
function $a3cc84ee80caab1f$export$af959912bf89ae42(slice, queueCardsFromChangedTr) {
    return (state, dispatch)=>{
        const { schema: schema, tr: { selection: selection } } = state;
        const { marks: { code: codeMark }, nodes: { decisionItem: decisionItem, emoji: emoji, hardBreak: hardBreak, mention: mention, paragraph: paragraph, taskItem: taskItem, text: text, panel: panel, bulletList: bulletList, orderedList: orderedList, taskList: taskList, listItem: listItem, expand: expand, heading: heading, codeBlock: codeBlock } } = schema;
        const selectionIsValidNode = state.selection instanceof (0, $3lIcL.NodeSelection) && [
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem'
        ].includes(state.selection.node.type.name);
        const selectionHasValidParentNode = (0, $BmspC.hasParentNodeOfType)([
            decisionItem,
            taskItem,
            panel
        ])(state.selection);
        const selectionIsCodeBlock = (0, $BmspC.hasParentNodeOfType)([
            codeBlock
        ])(state.selection);
        const panelNode = (0, $bFyUX.isSelectionInsidePanel)(selection);
        const selectionIsPanel = Boolean(panelNode);
        // we avoid handling codeBlock-in-panel use case in this function
        // returning false will allow code to flow into `handleCodeBlock` function
        if (selectionIsPanel && selectionIsCodeBlock) return false;
        // Some types of content should be handled by the default handler, not this function.
        // Check through slice content to see if it contains an invalid node.
        let sliceIsInvalid = false;
        let sliceHasTask = false;
        slice.content.nodesBetween(0, slice.content.size, (node)=>{
            if (node.type === bulletList || node.type === orderedList || node.type === expand || node.type === heading || node.type === listItem) sliceIsInvalid = true;
            if (selectionIsPanel && node.type === taskList) sliceHasTask = true;
        });
        // If the selection is a panel,
        // and the slice's first node is a paragraph
        // and it is not from a depth that would indicate it being from inside from another node (e.g. text from a decision)
        // then we can rely on the default behaviour.
        const selectionIsTaskOrDecision = (0, $BmspC.hasParentNode)((node)=>node.type === taskItem || node.type === decisionItem)(selection);
        const sliceIsAPanelReceivingLowDepthText = selectionIsPanel && !selectionIsTaskOrDecision && slice.content.firstChild?.type === paragraph && slice.openEnd < 2;
        if (sliceIsInvalid || sliceIsAPanelReceivingLowDepthText || !selectionIsValidNode && !selectionHasValidParentNode) return false;
        const filters = [
            (0, $grDTV.linkifyContent)(schema)
        ];
        const selectionMarks = selection.$head.marks();
        if (selection instanceof (0, $3lIcL.TextSelection) && Array.isArray(selectionMarks) && selectionMarks.length > 0 && (0, $bFyUX.hasOnlyNodesOfType)(paragraph, text, emoji, mention, hardBreak)(slice) && (!codeMark.isInSet(selectionMarks) || (0, $02q9c.anyMarkActive)(state, codeMark) // check if there is a code mark anywhere in the selection
        )) filters.push((0, $bFyUX.applyTextMarksToSlice)(schema, selection.$head.marks()));
        const transformedSlice = $a3cc84ee80caab1f$var$compose.apply(null, filters)(slice);
        const isFirstChildTaskNode = transformedSlice.content.firstChild.type === taskList || transformedSlice.content.firstChild.type === taskItem;
        const tr = (0, $apqw1.closeHistory)(state.tr);
        if (panelNode && sliceHasTask && slice.content.firstChild?.type === panel && (0, $bFyUX.isEmptyNode)(panelNode) && selection.$from.node() === selection.$to.node()) return Boolean((0, $es8xl.insertSliceInsideOfPanelNodeSelected)(panelNode)({
            tr: tr,
            slice: slice
        }));
        const transformedSliceIsValidNode = (transformedSlice.content.firstChild.type.inlineContent || [
            'decisionList',
            'decisionItem',
            'taskItem',
            'taskList',
            'panel'
        ].includes(transformedSlice.content.firstChild.type.name)) && (!(0, $3ADzg.isInListItem)(state) || (0, $3ADzg.isInListItem)(state) && isFirstChildTaskNode);
        // If the slice or the selection are valid nodes to handle,
        // and the slice is not a whole node (i.e. openStart is 1 and openEnd is 0)
        // or the slice's first node is a paragraph,
        // then we can replace the selection with our slice.
        const pastingIntoExtendedPanel = selectionIsPanel && panel.validContent(transformedSlice.content);
        if ((transformedSliceIsValidNode || selectionIsValidNode) && !pastingIntoExtendedPanel && !(transformedSlice.openStart === 1 && transformedSlice.openEnd === 0 || // Whole codeblock node has reverse slice depths.
        transformedSlice.openStart === 0 && transformedSlice.openEnd === 1) || transformedSlice.content.firstChild?.type === paragraph) tr.replaceSelection(transformedSlice).scrollIntoView();
        else {
            const isWholeContentSelected = selection.$from.pos === selection.$from.start() && selection.$to.end() === selection.$to.pos;
            if (pastingIntoExtendedPanel && selection.$from.pos !== selection.$to.pos && !isWholeContentSelected) // Do a replaceSelection if the entire panel content isn't selected
            //tr.replaceSelection(transformedSlice).scrollIntoView();
            tr.replaceSelection(new (0, $3xw6l.Slice)(transformedSlice.content, 0, transformedSlice.openEnd)).scrollIntoView();
            else if ([
                'mediaSingle'
            ].includes(transformedSlice.content.firstChild.type.name) && selectionIsPanel) {
                const parentNode = (0, $BmspC.findParentNodeOfType)(panel)(selection);
                if (selectionIsPanel && parentNode && (0, $3ADzg.isNodeEmpty)(parentNode.node)) {
                    tr.insert(selection.$from.pos, transformedSlice.content).scrollIntoView();
                    // Place the cursor at the the end of the insersertion
                    const endPos = tr.selection.from + transformedSlice.size;
                    tr.setSelection(new (0, $3lIcL.TextSelection)(tr.doc.resolve(endPos)));
                } else tr.replaceSelection(transformedSlice).scrollIntoView();
            } else {
                if (pastingIntoExtendedPanel && isWholeContentSelected) // if the entire panel content is selected, doing a replaceSelection removes the panel as well. Hence we do delete followed by safeInsert
                tr.delete(selection.$from.pos, selection.$to.pos);
                // This maintains both the selection (destination) and the slice (paste content).
                (0, $BmspC.safeInsert)(transformedSlice.content)(tr).scrollIntoView();
                if (transformedSlice.content.lastChild?.type?.name === 'rule') tr.setSelection((0, $3lIcL.TextSelection).near(tr.doc.resolve(tr.selection.$from.pos + transformedSlice.content.size)));
                else {
                    // safeInsert doesn't set correct cursor position
                    // it moves the cursor to beginning of the node
                    // we manually shift the cursor to end of the node
                    const nextPos = tr.doc.resolve(tr.selection.$from.end());
                    tr.setSelection(new (0, $3lIcL.TextSelection)(nextPos));
                }
            }
        }
        queueCardsFromChangedTr?.(state, tr, (0, $bMFKb.INPUT_METHOD).CLIPBOARD);
        if (dispatch) dispatch(tr);
        return true;
    };
}
function $a3cc84ee80caab1f$export$b8a52be876d0b84f(slice) {
    return (state, dispatch)=>{
        const { tr: tr } = state;
        const { selection: selection } = tr;
        const { $from: $from, $to: $to, from: from, to: to } = selection;
        const { orderedList: orderedList, bulletList: bulletList, listItem: listItem } = state.schema.nodes;
        // Selected nodes
        const selectionParentListItemNode = (0, $BmspC.findParentNodeOfType)(listItem)(selection);
        const selectionParentListNodeWithPos = (0, $BmspC.findParentNodeOfType)([
            bulletList,
            orderedList
        ])(selection);
        const selectionParentListNode = selectionParentListNodeWithPos?.node;
        // Slice info
        const sliceContent = slice.content;
        const sliceIsListItems = (0, $fCXIH.isListNode)(sliceContent.firstChild) && (0, $fCXIH.isListNode)(sliceContent.lastChild);
        // Find case of slices that can be inserted into a list item
        // (eg. paragraphs, list items, code blocks, media single)
        // These scenarios already get handled elsewhere and don't need to split the list
        let sliceContainsBlockNodesOtherThanThoseAllowedInListItem = false;
        slice.content.forEach((child)=>{
            if (!listItem || child.isBlock && !listItem.spec.content?.includes(child.type.name)) sliceContainsBlockNodesOtherThanThoseAllowedInListItem = true;
        });
        if (!selectionParentListItemNode || !sliceContent || (0, $BmspC.canInsert)($from, sliceContent) || // eg. inline nodes that can be inserted in a list item
        !sliceContainsBlockNodesOtherThanThoseAllowedInListItem || sliceIsListItems || !selectionParentListNodeWithPos) return false;
        // Offsets
        const listWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth + 1; // difference in depth between to position and list node
        const listItemWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth; // difference in depth between to position and list item node
        // Anything to do with nested lists should safeInsert and not be handled here
        if ($a3cc84ee80caab1f$export$67c0f4368bb304c3(state)) return false;
        // Node after the insert position
        const nodeAfterInsertPositionIsListItem = tr.doc.nodeAt(to + listItemWrappingOffset)?.type.name === 'listItem';
        // Get the next list items position (used later to find the split out ordered list)
        const indexOfNextListItem = $to.indexAfter($to.depth - listItemWrappingOffset);
        const positionOfNextListItem = tr.doc.resolve(selectionParentListNodeWithPos.pos + 1).posAtIndex(indexOfNextListItem);
        // These nodes paste as plain text by default so need to be handled differently
        const sliceContainsNodeThatPastesAsPlainText = sliceContent.firstChild && [
            'taskItem',
            'taskList',
            'heading',
            'blockquote'
        ].includes(sliceContent.firstChild.type.name);
        // Work out position to replace up to
        let replaceTo;
        if (sliceContainsNodeThatPastesAsPlainText && nodeAfterInsertPositionIsListItem) replaceTo = to + listItemWrappingOffset;
        else if (sliceContainsNodeThatPastesAsPlainText || !nodeAfterInsertPositionIsListItem) replaceTo = to;
        else replaceTo = to + listWrappingOffset;
        // handle the insertion of the slice
        if (slice.content.firstChild?.type.name === 'blockquote' && (0, $BmspC.contains)(slice.content.firstChild, state.schema.nodes.listItem)) (0, $3CAWf.insertSliceInsideBlockquote)({
            tr: tr,
            slice: slice
        });
        else if (sliceContainsNodeThatPastesAsPlainText || nodeAfterInsertPositionIsListItem || sliceContent.childCount > 1 && sliceContent.firstChild?.type.name !== 'paragraph') tr.replaceWith(from, replaceTo, sliceContent).scrollIntoView();
        else // When the selection is not at the end of a list item
        // eg. middle of list item, start of list item
        tr.replaceSelection(slice).scrollIntoView();
        // Find the ordered list node after the pasted content so we can set it's order
        const mappedPositionOfNextListItem = tr.mapping.map(positionOfNextListItem);
        if (mappedPositionOfNextListItem > tr.doc.nodeSize) return false;
        const nodeAfterPastedContentResolvedPos = (0, $BmspC.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(mappedPositionOfNextListItem), [
            orderedList
        ]);
        // Work out the new split out lists 'order' (the number it starts from)
        const originalParentOrderedListNodeOrder = selectionParentListNode?.attrs.order;
        const numOfListItemsInOriginalList = (0, $BmspC.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(from - 1), [
            orderedList
        ])?.node.childCount;
        // Set the new split out lists order attribute
        if (typeof originalParentOrderedListNodeOrder === 'number' && numOfListItemsInOriginalList && nodeAfterPastedContentResolvedPos) tr.setNodeMarkup(nodeAfterPastedContentResolvedPos.pos, orderedList, {
            ...nodeAfterPastedContentResolvedPos.node.attrs,
            order: originalParentOrderedListNodeOrder + numOfListItemsInOriginalList
        });
        // dispatch transaction
        if (tr.docChanged) {
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
const $a3cc84ee80caab1f$export$c2473d50cf33051b = (selection, findRootParentListNode)=>{
    const { $from: $from, $to: $to, from: from, to: to } = selection;
    const selectionParentListItemNodeResolvedPos = findRootParentListNode ? findRootParentListNode($from) || findRootParentListNode($to) : null;
    const selectionParentListNode = selectionParentListItemNodeResolvedPos?.parent;
    if (!selectionParentListItemNodeResolvedPos || !selectionParentListNode) return false;
    const startOfEntireList = $from.pos < $to.pos ? selectionParentListItemNodeResolvedPos.pos + $from.depth - 1 : selectionParentListItemNodeResolvedPos.pos + $to.depth - 1;
    const endOfEntireList = $from.pos < $to.pos ? selectionParentListItemNodeResolvedPos.pos + selectionParentListNode.nodeSize - $to.depth - 1 : selectionParentListItemNodeResolvedPos.pos + selectionParentListNode.nodeSize - $from.depth - 1;
    if (!startOfEntireList || !endOfEntireList) return false;
    if (from < to) return startOfEntireList >= $from.pos && endOfEntireList <= $to.pos;
    else if (from > to) return startOfEntireList >= $to.pos && endOfEntireList <= $from.pos;
    else return false;
};
function $a3cc84ee80caab1f$export$3fd7f6d89a9d2cac(slice, findRootParentListNode) {
    return (state, dispatch)=>{
        const { schema: schema, tr: tr } = state;
        const { selection: selection } = tr;
        // Check this pasting action is related to copy content from panel node into a selected the list node
        const blockNode = slice.content.firstChild;
        const isSliceWholeNode = slice.openStart === 0 && slice.openEnd === 0;
        const selectionParentListItemNode = selection.$to.node(selection.$to.depth - 1);
        const sliceIsWholeNodeButShouldNotReplaceSelection = isSliceWholeNode && !$a3cc84ee80caab1f$export$c2473d50cf33051b(selection, findRootParentListNode);
        if (!selectionParentListItemNode || selectionParentListItemNode?.type !== schema.nodes.listItem || !blockNode || ![
            'panel',
            'decisionList'
        ].includes(blockNode?.type.name) || slice.content.childCount > 1 || blockNode?.content.firstChild === undefined || sliceIsWholeNodeButShouldNotReplaceSelection) return false;
        // Paste the panel node contents extracted instead of pasting the entire panel node
        tr.replaceSelection(slice).scrollIntoView();
        if (dispatch) dispatch(tr);
        return true;
    };
}
const $a3cc84ee80caab1f$var$innerTextRangeOfTextblock = (doc, posOfBlock)=>{
    const block = doc.nodeAt(posOfBlock);
    if (!block || !block.isTextblock) return null;
    // raw content bounds
    const contentStart = posOfBlock + 1; // +1 to move from node's start token to content start
    const contentEnd = contentStart + block.content.size;
    // clamp to doc coord space
    const start = Math.max(0, Math.min(contentStart, doc.content.size));
    const end = Math.max(0, Math.min(contentEnd, doc.content.size));
    if (end <= start) return null;
    // snap to nearest valid text positions
    const startSel = (0, $3lIcL.TextSelection).findFrom(doc.resolve(start), 1, true);
    const endSel = (0, $3lIcL.TextSelection).findFrom(doc.resolve(end), -1, true);
    if (!startSel || !endSel) return null;
    const from = startSel.$from.pos;
    const to = endSel.$to.pos;
    return to > from ? {
        from: from,
        to: to
    } : null;
};
function $a3cc84ee80caab1f$var$resolveSingleTextblockRangeIfAllSelected(state) {
    const sel = state.selection;
    if (!(sel instanceof (0, $3lIcL.AllSelection))) return null;
    let count = 0;
    let posOfBlock = -1;
    state.doc.nodesBetween(sel.from, sel.to, (node, pos)=>{
        if (!node.isTextblock) return true;
        count++;
        if (count > 1) return false;
        posOfBlock = pos;
        return true;
    });
    if (count !== 1) return null;
    return $a3cc84ee80caab1f$var$innerTextRangeOfTextblock(state.doc, posOfBlock);
}
function $a3cc84ee80caab1f$export$5e27b285bdcc71bf(slice) {
    return (state, dispatch)=>{
        const { schema: schema, selection: selection, selection: { from: from, to: to }, tr: tr } = state;
        let linkMark;
        // check if we have a link on the clipboard
        if (slice.content.childCount === 1 && (0, $9Ssie.isParagraph)(slice.content.child(0), schema)) {
            const paragraph = slice.content.child(0);
            if (paragraph.content.childCount === 1 && (0, $9Ssie.isText)(paragraph.content.child(0), schema)) {
                const text = paragraph.content.child(0);
                // If pasteType is plain text, then
                //  @atlaskit/editor-markdown-transformer in getMarkdownSlice decode
                //  url before setting text property of text node.
                //  However href of marks will be without decoding.
                //  So, if there is character (e.g space) in url eligible escaping then
                //  mark.attrs.href will not be equal to text.text.
                //  That's why decoding mark.attrs.href before comparing.
                // However, if pasteType is richText, that means url in text.text
                //  and href in marks, both won't be decoded.
                linkMark = text.marks.find((mark)=>(0, $9Ssie.isLinkMark)(mark, schema) && (mark.attrs.href === text.text || decodeURI(mark.attrs.href) === text.text));
            }
        }
        // derive a linkable range if possible for Select‑All over a single textblock
        const selectAllRange = (0, $eGOwo.fg)('platform_editor_link_paste_select_all') ? $a3cc84ee80caab1f$var$resolveSingleTextblockRangeIfAllSelected(state) : null;
        const rangeFrom = selectAllRange?.from ?? from;
        const rangeTo = selectAllRange?.to ?? to;
        // if we have a link, apply it to the selected text if we have any and it's allowed
        if (linkMark && (selection instanceof (0, $3lIcL.TextSelection) || Boolean(selectAllRange)) && !selection.empty && (0, $grDTV.canLinkBeCreatedInRange)(rangeFrom, rangeTo)(state)) {
            tr.addMark(rangeFrom, rangeTo, linkMark);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
function $a3cc84ee80caab1f$export$efe55f809fabb910(slice, _event, editorAnalyticsAPI) {
    return (state, dispatch, view)=>{
        if (!view) return false;
        // prosemirror-bump-fix
        // Yes, this is wrong by default. But, we need to keep the private PAI usage to unblock the prosemirror bump
        // So, this code will make sure we are checking for both version (current and the newest prosemirror-view version
        const isShiftKeyPressed = // eslint-disable-next-line @typescript-eslint/no-explicit-any
        view.shiftKey || view.input?.shiftKey;
        // In case of SHIFT+CMD+V ("Paste and Match Style") we don't want to run the usual
        // fuzzy matching of content. ProseMirror already handles this scenario and will
        // provide us with slice containing paragraphs with plain text, which we decorate
        // with "stored marks".
        // @see prosemirror-view/src/clipboard.js:parseFromClipboard()).
        // @see prosemirror-view/src/input.js:doPaste().
        if (isShiftKeyPressed) {
            let tr = (0, $apqw1.closeHistory)(state.tr);
            const { selection: selection } = tr;
            // <- using the same internal flag that prosemirror-view is using
            // if user has selected table we need custom logic to replace the table
            tr = (0, $8hKAd.replaceSelectedTable)(state, slice);
            // add analytics after replacing selected table
            tr = (0, $bFyUX.addReplaceSelectedTableAnalytics)(state, tr, editorAnalyticsAPI);
            // otherwise just replace the selection
            if (!tr.docChanged) tr.replaceSelection(slice);
            (state.storedMarks || []).forEach((mark)=>{
                tr.addMark(selection.from, selection.from + slice.size, mark);
            });
            tr.scrollIntoView();
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
function $a3cc84ee80caab1f$export$de618421675f910e(slice, queueCardsFromChangedTr) {
    return (state, dispatch)=>{
        const { schema: schema, tr: { selection: selection } } = state;
        const { marks: { code: codeMark, annotation: annotationMark }, nodes: { bulletList: bulletList, emoji: emoji, hardBreak: hardBreak, heading: heading, listItem: listItem, mention: mention, orderedList: orderedList, text: text } } = schema;
        if (!(selection instanceof (0, $3lIcL.TextSelection))) return false;
        const selectionMarks = selection.$head.marks();
        if (selectionMarks.length === 0) return false;
        // special case for codeMark: will preserve mark only if codeMark is currently active
        // won't preserve mark if cursor is on the edge on the mark (namely inactive)
        const hasActiveCodeMark = codeMark && codeMark.isInSet(selectionMarks) && (0, $02q9c.anyMarkActive)(state, codeMark);
        const hasAnnotationMark = annotationMark && annotationMark.isInSet(selectionMarks);
        const selectionIsHeading = (0, $BmspC.hasParentNodeOfType)([
            heading
        ])(state.selection);
        // if the pasted data is one of the node types below
        // we apply current selection marks to the pasted slice
        if ((0, $bFyUX.hasOnlyNodesOfType)(bulletList, hardBreak, heading, listItem, text, emoji, mention, orderedList)(slice) || selectionIsHeading || hasActiveCodeMark || hasAnnotationMark) {
            const transformedSlice = (0, $bFyUX.applyTextMarksToSlice)(schema, selectionMarks)(slice);
            const tr = (0, $apqw1.closeHistory)(state.tr).replaceSelection(transformedSlice).setStoredMarks(selectionMarks).scrollIntoView();
            queueCardsFromChangedTr?.(state, tr, (0, $bMFKb.INPUT_METHOD).CLIPBOARD);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
async function $a3cc84ee80caab1f$var$getSmartLinkAdf(text, type, cardOptions) {
    if (!cardOptions.provider) throw Error('No card provider found');
    const provider = await cardOptions.provider;
    return await provider.resolve(text, type);
}
function $a3cc84ee80caab1f$var$insertAutoMacro(slice, macro, view, from, to) {
    if (view) {
        // insert the text or linkified/md-converted clipboard data
        const selection = view.state.tr.selection;
        let tr;
        let before;
        if (typeof from === 'number' && typeof to === 'number') {
            tr = view.state.tr.replaceRange(from, to, slice);
            before = tr.mapping.map(from, -1);
        } else {
            tr = view.state.tr.replaceSelection(slice);
            before = tr.mapping.map(selection.from, -1);
        }
        view.dispatch(tr);
        // replace the text with the macro as a separate transaction
        // so the autoconversion generates 2 undo steps
        view.dispatch((0, $apqw1.closeHistory)(view.state.tr).replaceRangeWith(before, before + slice.size, macro).scrollIntoView());
        return true;
    }
    return false;
}
function $a3cc84ee80caab1f$export$d23738992a74c3a9(text, slice, queueCardsFromChangedTr, runMacroAutoConvert, cardsOptions, extensionAutoConverter) {
    return (state, dispatch, view)=>{
        let macro = null;
        // try to use auto convert from extension provider first
        if (extensionAutoConverter) {
            const extension = extensionAutoConverter(text);
            if (extension) macro = (0, $3xw6l.Node).fromJSON(state.schema, extension);
        }
        // then try from macro provider (which will be removed some time in the future)
        if (!macro) macro = runMacroAutoConvert?.(state, text) ?? null;
        if (macro) {
            /**
			 * if FF enabled, run through smart links and check for result
			 */ if (cardsOptions && cardsOptions.resolveBeforeMacros && cardsOptions.resolveBeforeMacros.length) {
                if (cardsOptions.resolveBeforeMacros.indexOf(macro.attrs.extensionKey) < 0) return $a3cc84ee80caab1f$var$insertAutoMacro(slice, macro, view);
                if (!view) throw new Error('View is missing');
                const trackingId = (0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))();
                const trackingFrom = `handleMacroAutoConvert-from-${trackingId}`;
                const trackingTo = `handleMacroAutoConvert-to-${trackingId}`;
                (0, $1CqHB.startTrackingPastedMacroPositions)({
                    [trackingFrom]: state.selection.from,
                    [trackingTo]: state.selection.to
                })(state, dispatch);
                $a3cc84ee80caab1f$var$getSmartLinkAdf(text, 'inline', cardsOptions).then(()=>{
                    // we use view.state rather than state because state becomes a stale
                    // state reference after getSmartLinkAdf's async work
                    const { pastedMacroPositions: pastedMacroPositions } = (0, $3Elhj.getPluginState)(view.state);
                    if (dispatch) $a3cc84ee80caab1f$export$4b83e18c607f848f(slice, queueCardsFromChangedTr, pastedMacroPositions[trackingFrom], pastedMacroPositions[trackingTo])(view.state, dispatch);
                }).catch(()=>{
                    const { pastedMacroPositions: pastedMacroPositions } = (0, $3Elhj.getPluginState)(view.state);
                    $a3cc84ee80caab1f$var$insertAutoMacro(slice, macro, view, pastedMacroPositions[trackingFrom], pastedMacroPositions[trackingTo]);
                }).finally(()=>{
                    (0, $1CqHB.stopTrackingPastedMacroPositions)([
                        trackingFrom,
                        trackingTo
                    ])(view.state, dispatch);
                });
                return true;
            }
            return $a3cc84ee80caab1f$var$insertAutoMacro(slice, macro, view);
        }
        return !!macro;
    };
}
function $a3cc84ee80caab1f$export$98135102f7ccdef2(text) {
    return (state, dispatch)=>{
        const { codeBlock: codeBlock } = state.schema.nodes;
        if (text && (0, $BmspC.hasParentNodeOfType)(codeBlock)(state.selection)) {
            const tr = (0, $apqw1.closeHistory)(state.tr);
            tr.scrollIntoView();
            if (dispatch) dispatch(tr.insertText(text));
            return true;
        }
        return false;
    };
}
function $a3cc84ee80caab1f$var$isOnlyMedia(state, slice) {
    const { media: media } = state.schema.nodes;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return slice.content.childCount === 1 && slice.content.firstChild.type === media;
}
function $a3cc84ee80caab1f$var$isOnlyMediaSingle(state, slice) {
    const { mediaSingle: mediaSingle } = state.schema.nodes;
    return(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    mediaSingle && slice.content.childCount === 1 && slice.content.firstChild.type === mediaSingle);
}
function $a3cc84ee80caab1f$export$5fb647c5a57bac64(inputMethod, insertMediaAsMediaSingle) {
    return function(slice) {
        return (state, dispatch, view)=>{
            if (view) {
                if ($a3cc84ee80caab1f$var$isOnlyMedia(state, slice)) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return insertMediaAsMediaSingle?.(view, slice.content.firstChild, inputMethod) ?? false;
                if ((0, $eQTBG.insideTable)(state) && $a3cc84ee80caab1f$var$isOnlyMediaSingle(state, slice)) {
                    const tr = state.tr.replaceSelection(slice);
                    const nextPos = tr.doc.resolve(tr.mapping.map(state.selection.$from.pos));
                    if (dispatch) dispatch(tr.setSelection(new (0, $6BNUN.GapCursorSelection)(nextPos, (0, $6BNUN.Side).RIGHT)));
                    return true;
                }
            }
            return false;
        };
    };
}
const $a3cc84ee80caab1f$var$hasTopLevelExpand = (slice)=>{
    let hasExpand = false;
    slice.content.forEach((node)=>{
        if (node.type.name === 'expand' || node.type.name === 'nestedExpand') hasExpand = true;
    });
    return hasExpand;
};
function $a3cc84ee80caab1f$export$36e0fe2cadced224(slice) {
    return (state, dispatch)=>{
        const isInsideBodyExtension = (0, $BmspC.hasParentNodeOfType)(state.schema.nodes.bodiedExtension)(state.selection);
        if (!(0, $eQTBG.insideTable)(state) || !isInsideBodyExtension) return false;
        const { bodiedExtension: bodiedExtension } = state.schema.nodes;
        const newSlice = (0, $gbisc.mapSlice)(slice, (maybeNode)=>{
            if (maybeNode.type === bodiedExtension) return bodiedExtension.createChecked(maybeNode.attrs, maybeNode.content, maybeNode.marks);
            return maybeNode;
        });
        if (dispatch) {
            dispatch(state.tr.replaceSelection(newSlice));
            return true;
        }
        return false;
    };
}
function $a3cc84ee80caab1f$export$113227139658cc8d(slice, isNestingTablesSupported) {
    return (state, dispatch)=>{
        if (!isNestingTablesSupported || !(0, $eQTBG.insideTable)(state)) return false;
        const { schema: schema, selection: selection } = state;
        let sliceHasTable = false;
        slice.content.forEach((node)=>{
            if (node.type === state.schema.nodes.table) sliceHasTable = true;
        });
        if (sliceHasTable) {
            if ((0, $92xoS.editorExperiment)('nested-tables-in-tables', true, {
                exposure: true
            })) /* TEST COHORT */ // if slice has table - if pasting to deeply nested location place paste after top table
            {
                if ((0, $lQJJa.getParentOfTypeCount)(schema.nodes.table)(selection.$from) > 1) {
                    const positionAfterTopTable = (0, $lQJJa.getPositionAfterTopParentNodeOfType)(schema.nodes.table)(selection.$from);
                    let { tr: tr } = state;
                    tr = (0, $BmspC.safeInsert)(slice.content, positionAfterTopTable)(tr);
                    tr.scrollIntoView();
                    if (dispatch) {
                        dispatch(tr);
                        return true;
                    }
                }
            } else {
                /* CONTROL COHORT */ // if slice has table - place paste after top table
                const positionAfterTopTable = (0, $lQJJa.getPositionAfterTopParentNodeOfType)(schema.nodes.table)(selection.$from);
                let { tr: tr } = state;
                tr = (0, $BmspC.safeInsert)(slice.content, positionAfterTopTable)(tr);
                tr.scrollIntoView();
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
            }
        }
        return false;
    };
}
function $a3cc84ee80caab1f$export$a497757c6eac4530(slice) {
    return (state, dispatch)=>{
        const isInsideNestableExpand = !!$a3cc84ee80caab1f$var$insideExpand(state);
        // Do not handle expand if it's not being pasted into a table or expand
        // OR if it's nested within another node when being pasted into a table/expand
        if (!(0, $eQTBG.insideTable)(state) && !isInsideNestableExpand || !$a3cc84ee80caab1f$var$hasTopLevelExpand(slice)) return false;
        const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
        let { tr: tr } = state;
        let hasExpand = false;
        const newSlice = (0, $gbisc.mapSlice)(slice, (maybeNode)=>{
            if (maybeNode.type === expand || maybeNode.type === nestedExpand) {
                hasExpand = true;
                try {
                    return nestedExpand.createChecked(maybeNode.attrs, maybeNode.content, maybeNode.marks);
                } catch (e) {
                    tr = (0, $BmspC.safeInsert)(maybeNode, tr.selection.$to.pos)(tr);
                    return (0, $3xw6l.Fragment).empty;
                }
            }
            return maybeNode;
        });
        if (hasExpand && dispatch) {
            // If the slice is a subset, we can let PM replace the selection
            // it will insert as text where it can't place the node.
            // Otherwise we use safeInsert to insert below instead of
            // replacing/splitting the current node.
            if (slice.openStart > 1 && slice.openEnd > 1) dispatch(tr.replaceSelection(newSlice));
            else dispatch((0, $BmspC.safeInsert)(newSlice.content)(tr));
            return true;
        }
        return false;
    };
}
function $a3cc84ee80caab1f$export$4b83e18c607f848f(markdownSlice, queueCardsFromChangedTr, from, to) {
    return (state, dispatch)=>{
        const tr = (0, $apqw1.closeHistory)(state.tr);
        const pastesFrom = typeof from === 'number' ? from : tr.selection.from;
        if (typeof from === 'number' && typeof to === 'number') tr.replaceRange(from, to, markdownSlice);
        else tr.replaceSelection(markdownSlice);
        const textPosition = tr.doc.resolve(Math.min(pastesFrom + markdownSlice.size, tr.doc.content.size));
        tr.setSelection((0, $3lIcL.TextSelection).near(textPosition, -1));
        queueCardsFromChangedTr?.(state, tr, (0, $bMFKb.INPUT_METHOD).CLIPBOARD);
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
}
function $a3cc84ee80caab1f$var$removePrecedingBackTick(tr) {
    const { $from: { nodeBefore: nodeBefore }, from: from } = tr.selection;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if (nodeBefore && nodeBefore.isText && nodeBefore.text.endsWith('`')) tr.delete(from - 1, from);
}
function $a3cc84ee80caab1f$var$hasInlineCode(state, slice) {
    return slice.content.firstChild && slice.content.firstChild.marks.some((m)=>m.type === state.schema.marks.code);
}
function $a3cc84ee80caab1f$var$rollupLeafListItems(list, leafListItems) {
    list.content.forEach((child)=>{
        if ((0, $fCXIH.isListNode)(child) || (0, $fCXIH.isListItemNode)(child) && (0, $fCXIH.isListNode)(child.firstChild)) $a3cc84ee80caab1f$var$rollupLeafListItems(child, leafListItems);
        else leafListItems.push(child);
    });
}
function $a3cc84ee80caab1f$var$shouldFlattenList(state, slice) {
    const node = slice.content.firstChild;
    return node && (0, $eQTBG.insideTable)(state) && (0, $fCXIH.isListNode)(node) && slice.openStart > slice.openEnd;
}
function $a3cc84ee80caab1f$var$sliceHasTopLevelMarks(slice) {
    let hasTopLevelMarks = false;
    slice.content.descendants((node)=>{
        if (node.marks.length > 0) hasTopLevelMarks = true;
        return false;
    });
    return hasTopLevelMarks;
}
function $a3cc84ee80caab1f$var$getTopLevelMarkTypesInSlice(slice) {
    const markTypes = new Set();
    slice.content.descendants((node)=>{
        node.marks.map((mark)=>mark.type).forEach((markType)=>markTypes.add(markType));
        return false;
    });
    return markTypes;
}
function $a3cc84ee80caab1f$export$feb0d61bf65d9267(state, slice) {
    if (slice.content.size === 0) return slice;
    const { schema: schema, selection: { $from: $from } } = state;
    // If no paragraph in the slice contains marks, there's no need for special handling
    // Note: this doesn't check for marks applied to lower level nodes such as text
    if (!$a3cc84ee80caab1f$var$sliceHasTopLevelMarks(slice)) return slice;
    // If pasting a single paragraph into pre-existing content, match destination formatting
    const destinationHasContent = $from.parent.textContent.length > 0;
    if (slice.content.childCount === 1 && destinationHasContent) return slice;
    // Check the parent of (paragraph -> text) because block marks are assigned to a wrapper
    // element around the paragraph node
    const grandparent = $from.node(Math.max(0, $from.depth - 1));
    const markTypesInSlice = $a3cc84ee80caab1f$var$getTopLevelMarkTypesInSlice(slice);
    const forbiddenMarkTypes = [];
    for (const markType of markTypesInSlice)if (!grandparent.type.allowsMarkType(markType)) forbiddenMarkTypes.push(markType);
    if (forbiddenMarkTypes.length === 0) {
        // In a slice containing one or more paragraphs at the document level (not wrapped in
        // another node), the first paragraph will only have its text content captured and pasted
        // since openStart is 1. We decrement the open depth of the slice so it retains any block
        // marks applied to it. We only care about the depth at the start of the selection so
        // there's no need to change openEnd - the rest of the slice gets pasted correctly.
        const openStart = Math.max(0, slice.openStart - 1);
        return new (0, $3xw6l.Slice)(slice.content, openStart, slice.openEnd);
    }
    // If the paragraph or heading contains marks forbidden by the parent node
    // (e.g. alignment/indentation), drop those marks from the slice
    return (0, $gbisc.mapSlice)(slice, (node)=>{
        if (node.type === schema.nodes.paragraph) return schema.nodes.paragraph.createChecked(undefined, node.content, node.marks.filter((mark)=>!forbiddenMarkTypes.includes(mark.type)));
        else if (node.type === schema.nodes.heading) // Preserve heading attributes to keep formatting
        return schema.nodes.heading.createChecked(node.attrs, node.content, node.marks.filter((mark)=>!forbiddenMarkTypes.includes(mark.type)));
        return node;
    });
}
function $a3cc84ee80caab1f$export$79d83373d2946ba6(slice) {
    if (!slice.content.firstChild) return slice;
    const listToFlatten = slice.content.firstChild;
    const leafListItems = [];
    $a3cc84ee80caab1f$var$rollupLeafListItems(listToFlatten, leafListItems);
    const contentWithFlattenedList = slice.content.replaceChild(0, listToFlatten.type.createChecked(listToFlatten.attrs, leafListItems));
    return new (0, $3xw6l.Slice)(contentWithFlattenedList, slice.openEnd, slice.openEnd);
}
function $a3cc84ee80caab1f$export$f9c7e15c780a77d0(slice, queueCardsFromChangedTr) {
    return (state, dispatch)=>{
        const { codeBlock: codeBlock, heading: heading, paragraph: paragraph, panel: panel } = state.schema.nodes;
        const { selection: selection, schema: schema } = state;
        const firstChildOfSlice = slice.content?.firstChild;
        const lastChildOfSlice = slice.content?.lastChild;
        // In case user is pasting inline code,
        // any backtick ` immediately preceding it should be removed.
        let tr = state.tr;
        if ($a3cc84ee80caab1f$var$hasInlineCode(state, slice)) $a3cc84ee80caab1f$var$removePrecedingBackTick(tr);
        if ($a3cc84ee80caab1f$var$shouldFlattenList(state, slice)) slice = $a3cc84ee80caab1f$export$79d83373d2946ba6(slice);
        (0, $apqw1.closeHistory)(tr);
        const isFirstChildListNode = (0, $fCXIH.isListNode)(firstChildOfSlice);
        const isLastChildListNode = (0, $fCXIH.isListNode)(lastChildOfSlice);
        const isSliceContentListNodes = isFirstChildListNode || isLastChildListNode;
        const isFirstChildTaskListNode = firstChildOfSlice?.type?.name === 'taskList';
        const isLastChildTaskListNode = lastChildOfSlice?.type?.name === 'taskList';
        const isSliceContentTaskListNodes = isFirstChildTaskListNode || isLastChildTaskListNode;
        // We want to use safeInsert to insert invalid content, as it inserts at the closest non schema violating position
        // rather than spliting the selection parent node in half (which is what replaceSelection does)
        // Exception is paragraph and heading nodes, these should be split, provided their parent supports the pasted content
        const textNodes = [
            heading,
            paragraph
        ];
        const selectionParent = selection.$to.node(selection.$to.depth - 1);
        const noNeedForSafeInsert = selection.$to.node().type.validContent(slice.content) || textNodes.includes(selection.$to.node().type) && selectionParent.type.validContent(slice.content);
        const panelParentOverCurrentSelection = (0, $BmspC.findParentNodeOfType)(panel)(tr.selection);
        const isTargetPanelEmpty = panelParentOverCurrentSelection && panelParentOverCurrentSelection.node?.content.size === 2;
        if (!isSliceContentTaskListNodes && (isSliceContentListNodes || isTargetPanelEmpty)) (0, $3CAWf.insertSliceForLists)({
            tr: tr,
            slice: slice,
            schema: schema
        });
        else if (noNeedForSafeInsert) {
            if (firstChildOfSlice?.type?.name === 'blockquote' && firstChildOfSlice?.content.firstChild?.type.name && [
                'bulletList',
                'orderedList',
                'mediaSingle'
            ].includes(firstChildOfSlice?.content.firstChild?.type.name)) // checks if parent node is a blockquote and child node is either a bulletlist or orderedlist or mediaSingle
            (0, $3CAWf.insertSliceInsideBlockquote)({
                tr: tr,
                slice: slice
            });
            else {
                tr.replaceSelection(slice);
                // when cursor is inside a table cell, and slice.content.lastChild is a panel, expand, or decisionList
                // need to make sure the cursor position is is right after the panel, expand, or decisionList
                // still in the same table cell, see issue: https://product-fabric.atlassian.net/browse/ED-17862
                const shouldUpdateCursorPosAfterPaste = [
                    'panel',
                    'nestedExpand',
                    'decisionList',
                    'codeBlock'
                ].includes(slice.content.lastChild?.type?.name || '');
                const lastChild = slice.content.lastChild;
                const $nextPos = tr.doc.resolve(tr.mapping.map(selection.from));
                const nextSelection = lastChild?.type.isTextblock ? (0, $3lIcL.TextSelection).findFrom($nextPos, -1, true) : new (0, $6BNUN.GapCursorSelection)($nextPos, (0, $6BNUN.Side).RIGHT);
                if (nextSelection) tr.setSelection(nextSelection);
                else if ((0, $3ADzg.insideTableCell)(state) && shouldUpdateCursorPosAfterPaste) {
                    const nextPos = tr.doc.resolve(tr.mapping.map(selection.$from.pos));
                    tr.setSelection(new (0, $6BNUN.GapCursorSelection)(nextPos, (0, $6BNUN.Side).RIGHT));
                }
            }
        } else {
            // need to scan the slice if there's a block node or list items inside it
            let sliceHasList = false;
            slice.content.nodesBetween(0, slice.content.size, (node, start)=>{
                if (node.type === state.schema.nodes.listItem) {
                    sliceHasList = true;
                    return false;
                }
            });
            if ((0, $3ADzg.insideTableCell)(state) && (0, $3ADzg.isInListItem)(state) && (0, $BmspC.canInsert)(selection.$from, slice.content) && (0, $BmspC.canInsert)(selection.$to, slice.content) || sliceHasList) tr.replaceSelection(slice);
            else if ($a3cc84ee80caab1f$export$f0f8559835c0f076(state, slice) && !$a3cc84ee80caab1f$export$67c0f4368bb304c3(state)) (0, $3CAWf.insertSliceForTaskInsideList)({
                tr: tr,
                slice: slice
            });
            else {
                // need safeInsert rather than replaceSelection, so that nodes aren't split in half
                // e.g. when pasting a layout into a table, replaceSelection splits the table in half and adds the layout in the middle
                tr = (0, $BmspC.safeInsert)(slice.content, tr.selection.$to.pos)(tr);
                if ($a3cc84ee80caab1f$export$f0f8559835c0f076(state, slice)) (0, $3CAWf.updateSelectionAfterReplace)({
                    tr: tr
                });
            }
        }
        tr.setStoredMarks([]);
        if (tr.selection.empty && tr.selection.$from.parent.type === codeBlock) tr.setSelection((0, $3lIcL.TextSelection).near(tr.selection.$from, 1));
        tr.scrollIntoView();
        // queue link cards, ignoring any errors
        queueCardsFromChangedTr?.(state, tr, (0, $bMFKb.INPUT_METHOD).CLIPBOARD);
        if (dispatch) dispatch(tr);
        return true;
    };
}
function $a3cc84ee80caab1f$var$isUrlString(text) {
    try {
        new URL(text);
        return true;
    } catch  {
        return false;
    }
}
function $a3cc84ee80caab1f$var$isLinkOrUrlString(slice, schema) {
    if (slice.content.childCount !== 1 || !(0, $9Ssie.isParagraph)(slice.content.child(0), schema)) return false;
    const paragraph = slice.content.child(0);
    if (paragraph.content.childCount !== 1 || !(0, $9Ssie.isText)(paragraph.content.child(0), schema)) return false;
    const { marks: marks, text: text = '' } = paragraph.content.child(0);
    const hasLinkMark = marks.some((mark)=>(0, $9Ssie.isLinkMark)(mark, schema));
    return hasLinkMark || $a3cc84ee80caab1f$var$isUrlString(text);
}
function $a3cc84ee80caab1f$export$d399a86cc775ad7e(slice) {
    return (state, dispatch)=>{
        if ((0, $eGOwo.fg)('platform_editor_fix_captions_on_copy')) {
            if ($a3cc84ee80caab1f$var$isLinkOrUrlString(slice, state.schema)) return false;
        }
        const { caption: caption } = state.schema.nodes;
        const tr = state.tr;
        if ((0, $BmspC.hasParentNodeOfType)(caption)(state.selection)) {
            // We let PM replace the selection and it will insert as text where it can't place the node
            // This is totally fine as caption is just a simple block that only contains inline contents
            // And it is more in line with WYSIWYG expectations
            tr.replaceSelection(slice).scrollIntoView();
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
const $a3cc84ee80caab1f$export$4ce587bb5876886d = (editorAnalyticsAPI)=>(slice)=>(state, dispatch)=>{
            let tr = (0, $8hKAd.replaceSelectedTable)(state, slice);
            // add analytics after replacing selected table
            tr = (0, $bFyUX.addReplaceSelectedTableAnalytics)(state, tr, editorAnalyticsAPI);
            if (tr.docChanged) {
                if (dispatch) dispatch(tr);
                return true;
            }
            return false;
        };
function $a3cc84ee80caab1f$export$f0f8559835c0f076(state, slice) {
    return Boolean((0, $3ADzg.isInListItem)(state) && [
        'taskList',
        'taskItem'
    ].includes(slice.content.firstChild?.type?.name || ''));
}
function $a3cc84ee80caab1f$export$67c0f4368bb304c3(state) {
    const { selection: selection, tr: tr } = state;
    const { orderedList: orderedList, bulletList: bulletList, listItem: listItem } = state.schema.nodes;
    const selectionParentListItemNode = (0, $BmspC.findParentNodeOfType)(listItem)(selection);
    const selectionParentListNodeWithPos = (0, $BmspC.findParentNodeOfType)([
        bulletList,
        orderedList
    ])(selection);
    if (!selectionParentListItemNode || !selectionParentListNodeWithPos) return false;
    const grandParentListNode = (0, $BmspC.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(selectionParentListNodeWithPos.pos), [
        bulletList,
        orderedList
    ]);
    const selectionIsInNestedList = !!grandParentListNode;
    let selectedListItemHasNestedList = false;
    selectionParentListItemNode.node.content.forEach((child)=>{
        if ((0, $fCXIH.isListNode)(child)) selectedListItemHasNestedList = true;
    });
    return selectedListItemHasNestedList || selectionIsInNestedList;
}

});
parcelRegister("8hKAd", function(module, exports) {
$parcel$export(module.exports, "replaceSelectedTable", () => $149d5104da03519c$export$ea73b328547c6ad5);

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $kuDbA = parcelRequire("kuDbA");

var $bctVO = parcelRequire("bctVO");
const $149d5104da03519c$export$ea73b328547c6ad5 = (state, content)=>{
    if ((0, $bctVO.isTableSelected)(state.selection)) {
        const table = (0, $kuDbA.findTable)(state.selection);
        if (table) {
            const slice = typeof content === 'string' ? new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(state.schema.text(content)), 0, 0) : content;
            const tr = state.tr.replace(table.pos, table.pos + table.node.nodeSize, slice);
            tr.setSelection((0, $3lIcL.TextSelection).create(tr.doc, table.pos + slice.size + 1));
            return tr;
        }
    }
    return state.tr;
};

});

parcelRegister("3CAWf", function(module, exports) {
$parcel$export(module.exports, "insertSliceForLists", () => $2c28ee3918adf3eb$export$9beec16307c108ac);
$parcel$export(module.exports, "insertSliceInsideBlockquote", () => $2c28ee3918adf3eb$export$2dee216d0a70c94e);
$parcel$export(module.exports, "updateSelectionAfterReplace", () => $2c28ee3918adf3eb$export$e57c13697a8b8195);
$parcel$export(module.exports, "insertSliceForTaskInsideList", () => $2c28ee3918adf3eb$export$2982aac953f7c8b6);

var $fCXIH = parcelRequire("fCXIH");

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $lzEKq = parcelRequire("lzEKq");

var $BmspC = parcelRequire("BmspC");

var $bFyUX = parcelRequire("bFyUX");

var $es8xl = parcelRequire("es8xl");
function $2c28ee3918adf3eb$export$9beec16307c108ac({ tr: tr, slice: slice, schema: schema }) {
    const { selection: selection, selection: { $to: $to, $from: $from } } = tr;
    const { $cursor: $cursor } = selection;
    const panelNode = (0, $bFyUX.isSelectionInsidePanel)(selection);
    const selectionIsInsideList = $from.blockRange($to, (0, $fCXIH.isListNode));
    if (!$cursor && selectionIsInsideList) return (0, $es8xl.insertSliceIntoRangeSelectionInsideList)({
        tr: tr,
        slice: slice
    });
    // if inside an empty panel, try and insert content inside it rather than replace it
    if (panelNode && (0, $bFyUX.isEmptyNode)(panelNode) && $from.node() === $to.node()) return (0, $es8xl.insertSliceInsideOfPanelNodeSelected)(panelNode)({
        tr: tr,
        slice: slice,
        schema: schema
    });
    if (!$cursor || selectionIsInsideList) return tr.replaceSelection(slice);
    if ((0, $bFyUX.isEmptyNode)(tr.doc.resolve($cursor.pos).node())) return (0, $es8xl.insertSliceIntoEmptyNode)({
        tr: tr,
        slice: slice
    });
    // When pasting a single list item into an action or decision, we skip the special "insert at node edge"
    // logic so that prosemirror pastes the list's content into the action/decision, rather than
    // pasting a whole list node directly after the action/decision item. (But we still preserve the
    // existing "insert at" node edge" behaviour if dealing with a list with more than one item, so that
    // it still inserts whole list node after the action/decision item).
    const pastingIntoActionOrDecision = Boolean((0, $BmspC.findParentNodeOfType)([
        schema.nodes.taskList,
        schema.nodes.decisionList
    ])(selection));
    const oneListItem = slice.content.childCount === 1 && (0, $fCXIH.isListNode)(slice.content.firstChild) && slice.content.firstChild?.childCount === 1;
    if (!(pastingIntoActionOrDecision && oneListItem) && (0, $bFyUX.isCursorSelectionAtTextStartOrEnd)(selection)) return (0, $es8xl.insertSliceAtNodeEdge)({
        tr: tr,
        slice: slice
    });
    tr.replaceSelection(slice);
}
function $2c28ee3918adf3eb$export$2dee216d0a70c94e({ tr: tr, slice: slice }) {
    //insert blockquote explicitly and set the selection in blockquote since replaceSelection will only insert the list
    const { schema: schema } = tr.doc.type;
    tr.replaceSelection(new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(schema.nodes.blockquote.createAndFill()), 0, 0));
    $2c28ee3918adf3eb$export$e57c13697a8b8195({
        tr: tr
    });
    tr.replaceSelection(slice);
}
function $2c28ee3918adf3eb$export$e57c13697a8b8195({ tr: tr }) {
    // ProseMirror doesn't give a proper way to tell us where something was inserted.
    // However, we can know "how" it inserted something.
    //
    // So, instead of weird depth calculations, we can use the step produced by the transform.
    // For instance:
    //    The `replaceStep.to and replaceStep.from`, tell us the real position
    //    where the content will be insert.
    //    Then, we can use the `tr.mapping.map` to the updated position after the replace operation
    const replaceStep = tr.steps[0];
    if (!(replaceStep instanceof (0, $lzEKq.ReplaceStep))) return tr;
    const nextPosition = tr.mapping.map(replaceStep.to);
    // The findFrom will make search for both: TextSelection and NodeSelections.
    const nextSelection = (0, $3lIcL.Selection).findFrom(tr.doc.resolve(Math.min(nextPosition, tr.doc.content.size)), -1);
    if (nextSelection) tr.setSelection(nextSelection);
}
function $2c28ee3918adf3eb$export$2982aac953f7c8b6({ tr: tr, slice: slice }) {
    const { schema: schema } = tr.doc.type;
    //To avoid the list being replaced with the tasklist, enclose the slice within a taskItem.
    const selectionBeforeReplace = tr.selection.from;
    tr.replaceSelection(new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(schema.nodes.taskItem.createAndFill()), 0, 0));
    const nextSelection = (0, $3lIcL.Selection).near(tr.doc.resolve(selectionBeforeReplace + 1));
    tr.setSelection(nextSelection);
    tr.replaceSelection(slice);
}

});
parcelRegister("es8xl", function(module, exports) {
$parcel$export(module.exports, "insertSliceIntoEmptyNode", () => $911edaf88608fe46$export$d69afd888d46c7c);
$parcel$export(module.exports, "insertSliceAtNodeEdge", () => $911edaf88608fe46$export$7b48cb097052829);
$parcel$export(module.exports, "insertSliceIntoRangeSelectionInsideList", () => $911edaf88608fe46$export$eee44e0848f600ea);
$parcel$export(module.exports, "insertSliceInsideOfPanelNodeSelected", () => $911edaf88608fe46$export$778b6ddd10a6aad3);
parcelRequire("3ADzg");
var $5Z3Rm = parcelRequire("5Z3Rm");

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $lzEKq = parcelRequire("lzEKq");

var $BmspC = parcelRequire("BmspC");
function $911edaf88608fe46$export$d69afd888d46c7c({ tr: tr, slice: slice }) {
    tr.replaceSelection(slice);
}
function $911edaf88608fe46$export$7b48cb097052829({ tr: tr, slice: slice }) {
    const { selection: selection } = tr;
    const { $cursor: $cursor } = selection;
    if (!$cursor) return;
    const position = !$cursor.nodeBefore ? $cursor.before() : $cursor.after();
    tr.replaceRange(position, position, slice);
    const startSlicePosition = tr.doc.resolve(Math.min(position + slice.content.size - slice.openEnd, tr.doc.content.size));
    const direction = -1;
    tr.setSelection((0, $3lIcL.TextSelection).near(startSlicePosition, direction));
}
function $911edaf88608fe46$export$eee44e0848f600ea({ tr: tr, slice: slice }) {
    const { selection: { $to: $to, $from: $from, to: to, from: from } } = tr;
    // when the selection is inside of the same list item
    // we can use a normal replace
    if ($from.sameParent($to) || $from.depth === $to.depth) return tr.replaceSelection(slice);
    // if pasting a list inside another list, ensure no empty list items get added
    const newRange = $from.blockRange($to);
    if (!newRange) return;
    const startPos = from;
    const endPos = $to.nodeAfter ? to : to + 2;
    const newSlice = tr.doc.slice(endPos, newRange.end);
    tr.deleteRange(startPos, newRange.end);
    const mapped = tr.mapping.map(startPos);
    tr.replaceRange(mapped, mapped, slice);
    if (newSlice.size <= 0) return;
    const newSelection = (0, $3lIcL.TextSelection).near(tr.doc.resolve(tr.mapping.map(mapped)), -1);
    // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
    newSlice.openEnd = newSlice.openStart;
    tr.replaceRange(newSelection.from, newSelection.from, newSlice);
    tr.setSelection((0, $3lIcL.TextSelection).near(tr.doc.resolve(newSelection.from), -1));
}
function $911edaf88608fe46$export$778b6ddd10a6aad3(panelNode) {
    return ({ tr: tr, slice: slice, schema: schema })=>{
        const { selection: selection, selection: { $to: $to, $from: $from } } = tr;
        const { from: panelPosition } = selection;
        // if content of slice isn't valid for a panel node, insert the invalid node and following content after
        if (panelNode && !panelNode.type.validContent((0, $3xw6l.Fragment).from(slice.content))) {
            let insertPosition = $to.pos + 1;
            /* Adapting above logic to handle MBE, as it currently assumes that slice can be safely inserted after the panel node, which is not the case for MBE
         If insertPosition is in MBE and current slice contains invalid content for MBE, we need to insert the slice after the MBE node
      */ if (schema) {
                const mbeParentOfPanel = (0, $BmspC.findParentNodeOfType)(schema.nodes.multiBodiedExtension)(selection);
                if (mbeParentOfPanel && !mbeParentOfPanel.node.type.validContent((0, $3xw6l.Fragment).from(slice.content))) insertPosition = mbeParentOfPanel.start + mbeParentOfPanel.node.nodeSize - 1;
            }
            tr.replaceRange(insertPosition, insertPosition, slice);
            // need to delete the empty paragraph at the top of the panel
            const parentNode = tr.doc.resolve($from.before()).node();
            if (parentNode && parentNode.childCount > 1 && parentNode.firstChild?.type.name === 'paragraph' && (0, $5Z3Rm.isEmptyParagraph)(parentNode.firstChild)) {
                const startPosDelete = tr.doc.resolve($from.before()).posAtIndex(0);
                const endPosDelete = tr.doc.resolve($from.before()).posAtIndex(1);
                const SIZE_OF_EMPTY_PARAGRAPH = 2; // {startPos}<p>{startPos + 1}</p>{endPos}
                if (endPosDelete - startPosDelete === SIZE_OF_EMPTY_PARAGRAPH) tr.delete(startPosDelete, endPosDelete);
            }
            tr.setSelection((0, $3lIcL.TextSelection).near(tr.doc.resolve(insertPosition + slice.content.size - slice.openStart - slice.openEnd + 1)));
            return;
        }
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const temporaryDoc = new (0, $lzEKq.Transform)(tr.doc.type.createAndFill());
        temporaryDoc.replaceRange(0, temporaryDoc.doc.content.size, slice);
        const sliceWithoutInvalidListSurrounding = temporaryDoc.doc.slice(0);
        const newPanel = panelNode.copy(sliceWithoutInvalidListSurrounding.content);
        const panelNodeSelected = selection instanceof (0, $3lIcL.NodeSelection) ? selection.node : null;
        const replaceFrom = panelNodeSelected ? panelPosition : tr.doc.resolve(panelPosition).start();
        const replaceTo = panelNodeSelected ? panelPosition + panelNodeSelected.nodeSize : replaceFrom;
        tr.replaceRangeWith(replaceFrom, replaceTo, newPanel);
        tr.setSelection((0, $3lIcL.TextSelection).near(tr.doc.resolve($from.pos + newPanel.content.size), -1));
    };
}

});




parcelRegister("18m7e", function(module, exports) {
$parcel$export(module.exports, "clipboardTextSerializer", () => $84ef1cfd6a78bfd8$export$31d6ecfc7a959697);
$parcel$export(module.exports, "createClipboardTextSerializer", () => $84ef1cfd6a78bfd8$export$98b67e7d9513bbaf);

var $dZ5Iy = parcelRequire("dZ5Iy");
function $84ef1cfd6a78bfd8$export$31d6ecfc7a959697(slice) {
    const blockSeparator = '\n\n';
    return slice.content.textBetween(0, slice.content.size, blockSeparator, (leafNode)=>{
        switch(leafNode.type.name){
            case 'hardBreak':
                return '\n';
            case 'text':
                return leafNode.text;
            case 'inlineCard':
                return leafNode.attrs.url;
            case 'blockCard':
                return leafNode.attrs.url;
            // Note: Due to relying on an async fetch of the Mention name by the Node's React component,
            // pasting a mention does not actually work for the in-product Mention implementation.
            // However, this is also true of the previous implementation.
            // Bug ticket: https://product-fabric.atlassian.net/browse/ED-23076
            case 'mention':
                return leafNode.attrs.text;
            default:
                // Unsupported node
                return leafNode.text ?? '';
        }
    });
}
function $84ef1cfd6a78bfd8$export$98b67e7d9513bbaf(intl) {
    return (slice)=>{
        const blockSeparator = '\n\n';
        return slice.content.textBetween(0, slice.content.size, blockSeparator, (leafNode)=>{
            switch(leafNode.type.name){
                case 'hardBreak':
                    return '\n';
                case 'text':
                    return leafNode.text;
                case 'inlineCard':
                    return leafNode.attrs.url;
                case 'blockCard':
                    return leafNode.attrs.url;
                // Note: Due to relying on an async fetch of the Mention name by the Node's React component,
                // pasting a mention does not actually work for the in-product Mention implementation.
                // However, this is also true of the previous implementation.
                // Bug ticket: https://product-fabric.atlassian.net/browse/ED-23076
                case 'mention':
                    return leafNode.attrs.text;
                case 'date':
                    return (0, $dZ5Iy.timestampToString)(leafNode.attrs.timestamp, intl);
                default:
                    // Unsupported node
                    return leafNode.text ?? '';
            }
        });
    };
}

});

parcelRegister("di4lu", function(module, exports) {
$parcel$export(module.exports, "handleVSCodeBlock", () => $d8f5c77ceac2d361$export$d920fedcc56c4475);

var $236Qa = parcelRequire("236Qa");

var $gbisc = parcelRequire("gbisc");
function $d8f5c77ceac2d361$var$safelyGetVSCodeLanguage(editorData) {
    try {
        const vscodeData = editorData ? JSON.parse(editorData) : undefined;
        return vscodeData?.mode;
    } catch (_e) {}
}
function $d8f5c77ceac2d361$export$d920fedcc56c4475({ state: state, slice: slice, text: text, event: event }) {
    const vscodeData = event?.clipboardData?.getData('vscode-editor-data');
    const language = $d8f5c77ceac2d361$var$safelyGetVSCodeLanguage(vscodeData);
    if (text && language && (0, $236Qa.SUPPORTED_LANGUAGES).some((l)=>l.alias[0] === language)) {
        const { schema: schema } = state;
        slice = (0, $gbisc.mapSlice)(slice, (node)=>{
            if (node.type.name === schema.nodes.codeBlock?.name) return schema.nodes.codeBlock.createChecked({
                language: language
            }, schema.text(text));
            return node;
        });
    }
    return slice;
}

});

parcelRegister("2kOjB", function(module, exports) {
$parcel$export(module.exports, "isPastedFromTinyMCEConfluence", () => $925803403a610d61$export$4a3cccc9bf9da386);
$parcel$export(module.exports, "htmlHasIncompleteTable", () => $925803403a610d61$export$120b137b77798e76);
$parcel$export(module.exports, "tryRebuildCompleteTableHtml", () => $925803403a610d61$export$253f7bda9f1e0696);

var $lsLcV = parcelRequire("lsLcV");
const $925803403a610d61$var$isPastedFromTinyMCE = (pasteEvent)=>{
    return pasteEvent?.clipboardData?.types?.some((mimeType)=>mimeType === 'x-tinymce/html') ?? false;
};
const $925803403a610d61$export$4a3cccc9bf9da386 = (pasteEvent, html)=>{
    return $925803403a610d61$var$isPastedFromTinyMCE(pasteEvent) && !!html && // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    !!html.match(/class=\"\s?(confluenceTd|confluenceTh|confluenceTable).+"/gim);
};
const $925803403a610d61$export$4552e3fc797fc52a = (html)=>{
    const parser = new DOMParser();
    const nonTableWrappedDoc = parser.parseFromString(html, 'text/html');
    const tableWrappedDoc = parser.parseFromString(`<table>${html}</table>`, 'text/html');
    tableWrappedDoc.body.querySelectorAll('meta').forEach((meta)=>{
        tableWrappedDoc.head.prepend(meta);
    });
    return {
        tableWrappedDoc: tableWrappedDoc,
        nonTableWrappedDoc: nonTableWrappedDoc
    };
};
const $925803403a610d61$var$exactlyDivisible = (larger, smaller)=>larger % smaller === 0;
const $925803403a610d61$var$getTableElementsInfo = (doc)=>{
    const cellCount = doc.querySelectorAll('td').length;
    const thCount = doc.querySelectorAll('th').length;
    const mergedCellCount = doc.querySelectorAll('td[colspan]:not([colspan="1"])').length;
    let hasThAfterTd = false;
    const thsAndCells = doc.querySelectorAll('th,td');
    for(let i = 0, cellFound = false; i < thsAndCells.length; i++){
        if (cellFound && thsAndCells[i].nodeName === 'TH') {
            hasThAfterTd = true;
            break;
        }
        if (thsAndCells[i].nodeName === 'TD') cellFound = true;
    }
    const onlyTh = thCount > 0 && cellCount === 0;
    const onlyCells = cellCount > 0 && thCount === 0;
    const hasCompleteRow = // we take header-only and cell-only tables to be
    // row-complete
    onlyTh || onlyCells || // if headers and cells can "fit" against each other,
    // then we assume a complete row exists
    ($925803403a610d61$var$exactlyDivisible(thCount, cellCount) || $925803403a610d61$var$exactlyDivisible(cellCount, thCount)) && // all numbers are divisible by 1, so we carve out a specific
    // check for when there is only 1 table cell, and more than 1
    // table header.
    !(thCount > 1 && cellCount === 1);
    return {
        cellCount: cellCount,
        thCount: thCount,
        mergedCellCount: mergedCellCount,
        hasThAfterTd: hasThAfterTd,
        hasIncompleteRow: !hasCompleteRow
    };
};
const $925803403a610d61$var$configureTableRows = (doc, colsInRow)=>{
    const tableHeadersAndCells = Array.from(doc.body.querySelectorAll('th,td'));
    const evenlySplitChunks = (0, (/*@__PURE__*/$parcel$interopDefault($lsLcV)))(tableHeadersAndCells, colsInRow);
    const tableBody = doc.body.querySelector('tbody');
    evenlySplitChunks.forEach((chunk)=>{
        const tr = doc.createElement('tr');
        tableBody?.append(tr);
        tr.append(...chunk);
    });
    // We remove any leftover empty rows which may cause fabric editor
    // to no-op when parsing the table
    const emptyRows = Array.from(tableBody.querySelectorAll('tr'))?.filter((row)=>row.innerHTML.trim().length === 0);
    emptyRows.forEach((row)=>row.remove());
    return doc.body.innerHTML;
};
const $925803403a610d61$var$fillIncompleteRowWithEmptyCells = (doc, thCount, cellCount)=>{
    let extraCellsCount = 0;
    while(!$925803403a610d61$var$exactlyDivisible(cellCount + extraCellsCount, thCount))extraCellsCount++;
    const extraEmptyCells = Array.from(Array(extraCellsCount)).map(()=>doc.createElement('td'));
    const lastCell = doc.body.querySelector('td:last-of-type');
    lastCell?.parentElement?.append(...extraEmptyCells);
    return {
        updatedCellCount: cellCount + extraCellsCount
    };
};
const $925803403a610d61$export$d749bb0e238929f2 = (doc)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line prefer-const
    let { cellCount: cellCount, thCount: thCount, mergedCellCount: mergedCellCount, hasThAfterTd: hasThAfterTd, hasIncompleteRow: hasIncompleteRow } = $925803403a610d61$var$getTableElementsInfo(doc);
    if (mergedCellCount || hasThAfterTd) // bail out to avoid handling more complex table structures
    return doc.body.innerHTML;
    if (!thCount) // if no table headers exist for reference, fallback to a single column table structure
    return $925803403a610d61$var$configureTableRows(doc, 1);
    if (hasIncompleteRow) {
        // if shift-click selection copies a partial table row to the clipboard,
        // and we do have table headers for reference, then we add empty table cells
        // to fill out the partial row
        const { updatedCellCount: updatedCellCount } = $925803403a610d61$var$fillIncompleteRowWithEmptyCells(doc, thCount, cellCount);
        cellCount = updatedCellCount;
    }
    for(let possibleColsInRow = thCount; possibleColsInRow > 0; possibleColsInRow--){
        if ($925803403a610d61$var$exactlyDivisible(thCount, possibleColsInRow) && $925803403a610d61$var$exactlyDivisible(cellCount, possibleColsInRow)) return $925803403a610d61$var$configureTableRows(doc, possibleColsInRow);
    }
    return doc.body.innerHTML;
};
const $925803403a610d61$export$120b137b77798e76 = (html)=>{
    return !html.includes('<table ') && (html.includes('<td ') || html.includes('<th '));
};
const $925803403a610d61$export$253f7bda9f1e0696 = (incompleteTableHtml)=>{
    // first we try wrapping the table elements with <table> and let DOMParser try to rebuild
    // a valid DOM tree. we also keep the non-wrapped table for comparison purposes.
    const { nonTableWrappedDoc: nonTableWrappedDoc, tableWrappedDoc: tableWrappedDoc } = $925803403a610d61$export$4552e3fc797fc52a(incompleteTableHtml);
    const didPreserveTableElements = Boolean(!nonTableWrappedDoc.body.querySelector('th, td') && tableWrappedDoc.body.querySelector('th, td'));
    const isExpectedStructure = tableWrappedDoc.querySelectorAll('body > table:only-child') && !tableWrappedDoc.querySelector(`body > table > tbody > tr > :not(th,td)`);
    // if DOMParser saves table elements that we would otherwise lose, and
    // if the table html is what we'd expect (a single table, with no extraneous
    // elements in table rows other than th, td), then we can now also try to
    // rebuild table rows/columns.
    if (didPreserveTableElements && isExpectedStructure) {
        const completeTableHtml = $925803403a610d61$export$d749bb0e238929f2(tableWrappedDoc);
        return completeTableHtml;
    }
    return null;
};

});
parcelRegister("lsLcV", function(module, exports) {

var $1FqKq = parcelRequire("1FqKq");

var $eA1it = parcelRequire("eA1it");

var $c9FP3 = parcelRequire("c9FP3");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $fa00d4eb66826668$var$nativeCeil = Math.ceil, $fa00d4eb66826668$var$nativeMax = Math.max;
/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */ function $fa00d4eb66826668$var$chunk(array, size, guard) {
    if (guard ? $eA1it(array, size, guard) : size === undefined) size = 1;
    else size = $fa00d4eb66826668$var$nativeMax($c9FP3(size), 0);
    var length = array == null ? 0 : array.length;
    if (!length || size < 1) return [];
    var index = 0, resIndex = 0, result = Array($fa00d4eb66826668$var$nativeCeil(length / size));
    while(index < length)result[resIndex++] = $1FqKq(array, index, index += size);
    return result;
}
module.exports = $fa00d4eb66826668$var$chunk;

});



parcelRegister("bZVQL", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $8291d311f670335e$export$ae829ec7b2625219);

var $bMFKb = parcelRequire("bMFKb");

var $i8KtF = parcelRequire("i8KtF");

var $eGOwo = parcelRequire("eGOwo");

var $11STq = parcelRequire("11STq");

var $3X4gE = parcelRequire("3X4gE");

var $fZ8OQ = parcelRequire("fZ8OQ");

var $6Jk3D = parcelRequire("6Jk3D");

var $eAYGw = parcelRequire("eAYGw");
const $8291d311f670335e$export$ae829ec7b2625219 = (dispatch, editorAnalyticsAPI)=>{
    // This variable is used to distinguish between copy and cut events in transformCopied.
    let isCutEvent = false;
    return new (0, $i8KtF.SafePlugin)({
        key: (0, $fZ8OQ.pluginKey),
        state: (0, $3X4gE.createPluginState)(dispatch, (0, $6Jk3D.defaultState)),
        props: {
            handleDOMEvents: {
                cut: ()=>{
                    isCutEvent = true;
                }
            },
            handlePaste: ({ state: state, dispatch: dispatch }, event, slice)=>{
                // The state was cleaned after previous paste. We don't need to update plugin state
                // with 'contentPasted' if currentActions array doesn't have 'copiedOrCut'.
                const { contentMoved: contentMoved } = (0, $3X4gE.getPluginState)(state);
                const hasCutAction = contentMoved.currentActions.includes('contentCut');
                if (!hasCutAction) return;
                const { content: content } = slice;
                const nodeName = content.firstChild?.type.name;
                if (!nodeName || !contentMoved?.nodeName || !(0, $eAYGw.isCursorSelectionAtTopLevel)(state.selection)) return;
                const { tr: tr } = state;
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $bMFKb.ACTION).MOVED,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).NODE,
                    eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                    attributes: {
                        // keep nodeName from copied slice
                        nodeType: contentMoved?.nodeName,
                        nodeDepth: contentMoved?.nodeDepth,
                        destinationNodeDepth: (0, $eAYGw.getParentNodeDepth)(state.selection),
                        nodeTypes: contentMoved?.nodeTypes,
                        hasSelectedMultipleNodes: contentMoved?.hasSelectedMultipleNodes
                    }
                })(tr);
                // reset to default state
                const updatedTr = (0, $11STq.resetContentMovedTransform)()(tr);
                dispatch(updatedTr);
            },
            transformCopied: (slice, { state: state, dispatch: dispatch })=>{
                // We want to listen only to 'cut' events
                if (!isCutEvent) return slice;
                let resetState = false;
                const { content: content, size: size } = slice;
                const { selection: selection } = state;
                // Note: the following is not the case once `platform_editor_element_drag_and_drop_multiselect` is enabled
                // we now want to track cut events for multiple nodes
                // Content should be just one node, so we added a check for slice.content.childCount === 1;
                // 1. It is possible to select a table by dragging the mouse over the table's rows.
                // As a result, slice will contain rows without tableNode itself and the childCount will be the number of rows.
                // From a user's perspective the whole table is selected and copied and on paste a table will indeed be created.
                // 2. Some block nodes can get selected when a user drags the mouse from the paragraph above the node to
                // the paragraph below the node. Visually only the node in between is selected, in reality, three nodes are
                // in the slice.
                // These cases are ignored and moveContent event won't be counted.
                const isMultiSelectTrackingEnabled = (0, $eGOwo.fg)('platform_editor_track_node_types');
                const nodeName = content.firstChild?.type.name || '';
                let nodeTypes, hasSelectedMultipleNodes = false;
                if (content.childCount > 1) {
                    if (isMultiSelectTrackingEnabled) {
                        if ((0, $eAYGw.containsExcludedNode)(content)) resetState = true;
                        else {
                            const attributes = (0, $eAYGw.getMultipleSelectionAttributes)(content);
                            nodeTypes = attributes.nodeTypes;
                            hasSelectedMultipleNodes = attributes.hasSelectedMultipleNodes;
                        }
                    } else resetState = true;
                } else if (content.childCount === 1) {
                    // Some nodes are not relevant as they are parts of nodes, not whole nodes (like tableCell, tableHeader instead of table node)
                    // Some nodes like lists, taskList(item), decisionList(item) requires tricky checks that we want to avoid doing.
                    // These nodes were added to excludedNodes array.
                    if (!resetState && (0, $eAYGw.isExcludedNode)(nodeName)) resetState = true;
                    if (!resetState && !(0, $eAYGw.isEntireNestedParagraphOrHeadingSelected)(selection)) resetState = true;
                    if (!resetState && (0, $eAYGw.isInlineNode)(nodeName) && (0, $eAYGw.isNestedInlineNode)(selection)) resetState = true;
                    if (!resetState && (0, $eAYGw.isNestedInTable)(state)) resetState = true;
                } else resetState = true;
                if (resetState) (0, $11STq.resetContentMoved)()(state, dispatch);
                else {
                    let newState = {
                        size: size,
                        nodeName: nodeName,
                        nodeDepth: (0, $eAYGw.getParentNodeDepth)(selection)
                    };
                    if (isMultiSelectTrackingEnabled) newState = {
                        ...newState,
                        nodeTypes: nodeTypes ?? nodeName,
                        hasSelectedMultipleNodes: hasSelectedMultipleNodes
                    };
                    (0, $11STq.updateContentMoved)(newState, 'contentCut')(state, dispatch);
                }
                isCutEvent = false;
                return slice;
            }
        }
    });
};

});
parcelRegister("11STq", function(module, exports) {
$parcel$export(module.exports, "updateContentMoved", () => $5d23ff2758ee6cab$export$7c2867f48317a29d);
$parcel$export(module.exports, "resetContentMoved", () => $5d23ff2758ee6cab$export$56834735aa39d3eb);
$parcel$export(module.exports, "resetContentMovedTransform", () => $5d23ff2758ee6cab$export$47c45651eb91dff0);

var $ejKvo = parcelRequire("ejKvo");

var $3X4gE = parcelRequire("3X4gE");

var $fZ8OQ = parcelRequire("fZ8OQ");
const $5d23ff2758ee6cab$export$7c2867f48317a29d = (nextState, nextAction)=>(0, $3X4gE.createCommand)((state)=>{
        const { contentMoved: contentMoved } = (0, $3X4gE.getPluginState)(state);
        const data = {
            currentActions: [
                ...contentMoved.currentActions,
                nextAction
            ],
            size: nextState?.size || contentMoved.size,
            nodeName: nextState?.nodeName,
            nodeDepth: nextState?.nodeDepth,
            nodeTypes: nextState?.nodeTypes,
            hasSelectedMultipleNodes: nextState?.hasSelectedMultipleNodes
        };
        return {
            type: (0, $ejKvo.MoveAnalyticPluginTypes).UpdateMovedAction,
            data: data
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $5d23ff2758ee6cab$export$56834735aa39d3eb = ()=>(0, $3X4gE.createCommand)(()=>{
        return {
            type: (0, $ejKvo.MoveAnalyticPluginTypes).RemoveMovedAction
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $5d23ff2758ee6cab$export$47c45651eb91dff0 = ()=>(tr)=>{
        const payload = {
            type: (0, $ejKvo.MoveAnalyticPluginTypes).RemoveMovedAction
        };
        return tr.setMeta((0, $fZ8OQ.pluginKey), payload);
    };

});
parcelRegister("ejKvo", function(module, exports) {
$parcel$export(module.exports, "MoveAnalyticPluginTypes", () => $9e3f55173d4bc4af$export$a5fa3822909c7e0);
var $9e3f55173d4bc4af$export$a5fa3822909c7e0 = /*#__PURE__*/ function(MoveAnalyticPluginTypes) {
    MoveAnalyticPluginTypes[MoveAnalyticPluginTypes["UpdateMovedAction"] = 0] = "UpdateMovedAction";
    MoveAnalyticPluginTypes[MoveAnalyticPluginTypes["RemoveMovedAction"] = 1] = "RemoveMovedAction";
    return MoveAnalyticPluginTypes;
}({});

});

parcelRegister("3X4gE", function(module, exports) {
$parcel$export(module.exports, "createPluginState", () => $8a3050d70e39e4b3$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $8a3050d70e39e4b3$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $8a3050d70e39e4b3$export$f05434c51e3762e);

var $bazog = parcelRequire("bazog");

var $fZ8OQ = parcelRequire("fZ8OQ");

var $drN56 = parcelRequire("drN56");
const { createPluginState: $8a3050d70e39e4b3$export$656c7661095efe2e, createCommand: $8a3050d70e39e4b3$export$8d4021544bdece00, getPluginState: $8a3050d70e39e4b3$export$f05434c51e3762e } = (0, $bazog.pluginFactory)((0, $fZ8OQ.pluginKey), (0, $drN56.reducer));

});
parcelRegister("fZ8OQ", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $3f18de7a3374001d$export$18d4026d1ea86bb1);

var $3lIcL = parcelRequire("3lIcL");
const $3f18de7a3374001d$export$18d4026d1ea86bb1 = new (0, $3lIcL.PluginKey)('moveAnalyticsPlugin');

});

parcelRegister("drN56", function(module, exports) {
$parcel$export(module.exports, "reducer", () => $016f8413be251327$export$1650419e431d3ba3);

var $ejKvo = parcelRequire("ejKvo");

var $6Jk3D = parcelRequire("6Jk3D");
const $016f8413be251327$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case (0, $ejKvo.MoveAnalyticPluginTypes).UpdateMovedAction:
            return {
                ...state,
                contentMoved: {
                    ...state.contentMoved,
                    ...action.data
                }
            };
        case (0, $ejKvo.MoveAnalyticPluginTypes).RemoveMovedAction:
            return {
                ...state,
                contentMoved: (0, $6Jk3D.defaultState).contentMoved
            };
        default:
            return state;
    }
};

});
parcelRegister("6Jk3D", function(module, exports) {
$parcel$export(module.exports, "defaultState", () => $29e6b5eadf465ed9$export$49d5fc8cba920a0);
// For an event to be considered a move content event we want to ensure that
// cut had happened and was followed by paste. So our currentActions array should
// look like this ['contentCut', 'contentPasted'];
// After removing appendTransaction we don't update currentActions with 'contentPasted'
// but leaving it as array in case we decide to change it back or add 'contentCopied'.
const $29e6b5eadf465ed9$export$49d5fc8cba920a0 = {
    contentMoved: {
        nodeName: undefined,
        size: undefined,
        nodeDepth: undefined,
        currentActions: [],
        nodeTypes: undefined,
        hasSelectedMultipleNodes: undefined
    }
};

});




parcelRegister("eAYGw", function(module, exports) {
$parcel$export(module.exports, "isExcludedNode", () => $ccbbbefe2a50a3c9$export$75248da1527ddfc1);
$parcel$export(module.exports, "isCursorSelectionAtTopLevel", () => $ccbbbefe2a50a3c9$export$14f96cade94e47c);
$parcel$export(module.exports, "isInlineNode", () => $ccbbbefe2a50a3c9$export$82ae59a0847ee78b);
$parcel$export(module.exports, "isNestedInlineNode", () => $ccbbbefe2a50a3c9$export$8cd6af93b47990b9);
$parcel$export(module.exports, "isNestedInTable", () => $ccbbbefe2a50a3c9$export$78b714f3f17d88b0);
$parcel$export(module.exports, "getParentNodeDepth", () => $ccbbbefe2a50a3c9$export$568289ef11d607ce);
$parcel$export(module.exports, "isEntireNestedParagraphOrHeadingSelected", () => $ccbbbefe2a50a3c9$export$b6cb43348b690a2d);
$parcel$export(module.exports, "containsExcludedNode", () => $ccbbbefe2a50a3c9$export$c4a09517c4982d7c);
$parcel$export(module.exports, "getMultipleSelectionAttributes", () => $ccbbbefe2a50a3c9$export$f3a535d61fe1eda3);

var $BmspC = parcelRequire("BmspC");

var $cwzAY = parcelRequire("cwzAY");

var $eGOwo = parcelRequire("eGOwo");
const $ccbbbefe2a50a3c9$var$excludedNodes = [
    'caption',
    'layoutColumn',
    'listItem',
    'tableHeader',
    'tableCell',
    'tableRow',
    'text',
    'placeholder',
    'unsupportedBlock',
    'unsupportedInline',
    'hardBreak',
    'confluenceUnsupportedBlock',
    'confluenceUnsupportedInline',
    'taskItem',
    'decisionItem'
];
const $ccbbbefe2a50a3c9$export$75248da1527ddfc1 = (nodeName)=>$ccbbbefe2a50a3c9$var$excludedNodes.includes(nodeName);
const $ccbbbefe2a50a3c9$export$14f96cade94e47c = (selection)=>{
    const { from: from, to: to, $from: $from } = selection;
    if (from !== to) return false;
    return $from.parentOffset === 0;
};
const $ccbbbefe2a50a3c9$var$inlineNodes = [
    'emoji',
    'date',
    'status',
    'mention',
    'mediaInline',
    'inlineCard',
    'inlineExtension'
];
const $ccbbbefe2a50a3c9$export$82ae59a0847ee78b = (nodeName)=>{
    return $ccbbbefe2a50a3c9$var$inlineNodes.includes(nodeName);
};
const $ccbbbefe2a50a3c9$export$8cd6af93b47990b9 = (selection)=>{
    if (selection.$from.depth !== 1) return true;
    // check if the node is a part of a larger paragraph or heading
    const parentSize = selection.$from.parent.content.size;
    const contentSize = selection.content().size;
    const parentChildCount = selection.$from.parent.childCount;
    // when the node was copied and pasted, it won't have extra space the parent has only one child
    if (parentChildCount === 1) return false;
    // some inline nodes (like date and emoji) when inserted have extra space that is stores as a child
    if (parentChildCount === 2 && parentSize - contentSize === 1) return false;
    return true;
};
const $ccbbbefe2a50a3c9$export$78b714f3f17d88b0 = (state)=>{
    const { schema: schema, selection: selection } = state;
    if (selection instanceof (0, $cwzAY.CellSelection)) return false;
    const { table: table } = schema.nodes;
    const tableNode = (0, $BmspC.findParentNodeOfTypeClosestToPos)(selection.$from, table);
    if (!tableNode) return false;
    return true;
};
const $ccbbbefe2a50a3c9$export$568289ef11d607ce = (selection)=>{
    const parentNode = (0, $BmspC.findParentNodeClosestToPos)(selection.$from, ()=>true);
    if (!parentNode) return 0;
    return parentNode.node.type.name === 'heading' || parentNode.node.type.name === 'paragraph' ? parentNode.depth - 1 : parentNode.depth;
};
const $ccbbbefe2a50a3c9$export$b6cb43348b690a2d = (selection)=>{
    const { $from: $from, $to: $to } = selection;
    return $from.textOffset === 0 && $to.textOffset === 0;
};
const $ccbbbefe2a50a3c9$export$c4a09517c4982d7c = (content)=>{
    for(let i = 0; i < content.childCount; i++){
        const nodeName = content.maybeChild(i)?.type.name || '';
        if ($ccbbbefe2a50a3c9$export$75248da1527ddfc1(nodeName)) return true;
    }
    return false;
};
const $ccbbbefe2a50a3c9$export$f3a535d61fe1eda3 = (content)=>{
    const nodeTypes = [];
    if (content.size) content.forEach((node)=>{
        nodeTypes.push(node.type.name);
    });
    return {
        nodeTypes: (0, $eGOwo.fg)('platform_editor_track_node_types') ? [
            ...new Set(nodeTypes)
        ].sort().join(',') : undefined,
        hasSelectedMultipleNodes: nodeTypes.length > 1
    };
};

});




parcelRegister("3hdhz", function(module, exports) {
$parcel$export(module.exports, "quickInsertPlugin", () => (parcelRequire("33nQb")).quickInsertPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $33nQb = parcelRequire("33nQb");

});
parcelRegister("33nQb", function(module, exports) {
$parcel$export(module.exports, "quickInsertPlugin", () => $2c41757d4cc562e0$export$2ff93c7de46a9aaa);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $fNh22 = parcelRequire("fNh22");

var $46A2h = parcelRequire("46A2h");

var $38O6R = parcelRequire("38O6R");

var $i8KtF = parcelRequire("i8KtF");

var $7k8dr = parcelRequire("7k8dr");

var $i2fvj = parcelRequire("i2fvj");

var $eGOwo = parcelRequire("eGOwo");

var $cbSL1 = parcelRequire("cbSL1");

var $92xoS = parcelRequire("92xoS");

var $71AZG = parcelRequire("71AZG");

var $7et8b = parcelRequire("7et8b");

var $cdVXP = parcelRequire("cdVXP");

var $25zYy = parcelRequire("25zYy");

var $j7avG = parcelRequire("j7avG");
const $2c41757d4cc562e0$export$2ff93c7de46a9aaa = ({ config: options, api: api })=>{
    const refs = {};
    const onInsert = (item)=>{
        options?.onInsert?.(item);
    };
    const typeAhead = {
        id: (0, $7k8dr.TypeAheadAvailableNodes).QUICK_INSERT,
        trigger: '/',
        headless: options?.headless,
        getItems ({ query: query, editorState: editorState }) {
            const quickInsertState = (0, $cdVXP.pluginKey).getState(editorState);
            const queryAllItems = '';
            return Promise.resolve((0, $j7avG.getQuickInsertSuggestions)({
                query: (0, $92xoS.editorExperiment)('platform_editor_insertion', 'control') ? query : queryAllItems,
                disableDefaultItems: options?.disableDefaultItems,
                prioritySortingFn: options?.prioritySortingFn
            }, quickInsertState?.lazyDefaultItems, quickInsertState?.providedItems));
        },
        selectItem: (state, item, insert)=>{
            const quickInsertItem = item;
            const result = quickInsertItem.action(insert, state);
            if (result) onInsert(quickInsertItem);
            return result;
        },
        getMoreOptionsButtonConfig: options?.enableElementBrowser || !(0, $eGOwo.fg)('platform_editor_controls_fix_view_more_in_comment') ? ({ formatMessage: formatMessage })=>{
            return {
                title: formatMessage((0, $46A2h.toolbarInsertBlockMessages).viewMore),
                ariaLabel: formatMessage((0, $46A2h.toolbarInsertBlockMessages).viewMoreAriaLabel),
                onClick: (0, $71AZG.openElementBrowserModal),
                iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i2fvj))), {
                    label: ""
                })
            };
        } : undefined
    };
    let intl;
    return {
        name: 'quickInsert',
        pmPlugins (defaultItems) {
            return [
                {
                    name: 'quickInsert',
                    plugin: ({ providerFactory: providerFactory, getIntl: getIntl, dispatch: dispatch })=>$2c41757d4cc562e0$var$quickInsertPluginFactory(defaultItems, providerFactory, getIntl, dispatch, options?.emptyStateHandler)
                },
                ...(0, $cbSL1.expValEquals)('platform_editor_experience_tracking', 'isEnabled', true) ? [
                    {
                        name: 'quickInsertOpenExperience',
                        plugin: ()=>(0, $7et8b.getQuickInsertOpenExperiencePlugin)({
                                refs: refs
                            })
                    }
                ] : []
            ];
        },
        pluginsOptions: {
            typeAhead: typeAhead
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, wrapperElement: wrapperElement }) {
            refs.popupsMountPoint = popupsMountPoint || undefined;
            refs.wrapperElement = wrapperElement || undefined;
            if (!editorView || (0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) && (0, $fNh22.isSSR)()) return null;
            if (options?.enableElementBrowser) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $25zYy.default), {
                editorView: editorView,
                helpUrl: options?.elementBrowserHelpUrl,
                pluginInjectionAPI: api
            });
            return null;
        },
        getSharedState (editorState) {
            if (!editorState) return null;
            const quickInsertState = (0, $cdVXP.pluginKey).getState(editorState);
            if (!quickInsertState) return null;
            return {
                typeAheadHandler: typeAhead,
                lazyDefaultItems: quickInsertState.lazyDefaultItems,
                emptyStateHandler: quickInsertState.emptyStateHandler,
                providedItems: quickInsertState.providedItems,
                isElementBrowserModalOpen: quickInsertState.isElementBrowserModalOpen
            };
        },
        actions: {
            insertItem: (0, $71AZG.createInsertItem)(onInsert),
            openTypeAhead (inputMethod, removePrefixTriggerOnCancel) {
                return Boolean(api?.typeAhead?.actions.open({
                    triggerHandler: typeAhead,
                    inputMethod: inputMethod,
                    removePrefixTriggerOnCancel: removePrefixTriggerOnCancel
                }));
            },
            getSuggestions: (searchOptions)=>{
                const { lazyDefaultItems: lazyDefaultItems, providedItems: providedItems } = api?.quickInsert?.sharedState.currentState() ?? {};
                if (options?.prioritySortingFn) searchOptions = {
                    ...searchOptions,
                    prioritySortingFn: options.prioritySortingFn
                };
                return (0, $j7avG.getQuickInsertSuggestions)(searchOptions, lazyDefaultItems, providedItems);
            }
        },
        commands: {
            openElementBrowserModal: ({ tr: tr })=>{
                if ((0, $eGOwo.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.handleIntentToStartEdit({
                    shouldStartTimer: false,
                    shouldPersistActiveSession: true
                })({
                    tr: tr
                });
                return (0, $71AZG.openElementBrowserModal)({
                    tr: tr
                });
            },
            addQuickInsertItem: (item)=>({ tr: tr })=>{
                    const { lazyDefaultItems: lazyDefaultItems } = api?.quickInsert?.sharedState.currentState() ?? {};
                    const defaultItems = lazyDefaultItems ? lazyDefaultItems() : [];
                    const memoisedNewItems = (0, $38O6R.memoProcessQuickInsertItems)([
                        item
                    ], intl);
                    return tr.setMeta((0, $cdVXP.pluginKey), {
                        lazyDefaultItems: ()=>[
                                ...defaultItems,
                                ...memoisedNewItems
                            ]
                    });
                }
        },
        usePluginHook: ()=>{
            intl = (0, $lRq8t.default)();
        }
    };
};
const $2c41757d4cc562e0$var$setProviderState = (providerState)=>(state, dispatch)=>{
        if (dispatch) dispatch(state.tr.setMeta((0, $cdVXP.pluginKey), providerState));
        return true;
    };
function $2c41757d4cc562e0$var$quickInsertPluginFactory(defaultItems, providerFactory, getIntl, dispatch, emptyStateHandler) {
    return new (0, $i8KtF.SafePlugin)({
        key: (0, $cdVXP.pluginKey),
        state: {
            init () {
                return {
                    isElementBrowserModalOpen: false,
                    emptyStateHandler: emptyStateHandler,
                    // lazy so it doesn't run on editor initialization
                    // memo here to avoid using a singleton cache, avoids editor
                    // getting confused when two editors exist within the same page.
                    lazyDefaultItems: ()=>(0, $38O6R.memoProcessQuickInsertItems)(defaultItems || [], getIntl())
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta((0, $cdVXP.pluginKey));
                if (meta) {
                    const keys = Object.keys(meta);
                    const changed = keys.some((key)=>{
                        return pluginState[key] !== meta[key];
                    });
                    if (changed) {
                        const newState = {
                            ...pluginState,
                            ...meta
                        };
                        dispatch((0, $cdVXP.pluginKey), newState);
                        return newState;
                    }
                }
                return pluginState;
            }
        },
        view (editorView) {
            const providerHandler = async (_name, providerPromise)=>{
                if (providerPromise) try {
                    const provider = await providerPromise;
                    const providedItems = await provider.getItems();
                    $2c41757d4cc562e0$var$setProviderState({
                        provider: provider,
                        providedItems: providedItems
                    })(editorView.state, editorView.dispatch);
                } catch (e) {
                    // eslint-disable-next-line no-console
                    console.error('Error getting items from quick insert provider', e);
                }
            };
            providerFactory.subscribe('quickInsertProvider', providerHandler);
            return {
                destroy () {
                    providerFactory.unsubscribe('quickInsertProvider', providerHandler);
                }
            };
        }
    });
}

});
parcelRegister("38O6R", function(module, exports) {
$parcel$export(module.exports, "memoProcessQuickInsertItems", () => $2469ffc46f678b22$export$4fca091f4ee92b6d);
$parcel$export(module.exports, "find", () => $2469ffc46f678b22$export$71aa6c912b956294);

var $bcD3h = parcelRequire("bcD3h");

var $LFmXM = parcelRequire("LFmXM");
const $2469ffc46f678b22$var$processQuickInsertItems = (items, intl)=>{
    return items.reduce((acc, item)=>{
        if (typeof item === 'function' && // we preserve handler items with disableMemo so that we
        // can process them in a later step outside of memoizations
        !item.disableMemo) {
            const quickInsertItems = item(intl);
            return acc.concat(quickInsertItems);
        }
        return acc.concat(item);
    }, []);
};
const $2469ffc46f678b22$var$memoizedProcessQuickInsertItems = (0, $LFmXM.default)($2469ffc46f678b22$var$processQuickInsertItems);
const $2469ffc46f678b22$export$4fca091f4ee92b6d = (items, intl)=>{
    const memoizedResults = $2469ffc46f678b22$var$memoizedProcessQuickInsertItems(items, intl);
    const hasDisabledMemos = items.some((item)=>typeof item === 'function' && item.disableMemo);
    if (!hasDisabledMemos) return memoizedResults;
    return memoizedResults.flatMap((item)=>typeof item === 'function' && item.disableMemo ? item(intl) : item);
};
const $2469ffc46f678b22$var$options = {
    threshold: 0.3,
    includeScore: true,
    keys: [
        {
            name: 'title',
            weight: 0.57
        },
        {
            name: 'keywords',
            weight: 0.08
        },
        {
            name: 'description',
            weight: 0.04
        },
        {
            name: 'keyshortcut',
            weight: 0.01
        }
    ]
};
function $2469ffc46f678b22$export$71aa6c912b956294(query, items, prioritySortingFn) {
    if (query === '') // Copy and sort list by priority
    return items.slice(0).sort((a, b)=>(a.priority || Number.POSITIVE_INFINITY) - (b.priority || Number.POSITIVE_INFINITY));
    const fuseOptions = {
        ...$2469ffc46f678b22$var$options
    };
    if (prioritySortingFn) {
        const sortFn = prioritySortingFn(items);
        // prioritySortingFn will trigger the experiment exposure, but sortFn
        // will be undefined for the control group.
        if (sortFn) fuseOptions.sortFn = sortFn;
    }
    const fuse = new (0, $bcD3h.default)(items, fuseOptions);
    return fuse.search(query).map((result)=>result.item);
}

});
parcelRegister("bcD3h", function(module, exports) {
$parcel$export(module.exports, "default", () => $827f1b98b76cab0f$export$2e2bcd8739ae039);
/**
 * Fuse.js v6.6.2 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2022 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $827f1b98b76cab0f$var$isArray(value) {
    return !Array.isArray ? $827f1b98b76cab0f$var$getTag(value) === '[object Array]' : Array.isArray(value);
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const $827f1b98b76cab0f$var$INFINITY = 1 / 0;
function $827f1b98b76cab0f$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    let result = value + '';
    return result == '0' && 1 / value == -$827f1b98b76cab0f$var$INFINITY ? '-0' : result;
}
function $827f1b98b76cab0f$var$toString(value) {
    return value == null ? '' : $827f1b98b76cab0f$var$baseToString(value);
}
function $827f1b98b76cab0f$var$isString(value) {
    return typeof value === 'string';
}
function $827f1b98b76cab0f$var$isNumber(value) {
    return typeof value === 'number';
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function $827f1b98b76cab0f$var$isBoolean(value) {
    return value === true || value === false || $827f1b98b76cab0f$var$isObjectLike(value) && $827f1b98b76cab0f$var$getTag(value) == '[object Boolean]';
}
function $827f1b98b76cab0f$var$isObject(value) {
    return typeof value === 'object';
}
// Checks if `value` is object-like.
function $827f1b98b76cab0f$var$isObjectLike(value) {
    return $827f1b98b76cab0f$var$isObject(value) && value !== null;
}
function $827f1b98b76cab0f$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $827f1b98b76cab0f$var$isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function $827f1b98b76cab0f$var$getTag(value) {
    return value == null ? value === undefined ? '[object Undefined]' : '[object Null]' : Object.prototype.toString.call(value);
}
const $827f1b98b76cab0f$var$EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';
const $827f1b98b76cab0f$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const $827f1b98b76cab0f$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
const $827f1b98b76cab0f$var$PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
const $827f1b98b76cab0f$var$MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
const $827f1b98b76cab0f$var$INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
const $827f1b98b76cab0f$var$hasOwn = Object.prototype.hasOwnProperty;
class $827f1b98b76cab0f$var$KeyStore {
    constructor(keys){
        this._keys = [];
        this._keyMap = {};
        let totalWeight = 0;
        keys.forEach((key)=>{
            let obj = $827f1b98b76cab0f$var$createKey(key);
            totalWeight += obj.weight;
            this._keys.push(obj);
            this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach((key)=>{
            key.weight /= totalWeight;
        });
    }
    get(keyId) {
        return this._keyMap[keyId];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
}
function $827f1b98b76cab0f$var$createKey(key) {
    let path = null;
    let id = null;
    let src = null;
    let weight = 1;
    let getFn = null;
    if ($827f1b98b76cab0f$var$isString(key) || $827f1b98b76cab0f$var$isArray(key)) {
        src = key;
        path = $827f1b98b76cab0f$var$createKeyPath(key);
        id = $827f1b98b76cab0f$var$createKeyId(key);
    } else {
        if (!$827f1b98b76cab0f$var$hasOwn.call(key, 'name')) throw new Error($827f1b98b76cab0f$var$MISSING_KEY_PROPERTY('name'));
        const name = key.name;
        src = name;
        if ($827f1b98b76cab0f$var$hasOwn.call(key, 'weight')) {
            weight = key.weight;
            if (weight <= 0) throw new Error($827f1b98b76cab0f$var$INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = $827f1b98b76cab0f$var$createKeyPath(name);
        id = $827f1b98b76cab0f$var$createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $827f1b98b76cab0f$var$createKeyPath(key) {
    return $827f1b98b76cab0f$var$isArray(key) ? key : key.split('.');
}
function $827f1b98b76cab0f$var$createKeyId(key) {
    return $827f1b98b76cab0f$var$isArray(key) ? key.join('.') : key;
}
function $827f1b98b76cab0f$var$get(obj, path) {
    let list = [];
    let arr = false;
    const deepGet = (obj, path, index)=>{
        if (!$827f1b98b76cab0f$var$isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            let key = path[index];
            const value = obj[key];
            if (!$827f1b98b76cab0f$var$isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && ($827f1b98b76cab0f$var$isString(value) || $827f1b98b76cab0f$var$isNumber(value) || $827f1b98b76cab0f$var$isBoolean(value))) list.push($827f1b98b76cab0f$var$toString(value));
            else if ($827f1b98b76cab0f$var$isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, $827f1b98b76cab0f$var$isString(path) ? path.split('.') : path, 0);
    return arr ? list : list[0];
}
const $827f1b98b76cab0f$var$MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const $827f1b98b76cab0f$var$BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $827f1b98b76cab0f$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const $827f1b98b76cab0f$var$AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $827f1b98b76cab0f$var$get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $827f1b98b76cab0f$var$Config = {
    ...$827f1b98b76cab0f$var$BasicOptions,
    ...$827f1b98b76cab0f$var$MatchOptions,
    ...$827f1b98b76cab0f$var$FuzzyOptions,
    ...$827f1b98b76cab0f$var$AdvancedOptions
};
const $827f1b98b76cab0f$var$SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function $827f1b98b76cab0f$var$norm(weight = 1, mantissa = 3) {
    const cache = new Map();
    const m = Math.pow(10, mantissa);
    return {
        get (value) {
            const numTokens = value.match($827f1b98b76cab0f$var$SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            const n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear () {
            cache.clear();
        }
    };
}
class $827f1b98b76cab0f$var$FuseIndex {
    constructor({ getFn: getFn = $827f1b98b76cab0f$var$Config.getFn, fieldNormWeight: fieldNormWeight = $827f1b98b76cab0f$var$Config.fieldNormWeight } = {}){
        this.norm = $827f1b98b76cab0f$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
    setSources(docs = []) {
        this.docs = docs;
    }
    setIndexRecords(records = []) {
        this.records = records;
    }
    setKeys(keys = []) {
        this.keys = keys;
        this._keysMap = {};
        keys.forEach((key, idx)=>{
            this._keysMap[key.id] = idx;
        });
    }
    create() {
        if (this.isCreated || !this.docs.length) return;
        this.isCreated = true;
        // List is Array<String>
        if ($827f1b98b76cab0f$var$isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
            this._addString(doc, docIndex);
        });
        else // List is Array<Object>
        this.docs.forEach((doc, docIndex)=>{
            this._addObject(doc, docIndex);
        });
        this.norm.clear();
    }
    // Adds a doc to the end of the index
    add(doc) {
        const idx = this.size();
        if ($827f1b98b76cab0f$var$isString(doc)) this._addString(doc, idx);
        else this._addObject(doc, idx);
    }
    // Removes the doc at the specified index of the index
    removeAt(idx) {
        this.records.splice(idx, 1);
        // Change ref index of every subsquent doc
        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
    }
    getValueForItemAtKeyId(item, keyId) {
        return item[this._keysMap[keyId]];
    }
    size() {
        return this.records.length;
    }
    _addString(doc, docIndex) {
        if (!$827f1b98b76cab0f$var$isDefined(doc) || $827f1b98b76cab0f$var$isBlank(doc)) return;
        let record = {
            v: doc,
            i: docIndex,
            n: this.norm.get(doc)
        };
        this.records.push(record);
    }
    _addObject(doc, docIndex) {
        let record = {
            i: docIndex,
            $: {}
        };
        // Iterate over every key (i.e, path), and fetch the value at that key
        this.keys.forEach((key, keyIndex)=>{
            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
            if (!$827f1b98b76cab0f$var$isDefined(value)) return;
            if ($827f1b98b76cab0f$var$isArray(value)) {
                let subRecords = [];
                const stack = [
                    {
                        nestedArrIndex: -1,
                        value: value
                    }
                ];
                while(stack.length){
                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                    if (!$827f1b98b76cab0f$var$isDefined(value)) continue;
                    if ($827f1b98b76cab0f$var$isString(value) && !$827f1b98b76cab0f$var$isBlank(value)) {
                        let subRecord = {
                            v: value,
                            i: nestedArrIndex,
                            n: this.norm.get(value)
                        };
                        subRecords.push(subRecord);
                    } else if ($827f1b98b76cab0f$var$isArray(value)) value.forEach((item, k)=>{
                        stack.push({
                            nestedArrIndex: k,
                            value: item
                        });
                    });
                }
                record.$[keyIndex] = subRecords;
            } else if ($827f1b98b76cab0f$var$isString(value) && !$827f1b98b76cab0f$var$isBlank(value)) {
                let subRecord = {
                    v: value,
                    n: this.norm.get(value)
                };
                record.$[keyIndex] = subRecord;
            }
        });
        this.records.push(record);
    }
    toJSON() {
        return {
            keys: this.keys,
            records: this.records
        };
    }
}
function $827f1b98b76cab0f$var$createIndex(keys, docs, { getFn: getFn = $827f1b98b76cab0f$var$Config.getFn, fieldNormWeight: fieldNormWeight = $827f1b98b76cab0f$var$Config.fieldNormWeight } = {}) {
    const myIndex = new $827f1b98b76cab0f$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($827f1b98b76cab0f$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $827f1b98b76cab0f$var$parseIndex(data, { getFn: getFn = $827f1b98b76cab0f$var$Config.getFn, fieldNormWeight: fieldNormWeight = $827f1b98b76cab0f$var$Config.fieldNormWeight } = {}) {
    const { keys: keys, records: records } = data;
    const myIndex = new $827f1b98b76cab0f$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function $827f1b98b76cab0f$var$computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $827f1b98b76cab0f$var$Config.distance, ignoreLocation: ignoreLocation = $827f1b98b76cab0f$var$Config.ignoreLocation } = {}) {
    const accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $827f1b98b76cab0f$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $827f1b98b76cab0f$var$Config.minMatchCharLength) {
    let indices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
const $827f1b98b76cab0f$var$MAX_BITS = 32;
function $827f1b98b76cab0f$var$search(text, pattern, patternAlphabet, { location: location = $827f1b98b76cab0f$var$Config.location, distance: distance = $827f1b98b76cab0f$var$Config.distance, threshold: threshold = $827f1b98b76cab0f$var$Config.threshold, findAllMatches: findAllMatches = $827f1b98b76cab0f$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $827f1b98b76cab0f$var$Config.minMatchCharLength, includeMatches: includeMatches = $827f1b98b76cab0f$var$Config.includeMatches, ignoreLocation: ignoreLocation = $827f1b98b76cab0f$var$Config.ignoreLocation } = {}) {
    if (pattern.length > $827f1b98b76cab0f$var$MAX_BITS) throw new Error($827f1b98b76cab0f$var$PATTERN_LENGTH_TOO_LARGE($827f1b98b76cab0f$var$MAX_BITS));
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    const computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    const matchMask = computeMatches ? Array(textLen) : [];
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = $827f1b98b76cab0f$var$computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << patternLen - 1;
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = $827f1b98b76cab0f$var$computeScore$1(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $827f1b98b76cab0f$var$computeScore$1(pattern, {
                    errors: i,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = $827f1b98b76cab0f$var$computeScore$1(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    const result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        const indices = $827f1b98b76cab0f$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function $827f1b98b76cab0f$var$createPatternAlphabet(pattern) {
    let mask = {};
    for(let i = 0, len = pattern.length; i < len; i += 1){
        const char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
class $827f1b98b76cab0f$var$BitapSearch {
    constructor(pattern, { location: location = $827f1b98b76cab0f$var$Config.location, threshold: threshold = $827f1b98b76cab0f$var$Config.threshold, distance: distance = $827f1b98b76cab0f$var$Config.distance, includeMatches: includeMatches = $827f1b98b76cab0f$var$Config.includeMatches, findAllMatches: findAllMatches = $827f1b98b76cab0f$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $827f1b98b76cab0f$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $827f1b98b76cab0f$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $827f1b98b76cab0f$var$Config.ignoreLocation } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        if (!this.pattern.length) return;
        const addChunk = (pattern, startIndex)=>{
            this.chunks.push({
                pattern: pattern,
                alphabet: $827f1b98b76cab0f$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        const len = this.pattern.length;
        if (len > $827f1b98b76cab0f$var$MAX_BITS) {
            let i = 0;
            const remainder = len % $827f1b98b76cab0f$var$MAX_BITS;
            const end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, $827f1b98b76cab0f$var$MAX_BITS), i);
                i += $827f1b98b76cab0f$var$MAX_BITS;
            }
            if (remainder) {
                const startIndex = len - $827f1b98b76cab0f$var$MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
    searchIn(text) {
        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
        if (!isCaseSensitive) text = text.toLowerCase();
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.indices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
        let allIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
            const { isMatch: isMatch, score: score, indices: indices } = $827f1b98b76cab0f$var$search(text, pattern, alphabet, {
                location: location + startIndex,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches,
                ignoreLocation: ignoreLocation
            });
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && indices) allIndices = [
                ...allIndices,
                ...indices
            ];
        });
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.indices = allIndices;
        return result;
    }
}
class $827f1b98b76cab0f$var$BaseMatch {
    constructor(pattern){
        this.pattern = pattern;
    }
    static isMultiMatch(pattern) {
        return $827f1b98b76cab0f$var$getMatch(pattern, this.multiRegex);
    }
    static isSingleMatch(pattern) {
        return $827f1b98b76cab0f$var$getMatch(pattern, this.singleRegex);
    }
    search() {}
}
function $827f1b98b76cab0f$var$getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
class $827f1b98b76cab0f$var$ExactMatch extends $827f1b98b76cab0f$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'exact';
    }
    static get multiRegex() {
        return /^="(.*)"$/;
    }
    static get singleRegex() {
        return /^=(.*)$/;
    }
    search(text) {
        const isMatch = text === this.pattern;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !fire
class $827f1b98b76cab0f$var$InverseExactMatch extends $827f1b98b76cab0f$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(text) {
        const index = text.indexOf(this.pattern);
        const isMatch = index === -1;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: ^file
class $827f1b98b76cab0f$var$PrefixExactMatch extends $827f1b98b76cab0f$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'prefix-exact';
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(text) {
        const isMatch = text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !^fire
class $827f1b98b76cab0f$var$InversePrefixExactMatch extends $827f1b98b76cab0f$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-prefix-exact';
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(text) {
        const isMatch = !text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: .file$
class $827f1b98b76cab0f$var$SuffixExactMatch extends $827f1b98b76cab0f$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'suffix-exact';
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(text) {
        const isMatch = text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                text.length - this.pattern.length,
                text.length - 1
            ]
        };
    }
}
// Token: !.file$
class $827f1b98b76cab0f$var$InverseSuffixExactMatch extends $827f1b98b76cab0f$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-suffix-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(text) {
        const isMatch = !text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
class $827f1b98b76cab0f$var$FuzzyMatch extends $827f1b98b76cab0f$var$BaseMatch {
    constructor(pattern, { location: location = $827f1b98b76cab0f$var$Config.location, threshold: threshold = $827f1b98b76cab0f$var$Config.threshold, distance: distance = $827f1b98b76cab0f$var$Config.distance, includeMatches: includeMatches = $827f1b98b76cab0f$var$Config.includeMatches, findAllMatches: findAllMatches = $827f1b98b76cab0f$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $827f1b98b76cab0f$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $827f1b98b76cab0f$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $827f1b98b76cab0f$var$Config.ignoreLocation } = {}){
        super(pattern);
        this._bitapSearch = new $827f1b98b76cab0f$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        });
    }
    static get type() {
        return 'fuzzy';
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(text) {
        return this._bitapSearch.searchIn(text);
    }
}
// Token: 'file
class $827f1b98b76cab0f$var$IncludeMatch extends $827f1b98b76cab0f$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'include';
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(text) {
        let location = 0;
        let index;
        const indices = [];
        const patternLen = this.pattern.length;
        // Get all exact matches
        while((index = text.indexOf(this.pattern, location)) > -1){
            location = index + patternLen;
            indices.push([
                index,
                location - 1
            ]);
        }
        const isMatch = !!indices.length;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: indices
        };
    }
}
// ❗Order is important. DO NOT CHANGE.
const $827f1b98b76cab0f$var$searchers = [
    $827f1b98b76cab0f$var$ExactMatch,
    $827f1b98b76cab0f$var$IncludeMatch,
    $827f1b98b76cab0f$var$PrefixExactMatch,
    $827f1b98b76cab0f$var$InversePrefixExactMatch,
    $827f1b98b76cab0f$var$InverseSuffixExactMatch,
    $827f1b98b76cab0f$var$SuffixExactMatch,
    $827f1b98b76cab0f$var$InverseExactMatch,
    $827f1b98b76cab0f$var$FuzzyMatch
];
const $827f1b98b76cab0f$var$searchersLen = $827f1b98b76cab0f$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
const $827f1b98b76cab0f$var$SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const $827f1b98b76cab0f$var$OR_TOKEN = '|';
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $827f1b98b76cab0f$var$parseQuery(pattern, options = {}) {
    return pattern.split($827f1b98b76cab0f$var$OR_TOKEN).map((item)=>{
        let query = item.trim().split($827f1b98b76cab0f$var$SPACE_RE).filter((item)=>item && !!item.trim());
        let results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            let found = false;
            let idx = -1;
            while(!found && ++idx < $827f1b98b76cab0f$var$searchersLen){
                const searcher = $827f1b98b76cab0f$var$searchers[idx];
                let token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $827f1b98b76cab0f$var$searchersLen){
                const searcher = $827f1b98b76cab0f$var$searchers[idx];
                let token = searcher.isSingleMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
const $827f1b98b76cab0f$var$MultiMatchSet = new Set([
    $827f1b98b76cab0f$var$FuzzyMatch.type,
    $827f1b98b76cab0f$var$IncludeMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class $827f1b98b76cab0f$var$ExtendedSearch {
    constructor(pattern, { isCaseSensitive: isCaseSensitive = $827f1b98b76cab0f$var$Config.isCaseSensitive, includeMatches: includeMatches = $827f1b98b76cab0f$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $827f1b98b76cab0f$var$Config.minMatchCharLength, ignoreLocation: ignoreLocation = $827f1b98b76cab0f$var$Config.ignoreLocation, findAllMatches: findAllMatches = $827f1b98b76cab0f$var$Config.findAllMatches, location: location = $827f1b98b76cab0f$var$Config.location, threshold: threshold = $827f1b98b76cab0f$var$Config.threshold, distance: distance = $827f1b98b76cab0f$var$Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $827f1b98b76cab0f$var$parseQuery(this.pattern, this.options);
    }
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(text) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        let numMatches = 0;
        let allIndices = [];
        let totalScore = 0;
        // ORs
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            // Reset indices
            allIndices.length = 0;
            numMatches = 0;
            // ANDs
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const searcher = searchers[j];
                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if (includeMatches) {
                        const type = searcher.constructor.type;
                        if ($827f1b98b76cab0f$var$MultiMatchSet.has(type)) allIndices = [
                            ...allIndices,
                            ...indices
                        ];
                        else allIndices.push(indices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    allIndices.length = 0;
                    break;
                }
            }
            // OR condition, so if TRUE, return
            if (numMatches) {
                let result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (includeMatches) result.indices = allIndices;
                return result;
            }
        }
        // Nothing was matched
        return {
            isMatch: false,
            score: 1
        };
    }
}
const $827f1b98b76cab0f$var$registeredSearchers = [];
function $827f1b98b76cab0f$var$register(...args) {
    $827f1b98b76cab0f$var$registeredSearchers.push(...args);
}
function $827f1b98b76cab0f$var$createSearcher(pattern, options) {
    for(let i = 0, len = $827f1b98b76cab0f$var$registeredSearchers.length; i < len; i += 1){
        let searcherClass = $827f1b98b76cab0f$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $827f1b98b76cab0f$var$BitapSearch(pattern, options);
}
const $827f1b98b76cab0f$var$LogicalOperator = {
    AND: '$and',
    OR: '$or'
};
const $827f1b98b76cab0f$var$KeyType = {
    PATH: '$path',
    PATTERN: '$val'
};
const $827f1b98b76cab0f$var$isExpression = (query)=>!!(query[$827f1b98b76cab0f$var$LogicalOperator.AND] || query[$827f1b98b76cab0f$var$LogicalOperator.OR]);
const $827f1b98b76cab0f$var$isPath = (query)=>!!query[$827f1b98b76cab0f$var$KeyType.PATH];
const $827f1b98b76cab0f$var$isLeaf = (query)=>!$827f1b98b76cab0f$var$isArray(query) && $827f1b98b76cab0f$var$isObject(query) && !$827f1b98b76cab0f$var$isExpression(query);
const $827f1b98b76cab0f$var$convertToExplicit = (query)=>({
        [$827f1b98b76cab0f$var$LogicalOperator.AND]: Object.keys(query).map((key)=>({
                [key]: query[key]
            }))
    });
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function $827f1b98b76cab0f$var$parse(query, options, { auto: auto = true } = {}) {
    const next = (query)=>{
        let keys = Object.keys(query);
        const isQueryPath = $827f1b98b76cab0f$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$827f1b98b76cab0f$var$isExpression(query)) return next($827f1b98b76cab0f$var$convertToExplicit(query));
        if ($827f1b98b76cab0f$var$isLeaf(query)) {
            const key = isQueryPath ? query[$827f1b98b76cab0f$var$KeyType.PATH] : keys[0];
            const pattern = isQueryPath ? query[$827f1b98b76cab0f$var$KeyType.PATTERN] : query[key];
            if (!$827f1b98b76cab0f$var$isString(pattern)) throw new Error($827f1b98b76cab0f$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            const obj = {
                keyId: $827f1b98b76cab0f$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $827f1b98b76cab0f$var$createSearcher(pattern, options);
            return obj;
        }
        let node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach((key)=>{
            const value = query[key];
            if ($827f1b98b76cab0f$var$isArray(value)) value.forEach((item)=>{
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$827f1b98b76cab0f$var$isExpression(query)) query = $827f1b98b76cab0f$var$convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function $827f1b98b76cab0f$var$computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = $827f1b98b76cab0f$var$Config.ignoreFieldNorm }) {
    results.forEach((result)=>{
        let totalScore = 1;
        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
            const weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function $827f1b98b76cab0f$var$transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!$827f1b98b76cab0f$var$isDefined(matches)) return;
    matches.forEach((match)=>{
        if (!$827f1b98b76cab0f$var$isDefined(match.indices) || !match.indices.length) return;
        const { indices: indices, value: value } = match;
        let obj = {
            indices: indices,
            value: value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function $827f1b98b76cab0f$var$transformScore(result, data) {
    data.score = result.score;
}
function $827f1b98b76cab0f$var$format(results, docs, { includeMatches: includeMatches = $827f1b98b76cab0f$var$Config.includeMatches, includeScore: includeScore = $827f1b98b76cab0f$var$Config.includeScore } = {}) {
    const transformers = [];
    if (includeMatches) transformers.push($827f1b98b76cab0f$var$transformMatches);
    if (includeScore) transformers.push($827f1b98b76cab0f$var$transformScore);
    return results.map((result)=>{
        const { idx: idx } = result;
        const data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach((transformer)=>{
            transformer(result, data);
        });
        return data;
    });
}
class $827f1b98b76cab0f$export$2e2bcd8739ae039 {
    constructor(docs, options = {}, index){
        this.options = {
            ...$827f1b98b76cab0f$var$Config,
            ...options
        };
        this.options.useExtendedSearch;
        this._keyStore = new $827f1b98b76cab0f$var$KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
    setCollection(docs, index) {
        this._docs = docs;
        if (index && !(index instanceof $827f1b98b76cab0f$var$FuseIndex)) throw new Error($827f1b98b76cab0f$var$INCORRECT_INDEX_TYPE);
        this._myIndex = index || $827f1b98b76cab0f$var$createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
    }
    add(doc) {
        if (!$827f1b98b76cab0f$var$isDefined(doc)) return;
        this._docs.push(doc);
        this._myIndex.add(doc);
    }
    remove(predicate = ()=>false) {
        const results = [];
        for(let i = 0, len = this._docs.length; i < len; i += 1){
            const doc = this._docs[i];
            if (predicate(doc, i)) {
                this.removeAt(i);
                i -= 1;
                len -= 1;
                results.push(doc);
            }
        }
        return results;
    }
    removeAt(idx) {
        this._docs.splice(idx, 1);
        this._myIndex.removeAt(idx);
    }
    getIndex() {
        return this._myIndex;
    }
    search(query, { limit: limit = -1 } = {}) {
        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
        let results = $827f1b98b76cab0f$var$isString(query) ? $827f1b98b76cab0f$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
        $827f1b98b76cab0f$var$computeScore(results, {
            ignoreFieldNorm: ignoreFieldNorm
        });
        if (shouldSort) results.sort(sortFn);
        if ($827f1b98b76cab0f$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
        return $827f1b98b76cab0f$var$format(results, this._docs, {
            includeMatches: includeMatches,
            includeScore: includeScore
        });
    }
    _searchStringList(query) {
        const searcher = $827f1b98b76cab0f$var$createSearcher(query, this.options);
        const { records: records } = this._myIndex;
        const results = [];
        // Iterate over every string in the index
        records.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$827f1b98b76cab0f$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) results.push({
                item: text,
                idx: idx,
                matches: [
                    {
                        score: score,
                        value: text,
                        norm: norm,
                        indices: indices
                    }
                ]
            });
        });
        return results;
    }
    _searchLogical(query) {
        const expression = $827f1b98b76cab0f$var$parse(query, this.options);
        const evaluate = (node, item, idx)=>{
            if (!node.children) {
                const { keyId: keyId, searcher: searcher } = node;
                const matches = this._findMatches({
                    key: this._keyStore.get(keyId),
                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                    searcher: searcher
                });
                if (matches && matches.length) return [
                    {
                        idx: idx,
                        item: item,
                        matches: matches
                    }
                ];
                return [];
            }
            const res = [];
            for(let i = 0, len = node.children.length; i < len; i += 1){
                const child = node.children[i];
                const result = evaluate(child, item, idx);
                if (result.length) res.push(...result);
                else if (node.operator === $827f1b98b76cab0f$var$LogicalOperator.AND) return [];
            }
            return res;
        };
        const records = this._myIndex.records;
        const resultMap = {};
        const results = [];
        records.forEach(({ $: item, i: idx })=>{
            if ($827f1b98b76cab0f$var$isDefined(item)) {
                let expResults = evaluate(expression, item, idx);
                if (expResults.length) {
                    // Dedupe when adding
                    if (!resultMap[idx]) {
                        resultMap[idx] = {
                            idx: idx,
                            item: item,
                            matches: []
                        };
                        results.push(resultMap[idx]);
                    }
                    expResults.forEach(({ matches: matches })=>{
                        resultMap[idx].matches.push(...matches);
                    });
                }
            }
        });
        return results;
    }
    _searchObjectList(query) {
        const searcher = $827f1b98b76cab0f$var$createSearcher(query, this.options);
        const { keys: keys, records: records } = this._myIndex;
        const results = [];
        // List is Array<Object>
        records.forEach(({ $: item, i: idx })=>{
            if (!$827f1b98b76cab0f$var$isDefined(item)) return;
            let matches = [];
            // Iterate over every key (i.e, path), and fetch the value at that key
            keys.forEach((key, keyIndex)=>{
                matches.push(...this._findMatches({
                    key: key,
                    value: item[keyIndex],
                    searcher: searcher
                }));
            });
            if (matches.length) results.push({
                idx: idx,
                item: item,
                matches: matches
            });
        });
        return results;
    }
    _findMatches({ key: key, value: value, searcher: searcher }) {
        if (!$827f1b98b76cab0f$var$isDefined(value)) return [];
        let matches = [];
        if ($827f1b98b76cab0f$var$isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$827f1b98b76cab0f$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                idx: idx,
                norm: norm,
                indices: indices
            });
        });
        else {
            const { v: text, n: norm } = value;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                norm: norm,
                indices: indices
            });
        }
        return matches;
    }
}
$827f1b98b76cab0f$export$2e2bcd8739ae039.version = '6.6.2';
$827f1b98b76cab0f$export$2e2bcd8739ae039.createIndex = $827f1b98b76cab0f$var$createIndex;
$827f1b98b76cab0f$export$2e2bcd8739ae039.parseIndex = $827f1b98b76cab0f$var$parseIndex;
$827f1b98b76cab0f$export$2e2bcd8739ae039.config = $827f1b98b76cab0f$var$Config;
$827f1b98b76cab0f$export$2e2bcd8739ae039.parseQuery = $827f1b98b76cab0f$var$parse;
$827f1b98b76cab0f$var$register($827f1b98b76cab0f$var$ExtendedSearch);

});


parcelRegister("7k8dr", function(module, exports) {
$parcel$export(module.exports, "TypeAheadAvailableNodes", () => $1ac3d3cd18da0878$export$8c4c885c87e5cc07);
$parcel$export(module.exports, "SelectItemMode", () => $1ac3d3cd18da0878$export$4d7d0343c6d95a0e);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $4drex = parcelRequire("4drex");
var $1ac3d3cd18da0878$export$8c4c885c87e5cc07 = /*#__PURE__*/ function(TypeAheadAvailableNodes) {
    TypeAheadAvailableNodes["EMOJI"] = "emojiTypeAhead";
    TypeAheadAvailableNodes["MENTION"] = "mentionTypeAhead";
    TypeAheadAvailableNodes["QUICK_INSERT"] = "quickInsertTypeAhead";
    return TypeAheadAvailableNodes;
}({});
var $1ac3d3cd18da0878$export$4d7d0343c6d95a0e = /*#__PURE__*/ function(SelectItemMode) {
    SelectItemMode["SHIFT_ENTER"] = "shift-enter";
    SelectItemMode["ENTER"] = "enter";
    SelectItemMode["SPACE"] = "space";
    SelectItemMode["SELECTED"] = "selected";
    SelectItemMode["TAB"] = "tab";
    return SelectItemMode;
}({});

});
parcelRegister("4drex", function(module, exports) {
$parcel$export(module.exports, "typeAheadListMessages", () => $d1e71c029c5281e2$export$940a17143b866527);

var $7qGN1 = parcelRequire("7qGN1");
const $d1e71c029c5281e2$export$940a17143b866527 = (0, $7qGN1.defineMessages)({
    typeAheadPopupLabel: {
        id: 'fabric.editor.typeAhead.popupLabel',
        defaultMessage: 'Typeahead results',
        description: 'the result of a typeahead, similar to autocomplete results+'
    },
    quickInsertPopupLabel: {
        id: 'fabric.editor.typeAhead.quickInsertPopupLabel',
        defaultMessage: 'Shortcuts for inserts and formatting',
        description: 'the result of a quick insert typeahead, similar to autocomplete results+'
    },
    quickInsertInputLabel: {
        id: 'fabric.editor.typeAhead.quickInsertInputLabel',
        defaultMessage: 'Begin typing to search or filter shortcut options',
        description: 'assisitve text for typeahed input field'
    },
    quickInsertInputPlaceholderLabel: {
        id: 'fabric.editor.typeAhead.quickInsertInputPlaceholderLabel',
        defaultMessage: 'Search',
        description: 'placeholder for typeahed input field'
    },
    emojiPopupLabel: {
        id: 'fabric.editor.typeahead.emojiPopupLabel',
        defaultMessage: 'Emoji shortcuts',
        description: 'the result of a emoji typeahead, similar to autocomplete results+'
    },
    emojiInputLabel: {
        id: 'fabric.editor.typeahead.emojiInputLabel',
        defaultMessage: 'Begin typing to search or filter emoji options',
        description: 'assisitve text for typeahed input field'
    },
    mentionPopupLabel: {
        id: 'fabric.editor.typeahead.mentionPopupLabel',
        defaultMessage: 'Users you can tag',
        description: 'the aria label of a mention typeahead popup'
    },
    mentionInputLabel: {
        id: 'fabric.editor.typeahead.mentionInputLabel',
        defaultMessage: 'Begin typing to search for users to tag',
        description: 'assisitve text for typeahed input field'
    },
    metionListItemLabel: {
        id: 'fabric.editor.typeahead.metionListItemLabel',
        defaultMessage: 'User {name} @{shortName}',
        description: 'assistive text for user mention items username and nickname'
    },
    emojiListItemLabel: {
        id: 'fabric.editor.typeahead.emojiListItemLabel',
        defaultMessage: 'Emoji {name} Text Shortcut {shortcut}',
        description: 'assistive text for emoji name and shortcut'
    },
    inputQueryAssistiveLabel: {
        id: 'fabric.editor.inputQueryAssistiveTxt',
        defaultMessage: 'When autocomplete results are available use up and down arrows to review and enter to select. Touch device users, explore by touch or with swipe gestures.',
        description: 'Assistive text to the user when using typeahead shortcut'
    },
    searchResultsLabel: {
        id: 'fabric.editor.searchResults',
        defaultMessage: '{itemsLength, plural, one {# search result} other {# search results}} available. Use Up and Down arrow keys to navigate amongst the options. Press Enter to select an option.',
        description: 'Assistive text to the user when using typeahead shortcut and it preceeds with a number - Ex: 10 search results available'
    },
    noSearchResultsLabel: {
        id: 'fabric.editor.noSearchResults',
        defaultMessage: 'No search results',
        description: 'Assistive text to the user when using typeahead shortcut'
    },
    descriptionLabel: {
        id: 'fabric.editor.description',
        defaultMessage: 'Description',
        description: 'Description'
    },
    shortcutLabel: {
        id: 'fabric.editor.shortcut',
        defaultMessage: 'Text shortcut',
        description: 'Text shortcut'
    },
    typeAheadErrorFallbackHeading: {
        id: 'fabric.editor.typeAheadErrorFallbackHeading',
        defaultMessage: 'Something went wrong',
        description: 'Error message heading shown when typeahead items fail to load'
    },
    typeAheadErrorFallbackDesc: {
        id: 'fabric.editor.typeAheadErrorFallbackDescription',
        defaultMessage: 'No results available. Try again.',
        description: 'Error message description shown when typeahead items fail to load'
    },
    viewAllInserts: {
        id: 'fablric.editor.viewAllInserts',
        defaultMessage: 'View all inserts',
        description: 'a text on a button that opens a side panel with a list of all insertable editor elements'
    },
    emptySearchResults: {
        id: 'fabric.editor.emptySearchResults',
        defaultMessage: "We couldn't find any results.",
        description: 'a message displayed when there are no search results'
    },
    emptySearchResultsSuggestion: {
        id: 'fabric.editor.emptySearchResultsSuggestion',
        defaultMessage: 'Select {buttonName} to browse inserts.',
        description: 'a prompt to suggest user to click a button to browse inserts when there are no search results'
    }
});

});


parcelRegister("71AZG", function(module, exports) {
$parcel$export(module.exports, "openElementBrowserModal", () => $f3d8ca7d23af195f$export$a37159c5d6f821f5);
$parcel$export(module.exports, "closeElementBrowserModal", () => $f3d8ca7d23af195f$export$d7c09ddb7ec80ba9);
$parcel$export(module.exports, "createInsertItem", () => $f3d8ca7d23af195f$export$40b105cb73ed6b94);

var $j6ZdO = parcelRequire("j6ZdO");

var $cdVXP = parcelRequire("cdVXP");
const $f3d8ca7d23af195f$export$a37159c5d6f821f5 = ({ tr: tr })=>tr.setMeta((0, $cdVXP.pluginKey), {
        isElementBrowserModalOpen: true
    });
const $f3d8ca7d23af195f$export$d7c09ddb7ec80ba9 = ()=>(state, dispatch)=>{
        if (dispatch) dispatch(state.tr.setMeta((0, $cdVXP.pluginKey), {
            isElementBrowserModalOpen: false
        }));
        return true;
    };
const $f3d8ca7d23af195f$export$40b105cb73ed6b94 = (onInsert)=>$f3d8ca7d23af195f$var$insertItem(onInsert);
// this method was adapted from the typeahead plugin so we respect the API for quick insert items
const $f3d8ca7d23af195f$var$insertItem = (onInsert)=>(item, source)=>(state, dispatch)=>{
            const insert = (maybeNode, opts = {})=>{
                return (0, $j6ZdO.insertSelectedItem)(maybeNode, opts)(state, state.tr, state.selection.head);
            };
            const tr = item.action(insert, state, source);
            /** @note There is no transaction when called without a search currently (different insert) */ if (tr && dispatch) dispatch(tr);
            onInsert?.(item);
            return true;
        };

});
parcelRegister("cdVXP", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $30a1ffbda9dc6425$export$18d4026d1ea86bb1);

var $3lIcL = parcelRequire("3lIcL");
const $30a1ffbda9dc6425$export$18d4026d1ea86bb1 = new (0, $3lIcL.PluginKey)('quickInsertPluginKey');

});


parcelRegister("7et8b", function(module, exports) {
$parcel$export(module.exports, "getQuickInsertOpenExperiencePlugin", () => $150c547cf8c07b94$export$399cc8247eb1f3b5);

var $k2l7w = parcelRequire("k2l7w");
var $7SkRr = parcelRequire("7SkRr");
var $aYb4u = parcelRequire("aYb4u");
var $9nOJL = parcelRequire("9nOJL");

var $i8KtF = parcelRequire("i8KtF");

var $3lIcL = parcelRequire("3lIcL");
const $150c547cf8c07b94$var$pluginKey = new (0, $3lIcL.PluginKey)('quickInsertOpenExperience');
const $150c547cf8c07b94$var$START_METHOD = {
    QUICK_INSERT_BUTTON: 'quick-insert-button',
    TYPEAHEAD: 'typeahead'
};
const $150c547cf8c07b94$var$ABORT_REASON = {
    USER_CANCELED: 'user-canceled',
    EDITOR_DESTROYED: 'editor-destroyed'
};
const $150c547cf8c07b94$export$399cc8247eb1f3b5 = ({ refs: refs })=>{
    let targetEl;
    let editorViewEl;
    const getTarget = ()=>{
        if (!targetEl) targetEl = refs.popupsMountPoint || refs.wrapperElement || (0, $k2l7w.getPopupContainerFromEditorView)(editorViewEl);
        return targetEl;
    };
    const experience = new (0, $7SkRr.Experience)('quick-insert-open', {
        checks: [
            new (0, $9nOJL.ExperienceCheckTimeout)({
                durationMs: 500
            }),
            new (0, $aYb4u.ExperienceCheckDomMutation)({
                onDomMutation: ({ mutations: mutations })=>{
                    if (mutations.some($150c547cf8c07b94$var$isQuickInsertMenuAddedInMutation)) return {
                        status: 'success'
                    };
                },
                observeConfig: ()=>({
                        target: getTarget(),
                        options: {
                            childList: true
                        }
                    })
            })
        ]
    });
    return new (0, $i8KtF.SafePlugin)({
        key: $150c547cf8c07b94$var$pluginKey,
        props: {
            handleDOMEvents: {
                click: (_view, event)=>{
                    if ($150c547cf8c07b94$var$isTargetQuickInsertButton(event.target)) experience.start({
                        metadata: {
                            method: $150c547cf8c07b94$var$START_METHOD.QUICK_INSERT_BUTTON
                        }
                    });
                },
                beforeinput: (view, event)=>{
                    if ($150c547cf8c07b94$var$isQuickInsertTrigger(event) && $150c547cf8c07b94$var$isSelectionWhichSupportsTypeahead(view)) experience.start({
                        metadata: {
                            method: $150c547cf8c07b94$var$START_METHOD.TYPEAHEAD
                        }
                    });
                },
                keydown: (_view, event)=>{
                    if ($150c547cf8c07b94$var$isCancelKey(event.key) && !$150c547cf8c07b94$var$isQuickInsertMenuWithinNode(getTarget())) experience.abort({
                        metadata: {
                            reason: $150c547cf8c07b94$var$ABORT_REASON.USER_CANCELED
                        }
                    });
                }
            }
        },
        view: (editorView)=>{
            editorViewEl = editorView.dom;
            return {
                destroy: ()=>{
                    experience.abort({
                        metadata: {
                            reason: $150c547cf8c07b94$var$ABORT_REASON.EDITOR_DESTROYED
                        }
                    });
                }
            };
        }
    });
};
const $150c547cf8c07b94$var$isQuickInsertTrigger = ({ inputType: inputType, data: data })=>{
    return inputType === 'insertText' && data === '/';
};
const $150c547cf8c07b94$var$isSelectionWhichSupportsTypeahead = ({ state: state })=>{
    const { from: from, $from: $from } = state.selection;
    if ($from.parent.type.name === 'codeBlock') return false;
    if ($from.marks().some((mark)=>mark.type.name === 'code')) return false;
    if (from === 0) return true;
    const nodeBefore = state.doc.resolve(from).nodeBefore;
    if (!nodeBefore) return true;
    const charBefore = nodeBefore.textContent?.slice(-1) || '';
    return charBefore.trim().length === 0;
};
const $150c547cf8c07b94$var$isCancelKey = (key)=>{
    return key === 'Escape' || key === 'Backspace';
};
const $150c547cf8c07b94$var$isTargetQuickInsertButton = (target)=>{
    return target instanceof HTMLElement && (target.dataset.testid === 'editor-quick-insert-button' || !!target.closest('[data-testid="editor-quick-insert-button"]'));
};
const $150c547cf8c07b94$var$isQuickInsertMenuAddedInMutation = ({ type: type, addedNodes: addedNodes })=>{
    return type === 'childList' && [
        ...addedNodes
    ].some($150c547cf8c07b94$var$isQuickInsertMenuWithinNode);
};
const $150c547cf8c07b94$var$isQuickInsertMenuWithinNode = (node)=>{
    return (0, $k2l7w.containsPopupWithNestedElement)(node, '.fabric-editor-typeahead');
};

});
parcelRegister("k2l7w", function(module, exports) {
$parcel$export(module.exports, "containsPopupWithNestedElement", () => $b496a1e86ce34709$export$34b917212c8a3de1);
$parcel$export(module.exports, "getPopupContainerFromEditorView", () => $b496a1e86ce34709$export$f562a1e3da45e3ca);
/**
 * Checks if a given node contains a popup with a nested element identified by a specific test ID.
 *
 * @param node - The node to check.
 * @param nestedElementQuery - The query to look for the nested element.
 * @returns True if the node contains the popup, false otherwise.
 */ const $b496a1e86ce34709$export$34b917212c8a3de1 = (node, nestedElementQuery)=>{
    if (!(node instanceof HTMLElement)) return false;
    // Check if node itself has the popup attribute and contains the element matching the nestedElementQuery
    if (node.matches('[data-editor-popup="true"]')) return !!node.querySelector(nestedElementQuery);
    // Check if any direct child with popup attribute contains the element matching the nestedElementQuery
    return !!node.querySelector(`:scope > [data-editor-popup="true"] ${nestedElementQuery}`);
};
const $b496a1e86ce34709$export$f562a1e3da45e3ca = (editorViewEl)=>{
    const editorContentArea = editorViewEl?.closest('.ak-editor-content-area');
    const pluginsComponentsWrapper = editorContentArea?.querySelector(':scope > [data-testid="plugins-components-wrapper"]');
    return pluginsComponentsWrapper || undefined;
};

});

parcelRegister("7SkRr", function(module, exports) {
$parcel$export(module.exports, "Experience", () => $1ea2c81f01523524$export$c90b54e658fc4d7c);

var $aRnO1 = parcelRequire("aRnO1");
var $2pMzV = parcelRequire("2pMzV");
var $g0oDq = parcelRequire("g0oDq");

var $5rWen = parcelRequire("5rWen");
const $1ea2c81f01523524$var$PROGRESS_STATES = [
    (0, $g0oDq.UFOExperienceState).STARTED.id,
    (0, $g0oDq.UFOExperienceState).IN_PROGRESS.id
];
class $1ea2c81f01523524$export$c90b54e658fc4d7c {
    constructor(id, options = {}){
        this.id = id;
        this.options = options;
        this.check = new (0, $5rWen.ExperienceCheckComposite)(this.options.checks || []);
    }
    get ufoExperience() {
        if (!this._ufoExperience) this._ufoExperience = new (0, $2pMzV.UFOExperience)(this.id, {
            type: (0, $aRnO1.ExperienceTypes).Experience,
            performanceType: (0, $aRnO1.ExperiencePerformanceTypes).InlineResult,
            platform: {
                component: 'editor'
            }
        });
        return this._ufoExperience;
    }
    startCheck() {
        this.stopCheck();
        this.check.start((result)=>{
            const { metadata: metadata } = result;
            if (result.status === 'success') this.success({
                metadata: metadata
            });
            else if (result.status === 'abort') this.abort({
                metadata: metadata
            });
            else if (result.status === 'failure') this.failure({
                metadata: metadata
            });
        });
    }
    stopCheck() {
        this.check.stop();
    }
    isInProgress() {
        return $1ea2c81f01523524$var$PROGRESS_STATES.includes(this.ufoExperience.state.id);
    }
    getEndStateConfig(options) {
        return {
            metadata: options?.metadata || this.startOptions?.metadata ? {
                ...this.startOptions?.metadata,
                ...options?.metadata
            } : undefined
        };
    }
    /**
	 * Starts tracking the experience and all checks which monitor for completion.
	 *
	 * If the experience is already in progress, this will restart the checks.
	 * Metadata from options will be merged with any end state metadata.
	 *
	 * @param options - Configuration for starting the experience
	 * @param options.metadata - Optional metadata attached to all subsequent events for this started experience
	 */ start(options) {
        this.startOptions = options;
        this.ufoExperience.start();
        if (this.isInProgress()) this.startCheck();
    }
    /**
	 * Marks the experience as successful and stops any ongoing checks.
	 *
	 * Use this when the experience completes as expected.
	 *
	 * @param options - Configuration for the success event
	 * @param options.metadata - Optional metadata attached to the success event
	 */ success(options) {
        this.stopCheck();
        this.ufoExperience.success(this.getEndStateConfig(options));
        this.startOptions = undefined;
    }
    /**
	 * Aborts the experience and stops any ongoing checks.
	 *
	 * Use this when a started experience terminates early due to user action or context change
	 * (e.g., component unmount, navigation). This is neither success nor failure.
	 *
	 * @param options - Configuration for the abort event
	 * @param options.metadata - Optional metadata attached to the abort event
	 *
	 * @example
	 * // Abort on component unmount
	 * useEffect(() => {
	 *   return () => experience.abort({ metadata: { reason: 'unmount' } });
	 * }, []);
	 */ abort(options) {
        this.stopCheck();
        this.ufoExperience.abort(this.getEndStateConfig(options));
        this.startOptions = undefined;
    }
    /**
	 * Manually marks the experience as failed and stops any ongoing checks.
	 *
	 * Use this for actual failures in the experience flow (e.g., timeout, error conditions).
	 *
	 * @param options - Configuration for the failure event
	 * @param options.metadata - Optional metadata attached to the failure event
	 */ failure(options) {
        this.stopCheck();
        this.ufoExperience.failure(this.getEndStateConfig(options));
        this.startOptions = undefined;
    }
}

});
parcelRegister("5rWen", function(module, exports) {
$parcel$export(module.exports, "ExperienceCheckComposite", () => $3ac4876da5604cd5$export$fa331fd384051f6a);
class $3ac4876da5604cd5$export$fa331fd384051f6a {
    constructor(checks){
        this.checks = checks;
    }
    start(callback) {
        this.checks.forEach((check)=>check.start(callback));
    }
    stop() {
        this.checks.forEach((check)=>check.stop());
    }
}

});


parcelRegister("aYb4u", function(module, exports) {
$parcel$export(module.exports, "ExperienceCheckDomMutation", () => $96f08c0554e54381$export$e76932dc77daa06a);

var $tC3Jr = parcelRequire("tC3Jr");
class $96f08c0554e54381$export$e76932dc77daa06a {
    constructor({ onDomMutation: onDomMutation, observeConfig: observeConfig }){
        this.onDomMutation = onDomMutation;
        this.observeConfig = observeConfig;
    }
    start(callback) {
        this.stop();
        const config = this.observeConfig();
        if (!config?.target) {
            callback({
                status: 'failure',
                metadata: {
                    reason: (0, $tC3Jr.EXPERIENCE_FAILURE_REASON).DOM_MUTATION_TARGET_NOT_FOUND
                }
            });
            return;
        }
        this.mutationObserver = new MutationObserver((mutations)=>{
            try {
                const result = this.onDomMutation({
                    mutations: mutations
                });
                if (result) callback(result);
            } catch (error) {
                callback({
                    status: 'failure',
                    metadata: {
                        reason: (0, $tC3Jr.EXPERIENCE_FAILURE_REASON).DOM_MUTATION_CHECK_ERROR
                    }
                });
            }
        });
        const { target: target, options: options } = config;
        this.mutationObserver.observe(target, options);
    }
    stop() {
        if (this.mutationObserver) {
            this.mutationObserver.disconnect();
            this.mutationObserver = undefined;
        }
    }
}

});
parcelRegister("tC3Jr", function(module, exports) {
$parcel$export(module.exports, "EXPERIENCE_FAILURE_REASON", () => $ebe116d6e40aa6ee$export$21dde0ac9b2abe83);
/**
 * Built-in failure reasons for experience checks
 *
 * These are used by the various ExperienceCheck implementations to
 * provide consistent, well-known failure reasons for analytics and debugging.
 */ const $ebe116d6e40aa6ee$export$21dde0ac9b2abe83 = {
    /**
	 * Experience timed out before completion
	 */ TIMEOUT: 'timeout',
    /**
	 * Target element could not be found when starting DOM mutation observation
	 */ DOM_MUTATION_TARGET_NOT_FOUND: 'dom-mutation-target-not-found',
    /**
	 * Error occurred during DOM mutation check execution
	 */ DOM_MUTATION_CHECK_ERROR: 'dom-mutation-check-error'
};

});


parcelRegister("9nOJL", function(module, exports) {
$parcel$export(module.exports, "ExperienceCheckTimeout", () => $5ddc773d39ca6b51$export$1a6fa509d14ac50);

var $tC3Jr = parcelRequire("tC3Jr");
const $5ddc773d39ca6b51$var$DEFAULT_FAILURE_RESULT = {
    status: 'failure',
    metadata: {
        reason: (0, $tC3Jr.EXPERIENCE_FAILURE_REASON).TIMEOUT
    }
};
class $5ddc773d39ca6b51$export$1a6fa509d14ac50 {
    constructor({ durationMs: durationMs, onTimeout: onTimeout = ()=>$5ddc773d39ca6b51$var$DEFAULT_FAILURE_RESULT }){
        this.durationMs = 0;
        this.durationMs = durationMs;
        this.onTimeout = onTimeout;
    }
    start(callback) {
        this.stop();
        this.timeoutId = setTimeout(()=>{
            const result = this.onTimeout() || $5ddc773d39ca6b51$var$DEFAULT_FAILURE_RESULT;
            callback(result);
        }, this.durationMs);
    }
    stop() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = undefined;
        }
    }
}

});


parcelRegister("25zYy", function(module, exports) {
$parcel$export(module.exports, "default", () => $c608b1169c93c18f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $cxXTK = parcelRequire("cxXTK");

var $eGOwo = parcelRequire("eGOwo");

var $71AZG = parcelRequire("71AZG");

var $9edfs = parcelRequire("9edfs");
const $c608b1169c93c18f$var$Modal = ({ quickInsertState: quickInsertState, isOffline: isOffline, editorView: editorView, helpUrl: helpUrl, insertItem: insertItem, getSuggestions: getSuggestions, api: api })=>{
    const getItems = (0, $eJOHy.useCallback)((query, category)=>getSuggestions?.({
            query: query,
            category: category
        })?.map((item)=>{
            return isOffline && item.isDisabledOffline ? {
                ...item,
                isDisabled: true
            } : item;
        }) ?? [], // See: https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/157796/overview?commentId=8559952
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        getSuggestions,
        quickInsertState.lazyDefaultItems,
        quickInsertState.providedItems,
        isOffline
    ]);
    const focusInEditor = (0, $eJOHy.useCallback)(()=>{
        if (!editorView.hasFocus()) editorView.focus();
    }, [
        editorView
    ]);
    // ED-19408 We not store the item ref in the state
    // Instead of adding the item immediately on insert item
    // We wait until modal close is complete, refocus the editor and then add the item
    const insertableItem = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const onInsertItem = (0, $eJOHy.useCallback)((item)=>{
        (0, $71AZG.closeElementBrowserModal)()(editorView.state, editorView.dispatch);
        if ((0, $eGOwo.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
        insertableItem.current = item;
    }, [
        editorView,
        api
    ]);
    const onClose = (0, $eJOHy.useCallback)(()=>{
        (0, $71AZG.closeElementBrowserModal)()(editorView.state, editorView.dispatch);
        if ((0, $eGOwo.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
        focusInEditor();
    }, [
        editorView,
        focusInEditor,
        api
    ]);
    const onCloseComplete = (0, $eJOHy.useCallback)(()=>{
        if (!insertableItem.current) {
            focusInEditor();
            return;
        }
        const item = insertableItem.current;
        insertableItem.current = null;
        focusInEditor();
        insertItem?.(item)(editorView.state, editorView.dispatch);
    }, [
        editorView,
        focusInEditor,
        insertItem
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9edfs.default), {
        getItems: getItems,
        onInsertItem: onInsertItem,
        helpUrl: helpUrl,
        isOpen: quickInsertState.isElementBrowserModalOpen || false,
        emptyStateHandler: quickInsertState.emptyStateHandler,
        onClose: onClose,
        onCloseComplete: onCloseComplete,
        shouldReturnFocus: false
    });
};
var $c608b1169c93c18f$export$2e2bcd8739ae039 = ({ editorView: editorView, helpUrl: helpUrl, pluginInjectionAPI: pluginInjectionAPI })=>{
    const { lazyDefaultItems: lazyDefaultItems, providedItems: providedItems, isElementBrowserModalOpen: isElementBrowserModalOpen, emptyStateHandler: emptyStateHandler, mode: mode } = (0, $cxXTK.useSharedPluginStateWithSelector)(pluginInjectionAPI, [
        'quickInsert',
        'connectivity'
    ], (state)=>({
            lazyDefaultItems: state.quickInsertState?.lazyDefaultItems,
            providedItems: state.quickInsertState?.providedItems,
            isElementBrowserModalOpen: state.quickInsertState?.isElementBrowserModalOpen,
            emptyStateHandler: state.quickInsertState?.emptyStateHandler,
            mode: state.connectivityState?.mode
        }));
    return /*#__PURE__*/ (0, $gt9Am.jsx)($c608b1169c93c18f$var$Modal, {
        quickInsertState: {
            lazyDefaultItems: lazyDefaultItems,
            providedItems: providedItems,
            isElementBrowserModalOpen: isElementBrowserModalOpen,
            emptyStateHandler: emptyStateHandler
        },
        editorView: editorView,
        helpUrl: helpUrl,
        isOffline: mode === 'offline',
        insertItem: pluginInjectionAPI?.quickInsert?.actions?.insertItem,
        getSuggestions: pluginInjectionAPI?.quickInsert?.actions?.getSuggestions,
        api: pluginInjectionAPI
    });
};

});
parcelRegister("9edfs", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff4d7472b93555bf$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");

var $goZPP = parcelRequire("goZPP");

var $7vo9Y = parcelRequire("7vo9Y");

var $kpo54 = parcelRequire("kpo54");

var $k9Gmz = parcelRequire("k9Gmz");

var $gxxFp = parcelRequire("gxxFp");
var $gHHv2 = parcelRequire("gHHv2");
var $956it = parcelRequire("956it");
var $ioK9M = parcelRequire("ioK9M");

var $eGOwo = parcelRequire("eGOwo");


var $fbV60 = parcelRequire("fbV60");
function $ff4d7472b93555bf$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ff4d7472b93555bf$export$77ff514ac660f8f8 = 16;
const $ff4d7472b93555bf$var$actionsStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'inline-flex',
    margin: `0 ${"var(--ds-space-negative-050, -4px)"}`
});
const $ff4d7472b93555bf$var$actionItemStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    flex: '1 0 auto',
    margin: `0 ${"var(--ds-space-050, 4px)"}`
});
const $ff4d7472b93555bf$var$wrapperStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'flex',
    flex: '1 1 auto',
    boxSizing: 'border-box',
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"} 0 10px`,
    overflow: 'hidden',
    backgroundColor: `var(--ds-surface-overlay, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
    borderRadius: "var(--ds-radius-small, 3px)"
});
const $ff4d7472b93555bf$var$modalFooterStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'flex',
    padding: `${"var(--ds-space-200, 16px)"}`,
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between'
});
const $ff4d7472b93555bf$var$modalCloseButtonStyles = {
    name: "1446vv2",
    styles: "display:flex;justify-content:flex-end;padding-block-start:var(--ds-space-200, 16px);padding-inline:var(--ds-space-200, 16px)"
};
const $ff4d7472b93555bf$var$ModalElementBrowser = (props)=>{
    const [selectedItem, setSelectedItem] = (0, $eJOHy.useState)();
    const { helpUrl: helpUrl, intl: intl, onInsertItem: onInsertItemFn } = props;
    const isUpdateModalCloseButtonEnabled = (0, $eGOwo.fg)('platform_editor_update_modal_close_button');
    const onSelectItem = (0, $eJOHy.useCallback)((item)=>{
        setSelectedItem(item);
    }, [
        setSelectedItem
    ]);
    const onInsertItem = (0, $eJOHy.useCallback)((item)=>{
        onInsertItemFn(item);
    }, [
        onInsertItemFn
    ]);
    const RenderFooter = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, $1NIU8.jsx)($ff4d7472b93555bf$var$Footer, {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            onInsert: ()=>onInsertItem(selectedItem),
            beforeElement: helpUrl ? $ff4d7472b93555bf$var$HelpLink(helpUrl, intl.formatMessage((0, $kpo54.messages).help)) : undefined
        }), [
        onInsertItem,
        selectedItem,
        helpUrl,
        intl
    ]);
    const RenderBody = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $ff4d7472b93555bf$var$wrapperStyles
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $7vo9Y.default), {
            categories: (0, $fbV60.getCategories)(props.intl),
            getItems: props.getItems,
            showSearch: true,
            showCategories: true,
            mode: "full",
            onSelectItem: onSelectItem,
            onInsertItem: onInsertItem,
            emptyStateHandler: props.emptyStateHandler,
            autoFocusSearch: !isUpdateModalCloseButtonEnabled
        })), [
        props.intl,
        props.getItems,
        onSelectItem,
        onInsertItem,
        props.emptyStateHandler,
        isUpdateModalCloseButtonEnabled
    ]);
    const label = (0, $eGOwo.fg)('platform_editor_fix_browse_modal_header') ? intl.formatMessage((0, $kpo54.messages).browse) : undefined;
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        "data-editor-popup": true
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $956it.default), null, props.isOpen && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $gHHv2.default), {
        label: label,
        testId: "element-browser-modal-dialog",
        stackIndex: 0,
        key: "element-browser-modal",
        onClose: props.onClose,
        onCloseComplete: props.onCloseComplete,
        height: "664px",
        width: "x-large",
        shouldReturnFocus: props.shouldReturnFocus
    }, isUpdateModalCloseButtonEnabled && /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $ff4d7472b93555bf$var$modalCloseButtonStyles
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $gxxFp.CloseButton), {
        onClick: props.onClose
    })), /*#__PURE__*/ (0, $1NIU8.jsx)(RenderBody, null), /*#__PURE__*/ (0, $1NIU8.jsx)(RenderFooter, null))));
};
$ff4d7472b93555bf$var$ModalElementBrowser.displayName = 'ModalElementBrowser';
const $ff4d7472b93555bf$var$Footer = ({ onInsert: onInsert, beforeElement: beforeElement })=>{
    const { onClose: onClose } = (0, $ioK9M.useModal)();
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $ff4d7472b93555bf$var$modalFooterStyles
    }, beforeElement ? beforeElement : /*#__PURE__*/ (0, $1NIU8.jsx)("span", null), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $ff4d7472b93555bf$var$actionsStyles
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $ff4d7472b93555bf$var$actionItemStyles
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $goZPP.default), {
        appearance: "primary",
        onClick: onInsert,
        testId: "ModalElementBrowser__insert-button"
    }, "Insert")), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $ff4d7472b93555bf$var$actionItemStyles
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $goZPP.default), {
        appearance: "subtle",
        onClick: onClose,
        testId: "ModalElementBrowser__close-button"
    }, "Close"))));
};
const $ff4d7472b93555bf$var$HelpLink = (url, helpText)=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, $goZPP.default), {
        iconBefore: /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k9Gmz))), {
            label: ""
        }),
        appearance: "subtle-link",
        href: url,
        target: "_blank",
        testId: "ModalElementBrowser__help-button"
    }, helpText);
var $ff4d7472b93555bf$export$2e2bcd8739ae039 = (0, $6YFG2.default)($ff4d7472b93555bf$var$ModalElementBrowser);

});
parcelRegister("fbV60", function(module, exports) {
$parcel$export(module.exports, "getCategories", () => $b35315820ad6c732$export$7a0f33e8df10bd94);

var $kpo54 = parcelRequire("kpo54");
function $b35315820ad6c732$export$7a0f33e8df10bd94(intl) {
    return [
        {
            title: intl.formatMessage((0, $kpo54.messages).all),
            name: 'all'
        },
        {
            title: intl.formatMessage((0, $kpo54.messages).AI),
            name: 'AI'
        },
        {
            title: intl.formatMessage((0, $kpo54.messages).formatting),
            name: 'formatting'
        },
        {
            title: intl.formatMessage((0, $kpo54.messages)['confluence-content']),
            name: 'confluence-content'
        },
        {
            title: intl.formatMessage((0, $kpo54.messages).media),
            name: 'media'
        },
        {
            title: intl.formatMessage((0, $kpo54.messages).visuals),
            name: 'visuals'
        },
        {
            title: intl.formatMessage((0, $kpo54.messages).navigation),
            name: 'navigation'
        },
        {
            title: intl.formatMessage((0, $kpo54.messages)['external-content']),
            name: 'external-content'
        },
        {
            title: intl.formatMessage((0, $kpo54.messages).communication),
            name: 'communication'
        },
        {
            title: intl.formatMessage((0, $kpo54.messages).reporting),
            name: 'reporting'
        },
        {
            title: intl.formatMessage((0, $kpo54.messages).admin),
            name: 'admin'
        },
        {
            title: intl.formatMessage((0, $kpo54.messages).development),
            name: 'development'
        }
    ];
}

});



parcelRegister("j7avG", function(module, exports) {
$parcel$export(module.exports, "getQuickInsertSuggestions", () => $9c4f476e92f41df3$export$f7a129a7d10810d3);

var $38O6R = parcelRequire("38O6R");

var $3vP7W = parcelRequire("3vP7W");

var $eGOwo = parcelRequire("eGOwo");
const $9c4f476e92f41df3$export$f7a129a7d10810d3 = (searchOptions, lazyDefaultItems = ()=>[], providedItems)=>{
    // @ts-ignore
    const { query: query, category: category, disableDefaultItems: disableDefaultItems, featuredItems: featuredItems, prioritySortingFn: prioritySortingFn } = searchOptions;
    const defaultItems = disableDefaultItems ? [] : lazyDefaultItems();
    const dedupeFn = (0, $eGOwo.fg)('platform_editor_quick_insert_dedupe_title_desc') ? (item)=>`${item.title}-${item.description ?? ''}` : (item)=>item.title;
    const items = providedItems ? (0, $3vP7W.dedupe)([
        ...defaultItems,
        ...providedItems
    ], dedupeFn) : defaultItems;
    if (featuredItems) return items.filter((item)=>item.featured);
    return (0, $38O6R.find)(((0, $eGOwo.fg)('platform_editor_fix_space_triggering_ai') ? query?.trimEnd() : query) || '', category === 'all' || !category ? items : items.filter((item)=>item.categories && item.categories.includes(category)), prioritySortingFn);
};

});



parcelRegister("3IrrG", function(module, exports) {
$parcel$export(module.exports, "textColorPlugin", () => (parcelRequire("hCscm")).textColorPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $hCscm = parcelRequire("hCscm");

});
parcelRegister("hCscm", function(module, exports) {
$parcel$export(module.exports, "textColorPlugin", () => $9eddb986ddb686e3$export$7658bf1f1b6f477d);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $abZsg = parcelRequire("abZsg");

var $eGOwo = parcelRequire("eGOwo");

var $cbSL1 = parcelRequire("cbSL1");

var $92xoS = parcelRequire("92xoS");

var $8iPZf = parcelRequire("8iPZf");

var $c1YQE = parcelRequire("c1YQE");

var $2N9hk = parcelRequire("2N9hk");

var $5xD8f = parcelRequire("5xD8f");

var $5EiTG = parcelRequire("5EiTG");

var $9QMXz = parcelRequire("9QMXz");

var $kDLuw = parcelRequire("kDLuw");

var $6iB6A = parcelRequire("6iB6A");
const $9eddb986ddb686e3$var$pluginConfig = (textColorConfig)=>{
    if (!textColorConfig || typeof textColorConfig === 'boolean') return undefined;
    return textColorConfig;
};
const $9eddb986ddb686e3$export$7658bf1f1b6f477d = ({ config: textColorConfig, api: api })=>{
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const primaryToolbarComponent = ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing, dispatchAnalyticsEvent: dispatchAnalyticsEvent, disabled: disabled })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDLuw.PrimaryToolbarComponent), {
            isReducedSpacing: isToolbarReducedSpacing,
            editorView: editorView,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            disabled: disabled,
            api: api
        });
    };
    if (isToolbarAIFCEnabled) {
        if (api?.toolbar?.actions.registerComponents) api.toolbar.actions.registerComponents((0, $6iB6A.getToolbarComponents)(api));
    } else api?.primaryToolbar?.actions.registerComponent({
        name: 'textColor',
        component: primaryToolbarComponent
    });
    return {
        name: 'textColor',
        marks () {
            return [
                {
                    name: 'textColor',
                    mark: (0, $abZsg.textColor)
                }
            ];
        },
        pmPlugins () {
            return isToolbarAIFCEnabled && (0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) ? [
                {
                    name: 'textColor',
                    plugin: ({ dispatch: dispatch })=>(0, $5EiTG.createPlugin)(dispatch, $9eddb986ddb686e3$var$pluginConfig(textColorConfig))
                },
                {
                    name: 'textColorKeymap',
                    plugin: ()=>(0, $5xD8f.keymapPlugin)({
                            api: api
                        })
                }
            ] : [
                {
                    name: 'textColor',
                    plugin: ({ dispatch: dispatch })=>(0, $5EiTG.createPlugin)(dispatch, $9eddb986ddb686e3$var$pluginConfig(textColorConfig))
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $5EiTG.pluginKey).getState(editorState);
        },
        actions: {
            changeColor: (color, inputMethod)=>{
                return (0, $2N9hk.changeColor)(color, api?.analytics?.actions, inputMethod);
            }
        },
        commands: {
            changeColor: (color, inputMethod)=>{
                return (0, $8iPZf.changeColor)(color, api, inputMethod);
            },
            setPalette: (isPaletteOpen)=>{
                return (0, $c1YQE.setPalette)(isPaletteOpen);
            }
        },
        pluginsOptions: !isToolbarAIFCEnabled ? {
            selectionToolbar: ()=>{
                const toolbarDocking = (0, $eGOwo.fg)('platform_editor_use_preferences_plugin') ? api?.userPreferences?.sharedState?.currentState()?.preferences.toolbarDockingPosition : api?.selectionToolbar?.sharedState?.currentState()?.toolbarDocking;
                if (toolbarDocking === 'none' && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1', {
                    exposure: true
                })) {
                    const toolbarCustom = {
                        type: 'custom',
                        render: (view, _idx, dispatchAnalyticsEvent)=>{
                            if (!view) return;
                            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9QMXz.FloatingToolbarComponent), {
                                editorView: view,
                                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                                api: api
                            });
                        },
                        fallback: []
                    };
                    return {
                        isToolbarAbove: true,
                        items: [
                            toolbarCustom
                        ],
                        rank: 6,
                        pluginName: 'textColor'
                    };
                } else return undefined;
            }
        } : {},
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined
    };
};

});
parcelRegister("8iPZf", function(module, exports) {
$parcel$export(module.exports, "changeColor", () => $4971ef4896226a9d$export$917538e4f4eb20f9);

var $bMFKb = parcelRequire("bMFKb");

var $4XANP = parcelRequire("4XANP");

var $2cjj2 = parcelRequire("2cjj2");

var $48FYw = parcelRequire("48FYw");
/**
 * Helper to create an analytics payload
 * @param newColor  - Color to be change in hex code
 * @param previousColor - Active color in hex code
 * @param palette - Current palette of colors
 * @returns Higher order command with analytics logic inside.
 */ function $4971ef4896226a9d$var$createColorAnalyticsPayload(newColor, previousColor, palette, inputMethod) {
    const newColorFromPalette = palette.find(({ value: value })=>value === newColor);
    const previousColorFromPalette = palette.find(({ value: value })=>value === previousColor);
    const newColorLabel = newColorFromPalette ? newColorFromPalette.label : newColor;
    const previousColorLabel = previousColorFromPalette ? previousColorFromPalette.label : previousColor || '';
    return {
        action: (0, $bMFKb.ACTION).FORMATTED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_COLOR,
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
        attributes: {
            newColor: newColorLabel.toLowerCase(),
            previousColor: previousColorLabel.toLowerCase(),
            inputMethod: inputMethod
        }
    };
}
const $4971ef4896226a9d$export$917538e4f4eb20f9 = (color, api, inputMethod)=>({ tr: tr })=>{
        const { textColor: textColor } = tr.doc.type.schema.marks;
        const pluginState = api?.textColor.sharedState.currentState();
        if (!textColor || !pluginState) return tr;
        const activeColor = (0, $4XANP.getActiveColorNew)(tr);
        const colorAnalyticsPayload = $4971ef4896226a9d$var$createColorAnalyticsPayload(color, activeColor, pluginState.palette, inputMethod);
        if (pluginState.disabled) return tr;
        if (color === pluginState.defaultColor) {
            api?.analytics?.actions.attachAnalyticsEvent(colorAnalyticsPayload)(tr);
            (0, $2cjj2.removeColor)({
                tr: tr
            });
            return tr;
        }
        api?.analytics?.actions.attachAnalyticsEvent(colorAnalyticsPayload)(tr);
        (0, $48FYw.toggleColor)(color)({
            tr: tr
        });
        return tr;
    };

});
parcelRegister("4XANP", function(module, exports) {
$parcel$export(module.exports, "getActiveColor", () => $511add3678fc9c7d$export$1c6fa8f53a5fb47f);
$parcel$export(module.exports, "getActiveColorNew", () => $511add3678fc9c7d$export$9ed72cbbcfbf2a15);

var $8F29Y = parcelRequire("8F29Y");
const $511add3678fc9c7d$export$1c6fa8f53a5fb47f = (state)=>{
    const { $from: $from, $to: $to, $cursor: $cursor } = state.selection;
    const { textColor: textColor } = state.schema.marks;
    // Filter out other marks
    let marks = [];
    if ($cursor) marks.push(textColor.isInSet(state.storedMarks || $cursor.marks()) || undefined);
    else state.doc.nodesBetween($from.pos, $to.pos, (currentNode)=>{
        if (currentNode.isLeaf) {
            const mark = textColor.isInSet(currentNode.marks) || undefined;
            marks.push(mark);
            return !mark;
        }
        return true;
    });
    // Merge consecutive same color marks
    let prevMark;
    marks = marks.filter((mark)=>{
        if (mark && prevMark && mark.attrs.color === prevMark.attrs.color) return false;
        prevMark = mark;
        return true;
    });
    const marksWithColor = marks.filter((mark)=>!!mark);
    // When multiple colors are selected revert back to default color
    if (marksWithColor.length > 1 || marksWithColor.length === 1 && marks.length > 1) return null;
    return marksWithColor.length ? marksWithColor[0].attrs.color : (0, $8F29Y.DEFAULT_COLOR).color;
};
const $511add3678fc9c7d$export$9ed72cbbcfbf2a15 = (tr)=>{
    const { $from: $from, $to: $to, $cursor: $cursor } = tr.selection;
    const { textColor: textColor } = tr.doc.type.schema.marks;
    // Filter out other marks
    let marks = [];
    if ($cursor) marks.push(textColor.isInSet(tr.storedMarks || $cursor.marks()) || undefined);
    else tr.doc.nodesBetween($from.pos, $to.pos, (currentNode)=>{
        if (currentNode.isLeaf) {
            const mark = textColor.isInSet(currentNode.marks) || undefined;
            marks.push(mark);
            return !mark;
        }
        return true;
    });
    // Merge consecutive same color marks
    let prevMark;
    marks = marks.filter((mark)=>{
        if (mark && prevMark && mark.attrs.color === prevMark.attrs.color) return false;
        prevMark = mark;
        return true;
    });
    const marksWithColor = marks.filter((mark)=>!!mark);
    // When multiple colors are selected revert back to default color
    if (marksWithColor.length > 1 || marksWithColor.length === 1 && marks.length > 1) return null;
    return marksWithColor.length ? marksWithColor[0].attrs.color : (0, $8F29Y.DEFAULT_COLOR).color;
};

});
parcelRegister("8F29Y", function(module, exports) {
$parcel$export(module.exports, "overrideMarks", () => $7b57574e38c95b4d$export$ccbc17c7832f26ef);
$parcel$export(module.exports, "DEFAULT_COLOR", () => $7b57574e38c95b4d$export$37394b0fa44b998c);

const $7b57574e38c95b4d$export$ccbc17c7832f26ef = [
    'backgroundColor'
];
const $7b57574e38c95b4d$export$37394b0fa44b998c = {
    // TODO: DSP-4137 - Remove usage of N800
    /* eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage */ color: (0, $7bb4c1736002a04a$export$7d61b15e0da132af).toLowerCase(),
    label: 'Dark gray'
};

});


parcelRegister("2cjj2", function(module, exports) {
$parcel$export(module.exports, "removeColor", () => $8dcd6a25e6ddc7d8$export$4a26621adcb675d6);

var $66R0y = parcelRequire("66R0y");

var $5EiTG = parcelRequire("5EiTG");
const $8dcd6a25e6ddc7d8$export$4a26621adcb675d6 = ({ tr: tr })=>{
    const { textColor: textColor } = tr.doc.type.schema.marks;
    (0, $66R0y.removeMark)(textColor)({
        tr: tr
    });
    tr.setMeta((0, $5EiTG.pluginKey), {
        action: (0, $5EiTG.ACTIONS).RESET_COLOR
    });
    return tr;
};

});
parcelRegister("66R0y", function(module, exports) {
$parcel$export(module.exports, "transformNonTextNodesToText", () => $095d5fad2658d90e$export$abc5e6e01568db39);
$parcel$export(module.exports, "applyMarkOnRange", () => $095d5fad2658d90e$export$94a1aa532f5398df);
$parcel$export(module.exports, "entireSelectionContainsMark", () => $095d5fad2658d90e$export$cc5a5f0a00f537f5);
$parcel$export(module.exports, "toggleMark", () => $095d5fad2658d90e$export$797ad2667b8015a8);
$parcel$export(module.exports, "removeMark", () => $095d5fad2658d90e$export$5c9d031211c1b7c9);

var $3lIcL = parcelRequire("3lIcL");

var $cwzAY = parcelRequire("cwzAY");

var $eGOwo = parcelRequire("eGOwo");
const $095d5fad2658d90e$var$SMART_TO_ASCII = {
    "\u2026": '...',
    "\u2192": '->',
    "\u2190": '<-',
    "\u2013": '--',
    "\u201C": '"',
    "\u201D": '"',
    "\u2018": "'",
    "\u2019": "'"
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $095d5fad2658d90e$var$FIND_SMART_CHAR = new RegExp(`[${Object.keys($095d5fad2658d90e$var$SMART_TO_ASCII).join('')}]`, 'g');
function $095d5fad2658d90e$export$e46323d96cf32194(doc, from, to, predicate) {
    const results = [];
    doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (predicate(node, pos, parent)) results.push({
            node: node,
            pos: pos
        });
    });
    return results;
}
function $095d5fad2658d90e$export$abc5e6e01568db39(from, to, tr) {
    const { doc: doc } = tr;
    const { schema: schema } = doc.type;
    const { mention: mentionNodeType, text: textNodeType, emoji: emojiNodeType, inlineCard: inlineCardNodeType } = schema.nodes;
    const nodesToChange = [];
    doc.nodesBetween(from, to, (node, pos, parent)=>{
        if ([
            mentionNodeType,
            textNodeType,
            emojiNodeType,
            inlineCardNodeType
        ].includes(node.type)) nodesToChange.push({
            node: node,
            pos: pos
        });
    });
    nodesToChange.forEach(({ node: node, pos: pos })=>{
        if (node.type !== textNodeType) {
            const newText = node.attrs.url || // url for inlineCard
            node.attrs.text || `${node.type.name} text missing`; // fallback for missing text
            const currentPos = tr.mapping.map(pos);
            tr.replaceWith(currentPos, currentPos + node.nodeSize, schema.text(newText, node.marks));
        } else if (node.text) {
            // Find a valid start and end position because the text may be partially selected.
            const startPositionInSelection = Math.max(pos, from);
            const endPositionInSelection = Math.min(pos + node.nodeSize, to);
            const textForReplacing = doc.textBetween(startPositionInSelection, endPositionInSelection);
            const newText = textForReplacing.replace($095d5fad2658d90e$var$FIND_SMART_CHAR, (match)=>$095d5fad2658d90e$var$SMART_TO_ASCII[match] ?? match);
            const currentStartPos = tr.mapping.map(startPositionInSelection);
            const currentEndPos = tr.mapping.map(endPositionInSelection);
            tr.replaceWith(currentStartPos, currentEndPos, schema.text(newText, node.marks));
        }
    });
}
const $095d5fad2658d90e$export$94a1aa532f5398df = (from, to, removeMark, mark, tr)=>{
    const { schema: schema } = tr.doc.type;
    const { code: code } = schema.marks;
    if (mark.type === code) $095d5fad2658d90e$export$abc5e6e01568db39(from, to, tr);
    tr.doc.nodesBetween(tr.mapping.map(from), tr.mapping.map(to), (node, pos)=>{
        if ((0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes')) {
            if (!node.isText) {
                const isAllowedInlineNode = [
                    'emoji',
                    'status',
                    'date',
                    'mention',
                    'inlineCard'
                ].includes(node.type.name);
                if (!isAllowedInlineNode) return true;
            }
        } else {
            if (!node.isText) return true;
        }
        // This is an issue when the user selects some text.
        // We need to check if the current node position is less than the range selection from.
        // If it’s true, that means we should apply the mark using the range selection,
        // not the current node position.
        const nodeBetweenFrom = Math.max(pos, tr.mapping.map(from));
        const nodeBetweenTo = Math.min(pos + node.nodeSize, tr.mapping.map(to));
        if (removeMark) tr.removeMark(nodeBetweenFrom, nodeBetweenTo, mark);
        else tr.addMark(nodeBetweenFrom, nodeBetweenTo, mark);
        return true;
    });
    return tr;
};
const $095d5fad2658d90e$export$cc5a5f0a00f537f5 = (mark, doc, fromPos, toPos)=>{
    let onlyContainsMark = true;
    doc.nodesBetween(fromPos, toPos, (node)=>{
        // Skip recursion once we've found text which doesn't include the mark
        if (!onlyContainsMark) return false;
        if (node.isText) onlyContainsMark && (onlyContainsMark = !!mark?.isInSet(node.marks));
    });
    return onlyContainsMark;
};
const $095d5fad2658d90e$var$toggleMarkInRange = (mark)=>({ tr: tr })=>{
        if (tr.selection instanceof (0, $cwzAY.CellSelection)) {
            let removeMark = true;
            const cells = [];
            tr.selection.forEachCell((cell, cellPos)=>{
                cells.push({
                    node: cell,
                    pos: cellPos
                });
                const from = cellPos;
                const to = cellPos + cell.nodeSize;
                removeMark && (removeMark = $095d5fad2658d90e$export$cc5a5f0a00f537f5(mark, tr.doc, from, to));
            });
            for(let i = cells.length - 1; i >= 0; i--){
                const cell = cells[i];
                const from = cell.pos;
                const to = from + cell.node.nodeSize;
                $095d5fad2658d90e$export$94a1aa532f5398df(from, to, removeMark, mark, tr);
            }
        } else {
            const { $from: $from, $to: $to } = tr.selection;
            // We decide to remove the mark only if the entire selection contains the mark
            // Examples with *bold* text
            // Scenario 1: Selection contains both bold and non-bold text -> bold entire selection
            // Scenario 2: Selection contains only bold text -> un-bold entire selection
            // Scenario 3: Selection contains no bold text -> bold entire selection
            const removeMark = $095d5fad2658d90e$export$cc5a5f0a00f537f5(mark, tr.doc, $from.pos, $to.pos);
            $095d5fad2658d90e$export$94a1aa532f5398df($from.pos, $to.pos, removeMark, mark, tr);
        }
        if (tr.docChanged) return tr;
        return null;
    };
const $095d5fad2658d90e$export$797ad2667b8015a8 = (markType, attrs)=>({ tr: tr })=>{
        const mark = markType.create(attrs);
        // For cursor selections we can use the default behaviour.
        if (tr.selection instanceof (0, $3lIcL.TextSelection) && tr.selection.$cursor) {
            if (mark.isInSet(tr.storedMarks || tr.selection.$cursor.marks())) tr.removeStoredMark(mark);
            else tr.addStoredMark(mark);
            return tr;
        }
        return $095d5fad2658d90e$var$toggleMarkInRange(mark)({
            tr: tr
        });
    };
const $095d5fad2658d90e$export$5c9d031211c1b7c9 = (mark)=>({ tr: tr })=>{
        const { selection: selection } = tr;
        if (selection instanceof (0, $cwzAY.CellSelection)) selection.forEachCell((cell, cellPos)=>{
            const from = cellPos;
            const to = cellPos + cell.nodeSize;
            tr.removeMark(from, to, mark);
        });
        else if (selection instanceof (0, $3lIcL.TextSelection) && selection.$cursor) tr.removeStoredMark(mark);
        else {
            const { from: from, to: to } = selection;
            tr.removeMark(from, to, mark);
        }
        return tr;
    };

});

parcelRegister("5EiTG", function(module, exports) {
$parcel$export(module.exports, "ACTIONS", () => $71fc43bc5352b755$export$92a1a3b7554e9387);
$parcel$export(module.exports, "pluginKey", () => $71fc43bc5352b755$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "createPlugin", () => $71fc43bc5352b755$export$ae829ec7b2625219);

var $i8KtF = parcelRequire("i8KtF");

var $9WC9O = parcelRequire("9WC9O");

var $3lIcL = parcelRequire("3lIcL");

var $4XANP = parcelRequire("4XANP");

var $8F29Y = parcelRequire("8F29Y");

var $3zADK = parcelRequire("3zADK");
function $71fc43bc5352b755$var$createInitialPluginState(editorState, pluginConfig) {
    const defaultColor = pluginConfig?.defaultColor || (0, $8F29Y.DEFAULT_COLOR);
    const palette = [
        {
            value: defaultColor.color,
            label: defaultColor.label,
            border: "var(--ds-border, #091E4224)"
        },
        ...(0, $9WC9O.textColorPalette)
    ];
    const state = {
        color: (0, $4XANP.getActiveColor)(editorState),
        disabled: (0, $3zADK.getDisabledState)(editorState),
        palette: palette,
        defaultColor: defaultColor.color,
        isPaletteOpen: false
    };
    return state;
}
var $71fc43bc5352b755$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS[ACTIONS["RESET_COLOR"] = 0] = "RESET_COLOR";
    ACTIONS[ACTIONS["SET_COLOR"] = 1] = "SET_COLOR";
    ACTIONS[ACTIONS["DISABLE"] = 2] = "DISABLE";
    ACTIONS[ACTIONS["SET_PALETTE"] = 3] = "SET_PALETTE";
    return ACTIONS;
}({});
const $71fc43bc5352b755$export$18d4026d1ea86bb1 = new (0, $3lIcL.PluginKey)('textColorPlugin');
function $71fc43bc5352b755$export$ae829ec7b2625219(dispatch, pluginConfig) {
    return new (0, $i8KtF.SafePlugin)({
        key: $71fc43bc5352b755$export$18d4026d1ea86bb1,
        state: {
            init (_config, editorState) {
                return $71fc43bc5352b755$var$createInitialPluginState(editorState, pluginConfig);
            },
            apply (tr, pluginState, _, newState) {
                const meta = tr.getMeta($71fc43bc5352b755$export$18d4026d1ea86bb1) || {};
                let nextState;
                switch(meta.action){
                    case 0:
                        nextState = {
                            ...pluginState,
                            color: pluginState.defaultColor
                        };
                        break;
                    case 1:
                        nextState = {
                            ...pluginState,
                            color: meta.color,
                            disabled: false,
                            isPaletteOpen: false
                        };
                        break;
                    case 2:
                        nextState = {
                            ...pluginState,
                            disabled: true
                        };
                        break;
                    case 3:
                        nextState = {
                            ...pluginState,
                            isPaletteOpen: meta.isPaletteOpen
                        };
                        break;
                    default:
                        nextState = {
                            ...pluginState,
                            color: (0, $4XANP.getActiveColor)(newState),
                            disabled: (0, $3zADK.getDisabledState)(newState)
                        };
                }
                if (pluginState && pluginState.color !== nextState.color || pluginState && pluginState.disabled !== nextState.disabled || pluginState && pluginState.isPaletteOpen !== nextState.isPaletteOpen) {
                    dispatch($71fc43bc5352b755$export$18d4026d1ea86bb1, nextState);
                    return nextState;
                }
                return pluginState;
            }
        }
    });
}

});
parcelRegister("9WC9O", function(module, exports) {
$parcel$export(module.exports, "mapPaletteColor", () => $0b7466ad7887b6de$export$cf81161afbd9f18c);
$parcel$export(module.exports, "textColorPalette", () => $0b7466ad7887b6de$export$25c6a5f643998d29);

var $abZsg = parcelRequire("abZsg");

var $ebo8n = parcelRequire("ebo8n");

var $fHZGh = parcelRequire("fHZGh");
const $0b7466ad7887b6de$export$cf81161afbd9f18c = (label, color)=>{
    const key = label.toLowerCase().replace(' ', '-');
    const message = (0, $ebo8n.default)((0, $fHZGh.default), key);
    return {
        value: color,
        label: label,
        border: "var(--ds-border, #091E4224)",
        message: message
    };
};
const $0b7466ad7887b6de$export$25c6a5f643998d29 = [];
const $0b7466ad7887b6de$export$e8867f5d7b608416 = [];
(0, $abZsg.colorPalette).forEach((label, color)=>{
    $0b7466ad7887b6de$export$25c6a5f643998d29.push($0b7466ad7887b6de$export$cf81161afbd9f18c(label, color));
});

});
parcelRegister("fHZGh", function(module, exports) {
$parcel$export(module.exports, "default", () => $22c8b397025d29ea$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $22c8b397025d29ea$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    white: {
        id: 'fabric.theme.white',
        defaultMessage: 'White',
        description: 'Name of a color'
    },
    'light-blue': {
        id: 'fabric.theme.light-blue',
        defaultMessage: 'Light blue',
        description: 'Name of a color'
    },
    'light-teal': {
        id: 'fabric.theme.light-teal',
        defaultMessage: 'Light teal',
        description: 'Name of a color'
    },
    'light-green': {
        id: 'fabric.theme.light-green',
        defaultMessage: 'Light green',
        description: 'Name of a color'
    },
    'light-yellow': {
        id: 'fabric.theme.light-yellow',
        defaultMessage: 'Light yellow',
        description: 'Name of a color'
    },
    'light-red': {
        id: 'fabric.theme.light-red',
        defaultMessage: 'Light red',
        description: 'Name of a color'
    },
    'light-purple': {
        id: 'fabric.theme.light-purple',
        defaultMessage: 'Light purple',
        description: 'Name of a color'
    },
    'light-gray': {
        id: 'fabric.theme.light-gray',
        defaultMessage: 'Light gray',
        description: 'Name of a color'
    },
    blue: {
        id: 'fabric.theme.blue',
        defaultMessage: 'Blue',
        description: 'Name of a color'
    },
    teal: {
        id: 'fabric.theme.teal',
        defaultMessage: 'Teal',
        description: 'Name of a color'
    },
    green: {
        id: 'fabric.theme.green',
        defaultMessage: 'Green',
        description: 'Name of a color'
    },
    yellow: {
        id: 'fabric.theme.yellow',
        defaultMessage: 'Yellow',
        description: 'Name of a color'
    },
    red: {
        id: 'fabric.theme.red',
        defaultMessage: 'Red',
        description: 'Name of a color.'
    },
    orange: {
        id: 'fabric.theme.orange',
        defaultMessage: 'Orange',
        description: 'Name of a color.'
    },
    purple: {
        id: 'fabric.theme.purple',
        defaultMessage: 'Purple',
        description: 'Name of a color'
    },
    gray: {
        id: 'fabric.theme.gray',
        defaultMessage: 'Gray',
        description: 'Name of a color'
    },
    'dark-blue': {
        id: 'fabric.theme.dark-blue',
        defaultMessage: 'Dark blue',
        description: 'Name of a color'
    },
    'dark-teal': {
        id: 'fabric.theme.dark-teal',
        defaultMessage: 'Dark teal',
        description: 'Name of a color'
    },
    'dark-green': {
        id: 'fabric.theme.dark-green',
        defaultMessage: 'Dark green',
        description: 'Name of a color'
    },
    'dark-yellow': {
        id: 'fabric.theme.dark-yellow',
        defaultMessage: 'Dark yellow',
        description: 'Name of a color'
    },
    'dark-red': {
        id: 'fabric.theme.dark-red',
        defaultMessage: 'Dark red',
        description: 'Name of a color'
    },
    'dark-purple': {
        id: 'fabric.theme.dark-purple',
        defaultMessage: 'Dark purple',
        description: 'Name of a color'
    },
    'subtle-gray': {
        id: 'fabric.theme.subtle-gray',
        defaultMessage: 'Subtle gray',
        description: 'Name of a color'
    },
    'bold-gray': {
        id: 'fabric.theme.bold-gray',
        defaultMessage: 'Bold gray',
        description: 'Name of a color'
    },
    // Colors only used in highlight palette
    'no-color': {
        id: 'fabric.theme.no-color',
        defaultMessage: 'No highlight',
        description: 'Tooltip for the no color option in the highlight color palette in the main editor toolbar'
    },
    lime: {
        id: 'fabric.theme.lime',
        defaultMessage: 'Lime',
        description: "Tooltip for the lime color used in the main toolbar's highlight color palette"
    },
    magenta: {
        id: 'fabric.theme.magenta',
        defaultMessage: 'Magenta',
        description: "Tooltip for the magenta color used in the main toolbar's highlight color palette"
    }
});

});


parcelRegister("3zADK", function(module, exports) {
$parcel$export(module.exports, "getDisabledState", () => $000b3bd194704d33$export$4af1020a67b5ec91);
$parcel$export(module.exports, "getDisabledStateNew", () => $000b3bd194704d33$export$bc7d0019d5b59541);

var $02q9c = parcelRequire("02q9c");

var $8F29Y = parcelRequire("8F29Y");
const $000b3bd194704d33$var$hasLinkMark = ($pos)=>{
    const { doc: { type: { schema: { marks: { link: linkMarkType } } } }, pos: pos } = $pos;
    if (!linkMarkType) return false;
    return $pos.doc.rangeHasMark(pos, Math.min(pos + 1, $pos.doc.content.size), linkMarkType);
};
const $000b3bd194704d33$export$4af1020a67b5ec91 = (state)=>{
    const { textColor: textColor } = state.schema.marks;
    if (textColor) {
        const { empty: empty, ranges: ranges, $cursor: $cursor } = state.selection;
        if (empty && !$cursor || $cursor && $000b3bd194704d33$var$hasLinkMark($cursor) || (0, $02q9c.isMarkAllowedInRange)(state.doc, ranges, textColor) === false) return true;
        // Allow "excluded" marks that can be overridden
        // These marks are explicitly removed before applying the new mark (see toggleColor command)
        const omitOverrides = (mark)=>{
            return !(0, $8F29Y.overrideMarks).includes(mark.type.name);
        };
        if ((0, $02q9c.isMarkExcluded)(textColor, state.storedMarks?.filter(omitOverrides) || $cursor && $cursor.marks().filter(omitOverrides))) return true;
        return false;
    }
    return true;
};
const $000b3bd194704d33$export$bc7d0019d5b59541 = (tr)=>{
    const { textColor: textColor } = tr.doc.type.schema.marks;
    if (textColor) {
        const { empty: empty, ranges: ranges, $cursor: $cursor } = tr.selection;
        if (empty && !$cursor || $cursor && $000b3bd194704d33$var$hasLinkMark($cursor) || (0, $02q9c.isMarkAllowedInRange)(tr.doc, ranges, textColor) === false) return true;
        // Allow "excluded" marks that can be overridden
        // These marks are explicitly removed before applying the new mark (see toggleColor command)
        const omitOverrides = (mark)=>{
            return !(0, $8F29Y.overrideMarks).includes(mark.type.name);
        };
        if ((0, $02q9c.isMarkExcluded)(textColor, tr.storedMarks?.filter(omitOverrides) || $cursor && $cursor.marks().filter(omitOverrides))) return true;
        return false;
    }
    return true;
};

});



parcelRegister("48FYw", function(module, exports) {
$parcel$export(module.exports, "toggleColor", () => $9f9092123d886372$export$afb561a73dff6672);

var $66R0y = parcelRequire("66R0y");

var $5EiTG = parcelRequire("5EiTG");

var $8F29Y = parcelRequire("8F29Y");

var $3zADK = parcelRequire("3zADK");
const $9f9092123d886372$export$afb561a73dff6672 = (color)=>({ tr: tr })=>{
        const { textColor: textColor } = tr.doc.type.schema.marks;
        const disabledState = (0, $3zADK.getDisabledStateNew)(tr);
        if (disabledState) {
            tr.setMeta((0, $5EiTG.pluginKey), {
                action: (0, $5EiTG.ACTIONS).DISABLE
            });
            return tr;
        }
        (0, $8F29Y.overrideMarks).forEach((mark)=>{
            const { marks: marks } = tr.doc.type.schema;
            if (marks[mark]) (0, $66R0y.removeMark)(marks[mark])({
                tr: tr
            });
        });
        (0, $66R0y.toggleMark)(textColor, {
            color: color
        })({
            tr: tr
        });
        return tr;
    };

});


parcelRegister("c1YQE", function(module, exports) {
$parcel$export(module.exports, "togglePalette", () => $7f0ed8d81425f81b$export$7c9cf3bdfeac3246);
$parcel$export(module.exports, "setPalette", () => $7f0ed8d81425f81b$export$9567774ece486a9);

var $5EiTG = parcelRequire("5EiTG");
const $7f0ed8d81425f81b$export$7c9cf3bdfeac3246 = (api)=>({ tr: tr })=>{
        const pluginState = api?.textColor.sharedState.currentState();
        const isPaletteOpen = pluginState?.isPaletteOpen;
        tr.setMeta((0, $5EiTG.pluginKey), {
            action: (0, $5EiTG.ACTIONS).SET_PALETTE,
            isPaletteOpen: !isPaletteOpen
        });
        return tr;
    };
const $7f0ed8d81425f81b$export$9567774ece486a9 = (isPaletteOpen)=>({ tr: tr })=>{
        tr.setMeta((0, $5EiTG.pluginKey), {
            action: (0, $5EiTG.ACTIONS).SET_PALETTE,
            isPaletteOpen: isPaletteOpen
        });
        return tr;
    };

});

parcelRegister("2N9hk", function(module, exports) {
$parcel$export(module.exports, "changeColor", () => $625e5c3b4a75ebe0$export$917538e4f4eb20f9);

var $bMFKb = parcelRequire("bMFKb");

var $asjM0 = parcelRequire("asjM0");

var $5EiTG = parcelRequire("5EiTG");

var $4XANP = parcelRequire("4XANP");

var $1VJyq = parcelRequire("1VJyq");

var $2Eqxd = parcelRequire("2Eqxd");
/**
 * Helper to create a higher order analytics command
 * @param newColor  - Color to be change in hex code
 * @param previousColor - Active color in hex code
 * @param palette - Current palette of colors
 * @return Higher order command with analytics logic inside.
 */ function $625e5c3b4a75ebe0$var$createWithColorAnalytics(newColor, previousColor, palette, editorAnalyticsApi, inputMethod) {
    const newColorFromPalette = palette.find(({ value: value })=>value === newColor);
    const previousColorFromPalette = palette.find(({ value: value })=>value === previousColor);
    const newColorLabel = newColorFromPalette ? newColorFromPalette.label : newColor;
    const previousColorLabel = previousColorFromPalette ? previousColorFromPalette.label : previousColor || '';
    return (0, $asjM0.withAnalytics)(editorAnalyticsApi, {
        action: (0, $bMFKb.ACTION).FORMATTED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_COLOR,
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
        attributes: {
            newColor: newColorLabel.toLowerCase(),
            previousColor: previousColorLabel.toLowerCase(),
            inputMethod: inputMethod
        }
    });
}
const $625e5c3b4a75ebe0$export$917538e4f4eb20f9 = (color, editorAnalyticsApi, inputMethod)=>(state, dispatch)=>{
        const { textColor: textColor } = state.schema.marks;
        if (textColor) {
            const pluginState = (0, $5EiTG.pluginKey).getState(state);
            const activeColor = (0, $4XANP.getActiveColor)(state);
            const withColorAnalytics = $625e5c3b4a75ebe0$var$createWithColorAnalytics(color, activeColor, pluginState?.palette || [], editorAnalyticsApi, inputMethod);
            if (pluginState?.disabled) return false;
            if (color === pluginState?.defaultColor) {
                withColorAnalytics((0, $1VJyq.removeColor)())(state, dispatch);
                return true;
            }
            withColorAnalytics((0, $2Eqxd.toggleColor)(color))(state, dispatch);
            return true;
        }
        return false;
    };

});
parcelRegister("1VJyq", function(module, exports) {
$parcel$export(module.exports, "removeColor", () => $c9e50a3eba889c66$export$4a26621adcb675d6);

var $66R0y = parcelRequire("66R0y");

var $5EiTG = parcelRequire("5EiTG");
const $c9e50a3eba889c66$export$4a26621adcb675d6 = ()=>(state, dispatch)=>{
        const { schema: schema } = state;
        const { textColor: textColor } = schema.marks;
        const tr = state.tr;
        (0, $66R0y.removeMark)(textColor)({
            tr: tr
        });
        if (dispatch) dispatch(tr.setMeta((0, $5EiTG.pluginKey), {
            action: (0, $5EiTG.ACTIONS).RESET_COLOR
        }));
        return true;
    };

});

parcelRegister("2Eqxd", function(module, exports) {
$parcel$export(module.exports, "toggleColor", () => $afcee5c28ec38a50$export$afb561a73dff6672);

var $66R0y = parcelRequire("66R0y");

var $5EiTG = parcelRequire("5EiTG");

var $8F29Y = parcelRequire("8F29Y");

var $3zADK = parcelRequire("3zADK");
const $afcee5c28ec38a50$export$afb561a73dff6672 = (color)=>(state, dispatch)=>{
        const { textColor: textColor } = state.schema.marks;
        const tr = state.tr;
        const disabledState = (0, $3zADK.getDisabledState)(state);
        if (disabledState) {
            if (dispatch) dispatch(tr.setMeta((0, $5EiTG.pluginKey), {
                action: (0, $5EiTG.ACTIONS).DISABLE
            }));
            return false;
        }
        if (dispatch) {
            (0, $8F29Y.overrideMarks).forEach((mark)=>{
                const { marks: marks } = tr.doc.type.schema;
                if (marks[mark]) (0, $66R0y.removeMark)(marks[mark])({
                    tr: tr
                });
            });
            (0, $66R0y.toggleMark)(textColor, {
                color: color
            })({
                tr: tr
            });
            dispatch(tr);
        }
        return true;
    };

});


parcelRegister("5xD8f", function(module, exports) {
$parcel$export(module.exports, "keymapPlugin", () => $a482b2e04aeb9abe$export$e832373cff8dec22);

var $6Exgk = parcelRequire("6Exgk");
var $c9NXO = parcelRequire("c9NXO");

var $c1YQE = parcelRequire("c1YQE");
function $a482b2e04aeb9abe$export$e832373cff8dec22({ api: api }) {
    const list = {};
    if ((0, $6Exgk.toggleHighlightPalette).common) (0, $6Exgk.bindKeymapWithEditorCommand)((0, $6Exgk.toggleHighlightPalette).common, (0, $c1YQE.togglePalette)(api), list);
    return (0, $c9NXO.keymap)(list);
}

});

parcelRegister("9QMXz", function(module, exports) {
$parcel$export(module.exports, "FloatingToolbarComponent", () => $a003bd84c5a29346$export$b15abb95157a91c7);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $cxXTK = parcelRequire("cxXTK");

var $2sDI4 = parcelRequire("2sDI4");

var $iyXAm = parcelRequire("iyXAm");
const $a003bd84c5a29346$var$FloatingToolbarSettings = {
    disabled: false,
    isReducedSpacing: true
};
const $a003bd84c5a29346$var$selector = (states)=>{
    return {
        color: states.textColorState?.color,
        defaultColor: states.textColorState?.defaultColor,
        palette: states.textColorState?.palette,
        disabled: states.textColorState?.disabled
    };
};
const $a003bd84c5a29346$export$b15abb95157a91c7 = ({ api: api, editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const { color: color, defaultColor: defaultColor, palette: palette, disabled: disabled } = (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'textColor'
    ], $a003bd84c5a29346$var$selector);
    if (color === undefined || defaultColor === undefined || palette === undefined) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iyXAm.default), {
        pluginState: {
            color: color,
            defaultColor: defaultColor,
            palette: palette,
            disabled: disabled
        },
        isReducedSpacing: $a003bd84c5a29346$var$FloatingToolbarSettings.isReducedSpacing,
        editorView: editorView,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        disabled: $a003bd84c5a29346$var$FloatingToolbarSettings.disabled,
        pluginInjectionApi: api,
        toolbarType: (0, $2sDI4.ToolbarType).FLOATING
    });
};

});
parcelRegister("2sDI4", function(module, exports) {
$parcel$export(module.exports, "ToolbarType", () => $fd71498f4e7b738b$export$a5d11b3163e4b1a5);
var $fd71498f4e7b738b$export$a5d11b3163e4b1a5 = /*#__PURE__*/ function(ToolbarType) {
    ToolbarType["PRIMARY"] = "primaryToolbar";
    ToolbarType["FLOATING"] = "floatingToolbar";
    return ToolbarType;
}({});

});

parcelRegister("iyXAm", function(module, exports) {
$parcel$export(module.exports, "default", () => $6b882051a00f24e3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");

var $bMFKb = parcelRequire("bMFKb");

var $fCT5K = parcelRequire("fCT5K");
var $32xIU = parcelRequire("32xIU");

var $DGjKK = parcelRequire("DGjKK");

var $is7NW = parcelRequire("is7NW");
var $fcJnk = parcelRequire("fcJnk");

var $9LhzF = parcelRequire("9LhzF");
var $4nqSo = parcelRequire("4nqSo");
var $a44PI = parcelRequire("a44PI");

var $UpZp1 = parcelRequire("UpZp1");
var $cigQc = parcelRequire("cigQc");
var $2pk5j = parcelRequire("2pk5j");
var $9Sic1 = parcelRequire("9Sic1");

var $9NsIT = parcelRequire("9NsIT");

var $7yBx7 = parcelRequire("7yBx7");

var $5lAAn = parcelRequire("5lAAn");

var $6WP1Q = parcelRequire("6WP1Q");

var $eGOwo = parcelRequire("eGOwo");

var $92xoS = parcelRequire("92xoS");

var $2N9hk = parcelRequire("2N9hk");

var $hadhW = parcelRequire("hadhW");

var $2sDI4 = parcelRequire("2sDI4");

var $7hKj8 = parcelRequire("7hKj8");
function $6b882051a00f24e3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6b882051a00f24e3$var$addMarginToWrapper = {
    name: "we4ryv",
    styles: "margin-right:var(--ds-space-050, 4px)"
};
class $6b882051a00f24e3$export$2985b35a9cfdee76 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { isOpen: isOpen, isOpenedByKeyboard: isOpenedByKeyboard } = this.state;
        const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isReducedSpacing: isReducedSpacing, pluginState: pluginState, intl: { formatMessage: formatMessage }, disabled: disabled, pluginInjectionApi: pluginInjectionApi } = this.props;
        const palette = pluginState.palette;
        let fitWidth;
        if (document.body.clientWidth <= 740) // This was originally hard-coded, but moved here to a const
        // My guess is it's based off (width of button * columns) + left/right padding
        // 240 = (32 * 7) + (8 + 8)
        // Not sure where the extra 2px comes from
        fitWidth = 242;
        const selectedColor = this.getSelectedColor(pluginState);
        // TODO: ED-26959 - This doesn't work, the label isn't translated
        const selectedColorPaletteItemLabel = palette.find((paletteItem)=>paletteItem.value === pluginState.color)?.label;
        const selectedColorPaletteItemLabelText = selectedColorPaletteItemLabel || '';
        const labelTextColor = formatMessage((0, $DGjKK.textColorMessages).textColor, {
            selectedColorName: selectedColorPaletteItemLabelText
        });
        const tooltipTextColor = formatMessage((0, $DGjKK.textColorMessages).textColorTooltip);
        const { selectedRowIndex: selectedRowIndex, selectedColumnIndex: selectedColumnIndex } = (0, $4nqSo.getSelectedRowAndColumnFromPalette)(palette, pluginState.color);
        const reducedSpacing = this.props.toolbarType === (0, $2sDI4.ToolbarType).FLOATING ? 'compact' : 'none';
        return /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $eGOwo.fg)('platform-visual-refresh-icons') ? [
                (0, $fcJnk.wrapperStyle),
                $6b882051a00f24e3$var$addMarginToWrapper
            ] : (0, $fcJnk.wrapperStyle)
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $cigQc.DropdownContainer), {
            mountTo: popupsMountPoint,
            boundariesElement: popupsBoundariesElement,
            scrollableElement: popupsScrollableElement,
            isOpen: isOpen && !pluginState.disabled,
            handleClickOutside: this.hide,
            handleEscapeKeydown: this.hideonEsc,
            zIndex: (0, $7yBx7.akEditorMenuZIndex),
            fitWidth: fitWidth,
            closeOnTab: true,
            arrowKeyNavigationProviderOptions: {
                type: (0, $UpZp1.ArrowKeyNavigationType).COLOR,
                selectedRowIndex: selectedRowIndex,
                selectedColumnIndex: selectedColumnIndex,
                isOpenedByKeyboard: isOpenedByKeyboard,
                isPopupPositioned: true
            },
            trigger: /*#__PURE__*/ (0, $1NIU8.jsx)((0, $9Sic1.default), {
                buttonId: (0, $2pk5j.TOOLBAR_ACTION_SUBJECT_ID).TEXT_COLOR,
                spacing: !isReducedSpacing || (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? 'default' : reducedSpacing,
                disabled: disabled || pluginState.disabled,
                selected: isOpen,
                "aria-label": labelTextColor,
                "aria-expanded": isOpen,
                "aria-haspopup": true,
                title: tooltipTextColor,
                onClick: this.toggleOpen,
                onKeyDown: this.onKeyDown,
                ref: this.toolbarItemRef,
                iconBefore: /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
                    css: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
                    (0, $eGOwo.fg)('platform-visual-refresh-icons') ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $fcJnk.triggerWrapperStylesWithPadding) : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $fcJnk.triggerWrapperStyles)
                }, (0, $eGOwo.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $fCT5K.DynamicStrokeIconDecoration), {
                    selectedColor: selectedColor,
                    disabled: pluginState.disabled,
                    icon: /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6WP1Q))), {
                        label: "",
                        color: "currentColor",
                        spacing: "spacious"
                    })
                }) : /*#__PURE__*/ (0, $1NIU8.jsx)((0, $32xIU.SteppedRainbowIconDecoration), {
                    selectedColor: selectedColor,
                    disabled: pluginState.disabled,
                    icon: /*#__PURE__*/ (0, $1NIU8.jsx)((0, $7hKj8.EditorTextColorIcon), null)
                }), //eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
                    css: (0, $is7NW.expandIconContainerStyle)
                }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_margin: "0 0 0 -8px",
                    size: "small"
                })))
            })
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            "data-testid": "text-color-palette"
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $9LhzF.default), {
            onClick: (color)=>this.changeTextColor(color, pluginInjectionApi?.analytics?.actions, pluginState.disabled),
            selectedColor: pluginState.color,
            paletteOptions: {
                palette: palette,
                hexToPaletteColor: (0, $9NsIT.hexToEditorTextPaletteColor),
                paletteColorTooltipMessages: (0, $a44PI.textPaletteTooltipMessages)
            }
        }))), !pluginInjectionApi?.primaryToolbar && /* eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            css: (0, $fcJnk.separatorStyles)
        }));
    }
    getSelectedColor(pluginState) {
        const selectedColor = pluginState.color !== pluginState.defaultColor ? pluginState.color ? // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $9NsIT.hexToEditorTextPaletteColor)(pluginState.color) : pluginState.color : null;
        return selectedColor;
    }
    buildAnalyticsPalette(action, data) {
        return {
            action: action,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).TOOLBAR,
            actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_COLOR,
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
            attributes: {
                ...data
            }
        };
    }
    dispatchAnalyticsEvent(payload) {
        const { dispatchAnalyticsEvent: dispatchAnalyticsEvent } = this.props;
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent(payload);
    }
    constructor(...args){
        super(...args), this.state = {
            isOpen: false,
            isOpenedByKeyboard: false
        }, this.toolbarItemRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.changeColor = (color, editorAnalyticsApi)=>(0, $2N9hk.changeColor)(color, editorAnalyticsApi, (0, $hadhW.getInputMethod)(this.props.toolbarType))(this.props.editorView.state, this.props.editorView.dispatch), this.changeTextColor = (color, editorAnalyticsApi, disabled)=>{
            if (!disabled) {
                this.handleOpenChange({
                    isOpen: false,
                    logCloseEvent: false
                });
                this.changeColor(color, editorAnalyticsApi);
                //To set the focus on the textcolor button when the menu is closed by 'Esc' only to meet aria guidelines
                this.props.editorView?.focus();
            }
            return false;
        }, this.toggleOpen = ()=>{
            this.handleOpenChange({
                isOpen: !this.state.isOpen,
                logCloseEvent: true
            });
        }, this.onKeyDown = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.setState({
                    isOpenedByKeyboard: true
                });
                this.toggleOpen();
            }
        }, this.handleOpenChange = ({ isOpen: isOpen, logCloseEvent: logCloseEvent })=>{
            this.setState({
                isOpen: isOpen
            });
            if (!isOpen) this.setState({
                isOpenedByKeyboard: false
            });
            if (logCloseEvent) this.dispatchAnalyticsEvent(this.buildAnalyticsPalette(isOpen ? (0, $bMFKb.ACTION).OPENED : (0, $bMFKb.ACTION).CLOSED, {
                noSelect: isOpen === false
            }));
        }, this.hide = (e)=>{
            const { isOpen: isOpen } = this.state;
            if (isOpen === true) {
                this.dispatchAnalyticsEvent(this.buildAnalyticsPalette((0, $bMFKb.ACTION).CLOSED, {
                    noSelect: true
                }));
                this.setState({
                    isOpen: false
                });
                if (e instanceof KeyboardEvent && e.key === 'Escape') this.toolbarItemRef?.current?.focus();
            }
        }, this.hideonEsc = (e)=>{
            this.hide(e);
            this.toolbarItemRef?.current?.focus();
        };
    }
}
var $6b882051a00f24e3$export$2e2bcd8739ae039 = (0, $6YFG2.default)($6b882051a00f24e3$export$2985b35a9cfdee76);

});
parcelRegister("fCT5K", function(module, exports) {
$parcel$export(module.exports, "DynamicStrokeIconDecoration", () => $e0b641bf2353ff47$export$76b0278e018f8601);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
function $e0b641bf2353ff47$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e0b641bf2353ff47$var$barStyles = {
    name: "k9tay8",
    styles: "position:absolute;left:0;right:0;top:18px;margin:auto;width:var(--ds-space-200, 16px);height:3px"
};
const $e0b641bf2353ff47$var$textColorIconWrapper = (0, $1DXK0.xcss)({
    position: 'relative'
});
const $e0b641bf2353ff47$var$getBackground = (selectedColor, disabled)=>{
    if (selectedColor) return selectedColor;
    return disabled ? "var(--ds-icon-disabled, #091E424F)" : "var(--ds-icon, #44546F)";
};
const $e0b641bf2353ff47$export$76b0278e018f8601 = ({ selectedColor: selectedColor, disabled: disabled, icon: icon })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8nu6j.default), {
        xcss: $e0b641bf2353ff47$var$textColorIconWrapper
    }, icon, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        "data-testid": "toolbar-icon-dynamic-stroke",
        style: {
            background: $e0b641bf2353ff47$var$getBackground(selectedColor, disabled)
        },
        css: $e0b641bf2353ff47$var$barStyles
    }));
};

});

parcelRegister("32xIU", function(module, exports) {
$parcel$export(module.exports, "SteppedRainbowIconDecoration", () => $d6044e5d0062a2fa$export$9141b78f26ee217c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");
function $d6044e5d0062a2fa$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d6044e5d0062a2fa$var$createSteppedRainbow = (colors)=>{
    return `
    linear-gradient(
      to right,
      ${colors.map((color, i)=>{
        const inc = 100 / colors.length;
        const pos = i + 1;
        if (i === 0) return `${color} ${pos * inc}%,`;
        if (i === colors.length - 1) return `${color} ${(pos - 1) * inc}%`;
        return `
            ${color} ${(pos - 1) * inc}%,
            ${color} ${pos * inc}%,
          `;
    }).join('\n')}
    )`;
};
const $d6044e5d0062a2fa$export$8025971e8c08a5b8 = $d6044e5d0062a2fa$var$createSteppedRainbow([
    "var(--ds-background-accent-purple-bolder, #6E5DC6)",
    "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    "var(--ds-background-accent-orange-subtle, #FEA362)",
    "var(--ds-background-accent-red-bolder, #C9372C)"
]);
const $d6044e5d0062a2fa$export$9427247cfe66d53e = $d6044e5d0062a2fa$var$createSteppedRainbow([
    "var(--ds-background-accent-gray-subtle, #8590A2)",
    "var(--ds-background-accent-gray-subtle-hovered, #B3B9C4)",
    "var(--ds-background-accent-gray-subtle-pressed, #DCDFE4)",
    "var(--ds-background-accent-gray-subtle-hovered, #B3B9C4)"
]);
const $d6044e5d0062a2fa$var$barStyles = {
    name: "ox20r",
    styles: "position:absolute;left:0;right:0;top:var(--ds-space-200, 16px);margin:auto;width:12px;height:3px;border-radius:var(--ds-radius-small, 3px)"
};
const $d6044e5d0062a2fa$var$textColorIconWrapper = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $d6044e5d0062a2fa$var$getBackground = (selectedColor, disabled)=>{
    if (selectedColor) return selectedColor;
    if (disabled) return $d6044e5d0062a2fa$export$9427247cfe66d53e;
    return $d6044e5d0062a2fa$export$8025971e8c08a5b8;
};
const $d6044e5d0062a2fa$export$9141b78f26ee217c = ({ selectedColor: selectedColor, disabled: disabled, icon: icon })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $d6044e5d0062a2fa$var$textColorIconWrapper
    }, icon, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        "data-testid": "toolbar-icon-stepped-rainbow",
        style: {
            background: $d6044e5d0062a2fa$var$getBackground(selectedColor, disabled)
        },
        css: $d6044e5d0062a2fa$var$barStyles
    }));
};

});

parcelRegister("6WP1Q", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9f0917f4199f5ead8e2ff316703c32c4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $50efbe1b581ab665$var$_react = $50efbe1b581ab665$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $50efbe1b581ab665$var$_baseNew = $50efbe1b581ab665$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $50efbe1b581ab665$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextStyle".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for text styles in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $50efbe1b581ab665$var$TextStyleIcon = (props)=>/*#__PURE__*/ $50efbe1b581ab665$var$_react.default.createElement($50efbe1b581ab665$var$_baseNew.default, Object.assign({
        name: "TextStyleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.799.484A.75.75 0 0 1 7.5 0h1.018a.75.75 0 0 1 .701.485l3.733 9.875a.8.8 0 0 1 .048.265V11h-1.5v-.238L10.456 8H5.55L4.5 10.763V11H3v-.375a.8.8 0 0 1 .049-.266zM6.119 6.5h3.77L8.01 1.524z" clip-rule="evenodd"/>`
    }, props));
$50efbe1b581ab665$var$TextStyleIcon.displayName = 'TextStyleIcon';
var $50efbe1b581ab665$var$_default = module.exports.default = $50efbe1b581ab665$var$TextStyleIcon;

});

parcelRegister("hadhW", function(module, exports) {
$parcel$export(module.exports, "getInputMethod", () => $1a3b239966d17b37$export$8213a6fbfa466e73);

var $bMFKb = parcelRequire("bMFKb");

var $2sDI4 = parcelRequire("2sDI4");
const $1a3b239966d17b37$var$toolbarTypeToInputMethod = {
    [(0, $2sDI4.ToolbarType).PRIMARY]: (0, $bMFKb.INPUT_METHOD).TOOLBAR,
    [(0, $2sDI4.ToolbarType).FLOATING]: (0, $bMFKb.INPUT_METHOD).FLOATING_TB
};
const $1a3b239966d17b37$export$8213a6fbfa466e73 = (toolbarType)=>$1a3b239966d17b37$var$toolbarTypeToInputMethod[toolbarType];

});

parcelRegister("7hKj8", function(module, exports) {
$parcel$export(module.exports, "EditorTextColorIcon", () => $5bf90f0f723f2207$export$6f7e1bde4b1a013b);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $5bf90f0f723f2207$var$textColorGlyph = (props)=>// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
        ...props,
        width: "24",
        height: "24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            d: "M14 12.5h-4l-.874 2.186A.5.5 0 0 1 8.66 15H7.273a.5.5 0 0 1-.456-.705l4.05-9A.5.5 0 0 1 11.323 5h1.354a.5.5 0 0 1 .456.295l4.05 9a.5.5 0 0 1-.456.705h-1.388a.5.5 0 0 1-.465-.314L14 12.5zm-.6-1.5L12 7.5 10.6 11h2.8z",
            fill: "currentColor",
            fillRule: "evenodd"
        })
    });
const $5bf90f0f723f2207$export$6f7e1bde4b1a013b = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.default), {
        glyph: $5bf90f0f723f2207$var$textColorGlyph,
        label: ""
    });
};

});



parcelRegister("kDLuw", function(module, exports) {
$parcel$export(module.exports, "PrimaryToolbarComponent", () => $25efbd7fff20e8f4$export$94516d5cccf573e3);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $cxXTK = parcelRequire("cxXTK");

var $2sDI4 = parcelRequire("2sDI4");

var $iyXAm = parcelRequire("iyXAm");
const $25efbd7fff20e8f4$var$selector = (states)=>{
    return {
        color: states.textColorState?.color,
        defaultColor: states.textColorState?.defaultColor,
        palette: states.textColorState?.palette,
        disabled: states.textColorState?.disabled
    };
};
const $25efbd7fff20e8f4$export$94516d5cccf573e3 = ({ api: api, isReducedSpacing: isReducedSpacing, editorView: editorView, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, popupsBoundariesElement: popupsBoundariesElement, dispatchAnalyticsEvent: dispatchAnalyticsEvent, disabled: disabled })=>{
    const { color: color, defaultColor: defaultColor, palette: palette, disabled: textColorDisabled } = (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'textColor'
    ], $25efbd7fff20e8f4$var$selector);
    if (color === undefined || defaultColor === undefined || palette === undefined) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iyXAm.default), {
        pluginState: {
            color: color,
            defaultColor: defaultColor,
            palette: palette,
            disabled: textColorDisabled
        },
        isReducedSpacing: isReducedSpacing,
        editorView: editorView,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        disabled: disabled,
        pluginInjectionApi: api,
        toolbarType: (0, $2sDI4.ToolbarType).PRIMARY
    });
};

});

parcelRegister("6iB6A", function(module, exports) {
$parcel$export(module.exports, "getToolbarComponents", () => $7669e6fc47ea26a3$export$a758406ca53b86a5);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $3KjUM = parcelRequire("3KjUM");
var $6996L = parcelRequire("6996L");

var $cbSL1 = parcelRequire("cbSL1");

var $9JypA = parcelRequire("9JypA");

var $251Ep = parcelRequire("251Ep");

var $83ln8 = parcelRequire("83ln8");

var $3eoT6 = parcelRequire("3eoT6");
const $7669e6fc47ea26a3$export$a758406ca53b86a5 = (api)=>{
    return [
        {
            ...(0, $3KjUM.TEXT_COLOR_HIGHLIGHT_GROUP),
            parents: [
                {
                    ...(0, $3KjUM.TEXT_SECTION),
                    rank: (0, $6996L.TEXT_SECTION_RANK)[(0, $3KjUM.TEXT_COLOR_HIGHLIGHT_GROUP).key]
                },
                {
                    type: (0, $3KjUM.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $3KjUM.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $6996L.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $3KjUM.TEXT_COLOR_HIGHLIGHT_GROUP).key]
                }
            ]
        },
        {
            ...(0, $3KjUM.TEXT_COLOR_HIGHLIGHT_MENU),
            parents: [
                {
                    ...(0, $3KjUM.TEXT_COLOR_HIGHLIGHT_GROUP),
                    rank: (0, $6996L.TEXT_COLOR_HIGHLIGHT_GROUP_RANK)[(0, $3KjUM.TEXT_COLOR_HIGHLIGHT_MENU).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $251Ep.TextColorHighlightMenu), {
                    api: api,
                    children: children
                })
        },
        {
            ...(0, $3KjUM.TEXT_COLOR_HIGHLIGHT_MENU_SECTION),
            parents: [
                {
                    ...(0, $3KjUM.TEXT_COLOR_HIGHLIGHT_MENU),
                    rank: (0, $6996L.TEXT_COLOR_HIGHLIGHT_MENU_RANK)[(0, $3KjUM.TEXT_COLOR_HIGHLIGHT_MENU_SECTION).key]
                },
                ...(0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_responsive', 'isEnabled', true) ? [
                    {
                        type: (0, $3KjUM.TEXT_COLLAPSED_MENU).type,
                        key: (0, $3KjUM.TEXT_COLLAPSED_MENU).key,
                        rank: (0, $6996L.TEXT_COLLAPSED_MENU_RANK)[(0, $3KjUM.TEXT_COLOR_HIGHLIGHT_MENU_SECTION).key]
                    }
                ] : []
            ],
            component: (0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_responsive', 'isEnabled', true) ? (0, $3eoT6.TextMenuSection) : undefined
        },
        {
            ...(0, $3KjUM.TEXT_COLOR_MENU_ITEM),
            parents: [
                {
                    ...(0, $3KjUM.TEXT_COLOR_HIGHLIGHT_MENU_SECTION),
                    rank: (0, $6996L.TEXT_COLOR_HIGHLIGHT_MENU_SECTION_RANK)[(0, $3KjUM.TEXT_COLOR_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $83ln8.TextColorMenuItem), {
                    api: api,
                    parents: parents
                })
        },
        ...(0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_patch_4', 'isEnabled', true) ? [
            {
                ...(0, $3KjUM.CLEAR_COLOR_MENU_ITEM),
                parents: [
                    {
                        ...(0, $3KjUM.TEXT_COLOR_HIGHLIGHT_MENU_SECTION),
                        rank: (0, $6996L.TEXT_COLOR_HIGHLIGHT_MENU_SECTION_RANK)[(0, $3KjUM.CLEAR_COLOR_MENU_ITEM).key]
                    }
                ],
                component: ({ parents: parents })=>{
                    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9JypA.RemoveColorMenuItem), {
                        api: api,
                        parents: parents
                    });
                }
            }
        ] : []
    ];
};

});
parcelRegister("9JypA", function(module, exports) {
$parcel$export(module.exports, "RemoveColorMenuItem", () => $e966dec66b0cee24$export$cb635404e02af50a);
/* RemoveColorMenuItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $5CSKW = parcelRequire("5CSKW");

var $lVkxz = parcelRequire("lVkxz");

var $e7Koy = parcelRequire("e7Koy");

var $2ZXFU = parcelRequire("2ZXFU");

var $L6zCC = parcelRequire("L6zCC");

var $3cMgR = parcelRequire("3cMgR");
const $e966dec66b0cee24$var$styles = {
    removeColorButton: "_2rko12b0 _195gv77o _189ee4h9 _1dqonqa1 _1h6dmuej _19pk12x7"
};
const $e966dec66b0cee24$export$cb635404e02af50a = ({ api: api, parents: parents })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const context = (0, $L6zCC.useToolbarDropdownMenu)();
    const closeMenu = context?.closeMenu;
    const onClick = ()=>{
        if (!api) return;
        const defaultColor = api.textColor.sharedState.currentState()?.defaultColor;
        if (!defaultColor) return;
        api.core.actions.execute(({ tr: tr })=>{
            api.textColor.commands.changeColor(defaultColor, (0, $e7Koy.getInputMethodFromParentKeys)(parents))({
                tr: tr
            });
            api.highlight?.commands.changeColor({
                color: (0, $2ZXFU.REMOVE_HIGHLIGHT_COLOR),
                inputMethod: (0, $e7Koy.getInputMethodFromParentKeys)(parents)
            })({
                tr: tr
            });
            return tr;
        });
        closeMenu?.();
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            $e966dec66b0cee24$var$styles.removeColorButton
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
            shouldFitContainer: true,
            appearance: "subtle",
            onClick: onClick,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                weight: "medium",
                children: formatMessage((0, $lVkxz.highlightMessages).removeColor)
            })
        })
    });
};

});
parcelRegister("2ZXFU", function(module, exports) {
$parcel$export(module.exports, "REMOVE_HIGHLIGHT_COLOR", () => $6b3b8a1622039cbd$export$7af0d402d86db2f8);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $7i9jz = parcelRequire("7i9jz");

var $fL0In = parcelRequire("fL0In");

var $58yRG = parcelRequire("58yRG");

var $ebo8n = parcelRequire("ebo8n");

var $fHZGh = parcelRequire("fHZGh");

var $9WC9O = parcelRequire("9WC9O");
const $6b3b8a1622039cbd$export$7af0d402d86db2f8 = '#00000000';
const $6b3b8a1622039cbd$var$DiagonalLineGlyph = ()=>/*#__PURE__*/ (0, $1NIU8.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("rect", {
        width: "24",
        height: "24",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, $1NIU8.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.2038 7.70388C17.5955 8.09565 17.5941 8.73128 17.2005 9.12127L9.1213 17.1277C8.73027 17.5152 8.09958 17.5138 7.71031 17.1245C7.31854 16.7328 7.31997 16.0971 7.71351 15.7071L15.7928 7.70069C16.1838 7.31318 16.8145 7.31461 17.2038 7.70388Z",
        fill: "currentColor",
        fillOpacity: "0.5"
    }));
const $6b3b8a1622039cbd$export$b875e193f77236ba = ()=>{
    const { colorMode: colorMode } = (0, $58yRG.default)();
    const primaryColor = colorMode === 'dark' ? "var(--ds-background-accent-gray-bolder, #626F86)" : "var(--ds-background-accent-gray-subtle, #8590A2)";
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $fL0In.default), {
        glyph: $6b3b8a1622039cbd$var$DiagonalLineGlyph,
        label: "",
        primaryColor: primaryColor
    });
};
const $6b3b8a1622039cbd$export$d0f14653c33da02f = [
    {
        value: $6b3b8a1622039cbd$export$7af0d402d86db2f8,
        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
        label: 'No color',
        // Mostly informative, only used for analytics
        border: "var(--ds-border, #091E4224)",
        message: (0, $ebo8n.default)((0, $fHZGh.default), 'no-color'),
        decorator: /*#__PURE__*/ (0, $1NIU8.jsx)($6b3b8a1622039cbd$export$b875e193f77236ba, null)
    }
];
(0, $7i9jz.backgroundColorPalette).forEach((label, color)=>{
    $6b3b8a1622039cbd$export$d0f14653c33da02f.push((0, $9WC9O.mapPaletteColor)(label, color));
});
const $6b3b8a1622039cbd$export$5b3b64545c1497a3 = [
    {
        value: $6b3b8a1622039cbd$export$7af0d402d86db2f8,
        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
        label: 'No color',
        // Mostly informative, only used for analytics
        border: "var(--ds-border, #091E4224)",
        message: (0, $ebo8n.default)((0, $fHZGh.default), 'no-color'),
        decorator: /*#__PURE__*/ (0, $1NIU8.jsx)($6b3b8a1622039cbd$export$b875e193f77236ba, null)
    }
];
(0, $7i9jz.backgroundColorPaletteNext).forEach((label, color)=>{
    $6b3b8a1622039cbd$export$5b3b64545c1497a3.push((0, $9WC9O.mapPaletteColor)(label, color));
});

});


parcelRegister("251Ep", function(module, exports) {
$parcel$export(module.exports, "TextColorHighlightMenu", () => $b90e53cadbc57393$export$c448885240fc43ad);
/* TextColorHighlightMenu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $6Exgk = parcelRequire("6Exgk");

var $DGjKK = parcelRequire("DGjKK");

var $frlUM = parcelRequire("frlUM");

var $9NsIT = parcelRequire("9NsIT");

var $55nSZ = parcelRequire("55nSZ");
var $8dV54 = parcelRequire("8dV54");
var $l9Nax = parcelRequire("l9Nax");
var $lNljc = parcelRequire("lNljc");
var $L6zCC = parcelRequire("L6zCC");
var $64R2q = parcelRequire("64R2q");
var $7K3rS = parcelRequire("7K3rS");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");

var $cbSL1 = parcelRequire("cbSL1");
const $b90e53cadbc57393$var$styles = {
    menu: "_1rjcv77o _18zru2gc"
};
const $b90e53cadbc57393$var$getIconColor = (textColor, defaultColor, highlightColor)=>{
    if (highlightColor || !textColor || textColor === defaultColor && defaultColor) return "var(--ds-text, #172B4D)";
    return (0, $9NsIT.hexToEditorTextPaletteColor)(textColor) || "var(--ds-text, #172B4D)";
};
const $b90e53cadbc57393$export$c448885240fc43ad = ({ children: children, api: api })=>{
    const isHighlightPluginExisted = !!api?.highlight;
    const isTextColorDisabled = (0, $frlUM.useSharedPluginStateSelector)(api, 'textColor.disabled');
    const { isDisabled: isToolbarDisabled } = (0, $7K3rS.useToolbarUI)();
    const isDisabled = (0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_patch_5', 'isEnabled', true) ? Boolean(isToolbarDisabled || isTextColorDisabled) : isTextColorDisabled;
    const highlightColor = (0, $frlUM.useSharedPluginStateSelector)(api, 'highlight.activeColor');
    const textColor = (0, $frlUM.useSharedPluginStateSelector)(api, 'textColor.color');
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const defaultColor = (0, $frlUM.useSharedPluginStateSelector)(api, 'textColor.defaultColor');
    const isPaletteOpen = (0, $frlUM.useSharedPluginStateSelector)(api, 'textColor.isPaletteOpen');
    const setIsPaletteOpen = (0, $eJOHy.useCallback)((isOpen)=>{
        if (api?.textColor?.commands?.setPalette) api.core.actions.execute(({ tr: tr })=>{
            api.textColor.commands.setPalette(isOpen)({
                tr: tr
            });
            return tr;
        });
    }, [
        api?.textColor?.commands,
        api?.core.actions
    ]);
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if ((0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) && (0, $eGOwo.fg)('platform_editor_toolbar_aifc_patch_7')) {
                if (isPaletteOpen) setIsPaletteOpen(false);
            }
        };
    }, [
        setIsPaletteOpen,
        isPaletteOpen
    ]);
    const iconColor = $b90e53cadbc57393$var$getIconColor(textColor, defaultColor, highlightColor);
    const highlightColorIcon = highlightColor ? highlightColor : (0, $55nSZ.getContrastingBackgroundColor)(iconColor);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $64R2q.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6Exgk.ToolTipContent), {
            description: formatMessage(isHighlightPluginExisted ? (0, $DGjKK.textColorMessages).textColorHighlightTooltip : (0, $DGjKK.textColorMessages).textColorTooltip),
            keymap: (0, $6Exgk.toggleHighlightPalette)
        }),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $L6zCC.ToolbarDropdownMenuProvider), {
            isOpen: (0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) ? isPaletteOpen : undefined,
            setIsOpen: (0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) ? setIsPaletteOpen : undefined,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lNljc.ToolbarDropdownMenu), {
                iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l9Nax.ToolbarColorSwatch), {
                    highlightColor: highlightColorIcon,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8dV54.TextColorIcon), {
                        label: formatMessage((0, $DGjKK.textColorMessages).textColorTooltip),
                        iconColor: iconColor,
                        shouldRecommendSmallIcon: true,
                        size: 'small',
                        isDisabled: isDisabled,
                        spacing: 'compact'
                    })
                }),
                isDisabled: isDisabled,
                testId: "text-color-highlight-menu",
                hasSectionMargin: false,
                children: (0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_responsive', 'isEnabled', true) ? children : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    xcss: $b90e53cadbc57393$var$styles.menu,
                    children: children
                })
            })
        })
    });
};

});
parcelRegister("55nSZ", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_COLOR_PICKER_COLUMNS", () => $904d9e483f2d0e25$export$dc37d14f75a32acb);
$parcel$export(module.exports, "getColorsPerRowFromPalette", () => $904d9e483f2d0e25$export$d97d52770ca27b6f);
$parcel$export(module.exports, "getSelectedRowAndColumnFromPalette", () => $904d9e483f2d0e25$export$c16ae5b27ec0c8f6);
$parcel$export(module.exports, "getTokenCSSVariableValue", () => $904d9e483f2d0e25$export$426cbff16166281c);
$parcel$export(module.exports, "getContrastingBackgroundColor", () => $904d9e483f2d0e25$export$1549d7e409f36993);

var $ku9IZ = parcelRequire("ku9IZ");
const $904d9e483f2d0e25$export$dc37d14f75a32acb = 7;
function $904d9e483f2d0e25$export$d97d52770ca27b6f(palette, cols = $904d9e483f2d0e25$export$dc37d14f75a32acb) {
    return palette.reduce((resultArray, item, index)=>{
        const chunkIndex = Math.floor(index / cols);
        resultArray[chunkIndex] = resultArray[chunkIndex] || []; // start a new chunk
        resultArray[chunkIndex].push(item);
        return resultArray;
    }, []);
}
function $904d9e483f2d0e25$export$17092ffd56d3b3b2(colorsPerRow, selectedColor) {
    let selectedRowIndex = -1;
    let selectedColumnIndex = -1;
    colorsPerRow.forEach((row, rowIndex)=>{
        row.forEach(({ value: value }, columnIndex)=>{
            if (value === selectedColor) {
                selectedRowIndex = rowIndex;
                selectedColumnIndex = columnIndex;
            }
        });
    });
    return {
        selectedRowIndex: selectedRowIndex,
        selectedColumnIndex: selectedColumnIndex
    };
}
function $904d9e483f2d0e25$export$c16ae5b27ec0c8f6(palette, selectedColor, cols = $904d9e483f2d0e25$export$dc37d14f75a32acb) {
    const colorsPerRow = $904d9e483f2d0e25$export$d97d52770ca27b6f(palette, cols);
    return $904d9e483f2d0e25$export$17092ffd56d3b3b2(colorsPerRow, selectedColor);
}
const $904d9e483f2d0e25$export$426cbff16166281c = (variableExpression)=>{
    // Match CSS variable pattern: var(--variable-name, fallback)
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const matcher = variableExpression.match(/var\(([^,\)]+)(,.*)?/);
    if (matcher) {
        const variable = matcher[1].trim();
        const fallback = matcher[2] ? matcher[2].replace(',', '').trim() : '';
        // Return fallback if we're in a server environment
        if (typeof document === 'undefined') return fallback;
        // Get the computed value from the document
        const value = window.getComputedStyle(document.documentElement).getPropertyValue(variable).trim();
        return value || fallback;
    }
    return '';
};
function $904d9e483f2d0e25$export$1549d7e409f36993(textColor) {
    const candidates = [
        '#FFFFFF',
        '#172B4D'
    ];
    // Extract actual color value if it's a CSS variable
    const tokenVal = $904d9e483f2d0e25$export$426cbff16166281c(textColor);
    const colorValue = !!tokenVal ? tokenVal : textColor;
    // Find the color with the highest contrast ratio
    const bestContrast = candidates.sort((a, b)=>(0, $ku9IZ.default).difference(b, colorValue) - (0, $ku9IZ.default).difference(a, colorValue))[0];
    return bestContrast;
}

});

parcelRegister("8dV54", function(module, exports) {
$parcel$export(module.exports, "TextColorIcon", () => $c2a718ccf24bacad$export$36ed63fbff8ebdac);
/* TextColorIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6WP1Q = parcelRequire("6WP1Q");

var $8IeH1 = parcelRequire("8IeH1");
const $c2a718ccf24bacad$var$styles = {
    icon: "_19pk12x7"
};
const $c2a718ccf24bacad$export$36ed63fbff8ebdac = ({ label: label, shouldRecommendSmallIcon: shouldRecommendSmallIcon, size: size, spacing: spacing, testId: testId, iconColor: iconColor, isDisabled: isDisabled })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "span",
        xcss: $c2a718ccf24bacad$var$styles.icon,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6WP1Q))), {
            label: label,
            testId: testId,
            color: isDisabled ? "var(--ds-icon-disabled, #091E424F)" : iconColor,
            shouldRecommendSmallIcon: shouldRecommendSmallIcon,
            spacing: spacing,
            size: size
        })
    });
};

});

parcelRegister("l9Nax", function(module, exports) {
$parcel$export(module.exports, "ToolbarColorSwatch", () => $8c98e29bf35b3340$export$772f650f1e0be5db);
/* ToolbarColorSwatch.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
const $8c98e29bf35b3340$var$styles = {
    colorSwatch: "_19it7r9e _2rko12b0 _1e0c1txw _1bah1h6o _4cvr1h6o _1bsbgktf _4t3igktf _18u0r5cr _2hwxr5cr"
};
const $8c98e29bf35b3340$export$772f650f1e0be5db = ({ children: children, highlightColor: highlightColor })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: $8c98e29bf35b3340$var$styles.colorSwatch,
        style: {
            backgroundColor: highlightColor
        },
        children: children
    });
};

});


parcelRegister("83ln8", function(module, exports) {
$parcel$export(module.exports, "TextColorMenuItem", () => $64c516ecfee09a84$export$12b1414e9754f110);
/* TextColorMenuItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $cxXTK = parcelRequire("cxXTK");

var $DGjKK = parcelRequire("DGjKK");

var $e7Koy = parcelRequire("e7Koy");
var $c0YTT = parcelRequire("c0YTT");

var $a44PI = parcelRequire("a44PI");

var $9NsIT = parcelRequire("9NsIT");

var $cHWBv = parcelRequire("cHWBv");
var $L6zCC = parcelRequire("L6zCC");

var $806LH = parcelRequire("806LH");

var $78OnL = parcelRequire("78OnL");
const $64c516ecfee09a84$var$styles = {
    container: "_zulp12x7"
};
function $64c516ecfee09a84$export$12b1414e9754f110({ api: api, parents: parents }) {
    const { color: color, defaultColor: defaultColor, palette: palette } = (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'textColor'
    ], (states)=>({
            color: states.textColorState?.color,
            defaultColor: states.textColorState?.defaultColor || null,
            palette: states.textColorState?.palette || []
        }));
    const { editorView: editorView } = (0, $c0YTT.useEditorToolbar)();
    const context = (0, $L6zCC.useToolbarDropdownMenu)();
    const closeMenu = context?.closeMenu;
    const handleTextColorChange = (0, $eJOHy.useCallback)((color)=>{
        if (!editorView?.state || !editorView?.dispatch) return;
        if (api?.textColor?.actions?.changeColor) {
            api.textColor.actions.changeColor(color, (0, $e7Koy.getInputMethodFromParentKeys)(parents))(editorView.state, editorView.dispatch);
            closeMenu?.();
        }
    }, [
        editorView?.state,
        editorView?.dispatch,
        api?.textColor.actions,
        parents,
        closeMenu
    ]);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
        xcss: $64c516ecfee09a84$var$styles.container,
        testId: "text-color-menu-item",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                size: "xxsmall",
                children: formatMessage((0, $DGjKK.textColorMessages).textColorTooltip)
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cHWBv.default), {
                onClick: (color)=>{
                    handleTextColorChange(color);
                },
                selectedColor: color || defaultColor,
                paletteOptions: {
                    palette: palette,
                    hexToPaletteColor: (0, $9NsIT.hexToEditorTextPaletteColor),
                    paletteColorTooltipMessages: (0, $a44PI.textPaletteTooltipMessages)
                }
            })
        ]
    });
}

});
parcelRegister("cHWBv", function(module, exports) {
$parcel$export(module.exports, "default", () => $5fbe5b6419f9f0ef$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ku9IZ = parcelRequire("ku9IZ");

var $lRq8t = parcelRequire("lRq8t");

var $hYvlq = parcelRequire("hYvlq");
var $6djmC = parcelRequire("6djmC");

var $58yRG = parcelRequire("58yRG");

var $aIHrl = parcelRequire("aIHrl");

var $gmNpf = parcelRequire("gmNpf");

var $55nSZ = parcelRequire("55nSZ");
/**
 * For a given color pick the color from a list of colors with
 * the highest contrast
 *
 * @param color color string, supports HEX, RGB, RGBA etc.
 * @param useIconToken boolean, describes if a token should be used for the icon color
 * @returns Highest contrast color in pool
 */ function $5fbe5b6419f9f0ef$var$getCheckMarkColor(color, useIconToken) {
    const tokenVal = (0, $55nSZ.getTokenCSSVariableValue)(color);
    const colorValue = !!tokenVal ? tokenVal : color;
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    const contrastColor = [
        '#FFFFFF',
        '#42526E'
    ].sort((a, b)=>(0, $ku9IZ.default).difference(b, colorValue) - (0, $ku9IZ.default).difference(a, colorValue))[0];
    if (!useIconToken) return contrastColor;
    // Use of these token comes from guidance from designers in the Design System team
    // they are only intended for use with text colors (and there are different tokens
    // planned to be used when this extended to be used with other palettes).
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    return contrastColor === '#FFFFFF' ? "var(--ds-icon-inverse, #FFFFFF)" : "var(--ds-icon, #44546F)";
}
/**
 * ColorPalette component for displaying a grid of selectable colors
 *
 * Features:
 * - Responsive grid layout
 * - Keyboard navigation support
 * - Accessibility compliance (ARIA attributes)
 * - Theme-aware tooltips
 * - Design token integration
 * - Customizable color mapping
 */ const $5fbe5b6419f9f0ef$var$ColorPalette = ({ cols: cols = (0, $55nSZ.DEFAULT_COLOR_PICKER_COLUMNS), onClick: onClick, onKeyDown: onKeyDown, selectedColor: selectedColor, paletteOptions: paletteOptions })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { palette: palette, hexToPaletteColor: hexToPaletteColor, paletteColorTooltipMessages: paletteColorTooltipMessages } = paletteOptions;
    const { colorMode: tokenTheme } = (0, $58yRG.default)();
    const useIconToken = !!hexToPaletteColor;
    // Refs for keyboard navigation
    const paletteRef = (0, $eJOHy.useRef)(null);
    const currentFocusRef = (0, $eJOHy.useRef)({
        row: 0,
        col: 0
    });
    const colorsPerRow = (0, $eJOHy.useMemo)(()=>{
        return (0, $55nSZ.getColorsPerRowFromPalette)(palette, cols);
    }, [
        palette,
        cols
    ]);
    // Get initial focus position based on selected color
    const { selectedRowIndex: selectedRowIndex, selectedColumnIndex: selectedColumnIndex } = (0, $eJOHy.useMemo)(()=>{
        return (0, $55nSZ.getSelectedRowAndColumnFromPalette)(palette, selectedColor, cols);
    }, [
        palette,
        selectedColor,
        cols
    ]);
    // Focus management utility
    const focusColorAt = (0, $eJOHy.useCallback)((row, col)=>{
        if (!paletteRef.current) return;
        const rowElement = paletteRef.current.children[row];
        if (!(rowElement instanceof HTMLElement)) return;
        const colorButtonCandidate = rowElement.children[col]?.querySelector?.('button');
        const colorButton = colorButtonCandidate instanceof HTMLButtonElement ? colorButtonCandidate : null;
        if (colorButton) {
            colorButton.focus();
            currentFocusRef.current = {
                row: row,
                col: col
            };
        }
    }, []);
    // Initialize focus position and handle autofocus
    (0, $eJOHy.useEffect)(()=>{
        if (selectedRowIndex >= 0 && selectedColumnIndex >= 0) currentFocusRef.current = {
            row: selectedRowIndex,
            col: selectedColumnIndex
        };
        else currentFocusRef.current = {
            row: 0,
            col: 0
        };
    }, [
        selectedRowIndex,
        selectedColumnIndex
    ]);
    // Keyboard navigation handler
    const handleKeyDown = (0, $eJOHy.useCallback)((value, label, event)=>{
        const { row: row, col: col } = currentFocusRef.current;
        const maxRow = colorsPerRow.length - 1;
        const maxCol = colorsPerRow[row]?.length - 1 || 0;
        switch(event.key){
            case 'ArrowRight':
                event.preventDefault();
                if (col < maxCol) focusColorAt(row, col + 1);
                else if (row < maxRow) // Move to first color of next row
                focusColorAt(row + 1, 0);
                else // Wrap to first color of first row
                focusColorAt(0, 0);
                break;
            case 'ArrowLeft':
                event.preventDefault();
                if (col > 0) focusColorAt(row, col - 1);
                else if (row > 0) {
                    // Move to last color of previous row
                    const prevRowMaxCol = colorsPerRow[row - 1]?.length - 1 || 0;
                    focusColorAt(row - 1, prevRowMaxCol);
                } else {
                    // Wrap to last color of last row
                    const lastRowMaxCol = colorsPerRow[maxRow]?.length - 1 || 0;
                    focusColorAt(maxRow, lastRowMaxCol);
                }
                break;
            case 'ArrowDown':
                event.preventDefault();
                if (row < maxRow) {
                    // Move to same column in next row, or last available column
                    const nextRowMaxCol = colorsPerRow[row + 1]?.length - 1 || 0;
                    const targetCol = Math.min(col, nextRowMaxCol);
                    focusColorAt(row + 1, targetCol);
                } else {
                    // Wrap to same column in first row
                    const firstRowMaxCol = colorsPerRow[0]?.length - 1 || 0;
                    const targetCol = Math.min(col, firstRowMaxCol);
                    focusColorAt(0, targetCol);
                }
                break;
            case 'ArrowUp':
                event.preventDefault();
                if (row > 0) {
                    // Move to same column in previous row, or last available column
                    const prevRowMaxCol = colorsPerRow[row - 1]?.length - 1 || 0;
                    const targetCol = Math.min(col, prevRowMaxCol);
                    focusColorAt(row - 1, targetCol);
                } else {
                    // Wrap to same column in last row
                    const lastRowMaxCol = colorsPerRow[maxRow]?.length - 1 || 0;
                    const targetCol = Math.min(col, lastRowMaxCol);
                    focusColorAt(maxRow, targetCol);
                }
                break;
            case 'Home':
                event.preventDefault();
                focusColorAt(row, 0);
                break;
            case 'End':
                event.preventDefault();
                focusColorAt(row, maxCol);
                break;
            case 'PageUp':
                event.preventDefault();
                focusColorAt(0, col);
                break;
            case 'PageDown':
                {
                    event.preventDefault();
                    const lastRowMaxCol = colorsPerRow[maxRow]?.length - 1 || 0;
                    const targetCol = Math.min(col, lastRowMaxCol);
                    focusColorAt(maxRow, targetCol);
                    break;
                }
            case 'Tab':
                // Allow Tab to move to next focusable element (don't prevent default)
                // This will allow Tab to move between color palettes
                if (onKeyDown) onKeyDown(value, label, event);
                break;
            case 'Enter':
            case ' ':
                event.preventDefault();
                onClick(value, label);
                break;
            default:
                // Pass through to custom onKeyDown handler if provided
                if (onKeyDown) onKeyDown(value, label, event);
                break;
        }
    }, [
        colorsPerRow,
        focusColorAt,
        onClick,
        onKeyDown
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hYvlq.default), {
        gap: "space.050",
        ref: paletteRef,
        role: "group",
        children: colorsPerRow.map((row, rowIndex)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                rowSpace: "space.050",
                role: "radiogroup",
                children: row.map(({ value: value, label: label, border: border, message: message, decorator: decorator }, colIndex)=>{
                    let tooltipMessage = message;
                    // Override with theme-specific tooltip messages if provided
                    if (paletteColorTooltipMessages) {
                        if (tokenTheme === 'dark') tooltipMessage = (0, $gmNpf.default)(paletteColorTooltipMessages.dark, value.toUpperCase());
                        if (tokenTheme === 'light') tooltipMessage = (0, $gmNpf.default)(paletteColorTooltipMessages.light, value.toUpperCase());
                    }
                    // Determine if this color should be focusable
                    const isSelectedColor = value === selectedColor;
                    const isFirstColor = rowIndex === 0 && colIndex === 0;
                    // Only the selected color or first color should be focusable via Tab
                    // This allows Tab to move between color palettes
                    const shouldBeFocusable = isSelectedColor || !selectedColor && isFirstColor;
                    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aIHrl.Color), {
                        value: value,
                        borderColor: border,
                        label: tooltipMessage ? formatMessage(tooltipMessage) : label,
                        onClick: onClick,
                        onKeyDown: handleKeyDown,
                        isSelected: isSelectedColor,
                        checkMarkColor: $5fbe5b6419f9f0ef$var$getCheckMarkColor(value, useIconToken),
                        hexToPaletteColor: hexToPaletteColor,
                        decorator: decorator,
                        tabIndex: shouldBeFocusable ? 0 : -1
                    }, value);
                })
            }, `row-first-color-${row[0].value}`))
    });
};
var $5fbe5b6419f9f0ef$export$2e2bcd8739ae039 = $5fbe5b6419f9f0ef$var$ColorPalette;

});
parcelRegister("aIHrl", function(module, exports) {
$parcel$export(module.exports, "Color", () => $29b9487687174514$export$892596cec99bc70e);
/* Color.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6XkOW = parcelRequire("6XkOW");

var $k71qx = parcelRequire("k71qx");
const $29b9487687174514$var$buttonWrapperStyles = null;
const $29b9487687174514$var$buttonStyles = null; /**
                            * Individual color palette item component
                            * Displays a single color swatch with tooltip and selection state
                            */ 
const $29b9487687174514$export$892596cec99bc70e = /*#__PURE__*/ (0, $eJOHy.memo)(({ autoFocus: autoFocus, tabIndex: tabIndex, value: value, label: label, isSelected: isSelected, borderColor: borderColor, checkMarkColor: checkMarkColor = "var(--ds-icon-inverse, #FFFFFF)", hexToPaletteColor: hexToPaletteColor, decorator: decorator, onClick: onClick, onKeyDown: onKeyDown })=>{
    const colorStyle = hexToPaletteColor ? hexToPaletteColor(value) : value;
    const handleMouseDown = (0, $eJOHy.useCallback)((e)=>{
        e.preventDefault();
    }, []);
    const handleClick = (0, $eJOHy.useCallback)((e)=>{
        e.preventDefault();
        onClick(value, label);
    }, [
        onClick,
        value,
        label
    ]);
    const handleKeyDown = (0, $eJOHy.useCallback)((e)=>{
        if (!onKeyDown) return;
        e.preventDefault();
        onKeyDown(value, label, e);
    }, [
        onKeyDown,
        value,
        label
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: label,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            className: (0, $hcewu.default)([
                "_2rko12b0 _1h6d3acm _1dqonqa1 _189ee4h9 _1e0c1txw _4cvr1h6o _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _858umuej _jyzfmuej _4cvxmuej"
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)("button", {
                type: "button",
                "aria-label": label,
                role: "radio",
                "aria-checked": isSelected,
                onClick: handleClick,
                onKeyDown: handleKeyDown,
                onMouseDown: handleMouseDown,
                tabIndex: tabIndex,
                style: {
                    backgroundColor: colorStyle || "var(--ds-background-input, #FFFFFF)",
                    border: `${"var(--ds-border-width, 1px)"} solid ${borderColor}`
                },
                autoFocus: autoFocus,
                className: (0, $hcewu.default)([
                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2rko12b0 _19it1ps9 _4t3icr4y _1bsbcr4y _bfhkm7j4 _80omtlke _1e0c1ule _kqswh2mm _y2mv1q03 _1bg4v77o"
                ]),
                children: [
                    !decorator && isSelected && /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6XkOW))), {
                        color: checkMarkColor,
                        LEGACY_primaryColor: checkMarkColor,
                        label: ""
                    }),
                    decorator
                ]
            })
        })
    });
});

});

parcelRegister("gmNpf", function(module, exports) {
$parcel$export(module.exports, "default", () => $437db12fa553f511$export$2e2bcd8739ae039);
function $437db12fa553f511$export$2e2bcd8739ae039(messages, color) {
    const message = messages[color];
    if (!message) // eslint-disable-next-line no-console
    console.warn(`Color palette does not have an internationalization message for color ${color.toUpperCase()}.
You must add a message description to properly translate this color.
Using current label as default message.
This could have happened when someone changed the 'colorPalette' from 'adf-schema' without updating this file.
`);
    return message;
}

});



parcelRegister("3eoT6", function(module, exports) {
$parcel$export(module.exports, "TextMenuSection", () => $523807974e639d84$export$95716c110be351d7);
/* TextMenuSection.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $3KjUM = parcelRequire("3KjUM");

var $9tvdK = parcelRequire("9tvdK");

var $8IeH1 = parcelRequire("8IeH1");
const $523807974e639d84$var$styles = {
    menu: "_1rjcv77o _18zru2gc"
};
const $523807974e639d84$export$95716c110be351d7 = ({ children: children, parents: parents })=>{
    const hasSeparator = parents.some((parent)=>parent.key === (0, $3KjUM.TEXT_COLLAPSED_MENU).key);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9tvdK.ToolbarDropdownItemSection), {
        hasSeparator: hasSeparator,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            xcss: $523807974e639d84$var$styles.menu,
            children: children
        })
    });
};

});




parcelRegister("03aTp", function(module, exports) {
$parcel$export(module.exports, "textFormattingPlugin", () => (parcelRequire("cxOnI")).textFormattingPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $cxOnI = parcelRequire("cxOnI");

});
parcelRegister("cxOnI", function(module, exports) {
$parcel$export(module.exports, "textFormattingPlugin", () => $8ba5f5277d08f85b$export$2db686be056cb923);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eA6GD = parcelRequire("eA6GD");
var $eonww = parcelRequire("eonww");
var $f4V9T = parcelRequire("f4V9T");
var $YKDO7 = parcelRequire("YKDO7");
var $hI6rl = parcelRequire("hI6rl");
var $b7o0x = parcelRequire("b7o0x");

var $eGOwo = parcelRequire("eGOwo");

var $92xoS = parcelRequire("92xoS");

var $fYXDG = parcelRequire("fYXDG");

var $HNwmP = parcelRequire("HNwmP");

var $8Qk18 = parcelRequire("8Qk18");

var $baCX0 = parcelRequire("baCX0");

var $3rRlW = parcelRequire("3rRlW");

var $bqHtj = parcelRequire("bqHtj");

var $bi4Rc = parcelRequire("bi4Rc");

var $fCWsz = parcelRequire("fCWsz");

var $gOWcZ = parcelRequire("gOWcZ");

var $JbtjS = parcelRequire("JbtjS");

var $amor0 = parcelRequire("amor0");

var $bGYYb = parcelRequire("bGYYb");
const $8ba5f5277d08f85b$export$2db686be056cb923 = ({ config: options, api: api })=>{
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const primaryToolbarComponent = ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing, toolbarSize: toolbarSize, disabled: disabled })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $amor0.PrimaryToolbarComponent), {
            api: api,
            popupsMountPoint: popupsMountPoint,
            popupsScrollableElement: popupsScrollableElement,
            toolbarSize: toolbarSize,
            isReducedSpacing: isToolbarReducedSpacing,
            editorView: editorView,
            disabled: disabled,
            shouldUseResponsiveToolbar: Boolean(options?.responsiveToolbarMenu)
        });
    };
    if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $bGYYb.getToolbarComponents)(api));
    else api?.primaryToolbar?.actions.registerComponent({
        name: 'textFormatting',
        component: primaryToolbarComponent
    });
    return {
        name: 'textFormatting',
        marks () {
            return [
                {
                    name: 'em',
                    mark: (0, $eonww.em)
                },
                {
                    name: 'strong',
                    mark: (0, $YKDO7.strong)
                }
            ].concat(options?.disableStrikethrough ? [] : {
                name: 'strike',
                mark: (0, $f4V9T.strike)
            }).concat(options?.disableCode ? [] : {
                name: 'code',
                mark: (0, $eA6GD.code)
            }).concat(options?.disableSuperscriptAndSubscript ? [] : {
                name: 'subsup',
                mark: (0, $hI6rl.subsup)
            }).concat(options?.disableUnderline ? [] : {
                name: 'underline',
                mark: (0, $b7o0x.underline)
            });
        },
        pmPlugins () {
            return [
                {
                    name: 'textFormatting',
                    plugin: ({ dispatch: dispatch })=>(0, $bi4Rc.plugin)(dispatch, api?.analytics?.actions)
                },
                {
                    name: 'textFormattingCursor',
                    plugin: ()=>(0, $baCX0.default)
                },
                {
                    name: 'textFormattingInputRule',
                    plugin: ({ schema: schema })=>(0, $3rRlW.default)(schema, api?.analytics?.actions, api)
                },
                {
                    name: 'textFormattingSmartRule',
                    plugin: ()=>!options?.disableSmartTextCompletion ? (0, $gOWcZ.default)(api?.analytics?.actions) : undefined
                },
                {
                    name: 'textFormattingClear',
                    plugin: ({ dispatch: dispatch })=>(0, $HNwmP.plugin)(dispatch)
                },
                {
                    name: 'textFormattingClearKeymap',
                    plugin: ()=>(0, $8Qk18.default)(api?.analytics?.actions)
                },
                {
                    name: 'textFormattingKeymap',
                    plugin: ({ schema: schema })=>(0, $bqHtj.default)(schema, api?.analytics?.actions)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const textFormattingState = (0, $fCWsz.pluginKey).getState(editorState);
            return {
                ...textFormattingState,
                formattingIsPresent: (0, $HNwmP.pluginKey).getState(editorState)?.formattingIsPresent,
                isInitialised: !!textFormattingState?.isInitialised
            };
        },
        pluginsOptions: isToolbarAIFCEnabled ? {} : {
            selectionToolbar: ()=>{
                const toolbarDocking = (0, $eGOwo.fg)('platform_editor_use_preferences_plugin') ? api?.userPreferences?.sharedState.currentState()?.preferences?.toolbarDockingPosition : api?.selectionToolbar?.sharedState?.currentState()?.toolbarDocking;
                if (toolbarDocking === 'none' && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1', {
                    exposure: true
                })) {
                    const toolbarCustom = {
                        type: 'custom',
                        render: (view)=>{
                            if (!view) return;
                            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $JbtjS.FloatingToolbarTextFormalWithIntl), {
                                api: api,
                                editorView: view,
                                editorAnalyticsAPI: api?.analytics?.actions
                            });
                        },
                        fallback: []
                    };
                    return {
                        isToolbarAbove: true,
                        items: [
                            toolbarCustom
                        ],
                        rank: 7,
                        pluginName: 'textFormatting'
                    };
                } else return undefined;
            }
        },
        primaryToolbarComponent: !api?.primaryToolbar && !isToolbarAIFCEnabled ? primaryToolbarComponent : undefined,
        commands: {
            toggleSuperscript: (0, $fYXDG.toggleSuperscriptWithAnalytics)(api?.analytics?.actions),
            toggleSubscript: (0, $fYXDG.toggleSubscriptWithAnalytics)(api?.analytics?.actions),
            toggleStrike: (0, $fYXDG.toggleStrikeWithAnalytics)(api?.analytics?.actions),
            toggleCode: (0, $fYXDG.toggleCodeWithAnalytics)(api?.analytics?.actions),
            toggleUnderline: (0, $fYXDG.toggleUnderlineWithAnalytics)(api?.analytics?.actions),
            toggleEm: (0, $fYXDG.toggleEmWithAnalytics)(api?.analytics?.actions),
            toggleStrong: (0, $fYXDG.toggleStrongWithAnalytics)(api?.analytics?.actions)
        }
    };
};

});
parcelRegister("fYXDG", function(module, exports) {
$parcel$export(module.exports, "toggleEmWithAnalytics", () => $49b652b10cb3c3c6$export$fe8278eb0d365433);
$parcel$export(module.exports, "toggleStrikeWithAnalytics", () => $49b652b10cb3c3c6$export$f08ef336cb688397);
$parcel$export(module.exports, "toggleStrongWithAnalytics", () => $49b652b10cb3c3c6$export$686bc7c29753e27);
$parcel$export(module.exports, "toggleUnderlineWithAnalytics", () => $49b652b10cb3c3c6$export$bf3c86b5abdb857d);
$parcel$export(module.exports, "toggleSuperscriptWithAnalytics", () => $49b652b10cb3c3c6$export$ca1c98793b67ba6b);
$parcel$export(module.exports, "toggleSubscriptWithAnalytics", () => $49b652b10cb3c3c6$export$8d0c92ae27a193);
$parcel$export(module.exports, "toggleCodeWithAnalytics", () => $49b652b10cb3c3c6$export$2d4f5a54f840ba91);

var $bMFKb = parcelRequire("bMFKb");

var $66R0y = parcelRequire("66R0y");

var $ftDml = parcelRequire("ftDml");
const $49b652b10cb3c3c6$export$3032060d929f850a = ({ tr: tr })=>{
    const { em: em } = tr.doc.type.schema.marks;
    if (!em) // No transaction to apply
    return null;
    return (0, $66R0y.toggleMark)(em)({
        tr: tr
    });
};
const $49b652b10cb3c3c6$export$fe8278eb0d365433 = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $49b652b10cb3c3c6$export$3032060d929f850a({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $bMFKb.ACTION).FORMATTED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_ITALIC,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $49b652b10cb3c3c6$export$2670450dfa0f0caf = ({ tr: tr })=>{
    const { strike: strike } = tr.doc.type.schema.marks;
    if (!strike) // No transaction to apply
    return null;
    return (0, $66R0y.toggleMark)(strike)({
        tr: tr
    });
};
const $49b652b10cb3c3c6$export$f08ef336cb688397 = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $49b652b10cb3c3c6$export$2670450dfa0f0caf({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $bMFKb.ACTION).FORMATTED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_STRIKE,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $49b652b10cb3c3c6$export$52f111485e4791e7 = ({ tr: tr })=>{
    const { strong: strong } = tr.doc.type.schema.marks;
    if (!strong) // No transaction to apply
    return null;
    return (0, $66R0y.toggleMark)(strong)({
        tr: tr
    });
};
const $49b652b10cb3c3c6$export$686bc7c29753e27 = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $49b652b10cb3c3c6$export$52f111485e4791e7({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $bMFKb.ACTION).FORMATTED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_STRONG,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $49b652b10cb3c3c6$export$6bcc93697958b66d = ({ tr: tr })=>{
    const { underline: underline } = tr.doc.type.schema.marks;
    if (!underline) // No transaction to apply
    return null;
    return (0, $66R0y.toggleMark)(underline)({
        tr: tr
    });
};
const $49b652b10cb3c3c6$export$bf3c86b5abdb857d = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $49b652b10cb3c3c6$export$6bcc93697958b66d({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $bMFKb.ACTION).FORMATTED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_UNDERLINE,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $49b652b10cb3c3c6$export$4af6b58e12324fd = ({ tr: tr })=>{
    const { subsup: subsup } = tr.doc.type.schema.marks;
    if (!subsup) // No transaction to apply
    return null;
    return (0, $66R0y.toggleMark)(subsup, {
        type: 'sup'
    })({
        tr: tr
    });
};
const $49b652b10cb3c3c6$export$ca1c98793b67ba6b = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $49b652b10cb3c3c6$export$4af6b58e12324fd({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $bMFKb.ACTION).FORMATTED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_SUPER,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $49b652b10cb3c3c6$export$d26ab98fee0c804 = ({ tr: tr })=>{
    const { subsup: subsup } = tr.doc.type.schema.marks;
    if (!subsup) // No transaction to apply
    return null;
    return (0, $66R0y.toggleMark)(subsup, {
        type: 'sub'
    })({
        tr: tr
    });
};
const $49b652b10cb3c3c6$export$8d0c92ae27a193 = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $49b652b10cb3c3c6$export$d26ab98fee0c804({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $bMFKb.ACTION).FORMATTED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_SUB,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $49b652b10cb3c3c6$export$70686c6e7e15ed46 = ({ api: api })=>({ tr: tr })=>{
        const { code: code } = tr.doc.type.schema.marks;
        if (!code) // No transaction to apply
        return null;
        return (0, $ftDml.nextToggleMark)(code, api)({
            tr: tr
        });
    };
const $49b652b10cb3c3c6$export$2d4f5a54f840ba91 = (editorAnalyticsApi, api)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $49b652b10cb3c3c6$export$70686c6e7e15ed46({
                api: api
            })({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $bMFKb.ACTION).FORMATTED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_CODE,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };

});
parcelRegister("ftDml", function(module, exports) {
$parcel$export(module.exports, "nextToggleMark", () => $47543af6a7342712$export$21e1076136e25038);

var $66R0y = parcelRequire("66R0y");

var $3lIcL = parcelRequire("3lIcL");

var $cwzAY = parcelRequire("cwzAY");

var $eGOwo = parcelRequire("eGOwo");
const $47543af6a7342712$export$21e1076136e25038 = (markType, api, // eslint-disable-next-line @typescript-eslint/no-explicit-any
attrs)=>({ tr: tr })=>{
        const mark = markType.create(attrs);
        // For cursor selections we can use the default behaviour.
        if (tr.selection instanceof (0, $3lIcL.TextSelection) && tr.selection.$cursor) {
            if (mark.isInSet(tr.storedMarks || tr.selection.$cursor.marks())) tr.removeStoredMark(mark);
            else tr.addStoredMark(mark);
            return tr;
        }
        return $47543af6a7342712$var$nextToggleMarkInRange(mark, api)({
            tr: tr
        });
    };
const $47543af6a7342712$var$nextToggleMarkInRange = (mark, api)=>({ tr: tr })=>{
        if (tr.selection instanceof (0, $cwzAY.CellSelection)) {
            let removeMark = true;
            const cells = [];
            tr.selection.forEachCell((cell, cellPos)=>{
                cells.push({
                    node: cell,
                    pos: cellPos
                });
                const from = cellPos;
                const to = cellPos + cell.nodeSize;
                removeMark && (removeMark = (0, $66R0y.entireSelectionContainsMark)(mark, tr.doc, from, to));
            });
            for(let i = cells.length - 1; i >= 0; i--){
                const cell = cells[i];
                const from = cell.pos;
                const to = from + cell.node.nodeSize;
                $47543af6a7342712$export$2b94ea0e39917015(from, to, removeMark, mark, tr, api);
            }
        } else {
            const { $from: $from, $to: $to } = tr.selection;
            // We decide to remove the mark only if the entire selection contains the mark
            // Examples with *bold* text
            // Scenario 1: Selection contains both bold and non-bold text -> bold entire selection
            // Scenario 2: Selection contains only bold text -> un-bold entire selection
            // Scenario 3: Selection contains no bold text -> bold entire selection
            const removeMark = (0, $66R0y.entireSelectionContainsMark)(mark, tr.doc, $from.pos, $to.pos);
            $47543af6a7342712$export$2b94ea0e39917015($from.pos, $to.pos, removeMark, mark, tr, api);
        }
        if (tr.docChanged) return tr;
        return null;
    };
const $47543af6a7342712$export$2b94ea0e39917015 = (from, to, removeMark, mark, tr, api)=>{
    const { schema: schema } = tr.doc.type;
    const { code: code } = schema.marks;
    if (mark.type === code) {
        if ((0, $eGOwo.fg)('platform_editor_resolve_marks')) api?.base?.actions.resolveMarks(from, to, tr);
        else (0, $66R0y.transformNonTextNodesToText)(from, to, tr);
    }
    /**
	 * We should refactor this so text formatting doesn't reference plugins it doesn't know about.
	 */ tr.doc.nodesBetween(tr.mapping.map(from), tr.mapping.map(to), (node, pos)=>{
        if ((0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes')) {
            if (!node.isText) {
                const isAllowedInlineNode = [
                    'emoji',
                    'status',
                    'date',
                    'mention',
                    'inlineCard'
                ].includes(node.type.name);
                if (!isAllowedInlineNode) return true;
            }
        } else {
            if (!node.isText) return true;
        }
        // This is an issue when the user selects some text.
        // We need to check if the current node position is less than the range selection from.
        // If it’s true, that means we should apply the mark using the range selection,
        // not the current node position.
        const nodeBetweenFrom = Math.max(pos, tr.mapping.map(from));
        const nodeBetweenTo = Math.min(pos + node.nodeSize, tr.mapping.map(to));
        if (removeMark) tr.removeMark(nodeBetweenFrom, nodeBetweenTo, mark);
        else tr.addMark(nodeBetweenFrom, nodeBetweenTo, mark);
        return true;
    });
    return tr;
};

});


parcelRegister("HNwmP", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $9e05324e2c6739f3$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "plugin", () => $9e05324e2c6739f3$export$ca524d3785e2543);

var $i8KtF = parcelRequire("i8KtF");

var $3lIcL = parcelRequire("3lIcL");

var $7Dx2R = parcelRequire("7Dx2R");
const $9e05324e2c6739f3$export$18d4026d1ea86bb1 = new (0, $3lIcL.PluginKey)('clearFormattingPlugin');
const $9e05324e2c6739f3$export$ca524d3785e2543 = (dispatch)=>new (0, $i8KtF.SafePlugin)({
        state: {
            init (_config, state) {
                return {
                    formattingIsPresent: (0, $7Dx2R.checkFormattingIsPresent)(state)
                };
            },
            apply (_tr, pluginState, _oldState, newState) {
                const formattingIsPresent = (0, $7Dx2R.checkFormattingIsPresent)(newState);
                if (formattingIsPresent !== pluginState.formattingIsPresent) {
                    dispatch($9e05324e2c6739f3$export$18d4026d1ea86bb1, {
                        formattingIsPresent: formattingIsPresent
                    });
                    return {
                        formattingIsPresent: formattingIsPresent
                    };
                }
                return pluginState;
            }
        },
        key: $9e05324e2c6739f3$export$18d4026d1ea86bb1
    });

});
parcelRegister("7Dx2R", function(module, exports) {
$parcel$export(module.exports, "hasCode", () => $10fe3bfcb7d6f9f5$export$435b7561880b778c);
$parcel$export(module.exports, "markActive", () => $10fe3bfcb7d6f9f5$export$c91f8b3cbd625635);
$parcel$export(module.exports, "checkFormattingIsPresent", () => $10fe3bfcb7d6f9f5$export$4b48a1fc423972ea);
$parcel$export(module.exports, "compareItemsArrays", () => $10fe3bfcb7d6f9f5$export$53d327693050b221);
$parcel$export(module.exports, "isArrayContainsContent", () => $10fe3bfcb7d6f9f5$export$f8f79f933a3fce55);

var $02q9c = parcelRequire("02q9c");

var $2yLcK = parcelRequire("2yLcK");
const $10fe3bfcb7d6f9f5$export$435b7561880b778c = (state, pos)=>{
    const { code: code } = state.schema.marks;
    const node = pos >= 0 && state.doc.nodeAt(pos);
    if (node) return !!node.marks.filter((mark)=>mark.type === code).length;
    return false;
};
const $10fe3bfcb7d6f9f5$export$c91f8b3cbd625635 = (state, mark)=>{
    const { from: from, to: to, empty: empty } = state.selection;
    // When the selection is empty, only the active marks apply.
    if (empty) return !!mark.isInSet(state.tr.storedMarks || state.selection.$from.marks());
    // For a non-collapsed selection, the marks on the nodes matter.
    let found = false;
    state.doc.nodesBetween(from, to, (node)=>{
        found = found || mark.isInSet(node.marks);
    });
    return found;
};
const $10fe3bfcb7d6f9f5$var$blockStylingIsPresent = (state)=>{
    const { from: from, to: to } = state.selection;
    let isBlockStyling = false;
    state.doc.nodesBetween(from, to, (node)=>{
        if ((0, $2yLcK.FORMATTING_NODE_TYPES).indexOf(node.type.name) !== -1) {
            isBlockStyling = true;
            return false;
        }
        return true;
    });
    return isBlockStyling;
};
const $10fe3bfcb7d6f9f5$var$marksArePresent = (state)=>{
    const activeMarkTypes = (0, $2yLcK.FORMATTING_MARK_TYPES).filter((mark)=>{
        if (!!state.schema.marks[mark]) {
            const { $from: $from, empty: empty } = state.selection;
            const { marks: marks } = state.schema;
            if (empty) return !!marks[mark].isInSet(state.storedMarks || $from.marks());
            return (0, $02q9c.anyMarkActive)(state, marks[mark]);
        }
        return false;
    });
    return activeMarkTypes.length > 0;
};
const $10fe3bfcb7d6f9f5$export$4b48a1fc423972ea = (state)=>{
    return $10fe3bfcb7d6f9f5$var$marksArePresent(state) || $10fe3bfcb7d6f9f5$var$blockStylingIsPresent(state);
};
const $10fe3bfcb7d6f9f5$export$53d327693050b221 = (items, prevItems)=>{
    return items && items.filter((item)=>!prevItems.includes(item));
};
const $10fe3bfcb7d6f9f5$export$f8f79f933a3fce55 = (items, content)=>items.filter((item)=>item.content === content).length > 0;

});
parcelRegister("2yLcK", function(module, exports) {
$parcel$export(module.exports, "FORMATTING_NODE_TYPES", () => $477ddd36d0f3eeb3$export$a5cb0c20bd02ce0c);
$parcel$export(module.exports, "FORMATTING_MARK_TYPES", () => $477ddd36d0f3eeb3$export$73b50f8f13648c71);
$parcel$export(module.exports, "clearFormattingWithAnalytics", () => $477ddd36d0f3eeb3$export$332a1f720fc2ba0);
$parcel$export(module.exports, "clearFormattingWithAnalyticsNext", () => $477ddd36d0f3eeb3$export$38c6848f9e966bd5);

var $bMFKb = parcelRequire("bMFKb");

var $lzEKq = parcelRequire("lzEKq");

var $cwzAY = parcelRequire("cwzAY");

var $11Mxj = parcelRequire("11Mxj");
const $477ddd36d0f3eeb3$export$a5cb0c20bd02ce0c = [
    'heading',
    'blockquote'
];
const $477ddd36d0f3eeb3$export$73b50f8f13648c71 = [
    'em',
    'code',
    'strike',
    'strong',
    'underline',
    'textColor',
    'subsup',
    'backgroundColor'
];
const $477ddd36d0f3eeb3$var$formatTypes = {
    em: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_ITALIC,
    code: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_CODE,
    strike: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_STRIKE,
    strong: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_STRONG,
    underline: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_UNDERLINE,
    textColor: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_COLOR,
    subsup: 'subsup',
    backgroundColor: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_BACKGROUND_COLOR
};
function $477ddd36d0f3eeb3$export$332a1f720fc2ba0(inputMethod, editorAnalyticsAPI) {
    return $477ddd36d0f3eeb3$export$195de5d8e201efd7(inputMethod, editorAnalyticsAPI);
}
const $477ddd36d0f3eeb3$var$clearNodeFormattingOnSelectionNext = (schema, tr, formattedNodeType, nodeName, formattingCleared)=>{
    return function(node, pos) {
        if (node.type === formattedNodeType) {
            if (formattedNodeType.isTextblock) {
                tr.setNodeMarkup(pos, schema.nodes.paragraph);
                formattingCleared.push(nodeName);
                return false;
            } else {
                // In case of panel or blockquote
                const fromPos = tr.doc.resolve(pos + 1);
                const toPos = tr.doc.resolve(pos + node.nodeSize - 1);
                const nodeRange = fromPos.blockRange(toPos);
                if (nodeRange) {
                    const targetLiftDepth = (0, $lzEKq.liftTarget)(nodeRange);
                    if (targetLiftDepth || targetLiftDepth === 0) {
                        formattingCleared.push(nodeName);
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        tr.lift(nodeRange, targetLiftDepth);
                    }
                }
            }
        }
        return true;
    };
};
function $477ddd36d0f3eeb3$var$clearNodeFormattingOnSelection(state, tr, formattedNodeType, nodeName, formattingCleared) {
    return function(node, pos) {
        if (node.type === formattedNodeType) {
            if (formattedNodeType.isTextblock) {
                tr.setNodeMarkup(pos, state.schema.nodes.paragraph);
                formattingCleared.push(nodeName);
                return false;
            } else {
                // In case of panel or blockquote
                const fromPos = tr.doc.resolve(pos + 1);
                const toPos = tr.doc.resolve(pos + node.nodeSize - 1);
                const nodeRange = fromPos.blockRange(toPos);
                if (nodeRange) {
                    const targetLiftDepth = (0, $lzEKq.liftTarget)(nodeRange);
                    if (targetLiftDepth || targetLiftDepth === 0) {
                        formattingCleared.push(nodeName);
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        tr.lift(nodeRange, targetLiftDepth);
                    }
                }
            }
        }
        return true;
    };
}
function $477ddd36d0f3eeb3$export$195de5d8e201efd7(inputMethod, editorAnalyticsAPI) {
    return function(state, dispatch) {
        const { tr: tr } = state;
        const formattingCleared = [];
        $477ddd36d0f3eeb3$export$73b50f8f13648c71.forEach((mark)=>{
            const { from: from, to: to } = tr.selection;
            const markType = state.schema.marks[mark];
            if (!markType) return;
            if (tr.selection instanceof (0, $cwzAY.CellSelection)) (0, $11Mxj.cellSelectionNodesBetween)(tr.selection, tr.doc, (node, pos)=>{
                const isTableCell = node.type === state.schema.nodes.tableCell || node.type === state.schema.nodes.tableHeader;
                if (!isTableCell) return true;
                if (tr.doc.rangeHasMark(pos, pos + node.nodeSize, markType)) {
                    formattingCleared.push($477ddd36d0f3eeb3$var$formatTypes[mark]);
                    tr.removeMark(pos, pos + node.nodeSize, markType);
                }
                return false;
            });
            else if (tr.doc.rangeHasMark(from, to, markType)) {
                formattingCleared.push($477ddd36d0f3eeb3$var$formatTypes[mark]);
                tr.removeMark(from, to, markType);
            }
        });
        $477ddd36d0f3eeb3$export$a5cb0c20bd02ce0c.forEach((nodeName)=>{
            const formattedNodeType = state.schema.nodes[nodeName];
            const { $from: $from, $to: $to } = tr.selection;
            if (tr.selection instanceof (0, $cwzAY.CellSelection)) (0, $11Mxj.cellSelectionNodesBetween)(tr.selection, tr.doc, $477ddd36d0f3eeb3$var$clearNodeFormattingOnSelection(state, tr, formattedNodeType, nodeName, formattingCleared));
            else tr.doc.nodesBetween($from.pos, $to.pos, $477ddd36d0f3eeb3$var$clearNodeFormattingOnSelection(state, tr, formattedNodeType, nodeName, formattingCleared));
        });
        tr.setStoredMarks([]);
        if (formattingCleared.length && inputMethod) editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $bMFKb.ACTION).FORMATTED,
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
            actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_CLEAR,
            attributes: {
                inputMethod: inputMethod,
                formattingCleared: formattingCleared,
                dropdownMenu: inputMethod === (0, $bMFKb.INPUT_METHOD).TOOLBAR || inputMethod === (0, $bMFKb.INPUT_METHOD).FLOATING_TB ? 'textFormatting' : undefined
            }
        })(tr);
        if (dispatch) dispatch(tr);
        return true;
    };
}
const $477ddd36d0f3eeb3$export$38c6848f9e966bd5 = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const formattingCleared = [];
            const { schema: schema } = tr.doc.type;
            $477ddd36d0f3eeb3$export$73b50f8f13648c71.forEach((mark)=>{
                const { from: from, to: to } = tr.selection;
                const markType = schema.marks[mark];
                if (!markType) return;
                if (tr.selection instanceof (0, $cwzAY.CellSelection)) (0, $11Mxj.cellSelectionNodesBetween)(tr.selection, tr.doc, (node, pos)=>{
                    const isTableCell = node.type === tr.doc.type.schema.nodes.tableCell || node.type === schema.nodes.tableHeader;
                    if (!isTableCell) return true;
                    if (tr.doc.rangeHasMark(pos, pos + node.nodeSize, markType)) {
                        formattingCleared.push($477ddd36d0f3eeb3$var$formatTypes[mark]);
                        tr.removeMark(pos, pos + node.nodeSize, markType);
                    }
                    return false;
                });
                else if (tr.doc.rangeHasMark(from, to, markType)) {
                    formattingCleared.push($477ddd36d0f3eeb3$var$formatTypes[mark]);
                    tr.removeMark(from, to, markType);
                }
            });
            $477ddd36d0f3eeb3$export$a5cb0c20bd02ce0c.forEach((nodeName)=>{
                const formattedNodeType = schema.nodes[nodeName];
                const { $from: $from, $to: $to } = tr.selection;
                if (tr.selection instanceof (0, $cwzAY.CellSelection)) (0, $11Mxj.cellSelectionNodesBetween)(tr.selection, tr.doc, $477ddd36d0f3eeb3$var$clearNodeFormattingOnSelectionNext(schema, tr, formattedNodeType, nodeName, formattingCleared));
                else tr.doc.nodesBetween($from.pos, $to.pos, $477ddd36d0f3eeb3$var$clearNodeFormattingOnSelectionNext(schema, tr, formattedNodeType, nodeName, formattingCleared));
            });
            tr.setStoredMarks([]);
            if (formattingCleared.length && inputMethod) editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $bMFKb.ACTION).FORMATTED,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_CLEAR,
                attributes: {
                    inputMethod: inputMethod,
                    formattingCleared: formattingCleared,
                    dropdownMenu: inputMethod === (0, $bMFKb.INPUT_METHOD).TOOLBAR || inputMethod === (0, $bMFKb.INPUT_METHOD).FLOATING_TB ? 'textFormatting' : undefined
                }
            })(tr);
            return tr;
        };

});
parcelRegister("11Mxj", function(module, exports) {
$parcel$export(module.exports, "cellSelectionNodesBetween", () => $715bee50a29894cb$export$bd443c1dba3019b8);
const $715bee50a29894cb$export$bd443c1dba3019b8 = (selection, doc, f, startPos)=>{
    selection.forEachCell((cell, cellPos)=>{
        doc.nodesBetween(cellPos, cellPos + cell.nodeSize, f, startPos);
    });
};

});




parcelRegister("8Qk18", function(module, exports) {
$parcel$export(module.exports, "default", () => $6bbe19b9856f1b04$export$2e2bcd8739ae039);

var $bMFKb = parcelRequire("bMFKb");

var $6Exgk = parcelRequire("6Exgk");

var $x7sgX = parcelRequire("x7sgX");

var $cbSL1 = parcelRequire("cbSL1");

var $2yLcK = parcelRequire("2yLcK");
function $6bbe19b9856f1b04$export$e832373cff8dec22(editorAnalyticsAPI) {
    const list = {};
    (0, $6Exgk.bindKeymapWithEditorCommand)((0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $6Exgk.findShortcutByKeymap)((0, $6Exgk.clearFormatting)) : (0, $6Exgk.clearFormatting).common, (0, $2yLcK.clearFormattingWithAnalyticsNext)(editorAnalyticsAPI)((0, $bMFKb.INPUT_METHOD).SHORTCUT), list);
    return (0, $x7sgX.keymap)(list);
}
var $6bbe19b9856f1b04$export$2e2bcd8739ae039 = $6bbe19b9856f1b04$export$e832373cff8dec22;

});

parcelRegister("baCX0", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc2c8901551d3c2d$export$2e2bcd8739ae039);

var $i8KtF = parcelRequire("i8KtF");

var $3lIcL = parcelRequire("3lIcL");
var // eslint-disable-next-line import/no-anonymous-default-export
$cc2c8901551d3c2d$export$2e2bcd8739ae039 = new (0, $i8KtF.SafePlugin)({
    props: {
        handleClick (view, clickPos, event) {
            // Don't apply in Edge as per ED-4546
            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            if (navigator && /Edge\/\d/.test(navigator.userAgent)) return false;
            // @see ED-6231
            if (clickPos > view.state.doc.content.size) return false;
            const { code: code } = view.state.schema.marks;
            const { paragraph: paragraph } = view.state.schema.nodes;
            const $click = view.state.doc.resolve(clickPos);
            const clickWasAtEdgeOfATextNode = ($click.nodeBefore ? $click.nodeBefore.isInline : $click.nodeAfter) && ($click.nodeAfter ? $click.nodeAfter.isInline : $click.nodeBefore) && $click.textOffset === 0;
            const clickWasNearACodeMark = code && ($click.nodeBefore && code.isInSet($click.nodeBefore.marks) || $click.nodeAfter && code.isInSet($click.nodeAfter.marks));
            // Find the starting position of the clicked dom-element
            // TODO: ED-26962 - Remove calls to private API
            const clickedDOMElementPosition = event.target && event.target instanceof Node && view.posAtDOM(event.target);
            const clickNode = view.state.doc.nodeAt(clickPos);
            const clickWasAtTextNode = !!(clickNode && clickNode.isText);
            const clickWasAtEndOfAParagraphNode = $click.parent.type === paragraph && $click.textOffset === 0 && $click.nodeAfter === null;
            if (clickWasAtEdgeOfATextNode && clickWasNearACodeMark && clickedDOMElementPosition && // if click did not occur at a text node or end of paragraph, then
            // it was at a directly adjacent non-text node, so we skip this manual
            // text selection logic to preserve that non-text node's selection
            (clickWasAtTextNode || clickWasAtEndOfAParagraphNode)) {
                const clickWasInsideNodeDOM = event.target.parentNode === view.domAtPos(clickedDOMElementPosition).node && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                code.isInSet(view.state.doc.resolve(clickedDOMElementPosition).nodeAfter.marks);
                const nodeNextToClick = $click.nodeBefore && code.isInSet($click.nodeBefore.marks) ? $click.nodeAfter : $click.nodeBefore;
                // Need to set the selection here to allow clicking between [code('text'),{<>},emoji()]
                const tr = view.state.tr.setSelection((0, $3lIcL.TextSelection).near($click));
                if (clickWasInsideNodeDOM) tr.setStoredMarks([
                    code.create()
                ]);
                else tr.setStoredMarks(nodeNextToClick ? nodeNextToClick.marks : []);
                view.dispatch(tr);
                return true;
            }
            return false;
        }
    }
});

});

parcelRegister("3rRlW", function(module, exports) {
$parcel$export(module.exports, "default", () => $453d9aa3ca49e6e9$export$2e2bcd8739ae039);

var $bMFKb = parcelRequire("bMFKb");

var $66R0y = parcelRequire("66R0y");

var $i8KtF = parcelRequire("i8KtF");

var $leZY6 = parcelRequire("leZY6");

var $eGOwo = parcelRequire("eGOwo");

var $jCfsG = parcelRequire("jCfsG");
var $82vn7 = parcelRequire("82vn7");

var $cbSL1 = parcelRequire("cbSL1");
var $453d9aa3ca49e6e9$var$ValidAutoformatChars = /*#__PURE__*/ function(ValidAutoformatChars) {
    ValidAutoformatChars["STRONG"] = "__";
    ValidAutoformatChars["STRIKE"] = "~~";
    ValidAutoformatChars["STRONG_MARKDOWN"] = "**";
    ValidAutoformatChars["ITALIC_MARKDOWN"] = "*";
    ValidAutoformatChars["ITALIC"] = "_";
    ValidAutoformatChars["CODE"] = "`";
    return ValidAutoformatChars;
}($453d9aa3ca49e6e9$var$ValidAutoformatChars || {});
const $453d9aa3ca49e6e9$export$ab511c819612d3bc = {
    ["~~"]: [
        "_",
        "__",
        "**",
        "*"
    ],
    ["__"]: [
        "~~",
        "*"
    ],
    ["**"]: [
        "_",
        "~~"
    ],
    ["*"]: [
        "~~",
        "__"
    ],
    ["_"]: [
        "~~",
        "**"
    ],
    ["`"]: [
        // e.g: loko (`some code`
        '( '
    ]
};
function $453d9aa3ca49e6e9$var$addMark(markType, _schema, char, api) {
    return (state, _match, start, end)=>{
        const { doc: doc, schema: schema, tr: tr } = state;
        const textPrefix = state.doc.textBetween(start, start + char.length);
        // fixes the following case: my `*name` is *
        // expected result: should ignore special characters inside "code"
        if (textPrefix !== char || schema?.marks?.code?.isInSet(doc.resolve(start + 1).marks())) {
            if (!(0, $cbSL1.expValEquals)('platform_editor_lovability_inline_code', 'isEnabled', true)) return null;
            // if the prefix is not a character but the suffix is, continue
            const suffix = state.doc.textBetween(end - char.length, end);
            if (suffix !== char) return null;
        }
        // Prevent autoformatting across hardbreaks
        let containsHardBreak;
        doc.nodesBetween(start, end, (node)=>{
            if (node.type === schema.nodes.hardBreak) {
                containsHardBreak = true;
                return false;
            }
            return !containsHardBreak;
        });
        if (containsHardBreak) return null;
        // fixes autoformatting in heading nodes: # Heading *bold*
        // expected result: should not autoformat *bold*; <h1>Heading *bold*</h1>
        const startPosResolved = doc.resolve(start);
        const endPosResolved = doc.resolve(end);
        if (startPosResolved.sameParent(endPosResolved) && !startPosResolved.parent.type.allowsMarkType(markType)) return null;
        if (markType.name === 'code') {
            if ((0, $eGOwo.fg)('platform_editor_resolve_marks')) api?.base?.actions?.resolveMarks(tr.mapping.map(start), tr.mapping.map(end), tr);
            else (0, $66R0y.transformNonTextNodesToText)(tr.mapping.map(start), tr.mapping.map(end), tr);
        }
        const mappedStart = tr.mapping.map(start);
        const mappedEnd = tr.mapping.map(end);
        tr.addMark(mappedStart, mappedEnd, markType.create());
        const textSuffix = tr.doc.textBetween(mappedEnd - char.length, mappedEnd);
        if (textSuffix === char) tr.delete(mappedEnd - char.length, mappedEnd);
        if (textPrefix === char) tr.delete(mappedStart, mappedStart + char.length);
        return tr.removeStoredMark(markType);
    };
}
class $453d9aa3ca49e6e9$var$ReverseRegexExp extends RegExp {
    exec(str) {
        if (!str) return null;
        const reverseStr = [
            ...str
        ].reverse().join('');
        const result = super.exec(reverseStr);
        if (!result) return null;
        for(let i = 0; i < result.length; i++)if (result[i] && typeof result[i] === 'string') result[i] = [
            ...result[i]
        ].reverse().join('');
        if (result.input && typeof result.input === 'string') result.input = [
            ...result.input
        ].reverse().join('');
        if (result.input && result[0]) result.index = result.input.length - result[0].length;
        return result;
    }
}
const $453d9aa3ca49e6e9$var$buildRegex = (char)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const escapedChar = char.replace(/(\W)/g, '\\$1');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const combinations = $453d9aa3ca49e6e9$export$ab511c819612d3bc[char].map((c)=>c.replace(/(\W)/g, '\\$1')).join('|');
    // Single X - https://regex101.com/r/McT3yq/14/
    // Double X - https://regex101.com/r/pQUgjx/1/
    const baseRegex = '^X(?=[^X\\s]).*?[^\\sX]X(?=[\\sOBJECT_REPLACEMENT_CHARACTER]COMBINATIONS|$)'.replace('OBJECT_REPLACEMENT_CHARACTER', (0, $82vn7.leafNodeReplacementCharacter)).replace('COMBINATIONS', combinations ? `|${combinations}` : '');
    const replacedRegex = String.prototype.hasOwnProperty('replaceAll') ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    baseRegex.replaceAll('X', escapedChar) : // eslint-disable-next-line require-unicode-regexp
    baseRegex.replace(/X/g, escapedChar);
    return new $453d9aa3ca49e6e9$var$ReverseRegexExp(replacedRegex);
};
const $453d9aa3ca49e6e9$var$buildRegexNew = (char, allowsBackwardMatch = false)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const escapedChar = char.replace(/(\W)/g, '\\$1');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const combinations = $453d9aa3ca49e6e9$export$ab511c819612d3bc[char].map((c)=>c.replace(/(\W)/g, '\\$1')).join('|');
    // Single X - https://regex101.com/r/McT3yq/14/
    // Double X - https://regex101.com/r/pQUgjx/1/
    // if backwards matches are allowed, do not prefix the regex with an anchor (^)
    const maybeAnchor = allowsBackwardMatch ? '' : '^';
    const orCombinations = combinations ? `|${combinations}` : '';
    const baseRegex = `${maybeAnchor}X(?=[^X\\s]).*?[^\\sX]X(?=[\\s${(0, $82vn7.leafNodeReplacementCharacter)}]${orCombinations}|$)`;
    const replacedRegex = String.prototype.hasOwnProperty('replaceAll') ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    baseRegex.replaceAll('X', escapedChar) : // eslint-disable-next-line require-unicode-regexp
    baseRegex.replace(/X/g, escapedChar);
    return new $453d9aa3ca49e6e9$var$ReverseRegexExp(replacedRegex);
};
const $453d9aa3ca49e6e9$export$3312a15c47701971 = $453d9aa3ca49e6e9$var$buildRegex("__");
const $453d9aa3ca49e6e9$export$b2c5e5dc4b85ebff = $453d9aa3ca49e6e9$var$buildRegex("**");
const $453d9aa3ca49e6e9$export$5293ac529581c0f9 = $453d9aa3ca49e6e9$var$buildRegex("_");
const $453d9aa3ca49e6e9$export$bef0fedfe2c8027e = $453d9aa3ca49e6e9$var$buildRegex("*");
const $453d9aa3ca49e6e9$export$6dd2d2a62884fadf = $453d9aa3ca49e6e9$var$buildRegex("~~");
const $453d9aa3ca49e6e9$export$b311ac3b6caef479 = $453d9aa3ca49e6e9$var$buildRegex("`");
const $453d9aa3ca49e6e9$export$6e92f28cddbb8b0c = $453d9aa3ca49e6e9$var$buildRegexNew("`", true);
/**
 * Create input rules for strong mark
 *
 * @param {Schema} schema
 * @returns {InputRuleWrapper[]}
 */ function $453d9aa3ca49e6e9$var$getStrongInputRules(schema, editorAnalyticsAPI) {
    const ruleWithStrongAnalytics = (0, $leZY6.inputRuleWithAnalytics)({
        action: (0, $bMFKb.ACTION).FORMATTED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_STRONG,
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $bMFKb.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    // **string** or __strong__ should bold the text
    const doubleUnderscoreRule = (0, $leZY6.createRule)($453d9aa3ca49e6e9$export$3312a15c47701971, $453d9aa3ca49e6e9$var$addMark(schema.marks.strong, schema, "__"));
    const doubleAsterixRule = (0, $leZY6.createRule)($453d9aa3ca49e6e9$export$b2c5e5dc4b85ebff, $453d9aa3ca49e6e9$var$addMark(schema.marks.strong, schema, "**"));
    return [
        ruleWithStrongAnalytics(doubleUnderscoreRule),
        ruleWithStrongAnalytics(doubleAsterixRule)
    ];
}
/**
 * Create input rules for em mark
 *
 * @param {Schema} schema
 * @returns {InputRuleWrapper[]}
 */ function $453d9aa3ca49e6e9$var$getItalicInputRules(schema, editorAnalyticsAPI) {
    const ruleWithItalicAnalytics = (0, $leZY6.inputRuleWithAnalytics)({
        action: (0, $bMFKb.ACTION).FORMATTED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_ITALIC,
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $bMFKb.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    const underscoreRule = (0, $leZY6.createRule)($453d9aa3ca49e6e9$export$5293ac529581c0f9, $453d9aa3ca49e6e9$var$addMark(schema.marks.em, schema, "_"));
    const asterixRule = (0, $leZY6.createRule)($453d9aa3ca49e6e9$export$bef0fedfe2c8027e, $453d9aa3ca49e6e9$var$addMark(schema.marks.em, schema, "*"));
    return [
        ruleWithItalicAnalytics(underscoreRule),
        ruleWithItalicAnalytics(asterixRule)
    ];
}
/**
 * Create input rules for strike mark
 *
 * @param {Schema} schema
 * @returns {InputRuleWrapper[]}
 */ function $453d9aa3ca49e6e9$var$getStrikeInputRules(schema, editorAnalyticsAPI) {
    const ruleWithStrikeAnalytics = (0, $leZY6.inputRuleWithAnalytics)({
        action: (0, $bMFKb.ACTION).FORMATTED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_STRIKE,
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $bMFKb.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    const doubleTildeRule = (0, $leZY6.createRule)($453d9aa3ca49e6e9$export$6dd2d2a62884fadf, $453d9aa3ca49e6e9$var$addMark(schema.marks.strike, schema, "~~"));
    return [
        ruleWithStrikeAnalytics(doubleTildeRule)
    ];
}
/**
 * Create input rules for code mark
 *
 * @param {Schema} schema
 * @returns {InputRuleWrapper[]}
 */ function $453d9aa3ca49e6e9$var$getCodeInputRules(schema, editorAnalyticsAPI, api) {
    const ruleWithCodeAnalytics = (0, $leZY6.inputRuleWithAnalytics)({
        action: (0, $bMFKb.ACTION).FORMATTED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_CODE,
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $bMFKb.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    const allowsBackwardMatch = (0, $cbSL1.expValEquals)('platform_editor_lovability_inline_code', 'isEnabled', true);
    const backTickRule = (0, $leZY6.createRule)(allowsBackwardMatch ? $453d9aa3ca49e6e9$export$6e92f28cddbb8b0c : $453d9aa3ca49e6e9$export$b311ac3b6caef479, $453d9aa3ca49e6e9$var$addMark(schema.marks.code, schema, "`", api), allowsBackwardMatch);
    return [
        ruleWithCodeAnalytics(backTickRule)
    ];
}
function $453d9aa3ca49e6e9$export$568a7ed6897c4817(schema, editorAnalyticsAPI, api) {
    const rules = [];
    if (schema.marks.strong) rules.push(...$453d9aa3ca49e6e9$var$getStrongInputRules(schema, editorAnalyticsAPI));
    if (schema.marks.em) rules.push(...$453d9aa3ca49e6e9$var$getItalicInputRules(schema, editorAnalyticsAPI));
    if (schema.marks.strike) rules.push(...$453d9aa3ca49e6e9$var$getStrikeInputRules(schema, editorAnalyticsAPI));
    if (schema.marks.code) rules.push(...$453d9aa3ca49e6e9$var$getCodeInputRules(schema, editorAnalyticsAPI, api));
    if (rules.length !== 0) return new (0, $i8KtF.SafePlugin)((0, $jCfsG.createPlugin)('text-formatting', rules));
    return;
}
var $453d9aa3ca49e6e9$export$2e2bcd8739ae039 = $453d9aa3ca49e6e9$export$568a7ed6897c4817;

});

parcelRegister("bqHtj", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9bb8b2fa53fe1c7$export$2e2bcd8739ae039);

var $bMFKb = parcelRequire("bMFKb");

var $6Exgk = parcelRequire("6Exgk");

var $i8KtF = parcelRequire("i8KtF");

var $x7sgX = parcelRequire("x7sgX");

var $cbSL1 = parcelRequire("cbSL1");

var $92xoS = parcelRequire("92xoS");

var $fYXDG = parcelRequire("fYXDG");

var $fCWsz = parcelRequire("fCWsz");
function $b9bb8b2fa53fe1c7$export$2e2bcd8739ae039(schema, editorAnalyticsAPI) {
    const list = {};
    if (schema.marks.strong) (0, $6Exgk.bindKeymapWithEditorCommand)((0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $6Exgk.findShortcutByKeymap)((0, $6Exgk.toggleBold)) : (0, $6Exgk.toggleBold).common, (0, $fYXDG.toggleStrongWithAnalytics)(editorAnalyticsAPI)((0, $bMFKb.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.em) (0, $6Exgk.bindKeymapWithEditorCommand)((0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $6Exgk.findShortcutByKeymap)((0, $6Exgk.toggleItalic)) : (0, $6Exgk.toggleItalic).common, (0, $fYXDG.toggleEmWithAnalytics)(editorAnalyticsAPI)((0, $bMFKb.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.code) (0, $6Exgk.bindKeymapWithEditorCommand)((0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $6Exgk.findShortcutByKeymap)((0, $6Exgk.toggleCode)) : (0, $6Exgk.toggleCode).common, (0, $fYXDG.toggleCodeWithAnalytics)(editorAnalyticsAPI)((0, $bMFKb.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.strike) (0, $6Exgk.bindKeymapWithEditorCommand)((0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $6Exgk.findShortcutByKeymap)((0, $6Exgk.toggleStrikethrough)) : (0, $6Exgk.toggleStrikethrough).common, (0, $fYXDG.toggleStrikeWithAnalytics)(editorAnalyticsAPI)((0, $bMFKb.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.subsup) (0, $6Exgk.bindKeymapWithEditorCommand)((0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $6Exgk.findShortcutByKeymap)((0, $6Exgk.toggleSubscript)) : (0, $6Exgk.toggleSubscript).common, (0, $fYXDG.toggleSubscriptWithAnalytics)(editorAnalyticsAPI)((0, $bMFKb.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.subsup) (0, $6Exgk.bindKeymapWithEditorCommand)((0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $6Exgk.findShortcutByKeymap)((0, $6Exgk.toggleSuperscript)) : (0, $6Exgk.toggleSuperscript).common, (0, $fYXDG.toggleSuperscriptWithAnalytics)(editorAnalyticsAPI)((0, $bMFKb.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.underline) (0, $6Exgk.bindKeymapWithEditorCommand)((0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $6Exgk.findShortcutByKeymap)((0, $6Exgk.toggleUnderline)) : (0, $6Exgk.toggleUnderline).common, (0, $fYXDG.toggleUnderlineWithAnalytics)(editorAnalyticsAPI)((0, $bMFKb.INPUT_METHOD).SHORTCUT), list);
    const getEnabledKeylist = (view)=>{
        const textFormattingState = (0, $fCWsz.pluginKey).getState(view.state);
        const list = {};
        if (schema.marks.strong && !textFormattingState?.strongDisabled) (0, $6Exgk.bindKeymapWithEditorCommand)((0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $6Exgk.findShortcutByKeymap)((0, $6Exgk.toggleBold)) : (0, $6Exgk.toggleBold).common, (0, $fYXDG.toggleStrongWithAnalytics)(editorAnalyticsAPI)((0, $bMFKb.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.em && !textFormattingState?.emDisabled) (0, $6Exgk.bindKeymapWithEditorCommand)((0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $6Exgk.findShortcutByKeymap)((0, $6Exgk.toggleItalic)) : (0, $6Exgk.toggleItalic).common, (0, $fYXDG.toggleEmWithAnalytics)(editorAnalyticsAPI)((0, $bMFKb.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.code && !textFormattingState?.codeDisabled) (0, $6Exgk.bindKeymapWithEditorCommand)((0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $6Exgk.findShortcutByKeymap)((0, $6Exgk.toggleCode)) : (0, $6Exgk.toggleCode).common, (0, $fYXDG.toggleCodeWithAnalytics)(editorAnalyticsAPI)((0, $bMFKb.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.strike && !textFormattingState?.strikeDisabled) (0, $6Exgk.bindKeymapWithEditorCommand)((0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $6Exgk.findShortcutByKeymap)((0, $6Exgk.toggleStrikethrough)) : (0, $6Exgk.toggleStrikethrough).common, (0, $fYXDG.toggleStrikeWithAnalytics)(editorAnalyticsAPI)((0, $bMFKb.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.subsup && !textFormattingState?.subscriptDisabled) (0, $6Exgk.bindKeymapWithEditorCommand)((0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $6Exgk.findShortcutByKeymap)((0, $6Exgk.toggleSubscript)) : (0, $6Exgk.toggleSubscript).common, (0, $fYXDG.toggleSubscriptWithAnalytics)(editorAnalyticsAPI)((0, $bMFKb.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.subsup && !textFormattingState?.superscriptDisabled) (0, $6Exgk.bindKeymapWithEditorCommand)((0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $6Exgk.findShortcutByKeymap)((0, $6Exgk.toggleSuperscript)) : (0, $6Exgk.toggleSuperscript).common, (0, $fYXDG.toggleSuperscriptWithAnalytics)(editorAnalyticsAPI)((0, $bMFKb.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.underline && !textFormattingState?.underlineDisabled) (0, $6Exgk.bindKeymapWithEditorCommand)((0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $6Exgk.findShortcutByKeymap)((0, $6Exgk.toggleUnderline)) : (0, $6Exgk.toggleUnderline).common, (0, $fYXDG.toggleUnderlineWithAnalytics)(editorAnalyticsAPI)((0, $bMFKb.INPUT_METHOD).SHORTCUT), list);
        return list;
    };
    return new (0, $i8KtF.SafePlugin)({
        props: {
            handleKeyDown (view, event) {
                const keyboardEvent = (0, $6Exgk.isCapsLockOnAndModifyKeyboardEvent)(event);
                const keymapList = (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? getEnabledKeylist(view) : list;
                return (0, $x7sgX.keydownHandler)(keymapList)(view, keyboardEvent);
            }
        }
    });
}

});
parcelRegister("fCWsz", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $dc2326abc496789f$export$18d4026d1ea86bb1);

var $3lIcL = parcelRequire("3lIcL");
const $dc2326abc496789f$export$18d4026d1ea86bb1 = new (0, $3lIcL.PluginKey)('textFormatting');

});


parcelRegister("bi4Rc", function(module, exports) {
$parcel$export(module.exports, "plugin", () => $4631db6b691eb897$export$ca524d3785e2543);
// TODO: ED-26962 - Ideally this should use the custom toggleMark function from @atlaskit/editor-common so we also disable the options when selecting inline nodes but it disables the marks when the selection is empty at this point in time which is undesirable
// import { toggleMark } from '@atlaskit/editor-common/mark';

var $6Exgk = parcelRequire("6Exgk");

var $02q9c = parcelRequire("02q9c");

var $i8KtF = parcelRequire("i8KtF");

var $3ADzg = parcelRequire("3ADzg");

var $dEkUJ = parcelRequire("dEkUJ");

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $cbSL1 = parcelRequire("cbSL1");

var $92xoS = parcelRequire("92xoS");

var $3PXxk = parcelRequire("3PXxk");

var $fCWsz = parcelRequire("fCWsz");
const $4631db6b691eb897$var$isSelectionInlineCursor = (selection)=>{
    if (selection instanceof (0, $3lIcL.NodeSelection)) return true;
    return false;
};
const $4631db6b691eb897$var$checkNodeSelection = (mark, editorState, type)=>{
    const selection = editorState.selection;
    if ($4631db6b691eb897$var$isSelectionInlineCursor(selection)) return false;
    return (0, $dEkUJ.toggleMark)(mark, {
        type: type
    })(editorState);
};
const $4631db6b691eb897$var$getTextFormattingState = (editorState, editorAnalyticsAPI)=>{
    const { em: em, code: code, strike: strike, strong: strong, subsup: subsup, underline: underline } = editorState.schema.marks;
    const state = {
        isInitialised: true
    };
    const showOnlyCommonMarks = (0, $cbSL1.expValEquals)('platform_editor_controls', 'cohort', 'variant1');
    if (showOnlyCommonMarks) {
        // Code marks will disable all other formatting options when they are included in a
        // selection but (for now) we do not want to make it behave differently in regards to which
        // toolbar items are highlighted on selection. We need to track code in selection seperately
        // to ensure all other formatting options are disabled appropriately.
        if (code) state.codeInSelection = (0, $02q9c.anyMarkActive)(editorState, code.create());
        const marks = [
            [
                code,
                'code'
            ],
            [
                em,
                'em'
            ],
            [
                strike,
                'strike'
            ],
            [
                strong,
                'strong'
            ],
            [
                underline,
                'underline'
            ],
            [
                subsup?.create({
                    type: 'sub'
                }),
                'subscript'
            ],
            [
                subsup?.create({
                    type: 'sup'
                }),
                'superscript'
            ]
        ].filter(([mark])=>mark);
        const marksToName = new Map(marks);
        const activeMarks = (0, $02q9c.wholeSelectionHasMarks)(editorState, Array.from(marksToName.keys()));
        for (const [mark, markName] of marks){
            const active = activeMarks.get(mark);
            if (active !== undefined) state[`${markName}Active`] = active;
            state[`${markName}Disabled`] = // Disable when code is active, except for code itself which should not be disabled
            // when code is in selection 😅
            state.codeInSelection && markName !== 'code' ? true : !$4631db6b691eb897$var$checkNodeSelection(mark instanceof (0, $3xw6l.MarkType) ? mark : mark.type, editorState);
        }
        return state;
    }
    if (code) {
        state.codeActive = (0, $02q9c.anyMarkActive)(editorState, code.create());
        state.codeDisabled = !$4631db6b691eb897$var$checkNodeSelection(code, editorState);
    }
    if (em) {
        state.emActive = (0, $02q9c.anyMarkActive)(editorState, em);
        state.emDisabled = state.codeActive ? true : !$4631db6b691eb897$var$checkNodeSelection(em, editorState);
    }
    if (strike) {
        state.strikeActive = (0, $02q9c.anyMarkActive)(editorState, strike);
        state.strikeDisabled = state.codeActive ? true : !$4631db6b691eb897$var$checkNodeSelection(strike, editorState);
    }
    if (strong) {
        state.strongActive = (0, $02q9c.anyMarkActive)(editorState, strong);
        state.strongDisabled = state.codeActive ? true : !$4631db6b691eb897$var$checkNodeSelection(strong, editorState);
    }
    if (subsup) {
        const subMark = subsup.create({
            type: 'sub'
        });
        const supMark = subsup.create({
            type: 'sup'
        });
        state.subscriptActive = (0, $02q9c.anyMarkActive)(editorState, subMark);
        state.superscriptActive = (0, $02q9c.anyMarkActive)(editorState, supMark);
        state.subscriptDisabled = state.codeActive ? true : !$4631db6b691eb897$var$checkNodeSelection(subsup, editorState, 'sub');
        state.superscriptDisabled = state.codeActive ? true : !$4631db6b691eb897$var$checkNodeSelection(subsup, editorState, 'sup');
    }
    if (underline) {
        state.underlineActive = (0, $02q9c.anyMarkActive)(editorState, underline);
        state.underlineDisabled = state.codeActive ? true : !$4631db6b691eb897$var$checkNodeSelection(underline, editorState);
    }
    return state;
};
const $4631db6b691eb897$export$ca524d3785e2543 = (dispatch, editorAnalyticsAPI)=>new (0, $i8KtF.SafePlugin)({
        state: {
            init (_config, state) {
                return $4631db6b691eb897$var$getTextFormattingState(state, editorAnalyticsAPI);
            },
            apply (_tr, pluginState, _oldState, newState) {
                const state = $4631db6b691eb897$var$getTextFormattingState(newState, editorAnalyticsAPI);
                if (!(0, $3ADzg.shallowEqual)(pluginState, state)) {
                    dispatch((0, $fCWsz.pluginKey), state);
                    return state;
                }
                return pluginState;
            }
        },
        key: (0, $fCWsz.pluginKey),
        props: {
            handleKeyDown (view, event) {
                const { state: state, dispatch: dispatch } = view;
                if (event.key === (0, $6Exgk.moveRight).common && !event.metaKey) return $3PXxk.moveRight()(state, dispatch);
                else if (event.key === (0, $6Exgk.moveLeft).common && !event.metaKey) return $3PXxk.moveLeft()(state, dispatch);
                else if (event.key === 'u' && event.metaKey && (0, $fCWsz.pluginKey).getState(state)?.underlineDisabled && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) // This is a workaround for browser behaviour with cmd+u (in Chrome only) where the underline mark being applied around the selection
                event.preventDefault();
                return false;
            },
            handleTextInput (view, from, to, text) {
                const { state: state, dispatch: dispatch } = view;
                const { schema: schema, selection: { $from: { parent: { type: parentNodeType } } } } = state;
                if (parentNodeType.allowsMarkType(schema.marks.code)) return (0, $3PXxk.createInlineCodeFromTextInputWithAnalytics)(editorAnalyticsAPI)(from, to, text)(state, dispatch);
                return false;
            }
        }
    });

});
parcelRegister("3PXxk", function(module, exports) {
$parcel$export(module.exports, "moveRight", () => $3737929cada4b864$export$e2c874fbfec7201);
$parcel$export(module.exports, "moveLeft", () => $3737929cada4b864$export$108f27160c89e515);
$parcel$export(module.exports, "createInlineCodeFromTextInputWithAnalytics", () => $3737929cada4b864$export$7a99a2b030134bb0);

var $bMFKb = parcelRequire("bMFKb");

var $asjM0 = parcelRequire("asjM0");

var $66R0y = parcelRequire("66R0y");

var $3lIcL = parcelRequire("3lIcL");

var $7Dx2R = parcelRequire("7Dx2R");
const $3737929cada4b864$export$e2c874fbfec7201 = ()=>{
    return (state, dispatch)=>{
        const { code: code } = state.schema.marks;
        const { empty: empty, $cursor: $cursor } = state.selection;
        if (!empty || !$cursor) return false;
        const { storedMarks: storedMarks } = state.tr;
        if (code) {
            const insideCode = (0, $7Dx2R.markActive)(state, code.create());
            const currentPosHasCode = state.doc.rangeHasMark($cursor.pos, $cursor.pos, code);
            const nextPosHasCode = state.doc.rangeHasMark($cursor.pos, $cursor.pos + 1, code);
            const exitingCode = !currentPosHasCode && !nextPosHasCode && (!storedMarks || !!storedMarks.length);
            const enteringCode = !currentPosHasCode && nextPosHasCode && (!storedMarks || !storedMarks.length);
            // entering code mark (from the left edge): don't move the cursor, just add the mark
            if (!insideCode && enteringCode) {
                if (dispatch) dispatch(state.tr.addStoredMark(code.create()));
                return true;
            }
            // exiting code mark: don't move the cursor, just remove the mark
            if (insideCode && exitingCode) {
                if (dispatch) dispatch(state.tr.removeStoredMark(code));
                return true;
            }
        }
        return false;
    };
};
const $3737929cada4b864$export$108f27160c89e515 = ()=>{
    return (state, dispatch)=>{
        const { code: code } = state.schema.marks;
        const { empty: empty, $cursor: $cursor } = state.selection;
        if (!empty || !$cursor) return false;
        const { storedMarks: storedMarks } = state.tr;
        if (code) {
            const insideCode = code && (0, $7Dx2R.markActive)(state, code.create());
            const currentPosHasCode = (0, $7Dx2R.hasCode)(state, $cursor.pos);
            const nextPosHasCode = (0, $7Dx2R.hasCode)(state, $cursor.pos - 1);
            const nextNextPosHasCode = (0, $7Dx2R.hasCode)(state, $cursor.pos - 2);
            const exitingCode = currentPosHasCode && !nextPosHasCode && Array.isArray(storedMarks);
            const atLeftEdge = nextPosHasCode && !nextNextPosHasCode && (storedMarks === null || Array.isArray(storedMarks) && !!storedMarks.length);
            const atRightEdge = (exitingCode && Array.isArray(storedMarks) && !storedMarks.length || !exitingCode && storedMarks === null) && !nextPosHasCode && nextNextPosHasCode;
            const enteringCode = !currentPosHasCode && nextPosHasCode && Array.isArray(storedMarks) && !storedMarks.length;
            // at the right edge: remove code mark and move the cursor to the left
            if (!insideCode && atRightEdge) {
                const tr = state.tr.setSelection((0, $3lIcL.Selection).near(state.doc.resolve($cursor.pos - 1)));
                if (dispatch) dispatch(tr.removeStoredMark(code));
                return true;
            }
            // entering code mark (from right edge): don't move the cursor, just add the mark
            if (!insideCode && enteringCode) {
                if (dispatch) dispatch(state.tr.addStoredMark(code.create()));
                return true;
            }
            // at the left edge: add code mark and move the cursor to the left
            if (insideCode && atLeftEdge) {
                const tr = state.tr.setSelection((0, $3lIcL.Selection).near(state.doc.resolve($cursor.pos - 1)));
                if (dispatch) dispatch(tr.addStoredMark(code.create()));
                return true;
            }
            // exiting code mark (or at the beginning of the line): don't move the cursor, just remove the mark
            const isFirstChild = $cursor.index($cursor.depth - 1) === 0;
            if (insideCode && (exitingCode || !$cursor.nodeBefore && isFirstChild)) {
                if (dispatch) dispatch(state.tr.removeStoredMark(code));
                return true;
            }
        }
        return false;
    };
};
const $3737929cada4b864$var$createInlineCodeFromTextInput = (from, to, text)=>{
    return (state, dispatch)=>{
        if (state.selection.empty) {
            const { nodeBefore: before } = state.doc.resolve(from);
            const { nodeAfter: after } = state.doc.resolve(to);
            const hasTickBefore = before && before.text && before.text.endsWith('`');
            const hasTickAfter = after && after.text && after.text.startsWith('`');
            if (hasTickBefore && hasTickAfter) {
                let tr = state.tr.replaceRangeWith(from - 1, to + 1, state.schema.text(text));
                if (dispatch) {
                    const codeMark = state.schema.marks.code.create();
                    tr = (0, $66R0y.applyMarkOnRange)(tr.mapping.map(from - 1), tr.mapping.map(to + 1), false, codeMark, tr).setStoredMarks([
                        codeMark
                    ]);
                    dispatch(tr);
                }
                return true;
            }
        }
        return false;
    };
};
const $3737929cada4b864$export$7a99a2b030134bb0 = (editorAnalyticsAPI)=>(from, to, text)=>{
        return (0, $asjM0.withAnalytics)(editorAnalyticsAPI, {
            action: (0, $bMFKb.ACTION).FORMATTED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
            actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_CODE,
            attributes: {
                inputMethod: (0, $bMFKb.INPUT_METHOD).FORMATTING
            }
        })($3737929cada4b864$var$createInlineCodeFromTextInput(from, to, text));
    };

});


parcelRegister("gOWcZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e74f3bcc56d8b85$export$2e2bcd8739ae039);

var $bMFKb = parcelRequire("bMFKb");
var $aGCuE = parcelRequire("aGCuE");

var $i8KtF = parcelRequire("i8KtF");

var $leZY6 = parcelRequire("leZY6");

var $3lIcL = parcelRequire("3lIcL");

var $jCfsG = parcelRequire("jCfsG");
/**
 * Creates an InputRuleHandler that will match on a regular expression of the
 * form `(prefix, content, suffix?)`, and replace it with some given text,
 * maintaining prefix and suffix around the replacement.
 *
 * @param text text to replace with
 */ function $7e74f3bcc56d8b85$var$replaceTextUsingCaptureGroup(text) {
    return (state, match, start, end)=>{
        const [, prefix, , suffix] = match;
        const replacement = text + (suffix || '');
        const { tr: tr, selection: { $to: $to } } = state;
        const startPos = start + (prefix || '').length;
        const safePos = Math.min(// I know it is almost impossible to have a negative value at this point.
        // But, this is JS #trustnoone
        Math.max(startPos, 0), end);
        tr.replaceWith(safePos, end, state.schema.text(replacement, $to.marks()));
        tr.setSelection((0, $3lIcL.Selection).near(tr.doc.resolve(tr.selection.to)));
        return tr;
    };
}
function $7e74f3bcc56d8b85$var$createReplacementRule(to, from) {
    return (0, $leZY6.createRule)(from, $7e74f3bcc56d8b85$var$replaceTextUsingCaptureGroup(to));
}
/**
 * Create replacement rules fiven a replacement map
 * @param replMap - Replacement map
 * @param trackingEventName - Analytics V2 tracking event name
 * @param replacementRuleWithAnalytics - Analytics GAS V3 middleware for replacement and rules.
 */ function $7e74f3bcc56d8b85$var$createReplacementRules(replMap, replacementRuleWithAnalytics) {
    return Object.keys(replMap).map((replacement)=>{
        const regex = replMap[replacement];
        const rule = $7e74f3bcc56d8b85$var$createReplacementRule(replacement, regex);
        if (replacementRuleWithAnalytics) return replacementRuleWithAnalytics(replacement)(rule);
        return rule;
    });
}
// We don't agressively upgrade single quotes to smart quotes because
// they may clash with an emoji. Only do that when we have a matching
// single quote, or a contraction.
function $7e74f3bcc56d8b85$var$createSingleQuotesRules() {
    return [
        // wrapped text
        // eslint-disable-next-line require-unicode-regexp
        (0, $leZY6.createRule)(/(\s|^)'(\S+.*\S+)'$/, (state, match, start, end)=>{
            const OPEN_SMART_QUOTE_CHAR = "\u2018";
            const CLOSED_SMART_QUOTE_CHAR = "\u2019";
            const [, spacing, innerContent] = match;
            // Edge case where match begins with some spacing. We need to add
            // it back to the document
            const openQuoteReplacement = spacing + OPEN_SMART_QUOTE_CHAR;
            // End is not always where the closed quote is, edge case exists
            // when there is spacing after the closed quote. We need to
            // determine position of closed quote from the start position.
            const positionOfClosedQuote = start + openQuoteReplacement.length + innerContent.length;
            return state.tr.insertText(CLOSED_SMART_QUOTE_CHAR, positionOfClosedQuote, end).insertText(openQuoteReplacement, start, start + openQuoteReplacement.length);
        }),
        // apostrophe
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        $7e74f3bcc56d8b85$var$createReplacementRule("\u2019", /(\w+)(')(\w+)$/)
    ];
}
/**
 * Get replacement rules related to product
 */ function $7e74f3bcc56d8b85$var$getProductRules(editorAnalyticsAPI) {
    const productRuleWithAnalytics = (product)=>(0, $leZY6.inputRuleWithAnalytics)((_, match)=>({
                action: (0, $bMFKb.ACTION).SUBSTITUTED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).PRODUCT_NAME,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                attributes: {
                    product: product,
                    originalSpelling: match[2]
                }
            }), editorAnalyticsAPI);
    return $7e74f3bcc56d8b85$var$createReplacementRules({
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        Atlassian: /(\s+|^)(atlassian)(\s)$/,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        Jira: /(\s+|^)(jira|JIRA)(\s)$/,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        Bitbucket: /(\s+|^)(bitbucket|BitBucket)(\s)$/,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        Hipchat: /(\s+|^)(hipchat|HipChat)(\s)$/,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        Trello: /(\s+|^)(trello)(\s)$/
    }, productRuleWithAnalytics);
}
/**
 * Get replacement rules related to symbol
 */ function $7e74f3bcc56d8b85$var$getSymbolRules(editorAnalyticsAPI) {
    const symbolToString = {
        "\u2192": (0, $aGCuE.SYMBOL).ARROW_RIGHT,
        "\u2190": (0, $aGCuE.SYMBOL).ARROW_LEFT,
        "\u2194\uFE0E": (0, $aGCuE.SYMBOL).ARROW_DOUBLE
    };
    const symbolRuleWithAnalytics = (symbol)=>(0, $leZY6.inputRuleWithAnalytics)({
            action: (0, $bMFKb.ACTION).SUBSTITUTED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
            actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).SYMBOL,
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
            attributes: {
                symbol: symbolToString[symbol]
            }
        }, editorAnalyticsAPI);
    return $7e74f3bcc56d8b85$var$createReplacementRules({
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        "\u2192": /(\s+|^)(--?>)(\s)$/,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        "\u2190": /(\s+|^)(<--?)(\s)$/,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        "\u2194\uFE0E": /(\s+|^)(<->?)(\s)$/
    }, symbolRuleWithAnalytics);
}
/**
 * Get replacement rules related to punctuation
 */ function $7e74f3bcc56d8b85$var$getPunctuationRules(editorAnalyticsAPI) {
    const punctuationToString = {
        "\u2013": (0, $aGCuE.PUNC).DASH,
        "\u2026": (0, $aGCuE.PUNC).ELLIPSIS,
        "\u201D": (0, $aGCuE.PUNC).QUOTE_DOUBLE,
        [(0, $aGCuE.PUNC).QUOTE_SINGLE]: (0, $aGCuE.PUNC).QUOTE_SINGLE
    };
    const punctuationRuleWithAnalytics = (punctuation)=>(0, $leZY6.inputRuleWithAnalytics)({
            action: (0, $bMFKb.ACTION).SUBSTITUTED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
            actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).PUNC,
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
            attributes: {
                punctuation: punctuationToString[punctuation]
            }
        }, editorAnalyticsAPI);
    const dashEllipsisRules = $7e74f3bcc56d8b85$var$createReplacementRules({
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        "\u2013": /(\s+|^)(--)(\s)$/,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        "\u2026": /()(\.\.\.)$/
    }, punctuationRuleWithAnalytics);
    const doubleQuoteRules = $7e74f3bcc56d8b85$var$createReplacementRules({
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        "\u201C": /((?:^|[\s\{\[\(\<'"\u2018\u201C]))(")$/,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        "\u201D": /"$/
    }, punctuationRuleWithAnalytics);
    const singleQuoteRules = $7e74f3bcc56d8b85$var$createSingleQuotesRules();
    return [
        ...dashEllipsisRules,
        ...doubleQuoteRules,
        ...singleQuoteRules.map((rule)=>punctuationRuleWithAnalytics((0, $aGCuE.PUNC).QUOTE_SINGLE)(rule))
    ];
}
var $7e74f3bcc56d8b85$export$2e2bcd8739ae039 = (editorAnalyticsAPI)=>new (0, $i8KtF.SafePlugin)((0, $jCfsG.createPlugin)('text-formatting:smart-input', [
        ...$7e74f3bcc56d8b85$var$getProductRules(editorAnalyticsAPI),
        ...$7e74f3bcc56d8b85$var$getSymbolRules(editorAnalyticsAPI),
        ...$7e74f3bcc56d8b85$var$getPunctuationRules(editorAnalyticsAPI)
    ]));

});
parcelRegister("aGCuE", function(module, exports) {
$parcel$export(module.exports, "SYMBOL", () => $67fb0c56ff4ace42$export$27c95a7104c1f7aa);
$parcel$export(module.exports, "PUNC", () => $67fb0c56ff4ace42$export$3530f2dd0e78fdc2);
var $67fb0c56ff4ace42$export$27c95a7104c1f7aa = /*#__PURE__*/ function(SYMBOL) {
    SYMBOL["ARROW_RIGHT"] = "rightArrow";
    SYMBOL["ARROW_LEFT"] = "leftArrow";
    SYMBOL["ARROW_DOUBLE"] = "doubleArrow";
    return SYMBOL;
}({});
var $67fb0c56ff4ace42$export$3530f2dd0e78fdc2 = /*#__PURE__*/ function(PUNC) {
    PUNC["DASH"] = "emDash";
    PUNC["ELLIPSIS"] = "ellipsis";
    PUNC["QUOTE_SINGLE"] = "singleQuote";
    PUNC["QUOTE_DOUBLE"] = "doubleQuote";
    return PUNC;
}({});

});


parcelRegister("JbtjS", function(module, exports) {
$parcel$export(module.exports, "FloatingToolbarTextFormalWithIntl", () => $4410e732d7758e6a$export$d728f1bdde37938b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");

var $cxXTK = parcelRequire("cxXTK");

var $aBsWC = parcelRequire("aBsWC");

var $92xoS = parcelRequire("92xoS");

var $84UAZ = parcelRequire("84UAZ");

var $lW769 = parcelRequire("lW769");

var $fuNer = parcelRequire("fuNer");

var $8kTsv = parcelRequire("8kTsv");

var $5qGII = parcelRequire("5qGII");

var $91V0n = parcelRequire("91V0n");

var $iIDdW = parcelRequire("iIDdW");
const $4410e732d7758e6a$var$FloatingToolbarSettings = {
    disabled: false,
    isReducedSpacing: true,
    shouldUseResponsiveToolbar: false,
    toolbarSize: (0, $aBsWC.ToolbarSize).S,
    hasMoreButton: false,
    moreButtonLabel: '',
    toolbarType: (0, $iIDdW.ToolbarType).FLOATING
};
const $4410e732d7758e6a$var$selector = (states)=>{
    return {
        isInitialised: Boolean(states.textFormattingState?.isInitialised),
        formattingIsPresent: states.textFormattingState?.formattingIsPresent,
        emActive: states.textFormattingState?.emActive,
        emDisabled: states.textFormattingState?.emDisabled,
        emHidden: states.textFormattingState?.emHidden,
        codeActive: states.textFormattingState?.codeActive,
        codeDisabled: states.textFormattingState?.codeDisabled,
        codeHidden: states.textFormattingState?.codeHidden,
        underlineActive: states.textFormattingState?.underlineActive,
        underlineDisabled: states.textFormattingState?.underlineDisabled,
        underlineHidden: states.textFormattingState?.underlineHidden,
        strikeActive: states.textFormattingState?.strikeActive,
        strikeDisabled: states.textFormattingState?.strikeDisabled,
        strikeHidden: states.textFormattingState?.strikeHidden,
        strongActive: states.textFormattingState?.strongActive,
        strongDisabled: states.textFormattingState?.strongDisabled,
        strongHidden: states.textFormattingState?.strongHidden,
        superscriptActive: states.textFormattingState?.superscriptActive,
        superscriptDisabled: states.textFormattingState?.superscriptDisabled,
        superscriptHidden: states.textFormattingState?.superscriptHidden,
        subscriptActive: states.textFormattingState?.subscriptActive,
        subscriptDisabled: states.textFormattingState?.subscriptDisabled,
        subscriptHidden: states.textFormattingState?.subscriptHidden
    };
};
const $4410e732d7758e6a$var$FloatingToolbarTextFormat = ({ api: api, editorAnalyticsAPI: editorAnalyticsAPI, editorView: editorView, intl: intl })=>{
    const textFormattingState = (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'textFormatting'
    ], $4410e732d7758e6a$var$selector);
    const { formattingIsPresent: formattingIsPresent, ...formattingIconState } = textFormattingState;
    const defaultIcons = (0, $8kTsv.useFormattingIcons)({
        schema: editorView.state.schema,
        intl: intl,
        isToolbarDisabled: $4410e732d7758e6a$var$FloatingToolbarSettings.disabled,
        editorAnalyticsAPI: editorAnalyticsAPI,
        textFormattingState: formattingIconState,
        toolbarType: $4410e732d7758e6a$var$FloatingToolbarSettings.toolbarType
    });
    const { dropdownItems: dropdownItems, singleItems: singleItems } = (0, $5qGII.useIconList)({
        icons: defaultIcons,
        iconTypeList: (0, $84UAZ.ToolbarButtonsStrong)
    });
    const clearIcon = (0, $fuNer.useClearIcon)({
        formattingPluginInitialised: textFormattingState.isInitialised,
        formattingIsPresent: formattingIsPresent,
        intl: intl,
        editorAnalyticsAPI: editorAnalyticsAPI,
        toolbarType: $4410e732d7758e6a$var$FloatingToolbarSettings.toolbarType
    });
    const items = (0, $eJOHy.useMemo)(()=>{
        if (!clearIcon) return [
            {
                items: dropdownItems
            }
        ];
        return [
            {
                items: dropdownItems
            },
            {
                items: [
                    clearIcon
                ]
            }
        ];
    }, [
        clearIcon,
        dropdownItems
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $91V0n.SingleToolbarButtons), {
        items: singleItems,
        editorView: editorView,
        isReducedSpacing: false
    }), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $lW769.FormattingTextDropdownMenu), {
        editorView: editorView,
        items: items,
        isReducedSpacing: (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? false : $4410e732d7758e6a$var$FloatingToolbarSettings.isReducedSpacing,
        moreButtonLabel: $4410e732d7758e6a$var$FloatingToolbarSettings.moreButtonLabel,
        hasFormattingActive: $4410e732d7758e6a$var$FloatingToolbarSettings.hasMoreButton,
        hasMoreButton: $4410e732d7758e6a$var$FloatingToolbarSettings.hasMoreButton,
        intl: intl,
        toolbarType: $4410e732d7758e6a$var$FloatingToolbarSettings.toolbarType
    }));
};
const $4410e732d7758e6a$export$d728f1bdde37938b = (0, $6YFG2.default)($4410e732d7758e6a$var$FloatingToolbarTextFormat);

});
parcelRegister("84UAZ", function(module, exports) {
$parcel$export(module.exports, "ToolbarButtonsStrongItalic", () => $d76c87d933cce6eb$export$37a675a4731536c);
$parcel$export(module.exports, "ToolbarButtonsStrong", () => $d76c87d933cce6eb$export$9930ae1c7f6b53f3);
$parcel$export(module.exports, "ButtonsMenuMinimal", () => $d76c87d933cce6eb$export$5789feaf6941ee12);
$parcel$export(module.exports, "ResponsiveCustomButtonToolbarMinimal", () => $d76c87d933cce6eb$export$13589e95a4a6fb40);
$parcel$export(module.exports, "ResponsiveCustomButtonToolbarCompact", () => $d76c87d933cce6eb$export$fdd1bbcb63018330);
$parcel$export(module.exports, "ResponsiveCustomMenuMinimal", () => $d76c87d933cce6eb$export$1b53a931a2dd9e07);
$parcel$export(module.exports, "ResponsiveCustomMenuCompact", () => $d76c87d933cce6eb$export$53d57ab9be604153);

var $aBsWC = parcelRequire("aBsWC");

var $iIDdW = parcelRequire("iIDdW");
const $d76c87d933cce6eb$export$37a675a4731536c = [
    (0, $iIDdW.IconTypes).strong,
    (0, $iIDdW.IconTypes).em
];
const $d76c87d933cce6eb$export$9930ae1c7f6b53f3 = [
    (0, $iIDdW.IconTypes).strong
];
const $d76c87d933cce6eb$export$def34bf0ee813055 = [
    (0, $iIDdW.IconTypes).strong,
    (0, $iIDdW.IconTypes).em,
    (0, $iIDdW.IconTypes).underline
];
const $d76c87d933cce6eb$export$5789feaf6941ee12 = [
    (0, $iIDdW.IconTypes).em,
    (0, $iIDdW.IconTypes).underline,
    (0, $iIDdW.IconTypes).strike,
    (0, $iIDdW.IconTypes).code,
    (0, $iIDdW.IconTypes).subscript,
    (0, $iIDdW.IconTypes).superscript
];
const $d76c87d933cce6eb$export$f40ebaa61bfc4d53 = [
    (0, $iIDdW.IconTypes).underline,
    (0, $iIDdW.IconTypes).strike,
    (0, $iIDdW.IconTypes).code,
    (0, $iIDdW.IconTypes).subscript,
    (0, $iIDdW.IconTypes).superscript
];
const $d76c87d933cce6eb$export$b1ac64c82cac61ce = [
    (0, $iIDdW.IconTypes).strike,
    (0, $iIDdW.IconTypes).code,
    (0, $iIDdW.IconTypes).subscript,
    (0, $iIDdW.IconTypes).superscript
];
const $d76c87d933cce6eb$export$13589e95a4a6fb40 = {
    [(0, $aBsWC.ToolbarSize).XXL]: $d76c87d933cce6eb$export$9930ae1c7f6b53f3,
    [(0, $aBsWC.ToolbarSize).XL]: $d76c87d933cce6eb$export$9930ae1c7f6b53f3,
    [(0, $aBsWC.ToolbarSize).L]: $d76c87d933cce6eb$export$9930ae1c7f6b53f3,
    [(0, $aBsWC.ToolbarSize).M]: $d76c87d933cce6eb$export$9930ae1c7f6b53f3,
    [(0, $aBsWC.ToolbarSize).S]: $d76c87d933cce6eb$export$9930ae1c7f6b53f3,
    [(0, $aBsWC.ToolbarSize).XXXS]: []
};
const $d76c87d933cce6eb$export$fdd1bbcb63018330 = {
    [(0, $aBsWC.ToolbarSize).XXL]: $d76c87d933cce6eb$export$37a675a4731536c,
    [(0, $aBsWC.ToolbarSize).XL]: $d76c87d933cce6eb$export$37a675a4731536c,
    [(0, $aBsWC.ToolbarSize).L]: $d76c87d933cce6eb$export$37a675a4731536c,
    [(0, $aBsWC.ToolbarSize).M]: $d76c87d933cce6eb$export$37a675a4731536c,
    [(0, $aBsWC.ToolbarSize).S]: $d76c87d933cce6eb$export$37a675a4731536c,
    [(0, $aBsWC.ToolbarSize).XXXS]: []
};
const $d76c87d933cce6eb$export$861ad8d05e95bc1e = {
    [(0, $aBsWC.ToolbarSize).XXL]: $d76c87d933cce6eb$export$def34bf0ee813055,
    [(0, $aBsWC.ToolbarSize).XL]: $d76c87d933cce6eb$export$def34bf0ee813055,
    [(0, $aBsWC.ToolbarSize).L]: $d76c87d933cce6eb$export$def34bf0ee813055,
    [(0, $aBsWC.ToolbarSize).M]: $d76c87d933cce6eb$export$37a675a4731536c,
    [(0, $aBsWC.ToolbarSize).S]: $d76c87d933cce6eb$export$37a675a4731536c,
    [(0, $aBsWC.ToolbarSize).XXXS]: $d76c87d933cce6eb$export$9930ae1c7f6b53f3
};
const $d76c87d933cce6eb$export$1b53a931a2dd9e07 = {
    [(0, $aBsWC.ToolbarSize).XXL]: $d76c87d933cce6eb$export$5789feaf6941ee12,
    [(0, $aBsWC.ToolbarSize).XL]: $d76c87d933cce6eb$export$5789feaf6941ee12,
    [(0, $aBsWC.ToolbarSize).L]: $d76c87d933cce6eb$export$5789feaf6941ee12,
    [(0, $aBsWC.ToolbarSize).M]: $d76c87d933cce6eb$export$5789feaf6941ee12,
    [(0, $aBsWC.ToolbarSize).S]: $d76c87d933cce6eb$export$5789feaf6941ee12,
    [(0, $aBsWC.ToolbarSize).XXXS]: [
        (0, $iIDdW.IconTypes).strong,
        (0, $iIDdW.IconTypes).em,
        ...$d76c87d933cce6eb$export$5789feaf6941ee12
    ]
};
const $d76c87d933cce6eb$export$53d57ab9be604153 = {
    [(0, $aBsWC.ToolbarSize).XXL]: $d76c87d933cce6eb$export$f40ebaa61bfc4d53,
    [(0, $aBsWC.ToolbarSize).XL]: $d76c87d933cce6eb$export$f40ebaa61bfc4d53,
    [(0, $aBsWC.ToolbarSize).L]: $d76c87d933cce6eb$export$f40ebaa61bfc4d53,
    [(0, $aBsWC.ToolbarSize).M]: $d76c87d933cce6eb$export$f40ebaa61bfc4d53,
    [(0, $aBsWC.ToolbarSize).S]: $d76c87d933cce6eb$export$f40ebaa61bfc4d53,
    [(0, $aBsWC.ToolbarSize).XXXS]: [
        (0, $iIDdW.IconTypes).strong,
        (0, $iIDdW.IconTypes).em,
        ...$d76c87d933cce6eb$export$f40ebaa61bfc4d53
    ]
};
const $d76c87d933cce6eb$export$77ad87491c5fbf88 = {
    [(0, $aBsWC.ToolbarSize).XXL]: $d76c87d933cce6eb$export$b1ac64c82cac61ce,
    [(0, $aBsWC.ToolbarSize).XL]: $d76c87d933cce6eb$export$b1ac64c82cac61ce,
    [(0, $aBsWC.ToolbarSize).L]: $d76c87d933cce6eb$export$b1ac64c82cac61ce,
    [(0, $aBsWC.ToolbarSize).M]: [
        (0, $iIDdW.IconTypes).underline,
        ...$d76c87d933cce6eb$export$b1ac64c82cac61ce
    ],
    [(0, $aBsWC.ToolbarSize).S]: [
        (0, $iIDdW.IconTypes).underline,
        ...$d76c87d933cce6eb$export$b1ac64c82cac61ce
    ],
    [(0, $aBsWC.ToolbarSize).XXXS]: [
        (0, $iIDdW.IconTypes).em,
        (0, $iIDdW.IconTypes).underline,
        ...$d76c87d933cce6eb$export$b1ac64c82cac61ce
    ]
};

});
parcelRegister("iIDdW", function(module, exports) {
$parcel$export(module.exports, "IconTypes", () => $e979e304b7dd97fe$export$f84ca76848e3ed34);
$parcel$export(module.exports, "FormatOptions", () => $e979e304b7dd97fe$export$c1fb0eb1ea3f6fb6);
$parcel$export(module.exports, "ToolbarType", () => $e979e304b7dd97fe$export$a5d11b3163e4b1a5);
var $e979e304b7dd97fe$export$f84ca76848e3ed34 = /*#__PURE__*/ function(IconTypes) {
    IconTypes["strong"] = "strong";
    IconTypes["em"] = "em";
    IconTypes["underline"] = "underline";
    IconTypes["strike"] = "strike";
    IconTypes["code"] = "code";
    IconTypes["subscript"] = "subscript";
    IconTypes["superscript"] = "superscript";
    return IconTypes;
}({});
var $e979e304b7dd97fe$export$c1fb0eb1ea3f6fb6 = /*#__PURE__*/ function(FormatOptions) {
    FormatOptions["strong"] = "strong";
    FormatOptions["em"] = "em";
    FormatOptions["underline"] = "underline";
    FormatOptions["strike"] = "strike";
    FormatOptions["code"] = "code";
    FormatOptions["subscript"] = "subscript";
    FormatOptions["superscript"] = "superscript";
    return FormatOptions;
}({});
var $e979e304b7dd97fe$export$a5d11b3163e4b1a5 = /*#__PURE__*/ function(ToolbarType) {
    ToolbarType["PRIMARY"] = "primaryToolbar";
    ToolbarType["FLOATING"] = "floatingToolbar";
    return ToolbarType;
}({});

});


parcelRegister("lW769", function(module, exports) {
$parcel$export(module.exports, "FormattingTextDropdownMenu", () => $e7fb73c260bb5743$export$52e9a2bbe5d185e8);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $1D5wE = parcelRequire("1D5wE");

var $aPcNU = parcelRequire("aPcNU");

var $7yBx7 = parcelRequire("7yBx7");

var $92xoS = parcelRequire("92xoS");

var $jkIpu = parcelRequire("jkIpu");

var $25jFE = parcelRequire("25jFE");

var $6ab1O = parcelRequire("6ab1O");
const $e7fb73c260bb5743$export$52e9a2bbe5d185e8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ editorView: editorView, moreButtonLabel: moreButtonLabel, isReducedSpacing: isReducedSpacing, items: items, hasFormattingActive: hasFormattingActive, popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, hasMoreButton: hasMoreButton, intl: intl, toolbarType: toolbarType, isDisabled: isDisabled })=>{
    const [isMenuOpen, toggleMenu, closeMenu] = (0, $25jFE.useMenuState)();
    const [isOpenedByKeyboard, setIsOpenedByKeyboard] = (0, $eJOHy.useState)(false);
    const onItemActivated = (0, $eJOHy.useCallback)(({ item: item, shouldCloseMenu: shouldCloseMenu = true })=>{
        if (item) {
            item.command(editorView.state, editorView.dispatch);
            if (shouldCloseMenu) closeMenu();
        }
    }, [
        editorView.state,
        editorView.dispatch,
        closeMenu
    ]);
    const activeItem = items[0].items.find((item)=>item.isActive);
    const defaultIcon = (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? items[0].items[0]?.elemBefore : undefined;
    const defaultIconName = items[0].items[0]?.value.name;
    const iconBefore = activeItem ? activeItem?.elemBefore : defaultIcon;
    const activeIconName = activeItem?.value.name || defaultIconName;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aPcNU.DropdownMenuWithKeyboardNavigation), {
        mountTo: popupsMountPoint,
        onOpenChange: closeMenu,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        onItemActivated: onItemActivated,
        isOpen: isMenuOpen,
        items: items,
        zIndex: (0, $7yBx7.akEditorMenuZIndex),
        fitHeight: 188,
        fitWidth: (0, $92xoS.editorExperiment)('platform_editor_controls', 'control') ? 136 : 230,
        shouldUseDefaultRole: true,
        section: {
            hasSeparator: true
        },
        shouldFocusFirstItem: ()=>{
            if (isOpenedByKeyboard) setIsOpenedByKeyboard(false);
            return isOpenedByKeyboard;
        },
        children: hasMoreButton ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6ab1O.MoreButton), {
            isSelected: isMenuOpen || hasFormattingActive,
            label: moreButtonLabel,
            isReducedSpacing: isReducedSpacing,
            isDisabled: false,
            onClick: ()=>{
                toggleMenu();
                setIsOpenedByKeyboard(false);
            },
            onKeyDown: (event)=>{
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    toggleMenu();
                    setIsOpenedByKeyboard(true);
                }
            },
            "aria-expanded": isMenuOpen
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jkIpu.DropdownToolbarButton), {
            isReducedSpacing: isReducedSpacing,
            isDisabled: Boolean(isDisabled),
            isSelected: isMenuOpen,
            label: intl.formatMessage((0, $1D5wE.toolbarMessages).textFormat),
            "aria-expanded": isMenuOpen,
            "aria-haspopup": true,
            onClick: ()=>{
                toggleMenu();
                setIsOpenedByKeyboard(false);
            },
            onKeyDown: (event)=>{
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    toggleMenu();
                    setIsOpenedByKeyboard(true);
                }
            },
            toolbarType: toolbarType,
            iconBefore: iconBefore,
            activeIconName: activeIconName
        })
    });
});

});
parcelRegister("jkIpu", function(module, exports) {
$parcel$export(module.exports, "DropdownToolbarButton", () => $4802d0fed694dedd$export$7c43b97d70f40057);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $fcJnk = parcelRequire("fcJnk");
var $is7NW = parcelRequire("is7NW");

var $9Sic1 = parcelRequire("9Sic1");

var $5lAAn = parcelRequire("5lAAn");

var $ifOJ1 = parcelRequire("ifOJ1");

var $eGOwo = parcelRequire("eGOwo");

var $iIDdW = parcelRequire("iIDdW");
const $4802d0fed694dedd$export$7c43b97d70f40057 = ({ label: label, isReducedSpacing: isReducedSpacing, isDisabled: isDisabled, isSelected: isSelected, 'aria-expanded': ariaExpanded, onClick: onClick, onKeyDown: onKeyDown, toolbarType: toolbarType, iconBefore: iconBefore, activeIconName: activeIconName })=>{
    const reducedSpacing = toolbarType === (0, $iIDdW.ToolbarType).FLOATING ? 'compact' : 'none';
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $9Sic1.default), {
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-imported-style-values
        css: (0, $fcJnk.disableBlueBorderStyles),
        testId: 'ak-editor-selection-toolbar-format-text-button',
        spacing: isReducedSpacing ? reducedSpacing : 'default',
        disabled: isDisabled,
        selected: isSelected,
        "aria-label": label,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": true,
        title: label,
        onClick: onClick,
        onKeyDown: onKeyDown,
        iconBefore: /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: (0, $eGOwo.fg)('platform-visual-refresh-icons') ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $fcJnk.triggerWrapperStylesWithPadding) : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $fcJnk.triggerWrapperStyles),
            "data-testid": activeIconName ? `editor-toolbar__${activeIconName}` : undefined
        }, iconBefore ? iconBefore : /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ifOJ1))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        }), /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            css: (0, $is7NW.expandIconContainerStyle)
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
            label: "",
            color: "currentColor",
            LEGACY_margin: "0 0 0 -8px",
            size: "small"
        })))
    });
};

});
parcelRegister("ifOJ1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5444b51e487d7ee30ba43f31750651c0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d4a0f9a74b1d62bd$var$_react = $d4a0f9a74b1d62bd$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d4a0f9a74b1d62bd$var$_textItalic = $d4a0f9a74b1d62bd$var$_interopRequireDefault((parcelRequire("lwr5e")));

var $d4a0f9a74b1d62bd$var$_italic = $d4a0f9a74b1d62bd$var$_interopRequireDefault((parcelRequire("lasBY")));
function $d4a0f9a74b1d62bd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for TextItalicIcon.
 * This component is TextItalicIcon, with `UNSAFE_fallbackIcon` set to "EditorItalicIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for italicizing text.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d4a0f9a74b1d62bd$var$TextItalicIcon = (props)=>/*#__PURE__*/ $d4a0f9a74b1d62bd$var$_react.default.createElement($d4a0f9a74b1d62bd$var$_textItalic.default, Object.assign({
        name: "TextItalicIcon",
        LEGACY_fallbackIcon: $d4a0f9a74b1d62bd$var$_italic.default
    }, props));
$d4a0f9a74b1d62bd$var$TextItalicIcon.displayName = 'TextItalicIconMigration';
var $d4a0f9a74b1d62bd$var$_default = module.exports.default = $d4a0f9a74b1d62bd$var$TextItalicIcon;

});
parcelRegister("lwr5e", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::185c83995a7208ef1c24aad54fb1e0a7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fab1985802bcfb54$var$_react = $fab1985802bcfb54$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fab1985802bcfb54$var$_baseNew = $fab1985802bcfb54$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $fab1985802bcfb54$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextItalic".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for italicizing text.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fab1985802bcfb54$var$TextItalicIcon = (props)=>/*#__PURE__*/ $fab1985802bcfb54$var$_react.default.createElement($fab1985802bcfb54$var$_baseNew.default, Object.assign({
        name: "TextItalicIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 1h6.5v1.5h-2.409l-2.64 11H10V15H3.5v-1.5h2.409l2.64-11H6z" clip-rule="evenodd"/>`
    }, props));
$fab1985802bcfb54$var$TextItalicIcon.displayName = 'TextItalicIcon';
var $fab1985802bcfb54$var$_default = module.exports.default = $fab1985802bcfb54$var$TextItalicIcon;

});

parcelRegister("lasBY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f690b9cbaef64078$var$_react = $f690b9cbaef64078$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $f690b9cbaef64078$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f690b9cbaef64078$var$EditorItalicIcon = (props)=>/*#__PURE__*/ $f690b9cbaef64078$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M10 6h6a1 1 0 0 1 0 2h-6a1 1 0 1 1 0-2M8 16h6a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2m4-8h2l-2 8h-2z"/></svg>`
    }, props));
$f690b9cbaef64078$var$EditorItalicIcon.displayName = 'EditorItalicIcon';
var $f690b9cbaef64078$var$_default = module.exports.default = $f690b9cbaef64078$var$EditorItalicIcon;

});



parcelRegister("25jFE", function(module, exports) {
$parcel$export(module.exports, "useMenuState", () => $5448c5858028c7d5$export$8091e3849c182a6);

var $eJOHy = parcelRequire("eJOHy");
const $5448c5858028c7d5$export$8091e3849c182a6 = ()=>{
    const [isMenuOpen, setIsMenuOpened] = (0, $eJOHy.useState)(false);
    const toggleMenu = (0, $eJOHy.useCallback)(()=>{
        setIsMenuOpened(!isMenuOpen);
    }, [
        isMenuOpen
    ]);
    const closeMenu = (0, $eJOHy.useCallback)(()=>{
        setIsMenuOpened(false);
    }, []);
    return [
        isMenuOpen,
        toggleMenu,
        closeMenu
    ];
};

});

parcelRegister("6ab1O", function(module, exports) {
$parcel$export(module.exports, "MoreButton", () => $3d8b852166b47c3e$export$7f94856880993f27);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $fcJnk = parcelRequire("fcJnk");

var $9Sic1 = parcelRequire("9Sic1");

var $i2fvj = parcelRequire("i2fvj");

var $eGOwo = parcelRequire("eGOwo");
function $3d8b852166b47c3e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3d8b852166b47c3e$var$MoreIconStyle = {
    name: "1m17jn9",
    styles: "display:flex;align-items:center;height:var(--ds-space-300, 24px)"
};
const $3d8b852166b47c3e$export$7f94856880993f27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ label: label, 'aria-expanded': ariaExpanded, isReducedSpacing: isReducedSpacing, isSelected: isSelected, isDisabled: isDisabled, onClick: onClick, onKeyDown: onKeyDown })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $9Sic1.default), {
        disabled: isDisabled,
        selected: isSelected,
        onClick: onClick,
        onKeyDown: onKeyDown,
        spacing: isReducedSpacing ? 'none' : 'default',
        title: label,
        iconBefore: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: (0, $eGOwo.fg)('platform-visual-refresh-icons') ? $3d8b852166b47c3e$var$MoreIconStyle : (0, $fcJnk.triggerWrapperStyles)
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i2fvj))), {
            label: "",
            color: "currentColor",
            spacing: "spacious",
            size: "small"
        })),
        "aria-expanded": ariaExpanded,
        "aria-label": label,
        "aria-haspopup": true
    });
});

});


parcelRegister("fuNer", function(module, exports) {
$parcel$export(module.exports, "useClearIcon", () => $87ee7daa11fb1382$export$4ff17fae4b9914b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6Exgk = parcelRequire("6Exgk");

var $1D5wE = parcelRequire("1D5wE");

var $2dMzB = parcelRequire("2dMzB");

var $kmgRi = parcelRequire("kmgRi");

var $92xoS = parcelRequire("92xoS");

var $2yLcK = parcelRequire("2yLcK");

var $jkSZ5 = parcelRequire("jkSZ5");
const $87ee7daa11fb1382$export$4ff17fae4b9914b = ({ intl: intl, formattingPluginInitialised: formattingPluginInitialised, formattingIsPresent: formattingPresent, editorAnalyticsAPI: editorAnalyticsAPI, toolbarType: toolbarType })=>{
    const isPluginAvailable = Boolean(formattingPluginInitialised);
    const formattingIsPresent = Boolean(formattingPresent);
    const clearFormattingLabel = intl.formatMessage((0, $1D5wE.toolbarMessages).clearFormatting);
    const clearFormattingToolbar = (0, $eJOHy.useCallback)((state, dispatch)=>(0, $2yLcK.clearFormattingWithAnalytics)((0, $jkSZ5.getInputMethod)(toolbarType), editorAnalyticsAPI)(state, dispatch), [
        editorAnalyticsAPI,
        toolbarType
    ]);
    return (0, $eJOHy.useMemo)(()=>{
        if (!isPluginAvailable) return null;
        return {
            key: 'clearFormatting',
            command: clearFormattingToolbar,
            content: clearFormattingLabel,
            elemBefore: (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kmgRi))), {
                label: ""
            }) : undefined,
            elemAfter: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
                css: (0, $2dMzB.shortcutStyle)
            }, (0, $6Exgk.tooltip)((0, $6Exgk.clearFormatting))),
            value: {
                name: 'clearFormatting'
            },
            isActive: false,
            isDisabled: !formattingIsPresent,
            'aria-label': (0, $6Exgk.clearFormatting) ? (0, $6Exgk.tooltip)((0, $6Exgk.clearFormatting), String(clearFormattingLabel)) : String(clearFormattingLabel)
        };
    }, [
        isPluginAvailable,
        clearFormattingToolbar,
        clearFormattingLabel,
        formattingIsPresent
    ]);
};

});
parcelRegister("kmgRi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cf26d580385ecfdfcd87f2bd58ec1e28>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ed22f08197c2d0ff$var$_react = $ed22f08197c2d0ff$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $ed22f08197c2d0ff$var$_baseNew = $ed22f08197c2d0ff$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $ed22f08197c2d0ff$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableCellClear".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for clearing the contents of table cells.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ed22f08197c2d0ff$var$TableCellClearIcon = (props)=>/*#__PURE__*/ $ed22f08197c2d0ff$var$_react.default.createElement($ed22f08197c2d0ff$var$_baseNew.default, Object.assign({
        name: "TableCellClearIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm6.94 4L5.22 6.28l1.06-1.06L8 6.94l1.72-1.72 1.06 1.06L9.06 8l1.72 1.72-1.06 1.06L8 9.06l-1.72 1.72-1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$ed22f08197c2d0ff$var$TableCellClearIcon.displayName = 'TableCellClearIcon';
var $ed22f08197c2d0ff$var$_default = module.exports.default = $ed22f08197c2d0ff$var$TableCellClearIcon;

});

parcelRegister("jkSZ5", function(module, exports) {
$parcel$export(module.exports, "getInputMethod", () => $afa6dff31102a3ac$export$8213a6fbfa466e73);

var $bMFKb = parcelRequire("bMFKb");

var $iIDdW = parcelRequire("iIDdW");
const $afa6dff31102a3ac$export$ec2f5afcaf7ee094 = {
    [(0, $iIDdW.ToolbarType).PRIMARY]: (0, $bMFKb.INPUT_METHOD).TOOLBAR,
    [(0, $iIDdW.ToolbarType).FLOATING]: (0, $bMFKb.INPUT_METHOD).FLOATING_TB
};
const $afa6dff31102a3ac$export$8213a6fbfa466e73 = (toolbarType)=>$afa6dff31102a3ac$export$ec2f5afcaf7ee094[toolbarType];

});


parcelRegister("8kTsv", function(module, exports) {
$parcel$export(module.exports, "useFormattingIcons", () => $6c0190658f0fcddb$export$6f298ec13df828);
$parcel$export(module.exports, "useHasFormattingActived", () => $6c0190658f0fcddb$export$cb0a2ed6e982a08f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $2pk5j = parcelRequire("2pk5j");

var $6Exgk = parcelRequire("6Exgk");

var $1D5wE = parcelRequire("1D5wE");

var $8GLF3 = parcelRequire("8GLF3");

var $2dMzB = parcelRequire("2dMzB");

var $cnLJM = parcelRequire("cnLJM");

var $jaa3x = parcelRequire("jaa3x");

var $ifOJ1 = parcelRequire("ifOJ1");

var $bouBs = parcelRequire("bouBs");

var $f2cYq = parcelRequire("f2cYq");

var $92xoS = parcelRequire("92xoS");

var $fYXDG = parcelRequire("fYXDG");

var $cOhad = parcelRequire("cOhad");

var $jkSZ5 = parcelRequire("jkSZ5");

var $iIDdW = parcelRequire("iIDdW");
const $6c0190658f0fcddb$var$withInputMethod = (toolbarType, func)=>(0, $8GLF3.editorCommandToPMCommand)(func((0, $jkSZ5.getInputMethod)(toolbarType)));
const $6c0190658f0fcddb$var$IconButtons = (editorAnalyticsAPI, toolbarType)=>({
        strong: {
            buttonId: (0, $2pk5j.TOOLBAR_ACTION_SUBJECT_ID).TEXT_FORMATTING_STRONG,
            command: $6c0190658f0fcddb$var$withInputMethod(toolbarType, (0, $fYXDG.toggleStrongWithAnalytics)(editorAnalyticsAPI)),
            message: (0, $1D5wE.toolbarMessages).bold,
            tooltipKeymap: (0, $6Exgk.toggleBold),
            component: ()=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jaa3x))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: ""
                })
        },
        em: {
            buttonId: (0, $2pk5j.TOOLBAR_ACTION_SUBJECT_ID).TEXT_FORMATTING_ITALIC,
            command: $6c0190658f0fcddb$var$withInputMethod(toolbarType, (0, $fYXDG.toggleEmWithAnalytics)(editorAnalyticsAPI)),
            message: (0, $1D5wE.toolbarMessages).italic,
            tooltipKeymap: (0, $6Exgk.toggleItalic),
            component: ()=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ifOJ1))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: ""
                })
        },
        underline: {
            buttonId: (0, $2pk5j.TOOLBAR_ACTION_SUBJECT_ID).TEXT_FORMATTING_UNDERLINE,
            command: $6c0190658f0fcddb$var$withInputMethod(toolbarType, (0, $fYXDG.toggleUnderlineWithAnalytics)(editorAnalyticsAPI)),
            message: (0, $1D5wE.toolbarMessages).underline,
            tooltipKeymap: (0, $6Exgk.toggleUnderline),
            component: ()=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f2cYq))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: ""
                })
        },
        strike: {
            command: $6c0190658f0fcddb$var$withInputMethod(toolbarType, (0, $fYXDG.toggleStrikeWithAnalytics)(editorAnalyticsAPI)),
            message: (0, $1D5wE.toolbarMessages).strike,
            tooltipKeymap: (0, $6Exgk.toggleStrikethrough)
        },
        code: {
            command: $6c0190658f0fcddb$var$withInputMethod(toolbarType, (0, $fYXDG.toggleCodeWithAnalytics)(editorAnalyticsAPI)),
            message: (0, $1D5wE.toolbarMessages).code,
            tooltipKeymap: (0, $6Exgk.toggleCode)
        },
        subscript: {
            command: $6c0190658f0fcddb$var$withInputMethod(toolbarType, (0, $fYXDG.toggleSubscriptWithAnalytics)(editorAnalyticsAPI)),
            message: (0, $1D5wE.toolbarMessages).subscript,
            tooltipKeymap: (0, $6Exgk.toggleSubscript)
        },
        superscript: {
            command: $6c0190658f0fcddb$var$withInputMethod(toolbarType, (0, $fYXDG.toggleSuperscriptWithAnalytics)(editorAnalyticsAPI)),
            message: (0, $1D5wE.toolbarMessages).superscript,
            tooltipKeymap: (0, $6Exgk.toggleSuperscript)
        }
    });
const $6c0190658f0fcddb$var$IconBefore = {
    strong: {
        icon: /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jaa3x))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        })
    },
    em: {
        icon: /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ifOJ1))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        })
    },
    underline: {
        icon: /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f2cYq))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        })
    },
    strike: {
        icon: /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bouBs))), {
            label: ""
        })
    },
    code: {
        icon: /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cnLJM))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        })
    },
    subscript: {
        icon: /*#__PURE__*/ (0, $1NIU8.jsx)((0, $cOhad.Subscript), null)
    },
    superscript: {
        icon: /*#__PURE__*/ (0, $1NIU8.jsx)((0, $cOhad.Superscript), null)
    }
};
const $6c0190658f0fcddb$var$getIcon = ({ iconType: iconType, isDisabled: isDisabled, isActive: isActive, intl: intl, editorAnalyticsAPI: editorAnalyticsAPI, toolbarType: toolbarType })=>{
    const icon = $6c0190658f0fcddb$var$IconButtons(editorAnalyticsAPI, toolbarType)[iconType];
    const iconBefore = $6c0190658f0fcddb$var$IconBefore[iconType].icon;
    const content = intl.formatMessage(icon.message);
    const { tooltipKeymap: tooltipKeymap } = icon;
    return {
        content: content,
        buttonId: icon.buttonId,
        iconMark: iconType,
        key: iconType,
        command: icon.command,
        iconElement: icon.component ? icon.component() : undefined,
        tooltipElement: tooltipKeymap ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $6Exgk.ToolTipContent), {
            description: content,
            keymap: tooltipKeymap
        }) : undefined,
        elemBefore: (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? iconBefore : undefined,
        elemAfter: tooltipKeymap ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: (0, $2dMzB.shortcutStyle)
        }, (0, $6Exgk.tooltip)(tooltipKeymap)) : undefined,
        value: {
            name: iconType
        },
        isActive: isActive,
        isDisabled: isDisabled,
        'aria-label': tooltipKeymap ? (0, $6Exgk.tooltip)(tooltipKeymap, String(content)) : String(content),
        'aria-keyshortcuts': (0, $6Exgk.getAriaKeyshortcuts)(tooltipKeymap)
    };
};
const $6c0190658f0fcddb$var$IconsMarkSchema = {
    [(0, $iIDdW.IconTypes).strong]: 'strong',
    [(0, $iIDdW.IconTypes).em]: 'em',
    [(0, $iIDdW.IconTypes).strike]: 'strike',
    [(0, $iIDdW.IconTypes).code]: 'code',
    [(0, $iIDdW.IconTypes).underline]: 'underline',
    [(0, $iIDdW.IconTypes).superscript]: 'subsup',
    [(0, $iIDdW.IconTypes).subscript]: 'subsup'
};
const $6c0190658f0fcddb$var$buildMenuIconState = (iconMark)=>({ schema: schema, textFormattingState: textFormattingState })=>{
        const hasPluginState = Boolean(textFormattingState?.isInitialised);
        const markSchema = $6c0190658f0fcddb$var$IconsMarkSchema[iconMark];
        const hasSchemaMark = Boolean(schema.marks[markSchema]);
        if (!hasPluginState) return {
            isActive: false,
            isDisabled: true,
            isHidden: false,
            hasSchemaMark: hasSchemaMark
        };
        const isActive = textFormattingState?.[`${iconMark}Active`];
        const isDisabled = textFormattingState?.[`${iconMark}Disabled`];
        const isHidden = textFormattingState?.[`${iconMark}Hidden`];
        return {
            isActive: Boolean(isActive),
            isDisabled: Boolean(isDisabled),
            isHidden: Boolean(isHidden),
            hasSchemaMark: hasSchemaMark
        };
    };
const $6c0190658f0fcddb$var$buildIcon = (iconMark, editorAnalyticsAPI, toolbarType)=>{
    const getState = $6c0190658f0fcddb$var$buildMenuIconState(iconMark);
    return ({ schema: schema, textFormattingState: textFormattingState, intl: intl, isToolbarDisabled: isToolbarDisabled })=>{
        const iconState = getState({
            schema: schema,
            textFormattingState: textFormattingState
        });
        const { isActive: isActive, isDisabled: isDisabled, isHidden: isHidden, hasSchemaMark: hasSchemaMark } = iconState;
        const iconComponent = (0, $eJOHy.useMemo)(()=>$6c0190658f0fcddb$var$getIcon({
                iconType: (0, $iIDdW.IconTypes)[iconMark],
                isDisabled: isToolbarDisabled || isDisabled,
                isActive: isActive,
                intl: intl,
                editorAnalyticsAPI: editorAnalyticsAPI,
                toolbarType: toolbarType
            }), [
            isToolbarDisabled,
            isDisabled,
            isActive,
            intl
        ]);
        const shouldRenderIcon = hasSchemaMark && !isHidden;
        return (0, $eJOHy.useMemo)(()=>shouldRenderIcon ? iconComponent : null, [
            shouldRenderIcon,
            iconComponent
        ]);
    };
};
const $6c0190658f0fcddb$export$6f298ec13df828 = ({ isToolbarDisabled: isToolbarDisabled, textFormattingState: textFormattingState, schema: schema, intl: intl, editorAnalyticsAPI: editorAnalyticsAPI, toolbarType: toolbarType })=>{
    const props = {
        schema: schema,
        textFormattingState: textFormattingState,
        intl: intl,
        isToolbarDisabled: Boolean(isToolbarDisabled),
        toolbarType: toolbarType
    };
    const buildStrongIcon = $6c0190658f0fcddb$var$buildIcon((0, $iIDdW.IconTypes).strong, editorAnalyticsAPI, toolbarType);
    const buildEmIcon = $6c0190658f0fcddb$var$buildIcon((0, $iIDdW.IconTypes).em, editorAnalyticsAPI, toolbarType);
    const buildUnderlineIcon = $6c0190658f0fcddb$var$buildIcon((0, $iIDdW.IconTypes).underline, editorAnalyticsAPI, toolbarType);
    const buildStrikeIcon = $6c0190658f0fcddb$var$buildIcon((0, $iIDdW.IconTypes).strike, editorAnalyticsAPI, toolbarType);
    const buildCodeIcon = $6c0190658f0fcddb$var$buildIcon((0, $iIDdW.IconTypes).code, editorAnalyticsAPI, toolbarType);
    const buildSubscriptIcon = $6c0190658f0fcddb$var$buildIcon((0, $iIDdW.IconTypes).subscript, editorAnalyticsAPI, toolbarType);
    const buildSuperscriptIcon = $6c0190658f0fcddb$var$buildIcon((0, $iIDdW.IconTypes).superscript, editorAnalyticsAPI, toolbarType);
    const strongIcon = buildStrongIcon(props);
    const emIcon = buildEmIcon(props);
    const underlineIcon = buildUnderlineIcon(props);
    const strikeIcon = buildStrikeIcon(props);
    const codeIcon = buildCodeIcon(props);
    const subscriptIcon = buildSubscriptIcon(props);
    const superscriptIcon = buildSuperscriptIcon(props);
    const result = (0, $eJOHy.useMemo)(()=>[
            strongIcon,
            emIcon,
            underlineIcon,
            strikeIcon,
            codeIcon,
            subscriptIcon,
            superscriptIcon
        ], [
        strongIcon,
        emIcon,
        underlineIcon,
        strikeIcon,
        codeIcon,
        subscriptIcon,
        superscriptIcon
    ]);
    return result;
};
const $6c0190658f0fcddb$export$cb0a2ed6e982a08f = ({ iconTypeList: iconTypeList, textFormattingState: textFormattingState })=>{
    const hasActiveFormatting = (0, $eJOHy.useMemo)(()=>{
        if (!textFormattingState?.isInitialised) return false;
        return iconTypeList.some((iconType)=>textFormattingState[`${iconType}Active`]);
    }, [
        textFormattingState,
        iconTypeList
    ]);
    return hasActiveFormatting;
};

});
parcelRegister("jaa3x", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6f275adf768e9baa0bfb779f3f0533be>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $df36c066f8493404$var$_react = $df36c066f8493404$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $df36c066f8493404$var$_textBold = $df36c066f8493404$var$_interopRequireDefault((parcelRequire("5iunZ")));

var $df36c066f8493404$var$_bold = $df36c066f8493404$var$_interopRequireDefault((parcelRequire("b4zTI")));
function $df36c066f8493404$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for TextBoldIcon.
 * This component is TextBoldIcon, with `UNSAFE_fallbackIcon` set to "EditorBoldIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for bolding text.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $df36c066f8493404$var$TextBoldIcon = (props)=>/*#__PURE__*/ $df36c066f8493404$var$_react.default.createElement($df36c066f8493404$var$_textBold.default, Object.assign({
        name: "TextBoldIcon",
        LEGACY_fallbackIcon: $df36c066f8493404$var$_bold.default
    }, props));
$df36c066f8493404$var$TextBoldIcon.displayName = 'TextBoldIconMigration';
var $df36c066f8493404$var$_default = module.exports.default = $df36c066f8493404$var$TextBoldIcon;

});
parcelRegister("5iunZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fcbd61e491a8ad12e04031cd646fdab3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3db63433e55155cc$var$_react = $3db63433e55155cc$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $3db63433e55155cc$var$_baseNew = $3db63433e55155cc$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $3db63433e55155cc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextBold".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for bolding text.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3db63433e55155cc$var$TextBoldIcon = (props)=>/*#__PURE__*/ $3db63433e55155cc$var$_react.default.createElement($3db63433e55155cc$var$_baseNew.default, Object.assign({
        name: "TextBoldIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.125C3 1.504 3.504 1 4.125 1H8.75C11.004 1 13 2.626 13 5.063a3.93 3.93 0 0 1-.855 2.492A3.92 3.92 0 0 1 14 10.938C14 13.374 12.004 15 9.75 15H4.125A1.125 1.125 0 0 1 3 13.875zm5.75 4.75c1.198 0 2-.798 2-1.812s-.802-1.813-2-1.813h-3.5v3.625zm-3.5 2.25h4.5c1.198 0 2 .798 2 1.813s-.802 1.812-2 1.812h-4.5z" clip-rule="evenodd"/>`
    }, props));
$3db63433e55155cc$var$TextBoldIcon.displayName = 'TextBoldIcon';
var $3db63433e55155cc$var$_default = module.exports.default = $3db63433e55155cc$var$TextBoldIcon;

});

parcelRegister("b4zTI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $80fbe9f4c4ed2202$var$_react = $80fbe9f4c4ed2202$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $80fbe9f4c4ed2202$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $80fbe9f4c4ed2202$var$EditorBoldIcon = (props)=>/*#__PURE__*/ $80fbe9f4c4ed2202$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 6h4.832C13.908 6 16 6.5 16 9q0 2-1 2.5 2 .5 2 3c0 .5 0 3.5-4 3.5H8a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1m1 10h3.5c1 0 2-.25 2-1.5s-1.104-1.5-2-1.5H9zm0-4.975h3c.504 0 2 0 2-1.525S12 8 12 8H9z"/></svg>`
    }, props));
$80fbe9f4c4ed2202$var$EditorBoldIcon.displayName = 'EditorBoldIcon';
var $80fbe9f4c4ed2202$var$_default = module.exports.default = $80fbe9f4c4ed2202$var$EditorBoldIcon;

});


parcelRegister("bouBs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4892c276b5463761a4363f071816684>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $84b9acbe41f164e0$var$_react = $84b9acbe41f164e0$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $84b9acbe41f164e0$var$_baseNew = $84b9acbe41f164e0$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $84b9acbe41f164e0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextStrikethrough".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for strikethrough text tool
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $84b9acbe41f164e0$var$TextStrikethroughIcon = (props)=>/*#__PURE__*/ $84b9acbe41f164e0$var$_react.default.createElement($84b9acbe41f164e0$var$_baseNew.default, Object.assign({
        name: "TextStrikethroughIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7.47 2.5a2.12 2.12 0 0 0-1.79 3.25H4.03a3.59 3.59 0 0 1 .5-3.25A3.62 3.62 0 0 1 7.47 1h.93a4.08 4.08 0 0 1 3.19 1.53l-1.17.94A2.58 2.58 0 0 0 8.4 2.5zm3.51 7.75h1.58A3.82 3.82 0 0 1 8.86 15h-.67a4.5 4.5 0 0 1-4.11-2.67l-.01-.02 1.37-.61.01.02a3 3 0 0 0 2.74 1.78h.67a2.32 2.32 0 0 0 2.12-3.25m4.02-3H1v1.5h14z"/>`
    }, props));
$84b9acbe41f164e0$var$TextStrikethroughIcon.displayName = 'TextStrikethroughIcon';
var $84b9acbe41f164e0$var$_default = module.exports.default = $84b9acbe41f164e0$var$TextStrikethroughIcon;

});

parcelRegister("f2cYq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e6328b238b4e1d4c8883ade823798f3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af211b314b27c0f8$var$_react = $af211b314b27c0f8$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $af211b314b27c0f8$var$_baseNew = $af211b314b27c0f8$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $af211b314b27c0f8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextUnderline".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for underlined text tool
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af211b314b27c0f8$var$TextUnderlineIcon = (props)=>/*#__PURE__*/ $af211b314b27c0f8$var$_react.default.createElement($af211b314b27c0f8$var$_baseNew.default, Object.assign({
        name: "TextUnderlineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.5 8V1H5v7a3 3 0 0 0 6 0V1h1.5v7a4.5 4.5 0 1 1-9 0M0 16v-1.5h16V16z" clip-rule="evenodd"/>`
    }, props));
$af211b314b27c0f8$var$TextUnderlineIcon.displayName = 'TextUnderlineIcon';
var $af211b314b27c0f8$var$_default = module.exports.default = $af211b314b27c0f8$var$TextUnderlineIcon;

});

parcelRegister("cOhad", function(module, exports) {
$parcel$export(module.exports, "Subscript", () => $3a2856d6d9564a49$export$54eb3b8088f84d2b);
$parcel$export(module.exports, "Superscript", () => $3a2856d6d9564a49$export$a4eac561e2e9d419);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $3a2856d6d9564a49$var$SVGContainer = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        style: {
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)",
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        children: children
    });
const $3a2856d6d9564a49$export$54eb3b8088f84d2b = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)($3a2856d6d9564a49$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M5.10609 6.54799L7.88895 2.09448L9.16102 2.88936L5.99047 7.9633L9.21219 13.1191L7.94012 13.914L5.10609 9.37861L2.27207 13.914L1 13.1191L4.2217 7.9633L1.05117 2.88939L2.32324 2.09451L5.10609 6.54799ZM10.858 15.0001V13.696H12.3499V10.3153L10.8418 11.4343V9.86413L12.3138 8.83114H13.8161V13.696H14.9999V15.0001H10.858Z",
                fill: "currentColor"
            })
        })
    });
const $3a2856d6d9564a49$export$a4eac561e2e9d419 = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)($3a2856d6d9564a49$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M10.858 7.16892V5.86487H12.3499V2.4842L10.8418 3.60312V2.03298L12.3138 1H13.8161V5.86487H14.9999V7.16892H10.858ZM5.10609 6.5479L7.88895 2.09439L9.16102 2.88927L5.99047 7.96321L9.21219 13.119L7.94012 13.9139L5.10609 9.37852L2.27207 13.9139L1 13.119L4.2217 7.96321L1.05117 2.8893L2.32324 2.09442L5.10609 6.5479Z",
                fill: "currentColor"
            })
        })
    });

});


parcelRegister("5qGII", function(module, exports) {
$parcel$export(module.exports, "useIconList", () => $06fc91f891d1b505$export$894adbec036a07c6);

var $eJOHy = parcelRequire("eJOHy");
const $06fc91f891d1b505$export$894adbec036a07c6 = ({ icons: icons, iconTypeList: iconTypeList })=>{
    return (0, $eJOHy.useMemo)(()=>{
        return icons.reduce((acc, icon)=>{
            if (!icon || !icon.iconMark) return acc;
            const isIconSingleButton = iconTypeList.includes(icon.iconMark);
            if (isIconSingleButton) return {
                dropdownItems: acc.dropdownItems,
                singleItems: [
                    ...acc.singleItems,
                    icon
                ]
            };
            return {
                dropdownItems: [
                    ...acc.dropdownItems,
                    icon
                ],
                singleItems: acc.singleItems
            };
        }, {
            dropdownItems: [],
            singleItems: []
        });
    }, [
        icons,
        iconTypeList
    ]);
};

});

parcelRegister("91V0n", function(module, exports) {
$parcel$export(module.exports, "SingleToolbarButtons", () => $c004f81d43c31872$export$e3e9702c9c21585);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $fcJnk = parcelRequire("fcJnk");

var $9Sic1 = parcelRequire("9Sic1");

var $eGOwo = parcelRequire("eGOwo");
const $c004f81d43c31872$export$e3e9702c9c21585 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ items: items, isReducedSpacing: isReducedSpacing, editorView: editorView })=>{
    const onClick = (0, $eJOHy.useCallback)((command)=>{
        return ()=>{
            command(editorView.state, editorView.dispatch);
            return false;
        };
    }, [
        editorView.state,
        editorView.dispatch
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
        (0, $eGOwo.fg)('platform-visual-refresh-icons') ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $fcJnk.buttonGroupStyle) : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $fcJnk.buttonGroupStyleBeforeVisualRefresh)
    }, items.map((item)=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, $9Sic1.default), {
            key: item.key,
            testId: `editor-toolbar__${String(item.content)}`,
            buttonId: item.buttonId,
            spacing: isReducedSpacing ? 'none' : 'default',
            onClick: onClick(item.command),
            selected: item.isActive,
            disabled: item.isDisabled,
            title: item.tooltipElement,
            iconBefore: item.iconElement,
            "aria-pressed": item.isActive,
            "aria-label": item['aria-label'] ?? String(item.content),
            "aria-keyshortcuts": item['aria-keyshortcuts']
        }))));
});

});


parcelRegister("amor0", function(module, exports) {
$parcel$export(module.exports, "PrimaryToolbarComponent", () => $3116a324b6c063c5$export$94516d5cccf573e3);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $cxXTK = parcelRequire("cxXTK");

var $fyCt7 = parcelRequire("fyCt7");

var $iIDdW = parcelRequire("iIDdW");
const $3116a324b6c063c5$var$selector = (states)=>{
    return {
        isInitialised: Boolean(states.textFormattingState?.isInitialised),
        formattingIsPresent: states.textFormattingState?.formattingIsPresent,
        emActive: states.textFormattingState?.emActive,
        emDisabled: states.textFormattingState?.emDisabled,
        emHidden: states.textFormattingState?.emHidden,
        codeActive: states.textFormattingState?.codeActive,
        codeDisabled: states.textFormattingState?.codeDisabled,
        codeHidden: states.textFormattingState?.codeHidden,
        underlineActive: states.textFormattingState?.underlineActive,
        underlineDisabled: states.textFormattingState?.underlineDisabled,
        underlineHidden: states.textFormattingState?.underlineHidden,
        strikeActive: states.textFormattingState?.strikeActive,
        strikeDisabled: states.textFormattingState?.strikeDisabled,
        strikeHidden: states.textFormattingState?.strikeHidden,
        strongActive: states.textFormattingState?.strongActive,
        strongDisabled: states.textFormattingState?.strongDisabled,
        strongHidden: states.textFormattingState?.strongHidden,
        superscriptActive: states.textFormattingState?.superscriptActive,
        superscriptDisabled: states.textFormattingState?.superscriptDisabled,
        superscriptHidden: states.textFormattingState?.superscriptHidden,
        subscriptActive: states.textFormattingState?.subscriptActive,
        subscriptDisabled: states.textFormattingState?.subscriptDisabled,
        subscriptHidden: states.textFormattingState?.subscriptHidden
    };
};
const $3116a324b6c063c5$export$94516d5cccf573e3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ api: api, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, editorView: editorView, disabled: disabled, isReducedSpacing: isReducedSpacing, shouldUseResponsiveToolbar: shouldUseResponsiveToolbar })=>{
    const textFormattingState = (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'textFormatting'
    ], $3116a324b6c063c5$var$selector);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fyCt7.default), {
        textFormattingState: textFormattingState,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement,
        toolbarSize: toolbarSize,
        isReducedSpacing: isReducedSpacing,
        editorView: editorView,
        isToolbarDisabled: disabled,
        shouldUseResponsiveToolbar: shouldUseResponsiveToolbar,
        editorAnalyticsAPI: api?.analytics?.actions,
        api: api,
        toolbarType: (0, $iIDdW.ToolbarType).PRIMARY
    });
});

});
parcelRegister("fyCt7", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d6d3bee8fbfd23d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");

var $5ZVTg = parcelRequire("5ZVTg");

var $1D5wE = parcelRequire("1D5wE");

var $fcJnk = parcelRequire("fcJnk");

var $bQBk1 = parcelRequire("bQBk1");

var $eGOwo = parcelRequire("eGOwo");

var $92xoS = parcelRequire("92xoS");

var $7Dx2R = parcelRequire("7Dx2R");

var $lW769 = parcelRequire("lW769");

var $fuNer = parcelRequire("fuNer");

var $8kTsv = parcelRequire("8kTsv");

var $gZoIv = parcelRequire("gZoIv");

var $6ab1O = parcelRequire("6ab1O");

var $91V0n = parcelRequire("91V0n");
const $9d6d3bee8fbfd23d$var$ToolbarFormatting = ({ shouldUseResponsiveToolbar: shouldUseResponsiveToolbar, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView, toolbarSize: toolbarSize, isReducedSpacing: isReducedSpacing, isToolbarDisabled: isToolbarDisabled, intl: intl, editorAnalyticsAPI: editorAnalyticsAPI, textFormattingState: textFormattingState, api: api, toolbarType: toolbarType })=>{
    const [message, setMessage] = (0, $eJOHy.useState)('');
    const { formattingIsPresent: formattingIsPresent, ...formattingIconState } = textFormattingState;
    const defaultIcons = (0, $8kTsv.useFormattingIcons)({
        schema: editorView.state.schema,
        intl: intl,
        isToolbarDisabled: isToolbarDisabled,
        editorAnalyticsAPI: editorAnalyticsAPI,
        textFormattingState: formattingIconState,
        toolbarType: toolbarType
    });
    const clearIcon = (0, $fuNer.useClearIcon)({
        formattingPluginInitialised: textFormattingState.isInitialised,
        formattingIsPresent: formattingIsPresent,
        intl: intl,
        editorAnalyticsAPI: editorAnalyticsAPI,
        toolbarType: toolbarType
    });
    const menuIconTypeList = (0, $gZoIv.useResponsiveIconTypeMenu)({
        toolbarSize: toolbarSize,
        responsivenessEnabled: shouldUseResponsiveToolbar
    });
    const hasFormattingActive = (0, $8kTsv.useHasFormattingActived)({
        iconTypeList: menuIconTypeList,
        textFormattingState: textFormattingState
    });
    const { dropdownItems: dropdownItems, singleItems: singleItems } = (0, $gZoIv.useResponsiveToolbarButtons)({
        icons: defaultIcons,
        toolbarSize: toolbarSize,
        responsivenessEnabled: shouldUseResponsiveToolbar
    });
    const clearFormattingStatus = intl.formatMessage((0, $1D5wE.toolbarMessages).textFormattingOff);
    const superscriptOffSubscriptOnStatus = intl.formatMessage((0, $1D5wE.toolbarMessages).superscriptOffSubscriptOn);
    const subscriptOffSuperscriptOnStatus = intl.formatMessage((0, $1D5wE.toolbarMessages).subscriptOffSuperscriptOn);
    const activeItems = [
        ...dropdownItems,
        ...singleItems
    ].filter((item)=>item.isActive);
    const prevActiveItems = (0, $5ZVTg.default)(activeItems) ?? [];
    const fromSuperscriptToSubscript = (0, $7Dx2R.isArrayContainsContent)(activeItems, 'Subscript') && (0, $7Dx2R.isArrayContainsContent)(prevActiveItems, 'Superscript');
    const fromSubscriptToSuperscript = (0, $7Dx2R.isArrayContainsContent)(activeItems, 'Superscript') && (0, $7Dx2R.isArrayContainsContent)(prevActiveItems, 'Subscript');
    let comparedItems;
    let screenReaderMessage = '';
    if (prevActiveItems && activeItems.length > prevActiveItems.length) {
        comparedItems = (0, $7Dx2R.compareItemsArrays)(activeItems, prevActiveItems);
        screenReaderMessage = intl.formatMessage((0, $1D5wE.toolbarMessages).on, {
            formattingType: comparedItems[0].content
        });
    } else {
        comparedItems = (0, $7Dx2R.compareItemsArrays)(prevActiveItems, activeItems);
        if (comparedItems && comparedItems.length) {
            screenReaderMessage = intl.formatMessage((0, $1D5wE.toolbarMessages).off, {
                formattingType: comparedItems[0].content
            });
            if (activeItems[0]?.content === 'Code') screenReaderMessage = intl.formatMessage((0, $1D5wE.toolbarMessages).codeOn, {
                textFormattingOff: prevActiveItems?.length > 1 ? clearFormattingStatus : screenReaderMessage
            });
            if (fromSuperscriptToSubscript) screenReaderMessage = superscriptOffSubscriptOnStatus;
            if (fromSubscriptToSuperscript) screenReaderMessage = subscriptOffSuperscriptOnStatus;
        }
    }
    // handle 'Clear formatting' status for screen readers
    if (!activeItems?.length && prevActiveItems?.length > 1) screenReaderMessage = clearFormattingStatus;
    const items = (0, $eJOHy.useMemo)(()=>{
        if (!clearIcon) return [
            {
                items: dropdownItems
            }
        ];
        return [
            {
                items: dropdownItems
            },
            {
                items: [
                    clearIcon
                ]
            }
        ];
    }, [
        clearIcon,
        dropdownItems
    ]);
    const moreFormattingButtonLabel = intl.formatMessage((0, $1D5wE.toolbarMessages).moreFormatting);
    const labelTextFormat = intl.formatMessage((0, $1D5wE.toolbarMessages).textFormatting);
    (0, $eJOHy.useEffect)(()=>{
        if (screenReaderMessage) setMessage(screenReaderMessage);
    }, [
        screenReaderMessage
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
        (0, $eGOwo.fg)('platform-visual-refresh-icons') ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $fcJnk.buttonGroupStyle) : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $fcJnk.buttonGroupStyleBeforeVisualRefresh)
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        role: "group",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: 'js-text-format-wrap',
        "aria-label": labelTextFormat
    }, message && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $bQBk1.default), {
        ariaLive: "assertive",
        text: message,
        ariaRelevant: "additions",
        delay: 250
    }), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $91V0n.SingleToolbarButtons), {
        items: singleItems,
        editorView: editorView,
        isReducedSpacing: isReducedSpacing
    }), /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage
        css: (0, $fcJnk.wrapperStyle)
    }, isToolbarDisabled && !(0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, $1NIU8.jsx)("div", null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $6ab1O.MoreButton), {
        label: moreFormattingButtonLabel,
        isReducedSpacing: isReducedSpacing,
        isDisabled: true,
        isSelected: false,
        "aria-expanded": undefined,
        "aria-pressed": undefined
    })) : /*#__PURE__*/ (0, $1NIU8.jsx)((0, $lW769.FormattingTextDropdownMenu), {
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        editorView: editorView,
        isReducedSpacing: isReducedSpacing,
        moreButtonLabel: moreFormattingButtonLabel,
        hasFormattingActive: hasFormattingActive,
        hasMoreButton: !(0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1'),
        items: items,
        intl: intl,
        toolbarType: toolbarType,
        isDisabled: (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? isToolbarDisabled : false
    }))), !api?.primaryToolbar && /* eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: (0, $fcJnk.separatorStyles)
    })));
};
const $9d6d3bee8fbfd23d$var$Toolbar = ({ popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, isReducedSpacing: isReducedSpacing, editorView: editorView, isToolbarDisabled: isToolbarDisabled, shouldUseResponsiveToolbar: shouldUseResponsiveToolbar, intl: intl, editorAnalyticsAPI: editorAnalyticsAPI, textFormattingState: textFormattingState, api: api, toolbarType: toolbarType })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)($9d6d3bee8fbfd23d$var$ToolbarFormatting, {
        textFormattingState: textFormattingState,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement,
        toolbarSize: toolbarSize,
        isReducedSpacing: isReducedSpacing,
        editorView: editorView,
        isToolbarDisabled: isToolbarDisabled,
        shouldUseResponsiveToolbar: shouldUseResponsiveToolbar,
        intl: intl,
        editorAnalyticsAPI: editorAnalyticsAPI,
        api: api,
        toolbarType: toolbarType
    });
};
var $9d6d3bee8fbfd23d$export$2e2bcd8739ae039 = (0, $6YFG2.default)($9d6d3bee8fbfd23d$var$Toolbar);

});
parcelRegister("gZoIv", function(module, exports) {
$parcel$export(module.exports, "useResponsiveIconTypeMenu", () => $2435e103daa04534$export$110e6c3d6580196f);
$parcel$export(module.exports, "useResponsiveToolbarButtons", () => $2435e103daa04534$export$efa5449fdb315092);

var $eJOHy = parcelRequire("eJOHy");

var $9Letn = parcelRequire("9Letn");

var $84UAZ = parcelRequire("84UAZ");

var $5qGII = parcelRequire("5qGII");
const $2435e103daa04534$export$29ca18d8ace26dd8 = ({ toolbarSize: toolbarSize, responsivenessEnabled: responsivenessEnabled })=>{
    let ResponsiveCustomButtonToolbar = (0, $84UAZ.ResponsiveCustomButtonToolbarCompact);
    if ((0, $9Letn.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1')) ResponsiveCustomButtonToolbar = (0, $84UAZ.ResponsiveCustomButtonToolbarMinimal);
    const iconTypeList = (0, $eJOHy.useMemo)(()=>ResponsiveCustomButtonToolbar[toolbarSize], [
        toolbarSize,
        ResponsiveCustomButtonToolbar
    ]);
    if (responsivenessEnabled) return iconTypeList;
    if ((0, $9Letn.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1')) return 0, $84UAZ.ToolbarButtonsStrong;
    else return 0, $84UAZ.ToolbarButtonsStrongItalic;
};
const $2435e103daa04534$export$110e6c3d6580196f = ({ toolbarSize: toolbarSize, responsivenessEnabled: responsivenessEnabled })=>{
    let ResponsiveCustomMenu = (0, $84UAZ.ResponsiveCustomMenuCompact);
    if ((0, $9Letn.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1')) ResponsiveCustomMenu = (0, $84UAZ.ResponsiveCustomMenuMinimal);
    const iconTypeList = (0, $eJOHy.useMemo)(()=>ResponsiveCustomMenu[toolbarSize], [
        toolbarSize,
        ResponsiveCustomMenu
    ]);
    if (responsivenessEnabled) return iconTypeList;
    if ((0, $9Letn.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1')) return 0, $84UAZ.ButtonsMenuMinimal;
    else return 0, $84UAZ.ToolbarButtonsStrongItalic;
};
const $2435e103daa04534$export$efa5449fdb315092 = ({ icons: icons, toolbarSize: toolbarSize, responsivenessEnabled: responsivenessEnabled })=>{
    const iconTypeList = $2435e103daa04534$export$29ca18d8ace26dd8({
        toolbarSize: toolbarSize,
        responsivenessEnabled: responsivenessEnabled
    });
    const iconsPosition = (0, $5qGII.useIconList)({
        icons: icons,
        iconTypeList: iconTypeList
    });
    return iconsPosition;
};

});



parcelRegister("bGYYb", function(module, exports) {
$parcel$export(module.exports, "getToolbarComponents", () => $f4ed231c1bf0a5e9$export$a758406ca53b86a5);

var $3nXUe = parcelRequire("3nXUe");

var $8vczc = parcelRequire("8vczc");

var $aktt4 = parcelRequire("aktt4");

var $knNGL = parcelRequire("knNGL");

var $2cR2Z = parcelRequire("2cR2Z");
const $f4ed231c1bf0a5e9$export$a758406ca53b86a5 = (api)=>{
    return [
        ...(0, $aktt4.textFormattingGroupForPrimaryToolbar)(api),
        ...(0, $8vczc.textFormattingGroupForInlineToolbar)(api),
        ...(0, $3nXUe.boldButtonGroup)(api),
        ...(0, $2cR2Z.underlineButtonGroup)(api),
        ...(0, $knNGL.textFormattingMenuGroup)(api)
    ];
};

});
parcelRegister("3nXUe", function(module, exports) {
$parcel$export(module.exports, "boldButtonGroup", () => $281dd9728731913b$export$838bd3df7e6d113c);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $3KjUM = parcelRequire("3KjUM");
var $6996L = parcelRequire("6996L");
var $c0YTT = parcelRequire("c0YTT");

var $f893H = parcelRequire("f893H");
var $1ZfmT = parcelRequire("1ZfmT");

var $iIDdW = parcelRequire("iIDdW");

var $3I6tH = parcelRequire("3I6tH");

var $532OB = parcelRequire("532OB");
const $281dd9728731913b$var$BoldButtonGroup = ({ children: children })=>{
    const { editorAppearance: editorAppearance } = (0, $c0YTT.useEditorToolbar)();
    if (editorAppearance === 'full-page') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f893H.Show), {
        above: "xl",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1ZfmT.ToolbarButtonGroup), {
            children: children
        })
    });
};
const $281dd9728731913b$export$838bd3df7e6d113c = (api)=>[
        {
            type: (0, $3KjUM.BOLD_BUTTON_GROUP).type,
            key: (0, $3KjUM.BOLD_BUTTON_GROUP).key,
            parents: [
                {
                    type: (0, $3KjUM.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $3KjUM.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $6996L.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $3KjUM.BOLD_BUTTON_GROUP).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $gt9Am.jsx)($281dd9728731913b$var$BoldButtonGroup, {
                    children: children
                });
            }
        },
        {
            type: (0, $3KjUM.BOLD_BUTTON).type,
            key: (0, $3KjUM.BOLD_BUTTON).key,
            parents: [
                {
                    type: (0, $3KjUM.BOLD_BUTTON_GROUP).type,
                    key: (0, $3KjUM.BOLD_BUTTON_GROUP).key,
                    rank: 100
                }
            ],
            component: ({ parents: parents })=>{
                const { icon: icon, command: command, shortcut: shortcut, title: title } = (0, $532OB.formatOptions)().strong;
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3I6tH.FormatButton), {
                    api: api,
                    parents: parents,
                    icon: icon,
                    title: title,
                    shortcut: shortcut,
                    optionType: (0, $iIDdW.FormatOptions).strong,
                    toggleMarkWithAnalyticsCallback: command
                });
            }
        }
    ];

});
parcelRegister("3I6tH", function(module, exports) {
$parcel$export(module.exports, "FormatMenuItem", () => $a42a0ba90cec88c4$export$ddf8e5968f0fbf06);
$parcel$export(module.exports, "FormatButton", () => $a42a0ba90cec88c4$export$4ce756b69a643bb2);
$parcel$export(module.exports, "ClearFormatMenuItem", () => $a42a0ba90cec88c4$export$2d10ff258f7812b8);
$parcel$export(module.exports, "MoreFormattingMenu", () => $a42a0ba90cec88c4$export$f2e08b351bba4df);
$parcel$export(module.exports, "MenuSection", () => $a42a0ba90cec88c4$export$4b1545b4f2016d26);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $cxXTK = parcelRequire("cxXTK");

var $6Exgk = parcelRequire("6Exgk");

var $1D5wE = parcelRequire("1D5wE");

var $e7Koy = parcelRequire("e7Koy");
var $3KjUM = parcelRequire("3KjUM");

var $kmgRi = parcelRequire("kmgRi");
var $1ivsK = parcelRequire("1ivsK");
var $aDNj8 = parcelRequire("aDNj8");
var $dFLJN = parcelRequire("dFLJN");
var $9tvdK = parcelRequire("9tvdK");
var $lNljc = parcelRequire("lNljc");
var $ayYTB = parcelRequire("ayYTB");
var $64R2q = parcelRequire("64R2q");

var $cbSL1 = parcelRequire("cbSL1");

var $2yLcK = parcelRequire("2yLcK");

var $532OB = parcelRequire("532OB");
const $a42a0ba90cec88c4$export$ddf8e5968f0fbf06 = ({ parents: parents, api: api, optionType: optionType, toggleMarkWithAnalyticsCallback: toggleMarkWithAnalyticsCallback, icon: icon, shortcut: shortcut, title: title })=>{
    const { isActive: isActive, isDisabled: isDisabled, isHidden: isHidden, shortcutContent: shortcutContent, onClick: onClick, ariaLabel: ariaLabel, formatTitle: formatTitle } = (0, $532OB.useComponentInfo)({
        api: api,
        optionType: optionType,
        title: title,
        shortcut: shortcut,
        toggleMarkWithAnalyticsCallback: toggleMarkWithAnalyticsCallback,
        parents: parents
    });
    const Icon = icon;
    if (isHidden) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dFLJN.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
            size: "small",
            label: ""
        }),
        elemAfter: shortcutContent && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ayYTB.ToolbarKeyboardShortcutHint), {
            shortcut: shortcutContent
        }),
        isDisabled: isDisabled,
        isSelected: isActive,
        onClick: onClick,
        "aria-keyshortcuts": (0, $6Exgk.getAriaKeyshortcuts)(shortcut),
        "aria-label": ariaLabel,
        children: formatTitle
    });
};
const $a42a0ba90cec88c4$export$4ce756b69a643bb2 = ({ parents: parents, api: api, optionType: optionType, toggleMarkWithAnalyticsCallback: toggleMarkWithAnalyticsCallback, icon: icon, shortcut: shortcut, title: title })=>{
    const { isActive: isActive, isDisabled: isDisabled, onClick: onClick, ariaLabel: ariaLabel, formatTitle: formatTitle } = (0, $532OB.useComponentInfo)({
        api: api,
        optionType: optionType,
        title: title,
        shortcut: shortcut,
        toggleMarkWithAnalyticsCallback: toggleMarkWithAnalyticsCallback,
        parents: parents
    });
    const Icon = icon;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $64R2q.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6Exgk.ToolTipContent), {
            description: formatTitle,
            keymap: shortcut
        }),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aDNj8.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                label: ariaLabel,
                size: "small"
            }),
            onClick: onClick,
            isSelected: isActive,
            isDisabled: isDisabled,
            ariaKeyshortcuts: (0, $6Exgk.getAriaKeyshortcuts)(shortcut),
            testId: `editor-toolbar__${formatTitle}`
        })
    });
};
const $a42a0ba90cec88c4$export$2d10ff258f7812b8 = ({ api: api, parents: parents })=>{
    const { isInitialised: isInitialised, isFormattingPresent: isFormattingPresent } = (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'textFormatting'
    ], (states)=>({
            isInitialised: states.textFormattingState?.isInitialised,
            isFormattingPresent: states.textFormattingState?.formattingIsPresent
        }));
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (!isInitialised) return null;
    const formatTitle = formatMessage((0, $1D5wE.toolbarMessages).clearFormatting);
    const shortcutContent = (0, $6Exgk.tooltip)((0, $6Exgk.clearFormatting));
    const onClick = ()=>{
        api?.core.actions.execute((0, $2yLcK.clearFormattingWithAnalyticsNext)(api?.analytics?.actions)((0, $e7Koy.getInputMethodFromParentKeys)(parents)));
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dFLJN.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kmgRi))), {
            label: "",
            size: "small"
        }),
        elemAfter: shortcutContent && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ayYTB.ToolbarKeyboardShortcutHint), {
            shortcut: shortcutContent
        }),
        isDisabled: !isFormattingPresent,
        onClick: onClick,
        ariaKeyshortcuts: (0, $6Exgk.getAriaKeyshortcuts)((0, $6Exgk.clearFormatting)),
        children: formatTitle
    });
};
const $a42a0ba90cec88c4$export$f2e08b351bba4df = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const content = formatMessage((0, $1D5wE.toolbarMessages).moreFormatting);
    return (0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $64R2q.ToolbarTooltip), {
        content: formatMessage((0, $1D5wE.toolbarMessages).textFormat),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lNljc.ToolbarDropdownMenu), {
            iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1ivsK.MoreItemsIcon), {
                label: "",
                testId: "more-formatting"
            }),
            label: content,
            children: children
        })
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lNljc.ToolbarDropdownMenu), {
        iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1ivsK.MoreItemsIcon), {
            label: "",
            testId: "more-formatting"
        }),
        label: content,
        children: children
    });
};
const $a42a0ba90cec88c4$export$4b1545b4f2016d26 = ({ children: children, title: title, parents: parents })=>{
    const hasSeparator = parents.some((parent)=>parent.key === (0, $3KjUM.TEXT_COLLAPSED_MENU).key);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9tvdK.ToolbarDropdownItemSection), {
        hasSeparator: hasSeparator,
        title: title,
        children: children
    });
};

});
parcelRegister("532OB", function(module, exports) {
$parcel$export(module.exports, "useComponentInfo", () => $c8f9507924512532$export$fd1f6c37ffd41092);
$parcel$export(module.exports, "formatOptions", () => $c8f9507924512532$export$fb6751f88f91d177);

var $lRq8t = parcelRequire("lRq8t");

var $cxXTK = parcelRequire("cxXTK");

var $6Exgk = parcelRequire("6Exgk");

var $1D5wE = parcelRequire("1D5wE");

var $3KjUM = parcelRequire("3KjUM");
var $e7Koy = parcelRequire("e7Koy");
var $6996L = parcelRequire("6996L");

var $5iunZ = parcelRequire("5iunZ");
var $8lO5P = parcelRequire("8lO5P");
var $lwr5e = parcelRequire("lwr5e");
var $bouBs = parcelRequire("bouBs");
var $dltc6 = parcelRequire("dltc6");
var $iT3zM = parcelRequire("iT3zM");
var $f2cYq = parcelRequire("f2cYq");

var $fYXDG = parcelRequire("fYXDG");
const $c8f9507924512532$var$FormatMarkSchema = {
    strong: 'strong',
    em: 'em',
    underline: 'underline',
    strike: 'strike',
    code: 'code',
    subscript: 'subsup',
    superscript: 'subsup'
};
const $c8f9507924512532$export$fd1f6c37ffd41092 = ({ api: api, optionType: optionType, title: title, shortcut: shortcut, toggleMarkWithAnalyticsCallback: toggleMarkWithAnalyticsCallback, parents: parents })=>{
    const { isActive: isActive, isDisabled: isDisabled, isHidden: isHidden, isPluginInitialised: isPluginInitialised } = (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'textFormatting'
    ], (states)=>({
            isActive: states.textFormattingState?.[`${optionType}Active`],
            isDisabled: states.textFormattingState?.[`${optionType}Disabled`],
            isHidden: states.textFormattingState?.[`${optionType}Hidden`],
            isPluginInitialised: states.textFormattingState?.isInitialised
        }));
    const hasMarkSchema = api?.core?.sharedState.currentState()?.schema?.marks[$c8f9507924512532$var$FormatMarkSchema[optionType]];
    let formatOptionState;
    if (!isPluginInitialised) formatOptionState = {
        isActive: false,
        isDisabled: true,
        isHidden: false
    };
    else formatOptionState = {
        isActive: Boolean(isActive),
        isDisabled: Boolean(isDisabled),
        isHidden: Boolean(!hasMarkSchema || isHidden)
    };
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const formatTitle = formatMessage(title);
    const shortcutContent = (0, $6Exgk.tooltip)(shortcut);
    const ariaLabel = (0, $6Exgk.tooltip)(shortcut, formatTitle);
    const onClick = ()=>{
        api?.core.actions.execute(toggleMarkWithAnalyticsCallback(api?.analytics?.actions)((0, $e7Koy.getInputMethodFromParentKeys)(parents)));
    };
    return {
        ...formatOptionState,
        formatTitle: formatTitle,
        shortcutContent: shortcutContent,
        ariaLabel: ariaLabel || formatTitle,
        onClick: onClick
    };
};
const $c8f9507924512532$export$fb6751f88f91d177 = ()=>({
        strong: {
            rank: (0, $6996L.TEXT_FORMATTING_MENU_SECTION_RANK)[(0, $3KjUM.BOLD_MENU_ITEM).key],
            key: (0, $3KjUM.BOLD_MENU_ITEM).key,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($5iunZ))),
            title: (0, $1D5wE.toolbarMessages).bold,
            command: (0, $fYXDG.toggleStrongWithAnalytics),
            shortcut: (0, $6Exgk.toggleBold)
        },
        em: {
            rank: (0, $6996L.TEXT_FORMATTING_MENU_SECTION_RANK)[(0, $3KjUM.ITALIC_MENU_ITEM).key],
            key: (0, $3KjUM.ITALIC_MENU_ITEM).key,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lwr5e))),
            title: (0, $1D5wE.toolbarMessages).italic,
            command: (0, $fYXDG.toggleEmWithAnalytics),
            shortcut: (0, $6Exgk.toggleItalic)
        },
        underline: {
            rank: (0, $6996L.TEXT_FORMATTING_MENU_SECTION_RANK)[(0, $3KjUM.UNDERLINE_MENU_ITEM).key],
            key: (0, $3KjUM.UNDERLINE_MENU_ITEM).key,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($f2cYq))),
            title: (0, $1D5wE.toolbarMessages).underline,
            command: (0, $fYXDG.toggleUnderlineWithAnalytics),
            shortcut: (0, $6Exgk.toggleUnderline)
        },
        strike: {
            rank: (0, $6996L.TEXT_FORMATTING_MENU_SECTION_RANK)[(0, $3KjUM.STRIKE_MENU_ITEM).key],
            key: (0, $3KjUM.STRIKE_MENU_ITEM).key,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($bouBs))),
            title: (0, $1D5wE.toolbarMessages).strike,
            command: (0, $fYXDG.toggleStrikeWithAnalytics),
            shortcut: (0, $6Exgk.toggleStrikethrough)
        },
        code: {
            rank: (0, $6996L.TEXT_FORMATTING_MENU_SECTION_RANK)[(0, $3KjUM.CODE_MENU_ITEM).key],
            key: (0, $3KjUM.CODE_MENU_ITEM).key,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8lO5P))),
            title: (0, $1D5wE.toolbarMessages).code,
            command: (0, $fYXDG.toggleCodeWithAnalytics),
            shortcut: (0, $6Exgk.toggleCode)
        },
        subscript: {
            rank: (0, $6996L.TEXT_FORMATTING_MENU_SECTION_RANK)[(0, $3KjUM.SUBSCRIPT_MENU_ITEM).key],
            key: (0, $3KjUM.SUBSCRIPT_MENU_ITEM).key,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dltc6))),
            title: (0, $1D5wE.toolbarMessages).subscript,
            command: (0, $fYXDG.toggleSubscriptWithAnalytics),
            shortcut: (0, $6Exgk.toggleSubscript)
        },
        superscript: {
            rank: (0, $6996L.TEXT_FORMATTING_MENU_SECTION_RANK)[(0, $3KjUM.SUPERSCRIPT_MENU_ITEM).key],
            key: (0, $3KjUM.SUPERSCRIPT_MENU_ITEM).key,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iT3zM))),
            title: (0, $1D5wE.toolbarMessages).superscript,
            command: (0, $fYXDG.toggleSuperscriptWithAnalytics),
            shortcut: (0, $6Exgk.toggleSuperscript)
        }
    });

});
parcelRegister("dltc6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f5b21011f48bf458b340a61b5c22f75f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9b73e1df1cbe1877$var$_react = $9b73e1df1cbe1877$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9b73e1df1cbe1877$var$_baseNew = $9b73e1df1cbe1877$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $9b73e1df1cbe1877$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextSubscript".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for subscript text formatting.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9b73e1df1cbe1877$var$TextSubscriptIcon = (props)=>/*#__PURE__*/ $9b73e1df1cbe1877$var$_react.default.createElement($9b73e1df1cbe1877$var$_baseNew.default, Object.assign({
        name: "TextSubscriptIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m6.26 8 3.69 6H8.19L5.4 9.47 2.78 14H1.05l3.46-6-3.46-6h1.73L5.4 6.53 8.19 2h1.76zm7.49.5h.08a.75.75 0 0 1 .67.75V16H13v-6h-1V8.5z"/>`
    }, props));
$9b73e1df1cbe1877$var$TextSubscriptIcon.displayName = 'TextSubscriptIcon';
var $9b73e1df1cbe1877$var$_default = module.exports.default = $9b73e1df1cbe1877$var$TextSubscriptIcon;

});

parcelRegister("iT3zM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4915c62246fa16053f30e48aed5989a6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dc002333d548b757$var$_react = $dc002333d548b757$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $dc002333d548b757$var$_baseNew = $dc002333d548b757$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $dc002333d548b757$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextSuperscript".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for superscript text formatting.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dc002333d548b757$var$TextSuperscriptIcon = (props)=>/*#__PURE__*/ $dc002333d548b757$var$_react.default.createElement($dc002333d548b757$var$_baseNew.default, Object.assign({
        name: "TextSuperscriptIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m6.26 8 3.69 6H8.19L5.4 9.47 2.78 14H1.05l3.46-6-3.46-6h1.73L5.4 6.53 8.19 2h1.76zm7.49-8h.08a.75.75 0 0 1 .67.75V7.5H13v-6h-1V0z"/>`
    }, props));
$dc002333d548b757$var$TextSuperscriptIcon.displayName = 'TextSuperscriptIcon';
var $dc002333d548b757$var$_default = module.exports.default = $dc002333d548b757$var$TextSuperscriptIcon;

});




parcelRegister("8vczc", function(module, exports) {
$parcel$export(module.exports, "textFormattingGroupForInlineToolbar", () => $2404fedb37e6e5f0$export$653d8b3e035cd6f7);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6996L = parcelRequire("6996L");
var $3KjUM = parcelRequire("3KjUM");

var $1ZfmT = parcelRequire("1ZfmT");

var $iIDdW = parcelRequire("iIDdW");

var $3I6tH = parcelRequire("3I6tH");

var $532OB = parcelRequire("532OB");
const $2404fedb37e6e5f0$export$653d8b3e035cd6f7 = (api)=>[
        {
            type: (0, $3KjUM.TEXT_FORMATTING_GROUP_INLINE).type,
            key: (0, $3KjUM.TEXT_FORMATTING_GROUP_INLINE).key,
            parents: [
                {
                    type: (0, $3KjUM.TEXT_SECTION).type,
                    key: (0, $3KjUM.TEXT_SECTION).key,
                    rank: (0, $6996L.TEXT_SECTION_RANK)[(0, $3KjUM.TEXT_FORMATTING_GROUP).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1ZfmT.ToolbarButtonGroup), {
                    children: children
                });
            }
        },
        {
            type: (0, $3KjUM.TEXT_FORMATTING_HERO_BUTTON).type,
            key: (0, $3KjUM.TEXT_FORMATTING_HERO_BUTTON).key,
            parents: [
                {
                    type: (0, $3KjUM.TEXT_FORMATTING_GROUP_INLINE).type,
                    key: (0, $3KjUM.TEXT_FORMATTING_GROUP_INLINE).key,
                    rank: (0, $6996L.TEXT_FORMAT_GROUP_RANK)[(0, $3KjUM.TEXT_FORMATTING_HERO_BUTTON).key]
                }
            ],
            component: ({ parents: parents })=>{
                const { icon: icon, command: command, shortcut: shortcut, title: title } = (0, $532OB.formatOptions)().strong;
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3I6tH.FormatButton), {
                    api: api,
                    parents: parents,
                    icon: icon,
                    title: title,
                    shortcut: shortcut,
                    optionType: (0, $iIDdW.FormatOptions).strong,
                    toggleMarkWithAnalyticsCallback: command
                });
            }
        }
    ];

});

parcelRegister("aktt4", function(module, exports) {
$parcel$export(module.exports, "textFormattingGroupForPrimaryToolbar", () => $2dcc571f1c675756$export$ed04d15827dc03ae);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6996L = parcelRequire("6996L");
var $3KjUM = parcelRequire("3KjUM");
var $c0YTT = parcelRequire("c0YTT");

var $f893H = parcelRequire("f893H");
var $1ZfmT = parcelRequire("1ZfmT");

var $iIDdW = parcelRequire("iIDdW");

var $3I6tH = parcelRequire("3I6tH");

var $532OB = parcelRequire("532OB");
const $2dcc571f1c675756$var$TextFormattingGroup = ({ children: children })=>{
    const { editorAppearance: editorAppearance } = (0, $c0YTT.useEditorToolbar)();
    if (editorAppearance === 'full-page') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f893H.Show), {
        above: "xl",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1ZfmT.ToolbarButtonGroup), {
            children: children
        })
    });
};
const $2dcc571f1c675756$var$TextFormattingGroupCollapsed = ({ children: children })=>{
    const { editorAppearance: editorAppearance } = (0, $c0YTT.useEditorToolbar)();
    if (editorAppearance === 'full-page') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f893H.Show), {
        below: "xl",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1ZfmT.ToolbarButtonGroup), {
            children: children
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1ZfmT.ToolbarButtonGroup), {
        children: children
    });
};
const $2dcc571f1c675756$export$ed04d15827dc03ae = (api)=>[
        {
            type: (0, $3KjUM.TEXT_FORMATTING_GROUP).type,
            key: (0, $3KjUM.TEXT_FORMATTING_GROUP).key,
            parents: [
                {
                    type: (0, $3KjUM.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $3KjUM.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $6996L.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $3KjUM.TEXT_FORMATTING_GROUP).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $gt9Am.jsx)($2dcc571f1c675756$var$TextFormattingGroup, {
                    children: children
                });
            }
        },
        {
            type: (0, $3KjUM.TEXT_FORMATTING_GROUP_COLLAPSED).type,
            key: (0, $3KjUM.TEXT_FORMATTING_GROUP_COLLAPSED).key,
            parents: [
                {
                    type: (0, $3KjUM.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $3KjUM.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $6996L.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $3KjUM.TEXT_FORMATTING_GROUP).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $gt9Am.jsx)($2dcc571f1c675756$var$TextFormattingGroupCollapsed, {
                    children: children
                });
            }
        },
        {
            type: (0, $3KjUM.TEXT_FORMATTING_HERO_BUTTON).type,
            key: (0, $3KjUM.TEXT_FORMATTING_HERO_BUTTON).key,
            parents: [
                {
                    type: (0, $3KjUM.TEXT_FORMATTING_GROUP).type,
                    key: (0, $3KjUM.TEXT_FORMATTING_GROUP).key,
                    rank: (0, $6996L.TEXT_FORMAT_GROUP_RANK)[(0, $3KjUM.TEXT_FORMATTING_HERO_BUTTON).key]
                }
            ],
            component: ({ parents: parents })=>{
                const { icon: icon, command: command, shortcut: shortcut, title: title } = (0, $532OB.formatOptions)().em;
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3I6tH.FormatButton), {
                    api: api,
                    parents: parents,
                    icon: icon,
                    title: title,
                    shortcut: shortcut,
                    optionType: (0, $iIDdW.FormatOptions).em,
                    toggleMarkWithAnalyticsCallback: command
                });
            }
        },
        {
            type: (0, $3KjUM.TEXT_FORMATTING_HERO_BUTTON_COLLAPSED).type,
            key: (0, $3KjUM.TEXT_FORMATTING_HERO_BUTTON_COLLAPSED).key,
            parents: [
                {
                    type: (0, $3KjUM.TEXT_FORMATTING_GROUP_COLLAPSED).type,
                    key: (0, $3KjUM.TEXT_FORMATTING_GROUP_COLLAPSED).key,
                    rank: (0, $6996L.TEXT_FORMAT_GROUP_COLLAPSED_RANK)[(0, $3KjUM.TEXT_FORMATTING_HERO_BUTTON_COLLAPSED).key]
                }
            ],
            component: ({ parents: parents })=>{
                const { icon: icon, command: command, shortcut: shortcut, title: title } = (0, $532OB.formatOptions)().strong;
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3I6tH.FormatButton), {
                    api: api,
                    parents: parents,
                    icon: icon,
                    title: title,
                    shortcut: shortcut,
                    optionType: (0, $iIDdW.FormatOptions).strong,
                    toggleMarkWithAnalyticsCallback: command
                });
            }
        }
    ];

});

parcelRegister("knNGL", function(module, exports) {
$parcel$export(module.exports, "textFormattingMenuGroup", () => $075dc43462907a1b$export$21e1245c68e20dce);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $3KjUM = parcelRequire("3KjUM");
var $6996L = parcelRequire("6996L");

var $9tvdK = parcelRequire("9tvdK");

var $cbSL1 = parcelRequire("cbSL1");

var $3I6tH = parcelRequire("3I6tH");

var $532OB = parcelRequire("532OB");
const $075dc43462907a1b$export$922904c4345b3461 = (api)=>{
    return Object.entries((0, $532OB.formatOptions)()).map(([optionType, { icon: icon, shortcut: shortcut, title: title, command: command, rank: rank, key: key }])=>{
        return {
            type: 'menu-item',
            key: key,
            parents: [
                {
                    type: (0, $3KjUM.TEXT_FORMATTING_MENU_SECTION).type,
                    key: (0, $3KjUM.TEXT_FORMATTING_MENU_SECTION).key,
                    rank: rank
                }
            ],
            component: ({ parents: parents })=>{
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3I6tH.FormatMenuItem), {
                    api: api,
                    parents: parents,
                    icon: icon,
                    shortcut: shortcut,
                    title: title,
                    optionType: optionType,
                    toggleMarkWithAnalyticsCallback: command
                });
            }
        };
    });
};
const $075dc43462907a1b$export$21e1245c68e20dce = (api)=>[
        {
            type: (0, $3KjUM.TEXT_FORMATTING_MENU).type,
            key: (0, $3KjUM.TEXT_FORMATTING_MENU).key,
            parents: [
                {
                    type: (0, $3KjUM.TEXT_FORMATTING_GROUP).type,
                    key: (0, $3KjUM.TEXT_FORMATTING_GROUP).key,
                    rank: (0, $6996L.TEXT_FORMAT_GROUP_RANK)[(0, $3KjUM.TEXT_FORMATTING_MENU).key]
                },
                {
                    type: (0, $3KjUM.TEXT_FORMATTING_GROUP_COLLAPSED).type,
                    key: (0, $3KjUM.TEXT_FORMATTING_GROUP_COLLAPSED).key,
                    rank: (0, $6996L.TEXT_FORMAT_GROUP_RANK)[(0, $3KjUM.TEXT_FORMATTING_MENU).key]
                },
                {
                    type: (0, $3KjUM.TEXT_FORMATTING_GROUP_INLINE).type,
                    key: (0, $3KjUM.TEXT_FORMATTING_GROUP_INLINE).key,
                    rank: (0, $6996L.TEXT_FORMAT_GROUP_RANK)[(0, $3KjUM.TEXT_FORMATTING_HERO_BUTTON).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3I6tH.MoreFormattingMenu), {
                    children: children
                });
            }
        },
        {
            type: (0, $3KjUM.TEXT_FORMATTING_MENU_SECTION).type,
            key: (0, $3KjUM.TEXT_FORMATTING_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $3KjUM.TEXT_FORMATTING_MENU).type,
                    key: (0, $3KjUM.TEXT_FORMATTING_MENU).key,
                    rank: (0, $6996L.TEXT_FORMAT_MENU_RANK)[(0, $3KjUM.TEXT_FORMATTING_MENU_SECTION).key]
                },
                ...(0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_responsive', 'isEnabled', true) ? [
                    {
                        type: (0, $3KjUM.TEXT_COLLAPSED_MENU).type,
                        key: (0, $3KjUM.TEXT_COLLAPSED_MENU).key,
                        rank: (0, $6996L.TEXT_COLLAPSED_MENU_RANK)[(0, $3KjUM.TEXT_FORMATTING_MENU_SECTION).key]
                    }
                ] : []
            ],
            component: (0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_responsive', 'isEnabled', true) ? (0, $3I6tH.MenuSection) : undefined
        },
        ...$075dc43462907a1b$export$922904c4345b3461(api),
        {
            type: (0, $3KjUM.CLEAR_FORMARTTING_MENU_SECTION).type,
            key: (0, $3KjUM.CLEAR_FORMARTTING_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $3KjUM.TEXT_FORMATTING_MENU).type,
                    key: (0, $3KjUM.TEXT_FORMATTING_MENU).key,
                    rank: (0, $6996L.TEXT_FORMAT_MENU_RANK)[(0, $3KjUM.CLEAR_FORMARTTING_MENU_SECTION).key]
                },
                ...(0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_responsive', 'isEnabled', true) ? [
                    {
                        type: (0, $3KjUM.TEXT_COLLAPSED_MENU).type,
                        key: (0, $3KjUM.TEXT_COLLAPSED_MENU).key,
                        rank: (0, $6996L.TEXT_COLLAPSED_MENU_RANK)[(0, $3KjUM.CLEAR_FORMARTTING_MENU_SECTION).key]
                    }
                ] : []
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9tvdK.ToolbarDropdownItemSection), {
                    hasSeparator: true,
                    children: children
                });
            }
        },
        {
            type: (0, $3KjUM.CLEAR_FORMATTING_MENU_ITEM).type,
            key: (0, $3KjUM.CLEAR_FORMATTING_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $3KjUM.CLEAR_FORMARTTING_MENU_SECTION).type,
                    key: (0, $3KjUM.CLEAR_FORMARTTING_MENU_SECTION).key,
                    rank: (0, $6996L.CLEAR_FORMARTTING_MENU_SECTION_RANK)[(0, $3KjUM.CLEAR_FORMATTING_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>{
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3I6tH.ClearFormatMenuItem), {
                        parents: parents,
                        api: api
                    })
                });
            }
        }
    ];

});

parcelRegister("2cR2Z", function(module, exports) {
$parcel$export(module.exports, "underlineButtonGroup", () => $b26bd0cc3017458f$export$8988dc22a0ee54a7);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $3KjUM = parcelRequire("3KjUM");
var $6996L = parcelRequire("6996L");
var $c0YTT = parcelRequire("c0YTT");

var $f893H = parcelRequire("f893H");
var $1ZfmT = parcelRequire("1ZfmT");

var $iIDdW = parcelRequire("iIDdW");

var $3I6tH = parcelRequire("3I6tH");

var $532OB = parcelRequire("532OB");
const $b26bd0cc3017458f$var$UnderlineButtonGroup = ({ children: children })=>{
    const { editorAppearance: editorAppearance } = (0, $c0YTT.useEditorToolbar)();
    if (editorAppearance === 'full-page') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f893H.Show), {
        above: "xl",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1ZfmT.ToolbarButtonGroup), {
            children: children
        })
    });
};
const $b26bd0cc3017458f$export$8988dc22a0ee54a7 = (api)=>[
        {
            type: (0, $3KjUM.UNDERLINE_BUTTON_GROUP).type,
            key: (0, $3KjUM.UNDERLINE_BUTTON_GROUP).key,
            parents: [
                {
                    type: (0, $3KjUM.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $3KjUM.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $6996L.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $3KjUM.UNDERLINE_BUTTON_GROUP).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $gt9Am.jsx)($b26bd0cc3017458f$var$UnderlineButtonGroup, {
                    children: children
                });
            }
        },
        {
            type: (0, $3KjUM.UNDERLINE_BUTTON).type,
            key: (0, $3KjUM.UNDERLINE_BUTTON).key,
            parents: [
                {
                    type: (0, $3KjUM.UNDERLINE_BUTTON_GROUP).type,
                    key: (0, $3KjUM.UNDERLINE_BUTTON_GROUP).key,
                    rank: 100
                }
            ],
            component: ({ parents: parents })=>{
                const { icon: icon, command: command, shortcut: shortcut, title: title } = (0, $532OB.formatOptions)().underline;
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3I6tH.FormatButton), {
                    api: api,
                    parents: parents,
                    icon: icon,
                    title: title,
                    shortcut: shortcut,
                    optionType: (0, $iIDdW.FormatOptions).underline,
                    toggleMarkWithAnalyticsCallback: command
                });
            }
        }
    ];

});




parcelRegister("db6dP", function(module, exports) {
$parcel$export(module.exports, "typeAheadPlugin", () => (parcelRequire("5F9b7")).typeAheadPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $5F9b7 = parcelRequire("5F9b7");

});
parcelRegister("5F9b7", function(module, exports) {
$parcel$export(module.exports, "typeAheadPlugin", () => $fe52624c7c765b7f$export$a023c922ef32b883);
/**
 *
 * Revamped typeahead using decorations instead of the `typeAheadQuery` mark
 *
 * https://product-fabric.atlassian.net/wiki/spaces/E/pages/2992177582/Technical+TypeAhead+Data+Flow
 *
 *
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $anaPs = parcelRequire("anaPs");

var $bMFKb = parcelRequire("bMFKb");

var $i8KtF = parcelRequire("i8KtF");

var $7k8dr = parcelRequire("7k8dr");

var $b7EWj = parcelRequire("b7EWj");

var $eGOwo = parcelRequire("eGOwo");

var $azYbd = parcelRequire("azYbd");

var $cg71Z = parcelRequire("cg71Z");

var $PKsUR = parcelRequire("PKsUR");

var $2NBlM = parcelRequire("2NBlM");

var $3ATVn = parcelRequire("3ATVn");

var $kPuXt = parcelRequire("kPuXt");

var $kGFcc = parcelRequire("kGFcc");

var $akqoF = parcelRequire("akqoF");

var $elKSH = parcelRequire("elKSH");

var $7EuRs = parcelRequire("7EuRs");
const $fe52624c7c765b7f$var$createOpenAtTransaction = (editorAnalyticsAPI)=>(props)=>(tr)=>{
            const { triggerHandler: triggerHandler, inputMethod: inputMethod, query: query, removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = props;
            (0, $PKsUR.openTypeAheadAtCursor)({
                triggerHandler: triggerHandler,
                inputMethod: inputMethod,
                query: query,
                removePrefixTriggerOnCancel: removePrefixTriggerOnCancel
            })({
                tr: tr
            });
            // This function is called from the editor-plugin-emoji and editor-plugin-type-ahead
            // createOpenAtTransaction <- createOpenTypeAhead <- actions.open
            // 	<- emoji-plugin (Not used)
            //  <- type-ahead-plugin (Used)
            // and this caused the analytics event to be fired twice, as other places are relying on the
            // `onEditorViewStateUpdated` method to fire the analytics event
            // We want to disable this event
            if (!(0, $eGOwo.fg)('platform_editor_controls_patch_analytics_3')) editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $bMFKb.ACTION).INVOKED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).TYPEAHEAD,
                actionSubjectId: triggerHandler.id,
                attributes: {
                    inputMethod: inputMethod
                },
                eventType: (0, $bMFKb.EVENT_TYPE).UI
            })(tr);
            return true;
        };
const $fe52624c7c765b7f$var$createOpenTypeAhead = (editorViewRef, editorAnalyticsAPI)=>(props)=>{
        if (!editorViewRef.current) return false;
        const { current: view } = editorViewRef;
        const { tr: tr } = view.state;
        $fe52624c7c765b7f$var$createOpenAtTransaction(editorAnalyticsAPI)(props)(tr);
        view.dispatch(tr);
        return true;
    };
const $fe52624c7c765b7f$var$createInsertTypeAheadItem = (editorViewRef)=>(props)=>{
        if (!editorViewRef.current) return false;
        const { current: view } = editorViewRef;
        const { triggerHandler: triggerHandler, contentItem: contentItem, query: query, sourceListItem: sourceListItem, mode: mode } = props;
        (0, $cg71Z.insertTypeAheadItem)(view)({
            handler: triggerHandler,
            item: contentItem,
            mode: mode || (0, $7k8dr.SelectItemMode).SELECTED,
            query: query,
            sourceListItem: sourceListItem
        });
        return true;
    };
const $fe52624c7c765b7f$var$createFindHandlerByTrigger = (editorViewRef)=>(trigger)=>{
        if (!editorViewRef.current) return null;
        const { current: view } = editorViewRef;
        return (0, $elKSH.findHandler)(trigger, view.state);
    };
const $fe52624c7c765b7f$var$createCloseTypeAhead = (editorViewRef)=>(options)=>{
        if (!editorViewRef.current) return false;
        const { current: view } = editorViewRef;
        const currentQuery = (0, $elKSH.getTypeAheadQuery)(view.state) || '';
        const { state: state } = view;
        let tr = state.tr;
        if (options.attachCommand) {
            const fakeDispatch = (customTr)=>{
                tr = customTr;
            };
            options.attachCommand(state, fakeDispatch);
        }
        (0, $azYbd.closeTypeAhead)(tr);
        if (options.insertCurrentQueryAsRawText && currentQuery && currentQuery.length > 0) {
            const handler = (0, $elKSH.getTypeAheadHandler)(state);
            if (!handler) return false;
            const text = handler.trigger.concat(currentQuery);
            tr.replaceSelectionWith(state.schema.text(text));
        }
        view.dispatch(tr);
        if (!view.hasFocus()) view.focus();
        return true;
    };
const $fe52624c7c765b7f$export$a023c922ef32b883 = ({ api: api })=>{
    const popupMountRef = {
        current: null
    };
    const editorViewRef = {
        current: null
    };
    return {
        name: 'typeAhead',
        marks () {
            // We need to keep this to make sure
            // All documents with typeahead marks will be loaded normally
            return [
                {
                    name: 'typeAheadQuery',
                    mark: (0, $anaPs.typeAheadQuery)
                }
            ];
        },
        pmPlugins (typeAhead = []) {
            return [
                {
                    name: 'typeAhead',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(0, $kGFcc.createPlugin)({
                            getIntl: getIntl,
                            popupMountRef: popupMountRef,
                            reactDispatch: dispatch,
                            typeAheadHandlers: typeAhead,
                            nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                            api: api
                        })
                },
                {
                    name: 'typeAheadEditorViewRef',
                    plugin: ()=>{
                        return new (0, $i8KtF.SafePlugin)({
                            view (view) {
                                editorViewRef.current = view;
                                return {
                                    destroy () {
                                        editorViewRef.current = null;
                                    }
                                };
                            }
                        });
                    }
                },
                {
                    name: 'typeAheadInsertItem',
                    plugin: (0, $3ATVn.createPlugin)
                },
                {
                    name: 'typeAheadInputRule',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, $2NBlM.inputRulePlugin)(schema, typeAhead, featureFlags)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return {
                query: '',
                isOpen: false,
                isAllowed: false,
                currentHandler: undefined,
                decorationSet: (0, $b7EWj.DecorationSet).empty,
                decorationElement: null,
                triggerHandler: undefined,
                items: [],
                errorInfo: null,
                selectedIndex: 0
            };
            const isOpen = (0, $elKSH.isTypeAheadOpen)(editorState);
            const state = (0, $elKSH.getPluginState)(editorState);
            return {
                query: (0, $elKSH.getTypeAheadQuery)(editorState) || '',
                currentHandler: (0, $elKSH.getTypeAheadHandler)(editorState),
                isOpen: isOpen,
                isAllowed: !isOpen,
                decorationSet: state?.decorationSet ?? (0, $b7EWj.DecorationSet).empty,
                decorationElement: state?.decorationElement ?? null,
                triggerHandler: state?.triggerHandler,
                items: state?.items ?? [],
                errorInfo: state?.errorInfo ?? null,
                selectedIndex: state?.selectedIndex ?? 0
            };
        },
        actions: {
            isOpen: (0, $elKSH.isTypeAheadOpen),
            isAllowed: (0, $elKSH.isTypeAheadAllowed),
            open: $fe52624c7c765b7f$var$createOpenTypeAhead(editorViewRef, api?.analytics?.actions),
            openAtTransaction: $fe52624c7c765b7f$var$createOpenAtTransaction(api?.analytics?.actions),
            findHandlerByTrigger: $fe52624c7c765b7f$var$createFindHandlerByTrigger(editorViewRef),
            insert: $fe52624c7c765b7f$var$createInsertTypeAheadItem(editorViewRef),
            close: $fe52624c7c765b7f$var$createCloseTypeAhead(editorViewRef)
        },
        contentComponent ({ editorView: editorView, containerElement: containerElement, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, wrapperElement: wrapperElement }) {
            popupMountRef.current = {
                popupsMountPoint: popupsMountPoint || wrapperElement || undefined,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement || containerElement || undefined
            };
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7EuRs.ContentComponent), {
                editorView: editorView,
                popupMountRef: popupMountRef,
                api: api
            });
        },
        onEditorViewStateUpdated ({ originalTransaction: originalTransaction, oldEditorState: oldEditorState, newEditorState: newEditorState }) {
            const oldPluginState = (0, $elKSH.getPluginState)(oldEditorState);
            const newPluginState = (0, $elKSH.getPluginState)(newEditorState);
            if (!oldPluginState || !newPluginState) return;
            const { triggerHandler: oldTriggerHandler } = oldPluginState;
            const { triggerHandler: newTriggerHandler } = newPluginState;
            const isANewHandler = oldTriggerHandler !== newTriggerHandler;
            if (oldTriggerHandler?.dismiss && isANewHandler) {
                const typeAheadMessage = originalTransaction.getMeta((0, $kPuXt.pluginKey));
                const wasItemInserted = typeAheadMessage && typeAheadMessage.action === 'INSERT_RAW_QUERY';
                oldTriggerHandler.dismiss({
                    editorState: newEditorState,
                    query: oldPluginState.query,
                    stats: (oldPluginState.stats || new (0, $akqoF.StatsModifier)()).serialize(),
                    wasItemInserted: wasItemInserted
                });
            }
            if (newTriggerHandler?.onOpen && isANewHandler) {
                if ((0, $eGOwo.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.handleIntentToStartEdit({
                    shouldStartTimer: false,
                    shouldPersistActiveSession: true
                });
                newTriggerHandler.onOpen(newEditorState);
            }
            const oldIsOpen = (0, $elKSH.isTypeAheadOpen)(oldEditorState);
            const newIsOpen = (0, $elKSH.isTypeAheadOpen)(newEditorState);
            if (newTriggerHandler && isANewHandler) {
                // if the typeahead opens another typeahead via the quickInsert we do NOT want to fire this analytic event (mentions and emojis) as it is already being fired from editor-plugin-analytics
                const isDuplicateInvokedEvent = newPluginState.inputMethod === (0, $bMFKb.INPUT_METHOD).QUICK_INSERT && Object.values((0, $7k8dr.TypeAheadAvailableNodes)).includes(newTriggerHandler.id);
                if (!isDuplicateInvokedEvent) {
                    if ((0, $eGOwo.fg)('platform_editor_controls_patch_analytics_3')) api?.analytics?.actions?.fireAnalyticsEvent({
                        action: (0, $bMFKb.ACTION).INVOKED,
                        actionSubject: (0, $bMFKb.ACTION_SUBJECT).TYPEAHEAD,
                        actionSubjectId: newTriggerHandler.id || 'not_set',
                        attributes: {
                            inputMethod: newPluginState.inputMethod || (0, $bMFKb.INPUT_METHOD).KEYBOARD
                        },
                        eventType: (0, $bMFKb.EVENT_TYPE).UI
                    }, undefined, {
                        context: {
                            selection: newEditorState.selection
                        }
                    });
                    else api?.analytics?.actions?.fireAnalyticsEvent({
                        action: (0, $bMFKb.ACTION).INVOKED,
                        actionSubject: (0, $bMFKb.ACTION_SUBJECT).TYPEAHEAD,
                        actionSubjectId: newTriggerHandler.id || 'not_set',
                        attributes: {
                            inputMethod: newPluginState.inputMethod || (0, $bMFKb.INPUT_METHOD).KEYBOARD
                        },
                        eventType: (0, $bMFKb.EVENT_TYPE).UI
                    });
                }
            } else if (oldIsOpen && !newIsOpen && (0, $eGOwo.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
        }
    };
};

});
parcelRegister("azYbd", function(module, exports) {
$parcel$export(module.exports, "closeTypeAhead", () => $42233d5a860bd9e9$export$daba40574d0568e3);

var $ckKJp = parcelRequire("ckKJp");

var $kPuXt = parcelRequire("kPuXt");
const $42233d5a860bd9e9$export$daba40574d0568e3 = (tr)=>{
    return tr.setMeta((0, $kPuXt.pluginKey), {
        action: (0, $ckKJp.ACTIONS).CLOSE_TYPE_AHEAD
    });
};

});
parcelRegister("ckKJp", function(module, exports) {
$parcel$export(module.exports, "ACTIONS", () => $b11d849867a039e6$export$92a1a3b7554e9387);
var $b11d849867a039e6$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS["OPEN_TYPEAHEAD_AT_CURSOR"] = "OPEN_TYPEAHEAD_AT_CURSOR";
    ACTIONS["CLOSE_TYPE_AHEAD"] = "CLOSE_TYPE_AHEAD";
    ACTIONS["CHANGE_QUERY"] = "CHANGE_QUERY";
    ACTIONS["INSERT_ITEM"] = "INSERT_ITEM";
    ACTIONS["INSERT_RAW_QUERY"] = "INSERT_RAW_QUERY";
    ACTIONS["UPDATE_LIST_ITEMS"] = "UPDATE_LIST_ITEMS";
    ACTIONS["UPDATE_LIST_ERROR"] = "UPDATE_LIST_ERROR";
    ACTIONS["CLEAR_LIST_ERROR"] = "CLEAR_LIST_ERROR";
    ACTIONS["UPDATE_SELECTED_INDEX"] = "UPDATE_SELECTED_INDEX";
    return ACTIONS;
}({});

});

parcelRegister("kPuXt", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $7d79ad45f0f0254a$export$18d4026d1ea86bb1);

var $3lIcL = parcelRequire("3lIcL");
const $7d79ad45f0f0254a$export$18d4026d1ea86bb1 = new (0, $3lIcL.PluginKey)('typeAheadPlugin');

});


parcelRegister("cg71Z", function(module, exports) {
$parcel$export(module.exports, "insertTypeAheadItem", () => $3cc15d77a03bb294$export$173ade35125a6637);

var $3YJ2y = parcelRequire("3YJ2y");

var $7k8dr = parcelRequire("7k8dr");

var $3xw6l = parcelRequire("3xw6l");

var $apqw1 = parcelRequire("apqw1");

var $ckKJp = parcelRequire("ckKJp");

var $kPuXt = parcelRequire("kPuXt");

var $akqoF = parcelRequire("akqoF");

var $elKSH = parcelRequire("elKSH");

var $azYbd = parcelRequire("azYbd");

var $95mAm = parcelRequire("95mAm");
const $3cc15d77a03bb294$var$validateNode = ({ schema: schema, maybeNode: maybeNode })=>{
    if (!maybeNode) return null;
    if (maybeNode instanceof (0, $3xw6l.Node) || maybeNode instanceof (0, $3xw6l.Fragment)) return maybeNode;
    if (typeof maybeNode === 'string') return schema.text(maybeNode);
    try {
        return (0, $3xw6l.Node).fromJSON(schema, maybeNode);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        return null;
    }
};
const $3cc15d77a03bb294$var$createInsertCallback = ({ editorState: state, handler: handler, query: query, wasInsertedBySpace: wasInsertedBySpace, selectedIndex: selectedIndex, textStartPosition: textStartPosition, textInserted: textInserted })=>(maybeNode, opts = {})=>{
        const { tr: tr } = state;
        const position = {
            start: textStartPosition,
            end: textStartPosition + (wasInsertedBySpace ? textInserted.length : 0)
        };
        const node = $3cc15d77a03bb294$var$validateNode({
            schema: state.schema,
            maybeNode: maybeNode
        });
        if (!node) {
            (0, $azYbd.closeTypeAhead)(tr);
            // In this kind of situation we need to
            // delete the raw text query
            tr.delete(position.start, position.end);
            return tr;
        }
        node instanceof (0, $3xw6l.Node) && node.isBlock ? (0, $95mAm.insertBlockNode)({
            node: node,
            tr: tr,
            position: position
        }) : (0, $95mAm.insertInlineNodeOrFragment)({
            maybeFragment: node,
            tr: tr,
            position: position,
            selectInlineNode: Boolean(opts.selectInlineNode)
        });
        (0, $apqw1.closeHistory)(tr);
        if (wasInsertedBySpace) return tr;
        const config = {
            stage: (0, $3YJ2y.InsertTypeAheadStages).INSERTING_ITEM,
            query: query,
            selectedIndex: selectedIndex,
            trigger: handler.trigger
        };
        tr.step(new (0, $3YJ2y.InsertTypeAheadStep)(config));
        return tr;
    };
const $3cc15d77a03bb294$var$createDeleteRawTextCallback = ({ trigger: trigger, selectedIndex: selectedIndex, position: position, query: query, wasInsertedBySpace: wasInsertedBySpace, insertItem: insertItem })=>{
    return (newState)=>{
        const tr = newState.tr;
        (0, $apqw1.closeHistory)(tr);
        if (!wasInsertedBySpace) {
            tr.delete(position.start, position.end);
            const config = {
                stage: (0, $3YJ2y.InsertTypeAheadStages).DELETING_RAW_QUERY,
                selectedIndex: selectedIndex,
                query: query,
                trigger: trigger
            };
            tr.step(new (0, $3YJ2y.InsertTypeAheadStep)(config));
        }
        tr.setMeta((0, $kPuXt.pluginKey), {
            action: (0, $ckKJp.ACTIONS).INSERT_ITEM,
            params: insertItem
        });
        return tr;
    };
};
const $3cc15d77a03bb294$export$173ade35125a6637 = (view)=>({ item: item, handler: handler, mode: mode, query: query, sourceListItem: sourceListItem })=>{
        const pluginState = (0, $elKSH.getPluginState)(view.state);
        if (!pluginState) return;
        const stats = (pluginState.stats || new (0, $akqoF.StatsModifier)()).serialize();
        const meta = {
            mode: mode,
            query: query,
            stats: stats,
            sourceListItem: sourceListItem
        };
        const { tr: tr } = view.state;
        const trigger = handler.trigger;
        let text = `${trigger}${query}`;
        if (mode === (0, $7k8dr.SelectItemMode).SPACE) text = text.trim().concat(' ');
        // We want to always persist selectedIndex as -1 upon selecting an item from typeahead
        // in order to retain exist focus behaviour when undoing
        const selectedIndex = -1;
        const wasInsertedBySpace = mode === (0, $7k8dr.SelectItemMode).SPACE;
        const { selection: { from: textStartPosition } } = tr;
        const insertItem = (newEditorSate)=>{
            const insertCallback = $3cc15d77a03bb294$var$createInsertCallback({
                editorState: newEditorSate,
                query: query,
                mode: mode,
                handler: handler,
                wasInsertedBySpace: wasInsertedBySpace,
                selectedIndex: selectedIndex,
                textInserted: text,
                textStartPosition: textStartPosition
            });
            let wasInsertCallbackCalled = false;
            // Some wierd plugins doesn't call the insert item callback
            // For example, the link quick insert item
            // For those cases we need to make sure we are closing the typeahead
            const proxyHandler = {
                apply: function(target, _thisContext, argumentsList) {
                    wasInsertCallbackCalled = true;
                    return target(...argumentsList);
                }
            };
            const insertCallbackProxy = new Proxy(insertCallback, proxyHandler);
            const nextTr = handler.selectItem(newEditorSate, item, insertCallbackProxy, meta);
            if (!wasInsertCallbackCalled && nextTr) {
                (0, $apqw1.closeHistory)(nextTr);
                // In some cases we need to re-open the typeahead
                // e.g.: addign mentions from the quick insert
                //
                // Today, the QuickInsert API doesn't have a tool
                // to help on this. So the code below will close the typeahead
                // only if there is no previous metadata about typeahead in the
                // next transaction
                if (!nextTr.getMeta((0, $kPuXt.pluginKey))) (0, $azYbd.closeTypeAhead)(nextTr);
            }
            return nextTr;
        };
        const position = {
            start: tr.selection.from,
            end: tr.selection.from + text.length
        };
        tr.setMeta((0, $kPuXt.pluginKey), {
            action: (0, $ckKJp.ACTIONS).INSERT_RAW_QUERY,
            params: $3cc15d77a03bb294$var$createDeleteRawTextCallback({
                wasInsertedBySpace: wasInsertedBySpace,
                selectedIndex: selectedIndex,
                insertItem: insertItem,
                position: position,
                query: query,
                trigger: trigger
            })
        });
        tr.insertText(text);
        (0, $apqw1.closeHistory)(tr);
        view.dispatch(tr);
        view.focus();
    };

});
parcelRegister("3YJ2y", function(module, exports) {
$parcel$export(module.exports, "InsertTypeAheadStages", () => $2e59e9bc5a2ec7d1$export$1b2be0bed116d664);
$parcel$export(module.exports, "InsertTypeAheadStep", () => $2e59e9bc5a2ec7d1$export$5ca6d15deb246b5d);

var $3xw6l = parcelRequire("3xw6l");

var $lzEKq = parcelRequire("lzEKq");
const $2e59e9bc5a2ec7d1$export$2f0b0962a5993fe0 = 'atlaskit-insert-type-ahead';
let $2e59e9bc5a2ec7d1$export$1b2be0bed116d664 = /*#__PURE__*/ function(InsertTypeAheadStages) {
    InsertTypeAheadStages["DELETING_RAW_QUERY"] = "DELETING_RAW_QUERY";
    InsertTypeAheadStages["INSERTING_ITEM"] = "INSERTING_ITEM";
    return InsertTypeAheadStages;
}({});
class $2e59e9bc5a2ec7d1$export$5ca6d15deb246b5d extends (0, $lzEKq.Step) {
    constructor({ stage: stage, query: query, trigger: trigger, selectedIndex: selectedIndex }, isInvertStep = false){
        super();
        this.isInvertStep = isInvertStep;
        this.stage = stage;
        this.query = query;
        this.trigger = trigger;
        this.selectedIndex = selectedIndex;
    }
    invert() {
        const config = {
            stage: this.stage,
            query: this.query,
            trigger: this.trigger,
            selectedIndex: this.selectedIndex
        };
        return new $2e59e9bc5a2ec7d1$export$5ca6d15deb246b5d(config, !this.isInvertStep);
    }
    apply(doc) {
        return (0, $lzEKq.StepResult).ok(doc);
    }
    merge() {
        return null;
    }
    isInsertionStep() {
        return !this.isInvertStep;
    }
    isUndoingStep() {
        return this.isInvertStep;
    }
    map() {
        const config = {
            stage: this.stage,
            query: this.query,
            trigger: this.trigger,
            selectedIndex: this.selectedIndex
        };
        // Return the same events, this step will never be removed
        return new $2e59e9bc5a2ec7d1$export$5ca6d15deb246b5d(config, this.isInvertStep);
    }
    getMap() {
        return new (0, $lzEKq.StepMap)([
            0,
            0,
            0
        ]);
    }
    toJSON() {
        // When serialized we should create a noop Replace step
        return {
            stepType: 'replace',
            from: 0,
            to: 0
        };
    }
    static fromJSON() {
        // This is a "local custom step" once serialized
        // we need to transform it in a no-operation action
        return new (0, $lzEKq.ReplaceStep)(0, 0, (0, $3xw6l.Slice).empty);
    }
}
/** Register this step with Prosemirror */ (0, $lzEKq.Step).jsonID($2e59e9bc5a2ec7d1$export$2f0b0962a5993fe0, $2e59e9bc5a2ec7d1$export$5ca6d15deb246b5d);

});

parcelRegister("akqoF", function(module, exports) {
$parcel$export(module.exports, "StatsModifier", () => $77674b3b26f0c92c$export$630efe5940bb4d41);
class $77674b3b26f0c92c$export$630efe5940bb4d41 {
    constructor(){
        this.startedAt = 0;
        this.endedAt = 0;
        this.keyCount = {
            arrowUp: 0,
            arrowDown: 0
        };
        this.increaseArrowUp = ()=>{
            this.keyCount.arrowUp += 1;
        };
        this.increaseArrowDown = ()=>{
            this.keyCount.arrowDown += 1;
        };
        this.serialize = ()=>{
            return {
                startedAt: this.startedAt,
                endedAt: performance.now(),
                keyCount: {
                    arrowUp: this.keyCount?.arrowUp || 0,
                    arrowDown: this.keyCount?.arrowDown || 0
                }
            };
        };
        this.startedAt = performance.now();
        this.keyCount = {
            arrowUp: 0,
            arrowDown: 0
        };
    }
}

});

parcelRegister("elKSH", function(module, exports) {
$parcel$export(module.exports, "isTypeAheadHandler", () => $f852c50a6a396796$export$be092076596418f1);
$parcel$export(module.exports, "isTypeAheadOpen", () => $f852c50a6a396796$export$564dcc295d6ce147);
$parcel$export(module.exports, "getPluginState", () => $f852c50a6a396796$export$f05434c51e3762e);
$parcel$export(module.exports, "getTypeAheadHandler", () => $f852c50a6a396796$export$c1eba975d6442029);
$parcel$export(module.exports, "getTypeAheadQuery", () => $f852c50a6a396796$export$7a55deb43cd1340e);
$parcel$export(module.exports, "isTypeAheadAllowed", () => $f852c50a6a396796$export$74b0f581633f8412);
$parcel$export(module.exports, "findHandler", () => $f852c50a6a396796$export$2bae95e359577df4);
$parcel$export(module.exports, "skipForwardToSafeItem", () => $f852c50a6a396796$export$84a03e6192df0237);
$parcel$export(module.exports, "moveSelectedIndex", () => $f852c50a6a396796$export$f985e98ceae7c8f6);
$parcel$export(module.exports, "getTypeAheadListAriaLabels", () => $f852c50a6a396796$export$19cacaa810ba988a);

var $7k8dr = parcelRequire("7k8dr");
var $4drex = parcelRequire("4drex");

var $92xoS = parcelRequire("92xoS");

var $lKOUs = parcelRequire("lKOUs");

var $gclLy = parcelRequire("gclLy");

var $kPuXt = parcelRequire("kPuXt");

var $akqoF = parcelRequire("akqoF");
const $f852c50a6a396796$export$be092076596418f1 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
handler)=>{
    return handler && Object.values((0, $7k8dr.TypeAheadAvailableNodes)).includes(handler.id) && typeof handler.trigger === 'string' && typeof handler.selectItem === 'function' && typeof handler.getItems === 'function';
};
const $f852c50a6a396796$export$564dcc295d6ce147 = (editorState)=>{
    return !!(0, $kPuXt.pluginKey)?.getState(editorState)?.decorationSet?.find().length;
};
const $f852c50a6a396796$export$f05434c51e3762e = (editorState)=>{
    return (0, $kPuXt.pluginKey).getState(editorState);
};
const $f852c50a6a396796$export$c1eba975d6442029 = (editorState)=>{
    return (0, $kPuXt.pluginKey).getState(editorState)?.triggerHandler;
};
const $f852c50a6a396796$export$7a55deb43cd1340e = (editorState)=>{
    return (0, $kPuXt.pluginKey).getState(editorState)?.query;
};
const $f852c50a6a396796$export$74b0f581633f8412 = (state)=>{
    const isOpen = $f852c50a6a396796$export$564dcc295d6ce147(state);
    // if the TypeAhead is open
    // we should not allow it
    return !isOpen;
};
const $f852c50a6a396796$export$2bae95e359577df4 = (id, state)=>{
    const pluginState = (0, $kPuXt.pluginKey).getState(state);
    if (!pluginState || !pluginState.typeAheadHandlers || pluginState.typeAheadHandlers.length === 0) return null;
    const { typeAheadHandlers: typeAheadHandlers } = pluginState;
    return typeAheadHandlers.find((h)=>h.id === id) || null;
};
const $f852c50a6a396796$export$84a03e6192df0237 = ({ currentIndex: currentIndex, nextIndex: nextIndex, listSize: listSize, itemIsDisabled: itemIsDisabled })=>{
    // Use a loop to find the next selectable item
    for(let idx = nextIndex; idx < listSize; idx++){
        if (!itemIsDisabled(idx)) return idx;
    }
    // We got to the end of the list ^, now try from the start
    if ((0, $92xoS.editorExperiment)('platform_editor_offline_editing_web', true)) for(let idx = 0; idx < nextIndex; idx++){
        if (!itemIsDisabled(idx)) return idx;
    }
    // If no selectable items are found, return currentIndex
    return currentIndex;
};
const $f852c50a6a396796$export$723aff40bcdce278 = ({ currentIndex: currentIndex, nextIndex: nextIndex, listSize: listSize, itemIsDisabled: itemIsDisabled })=>{
    // Use a loop to find the next non-selectable item when going backwards
    for(let idx = nextIndex; idx >= 0; idx--){
        if (!itemIsDisabled(idx)) return idx;
    }
    // We got to the start of the list ^, now try from the end
    if ((0, $92xoS.editorExperiment)('platform_editor_offline_editing_web', true)) for(let idx = listSize; idx > nextIndex; idx--){
        if (!itemIsDisabled(idx)) return idx;
    }
    // If no non-selectable items are found, return currentIndex
    return currentIndex;
};
const $f852c50a6a396796$export$89c7a133a9db5167 = ({ trigger: trigger, editorState: editorState })=>{
    const pluginState = (0, $kPuXt.pluginKey).getState(editorState);
    if (!pluginState || !pluginState.typeAheadHandlers || pluginState.typeAheadHandlers.length === 0) return null;
    const { typeAheadHandlers: typeAheadHandlers } = pluginState;
    return typeAheadHandlers.find((h)=>h.trigger === trigger) || null;
};
const $f852c50a6a396796$export$f985e98ceae7c8f6 = ({ editorView: editorView, direction: direction, api: api })=>()=>{
        const typeAheadState = $f852c50a6a396796$export$f05434c51e3762e(editorView.state);
        if (!typeAheadState) return;
        const { selectedIndex: selectedIndex, items: items } = typeAheadState;
        const stats = typeAheadState.stats instanceof (0, $akqoF.StatsModifier) ? typeAheadState.stats : new (0, $akqoF.StatsModifier)();
        let nextIndex;
        const isDisabled = (idx)=>(0, $gclLy.itemIsDisabled)(items[idx], api);
        if (direction === 'next') {
            stats.increaseArrowDown();
            /**
			 * See: https://product-fabric.atlassian.net/browse/ED-17200
			 * `selectedIndex` is forced to -1 now to not immediately focus the typeahead
			 * and only do so when there is explicit logic to focus into the typeahead
			 * options.
			 *
			 * This check for "set index to 1 when -1"
			 * - is a temporary workaround to get back the previous behaviour without
			 *    entirely reverting the a11y improvements
			 *
			 */ if (selectedIndex === -1 && items.length > 1) // If the first item is disabled we actually want to skip to the 3rd item
            // on the first arrow down
            nextIndex = isDisabled(0) && items.length > 2 ? 2 : 1;
            else nextIndex = selectedIndex >= items.length - 1 ? 0 : selectedIndex + 1;
            nextIndex = $f852c50a6a396796$export$84a03e6192df0237({
                currentIndex: selectedIndex,
                nextIndex: nextIndex,
                listSize: items.length,
                itemIsDisabled: isDisabled
            });
        } else {
            stats.increaseArrowUp();
            nextIndex = selectedIndex <= 0 ? items.length - 1 : selectedIndex - 1;
            nextIndex = $f852c50a6a396796$export$723aff40bcdce278({
                currentIndex: selectedIndex,
                nextIndex: nextIndex,
                listSize: items.length,
                itemIsDisabled: isDisabled
            });
        }
        (0, $lKOUs.updateSelectedIndex)(nextIndex, api)(editorView.state, editorView.dispatch);
    };
const $f852c50a6a396796$export$19cacaa810ba988a = (trigger, intl, item)=>{
    switch(trigger){
        case '@':
            return {
                popupAriaLabel: intl.formatMessage((0, $4drex.typeAheadListMessages).mentionPopupLabel),
                listItemAriaLabel: intl.formatMessage((0, $4drex.typeAheadListMessages).metionListItemLabel, {
                    name: item?.mention?.name || '',
                    shortName: item?.mention?.mentionName || ''
                })
            };
        case '/':
            return {
                popupAriaLabel: intl.formatMessage((0, $4drex.typeAheadListMessages).quickInsertPopupLabel),
                listItemAriaLabel: intl.formatMessage((0, $4drex.typeAheadListMessages).emojiListItemLabel, {
                    name: item?.title || '',
                    shortcut: item?.emoji?.shortName || ''
                })
            };
        case ':':
            return {
                popupAriaLabel: intl.formatMessage((0, $4drex.typeAheadListMessages).emojiPopupLabel),
                listItemAriaLabel: intl.formatMessage((0, $4drex.typeAheadListMessages).emojiListItemLabel, {
                    name: item?.emoji?.name || '',
                    shortcut: item?.emoji?.shortName || ''
                })
            };
        default:
            return {
                popupAriaLabel: intl.formatMessage((0, $4drex.typeAheadListMessages).typeAheadPopupLabel)
            };
    }
};

});
parcelRegister("lKOUs", function(module, exports) {
$parcel$export(module.exports, "updateSelectedIndex", () => $514d7afb771706f4$export$9993709486a96a6b);

var $ckKJp = parcelRequire("ckKJp");

var $gclLy = parcelRequire("gclLy");

var $kPuXt = parcelRequire("kPuXt");
const $514d7afb771706f4$export$9993709486a96a6b = (selectedIndex, api)=>{
    return (state, dispatch)=>{
        const pluginState = (0, $kPuXt.pluginKey).getState(state);
        if (pluginState?.selectedIndex === selectedIndex) return false;
        // If the new index is disabled ignore this call, we can use the previous index
        if ((0, $gclLy.itemIsDisabled)(pluginState?.items[selectedIndex], api)) return false;
        const tr = state.tr;
        tr.setMeta((0, $kPuXt.pluginKey), {
            action: (0, $ckKJp.ACTIONS).UPDATE_SELECTED_INDEX,
            params: {
                selectedIndex: selectedIndex
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
};

});
parcelRegister("gclLy", function(module, exports) {
$parcel$export(module.exports, "itemIsDisabled", () => $df63d4403d4e0caf$export$1ebf03cc1b973f80);
const $df63d4403d4e0caf$export$1ebf03cc1b973f80 = (item, api)=>{
    const isOffline = api?.connectivity?.sharedState.currentState()?.mode === 'offline';
    return isOffline && item?.isDisabledOffline === true;
};

});



parcelRegister("95mAm", function(module, exports) {
$parcel$export(module.exports, "insertBlockNode", () => $fbff0dd4802d0e7b$export$faec73a52dd47a2c);
$parcel$export(module.exports, "insertInlineNodeOrFragment", () => $fbff0dd4802d0e7b$export$a6d430434014dc1c);

var $j6ZdO = parcelRequire("j6ZdO");

var $kMoqb = parcelRequire("kMoqb");

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");
function $fbff0dd4802d0e7b$var$findInsertPoint(doc, pos, nodeToInsert) {
    const $pos = doc.resolve(pos);
    const createInsertPosition = (from, to)=>({
            from: from,
            to: to || from
        });
    // Search for a valid position for nodeToInsert in progressively higher levels
    for(let level = $pos.depth; level >= 0; level--){
        const nodeAtLevel = $pos.node(level);
        // Try to replace the empty paragraph in the level above
        // Scenario:
        //   doc(
        //     table(
        //       row(
        //         cell(
        //           p('{<>}'),
        //         ),
        //       )
        //     )
        //   )
        const levelAbove = Math.max(level - 1, 0);
        const parentNode = $pos.node(levelAbove);
        // Special case: when this is true, the 'to' position should be the end
        // of the empty paragraph
        const isNodeAtLevelEmptyParagraph = nodeAtLevel.type.name === 'paragraph' && nodeAtLevel.content.size === 0;
        const indexAtLevelAbove = $pos.index(levelAbove);
        const canReplaceNodeAtLevelAbove = parentNode.canReplaceWith(indexAtLevelAbove, indexAtLevelAbove, nodeToInsert.type);
        if (isNodeAtLevelEmptyParagraph && canReplaceNodeAtLevelAbove) {
            const from = $pos.posAtIndex(indexAtLevelAbove, levelAbove);
            return createInsertPosition(from, from + nodeAtLevel.nodeSize);
        }
        // Try to insert this node right after the node in the level above
        // Scenario:
        //   doc(
        //     panel(
        //       p('{<>}'),
        //     )
        //   )
        const indexAfterAtLevelAbove = $pos.indexAfter(levelAbove);
        const canInsertNodeAtLevelAbove = parentNode.canReplaceWith(indexAfterAtLevelAbove, indexAfterAtLevelAbove, nodeToInsert.type);
        if (canInsertNodeAtLevelAbove) return createInsertPosition($pos.posAtIndex(indexAfterAtLevelAbove, levelAbove));
    }
    return createInsertPosition(0);
}
const $fbff0dd4802d0e7b$export$faec73a52dd47a2c = ({ node: node, tr: tr, position: position })=>{
    const { start: start, end: end } = position;
    if (node.isText) return tr.replaceWith(start, end, node);
    if (node.isBlock) {
        tr.delete(start, end);
        const mappedStart = tr.mapping.map(start);
        const nodeNormalized = (0, $j6ZdO.normaliseNestedLayout)(tr, node);
        const { listItem: listItem } = tr.doc.type.schema.nodes;
        // Handle edge cases if it's in a list or that it's inserting a node in the same node type
        /* e.g.
		 * panel (
		 *   1. text (insertion)
		 * )
		 * at insertion, text is parent (0), listItem is grandParent (-1), list is greatGrandparent (-2), panel is ggreatGrandParent (-3)
		 */ const grandParentNodeType = tr.selection.$from.node(-1)?.type;
        const ggreatGrandParentNodeType = tr.selection.$from.node(-3)?.type;
        if (grandParentNodeType === listItem && !(ggreatGrandParentNodeType === node.type)) return (0, $kMoqb.transformNodeIntoListItem)(tr, nodeNormalized);
        // Handle edge cases for hr and mediaSingle
        const inserted = (0, $j6ZdO.safeInsert)(nodeNormalized, mappedStart)(tr);
        if (inserted) return tr;
        const sliceInserted = (0, $3xw6l.Slice).maxOpen((0, $3xw6l.Fragment).from(nodeNormalized));
        const { from: from, to: to } = $fbff0dd4802d0e7b$var$findInsertPoint(tr.doc, mappedStart, nodeNormalized);
        tr.replaceWith(from, to, node);
        const openPosition = Math.min(from + (node.isAtom ? node.nodeSize : sliceInserted.openStart), tr.doc.content.size);
        const FORWARD_DIRECTION = 1;
        const nextSelection = (0, $3lIcL.TextSelection).findFrom(tr.doc.resolve(openPosition), FORWARD_DIRECTION, true);
        if (nextSelection) return tr.setSelection(nextSelection);
    }
    return tr;
};
const $fbff0dd4802d0e7b$export$a6d430434014dc1c = ({ maybeFragment: maybeFragment, tr: tr, position: position, selectInlineNode: selectInlineNode })=>{
    const { start: start, end: end } = position;
    const fragment = maybeFragment instanceof (0, $3xw6l.Node) ? (0, $3xw6l.Fragment).from(maybeFragment) : maybeFragment;
    tr.replaceWith(start, end, fragment);
    if (selectInlineNode) return tr.setSelection((0, $3lIcL.NodeSelection).create(tr.doc, start));
    return tr.setSelection((0, $3lIcL.TextSelection).near(tr.doc.resolve(start + fragment.size)));
};

});


parcelRegister("PKsUR", function(module, exports) {
$parcel$export(module.exports, "openTypeAheadAtCursor", () => $98ba95404114ccbe$export$e7ce737179b76875);

var $6BNUN = parcelRequire("6BNUN");

var $3lIcL = parcelRequire("3lIcL");

var $ckKJp = parcelRequire("ckKJp");

var $kPuXt = parcelRequire("kPuXt");
const $98ba95404114ccbe$export$adbec20dbbf15a6b = (props)=>(tr)=>{
        const { triggerHandler: triggerHandler, inputMethod: inputMethod, query: query, removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = props;
        tr.setMeta((0, $kPuXt.pluginKey), {
            action: (0, $ckKJp.ACTIONS).OPEN_TYPEAHEAD_AT_CURSOR,
            params: {
                triggerHandler: triggerHandler,
                inputMethod: inputMethod,
                query: query,
                removePrefixTriggerOnCancel: removePrefixTriggerOnCancel
            }
        });
    };
const $98ba95404114ccbe$export$e7ce737179b76875 = ({ triggerHandler: triggerHandler, inputMethod: inputMethod, query: query, removePrefixTriggerOnCancel: removePrefixTriggerOnCancel })=>({ tr: tr })=>{
        $98ba95404114ccbe$export$adbec20dbbf15a6b({
            triggerHandler: triggerHandler,
            inputMethod: inputMethod,
            query: query,
            removePrefixTriggerOnCancel: removePrefixTriggerOnCancel
        })(tr);
        const { selection: selection } = tr;
        const isInline = selection instanceof (0, $3lIcL.NodeSelection) && selection.node.type.isInline;
        if (!(selection instanceof (0, $3lIcL.TextSelection) || selection instanceof (0, $6BNUN.GapCursorSelection) || selection instanceof (0, $3lIcL.NodeSelection))) return tr;
        if (selection instanceof (0, $6BNUN.GapCursorSelection)) {
            // Create space for the typeahead menu in gap cursor
            tr.insertText(' ');
            // delete 1 pos before wherever selection is now - that will delete the empty space
            tr.delete(tr.selection.from - 1, tr.selection.from);
        } else {
            if (selection instanceof (0, $3lIcL.NodeSelection)) {
                if (isInline) {
                    tr.deleteSelection();
                    return tr;
                }
                return tr;
            }
            if (!selection.$cursor) {
                tr.deleteSelection();
                return tr;
            }
            // Search & Destroy placeholder
            const cursorPos = selection.$cursor.pos;
            const nodeAtCursor = tr.doc.nodeAt(cursorPos);
            const isPlaceholderAtCursorPosition = nodeAtCursor && nodeAtCursor.type.name === 'placeholder';
            if (nodeAtCursor && isPlaceholderAtCursorPosition) tr.delete(cursorPos, cursorPos + nodeAtCursor.nodeSize);
            // ME-2375 remove the superfluous '@' inserted before decoration
            // by composition (https://github.com/ProseMirror/prosemirror/issues/903)
            //
            // Update:
            // Now also handles any use case with superfluous typeahead triggers (ie. '@', ':', '/')
            // being inserted due to composition by checking if we have the trigger
            // directly before the typeahead. This should not happen unless it has
            // been eroneously added because we require whitespace/newline for typeahead.
            if (cursorPos >= 2 && !!selection?.$head?.parent?.textContent && selection.$head.parent.textContent.endsWith?.(triggerHandler.trigger)) tr.delete(cursorPos - 1, cursorPos);
        }
        return tr;
    };

});

parcelRegister("2NBlM", function(module, exports) {
$parcel$export(module.exports, "inputRulePlugin", () => $269e188109c30278$export$568a7ed6897c4817);

var $bMFKb = parcelRequire("bMFKb");

var $i8KtF = parcelRequire("i8KtF");

var $leZY6 = parcelRequire("leZY6");

var $jCfsG = parcelRequire("jCfsG");
var $82vn7 = parcelRequire("82vn7");

var $PKsUR = parcelRequire("PKsUR");
function $269e188109c30278$export$568a7ed6897c4817(schema, typeAheads, featureFlags) {
    if (!typeAheads || typeAheads.length === 0) return;
    const rules = typeAheads.reduce((acc, typeAhead)=>{
        const trigger = typeAhead.customRegex || typeAhead.trigger;
        if (!trigger) return acc;
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const regex = new RegExp(`(^|[.!?\\s${(0, $82vn7.leafNodeReplacementCharacter)}])(${trigger})$`);
        acc.push((0, $leZY6.createRule)(regex, (state, match)=>{
            return (0, $PKsUR.openTypeAheadAtCursor)({
                triggerHandler: typeAhead,
                inputMethod: (0, $bMFKb.INPUT_METHOD).KEYBOARD
            })({
                tr: state.tr
            });
        }));
        return acc;
    }, []);
    const plugin = new (0, $i8KtF.SafePlugin)((0, $jCfsG.createPlugin)('type-ahead', rules, {
        allowInsertTextOnDocument: false
    }));
    return plugin;
}
var $269e188109c30278$export$2e2bcd8739ae039 = $269e188109c30278$export$568a7ed6897c4817;

});

parcelRegister("3ATVn", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $6333d97ddf57772c$export$ae829ec7b2625219);

var $i8KtF = parcelRequire("i8KtF");

var $ckKJp = parcelRequire("ckKJp");

var $guQP2 = parcelRequire("guQP2");
function $6333d97ddf57772c$export$ae829ec7b2625219() {
    return new (0, $i8KtF.SafePlugin)({
        appendTransaction (transactions, _oldState, newState) {
            const insertItemCallback = (0, $guQP2.isInsertionTransaction)(transactions, (0, $ckKJp.ACTIONS).INSERT_ITEM);
            if (insertItemCallback) {
                const tr = insertItemCallback(newState);
                if (tr) return tr;
            }
        }
    });
}

});
parcelRegister("guQP2", function(module, exports) {
$parcel$export(module.exports, "isInsertionTransaction", () => $bbcd41ccec1baf9f$export$e715282b081c154e);

var $kPuXt = parcelRequire("kPuXt");
const $bbcd41ccec1baf9f$export$e715282b081c154e = (transactions, action)=>{
    const tr = transactions.find((tr)=>tr.getMeta((0, $kPuXt.pluginKey))?.action === action);
    if (!tr) return null;
    return tr.getMeta((0, $kPuXt.pluginKey))?.params;
};

});


parcelRegister("kGFcc", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $7134c4fdfa61f393$export$ae829ec7b2625219);

var $3YJ2y = parcelRequire("3YJ2y");

var $i8KtF = parcelRequire("i8KtF");

var $7SIsS = parcelRequire("7SIsS");

var $b7EWj = parcelRequire("b7EWj");

var $eGOwo = parcelRequire("eGOwo");

var $ckKJp = parcelRequire("ckKJp");

var $eQTrE = parcelRequire("eQTrE");

var $8IPtW = parcelRequire("8IPtW");

var $guQP2 = parcelRequire("guQP2");

var $kPuXt = parcelRequire("kPuXt");

var $ln6bC = parcelRequire("ln6bC");
const $7134c4fdfa61f393$var$hasValidTypeAheadStep = (tr)=>{
    const steps = tr.steps.filter((step)=>step instanceof (0, $3YJ2y.InsertTypeAheadStep));
    // There are some cases, like collab rebase, where the steps are re-applied
    // We should not re open the type-ahead for those cases
    if (steps.length === 1) return steps[0];
    return null;
};
function $7134c4fdfa61f393$export$ae829ec7b2625219({ reactDispatch: reactDispatch, popupMountRef: popupMountRef, typeAheadHandlers: typeAheadHandlers, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, api: api }) {
    const intl = getIntl();
    const { createDecorations: createDecorations, removeDecorations: removeDecorations } = (0, $8IPtW.factoryDecorations)({
        intl: intl,
        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
        popupMountRef: popupMountRef,
        api: api
    });
    const reducer = (0, $ln6bC.createReducer)({
        createDecorations: createDecorations,
        removeDecorations: removeDecorations,
        typeAheadHandlers: typeAheadHandlers,
        popupMountRef: popupMountRef
    });
    return new (0, $i8KtF.SafePlugin)({
        key: (0, $kPuXt.pluginKey),
        state: {
            init () {
                return {
                    typeAheadHandlers: typeAheadHandlers,
                    query: '',
                    decorationSet: (0, $b7EWj.DecorationSet).empty,
                    decorationElement: null,
                    items: [],
                    errorInfo: null,
                    selectedIndex: -1,
                    stats: null,
                    inputMethod: null,
                    removePrefixTriggerOnCancel: undefined
                };
            },
            apply (tr, currentPluginState, oldEditorState, state) {
                const customStep = $7134c4fdfa61f393$var$hasValidTypeAheadStep(tr);
                const nextPluginState = reducer(tr, currentPluginState, customStep);
                if (currentPluginState !== nextPluginState) reactDispatch((0, $kPuXt.pluginKey), nextPluginState);
                return nextPluginState;
            }
        },
        appendTransaction (transactions, _oldState, newState) {
            const insertItemCallback = (0, $guQP2.isInsertionTransaction)(transactions, (0, $ckKJp.ACTIONS).INSERT_RAW_QUERY);
            if (insertItemCallback) {
                const tr = insertItemCallback(newState);
                if (tr) {
                    if ((0, $eGOwo.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.startActiveSessionTimer()({
                        tr: tr
                    });
                    return tr;
                }
            }
        },
        view () {
            return {
                update (editorView) {}
            };
        },
        props: {
            decorations: (state)=>{
                return (0, $kPuXt.pluginKey).getState(state)?.decorationSet;
            },
            handleDOMEvents: {
                compositionend: (view, event)=>{
                    return false;
                },
                click: (view, event)=>{
                    const { target: target } = event;
                    // ProseMirror view listen to any click event inside of it
                    // When this event is coming from the typeahead
                    // we should tell to ProseMirror to sit down and relax
                    // cuz we know what we are doing (I hope)
                    if (target instanceof HTMLElement && (0, $7SIsS.closest)(target, `[data-type-ahead=${(0, $eQTrE.TYPE_AHEAD_DECORATION_DATA_ATTRIBUTE)}]`)) return true;
                    return false;
                }
            }
        }
    });
}

});
parcelRegister("eQTrE", function(module, exports) {
$parcel$export(module.exports, "TYPE_AHEAD_DECORATION_KEY", () => $ba23b5b1eaa1f638$export$65dc1d975bd3407b);
$parcel$export(module.exports, "TYPE_AHEAD_DECORATION_DATA_ATTRIBUTE", () => $ba23b5b1eaa1f638$export$be8a8259777b339f);
$parcel$export(module.exports, "TYPE_AHEAD_POPUP_CONTENT_CLASS", () => $ba23b5b1eaa1f638$export$a5cdf6890cae94d6);
$parcel$export(module.exports, "TYPE_AHEAD_DECORATION_ELEMENT_ID", () => $ba23b5b1eaa1f638$export$a38374e9651d6165);
$parcel$export(module.exports, "CloseSelectionOptions", () => $ba23b5b1eaa1f638$export$fc2dc87cf13c1ab1);
const $ba23b5b1eaa1f638$export$65dc1d975bd3407b = 'typeahead_decoration_key';
const $ba23b5b1eaa1f638$export$be8a8259777b339f = 'typeaheadDecoration';
const $ba23b5b1eaa1f638$export$a5cdf6890cae94d6 = 'fabric-editor-typeahead';
const $ba23b5b1eaa1f638$export$a38374e9651d6165 = 'typeahaed_decoration_element_id';
var $ba23b5b1eaa1f638$export$fc2dc87cf13c1ab1 = /*#__PURE__*/ function(CloseSelectionOptions) {
    CloseSelectionOptions["BEFORE_TEXT_INSERTED"] = "BEFORE_TEXT_INSERTED";
    CloseSelectionOptions["AFTER_TEXT_INSERTED"] = "AFTER_TEXT_INSERTED";
    return CloseSelectionOptions;
}({});

});

parcelRegister("8IPtW", function(module, exports) {
$parcel$export(module.exports, "factoryDecorations", () => $3d796e5e1d3db3b5$export$116b677c5744e397);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4nehu = parcelRequire("4nehu");

var $aXKmr = parcelRequire("aXKmr");

var $1rXzn = parcelRequire("1rXzn");

var $3lIcL = parcelRequire("3lIcL");

var $b7EWj = parcelRequire("b7EWj");

var $eGOwo = parcelRequire("eGOwo");

var $apqw1 = parcelRequire("apqw1");


var $1c5dC = parcelRequire("1c5dC");

var $azYbd = parcelRequire("azYbd");

var $eQTrE = parcelRequire("eQTrE");

var $akqoF = parcelRequire("akqoF");

var $elKSH = parcelRequire("elKSH");
const $3d796e5e1d3db3b5$export$116b677c5744e397 = ({ intl: intl, popupMountRef: popupMountRef, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, api: api })=>{
    const createDecorations = (tr, { triggerHandler: triggerHandler, inputMethod: inputMethod, reopenQuery: reopenQuery })=>{
        const { selection: selection } = tr;
        if (!(selection instanceof (0, $3lIcL.TextSelection)) || !selection.$cursor) return {
            decorationSet: (0, $b7EWj.DecorationSet).empty,
            stats: null,
            decorationElement: null
        };
        const decorationId = `decoration_id_${(0, $eQTrE.TYPE_AHEAD_DECORATION_KEY)}_${(0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))()}`;
        const { $cursor: $cursor } = selection;
        const typeaheadComponent = document.createElement('mark');
        const stats = new (0, $akqoF.StatsModifier)();
        let shouldFocusCursorInsideQuery = true;
        const deco = (0, $b7EWj.Decoration).widget($cursor.pos, (editorView, getDecorationPositionUnsafe)=>{
            const getDecorationPosition = ()=>{
                try {
                    return getDecorationPositionUnsafe();
                } catch (e) {
                    return undefined;
                }
            };
            typeaheadComponent.setAttribute('id', decorationId);
            typeaheadComponent.setAttribute('role', 'search');
            typeaheadComponent.dataset.typeAheadQuery = 'true';
            typeaheadComponent.dataset.trigger = triggerHandler.trigger;
            // This line below seems weird,
            // we need that cuz the clickAreaHelper
            // will try to hijack any click event coming
            // from the inside of the Editor
            // packages/editor/editor-core/src/ui/Addon/click-area-helper.ts
            typeaheadComponent.dataset.editorPopup = 'true';
            typeaheadComponent.dataset.typeAhead = (0, $eQTrE.TYPE_AHEAD_DECORATION_DATA_ATTRIBUTE);
            typeaheadComponent.style.color = `var(--ds-text-accent-blue, ${0, $7bb4c1736002a04a$export$b3de0ae08da2ce64})`;
            typeaheadComponent.style.backgroundColor = 'transparent';
            const onUndoRedo = (inputType)=>{
                if (![
                    'historyUndo',
                    'historyRedo'
                ].includes(inputType)) return false;
                const hasReopenQuery = typeof reopenQuery === 'string' && reopenQuery.trim().length > 0;
                const currentQuery = (0, $elKSH.getTypeAheadQuery)(editorView.state);
                if (hasReopenQuery || currentQuery?.length === 0) {
                    const command = inputType === 'historyUndo' ? (0, $apqw1.undo) : (0, $apqw1.redo);
                    let tr = editorView.state.tr;
                    const fakeDispatch = (customTr)=>{
                        tr = customTr;
                    };
                    const result = command(editorView.state, fakeDispatch);
                    if (result) {
                        (0, $azYbd.closeTypeAhead)(tr);
                        editorView.dispatch(tr);
                        editorView.focus();
                    }
                    return result;
                }
                return false;
            };
            nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
                    defaultLocale: intl.defaultLocale || 'en-US',
                    locale: intl.locale || 'en-US',
                    messages: intl.messages,
                    formats: intl.formats,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1c5dC.WrapperTypeAhead), {
                        triggerHandler: triggerHandler,
                        editorView: editorView,
                        anchorElement: typeaheadComponent,
                        inputMethod: inputMethod,
                        getDecorationPosition: getDecorationPosition,
                        shouldFocusCursorInsideQuery: shouldFocusCursorInsideQuery,
                        popupsMountPoint: popupMountRef.current?.popupsMountPoint,
                        popupsBoundariesElement: popupMountRef.current?.popupsBoundariesElement,
                        popupsScrollableElement: popupMountRef.current?.popupsScrollableElement,
                        onUndoRedo: onUndoRedo,
                        reopenQuery: reopenQuery,
                        api: api
                    })
                }), typeaheadComponent, decorationId, undefined, // @portal-render-immediately
            true);
            shouldFocusCursorInsideQuery = false;
            return typeaheadComponent;
        }, {
            isTypeAheadDecoration: true,
            key: decorationId,
            side: 0,
            stopEvent: (e)=>{
                const key = (0, $1rXzn.keyName)(e);
                const sel = document.getSelection();
                if ('ArrowLeft' === key && sel?.anchorOffset === 0) return false;
                return true;
            },
            ignoreSelection: false
        });
        return {
            decorationSet: (0, $b7EWj.DecorationSet).create(tr.doc, [
                deco
            ]),
            decorationElement: typeaheadComponent,
            stats: stats
        };
    };
    const removeDecorations = (decorationSet)=>{
        if (!decorationSet || decorationSet === (0, $b7EWj.DecorationSet).empty) return false;
        const typeAheadDecorations = decorationSet.find(undefined, undefined, (spec)=>{
            return spec.isTypeAheadDecoration;
        });
        if (!typeAheadDecorations || typeAheadDecorations.length === 0) return false;
        typeAheadDecorations.forEach(({ spec: spec })=>{
            if (!spec.key) return;
            const decoElement = document.querySelector(`#${spec.key}`);
            if (!decoElement) return;
            nodeViewPortalProviderAPI.remove(spec.key);
        });
        if ((0, $eGOwo.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
        return true;
    };
    return {
        createDecorations: createDecorations,
        removeDecorations: removeDecorations
    };
};

});
parcelRegister("1c5dC", function(module, exports) {
$parcel$export(module.exports, "WrapperTypeAhead", () => $ee5d0ebf046b4732$export$970faf6afe0d9376);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $bMFKb = parcelRequire("bMFKb");

var $7k8dr = parcelRequire("7k8dr");

var $eGOwo = parcelRequire("eGOwo");

var $92xoS = parcelRequire("92xoS");

var $2FODv = parcelRequire("2FODv");

var $8YhWI = parcelRequire("8YhWI");

var $gclLy = parcelRequire("gclLy");

var $elKSH = parcelRequire("elKSH");

var $l9ZHZ = parcelRequire("l9ZHZ");

var $3dFNR = parcelRequire("3dFNR");

var $ef4z4 = parcelRequire("ef4z4");

var $9nAiS = parcelRequire("9nAiS");
const $ee5d0ebf046b4732$export$970faf6afe0d9376 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ triggerHandler: triggerHandler, editorView: editorView, anchorElement: anchorElement, shouldFocusCursorInsideQuery: shouldFocusCursorInsideQuery, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, inputMethod: inputMethod, getDecorationPosition: getDecorationPosition, reopenQuery: reopenQuery, onUndoRedo: onUndoRedo, api: api })=>{
    // @ts-ignore
    const openElementBrowserModal = triggerHandler?.openElementBrowserModal;
    let showMoreOptionsButton = false;
    if ((0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) showMoreOptionsButton = !!triggerHandler?.getMoreOptionsButtonConfig;
    const [closed, setClosed] = (0, $eJOHy.useState)(false);
    const [query, setQuery] = (0, $eJOHy.useState)(reopenQuery || '');
    const queryRef = (0, $eJOHy.useRef)(query);
    const editorViewRef = (0, $eJOHy.useRef)(editorView);
    const items = (0, $3dFNR.useLoadItems)(triggerHandler, editorView, query, showMoreOptionsButton, api);
    (0, $eJOHy.useEffect)(()=>{
        if (!closed && (0, $eGOwo.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.handleIntentToStartEdit({
            shouldStartTimer: false,
            shouldPersistActiveSession: true
        }));
    }, [
        closed,
        api
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        queryRef.current = query;
    }, [
        query
    ]);
    const [onItemInsert, onTextInsert] = (0, $l9ZHZ.useItemInsert)(triggerHandler, editorView, items, api);
    const selectNextItem = (0, $eJOHy.useMemo)(()=>(0, $elKSH.moveSelectedIndex)({
            editorView: editorView,
            direction: 'next',
            api: api
        }), [
        editorView,
        api
    ]);
    const selectPreviousItem = (0, $eJOHy.useMemo)(()=>(0, $elKSH.moveSelectedIndex)({
            editorView: editorView,
            direction: 'previous',
            api: api
        }), [
        editorView,
        api
    ]);
    const cancel = (0, $eJOHy.useCallback)(({ setSelectionAt: setSelectionAt, addPrefixTrigger: addPrefixTrigger, text: text, forceFocusOnEditor: forceFocusOnEditor })=>{
        if ((0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) (0, $2FODv.fireTypeAheadClosedAnalyticsEvent)(api, (0, $bMFKb.ACTION).CANCELLED, !!queryRef.current, (0, $bMFKb.INPUT_METHOD).KEYBOARD, (0, $elKSH.getPluginState)(editorView.state)?.inputMethod);
        setClosed(true);
        const fullquery = addPrefixTrigger ? `${triggerHandler.trigger}${text}` : text;
        onTextInsert({
            forceFocusOnEditor: forceFocusOnEditor,
            setSelectionAt: setSelectionAt,
            text: fullquery
        });
    }, [
        triggerHandler.trigger,
        onTextInsert,
        api,
        editorView.state
    ]);
    const insertSelectedItem = (0, $eJOHy.useCallback)((mode = (0, $7k8dr.SelectItemMode).SELECTED)=>{
        const { current: view } = editorViewRef;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { selectedIndex: selectedIndex } = (0, $elKSH.getPluginState)(view.state);
        const safeSelectedIndex = (0, $elKSH.skipForwardToSafeItem)({
            currentIndex: selectedIndex,
            nextIndex: 1,
            listSize: items.length,
            itemIsDisabled: (idx)=>(0, $gclLy.itemIsDisabled)(items[idx], api)
        });
        // If the only safe index is -1 then none are safe - do not insert item
        if (safeSelectedIndex === -1) return;
        if ((0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) (0, $2FODv.fireTypeAheadClosedAnalyticsEvent)(api, (0, $bMFKb.ACTION).INSERTED, !!queryRef.current, (0, $bMFKb.INPUT_METHOD).KEYBOARD, (0, $elKSH.getPluginState)(editorView.state)?.inputMethod);
        setClosed(true);
        queueMicrotask(()=>{
            onItemInsert({
                mode: mode,
                index: selectedIndex,
                query: queryRef.current
            });
        });
    }, [
        items,
        api,
        editorView.state,
        onItemInsert
    ]);
    const showTypeAheadPopupList = (0, $eJOHy.useCallback)(()=>{}, []);
    const closePopup = (0, $eJOHy.useCallback)(()=>{
        setClosed(true);
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        const { current: view } = editorViewRef;
        const pluginState = (0, $elKSH.getPluginState)(view.state);
        if (query.length === 0 || query === pluginState?.query || !pluginState?.triggerHandler) return;
        (0, $8YhWI.updateQuery)(query)(view.state, view.dispatch);
    }, [
        query,
        reopenQuery
    ]);
    (0, $ef4z4.useOnForceSelect)({
        triggerHandler: triggerHandler,
        items: items,
        query: query,
        editorView: editorView,
        closePopup: closePopup
    });
    if (closed) return null;
    if (!triggerHandler) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9nAiS.InputQuery), {
        triggerQueryPrefix: triggerHandler?.trigger,
        onQueryChange: setQuery,
        onItemSelect: insertSelectedItem,
        selectNextItem: selectNextItem,
        selectPreviousItem: selectPreviousItem,
        onQueryFocus: showTypeAheadPopupList,
        cancel: cancel,
        forceFocus: shouldFocusCursorInsideQuery,
        onUndoRedo: onUndoRedo,
        reopenQuery: reopenQuery,
        editorView: editorView,
        items: items
    });
});
$ee5d0ebf046b4732$export$970faf6afe0d9376.displayName = 'WrapperTypeAhead';

});
parcelRegister("2FODv", function(module, exports) {
$parcel$export(module.exports, "fireTypeAheadClosedAnalyticsEvent", () => $bcb6305ac1f091ff$export$4a6068dadc2c7771);

var $bMFKb = parcelRequire("bMFKb");
const $bcb6305ac1f091ff$export$4a6068dadc2c7771 = (api, closeAction, hasQuery, inputMethod, invocationMethod = null)=>{
    api?.analytics?.actions.fireAnalyticsEvent({
        action: (0, $bMFKb.ACTION).CLOSED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).TYPEAHEAD,
        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).TYPEAHEAD_QUICK_INSERT,
        attributes: {
            inputMethod: inputMethod,
            closeAction: closeAction,
            hasQuery: hasQuery,
            invocationMethod: invocationMethod
        },
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK
    });
};

});

parcelRegister("8YhWI", function(module, exports) {
$parcel$export(module.exports, "updateQuery", () => $3e4d76c2d243fd19$export$4d1bf8b2f67bcb1);

var $ckKJp = parcelRequire("ckKJp");

var $kPuXt = parcelRequire("kPuXt");
const $3e4d76c2d243fd19$export$4d1bf8b2f67bcb1 = (query)=>{
    return (state, dispatch)=>{
        const pluginState = (0, $kPuXt.pluginKey).getState(state);
        if (pluginState?.query === query) return false;
        const tr = state.tr;
        tr.setMeta((0, $kPuXt.pluginKey), {
            action: (0, $ckKJp.ACTIONS).CHANGE_QUERY,
            params: {
                query: query
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
};

});

parcelRegister("l9ZHZ", function(module, exports) {
$parcel$export(module.exports, "useItemInsert", () => $582391ca569d663d$export$3a3385069392b26f);

var $eJOHy = parcelRequire("eJOHy");

var $7k8dr = parcelRequire("7k8dr");

var $azYbd = parcelRequire("azYbd");

var $cg71Z = parcelRequire("cg71Z");

var $gvgnX = parcelRequire("gvgnX");

var $eQTrE = parcelRequire("eQTrE");

var $gclLy = parcelRequire("gclLy");
const $582391ca569d663d$var$onlyHasViewMoreItem = (items)=>items.at(0)?.title === 'View more';
const $582391ca569d663d$var$insertRawQuery = ({ view: view, setSelectionAt: setSelectionAt, text: text, forceFocusOnEditor: forceFocusOnEditor })=>{
    const { tr: tr, schema: schema } = view.state;
    (0, $azYbd.closeTypeAhead)(tr);
    if (text.length > 0) {
        tr.replaceSelectionWith(schema.text(text));
        if (setSelectionAt === (0, $eQTrE.CloseSelectionOptions).BEFORE_TEXT_INSERTED) (0, $gvgnX.setSelectionBeforeQuery)(text)(tr);
    }
    view.dispatch(tr);
    if (forceFocusOnEditor) view.focus();
};
const $582391ca569d663d$export$3a3385069392b26f = (triggerHandler, editorView, items, api)=>{
    const editorViewRef = (0, $eJOHy.useRef)(editorView);
    const itemsRef = (0, $eJOHy.useRef)(items);
    const onTextInsert = (0, $eJOHy.useCallback)(({ setSelectionAt: setSelectionAt, text: text, forceFocusOnEditor: forceFocusOnEditor })=>{
        if (!triggerHandler) return;
        const { current: view } = editorViewRef;
        $582391ca569d663d$var$insertRawQuery({
            view: view,
            setSelectionAt: setSelectionAt,
            text: text,
            forceFocusOnEditor: forceFocusOnEditor
        });
    }, [
        triggerHandler
    ]);
    const onItemInsert = (0, $eJOHy.useCallback)(({ mode: mode, index: index, query: query })=>{
        const sourceListItem = itemsRef.current;
        if (sourceListItem.length === 0 || !triggerHandler || // View more item is only added for keyboard navigation and should not be considered as a valid item to be inserted
        $582391ca569d663d$var$onlyHasViewMoreItem(sourceListItem)) {
            const text = `${triggerHandler.trigger}${query}`;
            onTextInsert({
                forceFocusOnEditor: true,
                setSelectionAt: (0, $eQTrE.CloseSelectionOptions).AFTER_TEXT_INSERTED,
                text: text
            });
            return;
        }
        const itemToInsert = sourceListItem[index];
        if (!itemToInsert) return;
        const isDisabled = (0, $gclLy.itemIsDisabled)(itemToInsert, api);
        if (isDisabled) return;
        const { current: view } = editorViewRef;
        (0, $cg71Z.insertTypeAheadItem)(view)({
            item: itemToInsert,
            handler: triggerHandler,
            mode: mode,
            query: query,
            sourceListItem: sourceListItem
        });
    }, [
        triggerHandler,
        onTextInsert,
        api
    ]);
    const onItemMatch = (0, $eJOHy.useCallback)(({ mode: mode, query: query })=>{
        const _items = itemsRef.current;
        if (_items && _items.length > 1) return false;
        if (_items.length === 1 && // View more item is only added for keyboard navigation and should not be considered as a valid item to be inserted
        !$582391ca569d663d$var$onlyHasViewMoreItem(_items)) queueMicrotask(()=>{
            onItemInsert({
                mode: mode,
                query: query,
                index: 0
            });
        });
        else {
            const text = `${triggerHandler.trigger}${query}`;
            queueMicrotask(()=>{
                onTextInsert({
                    forceFocusOnEditor: true,
                    setSelectionAt: (0, $eQTrE.CloseSelectionOptions).AFTER_TEXT_INSERTED,
                    text: mode === (0, $7k8dr.SelectItemMode).SPACE ? text.concat(' ') : text
                });
            });
        }
        return true;
    }, [
        onItemInsert,
        triggerHandler,
        onTextInsert
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        itemsRef.current = items;
    }, [
        items
    ]);
    return [
        onItemInsert,
        onTextInsert,
        onItemMatch
    ];
};

});
parcelRegister("gvgnX", function(module, exports) {
$parcel$export(module.exports, "setSelectionBeforeQuery", () => $bd14cdb8e4324b21$export$5af11333ab9d7643);

var $3lIcL = parcelRequire("3lIcL");
const $bd14cdb8e4324b21$export$5af11333ab9d7643 = (rawText)=>(tr)=>{
        const currentPosition = tr.selection.$from.pos;
        const positionBeforeRawText = Math.max(currentPosition - rawText.length, 0);
        const resolvedPositionBeforeText = tr.doc.resolve(positionBeforeRawText);
        const nextSelection = (0, $3lIcL.TextSelection).findFrom(resolvedPositionBeforeText, -1, true);
        if (nextSelection) tr.setSelection(nextSelection);
    };

});


parcelRegister("3dFNR", function(module, exports) {
$parcel$export(module.exports, "useLoadItems", () => $2203402fc89469b4$export$36f5628e43bc3fcd);

var $eJOHy = parcelRequire("eJOHy");

var $92xoS = parcelRequire("92xoS");

var $97PVA = parcelRequire("97PVA");

var $hRexy = parcelRequire("hRexy");

var $7iDjN = parcelRequire("7iDjN");
const $2203402fc89469b4$var$EMPTY_LIST_ITEM = [];
const $2203402fc89469b4$export$36f5628e43bc3fcd = (triggerHandler, editorView, query, showViewMore, api)=>{
    const [items, setItems] = (0, $eJOHy.useState)($2203402fc89469b4$var$EMPTY_LIST_ITEM);
    const componentIsMounted = (0, $eJOHy.useRef)(true);
    const editorViewRef = (0, $eJOHy.useRef)(editorView);
    (0, $eJOHy.useEffect)(()=>{
        const getItems = triggerHandler?.getItems;
        if (!getItems) {
            setItems($2203402fc89469b4$var$EMPTY_LIST_ITEM);
            return;
        }
        const options = {
            query: query || '',
            editorState: editorView.state
        };
        const { current: view } = editorViewRef;
        if ((0, $92xoS.editorExperiment)('platform_editor_offline_editing_web', true)) // Clear any existing error state before making a new request
        queueMicrotask(()=>{
            api?.core.actions.execute((0, $97PVA.clearListError)());
        });
        getItems(options).then((result)=>{
            const list = result.length > 0 ? result : $2203402fc89469b4$var$EMPTY_LIST_ITEM;
            if (componentIsMounted.current) setItems(list);
            // Add a placeholder item for view more button so that it can be traversed with arrow keys
            const viewMoreItem = {
                title: 'View more'
            };
            queueMicrotask(()=>{
                (0, $7iDjN.updateListItem)(showViewMore ? list.concat(viewMoreItem) : list)(view.state, view.dispatch);
            });
        }).catch((e)=>{
            if ((0, $92xoS.editorExperiment)('platform_editor_offline_editing_web', true)) {
                if (e) {
                    if (componentIsMounted.current) setItems($2203402fc89469b4$var$EMPTY_LIST_ITEM);
                    queueMicrotask(()=>{
                        (0, $hRexy.updateListError)(e)(view.state, view.dispatch);
                    });
                }
            }
        });
    // ignore because EditorView is mutable but we don't want to
    // call loadItems when it changes, only when the query changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerHandler,
        query
    ]);
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            componentIsMounted.current = false;
        };
    }, []);
    return items;
};

});
parcelRegister("97PVA", function(module, exports) {
$parcel$export(module.exports, "clearListError", () => $7c04a0d45d4226ee$export$265c9044700bb67);

var $ckKJp = parcelRequire("ckKJp");

var $kPuXt = parcelRequire("kPuXt");
const $7c04a0d45d4226ee$export$265c9044700bb67 = ()=>{
    return ({ tr: tr })=>{
        tr.setMeta((0, $kPuXt.pluginKey), {
            action: (0, $ckKJp.ACTIONS).CLEAR_LIST_ERROR,
            params: {
                errorInfo: null
            }
        });
        return tr;
    };
};

});

parcelRegister("hRexy", function(module, exports) {
$parcel$export(module.exports, "updateListError", () => $308020a74a1dbd4a$export$4f4014ebb73e8d41);

var $ckKJp = parcelRequire("ckKJp");

var $kPuXt = parcelRequire("kPuXt");
const $308020a74a1dbd4a$export$4f4014ebb73e8d41 = (errorInfo)=>{
    return (state, dispatch)=>{
        const tr = state.tr;
        tr.setMeta((0, $kPuXt.pluginKey), {
            action: (0, $ckKJp.ACTIONS).UPDATE_LIST_ERROR,
            params: {
                errorInfo: errorInfo,
                items: []
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
};

});

parcelRegister("7iDjN", function(module, exports) {
$parcel$export(module.exports, "updateListItem", () => $6c9247b388dd3896$export$e482099e4c227d2);

var $ckKJp = parcelRequire("ckKJp");

var $kPuXt = parcelRequire("kPuXt");
const $6c9247b388dd3896$export$e482099e4c227d2 = (items)=>{
    return (state, dispatch)=>{
        const tr = state.tr;
        tr.setMeta((0, $kPuXt.pluginKey), {
            action: (0, $ckKJp.ACTIONS).UPDATE_LIST_ITEMS,
            params: {
                items: items
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
};

});


parcelRegister("ef4z4", function(module, exports) {
$parcel$export(module.exports, "useOnForceSelect", () => $6687075e6e53d9cd$export$4715c10ec9ca9321);

var $eJOHy = parcelRequire("eJOHy");

var $7k8dr = parcelRequire("7k8dr");

var $cg71Z = parcelRequire("cg71Z");
const $6687075e6e53d9cd$export$4715c10ec9ca9321 = ({ triggerHandler: triggerHandler, items: items, query: query, editorView: editorView, closePopup: closePopup })=>{
    const editorViewRef = (0, $eJOHy.useRef)(editorView);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!query || typeof triggerHandler.forceSelect !== 'function') return;
        const item = triggerHandler.forceSelect({
            items: items,
            query: query,
            editorState: editorViewRef.current.state
        });
        if (!item) return;
        const { current: view } = editorViewRef;
        closePopup();
        queueMicrotask(()=>{
            (0, $cg71Z.insertTypeAheadItem)(view)({
                item: item,
                mode: (0, $7k8dr.SelectItemMode).SPACE,
                query: query,
                handler: triggerHandler,
                sourceListItem: items
            });
        });
    }, [
        triggerHandler,
        closePopup,
        query,
        items
    ]);
};

});

parcelRegister("9nAiS", function(module, exports) {
$parcel$export(module.exports, "InputQuery", () => $cd70b04d74cf89b3$export$efc9b80896822e63);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $lRq8t = parcelRequire("lRq8t");

var $1rXzn = parcelRequire("1rXzn");

var $7EdFW = parcelRequire("7EdFW");

var $7k8dr = parcelRequire("7k8dr");
var $4drex = parcelRequire("4drex");

var $b7eFx = parcelRequire("b7eFx");

var $BmspC = parcelRequire("BmspC");

var $7yBx7 = parcelRequire("7yBx7");

var $eGOwo = parcelRequire("eGOwo");

var $cbSL1 = parcelRequire("cbSL1");

var $92xoS = parcelRequire("92xoS");

var $eQTrE = parcelRequire("eQTrE");

var $elKSH = parcelRequire("elKSH");
function $cd70b04d74cf89b3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $cd70b04d74cf89b3$var$placeholderStyles = {
    name: "yfltvp",
    styles: "&::after{content:attr(data-place-holder);color:var(--ds-text-subtlest, #626F86);position:relative;padding:var(--ds-space-025, 2px);left:var(--ds-space-negative-050, -4px);background-color:var(--ds-background-neutral, #091E420F);border-radius:var(--ds-radius-small, 3px);}"
};
const $cd70b04d74cf89b3$var$queryWithoutPlaceholderStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    '&::after': {
        content: `''`
    }
});
const $cd70b04d74cf89b3$var$querySpanStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    outline: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& input': {
        width: '5px',
        border: 'none',
        background: 'transparent',
        padding: 0,
        margin: 0,
        // TODO: ED-17022 - Fixes firefox caret position
        // Do not migrate font when em is used as unit
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $7yBx7.blockNodesVerticalMargin),
        caretColor: "var(--ds-text-accent-blue, #0052CC)"
    }
});
const $cd70b04d74cf89b3$var$isNavigationKey = (event)=>{
    return [
        'Enter',
        'Tab',
        'ArrowDown',
        'ArrowUp'
    ].includes(event.key);
};
const $cd70b04d74cf89b3$var$isUndoRedoShortcut = (event)=>{
    const key = (0, $1rXzn.keyName)(event);
    if (event.ctrlKey && key === 'y') return 'historyRedo';
    if ((event.ctrlKey || event.metaKey) && event.shiftKey && key === 'Z') return 'historyRedo';
    if ((event.ctrlKey || event.metaKey) && key === 'z') return 'historyUndo';
    return false;
};
const $cd70b04d74cf89b3$var$getAriaLabel = (triggerPrefix, intl)=>{
    switch(triggerPrefix){
        case '@':
            return (0, $4drex.typeAheadListMessages).mentionInputLabel;
        case '/':
            return (0, $4drex.typeAheadListMessages).quickInsertInputLabel;
        case ':':
            return (0, $4drex.typeAheadListMessages).emojiInputLabel;
        default:
            return (0, $4drex.typeAheadListMessages).quickInsertInputLabel;
    }
};
const $cd70b04d74cf89b3$export$efc9b80896822e63 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ triggerQueryPrefix: triggerQueryPrefix, cancel: cancel, onQueryChange: onQueryChange, onItemSelect: onItemSelect, selectNextItem: selectNextItem, selectPreviousItem: selectPreviousItem, forceFocus: forceFocus, reopenQuery: reopenQuery, onQueryFocus: onQueryFocus, onUndoRedo: onUndoRedo, editorView: editorView, items: items })=>{
    const ref = (0, $eJOHy.useRef)(document.createElement('span'));
    const inputRef = (0, $eJOHy.useRef)(null);
    const [query, setQuery] = (0, $eJOHy.useState)(null);
    const isEditorInsertionEnabled = (0, $92xoS.editorExperiment)('platform_editor_insertion', 'variant1');
    const isEditorControlsEnabled = (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1');
    const isSearchPlaceholderEnabled = isEditorInsertionEnabled || (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') && (0, $eGOwo.fg)('platform_editor_quick_insert_placeholder');
    const selection = editorView.state.selection;
    const { table: table } = editorView.state.schema.nodes;
    const [showPlaceholder, setShowPlaceholder] = (0, $eJOHy.useState)(isSearchPlaceholderEnabled && triggerQueryPrefix === '/' && // When triggered in very narrow table column, placeholder becomes ellipsis only
    // hence we disable it for now and revisit this scenario in ED-27480
    !(0, $BmspC.findParentNodeOfType)(table)(selection));
    const cleanedInputContent = (0, $eJOHy.useCallback)(()=>{
        const raw = ref.current?.textContent || '';
        return raw;
    }, []);
    const onKeyUp = (0, $eJOHy.useCallback)((event)=>{
        const text = cleanedInputContent();
        onQueryChange(text);
    }, [
        onQueryChange,
        cleanedInputContent
    ]);
    const onInput = (0, $eJOHy.useCallback)(()=>{
        if (cleanedInputContent()) setShowPlaceholder(false);
    }, [
        cleanedInputContent
    ]);
    const [isInFocus, setInFocus] = (0, $eJOHy.useState)(false);
    const checkKeyEvent = (0, $eJOHy.useCallback)((event)=>{
        const key = (0, $1rXzn.keyName)(event);
        const sel = document.getSelection();
        const raw = ref.current?.textContent || '';
        const text = cleanedInputContent();
        let stopDefault = false;
        const { selectedIndex: selectedIndex, removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = (0, $elKSH.getPluginState)(editorView.state) || {};
        setInFocus(true);
        switch(key){
            case ' ':
                // space key
                if (text.length === 0) {
                    cancel({
                        forceFocusOnEditor: true,
                        text: ' ',
                        addPrefixTrigger: isEditorControlsEnabled ? !removePrefixTriggerOnCancel : true,
                        setSelectionAt: (0, $eQTrE.CloseSelectionOptions).AFTER_TEXT_INSERTED
                    });
                    stopDefault = true;
                }
                break;
            case 'Escape':
            case 'PageUp':
            case 'PageDown':
            case 'Home':
                cancel({
                    text: text,
                    forceFocusOnEditor: true,
                    addPrefixTrigger: isEditorControlsEnabled ? !removePrefixTriggerOnCancel : true,
                    setSelectionAt: (0, $eQTrE.CloseSelectionOptions).AFTER_TEXT_INSERTED
                });
                stopDefault = true;
                break;
            case 'Backspace':
                if (raw.length === 0 || sel?.anchorOffset === 0) {
                    event.stopPropagation();
                    event.preventDefault();
                    cancel({
                        forceFocusOnEditor: true,
                        text: text,
                        addPrefixTrigger: false,
                        setSelectionAt: (0, $eQTrE.CloseSelectionOptions).BEFORE_TEXT_INSERTED
                    });
                }
                break;
            case 'Enter':
                // TODO: ED-14758 - Under the W3C specification, any keycode sent under IME would return a keycode 229
                // event.isComposing can't be used alone as this also included a virtual keyboard under a keyboardless device, therefore, it seems the best practice would be intercepting the event as below.
                // Some suggested the other workaround maybe listen on`keypress` instead of `keydown`
                if (!event.isComposing && event.which !== 229 && event.keyCode !== 229) {
                    if (selectedIndex === -1) {
                        /**
             * TODO DTR-1401: (also see ED-17200) There are two options
             * here, either
             * - set the index directly to 1 in WrapperTypeAhead.tsx's
             *   `insertSelectedItem` at the cost of breaking some of the a11y
             *   focus changes,
             * - or do this jank at the cost of some small analytics noise.
             *
             * The focus behaviour still needs cleanup
             */ selectPreviousItem();
                        selectNextItem();
                    }
                    onItemSelect(event.shiftKey ? (0, $7k8dr.SelectItemMode).SHIFT_ENTER : (0, $7k8dr.SelectItemMode).ENTER);
                }
                break;
            case 'Tab':
                if (selectedIndex === -1) {
                    /**
           * TODO DTR-1401: (also see ED-17200) There are two options
           * here, either
           * - set the index directly to 1 in WrapperTypeAhead.tsx's
           *   `insertSelectedItem` at the cost of breaking some of the a11y
           *   focus changes,
           * - or do this jank at the cost of some small analytics noise.
           *
           */ selectPreviousItem();
                    selectNextItem();
                }
                // TODO: DTR-1401 - why is this calling select item when hitting tab? fix this in DTR-1401
                onItemSelect((0, $7k8dr.SelectItemMode).TAB);
                break;
            case 'ArrowDown':
                selectNextItem();
                break;
            case 'ArrowUp':
                selectPreviousItem();
                break;
        }
        const undoRedoType = $cd70b04d74cf89b3$var$isUndoRedoShortcut(event);
        if (onUndoRedo && undoRedoType && onUndoRedo(undoRedoType)) stopDefault = true;
        if ($cd70b04d74cf89b3$var$isNavigationKey(event) || stopDefault) {
            event.stopPropagation();
            event.preventDefault();
            return false;
        }
    }, [
        onUndoRedo,
        onItemSelect,
        selectNextItem,
        selectPreviousItem,
        cancel,
        cleanedInputContent,
        editorView.state,
        isEditorControlsEnabled
    ]);
    // Remove when cleaning up platform_editor_a11y_remove_input_query_on_click
    const onClick = (0, $eJOHy.useCallback)((event)=>{
        event.stopPropagation();
        event.preventDefault();
        onQueryFocus();
        inputRef.current?.focus();
        return false;
    }, [
        onQueryFocus
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!ref.current) return;
        const browser = (0, $cbSL1.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $7EdFW.getBrowserInfo)() : (0, $7EdFW.browser);
        const { current: element } = ref;
        const { removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = (0, $elKSH.getPluginState)(editorView.state) || {};
        const onFocusIn = (event)=>{
            onQueryFocus();
        };
        const keyDown = (event)=>{
            const key = (0, $1rXzn.keyName)(event);
            if ([
                'ArrowLeft',
                'ArrowRight'
            ].includes(key) && document.getSelection && document.getSelection()) {
                const q = ref.current?.textContent || '';
                const sel = document.getSelection();
                const isMovingRight = sel && 'ArrowRight' === key && sel.anchorOffset === q.length;
                const isMovingLeft = sel && 'ArrowLeft' === key && (sel.anchorOffset === 0 || event.metaKey);
                if (!isMovingRight && !isMovingLeft) return;
                cancel({
                    forceFocusOnEditor: true,
                    addPrefixTrigger: isEditorControlsEnabled ? !removePrefixTriggerOnCancel : true,
                    text: cleanedInputContent(),
                    setSelectionAt: isMovingRight ? (0, $eQTrE.CloseSelectionOptions).AFTER_TEXT_INSERTED : (0, $eQTrE.CloseSelectionOptions).BEFORE_TEXT_INSERTED
                });
                event.preventDefault();
                event.stopPropagation();
                return;
            }
            checkKeyEvent(event);
        };
        const onPaste = (event)=>{
            const html = event.clipboardData?.getData('text/html');
            const plainText = event.clipboardData?.getData('text/plain');
            if (html && plainText) {
                event.preventDefault();
                // insert the plain text into the type-ahead input field
                const selection = window.getSelection();
                if (selection && ref.current) {
                    if (selection.rangeCount > 0) {
                        const range = selection.getRangeAt(0);
                        range.deleteContents();
                        range.insertNode(document.createTextNode(plainText));
                        range.collapse(false);
                    }
                }
            }
        };
        const onFocusOut = (event)=>{
            const { relatedTarget: relatedTarget } = event;
            // Given the user is changing the focus
            // When the target is inside the TypeAhead Popup
            // Then the popup should stay open
            if (relatedTarget instanceof HTMLElement && relatedTarget.closest && relatedTarget.closest(`.${(0, $eQTrE.TYPE_AHEAD_POPUP_CONTENT_CLASS)}`)) return;
            // Chrome and Edge may emit focusout events without direct input.
            // This path handles dismissals that don't involve item selection, so we ignore these events.
            // In Edge this also lead to duplication in the trigger character (@, /, :) as `cancel` would be called twice
            if ((browser.ie || browser.chrome) && !(window.getSelection()?.type === 'Range') && // eslint-disable-next-line @typescript-eslint/no-explicit-any
            !event.sourceCapabilities) return;
            cancel({
                addPrefixTrigger: isEditorControlsEnabled ? !removePrefixTriggerOnCancel : true,
                text: cleanedInputContent(),
                setSelectionAt: (0, $eQTrE.CloseSelectionOptions).BEFORE_TEXT_INSERTED,
                forceFocusOnEditor: false
            });
        };
        const close = ()=>{
            cancel({
                addPrefixTrigger: false,
                text: '',
                forceFocusOnEditor: true,
                setSelectionAt: (0, $eQTrE.CloseSelectionOptions).BEFORE_TEXT_INSERTED
            });
        };
        const beforeinput = (e)=>{
            setInFocus(false);
            const { target: target } = e;
            if (e.isComposing || !(target instanceof HTMLElement)) return;
            if (e.inputType === 'historyUndo' && target.textContent?.length === 0) {
                e.preventDefault();
                e.stopPropagation();
                close();
                return;
            }
            if (e.data != null && inputRef.current === null) {
                setQuery('');
                // We need to change the content on Safari
                // and set the cursor at the right place
                if (browser.safari) {
                    e.preventDefault();
                    const dataElement = document.createTextNode(e.data);
                    element.appendChild(dataElement);
                    const sel = window.getSelection();
                    const range = document.createRange();
                    range.setStart(dataElement, dataElement.length);
                    range.collapse(true);
                    sel?.removeAllRanges();
                    sel?.addRange(range);
                }
            }
        };
        const onInput = ()=>{};
        if (browser.safari) {
            // On Safari, for reasons beyond my understanding,
            // The undo behavior is totally different from other browsers
            // That why we need to have an specific branch only for Safari.
            const onInput = (e)=>{
                const { target: target } = e;
                if (!(e instanceof InputEvent) || e.isComposing || !(target instanceof HTMLElement)) return;
                if (e.inputType === 'historyUndo' && target.textContent?.length === 1) {
                    e.preventDefault();
                    e.stopPropagation();
                    close();
                    return;
                }
            };
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.addEventListener('input', onInput);
        }
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.addEventListener('focusout', onFocusOut);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.addEventListener('focusin', onFocusIn);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.addEventListener('keydown', keyDown);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.addEventListener('beforeinput', beforeinput);
        if ((0, $cbSL1.expValEquals)('platform_editor_paste_rich_text_bugfix', 'isEnabled', true)) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.addEventListener('paste', onPaste);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('focusout', onFocusOut);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('focusin', onFocusIn);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('keydown', keyDown);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('beforeinput', beforeinput);
            if ((0, $cbSL1.expValEquals)('platform_editor_paste_rich_text_bugfix', 'isEnabled', true)) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('paste', onPaste);
            if (browser.safari) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('input', onInput);
        };
    }, [
        triggerQueryPrefix,
        cleanedInputContent,
        onQueryFocus,
        cancel,
        checkKeyEvent,
        editorView.state,
        isEditorControlsEnabled
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        const hasReopenQuery = typeof reopenQuery === 'string' && reopenQuery.trim().length > 0;
        if (ref.current && forceFocus) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            setQuery(hasReopenQuery ? reopenQuery : null);
            requestAnimationFrame(()=>{
                if (!ref?.current) return;
                const sel = window.getSelection();
                if (sel && hasReopenQuery && ref.current.lastChild instanceof Text) {
                    const lastChild = ref.current.lastChild;
                    const range = document.createRange();
                    range.setStart(ref.current.lastChild, lastChild.length);
                    range.collapse(true);
                    sel.removeAllRanges();
                    sel.addRange(range);
                }
                ref.current.focus();
                setInFocus(true);
            });
        }
    }, [
        forceFocus,
        reopenQuery
    ]);
    const classNames = (0, $eJOHy.useMemo)(()=>{
        const classes = [];
        if (showPlaceholder) {
            // to avoid the placeholder wrapped to next line when triggered at the end of the line
            // see placeholderWrapStyles in editor-core/src/ui/ContentStyles/index.tsx
            classes.push('placeholder-decoration-wrap');
            if (selection.$from.depth > 1) // to hide placeholder overflow as ellipsis
            // see placeholderWrapStyles in editor-core/src/ui/ContentStyles/index.tsx
            classes.push('placeholder-decoration-hide-overflow');
        }
        return classes.join(' ');
    }, [
        showPlaceholder,
        selection
    ]);
    const assistiveHintID = (0, $eQTrE.TYPE_AHEAD_DECORATION_ELEMENT_ID) + '__assistiveHint';
    const intl = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, triggerQueryPrefix, /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: [
            $cd70b04d74cf89b3$var$querySpanStyles,
            isSearchPlaceholderEnabled && $cd70b04d74cf89b3$var$queryWithoutPlaceholderStyles,
            showPlaceholder && $cd70b04d74cf89b3$var$placeholderStyles
        ],
        contentEditable: true,
        ref: ref,
        onKeyUp: onKeyUp,
        onClick: (0, $eGOwo.fg)('platform_editor_a11y_remove_input_query_on_click') ? undefined : onClick,
        tabIndex: (0, $eGOwo.fg)('platform_editor_a11y_remove_input_query_on_click') ? -1 : undefined,
        onInput: isSearchPlaceholderEnabled ? onInput : undefined,
        role: "combobox",
        "aria-controls": (0, $eQTrE.TYPE_AHEAD_DECORATION_ELEMENT_ID),
        "aria-autocomplete": "list",
        "aria-expanded": items.length !== 0,
        "aria-labelledby": assistiveHintID,
        suppressContentEditableWarning: true,
        "data-query-prefix": triggerQueryPrefix,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: classNames,
        "data-place-holder": intl.formatMessage((0, $4drex.typeAheadListMessages).quickInsertInputPlaceholderLabel)
    }, query === null ? /*#__PURE__*/ (0, $1NIU8.jsx)("input", {
        ref: inputRef,
        type: "text",
        "aria-label": intl.formatMessage($cd70b04d74cf89b3$var$getAriaLabel(triggerQueryPrefix, intl))
    }) : query), /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        id: assistiveHintID,
        style: {
            display: 'none'
        }
    }, intl.formatMessage((0, $4drex.typeAheadListMessages).inputQueryAssistiveLabel)), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $b7eFx.AssistiveText), {
        assistiveText: items.length === 0 ? intl.formatMessage((0, $4drex.typeAheadListMessages).noSearchResultsLabel, {
            itemsLength: items.length
        }) : '',
        isInFocus: items.length === 0 || isInFocus,
        id: (0, $eQTrE.TYPE_AHEAD_DECORATION_ELEMENT_ID)
    }));
});
$cd70b04d74cf89b3$export$efc9b80896822e63.displayName = 'InputQuery';

});
parcelRegister("b7eFx", function(module, exports) {
$parcel$export(module.exports, "AssistiveText", () => $7787e9fb83d703bf$export$568f929105953699);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $3s8bj = parcelRequire("3s8bj");
function $7787e9fb83d703bf$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7787e9fb83d703bf$var$assitiveTextStyles = {
    name: "v66mgv",
    styles: "border:0;clip:rect(0 0 0 0);height:1px;marginbottom:-1px;marginright:-1px;overflow:hidden;padding:0;position:absolute;whitespace:nowrap;width:1px"
};
const $7787e9fb83d703bf$export$568f929105953699 = ({ assistiveText: assistiveText = '', isInFocus: isInFocus = false, id: id = '', statusDebounceMillis: statusDebounceMillis = 1400 })=>{
    const [bump, setBump] = (0, $eJOHy.useState)(false);
    const [debounced, setDebounced] = (0, $eJOHy.useState)(false);
    const [silenced, setSilenced] = (0, $eJOHy.useState)(false);
    const debounceStatusUpdate = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(()=>{
            const shouldSilence = !isInFocus;
            setBump((prevBump)=>!prevBump);
            setDebounced(true);
            setSilenced(shouldSilence);
        }), [
        isInFocus
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!debounced) {
            debounceStatusUpdate();
            return ()=>{
                debounceStatusUpdate.cancel();
            };
        }
    }, [
        assistiveText,
        isInFocus,
        debounced,
        debounceStatusUpdate
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (debounced) {
            setBump((prevBump)=>!prevBump);
            setDebounced(true);
            setSilenced(!isInFocus);
        }
    }, [
        assistiveText,
        isInFocus,
        debounced
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $7787e9fb83d703bf$var$assitiveTextStyles
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        "data-testid": id + '__status--A',
        id: id + '__status--A',
        role: "status",
        "aria-atomic": "true",
        "aria-live": "polite"
    }, !silenced && debounced && bump ? assistiveText : ''), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        "data-testid": id + '__status--B',
        id: id + '__status--B',
        role: "status",
        "aria-atomic": "true",
        "aria-live": "polite"
    }, !silenced && debounced && !bump ? assistiveText : ''));
};

});




parcelRegister("ln6bC", function(module, exports) {
$parcel$export(module.exports, "createReducer", () => $93f7a9637f86d44b$export$473eb76d322d0290);

var $3YJ2y = parcelRequire("3YJ2y");

var $bMFKb = parcelRequire("bMFKb");

var $b7EWj = parcelRequire("b7EWj");

var $enDkL = parcelRequire("enDkL");

var $cbSL1 = parcelRequire("cbSL1");

var $ckKJp = parcelRequire("ckKJp");

var $kPuXt = parcelRequire("kPuXt");

var $elKSH = parcelRequire("elKSH");
const $93f7a9637f86d44b$var$shouldForceOpen = (step)=>{
    if (!(step instanceof (0, $3YJ2y.InsertTypeAheadStep))) return false;
    const isDeletionRawQueryOperation = step.isInsertionStep() && step.stage === (0, $3YJ2y.InsertTypeAheadStages).DELETING_RAW_QUERY;
    const isUndoingInsertionItem = step.isUndoingStep() && step.stage === (0, $3YJ2y.InsertTypeAheadStages).INSERTING_ITEM;
    return isDeletionRawQueryOperation || isUndoingInsertionItem;
};
const $93f7a9637f86d44b$var$shouldForceClose = (step)=>{
    if (!(step instanceof (0, $3YJ2y.InsertTypeAheadStep))) return false;
    const isInsertingItem = step.isInsertionStep() && step.stage === (0, $3YJ2y.InsertTypeAheadStages).INSERTING_ITEM;
    const isUndoingDeletionRawQuery = step.isUndoingStep() && step.stage === (0, $3YJ2y.InsertTypeAheadStages).DELETING_RAW_QUERY;
    return isInsertingItem || isUndoingDeletionRawQuery;
};
const $93f7a9637f86d44b$var$createFindHandler = (typeAheadHandlers)=>(step)=>{
        if (!(step instanceof (0, $3YJ2y.InsertTypeAheadStep))) return null;
        const handler = typeAheadHandlers.find((h)=>h.trigger === step.trigger);
        return handler || null;
    };
const $93f7a9637f86d44b$export$473eb76d322d0290 = ({ typeAheadHandlers: typeAheadHandlers, removeDecorations: removeDecorations, createDecorations: createDecorations })=>{
    const findHandler = $93f7a9637f86d44b$var$createFindHandler(typeAheadHandlers);
    const openMenu = (currentPluginState, { tr: tr, triggerHandler: triggerHandler, inputMethod: inputMethod, reopenQuery: reopenQuery, selectedIndex: selectedIndex, removePrefixTriggerOnCancel: removePrefixTriggerOnCancel })=>{
        removeDecorations(currentPluginState.decorationSet);
        const { decorationSet: decorationSet, decorationElement: decorationElement, stats: stats } = createDecorations(tr, {
            triggerHandler: triggerHandler,
            inputMethod: inputMethod,
            reopenQuery: reopenQuery
        });
        if ((0, $cbSL1.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $enDkL.insm).session?.startFeature('typeaheadOpen');
        return {
            ...currentPluginState,
            stats: stats,
            decorationSet: decorationSet,
            triggerHandler: triggerHandler,
            decorationElement: decorationElement,
            inputMethod: inputMethod,
            selectedIndex: typeof selectedIndex === 'number' ? selectedIndex : -1,
            items: [],
            query: reopenQuery || '',
            removePrefixTriggerOnCancel: removePrefixTriggerOnCancel
        };
    };
    const closeMenu = (currentPluginState)=>{
        removeDecorations(currentPluginState.decorationSet);
        if ((0, $cbSL1.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $enDkL.insm).session?.endFeature('typeaheadOpen');
        return {
            ...currentPluginState,
            inputMethod: null,
            query: '',
            decorationElement: null,
            decorationSet: (0, $b7EWj.DecorationSet).empty,
            stats: null,
            triggerHandler: undefined,
            items: [],
            removePrefixTriggerOnCancel: undefined
        };
    };
    return (tr, currentPluginState, typeAheadStepOverride)=>{
        const meta = tr.getMeta((0, $kPuXt.pluginKey)) || {};
        // This code below controls when we should force
        // the menu to open or close during undo/redo operations
        const overrideHandler = findHandler(typeAheadStepOverride);
        if (typeAheadStepOverride && overrideHandler && $93f7a9637f86d44b$var$shouldForceOpen(typeAheadStepOverride)) return openMenu(currentPluginState, {
            tr: tr,
            triggerHandler: overrideHandler,
            inputMethod: (0, $bMFKb.INPUT_METHOD).KEYBOARD,
            reopenQuery: typeAheadStepOverride.query,
            selectedIndex: typeAheadStepOverride.selectedIndex
        });
        else if ($93f7a9637f86d44b$var$shouldForceClose(typeAheadStepOverride)) return closeMenu(currentPluginState);
        const { action: action, params: params } = meta || {};
        const shouldOpenMenu = action === (0, $ckKJp.ACTIONS).OPEN_TYPEAHEAD_AT_CURSOR && (0, $elKSH.isTypeAheadHandler)(params?.triggerHandler);
        const selectionChanged = tr.selectionSet && (tr.isGeneric || Boolean(tr.getMeta('pointer')));
        const shouldCloseMenu = [
            (0, $ckKJp.ACTIONS).CLOSE_TYPE_AHEAD,
            (0, $ckKJp.ACTIONS).INSERT_ITEM
        ].includes(action) || selectionChanged;
        const shouldUpdateQuery = action === (0, $ckKJp.ACTIONS).CHANGE_QUERY;
        const shouldUpdateListItems = action === (0, $ckKJp.ACTIONS).UPDATE_LIST_ITEMS;
        const shouldUpdateListError = action === (0, $ckKJp.ACTIONS).UPDATE_LIST_ERROR;
        const shouldUpdateSelectedIndex = action === (0, $ckKJp.ACTIONS).UPDATE_SELECTED_INDEX;
        const shouldClearListError = action === (0, $ckKJp.ACTIONS).CLEAR_LIST_ERROR;
        if (shouldOpenMenu) return openMenu(currentPluginState, {
            tr: tr,
            triggerHandler: params.triggerHandler,
            inputMethod: params.inputMethod,
            reopenQuery: params.query,
            removePrefixTriggerOnCancel: params.removePrefixTriggerOnCancel
        });
        else if (shouldCloseMenu) return closeMenu(currentPluginState);
        else if (shouldUpdateQuery) return {
            ...currentPluginState,
            query: params.query
        };
        else if (shouldUpdateListError) {
            const { errorInfo: errorInfo } = params;
            return {
                ...currentPluginState,
                errorInfo: errorInfo,
                items: [],
                selectedIndex: -1
            };
        } else if (shouldUpdateListItems) {
            const { items: items } = params;
            const { selectedIndex: selectedIndex } = currentPluginState;
            return {
                ...currentPluginState,
                items: items,
                selectedIndex: Math.max(selectedIndex >= items.length ? items.length - 1 : selectedIndex, -1)
            };
        } else if (shouldUpdateSelectedIndex) return {
            ...currentPluginState,
            selectedIndex: params.selectedIndex
        };
        else if (shouldClearListError) return {
            ...currentPluginState,
            errorInfo: null
        };
        if (tr.docChanged) {
            const { decorationSet: decorationSet } = currentPluginState;
            const onRemove = ()=>{
                // Make sure we are unmounting the component
                // from the react tree when this decoration is removed
                removeDecorations(currentPluginState.decorationSet);
            };
            const mappedDecorationSet = decorationSet.map(tr.mapping, tr.doc, {
                onRemove: onRemove
            });
            // return same pluginState if decorationSet did not change
            if (mappedDecorationSet === currentPluginState.decorationSet) return currentPluginState;
            return {
                ...currentPluginState,
                decorationSet: mappedDecorationSet
            };
        }
        return currentPluginState;
    };
};

});


parcelRegister("7EuRs", function(module, exports) {
$parcel$export(module.exports, "ContentComponent", () => $9d2301ec1aae957c$export$2dda1e4a1d1f6a81);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $cxXTK = parcelRequire("cxXTK");

var $7k8dr = parcelRequire("7k8dr");

var $92xoS = parcelRequire("92xoS");

var $ccZYC = parcelRequire("ccZYC");

var $eKKzu = parcelRequire("eKKzu");
function $9d2301ec1aae957c$export$2dda1e4a1d1f6a81({ api: api, editorView: editorView, popupMountRef: popupMountRef }) {
    const { triggerHandler: triggerHandler, items: items, errorInfo: errorInfo, decorationElement: decorationElement, decorationSet: decorationSet, query: query, selectedIndex: selectedIndex } = (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'typeAhead'
    ], (states)=>({
            triggerHandler: states.typeAheadState?.triggerHandler,
            items: states.typeAheadState?.items,
            errorInfo: states.typeAheadState?.errorInfo,
            decorationElement: states.typeAheadState?.decorationElement,
            decorationSet: states.typeAheadState?.decorationSet,
            query: states.typeAheadState?.query,
            selectedIndex: states.typeAheadState?.selectedIndex
        }));
    if (items === undefined || decorationSet === undefined || errorInfo === undefined || decorationElement === undefined || query === undefined || selectedIndex === undefined) return null;
    if (// TODO: ED-26959 - Also requires a check for editor appearance (needs to be enabled for full-page/full-width editor only ?)
    !(0, $92xoS.editorExperiment)('platform_editor_insertion', 'control') && triggerHandler?.id === (0, $7k8dr.TypeAheadAvailableNodes).QUICK_INSERT) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ccZYC.TypeAheadMenu), {
        editorView: editorView,
        popupMountRef: popupMountRef,
        typeAheadState: {
            triggerHandler: triggerHandler,
            items: items,
            errorInfo: errorInfo,
            decorationElement: decorationElement,
            decorationSet: decorationSet,
            query: query
        },
        api: api
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eKKzu.TypeAheadMenu), {
        editorView: editorView,
        popupMountRef: popupMountRef,
        typeAheadState: {
            triggerHandler: triggerHandler,
            items: items,
            errorInfo: errorInfo,
            decorationElement: decorationElement,
            decorationSet: decorationSet,
            query: query
        },
        selectedIndex: selectedIndex,
        api: api
    });
}

});
parcelRegister("ccZYC", function(module, exports) {
$parcel$export(module.exports, "TypeAheadMenu", () => $377c694aba1822a9$export$b11addef9209139);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7k8dr = parcelRequire("7k8dr");

var $lKOUs = parcelRequire("lKOUs");

var $l9ZHZ = parcelRequire("l9ZHZ");

var $lweSp = parcelRequire("lweSp");
const $377c694aba1822a9$export$b11addef9209139 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ editorView: editorView, popupMountRef: popupMountRef, typeAheadState: typeAheadState, api: api })=>{
    const isOpen = typeAheadState.decorationSet.find().length > 0;
    const { triggerHandler: triggerHandler, items: items, errorInfo: errorInfo, decorationElement: decorationElement, decorationSet: decorationSet, query: query } = typeAheadState;
    const [onItemInsert, onTextInsert] = (0, $l9ZHZ.useItemInsert)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    triggerHandler, editorView, items, api);
    const setSelectedItem = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(({ index: nextIndex })=>{
        queueMicrotask(()=>{
            (0, $lKOUs.updateSelectedIndex)(nextIndex, api)(editorView.state, editorView.dispatch);
        });
    }, [
        editorView,
        api
    ]);
    const insertItem = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((mode = (0, $7k8dr.SelectItemMode).SELECTED, index)=>{
        queueMicrotask(()=>{
            onItemInsert({
                mode: mode,
                index: index,
                query: query
            });
        });
    }, [
        onItemInsert,
        query
    ]);
    const cancel = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(({ setSelectionAt: setSelectionAt, addPrefixTrigger: addPrefixTrigger, forceFocusOnEditor: forceFocusOnEditor })=>{
        const fullQuery = addPrefixTrigger ? `${triggerHandler?.trigger}${query}` : query;
        onTextInsert({
            forceFocusOnEditor: forceFocusOnEditor,
            setSelectionAt: setSelectionAt,
            text: fullQuery
        });
    }, [
        triggerHandler,
        onTextInsert,
        query
    ]);
    if (!isOpen || !triggerHandler || !(decorationElement instanceof HTMLElement) || items.length === 0 && !errorInfo) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lweSp.TypeAheadPopup), {
        editorView: editorView,
        popupsMountPoint: popupMountRef.current?.popupsMountPoint,
        popupsBoundariesElement: popupMountRef.current?.popupsBoundariesElement,
        popupsScrollableElement: popupMountRef.current?.popupsScrollableElement,
        anchorElement: decorationElement,
        triggerHandler: triggerHandler,
        items: items,
        errorInfo: errorInfo,
        // selectedIndex={selectedIndex}
        setSelectedItem: setSelectedItem,
        onItemInsert: insertItem,
        decorationSet: decorationSet,
        isEmptyQuery: !query,
        query: query,
        cancel: cancel,
        api: api
    });
});

});
parcelRegister("lweSp", function(module, exports) {
$parcel$export(module.exports, "TypeAheadPopup", () => $eca9707f48496564$export$fbc0702507873a7d);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $bRPNB = parcelRequire("bRPNB");

var $lRq8t = parcelRequire("lRq8t");

var $bMFKb = parcelRequire("bMFKb");

var $4DFTL = parcelRequire("4DFTL");

var $dwnni = parcelRequire("dwnni");
var $avm98 = parcelRequire("avm98");

var $1eH5X = parcelRequire("1eH5X");
var $dGNvX = parcelRequire("dGNvX");

var $7yBx7 = parcelRequire("7yBx7");

var $dcLzM = parcelRequire("dcLzM");

var $eGOwo = parcelRequire("eGOwo");


var $eQTrE = parcelRequire("eQTrE");

var $nMpI6 = parcelRequire("nMpI6");
const $eca9707f48496564$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT = 520;
// const DEFAULT_TYPEAHEAD_MENU_HEIGHT_NEW = 480;
const $eca9707f48496564$var$ITEM_PADDING = 12;
const $eca9707f48496564$var$INSERT_PANEL_WIDTH = 320;
const $eca9707f48496564$var$typeAheadContent = /*#__PURE__*/ (0, $1NIU8.css)({
    background: `var(--ds-surface-overlay, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
    borderRadius: "var(--ds-radius-small, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 1px ${(0, $7bb4c1736002a04a$export$d2d3bedfb276cac0)}, 0 4px 8px -2px ${(0, $7bb4c1736002a04a$export$7d3359664e8bb0e5)}`})`,
    padding: `${"var(--ds-space-050, 4px)"} 0`,
    width: '280px',
    maxHeight: '520px' /* ~5.5 visibile items */ ,
    overflowY: 'auto',
    MsOverflowStyle: '-ms-autohiding-scrollbar',
    position: 'relative'
});
const $eca9707f48496564$var$OFFSET = [
    0,
    8
];
const $eca9707f48496564$export$fbc0702507873a7d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo((props)=>{
    const { triggerHandler: triggerHandler, anchorElement: anchorElement, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, items: items, errorInfo: errorInfo, onItemInsert: onItemInsert, isEmptyQuery: isEmptyQuery, cancel: cancel, api: api, query: query, setSelectedItem: setSelectedItem } = props;
    const ref = (0, $eJOHy.useRef)(null);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const defaultMenuHeight = $eca9707f48496564$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT;
    const startTime = (0, $eJOHy.useMemo)(()=>performance.now(), // In case those props changes
    // we need to recreate the startTime
    [
        items,
        isEmptyQuery,
        triggerHandler
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
    (0, $eJOHy.useEffect)(()=>{
        if (!api?.analytics?.actions?.fireAnalyticsEvent) return;
        const stopTime = performance.now();
        const time = stopTime - startTime;
        api?.analytics?.actions?.fireAnalyticsEvent({
            action: (0, $bMFKb.ACTION).RENDERED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).TYPEAHEAD,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
            attributes: {
                time: time,
                items: items.length,
                initial: isEmptyQuery
            }
        });
    }, [
        startTime,
        items,
        isEmptyQuery,
        // In case the current triggerHandler changes
        // e.g: Inserting a mention using the quick insert
        // we need to send the event again
        // eslint-disable-next-line react-hooks/exhaustive-deps
        triggerHandler,
        api
    ]);
    // useEffect(() => {
    // 	if (!api?.analytics?.actions?.fireAnalyticsEvent) {
    // 		return;
    // 	}
    // 	api?.analytics?.actions?.fireAnalyticsEvent({
    // 		action: ACTION.VIEWED,
    // 		actionSubject: ACTION_SUBJECT.TYPEAHEAD_ITEM,
    // 		eventType: EVENT_TYPE.OPERATIONAL,
    // 		attributes: {
    // 			index: selectedIndex,
    // 			items: items.length,
    // 		},
    // 	});
    // }, [
    // 	items,
    // 	api,
    // 	selectedIndex,
    // 	// In case the current triggerHandler changes
    // 	// e.g: Inserting a mention using the quick insert
    // 	// we need to send the event again
    // 	// eslint-disable-next-line react-hooks/exhaustive-deps
    // 	triggerHandler,
    // ]);
    const [fitHeight, setFitHeight] = (0, $eJOHy.useState)(defaultMenuHeight);
    const getFitHeight = (0, $eJOHy.useCallback)(()=>{
        if (!anchorElement || !popupsMountPoint) return;
        const target = anchorElement;
        const { top: targetTop, height: targetHeight } = target.getBoundingClientRect();
        const boundariesElement = popupsBoundariesElement || document.body;
        const { height: boundariesHeight, top: boundariesTop } = boundariesElement.getBoundingClientRect();
        // Calculating the space above and space below our decoration
        const spaceAbove = targetTop - (boundariesTop - boundariesElement.scrollTop);
        const spaceBelow = boundariesTop + boundariesHeight - (targetTop + targetHeight);
        // Keep default height if more than enough space
        if (spaceBelow >= defaultMenuHeight) return setFitHeight(defaultMenuHeight);
        // Determines whether typeahead will fit above or below decoration
        // and return the space available.
        const newFitHeight = spaceBelow >= spaceAbove ? spaceBelow : spaceAbove;
        // Each typeahead item has some padding
        // We want to leave some space at the top so first item
        // is not partially cropped
        const fitHeightWithSpace = newFitHeight - $eca9707f48496564$var$ITEM_PADDING * 2;
        // Ensure typeahead height is max its default height
        const minFitHeight = Math.min(defaultMenuHeight, fitHeightWithSpace);
        return setFitHeight(minFitHeight);
    }, [
        anchorElement,
        defaultMenuHeight,
        popupsBoundariesElement,
        popupsMountPoint
    ]);
    const getFitHeightDebounced = (0, $bRPNB.default)(getFitHeight);
    (0, $eJOHy.useLayoutEffect)(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const scrollableElement = popupsScrollableElement || (0, $dwnni.findOverflowScrollParent)(anchorElement);
        getFitHeight();
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('resize', getFitHeightDebounced);
        if (scrollableElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        scrollableElement.addEventListener('scroll', getFitHeightDebounced);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('resize', getFitHeightDebounced);
            if (scrollableElement) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            scrollableElement.removeEventListener('scroll', getFitHeightDebounced);
        };
    }, [
        anchorElement,
        popupsScrollableElement,
        getFitHeightDebounced,
        getFitHeight
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        const focusOut = (event)=>{
            const { relatedTarget: relatedTarget } = event;
            // Given the user is changing the focus
            // When the target is inside the TypeAhead Popup
            // Then the popup should stay open
            if (relatedTarget instanceof HTMLElement && relatedTarget.closest && (relatedTarget.closest(`.${(0, $eQTrE.TYPE_AHEAD_POPUP_CONTENT_CLASS)}`) || relatedTarget.closest(`[data-type-ahead="${(0, $eQTrE.TYPE_AHEAD_DECORATION_DATA_ATTRIBUTE)}"]`))) return;
            // Handles cases like emoji and @ typeaheads that open new typeaheads
            const isTextSelected = window.getSelection()?.type === 'Range';
            const innerEditor = anchorElement.closest('.extension-editable-area');
            if (innerEditor) {
                // When there is no related target, we default to not closing the popup
                let newFocusInsideCurrentEditor = !relatedTarget;
                if (relatedTarget instanceof HTMLElement) // check if the new focus is inside inner editor, keep popup opens
                newFocusInsideCurrentEditor = innerEditor.contains(relatedTarget);
                if (!isTextSelected && newFocusInsideCurrentEditor) return;
            } else {
                // if the current focus in outer editor, keep the existing behaviour, do not close the pop up if text is not selected
                if (!isTextSelected) return;
            }
            cancel({
                addPrefixTrigger: true,
                setSelectionAt: (0, $eQTrE.CloseSelectionOptions).AFTER_TEXT_INSERTED,
                forceFocusOnEditor: false
            });
        };
        const { current: element } = ref;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('focusout', focusOut);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('focusout', focusOut);
        };
    }, [
        ref,
        cancel,
        anchorElement
    ]);
    // TODO: ED-17443 - When you press escape on typeahead panel, it should remove focus and close the panel
    // This is the expected keyboard behaviour advised by the Accessibility team
    (0, $eJOHy.useLayoutEffect)(()=>{
        const escape = (event)=>{
            if (event.key === 'Escape') cancel({
                addPrefixTrigger: true,
                setSelectionAt: (0, $eQTrE.CloseSelectionOptions).AFTER_TEXT_INSERTED,
                forceFocusOnEditor: true
            });
        };
        const { current: element } = ref;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', escape);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', escape);
        };
    }, [
        ref,
        cancel
    ]);
    const handleViewAllItemsClick = (0, $eJOHy.useCallback)(()=>{
        const showContextPanel = api?.contextPanel?.actions?.showPanel;
        if (!showContextPanel || !items) return;
        // Opens main editor controls side panel
        showContextPanel({
            id: 'editor-element-insert-sidebar-panel',
            headerComponentElements: {
                headerLabel: (0, $4DFTL.elementInsertSidePanel).title,
                HeaderIcon: ()=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
                        label: formatMessage((0, $4DFTL.elementInsertSidePanel).title)
                    })
            },
            BodyComponent: ()=>{
                return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $dGNvX.SideInsertPanel), {
                    items: items,
                    onItemInsert: onItemInsert
                });
            }
        }, 'push', $eca9707f48496564$var$INSERT_PANEL_WIDTH);
        // Closes typeahead
        cancel({
            addPrefixTrigger: true,
            setSelectionAt: (0, $eQTrE.CloseSelectionOptions).AFTER_TEXT_INSERTED,
            forceFocusOnEditor: true
        });
    }, [
        api,
        cancel,
        formatMessage,
        items,
        onItemInsert
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $avm98.default), {
        zIndex: (0, $7yBx7.akEditorFloatingDialogZIndex),
        target: anchorElement,
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        fitHeight: fitHeight,
        fitWidth: 280,
        offset: $eca9707f48496564$var$OFFSET,
        ariaLabel: null,
        preventOverflow: true
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            $eca9707f48496564$var$typeAheadContent
        ],
        tabIndex: (0, $eGOwo.fg)('platform_editor_a11y_fix_typeahead_tabindex') ? undefined : 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $eQTrE.TYPE_AHEAD_POPUP_CONTENT_CLASS),
        ref: ref
    }, errorInfo ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $nMpI6.TypeAheadErrorFallback), null) : /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $1eH5X.QuickInsertPanel), {
        items: items,
        onItemInsert: onItemInsert,
        query: query,
        setSelectedItem: setSelectedItem,
        onViewAllItemsClick: Boolean(api?.contextPanel) ? handleViewAllItemsClick : undefined
    }))));
});
$eca9707f48496564$export$fbc0702507873a7d.displayName = 'TypeAheadPopup';

});
parcelRegister("1eH5X", function(module, exports) {
$parcel$export(module.exports, "QuickInsertPanel", () => $ccd11f0d9a88743c$export$c4b59221ed3995fe);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7k8dr = parcelRequire("7k8dr");

var $6YEko = parcelRequire("6YEko");

var $8nu6j = parcelRequire("8nu6j");
var $dW738 = parcelRequire("dW738");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $inQ44 = parcelRequire("inQ44");

var $i8VaZ = parcelRequire("i8VaZ");

var $aG5mc = parcelRequire("aG5mc");

var $e1oUK = parcelRequire("e1oUK");

var $3CAGn = parcelRequire("3CAGn");
const $ccd11f0d9a88743c$var$navButtonContainerStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.0',
    paddingBottom: 'space.0',
    paddingLeft: 'space.200',
    paddingRight: 'space.200'
});
const $ccd11f0d9a88743c$var$DefaultView = ({ suggested: suggested, itemsRegistry: itemsRegistry, categoryRegistry: categoryRegistry, onItemSelected: onItemSelected, onCategorySelected: onCategorySelected, setSelectedItem: setSelectedItem })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dW738.default), {
        children: [
            suggested && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i8VaZ.ListButtonGroupWithHeading), {
                id: suggested.id,
                items: suggested.items.slice(0, 6),
                label: suggested.label,
                onItemSelected: onItemSelected,
                setSelectedItem: setSelectedItem,
                startingIndex: 0
            }),
            (0, $inQ44.CategoriesStructure).map((category)=>{
                const { defautltItems: defautltItems } = category;
                const items = defautltItems.length > 0 ? defautltItems.map((itemIdOrTitle)=>itemsRegistry[itemIdOrTitle]).filter((item)=>item) : categoryRegistry[category.id] ? categoryRegistry[category.id].slice(0, 5) : [];
                return items.length > 0 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6YEko.default), {
                    hasSeparator: true,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                        xcss: $ccd11f0d9a88743c$var$navButtonContainerStyles,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e1oUK.LinkNavButton), {
                            id: category.id,
                            label: category.title,
                            onClick: onCategorySelected
                        })
                    })
                }, category.id);
            })
        ]
    });
};
const $ccd11f0d9a88743c$var$CategoryView = ({ categoryRegistry: categoryRegistry, selectedCategory: selectedCategory, onItemSelected: onItemSelected, onBackButtonClicked: onBackButtonClicked })=>{
    const categoryData = (0, $inQ44.PredefinedCategories).get(selectedCategory);
    const categoryLevelItems = categoryRegistry[selectedCategory] || [];
    let startingIndex = categoryLevelItems.length;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dW738.default), {
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3CAGn.SubPanelWithBackButton), {
            label: categoryData.title,
            buttonLabel: "Back to all items",
            onClick: onBackButtonClicked,
            children: [
                categoryLevelItems.length > 0 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i8VaZ.ListButtonGroup), {
                    id: categoryData.id,
                    items: categoryLevelItems,
                    onItemSelected: onItemSelected,
                    startingIndex: 0
                }),
                categoryData && categoryData.subcategories.map(({ id: id, title: title })=>{
                    if (categoryRegistry[id]) {
                        const list = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i8VaZ.ListButtonGroupWithHeading), {
                            id: id,
                            label: title,
                            items: categoryRegistry[id],
                            onItemSelected: onItemSelected,
                            startingIndex: startingIndex
                        });
                        startingIndex += categoryRegistry[id].length;
                        return list;
                    }
                })
            ]
        })
    });
};
const $ccd11f0d9a88743c$var$SearchView = ({ items: items, onItemSelected: onItemSelected, setSelectedItem: setSelectedItem })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i8VaZ.ListButtonGroup), {
        id: 'search',
        items: items,
        onItemSelected: onItemSelected,
        setSelectedItem: setSelectedItem,
        startingIndex: 0
    });
};
const $ccd11f0d9a88743c$var$EmptySearchView = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        padding: "space.300",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dW738.default), {
            space: "space.0",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                    align: "center",
                    as: "p",
                    children: "We couldn't find any results."
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $5qJVF.default), {
                    align: "center",
                    as: "p",
                    children: [
                        "Select ",
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                            weight: "medium",
                            children: "View all"
                        }),
                        " to browser inserts."
                    ]
                })
            ]
        })
    });
};
const $ccd11f0d9a88743c$export$c4b59221ed3995fe = /*#__PURE__*/ (0, $eJOHy.memo)(({ items: items, onItemInsert: onItemInsert, onViewAllItemsClick: onViewAllItemsClick, query: query, setSelectedItem: setSelectedItem })=>{
    const onItemSelect = (0, $eJOHy.useCallback)((index)=>{
        onItemInsert((0, $7k8dr.SelectItemMode).SELECTED, index);
    }, [
        onItemInsert
    ]);
    const { suggested: suggested, categoryRegistry: categoryRegistry, itemsRegistry: itemsRegistry, selectedCategory: selectedCategory, searchItems: searchItems, setSelectedCategory: setSelectedCategory } = (0, $inQ44.useItems)(items, query);
    const showViewAllItems = Boolean(onViewAllItemsClick);
    const view = searchItems ? searchItems.length > 0 ? /*#__PURE__*/ (0, $gt9Am.jsx)($ccd11f0d9a88743c$var$SearchView, {
        items: searchItems,
        onItemSelected: onItemSelect,
        setSelectedItem: setSelectedItem
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)($ccd11f0d9a88743c$var$EmptySearchView, {}) : selectedCategory ? /*#__PURE__*/ (0, $gt9Am.jsx)($ccd11f0d9a88743c$var$CategoryView, {
        categoryRegistry: categoryRegistry,
        selectedCategory: selectedCategory,
        onItemSelected: onItemSelect,
        onBackButtonClicked: ()=>setSelectedCategory(undefined)
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)($ccd11f0d9a88743c$var$DefaultView, {
        suggested: suggested,
        itemsRegistry: itemsRegistry,
        categoryRegistry: categoryRegistry,
        onItemSelected: onItemSelect,
        onCategorySelected: (categoryId)=>{
            setSelectedCategory(categoryId);
        },
        setSelectedItem: setSelectedItem
    });
    if (showViewAllItems) return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            view,
            showViewAllItems && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aG5mc.ViewAllButtonItem), {
                isViewAllInserts: true,
                label: 'View all inserts',
                onClick: onViewAllItemsClick ? onViewAllItemsClick : ()=>{}
            })
        ]
    });
    else return view;
});

});
parcelRegister("inQ44", function(module, exports) {
$parcel$export(module.exports, "CategoriesStructure", () => $40fe34ab6d5092d7$export$55e347ea2fcfe5fb);
$parcel$export(module.exports, "PredefinedCategories", () => $40fe34ab6d5092d7$export$55985cbdefca4b42);
$parcel$export(module.exports, "useItems", () => $40fe34ab6d5092d7$export$7bfdd97581ca93c);

var $eJOHy = parcelRequire("eJOHy");

var $6Exgk = parcelRequire("6Exgk");

var $12rg6 = parcelRequire("12rg6");

var $LbAHp = parcelRequire("LbAHp");
const $40fe34ab6d5092d7$var$transformBrowserElementItem = (item)=>{
    return {
        index: item.tempKey,
        title: item.title,
        description: item.description,
        showDescription: Boolean(item?.id) && item.id !== 'datasource' ? false : true,
        keyshortcut: item.keyshortcut ? (0, $6Exgk.makeKeyMapWithCommon)('', item.keyshortcut) : undefined,
        renderIcon: item.icon
    };
};
const $40fe34ab6d5092d7$export$55e347ea2fcfe5fb = [
    {
        id: 'media',
        title: 'Media',
        subcategories: [],
        // defaultItems and array or native elements' ids or titles of an extensions
        // TODO: ED-26961 - how should we identify extensions in prod?
        // Note: only 'media' or 'media-insert' will be available, so we'll display only 5 default items
        defautltItems: [
            'media',
            'media-insert',
            'emoji',
            'hyperlink',
            'loom',
            'Create whiteboard'
        ]
    },
    {
        id: 'structure',
        title: 'Structure',
        subcategories: [
            {
                id: 'text structure',
                title: 'Text structure'
            },
            {
                id: 'page structure',
                title: 'Page structure'
            },
            {
                id: 'connect pages',
                title: 'Connect pages'
            },
            {
                id: 'navigation',
                title: 'Navigation'
            },
            {
                id: 'search',
                title: 'Search'
            }
        ],
        defautltItems: [
            'date',
            'decision',
            'status',
            'table',
            'Table of contents'
        ]
    },
    {
        id: 'data',
        title: 'Data',
        subcategories: [
            {
                id: 'charts',
                title: 'Charts'
            },
            {
                id: 'gadgets',
                title: 'Gadgets'
            },
            {
                id: 'jira',
                title: 'Jira'
            },
            {
                id: 'labels',
                title: 'Labels'
            },
            {
                id: 'reports',
                title: 'Reports'
            },
            {
                id: 'timelines',
                title: 'Timelines'
            }
        ],
        defautltItems: [
            'Create database',
            'Filter by label',
            'Chart',
            'Create Jira issue',
            'Content Report Table'
        ]
    },
    {
        id: 'collaborate',
        title: 'Collaborate',
        subcategories: [],
        defautltItems: [
            'mention',
            'Contributors',
            'Contributors Summary',
            'User Profile',
            'Spaces List'
        ]
    },
    {
        id: 'ai',
        title: 'Atlassian Intelligence',
        subcategories: [],
        defautltItems: []
    },
    {
        id: 'apps',
        title: 'Apps',
        subcategories: [],
        defautltItems: []
    }
];
const $40fe34ab6d5092d7$export$55985cbdefca4b42 = new Map();
$40fe34ab6d5092d7$export$55e347ea2fcfe5fb.forEach((categoryData)=>{
    $40fe34ab6d5092d7$export$55985cbdefca4b42.set(categoryData.id, categoryData);
    categoryData.subcategories.forEach((subcategoryData)=>{
        $40fe34ab6d5092d7$export$55985cbdefca4b42.set(subcategoryData.id, subcategoryData);
    });
});
const $40fe34ab6d5092d7$var$parseCategories = (itemCategories)=>{
    if (!itemCategories) return [
        'apps'
    ];
    const filteredCategories = itemCategories.filter((category)=>{
        return $40fe34ab6d5092d7$export$55985cbdefca4b42.has(category.toLocaleLowerCase());
    });
    return filteredCategories.length > 0 ? filteredCategories : [
        'apps'
    ];
};
const $40fe34ab6d5092d7$var$suggestedIds = [
    'table',
    'action',
    'codeblock',
    'infopanel',
    'threecolumnslayout',
    'emoji',
    'rule',
    'expand'
];
const $40fe34ab6d5092d7$export$7bfdd97581ca93c = (quickInsertPanelItems, query)=>{
    const [searchText, setSearchText] = (0, $eJOHy.useState)(query);
    const [selectedCategory, setSelectedCategory] = (0, $eJOHy.useState)();
    const insertPanelItems = (0, $eJOHy.useMemo)(()=>(0, $12rg6.getMappedItems)(quickInsertPanelItems), [
        quickInsertPanelItems
    ]);
    const categoryRegistry = {};
    const itemsRegistry = {};
    const suggestedItems = [];
    insertPanelItems.forEach((item)=>{
        const categories = $40fe34ab6d5092d7$var$parseCategories(item.categories);
        const preparedItem = $40fe34ab6d5092d7$var$transformBrowserElementItem(item);
        categories.forEach((category)=>{
            category = category.toLocaleLowerCase();
            if (categoryRegistry[category]) categoryRegistry[category].push(preparedItem);
            else categoryRegistry[category] = [
                preparedItem
            ];
        });
        const itemKey = item.id || item.title;
        itemsRegistry[itemKey] = preparedItem;
        for(let i = 0; i < $40fe34ab6d5092d7$var$suggestedIds.length; i++){
            const realSuggestedItems = suggestedItems.filter((item)=>item);
            if (realSuggestedItems.length < $40fe34ab6d5092d7$var$suggestedIds.length && itemKey === $40fe34ab6d5092d7$var$suggestedIds[i]) suggestedItems[i] = preparedItem;
        }
    });
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    const suggested = {
        id: 'suggested',
        label: 'Suggestions',
        items: suggestedItems
    }; // TODO define the id and label as constants
    // when query gets updated from the prop drilling it won't cause a re-render of the hook
    // as it will be treated only as default state, so for now combinbing searchText and query here
    // we need to find a better more performant solution for the search (after the demo)
    const combinedSearchText = (0, $eJOHy.useMemo)(()=>searchText || query, [
        query,
        searchText
    ]);
    const searchItems = (0, $eJOHy.useMemo)(()=>{
        if (!combinedSearchText) return undefined;
        const filteredItems = (0, $LbAHp.find)(combinedSearchText, insertPanelItems);
        return filteredItems.map((item)=>$40fe34ab6d5092d7$var$transformBrowserElementItem(item));
    }, [
        insertPanelItems,
        combinedSearchText
    ]);
    return {
        suggested: suggested,
        categoryRegistry: categoryRegistry,
        itemsRegistry: itemsRegistry,
        selectedCategory: selectedCategory,
        searchItems: searchItems,
        setSearchText: setSearchText,
        setSelectedCategory: setSelectedCategory
    };
};

});
parcelRegister("12rg6", function(module, exports) {
$parcel$export(module.exports, "getMappedItems", () => $3d986e0a51248d06$export$c9a8cf32755faa87);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $l8Loi = parcelRequire("l8Loi");

var $5Fohz = parcelRequire("5Fohz");

var $iHaKK = parcelRequire("iHaKK");

var $8lO5P = parcelRequire("8lO5P");

var $btkTq = parcelRequire("btkTq");

var $kXFxs = parcelRequire("kXFxs");

var $euu4D = parcelRequire("euu4D");

var $1U4zO = parcelRequire("1U4zO");

var $fJNLD = parcelRequire("fJNLD");

var $6BR9Q = parcelRequire("6BR9Q");

var $9Nvwv = parcelRequire("9Nvwv");

var $cV8sz = parcelRequire("cV8sz");

var $4HB8x = parcelRequire("4HB8x");

var $amerd = parcelRequire("amerd");

var $bwM92 = parcelRequire("bwM92");

var $bTWCd = parcelRequire("bTWCd");
const $3d986e0a51248d06$var$getItemData = (item, tempKey)=>{
    const itemId = item.id;
    const itemTitle = item.title;
    if (itemId && itemId !== 'datasource') switch(itemId){
        case 'action':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bwM92))), {
                        label: ""
                    }),
                categories: [
                    'text structure'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'media-insert':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fJNLD))), {
                        label: ""
                    }),
                categories: [
                    'media'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'mention':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4HB8x))), {
                        label: ""
                    }),
                categories: [
                    'collaborate'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'emoji':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($euu4D))), {
                        label: ""
                    }),
                categories: [
                    'media'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'expand':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5Fohz))), {
                        label: ""
                    }),
                categories: [
                    'page structure'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'table':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1U4zO))), {
                        label: ""
                    }),
                categories: [
                    'page structure'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'codeblock':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8lO5P))), {
                        label: ""
                    }),
                categories: [
                    'text structure'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'status':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iHaKK))), {
                        label: ""
                    }),
                categories: [
                    'text structure'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'infopanel':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6BR9Q))), {
                        label: ""
                    }),
                categories: [
                    'page structure'
                ],
                shouldDisplayAtTop: true,
                title: 'Panel',
                tempKey: tempKey
            };
        case 'date':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($btkTq))), {
                        label: ""
                    }),
                categories: [
                    'date'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'loom':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bTWCd))), {
                        label: ""
                    }),
                categories: [
                    'media'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'decision':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kXFxs))), {
                        label: ""
                    }),
                categories: [
                    'text structure'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'threecolumnslayout':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9Nvwv))), {
                        label: ""
                    }),
                categories: [
                    'page structure'
                ],
                shouldDisplayAtTop: true,
                title: 'Layout',
                tempKey: tempKey
            };
        case 'hyperlink':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cV8sz))), {
                        label: ""
                    }),
                categories: [
                    'media'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'rule':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l8Loi))), {
                        label: ""
                    }),
                categories: [
                    'page structure'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'blockquote':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($amerd))), {
                        label: ""
                    }),
                categories: [
                    'text structure'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
    }
    else if (itemTitle) switch(itemTitle){
        case 'Assets':
            return {
                ...item,
                categories: [
                    'data'
                ],
                tempKey: tempKey
            };
        case 'Jira Issues':
        case 'Jira Road Map':
            return {
                ...item,
                categories: [
                    'jira'
                ],
                tempKey: tempKey
            };
        case 'Labels List':
        case 'Related Labels':
        case 'Labels Gadget':
        case 'Popular Labels':
            return {
                ...item,
                categories: [
                    'labels'
                ],
                tempKey: tempKey
            };
        case 'Version Report':
        case 'Time to First Response':
        case 'Decision report':
        case 'Two Dimensional Filter Statistics':
        case 'Task report':
        case 'Issue Statistics':
        case 'Page Properties Report':
            return {
                ...item,
                categories: [
                    'reports'
                ],
                tempKey: tempKey
            };
        case 'Opsgenie Incident Timeline EU':
        case 'Opsgenie Incident Timeline':
        case 'Jira timeline':
        case 'JSM Incident Timeline EU':
        case 'JSM Incident Timeline':
        case 'Resolution Time':
            return {
                ...item,
                categories: [
                    'timelines'
                ],
                tempKey: tempKey
            };
        case 'Create database':
        case 'Filter by label':
        case 'Chart':
        case 'Create Jira issue':
        case 'Content Report Table':
            return {
                ...item,
                categories: [
                    'data'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'Heat Map':
        case 'Pie Chart':
        case 'Time Since Chart':
        case 'Recently Created Chart':
        case 'Created vs. Resolved Chart':
        case 'Average Age Chart':
            return {
                ...item,
                categories: [
                    'charts'
                ],
                tempKey: tempKey
            };
        case 'Agile Wallboard Gadget':
        case 'Sprint Burndown Gadget':
            return {
                ...item,
                categories: [
                    'gadgets'
                ],
                tempKey: tempKey
            };
        case 'Anchor link':
        case 'Child pages':
        case 'Page Index':
            return {
                ...item,
                categories: [
                    'navigation'
                ],
                tempKey: tempKey
            };
        case 'Table of contents':
            return {
                ...item,
                categories: [
                    'page structure'
                ],
                tempKey: tempKey
            };
        case 'Insert Confluence list':
        case 'Live Search':
        case 'Page Tree Search':
        case 'Page Tree':
            return {
                ...item,
                categories: [
                    'search'
                ],
                tempKey: tempKey
            };
        case 'Excerpt':
        case 'Recently Updated Dashboard':
        case 'Create from Template':
            return {
                ...item,
                categories: [
                    'connect pages'
                ],
                tempKey: tempKey
            };
        case 'Powerpoint':
        case 'Excel':
        case 'Iframe':
        case 'Profile Picture':
        case 'Blog Posts':
        case 'Gallery':
        case 'Word':
        case 'PDF':
        case 'Widget Connector':
            return {
                ...item,
                categories: [
                    'media'
                ],
                tempKey: tempKey
            };
        case 'Create whiteboard':
            return {
                ...item,
                categories: [
                    'media'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'Contributors':
        case 'Contributors Summary':
        case 'User List':
        case 'Voted Issues':
        case 'User Profile':
        case 'Spaces List':
            return {
                ...item,
                categories: [
                    'collaborate'
                ],
                tempKey: tempKey
            };
        case 'Gliffy Diagram':
            return {
                ...item,
                categories: [
                    'apps'
                ],
                tempKey: tempKey
            };
        default:
            return {
                ...item,
                tempKey: tempKey
            };
    }
    return {
        ...item,
        categories: [
            'apps'
        ],
        tempKey: // category: 'apps',
        // subCategory: undefined,
        tempKey
    };
};
const $3d986e0a51248d06$export$c9a8cf32755faa87 = (items)=>{
    return items.map((item, index)=>$3d986e0a51248d06$var$getItemData(item, index));
};

});
parcelRegister("l8Loi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3d34bfaf1808a9f6cdccf6251ac5df7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f63f1b2ea61437e3$var$_react = $f63f1b2ea61437e3$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f63f1b2ea61437e3$var$_baseNew = $f63f1b2ea61437e3$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $f63f1b2ea61437e3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DividerElement".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for inserting divider elements in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f63f1b2ea61437e3$var$DividerElementIcon = (props)=>/*#__PURE__*/ $f63f1b2ea61437e3$var$_react.default.createElement($f63f1b2ea61437e3$var$_baseNew.default, Object.assign({
        name: "DividerElementIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 15v-2.5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2V15h1.5v-2.5A.5.5 0 0 1 4 12h8a.5.5 0 0 1 .5.5V15zm2-7.75H0v1.5h16zM2 3.5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V1h-1.5v2.5a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5V1H2z" clip-rule="evenodd"/>`
    }, props));
$f63f1b2ea61437e3$var$DividerElementIcon.displayName = 'DividerElementIcon';
var $f63f1b2ea61437e3$var$_default = module.exports.default = $f63f1b2ea61437e3$var$DividerElementIcon;

});

parcelRegister("5Fohz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bc4009de593579510dac1f1a04fe71b8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42039e0ef4ab9b94$var$_react = $42039e0ef4ab9b94$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $42039e0ef4ab9b94$var$_baseNew = $42039e0ef4ab9b94$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $42039e0ef4ab9b94$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ExpandElement".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for inserting expand elements in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $42039e0ef4ab9b94$var$ExpandElementIcon = (props)=>/*#__PURE__*/ $42039e0ef4ab9b94$var$_react.default.createElement($42039e0ef4ab9b94$var$_baseNew.default, Object.assign({
        name: "ExpandElementIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h12v1.5H3a.5.5 0 0 0-.5.5v12H1z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.48 8.42 4.61 5.67l1.04-1.08L8 6.84l2.36-2.25 1.04 1.08-2.87 2.75a.75.75 0 0 1-1.04 0M15 12H4.5v-1.5H15zm0 3H4.5v-1.5H15z" clip-rule="evenodd"/>`
    }, props));
$42039e0ef4ab9b94$var$ExpandElementIcon.displayName = 'ExpandElementIcon';
var $42039e0ef4ab9b94$var$_default = module.exports.default = $42039e0ef4ab9b94$var$ExpandElementIcon;

});


parcelRegister("LbAHp", function(module, exports) {
$parcel$export(module.exports, "find", () => $583415a7ae6ba102$export$71aa6c912b956294);

var $jKEuU = parcelRequire("jKEuU");
// Copied from platform/packages/editor/editor-common/src/quick-insert/utils.ts
const $583415a7ae6ba102$var$options = {
    threshold: 0.3,
    includeScore: true,
    keys: [
        {
            name: 'title',
            weight: 0.57
        },
        {
            name: 'priority',
            weight: 0.3
        },
        {
            name: 'keywords',
            weight: 0.08
        },
        {
            name: 'description',
            weight: 0.04
        },
        {
            name: 'keyshortcut',
            weight: 0.01
        }
    ]
};
// If an item has an id, it is a native editor element
// for the demo we could also use item.shouldDisplayAtTop (can potentially be
// replaced by item.isEditorExtention or something similar).
// For now, let's test search usring id as it is closer to production implementation.
const $583415a7ae6ba102$var$prioritySortingFn = (items)=>{
    return (a, b)=>{
        if (items[a.idx].id && items[b.idx].id) return a.score - b.score;
        else if (items[a.idx].id) return -1;
        else return 1;
    };
};
function $583415a7ae6ba102$export$71aa6c912b956294(query, items) {
    if (query === '') // Copy and sort list by priority
    return items.slice(0).sort((a, b)=>(a.priority || Number.POSITIVE_INFINITY) - (b.priority || Number.POSITIVE_INFINITY));
    const fuseOptions = {
        ...$583415a7ae6ba102$var$options,
        sortFn: $583415a7ae6ba102$var$prioritySortingFn(items)
    };
    const fuse = new (0, $jKEuU.default)(items, fuseOptions);
    return fuse.search(query).map((result)=>result.item);
}

});
parcelRegister("jKEuU", function(module, exports) {
$parcel$export(module.exports, "default", () => $e611ba2c9fb0d567$export$2e2bcd8739ae039);
/**
 * Fuse.js v6.6.2 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2022 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $e611ba2c9fb0d567$var$isArray(value) {
    return !Array.isArray ? $e611ba2c9fb0d567$var$getTag(value) === '[object Array]' : Array.isArray(value);
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const $e611ba2c9fb0d567$var$INFINITY = 1 / 0;
function $e611ba2c9fb0d567$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    let result = value + '';
    return result == '0' && 1 / value == -$e611ba2c9fb0d567$var$INFINITY ? '-0' : result;
}
function $e611ba2c9fb0d567$var$toString(value) {
    return value == null ? '' : $e611ba2c9fb0d567$var$baseToString(value);
}
function $e611ba2c9fb0d567$var$isString(value) {
    return typeof value === 'string';
}
function $e611ba2c9fb0d567$var$isNumber(value) {
    return typeof value === 'number';
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function $e611ba2c9fb0d567$var$isBoolean(value) {
    return value === true || value === false || $e611ba2c9fb0d567$var$isObjectLike(value) && $e611ba2c9fb0d567$var$getTag(value) == '[object Boolean]';
}
function $e611ba2c9fb0d567$var$isObject(value) {
    return typeof value === 'object';
}
// Checks if `value` is object-like.
function $e611ba2c9fb0d567$var$isObjectLike(value) {
    return $e611ba2c9fb0d567$var$isObject(value) && value !== null;
}
function $e611ba2c9fb0d567$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $e611ba2c9fb0d567$var$isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function $e611ba2c9fb0d567$var$getTag(value) {
    return value == null ? value === undefined ? '[object Undefined]' : '[object Null]' : Object.prototype.toString.call(value);
}
const $e611ba2c9fb0d567$var$EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';
const $e611ba2c9fb0d567$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const $e611ba2c9fb0d567$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
const $e611ba2c9fb0d567$var$PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
const $e611ba2c9fb0d567$var$MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
const $e611ba2c9fb0d567$var$INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
const $e611ba2c9fb0d567$var$hasOwn = Object.prototype.hasOwnProperty;
class $e611ba2c9fb0d567$var$KeyStore {
    constructor(keys){
        this._keys = [];
        this._keyMap = {};
        let totalWeight = 0;
        keys.forEach((key)=>{
            let obj = $e611ba2c9fb0d567$var$createKey(key);
            totalWeight += obj.weight;
            this._keys.push(obj);
            this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach((key)=>{
            key.weight /= totalWeight;
        });
    }
    get(keyId) {
        return this._keyMap[keyId];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
}
function $e611ba2c9fb0d567$var$createKey(key) {
    let path = null;
    let id = null;
    let src = null;
    let weight = 1;
    let getFn = null;
    if ($e611ba2c9fb0d567$var$isString(key) || $e611ba2c9fb0d567$var$isArray(key)) {
        src = key;
        path = $e611ba2c9fb0d567$var$createKeyPath(key);
        id = $e611ba2c9fb0d567$var$createKeyId(key);
    } else {
        if (!$e611ba2c9fb0d567$var$hasOwn.call(key, 'name')) throw new Error($e611ba2c9fb0d567$var$MISSING_KEY_PROPERTY('name'));
        const name = key.name;
        src = name;
        if ($e611ba2c9fb0d567$var$hasOwn.call(key, 'weight')) {
            weight = key.weight;
            if (weight <= 0) throw new Error($e611ba2c9fb0d567$var$INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = $e611ba2c9fb0d567$var$createKeyPath(name);
        id = $e611ba2c9fb0d567$var$createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $e611ba2c9fb0d567$var$createKeyPath(key) {
    return $e611ba2c9fb0d567$var$isArray(key) ? key : key.split('.');
}
function $e611ba2c9fb0d567$var$createKeyId(key) {
    return $e611ba2c9fb0d567$var$isArray(key) ? key.join('.') : key;
}
function $e611ba2c9fb0d567$var$get(obj, path) {
    let list = [];
    let arr = false;
    const deepGet = (obj, path, index)=>{
        if (!$e611ba2c9fb0d567$var$isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            let key = path[index];
            const value = obj[key];
            if (!$e611ba2c9fb0d567$var$isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && ($e611ba2c9fb0d567$var$isString(value) || $e611ba2c9fb0d567$var$isNumber(value) || $e611ba2c9fb0d567$var$isBoolean(value))) list.push($e611ba2c9fb0d567$var$toString(value));
            else if ($e611ba2c9fb0d567$var$isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, $e611ba2c9fb0d567$var$isString(path) ? path.split('.') : path, 0);
    return arr ? list : list[0];
}
const $e611ba2c9fb0d567$var$MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const $e611ba2c9fb0d567$var$BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $e611ba2c9fb0d567$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const $e611ba2c9fb0d567$var$AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $e611ba2c9fb0d567$var$get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $e611ba2c9fb0d567$var$Config = {
    ...$e611ba2c9fb0d567$var$BasicOptions,
    ...$e611ba2c9fb0d567$var$MatchOptions,
    ...$e611ba2c9fb0d567$var$FuzzyOptions,
    ...$e611ba2c9fb0d567$var$AdvancedOptions
};
const $e611ba2c9fb0d567$var$SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function $e611ba2c9fb0d567$var$norm(weight = 1, mantissa = 3) {
    const cache = new Map();
    const m = Math.pow(10, mantissa);
    return {
        get (value) {
            const numTokens = value.match($e611ba2c9fb0d567$var$SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            const n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear () {
            cache.clear();
        }
    };
}
class $e611ba2c9fb0d567$var$FuseIndex {
    constructor({ getFn: getFn = $e611ba2c9fb0d567$var$Config.getFn, fieldNormWeight: fieldNormWeight = $e611ba2c9fb0d567$var$Config.fieldNormWeight } = {}){
        this.norm = $e611ba2c9fb0d567$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
    setSources(docs = []) {
        this.docs = docs;
    }
    setIndexRecords(records = []) {
        this.records = records;
    }
    setKeys(keys = []) {
        this.keys = keys;
        this._keysMap = {};
        keys.forEach((key, idx)=>{
            this._keysMap[key.id] = idx;
        });
    }
    create() {
        if (this.isCreated || !this.docs.length) return;
        this.isCreated = true;
        // List is Array<String>
        if ($e611ba2c9fb0d567$var$isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
            this._addString(doc, docIndex);
        });
        else // List is Array<Object>
        this.docs.forEach((doc, docIndex)=>{
            this._addObject(doc, docIndex);
        });
        this.norm.clear();
    }
    // Adds a doc to the end of the index
    add(doc) {
        const idx = this.size();
        if ($e611ba2c9fb0d567$var$isString(doc)) this._addString(doc, idx);
        else this._addObject(doc, idx);
    }
    // Removes the doc at the specified index of the index
    removeAt(idx) {
        this.records.splice(idx, 1);
        // Change ref index of every subsquent doc
        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
    }
    getValueForItemAtKeyId(item, keyId) {
        return item[this._keysMap[keyId]];
    }
    size() {
        return this.records.length;
    }
    _addString(doc, docIndex) {
        if (!$e611ba2c9fb0d567$var$isDefined(doc) || $e611ba2c9fb0d567$var$isBlank(doc)) return;
        let record = {
            v: doc,
            i: docIndex,
            n: this.norm.get(doc)
        };
        this.records.push(record);
    }
    _addObject(doc, docIndex) {
        let record = {
            i: docIndex,
            $: {}
        };
        // Iterate over every key (i.e, path), and fetch the value at that key
        this.keys.forEach((key, keyIndex)=>{
            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
            if (!$e611ba2c9fb0d567$var$isDefined(value)) return;
            if ($e611ba2c9fb0d567$var$isArray(value)) {
                let subRecords = [];
                const stack = [
                    {
                        nestedArrIndex: -1,
                        value: value
                    }
                ];
                while(stack.length){
                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                    if (!$e611ba2c9fb0d567$var$isDefined(value)) continue;
                    if ($e611ba2c9fb0d567$var$isString(value) && !$e611ba2c9fb0d567$var$isBlank(value)) {
                        let subRecord = {
                            v: value,
                            i: nestedArrIndex,
                            n: this.norm.get(value)
                        };
                        subRecords.push(subRecord);
                    } else if ($e611ba2c9fb0d567$var$isArray(value)) value.forEach((item, k)=>{
                        stack.push({
                            nestedArrIndex: k,
                            value: item
                        });
                    });
                }
                record.$[keyIndex] = subRecords;
            } else if ($e611ba2c9fb0d567$var$isString(value) && !$e611ba2c9fb0d567$var$isBlank(value)) {
                let subRecord = {
                    v: value,
                    n: this.norm.get(value)
                };
                record.$[keyIndex] = subRecord;
            }
        });
        this.records.push(record);
    }
    toJSON() {
        return {
            keys: this.keys,
            records: this.records
        };
    }
}
function $e611ba2c9fb0d567$var$createIndex(keys, docs, { getFn: getFn = $e611ba2c9fb0d567$var$Config.getFn, fieldNormWeight: fieldNormWeight = $e611ba2c9fb0d567$var$Config.fieldNormWeight } = {}) {
    const myIndex = new $e611ba2c9fb0d567$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($e611ba2c9fb0d567$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $e611ba2c9fb0d567$var$parseIndex(data, { getFn: getFn = $e611ba2c9fb0d567$var$Config.getFn, fieldNormWeight: fieldNormWeight = $e611ba2c9fb0d567$var$Config.fieldNormWeight } = {}) {
    const { keys: keys, records: records } = data;
    const myIndex = new $e611ba2c9fb0d567$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function $e611ba2c9fb0d567$var$computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $e611ba2c9fb0d567$var$Config.distance, ignoreLocation: ignoreLocation = $e611ba2c9fb0d567$var$Config.ignoreLocation } = {}) {
    const accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $e611ba2c9fb0d567$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $e611ba2c9fb0d567$var$Config.minMatchCharLength) {
    let indices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
const $e611ba2c9fb0d567$var$MAX_BITS = 32;
function $e611ba2c9fb0d567$var$search(text, pattern, patternAlphabet, { location: location = $e611ba2c9fb0d567$var$Config.location, distance: distance = $e611ba2c9fb0d567$var$Config.distance, threshold: threshold = $e611ba2c9fb0d567$var$Config.threshold, findAllMatches: findAllMatches = $e611ba2c9fb0d567$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $e611ba2c9fb0d567$var$Config.minMatchCharLength, includeMatches: includeMatches = $e611ba2c9fb0d567$var$Config.includeMatches, ignoreLocation: ignoreLocation = $e611ba2c9fb0d567$var$Config.ignoreLocation } = {}) {
    if (pattern.length > $e611ba2c9fb0d567$var$MAX_BITS) throw new Error($e611ba2c9fb0d567$var$PATTERN_LENGTH_TOO_LARGE($e611ba2c9fb0d567$var$MAX_BITS));
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    const computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    const matchMask = computeMatches ? Array(textLen) : [];
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = $e611ba2c9fb0d567$var$computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << patternLen - 1;
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = $e611ba2c9fb0d567$var$computeScore$1(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $e611ba2c9fb0d567$var$computeScore$1(pattern, {
                    errors: i,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = $e611ba2c9fb0d567$var$computeScore$1(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    const result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        const indices = $e611ba2c9fb0d567$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function $e611ba2c9fb0d567$var$createPatternAlphabet(pattern) {
    let mask = {};
    for(let i = 0, len = pattern.length; i < len; i += 1){
        const char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
class $e611ba2c9fb0d567$var$BitapSearch {
    constructor(pattern, { location: location = $e611ba2c9fb0d567$var$Config.location, threshold: threshold = $e611ba2c9fb0d567$var$Config.threshold, distance: distance = $e611ba2c9fb0d567$var$Config.distance, includeMatches: includeMatches = $e611ba2c9fb0d567$var$Config.includeMatches, findAllMatches: findAllMatches = $e611ba2c9fb0d567$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $e611ba2c9fb0d567$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $e611ba2c9fb0d567$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $e611ba2c9fb0d567$var$Config.ignoreLocation } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        if (!this.pattern.length) return;
        const addChunk = (pattern, startIndex)=>{
            this.chunks.push({
                pattern: pattern,
                alphabet: $e611ba2c9fb0d567$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        const len = this.pattern.length;
        if (len > $e611ba2c9fb0d567$var$MAX_BITS) {
            let i = 0;
            const remainder = len % $e611ba2c9fb0d567$var$MAX_BITS;
            const end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, $e611ba2c9fb0d567$var$MAX_BITS), i);
                i += $e611ba2c9fb0d567$var$MAX_BITS;
            }
            if (remainder) {
                const startIndex = len - $e611ba2c9fb0d567$var$MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
    searchIn(text) {
        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
        if (!isCaseSensitive) text = text.toLowerCase();
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.indices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
        let allIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
            const { isMatch: isMatch, score: score, indices: indices } = $e611ba2c9fb0d567$var$search(text, pattern, alphabet, {
                location: location + startIndex,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches,
                ignoreLocation: ignoreLocation
            });
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && indices) allIndices = [
                ...allIndices,
                ...indices
            ];
        });
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.indices = allIndices;
        return result;
    }
}
class $e611ba2c9fb0d567$var$BaseMatch {
    constructor(pattern){
        this.pattern = pattern;
    }
    static isMultiMatch(pattern) {
        return $e611ba2c9fb0d567$var$getMatch(pattern, this.multiRegex);
    }
    static isSingleMatch(pattern) {
        return $e611ba2c9fb0d567$var$getMatch(pattern, this.singleRegex);
    }
    search() {}
}
function $e611ba2c9fb0d567$var$getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
class $e611ba2c9fb0d567$var$ExactMatch extends $e611ba2c9fb0d567$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'exact';
    }
    static get multiRegex() {
        return /^="(.*)"$/;
    }
    static get singleRegex() {
        return /^=(.*)$/;
    }
    search(text) {
        const isMatch = text === this.pattern;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !fire
class $e611ba2c9fb0d567$var$InverseExactMatch extends $e611ba2c9fb0d567$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(text) {
        const index = text.indexOf(this.pattern);
        const isMatch = index === -1;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: ^file
class $e611ba2c9fb0d567$var$PrefixExactMatch extends $e611ba2c9fb0d567$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'prefix-exact';
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(text) {
        const isMatch = text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !^fire
class $e611ba2c9fb0d567$var$InversePrefixExactMatch extends $e611ba2c9fb0d567$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-prefix-exact';
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(text) {
        const isMatch = !text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: .file$
class $e611ba2c9fb0d567$var$SuffixExactMatch extends $e611ba2c9fb0d567$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'suffix-exact';
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(text) {
        const isMatch = text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                text.length - this.pattern.length,
                text.length - 1
            ]
        };
    }
}
// Token: !.file$
class $e611ba2c9fb0d567$var$InverseSuffixExactMatch extends $e611ba2c9fb0d567$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-suffix-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(text) {
        const isMatch = !text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
class $e611ba2c9fb0d567$var$FuzzyMatch extends $e611ba2c9fb0d567$var$BaseMatch {
    constructor(pattern, { location: location = $e611ba2c9fb0d567$var$Config.location, threshold: threshold = $e611ba2c9fb0d567$var$Config.threshold, distance: distance = $e611ba2c9fb0d567$var$Config.distance, includeMatches: includeMatches = $e611ba2c9fb0d567$var$Config.includeMatches, findAllMatches: findAllMatches = $e611ba2c9fb0d567$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $e611ba2c9fb0d567$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $e611ba2c9fb0d567$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $e611ba2c9fb0d567$var$Config.ignoreLocation } = {}){
        super(pattern);
        this._bitapSearch = new $e611ba2c9fb0d567$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        });
    }
    static get type() {
        return 'fuzzy';
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(text) {
        return this._bitapSearch.searchIn(text);
    }
}
// Token: 'file
class $e611ba2c9fb0d567$var$IncludeMatch extends $e611ba2c9fb0d567$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'include';
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(text) {
        let location = 0;
        let index;
        const indices = [];
        const patternLen = this.pattern.length;
        // Get all exact matches
        while((index = text.indexOf(this.pattern, location)) > -1){
            location = index + patternLen;
            indices.push([
                index,
                location - 1
            ]);
        }
        const isMatch = !!indices.length;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: indices
        };
    }
}
// ❗Order is important. DO NOT CHANGE.
const $e611ba2c9fb0d567$var$searchers = [
    $e611ba2c9fb0d567$var$ExactMatch,
    $e611ba2c9fb0d567$var$IncludeMatch,
    $e611ba2c9fb0d567$var$PrefixExactMatch,
    $e611ba2c9fb0d567$var$InversePrefixExactMatch,
    $e611ba2c9fb0d567$var$InverseSuffixExactMatch,
    $e611ba2c9fb0d567$var$SuffixExactMatch,
    $e611ba2c9fb0d567$var$InverseExactMatch,
    $e611ba2c9fb0d567$var$FuzzyMatch
];
const $e611ba2c9fb0d567$var$searchersLen = $e611ba2c9fb0d567$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
const $e611ba2c9fb0d567$var$SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const $e611ba2c9fb0d567$var$OR_TOKEN = '|';
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $e611ba2c9fb0d567$var$parseQuery(pattern, options = {}) {
    return pattern.split($e611ba2c9fb0d567$var$OR_TOKEN).map((item)=>{
        let query = item.trim().split($e611ba2c9fb0d567$var$SPACE_RE).filter((item)=>item && !!item.trim());
        let results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            let found = false;
            let idx = -1;
            while(!found && ++idx < $e611ba2c9fb0d567$var$searchersLen){
                const searcher = $e611ba2c9fb0d567$var$searchers[idx];
                let token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $e611ba2c9fb0d567$var$searchersLen){
                const searcher = $e611ba2c9fb0d567$var$searchers[idx];
                let token = searcher.isSingleMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
const $e611ba2c9fb0d567$var$MultiMatchSet = new Set([
    $e611ba2c9fb0d567$var$FuzzyMatch.type,
    $e611ba2c9fb0d567$var$IncludeMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class $e611ba2c9fb0d567$var$ExtendedSearch {
    constructor(pattern, { isCaseSensitive: isCaseSensitive = $e611ba2c9fb0d567$var$Config.isCaseSensitive, includeMatches: includeMatches = $e611ba2c9fb0d567$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $e611ba2c9fb0d567$var$Config.minMatchCharLength, ignoreLocation: ignoreLocation = $e611ba2c9fb0d567$var$Config.ignoreLocation, findAllMatches: findAllMatches = $e611ba2c9fb0d567$var$Config.findAllMatches, location: location = $e611ba2c9fb0d567$var$Config.location, threshold: threshold = $e611ba2c9fb0d567$var$Config.threshold, distance: distance = $e611ba2c9fb0d567$var$Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $e611ba2c9fb0d567$var$parseQuery(this.pattern, this.options);
    }
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(text) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        let numMatches = 0;
        let allIndices = [];
        let totalScore = 0;
        // ORs
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            // Reset indices
            allIndices.length = 0;
            numMatches = 0;
            // ANDs
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const searcher = searchers[j];
                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if (includeMatches) {
                        const type = searcher.constructor.type;
                        if ($e611ba2c9fb0d567$var$MultiMatchSet.has(type)) allIndices = [
                            ...allIndices,
                            ...indices
                        ];
                        else allIndices.push(indices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    allIndices.length = 0;
                    break;
                }
            }
            // OR condition, so if TRUE, return
            if (numMatches) {
                let result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (includeMatches) result.indices = allIndices;
                return result;
            }
        }
        // Nothing was matched
        return {
            isMatch: false,
            score: 1
        };
    }
}
const $e611ba2c9fb0d567$var$registeredSearchers = [];
function $e611ba2c9fb0d567$var$register(...args) {
    $e611ba2c9fb0d567$var$registeredSearchers.push(...args);
}
function $e611ba2c9fb0d567$var$createSearcher(pattern, options) {
    for(let i = 0, len = $e611ba2c9fb0d567$var$registeredSearchers.length; i < len; i += 1){
        let searcherClass = $e611ba2c9fb0d567$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $e611ba2c9fb0d567$var$BitapSearch(pattern, options);
}
const $e611ba2c9fb0d567$var$LogicalOperator = {
    AND: '$and',
    OR: '$or'
};
const $e611ba2c9fb0d567$var$KeyType = {
    PATH: '$path',
    PATTERN: '$val'
};
const $e611ba2c9fb0d567$var$isExpression = (query)=>!!(query[$e611ba2c9fb0d567$var$LogicalOperator.AND] || query[$e611ba2c9fb0d567$var$LogicalOperator.OR]);
const $e611ba2c9fb0d567$var$isPath = (query)=>!!query[$e611ba2c9fb0d567$var$KeyType.PATH];
const $e611ba2c9fb0d567$var$isLeaf = (query)=>!$e611ba2c9fb0d567$var$isArray(query) && $e611ba2c9fb0d567$var$isObject(query) && !$e611ba2c9fb0d567$var$isExpression(query);
const $e611ba2c9fb0d567$var$convertToExplicit = (query)=>({
        [$e611ba2c9fb0d567$var$LogicalOperator.AND]: Object.keys(query).map((key)=>({
                [key]: query[key]
            }))
    });
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function $e611ba2c9fb0d567$var$parse(query, options, { auto: auto = true } = {}) {
    const next = (query)=>{
        let keys = Object.keys(query);
        const isQueryPath = $e611ba2c9fb0d567$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$e611ba2c9fb0d567$var$isExpression(query)) return next($e611ba2c9fb0d567$var$convertToExplicit(query));
        if ($e611ba2c9fb0d567$var$isLeaf(query)) {
            const key = isQueryPath ? query[$e611ba2c9fb0d567$var$KeyType.PATH] : keys[0];
            const pattern = isQueryPath ? query[$e611ba2c9fb0d567$var$KeyType.PATTERN] : query[key];
            if (!$e611ba2c9fb0d567$var$isString(pattern)) throw new Error($e611ba2c9fb0d567$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            const obj = {
                keyId: $e611ba2c9fb0d567$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $e611ba2c9fb0d567$var$createSearcher(pattern, options);
            return obj;
        }
        let node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach((key)=>{
            const value = query[key];
            if ($e611ba2c9fb0d567$var$isArray(value)) value.forEach((item)=>{
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$e611ba2c9fb0d567$var$isExpression(query)) query = $e611ba2c9fb0d567$var$convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function $e611ba2c9fb0d567$var$computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = $e611ba2c9fb0d567$var$Config.ignoreFieldNorm }) {
    results.forEach((result)=>{
        let totalScore = 1;
        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
            const weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function $e611ba2c9fb0d567$var$transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!$e611ba2c9fb0d567$var$isDefined(matches)) return;
    matches.forEach((match)=>{
        if (!$e611ba2c9fb0d567$var$isDefined(match.indices) || !match.indices.length) return;
        const { indices: indices, value: value } = match;
        let obj = {
            indices: indices,
            value: value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function $e611ba2c9fb0d567$var$transformScore(result, data) {
    data.score = result.score;
}
function $e611ba2c9fb0d567$var$format(results, docs, { includeMatches: includeMatches = $e611ba2c9fb0d567$var$Config.includeMatches, includeScore: includeScore = $e611ba2c9fb0d567$var$Config.includeScore } = {}) {
    const transformers = [];
    if (includeMatches) transformers.push($e611ba2c9fb0d567$var$transformMatches);
    if (includeScore) transformers.push($e611ba2c9fb0d567$var$transformScore);
    return results.map((result)=>{
        const { idx: idx } = result;
        const data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach((transformer)=>{
            transformer(result, data);
        });
        return data;
    });
}
class $e611ba2c9fb0d567$export$2e2bcd8739ae039 {
    constructor(docs, options = {}, index){
        this.options = {
            ...$e611ba2c9fb0d567$var$Config,
            ...options
        };
        this.options.useExtendedSearch;
        this._keyStore = new $e611ba2c9fb0d567$var$KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
    setCollection(docs, index) {
        this._docs = docs;
        if (index && !(index instanceof $e611ba2c9fb0d567$var$FuseIndex)) throw new Error($e611ba2c9fb0d567$var$INCORRECT_INDEX_TYPE);
        this._myIndex = index || $e611ba2c9fb0d567$var$createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
    }
    add(doc) {
        if (!$e611ba2c9fb0d567$var$isDefined(doc)) return;
        this._docs.push(doc);
        this._myIndex.add(doc);
    }
    remove(predicate = ()=>false) {
        const results = [];
        for(let i = 0, len = this._docs.length; i < len; i += 1){
            const doc = this._docs[i];
            if (predicate(doc, i)) {
                this.removeAt(i);
                i -= 1;
                len -= 1;
                results.push(doc);
            }
        }
        return results;
    }
    removeAt(idx) {
        this._docs.splice(idx, 1);
        this._myIndex.removeAt(idx);
    }
    getIndex() {
        return this._myIndex;
    }
    search(query, { limit: limit = -1 } = {}) {
        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
        let results = $e611ba2c9fb0d567$var$isString(query) ? $e611ba2c9fb0d567$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
        $e611ba2c9fb0d567$var$computeScore(results, {
            ignoreFieldNorm: ignoreFieldNorm
        });
        if (shouldSort) results.sort(sortFn);
        if ($e611ba2c9fb0d567$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
        return $e611ba2c9fb0d567$var$format(results, this._docs, {
            includeMatches: includeMatches,
            includeScore: includeScore
        });
    }
    _searchStringList(query) {
        const searcher = $e611ba2c9fb0d567$var$createSearcher(query, this.options);
        const { records: records } = this._myIndex;
        const results = [];
        // Iterate over every string in the index
        records.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$e611ba2c9fb0d567$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) results.push({
                item: text,
                idx: idx,
                matches: [
                    {
                        score: score,
                        value: text,
                        norm: norm,
                        indices: indices
                    }
                ]
            });
        });
        return results;
    }
    _searchLogical(query) {
        const expression = $e611ba2c9fb0d567$var$parse(query, this.options);
        const evaluate = (node, item, idx)=>{
            if (!node.children) {
                const { keyId: keyId, searcher: searcher } = node;
                const matches = this._findMatches({
                    key: this._keyStore.get(keyId),
                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                    searcher: searcher
                });
                if (matches && matches.length) return [
                    {
                        idx: idx,
                        item: item,
                        matches: matches
                    }
                ];
                return [];
            }
            const res = [];
            for(let i = 0, len = node.children.length; i < len; i += 1){
                const child = node.children[i];
                const result = evaluate(child, item, idx);
                if (result.length) res.push(...result);
                else if (node.operator === $e611ba2c9fb0d567$var$LogicalOperator.AND) return [];
            }
            return res;
        };
        const records = this._myIndex.records;
        const resultMap = {};
        const results = [];
        records.forEach(({ $: item, i: idx })=>{
            if ($e611ba2c9fb0d567$var$isDefined(item)) {
                let expResults = evaluate(expression, item, idx);
                if (expResults.length) {
                    // Dedupe when adding
                    if (!resultMap[idx]) {
                        resultMap[idx] = {
                            idx: idx,
                            item: item,
                            matches: []
                        };
                        results.push(resultMap[idx]);
                    }
                    expResults.forEach(({ matches: matches })=>{
                        resultMap[idx].matches.push(...matches);
                    });
                }
            }
        });
        return results;
    }
    _searchObjectList(query) {
        const searcher = $e611ba2c9fb0d567$var$createSearcher(query, this.options);
        const { keys: keys, records: records } = this._myIndex;
        const results = [];
        // List is Array<Object>
        records.forEach(({ $: item, i: idx })=>{
            if (!$e611ba2c9fb0d567$var$isDefined(item)) return;
            let matches = [];
            // Iterate over every key (i.e, path), and fetch the value at that key
            keys.forEach((key, keyIndex)=>{
                matches.push(...this._findMatches({
                    key: key,
                    value: item[keyIndex],
                    searcher: searcher
                }));
            });
            if (matches.length) results.push({
                idx: idx,
                item: item,
                matches: matches
            });
        });
        return results;
    }
    _findMatches({ key: key, value: value, searcher: searcher }) {
        if (!$e611ba2c9fb0d567$var$isDefined(value)) return [];
        let matches = [];
        if ($e611ba2c9fb0d567$var$isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$e611ba2c9fb0d567$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                idx: idx,
                norm: norm,
                indices: indices
            });
        });
        else {
            const { v: text, n: norm } = value;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                norm: norm,
                indices: indices
            });
        }
        return matches;
    }
}
$e611ba2c9fb0d567$export$2e2bcd8739ae039.version = '6.6.2';
$e611ba2c9fb0d567$export$2e2bcd8739ae039.createIndex = $e611ba2c9fb0d567$var$createIndex;
$e611ba2c9fb0d567$export$2e2bcd8739ae039.parseIndex = $e611ba2c9fb0d567$var$parseIndex;
$e611ba2c9fb0d567$export$2e2bcd8739ae039.config = $e611ba2c9fb0d567$var$Config;
$e611ba2c9fb0d567$export$2e2bcd8739ae039.parseQuery = $e611ba2c9fb0d567$var$parse;
$e611ba2c9fb0d567$var$register($e611ba2c9fb0d567$var$ExtendedSearch);

});



parcelRegister("i8VaZ", function(module, exports) {
$parcel$export(module.exports, "ListButtonGroupWithHeading", () => $7b302e46fd2fd29a$export$3f355796bb73d7b);
$parcel$export(module.exports, "ListButtonGroup", () => $7b302e46fd2fd29a$export$645edeb616ed3f65);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $806LH = parcelRequire("806LH");

var $6YEko = parcelRequire("6YEko");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $aG5mc = parcelRequire("aG5mc");
const $7b302e46fd2fd29a$var$headingContainerStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.075',
    paddingBottom: 'space.150',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});
const $7b302e46fd2fd29a$var$itemsContainerStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.0',
    paddingBottom: 'space.0',
    paddingLeft: 'space.200',
    paddingRight: 'space.200'
});
const $7b302e46fd2fd29a$var$ListButtonGroupBase = /*#__PURE__*/ (0, $eJOHy.memo)(({ id: id, label: label, items: items, hasSeparator: hasSeparator, onItemSelected: onItemSelected, setSelectedItem: setSelectedItem, startingIndex: startingIndex })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6YEko.default), {
        hasSeparator: hasSeparator,
        children: [
            label && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                xcss: [
                    $7b302e46fd2fd29a$var$headingContainerStyles
                ],
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                    size: 'xsmall',
                    as: "span",
                    children: label
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                xcss: [
                    $7b302e46fd2fd29a$var$itemsContainerStyles
                ],
                children: items.map((item, index)=>{
                    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aG5mc.ListButtonItem), {
                        index: item.index,
                        isSelected: startingIndex === undefined ? undefined : startingIndex + index === 0,
                        title: item.title,
                        description: item.description,
                        showDescription: item.showDescription,
                        attributes: item.attributes,
                        keyshortcut: item.keyshortcut,
                        renderIcon: item.renderIcon,
                        onItemSelected: (index)=>onItemSelected?.(index, id),
                        setSelectedItem: setSelectedItem
                    }, item.index);
                })
            })
        ]
    });
});
const $7b302e46fd2fd29a$export$3f355796bb73d7b = /*#__PURE__*/ (0, $eJOHy.memo)(({ id: id, label: label, items: items, hasSeparator: hasSeparator, onItemSelected: onItemSelected, setSelectedItem: setSelectedItem, startingIndex: startingIndex })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($7b302e46fd2fd29a$var$ListButtonGroupBase, {
        id: id,
        label: label,
        items: items,
        hasSeparator: hasSeparator,
        onItemSelected: onItemSelected,
        setSelectedItem: setSelectedItem,
        startingIndex: startingIndex
    });
});
const $7b302e46fd2fd29a$export$645edeb616ed3f65 = /*#__PURE__*/ (0, $eJOHy.memo)(({ id: id, items: items, hasSeparator: hasSeparator, onItemSelected: onItemSelected, setSelectedItem: setSelectedItem, startingIndex: startingIndex })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($7b302e46fd2fd29a$var$ListButtonGroupBase, {
        id: id,
        items: items,
        hasSeparator: hasSeparator,
        onItemSelected: onItemSelected,
        setSelectedItem: setSelectedItem,
        startingIndex: startingIndex
    });
});

});
parcelRegister("aG5mc", function(module, exports) {
$parcel$export(module.exports, "ListButtonItem", () => $f7545874d9b727de$export$74006863e39733dc);
$parcel$export(module.exports, "ViewAllButtonItem", () => $f7545874d9b727de$export$5beeafc8353ee1ed);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6Exgk = parcelRequire("6Exgk");

var $cQxBL = parcelRequire("cQxBL");

var $jdqdp = parcelRequire("jdqdp");

var $7saMl = parcelRequire("7saMl");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $98uII = parcelRequire("98uII");
const $f7545874d9b727de$var$shortcutStyles = (0, $1DXK0.xcss)({
    color: 'color.text.subtle',
    font: 'font.body.small',
    backgroundColor: 'color.background.accent.gray.subtlest',
    borderRadius: 'radius.small',
    borderStyle: 'none'
});
const $f7545874d9b727de$var$selectedColorStyles = (0, $1DXK0.xcss)({
    color: 'color.text.selected'
});
const $f7545874d9b727de$var$disabledShortcutStyles = (0, $1DXK0.xcss)({
    color: 'color.text.disabled',
    backgroundColor: 'color.background.disabled'
});
const $f7545874d9b727de$var$viewAllStyles = (0, $1DXK0.xcss)({
    background: "var(--ds-surface-overlay, #FFFFFF)",
    position: 'sticky',
    bottom: '-4px',
    width: '100%',
    height: '40px',
    borderTop: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #091E4224)"}`
});
const $f7545874d9b727de$var$ListButtonItemBase = /*#__PURE__*/ (0, $eJOHy.memo)(({ index: index, title: title, description: description, keyshortcut: keyshortcut, isSelected: isSelected, isDisabled: isDisabled, showDescription: showDescription = false, renderContent: renderContent, renderIcon: renderIcon, renderElementAfter: renderElementAfter, onItemSelected: onItemSelected })=>{
    const beforeElement = (0, $eJOHy.useMemo)(()=>{
        if (!renderIcon) return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $98uII.IconRenderer), {
            children: renderIcon()
        });
    }, [
        renderIcon
    ]);
    const afterElement = (0, $eJOHy.useMemo)(()=>renderElementAfter?.(), [
        renderElementAfter
    ]);
    const content = (0, $eJOHy.useMemo)(()=>renderContent?.(), [
        renderContent
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6Exgk.ToolTipContent), {
            description: title,
            keymap: keyshortcut
        }),
        position: "top",
        ignoreTooltipPointerEvents: true,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $7saMl.default), {
                ...tooltipProps,
                iconBefore: beforeElement,
                iconAfter: afterElement,
                description: showDescription ? description : undefined,
                shouldDescriptionWrap: true,
                isSelected: isSelected,
                isDisabled: isDisabled,
                onClick: ()=>onItemSelected?.(index),
                children: content
            })
    });
});
const $f7545874d9b727de$export$74006863e39733dc = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>{
    const { keyshortcut: keyshortcut, isSelected: isSelected, isDisabled: isDisabled, attributes: attributes, title: title, setSelectedItem: setSelectedItem, index: index } = props;
    const shortcutComponent = (0, $eJOHy.useCallback)(()=>{
        const shortcut = keyshortcut && (0, $6Exgk.formatShortcut)(keyshortcut);
        if (!shortcut) return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
            paddingInline: "space.025",
            paddingBlock: "space.025",
            xcss: [
                $f7545874d9b727de$var$shortcutStyles,
                isSelected && $f7545874d9b727de$var$selectedColorStyles,
                isDisabled && $f7545874d9b727de$var$disabledShortcutStyles
            ],
            children: shortcut
        });
    }, [
        isDisabled,
        isSelected,
        keyshortcut
    ]);
    const contentComponent = (0, $eJOHy.useCallback)(()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3Wh6p.default), {
            space: "space.100",
            alignBlock: 'center',
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                    children: title
                }),
                attributes?.new && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
                    appearance: "new",
                    children: "New"
                })
            ]
        });
    }, [
        attributes?.new,
        title
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isSelected) setSelectedItem?.({
            index: index
        });
    }, [
        isSelected,
        setSelectedItem,
        index
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($f7545874d9b727de$var$ListButtonItemBase, {
        ...props,
        renderContent: contentComponent,
        renderElementAfter: shortcutComponent
    });
});
const $f7545874d9b727de$export$5beeafc8353ee1ed = /*#__PURE__*/ (0, $eJOHy.memo)(({ label: label, onClick: onClick, isViewAllInserts: isViewAllInserts = false })=>{
    const contentComponent = (0, $eJOHy.useCallback)(()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3Wh6p.default), {
            space: "space.100",
            alignBlock: 'center',
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                    color: 'color.text.selected',
                    children: label
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                    xcss: [
                        $f7545874d9b727de$var$selectedColorStyles
                    ],
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
                        label: label,
                        size: "small"
                    })
                })
            ]
        });
    }, [
        label
    ]);
    return isViewAllInserts ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        xcss: $f7545874d9b727de$var$viewAllStyles,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($f7545874d9b727de$var$ListButtonItemBase, {
            index: -1,
            title: label,
            onItemSelected: onClick,
            renderContent: contentComponent,
            isViewAll: true
        })
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)($f7545874d9b727de$var$ListButtonItemBase, {
        index: -1,
        title: label,
        onItemSelected: onClick,
        renderContent: contentComponent
    });
});

});
parcelRegister("98uII", function(module, exports) {
$parcel$export(module.exports, "IconRenderer", () => $4541f922652033ea$export$32ff197eed95e568);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");
function $4541f922652033ea$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4541f922652033ea$var$iconWrapperStyles = {
    name: "e42xni",
    styles: "max-width:var(--ds-space-500, 40px);max-height:var(--ds-space-500, 40px);div{max-width:var(--ds-space-500, 40px);max-height:var(--ds-space-500, 40px);}span{max-width:var(--ds-space-500, 40px);max-height:var(--ds-space-500, 40px);}"
};
const $4541f922652033ea$export$32ff197eed95e568 = /*#__PURE__*/ (0, $eJOHy.memo)(({ children: children })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            $4541f922652033ea$var$iconWrapperStyles
        ]
    }, children);
});

});



parcelRegister("e1oUK", function(module, exports) {
$parcel$export(module.exports, "LinkNavButton", () => $edc823050c34b2a5$export$98ce6410d0ba022);
$parcel$export(module.exports, "ExpandableNavButton", () => $edc823050c34b2a5$export$6f3d5e896fa382de);
$parcel$export(module.exports, "BackNavButton", () => $edc823050c34b2a5$export$b83dc6f7d9624732);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $806LH = parcelRequire("806LH");

var $aqu01 = parcelRequire("aqu01");

var $1OQKp = parcelRequire("1OQKp");

var $cQxBL = parcelRequire("cQxBL");

var $1vA1E = parcelRequire("1vA1E");

var $jdqdp = parcelRequire("jdqdp");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");
const $edc823050c34b2a5$var$buttonStyles = (0, $1DXK0.xcss)({
    display: 'inline-flex',
    flexShrink: 0,
    boxSizing: 'border-box',
    position: 'relative',
    alignItems: 'baseline',
    justifyContent: 'center',
    textAlign: 'center',
    verticalAlign: 'middle',
    height: 'auto',
    minHeight: 'space.400',
    width: '100%',
    paddingBlock: 'space.075',
    paddingInline: 'space.100',
    borderRadius: 'radius.small',
    borderWidth: '0',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    transition: 'opacity 0.3s, background 0.1s ease-out',
    backgroundColor: 'color.background.neutral.subtle',
    color: 'color.text.subtle',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        color: 'color.text.subtle'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed',
        color: 'color.text.subtle'
    }
});
const $edc823050c34b2a5$var$selectedButtonStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.selected',
    color: 'color.text.selected',
    ':visited': {
        color: 'color.text.selected'
    },
    ':hover': {
        color: 'color.text.selected',
        backgroundColor: 'color.background.selected.hovered'
    },
    ':active': {
        color: 'color.text.selected',
        backgroundColor: 'color.background.selected.pressed'
    }
});
const $edc823050c34b2a5$var$disabledButtonStyles = (0, $1DXK0.xcss)({
    cursor: 'not-allowed',
    backgroundColor: 'color.background.disabled',
    color: 'color.text.disabled',
    ':hover': {
        backgroundColor: 'color.background.disabled',
        color: 'color.text.disabled'
    },
    ':active': {
        backgroundColor: 'color.background.disabled',
        color: 'color.text.disabled'
    },
    '::after': {
        content: 'none'
    }
});
const $edc823050c34b2a5$var$headingContainerStyles = (0, $1DXK0.xcss)({
    textAlign: 'left',
    color: 'color.text.accent.orange'
});
const $edc823050c34b2a5$var$ButtonBase = /*#__PURE__*/ (0, $eJOHy.memo)(({ id: id, mode: mode, label: label, isSelected: isSelected, isDisabled: isDisabled, isExpanded: isExpanded, attributes: attributes, onClick: onClick })=>{
    const iconComponent = (0, $eJOHy.useMemo)(()=>{
        let Icon;
        let iconLabel;
        switch(mode){
            case 'expandable':
                Icon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($1vA1E))) : (0, (/*@__PURE__*/$parcel$interopDefault($1OQKp)));
                iconLabel = isExpanded ? `Collapse ${label} inserts` : `Expand ${label} inserts`;
                break;
            default:
                Icon = (0, (/*@__PURE__*/$parcel$interopDefault($cQxBL)));
                iconLabel = `View all ${label} inserts`;
        }
        return /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
            label: iconLabel,
            size: "small"
        });
    }, [
        isExpanded,
        label,
        mode
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: label,
        position: "top",
        ignoreTooltipPointerEvents: true,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $bQP4O.default), {
                ...tooltipProps,
                type: "button",
                isDisabled: isDisabled,
                onClick: ()=>onClick?.(id),
                xcss: [
                    $edc823050c34b2a5$var$buttonStyles,
                    isSelected && $edc823050c34b2a5$var$selectedButtonStyles,
                    isDisabled && $edc823050c34b2a5$var$disabledButtonStyles
                ],
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3Wh6p.default), {
                    as: "span",
                    spread: "space-between",
                    alignBlock: "center",
                    space: 'space.100',
                    grow: "fill",
                    shouldWrap: false,
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3Wh6p.default), {
                            alignBlock: "center",
                            space: "space.100",
                            shouldWrap: false,
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                                    xcss: $edc823050c34b2a5$var$headingContainerStyles,
                                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                                        size: 'xsmall',
                                        as: "span",
                                        children: label
                                    })
                                }),
                                attributes?.new && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
                                        appearance: "new",
                                        children: "New"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                            children: iconComponent
                        })
                    ]
                })
            })
    });
});
const $edc823050c34b2a5$export$98ce6410d0ba022 = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $gt9Am.jsx)($edc823050c34b2a5$var$ButtonBase, {
        mode: "navigation",
        ...props
    }));
const $edc823050c34b2a5$export$6f3d5e896fa382de = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $gt9Am.jsx)($edc823050c34b2a5$var$ButtonBase, {
        mode: "expandable",
        ...props
    }));
const $edc823050c34b2a5$export$b83dc6f7d9624732 = /*#__PURE__*/ (0, $eJOHy.memo)(({ label: label, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: label,
        position: "top",
        ignoreTooltipPointerEvents: true,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                ...tooltipProps,
                label: label,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($aqu01))),
                appearance: "subtle",
                spacing: "compact",
                onClick: onClick
            })
    });
});

});

parcelRegister("3CAGn", function(module, exports) {
$parcel$export(module.exports, "SubPanelWithBackButton", () => $f412aca0504822bc$export$bc997d97789f130b);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $806LH = parcelRequire("806LH");

var $3Wh6p = parcelRequire("3Wh6p");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $e1oUK = parcelRequire("e1oUK");
const $f412aca0504822bc$var$itemContainerStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.025',
    paddingLeft: 'space.250',
    paddingRight: 'space.250'
});
const $f412aca0504822bc$export$bc997d97789f130b = /*#__PURE__*/ (0, $eJOHy.memo)(({ label: label, buttonLabel: buttonLabel, onClick: onClick, children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dW738.default), {
        space: "space.0",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3Wh6p.default), {
                alignBlock: "center",
                alignInline: "start",
                space: 'space.050',
                xcss: $f412aca0504822bc$var$itemContainerStyles,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e1oUK.BackNavButton), {
                        onClick: onClick,
                        label: buttonLabel
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                        size: 'xsmall',
                        as: "span",
                        children: label
                    })
                ]
            }),
            children
        ]
    });
});

});


parcelRegister("dGNvX", function(module, exports) {
$parcel$export(module.exports, "SideInsertPanel", () => $3fd5c58ed843354c$export$dfdc13f605e27090);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7k8dr = parcelRequire("7k8dr");

var $78OnL = parcelRequire("78OnL");

var $inQ44 = parcelRequire("inQ44");

var $1BNzE = parcelRequire("1BNzE");

var $1zKwc = parcelRequire("1zKwc");

var $i8VaZ = parcelRequire("i8VaZ");

var $hOT1n = parcelRequire("hOT1n");

var $3CAGn = parcelRequire("3CAGn");
const $3fd5c58ed843354c$var$DefaultView = ({ suggested: suggested, itemsRegistry: itemsRegistry, categoryRegistry: categoryRegistry, onItemSelected: onItemSelected, onCategorySelected: onCategorySelected })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
        children: [
            suggested && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1zKwc.IconButtonGroup), {
                id: suggested.id,
                items: suggested.items,
                label: suggested.label,
                onItemSelected: onItemSelected
            }),
            (0, $inQ44.CategoriesStructure).map((category, i)=>{
                const { defautltItems: defautltItems } = category;
                const items = defautltItems.length > 0 ? defautltItems.map((itemIdOrTitle)=>itemsRegistry[itemIdOrTitle]).filter((item)=>item) : categoryRegistry[category.id] ? categoryRegistry[category.id].slice(0, 5) : [];
                const shoudldShowSeparator = i === 0 && !suggested ? false : true;
                return items.length > 0 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1BNzE.ExpandablePanel), {
                    id: category.id,
                    label: category.title,
                    items: items,
                    hasSeparator: shoudldShowSeparator,
                    onItemSelected: onItemSelected,
                    onViewAllSelected: onCategorySelected
                }, category.id);
            })
        ]
    });
};
const $3fd5c58ed843354c$var$CategoryView = ({ categoryRegistry: categoryRegistry, selectedCategory: selectedCategory, onItemSelected: onItemSelected, onBackButtonClicked: onBackButtonClicked })=>{
    const categoryData = (0, $inQ44.PredefinedCategories).get(selectedCategory);
    const categoryLevelItems = categoryRegistry[selectedCategory] || [];
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $78OnL.default), {
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3CAGn.SubPanelWithBackButton), {
            label: categoryData.title,
            buttonLabel: "Back to all items",
            onClick: onBackButtonClicked,
            children: [
                categoryLevelItems.length > 0 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i8VaZ.ListButtonGroup), {
                    id: categoryData.id,
                    items: categoryLevelItems,
                    onItemSelected: onItemSelected
                }),
                categoryData && categoryData.subcategories.map(({ id: id, title: title })=>{
                    return categoryRegistry[id] && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i8VaZ.ListButtonGroupWithHeading), {
                        id: id,
                        label: title,
                        items: categoryRegistry[id],
                        onItemSelected: onItemSelected
                    });
                })
            ]
        })
    });
};
const $3fd5c58ed843354c$var$SearchView = ({ items: items, onItemSelected: onItemSelected })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i8VaZ.ListButtonGroup), {
        id: 'search',
        items: items,
        onItemSelected: onItemSelected
    });
};
const $3fd5c58ed843354c$export$dfdc13f605e27090 = ({ items: items, onItemInsert: onItemInsert })=>{
    const onItemSelect = (0, $eJOHy.useCallback)((index)=>{
        onItemInsert((0, $7k8dr.SelectItemMode).SELECTED, index);
    }, [
        onItemInsert
    ]);
    const { categoryRegistry: categoryRegistry, itemsRegistry: itemsRegistry, selectedCategory: selectedCategory, searchItems: searchItems, setSearchText: setSearchText, setSelectedCategory: setSelectedCategory } = (0, $inQ44.useItems)(items);
    const view = searchItems ? /*#__PURE__*/ (0, $gt9Am.jsx)($3fd5c58ed843354c$var$SearchView, {
        items: searchItems,
        onItemSelected: onItemSelect
    }) : selectedCategory ? /*#__PURE__*/ (0, $gt9Am.jsx)($3fd5c58ed843354c$var$CategoryView, {
        categoryRegistry: categoryRegistry,
        selectedCategory: selectedCategory,
        onItemSelected: onItemSelect,
        onBackButtonClicked: ()=>setSelectedCategory(undefined)
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)($3fd5c58ed843354c$var$DefaultView, {
        suggested: undefined,
        itemsRegistry: itemsRegistry,
        categoryRegistry: categoryRegistry,
        onItemSelected: onItemSelect,
        onCategorySelected: (categoryId)=>{
            setSelectedCategory(categoryId);
        }
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hOT1n.SearchPanel), {
                onChange: (event)=>{
                    setSearchText(event.target.value);
                }
            }),
            view
        ]
    });
};

});
parcelRegister("1BNzE", function(module, exports) {
$parcel$export(module.exports, "ExpandablePanel", () => $7be9acb2f99e9dc1$export$dbf21a0adc6a9ee0);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6YEko = parcelRequire("6YEko");

var $8nu6j = parcelRequire("8nu6j");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $aG5mc = parcelRequire("aG5mc");

var $e1oUK = parcelRequire("e1oUK");
const $7be9acb2f99e9dc1$var$headingContainerStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.075',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});
const $7be9acb2f99e9dc1$var$itemsContainerStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.0',
    paddingBottom: 'space.150',
    paddingLeft: 'space.200',
    paddingRight: 'space.200'
});
const $7be9acb2f99e9dc1$export$dbf21a0adc6a9ee0 = /*#__PURE__*/ (0, $eJOHy.memo)(({ id: id, label: label, items: items, hasSeparator: hasSeparator, attributes: attributes, onItemSelected: onItemSelected, onViewAllSelected: onViewAllSelected })=>{
    const [isExpanded, setIsExpanded] = (0, $eJOHy.useState)(true);
    // Dirty fix for AI label
    const shortAIlabel = label === 'Atlassian Intelligence' || label === 'Rovo';
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6YEko.default), {
        hasSeparator: hasSeparator,
        children: [
            label && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                xcss: [
                    $7be9acb2f99e9dc1$var$headingContainerStyles
                ],
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e1oUK.ExpandableNavButton), {
                    id: id,
                    label: label,
                    isExpanded: isExpanded,
                    attributes: attributes,
                    onClick: ()=>setIsExpanded(!isExpanded)
                })
            }),
            isExpanded && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dW738.default), {
                space: "space.025",
                xcss: [
                    $7be9acb2f99e9dc1$var$itemsContainerStyles
                ],
                children: [
                    items.map((item)=>{
                        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aG5mc.ListButtonItem), {
                            index: item.index,
                            title: item.title,
                            description: item.description,
                            showDescription: item.showDescription,
                            attributes: item.attributes,
                            keyshortcut: item.keyshortcut,
                            renderIcon: item.renderIcon,
                            onItemSelected: (index)=>onItemSelected?.(index, id)
                        }, item.index);
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aG5mc.ViewAllButtonItem), {
                        label: `View all ${shortAIlabel ? 'AI' : label.toLocaleLowerCase()} options`,
                        onClick: ()=>onViewAllSelected?.(id)
                    })
                ]
            })
        ]
    });
});

});

parcelRegister("1zKwc", function(module, exports) {
$parcel$export(module.exports, "IconButtonGroup", () => $536e7d2b2fab4a10$export$62ad8bbf2c8664a6);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $806LH = parcelRequire("806LH");

var $6YEko = parcelRequire("6YEko");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $jZxjL = parcelRequire("jZxjL");
const $536e7d2b2fab4a10$var$headingContainerStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.0',
    paddingBottom: 'space.075',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});
const $536e7d2b2fab4a10$var$buttonsContainerStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.150',
    paddingBottom: 'space.200',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});
const $536e7d2b2fab4a10$export$62ad8bbf2c8664a6 = /*#__PURE__*/ (0, $eJOHy.memo)(({ id: id, label: label, items: items, hasSeparator: hasSeparator, onItemSelected: onItemSelected })=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6YEko.default), {
        hasSeparator: hasSeparator,
        children: [
            label && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                xcss: [
                    $536e7d2b2fab4a10$var$headingContainerStyles
                ],
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                    size: 'xsmall',
                    as: "span",
                    children: label
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                xcss: [
                    $536e7d2b2fab4a10$var$buttonsContainerStyles
                ],
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3Wh6p.default), {
                    as: "span",
                    spread: "space-between",
                    alignBlock: "center",
                    space: "space.050",
                    rowSpace: "space.150",
                    grow: "fill",
                    shouldWrap: true,
                    children: items.map((item)=>{
                        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jZxjL.IconButtonItem), {
                            index: item.index,
                            title: item.title,
                            description: item.description,
                            showDescription: item.showDescription,
                            attributes: item.attributes,
                            keyshortcut: item.keyshortcut,
                            renderIcon: item.renderIcon,
                            onItemSelected: (index)=>onItemSelected?.(index, id)
                        }, item.index);
                    })
                })
            })
        ]
    }));
});

});
parcelRegister("jZxjL", function(module, exports) {
$parcel$export(module.exports, "IconButtonItem", () => $b147335e221d4081$export$b2bea3403fa20e61);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6Exgk = parcelRequire("6Exgk");

var $8nu6j = parcelRequire("8nu6j");
var $bQP4O = parcelRequire("bQP4O");
var $dW738 = parcelRequire("dW738");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $98uII = parcelRequire("98uII");
const $b147335e221d4081$var$WIDTH = '60px';
const $b147335e221d4081$var$largeButtonStyles = (0, $1DXK0.xcss)({
    display: 'inline-flex',
    flexShrink: 0,
    boxSizing: 'border-box',
    position: 'relative',
    alignItems: 'baseline',
    justifyContent: 'center',
    textAlign: 'center',
    verticalAlign: 'middle',
    height: `${$b147335e221d4081$var$WIDTH}`,
    width: `${$b147335e221d4081$var$WIDTH}`,
    borderRadius: 'radius.small',
    borderWidth: '0',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    transition: 'opacity 0.3s, background 0.1s ease-out',
    backgroundColor: 'color.background.neutral.subtle',
    color: 'color.text.subtle',
    '::after': {
        position: 'absolute',
        inset: 'space.0',
        content: '""',
        borderRadius: 'inherit',
        borderStyle: 'solid',
        borderWidth: 'border.width',
        borderColor: 'color.border',
        pointerEvents: 'none'
    },
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        color: 'color.text.subtle'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed',
        color: 'color.text.subtle'
    }
});
const $b147335e221d4081$var$selectedButtonStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.selected',
    color: 'color.text.selected',
    '::after': {
        content: '""',
        borderColor: 'color.border.selected'
    },
    ':visited': {
        color: 'color.text.selected'
    },
    ':hover': {
        color: 'color.text.selected',
        backgroundColor: 'color.background.selected.hovered'
    },
    ':active': {
        color: 'color.text.selected',
        backgroundColor: 'color.background.selected.pressed'
    }
});
const $b147335e221d4081$var$disabledButtonStyles = (0, $1DXK0.xcss)({
    cursor: 'not-allowed',
    backgroundColor: 'color.background.disabled',
    color: 'color.text.disabled',
    ':hover': {
        backgroundColor: 'color.background.disabled',
        color: 'color.text.disabled'
    },
    ':active': {
        backgroundColor: 'color.background.disabled',
        color: 'color.text.disabled'
    },
    '::after': {
        content: 'none'
    }
});
const $b147335e221d4081$var$iconStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: 'center',
    userSelect: 'none'
});
const $b147335e221d4081$var$textStyles = (0, $1DXK0.xcss)({
    width: `${$b147335e221d4081$var$WIDTH}`
});
const $b147335e221d4081$var$LargeIconButtonWithRef = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ icon: icon, isSelected: isSelected, isDisabled: isDisabled, onClick: onClick, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bQP4O.default), {
        ...rest,
        ref: ref,
        type: "button",
        isDisabled: isDisabled,
        onClick: onClick,
        xcss: [
            $b147335e221d4081$var$largeButtonStyles,
            isSelected && $b147335e221d4081$var$selectedButtonStyles,
            isDisabled && $b147335e221d4081$var$disabledButtonStyles
        ],
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
            as: "span",
            xcss: $b147335e221d4081$var$iconStyles,
            children: icon
        })
    });
}));
const $b147335e221d4081$export$b2bea3403fa20e61 = /*#__PURE__*/ (0, $eJOHy.memo)(({ index: index, title: title, keyshortcut: keyshortcut, isSelected: isSelected, isDisabled: isDisabled, renderIcon: renderIcon, onItemSelected: onItemSelected })=>{
    const iconComponent = (0, $eJOHy.useMemo)(()=>{
        if (!renderIcon) return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $98uII.IconRenderer), {
            children: renderIcon()
        });
    }, [
        renderIcon
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6Exgk.ToolTipContent), {
            description: title,
            keymap: keyshortcut
        }),
        position: "top",
        ignoreTooltipPointerEvents: true,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dW738.default), {
                alignInline: "center",
                space: "space.050",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)($b147335e221d4081$var$LargeIconButtonWithRef, {
                        ...tooltipProps,
                        icon: iconComponent,
                        isSelected: isSelected,
                        isDisabled: isDisabled,
                        onClick: ()=>onItemSelected?.(index)
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                        xcss: $b147335e221d4081$var$textStyles,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                            align: "center",
                            maxLines: 1,
                            color: isDisabled ? 'color.text.disabled' : isSelected ? 'color.text.selected' : 'color.text.subtle',
                            size: "small",
                            children: title
                        })
                    })
                ]
            })
    });
});

});


parcelRegister("hOT1n", function(module, exports) {
$parcel$export(module.exports, "SearchPanel", () => $d122cc989a305b5e$export$ea47151d20780fe9);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $dt3aG = parcelRequire("dt3aG");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $sY9BV = parcelRequire("sY9BV");
const $d122cc989a305b5e$var$searchPanelStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.025',
    paddingBottom: 'space.150',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});
const $d122cc989a305b5e$var$searchIconStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.050',
    paddingBottom: 'space.0',
    paddingLeft: 'space.100',
    paddingRight: 'space.0'
});
const $d122cc989a305b5e$export$ea47151d20780fe9 = /*#__PURE__*/ (0, $eJOHy.memo)(({ onChange: onChange })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        xcss: [
            $d122cc989a305b5e$var$searchPanelStyles
        ],
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $sY9BV.default), {
            name: "search",
            id: "search-textfield",
            placeholder: "Find or describe...",
            elemBeforeInput: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                xcss: $d122cc989a305b5e$var$searchIconStyles,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dt3aG))), {
                    label: "search",
                    color: "var(--ds-text-subtlest, #626F86)"
                })
            }),
            onChange: onChange
        })
    });
});

});


parcelRegister("nMpI6", function(module, exports) {
$parcel$export(module.exports, "TypeAheadErrorFallback", () => $04065a8b18020a11$export$71ea07f9d4f4ab38);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $lRq8t = parcelRequire("lRq8t");

var $4drex = parcelRequire("4drex");

var $5UqNW = parcelRequire("5UqNW");

var $fj8dX = parcelRequire("fj8dX");
function $04065a8b18020a11$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $04065a8b18020a11$var$minHeightComponentStyles = {
    name: "2omrkj",
    styles: "display:flex;align-items:stretch;justify-content:center;min-height:290px"
};
const $04065a8b18020a11$export$71ea07f9d4f4ab38 = ()=>{
    const intl = (0, $lRq8t.default)();
    const header = intl.formatMessage((0, $4drex.typeAheadListMessages).typeAheadErrorFallbackHeading);
    const description = intl.formatMessage((0, $4drex.typeAheadListMessages).typeAheadErrorFallbackDesc);
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        "data-testid": "typeahead-error-boundary-ui",
        css: $04065a8b18020a11$var$minHeightComponentStyles
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $5UqNW.EmptyState), {
        header: header,
        renderImage: ()=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, $fj8dX.GenericErrorSVG), null),
        description: description
    }));
};

});
parcelRegister("5UqNW", function(module, exports) {
$parcel$export(module.exports, "EmptyState", () => $4a443bb570ba9792$export$fddf379e22a74b00);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $806LH = parcelRequire("806LH");

var $lmgo6 = parcelRequire("lmgo6");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");
const $4a443bb570ba9792$var$containerStyles = (0, $1DXK0.xcss)({
    marginBlockStart: 'space.600',
    marginBlockEnd: 'space.600',
    textAlign: 'center'
});
const $4a443bb570ba9792$export$fddf379e22a74b00 = ({ testId: testId, header: header, description: description, renderImage: renderImage })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $lmgo6.default), {
        xcss: $4a443bb570ba9792$var$containerStyles,
        testId: testId,
        direction: "column",
        alignItems: "center",
        gap: "space.300",
        children: [
            renderImage?.(),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $lmgo6.default), {
                direction: "column",
                alignItems: "center",
                gap: "space.200",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                        size: "medium",
                        as: "h2",
                        children: header
                    }),
                    description && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                        as: "p",
                        color: "color.text",
                        children: description
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("fj8dX", function(module, exports) {
$parcel$export(module.exports, "GenericErrorSVG", () => $2ef11100883f2881$export$e54420a1a27457a4);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");
const $2ef11100883f2881$var$HEIGHT = 90;
const $2ef11100883f2881$var$genericErrorStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    height: `${$2ef11100883f2881$var$HEIGHT}px`,
    display: 'block'
});
const $2ef11100883f2881$export$e54420a1a27457a4 = (props)=>{
    const id = 'link-picker-ui-generic-error-svg';
    return /*#__PURE__*/ (0, $1NIU8.jsx)("svg", {
        height: "90",
        viewBox: "0 0 164 212",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        css: $2ef11100883f2881$var$genericErrorStyles,
        ...props
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("path", {
        d: "m95.43 74.16 66.44 115.08c5.84 10.12-1.46 22.76-13.14 22.76H15.85c-11.68 0-18.98-12.65-13.14-22.76L69.15 74.16c5.84-10.12 20.44-10.12 26.28 0Zm-7.56 83.55 2.88-44.35c.34-5.29-3.86-9.78-9.16-9.78-5.31 0-9.51 4.48-9.16 9.78l2.88 44.35a6.3 6.3 0 0 0 6.28 5.89c3.31 0 6.06-2.58 6.28-5.89Zm-15.84 23.54c0 5.66 4.76 10.1 10.39 9.58 4.85-.45 8.73-4.5 8.83-9.37.11-5.45-4.31-9.94-9.73-9.94-5.23-.01-9.49 4.37-9.49 9.73Z",
        fill: `url(#${id})`
    }), /*#__PURE__*/ (0, $1NIU8.jsx)("path", {
        opacity: ".6",
        d: "M93.35 27.17 85.94.45c-.17-.62-1.07-.58-1.19.05l-4.66 25.1-5.8-1.08a.612.612 0 0 0-.7.76L81 52c.17.62 1.07.58 1.19-.05l4.66-25.1 5.8 1.08c.45.08.82-.33.7-.76ZM66.77 41.81 55.9 33.26c-.22-.18-.53.07-.41.33l5.53 11.43-2.66 1.29c-.18.09-.2.33-.05.45l10.87 8.55c.22.18.53-.07.41-.33l-5.53-11.43 2.66-1.29c.17-.08.2-.33.05-.45Z",
        fill: "#C1C7D0"
    }), /*#__PURE__*/ (0, $1NIU8.jsx)("path", {
        opacity: ".6",
        d: "M102.78 56.75a.993.993 0 0 1-.92-1.38c-.24-.77-2.29-2.85-3.54-4.11-2.97-3.01-4.93-5-3.84-6.49 1.09-1.48 3.58-.22 7.35 1.7 1.32.67 3.35 1.7 4.45 2.03-.64-.95-2.24-2.58-3.28-3.63-2.97-3.01-4.93-5-3.84-6.49 1.08-1.48 3.58-.22 7.34 1.7 1.32.67 3.34 1.7 4.45 2.03-.64-.95-2.24-2.57-3.28-3.62-2.97-3.01-4.93-5-3.84-6.49 1.08-1.48 3.57-.22 7.34 1.7 1.58.8 4.18 2.13 4.98 2.13a1.005 1.005 0 0 1 1.46 1.36c-1.09 1.48-3.57.22-7.34-1.7-1.32-.67-3.34-1.7-4.44-2.03.64.95 2.24 2.57 3.28 3.62 2.97 3.01 4.93 5 3.84 6.49-1.08 1.48-3.57.22-7.34-1.7-1.32-.67-3.35-1.7-4.45-2.03.64.95 2.24 2.57 3.28 3.63 2.97 3.01 4.93 5 3.84 6.49-1.09 1.48-3.58.22-7.35-1.7-1.32-.67-3.35-1.71-4.45-2.03.64.95 2.24 2.58 3.28 3.63 2.97 3.01 4.93 5 3.84 6.49-.21.26-.51.4-.82.4Zm5.56 14.32c-.35 0-.69-.19-.88-.52-1.04-1.88-2.22-4.02-.91-5.21 1.31-1.2 3.34.18 5.49 1.63.87.59 2.26 1.53 2.93 1.71-.12-.68-.93-2.15-1.45-3.07-1.26-2.27-2.45-4.41-1.14-5.61 1.31-1.2 3.34.18 5.49 1.63.96.65 2.54 1.72 3.1 1.74a1 1 0 0 1 1.27 1.54c-1.31 1.2-3.34-.17-5.49-1.63-.87-.59-2.26-1.53-2.93-1.71.12.68.93 2.15 1.45 3.07 1.26 2.27 2.45 4.41 1.14 5.61-1.31 1.2-3.34-.18-5.49-1.63-.87-.59-2.26-1.53-2.93-1.71.12.68.93 2.14 1.22 2.67.27.48.09 1.09-.39 1.36-.15.09-.32.13-.48.13Zm-54.32-2.89c-.22 0-.44-.04-.67-.14-1.64-.69-1.24-3.11-.81-5.67.17-1.04.45-2.7.33-3.38-.57.39-1.56 1.75-2.18 2.6-1.53 2.09-2.99 4.07-4.62 3.38a.991.991 0 0 1-.53-1.31c.2-.48.73-.72 1.21-.57.52-.21 1.65-1.75 2.34-2.68 1.53-2.09 2.98-4.08 4.62-3.38 1.64.69 1.24 3.11.81 5.67-.17 1.04-.45 2.7-.33 3.38.57-.39 1.56-1.75 2.18-2.6 1.53-2.09 2.98-4.08 4.62-3.38 1.63.69 1.24 3.09.89 5.21-.09.54-.6.91-1.15.83-.54-.09-.92-.6-.83-1.15.1-.59.37-2.24.26-2.92-.57.39-1.56 1.75-2.18 2.6-1.33 1.79-2.59 3.51-3.96 3.51Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, $1NIU8.jsx)("defs", null, /*#__PURE__*/ (0, $1NIU8.jsx)("linearGradient", {
        id: id,
        x1: "26.169",
        y1: "228.621",
        x2: "138.408",
        y2: "116.382",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("stop", {
        stopColor: "#C1C7D0"
    }), /*#__PURE__*/ (0, $1NIU8.jsx)("stop", {
        offset: ".297",
        stopColor: "#C6CBD4",
        stopOpacity: ".881"
    }), /*#__PURE__*/ (0, $1NIU8.jsx)("stop", {
        offset: ".63",
        stopColor: "#D3D7DE",
        stopOpacity: ".748"
    }), /*#__PURE__*/ (0, $1NIU8.jsx)("stop", {
        offset: ".98",
        stopColor: "#E9EBEF",
        stopOpacity: ".608"
    }), /*#__PURE__*/ (0, $1NIU8.jsx)("stop", {
        offset: "1",
        stopColor: "#EBECF0",
        stopOpacity: ".6"
    }))));
};

});




parcelRegister("eKKzu", function(module, exports) {
$parcel$export(module.exports, "TypeAheadMenu", () => $e0fdd2bc686666bc$export$b11addef9209139);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7k8dr = parcelRequire("7k8dr");

var $92xoS = parcelRequire("92xoS");

var $lKOUs = parcelRequire("lKOUs");

var $l9ZHZ = parcelRequire("l9ZHZ");

var $gTtZl = parcelRequire("gTtZl");
const $e0fdd2bc686666bc$export$b11addef9209139 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ editorView: editorView, popupMountRef: popupMountRef, typeAheadState: typeAheadState, selectedIndex: selectedIndex, api: api })=>{
    const isOpen = typeAheadState.decorationSet.find().length > 0;
    const { triggerHandler: triggerHandler, items: items, errorInfo: errorInfo, decorationElement: decorationElement, decorationSet: decorationSet, query: query } = typeAheadState;
    const [onItemInsert, onTextInsert, onItemMatch] = (0, $l9ZHZ.useItemInsert)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    triggerHandler, editorView, items, api);
    const setSelectedItem = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(({ index: nextIndex })=>{
        queueMicrotask(()=>{
            (0, $lKOUs.updateSelectedIndex)(nextIndex, api)(editorView.state, editorView.dispatch);
        });
    }, [
        editorView,
        api
    ]);
    const insertItem = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((mode = (0, $7k8dr.SelectItemMode).SELECTED, index)=>{
        queueMicrotask(()=>{
            onItemInsert({
                mode: mode,
                index: index,
                query: query
            });
        });
    }, [
        onItemInsert,
        query
    ]);
    const cancel = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(({ setSelectionAt: setSelectionAt, addPrefixTrigger: addPrefixTrigger, forceFocusOnEditor: forceFocusOnEditor })=>{
        const fullQuery = addPrefixTrigger ? `${triggerHandler?.trigger}${query}` : query;
        onTextInsert({
            forceFocusOnEditor: forceFocusOnEditor,
            setSelectionAt: setSelectionAt,
            text: fullQuery
        });
    }, [
        triggerHandler,
        onTextInsert,
        query
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        if (!isOpen || !query) return;
        const isLastCharSpace = query[query.length - 1] === ' ';
        if (!isLastCharSpace) return;
        const result = onItemMatch({
            mode: (0, $7k8dr.SelectItemMode).SPACE,
            query: query.trim()
        });
        if (!result) return;
    }, [
        isOpen,
        query,
        onItemMatch
    ]);
    // @ts-ignore
    const openElementBrowserModal = triggerHandler?.openElementBrowserModal;
    let showMoreOptionsButton = false;
    if ((0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) showMoreOptionsButton = !!triggerHandler?.getMoreOptionsButtonConfig;
    if (!isOpen || !triggerHandler || !(decorationElement instanceof HTMLElement) || !openElementBrowserModal && items.length === 0 && !errorInfo) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gTtZl.TypeAheadPopup), {
        editorView: editorView,
        popupsMountPoint: popupMountRef.current?.popupsMountPoint,
        popupsBoundariesElement: popupMountRef.current?.popupsBoundariesElement,
        popupsScrollableElement: popupMountRef.current?.popupsScrollableElement,
        anchorElement: decorationElement,
        triggerHandler: triggerHandler,
        items: items,
        errorInfo: errorInfo,
        selectedIndex: selectedIndex,
        setSelectedItem: setSelectedItem,
        onItemInsert: insertItem,
        decorationSet: decorationSet,
        isEmptyQuery: !query,
        cancel: cancel,
        api: api,
        showMoreOptionsButton: showMoreOptionsButton
    });
});

});
parcelRegister("gTtZl", function(module, exports) {
$parcel$export(module.exports, "TypeAheadPopup", () => $c7acae6bbc4703ed$export$fbc0702507873a7d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $bRPNB = parcelRequire("bRPNB");

var $bMFKb = parcelRequire("bMFKb");

var $cxXTK = parcelRequire("cxXTK");

var $7k8dr = parcelRequire("7k8dr");

var $dwnni = parcelRequire("dwnni");
var $avm98 = parcelRequire("avm98");

var $7yBx7 = parcelRequire("7yBx7");

var $eGOwo = parcelRequire("eGOwo");


var $92xoS = parcelRequire("92xoS");

var $2FODv = parcelRequire("2FODv");

var $eQTrE = parcelRequire("eQTrE");

var $elKSH = parcelRequire("elKSH");

var $nMpI6 = parcelRequire("nMpI6");

var $97XBp = parcelRequire("97XBp");
function $c7acae6bbc4703ed$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c7acae6bbc4703ed$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT = 380;
const $c7acae6bbc4703ed$var$VIEWMORE_BUTTON_HEIGHT = 53;
const $c7acae6bbc4703ed$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT_NEW = 480;
const $c7acae6bbc4703ed$var$ITEM_PADDING = 12;
const $c7acae6bbc4703ed$var$typeAheadContent = /*#__PURE__*/ (0, $1NIU8.css)({
    background: `var(--ds-surface-overlay, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
    borderRadius: "var(--ds-radius-small, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 1px ${(0, $7bb4c1736002a04a$export$d2d3bedfb276cac0)}, 0 4px 8px -2px ${(0, $7bb4c1736002a04a$export$7d3359664e8bb0e5)}`})`,
    padding: `${"var(--ds-space-050, 4px)"} 0`,
    width: '320px',
    maxHeight: '380px' /* ~5.5 visibile items */ ,
    overflowY: 'auto',
    MsOverflowStyle: '-ms-autohiding-scrollbar',
    position: 'relative'
});
const $c7acae6bbc4703ed$var$typeAheadContentOverride = /*#__PURE__*/ (0, $1NIU8.css)({
    maxHeight: `${$c7acae6bbc4703ed$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT_NEW}px`
});
const $c7acae6bbc4703ed$var$typeAheadWrapperWithViewMoreOverride = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
const $c7acae6bbc4703ed$var$Highlight = ({ state: state, triggerHandler: triggerHandler })=>{
    if (!triggerHandler?.getHighlight) return null;
    return triggerHandler.getHighlight(state);
};
const $c7acae6bbc4703ed$var$OFFSET = [
    0,
    8
];
const $c7acae6bbc4703ed$export$fbc0702507873a7d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo((props)=>{
    const { editorView: editorView, triggerHandler: triggerHandler, anchorElement: anchorElement, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, items: items, errorInfo: errorInfo, selectedIndex: selectedIndex, onItemInsert: onItemInsert, isEmptyQuery: isEmptyQuery, cancel: cancel, api: api, showMoreOptionsButton: showMoreOptionsButton } = props;
    const ref = (0, $eJOHy.useRef)(null);
    const { moreElementsInQuickInsertView: moreElementsInQuickInsertView } = (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'featureFlags'
    ], (states)=>({
            moreElementsInQuickInsertView: states.featureFlagsState?.moreElementsInQuickInsertView
        }));
    const moreElementsInQuickInsertViewEnabled = moreElementsInQuickInsertView && triggerHandler.id === (0, $7k8dr.TypeAheadAvailableNodes).QUICK_INSERT;
    const isEditorControlsEnabled = (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1');
    const defaultMenuHeight = (0, $eJOHy.useMemo)(()=>moreElementsInQuickInsertViewEnabled ? $c7acae6bbc4703ed$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT_NEW : $c7acae6bbc4703ed$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT, [
        moreElementsInQuickInsertViewEnabled
    ]);
    const activityStateRef = (0, $eJOHy.useRef)({
        inputMethod: null,
        closeAction: null,
        invocationMethod: (0, $elKSH.getPluginState)(editorView.state)?.inputMethod
    });
    const startTime = (0, $eJOHy.useMemo)(()=>performance.now(), // In case those props changes
    // we need to recreate the startTime
    [
        items,
        isEmptyQuery,
        triggerHandler
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
    (0, $eJOHy.useEffect)(()=>{
        if (!api?.analytics?.actions?.fireAnalyticsEvent) return;
        const stopTime = performance.now();
        const time = stopTime - startTime;
        api?.analytics?.actions?.fireAnalyticsEvent({
            action: (0, $bMFKb.ACTION).RENDERED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).TYPEAHEAD,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
            attributes: {
                time: time,
                items: items.length,
                initial: isEmptyQuery
            }
        });
    }, [
        startTime,
        items,
        isEmptyQuery,
        // In case the current triggerHandler changes
        // e.g: Inserting a mention using the quick insert
        // we need to send the event again
        // eslint-disable-next-line react-hooks/exhaustive-deps
        triggerHandler,
        api
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!api?.analytics?.actions?.fireAnalyticsEvent) return;
        api?.analytics?.actions?.fireAnalyticsEvent({
            action: (0, $bMFKb.ACTION).VIEWED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).TYPEAHEAD_ITEM,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
            attributes: {
                index: selectedIndex,
                items: items.length
            }
        });
    }, [
        items,
        api,
        selectedIndex,
        // In case the current triggerHandler changes
        // e.g: Inserting a mention using the quick insert
        // we need to send the event again
        // eslint-disable-next-line react-hooks/exhaustive-deps
        triggerHandler
    ]);
    const [fitHeight, setFitHeight] = (0, $eJOHy.useState)(defaultMenuHeight);
    const fitHeightWithViewMore = (0, $eJOHy.useMemo)(()=>{
        if (showMoreOptionsButton) return fitHeight - $c7acae6bbc4703ed$var$VIEWMORE_BUTTON_HEIGHT;
        return fitHeight;
    }, [
        fitHeight,
        showMoreOptionsButton
    ]);
    const getFitHeight = (0, $eJOHy.useCallback)(()=>{
        if (!anchorElement || !popupsMountPoint) return;
        const target = anchorElement;
        const { top: targetTop, height: targetHeight } = target.getBoundingClientRect();
        const boundariesElement = popupsBoundariesElement || document.body;
        const { height: boundariesHeight, top: boundariesTop } = boundariesElement.getBoundingClientRect();
        // Calculating the space above and space below our decoration
        const spaceAbove = targetTop - (boundariesTop - boundariesElement.scrollTop);
        const spaceBelow = boundariesTop + boundariesHeight - (targetTop + targetHeight);
        // Keep default height if more than enough space
        if (spaceBelow >= defaultMenuHeight) return setFitHeight(defaultMenuHeight);
        // Determines whether typeahead will fit above or below decoration
        // and return the space available.
        const newFitHeight = spaceBelow >= spaceAbove ? spaceBelow : spaceAbove;
        // Each typeahead item has some padding
        // We want to leave some space at the top so first item
        // is not partially cropped
        const fitHeightWithSpace = newFitHeight - $c7acae6bbc4703ed$var$ITEM_PADDING * 2;
        // Ensure typeahead height is max its default height
        const minFitHeight = Math.min(defaultMenuHeight, fitHeightWithSpace);
        return setFitHeight(minFitHeight);
    }, [
        anchorElement,
        defaultMenuHeight,
        popupsBoundariesElement,
        popupsMountPoint
    ]);
    const getFitHeightDebounced = (0, $bRPNB.default)(getFitHeight);
    (0, $eJOHy.useLayoutEffect)(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const scrollableElement = popupsScrollableElement || (0, $dwnni.findOverflowScrollParent)(anchorElement);
        getFitHeight();
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('resize', getFitHeightDebounced);
        if (scrollableElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        scrollableElement.addEventListener('scroll', getFitHeightDebounced);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('resize', getFitHeightDebounced);
            if (scrollableElement) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            scrollableElement.removeEventListener('scroll', getFitHeightDebounced);
        };
    }, [
        anchorElement,
        popupsScrollableElement,
        getFitHeightDebounced,
        getFitHeight
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        const { removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = (0, $elKSH.getPluginState)(editorView.state) || {};
        const focusOut = (event)=>{
            const { relatedTarget: relatedTarget } = event;
            // Given the user is changing the focus
            // When the target is inside the TypeAhead Popup
            // Then the popup should stay open
            if (relatedTarget instanceof HTMLElement && relatedTarget.closest && (relatedTarget.closest(`.${(0, $eQTrE.TYPE_AHEAD_POPUP_CONTENT_CLASS)}`) || relatedTarget.closest(`[data-type-ahead="${(0, $eQTrE.TYPE_AHEAD_DECORATION_DATA_ATTRIBUTE)}"]`))) return;
            // Handles cases like emoji (:) and mention (@) typeaheads that open new typeaheads
            const isTextSelected = window.getSelection()?.type === 'Range';
            const innerEditor = anchorElement.closest('.extension-editable-area');
            if (innerEditor) {
                // When there is no related target, we default to not closing the popup
                let newFocusInsideCurrentEditor = !relatedTarget;
                if (relatedTarget instanceof HTMLElement) // check if the new focus is inside inner editor, keep popup opens
                newFocusInsideCurrentEditor = innerEditor.contains(relatedTarget);
                if (!isTextSelected && newFocusInsideCurrentEditor) return;
            } else {
                // if the current focus in outer editor, keep the existing behaviour, do not close the pop up if text is not selected
                if (!isTextSelected) return;
            }
            cancel({
                addPrefixTrigger: isEditorControlsEnabled ? !removePrefixTriggerOnCancel : true,
                setSelectionAt: (0, $eQTrE.CloseSelectionOptions).AFTER_TEXT_INSERTED,
                forceFocusOnEditor: false
            });
        };
        const { current: element } = ref;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('focusout', focusOut);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('focusout', focusOut);
        };
    }, [
        ref,
        cancel,
        editorView.state,
        isEditorControlsEnabled,
        anchorElement
    ]);
    // TODO: ED-17443 - When you press escape on typeahead panel, it should remove focus and close the panel
    // This is the expected keyboard behaviour advised by the Accessibility team
    (0, $eJOHy.useLayoutEffect)(()=>{
        const { removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = (0, $elKSH.getPluginState)(editorView.state) || {};
        const escape = (event)=>{
            if (event.key === 'Escape') {
                activityStateRef.current.inputMethod = (0, $bMFKb.INPUT_METHOD).KEYBOARD;
                cancel({
                    addPrefixTrigger: isEditorControlsEnabled ? !removePrefixTriggerOnCancel : true,
                    setSelectionAt: (0, $eQTrE.CloseSelectionOptions).AFTER_TEXT_INSERTED,
                    forceFocusOnEditor: true
                });
            }
        };
        const { current: element } = ref;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', escape);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', escape);
        };
    }, [
        ref,
        cancel,
        editorView.state,
        isEditorControlsEnabled
    ]);
    // @ts-ignore
    const openElementBrowserModal = triggerHandler?.openElementBrowserModal;
    const onMoreOptionsClicked = (0, $eJOHy.useCallback)(()=>{
        if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning
        openElementBrowserModal && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') && triggerHandler.id === (0, $7k8dr.TypeAheadAvailableNodes).QUICK_INSERT) activityStateRef.current = {
            inputMethod: (0, $bMFKb.INPUT_METHOD).MOUSE,
            closeAction: (0, $bMFKb.ACTION).VIEW_MORE,
            invocationMethod: activityStateRef.current.invocationMethod
        };
    }, [
        openElementBrowserModal,
        triggerHandler.id
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $avm98.default), {
        zIndex: (0, $7yBx7.akEditorFloatingDialogZIndex),
        target: anchorElement,
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        fitHeight: fitHeight,
        fitWidth: 340,
        offset: $c7acae6bbc4703ed$var$OFFSET,
        ariaLabel: null,
        preventOverflow: true,
        onUnmount: ()=>{
            if (selectedIndex > -1 && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) {
                // if selectedIndex is -1, it means that the user has not selected any item
                // will be handled by WrapperTypeAhead
                (0, $2FODv.fireTypeAheadClosedAnalyticsEvent)(api, activityStateRef.current.closeAction || (0, $bMFKb.ACTION).CANCELLED, !isEmptyQuery, activityStateRef.current.inputMethod || (0, $bMFKb.INPUT_METHOD).MOUSE, activityStateRef.current.invocationMethod);
                // reset activity state
                activityStateRef.current = {
                    inputMethod: null,
                    closeAction: null,
                    invocationMethod: null
                };
            }
        }
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            $c7acae6bbc4703ed$var$typeAheadContent,
            moreElementsInQuickInsertViewEnabled && $c7acae6bbc4703ed$var$typeAheadContentOverride,
            showMoreOptionsButton && $c7acae6bbc4703ed$var$typeAheadWrapperWithViewMoreOverride
        ],
        tabIndex: (0, $eGOwo.fg)('platform_editor_a11y_fix_typeahead_tabindex') ? undefined : 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $eQTrE.TYPE_AHEAD_POPUP_CONTENT_CLASS),
        ref: ref
    }, errorInfo ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $nMpI6.TypeAheadErrorFallback), null) : /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, $1NIU8.jsx)($c7acae6bbc4703ed$var$Highlight, {
        state: editorView.state,
        triggerHandler: triggerHandler
    }), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $97XBp.TypeAheadList), {
        items: items,
        selectedIndex: selectedIndex,
        onItemClick: (mode, index, inputMethod)=>{
            if ((0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) activityStateRef.current = {
                inputMethod: inputMethod || null,
                closeAction: (0, $bMFKb.ACTION).INSERTED,
                invocationMethod: activityStateRef.current.invocationMethod
            };
            onItemInsert(mode, index);
        },
        fitHeight: fitHeightWithViewMore,
        editorView: editorView,
        decorationElement: anchorElement,
        triggerHandler: triggerHandler,
        moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled,
        api: api,
        showMoreOptionsButton: showMoreOptionsButton,
        onMoreOptionsClicked: onMoreOptionsClicked
    }))));
});
$c7acae6bbc4703ed$export$fbc0702507873a7d.displayName = 'TypeAheadPopup';

});
parcelRegister("97XBp", function(module, exports) {
$parcel$export(module.exports, "TypeAheadList", () => $82d4adc319c78782$export$81b66b5b19964713);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");
var $lRq8t = parcelRequire("lRq8t");

var $kZS37 = parcelRequire("kZS37");

var $5R9ov = parcelRequire("5R9ov");

var $bMFKb = parcelRequire("bMFKb");

var $46A2h = parcelRequire("46A2h");

var $7k8dr = parcelRequire("7k8dr");
var $4drex = parcelRequire("4drex");

var $b7eFx = parcelRequire("b7eFx");

var $jUgeq = parcelRequire("jUgeq");

var $8IeH1 = parcelRequire("8IeH1");
var $3cMgR = parcelRequire("3cMgR");

var $azYbd = parcelRequire("azYbd");

var $lKOUs = parcelRequire("lKOUs");

var $eQTrE = parcelRequire("eQTrE");

var $elKSH = parcelRequire("elKSH");

var $ajlZ9 = parcelRequire("ajlZ9");

var $3mtr1 = parcelRequire("3mtr1");

var $9aOK1 = parcelRequire("9aOK1");
const $82d4adc319c78782$var$LIST_ITEM_ESTIMATED_HEIGHT = 64;
const $82d4adc319c78782$var$LIST_WIDTH = 320;
const $82d4adc319c78782$var$list = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    button: {
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`
    }
});
const $82d4adc319c78782$var$TypeaheadAssistiveTextPureComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ numberOfResults: numberOfResults })=>{
    const intl = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $b7eFx.AssistiveText), {
        assistiveText: intl.formatMessage((0, $4drex.typeAheadListMessages).searchResultsLabel, {
            itemsLength: numberOfResults
        }),
        // when the popup is open its always in focus
        isInFocus: true,
        id: (0, $eQTrE.TYPE_AHEAD_DECORATION_ELEMENT_ID) + '__popup'
    });
});
const $82d4adc319c78782$var$TypeAheadListComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ items: items, selectedIndex: selectedIndex, editorView: editorView, onItemClick: onItemClick, intl: intl, fitHeight: fitHeight, decorationElement: decorationElement, triggerHandler: triggerHandler, moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled, api: api, showMoreOptionsButton: showMoreOptionsButton, onMoreOptionsClicked: onMoreOptionsClicked })=>{
    const listRef = (0, $eJOHy.useRef)();
    const listContainerRef = (0, $eJOHy.useRef)(null);
    const lastVisibleIndexes = (0, $eJOHy.useRef)({
        overscanStartIndex: 0,
        overscanStopIndex: 0,
        startIndex: 0,
        stopIndex: 0
    });
    // Exclude view more item from the count
    const itemsLength = showMoreOptionsButton ? Math.max(items.length - 1, 0) : items.length;
    const estimatedHeight = itemsLength * $82d4adc319c78782$var$LIST_ITEM_ESTIMATED_HEIGHT;
    const [height, setHeight] = (0, $eJOHy.useState)(Math.min(estimatedHeight, fitHeight));
    const [cache, setCache] = (0, $eJOHy.useState)(new (0, $kZS37.CellMeasurerCache)({
        fixedWidth: true,
        defaultHeight: $82d4adc319c78782$var$LIST_ITEM_ESTIMATED_HEIGHT
    }));
    const onItemsRendered = (0, $eJOHy.useCallback)((props)=>{
        lastVisibleIndexes.current = props;
    }, []);
    const actions = (0, $eJOHy.useMemo)(()=>({
            onItemClick: onItemClick
        }), [
        onItemClick
    ]);
    const isNavigationKey = (event)=>{
        return [
            'ArrowDown',
            'ArrowUp',
            'Tab',
            'Enter'
        ].includes(event.key);
    };
    const focusTargetElement = (0, $eJOHy.useCallback)(()=>{
        //To reset the selected index
        (0, $lKOUs.updateSelectedIndex)(-1, api)(editorView.state, editorView.dispatch);
        listRef.current.scrollToRow(0);
        decorationElement?.querySelector(`[role='combobox']`)?.focus();
    }, [
        editorView,
        listRef,
        decorationElement,
        api
    ]);
    const selectNextItem = (0, $eJOHy.useMemo)(()=>(0, $elKSH.moveSelectedIndex)({
            editorView: editorView,
            direction: 'next',
            api: api
        }), [
        editorView,
        api
    ]);
    const selectPreviousItem = (0, $eJOHy.useMemo)(()=>(0, $elKSH.moveSelectedIndex)({
            editorView: editorView,
            direction: 'previous',
            api: api
        }), [
        editorView,
        api
    ]);
    const lastVisibleStartIndex = lastVisibleIndexes.current.startIndex;
    const lastVisibleStopIndex = lastVisibleIndexes.current.stopIndex;
    const onScroll = (0, $eJOHy.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ({ scrollUpdateWasRequested: scrollUpdateWasRequested })=>{
        if (!scrollUpdateWasRequested) return;
        // In case the user scroll to a non-visible item like press ArrowUp from the first index
        // We will force the scroll calling the scrollToItem in the useEffect hook
        // When the scroll happens and we render the elements,
        // we still need calculate the items height and re-draw the List.
        // It is possible the item selected became invisible again (because the items height changed)
        // So, we need to wait for height to be calculated. Then we need to check
        // if the selected item is visible or not. If it isn't visible we call the scrollToItem again.
        //
        // We can't do this check in the first frame because that frame is being used by the resetScreenThrottled
        // to calculate each height. THen, we can schedule a new frame when this one finishs.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                const isViewMoreSelected = showMoreOptionsButton && selectedIndex === itemsLength;
                const isSelectedItemVisible = selectedIndex >= lastVisibleStartIndex && selectedIndex <= lastVisibleStopIndex || // view more is always visible, hence no scrolling
                isViewMoreSelected;
                //Should scroll to the list item only when the selectedIndex >= 0 and item is not visible
                if (!isSelectedItemVisible && selectedIndex !== -1) listRef.current.scrollToRow(selectedIndex);
                else if (selectedIndex === -1) listRef.current.scrollToRow(0);
            });
        });
    }, [
        selectedIndex,
        lastVisibleStartIndex,
        lastVisibleStopIndex,
        itemsLength,
        showMoreOptionsButton
    ]);
    const onMouseMove = (event, index)=>{
        event.preventDefault();
        event.stopPropagation();
        if (selectedIndex === index) return;
        (0, $lKOUs.updateSelectedIndex)(index, api)(editorView.state, editorView.dispatch);
    };
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!listRef.current) return;
        const isViewMoreSelected = showMoreOptionsButton && selectedIndex === itemsLength;
        const isSelectedItemVisible = selectedIndex >= lastVisibleStartIndex && selectedIndex <= lastVisibleStopIndex || // view more is always visible, hence no scrolling
        isViewMoreSelected;
        //Should scroll to the list item only when the selectedIndex >= 0 and item is not visible
        if (!isSelectedItemVisible && selectedIndex !== -1) listRef.current.scrollToRow(selectedIndex);
        else if (selectedIndex === -1) listRef.current.scrollToRow(0);
    }, [
        selectedIndex,
        lastVisibleStartIndex,
        lastVisibleStopIndex,
        itemsLength,
        showMoreOptionsButton
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        setCache(new (0, $kZS37.CellMeasurerCache)({
            fixedWidth: true,
            defaultHeight: $82d4adc319c78782$var$LIST_ITEM_ESTIMATED_HEIGHT
        }));
        // When query is updated, sometimes the scroll position of the menu is not at the top
        // Scrolling back to top for consistency
        requestAnimationFrame(()=>{
            if (listContainerRef.current?.firstChild) // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            listContainerRef.current.firstChild.scrollTo(0, 0);
        });
    }, [
        items
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        // Exclude view more item from the count
        const itemsToRender = showMoreOptionsButton ? items.slice(0, -1) : items;
        const height = Math.min(itemsToRender.reduce((prevValue, currentValue, index)=>{
            return prevValue + cache.rowHeight({
                index: index
            });
        }, 0), fitHeight);
        setHeight(height);
    }, [
        items,
        cache,
        fitHeight,
        showMoreOptionsButton
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!listContainerRef.current) return;
        const { current: element } = listContainerRef;
        /**
     * To handle the key events on the list
     * @param event
     * @example
     */ const handleKeyDown = (event)=>{
            if (isNavigationKey(event)) switch(event.key){
                case 'ArrowDown':
                    selectNextItem();
                    event.preventDefault();
                    event.stopPropagation();
                    break;
                case 'ArrowUp':
                    selectPreviousItem();
                    event.preventDefault();
                    event.stopPropagation();
                    break;
                // TODO: DTR-1401 - why is this calling item click when hitting tab? fix this in DTR-1401
                case 'Tab':
                    //Tab key quick inserts the selected item.
                    onItemClick((0, $7k8dr.SelectItemMode).TAB, selectedIndex, (0, $bMFKb.INPUT_METHOD).KEYBOARD);
                    event.preventDefault();
                    break;
                case 'Enter':
                    //Enter key quick inserts the selected item.
                    if (!event.isComposing || event.which !== 229 && event.keyCode !== 229) {
                        onItemClick(event.shiftKey ? (0, $7k8dr.SelectItemMode).SHIFT_ENTER : (0, $7k8dr.SelectItemMode).ENTER, selectedIndex, (0, $bMFKb.INPUT_METHOD).KEYBOARD);
                        event.preventDefault();
                    }
                    break;
                default:
                    event.preventDefault();
            }
            else //All the remaining keys sets focus on the typeahead query(inputQuery.tsx))
            focusTargetElement();
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', handleKeyDown);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        editorView.state,
        focusTargetElement,
        selectNextItem,
        selectPreviousItem,
        selectedIndex,
        onItemClick,
        itemsLength
    ]);
    const firstOnlineSupportedRow = (0, $eJOHy.useMemo)(()=>{
        return items.findIndex((item)=>item.isDisabledOffline !== true);
    }, [
        items
    ]);
    const config = triggerHandler?.getMoreOptionsButtonConfig?.(intl);
    const handleClick = ()=>{
        if (onMoreOptionsClicked) onMoreOptionsClicked();
        api?.core.actions.execute(({ tr: tr })=>{
            (0, $azYbd.closeTypeAhead)(tr);
            config?.onClick({
                tr: tr
            });
            return tr;
        });
    };
    const renderRow = ({ index: index, key: key, style: style, parent: parent, isScrolling: isScrolling, isVisible: isVisible })=>{
        const currentItem = items[index];
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $kZS37.CellMeasurer), {
            key: key,
            cache: cache,
            parent: parent,
            columnIndex: 0,
            rowIndex: index
        }, ({ measure: measure })=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, $ajlZ9.ListRow), {
                measure: measure,
                index: index,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: style,
                isVisible: isVisible,
                isScrolling: isScrolling,
                onMouseMove: (e)=>onMouseMove(e, index)
            }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $9aOK1.TypeAheadListItem), {
                key: items[index].title,
                item: currentItem,
                firstOnlineSupportedIndex: firstOnlineSupportedRow,
                itemsLength: itemsLength,
                itemIndex: index,
                selectedIndex: selectedIndex,
                onItemClick: (mode, index)=>{
                    actions.onItemClick(mode, index, (0, $bMFKb.INPUT_METHOD).MOUSE);
                },
                ariaLabel: (0, $elKSH.getTypeAheadListAriaLabels)(triggerHandler?.trigger, intl, currentItem).listItemAriaLabel,
                moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled,
                api: api
            })));
    };
    const popupAriaLabel = (0, $elKSH.getTypeAheadListAriaLabels)(triggerHandler?.trigger, intl).popupAriaLabel;
    if (!Array.isArray(items)) return null;
    const menuGroupId = decorationElement.querySelector(`[role='combobox']`)?.getAttribute('aria-controls') || (0, $eQTrE.TYPE_AHEAD_DECORATION_ELEMENT_ID);
    const EmptyResultView = /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8IeH1.default), {
        paddingBlock: "space.150",
        paddingInline: "space.250"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $3cMgR.default), {
        align: "center",
        as: "p"
    }, intl.formatMessage((0, $4drex.typeAheadListMessages).emptySearchResults)), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $3cMgR.default), {
        align: "center",
        as: "p"
    }, intl.formatMessage((0, $4drex.typeAheadListMessages).emptySearchResultsSuggestion, {
        buttonName: /*#__PURE__*/ (0, $1NIU8.jsx)((0, $3cMgR.default), {
            weight: "medium"
        }, intl.formatMessage((0, $46A2h.toolbarInsertBlockMessages).viewMore))
    })));
    const ListContent = /*#__PURE__*/ (0, $1NIU8.jsx)((0, $5R9ov.List), {
        rowRenderer: renderRow,
        ref: listRef,
        // Skip rendering the view more button in the list
        rowCount: itemsLength,
        rowHeight: cache.rowHeight,
        onRowsRendered: onItemsRendered,
        width: $82d4adc319c78782$var$LIST_WIDTH,
        onScroll: onScroll,
        height: height,
        overscanRowCount: 3,
        "aria-label": (0, $elKSH.getTypeAheadListAriaLabels)(undefined, intl).popupAriaLabel,
        containerRole: "presentation",
        role: "listbox",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: [
            /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $1NIU8.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
                button: {
                    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-150, 12px)"} 11px`,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                    'span:last-child span:last-child': {
                        whiteSpace: 'normal'
                    }
                }
            }),
            moreElementsInQuickInsertViewEnabled && $82d4adc319c78782$var$list
        ]
    });
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jUgeq.default), {
        "aria-label": popupAriaLabel,
        "aria-relevant": "additions removals"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        id: menuGroupId,
        ref: listContainerRef
    }, !showMoreOptionsButton || itemsLength ? ListContent : EmptyResultView, showMoreOptionsButton && config && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $3mtr1.MoreOptions), {
        title: config.title,
        ariaLabel: config.ariaLabel,
        onClick: handleClick,
        isFocused: selectedIndex === itemsLength,
        iconBefore: config.iconBefore
    }), /*#__PURE__*/ (0, $1NIU8.jsx)($82d4adc319c78782$var$TypeaheadAssistiveTextPureComponent, {
        numberOfResults: itemsLength.toString()
    })));
});
const $82d4adc319c78782$export$81b66b5b19964713 = (0, $6YFG2.default)($82d4adc319c78782$var$TypeAheadListComponent);
$82d4adc319c78782$export$81b66b5b19964713.displayName = 'TypeAheadList';

});
parcelRegister("kZS37", function(module, exports) {
"use strict";

var $7Wmh0 = parcelRequire("7Wmh0");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "CellMeasurer", {
    enumerable: true,
    get: function get() {
        return $f4936e3629289cca$var$_CellMeasurer["default"];
    }
});
Object.defineProperty(module.exports, "CellMeasurerCache", {
    enumerable: true,
    get: function get() {
        return $f4936e3629289cca$var$_CellMeasurerCache["default"];
    }
});
module.exports["default"] = void 0;

var $f4936e3629289cca$var$_CellMeasurer = $7Wmh0((parcelRequire("gHtXY")));

var $f4936e3629289cca$var$_CellMeasurerCache = $7Wmh0((parcelRequire("kflPs")));
var $f4936e3629289cca$var$_default = module.exports["default"] = $f4936e3629289cca$var$_CellMeasurer["default"];

});
parcelRegister("gHtXY", function(module, exports) {
"use strict";

var $7Wmh0 = parcelRequire("7Wmh0");

var $2V8W5 = parcelRequire("2V8W5");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $c287e831903a7afd$var$_classCallCheck2 = $7Wmh0((parcelRequire("4r8Q9")));

var $c287e831903a7afd$var$_createClass2 = $7Wmh0((parcelRequire("3Ei40")));

var $c287e831903a7afd$var$_possibleConstructorReturn2 = $7Wmh0((parcelRequire("1gtk9")));

var $c287e831903a7afd$var$_getPrototypeOf2 = $7Wmh0((parcelRequire("hj4kH")));

var $c287e831903a7afd$var$_inherits2 = $7Wmh0((parcelRequire("33JSU")));

var $c287e831903a7afd$var$_defineProperty2 = $7Wmh0((parcelRequire("ky4V8")));

var $c287e831903a7afd$var$_react = $c287e831903a7afd$var$_interopRequireWildcard((parcelRequire("eJOHy")));
var $c287e831903a7afd$var$React = $c287e831903a7afd$var$_react;
function $c287e831903a7afd$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c287e831903a7afd$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $c287e831903a7afd$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $2V8W5(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $c287e831903a7afd$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $c287e831903a7afd$var$_callSuper(t, o, e) {
    return o = (0, $c287e831903a7afd$var$_getPrototypeOf2["default"])(o), (0, $c287e831903a7afd$var$_possibleConstructorReturn2["default"])(t, $c287e831903a7afd$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $c287e831903a7afd$var$_getPrototypeOf2["default"])(t).constructor) : o.apply(t, e));
}
function $c287e831903a7afd$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c287e831903a7afd$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
} /*:: import type {CellMeasureCache} from './types';*/ 
/*:: type Children = (params: {measure: () => void}) => React.Element<*>;*/ /*:: type Cell = {
  columnIndex: number,
  rowIndex: number,
};*/ /*:: type Props = {
  cache: CellMeasureCache,
  children: Children | React.Element<*>,
  columnIndex?: number,
  index?: number,
  parent: {
    invalidateCellSizeAfterRender?: (cell: Cell) => void,
    recomputeGridSize?: (cell: Cell) => void,
  },
  rowIndex?: number,
};*/ /**
 * Wraps a cell and measures its rendered content.
 * Measurements are stored in a per-cell cache.
 * Cached-content is not be re-measured.
 */ var $c287e831903a7afd$var$CellMeasurer = module.exports["default"] = /*#__PURE__*/ function(_React$PureComponent) {
    function CellMeasurer() {
        var _this;
        (0, $c287e831903a7afd$var$_classCallCheck2["default"])(this, CellMeasurer);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $c287e831903a7afd$var$_callSuper(this, CellMeasurer, [].concat(args));
        (0, $c287e831903a7afd$var$_defineProperty2["default"])(_this, "_child", /*#__PURE__*/ $c287e831903a7afd$var$React.createRef());
        (0, $c287e831903a7afd$var$_defineProperty2["default"])(_this, "_measure", function() {
            var _this$props = _this.props, cache = _this$props.cache, _this$props$columnInd = _this$props.columnIndex, columnIndex = _this$props$columnInd === void 0 ? 0 : _this$props$columnInd, parent = _this$props.parent, _this$props$rowIndex = _this$props.rowIndex, rowIndex = _this$props$rowIndex === void 0 ? _this.props.index || 0 : _this$props$rowIndex;
            var _this$_getCellMeasure = _this._getCellMeasurements(), height = _this$_getCellMeasure.height, width = _this$_getCellMeasure.width;
            if (height !== cache.getHeight(rowIndex, columnIndex) || width !== cache.getWidth(rowIndex, columnIndex)) {
                cache.set(rowIndex, columnIndex, width, height);
                if (parent && typeof parent.recomputeGridSize === 'function') parent.recomputeGridSize({
                    columnIndex: columnIndex,
                    rowIndex: rowIndex
                });
            }
        });
        (0, $c287e831903a7afd$var$_defineProperty2["default"])(_this, "_registerChild", function(element) {
            if (element && !(element instanceof Element)) console.warn('CellMeasurer registerChild expects to be passed Element or null');
            _this._child.current = element;
            if (element) _this._maybeMeasureCell();
        });
        return _this;
    }
    (0, $c287e831903a7afd$var$_inherits2["default"])(CellMeasurer, _React$PureComponent);
    return (0, $c287e831903a7afd$var$_createClass2["default"])(CellMeasurer, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._maybeMeasureCell();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this._maybeMeasureCell();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var children = this.props.children;
                var resolvedChildren = typeof children === 'function' ? children({
                    measure: this._measure,
                    registerChild: this._registerChild
                }) : children;
                if (resolvedChildren === null) return resolvedChildren;
                return /*#__PURE__*/ (0, $c287e831903a7afd$var$_react.cloneElement)(resolvedChildren, {
                    ref: function ref(node) {
                        if (typeof resolvedChildren.ref === 'function') resolvedChildren.ref(node);
                        else if (resolvedChildren.ref) resolvedChildren.ref.current = node;
                        _this2._child.current = node;
                    }
                });
            }
        },
        {
            key: "_getCellMeasurements",
            value: function _getCellMeasurements() {
                var cache = this.props.cache;
                var node = this._child.current;
                // TODO Check for a bad combination of fixedWidth and missing numeric width or vice versa with height
                if (node && node.ownerDocument && node.ownerDocument.defaultView && node instanceof node.ownerDocument.defaultView.HTMLElement) {
                    var styleWidth = node.style.width;
                    var styleHeight = node.style.height;
                    // If we are re-measuring a cell that has already been measured,
                    // It will have a hard-coded width/height from the previous measurement.
                    // The fact that we are measuring indicates this measurement is probably stale,
                    // So explicitly clear it out (eg set to "auto") so we can recalculate.
                    // See issue #593 for more info.
                    // Even if we are measuring initially- if we're inside of a MultiGrid component,
                    // Explicitly clear width/height before measuring to avoid being tainted by another Grid.
                    // eg top/left Grid renders before bottom/right Grid
                    // Since the CellMeasurerCache is shared between them this taints derived cell size values.
                    if (!cache.hasFixedWidth()) node.style.width = 'auto';
                    if (!cache.hasFixedHeight()) node.style.height = 'auto';
                    var height = Math.ceil(node.offsetHeight);
                    var width = Math.ceil(node.offsetWidth);
                    // Reset after measuring to avoid breaking styles; see #660
                    if (styleWidth) node.style.width = styleWidth;
                    if (styleHeight) node.style.height = styleHeight;
                    return {
                        height: height,
                        width: width
                    };
                } else return {
                    height: 0,
                    width: 0
                };
            }
        },
        {
            key: "_maybeMeasureCell",
            value: function _maybeMeasureCell() {
                var _this$props2 = this.props, cache = _this$props2.cache, _this$props2$columnIn = _this$props2.columnIndex, columnIndex = _this$props2$columnIn === void 0 ? 0 : _this$props2$columnIn, parent = _this$props2.parent, _this$props2$rowIndex = _this$props2.rowIndex, rowIndex = _this$props2$rowIndex === void 0 ? this.props.index || 0 : _this$props2$rowIndex;
                if (!cache.has(rowIndex, columnIndex)) {
                    var _this$_getCellMeasure2 = this._getCellMeasurements(), height = _this$_getCellMeasure2.height, width = _this$_getCellMeasure2.width;
                    cache.set(rowIndex, columnIndex, width, height);
                    // If size has changed, let Grid know to re-render.
                    if (parent && typeof parent.invalidateCellSizeAfterRender === 'function') parent.invalidateCellSizeAfterRender({
                        columnIndex: columnIndex,
                        rowIndex: rowIndex
                    });
                }
            }
        }
    ]);
}($c287e831903a7afd$var$React.PureComponent); // Used for DEV mode warning check
(0, $c287e831903a7afd$var$_defineProperty2["default"])($c287e831903a7afd$var$CellMeasurer, "__internalCellMeasurerFlag", false);

});

parcelRegister("kflPs", function(module, exports) {
"use strict";

var $7Wmh0 = parcelRequire("7Wmh0");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.DEFAULT_WIDTH = module.exports.DEFAULT_HEIGHT = void 0;

var $ebd62425f1d1c5cc$var$_classCallCheck2 = $7Wmh0((parcelRequire("4r8Q9")));

var $ebd62425f1d1c5cc$var$_createClass2 = $7Wmh0((parcelRequire("3Ei40")));

var $ebd62425f1d1c5cc$var$_defineProperty2 = $7Wmh0((parcelRequire("ky4V8")));
/*:: import type {CellMeasureCache} from './types';*/ var $ebd62425f1d1c5cc$var$DEFAULT_HEIGHT = module.exports.DEFAULT_HEIGHT = 30;
var $ebd62425f1d1c5cc$var$DEFAULT_WIDTH = module.exports.DEFAULT_WIDTH = 100;
// Enables more intelligent mapping of a given column and row index to an item ID.
// This prevents a cell cache from being invalidated when its parent collection is modified.
/*:: type KeyMapper = (rowIndex: number, columnIndex: number) => any;*/ /*:: type CellMeasurerCacheParams = {
  defaultHeight?: number,
  defaultWidth?: number,
  fixedHeight?: boolean,
  fixedWidth?: boolean,
  minHeight?: number,
  minWidth?: number,
  keyMapper?: KeyMapper,
};*/ /*:: type Cache = {
  [key: any]: number,
};*/ /*:: type IndexParam = {
  index: number,
};*/ /**
 * Caches measurements for a given cell.
 */ var $ebd62425f1d1c5cc$var$CellMeasurerCache = module.exports["default"] = /*#__PURE__*/ function() {
    function CellMeasurerCache() {
        var _this = this;
        var params /*: CellMeasurerCacheParams*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $ebd62425f1d1c5cc$var$_classCallCheck2["default"])(this, CellMeasurerCache);
        (0, $ebd62425f1d1c5cc$var$_defineProperty2["default"])(this, "_cellHeightCache", {});
        (0, $ebd62425f1d1c5cc$var$_defineProperty2["default"])(this, "_cellWidthCache", {});
        (0, $ebd62425f1d1c5cc$var$_defineProperty2["default"])(this, "_columnWidthCache", {});
        (0, $ebd62425f1d1c5cc$var$_defineProperty2["default"])(this, "_rowHeightCache", {});
        (0, $ebd62425f1d1c5cc$var$_defineProperty2["default"])(this, "_defaultHeight", void 0);
        (0, $ebd62425f1d1c5cc$var$_defineProperty2["default"])(this, "_defaultWidth", void 0);
        (0, $ebd62425f1d1c5cc$var$_defineProperty2["default"])(this, "_minHeight", void 0);
        (0, $ebd62425f1d1c5cc$var$_defineProperty2["default"])(this, "_minWidth", void 0);
        (0, $ebd62425f1d1c5cc$var$_defineProperty2["default"])(this, "_keyMapper", void 0);
        (0, $ebd62425f1d1c5cc$var$_defineProperty2["default"])(this, "_hasFixedHeight", void 0);
        (0, $ebd62425f1d1c5cc$var$_defineProperty2["default"])(this, "_hasFixedWidth", void 0);
        (0, $ebd62425f1d1c5cc$var$_defineProperty2["default"])(this, "_columnCount", 0);
        (0, $ebd62425f1d1c5cc$var$_defineProperty2["default"])(this, "_rowCount", 0);
        (0, $ebd62425f1d1c5cc$var$_defineProperty2["default"])(this, "columnWidth", function(_ref /*:: */ ) {
            var index = _ref /*:: */ .index;
            var key = _this._keyMapper(0, index);
            return _this._columnWidthCache[key] !== undefined ? _this._columnWidthCache[key] : _this._defaultWidth;
        });
        (0, $ebd62425f1d1c5cc$var$_defineProperty2["default"])(this, "rowHeight", function(_ref2 /*:: */ ) {
            var index = _ref2 /*:: */ .index;
            var key = _this._keyMapper(index, 0);
            return _this._rowHeightCache[key] !== undefined ? _this._rowHeightCache[key] : _this._defaultHeight;
        });
        var defaultHeight = params.defaultHeight, defaultWidth = params.defaultWidth, fixedHeight = params.fixedHeight, fixedWidth = params.fixedWidth, keyMapper = params.keyMapper, minHeight = params.minHeight, minWidth = params.minWidth;
        this._hasFixedHeight = fixedHeight === true;
        this._hasFixedWidth = fixedWidth === true;
        this._minHeight = minHeight || 0;
        this._minWidth = minWidth || 0;
        this._keyMapper = keyMapper || $ebd62425f1d1c5cc$var$defaultKeyMapper;
        this._defaultHeight = Math.max(this._minHeight, typeof defaultHeight === 'number' ? defaultHeight : $ebd62425f1d1c5cc$var$DEFAULT_HEIGHT);
        this._defaultWidth = Math.max(this._minWidth, typeof defaultWidth === 'number' ? defaultWidth : $ebd62425f1d1c5cc$var$DEFAULT_WIDTH);
    }
    return (0, $ebd62425f1d1c5cc$var$_createClass2["default"])(CellMeasurerCache, [
        {
            key: "clear",
            value: function clear(rowIndex /*: number*/ ) {
                var columnIndex /*: number*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var key = this._keyMapper(rowIndex, columnIndex);
                delete this._cellHeightCache[key];
                delete this._cellWidthCache[key];
                this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
            }
        },
        {
            key: "clearAll",
            value: function clearAll() {
                this._cellHeightCache = {};
                this._cellWidthCache = {};
                this._columnWidthCache = {};
                this._rowHeightCache = {};
                this._rowCount = 0;
                this._columnCount = 0;
            }
        },
        {
            key: "defaultHeight",
            get: function get() /*: number*/ {
                return this._defaultHeight;
            }
        },
        {
            key: "defaultWidth",
            get: function get() /*: number*/ {
                return this._defaultWidth;
            }
        },
        {
            key: "hasFixedHeight",
            value: function hasFixedHeight() /*: boolean*/ {
                return this._hasFixedHeight;
            }
        },
        {
            key: "hasFixedWidth",
            value: function hasFixedWidth() /*: boolean*/ {
                return this._hasFixedWidth;
            }
        },
        {
            key: "getHeight",
            value: function getHeight(rowIndex /*: number*/ ) /*: number*/ {
                var columnIndex /*: number*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                if (this._hasFixedHeight) return this._defaultHeight;
                else {
                    var _key = this._keyMapper(rowIndex, columnIndex);
                    return this._cellHeightCache[_key] !== undefined ? Math.max(this._minHeight, this._cellHeightCache[_key]) : this._defaultHeight;
                }
            }
        },
        {
            key: "getWidth",
            value: function getWidth(rowIndex /*: number*/ ) /*: number*/ {
                var columnIndex /*: number*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                if (this._hasFixedWidth) return this._defaultWidth;
                else {
                    var _key2 = this._keyMapper(rowIndex, columnIndex);
                    return this._cellWidthCache[_key2] !== undefined ? Math.max(this._minWidth, this._cellWidthCache[_key2]) : this._defaultWidth;
                }
            }
        },
        {
            key: "has",
            value: function has(rowIndex /*: number*/ ) /*: boolean*/ {
                var columnIndex /*: number*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var key = this._keyMapper(rowIndex, columnIndex);
                return this._cellHeightCache[key] !== undefined;
            }
        },
        {
            key: "set",
            value: function set(rowIndex /*: number*/ , columnIndex /*: number*/ , width /*: number*/ , height /*: number*/ ) /*: void*/ {
                var key = this._keyMapper(rowIndex, columnIndex);
                if (columnIndex >= this._columnCount) this._columnCount = columnIndex + 1;
                if (rowIndex >= this._rowCount) this._rowCount = rowIndex + 1;
                // Size is cached per cell so we don't have to re-measure if cells are re-ordered.
                this._cellHeightCache[key] = height;
                this._cellWidthCache[key] = width;
                this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
            }
        },
        {
            key: "_updateCachedColumnAndRowSizes",
            value: function _updateCachedColumnAndRowSizes(rowIndex /*: number*/ , columnIndex /*: number*/ ) {
                // :columnWidth and :rowHeight are derived based on all cells in a column/row.
                // Pre-cache these derived values for faster lookup later.
                // Reads are expected to occur more frequently than writes in this case.
                // Only update non-fixed dimensions though to avoid doing unnecessary work.
                if (!this._hasFixedWidth) {
                    var columnWidth = 0;
                    for(var i = 0; i < this._rowCount; i++)columnWidth = Math.max(columnWidth, this.getWidth(i, columnIndex));
                    var columnKey = this._keyMapper(0, columnIndex);
                    this._columnWidthCache[columnKey] = columnWidth;
                }
                if (!this._hasFixedHeight) {
                    var rowHeight = 0;
                    for(var _i = 0; _i < this._columnCount; _i++)rowHeight = Math.max(rowHeight, this.getHeight(rowIndex, _i));
                    var rowKey = this._keyMapper(rowIndex, 0);
                    this._rowHeightCache[rowKey] = rowHeight;
                }
            }
        }
    ]);
}();
function $ebd62425f1d1c5cc$var$defaultKeyMapper(rowIndex /*: number*/ , columnIndex /*: number*/ ) {
    return "".concat(rowIndex, "-").concat(columnIndex);
}

});


parcelRegister("5R9ov", function(module, exports) {
"use strict";

var $7Wmh0 = parcelRequire("7Wmh0");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "List", {
    enumerable: true,
    get: function get() {
        return $4439308393e770b3$var$_List["default"];
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $4439308393e770b3$var$_List["default"];
    }
});

var $4439308393e770b3$var$_List = $7Wmh0((parcelRequire("aCfSm")));

});
parcelRegister("aCfSm", function(module, exports) {
"use strict";

var $7Wmh0 = parcelRequire("7Wmh0");

var $2V8W5 = parcelRequire("2V8W5");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $7ba9c495dfa0f187$var$_extends2 = $7Wmh0((parcelRequire("6bgQp")));

var $7ba9c495dfa0f187$var$_classCallCheck2 = $7Wmh0((parcelRequire("4r8Q9")));

var $7ba9c495dfa0f187$var$_createClass2 = $7Wmh0((parcelRequire("3Ei40")));

var $7ba9c495dfa0f187$var$_possibleConstructorReturn2 = $7Wmh0((parcelRequire("1gtk9")));

var $7ba9c495dfa0f187$var$_getPrototypeOf2 = $7Wmh0((parcelRequire("hj4kH")));

var $7ba9c495dfa0f187$var$_inherits2 = $7Wmh0((parcelRequire("33JSU")));

var $7ba9c495dfa0f187$var$_defineProperty2 = $7Wmh0((parcelRequire("ky4V8")));

var $7ba9c495dfa0f187$var$_Grid = $7ba9c495dfa0f187$var$_interopRequireWildcard((parcelRequire("C8fAJ")));

var $7ba9c495dfa0f187$var$React = $7ba9c495dfa0f187$var$_interopRequireWildcard((parcelRequire("eJOHy")));

var $7ba9c495dfa0f187$var$_clsx = $7Wmh0((parcelRequire("frReV")));
function $7ba9c495dfa0f187$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($7ba9c495dfa0f187$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $7ba9c495dfa0f187$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $2V8W5(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $7ba9c495dfa0f187$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $7ba9c495dfa0f187$var$_callSuper(t, o, e) {
    return o = (0, $7ba9c495dfa0f187$var$_getPrototypeOf2["default"])(o), (0, $7ba9c495dfa0f187$var$_possibleConstructorReturn2["default"])(t, $7ba9c495dfa0f187$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $7ba9c495dfa0f187$var$_getPrototypeOf2["default"])(t).constructor) : o.apply(t, e));
}
function $7ba9c495dfa0f187$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7ba9c495dfa0f187$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
} /*:: import type {
  NoContentRenderer,
  Alignment,
  CellSize,
  CellPosition,
  OverscanIndicesGetter,
  RenderedSection,
  CellRendererParams,
  Scroll as GridScroll,
} from '../Grid';*/ 
/*:: import type {RowRenderer, RenderedRows, Scroll} from './types';*/ /**
 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
 * if only a few of those elements are visible. The primary purpose of this component is to improve
 * performance by only rendering the DOM nodes that a user is able to see based on their current
 * scroll position.
 *
 * This component renders a virtualized list of elements with either fixed or dynamic heights.
 */ /*:: type Props = {
  'aria-label'?: string,

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   *-/
  autoHeight: boolean,

  /** Optional CSS class name *-/
  className?: string,

  /**
   * Used to estimate the total height of a List before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   *-/
  estimatedRowSize: number,

  /** Height constraint for list (determines how many actual rows are rendered) *-/
  height: number,

  /** Optional renderer to be used in place of rows when rowCount is 0 *-/
  noRowsRenderer: NoContentRenderer,

  /** Callback invoked with information about the slice of rows that were just rendered.  *-/

  onRowsRendered: (params: RenderedRows) => void,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   *-/
  onScroll: (params: Scroll) => void,

  /** See Grid#overscanIndicesGetter *-/
  overscanIndicesGetter: OverscanIndicesGetter,

  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   *-/
  overscanRowCount: number,

  /** Either a fixed row height (number) or a function that returns the height of a row given its index.  *-/
  rowHeight: CellSize,

  /** Responsible for rendering a row given an index; ({ index: number }): node *-/
  rowRenderer: RowRenderer,

  /** Number of rows in list. *-/
  rowCount: number,

  /** See Grid#scrollToAlignment *-/
  scrollToAlignment: Alignment,

  /** Row index to ensure visible (by forcefully scrolling if necessary) *-/
  scrollToIndex: number,

  /** Vertical offset. *-/
  scrollTop?: number,

  /** Optional inline style *-/
  style: Object,

  /** Tab index for focus *-/
  tabIndex?: number,

  /** Width of list *-/
  width: number,
};*/ var $7ba9c495dfa0f187$var$List = module.exports["default"] = /*#__PURE__*/ function(_React$PureComponent) {
    function List() {
        var _this;
        (0, $7ba9c495dfa0f187$var$_classCallCheck2["default"])(this, List);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $7ba9c495dfa0f187$var$_callSuper(this, List, [].concat(args));
        (0, $7ba9c495dfa0f187$var$_defineProperty2["default"])(_this, "Grid", void 0);
        (0, $7ba9c495dfa0f187$var$_defineProperty2["default"])(_this, "_cellRenderer", function(_ref /*:: */ ) {
            var parent = _ref /*:: */ .parent, rowIndex = _ref /*:: */ .rowIndex, style = _ref /*:: */ .style, isScrolling = _ref /*:: */ .isScrolling, isVisible = _ref /*:: */ .isVisible, key = _ref /*:: */ .key;
            var rowRenderer = _this.props.rowRenderer;
            // TRICKY The style object is sometimes cached by Grid.
            // This prevents new style objects from bypassing shallowCompare().
            // However as of React 16, style props are auto-frozen (at least in dev mode)
            // Check to make sure we can still modify the style before proceeding.
            // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713
            var widthDescriptor = Object.getOwnPropertyDescriptor(style, 'width');
            if (widthDescriptor && widthDescriptor.writable) // By default, List cells should be 100% width.
            // This prevents them from flowing under a scrollbar (if present).
            style.width = '100%';
            return rowRenderer({
                index: rowIndex,
                style: style,
                isScrolling: isScrolling,
                isVisible: isVisible,
                key: key,
                parent: parent
            });
        });
        (0, $7ba9c495dfa0f187$var$_defineProperty2["default"])(_this, "_setRef", function(ref /*: ?React.ElementRef<typeof Grid>*/ ) {
            _this.Grid = ref;
        });
        (0, $7ba9c495dfa0f187$var$_defineProperty2["default"])(_this, "_onScroll", function(_ref2 /*:: */ ) {
            var clientHeight = _ref2 /*:: */ .clientHeight, scrollHeight = _ref2 /*:: */ .scrollHeight, scrollTop = _ref2 /*:: */ .scrollTop;
            var onScroll = _this.props.onScroll;
            onScroll({
                clientHeight: clientHeight,
                scrollHeight: scrollHeight,
                scrollTop: scrollTop
            });
        });
        (0, $7ba9c495dfa0f187$var$_defineProperty2["default"])(_this, "_onSectionRendered", function(_ref3 /*:: */ ) {
            var rowOverscanStartIndex = _ref3 /*:: */ .rowOverscanStartIndex, rowOverscanStopIndex = _ref3 /*:: */ .rowOverscanStopIndex, rowStartIndex = _ref3 /*:: */ .rowStartIndex, rowStopIndex = _ref3 /*:: */ .rowStopIndex;
            var onRowsRendered = _this.props.onRowsRendered;
            onRowsRendered({
                overscanStartIndex: rowOverscanStartIndex,
                overscanStopIndex: rowOverscanStopIndex,
                startIndex: rowStartIndex,
                stopIndex: rowStopIndex
            });
        });
        return _this;
    }
    (0, $7ba9c495dfa0f187$var$_inherits2["default"])(List, _React$PureComponent);
    return (0, $7ba9c495dfa0f187$var$_createClass2["default"])(List, [
        {
            key: "forceUpdateGrid",
            value: function forceUpdateGrid() {
                if (this.Grid) this.Grid.forceUpdate();
            }
        },
        {
            key: "getOffsetForRow",
            value: function getOffsetForRow(_ref4 /*:: */ ) {
                var alignment = _ref4 /*:: */ .alignment, index = _ref4 /*:: */ .index;
                if (this.Grid) {
                    var _this$Grid$getOffsetF = this.Grid.getOffsetForCell({
                        alignment: alignment,
                        rowIndex: index,
                        columnIndex: 0
                    }), scrollTop = _this$Grid$getOffsetF.scrollTop;
                    return scrollTop;
                }
                return 0;
            }
        },
        {
            key: "invalidateCellSizeAfterRender",
            value: function invalidateCellSizeAfterRender(_ref5 /*:: */ ) {
                var columnIndex = _ref5 /*:: */ .columnIndex, rowIndex = _ref5 /*:: */ .rowIndex;
                if (this.Grid) this.Grid.invalidateCellSizeAfterRender({
                    rowIndex: rowIndex,
                    columnIndex: columnIndex
                });
            }
        },
        {
            key: "measureAllRows",
            value: function measureAllRows() {
                if (this.Grid) this.Grid.measureAllCells();
            }
        },
        {
            key: "recomputeGridSize",
            value: function recomputeGridSize() {
                var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref6$columnIndex = _ref6.columnIndex, columnIndex = _ref6$columnIndex === void 0 ? 0 : _ref6$columnIndex, _ref6$rowIndex = _ref6.rowIndex, rowIndex = _ref6$rowIndex === void 0 ? 0 : _ref6$rowIndex;
                if (this.Grid) this.Grid.recomputeGridSize({
                    rowIndex: rowIndex,
                    columnIndex: columnIndex
                });
            }
        },
        {
            key: "recomputeRowHeights",
            value: function recomputeRowHeights() {
                var index /*: number*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.recomputeGridSize({
                    rowIndex: index,
                    columnIndex: 0
                });
            }
        },
        {
            key: "scrollToPosition",
            value: function scrollToPosition() {
                var scrollTop /*: number*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.scrollToPosition({
                    scrollTop: scrollTop
                });
            }
        },
        {
            key: "scrollToRow",
            value: function scrollToRow() {
                var index /*: number*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.scrollToCell({
                    columnIndex: 0,
                    rowIndex: index
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, className = _this$props.className, noRowsRenderer = _this$props.noRowsRenderer, scrollToIndex = _this$props.scrollToIndex, width = _this$props.width;
                var classNames = (0, $7ba9c495dfa0f187$var$_clsx["default"])('ReactVirtualized__List', className);
                return /*#__PURE__*/ $7ba9c495dfa0f187$var$React.createElement($7ba9c495dfa0f187$var$_Grid["default"], (0, $7ba9c495dfa0f187$var$_extends2["default"])({}, this.props, {
                    autoContainerWidth: true,
                    cellRenderer: this._cellRenderer,
                    className: classNames,
                    columnWidth: width,
                    columnCount: 1,
                    noContentRenderer: noRowsRenderer,
                    onScroll: this._onScroll,
                    onSectionRendered: this._onSectionRendered,
                    ref: this._setRef,
                    scrollToRow: scrollToIndex
                }));
            }
        }
    ]);
}($7ba9c495dfa0f187$var$React.PureComponent);
(0, $7ba9c495dfa0f187$var$_defineProperty2["default"])($7ba9c495dfa0f187$var$List, "defaultProps", {
    autoHeight: false,
    estimatedRowSize: 30,
    onScroll: function onScroll() {},
    noRowsRenderer: function noRowsRenderer() {
        return null;
    },
    onRowsRendered: function onRowsRendered() {},
    overscanIndicesGetter: $7ba9c495dfa0f187$var$_Grid.accessibilityOverscanIndicesGetter,
    overscanRowCount: 10,
    scrollToAlignment: 'auto',
    scrollToIndex: -1,
    style: {}
});

});
parcelRegister("C8fAJ", function(module, exports) {
"use strict";

var $7Wmh0 = parcelRequire("7Wmh0");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Grid", {
    enumerable: true,
    get: function get() {
        return $0729f318ca738ecb$var$_Grid["default"];
    }
});
Object.defineProperty(module.exports, "accessibilityOverscanIndicesGetter", {
    enumerable: true,
    get: function get() {
        return $0729f318ca738ecb$var$_accessibilityOverscanIndicesGetter["default"];
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $0729f318ca738ecb$var$_Grid["default"];
    }
});
Object.defineProperty(module.exports, "defaultCellRangeRenderer", {
    enumerable: true,
    get: function get() {
        return $0729f318ca738ecb$var$_defaultCellRangeRenderer["default"];
    }
});
Object.defineProperty(module.exports, "defaultOverscanIndicesGetter", {
    enumerable: true,
    get: function get() {
        return $0729f318ca738ecb$var$_defaultOverscanIndicesGetter["default"];
    }
});

var $0729f318ca738ecb$var$_Grid = $7Wmh0((parcelRequire("2O0vF")));

var $0729f318ca738ecb$var$_accessibilityOverscanIndicesGetter = $7Wmh0((parcelRequire("dA48H")));

var $0729f318ca738ecb$var$_defaultCellRangeRenderer = $7Wmh0((parcelRequire("gvLQZ")));

var $0729f318ca738ecb$var$_defaultOverscanIndicesGetter = $7Wmh0((parcelRequire("lykzA")));

});
parcelRegister("2O0vF", function(module, exports) {
"use strict";

var $7Wmh0 = parcelRequire("7Wmh0");

Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = void 0;

var $20b0a57dcc772bb6$var$_extends2 = $7Wmh0((parcelRequire("6bgQp")));

var $20b0a57dcc772bb6$var$_typeof2 = $7Wmh0((parcelRequire("2V8W5")));

var $20b0a57dcc772bb6$var$_classCallCheck2 = $7Wmh0((parcelRequire("4r8Q9")));

var $20b0a57dcc772bb6$var$_createClass2 = $7Wmh0((parcelRequire("3Ei40")));

var $20b0a57dcc772bb6$var$_possibleConstructorReturn2 = $7Wmh0((parcelRequire("1gtk9")));

var $20b0a57dcc772bb6$var$_getPrototypeOf2 = $7Wmh0((parcelRequire("hj4kH")));

var $20b0a57dcc772bb6$var$_inherits2 = $7Wmh0((parcelRequire("33JSU")));

var $20b0a57dcc772bb6$var$_defineProperty2 = $7Wmh0((parcelRequire("ky4V8")));

var $20b0a57dcc772bb6$var$React = $20b0a57dcc772bb6$var$_interopRequireWildcard((parcelRequire("eJOHy")));

var $20b0a57dcc772bb6$var$_clsx = $7Wmh0((parcelRequire("frReV")));

var $20b0a57dcc772bb6$var$_calculateSizeAndPositionDataAndUpdateScrollOffset = $7Wmh0((parcelRequire("eLBYA")));

var $20b0a57dcc772bb6$var$_ScalingCellSizeAndPositionManager = $7Wmh0((parcelRequire("fV4gO")));

var $20b0a57dcc772bb6$var$_createCallbackMemoizer = $7Wmh0((parcelRequire("es1wu")));

var $20b0a57dcc772bb6$var$_defaultOverscanIndicesGetter = $20b0a57dcc772bb6$var$_interopRequireWildcard((parcelRequire("lykzA")));

var $20b0a57dcc772bb6$var$_updateScrollIndexHelper = $7Wmh0((parcelRequire("cLBIS")));

var $20b0a57dcc772bb6$var$_defaultCellRangeRenderer = $7Wmh0((parcelRequire("gvLQZ")));

var $20b0a57dcc772bb6$var$_scrollbarSize = $7Wmh0((parcelRequire("5YzJ9")));

var $b4FuJ = parcelRequire("b4FuJ");

var $8nF5v = parcelRequire("8nF5v");
function $20b0a57dcc772bb6$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($20b0a57dcc772bb6$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $20b0a57dcc772bb6$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != (parcelRequire("2V8W5"))(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $20b0a57dcc772bb6$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $20b0a57dcc772bb6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $20b0a57dcc772bb6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $20b0a57dcc772bb6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $20b0a57dcc772bb6$var$_defineProperty2["default"])(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $20b0a57dcc772bb6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $20b0a57dcc772bb6$var$_callSuper(t, o, e) {
    return o = (0, $20b0a57dcc772bb6$var$_getPrototypeOf2["default"])(o), (0, $20b0a57dcc772bb6$var$_possibleConstructorReturn2["default"])(t, $20b0a57dcc772bb6$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $20b0a57dcc772bb6$var$_getPrototypeOf2["default"])(t).constructor) : o.apply(t, e));
}
function $20b0a57dcc772bb6$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($20b0a57dcc772bb6$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
} /*:: import type {
  CellRenderer,
  CellRangeRenderer,
  CellPosition,
  CellSize,
  CellSizeGetter,
  NoContentRenderer,
  Scroll,
  ScrollbarPresenceChange,
  RenderedSection,
  OverscanIndicesGetter,
  Alignment,
  CellCache,
  StyleCache,
} from './types';*/ 
/*:: import type {AnimationTimeoutId} from '../utils/requestAnimationTimeout';*/ /**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */ var $20b0a57dcc772bb6$var$DEFAULT_SCROLLING_RESET_TIME_INTERVAL = module.exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */ var $20b0a57dcc772bb6$var$SCROLL_POSITION_CHANGE_REASONS = {
    OBSERVED: 'observed',
    REQUESTED: 'requested'
};
var $20b0a57dcc772bb6$var$renderNull /*: NoContentRenderer*/  = function renderNull() {
    return null;
};
/*:: type ScrollPosition = {
  scrollTop?: number,
  scrollLeft?: number,
};*/ /*:: type Props = {
  'aria-label': string,
  'aria-readonly'?: boolean,

  /**
   * Set the width of the inner scrollable container to 'auto'.
   * This is useful for single-column Grids to ensure that the column doesn't extend below a vertical scrollbar.
   *-/
  autoContainerWidth: boolean,

  /**
   * Removes fixed height from the scrollingContainer so that the total height of rows can stretch the window.
   * Intended for use with WindowScroller
   *-/
  autoHeight: boolean,

  /**
   * Removes fixed width from the scrollingContainer so that the total width of rows can stretch the window.
   * Intended for use with WindowScroller
   *-/
  autoWidth: boolean,

  /** Responsible for rendering a cell given an row and column index.  *-/
  cellRenderer: CellRenderer,

  /** Responsible for rendering a group of cells given their index ranges.  *-/
  cellRangeRenderer: CellRangeRenderer,

  /** Optional custom CSS class name to attach to root Grid element.  *-/
  className?: string,

  /** Number of columns in grid.  *-/
  columnCount: number,

  /** Either a fixed column width (number) or a function that returns the width of a column given its index.  *-/
  columnWidth: CellSize,

  /** Unfiltered props for the Grid container. *-/
  containerProps?: Object,

  /** ARIA role for the cell-container.  *-/
  containerRole: string,

  /** Optional inline style applied to inner cell-container *-/
  containerStyle: Object,

  /**
   * If CellMeasurer is used to measure this Grid's children, this should be a pointer to its CellMeasurerCache.
   * A shared CellMeasurerCache reference enables Grid and CellMeasurer to share measurement data.
   *-/
  deferredMeasurementCache?: Object,

  /**
   * Used to estimate the total width of a Grid before all of its columns have actually been measured.
   * The estimated total width is adjusted as columns are rendered.
   *-/
  estimatedColumnSize: number,

  /**
   * Used to estimate the total height of a Grid before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   *-/
  estimatedRowSize: number,

  /** Exposed for testing purposes only.  *-/
  getScrollbarSize: () => number,

  /** Height of Grid; this property determines the number of visible (vs virtualized) rows.  *-/
  height: number,

  /** Optional custom id to attach to root Grid element.  *-/
  id?: string,

  /**
   * Override internal is-scrolling state tracking.
   * This property is primarily intended for use with the WindowScroller component.
   *-/
  isScrolling?: boolean,

  /**
   * Opt-out of isScrolling param passed to cellRangeRenderer.
   * To avoid the extra render when scroll stops.
   *-/
  isScrollingOptOut: boolean,

  /** Optional renderer to be used in place of rows when either :rowCount or :columnCount is 0.  *-/
  noContentRenderer: NoContentRenderer,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   *-/
  onScroll: (params: Scroll) => void,

  /**
   * Called whenever a horizontal or vertical scrollbar is added or removed.
   * This prop is not intended for end-user use;
   * It is used by MultiGrid to support fixed-row/fixed-column scroll syncing.
   *-/
  onScrollbarPresenceChange: (params: ScrollbarPresenceChange) => void,

  /** Callback invoked with information about the section of the Grid that was just rendered.  *-/
  onSectionRendered: (params: RenderedSection) => void,

  /**
   * Number of columns to render before/after the visible section of the grid.
   * These columns can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   *-/
  overscanColumnCount: number,

  /**
   * Calculates the number of cells to overscan before and after a specified range.
   * This function ensures that overscanning doesn't exceed the available cells.
   *-/
  overscanIndicesGetter: OverscanIndicesGetter,

  /**
   * Number of rows to render above/below the visible section of the grid.
   * These rows can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   *-/
  overscanRowCount: number,

  /** ARIA role for the grid element.  *-/
  role: string,

  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * Should implement the following interface: ({ index: number }): number
   *-/
  rowHeight: CellSize,

  /** Number of rows in grid.  *-/
  rowCount: number,

  /** Wait this amount of time after the last scroll event before resetting Grid `pointer-events`. *-/
  scrollingResetTimeInterval: number,

  /** Horizontal offset. *-/
  scrollLeft?: number,

  /**
   * Controls scroll-to-cell behavior of the Grid.
   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
   *-/
  scrollToAlignment: Alignment,

  /** Column index to ensure visible (by forcefully scrolling if necessary) *-/
  scrollToColumn: number,

  /** Vertical offset. *-/
  scrollTop?: number,

  /** Row index to ensure visible (by forcefully scrolling if necessary) *-/
  scrollToRow: number,

  /** Optional inline style *-/
  style: Object,

  /** Tab index for focus *-/
  tabIndex: ?number,

  /** Width of Grid; this property determines the number of visible (vs virtualized) columns.  *-/
  width: number,

  /** Reference to DOM node *-/
  elementRef?: React.Ref<React.ElementType>,
};*/ /*:: type InstanceProps = {
  prevColumnWidth: CellSize,
  prevRowHeight: CellSize,

  prevColumnCount: number,
  prevRowCount: number,
  prevIsScrolling: boolean,
  prevScrollToColumn: number,
  prevScrollToRow: number,

  columnSizeAndPositionManager: ScalingCellSizeAndPositionManager,
  rowSizeAndPositionManager: ScalingCellSizeAndPositionManager,

  scrollbarSize: number,
  scrollbarSizeMeasured: boolean,
};*/ /*:: type State = {
  instanceProps: InstanceProps,
  isScrolling: boolean,
  scrollDirectionHorizontal: -1 | 1,
  scrollDirectionVertical: -1 | 1,
  scrollLeft: number,
  scrollTop: number,
  scrollPositionChangeReason: 'observed' | 'requested' | null,
  needToResetStyleCache: boolean,
};*/ /**
 * Renders tabular data with virtualization along the vertical and horizontal axes.
 * Row heights and column widths must be known ahead of time and specified as properties.
 */ var $20b0a57dcc772bb6$var$Grid = /*#__PURE__*/ function(_React$PureComponent) {
    function Grid(props /*: Props*/ ) {
        var _this;
        (0, $20b0a57dcc772bb6$var$_classCallCheck2["default"])(this, Grid);
        _this = $20b0a57dcc772bb6$var$_callSuper(this, Grid, [
            props
        ]);
        // Invokes onSectionRendered callback only when start/stop row or column indices change
        (0, $20b0a57dcc772bb6$var$_defineProperty2["default"])(_this, "_onGridRenderedMemoizer", (0, $20b0a57dcc772bb6$var$_createCallbackMemoizer["default"])());
        (0, $20b0a57dcc772bb6$var$_defineProperty2["default"])(_this, "_onScrollMemoizer", (0, $20b0a57dcc772bb6$var$_createCallbackMemoizer["default"])(false));
        (0, $20b0a57dcc772bb6$var$_defineProperty2["default"])(_this, "_deferredInvalidateColumnIndex", null);
        (0, $20b0a57dcc772bb6$var$_defineProperty2["default"])(_this, "_deferredInvalidateRowIndex", null);
        (0, $20b0a57dcc772bb6$var$_defineProperty2["default"])(_this, "_recomputeScrollLeftFlag", false);
        (0, $20b0a57dcc772bb6$var$_defineProperty2["default"])(_this, "_recomputeScrollTopFlag", false);
        (0, $20b0a57dcc772bb6$var$_defineProperty2["default"])(_this, "_horizontalScrollBarSize", 0);
        (0, $20b0a57dcc772bb6$var$_defineProperty2["default"])(_this, "_verticalScrollBarSize", 0);
        (0, $20b0a57dcc772bb6$var$_defineProperty2["default"])(_this, "_scrollbarPresenceChanged", false);
        (0, $20b0a57dcc772bb6$var$_defineProperty2["default"])(_this, "_scrollingContainer", void 0);
        (0, $20b0a57dcc772bb6$var$_defineProperty2["default"])(_this, "_childrenToDisplay", void 0);
        (0, $20b0a57dcc772bb6$var$_defineProperty2["default"])(_this, "_columnStartIndex", void 0);
        (0, $20b0a57dcc772bb6$var$_defineProperty2["default"])(_this, "_columnStopIndex", void 0);
        (0, $20b0a57dcc772bb6$var$_defineProperty2["default"])(_this, "_rowStartIndex", void 0);
        (0, $20b0a57dcc772bb6$var$_defineProperty2["default"])(_this, "_rowStopIndex", void 0);
        (0, $20b0a57dcc772bb6$var$_defineProperty2["default"])(_this, "_renderedColumnStartIndex", 0);
        (0, $20b0a57dcc772bb6$var$_defineProperty2["default"])(_this, "_renderedColumnStopIndex", 0);
        (0, $20b0a57dcc772bb6$var$_defineProperty2["default"])(_this, "_renderedRowStartIndex", 0);
        (0, $20b0a57dcc772bb6$var$_defineProperty2["default"])(_this, "_renderedRowStopIndex", 0);
        (0, $20b0a57dcc772bb6$var$_defineProperty2["default"])(_this, "_initialScrollTop", void 0);
        (0, $20b0a57dcc772bb6$var$_defineProperty2["default"])(_this, "_initialScrollLeft", void 0);
        (0, $20b0a57dcc772bb6$var$_defineProperty2["default"])(_this, "_disablePointerEventsTimeoutId", void 0);
        (0, $20b0a57dcc772bb6$var$_defineProperty2["default"])(_this, "_styleCache", {});
        (0, $20b0a57dcc772bb6$var$_defineProperty2["default"])(_this, "_cellCache", {});
        (0, $20b0a57dcc772bb6$var$_defineProperty2["default"])(_this, "_debounceScrollEndedCallback", function() {
            _this._disablePointerEventsTimeoutId = null;
            // isScrolling is used to determine if we reset styleCache
            _this.setState({
                isScrolling: false,
                needToResetStyleCache: false
            });
        });
        (0, $20b0a57dcc772bb6$var$_defineProperty2["default"])(_this, "_invokeOnGridRenderedHelper", function() {
            var onSectionRendered = _this.props.onSectionRendered;
            _this._onGridRenderedMemoizer({
                callback: onSectionRendered,
                indices: {
                    columnOverscanStartIndex: _this._columnStartIndex,
                    columnOverscanStopIndex: _this._columnStopIndex,
                    columnStartIndex: _this._renderedColumnStartIndex,
                    columnStopIndex: _this._renderedColumnStopIndex,
                    rowOverscanStartIndex: _this._rowStartIndex,
                    rowOverscanStopIndex: _this._rowStopIndex,
                    rowStartIndex: _this._renderedRowStartIndex,
                    rowStopIndex: _this._renderedRowStopIndex
                }
            });
        });
        (0, $20b0a57dcc772bb6$var$_defineProperty2["default"])(_this, "_setScrollingContainerRef", function(ref /*: Element*/ ) {
            _this._scrollingContainer = ref;
            if (typeof _this.props.elementRef === 'function') _this.props.elementRef(ref);
            else if ((0, $20b0a57dcc772bb6$var$_typeof2["default"])(_this.props.elementRef) === 'object') _this.props.elementRef.current = ref;
        });
        (0, $20b0a57dcc772bb6$var$_defineProperty2["default"])(_this, "_onScroll", function(event /*: Event*/ ) {
            // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
            // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
            // See issue #404 for more information.
            if (event.target === _this._scrollingContainer) _this.handleScrollEvent(event.target /*: any*/ );
        });
        var columnSizeAndPositionManager = new $20b0a57dcc772bb6$var$_ScalingCellSizeAndPositionManager["default"]({
            cellCount: props.columnCount,
            cellSizeGetter: function cellSizeGetter(params) {
                return Grid._wrapSizeGetter(props.columnWidth)(params);
            },
            estimatedCellSize: Grid._getEstimatedColumnSize(props)
        });
        var rowSizeAndPositionManager = new $20b0a57dcc772bb6$var$_ScalingCellSizeAndPositionManager["default"]({
            cellCount: props.rowCount,
            cellSizeGetter: function cellSizeGetter(params) {
                return Grid._wrapSizeGetter(props.rowHeight)(params);
            },
            estimatedCellSize: Grid._getEstimatedRowSize(props)
        });
        _this.state = {
            instanceProps: {
                columnSizeAndPositionManager: columnSizeAndPositionManager,
                rowSizeAndPositionManager: rowSizeAndPositionManager,
                prevColumnWidth: props.columnWidth,
                prevRowHeight: props.rowHeight,
                prevColumnCount: props.columnCount,
                prevRowCount: props.rowCount,
                prevIsScrolling: props.isScrolling === true,
                prevScrollToColumn: props.scrollToColumn,
                prevScrollToRow: props.scrollToRow,
                scrollbarSize: 0,
                scrollbarSizeMeasured: false
            },
            isScrolling: false,
            scrollDirectionHorizontal: $20b0a57dcc772bb6$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD,
            scrollDirectionVertical: $20b0a57dcc772bb6$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD,
            scrollLeft: 0,
            scrollTop: 0,
            scrollPositionChangeReason: null,
            needToResetStyleCache: false
        };
        if (props.scrollToRow > 0) _this._initialScrollTop = _this._getCalculatedScrollTop(props, _this.state);
        if (props.scrollToColumn > 0) _this._initialScrollLeft = _this._getCalculatedScrollLeft(props, _this.state);
        return _this;
    }
    /**
   * Gets offsets for a given cell and alignment.
   */ (0, $20b0a57dcc772bb6$var$_inherits2["default"])(Grid, _React$PureComponent);
    return (0, $20b0a57dcc772bb6$var$_createClass2["default"])(Grid, [
        {
            key: "getOffsetForCell",
            value: function getOffsetForCell() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$alignment = _ref.alignment, alignment = _ref$alignment === void 0 ? this.props.scrollToAlignment : _ref$alignment, _ref$columnIndex = _ref.columnIndex, columnIndex = _ref$columnIndex === void 0 ? this.props.scrollToColumn : _ref$columnIndex, _ref$rowIndex = _ref.rowIndex, rowIndex = _ref$rowIndex === void 0 ? this.props.scrollToRow : _ref$rowIndex;
                var offsetProps = $20b0a57dcc772bb6$var$_objectSpread($20b0a57dcc772bb6$var$_objectSpread({}, this.props), {}, {
                    scrollToAlignment: alignment,
                    scrollToColumn: columnIndex,
                    scrollToRow: rowIndex
                });
                return {
                    scrollLeft: this._getCalculatedScrollLeft(offsetProps),
                    scrollTop: this._getCalculatedScrollTop(offsetProps)
                };
            }
        },
        {
            key: "getTotalRowsHeight",
            value: function getTotalRowsHeight() {
                return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
            }
        },
        {
            key: "getTotalColumnsWidth",
            value: function getTotalColumnsWidth() {
                return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
            }
        },
        {
            key: "handleScrollEvent",
            value: function handleScrollEvent(_ref2 /*:: */ ) {
                var _ref2$scrollLeft = _ref2 /*:: */ .scrollLeft, scrollLeftParam = _ref2$scrollLeft === void 0 ? 0 : _ref2$scrollLeft, _ref2$scrollTop = _ref2 /*:: */ .scrollTop, scrollTopParam = _ref2$scrollTop === void 0 ? 0 : _ref2$scrollTop;
                // On iOS, we can arrive at negative offsets by swiping past the start.
                // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
                if (scrollTopParam < 0) return;
                // Prevent pointer events from interrupting a smooth scroll
                this._debounceScrollEnded();
                var _this$props = this.props, autoHeight = _this$props.autoHeight, autoWidth = _this$props.autoWidth, height = _this$props.height, width = _this$props.width;
                var instanceProps = this.state.instanceProps;
                // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
                // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
                // This causes a series of rapid renders that is slow for long lists.
                // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.
                var scrollbarSize = instanceProps.scrollbarSize;
                var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
                var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam);
                // Certain devices (like Apple touchpad) rapid-fire duplicate events.
                // Don't force a re-render if this is the case.
                // The mouse may move faster then the animation frame does.
                // Use requestAnimationFrame to avoid over-updating.
                if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
                    // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
                    // Don't change direction for an axis unless scroll offset has changed.
                    var scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? $20b0a57dcc772bb6$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : $20b0a57dcc772bb6$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionHorizontal;
                    var scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? $20b0a57dcc772bb6$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : $20b0a57dcc772bb6$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionVertical;
                    var newState /*: $Shape<State>*/  = {
                        isScrolling: true,
                        scrollDirectionHorizontal: scrollDirectionHorizontal,
                        scrollDirectionVertical: scrollDirectionVertical,
                        scrollPositionChangeReason: $20b0a57dcc772bb6$var$SCROLL_POSITION_CHANGE_REASONS.OBSERVED
                    };
                    if (!autoHeight) newState.scrollTop = scrollTop;
                    if (!autoWidth) newState.scrollLeft = scrollLeft;
                    newState.needToResetStyleCache = false;
                    this.setState(newState);
                }
                this._invokeOnScrollMemoizer({
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    totalColumnsWidth: totalColumnsWidth,
                    totalRowsHeight: totalRowsHeight
                });
            }
        },
        {
            key: "invalidateCellSizeAfterRender",
            value: function invalidateCellSizeAfterRender(_ref3 /*:: */ ) {
                var columnIndex = _ref3 /*:: */ .columnIndex, rowIndex = _ref3 /*:: */ .rowIndex;
                this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
                this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
            }
        },
        {
            key: "measureAllCells",
            value: function measureAllCells() {
                var _this$props2 = this.props, columnCount = _this$props2.columnCount, rowCount = _this$props2.rowCount;
                var instanceProps = this.state.instanceProps;
                instanceProps.columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
                instanceProps.rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
            }
        },
        {
            key: "recomputeGridSize",
            value: function recomputeGridSize() {
                var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref4$columnIndex = _ref4.columnIndex, columnIndex = _ref4$columnIndex === void 0 ? 0 : _ref4$columnIndex, _ref4$rowIndex = _ref4.rowIndex, rowIndex = _ref4$rowIndex === void 0 ? 0 : _ref4$rowIndex;
                var _this$props3 = this.props, scrollToColumn = _this$props3.scrollToColumn, scrollToRow = _this$props3.scrollToRow;
                var instanceProps = this.state.instanceProps;
                instanceProps.columnSizeAndPositionManager.resetCell(columnIndex);
                instanceProps.rowSizeAndPositionManager.resetCell(rowIndex);
                // Cell sizes may be determined by a function property.
                // In this case the cDU handler can't know if they changed.
                // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.
                this._recomputeScrollLeftFlag = scrollToColumn >= 0 && (this.state.scrollDirectionHorizontal === $20b0a57dcc772bb6$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD ? columnIndex <= scrollToColumn : columnIndex >= scrollToColumn);
                this._recomputeScrollTopFlag = scrollToRow >= 0 && (this.state.scrollDirectionVertical === $20b0a57dcc772bb6$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD ? rowIndex <= scrollToRow : rowIndex >= scrollToRow);
                // Clear cell cache in case we are scrolling;
                // Invalid row heights likely mean invalid cached content as well.
                this._styleCache = {};
                this._cellCache = {};
                this.forceUpdate();
            }
        },
        {
            key: "scrollToCell",
            value: function scrollToCell(_ref5 /*:: */ ) {
                var columnIndex = _ref5 /*:: */ .columnIndex, rowIndex = _ref5 /*:: */ .rowIndex;
                var columnCount = this.props.columnCount;
                var props = this.props;
                // Don't adjust scroll offset for single-column grids (eg List, Table).
                // This can cause a funky scroll offset because of the vertical scrollbar width.
                if (columnCount > 1 && columnIndex !== undefined) this._updateScrollLeftForScrollToColumn($20b0a57dcc772bb6$var$_objectSpread($20b0a57dcc772bb6$var$_objectSpread({}, props), {}, {
                    scrollToColumn: columnIndex
                }));
                if (rowIndex !== undefined) this._updateScrollTopForScrollToRow($20b0a57dcc772bb6$var$_objectSpread($20b0a57dcc772bb6$var$_objectSpread({}, props), {}, {
                    scrollToRow: rowIndex
                }));
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props4 = this.props, getScrollbarSize = _this$props4.getScrollbarSize, height = _this$props4.height, scrollLeft = _this$props4.scrollLeft, scrollToColumn = _this$props4.scrollToColumn, scrollTop = _this$props4.scrollTop, scrollToRow = _this$props4.scrollToRow, width = _this$props4.width;
                var instanceProps = this.state.instanceProps;
                // Reset initial offsets to be ignored in browser
                this._initialScrollTop = 0;
                this._initialScrollLeft = 0;
                // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
                // We must do this at the start of the method as we may calculate and update scroll position below.
                this._handleInvalidatedGridSize();
                // If this component was first rendered server-side, scrollbar size will be undefined.
                // In that event we need to remeasure.
                if (!instanceProps.scrollbarSizeMeasured) this.setState(function(prevState) {
                    var stateUpdate = $20b0a57dcc772bb6$var$_objectSpread($20b0a57dcc772bb6$var$_objectSpread({}, prevState), {}, {
                        needToResetStyleCache: false
                    });
                    stateUpdate.instanceProps.scrollbarSize = getScrollbarSize();
                    stateUpdate.instanceProps.scrollbarSizeMeasured = true;
                    return stateUpdate;
                });
                if (typeof scrollLeft === 'number' && scrollLeft >= 0 || typeof scrollTop === 'number' && scrollTop >= 0) {
                    var stateUpdate = Grid._getScrollToPositionStateUpdate({
                        prevState: this.state,
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop
                    });
                    if (stateUpdate) {
                        stateUpdate.needToResetStyleCache = false;
                        this.setState(stateUpdate);
                    }
                }
                // refs don't work in `react-test-renderer`
                if (this._scrollingContainer) {
                    // setting the ref's scrollLeft and scrollTop.
                    // Somehow in MultiGrid the main grid doesn't trigger a update on mount.
                    if (this._scrollingContainer.scrollLeft !== this.state.scrollLeft) this._scrollingContainer.scrollLeft = this.state.scrollLeft;
                    if (this._scrollingContainer.scrollTop !== this.state.scrollTop) this._scrollingContainer.scrollTop = this.state.scrollTop;
                }
                // Don't update scroll offset if the size is 0; we don't render any cells in this case.
                // Setting a state may cause us to later thing we've updated the offce when we haven't.
                var sizeIsBiggerThanZero = height > 0 && width > 0;
                if (scrollToColumn >= 0 && sizeIsBiggerThanZero) this._updateScrollLeftForScrollToColumn();
                if (scrollToRow >= 0 && sizeIsBiggerThanZero) this._updateScrollTopForScrollToRow();
                // Update onRowsRendered callback
                this._invokeOnGridRenderedHelper();
                // Initialize onScroll callback
                this._invokeOnScrollMemoizer({
                    scrollLeft: scrollLeft || 0,
                    scrollTop: scrollTop || 0,
                    totalColumnsWidth: instanceProps.columnSizeAndPositionManager.getTotalSize(),
                    totalRowsHeight: instanceProps.rowSizeAndPositionManager.getTotalSize()
                });
                this._maybeCallOnScrollbarPresenceChange();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps /*: Props*/ , prevState /*: State*/ ) {
                var _this2 = this;
                var _this$props5 = this.props, autoHeight = _this$props5.autoHeight, autoWidth = _this$props5.autoWidth, columnCount = _this$props5.columnCount, height = _this$props5.height, rowCount = _this$props5.rowCount, scrollToAlignment = _this$props5.scrollToAlignment, scrollToColumn = _this$props5.scrollToColumn, scrollToRow = _this$props5.scrollToRow, width = _this$props5.width;
                var _this$state = this.state, scrollLeft = _this$state.scrollLeft, scrollPositionChangeReason = _this$state.scrollPositionChangeReason, scrollTop = _this$state.scrollTop, instanceProps = _this$state.instanceProps;
                // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
                // We must do this at the start of the method as we may calculate and update scroll position below.
                this._handleInvalidatedGridSize();
                // Handle edge case where column or row count has only just increased over 0.
                // In this case we may have to restore a previously-specified scroll offset.
                // For more info see bvaughn/react-virtualized/issues/218
                var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0;
                // Make sure requested changes to :scrollLeft or :scrollTop get applied.
                // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
                // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
                // So we only set these when we require an adjustment of the scroll position.
                // See issue #2 for more information.
                if (scrollPositionChangeReason === $20b0a57dcc772bb6$var$SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
                    // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
                    // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
                    if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) this._scrollingContainer.scrollLeft = scrollLeft;
                    if (!autoHeight && scrollTop >= 0 && (scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) this._scrollingContainer.scrollTop = scrollTop;
                }
                // Special case where the previous size was 0:
                // In this case we don't show any windowed cells at all.
                // So we should always recalculate offset afterwards.
                var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0;
                // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
                // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?
                if (this._recomputeScrollLeftFlag) {
                    this._recomputeScrollLeftFlag = false;
                    this._updateScrollLeftForScrollToColumn(this.props);
                } else (0, $20b0a57dcc772bb6$var$_updateScrollIndexHelper["default"])({
                    cellSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
                    previousCellsCount: prevProps.columnCount,
                    previousCellSize: prevProps.columnWidth,
                    previousScrollToAlignment: prevProps.scrollToAlignment,
                    previousScrollToIndex: prevProps.scrollToColumn,
                    previousSize: prevProps.width,
                    scrollOffset: scrollLeft,
                    scrollToAlignment: scrollToAlignment,
                    scrollToIndex: scrollToColumn,
                    size: width,
                    sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
                    updateScrollIndexCallback: function updateScrollIndexCallback() {
                        return _this2._updateScrollLeftForScrollToColumn(_this2.props);
                    }
                });
                if (this._recomputeScrollTopFlag) {
                    this._recomputeScrollTopFlag = false;
                    this._updateScrollTopForScrollToRow(this.props);
                } else (0, $20b0a57dcc772bb6$var$_updateScrollIndexHelper["default"])({
                    cellSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
                    previousCellsCount: prevProps.rowCount,
                    previousCellSize: prevProps.rowHeight,
                    previousScrollToAlignment: prevProps.scrollToAlignment,
                    previousScrollToIndex: prevProps.scrollToRow,
                    previousSize: prevProps.height,
                    scrollOffset: scrollTop,
                    scrollToAlignment: scrollToAlignment,
                    scrollToIndex: scrollToRow,
                    size: height,
                    sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
                    updateScrollIndexCallback: function updateScrollIndexCallback() {
                        return _this2._updateScrollTopForScrollToRow(_this2.props);
                    }
                });
                // Update onRowsRendered callback if start/stop indices have changed
                this._invokeOnGridRenderedHelper();
                // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners
                if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
                    var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                    var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                    this._invokeOnScrollMemoizer({
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop,
                        totalColumnsWidth: totalColumnsWidth,
                        totalRowsHeight: totalRowsHeight
                    });
                }
                this._maybeCallOnScrollbarPresenceChange();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this._disablePointerEventsTimeoutId) (0, $8nF5v.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, autoContainerWidth = _this$props6.autoContainerWidth, autoHeight = _this$props6.autoHeight, autoWidth = _this$props6.autoWidth, className = _this$props6.className, containerProps = _this$props6.containerProps, containerRole = _this$props6.containerRole, containerStyle = _this$props6.containerStyle, height = _this$props6.height, id = _this$props6.id, noContentRenderer = _this$props6.noContentRenderer, role = _this$props6.role, style = _this$props6.style, tabIndex = _this$props6.tabIndex, width = _this$props6.width;
                var _this$state2 = this.state, instanceProps = _this$state2.instanceProps, needToResetStyleCache = _this$state2.needToResetStyleCache;
                var isScrolling = this._isScrolling();
                var gridStyle /*: Object*/  = {
                    boxSizing: 'border-box',
                    direction: 'ltr',
                    height: autoHeight ? 'auto' : height,
                    position: 'relative',
                    width: autoWidth ? 'auto' : width,
                    WebkitOverflowScrolling: 'touch',
                    willChange: 'transform'
                };
                if (needToResetStyleCache) this._styleCache = {};
                // calculate _styleCache here
                // if state.isScrolling (not from _isScrolling) then reset
                if (!this.state.isScrolling) this._resetStyleCache();
                // calculate children to render here
                this._calculateChildrenToRender(this.props, this.state);
                var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                // Force browser to hide scrollbars when we know they aren't necessary.
                // Otherwise once scrollbars appear they may not disappear again.
                // For more info see issue #116
                var verticalScrollBarSize = totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
                var horizontalScrollBarSize = totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
                if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
                    this._horizontalScrollBarSize = horizontalScrollBarSize;
                    this._verticalScrollBarSize = verticalScrollBarSize;
                    this._scrollbarPresenceChanged = true;
                }
                // Also explicitly init styles to 'auto' if scrollbars are required.
                // This works around an obscure edge case where external CSS styles have not yet been loaded,
                // But an initial scroll index of offset is set as an external prop.
                // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
                // This was originally reported via clauderic/react-infinite-calendar/issues/23
                gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
                gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
                var childrenToDisplay = this._childrenToDisplay;
                var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;
                return /*#__PURE__*/ $20b0a57dcc772bb6$var$React.createElement("div", (0, $20b0a57dcc772bb6$var$_extends2["default"])({
                    ref: this._setScrollingContainerRef
                }, containerProps, {
                    "aria-label": this.props['aria-label'],
                    "aria-readonly": this.props['aria-readonly'],
                    className: (0, $20b0a57dcc772bb6$var$_clsx["default"])('ReactVirtualized__Grid', className),
                    id: id,
                    onScroll: this._onScroll,
                    role: role,
                    style: $20b0a57dcc772bb6$var$_objectSpread($20b0a57dcc772bb6$var$_objectSpread({}, gridStyle), style),
                    tabIndex: tabIndex
                }), childrenToDisplay.length > 0 && /*#__PURE__*/ $20b0a57dcc772bb6$var$React.createElement("div", {
                    className: "ReactVirtualized__Grid__innerScrollContainer",
                    role: containerRole,
                    style: $20b0a57dcc772bb6$var$_objectSpread({
                        width: autoContainerWidth ? 'auto' : totalColumnsWidth,
                        height: totalRowsHeight,
                        maxWidth: totalColumnsWidth,
                        maxHeight: totalRowsHeight,
                        overflow: 'hidden',
                        pointerEvents: isScrolling ? 'none' : '',
                        position: 'relative'
                    }, containerStyle)
                }, childrenToDisplay), showNoContentRenderer && noContentRenderer());
            }
        },
        {
            key: "_calculateChildrenToRender",
            value: function _calculateChildrenToRender() {
                var props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state /*: State*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                var cellRenderer = props.cellRenderer, cellRangeRenderer = props.cellRangeRenderer, columnCount = props.columnCount, deferredMeasurementCache = props.deferredMeasurementCache, height = props.height, overscanColumnCount = props.overscanColumnCount, overscanIndicesGetter = props.overscanIndicesGetter, overscanRowCount = props.overscanRowCount, rowCount = props.rowCount, width = props.width, isScrollingOptOut = props.isScrollingOptOut;
                var scrollDirectionHorizontal = state.scrollDirectionHorizontal, scrollDirectionVertical = state.scrollDirectionVertical, instanceProps = state.instanceProps;
                var scrollTop = this._initialScrollTop > 0 ? this._initialScrollTop : state.scrollTop;
                var scrollLeft = this._initialScrollLeft > 0 ? this._initialScrollLeft : state.scrollLeft;
                var isScrolling = this._isScrolling(props, state);
                this._childrenToDisplay = [];
                // Render only enough columns and rows to cover the visible area of the grid.
                if (height > 0 && width > 0) {
                    var visibleColumnIndices = instanceProps.columnSizeAndPositionManager.getVisibleCellRange({
                        containerSize: width,
                        offset: scrollLeft
                    });
                    var visibleRowIndices = instanceProps.rowSizeAndPositionManager.getVisibleCellRange({
                        containerSize: height,
                        offset: scrollTop
                    });
                    var horizontalOffsetAdjustment = instanceProps.columnSizeAndPositionManager.getOffsetAdjustment({
                        containerSize: width,
                        offset: scrollLeft
                    });
                    var verticalOffsetAdjustment = instanceProps.rowSizeAndPositionManager.getOffsetAdjustment({
                        containerSize: height,
                        offset: scrollTop
                    });
                    // Store for _invokeOnGridRenderedHelper()
                    this._renderedColumnStartIndex = visibleColumnIndices.start;
                    this._renderedColumnStopIndex = visibleColumnIndices.stop;
                    this._renderedRowStartIndex = visibleRowIndices.start;
                    this._renderedRowStopIndex = visibleRowIndices.stop;
                    var overscanColumnIndices = overscanIndicesGetter({
                        direction: 'horizontal',
                        cellCount: columnCount,
                        overscanCellsCount: overscanColumnCount,
                        scrollDirection: scrollDirectionHorizontal,
                        startIndex: typeof visibleColumnIndices.start === 'number' ? visibleColumnIndices.start : 0,
                        stopIndex: typeof visibleColumnIndices.stop === 'number' ? visibleColumnIndices.stop : -1
                    });
                    var overscanRowIndices = overscanIndicesGetter({
                        direction: 'vertical',
                        cellCount: rowCount,
                        overscanCellsCount: overscanRowCount,
                        scrollDirection: scrollDirectionVertical,
                        startIndex: typeof visibleRowIndices.start === 'number' ? visibleRowIndices.start : 0,
                        stopIndex: typeof visibleRowIndices.stop === 'number' ? visibleRowIndices.stop : -1
                    });
                    // Store for _invokeOnGridRenderedHelper()
                    var columnStartIndex = overscanColumnIndices.overscanStartIndex;
                    var columnStopIndex = overscanColumnIndices.overscanStopIndex;
                    var rowStartIndex = overscanRowIndices.overscanStartIndex;
                    var rowStopIndex = overscanRowIndices.overscanStopIndex;
                    // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.
                    if (deferredMeasurementCache) {
                        // If rows have a dynamic height, scan the rows we are about to render.
                        // If any have not yet been measured, then we need to render all columns initially,
                        // Because the height of the row is equal to the tallest cell within that row,
                        // (And so we can't know the height without measuring all column-cells first).
                        if (!deferredMeasurementCache.hasFixedHeight()) {
                            for(var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++)if (!deferredMeasurementCache.has(rowIndex, 0)) {
                                columnStartIndex = 0;
                                columnStopIndex = columnCount - 1;
                                break;
                            }
                        }
                        // If columns have a dynamic width, scan the columns we are about to render.
                        // If any have not yet been measured, then we need to render all rows initially,
                        // Because the width of the column is equal to the widest cell within that column,
                        // (And so we can't know the width without measuring all row-cells first).
                        if (!deferredMeasurementCache.hasFixedWidth()) {
                            for(var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++)if (!deferredMeasurementCache.has(0, columnIndex)) {
                                rowStartIndex = 0;
                                rowStopIndex = rowCount - 1;
                                break;
                            }
                        }
                    }
                    this._childrenToDisplay = cellRangeRenderer({
                        cellCache: this._cellCache,
                        cellRenderer: cellRenderer,
                        columnSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
                        columnStartIndex: columnStartIndex,
                        columnStopIndex: columnStopIndex,
                        deferredMeasurementCache: deferredMeasurementCache,
                        horizontalOffsetAdjustment: horizontalOffsetAdjustment,
                        isScrolling: isScrolling,
                        isScrollingOptOut: isScrollingOptOut,
                        parent: this,
                        rowSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
                        rowStartIndex: rowStartIndex,
                        rowStopIndex: rowStopIndex,
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop,
                        styleCache: this._styleCache,
                        verticalOffsetAdjustment: verticalOffsetAdjustment,
                        visibleColumnIndices: visibleColumnIndices,
                        visibleRowIndices: visibleRowIndices
                    });
                    // update the indices
                    this._columnStartIndex = columnStartIndex;
                    this._columnStopIndex = columnStopIndex;
                    this._rowStartIndex = rowStartIndex;
                    this._rowStopIndex = rowStopIndex;
                }
            }
        },
        {
            key: "_debounceScrollEnded",
            value: function _debounceScrollEnded() {
                var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;
                if (this._disablePointerEventsTimeoutId) (0, $8nF5v.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
                this._disablePointerEventsTimeoutId = (0, $8nF5v.requestAnimationTimeout)(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
            }
        },
        {
            key: "_handleInvalidatedGridSize",
            value: /**
     * Check for batched CellMeasurer size invalidations.
     * This will occur the first time one or more previously unmeasured cells are rendered.
     */ function _handleInvalidatedGridSize() {
                if (typeof this._deferredInvalidateColumnIndex === 'number' && typeof this._deferredInvalidateRowIndex === 'number') {
                    var columnIndex = this._deferredInvalidateColumnIndex;
                    var rowIndex = this._deferredInvalidateRowIndex;
                    this._deferredInvalidateColumnIndex = null;
                    this._deferredInvalidateRowIndex = null;
                    this.recomputeGridSize({
                        columnIndex: columnIndex,
                        rowIndex: rowIndex
                    });
                }
            }
        },
        {
            key: "_invokeOnScrollMemoizer",
            value: function _invokeOnScrollMemoizer(_ref6 /*:: */ ) {
                var _this3 = this;
                var scrollLeft = _ref6 /*:: */ .scrollLeft, scrollTop = _ref6 /*:: */ .scrollTop, totalColumnsWidth = _ref6 /*:: */ .totalColumnsWidth, totalRowsHeight = _ref6 /*:: */ .totalRowsHeight;
                this._onScrollMemoizer({
                    callback: function callback(_ref7) {
                        var scrollLeft = _ref7.scrollLeft, scrollTop = _ref7.scrollTop;
                        var _this3$props = _this3.props, height = _this3$props.height, onScroll = _this3$props.onScroll, width = _this3$props.width;
                        onScroll({
                            clientHeight: height,
                            clientWidth: width,
                            scrollHeight: totalRowsHeight,
                            scrollLeft: scrollLeft,
                            scrollTop: scrollTop,
                            scrollWidth: totalColumnsWidth
                        });
                    },
                    indices: {
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop
                    }
                });
            }
        },
        {
            key: "_isScrolling",
            value: function _isScrolling() /*: boolean*/ {
                var props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state /*: State*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                // If isScrolling is defined in props, use it to override the value in state
                // This is a performance optimization for WindowScroller + Grid
                return Object.hasOwnProperty.call(props, 'isScrolling') ? Boolean(props.isScrolling) : Boolean(state.isScrolling);
            }
        },
        {
            key: "_maybeCallOnScrollbarPresenceChange",
            value: function _maybeCallOnScrollbarPresenceChange() {
                if (this._scrollbarPresenceChanged) {
                    var onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;
                    this._scrollbarPresenceChanged = false;
                    onScrollbarPresenceChange({
                        horizontal: this._horizontalScrollBarSize > 0,
                        size: this.state.instanceProps.scrollbarSize,
                        vertical: this._verticalScrollBarSize > 0
                    });
                }
            }
        },
        {
            key: "scrollToPosition",
            value: /**
     * Scroll to the specified offset(s).
     * Useful for animating position changes.
     */ function scrollToPosition(_ref8 /*:: */ ) {
                var scrollLeft = _ref8 /*:: */ .scrollLeft, scrollTop = _ref8 /*:: */ .scrollTop;
                var stateUpdate = Grid._getScrollToPositionStateUpdate({
                    prevState: this.state,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop
                });
                if (stateUpdate) {
                    stateUpdate.needToResetStyleCache = false;
                    this.setState(stateUpdate);
                }
            }
        },
        {
            key: "_getCalculatedScrollLeft",
            value: function _getCalculatedScrollLeft() {
                var props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state /*: State*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                return Grid._getCalculatedScrollLeft(props, state);
            }
        },
        {
            key: "_updateScrollLeftForScrollToColumn",
            value: function _updateScrollLeftForScrollToColumn() {
                var props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state /*: State*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                var stateUpdate = Grid._getScrollLeftForScrollToColumnStateUpdate(props, state);
                if (stateUpdate) {
                    stateUpdate.needToResetStyleCache = false;
                    this.setState(stateUpdate);
                }
            }
        },
        {
            key: "_getCalculatedScrollTop",
            value: function _getCalculatedScrollTop() {
                var props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state /*: State*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                return Grid._getCalculatedScrollTop(props, state);
            }
        },
        {
            key: "_resetStyleCache",
            value: function _resetStyleCache() {
                var styleCache = this._styleCache;
                var cellCache = this._cellCache;
                var isScrollingOptOut = this.props.isScrollingOptOut;
                // Reset cell and style caches once scrolling stops.
                // This makes Grid simpler to use (since cells commonly change).
                // And it keeps the caches from growing too large.
                // Performance is most sensitive when a user is scrolling.
                // Don't clear visible cells from cellCache if isScrollingOptOut is specified.
                // This keeps the cellCache to a resonable size.
                this._cellCache = {};
                this._styleCache = {};
                // Copy over the visible cell styles so avoid unnecessary re-render.
                for(var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++)for(var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++){
                    var key = "".concat(rowIndex, "-").concat(columnIndex);
                    this._styleCache[key] = styleCache[key];
                    if (isScrollingOptOut) this._cellCache[key] = cellCache[key];
                }
            }
        },
        {
            key: "_updateScrollTopForScrollToRow",
            value: function _updateScrollTopForScrollToRow() {
                var props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state /*: State*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                var stateUpdate = Grid._getScrollTopForScrollToRowStateUpdate(props, state);
                if (stateUpdate) {
                    stateUpdate.needToResetStyleCache = false;
                    this.setState(stateUpdate);
                }
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps /*: Props*/ , prevState /*: State*/ ) /*: $Shape<State>*/ {
                var newState = {};
                if (nextProps.columnCount === 0 && prevState.scrollLeft !== 0 || nextProps.rowCount === 0 && prevState.scrollTop !== 0) {
                    newState.scrollLeft = 0;
                    newState.scrollTop = 0;
                // only use scroll{Left,Top} from props if scrollTo{Column,Row} isn't specified
                // scrollTo{Column,Row} should override scroll{Left,Top}
                } else if (nextProps.scrollLeft !== prevState.scrollLeft && nextProps.scrollToColumn < 0 || nextProps.scrollTop !== prevState.scrollTop && nextProps.scrollToRow < 0) Object.assign(newState, Grid._getScrollToPositionStateUpdate({
                    prevState: prevState,
                    scrollLeft: nextProps.scrollLeft,
                    scrollTop: nextProps.scrollTop
                }));
                var instanceProps = prevState.instanceProps;
                // Initially we should not clearStyleCache
                newState.needToResetStyleCache = false;
                if (nextProps.columnWidth !== instanceProps.prevColumnWidth || nextProps.rowHeight !== instanceProps.prevRowHeight) // Reset cache. set it to {} in render
                newState.needToResetStyleCache = true;
                instanceProps.columnSizeAndPositionManager.configure({
                    cellCount: nextProps.columnCount,
                    estimatedCellSize: Grid._getEstimatedColumnSize(nextProps),
                    cellSizeGetter: Grid._wrapSizeGetter(nextProps.columnWidth)
                });
                instanceProps.rowSizeAndPositionManager.configure({
                    cellCount: nextProps.rowCount,
                    estimatedCellSize: Grid._getEstimatedRowSize(nextProps),
                    cellSizeGetter: Grid._wrapSizeGetter(nextProps.rowHeight)
                });
                if (instanceProps.prevColumnCount === 0 || instanceProps.prevRowCount === 0) {
                    instanceProps.prevColumnCount = 0;
                    instanceProps.prevRowCount = 0;
                }
                // If scrolling is controlled outside this component, clear cache when scrolling stops
                if (nextProps.autoHeight && nextProps.isScrolling === false && instanceProps.prevIsScrolling === true) Object.assign(newState, {
                    isScrolling: false
                });
                var maybeStateA;
                var maybeStateB;
                (0, $20b0a57dcc772bb6$var$_calculateSizeAndPositionDataAndUpdateScrollOffset["default"])({
                    cellCount: instanceProps.prevColumnCount,
                    cellSize: typeof instanceProps.prevColumnWidth === 'number' ? instanceProps.prevColumnWidth : null,
                    computeMetadataCallback: function computeMetadataCallback() {
                        return instanceProps.columnSizeAndPositionManager.resetCell(0);
                    },
                    computeMetadataCallbackProps: nextProps,
                    nextCellsCount: nextProps.columnCount,
                    nextCellSize: typeof nextProps.columnWidth === 'number' ? nextProps.columnWidth : null,
                    nextScrollToIndex: nextProps.scrollToColumn,
                    scrollToIndex: instanceProps.prevScrollToColumn,
                    updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
                        maybeStateA = Grid._getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState);
                    }
                });
                (0, $20b0a57dcc772bb6$var$_calculateSizeAndPositionDataAndUpdateScrollOffset["default"])({
                    cellCount: instanceProps.prevRowCount,
                    cellSize: typeof instanceProps.prevRowHeight === 'number' ? instanceProps.prevRowHeight : null,
                    computeMetadataCallback: function computeMetadataCallback() {
                        return instanceProps.rowSizeAndPositionManager.resetCell(0);
                    },
                    computeMetadataCallbackProps: nextProps,
                    nextCellsCount: nextProps.rowCount,
                    nextCellSize: typeof nextProps.rowHeight === 'number' ? nextProps.rowHeight : null,
                    nextScrollToIndex: nextProps.scrollToRow,
                    scrollToIndex: instanceProps.prevScrollToRow,
                    updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
                        maybeStateB = Grid._getScrollTopForScrollToRowStateUpdate(nextProps, prevState);
                    }
                });
                instanceProps.prevColumnCount = nextProps.columnCount;
                instanceProps.prevColumnWidth = nextProps.columnWidth;
                instanceProps.prevIsScrolling = nextProps.isScrolling === true;
                instanceProps.prevRowCount = nextProps.rowCount;
                instanceProps.prevRowHeight = nextProps.rowHeight;
                instanceProps.prevScrollToColumn = nextProps.scrollToColumn;
                instanceProps.prevScrollToRow = nextProps.scrollToRow;
                // getting scrollBarSize (moved from componentWillMount)
                instanceProps.scrollbarSize = nextProps.getScrollbarSize();
                if (instanceProps.scrollbarSize === undefined) {
                    instanceProps.scrollbarSizeMeasured = false;
                    instanceProps.scrollbarSize = 0;
                } else instanceProps.scrollbarSizeMeasured = true;
                newState.instanceProps = instanceProps;
                return $20b0a57dcc772bb6$var$_objectSpread($20b0a57dcc772bb6$var$_objectSpread($20b0a57dcc772bb6$var$_objectSpread({}, newState), maybeStateA), maybeStateB);
            }
        },
        {
            key: "_getEstimatedColumnSize",
            value: function _getEstimatedColumnSize(props /*: Props*/ ) {
                return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
            }
        },
        {
            key: "_getEstimatedRowSize",
            value: function _getEstimatedRowSize(props /*: Props*/ ) {
                return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
            }
        },
        {
            key: "_getScrollToPositionStateUpdate",
            value: /**
     * Get the updated state after scrolling to
     * scrollLeft and scrollTop
     */ function _getScrollToPositionStateUpdate(_ref9 /*:: */ ) /*: $Shape<State>*/ {
                var prevState = _ref9 /*:: */ .prevState, scrollLeft = _ref9 /*:: */ .scrollLeft, scrollTop = _ref9 /*:: */ .scrollTop;
                var newState /*: Object*/  = {
                    scrollPositionChangeReason: $20b0a57dcc772bb6$var$SCROLL_POSITION_CHANGE_REASONS.REQUESTED
                };
                if (typeof scrollLeft === 'number' && scrollLeft >= 0) {
                    newState.scrollDirectionHorizontal = scrollLeft > prevState.scrollLeft ? $20b0a57dcc772bb6$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : $20b0a57dcc772bb6$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD;
                    newState.scrollLeft = scrollLeft;
                }
                if (typeof scrollTop === 'number' && scrollTop >= 0) {
                    newState.scrollDirectionVertical = scrollTop > prevState.scrollTop ? $20b0a57dcc772bb6$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : $20b0a57dcc772bb6$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD;
                    newState.scrollTop = scrollTop;
                }
                if (typeof scrollLeft === 'number' && scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft || typeof scrollTop === 'number' && scrollTop >= 0 && scrollTop !== prevState.scrollTop) return newState;
                return {};
            }
        },
        {
            key: "_wrapSizeGetter",
            value: function _wrapSizeGetter(value /*: CellSize*/ ) /*: CellSizeGetter*/ {
                return typeof value === 'function' ? value : function() {
                    return value /*: any*/ ;
                };
            }
        },
        {
            key: "_getCalculatedScrollLeft",
            value: function _getCalculatedScrollLeft(nextProps /*: Props*/ , prevState /*: State*/ ) {
                var columnCount = nextProps.columnCount, height = nextProps.height, scrollToAlignment = nextProps.scrollToAlignment, scrollToColumn = nextProps.scrollToColumn, width = nextProps.width;
                var scrollLeft = prevState.scrollLeft, instanceProps = prevState.instanceProps;
                if (columnCount > 0) {
                    var finalColumn = columnCount - 1;
                    var targetIndex = scrollToColumn < 0 ? finalColumn : Math.min(finalColumn, scrollToColumn);
                    var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                    var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
                    return instanceProps.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
                        align: scrollToAlignment,
                        containerSize: width - scrollBarSize,
                        currentOffset: scrollLeft,
                        targetIndex: targetIndex
                    });
                }
                return 0;
            }
        },
        {
            key: "_getScrollLeftForScrollToColumnStateUpdate",
            value: function _getScrollLeftForScrollToColumnStateUpdate(nextProps /*: Props*/ , prevState /*: State*/ ) /*: $Shape<State>*/ {
                var scrollLeft = prevState.scrollLeft;
                var calculatedScrollLeft = Grid._getCalculatedScrollLeft(nextProps, prevState);
                if (typeof calculatedScrollLeft === 'number' && calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) return Grid._getScrollToPositionStateUpdate({
                    prevState: prevState,
                    scrollLeft: calculatedScrollLeft,
                    scrollTop: -1
                });
                return {};
            }
        },
        {
            key: "_getCalculatedScrollTop",
            value: function _getCalculatedScrollTop(nextProps /*: Props*/ , prevState /*: State*/ ) {
                var height = nextProps.height, rowCount = nextProps.rowCount, scrollToAlignment = nextProps.scrollToAlignment, scrollToRow = nextProps.scrollToRow, width = nextProps.width;
                var scrollTop = prevState.scrollTop, instanceProps = prevState.instanceProps;
                if (rowCount > 0) {
                    var finalRow = rowCount - 1;
                    var targetIndex = scrollToRow < 0 ? finalRow : Math.min(finalRow, scrollToRow);
                    var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                    var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
                    return instanceProps.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
                        align: scrollToAlignment,
                        containerSize: height - scrollBarSize,
                        currentOffset: scrollTop,
                        targetIndex: targetIndex
                    });
                }
                return 0;
            }
        },
        {
            key: "_getScrollTopForScrollToRowStateUpdate",
            value: function _getScrollTopForScrollToRowStateUpdate(nextProps /*: Props*/ , prevState /*: State*/ ) /*: $Shape<State>*/ {
                var scrollTop = prevState.scrollTop;
                var calculatedScrollTop = Grid._getCalculatedScrollTop(nextProps, prevState);
                if (typeof calculatedScrollTop === 'number' && calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) return Grid._getScrollToPositionStateUpdate({
                    prevState: prevState,
                    scrollLeft: -1,
                    scrollTop: calculatedScrollTop
                });
                return {};
            }
        }
    ]);
}($20b0a57dcc772bb6$var$React.PureComponent);
(0, $20b0a57dcc772bb6$var$_defineProperty2["default"])($20b0a57dcc772bb6$var$Grid, "defaultProps", {
    'aria-label': 'grid',
    'aria-readonly': true,
    autoContainerWidth: false,
    autoHeight: false,
    autoWidth: false,
    cellRangeRenderer: $20b0a57dcc772bb6$var$_defaultCellRangeRenderer["default"],
    containerRole: 'row',
    containerStyle: {},
    estimatedColumnSize: 100,
    estimatedRowSize: 30,
    getScrollbarSize: $20b0a57dcc772bb6$var$_scrollbarSize["default"],
    noContentRenderer: $20b0a57dcc772bb6$var$renderNull,
    onScroll: function onScroll() {},
    onScrollbarPresenceChange: function onScrollbarPresenceChange() {},
    onSectionRendered: function onSectionRendered() {},
    overscanColumnCount: 0,
    overscanIndicesGetter: $20b0a57dcc772bb6$var$_defaultOverscanIndicesGetter["default"],
    overscanRowCount: 10,
    role: 'grid',
    scrollingResetTimeInterval: $20b0a57dcc772bb6$var$DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
    scrollToAlignment: 'auto',
    scrollToColumn: -1,
    scrollToRow: -1,
    style: {},
    tabIndex: 0,
    isScrollingOptOut: false
});
(0, $b4FuJ.polyfill)($20b0a57dcc772bb6$var$Grid);
var $20b0a57dcc772bb6$var$_default = module.exports["default"] = $20b0a57dcc772bb6$var$Grid;

});
parcelRegister("frReV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "clsx", () => $02e702ca0c5d0b54$export$4f5d2d50c9deca37);
$parcel$export(module.exports, "default", () => $02e702ca0c5d0b54$export$2e2bcd8739ae039);
function $02e702ca0c5d0b54$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $02e702ca0c5d0b54$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $02e702ca0c5d0b54$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $02e702ca0c5d0b54$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $02e702ca0c5d0b54$export$2e2bcd8739ae039 = $02e702ca0c5d0b54$export$4f5d2d50c9deca37;

});

parcelRegister("eLBYA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $ac02e9bef0e704ed$var$calculateSizeAndPositionDataAndUpdateScrollOffset;
/**
 * Helper method that determines when to recalculate row or column metadata.
 */ /*:: type Params<T> = {
  // Number of rows or columns in the current axis
  cellCount: number,

  // Width or height of cells for the current axis
  cellSize: ?number,

  // Method to invoke if cell metadata should be recalculated
  computeMetadataCallback: (props: T) => void,

  // Parameters to pass to :computeMetadataCallback
  computeMetadataCallbackProps: T,

  // Newly updated number of rows or columns in the current axis
  nextCellsCount: number,

  // Newly updated width or height of cells for the current axis
  nextCellSize: ?number,

  // Newly updated scroll-to-index
  nextScrollToIndex: number,

  // Scroll-to-index
  scrollToIndex: number,

  // Callback to invoke if the scroll position should be recalculated
  updateScrollOffsetForScrollToIndex: () => void,
};*/ function $ac02e9bef0e704ed$var$calculateSizeAndPositionDataAndUpdateScrollOffset(_ref /*:: */ ) {
    var cellCount = _ref /*:: */ .cellCount, cellSize = _ref /*:: */ .cellSize, computeMetadataCallback = _ref /*:: */ .computeMetadataCallback, computeMetadataCallbackProps = _ref /*:: */ .computeMetadataCallbackProps, nextCellsCount = _ref /*:: */ .nextCellsCount, nextCellSize = _ref /*:: */ .nextCellSize, nextScrollToIndex = _ref /*:: */ .nextScrollToIndex, scrollToIndex = _ref /*:: */ .scrollToIndex, updateScrollOffsetForScrollToIndex = _ref /*:: */ .updateScrollOffsetForScrollToIndex;
    // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
    // In that event users should use the manual recompute methods to inform of changes.
    if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
        computeMetadataCallback(computeMetadataCallbackProps);
        // Updated cell metadata may have hidden the previous scrolled-to item.
        // In this case we should also update the scrollTop to ensure it stays visible.
        if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) updateScrollOffsetForScrollToIndex();
    }
}

});

parcelRegister("fV4gO", function(module, exports) {
"use strict";

var $7Wmh0 = parcelRequire("7Wmh0");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $b96f7dd786558821$var$_objectWithoutProperties2 = $7Wmh0((parcelRequire("d51j6")));

var $b96f7dd786558821$var$_classCallCheck2 = $7Wmh0((parcelRequire("4r8Q9")));

var $b96f7dd786558821$var$_createClass2 = $7Wmh0((parcelRequire("3Ei40")));

var $b96f7dd786558821$var$_defineProperty2 = $7Wmh0((parcelRequire("ky4V8")));

var $b96f7dd786558821$var$_CellSizeAndPositionManager = $7Wmh0((parcelRequire("iix4f")));

var $6a5fO = parcelRequire("6a5fO");
var $b96f7dd786558821$var$_excluded = [
    "maxScrollSize"
];
/*:: import type {Alignment, CellSizeGetter, VisibleCellRange} from '../types';*/ /*:: type ContainerSizeAndOffset = {
  containerSize: number,
  offset: number,
};*/ /*:: type Params = {
  maxScrollSize?: number,
  cellCount: number,
  cellSizeGetter: CellSizeGetter,
  estimatedCellSize: number,
};*/ /**
 * Browsers have scroll offset limitations (eg Chrome stops scrolling at ~33.5M pixels where as Edge tops out at ~1.5M pixels).
 * After a certain position, the browser won't allow the user to scroll further (even via JavaScript scroll offset adjustments).
 * This util picks a lower ceiling for max size and artificially adjusts positions within to make it transparent for users.
 */ /**
 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
 */ var $b96f7dd786558821$var$ScalingCellSizeAndPositionManager = module.exports["default"] = /*#__PURE__*/ function() {
    function ScalingCellSizeAndPositionManager(_ref /*:: */ ) {
        var _ref$maxScrollSize = _ref /*:: */ .maxScrollSize, maxScrollSize = _ref$maxScrollSize === void 0 ? (0, $6a5fO.getMaxElementSize)() : _ref$maxScrollSize, params = (0, $b96f7dd786558821$var$_objectWithoutProperties2["default"])(_ref /*:: */ , $b96f7dd786558821$var$_excluded);
        (0, $b96f7dd786558821$var$_classCallCheck2["default"])(this, ScalingCellSizeAndPositionManager);
        (0, $b96f7dd786558821$var$_defineProperty2["default"])(this, "_cellSizeAndPositionManager", void 0);
        (0, $b96f7dd786558821$var$_defineProperty2["default"])(this, "_maxScrollSize", void 0);
        // Favor composition over inheritance to simplify IE10 support
        this._cellSizeAndPositionManager = new $b96f7dd786558821$var$_CellSizeAndPositionManager["default"](params);
        this._maxScrollSize = maxScrollSize;
    }
    return (0, $b96f7dd786558821$var$_createClass2["default"])(ScalingCellSizeAndPositionManager, [
        {
            key: "areOffsetsAdjusted",
            value: function areOffsetsAdjusted() /*: boolean*/ {
                return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
            }
        },
        {
            key: "configure",
            value: function configure(params) {
                this._cellSizeAndPositionManager.configure(params);
            }
        },
        {
            key: "getCellCount",
            value: function getCellCount() /*: number*/ {
                return this._cellSizeAndPositionManager.getCellCount();
            }
        },
        {
            key: "getEstimatedCellSize",
            value: function getEstimatedCellSize() /*: number*/ {
                return this._cellSizeAndPositionManager.getEstimatedCellSize();
            }
        },
        {
            key: "getLastMeasuredIndex",
            value: function getLastMeasuredIndex() /*: number*/ {
                return this._cellSizeAndPositionManager.getLastMeasuredIndex();
            }
        },
        {
            key: "getOffsetAdjustment",
            value: function getOffsetAdjustment(_ref2 /*:: */ ) /*: number*/ {
                var containerSize = _ref2 /*:: */ .containerSize, offset = _ref2 /*:: */ .offset;
                var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                var safeTotalSize = this.getTotalSize();
                var offsetPercentage = this._getOffsetPercentage({
                    containerSize: containerSize,
                    offset: offset,
                    totalSize: safeTotalSize
                });
                return Math.round(offsetPercentage * (safeTotalSize - totalSize));
            }
        },
        {
            key: "getSizeAndPositionOfCell",
            value: function getSizeAndPositionOfCell(index /*: number*/ ) {
                return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
            }
        },
        {
            key: "getSizeAndPositionOfLastMeasuredCell",
            value: function getSizeAndPositionOfLastMeasuredCell() {
                return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
            }
        },
        {
            key: "getTotalSize",
            value: function getTotalSize() /*: number*/ {
                return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
            }
        },
        {
            key: "getUpdatedOffsetForIndex",
            value: function getUpdatedOffsetForIndex(_ref3 /*:: */ ) {
                var _ref3$align = _ref3 /*:: */ .align, align = _ref3$align === void 0 ? 'auto' : _ref3$align, containerSize = _ref3 /*:: */ .containerSize, currentOffset = _ref3 /*:: */ .currentOffset, targetIndex = _ref3 /*:: */ .targetIndex;
                currentOffset = this._safeOffsetToOffset({
                    containerSize: containerSize,
                    offset: currentOffset
                });
                var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
                    align: align,
                    containerSize: containerSize,
                    currentOffset: currentOffset,
                    targetIndex: targetIndex
                });
                return this._offsetToSafeOffset({
                    containerSize: containerSize,
                    offset: offset
                });
            }
        },
        {
            key: "getVisibleCellRange",
            value: function getVisibleCellRange(_ref4 /*:: */ ) /*: VisibleCellRange*/ {
                var containerSize = _ref4 /*:: */ .containerSize, offset = _ref4 /*:: */ .offset;
                offset = this._safeOffsetToOffset({
                    containerSize: containerSize,
                    offset: offset
                });
                return this._cellSizeAndPositionManager.getVisibleCellRange({
                    containerSize: containerSize,
                    offset: offset
                });
            }
        },
        {
            key: "resetCell",
            value: function resetCell(index /*: number*/ ) /*: void*/ {
                this._cellSizeAndPositionManager.resetCell(index);
            }
        },
        {
            key: "_getOffsetPercentage",
            value: function _getOffsetPercentage(_ref5 /*:: */ ) {
                var containerSize = _ref5 /*:: */ .containerSize, offset = _ref5 /*:: */ .offset, totalSize = _ref5 /*:: */ .totalSize;
                return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
            }
        },
        {
            key: "_offsetToSafeOffset",
            value: function _offsetToSafeOffset(_ref6 /*:: */ ) /*: number*/ {
                var containerSize = _ref6 /*:: */ .containerSize, offset = _ref6 /*:: */ .offset;
                var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                var safeTotalSize = this.getTotalSize();
                if (totalSize === safeTotalSize) return offset;
                else {
                    var offsetPercentage = this._getOffsetPercentage({
                        containerSize: containerSize,
                        offset: offset,
                        totalSize: totalSize
                    });
                    return Math.round(offsetPercentage * (safeTotalSize - containerSize));
                }
            }
        },
        {
            key: "_safeOffsetToOffset",
            value: function _safeOffsetToOffset(_ref7 /*:: */ ) /*: number*/ {
                var containerSize = _ref7 /*:: */ .containerSize, offset = _ref7 /*:: */ .offset;
                var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                var safeTotalSize = this.getTotalSize();
                if (totalSize === safeTotalSize) return offset;
                else {
                    var offsetPercentage = this._getOffsetPercentage({
                        containerSize: containerSize,
                        offset: offset,
                        totalSize: safeTotalSize
                    });
                    return Math.round(offsetPercentage * (totalSize - containerSize));
                }
            }
        }
    ]);
}();

});
parcelRegister("d51j6", function(module, exports) {

var $h8lLa = parcelRequire("h8lLa");
function $985cc192321cd56d$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $h8lLa(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $985cc192321cd56d$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("iix4f", function(module, exports) {
"use strict";

var $7Wmh0 = parcelRequire("7Wmh0");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $d5238ef52271e2f5$var$_classCallCheck2 = $7Wmh0((parcelRequire("4r8Q9")));

var $d5238ef52271e2f5$var$_createClass2 = $7Wmh0((parcelRequire("3Ei40")));

var $d5238ef52271e2f5$var$_defineProperty2 = $7Wmh0((parcelRequire("ky4V8")));
/*:: import type {Alignment, CellSizeGetter, VisibleCellRange} from '../types';*/ /*:: type CellSizeAndPositionManagerParams = {
  cellCount: number,
  cellSizeGetter: CellSizeGetter,
  estimatedCellSize: number,
};*/ /*:: type ConfigureParams = {
  cellCount: number,
  estimatedCellSize: number,
  cellSizeGetter: CellSizeGetter,
};*/ /*:: type GetUpdatedOffsetForIndex = {
  align: Alignment,
  containerSize: number,
  currentOffset: number,
  targetIndex: number,
};*/ /*:: type GetVisibleCellRangeParams = {
  containerSize: number,
  offset: number,
};*/ /*:: type SizeAndPositionData = {
  offset: number,
  size: number,
};*/ /**
 * Just-in-time calculates and caches size and position information for a collection of cells.
 */ var $d5238ef52271e2f5$var$CellSizeAndPositionManager = module.exports["default"] = /*#__PURE__*/ function() {
    function CellSizeAndPositionManager(_ref /*:: */ ) {
        var cellCount = _ref /*:: */ .cellCount, cellSizeGetter = _ref /*:: */ .cellSizeGetter, estimatedCellSize = _ref /*:: */ .estimatedCellSize;
        (0, $d5238ef52271e2f5$var$_classCallCheck2["default"])(this, CellSizeAndPositionManager);
        // Cache of size and position data for cells, mapped by cell index.
        // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
        (0, $d5238ef52271e2f5$var$_defineProperty2["default"])(this, "_cellSizeAndPositionData", {});
        // Measurements for cells up to this index can be trusted; cells afterward should be estimated.
        (0, $d5238ef52271e2f5$var$_defineProperty2["default"])(this, "_lastMeasuredIndex", -1);
        // Used in deferred mode to track which cells have been queued for measurement.
        (0, $d5238ef52271e2f5$var$_defineProperty2["default"])(this, "_lastBatchedIndex", -1);
        (0, $d5238ef52271e2f5$var$_defineProperty2["default"])(this, "_cellCount", void 0);
        (0, $d5238ef52271e2f5$var$_defineProperty2["default"])(this, "_cellSizeGetter", void 0);
        (0, $d5238ef52271e2f5$var$_defineProperty2["default"])(this, "_estimatedCellSize", void 0);
        this._cellSizeGetter = cellSizeGetter;
        this._cellCount = cellCount;
        this._estimatedCellSize = estimatedCellSize;
    }
    return (0, $d5238ef52271e2f5$var$_createClass2["default"])(CellSizeAndPositionManager, [
        {
            key: "areOffsetsAdjusted",
            value: function areOffsetsAdjusted() {
                return false;
            }
        },
        {
            key: "configure",
            value: function configure(_ref2 /*:: */ ) {
                var cellCount = _ref2 /*:: */ .cellCount, estimatedCellSize = _ref2 /*:: */ .estimatedCellSize, cellSizeGetter = _ref2 /*:: */ .cellSizeGetter;
                this._cellCount = cellCount;
                this._estimatedCellSize = estimatedCellSize;
                this._cellSizeGetter = cellSizeGetter;
            }
        },
        {
            key: "getCellCount",
            value: function getCellCount() /*: number*/ {
                return this._cellCount;
            }
        },
        {
            key: "getEstimatedCellSize",
            value: function getEstimatedCellSize() /*: number*/ {
                return this._estimatedCellSize;
            }
        },
        {
            key: "getLastMeasuredIndex",
            value: function getLastMeasuredIndex() /*: number*/ {
                return this._lastMeasuredIndex;
            }
        },
        {
            key: "getOffsetAdjustment",
            value: function getOffsetAdjustment() {
                return 0;
            }
        },
        {
            key: "getSizeAndPositionOfCell",
            value: function getSizeAndPositionOfCell(index /*: number*/ ) /*: SizeAndPositionData*/ {
                if (index < 0 || index >= this._cellCount) throw Error("Requested index ".concat(index, " is outside of range 0..").concat(this._cellCount));
                if (index > this._lastMeasuredIndex) {
                    var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                    var offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
                    for(var i = this._lastMeasuredIndex + 1; i <= index; i++){
                        var size = this._cellSizeGetter({
                            index: i
                        });
                        // undefined or NaN probably means a logic error in the size getter.
                        // null means we're using CellMeasurer and haven't yet measured a given index.
                        if (size === undefined || isNaN(size)) throw Error("Invalid size returned for cell ".concat(i, " of value ").concat(size));
                        else if (size === null) {
                            this._cellSizeAndPositionData[i] = {
                                offset: offset,
                                size: 0
                            };
                            this._lastBatchedIndex = index;
                        } else {
                            this._cellSizeAndPositionData[i] = {
                                offset: offset,
                                size: size
                            };
                            offset += size;
                            this._lastMeasuredIndex = index;
                        }
                    }
                }
                return this._cellSizeAndPositionData[index];
            }
        },
        {
            key: "getSizeAndPositionOfLastMeasuredCell",
            value: function getSizeAndPositionOfLastMeasuredCell() /*: SizeAndPositionData*/ {
                return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
                    offset: 0,
                    size: 0
                };
            }
        },
        {
            key: "getTotalSize",
            value: function getTotalSize() /*: number*/ {
                var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                var totalSizeOfMeasuredCells = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
                var numUnmeasuredCells = this._cellCount - this._lastMeasuredIndex - 1;
                var totalSizeOfUnmeasuredCells = numUnmeasuredCells * this._estimatedCellSize;
                return totalSizeOfMeasuredCells + totalSizeOfUnmeasuredCells;
            }
        },
        {
            key: "getUpdatedOffsetForIndex",
            value: function getUpdatedOffsetForIndex(_ref3 /*:: */ ) /*: number*/ {
                var _ref3$align = _ref3 /*:: */ .align, align = _ref3$align === void 0 ? 'auto' : _ref3$align, containerSize = _ref3 /*:: */ .containerSize, currentOffset = _ref3 /*:: */ .currentOffset, targetIndex = _ref3 /*:: */ .targetIndex;
                if (containerSize <= 0) return 0;
                var datum = this.getSizeAndPositionOfCell(targetIndex);
                var maxOffset = datum.offset;
                var minOffset = maxOffset - containerSize + datum.size;
                var idealOffset;
                switch(align){
                    case 'start':
                        idealOffset = maxOffset;
                        break;
                    case 'end':
                        idealOffset = minOffset;
                        break;
                    case 'center':
                        idealOffset = maxOffset - (containerSize - datum.size) / 2;
                        break;
                    default:
                        idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
                        break;
                }
                var totalSize = this.getTotalSize();
                return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
            }
        },
        {
            key: "getVisibleCellRange",
            value: function getVisibleCellRange(params /*: GetVisibleCellRangeParams*/ ) /*: VisibleCellRange*/ {
                var containerSize = params.containerSize, offset = params.offset;
                var totalSize = this.getTotalSize();
                if (totalSize === 0) return {};
                var maxOffset = offset + containerSize;
                var start = this._findNearestCell(offset);
                var datum = this.getSizeAndPositionOfCell(start);
                offset = datum.offset + datum.size;
                var stop = start;
                while(offset < maxOffset && stop < this._cellCount - 1){
                    stop++;
                    offset += this.getSizeAndPositionOfCell(stop).size;
                }
                return {
                    start: start,
                    stop: stop
                };
            }
        },
        {
            key: "resetCell",
            value: function resetCell(index /*: number*/ ) /*: void*/ {
                this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
            }
        },
        {
            key: "_binarySearch",
            value: function _binarySearch(high /*: number*/ , low /*: number*/ , offset /*: number*/ ) /*: number*/ {
                while(low <= high){
                    var middle = low + Math.floor((high - low) / 2);
                    var currentOffset = this.getSizeAndPositionOfCell(middle).offset;
                    if (currentOffset === offset) return middle;
                    else if (currentOffset < offset) low = middle + 1;
                    else if (currentOffset > offset) high = middle - 1;
                }
                if (low > 0) return low - 1;
                else return 0;
            }
        },
        {
            key: "_exponentialSearch",
            value: function _exponentialSearch(index /*: number*/ , offset /*: number*/ ) /*: number*/ {
                var interval = 1;
                while(index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset){
                    index += interval;
                    interval *= 2;
                }
                return this._binarySearch(Math.min(index, this._cellCount - 1), Math.floor(index / 2), offset);
            }
        },
        {
            key: "_findNearestCell",
            value: function _findNearestCell(offset /*: number*/ ) /*: number*/ {
                if (isNaN(offset)) throw Error("Invalid offset ".concat(offset, " specified"));
                // Our search algorithms find the nearest match at or below the specified offset.
                // So make sure the offset is at least 0 or no match will be found.
                offset = Math.max(0, offset);
                var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);
                if (lastMeasuredCellSizeAndPosition.offset >= offset) // If we've already measured cells within this range just use a binary search as it's faster.
                return this._binarySearch(lastMeasuredIndex, 0, offset);
                else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
                // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
                // The overall complexity for this approach is O(log n).
                return this._exponentialSearch(lastMeasuredIndex, offset);
            }
        }
    ]);
}();

});

parcelRegister("6a5fO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getMaxElementSize = void 0;
var $47c7c09c9b624780$var$DEFAULT_MAX_ELEMENT_SIZE = 1500000;
var $47c7c09c9b624780$var$CHROME_MAX_ELEMENT_SIZE = 1.67771e7;
var $47c7c09c9b624780$var$isBrowser = function isBrowser() {
    return typeof window !== 'undefined';
};
var $47c7c09c9b624780$var$isChrome = function isChrome() {
    return !!window.chrome;
};
var $47c7c09c9b624780$var$getMaxElementSize = module.exports.getMaxElementSize = function getMaxElementSize() /*: number*/ {
    if ($47c7c09c9b624780$var$isBrowser()) {
        if ($47c7c09c9b624780$var$isChrome()) return $47c7c09c9b624780$var$CHROME_MAX_ELEMENT_SIZE;
    }
    return $47c7c09c9b624780$var$DEFAULT_MAX_ELEMENT_SIZE;
};

});


parcelRegister("es1wu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $a854dca88140780a$var$createCallbackMemoizer;
/**
 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
 */ function $a854dca88140780a$var$createCallbackMemoizer() {
    var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var cachedIndices = {};
    return function(_ref) {
        var callback = _ref.callback, indices = _ref.indices;
        var keys = Object.keys(indices);
        var allInitialized = !requireAllKeys || keys.every(function(key) {
            var value = indices[key];
            return Array.isArray(value) ? value.length > 0 : value >= 0;
        });
        var indexChanged = keys.length !== Object.keys(cachedIndices).length || keys.some(function(key) {
            var cachedValue = cachedIndices[key];
            var value = indices[key];
            return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
        });
        cachedIndices = indices;
        if (allInitialized && indexChanged) callback(indices);
    };
}

});

parcelRegister("lykzA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_BACKWARD = void 0;
module.exports["default"] = $fb0cbb506168d83f$var$defaultOverscanIndicesGetter;
/*:: import type {OverscanIndicesGetterParams, OverscanIndices} from './types';*/ var $fb0cbb506168d83f$var$SCROLL_DIRECTION_BACKWARD = module.exports.SCROLL_DIRECTION_BACKWARD = -1;
var $fb0cbb506168d83f$var$SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_FORWARD = 1;
var $fb0cbb506168d83f$var$SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var $fb0cbb506168d83f$var$SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */ function $fb0cbb506168d83f$var$defaultOverscanIndicesGetter(_ref /*:: */ ) /*: OverscanIndices*/ {
    var cellCount = _ref /*:: */ .cellCount, overscanCellsCount = _ref /*:: */ .overscanCellsCount, scrollDirection = _ref /*:: */ .scrollDirection, startIndex = _ref /*:: */ .startIndex, stopIndex = _ref /*:: */ .stopIndex;
    if (scrollDirection === $fb0cbb506168d83f$var$SCROLL_DIRECTION_FORWARD) return {
        overscanStartIndex: Math.max(0, startIndex),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
    else return {
        overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex)
    };
}

});

parcelRegister("cLBIS", function(module, exports) {
"use strict";

var $7Wmh0 = parcelRequire("7Wmh0");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $94b722c8b4458405$var$updateScrollIndexHelper;

var $94b722c8b4458405$var$_ScalingCellSizeAndPositionManager = $7Wmh0((parcelRequire("fV4gO")));
/*:: import type {Alignment, CellSize} from '../types';*/ /**
 * Helper function that determines when to update scroll offsets to ensure that a scroll-to-index remains visible.
 * This function also ensures that the scroll ofset isn't past the last column/row of cells.
 */ /*:: type Params = {
  // Width or height of cells for the current axis
  cellSize?: CellSize,

  // Manages size and position metadata of cells
  cellSizeAndPositionManager: ScalingCellSizeAndPositionManager,

  // Previous number of rows or columns
  previousCellsCount: number,

  // Previous width or height of cells
  previousCellSize: CellSize,

  previousScrollToAlignment: Alignment,

  // Previous scroll-to-index
  previousScrollToIndex: number,

  // Previous width or height of the virtualized container
  previousSize: number,

  // Current scrollLeft or scrollTop
  scrollOffset: number,

  scrollToAlignment: Alignment,

  // Scroll-to-index
  scrollToIndex: number,

  // Width or height of the virtualized container
  size: number,

  sizeJustIncreasedFromZero: boolean,

  // Callback to invoke with an scroll-to-index value
  updateScrollIndexCallback: (index: number) => void,
};*/ function $94b722c8b4458405$var$updateScrollIndexHelper(_ref /*:: */ ) {
    var cellSize = _ref /*:: */ .cellSize, cellSizeAndPositionManager = _ref /*:: */ .cellSizeAndPositionManager, previousCellsCount = _ref /*:: */ .previousCellsCount, previousCellSize = _ref /*:: */ .previousCellSize, previousScrollToAlignment = _ref /*:: */ .previousScrollToAlignment, previousScrollToIndex = _ref /*:: */ .previousScrollToIndex, previousSize = _ref /*:: */ .previousSize, scrollOffset = _ref /*:: */ .scrollOffset, scrollToAlignment = _ref /*:: */ .scrollToAlignment, scrollToIndex = _ref /*:: */ .scrollToIndex, size = _ref /*:: */ .size, sizeJustIncreasedFromZero = _ref /*:: */ .sizeJustIncreasedFromZero, updateScrollIndexCallback = _ref /*:: */ .updateScrollIndexCallback;
    var cellCount = cellSizeAndPositionManager.getCellCount();
    var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
    var sizeHasChanged = size !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize;
    // If we have a new scroll target OR if height/row-height has changed,
    // We should ensure that the scroll target is visible.
    if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) updateScrollIndexCallback(scrollToIndex);
    else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) // We need to ensure that the current scroll offset is still within the collection's range.
    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
    // Just check to make sure we're still okay.
    // Only adjust the scroll position if we've scrolled below the last set of rows.
    {
        if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) updateScrollIndexCallback(cellCount - 1);
    }
}

});

parcelRegister("gvLQZ", function(module, exports) {
"use strict";

var $7Wmh0 = parcelRequire("7Wmh0");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $c054a94fcb0e3cad$var$defaultCellRangeRenderer;

var $c054a94fcb0e3cad$var$_react = $7Wmh0((parcelRequire("eJOHy")));
/*:: import type {CellRangeRendererParams} from './types';*/ /**
 * Default implementation of cellRangeRenderer used by Grid.
 * This renderer supports cell-caching while the user is scrolling.
 */ function $c054a94fcb0e3cad$var$defaultCellRangeRenderer(_ref /*:: */ ) {
    var cellCache = _ref /*:: */ .cellCache, cellRenderer = _ref /*:: */ .cellRenderer, columnSizeAndPositionManager = _ref /*:: */ .columnSizeAndPositionManager, columnStartIndex = _ref /*:: */ .columnStartIndex, columnStopIndex = _ref /*:: */ .columnStopIndex, deferredMeasurementCache = _ref /*:: */ .deferredMeasurementCache, horizontalOffsetAdjustment = _ref /*:: */ .horizontalOffsetAdjustment, isScrolling = _ref /*:: */ .isScrolling, isScrollingOptOut = _ref /*:: */ .isScrollingOptOut, parent = _ref /*:: */ .parent, rowSizeAndPositionManager = _ref /*:: */ .rowSizeAndPositionManager, rowStartIndex = _ref /*:: */ .rowStartIndex, rowStopIndex = _ref /*:: */ .rowStopIndex, styleCache = _ref /*:: */ .styleCache, verticalOffsetAdjustment = _ref /*:: */ .verticalOffsetAdjustment, visibleColumnIndices = _ref /*:: */ .visibleColumnIndices, visibleRowIndices = _ref /*:: */ .visibleRowIndices;
    var renderedCells = [];
    // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
    // User cannot scroll beyond these size limitations.
    // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
    // We should never cache styles for compressed offsets though as this can lead to bugs.
    // See issue #576 for more.
    var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();
    var canCacheStyle = !isScrolling && !areOffsetsAdjusted;
    for(var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++){
        var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);
        for(var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++){
            var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
            var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
            var key = "".concat(rowIndex, "-").concat(columnIndex);
            var style = void 0;
            // Cache style objects so shallow-compare doesn't re-render unnecessarily.
            if (canCacheStyle && styleCache[key]) style = styleCache[key];
            else // In deferred mode, cells will be initially rendered before we know their size.
            // Don't interfere with CellMeasurer's measurements by setting an invalid size.
            if (deferredMeasurementCache && !deferredMeasurementCache.has(rowIndex, columnIndex)) // Position not-yet-measured cells at top/left 0,0,
            // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
            // Positioning them further to the right/bottom influences their measured size.
            style = {
                height: 'auto',
                left: 0,
                position: 'absolute',
                top: 0,
                width: 'auto'
            };
            else {
                style = {
                    height: rowDatum.size,
                    left: columnDatum.offset + horizontalOffsetAdjustment,
                    position: 'absolute',
                    top: rowDatum.offset + verticalOffsetAdjustment,
                    width: columnDatum.size
                };
                styleCache[key] = style;
            }
            var cellRendererParams = {
                columnIndex: columnIndex,
                isScrolling: isScrolling,
                isVisible: isVisible,
                key: key,
                parent: parent,
                rowIndex: rowIndex,
                style: style
            };
            var renderedCell = void 0;
            // Avoid re-creating cells while scrolling.
            // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
            // If a scroll is in progress- cache and reuse cells.
            // This cache will be thrown away once scrolling completes.
            // However if we are scaling scroll positions and sizes, we should also avoid caching.
            // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
            // For more info refer to issue #395
            //
            // If isScrollingOptOut is specified, we always cache cells.
            // For more info refer to issue #1028
            if ((isScrollingOptOut || isScrolling) && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
                if (!cellCache[key]) cellCache[key] = cellRenderer(cellRendererParams);
                renderedCell = cellCache[key];
            // If the user is no longer scrolling, don't cache cells.
            // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
            } else renderedCell = cellRenderer(cellRendererParams);
            if (renderedCell == null || renderedCell === false) continue;
            if (!renderedCell.props.role) renderedCell = /*#__PURE__*/ $c054a94fcb0e3cad$var$_react["default"].cloneElement(renderedCell, {
                role: 'gridcell'
            });
            renderedCells.push(renderedCell);
        }
    }
    return renderedCells;
}
function $c054a94fcb0e3cad$var$warnAboutMissingStyle(parent, renderedCell) {}

});

parcelRegister("5YzJ9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $459e450d69d7f007$export$2e2bcd8739ae039);

var $9MCmp = parcelRequire("9MCmp");
var $459e450d69d7f007$var$size;
function $459e450d69d7f007$export$2e2bcd8739ae039(recalc) {
    if (!$459e450d69d7f007$var$size && $459e450d69d7f007$var$size !== 0 || recalc) {
        if (0, $9MCmp.default) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $459e450d69d7f007$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $459e450d69d7f007$var$size;
}

});
parcelRegister("9MCmp", function(module, exports) {
$parcel$export(module.exports, "default", () => $71f65a509935e3e4$export$2e2bcd8739ae039);
var $71f65a509935e3e4$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

});


parcelRegister("b4FuJ", function(module, exports) {
$parcel$export(module.exports, "polyfill", () => $8100416702899bbe$export$cea1c58a6db52bca);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $8100416702899bbe$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $8100416702899bbe$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $8100416702899bbe$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$8100416702899bbe$var$componentWillMount.__suppressDeprecationWarning = true;
$8100416702899bbe$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$8100416702899bbe$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $8100416702899bbe$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $8100416702899bbe$var$componentWillMount;
        prototype.componentWillReceiveProps = $8100416702899bbe$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $8100416702899bbe$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

});

parcelRegister("8nF5v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.requestAnimationTimeout = module.exports.cancelAnimationTimeout = void 0;

var $jGSet = parcelRequire("jGSet");
/*:: export type AnimationTimeoutId = {
  id: number,
};*/ var $61a057ded4404cf5$var$cancelAnimationTimeout = module.exports.cancelAnimationTimeout = function cancelAnimationTimeout(frame /*: AnimationTimeoutId*/ ) {
    return (0, $jGSet.caf)(frame.id);
};
/**
 * Recursively calls requestAnimationFrame until a specified delay has been met or exceeded.
 * When the delay time has been reached the function you're timing out will be called.
 *
 * Credit: Joe Lambert (https://gist.github.com/joelambert/1002116#file-requesttimeout-js)
 */ var $61a057ded4404cf5$var$requestAnimationTimeout = module.exports.requestAnimationTimeout = function requestAnimationTimeout(callback /*: Function*/ , delay /*: number*/ ) /*: AnimationTimeoutId*/ {
    var start;
    // wait for end of processing current event handler, because event handler may be long
    Promise.resolve().then(function() {
        start = Date.now();
    });
    var _timeout = function timeout() {
        if (Date.now() - start >= delay) callback.call();
        else frame.id = (0, $jGSet.raf)(_timeout);
    };
    var frame /*: AnimationTimeoutId*/  = {
        id: (0, $jGSet.raf)(_timeout)
    };
    return frame;
};

});
parcelRegister("jGSet", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.raf = module.exports.caf = void 0;
/*:: type Callback = (timestamp: number) => void;*/ /*:: type CancelAnimationFrame = (requestId: number) => void;*/ /*:: type RequestAnimationFrame = (callback: Callback) => number;*/ // Properly handle server-side rendering.
var $e55c01fe7136667a$var$win;
if (typeof window !== 'undefined') $e55c01fe7136667a$var$win = window;
else if (typeof self !== 'undefined') $e55c01fe7136667a$var$win = self;
else $e55c01fe7136667a$var$win = {};
// requestAnimationFrame() shim by Paul Irish
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
var $e55c01fe7136667a$var$request = $e55c01fe7136667a$var$win.requestAnimationFrame || $e55c01fe7136667a$var$win.webkitRequestAnimationFrame || $e55c01fe7136667a$var$win.mozRequestAnimationFrame || $e55c01fe7136667a$var$win.oRequestAnimationFrame || $e55c01fe7136667a$var$win.msRequestAnimationFrame || function(callback /*: Callback*/ ) /*: RequestAnimationFrame*/ {
    return $e55c01fe7136667a$var$win /*: any*/ .setTimeout(callback, 1000 / 60);
};
var $e55c01fe7136667a$var$cancel = $e55c01fe7136667a$var$win.cancelAnimationFrame || $e55c01fe7136667a$var$win.webkitCancelAnimationFrame || $e55c01fe7136667a$var$win.mozCancelAnimationFrame || $e55c01fe7136667a$var$win.oCancelAnimationFrame || $e55c01fe7136667a$var$win.msCancelAnimationFrame || function(id /*: number*/ ) {
    $e55c01fe7136667a$var$win /*: any*/ .clearTimeout(id);
};
var $e55c01fe7136667a$var$raf /*: RequestAnimationFrame*/  = module.exports.raf = $e55c01fe7136667a$var$request /*: any*/ ;
var $e55c01fe7136667a$var$caf /*: CancelAnimationFrame*/  = module.exports.caf = $e55c01fe7136667a$var$cancel /*: any*/ ;

});



parcelRegister("dA48H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_BACKWARD = void 0;
module.exports["default"] = $9e31d91d2b4dbed8$var$defaultOverscanIndicesGetter;
/*:: import type {OverscanIndicesGetterParams, OverscanIndices} from './types';*/ var $9e31d91d2b4dbed8$var$SCROLL_DIRECTION_BACKWARD = module.exports.SCROLL_DIRECTION_BACKWARD = -1;
var $9e31d91d2b4dbed8$var$SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_FORWARD = 1;
var $9e31d91d2b4dbed8$var$SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var $9e31d91d2b4dbed8$var$SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */ function $9e31d91d2b4dbed8$var$defaultOverscanIndicesGetter(_ref /*:: */ ) /*: OverscanIndices*/ {
    var cellCount = _ref /*:: */ .cellCount, overscanCellsCount = _ref /*:: */ .overscanCellsCount, scrollDirection = _ref /*:: */ .scrollDirection, startIndex = _ref /*:: */ .startIndex, stopIndex = _ref /*:: */ .stopIndex;
    // Make sure we render at least 1 cell extra before and after (except near boundaries)
    // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
    // For more info see issues #625
    overscanCellsCount = Math.max(1, overscanCellsCount);
    if (scrollDirection === $9e31d91d2b4dbed8$var$SCROLL_DIRECTION_FORWARD) return {
        overscanStartIndex: Math.max(0, startIndex - 1),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
    else return {
        overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex + 1)
    };
}

});




parcelRegister("ajlZ9", function(module, exports) {
$parcel$export(module.exports, "ListRow", () => $eb23442c0a9644c5$export$c36f87108246a02a);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $eb23442c0a9644c5$export$c36f87108246a02a = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, measure: measure, index: index, style: style, isVisible: isVisible, isScrolling: isScrolling, onMouseMove: onMouseMove }, ref)=>{
    const childElementRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        // Do not measure if the row is not visible or is scrolling for performance reasons.
        if (!childElementRef.current || !isVisible || isScrolling) return;
        const observer = new ResizeObserver(()=>measure());
        observer.observe(childElementRef.current);
        return ()=>observer.disconnect();
    }, [
        isScrolling,
        isVisible,
        measure
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: ref,
        style: style,
        "data-index": index,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            ref: childElementRef,
            "data-testid": `list-item-height-observed-${index}`,
            onMouseMove: onMouseMove,
            children: children
        })
    }));
});

});

parcelRegister("3mtr1", function(module, exports) {
$parcel$export(module.exports, "MoreOptions", () => $1736df5f7314d253$export$76421314069e32e1);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $7saMl = parcelRequire("7saMl");
var $6YEko = parcelRequire("6YEko");

const $1736df5f7314d253$var$buttonStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button:hover': {
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $7bb4c1736002a04a$export$3e51e8f1440314ba)})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button:focus': {
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $7bb4c1736002a04a$export$3e51e8f1440314ba)})`
    }
});
const $1736df5f7314d253$export$76421314069e32e1 = ({ onClick: onClick, isFocused: isFocused, title: title, ariaLabel: ariaLabel, iconBefore: iconBefore })=>{
    const ref = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (isFocused && ref.current) ref.current.focus();
    }, [
        isFocused
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!ref.current) return;
        const { current: element } = ref;
        const handleEnter = (e)=>{
            if (e.key === 'Enter') {
                onClick();
                // Prevent keydown listener in TypeaheadList from handling Enter pressed
                e.stopPropagation();
            } else if (e.key === 'Tab') {
                // TypeaheadList will try to insert selected item on Tab press
                // hence stop propagation to prevent that and treat this as noop
                e.stopPropagation();
                e.preventDefault();
            }
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', handleEnter);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', handleEnter);
        };
    });
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $6YEko.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $1736df5f7314d253$var$buttonStyles
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $7saMl.default), {
        ref: ref,
        onClick: onClick,
        iconBefore: iconBefore,
        "aria-label": ariaLabel,
        testId: "type-ahead-more-options-button"
    }, title)));
};

});

parcelRegister("9aOK1", function(module, exports) {
$parcel$export(module.exports, "TypeAheadListItem", () => $29897f3555837a9c$export$913373331e95c13e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $lRq8t = parcelRequire("lRq8t");

var $cxXTK = parcelRequire("cxXTK");

var $ehOis = parcelRequire("ehOis");

var $7k8dr = parcelRequire("7k8dr");
var $4drex = parcelRequire("4drex");

var $7yBx7 = parcelRequire("7yBx7");

var $2dMzB = parcelRequire("2dMzB");

var $7saMl = parcelRequire("7saMl");

var $eGOwo = parcelRequire("eGOwo");


var $cbSL1 = parcelRequire("cbSL1");

var $6fs4r = parcelRequire("6fs4r");
function $29897f3555837a9c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $29897f3555837a9c$export$cfa784b45fc7b21d = /*#__PURE__*/ (0, $1NIU8.css)({
    width: "var(--ds-space-500, 40px)",
    height: "var(--ds-space-500, 40px)",
    overflow: 'hidden',
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, rgba(223, 225, 229, 0.5))"}`,
    borderRadius: "var(--ds-radius-small, 3px)",
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    div: {
        width: "var(--ds-space-500, 40px)",
        height: "var(--ds-space-500, 40px)"
    }
});
const $29897f3555837a9c$var$itemIconSizeUpdated = {
    name: "1pc97kj",
    styles: "width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);div{width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);}"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $29897f3555837a9c$var$itemBody = {
    name: "dblrt7",
    styles: "display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-between"
};
const $29897f3555837a9c$var$itemText = /*#__PURE__*/ (0, $1NIU8.css)({
    whiteSpace: 'initial',
    color: `${`var(--ds-text, ${(0, $7bb4c1736002a04a$export$7d61b15e0da132af)})`}`
});
const $29897f3555837a9c$var$itemTitle = {
    name: "1v4psb4",
    styles: "line-height:1.4"
};
const $29897f3555837a9c$var$itemTitleOverride = {
    name: "1th4nak",
    styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $29897f3555837a9c$var$itemDescription = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography
    fontSize: `${(0, $7yBx7.relativeFontSizeToBase16)(12)};`,
    color: `${`var(--ds-text-subtlest, ${(0, $7bb4c1736002a04a$export$f563ee71e9ee74cd)})`};`,
    marginTop: `${"var(--ds-space-050, 4px)"};`
});
// when cleaning up FG `platform_editor_typeahead_description_text_colour`
// replace above color with this and delete itemDescriptionColor
const $29897f3555837a9c$var$itemDescriptionColor = /*#__PURE__*/ (0, $1NIU8.css)({
    color: `${"var(--ds-text-subtle, #44546F)"};`
});
const $29897f3555837a9c$var$itemDescriptionOverride = {
    name: "7ynmig",
    styles: "font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);margin-top:0"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $29897f3555837a9c$var$itemAfter = {
    name: "ou8xsw",
    styles: "flex:0 0 auto"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $29897f3555837a9c$var$customRenderItemDivStyle = /*#__PURE__*/ (0, $1NIU8.css)("overflow:hidden;&:focus{box-shadow:inset 2px 0px 0px ", `var(--ds-border-focused, ${(0, $7bb4c1736002a04a$export$b3de0ae08da2ce64)})`, ";background-color:", `var(--ds-background-neutral-subtle-hovered, ${(0, $7bb4c1736002a04a$export$3e51e8f1440314ba)})`, ";outline:none;}");
/**
 * This CSS emulates the desired behaviour with :focus-visible for firefox.
 * Firefox unfortunately does not register keyboard focus if user mouseDown and drag a typeahead item
 * resulting in focus-visible style not drawn.
 */ const $29897f3555837a9c$var$selectionFrame = {
    '& > button:focus': {
        boxShadow: `inset 2px 0px 0px ${`var(--ds-border-focused, ${(0, $7bb4c1736002a04a$export$b3de0ae08da2ce64)})`};`,
        backgroundColor: `${`var(--ds-background-neutral-subtle-hovered, ${(0, $7bb4c1736002a04a$export$3e51e8f1440314ba)})`}`,
        outline: 'none',
        '&:active': {
            boxShadow: 'none'
        }
    },
    '& > button:hover': {
        backgroundColor: 'inherit',
        outline: 'none'
    }
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $29897f3555837a9c$var$selectedStyle = /*#__PURE__*/ (0, $1NIU8.css)("background-color:", `var(--ds-background-neutral-subtle-hovered, ${(0, $7bb4c1736002a04a$export$3e51e8f1440314ba)})`, ";box-shadow:inset 2px 0px 0px ", `var(--ds-border-focused, ${(0, $7bb4c1736002a04a$export$b3de0ae08da2ce64)})`, ";");
const $29897f3555837a9c$var$disabledStyle = {
    name: "16lzvw8",
    styles: "color:var(--ds-text-disabled, #091E424F)"
};
const $29897f3555837a9c$var$FallbackIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ label: label })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $ehOis.default), null);
});
const $29897f3555837a9c$var$noop = ()=>{};
const $29897f3555837a9c$var$CustomItemComponentWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo((props)=>{
    const { customRenderItem: customRenderItem, isSelected: isSelected, itemIsDisabled: itemIsDisabled, ariaLabel: ariaLabel, itemsLength: itemsLength, customItemRef: customItemRef, insertSelectedItem: insertSelectedItem, itemIndex: itemIndex } = props;
    const Comp = customRenderItem;
    const listItemClasses = (0, $eJOHy.useMemo)(()=>{
        return [
            $29897f3555837a9c$var$customRenderItemDivStyle,
            isSelected && !itemIsDisabled && $29897f3555837a9c$var$selectedStyle,
            itemIsDisabled && $29897f3555837a9c$var$disabledStyle
        ];
    }, [
        isSelected,
        itemIsDisabled
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        "aria-selected": isSelected,
        role: "option",
        "aria-label": ariaLabel,
        "aria-setsize": itemsLength,
        "aria-posinset": (0, $cbSL1.expValEquals)('platform_editor_fix_a11y_aria_posinset_0', 'isEnabled', true) ? itemIndex + 1 : itemIndex,
        tabIndex: 0,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: listItemClasses,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `ak-typeahead-item ${isSelected ? 'typeahead-selected-item' : ''}`,
        //CSS classes added for test cases purpose
        ref: customItemRef
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        "aria-hidden": true
    }, /*#__PURE__*/ (0, $1NIU8.jsx)(Comp, {
        onClick: insertSelectedItem,
        isSelected: false,
        onHover: $29897f3555837a9c$var$noop
    })));
});
const $29897f3555837a9c$export$913373331e95c13e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ item: item, itemsLength: itemsLength, selectedIndex: selectedIndex, onItemClick: onItemClick, itemIndex: itemIndex, ariaLabel: ariaLabel, moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled, api: api, firstOnlineSupportedIndex: firstOnlineSupportedIndex })=>{
    const { connectivityMode: connectivityMode } = (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'connectivity'
    ], (states)=>{
        return {
            connectivityMode: states.connectivityState?.mode
        };
    });
    const isItemDisabled = (item)=>connectivityMode === 'offline' && (item?.isDisabledOffline ?? false);
    const itemIsDisabled = isItemDisabled(item);
    const isFirstEnabledIndex = connectivityMode === 'offline' && itemIndex === firstOnlineSupportedIndex && selectedIndex === -1;
    /**
   * To select and highlight the first Item when no item is selected
   * However selectedIndex remains -1, So that user does not skip the first item when down arrow key is used from typeahead query(inputQuery.tsx)
   */ let isSelected = false;
    // Feature gated - connectivity is only available on desktop and behind a feature gate on full page mode
    if (connectivityMode === undefined) isSelected = itemIndex === selectedIndex || selectedIndex === -1 && itemIndex === 0;
    else isSelected = itemIndex === selectedIndex || selectedIndex === -1 && (itemIndex === 0 || isFirstEnabledIndex) && !itemIsDisabled;
    // Assistive text
    const intl = (0, $lRq8t.default)();
    const descriptionText = item.description ? `${item.description}.` : '';
    const shortcutText = item.keyshortcut ? ` ${intl.formatMessage((0, $4drex.typeAheadListMessages).shortcutLabel)} ${item.keyshortcut}.` : '';
    const descriptionId = `typeahead-item-description-${itemIndex}`;
    const { icon: icon, title: title, render: customRenderItem } = item;
    const elementIcon = (0, $eJOHy.useMemo)(()=>{
        return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: [
                $29897f3555837a9c$export$cfa784b45fc7b21d,
                moreElementsInQuickInsertViewEnabled && $29897f3555837a9c$var$itemIconSizeUpdated
            ]
        }, icon ? icon() : /*#__PURE__*/ (0, $1NIU8.jsx)($29897f3555837a9c$var$FallbackIcon, {
            label: title
        }));
    }, [
        icon,
        title,
        moreElementsInQuickInsertViewEnabled
    ]);
    const insertSelectedItem = (0, $eJOHy.useCallback)(()=>{
        if (itemIsDisabled) return;
        onItemClick((0, $7k8dr.SelectItemMode).SELECTED, itemIndex);
    }, [
        onItemClick,
        itemIndex,
        itemIsDisabled
    ]);
    const customItemRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const buttonItemRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const shouldUpdateFocus = selectedIndex === itemIndex && !isFirstEnabledIndex;
    const listItemClasses = (0, $eJOHy.useMemo)(()=>{
        return [
            $29897f3555837a9c$var$selectionFrame,
            isSelected && !itemIsDisabled && $29897f3555837a9c$var$selectedStyle
        ];
    }, [
        isSelected,
        itemIsDisabled
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (shouldUpdateFocus) customItemRef?.current?.focus();
    }, [
        customItemRef,
        shouldUpdateFocus
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (shouldUpdateFocus) buttonItemRef?.current?.focus();
    }, [
        buttonItemRef,
        shouldUpdateFocus
    ]);
    if (customRenderItem) return /*#__PURE__*/ (0, $1NIU8.jsx)($29897f3555837a9c$var$CustomItemComponentWrapper, {
        itemIsDisabled: itemIsDisabled,
        customRenderItem: customRenderItem,
        isSelected: isSelected,
        ariaLabel: ariaLabel,
        itemsLength: itemsLength,
        customItemRef: customItemRef,
        insertSelectedItem: insertSelectedItem,
        itemIndex: itemIndex
    });
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: listItemClasses
    }, (descriptionText || shortcutText) && (0, $eGOwo.fg)('platform_editor_a11y_fix_aria_description') && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $6fs4r.default), {
        id: descriptionId
    }, descriptionText, " ", shortcutText), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $7saMl.default), {
        onClick: insertSelectedItem,
        iconBefore: elementIcon,
        isSelected: isSelected,
        "aria-selected": isSelected,
        "aria-label": title,
        "aria-describedby": (descriptionText || shortcutText) && (0, $eGOwo.fg)('platform_editor_a11y_fix_aria_description') ? descriptionId : undefined,
        "aria-setsize": itemsLength,
        "aria-posinset": (0, $cbSL1.expValEquals)('platform_editor_fix_a11y_aria_posinset_0', 'isEnabled', true) ? itemIndex + 1 : itemIndex,
        role: "option",
        ref: buttonItemRef,
        isDisabled: itemIsDisabled,
        // @ts-ignore
        css: listItemClasses
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        "aria-hidden": true
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            $29897f3555837a9c$var$itemText
        ]
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $29897f3555837a9c$var$itemBody
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            $29897f3555837a9c$var$itemTitle,
            moreElementsInQuickInsertViewEnabled && $29897f3555837a9c$var$itemTitleOverride,
            itemIsDisabled && $29897f3555837a9c$var$disabledStyle
        ]
    }, item.title), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $29897f3555837a9c$var$itemAfter
    }, item.keyshortcut && /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: (0, $2dMzB.shortcutStyle)
    }, item.keyshortcut))), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            $29897f3555837a9c$var$itemDescription,
            (0, $eGOwo.fg)('platform_editor_typeahead_description_text_colour') && $29897f3555837a9c$var$itemDescriptionColor,
            moreElementsInQuickInsertViewEnabled && $29897f3555837a9c$var$itemDescriptionOverride,
            itemIsDisabled && $29897f3555837a9c$var$disabledStyle
        ]
    }, item.description))))));
});

});
parcelRegister("ehOis", function(module, exports) {
$parcel$export(module.exports, "default", () => $62cead323ec6543a$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $9phuu = parcelRequire("9phuu");
function $62cead323ec6543a$export$2e2bcd8739ae039() {
    const { iconThemed: iconThemed } = (0, $9phuu.useIconThemed)();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        focusable: "false",
        "aria-hidden": true,
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        x1: "-26.046%",
                        y1: "100%",
                        x2: "62.626%",
                        y2: "0%",
                        id: "fallback-a",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#B3BAC5",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#A5ADBA",
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        x1: "-12.24%",
                        y1: "100%",
                        x2: "82.44%",
                        y2: "0%",
                        id: "fallback-b",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#5A6977",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#454F59",
                                offset: "100%"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        fill: iconThemed({
                            light: '#FFF',
                            dark: '#161A1D'
                        }),
                        d: "M0 0h40v40H0z"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        fill: iconThemed({
                            light: '#DFE1E6',
                            dark: '#738496'
                        }),
                        d: "M20 16h12v12H20z"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        fill: iconThemed({
                            light: 'url(#fallback-a)',
                            dark: 'url(#fallback-b)'
                        }),
                        d: "M8 16h12v12H8z"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M20 16c-4 .5-6.029 2.5-6.086 6-.057 3.5-2.028 5.5-5.914 6h12V16z",
                        fill: iconThemed({
                            light: '#A5ADBA',
                            dark: '#454F59'
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        fill: iconThemed({
                            light: '#B3BAC5',
                            dark: '#454F59'
                        }),
                        d: "M17.5 13h5v3h-5z"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        fill: iconThemed({
                            light: '#A5ADBA',
                            dark: '#454F59'
                        }),
                        d: "M10 13h5v3h-5z"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        fill: iconThemed({
                            light: '#DFE1E6',
                            dark: '#738496'
                        }),
                        d: "M25 13h5v3h-5z"
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("9phuu", function(module, exports) {
$parcel$export(module.exports, "useIconThemed", () => $ab6df4a546216f42$export$a38bb9a8c9e5bc30);

var $58yRG = parcelRequire("58yRG");
const $ab6df4a546216f42$export$a38bb9a8c9e5bc30 = ()=>{
    const { colorMode: colorMode } = (0, $58yRG.default)();
    return {
        iconThemed: (colors)=>{
            return colorMode && colorMode === 'dark' ? colors['dark'] : colors['light'];
        }
    };
};

});










parcelRegister("MFHY3", function(module, exports) {
$parcel$export(module.exports, "useMemoisedFeatures", () => $815248c5478d3dd5$export$67693d05a6051899);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");
const $815248c5478d3dd5$var$featuresAreEqual = (_previousFeatures, _currentFeatures)=>{
    // If both are references point to the same object, return true
    if (_previousFeatures === _currentFeatures) return true;
    const previousFeatures = _previousFeatures || {};
    const currentFeatures = _currentFeatures || {};
    if (Object.keys(previousFeatures).length !== Object.keys(currentFeatures).length) return false;
    // if any properties has changed, return false
    for(const key in previousFeatures){
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(previousFeatures[key], currentFeatures[key])) return false;
    }
    return true;
};
const $815248c5478d3dd5$export$67693d05a6051899 = (features)=>{
    const previousFeatures = (0, $eJOHy.useRef)();
    const shouldUpdate = !$815248c5478d3dd5$var$featuresAreEqual(previousFeatures.current, features);
    if (shouldUpdate) previousFeatures.current = features;
    return previousFeatures.current;
};

});



parcelRegister("khGAc", function(module, exports) {
$parcel$export(module.exports, "CommentEditor", () => $476d35cac9ba45d2$export$4153d6fbc2386422);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lmw0x = parcelRequire("lmw0x");

var $bXaOH = parcelRequire("bXaOH");
const $476d35cac9ba45d2$export$4153d6fbc2386422 = (props)=>{
    const { onChange: onChange, defaultValue: defaultValue, features: features, isDisabled: isDisabled, onSave: onSave, onCancel: onCancel } = props.forgeDoc.props;
    const { preset: preset, editorApi: editorApi } = (0, $bXaOH.usePresetByFeatures)('comment', features);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lmw0x.CommentEditor), {
        disabled: isDisabled,
        defaultValue: defaultValue,
        preset: preset,
        onSave: onSave ? ()=>{
            editorApi?.core.actions.requestDocument((jsonDocNode)=>{
                onSave?.(jsonDocNode);
            });
        } : undefined,
        onCancel: onCancel ? ()=>onCancel() : undefined,
        onChange: ()=>{
            editorApi?.core.actions.requestDocument((jsonDocNode)=>{
                onChange?.(jsonDocNode);
            });
        }
    });
};

});
parcelRegister("lmw0x", function(module, exports) {
$parcel$export(module.exports, "CommentEditor", () => $7e58274ea51addbf$export$4153d6fbc2386422);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lGWJD = parcelRequire("lGWJD");

var $oN7a7 = parcelRequire("oN7a7");
function $7e58274ea51addbf$export$4153d6fbc2386422(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lGWJD.CoreEditor), {
        ...props,
        appearance: "comment",
        AppearanceComponent: (0, $oN7a7.CommentEditorWithIntl)
    });
}

});
parcelRegister("oN7a7", function(module, exports) {
$parcel$export(module.exports, "CommentEditorWithIntl", () => $60fe10be5cfe3118$export$7b9f3a51cd0c1967);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $k9JrM = parcelRequire("k9JrM");

var $lRq8t = parcelRequire("lRq8t");

var $48q59 = parcelRequire("48q59");

var $5CSKW = parcelRequire("5CSKW");

var $bSToC = parcelRequire("bSToC");
var $cxXTK = parcelRequire("cxXTK");

var $h2yqz = parcelRequire("h2yqz");

var $2bEPZ = parcelRequire("2bEPZ");

var $baHgw = parcelRequire("baHgw");

var $7yBx7 = parcelRequire("7yBx7");

var $eGOwo = parcelRequire("eGOwo");

var $cbSL1 = parcelRequire("cbSL1");

var $g5n6x = parcelRequire("g5n6x");

var $g0hAu = parcelRequire("g0hAu");

var $7XjxI = parcelRequire("7XjxI");

var $gyhYD = parcelRequire("gyhYD");

var $8NyYn = parcelRequire("8NyYn");

var $83GXu = parcelRequire("83GXu");

var $52GJU = parcelRequire("52GJU");

var $2VZ1E = parcelRequire("2VZ1E");

var $xxDMM = parcelRequire("xxDMM");
function $60fe10be5cfe3118$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $60fe10be5cfe3118$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT = 490;
const $60fe10be5cfe3118$var$commentEditorStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'flex',
    flexDirection: 'column',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.less-margin > .ProseMirror': {
        margin: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
    },
    minWidth: '272px',
    height: 'auto',
    backgroundColor: "var(--ds-background-input, white)",
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-input, #8590A2)"}`,
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-radius-small, 3px)",
    maxWidth: 'inherit',
    wordWrap: 'break-word'
});
const $60fe10be5cfe3118$var$secondaryToolbarStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    boxSizing: 'border-box',
    justifyContent: 'flex-end',
    alignItems: 'center',
    display: 'flex',
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-025, 2px)"}`
});
const $60fe10be5cfe3118$var$mainToolbarCustomComponentsSlotStyleNew = {
    name: "4cnzc6",
    styles: "display:flex;justify-content:flex-end;align-items:center;flex-grow:1;padding-right:var(--ds-space-250, 20px);> div{display:flex;flex-shrink:0;}"
};
const $60fe10be5cfe3118$var$mainToolbarCustomComponentsSlotStyleTwoLineToolbarNew = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    [`@media (max-width: ${$60fe10be5cfe3118$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px)`]: {
        paddingRight: 0
    }
});
const $60fe10be5cfe3118$var$appearance = 'comment';
const $60fe10be5cfe3118$export$7b9f3a51cd0c1967 = (props)=>{
    const { editorAPI: editorAPI } = props;
    const { editorViewMode: editorViewMode, primaryToolbarComponentsState: primaryToolbarComponentsState, maxContentSizeReached: maxContentSizeReached } = (0, $cxXTK.useSharedPluginStateWithSelector)(editorAPI, [
        'maxContentSize',
        'primaryToolbar',
        'editorViewMode'
    ], (states)=>({
            maxContentSizeReached: !!states.maxContentSizeState?.maxContentSizeReached,
            primaryToolbarComponentsState: states.primaryToolbarState?.components,
            editorViewMode: states.editorViewModeState?.mode
        }));
    const primaryToolbarState = (0, $8NyYn.getPrimaryToolbarComponents)(editorAPI, primaryToolbarComponentsState);
    const { mediaState: mediaState } = (0, $bSToC.useSharedPluginState)(editorAPI, [
        'media'
    ]);
    const intl = (0, $lRq8t.default)();
    const { editorDOMElement: editorDOMElement, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, contentComponents: contentComponents, customContentComponents: customContentComponents, customPrimaryToolbarComponents: customPrimaryToolbarComponents, primaryToolbarComponents: primaryToolbarComponentsProp, customSecondaryToolbarComponents: customSecondaryToolbarComponents, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, maxHeight: maxHeight, minHeight: minHeight = 150, onSave: onSave, onCancel: onCancel, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, useStickyToolbar: useStickyToolbar, pluginHooks: pluginHooks, featureFlags: featureFlags, innerRef: innerRef } = props;
    const showSecondaryToolbar = !!onSave || !!onCancel || !!customSecondaryToolbarComponents;
    const containerElement = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    // Wrapper container for toolbar and content area
    const wrapperElementRef = (0, $eJOHy.useMemo)(()=>innerRef || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), [
        innerRef
    ]);
    const [saveButtonDisabled, setSaveButtonDisabled] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (mediaState) mediaState.subscribeToUploadInProgressState(setSaveButtonDisabled);
        return ()=>mediaState?.unsubscribeFromUploadInProgressState(setSaveButtonDisabled);
    }, [
        mediaState
    ]);
    const handleSave = (0, $eJOHy.useCallback)(()=>{
        if (editorView && onSave) onSave(editorView);
    }, [
        editorView,
        onSave
    ]);
    const handleCancel = (0, $eJOHy.useCallback)(()=>{
        if (editorView && onCancel) onCancel(editorView);
    }, [
        editorView,
        onCancel
    ]);
    const isShortcutToFocusToolbar = (0, $eJOHy.useCallback)((event)=>{
        //Alt + F9 to reach first element in this main toolbar
        return event.altKey && (event.key === 'F9' || event.keyCode === 120);
    }, []);
    // When primary toolbar components is undefined, do not show two line editor toolbar
    const isTwoLineToolbarEnabled = !!customPrimaryToolbarComponents;
    const handleEscape = (0, $eJOHy.useCallback)((event)=>{
        if (!editorView?.hasFocus()) editorView?.focus();
        event.preventDefault();
        event.stopPropagation();
    }, [
        editorView
    ]);
    let primaryToolbarComponents = primaryToolbarComponentsProp;
    if (Array.isArray(primaryToolbarState?.components) && Array.isArray(primaryToolbarComponents)) primaryToolbarComponents = primaryToolbarState.components.concat(primaryToolbarComponents);
    const customToolbarSlot = /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            $60fe10be5cfe3118$var$mainToolbarCustomComponentsSlotStyleNew,
            isTwoLineToolbarEnabled && $60fe10be5cfe3118$var$mainToolbarCustomComponentsSlotStyleTwoLineToolbarNew
        ]
    }, customPrimaryToolbarComponents);
    const isToolbarAIFCEnabled = Boolean(editorAPI?.toolbar);
    const patch6Enabled = (0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $52GJU.default), {
        animate: maxContentSizeReached
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $2bEPZ.WidthProvider), null, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            $60fe10be5cfe3118$var$commentEditorStyles,
            /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $1NIU8.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                minHeight: `${minHeight}px`
            })
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "akEditor",
        ref: wrapperElementRef
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $xxDMM.MainToolbar), {
        useStickyToolbar: useStickyToolbar,
        twoLineEditorToolbar: isTwoLineToolbarEnabled,
        isNewToolbarEnabled: isToolbarAIFCEnabled
    }, isToolbarAIFCEnabled ? (0, $eGOwo.fg)('platform_editor_toolbar_aifc_patch_7') ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $baHgw.ToolbarArrowKeyNavigationProvider), {
        editorView: editorView,
        childComponentSelector: "[data-testid='ak-editor-main-toolbar']",
        isShortcutToFocusToolbar: isShortcutToFocusToolbar,
        handleEscape: handleEscape,
        editorAppearance: $60fe10be5cfe3118$var$appearance,
        useStickyToolbar: useStickyToolbar,
        intl: intl
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $2VZ1E.CommentToolbar), {
        editorAPI: editorAPI,
        editorView: editorView,
        editorAppearance: $60fe10be5cfe3118$var$appearance,
        disabled: patch6Enabled ? !!disabled : undefined,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        popupsMountPoint: popupsMountPoint
    }), customPrimaryToolbarComponents ? customToolbarSlot : null) : /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $2VZ1E.CommentToolbar), {
        editorAPI: editorAPI,
        editorView: editorView,
        editorAppearance: $60fe10be5cfe3118$var$appearance,
        disabled: patch6Enabled ? !!disabled : undefined,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        popupsMountPoint: popupsMountPoint
    }), customPrimaryToolbarComponents ? customToolbarSlot : null) : /*#__PURE__*/ (0, $1NIU8.jsx)((0, $baHgw.ToolbarArrowKeyNavigationProvider), {
        editorView: editorView,
        childComponentSelector: "[data-testid='ak-editor-main-toolbar']",
        isShortcutToFocusToolbar: isShortcutToFocusToolbar,
        handleEscape: handleEscape,
        editorAppearance: $60fe10be5cfe3118$var$appearance,
        useStickyToolbar: useStickyToolbar,
        intl: intl
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $83GXu.ToolbarWithSizeDetector), {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        editorView: editorView,
        editorActions: editorActions,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        eventDispatcher: eventDispatcher,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        providerFactory: providerFactory,
        appearance: $60fe10be5cfe3118$var$appearance,
        items: primaryToolbarComponents,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        disabled: !!disabled,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        containerElement: containerElement.current,
        twoLineEditorToolbar: isTwoLineToolbarEnabled
    }), customToolbarSlot)), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $g5n6x.default), {
        editorView: editorView,
        editorDisabled: disabled
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $2bEPZ.WidthConsumer), null, ({ width: width })=>{
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $7XjxI.default), {
            ref: containerElement,
            css: [
                maxHeight ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $1NIU8.css)({
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                    maxHeight: `${maxHeight}px`,
                    // When maxHeight is set, content area should have overflow-y explicitly set as auto
                    // As we have overflow-x: clip for the content area, and when maxHeight prop is set, overflow-y will be computed as visible by default.
                    // This will cause the content area to have content overflowing the container
                    // so need to set overflow-y as auto to make sure the content area is scrollable
                    overflowY: 'auto'
                }) : null
            ],
            isScrollable: maxHeight ? true : undefined,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($k9JrM)))('ak-editor-content-area', {
                'less-margin': width < (0, $7yBx7.akEditorMobileBreakoutPoint)
            }),
            featureFlags: featureFlags,
            viewMode: editorViewMode,
            appearance: $60fe10be5cfe3118$var$appearance
        }, customContentComponents && 'before' in customContentComponents ? (0, $g0hAu.contentComponentClickWrapper)(customContentComponents.before) : (0, $g0hAu.contentComponentClickWrapper)(customContentComponents), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $gyhYD.default), {
            editorView: editorView,
            editorActions: editorActions,
            eventDispatcher: eventDispatcher,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            providerFactory: providerFactory,
            appearance: $60fe10be5cfe3118$var$appearance,
            items: contentComponents,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            containerElement: containerElement.current,
            disabled: !!disabled,
            wrapperElement: wrapperElementRef.current,
            pluginHooks: pluginHooks
        }), editorDOMElement, customContentComponents && 'after' in customContentComponents ? (0, $g0hAu.contentComponentClickWrapper)(customContentComponents.after) : null);
    }))), showSecondaryToolbar && /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $60fe10be5cfe3118$var$secondaryToolbarStyles,
        "data-testid": "ak-editor-secondary-toolbar"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $48q59.default), null, !!onSave && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $5CSKW.default), {
        appearance: "primary",
        onClick: handleSave,
        testId: "comment-save-button",
        isDisabled: disabled || saveButtonDisabled,
        interactionName: "editor-comment-save-button"
    }, intl.formatMessage((0, $h2yqz.default).saveButton)), !!onCancel && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $5CSKW.default), {
        appearance: "subtle",
        onClick: handleCancel,
        testId: "comment-cancel-button",
        isDisabled: disabled,
        interactionName: "editor-comment-cancel-button"
    }, intl.formatMessage((0, $h2yqz.default).cancelButton))), /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        style: {
            flexGrow: 1
        }
    }), customSecondaryToolbarComponents)));
};
$60fe10be5cfe3118$export$7b9f3a51cd0c1967.displayName = 'CommentEditorAppearance';

});
parcelRegister("k9JrM", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("g5n6x", function(module, exports) {
$parcel$export(module.exports, "default", () => $371e4919406a4a18$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $jqh4E = parcelRequire("jqh4E");
function $371e4919406a4a18$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $371e4919406a4a18$var$clickWrapper = {
    name: "sox1a6",
    styles: "flex-grow:1;height:100%"
};
const $371e4919406a4a18$export$68468c5dbde37b99 = ({ editorView: editorView, editorDisabled: editorDisabled, children: children })=>{
    const handleMouseDown = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        if (!editorView) return;
        if (!editorDisabled) (0, $jqh4E.clickAreaClickHandler)(editorView, event);
    }, [
        editorView,
        editorDisabled
    ]);
    return(// eslint-disable-next-line @atlassian/a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        "data-editor-click-wrapper": true,
        "data-testid": "click-wrapper",
        css: $371e4919406a4a18$var$clickWrapper,
        onMouseDown: handleMouseDown
    }, children));
};
var $371e4919406a4a18$export$2e2bcd8739ae039 = $371e4919406a4a18$export$68468c5dbde37b99;

});
parcelRegister("jqh4E", function(module, exports) {
$parcel$export(module.exports, "clickAreaClickHandler", () => $ac7a694f83c2c94e$export$28b64e3e5a38e8a2);

var $eh3wX = parcelRequire("eh3wX");

var $2Ttys = parcelRequire("2Ttys");

var $gEqKI = parcelRequire("gEqKI");

var $7SIsS = parcelRequire("7SIsS");

var $cbSL1 = parcelRequire("cbSL1");

var $g0hAu = parcelRequire("g0hAu");
// we ignore all of the clicks made inside <div class="ak-editor-content-area" /> (but not clicks on the node itself)
const $ac7a694f83c2c94e$var$insideContentArea = (ref)=>{
    while(ref){
        if (ref.classList && ref.classList.contains('ak-editor-content-area')) return true;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        ref = ref.parentNode;
    }
    return false;
};
const $ac7a694f83c2c94e$var$insideProseMirrorEditableArea = (ref)=>{
    return Boolean(ref?.closest('.ProseMirror'));
};
const $ac7a694f83c2c94e$export$79ba7abfc5f47a65 = (target)=>{
    const modalDialog = target?.closest('[role=dialog]');
    if (modalDialog) // return false if not an editor inside modal, otherwise return true
    return !!modalDialog?.querySelector('.akEditor');
    // no modal present so we can return true
    return true;
};
const $ac7a694f83c2c94e$export$28b64e3e5a38e8a2 = (view, event)=>{
    const isEditorFocused = !!view?.hasFocus?.();
    if (!(event.target instanceof HTMLElement)) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const target = event.target;
    const isTargetContentArea = target?.classList.contains('ak-editor-content-area');
    const isTargetChildOfContentArea = $ac7a694f83c2c94e$var$insideContentArea(target?.parentNode instanceof HTMLElement ? target?.parentNode : null);
    const isTargetInsideEditableArea = $ac7a694f83c2c94e$var$insideProseMirrorEditableArea(target);
    // Any click inside ProseMirror should be managed by ProseMirror
    if (isTargetInsideEditableArea) return false;
    const isEventComingFromContentArea = Boolean(event.currentTarget.querySelector('.ak-editor-content-area'));
    // @see https://product-fabric.atlassian.net/browse/ED-4287
    // click event gets triggered twice on a checkbox (on <label> first and then on <input>)
    // by the time it gets triggered on input, PM already re-renders nodeView and detaches it from DOM
    // which doesn't pass the check !contentArea.contains(event.target)
    const isInputClicked = target?.nodeName === 'INPUT';
    // @see ED-5126
    const isPopupClicked = !!(0, $7SIsS.closestElement)(target, '[data-editor-popup]');
    // Fixes issue when using a textarea for editor title in full page editor doesn't let user focus it.
    const isTextAreaClicked = target?.nodeName === 'TEXTAREA';
    const isBreadcrumbClicked = !!(0, $7SIsS.closestElement)(target, 'nav[aria-label="Breadcrumbs"]');
    const selection = window.getSelection();
    const isEditorPopupTextSelected = selection?.type === 'Range' && // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    (0, $7SIsS.closestElement)(selection?.anchorNode, '[data-editor-popup]');
    // For clicks directly on the content component -- they should not be ignored
    const isContentComponent = target?.parentElement?.closest(`[${(0, $g0hAu.ignoreAttribute)}]`);
    // This is a super workaround to find when events are coming from Confluence InlineComment modal
    // We don't own those components, so we can't change them
    const isEventComingFromInlineCommentPopup = Boolean((0, $7SIsS.closestElement)(event.currentTarget, 'div[offset]')) || Boolean((0, $7SIsS.closestElement)(target, 'div[offset]'));
    const isAnchorButtonClicked = Boolean((0, $7SIsS.closestElement)(event.currentTarget, 'a')) || Boolean((0, $7SIsS.closestElement)(target, 'a')) || event.currentTarget?.nodeName === 'A' || target?.nodeName === 'A';
    const isButtonClicked = Boolean((0, $7SIsS.closestElement)(event.currentTarget, 'button')) || Boolean((0, $7SIsS.closestElement)(target, 'button')) || event.currentTarget?.nodeName === 'BUTTON' || target?.nodeName === 'BUTTON' || (0, $cbSL1.expValEquals)('platform_editor_toolbar_migrate_loom', 'isEnabled', true) && isAnchorButtonClicked;
    const isTargetInsideContentArea = Boolean(isTargetChildOfContentArea);
    const isBetweenContentAreaAndEditableContent = isTargetInsideContentArea && !isTargetInsideEditableArea;
    // Column Picker dropdown in Datasources table
    const isDatasourcePopupClicked = !!target?.closest('#column-picker-popup');
    const edgeCaseScenario1 = (isBetweenContentAreaAndEditableContent || !isEventComingFromContentArea) && !isEditorFocused;
    const edgeCaseScenario2 = !isTargetInsideContentArea && isEditorFocused;
    const edgeCaseScenario3 = isTargetContentArea && !isTargetInsideContentArea && !isEditorFocused;
    const edgeCaseScenario4 = isEventComingFromContentArea && !isTargetContentArea && !isTargetInsideContentArea && !isEditorFocused;
    const edgeCases = edgeCaseScenario1 || edgeCaseScenario2 || edgeCaseScenario3 || edgeCaseScenario4;
    const isClickOutsideEditor = edgeCases && !isDatasourcePopupClicked && !isEventComingFromInlineCommentPopup && !isButtonClicked && !isInputClicked && !isTextAreaClicked && !isPopupClicked && !isBreadcrumbClicked && !isEditorPopupTextSelected && !isContentComponent && $ac7a694f83c2c94e$export$79ba7abfc5f47a65(target);
    // click was within editor container and focus should be brought to input
    if (isClickOutsideEditor && view) $ac7a694f83c2c94e$export$c5a7a653c4681bfd(view, event);
};
const $ac7a694f83c2c94e$export$c5a7a653c4681bfd = (view, event)=>{
    const { dispatch: dispatch, dom: dom, state: state } = view;
    const { tr: tr } = state;
    const isEditorFocused = !!view?.hasFocus?.();
    const isBottomAreaClicked = event.clientY > dom.getBoundingClientRect().bottom;
    if (isBottomAreaClicked) {
        tr.setMeta('outsideProsemirrorEditorClicked', true);
        (0, $2Ttys.addParagraphAtEnd)(tr);
    }
    (0, $gEqKI.setSelectionTopLevelBlocks)(tr, event, // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    dom, view.posAtCoords.bind(view), isEditorFocused);
    (0, $eh3wX.tintDirtyTransaction)(tr);
    if (!tr.docChanged && !tr.selectionSet) return;
    if (dispatch) dispatch(tr);
    view.focus();
    event.preventDefault();
};

});
parcelRegister("g0hAu", function(module, exports) {
$parcel$export(module.exports, "ignoreAttribute", () => $12f311670fb11a3b$export$72d101e93c081651);
$parcel$export(module.exports, "contentComponentClickWrapper", () => $12f311670fb11a3b$export$57a965c23051130d);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $12f311670fb11a3b$export$72d101e93c081651 = 'data-editor-content-component';
const $12f311670fb11a3b$export$57a965c23051130d = (reactComponents)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-editor-content-component": 'true',
        children: reactComponents
    });
};

});



parcelRegister("8NyYn", function(module, exports) {
$parcel$export(module.exports, "getPrimaryToolbarComponents", () => $8b360cf558a33077$export$f454e86f6cef71f4);
const $8b360cf558a33077$export$f454e86f6cef71f4 = (editorAPI, components)=>{
    return {
        components: components ?? editorAPI?.primaryToolbar?.sharedState.currentState()?.components
    };
};

});

parcelRegister("83GXu", function(module, exports) {
$parcel$export(module.exports, "ToolbarWithSizeDetector", () => $2f7ab9153867bb66$export$6bb21858343ac39d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $fNh22 = parcelRequire("fNh22");

var $aBsWC = parcelRequire("aBsWC");

var $92xoS = parcelRequire("92xoS");

var $gMRLG = parcelRequire("gMRLG");

var $7uu4v = parcelRequire("7uu4v");

var $6caZI = parcelRequire("6caZI");

var $5DVwo = parcelRequire("5DVwo");

var $lUsTM = parcelRequire("lUsTM");
function $2f7ab9153867bb66$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2f7ab9153867bb66$var$toolbar = {
    name: "n48rgu",
    styles: "width:100%;position:relative"
};
const $2f7ab9153867bb66$export$6bb21858343ac39d = (props)=>{
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const [width, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(undefined);
    const elementWidth = (0, $6caZI.useElementWidth)(ref, {
        skip: typeof width !== 'undefined'
    });
    const defaultToolbarSize = (0, $fNh22.isSSR)() && (0, $7uu4v.isFullPage)(props.appearance) ? (0, $aBsWC.ToolbarSize).XXL : undefined;
    const toolbarSize = typeof width === 'undefined' && typeof elementWidth === 'undefined' ? defaultToolbarSize : // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $lUsTM.widthToToolbarSize)(width || elementWidth, props.appearance);
    const minWidthValue = (0, $eJOHy.useMemo)(()=>{
        if (props.hasMinWidth) {
            const toolbarWidth = (0, $7uu4v.isFullPage)(props.appearance) && props.twoLineEditorToolbar ? (0, $aBsWC.ToolbarSize).S : (0, $aBsWC.ToolbarSize).M;
            return `${(0, $lUsTM.toolbarSizeToWidth)(toolbarWidth, props.appearance)}px`;
        } else {
            const isPreviewPanelResponsivenessEnabled = (0, $92xoS.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                exposure: true
            });
            return isPreviewPanelResponsivenessEnabled ? 'fit-content' : '254px';
        }
    }, [
        props.appearance,
        props.hasMinWidth,
        props.twoLineEditorToolbar
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $2f7ab9153867bb66$var$toolbar,
        style: {
            minWidth: minWidthValue
        }
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $gMRLG.WidthObserver), {
        setWidth: setWidth
    }), props.editorView && toolbarSize ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $5DVwo.Toolbar), {
        toolbarSize: toolbarSize,
        items: props.items,
        editorView: props.editorView,
        editorActions: props.editorActions,
        eventDispatcher: props.eventDispatcher,
        providerFactory: props.providerFactory,
        appearance: props.appearance,
        popupsMountPoint: props.popupsMountPoint,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsScrollableElement: props.popupsScrollableElement,
        disabled: props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        containerElement: props.containerElement,
        hasMinWidth: props.hasMinWidth,
        twoLineEditorToolbar: props.twoLineEditorToolbar
    }) : /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        ref: ref
    }));
};

});
parcelRegister("6caZI", function(module, exports) {
$parcel$export(module.exports, "useElementWidth", () => $c781e6aa3a282142$export$1217913212f99c7);

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");
const $c781e6aa3a282142$export$1217913212f99c7 = (ref, { skip: skip })=>{
    const [elementWidth, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(undefined);
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        if (!skip && ref.current && !(0, $eGOwo.fg)('platform_editor_prevent_toolbar_width_reflow')) setWidth(Math.round(ref.current.getBoundingClientRect().width));
    }, [
        skip,
        setWidth,
        ref
    ]);
    return elementWidth;
};

});

parcelRegister("5DVwo", function(module, exports) {
$parcel$export(module.exports, "Toolbar", () => $1cf27d3b03d64cbb$export$4c260019440d418f);
$parcel$export(module.exports, "ToolbarNext", () => $1cf27d3b03d64cbb$export$1606f8c5fd0ac145);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $cxXTK = parcelRequire("cxXTK");

var $c0YTT = parcelRequire("c0YTT");
var $jA0hu = parcelRequire("jA0hu");

var $aBsWC = parcelRequire("aBsWC");

var $frlUM = parcelRequire("frlUM");

var $1ZfmT = parcelRequire("1ZfmT");
var $9tvdK = parcelRequire("9tvdK");
var $77ZIq = parcelRequire("77ZIq");

var $1SdRK = parcelRequire("1SdRK");

var $1DmqU = parcelRequire("1DmqU");

var $cbSL1 = parcelRequire("cbSL1");

var $c7es2 = parcelRequire("c7es2");
const $1cf27d3b03d64cbb$export$4c260019440d418f = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c7es2.ToolbarInner), {
        items: props.items,
        editorView: props.editorView,
        editorActions: props.editorActions,
        eventDispatcher: props.eventDispatcher,
        providerFactory: props.providerFactory,
        appearance: props.appearance,
        popupsMountPoint: props.popupsMountPoint,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsScrollableElement: props.popupsScrollableElement,
        disabled: props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        toolbarSize: props.toolbarSize,
        isToolbarReducedSpacing: props.toolbarSize < (0, $aBsWC.ToolbarSize).XXL,
        containerElement: props.containerElement
    });
};
const $1cf27d3b03d64cbb$var$usePluginState = (0, $1DmqU.conditionalHooksFactory)(()=>(0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_patch_3', 'isEnabled', true), (api)=>{
    return (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'connectivity',
        'editorViewMode',
        'userPreferences'
    ], (state)=>{
        return {
            connectivityStateMode: state.connectivityState?.mode,
            editorViewMode: state.editorViewModeState?.mode,
            editorToolbarDockingPreference: state.userPreferencesState?.preferences?.toolbarDockingPosition
        };
    });
}, (api)=>{
    const connectivityStateMode = (0, $frlUM.useSharedPluginStateSelector)(api, 'connectivity.mode');
    return {
        connectivityStateMode: connectivityStateMode,
        editorViewMode: undefined,
        editorToolbarDockingPreference: undefined
    };
});
const $1cf27d3b03d64cbb$export$1606f8c5fd0ac145 = ({ toolbar: toolbar, components: components, editorView: editorView, editorAPI: editorAPI, popupsMountPoint: popupsMountPoint, editorAppearance: editorAppearance, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isDisabled: isDisabled })=>{
    const { connectivityStateMode: connectivityStateMode, editorViewMode: editorViewMode, editorToolbarDockingPreference: editorToolbarDockingPreference } = $1cf27d3b03d64cbb$var$usePluginState(editorAPI);
    // remove offline check when patch6Enabled is cleaned up
    const isOffline = connectivityStateMode === 'offline';
    const patch6Enabled = (0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c0YTT.EditorToolbarProvider), {
        editorView: editorView ?? null,
        editorAppearance: editorAppearance,
        editorViewMode: (0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_patch_4', 'isEnabled', true) ? editorViewMode ?? 'edit' : editorViewMode,
        editorToolbarDockingPreference: editorToolbarDockingPreference,
        isOffline: isOffline,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jA0hu.EditorToolbarUIProvider), {
            api: editorAPI,
            isDisabled: patch6Enabled ? isDisabled : isOffline || isDisabled,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            fireAnalyticsEvent: (payload)=>{
                editorAPI?.analytics?.actions.fireAnalyticsEvent(payload);
            },
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1SdRK.ToolbarModelRenderer), {
                toolbar: toolbar,
                components: components,
                fallbacks: {
                    group: (0, $1ZfmT.ToolbarButtonGroup),
                    section: (0, $77ZIq.ToolbarSection),
                    menuSection: (0, $9tvdK.ToolbarDropdownItemSection)
                }
            })
        })
    });
};

});
parcelRegister("jA0hu", function(module, exports) {
$parcel$export(module.exports, "EditorToolbarUIProvider", () => $e8924ba8a007337a$export$54b6b74e939729c);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7K3rS = parcelRequire("7K3rS");

var $eGOwo = parcelRequire("eGOwo");
const $e8924ba8a007337a$export$54b6b74e939729c = ({ children: children, api: api, isDisabled: isDisabled, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, fireAnalyticsEvent: fireAnalyticsEvent, keyboardNavigation: keyboardNavigation })=>{
    const onDropdownOpenChanged = (0, $eJOHy.useCallback)(({ isOpen: isOpen, event: event })=>{
        if (!isOpen) {
            if ((0, $eGOwo.fg)('platform_editor_toolbar_aifc_patch_7')) {
                // Only refocus the editor when the dropdown closes via mouse or programmatic close.
                // When closed via keyboard Escape, keep focus on the trigger for better keyboard UX.
                const isKeyboardEscape = event instanceof KeyboardEvent && event.key === 'Escape';
                const shouldFocusEditor = !isKeyboardEscape;
                if (shouldFocusEditor) // On Dropdown closed, focus is returned to trigger button by default in requestAnimationFrame
                // Hence, `.focus()` should also be called in requestAnimationFrame
                setTimeout(()=>requestAnimationFrame(()=>{
                        api?.core.actions.focus({
                            scrollIntoView: false
                        });
                    }), 1);
            } else // On Dropdown closed, focus is returned to trigger button by default in requestAnimationFrame
            // Hence, `.focus()` should also be called in requestAnimationFrame
            setTimeout(()=>requestAnimationFrame(()=>{
                    api?.core.actions.focus({
                        scrollIntoView: false
                    });
                }), 1);
        }
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7K3rS.ToolbarUIProvider), {
        onDropdownOpenChanged: onDropdownOpenChanged,
        preventDefaultOnMouseDown: true,
        isDisabled: isDisabled,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        fireAnalyticsEvent: fireAnalyticsEvent,
        keyboardNavigation: keyboardNavigation,
        children: children
    });
};

});

parcelRegister("77ZIq", function(module, exports) {
$parcel$export(module.exports, "SeparatorPosition", () => $09b04124365e5cee$export$90683802e28416b5);
$parcel$export(module.exports, "ToolbarSection", () => $09b04124365e5cee$export$b978f6a1bb31af67);
/* ToolbarSection.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
var $09b04124365e5cee$export$90683802e28416b5 = /*#__PURE__*/ function(SeparatorPosition) {
    SeparatorPosition["START"] = "start";
    SeparatorPosition["END"] = "end";
    return SeparatorPosition;
}({});
const $09b04124365e5cee$var$styles = {
    container: "_zulp1b66 _1e0c1txw _4cvr1h6o"
};
const $09b04124365e5cee$var$separator = null;
const $09b04124365e5cee$var$ToolbarSeparator = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-toolbar-component": "separator",
        role: "separator",
        "aria-orientation": "vertical",
        className: (0, $hcewu.default)([
            "_195gu2gc _4t3igktf _1bsbt94y _bfhkmuej"
        ])
    });
};
const $09b04124365e5cee$export$b978f6a1bb31af67 = ({ children: children, testId: testId, hasSeparator: hasSeparator })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($09b04124365e5cee$var$styles.container),
        testId: testId,
        "data-toolbar-component": "section",
        children: [
            hasSeparator === "start" && /*#__PURE__*/ (0, $gt9Am.jsx)($09b04124365e5cee$var$ToolbarSeparator, {}),
            children,
            hasSeparator === "end" && /*#__PURE__*/ (0, $gt9Am.jsx)($09b04124365e5cee$var$ToolbarSeparator, {})
        ]
    });
};

});

parcelRegister("1SdRK", function(module, exports) {
$parcel$export(module.exports, "ToolbarModelRenderer", () => $b13a25bfb2c02220$export$9ceb2742df82af54);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $d91n8 = parcelRequire("d91n8");

var $1buvd = parcelRequire("1buvd");
const $b13a25bfb2c02220$export$9ceb2742df82af54 = ({ toolbar: toolbar, components: components, fallbacks: fallbacks })=>{
    if ((0, $eGOwo.fg)('platform_editor_toolbar_aifc_renderer_rewrite')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $d91n8.ToolbarModelRenderer), {
        toolbar: toolbar,
        components: components,
        fallbacks: fallbacks
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1buvd.ToolbarModelRenderer), {
        toolbar: toolbar,
        components: components,
        fallbacks: fallbacks
    });
};

});
parcelRegister("d91n8", function(module, exports) {
$parcel$export(module.exports, "ToolbarModelRenderer", () => $00cb1f9da95171d6$export$9ceb2742df82af54);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hJvMe = parcelRequire("hJvMe");
const $00cb1f9da95171d6$var$hasParents = (component)=>{
    return component.type !== 'toolbar';
};
const $00cb1f9da95171d6$var$getChildTypesForParent = (parentType)=>{
    switch(parentType){
        case 'toolbar':
            return [
                'section'
            ];
        case 'section':
            return [
                'group'
            ];
        case 'group':
            return [
                'button',
                'menu'
            ];
        case 'menu':
        case 'nested-menu':
            return [
                'menu-section'
            ];
        case 'menu-section':
            return [
                'menu-item',
                'nested-menu'
            ];
        default:
            return [];
    }
};
const $00cb1f9da95171d6$var$getFallbackComponent = (type, fallbacks)=>{
    switch(type){
        case 'group':
            return fallbacks.group;
        case 'menu-section':
            return fallbacks.menuSection;
        case 'section':
            return fallbacks.section;
        default:
            return 0, $hJvMe.NoOp;
    }
};
const $00cb1f9da95171d6$var$ComponentRenderer = ({ component: component, parents: parents, allComponents: allComponents, fallbacks: fallbacks })=>{
    const childTypes = $00cb1f9da95171d6$var$getChildTypesForParent(component.type);
    const children = (0, $hJvMe.getSortedChildren)(allComponents.filter((comp)=>childTypes.includes(comp.type)), component.key);
    if ((component.type === 'menu' || component.type === 'group' || component.type === 'nested-menu' || component.type === 'menu-section') && children.length === 0) return null;
    const Component = component.component || $00cb1f9da95171d6$var$getFallbackComponent(component.type, fallbacks);
    const newParents = [
        ...parents,
        {
            key: component.key,
            type: component.type
        }
    ];
    if (children.length === 0) return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        parents: parents,
        children: null
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        parents: parents,
        children: children.map((child)=>/*#__PURE__*/ (0, $gt9Am.jsx)($00cb1f9da95171d6$var$ComponentRenderer, {
                component: child,
                parents: newParents,
                allComponents: allComponents,
                fallbacks: fallbacks
            }, child.key))
    });
};
const $00cb1f9da95171d6$export$9ceb2742df82af54 = ({ toolbar: toolbar, components: components, fallbacks: fallbacks })=>{
    const ToolbarComponent = toolbar.component || (0, $hJvMe.NoOp);
    const sections = (0, $hJvMe.getSortedChildren)(components.filter((0, $hJvMe.isSection)), toolbar.key);
    return /*#__PURE__*/ (0, $gt9Am.jsx)(ToolbarComponent, {
        children: sections.map((section)=>/*#__PURE__*/ (0, $gt9Am.jsx)($00cb1f9da95171d6$var$ComponentRenderer, {
                component: section,
                parents: [
                    {
                        key: toolbar.key,
                        type: toolbar.type
                    }
                ],
                allComponents: components.filter($00cb1f9da95171d6$var$hasParents),
                fallbacks: fallbacks
            }, section.key))
    });
};

});
parcelRegister("hJvMe", function(module, exports) {
$parcel$export(module.exports, "getSortedChildren", () => $7e6fb0fcf3ffd37b$export$671f8dfe06a9af10);
$parcel$export(module.exports, "NoOp", () => $7e6fb0fcf3ffd37b$export$7fc4381d95dc76c8);
$parcel$export(module.exports, "isSection", () => $7e6fb0fcf3ffd37b$export$fc1acc9190910d14);
const $7e6fb0fcf3ffd37b$export$671f8dfe06a9af10 = (components, parentKey)=>components.filter((component)=>component.parents.some((parent)=>parent.key === parentKey)).sort((a, b)=>(a.parents.find((p)=>p.key === parentKey)?.rank || 0) - (b.parents.find((p)=>p.key === parentKey)?.rank || 0));
const $7e6fb0fcf3ffd37b$export$7fc4381d95dc76c8 = (props)=>null;
const $7e6fb0fcf3ffd37b$export$fc1acc9190910d14 = (component)=>{
    return component.type === 'section';
};

});


parcelRegister("1buvd", function(module, exports) {
$parcel$export(module.exports, "ToolbarModelRenderer", () => $e0421e5a73591e30$export$9ceb2742df82af54);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hJvMe = parcelRequire("hJvMe");
const $e0421e5a73591e30$var$isGroup = (component)=>{
    return component.type === 'group';
};
const $e0421e5a73591e30$var$isToolbarItem = (component)=>{
    return component.type === 'button' || component.type === 'menu';
};
const $e0421e5a73591e30$var$isToolbarMenuSection = (component)=>{
    return component.type === 'menu-section';
};
const $e0421e5a73591e30$var$isToolbarMenuItem = (component)=>{
    return component.type === 'menu-item' || component.type === 'menu-section';
};
const $e0421e5a73591e30$var$isToolbarMenuItemOrNestedMenu = (component)=>{
    return component.type === 'menu-item' || component.type === 'menu-section' || component.type === 'nested-menu';
};
const $e0421e5a73591e30$var$getSortedChildren = (components, parentKey)=>components.filter((component)=>component.parents.some((parent)=>parent.key === parentKey)).sort((a, b)=>(a.parents.find((p)=>p.key === parentKey)?.rank || 0) - (b.parents.find((p)=>p.key === parentKey)?.rank || 0));
const $e0421e5a73591e30$export$9ceb2742df82af54 = ({ toolbar: toolbar, components: components, fallbacks: fallbacks })=>{
    const sections = $e0421e5a73591e30$var$getSortedChildren(components.filter((0, $hJvMe.isSection)), toolbar.key);
    const groups = components.filter($e0421e5a73591e30$var$isGroup);
    const toolbarItems = components.filter($e0421e5a73591e30$var$isToolbarItem);
    const menuSections = components.filter($e0421e5a73591e30$var$isToolbarMenuSection);
    const menuItems = components.filter($e0421e5a73591e30$var$isToolbarMenuItem);
    const menuItemsAndNestedMenus = components.filter($e0421e5a73591e30$var$isToolbarMenuItemOrNestedMenu);
    const renderToolbarItem = ({ item: item, index: index, parents: parents })=>{
        if (item.type === 'menu') {
            const menuComponents = $e0421e5a73591e30$var$getSortedChildren(menuSections, item.key);
            if (menuComponents.length === 0) return null;
            const Menu = item.component || (0, $hJvMe.NoOp);
            return /*#__PURE__*/ (0, $gt9Am.jsx)(Menu, {
                parents: parents,
                children: menuComponents.map((menuSection)=>{
                    const menuItemsInSection = $e0421e5a73591e30$var$getSortedChildren(menuItemsAndNestedMenus, menuSection.key);
                    const MenuSection = menuSection.component || fallbacks.menuSection;
                    return /*#__PURE__*/ (0, $gt9Am.jsx)(MenuSection, {
                        parents: [
                            ...parents,
                            {
                                key: item.key,
                                type: item.type
                            }
                        ],
                        children: menuItemsInSection.map((menuItem)=>{
                            if (menuItem.type === 'nested-menu') {
                                const nestedMenuComponents = $e0421e5a73591e30$var$getSortedChildren(menuSections, menuItem.key);
                                const NestedMenu = menuItem.component;
                                return /*#__PURE__*/ (0, $gt9Am.jsx)(NestedMenu, {
                                    parents: [
                                        ...parents,
                                        {
                                            key: item.key,
                                            type: item.type
                                        },
                                        {
                                            key: menuSection.key,
                                            type: menuSection.type
                                        }
                                    ],
                                    children: nestedMenuComponents.map((nestedMenuSection)=>{
                                        const menuItemsInNestedMenuSection = $e0421e5a73591e30$var$getSortedChildren(menuItems, nestedMenuSection.key);
                                        const NestedMenuSection = nestedMenuSection.component || fallbacks.menuSection;
                                        return /*#__PURE__*/ (0, $gt9Am.jsx)(NestedMenuSection, {
                                            parents: [
                                                ...parents,
                                                {
                                                    key: item.key,
                                                    type: item.type
                                                },
                                                {
                                                    key: menuSection.key,
                                                    type: menuSection.type
                                                },
                                                {
                                                    key: menuItem.key,
                                                    type: menuItem.type
                                                }
                                            ],
                                            children: menuItemsInNestedMenuSection.map((nestedMenuItem)=>{
                                                const NestedMenuItem = nestedMenuItem.component || (0, $hJvMe.NoOp);
                                                return /*#__PURE__*/ (0, $gt9Am.jsx)(NestedMenuItem, {
                                                    parents: [
                                                        ...parents,
                                                        {
                                                            key: item.key,
                                                            type: item.type
                                                        },
                                                        {
                                                            key: menuSection.key,
                                                            type: menuSection.type
                                                        },
                                                        {
                                                            key: menuItem.key,
                                                            type: menuItem.type
                                                        },
                                                        {
                                                            key: nestedMenuSection.key,
                                                            type: nestedMenuSection.type
                                                        }
                                                    ]
                                                }, nestedMenuItem.key);
                                            })
                                        }, nestedMenuSection.key);
                                    })
                                }, menuItem.key);
                            }
                            const MenuItem = menuItem.component || (0, $hJvMe.NoOp);
                            return /*#__PURE__*/ (0, $gt9Am.jsx)(MenuItem, {
                                parents: [
                                    ...parents,
                                    {
                                        key: item.key,
                                        type: item.type
                                    },
                                    {
                                        key: menuSection.key,
                                        type: menuSection.type
                                    }
                                ]
                            }, menuItem.key);
                        })
                    }, menuSection.key);
                })
            }, item.key);
        }
        const Button = item.component || (0, $hJvMe.NoOp);
        return /*#__PURE__*/ (0, $gt9Am.jsx)(Button, {
            parents: parents
        }, item.key);
    };
    const renderGroup = (group, parents)=>{
        const groupItems = $e0421e5a73591e30$var$getSortedChildren(toolbarItems, group.key);
        if (groupItems.length === 0) return null;
        const Group = group.component || fallbacks.group;
        return /*#__PURE__*/ (0, $gt9Am.jsx)(Group, {
            parents: parents,
            children: groupItems.map((item, index)=>{
                return renderToolbarItem({
                    item: item,
                    index: index,
                    parents: [
                        ...parents,
                        {
                            key: group.key,
                            type: group.type
                        }
                    ]
                });
            })
        }, group.key);
    };
    const renderSection = (section)=>{
        const sectionGroups = $e0421e5a73591e30$var$getSortedChildren(groups, section.key);
        const Section = section.component || fallbacks.section;
        const parents = [
            {
                key: toolbar.key,
                type: toolbar.type
            }
        ];
        return /*#__PURE__*/ (0, $gt9Am.jsx)(Section, {
            parents: parents,
            children: sectionGroups.map((group)=>renderGroup(group, [
                    ...parents,
                    {
                        key: section.key,
                        type: section.type
                    }
                ]))
        }, section.key);
    };
    const ToolbarComponent = toolbar.component || (0, $hJvMe.NoOp);
    return /*#__PURE__*/ (0, $gt9Am.jsx)(ToolbarComponent, {
        children: sections.map(renderSection)
    });
};

});


parcelRegister("c7es2", function(module, exports) {
$parcel$export(module.exports, "ToolbarInner", () => $2736648cc3a08310$export$7c77e89663c6a665);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $cSmYj = parcelRequire("cSmYj");

var $fNh22 = parcelRequire("fNh22");

var $7yBx7 = parcelRequire("7yBx7");
const $2736648cc3a08310$var$toolbarComponentsWrapper = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${0, $7yBx7.akEditorMobileMaxWidth}px)`]: {
        justifyContent: 'space-between'
    }
});
class $2736648cc3a08310$export$7c77e89663c6a665 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(nextProps, this.props);
    }
    render() {
        const { appearance: appearance, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, items: items, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, dispatchAnalyticsEvent: dispatchAnalyticsEvent, containerElement: containerElement } = this.props;
        if (!items || !items.length) return null;
        if ((0, $fNh22.isSSR)()) // Toolbar in SSR environment is showing collapsed state, which caused layout shift after hydrating to SPA.
        // Hiding toolbar in SSR until the dependency of screen width is resolved in SSR environment.
        return null;
        return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $2736648cc3a08310$var$toolbarComponentsWrapper,
            "data-vc": "toolbar-inner"
        }, items.map((component, key)=>{
            const element = component({
                editorView: editorView,
                editorActions: editorActions,
                eventDispatcher: eventDispatcher,
                providerFactory: providerFactory,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                appearance: appearance,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                disabled: disabled,
                toolbarSize: toolbarSize,
                isToolbarReducedSpacing: isToolbarReducedSpacing,
                containerElement: containerElement,
                isLastItem: key === items.length - 1,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                wrapperElement: null
            });
            return element && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(element, {
                key: key
            });
        }));
    }
}

});


parcelRegister("lUsTM", function(module, exports) {
$parcel$export(module.exports, "toolbarSizeToWidth", () => $9fb6e1b7a31d0594$export$df8e48f984163082);
$parcel$export(module.exports, "widthToToolbarSize", () => $9fb6e1b7a31d0594$export$886398ab6922a80f);

var $aBsWC = parcelRequire("aBsWC");

var $eGOwo = parcelRequire("eGOwo");

var $7uu4v = parcelRequire("7uu4v");
// Toolbar sizes for full page editor a little bit different, because it has more buttons e.g. actions button...
const $9fb6e1b7a31d0594$var$toolbarSizesFullPageNext = [
    {
        width: (0, $aBsWC.ToolbarWidthsFullPageNext).XXL,
        size: (0, $aBsWC.ToolbarSize).XXL
    },
    {
        width: (0, $aBsWC.ToolbarWidthsFullPageNext).XL,
        size: (0, $aBsWC.ToolbarSize).XL
    },
    {
        width: (0, $aBsWC.ToolbarWidthsFullPageNext).L,
        size: (0, $aBsWC.ToolbarSize).L
    },
    {
        width: (0, $aBsWC.ToolbarWidthsFullPageNext).M,
        size: (0, $aBsWC.ToolbarSize).M
    },
    {
        width: (0, $aBsWC.ToolbarWidthsFullPageNext).S,
        size: (0, $aBsWC.ToolbarSize).S
    }
];
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/** @deprecated
 * To be removed as part of ED-25129 in favour of toolbarSizesFullPageNext along with references
 * to platform_editor_toolbar_responsive_fixes feature gate
 */ const $9fb6e1b7a31d0594$var$toolbarSizesFullPage = [
    {
        width: (0, $aBsWC.ToolbarWidthsFullPage).XXL,
        size: (0, $aBsWC.ToolbarSize).XXL
    },
    {
        width: (0, $aBsWC.ToolbarWidthsFullPage).XL,
        size: (0, $aBsWC.ToolbarSize).XL
    },
    {
        width: (0, $aBsWC.ToolbarWidthsFullPage).L,
        size: (0, $aBsWC.ToolbarSize).L
    },
    {
        width: (0, $aBsWC.ToolbarWidthsFullPage).M,
        size: (0, $aBsWC.ToolbarSize).M
    },
    {
        width: (0, $aBsWC.ToolbarWidthsFullPage).S,
        size: (0, $aBsWC.ToolbarSize).S
    }
];
const $9fb6e1b7a31d0594$var$toolbarSizesNext = [
    {
        width: (0, $aBsWC.ToolbarWidthsNext).XXL,
        size: (0, $aBsWC.ToolbarSize).XXL
    },
    {
        width: (0, $aBsWC.ToolbarWidthsNext).XL,
        size: (0, $aBsWC.ToolbarSize).XL
    },
    {
        width: (0, $aBsWC.ToolbarWidthsNext).L,
        size: (0, $aBsWC.ToolbarSize).L
    },
    {
        width: (0, $aBsWC.ToolbarWidthsNext).M,
        size: (0, $aBsWC.ToolbarSize).M
    },
    {
        width: (0, $aBsWC.ToolbarWidthsNext).S,
        size: (0, $aBsWC.ToolbarSize).S
    }
];
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/** @deprecated
 * To be removed as part of ED-25129 in favour of toolbarSizesNext along with references
 * to platform_editor_toolbar_responsive_fixes feature gate
 */ const $9fb6e1b7a31d0594$var$toolbarSizes = [
    {
        width: (0, $aBsWC.ToolbarWidths).XXL,
        size: (0, $aBsWC.ToolbarSize).XXL
    },
    {
        width: (0, $aBsWC.ToolbarWidths).XL,
        size: (0, $aBsWC.ToolbarSize).XL
    },
    {
        width: (0, $aBsWC.ToolbarWidths).L,
        size: (0, $aBsWC.ToolbarSize).L
    },
    {
        width: (0, $aBsWC.ToolbarWidths).M,
        size: (0, $aBsWC.ToolbarSize).M
    },
    {
        width: (0, $aBsWC.ToolbarWidths).S,
        size: (0, $aBsWC.ToolbarSize).S
    }
];
const $9fb6e1b7a31d0594$var$toolbarSizesForAppearance = (appearance)=>(0, $7uu4v.isFullPage)(appearance) ? (0, $eGOwo.fg)('platform_editor_toolbar_responsive_fixes') ? $9fb6e1b7a31d0594$var$toolbarSizesFullPageNext : $9fb6e1b7a31d0594$var$toolbarSizesFullPage : (0, $eGOwo.fg)('platform_editor_toolbar_responsive_fixes') ? $9fb6e1b7a31d0594$var$toolbarSizesNext : $9fb6e1b7a31d0594$var$toolbarSizes;
const $9fb6e1b7a31d0594$export$df8e48f984163082 = (toolbarSize, appearance)=>{
    return ($9fb6e1b7a31d0594$var$toolbarSizesForAppearance(appearance).find(({ size: size })=>toolbarSize === size) || {
        width: (0, $aBsWC.ToolbarWidths).S
    }).width;
};
const $9fb6e1b7a31d0594$export$886398ab6922a80f = (toolbarWidth, appearance)=>{
    return ($9fb6e1b7a31d0594$var$toolbarSizesForAppearance(appearance).find(({ width: width })=>toolbarWidth > width) || {
        size: (0, $aBsWC.ToolbarSize).XXXS
    }).size;
};

});


parcelRegister("2VZ1E", function(module, exports) {
$parcel$export(module.exports, "CommentToolbar", () => $a88c456605663d34$export$48156340a1673791);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $3KjUM = parcelRequire("3KjUM");

var $kBHb7 = parcelRequire("kBHb7");

var $5DVwo = parcelRequire("5DVwo");
const $a88c456605663d34$export$48156340a1673791 = ({ editorAPI: editorAPI, editorView: editorView, editorAppearance: editorAppearance, disabled: disabled, popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement })=>{
    const components = editorAPI?.toolbar?.actions.getComponents();
    const toolbar = components?.find((component)=>component.key === (0, $3KjUM.TOOLBARS).PRIMARY_TOOLBAR);
    if (!components || !(0, $kBHb7.isToolbar)(toolbar)) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5DVwo.ToolbarNext), {
        toolbar: toolbar,
        components: components,
        editorView: editorView,
        editorAPI: editorAPI,
        editorAppearance: editorAppearance,
        isDisabled: disabled,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        popupsMountPoint: popupsMountPoint
    });
};

});
parcelRegister("kBHb7", function(module, exports) {
$parcel$export(module.exports, "isToolbar", () => $f6fa8157b57bf98b$export$75279ffd74fef67b);
const $f6fa8157b57bf98b$export$75279ffd74fef67b = (component)=>{
    return component?.type === 'toolbar';
};

});


parcelRegister("xxDMM", function(module, exports) {
$parcel$export(module.exports, "MainToolbar", () => $cdffe18353f994db$export$f7e5e5a2fbd99270);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $eGOwo = parcelRequire("eGOwo");

var $cbSL1 = parcelRequire("cbSL1");
function $cdffe18353f994db$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $cdffe18353f994db$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT = 490;
const $cdffe18353f994db$var$akEditorMenuZIndex = 500;
const $cdffe18353f994db$var$akEditorToolbarKeylineHeight = 2;
const $cdffe18353f994db$var$mainToolbarWrapperStyleNew = /*#__PURE__*/ (0, $1NIU8.css)({
    position: 'relative',
    alignItems: 'center',
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} 0`,
    display: 'flex',
    height: 'auto',
    backgroundColor: "var(--ds-surface, white)",
    boxShadow: 'none',
    paddingLeft: "var(--ds-space-250, 20px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '> div': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div:first-of-type:not(style), > style:first-of-type + *': {
            marginLeft: 0
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.block-type-btn': {
        paddingLeft: 0
    }
});
/** keep default padding for entire toolbar */ const $cdffe18353f994db$var$mainToolbarWithoutLeftPadding = /*#__PURE__*/ (0, $1NIU8.css)({
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} 0`
});
const $cdffe18353f994db$var$mainToolbarWithPadding = /*#__PURE__*/ (0, $1NIU8.css)({
    padding: `${"var(--ds-space-100, 8px)"}`
});
const $cdffe18353f994db$var$mainToolbarTwoLineStylesNew = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& > div': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`@media (max-width: ${$cdffe18353f994db$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px)`]: {
            flexDirection: 'column-reverse',
            alignItems: 'end',
            display: 'flex',
            justifyContent: 'flex-end'
        },
        /* make this more explicit for a toolbar */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div:first-of-type': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`@media (max-width: ${$cdffe18353f994db$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px)`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                '> div:nth-of-type(2)': {
                    justifyContent: 'flex-end',
                    display: 'flex'
                }
            }
        }
    }
});
const $cdffe18353f994db$var$mainToolbarWrapperStylesVisualRefresh = {
    name: "y5dbpb",
    styles: "span svg{max-width:100%;}"
};
const $cdffe18353f994db$var$mainToolbarWithRadiusStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    borderRadius: `${"var(--ds-radius-small, 3px)"} ${"var(--ds-radius-small, 3px)"} 0 0`
});
const $cdffe18353f994db$var$stickyToolbarWrapperStyleNew = /*#__PURE__*/ (0, $1NIU8.css)({
    position: 'sticky',
    paddingBottom: "var(--ds-space-100, 8px)",
    zIndex: $cdffe18353f994db$var$akEditorMenuZIndex,
    transition: 'box-shadow ease-in-out 0.2s',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&.show-keyline': {
        boxShadow: `0 ${$cdffe18353f994db$var$akEditorToolbarKeylineHeight}px 0 0 ${"var(--ds-background-accent-gray-subtlest, #F1F2F4)"}`
    }
});
const $cdffe18353f994db$var$StickyToolbar = (props)=>{
    const [top, setTop] = (0, $eJOHy.useState)(0);
    const toolbarPatch6Enabled = (0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true);
    // ED-15802: if externalToolbarRef is passed in, set top to externalToolbarRef?.current?.clientHeight
    // else if offsetTop is a number set top to offsetTop
    // otherwise top is 0 as initial state
    (0, $eJOHy.useEffect)(()=>{
        if (props.externalToolbarRef?.current?.clientHeight) setTop(props.externalToolbarRef.current.clientHeight);
        else setTop(props.offsetTop || 0);
    }, [
        props.externalToolbarRef,
        props.offsetTop
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            $cdffe18353f994db$var$mainToolbarWrapperStyleNew,
            props.twoLineEditorToolbar && $cdffe18353f994db$var$mainToolbarTwoLineStylesNew,
            (0, $eGOwo.fg)('platform-visual-refresh-icons') && $cdffe18353f994db$var$mainToolbarWrapperStylesVisualRefresh,
            $cdffe18353f994db$var$stickyToolbarWrapperStyleNew,
            props.isNewToolbarEnabled && !toolbarPatch6Enabled && $cdffe18353f994db$var$mainToolbarWithoutLeftPadding,
            props.isNewToolbarEnabled && toolbarPatch6Enabled && $cdffe18353f994db$var$mainToolbarWithPadding
        ],
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        style: {
            top: `${top}px`
        },
        "data-testid": "ak-editor-main-toolbar",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: 'show-keyline'
    }, props.children));
};
const $cdffe18353f994db$var$FixedToolbar = (props)=>// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            $cdffe18353f994db$var$mainToolbarWrapperStyleNew,
            props.twoLineEditorToolbar && $cdffe18353f994db$var$mainToolbarTwoLineStylesNew,
            (0, $eGOwo.fg)('platform-visual-refresh-icons') && $cdffe18353f994db$var$mainToolbarWrapperStylesVisualRefresh,
            props.isNewToolbarEnabled && $cdffe18353f994db$var$mainToolbarWithoutLeftPadding,
            (0, $eGOwo.fg)('platform_editor_comments_border_radius') && $cdffe18353f994db$var$mainToolbarWithRadiusStyle
        ],
        "data-testid": "ak-editor-main-toolbar"
    }, props.children);
/**
 * ED-15802: Scenarios when a sticky bar is used:
 * 1. useStickyToolbar is true
 * 2. useStickyToolbar is a DOM element
 * 3. useStickyToolbar is an object and has offsetTop key;
 */ const $cdffe18353f994db$var$getStickyParameters = (configuration)=>{
    // const isUsingStickyOffset, isHTMLElement is used so TS can properly infer types.
    const isHTMLElement = typeof configuration === 'object' && !('offsetTop' in configuration);
    const isUsingStickyOffset = typeof configuration === 'object' && 'offsetTop' in configuration;
    if (typeof configuration !== 'object') return {
        externalToolbarRef: undefined,
        offsetTop: undefined
    };
    if (isUsingStickyOffset) return {
        offsetTop: configuration.offsetTop
    };
    if (isHTMLElement) return {
        externalToolbarRef: configuration
    };
};
const $cdffe18353f994db$export$f7e5e5a2fbd99270 = ({ useStickyToolbar: useStickyToolbar, twoLineEditorToolbar: twoLineEditorToolbar, children: children, isNewToolbarEnabled: isNewToolbarEnabled })=>{
    if (useStickyToolbar) return /*#__PURE__*/ (0, $1NIU8.jsx)($cdffe18353f994db$var$StickyToolbar, {
        ...$cdffe18353f994db$var$getStickyParameters(useStickyToolbar),
        twoLineEditorToolbar: twoLineEditorToolbar,
        isNewToolbarEnabled: isNewToolbarEnabled
    }, children);
    return /*#__PURE__*/ (0, $1NIU8.jsx)($cdffe18353f994db$var$FixedToolbar, {
        twoLineEditorToolbar: twoLineEditorToolbar,
        isNewToolbarEnabled: isNewToolbarEnabled
    }, children);
};

});




parcelRegister("19DFx", function(module, exports) {
$parcel$export(module.exports, "ExtensionProvider", () => $2a75573aa69f1f3f$export$c6ef18cd2d1a61a0);

var $eJOHy = parcelRequire("eJOHy");

var $ghFws = parcelRequire("ghFws");

var $33gLE = parcelRequire("33gLE");

var $c028c = parcelRequire("c028c");

var $cud6T = parcelRequire("cud6T");

var $2Mqjh = parcelRequire("2Mqjh");
const $2a75573aa69f1f3f$export$c6ef18cd2d1a61a0 = ({ children: children, extension: extension, localId: localId, renderNoAccessFallback: renderNoAccessFallback })=>{
    const memoRenderNoAccessFallback = (0, $eJOHy.useMemo)(()=>renderNoAccessFallback || (()=>null), [
        renderNoAccessFallback
    ]);
    const hasForgeAccess = (0, $cud6T.useHasForgeAccess)();
    const environment = (0, $c028c.useEnvironment)();
    /**
	 * Since we do not have docs for the metal client change, I'll link notes from the internal discussion:
	 * https://atlassian.slack.com/archives/CK2KJ2EVD/p1589267473262900?thread_ts=1589205176.225800&cid=CK2KJ2EVD
	 *
	 * `environment` is the product environment
	 * `product` is `jira` or `confluence`
	 * `page` is essentially just a tag that we add onto each of the events
	 *    to distinguish between events, e.g. for Confluence’s Editor it is `editPageScreen`
	 *    (i.e. like source in an analytics event)
	 */ const metalClientProps = {
        page: extension.type,
        environment: environment,
        product: 'jira'
    };
    return hasForgeAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ghFws.ForgeUIExtensionPointProvider), {
        ...metalClientProps,
        // @ts-expect-error - TS2322 - Type 'Promise<typeof AnalyticsWebClient | AnalyticsWebClient>' is not assignable to type 'AnalyticsWebClient | Promise<AnalyticsWebClient>'.
        analyticsWebClient: (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>client.getInstance())
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $33gLE.ForgeUIExtensionAnalyticsContext), {
        localId: localId,
        extensionId: extension.id
    }, children)) : memoRenderNoAccessFallback();
};

});
parcelRegister("ghFws", function(module, exports) {
$parcel$export(module.exports, "ForgeUIExtensionPointProvider", () => $3d19736dd47acbe1$export$64f0f7e9be5f8ff);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $83IbI = parcelRequire("83IbI");
var $6yq62 = parcelRequire("6yq62");

var $dHXR3 = parcelRequire("dHXR3");
const $3d19736dd47acbe1$export$64f0f7e9be5f8ff = ({ analyticsWebClient: analyticsWebClient, environment: environment, product: product, page: page, children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $83IbI.EnvironmentContext).Provider, {
        value: environment,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6yq62.MetricsContextProvider), {
            value: {
                product: product,
                page: page
            },
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dHXR3.default), {
                client: analyticsWebClient,
                commonAttributes: {
                    moduleType: page
                },
                children: children
            })
        })
    });
};

});

parcelRegister("c028c", function(module, exports) {
$parcel$export(module.exports, "useEnvironment", () => $02f947c9c933103a$export$ea7ed2425832167d);
parcelRequire("1B59H");
var $bMVUa = parcelRequire("bMVUa");

var $kyq27 = parcelRequire("kyq27");
const $02f947c9c933103a$export$ea7ed2425832167d = ()=>{
    const env = (0, $kyq27.useEnvironment)();
    switch(env){
        case 'staging':
            return (0, $bMVUa.ProductEnvironment).STAGING;
        case 'dev':
        case 'local':
            return (0, $bMVUa.ProductEnvironment).DEVELOPMENT;
        case 'prod':
        default:
            return (0, $bMVUa.ProductEnvironment).PRODUCTION;
    }
};

});
parcelRegister("kyq27", function(module, exports) {
$parcel$export(module.exports, "useEnvironment", () => $3308bdf614fc7dbd$export$ea7ed2425832167d);
$parcel$export(module.exports, "useIsStagingOrDevOrLocal", () => $3308bdf614fc7dbd$export$b0d8f74f433a09c9);

var $koAZ4 = parcelRequire("koAZ4");
const $3308bdf614fc7dbd$var$ENVIRONMENT = {
    STAGING: 'staging',
    DEV: 'dev',
    LOCAL: 'local',
    PROD: 'prod'
};
const $3308bdf614fc7dbd$export$ea7ed2425832167d = ()=>{
    const tenantContext = (0, $koAZ4.useTenantContext)();
    return tenantContext?.environment || $3308bdf614fc7dbd$var$ENVIRONMENT.PROD;
};
const $3308bdf614fc7dbd$export$b0d8f74f433a09c9 = ()=>{
    const env = $3308bdf614fc7dbd$export$ea7ed2425832167d();
    return env === $3308bdf614fc7dbd$var$ENVIRONMENT.STAGING || env === $3308bdf614fc7dbd$var$ENVIRONMENT.DEV || env === $3308bdf614fc7dbd$var$ENVIRONMENT.LOCAL;
};

});



parcelRegister("j7XAd", function(module, exports) {
$parcel$export(module.exports, "LoadingComponentWithUnmountEvent", () => $92290e7f62b92e53$export$cfb476d509d416bd);

var $eJOHy = parcelRequire("eJOHy");

var $7ep4S = parcelRequire("7ep4S");
const $92290e7f62b92e53$var$FireEventOnUnmount = ({ onInitialRender: onInitialRender, appTime: appTime, forgeDoc: forgeDoc, error: error })=>{
    (0, $eJOHy.useLayoutEffect)(// immediately returning a function here defines
    // a clean-up function that gets called during unmount
    ()=>()=>{
            // don't want to fire yet if forgeDoc and error are both undefined (initial values)
            if (forgeDoc === undefined && error === undefined) return;
            onInitialRender({
                forgeDoc: forgeDoc,
                appTime: appTime,
                error: error
            });
        }, [
        onInitialRender,
        forgeDoc,
        error,
        appTime
    ]);
    return null;
};
const $92290e7f62b92e53$var$OnLoadingComponentUnmount = ({ onUnmount: onUnmount })=>{
    (0, $eJOHy.useLayoutEffect)(// immediately returning a function here defines
    // a clean-up function that gets called during unmount
    ()=>()=>{
            onUnmount();
        }, [
        onUnmount
    ]);
    return null;
};
const $92290e7f62b92e53$export$cfb476d509d416bd = ({ loadingComponent: loadingComponent, onInitialRender: onInitialRender, forgeDoc: forgeDoc, appTime: appTime = 0, error: error, onUnmount: onUnmount })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, loadingComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), null), onUnmount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($92290e7f62b92e53$var$OnLoadingComponentUnmount, {
        onUnmount: onUnmount
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($92290e7f62b92e53$var$FireEventOnUnmount, {
        onInitialRender: onInitialRender,
        forgeDoc: forgeDoc,
        appTime: appTime,
        error: error
    }));

});

parcelRegister("8Yxmm", function(module, exports) {
$parcel$export(module.exports, "calculateHeight", () => $dde870cc33e16741$export$dc162cc8e2f32f66);

var $fohjD = parcelRequire("fohjD");
const $dde870cc33e16741$var$panelHeights = {
    default: '100%',
    small: '112px',
    medium: '262px',
    large: '524px',
    xlarge: '1048px'
};
const $dde870cc33e16741$var$issueGlanceHeights = {
    // subtraction was added to solve the scrolling bug
    default: 'calc(100% - 4px)'
};
const $dde870cc33e16741$var$fullPageHeights = {
    default: '100%'
};
const $dde870cc33e16741$var$extensionPointHeights = {
    [(0, $fohjD.ISSUE_PANEL_MODULE)]: $dde870cc33e16741$var$panelHeights,
    [(0, $fohjD.ISSUE_ACTIVITY_MODULE)]: $dde870cc33e16741$var$panelHeights,
    [(0, $fohjD.ISSUE_GLANCE_MODULE)]: $dde870cc33e16741$var$issueGlanceHeights,
    [(0, $fohjD.ADMIN_PAGE_MODULE)]: $dde870cc33e16741$var$fullPageHeights,
    [(0, $fohjD.PROJECT_PAGE_MODULE)]: $dde870cc33e16741$var$fullPageHeights
};
const $dde870cc33e16741$export$dc162cc8e2f32f66 = (type, size, isInModal)=>{
    if (isInModal === true) return '100%';
    const heights = $dde870cc33e16741$var$extensionPointHeights[type];
    if (!heights) return '100%';
    if (size) return heights[size] ?? heights.default;
    return heights.default;
};

});




//# sourceMappingURL=async-forge-ui-extension.402df170.js.map
